export const companies = [
"BSCUBES TECHNOLOGIES PRIVATE LIMITED",
"EXPORTS INTERNATIONAL CORPORATION",
"DAESEUNG AUTOPARTS INDIA PRIVATE LIMITED",
"IKIO LIGHTING LIMITEDC",
"ISGEC SFW BOILERS PRIVATE LIMITED",
"J B MANGHARAM FOODS PRIVATE LIMITED",
"PAHARPUR 3P PRIVATE LIMITED",
"PRAMILA PROJECTS PRIVATE LIMITED",
"SOL INDIA PRIVATE LIMITED",
"HARYANA CITY GAS DISTRIBUTION (BHIWADI) LIMITED",
"VN ADVERTISING. PRIVATE LIMITED.",
"0522 AXIOTECH PRIVATE LIMITED",
"05BN FINHEALTH PRIVATE LIMITED",
"1 DEFENCE SECURITY SOLUTIONS PRIVATE LIMITED",
"1 POINT 1 SOLUTIONS PRIVATE LIMITED",
"1 SPACION BUSINESS CENTRE PRIVATE LIMITED",
"1 STOP HOSPITAL SOLUTION PRIVATE LIMITED",
"1 TTR 1 STC",
"VINSPIRE AGROTECH (I) PRIVATE LIMITED",
"100MB DIGITAL PRIVATE LIMITED",
"100X TECHNOLOGIES PRIVATE LIMITED",
"101 ACRES REAL ESTATE AND INFRA DEVELOPERS PRIVATE LIMITED",
"102 MOTHER CHILD SERVICES (UP)",
"102 MOTHER CHILD SERVICES UP",
"108 EMERGENCY MEDICAL TRANSPORT SERVICES EAST UP",
"108 EMERGENCY MEDICAL TRANSPORT SERVICES WEST (UP)",
"10FINGERS SOLUTIONS PRIVATE LIMITED",
"10I COMMERCE SERVICES PRIVATE LIMITED",
"10KINFO DATA SOLUTIONS PRIVATE LIMITED",
"10XTD DIGITAL & DESIGN SOLUTIONS PRIVATE LIMITED",
"11 FIELD ORDNANCE DEPOT",
"11SPORTS PRIVATE LIMITED",
"11THZENSE FOODS PRIVATE LIMITED",
"120 MEDIA COLLECTIVE PRIVATE LIMITED",
"121 OUTSOURCE INDIA PRIVATE LIMITED",
"1218 INDIA PRIVATE LIMITED",
"123 HOMEPAINTS PRIVATE LIMITED",
"123 MUSIX ENTERTAINMENTS PRIVATE LIMITED",
"123STORES E COMMERCE PRIVATE LIMITED",
"12TH WONDER RESEARCH INDIA PRIVATE LIMITED",
"14PEAKS EVENT LOGISTIC SOLUTIONS PRIVATE LIMITED",
"1589 HOTELS PRIVATE LIMITED",
"159 TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"15HERBS ORGANIC LABS PRIVATE LIMITED",
"16TH AUDIO PRIVATE LIMITED",
"18TH DIGITECH PRIVATE LIMITED",
"1908 E-VENTURES PRIVATE LIMITED",
"19TH HOLE STUDIOS PRIVATE LIMITED",
"1ENTERTAINMENT DIGITAL NETWORK PRIVATE LIMITED",
"1FB SUPPORT SERVICES PRIVATE LIMITED",
"1ICT INDIA PRIVATE LIMITED",
"1M TRAVEL SERVICES PRIVATE LIMITED",
"1M1B FOUNDATION",
"1NETWORK WEBSERVE PRIVATE LIMITED",
"1PAY MOBILEWARE PRIVATE LIMITED",
"1PS SOFTWARE AND SUPPORT SOLUTIONS PRIVATE LIMITED",
"1RIVET INDIA LLP",
"1ST ADDITIONAL SPECIAL AUDITOR CL 2 C S MUMBAI",
"1ST SHIVAM TRANS MOVERS PRIVATE LIMITED",
"1THING DESIGN & INNOVATION PRIVATE LIMITED",
"1TO1 HELP NET PRIVATE LIMITED",
"2 DEGREES CLICON PRIVATE LIMITED",
"2 INFINITY SERVICES PRIVATE LIMITED",
"2 TECHNICAL TRAINING REGIMENT 1 STC JABALPUR",
"2 X 2 LOGISTICS PRIVATE LIMITED",
"20 MAH BTN NCC",
"20 MCC PRIVATE LIMITED",
"20 MICRONS LIMITED",
"20 MICRONS NANO MINERALS LIMITED",
"20 WATTS PRIVATE LIMITED",
"200NOT OUT CINEMAS P LIMITED",
"200OK SOLUTIONS LTD",
"2020 MOTORS PRIVATE LIMITED",
"20CUBE LOGISTICS PRIVATE LIMITED",
"20CUBE LOGISTICS SOLUTIONS PRIVATE LIMITED",
"20CUBE WAREHOUSING AND DISTRIBUTION PRIVATE LIMITED",
"20MED MEDIA PRIVATE LIMITED",
"20TH CENTURY HOLDINGS PRIVATE LIMITED",
"21 FOOLS DESIGN AND ENTERTAINMENT PRIVATE LIMITED",
"21 KNOTS DESIGN & CONSULTING PRIVATE LIMITED",
"21 TRENDS PRIVATE LIMITED",
"21CC VISHWA SARVAGANA PRIVATE LIMITED",
"21G DESIGN WORKS PRIVATE LIMITED",
"21K SCHOOL",
"21N78E CREATIVE LABS PRIVATE LIMITED",
"21ST CASTLE VENTURES PRIVATE LIMITED",
"21ST CENTURY ADVISORS PRIVATE LIMITED",
"21ST CENTURY CLOUD COMPUTING PRIVATE LIMITED",
"21ST CENTURY ENVIRO ENGINEERS PRIVATE LIMITED",
"21ST CENTURY E-SOLUTIONS PRIVATE LIMITED",
"21ST CENTURY FASHIONS PRIVATE LIMITED",
"21ST CENTURY HEALTH MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"21ST CENTURY INFORMATICS INDIA PRIVATE LIMITED",
"21ST CENTURY VENTURES INDIA PRIVATE LIMITED",
"21ST SECURITY SERVICES PRIVATE LIMITED",
"22 FEET TRIBAL WORLDWIDE PRIVATE LIMITED",
"22 HECTARE FARMTRADE PRIVATE LIMITED",
"222 BUDS INDIA PRIVATE LIMITED",
"22ND AVENUE TALENT MANAGEMENT PRIVATE LIMITED",
"23 AND HALF DEGREE CORPORATION PRIVATE LIMITED",
"23 INFO MEDIA PRIVATE LIMITED",
"23 SOFTWARE DEVELOPMENT PRIVATE LIMITED",
"23 WATTS MEDIA PRIVATE LIMITED",
"23NORTH LOGISTICS SOLUTIONS PRIVATE LIMITED",
"24 7 INTOUCH INDIA PRIVATE LIMITED",
"24 VISION STAFFING SOLUTIONS PRIVATE LIMITED",
"24*7 RUDRAKSHA MULTISPECIALITY HOSPITAL PRIVATE LIMITED",
"24/7 CUSTOMER PRIVATE LIMITED",
"24/7 NETWORKS PRIVATE LIMITED",
"247 FACILITY SERVICES PRIVATE LIMITED",
"247DIGITIZE SERVICES PRIVATE LIMITED",
"247HIRE INDIA PRIVATE LIMITED",
"24ASHOK FASTENERS PRIVATE LIMITED",
"24K AGRO PRODUCTS PRIVATE LIMITED",
"24ONLINE INFO TECHNOLOGIES PRIVATE LIMITED",
"24SEVEN HOME HEALTH CARE SERVICES PRIVATE LIMITED",
"24SEVEN OPERATIONS PRIVATE LIMITED",
"24X7 CONNECT INDIA PRIVATE LIMITED",
"24X7 FACILITY SERVICE CONNECT PRIVATE LIMITED",
"24X7 LOGISTICS PRIVATE LIMITED",
"25FPS MEDIA PRIVATE LIMITED",
"2626 CREATIVE STUDIO PRIVATE LIMITED",
"29 FIELD AMMUNITION DEPOT ( ORDINANCE FACTORY)",
"29 THREE HOLIDAYS PRIVATE LIMITED",
"29K INVESTMENT ADVISERS PRIVATE LIMITED",
"2BASE TECHNOLOGIES PRIVATE LIMITED",
"2CQR AUTOMATION PRIVATE LIMITED",
"2D ENTERTAINMENT PRIVATE LIMITED",
"2DO TECHNOLOGIES PRIVATE LIMITED",
"2GETHERMENTS INFRA PRIVATE LIMITED",
"2GETHERZ MARKETING PRIVATE LIMITED",
"2HOP SERVICES",
"2HUB PRIVATE LIMITED",
"2IIM",
"2IN ROCKS HOTELS & RESTURANT PRIVATE LIMITED",
"2ISOLUTIONS CONSULTING SERVICES PRIVATE LIMITED",
"2J COMMERCE PRIVATE LIMITED",
"2M ATELIERS & DESIGN PRIVATE LIMITED",
"2M ELECTRICAL PRIVATE LIMITED",
"2M ENGINEERING INDIA PRIVATE LIMITED",
"2ND INNINGS HANDICRAFTS PRIVATE LIMITED",
"2RUE COLORS KNOWBILITY PRIVATE LIMITED",
"2S WELLNESS AND RESEARCH CENTRE PRIVATE LIMITED",
"2V ENGINEERING INTERIORS INDIA PRIVATE LIMITED",
"3 ACES WOOD PRIVATE LIMITED",
"3 AXIAL STEEL DETAILING SERVICES PRIVATE LIMITED",
"3 COLON 33 TECHNOLOGIES PRIVATE LIMITED",
"3 DIMENSIONAL INSURANCE BROKERS INDIA PRIVATE LIMITED",
"3 FORKS HOSPITALITY PRIVATE LIMITED",
"3 GEN CONSULTING SERVICES LLP",
"JOINT COMMISSIONER SALES TAX (BUSINESS AUDIT)",
"3 LOQ LABS PRIVATE LIMITED",
"3 MINDS ESOLUTIONS PRIVATE LIMITED",
"3 POINT HUMAN CAPITAL PRIVATE LIMITED",
"3 SIDES OPEN CONSULTING PRIVATE LIMITED",
"3 STAR BRANDING PRIVATE LIMITED",
"3 STAR LIVING PRIVATE LIMITED",
"3 STAR LOGISTICS PRIVATE LIMITED",
"3 VERTICES ANALYTICAL SOLUTIONS PRIVATE LIMITED",
"300 MIND",
"3003BC LIFESTYLE PRIVATE LIMITED",
"300PLUS CONSULTING SERVIES PRIVATE LIMITED",
"31 PARALLEL BUSINESS PROCESSING OPERATION PRIVATE LIMITED",
"31 PARALLEL IT & BPO SOLUTIONS PRIVATE LIMITED",
"315 WORK AVENUE SPACES PRIVATE LIMITED",
"33 FIELD AMMUNITION DEPOT",
"360 BRANDING SOLUTIONS PRIVATE LIMITED",
"360 DEGREE CLOUD TECHNOLOGIES PRIVATE LIMITED",
"360 DEGREE GLOBAL EQUIPMENTS PRIVATE LIMITED",
"360 DEGREE MEDIA SOLUTIONS PRIVATE LIMITED",
"360 DEGREE PROPERTY AND ENGINEERING SERVICES PRIVATE LIMITED",
"360 DEGREE VENTURES PRIVATE LIMITED",
"360 DIAGNOSTIC & HEALTH SERVICES PRIVATE LIMITED",
"360 DIGITAL MARKETING AND ADVERTISING PRIVATE LIMITED",
"360 IN EX CREATION PRIVATE LIMITED",
"360 INTERIOR DESIGNS LLP",
"360 MARKETING SERVICE PRIVATE LIMITED",
"360 NAUTICA TECH VENTURES LLP",
"360 ONE ASSET MANAGEMENT LIMITED",
"360 ONE ASSET TRUSTEE LIMITED",
"360 ONE FOUNDATION",
"360 ONE INVESTMENT ADVISER AND TRUSTEE SERVICES LIMITED",
"360 ONE PORTFOLIO MANAGERS LIMITED",
"360 ONE WAM LIMITED",
"360 REALTOR EXPRESS LLP",
"360 REALTORS LLP",
"360VITY INFOSOURCE (OPC) PRIVATE LIMITED",
"365 BUILD TECHNOLOGIES INDIA PRIVATE LIMITED",
"365 CELEBRATIONS PRIVATE LIMITED",
"365 FACILITY MANAGEMENT PRIVATE LIMITED",
"365 MEDIA PRIVATE LIMITED",
"365 PLASTIUM PRIVATE LIMITED",
"365 PUBLICATION PRIVATE LIMITED",
"365 SURAKSHA ADVISORY SERVICES PRIVATE LIMITED",
"382 COY ASC SUP TYPE A",
"39 ALTAMOUNT PRIVATE LIMITED",
"3A & A CONSTRUCTION COMPANY PRIVATE LIMITED",
"3A BUSINESS CONSULTING PRIVATE LIMITED",
"3A CAPITAL SERVICES LIMITED",
"3A COMPOSITES INDIA PRIVATE LIMITED",
"3A FINANCIAL SERVICES LIMITED",
"3A GLOBAL ENGINEERING PRIVATE LIMITED",
"3A ITECHQORE (OPC) PRIVATE LIMITED",
"3A LEARNING SOLUTIONS INDIA PRIVATE LIMITED",
"3A TRAVELS PRIVATE LIMITED",
"3AG NETWORK SOLUTIONS PRIVATE LIMITED",
"3AIP SERVICES PRIVATE LIMITED",
"3AK CHEMIE PRIVATE LIMITED",
"3ANALYTICS INDIA PRIVATE LIMITED",
"3B BLACKBIO DX LIMITED",
"3B CONSULLTING PRIVATE LIMITED",
"3B FILMS PRIVATE LIMITED",
"3B FLEXIPACKS PRIVATE LIMITED",
"3B HOTELS & RESORTS PRIVATE LIMITED",
"3B INFRASTRUCTURE PRIVATE LIMITED",
"3B STAFFING PRIVATE LIMITED",
"3BG ADVISORS & MANAGERS PRIVATE LIMITED",
"3BIGS OMICSCORE PRIVATE LIMITED",
"3C IT SOLUTIONS & TELECOMS (INDIA) LIMITED",
"3C3 INDIA PRIVATE LIMITED",
"3CDN WORKPLACE TECH PRIVATE LIMITED",
"3CHEM SURFACES PRIVATE LIMITED",
"3CUBE MEDICARE PRIVATE LIMITED",
"3D BLUEPRINT (INDIA) PRIVATE LIMITED",
"3D CONCEPT TOOLING PRIVATE LIMITED",
"3D EDTECH PRIVATE LIMITED",
"3D ENGINEERING AUTOMATION LLP",
"3D FIRE & SAFETY PRIVATE LIMITED",
"3D FOAMCUT PRIVATE LIMITED",
"3D FUTURE TECHNOLOGIES PRIVATE LIMITED",
"3D LOGIC PRIVATE LIMITED",
"3D MEDICARE PRIVATE LIMITED",
"3D MEGA STRUCTURES PRIVATE LIMITED",
"3D PRINT WORLD PRIVATE LIMITED",
"3D PRODUCT DEVELOPMENT PRIVATE LIMITED",
"3D SYSTEMS INDIA PRIVATE LIMITED",
"3D TECHNOPACK PRIVATE LIMITED",
"3DI SCHOOL PRIVATE LIMITED",
"3DIMENSION CAPITAL SERVICES LIMITED",
"3DIQ SOFTWARE PRIVATE LIMITED",
"3DN SOLUTIONS",
"3DOT LAM INDUSTRIES PRIVATE LIMITED",
"3DOT14 MOBITECH PRIVATE LIMITED",
"3DPRIME DESIGNNERS PRIVATE LIMITED",
"3DTEK SOLUTIONS PRIVATE LIMITED",
"3E ADVISORS PRIVATE LIMITED",
"3E CONSULTING PRIVATE LIMITED",
"3E RENEWABLE ENERGY SOFTWARE AND SERVICES PRIVATE LIMITED",
"3EA LIMITED",
"3EMBED SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"3EYE AGRO MERCHANTS PRIVATE LIMITED",
"3F ADVANCED TECHNO LABS PRIVATE LIMITED",
"3F INDUSTRIES LIMITED",
"3F MAGNUS TECH PRIVATE LIMITED",
"3F OIL PALM PRIVATE LIMITED",
"3FEET INTERIO PRIVATE LIMITED",
"3FIVE8 TECHNOLOGIES PRIVATE LIMITED",
"3FRAMES SOFTWARE LABS PRIVATE LIMITED",
"3G BELL PEPPERS PRIVATE LIMITED",
"3G CARGO MOVERS PRIVATE LIMITED",
"3G CELL LABS PRIVATE LIMITED",
"3G SURGICAL INDUSTRIES PRIVATE LIMITED",
"3GB TECHNOLOGY PRIVATE LIMITED",
"3GM INTERIOR CONCEPTS PRIVATE LIMITED",
"3H LEARNING PRIVATE LIMITED",
"3HANDSHAKE INNOVATION PRIVATE LIMITED",
"3I ASSET MANAGEMENT PRIVATE LIMITED",
"3I CONSULTING PRIVATE LIMITED",
"3I ENERGY SOLUTIONS PRIVATE LIMITED",
"3I INDIA PRIVATE LIMITED",
"3I INFOTECH CONSULTANCY SERVICES LIMITED",
"3I INFOTECH DIGITAL BPS LIMITED",
"3I INFOTECH LIMITED",
"3I LABELS INDIA PRIVATE LIMITED",
"3I MEDICAL TECHNOLOGIES PRIVATE LIMITED",
"3I MOLECULAR SOLUTIONS AND HEALTHCARE SERVICES PRIVATE LIMITED",
"3I PUBLISHING PRIVATE LIMITED",
"3INSYS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"3J ASSOCIATES",
"3J GLOBAL SERVICES PRIVATE LIMITED",
"3K CERA-FRIT PRIVATE LIMITED",
"3K SOFTECH PRIVATE LIMITED",
"3LEADS RESOURCES INDIA PRIVATE LIMITED",
"3M ANSR GLOBAL TECHNOLOGY CENTER LLP",
"3M DIGITAL NETWORKS PRIVATE LIMITED",
"3M ELECTRO AND COMMUNICATION INDIA PRIVATE LIMITED",
"3M EXIM PRIVATE LIMITED",
"3M INDIA LIMITED",
"3M PROJECTS PRIVATE LIMITED",
"3M SOUTH ASIA MANUFACTURING PRIVATE LIMITED",
"3M TECHNO SKILL PRIVATE LIMITED",
"3NDA2D TECH AND SERVICES PRIVATE LIMITED",
"3P FILTRATION PRIVATE LIMITED",
"3PL LOGISTICS INDIA PRIVATE LIMITED",
"3PL SOLUTIONS PRIVATE LIMITED",
"3PLANES SPORTSTECH PRIVATE LIMITED",
"3PLATE FOODS PRIVATE LIMITED",
"3PLUS GARMENTS PRIVATE LIMITED",
"3POINTLIGHT BRAND & COMMUNICATIONS PRIVATE LIMITED",
"3PS MEDIA INDIA PRIVATE LIMITED",
"3PSOFT TECHNOLOGIES PRIVATE LIMITED",
"3Q FINANCIAL CONSULTANTS LLP",
"3QI LABS INDIA PRIVATE LIMITED",
"3R BUSINESS SOLUTIONS PRIVATE LIMITED",
"3R DFLIX VISUAL EFFECTS PRIVATE LIMITED",
"3R IMAGING SOLUTIONS PRIVATE LIMITED",
"3R INFOTECH PRIVATE LIMITED",
"3R MANAGEMENT LIMITED",
"3R POLYMERS PRIVATE LIMITED",
"3RD EYE PERCEPTION PRIVATE LIMITED",
"3RD EYE TECHNO SOLUTIONS PRIVATE LIMITED",
"3RD I ADVERTISING",
"3RD ROCK MULTIMEDIA LIMITED",
"3RI TECHNOLOGIES PRIVATE LIMITED",
"3RINFO SOFTECH PRIVATE LIMITED",
"3S BUSINESS INFO SERVICES",
"3S FITNESS TECHNOLOGIES PRIVATE LIMITED",
"3S HIVETECH PRIVATE LIMITED",
"3S INFRASOLUTIONS PRIVATE LIMITED",
"3S INTEGRATED FACILITY MANAGEMENT PRIVATE LIMITED",
"3S LOGICS PRIVATE LIMITED",
"3S STRUCTURE & MEP PRIVATE LIMITED",
"3S STUDIO PRIVATE LIMITED",
"3S TECHNOLOGIES & AUTOMATION PRIVATE LIMITED",
"3S TEMPLE PROJECTS PRIVATE LIMITED",
"3S TOUCH SERVICE SOLUTIONS PRIVATE LIMITED",
"3SA AUTOTECH PRIVATE LIMITED",
"3SDM BUSINESS SOLUTIONS PRIVATE LIMITED",
"3STAGE PRIVATE LIMITED",
"3STRYPS SOLUTIONS PRIVATE LIMITED",
"3T INDUSTRIAL SOLUTIONS PRIVATE LIMITED",
"3TANDAI INDIA PRIVATE LIMITED",
"3TEE ELASTIC PRIVATE LIMITED",
"3V TASTY FOODS PRIVATE LIMITED",
"3W PACKMARK PRIVATE LIMITED",
"3X ENGINEERING PRIVATE LIMITED",
"4 D DMASS MARKETING PRIVATE LIMITED",
"4 LIONS FILMS PRIVATE LIMITED",
"4 M SECURITY AND ALLIED SERVICES PRIVATE LIMITED",
"4 MINUTE MILE MARKETING SERVICES PRIVATE LIMITED",
"4 R INVESTMENTS PRIVATE LIMITED",
"40K PLUS EDUCATION PRIVATE LIMITED",
"42 1 SPORTS PRIVATE LIMITED",
"42GEARS MOBILITY SYSTEMS PRIVATE LIMITED",
"42HERTZ SOFTWARE INDIA PRIVATE LIMITED",
"42WORKS INFO SOLUTIONS PRIVATE LIMITED",
"44 EMB STUDIO PRIVATE LIMITED",
"45 COY ASC",
"4A DESIGN & ENGINEERING PRIVATE LIMITED",
"4A SECURITIES LIMITED",
"4AI ODC PRIVATE LIMITED",
"4AM WORLDWIDE ADVERTISING PRIVATE LIMITED",
"4ARMS FACILITIES PRIVATE LIMITED",
"4C CONSULTING PRIVATE LIMITED",
"4C DRUG SAFETY SERVICES LLP",
"4CARE LIFESCIENCE PRIVATE LIMITED",
"4CRISK AI SOFTWARE PRIVATE LIMITED",
"4CURENCARE HEALTHCARE TECHNOLOGIES AND SOLUTIONS PRIVATE LIMITED",
"4D GLOBAL MEDICAL BILLING SERVICES PRIVATE LIMITED",
"4D INDIATEQ LIMITED",
"4D TELECOM SOLUTION PRIVATE LIMITED",
"4ESOFTWARE PRIVATE LIMITED",
"4FOX LOGISTICS PRIVATE LIMITED",
"4FTBSYS PRIVATE LIMITED",
"4G IDENTITY SOLUTIONS PRIVATE LIMITED",
"4G INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"4G PHARMACARE PRIVATE LIMITED",
"4G5G CONSULTANTS PRIVATE LIMITED",
"4I APPS SOLUTIONS PRIVATE LIMITED",
"4I INTERNET PRIVATE LIMITED",
"4M HOSPITALS",
"4MANN INDUSTRIES PRIVATE LIMITED",
"4MATION BIOSCIENCES PRIVATE LIMITED",
"4MATION TECHNOLOGIES INDIA PRIVATE LIMITED",
"4N MALL PRIVATE LIMITED",
"4PE DISTRIBUTED SOLAR SERVICES PRIVATE LIMITED",
"4PEL CLEAN TECH PRIVATE LIMITED",
"4PEL DISTRIBUTED SOLAR ENERGY PRIVATE LIMITED",
"4PEL DISTRIBUTED SOLAR POWER PRIVATE LIMITED",
"4PEL ENERGY SERVICES PRIVATE LIMITED",
"4PEL GREEN POWER PRIVATE LIMITED",
"4PEL MEGA LIGHT PRIVATE LIMITED",
"4PEL MEGA URJA PRIVATE LIMITED",
"4PEL RELIABLE POWER SERVICES PRIVATE LIMITED",
"4PEL SAUR VIDYUT PRIVATE LIMITED",
"4PEL SOLAR DAYLIGHT ENERGY PRIVATE LIMITED",
"4PEL SOLAR SUN FLAME PRIVATE LIMITED",
"4PEL SUN ABILITY PRIVATE LIMITED",
"4PEL SUN FLASH PRIVATE LIMITED",
"4PEL SURYA MITRA PRIVATE LIMITED",
"4PEL SURYA PRAKASH PRIVATE LIMITED",
"4PI INFOTECH INDIA PRIVATE LIMITED",
"4PL SCM TECHNOLOGIES PRIVATE LIMITED",
"4R RECYCLING PRIVATE LIMITED",
"4RS HOSPITALITY PRIVATE LIMITED",
"4S DEVELOPERS PRIVATE LIMITED",
"4S INTERNATIONAL LIMITED",
"4S LOGISTIC SOLUTIONS PRIVATE LIMITED",
"4S PHARMA SOLUTIONS PRIVATE LIMITED",
"4S SPINTEX INDIA PRIVATE LIMITED",
"4S SYNERGIES PRIVATE LIMITED",
"4SIGHT SOLUTIONS PRIVATE LIMITED",
"4SL IT CONSULTING PRIVATE LIMITED",
"4SPID CONSULTANCY (INDIA) PRIVATE LIMITED",
"4SQUARE REALTY INDIA PRIVATE LIMITED",
"4SUN POWERGEN INDIA PRIVATE LIMITED",
"4SYZ INFOTECH SOLUTIONS PRIVATE LIMITED",
"4TH DIMENSION INFRATECH PRIVATE LIMITED",
"4TH QUARTER TECHNOLOGIES PRIVATE LIMITED",
"4TPS FOODS PRIVATE LIMITED",
"4TTR 1STC JABALPUR",
"4YOU IMPEX PRIVATE LIMITED",
"5 CG COM (T) NCC GOVT ENGINEERING COLLEGE CAMPS",
"5 POINT SOLUTIONS PRIVATE LIMITED",
"5 S COLONIZERS & DEVELOPERS PRIVATE LIMITED",
"50 HERTZ LIMITED",
"50+ VOYAGERS TRAVEL AND ADVENTURE CLUB PRIVATE LIMITED",
"506 ARMY BASE WORKSHOP JABALPUR",
"507 ARMY BASE WORKSHOP KANKINARA PO ESD M",
"508 ARMY BASE WORKSHOP",
"509 ARMY BASE WORKSHOP, AGRA",
"512 ARMY BASE WORKSHOP",
"52 COY ASC SUPPLY TYPE A",
"52N2W MACHINE TOOLS PRIVATE LIMITED",
"54 COY ASC SUP TYPE C",
"555 MEGA STORE PRIVATE LIMITED",
"56N SOFTWARE PRIVATE LIMITED",
"5C NETWORK INDIA PRIVATE LIMITED",
"5D GLOBAL TRAVEL SOLUTIONS PRIVATE LIMITED",
"5D SOLUTIONS INDIA PRIVATE LIMITED",
"5E TECHNOLOGIES PRIVATE LIMITED",
"5F WORLD PRIVATE LIMITED",
"5G MOBILITY PRIVATE LIMITED",
"5H LIFEXPRESSION PRIVATE LIMITED",
"5K CAR CARE PRIVATE LIMITED",
"5MF&G TRADING PRIVATE LIMITED",
"5PAISA CAPITAL LIMITED",
"5PAISA P2P LIMITED",
"5S MEDIPACK PRIVATE LIMITED",
"5SEC CYBERPWN TECHNOLOGIES PRIVATE LIMITED",
"5SIDE RETAIL LLP",
"5T INFRAPROJECTS PRIVATE LIMITED",
"5TH BN NATIONAL DISASTER RESPONSE FORCE",
"5TH ELEMENTS WORLDWIDE PRIVATE LIMITED",
"5W1H MEDIA PRIVATE LIMITED",
"5WAY LOGISTICS SOLUTIONS INDIA PRIVATE LIMITED",
"5Y BUSINESS SOLUTIONS PRIVATE LIMITED",
"5ZEE INFOTECH PRIVATE LIMITED",
"6 LIVO TECHNOLOGIES PRIVATE LIMITED",
"6 MOUNTAIN DIVISION ORRDANCE UNIT",
"6 PROTECTION FORCE PRIVATE LIMITED",
"60 DECIBELS IMPACT PRIVATE LIMITED",
"610 WEB LAB LLP",
"63 MOONS TECHNOLOGIES LIMITED",
"63DIGITAL TECH PRIVATE LIMITED",
"63IDEAS INFOLABS PRIVATE LIMITED",
"64 NETWORK SECURITY PRIVATE LIMITED",
"66DEGREES INTERNATIONAL PRIVATE LIMITED",
"6IPAIN HEALTHCARE PRIVATE LIMITED",
"6PROPRINT PACKAGING PRIVATE LIMITED",
"6SENSE INSIGHTS INDIA PRIVATE LIMITED",
"6TH WALL PRODUCTION PRIVATE LIMITED",
"6THGEAR AUTOHUB PRIVATE LIMITED",
"6WRESEARCH & DATABASE SERVICES PRIVATE LIMITED",
"7 CON TECHNOLOGIES PRIVATE LIMITED",
"7 C'S",
"7 DIMENSION DESIGN SERVICES LLP",
"7 GOLDENAILES LOGISTICS PRIVATE LIMITED",
"7 INTELLIGENCE PRIVATE LIMITED",
"7 LOTUS ELEVENSES PRIVATE LIMITED",
"7 MED INDIA PRIVATE LIMITED",
"7 OAK DEVELOPERS PRIVATE LIMITED",
"7 ORANGE HEALTHCARE ORGANIZATION LLP",
"7 PETALS HORTICULTURE (INDIA) PRIVATE LIMITED",
"7 SEASONS RESORT & SPA",
"7 STAR CABLENET PRIVATE LIMITED",
"7 STAR COMPANY",
"7 STAR EMPIRE LIMITED",
"7 STAR SUPER SPECIALITY HOSPITAL PRIVATE LIMITED",
"7 STEPS CONSULTORES PRIVATE LIMITED",
"70K WATERWORKS PRIVATE LIMITED",
"711030 SCHOOL OF EXCELLENCE",
"72 NETWORKS PRIVATE LIMITED",
"73STRINGS AI INDIA PRIVATE LIMITED",
"75F SMART INNOVATIONS INDIA PRIVATE LIMITED",
"75WAY TECHNOLOGIES PRIVATE LIMITED",
"7C HOLIDAYS PRIVATE LIMITED",
"7C REALTY MANAGEMENT PRIVATE LIMITED",
"7CS COMMUNICATION PRIVATE LIMITED",
"7EDGE INTERNET PRIVATE LIMITED",
"7-ELEVEN CORPORATE SERVICES INDIA LLP",
"7ELEVEN SHIPPING PRIVATE LIMITED",
"7EVENC TECHNOLOGIES PRIVATE LIMITED",
"7GEM PRIVATE LIMITED",
"7HILLS CONCRETE SOLUTIONS PRIVATE LIMITED",
"7INK BREWS PRIVATE LIMITED",
"7JANPATH FOREX PRIVATE LIMITED",
"7NR RETAIL LIMITED",
"7ORSES BUSINESS SERVICES PRIVATE LIMITED",
"7RAYS FAB PRIVATE LIMITED",
"7SEAS ENTERTAINMENT LIMITED",
"7SHR CONSULTING PRIVATE LIMITED",
"7SPAN INTERNET PRIVATE LIMITED",
"7STAR IMAGE SOLUTION PRIVATE LIMITED",
"7UNIT SOFTWARE",
"7VACHAN SERVICES PRIVATE LIMITED",
"8 BIT ENTERTAINMENT PRIVATE LIMITED",
"8 BOUNDARIES BUILDERS PRIVATE LIMITED",
"8 DIRECTIONS SECURITY SERVICES PRIVATE LIMITED",
"8 SQUARE STRUCTURES PRIVATE LIMITED",
"80 DB COMMUNICATIONS PRIVATE LIMITED",
"83INCS SOFTECH PRIVATE LIMITED",
"88GB BUSINESS SOLUTIONS PRIVATE LIMITED",
"8KPC INDIA PRIVATE LIMITED",
"9 9 GROUP PRIVATE LIMITED",
"9 BLUE INTERGLOBE PRIVATE LIMITED",
"9 CUBE EXPERIENTIAL MARKETING AND EVENTS INDIA PRIVATE LIMITED",
"9 M MEDICAL SYSTEM PRIVATE LIMITED",
"9 PINN DIGITAL MEDIA PRIVATE LIMITED",
"9 W HOSPITALITY PRIVATE LIMITED",
"90-10 FINANCIAL PLANNERS PRIVATE LIMITED",
"90MINUTES RETAIL PRIVATE LIMITED",
"91 SPRINGBOARD BUSINESS HUB PRIVATE LIMITED",
"911 INDIA HEALTHCARE PRIVATE LIMITED",
"916 EPARI JEWELLER PRIVATE LIMITED",
"91DIGITAL WEB PRIVATE LIMITED",
"91SOCIAL SOFTWARE PRIVATE LIMITED",
"930 TECHNOLOGIES PRIVATE LIMITED",
"955 SPICES PRIVATE LIMITED",
"96K INTERNET TECHNOLOGIES PRIVATE LIMITED",
"99 ALGORITHMS PRIVATE LIMITED",
"99 AVENUE REALTY LLP",
"99 HIND SURAKSHA PRIVATE LIMITED",
"99 HOMEZ INFRASTRUCTURE PRIVATE LIMITED",
"99RPM WEB PRIVATE LIMITED",
"99YRS NETWORK LLP",
"9BITS TECHNOLOGY PRIVATE LIMITED",
"9EDGE TECHNOLOGIES PRIVATE LIMITED",
"9G TELE SOLUTIONS PRIVATE LIMITED",
"9LOGIC TECHNOLOGIES PRIVATE LIMITED",
"9M INDIA LIMITED",
"9M PHARMALOGIC PRIVATE LIMITED",
"9PLANETS TECH SERVICES PRIVATE LIMITED",
"9SERIES COMPUTERS PRIVATE LIMITED",
"9TH LANE ART PRIVATE LIMITED",
"9THREAD APPARELS PRIVATE LIMITED",
"9X MEDIA PRIVATE LIMITED",
"A - Z ENERGY ENGINEERS PRIVATE LIMITED",
"A & A BUSINESS CONSULTING PRIVATE LIMITED.",
"A & A EARTH MOVERS PRIVATE LIMITED",
"A & A INFRASTRUCTURE PRIVATE LIMITED",
"A & A INTERNATIONAL TRADING PRIVATE LIMITED",
"A & D INTERNATIONAL PRIVATE LIMITED",
"A & E INFORMATION SYSTEM PRIVATE LIMITED",
"A & J BUSINESS SOLUTIONS",
"A & J MICRONS PRIVATE LIMITED",
"A & L APPARELS PRIVATE LIMITED",
"A & N VENTURES PRIVATE LIMITED",
"A & P DOX N PAK SERVICES PRIVATE LIMITED",
"A & R BON VIVANTS PRIVATE LIMITED",
"A & S GLOBAL FREIGHT SOLUTIONS PRIVATE LIMITED",
"A & T STATIONERS PRIVATE LIMITED",
"A & T VIDEO NETWORKS PRIVATE LIMITED",
"A & V JEWELS PRIVATE LIMITED",
"A & V ZIPPERS PRIVATE LIMITED",
"A & W PROMOTERS & DEVELOPERS PRIVATE LIMITED",
"A .R. S. ENTERPRISES PRIVATE LIMITED",
"A 1 DRESSES PRIVATE LIMITED",
"A 1 FACILITY AND PROPERTY MANAGERS PRIVATE LIMITED",
"A 1 FENCE PRODUCTS COMPANY PRIVATE LIMITED",
"A -1 GADGET WORLD PRIVATE LIMITED",
"A 1 MACHINE TOOLS PRIVATE LIMITED",
"A 1 NEWS NETWORK PRIVATE LIMITED",
"A 1 TECHNOLOGY PRIVATE LIMITED",
"A 2 Z AUTO WHEELS PRIVATE LIMITED",
"A 2 Z LOGISTICS INDIA PRIVATE LIMITED",
"A A ADVERTISING & COMMUNICATIONS PRIVATE LIMITED",
"A A ATTARWALA AND COMPANY PRIVATE LIMITED",
"A A CALIBRATION PRIVATE LIMITED",
"A A DEHGAMWALA AND CO PVT LTD",
"A A ENERGY PRIVATE LIMITED",
"A A FRICTION MATERIALS PRIVATE LIMITED",
"A A I STAFF CO OPERATIVE THRIFT& CREDIT SOCIETY LTD",
"A A M INFOTECH PRIVATE LIMITED",
"A A MOOLLA AND M A NANA GIRLS HIGH SCHOOL",
"A A MOTIWALA JEWELLERS PRIVATE LIMITED",
"A A NAYAK CONSTRUCTIONS PRIVATE LIMITED",
"A A PLASTICS PRIVATE LIMITED",
"A A S FLIGHT SOLUTIONS PRIVATE LIMITED",
"A A STORE",
"A AHMEDALLY AND COMPANY PRIVATE LIMITED",
"A AND A PERIODICAL SUBSCRIPTION AGENCY PRIVATE LIMITED",
"A AND A REAL ESTATE PRIVATE LIMITED",
"A AND C BRAID AND ROPE COMPANY PRIVATE LIMITED",
"A AND H INFOTECH INDIA PRIVATE LIMITED",
"A AND M DIGI5 STUDIOS PRIVATE LIMITED",
"A AND M INSURANCE BROKERS PRIVATE LIMITED",
"A AND M SIGNALLING SERVICES PRIVATE LIMITED",
"A AND S LABELS PRIVATE LIMITED",
"A AND S STEEL PRIVATE LIMITED",
"A AND T BANON PRIVATE LIMITED",
"A AND V SUPPLIES PRIVATE LTD.",
"A AND W SECURITIES PRIVATE LIMITED",
"A AUTO MOVERS PRIVATE LIMITED",
"A B BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"A B C FARMS PVT LTD",
"A B C GLOBAL PRIVATE LIMITED",
"A B CARD CLOTHING PRIVATE LTD.",
"A B CARGO LOGISTICS PRIVATE LIMITED",
"A B CARRIERS DYNAMICS PRIVATE LIMITED",
"A B COMPOSITES PVT LTD",
"A B COTSPIN INDIA LIMITED",
"A B D AND CO LLP",
"A B DIAMONDS",
"A B ENTERPRISE",
"A B GRAIN SPIRITS PRIVATE LIMITED",
"A B HIGHER SECONDARY SCHOOL",
"A B HOTELS LIMITED",
"A B INFRABUILD LIMITED",
"A B LEASING AND FINANCE LIMITED",
"A B M MARKETING CELL PRIVATE LIMITED",
"A B MEDISURG PRIVATE LIMITED",
"A B METAL FORMERS PRIVATE LIMITED",
"A B MOTIONS PRIVATE LIMITED",
"A B MUTTON STALL",
"A B PAL ELECTRICALS PRIVATE LIMITED",
"A B PLASTO PRIVATE LIMITED",
"A B RENEWABLE ENERGY PRIVATE LIMITED",
"A B RESORTS AND RESTAURANTS PRIVATE LIMITED",
"A B RESORTS PRIVATE LIMITED",
"A B ROLLING MILLS PRIVATE LIMITED",
"A B S REMEDIES PRIVATE LIMITED",
"A B S S SECURITAS PRIVATE LIMITED",
"A B SCHOOL KLHUNDH TAL CHIKHLI",
"A B SINGH ASSOCIATES PRIVATE LIMITED",
"A B SMELTERS PRIVATE LIMITED",
"A B SYSTEMS PRIVATE LIMITED",
"A B T LIMITED",
"A B T TOURS & TRAVELS PRIVATE LIMITED",
"A B T TWO WHEELER PRIVATE LIMITED",
"A B TOOLS PRIVATE LIMITED",
"A B V M AGRAWAL JATIYA KOSH SETH JUGGILAL PODDAR ACADEMY",
"A BETTER CHOICE",
"A BHUPAL REDDY CIVIL CONTRACTOR",
"A BLUE HILL GRANITES INDIA PRIVATE LIMITED",
"A C & R APPLIANCES PRIVATE LIMITED",
"A C AGARWAL SHARE BROKERS PRIVATE LIMITED",
"A C BAXI AND COMPANY PRIVATE LIMITED",
"A C CHOKSI SHARE BROKERS PRIVATE LIMITED",
"A C CORPORATE SERVICES PRIVATE LIMITED",
"A C DRIVES & TECHNOLOGY PRIVATE LIMITED",
"A C E P MEDICAL ASSOCIATES PRIVATE LIMITED",
"A C L METALS PRIVATE LIMITED",
"A C N TEX PRIVATE LIMITED",
"A C PAUL AGRICULTURAL CO PVT LTD",
"A C SERVICES PRIVATE LIMITED",
"A C T AGRO-CHEM PRIVATE LIMITED",
"A C TRIBAL WELFARE",
"A CLASS MARBLE INDIA PRIVATE LIMITED",
"A D AGARWAL & CO LLP",
"A D ASSOCIATES ELECTRICALS PRIVATE LIMITED",
"A D H INKS PRIVATE LIMITED",
"A D K SILK MILLS",
"A D M EQUIPMENTS PRIVATE LIMITED",
"A D N INSTITUTE OF PARAMEDICAL SCIENCE & HOSPITAL",
"A D NET COMPUTRONICS (INDIA) PRIVATE LIMITED",
"A D PRECISION FORGINGS PRIVATE LIMITED",
"A D S DIAGNOSTIC LIMITED",
"A DELHI NETWORK PRIVATE LIMITED",
"A DESIGN INDI PRIVATE LIMITED",
"A E C MACHINERY COMPANY PRIVATE LIMITED",
"A E FOR VICE CHAIRMAN NVD AUTHORITY BHOPAL",
"A E INFRA PROJECTS PRIVATE LIMITED",
"A E S RUPIBAIBORA MOTILALJI BORA NEW ENGLISH SCHOOL",
"A EN PHED CITY SUB DIV VII UDR 14830",
"A F ENTERPRISES LIMITED",
"A F TRADING PRIVATE LIMITED",
"A FOR AYURVEDA PRIVATE LIMITED",
"A G AANDE ODISHA BHUBANESWAR",
"A G ACOUSTICS INDIA PRIVATE LIMITED",
"A G ASHTAVINAYAKA PETROCHEM PRIVATE LIMITED",
"A G BELTING PRIVATE LIMITED",
"A G DIAGNOSTICS PRIVATE LIMITED",
"A G FATS PRIVATE LIMITED",
"A G FUTURE TRENDZ PRIVATE LIMITED",
"A G HORIZON PRIVATE LIMITED",
"A G HOSPITALITIES PRIVATE LIMITED",
"A G IMARAT PRIVATE LIMITED",
"A G INDUSTRIES PRIVATE LIMITED",
"A G INFRA PROJECT",
"A G PADMAVATI'S HOSPITAL",
"A G PATIL POLYTECHNIC INSTITUTE SOLAPUR",
"A G R INFOSOLUTIONS PRIVATE LIMITED",
"A G RICE MILLS PRIVATE LIMITED",
"A G S ALUMINIUM ALLOY PRIVATE LIMITED",
"A G S CUSTOMER SERVICES (INDIA) PRIVATE LIMITED",
"A G S DEVELOPERS PRIVATE LIMITED",
"A G STANDARD ELEVATOR PRIVATE LIMITED",
"A G STOCK BROKERS PRIVATE LIMITED",
"A G SYNERGY PRIVATE LIMITED",
"A G T ELECTRONICS LIMITED",
"A G T INFRASTRUCTURE PRIVATE LIMITED",
"A G UNIVERSAL LIMITED",
"A H GLASS",
"A H INTERNATIONAL PRIVATE LIMITED",
"A H M ADVERTISING PRIVATE LIMITED",
"A H MALLICK AGRO SERVICES & COLD STORAGE PRIVATE LIMITED",
"A H WHEELER AND COMPANY PRIVATE LIMITED",
"A HARILAL AND CO PVT LTD",
"A HARTRODTINDIAPRIVATE LIMITED",
"A HIMANSHU JEWELERY PRIVATE LIMITED",
"A HYLAND PVT LTD",
"A I C CHEMICALS PRIVATE LIMITED",
"A I S MAPARA PVT LTD",
"A INFRASTRUCTURE LIMITED",
"A INNOVATIVE INTERNATIONAL LIMITED",
"A J CAST ALLOYS PVT LTD",
"A J COAL PRIVATE LIMITED",
"A J ENGINEERING",
"A J HI TECH PLY PRODUCTS PRIVATE LIMITED",
"A J INDUSTRIES PRIVATE LIMITED",
"A J INSTITUTE OF MEDICAL SCIENCES AND RESEARCH CENTER",
"A J M TOOLS PRIVATE LIMITED",
"A J PACKAGING LIMITED",
"A J RUBBERS PRIVATE LIMITED",
"A J S LOGISTICS PRIVATE LIMITED",
"A J S RAILTECH PRIVATE LIMITED",
"A J SHETTY AND CO PRIVATE LIMITED",
"A J SMART SOLUTIONS PRIVATE LIMITED",
"A JAY VENTURES PRIVATE LIMITED",
"A JAYAA TEXTILE PRIVATE LIMITED",
"A K ALLOYS PVT LTD",
"A K BUILDSOLUTION PRIVATE LIMITED",
"A K C M INSU AUXILIARY PRIVATE LIMITED",
"A K C PROJECTS AND CONTRACTS PRIVATE LIMITED",
"A K C STEEL INDUSTRIES LTD",
"A K CAPITAL FINANCE LIMITED",
"A K CAPITAL SERVICES LIMITED",
"A K CLINICS PRIVATE LIMITED",
"A K COLD STORAGE PRIVATE LIMITED",
"A K CONCAST PRIVATE LIMITED",
"A K CONTRACTORS PRIVATE LIMITED",
"A K CREATIVE OUTSOURCING SERVICES PRIVATE LIMITED",
"A K D POLYMERS PRIVATE LIMITED",
"A K DAS ASSOCIATES LIMITED",
"A K DEBT AGENCIES PRIVATE LIMITED",
"A K DUTTA & COMPANY PRIVATE LIMITED",
"A K DUTTA HOTELS PVT LTD",
"A K E INFRA STRUCTURE PRIVATE LIMITED",
"A K ENGINEERING INDUSTRIES (INDIA) PRIVATE LIMITED",
"A K ENTERPRISES PRIVATE LIMITED",
"A K EQUITIES PRIVATE LIMITED",
"A K FERROCAST PVT LTD",
"A K FORMALINE (I) PRIVATE LIMITED",
"A K FORMINGS (INDIA) PRIVATE LIMITED",
"A K G CONSULTANTS PRIVATE LIMITED",
"A K G MEMORIAL PRINTING AND PUBLISHING CO PVT LTD",
"A K G SECURITIES AND CONSULTANCY LIMITED",
"A K HARDWARE STORES PRIVATE LIMITED",
"A K INDUSTRIES PVT LTD",
"A K INFRA CONSTRUCTIONS PRIVATE LIMITED",
"A K INFRACON",
"A K INFRADEAL PRIVATE LIMITED",
"A K INFRADEVELOPERS PRIVATE LIMITED",
"A K INFRAPROJECTS PRIVATE LIMITED",
"A K JAIN SALES & MARKETING LIMITED",
"A K JAIN SALES & MARKETING PRIVATE LIMITED",
"A K K NEW LAW ACADEMY & P H D (LAW) RESEARCH CENTRE PUNE",
"A K KRISHNA PHARMA PRIVATE LIMITED",
"A K LOGISTIC PRIVATE LIMITED",
"A K LUMBERS LIMITED",
"A K M N CYLINDERS PRIVATE LIMITED",
"A K M SYSTEMS PRIVATE LIMITED",
"A K MANPOWER PRIVATE LIMITED",
"A K METANEMELLS PRIVATE LIMITED",
"A K MISHRA AGENCIES PRIVATE LIMITED",
"A K MULTIMETALS PRIVATE LIMITED",
"A K NAMKEENS PRIVATE LIMITED",
"A K NANDI AGRO BASED PRIVATE LIMITED",
"A K P FINVEST PRIVATE LIMITED",
"A K P FOUNDRIES PRIVATE LIMITED",
"A K PANELS PRIVATE LIMITED",
"A K R L LOGISTICS PRIVATE LIMITED",
"A K S AUTOMATIONS AND PRESSINGS PRIVATE LIMITED",
"A K S INTERNATIONAL LIMITED",
"A K SERVICES PRIVATE LIMITED",
"A K SHIPPING PRIVATE LIMITED",
"A K SHIVHARE INFRASTRUCTURE PRIVATE LIMITED",
"A K SHOE TRADING PRIVATE LIMITED",
"A K SPEAK WIRELESS PRIVATE LIMITED",
"A K SPINTEX LIMITED",
"A K STOCKMART PRIVATE LIMITED",
"A K SURYA POWER MAGIC PRIVATE LIMITED",
"A K SYNTHETICS PRIVATE LIMITED",
"A K TRADING COMPANY PRIVATE LIMITED",
"A K TRAVEL AND TOURS PRIVATE LIMITED",
"A KLASS DRUGS AND PHARMACEUTICALS PRIVATE LIMITED",
"A L A CHEMICALS PRIVATE LIMITED",
"A L M INDUSTRIES LIMITED",
"A L OVERSEAS",
"A L SOFTWEB PRIVATE LIMITED",
"A L W ESTATE PRIVATE LTD",
"A LINE CONSULTING PRIVATE LIMITED",
"A LITTLE WORLD PRIVATE LIMITED",
"A M BEAUTY STUDIO PRIVATE LIMITED",
"A M FLEXIPACK PRIVATE LIMITED",
"A M HANDA LUXMI NARAIN INDIA PRIVATE LIMITED",
"A M INDUSTRIES",
"A M INFOWEB PRIVATE LIMITED",
"A M JALGAONWALA AGRO PRODUCTS PRIVATE LIMITED",
"A M MARKETING PRIVATE LIMITED",
"A M MARKETPLACES PRIVATE LIMITED",
"A M MEDICAL CENTRE PRIVATE LIMITED",
"A M NAIK SCHOOL",
"A M O ESIS",
"A M PHARMACEUTICALS (INDIA) PRIVATE LIMITED",
"A M PLASTOMOULDS PRIVATE LIMITED",
"A M REDDY MEMORIAL COLLEGE OF ENGINEERING & TECHNOLOGY",
"A M S INFORM PRIVATE LTD",
"A M TEXTILES & KNITWEARS LIMITED",
"A MANIAR HEALTHCARE PRIVATE LIMITED",
"A MENARINI INDIA PRIVATE LIMITED",
"A N A FASHIONS PRIVATE LIMITED",
"A N B CONSULTING COMPANY PRIVATE LIMITED",
"A N E INDUSTRIES PRIVATE LIMITED",
"A N EXFLAME FIRE PROTECTION PRIVATE LIMITED",
"A N INSTRUMENTS PVT LTD",
"A N JOHN PRIVATE LIMITED",
"A N JOHN VENTURES PRIVATE LIMITED",
"A N KAPUR(JANITORS) PRIVATE LIMITED",
"A N LEATHERS PRIVATE LIMITED",
"A N M B T TEXTILES PRIVATE LIMITED",
"A N P TECHNOLOGIES PRIVATE LIMITED",
"A N PACKAGING PRIVATE LIMITED",
"A N PHARMACEUTICALS PRIVATE LIMITED",
"A N PHARMACIA LABORATORIES PRIVATE LIMITED",
"A N POLYMERS PRIVATE LIMITED",
"A N SECURITIES PRIVATE LIMITED",
"A N V FOODS PRIVATE LIMITED",
"A N WIRE PRIVATE LIMITED",
"A N Y GRAPHICS PRIVATE LIMITED",
"A NINETEEN FILMS PRIVATE LIMITED",
"A O SMITH INDIA WATER PRODUCTS PRIVATE LIMITED",
"A ONE BIZ SOLUTIONS PRIVATE LIMITED",
"A ONE CARETAKER PRIVATE LIMITED",
"A ONE CHEMICALS",
"A ONE ELECTRICALS",
"A ONE FOOTWEARS PRIVATE LIMITED",
"A ONE INFRACONSULTANTS PRIVATE LIMITED",
"A ONE ISPAT PRIVATE LIMITED",
"A ONE MACHINED COMPONENTS PRIVATE LIMITED",
"A ONE MILK PRODUCTS PRIVATE LIMITED",
"A ONE PAINTCHEM PRIVATE LIMITED",
"A ONE SALASAR PRIVATE LIMITED",
"A ONE STEELS INDIA PRIVATE LIMITED",
"A ONE TEXTECH PRIVATE LIMITED",
"A ONE-SILVER SHINE MANAGEMENT SERVICES PRIVATE LIMITED",
"A P A TEXTILES INDIA PRIVATE LIMITED",
"A P BEVERAGES CORP LIMITED",
"A P C SYSTEM & PRODUCTS PVT LTD",
"A P CARGO CLEARSHIP PRIVATE LIMITED",
"A P CRANES PRIVATE LIMITED",
"A P DISTRIBUTORS",
"A P ENGINEERING PRIVATE LIMITED",
"A P FLANGES PRIVATE LIMITED",
"A P FORGINGS PRIVATE LIMITED",
"A P HOLDINGS PVT LTD",
"A P I ISPAT AND POWERTECH PRIVATE LIMITED",
"A P INTERNATIONAL SCHOOL",
"A P MAHESH CO- OP URBAN BANK LTD",
"A P MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"A P MANI AND SONS VEGETABLES AND FRUITS PRIVATE LIMITED",
"A P OFFSET PRIVATE LIMITED",
"A P ORGANICS LIMITED",
"A P POLY INDUSTRIES PRIVATE LIMITED",
"A P POLYPLAST PRIVATE LIMITED",
"A P PROPERTIES PRIVATE LIMITED",
"A P REFINERY PRIVATE LIMITED",
"A P RICE MILLS PVT LTD",
"A P S ASSOCIATES PVT LTD",
"A P SECURITAS PRIVATE LIMITED",
"A P SHAH INSTITUTE OF TECHNOLOGY",
"A P STAR MOVERS PRIVATE LIMITED",
"A P T AND CO LLP",
"A P T PORTFOLIO PRIVATE LIMITED",
"A P TARAPOREVALA AND SONS PRIVATE LIMITED",
"A PAUL INSTRUMENTS PRIVATE LIMITED",
"A PLUS EDUCATION SOLUTIONS PRIVATE LIMITED",
"A PLUS EXPORTS PRIVATE LIMITED",
"A PLUS FINANCIAL SOLUTIONS PRIVATE LIMITED",
"A PLUS FIXTURES INDIA PRIVATE LIMITED",
"A PLUS PROJECTS AND TECHNOLOGY PRIVATE LIMITED",
"A PRODULE SYSTEMS PRIVATE LIMITED",
"A Q INFRASTRUCTURE PRIVATE LIMITED",
"A R AUTOMOTIVE ENGINEERING INDUSTRIES",
"A R AYURVEDA PRIVATE LIMITED",
"A R B BEARINGS LIMITED",
"A R BURLA MAHILA VARISHTHA MAHAVIDYALAYA",
"A R C CABINET SECRETARIAT",
"A R C INDIA PETROLEUM PRIVATE LIMITED",
"A R C MILLS PRIVATE LIMITED",
"A R CHADHA AND CO INDIA PVT LTD",
"A R COMM TELEVENTURE PRIVATE LIMITED",
"A R CORPORATION",
"A R DUDI AUTOMOBILES PRIVATE LIMITED",
"A R E ENTERPRISES PRIVATE LIMITED",
"A R ELECTRO POWER PRIVATE LIMITED",
"A R ENGINEERS",
"A R F ENGINEERING PRIVATE LIMITED",
"A R FABRICS PRIVATE LIMITED",
"A R G ALUMINIUM PRIVATE LIMITED",
"A R GOLD PRIVATE LIMITED",
"A R HOSE PRIVATE LIMITED",
"A R INFRAVISION PRIVATE LIMITED",
"A R K HEALTH CARE PVT LTD",
"A R L TRADING PRIVATE LIMITED",
"A R LIFE SCIENCES PRIVATE LIMITED",
"A R M MOTORS LLP",
"A R MANUFACTURING SOLUTIONS PRIVATE LIMITED",
"A R ONLINE ELECTRICALS PRIVATE LIMITED",
"A R OVERSEAS TRADECOM PRIVATE LIMITED",
"A R P AUTO PARTS PRIVATE LIMITED",
"A R PHARMACUTICAL",
"A R RAIL VIKAS SERVICES PRIVATE LIMITED",
"A R RESORTS AND HOTELS PRIVATE LIMITED",
"A R S AGRI SCIENCE PRIVATE LIMITED",
"A R S FABRICS PRIVATE LIMITED",
"A R SPARES PRIVATE LIMITED",
"A R STEEL INDUSTRIES PRIVATE LIMITED",
"A R STONE CRAFT PRIVATE LIMITED",
"A R SULPHONATES PRIVATE LIMITED",
"A R T ENTERTAINMENT & SERVICES PRIVATE LIMITED",
"A R THERMOSETS PRIVATE LIMITED",
"A R TRADE LINKS",
"A R TRANSMISSIONS PRIVATE LIMITED",
"A R WOODCRAFTS PRIVATE LIMITED",
"A RUDOLF STEINER SCHOOL",
"A RUSHABH TRADE LINK PRIVATE LIMITED",
"A S AGRAWAL ENTERPRISES PRIVATE LIMITED",
"A S AUTO INDUSTRIES",
"A S B INTER COLLEGE",
"A S BUILDTECH ENGINEERS PRIVATE LIMITED",
"A S CAR AUDIO PRIVATE LIMITED",
"A S CHATTHA EXIM PRIVATE LIMITED",
"A S CHEMOPHARMA PRIVATE LIMITED",
"A S CLEARING AND FORWARDING INDIA PRIVATE LIMITED",
"A S COLLEGE KHANNA",
"A S COMPUTER SERVICES PRIVATE LIMITED",
"A S ENTERPRISES",
"A S FASTENERS PRIVATE LIMITED",
"A S FERRUM PRIVATE LIMITED",
"A S G EXPORTS PRIVATE LIMITED",
"A S G S INVESTMENT PRIVATE LIMITED",
"A S HOSPITAL",
"A S INFLIGHT XPERTS PRIVATE LIMITED",
"A S INFOTECH E-SOLUTIONS PRIVATE LIMITED",
"A S INFRA-TECH PRIVATE LIMITED",
"A S INSTRUMENTS AND LAB PRIVATE LIMITED",
"A S IYER CONSTRUCTIONS PRIVATE LIMITED",
"A S J PROMOTERS & DEVELOPERS PRIVATE LIMITED",
"A S K BROTHERS LIMITED",
"A S K CEMENT PRIVATE LIMITED",
"A S KRISHNA AND CO PVT LTD",
"A S MALHOTRA AND ASSOCIATES PRIVATE LIMITED",
"A S MOLOOBHOY AND SONS PRIVATE LIMITED",
"A S MOLOOBHOY PRIVATE LIMITED",
"A S MULTISPECIALITY HOSPITAL",
"A S P PVT LTD",
"A S PACKERS PROVIDERS PRIVATE LIMITED",
"A S PHARMA PRIVATE LIMITED",
"A S POLYCRAFT (OPC) PRIVATE LIMITED",
"A S PRECISION MACHINES PRIVATE LIMITED",
"A S R BUSINESS ADVISORS PRIVATE LIMITED",
"A S SHIPPING AGENCIES PRIVATE LIMITED",
"A S SHOE ACCESSORIES PRIVATE LIMITED",
"A S SOFTWARE SERVICES PRIVATE LIMITED",
"A S SOLUTIONS PRIVATE LIMITED",
"A S SPINNERS PRIVATE LIMITED",
"A S STEEL INDUSTRIES",
"A S STOCK BROKING AND MANAGEMENT PRIVATE LIMITED",
"A S T PIPES PRIVATE LIMITED",
"A S TRADETECH PRIVATE LIMITED",
"A S TRANSPORT PRIVATE LIMITED",
"A S V BHAGAT SINGH HINDI U P SCH",
"A S WIRE INDUSTRIES VSP PRIVATE. LIMITED.",
"A SAJ AGRICARE PRIVATE LIMITED",
"A SAN HOSPITALITY SUPPORT COMPANY PRIVATE LIMITED",
"A SEPTEMBER HOME LIFESTYLE PRIVATE LIMITED",
"A SQUARE REMEDIES PRIVATE LIMITED",
"A STAR JEWELLERY(A DIVISION OF ASIAN STAR CO.LTD)",
"A T E ENTERPRISES PRIVATE LIMITED",
"A T H LEDER FABRIK",
"A T INVOFIN INDIA PRIVATE LIMITED",
"A T KEARNEY CONSULTING (INDIA) PRIVATE LIMITED",
"A T KEARNEY INDIA PVT LTD",
"A T O I LTD",
"A T PAPER PRINT PRIVATE LIMITED",
"A T POLYMER AGENCY PRIVATE LIMITED",
"A T SEASONS & VACATIONS TRAVEL PRIVATE LIMITED",
"A T THREADS PRIVATE LIMITED",
"A TECH INFRASTRUCTURES PRIVATE LIMITED",
"A THREE AGRO TECH PRIVATE LIMITED",
"A TO Z ALLOYS PRIVATE LIMITED",
"A TO Z BROADBAND SERVICE AND SOLUTIONS PRIVATE LIMITED",
"A TO Z CATERING SERVICES PRIVATE LIMITED",
"A TO Z DEVELOPERS LIMITED",
"A TO Z ELECTROTRADE (INDIA) PRIVATE LIMITED",
"A TO Z EXPRESS GOODS CARRIERS INDIA PRIVATE LIMITED",
"A TO Z FOREX PRIVATE LIMITED",
"A TO Z HOLDINGS PRIVATE LIMITED",
"A TO Z HOUSEKEEPING SOLUTIONS PRIVATE LIMITED",
"A TO Z INFRASPARES PRIVATE LIMITED",
"A TO Z LIFESTYLE (INDIA) PRIVATE LIMITED",
"A TO Z NDT SOLUTIONS PRIVATE LIMITED",
"A TO Z PROTECTION & AMC SERVICES PRIVATE LIMITED",
"A TO Z SECURITIES LIMITED",
"A TO Z SECUTECH PRIVATE LIMITED",
"A TO Z SERVICES PRIVATE LIMITED",
"A TO Z STEELLOYS PRIVATE LIMITED",
"A TO Z TIE UP PVT LTD",
"A TO Z WIRES (NASHIK) PRIVATE LIMITED",
"A TOSH & SONS INDIA LIMITED",
"A TREDS LIMITED",
"A V A SPICEX PRIVATE LIMITED",
"A V ACCESSORIES AND ATTACHMENTS PRIVATE LIMITED",
"A V ASHIYANA PRIVATE LIMITED",
"A V AUTO INDUSTRIES PRIVATE LIMITED",
"A V BOBBINS PRIVATE LIMITED",
"A V COMPSOL PRIVATE LIMITED",
"A V COMPUSOFT PRIVATE LIMITED",
"A V ENGINEERS PRIVATE LIMITED",
"A V GLOBAL CORPORATION PRIVATE LIMITED",
"A V GOLD PRIVATE LIMITED",
"A V HOTELS PVT LTD",
"A V IMMIGATION AND CAREERS CONSULTANCY PRIVATE LIMITED",
"A V M SALES PVT LTD",
"A V MULTIMEDIA PRIVATE LIMITED",
"A V N INT COLL HATHRAS",
"A V P WATER WORLD (INDIA) PRIVATE LIMITED",
"A V PLASTIC EQUIPMENTS PRIVATE LIMITED",
"A V PRECISION TUBES PRIVATE LIMITED",
"A V RAMBABU INFRA PRIVATE LIMITED",
"A V S R HOLDINGS PRIVATE LIMITED",
"A V S READY MIX CONCRETE PRODUCTS PRIVATE LIMITED",
"A V SMARAK VIDYAMANDIR VIRAR",
"A V THOMAS LEATHER & ALLIED PRODUCTS PRIVATE LIMITED",
"A V V ENTERPRISES PRIVATE LIMITED",
"A V WELDTECH PRIVATE LIMITED",
"A W FABER CASTELL INDIA PRIVATE LIMITED",
"A Y S JEWELS PRIVATE LIMITED",
"A Y SERVICES PRIVATE LIMITED",
"A&A AUTOMOBILES PRIVATE LIMITED",
"A&A HEALTHCARE PRIVATE LIMITED",
"A&A PICTURES PRIVATE LIMITED",
"A&B CONSULTANCY SOLUTIONS PRIVATE LIMITED",
"A&B HOUSEKEEPERS PRIVATE LIMITED",
"A&D INSTRUMENTS INDIA PRIVATE LIMITED",
"A&I HOSPITALITY PRIVATE LIMITED",
"A&J MICRONS (BHARAT) PRIVATE LIMITED",
"A&J MINECHEM PRIVATE LIMITED",
"A&M RESOURCES PRIVATE LIMITED",
"A&M SUPPLIES INDIA PRIVATE LIMITED",
"A&N UNIVERSE MARKET RESEARCH INDIA PRIVATE LIMITED",
"A&S LUXURY FASHION HOUSE PRIVATE LIMITED",
"A&T ENGINEERING PRIVATE LIMITED",
"A&V FASHION HOUSE PRIVATE LIMITED",
"A&W ENGINEERING WORKS (INDIA) PRIVATE LIMITED",
"A&Y KIDNEY HOSPITAL PRIVATE LIMITED",
"A. B. BANSAL FOODS PRIVATE LIMITED",
"A. B. BIZHUB PRIVATE LIMITED",
"A. B. MULTI PHARMA PRIVATE LIMITED",
"A. B. P. ENTERPRISES PRIVATE LIMITED",
"A. BHATIA INT PRIVATE LIMITED",
"A. C. FOOTWEAR PRIVATE LIMITED",
"A. C. HUMIDIN AIR SYSTEMS PRIVATE LIMITED",
"A. CHOWDHURY CONSTRUCTION PRIVATE LIMITED",
"A. D. GLOBAL SYNERGIES PRIVATE LIMITED",
"A. ENERGYS PRIVATE LIMITED",
"A. G. CONCEPTS PRIVATE LIMITED",
"A. G. TOURS PRIVATE LIMITED",
"A. I. ISPAT PRIVATE LIMITED",
"A. J BELTINGS PRIVATE LIMITED",
"A. J. PRECISION & AUTOMATION PRIVATE LIMITED",
"A. K. DREAM CITY PRIVATE LIMITED",
"A. K. INFRADREAM LIMITED",
"A. K. L. INFRACON PRIVATE LIMITED",
"A. K. PIPE FITTING PRIVATE LIMITED",
"A. K. SHAW & CO. WINES SALE PRIVATE LIMITED",
"A. K. TECHNOPOWER INDIA PRIVATE LIMITED",
"A. K. TRADING (PAPER) PRIVATE LIMITED",
"A. K. WEALTH MANAGEMENT PRIVATE LIMITED",
"A. L. A TRADING PRIVATE LIMITED",
"A. L. SOFTWEB PRIVATE LIMITED",
"A. L. T. INFOTECH PRIVATE LIMITED",
"A. M. ASSOCIATES PRIVATE LIMITED",
"A. M. DIAMONDS PRIVATE LIMITED",
"A. M. MULTI PACKAGING PRIVATE LIMITED",
"A. M. PATEL INFRA PRIVATE LIMITED",
"A. N. INTERIOR STUDIO PRIVATE LIMITED",
"A. N. R. LIGHTING PRIVATE LIMITED",
"A. N. SETHURAMAN (OPC) PRIVATE LIMITED",
"A. P. EXPERT TRAVO PRIVATE LIMITED",
"A. P. LEATHER CO. PRIVATE LIMITED",
"A. P. YARNS PRIVATE LIMITED",
"A. R. AMBOLI DEVELOPERS PRIVATE LIMITED",
"A. R. TECHNOPACK INDUSTRIES PRIVATE LIMITED",
"A. RANGASAMY ENGINEERS PRIVATE LIMITED",
"A. S. IRON AND STEELS INDIA PRIVATE LIMITED",
"A. S. K LANDS PROJECTS PRIVATE LIMITED",
"A. S. L. TRAVELS PRIVATE LIMITED",
"A. S. MEHTA AND PRIVATE LIMITED",
"A. S. VASAN SHIPPING SERVICES PRIVATE LIMITED",
"A. S. YARN TEX PRIVATE LIMITED",
"A. SIRKAR & CO. (JEWELLERS) PVT LTD",
"A. T. EXPORTS",
"A. V. FREIGHT & LOGISTICS PRIVATE LIMITED",
"A. V. POLYPLAST PRIVATE LIMITED",
"A. W. CONSTRUCTIONS PRIVATE LIMITED",
"A.A. AUTECH PRIVATE LIMITED",
"A.A. AUTOTECH PRIVATE LIMITED",
"A.A.PMC AND ENGINEERING LLP",
"A.A.TRENDZ PRIVATE LIMITED",
"A.A.YARNS PRIVATE LIMITED",
"A.AND A.ORGO CHEM PRIVATE LIMITED",
"A.B. COTTON DESIGN PRIVATE LIMITED",
"A.B. DESIGNERS AND ENGINEERS PRIVATE LIMITED",
"A.B. GENSETS PRIVATE LIMITED",
"A.B.C. BROTHERS TECH (I) PRIVATE LIMITED",
"A.B.C.POULTECH PRIVATE LIMITED",
"A.B.M WOOD- DECOR PRIVATE LIMITED",
"A.B.METAL CASTERS PRIVATE LIMITED",
"A.B.PLASTICS PRIVATE LIMITED",
"A.B.S.A TRADES PRIVATE LIMITED",
"A.C. AND COMPANY PRIVATE LIMITED",
"A C POLYCOATERS PRIVATE LIMITED",
"A.C. UNICOATERS PRIVATE LIMITED",
"A.C.BIMAL KUMAR PVT LTD",
"A.C.SECURITY PRODUCTS PRIVATE LIMITED",
"A.CHOKSHI ENGINEERING PRIVATE LIMITED",
"A.D. AIRCONDITIONER PRIVATE LIMITED",
"A.D. ENTERPRISES PRIVATE LIMITED",
"A.D. HOTELS PVT LTD",
"A.D. PLYWOOD INDIA PRIVATE LIMITED",
"A.D. PRODUCTS PRIVATE LIMITED",
"A.D.BRUSHES (INDIA) PRIVATE LIMITED",
"A.D.S. IMPEX PRIVATE LIMITED",
"A.D.S.ENGINEERING PRIVATE LIMITED",
"A.E INFRATECH PRIVATE LIMITED",
"A.E. AUTOMOTION PRIVATE LIMITED",
"A.E.LOGISTICS PRIVATE LIMITED",
"A.EBERLE SYSTEMS PRIVATE LIMITED",
"A.G BUSINESS PRIVATE LIMITED",
"A.G. ADVANCE CHEMICALS PRIVATE LIMITED",
"A.G. AGRI MART PRIVATE LIMITED",
"A.G. CONVEYOR PARTS PRIVATE LIMITED",
"A.G. DESIGNS AND DEVELOPMENT PRIVATE LIMITED",
"A.G. GASOCHEM PRIVATE LIMITED",
"A.G. HOSPITALS PRIVATE LIMITED",
"A.G. INDIA RETAIL PRIVATE LIMITED",
"A.G. ORGANICA PRIVATE LIMITED",
"A.G. SHARES AND SECURITIES LIMITED",
"A.G.PADMAVATI'S HOSPITAL LIMITED",
"A.G.PIPES PRIVATE LIMITED",
"A.GANAPATHI CHETTIAR PRIVATE LIMITED",
"A.H. FASHION KARMA PRIVATE LIMITED",
"A.H. IVF & INFERTILITY RESEARCH CENTRE PRIVATE LIMITED",
"A.H. MARKET ACCESS TRANSFORMATION PRIVATE LIMITED",
"A.H. PHARMAMECH PRIVATE LIMITED",
"A.H.WANI INFRATECH PRIVATE LIMITED",
"A.I. CONSULTANCY AND SERVICES PRIVATE LIMITED",
"A.I.A. INFRATECH PRIVATE LIMITED",
"A.I.ENTERPRISES PRIVATE LIMITED",
"A.J. AUTO PRIVATE LIMITED",
"A.J. DAIRY PRIVATE LIMITED",
"A.J. EXPORTS PRIVATE LIMITED",
"A.J. TOBACCO PRODUCTS PRIVATE LIMITED",
"A.J.MEHTA & CO. LLP",
"A.J.STATIONERY PRIVATE LIMITED",
"A.JAIN AND COMPANY PVT.LTD.",
"A.K STEEL TRADING PRIVATE LIMITED",
"A.K TOURS PRIVATE LIMITED",
"A.K. BAKELITE AND RESINS PRIVATE LIMITED",
"A.K. CAPITAL FINANCE PRIVATE LIMITED",
"A.K. CHEMICALS (GUJARAT) PRIVATE LIMITED",
"A.K. LEATHER EXPORT PRIVATE LIMITED",
"A.K. MANAGE MENT SERVICES PRIVATE LIMITED",
"A.K. OUTSOURCING SERVICES PRIVATE LIMITED",
"A.K. POWER TRANSMISSION TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"A.K. SAREES PRIVATE LIMITED",
"A.K. SUPPLIERS PRIVATE LIMITED",
"A.K. TEXTILES DISTRIBUTORS PRIVATE LIMITED",
"A.K. VYAPAR PRIVATE LIMITED",
"A.K.A. CHEMICALS PRIVATE LIMITED",
"A.K.D.K JAIN TRADING PRIVATE LIMITED",
"A.K.G. INFRATECH PRIVATE LIMITED",
"A.K.INDIA CERAMICS PRIVATE LIMITED",
"A.K.J.SECURITIES PRIVATE LIMITED",
"A.K.M.K. ENTERPRISES PRIVATE LIMITED",
"A.K.MINERALS PVT.LTD.",
"A.K.PAPER PRODUCTS PRIVATE LIMITED",
"A.K.S.HOUSING DEVELOPMENT COMPANY PRIVATE LIMITED",
"A.K.VENEERS PRIVATE LIMITED",
"A.L. COLDFORGE PRIVATE LIMITED",
"A.L. LOGISTICS PRIVATE LIMITED",
"A.L. OIL MILLS PRIVATE LIMITED",
"A.L. TRANS PRIVATE LIMITED",
"A.M. BUILDTECH PRIVATE LIMITED",
"A.M. ECOSYSTEM TECHNOLOGIES PRIVATE LIMITED",
"A.M. FASHIONS (INDIA) PRIVATE LIMITED",
"A.M. LATEX FOAM PRIVATE LIMITED",
"A.M. MASTERBATCH PRIVATE LIMITED",
"A.M. NUTRATECH PRIVATE LIMITED",
"A.M. TRADELINK PRIVATE LIMITED",
"A.M.A AGRO OIL PRIVATE LIMITED",
"A.M.A.S. TRADEX PRIVATE LIMITED",
"A.M.N. JEWELLERS PRIVATE LIMITED",
"A.M.P. POLYMERS INDIA PRIVATE LIMITED",
"A.N. ELECTRO-MECH (INDIA) PRIVATE LIMITED",
"A.N. MANUFACTURING PRIVATE LIMITED",
"A.N. PRAKASH CONSTRUCTION PROJECT MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"A.N.B. AUTO (INDIA) PRIVATE LIMITED",
"A.N.D VALVES AND CASTINGS INDIA PRIVATE LIMITED",
"A.N.D. INFRA DEVELOPMENT PRIVATE LIMITED",
"A.N.G MERCHANDISE PRIVATE LIMITED",
"A.N.INVESTMENTS PRIVATE LIMITED",
"A.N.J. METAL RECYCLING PRIVATE LIMITED",
"A.N.MARKET SOLUTIONS PRIVATE LIMITED",
"A.N.S. PAPER MILLS PRIVATE LIMITED",
"A.N.TRAVELS & ROADLINES PRIVATE LIMITED",
"A.P SHREE COLONISERS PRIVATE LIMITED",
"A.P. AUTOMOTIVES PVT. LTD.",
"A.P. CONSTRUCTIONS INDIA PRIVATE LIMITED",
"A.P. ELECTRICALS SALES & SERVICES",
"A.P. ENGINEERS & INTERIORS PRIVATE LIMITED",
"A.P. GEMS AND JEWELLARY PARK PRIVATE LIMITED",
"A.P. JUTE PRODUCTS PRIVATE LIMITED",
"A.P. MANI SUPERMARKETS PRIVATE LIMITED",
"A.P. PRECISION AUTOMAX PRIVATE LIMITED",
"A.P.A. INFRASTEEL PRIVATE LIMITED",
"A.P.ENGINEERING PRIVATE LIMITED",
"A.P.FASTENERS PRIVATE LIMITED",
"A.P.FINE CHEM PRIVATE LIMITED",
"A.P.FOUNDRIES PRIVATE LIMITED",
"A.P.G. PROTECTION AND INTELLIGENCE PRIVATE LIMITED",
"A.P.I. CIVILCON PRIVATE LIMITED",
"A.P.I. MOTORS PRIVATE LIMITED",
"A.P.I.D.C. VENTURE CAPITAL PRIVATE LIMITED",
"A.P.K.S ORGANIC INDIA PRIVATE LIMITED",
"A.P.MET-ENGG LIMITED",
"A.P.S PUBLIC SCHOOL",
"A.P.S. AND COMPANY PRIVATE LIMITED",
"A.P.S.HIRE PURCHASE LIMITED",
"A.PAUL SOFTWARE SYSTEMS PRIVATE LIMITED",
"A.R .DYES & CHEMICALS",
"A.R DAIRY FOOD PRIVATE LIMITED",
"A.R INDUSTRIAL SOLUTIONS PRIVATE LIMITED",
"A.R. CREDIT INFORMATION SERVICES PRIVATE LIMITED",
"A.R. FISHERIES PRIVATE LIMITED",
"A R FOUNDATIONS PRIVATE LIMITED",
"A.R. HOSPITAL PRIVATE LIMITED",
"A.R. INNOVATIONS PRIVATE LIMITED",
"A.R. LEASING PRIVATE LIMITED",
"A.R. PETROCHEM PRIVATE LIMITED",
"A.R. POWER EQUIPMENTS PRIVATE LIMITED",
"A.R. RELOCATIONS PRIVATE LIMITED",
"A.R. SOLANKI STOCKS PRIVATE LIMITED",
"A.R.ALLOYS PRIVATE LIMITED",
"A.R.FOODS PRIVATE LIMITED",
"A.R.HIND LASER POINT PRIVATE LIMITED",
"A.R.HOLDINGS AND ELECTRONICS PRIVATE LIMITED",
"A.R.PHARMA PACKAGING PRIVATE LIMITED",
"A.R.S AUTOMOTIVE PRIVATE LIMITED",
"A.R.S. AGRO BUSINESS PRIVATE LIMITED",
"A.R.S. INTERNATIONAL PRIVATE LIMITED",
"A.R.S. LINERS (INDIA) PRIVATE LIMITED",
"A.R.S. PROPERTIES PRIVATE LIMITED",
"A.R.STANCHEM PRIVATE LIMITED",
"A.R.T. FABRICATION INDUSTRIES PRIVATE LIMITED",
"A.R.TECHNOLOGIES PRIVATE LIMITED",
"A.R.V. FOOTWEAR PRIVATE LIMITED",
"A.R.WILFLEY INDIA PRIVATE LIMITED",
"A.R.WIRE PRODUCTS PRIVATE LIMITED",
"A.R.Y. STEELS PRIVATE LIMITED",
"A.R.Y. TEXTILE MARKETING PRIVATE LIMITED",
"A.S BRAWNY METAL & ALLOYS PRIVATE LIMITED",
"A.S JUSTRIDE TOURS AND TRAVELS PRIVATE LIMITED",
"A.S. BOARD AND PAPER BOXES PRIVATE LIMITED",
"A.S. CAREHOMES PRIVATE LIMITED",
"A.S. CARRIERS PRIVATE LIMITED",
"A.S. COSMETICS PRIVATE LIMITED",
"A.S. COTEX AND CLOTHING PRIVATE LIMITED",
"A.S. FRESH EXOTICS PRIVATE LIMITED",
"A.S. HEALTHCARE ASSISTANCE PRIVATE LIMITED",
"A.S. JUTE PRODUCT PRIVATE LIMITED",
"A.S. KIDNEY HOSPITAL & STONE CENTRE PRIVATE LIMITED",
"A.S. KOLKATA PLY HOUSE PRIVATE LIMITED",
"A.S. MAGNATICINFRA PRIVATE LIMITED",
"A.S. MOBIKES PRIVATE LIMITED",
"A.S. REDDY INFRATECH PRIVATE LIMITED",
"A.S. SECURA SECURITY AND FACILITY MANAGEMENT PRIVATE LIMITED",
"A.S. STEEL TRADERS (VSP) PRIVATE LIMITED",
"A.S. TECHNO GREEN PRIVATE LIMITED",
"A.S. TELEMATICS PRIVATE LIMITED",
"A.S. WASHERS PRIVATE LIMITED",
"A.S.CONFIN PVT.LTD.",
"A.S.I. SALES PRIVATE LIMITED",
"A.S.K.BROTHERS .PRIVATE LIMITED",
"A.S.M EVENT TECHNOLOGY PRIVATE LIMITED",
"A.S.P. INVESTMENTS PRIVATE LIMITED",
"A.S.R. REALTORS PRIVATE LIMITED",
"A.S.SS AYURVEDIC COLLEGE NASHIK",
"A.S.TEXTILES PVT LTD",
"A.T. BUILDCON PRIVATE LIMITED",
"A.T. KEARNEY LIMITED",
"A.T. PIPES (INDIA) PRIVATE LIMITED",
"A.T. TRADE OVERSEAS PRIVATE LIMITED",
"A.T.E. PRIVATE LIMITED",
"A.T.O. EXIMS PRIVATE LIMITED",
"A.T.R. CONSTRUCTION PVT. LTD.",
"A.T.S MECHANICALS & ELECTRONIC PRIVATE LIMITED",
"A.TOSH ISHIMITSU BEVERAGES INDIA PRIVATE LIMITED",
"A.U.T.O. WIRES PRIVATE LIMITED",
"A.V TECHNO SOFT INDIA PRIVATE LIMITED",
"A.V. AUTOMOBILES PRIVATE LIMITED",
"A.V. CAM CORPORATION",
"A.V. INFRAPROJECTS PRIVATE LIMITED",
"A.V. ISPAT PRIVATE LIMITED",
"A.V. UNICOATERS PRIVATE LIMITED",
"A.V. VALVES LIMITED",
"A.V.A. ASSOCIATES (INDIA) PRIVATE LIMITED",
"A.V.DIGITAL NETWORKS(HYDERABAD) PRIVATE LIMITED",
"A.V.H. HEALTH CARE INDIA PRIVATE LIMITED",
"A.V.M.M.ASSOCIATES PRIVATE LIMITED",
"A.V.PROPERTIES (INDIA) PRIVATE LIMITED",
"A.V.R.N.HOTELS PRIVATE LIMITED",
"A.V.S. BRAKE LININGS PVT LTD",
"A.V.S.M. SOLUTIONS INDIA PRIVATE LIMITED",
"A.W. BUILDERS & REALTORS PRIVATE LIMITED",
"A.W. INDUSTRIES PRIVATE LIMITED",
"A.Y. TEXTILES INDUSTRIES PRIVATE LIMITED",
"A-1 ACID LIMITED",
"A1 AGRI GLOBAL LIMITED",
"A1 BILLING & CONSULTANCY PRIVATE LIMITED",
"A1 BLOWERS INDIA PRIVATE LIMITED",
"A1 CHIPS AND EXPORTS (INDIA) PRIVATE LIMITED",
"A1 CLAMPS INDIA PRIVATE LIMITED",
"A1 CLASSIC FLEXIPACK PRIVATE LIMITED",
"A-1 CUISINES PRIVATE LIMITED",
"A1 FARMERS MILK PRODUCER COMPANY LIMITED",
"A1 FIDELITY SERVICES PRIVATE LIMITED",
"A1 FORCE SECURITY PRIVATE LIMITED",
"A1 FUTURE TECHNOLOGIES PRIVATE LIMITED",
"A-1 HANDLOOMS PRIVATE LIMITED",
"A-1 HEIGHTS & HOSPITALITY PRIVATE LIMITED",
"A1 PRECISION SOLUTIONS PRIVATE LIMITED",
"A1 SOURCE LOGIX PRIVATE LIMITED",
"A-1 TEAK PRODUCTS PRIVATE LIMITED",
"A1 TECHNOLOGIES AND SERVICES PRIVATE LIMITED",
"A1 TRADERS",
"A10 NETWORKS INDIA PRIVATE LIMITED",
"A2 INFRASOL PRIVATE LIMITED",
"A2 SOFTWARE MANAGEMENT & CONSULTANCY SERVICES PRIVATE LIMITED",
"A2 WINGS AUTOMOBILES PRIVATE LIMITED",
"A2AIRCONDITIONING CO. PRIVATE LIMITED",
"A2B GIFTING SOLUTIONS PRIVATE LIMITED",
"A2DS SCHUH FABRIK PRIVATE LIMITED",
"A2DYA MILK AND ORGANIC PRODUCTS PRIVATE LIMITED",
"A2G CIVIL ENGINEERING SERVICES PRIVATE LIMITED",
"A2G PLACEMENT PRIVATE LIMITED",
"A2IR INDUSTRIES PRIVATE LIMITED",
"A2K EPIC DECOR PRIVATE LIMITED",
"A2K POLYWEAVES PRIVATE LIMITED",
"A2P ENERGY SOLUTION PRIVATE LIMITED",
"A2R BROTHERS",
"A2VK TRADE IMPEX PRIVATE LIMITED",
"A2Z AGRI TECHNOLOGY PRIVATE LIMITED",
"A2Z EXCURSION PRIVATE LIMITED",
"A2Z FILTRATION SPECIALITIES PRIVATE LIMITED",
"A2Z HARDWARE & NETWORKING IT SOLUTION PRIVATE LIMITED",
"A2Z INFOTECH PRIVATE LIMITED",
"A2Z INFRA ENGINEERING LIMITED",
"A2Z INFRADEVELOPERS PRIVATE LIMITED",
"A2Z INFRASERVICES LIMITED",
"A2Z KNITTING INDUSTRIES PRIVATE LIMITED",
"A2Z LOGISTICS",
"A2Z MULTISERVICES AND IT SOLUTIONS PRIVATE LIMITED",
"A2Z ONLINE SERVICES PRIVATE LIMITED",
"A2Z PARTY DECO PRIVATE LIMITED",
"A2Z SUPPORT SERVICES PRIVATE LIMITED",
"A2Z TEAMACH PRIVATE LIMITED",
"A2Z WASTE MANAGEMENT (ALIGARH) LIMITED",
"A2Z WASTE MANAGEMENT (JAIPUR) LIMITED",
"A2Z WHEEL RACE PRIVATE LIMITED",
"A2ZSUPER MALL PRIVATE LIMITED",
"A3 AQUA PRIVATE LIMITED",
"A3 INFOMATICS INDIA PRIVATE LIMITED",
"A3 MINERALS AND METAL EXPORT PRIVATE LIMITED",
"A3 REMOTE MONITORING TECHNOLOGIES PRIVATE LIMITED",
"A3 TECHNO CRAFTS PRIVATE LIMITED",
"A3A INFOTECH PRIVATE LIMITED",
"A3LOGICS INDIA LIMITED",
"A3M CONTRACTS INDIA PRIVATE LIMITED",
"A3P INFRA LIMITED",
"A4 ELECTRICALS PRIVATE LIMITED",
"A4 STAR INFRATECH PRIVATE LIMITED",
"A4A HOSPITALITY SERVICES PRIVATE LIMITED",
"A4DM DIGITAL AUTOMATION PRIVATE LIMITED",
"A5 HEALTH SOLUTIONS PRIVATE LIMITED",
"A5E CONSULTING PRIVATE LIMITED",
"AA ARTS SCIENCE COLLEGE",
"AA BEE RESORT AND TRAVEL PRIVATE LIMITED",
"AA BIZCORP PRIVATE LIMITED",
"AA BRANDS PRIVATE LIMITED",
"AA EDUTECH PRIVATE LIMITED",
"AA ELECTRO MAGNETIC TEST LABORATORY PRIVATE LIMITED",
"AA GLOBAL ENGINEERING AND CONSTRUCTION COMPANY PRIVATE LIMITED",
"AA LABELS PRIVATE LIMITED",
"AA PLUS TRADELINK LIMITED",
"AA REALVENTURE PRIVATE LIMITED",
"AA STANDARD IMPEX PRIVATE LIMITED",
"AA STUDIO CONSULTING PRIVATE LIMITED",
"AA.RA. HOTELS PRIVATE LIMITED",
"AAA 2 INNOVATE PRIVATE LIMITED",
"AAA ADVISORY SERVICES PRIVATE LIMITED",
"AAA CAPITAL SERIVICES PRIVATE LIMITED",
"AAA CONSTRUCTIONS PRIVATE LIMITED",
"AAA CREATIVE SOLUTIONS PRIVATE LIMITED",
"AAA ENGINEERING SERVICES",
"AAA HYDRAULICS (INDIA) PRIVATE LIMITED",
"AAA INSOLVENCY PROFESSIONALS LLP",
"AAA INTERNATIONAL EDUCATION SERVICES PRIVATE LIMITED",
"AAA PAPER MARKETING LIMITED.",
"AAA PEE FOUNDATIONS PRIVATE LIMITED",
"AAA PHARMATRADE PRIVATE LIMITED",
"AAA PLUS RISK MANAGEMENT PRIVATE LIMITED",
"AAA PRODUCTS PRIVATE LIMITED",
"AAA PUBLICITY PRIVATE LIMITED",
"AAA ROLLER FLOUR MILLS PRIVATE LIMITED",
"AAA SALT AND CHEMICALS PRIVATE LIMITED",
"AAA SHENYANG CONTAINER SEAL PRIVATE LIMITED",
"AAA SULPHITE PRIVATE LIMITED",
"AAA SUPPORTS PRIVATE LIMITED",
"AAA SWITCH GEAR PRIVATE LIMITED",
"AAA TECHNOLOGIES LIMITED",
"AAA TECHNOLOGIES PRIVATE LIMITED",
"AAA TEXTILES PRIVATE LIMITED",
"AAA TRAINING HUB PRIVATE LIMITED",
"AAA VEHICLEADES PRIVATE LIMITED",
"AAA VENTURES CONSULTANCY SERVICES PRIVATE LIMITED",
"AAA WASHERS & DYERS PRIVATE LIMITED",
"AAAA DURA SMART INDIA PRIVATE LIMITED",
"AAAAA TRADE INDIA PRIVATE LIMITED",
"AAACORP EXIM INDIA PRIVATE LIMITED",
"AAAPLUS TRADING PRIVATE LIMITED",
"AAAR FINANCIAL SERVICES PRIVATE LIMITED",
"AAARA SHIPPING PRIVATE LIMITED",
"AAAS FOODS AND NATURE'S SOUL PRIVATE LIMITED",
"AAASK CHEMTECH PRIVATE LIMITED",
"AAASMA MICROBIZ PRIVATE LIMITED",
"AABAD DAIRY PRIVATE LIMITED",
"AABAD FOOD PVT LTD",
"AABAD MARKETING PRIVATE LIMITED",
"AABASOFT TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"AABHA CONTRACEPTIVES PRIVATE LIMITED",
"AABHAS SPINNERS PVT LTD",
"AABHIR TEXTILE PRIVATE LIMITED",
"AABHUSHAN FOREX & JEWELS PRIVATE LIMITED",
"AABHUSHAN JEWELLERS PRIVATE LIMITED",
"AABHYASA TECHNOLOGIES PRIVATE LIMITED",
"AABIPORT PRIVATE LIMITED",
"AABMATICA TECHNOLOGIES PRIVATE LIMITED",
"AABON SMIT ALLOYS PRIVATE LIMITED",
"AABSYS INFORMATION TECHNOLOGY PRIVATE LIMITED",
"AAC MINING EXECUTORS INDIA PRIVATE LIMITED",
"AAC NATURAL PRODUCTS PRIVATE LIMITED",
"AACBD MAINTENANCE SERVICES PRIVATE LIMITED",
"AACE HITECH ENGINEERING PRIVATE LIMITED",
"AACESS TOUGH DOORS PRIVATE LIMITED",
"AACHARAN ENTERPRISES PRIVATE LIMITED",
"AACHI GLOBAL SCHOOL",
"AACHI MASALA FOODS PRIVATE LIMITED",
"AACHI SPECIAL FOODS PRIVATE LIMITED",
"AACHI SPICES AND FOODS PRIVATE LIMITED",
"AACHMAN VANIJYA PVT. LTD.",
"AACK TECHNOCRAFT TOOLINGS PRIVATE LIMITED",
"AACP INFRASTRUCTURE SYSTEMS PRIVATE LIMITED",
"AAD CONTRACTS PRIVATE LIMITED",
"AAD CORPORATION PRIVATE LIMITED",
"AAD RETAIL PRIVATE LIMITED",
"AAD TECH ENVIRON PRIVATE LIMITED",
"AAD TECH INDIA PRIVATE LIMITED",
"AADARSH ADCRAFT",
"AADARSH AUTOMOTIVES LLP",
"AADARSH BHARAT ENVIRO PRIVATE LIMITED",
"AADARSH CREDIT CO-OPERATIVE SOCIETY LIMITED",
"AADARSH EXTRUSION PRIVATE LIMITED",
"AADARSH FOUNDATION",
"AADARSH HOME DECOR PRIVATE LIMITED",
"AADARSH INDUSTRIAL SERVICES",
"AADARSH INFRASPACE PRIVATE LIMITED",
"AADARSH LIFE CARE",
"AADARSH NURSING INSTITUTE PRIVATE LIMITED",
"AADARSH PRIVATE LIMITED",
"AADARSH QUALITY PRIVATE LIMITED",
"AADARSH TECHNOSOFT PRIVATE LIMITED",
"AADARSH TRADLINK LIMITED",
"AADARSH TREASURY COLLECTORATE LUCKNOW",
"AADARSH VIDYALAY & ART SCIENCE COMMERS COLLEGE MANDANE",
"AADARSHA CHITRALAYA PRIVATE LIMITED",
"AADCO TESTING & RESEARCH LABORATORY PRIVATE LIMITED",
"AADD TECHNOLOGIES PRIVATE LIMITED",
"AADE TRANS LOGISTICS PRIVATE LIMITED",
"AADEE INDIA LIMITED",
"AADEESH ENGINEERING (PUNE)PRIVATE LIMITED",
"AADEESHAKTHI AUTO PRIVATE LIMITED",
"AADESH DYESTUFF PRIVATE LIMITED",
"AADESH ENTERPRISES PRIVATE LIMITED",
"AADESH ROADTECH INDIA PRIVATE LIMITED",
"AADESH SALES PRIVATE LIMITED",
"AADESH TRAVELS PRIVATE LIMITED",
"AADESHWAR PAPER PRODUCTS PRIVATE LIMITED",
"AADEVRAJ TECH SOLUTIONS PRIVATE LIMITED",
"AADEY JEWELS PRIVATE LIMITED",
"AADHAAR FOODS AND AGRO INDUSTRIES PRIVATE LIMITED",
"AADHAAR WHOLESALE TRADING AND DISTRIBUTION LIMITED",
"AADHAN MEDIA PRIVATE LIMITED",
"AADHAR DIGITAL VISION PRIVATE LIMITED",
"AADHAR EQUIPMENTS PRIVATE LIMITED",
"AADHAR HOSPITAL AADHAR HEALTH INSTITUTE",
"AADHAR HOUSING FINANCE LIMITED",
"AADHAR INDUSTRIES PRIVATE LIMITED",
"AADHAR INFONET PRIVATE LIMITED",
"AADHAR INFRACRAFT (INDIA) PRIVATE LIMITED",
"AADHAR INFRAPROJECTS PRIVATE LIMITED",
"AADHAR MEDICARE PRIVATE LIMITED",
"AADHAR PACKAGING INDUSTRIES PRIVATE LIMITED",
"AADHAR PRODUCTS PRIVATE LIMITED",
"AADHAR RICE MILL PRIVATE LIMITED",
"AADHAR SALES AND SERVICES PRIVATE LIMITED",
"AADHAR SECURITY & FACILITY SOLUTIONS PRIVATE LIMITED",
"AADHAR STUMBH INFRA PRIVATE LIMITED",
"AADHAR STUMBH TOWNSHIP PRIVATE LIMITED",
"AADHAR TECH & PROJECTS PRIVATE LIMITED",
"AADHARRSHILA ENROLL SYSTEMS PRIVATE LIMITED",
"AADHARSHILA BUILDERS PVT LTD",
"AADHARSHILA DESIGNS PRIVATE LIMITED",
"AADHARSHILA HOSPITALITY PRIVATE LIMITED",
"AADHARSHILA INFRATECH PRIVATE LIMITED",
"AADHARSHILA MOBILITY SOLUTIONS PRIVATE LIMITED",
"AADHARSHILA PROJECTS PRIVATE LIMITED",
"AADHARSHILLA CONTRACTORS PRIVATE LIMITED",
"AADHARSHREE PAPER MILLS PRIVATE LIMITED",
"AADHARSHREE PLASTER INDIA PRIVATE LIMITED",
"AADHAV ENERGY TECH PRIVATE LIMITED",
"AADHAV GREEN POWER PRIVATE LIMITED",
"AADHAVAN ENERGY PRIVATE LIMITED",
"AADHAVAN SIDDHASHRAM PRIVATE LIMITED",
"AADHAVAN SPINNERS PRIVATE LIMITED",
"AADHEESH TEXFAB PRIVATE LIMITED",
"AADHESHWAR STAINLESS STEEL PRIVATE LIMITED",
"AADHI CARS PRIVATE LIMITED",
"AADHI ENTERPRISES PRIVATE LIMITED",
"AADHI GRANITES INDIA PRIVATE LIMITED",
"AADHI TECH HVAC SYSTEMS PRIVATE LIMITED",
"AADHIMALAI PAZHANGUDIYINAR PRODUCER COMPANY LIMITED",
"AADHIRA CNC PRODUCT PRIVATE LIMITED",
"AADHITYAA CREDIT SERVICES PRIVATE LIMITED",
"AADHUNIK GRANIMARMO PRIVATE LIMITED",
"AADHUNIK INFRASTRUCTURE DEVELOPMENT PRIVATE LIMITED",
"AADHUNIK MAINTENANCE SERVICES PRIVATE LIMITED",
"AADHUNIK WORKFORCE UTILITY SERVICES PRIVATE LIMITED",
"AADHYA AUTOMART PRIVATE LIMITED",
"AADHYA BREAST CARE CENTER",
"AADHYA CARGO MOVERS PRIVATE LIMITED",
"AADHYA DIDACTICS PRIVATE LIMITED",
"AADHYA EDIBLES PRIVATE LIMITED",
"AADHYA GLOBAL TRADERS",
"AADHYA HR SOLUTIONS PRIVATE LIMITED",
"AADHYA TRADELINKS PRIVATE LIMITED",
"AADHYAA SEEDS PRIVATE LIMITED",
"AADI 925 SILVER PRIVATE LIMITED",
"AADI AGRO VENTURES PRIVATE LIMITED",
"AADI CEMENTS PRIVATE LIMITED",
"AADI CHEMTRADE PRIVATE LIMITED",
"AADI CREDIT COOPERATIVE SOCIETY LIMITED",
"AADI DIAMONDS AND JEWELLERY PRIVATE LIMITED",
"AADI FLEXIMAT PRIVATE LIMITED",
"AADI IDEOLOGY SERVICES PRIVATE LIMITED",
"AADI INDIA PRIVATE LIMITED",
"AADI INFRACON (INDIA) PRIVATE LIMITED",
"AADI IT SOLUTIONS PRIVATE LIMITED",
"AADI LOCKS PRIVATE LIMITED",
"AADI MATA MARBLES AND ENGINEERS PRIVATE LIMITED",
"AADI MOTORS PRIVATE LIMITED",
"AADI PIPES PRIVATE LIMITED",
"AADI PLASTICS INDUSTRIES PRIVATE LIMITED",
"AADI POLYEXTRUSION & MOULDING PRIVATE LIMITED",
"AADI POLYMERS PRIVATE LIMITED",
"AADI SATYA TRAVELS PRIVATE LIMITED",
"AADI SHAKTI HEALTHCARE PRIVATE LIMITED",
"AADI SOLVENT RECYCLERS PRIVATE LIMITED",
"AADI TRADEMART PRIVATE LIMITED",
"AADI WEALTH MANAGEMENT PRIVATE LIMITED",
"AADIA INNOVATORS PRIVATE LIMITED",
"AADIANANT INFRABUILT PRIVATE LIMITED",
"AADIDEV INVESTMENT AND FINANCE LIMITED",
"AADIEE SUPERPLAST INDUSTRIES PRIVATE LIMITED",
"AADIFIDELIS SOLUTIONS PRIVATE LIMITED",
"AADIL ASHFAQUE & CO.PRIVATE LIMITED",
"AADIM JATI SEVA SAHAKARI SAMITI",
"AADIM JATI SEVA SAHAKARI SANSTHA MARYADIT",
"AADINATH ADVISORS PRIVATE LIMITED",
"AADINATH BULK PRIVATE LIMITED",
"AADINATH FLEXIPACK PRIVATE LIMITED",
"AADINATH INDIA PRIVATE LIMITED",
"AADINATH INFRA DEVELOPERS PRIVATE LIMITED",
"AADINATH MERCHANDISE PRIVATE LIMITED",
"AADINATH SHARE SERVICES PRIVATE LIMITED",
"AADINATH UVPACK PRIVATE LIMITED",
"AADISACH GLOBAL SERVICES PRIVATE LIMITED",
"AADISAI INDUSTRIES PRIVATE LIMITED",
"AADISAR ENTERPRISES PRIVATE LIMITED",
"AADISH IMPEX PRIVATE LIMITED",
"AADISH VENTURE PRIVATE LIMITED",
"AADISHAKTI METAL RECYCLING PRIVATE LIMITED",
"AADISHAKTI TRANSLINE PRIVATE LIMITED",
"AADISHREE INFRA PRIVATE LIMITED",
"AADISHRI SYNTHETIC PRIVATE LIMITED",
"AADISHU SECURITIES PRIVATE LIMITED",
"AADISHWAR EXCIPIENTS PRIVATE LIMITED",
"AADISHWAR EXIM PRIVATE LIMITED",
"AADISREE MEDICALS PRIVATE LIMITED",
"AADISURYA POWERTECH PRIVATE LIMITED",
"AADISWAN INFO CONSULTANTS PRIVATE LIMITED",
"AADIT AUTO COMPANY PRIVATE LIMITED",
"AADIT CONCRETE PRODUCTS PRIVATE LIMITED",
"AADIT EHS SOLUTIONS PRIVATE LIMITED",
"AADIT INDUSTRIAL SERVICES PRIVATE LIMITED",
"AADIT INFRA",
"AADIT MOTORS PRIVATE LIMITED",
"AADIT SPECIALIZED PROCESS EQUIPMENTS PRIVATE LIMITED",
"AADIT TECHNOLOGIES PRIVATE LIMITED",
"AADITECH INSPECTIONS & SERVICES PRIVATE LIMITED",
"AADITI CREATIVE INDIA PRIVATE LIMITED",
"AADITIYA ASWIN PAPER MILLS PRIVATE LIMITED",
"AADITRI HOUSING PRIVATE LIMITED",
"AADITYA AGROFOOD PRODUCTS LIMITED",
"AADITYA CERAMICS PRIVATE LIMITED",
"AADITYA DYECHEM PRIVATE LIMITED",
"AADITYA ENVIRO INDIA PRIVATE LIMITED",
"AADITYA FINECHEM PRIVATE LIMITED",
"AADITYA FLAMEPROOF PRIVATE LIMITED",
"AADITYA HVAC SOLUTIONS PRIVATE LIMITED",
"AADITYA JUNIOR COLLEGE",
"AADITYA KHANIJ & COAL NAGPUR PRIVATE LIMITED",
"AADITYA KRAFT & PAPERS PRIVATE LIMITED",
"AADITYA LIFE SUPPORT DEVICES PRIVATE LIMITED",
"AADITYA PAPTECH PRIVATE LIMITED",
"AADITYA PEST SPECIALIZERS PRIVATE LIMITED",
"AADITYA POLY PET INDIA PRIVATE LIMITED",
"AADITYA VIDYA VIHAR INTERNATIONAL SCHOOL",
"AADIVIGHNESH CHEM PRIVATE LIMITED",
"AADIYA CONTRACTS PRIVATE LIMITED",
"AADL REGISTRAR HIGH COURT M P INDORE BENCH",
"AADOM INFRASTRUCTURE PRIVATE LIMITED",
"AADRA INTEGRATED SUPPORT SERVICES PRIVATE LIMITED",
"AADRIK DISTRIBUTORS PRIVATE LIMITED",
"AADRIKA GLOBAL INFO SOLUTIONS PRIVATE LIMITED",
"AADRIKA INFORMATION SERVICES PRIVATE LIMITED",
"AADRILA TECHNOLOGIES PRIVATE LIMITED",
"AADROIT INDULGENCE PRIVATE LIMITED",
"AADSHRI BUSINESS & CONSULTING PRIVATE LIMITED",
"AADVIK HOSPITAL PRIVATE LIMITED",
"AADWIK INFRABUILD PRIVATE LIMITED",
"AADWIK JEWELLERS PRIVATE LIMITED",
"AADWIN REFRIGERATION INDIA PRIVATE LIMITED",
"AADYA CHEMICALS AND WIRES PRIVATE LIMITED",
"AADYA GLOBAL HEALTHCARE PRIVATE LIMITED",
"AADYA GRAPHICS LIMITED",
"AADYA HOSPITAL SPECIALITY SURGICAL CENTRE",
"AADYA INFORMATICS PRIVATE LIMITED",
"AADYA OVERSEAS PRIVATE LIMITED",
"AADYA URJA SOLUTIONS PRIVATE LIMITED",
"AADYAA ORIGINALS PRIVATE LIMITED",
"AADYAARUSH POWER PROJECTS PRIVATE LIMITED",
"AADYAH AEROSPACE PRIVATE LIMITED",
"AADYAM AUTOMOBILES PRIVATE LIMITED",
"AADYS COMPONENTS PRIVATE LIMITED",
"AAEMVEE GRANITES PRIVATE LIMITED",
"AAF ENTERPRISES PRIVATE LIMITED",
"AAF INDIA PRIVATE LIMITED",
"AAFCO REAL ESTATES INDIA PRIVATE LIMITED",
"AAFT PRIVATE LIMITED",
"AAG CENTRE FOR AVIATION TRAINING PRIVATE LIMITED",
"AAG INDIA PRIVATE LIMITED",
"AAGAAM MARKETING PRIVATE LIMITED",
"AAGAAZ WORLDTRADE PRIVATE LIMITED",
"AAGAM AGENCIES PRIVATE LIMITED",
"AAGAM APPARELS PRIVATE LIMITED",
"AAGAM COMMERCIAL PRIVATE LIMITED",
"AAGAM CONTROL TECHNOLOGIES PRIVATE LIMITED",
"AAGAM HOLDINGS PRIVATE LIMITED",
"AAGAM INTERNATIONAL PRIVATE LIMITED",
"AAGAM LIFE SCIENCES PRIVATE LIMITED",
"AAGAM READYMIX PRIVATE LIMITED",
"AAGAM SILK MILLS PRIVATE LIMITED",
"AAGAM WORLD WIDE INDUSTRIES PRIVATE LIMITED",
"AAGAM WORLDWIDE INDUSTRIES LIMITED",
"AAGHNYA TRADEXIM PRIVATE LIMITED",
"AAGMAN FLEXIPRINTS PRIVATE LIMITED",
"AAGMAN INDIA TRAVEL & LIVING PRIVATE LIMITED",
"AAGNA GLOBAL SOLUTION PRIVATE LIMTED",
"AAGNEYA HEAT TECHNOLOGIES PRIVATE LIMITED",
"AAGNI ROADWAYS PRIVATE LIMITED",
"AAGYA BIOTECH PRIVATE LIMITED",
"AAGYA ENTERPRISES PRIVATE LIMITED",
"AAHA NOLAMBUR BIRYANI",
"AAHAA STORES PRIVATE LIMITED",
"AAHAAN POLYCARE PRIVATE LIMITED",
"AAHAMNE HOSPITALITY PRIVATE LIMITED",
"AAHAN AQUA PRIVATE LIMITED",
"AAHAN COMMUNICATION PRIVATE LIMITED",
"AAHAN ENGINEERS PRIVATE LIMITED",
"AAHANA COMMERCE PRIVATE LIMITED",
"AAHANA SALES PRIVATE LIMITED",
"AAHANS GIFT AND TOY SHOP",
"AAHARI CORPORATE SERVICES PRIVATE LIMITED",
"AAHIL PRODUCTS COMPANY PRIVATE LIMITED",
"AAHIL SCRAP CORPORATION PRIVATE LIMITED",
"AAHIL SHIPPING & LOGISTICS PRIVATE LIMITED",
"AAHLAAD SOFTWARE PRIVATE LIMITED",
"AAHLADA SECURITIES PRIVATE LIMITED",
"AAHNA FOODLIFE PRIVATE LIMITED",
"AAHNA SYSTECH PRIVATE LIMITED",
"AAHVISHKAAR TRAINING SERVICES PRIVATE LIMITED",
"AAI CARGO LOGISTICS & ALLIED SERVICES COMPANY LIMITED",
"AAI SHARDA LOGISTICS PRIVATE LIMITED",
"AAI SPEECH AND HEARING INDIA PRIVATE LIMITED",
"AAIC TECHNOLOGIES PRIVATE LIMITED",
"AAIDEA SOLUTIONS LIMITED",
"AAIDEA SOLUTIONS PRIVATE LIMITED",
"AAIHMS SUPERSPECIALITY HOSPITAL",
"AAIIRA MARBLES PRIVATE LIMITED",
"AAIJI POLYPACK PRIVATE LIMITED",
"AAIMS PROTECTION SERVICES PRIVATE LIMITED",
"AAIMZ ENTERPRISES PRIVATE LIMITED",
"AAIRA IMPEX PRIVATE LIMITED",
"AAISHA CREATIONS PRIVATE LIMITED",
"AAISHVARIYA CHEMICALS PRIVATE LIMITED",
"AAISWARYA DYEING MILLS PRIVATE LIMITED",
"AAITCS PRIVATE LIMITED",
"AAITHER INFRASTRUCTURE PRIVATE LIMITED",
"AAJ BUILDCON PRIVATE LIMITED",
"AAJ ENTERPRISES PRIVATE LIMITED",
"AAJ REALTECH PRIVATE LIMITED",
"AAJ TECH PRIVATE LIMITED",
"AAJI CARE HOME HEALTH SERVICES PRIVATE LIMITED",
"AAJKAAL PUBLISHERS PRIVATE. LIMITED",
"AAJVETO MANUFACTURING PRIVATE LIMITED",
"AAK INDIA PRIVATE LIMITED",
"AAK INFRACON PRIVATE LIMITED",
"AAK MARKETING SERVICES PRIVATE LIMITED",
"AAK SOUTH EAST INDIA PRIVATE LIMITED",
"AAKAAR BUILDING SOLUTIONS PRIVATE LIMITED",
"AAKAAR IRON CREATIONS PRIVATE LIMITED",
"AAKAAR MARBLE'S AND MINERALS PRIVATE LIMITED",
"AAKAAR MEDICAL TECHNOLOGIES PRIVATE LIMITED",
"AAKAASH MANUFACTURING COMPANY PRIVATE LIMITED",
"AAKAF STEEL PRIVATE LIMITED",
"AAKALPA PACKAGING INDUSTRIES PRIVATE LIMITED",
"AAKANKSH IVF CENTRE PRIVATE LIMITED",
"AAKANKSHA DISTRIBUTORS PRIVATE LIMITED",
"AAKANKSHA LOGISTICS PRIVATE LIMITED",
"AAKANKSHA SILK MILLS PRIVATE LIMITED",
"AAKANKSHA WASTE MANAGEMENT PRIVATE LIMITED",
"AAKANSHA CABLES INDIA PRIVATE LIMITED",
"AAKANSHA ELEMENT INDUSTRIES PRIVATE LIMITED",
"AAKANSHA FOOD PRODUCT",
"AAKAR ABHINAV CONSULTANTS PRIVATE LIMITED",
"AAKAR AKSHAR PRESS PRIVATE LIMITED",
"AAKAR CARBONS (INDIA) PRIVATE LIMITED",
"AAKAR CONSTRUCTIONS",
"AA-KAR CONSTRUCTIONS PRIVATE LIMITED",
"AAKAR DESIGN CONSULTANTS PRIVATE LIMITED",
"AAKAR DIAMOND 1",
"AAKAR EXHIBITION PRIVATE LIMITED",
"AAKAR FOUNDRY PRIVATE LIMITED",
"AAKAR FRAGRANCE LIMITED",
"AAKAR INFRA-ENGINEERS PRIVATE LIMITED",
"AAKAR INNOVATIONS PRIVATE LIMITED",
"AAKAR INTIMATES PRIVATE LIMITED",
"AAKAR INVESTMENT PRIVATE LIMITED",
"AAKAR LASERTECH PRIVATE LIMITED",
"AAKAR MACHINES PRIVATE LIMITED",
"AAKAR PIPING SOLUTIONS PRIVATE LIMITED",
"AAKAR POWER SYSTEMS PRIVATE LIMITED",
"AAKAR RASAYAN PRIVATE LIMITED",
"AAKAR SCIENTIFIC PRIVATE LIMITED",
"AAKARSH AIR & SEA FREIGHT FORWARDERS PRIVATE LIMITED",
"AAKARSH INDUSTRIES PRIVATE LIMITED",
"AAKARSHAN BOUTIQUE PRIVATE LIMITED",
"AAKARSHAN ESTATES PRIVATE LIMITED",
"AAKARSHAN HOUSING PRIVATE LIMITED",
"AAKARSHIT ICE AND COLD STORAGE PRIVATE LIMITED",
"AAKAS SKYTR PRIVATE LIMITED",
"AAKASH (INDIA) PROJECTS AND BUILDERS PRIVATE LIMITED",
"AAKASH AGRO FARMERS PRODUCER COMPANY LIMITED",
"AAKASH AGROTECH PRIVATE. LIMITED.",
"AAKASH AUTO PRIVATE. LIMITED.",
"AAKASH AUTOMOBILES PRIVATE. LIMITED.",
"AAKASH BUILDWELL PRIVATE LIMITED",
"AAKASH CABLES PRIVATE LIMITED",
"AAKASH CATERERS PRIVATE LIMITED",
"AAKASH CROPSCIENCE PRIVATE LIMITED",
"AAKASH EXPLORATION SERVICES LIMITED",
"AAKASH EXPLORATION SERVICES PRIVATE. LIMITED",
"AAKASH EYE CARE PRIVATE LIMITED",
"AAKASH FOOD PRODUCTS PRIVATE LIMITED",
"AAKASH GANGA YATRA PRIVATE LIMITED",
"AAKASH GASES PRIVATE LIMITED",
"AAKASH GINNING INDUSTRIES PRIVATE LIMITED",
"AAKASH GLOBAL FOODS PRIVATE LIMITED",
"AAKASH HEALTHCARE PRIVATE LIMITED",
"AAKASH HOSPITAL & EVES CLINIC & ENDROSCOPY CENTRE PRIVATE L",
"AAKASH INTERNATIONAL SCHOOL",
"AAKASH JEWELS PRIVATE LIMITED",
"AAKASH MOTORS PRIVATE LIMITED",
"AAKASH OIL FIELD SERVICES PRIVATE LIMITED",
"AAKASH PACKAGING",
"AAKASH PHARMA PRIVATE LIMITED",
"AAKASH PLASTOPACK PRIVATE LIMITED",
"AAKASH POLYESTERS PVT LTD",
"AAKASH POLYFILMS LIMITED",
"AAKASH POLYTECH PRIVATE LIMITED",
"AAKASH POWERTECH PRIVATE. LIMITED",
"AAKASH PRESS PARTS PRIVATE LIMITED",
"AAKASH PROMOTORS DEVELOPER PRIVATE LIMITED",
"AAKASH RESTAURANT AND FOODS PRIVATE LIMITED",
"AAKASH UNIVERSAL LIMITED",
"AAKASH VALUE REALTY PRIVATE LIMITED",
"AAKASH VISHAL MOTORS PRIVATE LIMITED",
"AAKASH WHEELS PRIVATE LIMITED",
"AAKAVI SPINNING MILLS PRIVATE LIMITED",
"AAKHYA MEDIA SERVICES PRIVATE LIMITED",
"AAKIT TECHNOLOGIES PRIVATE LIMITED",
"AAKRAA PRIVATE LIMITED",
"AAKRAN INDUSTRIES PRIVATE LIMITED",
"AAKRATI INFRATECH PRIVATE LIMITED",
"AAKRISING INFRA PRIVATE LIMITED",
"AAKRITI",
"AAKRITI BUILDCON PRIVATE LIMITED",
"AAKRITI BUILDMART PRIVATE LIMITED",
"AAKRITI CONSTRUCTIONS AND DEVELOPERS PRIVATE LIMITED",
"AAKRITI CRAFTS PRIVATE LIMITED",
"AAKRITI FURNISHERS PRIVATE LIMITED",
"AAKRITI INFOTRONIX PRIVATE LIMITED",
"AAKRITI MANUFACTURING PRIVATE LIMITED",
"AAKRITI PRIME PRODUCTS PRIVATE LIMITED",
"AAKRITI SUPER SNACKS PRIVATE LIMITED",
"AAKRITI TRADECOM PRIVATE LIMITED",
"AAKRUTHI MEDIA & COMMUNICATIONS INDIA PRIVATE LIMITED",
"AAKRUTI BOARDLAM PRIVATE LIMITED",
"AAKRUTI CREATIVE SOLUTIONS PRIVATE LIMITED",
"AAKRUTI DIGIPRESS PRIVATE LIMITED",
"AAKRUTI HOSPITALITY PRIVATE LIMITED",
"AAKRUTI IMAGING PRIVATE LIMITED",
"AAKRUTI MULTIPACK PRIVATE LIMITED",
"AAKRUTI PROCESS TECHNOLOGIES PRIVATE LIMITED",
"AAKRUTI TECHINFRA PRIVATE LIMITED",
"AAKRUTI TENSO STRUCTURES & FACADES PRIVATE LIMITED",
"AAKRUTS COMMOTRADE PRIVATE LIMITED",
"AAKS TECHNO SYSTEMS PRIVATE LIMITED",
"AAKSH BEVERAGES PRIVATE LIMITED",
"AAKSHAY AUTOMOTIVE PRIVATE LIMITED",
"AAKSHEE ELEC SOLUTION PRIVATE LIMITED",
"AALACOM TECHNOLOGIES PRIVATE LIMITED",
"AALAM GOLD AND DIAMONDS PRIVATE LIMITED",
"AALAM INFO SOLUTIONS LLP",
"AALANNA PLASTICS INDIA PRIVATE LIMITED",
"AALANNA POLYWELL INDIA PRIVATE LIMITED",
"AALANNA PROJECTS PRIVATE LIMITED",
"AALAY SURGICALS PRIVATE LIMITED",
"AALAYA ENGINEERING PROJECT PRIVATE LIMITED",
"AALAYAA MILLS PRIVATE LIMITED",
"AALAYAM ENTERPRISES PRIVATE LIMITED",
"AALAYAM FOUNDATION PRIVATE LIMITED",
"AALAYAM REALTY PRIVATE LIMITED",
"AALAYAM WIND FARMS PRIVATE LIMITED",
"AALAYAMS AUTOTECK PRIVATE LIMITED",
"AALEE INDIA EXPORTS PRIVATE LIMITED",
"AALEKHA SUPPLY PVT. LTD.",
"AALEKHYA INFOTAINMENT PRIVATE LIMITED",
"AALFA ENETWORK PRIVATE LIMITED",
"AALFA TANGO MANAGEMENT SERVICES PRIVATE LIMITED",
"AALGRO FOODS PRIVATE LIMITED",
"AALIAADO MAC-B PRIVATE LIMITED",
"AALIDHRA INDUSTRIES PRIVATE LIMITED",
"AALIDHRA PHARMACHEM PRIVATE LIMITED",
"AALIDHRA TEXFAB PRIVATE LIMITED",
"AALIDHRA TEXPRO ENGINEERS PRIVATE LIMITED",
"AALIDHRA TEXTOOL ENGINEERS PRIVATE LIMITED",
"AALIM MUHAMMED SALEGH ACADEMY OF ARCHITECTURE",
"AALINO INDIA PRIVATE LIMITED",
"AALISHAAN STRUCTURE AND INTERIORS PRIVATE LIMITED",
"AALISHAN FIBRES PVT. LTD",
"AALIYAH INFRAHEIGHTS PRIVATE LIMITED",
"AALL MART LIMITED",
"AALLIA HOSPITALITY PRIVATE LIMITED",
"AALOK GROUP PRIVATE LIMITED",
"AALOK INFRASTRUCTURE PRIVATE LIMITED",
"AALOK SOLARFARMS LIMITED",
"AALPHA SYSTEMS AND ENGINEERING PRIVATE LIMITED",
"AALTOP HEALTHCARE PRIVATE LIMITED",
"AAM AAN KAY GASES PRIVATE LIMITED",
"AAM AUTO COMPONENT (INDIA) PRIVATE LIMITED",
"AAM AUTOMOTIVES PRIVATE LIMITED",
"AAM FORGE PRIVATE LIMITED",
"AAM FOUNDATION",
"AAM GEO SPATIAL TECH PRIVATE LIMITED",
"AAM INDIA MANUFACTURING CORPORATION PRIVATE LIMITED",
"AAM VICTUALS PRIVATE LIMITED",
"AAMARA CAPITAL PRIVATE LIMITED",
"AAMBAJI TECH ENTERPRISE PRIVATE LIMITED",
"AAMBIS FOOD PRODUCTS PRIVATE LIMITED",
"AAMBY VALLEY LIMITED",
"AAMDHARA FOODS AGRO EXPORT PRIVATE LIMITED",
"AAMENA SARVAJANIK HOSPITAL",
"AAMENA SARVAJANIK HOSPITAL MANAGED BY HASHIMI PUBL",
"AAMERA INFRA-LINE PRIVATE LIMITED",
"AAMIR BEADING AND EMBROIDERIES PRIVATE LIMITED",
"AAMIR ZARIWALA PRIVATE LIMITED",
"AAMIRAV INGREDIENTS AND SPECIALTIES PRIVATE LIMITED",
"AAMKU LIFESTYLE PRIVATE LIMITED",
"AAMLINN WORLDWIDE PRIVATE LIMITED",
"AAMOD FINSERV PRIVATE LIMITED",
"AAMODA BROADCASTING COMPANY PRIVATE LIMITED",
"AAMODA PUBLICATIONS PRIVATE LIMITED",
"AAMOKSH LEISURE LIVING PRIVATE LIMITED",
"AAMOKSH ONE EIGHTY HOSPITALITY PRIVATE LIMITED",
"AAMOLIK CONSULTANCY SERVICES PRIVATE LIMITED",
"AAMOR INOX LIMITED",
"AAMORB PHARMACEUTICALS PRIVATE LIMITED",
"AAMRAKUNJ REALTY LIMITED",
"AAMRAPALI REAL ESTATE PRIVATE LIMITED",
"AAMRO FREIGHT SERVICES PRIVATE LIMITED",
"AAN CLOTHING LLP",
"AAN ENGINEERING INDUSTRIES LIMITED",
"AAN FINVEST PRIVATE LIMITED",
"AAN LIFESCIENCE PRIVATE LIMITED",
"AAN LOGISTICS PRIVATE LIMITED",
"AAN MOTORS PRIVATE LIMITED",
"AAN OVERSEAS PRIVATE LIMITED",
"AANANDA AGRO PROCESSORS PRIVATE LIMITED",
"AANANDA LAKSHMI SPINNING MILLS LIMITED",
"AANANDAM ORNAMENTS PRIVATE. LIMITED.",
"AANANDDARSHAN INFRASTRUCTURE PRIVATE LIMITED",
"AANANDHAM LABELS PRIVATE LIMITED",
"AANANDINII RESORTS & VILLAS PRIVATE LIMITED",
"AANANDLOK REMEDIAL RESEARCH CENTRE PRIVATE LIMITED",
"AANCH HOSPITAL",
"AANCHAL APPARELS PRIVATE LIMITED",
"AANCHAL COLLECTION LIMITED",
"AANCHAL COMPUTERS LIMITED",
"AANCHAL CREATIONS",
"AANCHAL FABTEX INDIA PRIVATE LIMITED",
"AANCHAL HOTELS PRIVATE LIMITED",
"AANCHAL JEWELLERS EXPORT PVT LTD",
"AANEE FACILITIES SERVICES PRIVATE LIMITED",
"AANEEKAFOODS INTERNATIONAL PRIVATE LIMITED",
"AANEEL TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"AANGAN AGROTECH EXPORTS LIMITED",
"AANGEE COLOURANT PRIVATE LIMITED",
"AANGGAN HOSPITALITY PRIVATE LIMITED",
"AANGI ADVANCED COMPOSITE PRIVATE LIMITED",
"AANJANA INDUSTRIES PRIVATE LIMITED",
"AANJANA METAL CONCEPTS PRIVATE LIMITED",
"AANJANEY CHEM ORGANICS PRIVATE LIMITED",
"AANJANEY RAIL PRIVATE LIMITED",
"AANJANEYA BUSINESS INDIA PRIVATE LIMITED",
"AANJANEYA IMPEX PRIVATE LIMITED",
"AANJNEY RESEARCH & MEDICARE PRIVATE LIMITED",
"AANOOR BAGLEY COIR PRIVATE LIMITED",
"AANOOR GLOBAL CORPORATE SOLUTIONS PRIVATE LIMITED",
"AANOOR TEXTILES PRIVATE LIMITED",
"AANP BEAUTY SOLUTIONS PRIVATE LIMITED",
"AANSH CONSTRUCTION PRIVATE LIMITED",
"AANSH IVF HOSPITAL PRIVATE LIMITED",
"AANSHI INDUSTRIES PRIVATE LIMITED",
"AANSHI WEAVES PRIVATE LIMITED",
"AANSTAR TECHNOLOGIES PRIVATE LIMITED",
"AANTARBHARTI HOMEOPATHY COLLEGE",
"AANTHRA HOME SOLUTIONS PRIVATE LIMITED",
"AANUJ INFRAPROJECTS PRIVATE LIMITED",
"AANVI POLYLABS PRIVATE LIMITED",
"AANVI REALTORS PRIVATE LIMITED",
"AANVI SAFETY PRIVATE LIMITED",
"AANVII HEARING SOLUTIONS PRIVATE LIMITED",
"AANYA AGROTECH PRIVATE LIMITED",
"AANYA AND ARYA INFRACON PRIVATE LIMITED",
"AANYA BUILDTECH PRIVATE LIMITED",
"AANYA HEAVY FORGE PRIVATE LIMITED",
"AANYA RESORT AND SPA PRIVATE LIMITED",
"AANYARAYAN CONSTRUCTIONS PRIVATE LIMITED",
"AANYATEK PRIVATE LIMITED",
"AAO MARKETING PRIVATE LIMITED",
"AAONE DEVELOPERS PRIVATE LIMITED",
"AAP EXIM PRIVATE LIMITED",
"AAP GLOBAL CAPABILITY CENTER LLP",
"AAP INDUSTRIES PRIVATE LIMITED",
"AAP INFOSYSTEMS PRIVATE LIMITED",
"AAP INFRATECH PRIVATE LIMITED",
"AAP KA FAISLA PRAKASHAN PRIVATE LIMITED",
"AAP MEDIA PRIVATE LIMITED",
"AAP PEDIATRICS HEALTH CARE PRIVATE LIMITED",
"AAP PHARMA TECHNOLOGIES INDIA PRIVATE LIMITED",
"AAP REALTORS LIMITED",
"AAPAAVANI ENVIRONMENTAL SOLUTIONS PRIVATE LIMITED",
"AAPARTH ENGINEERS PRIVATE LIMITED",
"AAPC INDIA HOTEL MANAGEMENT PRIVATE LIMITED",
"AAPC INDIA LLP",
"AAPC INDIA PRIVATE LIMITED",
"AAPEX POWER AND INDUSTRIES PRIVATE LIMITED",
"AAPKA TRAVELS PRIVATE LIMITED",
"AAPKAPAINTER SOLUTIONS PRIVATE LIMITED",
"AAPKI DESIGN PRIVATE LIMITED",
"AAPL SOLUTIONS PRIVATE LIMITED",
"AAPNA INFOTHEEK PRIVATE LIMITED",
"AAPNI PEDIATRICS HEALTH CARE PRIVATE LIMITED",
"AAPO STEEL PIPE PRIVATE LIMITED",
"AAPOON DIGITAL PRIVATE LIMITED",
"AAPOORTI SHOPPING MALL LIMITED",
"AAPSOJ PHARMA PRIVATE LIMITED",
"AAPT DISTRIBUTION PRIVATE LIMITED",
"AAPT FACILITY MANAGEMENT PRIVATE LIMITED",
"AAPT OUTSOURCING SOLUTIONS PRIVATE LIMITED",
"AAPTTEKNOUS LLP",
"AAPURANI FOOD PRODUCTS PRIVATE LIMITED",
"AAPURTI E-MART INDIA PRIVATE LIMITED",
"AAPURTI FINANCE PRIVATE LIMITED",
"AAQUARIES GLOBAL INDUSTRIES LIMITED",
"AAR AAR TECHNOPLAST PRIVATE LIMITED",
"AAR AAY GALAXY ENTERPRISES PRIVATE LIMITED",
"AAR AUTOCORP PRIVATE LIMITED",
"AAR BEE CONTAINERS PRIVATE LIMITED",
"AAR BEE FREIGHT FORWARDERS PRIVATE LIMITED",
"AAR BEE ROLLER FLOUR MILLS PRIVATE LIMITED",
"AAR CEE AUTO COMPONENTS PRIVATE LIMITED",
"AAR CEE CONTRACTS PRIVATE LIMITED",
"AAR CONSULTING & SERVICES PRIVATE LIMITED",
"AAR DEE EXTRUSIONS INDIA PRIVATE LIMITED",
"AAR DEE INDIA PRIVATE LIMITED",
"AAR DEE INDUSTRIES PRIVATE LIMITED",
"AAR DEE SOLUTIONS PRIVATE LIMITED",
"AAR ESS EXIM PRIVATE LIMITED",
"AAR ESS MANUFACTURING PRIVATE LIMITED",
"AAR ESS REMEDIES PRIVATE LIMITED",
"AAR GEE CREATION PRIVATE LIMITED",
"AAR GEE PEE TEXTILES SIZING PRIVATE LIMITED",
"AAR K VASUDHA CONSTRUCTION PRIVATE LIMITED",
"AAR KAY DEEPAK STEELS PRIVATE LIMITED",
"AAR KAY FIN-LEASE PVT LTD",
"AAR KAY FORGE PVT. LTD.",
"AAR KAY INTERNATIONAL EXPRESS DELIVERY PRIVATE LIMITED",
"AAR KAY METALLOYS INDIA PRIVATE LIMITED",
"AAR MARKETING AND SERVICES PRIVATE LIMITED",
"AAR PAR GLASSES PRIVATE LIMITED",
"AAR PEE LIFE CARE PRIVATE LIMITED",
"AAR PEE RETAIL INDIA PRIVATE LIMITED",
"AAR ROYAL RESIDENCY PRIVATE LIMITED",
"AAR VEE DENIMS AND EXPORTS LIMITED.",
"AAR VEE ENTERPRISES",
"AARA BUSINESS PRIVATE LIMITED",
"AARA ENERGY INNOVATIONS PRIVATE LIMITED",
"AARA TECH PRIVATE LIMITED",
"AARADHANA ENERGY PRIVATE LIMITED",
"AARADHANA MACHINERIES PRIVATE LIMITED",
"AARADHANA MARKETING PRIVATE LIMITED",
"AARADHANA PLASTICS PRIVATE LIMITED",
"AARADHYA AUTO PRIVATE LIMITED",
"AARADHYA ELECTRONICS PRIVATE LIMITED",
"AARADHYA FOUNDATION",
"AARADHYA FRUITS FARMER PRODUCER COMPANY LIMITED",
"AARADHYA FRUITS PROCESSING PRIVATE LIMITED",
"AARADHYA PACKAGING PRIVATE LIMITED",
"AARADHYA PLYWOOD PRIVATE LIMITED",
"AARAM PLASTICS PRIVATE LIMITED",
"AARAM SHOP PRIVATE LIMITED",
"AARAMBB UNIVERSAL MARKETING PRIVATE LIMITED",
"AARAMBH AD-EVENTS PRIVATE LIMITED",
"AARAMBH INFRADEVELOPERS PRIVATE LIMITED",
"AARAMBH PUBLIC SCHOOL",
"AARAN 1 ENGINEERING PRIVATE LIMITED",
"AARANA GLOBAL IMPEX PRIVATE LIMITED",
"AARANI ENTERPRISES PRIVATE LIMITED",
"AARAQ INFRA CONSTRUCTORS AND ENGINEERS PRIVATE LIMITED",
"AARATRIKA APPARELS PRIVATE LIMITED",
"AARAV CASINGS PRIVATE LIMITED",
"AARAV CONSTRUCTION PRIVATE LIMITED",
"AARAV CONTRACTS LIMITED",
"AARAV FOREX PRIVATE LIMITED",
"AARAV FRAGRANCES AND FLAVORS PRIVATE LIMITED\n",
"AARAV GLOBAL PRODUCTS AND SERVICES PRIVATE LIMITED",
"AARAV INFO SOLUTIONS PRIVATE LIMITED¬†",
"AARAV INFOTECH INDIA PRIVATE LIMITED",
"AARAV ITES PRIVATE LIMITED",
"AARAV JEWELLERS PRIVATE LIMITED",
"AARAV MANAGEMENT ADVISORS LLP",
"AARAV PACKAGING PRIVATE LIMITED",
"AARAV PROTECTION PRIVATE LIMITED",
"AARAV REALITY PRIVATE LIMITED",
"AARAV SALT & CHEMICALS PRIVATE LIMITED",
"AARAV SOLUTIONS PRIVATE LIMITED",
"AARAVI DEVELOPERS PRIVATE LIMITED",
"AARAVSHARMA HOSIERY PRIVATE LIMITED",
"AARAVYA SPINNING MILLS PRIVATE LIMITED",
"AARAYAA ADVISORY SERVICES PRIVATE LIMITED",
"AARBE COSMETICS PRIVATE LIMITED",
"AARBEE STRUCTURES PRIVATE LIMITED",
"AARBRO AGENCIES PRIVATE LIMITED",
"AARCADE LAUNDRY CONCEPTS PRIVATE LIMITED",
"AARCCHOR INNOVATIONS PRIVATE LIMITED",
"AARCEE BUILDERS PVT LTD",
"AARCEE MITTAL ELECTRICALS PRIVATE LIMITED",
"AARCH FASHIONS PRIVATE LIMITED",
"AARCMARINE ENGINEERING AND SHIP SUPPLY PRIVATE LIMITED",
"AARCO ENGINEERING PROJECTS PRIVATE LIMITED",
"AARCO INDUSTRIES PRIVATE LIMITED",
"AARCON NIRMAN PRIVATE LIMITED",
"AARCOT CERAMIC PRIVATE LIMITED",
"AARDE TECHNOSOFT PRIVATE LIMITED",
"AARDENCO INFOTECH PRIVATE LIMITED",
"AARDING(INDIA)PRIVATE LIMITED",
"AARDOUR WORLDWIDE LOGISTICS PRIVATE LIMITED",
"AAREDHILLS INFRA PROJECT PRIVATE LIMITED",
"AAREEN HEALTHCARE PRIVATE LIMITED",
"AAREHA ELASTIN FIBC PRIVATE LIMITED",
"AAREL IMPORT EXPORT PRIVATE LIMITED",
"AAR-EM ELECTRONICS PRIVATE LIMITED",
"AAREM TRADEX PRIVATE LIMITED",
"AAREN BESPOKE LIVING PRIVATE LIMITED",
"AAREN STONES AND GRANITES PRIVATE LIMITED",
"AARENZA DIE CAST PRIVATE LIMITED",
"AARES TELECOM PRIVATE LIMITED",
"AARESS AUTO PVT LTD",
"AAR-ESS CONCEPTS PRIVATE LIMITED",
"AARETE TECHNOSOFT PRIVATE LIMITED",
"AAREY ORGANIC INDUSTRIES PVT.LTD.",
"AARG TECHNOLOGIES PRIVATE LIMITED",
"AARGEE EQUIPMENTS PRIVATE LIMITED",
"AARGEE PIPELINE SERVICES PRIVATE LIMITED",
"AARGEE PROJECTS PRIVATE LIMITED",
"AARGEE STAFFING SERVICES PRIVATE LIMITED",
"AARGUS GLOBAL LOGISTICS PRIVATE LIMITED",
"AARGUS INFOTEC PRIVATE LIMITED",
"AARHAM ENGINEERS PRIVATE LIMITED",
"AARHAT TRADE-COM PRIVATE LIMITED",
"AARI CASA INDIA PRIVATE LIMITED",
"AARI TARI FASHIONS PRIVATE LIMITED",
"AARIA BIO - LIFESCIENCES RESEARCH PRIVATE LIMITED",
"AARIA PROJECTS LIMITED",
"AARIALIFE TECHNOLOGIES PRIVATE LIMITED",
"AARIKA CHROMA INDUSTRIES PRIVATE LIMITED",
"AARIKET BPS ENTERPRISES PRIVATE LIMITED",
"AARIN HOSPITALITY PRIVATE LIMITED",
"AARINSTAR ENTERPRISE PRIVATE LIMITED",
"AARISH PACCOR LIMITED",
"AARISH SOLAR POWER PRIVATE LIMITED",
"AARISTO ELASTIC PRIVATE LIMITED",
"AARIVA PHARMA PRIVATE LIMITED",
"AARIYA CARS PRIVATE LIMITED",
"AARIZ CONSTRUCTION PRIVATE LIMITED",
"AARIZE REALTECH LLP",
"AARJA BUILDCON PRIVATE LIMITED",
"AARJAVAM POLYMER PRIVATE LIMITED",
"AARJAVAM TECHFAB PRIVATE LIMITED",
"AARJAY INTERNATIONAL PRIVATE LIMITED",
"AARJUN AGRO FOODS PRIVATE LIMITED",
"AARK INFOSOFT PRIVATE LIMITED",
"AARK PHARMACEUTICALS",
"AARK QUALITY FOODS PRIVATE LIMITED",
"AARK SPICE AND INGREDIENTS PRIVATE LIMITED",
"AARK WORLD PRIVATE LIMITED",
"AARKA MEDICARE PRIVATE LIMITED",
"AARKA SPORTS MANAGEMENT PRIVATE LIMITED",
"AARKAY ERECTORS PRIVATE LIMITED",
"AARKAY FOOD PRODUCTS LIMITED",
"AARKAY INNOVATIONS LIMITED",
"AARKAY INSTRUMENTS PRIVATE LIMITED",
"AARKAY INVESTMENTS PVT. LTD.",
"AARKAY KAMAL JEWELLERS PRIVATE LIMITED",
"AARKAY PAINTS PVT LTD",
"AARKAYS AIR EQUIPMENT PRIVATE LIMITED",
"AARKEN ADVISORS PRIVATE LIMITED",
"AARKEY RETAIL PRIVATE LIMITED",
"AARKFAB ENGINEERS PRIVATE LIMITED",
"AARKHA AGROS PVT LTD,",
"AARMATION ELECTRIC PRIVATE LIMITED",
"AARMED FORMULATIONS PRIVATE LIMITED",
"AARMONIA CHEMICALS PRIVATE LIMITED",
"AARMS VALUE CHAIN PRIVATE LIMITED",
"AARN LOGISTICS PRIVATE LIMITED",
"AARNA AUTOMOBILES PRIVATE LIMITED",
"AARNA CLOTHING PRIVATE LIMITED",
"AARNA COTTON PRIVATE LIMITED",
"AARNA ENTERTAINMENT PRIVATE LIMITED",
"AARNA FOODS PRIVATE LIMITED",
"AARNA INFRATECH INDIA PRIVATE LIMITED",
"AARNA LUBE PRIVATE LIMITED",
"AARNA MEGACORP PRIVATE LIMITED",
"AARNA NETWORKS INDIA PRIVATE LIMITED",
"AARNA PACKAGING PRODUCTS PRIVATE LIMITED",
"AARNA SYSTEMS PRIVATE LIMITED",
"AARNA VENTURES PRIVATE LIMITED",
"AARNAA MEDICARE PRIVATE LIMITED",
"AARNAINTECH SOLUTIONS PRIVATE LIMITED",
"AARNAV FABRICS PRIVATE LIMITED",
"AARNAV FASHIONS LIMITED",
"AARNAV INDUSTRIES PRIVATE LIMITED",
"AARNAV INFRA & TECHNOLOGY PRIVATE LIMITED",
"AARNAV ISPAT PRIVATE LIMITED",
"AARNAV SOFTECH PRIVATE LIMITED",
"AARNEDE CREATIONS PRIVATE LIMITED",
"AARNEEL TECHNOCRAFTS PRIVATE LIMITED",
"AARNESH AIR PRODUCTS PRIVATE LIMITED",
"AARNIKA PRODUCTS PRIVATE LIMITED",
"AARNOVA TECHNOLOGIES PRIVATE LIMITED",
"AARNYA INFRA SERVICES PRIVATE LIMITED",
"AARO FOODS PRIVATE LIMITED",
"AAROCARE SMART HEALTH PRIVATE LIMITED",
"AAROGYA BHARTI JANAI HOSPITAL",
"AAROGYA DAIRY PRODUCTS PRIVATE LIMITED",
"AAROGYA MANDAL SWASTHAYA KENDRA PRIVATE LIMITED",
"AAROGYA MATERNITY AND MULTISPECIALITY HOSPITAL",
"AAROGYA ORTHOPAEDIC & TRAUMA CLINIC PRIVATE LIMITED",
"AAROGYADHAN MEDI HEALTH AND WELLNESS SOLUTIONS PRIVATE LIMITED",
"AAROGYAM LIFESCIENCES PRIVATE LIMITED",
"AAROGYAM MULTISPECIALITY HOSPITAL PRIVATE LIMITED",
"AAROGYAM ORGANICS",
"AAROGYAM SUPERSPECIALITY HOSPITAL & RESEARCH CENTER",
"AAROGYAM THE WELLNESS STORE PRIVATE LIMITED",
"AAROGYAVAT PHARMACY PRIVATE LIMITED",
"AAROH LABS PRIVATE LIMITED",
"AAROHA HEALTHCARE PRIVATE LIMITED",
"AAROHAN BUILDERS PRIVATE LIMITED",
"AAROHAN HOLDINGS AND ADVISORS PRIVATE LIMITED",
"AAROHAN LOGISTICS PRIVATE LIMITED",
"AAROHAN TOURS & TRAVELS PRIVATE LIMITED",
"AAROHI AND RIDHI CONSULTANCY SERVICES PRIVATE LIMITED",
"AAROHI BREEDING FARMS & FOODS PRIVATE LIMITED",
"AAROHI CONSTRUCTIONS PRIVATE LIMITED",
"AAROHI EMBEDDED SYSTEMS PRIVATE LIMITED",
"AAROHI IT SOLUTIONS PRIVATE LIMITED",
"AAROHI MODEL SR SEC SCHOOL",
"AAROHI PACKAGING PRIVATE LIMITED",
"AAROHI PNEUMATICS PRIVATE LIMITED",
"AAROHI POWER ENGINEERING PRIVATE LIMITED",
"AAROHI SOLAR PRIVATE LIMITED",
"AAROHI STARZ CLUB PRIVATE LIMITED",
"AAROHIE NUTRIFOOD PRIVATE LIMITED",
"AAROMBOR DEVELOPER PRIVATE LIMITED",
"AARON BABCON (INDIA) PVT LTD",
"AARON ENC PRIVATE LIMITED",
"AARON ENTERPRISES PRIVATE LIMITED",
"AARON FINE CHEMICALS PRIVATE LIMITED",
"AARON HEALTHCARE AND EXPORT PRIVATE LIMITED",
"AARON HELMETS PRIVATE LIMITED",
"AARON INDUSTRIES LIMITED",
"AARON LOGISTICS PRIVATE LIMITED",
"AARON MERCHENTARY PRIVATE LIMITED",
"AARON SUPPLY CHAIN PRIVATE LIMITED",
"AARON TOURS PRIVATE LIMITED",
"AARONE INFRASTRUCTURE PRIVATE LIMITED",
"AARONIC LOGISTICS PRIVATE LIMITED",
"AARON'S E-COMMERCE WALA PRIVATE LIMITED",
"AAROODH ENGINEERS INDIA PRIVATE LIMITED",
"AAROOHEE HEALTHCARE PRIVATE LIMITED",
"AAROV INFRA PRIVATE LIMITED",
"AARPEE INFRAPROJECTS PRIVATE LIMITED",
"AARPEE PROMOTERS PRIVATE LIMITED",
"AARPIK PHARMACEUTICALS PRIVATE LIMITED",
"AARPIKA ENGINEERING PRIVATE LIMITED",
"AARPM INDUSTRIAL SOLUTION PRIVATE LIMITED",
"AARRAY SPORTS PRIVATE LIMITED",
"AARRYAVEER OIL INDUSTRIES PRIVATE LIMITED",
"AARS COMPUTERS PRIVATE LIMITED",
"AARSAN AMERICAS PRIVATE LIMITED",
"AARSAN TREXIM PRIVATE LIMITED",
"AARSH DIE CASTINGS PRIVATE LIMITED",
"AARSH FINCON LIMITED",
"AARSHA CHEMICALS PRIVATE LIMITED",
"AARSHADHAATU GREEN NANOTECHNOLOGIES INDIA PRIVATE. LIMITED.",
"AARSHI MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"AARSUN WOODS PRIVATE LIMITED",
"AART CORPORATE ADVISORS PRIVATE LIMITED",
"AART INTEGRATED PROJECTS PRIVATE LIMITED",
"AART VENTURES PRIVATE LIMITED",
"AARTAS CARE PRIVATE LIMITED",
"AARTAV ENGINEERING PRIVATE LIMITED",
"AARTECH CONSULTANTS (INDIA) PRIVATE LIMITED",
"AARTEE HORTICULTURAL SERVICES PRIVATE LIMITED",
"AARTEXX EXIMS PRIVATE LIMITED",
"AARTH FACILITATORS PRIVATE LIMITED",
"AARTH SOFTWARE PRIVATE LIMITED",
"AARTH UNIVERSAL SCHOOL",
"AARTHI A1 HOME TRENDS PRIVATE LIMITED",
"AARTHI CONSULTANTS PRIVATE LIMITED",
"AARTHI PETRO CHEMICALS PRIVATE LIMITED",
"AARTHI SANITATION PRIVATE LIMITED",
"AARTHI SCANS PRIVATE LIMITED",
"AARTHI SWITCHGEAR PRIVATE LIMITED",
"AARTHIK HOUSING LIMITED",
"AARTHSIDDHI SERVICES PRIVATE LIMITED",
"AARTI CABLE AND COMPOUNDS PRIVATE LIMITED",
"AARTI CATALYST SOLUTIONS PRIVATE LIMITED",
"AARTI DISTILLERIES PRIVATE LIMITED",
"AARTI DRUGS LIMITED",
"AARTI EXTRACTIONS PRIVATE LIMITED",
"AARTI FAB TEX PRIVATE LIMITED",
"AARTI GREEN TECH LIMITED",
"AARTI HIGHRISE PRIVATE LIMITED",
"AARTI HYDRO POWER PRIVATE LIMITED",
"AARTI INDUSTRIES LTD",
"AARTI INFRASTRUCTURE AND BUILDCON LIMITED",
"AARTI INTERNATIONAL LIMITED",
"AARTI JEWELLERS PRIVATE LIMITED",
"AARTI LIFE SCIENCE LLP",
"AARTI LOGISTIC PRIVATE LIMITED",
"AARTI MEDICALS PRIVATE LIMITED",
"AARTI PHARMALABS LIMITED",
"AARTI POULTRY FEEDS PRIVATE LIMITED",
"AARTI SILVERWARE PRIVATE LIMITED",
"AARTI SPONGE AND POWER LIMITED",
"AARTI STEEL INTERNATIONAL LIMITED",
"AARTI STEELS LIMITED",
"AARTI STRUCTURES PRIVATE LIMITED",
"AARTI SURFACTANTS LIMITED",
"AARTI TRADERS",
"AARTI YARNFAB PRIVATE LIMITED",
"AARTS CREATIVE CONSULTANCY PRIVATE LIMITED",
"AARTVISION METAL COMPONENT & PROCESSING PRIVATE LIMITED",
"AARUDHRA ELECTRICAL ENGINEERS (INDIA) PRIVATE LIMITED",
"AARUDHRA WIND ENERGY PRIVATE LIMITED",
"AARUHI CONSTRUCTION COMPANY PRIVATE LIMITED",
"AARUHI INSTITUTE PRIVATE LIMITED",
"AARUMA TRADEX PRIVATE LIMITED",
"AARUNI HOSPITAL PRIVTAE LIMITED",
"AARUNYA CARE PRIVATE LIMITED",
"AARUPADAI VEEDU INSTITUTE OF TECHNOLOGY",
"AARUPADAI VEEDU MEDICAL COLLEGE & HOSPITAL",
"AARURAA TECHNOLOGIES PRIVATE LIMITED",
"AARUSH (PHASE II) LOGISTICS PARK PRIVATE LIMITED",
"AARUSH (PHASE III) LOGISTICS PARK PRIVATE LIMITED",
"AARUSH (PHASE IV) LOGISTICS PARK PRIVATE LIMITED",
"AARUSH (PHASE V) LOGISTICS PARK PRIVATE LIMITED",
"AARUSH AGRO FOODS PRIVATE LIMITED",
"AARUSH BUILDING MATERIALS PRIVATE LIMITED",
"AARUSH GEMS PRIVATE LIMITED",
"AARUSH GOC PRIVATE LIMITED",
"AARUSH LOGISTICS PARK PRIVATE LIMITED",
"AARUSH MANUFACTURING SOLUTIONS PRIVATE LIMITED",
"AARUSH VINAYAK ENTERPRISES",
"AARUSHA HOMES PRIVATE LIMITED",
"AARUSHI AGRIL PRODUCTS PRIVATE LIMITED",
"AARUSHI CHEMPHARM PRIVATE LIMITED",
"AARUSHI CONSULTING & SERVICES PRIVATE LIMITED",
"AARUSHI ELECTRICALS INDIA PRIVATE LIMITED",
"AARUX PHARMACEUTICALS PRIVATE LIMITED",
"AARV WOOD AND VENEER PRIVATE LIMITED",
"AARVAK UDYOG PRIVATE LIMITED",
"AARVE LIFT PRODUCTS PRIVATE LIMITED",
"AARVEE ASSOCIATES ARCHITECTS ENGINEERS & CONSULTANTS PRIVATE LIMITED",
"AARVEE COLD CHAIN LOGISTICS PRIVATE LIMITED",
"AARVEX INFOTECH PRIVATE LIMITED",
"AARVI ENCON LIMITED",
"AARVI ENCON PRIVATE LIMITED",
"AARVI INSURANCE BROKERS PRIVATE LIMITED",
"AARVI IRON PRIVATE LIMITED",
"AARVI KITCHEN APPLIANCES PRIVATE LIMITED",
"AARVI MARKETING PRIVATE LIMITED",
"AARVI SHINX INDIA PRIVATE LIMITED",
"AARVI TRADELINK",
"AARVIEM DYECHEM INDUSTRIES PVT LTD",
"AARVY REAL ESTATE & BUILDERS PRIVATE LIMITED",
"AARWIN ENGINEERING PROJECTS SERVICES PRIVATE LIMITED",
"AARY VEDIK JUNIOR HIGH SCHOOL KUTAKPUR GOLA",
"AARYA AGENCIES PRIVATE LIMITED",
"AARYA ELECTRODES PRIVATE LIMITED",
"AARYA FASH TEX PRIVATE LIMITED",
"AARYA GRAND HOTELS & RESORTS PRIVATE LIMITED",
"AARYA GREEN FIELDS PRIVATE LIMITED",
"AARYA HARSH FOOD PRODUCTS PRIVATE LIMITED",
"AARYA ITES PRIVATE LIMITED",
"AARYA METALLURGICALS (INDIA) PRIVATE LIMITED",
"AARYA OCEAN LOGISTICS PARK PRIVATE LIMITED",
"AARYA PACKERS INDIA PRIVATE LIMITED",
"AARYA PACKTHREAD PRIVATE LIMITED",
"AARYA POLYMERS INDIA PRIVATE LIMITED",
"AARYA PRECAST INDIA PRIVATE LIMITED",
"AARYA SALES CORPORATION PRIVATE LIMITED",
"AARYA TRANS SOLUTIONS PRIVATE LIMITED",
"AARYA TRENCHLESS SERVICES PRIVATE LIMITED",
"AARYA24KT (INDIA) PRIVATE LIMITED",
"AARYAHAAN INTERNATIONAL PRIVATE LIMITED",
"AARYAMAN GEO INFO SOLUTIONS PRIVATE LIMITED",
"AARYAN DEVCON PRIVATE LIMITED",
"AARYAN ENGINEERING PRIVATE LIMITED",
"AARYAN HITECH STEELS INDIA PRIVATE LIMITED",
"AARYAN INFRA EQUIPMENTS PRIVATE LIMITED",
"AARYAN INFRA-BUILD PRIVATE LIMITED",
"AARYAN KUMAR FABRICS PRIVATE LIMITED",
"AARYAN LAMIFAB PRIVATE LIMITED",
"AARYAN MIRAI PRIVATE LIMITED",
"AARYAN STRUCTCON PRIVATE LIMITED",
"AARYANS WORLD SCHOOL",
"AARYANSH IMPEX PRIVATE LIMITED",
"AARYASHREE MOTORS PRIVATE LIMITED",
"AARYAVART DEVELOPERS PRIVATE LIMITED",
"AARYAVART INFRASTRUCTURE PRIVATE LIMITED",
"AARYAVEER SOLUTIONS PRIVATE LIMITED",
"AARYAVISION PROJECTS PRIVATE LIMITED",
"AARYAVRAT ENGINEERING AND TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"AARYAVRAT INDIA LIMITED",
"AARYAWART COMMUNICATION APPLIANCES PRIVATE LIMITED",
"AAS HEALTHCARE PRIVATE LIMITED",
"AAS MEDICARE PRIVATE LIMITED",
"AAS RESEARCH & SOLUTIONS PRIVATE LIMITED",
"AASAAN GLOBAL TECHNOLOGY PRIVATE LIMITED",
"AASAAN JOBS PRIVATE LIMITED",
"AASAANJOBS PRIVATE LIMITED",
"AASAN DEVELOPERS & CONSTRUCTIONS PRIVATE LIMITED",
"AASAN SOFTWARE PRIVATE LIMITED",
"AASC DEVELOPERS PRIVATE LIMITED",
"AASEYA IT SERVICES PRIVATE LIMITED",
"AASH BIOTECH PRIVATE LIMITED",
"AASH LOGISTICS PRIVATE LIMITED",
"AASHA BUILDCON PRIVATE LIMITED",
"AASHA HOSTELS PRIVATE LIMITED",
"AASHA LEVIN LIGHTING SYSTEMS PRIVATE LIMITED",
"AASHADEEP SHEETALAYA PRIVATE LIMITED",
"AASHAPURA AGRO PRODUCTS PRIVATE LIMITED",
"AASHAPURI ENGINEERING PRIVATE LIMITED",
"AASHAPURNA TEXOPRINT PRIVATE LIMITED",
"AASHARAM SHALA VAGHECHA",
"AASHARYA HOTELS & ESTATES PRIVATE. LIMITED.",
"AASHAY INDUSTRIES PRIVATE LIMITED",
"AASHAY MEASUREMENTS PRIVATE LIMITED",
"AASHAY SYNTEX PRIVATE LIMITED",
"AASHI AUXICHEM PRIVATE LIMITED",
"AASHI ENGINEERING AND CONSTRUCTION PRIVATE LIMITED",
"AASHI HOME PRIVATE LIMITED",
"AASHI HOUSEWARE INDIA PRIVATE LIMITED",
"AASHI PLASTIC PRIVATE LIMITED",
"AASHI SALES PRIVATE LIMITED",
"AASHI TECHNOLOGY INDIA PRIVATE LIMITED",
"AASHI TIE-UP PRIVATE LIMITED",
"AASHI TRANSGLOBAL PRIVATE LIMITED",
"AASHIANA ROLLING MILLS LIMITED",
"AASHIKA INDUSTRIES PRIVATE LIMITED",
"AASHIMA IMPEX PRIVATE LIMITED",
"AASHIRVAD AUTOTECH (GUJ )PRIVATE LIMITED",
"AASHIRVAD MILK AND AGRO FOODS INDUSTRIES PRIVATE LIMITED",
"AASHIRVAD SAREES PRIVATE LIMITED",
"AASHIRWAD BUILDWELL PRIVATE LIMITED",
"AASHIRWAD CROP SCIENCE PRIVATE LIMITED",
"AASHIRWAD FOREX PRIVATE LIMITED",
"AASHIRWAD GLOBAL",
"AASHIRWAD INDUSTRIES PRIVATE LIMITED",
"AASHIRWAD INFRA CARE SERVICES LIMITED",
"AASHIRWAD MEDICAREW AND RESEARCH CENTRE PRIVATE LIMITED",
"AASHIRWAD MEDICOS PRIVATE LIMITED",
"AASHIRWAD POLYPLAST PRIVATE LIMITED",
"AASHIRWAD TAPES INDUSTRIES PRIVATE LIMITED",
"AASHIRWAD WOMEN‚ÄôS HOSPITAL",
"AASHIRYA MULTIVENTURES PRIVATE LIMITED",
"AASHISH AUTO COMPONENTS MANUFACTURERS PRIVATE LIMITED",
"AASHISH BIO BUSINESS PRIVATE LIMITED",
"AASHISH CABLE NET (INDIA) PRIVATE LIMITED",
"AASHISH COATING TECHNOLOGIES PRIVATE LIMITED",
"AASHISH IRON AND STEEL PRIVATE LIMITED",
"AASHITA RESTAURANT AND FOOD PRODUCTS PRIVATE LIMITED",
"AASHIYANA INFRASTRUCTURE DEVELOPMENT PRIVATE LIMITED",
"AASHKA HOSPITALS LIMITED",
"AASHKA HOSPITALS PRIVATE. LIMITED.",
"AASHKA SOFTWARE LIMITED",
"AASHMAN AIR TRAVELS PRIVATE LIMITED",
"AASHMAN ENERGY PRIVATE LIMITED",
"AASHNA BUSINESS SERVICES PRIVATE LIMITED",
"AASHNA DESIGNS PRIVATE LIMITED",
"AASHNOKHI PROPERTIES PRIVATE LIMITED",
"AASHRAM SCHOOL VAGHECHA",
"AASHRAMSHADA GOPALPURA (GOV)",
"AASHRAY DESIGN CONSULTANTS PRIVATE. LIMITED",
"AASHRAYA BUILDTECH PRIVATE LIMITED",
"AASHRIT CAPITAL LIMITED",
"AASHRITH HOTELS PRIVATE LIMITED",
"AASHRITH WINDOWS AND DOORS PRIVATE LIMITED",
"AASHRITHA FACILITIES MANAGEMENT PRIVATE LIMITED",
"AASHUMI CHEMICALS PRIVATE LIMITED",
"AASHVIT SALES PRIVATE LIMITED",
"AASHWAS CHEST & ALLERGY CLINIC PRIVATE LIMITED",
"AASHWASAN LIFE ENHANCEMENT SERVICES PRIVATE LIMITED",
"AASI CRYOGENIC PRIVATE LIMITED",
"AASIA CORPORATION LLP",
"AASIANA AEROTECH PRIVATE LIMITED",
"AASIM COMMUNICATIONS PRIVATE LIMITED",
"AASIM PROJECTS INDIA PRIVATE LIMITED",
"AASK FOREX PRIVATE LIMITED",
"AASK PRECISION ENGINEERS PRIVATE LIMITED",
"AASMAA SECURITIES PRIVATE LIMITED",
"AASMAK INDUSTRIES LIMITED",
"AASMAUK ENTERTAINMENTS LIMITED",
"AASN CONSULTANTS PRIVATE LIMITED",
"AASNAA ENGINEERS PRIVATE LIMITED",
"AASONI CONSTRUCTIONS PRIVATE LIMITED",
"AASPA EQUIPMENT PRIVATE LIMITED",
"AASPAS MULTIMEDIA LIMITED",
"AASRA EMERGE PRIVATE LIMITED",
"AASRA FINCORP PRIVATE LIMITED",
"AASRA HOSPITAL",
"AASRA INFRADEVELOPERS PRIVATE LIMITED",
"AASRA MARTECH PRIVATE LIMITED",
"AASRA PROJECTS PRIVATE LIMITED",
"AASRALOKA LIFESTYLE AND HEALTH PRIVATE LIMITED",
"AASRIT BIO-ENERGY PRIVATE LIMITED",
"AASRIT ENERGY PLANTATIONS PRIVATE LIMITED",
"AASSK PHARMACEUTICALS PRIVATE LIMITED",
"AASSOCIATED AROMATICS PRIVATE LIMITED",
"AASTHA ALUMINA PRIVATE LIMITED",
"AASTHA AUTOMOBILES PRIVATE LIMITED",
"AASTHA AUTOTECH PRIVATE LIMITED",
"AASTHA BIO-TECH PRIVATE LIMITED",
"AASTHA BROAD CASTING NETWORK LIMITED",
"AASTHA CLEANROOM SYSTEM PRIVATE LIMITED",
"AASTHA CONTRACTS INDIA PRIVATE LIMITED",
"AASTHA CROPS MILL PRIVATE LIMITED",
"AASTHA ENVIRO ENGINEERS PRIVATE LIMITED",
"AASTHA FASHIONS PRIVATE. LIMITED.",
"AASTHA FINE PACKAGING PRIVATE LIMITED",
"AASTHA FOUNDATION PRIVATE LIMITED",
"AASTHA INFRABUILD PRIVATE LIMITED",
"AASTHA INFRACITY LIMITED",
"AASTHA INTERNATIONAL",
"AASTHA INTERTRADE PRIVATE LIMITED",
"AASTHA KIDNEY AND SUPER SPECIALITY HOSPITAL",
"AASTHA LIFE CARE CORP. PRIVATE LIMITED",
"AASTHA LIFECARE CORPORATION PRIVATE LIMITED",
"AASTHA LOK HOSPITAL PRIVATE LIMITED",
"AASTHA MEDICAL TECHNOLOGIES PRIVATE LIMITED",
"AASTHA NANOCHEM PRIVATE LIMITED",
"AASTHA ONCOLOGY PRIVATE LIMITED",
"AASTHA PAPER INDUSTRIES PRIVATE LIMITED",
"AASTHA PROMOTERS & DEVELOPERS PRIVATE LIMITED",
"AASTHA SALT INDUSTRIES PRIVATE LIMITED",
"AASTHA SALT MARKETING PRIVATE LIMITED",
"AASTHA SAREES PRIVATE LIMITED",
"AASTHA SOCIETY",
"AASTHA SPINTEX PRIVATE LIMITED",
"AASTHA TECH PRODUCTS PRIVATE LIMITED",
"AASTHA TRADECOMM PRIVATE LIMITED",
"AASTHA TRAVELS PRIVATE LIMITED",
"AASTHANEER CONSTRUCTION PRIVATE LIMITED",
"AASTHAVISION MOTORS PRIVATE LIMITED",
"AASTHRA SIZING PRIVATE LIMITED",
"AASTHVINAYAK LOGISTIC AND MINERALS PRIVATE LIMITED",
"AASTIK INFRA PROJECT PRIVATE LIMITED",
"AASTRID INTERNATIONAL PRIVATE LIMITED",
"AASTRID LIFE SCIENCES PRIVATE LIMITED",
"AASU EXIM PRIVATE LIMITED",
"AASU PLASTICS PVT.LTD.",
"AATAPI SEVA FOUNDATION",
"AATARSH CLOTHING COMPANY",
"AATASH COMPUTER AND COMMUNICATIONS PRIVATE LIMITED",
"AATASH NORCONTROL LIMITED",
"AATASH POWER PRIVATE LIMITED",
"AATCO FOODS INDIA PRIVATE LIMITED",
"AATEEV EXIM PRIVATE LIMITED",
"AATHARVA VYAPAR PRIVATE LIMITED",
"AATHAVA GARMENTS INDIA PRIVATE LIMITED",
"AATHESH VENTURES PRIVATE LIMITED",
"AATHI SHIPPING AND MARINE SERVICES PRIVATE LIMITED",
"AATHMIKA HOSPITALITY PRIVATE LIMITED",
"AATIQ POWER SOLUTIONS INDIA PRIVATE LIMITED",
"AATISH FINANCIAL CONSULTANTS LIMITED",
"AATITHYA HOLIDAY PLANNER PRIVATE LIMITED",
"AATITHYAA TECHNO INDIA PRIVATE LIMITED",
"AATMAJ HEALTHCARE LIMITED",
"AATMAJ HEALTHCARE PRIVATE LIMITED",
"AATMAN ELECTRO MAGNETICS PRIVATE LIMITED",
"AATMAN INNOVATIONS PRIVATE LIMITED",
"AATMAN PLASTTO PRIVATE LIMITED",
"AATMANAND GINING PRESSING AND OIL MILL PRIVATE LIMITED",
"AATMANIRBHAR SOLAR PRIVATE LIMITED",
"AATMDEEP VIDYALAYA",
"AATMOSFERA DI VITA PRIVATE LIMITED",
"AATOMIZE MANUFACTURING PRIVATE LIMITED",
"AATOUS INTERNATIONAL PRIVATE LIMITED",
"AATRAL TECHNOLOGIES INDIA PRIVATE LIMITED",
"AATREYEE NIRMAN PRIVATE LIMITED",
"AATULYA INFRA PROJECTS PRIVATE LIMITED",
"AATULYA LIFECARE PRIVATE LIMITED",
"AAUM RESEARCH & ANALYTICS PRIVATE LIMITED",
"AAURAA INTERNATIONAL",
"AAV CLOTHING PRIVATE LIMITED",
"AAV MINERAL AND CHEMICALS INDUSTRIES PRIVATE LIMITED",
"AAV WELLCARE PRIVATE LIMITED",
"AAVA AUTOCOMPS PRIVATE LIMITED",
"AAVALI PRINTS PRIVATE LIMITED",
"AAVANA CORPORATE SOLUTIONS PRIVATE LIMITED",
"AAVANA GREENS PRIVATE LIMITED",
"AAVANIRA BIOTECH PRIVATE LIMITED",
"AAVANTI RENEWABLE ENERGY PRIVATE LIMITED",
"AAVANTI SOLAR ENERGY PRIVATE LIMITED",
"AAVANTIKA GAS LIMITED",
"AAVAS FINANCIERS LIMITED",
"AAVAZ AI TECHNOLOGY PRIVATE LIMITED",
"AAVEG MANAGEMENT SERVICES PRIVATE LIMITED",
"AAVEG TECHNOLOGY PRIVATE LIMITED",
"AAVENIR SOFTWARE PRIVATE LIMITED",
"AAVIN STAINLESS PRIVATE LIMITED",
"AAVISHKAAR GEMS PRIVATE LIMITED",
"AAVISHKAR EDUCATIONAL SOCIETY",
"AAVISHKAR HYFAB INDUSTRIES PRIVATE LIMITED",
"AAVISHKAR IMPEX PRIVATE LIMITED",
"AAVISHKAR ORAL STRIPS PRIVATE LIMITED",
"AAVISHKAR SALES AND TECHNICAL SERVICES PRIVATE LIMITED",
"AAVIZA ELECTRONICS PRIVATE LIMITED",
"AAVKAR DRUGS PRIVATE LIMITED",
"AAVKAR INFRASTRUCTURE PRIVATE LIMITED",
"AAVON STEELS MANUFACTURING PRIVATE LIMITED",
"AAVRITII INTERCONNECT PRIVATE LIMITED",
"AAVVIK BUSINESS PRIVATE LIMITED",
"AAVYA AGRI SCIENCE PRIVATE LIMITED",
"AAVYAAN CHEMICAL PRIVATE LIMITED",
"AAWADKRUPA PLASTOMECH PRIVATE LIMITED",
"AAWASONLINE PRIVATE LIMITED",
"AAXIS GROUP INDIA PRIVATE LIMITED",
"AAXIS NANO TECHNOLOGIES PRIVATE LIMITED",
"AAY ESS BLISTERS PRIVATE LIMITED",
"AAY JAY REALTECH PRIVATE LIMITED",
"AAY JAY SPINNERS PRIVATE LIMITED",
"AAY KAY INFRAESTATE PRIVATE LIMITED",
"AAY TEE LOGISTICS PRIVATE LIMITED",
"AAY VEE CATERERS PRIVATE LIMITED",
"AAYAM CAREER INSTITUTE PRIVATE LIMITED",
"AAYAM PROJECTS PRIVATE LIMITED",
"AAYAN BRICKS INDUSTRY PRIVATE LIMITED",
"AAYAN DIGI TECH PRIVATE LIMITED",
"AAYAN NANOTECH PRIVATE LIMITED",
"AAYANSH SHIPPING SERVICES PRIVATE LIMITED",
"AAYANSH WELLNESS PRIVATE LIMITED",
"AAYESHIVA INTERNATIONAL PRIVATE LIMITED",
"AAYKA WATERPROOFERS PRIVATE LIMITED",
"AAYOJAN RESOURCES PRIVATE LIMITED",
"AAYS ADVISORY PRIVATE LIMITED",
"AAYU CREATION PRIVATE LIMITED",
"AAYU INFOSYSTEMS PRIVATE LIMITED",
"AAYU LOGISTICS PRIVATE LIMITED",
"AAYUJA TECHNOLOGIES INDIA PRIVATE LIMITED",
"AAYUKART PRIVATE LIMITED",
"AAYUR TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"AAYURDHAANVET PHARMA PRIVATE LIMITED",
"AAYURITZ PHYTONUTRIENTS PRIVATE LIMITED",
"AAYUSH DECOR PRIVATE LIMITED",
"AAYUSH FOOD AND HERBS LIMITED",
"AAYUSH MULTISPECIALITY HOSPITAL",
"AAYUSH NRI LEPL HEALTHCARE PRIVATE LIMITED",
"AAYUSH PULSES PRODUCTS PRIVATE LIMITED",
"AAYUSH REALSTRUCTURE PRIVATE LIMITED",
"AAYUSH RETREATS PRIVATE LIMITED",
"AAYUSH SHREYESH PROPERTIES PRIVATE LIMITED",
"AAYUSH SPINTEX PRIVATE LIMITED",
"AAYUSH TEX DYE PRIVATE LIMITED",
"AAYUSH TEXFAB PRIVATE LIMITED",
"AAYUSH TEX-TRADE PRIVATE LIMITED",
"AAYUSHI HYGIENE AND CARE PRIVATE LIMITED",
"AAYUSHI PAPERS PRIVATE LIMITED",
"AAYUSHMAAN LOGISTICS SERVICES PRIVATE LIMITED",
"AAYUSHMAN WELL CARE PRIVATE LIMITED",
"AAYUSHYA FOUNDATION",
"AAYUV TECHNOLOGIES PRIVATE LIMITED",
"AAYYUSKAAM PRIVATE LIMITED",
"AAZTEC INDIA SOLUTIONS PRIVATE LIMITED",
"AB AIRCON",
"AB AQUA NEEDS",
"AB BANK LIMITED",
"AB CARTER INDIA PRIVATE LIMITED",
"AB CARTRIDGE PRIVATE LIMITED",
"AB CHEMICALS INDIA PRIVATE. LIMITED.",
"AB COATINGS PRIVATE LIMITED",
"AB COLOR PRIVATE LTD",
"AB COM PRIVATE LIMITED",
"AB CONSTRUCTIONS PVT LTD",
"AB CONTROL PANELS PRIVATE LIMITED",
"AB CORP PROPERTY MANAGEMENT LLP",
"AB CORPORATE INTERIORS PRIVATE LIMITED",
"AB CYCLE PARTS PRIVATE LIMITED",
"AB ELASTO PRODUCTS PVT LTD",
"AB EMULTECH PRIVATE LIMITED",
"AB ENERGIA SOLUTIONS PRIVATE LIMITED",
"AB ENGINEERING AND SYSTEMS PRIVATE LIMITED",
"AB ENTERPRISE",
"AB FACILITY MANAGEMENT INDIA PRIVATE LIMITED",
"AB FLON PRIVATE LIMITED",
"AB FORCE ENGINEERS PRIVATE LIMITED",
"AB FORTUNE TECHNOLOGY SERVICES PRIVATE LIMITED",
"AB HYDROMATICS PRIVATE LIMITED",
"AB INBEV GCC SERVICES INDIA PRIVATE LIMITED",
"AB INFRA INVESTMENTS PRIVATE. LIMITED.",
"AB INFRAZONE PRIVATE LIMITED",
"AB INNOVATIVE SOFTWARE PRIVATE LIMITED",
"AB INSURANCE BROKERS PRIVATE LIMITED",
"AB MAURI INDIA PRIVATE LIMITED",
"AB MOBILE AND TERMINALS PRIVATE LIMITED",
"AB MOBILE SERVICES ALLIANCE INDIA PRIVATE LIMITED",
"AB MOBILE STANDARDS ALLIANCE INDIA PRIVATE LIMITED",
"AB N DHRUV AUTOCRAFT (INDIA) PRIVATE LIMITED",
"AB OPTIQUE EYE EAR AND SPEECH PRIVATE LIMITED",
"AB POLYPACKS PRIVATE LIMITED",
"AB REINIGER INDUSTRIES PRIVATE LIMITED",
"AB RICETECH PRIVATE LIMITED",
"AB ROY'S PHARMACEUTICAL PRIVATE LIMITED",
"AB SEA CONTAINER PRIVATE LIMITED",
"AB SOURCE BIOLOGICS PRIVATE LIMITED",
"AB STUDIOS PRIVATE LIMITED",
"AB SUGARS LIMITED",
"AB TECHNICAL SERVICES PRIVATE LIMITED",
"AB TRUCKS PRIVATE LIMITED",
"AB TUTORIALS PRIVATE LIMITED",
"AB UDYOG PRIVATE LIMITED",
"AB VARDHAN PRIVATE LIMITED",
"AB WELLNESS PRIVATE LIMITED",
"AB&D SOFTWARE INDIA PRIVATE LIMITED",
"AB2 CONSULTING PRIVATE LIMITED",
"ABA INFRASTRUCTURE PRIVATE LIMITED",
"ABAAM DIGITAL MEDIA PRIVATE LIMITED",
"ABAAM HOSPITALITY PRIVATE LIMITED",
"ABAAN IMPEX PRIVATE LIMITED",
"ABAAN STEELS PRIVATE LIMITED",
"ABABIL GRANITE EXPORTS PRIVATE LIMITED",
"ABABIL HEALTHCARE PRIVATE LIMITED",
"ABABIL MEDICAL DEVICES PRIVATE LIMITED",
"ABACA SYSTEMS PRIVATE LIMITED",
"ABACUS ACCOUNTING PRIVATE LIMITED",
"ABACUS BUILDTECH PRIVATE LIMITED",
"ABACUS CONSULTANTS PRIVATE LIMITED",
"ABACUS CORPORATION PRIVATE LIMITED",
"ABACUS ELECTRONICS PRIVATE LIMITED",
"ABACUS HEAT TRANSFER LIMITED",
"ABACUS INDIA AGENCIES PRIVATE LIMITED",
"ABACUS INFOSYSTEM PRIVATE LIMITED",
"ABACUS INFRASTRUCTURES PRIVATE LIMITED",
"ABACUS METALS PRIVATE LIMITED",
"ABACUS PERIPHERALS PRIVATE LIMITED",
"ABACUS REAL ESTATE PRIVATE LIMITED",
"ABACUS STAFFING & SERVICES PRIVATE LIMITED",
"ABACUS TECHNOCRATS PRIVATE LIMITED",
"ABACUS TECHNOSOLUTIONS PRIVATE LIMITED",
"ABAD BUILDERS PRIVATE LIMITED",
"ABAD EXPORTS PVT LTD",
"ABAD FISHERIES PRIVATE LIMITED",
"ABAD HOTELS INDIA PVT LTD",
"ABAD INSULATION PRIVATE LIMITED",
"ABAD MOTELS AND RESORTS PRIVATE LIMITED",
"ABAD OVERSEAS PRIVATE LIMITED",
"ABAD PROPERTY MANAGEMENT SERVICES PRIVATE LIMITED",
"ABAD SPECIALITY HOTELS PRIVATE LIMITED",
"ABAFT WORLDWIDE SERVICES PRIVATE LIMITED",
"ABAJ DIGITAL VENTURES PRIVATE LIMITED",
"ABAJ INTERIORS PRIVATE LIMITED",
"ABAJ TECHNOLOGIES PRIVATE LIMITED",
"ABAK ELECTROFAB ENGINEERING PRIVATE LIMITED",
"ABAKURE PHARMACEUTICAL PRIVATE LIMITED",
"ABAL INDIA COMPUTECH PRIVATE LIMITED",
"ABALONE IMPEX PRIVATE LIMITED",
"ABAN CONSTRUCTIONS PRIVATE LIMITED",
"ABAN DEVELOPERS PRIVATE LIMITED",
"ABAN SINGAPORE PTE LTD",
"ABANA TECHNOLOGY PRIVATE LIMITED",
"ABANI DIGITAL PRIVATE LIMITED",
"ABANI HEALTHCARE PRIVATE LIMITED",
"ABANS AGRI WAREHOUSING & LOGISTICS PRIVATE LIMITED",
"ABANS BROKING SERVICES PRIVATE LIMITED",
"ABANS COMMODITIES (I) PRIVATE LIMITED",
"ABANS COMODITIES I PRIVATE LIMITED",
"ABANS CREATIONS PRIVATE LIMITED",
"ABANS ENTERPRISES LIMITED",
"ABANS FACILITY MANAGEMENT INDIA PRIVATE LIMITED",
"ABANS FINANCE PRIVATE LIMITED",
"ABANS GLOBAL BROKING (IFSC) PRIVATE LIMITED",
"ABANS HOLDINGS LIMITED",
"ABANS JEWELS LIMITED",
"ABANS METALS PRIVATE LIMITED",
"ABANS REALITY AND INFRASTRUCTURE PRIVATE LIMITED",
"ABANS TEXTILES PRIVATE LIMITED",
"ABANTE INTEGRATED MANAGEMENT SERVICES PRIVATE LIMITED",
"ABANTIKA TECHNO PROJECTS PRIVATE LIMITED",
"ABAP IT SOLUTIONS PRIVATE LIMITED",
"ABARAN TIMELESS JEWELLERY PRIVATE LIMITED",
"ABARIS HEALTHCARE PRIVATE LIMITED",
"ABAS FORCE (INDIA) PRIVATE LIMITED",
"ABASAHEB BHOGAONKAR HIGHSCHOOL PANHALA KOLHAPUR",
"ABASAHED GARWARE COLLEGE OF ARTS SCIEN",
"ABASKAR CONSTRUCTION PVT LTD",
"ABAX CONSULTANTS AND FACILITATORS PRIVATE LIMITED",
"ABAXIAL ARCHITECTS PRIVATE LIMITED",
"ABAXIS DESIGN AND BUILD PRIVATE LIMITED",
"ABAXISBIO PHARMA PRIVATE LIMITED",
"ABB AB",
"ABB BUSINESS SERVICES PRIVATE LIMITED",
"ABB GLOBAL INDUSTRIES AND SERVICES PRIVATE LIMITED",
"ABB INDIA LIMITED",
"ABB INFRA BUILDTECH PRIVATE LIMITED",
"ABB LIMITED",
"ABB SHIP MANAGEMENT PRIVATE LIMITED",
"ABBA CONSULTANTS PRIVATE LIMITED",
"ABBA KABA OVERSEAS PRIVATE LIMITED",
"ABBACUS TECH INDIA PRIVATE LIMITED",
"ABBAKKA ENGINEERING PRIVATE LIMITED",
"ABBANI BEADS PRIVATE LIMITED",
"ABBARES PHARMACEUTICALS PRIVATE LIMITED",
"ABBAS CONSTRUCTION PRIVATE LIMITED",
"ABBAS KHAN COLLEGE FOR WOMEN",
"ABBAS WAZIR PRIVATE LIMITED",
"ABBASI RAO DEVELOPERS PRIVATE LIMITED",
"ABBESS HEALTH CARE OPC PRIVATE LIMITED",
"ABBEY HEALTHCARE PRIVATE LIMITED",
"ABBEY LABORATORIES PRIVATE LIMITED",
"ABBEY WEST SERVICES PRIVATE LIMITED",
"ABBIE IT MART PRIVATE LIMITED",
"ABBIRAMI HOTELS PRIVATE LIMITED",
"ABBKUS (OPC) PRIVATE LIMITED",
"ABBOTT COLD STORAGES PRIVATE LIMITED",
"ABBOTT DIAGNOSTICS MEDICAL PRIVATE LIMITED",
"ABBOTT HEALTHCARE PRIVATE LIMITED",
"ABBOTT HOTELS PRIVATE LIMITED.",
"ABBOTT INDIA LIMITED",
"ABBOTT TOOLFAST PRIVATE LIMITED",
"ABBOTTSONS IMPEX PRIVATE LIMITED",
"ABBSCISSA HR CONSULTING PRIVATE LIMITED",
"ABBTRON TECHNOLOGIES PRIVATE LIMITED",
"ABBUNDU INTERIORS AND CONSTRUCTIONS PRIVATE LIMITED",
"ABBVIE HEALTHCARE INDIA PRIVATE LIMITED",
"ABBVIE THERAPEUTICS INDIA PRIVATE LIMITED",
"ABBY LIGHTING AND SWITCHGEAR LIMITED",
"ABC AGRO AND FOOD MACHINE INDIA PRIVATE LIMITED",
"ABC AGROBIOTECHNOLOGY PRIVATE LIMITED",
"ABC APPARELS PRIVATE LIMITED",
"ABC APPTECH PRIVATE LIMITED",
"ABC BEARINGS LIMITED",
"ABC BUILDCON PRIVATE LIMITED",
"ABC BUILDERS & CONSTRUCTION LIMITED",
"ABC BUILDWARES (INDIA) PRIVATE LIMITED",
"ABC CHASHMEWALE LLP",
"ABC CHEMICAL EXPORTS PRIVATE LIMITED",
"ABC CHEMICALS PRIVATE LIMITED",
"ABC COLOURCHEM PRIVATE LIMITED",
"ABC COMNET PRIVATE LIMITED",
"ABC CONSOLIDATED PRIVATE LIMITED",
"ABC CONSULTANCY SERVICES PRIVATE LIMITED",
"ABC CONSULTANTS PRIVATE LIMITED",
"ABC CREATIONS PRIVATE LIMITED",
"ABC DIAGNOSTICS PVT LTD",
"ABC FUELS PRIVATE LIMITED",
"ABC GARMENTS",
"ABC GAS (INTERNATIONAL) LIMITED",
"ABC HEALTHPLUS PRIVATE LIMITED",
"ABC IMPEX PRIVATE LIMITED",
"ABC IMPORTS AND EXPORTS INDIA PRIVATE LIMITED",
"ABC INDIA LIMITED",
"ABC INFRA DESIGN PRIVATE LIMITED",
"ABC INFRA EQUIPMENT PRIVATE LIMITED",
"ABC INFRAHOMES PRIVATE LIMITED",
"ABC INFRAREAL PRIVATE LIMITED",
"ABC LAND & INVESTMENT CO PVT LTD",
"ABC MARINE PRIVATE LIMITED",
"ABC MERCANTILE GROUP (INDIA) PRIVATE LIMITED",
"ABC MONTESSORI SCHOOL",
"ABC OVERSEAS PRIVATE LIMITED",
"ABC PRINTADS PRIVATE LIMITED",
"ABC PROCESS SOLUTIONS PRIVATE LIMITED",
"ABC PUBLISHERS & DISTRIBUTORS PRIVATE LIMITED",
"ABC RENEWABLE ENERGY (RJ-01) PRIVATE LIMITED",
"ABC SITES PRIVATE LIMITED",
"ABC SPORTS PRIVATE LIMITED",
"ABC SYNTHETICS PVT LTD",
"ABC TEA WORKERS WELFARE SERVICES",
"ABC TECHNO LABS INDIA PRIVATE LIMITED",
"ABC TELECOM PRIVATE LIMITED",
"ABC TRANSCARRIERS PRIVATE LIMITED",
"ABC TRANSFORMERS PRIVATE LIMITED",
"ABC TRANSPORT COMPANY PRIVATE LIMITED",
"ABCC BUILDERS PRIVATE LIMITED",
"ABCHLOR INVESTMENT ADVISORS PRIVATE LIMITED",
"ABCI AGROCHEM PRIVATE LIMITED",
"ABCI INFRASTRUCTURES PRIVATE LIMITED",
"ABCKON HEALTHCARE PRIVATE LIMITED",
"ABCMNN MYSURU PRIVATE LIMITED",
"ABCN LOGISTICS PRIVATE LIMITED",
"ABCO ENTERPRISES PVT LTD",
"ABCO INDIA PRIVATE LIMITED",
"ABCO INFOTECH INTERNATIONAL PRIVATE LIMITED",
"ABCO LEATHERS PRIVATE LIMITED",
"ABCO STEEL INTERNATIONAL PRIVATE LIMITED",
"ABCONE INTERNATIONAL PRIVATE LIMITED",
"ABCSTAR EXPRESS PRIVATE LIMITED",
"ABCUS TEXTILES PRIVATE. LIMITED",
"ABD DIAMONDS PRIVATE LIMITED",
"ABD IMPEX PRIVATE LIMITED",
"ABDHARA FOOD SERVICES PRIVATE LIMITED",
"ABDHARA SERVICES",
"ABDHI JEWELS PRIVATE LIMITED",
"ABDOS CONSUMER CARE LIMITED",
"ABDOS LABTECH PRIVATE LIMITED",
"ABDOS LAMITUBES PRIVATE LIMITED",
"ABDOS OILS PVT LTD",
"ABDOS TRADING CO PVT LTD",
"ABDUL BARIK MEMORIAL HIGH SCHOOL NOWAMUNDI",
"ABDUL SALAM MIR CONSTRUCTION COMPANY PRIVATE LIMITED",
"ABDUL SHAKOOR PRIMARY SCHOOL",
"ABDULLAH PATEL URDU PRI SCHOOL KAUSA",
"ABDULLAH TANNERY PRIVATE LIMITED",
"ABE ENGINEERS PRIVATE LIMITED",
"ABE SECURITY MECHANICS PRIVATE LIMITED",
"ABE SERVICES PRIVATE LIMITED",
"ABEC EXHIBITIONS & CONFERENCES PRIVATE LIMITED",
"ABECO INFRASTRUCTURES PRIVATE LIMITED",
"ABEDA INAMDAR SENIOR COLLEGE FOR GIRLS",
"ABEDHA TECHNOLOGIES PRIVATE LIMITED",
"ABEE SMART COMMERCE INDIA PRIVATE LIMITED",
"ABEER TEXTILE PRIVATE LIMITED",
"ABEINSA BUSINESS DEVELOPMENT PRIVATE LIMITED",
"ABEL ESTATES PRIVATE LIMITED",
"ABEL SOFTWARE AND CONSULTANTS PRIVATE LIMITED",
"ABELLON AGRISCIENCES LIMITED",
"ABELLON CLEANENERGY LIMITED.",
"ABELLON EPC & TECHNOLOGIES LIMITED",
"ABERDARE TECHNOLOGIES PRIVATE LIMITED",
"ABERDEEN FOODS PRIVATE LIMITED",
"ABES ENGINEERING COLLEGE",
"ABES INSTITUTE OF TECHNOLOGY",
"ABETTOR LIFE SCIENCES PRIVATE LIMITED",
"ABEXMATIC HYDROLICS PRIVATE LIMITED",
"ABEYAANTRIX SOLUTIONS PRIVATE LIMITED",
"ABF ENGINEERING INTERNATIONAL PRIVATE LIMITED",
"ABF FREIGHT INTERNATIONAL PRIVATE LIMITED",
"ABG ENGINEERING INDIA PRIVATE LIMITED",
"ABG SPORTS ACADEMY LLP",
"ABH BIOCHEM PRIVATE LIMITED",
"ABH HEALTHCARE PRIVATE LIMITED",
"ABHA AGRO EXPORTS PRIVATE LIMITED",
"ABHA AGRO INDUSTRIES PRIVATE LIMITED",
"ABHA FERRO ALLOYS LIMITED",
"ABHA JEWELLERS AND GEMS PRIVATE LIMITED",
"ABHA NURSING HOME PRIVATE LIMITED",
"ABHA POWER AND STEEL PRIVATE LIMITED",
"ABHA REFRACTORIES LIMITED",
"ABHA SHARE TRADING PRIVATE LIMITED",
"ABHA SOLARFARMS LIMITED",
"ABHA SUNLIGHT PRIVATE LIMITED",
"ABHA TRAVELS PRIVATE LIMITED",
"ABHANG AGRO PRODUCTS PRIVATE LIMITED",
"ABHARAN JEWELLERS PRIVATE LIMITED",
"ABHARAN MOTORS PRIVATE LIMITED",
"ABHARANI VINIMAY PVT LTD",
"ABHARSH HEALTHCARE PRIVATE LIMITED",
"ABHAS SURGICALS PRIVATE LIMITED",
"ABHASA WELLNESS RETREAT PRIVATE LIMITED",
"ABHASH TELECOM PRIVATE LIMITED",
"ABHAV INFRASTRUCTURES PRIVATE LIMITED",
"ABHAY CAPITAL SERVICES PRIVATE LIMITED",
"ABHAY CARRIERS PRIVATE LIMITED",
"ABHAY CONSULTANTS PVT LTD",
"ABHAY ENTERPRISES PRIVATE LIMITED",
"ABHAY FIRE ENGINEERING & SERVICES PRIVATE LIMITED",
"ABHAY FOOTWEAR PRIVATE LIMITED",
"ABHAY IMPEX PRIVATE LIMITED",
"ABHAY INTEGRATED TECHNOLOGIES PRIVATE LIMITED",
"ABHAY ISPAT (INDIA) PRIVATE LIMITED",
"ABHAY PROP MANAGEMENT PRIVATE LIMITED",
"ABHAY SAHNI PROJECTS PVT LTD",
"ABHAY SOLVENTS PRIVATE LIMITED",
"ABHAY TECHNO SERVICES PRIVATE LIMITED",
"ABHAY TRADING PRIVATE LIMITED",
"ABHAY TRANSFORMERS PRIVATE LIMITED",
"ABHAY VASISHTHA HOSPITAL",
"ABHAY.S STEELS PRIVATE LIMITED",
"ABHAYA EXPORTS PRIVATE LIMITED",
"ABHAYA FROZEN FOODS PRIVATE LIMITED",
"ABHAYA POWER SYSTEMS PRIVATE LIMITED",
"ABHAYAA CYBER SOLUTIONS PRIVATE LIMITED",
"ABHAYAHASTA MULTISPECIALITY HOSPITAL",
"ABHAYANAND STEEL PRIVATE LIMITED",
"ABHAYANJANEYA HEALTH CARE PRIVATE LIMITED",
"ABHAYKUMAR COMMODITIES PRIVATE LIMITED",
"ABHAYKUMAR LEAFIN AND INVESTMENTS P LTD",
"ABHAYKUMAR WALCHAND SHAH SARAF PRIVATE LIMITED",
"ABHAYSINHRAJE BHONSLE INSTITUT OF TECHNOLOGY POLYTECHNIC",
"ABHAYSURAKSHA BUILDERS PRIVATE LIMITED",
"ABHED INFRABUILD PRIVATE LIMITED",
"ABHEDY INTELLIGENCE & SECURITY PRIVATE LIMITED",
"ABHEDYA POWER PRIVATE LIMITED",
"ABHEEK CONSULTANCY PRIVATE LIMITED",
"ABHEY STEELS PRIVATE LIMITED",
"ABHEY'S JEWELLERY PALACE PRIVATE LIMITED",
"ABHI AGRO PRIVATE LIMITED",
"ABHI AUTOMOTIVES PRIVATE LIMITED",
"ABHI BHEJO TECHNOLOGIES PRIVATE LIMITED",
"ABHI COLD STORAGE PRIVATE LIMITED",
"ABHI CORPORATION PRIVATE LIMITED",
"ABHI DESIGNERS AND DEVELOPERS PRIVATE LIMITED",
"ABHI ENERGY PRIVATE LIMITED",
"ABHI ENGINEERING CORPORATION PRIVATE LIMITED",
"ABHI IMPACT LOGISTICS SOLUTIONS PRIVATE LIMITED",
"ABHI MEDICO PRIVATE LIMITED",
"ABHI S.K. HOSPITAL PRIVATE LIMITED",
"ABHI TRANSMISSIONS PRIVATE LIMITED",
"ABHI VAIRAVANS PLUMBING PRIVATE LIMITED",
"ABHIAAN PREFAB PRIVATE LIMITED",
"ABHI-ANI MANUFACTURING COMPANY PRIVATE LIMITED",
"ABHIANSH HOME APPLIANCES PRIVATE LIMITED",
"ABHIAYA MARKETING PRIVATE LIMITED",
"ABHIBHASYA PRIVATE LIMITED",
"ABHIBUS SERVICES INDIA PRIVATE LIMITED",
"ABHIDEEP CHEMICALS PVT LTD",
"ABHIDI SOLUTION PRIVATE LIMITED",
"ABHIEJEET CONSTRUCTION AND SERVICES PRIVATE LIMITED",
"ABHIFLAX PHARMA-CHEM PRIVATE LIMITED",
"ABHIGNA MACHINERIES PRIVATE LIMITED",
"ABHIGNA RICE AND PARBOILED INDUSTRIES",
"ABHIGYAN AJAY FOOD AND BEVERAGES PRIVATE LIMITED",
"ABHIGYAN ENGINEERS PRIVATE LIMITED",
"ABHIGYAN INFRATECH PRIVATE LIMITED",
"ABHIHIT SYSTEM PRIVATE LIMITED",
"ABHIHOME EXPORTS LLP",
"ABHIJAT EQUIPMENTS PRIVATE LIMITED",
"ABHIJAY AUTO PARTS PRIVATE LIMITED",
"ABHIJEET ASHOKA INFRASTRUCTURE PRIVATE LIMITED",
"ABHIJEET AUTO COMPONENTS PRIVATE LIMITED",
"ABHIJEET CASTINGS PRIVATE LIMITED",
"ABHIJEET CHEMICALS PRIVATE LIMITED",
"ABHIJEET DIES AND TOOLS PRIVATE LIMITED",
"ABHIJEET EXPORTS PVT. LTD.",
"ABHIJEET INDUSTRIES",
"ABHIJEET INDUSTRIES PRIVATE LIMITED",
"ABHIJEET LANDINFRA PRIVATE LIMITED",
"ABHIJEET LOGISTICS PRIVATE LIMITED",
"ABHIJEET PLASTICS I PRIVATE. LIMITED.",
"ABHIJEET POLYMERS PRIVATE LIMITED",
"ABHIJEET RANEE POLYMERS PRIVATE LIMITED",
"ABHIJEET SEEDS PRIVATE LIMITED",
"ABHIJEET TRADEIMPEX",
"ABHIJIT AUTO AGENCY INDIA PRIVATE LIMITED",
"ABHIJIT FOREX & TRAVELS PRIVATE LIMITED",
"ABHIJIT GRAPHICS",
"ABHIJIT REALTORS & INFRAVENTURES PRIVATE LIMITED",
"ABHIJIT TEA CO PVT LTD",
"ABHIK ADVERTISING PRIVATE LIMITED",
"ABHIKALP DESIGN STUDIO PRIVATE LIMITED",
"ABHIKALP INFRASTRUCTURE INDIA PRIVATE LIMITED",
"ABHIKRITI IMPEX PRIVATE LIMITED",
"ABHILASH CHEMICALS AND PHARMACEUTICALS PRIVATE LIMITED",
"ABHILASH GROWTH FUND PRIVATE LIMITED",
"ABHILASHA BUILDTECH PRIVATE LIMITED",
"ABHILASHA COMMERCIAL PVT.LTD..",
"ABHILASHA CREATION PRIVATE LIMITED",
"ABHILASHA ENGINEERING CORPORATION PRIVATE LIMITED",
"ABHILASHA ENTERPRISES",
"ABHILASHA EXIM PRIVATE LIMITED",
"ABHILASHA HR SOLUTIONS PRIVATE LIMITED",
"ABHILASHA IMPEX PRIVATE LIMITED",
"ABHILASHA JEWELLERS PRIVATE LIMITED",
"ABHILASHA LOGISTICS PRIVATE LIMITED",
"ABHILASHA PHARMA PRIVATE LIMITED",
"ABHILASHA PRODUCTION",
"ABHILASHA SILK MILLS PRIVATE LIMITED",
"ABHILASHA TECHNOLOGIES PRIVATE LIMITED",
"ABHILASHA TEX-CHEM LIMITED",
"ABHILASHA VANIJYA PRIVATE LIMITED",
"ABHILASHINI REALCON PRIVATE LIMITED",
"ABHILEKH INFRASTRUCTURE PRIVATE LIMITED",
"ABHILEKHA INFORMATION PRIVATE LIMITED",
"ABHIMAANI PUBLICATIONS LIMITED.",
"ABHIMAANI STRUCTURES AND ENGINEERING PRIVATE LIMITED",
"ABHIMAN BUSINESS VENTURES PRIVATE LIMITED",
"ABHIMAN TECHNOLOGIES PRIVATE LIMITED",
"ABHIMAND NUMERICALS PRIVATE LIMITED",
"ABHIMANHAN ENERGY PRIVATE LIMITED",
"ABHIMANTRIT GURUPRASADAM AYURVEDA HERBAL FOODS PRIVATE LIMITED",
"ABHIMANU ADVENTURE RESORTS PRIVATE LIMITED",
"ABHIMANU VISIONS EDUCATIONALS PRIVATE LIMITED",
"ABHIMANYA INTERIO PRIVATE LIMITED",
"ABHIMANYU COLONIZERS PRIVATE LIMITED",
"ABHIMANYU CORPORATION PRIVATE LIMITED",
"ABHIMANYU CRICKET ACADEMY PRIVATE LIMITED",
"ABHIMANYU ENTERPRISES PRIVATE LIMITED",
"ABHIMANYU SEEDS PRIVATE LIMITED",
"ABHIMAYA PROJECTS PRIVATE LIMITED",
"ABHIMIT AUTOMOBILES PRIVATE LIMITED",
"ABHINAASH AGROFOOD INDUSTRIES PRIVATE LIMITED",
"ABHINAND VENTURES PRIVATE LIMITED",
"ABHINANDAN ART ORNAMENTS PRIVATE LIMITED",
"ABHINANDAN BUILDHOME PRIVATE LIMITED",
"ABHINANDAN BUSINESS CENTRE PRIVATE LIMITED",
"ABHINANDAN EXPORTS LIMITED",
"ABHINANDAN FOREX PRIVATE LIMITED",
"ABHINANDAN INDUSTRIES PRIVATE LIMITED",
"ABHINANDAN INVESTMENTS PRIVATE LIMITED",
"ABHINANDAN KNITS PRIVATE LIMITED",
"ABHINANDAN LAND DEVELOPERS PRIVATE. LIMITED.",
"ABHINANDAN LEASING AND FINANCE PRIVATE LIMITED",
"ABHINANDAN MOTORS PRIVATE. LIMITED.",
"ABHINANDAN PETRO PACK PRIVATE LIMITED",
"ABHINANDAN PETROCHEMICAL PRIVATE LIMITED",
"ABHINANDAN PLASTICS INDIA PRIVATE LIMITED",
"ABHINANDAN SILK MILLS PRIVATE LIMITED",
"ABHINANDAN SNACKS PRIVATE LIMITED",
"ABHINANDAN STOCK BROKING PRIVATE LIMITED",
"ABHINANDAN URBAN CO-OP BANK LTD AMRAVATI",
"ABHINANDAN VANIJYA PVT.LTD.",
"ABHINANDANA AGROVET INDIA PRIVATE LIMITED",
"ABHINANDANA AVENUES PRIVATE LIMITED",
"ABHINANDANA HOUSING PRIVATE LIMITED",
"ABHINAV ADVERTISING AGENCY PRIVATE LIMITED",
"ABHINAV ALLOYS PVT LTD",
"ABHINAV BIOTECH PRIVATE LIMITED",
"ABHINAV CAPITAL SERVICES LIMITED",
"ABHINAV DIGITAL AND INTERIOR SOLUTIONS PRIVATE LIMITED",
"ABHINAV EDUCATION SOCIETY",
"ABHINAV EXOTIC RESORTS PRIVATE LIMITED",
"ABHINAV FUTURISTICS PRIVATE LIMITED",
"ABHINAV GRANI CERAMICS PVT.LTD.",
"ABHINAV GRAPHICS AND PAPERS PRIVATE LIMITED",
"ABHINAV HEALTHCARE PRODUCTS PRIVATE LIMITED",
"ABHINAV HOME DECOR PRIVATE LIMITED",
"ABHINAV HOSPITAL",
"ABHINAV HOSPITALITY & INFRASTRUCTURE PRIVATE LIMITED",
"ABHINAV IMMIGRATION SERVICES PRIVATE LIMITED",
"ABHINAV INFRABUILD PRIVATE LIMITED",
"ABHINAV INFRAPROJECTS PRIVATE LIMITED",
"ABHINAV INFRATECH PRIVATE LIMITED",
"ABHINAV INSTITUTE OF TECHNOLOGY AND MANAGEMENT",
"ABHINAV LEASING AND FINANCE LIMITED",
"ABHINAV MRI & DIAGNOSTICS PRIVATE LIMITED",
"ABHINAV PAPER PRODUCTS PRIVATE LIMITED",
"ABHINAV PICTURES PVT LTD",
"ABHINAV POLYCHEM PRIVATE LIMITED",
"ABHINAV POLYPLAST PRIVATE LIMITED",
"ABHINAV PUBLIC SCHOOL",
"ABHINAV SHIPPING SERVICES PRIVATE LIMITED",
"ABHINAV STONES PRIVATE LIMITED",
"ABHINAV SYSTECH PRIVATE LIMITED",
"ABHINAV TRADEX PRIVATE LIMITED",
"ABHINAV TRADING PRIVATE LIMITED",
"ABHINAV TRANS-CARGO (MUMBAI) PRIVATE LIMITED",
"ABHINAV TRANSPORT (INDIA) PRIVATE LIMITED",
"ABHINAV VIDYALAY",
"ABHINAV VIDYALAY V KANISTA MAHAVIDYALAY JANUNA",
"ABHINAV VIDYAMANDIR AND JUNIOR COLLEGE",
"ABHINAV XPRESS CARGO PRIVATE LIMITED",
"ABHINAVA ALUMINIUM PRIVATE LIMITED",
"ABHINAVA ENGINEERING PROJECTS PRIVATE LIMITED",
"ABHINAY BUILDERS & DEVELOPERS PRIVATE LIMITED",
"ABHINAYA FOODS PRIVATE LIMITED",
"ABHINEET NURSING HOMES AND LAPAROSCOPIC CENTRE PRIVATE LIMITED",
"ABHIPRA CAPITAL LIMITED",
"ABHIPRA STEELTECH PRIVATE LIMITED",
"ABHIPRAJ INNOVATIVE FRUITS PRIVATE LIMITED",
"ABHIPRIYA BUSINESS (INDIA) PRIVATE LIMITED",
"ABHIPRIYA GLOBAL PRIVATE LIMITED",
"ABHIRA INFRATECH PRIVATE LIMITED",
"ABHIRAJ AGROVET PRIVATE LIMITED",
"ABHIRAJ ENGICON PRIVATE. LIMITED.",
"ABHIRAJ OVERSEAS PRIVATE LIMITED",
"ABHIRAJ SHRINK PACK PRIVATE LIMITED",
"ABHIRAM MARKETING SERVICES LIMITED",
"ABHIRAM NIRMAN (INDIA) PRIVATE LIMITED",
"ABHIRAMA STEELS LIMITED ASL",
"ABHIRAMI PET INDUSTRIES PRIVATE LIMITED",
"ABHIRAV ENGINEERING PRIVATE LIMITED",
"ABHIRAV INFRA & REALTORS PRIVATE LIMITED",
"ABHIRIT DISTRUBUTORS PRIVATE LIMITED",
"ABHIRU INDUSTRIES LIMITED",
"ABHIRUCHI FAMILY RESTARENT",
"ABHIRUCHI FUN & FOOD VILLAGE PRIVATE LIMITED",
"ABHIRUP COMMERCIAL PRIVATE LIMITED",
"ABHIS OVERSEAS EDUCAMPUS PRIVATE LIMITED",
"ABHISAR BUILDWELL PRIVATE LIMITED",
"ABHISEK CONTECH (INDIA) PRIVATE LIMITED",
"ABHISEK KNITWEAR PRIVATE LIMITED",
"ABHISEKH TEXCHEM PRIVATE LIMITED",
"ABHISHEK ADMINISTRATIVE SOLUTIONS PRIVATE LIMITED",
"ABHISHEK AGROCOM VYAPAAR PRIVATE LIMITED",
"ABHISHEK ALCOBEV PRIVATE LIMITED",
"ABHISHEK APPLIANCES PRIVATE LIMITED",
"ABHISHEK AUTOMOTIVES PRIVATE LIMITED",
"ABHISHEK CABLES PRIVATE LIMITED",
"ABHISHEK CAPITAL SERVICES PVT. LTD.",
"ABHISHEK CARGO MOVERS PRIVATE LIMITED",
"ABHISHEK CARS PRIVATE LIMITED",
"ABHISHEK CONSTRUCTION",
"ABHISHEK DIAMOND PRIVATE LIMITED",
"ABHISHEK DISTRIBUTORS PRIVATE LIMITED",
"ABHISHEK ENTERTAINMENT & FOODS PRIVATE LIMITED",
"ABHISHEK FABRICATION & ENGINEERING WORKS PRIVATE LIMITED",
"ABHISHEK FIRE PROTECTION PRIVATE LIMITED",
"ABHISHEK FLOUR MILLS PRIVATE LIMITED",
"ABHISHEK FORGINGS PVT LTD",
"ABHISHEK FORWARDING & LOGISTICS PRIVATE LIMITED",
"ABHISHEK FREIGHT (INDIA) PRIVATE LIMITED",
"ABHISHEK GINNING AND PRESSING PRIVATE LIMITED",
"ABHISHEK GLASS INDUSTRIES LIMITED",
"ABHISHEK GLASS INTERNATIONAL PRIVATE LIMITED",
"ABHISHEK GRANITES PRIVATE LIMITED",
"ABHISHEK GREEN CHEM PRIVATE LIMITED",
"ABHISHEK HOSPITALITIES PRIVATE LIMITED",
"ABHISHEK I MISHRA MEMORIAL MEDICAL COLLEGE & RESEARCH",
"ABHISHEK INDUSTRIAL SERVICES PVT LTD",
"ABHISHEK INDUSTRIES INDIA LIMITED",
"ABHISHEK INTEGRATIONS LIMITED",
"ABHISHEK INTERNATIONAL PRIVATE LIMITED",
"ABHISHEK ISPAT PRIVATE LIMITED",
"ABHISHEK JEWELLERS PRIVATE LIMITED",
"ABHISHEK KUMAR TIWARI CONSTRUCTIONS PRIVATE LIMITED",
"ABHISHEK MILLENNIUM CONTRACTS PRIVATE LIMITED",
"ABHISHEK MOTORS PRIVATE LIMITED",
"ABHISHEK ORGANICS PRIVATE LIMITED",
"ABHISHEK PROPBUILD PRIVATE LIMITED",
"ABHISHEK RAJ CONSTRUCTION PRIVATE LIMITED",
"ABHISHEK RE ROLLING MILLS (INDIA) PRIVATE LIMITED",
"ABHISHEK SEEDS PRIVATE LIMITED",
"ABHISHEK SINGH RATHAUR CONSTRUCTION PRIVATE LIMITED",
"ABHISHEK SOLAR INDUSTRIES PRIVATE. LIMITED.",
"ABHISHEK STEEL (BOKARO) PRIVATE LIMITED",
"ABHISHEK STEEL INDUSTRIES LIMITED",
"ABHISHEK SYNCOTEX PRIVATE LIMITED",
"ABHISHEK TRADEMART PRIVATE LIMITED",
"ABHISHEK TRADERS PRIVATE LIMITED",
"ABHISHEK TRANSLOGISTICS PRIVATE LIMITED",
"ABHISHEK VIPIN & ASSOCIATES LLP",
"ABHISHEK WHEELS PRIVATE LIMITED",
"ABHISHEK WOOLTEX PVT.LTD.",
"ABHISHEK WORLD LOGISTICS PRIVATE LIMITED",
"ABHISHEKH BOOK DISTRIBUTORS PRIVATE LIMITED",
"ABHISHRI PACKAGING PRIVATE LIMITED",
"ABHISHT DEVELOPERS AND BUILDERS PRIVATE LIMITED",
"ABHISHTA SOLAR PRIVATE LIMITED",
"ABHISHTI TEXTILE PRIVATE LIMITED",
"ABHISREE INFRA PROJECTS PRIVATE LIMITED",
"ABHISRI RETAIL PRIVATE LIMITED",
"ABHITECH DEVELOPERS PRIVATE LIMITED",
"ABHITECH ENERGYCON LIMITED",
"ABHI-TECH FAB & MACHINING PRIVATE LIMITED",
"ABHITECH IT SOLUTIONS PRIVATE LIMITED",
"ABHITEX INTERNATIONAL",
"ABHIUDAY PRINT INDUSTRIES PRIVATE LIMITED",
"ABHIVRIDHI INSURANCE BROKER PRIVATE LIMITED",
"ABHIVRUDHI FACILITY SERVICES PRIVATE LIMITED",
"ABHIYAAN BUILDCON PRIVATE LIMITED",
"ABHIYAAN INFRA PROJECTS PRIVATE LIMITED",
"ABHIYAN DEALCOMM PVT LTD",
"ABHIYAN MERCHANTTS PVT LTD",
"ABHIYANT TECHNOLOGIES PRIVATE LIMITED",
"ABHIYANTA INDIA SOLUTIONS PRIVATE LIMITED",
"ABHIYANTRI TECH SERVICES PRIVATE LIMITED",
"ABHIYUSH METALBRAINS PRIVATE LIMITED",
"ABHJ FASHIONS PRIVATE LIMITED",
"ABHOG INFRASTRUCTURE PRIVATE LIMITED",
"ABHRA PRIMARY SCHOOL",
"ABHRACLOUD SOFTWARES INDIA PRIVATE LIMITED",
"ABHU DHABI COMMERCIAL BANK",
"ABHUDAY BUILDCON PRIVATE LIMITED",
"ABHUDAYA EDN SOC ENG PRIM SCH",
"ABHUSHAN DIAMONDS & GOLD PRIVATE LIMITED",
"ABHUSHAN JEWELLERY (INDIA ) PRIVATE LIMITED",
"ABHYAAS EDU TECHNOLOGIES PRIVATE LIMITED",
"ABHYAAS EDUCATIONAL SOCIETY",
"ABHYAAS JUNIOR COLLEGE",
"ABHYANK ACADEMY PRIVATE LIMITED",
"ABHYANKAR AYURVEDIC PRODUCTS PRIVATE LIMITED",
"ABHYANKAR FOOTWEAR PRIVATE LIMITED",
"ABHYANKAR KANYA SHALA JUNIOR COLLEGE YAVATMAL",
"ABHYANSH SHIPPING SERVICES (INDIA) PRIVATE LIMITED",
"ABHYOODAY EXIM PRIVATE LIMITED",
"ABHYUDAY BHARAT PROJECTS PRIVATE LIMITED",
"ABHYUDAY JEWELS PRIVATE LIMITED",
"ABHYUDAY MOTOR SERVICES PRIVATE LIMITED",
"ABHYUDAYA CO-OPERATIVE BANK LIMITED",
"ABHYUDAYA EDUCATION SOCIETY ENGLISH PRIMARY SCHOOL",
"ABHYUDAYA FARMS PRIVATE LIMITED",
"ABHYUDAYA GREEN ECONOMIC ZONES PRIVATE LIMITED",
"ABHYUDAYA HOUSING AND CONSTRUCTIONS PRIVATE LIMITED",
"ABHYUDAYA HR BUSINESS SOLUTIONS PRIVATE LIMITED",
"ABHYUDAYA TELE-INFRA & CONSULTANTS PRIVATE LIMITED",
"ABHYUT ENGINEERING PRIVATE LIMITED",
"ABI ANALYTICS PRIVATE LIMITED",
"ABI AND ABI GROUP OF COMPANIES INSTITUTIONS AND MEDIA",
"ABI AND ABI MARKETING PRIVATE LIMITED",
"ABI CONFECTIONERY PRIVATE LIMITED",
"ABI ENERGY CONSULTANCY SERVICES PRIVATE LIMITED",
"ABI ENGINEERING",
"ABI ESTATES PRIVATE LIMITED",
"ABI INSTRUMENTS PRIVATE LIMITED",
"ABI KIRAN AGRO FARMS ASIA PRIVATE LIMITED",
"ABI MICROFORMS AND INTERGRATED CIRUCITS PRIVATE LIMITED",
"ABI REALTORS PRIVATE LIMITED",
"ABI SHOWATECH INDIA LIMITED",
"ABI TOURS AND TRAVELS",
"ABIA PHARMACEUTICALS PRIVATE LIMITED",
"ABIBA PHARMACIA PRIVATE LIMITED",
"ABIBA SYSTEMS PRIVATE LIMITED",
"ABICEE PHARMACEUTICALS PVT LTD",
"ABICOR BINZEL PRODUCTION INDIA PRIVATE LIMITED",
"ABICOR BINZEL TECHNOWELD PRIVATE LIMITED",
"ABID REFRIGERATION & ENGINEERING PRIVATE LIMITED",
"ABIDE CONSULTANCY SERVICES PRIVATE LIMITED",
"ABIEL LANDMARKS PRIVATE LIMITED",
"ABIGAIL ENTERPRISES PRIVATE LIMITED",
"ABIGAIL REGENCY PRIVATE LIMITED",
"ABI-HEALTH TECHNOLOGIES PRIVATE LIMITED",
"ABIJIT SOLAR ENERGY PRIVATE LIMITED",
"ABIKIRAN CARS PRIVATE LIMITED",
"ABIKRISHNA RUBBER PRODUCTS PRIVATE LIMITED",
"ABIL CHEMPHARMA PRIVATE. LIMITED.",
"ABIL CORPORATION PRIVATE LIMITED",
"ABIL HOUSE",
"ABIL INFRAPROJECTS PRIVATE LIMITED",
"ABIL INFRASTRUCTURE PRIVATE LIMITED",
"ABIL REALTY PRIVATE LIMITED",
"ABILASH RAMAKRISHNA HASSAN",
"ABILITIES INDIA PISTONS & RINGS LIMITED",
"ABILITY ENGINEERING PRIVATE LIMITED",
"ABILITY GAMES LIMITED",
"ABILITY PROSTHETICS & ORTHOTICS PRIVATE LIMITED",
"ABILITY TECHNOCAST PRIVATE LIMITED",
"ABIMA YARN SPINTEX PRIVATE LIMITED",
"ABINANDAN HOLDINGS PVT LTD",
"ABIOGENESIS CLINPHARM PRIVATE LIMITED",
"ABIPET TECHNOLOGIES PRIVATE LIMITED",
"ABIR CASHEW PRIVATE LIMITED",
"ABIR DISTILLERS AND BOTTLERS PRIVATE LIMITED",
"ABIR INFRASTRUCTURE PRIVATE LIMITED",
"ABIR NETWORKS PRIVATE LIMITED",
"ABIRA NIRMAN UDYOG LIMITED",
"ABIRA SECURITIES LIMITED",
"ABIRAAJA VENTURES PRIVATE LIMITED",
"ABIRAMI ELECTRONICS PRIVATE LIMITED",
"ABIRAMI ENGINEERING CONSTRUCTION & CO.",
"ABIRAMI METAL FABS PRIVATE LIMITED",
"ABIRAMI PAPERS AND BOARDS PRIVATE LIMITED",
"ABIRAMI POLYMERS",
"ABIRAMI TECHNOLOGIES PRIVATE LIMITED",
"ABIS AGROTECH PRIVATE LIMITED",
"ABIS EXPORTS (INDIA) PRIVATE LIMITED",
"ABIS HATCHERY PRIVATE LIMITED",
"ABISHAR TECHNOLOGIES PRIVATE LIMITED",
"ABISHAYYA ENTERPRISES PRIVATE LIMITED",
"ABISKY-RITKRITI PROJECTS KESHAVNAGAR LIMITED LIABILITY PARTNERSHIP",
"ABISOL ENTERPRISES PRIVATE LIMITED",
"ABISTAR WORLDWIDE SHIPPING AND LOGISTICS PRIVATE LMITED",
"ABIZ PHARMA PRIVATE LIMITED",
"ABIZCON CONTRACT SERVICES AND CONSULTING PRIVATE LIMITED",
"ABJA POWER PRIVATE LIMITED",
"ABJAYON CONSULTANCY PRIVATE LIMITED",
"ABJIBAPA BUILDCON PRIVATE LIMITED",
"ABJIBAPA PROJECTS PRIVATE LIMITED",
"ABK IMPORTS PRIVATE LIMITED",
"ABK LOGISTICS INDIA PRIVATE LIMITED",
"ABK NIRMITI PRIVATE LIMITED",
"ABK SOFTWARE SERVICES PRIVATE LIMITED",
"ABKASA DESIGNER APPARELS PRIVATE LIMITED",
"ABKE READYMIX PRIVATE LIMITED",
"ABKJ INFRASTRUCTURE AND DESIGN SOLUTIONS PRIVATE LIMITED",
"ABKO ENGLISH ACADEMY",
"ABL BIOSCIENCES PRIVATE LIMITED",
"ABL ENERGY AND MARINE CONSULTANTS INDIA PRIVATE LIMITED",
"ABL ENTERPRISES PRIVATE LIMITED",
"ABL INFRASTRUCTURE PRIVATE LIMITED",
"ABL LIFECARE PRIVATE LIMITED",
"ABL LOGISTICS PRIVATE LIMITED",
"ABLAZE ELECTRONICS PRIVATE LIMITED",
"ABLAZE GLASS WORKS PRIVATE LIMITED",
"ABLAZE INDUSTRIES INDIA PRIVATE LIMITED",
"ABLAZE POLYMER LINING AND COATING PRIVATE LIMITED",
"ABLAZE WEIGH INDIA PRIVATE LIMITED",
"ABLE DIAGNOSTIC SYSTEMS PRIVATE LIMITED",
"ABLE HEALTHCARE SYSTEMS PRIVATE LIMITED",
"ABLE INDUSTRIES PRIVATE LIMITED",
"ABLE OILS AND AGRO PRIVATE LIMITED",
"ABLE SHOE MACHINERY PRIVATE LIMITED",
"ABLEGRANGE DEVELOPERS PRIVATE LIMITED",
"ABLERS SERVICES PRIVATE LIMITED",
"ABLES INDIA AUTO PRIVATE LIMITED",
"ABLETECH ELECTRO ENGINEERS PRIVATE LIMITED",
"ABLOY HIGH SECURITY LOCKS PRIVATE LIMITED",
"ABLROOTS INDUSTRIES PRIVATE LIMITED",
"ABLY SOFT PRIVATE. LIMITED.",
"ABM 4 BUILDERS",
"ABM CIVIL VENTURES PRIVATE LIMITED",
"ABM COMMUNICATION PRIVATE LIMITED",
"ABM COOLING SOLUTIONS INDIA PRIVATE LIMITED",
"ABM ENTERPRISES PRIVATE LIMITED",
"ABM GREEN POWER PRIVATE LIMITED",
"ABM INFOCOM PRIVATE LIMITED",
"ABM INTERNATIONAL LIMITED",
"ABM KNOWLEDGEWARE LIMITED",
"ABM PIZZA PRIVATE LIMITED",
"ABM RUBBER INDUSTRIES PRIVATE LIMITED",
"ABM STEEL SUPPLIERS PRIVATE LIMITED",
"ABM STEELS PRIVATE. LIMITED",
"ABM TELE MOBILES INDIA PRIVATE LIMITED",
"ABM TRANSLINE PRIVATE LIMITED",
"ABM TRAVEL & TOURS PRIVATE. LIMITED.",
"AB-MARKOSYS PRIVATE LIMITED",
"ABML AIR CARGO PRIVATE LIMITED",
"ABMM MAHESHWARI RELIEF FOUNDATION",
"ABMS PARISHAD LAW COLLEGE PUNE",
"ABN AUTOMOBILES PRIVATE LIMITED",
"ABN CORPORATE SOLUTIONS PRIVATE LIMITED",
"ABN EQUIPMENTS AND SYSTEMS PRIVATE LIMITED",
"ABN FABRICATORS PRIVATE LIMITED",
"ABN IMPEX PRIVATE LIMITED",
"ABN INDIAN BIOTECH PRIVATE LIMITED",
"ABN INTERARCH PRIVATE LIMITED",
"ABN TEXTILES (INDIA) PRIVATE LIMITED",
"ABN TOWER AND TRANSMISSION PRIVATE LIMITED",
"ABNC PROPERTY MANAGEMENT PRIVATE LIMITED",
"ABNCO LOGISTICS PRIVATE LIMITED",
"ABNCO VIE WIN ENT PRIVATE LIMITED",
"ABNL INVESTMENT LIMITED",
"ABNM RESTAURANT PRIVATE LIMITED",
"ABNOLL HEALTHCARE PRIVATE LIMITED",
"ABODANA HOTELS PRIVATE LIMITED",
"ABODE BUILDERS AND DEVELOPERS PVT LTD",
"ABODE INFRA PROJECTS INDIA PRIVATE LIMITED",
"ABODEX PROCESS SYSTEMS PRIVATE LIMITED",
"ABOHAR POWER GENERATION PRIVATE LIMITED",
"ABOK SPRING PRIVATE LIMITED",
"ABOLI INVESTMENT PRIVATE LIMITED",
"ABONE SURGICALS PRIVATE LIMITED",
"ABOTTS CONSULTING INDIA PRIVATE LIMITED",
"ABOUND ERP PRIVATE LIMITED",
"ABOVE AND BEYOND CONFRA PRIVATE LIMITED",
"ABOVE SOLUTIONS INDIA PRIVATE LIMITED",
"ABOVEO SERVICES PRIVATE LIMITED",
"ABOX PAPERPACK PRIVATE LIMITED",
"ABP CREATIONS PRIVATE LIMITED",
"ABP ENERGYTEK INDUSTRIES PRIVATE LIMITED",
"ABP EVENTURES PRIVATE LIMITED",
"ABP IMAGING TECHNOLOGIES PRIVATE LIMITED",
"ABP INDUCTION SYSTEMS PRIVATE LIMITED",
"ABP MODULER FURNITURE PRIVATE LIMITED",
"ABP NETWORK PRIVATE LIMITED",
"ABP PRIVATE LIMITED",
"ABP SKILL SERVICES PRIVATE LIMITED",
"ABP TRAVELS AND FACILITY MANAGEMENT PRIVATE LIMITED",
"ABP VENTURES PRIVATE LIMITED",
"ABPL EMPIRE PRIVATE LIMITED",
"ABPP PAPERS PRIVATE LIMITED",
"ABPS INFRASTRUCTURE ADVISORY PRIVATE LIMITED",
"ABPS SOLUTION PRIVATE LIMITED",
"ABR AUTO PRIVATE LIMITED",
"ABR CAFE AND BAKERS PRIVATE LIMITED",
"ABR ENTREPRENEUR SERVICES PRIVATE LIMITED",
"ABR HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"ABR INFRASOLUTIONS PRIVATE LIMITED",
"ABR LOGISTICS PRIVATE LIMITED",
"ABR MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"ABR PETRO PRODUCTS LTD",
"ABR ROADLINES PRIVATE LIMITED",
"ABRA COTTON CREATIONS PRIVATE LIMITED",
"ABRA EXPORTS PRIVATE LIMITED",
"ABRA HOTELS PRIVATE LIMITED",
"ABRA MOTORS PRIVATE LIMITED",
"ABRABLAST EQUIPMENT PRIVATE LIMITED",
"ABRAHAM & THAKORE EXPORTS",
"ABRAHAM AND THOMAS ENGINEERS PRIVATE LIMITED",
"ABRAM BUILDTECH PRIVATE LIMITED",
"ABRAM FOOD PRIVATE LIMITED",
"ABRAM UDYOG PRIVATE LIMITED",
"ABRAR VENTURES PRIVATE LIMITED",
"ABRARI GADJET TRADING PRIVATE LIMITED",
"ABRASIVE ENGINEERS PRIVATE LIMITED",
"ABRASSIVE EMERY INDUSTRIES LIMITED",
"ABRECO FREIGHT PRIVATE LIMITED",
"ABRECO TRADERS PRIVATE LIMITED",
"ABRECO TRANSPORTS PRIVATE LIMITED",
"ABREF PRIVATE LIMITED.",
"ABREL SPV 2 LIMITED",
"ABRENTE LIFESCIENCES PRIVATE LIMITED",
"ABRIA INDUSTRIES PRIVATE LIMITED",
"ABRICATE ENGINEERING PRIVATE LIMITED",
"ABRIK REMEDIES PRIVATE LIMITED",
"ABRIVIAR CLOTHINGS PRIVATE LIMITED",
"ABRM CONSTRUCTION MATERIAL PRIVATE LIMITED",
"ABRO CHIMIQUE PRIVATE LIMITED",
"ABRO TECHNOLOGIES PRIVATE LIMITED",
"ABROAD VITRIFIED PRIVATE LIMITED",
"ABROL ENGINEERING COMPANY PRIVATE LIMITED",
"ABROL WATCHES PRIVATE LIMITED",
"ABROSIA HOSPITALITY PRIVATE LIMITED",
"ABS AIR TECH PRIVATE LIMITED",
"ABS BUSINESS SERVICES PRIVATE LIMITED",
"ABS CHANNEL PLUS VISUAL MEDIA ADVERTISING PRIVATE LIMITED",
"ABS CONNECT PTE LTD",
"ABS ELECTROPLATERS INDIA PRIVATE LIMITED",
"ABS ENVIRO TECH INDIA PRIVATE LIMITED",
"ABS FOODS LIMITED",
"ABS FUJITSU GENERAL PRIVATE LIMITED",
"ABS GLOBAL SMART SCHOOL",
"ABS GROUP OF SCHOOLS",
"ABS INDIA PRIVATE. LIMITED.",
"ABS INDUSTRIAL VERIFICATION INDIA PRIVATE LIMITED",
"ABS INSTRUMENTS PRIVATE LIMITED",
"ABS INTERNATIONAL PRIVATE LIMITED",
"ABS LOGISTICS PRIVATE LIMITED",
"ABS MARINE SERVICES LIMITED",
"ABS MARINE SERVICES PRIVATE LIMITED",
"ABS MERCHANT PRIVATE LIMITED",
"ABS PRECISION PRIVATE LIMITED",
"ABS PRIMA PRIVATE LIMITED",
"ABS PROFESSIONAL SERVICES INDIA PRIVATE LIMITED",
"ABS REFRACTORIES PRIVATE LIMITED",
"ABS RENEW POWER PRIVATE LIMITED",
"ABS SEATING PRIVATE LIMITED",
"ABS TOOL AND DIE PRIVATE LIMITED",
"ABS TOUGHENED GLASSES PRIVATE LIMITED",
"ABSA INDIA INTERNATIONAL PRIVATE LIMITED",
"ABSAI FOODS PRIVATE LIMITED",
"ABSAS SOLUTIONS PRIVATE LIMITED",
"ABSC ENTERTAINMENT PRIVATE LIMITED",
"ABSCO LOGISTICS PRIVATE LIMITED",
"ABSENTIA VIRTUAL REALITY PRIVATE LIMITED",
"ABSK DIGITAL PRIVATE LIMITED",
"ABSL ENTERPRISES PRIVATE LIMITED",
"ABSOLENT FILTERMIST INDIA PRIVATE LIMITED",
"ABSOLINK ENTERPRISE PRIVATE LIMITED",
"ABSOLUT INFO SYSTEMS PRIVATE LIMITED",
"ABSOLUTDATA RESEARCH & ANALYTICS SOLUTIONS PRIVATE LIMITED",
"ABSOLUTE ABODES PRIVATE LIMITED",
"ABSOLUTE ARK PRIVATE LIMITED",
"ABSOLUTE AUTO PRIVATE LIMITED",
"ABSOLUTE BARBEQUE PRIVATE LIMITED",
"ABSOLUTE BEAUTY CONCEPTS PRIVATE LIMITED",
"ABSOLUTE BROADBAND COMMUNICATIONS PRIVATE LIMITED",
"ABSOLUTE BROADCAST PRIVATE LIMITED",
"ABSOLUTE BUSINESS PROCESS HOLDINGS PRIVATE LIMITED",
"ABSOLUTE COMPOSITES PRIVATE LIMITED",
"ABSOLUTE DISTRIBUTION SOLUTIONS PRIVATE LIMITED",
"ABSOLUTE ELECTROVISION PRIVATE LIMITED",
"ABSOLUTE ENTERTAINMENT PRIVATE LIMITED",
"ABSOLUTE FACILITIES PRIVATE LIMITED",
"ABSOLUTE FILTER SOLUTIONS PRIVATE LIMITED",
"ABSOLUTE GREEN POLYMERS PRIVATE LIMITED",
"ABSOLUTE HOMES PRIVATE LIMITED",
"ABSOLUTE IMAGING INTERNATIONAL (INDIA) PRIVATE LIMITED",
"ABSOLUTE INSURANCE SURVEYORS & LOSS ASSESSORS PRIVATE LIMITED",
"ABSOLUTE IT SOLUTIONS PRIVATE LIMITED",
"ABSOLUTE JOURNEY PRIVATE LIMITED",
"ABSOLUTE NETWORKS PRIVATE LIMITED",
"ABSOLUTE PROJECTS INDIA LIMITED",
"ABSOLUTE REPORTS PRIVATE LIMITED",
"ABSOLUTE RETURN FOR KIDS",
"ABSOLUTE RG EQUIPMENTS PRIVATE LIMITED",
"ABSOLUTE SECURITY AND FACILITY MANAGEMENT PRIVATE LIMITED",
"ABSOLUTE SPORTS PRIVATE LIMITED",
"ABSOLUTE STONES PRIVATE LIMITED",
"ABSOLUTE STUDIOS PRIVATE LIMITED",
"ABSOLUTE TALENT PRIVATE LIMITED",
"ABSOLUTE TECHNOLOGIES",
"ABSOLUTE WATER PRIVATE LIMITED",
"ABSOLUTE WEB RANKING PRIVATE LIMITED",
"ABSOLUTE WIRES PRIVATE LIMITED",
"ABSOLUTUS SOLITIO PRIVATE LIMITED",
"ABSOLVE MANAGEMENT SERVICES PRIVATE LIMITED",
"ABSON PROJECTS PRIVATE LIMITED",
"ABSOTHERM",
"ABSOTHERM FACILITY MANAGEMENT PRIVATE LIMITED",
"ABSP HOSPITALITY PRIVATE LIMITED",
"ABSR ENGINEERS & SERVICES PRIVATE LIMITED",
"ABSS CONSULTING SERVICES PRIVATE LIMITED",
"ABSSTEM TECHNOLOGIES LLP",
"ABSTERGE ACME FILTERS INDIA PRIVATE LIMITED",
"ABSTERGE REALESTATE PRIVATE LIMITED",
"ABSTRACT CREATIONS ART PRIVATE LIMITED",
"ABSTRACT MANNEQUINS PRIVATE LIMITED",
"ABSTURGO TECHNOLOGIES PRIVATE LIMITED",
"ABSUMA LOGISTICS INDIA PRIVATE LIMITED",
"ABSYZ SOFTWARE CONSULTING PRIVATE LIMITED",
"ABT ASSOCIATES INDIA PRIVATE LIMITED",
"ABT INDUSTRIES LIMITED",
"ABT SYSTEMS PRIVATE LIMITED",
"ABT UDYOG PRIVATE LIMITED",
"ABTEQ CONSULTANTS PRIVATE LIMITED",
"ABTON POWER DEVICES PRIVATE LIMITED",
"ABU DHABI COMMERCIAL BANK LIMITED",
"ABU ESTATE PRIVATE LIMITED",
"ABU GHAZALEH INTELLECTUAL PROPERTY TMP AGENTS INDIA PRIVATE LIMITED",
"ABU JANI SANDEEP KHOSLA",
"ABU SANDEEP DESIGNS PRIVATE LIMITED",
"ABU SANDEEP FASHIONS PRIVATE LIMITED",
"ABU SECURITIES PRIVATE LIMITED",
"ABUL HASSAN & BROTHERS PRIVATE LIMITED",
"ABUNDANCE RETAIL PRIVATE LIMITED",
"ABUNDANCE TOUJOURS PRIVATE LIMITED",
"ABUNDANT ENERGY PRIVATE LIMITED",
"ABUNDANTIA ENTERTAINMENT PRIVATE LIMITED",
"ABUTANI MERCANTILE PRIVATE LIMITED",
"ABUTANI VAAHAN PRIVATE LIMITED",
"ABV CONCEPTS PRIVATE LIMITED",
"ABV INDIAN INSTITUTE OF INFORMATION TECHNOLOGY AND MANAGEMENT GWALIOR",
"ABV MACHINE WORKS PRIVATE LIMITED",
"ABV RESOURCES PRIVATE LIMITED",
"ABVS ADVISORY SERVICES PRIVATE LIMITED",
"ABVS MEDIA NETWORK PRIVATE LIMITED",
"ABWATT SOLAR PRIVATE LIMITED",
"ABY BABY APPARELS PRIVATE LIMITED",
"ABYANTRA TECHNOLOGIES AND SOLUTIONS PRIVATE LIMITED",
"ABYBABY EVENTS PRIVATE LIMITED",
"ABYCONS TEXTILES PRIVATE LIMITED",
"ABYDOS TECHNOLOGIES PRIVATE LIMITED",
"ABYSS AND HORIZON CONSULTING PRIVATE LIMITED",
"ABYSS PHARMA PRIVATE LIMITED",
"ABZ AGRO FOODS LIMITED",
"ABZER TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"ABZOOBA INDIA INFOTECH PRIVATE LIMITED",
"AC AND DC ELECTRICAL PRIVATE LIMITED",
"AC CENTRE AND SCHOOL AHMEDNAGAR",
"AC CITY PROJECTS PRIVATE LIMITED",
"AC DIGITAL PRIVATE LIMITED",
"AC GOEL DISTRIBUTORS PRIVATE LIMITED",
"ACA CASHEW FRESH PRIVATE LIMITED",
"ACACIA BIOTECH LIMITED",
"ACACIA FASHIONS PRIVATE LIMITED",
"ACACIA LIFE SCIENCES PRIVATE LIMITED",
"ACADECRAFT PRIVATE LIMITED",
"ACADEMIC CITY EDU SERVICES PRIVATE LIMITED",
"ACADEMIC HEIGHTS PUBLIC SCHOOL",
"ACADEMIC HIGH & JUNIOR COLLEGE",
"ACADEMY",
"ACADEMY FOR COMPUTER TRAINING (GUJ) PRIVATE LIMITED",
"ACADEMY FOR CREATIVE TEACHING INDIA PRIVATE LIMITED",
"ACADEMY FOR GLOBAL EDUCATION SERVICES PRIVATE LIMITED",
"ACADEMY FOR MEDIA LEARNING PRIVATE LIMITED",
"ACADEMY NEWSPAPERS PRIVATE LIMITED",
"ACADEMY OF CARVER AVIATION PRIVATE LIMITED",
"ACADEMY OF COMMERCE STUDIES PRIVATE LIMITED",
"ACADEMY OF MARTIME EDUCATION AND TRAINING",
"ACADEMY OF RADIO STUDIES PRIVATE LIMITED",
"ACADEMY OF STEM INDIA",
"ACADEMY SCHOOL",
"ACADIAN SEAPLANTS INDIA PRIVATE LIMITED",
"ACADMART SOLUTIONS PRIVATE LIMITED",
"ACADS360 INDIA PRIVATE LIMITED",
"ACAIPL INVESTMENT & FINANCIAL SERVICES PRIVATE LIMITED",
"ACAJU PROCESSING PRIVATE LIMITED",
"ACAMBIS HELPLINE MANAGEMENT PRIVATE LIMITED",
"ACAMS GRC INDIA LLP",
"ACANTHUS ASSOCIATES PRIVATE LIMITED",
"ACAO COMMISSIONERATE OF CUSTOMS HQ",
"ACAO HQ CGST COMMISSIONERATE MUMBAI",
"ACAO HQ CGST COMMISSIONERATE PUNE I",
"ACAP SOLUTIONS INDIA PRIVATE LIMITED",
"ACAPELLA FOODS AND RESTAURANTS PRIVATE LIMITED",
"ACARA BIOHERB PRIVATE LIMITED",
"ACARA SOLUTIONS INDIA PRIVATE LIMITED",
"A-CARE MEDISYSTEM PRIVATE LIMITED",
"ACARIO ENTERPRISES PRIVATE LIMITED",
"ACAS LOGISTICS SOLUTION PRIVATE LIMITED",
"ACAYA EXIMS PRIVATE LIMITED",
"ACB (INDIA) POWER LIMITED",
"ACB INDIA LIMITED",
"ACBEX GLOBAL PRIVATE LIMITED",
"ACC INDIA PRIVATE LIMITED",
"ACC LIMITED",
"ACC MINERAL RESOURCES LIMTED",
"ACC MINING PRIVATE LIMITED",
"ACC STEEL PRIVATE LIMITED",
"ACCARIO SOLUTIONS INDIA PRIVATE LIMITED",
"ACCE GLOBAL SOFTWARE PRIVATE LIMITED",
"ACCEDE HEALTHCARE (INDIA) PRIVATE LIMITED",
"ACCEDERE LIMITED",
"ACCEDIAN NETWORKS INDIA PRIVATE LIMITED",
"ACCEDO TECHNOLOGIES INDIA PRIVATE LIMITED",
"ACCEL BPO PRIVATE LIMITED",
"ACCEL HOLIDAYS PRIVATE LIMITED",
"ACCEL INDIA MANAGEMENT COMPANY PRIVATE LIMITED",
"ACCEL LIMITED",
"ACCEL MEDIA VENTURES LIMITED",
"ACCEL SHIPPING PRIVATE LIMITED",
"ACCELALPHA SOFTWARE PRIVATE LIMITED",
"ACCELCIA BUSINESS SERVICES INDIA PRIVATE LIMITED",
"ACCELDATA TECHNOLOGY PRIVATE LIMITED",
"ACCELERATE AUTOMOTIVES PRIVATE LIMITED",
"ACCELERATE MEDIA PRIVATE LIMITED",
"ACCELERATE MERCANTILE PRIVATE LIMITED",
"ACCELERATE PRODUCTX VENTURES PRIVATE LIMITED",
"ACCELERATED CLEANING SYSTEMS INDIA PRIVATE LIMITED",
"ACCELERATED DEVELOPMENT MACHINES PRIVATELIMITED",
"ACCELERATED GROWTH RESEARCH & DELIVERY CENTER PRIVATE LIMITED",
"ACCELERATOR ENTERPRISE PRIVATE LIMITED",
"ACCELERE DEVELOPMENT SOLUTIONS PRIVATE LIMITED",
"ACCELERE INFOSOFT PRIVATE LIMITED",
"ACCELERIZE 360 PRIVATE LIMITED",
"ACCELERON LABS PRIVATE LIMITED",
"ACCELETRADE TECHNOLOGIES PRIVATE LIMITED",
"ACCELIGENT BUSINESS SOLUTIONS PRIVATE LIMITED",
"ACCELIGIZE BUSINESS SERVICES PRIVATE LIMITED",
"ACCELINE DIGITAL MEDIA PRIVATE LIMITED",
"ACCELIRATE SOFTECH PRIVATE LIMITED",
"ACCELON TECHNOLOGIES PRIVATE LIMITED",
"ACCELOR FOOD TECH PRIVATE LIMITED",
"ACCELQ SOFTWARE SOLUTIONS INDIA PRIVATE LIMITED",
"ACCELTECH INFRACON & DEVELOPERS PRIVATE LIMITED",
"ACCELTREE SOFTWARE PRIVATE LIMITED",
"ACCELY CONSULTING INDIA PRIVATE LIMITED",
"ACCELY TECHNOLOGIES PRIVATE LIMITED",
"ACCELYA SERVICES INDIA PRIVATE LIMITED",
"ACCELYA SOLUTIONS INDIA LIMITED",
"ACCELYST SOLUTIONS PRIVATE LIMITED",
"ACCENDERE INFO TECHNOLOGIES PRIVATE LIMITED",
"ACCENDO TECHNOLOGIES PRIVATE LIMITED",
"ACCENT ADVISORY SERVICES PRIVATE LIMITED",
"ACCENT AGENCIES PRIVATE LIMITED",
"ACCENT AUTOMATION PRIVATE LIMITED",
"ACCENT BUILDERS PRIVATE LIMITED",
"ACCENT CERAMICS PRIVATE LIMITED",
"ACCENT CONTROLS PRIVATE LIMITED",
"ACCENT DEALTRADE PRIVATE LIMITED",
"ACCENT EQUITIES PRIVATE LIMITED",
"ACCENT HOTELS PRIVATE LIMITED",
"ACCENT INDUSTRIES LIMITED",
"ACCENT INFO MEDIA PRIVATE LIMITED",
"ACCENT MICROCELL LIMITED",
"ACCENT MICROCELL PRIVATE LIMITED",
"ACCENT MINMET RESOURCES PRIVATE LIMITED",
"ACCENT OVERSEAS PRIVATE LIMITED",
"ACCENT PROPERTIES PRIVATE LIMITED",
"ACCENT SOFTECH PRIVATE LIMITED",
"ACCENT STEELS INDIA PRIVATE LIMITED",
"ACCENT VYAPAAR PRIVATE LIMITED",
"ACCENTEK SOLUTIONS PRIVATE LIMITED",
"ACCENTIQA SYSTEMS PRIVATE LIMITED",
"ACCENTIUM WEB PRIVATE LIMITED",
"ACCENTIV INDIA PRIVATE LIMITED",
"ACCENTRIA SOLUTIONS PRIVATE LIMITED",
"ACCENTS CHENNAI PRIVATE LIMITED",
"ACCENTUATE BUSINESS SOLUTIONS PRIVATE LIMITED",
"ACCENTUATE HYGIENE PRODUCTS LLP",
"ACCENTUATE TRADECOM PRIVATE LIMITED",
"ACCENTURE HIGH PERFORMANCE DELIVERED",
"ACCENTURE OPERATIONS SERVICES PRIVATE LIMITED",
"ACCENTURE SERVICES PRIVATE LIMITED",
"ACCENTURE SOLUTIONS PRIVATE LIMITED",
"ACCEPT ORGANIC AND NATURAL PRODUCTS EXIM PRIVATE LIMITED",
"ACCERNAI SOFTWARE SOLUTIONS INDIA PRIVATE LIMITED",
"ACCESO MERCANDIN MARKETING PRIVATE LIMITED",
"ACCESS ASSET MANAGERS PRIVATE LIMITED",
"ACCESS AUTOMATION PRIVATE LIMITED",
"ACCESS BUILDCON EQUIPMENTS PRIVATE LIMITED",
"ACCESS COMPUTECH PVT LTD",
"ACCESS DATA SYSTEMS PRIVATE LIMITED",
"ACCESS DESIGN SOLUTIONS PRIVATE LIMITED",
"ACCESS DEVELOPER PRIVATE LIMITED",
"ACCESS DEVELOPMENT SERVICES",
"ACCESS DIAMONDS PRIVATE LIMITED",
"ACCESS EDUTECH PRIVATE LIMITED",
"ACCESS ENTERPRISES PRIVATE LIMITED",
"ACCESS EQUITY PRIVATE LIMITED",
"ACCESS HEALTHCARE SERVICES PRIVATE LIMITED",
"ACCESS HOSPITAL SUPPLY SOLUTIONS PRIVATE LIMITED",
"ACCESS HOSPITALITY MANAGEMENT PRIVATE LIMITED",
"ACCESS INFOTECH PRIVATE LIMITED",
"ACCESS INFOWAY",
"ACCESS INFRASTRUCTURE & TELE MEDIA PRIVATE LIMITED",
"ACCESS LIFE ASSISTANCE FOUNDATION",
"ACCESS LIVELIHOODS FOUNDATION",
"ACCESS MARKETING PVT LTD",
"ACCESS NET IT SOLUTIONS PRIVATE LIMITED",
"ACCESS PHARMACEUTICALS PRIVATE LIMITED",
"ACCESS PLATFORM EQUIPMENTS LIMITED",
"ACCESS RAPID TRANSIT SERVICES PRIVATE LIMITED",
"ACCESS RESEARCH LABS",
"ACCESS SERVICED OFFICES PRIVATE LIMITED",
"ACCESS SOLAR LIMITED",
"ACCESS TECHNICAL SOLUTIONS PRIVATE LIMITED",
"ACCESS WAREHOUSING PRIVATE LIMITED",
"ACCESS WELD TECHNOLOGIES PRIVATE LIMITED",
"ACCESSGLOBAL TECHNOLOGY PRIVATE LIMITED",
"ACCESSIBILITY IT WORLD PRIVATE LIMITED",
"ACCESSIBLE TECH SOLUTIONS PRIVATE LIMITED",
"ACCESSLINE LIMITED",
"ACCESSORIES INDIA PRIVATE LIMITED",
"ACCESSORIES OVERSEAS INDIA PRIVATE LIMITED",
"ACCESSPAY INDIA PRIVATE LIMITED",
"ACCEX SUPPLY CHAIN AND WAREHOUSING PRIVATE LIMITED",
"ACCHA JEE ON-LINE SHOPPING PRIVATE LIMITED",
"ACCHYUT PACKAGINGS PRIVATE LIMITED",
"ACCIDENT RELIEF CARE INDIA PRIVATE LIMITED",
"ACCIL AUTO STEELS PRIVATE LIMITED",
"ACCIL CORPORATION PRIVATE LIMITED",
"ACCIL STEEL PROCESSORS PRIVATE LIMITED",
"ACCION FRATERNA ECOLOGY CENTER",
"ACCION LABS INDIA PRIVATE LIMITED",
"ACCION TECHNICAL ADVISORS INDIA",
"ACCION TECHNOLOGIES PRIVATE LIMITED",
"ACCIONA CONSTRUCTION PRIVATE LIMITED",
"ACCIONA ENERGY INDIA PRIVATE LIMITED",
"ACCIONA WIND ENERGY PRIVATE LIMITED",
"ACCIVA TRAVELS PRIVATE LIMITED",
"ACCLAIM GLOBAL EDUCATION INDIA PRIVATE LIMITED",
"ACCLAIM MOTORS PRIVATE LIMITED",
"ACCLAIMED INFRA PROJECTS PRIVATE LIMITED",
"ACCLARIS BUSINESS SOLUTIONS PRIVATE LIMITED",
"ACCLIN PATH LABS INDIA PRIVATE LIMITED",
"ACCLIVITY INFRA PRIVATE LIMITED",
"ACCME (URVASHI PUMPS)ENGINEERS PRIVATE LIMITED",
"ACCO BRANDS INDIA PRIVATE LIMITED",
"ACCOCCA CONSTRUCTION PRIVATE LIMITED",
"ACCOLADE AMUSEMENT PRIVATE LIMITED",
"ACCOLADE ATELIER PRIVATE LIMITED",
"ACCOLADE BUILDERS AND SERVICES PRIVATE LIMITED",
"ACCOLADE ELECTRONICS PRIVATE LIMITED",
"ACCOLADE ENGINEERING PRIVATE LIMITED",
"ACCOLADE HOLDINGS PRIVATE LIMITED",
"ACCOLET ADVISORS PRIVATE LIMITED",
"ACCOLITE DIGITAL INDIA PRIVATE LIMITED",
"ACCOLITE SOFTWARE INDIA PRIVATE LIMITED",
"ACCOM MANAGEMENT SERVICES PRIVATE LIMITED",
"ACCOMBLISS PRIVATE LIMITED",
"ACCOMPANY ARTISTIC INFRASTRUCTURE PRIVATE LIMITED",
"ACCOMPLISH TRADES SOLUTIONS PRIVATE LIMITED",
"ACCONLINK SOLUTIONS PRIVATE LIMITED",
"ACCONTS OFFICER FOR SECRETARY P S C MP INDORE",
"ACCOONIO CUBE PRIVATE LIMITED",
"ACCOPS SYSTEMS PRIVATE LIMITED",
"ACCOR ADVANTAGE PLUS MARKETING INDIA PRIVATE LIMITED",
"ACCORD AUTOCOMP PRIVATE LIMITED",
"ACCORD AUTOMATION PRIVATE LIMITED",
"ACCORD BLUE PRIVATE LIMITED",
"ACCORD CERAMICS PRIVATE LIMITED",
"ACCORD CHEMCORP PRIVATE LIMITED",
"ACCORD COMMUNICATIONS LIMITED",
"ACCORD COMPUTECH PRIVATE LIMITED",
"ACCORD COMPUTERS PRIVATE LIMITED",
"ACCORD DISPLAY SERVICES PRIVATE LIMITED",
"ACCORD DISTILLERS & BREWERS PRIVATE LIMITED",
"ACCORD ELECTRO - TECHNICS PRIVATE LIMITED",
"ACCORD ELECTROPOWER PRIVATE LIMITED",
"ACCORD ELEVATORS INDIA PRIVATE LIMITED",
"ACCORD ENVIRO SYSTEMS INDIA PRIVATE LIMITED",
"ACCORD EQUIPS PRIVATE LIMITED",
"ACCORD ESTATES PVT LTD",
"ACCORD FINTECH PRIVATE LIMITED",
"ACCORD GLOBAL EXPRESS PRIVATE LIMITED",
"ACCORD GLOBAL LOGISTICS PRIVATE LIMITED",
"ACCORD GLOBAL TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"ACCORD HEALTHCARE LIMITED",
"ACCORD HOSPITALITY SERVICES PRIVATE LIMITED",
"ACCORD HOUSING PRIVATE LIMITED",
"ACCORD IDEATION PRIVATE LIMITED",
"ACCORD INDIA INTERNATIONAL PRIVATE LIMITED",
"ACCORD LAND DEVELOPERS PRIVATE LIMITED",
"ACCORD LASER MACHINING PRIVATE LIMITED",
"ACCORD LIFE SPEC PRIVATE LIMITED",
"ACCORD METAL INDIA PRIVATE LIMITED",
"ACCORD MULTI-SPECIALITY HOSPITAL",
"ACCORD PLUS CERAMICS PRIVATE LIMITED",
"ACCORD POLYPACK PRIVATE LIMITED",
"ACCORD POWER CONVERSION PRIVATE LIMITED",
"ACCORD PUBLIC RELATIONS PRIVATE LIMITED",
"ACCORD SECURITY AND ALLIED SERVICES PRIVATE LIMITED",
"ACCORD SHIP MANAGEMENT PRIVATE LIMITED",
"ACCORD SHIPPING AGENCIES INDIA PRIVATE LIMITED",
"ACCORD SOFTWARE AND SYSTEMS PRIVATE LIMITED",
"ACCORD SYNERGY LIMITED",
"ACCORD TECH PRIVATE LIMITED",
"ACCORD TELESERVICES PRIVATE LIMITED",
"ACCORD TOOLS AND ACCESSORIES PRIVATE LIMITED",
"ACCORD TRADING INDIA PRIVATE LIMITED",
"ACCORD TRANSFORMER & SWITCHGEAR PRIVATE LIMITED",
"ACCORD VITRIFIED PRIVATE LIMITED",
"ACCORD WATERTECH & INFRASTRUCTURE PRIVATE LIMITED",
"ACCORD212 HUMAN RESOURCE SOLUTIONS PRIVATE LIMITED",
"ACCORDD ORGANICS PRIVATE LIMITED",
"ACCORDIA GLOBAL COMPLIANCE GROUP (INDIA) PRIVATE LIMITED",
"ACCORDION TECHNOLOGY PRIVATE LIMITED",
"ACCOREZ TRAVEL SERVICES PRIVATE LIMITED",
"ACCORP PARTNERS PRIVATE LIMITED",
"ACCOST ENGINEERING INDIA PRIVATE LIMITED",
"ACCOST IMPEX PRIVATE LIMITED",
"ACCOSTS REMEDIES PRIVATE LIMITED",
"ACCOTAX ADVISORS PRIVATE LIMITED",
"ACCOUNT DEPARTMENT PANCHYAT SAMITI HATKANANGALE",
"ACCOUNTABILIT GDC INDIA PRIVATE LIMITED",
"ACCOUNTANT GENERALS OFFICE",
"ACCOUNTANTANYWHERE SERVICES PRIVATE LIMITED",
"ACCOUNTSWHIZ INDIA PRIVATE LIMITED",
"ACCPL TRAINING AND INFRA PRIVATE LIMITED",
"ACC-Q-DATA BPO INDIA LLP",
"ACCRA PAC INDIA PRIVATE LIMITED",
"ACCRA PROPERTIES PRIVATE LIMITED",
"ACCREATE ADDITIVE LABS PRIVATE LIMITED",
"ACCREDITED CONSULTANTS PRIVATE LIMITED",
"ACCRETE AUTOMATION INDIA PRIVATE LIMITED",
"ACCRETE CONSULTING ENGINEERS PRIVATE LIMITED",
"ACCRETE ELECTROMECH PRIVATE LIMITED",
"ACCRETE EXECUTIVE SEARCH PRIVATE LIMITED",
"ACCRETE GLOBUS TECHNOLOGY PRIVATE LIMITE D",
"ACCRETE HEALTHCARE PRIVATE LIMITED",
"ACCRETE HITECH SOLUTIONS PRIVATE LIMITED",
"ACCRETE INNOVATIONS PRIVATE LIMITED",
"ACCRETE PHARMACEUTICALS PRIVATE LIMITED",
"ACCRETION ENGINEERS PRIVATE LIMITED",
"ACCRETION NUTRAVEDA PRIVATE LIMITED",
"ACCRETIVE TECHNOLOGIES PRIVATE LIMITED",
"ACCREVENT SOLUTIONS PRIVATE LIMITED",
"ACCROPOLY METAL INDUSTRIES PRIVATE LIMITED",
"ACCROPOLY NINOMIYA INDUSTRIES PRIVATE LIMITED",
"ACCRUAL REALITIES PRIVATE LIMITED",
"ACCRUEPOLE PRIVATE LIMITED",
"ACCSOURCE KNOWLEDGE PROCESS OUTSOURCING PRIVATE LIMITED",
"ACCSOURCE KPO PRIVATE LIMITED",
"ACCSYS DOT COM STORE PRIVATE LIMITED",
"ACCTURA TECHNOLOGIES PRIVATE LIMITED",
"ACCU METALS PRIVATE LIMITED",
"ACCU PACK ENGINEERING PRIVATE LIMITED",
"ACCU SHARP CUTTING TOOLS PRIVATE LIMITED",
"ACCU TECH ENGINEERING PRIVATE LIMITED",
"ACCUBILLS HEALTHCARE SOLUTION",
"ACCUBITS TECHNOLOGIES PRIVATE LIMITED",
"ACCU-FIX PRECISION TOOLS PRIVATE LIMITED",
"ACCUFLEX CONSULTING PRIVATE LIMITED",
"ACCUFOX ENTERPRISES PRIVATE LIMITED",
"ACCUHEALTH SOLUTIONS PRIVATE LIMITED",
"ACCUISITE TECHNOLOGIES PRIVATE LIMITED",
"ACCULI LABS PRIVATE LIMITED",
"ACCULINE DIAGNOSTICS PRIVATE LIMITED",
"ACCULOGICX SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED",
"ACCULOGIX SOFTWARE SOLUTIONS PRIVATE LIMITED",
"ACCULYTIXS PRIVATE LIMITED",
"ACCUMAX LAB DEVICES PRIVATE LIMITED",
"ACCUMECH BUILDING SYSTEMS PRIVATE LIMITED",
"ACCUMEN WEALTH PRIVATE LIMITED",
"ACCUMETRIC SILICONES PRIVATE LIMITED",
"ACCUMIX PRIVATE LIMITED",
"ACCUNITE SOLUTIONS PRIVATE LIMITED",
"ACCUNITY HR SERVICES PRIVATE LIMITED",
"ACCUNOVA ENGINEERING PRIVATE LIMITED",
"ACCUPAK PRIVATE LIMITED",
"ACCU-PANELS ENERGY PRIVATE LIMITED",
"ACCUPAYD TECH PRIVATE LIMITED",
"ACCUPREC RESEARCH LABS PRIVATE LIMITED",
"ACCUPROBE HEALTHCARE AND DIAGNOSTICS PRIVATE LIMITED",
"ACCUR8 DIAMONDS PRIVATE LIMITED",
"ACCURA CAPITAL PRIVATE LIMITED",
"ACCURA CARE PHARMACEUTICALS PRIVATE LIMITED",
"ACCURA ENTERPRISES PRIVATE LIMITED",
"ACCURA INKS PRIVATE LIMITED",
"ACCURA MACHINE TOOLS PRIVATE LIMITED",
"ACCURA MARITIME SERVICES PRIVATE LIMITED",
"ACCURA MOULDS AND DIES INDIA PRIVATE LIMITED",
"ACCURA NETWORK MARKETING PRIVATE LIMITED",
"ACCURA ORGANIC FOODS",
"ACCURA PHARMAQUIP PRIVATE LIMITED",
"ACCURA POLYPLAST PRIVATE LIMITED",
"ACCURA POLYTECH PVT LTD",
"ACCURA REPROTECH PRIVATE LIMITED",
"ACCURA SHELVING SYSTEMS PRIVATE LIMITED",
"ACCURA SPECIALITY LABS PRIVATE LIMITED",
"ACCURA SPINTEX PRIVATE LIMITED",
"ACCURA VALVES PRIVATE LIMITED",
"ACCURA WELDRODS KOVAI PRIVATE LIMITED",
"ACCURACY SHIPPING LIMITED",
"ACCURAMECH INDUSTRIAL ENGINEERING PRIVATE LIMITED",
"ACCURANT ENGINEERS AND CONSULTANTS PRIVATE LIMITED",
"ACCURATE ANCILLARY PRODUCTS LIMITED",
"ACCURATE AUTO LATHES PVT LTD",
"ACCURATE BACKGROUND INDIA PRIVATE LIMITED",
"ACCURATE BALL INDUSTRIES P. LTD.",
"ACCURATE BILLING SERVICES PRIVATE LIMITED",
"ACCURATE BUILDTECH PRIVATE LIMITED",
"ACCURATE BYCYCLE PARTS PRIVATE LIMITED",
"ACCURATE CABLES PRIVATE LIMITED",
"ACCURATE CARGO CLEARING PRIVATE LIMITED",
"ACCURATE CASTALLOYS PRIVATE LIMITED",
"ACCURATE COMPUTER TECHNOLOGIES PRIVATE LIMITED",
"ACCURATE CONNECTING SYSTEMS PRIVATE LIMITED",
"ACCURATE COOLING PRIVATE LIMITED",
"ACCURATE CROP CARE PRIVATE LIMITED",
"ACCURATE CUTTING SYSTEMS PRIVATE LIMITED",
"ACCURATE DEVELOPERS PRIVATE LIMITED",
"ACCURATE DIAGNOSTICS PRIVATE LIMITED",
"ACCURATE DIMENSIONS PRIVATE LIMITED",
"ACCURATE DISTRIBUTORS PRIVATE LIMITED",
"ACCURATE ENGINEERING CO PRIVATE LIMITED",
"ACCURATE FABOX PRIVATE LIMITED",
"ACCURATE FINMAN SERVICES LIMITED",
"ACCURATE FLOORTEX PRIVATE LIMITED",
"ACCURATE FOODS & BEVERAGES PRIVATE LIMITED",
"ACCURATE FREIGHT CARRIERS PRIVATE LIMITED",
"ACCURATE GAUGING AND INSTRUMENTS PRIVATE LIMITED",
"ACCURATE GRAPHICS PRIVATE LIMITED",
"ACCURATE HELICAL SPRINGS PRIVATE LIMITED",
"ACCURATE HYDRAULICS PRIVATE LIMITED",
"ACCURATE INDUSTRIAL CONTROLS PRIVATE LIMITED",
"ACCURATE INFO SOFT PRIVATE LIMITED",
"ACCURATE INFRA INDUSTRIES PRIVATE LIMITED",
"ACCURATE INTEGRATED CONSULTANCY PRIVATE LIMITED",
"ACCURATE LABELS PRIVATE LIMITED",
"ACCURATE MACHINES AND ACCESSORIES PRIVATE LIMITED",
"ACCURATE MAINTENANCE CO PRIVATE LIMITED",
"ACCURATE MARK-INVEST PRIVATE LIMITED",
"ACCURATE MATERIAL HANDLERS PRIVATE LIMITED",
"ACCURATE MEDICARE & DIAGNOSTIC PRIVATE LIMITED",
"ACCURATE OPTOELECTRONICS PRIVATE LIMITED",
"ACCURATE PMS PRIVATE LIMITED",
"ACCURATE POLYMERS PRIVATE. LIMITED.",
"ACCURATE POWERTECH INDIA PRIVATE LIMITED",
"ACCURATE PRINTPACK PRIVATE LIMITED",
"ACCURATE PRODUCTS CORPORATION PRIVATE LIMITED",
"ACCURATE RESOLUTION SERVICES PRIVATE LIMITED",
"ACCURATE RINGS PRIVATE LIMITED",
"ACCURATE RISK MANAGERS & INSURANCE BROKERS PRIVATE LIMITED",
"ACCURATE SALESANDSERVICES PRIVATE LIMITED",
"ACCURATE SENSING TECHNOLOGIES PRIVATE LIMITED",
"ACCURATE SOLUTION PROVIDERS PRIVATE LIMITED",
"ACCURATE SPRINGS PRIVATE LIMITED",
"ACCURATE STEEL FORGINGS INDIA LIMITED",
"ACCURATE STRIPS PRIVATE LIMITED",
"ACCURATE SURVEILLANCE INDIA PRIVATE LIMITED",
"ACCURATE TECHNO SOLUTIONS PRIVATE LIMITED",
"ACCURATE TECHNOCAST PRIVATE LIMITED",
"ACCURATE THERMAL SPRAY PRIVATE LIMITED",
"ACCURATE TOOLS PVT LTD",
"ACCURATE TRANSHEAT PVT LTD",
"ACCURATE TURNERS PVT LTD",
"ACCURATE WEAVE PRIVATE LIMITED",
"ACCURATE WELDARC PRIVATE LIMITED",
"ACCURATE WOOD WORKS PRIVATE LIMITED",
"ACCURAY MEDICAL EQUIPMENT INDIA PRIVATE LIMITED",
"ACCURE LABS PRIVATE LIMITED",
"ACCURE MEDICAL PRIVATE LIMITED",
"ACCURE POWER TECHNOLOGIES PRIVATE LIMITED",
"ACCUREX BIOMEDICAL PRIVATE LIMITED",
"ACCUREX SOFTWARE PRIVATE LIMITED",
"ACCUREX SOLUTIONS PRIVATE LIMITED",
"ACCURICS INDIA PRIVATE LIMITED",
"ACCURIGHT INFRA PRIVATE LIMITED",
"ACCURIO HEALTH PRIVATE LIMITED",
"ACCURO SOLUTIONS PRIVATE LIMITED",
"ACCURPRESS INDIA MACHINERY PRIVATE LIMITED",
"ACCUSOL TECHNOLOGIES PRIVATE LIMITED",
"ACCUSONIC CONTROLS PVT LTD",
"ACCUSPEED ENGINEERING SERVICES INDIA PRIVATE LIMITED",
"ACCUSPRING HEALTHCARE PRIVATE LIMITED",
"ACCUSTER TECHNOLOGIES PRIVATE LIMITED",
"ACCUSTRUCT ENGINEERS PRIVATE LIMITED",
"ACCUTE HEALTHCARE PRIVATE LIMITED",
"ACCUTE LASER DIE PRIVATE LIMITED",
"ACCUTECH AGRO PRIVATE LIMITED",
"ACCUTECH AIRCOOL PRIVATE LIMITED",
"ACCUTECH DIGITAL REVIEW LLP",
"ACCUTECH ENGINEERS PRIVATE LIMITED",
"ACCUTECH INFOSYSTEMS PRIVATE LIMITED",
"ACCUTECH LASER PRIVATE LIMITED",
"ACCUTECH PACKAGING PRIVATE LIMITED",
"ACCUTECH POWER SOLUTIONS PRIVATE LIMITED",
"ACCUTECH TECHNOLOGIES PRIVATE LIMITED",
"ACCUTECH TOOL CRAFTS PRIVATE LIMITED",
"ACCUTEK SERVICES PRIVATE LIMITED",
"ACCUTEST BIOLOGICS PRIVATE LIMITED",
"ACCUTEST RESEARCH LABORATORIES INDIA PRIVATE LIMITED",
"ACCUTIME LOGISTICS PRIVATE LIMITED",
"ACCUTIME SOFTWARE PRIVATE LIMITED",
"ACCUTRANS PRIVATE LIMITED",
"ACCUWELL MEDICS PRIVATE LIMITED",
"ACCUWRITE STATIONERY PRODUCTS",
"ACCVEIL SOLUTIONS PRIVATE LIMITED",
"ACCVEN SOLUTIONS PRIVATE LIMITED",
"ACCVEN TECHNOLOGIES PRIVATE LIMITED",
"ACD AUTOMATION PRIVATE LIMITED",
"ACD MACHINE CONTROL COMPANY PRIVATE LIMITED",
"ACDC POWERCARE PRIVATE LIMITED",
"ACDC SAIDEEP BUILDCON PRIVATE LIMITED",
"ACE ACOUSTICS AND AUDIO VIDEO SOLUTIONS PRIVATE LIMITED",
"ACE ALLIANCE PRIVATE LIMITED",
"ACE ANTENNA INDIA PRIVATE LIMITED",
"ACE AUTOMATIONS PRIVATE LIMITED",
"ACE AUTOMOBILES PRIVATE LIMITED",
"ACE BASE COLONIZERS AND DEVELOPERS PRIVATE LIMITED",
"ACE BEVERAGEZ PRIVATE LIMITED",
"ACE BIO MED PRIVATE LIMITED",
"ACE BPO SERVICES PRIVATE LIMITED",
"ACE BRAIN SYSTEMS AND SOFTWARE PRIVATE LIMITED",
"ACE BRAIN TECHNOLOGIES PRIVATE LIMITED",
"ACE BUILD PRIVATE LIMITED",
"ACE BUYING AGENCY PRIVATE LIMITED",
"ACE CABS PRIVATE LIMITED",
"ACE CARBIDE TOOLS PRIVATE LIMITED",
"ACE CARDIOPATHY SOLUTIONS PRIVATE LIMITED",
"ACE CATERING SERVICES OPC PRIVATE LIMITED",
"ACE CHEMICALS COMPANY PRIVATE LIMITED",
"ACE CLAVAX SOLUTIONS PRIVATE LIMITED",
"ACE CLOTHING COMPANY PRIVATE LIMITED",
"ACE COATING INDIA PRIVATE LIMITED",
"ACE COMMERCIAL CO PRIVATE LIMITED",
"ACE COPIERS PRIVATE LIMITED.",
"ACE COTTON GURU PRIVATE LIMITED",
"ACE CUSTOMER SERVICE PRIVATE LIMITED",
"ACE DATA DEVICES PRIVATE LIMITED",
"ACE DERIVATIVES COMMODITY EXCHANGE",
"ACE DESIGNERS LIMITED",
"ACE DISTRIBUTORS PRIVATE LIMITED",
"ACE ECO BLOCKS PRIVATE LIMITED",
"ACE ELECTRICAL EQUIPMENTS (INDIA) PRIVATE LIMITED",
"ACE ELECTROTREND PANELS PRIVATE LIMITED",
"ACE EMBEDDED INTENSIVE CARE UNITS PRIVATE LIMITED",
"ACE ENERGY INFRASTRUCTURE PRIVATE LIMITED",
"ACE ENGINEERING COLLEGE",
"ACE ENGINEERING EDUCATION INDIA PRIVATE LIMITED",
"ACE ENGINEERING SOLUTIONS INDIA PRIVATE LIMITED",
"ACE ENGINEERING SYSTEMS AND EQUIPMENTS PRIVATE LIMITED",
"ACE ENGINEERING TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"ACE ENGINEERINGS & CHEMICALS PRIVATE LIMITED",
"ACE ENTERPRISES",
"ACE ENVIRO TECH PRIVATE LIMITED",
"ACE EQUITY SOLUTIONS PRIVATE LIMITED",
"ACE EXPERIENCES ASIA PRIVATE LIMITED",
"ACE EXPORTS LIMITED",
"ACE EXPRESS LOGISTICS PRIVATE LIMITED",
"ACE EXTRUSIONS PRIVATE LIMITED",
"ACE FABRICS LLP",
"ACE FACILITY MANAGEMENT PRIVATE LIMITED",
"ACE FASTENING SOLUTIONS PRIVATE LIMITED",
"ACE FEEDS PRIVATE LIMITED",
"ACE FINDISTRIA INDIA PRIVATE LIMITED",
"ACE FINEPACK PRIVATE LIMITED",
"ACE FINLEASE PRIVATE LIMITED",
"ACE FLEXI PACK PRIVATE LIMITED",
"ACE FLOW CONTROL PRIVATE LIMITED",
"ACE FOILS PRIVATE LIMITED",
"ACE FOODS PRIVATE. LIMITED.",
"ACE FORWARDERS PRIVATE LIMITED",
"ACE FURNACES PRIVATE LIMITED",
"ACE FURNITURE SOLUTIONS PRIVATE LIMITED",
"ACE GAS ANALYSERS PRIVATE LIMITED",
"ACE GAS CONVERSIONS PRIVATE LIMITED",
"ACE GLOBAL AIRCON SERVICES LIMITED",
"ACE GROUP ARCHITECTS PRIVATE LIMITED",
"ACE HARDWARE PRIVATE LIMITED",
"ACE HERO PAPERS PRIVATE LIMITED",
"ACE HOUSING AND CONSTRUCTION PRIVATE LIMITED",
"ACE HUMAN CAPITAL LIMITED",
"ACE HYGIENE PRODUCTS PRIVATE LIMITED",
"ACE INDIA OFFICE SOLUTIONS PRIVATE LIMITED",
"ACE INDUSTRIAL GASES PRIVATE LIMITED",
"ACE INDUSTRIES (INDIA) PRIVATE LIMITED",
"ACE INFO SYSTEMS",
"ACE INFOBAHN PRIVATE LIMITED",
"ACE INFOTEXIS PRIVATE LIMITED",
"ACE INFOWAY PRIVATE LIMITED",
"ACE INFRA & SECURITY PRIVATE LIMITED",
"ACE INFRACITY DEVELOPERS PRIVATE LIMITED",
"ACE INNOVATORS PRIVATE LIMITED",
"ACE INOTEC MANUFACTURING PRIVATE LIMITED",
"ACE INSURANCE BROKERS PRIVATE LIMITED",
"ACE INTEGRATED SOLUTIONS LIMITED",
"ACE INVESTMENT SERVICES (INDIA) PRIVATE LIMITED",
"ACE KARGOWAYS PRIVATE LIMITED",
"ACE KUDALE CAR PRIVATE LIMITED",
"ACE KUDALE CORPORATION LIMITED",
"ACE LANDCON PRIVATE LIMITED",
"ACE MAISON PRIVATE LIMITED",
"ACE MANUFACTURING SYSTEMS LIMITED",
"ACE MARINETECH",
"ACE MARKETING PRIVATE LIMITED",
"ACE MARMO PRIVATE LIMITED",
"ACE MEDIA SOLUTIONS PRIVATE LIMITED",
"ACE MEDICAL DEVICES PRIVATE LIMITED",
"ACE MEGA STRUCTURES PRIVATE LIMITED",
"ACE MEN ENGG WORKS LIMITED",
"ACE METAL TECHNOLOGIES PRIVATE LIMITED",
"ACE MICA PRIVATE LIMITED",
"ACE MICROMATIC INTERNATIONAL PRIVATE LIMITED",
"ACE MOTORS PRIVATE LIMITED",
"ACE MOULDINGS LIMITED",
"ACE MULTI AXES SYSTEMS LIMITED",
"ACE MULTIFREIGHT LOGISTICS PRIVATE LIMITED",
"ACE NONWOVEN PRIVATE LIMITED",
"ACE ORTHO CARE PRIVATE LIMITED",
"ACE PAN FUEL TECHNOLOGY PRIVATE LIMITED",
"ACE PAPER BOARD LIMITED",
"ACE PAPER EDGES PRIVATE LIMITED",
"ACE PAYXPRESS SERVICES PRIVATE LIMITED",
"ACE PERSONAL CARE PRODUCTS PRIVATE LIMITED",
"ACE PIPELINE CONTRACTS PRIVATE LIMITED",
"ACE PNEUMATICS PRIVATE LIMITED",
"ACE POLYBOND PRIVATE LIMITED",
"ACE POLYPLAST PRIVATE. LIMITED.",
"ACE PRO INDIA LLP",
"ACE PROCESS EQUIPMENT PRIVATE LIMITED",
"ACE PROMOTERS AND DEVELOPERS PRIVATE LIMITED",
"ACE REMEDIES PRIVATE LIMITED",
"ACE SEAFOOD BAZAAR PRIVATE LIMITED",
"ACE SEZ DEVELOPERS PRIVATE LIMITED",
"ACE SKILL DEVELOPMENT PRIVATE LIMITED",
"ACE SMART ADVERTISING PRIVATE LIMITED",
"ACE SOFTWARE EXPORTS LIMITED",
"ACE SOFTWARE SOLUTIONS I PRIVATE LIMITED",
"ACE STAR MANAGEMENT PRIVATE LIMITED",
"ACE STONE CRAFT LIMITED",
"ACE SYNERGIES AND HOLDINGS PVT. LTD.",
"ACE TECH PRODUCTS INDIA PRIVATE LIMITED",
"ACE TECH SYS PRIVATE LIMITED",
"ACE TECHNOCRATS PRIVATE LIMITED",
"ACE TECHNOLOGIES",
"ACE TECHNOLOGIES & INFRASTRUCTURE LIMITED",
"ACE TECHNOLOGIES & PACKAGING SYSTEMS PRIVATE LIMITED",
"ACE TECHNOMOLD PRIVATE LIMITED",
"ACE TELEVOICE AND SERVICES PRIVATE LIMITED",
"ACE TENNIS AND SPORTS ASSOCIATION",
"ACE TEXTILES PRIVATE LIMITED",
"ACE TYRES LIMITED",
"ACE TYRES PRIVATE LIMITED",
"ACE URBAN DEVELOPERS PRIVATE LIMITED",
"ACE URBAN HITECH CITY LIMITED",
"ACE URBAN INFOCITY LIMITED",
"ACE UTILITY & H R SOLUTION PRIVATE LIMITED",
"ACE VENTURES INDIA PRIVATE LIMITED",
"ACE WRITING INSTRUMENTS PRIVATE LIMITED",
"ACEANN LIFESTYLE PRIVATE LIMITED",
"ACEBO TECHNOLOGIES PRIVATE LIMITED",
"ACE-BYTES SERVICES AND COMPUTERS PRIVATE LIMITED",
"ACECHEMIE ZYNK ENERGY LIMITED",
"ACECON VITRIFIED PRIVATE LIMITED",
"ACECRETE ADHESIONS INDIA PRIVATE LIMITED",
"ACECULINAIRE HOSPITALITY PRIVATE LIMITED",
"ACEELENE SUITINGS PRIVATE LIMITED",
"ACEFONE SOFTWARE PRIVATE LIMITED",
"ACEINOTEC MANUFACTURING PRIVATE LIMITED",
"ACEINOX INDUSTRIES PRIVATE LIMITED",
"ACEIR BUILDING SOLUTIONS PRIVATE LIMITED",
"ACEIS SERVICES PRIVATE LIMITED",
"ACEKINETICS HEALTHCARE PRIVATE LIMITED",
"ACELERAR TECHNOLOGIES PRIVATE LIMITED",
"ACELINE INFO SOLUTIONS PRIVATE LIMITED",
"ACELINE TECH SOLUTIONS PRIVATE LIMITED",
"ACELINKERS CONSULTANCY SERVICES PRIVATE LIMITED",
"ACELLER STEELS PRIVATE LIMITED",
"ACELLERE SOFTWARE PRIVATE LIMITED",
"ACELUCID TECHNOLOGIES PRIVATE LIMITED",
"ACEMETRO ELECTRONICS INDIA PRIVATE LIMITED",
"ACEMICROMATIC MANUFACTURING INTELLIGENCE TECHNOLOGIES PRIVATE LIMITED",
"ACEMONEY INTERMEDIARIES PRIVATE LIMITED",
"ACENDO CAPITAL ADVISORS PRIVATE LIMITED",
"ACENET CONSULTING PRIVATE LIMITED",
"ACENGAGE INFOSERVICES PRIVATE LIMITED",
"ACENNA TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"ACENTRA HEALTH SOFTWARE INDIA PRIVATE LIMITED",
"ACEOLUTION INDIA PRIVATE LIMITED",
"ACEONE FUTURISTIC (OPC) PRIVATE LIMITED",
"ACEPRO FINANCE PRIVATE LIMITED",
"ACEPRO INTERNATIONAL PRIVATE LIMITED",
"ACER ENGINEERS PRIVATE LIMITED",
"ACER GRANITO PRIVATE LIMITED",
"ACER GREEN CARRIERS PRIVATE LIMITED",
"ACER INDIA PRIVATE LIMITED",
"ACER SOFTWARES PRIVATE LIMITED",
"ACERHEALTH ONESOURCE PRIVATE LIMITED",
"ACERINOX (INDIA) PRIVATE LIMITED",
"ACEROCK DEVELOPERS PRIVATE LIMITED",
"ACEROS OIL AND GAS EQUIPMENT PRIVATE LIMITED",
"ACERTEC TECHNOLOGIES PRIVATE LIMITED",
"ACES INDIA PRIVATE LIMITED",
"ACES INFOTECH PVT LTD",
"ACES INTACT PRIVATE LIMITED",
"ACESO POLYMERS PRIVATE LIMITED",
"ACESO TECHNOLOGIES PRIVATE LIMITED",
"ACESOFT LABS INDIA PRIVATE LIMITED",
"ACESPERA SYSTEMS PRIVATE LIMITED",
"ACESS MEDITECH PRIVATE LIMITED",
"ACESTACK LIMITED LIABILITY PARTNERSHIP",
"ACESTAR PROPERTIES PRIVATE LIMITED",
"ACET INFOTECH PRIVATE LIMITED",
"ACETEC AUTOMOTIVES PRIVATE LIMITED",
"ACETEC MOTORS PRIVATE LIMITED",
"ACETECH HEAVY FAB PRIVATE LIMITED",
"ACETECH REALTOR PRIVATE LIMITED",
"ACETECH TECHNOLOGIES PRIVATE LIMITED",
"ACETECHPEB SYSTEMS PRIVATE LIMITED",
"ACETEL ENTERPRISES PRIVATE LIMITED",
"ACETO PHARMA (INDIA) PRIVATE LIMITED",
"ACETO TEX-CHEM PRIVATE LIMITED",
"ACETOCHEM PRIVATE LIMITED",
"ACETRIX TECH SOLUTIONS LLP",
"ACETRON TRADE LLP",
"ACETYLENE TREXIM PVT LTD",
"ACEVECTOR LIMITED",
"ACEVISION CHEMICALS PRIVATE LIMITED",
"ACEVISION PUBLISHER PRIVATE LIMITED",
"ACEWORX SYNERGISTIC AGRIBUSINESS NETWORKS PRIVATE LIMITED",
"ACEY ENGINEERING PVT LTD",
"ACEZD CONSULTANCY SERVICES PRIVATE LIMITED",
"ACFTRUCK ENGINEERING PRIVATE LIMITED",
"ACG ASSOCIATED CAPSULES PRIVATE LIMITED",
"ACG CARES FOUNDATION",
"ACG INSPECTION SYSTEMS PRIVATE LIMITED",
"ACG METALCRAFTS PRIVATE LIMITED",
"ACG PAM PHARMA TECHNOLOGIES PRIVATE LIMITED",
"ACG PAMPAC MACHINES PRIVATE LIMITED",
"ACG PHARMA TECHNOLOGIES PRIVATE LIMITED",
"ACG PHARMAPACK PRIVATE LIMITED",
"ACG PRORELSYS PRIVATE LIMITED",
"ACG VALUE LINKS LLP",
"ACHAL CASHEWS PRIVATE LIMITED",
"ACHAL EXIM P LTD",
"ACHAL FARMPRODUCTS PRIVATE LIMITED",
"ACHAL INDUSTRIES PRIVATE LIMITED",
"ACHAL JEWELS PRIVATE LIMITED",
"ACHAL PRIMENUTS PRIVATE LIMITED",
"ACHAL SPINNING PRIVATE LIMITED",
"ACHAL VANIJYA PRIVATE LIMITED",
"ACHALA AGRO CHEMICALS PRIVATE LIMITED",
"ACHALA BUILDOGRAPHY PRIVATE LIMITED",
"ACHALA COMMERCIAL VENTURES PRIVATE LIMITED",
"ACHALA IT SOLUTIONS PRIVTAE LIMITED",
"ACHALAINFRA ESTATE PRIVATE LIMITED",
"ACHALARE REALTORS PRIVATE LIMITED",
"ACHALESHWAR INFRASTRUCTURE PRIVATE LIMITED",
"ACHALPUR NAGAR PARISHAD",
"ACHAMPET SOLAR PRIVATE LIMITED",
"ACHARAN PRINTERS PVT LTD",
"ACHARIYA EDUCATIONAL PUBLIC TRUST",
"ACHARIYA TECHNOLOGIES",
"ACHARIYA WORLD CLASS EDUCATION",
"ACHARYA BROTHERS CONSTRUCTION PRIVATE LIMITED",
"ACHARYA CHARAN MAHAPRABHU SHRIMAD BALLABH H S S C BAGH AURANGABAD MATHURA",
"ACHARYA INSTITUTE OF GRADUATE STUDIES",
"ACHARYA INSTITUTE OF HEALTH SCIENCES",
"ACHARYA INSTITUTE OF TECHNOLOGY",
"ACHARYA LUBE INDUSTRY PRIVATE LIMITED",
"ACHARYA N G RANGA AGRICULTURAL UNIVERSITY",
"ACHARYA NAGARJUNA UNIVERSITY",
"ACHARYA PATA SHALA COLLEGE",
"ACHARYA POLYTECHNIC",
"ACHARYA SHREE BHIKSHU GOVERNMENT HOSPITAL",
"ACHARYA SHRI NANESH HOSPITAL",
"ACHARYA SHRIMANNARAYAN POLYTECHNIC WARDHA",
"ACHARYA VINOBA BHAVE RURAL HOSPITAL SAWANGI (MEGHE) WARDHA",
"ACHARYAKULAM",
"ACHARYAS NRV SCHOOL OF ARCHITECTURE",
"ACHATES INTERNATIONAL PVT LTD",
"ACHBEE FOOD INDUSTRY PRIVATE LIMITED",
"A-CHECK GLOBAL SOLUTIONS PRIVATE LIMITED",
"ACHEET CTS PRIVATE LIMITED",
"ACHERON SERVICES PRIVATE LIMITED",
"ACHERON SOFTWARE CONSULTANCY PRIVATE LIMITED",
"ACHI HOSPITAL PRIVATE LIMITED",
"ACHIEVA HEALTHCARE PRIVATE LIMITED",
"ACHIEVA SCHOOL OF PROFESSIONAL STUDIES",
"ACHIEVE CYBERSECURITY SOLUTIONS INDIA PRIVATE LIMITED",
"ACHIEVE HYDRAULICS & PNEUMATICS PRIVATE LIMITED",
"ACHIEVE TECHNO CAST PRIVATE LIMITED",
"ACHIEVER APPARELS PRIVATE LIMITED",
"ACHIEVER CREATIONS PRIVATE LIMITED",
"ACHIEVER HOSPITALITY PRIVATE LIMITED",
"ACHIEVERS INDIA ADVERTISING PRIVATE LIMITED",
"ACHIEVERS VENTURES PRIVATE LIMITED",
"ACHIEVO ENGINEERING COMPONENTS PRIVATE LIMITED",
"ACHIEVO MULTI SOLUTIONS PRIVATE LIMITED",
"ACHIEVVERS JUNIOR COLLEGE",
"ACHIIEVERS EQUITIES LIMITED",
"ACHIIEVERS FINANCE INDIA PRIVATE LIMITED",
"ACHILLEA LIFE SCIENCES PRIVATE LIMITED",
"ACHILLES CHIT FUND PRIVATE LIMITED",
"ACHILLES INFORMATION INDIA PRIVATE LIMITED",
"ACHILLES TRADING PRIVATE LIMITED",
"ACHILLEZ TRANSCRIPTION SOLUTIONS INDIA PRIVATE LIMITED",
"ACHINDRA ONLINE MARKETING PRIVATE LIMITED",
"ACHINTYA COMMODITIES PRIVATE LIMITED",
"ACHINTYA HEALTHCARE PRIVATE LIMITED",
"ACHINTYA MANAGEMENT PRIVATE LIMITED",
"ACHINTYA SECURITIES PRIVATE LIMITED",
"ACHINTYA SOLAR POWER PRIVATE LIMITED",
"ACHIRA LABS PRIVATE LIMITED",
"ACHIVERS IT SOLUTION PRIVATE LIMITED",
"ACHME WATER SOLUTIONS PRIVATE LIMITED",
"ACHNERA COLD STORAGE PRIVATE LIMITED",
"ACHO PHARMA SURGICALS PRIVATE LIMITED",
"ACHOLE DEVELOPERS PRIVATE LIMITED",
"ACHRAJ AUTOTECH PRIVATE LIMITED",
"ACHROMIC POINT CONSULTING PRIVATE LIMITED",
"ACHU PRECISION COMPONENTS PRIVATE LIMITED",
"ACHYUT HEALTHCARE LIMITED",
"ACHYUT INSURANCE BROKERS INDIA PRIVATE LIMITED",
"ACHYUTA ACADEMY MATRIC HR SEC SCHOOL",
"ACHYUTA PUBLIC SCHOOL",
"ACHYUTAM ENGINEERING PRIVATE LIMITED",
"ACHYUTAM INTERNATIONAL PRIVATE LIMITED",
"ACHYUTJIVA SILICONE PRIVATE LIMITED",
"ACI AUTOMATION PRIVATE LIMITED",
"ACI CLEAN ENERGY PRIVATE LIMITED",
"ACI CUMBALLA HILL HOSPITAL",
"ACI GLOBAL BUSINESS SERVICES PRIVATE LIMITED",
"ACI INDUSTRIAL ORGANIC PRIVATE LIMITED",
"ACI INFOCOM LIMITED",
"ACI OILS PRIVATE LIMITED",
"ACI SYSTEMS & SERVICES",
"ACI WORLDWIDE CONSULTING INDIA PRIVATE LIMITED",
"ACI WORLDWIDE SOLUTIONS PRIVATE LIMITED",
"ACIC ADVISORY PRIVATE LIMITED",
"ACID INDIA LIMITED",
"ACIDAES SOLUTIONS PRIVATE LIMITED",
"ACIDUS MANAGEMENT SOLUTIONS",
"ACIER ALLOYS INDIA PRIVATE LIMITED",
"ACIER FALCON PRIVATE LIMITED",
"ACIER SYSTEMS PRIVATE LIMITED",
"ACIES CONSULTING LLP",
"ACIES PHARMACEUTICAL PRIVATE LIMITED",
"ACIESIND PRIVATE LIMITED",
"ACIFORM MARKETING PRIVATE LIMITED",
"ACINTA PHARMACEUTICALS PRIVATE .LIMITED",
"ACIRON CONSULTING PRIVATE LIMITED",
"ACJK FOODS PRIVATE LIMITED",
"ACK CAPITAL MANAGEMENT PRIVATE LIMITED",
"ACK IMAGING TEK PRIVATE LIMITED",
"ACK KALYAN CONSTRUCTION PRIVATE LIMITED",
"ACKIN MARKETING PRIVATE LIMITED",
"ACKNIT INDUSTRIES LIMITED",
"ACKNOWN TECHNOLOGIES PRIVATE LIMITED",
"ACKROLL STEEL PRIVATE LIMITED",
"ACKRUTI SAFEGUARD SYSTEMS PRIVATE LIMITED",
"ACKRUTI STAR MAINTENANCE PRIVATE LIMITED",
"ACKTRON SECURITY SYSTEM PRIVATE LIMITED",
"ACKURETTA SYSTEMS PRIVATE LIMITED",
"ACL INFRACON PRIVATE LIMITED",
"ACL MOBILE PRIVATE LIMITED",
"ACL WINE PRIVATE LIMITED",
"ACLARA INDIA PRIVATE LIMITED",
"ACLAT TECHNOLOGIES PRIVATE LIMITED",
"ACLENT EXIM PRIVATE LIMITED",
"ACLIMA THERAPEUTICS DERIVE PRIVATE LIMITED",
"ACLINE MEP PRIVATE LIMITED",
"ACLIV TECHNOLOGIES PRIVATE LIMITED",
"ACLIX BUSINESS SOLUTIONS PRIVATE LIMITED",
"ACM CARGO MOVERS PRIVATE LIMITED",
"ACM CARTRIDGE RECHARGERS PRIVATE LIMITED",
"ACM GLOBAL LABORATORIES PRIVATE LIMITED",
"ACM INFRASTRUCTURE PRIVATE LIMITED",
"ACM INVESTMENT ADVISORS DIVISION OF ACMPL",
"ACM MEDICAL FOUNDATION",
"ACM NATURAL PRODUCTS PRIVATE LIMITED",
"ACMA COMPUTERS LIMITED",
"ACMA INDUSTRIAL PROJECT PVT LTD",
"ACMA TRAVEL TOURS PRIVATE LIMITED",
"ACMAS TECHNOLOGIES PRIVATE LIMITED",
"ACME AGENCIES",
"ACME AIR EQUIPMENTS COMPANY PRIVATE LIMITED",
"ACME AUTOMATION PRIVATE LIMITED",
"ACME AUTO-TECH PRIVATE LIMITED",
"ACME BUILDERS PRIVATE LIMITED",
"ACME CAPITAL MARKET PRIVATE LIMITED",
"ACME CHEM LIMITED",
"ACME CHITTORGARH SOLAR ENERGY PRIVATE LIMITED",
"ACME CLEANROOM TECHNOLOGIES PRIVATE LIMITED",
"ACME CLEANTECH SOLUTIONS PRIVATE LIMITED",
"ACME COMMODITIES PRIVATE LIMITED",
"ACME COMPLEX PRIVATE LIMITED",
"ACME CONCRETE MIXERS PRIVATE LIMITED",
"ACME CONDUCTORS PRIVATE LIMITED",
"ACME COTSYN PRIVATE LIMITED",
"ACME CREATION PRIVATE LIMITED",
"ACME DIE SYSTEMS PRIVATE LIMITED",
"ACME DIET CARE PRIVATE LIMITED",
"ACME DIGITEK SOLUTIONS PRIVATE LIMITED",
"ACME DISTRIBUTORS PRIVATE LIMITED",
"ACME ENGINEERING PRODUCTS & SYSTEMS (INDIA) PRIVATE LIMITED",
"ACME ENGINEERING-FABRICATORS PRIVATE LIMITED",
"ACME EXCELLENT MANAGEMENT PRIVATE LIMITED",
"ACME EXIM PRIVATE LIMITED",
"ACME FAB - CON INDIA PRIVATE LIMITED",
"ACME FABRIK PLAST PRIVATE LIMITED",
"ACME FASTENERS PRIVATE LIMITED",
"ACME FERRO ALLOYS PRIVATE LIMITED",
"ACME FITNESS PRIVATE LIMITED",
"ACME FORGINGS",
"ACME FORMULATION PRIVATE LIMITED",
"ACME GENERICS LLP",
"ACME GENERICS PRIVATE LIMITED",
"ACME GLOBAL BRANDS PRIVATE LIMITED",
"ACME GULEDAGUDDA SOLAR ENERGY PRIVATE LIMITED",
"ACME HARVEST PRIVATE LIMITED",
"ACME HEALTHCENTER PRIVATE LIMITED",
"ACME HEARING INSTRUMENTS PRIVATE LIMITED",
"ACME HEERGARH POWERTECH PRIVATE LIMITED",
"ACME HEIGHTS INFRASTRUCTURE PRIVATE LIMITED",
"ACME HOUSING INDIA PRIVATE.LIMITED",
"ACME HUKKERI SOLAR ENERGY PRIVATE LIMITED",
"ACME INDIA EQUIPMENT MANUFACTURES PRIVATE LIMITED",
"ACME INDIA MICROSYS PRIVATE LIMITED",
"ACME INFOCOM PRIVATE LIMITED",
"ACME INFOVISION SYSTEMS PRIVATE LIMITED",
"ACME INFRABUILDTECH (INDIA) PRIVATE LIMITED",
"ACME INFRACITY PRIVATE LIMITED",
"ACME INSURANCE BROKING SERVICES PRIVATE LIMITED",
"ACME INTERIORS PRIVATE LIMITED",
"ACME INTERNATIONAL LIMITED",
"ACME JAISALMER SOLAR POWER PRIVATE LIMITED",
"ACME JODHPUR SOLAR POWER PRIVATE LIMITED",
"ACME KAITHAL SOLAR POWER PRIVATE LIMITED",
"ACME KITTUR SOLAR ENERGY PRIVATE LIMITED",
"ACME KUDLIGI SOLAR ENERGY PRIVATE LIMITED",
"ACME LIFETECH LLP",
"ACME LOCKS LIMITED",
"ACME MACHINERY (INDIA) PRIVATE LIMITED",
"ACME MACHINERY COMPANY P LTD",
"ACME MAGADH SOLAR POWER PRIVATE LIMITED",
"ACME MAHBUBNAGAR SOLAR ENERGY PRIVATE LIMITED",
"ACME MEDIA CREATIONS PRIVATE LIMITED",
"ACME MEDICAL SERVICES PRIVATE LIMITED",
"ACME MEP SERVICES PRIVATE LIMITED",
"ACME METAL INDUSTRIES PRIVATE LIMITED",
"ACME METAWIRES PRIVATE LIMITED",
"ACME MOBILITY SOLUTIONS PRIVATE LIMITED",
"ACME MOULDERS & FURNITURES PRIVATE LIMITED",
"ACME NALANDA SOLAR POWER PRIVATE LIMITED",
"ACME ODISHA SOLAR POWER PRIVATE LIMITED",
"ACME OFFICE SOLUTIONS PRIVATE LIMITED",
"ACME ORGANICS PRIVATE LIMITED",
"ACME PACKS AND PRINTS (INDIA ) PRIVATE LIMITED",
"ACME PAINTS & RESIN PRIVATE LIMITED",
"ACME PC COMPONENTS PRIVATE LIMITED",
"ACME PET PACKAGING INDIA PRIVATE LIMITED",
"ACME PLAZA PREMISES CO- OPERATIVE SOCIETY LIMITED",
"ACME PROCESS HEAT FURNACES PRIVATE LIMITED",
"ACME PROCESS SYSTEMS PRIVATE LIMITED",
"ACME PROTECTION SERVICES PRIVATE LIMITED",
"ACME PROTECTIVE SOLUTIONS PRIVATE LIMITED",
"ACME PUMPS A ND POWER PROJECTS LIMITED",
"ACME PV POWERTECH PRIVATE LIMITED",
"ACME RAIPUR SOLAR POWER PRIVATE LIMITED",
"ACME REALTIES PRIVATE LIMITED",
"ACME REREGERATION PRIVATE LIMITED",
"ACME RESOURCES LIMITED",
"ACME REWA SOLAR ENERGY PRIVATE LIMITED",
"ACME ROLLTECH PRIVATE LIMITED",
"ACME SAFE INDIA PRIVATE LIMITED",
"ACME SAFETYWEARS LIMITED",
"ACME SANDUR SOLAR ENERGY PRIVATE LIMITED",
"ACME SERVICES PRIVATE LIMITED",
"ACME SIDLAGHATTA SOLAR ENERGY PRIVATE LIMITED",
"ACME SK FOODS PRIVATE LIMITED",
"ACME SOLAR ENERGY (MADHYA PRADESH) PRIVATE LIMITED",
"ACME SOLAR ENERGY PRIVATE LIMITED",
"ACME SOLAR HOLDINGS PRIVATE LIMITED",
"ACME SOLAR POWER TECHNOLOGY PRIVATE LIMITED",
"ACME SOLAR ROOFTOP SYSTEMS PRIVATE LIMITED",
"ACME SOLAR TECHNOLOGY GUJARAT PRIVATE LIMITED.",
"ACME SOLVENTS PRIVATE LIMITED",
"ACME SPACES PRIVATE LIMITED",
"ACME TECHPLAST PRIVATE LIMITED",
"ACME TEXFAB INDIA PRIVATE LIMITED",
"ACME THERAPEUTICS (I) PRIVATE LIMITED",
"ACME THREAD CO PVT LTD",
"ACME TOOLS PRIVATE LIMITED",
"ACME UNIVERSAL SAFEZONE 9 PRIVATE LIMITED",
"ACME VINIYOG PRIVATE LIMITED",
"ACME VISA SOLUTIONS PRIVATE LIMITED",
"ACME VOYAGES PRIVATE LIMITED",
"ACME WAREHOUSING PRIVATE LIMITED",
"ACME YAMUNANAGAR SOLAR POWER PRIVATE LIMITED",
"ACME YARNS PRIVATE. LIMITED.",
"ACMEECS INFRA PRIVATE LIMITED",
"ACMEFIL ENGINEERING SYSTEMS PRIVATE LIMITED",
"ACMEPACK PVT LTD",
"ACMETEK SSL & AUTHENTICATION SOLUTIONS PRIVATE LIMITED",
"ACMETOSH SERVICES PRIVATE LIMITED",
"ACMEVAC PUMPS AND ENGINEERING PRIVATE LIMITED",
"ACMEVAC SALES PVT LTD",
"ACMEVIEW INTERIOR SOLUTIONS PRIVATE LIMITED",
"ACML CAPITAL MARKETS LIMITED",
"ACN CABLE PRIVATE LIMITED",
"ACN CONSTRUCTIONS PRIVATE LIMITED",
"ACN DIGITAL PRIVATE LIMITED",
"ACN HEALTHCARE RCM SERVICES PRIVATE LIMITED",
"ACN INFOTECH ( INDIA ) PRIVATE LIMITED",
"ACN MEDICARE PRIVATE LIMITED",
"ACNA DYE CHEM P.LTD.",
"ACNAL INDUSTRIES PRIVATE LIMITED",
"ACNOVATE TECHNOLOGIES PRIVATE LIMITED",
"ACNT VENTURE PRIVATE LIMITED",
"ACO DEVELOPERS PRIVATE LIMITED",
"ACO SOURCING PRIVATE LIMITED",
"ACO SYSTEMS AND SOLUTIONS PRIVATE LIMITED",
"ACO TECHNOLOGY CENTRE PRIVATE LIMITED",
"ACODEIDEA TECHNOLOGIES PRIVATE LIMITED",
"ACODEZ IT SOLUTIONS PRIVATE LIMITED",
"ACOLAD CONTENT SOLUTIONS INDIA PRIVATE LIMITED",
"ACOLYTE INFOTECH PRIVATE LIMITED",
"ACOMS INDIA PRIVATE LIMITED",
"ACON BUILDSPACE PRIVATE LIMITED",
"ACONEX INDIA PRIVATE LIMITED",
"ACONITE TECHNOLOGIES PRIVATE LIMITED",
"ACONTER BUSINESS SOLUTIONS PRIVATE LIMITED",
"ACOR INFRA PROJECTS INDIA PRIVATE LIMITED",
"ACORE INDUSTRIES PRIVATE LIMITED",
"ACORIA INTERNATIONAL PRIVATE LIMITED",
"ACORIS RESEARCH LIMITED",
"ACORN CHEMIGREEN PRIVATE LIMITED",
"ACORN CONTROLS PRIVATE LIMITED",
"ACORN FUND CONSULTANTS PRIVATE LIMITED",
"ACORP CONSULTANTS PRIVATE LIMITED",
"ACOTT INDUSTRIES PRIVATE LIMITED",
"ACOUSTIC ARTS PRIVATE LIMITED",
"ACOUSTIC CONTROL PRIVATE LIMITED",
"ACOUSTIC ECO FOODS LIMITED",
"ACOUSTIC MARKETING INDIA PRIVATE LIMITED",
"ACOUSTICAL SURFACES PRIVATE LIMITED",
"ACOUSTICS INDIA PRIVATE LIMITED",
"ACOUSTIKA INTERNATIONAL PRIVATE LIMITED",
"ACP BILLING SERVICES PRIVATE LIMITED",
"ACP BUSINESS ENTERPRISES PRIVATE LIMITED",
"ACP FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"ACP INDUSTRIES LIMITED",
"ACP INDUSTRIES LIMITED.",
"ACP INVESTMENT ADVISORY PRIVATE LIMITED",
"ACP IT SOLUTIONS PRIVATE LIMITED",
"ACP TOLLWAYS PRIVATE LIMITED",
"ACPC INFRASTRUCTURES PRIVATE LIMITED",
"ACPL DESIGN LIMITED",
"ACPL EXPORTS P LIMITED",
"ACPL FINVEST PRIVATE LIMITED",
"ACPL GLOBAL PRIVATE LIMITED",
"ACPL JEWELS PRIVATE LIMITED",
"ACPL SYSTEMS PRIVATE LIMITED",
"ACQUA BOREWELL PRIVATE LIMITED",
"ACQUA PEARL PROPERTIES AND EXPORTS (INDIA) PRIVATE LIMITED",
"ACQUAFRONT INFRASTRUCTURE PRIVATE LIMITED",
"ACQUAINT BEE VENTURES PRIVATE LIMITED",
"ACQUAINT ENGINEERS & INFRASTRUCTURE PRIVATE LIMITED",
"ACQUAINT SOFTTECH PRIVATE LIMITED",
"ACQUAIR VENTURES PRIVATE LIMITED",
"ACQUARIUS CAPSTORM LIMITED",
"ACQUAVIVA INDIA PRIVATE LIMITED",
"ACQUEON TECHNOLOGIES PRIVATE LIMITED",
"ACQUEST ESTATES PRIVATE LIMITED",
"ACQUEST PROPERTY AND HOSPITALITY SERVICES PRIVATE LIMITED",
"ACQUIA INDIA PRIVATE LIMITED",
"ACQUIRE LOGIX TECHNOLOGY PRIVATE LIMITED",
"ACQUIRE PROJECTS PRIVATE LIMITED",
"ACQUISORY INDIA CONSULTING PRIVATE LIMITED",
"ACQUISORY RISK CONSULTING PRIVATE LIMITED",
"ACQUIST MARKETING AND INFORMATION SOLUTIONS PRIVATE LIMITED",
"ACQUITECH ENGINEERS PRIVATE LIMITED",
"ACQUITY LABS PRIVATE LIMITED",
"ACQUVEN BUSINESS SOLUTIONS PRIVATE LIMITED",
"ACR ENGINEERING SALES AND SERVICES PRIVATE LIMITED",
"ACR FOODS PRIVATE LIMITED",
"ACR INFRAZONE LIMITED",
"ACR MACHINING PRIVATE LIMITED",
"ACR PROJECT CONSULTANTS PRIVATE LIMITED",
"ACRANNOLIFE GENOMICS PRIVATE LIMITED",
"ACRASTYLE POWER INDIA LIMITED",
"ACREATY MANAGEMENT CONSULTANT PRIVATE LIMITED",
"ACREF SOLUTION PRIVATE LIMITED",
"ACRENOX FERRO ALLOYS PRIVATE LIMITED",
"ACRERISE PROJECTS PRIVATE LIMITED",
"ACRES 21 HOMES PRIVATE LIMITED",
"ACRES BUILDWELL PRIVATE LIMITED",
"ACRESNINCHES PRIVATE LIMITED",
"ACRIFAB PRIVATE LIMITED",
"ACRIS TECHNOLOGIES PRIVATE LIMITED",
"ACRNS ANALYTICAL TECHNOLOGIES PRIVATE LIMITED",
"ACRO EDGE SYSTEMS PRIVATE LIMITED",
"ACRO HR SOLUTIONS INDIA PRIVATE LIMITED",
"ACRO LABS AND RESEARCH PRIVATE LIMITED",
"ACRO LABS PRIVATE LIMITED",
"ACRO PAINTS LIMITED",
"ACRO SOFTECH PRIVATE LIMITED",
"ACRO TECH INFRASTRUCTURE PRIVATE LIMITED",
"ACRO TECHNOLOGIES INDIA PRIVATE LIMITED",
"ACRO VENTURES PRIVATE LIMITED",
"ACRO-DECORS INDIA PRIVATE LIMITED",
"ACROLAND TIMBERS PRIVATE LIMITED",
"ACROLOGIC AUTOMATION PRIVATE LIMITED",
"ACROLOGIC BUSINESS SOLUTIONS PRIVATE LIMITED",
"ACROMAX INDUSTRIES PRIVATE LIMITED",
"ACRON DEVELOPERS PRIVATE LIMITED",
"ACRON HOUSING PRIVATE LIMITED",
"ACRON PLAST PRIVATE LIMITED",
"ACRONOTICS PRIVATE LIMITED",
"ACRONYMINGREDIENTS INDIA PRIVATE LIMITED",
"ACROPETAL GENETICS PRIVATE LIMITED",
"ACROPOLE TRAVELS PRIVATE LIMITED",
"ACROPOLIS FOUNDATIONS PRIVATE LIMITED",
"ACROPOLIS INFRAPORT PRIVATE LIMITED",
"ACROPOLIS MAINTENANCE SERVICES PRIVATE LIMITED",
"ACROPOLIS PURPLE DEVELOPERS",
"ACROPOLIS SYSTEMS PRIVATE LIMITED",
"ACROSIL PRODUCTS PRIVATE LIMITED",
"ACROSS & BEYOND DEVELOPMENT CONSULTANCY PRIVATE LIMITED",
"ACROSS ASSIST PRIVATE LIMITED",
"ACROSS ENGITECH PRIVATE LIMITED",
"ACROSS NODE TRANSIT SOLUTIONS PRIVATE LIMITED",
"ACROSS THE MONDE TRAVEL AND TOURS P L",
"ACROSSDOMAIN SOLUTIONS PRIVATE LIMITED",
"ACROTREND SOLUTIONS PRIVATE LIMITED",
"ACROW INDIA LIMITED",
"ACROWIT TECHNOLOGIES PRIVATE LIMITED",
"ACRUX REALCON PRIVATE LIMITED",
"ACRY MONOMERS (INDIA) PVT.LTD.",
"ACRYCOL MINERALS LIMITED",
"ACRYNOVA INDUSTRIES PRIVATE LIMITED",
"CARYSIL LIMITED",
"ACRYSIL STEEL LIMITED",
"ACS ADVISORY SERVICES LIMITED",
"ACS AIR CHARTER SERVICE INDIA PRIVATE LIMITED",
"ACS APPLIANCES PRIVATE LIMITED",
"ACS CARS PRIVATE LIMITED",
"ACS DESIGN CONSULTING PRIVATE LIMITED",
"ACS ENGITECH PRIVATE LIMITED",
"ACS GLOBAL TECH SOLUTIONS PRIVATE LIMITED",
"ACS HOTELS & SERVICES PRIVATE LIMITED",
"ACS HYDRAULICS PRIVATE LIMITED",
"ACS INFOTECH PRIVATE LIMITED",
"ACS INTERNATIONAL INDIA PRIVATE LIMITED",
"ACS LOGISTICS PRIVATE LIMITED",
"ACS MARINE SERVICES PRIVATE LIMITED",
"ACS MEDICAL COLLEGE AND HOSPITAL",
"ACS PAPERS INDIA PRIVATE LIMITED",
"ACS SHIPPING PRIVATE LIMITED",
"ACS TECHNOLOGIES LIMITED",
"ACS TRADERS PRIVATE LIMITED",
"ACSE SOLUTIONS PRIVATE LIMITED",
"ACSIA TECHNOLOGIES PRIVATE LIMITED",
"ACSION ENGINEERING (INDIA) PRIVATE LIMITED",
"ACSIS INDIA PRIVATE LIMITED",
"ACSIUS TECHNOLOGIES PRIVATE LIMITED",
"ACSURGIPHARMA PRIVATE LIMITED",
"ACSYS INVESTMENTS PRIVATE LIMITED",
"ACT DIGITAL HOME ENTERTAINMENT PRIVATE LIMITED",
"ACT FININVEST LIMITED",
"ACT INFRAPORT LIMITED",
"ACT LIFESCIENCES PRIVATE LIMITED",
"ACT PLAST PAINTS PRIVATE LIMITED",
"ACT SENSORS PRIVATE LIMITED",
"ACT1 AGILE1 INDIA PRIVATE LIMITED",
"ACT21 SOFTWARE PRIVATE LIMITED",
"ACTA SCIENTIFIC PUBLICATIONS OPC PRIVATE LIMITED",
"ACTAL FOODS INDIA PRIVATE LIMITED",
"ACTAS TECHNOLOGIES PRIVATE LIMITED",
"ACTAVIS PHARMA DEVELOPMENT CENTRE PRIVATE LIMITED",
"ACTAVIS PHARMA PRIVATE LIMITED",
"ACTE TECHNOLOGIES PRIVATE LIMITED",
"ACTECH INFORMATION SYSTEMS LIMITED",
"ACTEON INDIA PRIVATE LIMITED",
"ACTFIVE CLEANING MACHINES (INDIA) PRIVATE LIMITED",
"ACTG COMPUTING SERVICES PRIVATE LIMITED",
"ACTGEN PHARMA PRIVATE LIMITED",
"ACTIA INDIA PRIVATE LIMITED",
"ACTIFF PHARMACEUTICALS PRIVATE LIMITED",
"ACTIFIO TECHNOLOGIES INDIA PRIVATE LIMITED",
"ACTIFY DATA LABS PRIVATE LIMITED",
"ACTIFY INFOTECH PRIVATE LIMITED",
"ACTIGEAR VENTURES PRIVATE LIMITED",
"ACTIKNOW BUSINESS CONSULTING PRIVATE LIMITED",
"ACTIKNOW CONSULTING PRIVATE LIMITED",
"ACTIMEDIA PRIVATE LIMITED",
"ACTIMUS BIOSCIENCES PRIVATE LIMITED",
"ACTINOVA PRIVATE LIMITED",
"ACTIO SERVICES PROVIDER PRIVATE LIMITED",
"ACTION AGAINST HUNGER FOUNDATION",
"ACTION AGRO (INDIA) PRIVATE LIMITED",
"ACTION AID ASSOCIATION",
"ACTION AUTOMOTIVES P LIMITED",
"ACTION BATTERIES PRIVATE LIMITED",
"ACTION BRIDGEGAP CONSTRUCTIONS PRIVATE. LIMITED.",
"ACTION CANCER HOSPITAL",
"ACTION CAPITAL PRIVATE LIMITED",
"ACTION CONSTRUCTION EQUIPMENT LIMITED",
"ACTION FACILITY SERVICES PRIVATE LIMITED",
"ACTION FOOTWEARS PRIVATE LIMITED",
"ACTION FOR INDIA SCALING SOCIAL INNOVATION",
"ACTION FOUNDATION FOR SOCIAL SERVICES",
"ACTION GUARDING SERVICES PRIVATE LIMITED",
"ACTION INTERNATIONAL PRIVATE LIMITED",
"ACTION MARBLE AND GRANITES PRIVATE LIMITED",
"ACTION MEDICAL MARKETING PRIVATE LIMITED",
"ACTION RETAIL VENTURES PRIVATE LIMITED",
"ACTION SHOES PRIVATE LIMITED",
"ACTION SPRINGS(INDIA)PRIVATE LIMITED",
"ACTION SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED",
"ACTIONABLE SCIENCE LABS PRIVATE LIMITED",
"ACTIONFI TECHNOLOGIES PRIVATE LIMITED",
"ACTIONWARE INDIA PRIVATE LIMITED",
"ACTIS ADVISERS PRIVATE LIMITED",
"ACTIS GENERICS PRIVATE LIMITED",
"ACTIS GLOBAL SERVICES PRIVATE LIMITED",
"ACTIS TECHNOLOGIES PRIVATE LIMITED",
"ACTIVAA TECHNOCONTROLS PRIVATE LIMITED",
"ACTIVANT SOLUTIONS PRIVATE LIMITED",
"ACTIVATE DIMENSION PRIVATE LIMITED",
"ACTIVATE INFOCOM PRIVATE LIMITED",
"ACTIVBYTES TECHNOLOGIES PRIVATE LIMITED",
"ACTIVE ACRES RESIDENTS WELFARE ASSOCIATION",
"ACTIVE ADWORKSHOP PRIVATE LIMITED",
"ACTIVE ALUMINIUM PRIVATE LIMITED",
"ACTIVE AUTO-INSULATIONS PVT LTD",
"ACTIVE AUTOMATION PRIVATE LIMITED",
"ACTIVE BAGS PRIVATE LIMITED",
"ACTIVE CARBON INDIA PRIVATE LIMITED",
"ACTIVE CARGO MOVERS",
"ACTIVE CARGO SOLUTIONS PRIVATE LIMITED",
"ACTIVE CERAMIC PRIVATE LIMITED",
"ACTIVE CHAR PRODUCTS PRIVATE LIMITED",
"ACTIVE CHROMEWELL EXHAUST PRIVATE LIMITED",
"ACTIVE CLOTHING CO. PRIVATE LIMITED",
"ACTIVE DERIVATIVES PRIVATE LIMITED",
"ACTIVE DESIGNS PRIVATE LIMITED",
"ACTIVE DEVELOPERS PRIVATE. LIMITED.",
"ACTIVE EDU-TECHNOLOGIES INDIA PRIVATE LIMITED",
"ACTIVE FORCE SECURITY PRIVATE LIMITED",
"ACTIVE FREIGHT LOGISTICS PRIVATE LIMITED",
"ACTIVE INDIA HOLIDAYS PRIVATE LIMITED",
"ACTIVE INFRASTRUCTURES PRIVATE LIMITED",
"ACTIVE INNOVATIONS MEDIA INDIA PRIVATE LIMITED",
"ACTIVE LIFESTYLE RETAIL PRIVATE LIMITED",
"ACTIVE MARATHON HOLIDAYS PRIVATE LIMITED",
"ACTIVE MARINE PRIVATE LIMITED",
"ACTIVE MEDIA PRIVATE LIMITED",
"ACTIVE METALS PRIVATE LIMITED",
"ACTIVE MOTORS PRIVATE LIMITED",
"ACTIVE OPERATIONS MANAGEMENT INDIA PRIVATE LIMITED",
"ACTIVE PHOTO SERVICES PRIVATE LIMITED",
"ACTIVE PLUS MANUFACTURERS PRIVATE LIMITED",
"ACTIVE POLYMERS PRIVATE LIMITED",
"ACTIVE PRINTPACK PRIVATE LIMITED",
"ACTIVE PROTECTION SERVICES PRIVATE LIMITED",
"ACTIVE PUMPS PRIVATE LIMITED",
"ACTIVE REALTORS PRIVATE LIMITED",
"ACTIVE SAFEKEEPING SERVICES PRIVATE LIMITED",
"ACTIVE SALES PRIVATE LIMITED",
"ACTIVE SECURITIES LIMITED",
"ACTIVE SMART HUB",
"ACTIVE TELECOM PRIVATE LIMITED",
"ACTIVE TOOLS PRIVATE LIMITED",
"ACTIVE TOYS PRIVATE LIMITED",
"ACTIVE TRANSPORT COMPANY LIMITED",
"ACTIVEARK DIGITAL MEDIA PRIVATE LIMITED",
"ACTIVEGRAB ENGINEERING & TRADING PRIVATE LIMITED",
"ACTIVEIQ PRIVATE LIMITED",
"ACTIVEKIDSS RETAIL PRIVATE LIMITED",
"ACTIVELOBBY INFORMATION SYSTEMS PRIVATE LIMITED",
"ACTIVENTIS BIOTECH PRIVATE LIMITED",
"ACTIVETHEORY PRIVATE LIMITED",
"ACTIVITAS MANAGEMENT ADVISORS PRIVATE LIMITED",
"ACTIVOLT TECH SOLUTIONS PRIVATE LIMITED",
"ACTIVZ LIFESCIENCES I PRIVATE LIMITED",
"ACTLINK LOGISTICS PRIVATE LIMITED",
"ACTMOTIVE ENGINEERING PRIVATE LIMITED",
"ACTOLAP SOLUTIONS INDIA PRIVATE LIMITED",
"ACTON FINISHING PRIVATE LIMITED",
"ACTON PHARMA PRIVATE LIMITED",
"ACTONICS INDIA PRIVATE LIMITED",
"ACTOSERBA ACTIVE WHOLESALE LIMITED",
"ACTOSERBA ACTIVE WHOLESALE PRIVATE LIMITED",
"ACTRA CONSTRUCTION AND INFRASTRUCTURE SERVICES PRIVATE LIMIT",
"ACTS MAHILA MUTUALLY AIDED CO_OP THRIFT SOCIETY LTD",
"ACTUACION NUTRICION PRIVATE LIMITED",
"ACTUALIZE CONSULTING ENGINEERS INDIA PRIVATE LIMITED",
"ACTUANT INDIA PRIVATE LIMITED",
"ACTUATE BUSINESS CONSULTING PRIVATE LIMITED",
"ACTY SYSTEM INDIA PRIVATE LIMITED",
"ACU ROAD KRAFT PRIVATE LIMITED",
"ACUAPURO WATER EQUIPMENT INDIA PRIVATE LIMITED",
"ACUBE AIRCONDITIONING PRIVATE LIMITED",
"ACUBE BUSINESS AND TECHNOLOGIES SOLUTIONS PRIVATE LIMITED",
"ACUBE BUSINESS SOLUTIONS PRIVATE LIMITED",
"ACUBE KRAFT CONCEPTS PRIVATE LIMITED",
"ACUBE KRAFT PRIVATE LIMITED",
"ACUBE TRADELINK PRIVATE LIMITED",
"ACUBETECH SOLUTIONS PRIVATE LIMITED",
"ACUERE BIOSCIENCES PRIVATE LIMITED",
"ACUFAB PRIVATE LIMITED",
"ACUFIRE SYSTEMS (INDIA) PRIVATE LIMITED",
"ACUFORE INDIA PRIVATE LIMITED",
"ACUITAS CAPITAL ADVISORS PRIVATE LIMITED",
"ACUITE RATINGS & RESEARCH LIMITED",
"ACUITI LABS (INDIA) PRIVATE LIMITED",
"ACUITTY CONSULTANTS LLP",
"ACUITY INDIA RESORTS PRIVATE LIMITED",
"ACUITY KNOWLEDGE CENTRE INDIA PRIVATE LIMITED",
"ACUITY KNOWLEDGE SERVICES INDIA PRIVATE LIMITED",
"ACUITY KP SOLUTIONS (INDIA) PRIVATE LIMITED",
"ACUITY PROFESSIONAL PRIVATE LIMITED",
"ACUITY SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"ACULIFE HEALTHCARE PRIVATE LIMITED",
"ACULORE STATISTICS PRIVATE LIMITED",
"ACUMAC MACHINE TOOLS PRIVATE LIMITED",
"ACUME CHEMICALS PRIVATE LIMITED",
"ACUMEN (J) MARKETING PVT LTD",
"ACUMEN ADVERTISING PRIVATE LIMITED",
"ACUMEN AIRCOOL PRIVATE LIMITED",
"ACUMEN CAPITAL MARKET INDIA LIMITED",
"ACUMEN CHEMICALS PRIVATE LIMITED",
"ACUMEN COMMODITIES INDIA LIMITED",
"ACUMEN GPS INDIA PRIVATE LIMITED",
"ACUMEN INFRA PRIVATE LIMITED",
"ACUMEN MAINTENANCE SERVICES PRIVATE LIMITED",
"ACUMEN MARKETING SOLUTIONS PRIVATE LIMITED",
"ACUMEN OVERSEAS PRIVATE LIMITED",
"ACUMEN PACKAGING PRIVATE LIMITED",
"ACUMEN PHARMACEUTICALS PRIVATE LIMITED",
"ACUMEN STRUCTURES PRIVATE LIMITED",
"ACUMEN TECHNICAL ADVISORY PRIVATE LIMITED",
"ACUMEN TECHNOLOGIES PRIVATE LIMITED",
"ACUMEN TECH-SOL PRIVATE LIMITED",
"ACUMEUS RESEARCH BUSINESS SOLUTION & CONSULTANCY PRIVATE LIMITED",
"ACUMINOUS SOFTWARE PRIVATE LIMITED",
"ACUMONT SOLUTIONS PRIVATE LIMITED",
"ACURA BRANDS PRIVATE LIMITED",
"ACURA EXTRUSION INDIA PRIVATE LIMITED",
"ACURA HEALTH CARE PRIVATE LIMITED",
"ACURA HEALTH SOLUTIONS PRIVATE LIMITED",
"ACURACON HEALTH SCIENCES PRIVATE LIMITED",
"ACURO ORGANICS LIMITED",
"ACURUS SOLUTIONS PRIVATE LIMITED",
"ACUS IMPEX PRIVATE LIMITED",
"ACUSERVE INTEGRATED FACILITIES PRIVATE LIMITED",
"ACUSIS SOFTWARE INDIA PRIVATE LIMITED",
"ACUTE CERAMIC PRIVATE LIMITED",
"ACUTE ENGINEERS AND CONTRACTORS (OPC) PRIVATE LIMITED",
"ACUTE HEALTH CARE PRIVATE LIMITED",
"ACUTE INFORMATICS PRIVATE LIMITED",
"ACUTE REALTY PRIVATE LIMITED",
"ACUTE RESEARCH PRIVATE LIMITED",
"ACUTEC GLOBAL SERVICES LLP",
"ACUTECH CONSULTING PRIVATE LIMITED",
"ACUTECH MANUFACTURING COMPANY PRIVATE LIMITED",
"ACUTECQ TECHNOLOGY",
"ACUTEX INDUSTRIES PRIVATE LIMITED",
"ACUTUS BIAS SOLUTIONS PRIVATE LIMITED",
"ACUVATE SOFTWARE PRIVATE LIMITED",
"ACUVER EDU CONZULT PRIVATE LIMITED",
"ACUVITTA CORPORATE SERVICES PRIVATE LIMITED",
"ACUVON CONSULTING PRIVATE LIMITED",
"ACUWAY MOLDS( INDIA) PRIVATE LIMITED",
"ACV MINERALS PRIVATE LIMITED",
"ACV PRODUCTS PRIVATE LIMITED",
"ACVA SOLAR PRIVATE LIMITED",
"ACVENTA RESEARCH LABS PRIVATE LIMITED",
"ACVISS TECHNOLOGIES PRIVATE LIMITED",
"ACXIOM CONSULTING PRIVATE LIMITED",
"ACXIOM TECHNOLOGIES LLP",
"ACYUTA TECHNOLOGIES PRIVATE LIMITED",
"ACZ GLOBAL PRIVATE LIMITED",
"ACZET PRIVATE LIMITED",
"AD 4 U COMMUNICATIONS PRIVATE LIMITED",
"AD ASTRA CONSULTANTS",
"AD ASTRA STAFFING SOLUTIONS PRIVATE LIMITED",
"AD AUTOMOTIVES PRIVATE LIMITED",
"AD BOX PRIVATE LIMITED",
"AD COM PROPERTIES PRIVATE LIMITED",
"AD DIRECTORATE OF AGRICULTURE BHOPAL MADHYA PRADESH",
"AD ESSENCE SERVICES PRIVATE LIMITED",
"AD EXIM PRIVATE LIMITED",
"AD FRAME PRIVATE LIMITED",
"AD GLOBAL 360 INDIA PRIVATE LIMITED",
"AD HANDLOOM DIRECTORATE BHOPAL",
"AD HOC SCIENTIFIC PRIVATE LIMITED",
"AD HOME PRODUCTS PRIVATE LIMITED",
"AD HYDRO POWER LIMITED",
"AD IDEAS PRIVATE LIMITED",
"AD MERCHANT INDIA PRIVATE LIMITED",
"AD METHODS INDIA PRIVATE LIMITED",
"AD NORTH EAST AIR CARGO PRIVATE LIMITED",
"AD PATEL INSTITUTE OF TECHNOLOGY",
"AD POINT PRINTING AND PUBLICITY PRIVATE LIMITED",
"AD PRO SYSTEMS INDIA PRIVATE LIMITED",
"AD SHIP MANAGEMENT PRIVATE LIMITED",
"AD SOLACE INTERNATIONAL HEALTHCARE PRIVATE LIMITED",
"AD SONS REALITY PRIVATE LIMITED",
"AD SQUARE PROJECTS INDIA PRIVATE LIMITED",
"AD TRADE LINKS PRIVATE LIMITED",
"AD&T CYCLES PRIVATE LIMITED",
"AD2PRO GLOBAL CREATIVE SOLUTIONS PRIVATE LIMITED",
"AD2PRO MEDIA SOLUTIONS PRIVATE LIMITED",
"AD3I SOFTWARE SOLUTIONS PRIVATE LIMITED",
"AD9 SYNTHETIC & SPORTS PRIVATE LIMITED",
"ADA ANNEX ADVISORY SERVICES PRIVATE LIMITED",
"ADA CREATIONS PRIVATE LIMITED",
"ADA DIGITAL ANALYTICS PRIVATE LIMITED",
"ADA SOFTWARE RE ENGINEERING SERVICES PRIVATE LIMITED",
"ADA TECH SOLUTIONS PRIVATE LIMITED",
"ADAA TRADERS PRIVATE LIMITED",
"ADAAN DIGITAL SOLUTIONS PRIVATE LIMITED",
"ADACELL TECHNOLOGIES PRIVATE LIMITED",
"ADACKANATT FOODS AND BEVERAGES PRIVATE LIMITED",
"ADACLE IT SOLUTIONS PRIVATE LIMITED",
"ADACTS DIGITAL PRIVATE LIMITED",
"ADADYN TECHNOLOGIES PRIVATE LIMITED",
"ADAEQUARE INFO PRIVATE LIMITED",
"ADAERO TECH PRIVATE LIMITED",
"ADAGE AUTOMATION PRIVATE LIMITED",
"ADAGE PAPERS PRIVATE LIMITED",
"ADAGRAD PRIVATE LIMITED",
"ADAH HOSPITALITY PRIVATE LIMITED",
"ADAJAN HEALTH CARE LIMITED",
"ADAK ELECTRICALS PRIVATE LIMITED",
"ADAK METCAST ENGINEERS PRIVATE LIMITED",
"ADAM & COAL RESOURCES PRIVATE LIMITED",
"ADAM ASSOCIATES UTILITY ENGINEERS PRIVATE LIMITED",
"ADAM CROP SCIENCE PRIVATE LIMITED",
"ADAM FABRIWERK PRIVATE LIMITED",
"ADAM INFORMATION TECHNOLOGIES INDIA PRIVATE LIMITED",
"ADAM SMITH ASSOCIATES PRIVATE LIMITED",
"ADAM VACATIONS PRIVATE LIMITED",
"ADAMA INDIA PRIVATE LIMITED",
"ADAMANT DIAGNOSTIC PRIVATE. LIMITED",
"ADAMANT ENGINEER'S PRIVATE LIMITED",
"ADAMANT HR CONSULTING PRIVATE LIMITED",
"ADAMANTEM EXIM PRIVATE LIMITED",
"ADAMAS BUILDERS PRIVATE LIMITED",
"ADAMAS CLINICAL QUALITY CONSULTING PRIVATE LIMITED",
"ADAMAS EXPORT (INDIA) PRIVATE LIMITED",
"ADAMAS HR SERVICES PRIVATE LIMITED",
"ADAMAS INTERNATIONAL SCHOOL",
"ADAMAS UNIVERSITY",
"ADAMAS WORLD SCHOOL",
"ADAMIS VENTURES PRIVATE LIMITED",
"ADAMS APPLIANCES AND ELECTRONICS PRIVATE LIMITED",
"ADAMS ENGINEERING PROJECTS PRIVATE LIMITED",
"ADAMS EXIM PRIVATE LIMITED",
"ADAMS FINE CHEMICALS PRIVATE LIMITED",
"ADAMS RETAILING PRIVATE LIMITED",
"ADAMS TECHNOLOGIES PRIVATE LIMITED",
"ADANI AGRI FRESH LIMITED",
"ADANI AGRI LOGISTICS (DEWAS) LIMITED",
"ADANI AGRI LOGISTICS (DHAMORA) LIMITED",
"ADANI AGRI LOGISTICS (HARDA) LIMITED",
"ADANI AGRI LOGISTICS (HOSHANGABAD) LIMITED",
"ADANI AGRI LOGISTICS (KATIHAR) LIMITED",
"ADANI AGRI LOGISTICS (KOTKAPURA) LIMITED",
"ADANI AGRI LOGISTICS (MP) LIMITED",
"ADANI AGRI LOGISTICS (PANIPAT) LIMITED",
"ADANI AGRI LOGISTICS (SATNA) LIMITED",
"ADANI AGRI LOGISTICS (UJJAIN) LIMITED",
"ADANI AGRI LOGISTICS LIMITED",
"ADANI AIRPORT HOLDINGS LIMITED",
"ADANI BRAHMA SYNERGY PRIVATE LIMITED",
"ADANI BUNKERING PRIVATE LIMITED",
"TYGER CAPITAL PRIVATE LIMITED",
"ADANI CEMENT INDUSTRIES LIMITED",
"ADANI CMA MUNDRA TERMINAL PRIVATE LIMITED",
"ADANI DEFENCE SYSTEMS AND TECHNOLOGIES LIMITED",
"ADANI DEVELOPERS PRIVATE LIMITED",
"ADANI DIGITAL LABS PRIVATE LIMITED",
"ADANI ELBIT ADVANCED SYSTEMS INDIA LIMITED",
"ADANI ELECTRICITY MUMBAI",
"ADANI ELECTRICITY MUMBAI INFRA LIMITED",
"ADANI ELECTRICITY MUMBAI LIMITED",
"ADANI ENERGY",
"ADANI ENNORE CONTAINER TERMINAL PRIVATE LIMITED",
"ADANI ENTERPRISES LIMITED",
"ADANI ESTATE MANAGEMENT PRIVATE LIMITED",
"ADANI ESTATE PRIVATE LIMITED",
"ADANI FINSERVE PRIVATE LIMITED",
"ADANI FOOD PRODUCTS PVT LTD",
"ADANI FORWARDING AGENT LIMITED",
"ADANI FOUNDATION",
"ADANI GOODHOMES PRIVATE LIMITED",
"ADANI GREEN ENERGY (TAMILNADU) LIMITED",
"ADANI GREEN ENERGY (UP) LIMITED",
"ADANI GREEN ENERGY LIMITED",
"ADANI GREEN ENERGY SIX LIMITED",
"ADANI GREEN ENERGY TWENTY THREE LIMITED",
"ADANI HARBOUR SERVICES LIMITED",
"ADANI HAZIRA PORT LIMITED",
"ADANI HAZIRA PORT PRIVATE LIMITED",
"ADANI HOSPITALS MUNDRA LIMITED",
"TYGER HOME FINANCE PRIVATE LIMITED",
"ADANI HYBRID ENERGY JAISALMER FOUR LIMITED",
"ADANI HYBRID ENERGY JAISALMER ONE LIMITED",
"ADANI HYBRID ENERGY JAISALMER THREE LIMITED",
"ADANI HYBRID ENERGY JAISALMER TWO LIMITED",
"ADANI INFRA INDIA LIMITED",
"ADANI INFRASTRUCTURE AND DEVELOPERS PRIVATE LIMITED",
"ADANI INFRASTRUCTURE MANAGEMENT SERVICES LIMITED",
"ADANI INSTITUTE FOR EDUCATION AND RESEARCH",
"ADANI INTERNATIONAL CONTAINER TERMINAL PRIVATE LIMITED",
"ADANI INTERNATIONAL SCHOOL",
"ADANI KANDLA BULK TERMINAL PRIVATE LIMITED",
"ADANI KATTUPALLI PORT LIMITED",
"ADANI KP AGRIWAREHOUSING PRIVATE LIMITED",
"ADANI KRISHNAPATNAM CONTAINER TERMINAL PRIVATE LIMITED",
"ADANI KRISHNAPATNAM PORT LIMITED",
"ADANI LOGISTICS LIMITED",
"ADANI LOGISTICS SERVICES LIMITED",
"ADANI M2K PROJECTS LLP",
"ADANI MUNDRA SEZ INFRASTRUCTURE PRIVATE LIMITED",
"ADANI MURMUGAO PORT TERMINAL PRIVATE LIMITED",
"ADANI NYK AUTO LOGISTICS SOLUTIONS PRIVATE LIMITED",
"ADANI PENCH POWER LIMITED",
"ADANI PETRONET (DAHEJ) PORT LIMITED",
"ADANI PETRONET DAHEJ PORT PRIVATE LIMITED",
"ADANI PHARMACHEM PRIVATE LIMITED",
"ADANI PORTS AND SPECIAL ECONOMIC ZONE LIMITED",
"ADANI POWER (JHARKHAND) LIMITED",
"ADANI POWER LIMITED",
"ADANI POWER MAHARASHTRA LIMITED.",
"ADANI POWER MUNDRA LIMITED",
"ADANI POWER RAJASTHAN LIMITED",
"ADANI PROPERTIES PRIVATE LIMITED",
"ADANI RAIL INFRA PRIVATE LIMITED",
"ADANI RENEWABLE ENERGY (KA) LIMITED",
"ADANI RENEWABLE ENERGY (MH) LIMITED",
"ADANI RENEWABLE ENERGY (RJ) LIMITED",
"ADANI RENEWABLE ENERGY HOLDING EIGHTEEN LIMITED",
"ADANI RENEWABLE ENERGY HOLDING FIVE LIMITED",
"ADANI RENEWABLE ENERGY HOLDING FOUR LIMITED",
"ADANI RENEWABLE ENERGY HOLDING NINETEEN PRIVATE LIMITED",
"ADANI RENEWABLE ENERGY HOLDING ONE LIMITED",
"ADANI RENEWABLE ENERGY HOLDING SEVENTEEN LIMITED",
"ADANI RENEWABLE ENERGY HOLDING SIXTEEN LIMITED",
"ADANI RENEWABLE ENERGY HOLDING TEN LIMITED",
"ADANI RENEWABLE ENERGY HOLDING THREE LIMITED",
"ADANI RENEWABLE ENERGY PARK RAJASTHAN LIMITED",
"ADANI RESOURCES PRIVATE LIMITED",
"ADANI ROAD TRANSPORT LIMITED",
"ADANI SHIPPING I PRIVATE LIMITED",
"ADANI SKILL DEVELOPMENT CENTRE",
"ADANI SOLAR ENERGY AP EIGHT PRIVATE LIMITED",
"ADANI SOLAR ENERGY AP SEVEN PRIVATE LIMITED",
"ADANI SOLAR ENERGY AP SIX PRIVATE LIMITED",
"ADANI SOLAR ENERGY CHITRAKOOT ONE LIMITED",
"ADANI SOLAR ENERGY FOUR LIMITED",
"ADANI SOLAR ENERGY JAISALMER ONE PRIVATE LIMITED",
"ADANI SOLAR ENERGY JAISALMER TWO PRIVATE LIMITED",
"ADANI SOLAR ENERGY JODHPUR FIVE LIMITED",
"ADANI SOLAR ENERGY JODHPUR FOUR LIMITED",
"ADANI SOLAR ENERGY JODHPUR THREE LIMITED",
"ADANI SOLAR ENERGY JODHPUR TWO LIMITED",
"ADANI SOLAR ENERGY KA NINE PRIVATE LIMITED",
"ADANI SOLAR ENERGY KUTCHH ONE LIMITED",
"ADANI SOLAR ENERGY KUTCHH TWO PRIVATE LIMITED",
"ADANI SOLAR ENERGY RJ ONE PRIVATE LIMITED",
"ADANI SPORTSLINE PRIVATE LIMITED",
"ADANI TOTAL GAS LIMITED",
"ADANI TOTAL PRIVATE LIMITED",
"ADANI TOWNSHIP & REAL ESTATE COMPANY PRIVATE LIMITED",
"ADANI TRACKS MANAGEMENT SERVICES LIMITED",
"ADANI TRANSMISSION (INDIA) LIMITED",
"ADANI TRANSMISSION (RAJASTHAN) LIMITED",
"ADANI TRANSMISSION LIMITEDS ATL",
"ADANI TRANSMISSION STEP-ONE LIMITED",
"ADANI VIZAG COAL TERMINAL PRIVATE LIMITED",
"ADANI VIZHINJAM PORT PRIVATE LIMITED",
"ADANI WAREHOUSING SERVICES LIMITED",
"ADANI WATER LIMITED",
"ADANI WELSPUN EXPLORATION LIMITED",
"ADANI WILMAR LIMITED",
"ADANI WIND ENERGY (GUJARAT) PRIVATE LIMITED",
"ADANI WIND ENERGY KUTCHH ONE LIMITED",
"ADANI WIND ENERGY KUTCHH SIX LIMITED",
"ADANI WIND ENERGY KUTCHH THREE LIMITED",
"ADANI WIND ENERGY KUTCHH TWO LIMITED",
"ADANI WIND ENERGY MP ONE PRIVATE LIMITED",
"ADANICONNEX PRIVATE LIMITED",
"ADAPPT INTELLIGENCE PRIVATE LIMITED",
"ADAPPT MOBILE CLOUD APPLICATIONS PRIVATE LIMITED",
"ADAPS IT PRIVATE LIMITED",
"ADAPT IDEATIONS PRIVATE LIMITED",
"ADAPT INFRA PRIVATE LIMITED",
"ADAPT MARKETING & SALES (OPC) PRIVATE LIMITED",
"ADAPT SOFTWARE INDIA PRIVATE LIMITED",
"ADAPTABIZ TECHNOLOGIES PRIVATE LIMITED",
"ADAPTABLE SYSTEMS CONSULTING PRIVATE LIMITED",
"ADAPTIO FACILITY MANAGEMENT PRIVATE LIMITED",
"ADAPTIVE CONTROL SECURITY GLOBAL CORPORATE PRIVATE LIMITED",
"ADAPTIVE FITNESS PRIVATE LIMITED",
"ADAPTIVE MARKETING SOLUTIONS PRIVATE LIMITED",
"ADAPTIVE MOBILE SECURITY SOLUTIONS INDIA PRIVATE LIMITED",
"ADAPTIVE OCULAR SCIENCES PRIVATE LIMITED",
"ADAPTIVE SOFTECH PRIVATE LIMITED",
"ADAPTIVE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"ADAPTIVE TECHNOLOGY (INDIA) PRIVATE LIMITED",
"ADAPTOID LABS INDIA PRIVATE LIMITED",
"ADAPTY SOLUTIONS PRIVATE LIMITED",
"ADAR CHEMICALS PVT LTD",
"ADARASH AGROTECH FARMERS PRODUCER COMPANY LIMITED",
"ADARSH AGRITECH PRIVATE LIMITED",
"ADARSH ANUSUCHIT JATI PRATHMIK VIDYALAYA",
"ADARSH AROMAS PRIVATE LIMITED",
"ADARSH BAL NIKETAN SECONDARY SCHOOL",
"ADARSH BEARING PRIVATE LIMITED",
"ADARSH BEARINGS PRIVATE LIMITED",
"ADARSH BUILD ESTATE LIMITED",
"ADARSH CARGO AND COURIER SERVICES PRIVATE LIMITED",
"ADARSH COLLEGE OF ARTS AND COMMERCE",
"ADARSH DEVELOPERS",
"ADARSH ELECTRONICS PRIVATE LIMITED",
"ADARSH ENGITECH PROJECTS PRIVATE LIMITED",
"ADARSH ENGLISH HIGH SCHOOL",
"ADARSH EQUIPMENTS AND PROJECTS PRIVATE LIMITED",
"ADARSH FIBRES PRIVATE LIMITED",
"ADARSH FINETRADE PRIVATE LIMITED",
"ADARSH FOOD PRODUCTS PRIVATE LIMITED",
"ADARSH GLOBAL PVT LTD",
"ADARSH GROUP OF INSTITUTIONS",
"ADARSH HAVEN PRIVATE LIMITED",
"ADARSH HIGHER SECONDARY SCHOOL",
"ADARSH HINDI HIGH SCHOOL",
"ADARSH HINDI PRIMARY VIDYMANDIR GADCHANDUR",
"ADARSH HOME FURNISHING",
"ADARSH HOSPITAL PVT LTD",
"ADARSH INFINITY IMPORTS PRIVATE LIMITED",
"ADARSH INFOSOLUTIONS PRIVATE LIMITED",
"ADARSH INFRAINTERIO PRIVATE LIMITED",
"ADARSH INSTITUTE OF PHARMACY",
"ADARSH INSTRUMENTS PRIVATE LIMITED",
"ADARSH INTER COLLEGE",
"ADARSH ISPAT UDYOG PRIVATE LIMITED",
"ADARSH JUNIOR HIGH SCHOOL",
"ADARSH KANCH UDYOG PRIVATE LIMITED",
"ADARSH KARAM SINGH MEMORIAL HOSPITAL PRIVATE LIMITED",
"ADARSH KNIT WEAR PRIVATE LIMITED",
"ADARSH LIFESTYLE MALL PRIVATE LIMITED",
"ADARSH LINE ACCESSORIES PRIVATE LIMITED",
"ADARSH MARKETING",
"ADARSH MARMO GRANITES PRIVATE LIMITED",
"ADARSH MATRIC HR SEC SCHOOL",
"ADARSH MEDICO PRIVATE LIMITED",
"ADARSH METAL INDUSTRIES PRIVATE LIMITED",
"ADARSH MILK AND FOOD (INDIA) PRIVATE LIMITED",
"ADARSH NIVAAS PRIVATE LIMITED",
"ADARSH NIVASI SHALA KANYA KHEDBRAHMA",
"ADARSH NOBLE CORPORATION LIMITED",
"ADARSH PET PRIVATE LIMITED",
"ADARSH PLANT PROTECT LIMITED",
"ADARSH PRIMARY SCHOOL NILANGA",
"ADARSH PUBLIC SCHOOL",
"ADARSH PULSES PRIVATE LIMITED",
"ADARSH PVC PIPES PRIVATE LIMITED",
"ADARSH REALTY AND HOTELS PRIVATE LIMITED",
"ADARSH RENT-A-CAR PRIVATE LIMITED",
"ADARSH ROADLINES PRIVATE LIMITED",
"ADARSH SALES PRIVATE LIMITED",
"ADARSH SAMDARSHI INTER COLLEGE KHADEHIJAR HAMIRPUR",
"ADARSH SANSKAR ADHYAPAK MAHAVIDYALAYA",
"ADARSH SANSKAR ANUDANIT ADIWASI ASHRAM SCHOOL",
"ADARSH SHARMA TRAVEL SERVICES INDIA PRIVATE LIMITED",
"ADARSH SHEET GRAH PRIVATE LIMITED",
"ADARSH SHIKSHAN SANSTHAN",
"ADARSH SOLUTIONS PRIVATE LIMITED",
"ADARSH STAINLESS PRIVATE LIMITED",
"ADARSH SYNTHETICS PRIVATE LIMITED",
"ADARSH THERMOPACK INDUSTRIES PRIVATE LIMITED",
"ADARSH TRADEVENTURES PRIVATE LIMITED",
"ADARSH TRANSFORMERS PRIVATE LIMITED",
"ADARSH TYRES & TREAD PVT LTD",
"ADARSH VID. KACHARISAWANGA",
"ADARSH VIDHYA VIHAR UJLESHWAR ( EDUCATION DEPARTMENT COMMISSIONER OF SCHOOLS GANDHINAGAR)",
"ADARSH VIDHYALAY KARANJ",
"ADARSH VIDHYALAYA SECONDARY AND HIGHER SECONDARY SCHOOL NIKOL",
"ADARSH VIDHYALAYA SIPOR",
"ADARSH VIDHYALAYA VANAGALA",
"ADARSH VIDYA MANDIR",
"ADARSH VIDYA NIKETAN PUBLIC SCHOOL",
"ADARSH VIDYA SANGH",
"ADARSH VIDYALAYA",
"ADARSH VIDYALAYA SOLAPUR",
"ADARSH VIKAS MANDAL KARMAVEER BHAURAO PATIL COLLEGE OF ARTS AND COMMERCE",
"ADARSH VIKAS MANDAL S BAL VIDYA MANDIR & KARMAVEER BHAURAO PATIL JR COLLEGE",
"ADARSH WINGS AUTO PRIVATE LIMITED",
"ADARSH WORLD SCHOOL",
"ADARSHA AUTO SERVICE (HANAMKONDA) PRIVATE LIMITED",
"ADARSHA AUTO WORLD PRIVATE LIMITED",
"ADARSHA AUTOMOTIVES PRIVATE LIMITED",
"ADARSHA COLLEGE",
"ADARSHA CONTROL & AUTOMATION PRIVATE LIMITED",
"ADARSHA CONTROL SYSTEMS PRIVATE LIMITED",
"ADARSHA HOSPITAL",
"ADARSHA MADHYAMIK VIDYALAYA DUM DUM",
"ADARSHA MARATHI PRIM SCHOOL WARD NO 20",
"ADARSHA MOTOR SALES PRIVATE LIMITED",
"ADARSHA PACKAGING PRIVATE LIMITED",
"ADARSHA SEC HIGH SCH AMALGAON",
"ADARSHA SPECIALTY CHEMICALS PRIVATE LIMITED",
"ADARSHA VIDYA MANDIR NAGDEVWAD NAGDEVWADI",
"ADARSHA VIDYALAYA KOTHALI",
"ADARSHBADLI CONSTRUCTION PRIVATE LIMITED",
"ADARSHINI AUTOMOBILES PRIVATE LIMITED",
"ADASTRA JEWELRY PRIVATE LIMITED",
"ADASTRA LEARNING PRIVATE LIMITED",
"ADATA TECHNOLOGY INDIA PRIVATE LIMITED",
"ADATTE E-WASTE MANAGEMENT PRIVATE LIMITED",
"ADAYANA LEARNING SOLUTIONS PRIVATE LIMITED",
"ADAYAT RICE & FLOUR MILL PRIVATE LIMITED",
"ADB LOGISTICS PRIVATE LIMITED",
"ADB PROJECTS PRIVATE LIMITED",
"ADBAKX INDIA PRIVATE LIMITED",
"ADBHUT JEWELLS PRIVATE LIMITED",
"ADBIRD MEDIA PRIVATE LIMITED",
"ADBLOWZ SERVICES PRIVATE LIMITED",
"ADBOND INDUSTRIES PRIVATE LIMITED",
"ADBOX SOFTWARE PRIVATE LIMITED",
"ADBRIDGE COMMUNICATIONS INDIA PRIVATE LIMITED.",
"ADBS SECURITY & SERVICES PRIVATE LIMITED",
"ADBSAFEGATE INDIA PRIVATE LIMITED",
"ADBUR PRIVATE LIMITED",
"ADC DYES AND CHEMICALS PRIVATE LIMITED",
"ADC POWER PRIVATE LIMITED",
"ADCA CONSULTING PRIVATE LIMITED",
"ADCANOPUS DIGITAL MEDIA PRIVATE LIMITED",
"ADCARE PHARMA PRIVATE LIMITED",
"ADCC ACADEMY PRIVATE LIMITED",
"ADCC INFRACON PRIVATE LIMITED",
"ADCL FAFECO ENGINEERING PRIVATE LIMITED",
"ADCLAN MEDIA SERVICES PRIVATE LIMITED",
"ADCLICK IT SOLUTION PRIVATE LIMITED",
"ADCO MOTORS PVT LTD",
"ADCO TECH RECYCLING PRIVATE LIMITED",
"ADCO VENTURES PRIVATE LIMITED",
"ADCOCK INGRAM LIMITED",
"ADCOLONY INDIA PRIVATE LIMITED",
"ADCOM DISPLAY PRIVATE LIMITED",
"ADCON CEMENT INDUSTRIES PVT LTD",
"ADCON ENGINEERS PRIVATE LIMITED",
"ADCON INSTRUMENTS PRIVATE LIMITED",
"ADCON TECHNOLOGIES LIMITED",
"ADCOUNT TECHNOLOGIES PRIVATE LIMITED",
"ADCOUNTY MEDIA INDIA PRIVATE LIMITED",
"ADCURATIO MEDIA INDIA PRIVATE LIMITED",
"ADD ANNEX HEALTHCARE PRIVATE LIMITED",
"ADD ENGINEERING COMPONENTS (INDIA) PRIVATE LIMITED",
"ADD HOSPITAL PRIVATE LIMITED",
"ADD INNOVATIONS PRIVATE LIMITED",
"ADD LAUNDRY CONCEPTS PRIVATE LIMITED",
"ADD LOUNGE SERVICES PRIVATE LIMITED",
"ADD PENS PRIVATE LIMITED",
"ADD POLYMERS PRIVATE LIMITED",
"ADD REALTY LIMITED",
"ADD STORY MEDIA PRIVATE LIMITED",
"ADD WHIZ ENTERPRISES",
"ADDA3 ENTERPRISES PRIVATE LIMITED",
"ADDACT TECHNOLOGIES PRIVATE LIMITED",
"ADDAGIO KNIT CREATIONS PRIVATE LIMITED",
"ADDAGUDI EXPORTS PRIVATE LIMITED",
"ADDARSH MANAGEMENT PVT. LTD.",
"ADDATIMES MEDIA PRIVATE LIMITED",
"ADDBIKE AUTOMOBILES PRIVATE LIMITED",
"ADDBOATS INTERNATIONAL PRIVATE LIMITED",
"ADDED VALUE COMMUNICATIONS PRIVATE LIMITED",
"ADDEN FASHIONS INDIA PRIVATE LIMITED",
"ADDENDA CHEMICAL INDIA PRIVATE LIMITED",
"ADDESMAR HOMETEX PRIVATE LIMITED",
"ADDEV MATERIALS PRIVATE LIMITED",
"ADDGROWTH MEDIA PRIVATE LIMITED",
"ADDHAR HOUSING FINANCE LIMITED",
"ADDHYA FOREX PRIVATE LIMITED",
"ADDI ALLOYS PRIVATE LIMITED",
"ADDI INDUSTRIES LIMITED",
"ADDICTIVE LEARNING TECHNOLOGY LIMITED",
"ADDICTIVE LEARNING TECHNOLOGY PRIVATE LIMITED",
"ADDII BIOTECH PRIVATE LIMITED",
"ADDIKIIN TECHNOLOGY PRIVATE LIMITED",
"ADDINOL LUBE OIL INDIA PRIVATE LIMITED",
"ADDINOVA INGREDIENTS (INDIA) PRIVATE LIMITED",
"ADDISON & CO LIMITED",
"ADDISON BIOLOGICAL PRIVATE LIMITED",
"ADDISON CABLE PRIVATE LIMITED",
"ADDISON INFRASTRUCTURE PRIVATE LIMITED",
"ADDISSUN LIFESCIENCE PRIVATE LIMITED",
"ADDISTRO TECHNOLOGIES PRIVATE LIMITED",
"ADDITH BEDLINENS PRIVATE LIMITED",
"ADDITIONAL ASSISTANT ELIMENTARY EDUCATIONAL OFFICE",
"ADDITIONAL CHIEF ENGINEER CUM ELECTRICAL INSPECTOR BHUBANESWAR",
"ADDITIONAL CHIEF ENGINEER,MECHANICAL CIRCLE,HIRAKUD ,BURLA",
"ADDITIONAL COMMISSIONER OF COMMERCIAL TAX JABALPUR MADHYA PRADESH",
"ADDITIONAL PRINCIPAL CHIEF CONSERVATOR OF FORESTS WEST, MUMBAI",
"ADDITIONAL SESSION DISTRICT COURT VAPI",
"ADDITIONAL SKILL ACQUISITION PROGRAMME KERALA",
"ADDITIONAL TAHSILDAR BELA TALUKA UMRED",
"ADDL ASSTT DEVELOPMENT COMMISSIONER(CEO JANPAD) PANAGAR JBP",
"ADDL COLLECTOR UDR 104479",
"ADDL COMMISSIONER OF COMMERCIAL TAX MP INDORE",
"ADDL DIR H C M R I P A UDAIPUR409",
"ADDL JUDGE FOR DISTRICT AND SESSION JUDGE INDORE",
"ADDL LABOUR COMMISSIONER KANPUR",
"ADDLER ENGINEERING SOLUTIONS PRIVATE LIMITED",
"ADDLIFE COATING SYSTEMS PRIVATE LIMITED",
"ADDMAX TECHNOLOGIES PRIVATE LIMITED",
"ADDNECTAR SOLUTIONS PRIVATE LIMITED",
"ADDNODE INDIA PRIVATE LIMITED",
"ADDON CONCEPTS",
"ADDON ENGINEERING PRIVATE LIMITED",
"ADDON ENTERPRISES PRIVATE LIMITED",
"ADDON EXPORT HOUSE LIMITED",
"ADDON HOLDINGS PRIVATE LIMITED",
"ADDON MANPOWER SOLUTIONS PRIVATE LIMITED",
"ADDON SOLUTIONS PRIVATE LIMITED",
"ADDON TRIP PRIVATE LIMITED",
"ADDONIX TECHNOLOGIES PRIVATE LIMITED",
"ADDONN POLYCOMPOUNDS PRIVATE LIMITED",
"ADD-ONS INTERIORS (INDIA) PVT LTD",
"ADDOR REALTY PRIVATE LIMITED",
"ADDPRINT INDIA ENTERPRISES PRIVATE LIMITED",
"ADDPRO NETWORK PRIVATE LIMITED",
"ADDREC SOLUTIONS PRIVATE LIMITED",
"ADDRESS HOME RETAIL PRIVATE LIMITED",
"ADDRESS INFRASTRUCTURES PRIVATE LIMITED",
"ADDRESS INFRATECH OPC PRIVATE LIMITED",
"ADDRESS MAKER LIFE SPACES PRIVATE LIMITED",
"ADDRESSHEALTH SOLUTIONS INDIA PRIVATE LIMITED",
"ADDRESSOFCHOICE REALTY PRIVATE LIMITED",
"ADDS PROJECTS PRIVATE LIMITED",
"ADDTECH PACKAGING PRIVATE LIMITED",
"ADDTITANS DIGITAL PRIVATE LIMITED",
"ADDUCO ENGINEERING SOLUTIONS PRIVATE LIMITED",
"ADDV HEALTHTECH SOLUTIONS PRIVATE LIMITED",
"ADDVAL SOLUTIONS PRIVATE LIMITED",
"ADDVALUE INTERNATIONAL PRIVATE LIMITED",
"ADDVALUE WELLNESS SCIENCE SERVICES PRIVATE LIMITED",
"ADDVERB TECHNOLOGIES LIMITED",
"ADDVERB TECHNOLOGIES PRIVATE LIMITED",
"ADDVET FARM CARE PRIVATE LIMITED",
"ADDWATT POWER SOLUTIONS PRIVATE LIMITED",
"ADDWAYA CHEMICALS PRIVATE LIMITED",
"ADDWEB SOLUTION PRIVATE LIMITED",
"ADDWELL LABELS PRIVATE LIMITED",
"ADDWRAP PACKAGING PRIVATE LIMITED",
"ADDYA MULTISERVICES PRIVATE LIMITED",
"ADDYA SAKTI COLD STORAGE PVT LTD",
"ADDYS FOOD PROCESSORS PRIVATE LIMITED",
"ADDYUTHIYA POWER PROJECTS PRIVATE LIMITED",
"ADDZOL OIL (INDIA) PRIVATE LIMITED",
"ADECCO INDIA PRIVATE LIMITED",
"ADECO CONSULTANTS OPC PRIVATE LIMITED",
"ADECO ENERGY INDIA PRIVATE LIMITED",
"ADECO WORKFORCE SOLUTIONS",
"ADECON SERVICES PRIVATE LIMITED",
"ADEELITE DESIGN CONSULTANTS PRIVATE LIMITED",
"ADEEN HEALTH CARE PRIVATE LIMITED",
"ADEEP CONSTRUCTION COMPANY PRIVATE LIMITED",
"ADEEP LIFE SCIENCES PRIVATE LIMITED",
"ADEESH AGRO PVT. LTD.",
"ADEESH PACKAGING PRIVATE LIMITED",
"ADEKA INDIA PRIVATE LIMITED",
"ADEKAR ENTERPRISES PRIVATE LIMITED",
"ADEL ASSESORIES PRIVATE LIMITED",
"ADEL SHIPPING & LOGISTICS LIMITED.",
"ADELA ELECTRICALS PRIVATE LIMITED",
"ADELA LABS PVT LTD",
"ADELA SOFTWARE AND SERVICES PRIVATE LIMITED",
"ADELEMENT MEDIA SOLUTIONS PRIVATE LIMITED",
"ADELINE PHARMA PRIVATE LIMITED",
"ADELPHI TECHNOLOGIES PRIVATE LIMITED",
"ADEN PATHI AUTOMOBILE PRIVATE LIMITED",
"ADEN PHARMACEUTICALS PRIVATE LIMITED",
"ADENIUM GARDENS PRIVATE LIMITED",
"ADENWALA MARBLES PRIVATE LIMITED",
"ADENZA INDIA PRIVATE LIMITED",
"ADEON MEDIA TECHNOLOGIES PRIVATE LIMITED",
"ADEPT ARTVERTISING SOLUTIONS PRIVATE LIMITED",
"ADEPT CHIP SERVICES PRIVATE LIMITED",
"ADEPT CONCEPTS PRIVATE LIMITED",
"ADEPT CONTRACT PRIVATE LIMITED",
"ADEPT ENERGY SOLUTIONS PRIVATE LIMITED",
"ADEPT FLUIDYNE PRIVATE LIMITED",
"ADEPT IMPEX PRIVATE LIMITED",
"ADEPT INDIA",
"ADEPT INFORMATION SERVICES PRIVATE LIMITED",
"ADEPT INTERIORS PRIVATE LIMITED",
"ADEPT LEGAL SOLUTIONS PRIVATE LIMITED",
"ADEPT MINING PRIVATE LIMITED",
"ADEPT PEOPLE STAFFING SOLUTIONS PRIVATE LIMITED",
"ADEPT PHARMA AND BIOSCIENCE EXCELLENCE PRIVATE LIMITED",
"ADEPT POWER PRIVATE LIMITED",
"ADEPT RESOURCE TRAINING SERVICES PRIVATE LIMITED",
"ADEPT SOFTWARE AVENUES PRIVATE LIMITED",
"ADEPT STEELS INDIA PRIVATE LIMITED",
"ADEPT TELECOMM PRIVATE LIMITED",
"ADEPTECH SYSTEMS PRIVATE LIMITED",
"ADEPTIA INDIA PRIVATE LIMITED",
"ADEPTIQ SOLUTIONS PRIVATE LIMITED",
"ADEPTUS TECHNOLOGIES PRIVATE LIMITED",
"ADEQUATE BOOKKEEPING SERVICES LLP",
"ADEQUATE INFOSOFT PRIVATE LIMITED",
"ADESARA JAYANTILAL SHANTILAL JEWELLERS PRIVATE LIMITED",
"ADESH ALLOYS PRIVATE LIMITED",
"ADESH BROKING HOUSE PRIVATE LIMITED",
"ADESH DENIM PRIVATE LIMITED",
"ADESH FOUNDATION, MUKTSAR",
"ADESH HOSPITAL AND RESEARCH CENTRE PVT LTD",
"ADESH MEDICAL COLLEGE AND HOSPITAL",
"ADESH PROJECTS PRIVATE LIMITED",
"ADESH REALCON PRIVATE LIMITED",
"ADESHWAR ASSOCIATE NX",
"ADESHWAR ELECTRICALS PRIVATE LIMITED",
"ADESHWAR FOODS PRIVATE LIMITED",
"ADESHWAR IMPEX PRIVATE LIMITED",
"ADESHWAR MEDITEX LIMITED",
"ADESHWAR MOULDS PRIVATE LIMITED",
"ADESHWARA CEMENT COMPANY PRIVATE LTD",
"ADESWAR GRANITES PRIVATE LIMITED",
"ADEVYA SPORTS PRIVATE LIMITED",
"ADEX COMPOSITES PRIVATE LIMITED",
"ADEX DIGITAL SOLUTION PRIVATE LIMITED",
"ADEX POLYBLEND PRIVATE LIMITED",
"ADF DATA SCIENCE PRIVATE LIMITED",
"ADF FOODS LIMITED",
"ADF TRADING PRIVATE LIMITED",
"ADFACTORS PR PRIVATE LIMITED",
"ADFERT TECHNOLOGIES PRIVATE LIMITED",
"ADFINITY GLOBAL SOLUTIONS PRIVATE LIMITED",
"ADFLUENCE HUB PRIVATE LIMITED",
"ADG AGROTECH PRIVATE LIMITED",
"ADG EDUCATION",
"ADG FILTER SCIENCE PRIVATE LIMITED",
"ADG HOMES PRIVATE LIMITED",
"ADG ONLINE SOLUTIONS PRIVATE LIMITED",
"ADGEAR MEDIA PRIVATE LIMITED",
"ADGLOBAL360 INDIA PRIVATE LIMITED",
"ADGRAM COMUNICATIONS PRIVATE LIMITED",
"ADGULLY NETWORK PRIVATE LIMITED",
"ADGUMS PRIVATE LIMITED",
"ADGYL LIFESCIENCES PRIVATE LIMITED",
"ADH CHEMICALS PRIVATE LIMITED",
"ADH LABS PRIVATE LIMITED",
"ADH POLYMERS PVT LTD",
"ADHAAN SOLUTION PRIVATE LIMITED",
"ADHANE INDUSTRIES PRIVATE LIMITED",
"ADHANE MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"ADHAR BUILDCON INDIA PRIVATE LIMITED",
"ADHARSH VIDHYALAYA MATRICULATION HR SEC SCHOOL",
"ADHARSHILA FOR SUSTAINABLE SOCIO-ECONOMI C TRANSFORMATION AND WELFARE",
"ADHARSHILA STRUCTURES PRIVATE LIMITED",
"ADHARSILA HOMES PRIVATE LIMITED",
"AD-HASH TECHNOLABS PRIVATE LIMITED",
"ADHATA GLOBAL LIMITED",
"ADHAVAN DIABETES FOUNDATION INDIA PRIVATE LIMITED",
"ADHAVAN GROUP OF COMPANIES",
"ADHAVAN STEELS PRIVATE LIMITED",
"ADHAYANARTH PUBLISHING PRIVATE LIMITED",
"ADHAYNIMIT ENGINEER'S PRIVATE LIMITED",
"ADHBHUT INFRASTRUCTURE LIMITED",
"ADHERE BONDS COATS PRIVATE LIMITED",
"ADHERE FOUNDATION",
"ADHESWARA (EXPORTS) PRIVATE LIMITED",
"ADHESWARA ALUM PRIVATE LIMITED",
"ADHESWARA CHEMICALS PRIVATE LIMITED",
"ADHI ARIHANT PRESS TOOL PRIVATE LIMITED",
"ADHI AUTOMATION INDIA PRIVATE LIMITED",
"ADHI COLLEGE OF ENGINEERING AND TECHNOLOGY",
"ADHI SAKTHI PROJECTS PRIVATE LIMITED",
"ADHI SOFTWARE PRIVATE LIMITED",
"ADHI SPECIALITY HOSPITAL PRIVATE LIMITED",
"ADHI TYRES PRIVATE LIMITED",
"ADHIAM THERMAL SYSTEMS & SOLUTIONS PRIVATE LIMITED",
"ADHIANNAM COIR COMFORTS PRIVATE LIMITED",
"ADHIEV INDIA PRIVATE LIMITED",
"ADHIGUM MARKETING AND CONSULTANCY SOLUTIONS PRIVATE LIMITED",
"ADHIK RANGOLI FOODS EXIM PRIVATE LIMITED",
"ADHIK RESORT INDIA PRIVATE LIMITED",
"ADHIKAR MICROFINANCE PRIVATE LIMITED",
"ADHIKARI ENGINEERING PRIVATE LIMITED",
"ADHIKARY LEGAL LLP",
"ADHIKHAH MECHNEERING SOLUTIONS PRIVATE LIMITED",
"ADHIKSHAK BHU ABHILEKH NIYAMIT JABALPUR",
"ADHIKSYAK BHU ABHILEKH NIYAMIT JABALPUR",
"ADHILAKSHMI SPINNING MILLS PRIVATE LIMITED",
"ADHINAYAK PROJECTS PRIVATE LIMITED",
"ADHIPARASAKTHI COLLEGE OF ARTS AND SCIENCE",
"ADHIPARASAKTHI COLLEGE OF ENGINEERING",
"ADHIPARASAKTHI MATRICULATION HIGHER SECONDARY SCHOOL",
"ADHIPATHI MINERALS & CHEMICALS PRIVATE LIMITED",
"ADHIR TECHNOCAST PRIVATE LIMITED",
"ADHIRA COMMUNICATIONS PRIVATE LIMITED",
"ADHIRA MEDVICE PRIVATE LIMITED",
"ADHIRAAJ AGRO & SPICES PRIVATE LIMITED",
"ADHIRAAJ CORPORATE ADVISORY SERVICES PRIVATE LIMITED",
"ADHIRAJ CONSTRUCTIONS PRIVATE LIMITED",
"ADHIRAJ FOOD PRODUCTS PRIVATE LIMITED",
"ADHIRAJ METAFLUX PRIVATE LIMITED",
"ADHISHAK SAMUDYIK SWASTH KENDRA",
"ADHISHAKTHI CASTINGS PRIVATE LIMITED",
"ADHISHRI PLASTICS AND TECHNOLOGIES PRIVATE LIMITED",
"ADHISHRI TECHNOLOGIES",
"ADHISHSI ABHIYANTA LKO KHAND SHARDA NAHAR LKO",
"ADHISHTAN INVESTMENTS INDIA PRIVATE LIMITED",
"ADHIST GARMENT EXPORT PRIVATE LIMITED",
"ADHISTHA INFRACON PRIVATE LIMITED",
"ADHITHYAN PACKERS PRIVATE LIMITED",
"ADHUNIK AKSHAT UDYOG PRIVATE LIMITED",
"ADHUNIK AUTOMATION INDIA",
"ADHUNIK AUTOMOTIVES PRIVATE LIMITED",
"ADHUNIK CONSTRUCTION (INDIA) PRIVATE LIMITED",
"ADHUNIK COOLING SYSTEM PRIVATE LIMITED",
"ADHUNIK CORPORATION LIMITED",
"ADHUNIK COTTON MILLS PRIVATE LIMITED",
"ADHUNIK CROP CARE PRIVATE LIMITED",
"ADHUNIK DEALCOM PRIVATE LIMITED",
"ADHUNIK ELECTRO CONTROLS PRIVATE LIMITED",
"ADHUNIK ENERGY SOLUTIONS PRIVATE LIMITED",
"ADHUNIK FERTICHEM LIMITED",
"ADHUNIK FREIGHT CARRIERS PRIVATE LIMITED",
"ADHUNIK FUELS PRIVATE LIMITED",
"ADHUNIK INFOTECH LIMITED",
"ADHUNIK INFRASTRUCTURES PRIVATE LIMITED",
"ADHUNIK INFRATECH INDIA PRIVATE LIMITED",
"ADHUNIK MANPOWER SERVICES PRIVATE LIMITED",
"ADHUNIK MARKETING PRIVATE LIMITED",
"ADHUNIK METALIKS LIMITED",
"ADHUNIK NIRYAT ISPAT LIMITED",
"ADHUNIK PACKAGERS PVT LTD",
"ADHUNIK POLYTEX LIMITED",
"ADHUNIK POWER & NATURAL RESOURCES LIMITED",
"ADHUNIK POWER TRANSMISSION LIMITED",
"ADHUNIK SERVICE MANAGEMENT PRIVATE LIMITED",
"ADHUNIK STEELS LIMITED",
"ADHUNIK SWITCHGEARS PVT LTD",
"ADHUNIK TECHNO ENGINEERS PRIVATE LIMITED",
"ADHUNIK TRANSPORT ORGANISATION LIMITED",
"ADHUNIK VATANUKOOL PRIVATE LIMITED",
"ADHUNIK YANTRA UDYOG PRIVATE LIMITED : CO. LISTING",
"ADHUNNIK MERCANTILE PRIVATE LIMITED",
"ADHYA DESIGN PRIVATE LIMITED",
"ADHYA PHARMACEUTICALS PRIVATE LIMITED",
"ADHYALAXMI INDUSTRIAL RUBBER AND POLYMERS PRIVATE LIMITED",
"ADHYANTA ENGINEERING PRIVATE LIMITED",
"ADHYANTHA TECHNOLOGIES (OPC) PRIVATE LIMITED",
"ADHYAPAK MAHAVIDYALAYA",
"ADHYAPANA SCHOOL CBSE",
"ADHYASHAKTI AGRO PRIVATE LIMITED",
"ADHYASHAKTI PAPER PRIVATE LIMITED",
"ADI AQUA PROJECTS PRIVATE LIMITED",
"ADI ARTECH TRANSDUCERS PRIVATE LIMITED",
"ADI ATHARAV PHARMACEUTICALS PRIVATE LIMITED",
"ADI BACKOFFICE PROFESSIONALS PRIVATE LIMITED",
"ADI BPO SERVICES LIMITED",
"ADI BUILDCON PRIVATE LIMITED",
"ADI CHITRAGUPTA FINANCE LIMITED",
"ADI COMMERCIALS PRIVATE LIMITED",
"ADI DIAGNOSTICS PRIVATE LIMITED",
"ADI DURGA STEEL PRIVATE.LIMITED",
"ADI ELECTRONICS MANUFACTURING TECHNOLOGIES PRIVATE LIMITED",
"ADI ENTERPRISES",
"ADI HI TECH TEXTILES PRIVATE LIMITED",
"ADI INSULATIONS PRIVATE LIMITED",
"ADI MEDIA PRIVATE LIMITED",
"ADI MOHINI MOHAN KANJILAL MARKETING PRIVATE LIMITED",
"ADI READYMADE CENTRE PRIVATE LIMITED",
"ADI SHRI INFRA POWER ELECTRICALS PRIVATE LIMITED",
"ADI SPORTS (INDIA) PRIVATE LIMITED",
"ADI SURYA AUTO SPRINGS PRIVATE LIMITED",
"ADIAARJ TECHNOLOGIES PRIVATE LIMITED",
"ADIAMBE PAPERS PRIVATE LIMITED",
"ADICHEM TECHNOLOGY PRIVATE LIMITED",
"ADICO ESCORTS AGRI EQUIPMENTS PRIVATE LIMITED",
"ADICO SPARES PRIVATE LIMITED",
"ADICON INFRASTRUCTURE PRIVATE LIMITED",
"ADIDAS INDIA MARKETING PRIVATE LIMITED",
"ADIDAS INDIA PRIVATE LIMITED",
"ADIDAS TECHNICAL SERVICES PRIVATE LIMITED",
"ADIDEV COMMODITIES PRIVATE LIMITED",
"ADIDEV FREIGHT SERVICES PRIVATE LIMITED",
"ADIDEV GLOBAL INFO SERVICES PRIVATE LIMITED",
"ADIDEV REALTORS PRIVATE LIMITED",
"ADIDEV TECHNOA PRIVATE LIMITED",
"ADIDEVA AUTO SYSTEMS PRIVATE LIMITED",
"ADIE BROSWON BREWERIES PRIVATE LIMITED",
"ADIENCE PHARMA PRIVATE LIMITED",
"ADIENT INDIA PRIVATE LIMITED",
"A-DIET HOSPITALITY SERVICE LIMITED",
"ADIFAB INDUSTRIES PRIVATE LIMITED",
"ADIFLEX NARROW FABRICS PRIVATE LIMITED",
"ADIH BIZTECH PRIVATE LIMITED",
"ADIIDADA METALS PRIVATE LIMITED",
"ADIIN CARE PRIVATE LIMITED",
"ADIKAN HEALTHCARE PRIVATE LIMITED",
"ADIKANKSHA IMPEX PRIVATE LIMITED",
"ADIKANSHA INDIA PRIVATE LIMITED",
"ADIKARAH AMENITIES PRIVATE LIMITED",
"ADIKAVI NANNAYA UNIVERSITY",
"ADIKO ELECTRONICS PRIVATE LIMITED",
"ADIL IMPEX INDIA LIMITED",
"ADIL TEXTILES PRIVATE LIMITED",
"ADILA BIOTECH PRIVATE LIMITED",
"ADILAB TECHNOLOGIES PRIVATE LIMITED",
"ADILABAD EXPRESSWAY PRIVATE LIMITED",
"ADILABS CONSULTING SERVICES PRIVATE LIMITED",
"ADILAKSHMI ENTERPRISES LIMITED",
"ADILON SYNTHETICS PVT LTD",
"ADILQADRI E-COMMERCE PRIVATE LIMITED",
"ADIMA DEVELOPERS PRIVATE LIMITED",
"ADIMA ORGANICS (INDIA) PRIVATE LIMITED",
"ADINAN LIFESTYLE LIMITED",
"ADINARAYAN ASSOCIATES PRIVATE LIMITED",
"ADINATH AGRO PROCESSED FOODS PRIVATE LIMITED",
"ADINATH BATH FITT PRIVATE LIMITED",
"ADINATH BUILDWELL PRIVATE LIMITED",
"ADINATH CAPITAL SERVICES LIMITED",
"ADINATH CARS PRIVATE LIMITED",
"ADINATH COLOUR & PRINT PRIVATE LIMITED",
"ADINATH CONSTRUCTIONS PRIVATE LIMITED",
"ADINATH CONTROLS PRIVATE LIMITED",
"ADINATH ELASTIC PRIVATE LIMITED",
"ADINATH ELECTRICALS PRIVATE LIMITED",
"ADINATH EXTRUSION PRIVATE LIMITED",
"ADINATH FABRICS PRIVATE LIMITED",
"ADINATH FIN TRADE PRIVATE LIMITED",
"ADINATH FLOUR MILLS PRIVATE LIMITED",
"ADINATH FORGING PRIVATE LIMITED",
"ADINATH FOUNDATIONS PRIVATE LIMITED",
"ADINATH FURNITURE PRIVATE LIMITED",
"ADINATH GEMS PRIVATE LIMITED",
"ADINATH INDUSTRIES",
"ADINATH INTERNATIONAL PRIVATE LIMITED",
"ADINATH IRRIGATION SYSTEMS PRIVATE LIMITED",
"ADINATH JEWELLERY EXPORTS",
"ADINATH MACHINE & TOOLING",
"ADINATH POLY PLAST PRIVATE LIMITED",
"ADINATH PRIME DEVELOPERS PRIVATE LIMITED",
"ADINATH PROPERTIES PRIVATE LIMITED",
"ADINATH PUBLIC SCHOOL",
"ADINATH RECYCLOTRONIX PRIVATE LIMITED",
"ADINATH SILKS LIMITED",
"ADINATH TEX CHEM LIMITED",
"ADINATH VETERINARY PRODUCTS PRIVATE LIMITED",
"ADINFINITUM MEDIA NETWORK PRIVATE LIMITED",
"ADINITY VENTURES (OPC) PRIVATE LIMITED",
"ADINO TELE SERVICES LIMITED",
"ADINO TELECOM LIMITED",
"ADINSTRUMENTS SOUTH ASIA (INDIA) PRIVATE LIMITED",
"ADIONA TRAVELS PRIVATE LIMITED",
"ADIPS LABORATORIES LIMITED",
"ADIQUITY TECHNOLOGIES PRIVATE LIMITED",
"ADIRA TECH SERVICES PRIVATE LIMITED",
"ADIRA TECHNOLOGIES PRIVATE LIMITED",
"ADIRAJ MANPOWER SERVICES PRIVATE LIMITED",
"ADIRAJ PAPER PRODUCTS PRIVATE LIMITED",
"ADIRAJ REALTORS PRIVATE LIMITED",
"ADIRAN IB HEALTHCARE PRIVATE LIMITED",
"ADIROHA SOLUTIONS OPC PRIVATE LIMITED",
"ADIS ENTERPRISES PRIVATE LIMITED",
"ADISA LOGISTICS PRIVATE LIMITED",
"ADISAN LABORATORIES PRIVATE LIMITED",
"ADISANKARA SPINNING MILLS PRIVATE LIMITED",
"ADISASO GLOBAL PRIVATE LIMITED",
"ADISATTVA HEALTHCARE PRIVATE LIMITED",
"ADISH ASSOCIATES PRIVATE LIMITED",
"ADISH FABRICS PVT LTD",
"ADISH HEALTHCARE SERVICES",
"ADISH INFORMATICS PRIVATE LIMITED",
"ADISH PLASTICS PRIVATE LIMITED",
"ADISH SEATING COLLECTION PRIVATE LIMITED",
"ADISHAKTI AUTOMOBILES PRIVATE LIMITED",
"ADISHAKTI CARS PRIVATE LIMITED",
"ADISHAKTI ICE & COLD STORAGE PRIVATE LIMITED",
"ADISHAKTI INDUSTRIES PRIVATE LIMITED",
"ADISHAKTI SMELTERS PRIVATE LIMITED",
"ADISHAKTI STEELS PRIVATE LIMITED",
"ADISHANK CHEMICALS PRIVATE LIMITED",
"ADISHIV FORGE PVT LTD",
"ADISHRI ELECTROMECH PRIVATE LIMITED",
"ADISHRRI MANAGEMENT SERVICES PRIVATE LIMITED",
"ADISHWAR AUTO DIAGNOSTICS PRIVATE LIMITED",
"ADISHWAR AUTO RIDE INDIA PRIVATE LIMITED",
"ADISHWAR IMPEX PRIVATE LIMITED",
"ADISHWAR INDIA LIMITED",
"ADISHWAR INFRASTRUCTURE PRIVATE LIMITED",
"ADISHWAR ORGANIC PRIVATE LIMITED",
"ADISHWAR REAL ESTATE PRIVATE LIMITED",
"ADISHWAR TELE-NETWORKS PRIVATE LIMITED",
"ADISOFT TECHNOLOGIES PRIVATE LIMITED",
"ADISON LOGISTICS AND WAREHOUSING PRIVATE LIMITED",
"ADISON RESORTS LIMITED",
"ADISOY FOODS & BEVERAGES PRIVATE LIMITED",
"ADISSEO ANIMAL NUTRITION PRIVATE LIMITED",
"ADISTALO INDIA PRIVATE LIMITED",
"ADI-SUROVI MANSION GEMS & JEWEL (I) PRIVATE LIMITED",
"ADIT BUILDWELL PRIVATE LIMITED",
"ADIT CONTAINERS PRIVATE LIMITED",
"ADIT INTERNATIONAL PLASTIC PRODUCTS PRIVATE LIMITED",
"ADIT MERCANTILES PRIVATE LIMITED",
"ADIT MICROSYS PRIVATE LIMITED",
"ADIT PHARMA PRIVATE LIMITED",
"ADIT SECURITY SYSTEM PRIVATE LIMITED",
"ADITAC SOLUTIONS & SERVICES PRIVATE LIMITED",
"ADITECH ICT PRIVATE LIMITED",
"ADITECH PLASTICS PRIVATE LIMITED",
"ADITEE BUILDCON PRIVATE LIMITED",
"ADITEE SEAFOOD PRIVATE LIMITED",
"ADITH PLASTIC",
"ADITHI AGRO MARKETING PRIVATE LIMITED",
"ADITHIYA MANAGEMENT & SOLUTIONS PRIVATE LIMITED",
"ADITHIYAN ENTERPRISES",
"ADITHYA ACADEMY",
"ADITHYA AUTOMOTIVE APPLICATIONS PRIVATE LIMITED",
"ADITHYA CARTONS",
"ADITHYA FERRO ALLOYS PRIVATE LIMITED",
"ADITHYA PRO-TECT PRIVATE LIMITED",
"ADITHYA TOUR OPERATORS INDIA PRIVATE LIMITED",
"ADITHYAPOWER PRIVATE LIMITED",
"ADITI AIRCONDITIONING PRIVATE LIMITED",
"ADITI BROOMS PRIVATE LIMITED",
"ADITI COMMUNICATIONS PRIVATE LIMITED",
"ADITI CREATION",
"ADITI ELECTRONICS PRIVATE LIMITED",
"ADITI ENTERPRISES PVT LTD",
"ADITI FOODS (INDIA)PRIVATE LIMITED",
"ADITI GREEN RENEWABLE ENERGY PRIVATE LIMITED",
"ADITI INDUSTRIES",
"ADITI INFRA AND AGRI PRODUCTS PRIVATE LIMITED",
"ADITI INFRABUILD & SERVICES LIMITED",
"ADITI INFRAPROJECTS (INDIA) PRIVATE LIMITED",
"ADITI INFRAWORKS PRIVATE LIMITED",
"ADITI IRRIGATION TECHNOLOGIES PRIVATE LIMITED",
"ADITI IT SERVICES PRIVATE LIMITED",
"ADITI MEP SERVICES PRIVATE LIMITED",
"ADITI ORGANIC CERTIFICATIONS PRIVATE LIMITED",
"ADITI PHARMACEUTICALS PVT LTD",
"ADITI POWER EQUIPMENTS PRIVATE LIMITED",
"ADITI PROPERTIES PRIVATE LIMITED",
"ADITI ROAD LINK PRIVATE LIMITED",
"ADITI SILK MILLS PRIVATE LIMITED",
"ADITI SOLAR PRIVATE. LIMITED.",
"ADITI SPACE SAVING FURNITURE PRIVATE LIMITED",
"ADITI SPECIALTY PACKING PRIVATE LIMITED",
"ADITI TECH CONSULTING PRIVATE LIMITED",
"ADITI TELELINK PRIVATE LIMITED",
"ADITI TOYS PRIVATE LIMITED",
"ADITI TRACKING SUPPORT PRIVATE LIMITED",
"ADITI WELLNESS PRIVATE LIMITED",
"ADITIBHUMI VENTURES PRIVATE LIMITED",
"ADITRAJ AUTO PVT LTD",
"ADITRI VAISHNO INFRA PRIVATE LIMITED",
"ADITRRI PLAST PRIVATE LIMITED",
"ADITT & MINTT INDUSTRIES PRIVATE LIMITED",
"ADITY DESIGNS PRIVATE LIMITED",
"ADITYA AGRI TECH PRIVATE LIMITED",
"ADITYA AGRIPACK PRIVATE LIMITED",
"ADITYA AGRO FOODS",
"ADITYA AIR PRODUCTS PRIVATE LIMITED",
"ADITYA AIRCON & SERVICES PRIVATE LIMITED",
"ADITYA ALUMINIUM PRIVATE LIMITED",
"ADITYA ARAV DEV-CONS CO. PRIVATE LIMITED",
"ADITYA AUTO COMPONENTS",
"ADITYA AUTO ENGINEERING",
"ADITYA AUTO INDUSTRIES",
"ADITYA AUTO MOBILE SPARES PRIVATE LIMITED",
"ADITYA AUTO PRODUCTS & ENGINEERING INDIA PRIVATE LIMITED",
"ADITYA AUTOMOBILES",
"ADITYA AUTORENTALS PRIVATE LIMITED",
"ADITYA AVENUE MEGACORP PRIVATE LIMITED",
"ADITYA BETTER CONTAINERS PVT. LTD.,",
"ADITYA BHARDWAJ INFRATOWER PRIVATE LIMITED",
"ADITYA BIRLA AHURA CENTRE MANAGEMENT PRIVATE LIMITED",
"ADITYA BIRLA ARC LIMITED",
"ADITYA BIRLA CAPITAL",
"ADITYA BIRLA CAPITAL DIGITAL LIMITED",
"ADITYA BIRLA CAPITAL FOUNDATION",
"ADITYA BIRLA CAPITAL TECHNOLOGY SERVICES LIMITED",
"ADITYA BIRLA CHEMICALS INDIA LIMITED",
"ADITYA BIRLA DIGITAL FASHION VENTURES LIMITED",
"ADITYA BIRLA EDUCATION TRUST",
"ADITYA BIRLA FASHION AND RETAIL LIMITED",
"ADITYA BIRLA FINANCE LIMITED",
"ADITYA BIRLA FINANCIAL SHARED SERVICES LIMITED",
"ADITYA BIRLA GARMENTS LIMITED",
"ADITYA BIRLA GLOBAL TRADING",
"ADITYA BIRLA GLOBAL TRADING (INDIA) PRIVATE LIMITED",
"ADITYA BIRLA HEALTH INSURANCE CO. LIMITED",
"ADITYA BIRLA HEALTH SERVICES LIMITED",
"ADITYA BIRLA HEALTH SERVICES PRIVATE LIMITED",
"ADITYA BIRLA HOSTEL FOR WORKING WOMEN",
"ADITYA BIRLA HOUSING FINANCE LIMITED",
"ADITYA BIRLA INSULATORS LIMITED",
"ADITYA BIRLA INSURANCE BROKERS LIMITED",
"ADITYA BIRLA INTEGRATED SCHOOL",
"ADITYA BIRLA MANAGEMENT CORPORATION PRIVATE LIMITED",
"ADITYA BIRLA MONEY INSURANCE ADVISORY SERVICES LIMITED",
"ADITYA BIRLA MONEY LIMITED",
"ADITYA BIRLA MONEY MART LIMITED",
"ADITYA BIRLA NEW AGE PRIVATE LIMITED",
"ADITYA BIRLA NUVO LIMITED",
"ADITYA BIRLA ONLINE FASHION",
"ADITYA BIRLA PE ADVISORS PRIVATE LIMITED",
"ADITYA BIRLA POWER COMPOSITES LIMITED",
"ADITYA BIRLA PUBLIC SCHOOL GULBARGA",
"ADITYA BIRLA PUBLIC SCHOOL NATHDWARA",
"ADITYA BIRLA PULP AND FIBER NAGDA",
"ADITYA BIRLA RENEWABLES ENERGY LIMITED",
"ADITYA BIRLA RENEWABLES GREEN POWER PRIVATE LIMITED",
"ADITYA BIRLA RENEWABLES LIMITED",
"ADITYA BIRLA RENEWABLES SOLAR LIMITED",
"ADITYA BIRLA RENEWABLES SPV 1 LIMITED",
"ADITYA BIRLA RENEWABLES SUBSIDIARY LIMITED",
"ADITYA BIRLA RENEWABLES UTKAL LIMITED",
"ADITYA BIRLA SCIENCE AND TECHNOLOGY COMPANY PRIVATE LIMITED",
"ADITYA BIRLA SOLAR LIMITED",
"ADITYA BIRLA STRESSED ASSET AMC PRIVATE LIMITED",
"ADITYA BIRLA SUN LIFE AMC LIMITED",
"ADITYA BIRLA SUN LIFE INSURANCE COMPANY LIMITED",
"ADITYA BIRLA SUN LIFE PENSION MANAGEMENT LIMITED",
"ADITYA BIRLA SUN LIFE TRUSTEE PRIVATE LIMITED",
"ADITYA BIRLA TRUSTEE COMPANY PRIVATE LIMITED",
"ADITYA BIRLA WELLNESS PRIVATE LIMITED",
"ADITYA BIRLA WORLD ACADEMY",
"ADITYA BOOKS PRIVATE LIMITED",
"ADITYA BULLIONS & BROKING PRIVATE LIMITED",
"ADITYA BUS SERVICES PRIVATE LIMITED",
"ADITYA CAR AUTOMOTIVES PRIVATE LIMITED",
"ADITYA CAR CARE PRIVATE LIMITED",
"ADITYA CARS PRIVATE LIMITED",
"ADITYA CASS MANAGEMENT LIMITED",
"ADITYA CASTALLOY PRIVATE LIMITED",
"ADITYA CLEAN ENERGY SYSTEMS PRIVATE LIMITED",
"ADITYA COAL SUPPLIERS PRIVATE LIMITED",
"ADITYA COLLEGE GWALIOR",
"ADITYA COLLEGE OF ENGINEERING & TECHNOLOGY",
"ADITYA CONSTRUCTION COMPANY INDIA PRIVATE LIMITED",
"ADITYA CONSTRUCTIONS",
"ADITYA CONSUMER MARKETING LIMITED",
"ADITYA CRANES PRIVATE LIMITED",
"ADITYA CRITICARE PRIVATE LIMITED",
"ADITYA CUSTOM CLEARING PRIVATE LIMITED",
"ADITYA CYCLES PVT LTD",
"ADITYA DEGREE COLLEGE",
"ADITYA DEV CONSTRUCTIONS PRIVATE LIMITED",
"ADITYA DEV INFRATECH PRIVATE LIMITED",
"ADITYA DIGITAL TECHNOLOGIES PRIVATE LIMITED",
"ADITYA DISPOMED PRODUCTS PRIVATE LIMITED",
"ADITYA DISTRIBUTORS PRIVATE LIMITED",
"ADITYA DRIER TECH PRIVATE LIMITED",
"ADITYA DUROBUILD PRIVATE LIMITED",
"ADITYA EASTERN (INDIA) AGENCIES PRIVATE LIMITED",
"ADITYA EDUCATIONAL SERVICES PRIVATE LIMITED",
"ADITYA EDUCATIONAL SOCIETY",
"ADITYA ELASTOBOND PVT LTD",
"ADITYA ELECTRONICS PRIVATE LIMITED",
"ADITYA ENGIMACH PRIVATE LIMITED",
"ADITYA ENGINEERING COLLEGE",
"ADITYA ENTERPRISES PRIVATE LIMITED",
"ADITYA ENVIRONMENTAL SERVICES PRIVATE LIMITED",
"ADITYA EPC INFRATEC PRIVATE LIMITED",
"ADITYA EQUIPMENTS PRIVATE LIMITED",
"ADITYA EXPORTS",
"ADITYA EXPRESS CARGO PRIVATE LIMITED",
"ADITYA EXTRACTIONS PVT.LTD.",
"ADITYA FACILITY SERVICES PRIVATE LIMITED",
"ADITYA FILAMENTS PRIVATE LIMITED.",
"ADITYA FILTERATION SYSTEM PRIVATE LIMITED",
"ADITYA FINDINGS PRIVATE LIMITED",
"ADITYA FIN-FAB PVT.LTD",
"ADITYA FLEXIPACK",
"ADITYA FLOUR MILLS PRIVATE LIMITED",
"ADITYA FOOD MANAGEMENT SERVICES PRIVATE LIMITED",
"ADITYA FORGE LIMITED",
"ADITYA FOUNDRY PRIVATE LIMITED",
"ADITYA FREIGHT CONSOLIDATORS PRIVATE LIMITED",
"ADITYA FURNITURE AND INTERIOR PRIVATE LIMITED",
"ADITYA FUTURISTIC TRADING PRIVATE LIMITED",
"ADITYA GENERIC(DRUGS) PRIVATE LIMITED",
"ADITYA GREEN ENERGY PRIVATE LIMITED",
"ADITYA HIGH VACUUM PRIVATE LIMITED",
"ADITYA HI-TECH PRIVATE LIMITED",
"ADITYA HOSPITALS PRIVATE LIMITED",
"ADITYA HOTELS AND HOSPITALITIES PRIVATE LIMITED",
"ADITYA INDUSTECH LIMITED",
"ADITYA INDUSTECH PRIVATE LIMITED",
"ADITYA INFO SERVICES PRIVATE LIMITED",
"ADITYA INFORMATIQUE INDIA PRIVATE LIMITED",
"ADITYA INFOSOLUTIONS PRIVATE LIMITED",
"ADITYA INFOTECH LIMITED",
"ADITYA INFRABUILDCON PRIVATE LIMITED",
"ADITYA INFRADEVELOPERS PRIVATE LIMITED",
"ADITYA INFRAHEIGHTS PRIVATE LIMITED",
"ADITYA INFRASTRUCTURE PRIVATE LIMITED",
"ADITYA INSTITUTE OF MANAGEMENT STUDIES & RESEARCH",
"ADITYA INTERNATIONAL SCHOOL",
"ADITYA INVESTMENTS AND COMMUNICATION LIMITED",
"ADITYA IRRIGATION TECHNOLOGIES PRIVATE LIMITED",
"ADITYA ISOLATOR INDUSTRIES PRIVATE LIMITED",
"ADITYA ISPAT LIMITED",
"ADITYA IT DEVELOPERS PRIVATE LIMITED",
"ADITYA JUTE UDYOG PRIVATE LIMITED",
"ADITYA JYOT EYE HOSPITAL PRIVATE. LIMITED",
"ADITYA KNITS PRIVATE LIMITED",
"ADITYA LAP TECH DEVELOPMENT LAB PRIVATE LIMITED",
"ADITYA LIFELINE PRIVATE LIMITED",
"ADITYA MARINE LIMITED",
"ADITYA MEDI PHARMA PRIVATE LIMITED",
"ADITYA MEDISALES LIMITED",
"ADITYA MEDISCRIPTS PRIVATE LIMITED",
"ADITYA MERUCHEM PRIVATE LIMITED",
"ADITYA METAL TRADING PRIVATE LIMITED",
"ADITYA METALCOAT PRIVATE LIMITED",
"ADITYA MILLS LTD",
"ADITYA MINDA INDUSTRIES PRIVATE LIMITED",
"ADITYA MINERALS PVT LTD",
"ADITYA MODA REALTECH PRIVATE LIMITED",
"ADITYA MOTO (GUJARAT) PRIVATE LIMITED",
"ADITYA MOTOCORP PRIVATE LIMITED",
"ADITYA MOTOR PRIVATE LIMITED",
"ADITYA MULTI SPECIALITY HOSPITAL",
"ADITYA MULTICOM PRIVATE LIMITED",
"ADITYA MULTIPACK SOLUTIONS PRIVATE LIMITED",
"ADITYA MUSIC INDIA PRIVATE LIMITED",
"ADITYA NARASIMHA PHARMACY PRIVATE LIMITED",
"ADITYA NATURE FRESH PRODUCTS (INDIA) PRIVATE LIMITED",
"ADITYA NONWOVEN FABRICS INDIA PRIVATE LIMITED",
"ADITYA OFFSET PROCESS (I) PRIVATE LIMITED",
"ADITYA OIL INDUSTRIES LIMITED",
"ADITYA PACKAGING AND CONSULTING SERVICES PRIVATE LIMITED",
"ADITYA PARK CONSTRUCTIONS PRIVATE LIMITED",
"ADITYA PATHOLOGY LABORATORY",
"ADITYA PERIPHERALS PRIVATE LIMITED",
"ADITYA PETROREFINERY PRIVATE LIMITED",
"ADITYA PLAZA MAKERS PRIVATE LIMITED",
"ADITYA POLYCARE PRIVATE LIMITED",
"ADITYA POLYCONTAINER PRIVATE LIMITED",
"ADITYA POLYMERS LIMITED",
"ADITYA POLYSACK PRIVATE LIMITED",
"ADITYA POLYSPIN PRIVATE LIMITED",
"ADITYA POLYTECHNIC PRIVATE LIMITED",
"ADITYA POLYTUBES PRIVATE LIMITED",
"ADITYA PRECITECH PRIVATE LIMITED",
"ADITYA PRIYA LOGISTICS LIMITED",
"ADITYA PROFESSIONAL SERVICES PRIVATE LIMITED",
"ADITYA PROFILES PRIVATE LIMITED",
"ADITYA PROPELLER (AUTO) PRIVATE LIMITED",
"ADITYA PUMPS PRIVATE LIMITED",
"ADITYA REAL ESTATES AND DEVELOPERS PRIVATE LIMITED",
"ADITYA RENT A CAR PRIVATE LIMITED",
"ADITYA RESTAURANT PRIVATE LIMITED",
"ADITYA RICE INDUSTRIES",
"ADITYA ROBOTICS AND AUTOMATION PRIVATE LIMITED",
"ADITYA ROLLAR FLOUR MILLS PRIVATE LIMITED",
"ADITYA SAI COT SPIN PRIVATE LIMITED",
"ADITYA SCAN-LAB PRIVATE LIMITED",
"ADITYA SCHOOL OF BUSINESS MANAGEMENT",
"ADITYA SEALINK PRIVATE LIMITED",
"ADITYA SOLAR ENERGY PRIVATE LIMITED",
"ADITYA SOLVENTS & CHEMICALS (INDIA) PRIVATE LIMITED",
"ADITYA SPINNERS LIMITED",
"ADITYA SPINTEX PRIVATE LIMITED",
"ADITYA STEEL ROLLING MILLS PVT LTD",
"ADITYA SUNWORLD PRIVATE LIMITED",
"ADITYA SUPER BAZAR PRIVATE LIMITED",
"ADITYA SUPER PUMP INDUSTRIES PRIVATE LIMITED",
"ADITYA SUPER SPECIALITY HOSPITAL TRAUMA CENTER",
"ADITYA SYNTHETICS PVT LTD",
"ADITYA TALENT MANAGEMENT SERVICES PRIVATE LIMITED",
"ADITYA TECHNO PRODUCTS PRIVATE LIMITED",
"ADITYA THERMAL ENERGY PRIVATE LIMITED",
"ADITYA TIMPACK PRIVATE LIMITED",
"ADITYA TRADEMART SPECIALITIES PRIVATE LIMITED",
"ADITYA TRADING SOLUTIONS PRIVATE LIMITED",
"ADITYA TRANSLINK PVT LTD",
"ADITYA ULTRA STEEL LIMITED",
"ADITYA VIDHYALAYA",
"ADITYA VISION LIMITED",
"ADITYA WASTE MANAGEMENT PRIVATE LIMITED",
"ADITYABHUSHAN INFRA PROJECTS PRIVATE LIMITED",
"ADITYAN TRANZKING TRAVELS PRIVATE LIMITED",
"ADITYANARAIN BUILDCITY PRIVATE LIMITED",
"ADITYANARAIN MOTORCYCLES PRIVATE LIMITED",
"ADITYAPUR AUTO CLUSTER",
"ADITYAPUR TOLL BRIDGE COMPANY LIMITED",
"ADITYAPUR WASTE MANAGEMENT PRIVATE LIMITED",
"ADITYARAI INFRASTRUCTURE PRIVATE LIMITED",
"ADITYARAJ AGRI GENETICS PRIVATE LIMITED",
"ADITYARAJ MEDICAL CARE PRIVATE LIMITED",
"ADITYAS CENTRE POINT HOTEL PRIVATE LIMITED",
"ADITYA'S VIVEKANANDA MATRICULATION HIGHER SECONDARY SCHOOL",
"ADITYASAMRAJ NATURAL FOODS PRIVATE LIMITED",
"ADITYASHREE ENGICONS PRIVATE LIMITED",
"ADITYAVANI FACILITY SERVICES PRIVATE LIMITED",
"ADIUVO DIAGNOSTICS PRIVATE LIMITED",
"ADIV PURE NATURE PRODUCTS PRIVATE LIMITED",
"ADIVEER SUPPLIERS PRIVATE LIMITED",
"ADIVERSE TECHNOLOGIES LLP",
"ADIVISION OF PHP CREATIONS PRIVATE LIMITED",
"ADIZES INSTITUTE NEW DELHI PRIVATE LIMITED",
"ADJACENT INDUSTRIAL INDIA PRIVATE LIMITED",
"ADJAVIS CAPITAL PRIVATE LIMITED",
"ADJAVIS DIGITAL PRIVATE LIMITED",
"ADJECTI SOLUTIONS PRIVATE LIMITED",
"ADJETTER MEDIA NETWORK PRIVATE LIMITED",
"ADJM TECHNOLOGIES PRIVATE LIMITED",
"ADJOINT TECHNOLOGIES PRIVATE LIMITED",
"ADJUST SOFTWARE INDIA LLP",
"ADKAR HOSPITAL AND RESEARCH INSTITUTE PRIVATE LIMITED",
"ADKENS AGRO PRIVATE LIMITED",
"ADL AGROTECH LIMITED",
"ADL SP (ADMN) WIRELESS POLICE RAJ JAIPUR",
"ADLAKHA ASSOCIATES PRIVATE LIMITED",
"ADLAKHA FOODS & BEVERAGES RETAIL PRIVATE LIMITED",
"ADLEC SYSTEMS PRIVATE. LIMITED.",
"ADLER ELECTRONICS PRIVATE LIMITED",
"ADLER INDUSTRIAL SERVICES PRIVATE LIMITED",
"ADLER STEELS INDIA PRIVATE LIMITED",
"ADLER WOOD INDIA PRIVATE LIMITED",
"ADLERENSERV PRIVATE LIMITED",
"ADLERS BIO-ENERGY LIMITED",
"ADLEY FORMULATIONS PRIVATE LIMITED",
"ADLEY LAB",
"ADLEY LAB LIMITED",
"ADLIFT MARKETING PRIVATE LIMITED",
"ADLUX MEDICITY AND CONVENTION CENTRE PRIVATE LIMITED",
"ADLY MARKETING PRIVATE LIMITED",
"ADM AGRO INDUSTRIES DHARWAD PRIVATE LIMITED",
"ADM AGRO INDUSTRIES INDIA PRIVATE LIMITED",
"ADM AGRO INDUSTRIES KOTA & AKOLA PRIVATE LIMITED",
"ADM AGRO INDUSTRIES LATUR & VIZAG PRIVATE LIMITED",
"ADM COMMERCIAL PRIVATE LIMITED",
"ADM DEVELOPERS PRIVATE LIMITED",
"ADM ESTATES PRIVATE LIMITED",
"ADM JOINFLEX INDIA PRIVATE LIMITED",
"ADM OFF COMM OF INCOME TAX",
"ADM SOLAR POWER &INFRASTRUCTURE PVT LTD",
"ADM SYSTEMS PRIVATE LIMITED",
"ADM TECHNOLOGIES PRIVATE LIMITED",
"ADMA AUTO COMPONENTS PRIVATE LIMITED",
"ADMA ENGINEERS AND LOGISTICS PRIVATE LIMITED",
"ADMA SOLUTIONS PRIVATE LIMITED",
"ADMAARK EVENTS (INDIA) PRIVATE LIMITED",
"ADMAC LIFESCIENCES",
"ADMACH AUTO INDIA LIMITED",
"ADMACH AUTO INDUSTRIES INDIA PRIVATE LIMITED",
"ADMACH SYSTEMS PRIVATE LIMITED",
"ADMAKE INDIA MEDIA PRIVATE.LIMITED",
"ADMAN FOREX AND SERIVICES PRIVATE LIMITED",
"ADMAN FORMULATION PVT LTD",
"ADMAREN TECH PRIVATE LIMITED",
"ADMARK DIGITECH PRIVATE LIMITED",
"ADMARK POLYCOATS PRIVATE LIMITED",
"ADMEC LOGISTICS LIMITED",
"ADMECH EQUIPMENT INDIA PRIVATE LIMITED",
"ADMED PHARMA PRIVATE LIMITED",
"ADMEK TERMINALS PRIVATE LIMITED",
"ADMERUS BIOSCIENCES PRIVATE LIMITED",
"ADMI PROMOTIONS PRIVATE LIMITED",
"ADMILES AVIATION PRIVATE LIMITED",
"ADMIN OFFICER C M H O BHOPAL",
"ADMIN OFFICER REG MNGT RESERCH INSTITUTE BPL MADHYA PRADESH",
"ADMIN VITRIFIED PRIVATE LIMITED",
"ADMINIDTRATIVE OFFICER DIST FAMILY WELFARE BUREAU Z P",
"ADMINISTRATION OF UT OF DAMAN & DIU",
"ADMINISTRATIVE MEDICAL OFFICER ESI SCHEME MUMBAI",
"ADMINISTRATIVE OFFICER CIP PO KANKEE",
"ADMINISTRATIVE STAFF COLLEGE OF INDIA",
"ADMINSTRATIVE STAFF COLLEGE OF INDIA",
"ADMINWARE SOFTWARE PRIVATE LIMITED",
"ADMIRAL HITEC LOGISTICS (INDIA) PRIVATE LIMITED",
"ADMIRAL MARINE SERVICES PRIVATE LIMITED",
"ADMIRAL SALT PRIVATE LIMITED",
"ADMIRAL SHIPPING LIMITED",
"ADMIRAL VTMS SERVICES PRIVATE LIMITED",
"ADMIRE ARCHITECTS PRIVATE LIMITED",
"ADMIRE FABRICS PRIVATE LIMITED",
"ADMIRE FIBER TEX (INDIA) PRIVATE LIMITED",
"ADMIRE INFRAZONE PRIVATE LIMITED",
"ADMIRE POWER ENGINEERS PRIVATE LIMITED",
"ADMIRE PUBLICITY PRIVATE LIMITED",
"ADMIRE WHEELS PRIVATE LIMITED",
"ADMIRED HEIGHT PROJECTS PRIVATE LIMITED",
"ADMIRER TRADERS PRIVATE LIMITED",
"ADMITAD MEDIA PRIVATE LIMITED",
"ADMIXTURE TECHNOLOGIES PRIVATE LIMITED",
"ADMK AGRITECH & RESEARCH FARMER PRODUCER COMPANY LIMITED",
"ADMN OFFICER CUSTOMS DIV VALSAD",
"ADMN OFFICER OFFICE OF E IN C WATER RESOURCE DEPTT MADHYA PRADESH",
"ADMOD TECHNOLOGIES PRIVATE LIMITED",
"ADMS MARKETING PRIVATE LIMITED",
"ADN BROADBAND PRIVATE LIMITED",
"ADN FIRE SAFETY PRIVATE LIMITED",
"ADNAKS MARKETING SOLUTIONS PRIVATE LIMITED",
"ADNAN ENERGY PRIVATE LIMITED",
"ADNANI EXPORTS LIMITED",
"ADNET INFOSYSTEMS (INDIA) PRIVATE LIMITED",
"ADNET INFOSYSTEMS I PRIVATE LIMITED",
"ADNIV TECHNOLOGIES PRIVATE LIMITED",
"ADNL ASSTT DEV COMMISSIONER",
"ADNOC CHEM PRIVATE LIMITED",
"ADNOVA HEALTHCARE PRIVATE LIMITED",
"ADNYA SERVICES",
"ADNYAA FOODS AND BEVERAGES PRIVATE LIMITED",
"ADO ADDITIVES MFG PRIVATE LIMITED",
"ADO ADDITIVES TECHNOLOGIES LIMITED",
"ADO SECURITY & PROTECTION SERVICES PRIVATE LIMITED",
"ADOBE HEALTH CARE",
"ADOBE PROPERTIES PRIVATE LIMITED",
"ADOBE SYSTEMS INDIA PRIVATE LIMITED",
"ADOLF7 AUTOMOTIVE INDUSTRIES PRIVATE LIMITED",
"ADOMANTRA DIGITAL INDIA PRIVATE LIMITED",
"ADOMITA TECHNOLOGIES PRIVATE LIMITED",
"ADON EQUIPMENTS PRIVATE LIMITED",
"ADON INTERNATIONAL PRIVATE LIMITED",
"ADONIA COSMETICS PRIVATE LIMITED",
"ADONIA SYSTEMS PRIVATE LIMITED",
"ADONIS BIOTECH PRIVATE LIMITED",
"ADONIS ELECTRONICS PRIVATE LIMITED",
"ADONIS LABORATORIES PRIVATE LIMITED",
"ADONIS LIFECARE PRIVATE LIMITED",
"ADONIS MANUFACTURING PRIVATE LIMITED",
"ADONIS MEDICAL SYSTEMS PRIVATE LIMITED",
"ADONIS PHYTOCEUTICALS PRIVATE LIMITED",
"ADONIS STAFF SERVICES PRIVATE LIMITED",
"ADONOMIST ALGO SOFT",
"ADOOR RUBBERS PVT LTD",
"ADOPT NETTECH PRIVATE LIMITED",
"ADOR CERAMICS PRIVATE LIMITED",
"ADOR DIGATRON PRIVATE LIMITED",
"ADOR ENGINEERS PRIVATE LIMITED",
"ADOR FONTECH LIMITED",
"ADOR MULTI PRODUCTS LIMITED",
"ADOR POLY-CONTAINERS LIMITED",
"ADOR POWERTRON LIMITED",
"ADOR WELDING LIMITED",
"ADORA CARPET SPLENDOR PRIVATE LIMITED",
"ADORA ENERGY PRIVATE LIMITED",
"ADORA JEWELS INDIA PRIVATE LIMITED",
"ADORA PRODUCTS PRIVATE LIMITED",
"ADORABLE JEWELS INDIA PRIVATE LIMITED",
"ADORATION CERAMICA PRIVATE LIMITED",
"ADORE ADVERTISING PRIVATE LIMITED",
"ADORE CONTRACTORS PRIVATE LIMITED",
"ADORE DEVELOPERS PRIVATE LIMITED",
"ADORE INFOTECH PRIVATE LIMITED",
"ADORE LIFESCIENCE PRIVATE LIMITED",
"ADORE MEDICAL PRIVATE LIMITED",
"ADORE PHARMACEUTICALS PVT LTD",
"ADORE PROPMART LLP",
"ADORE REALTECH PRIVATE LIMITED",
"ADORE SUITINGS PRIVATE LIMITED",
"ADORE TECHNOSOFT OPC PRIVATE LIMITED",
"ADORISH INDIA PRIVATE LIMITED",
"ADORIT IT SERVICES PRIVATE LIMITED",
"ADORIVA INFRATECH PRIVATE LIMITED",
"ADORN CHEMICALS PVT LTD",
"ADORN ENTERPRISES LIMITED",
"ADORN INFRA ENERGY PRIVATE LIMITED",
"ADORN LOGISTICS PRIVATE LIMITED",
"ADORN SPECIALITY POLYMERS PRIVATE LIMITED",
"ADORN WIRELINKS PRIVATE LIMITED",
"ADOROI MARKETING SCIENCE PRIVATE LIMITED",
"ADOROI TECH VENTURES PRIVATE LIMITED",
"ADORUS ADVISORS PRIVATE LIMITED",
"ADOS INTERIORS PRIVATE LIMITED",
"ADOSPHERE BRANDINGS PRIVATE LIMITED",
"ADP ASSOCIATES PRIVATE LIMITED",
"ADP GLOBAL INDUSTRIES PRIVATE LIMITED",
"ADP INDIA PRIVATE LIMITED",
"ADP PRIVATE LIMITED",
"ADP SOLUTIONS PRIVATE LIMITED",
"ADPAK PACKAGING SOLUTION PRIVATE LIMITED",
"ADPAY MOBILE PAYMENT INDIA PRIVATE LIMITED",
"AD-PHARMACHEM PRIVATE LIMITED",
"ADPL ESTATES PRIVATE LIMITED",
"AD-PLAY LEASE SPACE PRIVATE LIMITED",
"ADPO COMMUNICATION INDIA PRIVATE LIMITED",
"ADPRO AUTOMATION PRIVATE LIMITED",
"ADPRO CERAMICS INDIA PRIVATE LIMITED",
"ADPRO ENGINEERING AND POWER PRIVATE LIMITED",
"ADPS INDIA (OPC) PRIVATE LIMITED",
"ADPS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"ADPUSHUP SOFTWARE INDIA PRIVATE LIMITED",
"ADQ SERVICES LLP",
"ADQURA IT SOLUTIONS PRIVATE LIMITED",
"ADR AXLES INDIA PRIVATE LIMITED",
"ADR ENGINEERING & TRADING PRIVATE LIMITED",
"ADR ENGINEERING ENTERPRISES",
"ADR GEMS PRIVATE LIMITED",
"ADR PLASTICS PRIVATE LIMITED",
"ADRAK BUILDERS & DEVELOPERS PRIVATE LIMITED",
"ADRAK ENGINEERING & CONSTRUCTION INDIA PRIVATE LIMITED",
"ADREEK MEDIA PRIVATE LIMITED",
"ADREFRESH MEDIA PRIVATE LIMITED",
"ADREM INDIA PRIVATE LIMITED",
"ADRENAL ADVERTISING AND PROMOTIONS PRIVATE LIMITED",
"ADRENALIN E SYSTEMS LIMITED",
"ADRENO TECHNOLOGIES INDIA PRIVATE LIMITED",
"ADRET RETAIL PRIVATE LIMITED",
"ADREZ ADVISORS PRIVATE LIMITED",
"ADRI STEEL PRIVATE LIMITED",
"ADRIAN TRADING PRIVATE LIMITED",
"ADRIANNA PAPELL KD INDIA PRIVATE LIMITED",
"ADRIANNA SPRINGS IMPEX PRIVATE LIMITED",
"ADRIATIC BUSINESS VENTURE PRIVATE LIMITED",
"ADRIE MARINE ELECTRONICS SOLUTIONS PRIVATE LIMITED",
"ADRIJ PUMPS PRIVATE LIMITED",
"ADRIKA DEVELOPERS PRIVATE LIMTED",
"ADRIKA HEALTH FOOD PRIVATE LIMITED",
"ADRIKA MOTORS PRIVATE LIMITED",
"ADRIN - DEPARTMENT OF SPACE",
"ADRIOT CADENATECH PRIVATE LIMITED",
"ADRIS ELECTRIC PRIVATE LIMITED",
"ADRISHTA HOTELS AND RESORTS PRIVATE LIMITED",
"ADROID PRECISION PLASTICS PRIVATE LIMITED",
"ADROIT & ARDENT ASSOCIATES PRIVATE LIMITED",
"ADROIT AGENCIES PRIVATE LIMITED",
"ADROIT AGRI TRADE PRIVATE LIMITED",
"ADROIT ASSOCIATES PRIVATE LIMITED",
"ADROIT AUTOMATION INDIA PRIVATE LIMITED",
"ADROIT BIOMED LIMITED",
"ADROIT BUSINESS SOLUTIONS PRIVATE LIMITED",
"ADROIT COMMERCIAL PVT LTD",
"ADROIT COMMODITIES SERVICES PRIVATE LIMITED",
"ADROIT CONTROL ENGINEERS PRIVATE LIMITED",
"ADROIT CORPORATE SERVICES P LTD",
"ADROIT DIES AND MOULDS PRIVATE LIMITED",
"ADROIT ENGIMACH PRIVATE LIMITED",
"ADROIT EXPORT PRIVATE LIMITED",
"ADROIT FCS PRIVATE LIMITED",
"ADROIT FINANCIAL SERVICES PRIVATE LIMITED",
"ADROIT FIRE SAFETY PRIVATE LIMITED",
"ADROIT GLOBAL PERSONNEL SERVICES PRIVATE LIMITED",
"ADROIT GRAVURES SOLUTIONS PRIVATE LIMITED",
"ADROIT IMMIGRATION SERVICES PRIVATE LIMITED",
"ADROIT INDUSTRIES INDIA LIMITED",
"ADROIT INFOSYSTEMS PRIVATE LIMITED",
"ADROIT INFRATECH PRIVATE LIMITED",
"ADROIT INSPECTION SERVICES PRIVATE LIMITED",
"ADROIT LEGION ADVERTISING PRIVATE LIMITED",
"ADROIT LIFESCIENCE PRIVATE LIMITED",
"ADROIT NEO TECH SOLUTIONS PRIVATE LIMITED",
"ADROIT PEOPLE INDIA PRIVATE LIMITED",
"ADROIT PHARMA RESEARCH PRIVATE LIMITED",
"ADROIT PHARMACEUTICALS PRIVATE LIMITED",
"ADROIT PHARMACHEM PRIVATE LIMITED",
"ADROIT POWER SYSTEMS INDIA PRIVATE LIMITED",
"ADROIT PRODUCTS PRIVATE LIMITED",
"ADROIT SERVICE AND NETWORK PRIVATE LIMITED",
"ADROIT SHARE AND STOCK BROKER PRIVATE LIMITED",
"ADROIT STRUCTURAL ENGINEERS PRIVATE LIMITED",
"ADROIT SUPPLY CHAIN MANAGEMENT PRIVATE LIMITED",
"ADROIT SYNERGIES PRIVATE LIMITED",
"ADROIT TECH SERVICES",
"ADROIT TECHNICAL SERVICES PRIVATE LIMITED",
"ADROIT TRADING NUTS PRIVATE LIMITED",
"ADROIT URBAN DEVELOPERS PRIVATE LIMITED",
"ADROIT VALUATION SERVICES PRIVATE LIMITED",
"ADROIT VENTURES PRIVATE LIMITED",
"ADROITEC ENGINEERING SOLUTIONS PRIVATE LIMITED",
"ADROITEC INFORMATION SYSTEMS PRIVATE LIMITED",
"ADROITONE INFRA PRIVATE LIMITED",
"ADROITSQUARE CREATIVE VENTURE PRIVATE LIMITED",
"ADROSONIC IT CONSULTANCY SERVICES PRIVATE LIMITED",
"ADRPLEXUS MEDICAL SERVICES PRIVATE LIMITED",
"ADRS EXPORTS PRIVATE LIMITED",
"ADRUSTAM MOTORS PRIVATE LIMITED",
"ADS ADVERTISING PRIVATE LIMITED",
"ADS AGRO INDUSTRIES PRIVATE LIMITED",
"ADS AGROTECH PRIVATE LIMITED",
"ADS ARCHITECT PRIVATE LIMITED",
"ADS CIVIL & INTERIORS PRIVATE LIMITED",
"ADS DESIGNS PRIVATE LIMITED",
"ADS DISTILLERIES PRIVATE LIMITED",
"ADS INNOTECH PRIVATE LIMITED",
"ADS PROJECTS & SYSTEMS PRIVATE LIMITED",
"ADS SENSOR TECHNIK PRIVATE LIMITED",
"ADS SOFTEK PRIVATE LIMITED",
"ADS SPIRITS PRIVATE LIMITED",
"ADS TRADING ASSOCIATES PRIVATE LIMITED",
"ADSAT ENGINEERS PRIVATE LIMITED",
"ADSC INSTRUMENTATION PRIVATE LIMITED",
"ADSCHOLARS MARKETING INDIA PRIVATE LIMITED",
"ADSD CONSULTING PRIVATE LIMITED",
"ADSE TECH PRIVATE LIMITED",
"ADSERT WEB SOLUTIONS PRIVATE LIMITED",
"ADSERVE CONSULTANCY PRIVATE LIMITED",
"ADSFLO WORLDWIDE PRIVATE LIMITED",
"ADSHI5.COM PRIVATE LIMITED",
"ADSIDUOUS MEDIA PRIVATE LIMITED",
"ADSILA ORGANICS PRIVATE LIMITED",
"ADSILE MEDIA PRIVATE LIMITED",
"ADSIN PROJECTS PRIVATE LIMITED",
"ADSIZZLER MEDIA PRIVATE LIMITED",
"ADSKOM INDIA PRIVATE LIMITED",
"ADSMN INTERACTIVE PRIVATE LIMITED",
"ADSN ICON SIGN PRIVATE LIMITED",
"ADSNET DIGITAL SOLUTIONS PRIVATE LIMITED",
"ADSO NATURALS PRIVATE LIMITED",
"ADSOM GLOBALTECH PRIVATE LIMITED",
"ADSON SYSTEMS PRIVATE LIMITED",
"ADSONS FURNISHERS PRIVATE LIMITED",
"ADSORBTECH ENGINEERS PRIVATE LIMITED",
"ADSPAYMEDIA PRIVATE LIMITED",
"ADSROLE PRIVATE LIMITED",
"ADSS FOREX PRIVATE LIMITED",
"ADSTOCK SYSTEMS PRIVATE LIMITED",
"ADSTREAM ADVERTISING SERVICES PRIVATE LIMITED",
"ADSTREET COMMUNICATIONS PRIVATE LIMITED",
"ADSTRINGO SOFTWARE PRIVATE LIMITED",
"ADSUM ADVISORY SERVICES PRIVATE LIMITED",
"ADSUM ECO SOLUTION PRIVATE LIMITED",
"ADSUM HOSPITAL PRIVATE LIMITED",
"ADSUM IMPEX PRIVATE LIMITED",
"ADSUN ELECTRONICS PRIVATE LIMITED",
"ADSUN LIGHTING PRIVATE LIMITED",
"ADSUN OFFSHORE DIVING CONTRACTORS PRIVATE LIMITED",
"ADSUN TELECOM INDUSTRIES PRIVATE LIMITED",
"ADSYNDICATE SERVICES PRIVATE LIMITED",
"ADT INDIA PRIVATE LIMITED",
"ADTEC ELECTRONIC INSTRUMENTS PRIVATE LIMITED",
"ADTECH CONCEPTS PRIVATE LIMITED",
"ADTECH SYSTEMS LIMITED",
"ADTECHCORP TECHNOLOGIES PRIVATE LIMITED",
"ADTEK PRINT & MEDIA PRIVATE LIMITED",
"ADTEL SOFTEARE PRIVATE LIMITED",
"ADTHERA CONSUMER BRANDS PRIVATE LIMITED",
"ADTRAN NETWORKS INDIA PRIVATE LIMITED",
"ADTRIC SOLUTIONS PRIVATE LIMITED",
"ADTYM VIEWVISION PRIVATE LIMITED",
"ADUCADU GRANITES PRIVATE LIMITED",
"ADUCLICK BUSINESS SERVICES PRIVATE LIMITED",
"ADUKIA INDUSTRIES PRIVATE LIMITED",
"ADULOGIX BUSINESS SOLUTIONS PRIVATE LIMITED",
"ADURI INFRA PRIVATE LIMITED",
"ADURJEE & BROS PRIVATE LIMITED",
"ADV INDUSTRIAL SERVICES PRIVATE LIMITED",
"ADV LALITA PATIL INTERNATIONAL SCHOOL",
"ADV METAL COMBINE PRIVATE LIMITED",
"ADV PARTNERS INVESTMENT ADVISER INDIA PRIVATE LIMITED",
"ADV SPORTS PRIVATE LIMITED",
"ADVA OPTICAL NETWORKING INDIA PRIVATE LIMITED",
"ADVA STUDIO PRIVATE LIMITED",
"ADVA-HAENNI ENGINEERS PRIVATE LIMITED",
"ADVAIT AGROTECH PRIVATE LIMITED",
"ADVAIT BUILDTECH PRIVATE LIMITED",
"ADVAIT BUSINESS SOLUTIONS PRIVATE LIMITED",
"ADVAIT GLOBAL MOTOCORP PRIVATE LIMITED",
"ADVAIT INFRATECH LIMITED",
"ADVAIT MEDICOM & RESEARCH INSTITUTE PRIVATE LIMITED",
"ADVAIT TECHSERVE INDIA PRIVATE LIMITED",
"ADVAITA DEVELOPERS AND PROMOTERS PRIVATE LIMITED",
"ADVAITA GLOBAL EXIM PRIVATE LIMITED",
"ADVAITA HOMES",
"ADVAITA INTERIORS PRIVATE LIMITED",
"ADVAITA INTERNATIONAL SCHOOL",
"ADVAITAM TECH SOLUTIONS PRIVATE LIMITED",
"ADVAITH AEROSPACE PRIVATE LIMITED",
"ADVAITH AUTOMATION PRIVATE LIMITED",
"ADVAITH BIOFUELS LIMITED",
"ADVAITH MOTORS PRIVATE LIMITED",
"ADVAITH SPARES AND ACCESSORIES PRIVATE LIMITED",
"ADVAITHA VENTURES PRIVATE LIMITED",
"ADVAIYA SOLUTIONS PRIVATE LIMITED",
"ADVANC LASER IMPEX PRIVATE LIMITED",
"ADVANCE ADDMINE PRIVATE LIMITED",
"ADVANCE AGRISEARCH LIMITED",
"ADVANCE AGRO RIPE PRIVATE LIMITED",
"ADVANCE AGROLIFE PRIVATE LIMITED",
"ADVANCE AIR SYSTEMS (INDIA) PRIVATE LIMITED",
"ADVANCE AIRCON SERVICES PRIVATE LIMITED",
"ADVANCE AUTO PARTS INC.",
"ADVANCE BIOMATERIAL COMPANY PRIVATE LIMITED",
"ADVANCE CABLE TECHNOLOGIES PRIVATE LIMITED",
"ADVANCE CAR CARE SYSTEMS PRIVATE LIMITED",
"ADVANCE CARGO MOVERS (INDIA) PRIVATE LIMITED",
"ADVANCE CASTINGS PRIVATE LIMITED",
"ADVANCE CATALYST PRIVATE LIMITED",
"ADVANCE CHEMICALS PVT LTD",
"ADVANCE CLEARTECH (OPC) PRIVATE LIMITED",
"ADVANCE COLOURS AND COATINGS PRIVATE LIMITED",
"ADVANCE COMPAIR SYSTEMS PVT LTD",
"ADVANCE COMPONENTS AND INSTRUMENTS PRIVATE LIMITED",
"ADVANCE COMPUTER SERVICES LIMITED",
"ADVANCE CONSULTING ENGINEERS PRIVATE LIMITED",
"ADVANCE COOLING SYSTEMS PRIVATE LIMITED",
"ADVANCE COOLING TOWERS PRIVATE LIMITED",
"ADVANCE CORK PRIVATE LIMITED",
"ADVANCE CREW AUTOMATION",
"ADVANCE CROPCARE INDIA PRIVATE LIMITED",
"ADVANCE CT SCAN AND DIAGNOSTIC CENTER PRIVATE LIMITED",
"ADVANCE DECORATIVE LAMINATE PRIVATE LIMITED",
"ADVANCE DEHYDRATE PRIVATE LIMITED",
"ADVANCE DIESEL ENGINES PRIVATE LIMITED",
"ADVANCE DYNAMIC SOLUTIONS PRIVATE LIMITED",
"ADVANCE E SERVICES PRIVATE LIMITED",
"ADVANCE ENGINEERING WORKS PRIVATE LIMITED",
"ADVANCE ENTERPRISES PRIVATE LIMITED",
"ADVANCE EPC CONTRACTS PRIVATE LIMITED",
"ADVANCE FERTILIZERS INDIA PRIVATE LIMITED",
"ADVANCE FORGINGS PRIVATE LIMITED",
"ADVANCE FURNACES AND CONTROLS PRIVATE LIMITED",
"ADVANCE GENUINE SPARES PRIVATE LIMITED",
"ADVANCE GEO HYDRO ENGINEERS LLP",
"ADVANCE HEART CARE CENTRE PRIVATE LIMITED",
"ADVANCE HYDRAU-COMPONENTS PRIVATE LIMITED",
"ADVANCE HYDRAULICS PRIVATE LIMITED",
"ADVANCE HYDRU-TECH PRIVATE LIMITED",
"ADVANCE INDIA EXIM PRIVATE LIMITED",
"ADVANCE INDIA INSURANCE BROKER SERVICES LIMITED",
"ADVANCE INDIA PROJECTS LIMITED",
"ADVANCE INDUSTRIAL ROLLERS PRIVATE LIMITED",
"ADVANCE INFO DISTRIBUTORS PRIVATE LIMITED",
"ADVANCE INFORMATICS PRIVATE LIMITED",
"ADVANCE INFOSOLUTIONS PRIVATE LIMITED",
"ADVANCE INFRASTRUCTURES PRIVATE LIMITED",
"ADVANCE ISPAT (INDIA) LIMITED",
"ADVANCE KNEE & SHOULDER HOSPITAL",
"ADVANCE LABS SCIENTIFIC PRIVATE LIMITED",
"ADVANCE LAMINATES PRIVATE LIMITED",
"ADVANCE LAMP COMPONENT AND TABLE WARES PRIVATE LIMITED",
"ADVANCE LIFE INSURANCE BROKERS PRIVATE LIMITED",
"ADVANCE LIFECARE PRIVATE LIMITED",
"ADVANCE LIFESTYLES LIMITED",
"ADVANCE MACHINE AND AUTOMATION TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"ADVANCE MARKS AND LABELS PRIVATE LIMITED",
"ADVANCE MECHANICAL SERVICES PRIVATE LIMITED",
"ADVANCE MEDIPLUS PRIVATE LIMITED",
"ADVANCE METAL POWDER PRIVATE LIMITED",
"ADVANCE MOULDERS PRIVATE LIMITED",
"ADVANCE NEUROSCIENCE HOSPITAL AND RESEARCH PVT LTD",
"ADVANCE PAINTS PRIVATE LIMITED",
"ADVANCE PANELS AND SWITCHGEARS PRIVATE LIMITED",
"ADVANCE PESTICIDES LIMITED",
"ADVANCE PETROCHEMICALS LIMITED",
"ADVANCE PIGMENTS PRIVATE LIMITED",
"ADVANCE POWER CABLE TECHNOLOGIES PRIVATE LIMITED",
"ADVANCE POWER DISPLAY SYSTEM LIMITED",
"ADVANCE PRINT MEDIA PRIVATE LIMITED",
"ADVANCE REFRIGERATION ENGINEERING PRIVATE LIMITED",
"ADVANCE ROTOFLEX PRIVATE LIMITED",
"ADVANCE SAFETY MANAGEMENT SERVICES PRIVATE LIMITED",
"ADVANCE SCIENTIFIC EQUIPMENTS PRIVATE LIMITED",
"ADVANCE STAR INDIA PRIVATE LIMITED",
"ADVANCE STIMUL ENGINEERING PRIVATE LIMITED",
"ADVANCE STRIPS PVT LTD",
"ADVANCE SULZ PRIVATE LIMITED",
"ADVANCE SURFACTANTS LIMITD",
"ADVANCE SURGICALS PRIVATE LIMITED",
"ADVANCE SYNTEX LIMITED",
"ADVANCE TECH CONTROLS PRIVATE LIMITED",
"ADVANCE TECH ENERGY EDIBLES INDIA PRIVATE LIMITED",
"ADVANCE TECH MEDI SYSTEMS PRIVATE LIMITED",
"ADVANCE TECH SERVICES PRIVATE LIMITED",
"ADVANCE TECHNOFORGE PRIVATE LIMITED",
"ADVANCE TECHNOLOGY",
"ADVANCE TECMATE PRIVATE LIMITED",
"ADVANCE TRANSMISSIONS PRIVATE LIMITED",
"ADVANCE VALVES PRIVATE LIMITED",
"ADVANCE VALVES PRIVATE. LIMITED",
"ADVANCE VENTILATION PRIVATE LIMITED",
"ADVANCE WHEELCARE PRIVATE LIMITED",
"ADVANCE2RISE ITES PRIVATE LIMITED",
"ADVANCED AGRICULTURE FARMER PRODUCER COMPANY LIMITED",
"ADVANCED AMORPHOUS TECHNOLOGY LLP",
"ADVANCED ANIMAL NUTRITION PRIVATE LIMITED",
"ADVANCED ANMOL METCOMP PRIVATE LIMITED",
"ADVANCED APPLIANCES PRIVATE LIMITED",
"ADVANCED BAKING CONCEPTS PRIVATE LIMITED",
"ADVANCED BIO-AGRO TECH LIMITED",
"ADVANCED BIONICS INDIA PRIVATE LIMITED",
"ADVANCED BIOTECH PRODUCTS PRIVATE LIMITED",
"ADVANCED BOLTING SOLUTIONS PRIVATE LIMITED",
"ADVANCED BRICKSTONE CONSTRUCTIONS PRIVATE LIMITED",
"ADVANCED BUSINESS & HEALTHCARE SOLUTIONS INDIA PRIVATE LIMITED",
"ADVANCED BUSINESS INTELLIGENCE AND ANALYTICS PRIVATE LIMITED",
"ADVANCED CALIBRATION & VALIDATION SERVICES PRIVATE LIMITED",
"ADVANCED CARDIOVASCULAR CARE PRIVATE LIMITED",
"ADVANCED CHROMATOGRAPHY TECHNOLOGIES PRIVATE LIMITED",
"ADVANCED COMPUTERS AND MOBILES INDIA PRIVATE LIMITED",
"ADVANCED CONSTRUCTION TECHNOLOGIES PRIVATE LIMITED",
"ADVANCED CONTRACTORS & ENGINEERS PRIVATE LIMITED",
"ADVANCED CRUSHING ENGINEERS PRIVATE LIMITED",
"ADVANCED DESIGN AND MANUFACTURING TECHNOLOGIES PRIVATE LIMITED",
"ADVANCED DIABETES CENTRE PRIVATE LIMITED",
"ADVANCED DIGITAL TECHNOLOGY INDIA PRIVATE LIMITED",
"ADVANCED DISPOSABLE PRIVATE LIMITED",
"ADVANCED DRUGS AND CHEMICALS PRIVATE LIMITED",
"ADVANCED EDUCARE TRAINING PRIVATE LIMITED",
"ADVANCED ELAF",
"ADVANCED ENGINEERING SOLUTIONS PRIVATE LIMITED",
"ADVANCED ENVIRONMENTAL TESTING AND RESEARCH LAB PRIVATE LIMITED",
"ADVANCED ENZYME TECHNOLOGIES LIMITED",
"ADVANCED ENZYTECH SOLUTIONS LIMITED",
"ADVANCED EQUIPMENTS AND SOLUTIONS PRIVATE LIMITED",
"ADVANCED EXPERTISE TECHNOLOGY PRIVATE LIMITED",
"ADVANCED EYE INSTITUTE PRIVATE LIMITED",
"ADVANCED FIBER SYSTEMS PRIVATE LIMITED",
"ADVANCED FISCAL SERVICES PVT.LTD.",
"ADVANCED FITTINGS PRIVATE LIMITED",
"ADVANCED FMS AND SECURITY SERVICES PRIVATE LIMITED",
"ADVANCED GENOMICS INSTITUTE & LABORATORY MEDICINE PRIVATE LIMITED",
"ADVANCED GRID TECHNOLOGIES INDIA PRIVATE LIMITED",
"ADVANCED GUARDS PRIVATE LIMITED",
"ADVANCED HAIR RESTORATION INDIA PRIVATE LIMITED",
"ADVANCED HAIR STUDIO PRIVATE LIMITED",
"ADVANCED INDUSTRIAL SOLUTIONS PRIVATE LIMITED",
"ADVANCED INFRASTRUCTURE ENGINEERING PRIVATE LIMITED",
"ADVANCED INFRATECH PRIVATE LIMITED",
"ADVANCED INVESTMENT MECHANICS INDIA PRIVATE LIMITED",
"ADVANCED LEASING AND FINANCE PRIVATE LIMITED",
"ADVANCED LIFE CARE MULTI DISCIPLINARY HOSPITAL PRIVATE LIMITED",
"ADVANCED LIFESCIENCES PRIVATE LIMITED",
"ADVANCED MATERIALS PROCESSES INST",
"ADVANCED MICRO DEVICES INC.",
"ADVANCED MICRO SERVICES PRIVATE LIMITED",
"ADVANCED MICRODEVICES PRIVATE LIMITED",
"ADVANCED MILLENIUM TECHNOLOGIES PRIVATE LIMITED",
"ADVANCED MINING TECHNOLOGIES PRIVATE LIMITED",
"ADVANCED MONOLITHIC POWER SEMICONDUCTOR PRIVATE LIMITED",
"ADVANCED NEURODIAGNOSTIC CENTRE PRIVATE LIMITED",
"ADVANCED NUTRIENTS INDIA PRIVATE LIMITED",
"ADVANCED PENUMATICS PRIVATE LIMITED",
"ADVANCED PERFORMANCE MATERIALS PRIVATE LIMITED",
"ADVANCED POWER SOURCES LIMITED",
"ADVANCED PRETTY PICTURES INDIA PRIVATE LIMITED",
"ADVANCED RAIL CONTROLS PRIVATE LIMITED",
"ADVANCED REALTY PRIVATE LIMITED",
"ADVANCED RISK ANALYTICS PRIVATE LIMITED",
"ADVANCED ROOF INDIA PRIVATE LIMITED",
"ADVANCED SCAN SUPPORT TECHNOLOGY PRIVATE LIMITED",
"ADVANCED SENSOR SYSTEMS PRIVATE LIMITED",
"ADVANCED SILICONES PRIVATE LIMITED",
"ADVANCED SPECIALTY HOSPITALS PRIVATE LIMITED",
"ADVANCED SPORT TECHNOLOGIES LLP",
"ADVANCED STERILIZATION PRODUCTS INDIA PRIVATE LIMITED",
"ADVANCED STRUCTURES INDIA PRIVATE LIMITED",
"ADVANCED SURVEYING INSTRUMENTS (INDIA) PRIVATE LIMITED",
"ADVANCED SWITCHING CONVERTERS PRIVATE LIMITED",
"ADVANCED SYNTHETIC MINERALS PRIVATE LIMITED",
"ADVANCED SYS-TEK PRIVATE LIMITED",
"ADVANCED SYSTEMS LABORATORY",
"ADVANCED SYSTEMS SAMPLING PRIVATE LIMITED",
"ADVANCED TECH SERVICES PRIVATE LIMITED",
"ADVANCED TECHNOLOGY",
"ADVANCED TECHNOLOGY CONSULTING SERVICE PRIVATE LIMITED",
"ADVANCED TELECOM & POWER NETWORKS PRIVATE LIMITED",
"ADVANCED TELEMEDIA PRIVATE LIMITED",
"ADVANCED TEXTILES AND MATERIALS PRIVATE LIMITED",
"ADVANCED TRENDS INDIA PRIVATE LIMITED",
"ADVANCED UROCARE PRIVATE LIMITED",
"ADVANCED VITAL ENZYMES PRIVATE LIMITED",
"ADVANCED WEAPONS AND EQUIPMENT INDIA LIMITED",
"ADVANCETECH INDIA PRIVATE LIMITED",
"ADVANCETECH METALLOYS PRIVATE LIMITED",
"ADVANI HOTELS AND RESORTS (INDIA) LIMITED",
"ADVANI OLICKAL HEALTHCARE SERVICES PRIVATE LIMITED",
"ADVANI PRIVATE LIMITED",
"ADVANIDE INDIA PRIVATE LIMITED",
"ADVANOV PHARMA PRIVATE LIMITED",
"ADVANS IT SERVICES PRIVATE LIMITED",
"ADVANSIS CONSULTING PRIVATE LIMITED",
"ADVANSITY SUPPLIERS PRIVATE LIMITED",
"ADVANSOFT",
"ADVANSYS (INDIA) PRIVATE LIMITED",
"ADVANT ENERGY PRIVATE LIMITED",
"ADVANT IT PARK PRIVATE LIMITED",
"ADVANT MEDIACOM PRIVATE LIMITED",
"ADVANTA LIFESCIENCES PRIVATE LIMITED",
"ADVANTA SUPER SPECIALITY HOSPITAL PRIVATE LIMITED",
"ADVANTAGE AGRI GAIN INTERNATIONAL PRIVATE LIMITED",
"ADVANTAGE BENGAL INFRASTRUCTURE LIMITED",
"ADVANTAGE COMMODITIES PRIVATE LIMITED",
"ADVANTAGE COMPUTERS INDIA PRIVATE LIMITED",
"ADVANTAGE EQUI FUND PVT LTD",
"ADVANTAGE EXPORTS PRIVATE LIMITED",
"ADVANTAGE FOODS PRIVATE LIMITED",
"ADVANTAGE HEALTHCARE SOLUTIONS",
"ADVANTAGE INDIA LOGISTICS PRIVATE LIMITED",
"ADVANTAGE MEDICAL SYSTEMS PRIVATE LIMITED",
"ADVANTAGE NETWORKING AND SOLUTIONS PRIVATE LIMITED",
"ADVANTAGE OILS PRIVATE LIMITED",
"ADVANTAGE ONE HUMAN RESOURCING PRIVATE LIMITED",
"ADVANTAGE ONE SOLUTIONS PRIVATE LIMITED",
"ADVANTAGE ONE TAX CONSULTING PRIVATE LIMITED",
"ADVANTAGE ONE TECHNOLOGIES & CONSULTING PRIVATE LIMITED",
"ADVANTAGE PLUS HOTELS PRIVATE LIMITED",
"ADVANTAGE VINIMAY PRIVATE LIMITED",
"ADVANTAGESAI PROJECTS PRIVATE LIMITED",
"ADVANTAGESB TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"ADVANTAL TECHNOLOGIES PRIVATE LIMITED",
"ADVANTEC CASTING PRIVATE LIMITED",
"ADVANTECH CONTROL SYSTEMS PRIVATE LIMITED",
"ADVANTECH INDUSTRIAL COMPUTING INDIA PRIVATE LIMITED",
"ADVANTEDGE HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"ADVANTEDGE TECHNOLOGIES PRIVATE LIMITED",
"ADVANTEK AIR SYSTEMS PRIVATE LIMITED",
"ADVANTEK FUEL SYSTEMS PRIVATE LIMITED",
"ADVANTEST INDIA PRIVATE LIMITED",
"ADVANTIC FOOD & AGRI EXPORT PRIVATE LIMITED",
"ADVANTIQS TECHNOLOGIES INDIA PRIVATE LIMITED",
"ADVANTIS CROP SCIENCE PRIVATE LIMITED",
"ADVANTIS QUARTZ LLP",
"ADVANTMED INDIA LLP",
"ADVANTUM HEALTH PRIVATE LIMITED",
"ADVANTUS CORPORATE INFOSERVE PRIVATE LIMITED",
"ADVANZ 101 SYSTEMS PRIVATE LIMITED",
"ADVANZ PHARMA SERVICES INDIA PRIVATE LIMITED",
"ADVARRA INDIA PRIVATE LIMITED",
"ADVATECH CERA TILES LIMITED",
"ADVATECH HEALTHCARE PRIVATE LIMITED",
"ADVATECH INDUSTRIES PRIVATE LIMITED",
"ADVATIX APAC LOGISTICS PRIVATE LIMITED",
"ADVAYA INFOTECH PRIVATE LIMITED",
"ADVECTUS SOLUTIONS INDIA PRIVATE LIMITED",
"ADVEN BIOTECH PRIVATE LIMITED",
"ADVEN TYRE TUBE INDIA PRIVATE LIMITED",
"ADVENSER ENGINEERING SERVICES PRIVATE LIMITED",
"ADVENSURE PRIVATE LIMITED",
"ADVENT ACQUA PROJECTS P.LTD",
"ADVENT ADVISORYSERVICES PRIVATE LIMITED",
"ADVENT AIRCON PRIVATE LIMITED",
"ADVENT AUTOMOBILES PVT. LTD.",
"ADVENT BIZTECH SOLUTIONS PRIVATE LIMITED",
"ADVENT BUILDWEL PRIVATE LIMITED",
"ADVENT CHEMBIO PRIVATE LIMITED",
"ADVENT CHRISTIAN MIDDLE SCHOOL",
"ADVENT CHRISTIAN SCHOOLS",
"ADVENT DEVELOPERS PRIVATE LIMITED",
"ADVENT DYESTUFFS AND CHEMICALS PVT LTD",
"ADVENT ELECTRIC TECHNOLOGIES PRIVATE LIMITED",
"ADVENT ENGINEERING PRIVATE LIMITED",
"ADVENT ENVIROCARE TECHNOLOGY PVT LTD",
"ADVENT FOUNDRY AND ALLIED SUPPLIES PRIVATE LIMITED",
"ADVENT GLOBAL SOLUTIONS PRIVATE LIMITED",
"ADVENT HEALTHCARE & HI-TECH PRODUCTS",
"ADVENT HOSPITALITY PRIVATE LIMITED",
"ADVENT INDIA PE ADVISORS PRIVATE LIMITED",
"ADVENT INFOMAX PRIVATE LIMITED",
"ADVENT INFRATECH PRIVATE LIMITED",
"ADVENT LIFESCIENCES PRIVATE LIMITED",
"ADVENT LOGISTICS INDIA PRIVATE LIMITED",
"ADVENT METAL PROFILE PRIVATE LIMITED",
"ADVENT MINERALS PRIVATE LIMITED",
"ADVENT OILFIELD SERVICES PRIVATE LIMITED",
"ADVENT PRIME CONSTRUCTION PRIVATE LIMITED",
"ADVENT PRODUCTIONS PRIVATE LIMITED",
"ADVENT PROFESSIONAL SERVICES PRIVATE LIMITED",
"ADVENT PROJECTS & CONSULTANCY SERVICES PRIVATE LIMITED",
"ADVENT STONE CALIBRATION PRIVATE LIMITED",
"ADVENT TECH PROJECTS PRIVATE LIMITED",
"ADVENT TOOLTECH PRIVATE LIMITED",
"ADVENTAGE AGENCY PRIVATE LIMITED",
"ADVENTITY GLOBAL SERVICES PRIVATE LIMITED",
"ADVENTSYS TECHNOLOGIES PRIVATE LIMITED",
"ADVENTURE ADVERTISING PRIVATE LIMITED",
"ADVENTURE AND NATURE NETWORK PRIVATE LIMITED",
"ADVENTURE AUTO CAR INDIA LIMITED",
"ADVENTURE AXIS EQUIPMENTS PRIVATE LIMITED",
"ADVENTURE EDUCATION TOURS (MUMBAI) PRIVATE LIMITED",
"ADVENTURE EVENT MANAGEMENT PRIVATE LIMITED",
"ADVENTURE LIFE SCIENCES PRIVATE LIMITED",
"ADVENTURE MEDIA PRIVATE LIMITED",
"ADVENTURE OUTSOURCING PRIVATE LIMITED",
"ADVENTURE RECRUITMENT INDIA PRIVATE LIMITED",
"ADVENTURE RESORTS AND CRUSIES PRIVATE LIMITED",
"ADVENTURE SECURITAS PRIVATE LIMITED",
"ADVENTURE WATER CARE",
"ADVENTURES (INDIA) PRIVATE LIMITED",
"ADVENTURES INTERNATIONAL PRIVATE LIMITED",
"ADVENTUS EDUCATION INDIA PRIVATE LIMITED",
"ADVENTZ FINANCE PRIVATE LIMITED",
"ADVENTZ SECURITIES ENTERPRISES LIMITED",
"ADVERGAME TECHNOLOGIES PRIVATE LIMITED",
"ADVERT COMMUNICATIONS PRIVATE LIMITED",
"ADVER-TECH PRIVATE LIMITED",
"ADVERTISING CONCESSIONAIRES PRIVATE LIMITED",
"ADVERTIZIA PRIVATE LIMITED",
"ADVERTO ADVERTISING PRIVATE LIMITED",
"ADVERTRICSSOFT IT SYSTEMS PRIVATE LIMITED",
"ADVIACENT CONSULTING SERVICES PRIVATE LIMITED",
"ADVICE BUILTCARE PRIVATE LIMITED",
"ADVICEAMERICA SOFTWARE DEVELOPMENT CENTRE PRIVATE LIMITED",
"ADVICS INDIA PRIVATE LIMITED",
"ADVIEW ADVERTISING PRIVATE LIMITED",
"ADVIK AUTO PRIVATE LIMITED",
"ADVIK AUTOCOMP PRIVATE LIMITED",
"ADVIK CAPITAL LIMITED",
"ADVIK CONTRACTS INDIA PRIVATE LIMITED",
"ADVIK ENERGY SOLUTION PRIVATE LIMITED",
"ADVIK HI-TECH PRIVATE LIMITED",
"ADVIK INNOVATIONS PRIVATE LIMITED",
"ADVIK RENEWABLE ENERGY PRIVATE LIMITED",
"ADVIK TECNOCOMMERCIAL PRIVATE LIMITED",
"ADVIKA CONSTRUCTIONS PRIVATE LIMITED",
"ADVIKA ENERGIES PRIVATE LIMITED",
"ADVIKA ENTERPRISES PRIVATE LIMITED",
"ADVIKA PROPERTIES PRIVATE LIMITED",
"ADVIND HEALTHCARE INDIA PRIVATE LIMITED",
"ADVINO HEALTHCARE PRIVATE LIMITED",
"ADVINTEK CONSULTING SERVICES PRIVATE LIMITED",
"ADVIRA TECHNOMANAGEMENT PRIVATE LIMITED",
"ADVISE ADVERTISING & MEDIA PRIVATE LIMITED",
"ADVISER LOGIC SOFTWARE PRIVATE LIMITED",
"ADVISERS CIRCLE PRIVATE LIMITED",
"ADVISHA DYE CAST INDUSTRIES PRIVATE LIMITED",
"ADVISION COMMUNICATIONS PRIVATE LIMITED",
"ADVISTA TECHNOSOLUTIONS PRIVATE LIMITED",
"ADVIT JEWELS PRIVATE LIMITED",
"ADVIT LIFTS AND AUTOMATION PRIVATE LIMITED",
"ADVIT VENTURES PRIVATE LIMITED",
"ADVITA MANAGEMENT SERVICES POINT PRIVATE LIMITED",
"ADVITEEYA PHARMA PRIVATE LIMITED",
"ADVITH PLASTOTECH PRIVATE LIMITED",
"ADVITIYA EXIM PRIVATE LIMITED",
"ADVITIYA FABRICS PRIVATE LIMITED",
"ADVOLOGY SOLUTION PRIVATE LIMITED",
"ADVOLT MEDIA PRIVATE LIMITED",
"ADVUTION INDIA PRIVATE LIMITED",
"ADVY CHEMICAL PRIVATE LIMITED",
"ADW HIGHER SECONDARY SCHOOL",
"ADWAIT HOLDINGS PRIVATE LIMITED",
"ADWAITH LAKSHMI INDUSTRIES LIMITED",
"ADWAITH TEXTILES LIMITED",
"ADWALPALKAR CONSTRUCTIONS AND RESORTS PRIVATE LIMITED",
"ADWANI OERLIKON GOVT. SCHOOL OF EXCELLENCE SAGES BIRGAON RAIPUR C.G.",
"ADWANI TEX FAB PRIVATE LIMITED",
"ADWARDS INTELLITECH PRIVATE LIMITED",
"ADWARE TECHNOLOGIES PRIVATE LIMITED",
"ADWAVE ADVERTISING PRIVATE LIMITED",
"ADWAVIK SERVICES PRIVATE LIMITED",
"ADWAY INITIATIVE MARCOM SERVICES PRIVATE LIMITED",
"ADWAY PRINT CONCEPT PRIVATE LIMITED",
"ADWAY TEXTILES PRIVATE LIMITED",
"ADWAYS VC INDIA PRIVATE LIMITED",
"ADWEALTH STOCK BROKING PRIVATE LIMITED",
"ADWEL INDIA PRIVATE LIMITED",
"AD-WELL INTERNATIONAL PRIVATE LIMITED",
"ADWIK INTELLIMECH PRIVATE LIMITED",
"ADWIK SECURITY & HR SOLUTIONS PRIVATE LIMITED",
"ADWIN INNOVATIONS PRIVATE LIMITED",
"ADWIN LIFE CARE PRIVATE LIMITED",
"ADWINGS ADVERTISERS PRIVATE LIMITED",
"ADWISH LOGISTICS PRIVATE LIMITED",
"ADWIT INDIA PRIVATE LIMITED",
"ADWITA INFRATECH PRIVATE LIMITED",
"ADWITHA GLOBAL HEALTH CARE PRIVATE LIMITED",
"ADWITIYA FASHION PRIVATE LIMITED",
"ADWITIYA PROJECTS INDIA PRIVATE LIMITED",
"ADWITYA PROJECTS PRIVATE LIMITED",
"ADWITYA SHASWAT PRIVATE LIMITED",
"ADWIZ MARKETING PRIVATE LIMITED",
"ADWORLD GRAPHICS PRIVATE LIMITED",
"ADWORLD SIGNAGES PRIVATE LIMITED",
"ADWORTH BUSINESS SOLUTION PRIVATE LIMITED",
"ADWORTH MEDIA PRIVATE LIMITED",
"ADWYN CHEMICALS PRIVATE LIMITED",
"ADXOR TECHNOLOGIES PRIVATE LIMITED",
"ADYA BHAWAN LIMITED",
"ADYA DAIRY PRODUCTS PRIVATE LIMITED",
"ADYA DESIGNS PRIVATE LIMITED",
"ADYA EARTH PRIVATE LIMITED",
"ADYA ENTERPRISES PRIVATE LIMITED",
"ADYA INTERIORS PRIVATE LIMITED",
"ADYA PACKAGING PRIVATE LIMITED",
"ADYA SHAKTI HIMGHAR PVT LTD",
"ADYA SMART METERING PRIVATE LIMITED",
"ADYAH AGRO PRIVATE LIMITED",
"ADYAH SOLAR ENERGY PRIVATE LIMITED",
"ADYAM ENERGY SOLUTIONS PRIVATE LIMITED",
"ADYAMA HIMGHAR PRIVATE LIMITED",
"ADYAMAA TRADELINK PRIVATE LIMITED",
"ADYANT AUTOMOVERS PRIVATE LIMITED",
"ADYANT EDUCATION PRIVATE LIMITED",
"ADYANT TRADELINK PRIVATE LIMITED",
"ADYANT WELLNESS MEDICARE SERVICES PRIVATE LIMITED",
"ADYAR ANANDA BHAVAN SWEETS INDIA PRIVATE LIMITED",
"ADYAR BAKERY PRIVATE LIMITED",
"ADYAR GATE HOTELS LIMITED",
"ADYAR MOTORS PRIVATE LIMITED",
"ADYAR PM HOSPITALS AND RESEARCH CENTRE PRIVATE LIMITED",
"ADYAR STUDENTS XEROX PRIVATE LIMITED",
"ADYAR TRAVEL BUREAU PRIVATE LIMITED",
"ADYARAJ DEVELOPERS PRIVATE LIMITED",
"ADYAYAN INDUSTRIES PRIVATE LIMITED",
"ADYCON INFRASTRUCTURES PRIVATE LIMITED",
"ADYEN INDIA TECHNOLOGY SERVICES PRIVATE LIMITED",
"ADYOG SOFTWARE SOLUTIONS PRIVATE LIMITED",
"ADZ EDGE COMMUNICATIONS PRIVATE LIMITED",
"ADZ NETWORK MEDIA PRIVATE LIMITED",
"ADZ VALUE SERVICE PRIVATE LIMITED",
"ADZ2LEAD MEDIA PRIVATE LIMITED",
"ADZEALOUS MEDIA PRIVATE LIMITED",
"ADZILLOW PRIVATE LIMITED",
"ADZONE CAST PRIVATE LIMITED",
"ADZURITE SOLUTIONS PRIVATE LIMITED",
"AE ABRASIVES EDGE PRIVATE LIMITED",
"AE AVON ENGINEERING",
"AE INDUSTRIES PRIVATE LIMITED",
"AE MART PRIVATE LIMITED",
"AE SECURITAS INTERNATIONAL PRIVATE LIMITED",
"AE SECURITIES AND INVESTMENTS PRIVATE LIMITED",
"AE TELELINK SYSTEMS LIMITED",
"AE TOLLWAY LIMITED",
"AEC BIM SOLUTIONS PRIVATE LIMITED",
"AEC DIGITAL STUDIO PRIVATE LIMITED",
"AEC EDUCATION PRIVATE LIMITED",
"AEC ELECTRICALS AND NETWORKS PRIVATE LIMITED",
"AEC ELECTRO-MECH PROJECTS PRIVATE LIMITED",
"AEC ENGINEERS PVT LTD",
"AEC INTERIORS PRIVATE LIMITED",
"AEC OFFSHORE TRADING PRIVATE LIMITED",
"AEC TRANSOLUTIONS PRIVATE LIMITED",
"AECC INDIA PRIVATE LIMITED",
"AECIO IT SOLUTIONS INDIA PRIVATE LIMITED",
"AECLAT LIFESCIENCES PRIVATE LIMITED",
"AECO TECHNOSTRUCT PRIVATE LIMITED",
"AECOM ASIA COMPANY LIMITED",
"AECOM INDIA GLOBAL SERVICES PRIVATE LIMITED",
"AECOM INDIA PRIVATE LIMITED",
"AECONE CONSUMER CARE PRIVATE LIMITED",
"AECOR DIGITAL INTERNATIONAL PRIVATE LIMITED",
"AECOZ BIOWARE PRIVATE LIMITED",
"AECS ENGINEERING & GEOTECHNICAL SERVICES PRIVATE LIMITED",
"AEDAS INDIA PRIVATE LIMITED",
"AEDBM CONSULTANTS PRIVATE LIMITED",
"AEDCO DEVELOPERS PRIVATE LIMITED",
"AEDEN FRUITS INTERNATIONAL PRIVATE LIMITED",
"AEDIFICE INFRASTRUCTURE PROJECTS PRIVATE LIMITED",
"AEG POWER SOLUTIONS INDIA PRIVATE. LIMITED.",
"AEGAN TECHNOLOGIES PRIVATE LIMITED",
"AEGAR HEALTHCARE PRIVATE LIMITED",
"AEGEUS FOOD PRIVATE LIMITED",
"AEGEUS MANAGEMENT PRIVATE LIMITED",
"AEGEUS PHARMA PRIVATE LIMITED",
"AEGEUS TECHNOLOGIES PRIVATE LIMITED",
"AEGIS AGRI INNOVATIONS PRIVATE LIMITED",
"AEGIS AGRO CHEMICALS (INDIA) PRIVATE LIMITED",
"AEGIS ASSOCIATES PRIVATE LIMITED",
"AEGIS AUTOMATION INDIA PRIVATE LIMITED",
"AEGIS BEVERAGES PRIVATE LIMITED",
"AEGIS BUSINESS LIMITED",
"AEGIS CARE ADVISORS PRIVATE LIMITED",
"AEGIS CUSTOMER SUPPORT SERVICES PRIVATE LIMITED",
"AEGIS DISTRIBUTORS PRIVATE LIMITED",
"AEGIS ELEVATOR PRIVATE LIMITED",
"AEGIS ENGG CO PVT LTD",
"AEGIS FARM SOLUTIONS PRIVATE LIMITED",
"AEGIS GAS LPG PRIVATE LIMITED'S AGPL",
"AEGIS INDUSTRIES LIMITED",
"AEGIS INFORMATICS PRIVATE LIMITED",
"AEGIS INFOTECH PRIVATE LIMITED",
"AEGIS INFRA SOLUTIONS PRIVATE LIMITED",
"AEGIS INFRASOLUTIONS INDIA PRIVATE LIMITED",
"AEGIS LIFESCIENCES PRIVATE LIMITED",
"AEGIS LOGISTICS LIMITED ALL",
"AEGIS MANAGEMENT & FINANCIAL CONSULTING INDIA PRIVATE. LIMITED",
"AEGIS PERSONAL CARE LLP",
"AEGIS PRECISION PRIVATE LIMITED",
"AEGIS PROTECTION PRIVATE LIMITED",
"AEGIS PUNCHING SYSTEMS PRIVATE LIMITED",
"AEGIS REALTORS & DEVELOPERS PRIVATE LIMITED",
"AEGIS RESOLUTION SERVICES PRIVATE LIMITED",
"AEGIS SCAFFOLDING SERVICES PRIVATE LIMITED",
"AEGIS SECURITY VENTURES PRIVATE LIMITED",
"AEGIS SEEDS PRIVATE LIMITED",
"AEGIS SKYHIGH HOUSING CORPORATION PRIVATE LIMITED",
"AEGIS SMART LOGIX INDIA PRIVATE LIMITED",
"AEGIS STEEL CAST",
"AEGIS VALUE HOMES LIMITED",
"AEGIS VOPAK TERMINALS LIMITED",
"AEGIS WAREHOUSING SERVICES PRIVATE LIMITED",
"AEGISCOVENANT PRIVATE LIMITED",
"BANDHAN LIFE INSURANCE LIMITED",
"AEGON SHIPPING INDIA PRIVATE LIMITED",
"AEGOUS HEALTHCARE PRIVATE LIMITED",
"AEH OILFIELD EQUIPMENT AND SERVICES PRIVATE LIMITED",
"AEI COMPOUNDS INDIA PRIVATE LIMITED",
"AEI ENGINEERING INDUSTRIES PRIVATE LIMITED",
"AEI EXPLOMOBILE PRIVATE LIMITED",
"AEI LAMINATIONS PRIVATE LIMITED",
"AEIFORIA CONSTRUCTIONS PRIVATE LIMITED",
"AEINDRI AGRO FOOD PRODUCT PRIVATE LIMITED",
"AEKOT CONSULTING AND TECHNOLOGIES PRIVATE LIMITED",
"AEL BERKMAN GLOBAL BUSINESS SOLUTIONS (INDIA) PRIVATE LIMITED",
"AEL BERKMAN GLOBAL BUSINESS SOLUTIONS I PRIVATE LIMITED",
"AEL DATA SERVICES LLP",
"AELEA COMMODITIES LIMITED",
"AELEA COMMODITIES PRIVATE LIMITED",
"AELITE EDGE BUSINESS CONSULTING PRIVATE LIMITED",
"AELITE LOGISTICS & MARKETING PRIVATE LIMITED",
"AELIUSPARALLEL HOLDINGS PRIVATE LIMITED",
"AELIYA MARINE TECH PRIVATE LIMITED",
"AELUM CONSULTING PRIVATE LIMITED",
"AEM EQUIPMENTS PRIVATE LIMITED",
"AEM MARCOM INDIA PRIVATE LIMITED",
"AEMA INTERNATIONAL PRIVATE LIMITED",
"AEML INVESTMENTS LIMITED",
"AEMS ENGINEERING WORKS PRIVATE LIMITED",
"AENDVI TECHNOLOGIES PRIVATE LIMITED",
"AEOLOGIC TECHNOLOGIES PRIVATE LIMITED",
"AEOLUS ENGINEERING AND TECHNOLOGIES PRIVATE LIMITED",
"AEOLUS WIND PARKS PRIVATE LIMITED",
"AEOMEDS HEALTHCARE PRIVATE LIMITED",
"AEON CEREALS LIMITED",
"AEON COMMERCIAL INDIA PRIVATE LIMITED",
"AEON COMMODITIES PRIVATE LIMITED",
"AEON COMMUNICATION PRIVATE LIMITED",
"AEON CREDIT SERVICE INDIA PRIVATE LIMITED",
"AEON CREDIT SERVICES INDIA PRIVATE LIMITED",
"AEON ENTERTAINMENT PRIVATE LIMITED",
"AEON FASHIONS (INDIA) PRIVATE LIMITED",
"AEON FORMULATIONS PRIVATE LIMITED",
"AEON INDIA CORPORATION PRIVATE LIMITED",
"AEON IT SOLUTIONS PRIVATE LIMITED",
"AEON LEARNING PRIVATE LIMITED",
"AEON MARKET RESEARCH PRIVATE LIMITED",
"AEON MEASUREMENT SYSTEMS PRIVATE LIMITED",
"AEON MEDICAL PRIVATE LIMITED",
"AEON OUTSOURCING PRIVATE LIMITED",
"AEON PROCARE PRIVATE LIMITED",
"AEON SPORTS INDIA PRIVATE LIMITED",
"AEON SYSTEMS INDIA PRIVATE LIMITED",
"AEON TELECTRONICS PRIVATE LIMITED",
"AEONAUTO PRIVATE LIMITED",
"AEONX DIGITAL SOLUTIONS PRIVATE LIMITED",
"AEONX DIGITAL TECHNOLOGY LIMITED",
"AEORA ROCKS EXPORTS (OPC) PRIVATE LIMITED",
"AEP INDUSTRIES PRIVATE LIMITED",
"AEPCOM FASTENERS PRIVATE LIMITED",
"AEPL ENGINEERING PRIVATE LIMITED",
"AEPL INFRASTRUCTURE PRIVATE LIMITED",
"AEPROCUREX SOURCING PRIVATE LIMITED",
"AEQUITAS DEBT SOLUTIONS PRIVATE LIMITED",
"AEQUITAS DIAQURE PRIVATE LIMITED",
"AEQUITAS ENGINEERING PRIVATE LIMITED",
"AEQUITAS ENTERPRISES PRIVATE LIMITED",
"AEQUITAS HEALTHCARE PRIVATE LIMITED",
"AEQUITAS INVESTMENT CONSULTANCY PRIVATE LIMITED",
"AEQUOR INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"AEQUS AUTOMOTIVE PRIVATE LIMITED",
"AEQUS CONSUMER PRODUCTS PRIVATE LIMITED",
"AEQUS ENGINEERED PLASTICS PRIVATE LIMITED",
"AEQUS FORCE CONSUMER PRODUCTS PRIVATE LIMITED",
"AEQUS FOUNDATION",
"AEQUS PRIVATE LIMITED",
"AEQUS SEZ PRIVATE LIMITED",
"AER WORLDWIDE INDIA PRIVATE LIMITED",
"AERA EXPORTS PRIVATE LIMITED",
"AERA SOFTWARE TECHNOLOGY PRIVATE LIMITED",
"AERAMIC AEROSPACE INDIA PRIVATE LIMITED",
"AERAN LAB INDIA PRIVATE LIMITED",
"AERANN INSTRUMENTS AND ENGINEERING SERVICES PRIVATE LIMITED",
"AERATE FROST INDIA PRIVATE LIMITED",
"AERCOMFORT PRIVATE LIMITED",
"AERCON INDIA",
"AEREM SOLUTIONS PRIVATE LIMITED",
"AEREN IT SOLUTIONS PRIVATE LIMITED",
"AEREN R REALTORS PRIVATE LIMITED",
"AERENS BUILDWELL LIMITED",
"AERENS JAI REALTY PRIVATE LIMITED",
"AE-RESEARCH PRIVATE LIMITED",
"AERGLO LIGHTING PRIVATE LIMITED",
"AERIAL GLOBAL COMMUNICATIONS LLP",
"AERIAL SERVICES PRIVATE LIMITED",
"AERIAL TELECOM SOLUTIONS PRIVATE LIMITED",
"AERICON POWER PRIVATE LIMITED",
"AERIES FINANCIALTECHNOLOGIES PRIVATE LIMITED",
"AERIFY INDIA PRIVATE LIMITED",
"AERIS COMMUNICATIONS INDIA PRIVATE LIMITED",
"AERIS DYNAMICS PACKAGING INDIA PRIVATE LIMITED",
"AERIS METALS & ALLOYS PRIVATE LIMITED",
"AERIUS MARINE INDIA PRIVATE LIMITED",
"AERIZ AGRI EXPORTS PRIVATE LIMITED",
"AERO AGENCIES PRIVATE LIMITED",
"AERO AGRO CHEMICAL INDUSTRIES LIMITED",
"AERO BASED CONTROL SYSTEMS PRIVATE LIMITED",
"AERO CARE PERSONAL PRODUCTS LLP",
"AERO CHARTER SERVICES INDIA PRIVATE LIMITED",
"AERO CLUB",
"AERO DIGITAL WORLD PRIVATE LIMITED",
"AERO ENGINEERS GUJARAT PRIVATE LIMITED",
"AERO FASTENERS PRIVATE LIMITED",
"AERO FIBRE PRIVATE LIMITED",
"AERO FLIGHT SOLUTIONS PRIVATE LIMITED",
"AERO INTERIORS PRIVATE LIMITED",
"AERO INVENTIVE LASER INDIA PRIVATE LIMITED",
"AERO MARKETING PRIVATE LTD",
"AERO PISTONS PRIVATE LIMITED",
"AERO PLAST LIMITED",
"AERO RETAIL LOGISTICS PRIVATE LIMITED",
"AERO SAIL SERVICES PRIVATE LIMITED",
"AERO STEELS PRIVATE LIMITED",
"AERO SURVEY PRIVATE LIMITED",
"AERO TECH WEARS PRIVATE LIMITED",
"AERO TREATMENTS PRIVATE LIMITED",
"AERO WALK INTERNATIONAL (INDIA) PRIVATE LIMITED",
"AEROARC PRIVATE LIMITED",
"AEROBE PRIVATE LIMITED",
"AEROBODE ONE PRIVATE LIMITED",
"AEROBOK SHOE PRIVATE LIMITED",
"AEROCHAMP AVIATION INTERNATIONAL PRIVATE LIMITED",
"AEROCHEM PIPING PRIVATE LIMITED",
"AEROCOACH PRIVATE LIMITED",
"AEROCOAST LOGISTICS PRIVATE LIMITED",
"AEROCOM AUTOMOTIVES PRIVATE LIMITED",
"AEROCOM CUSHIONS PRIVATE LIMITED",
"AEROCOM PVT LTD",
"AEROCOMPACT INDIA PRIVATE LIMITED",
"AEROCON BUILDWELL PRIVATE LIMITED",
"AEROCRAFT ENGINEERING (INDIA) PRIVATE LIMITED",
"AEROCRUZ LOGISTICS PRIVATE LIMITED",
"AERODRY PLASTICS AUTOMATION PRIVATE LIMITED",
"AERODYNAMIKS AVIGATION PRIVATE LIMITED",
"AERODYNE INDIA VENTURES PRIVATE LIMITED",
"AEROFIL FILTERS INDIA PRIVATE LIMITED",
"AEROFLEX FITTINGS PRIVATE LIMITED",
"AEROFLEX INDIA PRIVATE LIMITED",
"AEROFLEX INDUSTRIES LIMITED",
"AEROFLEX SPORTS FLOORINGS PRIVATE LIMITED",
"AEROFLOT SECURITY SERVICE PRIVATE LIMITED",
"AEROFLOT TOUR INDIA PRIVATE LIMITED",
"AEROFREIGHT LOGISTICS PRIVATE LIMITED",
"AEROGEN MEDICAL DEVICES INDIA PRIVATE LIMITED",
"AEROGRAPHICS PAPERS PRIVATE LIMITED",
"AEROGUIDE AVIATION SERVICES PRIVATE LIMITED",
"AEROL FORMULATIONS PRIVATE LIMITED",
"AEROLAM INSULATIONS PRIVATE LIMITED",
"AEROLEX CABLES PRIVATE LIMITED",
"AEROLEX MOTORS P LIMITED",
"AEROLITE ENGINEERS PRIVATE LIMITED",
"AEROLITE INDUSTRIES PRIVATE LIMITED",
"AEROLLOY TECHNOLOGIES LIMITED",
"AEROLOGIX INDIA PRIVATE LIMITED",
"AEROLUX INDIA PRIVATE LIMITED",
"AEROMA CHEMICALS PVT LTD",
"AEROMACH WONDERS",
"AEROMAR LOGISTICS INDIA PRIVATE LIMITED",
"AEROMARINE PRIVATE LIMITED",
"AEROMATIC ENGINEERING PRIVATE LIMITED",
"AEROMAX AVIATION SERVICES PRIVATE LIMITED",
"AEROMEC MARKETING COMPANY PRIVATE LIMITED",
"AEROMECH EQUIPMENTS PRIVATE LIMITED",
"AEROMED INTERNATIONAL RESCUE SERVICES PRIVATE LIMITED",
"AEROMETIC CARE PRIVATE LIMITED",
"AERON AQUA TRADERS PRIVATE LIMITED",
"AERON AUTOMATION SOLUTIONS PRIVATE LIMITED",
"AERON COMPOSITE PRIVATE LIMITED",
"AERON LIFESCIENCE PRIVATE LIMITED",
"AERON SYSTEMS PRIVATE LIMITED",
"AERONET TECHNOLOGIES PRIVATE LIMITED",
"AERONET TRAVTOUR PRIVATE LIMITED",
"AERONOT FRAGRANCES PRIVATE LIMITED",
"AERONS (INDIA) EXIM PRIVATE LIMITED",
"AERONUBE TECHNOLOGY PRIVATE LIMITED",
"AERONUTRIX SPORTS PRODUCTS PRIVATE LIMITED",
"AEROPACT PRECISION MACHINING PRIVATE LIMITED",
"AEROPICT LOGISTICS SOLUTIONS PRIVATE LIMITED",
"AEROPOST LOGISTICS PRIVATE LIMITED",
"AEROS FOOTCARE PRIVATE LIMITED",
"AEROSEA FORWARDERS PRIVATE LIMITED",
"AEROSHIP FREIGHT SOLUTIONS PRIVATE LIMITED",
"AEROSHIP LOGICARE PRIVATE LIMITED",
"AEROSHIP LOGISTICS PRIVATE LIMITED",
"AEROSOL FILTERS PRIVATE LIMITED",
"AEROSOL SERVICES (INDIA) PRIVATE LIMITED",
"AEROSOURCE (INDIA) PRIVATE LIMITED",
"AEROSPACE AND AVIATION SECTOR SKILL COUNCIL",
"AEROSPACE ENGINEERS PRIVATE LIMITED",
"AEROSPACE HOLIDAYS PRIVATE LIMITED",
"AEROSPACE MATERIALS PRIVATE. LIMITED.",
"AEROSPACE PROCESSING INDIA PRIVATE LIMITED",
"AEROSTRUCTURES ASSEMBLIES INDIA PRIVATE LIMITED",
"AEROSTRUCTURES MANUFACTURING INDIA PRIVATE LIMITED",
"AEROTECH AVIATION SERVICES PRIVATE LIMITED",
"AEROTECH ENERGY PRIVATE LIMITED",
"AEROTECH ENG. WORKS PRIVATE LIMITED",
"AEROTECH ENGINEERING INDIA PRIVATE LIMITED",
"AEROTECH FMS PRIVATE LIMITED",
"AEROTECH INSPECTION & NDT (INDIA) PRIVATE LIMITED",
"AEROTIME PRIVATE LIMITED",
"AEROTIVEPLUS TECHNOLOGIES AND SERVICES PRIVATE LIMITED",
"AEROTO BOLDROCCHI INDIA PRIVATE LIMITED",
"AEROTRAINS LOGISTICS & ENGINEERING SOLUTIONS PRIVATE LIMITED",
"AEROTRANS GLOBAL FORWARDING INDIA PRIVATE LIMITED",
"AEROTRANS SERVICES PRIVATE LIMITED",
"AEROVATIVE TECHNOLOGIES PRIVATE LIMITED",
"AEROVENT PROJECTS PRIVATE LIMITED",
"AEROVENTO FAN COMPANY PRIVATE LIMITED",
"AEROWAY NETWORKS PRIVATE LIMITED",
"AEROWELL PUMP PRIVATE LIMITED",
"AEROWHEELS TRAVELS PRIVATE LIMITED",
"AEROWISE TRAVEL AND FOREX PRIVATE LIMITED",
"AEROX CLOTHING PRIVATE LIMITED",
"AERWA INFRASTRUCTURE AND SOLUTIONS PRIVATE LIMITED",
"AERZEN MACHINES (INDIA) PRIVATE LIMITED",
"AES AUTOMOTIVE COMPANY PRIVATE LIMITED",
"AES INDIA PRIVATE LIMITED",
"AES INSULATE SEALS INDIA PRIVATE LIMITED",
"AES LABORATONES PRIVATE LIMITED",
"AES SERVICES LLP",
"AES TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"AES THERMAL ENGINEERING PRIVATE LIMITED",
"AES TRANSPOWER INC.",
"AESA AIR ENGINEERING PRIVATE LIMITED",
"AESEO HOTELS PRIVATE LIMITED",
"AESERA JEWELS PRIVATE LIMITED",
"AESMOVE GLOBAL MOBILITY SERVICES PRIVATELIMITED",
"AESSEAL COLD WELD PRIVATE LIMITED",
"AESSEAL INDIA PRIVATE LIMITED",
"AESSEN PRIVATE LIMITED",
"AESTHETE INTERNATIONAL PRIVATE LIMITED",
"AESTHETIC ARC INFRATECH PRIVATE LIMITED",
"AESTHETIC GOLD ORNAMENTS PRIVATE LIMITED",
"AESTHETIC INTERNATIONAL PRODUCTS PRIVATE LIMITED",
"AESTHETIC LIVING MERCHANTS PRIVATE LIMITED",
"AESTHETIC STAMPINGS& LAMINATION LIMITED",
"AESTHETICS ZONE MEDISYS PRIVATE LIMITED",
"AESTHETIK ENGINEERS LIMITED",
"AESTHETIX TECHNOLOGIES INDIA PRIVATE LIMITED",
"AESTICARE HEALTH SERVICES OPS PRIVATE LIMITED",
"AESTRO VALVES & PNEUMATICS CO",
"AESTUS INDUCTION (INDIA) PRIVATE LIMITED",
"AET BUILDING PRODUCTS (WESTERN INDIA) PRIVATE LIMITED",
"AET FLEXIBLESPACE INDIA PRIVATE LIMITED",
"AET LABORATORIES PRIVATE LIMITED",
"AETAS RETAIL PRIVATE LIMITED",
"AETHER BREWERIES LLP",
"AETHER CONSULTING PRIVATE LIMITED",
"AETHER ENTERPRISE APPLICATIONS LLP",
"AETHER INDUSTRIES LIMITED",
"AETHER PROSTHETICS PRIVATE LIMITED",
"AETHEREUS CONSULTING PRIVATE LIMITED",
"AETINS GLOBAL SERVICES PRIVATE LIMITED",
"AETIUS OUTSOURCING & CONSULTING PRIVATE LIMITED",
"AETN18 MEDIA PRIVATE LIMITED",
"AETNA INC.",
"AETOM ENGINEERING TECHNOLOGIES PRIVATE LIMITED",
"AETOS AGRO MERCHANTS PRIVATE LIMITED",
"AETOS DESIGN AND ENGINEERING PRIVATE LIMITED",
"AETOS DIGITAL INNOVATIONS PRIVATE LIMITED",
"AETRICO INDUSTRIES PRIVATE LIMITED",
"AETRIO TECHNOLOGY INDIA PRIVATE LIMITED",
"AETS INDIA PRIVATE LIMITED",
"AEVAS BUSINESS SOLUTIONS PRIVATE LIMITED",
"AEVITAS CAPITAL PRIVATE LIMITED",
"AEVITAS PHARMAGRO TECH PRIVATE LIMITED",
"AEVITAS PROCUREMENT SERVICE PRIVATE LIMITED",
"AEW AUTOMATIONS PRIVATE LIMITED",
"AEW ELECTRICAL PRIVATE LIMITED",
"AEW FABRICATORS PRIVATE LIMITED",
"AEW INFRATECH PRIVATE LIMITED",
"AEXON GRAPHICS INDIA PRIVATE LIMITED",
"AEXONTRONICS PRIVATE LIMITED",
"AEY KEY TANKS AND VESSELS PRIVATE LIMITED",
"AEY PEE ROADWAYS PRIVATE LIMITED",
"AEY PEE TRANSPORT COMPANY PRIVATE LIMITED",
"AEZION TECHNOLGIES PRIVATE LIMITED",
"AEZIS GLOBAL PRIVATE LIMITED",
"AF ADVISORS PRIVATE LIMITED",
"AF CONSULT INDIA PRIVATE LIMITED",
"AF FERRARI SECURE LOGITECH PRIVATE LIMITED",
"AF GARMENTS PRIVATE LIMITED",
"AF INFRASTRUCTURE PRIVATE LIMITED",
"AF LIFESTYLE INTERNATIONAL PRIVATE LIMITED",
"AFAAF BUILDERS & DEVELOPERS PRIVATE LIMITED",
"AFABLEZ SEMICONDUCTOR PRIVATE LIMITED",
"AFAC ENGLISH SCHOOL",
"AFAIRS EXHIBITIONS & MEDIA PRIVATE LIMITED",
"AFC DIGITAL PRIVATE LIMITED",
"AFC ELASTOMERS TECHNOLOGY PRIVATE LIMITED",
"AFC FURNITURE SOLUTIONS PRIVATE LIMITED",
"AFC INDIA LIMITED",
"AFC OVERSEAS PRIVATE LIMITED",
"AFCL LOGISTICS PRIVATE LIMITED",
"AFCO FINCON PRIVATE LIMITED",
"AFCO INVESTMENTS SERVICES PRIVATE LIMITED",
"AFCO LOGISTICS PRIVATE LIMITED",
"AFCOM HOLDINGS LIMITED",
"AFCOM HOLDINGS PRIVATE LIMITED",
"AFCONS INFRASTRUCTURE LIMITED",
"AFD LABORATORIES PRIVATE LIMITED",
"AFEEL LIFE CARE PRIVATE LIMITED",
"AFERA INFRATECH PRIVATE LIMITED",
"AFEX TECHNOLOGIES PRIVATE LIMITED",
"AFF AROMATICS PVT LTD",
"AFF DETAILING SERVICES PRIVATE LIMITED",
"AFF LOGISTICS PRIVATE LIMITED",
"AFFAN SHOES PRIVATE LIMITED",
"AFFECTION INFRADEVELOPERS PRIVATE LIMITED",
"AFFERENT WEARABALE TECH PRIVATE LIMITED",
"AFFIANCE INFRASTRUCTURE AND DEVELOPERS PRIVATE LIMITED",
"AFFIGENIX BIOSOLUTIONS PRIVATE LIMITED",
"AFFIL VITRIFIED PRIVATE LIMITED",
"AFFILIATED COMPUTER SERVICES OF INDIA PRIVATE LIMITED",
"AFFILIATED EAST WEST PRESS PRIVATE LIMITED",
"AFFILIATEVIA ONLINE MEDIA PRIVATE LIMITED",
"AFFINE ANALYTICS PRIVATE LIMITED",
"AFFINE STEELS PRIVATE LIMITED",
"AFFINIDI INDIA PRIVATE LIMITED",
"AFFINIQUE MARKETING PRIVATE LIMITED",
"AFFINIQUE TRADING INDIA PRIVATE LIMITED",
"AFFINITEE LABORATORIES PRIVATE LIMITED",
"AFFINITI FORWARDERS PRIVATE LIMITED",
"AFFINITIV ENGINEERING INDIA LLP",
"AFFINITY ANSWERS PRIVATE LIMITED",
"AFFINITY ASSOCIATES LIMITED",
"AFFINITY CONSULTANT PRIVATE LIMITED",
"AFFINITY CONSULTANTS PRIVATE LIMITED",
"AFFINITY ELDER CARE",
"AFFINITY EXPRESS INDIA PRIVATE LIMITED",
"AFFINITY GLOBAL ADVERTISING PRIVATE LIMITED",
"AFFINITY IT SOLUTIONS PRIVATE LIMITED",
"AFFINITY JEWELS PRIVATE L TD",
"AFFINITY LOGISTICS & PLANNERS PRIVATE LIMITED",
"AFFINITY MARITIME SERVICES PRIVATE LIMITED",
"AFFINITY MEDIA SERVICES PRIVATE LIMITED",
"AFFINITY OUTSOURCING LIMITED",
"AFFINITY PLANNERS PRIVATE LIMITED",
"AFFINITY POWER PRIVATE LIMITED",
"AFFINITY PREMIUM DENTAL CLINIC AND TRAINING CENTRE PRIVATE LIMITED",
"AFFINITY SECURITIES PRIVATE LIMITED",
"AFFINSYS AI PRIVATE LIMITED",
"AFFIPEDIA DIGITAL PRIVATE LIMITED",
"AFFIRM DATA SERVICES PRIVATE LIMITED",
"AFFIRMA CAPITAL INVESTMENT ADVISER INDIA PRIVATE LIMITED",
"AFFIRMATIVE FINANCIAL SERVICES PRIVATE LIMITED",
"AFFISE TECHNOLOGIES INDIA PRIVATE LIMITED",
"AFFITO GAS PRIVATE LIMITED",
"AFFIX SCAFFOLDING INDIA PRIVATE LIMITED",
"AFFIXIOUS CONSULTING PRIVATE LIMITED",
"AFFLATUS GRAVURES PRIVATE LIMITED",
"AFFLATUS PHARMACEUTICALS PRIVATE LIMITED",
"AFFLATUS TRADING PRIVATE LIMITED",
"AFFLE (INDIA) LIMITED",
"AFFLE INDIA PRIVATE LIMITED",
"AFFLON IMPEX PRIVATE LIMITED",
"AFFLUENCE COMMODITIES PRIVATE LIMITED",
"AFFLUENCE FINCON SERVICE PRIVATE LIMITED",
"AFFLUENCE GEMS PRIVATE LIMITED",
"AFFLUENCE INFOSYSTEMS PRIVATE LIMITED",
"AFFLUENCE REALTY AND LEASING PRIVATE LIMITED",
"AFFLUENCE SHARES AND STOCKS PRIVATE LIMITED",
"AFFLUENT AGENTS PRIVATE LIMITED",
"AFFLUENT ESTATES PRIVATE LIMITED",
"AFFLUENT EXTRUSION TECHNIK PRIVATE LIMITED",
"AFFLUENT GLOBAL SERVICES PRIVATE LIMITED",
"AFFLUENT INFOTECH PRIVATE LIMITED",
"AFFLUENT REALHOME PRIVATE LIMITED",
"AFFLUENTIAL PHARMACEUTICALS PRIVATE LIMITED",
"AFFLY IMPEX PRIVATE LIMITED",
"AFFNADS SOLUTIONS PRIVATE LIMITED",
"AFFNET MARKETING MEDIA PRIVATE LIMITED",
"AFFORD AIR-EXPRESS PRIVATE LIMITED",
"AFFORD FREIGHT SERVICES PRIVATE LIMITED",
"AFFORD MARINE CONTROLS PRIVATE LIMITED",
"AFFORD MEDICAL TECHNOLOGIES PRIVATE LIMITED",
"AFFORD MOTORS INDIA PRIVATE LIMITED",
"AFFORDA CONSULTANTS PRIVATE LIMITED",
"AFFORDABLE DEALS PRIVATE LIMITED",
"AFFORDABLE FOREX PRIVATE LIMITED",
"AFFORDABLE INFRASTRUCTURE AND HOUSING PROJECTS PRIVATE LIMITED",
"AFFORDABLE KIMAYA KIDNEY CARE PRIVATE LIMITED",
"AFFORDABLE ROBOTIC & AUTOMATION LIMITED",
"AFFORDABLE TRAVEL VOYAGE PRIVATE LIMITED",
"AFFORTABLE TECH SERVICE PRIVATE LIMITED",
"AFFOSOFT TECHNOLOGIES INDIA PRIVATE LIMITED",
"AFFOY MEDIA PRIVATE LIMITED",
"AFFREIGHTER LOGISTICS PRIVATE LIMITED",
"AFFROOTS ONLINE PRIVATE LIMITED",
"AFFY INDIA PRIVATE LIMITED",
"AFG BUSINESS SOLUTIONS INDIA PRIVATE LIMITED",
"AFG LIFESTYLE PRIVATE LIMITED",
"AFH FURNITURE PRIVATE LIMITED",
"AFI AGRO PRIVATE LIMITED",
"AFIA INSURANCE BROKERAGE SERVICES",
"AFIA STEEL ISPAT PRIVATE LIMITED",
"AFICIONADO TECHNOLOGIES PRIVATE LIMITED",
"AFILIAS INDIA PRIVATE LIMITED",
"AFILITY ENGINEERING PRIVATE LIMITED",
"AFIMAC ASSOCIATES PRIVATE LTD",
"AFIRST LIFESCIENCE PRIVATE LIMITED",
"AFITA CONSTRUCTIONS PRIVATE LIMITED",
"AFKON AUTOMOTIVES PRIVATE LIMITED",
"AFL PRIVATE LIMITED",
"AFLAH TECHNOLOGIES PRIVATE LIMITED",
"AFLASH SECURITY AND PERSONNEL MANAGEMENT PRIVATE LIMITED",
"AFLOAT ENTERPRISES LIMITED",
"AFLON ENGINEERING PRIVATE LIMITED",
"AFM LOGISTICS PRIVATE LIMITED",
"AFN LANGRANA SHARE AND STOCK BROKERS PRIVATE LIMITED",
"AFN SUPPLY CHAIN INDIA PRIVATE LIMITED",
"AFOND CONSTRUCTIONS PRIVATE LIMITED",
"AFOND STEEL COMPLEX PRIVATE LIMITED",
"AFOOZO PRIVATE LIMITED",
"AFORESERVE LABS PRIVATE LIMITED",
"AFORORANGE COMMUNICATIONS PRIVATE LIMITED",
"AFOUR TECHNOLOGIES PRIVATE LIMITED",
"AFP IDEAS AND EXECUTION PRIVATE LIMITED",
"AFP MANUFACTURING CO. PRIVATE LIMITED",
"AFP MARKETING COMPANY PRIVATE LIMITED",
"AFPA INDIA PRIVATE LIMITED",
"AFPL GLOBAL PRIVATE LIMITED",
"AFRAMAX LOGISTICS INDIA PRIVATE LIMITED",
"AFRASIA COMMUNICATION PRIVATE LIMITED",
"AFRAZ HEALTHCARE PRIVATE LIMITED",
"AFRI POWER VENTURES PRIVATE LIMITED",
"AFRI VENTURES (INDIA) PRIVATE LIMITED",
"AFRIBA AGRO PRIVATE LIMITED",
"AFRICA COLD STORAGE PVT LTD",
"AFRICA VIEW PRIVATE LIMITED",
"AFRICAN AGRO PRODUCTS PRIVATE LIMITED",
"AFRICAN ASIAN RURAL DEVELOPMENT ORGANZATION",
"AFRICAN BANKING CORPORATION",
"AFRICAN CARIBBEAN ALOE SALES (INDIA) PRIVATE LIMITED",
"AFRICURE PHARMACEUTICALS (INDIA) PRIVATE LIMITED",
"AFRINEXT OVERSEAS PRIVATE LIMITED",
"AFRISO INDIA PRIVATE LIMITED",
"AFRO ASIAN INSURANCE & REINSURANCE BROKERS I PRIVATE. LIMITED",
"AFROZ SHAH FOUNDATION",
"AFRO-ZEST INDUSTRIES INDIA PRIVATE LIMITED",
"AFRY ENGINEERING INDIA PRIVATE LIMITED",
"AFRY INDIA PRIVATE LIMITED",
"AFS FACILITY INTENT INDIA PRIVATE LIMITED",
"AFS INTERCULTURAL PROGRAMS INDIA",
"AFS LOGISTICS INTERNATIONAL PRIVATE LIMITED",
"AFS TECHNOLOGY SERVICES PRIVATE LIMITED",
"AFSAN FOOD PRODUCTS PVT LTD",
"AFSARHUB PRIVATE LIMITED",
"AFSHAN QTAT BPO SOLUTIONS PRIVATE LIMITED",
"AFSRAA STEEL PRIVATE LIMITED",
"AFSS CONSULTANCY PRIVATE LIMITED",
"AFT FIBER TECHNOLOGIES PRIVATE LIMITED",
"AFT TOBACCO PRIVATE LIMITED",
"AFTAAB SOLAR PRIVATE LIMITED",
"AFTAB AGENCIES PVT. LTD.",
"AFTAB INFOCOM PRIVATE LIMITED",
"AFTAB STEELS PRIVATE LIMITED",
"AFTEK DEVELOPERS PRIVATE LIMITED",
"AFTERNOW LAB PRIVATE LIMITED",
"AFTERPLAY STUDIOS LLP",
"AFTERTHOUGHT FEEDBACK SERVICES PRIVATE LIMITED",
"AFTON CHEMICAL HYDERABAD PRIVATE LIMITED",
"AFTON CHEMICAL INDIA PRIVATE LIMITED",
"AFV HOSPITALITY PRIVATE LIMITED",
"AFV RETAIL PRIVATE LIMITED",
"AFVAL WATER SOLUTIONS PRIVATE LIMITED",
"AFXIA FRANKE PRIVATE LIMITED",
"AFY TECHNOLOGIES LLP",
"AFZA INTERNATIONAL PRIVATE LIMITED",
"AFZAL TEXTILES PRIVATE LIMITED",
"AG (E AND RS AUDIT) MP BHOPAL",
"AG ACCOUNTS BHUBANESWAR",
"AG AUTO PRIVATE LIMITED",
"AG BELTING PRIVATE LIMITED",
"AG BIM DESIGN SERVICES PRIVATE LIMITED",
"AG CREATIVE THINKERS CONSULTING PRIVATE LIMITED",
"AG DERCO BELTING (INDIA) PRIVATE LIMITED",
"AG ENTERPRISES",
"AG ENVIRO INFRA PROJECTS PRIVATE LIMITED",
"AG FIBROTECH PVT LTD",
"AG FURNANCE IMPROVEMENTS PRIVATE LIMITED",
"AG GRANITES PRIVATE LIMITED",
"AG INDUSTRIES (BAWAL) PRIVATE LIMITED",
"AG INDUSTRIES BAWAL PRIVATE LIMITED",
"AG KNOWLEDGETECH PRIVATE LIMITED",
"AG LAMITEX PRIVATE LIMITED",
"AG MEASUREMATICS PRIVATE LIMITED",
"AG MULLER TECHNIK PRIVATE LIMITED",
"AG POLY PACKS PRIVATE LIMTED",
"AG RESOURCES INDIA PRIVATE LIMITED",
"AG TECHNOLOGIES PRIVATE LIMITED",
"AG UP DIRECTORATE UP LKO",
"AG&P INFRASTRUCTURE INDIA PRIVATE LIMITED",
"AG. MARITIME PRIVATE LIMITED",
"AG. TRAVELS SOLUTIONS MANAGEMENT PRIVATE LIMITED",
"AGA HOSPITALITY PRIVATE LIMITED",
"AGA INFRA PROJECTS PRIVATE LIMITED",
"AGA KHAN AGENCY FOR HABITAT INDIA",
"AGA KHAN EDUCATION SERVICE INDIA",
"AGA KHAN HEALTH SERVICES INDIA",
"AGA KHAN RURAL SUPPORT PROGRAMME (INDIA)",
"AGA MEDIA VENTURES PRIVATE LIMITED",
"AGA PUBLICATIONS LIMITED",
"AGACHE ASSOCIATES LIMITED",
"AGADA DIAGNOSTICS PRIVATE LIMITED",
"AGADA HEALTHCARE PRIVATE LIMITED",
"AGAETIS TECHNOLOGIES PRIVATE LIMITED",
"AGAM AGOCHAR'S PRIVATE LIMITED",
"AGAM FASHIONS PRIVATE LIMITED",
"AGAM NOOR SUPPLIERS PRIVATE LIMITED",
"AGAM PHARMACEUTICALS",
"AGAM TEXTILES PVT LTD",
"AGAMA EDUCON PRIVATE LIMITED",
"AGAMA SOLUTIONS INDIA PRIVATE LIMITED",
"AGAMAHIL NATURAL PRODUCTS PRIVATE LIMITED",
"AGAMAN FASHIONS PVT LTD",
"AGAMANALYTICS PRIVATE LIMITED",
"AGAMANI BASANTI FASHIONS PRIVATE LIMITED",
"AGAMI TECH PRIVATE LIMITED",
"AGANI PROJECTS PRIVATE LIMITED",
"AGAP TECHNOLOGIES PRIVATE LIMITED",
"AGAPE WORLD PRIVATE LIMITED",
"AGAPPE DIAGNOSTICS LIMITED",
"AGARAM INFOTECH PRIVATE LIMITED",
"AGARAM PAINTS PRIVATE LIMITED",
"AGARAM TECHNOLOGIES PRIVATE LIMITED",
"AGARDEEP ENTERPRISES PRIVATE LIMITED",
"AGARMIN COALWASHERY PRIVATE LIMITED",
"AGARNI LEASING & FINANCE PRIVATE LIMITED",
"AGARPARA JUTE MILLS LIMITED",
"AGARSAIN BUSINESS SOLUTIONS PRIVATE LIMITED",
"AGARSAIN PACKERS & MOVERS PRIVATE LIMITED",
"AGARSEN INDUSTRIES PRIVATE LIMITED",
"AGARSEN MARBLES AND GRANITES PVT.LTD.",
"AGARSEN REROLLERS PVT LTD",
"AGARSHA INVESTMENT MANAGER PRIVATE LIMITED",
"AGARSHA SENIOR HOMES PRIVATE LIMITED",
"AGARSONS FINCAP SERVICES PRIVATE LIMITED",
"AGARTALA PLASTICS PRIVATE LIMITED",
"AGARVANSHI ALUMINIUM AND INFRA LIMITED",
"AGARVANSHI ALUMINIUM LIMITED",
"AGARWAL & AGARWAL PVT LTD",
"AGARWAL ADPRO PVT LTD",
"AGARWAL AGRO PRODUCTS PRIVATE LIMITED",
"AGARWAL ALUMAX PRIVATE LIMITED",
"AGARWAL AND ASSOCIATES IMPEX PRIVATE LIMITED",
"AGARWAL AROMAS PRIVATE LIMITED",
"AGARWAL ASSOCIATES PRIVATE LIMITED",
"AGARWAL ASSOCIATES PROMOTERS LIMITED",
"AGARWAL AUTO & CARE PRIVATE LIMITED",
"AGARWAL AUTOMOBILES",
"AGARWAL BEDDING SOLUTIONS PRIVATE LIMITED",
"AGARWAL BEVERAGES PRIVATE LIMITED",
"AGARWAL BOLTS LTD",
"AGARWAL BULKACTIVES PRIVATE LIMITED",
"AGARWAL CINE STUDIOS PRIVATE LIMITED",
"AGARWAL CINE WORLD PRIVATE LIMITED",
"AGARWAL CLEARING PRIVATE LIMITED",
"AGARWAL COAL CORPORATION PRIVATE LIMITED",
"AGARWAL CORPORATION",
"AGARWAL CREATION FASHIONS PRIVATE LIMITED",
"AGARWAL DENIM PRIVATE LIMITED",
"AGARWAL DET CHEM PRIVATE LIMITED",
"AGARWAL DIAM EXPO PRIVATE LIMITED",
"AGARWAL DREAM BUILDERS PRIVATE LIMITED",
"AGARWAL DRUG DISTRIBUTORS PRIVATE LIMITED",
"AGARWAL DUPLEX BOARD MILLS LTD.",
"AGARWAL ELECTRICAL AND INFRASTRUCTURE PRIVATE LIMITED",
"AGARWAL ELECTROPOWER PRIVATE LIMITED",
"AGARWAL EYE CARE HOSPITAL PRIVATE LIMITED",
"AGARWAL EYE INSTITUTE",
"AGARWAL FABRICS PRIVATE LIMITED",
"AGARWAL FASTNERS PVT LTD",
"AGARWAL FERRO (INDIA) PRIVATE LIMITED",
"AGARWAL FERRO-METALLIC PRIVATE LIMITED",
"AGARWAL FINESTATE PRIVATE LIMITED",
"AGARWAL FLOAT GLASS INDIA LIMITED",
"AGARWAL FOOTWEAR COMPANY PRIVATE LIMITED",
"AGARWAL FORTUNE INDIA LIMITED",
"AGARWAL FUEL CORPORATION PRIVATE LIMITED",
"AGARWAL GENERAL ENGINEERING WORKS PVT LTD",
"AGARWAL GLOBAL FOUNDATION",
"AGARWAL GLOBAL STEELS LIMITED",
"AGARWAL GREEN ENERGY PRIVATE LIMITED",
"AGARWAL HEALTHCARE SERVICES PRIVATE LIMITED",
"AGARWAL HERBALS & COSMETICS PRIVATE LIMITED",
"AGARWAL HOLDINGS PRIVATE LIMITED",
"AGARWAL HOME SHIFTING PRIVATE LIMITED",
"AGARWAL HOSPITALITY PRIVATE LIMITED",
"AGARWAL INDUCTION FURNACE PRIVATE LIMITED",
"AGARWAL INDUSTRIAL CORPORATION LIMITED",
"AGARWAL INDUSTRIES PRIVATE LIMITED",
"AGARWAL INDUSTRIES PVT LTD",
"AGARWAL INFRATECH LIMITED.",
"AGARWAL JAGDISH CONSTRUCTION COMPANY PRIVATE LIMITED",
"AGARWAL JEWELS & GEMS PRIVATE LIMITED",
"AGARWAL LIFE SCIENCES PRIVATE LIMITED",
"AGARWAL LIFE SOLUTIONS PRIVATE LIMITED",
"AGARWAL LIGHTING CONCEPT PRIVATE LIMITED",
"AGARWAL LOGISTICS PRIVATE LIMITED",
"AGARWAL MARBLES AND INDUSTRIES PRIVATE LIMITED",
"AGARWAL MARBLES INDIA PRIVATE LIMITED",
"AGARWAL MARKETING & SERVICES (ENERGY) PRIVATE LIMITED",
"AGARWAL MEDILIFE DISTRIBUTORS PRIVATE LIMITED",
"AGARWAL MINCHEM LIMITED",
"AGARWAL MINERALS",
"AGARWAL MULTIAGRO INDUSTRIES PRIVATE LIMITED",
"AGARWAL NAMKEEN SWEETS PRIVATE LIMITED",
"AGARWAL P G COLLEGE",
"AGARWAL PACKAGING PRIVATE LIMITED",
"AGARWAL PACKERS AND MOVERS LIMITED",
"AGARWAL PETROCHEM PRIVATE LIMITED",
"AGARWAL PLASTICS PRIVATE LIMITED",
"AGARWAL POLY FOAM PRIVATE LIMITED",
"AGARWAL POLYSACKS LIMITED",
"AGARWAL PRIME HEIGHTS PRIVATE LIMITED",
"AGARWAL PULSES PRIVATE LIMITED",
"AGARWAL READY MIX PRIVATE LIMITED",
"AGARWAL REAL CITY PRIVATE LIMITED",
"AGARWAL RECLAIM AND RUBBER PRODUCTS PRIVATE LIMITED",
"AGARWAL RECYCLING AND MANUFACTURING PRIVATE LIMITED",
"AGARWAL SALES AGENCIES LIMITED",
"AGARWAL SANDS PRIVATE LIMITED",
"AGARWAL SAREE (INDIA) PRIVATE LIMITED",
"AGARWAL SHELTERS PRIVATE LIMITED",
"AGARWAL SHIRTINGS PRIVATE LIMITED",
"AGARWAL SPICES AND FOOD PROCESSORS PRIVATE LIMITED",
"AGARWAL STEEL PRIVATE LIMITED",
"AGARWAL STEEL TRADING PRIVATE LIMITED",
"AGARWAL TECHNOPLAST PRIVATE LIMITED",
"AGARWAL TEX FAB PRIVATE LIMITED",
"AGARWAL TEXCHEM INDUSTRIES PRIVATE LIMITED",
"AGARWAL TEXTILE INDUSTRIES PRIVATE LIMITED",
"AGARWAL TMT INDUSTRIES PRIVATE LIMITED",
"AGARWAL TOUGHENED GLASS INDIA LIMITED",
"AGARWAL TRADE CENTRE PVT LTD",
"AGARWAL TRADEMART PRIVATE LIMITED",
"AGARWAL TRADERS FERTILIZERS PRIVATE LIMITED",
"AGARWAL TRADING COMPANY PRIVATE LIMITED",
"AGARWAL TRAFIN PRIVATE LIMITED",
"AGARWAL TRANSLINK PRIVATE LIMITED",
"AGARWAL TRUCKING PRIVATE LIMITED",
"AGARWAL VIDYALAYA AND JUNIOR COLLEGE",
"AGARWAL WHEELS PRIVATE LIMITED",
"AGARWAL ZIPPER AND SLIDER PRIVATE LIMITED",
"AGARWALA FABTRADE PRIVATE LIMITED",
"AGARWALAUTO SALES PRIVATE LIMITED",
"AGARWALLA PAPERMART PRIVATE LIMITED",
"AGARWALLA TEAK INTERNATIONAL PRIVATE LIMITED ATIPL",
"AGARWALLA TIMBERS PRIVATE LIMITED",
"AGASH NURSING HOME",
"AGASHE STORES PRIVATE LIMITED",
"AGASTHA SOFTWARE PRIVATE LIMITED",
"AGASTHIYAA GRANITE PRIVATE LIMITED",
"AGASTHYA EDTECH PRIVATE LIMITED",
"AGASTHYA NATURALS PRIVATE LIMITED",
"AGASTI BHARATVARSH PRIVATE LIMITED",
"AGASTYA ACADEMY",
"AGASTYA AEROWORKS PRIVATE LIMITED",
"AGASTYA AGRO LIMITED",
"AGASTYA DREAMS TECHNOLOGY PRIVATE LIMITED",
"AGASTYA INTERNATIONAL FOUNDATION",
"AGASTYA SYNCOTEX PRIVATE LIMITED",
"AGASTYA TECHASYST INDIA PRIVATE LIMITED",
"AGATE BUSINESS SERVICE PRIVATE.LIMITED",
"AGATE CRANES & HOIST PRIVATE LIMITED",
"AGATI CLINICAL INFORMATICS LLP",
"AGATI HEALTHCARE PRIVATE LIMITED",
"AGATOS CONTROL & SOLUTIONS PRIVATE LIMITED",
"AGAVE INDUSTRIES INDIA PRIVATE LIMITED",
"AGB OLEOCHEM PRIVATE LIMITED",
"AGC CHEMICALS PRIVATE LIMITED",
"AGC INFOTECH PRIVATE LIMITED",
"AGC REALTY PRIVATE LIMITED",
"AGCO TRADING (INDIA) PRIVATE LIMITED",
"AGD BIOMEDICALS PRIVATE LIMITED",
"AGE E/M CME KHADKI",
"AGE HOME APPLIANCES INDIA PRIVATE LIMITED",
"AGE HOSPITALITIES PRIVATE LIMITED",
"AGE INDUSTRIES PRIVATE LIMITED",
"AGE RCC ENERGY PRIVATE LIMITED",
"AGEAS FEDERAL LIFE INSURANCECOMPANY LIMITED",
"AGECO INDIA PRIVATE LIMITED",
"AGEIS HOME HEALTH CARE PRIVATE LIMITED",
"AGELESS CAPITAL AND FINANCE PRIVATE LIMITED",
"AGELESS CLINIC PRIVATE LIMITED",
"AGELN SURGICAL AND HEALTHCARE PRIVATE LIMITED",
"AGEM SOUTH INDIA PRIVATE LIMITED",
"AGENA INTERNATIONAL PRIVATE LIMITED",
"AGENCE FRANCAISE DE DEVELOPPEMENT",
"AGENCIA REAL TRADING AND MARKETING PRIVATE LIMITED",
"AGENCIA ULTRAMARINA PRIVATE LIMITED",
"AGENCIES AND CARGO CARE LIMITED",
"AGENCY HOUSE (A&N ISLANDS) PRIVATE LIMITED",
"AGENCY REAL MAPUSA PVT LTD",
"AGENCY REAL PONDA PVT LTD",
"AGENIC FOODS AND PRODUCTS INDIA PRIVATE LIMITED",
"AGENTDESKS TECH PRIVATE LIMITED",
"AGEON COMMODITIES PRIVATE LIMITED",
"AGEP INDIA PRIVATE LIMITED",
"AGEW STEEL MANUFACTURERS PRIVATE LIMITED",
"AGEY ENGINEERS AND CONTRACTORS PRIVATE LIMITED",
"AGF LOGISTICS PRIVATE LIMITED",
"AGF ORGANICS PRIVATE LIMITED",
"AGF TECNIK INDIA PRIVATE LIMITED",
"AGFA HEALTHCARE INDIA PRIVATE.LIMITED",
"AGFERM INNOVATIONS PRIVATE LIMITED",
"AGFR FINANCIALS RESEARCH PRIVATE LIMITED",
"AGG TRADE PRIVATE LIMITED",
"AGGAR SECURITY SERVICES (INDIA) PRIVATE LIMITED",
"AGGARSAIN AGROPEST PRIVATE LIMITED",
"AGGARSAIN FIBERS LIMITED",
"AGGARSAIN FIBRES PRIVATE LIMITED",
"AGGARSAIN POLYMER PRIVATE LIMITED",
"AGGARSAIN SPINNERS LIMITED",
"AGGARSAIN WOOLTEX PVT.LTD.",
"AGGARWAL AND MODI ENTERPRISES CINEMA PROJECT PRIVATE LIMITED",
"AGGARWAL ART AND PATTERN PRIVATE LIMITED",
"AGGARWAL AUTOMOTIVE PRIVATE LIMITED",
"AGGARWAL BATH CONCEPTS PRIVATE LIMITED",
"AGGARWAL BATH GALLERY PRIVATE LIMITED",
"AGGARWAL BIKANERI SWEETS PRIVATE LIMITED",
"AGGARWAL BIOTECH PRIVATE LIMITED",
"AGGARWAL BROTHERS PRIVATE LTD.",
"AGGARWAL BUILDING DEVELOPERS PRIVATE LIMITED",
"AGGARWAL CASH AND CARRY PRIVATE LIMITED",
"AGGARWAL CHEM TECH PRIVATE LIMITED",
"AGGARWAL CHEMPACK ENTERPRISES PRIVATE LIMITED",
"AGGARWAL COATED FAB PRIVATE LIMITED",
"AGGARWAL COMPUTRONIX PRIVATE LIMITED",
"AGGARWAL CONCAST PRIVATE LIMITED",
"AGGARWAL CORRUGATORS INDIA PRIVATE LIMITED",
"AGGARWAL CORRUKRAFTS PRIVATE LIMITED",
"AGGARWAL DRESS MATERIALS PRIVATE LIMITED",
"AGGARWAL ENTERTAINMENT PRIVATE LIMITED",
"AGGARWAL FERROUSCAST PRIVATE LIMITED",
"AGGARWAL FIBRES PRIVATE LIMITED",
"AGGARWAL HAMMER WORKS PRIVATE LIMITED",
"AGGARWAL HOSPITAL & RESEARCH SERVICS PRIVATE LIMITED",
"AGGARWAL HOTELS PRIVATE LIMITED",
"AGGARWAL INDUSTRIAL BUILDERS PRIVATE LIMITED",
"AGGARWAL INFRACON EQUIPMENTS PRIVATE LIMITED",
"AGGARWAL KITCHENWARES PRIVATE LIMITED",
"AGGARWAL LAMINATES PRIVATE LIMITED",
"AGGARWAL MARBLE & STONES PRIVATE LIMITED",
"AGGARWAL MARKETERS (INDIA) PRIVATE LIMITED",
"AGGARWAL MEDICAL STORE PRIVATE LIMITED",
"AGGARWAL METCAST PRIVATE LIMITED",
"AGGARWAL MOTORS CARRIER PRIVATE LIMITED",
"AGGARWAL PACKERS AND LOGISTIC PRIVATE LIMITED",
"AGGARWAL PLAZA PRIVATE LIMITED",
"AGGARWAL PLYWOOOD",
"AGGARWAL STEEL INDUSTRIES PRIVATE LIMITED",
"AGGARWAL SUPERMART PRIVATE LIMITED",
"AGGARWAL TOOLS AND FABRICATORS PRIVATE LIMITED",
"AGGARWAL TOWERS PRIVATE LIMITED",
"AGGARWAL YARNS AND FABRICS PVT LTD",
"AGGARWAL ZARDA FACTORY PRIVATE LIMITED",
"AGGASSO INDIA PRIVATE LIMITED",
"AGGCON EQUIPMENTS INTERNATIONAL PRIVATE LIMITED",
"AGGNE GLOBAL IT SERVICES PRIVATE LIMITED",
"AGGRA TECHNOLOGIES PRIVATE LIMITED",
"AGGRAWAL SHOPPING MALL PRIVATE LIMITED",
"AGGREEN TECH PRIVATE LIMITED",
"AGGREGATE AGRICULTURAL MULTITRADELINK PRIVATE LIMITED",
"AGGREKO ENERGY RENTAL INDIA PRIVATE LIMITED",
"AGGREPAY PAYMENTS SOLUTIONS PRIVATE LIMITED",
"AGGRESAR LEASING AND FINANCE PVT LTD",
"AGGRESSIVE ELECTRONICS MANUFACTURING SERVICES PRIVATE LIMITED",
"AG-GROW PRODUCTS LIMITED",
"AGH CONSTRUCTIONS PRIVATE LIMITED",
"AGH ISOLUTECH PRIVATE LIMITED",
"AGHARA KNITWEAR PRIVATE LIMITED",
"AGHARKAR RESEARCH INSTITUTE",
"AGHIN AGRO FOOD INDUSTRIES PRIVATE LIMITED",
"AGHNE ELECTRIKAL VEHICLES INDIA PRIVATE LIMITED",
"AGHRENI TECHNOLOGIES PRIVATE LIMITED",
"AGI GLASSPACK LIMITED",
"AGI GREENPAC LIMITED",
"AGI HOSPITALITIES PRIVATE LIMITED",
"AGI INFRA LIMITED",
"AGIAS ENGINEERING PRIVATE LIMITED",
"AGICENT TECHNOLOGIES PRIVATE LIMITED",
"AGILE AIRPORT SERVICES PRIVATE LIMITED",
"AGILE BRANDS PRIVATE LIMITED",
"AGILE BROADBAND PRIVATE LIMITED",
"AGILE BUSINESS INTELLIGENCE SERVICES PRIVATE LIMITED",
"AGILE COCKPIT SOFTWARE DEVELOPMENT PRIVATE LIMITED",
"AGILE COMPUTER SOFTWARE DEVELOPMENT & SOLUTIONS INDIA PRIVATE LIMITED",
"AGILE CONNECTS PRIVATE LIMITED",
"AGILE CONSULTING PRIVATE LIMITED",
"AGILE DATA SOLUTIONS PRIVATE LIMITED",
"AGILE ELECTRIC SUB ASSEMBLY PRIVATE LIMITED",
"AGILE ENGINEERING AND PACKAGING PRIVATE LIMITED",
"AGILE FINANCIAL TECHNOLOGIES PRIVATE LIMITED",
"AGILE FINSERV PRIVATE LIMITED",
"AGILE HOSPITALS PVT LTD",
"AGILE INFOWAYS PRIVATE LIMITED",
"AGILE LABS PRIVATE LIMITED",
"AGILE LIFESCIENCE TECHNOLOGIES INDIA PRIVATE LIMITED",
"AGILE LOGISTICS PRIVATE LIMITED",
"AGILE MACHINERIES PRIVATE LIMITED",
"AGILE MANUFACTURING SERVICES PRIVATE LIMITED",
"AGILE MICROSYS PRIVATE LIMITED",
"AGILE MINING PRIVATE LIMITED",
"AGILE PARKING SOLUTIONS PRIVATE LIMITED",
"AGILE PMC PRIVATE LIMITED",
"AGILE REAL ESTATE PRIVATE LIMITED",
"AGILE SECURITY FORCE & SYSTEMS PRIVATE LIMITED",
"AGILE SECURITY FORCE PRIVATE LIMITED",
"AGILE SOFT SYSTEMS INDIA PRIVATE LIMITED",
"AGILE TRADELINKS PRIVATE LIMITED",
"AGILE VENTURES PRIVATE LIMITED",
"AGILEAXIS PRIVATE LIMITED",
"AGILEDEV PRIVATE LIMITED",
"AGILEDGE PROCESS SOLUTIONS P LIMITED",
"AGILEINTELLI NETWORK INDIA PRIVATE LIMITED",
"AGILEMANIA TECHNOLOGIES PRIVATE LIMITED",
"AGILEMATE INNOVATION SERVICES PRIVATE LIMITED",
"AGILENT TECHNOLOGIES INDIA PRIVATE LIMITED",
"AGILENT TECHNOLOGIES INTERNATIONAL PRIVATE LIMITED",
"AGILEPOINT SOFTWARE INDIA PRIVATE LIMITED",
"AGILETECH INFO SOLUTIONS PRIVATE LIMITED",
"AGILETS PRIVATE LIMITED",
"AGILIAD TECHNOLOGIES PRIVATE LIMITED",
"AGILIANCE INDIA PRIVATE LIMITED",
"AGILIFI TECHNOLOGIES LLP",
"AGILINE SOFTWARE PRIVATE LIMITED",
"AGILIQ INFO SOLUTIONS INDIA PRIVATE LIMITED",
"AGILIS HEALTHCARE PRIVATE LIMITED",
"AGILIS MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"AGILISH TELECOM PRIVATE LIMITED",
"AGILISIUM CONSULTING INDIA PRIVATE LIMITED",
"AGILISYS IT SERVICES INDIA PRIVATE LIMITED",
"AGILITE GROUP TECHNOLOGIES PRIVATE LIMITED",
"AGILITICS EDUTECH PRIVATE LIMITED",
"AGILITY E SERVICES PRIVATE LIMITED",
"AGILITY ELEKTROTEKNIKS PRIVATE LIMITED",
"AGILITY- GIL SHARED SERVICES PRIVATE LIMITED",
"AGILIZTECH SOFTWARE SERVICES PRIVATE LIMITED",
"AGILLERE INFOTECH INDIA PRIVATE LIMITED",
"AGILO RESEARCH PRIVATE LIMITED",
"AGILON HEALTH INDIA PRIVATE LIMITED",
"AGILUS DIAGNOSTICS LIMITED",
"AGILUS PATHLABS PRIVATE LIMITED",
"AGILYSYS TECHNOLOGIES INDIA PRIVATE LIMITED",
"AGINOVA TECHNOLOGIES PRIVATE LIMITED",
"AGIO PHARMACEUTICALS LIMITED",
"AGIO STOCKS AND SHARES PRIVATE LIMITED",
"AGION LABORATORIES PRIVATE LIMITED",
"AGIRA GPMV SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"AGISTIN BIOTECH PRIVATE LIMITED",
"AGK FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"AGK INFRA SYSTEMS PRIVATE LIMITED",
"AGKEM IMPEX PRIVATE LIMITED",
"AGKG CONSTRUCTION PRIVATE LIMITED",
"AGKON SOFTWARE PRIVATE LIMITED",
"AGL GLASS PRIVATE LIMITED",
"AGL POLYFIL PRIVATE LIMITED",
"AGL WAREHOUSING PRIVATE LIMITED",
"AGLAYA PRIVATE LIMITED",
"AGLO PACKAGINGS PRIVATE LIMITED",
"AGLO POLYMERS PRIVATE LIMITED",
"AGLOBIS TRADES PRIVATE LIMITED",
"AGLON IMPEX PRIVATE LIMITED",
"AGLON INDUSTRIES PRIVATE LIMITED",
"AGLOW CHEMICALS PRIVATE LIMITED",
"AGLOW ENGINEERS PRIVATE LIMITED",
"AGLOW FINANCIAL SERVICES PRIVATE LIMITED",
"AGLOW HOSPITALITY SERVICES PRIVATE LIMITED",
"AGLOW INDUSTRIES PRIVATE LIMITED",
"AGLOWMED LIMITED",
"AGM BIOTECH PRIVATE LIMITED",
"AGM GRAND HOTELS PRIVATE LIMITED",
"AGM INDIA ADVISORS PRIVATE LIMITED",
"AGM INFRA SOLUTIONS PRIVATE LIMITED",
"AGM MANAGEMENT SERVICES LIMITED",
"AGM TEXTILES PRIVATE LIMITED",
"AGMA ENERGY PRIVATE LIMITED",
"AGMA PACKAGING PRIVATE LIMITED",
"AGMA POLYMERS PRIVATE LIMITED",
"AGMACO INDUSTRIES PRIVATE LIMITED",
"AGMATEL INDIA PRIVATE LIMITED",
"AGMECO FAUCETS PRIVATE LIMITED",
"AGMEHRA PRIVATE LIMITED",
"AGMELCO TECHNO SERVICES PRIVATE LIMITED",
"AGMORE INDUSTRIES PRIVATE LIMITED",
"AGMOTEX FABRICS PRIVATE LIMITED",
"AGN LOGISTICS & SOLUTIONS PRIVATE LIMITED",
"AGN SOLUTIONS PRIVATE LIMITED",
"AGNA ORG AGROVILLA (INDIA) PRIVATE LIMITED",
"AGNEE TRANSMISSIONS (INDIA) PRIVATE LIMITED",
"AGNEL CHARITIES",
"AGNEL DEVELOPERS LLP",
"AGNES MANAGEMENT CONSULTANCY PRIVATE LIMITED",
"AGNETA CHEMICALS INDIA PRIVATE LIMITED",
"AGNEY POLYSOFT INDIA PRIVATE LIMITED",
"AGNI COLLEGE OF TECHNOLOGY",
"AGNI DAIRY INDUSTRY PRIVATE LIMITED",
"AGNI DEVICES PRIVATE LIMITED",
"AGNI ESTATES AND FOUNDATIONS PRIVATE LIMITED",
"AGNI FIBER BOARDS PRIVATE LIMITED",
"AGNI GAS TECHNOLOGIES PRIVATE LIMITED",
"AGNI GREEN POWER LIMITED",
"AGNI HI-TECH REFRACTORIES PRIVATE LIMITED",
"AGNI INDUSTRIAL FIRE SERVICES LIMITED",
"AGNI INSTRUMENTS ENGINEERS (INDIA) PRIVATE LIMITED",
"AGNI INSULATIONS PRIVATE LIMITED",
"AGNI JEWELS PRIVATE LIMITED",
"AGNI LIMITED",
"AGNI MHE PRIVATE LIMITED",
"AGNI PEN & PLASTIC PVT LTD",
"AGNI RAKSHAK PRIVATE LIMITED",
"AGNI SAFETY (INDIA) PRIVATE LIMITED",
"AGNI SHANTI BUILDTECH PRIVATE LIMITED",
"AGNI SOFTWARE PRIVATE LIMITED",
"AGNI STEELS PRIVATE LIMITED",
"AGNI SURYA ENERGY PRIVATE LIMITED",
"AGNI TOUR AND TRAVELS PRIVATE LIMITED",
"AGNIBINA FOODS PRIVATE LIMITED",
"AGNICE FIRE PROTECTION PRIVATE LIMITED",
"AGNIE CONSULTING INDIA PRIVATE LIMITED",
"AGNIFORMA PRIVATE LIMITED",
"AGNIGARBHA PRIVATE LIMITED",
"AGNIJA TIE-UP PRIVATE LIMITED",
"AGNIS BULLION HOUSE LLP",
"AGNISHARMAN LOGISTICS PRIVATE LIMITED",
"AGNISUMUKH ENERGY SOLUTIONS PRIVATE LIMITED",
"AGNISYS TECHNOLOGY PRIVATE LIMITED",
"AGNITH TECHNOLOGIES PRIVATE LIMITED",
"AGNITIO SOLUTIONS PRIVATE LIMITED",
"AGNITY COMMUNICATIONS PRIVATE LIMITED",
"AGNIVESH HEALTH CARE CENTRE PRIVATE LIMITED",
"AGNIWA COMMERCIAL TRADE PRIVATE LIMITED",
"AGNORMS HOSPITALS PRIVATE LIMITED",
"AGNOSHIN TECHNOLOGIES PRIVATE LIMITED",
"AGNOSTIC SOLUTIONS PRIVATE LIMITED",
"AGNUS HOLDINGS PRIVATE LIMITED",
"AGOC CARE PRIVATE LIMITED",
"AGOCONS AGROTECH INDUSTRIES PRIVATE LIMITED",
"AGODA INTERNATIONAL INDIA PRIVATE LIMITED",
"AGOG PHARMA LIMITED.",
"AGOG POWER PROJECTS PRIVATE LIMITED",
"AGOG SECURITIES BROKERAGES PRIVATE LIMITED",
"AGOL WORLDWIDE INDIA PRIVATE LIMITED",
"AGON PHARMA PRIVATE LIMITED",
"AGOND LIFESCIENCES PRIVATE LIMITED",
"AGONY CARE PHARMACEUTICAL PRIVATE LIMITED",
"AGORA IMPERIUM INDIA PRIVATE LIMITED",
"AGORA MARKETING PRIVATE LIMITED",
"AGORA MICROFINANCE INDIA LIMITED",
"AGORAA SMART SOLUTIONS PRIVATE LIMITED",
"AGOS AVIATION SERVICES PRIVATE LIMITED",
"AGOX CERA PRIVATE LIMITED",
"AGP CGD INDIA PRIVATE LIMITED",
"AGP MINECHEM PRIVATE LIMITED",
"AGP OILS PRIVATE LIMITED",
"AGP PUBLIC SCHOOL",
"AGP YARN PRIVATE LIMITED",
"AGPAYTECH INDIA PRIVATE LIMITED",
"AGPM ENTERPRISES PRIVATE LIMITED",
"AGPO MANAGEMENT SERVICES PRIVATE LIMITED",
"AGR AUTOMOBILES PRIVATE LIMITED",
"AGR CONCEPT PRIVATE LIMITED",
"AGR GLOBAL SCHOOL",
"AGR KNOWLEDGE SERVICES PRIVATE LIMITED",
"AGR LOGISTICS PRIVATE LIMITED",
"AGR PETRO VENTURES PRIVATE LIMITED",
"AGRA BARTAN BHANDAR PRIVATE LTD",
"AGRA CASTINGS PRIVATE LIMITED",
"AGRA CHAIN FOUNDATION",
"AGRA CHAINS PRIVATE LIMITED",
"AGRA CHEMICALS PRIVATE LIMITED",
"AGRA COLLEGE AGRA",
"AGRA COLOR LAB PRIVATE LIMITED",
"AGRA DISTRICT COOPERATIVE BANK LTD",
"AGRA GWALIOR PATHWAYS PRIVATE LIMITED",
"AGRA INFRALAND DEVELOPERS PRIVATE LIMITED",
"AGRA INFRAPLANNERS PRIVATE LIMITED",
"AGRA MACHINE TOOLS PRIVATE LIMITED",
"AGRA OIL & GENERAL INDUSTRIES LIMITED",
"AGRA PRODUCTS PRIVATE LIMITED",
"AGRA PUBLIC INSTITUTE OF TECH AND COMPUTER EDUCATION",
"AGRA SMART CITY LIMITED",
"AGRA TRADELINK PRIVATE LIMITED",
"AGRADOOT PUBLISHERS PVT LTD",
"AGRAGAMI PRE UNIVERSITY COLLEGE",
"AGRAGAMI RICE INDUSTRIES PRIVATE LIMITED",
"AGRAHAN ENGINEERS PRIVATE LIMITED",
"AGRAHARI BUILDERS PRIVATE LIMITED",
"AGRAHARI HEALTH CARE AND RESEARCH CENTRE PRIVATE LIMITED",
"AGRAJ INFRASTRUCTURE PRIVATE LIMITED",
"AGRAL POLYSACK PRIVATE LIMITED",
"AGRALOGICS FARMERS PRODUCER COMPANY LIMITED",
"AGRANA FRUIT INDIA PRIVATE LIMITED",
"AGRANEE SOLUTIONS PRIVATE LIMITED",
"AGRANEEH TECHNOLOGIES P L",
"AGRANI FOODS AND AGRO CORPORATION PRIVATE LIMITED",
"AGRANI ICE AND COLD STORAGE PVT LTD",
"AGRANI MILK & MILK PROCESSORS PRIVATE LIMITED",
"AGRANTE DEVELOPERS PRIVATE LIMITED",
"AGRANTE REALTY LIMITED",
"AGRANTIS CORPORATION PRIVATE LIMITED",
"AGRARIAN CROP SOLUTIONS PRIVATE LIMITED",
"AGRAS KHARA PRIVATE LIMITED",
"AGRA'S RESIDENCY PRIVATE LIMITED",
"AGRASAIN BALIKA SIKHA SADAN",
"AGRASEN AGRO FOOD PRODUCTS PRIVATE LIMITED",
"AGRASEN AGRO MECHANICAL PRIVATE LIMITED",
"AGRASEN CARS PRIVATE LIMITED",
"AGRASEN COTTON INDUSTRIES PRIVATE LIMITED",
"AGRASEN ENGINEERING INDUSTRIES PRIVATE LIMITED",
"AGRASEN FOUNDRY PRIVATE LIMITED",
"AGRASEN INFRABUILD PRIVATE LIMITED",
"AGRASEN INTER COLLEGE HARDUAGANJ COLLEGES IN ALIGARH",
"AGRASEN IRON AND STEELS PRIVATE LIMITED",
"AGRASEN ISPAT PRIVATE LIMITED",
"AGRASEN REALTORS & DEVELOPERS PRIVATE LIMITED",
"AGRASEN SHIPBREAKERS PRIVATE LIMITED",
"AGRASEN SPONGE PRIVATE LIMITED",
"AGRASEN SUPPLIERS PRIVATE LIMITED",
"AGRASEN TRADERS PRIVATE LIMITED",
"AGRASENPRIME OVERSEAS PRIVATE LIMITED",
"AGRASHA ALLOYS AND METALS PRIVATE LIMITED",
"AGRASIA IMPEX",
"AGRAVANSHI INDIA PRIVATE LIMITED",
"AGRAVANSHI PRIVATE LIMITED",
"AGRAVANSHI STEELLS PRIVATE LIMITED",
"AGRAWAL ACCURATE PRINTECH PRIVATE LIMITED",
"AGRAWAL AGROVET PRIVATE LIMITED",
"AGRAWAL BANDHU AGROTECH PRIVATE LIMITED",
"AGRAWAL CABCON PRIVATE LIMITED",
"AGRAWAL CHANNEL MILLS PRIVATE. LIMITED",
"AGRAWAL CONTRACTS PRIVATE LIMITED",
"AGRAWAL COTSPIN PRIVATE LIMITED",
"AGRAWAL DALL MILLS",
"AGRAWAL DEPARTMENTAL STORES INDIA PRIVATE LIMITED",
"AGRAWAL DIAGNOSTIC CENTRE",
"AGRAWAL DISTILLERIES PRIVATE LIMITED",
"AGRAWAL DRIP IRRIGATION PRIVATE LIMITED",
"AGRAWAL DRUGS AND CHEMICALS PVT LTD",
"AGRAWAL ELECTRONICS AND MOBILE",
"AGRAWAL ESTATE ORGANISERS LIMITED",
"AGRAWAL FINANCE & CONSTRUCTION PRIVATE LIMITED",
"AGRAWAL GINNING & PRESSING PRIVATE LIMITED",
"AGRAWAL GLOBAL INFRATECH PRIVATE LIMITED",
"AGRAWAL GRAPHITE & CARBON PRODUCTS PRIVATE LIMITED",
"AGRAWAL GRAVURE PRIVATE LIMITED",
"AGRAWAL GUM MANUFACTURING COMPANY PRIVATE LIMITED",
"AGRAWAL HOSPITALITY PRIVATE LIMITED",
"AGRAWAL INFRABUILD PRIVATE. LIMITED.",
"AGRAWAL LIFE CARE PRIVATE LIMITED",
"AGRAWAL METAL WORKS PRIVATE LIMITED",
"AGRAWAL MINERALS (GOA) PRIVATE LIMITED",
"AGRAWAL OIL AND GENERAL INDUSTRIES",
"AGRAWAL OIL PRODUCTS PRIVATE LIMITED",
"AGRAWAL OPTICALS PRIVATE LIMITED",
"AGRAWAL PAPAD PRIVATE LIMITED",
"AGRAWAL PIPE AND CERAMICS PRIVATE LIMITED",
"AGRAWAL PLASTOWARE INDUSTRIES PRIVATE LIMITED",
"AGRAWAL PLYWOOD AND HARDWARE PRIVATE LIMITED",
"AGRAWAL POLY PLAST PRIVATE LIMITED",
"AGRAWAL POWER PRIVATE LIMITED",
"AGRAWAL RENEWABLE ENERGY PRIVATE LIMITED",
"AGRAWAL RIDERS PRIVATE LIMITED",
"AGRAWAL ROADLINES PRIVATE LIMITED",
"AGRAWAL ROUND ROLLING MILLS LIMITED",
"AGRAWAL S S TRADING COMPANY PRIVATE LIMITED",
"AGRAWAL SOLAR POWER (UP) PRIVATE LIMITED",
"AGRAWAL SOLAR POWER VENTURES (RAJASTHAN) PRIVATE LIMITED",
"AGRAWAL SOYA EXTRACTS PRIVATE LIMITED",
"AGRAWAL SPONGE PRIVATE LIMITED",
"AGRAWAL STRUCTURE MILLS PRIVATE LIMITED ASMPL",
"AGRAWAL TRADERS",
"AGRAWAL WAREHOUSING & LOGISTICS",
"AGRAWALA FINSERVE PRIVATE LIMITED",
"AGRAY INFOSOLUTIONS PRIVATE LIMITED",
"AGRAZA SEEDS AND BIOTECH PRIVATE LIMITED",
"AGRE STRATEGIES PRIVATE LIMITED",
"AGREED TECHNOLOGIES PRIVATE LIMITED",
"AGREETA SOLUTIONS PRIVATE LIMITED",
"AGREEYA MOBILITY INDIA PRIVATE LIMITED",
"AGREEYA SOLUTIONS INDIA PRIVATE LIMITED",
"AGR-EH TECHNOLOGIES PRIVATE LIMITED",
"AGRELLA CROPSCIENCES PRIVATE LIMITED",
"AGRESOURCE MANAGEMENT PRIVATE LIMITED",
"AGRESTAL ORGANIC LIVING INDIA PRIVATE LIMITED",
"AGREYA CAPITAL ADVISORS LLP",
"AGRI ENGINEER SATNA",
"AGRI ENTREPRENEUR GROWTH FOUNDATION",
"AGRI FINANCIAL CONTROL SERVICES PRIVATE LIMITED",
"AGRI GOLD FARM ESTATES INDIA PRIVATE LIMITED",
"AGRI IMPORT & EXPORT LIMITED",
"AGRI LINK FOOD PROCESSING PRIVATE LIMITED",
"AGRI PROCESS INNOVATIONS TECHNOLOGIES LLP",
"AGRI SEARCH (INDIA) PRIVATE LIMITED",
"AGRIABLE IMPEX PRIVATE LIMITED",
"AGRIAPP TECHNOLOGIES PRIVATE LIMITED",
"AGRIBATOR TECHNOLOGIES PRIVATE LIMITED",
"AGRIBEE SEEDS PRIVATE LIMITED",
"AGRIBEGRI TRADELINK PRIVATE LIMITED",
"AGRIBIOTECH INDUSTRIES LIMITED",
"AGRIBIZ INDIA AGRO COMMODITIES PRIVATE LIMITED",
"AGRIBOARD INDUSTRIES LLP",
"AGRIBOOK TECH SOLUTIONS AND ALLIED SERVICES PRIVATE LIMITED",
"AGRIBUND PRIVATE LIMITED",
"AGRICARE BIOTECH PRIVATE LIMITED",
"AGRICHEM LIFE SCIENCE PRIVATE LIMITED",
"AGRICHOICE FOOD PRODUCTS PRIVATE LIMITED",
"AGRICO ORGANICS LIMITED",
"AGRICOLES NATUREL FOODS PRIVATE LIMITED",
"AGRICOM AGRI INPUTS PRIVATE LIMITED",
"AGRICOM FOODS PRIVATE LIMITED",
"AGRICOM SERVICES PRIVATE LIMITED",
"AGRICORP EXIM PRIVATE LIMITED",
"AGRICRYSTL OIL PRODUCER COMPANY LIMITED",
"AGRICULTLURE DEPARTMENT PANCHYAT SAMITI INDAPUR",
"AGRICULTLURE DIRECTORATE UP LUCKNOW",
"AGRICULTURAL DEVELOPMENT COMM.CREDITANDINDUSTRIAL INVESTMENT P.LTD.",
"AGRICULTURAL DISCS (INDIA) LIMITED",
"AGRICULTURAL FINANCE CORPORATION",
"AGRICULTURAL TECHNOLOGY MANAGEMENT AGENCY BATHINDA",
"AGRICULTURE AND FARMER WELFARE DEPARTMENT/ HORTICULTURE",
"AGRICULTURE COLLEGE",
"AGRICULTURE DEPARTMENT",
"AGRICULTURE DEPARTMENT GOVT OF WEST BENGAL",
"AGRICULTURE DIRECTORATE UP LKO",
"AGRICULTURE INSURANCE COMPANY OF IN",
"AGRICULTURE OFFICE OF ASCO NWS",
"AGRICULTURE PRODUCE MARKET COMMITTEE NIZAR",
"AGRICULTURE SKILL COUNCIL OF INDIA",
"AGRICULTURE UNIVERSITY - GOVT RAJ",
"AGRIFINE RESOURCES INDIA PRIVATE LIMITED",
"AGRIFLO FOODS PRIVATE LIMITED",
"AGRIFORT TECHNOLOGIES PRIVATE LIMITED",
"AGRIFY ORGANIC SOLUTIONS PRIVATE LIMITED",
"AGRIGENOME LABS PRIVATE LIMITED",
"AGRIGLOW PRIVATE LIMITED",
"AGRIGO TRADING PRIVATE LIMITED",
"AGRIGUARD MANUFACTURING PRIVATE LIMITED",
"AGRIHAWK TECHNOLOGIES PRIVATE LIMITED",
"AGRIHIKE FARMER PRODUCER COMPANY LIMITED",
"AGRILAND BIOTECH LIMITED",
"AGRILEAF EXPORTS PRIVATE LIMITED",
"AGRILIFE TECHNOLOGIES PRIVATE LIMITED",
"AGRILINK ASIA PRIVATE LIMITED",
"AGRIM AGROTECH (OPC) PRIVATE LIMITED",
"AGRIM AVIATION PRIVATE LIMITED",
"AGRIM COMPONENTS PRIVATE LIMITED",
"AGRIM FABRICATION PRIVATE LIMITED",
"AGRIM HOSPITALS PRIVATE LIMITED",
"AGRIM HOUSING FINANCE PRIVATE LIMITED",
"AGRIM JEWEL KRAFT PRIVATE LIMITED",
"AGRIM STONE PRIVTE LIMITED",
"AGRIMA INFOTECH INDIA PRIVATE LIMITED",
"AGRIMA INFRA PROJECTS PRIVATE LIMITED",
"AGRIMECH ENGINEERING PRIVATE LIMITED",
"AGRIMONY COMMODITIES LIMITED",
"AGRIMORE SOLUTIONS PRIVATE LIMITED",
"AGRIMPEX INDIA PRIVATE LIMITED",
"AGRINACK MERCHANDISE PRIVATE LIMITED",
"AGRINEXUS FARM SOLUTIONS PRIVATE LIMITED",
"AGRINNOVATE INDIA LIMITED",
"AGRINOS INDIA PRIVATE LIMITED",
"AGRINOVA BIOCARE PRIVATE LIMITED",
"AGRIPLAST PROTECTED CULTIVATION PRIVATE LIMITED",
"AGRIPRIME INDUSTRIES PRIVATE LIMITED",
"AGRIROUTE FOUNDATION",
"AGRISAM AGRO INDIA PRIVATE LIMITED",
"AGRISAN CHEMICALS PRIVATE LIMITED",
"AGRISEA GLOBAL TRADE PRIVATE LIMITED",
"AGRISENSE LANDSCAPE PRIVATE LIMITED",
"AGRISIA AGRO PRIVATE LIMITED",
"AGRISK DATA ANALYTICS PRIVATE LIMITED",
"AGRISOFT DAIRY AND AGRO PRODUCER COMPANY LIMITED",
"AGRISOLINDIA PRIVATE LIMITED",
"AGRISTO MASA PRIVATE LIMITED",
"AGRISUN COMMODITIES PRIVATE LIMITED.",
"AGRITECH INDUSTRIES PRIVATE LIMITED",
"AGRITOP SEEDS PRIVATE LIMITED",
"AGRITOUCH FARMERS PRODUCER COMPANY LIMITED",
"AGRITRADEX COMMODITIES INDIA PRIVATE LIMITED",
"AGRITY MINERALS PRIVATE LIMITED",
"AGRIUS INDIA PRIVATE LIMITED",
"AGRIVET CHEMICALS PRIVATE LIMITED",
"AGRIVET RESEARCH & ADVISORY PRIVATE LIMITED",
"AGRIWELL PRODUCTS PRIVATE LIMITED",
"AGRI-WIN BHARATH PRODUCER COMPANY LIMITED",
"AGRIWISE FINSERV LIMITED",
"AGRIX AGROTECH PRIVATE LIMITED",
"AGRIYA CASTINGS PRIVATE LIMITED",
"AGRIYAH SAFETY GEAR PRIVATE LIMITED",
"AGRJA PAPERS PRIVATE LIMITED",
"AGRO AUTO GRIND ENGINEERS PRIVATE LIMITED",
"AGRO BIOTECH RESEARCH CENTRE LTD",
"AGRO COOL INDIA LIMITED",
"AGRO ECONOMIC RESEARCH CENTRE",
"AGRO ENERGY ECO EFFICIENT PRIVATE LIMITED",
"AGRO ENGINEERING EQUIPEMENT CO",
"AGRO ENGINEERS PRIVATE LIMITED",
"AGRO EXTRACTS LIMITED",
"AGRO FOOD INDUSTRIES",
"AGRO HARDWARE INDUSTRIES PRIVATE LIMITED",
"AGRO HEALTH INDIA PRIVATE LIMITED",
"AGRO INDUS CREDITS LIMITED",
"AGRO INDUSTRIAL COMMODITIES TRADING CO PRIVATE LIMITED",
"AGRO INDUSTRIAL PACKAGING INDIA LIMITED",
"AGRO INDUSTRIES CORPORATION",
"AGRO ISLAND PRIVATE LIMITED",
"AGRO JUNCTION INDIA PRIVATE LIMITED",
"AGRO KING PESTICIDES PRIVATE LIMITED",
"AGRO LEADER PIPES & PRODUCTS PRIVATE. LIMITED.",
"AGRO LIFE SCIENCE CORPORATION",
"AGRO MANURES AND CHEMICALS INDIA PRIVATE LIMITED",
"AGRO MARINE AGGREGATORS PRIVATE LIMITED",
"AGRO MAX AGENCIES PRIVATE LIMITED",
"AGRO NATURE INDIA PRIVATE LIMITED",
"AGRO NUTRIENTS PRIVATE LIMITED",
"AGRO PHOS INDIA LIMITED.",
"AGRO POWER GASIFICATION PLANT PRIVATE LIMITED",
"AGRO PULPING MACHINERY PRIVATE LIMITED",
"AGRO SOLVENT PRODUCTS PVT LTD",
"AGRO SPICE INDIA PRIVATE LIMITED",
"AGRO TECH FOODS LIMITED",
"AGRO WHITE INDUSTRIES OPC PVT LTD",
"AGRO WHITE INDUSTRIES PRIVATE LIMITED",
"AGROBABA PRODUCER COMPANY LIMITED",
"AGROBURG LIMITED",
"AGROCEL INDUSTRIES PRIVATE LIMITED",
"AGROCOMM TRADING COMPANY PRIVATE LIMITED",
"AGROCORP INDIA TRADE SERVICES PRIVATE LIMITED",
"AGROCORP LANDBASE PRIVATE LIMITED",
"AGROCORPEX INDIA LIMITED",
"AGROCROPS INDIA LIMITED",
"AGROCROPS INDIA PRIVATE LIMITED",
"AGROCROPS SPICES PRIVATE LIMITED",
"AGRODAYA PRODUCTS PRIVATE LIMITED",
"AGROES SERVICES PRIVATE LIMITED",
"AGROFAB MACHINERIES (INDIA) PVT LTD",
"AGROFLEET LOGISTICS PRIVATE LIMITED",
"AGROFOOD GRAINS PRIVATE LIMITED",
"AGROH BIAORA TOLLWAYS PRIVATE LIMITED",
"AGROH DIU LINK HIGHWAYS PRIVATE LIMITED",
"AGROH INFRASTRUCTURE DEVELOPERS PRIVATE LIMITED",
"AGROH RATLAM TOLLWAYS PRIVATE LIMITED",
"AGROH REWA RING ROAD PRIVATE LIMITED",
"AGROH TOLL HIGHWAYS PRIVATE LIMITED",
"AGROHA COLOURTEC PRIVATE LIMITED",
"AGROHA ENTERPRISES PRIVATE LIMITED",
"AGROHA MARKETING PVT LTD",
"AGROHA MINES PRIVATE LIMITED",
"AGROHAAT RETAIL PRIVATE LIMITED",
"AGROISIA SEEDS PRIVATE LIMITED",
"AGROISTIC TRADE BLOSSOMS PRIVATE LIMITED",
"AGROLT SOLUTIONS PRIVATE LIMITED",
"AGROMACH ENGINEERING PRIVATE LIMITED",
"AGROMATICA ENGINEERING INDIA PRIVATE LIMITED",
"AGROMATION INDIA PRIVATE LIMITED",
"AGROMECH RETAIL PRIVATE LIMITED",
"AGROMEDHA INDUSTRIES PRIVATE LIMITED",
"AGROMETAL VENDIBLES PRIVATE LIMITED",
"AGROMONK FOODS LLP",
"AGRON LOGISTICS INDIA PRIVATE LIMITED",
"AGRON REMEDIES PRIVATE LIMITED",
"AGRO-NEXT INTERNATIONAL PRIVATE LIMITED",
"AGRONIC FOOD PRIVATE LIMITED",
"AGRONIRMITI EXPORT INNOVATION FARMER PRODUCER COMPANY LIMITED",
"AGRONY NATURAL PRIVATE LIMITED",
"AGROPAC PRIVATE LIMITED",
"AGROPROCESS ENGINEERS PRIVATE LIMITED",
"AGROS IMPEX INDIA PRIVATE LIMITED",
"AGROSQUARE PRIVATE LIMITED",
"AGROSURG IRRADIATORS (INDIA)) PRIVATE LIMITED",
"AGROSYNTH CHEMICALS LIMITED",
"AGROTECH AGRO PRODUCER COMPANY LIMITED",
"AGROTEXT COMMODITIES PRIVATE LIMITED",
"AGROVATIKA PRODUCTS PRIVATE LIMITED",
"AGROVISION FOOD TECHNOLOGIES PRIVATE LIMITED",
"AGROVISION GREEN ENERGY PRIVATE LIMITED",
"A-GROW AGRICULTURES PRIVATE LIMITED",
"AGROW ALLIED VENTURES PRIVATE LIMITED",
"AGROWIN AGRI SOLUTION PRIVATE LIMITED",
"AGROWIN GREEN CLEAN SOLUTION PRIVATE LIMITED",
"AGROWNATION INDIA VENTURES PRIVATE LIMITED",
"AGROXY CROPS SOLUTIONS PRIVATE LIMITED",
"AGROY COMMODITIES PRIVATE LIMITED.",
"AGROY FINANCE AND INVESTMENT LIMITED",
"AGRU PLASTIC TECHNOLOGY PRIVATE LIMITED",
"AGRUD PARTNERS",
"AGRUD TECHNOLOGIES INDIA PRIVATE LIMITED",
"AGRUM FOODS INDIA PRIVATE LIMITED",
"AGRYA CONSULTING PRIVATE LIMITED",
"AGRYUJ ITSERV PRIVATE LIMITED",
"AGS CINEMAS PRIVATE LIMITED",
"AGS ENTERTAINMENT PRIVATE LIMITED",
"AGS FOODS INDIA PRIVATE LIMITED",
"AGS FOUR WINDS INDIA PRIVATE LIMITED",
"AGS GEOPHYSICAL SERVICES INDIA PRIVATE LIMITED",
"AGS HEALTH PRIVATE LIMITED",
"AGS INDUSTRIES ENGINEERING PRIVATE LIMITED",
"AGS INFRAPROJECTS PRIVATE LIMITED",
"AGS RETAILS (INDIA) LIMITED",
"AGS STRUCTURAL DETAILING PRIVATE LIMITED",
"AGS TECH EXIM PRIVATE LIMITED",
"AGS TECHNOLOGIES INDIA PRIVATE LIMITED",
"AGS TRANSACT TECHNOLOGIES LIMITED",
"AGS VISIONS PRIVATE LIMITED",
"AGSA SPRINGS PRIVATE LIMITED",
"AGSAR PAINTS PRIVATE LIMITED",
"AGSK SOLUTION",
"AGSOM ENTERPRISES PRIVATE LIMITED",
"AGSON GLOBAL PRIVATE LIMITED",
"AGSON INDUSTRIES PRIVATE LIMITED",
"AGSONS AGENCIES (INDIA) PRIVATE LTD",
"AGSS ANALYTICAL AND RESEARCH LAB PRIVATE LIMITED",
"AGSTACK TECHNOLOGIES PRIVATE LIMITED",
"AGSUITE TECHNOLOGIES PRIVATE LIMITED",
"AGT CLEARING & FORWARDING PRIVATE LIMITED",
"AGT FOODS INDIA PRIVATE LIMITED",
"AGTECHPRO PRIVATE LIMITED",
"AGTRS IDART PRIVATE LIMITED",
"AGUA CORE PUMPEN LIMITED",
"AGUA TECHNIQUE PRIVATE LIMITED",
"AGUA WIRELESS SYSTEMS PRIVATE LIMITED",
"AGUACLAN WATER PURIFIERS PRIVATE LIMITED",
"AGUAPURO EQUIPMENTS PRIVATE LIMITED",
"AGUERRI INDUSTRIES P LIMITED",
"AGUR HEALTH DEVELOPERS INDIA PRIVATE LIMITED",
"AGURCHAND MANMULL JAIN COLLEGE",
"AGURUDAS AGRO PRIVATE LIMITED",
"AGUSTO FORMULATIONS PRIVATE LIMITED",
"AGV SOLAR POWER PROJECT PRIVATE LIMITED",
"AGV SYSTEMS PRIVATE LIMITED",
"AGVENTURE ENTERPRISES PRIVATE LIMITED",
"AGVENTURE INDUSTRIES PRIVATE LIMITED",
"AGVG INFRATECH PRIVATE LIMITED",
"AGV-II FACILITY MANAGEMENT PRIVATE LIMITED",
"AGVISI TECHNOLOGIES PRIVATE LIMITED",
"AGVS MATOSHRI FOOD PRODUCTS PRIVATE LIMITED",
"AGWAN ENTERPRISES PRIVATE LIMITED",
"AGWAN MOTORS PRIVATE LIMITED",
"AGWANI FASHIONS PRIVATE LIMITED",
"AGWIN INNOVATIONS INDIA PRIVATE LIMITED",
"AGX LOGISTICS INDIA PRIVATE LIMITED",
"AGX RETAIL SOLUTIONS PRIVATE LIMITED",
"AGYA AUTO LIMITED",
"AGYEYA DEVELOPERS PRIVATE LIMITED",
"AH BETA DYNAMICS AND ROBOTICS PRIVATE LIMITED",
"AH CHEMICALS PRIVATE LIMITED",
"AH MACHINES INDIA PRIVATE LIMITED",
"AHA HOLDINGS PRIVATE LIMITED",
"AHAA GLOBAL TRAVEL & HOLIDAYS PRIVATE LIMITED",
"AHAADYA INTERIORS PRIVATE LIMITED",
"AHAAN AUTOMOBILES (ANDAMAN) PRIVATE LIMITED",
"AHAAN HEALTHCARE PRIVATE LIMITED",
"AHAAN INFRASTRUCTURE PRIVATE LIMITED",
"AHAAN RESORT PRIVATE LIMITED",
"AHAANA INFRACON ( VIHAAN GROUP)",
"AHAAPPS INFOTECH PRIVATE LIMITED",
"AHAAR CONSUMER PRODUCTS PRIVATE LIMITED",
"AHAD BUILDERS PRIVATE LIMITED",
"AHAD HOSIERY PRIVATE LIMITED",
"AHADIAR TRADING PRIVATE LIMITED",
"AHALIA ALTERNATE ENERGY PRIVATE LIMITED",
"AHALIA FINFOREX LIMITED",
"AHALIA HEALTHCARE LIMITED",
"AHALIA MONEY EXCHANGE AND FINANCIAL SERVICES PRIVATE. LIMITED.",
"AHALYA AGENCIES",
"AHALYA CONSTRUCTIONS PRIVATE LIMITED",
"AHAMANA BUILD-CON PRIVATE LIMITED",
"AHAMMED ROLLER FLOUR MILLS PRIVATE LIMITED",
"AHANA RAY TECHNOLOGIES INDIA PRIVATE LIMITED",
"AHANA SYSTEMS AND SOLUTIONS PRIVATE LIMITED",
"AHAR FOODS & FATS PRIVATE LIMITED",
"AHARVEDA SEVA PRIVATE LIMITED",
"AHASH AUTOMOBILES PRIVATE LIMITED",
"AHASOLAR TECHNOLOGIES LIMITED",
"AHATHESHWARAR SPINNING MILL PRIVATE LIMITED",
"AHC HEALTH CARE PRIVATE LIMITED",
"AHE TECHNOLOGIES PRIVATE LIMITED",
"AHEAD INDUSTRIES PRIVATE LIMITED",
"AHEAD INFOSOFT PRIVATE LIMITED",
"AHEADRACE SOFTWARWE DEVELOPMENT SERVICES PRIVATE LIMITED",
"AHEERA INDIA PRIVATE LIMITED",
"AHEPRA HEALTHCARE LIMITED",
"AHEPRA HEALTHCARE PRIVATE LIMITED",
"AHER AUTOMOBILES PRIVATE LIMITED",
"AHEX TECHNOLOGIES PRIVATE LIMITED",
"AHI CARGO SOLUTION PRIVATE LIMITED",
"AHICHATRA HEALTH CARE PRIVATE LIMITED",
"AHIL GREEN ENERGIE PRIVATE LIMITED",
"AHILL APPAREL EXPORTS PRIVATE LIMITED",
"AHILYA EXPERIENTAL HOSPITALITY AND SERVI CES LLP",
"AHILYA JEWELS PRIVATE LIMITED",
"AHIMSA HOSPITALITY PRIVATE LIMITED",
"AHIMSA INDUSTRIES LIMITED",
"AHIMSA NETWORK SOLUTIONS PRIVATE LIMITED",
"AHINSA FLOUR MILL PRIVATE LIMITED",
"AHINSA INFRASTRUCTURE AND DEVELOPERS LIMITED",
"AHINSA JEWELLERY MANUFACTURING COMPANY PRIVATE LIMITED",
"AHINSA MEDICO PRIVATE LIMITED",
"AHINSA POLYFILMS PRIVATE LIMITED",
"AHINSA POLYTECHNIC DONDAICHA",
"AHINSHA AUTOMOBILES LLP",
"AHINSHA BEVERAGES PRIVATE LIMITED",
"AHINSHA BUILDERS PRIVATE LIMITED",
"AHINSHA MOTORS PRIVATE LIMITED",
"AHINSHA PROPERTIES LTD",
"AHINSHA TEXCONE INDUSTRIES PRIVATE LIMITED",
"AHINSHHA SYNTEX PRIVATE LIMITED",
"AHIR SALT AND ALLIED PRODUCTS PRIVATE LIMITED",
"AHIRE MACHINE TOOLS P LTD",
"AHIRKAR INSTITUTE OF MANAGEMENT STUDIES NAGPUR",
"AHK INFRA ENTERPRISES PRIVATE LIMITED (OPC)",
"AHL GLOBAL LOGISTICS PRIVATE LIMITED",
"AHL INVESTMENT CONSULTANTS PRIVATE LIMITED",
"AHL MINING COMPANY PRIVATE LIMITED",
"AHL MINING PROJECTS PRIVATE LIMITED",
"AHLADA CLEAN ROOM TECH PRIVATE LIMITED",
"AHLADA ENGINEERS LIMITED",
"AHLADA ENGINEERS PRIVATE LIMITED",
"AHLADA HVAC SYSTEMS PRIVATE LIMITED",
"AHLCOM PAPERS PRIVATE LIMITED",
"AHLCON INTERNATIONAL SCHOOL",
"AHLCON PARENTERALS INDIA LIMITED",
"AHLCON PUBLIC SCHOOL",
"AHLCON READY MIX CONCRETE PRIVATE LIMITED",
"AHLERS INDIA PRIVATE. LIMITED",
"AHLUWALIA CONTRACTS INDIA LIMITED",
"AHLUWALIA MARBLES PRIVATE LIMITED",
"AHM DIGITAL NETWORK PRIVATE LIMITED",
"AHM INFRASTRUCTURE PRIVATE LIMITED",
"AHM MARKETING SOLUTIONS PRIVATE LIMITED",
"AHMAD JURAK PRIVATE LIMITED",
"AHMADIA HANAFIA INTER COLLEGE AGRA",
"AHMADNAGAR INDUSTRIAL GASES PRIVATE LIMITED",
"AHMED FOREX & TRAVELS PRIVATE LIMITED",
"AHMED TANNERY PRIVATE LIMITED",
"AHMED TEA CO PVT LTD",
"AHMED TRADE CORP. PRIVATE LIMITED",
"AHMEDABAD ADVANCE HOSPITAL LLP",
"AHMEDABAD AVIATION AND AERONAUTICS LIMITED",
"AHMEDABAD BARIATRICS AND COSMETICS PRIVATE LIMITED",
"AHMEDABAD CEMENT COMPANY PRIVATE LIMITED",
"AHMEDABAD DISTRICT CO OPERATIVE BANK LIMITED",
"AHMEDABAD DISTRICT CO OPERATIVE MILK PRODUCERS UNION LTD",
"AHMEDABAD DISTRICT EDUCATION COMMITTEE MANAGED PRIMARY SCHOOL TEACHER",
"AHMEDABAD ENGINEERS PRIVATE LIMITED",
"AHMEDABAD INFORMATICS SYSTEMS PRIVATE LIMITED",
"AHMEDABAD INFRACON PRIVATE LIMITED",
"AHMEDABAD INSTITUTE OF TECHNOLOGY",
"AHMEDABAD INTERNATIONAL AIRPORT LIMITED",
"AHMEDABAD INTERNATIONAL SCHOOL",
"AHMEDABAD IRRIGATION DIVISION",
"AHMEDABAD MULTICHEM TRADE SOLUTIONS",
"AHMEDABAD MUNCIPLE CORPORATION",
"AHMEDABAD MUNICIPAL CORPORATION",
"AHMEDABAD MUNICIPAL TRANSPORT SERVICE",
"AHMEDABAD PACKAGING INDUSTRIES LIMITED",
"AHMEDABAD RADIO AND MAST SERVICES PRIVATE LIMITED",
"AHMEDABAD RING ROAD INFRA",
"AHMEDABAD ROADLINES PRIVATE LIMITED",
"AHMEDABAD ROADLINK PRIVATE LIMITED",
"AHMEDABAD STEEL CRAFT LIMITED",
"AHMEDABAD STRIPS PRIVATE LIMITED",
"AHMEDABAD TEXTILE INDUSTRYS RESEARCH ASSOCIATION",
"AHMEDABAD UNIVERSITY",
"AHMEDABAD UNIVERSITY SUPPORT FOUNDATION",
"AHMEDABAD WATERFLOW PUMPS PRIVATE LIMITED",
"AHMEDNAGAR ALLOYS PRIVATE LIMITED",
"AHMEDNAGAR BYPASS ROAD PROJECT PRIVATE LIMITED",
"AHMEDNAGAR CATHLAB (INDIA) PRIVATE LIMITED",
"AHMEDNAGAR CINE EXHIBITORS PRIVATE LIMITED",
"AHMEDNAGAR DISTRICT POULTRY FARMER PRODUCER COMPANY LIMITED",
"AHMEDNAGAR FERRO ALLOYS LIMITED",
"AHMEDNAGAR FINANCE LTD",
"AHMEDNAGAR MATHADI & UNPROTECTED LABUR BOARD",
"AHMEDNAGAR MERCHANTS CO OP BANK LTD",
"AHMEDNAGAR MUNICIPAL CORPORATION",
"AHMEDNAGAR POLYMERS PVT.LTD.",
"AHMEDNAGAR STEELS PRIVATE LIMITED",
"AHMEDNAGAR ZILLA PARISHAD EDUCATION",
"AHN HOTEL AND MANAGEMENT SERVICES PRIVATE LIMITED",
"AHOM TECHNOLOGIES PRIVATE LIMITED",
"AHOORA BLOCKS PRIVATE LIMITED",
"AHOY TELECOM PRIVATE LIMITED",
"AHP APPAREL PRIVATE LIMITED",
"AHP GARMENTS PRIVATE LIMITED",
"AHP STAR TRADELINK PRIVATE LIMITED",
"AHR HOSPITALITY PRIVATE LIMITED",
"AHRAINBOW AIRCONDITIONING PRIVATE LIMITED",
"AHRESTY INDIA PRIVATE LIMITED",
"AHRK INFRA PROJECTS PRIVATE LIMITED",
"AHS FACILITY AND SECURITY SOLUTIONS PRIVATE LIMITED",
"AHS HOSPITALITY INDIA PRIVATE LIMITED",
"AHSAN CONSTRUCTION PRIVATE LIMITED",
"AHSAN LEATHERS PRIVATE LIMITED",
"AHSB STEEL PRIVATE LIMITED",
"AHT HOLDINGS PRIVATE LIMITED",
"AHUJA AND ANAND BUILDWELL PRIVATE LIMITED",
"AHUJA BOOK COMPANY PRIVATE LIMITED",
"AHUJA BROTHERS COLD STORAGE PRIVATE LIMITED",
"AHUJA BUILDMART PRIVATE LIMITED",
"AHUJA BULBS PRIVATE LIMITED",
"AHUJA CLOTHIERS PRIVATE LIMITED",
"AHUJA COMMODITIES PRIVATE LIMITED",
"AHUJA CONSTRUCTION",
"AHUJA CONTINENTAL PRIVATE LIMITED",
"AHUJA CORPORATION PRIVATE LIMITED",
"AHUJA COTSPIN PRIVATE LIMITED",
"AHUJA EVENTS & EXHIBITS PRIVATE LIMITED",
"AHUJA FRAMERS PRIVATE LIMITED",
"AHUJA HOSPITAL PRIVATE LIMITED",
"AHUJA IMPEX PRIVATE LIMITED",
"AHUJA KASHYAP PRIVATE LIMITED",
"AHUJA PLASTICS LTD",
"AHUJA RESIDENCY PRIVATE LIMITED",
"AHUJA SALES PRIVATE LIMITED",
"AHUJA SILK MILLS PRIVATE LIMITED",
"AHUJA SYNFAB PRIVATE LIMITED",
"AHUJA TYRES PRIVATE LIMITED",
"AHUJA¬†CONSTRUCTION¬†ENGINEERS",
"AHUJAS' NEXUS INDIA PRIVATE LIMITED",
"AHUJAS WEB PRIVATE LIMITED",
"AHUJASONS SHAWLWALE PRIVATE LIMITED",
"AHURA GAS ENTERPRISES PVT LTD",
"AHURA LEISURE PRIVATE LIMITED",
"AHURA LOGISTICS PRIVATE LIMITED",
"AHURA MAZDA MANUFACTURING COMPANY PRIVATE LIMITED",
"AHURA RESTAURANTS PRIVATE LIMITED",
"AHURAZ SHIPPING AND CLEARING COMPANY PRIVATE LIMITED",
"AHUVA ELECTRONIC TECHNOLOGIES PRIVATE LIMITED",
"AHV ENGINEERS PRIVATE LIMITED",
"AHVENTURES INDIA PRIVATE LIMITED",
"AHW STEELS PRIVATE LIMITED",
"AI AIRPORT SERVICES LIMITED",
"AI ASSETS HOLDING LIMITED",
"AI CORPORATE SOLUTIONS PRIVATE LIMITED",
"AI ENGINEERING",
"AI ENGINEERING SERVICES LIMITED",
"A-I ENTERPRISES PRIVATE LIMITED",
"AI GROWTH PRIVATE LIMITED",
"AI INSTRUMENTS PRIVATE LIMITED",
"AI LABS PRIVATE LIMITED",
"AI MARINE PRODUCTS INDIA PRIVATE LIMITED",
"AI MEDCON OPC PRIVATE LIMITED",
"AI OPTICS PRIVATE LIMITED",
"AI SOFT TECHNOLOGIES PRIVATE LIMITED",
"AIA CSR FOUNDATION",
"AIA ENGINEERING LIMITED",
"AIA TECHNOCRAFTS PRIVATE LIMITED",
"AIAB VENTURES PRIVATE LIMITED",
"AIB LIFE SCIENCE PRIVATE LIMITED",
"AIB MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"AIBC LOGISTICS PRIVATE LIMITED",
"AIBHUNA TECHNOLOGY AND COMMUNICATION PRIVATE LIMITED",
"AIC AGRO INSTRUMENTS PVT LTD",
"AIC CAPITANIO AUTOMATION SYSTEMS INDIA PRIVATE LIMITED",
"AIC CASTING PVT LTD",
"AIC INFRASTRUCTURES PRIVATE LIMITED",
"AIC IRON INDUSTRIES PRIVATE LIMITED",
"AIC ISB ASSOCIATION",
"AIC METALIKS PRIVATE LIMITED",
"AIC REALTORS PRIVATE LIMITED",
"AIC SECURITIES PRIVATE LIMITED",
"AIC STEEL PRIVATE LIMITED",
"AIC STPINEXT INITIATIVES",
"AIC TECHNIK PRIVATE LIMITED",
"AIC VMR PROJECTS PRIVATE LIMITED",
"AICA LAMINATES INDIA PRIVATE LIMITED",
"AICE HEALTH CARE PRIVATE LIMITED",
"AICELLO INDIA PRIVATE LIMITED",
"AICENCE IT SOLUTIONS (OPC) PRIVATE LIMITED",
"AICHELIN UNITHERM HEAT TREATMENT SYSTEMS INDIA",
"AICITTA INTELLIGENT TECHNOLOGY PRIVATE LIMITED",
"AICL COMMUNICATIONS LIMITED",
"AIC-LMCP FOUNDATION",
"AICO FOODS LIMITED",
"AI-COGITO INDIA PRIVATE LIMITED",
"AICON INTALIA REALTY PRIVATE LIMITED",
"AICONS ENGINEERING PRIVATE LIMITED",
"AIC-PINNACLE ENTREPRENEURSHIP FORUM",
"AIC-RAMBHAU MHALGI PRABODHINI FOUNDATION",
"SELCO FOUNDATION",
"AICT ENGINEERING PRIVATE LIMITED",
"AIDA FOODS PRIVATE LIMITED",
"AIDA INDIA PRIVATE LIMITED",
"AIDASH SYSTEMS INDIA PRIVATE LIMITED",
"AIDC TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"AIDDITION TECHNOLOGIES PRIVATE LIMITED",
"AIDE ET ACTION INDIA PRIVATE LIMITED",
"AIDED RECO MANAGEMENT PRIVATE LIMITED",
"AIDED SECONDARY ASHRAM SCHOOL",
"AIDEM VENTURES PRIVATE LIMITED",
"AIDEMTEC SERVICES PRIVATE LIMITED",
"AIDEOBARIE TEA ESTATES PRIVATE LIMITED",
"AIDEQUATE INDIA PRIVATE LIMITED",
"AIDETIC SOFTWARE PRIVATE LIMITED",
"AIDHI PROJECTS PRIVATE LIMITED",
"AIDIAS CONSULTING PRIVATE LIMITED",
"AIDIGITAS DIGITAL PRIVATE LIMITED",
"AIDNEX SERVICES PRIVATE LIMITED",
"AIDNI EXPRESS LINE PRIVATE LIMITED",
"A-ID-SYSTEMS INDIA PRIVATE LIMITED",
"AIDU MOTORS PRIVATE LIMITED",
"AIDWELL UNIVET PRIVATE LIMITED",
"AIE APPAREL PRIVATE LIMITED",
"AIE FIBER RESOURCE AND TRADING INDIA PRIVATE LIMITED",
"AIE SOFTWARE INDIA PRIVATE LIMITED",
"AIE VALLEY TRADERS PVT LTD",
"AIES PHARMA CHEM PRIVATE LIMITED",
"AIETS COM PRIVATE LIMITED",
"AIEZE VERTEX PRIVATE LIMITED",
"AIF & PMS EXPERTS INDIA PRIVATE LIMITED",
"AIF CAPITAL INDIA PRIVATE LIMITED",
"AIF ENGINEERING PRIVATE LIMITED",
"AIFA STRATEGIC MANAGEMENT AND CONSULTANTS PRIVATE LIMITED",
"AIFAZ COTTEX PRIVATE LIMITED",
"AIFSO TECHNOLOGIES PRIVATE LIMITED",
"AIG BUILDCON PRIVATE LIMITED",
"AIG BUSINESS SOLUTION PRIVATE LIMITED",
"AIG DATA SERVICES PRIVATE LIMITED",
"AIG HOSPITAL",
"AIG INFRATECH INDIA PRIVATE LIMITED AIG",
"AIG LOGISTICS AND CARGO PRIVATE LIMITED",
"AIGA ENGINEERS PRIVATE LIMITED",
"AIGC LOGISTICS PRIVATE LIMITED",
"AIGILX HEALTH TECHNOLOGIES PRIVATE LIMITED",
"AIGL PROPERTIES LIMITED",
"AIGUA SPRINKLER AND HYDRANT INDIA PRIVATE LIMITED",
"AIHP EXECUTIVE CENTRES PRIVATE LIMITED",
"AIIPL MU FIVE PROJECT PRIVATE LIMITED",
"AIJAL HANDICRAFTS PRIVATE LIMITED",
"AIK PIPES AND POLYMERS LIMITED",
"AIKAA VENTURES PRIVATE LIMITED",
"AIKAAN LABS PRIVATE LIMITED",
"AIKI LOGISTICS PRIVATE LIMITED",
"AIKM PHARMA PRIVATE LIMITED",
"AI-KNOW LABS PRIVATE LIMITED",
"AIKON HYBRID SEEDS AND AGRI INPUTS PRIVATE LIMITED",
"AIKON TECHNOLOGIES PRIVATE LIMITED",
"AIKON TELECOM PRIVATE LIMITED",
"AIKYA CHEMICALS PRIVATE LIMITED",
"AIKYA CLOTHING PRIVATE LIMITED",
"AIKYA HEALTHCARE PRIVATE LIMITED (OPC)",
"AIKYA REALTY PRIVATE LIMITED",
"AIKYAM HOLDINGS PRIVATE LIMITED",
"AIL DIXON TECHNOLOGIES PRIVATE LIMITED",
"AIL PLASTICS PRIVATE LIMITED",
"AILAS ENGINEERED SOLUTIONS PRIVATE LIMITED",
"AILEX PHARMACEUTICALS PRIVATE LIMITED",
"AI-LEXICONTECH DEVICES PRIVATE LIMITED",
"AILIS ENERGY PRIVATE LIMITED",
"AILOITTE TECHNOLOGIES PRIVATE LIMITED",
"AILSINGHANI TRANSPORT PRIVATE LIMITED",
"AIM ADDCOM PRIVATE LIMITED",
"AIM ADVISORY SERVICES PRIVATE LIMITED",
"AIM APEX INTERNATIONAL MEDIA PRIVATE LIMITED",
"AIM CAPITAL ADVISORS PRIVATE LIMITED",
"AIM CHEMTECH PRIVATE LIMITED",
"AIM EDUCATION PVT LTD",
"AIM ELECTRICAL CONTROLS INDIA PRIVATE LIMITED",
"AIM ENGRAVING PRIVATE LIMITED",
"AIM FINCON PRIVATE. LIMITED",
"AIM FINCON PVT. LTD.",
"AIM GRAPHIC MACHINES PRIVATE LIMITED",
"AIM INFOCOM SERVICES PRIVATE LIMITED",
"AIM LAMINAR PRIVATE LIMITED",
"AIM MACHINTECHNIK PRIVATE LIMITED",
"AIM NONWOVENS AND INTERIORS PRIVATE LIMITED",
"AIM PLUS STAFFING SOLUTIONS",
"AIM REALTORS PRIVATE LIMITED",
"AIM TECH ENGINEERING SOLUTIONS PRIVATE LIMITED",
"AIM TECHNOLOGIES PRIVATE LIMITED",
"AIM VYAPTHI ADVERTISING PRIVATE LIMITED",
"AIM WORLD HOLIDAY PRIVATE LIMITED",
"AIM WORLDWIDE PRIVATE LIMITED",
"AIMAN INDIA PVT LTD",
"AIMBEYOND INFOTECH PRIVATE LIMITED",
"AIMCAD BIOTECH PRIVATE LIMITED",
"AIMCHEM INGREDIENTS PRIVATE LIMITED",
"AIMCO PESTICIDES LIMITED",
"AIMDEK TECHNOLOGIES PRIVATE LIMITED",
"AIMEN ENGINEERS PRIVATE LIMITED",
"AIMEX INDUSTRIES PRIVATE LIMITED",
"AIMIL LIMITED",
"AIMIL PHARMACEUTICALSINDIA LIMITED",
"AIMISON BUSINESS SOLUTIONS PRIVATE LIMITED",
"AIML DATA ANALYTICS SOLUTIONS PRIVATE LIMITED",
"AIML DATA LOGICS PRIVATE LIMITED",
"AIMLYTICS TECHNOLOGIES PRIVATE LIMITED",
"AIMM FREIGHT FORWARDERS INDIA PRIVATE LIMITED",
"AIMO MARKETING SERVICES LLP",
"AIMRA CORPORATION PRIVATE LIMITED",
"AIMS BUILDMART PRIVATE LIMITED",
"AIMS DIGITAL SERVICES PRIVATE LIMITED",
"AIMS FEEDS PRIVATE LIMITED,",
"AIMS HOSPITAL & RESEARCH CENTER",
"AIMS HOSPITAL AND RESEARCH CENTRE",
"AIMS HYBRID SEEDS PRIVATE LIMITED",
"AIMS INDUSTRIES PRIVATE LIMITED",
"AIMS INSTITUTES",
"AIMS INSURANCE BROKING PRIVATE LIMITED",
"AIMS MAX GARDENIA DEVELOPERS PRIVATE LIMITED",
"AIMS MIGITAL TECHNOVATIONS PRIVATE LIMITED",
"AIMS OXYGEN PRIVATE LIMITED",
"AIMS RETAIL SERVICES PRIVATE LIMITED",
"AIMS RG ANGEL PROMOTERS PRIVATE LIMITED",
"AIMS SALES & SERVICE PRIVATE LIMITED",
"AIMS-AVIATION INFRASTRUCTURE SERVICES PRIVATE LIMITED",
"AIMSFINCAP",
"AIMSITE DISPLAY PRIVATE LIMITED",
"AIMSON INDUSTRIES PRIVATE LIMITED",
"AIMTECH INFRA LIMITED",
"AIMTREX TECHNOLOGIES PRIVATE LIMITED",
"AIMTRON ELECTRONICS LIMITED",
"AIMZ EXPERT SECURITY SERVICES PRIVATE LIMITED",
"AIMZ SPECTRUM PRIVATE LIMITED",
"AIN WIND PRIVATE LIMITED",
"AINA CREATIONS PRIVATE LIMITED",
"AINAKWALA OPTYCALS PRIVATE LIMITED",
"AINDLEY MARINE PRIVATE LIMITED",
"AINDRIYA PROPERTIES PRIVATE LIMITED",
"AINESH PHARMA PRIVATE LIMITED",
"AINO MANAGEMENT CONSULTANCY PRIVATE LIMITED",
"AINO SOFTWARES PRIVATE LIMITED",
"AINOMIQ INDIA PRIVATE LIMITED",
"AINQA QDM PRIVATE LIMITED",
"AINTIRAM WEB TECH PRIVATE LIMITED",
"AINTREE TECH SOLUTIONS PRIVATE LIMITED",
"AINVINCIBLE MARKETING PRIVATE LIMITED",
"AIOI.SYSTEMS INDIA PRIVATE LIMITED",
"AIOLOS SOLUTIONS PRIVATE LIMITED",
"AIOMAX MEDICO PRIVATE LIMITED",
"AION PIPES PRIVATE LIMITED",
"AIONEERS TECHNOLOGIES INDIA PRIVATE LIMITED",
"AIONION INVESTMENT SERVICES PRIVATE LIMITED",
"AIONSI INDIA PRIVATE LIMITED",
"AIOSELL TECHNOLOGIES PRIVATE LIMITED",
"AIOT FOUNDRY PRIVATE LIMITED",
"AIOTEL PRIVATE LIMITED",
"AIOTEQ GLOBAL TECHNOLOGIES PRIVATE LIMITED",
"AIP INVESTMENT ADVISORS PRIVATE LIMITED",
"AIPALETTE INDIA PRIVATE LIMITED",
"AIPC INDUSTRIES PRIVATE LIMITED",
"AIPEX WORLDWIDE (OPC) PRIVATE LIMITED",
"AIPHANT TECHNOLOGIES (OPC) PRIVATE LIMITED",
"AIPITA MARKETING PRIVATE LIMITED",
"AIPL AMBUJA HOUSING AND URBAN INFRASTRUCTURE LIMITED",
"AIPL HOUSING AND URBAN INFRASTRUCTURE LIMITED",
"AIPL MARKETING PRIVATE LIMITED",
"AIPL ZORRO PRIVATE LIMITED",
"AIPLEX SOFTWARE PRIVATE LIMITED",
"AIPS REAL ESTATE & ADVISORY SERVICES PRIVATE LIMITED",
"AIPT & APTC DEPOT",
"AIPXPERTS TECHNOLABS PRIVATE LIMITED",
"AIR AFFAIRE TRAVEL & TOURS PRIVATE LIMITED",
"AIR ARABIA PJSC",
"AIR BORNE RECRUITING PRIVATE LIMITED",
"AIR BREAK SWITCHGEAR PRODUCTS PRIVATE LIMITED",
"AIR BREEZE INDIA PRIVATE LIMITED",
"AIR CANADA",
"AIR CARE REFRIGERATION SYSTEM PRIVATE LIMITED",
"AIR CARE SYSTEMS PRIVATE LIMITED",
"AIR CARGO CONNECTIONS (INDIA) PRIVATE LIMITED",
"AIR CASTLE SYSTEM AND SERVICES",
"AIR CHARTER SERVICES PRIVATE LIMITED",
"AIR CHEF PRIVATE LIMITED",
"AIR COM TRAVELS PRIVATE LIMITED",
"AIR COMMAND ACR ENGINEERS PRIVATE LIMITED",
"AIR COMMAND ECO COOLING PRIVATE LIMITED",
"AIR COMMUNICATION SERVICES PRIVATE LIMITED",
"AIR CON SYSTEM INDIA PRIVATE LIMITED",
"AIR CONNECTION PRIVATE LIMITED",
"AIR CONTROL ENGINEERING PRIVATE LIMITED",
"AIR CONTROL INDIA PRIVATE LIMITED",
"AIR DESIGN HVAC PRIVATE LIMITED",
"AIR DESIGN SYSTEMS",
"AIR DISTRIBUTORS PRIVATE LIMITED",
"AIR FILTER INDUSTRIES PRIVATE LIMITED",
"AIR FLOW COOLTECH PRIVATE LIMITED",
"AIR FLOW EQUIPMENTS (INDIA) PRIVATE LIMITED",
"AIR FLOW PRIVATE LIMITED",
"AIR FORCE BAL BHARATI SCHOOL",
"AIR FORCE CENTRAL ACCOUNTS OFFICE NEW DELHI",
"AIR FORCE SCHOOL GANDHINAGAR",
"AIR FORCE SCHOOL VIMAN NAGAR",
"AIR FORCE STATION",
"AIR GAS ELECTRONIC MATERIALS INDIA PRIVATE LIMITED",
"AIR GENERAL HOME APPLIANCES PRIVATE LIMITED",
"AIR INDIA EXPRESS LIMITED",
"AIR INDIA SATS AIRPORT SERVICES PRIVATE LIMITED",
"AIR INN PRIVATE LIMITED",
"AIR INTERNATIONAL TTR THERMAL SYSTEMS PRIVATE LIMITED",
"AIR LINKERS EXPRESS PRIVATE LIMITED",
"AIR LIQUIDE GLOBAL E&C SOLUTIONS INDIA PRIVATE LIMITED",
"AIR LIQUIDE INDIA HOLDING PRIVATE LIMITED",
"AIR LIQUIDE INDIA SPECIALITY GASES PRIVATE LIMITED",
"AIR LIQUIDE MEDICAL SYSTEMS PRIVATE LIMITED",
"AIR LIQUIDE NORTH INDIA PRIVATE LIMITED",
"AIR LIVERY INDIA PRIVATE LIMITED",
"AIR MASTER FLOWTEC PRIVATE LIMITED",
"AIR MAURITIUS LIMITED",
"AIR MECH ENGINEERS PRIVATE LIMITED",
"AIR MEDIA NETWORK PRIVATE LIMITED",
"AIR MOVEMENT & CONTROL SYSTEM PRIVATE LIMITED",
"AIR PACK PVT LTD",
"AIR PARADISE TOUR AND TRAVELS PRIVATE LIMITED",
"AIR POWER ENGINEERING COMPANY PRIVATE LIMITED",
"AIR PUSHPAK TOURS INDIA PRIVATE LIMITED",
"AIR RESCUERS WORLD WIDE PRIVATE LIMITED",
"AIR REVIVE PRIVATE LIMITED",
"AIR SHAGOON NETWORK PRIVATE LIMITED",
"AIR TECHNO INDIA PRIVATE LIMITED",
"AIR TEX (INDIA) PRIVATE LIMITED",
"AIR- TOUCH TECHNOLOGIES PRIVATE LIMITED",
"AIR TRANSPORT & TOURISM ADVISORS INDIA PRIVATE LIMITED",
"AIR TRANSPORT CORPORATION ASSAM PRIVATE LIMITED",
"AIR TRENDZ PRIVATE LIMITED",
"AIR WATER INDIA PRIVATE LIMITED",
"AIR WAVES ENGINEERS PRIVATE LIMITED",
"AIR WAVES PROJECTS PRIVATE LIMITED",
"AIR WORKS MRO SERVICES PRIVATE LIMITED",
"AIRA 4MATIC GLOBAL VALVE AUTOMATION PRIVATE LIMITED",
"AIRA CARGO SERVICES PRIVATE LIMITED",
"AIRA EURO AUTOMATION PRIVATE LIMITED",
"AIRA OXYGEN PRIVATE LIMITED",
"AIRA TREX SOLUTIONS INDIA PRIVATE LIMITED",
"AIRADS LIMITED",
"AIRALLIANCE EXPRESS CARGO SERVICES PRIVATE LIMITED",
"AIRAN FINSTOCKS PRIVATE LIMITED",
"AIRAN GLOBAL PRIVATE LIMITED",
"AIRAN INKS INDIA PRIVATE LIMITED",
"AIRAN LIMITED",
"AIRAN STEEL & POWER PRIVATE LIMITED",
"AIRASIA BERHAD",
"AIRASIA TECHNOLOGY CENTRE INDIA PRIVATE LIMITED",
"AIRASK TECHNOLOGY PRIVATE LIMITED",
"AIRAVA INTERIOR SOLUTIONS PRIVATE LIMITED",
"AIRAVANA SYSTEMS PRIVATE LIMITED",
"AIRAVAT AUTO SPARES PRIVATE LIMITED",
"AIRAVATA CONSTRUCTION PRIVATE LIMITED",
"AIRAWAT DEVELOPERS PRIVATE LIMITED",
"AIRBASE LABS INDIA PRIVATE LIMITED",
"AIRBEAS ONLINE TRAVEL PRIVATE LIMITED",
"AIRBNB GLOBAL CAPABILITY CENTER PRIVATE LIMITED",
"AIRBOAT TECHNOLOGIES PRIVATE LIMITED",
"AIRBORN HOLIDAYS PRIVATE LIMITED",
"AIRBORNE CHARTERS INDIA PRIVATE LIMITED",
"AIRBORNE FREIGHT",
"AIRBORNE INDUSTRIES LLP",
"AIRBORNE TRAVELS PRIVATE LIMITED",
"AIRBUS INDIA PRIVATE LIMITED",
"AIRCAR AIRLINES PRIVATE LIMITED",
"AIRCARE PROJECTS PRIVATE LIMITED",
"AIRCARE SYSTEM AND SOLUTION INDIA PRIVATE LIMITED",
"AIRCARE TECHNOLOGIES INDIA PRIVATE LIMITED",
"AIRCEL SMART MONEY LIMITED",
"AIRCHECK INDIA PRIVATE LIMITED",
"AIRCITY FOOTWEARS PRIVATE LIMITED",
"AIRCITY HVAC EQUIPMENT PRIVATE LIMITED",
"AIRCITY SHOES PRIVATE LIMITED",
"AIRCO-FIN TUBES INDIA PRIVATE LIMITED",
"AIRCOM INTERNATIONAL INDIA PRIVATE LIMITED",
"AIRCON AIR-SPARES AND SERVICES PRIVATE LIMITED",
"AIRCON AUTOMATION INDIA PRIVATE LIMITED",
"AIRCON COOLING SOLUTIONS PRIVATE LIMITED",
"AIRCON ENGINEERS PRIVATE LIMITED",
"AIRCON HANDLING SYSTEMS PRIVATE LIMITED",
"AIRCON REF PRIVATE LIMITED",
"AIRCON SOLUTIONS PRIVATE LIMITED",
"AIRCON TECHNIQUE PRIVATE LIMITED",
"AIRCON TRADEX PRIVATE LIMITED",
"AIR-COOL HVAC ENGINEERS PRIVATE LIMITED",
"AIRCRAFT DESIGN AND ENGINEERING",
"AIRCRUISE LOGISTICS INDIA PRIVATE LIMITED",
"AIRCRUISE TRAVELS PRIVATE LIMITED",
"AIRDIT SOFTWARE SERVICES PRIVATE LIMITED",
"AIRDRIVEN AVIATION PRIVATE LIMITED",
"AIREF ENGINEERS PRIVATE LIMITED",
"AIREL (INDIA) PRIVATE LIMITED",
"AIREN METALS PRIVATE LIMITED",
"AIRENS MARKETING PRIVATE LIMITED",
"AIRFAST GLOBAL LOGISTICS PRIVATE LIMITED",
"AIRFI AVIATION SOLUTIONS PRIVATE LIMITED",
"AIRFIBER NETWORKS PRIVATE LIMITED",
"AIRFIELD EXPRESS PRIVATE LIMITED",
"AIRFIL CLEANROOM SYSTEMS PRIVATE LIMITED",
"AIRFILT TECHNOLOGIES PRIVATE LIMITED",
"AIRFINS PRIVATE LIMITED",
"AIRFLOW AQUIPEMENT INDIA PRIVATE LIMITED",
"AIRFLOW TECH EQUIPMENTS PRIVATE LIMITED",
"AIRFORCE ADMIN COLLEGE",
"AIRFORCE VOCATIONAL COLLEGE",
"AIRFORM SHOES PRIVATE LIMITED",
"AIRFRIG TECHNOLOGIES PRIVATE LIMITED",
"AIRFRIGE ENGINEERS PRIVATE LIMITED",
"AIRGASES PROJECTS PRIVATE LIMITED",
"AIRGENIE COMMUNICATIONS PRIVATE LIMITED",
"AIRGUARD INDIA PRIVATE LIMITED",
"AIRICON TECHNOLOGY",
"AIRIER NATURA PRIVATE LIMITED",
"AIRIFIC SYSTEMS PRIVATE LIMITED",
"AIRIS DATA INDIA PRIVATE LIMITED",
"AIRIS PHARMA PRIVATE LIMITED",
"AIRISH FINANCIAL & FOREX SERVICES PRIVATE LIMITED",
"AIRKING CHARTERS PRIVATE LIMITED",
"AIRKOM AGENCIES INDIA PRIVATE LIMITED",
"AIRKOM ELECTRONICS PRIVATE LIMITED",
"AIRKOMM MEDIA PRIVATE LIMITED",
"AIRL CONSULTANTS PRIVATE LIMITED",
"AIRLAND TOURS AND TRAVELS PRIVATE LIMITED",
"AIRLIFE GASES PRIVATE LIMITED",
"AIRLIFT CARGO SYSTEM(MADRAS)PRIVATE LIMITED",
"AIRLIFT CONTAINER LINES PRIVATE LIMITED",
"AIRLIFT GLOBAL CARRIERS PRIVATE. LIMITED",
"AIRLIFT MARINE SERVICES PRIVATE LIMITED",
"AIRLIFT SERVICES PRIVATE LIMITED",
"AIRLIFT TRANS OCEANIC PRIVATE LIMITED",
"AIRLIFT(INDIA)PRIVATE LIMITED",
"AIRLINE MARKETING SERVICES INDIA PRIVATE LIMITED",
"AIRLINK COMMUNICATIONS PRIVATE LIMITED",
"AIRLINK LOGISTICS PRIVATE LIMITED",
"AIRLINQ TECHNOLOGY PRIVATE LIMITED",
"AIRLOCK INDIA PRIVATE LIMITED",
"AIRMART E-COMMERCE PRIVATE LIMITED",
"AIRMASTER INDO PLAST PRIVATE LIMITED",
"AIRMASTER RECTIFIERS PRIVATE LIMITED",
"AIRMAX PNEUMATICS LIMITED",
"AIRMAX(GUJARAT ) PVT LTD",
"AIRMECH ENTERPRISES PRIVATE LIMITED",
"AIRMEN ENGINEERS & SERVICES PRIVATE LIMITED",
"AIRMID AVIATION SERVICES LIMITED",
"AIRMID AVIATION SERVICES LIMITED.",
"AIRMID INFRASTRUCTURE LIMITED",
"AIRMISTIC ENGINEERS PRIVATE LIMITED",
"AIRNET INFOTECH PRIVATE LIMITED",
"AIRNET SERVICES PRIVATE LIMITED",
"AIRNOV INDIA LIMITED",
"AIRO BUSINESS TRAVEL PRIVATE LIMITED",
"AIRO DIGITAL LABS INDIA PRIVATE LIMITED",
"AIRO LAM LIMITED",
"AIROFLY TRAVELS PRIVATE LIMITED",
"AIROFROST HVAC SYSTEMS PRIVATE LIMITED",
"AIROGO LOGISTICS PRIVATE LIMITED",
"AFG COMBUSTION PRIVATE LIMITED",
"AIROKLEAN BIO-TECHNOLOGIES PRIVATE LIMITED",
"AIROLI IRON AND STEEL PRIVATE LIMITED",
"AIROLI ITP DEVELOPMENT PRIVATE LIMITED",
"AIROLINK CONTRACTING PRIVATE LIMITED",
"AIROLL CONVEYOR PRODUCTS PRIVATE LIMITED",
"AIRON TRADING PRIVATE LIMITED",
"AIRONA TILES LIMITED",
"AIRONESOURCE PRIVATE LIMITED",
"AIROTEK POLLU CONTROL PROJECTS AND EQUIPMENT PRIVATE LIMITED",
"AIROVAC PUMPS & ENGINEERING PRIVATE LIMITED",
"AIROVIENT FANS & SYSTEMS PRIVATE LIMITED",
"AIROWIRE NETWORKS PRIVATE LIMITED",
"AIROX NIGEN EQUIPMENTS PRIVATE LIMITED",
"AIROX NIGEN PROJECTS PRIVATE LIMITED",
"AIROX TECHNOLOGIES LIMITED",
"AIROX TECHNOLOGIES PRIVATE LIMITED",
"AIRPAC CLEANTECH PRIVATE LIMITED",
"AIRPACK COMPRESSOR TEKNOLOGIES PRIVATE LIMITED",
"AIRPACK EXPRESS PRIVATE LIMITED",
"AIRPAY PAYMENT SERVICES PRIVATE LIMITED",
"AIRPETS RELOCATION SERVICES PRIVATE LIMITED",
"AIRPLAZA RETAIL HOLDINGS PRIVATE LIMITED",
"AIRPLUS ELECTRONICS INDIA PRIVATE LIMITED",
"AIRPLUS TRAVEL SERVICES PRIVATE LIMITED",
"AIRPORT GOLF VIEW HOTELS AND SUITES PRIVATE LIMITED",
"AIRPORT HEALTH ORGANISATION MUMBAI",
"AIRPORT NURSERY AND PRIMARY SCHOOL",
"AIRPORT RETAIL PRIVATE LIMITED",
"AIRPORT SCHOOL AHMEDABAD",
"AIRPORTS AUTHORITY OF INDIA",
"AIRPOWER WINDFARMS PRIVATE LIMITED",
"AIRPRO FRAGRANCE PRIVATE LIMITED",
"AIRPRO TECHNOLOGY INDIA PRIVATE LIMITED",
"AIRPUSH INDIA PRIVATE LIMITED",
"AIRRELAX INDUSTRIES PRIVATE LIMITED",
"AIRSAH SOLUTIONS PRIVATE LIMITED",
"AIRSEA FORWARDERS INDIA PRIVATE LIMITED",
"AIR-SEA-LINE LOGISTICS PRIVATE LIMITED",
"AIRSERCO PRIVATE LIMITED",
"AIRSOFT GUN INDIA PRIVATE LIMITED",
"AIRSON CERAMIC INDUSTRIES",
"AIR-SON FIBC PRIVATE LIMITED",
"AIRSON GLASS FABRICS PRIVATE LIMITED",
"AIRSON MERCANTILE PRIVATE LIMITED",
"AIRSON OILS PRIVATE LIMITED",
"AIRSON VENTURES PRIVATE LIMITED",
"AIRSONIC HOLIDAYS PRIVATE LIMITED",
"AIRSONIC TRAVELS PRIVATE LIMITED",
"AIRSPACE BROADBAND PRIVATE LIMITED",
"AIRSPAN NETWORKS INDIA PRIVATE LIMITED",
"AIRSPUN FABRICS PRIVATE LIMITED",
"AIRSPUN SYNTHETICS PRIVATE LIMITED",
"AIRSTREAM SYSTEMS PRIVATE LIMITED",
"AIRSURGE LOGISTICS PRIVATE LIMITED",
"AIRTEC ELECTROVISION PRIVATE LIMITED",
"AIRTECH COMPRESSORS PRIVATE LIMITED",
"AIRTECH COOLING PROCESS PRIVATE LIMITED",
"AIRTECH INTERNET SOLUTIONS PRIVATE LIMITED",
"AIRTECH PRIVATE. LIMITED.",
"AIRTECH SOLUTIONS INDIA PRIVATE LIMITED",
"AIRTECH SYSTEMS INDIA PRIVATE LIMITED",
"AIRTEL COMMUNICATION",
"XTELIFY LIMITED",
"AIRTEL INTERNATIONAL LLP",
"AIRTEL PAYMENTS BANK LIMITED",
"AIRTEMP SOLUTIONS PRIVATE LIMITED",
"AIRTHMATIC CORPORATION PRIVATE LIMITED",
"AIRTICKETS INDIA PRIVATE LIMITED",
"AIRTORY INTERACTIVE PRIVATE LIMITED",
"AIRTRAX POLYMERS PRIVATE LIMITED",
"AIRTRON CONSULTING ENGINEERS PRIVATE LIMITED",
"AIRTRONIC GAUGES & INSTRUMENTS PRIVATE LIMITED",
"AIRUSHA ENERGY PRIVATE LIMITED",
"AIRVAC INDUSTRIES PRIVATE LIMITED",
"AIRVEDA TECHNOLOGIES PRIVATE LIMITED",
"AIRVEL TOURS AND TRAVELS PRIVATE LIMITED",
"AIRVISION INDIA PRIVATE LIMITED",
"AIRVISION TECHNOLOGIES PRIVATE LIMITED",
"AIRWAVES SYSTEMS PRIVATE LIMITED",
"AIRWAYS COURIER (INDIA) PRIVATE LIMITED",
"AIRWAYS LOGISTICS PRIVATE LIMITED",
"AIRWAYS SURGICALS PRIVATE LIMITED",
"AIRWELL ENGINEERING PRIVATE LIMITED",
"AIRWIDE CAR RENT PRIVATE LIMITED",
"AIRWIDE EXPRESS CARGO PRIVATE LIMITED",
"AIRWILL HOME COLLECTIONS PRIVATE LIMITED",
"AIRWINGS COURIER EXPRESS (INDIA) PRIVATE LIMITED",
"AIRWINGS NEWORK SOLUTIONS",
"AIRYSOLE FOOTWEAR PRIVATE LIMITED",
"AIS ADHESIVES LIMITED",
"AIS ASSOCIATES LLP",
"AIS BUSINESS SOLUTIONS PRIVATE LIMITED",
"AIS DISTRIBUTION SERVICES LIMITED",
"AIS GLASS SOLUTIONS LIMITED",
"AIS HOLIDAYS PRIVATE LIMITED",
"AIS SOLUTIONS AND CONSUMABLES PRIVATE LIMITED",
"AIS TECHNOLABS PRIVATE LIMITED",
"AIS TRADEX PRIVATE LIMITED",
"AISA INDUSTRIAL AUTOMATION INDIA PRIVATE LIMITED",
"AISAN AUTO PARTS INDIA PRIVATE LIMITED",
"AISAN INDUSTRY INDIA PRIVATE LIMITED",
"AISAN SALES INDIA PRIVATE LIMITED",
"AISCOR PRIVATE LIMITED",
"AISECT LIMITED",
"AISECT SOCIETY",
"AISECT UNIVERSITY",
"AISHA (INDIA) PRIVATE LIMITED",
"AISHAN TECHNOLOGIES INDIA PRIVATE LIMITED",
"AISHANI CONSTRUCTIONS PRIVATE LIMITED",
"AISHANI ELECTRONICS PRIVATE LIMITED",
"AISHANI INFRA PRIVATE LIMITED",
"AISHANI PROJECTS PRIVATE LIMITED",
"AISHANYA COFFEE PRIVATE LIMITED",
"AISHI AQUA EXPORTS PRIVATE LIMITED",
"AISHIKA PHARMA PRIVATE LIMITED",
"AISHITA PHARMA & HEALTHCARE SERVICES LLP",
"AISHREE KHODIYAR H S U B SHALA",
"AISHU TEXTILES PRIVATE LIMITED",
"AISHVI TAPES INDUSTRIES",
"AISHWARIYA MEDICAL INSTITUTION",
"AISHWARYA AGRIPROCESSORS PRIVATE LIMITED",
"AISHWARYA BUSINESS CORPORATION PRIVATE LIMITED",
"AISHWARYA CIVILTECH PRIVATE LIMITED",
"AISHWARYA COLONISERS PRIVATE LIMITED",
"AISHWARYA COMPLEX PVT LTD",
"AISHWARYA CONSOLIDATES PRIVATE LIMITED",
"AISHWARYA COTTONS",
"AISHWARYA DESIGN STUDIO PRIVATE LIMITED",
"AISHWARYA GROWERS PRIVATE LIMITED",
"AISHWARYA INTERIORS PRIVATE LIMITED",
"AISHWARYA LAXMI AGROMART PRIVATE LIMITED",
"AISHWARYA LIFESTYLE PRIVATE LIMITED",
"AISHWARYA MECHFO (INDIA) PRIVATE LIMITED",
"AISHWARYA NUTRI FOODS PRIVATE LIMITED",
"AISHWARYA PUBLICATIONS PRIVATE LIMITED",
"AISHWARYA TEA CO PVT LTD",
"AISHWARYA TRADEX PRIVATE LIMITED",
"AISHWARYA TRADING COMPANY",
"AISHWARYAA ORGANICS PRIVATE LIMITED",
"AISHWARYAM INFRA PRIVATE LIMITED",
"AISIN AUTOMOTIVE HARYANA PRIVATE LIMITED",
"AISIN AUTOMOTIVE KARNATAKA PRIVATE LIMITED",
"AISIRI AGRO PRIVATE LIMITED",
"AISMULTI GLOBAL SOLUTIONS PRIVATE LIMITED",
"AISRI CONSULTANCY PRIVATE LIMITED",
"AISSA MARITIME PRIVATE LIMITED",
"AISSEL TECHNOLOGIES PRIVATE LIMITED",
"AISSHPRA DEVELOPERS PRIVATE LIMITED",
"AISSHPRA LIFE SPACES PRIVATE LIMITED",
"AISSMS COLLEGE OF ENGINEERING",
"AISSMS INSTITUTE OF INFORMATION TECHNOLOGY",
"AIST INFOTECH PRIVATE LIMITED (OPC)",
"AISVARISTA VENTURES PRIVATE LIMITED",
"AISWARYA POLYFLEX PVT LTD",
"AISWARYAM STEELS PRIVATE LIMITED",
"AISYA COLD STORAGE AND ICE PLANT PRIVATE LIMITED",
"AIT GLOBAL INDIA PRIVATE LIMITED",
"AIT INTERNET SERVICES PRIVATE LIMITED",
"AIT RESOURCE INDIA PRIVATE LIMITED",
"AIT WORLDWIDE LOGISTICS INDIA PRIVATE LIMITED",
"AITA CARRIERS PRIVATE LIMITED",
"AITA POLYMERS PRIVATE LIMITED",
"AITALIA COATS PRIVATE LIMITED",
"AITC FACILITIES MANAGEMENT PRIVATE LIMITED",
"AITC TRANSLOGISTICS PRIVATE LIMITED",
"AITECH INNOVATIONS INDIA PRIVATE LIMITED",
"AITECHEX QUANTUM INNOVATIVE SOLUTIONS PRIVATE LIMITED",
"AITESS NETWORKS PRIVATE LIMITED",
"AITHENT TECHNOLOGIES PRIVATE LIMITED",
"AITHER TECHNOLOGY INDIA PRIVATE LIMITED",
"AITHINKERDS INDIA PRIVATE LIMITED",
"AITITUDE IT PRIVATE LIMITED",
"AITKEN SPENCE HOTEL MANAGEMENTS SOUTH INDIA PRIVATE LIMITED",
"AITMC VENTURES LIMITED",
"AITMC VENTURES PRIVATE LIMITED",
"AITS TECHNOLOGY SERVICES INDIA PRIVATE LIMITED",
"AITSIL SPV PRIVATE LIMITED",
"AITURISTIC SOFTWARE PRIVATE LIMITED",
"AIVA ENGINEERING PRIVATE LIMITED",
"AIWASILKS PRIVATE LIMITED",
"AIWF TECHNOLOGIES PRIVATE LIMITED",
"AIWMI KNOWLEDGE MANAGEMENT PRIVATE LIMITED",
"AIX CONNECT PRIVATE LIMITED",
"AIXXO FLOUR AND RICE MILLS PRIVATE LIMITED",
"AIYER SHIPPING AGENCY PRIVATE LIMITED",
"AIYO LABS PRIVATE LIMITED",
"AIZANT DRUG RESEARCH SOLUTIONS PRIVATE LIMITED",
"AIZER ELECTRIC INDIA PRIVATE LIMITED",
"AIZHER FINE CHEM PRIVATE LIMITED",
"AIZZA COLLEGE OF ENGG & TECHNOLOGY",
"AJ AGROTECH IMPEX PRIVATE LIMITED",
"AJ AND SONS PRIVATE LIMITED",
"AJ ARCHITECTS AND INTERIOR DESIGNERS PRIVATE LIMITED",
"AJ CANS PRIVATE LIMITED",
"AJ COUNTRYWIDE FOREX PRIVATE LIMITED",
"AJ DEVTECH PRIVATE LIMITED",
"AJ FIBERTEK INDIA PRIVATE LIMITED",
"AJ HIGHER SECONDARY SCHOOL",
"AJ HOSPITAL & RESEARCH CENTRE",
"AJ HOUSEKEEPING AND MANAGEMENT SERVICES PRIVATE LIMITED",
"AJ HVAC & ELECTRICAL PRIVATE LIMITED",
"AJ INDUSTRIAL ELECTRONICS PRIVATE LIMITED",
"AJ INSTITUTE OF MANAGEMENT",
"AJ PRAKASHAN PRIVATE LIMITED",
"AJ REFINERY PRIVATE LIMITED",
"AJ RETAIL PRIVATE LIMITED",
"AJ SHETTY MEDICAL COLLEGE",
"AJ TECHNOVATIONS PRIVATE LIMITED",
"AJ TRAVELS PRIVATE LIMITED",
"AJ VALUE AUTOMATION",
"AJ WISE INVESTMENT PRIVATE LIMITED",
"AJA ELECTRONICS PRIVATE LIMITED",
"AJA IMPEX PRIVATE LIMITED",
"AJA RADIOLOGY IMAGING AND MEDICAL CARE PRIVATE LIMITED",
"AJAAYA DEVELOPMENT FOUNDATION",
"AJAAYU TRADING AND CONSULTANCY PRIVATE LIMITED",
"AJAGAR FINANCE PRIVATE LIMITED",
"AJAGAR MARKETING PRIVATE LIMITED",
"AJAI TIMBERS PRIVATE LIMITED",
"AJAKA IMPEX PRIVATE LIMITED",
"AJANTA BELTS PRIVATE LIMITED",
"AJANTA BOOKS INTERNATIONAL PRIVATE LIMITED",
"AJANTA BOTTLE PRIVATE LIMITED",
"AJANTA BOTTLERS & BLENDERS PRIVATE LIMITED",
"AJANTA BUILDERS PRIVATE LIMITED",
"AJANTA BUSINESS PVT LTD.",
"AJANTA CYCLES PVT LTD",
"AJANTA DAIRYMILK & FOODS PRIVATE LIMITED",
"AJANTA ENERGY PRIVATE LIMITED",
"AJANTA FOOTCARE INDIA PRIVATE LIMITED",
"AJANTA GARTEX PROCESSORS PRIVATE LIMITED",
"AJANTA HANDTEX PRIVATE LIMITED",
"AJANTA HOSPITAL AND IVF CENTRE PRIVATE LIMITED",
"AJANTA INDIA LIMITED",
"AJANTA INDIA PRIVATE LIMITED",
"AJANTA INDUSTRIES",
"AJANTA ISPAT PRIVATE LIMITED",
"AJANTA LABELS COMPANY PRIVATE LIMITED",
"AJANTA LOGISTIC PRIVATE LIMITED",
"AJANTA MANUFACTURING LIMITED",
"AJANTA MANUFACTURING PRIVATE LIMITED",
"AJANTA MARKETING SERVICES PRIVATE LIMITED",
"AJANTA MEDICALS PRIVATE LIMITED",
"AJANTA MOTELS PRIVATE LIMITED",
"AJANTA ORGOCHEM PRIVATE LIMITED",
"AJANTA PACK MART PRIVATE LIMITED.",
"AJANTA PACKAGING",
"AJANTA PHARMA LIMITED",
"AJANTA PHOTO AND TECHNOLOGIES PRIVATE LIMITED",
"AJANTA POLYMERS PRIVATE. LIMITED.",
"AJANTA PRINT ARTS",
"AJANTA RAAJ PROTEINS LIMITED",
"AJANTA REALTECH PRIVATE LIMITED",
"AJANTA SALES PVT.LTD.",
"AJANTA SANITARYWARE PRIVATE LIMITED",
"AJANTA SELF RELIANT FARMERS PRODUCER COMPANY LIMITED",
"AJANTA SHOES INDIA PRIVATE LIMITED",
"AJANTA SOYA LIMITED TRANSFER FROM DELHI TO RAJASTHAN",
"AJANTA STEELS INDIA PRIVATE LIMITED",
"AJANTA SURFACE TREATMENT PRIVATE LIMITED",
"AJANTA TRAVELS PRIVATE LIMITED",
"AJANTA ULTRAPLAST PRIVATE LIMITED",
"AJANTA UNIVERSAL FABRICS LIMITED",
"AJANTHA AUTOCAST PRIVATE LIMITED",
"AJANTHA BATHROOM PRODUCTS AND PIPES PRIVATE LIMITED",
"AJANTHA WOOD SUPPLIERS",
"AJARA HEALTH CARE AND RESEARCH CENTRE PRIVATE LIMITED",
"AJARA MAHAVIDYALAYA AJARA",
"AJARAMAR PROCESSORS PRIVATE LIMITED",
"AJAS COMPONENT PRIVATE LIMITED",
"AJASHY ENGINEERING SALES PRIVATE LIMITED",
"AJASRA HOMES PRIVATE LIMITED",
"AJATUS SOFTWARE PRIVATE LIMITED",
"AJAX ARCHITECTURALS PRIVATE LIMITED",
"AJAX ENGINEERING PRIVATE LIMITED",
"AJAX NETWORK SOLUTIONS PRIVATE LIMITED",
"AJAX STONEKRAFT PRIVATE LIMITED",
"AJAX.COM PRIVATE LIMITED",
"AJAY (INDIA) LTD",
"AJAY ADVERTISING AND HOLDINGS PRIVATE LIMITED",
"AJAY AGROTECH PRIVATE LIMITED",
"AJAY AIR PRODUCTS PRIVATE LIMITED",
"AJAY ASSOCIATES PRIVATE LIMITED",
"AJAY BHARAT PVT LTD",
"AJAY BHAT FINANCIAL SERVICES PRIVATE LIMITED",
"AJAY BIO-TECH INDIA LIMITED",
"AJAY BUILDERS ENGINEERS & CONSTRUCTION (OPC) PRIVATE LIMITED",
"AJAY CAR RENTAL INDIA PRIVATE LIMITED",
"AJAY CASTINGS PRIVATE LIMITED",
"AJAY COLOR FILMS PVT LTD",
"AJAY COMPONENTS (PVT) LIMITED",
"AJAY DECORATIVE LAMINATES PRIVATE LIMITED",
"AJAY ELASTIC PRIVATE LIMITED",
"AJAY ENGICONE PRIVATE LIMITED",
"AJAY ENGI-INFRASTRUCTURE PRIVATE LIMITED",
"AJAY ENGINEERING WORKS & EQUIPMENT PRIVATE LIMITED",
"AJAY ENTERPRISES PRIVATE LIMITED",
"AJAY FASHIONS PRIVATE LIMITED",
"AJAY FOOD PRODUCTS KATNI PRIVATE LIMITED",
"AJAY GELATINE PRODUCTS PVT LTD",
"AJAY GOEL TEXTILES PRIVATE LIMITED",
"AJAY HARDWARE INDUSTRIES PRIVATE LIMITED",
"AJAY INDUSTRIAL CORP LIMITED",
"AJAY INDUSTRIAL POLYMERS PRIVATE LIMITED",
"AJAY INFRA ENGINEERING PRIVATE LIMITED",
"AJAY INGOT ROLLING MILL PRIVATE LIMITED",
"AJAY ISPAT UDYOG PVT.LTD.",
"AJAY KUMAR GARG ENGINEERING COLLEGE",
"AJAY KUMAR INFRADEVELOPERS PRIVATE LIMITED",
"AJAY KUMAR RAHUL KUMAR PRIVATE LIMITED",
"AJAY LABOUR SOLUTION",
"AJAY LANDMARK PRIVATE LIMITED",
"AJAY LOGISTICS PRIVATE LIMITED",
"AJAY MADEUPS PRIVATE LIMITED",
"AJAY MANPOWER AND CONSTRUCTION PRIVATE LIMITED",
"AJAY METALLOYS PRIVATE LIMITED",
"AJAY MODI TRAVELS PRIVATE LIMITED",
"AJAY MULTI PROJECTS PRIVATE LIMITED",
"AJAY NATAVARLAL COMMODITIES PRIVATE LIMITED",
"AJAY ORGANICS PVT LTD",
"AJAY PHARMACEUTICALS PVT LTD",
"AJAY PLASTIC INDUSTRIES (INDIA) PVT LTD",
"AJAY PLYWOOD INDUSTRIES PVT LTD",
"AJAY POLY PRIVATE LIMITED",
"AJAY PRAKASH ASSOCIATES CONSTRUCTION PRIVATE LIMITED",
"AJAY PROTECH PRIVATE LIMITED",
"AJAY SAREES PRIVATE LIMITED",
"AJAY SCIENTIFIC",
"AJAY SHUKLA PRODUCTIONS PRIVATE LIMITED",
"AJAY SNACKS PRIVATE LIMITED",
"AJAY STEEL CASTING PRIVATE LIMITED",
"AJAY STEELS PRIVATE LIMITED",
"AJAY SYNTEX PRIVATE LIMITED",
"AJAY SYSCON PRIVATE LIMITED",
"AJAY TRADECORPORATION PRIVATE LIMITED",
"AJAY TRADELINKS PRIVATE LIMITED",
"AJAY TRADERS",
"AJAY TRADING COMPANY",
"AJAY TRAVELS PRIVATE LIMITED",
"AJAY VALVES PVT LTD",
"AJAYA EXPORTS PRIVATE LTD",
"AJAYA INFRA ADVISORS PRIVATE LIMITED",
"AJAY-DEEP CONSTRUCTION PRIVATE LIMITED",
"AJAYDEEP INFRACON PRIVATE LIMITED",
"AJAYDEEP PRIVATE LIMITED",
"AJAYMA ELECTRICALS PRIVATE LIMITED",
"AJAYMERU METALS PRIVATE LIMITED",
"AJAYVISION EDUCATION PRIVATE LIMITED",
"AJB VENTURES PRIVATE LIMITED",
"AJC BOSE COLLEGE",
"AJC EDUTECH OPC PRIVATE LIMITED",
"AJC EDUTECH PRIVATE LIMITED",
"AJC JEWEL MANUFACTURERS PRIVATE LIMITED",
"AJCON GLOBAL SERVICES LIMITED",
"AJCON INFRA PROJECTS PRIVATE LIMITED",
"AJD DEVELOPERS PRIVATE LIMITED",
"AJD ENGINEERING PRIVATE LIMITED",
"AJD MOTORS PRIVATE LIMITED",
"AJD RESORTS AND HOTELS PRIVATE LIMITED",
"AJDISTI INDIA PRIVATE LIMITED",
"AJE INDIA PRIVATE LIMITED",
"AJE MERCANTILE PRIVATE LIMITED",
"AJEENKYA D Y PATIL UNIVERSITY",
"AJEENKYA DY PATIL UNIVERSITY",
"AJEET IMPEX PRIVATE LIMITED",
"AJEET SEEDS PRIVATE LIMITED",
"AJEET SINGH LOGISTIC PRIVATE LIMITED",
"AJEET TRADERLINK PRIVATE LIMITED",
"AJEL LIMITED",
"AJENTA CHEMICALS ( INDIA) LIMITED",
"AJESH BUILDERS & DEVELOPERS PRIVATE LIMITED",
"AJEY & SONS OILS MADRAS PRIVATE LIMITED",
"AJFAN DATES AND NUTS PRIVATE LIMITED",
"AJHURAY INTER MEEDIET COLLEGE",
"AJI INTERNATIONAL PRIVATE LIMITED",
"AJIBAN CONSTRUCTION PRIVATE LIMITED",
"AJINKYA CHEMTECH PRIVATE LIMITED",
"AJINKYA ELECTROMELT PRIVATE LIMITED",
"AJINKYA INDUSTRIAL SUPPLIERS PRIVATE LIMITED",
"AJINKYA INVESTMENT AND TRADING COMPANY",
"AJINKYA MARINE PRIVATE LIMITED",
"AJINKYA MERCANTILE PRIVATE LIMITED",
"AJINKYA MILK PROCESSING LIMITED",
"AJINKYA SEEDS PRIVATE LIMITED",
"AJINKYATARA CO-OPERATIVE SUGAR FACTORY LTD",
"AJINKYATARA GRAINS PRODUCER COMPANY LIMITED",
"AJINKYATARA MULTISPECIALITY HOSPITAL PRIVATE LIMITED",
"AJINOMOTO BIO-PHARMA SERVICES INDIA PRIVATE LIMITED",
"AJINOMOTO INDIA PRIVATE LIMITED",
"AJINTHA INDUSTRIES PRIVATE LIMITED",
"AJIRA SOFTWARE INDIA PRIVATE LIMITED",
"AJIT BHAWAN",
"AJIT COATINGS PRIVATE LIMITED",
"AJIT DADA PAWAR COLLEGE OF POLYTECHNIC",
"AJIT DADA URDU HIGH SCHOOL",
"AJIT GLAFA INDIA PRIVATE LIMITED",
"AJIT INDIA (HYDERABAD) PVT LTD",
"AJIT INDIA ENTERPRISES RS GHUMMAN GROUP ENTITY",
"AJIT INDUSTRIES PRIVATE LIMITED",
"AJIT KADAMS DENTAL CLINIC",
"AJIT MARBLES PVT LTD",
"AJIT OPTICIANS PRIVATE LIMITED",
"AJIT POLYPLAST PRIVATE LIMITED",
"AJIT POWER SOLUTIONS PRIVATE LIMITED",
"AJIT RICE MILL PVT LTD",
"AJIT SCANNING AND DIAGNOSTIC CENTRE PVT.LTD.",
"AJIT SHEETS INDIA PRIVATE LIMITED",
"AJIT SINGH OM PARKASH PRIVATE LIMITED",
"AJIT TECHNOPLAST PRIVATE LIMITED",
"AJIT TELECOM AND INFRASTRUCTURE PRIVATE LIMITED",
"AJIT TYRES PRIVATE LIMITED",
"AJIT WINDOWS PRIVATE LIMITED",
"AJITA SIL-CHEM PRIVATE LIMITED",
"AJITEK TECH SOLUTIONS PRIVATE LIMITED",
"AJITESH ELECTRICALS PRIVATE LIMITED",
"AJITGARH ENGINEERING CONSULTANTS PRIVATE LIMITED",
"AJITNATH EXPORTS PRIVATE LIMITED",
"AJITNATH MERCHANTS PRIVATE LIMITED",
"AJITNATH TRAVELS PRIVATE LIMITED",
"AJIVEENA EXPORTS LIMITED",
"AJIVIKA FINANCE LIMITED",
"AJJANYA HANDICRAFTS INDIA PRIVATE LIMITED",
"AJJREE ENGINEERING INDUSTRIESS PRIVATE LIMITED",
"AJJRI METALLICS PRIVATE LIMITED",
"AJK FORGE PRIVATE LIMITED",
"AJM BUILDWELL PRIVATE LIMITED",
"AJMAL BIOTECH PRIVATE LIMITED",
"AJMAL ESTATES AND PROPERTIES PRIVATE LIMITED",
"AJMAL FOUNDATION",
"AJMAL FRAGRANCES AND FASHIONS PRIVATE LIMITED",
"AJMANI ASSOCIATES ENGINEERING PRIVATE LIMITED",
"AJMANI FLOUR MILLS PRIVATE LIMITED",
"AJMANI INFRASTRUCTURE AND PROJECTS PRIVATE LIMITED",
"AJMANI MILL STORES PRIVATE LIMITED",
"AJMER AGRO PRODUCTS PRIVATE. LIMITED.",
"AJMER AUTO AGENCIES PRIVATE LIMITED",
"AJMER AUTOMOBILES PRIVATE LIMITED",
"AJMER DAIRY",
"AJMER FOOD INDUSTRIES PRIVATE LIMITED",
"AJMER FOOD PRODUCTS PRIVATE LIMITED",
"AJMER FOOTWEAR PRIVATE LIMITED",
"AJMER INDUSTRIAL GASES PRIVATE LIMITED",
"AJMER MARBLES P LTD",
"AJMER PROTEINS AND CHEMICALS PRIVATE LIMITED",
"AJMER THERMOTECH PRIVATE LIMITED",
"AJMER TRADE & INDUSTRIES PRIVATE LIMITED",
"AJMER VIDYUT VITRAN NIGAM LIMITED",
"AJMERA ASSOCIATES LIMITED",
"AJMERA INFOTECH PRIVATE LIMITED",
"AJMERA ISPAT PRIVATE LIMITED",
"AJMERA MARBLES & TILES PVT LTD",
"AJMERA METALS (INDORE) PRIVATE LIMITED",
"AJMERA PAPER PRIVATE LIMITED",
"AJMERA PHARMACEUTICALS PVT LTD",
"AJMERA PHARMASURE LIMITED",
"AJMERA REALTY & INFRA INDIA LIMITED",
"AJMERA RETAIL PRIVATE LIMITED",
"AJMERA STEELS PVT LTD",
"AJMERA TYRES PRIVATE LIMITED",
"AJMI FLOUR MILLS (INDIA) PRIVATE LIMITED",
"AJMIR TOWER PRIVATE LIMITED",
"AJMR MARKETING PRIVATE LIMITED",
"AJN METALS PRIVATE LIMITED",
"AJNAR AGROFOOD PROCESSING PRIVATE LIMITED",
"AJNARA INFRASTRUCTURE LIMITED",
"AJNARA REALTECH LIMITED",
"AJNASYS TECH SOLUTIONS PRIVATE LIMITED",
"AJNI INDUSTRIES PRIVATE LIMITED",
"AJOITE TECHNOLOGY PRIVATE LIMITED",
"AJOLA PRINTWELL PAPERS PVT LTD",
"AJOONI BIOTECH LIMITED",
"AJOONI BIOTECH PRIVATE LIMITED",
"AJORAS EXPORRTS PRIVATE LIMITED",
"AJOSH INFRAPROJECT LIMITED",
"AJOSHA BIOTEKNIK PRIVATE LIMITED",
"AJR INFO SYSTEMS PRIVATE LIMITED",
"AJR OIL & GAS ENGINEERING SERVICES PRIVATE LIMITED",
"AJRAMAR FASHIONS PRIVATE LIMITED",
"AJRI HEAVY ENGINEERING WORKS PRIVATE LIMITED",
"AJRN PRIVATE LIMITED",
"AJRO DEAL PRIVATE LIMITED",
"AJRR HOLDINGS PRIVATE LIMITED",
"AJRS TIMBERS AND FURNITURES PRIVATE LIMITED",
"AJS AUTO PRODUCTS PRIVATE LIMITED",
"AJS IMPEX PRIVATE. LIMITED.",
"AJS MANAGEMENT SERVICES PRIVATE LIMITED",
"AJS SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"AJSG MOTORS PRIVATE LIMITED",
"AJSH & CO LLP",
"AJSOFT COMPUTERS PRIVATE LIMITED",
"AJSP MANAGEMENT PRIVATE LIMITED",
"AJU RYOKAN NCR PRIVATE LIMITED",
"AJU TECH PRIVATE LIMITED",
"AJUBA RESIDENCY",
"AJUNI ENTERPRISES PRIVATE LIMITED",
"AJUNI MANAGEMENT PRIVATE LIMITED",
"AJURA SEEDS PRIVATE LIMITED",
"AJUS ELECTRIC PRIVATE LIMITED",
"AJVICK EXPORTS PRIVATE LIMITED",
"AJVIN INFOTECH PRIVATE LIMITED",
"AJW EXPRESS SERVICE PRIVATE LIMITED",
"AJWA FUN WORLD AND RESORT LIMITED",
"AJWA KAIF PRIVATE LIMITED",
"AJWA PROJECTS PRIVATE LIMITED",
"AJWANI EYE HOSPITAL",
"AJWANI INFRASTRUCTURE PRIVATE LIMITED",
"AJWIN CONSULTING SOLUTIONS PRIVATE LIMITED",
"AJY TECH INDIA PRIVATE LIMITED",
"AK & AK SOIL ENTERPRISES PRIVATE LIMITED",
"AK AEROTEK SOFTWARE CENTRE PRIVATE LIMITED",
"AK AGRO FOODS PROCESSING PRIVATE LIMITED",
"AK AUTO ELECTRIC SYSTEMS (INDIA) PRIVATE LIMITED",
"AK AUTO PUMP TECHNOLOGIES INDIA PRIVATE LIMITED",
"AK BUILDTRADE PRIVATE LIMITED",
"AK CHOUDHARY METALS PRIVATE LIMITED",
"AK CLEARING AGENCY",
"AK FILM PRODUCTIONS PRIVATE LIMITED",
"AK FUEL INDUSTRIES PRIVATE LIMITED",
"AK GANDHI AUTO PRIVATE LIMITED",
"AK GHOSH AND SONS INFRASTRUCTURE PRIVATE LIMITED",
"AK HEALTH QUOTIENT INDIA PRIVATE LIMITED",
"AK HEALTH TECH PRIVATE LIMITED",
"AK INFOPARK PRIVATE LIMITED",
"AK INFRA & REALITY DEVELOPERS PRIVATE LIMITED",
"AK INFRA ENGINEERING PRIVATE LIMITED",
"AK INTERICONS PRIVATE LIMITED",
"AK INTERIORS DESIGNING PRIVATE LIMITED",
"AK MEDICAL TECHNOLOGY PRIVATE LIMITED",
"AK NAVJEEVAN WOMENS COLLEGE",
"AK NOVA LIFESCIENCES PRIVATE LIMITED",
"AK PHARMACEUTICALS PRIVATE LIMITED",
"AK RAPOLU THEOREM PRIVATE LIMITED",
"AK SEALING SYSTEMS PRIVATE LIMITED",
"AK STEEL HOLDING CORPORATION",
"AK SYSTEMS INDIA PRIVATE LIMITED",
"AK TRANSCHARGER PRIVATE LIMITED",
"AK TUTORIAL SERVICES PRIVATE LIMITED",
"AKA CONSULTANTS (INDIA) PRIVATE LIMITED",
"AKA LOGISTICS PRIVATE LIMITED",
"AKAAISH MECHATRONICS LIMITED",
"AKAANKSHA CREDIT & LEASING PRIVATE LIMITED",
"AKAAR FOUNDERS PRIVATE LIMITED",
"AKAASH BELTING PVT LTD",
"AKAASH THE SCHOOL",
"AKAASHJYOTI TECHNO PRIVATE LIMITED",
"AKAG CONSULTING PRIVATE LIMITED",
"AKAISHA COMMERCIAL PRIVATE LIMITED",
"AKAK HEALTHCARE PRIVATE LIMITED",
"AKAK ISPAT UDYOG PRIVATE LIMITED",
"AKAL ACADEMY BARU SAHIB",
"AKAL ACADEMY JAWAHRKE",
"AKAL FASHIONS AND DESIGNERS PRIVATE LIMITED",
"AKAL INFORMATION SYSTEMS LIMITED",
"AKAL LOGISTIC (INDIA) PRIVATE LIMITED",
"AKAL PIPES PRIVATE LIMITED",
"AKAL SAHAI ACADEMY",
"AKAL SALES PRIVATE LIMITED",
"AKAL SPRING LTD",
"AKALTECH INFRALOGIS PRIVATE LIMITED",
"AKALYA SHIPPING PRIVATE LIMITED",
"AKAMAI INDIA NETWORKS PRIVATE LIMITED",
"AKAMAI TECHNOLOGIES INDIA PRIVATE LIMITED",
"AKAMAI TECHNOLOGIES SOLUTIONS INDIA PRIVATE LIMITED",
"AKANA TECHNOLOGIES PRIVATE LIMITED",
"AKANI ISPAT PRIVATE LIMITED",
"AKANKSHA AGENCIES PVT. LTD",
"AKANKSHA AUTOMOBILES PRIVATE LIMITED",
"AKANKSHA AUTOMOBILES RUDRAPUR PRIVATE LIMITED",
"AKANKSHA AUTOWHEELS PRIVATE LIMITED",
"AKANKSHA AUTOZONE PRIVATE LIMITED",
"AKANKSHA CONTRACTS PRIVATE LIMITED",
"AKANKSHA FOODS PRIVATE LIMITED",
"AKANKSHA GLOBAL LOGISTICS PRIVATE LIMITED",
"AKANKSHA HOSPITAL PRIVATE LIMITED",
"AKANKSHA INFRACOM PRIVATE LIMITED",
"AKANKSHA INTERNATIONAL PRIVATE LIMITED",
"AKANKSHA PLAST-N-PRINT PRIVATE LIMITED",
"AKANKSHA POWER AND INFRASTRUCTURE LIMITED",
"AKANKSHA POWER AND INFRASTRUCTURE PRIVATE LIMITED",
"AKANKSHA SALES PROMOTERS INDIA PRIVATE. LIMITED.",
"AKANSHA (INDIA) ENTRADE PRIVATE LIMITED",
"AKANSHA AVIATION SERVICES PRIVATE LIMITED",
"AKANSHA EDUCARE PRIVATE LIMITED",
"AKANSHA HALLMARK CENTRE PRIVATE LIMITED",
"AKANSHA ISPAT PRIVATE LIMITED",
"AKANSHA JEWEL EXPORT PRIVATE LIMITED",
"AKANSHA MEDICARE PRIVATE LIMITED",
"AKANSHA POWER ENERGY PRIVATE LIMITED",
"AKANSHA SHIPBREAKING PRIVATE LIMITED",
"AKANSHI ENTERPRISES PRIVATE LIMITED",
"AKAR ADVERTISING AND MARKETING PVT LTD",
"AKAR AUTO INDUSTRIES LIMITED",
"AKAR CARS PRIVATE LIMITED",
"AKAR CREATIONS PRIVATE LIMITED",
"AKAR EVENTS PRIVATE LIMITED",
"AKAR FOURWHEEL PRIVATE LIMITED",
"AKAR INDUSTRIES PRIVATE LIMITED",
"AKAR INFO-MEDIA PRIVATE LIMITED",
"AKAR LABELS PRIVATE LIMITED",
"AKAR LIMITED",
"AKAR PACKERS PVT LTD",
"AKARA ART INDIA PRIVATE LIMITED",
"AKARA CAPITAL ADVISORS PRIVATE LIMITED",
"AKARA RESEARCH & TECHNOLOGIES PRIVATE LIMITED",
"AKARSH AUTO PRIVATE LIMITED",
"AKARSH BUSINESS CONSULTING PRIVATE LIMITED",
"AKARSH DAIRY PRIVATE LIMITED",
"AKARSH DEEPA CHITS INDIA PRIVATE LIMITED",
"AKARSH DIAMOND & JEWELLERY PRIVATE LIMITED",
"AKARSH MARKETING PRIVATE LIMITED",
"AKARSH PAINT PRIVATE LIMITED",
"AKARSHA REALTY PRIVATE LIMITED",
"AKARSHAK INFRASTRUCTURE PRIVATE LIMITED",
"AKARUI NETWORKS PRIVATE LIMITED",
"AKARUI SOLUTIONS LLP",
"AKARUILABS INDIA PRIVATE LIMITED",
"AKAS MEDICAL EQUIPMENT",
"AKASA CLEAN ENERGY PRIVATE LIMITED",
"AKASA FINANCE LIMITED",
"AKASA SECURITIES & FINANCIAL SERVICES PRIVATE LIMITED",
"AKASAKA ELECTRONICS LIMITED",
"AKASAM CONSULTING PRIVATE LIMITED",
"AKASANDRA CONSULTANTS PRIVATE LIMITED",
"AKASH AGRO INDUSTRIES LIMITED",
"AKASH BISCUITS PVT LTD",
"AKASH CARS PRIVATE LIMITED",
"AKASH CERAMICS PRIVATE LIMITED",
"AKASH COKE INDUSTRIES PRIVATE LIMITED",
"AKASH COLONISERS INDIA PRIVATE LIMITED",
"AKASH COMBINES LIMITED",
"AKASH COTEX",
"AKASH DEVELOPERS PRIVATE LIMITED",
"AKASH DHINGRA SALES PRIVATE LIMITED",
"AKASH DYEING AND PRINTING MILLS PRIVATE LIMITED",
"AKASH ENGIMECH (INDIA) PRIVATE LIMITED",
"AKASH ENGINEERING ASSOCIATES PRIVATE LIMITED",
"AKASH ENTERPRISES",
"AKASH EXPORTS INTERNATIONAL PRIVATE LIMITED",
"AKASH EXTRUSIONS PRIVATE LIMITED",
"AKASH FASHION PRINTS PRIVATE LIMITED",
"AKASH FEEDS & CHICKS PRIVATE LIMITED",
"AKASH FISHMEAL & FISHOIL PRIVATE LIMITED",
"AKASH FOOTWEAR PRIVATE LIMITED",
"AKASH GANGA COURIER LIMITED",
"AKASH GANGA ELECTRICALS PRIVATE LIMITED",
"AKASH GANGA PORTFOLIOS PRIVATE LIMITED",
"AKASH GANGA RICE MILLS PRIVATE LIMITED",
"AKASH GANGA SUPPLY CHAIN LIMITED",
"AKASH GEMS PRIVATE LIMITED",
"AKASH GRANIMARBO PRIVATE LIMITED",
"AKASH H C ENTERPRISES",
"AKASH HI-TECH INDUSTRIES PRIVATE LIMITED",
"AKASH HOTELS PRIVATE LIMITED",
"AKASH INFRA ENTERPRISES PRIVATE LIMITED",
"AKASH INFRA-CON PROJECTS PRIVATE LIMITED",
"AKASH INFRA-PROJECTS LIMITED",
"AKASH ISPAT PRIVATE LIMITED",
"AKASH METALS PRIVATE LTD",
"AKASH NATURE RESORTS PRIVATE LIMITED",
"AKASH OIL & COTTON FACTORY",
"AKASH PACKTECH PRIVATE LIMITED",
"AKASH PETROLEUM PRIVATE LIMITED",
"AKASH POULTRY PRIVATE LIMITED",
"AKASH PRECISION COMPONENTS PRIVATE LIMITED",
"AKASH RECOVERY SERVICES PRIVATE LIMITED",
"AKASH RICE & AGRO INDUSTRIES PRIVATE LIMITED",
"AKASH ROADLINES PRIVATE LIMITED",
"AKASH SPAREPARTS PRIVATE LIMITED",
"AKASH STEEL CRAFTS PRIVATE. LIMITED.",
"AKASH TECHNO ENGINEERS INDIA PRIVATE LIMITED",
"AKASH TORI INFOCOM SERVICES PRIVATE LIMITED",
"AKASH TOURISM & RESORTS PRIVATE LIMITED",
"AKASH TRADER",
"AKASH TRADERS",
"AKASH VANIJYA PVT LTD",
"AKASH VINTRADE PRIVATE LIMITED",
"AKASHAR ENGINEERING SOLUTION",
"AKASHDEEP COLD STORAGE PRIVATE LIMITED",
"AKASHDEEP GLASS INDUSTRIES PVT LTD",
"AKASHDEEP PAPERS PRIVATE LIMITED",
"AKASHDOOT VAYAPAR PVT LTD",
"AKASHGANGA BROILER BREEDING FARM PRIVATE LIMITED",
"AKASHGANGA CARGO MOVERS PRIVATE LIMITED",
"AKASHGANGA CONSTRUCTIONAL MACHINES PRIVATE LIMITED",
"AKASHGANGA INFRAVENTURES INDIA PRIVATE LIMITED",
"AKASHGANGA MOTORS PRIVATE LIMITED",
"AKASHGANGA PROCESSORS PRIVATE LIMITED",
"AKASHICHEM PRIVATE LIMITED",
"AKASHNA GLOBAL STEEL PRIVATE LIMITED",
"AKASHYOG HEALTH PRODUCTS PRIVATE LIMITED",
"AKASIA MAGNUM HOSPITALITY PRIVATE LIMITED",
"AKATVA INFRASTRUCTURE PRIVATE LIMITED",
"AKAY CONSUMER CARE LLP",
"AKAY FASTENERS PRIVATE LIMITED",
"AKAY FILTIPS PRIVATE LIMITED",
"AKAY FOOTWEAR PRIVATE LIMITED",
"AKAY INDUSTRIES PRIVATE LIMITED",
"AKAY NATURAL INGREDIENTS PRIVATE LIMITED",
"AKAY SPICES PRIVATE LIMITED",
"AKB INDUSTRIES LIMITED",
"AKB VENTURES PRIVATE LIMITED",
"AKBAR CORPORATION LIMITED",
"AKBAR EXPRESS CARGO PRIVATE LIMITED",
"AKBAR HOLIDAYS PRIVATE LIMITED",
"AKBAR OFFSHORE PRIVATE LIMITED",
"AKBAR ONLINE BOOKING COMPANY PRIVATE LIMITED",
"AKBAR TRAVELS OF INDIA PRIVATE LIMITED",
"AKBERALI PRECAST PRIVATE LIMITED",
"AKBS COMPUTERS PRIVATE LIMITED",
"AKC AUTO PRIVATE LIMITED",
"AKC CARGO MANAGEMENT SERVICES PRIVATE LIMITED",
"AKC DATA SYSTEMS I PRIVATE LIMITED",
"AKC FINSERV PRIVATE LIMITED",
"AKC MOTORS PRIVATE LIMITED",
"AKC UMBRELLA PRIVATE LIMITED",
"AKCENT HEALTHCARE INDIA PRIVATE LIMITED",
"AKCONSIS PRIVATE LIMITED",
"AKCROS TRADELINK PRIVATE LIMITED",
"AKD FOREX PRIVATE LIMITED",
"AKD HOLDING PRIVATE LIMITED",
"AKD HOSPITALITY PRIVATE LIMITED",
"AKE ENGINEERS PRIVATE LIMITED",
"AKE EXPORTER PRIVATE LIMITED",
"AKEBONO CREDIT SERVICES PRIVATE LIMITED",
"AKEBONO SOFT TECHNOLOGIES PRIVATE LIMITED",
"AKEEN R IMPEX PRIVATE LIMITED",
"AKEIA HEALTHCARE PRIVATE LIMITED",
"AKEMI BUSINESS SCHOOL",
"AKEMI TECHNOLOGY INDIA PRIVATE LIMITED",
"AKEO SOFTWARE SOLUTIONS PRIVATE LIMITED",
"AKER BIOMARINE INDIA PRIVATE LIMITED",
"AKER POWERGAS PRIVATE LIMITED",
"AKER POWERGAS SUBSEA PRIVATE LIMITED",
"AKER SOLUTIONS INDIA SDN.BHD",
"AKESISS PHARMA PRIVATE LIMITED",
"AKF PLANTSCIENCES PRIVATE LIMITED",
"AKFA HOSPITAL",
"AKG BUILDING CONSULTANTS PRIVATE LIMITED",
"AKG EXTRUSIONS PRIVATE LIMITED",
"AKG FINVEST PRIVATE LIMITED",
"AKG INDIA PRIVATE LIMITED",
"AKG MEDICARE SERVICES PRIVATE LIMITED",
"AKG PACKERS PRIVATE LIMITED",
"AKG PLASTICS PRIVATE. LIMITED",
"AKG POWER CARE PRIVATE LIMITED",
"AKG SHUTTERINGS PRIVATE LIMITED",
"AKG TECHNICAL PRIVATE LIMITED",
"AKGEC SKILLS FOUNDATION",
"AKH INFRACON PRIVATE LIMITED",
"AKHAND AGRICOM PRIVATE LIMITED",
"AKHAND ANAND HOLDINGS PVT LTD",
"AKHAND BHARAT SENIOR SECODARY SCHOOL THANAGAZI",
"AKHAND DISTRIBUTORS PRIVATE LIMITED",
"AKHANDA SEVA FOR INTERNATIONAL SHANTI",
"AKHANDALAMANI ELECTRICALS & CONSTRUCTION",
"AKHANDJYOTI FABTEX LIMITED",
"AKHBAR-E-MASHRIQ PRIVATE LIMITED",
"AKHIL BEACH RESORT PRIVATE LIMITED",
"AKHIL CHANDRA CONSTRUCTION COMPANY PRIVATE LIMITED",
"AKHIL FOOD FACILITY MANAGEMENT PRIVATE LIMITED",
"AKHIL HEALTHCARE PRIVATE LIMITED",
"AKHIL INDIA PRIVATE LIMITED",
"AKHIL INFRA PROJECTS PRIVATE LIMITED",
"AKHIL ISPAT PRIVATE LIMITED",
"AKHIL LOGISTICS PRIVATE LIMITED",
"AKHIL OVERSEAS PRIVATE LIMITED",
"AKHIL PALACE HOTELS PRIVATE LIMITED",
"AKHIL RETAIL PRIVATE LIMITED",
"AKHIL RIBBONS PRIVATE LIMITED",
"AKHIL SHIP BREAKERS PRIVATE LIMITED",
"AKHIL SYSTEMS PRIVATE LIMITED",
"AKHIL WIRES PRIVATE LIMITED",
"AKHILAGYA SOLAR ENERGY PRIVATE LIMITED",
"AKHILANDESHWARI CARBON GAS PRIVATE LIMITED",
"AKHILESH INFRASTRUCTURES PRIVATE LIMITED",
"AKHILESH KUMAR SINGH HOSPITAL PRIVATE LIMITED",
"AKHILESH LEFIN PRIVATE LIMITED",
"AKHILESH LOHISPAT PRIVATE LIMITED",
"AKHILESH MOTORCYCLE PRIVATE LIMITED",
"AKHILESHWAR BUILDERS PRIVATE LIMITED",
"AKHILESHWAR PROPERTIES LIMITED",
"AKHIN ALUMINIUM PRIVATE LIMITED",
"AKHINITI INFRA PRIVATE LIMITED",
"AKHINTA ENTERPRISES PRIVATE LIMITED",
"AKHNOOR HOTELS PRIVATE LIMITED",
"AKHTARI AGRO INDUSTRIES PRIVATE LIMITED",
"AKHYAR ESTATE HOLDINGS PRIVATE LIMITED",
"AKI INDIA LIMITED",
"AKI INDUSTRIAL ENGINEERS PRIVATE LIMITED",
"AKIKO GLOBAL SERVICES LIMITED",
"AKIKO GLOBAL SERVICES PRIVATE LIMITED",
"AKILA TRADING PRIVATE LIMITED",
"AKIMAYA ENERGY SERVICES PRIVATE LIMITED",
"AKIN CHEMICALS PRIVATE LIMITED",
"AKIN LABORATORIES PVT LTD",
"AKINA BUILDERS & DEVELOPERS PRIVATE LIMITED",
"AKIRA ACADEMY FOR LEARNING PRIVATE LIMITED",
"AKIRA ANALYTICAL SOLUTIONS PRIVATE LIMITED",
"AKIRA CONSULTANCY PRIVATE LIMITED",
"AKIRA PHARMA PRIVATE LIMITED",
"AKIRA PRODUCTIONS PRIVATE LIMITED",
"AKIRA PROJECTS PRIVATE LIMITED",
"AKIRHS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"AKITA ENTERPRISES PRIVATE LIMITED",
"AKITA GEAR INDIA PRIVATE LIMITED",
"AKITEX FABRICS PRIVATE LIMITED",
"AKITI'S AGRI TECH PRIVATE LIMITED",
"AKJ ENGINEERS PRIVATE LIMITED",
"AKJ ENTERPRISES PRIVATE LIMITED",
"AKJ FINCAP LIMITED",
"AKJ INDUSTRIES PRIVATE LIMITED",
"AKJ METALS PRIVATE LIMITED",
"AKJA EXIM PRIVATE LIMITED",
"AKKADAVALLI ENTERPRISES PRIVATE LIMITED",
"AKKAM OVERSEAS SERVICES PRIVATE LIMITED",
"AKKAVILA K LEKSHMANAN & COMPANY",
"AKKEN TECHNOLOGIES PRIVATE LIMITED",
"AKKIHAL COLLEGE OF COMMERCE",
"AKKOMPLISH CONSULTING PRIVATE LIMITED",
"AKKU MARKETING PRIVATE LIMITED",
"AKLAVYA INDUSTRIES PRIVATE LIMITED",
"AKLEM PHARMA",
"AKLIMA PROPERTIES PRIVATE LIMITED",
"AKM AGRO PROCESSING PRIVATE LIMITED",
"AKM CREATIONS LIMITED",
"AKM ENTERPRISES PRIVATE LIMITED",
"AKM GLOBAL CORPORATE ADVISORS",
"AKM MOTORS PRIVATE LIMITED",
"AKMAN WELLNESS PRIVATE LIMITED",
"AKMB PROJECTS PRIVATE LIMITED",
"AKME AUTOMOBILES PRIVATE LIMITED",
"AKME BUILD ESTATE LIMITED",
"AKME BUILDMART PRIVATE LIMITED",
"AKME CARDS PRIVATE LIMITED",
"AKME FINTRADE (INDIA) LIMITED",
"AKME INDIA LINKS PRIVATE LIMITED",
"AKMIN TECHNOLOGIES PRIVATE LIMITED",
"AKMY BUILDCON PRIVATE LIMITED",
"AKN DEVELOPERS PRIVATE LIMITED",
"AKN FASHIONS PRIVATE LIMITED",
"AKNA MEDICAL PRIVATE LIMITED",
"AKNAM FINVEST PRIVATE LIMITED",
"AKNG STEELS PRIVATE LIMITED",
"AKOGNOS LIFE SCIENCES PRIVATE LIMITED",
"AKOLA CHEMICALS (INDIA) PRIVATE LIMITED",
"AKOLA CITY HEALTH CARE PRIVATE LIMITED",
"AKOLA LIFE SUPPORT PRIVATE LIMITED",
"AKOLA MAHANAGARPALIKA AKOLA",
"AKOLITE INDUSTRIAL SYSTEMS PRIVATE LIMITED",
"AKOM TECHNOLOGIES PRIVATE LIMITED",
"AKOMKAR ALLOYS PRIVATE LIMITED",
"AKON ELECTRONICS INDIA PRIVATE LIMITED",
"AKON FIN ADVISORS PRIVATE LIMITED",
"AKONA ENGINEERING PRIVATE LIMITED",
"AKOONS LIFE SCIENCES PRIVATE LIMITED",
"AKORBI WORKFORCE SOLUTIONS PRIVATE LIMITED",
"AKORE PLAST INDIA PRIVATE LIMITED",
"AKOS KEM PRIVATE LIMITED",
"AKOT AGRO PRODUCER COMPANY LIMITED",
"AKOUNTO SERVICES PRIVATE LIMITED",
"AKOYA MOTORS PRIVATE LIMITED",
"AKP HEALTHCARE PRIVATE LIMITED",
"AKP INFRA PRIVATE LIMITED",
"AKP POWERTECH PRIVATE LIMITED",
"AKP PROJECTS PRIVATE LIMITED",
"AKP TECHNOLOGIES INDIA PRIVATE LIMITED",
"AKPASH PHARMACEUTICALS PRIVATE LIMITED",
"AKPS AUTO ACCESSORIES PRIVATE LIMITED",
"AKPS INFOTECH SERVICES PRIVATE LIMITED",
"AKQA MEDIA INDIA PRIVATE LIMITED",
"AKR ACADEMY SCHOOL",
"AKR COTSPIN PRIVATE LIMITED",
"AKR EXPRESS PRIVATE LIMITED",
"AKR HOTELS AND RESTAURANTS PRIVATE LIMITED",
"AKR INDUSTRIES PRIVATE LIMITED",
"AKR INFRA PROJECTS PRIVATE LIMITED",
"AKR INFRA SERVICES",
"AKR LOGISTICS (INDIA) PRIVATE LIMITED",
"AKR SOURCING PRIVATE LIMITED",
"AKRA GIRLS HIGH MADRASHA HS",
"AKRANO LIFE SCIENCES PRIVATE LIMITED",
"AKRAS FLAVOURS INDIA PRIVATE LIMITED",
"AKRATI TECHNIMONT LIMITED",
"AKRAYA SOLUTIONS PRIVATE LIMITED",
"AKREETA INFRA PRIVATE LIMITED",
"AKRG COLLEGE OF PHARMACY",
"AKRIBIZ BUSINESS SOLUTIONS PRIVATE LIMITED",
"AKRIDATA INDIA PRIVATE LIMITED",
"AKRITI ADCOMM PRIVATE LIMITED",
"AKRITI APPARELS PRIVATE LIMITED",
"AKRITI COAL PRIVATE LIMITED",
"AKRITI CREATIONS PRIVATE LIMITED",
"AKRITI CREATIONS PVT LTD",
"AKRITI FINANCE PRIVATE LIMITED",
"AKRITI GUPTA JEWELLERS PRIVATE LIMITED",
"AKRITI JEWELCRAFTZ PRIVATE LIMITED",
"AKRITI PHARMACEUTICALS PRIVATE LIMITED",
"AKRITI RESOURCES PRIVATE LIMITED",
"AKRITI TAPES AND PACKAGING INDIA PRIVATE LIMITED",
"AKRIVEIA LABORATORIES PRIVATE LIMITED",
"AKRIVIA AUTOMATION PRIVATE LIMITED",
"AKRIVIS PACKAGING PRIVATE LIMITED",
"AKRK TECHNOLOGIES PRIVATE LIMITED",
"AKRODEEP AGRO PRIVATE LIMITED",
"AKRON CROWDSOURCE MANAGEMENT PRIVATE LIMITED",
"AKRON ENERGY PRIVATE LIMITED",
"AKRON PARENTARALS PRIVATE LIMITED",
"AKROOR INT COLL CHHATA MATHURA",
"AKROS TRADING INDIA PRIVATE LIMITED",
"AKROSH CONSULTANTS PRIVATE LIMITED",
"AKROSS COATINGS PRIVATE LIMITED",
"AKROSS SYNTHETICS PVT LTD",
"AKRUTI CITY LIMITED",
"AKRUTI DYEING AND PRINTING MILLS PVT LTD",
"AKRUTI KITCHENS & FURNITURE PRIVATE LIMITED",
"AKRUTI PRINT SOLUTIONS PRIVATE LIMITED",
"AKRUTI TRADVEST PRIVATE LIMITED",
"AKRY ORGANICS PRIVATE. LIMITED.",
"AKS ASSOCIATES PRIVATE LIMITED",
"AKS BEARINGS LTD",
"AKS BUILDERS PRIVATE LIMITED",
"AKS ENTERPRISES PRIVATE LIMITED",
"AKS EXIMTRADE AND SERVICES PRIVATE LIMITED",
"AKS EXPO-CHEM PRIVATE LIMITED",
"AKS HR SERVICES PRIVATE LIMITED",
"AKS INFORMATION TECHNOLOGY SERVICES PRIVATE LIMITED",
"AKS INFRA AND SERVICES PRIVATE LIMITED",
"AKS INTERACTIVE SOLUTIONS PRIVATE LIMITED",
"AKS JEWELS PRIVATE LIMITED",
"AKS LASER AND COSMETIC STUDIO PRIVATE LIMITED",
"AKS LEATHER INDIA (OPC) PRIVATE LIMITED",
"AKS LOGISTICS PRIVATE LIMITED",
"AKS MEDICAL & RESEARCH CENTRE PRIVATE LIMITED",
"AKS MEDICARE PRIVATE LIMITED",
"AKS UNIVERSAL MAGNETICS PRIVATE LIMITED",
"AKS UNIVERSITY SATNA",
"AKS WHEELS (INDIA) PRIVATE LIMITED",
"AKSA CONVERTEX STERILANTS PRIVATE LIMITED",
"AKSA INDUSTRIAL PROCESS CONTROLS PRIVATE LIMITED",
"AKSA IRON & COKE INDUSTRIES PRIVATE LIMITED",
"AKSA JEWELLERS PRIVATE LIMITED",
"AKSA PAPER MILLS PRIVATE LIMITED",
"AKSANA FASHION PRIVATE LIMITED",
"AKSAR MICRONS PRIVATE LIMITED",
"AKSAR WIRE PRODUCTS PRIVATE LIMITED",
"AKSARA MARKETING PRIVATE LIMITED",
"AKSCELLENCE INFO SOLUTIONS LLP",
"AKSENTT PROJECTS PRIVATE LIMITED",
"AKSENTT TECH SERVICES LIMITED",
"AKSH COMPOSITES PRIVATE LIMITED",
"AKSH ENGINEERING SYSTEMS PRIVATE LIMITED",
"AKSH MANUFACTURING PRIVATE LIMITED",
"AKSH OPTIFIBRE LIMITED",
"AKSH RESOURCES PRIVATE LIMITED",
"AKSH TRADERS PRIVATE LIMITED",
"AKSHAJ KNITTERS PRIVATE LIMITED",
"AKSHAMAALA SOLUTIONS PRIVATE LIMITED",
"AKSHAR AGENCIES ELECTRADE PRIVATE LIMITED",
"AKSHAR AIRCONDITIONING PRIVATE LIMITED",
"AKSHAR AQUACULTURE PRIVATE LIMITED",
"AKSHAR ARBOL INTERNATIONAL SCHOOL",
"AKSHAR CENTRE OF EDUCATION",
"AKSHAR COMMUNICATIONS PRIVATE LIMITED",
"AKSHAR DETERGENT PRIVATE LIMITED",
"AKSHAR ELECINFRA PRIVATE LIMITED",
"AKSHAR EMBRO EXIM PRIVATE LIMITED",
"AKSHAR EXIM COMPANY PRIVATE LIMITED",
"AKSHAR FABRICS PVT LTD",
"AKSHAR FIBRES PVT LTD",
"AKSHAR GRAVURES PRIVATE LIMITED",
"AKSHAR HOSPITAL",
"AKSHAR IMPEX PRIVATE LIMITED",
"AKSHAR ISPAT LIMITED",
"AKSHAR METALS PRIVATE LIMITED",
"AKSHAR MINE-CHEM PRIVATE LIMITED",
"AKSHAR NURSING COLLEGE MODASA",
"AKSHAR NX DIGITAL PRIVATE LIMITED",
"AKSHAR PLAST CHEM INVESTMENT PRIVATE LIMITED",
"AKSHAR PRECISION TUBES PRIVATE LIMITED",
"AKSHAR PRINTING & PACKAGING WORKS PRIVATE LIMITED",
"AKSHAR PROTEINS PRIVATE LIMITED",
"AKSHAR RISK CONSULTANCY PRIVATE LIMITED",
"AKSHAR SALES AND AUTOMATION PRIVATE LIMITED",
"AKSHAR SCHOOL SOLUTIONS PRIVATE LIMITED",
"AKSHAR SELECTION PRIVATE LIMITED",
"AKSHAR SHANTI REALTORS PRIVATE LIMITED",
"AKSHAR SPACE PRIVATE LIMITED",
"AKSHAR SPINTEX LIMITED",
"AKSHAR TELECOM PRIVATE LIMITED",
"AKSHAR TRAVELS PRIVATE LIMITED",
"AKSHARA AUTOMOTIVES PRIVATE LIMITED",
"AKSHARA CHIT FUNDS PRIVATE LIMITED",
"AKSHARA ENTERPRISES INDIA PRIVATE LIMITED",
"AKSHARA ENTERPRISES PRIVATE LIMITED.",
"AKSHARA FINSERV PRIVATE LIMITED",
"AKSHARA INDUSTRIES LIMITED",
"AKSHARA INDUSTRIES PRIVATE LIMITED",
"AKSHARA INFRA ESTATE PRIVATE LIMITED",
"AKSHARA INSTITUTE OF MANAGEMENT & TECHNOLOGY",
"AKSHARA INTERNATIONAL SCHOOL",
"AKSHARA JUNIOR COLLEGE",
"AKSHARA MILK PRODUCTS PRIVATE LIMITED",
"AKSHARA MOTO DREAMS PRIVATE LIMITED",
"AKSHARA MOTORS PRIVATE LIMITED",
"AKSHARA RESIDENTIAL SCHOOL",
"AKSHARA SPINNING MILLS PRIVATE LIMITED",
"AKSHARA SRIVIDYA PUBLIC SCHOOL",
"AKSHARA TEXFAB PRIVATE LIMITED",
"AKSHARA VIDYALAYA",
"AKSHARA VINIMAY PVT LTD",
"AKSHARAA CORPORATE SERVICES PRIVATE LIMITED",
"AKSHARAM PHARMA PRIVATE LIMITED",
"AKSHARASREE EDUCATIONAL INSTITUTIONS",
"AKSHARATEK SYSTEMS PRIVATE LIMITED",
"AKSHARCHEM INDIA LIMITED",
"AKSHARDHAM CENTRAL SCHOOL",
"AKSHARDHAM JEWELLERS PRIVATE LIMITED",
"AKSHARMURTI NUTS PRIVATE LIMITED",
"AKSHARVANI TRADERS PRIVATE LIMITED",
"AKSHAT AGRO MILLING COMPANY PRIVATE LIMITED",
"AKSHAT ALLOYS PRIVATE LIMITED",
"AKSHAT APARTMENTS PRIVATE LIMITED",
"AKSHAT AUTOLINE PRIVATE LIMITED",
"AKSHAT BIO MEDICALS PRIVATE LIMITED",
"AKSHAT COMMODITY LIMITED",
"AKSHAT COOLING TOWERS PRIVATE LIMITED",
"AKSHAT DEALCOM PRIVATE LIMITED",
"AKSHAT ENGINEERS PRIVATE LIMITED",
"AKSHAT FREIGHT CARRIERS PRIVATE LIMITED",
"AKSHAT FUELS PRIVATE LIMITED",
"AKSHAT GOLD PRIVATE LIMITED",
"AKSHAT INNOVATION INDIA PRIVATE LIMITED",
"AKSHAT INTERNATIONAL PRIVATE LIMITED",
"AKSHAT JAIN INVESTMENTS PRIVATE LIMITED",
"AKSHAT PAPERS LIMITED",
"AKSHAT PLASTICS PRIVATE. LIMITED.",
"AKSHAT ROLLER FLOUR MILLS PRIVATE LIMITED",
"AKSHAT TELECOM PRIVATE LIMITED",
"AKSHAT VINIMAY PRIVATE LIMITED",
"AKSHATA ENTERPRISES",
"AKSHAY BEARING LIMITED",
"AKSHAY BUILDPROP PRIVATE LIMITED",
"AKSHAY COMPONANTS PRIVATE LIMITED",
"AKSHAY CONTROLS AND SYSTEMS PRIVATE LIMITED",
"AKSHAY E COMMERCE TRADING PRIVATE LIMITED",
"AKSHAY EMBEDDED SYSTEMS PRIVATE LIMITED",
"AKSHAY EMINENCE DEVELOPERS PRIVATE LIMITED",
"AKSHAY ENTERPRISES PRIVATE LIMITED",
"AKSHAY ENVIRONCE PRIVATE LIMITED",
"AKSHAY FOOD IMPEX PRIVATE LIMITED",
"AKSHAY INFRANIRMAN PRIVATE LIMITED",
"AKSHAY INFRASTRUCTURE PRIVATE LIMITED",
"AKSHAY INFRASYS INDUSTRIES PRIVATE LIMITED",
"AKSHAY MILKDAIRY PRIVATE LIMITED",
"AKSHAY MULTITRADE PRIVATE LIMITED",
"AKSHAY NIDHI SYNTEX PRIVATE LIMITED",
"AKSHAY ORGANICS PRIVATE LTD",
"AKSHAY PAPERWASTE MARKETING PRIVATE LIMITED",
"AKSHAY PLASTOCHEM PRIVATE LIMITED",
"AKSHAY POLYFAB PRIVATE LIMITED",
"AKSHAY PRESSINGS PRIVATE LIMITED",
"AKSHAY PROFILES PRIVATE LIMITED",
"AKSHAY SEEDS PRIVATE LIMITED",
"AKSHAY SOFTWARE TECHNOLOGIES LIMITED",
"AKSHAY STEEL WORKS PVT. LTD.",
"AKSHAY STHAPATYA PRIVATE LIMITED",
"AKSHAY SUPERBIKE INDIA PRIVATE LIMITED",
"AKSHAY VANIJYA & FINANCE PRIVATE LIMITED",
"AKSHAYA ACADEMY CBSE SCHOOL",
"AKSHAYA AGRO FOOD PRIVATE LIMITED",
"AKSHAYA AGRO SALES PRIVATE LIMITED",
"AKSHAYA BUILDERS",
"AKSHAYA CARTONS AND BOARDS PRIVATE LIMITED",
"AKSHAYA COLLEGE OF ENGINEERING AND TECHNOLOGY",
"AKSHAYA CORPORATE SOLUTIONS PRIVATE LIMITED",
"AKSHAYA CUBE SYNERGIES PRIVATE LIMITED",
"AKSHAYA DIGINET CABLE VISION PRIVATE LIMITED",
"AKSHAYA ENGINEERING WORKS PRIVATE LIMITED",
"AKSHAYA INDIA TOURS & TRAVELS PRIVATE LIMITED",
"AKSHAYA INFRA CONSULTANTS PRIVATE LIMITED",
"AKSHAYA JEWELLERS PRIVATE LIMITED",
"AKSHAYA LEISURE PRIVATE LIMITED",
"AKSHAYA MEDICAL EQUIPMENT PRIVATE LIMITED",
"AKSHAYA PATRA FOUNDATION",
"AKSHAYA PRIVATE LIMITED",
"AKSHAYA REMEDIES PVT LTD",
"AKSHAYA RESORTS P LTD",
"AKSHAYA ROLL MILL PRIVATE LIMITED",
"AKSHAYA SCIENTIFICS PRIVATE LIMITED",
"AKSHAYA SERVICES PRIVATE LIMITED",
"AKSHAYA SOLAR POWER INDIA PRIVATE LIMITED",
"AKSHAYA WEALTH MANAGEMENT PRIVATE LIMITED",
"AKSHAYAA MULTI CLEANING SYSTEMS PRIVATE LIMITED",
"AKSHAYAKALPA FARMS AND FOODS PRIVATE LIMITED",
"AKSHAYALAKSHMI TRADING PRIVATE LIMITED",
"AKSHAY-DEEP TEXTILE PRIVATE LIMITED",
"AKSHAYKRISH JEWELLERS PRIVATE LIMITED",
"AKSHAYNIDHI STEELS PRIVATE LIMITED",
"AKSHAYPATRA UDYOG PRIVATE LIMITED",
"AKSHDEEP MARKETING PRIVATE LIMITED",
"AKSHERA PAPERS",
"AKSHERA YUVA NURSERY AND PRIMARY SCHOOL",
"AKSHI ENGINEERS PRIVATE LIMITED",
"AKSH-INFRASPACE PRIVATE LIMITED",
"AKSHIT ENTERPRISES PRIVATE LIMITED",
"AKSHIT INSTRUMENTS PRIVATE LIMITED",
"AKSHIT MELMOWARES PRIVATE LIMITED",
"AKSHIT PETROCHEM PRIVATE LIMITED",
"AKSHIT TRADELINK PRIVATE LIMITED",
"AKSHITA COMMERCIAL PRIVATE LIMITED",
"AKSHITA IT SOLUTION PRIVATE LIMITED",
"AKSHITA POLYMERS PRIVATE LIMITED",
"AKSHITA SRI AGRO FOODS PRIVATE LIMITED",
"AKSHKUBER SORTEX PRIVATE LIMITED",
"AKSHOBYA FOODS PRIVATE LIMITED",
"AKSHODAYA CHITS PRIVATE LIMITED",
"AKSHOY CREATION",
"AKSHYA CHEMICALS PRIVATE LIMITED",
"AKSHYAN POWER SOLUTIONS PRIVATE LIMITED",
"AKSI ATLANTIC HOSPITALITY MANAGEMENT PRIVATE LIMITED",
"AKSIGEN HOSPITAL CARE",
"AKSMD RECHARGEABLE VEHICLES PRIVATE LIMITED",
"AKSOCOL CHEMICALS PRIVATE LIMITED",
"AKSON OILTECH PRIVATE LIMITED",
"AKSS CONSULTING SERVICES PRIVATE LIMITED",
"AKSUNNA TECHNOLOGIES PRIVATE LIMITED",
"AKSUS TECHNOLOGY SERVICES PRIVATE LIMITED",
"AKT ACADEMY MATRICULATION HIGHER SECONDARY SCHOOL",
"AKT HEALTH ANALYTICS PRIVATE LIMITED",
"AKT INTERNATIONAL PRIVATE LIMITED",
"AKTA ENTERPRISES PRIVATE LIMITED",
"AKTINOS HEALTHCARE PRIVATE LIMITED",
"AKTINOS PHARMA PRIVATE LIMITED",
"AKTINSON HIGH SCHOOL",
"AKTION INTERIORS PRODUCT PRIVATE LIMITED",
"AKTION SAFETY SOLUTIONS PRIVATE LIMITED",
"AKTIQA SOFTWARE SOLUTIONS PRIVATE LIMITED",
"AKTIS ENGINEERING SOLUTIONS PRIVATE LIMITED",
"AKTIV SOFTWARE PRIVATE LIMITED",
"AKTIVORTHO PRIVATE LIMITED",
"AKKODIS INDIA PRIVATE LIMITED",
"AKTREA SOLUTIONS INDIA PRIVATE LIMITED",
"AKUATE INTERNET SERVICES PRIVATE LIMITED",
"AKUL DEVELOPERS",
"AKUL INDUSTRIES PRIVATE LIMITED",
"AKUL KRITHICK CHITS PRIVATE LIMITED",
"AKUL MANPOWER CONSULTING PRIVATE LIMITED",
"AKULA BOARDS LIMITED",
"AKULAKU ONLINE SERVICE PRIVATE LIMITED",
"AKUMENTIS HEALTHCARE LIMITED",
"AKUMS DRUGS AND PHARMACEUTICALS LIMITED",
"AKUMS FOUNDATION",
"AKUMS HEALTHCARE LIMITED",
"AKURATE MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"AKURATH BUILDWELL PRIVATE LIMITED",
"AKURATH STEELS PRIVATE LIMITED",
"AKUS LANDSMITHS & INFRASTRUCTURE PRIVATE LIMITED",
"AKV BRIGHT SOLUTIONS PRIVATE LIMITED",
"AKV ELECTRICAL ENGINEERING PRIVATE LIMITED",
"AKV EXIM (INDIA) PRIVATE LIMITED",
"AKV LOGISTICS PRIVATE LIMITED",
"AKVALO INSTRUMENTS PRIVATE LIMITED.",
"AKVARR TECHNOLOGIES PRIVATE LIMITED",
"AKVBDASTAK SERVICES PRIVATE LIMITED",
"AKXA TECH PRIVATE LIMITED",
"AKY CONSTRUCTION PRIVATE LIMITED",
"AKYA RETAIL PRIVATE LIMITED",
"AKZO NOBEL GLOBAL BUSINESS SERVICES LLP",
"AKZO NOBEL INDIA LIMITED",
"AL - SUFIYAN EXPORTS PRIVATE LIMITED",
"AL- AALI EXPORTS PRIVATE LIMITED",
"AL AFDAL PRODUCTIONS INDIA PRIVATE LIMITED",
"AL AHAD TRADERS PRIVATE LIMITED",
"AL AHALI BUSINESS TRADE LINKS PRIVATE LIMITED",
"AL ALLIED FOOD EXPORTS PRIVATE LIMITED",
"AL AMANATH HAJ SERVICE INDIA PRIVATE LIMITED",
"AL AMANI FOODS PRIVATE LIMITED",
"AL AMEEN ARTS AND SCIENCE COLLEGE",
"AL AMEEN COLLEGE OF NURSING",
"AL AMEEN GREEN ENERGY PRIVATE LIMITED",
"AL AMEEN MEDICAL COLLEGE HOSPITAL VIJAYAPUR",
"AL AMMAR FROZEN FOODS EXPORTS PRIVATE LIMITED",
"AL ARAAF INFRA PRIVATE LIMITED",
"AL BADR SEAFOODS PRIVATE LIMITED",
"AL BARKAAT MALIK MUHAMMAD ISLAM ENGLISH SCHOOL",
"AL BARKAH TANNERY PRIVATE LIMITED",
"AL CARE DIAGNOSTIC AND RESEARCH CENTRE PRIVATE LIMITED",
"AL DAHRA FOOD INDIA PRIVATE LIMITED",
"AL DUA FOOD PROCESSING PRIVATE LIMITED",
"AL FAIZ GROUP",
"AL FALAH PUBLIC SCHOOL",
"AL FAS LAMINATIONS PRIVATE LIMITED",
"AL FATTAH POLYMER PRIVATE LIMITED",
"AL FURQAN ISLAMIC ENGLISH MEDIUM SCHOOL",
"AL GAYATHRI TRADING COMPANY PRIVATE LIMITED",
"AL GEBRA SECURITY & SOLUTIONS PRIVATE LIMITED",
"AL GHURAIR CONSTRUCTION ALUMINIUM INDIA PRIVATE LIMITED",
"AL GLOBAL STAR PRIVATE LIMITED",
"AL GRAND NUTRIMENTS PRIVATE LIMITED",
"AL GURG ENGINEERING & SUPPORT SERVICES PRIVATE LIMITED",
"AL HAJ AMIR HASAN PROPERTIES PVT. LTD.",
"AL- HALAL INTERNATIONAL PRIVATE LIMITED",
"AL HAMD AGRO FOOD PRODUCTS PRIVATE LIMITED",
"AL HAMD LEATHER (INDIA) PRIVATE LIMITED",
"AL HAMD SCHOOL",
"AL HAQ FOODS PRIVATE LIMITED",
"AL HARAMINE HAJ SERVICES P LIMITED",
"AL HASAN AGRO FOODS PRIVATE LIMITED",
"AL HASANAT BOOKS PRIVATE LIMITED",
"AL HAYAT MEDICAL TOUR & TOURISM PRIVATE LIMITED",
"AL HIRA DEVELOPERS PRIVATE LIMITED",
"AL HIRA PUBLIC SCHOOL",
"AL HUDA URDU PRIMARY SCHOOL BHOKARDAN",
"AL IRAM INTZAR PRIVATE LIMITED",
"AL JAMIEATHUS SADHIK MATRICULATION SCHOOL",
"AL JAZIRAH ENGINEERS & CONSULTANTS",
"AL KABEER EXPORTS PRIVATE LIMITED",
"AL KABIR POLYTECHNIC",
"AL KARMA",
"AL LIMRA CRAFT INDIA PRIVATE LIMITED",
"AL MADEENA INSTITUTE OF MEDICAL SCIENCE PRIVATE LIMITED",
"AL MAHA FOODS INTERNATIONAL PRIVATE LIMITED",
"AL MANJAL JEWELLERS PRIVATE LIMITED",
"AL MAZAYA TRADING VENTURES PRIVATE LIMITED",
"AL MEHFOOZ AGRO FOODS PRIVATE LIMITED",
"AL METALS AND METHODS PRIVATE LIMITED",
"AL MIZAN GARMENTS PRIVATE LIMITED",
"AL MOVERS PRIVATE LIMITED",
"AL NASIR EXPORTS PRIVATE LIMITED",
"AL NASSAR GRANITES PRIVATE LIMITED",
"AL NAVED AGRO FOOD INDUSTRIES PRIVATE LIMITED",
"AL NOOR AGRI FRESH PRIVATE LIMITED",
"AL NOOR TRADITION PRIVATE LIMITED",
"AL QALAM PUBLICATIONS PRIVATE LIMITED",
"AL QURESH EXPORTS PRIVATE LIMITED",
"AL RODS PRIVATE LIMITED",
"AL SALAMA EYE HOSPITAL LIMITED",
"AL SARNA RETAIL PRIVATE LIMITED",
"AL SHAAYAN GENERAL TRADING LLC",
"AL SUMAMA AGRO FOODS PRIVATE LIMITED",
"AL TABARAK MEATEX PRIVATE LIMITED",
"AL TOMOUH IT PRIVATE LIMITED",
"AL UMAR AGRO FOODS EXPORTS PRIVATE LIMITED",
"AL WAHA MECHANICAL INDIA PRIVATE LIMITED",
"AL WARITH BLUE DIAMOND GENERAL TRADING PRIVATE LIMITED",
"AL YUSUF FOOD PRODUCTS PRIVATE LIMITED",
"AL- ZAID JUNAID FROZEN FOODS PRIVATE LIMITED",
"AL ZEID FROZEN FOOD EXPORT PRIVATE LIMITED",
"ALA FOODSTUFF PRIVATE LIMITED",
"ALA MODE TECHNOLOGIES PRIVATE LIMITED",
"ALAACRITY PROJECTS AND LOGISTICS INDIA PRIVATE LIMITED",
"ALAACRITY PROJECTS INDIA PRIVATE LIMITED",
"ALAB HR CONSULTANTS PRIVATE LIMITED",
"ALABAMA CELLULOSE SOLUTIONS PRIVATE LIMITED",
"ALABAMA TRADING CO PVT LTD",
"ALABOS BPO SOLUTIONS PRIVATE LIMITED",
"ALACKRITY CONSOLS PRIVATE LIMITED",
"ALACRIS HEALTHCARE PRIVATE LIMITED",
"ALACRITI INFOSYSTEMS PRIVATE LIMITED",
"ALACRITY BUSINESS CENTRE PRIVATE LIMITED",
"ALACRITY CONSTRUCTIONS PRIVATE LIMITED",
"ALACRITY CORPORATE SOLUTIONS PRIVATE LIMITED",
"ALACRITY DEVELOPMENTS PRIVATE LIMITED",
"ALACRITY E-COMMERCE SOLUTIONS PRIVATE LIMITED",
"ALACRITY EXPORTS PRIVATE LIMITED",
"ALACRITY INFRA SOLUTIONS AND SERVICES PRIVATE LIMITED",
"ALACRITY KNOWLEDGE SERVICES PRIVATE LIMITED",
"ALACRITY SECURITIES LIMITED",
"ALACRITY SHIPPING SERVICES INDIA PRIVATE LIMITED",
"ALADA SOLUTIONS PRIVATE LIMITED",
"ALADA TECHNOLOGIES PRIVATE LIMITED",
"ALADIAN HOME STYLES PRIVATE LIMITED",
"ALAG PROPERTY CONSTRUCTIONS PRIVATE LIMITED",
"ALAGAPPA COLLEGE OF TECHNOLOGY",
"ALAGAPPA ENGINEERING PRIVATE LIMITED",
"ALAGAPPA MATRIC HR SEC SCHOOL",
"ALAGAPPA UNIVERSITY",
"ALAGAR JEWELLERS PRIVATE LIMITED",
"ALAGAR POLYTEX PRIVATE LIMITED",
"ALAGAR RESINS PRIVATE LIMITED",
"ALAGENDRAN AUTO AGENCIES PRIVATE LIMITED",
"ALAGENDRAN NIDHI LIMITED",
"ALAGENDRAN SPINNING MILLS PRIVATE LIMITED",
"ALAGHU BUILDMAART PRIVATE LIMITED",
"ALAI SHARE BROKING PRIVATE LIMITED",
"ALAI TECHNOLOGY LABS INDIA PRIVATE LIMITED",
"ALAIN ENTERPRISES PRIVATE LIMITED",
"ALAINA BULLIONS PRIVATE LIMITED",
"ALAINA HEALTHCARE PRIVATE LIMITED",
"ALAKANANDA COLD STORAGE PRIVATE LIMITED",
"ALAKAPURI HOTELS PRIVATE LIMITED",
"ALAKH ADVERTISING & PUBLICITY PRIVATE LIMITED",
"ALAKHNANDA PLYWOOD INDUSTRIES PVT LTD",
"ALAKHRAM INFRASTRUCTURE PRIVATE LIMITED",
"ALAKMALAK TECHNOLOGIES PRIVATE LIMITED",
"ALAKNADA ENTERPRISES PRIVATE LIMITED",
"ALAKNANDA ADVERTISING PRIVATE LIMITED",
"ALAKNANDA BALMUKUND ISPAT PRIVATE LIMITED",
"ALAKNANDA CEMENTS PRIVATE LIMITED",
"ALAKNANDA CONSTRUCTION PRIVATE LIMITED",
"ALAKNANDA FUEL PRIVATE LIMITED",
"ALAKNANDA HYDRO POWER COMPANY LIMITED",
"ALAKNANDA METALS PRIVATE LIMITED",
"ALAKNANDA PRINTERS PRIVATE LIMITED",
"ALAKODE MERCHANTS PRIVATE LIMITED",
"ALAKRAM INTERNATIONAL TRADING COMPANY PRIVATE LIMITED",
"ALAM HOSPITALS & RESEARCH CENTRE PRIVATE LIMITED",
"ALAM MARBLE & GRANITE INDIA PRIVATE LIMITED",
"ALAM TANNERY PRIVATE LIMITED",
"ALAMAK CAPITAL ADVISORS PRIVATE LIMITED",
"AL-AMAL EXPORTS PRIVATE LIMITED",
"ALAMBA WIFI PRIVATE LIMITED",
"ALAMBAZAR C. S. SHOP PRIVATE LIMITED",
"ALAMBRE CABLES PRIVATE LIMITED",
"ALAMDAR FABRICATOR PRIVATE LIMITED",
"ALAMDAR INFRASTRUCTURE PRIVATE LIMITED",
"AL-AMEEN COLLEGE OF ENGINEERING",
"AL-AMEEN COLLEGE OF PHARMACY",
"ALAMELU CHARITABLE FOUNDATION",
"ALAMELU MAGNESIA PRIVATE LIMITED",
"ALAMIN RMC PRIVATE LIMITED",
"ALAMPALLY BROTHERS LTD",
"ALAMPALLY PRESSURE TESTING CO PVT LTD",
"ALAMURI RATNAMALA INSTITUTE OF ENGINEERING AND TECHNOLOGY",
"ALAMY IMAGES INDIA PRIVATE LIMITED",
"ALAN BRIGHT STEEL PRIVATE LIMITED",
"ALAN ELECTRONIC SYSTEMS PRIVATE LIMITED",
"ALAN OVERSEAS PRIVATE LIMITED",
"AL-ANAM AGRO FOODS PRIVATE LIMITED",
"ALAND CERAMIC PRIVATE LIMITED",
"ALAND SPINNERS PRIVATE. LIMITED.",
"ALANDI NAGAR PARISHAD SHIKSHAN VIBHAG",
"ALANDUR PERMANENT FUND NIDHI LIMITED",
"ALANG AUTO AND GENERAL ENGINEERING COMPANY PVT LIMITED",
"ALANG ISPAT PRIVATE LIMITED",
"ALANG STEEL RECYCLING PRIVATE LIMITED",
"ALANITA TRAVEL PRIVATE LIMITED",
"ALANKAR AGENCIES PRIVATE LIMITED",
"ALANKAR AGRO PRODUCTS PRIVATE LIMITED",
"ALANKAR ALLOYS PRIVATE LIMITED",
"ALANKAR APARTMENTS PRIVATE LIMITED",
"ALANKAR AUTO SALES AND SERVICE PRIVATE LIMITED",
"ALANKAR AUTOMOTIVES PRIVATE LIMITED",
"ALANKAR BUSINESS CORPORATION PRIVATE LIMITED",
"ALANKAR ELITE INNS AND HOTELS PRIVATE LIMITED",
"ALANKAR ENGINEERING EQUIPMENTS PRIVATE LIMITED",
"ALANKAR GEMS AND JEWELLERY PRIVATE LIMITED",
"ALANKAR GLOBAL PRIVATE LIMITED",
"ALANKAR GRAPHICS PRIVATE LIMITED",
"ALANKAR HEALTH CARE PRIVATE LIMITED",
"ALANKAR HOTELS & RESORTS INDIA PRIVATE LIMITED",
"ALANKAR INTERNATIONAL PRIVATE LIMITED",
"ALANKAR JEWELARTS PRIVATE LIMITED CO WITH POART IX",
"ALANKAR LAMINATION WORKS PRIVATE LIMITED",
"ALANKAR MANGAL DECOR FURNISHINGS PRIVATE LIMITED",
"ALANKAR OPTICAL SERVICES",
"ALANKAR PRIVATE LIMITED",
"ALANKAR REAL ESTATES PRIVATE LIMITED",
"ALANKAR RINGS PRIVATE LIMITED",
"ALANKAR STEELS PRIVATE LIMITED",
"ALANKIT ASSIGNMENTS LIMITED",
"ALANKIT FINSEC LIMITED",
"ALANKIT FOREX INDIA LIMITED",
"ALANKIT IMAGINATIONS LIMITED",
"ALANKIT INSURANCE BROKERS LIMITED",
"ALANKIT INSURANCE TPA LIMITED",
"ALANKIT LIFE CARE LIMITED",
"ALANKIT LIMITED",
"ALANKIT TECHNOLOGIES LIMITED",
"ALANKRIT HANDICRAFTS PVT LTD",
"ALANKRIT MULTIBUSINESS PRIVATE LIMITED",
"ALANTRA HEALTHCARE PRIVATE LIMITED",
"ALAPATT JEWELS",
"ALAPPAT TRADERS PRIVATE LIMITED",
"ALAR IMPEX PRIVATE LIMITED",
"ALAR INFRASTRUCTURES PRIVATE LIMITED",
"ALARIC LIFE SCIENCES PRIVATE LIMITED",
"ALARIC LOGISTICS PRIVATE LIMITED",
"ALARIC VENTURES PRIVATE LIMITED",
"ALARMIT INDIA PRIVATE LIMITED",
"ALASCO SPRINGS PRIVATE LIMITED",
"ALASHORE AQUA PRIVATE LIMITED",
"ALASKA AUTOMATION PRIVATE LIMITED",
"ALASKA DIGITAL SOLUTIONS PRIVATE LIMITED",
"ALASKA EXPORTS",
"ALASKA FABTECH PRIVATE LIMITED",
"ALASKA FLEXO PRIVATE LIMITED",
"ALASKA INFRATECH PRIVATE LIMITED",
"ALASKA RUBBERS PVT LTD",
"ALASKA STEELS PRIVATE LIMITED",
"ALASR BUILDTECH PRIVATE LIMITED",
"ALATION INDIA PRIVATE LIMITED",
"ALAUDDIN MONDAL",
"ALAUKIK HEALTHCARE PRIVATE LIMITED",
"ALAUKIK INCENSE PRIVATE LIMITED",
"ALAX BIORESEARCH PRIVATE LIMITED",
"ALAY VINCOM PRIVATE LIMITED",
"AL-AYAAN FOODS PRIVATE LIMITED",
"AL-AZEEZ PAPER PRODUCTS PRIVATE LIMITED",
"AL-AZIZ PLASTICS PRIVATE LIMITED",
"ALB PROJECTS PRIVATE LIMITED",
"ALB STOCK BROKING PRIVATE LIMITED",
"ALBA ASIA PRIVATE LIMITED",
"ALBA GARMENTS PRIVATE LIMITED",
"ALBA POWER PRIVATE LIMITED",
"ALBA POWERSPACK TOOLING INDIA PRIVATE LIMITED",
"ALBA SMART AUTOMATION PRIVATE LIMITED",
"ALBA URMET COMMUNICATION AND SECURITY PRIVATE LIMITED",
"ALBACORE ACCOUNTING SERVICES PRIVATE LIMITED",
"ALBAJ ENGINEERING CORPORATION PRIVATE LIMITED",
"AL-BAKE RESTAURANT PRIVATE LIMITED",
"ALBAN TRAVELS INDIA PRIVATE LIMITED",
"ALBANS PROJECTS PRIVATE LIMITED",
"ALBARIN EXPLOTECH PRIVATE LIMITED",
"AL-BARKAAT MALIK MUHAMMED ISLAM ENGLISH SCHOOL",
"AL-BARKAAT PUBLIC SCHOOL",
"ALBAT REMEDIES LIMITED",
"ALBATA BIOTECH INDIA PRIVATE LIMITED",
"ALBATROSS BLACKGOLD PRIVATE LIMITED",
"ALBATROSS FINECHEM PRIVATE LIMITED",
"ALBATROSS FINISHING SCHOOL PRIVATE LIMITED",
"ALBATROSS FLYING SYSTEMS (OPC) PRIVATE LIMITED",
"ALBATROSS HERBALS (INDIA) PRIVATE LIMITED",
"ALBATROSS HOMES PRIVATE LIMITED",
"ALBATROSS INLAND PORTS PRIVATE LIMITED",
"ALBATROSS LOGISTICS PRIVATE LIMITED",
"ALBATROSS PARCEL EXPREES PRIVATE LIMITED",
"ALBATROSS POLYMERS PRIVATE LIMITED",
"ALBATROSS PROJECTS PRIVATE LIMITED",
"ALBATROSS SECURITY AND ALLIED SERVICES PRIVATE LIMITED",
"ALBATROSS SHIPPING AGENCIES (INDIA) PRIVATE LIMITED",
"ALBATROSS SHIPPING PRIVATE LIMITED",
"ALBATROSS SKIMED PRIVATE LIMITED",
"ALBATROSS SOFTWARE SERVICES PRIVATE LIMITED",
"ALBELI LEASING AND FINANCE PRIVATE LIMITED",
"ALBEMARLE INDIA NEW MATERIALS PRIVATE LIMITED",
"ALBEN CHEMICALS PRIVATE LIMITED",
"ALBERGO PROJECT SERVICES PRIVATE LIMITED",
"ALBERT DAVID LIMITED",
"ALBERT ROSE CHEMICALS (INDIA) PRIVATE LIMITED",
"ALBERTSONS INTERNATIONAL PRIVATE LIMITED",
"ALBGARN MICRONUTRIENTS PRIVATE LIMITED",
"ALBHA HEATH CARE PRIVATE LIMITED",
"ALBIE FRAGRANCE PRIVATE LIMITED",
"ALBIN POLYCHEM PRIVATE LIMITED",
"ALBINO LIFESCIENCES P LIMITED",
"ALBION CONSULTING PRIVATE LIMITED",
"ALBION ECOTECH PRIVATE LIMITED",
"ALBION ENGINEERING INDIA PRIVATE LIMITED",
"ALBION INVESTMENTS & HOLDINGS PRIVATE LIMITED",
"ALBION LIFECARE PRIVATE LIMITED",
"ALBIORIX TECHNOLOGY PRIVATE LIMITED",
"ALBIOS LIFESCIENCES PRIVATE LIMITED",
"ALBIS CONSTRUCTIONS PRIVATE LIMITED",
"ALBITEK POWER SERVICES PRIVATE LIMITED",
"ALBONAIR (INDIA) PRIVATE LIMITED",
"ALBONAIR INDIA PRIVATE LIMITED",
"ALBOTT CONTAINERS PRIVATE LIMITED",
"ALBOTT PACKAGERS PRIVATE LIMITED",
"ALBRECHT BUILDER PRIVATE LIMITED",
"ALBRIGHT VINIYOG & NIRMAN PVT. LTD.",
"ALBROSS INDIA PRIVATE LIMITED",
"ALBUM SEMICONDUCTORS INDIA PRIVATE LIMITED",
"ALBUS HEALTHCARE PRIVATE LIMITED",
"ALBUS PHARMACEUTICALS PRIVATE LIMITED",
"ALBY ENGINEERING PRIVATE LIMITED",
"ALBYS AGRO PRIVATE LIMITED",
"ALC SKICORP THERMOADHESIVES PRIVATE LIMITED",
"ALCADE ENGINEERS PRIVATE LIMITED",
"ALCAN CHEMPHARM (INDIA) PRIVATE LIMITED",
"AL-CAN EXPORTS P LTD",
"ALCANES FURNITURE INDIA PRIVATE LIMITED",
"ALCAP ELECTRONICS PRIVATE LIMITED",
"ALCARE CONTAINERS PRIVATE LIMITED",
"ALCASO INFRASPACE PRIVATE LIMITED",
"ALCATEC RESEARCH LABORATORIES INDIA PRIVATE LIMITED",
"ALCATEL-LUCENT INDIA LIMITED",
"ALCATEL-LUCENT MANAGED SOLUTIONS INDIA PRIVATE LIMITED",
"ALCCOTECH BUILDING MATERIALS PRIVATE LIMITED",
"ALCEA BIOTECH PRIVATE LIMITED",
"ALCEDO PHARMACHEM PRIVATE LIMITED",
"ALCHAW METPRINT INDIA LIMITED",
"ALCHEM INTERNATIONAL PRIVATE LIMITED",
"ALCHEM PHYTOCEUTICALS LIMITED",
"ALCHEM SYNTHON PRIVATE LIMITED.",
"ALCHEM TADE PRIVATE LIMITED",
"ALCHEME FASHIONS PRIVATE LIMITED",
"ALCHEME SALES PRIVATE LIMITED",
"ALCHEMIA DESIGN PRIVATE LIMITED",
"ALCHEMIC COMMERCE PRIVATE LIMITED",
"ALCHEMIE FINANCIAL SERVICES LTD",
"ALCHEMIE FINSERV PRIVATE LIMITED",
"ALCHEMIE GASES AND CHEMICALS PRIVATE LIMITED",
"ALCHEMIE SPECIALITY CHEMICALS PRIVATE LIMITED",
"ALCHEMIST AIRWAYS PRIVATE LIMITED",
"ALCHEMIST AVIATION PRIVATE LIMITED",
"ALCHEMIST CAREER ENHANCEMENT PRIVATE LIMITED",
"ALCHEMIST F&B LIMITED",
"ALCHEMIST FOODS LIMITED",
"ALCHEMIST HOSPITALS LIMITED",
"ALCHEMIST MARKETING TALENT SOLUTIONS PRIVATE LIMITED",
"ALCHEMIST OIL PRIVATE LIMITED",
"ALCHEMIST REMEDIES PRIVATE LIMITED",
"ALCHEMIST RETAIL LIMITED",
"ALCHEMIST TOUCHNOLOGY LIMITED",
"ALCHEMY ADVERTISING PRIVATE LIMITED",
"ALCHEMY CAPITAL MANAGEMENT PRIVATE LIMITED",
"ALCHEMY EQUITY RESEARCH AND SECURITIES PRIVATE LIMITED",
"ALCHEMY FILMZ PRIVATE LIMITED",
"ALCHEMY GRANI MARMO PRIVATE LIMITED",
"ALCHEMY INTERIORS PRIVATE LIMITED",
"ALCHEMY LABORATORIES PRIVATE LIMITED",
"ALCHEMY MEDICINE PRIVATE LIMITED",
"ALCHEMY RESEARCH AND ANALYTICS LLP",
"ALCHEMY SOLUTIONS PRIVATE LIMITED",
"ALCHEMY STONES MATRIX PRIVATE LIMITED",
"ALCHEMY SURFACTANTS PRIVATE LIMITED",
"ALCHEMY TECHSOL INDIA PRIVATE LIMITED",
"ALCHEMY WEB PRIVATE LIMITED",
"ALCHYMARS ICM SM PRIVATE LIMITED",
"ALCIRCLE PRIVATE LIMITED",
"ALCIS SPORTS PRIVATE LIMITED",
"ALCIT (INDIA) PRIVATE LTD",
"ALCLAD FABRICATION PRIVATE LIMITED",
"ALCLED LIGHTING PRIVATE LIMITED",
"ALCO ALUMINIUM LADDERS PRIVATE LIMITED",
"ALCO COMPANY LIMITED",
"ALCO ELECTROSTRIPS PVT LTD",
"ALCO ENAMELLED WIRE MFG.CO. PRIVATE LIMITED JAIPUR",
"ALCO ENGINEERS PRIVATE LIMITED",
"ALCO FOODS PRIVATE LIMITED",
"ALCO INDUSTRIES PRIVATE LIMITED",
"ALCO INFO TECH PRIVATE LIMITED",
"ALCO SPIRITS PRIVATE LIMITED",
"ALCO STEELS PRIVATE LIMITED",
"ALCO SUPPLIERS PVT.LTD.",
"ALCO WIRE PRODUCTS PVT LTD",
"ALCOB TRANSMISSIONS PRIVATE LIMITED",
"ALCOBREW DISTILLERIES INDIA LIMITED",
"ALCOI INDIA PRIVATE LIMITED",
"ALCOLITE INDIA ROAD SAFETY PRIVATE LIMITED",
"ALCOMEX SPRINGS PRIVATE LIMITED",
"ALCON AUTO PRIVATE LIMITED",
"ALCON BIOSCIENCES PRIVATE LIMITED",
"ALCON BUILDERS AND ENGINEERS PRIVATE LIMITED",
"ALCON CEMENT COMPANY PRIVATE LIMITED",
"ALCON CONSTRUCTIONS GOA PRIVATE LIMITED",
"ALCON CONSULTING ENGINEERS (INDIA) PRIVATE LIMITED",
"ALCON ELECTRONICS PRIVATE LIMITED",
"ALCON FINANCE AND INVESTMENTS LIMITED",
"ALCON HOTELS GOA PRIVATE LIMITED",
"ALCON LABORATORIES INDIA PRIVATE LIMITED",
"ALCON PANEL INDUSTRIES PRIVATE LIMITED",
"ALCON PETRO PRIVATE LIMITED",
"ALCON PRODUCTS PRIVATE LIMITED",
"ALCON REAL ESTATES PRIVATE LIMITED",
"ALCON RESORT HOLDINGS PRIVATE LIMITED",
"ALCONE TEX ENGINEERING PRIVATE LIMITED",
"ALCONS INFRAESTATE PRIVATE LIMITED",
"ALCOP INDUSTRIES",
"ALCOP INDUSTRIES PRIVATE LIMITED",
"ALCOPRIME DISTILLERIES PRIVATE LIMITED",
"ALCOR MERGERS AND ACQUISITIONS PRIVATE LIMITED",
"ALCOR POLYMER PRIVATE LIMITED",
"ALCOR SOLUTIONS INDIA PRIVATE LIMITED",
"ALCOSTAR DISTILLERIES PRIVATE LIMITED",
"ALCOT SLUGS PVT LTD",
"ALCOTT HEALTHCARE PRIVATE LIMITED",
"ALCOVE CONSTRUCTIONS PRIVATE LIMITED",
"ALCOVE GLORIA COMMERCIAL MAINTENANCE PRIVATE LIMITED",
"ALCOVE INFRATECH PRIVATE LIMITED",
"ALCRUCIS INTERACTIVE VISUAL TECHNOLOGIES PRIVATE LIMITED",
"ALCURIS HEALTHCARE PRIVATE LIMITED",
"ALCYON ENGINEERING PRIVATE LIMITED",
"ALD AUTOMOTIVE PRIVATE LIMITED",
"ALD DYNATECH FURNACES PRIVATE LIMITED",
"AL-DAAZ FOODS PRIVATE LIMITED",
"ALDAN HEALTHE PRIVATE LIMITED",
"ALDAN INVESTMENTS PRIVATE LIMITED",
"ALDAY HEALTHCARE",
"ALDE MEDI IMPEX LIMITED",
"ALDEA INFOTECH PRIVATE LIMITED",
"ALDECOR INTERIORS PRIVATE LIMITED.",
"ALDEE WATER PRIVATE LIMITED",
"ALDEKO PANELS PRIVATE LIMITED",
"ALDER FURNITURE PRIVATE LIMITED",
"ALDER TRADING COMPANY PRIVATE LIMITED",
"ALDERLEY ENGINEERING PRIVATE LIMITED",
"ALDICA TECHNOLOGIES PRIVATE LIMITED",
"ALDINE VENTURES PRIVATE LIMITED",
"ALDON STEEL PRIVATE LIMITED",
"ALDRICH BUSINESS SERVICES PRIVATE LIMITED",
"ALDRICH RESEARCH SERVICES PRIVATE LIMITED",
"ALDRIN PHARMA PRIVATE LIMITED",
"ALDURA INDUSTRIES PRIVATE LIMITED",
"ALDYS TECHNOLOGIES PRIVATE. LIMITED",
"ALE BREWERIES PRIVATE LIMITED",
"ALE INDIA PRIVATE LIMITED",
"ALEA INTERNATIONAL CONSULTING PRIVATE LIMITED",
"AL-EAINAB FOODS PRIVATE LIMITED",
"ALEC ENTERPRISE PRIVATE LIMITED",
"ALEC MEDITECH PRIVATE LIMITED",
"ALECTO DESIGN ENGINEERING PRIVATE LIMITED",
"ALECTRA INFRASTATE LIMITED",
"ALEEF TRAVEL SERVICE PRIVATE LIMITED",
"ALEENA COMERCIAL PRIVATE LIMITED",
"ALEF MOBITECH PRIVATE LIMITED",
"ALEGION INSURANCE BROKING PRIVATE LIMITED",
"ALEIXO TECHNOLOGIES PRIVATE LIMITED",
"ALEKAS SOLUTIONS PRIVATE LIMITED",
"ALEKH INFRACON PRIVATE LIMITED",
"ALEKHASUNDARI TECH SOLUTION PRIVATE LIMITED",
"ALEKHYA AQUA TRADERS PRIVATE LIMITED",
"ALEKHYA HOMES BUILDING SYSTEMS PRIVATE LIMITED",
"ALEKHYA PROPERTY DEVELOPMENTS PRIVATE LIMITED",
"ALEKOS TECHNOLOGIES INDIA PRIVATE LIMITED",
"ALEKTON ENGG INDS PRIVATE LIMITED",
"ALEMAC ELECTRICAL PRIVATE LIMITED",
"ALEMBIC CITY LIMITED",
"ALEMBIC LIMITED",
"ALEMBIC METALS PRIVATE LIMITED",
"ALEMBIC PHARMACEUTICALS LIMITED",
"ALEN SMITH STEELS PRIVATE LIMITED",
"ALENA CONSULTANTS PRIVATE LIMITED",
"ALENCURE BIOTECH PRIVATE LIMITED",
"ALENMEDS HEALTH CARE PRIVATE LIMITED",
"ALENT TECHNOLOGY PRIVATE LIMITED",
"ALENTICA PHARMACEUTICALS PRIVATE LIMITED",
"ALEO MANALI HYDROPOWER PRIVATE LIMITED",
"ALEOR DERMACEUTICALS LIMITED",
"ALEPA DAIRY FOODS PRIVATE LIMITED",
"ALEPH ACCREDITATION AND TESTING CENTRE PRIVATE LIMITED",
"ALEPH BOOK COMPANY PRIVATE LIMITED",
"ALEPH INDUSTRIES (INDIA) PRIVATE LIMITED",
"ALEPHIX CONSULTING PRIVATE LIMITED",
"ALEPO TECHNOLOGIES PRIVATE LIMITED",
"ALEPT CONSULTING PRIVATE LIMITED",
"ALERIO LOGISTICS PRIVATE LIMITED",
"ALERON SHARED RESOURCES INDIA PRIVATE LIMITED",
"ALERT CARE & CONSTRUCTION SERVICES PRIVATE LIMITED",
"ALERT CROPSCIENCE PRIVATE LIMITED",
"ALERT FACILITY MANAGEMENT INDIA PRIVATE LIMITED",
"ALERT IMPEX PRIVATE LIMITED",
"ALERT INDIA PRIVATE LIMITED",
"ALERT INSURANCE BROKERS PRIVATE LIMITED",
"ALERT INTELLIGENCE SERVICES PRIVATE LIMITED",
"ALERT ONSITEMEDICAL ASSISTANCE PRIVATE LIMITED",
"ALERTFORCE SECURITY AND FACILITY MANAGEMENT PRIVATE LIMITED",
"ALERTLABS INDIA PRIVATE LIMITED",
"ALERTOPS INDIA PRIVATE LIMITED",
"ALESSANDRA UNIVERSAL PRIVATE LIMITED",
"ALETA TECHNOLOGIES PRIVATE LIMITED",
"ALETAN INDIA PRIVATE LIMITED",
"ALETHE CONSULTING PRIVATE LIMITED",
"ALETHEA COMMUNICATIONS TECHNOLOGIES PRIVATE LIMITED",
"ALETHEIA MEDICARE PRIVATE LIMITED",
"ALETHEIA TECHNOLOGIES PRIVATE LIMITED",
"ALETHIA INFOTEL PRIVATE LIMITED",
"ALEWIAN INFRATECH PRIVATE LIMITED",
"ALEX A APCAR JUNIOR & CO PVT LTD",
"ALEX ASTRAL POWER PRIVATE LIMITED",
"ALEX ASTRAL POWER PRIVATE. LIMITED.",
"ALEX ELECTRICAL ENGINEERS PRIVATE LIMITED",
"ALEX EXTRUSIONS LIMITED",
"ALEX FISHING NET PRIVATE LIMITED",
"ALEX GRINDERS PRIVATE LIMITED",
"ALEX JEWELLERY PRIVATE LIMITED",
"ALEX MACHINE TOOLS PRIVATE LIMITED",
"ALEX OVERSEAS PRIVATE LIMITED",
"ALEX PACKAGING PRIVATE LIMITED",
"ALEX PHARMACEUTICALS PVT LTD",
"ALEX PIPE INDIA PRIVATE LIMITED",
"ALEX STEWART INSURANCE SURVEYORS AND LOSS ASSESSORS PRIVATE LIMITED",
"ALEX STEWART INTERNATIONAL INDIA PRIVATE LIMITED",
"ALEXA FILTRATION AND CLEANING SOLUTIONS PRIVATE LIMITED",
"ALEXA ORGANICS PRIVATE LIMITED",
"ALEXANDER DESIGN CONSULTANTS PRIVATE LIMITED",
"ALEXANDER MANN SOLUTIONS PRIVATE LIMITED",
"ALEXANDER STAMPS AND COIN LIMITED",
"ALEXANDRE QUALITY MANAGEMENT INDIA PRIVATE LIMITED",
"ALEXANDRIA CARBON BLACK",
"ALEXCURE LIFESCIENCES PRIVATE LIMITED",
"ALEXCY MERCANTILE PRIVATE LIMITED",
"ALEXI FINANCIALS LIMITED",
"ALEXI PHARMICIA PRIVATE LIMITED",
"ALEXION BUSINESS SERVICES PRIVATE LIMITED",
"ALEXIS GLOBAL PRIVATE LIMITED",
"ALEXIS MULTI-SPECIALITY HOSPITAL PRIVATE LIMITED",
"ALEXIUS E-SOLUTIONS PRIVATE LIMITED",
"ALEXY CONCEPT ENGLISH MEDIUM UPPER PRIMARY SCHOOL",
"ALF - P M SURFACE COATING PRIVATE LIMITED",
"ALF AUTO SERVICES PRIVATE LIMITED",
"ALF BARIK LEATHERS PRIVATE LIMITED",
"ALF DESIGN CONSULTANTS PRIVATE LIMITED",
"ALF ENGINEERING PRIVATE LIMITED",
"ALF FARMS PRIVATE LIMITED",
"ALFA AUTOMOBILES PRIVATE LIMITED",
"ALFA BIOMED INDIA PRIVATE LIMITED",
"ALFA BOILERS PRIVATE LIMITED",
"ALFA BUILDHOME PRIVATE LIMITED",
"ALFA CARPETING COMPANY PRIVATE LIMITED",
"ALFA CHEMO PLAST PRIVATE LIMITED",
"ALFA COILS & CONDENSERS PRIVATE LIMITED",
"ALFA COLOUR CHEM PRIVATE LIMITED",
"ALFA CORPUSCLES PRIVATE LIMITED",
"ALFA DEAL PRIVATE LIMITED",
"ALFA ENTECH (GUJARAT) PRIVATE LIMITED",
"ALFA E-SOLUTIONS PRIVATE LIMITED",
"ALFA ESTATES PRIVATE LIMITED",
"ALFA EXIM PRIVATE LIMITED",
"ALFA FACADE SYSTEMS PRIVATE LIMITED",
"ALFA FISCAL SERVICES PVT LTD",
"ALFA FLEXITUBES PRIVATE LIMITED",
"ALFA FLOW CONTROL COMPONENTS PRIVATE LIMITED",
"ALFA HEALTHWAYS PRIVATE LIMITED",
"ALFA HOLDINGS",
"ALFA ICA (INDIA) LIMITED",
"ALFA INDIA TOURS & TRAVELS PRIVATE LIMITED",
"ALFA INDUSTRIES SOLUTIONS PRIVATE LIMITED",
"ALFA INFRAPROP PRIVATE LIMITED",
"ALFA INGOT PRIVATE LIMITED",
"ALFA KPO PRIVATE LIMITED",
"ALFA LAVAL INDIA PRIVATE LIMITED",
"ALFA LAVAL SUPPORT SERVICES PRIVATE LIMITED",
"ALFA MACHINE TOOLS PRIVATE LIMITED",
"ALFA MANA REALTORS PARIVATE LIMITED",
"ALFA MAXWORTH PRIVATE LIMITED",
"ALFA MOULDING INDUSTRIES PVT LTD",
"ALFA NEXT GEN TECH INDIA PRIVATE LIMITED",
"ALFA OCEANIC SHIPPING SERVICES PRIVATE LIMITED",
"ALFA PEB LIMITED",
"ALFA PIGMENT AND CHEMICALS PRIVATE LIMITED",
"ALFA POLYMERS PRIVATE LIMITED",
"ALFA PRECISION TECHNOLOGIES PRIVATE LIMITED",
"ALFA PROJECTS AND SERVICES PRIVATE LIMITED",
"ALFA PROTEINS PRIVATE LIMITED",
"ALFA PUMPS PRIVATE LIMITED",
"ALFA RUBBER & SPRINGS PRIVATE LIMITED",
"ALFA SOAPS AND TOILETERIES PRIVATE LIMITED",
"ALFA SOLVENTS PRIVATE LIMITED",
"ALFA SUITINGS PRIVATE LIMITED",
"ALFA SURGICALS PRIVATE LIMITED",
"ALFA SWITCHGEAR (INDIA) PRIVATE LIMITED",
"ALFA SYSTEMS PRIVATE LIMITED",
"ALFA TECHNOLOGY AND SERVICES",
"ALFA THERM LIMITED",
"ALFA TKG INTEGRATED SOLUTIONS INDIA PRIVATE LIMITED",
"ALFA TRANSFORMERS LIMITED",
"ALFA VITRIFIED PRIVATE LIMITED",
"ALFA WOODPACK PRIVATE LIMITED",
"ALFAAZ",
"ALFAB MARKETING & SALES PRIVATE LIMITED",
"ALFACCURATE ADVISORS PRIVATE LIMITED",
"ALFAGENESIS INOX PRIVATE LIMITED",
"ALFAGRO PRIVATE LIMITED",
"AL-FALAH FOODS PRIVATE LIMITED",
"ALFALAL SHIPPING PRIVATE LIMITED",
"ALFALEO",
"ALFALOGIC SOLUTIONS INDIA PRIVATE LIMITED",
"ALFAMAX PACKAGING SOLUTIONS PRIVATE LIMITED",
"ALFANAR ENERGY PRIVATE LIMITED",
"ALFANAR ENGINEERING SERVICES INDIA PRIVATE LIMITED",
"ALFANAR POWER PRIVATE LIMITED",
"ALFANAR POWER SERVICES PRIVATE LIMITED",
"ALFANIO INDIA PRIVATE LIMITED",
"ALFANSO VITRIFIED PRIVATE LIMITED",
"ALFAONE TECHNOLOGIES PRIVATE LIMITED",
"AL-FAS TRADING INTERNATIONAL PRIVATE LIMITED",
"AL-FAS WOOD PRODUCTS PRIVATE LIMITED",
"ALFASOLIS URBANLYFE PRIVATE LIMITED",
"ALFATECH ENGINEERS PRIVATE LIMITED",
"ALFATECH SERVICES PRIVATE LIMITED",
"ALFATECH SYSTEMS PRIVATE LIMITED",
"AL-FATHIMA GENERAL TRADING PRIVATE LIMITED",
"ALFAVISION BIOTECH PRIVATE LIMITED",
"ALFAVISION FIBRES PRIVATE LIMITED",
"ALFAVISION OVERSEAS (INDIA) LIMITED",
"ALFAZ LIFESTYLE SOLUTIONS PRIVATE LIMITED",
"ALFAZANCE INDIA PRIVATE LIMITED",
"ALFEN ECO-TECH CONSULTANTS PRIVATE LIMITED",
"ALFEN SYSTEMS PRIVATE LIMITED",
"ALFENI METARC PRIVATE LIMITED",
"ALFEREZ PRIVATE LIMITED",
"ALFHEIM INDIA PRIVATE LIMITED",
"ALFIE SOFTWARE PRIVATE LIMITED",
"ALFINE KNIT PRIVATE LIMITED",
"ALFON TAPS LIMITED",
"ALFORD SCHOOLS COUNCIL",
"ALFRED HERBERT (INDIA) LTD",
"ALFRED HERBERT LIMITED",
"ALG ENGINEERING WORKS PRIVATE LIMITED",
"ALG PRODUCTS PRIVATE LIMITED",
"ALGAUSIYA EXPORTS PRIVATE LIMITED",
"ALGAVISTA GREENTECH PRIVATE LIMITED",
"ALGEE LOGISTICS PRIVATE LIMITED",
"ALGEMENE BANK NETHERLANDS N V",
"ALGEN EXPORTS PRIVATE LIMITED",
"ALGEN HEALTHCARE LIMITED",
"ALGEN REMEDIES PRIVATE LIMITED",
"ALGIATRY MEDICAL SERVICES PRIVATE LIMITED",
"ALGO ENERGYTECH VENTURES PRIVATE LIMITED",
"ALGO FLUID SYSTEMS PRIVATE LIMITED",
"ALGO MATRIIX CAPITAL PRIVATE LIMITED",
"ALGO ONE AI PRIVATE LIMITED",
"ALGOANALYTICS PRIVATE LIMITED",
"ALGOCUBES PRIVATE LIMITED",
"ALGODEX SYSTEMS PRIVATE LIMITED",
"ALGOFUSION TECHNOLOGIES INDIA PRIVATE LIMITED",
"ALGOL BUSINESS SYSTEMS PRIVATE. LIMITED.",
"ALGOL CHEMICALS INDIA PRIVATE LIMITED",
"ALGOLDEN FOODS PRIVATE LIMITED",
"ALGOLEAP TECHNOLOGIES PRIVATE LIMITED",
"ALGOMATIX TECHNOLOGY PRIVATE LIMITED",
"ALGOMILL TECHNOLOGIES (OPC) PRIVATE LIMITED",
"ALGONOMY SOFTWARE PRIVATE LIMITED",
"ALGONOX TECHNOLOGIES PRIVATE LIMITED",
"ALGOPACE SYSTEMS PRIVATE LIMITED",
"ALGOR SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED",
"ALGORHYTHM TECH PRIVATE LIMITED",
"ALGORHYTHMS CONSULTANTS PRIVATE LIMITED",
"ALGORISYS TECHNOLOGIES PRIVATE LIMITED",
"ALGORITHAM INFRASTRUCTURE PRIVATE LIMITED",
"ALGORITHM DIGITAL PRIVATE LIMITED",
"ALGORITHM INFORMATICS PRIVATE LIMITED",
"ALGORITHM INFOWEB PRIVATE LIMITED",
"ALGORITHM VENTURES PRIVATE LIMITED",
"ALGORITHMS SOFTWARE PRIVATE LIMITED",
"ALGORITZ WEB TECHNOLOGIES PRIVATE LIMITED",
"ALGORT TECHNOLOGIES PRIVATE LIMITED",
"ALGORT TECHNOSOLUTIONS PRIVATE LIMITED",
"ALGOSCALE TECHNOLOGIES PRIVATE LIMITED",
"ALGOSEC INDIA LLP",
"ALGOSHACK TECHNOLOGIES PRIVATE LIMITED",
"ALGOSOFT APPS TECHNOLOGIES PRIVATE LIMITED",
"ALGOWIRE TRADING TECHNOLOGIES PRIVATE LIMITED",
"ALGOWORKS TECHNOLOGIES PRIVATE LIMITED",
"AL-GYAS EXPORTS PRIVATE LIMITED",
"AL-HABEEB EDUCATIONAL AND WELFARE SOCIETY",
"ALHAK QUALITY INSPECTION SERVICES",
"AL-HAMD PROPERTIES PRIVATE LIMITED",
"ALHAMZA FEEDS AND FARMS PRIVATE LIMITED",
"AL-HARMAIN PHARMA (INDIA) PRIVATE LIMITED",
"ALHAYAT NURSING HOME PVT. LTD.",
"AL-HILAL ENGINEERS PRIVATE LIMITED",
"ALHIND CALICUT TOWER PRIVATE LIMITED",
"AL-HIND EXPORTS",
"ALHIND TOURS AND TRAVELS PRIVATE LIMITED",
"AL-HUDA MONEY EXCHANGE PRIVATE LIMITED",
"ALHUDA URDU MADHYAMIK VIDYALAY",
"ALHUDA URDU MADHYAMIK VIDYALAY BHOKARDAN",
"ALI AFZAL FLOUR MILL LIMITED",
"ALI DESIGNERS AND GLAZERS PRIVATE LIMITED",
"ALI TEPPICH PRIVATE LIMITED",
"ALIA CREATIVE CONSULTANTS PRIVATE LIMITED",
"ALIA PREMEDIA SERVICES PRIVATE LIMITED",
"ALIANCA LOGISTICS PRIVATE LIMITED",
"ALIANZA FOODS AND NUTS PRIVATE LIMITED",
"ALIAXIS UTILITIES AND INDUSTRY PRIVATE LIMITED",
"ALIBABA TOYS PRIVATE LIMITED",
"ALIBAGH FARMING AND AGRICULTURIST COMPANY PRIVATE LIMITED",
"ALICA KRAFT PAPER PRIVATE LIMITED",
"ALICANTE SURFACES PRIVATE LIMITED",
"ALICE BIOTECH PRIVATE LIMITED",
"ALICE BLUE COMMODITIES PRIVATE LIMITED",
"ALICE BLUE FINANCIAL SERVICES PRIVATE LIMITED",
"ALICE CAMERA PRIVATE LIMITED",
"ALICE PHARMA PRIVATE LIMITED",
"ALICE REAL ESTATES PRIVATE LIMITED",
"ALICE TOWER PRIVATE LIMITED",
"ALICH INDUSTRIES PRIVATE LIMITED",
"ALICID ORGANIC INDUSTRIES LIMITED",
"ALICON CASTALLOY LIMITED",
"ALICON PHARMACEUTICAL PRIVATE LIMITED",
"ALICORN WELLNESS PRIVATE LIMITED",
"ALIDA BAGNAR HIGH SCHOOL HS",
"ALIDHRA MACHINES PRIVATE LIMITED",
"ALIEN ENERGY PRIVATE LIMITED",
"ALIEN TECHNOLOGY TRANSFER INDIA PRIVATE LIMITED",
"ALIENGENA CAPTIVE PRIVATE LIMITED",
"ALIENS ART PRIVATE LIMITED",
"ALIENS ART SCHOOL PRIVATE LIMITED",
"ALIENS BUILDCOM PRIVATE LIMITED",
"ALIENT CERAMICS PRIVATE LIMITED",
"ALIF LAAM MEEM ENTERPRISES PRIVATE LIMITED",
"ALIF MEDICAL DEVICES PRIVATE LIMITED",
"ALIF SEMICONDUCTOR INDIA PRIVATE LIMITED",
"ALIF STEELS PVT LTD",
"ALIF TRAVELS PRIVATE LIMITED",
"ALIFCLOUD IT CONSULTING PRIVATE LIMITED",
"ALIFCON PHARMACEUTICAL PRIVATE LIMITED",
"ALIFF OVERSEAS PRIVATE LIMITED",
"ALIG CONVEYOR AUTOMATION PRIVATE LIMITED",
"ALIGARH COLLEGE OF PHARMACY",
"ALIGARH DEVELOPMENT AUTHORITY",
"ALIGARH HOUSE FOODS & HOSPITALITY PRIVATE LIMITED",
"ALIGARH LOCKS PRIVATE LIMITED",
"ALIGARH MARKETING PRIVATE LIMITED",
"ALIGARH MUSLIM UNIVERSITY",
"ALIGARH ROLLER FLOUR MILLS PRIVATE LIMITED",
"ALIGARH SMART CITY LIMITED",
"ALIGARH TUBES AND SHUTTER PRIVATE LIMITED",
"ALIGHT CONSULTANTS PRIVATE LIMITED",
"ALIGHT HR SERVICES INDIA PRIVATE LIMITED",
"ALIGHT SERVICES INDIA PRIVATE LIMITED",
"ALIGN BIZ TECHNOLOGIES PRIVATE LIMITED",
"ALIGN COMPONENTS PRIVATE LIMITED",
"ALIGN CONSTRUCTIONS PRIVATE LIMITED",
"ALIGN KNOWLEDGE CENTRE PRIVATE LIMITED",
"ALIGN RETAIL TRADES PRIVATE LIMITED",
"ALIGNED AUTOMATION SERVICES PRIVATE LIMITED",
"ALIGNMINDS TECHNOLOGIES PRIVATE LIMITED",
"ALIGNZ EXPORT PRIVATE LIMITED",
"ALIJA ORGANICS FOODS PRIVATE LIMITED",
"ALIKE THOUGHTS SOLUTIONS PRIVATE LIMITED",
"ALIKENT INDIA PRIVATE LIMITED",
"ALIKRAFT ENGINEERS PRIVATE LIMITED",
"ALIMAK GROUP INDIA PRIVATE LIMITED",
"ALIMENT SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"ALIMENTO AGRO FOODS PRIVATE LIMITED",
"ALIN LEASING AND FINSTOCK PRIVATE LIMITED",
"ALINA PRIVATE LIMITED",
"ALINAA TECHNICAL TEXTILE PRIVATE LIMITED",
"ALINE CHIROPRACTIC PRIVATE LIMITED",
"ALINE CONVEYORS PRIVATE LIMITED",
"ALINE CURTAIN WALLS PRIVATE LIMITED",
"ALINE DESIGN PRIVATE LIMITED",
"A-LINE TRAVELS PRIVATE LIMITED",
"ALINEA HEALTHCARE PRIVATE LIMITED",
"ALINER AUTOMOTIVE EQUIPMENTS PRIVATE LIMITED",
"ALINTA GRANITO PRIVATE LIMITED",
"ALION TRADE PRIVATE LIMITED",
"ALIPORE DIVISION PHE DTE",
"ALIPORE TOWERS PVT. LTD.",
"ALIPURDUAR TRANSMISSION LIMITED",
"ALIQAN SERVICES PRIVATE LIMITED",
"AL-IQRA FROZEN FOOD PRIVATE LIMITED",
"ALIQUE PET PRIVATE LIMITED",
"ALIRAJPUR - MATHWAD HIGHWAY PRIVATE LIMITED",
"ALISHA PACKAGING PRIVATE LIMITED",
"ALISHA PNEUMATICS INDIA PRIVATE LIMITED",
"ALISHA RETAIL PRIVATE LIMITED",
"ALISHA SNACKS PRIVATE LIMITED",
"ALISHA TORRENT CLOSURES INDIA PRIVATE LIMITED",
"ALISHAA FOODS PRIVATE LIMITED",
"ALISHAN COMPUTER & SERVICES PRIVATE LIMITED",
"ALISHAN ENTERTAINMENT PRIVATE LIMITED",
"ALISHAN GINNING MILLS PRIVATE LIMITED",
"ALISHAN REALCON PRIVATE LIMITED",
"ALISHAN STEELS PRIVATE LIMITED",
"ALISHAN VENEER AND PLYWOOD PRIVATE LIMITED",
"ALISIER DRUGS PRIVATE LIMITED",
"ALISPED INDIA PRIVATE LIMITED",
"ALITE FOOD INGREDIENTS (OPC) PRIVATE LIMITED",
"ALITER BUSINESS SOLUTIONS PRIVATE LIMITED",
"ALITRONZ TECHNOLOGY",
"ALITSO INDIA IT CONSULTING PRIVATE LIMITED",
"ALITY AGRO PRODUCTS PRIVATE LIMITED",
"ALIUS DESIGN PRIVATE LIMITED",
"ALIVE DEVELOPERS PRIVATE LIMITED",
"ALIVE HEALTHCARE PRIVATE LIMITED",
"ALIVE IMPEX PRIVATE LIMITED",
"ALIVE MANAGEMENT SERVICES PRIVATE LIMITED",
"ALIVECOR INDIA PRIVATE LIMITED",
"ALIVENET SOLUTION PRIVATE LIMITED",
"ALIVIO HEALTHCARE PRIVATE LIMITED",
"ALIVIRA ANIMAL HEALTH LIMITED",
"ALIXIR CHEM PRIVATE LIMITED",
"ALIYA AIR TRAVELS PRIVATE LIMITED",
"ALIYA INFRASTRUCTURE ENGINEERING SERVICES PRIVATE LIMITED",
"ALIZA EXPORTS PRIVATE LIMITED",
"ALIZA HEALTHCARE PRIVATE LIMITED",
"ALJAZEER SOFTWARE SOLUTIONS PRIVATE LIMITED",
"ALK TALENT SEARCH LLP",
"ALKA AYURVEDIC PRIVATE LIMITED",
"ALKA CHEMI-PACK PRIVATE LIMITED",
"ALKA ELECTROMECH PRIVATE LIMITED",
"ALKA GREENFARMS PRIVATE LIMITED",
"ALKA HIMAGAR PRIVATE LIMITED",
"ALKA ISPAT PVT LTD",
"ALKA LABORATORIES PRIVATE LIMITED",
"ALKA PANDEY PACKAGING PRIVATE LIMITED",
"ALKA PLYWOOD PRIVATE LIMITED",
"ALKABIR HEALTHCARE SERVICES PRIVATE LIMITED",
"ALKALI METALS LIMITED",
"ALKALOIDS PRIVATE LIMITED",
"ALKAM LICENCE PRODUCTS PRIVATE LIMITED",
"ALKANS PHARMACEUTICALS PRIVATE LIMITED",
"ALKARA STONES PRIVATE LIMITED",
"ALKARIM SCRAP TRADERS PRIVATE LIMITED",
"AL-KAVIZ INDUSTRIES PRIVATE LIMITED",
"ALKEM FOUNDATION",
"ALKEM LABORATORIES LIMITED",
"ALKEMI DACOR DESIGNS PRIVATE LIMITED",
"ALKEMI GROWTH CAPITAL LLP",
"ALKEY SYNTHETICS PRIVATE LIMITED",
"AL-KHATIB INTERNATIONAL PRIVATE LIMITED",
"ALKHIJAR MARINE PRIVATE LIMITED",
"ALKIMIA PHARMA-CHEM PRIVATE LIMITED",
"ALKLEENZ FACILITY MANAGEMENT PRIVATE LIMITED",
"ALKO PLUS TECHNOSAFE PRIVATE LIMITED",
"ALKOM PARTITIONING SYSTEMS PRIVATE LIMITED",
"ALKOMEX PHARMA PRIVATE LIMITED",
"ALKON FORMULATION PRIVATE LIMITED",
"ALKON PLASTICS PRIVATE LIMITED",
"ALKOSH GLOBAL SOLUTIONS PRIVATE LIMITED",
"ALKOSIGN LIMITED",
"ALKOXIDE FINE CHEM PRIVATE LIMITED",
"ALKR MARKETING PRIVATE LIMITED",
"ALKRAFT THERMOTECHNOLOGIES PRIVATE LIMITED",
"ALKUSH INDUSTRIES PRIVATE LIMITED",
"ALKYL AMINES CHEMICALS LIMITED",
"ALL ABOUT LOGISTICS PRIVATE LIMITED",
"ALL ABOUT OUTDOOR PRIVATE. LIMITED.",
"ALL ARCH INDIA PRIVATE LIMITED",
"ALL AROUND GLOBE SERVICES PRIVATE LIMITED",
"ALL BOUND LOGISTICS PRIVATE LIMITED",
"ALL BROTHERS PASTRIES PRIVATE LIMITED",
"ALL CAD SERVICES PRIVATE LIMITED",
"ALL CLOUD ENTERPRISISE SOLUTIONS",
"ALL E CONSULTING PRIVATE LIMITED",
"ALL E TECHNOLOGIES LIMITED",
"ALL E TECHNOLOGIES PRIVATE LIMITED",
"ALL HUDA URDU HIGHSCHOOL BHOKARDAN",
"ALL I INST OF LOCAL SELF GOVT",
"ALL IN MERCHANDISE PRIVATE LIMITED",
"ALL IN ONE PHARMA PRIVATE LIMITED",
"ALL INDIA CLEARING AND FORWARDING PRIVATE LIMITED",
"ALL INDIA COUNCIL FOR TECHNICAL EDUCATION",
"ALL INDIA DIGITAL CABLE FEDERATION",
"ALL INDIA FOOD SUPPLY PRIVATE LIMITED",
"ALL INDIA GEM AND JEWELLERYY DOMESTIC COUNCIL",
"ALL INDIA GLASS WORKS PRIVATE LIMITED",
"ALL INDIA HAJJ & UMRAH TOURS PRIVATE LIMITED",
"ALL INDIA HEART FOUND HEART INST",
"ALL INDIA HING SUPPLYING PRIVATE LIMITED",
"ALL INDIA INSTITUTE OF HYGIENE AND PUBLIC HEALTH",
"ALL INDIA INSTITUTE OF LOCAL SELF GOVERNMENT",
"ALL INDIA INSTITUTE OF MEDICAL SCIENCE",
"ALL INDIA INSTITUTE OF PHYSICAL MEDICINE AND REHABILITATION",
"ALL INDIA MANAGEMENT ASSOCIATION",
"ALL INDIA POSTAL EMPLOYEES UNION GROUP C",
"ALL INDIA POULTRY DEVELOPMENT AND SERVICES PRIVATE LIMITED",
"ALL INDIA RADIO",
"ALL INDIA REPORTER PRIVATE LIMITED",
"ALL INDIA RUBBER INNDUSTRIES ASSOCIATION",
"ALL INDIA SKIN AND HAIR HOSPITAL",
"ALL INDIA TECHNOLOGIES LIMITED",
"ALL INDIA TRAVEL AGENCY PRIVATE LIMITED",
"ALL INDIA WAREHOUSING PRIVATE LIMITED",
"ALL MEASURE TECHNOLOGIES PRIVATE LIMITED",
"ALL METALS AND ALLOYS PRIVATE LIMITED",
"ALL NATURE GREEN PRIVATE LIMITED",
"ALL NIPPON AIRWAYS CO LIMITED",
"ALL NIPPON AIRWAYS CO. LIMITED.",
"ALL OFFICE SOLUTIONS TRADING PRIVATE LIMITED",
"ALL RICH DAIRY PRIVATE LIMITED",
"ALL ROUND CREATIONS AND MARKETING PVT. LTD.",
"ALL ROUND ENTERPRISES PRIVATE LIMITED",
"ALL ROUND SECURITY SERVICES PRIVATE LIMITED",
"ALL SAINTS' HIGH SCHOOL",
"ALL SAINTS SCHOOL",
"ALL SEASONS GARMENTS PRIVATE LIMITED",
"ALL SERVICES GLOBAL PRIVATE LIMITED",
"ALL SKY FOOTWEAR PRIVATE LIMITED",
"ALL SKY MARKETING PRIVATE LIMITED",
"ALL STATE FINANCIAL SERVICES PRIVATE LIMITED",
"ALL STATE TECHNOLOGIES",
"ALL TECH AUTOMOBILES PRIVATE LIMITED",
"ALL THAT DIPS PRIVATE LIMITED",
"ALL THAT JAZZ EVENTS & ENTERTAINMENT PRIVATE LIMITED",
"ALL THINGS BABY INDIA PRIVATE LIMITED",
"ALL TIME COURIER'S & CARGO PRIVATE LIMITED",
"ALL TIME DATA PRIVATE LIMITED",
"ALL TIME FOODS PVT.LTD.",
"ALL TIME NUTRITION PRIVATE LIMITED",
"ALL TIME PLASTICS PRIVATE LIMITED",
"ALL TIME SECURITIES PRIVATE LIMITED",
"ALL TRADE CONSULTANTS PRIVATE LIMITED",
"ALL WAVE AV PRIVATE LIMITED",
"ALL WAYS CARRIERS PRIVATE LIMITED",
"ALL WAYS LOGISTICS INDIA PRIVATE LIMITED",
"ALL WELD SOLUTION PRIVATE LIMITED",
"ALL WELL HOSPITAL & RESEARCH INSTITUTE PRIVATE LIMITED",
"ALL WORLD CARGO LINES PRIVATE LIMITED",
"ALLA MODA KNITWEAR PRIVATE LIMITED",
"ALLABOUT INNOVATIONS PRIVATE LIMITED",
"ALLAHABAD AGRO COMMODITIES PRIVATE LIMITED",
"ALLAHABAD BANK",
"ALLAHABAD BYPASS PATHWAYS PRIVATE LIMITED",
"ALLAHABAD CANNING LIMITED",
"ALLAHABAD CAPS PRIVATE LIMITED",
"ALLAHABAD CONSTRUCTIONS PRIVATE LIMITED",
"ALLAHABAD ENTERPRISES PRIVATE LIMITED",
"ALLAHABAD KISAAN PRODUCER COMPANY LIMITED",
"ALLAHABAD MEDICAL AND RESEARCH CENTER PRIVATE LIMITED",
"ALLAHABAD PATRIKA PVT LTD",
"ALLAHABAD PUBLIC SCHOOL",
"ALLAM INFINITE INDIA PRIVATE LIMITED",
"ALLAMA SHIBLI URDU HIGH SCHOOL",
"ALLAN SMITH ENGINEERING PRIVATE LIMITED",
"ALLANA COLD STORAGE PRIVATE LIMITED",
"ALLANA EXPORTS PRIVATE LIMITED",
"ALLANA INVESTMENTS AND TRADING COMPANY PRIVATE LIMITED",
"ALLANASONS PRIVATE LIMITED",
"ALLANS MEDICAL SYSTEMS PRIVATE LIMITED",
"ALLARK DISPLAY SYSTEM PRIVATE LIMITED",
"ALLASTIR PRIVATE LIMITED",
"ALLAYSOL PRIVATE LIMITED",
"ALLBOUND GLOBAL FREIGHT PRIVATE LIMITED",
"ALLBRIGHT ELECTRICALS PVT.LTD.",
"ALLBRIGHT PACKAGING PRIVATE LIMITED",
"ALLCARE BUILDERS AND TRADERS (INDIA) PRIVATE LIMITED",
"ALLCARGO LOGISTICS & INDUSTRIAL PARK PRIVATE LIMITED",
"ALLCARGO LOGISTICS LIMITED",
"ALLCARGO LOGISTICS PARK PRIVATE LIMITED",
"ALLCARGO MULTIMODAL PRIVATE LIMITED",
"ALLCARGO SHIPPING SERVICES PRIVATE LIMITED",
"ALLCARGO TERMINALS LIMITED",
"ALLCAST METALS PRIVATE LIMITED",
"ALLCHECKDEALS INDIA PRIVATE LIMITED",
"ALLCHEM BIO SCIENCES PRIVATE LIMITED",
"ALLCHEM LIFESCIENCE PRIVATE LIMITED",
"ALLCLOUD ENTERPRISE SOLUTIONS PRIVATE LIMITED",
"ALLCOM WORLDWIDE TRADING PRIVATE LIMITED",
"ALLDAY BISCUITS PRIVATE LIMITED",
"ALLDAY PHARMA PRIVATE LIMITED",
"ALLDOMAINSOFT.COM PRIVATE LIMITED",
"ALLEARTH ORGANIC FOODS PRIVATE LIMITED",
"ALLEE CIVIL PROJECTS PRIVATE LIMITED",
"ALLEGHANY CORPORATION",
"ALLEGHENY TECHNOLOGIES ASIA INC.",
"ALLEGIANCE CONBUILD PRIVATE LIMITED",
"ALLEGIANCE FINVEST SERVICES PRIVATE LIMITED",
"ALLEGIANCE WORKMATE PRIVATE LIMITED",
"ALLEGIANT BUILDING SYSTEMS PRIVATE LIMITED",
"ALLEGIANT REAL TORS LLP",
"ALLEGION INDIA PRIVATE LIMITED",
"ALLEGIS GLOBAL SOLUTIONS (INDIA) PRIVATE LIMITED",
"ALLEGIS SERVICES INDIA PRIVATE LIMITED",
"ALLEGRO CAPITAL ADVISORS PRIVATE LIMITED",
"ALLEGRO CAPITAL PRIVATE LIMITED",
"ALLEGRO HOLDINGS PRIVATE LIMITED",
"ALLEGRO INSURANCE BROKERS PRIVATE LIMITED",
"ALLEGRO PHARMACEUTICALS PRIVATE LIMITED",
"ALLEGRO SECURITIES PRIVATE LIMITED",
"ALLEGRO SPECIALITY CHEMICALS PRIVATE LIMITED",
"ALLEIMA INDIA PRIVATE LIMITED",
"ALLEIN MARKETING PRIVATE LIMITED",
"ALLEN AND ALVAN PVT LTD",
"ALLEN BIOPHARMA LIMITED",
"ALLEN BUILDWELL PRIVATE LIMITED",
"ALLEN HEALTH CARE CO LIMITED",
"ALLEN HOMOEO AND HERBAL PRODUCTS LIMITED",
"ALLEN HOMOEO INTERNATIONAL PRIVATE LIMITED",
"ALLEN INDUSTRIES LIMITED",
"ALLEN LABORATORIES LIMITED",
"ALLEN MULTITADING PRIVATE LIMITED",
"ALLEN REINFORCED PLASTICS PRIVATE LIMITED",
"ALLEN SOLLY",
"ALLENA AUTO INDUSTRIES PRIVATE LIMITED",
"ALLENBY REAL ESTATE PRIVATE LIMITED",
"ALLENE OVERSEAS PRIVATE LIMITED",
"ALLENGERS GLOBAL HEALTHCARE PRIVATE LIMITED",
"ALLENGERS INFOTECH PRIVATE LIMITED",
"ALLENGERS MEDICAL SYSTEMS LIMITED",
"ALLENHOUSE BUSINESS SCHOOL",
"ALLENHOUSE PUBLIC SCHOOL",
"ALLEN'S INDIA LTD.",
"ALLENTIS PHARMACEUTICALS PRIVATE LIMITED",
"ALLEPPEY DISTRICT CO-OP BANK",
"ALLEPPEY FIBRETUFT PRIVATE LIMITED",
"ALLEPPEY LATEX PVT LTD",
"ALLERGAN INDIA PRIVATE LIMITED",
"ALLERGIMMUNO DIAGNOSTICS PRIVATE LIMITED",
"ALLERN ENTERPRISES PRIVATE LIMITED",
"ALLES INFRA TELECOM PRIVATE LIMITED",
"ALLESPACK SYSTEMS PRIVATE LIMITED",
"ALLEVENTS INFORMATIONS PRIVATE LIMITED",
"ALLEVIARE LIFE SCIENCES PRIVATE LIMITED",
"ALLEVIATE LIFESCIENCE PRIVATE LIMITED",
"ALLEVIATE MANAGEMENT SERVICES PRIVATE LIMITED",
"ALLEVIATE PHARMACEUTICALS PRIVATE LIMITED",
"ALLFINE INDUSTRIES PRIVATE LIMITED",
"ALLFLEX INDIA PRIVATE LIMITED",
"ALLFREIGHT LOGISTICS PRIVATE LIMITED",
"ALLFRESH SUPPLY MANAGEMENT PRIVATE LIMITED",
"ALLGOVISION TECHNOLOGIES PRIVATE LIMITED",
"ALLGRACE DEVELOPERS PRIVATE LIMITED",
"ALLGROW FINANCE AND INVESTMENT PRIVATE LIMITED",
"ALLIAGE METAL CASTINGS PRIVATE LIMITED",
"ALLIANCE ADVERTISING AND MARKETING PRIVATE LIMITED",
"ALLIANCE AIR AVIATION LIMITED",
"ALLIANCE ASSURE PRIVATE LIMITED",
"ALLIANCE AUTOMATION SYSTEMS PRIVATE LIMITED",
"ALLIANCE AUTOMOBILES PRIVATE LIMITED",
"ALLIANCE AUTOMOTIVES PRIVATE LIMITED",
"ALLIANCE BIOMEDICA PRIVATE LIMITED",
"ALLIANCE BROAD BAND SERVICES PRIVATE LIMITED",
"ALLIANCE BROADBAND SERVICES PRIVATE LIMITED",
"ALLIANCE BROADCASTING PRIVATE LIMITED",
"ALLIANCE BUSINESS PARKS PRIVATE LIMITED",
"ALLIANCE BUSINESS SCHOOL",
"ALLIANCE CAR CARRIER PRIVATE LIMITED",
"ALLIANCE CELLULOSE INDIA PRIVATE LIMITED",
"ALLIANCE CITY DEVELOPERS REALTORS PRIVATE LIMITED",
"ALLIANCE COMMERCIAL TRANSPORT",
"ALLIANCE COMMUNICATION PRIVATE LIMITED",
"ALLIANCE CONTROLS PRIVATE LIMITED",
"ALLIANCE COPPER CONCEPTS PRIVATE LIMITED",
"ALLIANCE DEALERS PRIVATE LIMITED",
"ALLIANCE DENTAL CARE LIMITED",
"ALLIANCE DIGITECH PRIVATE LIMITED",
"ALLIANCE DISPLAY FORMS PRIVATE LIMITED",
"ALLIANCE EMBROIDERY MACHINE PRIVATE LIMITED",
"ALLIANCE ENVIROCARE COMPANY PRIVATE LIMITED",
"ALLIANCE FIBRES LIMITED",
"ALLIANCE FILAMENTS LIMITED",
"ALLIANCE FRANCAISE",
"ALLIANCE FRANCAISE DE DELHI",
"ALLIANCE FREIGHT CARRIER PRIVATE LIMITED",
"ALLIANCE FRICTION TECHNOLOGY PRIVATE LIMITED",
"ALLIANCE GRANIMARMO PRIVATE LIMITED",
"ALLIANCE SPACES PRIVATE LIMITED",
"ALLIANCE INFO TEL PRIVATE LIMITED",
"ALLIANCE INFOTECH PRIVATE LIMITED",
"ALLIANCE INFRASTRUCTURE PROJECTS PRIVATE LIMITED",
"ALLIANCE INFRATECH PRIVATE LIMITED",
"ALLIANCE INN INDIA PRIVATE LIMITED",
"ALLIANCE INSURANCE BROKERS PRIVATE LIMITED",
"ALLIANCE INTEGRATED METALIKS LIMITED",
"ALLIANCE INTERLINK PRIVATE LIMITED",
"ALLIANCE MACHINES PRIVATE LIMITED",
"ALLIANCE MALL DEVELOPERS CO PRIVATE LIMITED",
"ALLIANCE MARINE AGENCIES PRIVATE LIMITED",
"ALLIANCE MARITIME PRIVATE LIMITED",
"ALLIANCE MEDIA AND ENTERTAINMENT PRIVATE LIMITED",
"ALLIANCE MEDICAL EQUIPMENTS PRIVATE LIMITED",
"ALLIANCE MEDIEQUIP PRIVATE LIMITED",
"ALLIANCE MEDITECH PRIVATE LIMITED",
"ALLIANCE MERCHANDISING COMPANY PRIVATE LIMITED",
"ALLIANCE METAWARE PRIVATE LIMITED",
"ALLIANCE MILLS (LESSEES) LTD",
"ALLIANCE MULTISPECIALITY HOSPITAL LLP",
"ALLIANCE MULTI-TECH PRIVATE LIMITED",
"ALLIANCE OF DIGITAL INDIA FOUNDATION",
"ALLIANCE ONE INDUSTRIES INDIA PRIVATE LIMITED",
"ALLIANCE OUTSOURCING PRIVATE LIMITED",
"ALLIANCE OVERSEAS PRIVATE LIMITED",
"ALLIANCE POLYSACKS PRIVATE LIMITED",
"ALLIANCE POLYTECH PRIVATE LIMITED",
"ALLIANCE PRINTECH PRIVATE LIMITED",
"ALLIANCE PRO IT PRIVATE LIMITED",
"ALLIANCE PROJECTS",
"ALLIANCE PROJECTS AND ENGINEERING SERVICES PRIVATE LIMITED",
"ALLIANCE QUARRIES MINES PRIVATE LIMITED",
"ALLIANCE SECURITY AND ALLIED SERVICES PRIVATE LIMITED",
"ALLIANCE STRATEGIES LIMITED",
"ALLIANCE STRUCTURAL ENGINEERS PRIVATE LIMITED",
"ALLIANCE SUPER FINE INDUSTRIES LIMITED",
"ALLIANCE TECH SOLUTION PRIVATE LIMITED",
"ALLIANCE TECHNOCRATS PRIVATE LIMITED",
"ALLIANCE TEXTILES PRIVATE LIMITED",
"ALLIANCE TRADEVISION PRIVATE LIMITED",
"ALLIANCE TRANSCON PRIVATE LIMITED",
"ALLIANCE TRANSFUSION PRIVATE LIMITED",
"ALLIANCE UDYOG LTD.",
"ALLIANCE UNIVERSITY",
"ALLIANCE VITRIFIED PRIVATE LIMITED",
"ALLIANCE WEB SOLUTION PRIVATE LIMITED",
"ALLIANCE WINDING EQUIPMENT INDIA PRIVATE LIMITED",
"ALLIANCE WORLD MANUFACTURING LIMITED",
"ALLIANCECARE BIOLIFESCIENCES PRIVATE LIMITED",
"ALLIANCEIT AND CSS PRIVATE LIMITED",
"ALLIANT ADVISORY SERVICES PRIVATE LIMITED",
"ALLIANT TECHSOL PRIVATE LIMITED",
"ALLIANTGROUP INDIA TALENT PRIVATE LIMITED",
"ALLIANZ ALKALIES PRIVATE LIMITED",
"ALLIANZ BIOSCIENCES PRIVATE LIMITED",
"ALLIANZ BULK CARRIERS MANAGEMENT SERVICES PRIVATE LIMITED",
"ALLIANZ CLOUD PRIVATE LIMITED",
"ALLIANZ ECOPOWER PRIVATE LIMITED",
"ALLIANZ FMCG PRIVATE LIMITED",
"ALLIANZ OFFSHORE SERVICES PRIVATE LIMITED",
"ALLIANZ SERVICES PRIVATE LIMITED",
"ALLIANZ TECHNOLOGY SE",
"ALLIANZ TRANS ALLOY PRIVATE LIMITED",
"ALLIANZ TRANSFORMERS PRIVATE LIMITED",
"ALLIE INDUSTRIAL EQUIPMENT PRIVATE LIMITED",
"ALLIED AERO SYSTEMS PRIVATE LIMITED",
"ALLIED AGRITECH PRIVATE LIMITED",
"ALLIED AGROCAST PRIVATE LIMITED",
"ALLIED AIR PRODUCTS PRIVATE LIMITED",
"ALLIED ANALYTICS LLP",
"ALLIED AUTO AGENCIES PRIVATE LIMITED",
"ALLIED AUTOMATION ENGINEERING SERVICES PRIVATE LIMITED",
"ALLIED AUTOTECH (INTERNATIONAL) PRIVATE LIMITED",
"ALLIED AUTOWHEELS SILIGURI PRIVATE LIMITED",
"ALLIED AVIATION INTERNATIONAL PRIVATE LIMITED",
"ALLIED AVIATION PRIVATE LIMITED",
"ALLIED BIOTECHNOLOGY INDIA PRIVATE LIMITED",
"ALLIED BLENDERS AND DISTILLERS LIMITED",
"ALLIED BLENDERS AND DISTILLERS PRIVATE LIMITED",
"ALLIED CAPS AND CLOSURES PRIVATE LIMITED",
"ALLIED CARBIDES PRIVATE LIMITED",
"ALLIED CARGO SERVICES (INDIA) PRIVATE LIMITED",
"ALLIED CASTALLOYS (INDIA) PRIVATE LIMITED",
"ALLIED CERAMICS PVT LTD",
"ALLIED CHEMICALS AND PHARMACEUTICALS PRIVATE LIMITED",
"ALLIED COMMODITIES PVT LTD",
"ALLIED CONCEPTS INDIA PRIVATE LIMITED",
"ALLIED DIGITAL SERVICES LIMITED",
"ALLIED ELECTRO-MECHANICALS PRIVATE LIMITED",
"ALLIED ELECTRONICS AND MAGNETICS LIMITED",
"ALLIED ELECTRONICS AND MAGNETICS PRIVATE LIMITED",
"ALLIED ENGINEERING AND INFRASTRUCTURE PRIVATE LIMITED",
"ALLIED ENGINEERING PRIVATE LIMITED",
"ALLIED ENGINEERING WORKS PRIVATE LIMITED",
"ALLIED EXIM AND CONSTRUCTION CO. PRIVATE LIMITED",
"ALLIED FERROMET PRIVATE LIMITED",
"ALLIED FOAMS PRIVATE LIMITED",
"ALLIED FURNACES PRIVATE LIMITED",
"ALLIED GLASSES PRIVATE LIMITED",
"ALLIED GLOBAL PLASTICS PRIVATE LIMITED",
"ALLIED GLOBETECH LLP",
"ALLIED GROW TECH SOLUTIONS PRIVATE LIMITED",
"ALLIED HEALTHSCIENCES PRIVATE LIMITED",
"ALLIED HITECH INDUSTRIES PRIVATE LIMITED",
"ALLIED HTI PRIVATE LIMITED",
"ALLIED ICD SERVICES LIMITED",
"ALLIED INFOSOFT",
"ALLIED INFRADEVELOPMENT PRIVATE LIMITED",
"ALLIED INFRASTRUCTURES & PROJECTS PRIVATE LIMITED",
"ALLIED INFRATECH PRIVATE LIMITED",
"ALLIED INSTRUMENTS PRIVATE LIMITED",
"ALLIED INTEGRATED SECURE SOLUTIONS PRIVATE LIMITED",
"ALLIED INTERNATIONAL SHARED SERVICES PRIVATE LIMITED",
"ALLIED INTERTRADE COMPANY LIMITED",
"ALLIED INVESTMENTS AND HOUSING PRIVATE LIMITED",
"ALLIED IRON PRODUCTS PRIVATE LIMITED",
"ALLIED ISPAT PRIVATE LIMITED",
"ALLIED JB FRICTION PRIVATE LIMITED",
"ALLIED KEYMAIL EXPRESS (INDIA) PRIVATE LIMITED",
"ALLIED KNOWLEDGE SOLUTIONS PRIVATE LIMITED",
"ALLIED KRISHNA PROCESSING INDUSTRIES PRIVATE LIMITED",
"ALLIED LABELS PRIVATE LIMITED",
"ALLIED LEATHER FINISHERS PRIVATE LIMITED",
"ALLIED LOGISTIC PRIVATE LIMITED",
"ALLIED LOGISTICS PRIVATE LIMITED",
"ALLIED MEDIA INNOTECH PRIVATE LIMITED",
"ALLIED MEDIA NETWORK PRIVATE LIMITED",
"ALLIED MEDICAL LIMITED",
"ALLIED MEDIPHARMA PRIVATE LIMITED",
"ALLIED METAL & ALLOYS IMPEX PRIVATE LIMITED",
"ALLIED METALLURGICAL PRODUCTS LIMITED",
"ALLIED METALLURGICAL PRODUCTS PRIVATE LIMITED",
"ALLIED METALS INDIA PRIVATE LIMITED",
"ALLIED MINERALS INDUSTRIES PRIVATE LIMITED",
"ALLIED MOTORS LIMITED",
"ALLIED MOULDED ENCLOSURE PRODUCTS INDIA PRIVATE LIMITED",
"ALLIED MULTIMETALS & ALLOYS PRIVATE LIMITED",
"ALLIED NIPPON PRIVATE LIMITED",
"ALLIED NOVATECH PRIVATE LIMITED",
"ALLIED OFFSET PRINTERS (GUJARAT ) PVT LTD",
"ALLIED OUTFITTERS LIMITED",
"ALLIED PHOTOGRAPHICS INDIA LIMITED",
"ALLIED PIG IRON TRADING CO PVT LTD",
"ALLIED PROPACK PRIVATE LIMITED",
"ALLIED PUBLISHERS PRIVATE LIMITED",
"ALLIED RECYCLING LIMITED",
"ALLIED REFRACTORY PRODUCTS INDIA PRIVATE LIMITED",
"ALLIED RESOURCE MANAGEMENT INDIA PRIVATE LIMITED",
"ALLIED RESOURCE MANAGEMENT SERVICESINDIA PRIVATE LIMITED",
"ALLIED SAFETY EQUIPMENTS PRIVATE LIMITED",
"ALLIED SIGNAL INTERNATIONAL INC",
"ALLIED SOFTECH PRIVATE LIMITED",
"ALLIED SOLUTIONS I PRIVATE LIMITED",
"ALLIED SPARES AND AUTO PARTS MFG COMPANY PVT LTD",
"ALLIED SPECIALITY PAPERS (INDIA) PRIVATE LIMITED",
"ALLIED SUPPER LOGISTICS PRIVATE LIMITED",
"ALLIED SURGICAL EMPORIUM PRIVATE LIMITED",
"ALLIED TECHNO SERVICES PRIVATE LIMITED",
"ALLIED TELENET PRIVATE LIMITED",
"ALLIED TELESIS INDIA PRIVATE LIMITED",
"ALLIED TRADE-COM PRIVATE LIMITED",
"ALLIED TRANSMISSION AND GEARS PRIVATE LIMITED",
"ALLIED TUBES PRIVATE LIMITED",
"ALLIED UDYOG PVT LTD",
"ALLIED WESTLAKE PRIVATE LIMITED",
"ALLIED WIND POWERS PRIVATE LIMITED",
"ALLIED WORLDWIDE BUSINESS SOLUTIONS PRIVATE LIMITED",
"ALLIEDINDIA IRON AND STEELS PRIVATE LIMITED",
"ALLIES CONSTRUCTION PRIVATE LIMITED",
"ALLIES FIRE SYSTEMS PRIVATE LIMITED",
"ALLIES INTERACTIVE SERVICES PRIVATE LIMITED",
"ALLIEVA PHARMA PRIVATE LIMITED",
"ALLIGATE CARGO LOGISTICS PRIVATE LIMITED",
"ALLIGATOR AUTOMATIONS PRIVATE LIMITED",
"ALLIGN HOSPITALITY SERVICES PRIVATE LIMITED",
"ALLIGO HORIZON PRIVATE LIMITED",
"ALLIN IMPEX SERVICES PRIVATE LIMITED",
"ALLIN INFO SYSTEMS",
"ALLINCALL RESEARCH AND SOLUTIONS PRIVATE LIMITED",
"ALLINFO INDIA PRIVATE LIMITED",
"ALLINMOTION STUDIOS PRIVATE LIMITED",
"ALLINS WEALTHPRO INDIA PRIVATE LIMITED",
"ALLISON TRANSMISSION INDIA PRIVATE LIMITED",
"ALLITES LIFE SCIENCES PRIVATE LIMITED",
"ALLIUM FINANCE PRIVATE LIMITED",
"ALLIX CERAMIC PRIVATE LIMITED",
"ALLMARC INDUSTRIES PRIVATE LIMITED",
"ALLMARK DEVICE INTEGRATIONS PRIVATE LIMITED",
"ALL-MART SUPER MARKET PRIVATE LIMITED",
"ALLNET BROADBAND NETWORK PRIVATE LIMITED",
"ALLNEX RESINS INDIA PRIVATE LIMITED",
"ALLOCEAN EDIBLES PRIVATE LIMITED",
"ALLOES PHARMACEUTICALS PRIVATE LIMITED",
"ALLOL CREATION PRIVATE LIMITED",
"ALLOL SAREES PRIVATE LIMITED",
"ALLONE INFRA PRIVATE LIMITED",
"ALLONSY VENTURES PRIVATE LIMITED",
"ALLOTAL STEEL PRIVATE LIMITED",
"ALLOTROPE (INDIA) PVT.LTD.",
"ALLOY CAST PVT LTD",
"ALLOY STEEL PLANT",
"ALLOY STEELS EMPORIUM PRIVATE LIMITED",
"ALLOY THERMAL SPRAY PRIVATE LIMITED",
"ALLOY WAREHOUSE & INTERIORS LLP",
"ALLOYAGE TRIANGLE PRIVATE LIMITED",
"ALLOYCRAFT STEEL PRIVATE LIMITED",
"ALLOYSMIN INDIA PRIVATE LIMITED",
"ALLOZEN PHARMA PRIVATE LIMITED",
"ALLPHARMA CARE PRIVATE LIMITED",
"ALLPORT INTERNATIONAL PRIVATE LIMITED",
"ALLROUND (INDIA) VEGETABLE PROCESSING MACHINES PRIVATE LIMITED",
"ALLSAFE TECHNOLOGIES PRIVATE LIMITED",
"ALTERA DIGITAL HEALTH (INDIA) LLP",
"ALLSEAS GLOBAL LOGISTICS INDIA PRIVATE LIMITED",
"ALL-SEASON HERBS PRIVATE LIMITED",
"ALLSEC TECHNOLOGIES LIMITED",
"ALLSERVE MARKETING AND CONSULTING SERVICES PRIVATE LIMITED",
"ALLSILKS DESIGNERS PRIVATE LIMITED",
"ALLSTAR SHIPPING PRIVATE LIMITED",
"ALLSTATE INDIA PRIVATE LIMITED",
"ALLSTONE MINES & MINERALS PRIVATE LIMITED",
"ALLSURE SERVICES PRIVATE LIMITED",
"ALLSWAGE HOSE AND FITTINGS PRIVATE LIMITED",
"ALLTAKE ITES PRIVATE LIMITED",
"ALLTECH BIOTECHNOLOGY PRIVATE LIMITED",
"ALLTECH INDUSTRIES INDIA PRIVATE LIMITED",
"ALLTECH TECHNOCAST PRIVATE LIMITED",
"ALLTEX EXIM PRIVATE LIMITED",
"ALLTICKS CORPORATE SERVICES PRIVATE LIMITED",
"ALLTIME FITNESS PRIVATE LIMITED",
"ALLTIME LOGISTIC PRIVATE LIMITED",
"ALLTIMEIT SOLUTIONS PRIVATE LIMITED",
"ALLTOIT TECHNOLOGY PRIVATE LIMITED",
"ALLTRADE CONSTRUCTION PRIVATE LIMITED",
"ALL-TRANS SHIPPING & LOGISTIC PRIVATE LIMITED",
"ALLUCENT",
"ALLUMER MEDICAL PRIVATE LIMITED",
"ALLURE ENTERPRISES PRIVATE LIMITED",
"ALLURE EXPORTS PRIVATE LIMITED",
"ALLURE GIFT WRAPS PRIVATE LIMITED",
"ALLURE HAIR PRODUCTS PRIVATE LIMITED",
"ALLURE JEWELLERY PRIVATE LIMITED",
"ALLURE POLYPLAST PRIVATE LIMITED",
"ALLURE SOFTWARE PRIVATE LIMITED",
"ALLURE TRAVELSEVA SERVICES PRIVATE LIMITED",
"ALLURI SITARAMA RAJU EDUCATIONAL SOCIETY",
"ALLVANT INFRASTRUCTURE PRIVATE LIMITED",
"ALLVY SOFTWARE SOLUTIONS PRIVATE LIMITED",
"ALLWEILER INDIA PRIVATE LIMITED",
"ALLWELD ENGINEERS PRIVATE LIMITED AEPL",
"ALLWIN BRUSHES (INDIA) PRIVATE LIMITED",
"ALLWIN CHEMICAL AND FERTILIZERS PRIVATE LIMITED",
"ALLWIN DECOR PRIVATE LIMITED",
"ALLWIN INFRASTRUCTURE LIMITED",
"ALLWIN JEWELLERS PRIVATE LIMITED",
"ALLWIN MARINE SERVICES PRIVATE LIMITED",
"ALLWIN SECURITIES LIMITED",
"ALLWORLD TRADE PRIVATE LIMITED",
"ALLWORTH INFRA PRIVATE LIMITED",
"ALLWORTH NIRMAN PRIVATE LIMITED",
"ALLWYN BIKES PRIVATE LIMITED",
"ALLWYN TEX PRIVATE LIMITED",
"ALLY CHEM LABORATORIES PRIVATE LIMITED",
"ALLY FINANCIAL INC.",
"ALLY PACKAGING SYSTEMS PRIVATE LIMITED",
"ALLY WIRED SOFT SOLUTIONS PRIVATE LIMITED",
"ALLYGRAM SYSTEMS AND TECHNOLOGIES PRIVATE LIMITED",
"ALLYGROW TECHNOLOGIES PRIVATE LIMITED",
"ALLYIS INDIA PRIVATE LIMITED",
"ALLYN INTL SERVICES INDIA PRIVATE LIMITED",
"ALLYPHARMACIA INDIAPRIVATE LIMITED",
"ALLYSA E-RETAIL PRIVATE LIMITED",
"ALLYSIA LIFESCIENCES PRIVATE LIMITED",
"ALLYSMART BUSINESS PROCESS SOLUTIONS INDIA PRIVATE LIMITED",
"ALLYSON AGRO INDUSTRIES PRIVATE LIMITED",
"ALLYVENTURE (INDIA) PRIVATE LIMITED",
"ALLZONE MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"ALM ENGINEERING AND INSTRUMENTATION PRIVATE LIMITED",
"ALM FOOD PRODUCTS LIMITED",
"ALM INFOTECH CITY PRIVATE LIMITED",
"ALMA LASERS INDIA PRIVATE LIMITED",
"ALMA MATER MATTERS PRIVATE LIMITED",
"ALMA MATER THE SCHOOL",
"ALMA MEDICAL PRIVATE LIMITED",
"ALMA SPECIALTY CHEMICALS PRIVATE LIMITED",
"ALMAA HERBAL NATURE PRIVATE LIMITED",
"ALMABASE INDIA PRIVATE LIMITED",
"ALMAC LASER PRIVATE LIMITED",
"ALMAMET INDIA PRIVATE LIMITED",
"ALMANSOORI PETROLEUM SERVICES LLC",
"ALMARK MARKETING PRIVATE LIMITED",
"ALMAS ELECTROMECH PRIVATE LIMITED",
"ALMAS EXPORTS AND IMPORTS PVT LTD",
"ALMAS JEWELS PRIVATE LIMITED",
"ALMAS LIFTS PRIVATE LIMITED",
"ALMAS STEEL AND ALLOYS PRIVATE LIMITED",
"ALMATIN ENERGY PRIVATE LIMITED",
"ALMATIS ALUMINA PRIVATE LIMITED",
"ALMATS BRANDING SOLUTIONS PRIVATE LIMITED",
"AL-MAX FOODS PRIVATE LIMITED",
"ALMAX POLYMERS PRIVATE LIMITED",
"ALMAZ CORRUGATORS PRIVATE LIMITED",
"ALMAZ ROOFING SHEETS PRIVATE LIMITED",
"ALMEC MACHINING SOLUTIONS PRIVATE LIMITED",
"ALMECH FABS PRIVATE LIMITED",
"ALMECH FACADES PRIVATE LIMITED",
"ALMED LABORATORIES PRIVATE LIMITED",
"ALMEER TECHNICAL SERVICES CO. W.L.L.",
"ALMEGA PAINTS PRIVATE LIMITED",
"AL-MEHDIYAH PROPERTY PRIVATE LIMITED",
"ALMEHTAB INDUSTRIES PRIVATE LIMITED",
"ALMEHTAB PROJECTS PRIVATE LIMITED",
"AL-MELA MARKETING PRIVATE LIMITED",
"ALMELO PRIVATE LIMITED",
"ALMET CASTINGS PRIVATE LIMITED",
"ALMET HEALTHCARE PRIVATE LIMITED",
"ALMETAL INDUSTRIES PRIVATE LIMITED",
"ALMETECH AUTOMATION INDIA PRIVATE LIMITED",
"ALMEX INDUSTRIES PRIVATE LIMITED",
"ALMIGHTY AGROTECH PRIVATE LIMITED",
"ALMIGHTY AUTO ANCILLARY PRIVATE LIMITED",
"ALMIGHTY CREATIONS PRIVATE LIMITED",
"ALMIGHTY CROP SCIENCE PRIVATE LIMITED",
"ALMIGHTY INFRAHEIGHTS PRIVATE LIMITED",
"ALMIGHTY NUTRITIONS PRIVATE LIMITED",
"ALMIGHTY RESOURCES PRIVATE LIMITED",
"ALMIGHTY RING FORGINGS PRIVATE LIMITED",
"ALMIGHTY SHIPPING AND LOGISTICS PRIVATE LIMITED",
"ALMIGHTY VENTURES PRIVATE LIMITED",
"AL-MIR RUBBER MALL PRIVATE LIMITED",
"ALMIV RETAIL PRIVATE LIMITED",
"ALMIYA ENGINEERING CONSULTANTS PRIVATE LIMITED",
"ALMIYA FUTURE ENERGIES PRIVATE LIMITED",
"ALMO DIGITAL PRIVATE LIMITED",
"ALMO EXPORTS PRIVATE LIMITED",
"ALMO LAMINATES PRIVATE LIMITED",
"ALMOE DIGITAL SOLUTIONS PRIVATE LIMITED",
"ALMONARD PRIVATE LIMITED",
"ALMOND BRANDING PRIVATE LIMITED",
"ALMOND HOUSE PRIVATE LIMITED",
"ALMOND INFRABUILD PRIVATE LIMITED",
"ALMONDS HEALTH CARE PRIVATE LIMITED",
"ALMONDZ COMMODITIES PRIVATE LIMITED",
"ALMONDZ FINANCIAL SERVICES LIMITED",
"ALMONDZ FINANZ LIMITED",
"ALMONDZ GLOBAL INFRA-CONSULTANT LIMITED",
"ALMONDZ GLOBAL SECURITIES LIMITED",
"ALMONDZ WEALTH ADVISORS LIMITED",
"ALMONTROZ HOSPITALITY PRIVATE LIMITED",
"ALMORA MAGNESITE LIMITED",
"ALMORA URBAN CO-OPERATIVE BANK LTD",
"ALMS FOODS PRIVATE LIMITED",
"ALMTECH SOFTWARE SOLUTIONS LIMITED",
"ALMUG TECHNOLOGIES PRIVATE LIMITED",
"ALMUQEET SYSTEMS PRIVATE LIMITED",
"ALMUS RISK CONSULTING",
"ALN BILLING PRIVATE LIMITED",
"ALN EQUIPMENTS PRIVATE LIMITED",
"ALNA BIOTECH PRIVATE LIMITED",
"AL-NAAS FOREX PRIVATE LIMITED",
"ALNICHE LIFESCIENCES PRIVATE LIMITED",
"ALNITAK TRADING PRIVATE LIMITED",
"AL-NOOR GLOBAL EXPORTS PRIVATE LIMITED",
"ALNOURISH HEALTHY FOODS PRIVATE LIMITED",
"ALOAK LIFE CARE SERVICES PRIVATE LIMITED",
"ALOBHA TECHNOLOGIES PRIVATE LIMITED",
"ALOD KISAN SAMRUDDHI PRODUCER COMPANY LIMITED",
"ALODIA LIFE SCIENCES PRIVATE LIMITED",
"ALOFT",
"ALOFT AVIATION PRIVATE LIMITED",
"ALOFT CONSULTING SOLUTIONS",
"ALOFT INDUSTRIES PRIVATE LIMITED",
"ALOGIC ELECTRONICS INDIA PRIVATE LIMITED",
"ALOHA COMMODITIES PRIVATE LIMITED",
"ALOHA ENGINEERING PRIVATE LIMITED",
"ALOHA TECHNOLOGY PRIVATE LIMITED",
"ALOHA TOURS & TRAVELS INDIA PRIVATE LIMITED",
"ALOIS TECHNOLOGIES LLP",
"ALOIS TECHNOLOGIES PRIVATE LIMITED",
"ALOK BUILDTECH PRIVATE LIMITED",
"ALOK CHEMICALS PRIVATE LIMITED",
"ALOK DEVELOPERS PRIVATE LIMITED",
"ALOK EM PROJECTS PRIVATE LIMITED",
"ALOK EQUIPMENTS PVT.LTD.",
"ALOK FERRO ALLOYS LIMITED",
"ALOK HARSH RICE MILL PRIVATE LIMITED",
"ALOK IMPEX PRIVATE LIMITED",
"ALOK INDUSTRIES LIMITED",
"ALOK INFRACON PRIVATE LIMITED",
"ALOK INFRAMATE PRIVATE LIMITED",
"ALOK INGOTS MUMBAI PRIVATE LIMITED",
"ALOK INTERNATIONAL PRIVATE LIMITED",
"ALOK ISPAT PRIVATE LIMITED",
"ALOK JAIN EXIM PRIVATE LIMITED",
"ALOK LEASINGS PRIVATE LIMITED",
"ALOK MASTER BATCHES PRIVATE LIMITED",
"ALOK NANDA & COMPANY COMM PRIVATE LIMITED",
"ALOK NIWAS PRIVATE LIMITED",
"ALOK OIL INDUSTRIES LTD",
"ALOK PHARMACEUTICAL AND INDUSTRIAL CO PVT LTD",
"ALOK PLASTICS PRIVATE LTD.",
"ALOK PUBLIC SCHOOL",
"ALOK PUNJ SECONDARY SCHOOL",
"ALOK RIM UDYOG PRIVATE LIMITED",
"ALOK TEXTILE MILLS PRIVATE LIMITED",
"ALOK TRADELINK PRIVATE LIMITED",
"ALOK TRANSPORT PRIVATE LIMITED",
"ALOKA COLD STORAGE PVT LTD",
"ALOKA COMMERCIALS PRIVATE LIMITED",
"ALOKA EXPORTS",
"ALOKA INNOVATIVE BUSINESS SOLUTIONS PRIVATE LIMITED",
"ALOKE SPECIALTY MACHINES & COMPONENTS PR IVATE LIMITED",
"ALOKE STEELS INDUSTRIES PRIVATE LIMITED",
"ALOKIK CAPITAL PRIVATE LIMITED",
"ALOKIK FINLEASE PRIVATE LIMITED",
"ALOKIK STEELS PRIVATE LIMITED",
"ALOKIN SOFTWARE PRIVATE LIMITED",
"ALOKSHA HEALTHCARE PRIVATE LIMITED",
"ALOL INSTRUMENTS PRIVATE LIMITED",
"ALOM ALUMINIUM PRIVATE LIMITED",
"ALOM EXTRUSIONS LIMITED",
"ALOM POLY EXTRUSIONS LIMITED",
"ALOMA DIAMOND PRIVATE LIMITED",
"ALOMMEX PROFILES PRIVATE LIMITED",
"ALONSO LOGISTICS INDIA PRIVATE LIMITED",
"ALOPA INFOTECH PRIVATE LIMITED",
"ALORA AGRITECH PRIVATE LIMITED",
"ALORENCE IMMIGRATION PRIVATE LIMITED",
"ALORICA (INDIA) PRIVATE LIMITED",
"ALORIVA GLOBAL INFRATECH PRIVATE LIMITED",
"ALOT DIGITAL SOLUTIONS INDIA PRIVATE LIMITED",
"ALOX CAST PRIVATE LIMITED",
"ALP AEROFLEX INDIA PRIVATE LIMITED",
"ALP CONSULTING LIMITED",
"ALP CORPORATE SERVICES PRIVATE LIMITED",
"ALP INTERNATIONAL TRADE PRIVATE LIMITED",
"ALP MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"ALP MILK FOODS PRIVATE LIMITED",
"ALP NISHIKAWA COMPANY PRIVATE LIMITED",
"ALP NONWOVEN PRIVATE LIMITED",
"ALP OVERSEAS PRIVATE. LIMITED.",
"ALP PLASTICS PRIVATE LIMITED",
"ALP POLYMER PARK PRIVATE LIMITED",
"ALP RETAIL PRIVATE LIMITED",
"ALP SAFETY & SECURITY SERVICES PRIVATE LIMITED",
"ALPA INFRASTRUCTURE PRIVATE LIMITED",
"ALPA INTERNATIONAL PRIVATE LIMITED",
"ALPA LABORATORIES LIMITED",
"ALPAC CREATIONS PRIVATE LIMITED",
"ALPACHEM INTERNATIONAL PRIVATE LIMITED",
"ALPACK PAPER PACKAGING PRIVATE LIMITED",
"ALPAK INVESTMENTS PVT LTD",
"ALPANIL INDUSTRIES",
"ALPARGATAS INDIA FASHIONS PRIVATE LIMITED",
"ALPAS MARKETING AND ADVERTISING PRIVATE LIMITED",
"ALPASSO INDUSTRIES PRIVATE LIMITED",
"ALPCORD NETWORK",
"ALPEN CAPITAL INDIA PRIVATE LIMITED",
"ALPEN FASHION & TRACHT PRIVATE LIMITED",
"ALPENNO PULSES PRIVATE LIMITED",
"ALPERE TECHNOLOGIES PRIVATE LIMITED",
"ALPESA AGRO INDUSTRIES PRIVATE LIMITED",
"ALPESH SURFACE COATINGS PRIVATE LIMITED",
"ALPET CONTAINERS PRIVATE LIMITED",
"ALPEX EXIM PRIVATE LIMITED",
"ALPEX EXPORTS PRIVATE LIMITED",
"ALPEX SOLAR LIMITED",
"ALPEX SOLAR PRIVATE LIMITED",
"ALPGIRI SEED SCIENCES PRIVATE LIMITED",
"ALPHA & OMEGA COMPUTERS PRIVATE LIMITED",
"ALPHA AEROTECH PRIVATE LIMITED",
"ALPHA AGRO FOODS INTERNATIONAL PRIVATE LIMITED",
"ALPHA AGRO SNACK INTERNATIONAL PRIVATE LIMITED",
"ALPHA AIR TRAVELS PRIVATE LIMITED",
"ALPHA ALTERNATIVE ASSET ADVISORS PRIVATE LIMITED",
"ALPHA ALTERNATIVES FUND ADVISORS LLP",
"ALPHA ALTERNATIVES HOLDINGS PRIVATE LIMITED",
"ALPHA ANALYTICS SERVICES PRIVATE LIMITED",
"ALPHA AND OMEGA CONVENT SCHOOL",
"ALPHA ARC PRIVATE LIMITED",
"ALPHA AROMATIC PRIVATE LIMITED",
"ALPHA AUTOMATION PRIVATE LIMITED",
"ALPHA BETA ENGINEERING CONSTRUCTION PRIVATE LIMITED",
"ALPHA BLUE-CHEM PRIVATE LIMITED",
"ALPHA BUILDING SERVICES PRIVATE LIMITED",
"ALPHA BUSINESS ENTERPRISE PRIVATE LIMITED",
"ALPHA CARBONLESS PAPER MANUFACTURING CO.P.LIMITED",
"ALPHA CARDIAC SCIENCES LLP",
"ALPHA CARGO EXPRESS PRIVATE LIMITED",
"ALPHA CEILING SYSTEMS PRIVATE LIMITED",
"ALPHA CITY CHENNAI IT PARK PROJECTS PRIVATE LIMITED",
"ALPHA CLOUD LABS PRIVATE LIMITED",
"ALPHA COLLEGE OF ARTS SCIENCE",
"ALPHA COMMANDOS AND GUARDING SERVICES PRIVATE LIMITED",
"ALPHA COMMUNICATION LTD.",
"ALPHA CONTAINERS (MADRAS) PRIVATE LIMITED",
"ALPHA CONTROL INSTRUMENTS PRIVATE LIMITED",
"ALPHA CORP MANAGEMENT SERVICES PRIVATE LIMITED",
"ALPHA CORRPACK PRIVATE LIMITED",
"ALPHA CRAFT PRIVATE LIMITED",
"ALPHA CUSTOMER CARE PRIVATE LIMITED",
"ALPHA DELTA COATINGS PRIVATE LIMITED",
"ALPHA DESIGN TECHNOLOGIES PRIVATE LIMITED",
"ALPHA DEZINE SERVICES PRIVATE LIMITED",
"ALPHA DIES AND PATTERN INDIA PRIVATE LIMITED",
"ALPHA DIGITAL EQUIPMENTS PRIVATE LIMITED",
"ALPHA E BARCODE SOLUTIONS PRIVATE LIMITED",
"ALPHA EDUCATIONAL SOCIETY",
"ALPHA ELASTOMER BANGALORE PRIVATE LIMITED",
"ALPHA ENERGY SYSTEMS LIMITED",
"ALPHA ENGINEERING AND SYSTEMS PRIVATE LIMITED",
"ALPHA EXIM MANAGEMENT PRIVATE LIMITED",
"ALPHA FACILITY MANAGEMENT",
"ALPHA FACILITY SERVICES PRIVATE LIMITED",
"ALPHA FERTILIZER (INDIA) PRIVATE LIMITED",
"ALPHA FINSOFT PRIVATE LIMITED",
"ALPHA FINTECH PRIVATE LIMITED",
"ALPHA FOAM LIMITED",
"ALPHA FOREX PRIVATE LIMITED",
"ALPHA FOUNDATIONS PRIVATE LIMITED",
"ALPHA FOUNDERS PRIVATE LIMITED",
"ALPHA FREIGHT CHAIN PRIVATE LIMITED",
"ALPHA GROUP OF INSTITUTIONS",
"ALPHA IMAGING AND RESEARCH INSTITUTE PRIVATE LIMITED",
"ALPHA INDUSTRIAL ENGINEERING PROJECTS PRIVATE LIMITED",
"ALPHA INDUSTRIES LIMITED",
"ALPHA INK PRIVATE LIMITED",
"ALPHA INTEGRATED MANAGEMENT SERVICES PRIVATE LIMITED",
"ALPHA INTERIOR PRODUCTS PRIVATE LIMITED",
"ALPHA INTERNATIONAL",
"ALPHA INTERNATIONAL ACADEMY",
"ALPHA INVITRO DIAGNOSTICS PRIVATE LIMITED",
"ALPHA IT CONSULTANTS PRIVATE LIMITED",
"ALPHA KKC LOGISTICS INDIA PRIVATE LIMITED",
"ALPHA LASERTEK INDIA LIMITED",
"ALPHA LEON ENTERPRISES LLP",
"ALPHA LIGHTING DEVICES PVT.LTD.",
"ALPHA LINEAR PRIVATE LIMITED",
"ALPHA MAIER PRIVATE LIMITED",
"ALPHA MANTRA CONSULTING PRIVATE LIMITED",
"ALPHA MATRIC HR SEC SCHOOL",
"ALPHA MD PRIVATE LIMITED",
"ALPHA MEDICARE AND DEVICES PRIVATE LIMITED",
"ALPHA MILKFOODS PRIVATE LIMITED",
"ALPHA MULTI-SPECIALITY DIAGNO CENTRE & CLINIC PRIVATE LIMITED",
"ALPHA NATIONAL FIRE SAFETY SERVICES PRIVATE LIMITED",
"ALPHA NODUS TECHNOLOGIES INDIA PRIVATE LIMITED",
"ALPHA OMEGA GRACE PROJECT PRIVATE LIMITED",
"ALPHA OMEGA PERSONAL SERVICES PRIVATE LIMITED",
"ALPHA OMEGA SHIPPING SERVICES PRIVATE LIMITED",
"ALPHA ONE INFRA INDIA PRIVATE LIMITED",
"ALPHA ORI INDIA PRIVATE LIMITED",
"ALPHA OVERSEAS INTERNATIONAL PVT LTD",
"ALPHA PACIFIC SYSTEMS PRIVATE LIMITED",
"ALPHA PACK PRIVATE LIMITED",
"ALPHA PACKAGING PRIVATE LIMITED",
"ALPHA PLASTOMERS PRIVATE LIMITED",
"ALPHA PLUS MEDICOS PRIVATE LIMITED",
"ALPHA PLUS TECHNOLOGIES PRIVATE LIMITED",
"ALPHA POLYMER TECK PRIVATE LIMITED",
"ALPHA POWER ENGINEERING SERVICES PRIVATE LIMITED",
"ALPHA PROPMART PRIVATE LIMITED",
"ALPHA PURE PACK PRIVATE LIMITED",
"ALPHA REAL CAPITAL INDIA PRIVATE LIMITED",
"ALPHA RESOURCE SOLUTIONS PRIVATE LIMITED",
"ALPHA REVERSE ENGINEERING AND DESIGN SOLUTIONS PRIVATE LIMITED",
"ALPHA ROTO MACHINES PRIVATE LIMITED",
"ALPHA SAFETY GLASS PRIVATE LIMITED",
"ALPHA SCIENCE ACADEMY PRIVATE LIMITED",
"ALPHA SEA AND AIR PRIVATE LIMITED",
"ALPHA SECURITY INSTRUMENTS INDIA PRIVATE LIMITED",
"ALPHA SPECIAL PURPOSE VEHICLE PRIVATE LIMITED",
"ALPHA STAR TRADING PRIVATE LIMITED.",
"ALPHA STITCH-ART PRIVATE LIMITED",
"ALPHA SUPER SPECIALITY HOSPITAL",
"ALPHA TAR INDUSTRIES PRIVATE LIMITED",
"ALPHA TECHNOPLAST PRIVATE LIMITED",
"ALPHA TEKNISK PRIVATE LIMITED",
"ALPHA TELECOM",
"ALPHA THERAPEUTICS PRIVATE LIMITED",
"ALPHA TOCOL ENGINEERING SERVICES PRIVATE LIMITED",
"ALPHA TOYO LIMITED",
"ALPHA TRADING COMPANY",
"ALPHA VANIJYA PVT LTD",
"ALPHA VARIANCE SOLUTIONS INDIA PRIVATE LIMITED",
"ALPHA2OMEGA ADMINISTRATORS PRIVATE LIMITED",
"ALPHAA AI DATA PRIVATE LIMITED",
"ALPHAA AV SOLUTIONS & AUTOMATION PRIVATE LIMITED",
"ALPHAA SPRINGS CHENNAI PRIVATE LIMITED",
"ALPHABET CORPORATION PRIVATE LIMITED",
"ALPHABET TECHNOLOGY PRIVATE LIMITED",
"ALPHABET TECHSOLUTIONS (INDIA) PRIVATE LIMITED",
"ALPHABETA INNOVATIONS PRIVATE LIMITED",
"ALPHABETICS BUSINESS MACHINES PRIVATE LIMITED",
"ALPHABULK SUPPLY SOLUTIONS PRIVATE LIMITED",
"ALPHACLARTE DIAMONDS PRIVATE LIMITED",
"ALPHACMA PRIVATE LIMITED",
"IN2IT SYSTEMS AND SERVICES PRIVATE LIMITED",
"ALPHACOM VENTURES PRIVATE LIMITED",
"ALPHACORE TECHNOLOGIES PRIVATE LIMITED",
"ALPHADECIMAL NETWORKS PRIVATE LIMITED",
"ALPHA-DRILL PRIVATE LIMITED",
"ALPHA ELSEC DEFENCE & AEROSPACE SYSTEMS PRIVATE LIMITED",
"ALPHAGAM COATING SOLUTIONS PRIVATE LIMITED",
"ALPHAGEO INDIA LIMITED",
"ALPHAGREP SECURITIES PRIVATE LIMITED",
"ALPHAICS INDIA PRIVATE LIMITED",
"ALPHAKIDS LEARNING CENTRES PRIVATE LIMITED",
"ALPHA-KREOL (INDIA) PRIVATE LIMITED",
"ALPHALOGIC INDUSTRIES LIMITED",
"ALPHALOGIC TECHSYS LIMITED",
"ALPHAMED FORMULATIONS PRIVATE LIMITED",
"ALPHAMERS LIMITED",
"ALPHANSO PRODUCTS PRIVATE LIMITED",
"ALPHAONE SERVICES PRIVATE LIMITED",
"ALPHA-PHARMA HEALTHCARE PRIVATE LIMITED",
"ALPHAPLUS CORPORATE SERVICES PRIVATE LIMITED",
"ALPHARD MARITIME PRIVATE LIMITED",
"ALPHARITHM TECHNOLOGIES PRIVATE LIMITED",
"ALPHARM TRADING PRIVATE LIMITED",
"ALPHARUB CRUMB RUBBER PRIVATE LIMITED",
"ALPHARUB TRADING AND MANUFACTURING PRIVATE LIMITED",
"ALPHASENSE TECHNOLOGY (INDIA) PRIVATE LIMITED",
"ALPHASILICON PRIVATE LIMITED",
"ALPHASTREAM TECHNOLOGIES PRIVATE LIMITED",
"ALPHASTREET INDIA PRIVATE LIMITED",
"ALPHATEC AUDIO VIDEO PRIVATE LIMITED",
"ALPHATECH ACRES PRIVATE LIMITED",
"ALPHATECH PROCESS EQUIPMENTS PRIVATE LIMITED",
"ALPHATECH SOFTWARE PRIVATE LIMITED",
"ALPHATONE MULTITRADE PRIVATE LIMITED",
"ALPHAVECTOR INDIAPRIVATE LIMITED",
"ALPHAVIMA TECHNOLOGIES PRIVATE LIMITED",
"ALPHAVISION MULTIVENTURES (I) PRIVATE LIMITED",
"ALPHENTRIX GLOBAL SERVICES PRIVATE LIMITED",
"ALPHHA ELECTROMART PRIVATE LIMITED",
"ALPHIND SOFTWARE SOLUTIONS PRIVATE LIMITED",
"ALPHION INDIA PRIVATE LIMITED",
"ALPHONIC NETWORK SOLUTIONS PRIVATE LIMITED",
"ALPHONSA SCHOOL MIRAJ",
"ALPHONSO LABS PRIVATE LIMITED",
"ALPHONSO STEEL PRIVATE LIMITED",
"ALPHORES EDUCATIONAL SOCIETY",
"ALPHORES ETECHNO SCHOOL",
"ALPHORES JUNIOR COLLEGE",
"ALPHRADE GLOBAL PRIVATE LIMITED",
"ALPIC BIOTECH LIMITED",
"ALPIC REMEDIES LIMITED",
"ALPIERS TECHNOLOGIES LIMITED",
"ALPINE APPARELS PRIVATE LIMITED",
"ALPINE BIOMEDICALS PRIVATE LIMITED",
"ALPINE CONTAINERS PRIVATE LIMITED",
"ALPINE CORRUGATORS PRIVATE LIMITED",
"ALPINE CREATIONS PRIVATE LIMITED",
"ALPINE DISTILLERIES PRIVATE LIMITED",
"ALPINE ENERGIES PRIVATE LIMITED",
"ALPINE ENERGY LIMITED",
"ALPINE ENVIRONMENTAL ENGINEERS LIMITED",
"ALPINE EXPO TEX PRIVATE LIMITED",
"ALPINE FASHION FABRICS",
"ALPINE FIBC PRIVATE LIMITED",
"ALPINE FOODS INDUSTRIES PRIVATE LIMITED",
"ALPINE FOREX PRIVATE LIMITED",
"ALPINE HOUSING DEVELOPMENT CORPORATION LIMITED.",
"ALPINE IMPEX PRIVATE LTD",
"ALPINE INFRAPROJECTS PRIVATE LIMITED",
"ALPINE INSTITUTE OF MANAGEMENT & TECHNOLOGY",
"ALPINE INTERNATIONAL PRIVATE LIMITED",
"ALPINE KNITS INDIA PRIVATE. LIMITED.",
"ALPINE LIFESCIENCE PRIVATE LIMITED",
"ALPINE MODULAR INTERIORS PRIVATE LIMITED",
"ALPINE OF ASIA PACIFIC INDIA PRIVATE LIMITED",
"ALPINE POLY RUB PRIVATE LIMITED",
"ALPINE REALITY PRIVATE LIMITED",
"ALPINE REHABILITATIONS PRIVATE LIMITED",
"ALPINE SEEDS PRIVATE LIMITED",
"ALPINE SHOES PRIVATE LIMITED",
"ALPINE SPINWEAVE PRIVATE LIMITED",
"ALPINE TAPE PRIVATE LIMITED",
"ALPINES TECHNOQUIP PRIVATE LIMITED",
"ALPINESOFT IT SOLUTIONS PRIVATE LIMITED",
"ALPINISMO ONLINE VENTURES PRIVATE LIMITED",
"ALPINO HEALTH FOODS PRIVATE LIMITED",
"ALPLA INDIA PRIVATE LIMITED",
"ALPNA ENGINEERS PRIVATE LIMITED",
"ALPNA PACKAGING PRIVATE LIMITED",
"ALPRO CONSUMER PRODUCT PRIVATE LIMITED",
"ALPRO EXTRUSION PRIVATE LIMITED",
"ALPRO TECH PRIVATE LIMITED",
"ALPROSE INDUSTRIES PRIVATE LIMITED",
"ALPS CHEMICALS PRIVATE LIMITED",
"ALPS COMMUNICATION PRIVATE LIMITED",
"ALPS CORPORATION",
"ALPS DIAGNOSTICS PRIVATE LIMITED",
"ALPS DISTRIBUTORS PRIVATE LIMITED",
"ALPS EDU SERVICES PRIVATE LIMITED",
"ALPS ELECTRIC INDIA PRIVATE LIMITED",
"ALPS HOSPITAL LIMITED",
"ALPS ICE & COLD STORAGE PRIVATE LIMITED",
"ALPS INTERNATIONAL PVT LTD",
"ALPS LIFE SCIENCES PRIVATE LIMITED",
"ALPS LOGISTICS INDIA PRIVATE LIMITED",
"ALPS LOGISTICS LIMITED",
"ALPS MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"ALPS REMEDIES PRIVATE LIMITED",
"ALPS SOFTWARE TECHNOLOGIES LIMITED",
"ALPS SOLUTIONS PRIVATE LIMITED",
"ALPS TECHNOLOGIES PRIVATE LIMITED",
"ALPS TECHNOSYSTEMS INDIA LIMITED",
"ALPSCO GRAINTECH PRIVATE LIMITED",
"ALPSPURE LIFESCIENCES PRIVATE LIMITED",
"ALPSPURE NUTRACEUTICALS PRIVATE LIMITED",
"ALPSTECH INNOVATIONS PRIVATE LIMITED",
"ALPTECH CONTROLS PRIVATE LIMITED",
"ALPUMP LIMITED",
"ALPUS AGROVET PRIVATE LIMITED",
"AL-QURESH (AURANGABAD CITY) MODERN ABATTOIR PRIVATE LIMITED",
"ALR LABS PRIVATE LIMITED",
"AL-RAHEEM INTERNATIONAL PRIVATE LIMITED",
"AL-RAHMAN FABRIC PRIVATE LIMITED",
"ALRAJHI BANK",
"ALRAW ENTERPRISES PRIVATE LIMITED",
"AL-REHMAT GLASS PRIVATE LIMITED",
"ALRIUM PRIVATE LIMITED",
"AL-RKAYAN APPARELS & EXPORTS PRIVATE LIMITED",
"ALROCS LIFESTYLE PRIVATE LIMITED",
"ALS EDUVENTURES PRIVATE LIMITED",
"ALS SATELLITE EDUCATION PRIVATE LIMITED",
"ALS SINGAMAS LOGISTICS LIMITED",
"ALS TESTING SERVICES INDIA PRIVATE LIMITED",
"ALS TUTICORIN TERMINAL PRIVATE LIMITED",
"ALSACE LORRAINE INDIA PRIVATE LIMITED",
"AL-SAFA INDUSTRIES PRIVATE LIMITED",
"AL-SAMA PERSONNEL SOLUTIONS PRIVATE LIMITED",
"AL-SAMEER EXPORTS PRIVATE LIMITED",
"AL-SAMI AGRO PRODUCTS PRIVATE LIMITED",
"AL-SAMI COLD STORAGE PRIVATE LIMITED",
"AL-SAMI FOOD EXPORTS PRIVATE LIMITED",
"AL-SANA AGRO FOOD PRODUCTS PRIVATE LIMITED",
"AL-SAQIB EXIM PRIVATE LIMITED",
"AL-SAQIB EXPORTS PRIVATE. LIMITED.",
"ALSAY GASTECH PRIVATE LIMITED",
"ALSECURE AND PROTECTION SERVICES (INDIA) PRIVATE LIMITED",
"ALSHA HOTEL SUPPLIES PRIVATE LIMITED",
"AL-SHAVEZ FROZEN FOODS PRIVATE LIMITED",
"ALSHAYA OUTSOURCING COMPANY INDIA PRIVATE LIMITED",
"ALSHIFA HEALTHCARE SERVICES PRIVATE LIMITED",
"ALSHIFA MULTISPECIALITY HOSPITAL",
"AL-SHUMAILA FOOD PROCESSING PRIVATE LIMITED",
"ALSINA FORMWORK INDIA PRIVATE LIMITED",
"ALSISAR HOTELS AND RESORTS PRIVATE LIMITED",
"ALSISAR IMPACT PRIVATE LIMITED",
"ALSMITHS INDUSTRIES (INDIA) PRIVATE LIMITED",
"ALSOFI GROUP PRIVATE LIMITED",
"ALSOK INDIA PRIVATE LIMITED",
"ALSON MARKETING & SERVICES PRIVATE LIMITED",
"ALSON PHARMA PRIVATE LIMITED",
"ALSORG DESIGN STUDIO LLP",
"ALSORG INTERIORS INDIA PRIVATE LIMITED",
"ALSS TRADING PRIVATE LIMITED",
"ALSTHOM INDUSTRIES LIMITED",
"ALSTOM MANUFACTURING INDIA PRIVATE LIMIT ED",
"ALSTOM RAIL TRANSPORTATION INDIA PRIVATE LIMITED",
"ALSTOM SYSTEMS INDIA PRIVATE LIMITED",
"ALSTOM TRANSPORT INDIA LIMITED",
"ALSTON ELLIOT INDIA PRIVATE LIMITED",
"ALSTON EQUIPMENTS PRIVATE LIMITED",
"ALSTONE GREEN INDIA PRIVATE LIMITED",
"ALSTONE INDUSTRIES PRIVATE LIMITED",
"ALSTONE MANUFACTURING PRIVATE LIMITED",
"ALSTONE TEXTILES (INDIA) LIMITED",
"ALSTONIA CONSULTING LLP",
"ALSTORM TECHNOLOGIES INDIA PRIVATE LIMITED",
"ALSTROM INTERNATIONAL PRIVATE LIMITED",
"ALSTRONG ENTERPRISES INDIA PRIVATE LIMITED",
"ALSTRUT INDIA PRIVATE LIMITED",
"ALSTYLE INDIA PRIVATE LIMITED",
"AL-SUNATH MARRIAGE SERVICES PRIVATE LIMITED",
"AL SUPER FROZEN FOODS PRIVATE LIMITED",
"ALT DIGITAL MEDIA ENTERTAINMENT LIMITED",
"ALT DIGITAL TECHNOLOGIES PRIVATE LIMITED",
"ALTA FITNESS AND FOOD PRIVATE LIMITED",
"ALTA LABORATORIES LIMITED",
"ALTA LEASING AND FINANCE LIMITED",
"ALTA WORLD TRAVEL AND TOURISM PRIVATE LIMITED",
"ALTAA VISTAA BUSINESS SOLUTIONS PRIVATE LIMITED",
"ALTAAS TEXTILES PRIVATE LIMITED",
"AL-TABARAK FROZEN FOODS PRIVATE LIMITED",
"ALTAF. H. VALI ELECTRONICS PRIVATE LIMITED",
"ALTAHER LIAISON PRIVATE LIMITED",
"AL-TAIBA PERFUMERY PRIVATE LIMITED",
"ALTAIR ENGINEERING INDIA PRIVATE LIMITED",
"ALTAIR HOLIDAYS PRIVATE LIMITED",
"ALTAIR INFRASTRUCTURE PRIVATE LIMITED",
"ALTAIR POWER PRIVATE LIMITED",
"AL-TAKBEER FROZEN FOODS PRIVATE LIMITED",
"ALTALUX INTERNATIONAL EXPORTS & IMPORTS PRIVATE LIMITED",
"ALTAMOUNT CAPITAL MANAGEMENT PRIVATE. LIMITED",
"ALTAMOUNT CONSULTING SERVICES LLP",
"ALTAMOUNT HOLDINGS AND TRADING COMPANY PVT LTD",
"ALTAMOUNT ROAD PROPERTY PRIVATE LIMITED",
"ALTAN ENGINEERING PRIVATE LIMITED",
"ALTAR HEALTH CARE PRIVATE LIMITED",
"ALTAR PHARMACEUTICALS PRIVATE LIMITED",
"ALTAROMA CHEMICALS PRIVATE LIMITED",
"ALTAR-SRI LABS PRIVATE LIMITED",
"ALTAVISTA CAPITAL ADVISORY SERVICES PRIVATE LIMITED",
"ALTAVISTA DECO SERVICES PRIVATE LIMITED",
"ALTAVISTA PROJECTS PRIVATE LIMITED",
"ALTAVISTA TRENDZ PRIVATE LIMITED",
"ALTEATEC IT SOLUTIONS PRIVATE LIMITED",
"ALTECH ALLOYS INDIA PRIVATE LIMITED",
"AL-TECH ENGINEERING & CONSTRUCTION PRIVATE LIMITED",
"ALTECH INFRASTRUCTURE PRIVATE LIMITED",
"ALTECH STAR LLP",
"ALTEM ENERGY LIMITED",
"ALTEM TECHNOLOGIES PRIVATE LIMITED",
"ALTEN CALSOFT LABS (INDIA) PRIVATE LIMITED",
"ALTEN INDIA PRIVATE LIMITED",
"ALTEN POWER PRIVATE LIMITED",
"ALTENDORF INDIA PRIVATE LIMITED",
"ALTEO INDIA ALUMINAS PRIVATE LIMITED",
"ALTER FOODS PRIVATE LIMITED",
"ALTER MARKETING SOLUTIONS PRIVATE LIMITED",
"ALTEREGO TECHNOLOGY LIMITED",
"ALTEREST INDIA PRIVATE LIMITED",
"ALTERNATE ENERGY CORPORATION",
"ALTERNATIVE BUILDING SOLUTIONS PRIVATE LIMITED",
"ALTERNATIVE BUSINESS INTELLIGENCE PRIVATE LIMITED",
"ALTERNATIVE GREEN ENERGY SOLUTIONS PRIVATE LIMITED",
"ALTERNATIVE LEARNING SYSTEMS LIMITED",
"ALTERNATIVE PATH PRIVATE LIMITED",
"ALTERNATIVE PROTEIN SOLUTIONS PRIVATE LIMITED",
"ALTEUS BIOGENICS PRIVATE LIMITED",
"ALTEZA TELE SERVICES LLP",
"ALTEZZASYS SYSTEMS PRIVATE LIMITED",
"ALTF SPACES PRIVATE LIMITED",
"ALTHAEA FINANCE AND LEASING PRIVATE LIMITED",
"ALTHAF SHOES PRIVATE LIMITED",
"ALTHAR FINTEC PRIVATE LIMITED",
"ALTHEA DRF LIFESCIENCES LIMITED",
"ALTHEA PHARMA PRIVATE LIMITED",
"ALTHEA UNILIFE LLP",
"ALTHERA LABORATORIES INDIA PRIVATE LIMITED",
"ALTICE LABS INDIA PRIVATE LIMITED",
"ALTICO ADVISORS LIMITED",
"ALTICRETE BUILDING SOLUTIONS PRIVATE LIMITED",
"ALTIER ELECTRIC VEHICLES PRIVATE LIMITED",
"ALTIF TELECOMMUNICATIONS PRIVATE LIMITED",
"ALTILIUM ENERGIE PRIVATE LIMITED",
"ALTIM METALS PRIVATE LIMITED",
"ALTIMA CHEMI PRIVATE LIMITED",
"ALTIMA CONMIX INDIA PRIVATE LIMITED",
"ALTIMA INFRASTRUCTURE PRIVATE LIMITED",
"ALTIMA SECURITY TECHNOLOGIES PRIVATE LIMITED",
"ALTIMATE VYAPAR PRIVATE LIMITED",
"ALTIMETRIC DIGITAL PRIVATE LIMITED",
"ALTIMETRIK INDIA PRIVATE LIMITED",
"ALTIN TRADING PRIVATE LIMITED",
"ALTINA FINANCE PRIVATE LIMITED",
"ALTINOK INDIA PRIVATE LIMITED",
"ALTIOS CONSULTING PRIVATE LIMITED",
"ALTIOSTAR NETWORKS INDIA PRIVATE LIMITED",
"ALTIOUS CORPORATE SERVICES PVT. LTD.",
"ALTIR INDIA PRIVATE LIMITED",
"ALTIS BUILDCON PRIVATE LIMITED (OPC)",
"ALTIS FINECHEM PRIVATE LIMITED",
"ALTIS INDUSTRIES PRIVATE LIMITED",
"ALTISOURCE BUSINESS SOLUTIONS PRIVATE LIMITED",
"ALTITUDE GLOBAL LOGISTIC PRIVATE LIMITED",
"ALTITUDE INVESTMENTS PRIVATE LIMITED",
"ALTITUDE MARKETING LLP",
"ALTITUDE SOFTWARE ISRAEL LIMITED",
"ALTIUM SOFTWARE INDIA PRIVATE LIMITED",
"ALTIUS AGROEATS PRIVATE LIMITED",
"ALTIUS AUTO SOLUTIONS PRIVATE LIMITED",
"ALTIUS CUSTOMER SERVICES PRIVATE LIMITED",
"ALTIUS DATA SOLUTION PRIVATE LIMITED",
"ALTIUS DIGITAL PRIVATE LIMITED",
"ALTIUS FINSERV PRIVATE LIMITED",
"ALTIUS HEALTHCARE PRIVATE LIMITED",
"ALTIUS HOSPITALS PRIVATE LIMITED",
"ALTIUS INVESTECH PRIVATE LIMITED",
"ALTIUS MANAGEMENT ADVISORS PRIVATE LIMITED",
"ALTIUS PHARMACEUTICALS PRIVATE LIMITED",
"ALTIUS SECURITIES TRADING PRIVATE LIMITED",
"ALTIUS SPORTS & LEISURE PRIVATE LIMITED",
"ALTIUSTECH HEALTH IT SOLUTIONS LLP",
"ALTIUX INNOVATIONS PRIVATE LIMITED",
"ALTIZON SYSTEMS PRIVATE LIMITED",
"ALTN IT SOLUTIONS PRIVATE LIMITED",
"ALTO CASA DEVELOPERS PRIVATE LIMITED",
"ALTO HEALTHCARE PRIVATE LIMITED",
"ALTO MEDICAL SYSTEMS PRIVATE LIMITED",
"ALTO POWER SYSTEM PRIVATE LIMITED",
"ALTOMECH PRIVATE LIMITED",
"ALTON BUILDTECH INDIA PRIVATE LIMITED",
"ALTON PLASTICS PRIVATE LIMITED",
"ALTONA DIAGNOSTICS INDIA PRIVATE LIMITED",
"ALTONEXUS TECHNOLOGIES PRIVATE LIMITED",
"ALTOP CONSTRUCTIONS PRIVATE LIMITED",
"ALTOP INDUSTRIES LTD",
"ALTOP LABS INDIA PRIVATE LIMITED",
"ALTORISE VENTURES PRIVATE LIMITED",
"ALTORUM LEREN PRIVATE LIMITED",
"ALTOS COMPUTING (INDIA) PRIVATE LIMITED",
"ALTOS ENGINEERS PRIVATE LIMITED",
"ALTOS ENTERPRISES PRIVATE LIMITED",
"ALTOS GLOBAL SERVICES PRIVATE LIMITED",
"ALTOTEC INFRARED SYSTEM PRIVATE LIMITED",
"ALTOVA HEALTHCARE LIMITED",
"ALTR (INDIA) PRIVATE LIMITED",
"ALTRA AGRO-CHEM PRIVATE LIMITED",
"ALTRA INDUSTRIAL MOTION INDIA PRIVATE LIMITED",
"ALTRA PHARMA-CHEM PRIVATE LIMITED",
"ALTRADE HOSPITALITY PRIVATE LIMITED",
"ALTRADE MINERALS PVT LTD",
"ALTRAFINE STEEL PRIVATE LIMITED",
"ALTRAN TECHNOLOGIES INDIA PRIVATE LIMITED",
"ALTRAN VENTURES PRIVATE LIMITED",
"ALTRES TECHNOLOGIES INDIA LLP",
"ALTRET INDUSTRIES PRIVATE LIMITED",
"ALTRIA GROUP INC.",
"ALTRIX TECHNOLOGIES PRIVATE LIMITED",
"ALTROCKS TECH PRIVATE LIMITED",
"ALTRON CAST PRIVATE LIMITED",
"ALTRON INTERNATIONAL LOGISTIC PRIVATE LIMITED",
"ALTRON SOFA BOUTIQUE PRIVATE LIMITED",
"ALTROSS PHARMACY PRIVATE LIMITED",
"ALTROSYN TECHNOLOGIES PRIVATE LIMITED",
"ALTROVA INDIA SOFTWARE SOLUTIONS PRIVATE LIMITED",
"ALTRUIST CUSTOMER MANAGEMENT INDIA PRIVATE LIMITED",
"ALTRUIST GEOTECHNICAL SERVICES PRIVATE LIMITED",
"ALTRUIST HOSPITALITY PRIVATE LIMITED",
"ALTRUIST TECHNOLOGIES PRIVATE LIMITED",
"ALTRUISTIC METAL PRIVATE LIMITED",
"ALTRUS FOOD TECH LLP",
"ALTUDO CONSULTANCY SERVICES PRIVATE LIMITED",
"ALTUM CREDO HOME FINANCE PRIVATE LIMITED",
"ALTUNTOP BAKERY EQUIPMENTS PRIVATE LIMITED",
"ALTURA CONSULTING PRIVATE LIMIED",
"ALTURAASH ART GALLERY PRIVATE LIMITED",
"ALTUS DIAGNOSTIC PRIVATE LIMITED",
"ALTUS ENGINEERING SOLUTION PRIVATE LIMITED",
"ALTUS HYGIENIC PRODUCTS PRIVATE LIMITED",
"ALTUS INTELITECH PRIVATE LIMITED",
"ALTUS INTERIO",
"ALTUS LEARNING PRIVATE LIMITED",
"ALTUS LIVING SOLUTIONS PRIVATE LIMITED",
"ALTUS SPACE BUILDERS PRIVATE LIMITED",
"ALTUS SURGICALS PRIVATE LIMITED",
"ALTUX INNOVATION PRIVATE LIMITED",
"ALU DYCO MANUFACTURING TECHNOLOGIES PRIVATE LIMITED",
"ALUBOND DACS INDIA PRIVATE LIMITED",
"ALUBUILD ENGINEERS PRIVATE LIMITED",
"ALUCAST ENGINEERING PRIVATE LIMITED",
"ALUCO PANELS LIMITED",
"ALUCOM PANELS PRIVATE LIMITED",
"ALUDECOR LAMINATION PRIVATE LIMITED",
"ALUDOR INDIA PRIVATE LIMITED",
"ALUDREAM FLOAT GLASS PRIVATE LIMITED",
"ALUFIB INTERIORS PRIVATE LIMITED",
"ALUFINISH METAL SURFACE TECHNOLOGIES PRIVATE LIMITED",
"ALUFIT INDIA PRIVATE LIMITED",
"ALUFIT INTERNATIONAL PRIVATE LIMITED",
"ALUFLUORIDE LIMITED",
"ALUFOIL PRODUCTS PRIVATE LIMITED",
"ALUK BUILDING SYSTEMS PRIVATE LIMITED",
"ALUKKAS ENTERPRISES PRIVATE LIMITED",
"ALUKKAS GOLD RETAIL INDIA PRIVATE LIMITED",
"ALULINE SYSTEMS PRIVATE LIMITED",
"ALUMATIC CANS PRIVATE LIMITED",
"ALUMAYER INDIA PRIVATE LIMITED",
"ALUMEDS HEALTH CARE PRIVATE LIMITED",
"ALUMENTICA TRADING PRIVATE LIMITED",
"ALUMIL BUILDMATE PRIVATE LIMITED",
"ALUMIL SYSTEMS INDIA PRIVATE LIMITED",
"ALUMILITE ARCHITECTURALS PRIVATE LIMITED",
"ALUMILL INDIA PRIVATE LIMITED",
"ALUMINA ENGINEERING PRIVATE LIMITED",
"ALUMINE FABRICATORS INDIA PRIVATE LIMITED",
"ALUMINIUM CENTRE PVT LTD",
"ALUMINIUM FORMWORK ACCESSORIES PRIVATE LIMITED",
"ALUMINIUM INDIA",
"ALUMINIUM INDUSTRIES LIMITED",
"ALUMINIUM POWDER COMPANY LIMITED",
"ALUMNUS SOFTWARE LIMITED",
"ALUMOZ EXTRUSION PRIVATE LIMITED",
"ALUPA FOODS PRIVATE LIMITED",
"ALUPLAST INDIA PRIVATE LIMITED",
"ALURAYS LIGHTING TECHNOLOGY INDIA PRIVATE LIMITED",
"ALUSTAR MARKETING PRIVATE LIMITED",
"ALUTECH COOLING SYSTEM PRIVATE LIMITED",
"ALUTECH FOUNDRY INDIA PRIVATE LIMITED",
"ALUTECH GREEN PRIVATE LIMITED",
"ALUTECH PACKAGING PRIVATE LIMITED",
"ALUVA BROADBAND COMMUNICATIONS PRIVATE LIMITED",
"ALUVA MOTORS INDIA PRIVATE LIMITED",
"ALUVA PLASTIC CONSORTIUM PRIVATE LIMITED",
"ALUVEERA TECH PRIVATE LIMITED",
"ALUVISION FACADE SOLUTIONS PRIVATE LIMITED",
"ALUVITRO SYSTEMS PRIVATE LIMITED",
"ALUWARE PACKAGING PRIVATE LIMITED",
"ALUWIND ARCHITECTURAL LIMITED",
"ALUWIND ARCHITECTURAL PRIVATE LIMITED",
"ALVA AUTO SPARES PRIVATE LIMITED",
"ALVAREZ AND MARSAL INDIA PRIVATE LIMITED",
"ALVARION SECURITY SYSTEMS PRIVATE LIMITED",
"ALVARO TRADING INDIA PRIVATE LIMITED",
"ALVAS ACADEMY FOR EXCELLENCE",
"ALVAS AYURVEDA MEDICAL COLLEGE",
"ALVAS EDUCATION FOUNDATION",
"ALVAS EDUCATION TRUST",
"ALVAS ENGLISH MEDIUM HIGHER PRIMARY SCHOOL",
"ALVA'S HOMOEOPATHIC MEDICAL COLLEGE",
"ALVA'S INSTITUTE OF ENGINEERING & TECHNOLOGY",
"ALVAS PREUNIVERSITY COLLEGE",
"ALVEO SOFTWARE PRIVATE LIMITED",
"ALVEOR PLASTIC TECHNOLOGIES PRIVATE LIMITED",
"ALVES HEALTHCARE PRIVATE LIMITED",
"ALVESS DEVELOPERS PRIVATE LIMITED",
"ALVI AUTOMATION (INDIA) PRIVATE LIMITED",
"ALVI FOREX PRIVATE LIMITED",
"ALVI MOTOWINGS PRIVATE LIMITED",
"ALVI TECH SERVICES PRIVATE LIMITED",
"ALVIK FREIGHT FORWARDERS PRIVATE LIMITED",
"ALVIN CARAMEL COLOURS (INDIA) PRIVATE LIMITED",
"ALVIN COTSPIN LIMITED",
"ALVIN LEATHER CRAFTS PRIVATE LIMITED",
"ALVIN PRECISION MACHINERY INDIA PRIVATE LIMITED",
"ALVINO INFRA PROJECTS PRIVATE LIMITED",
"ALVIO PHARMACEUTICALS PRIVATE LIMITED",
"ALVIRA REALTY SERVICES PRIVATE LIMITED",
"ALVIRAS INDUSTRIES PRIVATE LIMITED",
"ALVISTA BIOSCIENCES PRIVATE LIMITED",
"ALVITA PHARMA PRIVATE LIMITED",
"ALVIVA STEELS LIMITED",
"ALVOGEN PHARMA INDIA PRIVATE LIMITED",
"ALW LIGHTING (INDIA) PRIVATE LIMITED",
"AL-WAHEED MEATEX PRIVATE LIMITED",
"ALWAR GENERAL FINANCE CO. PVT. LTD.",
"ALWAR INVESTMENT COMPANY LIMITED",
"ALWAR ISPAT PRIVATE LIMITED",
"ALWAR LAMPS PRIVATE LIMITED",
"ALWAR MALT MANUFACTURERS PRIVATE LIMITED",
"ALWAR MANUFACTURERS PVT. LTD",
"ALWAR PARAFFIN AND ALLIED PRODUCTS PRIVATE LTD",
"ALWAR PIGMENTS PRIVATE LIMITED",
"ALWAR ROLLER FLOUR MILLS PRIVATE LIMITED",
"ALWAR ROLLING MILLS PVT LTD",
"ALWARPET PROPERTIES PRIVATE LIMITED",
"ALWAYE RUBEX PRIVATE LIMITED",
"ALWAYE TECHNO RUBBERS PVT LTD",
"ALWAYS MUSIC GLOBAL PRIVATE LIMITED",
"ALWAYS REMEMBER PROPERTIES PRIVATE LIMITED",
"ALWAYSONVACATION ESOLUTIONS PRIVATE LIMITED",
"ALWAZO SOLUTIONS PRIVATE LIMITED",
"ALWIN INTERNATIONAL PUBLIC SCHOOL",
"ALWIN MEMORIAL PUBLIC SCHOOL",
"ALWIN WILLCURE PHARMACEUTICALS",
"ALX SHIPPING AGENCIES INDIA PRIVATE LIMITED",
"ALXENDRA ENGINEERING WORKS PRIVATE LIMITED",
"AL-YASEEN TRADING COMPANY PRIVATE LIMITED",
"ALYSSUM GLOBAL SERVICES PRIVATE LIMITED",
"ALYTSEE TECHNOLOGIES PRIVATE LIMITED",
"ALYTUS REMEDIES PRIVATE LIMITED",
"ALYX TECHNOLOGIES INDIA PRIVATE LIMITED",
"ALZA EXPORTS PRIVATE LIMITED",
"ALZADO INDIA PRIVATE LIMITED",
"ALZAN PHARMACEUTICALS PRIVATE LIMITED",
"ALZEY PHARMACEUTICALS PRIVATE LIMITED",
"ALZINC INDIA PRIVATE LIMITED",
"AL-ZOYA OVERSEAS PRIVATE LIMITED",
"AM ACCOUNTING PRIVATE LIMITED",
"AM ADMIN & SECURITY SERVICES PRIVATE LIMITED",
"AM ART INDIA PRIVATE LIMITED",
"AM CLEAN AIR ENGINEERING PRIVATE LIMITED",
"AM COOL ENGINEERS AND CONSULTANTS PRIVATE LIMITED",
"AM DATA LAB PRIVATE LIMITED",
"AM DIAMOND ENGINEERING WORKS PRIVATE LIMITED",
"AM EATS PRIVATE LIMITED",
"AM EDUCON SERVICES (OPC) PRIVATE LIMITED",
"AM EQUIPMENT AND SERVICES PRIVATE LIMITED (TRANSFERRED FROM TAMILNADU)",
"AM ESI LLP",
"AM FREIGHT SYSTEMS PRIVATE LIMITED",
"AM INFRASTRUCTURE PROJECTS PRIVATE LIMITED",
"AM INSTITUTE OF GI AND ADVANCED ENDOSCOPY PRIVATE LIMITED",
"AM JAIN COLLEGE",
"AM MINING INDIA PRIVATE LIMITED",
"AM MOBILE TELECOM PRIVATE LIMITED",
"AM MOTORS",
"AM ORGO TECH PRIVATE LIMITED",
"AM OZONICS PRIVATE LIMITED",
"AM PACKAGING PRIVATE LIMITED",
"AM PM 24 HRS HOSPITALS PRIVATE LIMITED",
"AM PROFESSIONAL SERVICES PRIVATE LIMITED",
"AM PROTOTYPING LABS PRIVATE LIMITED",
"AM S SPICES AND FOOD PRODUCTS PRIVATE LIMITED",
"AM SECURITY GUARD SERVICES PRIVATE LIMITED",
"AM SERVICES 24X7 PRIVATE LIMITED",
"AM SONS IMPEX PRIVATE LIMITED",
"AM SYNERGY PRIVATE LIMITED",
"AM TECHNOLOGY PRIVATE LIMITED",
"AM TELEVISION PRIVATE LIMITED",
"AM THYROVISION LABORATORIES PRIVATE LIMITED",
"AM TRIDENT TECHNOLOGIES PRIVATE LIMITED",
"AM UNICORN PROFESSIONAL PRIVATE LIMITED",
"AM WEBSHOP INDIA PRIVATE LIMITED",
"AM.P.PAN PRODUCTS PRIVATE LIMITED",
"AM:PM FASHIONS PRIVATE LIMITED",
"AMA AGENCIES PRIVATE LIMITED",
"AMA DESIGN SOLUTIONS PRIVATE LIMITED",
"AMA DIAGNOSTICS CENTRE PRIVATE LIMITED",
"AMA HERBAL LABORATORIES PRIVATE LIMITED",
"AMA INDIA ENTERPRISES PRIVATE LIMITED",
"AMA INDUSTRIES PRIVATE LIMITED",
"AMA LAMINATORS PRIVATE LIMITED",
"AMA LOGISTICS PRIVATE LIMITED",
"AMA MEDICAL AND DIAGNOSTIC CENTRE PRIVATE LIMITED",
"AMA OVERSEAS PRIVATE LIMITED",
"AMA PRIVATE LIMITED",
"AMA PROJECTS PRIVATE LIMITED",
"AMA SERVICES PRIVATE LIMITED",
"AMA SOLUTIONS INDIA PRIVATE LIMITED",
"AMAANA CASA AND HOTELS PRIVATE LIMITED",
"AMAANZA AGRO INDIA PRIVATE LIMITED",
"AMAANZA TRADELINK PRIVATE LIMITED",
"AMAARA FOOD & WELLNESS PRIVATE LIMITED",
"AMAARA TECHNOLOGIES PRIVATE LIMITED",
"AMAARE FASHION PRIVATE LIMITED",
"AMAATRA BANQUETS PRIVATE LIMITED",
"AMAAYRA TEXTILE PRIVATE LIMITED",
"AMAB CLOTHING PRIVATE LIMITED",
"AMABLE CONSULTANCY SERVICES PRIVATE LIMITED",
"AMACE SOLUTIONS PRIVATE LIMITED",
"AMACO IMPEX PRIVATE LIMITED",
"AMADA INDIA PRIVATE LIMITED",
"AMADA SOFT INDIA P LIMITED",
"AMADA WELD TECH INDIA PRIVATE LIMITED",
"AMADEUS DESIGN STUDIO PRIVATE LIMITED",
"AMADEUS INDIA PRIVATE LIMITED",
"AMADEUS MERCHANDISING LIMITED",
"AMADEUS SOFTWARE LABS INDIA PRIVATE LIMITED",
"AMADOR BUSINESS SERVICES PRIVATE LIMITED",
"AMADORA GOURMET ICE CREAM PRIVATE LIMITED",
"AMAESTRO MEDIA PRIVATE LIMITED",
"AMAFHH PETRAXON INDIA PRIVATE LIMITED",
"AMAFHHA MEDIA PRIVATE LIMITED",
"AMAFLIP INDIA PRIVATE LIMITED",
"AMAGI MEDIA LABS PRIVATE LIMITED",
"AMAGO EXIM PRIVATE LIMITED",
"AMAL EMBROIDERIES PRIVATE LIMITED",
"AMAL INFOSYSTEMS PRIVATE LIMITED",
"AMAL LIMITED",
"AMAL LOGISTICS SERVICES PRIVATE LIMITED",
"AMAL OFFSET PRODUCTS P LTD",
"AMAL REALTORS PRIVATE LIMITED",
"AMAL SPECIALITY CHEMICALS LIMITED",
"AMALA CANCER HOSPITAL SOCIETY",
"AMALA ENGINEERING COMPANY PRIVATE LIMITED",
"AMALA PROJECTS PRIVATE LIMITED",
"AMALCO RAIL & INFRA PRIVATE LIMITED",
"AMALGAM FOODS LIMITED",
"AMALGAM FROZEN FOODS PRIVATE LIMITED",
"AMALGAM NUTRIENTS & FEEDS LIMITED",
"AMALGAM STEEL & POWER LIMITED",
"AMALGAM STEEL PRIVATE LIMITED",
"AMALGAMATED COKES AND FUELS (INDIA) PVT LTD",
"AMALGAMATED ENGINEERS PRIVATE LIMITED",
"AMALGAMATED HOLDINGS LIMITED",
"AMALGAMATED INDUSTRIAL COMPOSITES PVT LTD",
"AMALGAMATED PLANTATIONS PRIVATE LIMITED",
"AMALGAMATED TRANSPORT (INDIA) PVT LTD",
"AMALGAMATIONS PRIVATE LIMITED",
"AMALGAMATIONS REPCO LIMITED",
"AMALGAMATIONS VALEO CLUTCH PRIVATE LIMITED",
"AMALGUS INFRA PRIVATE LIMITED",
"AMALI BUILDERS PRIVATE LIMITED",
"AMALIA MEDICAL SERVICES",
"AMALNER NAGAR PARISHAD",
"AMALORPAVAM HIGHER SECONDARY SCHOOL",
"AMALORPAVAM LOURDS ACADEMY",
"AMALTAS ADVISORY SERVICES PRIVATE LIMITED",
"AMALTAS APPAREL AND ACCESSORIES PRIVATE LIMITED",
"AMALTAS HOTELS PRIVATE LIMITED",
"AMALTAS INSTITUTE OF MEDICAL SCIENCE",
"AMALTAS INSTITUTE OF MEDICAL SCIENCES",
"AMALTAS MULTIVENTURES PRIVATE LIMITED",
"AMALYA CHEMEX PRIVATE LIMITED",
"AMAN ADITYA ENTERPRISES PRIVATE LIMITED",
"AMAN ATLANTIC PRIVATE LIMITED",
"AMAN AUTO PRIVATE LIMITED",
"AMAN AVIATION AND AEROSPACE SOLUTIONS PRIVATE LIMITED",
"AMAN BOX FACTORY PRIVATE LIMITED",
"AMAN CIVIL ENGINEERING COMPANY PRIVATE LIMITED",
"AMAN CONCEPTS PRIVATE LIMITED",
"AMAN CONSULTANTS PRIVATE LIMITED",
"AMAN CONTRANS INDIA PRIVATE LIMITED",
"AMAN DIE MAKERS PRIVATE LIMITED",
"AMAN E-WASTE RECYCLERS PRIVATE LIMITED",
"AMAN EXPORTS INTERNATIONAL",
"AMAN EYELETS PRIVATE LIMITED",
"AMAN FERRO STEEL PIPE PRIVATE LIMITED",
"AMAN FINVEST PRIVATE LIMITED",
"AMAN FIREOTECH PRIVATE LIMITED",
"AMAN HEALTH WAYS DIAGNOSTICS PRIVATE LIMITED",
"AMAN HOSPITAL AND SURGICAL CENTRE",
"AMAN INDUSTRIAL SERVICES PRIVATE LIMITED",
"AMAN IRON INDUSTRIES INDIA PRIVATE LIMITED",
"AMAN LIFESTYLE",
"AMAN MACHINE TOOLS PVT LTD",
"AMAN METAL FINISHERS",
"AMAN METALCOMP PRIVATE LIMITED",
"AMAN METALLOY PRIVATE LIMITED",
"AMAN PIPES PRIVATE LIMITED",
"AMAN POLY PLAST PRIVATE LIMITED",
"AMAN PRODUCTS PRIVATE LIMITED",
"AMAN REFRIGERATION PRIVATE LIMITED",
"AMAN REX PRIVATE LTD",
"AMAN ROAD TRANSPORT PRIVATE LIMITED",
"AMAN ROLLING MILLS PRIVATE LIMITED",
"AMAN SAREE PRIVATE LIMITED",
"AMAN SEATRANS PRIVATE LIMITED",
"AMAN SHILPI AGENCIES PRIVATE LTD",
"AMAN SHREE DESIGNERS PRIVATE LIMITED",
"AMAN SPIN FAB PRIVATE LIMITED",
"AMAN STAMPINGS AND TOOLINGS PRIVATE LIMITED",
"AMAN SUPER SECURITAS PRIVATE LIMITED",
"AMAN TEA DISTRIBUTORS PRIVATE LIMITED",
"AMAN TECHNOLOGIES PRIVATE LIMITED",
"AMAN TRADING COMPANY PRIVATE LIMITED",
"AMAN TRAVELS DELHI PRIVATE LIMITED",
"AMAN TRAVELS PRIVATE LIMITED",
"AMAN VENTURES PRIVATE LIMITED",
"AMANA LITERATURE PRIVATE LIMITED",
"AMANAN RETAIL INDIA PRIVATE LIMITED",
"AMANAT CONSTRUCTIONS PRIVATE LIMITED",
"AMANAT DISTRIBUTORS PRIVATE LIMITED",
"AMANAT IMPEX PRIVATE LIMITED",
"AMANAT STEELS PRIVATE LIMITED",
"AMANAYA VENTURES LIMITED",
"AMANCITY INFRAHOMES PRIVATE LIMITED",
"AMANDEEP GARDENING PRIVATE LIMITED",
"AMANDEEP HEALTHCARE PRIVATE LIMITED",
"AMANDEEP HOSPITAL",
"AMANDEEP KAMAL HOSPITAL PRIVATE LIMITED",
"AMANI GLOBAL PRIVATE LIMITED",
"AMANI LEATHER CRAFTS PRIVATE LIMITED",
"AMANN SEWING & EMBROIDERY THREADS PRIVATE LIMITED",
"AMANORA KNOWLEDGE FOUNDATION",
"AMANORA THE FERN",
"AMANRAJ ENTERPRISES PRIVATE LIMITED",
"AMANS ATLANTIC LIMITED",
"AMANTA HEALTHCARE LIMITED",
"AMANTE HOSPITALITY PRIVATE LIMITED",
"AMANTE INDIA LIMITED",
"AMANTRA INDIA ELECTRIC (OPC) PRIVATE LIMITED",
"AMANTRAN GEMS & JEWELS PRIVATE LIMITED",
"AMANTRAN GUEST HOUSE PRIVATE LIMITED",
"AMANTRAN JEWELLERS PRIVATE LIMITED",
"AMANTYA TECHNOLOGIES PRIVATE LIMITED",
"AMANYS PHARMA INDIA PRIVATE LIMITED",
"AMANZI TECHNOLOGIES PRIVATE LIMITED",
"AMAP PRESS & TOOLS PRIVATE LIMITED",
"AMAPURE CHEMICALS PRIVATE LIMITED",
"AMAR ACCESSORIES PRIVATE LIMITED",
"AMAR AGARWAL FOODS (INDIA) PRIVATE LIMITED",
"AMAR AGRI SOLUTIONS PRIVATE LIMITED",
"AMAR AGRO INDUSTRIES",
"AMAR ALLIANCE CONSULTANTS PRIVATE LIMITED",
"AMAR ALLIANCE SECURITIES PRIVATE LIMITED",
"AMAR ALLOYS PRIVATE LIMITED",
"AMAR ALUM AND ALLIED CHEMICALS PRIVATE LIMITED",
"AMAR ARCHITECTURE & DESIGNS PRIVATE LIMITED",
"AMAR AUTOTECH PRIVATE LIMITED",
"AMAR BEER SHOPPEE",
"AMAR BIO ORGANICS (INDIA) PRIVATE LIMITED",
"AMAR BROTHERS GLOBAL PRIVATE LIMITED",
"AMAR BUILDERS AND DEVELOPERS",
"AMAR BUILDHOME PRIVATE LIMITED",
"AMAR BUILDTECH PRIVATE LIMITED",
"AMAR CAB PRIVATE LIMITED",
"AMAR CARS PRIVATE LIMITED",
"AMAR CHITRA KATHA PRIVATE LIMITED",
"AMAR COLOUR CHEM INDIA PRIVATE LIMITED",
"AMAR COMMUNICATION PRIVATE LIMITED",
"AMAR ELASTOMERS PRIVATE LIMITED",
"AMAR ENGICON AND CONSTRUCTION PRIVATE LIMITED",
"AMAR ENGINEERING COMPANY PRIVATE LIMITED",
"AMAR EQUIPMENTS PRIVATE LIMITED",
"AMAR FLAVOURS PRIVATE LIMITED",
"AMAR FLOORINGS PRIVATE LIMITED",
"AMAR FOUNDERS PRIVATE LIMITED",
"AMAR HIGHSCHOLL SANJAYNAGAR",
"AMAR HOSPITAL",
"AMAR HYDROCARBON PRIVATE LIMITED.",
"AMAR ICE AND PRESERVATIONS PRIVATE LIMITED",
"AMAR IMPEX",
"AMAR INDIA PRIVATE LIMITED",
"AMAR INDIA WOOLLEN MILLS PVT LTD",
"AMAR INDUSTRIES LIMITED",
"AMAR INFRACON PRIVATE LIMITED",
"AMAR INFRASTRUCTURE LIMITED",
"AMAR INTERNATIONAL",
"AMAR INVESTMENTS LTD",
"AMAR IRON UDYOG PRIVATE. LIMITED.",
"AMAR JAIN HOSPITAL",
"AMAR JEWELLERS LIMITED.",
"AMAR JYOTI AUTO PRIVATE LIMITED",
"AMAR JYOTI AUTOMOBILES PRIVATE LIMITED",
"AMAR JYOTI FASHIONS PRIVATE LIMITED",
"AMAR JYOTI INDUSTRIES PRIVATE LIMITED",
"AMAR JYOTI LOGISTICS PRIVATE LIMITED",
"AMAR JYOTI SARASWATI INTERNATIONAL SCHOOL",
"AMAR JYOTI TRAVELS PRIVATE LIMITED",
"AMAR JYOTI VIDHYA VIHAR",
"AMAR KNITMESH TECHNOLOGIES PRIVATE LIMITED",
"AMAR KRISHI SEVA KENDRA",
"AMAR MOTORCYCLES AND SCOOTERS PRIVATE LIMITED",
"AMAR NATH AGGARWAL BUILDERS PRIVATE LIMITED",
"AMAR NATH AGGARWAL ENTERTAINMENTS PRIVATE LIMITED",
"AMAR NATH AGGARWAL INVESTMENTS PVT LTD",
"AMAR NATH VIDHYA ASHRAM MATHURA",
"AMAR NATH VIDYA ASHRAM SENIOR SECONDRY SCHOOL",
"AMAR PARKASH AGRO INDIA LIMITED",
"AMAR PARTAP STEEL PRIVATE. LIMITED.",
"AMAR PHARMACEUTICALS AND LABS (INDIA) PRIVATE LIMITED",
"AMAR PLASTIC INDUSTRIES",
"AMAR POLYFILS PVT LTD",
"AMAR PRAKAASH DEVELOPERSS PRIVATE LIMITED",
"AMAR PRATAP AGRO PRIVATE LIMITED",
"AMAR PRATAP DEVELOPERS PRIVATE LIMITED",
"AMAR PROMOTERS PVT LTD",
"AMAR ROLLER FLOUR MILLS PRIVATE LIMITED",
"AMAR SHAKTI TECHNO ESTATE PRIVATE LIMITED",
"AMAR SINGH FOODS PRIVATE LIMITED",
"AMAR SPIRITS PRIVATE LIMITED",
"AMAR SPLINTS PRIVATE LIMITED",
"AMAR SURGICARE PRIVATE LIMITED",
"AMAR TAXI SERVICES PRIVATE LIMITED",
"AMAR TEA DISTRIBUTORS",
"AMAR TEA PRIVATE LIMITED",
"AMAR TECHNOLABS PRIVATE LIMITED",
"AMAR TELETRONICS PRIVATE LIMITED",
"AMAR TIE-UP PRIVATE LIMITED",
"AMAR TRACTORS PRIVATE LIMITED",
"AMAR TRADES LIMITED",
"AMAR TRANSFORMERS PRIVATE LIMITED",
"AMAR UJALA LIMITED",
"AMAR UJALA WEB SERVICES PRIVATE LIMITED",
"AMAR UNIVERSAL PRIVATE LIMITED",
"AMAR VASTUNIRMAN PRIVATE LIMITED",
"AMAR WHEELS PVT LTD",
"AMAR WOOD INDUSTRIES PRIVATE LIMITED.",
"AMARA BREWERIES PRIVATE LIMITED",
"AMARA HOSPITAL",
"AMARA HOTELS & RESORT PRIVATE LIMITED",
"AMARA INTERIORS PRIVATE LIMITED",
"AMARA LEARNING SPACES PRIVATE LIMITED",
"AMARA MUZIK PRIVATE LIMITED",
"AMARA PACKAGING PRIVATE LIMITED",
"AMARA RAJA BLAZE TECHNOLOGIES PRIVATE LIMITED",
"AMARA RAJA EDUCATIONAL SOCIETY",
"AMARA RAJA ELECTRONICS LIMITED",
"AMARA RAJA ENERGY & MOBILITY LIMITED",
"AMARA RAJA INDUSTRIAL SERVICES PRIVATE LIMITED",
"AMARA RAJA INFRA PRIVATE LIMITED",
"AMARA RAJA MEDIA AND ENTERTAINMENT PRIVATE LIMITED",
"AMARA RAJA POWER SYSTEMS LIMITED",
"AMARA STORES PRIVATE LIMITED",
"AMARA TRADELINE PRIVATE LIMITED",
"AMARALINGESWARA COLD STORAGE PRIVATE LIMITED",
"AMARANT LIFESCIENCES PRIVATE LIMITED",
"AMARANTE BULK CARRIERS PRIVATE LIMITED",
"AMARANTTOSS INFRATECH PRIVATE LIMITED",
"AMARASHA DIGITAL PRINTS PRIVATE LIMITED",
"AMARAVATHI AQUA EXPORTS PRIVATE LIMITED",
"AMARAVATHI CANCER TREATMENT PRIVATE LIMITED",
"AMARAVATHI CHEMICALS AND FERTILISERS PRIVATE LIMITED",
"AMARAVATHI EDUCATIONAL TRUST",
"AMARAVATHI ENTERPRISES",
"AMARAVATHI GARMENTS MANUFACTURING COMPANY",
"AMARAVATHI INSTITUTE OF MEDICAL SCIENCES PRIVATE LIMITED",
"AMARAVATHI PRO-TECH PRIVATE LIMITED",
"AMARAVATHI RESTAURANTS PRIVATE LIMITED",
"AMARAVATHI SPINNING MILLS RAJAPALAYAM PRIVATE LIMITED",
"AMARAVATHI TEXTILES PRIVATE LIMITED",
"AMARAVATI BUILDING MATERIALS PRIVATE LIMITED",
"AMARAVATI DEVELOPMENT CORPORATION LIMITED",
"AMARAVATI LIFE CARE & PHARMA PRIVATE LIMITED",
"AMARAVATI MEDICARE PRIVATE LIMITED",
"AMARAVATI METROPOLITAN REGION DEVELOPMENT AUTHORITY",
"AMARAVATI ROOFINGS PRIVATE LIMITED",
"AMARAWATI TEA CO. LIMITED",
"AMARBHAW POWER PRIVATE LIMITED",
"AMARCHAND JEWELLERS PRIVATE LIMITED",
"AMARCHAND TOWERS PROPERTY HOLDINGS PRIVATE LIMITED",
"AMARDEEP AGGREGATES PRIVATE LIMITED",
"AMARDEEP CHEMICALS INDUSTRIES PRIVATE LIMITED",
"AMARDEEP DESIGNS INDIA PRIVATE LIMITED",
"AMARDEEP DYES AND INTERMEDIATES LIMITED",
"AMARDEEP ENGINEERS AND CONTRACTORS PRIVATE LIMITED",
"AMARDEEP FABRICS PRIVATE LIMITED",
"AMARDEEP GOLD PRIVATE LIMITED",
"AMARDEEP ISPAT PRIVATE LIMITED",
"AMARDEEP LIFE SCIENCES PRIVATE LIMITED",
"AMARDEEP LOGISTICS PRIVATE LIMITED",
"AMAR-DEEP PHARMAS LLP",
"AMARDEEP SHIPPING PRIVATE LIMITED",
"AMARDEEP UTENSILS INDIA PRIVATE LIMITED",
"AMARDEEP-DIYA EYE CARE PRIVATE LIMITED",
"AMARDHAN SPECIALITY FEEDS LLP",
"AMAREECHI SALES PVT.LTD.",
"AMARENDRA FINANCIAL PRIVATE LIMITED",
"AMARESH ENGINEERING PRIVATE LIMITED",
"AMARGANGA AGRO FOODS PRIVATE LIMITED",
"AMARINDIA IRON COMPANY PRIVATE LIMITED",
"AMARIS INDUSTRIES PRIVATE LIMITED",
"AMARITA PACKAGING PRIVATE LIMITED",
"AMARJEET RESORTS PVT LTD",
"AMARJIT FISCAL VENTURES PRIVATE LIMITED",
"AMARJOTHI GRANITES (INDIA) PRIVATE LIMITED (TRANSFER FROM TAMILNADU)",
"AMARJOTHI SPINNING MILLS LIMITED",
"AMARJYOT COMMODITIES PRIVATE LIMITED",
"AMARJYOTI EXIM PRIVATE LIMITED",
"AMARKANTAK GRANITES PRIVATE LIMITED",
"AMARKETFORCE INDIA PRIVATE LIMITED",
"AMARLEELA HOSPITALS PRIVATE LIMITED",
"AMARMEENA METALCRAFT PRIVATE LIMITED",
"AMARNATH AGGARWAL CONSTRUCTIONS PRIVATE LIMITED",
"AMARNATH COLD STORAGE PVT LTD",
"AMARNATH DYEING & BLEACHING WORKS PRIVATE LIMITED",
"AMARNATH ELECTRICALS PRIVATE LIMITED",
"AMARNATH ENVIROPLAST LIMITED",
"AMARNATH FOODS PRIVATE LIMITED",
"AMARNATH GRANITES PRIVATE LIMITED",
"AMARNATH INTERNET SOLUTION PRIVATE LIMITED",
"AMARNATH ISPAT PRIVATE LIMITED",
"AMARNATH KASHIRAM CONSTRUCTION PVT LTD",
"AMARNATH KHANDELWAL AGENCIES PRIVATE LIMITED",
"AMARNATH LEATHER GOODS EXPORTS PRIVATE LIMITED",
"AMARNATH MANUFACTURER PRIVATE LIMITED",
"AMARNATH MISHRA ENTERPRISES PRIVATE LIMITED",
"AMARNATH SALES CO",
"AMARNATH VANIJYA PRIVATE LIMITED",
"AMARON CONSTRUCTIONS PRIVATE LIMITED",
"AMARPADMA TRADELINKS PRIVATE LIMITED",
"AMARPALI CYLINDERS PRIVATE LIMITED",
"AMARPALI INFRASTRUCTURES PRIVATE LIMITED",
"AMARPRAKASH DEVELOPERS PRIVATE LIMITED",
"AMARPUR CONSTRUCTION COMPANY PRIVATE LIMITED",
"AMARPUR TEA & PLANTATIONS LIMITED",
"AMARRAJ RESEARCH FOUNDATION",
"AMARS FOOD PRODUCTS PRIVATE LIMITED",
"AMARSAGAR PRINTS PRIVATE LIMITED",
"AMARSAGAR SEAFOODS PRIVATE LIMITED",
"AMARSH GLOBAL CONNECT LLP",
"AMARSHEEL DEVELOPERS PRIVATE LIMITED",
"AMARSHIVA POLYVIN PRIVATE LIMITED",
"AMARSINH AGRO PRODUCER COMPANY LIMITED",
"AMARSON ENGINEERING PRIVATE LIMITED",
"AMARSON INTERNATIONAL PRIVATE LIMITED",
"AMARSON OVERSEAS PRIVATE LIMITED",
"AMARSONS TRADING PVT LTD",
"AMARSTAR SYSTEMS PRIVATE LIMITED",
"AMARTAM TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"AMARTARA PRIVATE LIMITED",
"AMARTECH CONVERGENCE INDIA PRIVATE LIMITED",
"AMARTEJ PLASTOTRADE PRIVATE LIMITED",
"AMARTEX INDUSTRIES LIMITED",
"AMARTYA COMMERCIAL PRIVATE LIMITED",
"AMARTYA WIRE MESH PRIVATE LIMITED",
"AMARULA SOLUTIONS INDIA PRIVATE LIMITED",
"AMARVICKY INFRASTRUCTURE & SERVICES PRIVATE LIMITED",
"AMARYLLIS APPLIANCES (INDIA) PRIVATE LIMITED",
"AMARYLLIS CLOTHING PRIVATE LIMITED",
"AMARYLLIS HEALTHCARE PRIVATE LIMITED",
"AMAS ENTERPRISES PRIVATE LIMITED",
"AMASHT PAPER HYGIENE PRODUCTS PRIVATE LIMITED",
"AMASIA MULTIGRAIN PRIVATE LIMITED",
"AMASS SKILL VENTURES PRIVATE LIMITED",
"AMASS TRAVEL SERVICES PRIVATE LIMITED",
"AMATE PRODUCTS PRIVATE LIMITED",
"AMATO AUTOMOTIVE PRIVATE LIMITED",
"AMATYA ENTERPRISES PRIVATE LIMITED",
"AMAX ADHESIVE INDIA PRIVATE LIMITED",
"AMAX TECHNOLOGIES INDIA PRIVATE LIMITED",
"AMAY ENTERPRISES",
"AMAY HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"AMAY SPINCOT PRIVATE LIMITED",
"AMAY TECHNOSYSTEMS PRIVATE LIMITED",
"AMAYA APPARELS PRIVATE LIMITED",
"AMAYA EXIM PRIVATE LIMITED",
"AMAYA FABRICS PRIVATE LIMITED",
"AMAYA HERITAGE INN PRIVATE LIMITED",
"AMAYA PROSERVE LLP",
"AMAYRAJ PRESS COMPONENTS PRIVATE LIMITED",
"AMAYSHA TEXTILES PRIVATE LIMITED",
"AMAZE CONCRETE PRODUCTS PRIVATE LIMITED",
"AMAZE ELEVATOR COMPONENTS PRIVATE LIMITED",
"AMAZE GLOBAL MANUFACTURING PRIVATE LIMITED",
"AMAZE INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"AMAZE INSURANCE BROKERS PRIVATE LIMITED",
"AMAZE MARITIME SERVICES PRIVATE LIMITED",
"AMAZE ORGANIC PRIVATE LIMITED",
"AMAZE PROPERTY MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"AMAZE SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"AMAZE TECH SOLUTIONS PRIVATE LIMITED",
"AMAZE TRAVELS PRIVATE LIMITED",
"AMAZECH SYSTEMS PRIVATE LIMITED",
"AMAZECRETE PRIVATE LIMITED",
"AMAZEKART",
"AMAZENT CONTENT SERVICES LLP",
"AMAZER INVESTMENT AND FINANCE LIMITED",
"AMAZIA FASHION PRIVATE LIMITED",
"AMAZIA VISION ENVIRONMENT PRIVATE LIMITED",
"AMAZIN AUTOMATION SOLUTIONS INDIA PRIVATE LIMITED",
"AMAZING BIOTECH PRIVATE LIMITED",
"AMAZING CREATIONS PRIVATE LIMITED",
"AMAZING ESTATES PRIVATE LIMITED",
"AMAZING FASHIONS PVT LTD",
"AMAZING FUN WORLD PRIVATE LIMITED",
"AMAZING HOMES FURNISHINGS PRIVATE LIMITED",
"AMAZING HOTELS PRIVATE LIMITED",
"AMAZING INFRA EQUIPMENTS PRIVATE LIMITED",
"AMAZING MEDICAL DISPOSABLES PRIVATE LIMITED",
"AMAZING PRODUCTS PRIVATE LIMITED",
"AMAZING REAL ESTATE PRIVATE LIMITED",
"AMAZING RESEARCH LABORATORIES LIMITED",
"AMAZING RUBBER PRODUCTS PRIVATE LIMITED",
"AMAZING SECURITY SERVICES PRIVATE LIMITED",
"AMAZINTECH INNOVATIONS PRIVATE LIMITED",
"AMAZON ACADEMIC FOUNDATION",
"AMAZON CHEM (INDIA) PRIVATE LIMITED",
"AMAZON CONTROL TECHNOLOGY PRIVATE LIMITED",
"AMAZON CORPORATE SERVICES PRIVATE LIMITED",
"AMAZON DATA SERVICES INDIA PRIVATE LIMITED",
"AMAZON DEVELOPMENT CENTRE INDIA PRIVATE LIMITED",
"AMAZON DIGITAL SERVICES PRIVATE LIMITED",
"AMAZON DISTRIBUTERS PRIVATE LIMITED",
"AMAZON DISTRIBUTORS PRIVATE LIMITED",
"AMAZON DRUGS PRIVATE LIMITED",
"AMAZON ENVIROTECH PRIVATE LIMITED",
"AMAZON FABRICS PRIVATE LIMITED",
"AMAZON INDIA PVT LTD",
"AMAZON INFOSOLUTION PRIVATE LIMITED",
"AMAZON PAPYRUS CHEMICALS PRIVATE LIMITED",
"AMAZON PAY INDIA PRIVATE LIMITED",
"AMAZON RETAIL INDIA PRIVATE LIMITED",
"AMAZON SELLER SERVICES PRIVATE LIMITED",
"AMAZON SMART COMMERCE SOLUTIONS PRIVATE LIMITED",
"AMAZON SPICES PRIVATE LIMITED",
"AMAZON TECHNOCAST PRIVATE LIMITED",
"AMAZON TEXTILES PRIVATE. LIMITED",
"AMAZON TRANSPORTATION SERVICES PRIVATE LIMITED",
"AMAZON WEB SERVICES INDIA PRIVATE LIMITED",
"AMAZON WHOLESALE (INDIA) PRIVATE LIMITED",
"AMAZON WOOD PRIVATE LIMITED",
"AMAZONE CASTINGS & ENGINEERING PRIVATE LIMITED",
"AMAZONE PHARMACEUTICALS PRIVATE LIMITED",
"AMAZOONE CERAMICS LIMITED",
"AMAZURE TECHNOLOGIES PRIVATE LIMITED",
"AMB CINEMAS LLP",
"AMB INFRASTRUCTURES PRIVATE LIMITED",
"AMB INFRAVENTURES PRIVATE LIMITED",
"AMBA AIRCON PRIVATE LIMITED",
"AMBA ALLUMINIUM PRIVATE LIMITED",
"AMBA AUTO INDUSTRIES PRIVATE LIMITED",
"AMBA AUTO SALES AND SERVICES PRIVATE LIMITED",
"AMBA BANIJYA PRIVATE LIMITED",
"AMBA CARBONISATION PRIVATE LIMITED",
"AMBA CEMENT AND CHEMICALS (INDIA) PRIVATE LIMITED",
"AMBA CEMENT AND CHEMICALS PRIVATE LIMITED",
"AMBA COACH BUILDERS PRIVATE LIMITED",
"AMBA CONDUCTORS",
"AMBA CYLINDERS LIMITED",
"AMBA DISTRIBUTORS PRIVATE LIMITED",
"AMBA ENTERPRISES LIMITED",
"AMBA FOODS",
"AMBA FOUNDARIES PRIVATE LIMITED",
"AMBA GARMENTS PRIVATE LIMITED",
"AMBA GRAINS PRIVATE LIMITED",
"AMBA HIGHRISE PRIVATE LIMITED",
"AMBA HOUSING INDUSTRIES PRIVATE LIMITED",
"AMBA LAMINATE PRIVATE LIMITED",
"AMBA MOBILES PRIVATE LIMITED",
"AMBA MOTORS PRIVATE LIMITED",
"AMBA MULTIPRINT",
"AMBA OXY ENTERPRISES PRIVATE LIMITED",
"AMBA PANEL INDIA PRIVATE LIMITED",
"AMBA PIGMENTS & CHEMICALS PRIVATE LIMITED",
"AMBA POLY PLAST PRIVATE LIMITED",
"AMBA POLYCHROME PRIVATE LIMITED",
"AMBA RIVER COKE LIMITED",
"AMBA SANITARY STORE PRIVATE LIMITED",
"AMBA SHAKTI ISPAT LIMITED",
"AMBA SHAKTI ISPAT LIMITED.",
"AMBA SHAKTI STEELS LIMITED.",
"AMBA SHAKTI UDYOG LIMITED. NEW DELHI",
"AMBA SHIPPING & LOGISTICS PRIVATE LIMITED",
"AMBA TOWNSHIP PRIVATE LIMITED",
"AMBAA SECURITIES PVT. LTD.",
"AMBAB INFOTECH PRIVATE LIMITED",
"AMBABA COMMERCE COLLEGE",
"AMBADAS GINNING & PRESSING PRIVATE LIMITED",
"AMBADI ENTERPRISES LIMITED",
"AMBADI INVESTMENTS LIMITED",
"AMBAJEE COTEX PRIVATE LIMITED",
"AMBAJEE DRUGGISTS PRIVATE LIMITED",
"AMBAJI CEMENTS PRIVATE LIMITED",
"AMBAJI FOODS (INDIA) PRIVATE LIMITED",
"AMBAJI GEOTEX PRIVATE LIMITED",
"AMBAJI IMPORT PRIVATE LIMITED",
"AMBAJI INFRACON PRIVATE LIMITED",
"AMBAJI JEWELLERS PRIVATE LIMITED",
"AMBAJI KAOLIN & MINERALS PRIVATE LIMITED",
"AMBAJI MARKETING",
"AMBAJI NURSING COLLEGE GANESHPURA",
"AMBAJI SHEET PROCESSORS PRIVATE LIMITED",
"AMBAJI SURGICAL MEDICAL AYURVEDIC PRIVATE LIMITED",
"AMBAJI SYNTEX PRIVATE LIMITED",
"AMBAL BRICKS PRIVATE LIMITED",
"AMBALA BUS SYNDICATE PVT LTD",
"AMBALA COLLEGE OF ENGINEERING AND APPLIED RESARCH",
"AMBALA COTSPIN PRIVATE LIMITED",
"AMBALA FOODS PVT LTD",
"AMBALAL CHHOTALAL & SONS PRIVATE LIMITED",
"AMBALAL NIDHI",
"AMBALAL SHARES AND STOCKS PRIVATE LIMITED",
"AMBALAL SYSTEM PRIVATE LIMITED",
"AMBALICKA TEXFAB TRADING PRIVATE LIMITED",
"AMBALIKA CONSTRUCTION LIMITED",
"AMBALIKA HOUSING PRIVATE LIMITED",
"AMBALIKA MINERALS PRIVATE LIMITED",
"AMBALIKA PLYWOOD PVT. LTD",
"AMBALIKA WELFARE FOUNDATION",
"AMBALSOFT INFOTECH PRIVATE LIMITED",
"AMBANA EXPORTS PRIVATE LIMITED",
"AMBANI CERAMIC INDUSTRIES",
"AMBANI FASHION JEWELLERY PRIVATE LIMITED",
"AMBANI ORGANICS LIMITED",
"AMBANI VITRIFIED PRIVATE LIMITED",
"AMBAR AUTO ENGINEERS PRIVATE LIMITED",
"AMBAR AUTOTECH PRIVATE LIMITED",
"AMBAR FORGE PRIVATE LIMITED",
"AMBAR PROTEIN INDUSTRIES LIMITED",
"AMBARA HOSPITALITY PRIVATE LIMITED",
"AMBARAM INFRA (INDIA) PRIVATE LIMITED",
"AMBARNATH JAIHIND CO OP BANK LTD",
"AMBARNATH MUNICIPAL COUNCIL",
"AMBASHAKTI GLASS INDIA PRIVATE LIMITED",
"AMBASHAKTI INDUSTRIES LIMITED",
"AMBASHAKTI UDYOG LIMITED",
"AMBASSADOR BUILDING SOLUTIONS PRIVATE LIMITED",
"AMBASSADOR CEMENT LIMITED",
"AMBASSADOR CONSTRUCTION PRIVATE LIMITED",
"AMBASSADOR CONSULTING SERVICES PRIVATE LIMITED",
"AMBASSADOR EXPRESS HOLIDAYS PRIVATE LIMITED",
"AMBASSADOR INTRA HOLDINGS LIMITED",
"AMBASSADOR OVERSEAS PRIVATE LIMITED",
"AMBASSADOR PRIME HOSPITALITY PRIVATE LIMITED",
"AMBASSADOR RESORTS PRIVATE LIMITED",
"AMBASSADOR SKYCHEF CATERINGS PRIVATE LIMITED",
"AMBASSADORS SKY CHEF",
"AMBASSY OF LEBANON",
"AMBASY CONTRACTORS PRIVATE LIMITED",
"AMBATI RESOURCE SOLUTIONS PRIVATE LIMITED",
"AMBATIRUPATI ZETETIC ENGINEERING PRIVATE LIMITED",
"AMBATTUR CLOTHING LIMITED",
"AMBATTUR DEVELOPERS PRIVATE LIMITED",
"AMBATTUR FASHION INDIA PRIVATE LIMITED",
"AMBATTUR HEAT TREATERS PRIVATE LIMITED",
"AMBATTUR HOTELS PRIVATE LIMITED",
"AMBATTUR INDUSTRIAL ESTATE MFGS.ASSOCIATION",
"AMBATTUR INFRA INDIA PRIVATE LIMITED",
"AMBATY SILKS PRIVATE LIMITED",
"AMBAVAT JAIN & ASSOCIATES LLP",
"AMBAY AUTOCARS PRIVATE LIMITED",
"AMBAY BOARDS INDIA PRIVATE LIMITED",
"AMBAY ISPAT PRIVATE LIMITED",
"AMBAY LABELS PRIVATE LIMITED",
"AMBBER INNOVATIONS PRIVATE LIMITED",
"AMBC TECHNOLOGIES PRIVATE LIMITED",
"AMBE AGRO FOODS LIMITED",
"AMBE AGRO INDUSTRIES PRIVATE LIMITED",
"AMBE BHAVANI MERCANTILE PRIVATE LIMITED",
"AMBE CARRIERS PRIVATE LIMITED",
"AMBE CONSULTANCY SERVICES PRIVATE LIMITED",
"AMBE DYE-CHEM PVT LTD",
"AMBE ESTATES PRIVATE LIMITED",
"AMBE HARIKEM PVT LTD",
"AMBE LEARNING PRIVATE LIMITED",
"AMBE NS AGRO PRODUCTS PRIVATE LIMITED",
"AMBE PHYTOEXTRACTS PRIVATE LIMITED",
"AMBE PROPTECH PRIVATE LIMITED",
"AMBE TEX-FAB INDIA PRIVATE LIMITED",
"AMBE TRADECORP PRIVATE LIMITED",
"AMBE XPRESS LOGISTICS PRIVATE LIMITED",
"AMBEDKAR INSTITUTE OF MANAGEMENT STUDIES",
"AMBEKAR PAINTS PRIVATE LIMITED",
"AMBEKESHWAR STEELS PRIVATE. LIMITED.",
"AMBER (INDIA) PVT LTD",
"AMBER APARTMENT MAKERS PRIVATE LIMITED",
"AMBER AVIATION INDIA PRIVATE LIMITED",
"AMBER BUILDERS",
"AMBER BUSH RUBBER INDUSTRIES PVT LTD",
"AMBER CAPRO PRIVATE LIMITED",
"AMBER CONFECTIONERY PRIVATE LIMITED",
"AMBER CREDIT COMPANY LTD",
"AMBER CROP SCIENCE PRIVATE LIMITED",
"AMBER DESIGN TECH PRIVATE LIMITED",
"AMBER DISTILLERIES LIMITED",
"AMBER DYE TRADE PVT LTD",
"AMBER ELECTROTECH LIMITED",
"AMBER ENTERPRISES INDIA LIMITED",
"AMBER EXIM PRIVATE LIMITED",
"AMBER EXPORTS INDIA",
"AMBER FABTECH PRIVATE LIMITED",
"AMBER FOOD AND INGREDIENTS INDIA PRIVATE LIMITED",
"AMBER HEALTH & NUTRITION PRIVATE LIMITED",
"AMBER HOME INTERIORS PRIVATE LIMITED",
"AMBER INFRACON & ENERGY INDIA PRIVATE LIMITED.",
"AMBER INFRAPROJECT PRIVATE LIMITED",
"AMBER INTERNATIONAL",
"AMBER INTERNET SOLUTIONS PRIVATE LIMITED",
"AMBER METALS PRIVATE LIMITED",
"AMBER NUTRITION PRIVATE LIMITED",
"AMBER POLYTEX PRIVATE LIMITED",
"AMBER PRESS PRIVATE LIMITED",
"AMBER ROAD SOFTWARE PRIVATE LIMITED",
"AMBER ROADWAYS PRIVATE LIMITED",
"AMBER SOLUTIONS PRIVATE LIMITED",
"AMBER SPINTEX PRIVATE LIMITED",
"AMBER SPIRITS PRIVATE LIMITED",
"AMBERG ENGINEERING AG",
"AMBERG ENGINEERING INDIA PRIVATE LIMITED",
"AMBERG INFOCON PRIVATE LIMITED",
"AMBERHEIGHTS INFRA PRIVATE LIMITED",
"AMBEROL LUBTECH PRIVATE LIMITED",
"AMBERPR TECHNOPLAST INDIA PRIVATE LIMITED",
"AMBERTAG ANALYTICS PRIVATE LIMITED",
"AMBEST PRINTS PRIVATE LIMITED",
"AMBESTEN HOMES PRIVATE LIMITED",
"AMBETRONICS ENGINEERS PRIVATE LIMITED",
"AMBEY ABASAN PVT LTD",
"AMBEY AUTOMOBILES PRIVATE LIMITED",
"AMBEY CASTINGS PRIVATE LIMITED",
"AMBEY DURGA IT SOLUTIONS PRIVATE LIMITED",
"AMBEY EDIBLE FOOD PRODUCTS PRIVATE LIMITED",
"AMBEY FABRIC CREATIONS PRIVATE LIMITED",
"AMBEY GOODWILL INFRATECH PRIVATE LIMITED",
"AMBEY INFRA REALTY PRIVATE LIMITED",
"AMBEY IRISH CONSTRUCTIONS PRIVATE LIMITED",
"AMBEY IRON PRIVATE LIMITED",
"AMBEY LABORATORIES LIMITED",
"AMBEY METALLIC LIMITED",
"AMBEY MINING PRIVATE LIMITED",
"AMBEY NIWAS PRIVATE LIMITED",
"AMBEY POLYMERS PVT LTD",
"AMBEY SELECTIONS PRIVATE LIMITED",
"AMBEY SPINNING MILLS",
"AMBEY SUPPLIERS PRIVATE LIMITED",
"AMBEY TUBES PRIVATE LIMITED",
"AMBEYKRIPA INDUSTRIES PRIVATE LIMITED",
"AMBHE FERRO METAL PROCESSORS PRIVATE LIMITED",
"AMBI KNIT PRIVATE LIMITED",
"AMBI KNITWEARS",
"AMBIANCE HOME FURNISHINGS PRIVATE LIMITED",
"AMBIANCE INDIA P LIMITED",
"AMBIANT HOUSING & CONSTRUCTIONS PRIVATE LIMITED",
"AMBIANT INFRA PRIVATE LIMITED",
"AMBIC AYURVED INDIA PRIVATE LIMITED",
"AMBICA AGARBATHIES AROMA & INDUSTRIES LIMITED",
"AMBICA ALLOYS AND STEELS INDIA LIMITED",
"AMBICA ALLOYS AND STEELS INDIA PRIVATE LIMITED",
"AMBICA ALUMINIUM",
"AMBICA BAKELITE PRODUCTS PRIVATE LIMITED",
"AMBICA CAPITAL MARKETS LIMITED",
"AMBICA CASTWELL PRIVATE LIMITED",
"AMBICA CORPORATION LIMITED",
"AMBICA COTSEEDS LIMITED",
"AMBICA DHATU PVT LTD",
"AMBICA ENGTECH WORKS PRIVATE LIMITED",
"AMBICA FABRICS PRIVATE LIMITED",
"AMBICA GINNING PRESSING PRIVATE LIMITED",
"AMBICA HYDRAULICS PRIVATE LIMITED",
"AMBICA INFRA VENTURES PRIVATE LIMITED",
"AMBICA INTERNATIONAL LIMITED",
"AMBICA INTERNATIONAL PRIVATE LIMITED",
"AMBICA IRON AND STEEL PVT LTD",
"AMBICA IRON AND STEELS [HYDERABAD] PRIVATE LIMITED",
"AMBICA ISPAT PRIVATE LIMITED",
"AMBICA JUTE MILLS LIMITED",
"AMBICA LOGISTICS PRIVATE LIMITED",
"AMBICA ORGO-CHEM PRIVATE LIMITED",
"AMBICA PATTERNS (INDIA) PRIVATE LIMITED",
"AMBICA PHARMA MACHINES PRIVATE LIMITED",
"AMBICA POLES PRIVATE LIMITED",
"AMBICA REFRACTORIES PRIVATE LIMITED",
"AMBICA ROTO TECHNOLOGY. PRIVATE LIMITED",
"AMBICA SPINTEX PRIVATE LIMITED",
"AMBICA STEELS LIMITED",
"AMBICA STONES PRIVATE LIMITED",
"AMBICA SYNFAB PRIVATE LIMITED",
"AMBICA SYNTEX PRIVATE LIMITED",
"AMBICA TAPTEX PRIVATE LIMITED",
"AMBICA TECHCERA PRIVATE LIMITED",
"AMBICA WAREHOUSE PRIVATE LIMITED",
"AMBICREATE SOLUTIONS PRIVATE LIMITED",
"AMBICRYSIS SOLUTIONS INDIA PRIVATE LIMITED",
"AMBIDEXTROUS INDICA PRIVATE LIMITED",
"AMBIENCE AIRTECH PRIVATE LIMITED",
"AMBIENCE COMMERCIAL DEVELOPERS PRIVATE. LIMITED.",
"AMBIENCE CONSTRUCTIONS INDIA LIMITED",
"AMBIENCE DESIGNS PRIVATE LIMITED",
"AMBIENCE DEVELOPERS & INFRASTRUCTURE PRIVATE. LIMITED.",
"AMBIENCE EDUCATION SOCIETY",
"AMBIENCE GOLDEN VENTURES PRIVATE LIMITED",
"AMBIENCE HOLIDAY RESORTS LTD",
"AMBIENCE HOSPITALITY MANAGEMENT PRIVATE LIMITED",
"AMBIENCE HOSPITALITY PRIVATE LIMITED",
"AMBIENCE HOTELS & RESORTS PRIVATE LIMITED",
"AMBIENCE IMPEX LIMITED",
"AMBIENCE INTERIORS PRIVATE LIMITED",
"AMBIENCE PUBLIC SCHOOL",
"AMBIENCE TOWERS PRIVATE. LIMITED.",
"AMBIENCE UPKEEP MAINTENANCE HOUSE AND ALLIED SERVICE PRIVATE LIMITED",
"AMBIENCE WATER SOLUTIONS AND MARKETING LIMITED",
"AMBIENT BUSINESS SOLUTIONS PRIVATE LIMITED",
"AMBIENT CONTROLS PRIVATE LIMITED.",
"AMBIENT HOSPITALITY & INFRA SERVICES PRIVATE LIMITED",
"AMBIENT RESORTS PRIVATE LIMITED",
"AMBIENTE TECHNOLOGIES PRIVATE LIMITED",
"AMBIGA ENTERPRISES",
"AMBIGA FIRE TECH PRIVATE LIMITED",
"AMBIGAI CONSULTANCY SERVICES INDIA PRIVATE LIMITED",
"AMBIIENCE METCORP PRIVATE LIMITED",
"AMBIK HARMONIC FILTERS PRIVATE LIMITED",
"AMBIKA APPLIANCES PRIVATE LIMITED",
"AMBIKA CHAIN PRIVATE LIMITED",
"AMBIKA COTTON MILLS LIMITED",
"AMBIKA DRESS COLLECTIONS PRIVATE LIMITED",
"AMBIKA EKECTRICAL WORKS",
"AMBIKA EMPORIUM PRIVATE LIMITED",
"AMBIKA FINCAP CONSULTANTS PRIVATE LIMITED",
"AMBIKA FLOUR MILLS PVT LTD",
"AMBIKA FOOD INDUSTRIES PRIVATE LIMITED",
"AMBIKA FOOTWEAR PRIVATE LIMITED",
"AMBIKA FOREX PRIVATE LIMITED",
"AMBIKA GLOBAL FOODS AND BEVERAGES PRIVATE LIMITED",
"AMBIKA INDIA PRIVATE LIMITED",
"AMBIKA KNITS PRIVATE LIMITED",
"AMBIKA MINING PRIVATE LIMITED",
"AMBIKA MULTIVENTURES PRIVATE LIMITED",
"AMBIKA NUTRITION PRIVATE LIMITED",
"AMBIKA ORNAMENTS PRIVATE LIMITED",
"AMBIKA OVERSEAS PVT LTD",
"AMBIKA PETROCHEM PRIVATE LIMITED",
"AMBIKA PLYWOOD INDUSTRIES PRIVATE LIMITED",
"AMBIKA PREMISES PVT. LTD.",
"AMBIKA PROPERTY VENTURES PRIVATE LIMITED",
"AMBIKA PROPWELL PRIVATE LIMITED",
"AMBIKA REAL ESTATE DEVELOPERS PRIVATE LIMITED",
"AMBIKA REALCON DEVELOPERS PRIVATE LIMITED",
"AMBIKA REALCON PRIVATE LIMITED",
"AMBIKA RECHARGE SOLUTION PRIVATE LIMITED",
"AMBIKA RETAIL PRIVATE LIMITED",
"AMBIKA RUBBER COMPONENTS PRIVATE LIMITED.",
"AMBIKA SAREE HOUSE PRIVATE LIMITED",
"AMBIKA TECHNOPLAST PRIVATE LIMITED",
"AMBIKA TEXFAB PRIVATE LIMITED",
"AMBIKA TIMBER DEPOT",
"AMBIKA WASTE MANAGEMENT PRIVATE LIMITED",
"AMBIKA WHEELS PRIVATE LIMITED",
"AMBIKA WOOD INDUSTRIES PRIVATE. LIMITED.",
"AMBIKAA DAIRYLAND AND RICH FOODS PRIVATE LIMITED",
"AMBIKASHREE PACKING PRIVATE LIMITED",
"AMBISHINE SKILLS PRIVATE LIMITED",
"AMBISURE TECHNOLOGIES PRIVATE LIMITED",
"AMBIT CAPITAL PRIVATE LIMITED",
"AMBIT CONCRETE PRIVATE LIMITED",
"AMBIT ENERGY PRIVATE LIMITED",
"AMBIT FINANCIAL SERVICES PRIVATE LIMITED",
"AMBIT FINVEST PRIVATE LIMITED",
"AMBIT INDUSTRIES PRIVATE LIMITED",
"AMBIT INVESTMENT ADVISORS PRIVATE LIMITED",
"AMBIT POWER SOLUTIONS PRIVATE LIMITED",
"AMBIT PRIVATE LIMITED",
"AMBIT SECURITIES BROKING PRIVATE LIMITED",
"AMBIT SEMICONDUCTORS PRIVATE LIMITED",
"AMBIT SOFTWARE PRIVATE LIMITED",
"AMBIT SWITCHGEAR PRIVATE. LIMITED.",
"AMBIT TRANSMISSION PRODUCTS PRIVATE LIMITED",
"AMBIT WEALTH ADVISORS PRIVATE LIMITED",
"AMBIT WEALTH PRIVATE LIMITED",
"AMBITECH HEALTHCARE PRIVATE LIMITED",
"AMBITION BUILDERS PRIVATE LIMITED",
"AMBITION COAL PRIVATE LIMITED",
"AMBITION EDUCARE PRIVATE LIMITED",
"AMBITION ENTERPRISES PRIVATE LIMITED",
"AMBITION FINSERVE PRIVATE LIMITED",
"AMBITION GLOBAL LOGISTICS PRIVATE LIMITED",
"AMBITION HOMES PRIVATE LIMITED",
"AMBITION HOTELS PRIVATE LIMITED",
"AMBITION INFRABUILD PRIVATE LIMITED",
"AMBITION JEWELS PRIVATE LIMITED",
"AMBITION LOGISTICS PARK PRIVATE LIMITED",
"AMBITION MECHANICALS PRIVATE LIMITED",
"AMBITION MICA LIMITED",
"AMBITION PAPER TECH PRIVATE LIMITED",
"AMBITION SERVICES PRIVATE LIMITED",
"AMBITION TIE-UP PVT LTD",
"AMBITION TRADECOM PRIVATE LIMITED",
"AMBITION TRAVELS & TOURS PRIVATE LIMITED",
"AMBITIONS COMMERCE INSTITUTE PRIVATE LIMITED",
"AMBITIONS FLYING CLUB PRIVATE LIMITED",
"AMBITIOUS PENS PRIVATE LIMITED",
"AMBITIOUS POWER TRADING COMPANY LIMITED",
"AMBITREE INDIA PRIVATE LIMITED",
"AMBITROSS PRIVATE LIMITED",
"AMBITUS WORLD SCHOOL",
"AMBIVIJAY STEEL SUPPLIERS PRIVATE. LIMITED.",
"AMBIX HEALTHCARE LLP",
"AMBIZIONE INFRASTRUCTURE PRIVATE LIMITED",
"AMBLY ENGINEERING PRIVATE LIMITED",
"AMBO AGRITEC LIMITED",
"AMBOOTIA TEA EXPORTS PRIVATE LIMITED",
"AMBOSELI PROFESSIONAL ASSOCIATES PRIVATE LIMITED",
"AMBOULA MODERN RICE MILL PRIVATE LIMITED",
"AMBRA BUSINESS SYSTEM PRIVATE LIMITED",
"AMBRANE INDIA PRIVATE LIMITED",
"AMBRELLA NEXUS PRIVATE LIMITED",
"AMBRIONA CACAO BLENDS PRIVATE LIMITED",
"AMBRISH AGENCIES PRIVATE LIMITED",
"AMBRISH KUMAR TRIPATHI",
"AMBRISK SOFT SYSTEMS PRIVATE LIMITED",
"AMBRO ASIA PRIVATE LIMITED",
"AMBRO TEX LIMITED",
"AMBROCIA SEEDS PRODUCER COMPANY LIMITED",
"AMBROSIA BUILDCON PRIVATE LIMITED",
"AMBROSIA CHEMICALS & PHARMACEUTICALS PRIVATE LIMITED",
"AMBROSIA DESIGNS PRIVATE LIMITED",
"AMBROSIA ENVIRO FARMS PRIVATE LIMITED",
"AMBROSIA INFOTECH LIMITED",
"AMBROSIA LANDMARK PRIVATE LIMITED",
"AMBROSIA LIFE SCIENCES PRIVATE LIMITED",
"AMBROSIA NATURAL PRODUCTS INDIA PRIVATE LIMITED",
"AMBROSIA NUTRITION PRIVATE LIMITED",
"AMBROSIA RESORTS PRIVATE LIMITED",
"AMBROSIAL DEVELOPERS PRIVATE LIMITED",
"AMBROZIA DELICACIES PRIVATE LIMITED",
"AMBTU LIFESCIENCES PRIVATE LIMITED",
"AMBU INDIA PRIVATE LIMITED",
"AMBUJ CONSTRUCTION COMPANY",
"AMBUJ FOODS PRIVATE LIMITED",
"AMBUJ HOTEL AND REAL ESTATE PRIVATE LIMITED",
"AMBUJA CEMENT FOUNDATION",
"AMBUJA CEMENTS LIMITED",
"AMBUJA EDUCATIONAL INSTITUTE",
"AMBUJA FOREX PRIVATE LIMITED",
"AMBUJA GINNING PRESSING AND OIL COMPANY PRIVATE. LIMITED.",
"AMBUJA HOUSING AND URBAN INFRASTRUCTURE COMPANY LIMITED",
"AMBUJA INTERMEDIATES PRIVATE LIMITED",
"AMBUJA NEOTIA HEALTHCARE VENTURE LIMITED",
"AMBUJA NEOTIA HOLDINGS PRIVATE LIMITED",
"AMBUJA NEOTIA TEESTA DEVELOPMENT PRIVATE LIMITED",
"AMBUJA OVERSEAS LLP",
"AMBUJA PIPES PRIVATE LIMITED",
"AMBUJA PLASTICS PRIVATE LIMITED",
"AMBUJA REALTY EVENTS MANAGEMENT LIMITED",
"AMBUJA SOLVEX PRIVATE LIMITED",
"AMBUR TANNERY EFFLUENT TREATMENT COMPANY LIMITED",
"AMBUSH SECURITY PRIVATE LIMITED",
"AMBUTHIRTHA POWER PRIVATE LIMITED",
"AMBUTHIRTHA POWER PRIVATE. LIMITED.",
"AMC CHEMICALS PRIVATE LIMITED",
"AMC COOKWARE INDIA PRIVATE LIMITED",
"AMC ENGINEERING COLLEGE",
"AMC GLOBAL FREIGHT FORWARDING PRIVATE LIMITED",
"AMC GRANITES PRIVATE LIMITED",
"AMC INDIA DIRECT SELLING PRIVATE LIMITED",
"AMC LOGISTICS (INDIA) PRIVATE LIMITED",
"AMC MANUFACTURING INDIA PRIVATE LIMITED",
"AMC SCHOOL BOARD",
"AMC SERVICES & ENGINEERS PRIVATE LIMITED",
"AMC SIX SIGMA PRIVATE LIMITED",
"AMC SQUARE PRIVATE LIMITED",
"AMC STUDIO PRIVATE LIMITED",
"AMCA MARINE CONSULTING PRIVATE LIMITED",
"AMCARE MEDICAL AND RESEARCH PRIVATE LIMITED",
"AMCATS PRIVATE LIMITED",
"AMCHAN PLASTOMAKE PRIVATE LIMITED",
"AMCHEM PRODUCTS PRIVATE LIMITED",
"AMCL MACHINERY LIMITED",
"AMCO AUTOMOBILES PRIVATE LIMITED",
"AMCO BANK",
"AMCO BARRELS RECONDITIONERS PRIVATE LIMITED",
"AMCO BATTERIES LIMITED",
"AMCO CARGO SYSTEMS INDIA PRIVATE LIMITED",
"AMCO CONVERTERS PRIVATE LIMITED",
"AMCO DIGITAL SCALES PRIVATE LIMITED",
"AMCO ENTERPRISES PRIVATE LIMITED",
"AMCO HERBALS PRIVATE LIMITED",
"AMCO INDIA LIMITED",
"AMCO MINING AND DRILLING EQUIPMENTS PRIVATE LIMITED",
"AMCOD ELECTRONICS INDIA PRIVATE LIMITED",
"AMCOL MINERALS AND MATERIALS INDIA P LIMITED",
"AMCON BUILDCON PRIVATE LIMITED",
"AMCON CASTINGS PRIVATE LIMITED",
"AMCON PAVERS AND PROJECTS PRIVATE LIMITED",
"AMCON REALTECH PRIVATE LIMITED",
"AMCOR FLEXIBLES INDIA PRIVATE LIMITED",
"AMCOR PHARMA PRIVATE LIMITED",
"AMCOR RIGID PLASTICS INDIA PRIVATE LIMITED",
"AMCS INDIA PRIVATE LIMITED",
"AMD APPARELS PRIVATE LIMITED",
"AMD ESTATES AND DEVELOPERS PRIVATE LIMITED",
"AMD FABRICS PRIVATE LIMITED",
"AMD FINANCIAL SERVICES PRIVATE LIMITED",
"AMD GREEN ENERGY (INDIA) PRIVATE LIMITED",
"AMD INDIA PRIVATE LIMITED",
"AMD INDUSTRIES LIMITED.",
"AMD OVERSEAS IMPEX (INDIA) PRIVATE LIMITED",
"AMD RESEARCH & DEVELOPMENT CENTER INDIA PRIVATE LIMITED",
"AMDAVAD EYE LASER HOSPITALS PRIVATE LIMITED",
"AMDD FOODS PRIVATE LIMITED",
"AMDDC HOSPITALITY PRIVATE LIMITED",
"AMDHAN CONSULTING SOLUTIONS PRIVATE LIMITED",
"AMDIS HEALTHSCIENCES PRIVATE LIMITED",
"AMDO FOOD COMPANY PRIVATE LIMITED",
"AMDOCS BPO PRIVATE LIMITED",
"AMDOCS DEVELOPMENT CENTRE INDIA LLP",
"AMDOIT TECHNOLOGIES PRIVATE LIMITED",
"AME INFRALOGISTICS PRIVATE LIMITED",
"AME TECHNOLOGIES PRIVATE LIMITED",
"AMEA COLD PRIVATE LIMITED",
"AMEBI TECHNOLOGIES PRIVATE LIMITED",
"AMEE CASTOR AND DERIVATIVES LIMITED",
"AMEE METALS PRIVATE LIMITED",
"AMEEDHARA INDUSTRIES",
"AMEEGO SERVICES INDIA PRIVATE LIMITED",
"AMEELIO HOSPITALS",
"AMEEN SILK MILLS PRIVATE LIMITED",
"AMEENJI RUBBER PRIVATE LIMITED",
"AMEER FAISAL UTTAR BUNIYADI HIGH SCHOOL NARA",
"AMEERA SHIPPING & LOGISTICS PRIVATE LIMITED",
"AMEERA SHIPPING AGENCIES PRIVATE LIMITED",
"AMEET CONSULTANTS AND ENGINEERS PRIVATE LIMITED",
"AMEET METAPLAST PRIVATE LIMITED",
"AMEET POLYFILMS PRIVATE LIMITED",
"AMEEX TECHNOLOGIES PRIVATE LIMITED",
"AMEGH PHARMA PRIVATE LIMITED",
"AMELIORATE DIGITAL CONSULTANCY PRIVATE LIMITED",
"AMELIORATE PHARMA CARE PRIVATE LIMITED",
"AMENA KHATUN MULTI SPECIALITY HOSPITAL",
"AMENITY APPLIANCES PRIVATE LIMITED",
"AMENITY PUBLIC SCHOOL",
"AMENSCO MEDICAL TECHNOLOGIES PRIVATE LIMITED",
"AMENSYS TECHNOLOGIES PRIVATE LIMITED",
"AMEO HOOK LOOP PRIVATE LIMITED",
"AMER NSM INDIA PRIVATE LIMITED",
"AMER PROJECTS PRIVATE LIMITED",
"AMERAX FIRE INDIA PRIVATE LIMITED",
"AMERCO INDUSTRIES PRIVATE LIMITED",
"AMERCO PACKAGING SOLUTIONS PRIVATE LIMITED",
"AMEREN CORPORATION",
"AMEREX PRIVATE LIMITED",
"AMERI CONSULTING SERVICE PRIVATE LIMITED",
"AMERI100 CONSULTING PRIVATE LIMITED",
"AMERIA MINCHEM PRIVATE LIMITED",
"AMERIC TECHNOLOGY CONSULTING PRIVATE LIMITED",
"AMERICA FUJIKURA INDIA PRIVATE LIMITED",
"AMERICAN AIRLINES GROUP INC.",
"AMERICAN AUTO SERVICE PRIVATE LIMITED",
"AMERICAN BUREAU OF SHIPPING",
"AMERICAN CONSULATE GENERAL MUMBAI SERVICES",
"AMERICAN EDUCATION SOCIETY",
"AMERICAN EMBASSY SCHOOL",
"AMERICAN EPAY SERVICES PRIVATE LIMITED",
"AMERICAN EXPRESS BANKING CORP",
"AMERICAN EXPRESS BUSINESS SOLUTIONS INDIA PRIVATE LIMITED",
"AMERICAN EXPRESS INDIA PRIVATE LIMITED",
"AMERICAN EXPRESS SERVICES INDIA PRIVATE LIMITED",
"AMERICAN HOTELS AND RESTAURANTS PRIVATE LIMITED",
"AMERICAN INSTITUTE OF CHEMICAL ENGINEERS INDIA",
"AMERICAN INSTITUTE OF ENGLISH LANGUAGE PRIVATE LIMITED",
"AMERICAN INSTITUTE OF PATHOLOGY AND LABORATORY SCIENCES PRIVATE LIMITED",
"AMERICAN INTERNATIONAL GROUP",
"AMERICAN INTERNATIONAL HEALTH MANAGEMENT LTD",
"AMERICAN INTERNATIONAL SCHOOL",
"AMERICAN LEGALNET INDIA PRIVATE LIMITED",
"AMERICAN MEGATRENDS INTERNATIONAL INDIA PRIVATE LIMITED",
"AMERICAN ORTHO TECH PRIVATE LIMITED",
"AMERICAN PLASTICS ENGINEERING CORPORATION LIMITED",
"AMERICAN PRECOAT SPECIALITY PRIVATE LIMITED",
"AMERICAN REMEDIES HEALTHCARE PRIVATE LIMITED",
"AMERICAN SCHOOL OF BOMBAY",
"AMERICAN SOCIETY FOR QUALITY INDIA PRIVATE LIMITED",
"AMERICAN SOFTWARE TECHNOLOGY PRIVATE LIMITED",
"AMERICAN SPRING AND PRESSING WORKS PRIVATE LIMITED",
"AMERICAN SUPERCONDUCTOR CORPORATION",
"AMERICAN TEC ELECTRONIC INDIA PRIVATE LIMITED",
"AMERICAN TELEPHONE & TELEGRAPHAT&T",
"AMERICAN UNIT INDIA PRIVATE LIMITED",
"AMERICAN VITAMINS INDIA PRIVATE LIMITED",
"AMERICHEM POLYMERS INDIA PRIVATE LIMITED",
"AMERICOS CHEMICALS PRIVATE LIMITED",
"AMERIGO REALTY PRIVATE LIMITED",
"AMERIGO STRUCTURAL ENGINEERS PRIVATE LIMITED",
"AMERIKAN STEELS PRIVATE LIMITED",
"AMERIND DATA SOLUTIONS PRIVATE LIMITED",
"AMERIPRISE INDIA LLP",
"AMERISE PHARMACEUTICALS PRIVATE LIMITED",
"AMERIT RESOURCES PRIVATE LIMITED",
"AMERIYA TEXTILES",
"AMERJUNEIDI FOR FOOD INDUSTRIES PRIVATE LIMITED",
"AMERSEY REALTORS PRIVATE LIMITED",
"AMER-SIL KETEX PRIVATE LIMITED",
"AMES DENTAL COLLEGE",
"AMES IMPEX ELECTRICALS PVT LTD",
"AMESS CONTROLS PRIVATE LIMITED",
"AMET UNIVERSITY",
"AMET UNIVERSITY ACADEMY OF MARITIME EDUCATION AND TRAINING",
"AMETEK HOMES PRIVATE LIMITED",
"AMETEK INSTRUMENTS INDIA PRIVATE LIMITED",
"AMETHYST BIO LABS PRIVATE LIMITED",
"AMETHYST CAFE PRIVATE LIMITED",
"AMETHYST HOSPITALITY PRIVATE LIMITED",
"AMETHYST IT SOLUTIONS PRIVATE LIMITED",
"AMETHYST ONLINE CONSULTANTS PRIVATE LIMITED",
"AMETHYST TRAVELS PRIVATE LIMITED",
"AMETS SOFTWARE PRIVATE LIMITED",
"AMEV RG INDIA PRIVATE LIMITED",
"AMEX ALLOYS PRIVATE LIMITED",
"AMEX GLOBAL PRIVATE LIMITED",
"AMEX INSURANCE BROKERS INDIA PRIVATE LIMITED",
"AMEX TECHPRO PRIVATE LIMITED",
"AMEY BUILDTECH PRIVATE LIMITED",
"AMEY ENETRPRISES",
"AMEY PRABHU SALES PRIVATE LIMITED",
"AMEYA AGENCIES",
"AMEYA BATTERIES PRIVATE LIMITED",
"AMEYA CASTING PRIVATE LIMITED",
"AMEYA CLEARING AGENCY PRIVATE LIMITED",
"AMEYA COMMERCIAL PROJECTS PRIVATE LIMITED",
"AMEYA CONCRETECH PRIVATE LIMITED",
"AMEYA FINISHING SOLUTIONS PRIVATE LIMITED",
"AMEYA FOOD-CHEM PLAST SYSTEMS PVT LTD",
"AMEYA FROZEN FOODS PRIVATE LIMITED",
"AMEYA HOMES & INFRA PRIVATE LIMITED",
"AMEYA INFOVISION PRIVATE LIMITED",
"AMEYA PERFOMATT PRIVATE LIMITED",
"AMEYA PLASTICS PRIVATE LIMITED",
"AMEYA PRECISION ENGINEERS LIMITED",
"AMEYA PRECISION ENGINEERS PRIVATE LIMITED",
"AMEYA REALCON PRIVATE LIMITED",
"AMEYA WORLD SCHOOL",
"AMEYAA TRADING AND CONTRACTING PRIVATE LIMITED",
"AMEYAS BUILDCONS PRIVATE LIMITED",
"AMFA CLIMATECH SOLUTUIONS PRIVATE LIMITED",
"AMFAH INDIA TRADING PRIVATE LIMITED",
"AMFAH INFRASTRUCTURES PRIVATE LIMITED",
"AMFARE SERVICES PRIVATE LIMITED",
"AMFICO AGENCIES PRIVATE LIMITED",
"AMFIL AUTOTECH COMPONENTS PRIVATE LIMITED",
"AMFINO TEX (INDIA) PRIVATE LIMITED",
"AMFORGE INDUSTRIES LIMITED",
"AMG ANESTHESIA MANAGEMENT PRIVATE LIMITED",
"AMG CLEAN ENERGY PRIVATE LIMITED",
"AMG EXIM PRIVATE LIMITED",
"AMG FOOD PRODUCTS PRIVATE LIMITED",
"AMG HOTELS PRIVATE LIMITED",
"AMGEN TECHNOLOGY PRIVATE LIMITED",
"AMGIS LIFESCIENCE LIMITED",
"AMGLO RESOURCES PRIVATE LIMITED",
"AMGTECH ENGINEERS & CONSULTANTS LLP",
"AMH AGRO FOODS PRIVATE LIMITED",
"AMH SOLAR SOLUTIONS PRIVATE LIMITED",
"AMHAQ HEALTH CARE PRIVATE LIMITED",
"AMHARA CONSTRUCTION PRIVATE LIMITED",
"AMHATA HYDRO ENERGY PRIVATE LIMITED",
"AMHOGHA BUILDPRO LIMITED",
"AMI BUILDERS PRIVATE LIMITED",
"AMI BUILDTECH PRIVATE LIMITED",
"AMI CHAND MAKHAN LAL FEEDS PRIVATE LIMITED",
"AMI COMPUTER CONSULTANCY",
"AMI CONTROL SERVICES PRIVATE LIMITED",
"AMI DERMATOLOGY AND WELLNESS PRIVATE LIMITED",
"AMI ENTERPRISES PVT LTD",
"AMI GLOBAL LOGISTICS PRIVATE LIMITED",
"AMI HOLDINGS PRIVATE LIMITED",
"AMI INFRA PROJECTS PRIVATE LIMITED",
"AMI LIFESCIENCES PRIVATE LIMITED¬†",
"AMI MEDITEX PRIVATE LIMITED",
"AMI ORGANICS LIMITED",
"AMI ORGANICS PRIVATE LIMITED",
"AMI PIGMENTS PRIVATE LIMITED",
"AMI POLYMER PRIVATE LIMITED",
"AMI PYROFLEX PRIVATE LIMITED",
"AMI RIDDHI CHEM PRIVATE. LIMITED.",
"AMI TECH INDIA PRIVATE. LIMITED.",
"AMIABLE HOTELS PRIVATE LIMITED",
"AMIABLE JEWELLERY PRIVATE LIMITED",
"AMIABLE LOGISTICS (INDIA) LIMITED",
"AMIAD FILTRATION SYSTEMS (INDIA) PRIVATE LIMITED",
"AMIAD RASAYANA INDIA PRIVATE LIMITED",
"AMIAND CONSULTING PRIVATE LIMITED",
"AMIAS ASSOCIATES PRIVATE LIMITED",
"AMIAS RETAILS PRIVATE LIMITED",
"AMIC FORGING LIMITED",
"AMIC FORGING PRIVATE LIMITED",
"AMICABLE EQUIPMENTS PRIVATE LIMITED",
"AMICALIS BRAIN PRIVATE LIMITED",
"AMICARE HOSPITAL PRIVATE LIMITED",
"AMICHAND TECHNOLOGICAL PRIVATE LIMITED",
"AMICI SECURITIES LIMITED",
"AMICIKART ONLINE SERVICES PRIVATE LIMITED",
"AMICK BROWN INDIA PRIVATE LIMITED",
"AMICO AGROTECH (OPC) PRIVATE LIMITED",
"AMICO OUTLINE PRIVATE LIMITED",
"AMICO SOFTWARE SOLUTIONS LLP",
"AMICO SPORTS PRIVATE LIMITED",
"AMICON TECHNOLOGIES PRIVATE LIMITED",
"AMICORP ADVISORY SERVICES PRIVATE LIMITED",
"AMICORP FUND SERVICES INDIA PRIVATE LIMITED",
"AMICORP MANAGEMENT INDIA PRIVATE LIMITED",
"AMICORP TRUSTEES (INDIA) PRIVATE LIMITED",
"AMICOS CONSOLE SERVICES PRIVATE LIMITED",
"AMICRAFT LIFESTYLE PRIVATE LIMITED",
"AMICRON CLEANTECH PRIVATE LIMITED",
"AMICUS INFOTECH PRIVATE LIMITED",
"AMICUS NATURAL PRODUCTS PRIVATE LIMITED",
"AMICUS TECHNOLOGY PRIVATE LIMITED",
"AMIDA COMTRADE PRIVATE LIMITED",
"AMIDA HOTELS PRIVATE LIMITED",
"AMIDEEP AUTOMOBILES",
"AMIDEV AGRO CARE PRIVATE LIMITED",
"AMIDHAN DEVELOPERS",
"AMIEE COLLECTION PRIVATE LIMITED",
"AMIGA INFORMATICS PRIVATE LIMITED",
"AMIGGO CREATIONS PRIVATE LIMITED",
"AMIGO CONMIX INDIA PRIVATE LIMITED",
"AMIGO FOREX PRIVATE LIMITED",
"AMIGO INDIA PRIVATE LIMITED",
"AMIGO LOGISTICS (INDIA) PRIVATE LIMITED",
"AMIGO OPTIMA SOFTWARE SOLUTIONS PRIVATE LIMITED",
"AMIGO PREFAB PRIVATE LIMITED",
"AMIGO SAMPOORNA PANACEA PRIVATE LIMITED",
"AMIGO SHELTERS PRIVATE LIMITED",
"AMIGO SURGICARE PRIVATE LIMITED",
"AMIGO TRAVELS PRIVATE LIMITED",
"AMIGOBULLS FINTECH SERVICES PRIVATE LIMITED",
"AMIGOS AUTOMOBILES PRIVATE LIMITED",
"AMIGOS ENTERPRISES PRIVATE LIMITED",
"AMIGOS SOLUTIONS PRIVATE LIMITED",
"AMIHA AGRO PRIVATE LIMITED",
"AMIK PRINTERS INDIA PRIVATE LIMITED",
"AMIKA HOTELS MADURAI PRIVATE LIMITED",
"AMIKER ENTERPRISES PRIVATE LIMITED",
"AMILIONN TECHNOLOGIES PRIVATE LIMITED",
"AMIMA MINES AND MINERALS PRIVATE LIMITED",
"AMIN CONTAINER SERVICES PRIVATE LIMITED",
"AMIN FINVEST PRIVATE LIMITED",
"AMIN INTERNATIONAL LIMITED",
"AMIN MANILAL AND COMPANY PRIVATE LIMITED",
"AMIN SONS MARKETING PRIVATE LIMITED",
"AMIN TANNERY LIMITED",
"AMINA HENNA HERBAL (INDIA) PRIVATE LIMITED",
"AMINDER RESORTS PRIVATE LIMITED",
"AMINDO BIOLOGICS PRIVATE LIMITED",
"AMINES BIOTECH PRIVATE LIMITED",
"AMINS PATHOLOGY LABORATORY PRIVATE LIMITED",
"AMIOWN SCHOOLS PRIVATE LIMITED",
"AMIR CHAND ENGINEERING WORKS PRIVATE LIMITED",
"AMIR CHAND JAGDISH KUMAR EXPORTS LIMITED",
"AMIR PATEL CRUSHING SOLUTIONS PRIVATE LIMITED",
"AMIR SHEET GRAH PRIVATE LIMITED",
"AMIR TANKS & VESSELS PVT LTD",
"AMIRA LIFESTYLE PRIVATE LIMITED",
"AMIRSONS SCAFFOLDING PRIVATE LIMITED",
"AMIRTHAA DAIRY PRIVATE LIMITED",
"AMIRTHAA GREEN INFRA PRIVATE LIMITED",
"AMIRTHAM AGRO INDUSTRIES PRIVATE LIMITED",
"AMIRTHAM ENTERPRISES PRIVATE LIMITED",
"AMISA ENGINEERING PRIVATE LIMITED",
"AMISEQ INDIA PRIVATE LIMITED",
"AMISH CROP SCIENCES PRIVATE LIMITED",
"AMISH DAIRY & FOODS PRIVATE LIMITED",
"AMISH STATIONERY PRODUCTS PVT LTD",
"AMISH WIRES PRIVATE LIMITED",
"AMISHA FORWARDERS PRIVATE LIMITED",
"AMISHA IMPEX PRIVATE LIMITED",
"AMISHA POLYMERS PRIVATE LIMITED",
"AMISHA STEELS PRIVATE LIMITED",
"AMISHA TEXTILES PRIVATE LIMITED",
"AMISHA VINYLS PRIVATE LIMITED",
"AMISHI CONSUMER TECHNOLOGIES PRIVATE LIMITED",
"AMISHI DRUGS AND CHEMICALS PRIVATE LIMITED",
"AMISHI INDUSTRIES INDIA PRIVATE LIMITED",
"AMISOFT TECHNOLOGIES PRIVATE LIMITED",
"AMISON FISHERIES LTD",
"AMISTAD PHARMACHEM PRIVATE LIMITED",
"AMIT AGRO TRADE PRIVATE LIM ITED",
"AMIT AGROTECH PRIVATE LIMITED",
"AMIT ASHTECH PRIVATE LIMITED",
"AMIT AUTO WHEELS PRIVATE LIMITED",
"AMIT BIOTECH PRIVATE LIMITED",
"AMIT BUILDWELL PRIVATE LIMITED",
"AMIT CAPACITORS LIMITED",
"AMIT CAPITAL AND SECURITIES PVT LTD",
"AMIT CATSCAN CENTRE PRIVATE LIMITED",
"AMIT CHANDRA TEXTILES PRIVATE LIMITED",
"AMIT CONINFRA INDIA PRIVATE LIMITED",
"AMIT CONSTRUCTION",
"AMIT CREDIT COMPANY PRIVATE LIMITED",
"AMIT DAIRY PRIVATE LIMITED",
"AMIT DECORATIVE PLYWOODS PRIVATE LIMITED",
"AMIT DENISFIED DOORS PRIVATE LIMITED",
"AMIT DYECHEM PRIVATE LIMITED",
"AMIT ENGINEERS AND TOOLS PRIVATE LIMITED",
"AMIT ENTERPRISES HOUSING LIMITED",
"AMIT FABRICATORS PVT LTD",
"AMIT FERRO-ALLOYS & STEEL PRIVATE LIMITED",
"AMIT GLASS PVT LTD",
"AMIT HETEROCHEM LABS INDIA LIMITED",
"AMIT HOMEDECOR PRIVATE LIMITED",
"AMIT HOSPITALS PRIVATE LIMITED",
"AMIT INDUSTRIES PRIVATE LIMITED",
"AMIT INFRAENGINEERS PRIVATE LIMITED",
"AMIT INFRA-LOGIC INDIA PRIVATE LIMITED",
"AMIT IRON PRIVATE LIMITED",
"AMIT ISPAT LIMITED",
"AMIT JALAN AND ASSOCIATES",
"AMIT JASANI FINANCIAL SERVICES PRIVATE LIMITED",
"AMIT JINDAL INFRAWAYS INDORE PRIVATE LIMITED",
"AMIT LAMINATES PRIVATE LIMITED",
"AMIT MARBLES PRIVATE LIMITED",
"AMIT MEDICOS",
"AMIT METALIKS LIMITED",
"AMIT MINES PRIVATE LIMITED",
"AMIT MOTORS PRIVATE LIMITED",
"AMIT NALIN SECURITIES PRIVATE LIMITED",
"AMIT NARROW FAB PRIVATE LIMITED",
"AMIT NUT BOLT",
"AMIT OILS PRIVATE LIMITED",
"AMIT PARIDHAN PRIVATE LIMITED",
"AMIT PETRO PRODUCTS MANUFACTURING PVT. LTD.",
"AMIT POLYPIPES PRIVATE LIMITED",
"AMIT POLYSEATS LIMITED",
"AMIT POMEG-TECH PRIVATE LIMITED",
"AMIT RATHI WEALTH MANAGEMENT PRIVATE LIMITED",
"AMIT REALTORS PRIVATE LIMITED",
"AMIT REALTY PRIVATE. LIMITED.",
"AMIT RISHABH BUILDERS PRIVATE LIMITED",
"AMIT ROAD CARRIER INDIA PRIVATE LIMITED",
"AMIT ROAD LINES",
"AMIT ROADWAYS PRIVATE LIMITED",
"AMIT RUBBER CHEM. TRADING COMPANY PRIVATE LIMITED",
"AMIT SAHITA FINANCE PRIVATE LIMITED",
"AMIT SALES CORPORATION PRIVATE LIMITED",
"AMIT SECURITIES LIMITED",
"AMIT SHOES PRIVATE LIMITED",
"AMIT SPINNING MILLS",
"AMIT STEEL INDUSTRIES PRIVATE LIMITED",
"AMIT WAREHOUSING PRIVATE LIMITED",
"AMIT WAX UDYOG PRIVATE LIMITED",
"AMIT WEAVING MILLS PVT LTD",
"AMITA POLYMERS PRIVATE LIMITED",
"AMITA TECHNICAL COMPANY PRIVATE LIMITED",
"AMITABH CONSTRUCTIONS PRIVATE LIMITED",
"AMITABH PROPERTIES AND HOLDINGS PVT LTD",
"AMITARA GREEN HI-TECH PARK PRIVATE LIMITED",
"AMITARA INDUSTRIES PRIVATE LIMITED",
"AMITARA OVERSEAS LIMITED",
"AMITARA OVERSEAS PRIVATE LIMITED",
"AMITASHA ENTERPRISES PRIVATE LIMITED",
"AMITDIE LASER PRIVATE LIMITED",
"AMITEC ELECTRONICS LIMITED",
"AMITECH INDUSTRIES PRIVATE LIMITED",
"AMITECH TEXTILES LIMITED.ERSTWHILE AMITECH INDUSTRIES LIMITED.",
"AMITEK INFRA PRIVATE LIMITED",
"AMITEK MOLDERS PRIVATE LIMITED",
"AMITEX AGRO PRODUCT PRIVATE LIMITED",
"AMITEX FASHIONS PVT LTD",
"AMITEX TRADING PRIVATE LIMITED",
"AMITH CASHEW INDUSTRIES",
"AMITH MART INTERNATIONAL PRIVATE LIMITED",
"AMITHA MINING EQUIPMENT'S PRIVATE LIMITED",
"AMITI SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"AMITIK TECHNOLOGIES PRIVATE LIMITED",
"AMITOJAS WELLNESS PRIVATE LIMITED",
"AMITOJE INDIA PRIVATE LIMITED",
"AMITRAA HOTELS AND RESTAURANTS PRIVATE LIMITED",
"AMITRAJ DEVELOPERS PRIVATE LIMITED",
"AMITRON DIGITECH PRIVATE LIMITED",
"AMITRON TUBULARS PRIVATE LIMITED",
"AMITRONICS PRIVATE LIMITED",
"AMITY FORGINGS PRIVATE LIMITED",
"AMITY GLOBAL EDUCATION ORGANISATION",
"AMITY GLOBAL VARSITY PRIVATE LIMITED",
"AMITY INFOSOFT PRIVATE LIMITED",
"AMITY INFOTECH PRIVATE LIMITED",
"AMITY INFRA DEVELOPERS PRIVATE LIMITED",
"AMITY INSTITUTE FOR COMPETITIVE EXAMINATIONS",
"AMITY INSTITUTE OF AEROSPACE ENGINEERING",
"AMITY INSTITUTE OF FOOD TEACHNOLOGY",
"AMITY INSTITUTE OF ORGANIC AGRICULTURE",
"AMITY INTERLINK STEELS PRIVATE LIMITED",
"AMITY INTERNATIONAL SCHOOL",
"AMITY LEATHER INTERNATIONAL",
"AMITY POWER PRODUCTS PRIVATE LIMITED",
"AMITY PROJECTS INDIA PRIVATE LIMITED",
"AMITY ROCK PRODUCTS PRIVATE LIMITED",
"AMITY SOFTWARE SYSTEMS LIMITED",
"AMITY THERMOSETS PRIVATE LIMITED",
"AMITY UNIVERSITY",
"AMITY UNIVERSITY MUMBAI",
"AMITY UNIVERSITY PRESS",
"AMITYSOFT TECHNOLOGIES PRIVATE LIMITED",
"AMIURE INTERNATIONAL PRIVATE LIMITED",
"AMI-VARSHA FASHION PRIVATE LIMITED",
"AMIYA COMMERCE & CONSTRUCTION CO PVT LTD",
"AMIYA STEEL PRIVATE. LIMITED.",
"AMIYODAYA PETROCHEM PRODUCTS PVT LTD",
"AMJ LAND HOLDINGS LIMITED",
"AMJ SALES PRIVATE LIMITED",
"AMJAD BOND PRIVATE LIMITED",
"AMJAY EXPORTS PRIVATE LIMITED",
"AMJEY CHEM TRADE PRIVATE LIMITED",
"AMK COMPUTERS PRIVATE LIMITED",
"AMK GROUP OF COMPANIES (GENERAL INSTRUMENTS CON) PRIVATE LIMITED",
"AMK INFORMATION SYSTEMS PRIVATE LIMITED",
"AMK INFRA PROJECTS PRIVATE LIMITED",
"AMK SOLUTIONS PRIVATE LIMITED",
"AMKAP MARKETING PRIVATE LIMITED",
"AMKAY PRODUCTS LIMITED",
"AMKAY VASTRA BHANDAR PRIVATE LIMITED",
"AMKETTE ANALYTICS LIMITED",
"AMKO EXPORTS PRIVATE LIMITED",
"AML FINANCIAL SERVICES PRIVATE LIMITED",
"AML REALTIES PRIVATE LIMITED",
"AML RIGHTSOURCE INDIA PRIVATE LIMITED",
"AMLAGORA COLD STORAGE PVT LTD",
"AMLAVAHINI SOLUTIONS PRIVATE LIMITED",
"AMLF LOGISTICS PRIVATE LIMITED",
"AMLOH STEELS PRIVATE LIMITED",
"AMLOK ENGINEERING & CONSULTANCY PRIVATE LIMITED",
"AMM CONSULTANTS PRIVATE LIMITED",
"AMM INDIA PRIVATE LIMITED",
"AMMA CHANDRAWATI EDUCATIONAL AND CHARITABLE TRUST",
"AMMA CONSTRUCTION INDIA PRIVATE LIMITED",
"AMMA HOSPITAL",
"AMMA MOTORS PRIVATE LIMITED",
"AMMA WOODS PRIVATE LIMITED",
"AMMADOES TRADING AND CONSULTANTS PRIVATE LIMITED",
"AMMAJI PAVANI MEMORIAL SUPER SPECIALITY HOSPITAL",
"AMMAN ASSOCIATED SERVICES PRIVATE LIMITED",
"AMMAN AUTO PRIVATE LIMITED",
"AMMAN BALAJI TWO WHEELERS PRIVATE LIMITED",
"AMMAN SAGO FACTORY",
"AMMAN TRY STEELS PRIVATE LIMITED",
"AMMAN TWO WHEELERS SALEM PRIVATE LIMITED",
"AMMANN INDIA PRIVATE LIMITED",
"AMMAN-TRY SPONGE AND POWER PRIVATE LIMITED",
"AMMAPUR INFRASTRUCTURE PRIVATE LIMITED",
"AMMAR TOOLS & MACHINERY (INDIA ) PRIVATE LIMITED",
"AMMARA CRAFT MAESTROS PRIVATE LIMITED",
"AMMARUN FOUNDRIES",
"AMMAYAPPER ROADWAYS PRIVATE LIMITED",
"AMMAYAPPER TEXTILES PRIVATE LIMITED",
"AMMBIIR HOSPITALITY PRIVATE LIMITED",
"AMMEGA BELTING INDIA PRIVATE LIMITED",
"AMMERAAL BELTECH INDIA PRIVATE LIMITED",
"AMMINI DAIRY & AGRI FARMS PRIVATE LIMITED",
"AMMINI ENERGY SYSTEM PRIVATE LIMITED",
"AMMINI SOLAR PRIVATE LIMITED",
"AMMON INFRAPROJECTS PRIVATE LIMITED",
"AMMONIA SUPPLIES CORPORATION PRIVATE LIMITED",
"AMMTYS INTERIOR (INDIA) PROJECTS PRIVATE LIMITED",
"AMMU INFRASTRUCTURES PRIVATE LIMITED",
"AMMUNITION FACTORY KHADKI",
"AMMUNITION FACTORY KHADKI PUNE",
"AMMUS ENGINEERS PRIVATE LIMITED",
"AMMY VIRK PRODUCTIONS PRIVATE LIMITED",
"AMN LIFE SCIENCE PRIVATE LIMITED",
"AMN PROPERTIES PRIVATE LIMITED",
"AMN TECHNOLOGY PRIVATE LIMITED",
"AMNA CONSTRUCTIONS PRIVATE LIMITED",
"AMNAA PROJECT PRIVATE LIMITED",
"AMNEAL HEALTHCARE PRIVATE LIMITED",
"AMNEAL ONCOLOGY PRIVATE LIMITED",
"AMNEAL PHARMACEUTICALS PRIVATE LIMITED",
"AMNET SYSTEMS PRIVATE LIMITED",
"AMNET TRADING INDIA PRIVATE LIMITED",
"AMNEX INFOTECHNOLOGIES PRIVATE LIMITED",
"AMNEY GENERATOR PRIVATE LIMITED",
"AMNION BIOSCIENCES PRIVATE LIMITED",
"AMNS KHOPOLI LIMITED",
"AMNS PORTS INDIA LIMITED",
"AMNS PORTS PARADIP LIMITED",
"AMNS PORTS SHARED SERVICES PRIVATE LIMITED",
"AMNS SHARED SERVICES LIMITED",
"AMO COMMUNICATIONS PRIVATE LIMITED",
"AMO MOBILITY SOLUTIONS PRIVATE LIMITED",
"AMOCO INDIA INC.,",
"AMOD STAMPINGS PRIVATE. LIMITED.",
"AMODA IRON AND STEEL LIMITED",
"AMODE GARMENTS PRIVATE LIMITED",
"AMODH CERAMIC PRIVATE LIMITED",
"AMODH INFRACON PRIVATE LIMITED",
"AMODHINI ESTATES PRIVATE LIMITED",
"AMOEBA EVENTS PRIVATE LIMITED",
"AMOEBOIDS TECHNOLOGIES PRIVATE LIMITED",
"AMOGGH MERCHANTS PRIVATE LIMITED",
"AMOGH BROADBAND SERVICE PRIVATE LIMITED",
"AMOGH CHEMICALS PRIVATE LIMITED",
"AMOGH CONSULTANTS PRIVATE LIMITED",
"AMOGH CORRUPACK PRIVATE LIMITED",
"AMOGH EXPORTS PRIVATE LIMITED",
"AMOGHA DIVYA CHAITANYA MINERALS & TRADERS PRIVATE LIMITED",
"AMOGHA POLYMERS INDIA PRIVATE LIMITED",
"AMOGHA REALCON PRIVATE LIMITED",
"AMOGHDHAM TRADING PRIVATE LIMITED",
"AMOGUE EXPEDITE PRIVATE LIMITED",
"AMOHA EDUCATION PRIVATE LIMITED",
"AMOHA TRADERS PRIVATE LIMITED",
"AMOL CERAMICA PRIVATE LIMITED",
"AMOL DICALITE LIMITED",
"AMOL HOUSEWARE PRIVATE LIMITED",
"AMOL MINECHEM LIMITED",
"AMOL PAPER MILLS PVT LTD",
"AMOL PHARMACEUTICALS PRIVATE LIMITED",
"AMOL SHETI UDYOG PRIVATE LIMITED",
"AMOL STEEL PRIVATE LIMITED",
"AMOLAKCHAND ANKUR KOTHARI ENTERPRISES PRIVATE LIMITED",
"AMOLAKCHAND MAHAVIDYALAY YAVATMAL",
"AMOLDEEP INFRASTRUCTURE PRIVATE LIMITED",
"AMOLI ORGANICS PRIVATE LIMITED",
"AMOLIK HOUSING PRIVATE LTC",
"AMON ENGINEERS PRIVATE LIMITED",
"AMON-RA IMPEX PRIVATE LIMITED",
"AMOOL OIL AND CHEMICAL INDUSTRIES",
"AMOON JEWELLERS LIMITED",
"AMOPHIL CHEMICALS PRIVATE LIMITED",
"AMOR ADVERTISING MEDIA PRIVATE LIMITED",
"AMOR HOSPITALS",
"AMORA TILES PRIVATE LIMITED",
"AMORE HEALTH ESSENTIALS PRIVATE LIMITED",
"AMORE JEWELS PRIVATE LIMITED",
"AMORGOS HEALTHCARE PRIVATE LIMITED",
"AMOROUS TRADING INDIA PRIVATE LIMITED",
"AMORPHOS CHEMICALS PRIVATE LIMITED",
"AMORPHOS PACKAGING PRIVATE LIMITED",
"AMORRE WOODS PRIVATE LIMITED",
"AMOS BIOSCIENCES PRIVATE LIMITED",
"AMOS ENTERPRISE PRIVATE LIMITED",
"AMOS UNIVERSAL TRADING PRIVATE LIMITED",
"AMOSSYS CONSULTING SERVICES PRIVATE LIMITED",
"AMOSSYS DIGITAL PRIVATE LIMITED",
"AMOTO ENGINEERS PRIVATE LIMITED",
"AMOUNEE HANDLOOM VENTURES PRIVATE LIMITED",
"AMP COMMUNICATIONS PRIVATE LIMITED",
"AMP E - SERVICES PRIVATE LIMITED",
"AMP ENERGY DISTRIBUTED GENERATION ONE PRIVATE LIMITED",
"AMP ENERGY GREEN (C& I) PRIVATE LIMITED",
"AMP ENERGY GREEN ELEVEN PRIVATE LIMITED",
"AMP ENERGY GREEN FIFTEEN PRIVATE LIMITED",
"AMP ENERGY GREEN FOUR PRIVATE LIMITED",
"AMP ENERGY GREEN PRIVATE LIMITED",
"AMP ENERGY INDIA PRIVATE LIMITED",
"AMP FITNESS LLP",
"AMP INFRA PRIVATE LIMITED",
"AMP MOTORS PRIVATE LIMITED",
"AMP ROSE PRIVATE LIMITED",
"AMP SPECIALITY PRODUCTS PRIVATE LIMITED",
"AMP UNIVERSAL REALTY PRIVATE LIMITED",
"AMPA CYCLES PRIVATE LIMITED",
"AMPA HOUSING DEVELOPMENT PRIVATE LIMITED",
"AMPACET SPECIALITY PRODUCTS PRIVATE LIMITED",
"AMPCO METAL INDIA PRIVATE LIMITED",
"AMPCOME TECHNOLOGIES OPC PRIVATE LIMITED",
"AMPCONTROL EQUIPMENTS PRIVATE LIMITED",
"AMPCUS TECH PRIVATE LIMITED",
"AMPERE COMPUTING INDIA PRIVATE LIMITED",
"AMPERE INDUSTRIES PRIVATE LIMITED",
"AMPERE SOFTWARE PRIVATE LIMITED",
"AMPERE VEHICLES PRIVATE LIMITED",
"AMPEREHOUR SOLAR TECHNOLOGY PRIVATE LIMITED",
"AMPERS AND COMMUNICATIONS PRIVATE LIMITED",
"AMPERSAND BIONATURALS PRIVATE LIMITED",
"AMPERSAND DESIGN PRIVATE LIMITED",
"AMPERSAND LOGISTICS PRIVATE LIMITED",
"AMPEX COMMUNICATION (INDIA) PRIVATE LIMITED",
"AMPHAN INFRA PROJECTS PRIVATE LIMITED",
"AMPHENOL INTERCONNECT INDIA PRIVATE LIMITED",
"AMPHENOL OMNICONNECT INDIA PRIVATE LIMITED",
"AMPHETRONIX OFFSET INTERCONNECT SOLUTIONS PRIVATE LIMITED",
"AMPHI ANALYTIC OUTSOURCING PRIVATE LIMITED",
"AMPHI ANQLUTIC",
"AMPHIBIA CONSULTANTS PRIVATE LIMITED",
"AMPHISOFT TECHNOLOGIES PRIVATE LIMITED",
"AMPHITRITE SUBSEA PRIVATE LIMITED",
"AMPHORA SOFTWARE PRIVATE LIMITED",
"AMPI AGENCIES PRIVATE LIMITED",
"AMPINITY POWER EQUIPMENTS PRIVATE LIMITED",
"AMPIRA BIOTECHNICS PRIVATE LIMITED",
"AMPITY INFOTECH PRIVATE LIMITED",
"AMPL CORPORATION PRIVATE LIMITED",
"AMPL MIPL GCL PRIVATE LIMITED",
"AMPLE AUTO TECH PRIVATE LIMITED",
"AMPLE BIO CARE PRIVATE LIMITED",
"AMPLE DESIGNING AND DEVELOPMENT SOLUTIONS PRIVATE LIMITED",
"AMPLE DIGITAL PRIVATE LIMITED",
"AMPLE ENTERPRISE TECHNOLOGIES PRIVATE LIMITED",
"AMPLE FOODS PRIVATE LIMITED",
"AMPLE GRAPHICS PRIVATE LIMITED",
"AMPLE HOTELS AND RESORTS PRIVATE LIMITED",
"AMPLE HR AND PAYROLL SERVICES PRIVATE LIMITED",
"AMPLE INFRASTRUCTURE PRIVATE LIMITED",
"AMPLE PAPER CONTAINERS PVT LTD",
"AMPLE POLYMERS PRIVATE LIMITED",
"AMPLE RETAIL PRIVATE LIMITED",
"AMPLE SOFTECH SYSTEMS PRIVATE LIMITED",
"AMPLE TECHNOLOGIES PRIVATE LIMITED",
"AMPLE TELECOMMUNICATION PRIVATE LIMITED",
"AMPLE TEXTECH PRIVATE LIMITED",
"AMPLE VYAPAAR PRIVATE LIMITED",
"AMPLER TECHNOLOGIES PRIVATE LIMITED",
"AMPLESTA INDIA PRIVATE LIMITED",
"AMPLIFI COMMERCE SOLUTIONS PRIVATE LIMITED",
"AMPLIFON INDIA PRIVATE LIMITED",
"AMPLIFY MINDWARE PRIVATE.LIMITED",
"AMPLIFY SOFTWARE SOLUTIONS PRIVATE LIMITED",
"AMPLIGENE INDIA BIOTECH PRIVATE LIMITED",
"AMPLITECH SOLUTIONS PRIVATE LIMITED",
"AMPLITUDE DEALTRADE PRIVATE LIMITED",
"AMPLIZ PRIVATE LIMITED",
"AMPLUS ALPHA SOLAR PRIVATE LIMITED",
"AMPLUS ANDHRA POWER PRIVATE LIMITED",
"AMPLUS COASTAL POWER PRIVATE LIMITED",
"AMPLUS DAKSHIN PRIVATE LIMITED",
"AMPLUS ENERGY SOLUTIONS PRIVATE LIMITED",
"AMPLUS GREEN POWER PRIVATE LIMITED",
"AMPLUS JYOTIMANGAL ENERGY PRIVATE LIMITED",
"AMPLUS KN ONE POWER PRIVATE LIMITED",
"AMPLUS KN SOLAR PRIVATE LIMITED",
"AMPLUS MANAGEMENT SERVICES PRIVATE LIMITED",
"AMPLUS PAVAGADA SOLAR ENERGY TWO PRIVATE LIMITED",
"AMPLUS POORVA PRIVATE LIMITED",
"AMPLUS POWER SOLUTIONS PRIVATE LIMITED",
"AMPLUS RJ SOLAR PRIVATE LIMITED",
"AMPLUS SHAMS PRIVATE LIMITED",
"AMPLUS SOLAR POWER MH PRIVATE LIMITED",
"AMPLUS SOLAR POWER PRIVATE LIMITED",
"AMPLUS SOLAR SOLUTIONS PRIVATE LIMITED",
"AMPLUS SUN SOLUTIONS PRIVATE LIMITED",
"AMPLUS SUNSHINE PRIVATE LIMITED",
"AMPLUS TUMKUR SOLAR ENERGY ONE PRIVATE LIMITED",
"AMPLUS VENUS PRIVATE LIMITED",
"AMPM FASHIONS PRIVATE LIMITED",
"AMPM LOGISTICS PRIVATE LIMITED",
"AMPM SECURITY SERVICES PRIVATE LIMITED",
"AMPM XPRESS PRIVATE LIMITED",
"AMPM365 ONLINE SERVICES PRIVATE LIMITED",
"AMPO VALVES INDIA PRIVATE LIMITED",
"AMPOL/1 PRIVATE LIMITED",
"RAM TARANGA SOLUTIONS PRIVATE LIMITED",
"AMPOOL INDIA PRIVATE LIMITED",
"AMPORIOS VENTURES PRIVATE LIMITED",
"AMPOWER ENGINEERS PRIVATE LIMITED",
"AMPRA BIOBACT PRIVATE LIMITED",
"AMPRI CONSULTANTS PRIVATE LIMITED",
"AMPRI HYDRAULICS & PNEUMATICS PRIVATE LIMITED",
"AMPS ENGINEERING & EQUIPMENTS PRIVATE LIMITED",
"AMPS FACILITIES MANAGEMENT SERVICES PRIVATE LIMITED",
"AMPS HEALTHCARE INDIA PRIVATE LIMITED",
"AMPS POWER INDIA PRIVATE LIMITED",
"AMPSCON ENGINEERS PRIVATE LIMITED",
"AMPSEPC PRIVATE LIMITED",
"AMPSOLAR CLEAN POWER PRIVATE LIMITED",
"AMPSOLAR ENERGY PRIVATE LIMITED",
"AMPSOLAR ENERGY SYSTEMS PRIVATE LIMITED",
"AMPSOLAR EVOLUTION PRIVATE LIMITED",
"AMPSOLAR GENERATION PRIVATE LIMITED",
"AMPSOLAR INFRASTRUCTURE PRIVATE LIMITED",
"AMPSOLAR POWER GENERATION PRIVATE LIMITED",
"AMPSOLAR POWER SYSTEMS PRIVATE LIMITED",
"AMPSOLAR PROJECTS PRIVATE LIMITED",
"AMPSOLAR SOLUTION PRIVATE LIMITED",
"AMPSOLAR SYSTEMS PRIVATE LIMITED",
"AMPSOLAR TECHNOLOGY PRIVATE LIMITED",
"AMPSOLAR TECHNOLOGY TWO PRIVATE LIMITED",
"AMPSOLAR VENTURES PRIVATE LIMITED",
"AMPSON ENGINEERING PRIVATE LIMITED",
"AMPT FOODS PRIVATE LIMITED",
"AMPTECH ELECTRIC INDIA PVT LTD",
"AMPTON ENGINEERING PRIVATE LIMITED",
"AMPTRONICS TECHNO PRIVATE LIMITED",
"AMPUS LIFE SCIENCES LIMITED",
"AMPYR ENERGY TECH SOLUTIONS PRIVATE LIMITED",
"AMR ENERGY RESOURCES PRIVATE LIMITED",
"AMR EXPORTS INDIA PRIVATE LIMITED",
"AMR INDIA LIMITED",
"AMR INFRACON PRIVATE LIMITED",
"AMR MANUFACTURING PRIVATE LIMITED",
"AMR MERCANTILE PRIVATE LIMITED",
"AMR VALVES PRIVATE LIMITED",
"AMRA GEOGREEN WORKS PRIVATE LIMITED",
"AMRA MOTORS PRIVATE LIMITED",
"AMRAI 69 PRIVATE LIMITED",
"AMRAPALI BANQUETS PRIVATE LIMITED",
"AMRAPALI CARRIAGE AND SECURITY PRIVATE LIMITED",
"AMRAPALI DREAM VALLEY PRIVATE. LIMITED.",
"AMRAPALI EDEN PARK DEVELOPERS PRIVATE. LIMITED.",
"AMRAPALI FINCAP LIMITED",
"AMRAPALI FOODS LIMITED",
"AMRAPALI GROUP OF INSTITUTES",
"AMRAPALI HOSPITALITY SERVICES PRIVATE. LIMITED.",
"AMRAPALI INDUSTRIES LIMITED",
"AMRAPALI JEWELS PRIVATE LIMITED",
"AMRAPALI PACKAGING PRIVATE LIMITED",
"AMRAPALI RESORTS PRIVATE LIMITED",
"AMRAPALI SERVICES PVT LTD.",
"AMRAPALI STEELS PRIVATE LIMITED",
"AMRAPH INDIA PRIVATE LIMITED",
"AMRAT CHITS (INDIA) PRIVATE LIMITED",
"AMRATLAL ASHOK KUMAR COLD STORAGE AND ICE FACTORY PRIVATE LIMITED",
"AMRAVATI AGRO FOODS PRIVATE LIMITED",
"AMRAVATI AMUSEMENTS AND HEALTH CARE PRIVATE LIMITED",
"AMRAVATI JILHA GRAMSEVAK GRAMVIKAS ADHIKARI SAHKARI PATSANTHA",
"AMRAVATI MAHANAGAR PALIKA",
"AMRAVATI MUNCIPAL CORPORATION",
"AMRAVATI POWER TRANSMISSION COMPANY LIMITED",
"AMRAWATI RESIDENCY PRIVATE LIMITED",
"AMREESH NEON PRIVATE LIMITED",
"AMREKHA COMMODITIES PRIVATE LIMITED",
"AMRELI INDUSTRIAL AROMATICS PRIVATE LIMITED",
"AMRELI RENEWABLE ENERGY PRIVATE LIMITED",
"AMREN BOARDS PRIVATE LIMITED",
"AMREST ELECTRICALS LIMITED",
"AMREX MARKETING PVT LTD",
"AMRFEO PRIVATE LIMITED",
"AMRI HOSPITALS LIMITED",
"AMRI HOSPITALS PRIVATE LIMITED",
"AMRI INDIA PRIVATE LIMITED",
"AMRIC SOLAR ENERGY PRIVATE LIMITED",
"AMRIK ENTERPRISE PRIVATE LIMITED",
"AMRIK INFONET PRIVATE LIMITED",
"AMRIK SINGH AND SONS CRANE SERVICES PRIVATE LIMITED",
"AMRISH ONCOLOGY SERVICES PRIVATE LIMITED",
"AMRIT BANASPATI COMPANY PRIVATE LIMITED",
"AMRIT BHOG AGRO PRIVATE LIMITED",
"AMRIT BHOG FLOUR MILLS PRIVATE LIMITED",
"AMRIT BREEDER FARMS PRIVATE LIMITED",
"AMRIT CEMENT LIMITED",
"AMRIT CIC PRIVATE LIMITED",
"AMRIT CORP LIMITED",
"AMRIT CORP. LIMITED",
"AMRIT CRAFTS PRIVATE LIMITED",
"AMRIT DIAMOND TRADE CENTRE PRIVATE LIMITED",
"AMRIT ECOTEX PRIVATE LIMITED",
"AMRIT ENGINEERING PVT LTD",
"AMRIT EXPORTS PRIVATE LIMITED",
"AMRIT FABTECH PRIVATE LIMITED",
"AMRIT FIBERS PRIVATE LIMITED",
"AMRIT FRESH PRIVATE LIMITED",
"AMRIT GOLDIAM PRIVATE LIMITED",
"AMRIT GRAPHICS PRIVATE LIMITED",
"AMRIT HOMES PVT LTD",
"AMRIT HUMIFRESH PRESERVATION PRIVATE LIMITED",
"AMRIT IMPEX PRIVATE LIMITED",
"AMRIT INDUSTRIES PRIVATE LIMITED",
"AMRIT LEARNING LIMITED",
"AMRIT MALWA CAPITAL LIMITED",
"AMRIT MEDICARE PRIVATE LIMITED",
"AMRIT MULTISPECIALITY HOSPITALS PRIVATE LIMITED",
"AMRIT MUSIC PRIVATE LIMITED",
"AMRIT PAPERS PRIVATE LIMITED",
"AMRIT PLACEMENT SERVICES PRIVATE LIMITED",
"AMRIT PLASTRONICS PRIVATE LIMITED",
"AMRIT POLYCHEM PRIVATE LIMITED",
"AMRIT PRIME PROPERTIES PRIVATE LIMITED",
"AMRIT RAJ INFRAPROJECTS PRIVATE LIMITED",
"AMRIT REFINED PRIVATE LIMITED",
"AMRIT SCIENTIFIC IND. PRIVATE LIMITED",
"AMRIT SEAIR EXPRESS PRIVATE LIMITED",
"AMRIT SKILLS DEVELOPMENT PRIVATE LIMITED",
"AMRIT SPINNERS PRIVATE LIMITED",
"AMRIT TRADERS PRIVATE LIMITED",
"AMRIT TRANSPORT COMPANY PVT LTD",
"AMRITA ARTS PRIVATE LIMITED",
"AMRITA CENTRE FOR RESEARCH AND DEVELOPMENT",
"AMRITA CHEMICALS (INDIA) PRIVATE LIMITED",
"AMRITA CONSTRUCTIONS & EQUIPMENTS ENGINEERING PRIVATE LIMITED",
"AMRITA ENGINEERING AND TRADING COMPANY PRIVATE LIMITED",
"AMRITA ENTERPRISES PRIVATE LIMITED",
"AMRITA HOSPITAL",
"AMRITA INSTITUTE OF MEDICAL SCIENCES AND RESEARCH CENTRE",
"AMRITA PLUMARCH PRIVATE LIMITED",
"AMRITA VIDYALAYAM",
"AMRITA VISHWA VIDYAPEETHAM",
"AMRITA VISHWA VIDYAPEETHAM SCHOOL OF ENGINEERING",
"AMRITAPUR TEA CO LTD",
"AMRITASHA HOSPITALS AND TRAUMA CENTER PRIVATE LIMITED",
"AMRITDHARA HOSPITAL PRIVATE LIMITED",
"AMRITDHARA OVERSEAS PRIVATE LIMITED",
"AMRITDHARA VINTRADE PRIVATE LIMITED",
"AMRITESH AGRO PRODUCTS PRIVATE LIMITED",
"AMRITESH INDUSTRIES PRIVATE LIMITED",
"AMRITHA INSTITUTE OF MEDICAL SCIENCE",
"AMRITHA INSTITUTE OF TECHNOLOGY",
"AMRITHA TOOL CRAFTS PRIVATE LIMITED",
"AMRITLAKSHMI MACHINE WORKS",
"AMRITLAL CHEMAUX PRIVATE LIMITED",
"AMRITMAYA FOODS PRIVATE LIMITED",
"AMRITPUR RICE LAND PRIVATE LIMITED",
"AMRITSAR BOWLING AND FUN CENTRE PRIVATE LIMITED",
"AMRITSAR COLLEGE OF ENGINEERING & TECHNOLOGY",
"AMRITSAR ENVIROCARE SYSTEMS PRIVATE LIMITED",
"AMRITSAR IMPROVEMENT TRUST",
"AMRITSAR MUNCIPAL CORPORATION",
"AMRITSAR RICE LAND",
"AMRITSAR SCANOMED PVT LTD",
"AMRITSAR SWADESHI TEXTILE CORPORATION PRIVATE LIMITED",
"AMRITUM FASHION PRIVATE LIMITED",
"AMRITVANI TECHNOLOGIES PRIVATE LIMITED",
"AMRITVARSA TEXTILE MILLS PRIVATE LIMITED",
"AMRITVARSHA FINANCE & LEASING LIMITED",
"AMRITVARSHA UDYOG LIMITED",
"AMRITWAHINI COLLEGE OF ENGINEERING",
"AMRK GOLD REFINES PRIVATE LIMITED",
"AMRL HITECH CITY LIMITED",
"AMRO FEEDS PRIVATE LIMITED",
"AMRO KINGS LIMITED",
"AMRO MANUFACTURERS PRIVATE LIMITED",
"AMRO PHARMA PRIVATE LIMITED",
"AMROHA GLASS FACTORY PRIVATE LIMITED",
"AMRON REALTORS PRIVATE LIMITED",
"AMROP INDIA PRIVATE LIMITED",
"AMROZIYA GARMENTS PRIVATE LIMITED",
"AMRR MAHARAJA DHALL MILLS PRIVATE LIMITED",
"AMRS BUSINESS SERVICES PRIVATE LIMITED",
"AMRTA REALTY (INDIA) PRIVATE LIMITED",
"AMRTA TEXFAB PRIVATE LIMITED",
"AMRUT BAL RUGNALAY AND CRITICAL CARE CENTER",
"AMRUT BAL RUGNALAY AND CRITICAL CARE CENTRE",
"AMRUT BROTHERS MACHINERY PRIVATE LIMITED",
"AMRUT BUILDERS",
"AMRUT COLD STORAGE PRIVATE LIMITED",
"AMRUT CORROSION CONTROLS PRIVATE LIMITED",
"AMRUT CREATIONS INDIA LIMITED",
"AMRUT DOG GURU SERVICES PRIVATE LIMITED",
"AMRUT DREDGING AND SHIPPING LIMITED",
"AMRUT GEMS",
"AMRUT HOSPITAL",
"AMRUT MADHAVI FOODS AND AGRO PRODUCTS PRIVATE LIMITED",
"AMRUT ORNAMENTS PRIVATE LIMITED",
"AMRUT PACK PRINT PRIVATE LIMITED",
"AMRUT PAPER PRODUCTS PRIVATE LIMITED",
"AMRUT PRIMARY SCHOOL",
"AMRUT SANJIVANI SUGARCANE PRIVATE LIMITED",
"AMRUT SOFTWARE PRIVATE LIMITED",
"AMRUT TECHNOCAST PRIVATE LIMITED",
"AMRUTA APPAREL PRIVATE LIMITED",
"AMRUTA HERBALS PRIVATE LIMITED",
"AMRUTA INFRATECH PRIVATE LIMITED",
"AMRUTA PAPAD PRODUCTS PRIVATE LIMITED",
"AMRUTA PEDIACARE PRIVATE LIMITED",
"AMRUTANJAN HEALTH CARE LIMITED",
"AMRUTDHARA BUILDCON PRIVATE LIMITED",
"AMRUTDHARA DRILLWELL PRIVATE LIMITED",
"AMRUTH AGRO FARMS PRIVATE LIMITED",
"AMRUTH AUTOMOTIVES PRIVATE LIMITED",
"AMRUTHA ALLWELL MEDIA SOLUTIONS PRIVATE LIMITED",
"AMRUTHA COFFEE PRIVATE. LIMITED.",
"AMRUTHA CONSTRUCTIONS PRIVATE. LIMITED.",
"AMRUTHA FINANCE PVT LTD",
"AMRUTHA SHELTERS PRIVATE LIMITED",
"AMRUTHA SYSTEMS AND SOLUTIONS PRIVATE LIMITED",
"AMRUTHASHALA INDIA PRIVATE LIMITED",
"AMRUTKAPADIA NAVJEEVAN WOMENS COLLEGE",
"AMRUTLAL DESAI GENERAL HOSPITAL",
"AMRUTVAHINI SHETI AND SHIKSHAN VIKAS SANSTHA",
"AMRUTWEL GLOBAL SCHOOL",
"AMRUTWELL HEALTHCARE PRIVATE LIMITED",
"AMS AGRO FOODS PRIVATE LIMITED",
"AMS ALLIED PRIVATE LIMITED",
"AMS BHARGAVA MACHINING PRIVATE LIMITED",
"AMS COMTEL BUSINESS PROCESS MANAGEMENT SERVICES PRIVATE LIMITED",
"AMS CONTAINER LINES PRIVATE LIMITED",
"AMS ELECTROCOAT LLP",
"AMS ENGINEERING COLLEGE",
"AMS EXPRESS SERVICES PRIVATE LIMITED",
"AMS MARINE SERVICES PRIVATE LIMITED",
"AMS NARULA LABELS PRIVATE LIMITED",
"AMS PROJECT CONSULTANTS PRIVATE LIMITED",
"AMS RAJ PALACE SUNDAR",
"AMS RENT A CAB PRIVATE LIMITED",
"AMS SEMICONDUCTORS INDIA PRIVATE LIMITED",
"AMS TOOLS PRIVATE LIMITED",
"AMSAK CRANES PRIVATE LIMITED",
"AMSAL CHEM PRIVATE LIMITED",
"AMSAM BRANDS PRIVATE LIMITED",
"AMSAR GOA PRIVATE LIMITED",
"AMSAR PRIVATE LIMITED",
"AMSAT INDUSTRIES PRIVATE LIMITED",
"AMSBURG INDUSTRIES PRIVATE LIMITED",
"AMSC INDIA PRIVATE LIMITED",
"AMS-CHASYS AUTOMOTIVE INDIA PRIVATE LIMITED",
"AMSEPAL INDIA PRIVATE LIMITED",
"AMSERVE CONSULTANTS LIMITED",
"AMSH PRODUCT LINE PRIVATE LIMITED",
"AMSHUHU I TECH SOLUTION PRIVATE LIMITED",
"AMSI ENGINEER PRIVATE LIMITED",
"AMSM AUTOMART PRIVATE LIMITED",
"AMSON INTERCONNECT PRIVATE LIMITED",
"AMSON PRINT PACK PRIVATE LIMITED",
"AMSON TEK PRIVATE LIMITED",
"AMSONS COMMUNICATIONS PRIVATE LIMITED",
"AMSONS LABORATORIES PRIVATE LIMITED",
"AMSONS STEELS PRIVATE LIMITED",
"AMSONS TOURS AND TRAVELS",
"AMSPRO BIOTECH PRIVATE LIMITED",
"AMSPRO LIFESCIENCES PRIVATE LIMITED",
"AMSS DEFINE URBAN ECOLOGICAL DESIGN PRIVATE LIMITED",
"AMSS TRAVEL STREET PRIVATE LIMITED",
"AMSTED STEEL FOUNDRIES (INDIA) PRIVATE LIMITED",
"AMSTEEL CASTINGS PRIVATE LIMITED",
"AMSTEEL INDUSTRIES PRIVATE LIMITED",
"AMSTER HEALTHCARE PRIVATE LIMITED",
"AMSTER MICROCELL PRIVATE LIMITED",
"AMSTOR INFORMATION TECHNOLOGY INDIA PVT LTD",
"AMSTRAD CONSUMER INDIA PRIVATE LIMITED",
"AMSTRONG AGENCIES PRIVATE LIMITED",
"AMSURE INSURANCE AGENCY LIMITED",
"AMT ALLOYS PRIVATE LIMITED",
"AMT BUILDERS PRIVATE LIMITED",
"AMT ENVIRACLEAN TECHNOLOGIES PRIVATE LIMITED",
"AMT INTERNATIONAL",
"AMT POWDER TECH PRIVATE LIMITED",
"AMT PROJECT PRIVATE LIMITED",
"AMT WORLD TRADE PRIVATE LIMITED",
"AMTALI JOYGOPALPUR HIGH SCHOOL",
"AMTEC HEALTH CARE PRIVATE LIMITED",
"AMTECH ELECTRONICS INDIA LIMITED",
"AMTECH ENGINEERING PRIVATE LIMITED",
"AMTECH ESTERS LIMITED",
"AMTECH ESTERS PRIVATE LIMITED",
"AMTECH INVESTMENT CASTING PRIVATE LIMITED",
"AMTECH POWER LIMITED",
"AMTEK AUTO PRESSINGS & EXPORTS PRIVATE LIMITED",
"AMTEK DISTRIBUTORS PVT LTD",
"AMTEK INSTRUMENTS PRIVATE LIMITED",
"AMTEK PROJECTS PVT LTD",
"AMTEK TEKFOR AUTOMOTIVE LIMITED",
"AMTEK TRANSPORTATION SYSTEMS LIMITED",
"AMTEL COMMUNICATION PRIVATE LIMITED",
"AMTEL TELECOMMUNICATIONS PRIVATE LIMITED",
"AMTERP SOLUTIONS INDIA PRIVATE LIMITED",
"AMTEX DIGITAL CORPORATION PRIVATE LIMITED",
"AMTEX ENTERPRISES INDIA PRIVATE LIMITED",
"AMTIK PACKAGING PRIVATE LIMITED",
"AMTIK POLYMERS PRIVATE LIMITED",
"AMTM MISTJET PRIVATE LIMITED",
"AMTRAC AUTOMOTIVE INDIA PRIVATE LIMITED",
"AMTRAC INDUSTRIES PRIVATE LIMITED",
"AMTRAK INFONET PRIVATE LIMITED",
"AMTRAK TECHNOLOGIES PRIVATE LIMITED",
"AMTRAN MAGNETICS PRIVATE LIMITED",
"AMTRAX (INDIA) LIFE SCIENCES PRIVATE LIMITED",
"AMTS SALES PRIVATE LIMITED",
"AMU LEASING PRIVATE LIMITED",
"AMU MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"AMU SHARES AND SECURITIES LIMITED",
"AMUDHA ASEPTIC FOOD PRODUCTS",
"AMUDHA CIVIL CONSTRUCTION PRIVATE LIMITED",
"AMUKHA TECHNOLOGIES PRIVATE LIMITED",
"AMUL AUTO COMPONENTS PRIVATE LIMITED",
"AMUL BOARDS PRIVATE LIMITED",
"AMUL CHEMICAL INDUSTRIES PRIVATE LIMITED",
"AMUL CONSTRUCTIONS INDIA PRIVATE LIMITED",
"AMUL DAIRY",
"AMUL FEED PRIVATE LIMITED",
"AMUL INDUSTRIES PRIVATE LIMITED",
"AMUL POLYMER (INDIA) PRIVATE LIMITED",
"AMULAKH AMICHAND INTERNATIONAL SCHOOL",
"AMULET COATINGS PRIVATE LIMITED",
"AMULFED DAIRY ( A UNIT OF GUJARAT COOPERATIVE MILK MARKETING FEDERATION LTD)",
"AMULIN HYDRO POWER PRIVATE LIMITED",
"AMULRAJ JEWELLERS PRIVATE LIMITED",
"AMULYA DISHA MEDICINE PRIVATE LIMITED",
"AMULYA HERBS PRIVATE LIMITED",
"AMULYA INFOTECH INDIA PRIVATE LIMITED",
"AMULYA LABS PRIVATE LIMITED",
"AMULYA SEA FOODS",
"AMULYA TRADERS AND ENGINEERS PRIVATE LIMITED",
"AMULYAM AYURVEDA PRIVATE LIMITED",
"AMUN SOLARFARMS LIMITED",
"AMUNRA INFRATECH AND AGRITECH PRIVATE LIMITED",
"AMUR STEEL PRIVATE LIMITED",
"AMURA MARKETING TECHNOLOGIES PRIVATE LIMITED",
"AMURDAILY MILKCLUBS PRIVATE LIMITED",
"AMURTHA TEXTILES",
"AMUSAVI MTC PRIVATE LIMITED",
"AMUSE DIGITEC INDIA PRIVATE LIMITED",
"AMUSE LABS PRIVATE LIMITED",
"AMUSE POLYMERS PRIVATE LIMITED",
"AMUST WATER PRODUCTS PVT LTD",
"AMUTHA GOLD AND DIAMONDS PRIVATE LIMITED",
"AMV BOTANICS PRIVATE LIMITED",
"AMV CASTING PRIVATE LIMITED",
"AMV INFRATECH PRIVATE LIMITED",
"AMVAR VENTURES PRIVATE LIMITED",
"AMVEL AUTOMATION PRIVATE LIMITED",
"AMVI BUILDWELL PRIVATE LIMITED",
"AMVI ENGINEERING PRIVATE LIMITED",
"AMVIAK CONSULTING PRIVATE LIMITED",
"AMVIAN AUTOMOTIVE PRIVATE LIMITED",
"AMVID CARGO TRANSIT PRIVATE LIMITED",
"AMVIGOR ORGANICS PRIVATE LIMITED",
"AMVIK SOLUTIONS PRIVATE LIMITED",
"AMVION LABS PRIVATE LIMITED",
"AMVIRA MEDIA & MARKETING PRIVATE LIMITED",
"AMVIS SYSTEMS INDIA LIMITED",
"AMVOTECH SOLUTIONS PRIVATE LIMITED",
"AMW LIFESTYLE PRIVATE LIMITED",
"AMWAY INDIA ENTERPRISES PRIVATE LIMITED",
"AMWILL HEALTH CARE LIMITED",
"AMWILL HEALTH CARE PRIVATE LIMITED",
"AMWIN MACHINING PRIVATE LIMITED",
"AMWIN SYSTEMS PRIVATE LIMITED",
"AMWOODO ECO PRODUCTS PRIVATE LIMITED",
"AMX PRODUCTS AND SOLUTIONS PRIVATE LIMITED",
"AMY EXPORTS AND IMPORTS PRIVATE LIMITED",
"AMY FRESH FRUITS INDIA PRIVATE LIMITED",
"AMY SOFTECH PRIVATE LIMITED",
"AMYGB.AI PRIVATE LIMITED",
"AMYLO DEX PRIVATE LIMITED",
"AMYNTOR TECH SOLUTIONS PRIVATE LIMITED",
"AMYRA HERBS PRIVATE LIMITED",
"AMYRINA INFOTECH PRIVATE LIMITED",
"AMYUSH TECHNO SOLUTIONS PRIVATE LIMITED",
"AMZ LOGISTICS SOLUTIONS PRIVATE LIMITED",
"AMZ PACKAGING PRIVATE LIMITED",
"AMZEN TECHNOLOGIES PRIVATE LIMITED",
"AMZES TRADING PRIVATE LIMITED",
"AMZETTA TECHNOLOGIES PRIVATE LIMITED",
"AMZOLE INDIA PRIVATE LIMITED",
"AMZONE INTERNATIONAL PRIVATE LIMITED",
"AM-ZONE INTERNATIONAL PRIVATE LIMITED",
"AMZUR INFOTECH PRIVATE LIMITED",
"AMZUR TECHNOLOGIES PRIVATE LIMITED",
"AN BEACH HOSPITAL",
"AN CRYO INSTRUMENTS PRIVATE LIMITED",
"AN DENT INDIA PRIVATE LIMITED",
"AN HOUR SOLUTION PRIVATE LIMITED",
"AN IGP E-LEARNING PRIVATE LIMITED",
"AN INFOWEB",
"AN INSTITUTE FOR GROOMING PROFESSIONALS PRIVATE LIMITED",
"AN ROYAL ENGINEERING INDIA PRIVATE LIMITED",
"AN USEDLESS PAPER PRIVATE LIMITED",
"AN VISTAR ENGINEERING PRIVATE LIMITED",
"ANA ARC PRIVATE LIMITED",
"ANA CONSORTIUM PRIVATE LIMITED",
"ANA DESIGN STUDIO PRIVATE LIMITED",
"ANA DESIGNS PRIVATE LIMITED",
"ANA DESIGNWORX PRIVATE LIMITED",
"ANA INDUSTRIAL SAFETY PRIVATE LIMITED",
"ANA INDUSTRIES PRIVATE LIMITED",
"ANA JEWELLERS PRIVATE LIMITED",
"ANA LABORATORIES",
"ANA OILS AND FATS INDIA PRIVATE LIMITED",
"ANA PRINT O GRAFIX PRIVATE LIMITED",
"ANA TENDERASIA PRIVATE LIMITED",
"ANAAD PROP TRADE PRIVATE LIMITED",
"ANAADIH LIFESTYLES PRIVATE LIMITED",
"ANAADIH VINCOM PRIVATE LIMITED",
"ANABH GEMS PRIVATE LIMITED",
"ANABHA VENTURES PRIVATE LIMITED",
"ANABIO TECHNOLOGIES PRIVATE LIMITED",
"ANABIOSIS MEDISCIENCES LIMITED",
"ANABIOSIS MEDSCIENCES PRIVATE LIMITED",
"ANABIR DESIGNS PRIVATE LIMITED",
"ANABLER OUTSOURCING SERVICES PRIVATE LIMITED",
"ANABOND HS BUTYL PRIVATE LIMITED",
"ANABOND LIMITED",
"ANABOND STEDMAN PHARMA RESEARCH PRIVATE LIMITED",
"ANACLE SYSTEMS (INDIA) PRIVATE LIMITED",
"ANACON LABORATORIES PRIVATE LIMITED",
"ANADA PRAKASHAN PRIVATE LIMITED",
"ANADATA PRODUCER COMPANY LIMITED",
"ANADI INVESTMENTS PVT LTD",
"ANADI MERCANTILE PRIVATE. LIMITED.",
"ANADI OIL MILL PRIVATE LIMITED",
"ANADIGI SOLUTIONS PRIVATE LIMITED",
"ANADIHOME HARD GOODS PRIVATE LIMITED",
"ANADIKAL PEDHI RETAIL PRIVATE LIMITED",
"ANADYA PROPERTIES PRIVATE LIMITED",
"ANADYA TECHNOLOGIES PRIVATE LIMITED",
"ANAEK SOFT PRIVATE LIMITED",
"ANAESTHETIC GASES PVT LTD",
"ANAESTHETICS INDIA PRIVATE LIMITED",
"ANAGA SPECIALITIES PRIVATE LIMITED",
"ANAGH DIGICOM PRIVATE LIMITED",
"ANAGHA AUTOMOBILES PRIVATE LIMITED",
"ANAGHA CHEM PRIVATE LIMITED",
"ANAGHA INFO SERVICES PRIVATE LIMITED",
"ANAGHA LOGISTICS PRIVATE LIMITED",
"ANAGHA POLYMERS PRIVATE LIMITED",
"ANAGHA SURFACE TRANSPORTS PRIVATE LIMITED",
"ANAGRAM MEDIA LABS PRIVATE LIMITED",
"ANAHA HOLDINGS PRIVATE LIMITED",
"ANAHAT ORGANISATION DEVELOPMENT CONSULTANCY PRIVATE LIMITED",
"ANAHITA APPLIANCES PRIVATE LIMITED",
"ANAHITHA RESOURCES PRIVATE LIMITED",
"ANAIKAR MATRIC HIGHER SECONDARY SCHOOL",
"ANAISHA FOREX PRIVATE LIMITED",
"ANAIVA THERAPEUTICS PRIVATE LIMITED",
"ANAKAGE TECHNOLOGIES PRIVATE LIMITED",
"ANAKAMPOIL POWER PRIVATE LIMITED",
"ANAKAPALLE RURAL ELECTRIC CO OP SOCIETY LTD",
"ANAKAYA MALLS PRIVATE LIMITED",
"ANAKI GLOBAL PRIVATE LIMITED",
"ANAKIN MANGEMENT CONSULTANTS PRIVATE LIMITED",
"ANALA FIRE CONSULTING PRIVATE LIMITED",
"ANALAB SCIENTIFIC INSTRUMENTS PRIVATE LIMITED",
"ANALAH CAPITAL PRIVATE LIMITED",
"ANALCO IMPEX LIMITED",
"ANALCO INDIA PRIVATE LIMITED",
"ANALEE BUILDCON PRIVATE LIMITED",
"ANALICS RESEARCH PRIVATE LIMITED",
"ANALINEAR DESIGN TECHNOLOGIES PRIVATE LIMITED",
"ANALINEAR IMAGING SYSTEMS PRIVATE LIMITED",
"ANALOG AND DIGITAL SYSTEMS PRIVATE LIMITED",
"ANALOG DEVICES INDIA PRIVATE LIMITED",
"ANALOG HEALTHCARE PRIVATE LIMITED",
"ANALOG IAS ACADEMY",
"ANALOG IAS INSTITUTE",
"ANALOG LEGALHUB TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"ANALOG PORT PRIVATE LIMITED",
"ANALOG TRADE PRIVATE LIMITED",
"ANALOGIC AUTOMATION PRIVATE LIMITED",
"ANALOGIC CONTROLS INDIA LIMITED",
"ANALOGICS TECH INDIA LIMITED",
"ANALYS LAB PRIVATE LIMITED",
"ANALYSE DIGITAL BUSINESS SOLUTIONS PRIVATE LIMITED",
"ANALYSER INSTRUMENTS CO. PRIVATE. LIMITED.",
"ANALYSYS MASON INDIA PRIVATE LIMITED",
"ANALYTIC BRAINS TECHNOLOGIES PRIVATE LIMITED",
"ANALYTIC EDGE PRIVATE LIMITED",
"ANALYTICA CONTROL SERVICES PRIVATE LIMITED",
"ANALYTICA FOODTECH SERVICES PRIVATE LIMITED",
"ANALYTICA INDIA PRIVATE LIMITED",
"ANALYTICAL AUTOMATION INDIA PRIVATE LIMITED",
"ANALYTICAL RESEARCH & METALLURGICAL LABORATORIES PRIVATE LIMITED",
"ANALYTICAL TECHNOLOGIES LIMITED",
"ANALYTICALS MEDICAL TECHNOLOGIES PRIVATE LIMITED",
"ANALYTICALWIZARDS SERVICES PRIVATE LIMITED",
"ANALYTICS INDIA MAGAZINE PRIVATE LIMITED",
"ANALYTICS QUAD4 INDIA PRIVATE LIMITED",
"ANALYTICS SAVES AT WORK INDIA PRIVATE LIMITED",
"ANALYTICSFOX SOFTWARES PRIVATE LIMITED",
"ANALYTICSQUOTIENT SERVICES INDIA PRIVATE LIMITED",
"ANALYTIK JENA INDIA PRIVATE LIMITED",
"ANALYTIQ BUSINESS VENTURES PRIVATE LIMITED",
"ANALYTIQ SPORTS TECHNOLOGY PRIVATE LIMITED",
"ANALYTIX BUSINESS SOLUTIONS (INDIA) PRIVATE LIMITED",
"ANALYTIX CORPORATE SOLUTIONS PRIVATE LIMITED",
"ANALYTIX MANTRA PRIVATE LIMITED",
"ANALYTTICA DATALAB PRIVATE LIMITED",
"ANAM ELECTRONICS PRIVATE LIMITED",
"ANAM FX EXCHANGE PRIVATE LIMITED",
"ANAM LEATHER AND CHEMICALS INDUSTRIES PRIVATE LIMITED",
"ANAM PESTICIDE PVT LTD",
"ANAM RICE MILL PRIVATE LIMITED",
"ANAMALLAIS AGENCIES MADURAI PRIVATE LIMITED",
"ANAMALLAIS AGENCIES PRIVATE LIMITED",
"ANAMALLAIS AUTOMOBILES PRIVATE LIMITED",
"ANAMALLAIS ENGINEERING PRIVATE LIMITED",
"ANAMALLAIS MOTORS PRIVATE LIMITED",
"ANAMAY BIOTECH PRIVATE LIMITED",
"ANAMI JEWELLERS PRIVATE LIMITED",
"ANAMIKA AUTOMOBILES PRIVATE LIMITED",
"ANAMIKA DEVELOPERS",
"ANAMIKA ENTERPRISES PRIVATE LIMITED",
"ANAMIKA FASHIONWEARS AND EXPORTS PRIVATE LIMITED",
"ANAMIKA MARBLES AND GRANITES PRIVATE LIMITED",
"ANAMIKA SECURITIES PRIVATE LIMITED",
"ANAMIKA SHREYA PRINT PACKAGING PRIVATE LIMITED",
"ANAMIKA SUGAR MILLS PRIVATE LIMITED",
"ANAMIKA TRADE LINKS PRIVATE LIMITED",
"ANAMIKA TUBE PRIVATE LIMITED",
"ANAMKLEAN ENVIROTECH PRIVATE LIMITED",
"ANAMLIFE INFRAHEIGHTS PRIVATE LIMITED",
"ANAMMYAA WELLNESS PRIVATE LIMITED",
"ANAMOL LABORATORIES PRIVATE LIMITED",
"ANAND AGENCIES AND MANUFACTURING COMPANY PRIVATE LIMITED",
"ANAND AGRICULTURAL UNIVERSITY",
"ANAND AGRO CARE NASHIK",
"ANAND AGRO FOOD PRIVATE LIMITED",
"ANAND ALPINE IMPEXO PRIVATE LIMITED",
"ANAND ANIMAL HEALTH PRIVATE LIMITED",
"ANAND ARC LIMITED",
"ANAND AUTO TRANZ PRIVATE LIMITED",
"ANAND AUTOCARE PRIVATE LIMITED",
"ANAND AUTOMOTIVE PRIVATE LIMITED",
"ANAND AZCO INFRACON INDIA PRIVATE LIMITED",
"ANAND BHAVAN PROPERTIES PRIVATE LIMITED",
"ANAND BHAWAN SCHOOL",
"ANAND BOOKS INTERNNATIONAL PRIVATE LIMITED",
"ANAND BUILDTECH PRIVATE LIMITED",
"ANAND BUSINESS ENTERPRISES PRIVATE LIMITED",
"ANAND BUTTONS LIMITED",
"ANAND CANVAS MILLS PRIVATE LIMITED",
"ANAND CARBO PRIVATE LIMITED",
"ANAND CARS PRIVATE LIMITED",
"ANAND CHAMBERS PVT LTD",
"ANAND CHEM INDUSTRIES PVT LTD",
"ANAND CHEMICALS & RUBBER PVT LTD",
"ANAND COLLEGE OF EDUCATION",
"ANAND COLLEGE OF ENGINEERING AND MANAGEMENT",
"ANAND COLOURS PVT LTD",
"ANAND COMFORTS PRIVATE LIMITED",
"ANAND COMMODITIES SERVICES PRIVATE LIMITED",
"ANAND COMPUTERS",
"ANAND CONCAST LIMITED",
"ANAND CONSTRUCTION",
"ANAND CONSTRUCTION INFRASTRUCTURE PRIVATE LIMITED",
"ANAND CONSTRUWELL PRIVATE. LIMITED",
"ANAND CONTROL SYSTEM P LIMITED",
"ANAND COOLING EQUIPMENT PRIVATE LIMITED",
"ANAND COTEX LIMITED",
"ANAND COTTGINN PRIVATE LIMITED",
"ANAND CREATIVES AND DEVELOPERS PRIVATE LIMITED",
"ANAND CURRENCY CONVERTIBLES PRIVATE LIMITED",
"ANAND CY MYUTEC AUTOMOTIVE PRIVATE LIMITED",
"ANAND D. LODARIYA SALT AND STORAGE PRIVATE LIMITED",
"ANAND DEALERS PRIVATE LIMITED",
"ANAND DEVELOPERS",
"ANAND DIAGNOSTIC LABORATORY",
"ANAND DIARIES PRIVATE LIMITED",
"ANAND DISTRIBUTER",
"ANAND DISTRICT EDUCATION COMMITTEE MANAGED PRIMARY SCHOOL TEACHER",
"ANAND DIVINE DEVELOPERS PRIVATE LIMITED",
"ANAND DOMESTIC APPLIANCES PVT. LTD.",
"ANAND DUPLEX LIMITED",
"ANAND ELECTRONICS & INDUSTRIES PRIVATE LIMITED",
"ANAND EMBALLAGE PRIVATE LIMITED",
"ANAND ENGINEERING PRODUCTS PRIVATE LIMITED",
"ANAND ENGINEERS PRIVATE LIMITED",
"ANAND ENVIRONMENTAL CONSULTANTS PRIVATE LIMITED",
"ANAND EXPORTS AND ORES PRIVATE LIMITED",
"ANAND EYE INSTITUTE PRIVATE LIMITED",
"ANAND FABRICATORS PRIVATE LIMITED",
"ANAND FABS SYSTEM PRIVATE LIMITED",
"ANAND FLOUR MILLS LTD",
"ANAND FOOD AND MILK SPECIALITIES PRIVATE LIMITED",
"ANAND FREIGHT OVERSEAS PVT LTD",
"ANAND GARMENTS PRIVATE LIMITED",
"ANAND GRANITE EXPORTS PVT LTD",
"ANAND GUINEA MAKER PVT LTD",
"ANAND GURUKUL ENGLISH MEDIUM SCHOOL",
"ANAND HABITAT INFRASTRUCTURE PRIVATE LIMITED",
"ANAND HANDLOOM HOUSE PRIVATE LIMITED",
"ANAND HATCHERIES PRIVATE LIMITED",
"ANAND HIGHTECH INDUSTRIES PRIVATE LIMITED",
"ANAND HOSPITAL AND CHIDDA SINGH YADAV TRAUMA CENTRE",
"ANAND HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED",
"ANAND HOTEL INTERNATIONAL PRIVATE LIMITED",
"ANAND HOUSING FINANCE PRIVATE LIMITED",
"ANAND HR MANAGEMENT PRIVATE LIMITED",
"ANAND INDUSTRIAL GASES PRIVATE LIMITED",
"ANAND INDUSTRIES",
"ANAND INFRACON PRIVATE LIMITED",
"ANAND INSTITUTE OF HIGHER TECHNOLOGY",
"ANAND INSULATIONS PRIVATE LIMITED",
"ANAND INTERIOR",
"ANAND I-POWER LIMITED",
"ANAND ISHER SR SEC PUBLIC SCHOOL",
"ANAND ISPAT UDYOG LIMITED.",
"ANAND JAGANNATH PEDNEKAR JEWELLERS PVT LTD",
"ANAND JEWELLERS PRIVATE LIMITED",
"ANAND JEWELS INDORE PRIVATE LIMITED",
"ANAND KAMAL CO-OPERATIVE HOUSING SOCIETY LIMITED",
"ANAND LIFESPACE DEVELOPMENT LLP",
"ANAND LIMITED",
"ANAND LINERS (INDIA) PRIVATE LIMITED",
"ANAND MEDICAIDS PRIVATE LIMITED",
"ANAND MEDIPRODUCTS PRIVATE LIMITED",
"ANAND METAL ENGINEERING PRIVATE LIMITED",
"ANAND METAL ISPAT PRIVATE LIMITED",
"ANAND METALLICS AND POWER PRIVATE LIMITED",
"ANAND METRO-MART PRIVATE LIMITED",
"ANAND MINI MART PRIVATE LIMITED",
"ANAND MOHATA AGRO INDUSTRIES PRIVATE LIMITED",
"ANAND MONEY CHANGERS PRIVATE LIMITED",
"ANAND MOTOR AGENCIES LIMITED",
"ANAND MOTOR PRODUCTS PRIVATE LIMITED",
"ANAND MOULD STEELS PRIVATE LIMITED",
"ANAND MULTISPECIALITY HOSPITALS PRIVATE LIMITED",
"ANAND NIKETAN",
"ANAND NIKETAN COLLEGE ANANDWAN WARORA",
"ANAND NIKETAN SATELLITE CAMPUS",
"ANAND NIROG DHAM HOSPITAL PRIVATE LIMITED",
"ANAND NVH PRODUCTS PRIVATE LIMITED",
"ANAND ORTHOPEDIC PRIVATE LIMITED",
"ANAND PAG SYSTEMS INDIA PRIVATE LIMITED",
"ANAND PALACE PRIVATE LIMITED",
"ANAND PETROCHEM PRIVATE LIMITED",
"ANAND POLYPACK PRIVATE LIMITED",
"ANAND POLYURETHANES PRIVATE LIMITED",
"ANAND POTATO COLD STORAGE PRIVATE LIMITED",
"ANAND PRIMARY SCHOOL AMRAVATI",
"ANAND PROPERTY FINANCE LTD",
"ANAND PU COLLEGE",
"ANAND RAJ AND CO PVT LTD",
"ANAND RATHI ADVISORS LIMITED",
"ANAND RATHI COMMODITIES LIMITED",
"ANAND RATHI FINANCIAL SERVICES LIMITED",
"ANAND RATHI GLOBAL FINANCE LIMITED",
"ANAND RATHI INSURANCE BROKERS LIMITED",
"ANAND RATHI IT PRIVATE LIMITED",
"ANAND RATHI SHARE AND STOCK BROKERS LIMITED",
"ANAND RATHI WEALTH LIMITED",
"ANAND RAYONS LIMITED",
"ANAND REALDEV PRIVATE LIMITED",
"ANAND REFRIGERATION COMPANY PRIVATE LIMITED",
"ANAND RETAILS (INDIA) PRIVATE LIMITED",
"ANAND RICE MILLS",
"ANAND ROTOGRAVURES PRIVATE LIMITED",
"ANAND SAGAR REAL ESTATES PRIVATE LIMITED",
"ANAND SEALING SOLUTIONS PRIVATE LIMITED",
"ANAND SEAMLESS LIMITED",
"ANAND SEAMLESS TUBES PRIVATE LIMITED",
"ANAND SHREE INFRAREALITY PRIVATE LIMITED",
"ANAND SHREE STEELS PRIVATE LIMITED",
"ANAND SINGAPORE INTERNATION SCHOOL",
"ANAND SONS GOYAL SONS ZAVERI",
"ANAND SPINNING MILL",
"ANAND SURFACE COATINGS PRIVATE LIMITED",
"ANAND SURGICAL HOSPITAL PRIVATE LIMITED",
"ANAND SYSTEMS ENGINEERING PRIVATE LIMITED",
"ANAND SYSTEMS INDIA",
"ANAND TALC AND STEATITE PVT LTD",
"ANAND TOP SECURITY PRIVATE LIMITED",
"ANAND TRACK AND FIELD EQUIPMENT PRIVATE LIMITED",
"ANAND TRADELINK PVT LTD",
"ANAND TRANS LOGISTICS PRIVATE LIMITED",
"ANAND TRANSFORMERS PRIVATE. LIMITED",
"ANAND TRANSMISSION PRODUCTS PRIVATE LIMITED",
"ANAND TRANSPORT PRIVATE. LIMITED.",
"ANAND TRILOK CONSTRUCTION CO PRIVATE LIMITED",
"ANAND TRIPLEX BOARD PRIVATE LIMITED",
"ANAND TRUCKING PRIVATE LIMITED",
"ANAND TUBES PRIVATE LIMITED",
"ANAND TWINES MANUFACTURING PRIVATE LIMITED",
"ANAND UTILITIES PRIVATE LIMITED",
"ANAND UTSAV HOMES PRIVATE LIMITED",
"ANAND VIDHYALAY GOVT SCHOOL",
"ANAND VIHAR REALITY PVT LTD",
"ANAND VISHWA GURUKUL COLLEGE OF LAW",
"ANAND WATER METER MANUFACTURING COMPANY PRIVATE LIMITED",
"ANAND WHEELS SERVICES PRIVATE LIMITED",
"ANAND ZIPPERS PRIVATE LIMITED",
"ANANDA AQUA EXPORTS PRIVATE LIMITED",
"ANANDA BHARATHI FERTILIZERS (INDIA) PRIVATE LIMITED",
"ANANDA BHARATI PUBLISHERS A DIVISION OF HEADWORD PUBLISHING COMPANY PRIVATE LIMITED",
"ANANDA DAIRY LIMITED",
"ANANDA ENTERPRISES INDIA PRIVATE LIMITED",
"ANANDA FOODS LIMITED",
"ANANDA HOMES PRIVATE LIMITED",
"ANANDA KRISHNA INFRADEVELOPMENT PRIVATE LIMITED",
"ANANDA MOHAN COLLEGE",
"ANANDA NILAYAM HOTELS PRIVATE LIMITED",
"ANANDA OFFSET PRIVATE LIMITED",
"ANANDA PROFILES PRIVATE LIMITED",
"ANANDA PROTEIN LIMITED",
"ANANDA PUBLISHERS PVT LTD",
"ANANDA SAW MILLS",
"ANANDA VIKATAN DIGITAL PRIVATE LIMITED",
"ANANDA VIKATAN PRODUCTIONS PRIVATE LIMITED",
"ANANDA VIKATAN PUBLISHERS PRIVATE LIMITED",
"ANANDABARI TEA CO PVT LTD",
"ANANDALOK HOSPITAL",
"ANANDALOKE MEDICAL CENTRE PRIVATE LIMITED",
"ANANDALOKE SONOSCAN CENTRE PRIVATE LIMITED",
"ANANDAM AUTOLINKS PRIVATE LIMITED",
"ANANDAM HEIGHTS DEVELOPERS PRIVATE LIMITED",
"ANANDAM HOSTELS PRIVATE LIMITED",
"ANANDAM JEWELLERS",
"ANANDAMAYEE AGROTECH PRIVATE LIMITED",
"ANANDAMAYEE FOOD PRODUCTS PRIVATE LIMITED",
"ANANDAMELA ELECTRONICS PRIVATE LIMITED",
"ANANDAMOYEE AGRO & ALLIED PRODUCTS PRIVATE LIMITED",
"ANANDAMOYEE APPARELS PRIVATE LIMITED",
"ANANDANILAYAM CHAITANYAKIRAN HOUSING PRIVATE LIMITED",
"ANANDANILAYAM DEVELOPERS PRIVATE LIMITED",
"ANANDDAS DIAGNOSTIC LABORATORY PRIVATE LIMITED",
"ANANDESHWAR AGRO FOODS PRIVATE LIMITED",
"ANANDESHWAR INDUSTRIES PRIVATE LIMITED",
"ANANDESHWAR LEASING AND FINANCE LIMITED",
"ANANDESHWAR POLY PACK PRIVATE LIMITED",
"ANANDESHWAR PRODUCER COMPANY LIMITED",
"ANANDESHWAR TEXTILES PRIVATE LIMITED",
"ANAND-GREENS EDUCATION FOUNDATION",
"ANANDHA FABRICATIONS CBE PRIVATE LIMITED",
"ANANDHA PHARMACY PRIVATE LIMITED",
"ANANDHI DIAGNOSTICS PRIVATE LIMITED",
"ANANDHI TEXSTYLES PRIVATE LIMITED",
"ANANDI ATTA CHAKKI PRIVATE LIMITED",
"ANANDI CONSULTANTS PRIVATE LIMITED",
"ANANDI ELECTRICALS AND ELECTRONICS PRIVATE LIMITED",
"ANANDI GOLD PRIVATE LIMITED",
"ANANDI INDUSTRIES PRIVATE LIMITED",
"ANANDI INFRA PRIVATE LIMITED",
"ANANDI METAL INDUSTRIES PRIVATE LIMITED",
"ANANDI SILK MILLS PRIVATE LIMITED",
"ANANDI SPECIALITIES AND SERVICES PRIVATE LIMITED",
"ANANDI WATER PARKS RESORTS & CLUB PRIVATE LIMITED",
"ANANDIA ENGI-TECH PRIVATE LIMITED",
"ANANDILAL & GANESH PODAR SOCIETY",
"ANANDINA MUVADA PRIMARY SCHOOL",
"ANANDIT INFOTECH INDIA PRIVATE LIMITED",
"ANANDJEEVAN FIN CONSULTANTS PRIVATE LIMITED",
"ANANDJI HARIDAS AND COMPANY PRIVATE LIMITED",
"ANANDJIWALA INFRA ADVISORY PRIVATE LIMITED",
"ANANDKAND PARAMOUNT PRODUCTS PRIVATE LIMITED",
"ANANDMAYEE FORGINGS (P)LTD",
"ANANDMAYEE HOMECARE & HYGIENE PRIVATE LIMITED",
"ANANDMAYI TRANSPORT COMPANY PRIVATE LIMITED",
"ANANDPUSHP TECHNOLOGIES PRIVATE LIMITED",
"ANANDRAO DHONDE ALIAS BABAJI MAHAVIDYALAYA",
"ANANDRAO PAWAR SARASWATI VIDYAMANDIR",
"ANANDRUSHIJI HOSPITAL AHEMEDNGAR",
"ANANDS GOLD PRIVATE LIMITED",
"ANANDSONS OVERSEAS TRADING PRIVATE LIMITED",
"ANANGAKSHIS CREATION PRIVATE LIMITED",
"ANANGAKSHIS FERRO ALLOYS PRIVATE LIMITED",
"ANANGESHWAR PARWATI RAMANUGRAH PROJECTS PRIVATE LIMITED",
"ANANJAY CONSTRUCTION AND CONTRACTS PRIVATE LIMITED",
"ANANJAY PHARMACEUTICALS PRIVATE LIMITED",
"ANANKE TRUSTEE COMPANY PRIVATE LIMITED",
"ANANT AGRO EXIMS PRIVATE LIMITED",
"ANANT AGRO INDUSTRIES PRIVATE LIMITED",
"ANANT ASHISH ROLLING PRIVATE LIMITED",
"ANANT ASSOCIATES PRIVATE LIMITED",
"ANANT BUSINESS PVT LTD.",
"ANANT COMMODITIES PRIVATE LIMITED",
"ANANT COTTON COMPANY PRIVATE LIMITED",
"ANANT CUTTING EDGE PRIVATE LIMITED",
"ANANT DEFENCE SYSTEMS PRIVATE LIMITED",
"ANANT DESIGNERS PRIVATE LIMITED",
"ANANT ELECTRICALS AND ENGINEERS",
"ANANT ENTREPRENEURS PRIVATE LIMITED",
"ANANT FRAGRANCE PVT LTD",
"ANANT HALWAI PRIVATE LIMITED",
"ANANT IMAGING PRIVATE LIMITED",
"ANANT INFOMEDIA PRIVATE LIMITED",
"ANANT INFRA GLASSES INDIA PRIVATE LIMITED",
"ANANT INFRATECH PRIVATE LIMITED",
"ANANT INTERNATIONAL PRIVATE LIMITED",
"ANANT INVESTMENTS PRIVATE LIMITED",
"ANANT LEWIS PUBLIC SCHOOL JODHPUR",
"ANANT MEDIA PRIVATE LIMITED",
"ANANT NATIONAL UNIVERSITY",
"ANANT NURSING HOME PRIVATE LIMITED",
"ANANT PADDY PRODUCTS PRIVATE LIMITED",
"ANANT PHARMACEUTICALS PRIVATE LIMITED",
"ANANT PROJECTS INDIA PRIVATE LIMITED",
"ANANT PULSES PRIVATE LIMITED",
"ANANT RAJ ESTATE MANAGEMENT SERVICES LIMITED",
"ANANT RAJ GLOBAL LIMITED",
"ANANT RAJ LIMITED",
"ANANT REFRACTORY PRODUCTS PRIVATE LIMITED",
"ANANT RICE INDUSTRIES",
"ANANT SIZERS PRIVATE LIMITED",
"ANANT SKY INFRATECH PRIVATE LIMITED",
"ANANT SOFTTECH PRIVATE LIMITED",
"ANANT SPINNING MILLS",
"ANANT STAINLESS PRIVATE LIMITED",
"ANANT STEELS PRIVATE LIMITED ASPL",
"ANANT STONES PRIVATE LIMITED",
"ANANT TOOLS UNIT NO 11 PVT LTD",
"ANANT TRAFINA PRIVATE LIMITED",
"ANANT UTSAV SCHOOL",
"ANANT WRAPS PRIVATE LIMITED",
"ANANTA BHAGYA PUNASA FARMER PRODUCER COMPANY LIMITED",
"ANANTA BUSINESSCORP LIMITED",
"ANANTA EDIBLE PRIVATE LIMITED",
"ANANTA GLOBAL HOSPITALITY MANAGEMENT SER VICES LLP",
"ANANTA INSTITUTE OF MEDICAL SCIENCES AND RESEARCH CENTRE",
"ANANTA INTERNATIONAL MARKETING PRIVATE LIMITED",
"ANANTA JEWELS PRIVATE LIMITED",
"ANANTA KALYAN INDUSTRIES PRIVATE LIMITED",
"ANANTA LANDMARKS PRIVATE LIMITED",
"ANANTA LANDWISE PRIVATE LIMITED",
"ANANTA MEDICARE LIMITED",
"ANANTA MERX LLP",
"ANANTA OORJAA E PRIVATE LIMITED",
"ANANTA PHARMACY DISTRIBUTORS PRIVATE LIMITED",
"ANANTA POLYRUBB PRIVATE LIMITED",
"ANANTA PROCON PRIVATE LIMITED",
"ANANTA SHREE ENTERPRISES PRIVATE LIMITED",
"ANANTA SPA & RESORT",
"ANANTA VEGETABLE SEEDS PRIVATE LIMITED",
"ANANTAA ENGINEERING AND INFRASTRUCTURES PRIVATE LIMITED",
"ANANTAA GSK INNOVATIONS PRIVATE LIMITED",
"ANANTAJIT STEELS PRIVATE LIMITED",
"ANANTAM JEWELS PRIVATE LIMITED",
"ANANTANARAYAN MINERALS PRIVATE LIMITED",
"ANANTAPUR SOLAR PARKS PRIVATE LIMITED",
"ANANTARA ENTERPRISES PRIVATE LIMITED",
"ANANTARA SOLUTIONS PRIVATE LIMITED",
"ANANTASHAYANA ORGANICS PRIVATE LIMITED",
"ANANTAYA RETAILS PRIVATE LIMITED",
"ANANTCARS AUTO PRIVATE LIMITED",
"ANANTCO ENTERPRISES PRIVATE LIMITED",
"ANANTECH VENTURES PRIVATE LIMITED",
"ANANTH OIL EXTRACTIONS PRIVATE LTD",
"ANANTH SOLAR POWER MAHARASHTRA PRIVATE LIMITED",
"ANANTH TECHNOLOGIES LIMITED",
"ANANTH TECHNOLOGIES PRIVATE LIMITED",
"ANANTHA AGENCY'S PRIVATE LIMITED",
"ANANTHA BIOTECHNOLOGIES AND ALLIED INDUSTRIES PRIVATE LIMITED",
"ANANTHA LAKSHMI INSTITUTE OF TECHNOLOGY AND SCIENCES",
"ANANTHA NATURALS PRIVATE LIMITED",
"ANANTHA PROJECTS & TECHNICAL SERVICES PRIVATE LIMITED",
"ANANTHA PVC PIPES PRIVATE LIMITED (PART IX)",
"ANANTHA REFINERY PRIVATE LIMITED",
"ANANTHA SAI INDUSTRIES PRIVATE LIMITED",
"ANANTHAGIRI INDUSTRIES PRIVATE LIMITED",
"ANANTHAM PRECIOUS JEWELS PRIVATE LIMITED",
"ANANTHAM RETAIL PRIVATE LIMITED",
"ANANTHAPURAM FOREX & SERVICES PRIVATE LIMITED",
"ANANTHAPURI HOSPITAL PVT LTD",
"ANANTHAPURI RUBBERS PRIVATE LIMITED",
"ANANTHAPURI TRADERS PRIVATE LIMITED",
"ANANTHARI INDUSTRIES PRIVATE LIMITED",
"ANANTHAVALLII MOTORS PRIVATE LIMITED",
"ANANTHESWARA MOTORS PRIVATE LIMITED",
"ANANTI BUILDERS & CONSTRUCTION PRIVATE LIMITED",
"ANANTJEEVAK HERBOTECH PRIVATE LIMITED",
"ANANTNATH SALES PRIVATE LIMITED",
"ANANTNATH SILK MILLS PRIVATE LIMITED",
"ANANTNATH SKYCON PRIVATE LIMITED",
"ANANTPURA WIND ENERGIES PRIVATE LIMITED",
"ANANTRAO THOPTE COLLEGE",
"ANANTROOP FINANCIAL ADVISORY SERVICES PRIVATE LIMITED",
"ANANTSATYA TECHNOCRAFT PRIVATE LIMITED",
"ANANTSHREE HOSPITAL",
"ANANTSHREE POLYFAB PRIVATE LIMITED",
"ANANTSHREE POLYMERS PRIVATE LIMITED",
"ANANTVIR AUTO ENGINEERS PRIVATE LIMITED",
"ANANTYA BPO PRIVATE LIMITED",
"ANANTYA RESORTS AND HOTELS PRIVATE LIMITED",
"ANANYA AGRO PRODUCTS SERVICES PRIVATE LIMITED",
"ANANYA AND ADITHYA PROPERTIES AND DEVELOPERS PRIVATE LIMITED",
"ANANYA ASHUTOSH INFRASTRUCTURE PRIVATE LIMITED",
"ANANYA AUTO AGENCY PRIVATE LIMITED",
"ANANYA CABLE TECH PRIVATE LIMITED",
"ANANYA CREATIONS LIMITED",
"ANANYA ENGINEERING PRIVATE LIMITED",
"ANANYA FIBROCHEM PRIVATE LIMITED",
"ANANYA FINANCE FOR INCLUSIVE GROWTH PRIVATE LIMITED",
"ANANYA FLOUR MILLS PRIVATE LIMITED",
"ANANYA HERBAL PRIVATE LIMITED",
"ANANYA HOSPITAL PRIVATE LIMITED",
"ANANYA HOTELS PRIVATE LIMITED",
"ANANYA MANPOWER SOLUTIONS PRIVATE LIMITED",
"ANANYA PACKAGE PRIVATE LIMITED",
"ANANYA PAPER INDUSTRIES PRIVATE LIMITED",
"ANANYA RICE MILL PRIVATELIMITED",
"ANANYA SECURITIES AND FINANCE PRIVATE LIMITED",
"ANANYA SEEDS PRIVATE LIMITED",
"ANANYA SHELTERS PRIVATE LIMITED",
"ANANYA SILK PRIVATE LIMITED",
"ANANYA TECHNOLOGIES PRIVATE LIMITED",
"ANANYA VIDYALAYA",
"ANANYA WOOD PRIVATE. LIMITED.",
"ANANYAA RETAILS PRIVATE LIMITED",
"ANANYAKOUSTAV HOSPITAL PRIVATE LIMITED",
"ANANYAKRISHNAA CONSTRUCTIONS PRIVATE LIMITED",
"ANAPARTHY POULTRIES PRIVATE LIMITED",
"ANAPARTI WAREHOUSING COMPLEX PRIVATE LIMITED",
"ANAPPADIKKAL TRADING COMPANY PRIVATE LIMITED",
"ANAPPURAM STEELS PRIVATE LIMITED",
"ANAPURNA SHIPPING PRIVATE LIMITED",
"ANAQUA INDIA LLP",
"ANAR ENTERPRISES PRIVATE LIMITED",
"ANAR FOREX PRIVATE LIMITED",
"ANAR INSURANCE BROKERS LIMITED",
"ANAR MCAT ADVANCED ELECTRONIC CHEMICALS PRIVATE LIMITED",
"ANAR SOLUTIONS PRIVATE LIMITED",
"ANARDANA HOSPITALITY PRIVATE LIMITED",
"ANAROCK CAPITAL ADVISORS PRIVATE LIMITED",
"ANAROCK PROPERTY CONSULTANTS PRIVATE LIMITED",
"ANAROCK RETAIL ADVISORS PRIVATE LIMITED",
"ANAS GREEN ENVIRONMENT PRIVATE LIMITED",
"ANAS MOTORS PRIVATE LIMITED",
"ANASWARA OFFSET PRIVATE LIMITED",
"ANATECH ULTRA COATER AND CONTROLS PRIVATE LIMITED",
"ANATEK SERVICES PRIVATE LIMITED",
"ANATI TECHNOLOGIES PRIVATE LIMITED",
"ANATIKA SOFTWARE SOLUTIONS PRIVATE LIMITED",
"ANAVCLOUDS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"ANAVEEY ENGINEERING PRIVATE LIMITED",
"ANAVEN LLP",
"ANAWIL WIRE AND ENGINEERING PRIVATE LIMITED",
"ANAX LIFESCIENCE PRIVATE LIMITED",
"ANAXEE DIGITAL RUNNERS PRIVATE LIMITED",
"ANAY SALES PRIVATE LIMITED",
"ANAY TECHNOSOFT PRIVATE LIMITED",
"ANAYA INFRACON PRIVATE LIMITED",
"ANAYA INFRASTRUCTURE PRIVATE LIMITED",
"ANAYA RETAILERS PRIVATE LIMITED",
"ANAYA TECH SYSTEMS PRIVATE LIMITED",
"ANAYSHA HEALTH SOLUTIONS PRIVATE LIMITED",
"ANAZEAL ANALYTICALS & RESEARCH PRIVATE LIMITED",
"ANB COMPUTER SOLUTIONS PRIVATE LIMITED",
"ANB FUELS PRIVATE LIMITED",
"ANB INTERIORS AND EXTERIORS PRIVATE LIMITED",
"ANB METAL CAST PRIVATE LIMITED",
"ANB SOLUTIONS PRIVATE LIMITED",
"ANB SYSTEMS PRIVATE LIMITED",
"ANBIYA TECHNOLOGIES PRIVATE LIMITED",
"ANBLICK SOLUTIONS PRIVATE LIMITED",
"ANBLICKS CLOUD DATA ENGG PRIVATE LIMITED",
"ANBRE CONSTRUCTION AND INTERIORS PRIVATE LIMITED",
"ANBRONICA TECHNOLOGIES PRIVATE LIMITED",
"ANBS EXIM PRIVATE LIMITED",
"ANBU ENGINEERING INDIA PRIVATE LIMITED",
"ANBU HOSPITAL MULTI SPECIALITY",
"ANBU HOSPITAL PRIVATE LIMITED",
"ANBU INFRATECH PRIVATE LIMITED",
"ANC ALUMINIUM GLASS PRIVATE LIMITED",
"ANC INDUSTRIES PRIVATE LIMITED",
"ANC SECURITIES LIMITED",
"ANCA MACHINE TOOLS PRIVATE LIMITED",
"ANCALIMA LIFESCIENCES LIMITED",
"ANCENERGY TECHNOLOGY SERVICES PRIVATE LIMITED",
"ANCHAL POLYPACK PRIVATE LIMITED",
"ANCHAL VINCOM PRIVATE LIMITED",
"ANCHAN'S SHIPPING & LOGISTICS PRIVATE LIMITED",
"ANCHANTO SERVICES PRIVATE LIMITED",
"ANCHAU INDUSTRIES PRIVATE LIMITED",
"ANCHEMCO ANAND LLP",
"ANCHI APPARELS PRIVATE LIMITED",
"ANCHOR AUXI-CHEM MANUFACTURING PRIVATE LIMITED",
"ANCHOR CERAMIC CO PRIVATE LIMITED",
"ANCHOR CONSUMER PRODUCTS PRIVATE LIMITED",
"ANCHOR CONTAINER SERVICES PRIVATE LIMITED",
"ANCHOR CORK PRIVATE LIMITED",
"ANCHOR DETAILING SERVICES PRIVATE LIMITED",
"ANCHOR ELECTRICALS PRIVATE LIMITED",
"ANCHOR ENTERPRISES PRIVATE LIMITED",
"ANCHOR FREIGHT SERVICES PRIVATE LIMITED",
"ANCHOR INDIA LIMITED",
"ANCHOR INFRASTRUCTURES PRIVATE LIMITED",
"ANCHOR INVESTMENTS PVT LTD",
"ANCHOR ISPAT PRIVATE LIMITED",
"ANCHOR LEASING PRIVATE LIMTED",
"ANCHOR LOGISTICS INDIA PRIVATE LIMITED",
"ANCHOR MARK PRIVATE LIMITED",
"ANCHOR METAL PRIVATE LIMITED",
"ANCHOR OFFSHORE SERVICES LIMITED",
"ANCHOR OFFSHORG SERVICE",
"ANCHOR PHARMA PRIVATE LIMITED",
"ANCHOR POWER AND INFRASTRUCTURE PRIVATE LIMITED",
"ANCHOR REFRACTORIES PRIVATE LIMITED",
"ANCHOR ROAD LINES PRIVATE LIMITED",
"ANCHOR SANITARY WARE PRIVATE LIMITED",
"ANCHOR TREADS PVT LTD",
"ANCHORCERT ANALYTICAL INDIA PRIVATE LIMITED",
"ANCHORMEN EQUIPMENTS PRIVATE LIMITED",
"ANCHORWALA EDUCATION ACADEMY",
"ANCHROM ENTERPRISES (INDIA) PVT LTD",
"ANCIENT GREENFIELDS PRIVATE LIMITED",
"ANCO INDIA CHEMICALS PRIVATE LIMITED",
"ANCON ART PRIVATE LIMITED",
"ANCON CHEMPLAST PRIVATE LIMITED",
"ANCORA STUD FARMS PRIVATE LIMITED",
"ANCORA TECHNOLOGIES PRIVATE LIMITED",
"ANCOROTTI COSMETICS INDIA PRIVATE LIMITED",
"ANCUS INDIA REPROCESSING PRIVATE LIMITED",
"AND HEALTHCARE LIMITED",
"AND HITECH INDUSTRIES LIMITED",
"AND MORE PROPERTIES PRIVATE LIMITED",
"ANDA TELECOM PRIVATE LIMITED",
"ANDABAR COLD STORES PRIVATE LIMITED",
"ANDALAN SHAKTI PRIVATE LIMITED",
"ANDAMAN AND NICOBAR ISLANDS INTEGRATED DEVELOPMENT CORPORATION LIMITED.",
"ANDAMAN ESCAPADES PRIVATE LIMITED",
"ANDAMAN ISLAND TRAVELS PRIVATE LIMITED",
"ANDAMAN PUBLIC WORKS DEPARTMENT APWD",
"ANDAMAN TIMBER COMPANY",
"ANDAND BRAND PARTNERS PRIVATE LIMITED",
"ANDANTE FOODS LLP",
"ANDAVAR MARKETING PRIVATE LIMITED",
"ANDAVAR TEXCHEM (KARUR) PRIVATE LIMITED",
"ANDAZ BUILDERS PRIVATE LIMITED",
"ANDAZ COLORS PRIVATE LIMITED",
"ANDD TECHSERVICES PRIVATE LIMITED",
"ANDEES IMPEX PRIVATE LIMITED",
"ANDELI INDIA PRIVATE LIMITED",
"ANDERSON BUSINESS SOLUTIONS PRIVATE LIMITED",
"ANDERSON DIAGNOSTIC SERVICES PRIVATE LIMITED",
"ANDERSON GREENWOOD CROSBY SANMAR LIMITED",
"ANDERSON PRINTING HOUSE PRIVATE LIMITED",
"ANDERSON TRAVELS PRIVATE LIMITED",
"ANDESOFT CONSULTING PRIVATE LIMITED",
"ANDEX FIRE ENGINEERING WORKS PRIVATE LIMITED",
"ANDHERI PROPERTIES AND DEVELOPERS PRIVATE LIMITED",
"ANDHRA AGRO-VET ASSOCIATES PRIVATE LIMITED",
"ANDHRA AGROVET THERAPEUTICS PRIVATE LIMITED",
"ANDHRA ASBESTOS TRANSPORT COMPANY",
"ANDHRA BANGLORE ROADWAYS PVT LTD",
"ANDHRA BANK",
"ANDHRA BANK EMPLOYEES' CO-OPERATIVE BANK LIMITED",
"ANDHRA CHAMBER OF COMMERCE",
"ANDHRA CHRISTIAN COLLEGE",
"ANDHRA CRICKET ASSOCIATION",
"ANDHRA EDUCATION SOCIETY",
"ANDHRA ELECTRIC AND ENGINEERING COMPANY PRIVATE LIMITED",
"ANDHRA ELECTRONICS LIMITED",
"ANDHRA ENGINEERING CO PVT LTD",
"ANDHRA EXPANDED POLYSTYRENE PRIVATE LIMITED",
"ANDHRA HEALTH DIAGNOSTIC SERVICES LIMITED",
"ANDHRA HOSPITALS ELURU PRIVATE LIMITED",
"ANDHRA HOSPITALS VIJAYAWADA PRIVATE LIMITED",
"ANDHRA LOYOLA INSTITUTE OF ENGINEERING AND TECHNOLOGY",
"ANDHRA MAHILA SABHA P.OBUL REDDY PUBLIC SCHOOL",
"ANDHRA MAHILA SABHI WOMENS COLLEGE",
"ANDHRA MARINE SERVICES AND EXPORTS LIMITED",
"ANDHRA MEDI PHARMA INDIA PRIVATE LIMITED",
"ANDHRA NETWORKS LIMITED",
"ANDHRA ORGANICS LIMITED",
"ANDHRA OXYGEN PRIVATE LIMITED",
"ANDHRA PACKAGES PRIVATE LIMITED",
"ANDHRA PAPER LIMITED",
"ANDHRA PETROCHEMICALS",
"ANDHRA POLYMERS PRIVATE LIMITED",
"ANDHRA PRABHA PUBLICATIONS LIMITED",
"ANDHRA PRADESH AGRICULUTURAL UNIVERSITY",
"ANDHRA PRADESH CAPITAL REGION DEVELOPMENT AUTHORITY",
"ANDHRA PRADESH CENTRAL POWER DISTRIBUTION COMPANY LIMITED",
"ANDHRA PRADESH CORPORATION FOR OUTSOURCED SERVICES",
"ANDHRA PRADESH EXPRESSWAY LIMITED",
"ANDHRA PRADESH FOOD PROCESSING SOCIETY",
"ANDHRA PRADESH FOREST DEVELOPMENT CORPN LTD",
"ANDHRA PRADESH GAS DISTRIBUTION CORPORATION LIMITED",
"ANDHRA PRADESH GAS POWER CORPORATION LIMITED",
"ANDHRA PRADESH GRAMEENA VIKAS BANK",
"ANDHRA PRADESH GRANITE MIDWEST PRIVATE LIMITED",
"ANDHRA PRADESH HEAVY MACHINERY AND ENGINEERING LTD",
"ANDHRA PRADESH HOMES PRIVATE LIMITED",
"ANDHRA PRADESH MARITIME BOARD",
"ANDHRA PRADESH MARITIME INFRASTRUCTURE DEVELOPMENT CORPORATION LIMITED",
"ANDHRA PRADESH MEDTECH ZONE LIMITED",
"ANDHRA PRADESH POWER DEVELOPMENT COMPANY LTD",
"ANDHRA PRADESH POWER FINANCE CORPORATION LIMITED",
"ANDHRA PRADESH POWER GENERATION CORPORATION LIMITED",
"ANDHRA PRADESH POWER GENERATION CORPORATION LIMITED.",
"ANDHRA PRADESH RAJIV SWAGRUHA CORPORATION LIMITED",
"ANDHRA PRADESH SOLAR POWER CORPORATION PRIVATE LIMITED",
"ANDHRA PRADESH STATE BEVERAGES CORPORATION LIMITED",
"ANDHRA PRADESH STATE FIBERNET LIMITED",
"ANDHRA PRADESH STATE FINANCE CORPORATION",
"ANDHRA PRADESH STATE FINANCIAL SERVICES CORPORATION LIMITED",
"ANDHRA PRADESH STATE GOVERNMENT EMPLOYEE MUTUALLY AIDED CO-OPERATIVE HOUSE BUILDING SOCIETY LTD",
"ANDHRA PRADESH STATE SKILL DEVELOPMENT CORPORATION",
"ANDHRA PRADESH TOURISM DEVELOPMENT CORPORATION LIMITED",
"ANDHRA PRADESH TOWNSHIP AND INFRASTRUCTURE DEVELOPMENT CORPORATION LIMITED",
"ANDHRA PRADESH URBAN FINANCE AND INFRASTRUCTURE DEVELOPMENT CORPORATION LTD",
"ANDHRA PRADESH URBAN INFRASTRUCTURE ASSET MANAGEMENT LIMITED",
"ANDHRA PRAGATHI GRAMEENA BANK",
"ANDHRA REFRIGERATION COMPANY",
"ANDHRA SUGARS LIMITED",
"ANDHRA UNIVERSITY",
"ANDHRA UNIVERSITY LAW COLLEGE",
"ANDHRA UNIVERSITY WALTAIR VISAKHAPATNAM",
"ANDLEYS ASSOCIATES PRIVATE. LIMITED",
"ANDNR SOFT SOLUTIONS PRIVATE LIMITED",
"ANDOLAN FILMS PRIVATE LIMITED",
"ANDOLASOFT INDIA PRIVATE LIMITED",
"ANDOR COMMUNICATIONS PRIVATE LIMITED",
"ANDOR TECH (INDIA) PRIVATE LIMITED",
"ANDOSA LAB INDIA PRIVATE LIMITED",
"ANDRA PRADESH MEDICAL SERVICES AND INFRASTRUCTURE DEVELOPMENT CORPORATION",
"ANDRAGOGY IMPACT METHODOLOGY AND ANALYSIS PRIVATE LIMITED",
"ANDRAPRADESH INDUSTRIAL INFRASTRUCTURE C",
"ANDRAS INDIA SERVICES PRIVATE LIMITED",
"ANDREAS MAIER WORKHOLDING TECHNOLOGY PRIVATE LIMITED.",
"ANDREAS PHARMA PRIVATE LIMITED",
"ANDREAS STIHL PRIVATE LIMITED",
"ANDREW YULE & CO LTD",
"ANDRI BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"ANDRI ENGINEERING PRIVATE LIMITED",
"ANDRITZ EUROSLOT INDIA PRIVATE LIMITED",
"ANDRITZ HYDRO PRIVATE LIMITED",
"ANDRITZ O&M PRIVATE LIMITED",
"ANDRITZ SEPARATION AND PUMP TECHNOLOGIES INDIA PRIVATE LIMITED",
"ANDRITZ TECHNOLOGIES PRIVATE LIMITED",
"ANDROID MOTORS PRIVATE LIMITED",
"ANDROMEDA BUSINESS CORPORATIONEXPORTSPRIVATE LIMITED",
"ANDROMEDA CONSULTANCY PRIVATE LIMITED",
"ANDROMEDA PACKAGING PRIVATE LIMITED",
"ANDROMEDA SALES AND DISTRIBUTION PRIVATE LIMITED",
"ANDROMEDA SHIPPING INDIA PRIVATE LIMITED",
"ANDROMIDA REAL ESTATE CONSORTIUM PRIVATE LIMITED",
"ANDRU INDUSTRIES PRIVATE LIMITED",
"ANDRU PRODUCTS PRIVATE LIMITED",
"ANDS LITE PRIVATE LIMITED",
"ANDURIL RETAIL PRIVATE LIMITED",
"ANDURIL TECHNOLOGIES PRIVATE LIMITED",
"ANDVI CIVIL CONSTRUCTION WORKS PRIVATE LIMITED",
"ANDWIN PHARMA PRIVATE LIMITED",
"ANDY MANNHART VERPACO INDIA PRIVATE LIMITED",
"ANDYANN LAMINATION",
"ANE BOOKS PRIVATE LIMITED",
"ANECO INDUSTRIES PRIVATE LIMITED",
"ANECOM TECHNOLOGIES PRIVATE LIMITED",
"ANEDYA INDUSTRIES PRIVATE LIMITED",
"ANEE MARCOM PRIVATE LIMITED",
"ANEEK SOLUTIONS PRIVATE LIMITED",
"ANEEKA UNIVERSAL PRIVATE LIMITED",
"ANEEL COATING AND POLYMERS PRIVATE LIMITED",
"ANEER ENGINEERS PRIVATE LIMITED",
"ANEES MEDIA & MARKETING PRIVATE LIMITED",
"ANEESH JEWELLERS PVT LTD",
"ANEETA TECHNOPACK PRIVATE LIMITED",
"ANEJA ASSURANCE PRIVATE LIMITED",
"ANEJA CONSTRUCTIONS INDIA LIMITED",
"ANEJA ENTERPRISES PRIVATE LIMITED",
"ANEJA FOODS PRIVATE LIMITED",
"ANEJA GIFT EMPORIUM PRIVATE LIMITED",
"ANEJA MANAGEMENT CONSULTANTS PVT LTD",
"ANEJA PAPER AND POLYMER PRIVATE LIMITED",
"ANEJA PLYWOODS PRIVATE LIMITED",
"ANEJA SWEETS AND BAKERS PRIVATE LIMITED",
"ANEK PRAYOG PRIVATE LIMITED",
"ANEKA FABTEX PRIVATE LIMITED",
"ANEKAL HORTICULTURE PRODUCER COMPANY LIMITED",
"ANEKANT STEEL INDIA PRIVATE LIMITED",
"ANEKARTH SOLAR PRIVATE LIMITED",
"ANEMO ENGINEERS PRIVATE LIMITED",
"ANEMO PRIME PRIVATE LIMITED",
"ANEMO PROJECTS PRIVATE LIMITED",
"ANEMOI TECHNOLOGIES PRIVATE LIMITED",
"ANEMONE DIGITAL WORLD PRIVATE LIMITED",
"ANEMONE HOLDINGS PRIVATE LIMITED",
"ANEMOS LIFESTYLE PRIVATE LIMITED",
"ANERGY ENTERPRISES PRIVATE LIMITED",
"ANERGY INSTRUMENTS PRIVATE LIMITED",
"ANERI CONSTRUCTION PRIVATE LIMITED",
"ANERI FINCAP LIMITED",
"ANESH PLACEMENTS PRIVATE LIMITED",
"ANEST IWATA MOTHERSON COATING EQUIPMENT PRIVATE LIMITED",
"ANEST IWATA MOTHERSON PRIVATE LIMITED",
"ANETCORP INDIA PRIVATE LIMITED",
"ANEVA GAMES PRIVATE LIMITED",
"ANEVA MORA PRIVATE LIMITED",
"ANEW CONSTRUCTIONS PRIVATE LIMITED",
"ANEWA ENGINEERING PRIVATE LIMITED",
"ANEWADDRESS CONSULTANCY PRIVATE LIMITED",
"ANEXA HOME APPLIANCES INDIA PRIVATE LIMITED",
"ANEXAS CONSULTANCY SE PRIVATE LIMITED",
"ANEXAS PHARMACEUTICALS PRIVATE LIMITED",
"ANEXTECH ELECTRONICS MANUFACTURING PRIVATE LIMITED",
"ANEYA FOUNDRIES PRIVATE LIMITED",
"ANF BUILD TECH PRIVATE LIMITED",
"ANFAA MASBAK PRIVATE LIMITED",
"ANFARND INFOTECH PRIVATE LIMITED",
"ANFILCO LIMITED",
"ANG AGRO FOODS PRIVATE LIMITED",
"ANG CAPITAL SERVICES PRIVATE LIMITED",
"ANG CENTRE FOR LIVER AND BILIARY SURGERY PRIVATE LIMITED",
"ANG CORPORATE SERVICES PRIVATE LIMITED",
"ANG GLOBALS",
"ANG HEALTHCARE INDIA PRIVATE LIMITED",
"ANG HEAVY LIFT PRIVATE LIMITED",
"ANG INDIA LIMITED",
"ANG INFRA PRIVATE LIMITED",
"ANG LIFESCIENCES INDIA LIMITED",
"ANG SECURE PRIVATE LIMITED",
"ANGAD CONSTRUCTION PRIVATE LIMITED",
"ANGAD CORPORATE INDIA PRIVATE LIMITED",
"ANGAD ESTATES PRIVATE LIMITED",
"ANGAD IMPEX PRIVATE LIMITED",
"ANGAD MILKFOODS PRIVATE LIMITED",
"ANGAD SEEDS PRIVATE LIMITED",
"ANGADI VENTURES PRIVATE LIMITED",
"ANGAMALY HOTELS AND RESORTS PRIVATE LIMITED",
"ANGAN FOODS PRIVATE LIMITED",
"ANGAN PRINTS PRIVATE LIMITED",
"ANGARA ECOMMERCE PRIVATE LIMITED",
"ANGARAJ VANIJYA PVT.LTD.",
"ANGARIKA DIGI TEX PRIVATE LIMITED",
"ANGARKAY MEDI SCIENCE PRIVATE LIMITED",
"ANGAROS INDIA PRIVATE LIMITED",
"ANGAT TECH PRIVATE LIMITED",
"ANGAYEEAMMAL DEVARAJAN TEXTILE PRIVATE LIMITED",
"ANGD FRUIT RANCH PRIVATE LIMITED",
"ANGEL & EVE HOSPITAL PRIVATE LIMITED",
"ANGEL ANTS PRIVATE LIMITED",
"ANGEL ASSOCIATES PRIVATE LIMITED",
"ANGEL BABY PRODUCTS PRIVATE LIMITED",
"ANGEL BAKERY PVT LTD",
"ANGEL BIOGENICS PRIVATE LIMITED",
"ANGEL BOOK HOUSE PRIVATE LIMITED",
"ANGEL BROADCASTING NETWORK PRIVATE LIMITED",
"ANGEL BUSINESS SERVICES PRIVATE LIMITED",
"ANGEL CHRISTIAN CHARITABLE FOUNDATION INDIA",
"ANGEL COMMUNITY COLLEGE",
"ANGEL DIGITECH SERVICES PRIVATE LIMITED",
"ANGEL EDUNEXT PRIVATE LIMITED",
"ANGEL EXPANDERS PRIVATE LIMITED",
"ANGEL EXTRUSION PRIVATE LIMITED",
"ANGEL FACADE ENGINEERS PRIVATE LIMITED",
"ANGEL FEEDS LIMITED",
"ANGEL FIBERS LIMITED",
"ANGEL FINANCIAL ADVISORS PRIVATE LIMITED",
"ANGEL FINCAP PRIVATE LIMITED",
"ANGEL HEALTHCARE",
"ANGEL IMART PRIVATE LIMITED",
"ANGEL INDIA CAD CAM PRIVATE LIMITED",
"ANGEL INFOSPACE CORPORATION PRIVATE LIMITED",
"ANGEL INTERNATIONAL",
"ANGEL ISPAT PRIVATE LIMITED",
"ANGEL LABORATORIES PVT LTD",
"ANGEL LEATHERS PRIVATE LIMITED",
"ANGEL MAGNETICS INDIA PRIVATE LIMITED",
"ANGEL METAL PRIVATE LIMITED",
"ANGEL ONE LIMITED",
"ANGEL PAPERS PRIVATE LIMITED",
"ANGEL PIPES AND TUBES PRIVATE LIMITED",
"ANGEL PROMOTERS PRIVATE LIMITED",
"ANGEL PUMPS PRIVATE LIMITED",
"ANGEL QUALITY SOLUTIONS PRIVATE LIMITED",
"ANGEL SEAIR CARGO PRIVATE LIMITED",
"ANGEL SECURITIES LIMITED",
"ANGEL SOFTWARE PRIVATE LIMITED",
"ANGEL SOLUTIONS PRIVATE LIMITED",
"ANGEL STARCH & FOOD PRIVATE LIMITED",
"ANGEL TRENDS PRIVATE LIMITED",
"ANGEL WEAVETECH PRIVATE LIMITED",
"ANGEL WORLD ELEVATION PRIVATE LIMITED",
"ANGELA MERCANTILES PVT LTD",
"ANGELBAY HOLDINGS PRIVATE LIMITED",
"ANGELCHEM NUTRACEUTICALS PRIVATE LIMITED",
"ANGELIC INFRACON PRIVATE LIMITED",
"ANGELIC SOFTECH PRIVATE LIMITED",
"ANGELIQUE INTERNATIONAL LIMITED",
"ANGELROSE TRADING PRIVATE LIMITED",
"ANGELS INFRAHEIGHT PRIVATE LIMITED",
"ANGELS PARADISE ENGLISH SCHOOL IN MUMBRA MUMBAI",
"ANGELS PARADISE MARATHI SECONDARY SCHOOL MUMBRA",
"ANGELS PHARMA INDIA PRIVATE LIMITED",
"ANGEL'S PLANET PRIVATE LIMITED",
"ANGELS PUBLIC SCHOOL",
"ANGELS REALTOR PRIVATE LIMITED",
"ANGELS TECHNICAL ENGINEERING SERVICES PRIVATE LIMITED",
"ANGENE CHEMICAL PRIVATE LIMITED",
"ANGGERIK LAKSANA (INDIA) PRIVATE LIMITED",
"ANGIA RX LIFE SCIENCE PRIVATE LIMITED",
"ANGIOLIFE HEALTHCARE PRIVATE LIMITED",
"ANGIPLAST PRIVATE LIMITED",
"ANGIRA DIAMONDS AND JEWELLERY PRIVATE LIMITED",
"ANGIRA PLYWOOD PRIVATE LIMITED",
"ANGKURAM HEALTH CARE PRIVATE LIMITED",
"ANGLE ENGINEERS PRIVATE LIMITED",
"ANGLEPAISA CONSULTANCY SERVICES PRIVATE LIMITED",
"ANGLEPLUS PROJECTS PRIVATE LIMITED",
"ANGLEPOINT INDIA PRIVATE LIMITED",
"ANGLER TECHNOLOGIES INDIA PRIVATE LIMITED",
"ANGLES VINIMAY PVT LTD",
"ANGLEWOOD FURNITURE SOLUTIONS PRIVATE LIMITED",
"ANGLO ARABIC MODEL SCHOOL",
"ANGLO EASTERN MARITIME SERVICES PRIVATE LIMITED",
"ANGLO EASTERN MARITIME TRAINING CENTRE",
"ANGLO FRENCH DRUGS & INDUSTRIES LIMITED",
"ANGLO GOLDY HYGIENE HEALTHCARE PRIVATE LIMITED",
"ANGLO INDIA JUTE & TEXTILE INDUSTRIES PRIVATE LIMITED",
"ANGLO INDIAN FLOWER BREEDERS PRIVATE LIMITED",
"ANGLO URDU GIRLS HIGH SCHOOL AND ABEDA INAMDAR JUNIOR COLLEGE FOR GIRLS",
"ANGLO URDU HIGH SCHOOL",
"ANGLO-EASTERN MARITIME ACADEMY",
"ANGLO-EASTERN SHIP MANAGEMENT INDIA PRIVATE LIMITED",
"ANGLOGOLDY INFRASTRUCTURE PRIVATE LIMITED",
"ANGLOGOLDY SHIPPING & LOGISTICS PRIVATE LIMITED",
"ANGLO-INDIAN PHARMACEUTICALS PRIVATE LIMITED",
"ANGLOMONTO RESOURCE PRIVATE LIMITED",
"ANGO MOTORS PRIVATE LIMITED",
"ANGORE FASHIONS PRIVATE LIMITED",
"ANGOT CHEMICALS PVT LTD",
"ANGRE PORT PRIVATE LIMITED",
"ANGUIL ENVIRONMENTAL SYSTEMS PRIVATE LIMITED",
"ANGUL ALUMINIUM PARK PRIVATE LIMITED",
"ANGUL ENERGY LIMITED",
"ANGUL SUKINDA RAILWAY LIMITED",
"ANGULARITY ANALYTICS PRIVATE LIMITED",
"ANGUR CRANE HIRING PRIVATE LIMITED",
"ANGUS CONSULTING ENGINEERS PRIVATE LIMITED",
"ANGUS DUNDEE INDIA PRIVATE LIMITED",
"ANGUS EXIM PRIVATE LIMITED",
"ANGUS JUTE WORKS UNIT OF THE ANGUS COMPANY LIMITED",
"ANH CONSTRUCTION PRIVATE LIMITED",
"ANH ENGINEERING SERVICES PRIVATE LIMITED",
"ANH INFOTECH PRIVATE LIMITED",
"ANH TECHNOLOGIES PRIVATE LIMITED",
"ANHA FASHIONS PRIVATE LIMITED",
"ANHAD EDUTRAIN SOLUTIONS PRIVATE LIMITED",
"ANHAD MINERARIO PRIVATE LIMITED",
"ANHAD STUDIO PRIVATE LIMITED",
"ANHALTEN FAB ENGINEERS PRIVATE LIMITED",
"ANHEUSER BUSCH INBEV INDIA LIMITED",
"ANHOX HEALTHCARE PRIVATE LIMITED",
"ANI GENERICS PRIVATE LIMITED",
"ANI HEALTHCARE PRIVATE LIMITED",
"ANI INTEGRATED SERVICES LIMITED",
"ANI MEDIA PRIVATE LIMITED",
"ANI NETWORK PRIVATE LIMITED",
"ANIAN INTERIORS PRIVATE LIMITED",
"ANIBRAIN DIGITAL TECHNOLOGIES PRIVATE LIMITED",
"ANICARE PHARMACEUTICALS PRIVATE LIMITED",
"ANICCA DATA SCIENCE SOLUTIONS PRIVATE LIMITED",
"A'NICHE INFOTECH SOLUTIONS PRIVATE LIMITED",
"AN-ICON ENGINEERING TECHNOLOGIES & INFRASTRUCTURE DEVELOPMENTS PRIVATE LIMITED",
"ANICON FLOWCONTROLS LLP",
"ANICUT",
"ANIDEEP EYE HOSPITAL AND INSTITUTE PRIVATE LIMITED",
"ANIHAR GLOBAL PRIVATE LIMITED",
"ANIJEEV TRADESERVE PRIVATE LIMITED",
"ANIK FERRO ALLOYS PRIVATE LIMITED",
"ANIK FINANCIAL SERVICES PVT LTD",
"ANIK INDUSTRIES LIMITED",
"ANIK MILK PRODUCTS PRIVATE LIMITED",
"ANIKA APPARELS PRIVATE. LIMITED.",
"ANIKA AUTOMOBILES PRIVATE LIMITED",
"ANIKA CONSTRUCTIONS PRIVATE LIMITED",
"ANIKA GLOBAL TRADING PRIVATE LIMITED",
"ANIKA HEALTHCARE INDIA PRIVATE LIMITED",
"ANIKA INTERNATIONAL PRIVATE LIMITED",
"ANIKA MOTOCORP INDIA PRIVATE LIMITED",
"ANIKA MOTORS PRIVATE LIMITED",
"ANIKA POWER PRIVATE LIMITED",
"ANIKA STERILIS PRIVATE LIMITED",
"ANIKEDHYA BUSINESS VENTURES LLP",
"ANIKEDHYA INFRAPROJECTS PRIVATE LIMITED",
"ANIKET AMENITIES PRIVATE LIMITED",
"ANIKET AUTOBIKES PRIVATE LIMITED",
"ANIKET BUILDCON PRIVATE LIMITED",
"ANIKET FABRICATIONS",
"ANIKET FOOD PRODUCTS PRIVATE LIMITED",
"ANIKET HR & ALLIED SERVICES PRIVATE LIMITED",
"ANIKET MEDICAL AND GENERAL STORES",
"ANIKET METALS PRIVATE LIMITED",
"ANIKET POLYMERS PRIVATE LIMITED",
"ANIKET TEXTILES PRIVATE LIMITED",
"ANIKUL CONSULTANTS",
"ANIL AGENCIES PRIVATE LIMITED",
"ANIL AGROTECH PRIVATE LIMITED",
"ANIL AIR TECH ENGINEERS PVT.LTD.",
"ANIL ASHOK AND ASSOCIATES",
"ANIL BROTHERS DECORATORS PRIVATE LIMITED",
"ANIL BUILDCON INDIA PRIVATE LIMITED",
"ANIL BULK MOVERS INDIA PRIVATE LIMITED",
"ANIL COLOUR INDUSTRIES PRIVATE LIMITED",
"ANIL CONTRACTORS PRIVATE LIMITED",
"ANIL DYE-CHEM INDUSTRIES PRIVATE LIMITED",
"ANIL ENGINEERING PRIVATE LIMITED",
"ANIL FASHIONS PVT LTD",
"ANIL FINATURE PRIVATE LIMITED",
"ANIL HERBALS AND FOODS PRIVATE LIMITED",
"ANIL HOSIERY PRIVATE LIMITED",
"ANIL INDUSTRIES KATNI PRIVATE LIMITED",
"ANIL KANODIA ASSOCIATES PRIVATE LIMITED",
"ANIL KAPOOR FILM AND COMMUNICATION NETWORK PRIVATE LIMITED",
"ANIL KAPOOR FILM COMPANY PRIVATE LIMITED",
"ANIL KRISHNA STEEL PRIVATE LIMITED",
"ANIL KUMAR BISWAL",
"ANIL KUMAR SINGH CONSTRUCTION PRIVATE LIMITED",
"ANIL LOCKS LIMITED",
"ANIL LOCKS PRIVATE LIMITED",
"ANIL M V WAGHADKAR VALUERS PRIVATE LIMITED",
"ANIL MANTRA AVIATION PRIVATE LIMITED",
"ANIL MANTRA LOGISTIX PRIVATE LIMITED",
"ANIL MEDICOS PVT LTD",
"ANIL METALS PRIVATE LIMITED",
"ANIL MOTORS PRIVATE LIMITED",
"ANIL NEERUKONDA EDUCATIONAL SOCIETY",
"ANIL NEERUKONDA HOSPITAL",
"ANIL NEERUKONDA INSTITUTE OF TECHNOLOGY & SCIENCES",
"ANIL OIL TRADERS PRIVATE LIMITED",
"ANIL ORGANIC PRIVATE LIMITED",
"ANIL PETRO LUBE PRIVATE LIMITED",
"ANIL PLAST INDUSTRIES PRIVATE LIMITED",
"ANIL POULTRY FARM PRIVATE LIMITED",
"ANIL PUMPS PRIVATE LIMITED",
"ANIL RAJESH CAPS MANUFACTURING PRIVATE LIMITED",
"ANIL RUBBER MILLS PRIVATE LIMITED",
"ANIL SALES FOOTWEAR PVT LTD",
"ANIL SANITARY PRIVATE LIMITED",
"ANIL SECURITY AND PERSONNEL SERVICES PRIVATE LIMITED",
"ANIL STEELS PRIVATE LIMITED",
"ANIL THERMOPLASTICS PRIVATE LIMITED",
"ANIL TRADING INDIA PRIVATE LIMITED",
"ANIL YARNS PRIVATE LIMITED",
"ANILA MEDICAL PRIVATE LIMITED",
"ANILAHIR LOGISTICS PRIVATE LIMITED",
"ANILESH ENTERPRISES PRIVATE LIMITED",
"ANILINE CONSTRUCTION COMPANY PRIVATE LIMITED",
"ANILINE PROPERTIES PRIVATE LIMITED",
"ANILISHWAR IMPACT PRIVATE LIMITED",
"ANILKUMAR AND COMPANY",
"ANILRAJ PROMOTERS & FINCON PVT. LTD.",
"ANILTECH FABRICATORS PRIVATE LIMITED",
"ANIMA CONSTRUCTION PRIVATE LIMITED",
"ANIMA PAUL STEEL PRIVATE LIMITED",
"ANIMA TECHNOLOGIES PRIVATE LIMITED",
"ANIMAKER INDIA PRIVATE LIMITED",
"ANIMAL ADVERTISING PRIVATE LIMITED",
"ANIMAL BIOTECH (BANGALORE)PRIVATE LIMITED",
"ANIMAL HUSBANDARY & DAIRYING",
"ANIMAL HUSBANDRY DEPARTMENT",
"ANIMAL RAHAT",
"ANIMALA WIND POWER PRIVATE LIMITED",
"ANIMATE POWER AND CONTROL PRIVATE LIMITED",
"ANIMATION XPRESS INDIA PRIVATE LIMITED",
"ANIMAX HEALTH CARE PRIVATE LIMITED",
"ANIMAX PHARMA PRIVATE LIMITED",
"ANIMAX STUDIOS INDIA PRIVATE LIMITED",
"ANIMESH BUILDTECH INDIA PRIVATE LIMITED",
"ANIMESH DEVELOPERS PRIVATE LIMITED",
"ANIMIT MARBLE AND GRANITES PRIVATE LIMITED",
"ANIMUGH SPORTS PRIVATE LIMITED",
"ANIMUS CONSULTANCY AND SERCIVES PRIVATE",
"ANIN CONSULTANCY SERVICES PRIVATE LIMITED",
"ANINDITA FASHIONS PRIVATE LIMITED",
"ANIQUE BIO SOLUTIONS",
"ANIR TECH PARK PRIVATE LIMITED",
"ANIRA PAPER MILLS PRIVATE LIMITED",
"ANIRA SOLUTIONS PRIVATE LIMITED",
"ANIRAJ DISTRIBUTORS PRIVATE LIMITED",
"ANIR-ARIN HOLDINGS PRIVATE LIMITED",
"ANIRAT CONTRACTS PRIVATE LIMITED",
"ANIRIT URBAN AGROFOODS PRIVATE LIMITED",
"ANIRUDDH ECO RECYCLING PRIVATE LIMITED",
"ANIRUDDHA ENTERPRISES PRIVATE LIMITED",
"ANIRUDDHA TELEMETRY SYSTEMS PRIVATE LIMITED",
"ANIRUDH AAPT PRIVATE LIMITED",
"ANIRUDH FOODS LIMITED",
"ANIRUDH FOUNDATION PRIVATE LIMITED",
"ANIRUDH GENEXT MANAGEMENT AND SECURITY SERVICES PRIVATE LIMITED",
"ANIRUDH METASTEEL PRIVATE LIMITED",
"ANIRUDH PLASTIC PRIVATE LIMITED",
"ANIRUDH TEXCHEM PRIVATE LIMITED",
"ANIRUTH GREEN INDIA PRIVATE LIMITED",
"ANIRUTH GREEN TEC PRIVATE LIMITED",
"ANIRUTHK INFRASTRUCTURE PRIVATE LIMITED",
"ANISA CARPETS LIMITED",
"ANISH FINANCIAL CONSULTANTS PRIVATE LIMITED",
"ANISH FOODS PRIVATE LIMITED",
"ANISH FORGE PRIVATE LIMITED",
"ANISH HOSPITALITY MANUFACTURERS PRIVATE LIMITED",
"ANISH HYDRAULICS PVT LTD",
"ANISH INDIA EXPORTS LLP",
"ANISH INFRACON INDIA PRIVATE LIMITED",
"ANISH INFRASTRUCTURE (COIMBATORE) PRIVATE LIMITED",
"ANISH PHARMA RESEARCH CENTRE PVT LTD",
"ANISH PHARMAEQUIP PRIVATE LIMITED",
"ANISH REALTORS PRIVATE LIMITED",
"ANISH SCAFFOLDING INDIA PRIVATE LIMITED",
"ANISH TEXFAB PRIVATE LIMITED",
"ANISHA BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"ANISHA ESTATE & FINANCE PVT LTD",
"ANISHA FASHIONS PRIVATE LIMITED",
"ANISHA IMPEX LIMITED",
"ANISHA TRANSFORMERS PRIVATE LIMITED",
"ANISHKA DEVELOPERS PRIVATE LIMITED",
"ANISHWAR INFRA PRIVATE LIMITED",
"ANISHYA LIFECARE PRIVATE LIMITED",
"ANITA BUILDERS PRIVATE LIMITED",
"ANITA DISTRIBUTORS PRIVATE LIMITED",
"ANITA FASHION PRIVATE LIMITED",
"ANITA HOSIERY PRIVATE LIMITED",
"ANITA INTERNATIONAL",
"ANITA MEDICAL SYSTEMS PRIVATE LIMITED",
"ANITA METHODIST MATRICULATION HIGHER SECONDARY SCHOOL",
"ANITA OILS & FATS PRIVATE LIMITED",
"ANITA REALTECH PRIVATE LIMITED",
"ANITA RISEWELL HOLDINGS PVT LTD",
"ANITA SUITS AND SAREES PRIVATE LIMITED",
"ANITA SWEETY DEVCON PRIVATE LIMITED",
"ANITHA POLYPACK BANGALORE PRIVATE LIMITED",
"ANITHA TEXCOT (INDIA) PRIVATE LIMITED",
"ANITHAA COTTON MILLS (INDIA) PRIVATE LIMITED",
"ANITHAA WEAVING MILL PRIVATE LIMITED",
"ANIVALE PRIVATE LIMITED",
"ANIVARYA PRODUCTS PRIVATE LIMITED",
"ANIVASI MUKBADHIR VIDYALAYA VASANWADI BEED",
"ANIVED PORTFOLIO MANAGERS PRIVATE LIMITED",
"ANIX SYSTEMS PRIVATE LIMITED",
"ANIXTER INDIA PRIVATE LIMITED",
"ANJ CREATIONS PRIVATE LIMITED",
"ANJ ENTERPRISES PRIVATE LIMITED",
"ANJ PRODUCTS PRIVATE LIMITED",
"ANJ TURNKEY PROJECTS PRIVATE LIMITED",
"ANJA JEWELS PRIVATE LIMITED",
"ANJAIAH AND CO.HOTELS PVT.LTD.",
"ANJAIYA JEWELLERY PRIVATE LIMITED",
"ANJAK ENGINEERS PRIVATE LIMITED",
"ANJALEE BUSINESS SOLUTIONS PRIVATE LIMITED",
"ANJALEE GRANITES PRIVATE LIMITED",
"ANJALEE JEWELLERS (INDIA) PRIVATE LIMITED",
"ANJALI ALUMINIUM PRIVATE LIMITED",
"ANJALI AND COMPANY PRIVATE LIMITED",
"ANJALI CREATION",
"ANJALI CREDIT PVT LTD",
"ANJALI DOORS PRIVATE LIMITED",
"ANJALI ELECTRONICS PRIVATE LIMITED",
"ANJALI ENERPRISE",
"ANJALI FISCAL PVT LTD",
"ANJALI FOUNDATION",
"ANJALI HARDWARES PRIVATE LIMITED",
"ANJALI HOTELS PRIVATE LIMITED",
"ANJALI ICE-CREAM PRIVATE LIMITED",
"ANJALI JEWELLERS PRIVATE.LIMITED",
"ANJALI KITCHEN APPLIANCES PRIVATE LIMITED",
"ANJALI KITCHENWARE PRIVATE LIMITED",
"ANJALI LABS",
"ANJALI LABS JMJK PRIVATE LIMITED",
"ANJALI MUKERJEE HEALTH TOTAL PRIVATE LIMITED",
"ANJALI POLYPLAST PRIVATE LIMITED",
"ANJALI PROMOTERS AND DEVELOPERS PRIVATE LIMITED",
"ANJALI RICE MILL PRIVATE LIMITED",
"ANJALI STAINLESS PRIVATE LIMITED",
"ANJALI TEXTILE MILLS",
"ANJALI TRAUMA & JOINTS PRIVATE LIMITED",
"ANJALI VENTURES LIMITED",
"ANJALIN LOGISTICS PRIVATE LIMITED",
"ANJALINE BLUE MOONS PRIVATE LIMITED",
"ANJAN AIR TRACK SYSTEMS PRIVATE LIMITED",
"ANJAN DRUG PRIVATE LIMITED",
"ANJAN INFRASTRUCTURE PRIVATE LIMITED",
"ANJAN NURSING HOME PRIVATE LIMITED",
"ANJANA ADORABLES",
"ANJANA ELECTRICALS AND ENGINEERING PRIVATE LIMITED",
"ANJANA EXPLOSIVES LIMITED",
"ANJANA EXPORTS PVT LTD",
"ANJANA MEDICARE SERVICE PRIVATE LIMITED",
"ANJANA MULTICUISINE PRIVATE LIMITED",
"ANJANA PROJECTS PRIVATE LIMITED",
"ANJANA SOFTWARE SOLUTIONS PRIVATE LIMITED",
"ANJANADHRII FASHIONS PRIVATE LIMITED",
"ANJANADRI PRECAST PRIVATE LIMITED",
"ANJANAM EXTRUSIONS PRIVATE LIMITED",
"ANJANAY RICE MILL PVT LTD",
"ANJANEE DECOR PRIVATE LIMITED",
"ANJANEE INFRASPACE LIMITED",
"ANJANEY AUTOMOBILES PRIVATE LIMITED",
"ANJANEY FERRO ALLOYS LTD.",
"ANJANEY STOCK BROKING LIMITED",
"ANJANEYA ARTEFACTS PRIVATE LIMITED",
"ANJANEYA AUTOWORLD INDIA PRIVATE LIMITED",
"ANJANEYA COLD STORAGE PRIVATE LIMITED",
"ANJANEYA COMTECH PRIVATE LIMITED",
"ANJANEYA CORPORATE SERVICES PRIVATE LIMITED",
"ANJANEYA COTTON PRIVATE LIMITED",
"ANJANEYA INFRASTRUCTURE PROJECTS PRIVATE LIMITED",
"ANJANEYA ISPAT LIMITED",
"ANJANEYA MINERALS PRIVATE LIMITED",
"ANJANEYA PRIME REALTY PRIVATE LIMITED",
"ANJANEYA ROLLER FLOUR MILLS PRIVATE LIMITED",
"ANJANEYA RUBBER & TECHNOCRAFTS PRIVATE LIMITED",
"ANJANEYAA INTERIO PRIVATE LIMITED",
"ANJANEYAPUTRA HUMAN RESOURCE CONSULTANCY PRIVATE LIMITED",
"ANJANI ADVISORY SERVICES PRIVATE LIMITED",
"ANJANI CLOSURES PRIVATE LIMITED",
"ANJANI DYES AND INTERMEDIATES PRIVATE LIMITED",
"ANJANI ENTERPRISES LTD.",
"ANJANI FINANCE LIMITED",
"ANJANI FOOD PRODUCTS PRIVATE LIMITED",
"ANJANI FOODS LIMITED",
"ANJANI GOLD PRIVATE LIMITED",
"ANJANI GOODS PRIVATE LIMITED",
"ANJANI INFRA",
"ANJANI INTERNATIONAL PRIVATE LIMITED",
"ANJANI KUMAR COMPANY PRIVATE LIMITED",
"ANJANI PAPER MART PRIVATE LIMITED",
"ANJANI POLYPACK PRIVATE LIMITED",
"ANJANI POLYTEC PRIVATE LIMITED",
"ANJANI PORTLAND CEMENT LIMITED",
"ANJANI ROLLER FLOUR MILLS PRIVATE LIMITED",
"ANJANI SAREE PRIVATE LIMITED",
"ANJANI SOFTTECH PRIVATE LIMITED",
"ANJANI STAINLESS STEELS PRIVATE LIMITED",
"ANJANI STEELS LIMITED",
"ANJANI SYNTHETICS LIMITED",
"ANJANI TARPAULIN PRIVATE LIMITED",
"ANJANI TILES LIMITED",
"SKAPS ADVANCED COMPOSITES PRIVATE LIMITED",
"ANJANI VISHNU ALLIED SERVICES LIMITED",
"ANJANI VISHNU HOLDINGS LIMITED",
"ANJANIKRUPA LOGISTICS PRIVATE LIMITED",
"ANJANINANDAN PREMIER PACKAGING PRIVATE LIMITED",
"ANJANIPUTRA AGENCIES PRIVATE LIMITED",
"ANJANIPUTRA VINIMAY PRIVATE LIMITED",
"ANJANISSUT SALTS PRIVATE LIMITED",
"ANJANISUT IRON AND STEELS PRIVATE LIMITED",
"ANJANISUTA STEELS PRIVATE LIMITED",
"ANJAPPAR CHETTINAD",
"ANJAPPAR CHETTINAD A C RESTAURANT MADURAI LLP",
"ANJARIA ENVIRO TECH PRIVATE LIMITED",
"ANJARS HARIHAR ENGINEERS PRIVATE LIMITED",
"ANJIS DEVELOPERS PRIVATE LIMITED",
"ANJITA ENTERPRISES PRIVATE LIMITED",
"ANJLE MEP PROJECTS PRIVATE LIMITED",
"ANJNI CASTING PRIVATE LIMITED",
"ANJU KNIT FAB PRIVATE LIMITED",
"ANJU LIFE SCIENCES PRIVATE LIMITED",
"ANJU RANI AROGYAM HOSPITAL",
"ANJU RUBBER FACTORY PRIVATE LIMITED",
"ANJU SIIMA TECHNOLOGIES PRIVATE LIMITED",
"ANJU SYNTHETICS PRIVATE LIMITED",
"ANJULI AUTOMOBILES PRIVATE LIMITED",
"ANJUM EXTRACTIONS PVT LTD",
"ANJUMAN BRAND DESIGNS PRIVATE LIMITED",
"ANJUMAN COLLEGE OF ENGINEERING",
"ANJUMAN FASHIONS LIMITED",
"ANJUMAN HIGH SCHOOL",
"ANJUMAN HIGH SCHOOL AND JUNIOR COLLEGE",
"ANJUMAN I ISLAM",
"ANJUMAN I ISLAM KALSEKAR TECHNICAL CAMPUS SCHOOL OF ENGINEERING AND TECHNOLOGY",
"ANJUMAN I ISLAM‚ÄôS SAIF TYABJI GIRLS HIGH SCHOOL",
"ANJUMAN ISLAM'S AKBAR PEERBHOY COLLEGE OF COMMERCE",
"ANJUMAN KHAIRUL ISLAM URDU HIGH SCHOOL NALASOPARA",
"ANJUMAN RIYAZUL ISLAM URDU HIGH SCHOOL",
"ANJUMAN RIYAZUL ISLAM URDU PRIMARY SCHOOL",
"ANJUMAN TEA COMPANY LTD",
"ANJUSHA GROWERS & MANUFACTURERS PRIVATE LIMITED",
"ANJUSHREE HOTEL & RESORTS PRIVATE LIMITED",
"ANJUSOFT (INDIA) PRIVATE LIMITED",
"ANK CARES PRIVATE LIMITED",
"ANK ENGINEERS PRIVATE LIMITED",
"ANK EV",
"ANK EXPORTS",
"ANK HANDLOOM",
"ANK HOTELS PRIVATE LIMITED",
"ANK LIFECARE PRIVATE LIMITED",
"ANK METALS PRIVATE LIMITED",
"ANK PHARMA PRIVATE LIMITED",
"ANKA ENTERPRISES PRIVATE LIMITED",
"ANKAI INDIA PRIVATE LIMITED",
"ANKAI INTERNATIONAL PRIVATE LIMITED",
"ANKALAN WEB SOLUTION PRIVATE LIMITED--BANGLORE",
"ANKALESH TEXTILE PRIVATE LIMITED",
"ANKAPALLI TOLLWAY PRIVATE LIMITED",
"ANKAR ENGINEERS AND FABRICATIONS PRIVATE LIMITED",
"ANKAR INDUSTRIES PVT LTD",
"ANKASUMMOR FOODS PRIVATE LIMITED",
"ANKAY DRUGS PRIVATE LIMITED",
"ANKDEEP PLASTECH PRIVATE LIMITED",
"ANKEENA NETWORKS PRIVATE LIMITED",
"ANKERCLOUD TECHNOLOGIES PRIVATE LIMITED",
"ANKERITE HEALTH CARE PRIVATE LIMITED",
"ANKEY INNOVATIONS PRIVATE LIMITED",
"ANKHONIA ADVISORS PRIVATE LIMITED",
"ANKHUA EXPORTS PRIVATE LIMITED",
"ANKI WINE PRIVATE LIMITED",
"ANKIKA STEELS PRIVATE LIMITED",
"ANKISH AUTOMATIONS PRIVATE LIMITED",
"ANKIT ADVERTISING PRIVATE LIMITED",
"ANKIT AEROSPACE PRIVATE LIMITED",
"ANKIT AGRO INDUSTRIES PRIVATE LIMITED",
"ANKIT AIR SYSTEMS PRIVATE LIMITED",
"ANKIT BISCUITS PRIVATE LIMITED",
"ANKIT BUILDESTATE PRIVATE LIMITED",
"ANKIT DEALCOM PRIVATE LIMITED",
"ANKIT DIAMOND",
"ANKIT ELECTRICALS PRIVATE LIMITED",
"ANKIT ELECTRO GRATING",
"ANKIT ENTERPRISES",
"ANKIT EQUIPMENTS PRIVATE LIMITED",
"ANKIT EXCLUSIVE AUTO PRIVATE LIMITED",
"ANKIT FASTENERS PRIVATE LIMITED",
"ANKIT FINANCIAL SERVICES PRIVATE LTD",
"ANKIT FOREX PRIVATE LIMITED",
"ANKIT FUTURE MARKET SERVICES PVT LTD",
"ANKIT GEMS PRIVATE LIMITED",
"ANKIT GRAPHICS PRIVATE LIMITED",
"ANKIT IMPEX MARKETING SERVICES PRIVATE LIMITED",
"ANKIT INDIA LIMITED",
"ANKIT INTERNATIONAL.",
"ANKIT IRRIGATION PRIVATE LIMITED",
"ANKIT MACHINES PRIVATE LIMITED",
"ANKIT MARKETING PRIVATE LIMITED",
"ANKIT MECHANICAL WORKS PRIVATE LIMITED",
"ANKIT METAL & POWER LIMITED",
"ANKIT PETROPRODUCTS PRIVATE LIMITED",
"ANKIT PIGMENTS EXPORTS PRIVATE LIMITED",
"ANKIT POLYPLAST PRIVATE LIMITED",
"ANKIT POLYSACK (INDIA) PRIVATE LIMITED",
"ANKIT POLYTEX PRIVATE LIMITED",
"ANKIT PRINTS",
"ANKIT PULPS AND BOARDS PRIVATE LIMITED",
"ANKIT RAJ ORGANO CHEMICALS LIMITED",
"ANKIT SHINY MECHANICALS INDIA PRIVATE LIMITED",
"ANKIT SHOES LIMITED",
"ANKIT SILKS PRIVATE LIMITED",
"ANKIT SIZING PVT LTD",
"ANKIT SMELTERS AND SCRAP TRADING PRIVATE LIMITED",
"ANKIT SOAPS AND SILICATES PRIVATE LIMITED",
"ANKIT SOOD VEGIES PRIVATE LIMITED",
"ANKIT STEELS",
"ANKIT TANDON ENTERPRISES & TOLLWAYS PRIVATE LIMITED",
"ANKIT TEXO INNOVATIONS PRIVATE LIMITED",
"ANKIT TEXPIN PRIVATE LIMITED",
"ANKIT TILES PRIVATE LIMITED",
"ANKIT TRACOM PVT. LTD.",
"ANKIT TRADEX (INDIA) PRIVATE LIMITED",
"ANKIT VASTU CREATIONS PRIVATE LIMITED",
"ANKITA AGRO & FOOD PROCESSING PRIVATE LIMITED",
"ANKITA BRASS COMPONENTS PRIVATE LIMITED",
"ANKITA CONSTRUCTION",
"ANKITA ELECTRONICS PRIVATE LIMITED",
"ANKITA FINANCIAL SERVICES PRIVATE LIMITED",
"ANKITA INFRAPROJECT PRIVATE LIMITED",
"ANKITA ORGANICS PRIVATE LIMITED",
"ANKITA POLYMER INDIA PRIVATE LIMITED",
"ANKITA POLYTUBES PRIVATE LIMITED",
"ANKITA PRATISTHAN LIMITED",
"ANKITA SILK MILLS PRIVATE LIMITED",
"ANKITA TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"ANKITA TEXTILE PRIVATE LIMITED",
"ANKITRAJ EXPOTRADE PRIVATE LIMITED",
"ANKLESHWAR AMMONIA SUPPLY PRIVATE LIMITED",
"ANKLESHWAR RESEARCH AND ANALYTICAL INFRASTRUCTURE ASSOCIATION",
"ANKLETS INDIA PRIVATE LIMITED",
"ANKR CONSULTING PRIVATE LIMITED",
"ANKRIS TECHNOLOGIES PRIVATE LIMITED",
"ANKSHREE INVESTMENTS AND TRADING COMPANY LIMITED",
"ANKTECH SOFTWARES PRIVATE LIMITED",
"ANKUR AND ARCHNA CONSULTING PRIVATE LIMITED",
"ANKUR AUTO SALES & SERVICES PRIVATE LIMITED",
"ANKUR BIOCHEM PRIVATE LIMITED",
"ANKUR CHEMFOOD LIMITED",
"ANKUR CLOTHING PRIVATE LIMITED",
"ANKUR CONSTRUCTIONS PVT LTD",
"ANKUR COTTEX PRIVATE LIMITED",
"ANKUR DEALCOM PRIVATE LIMITED",
"ANKUR DEALERS PRIVATE LIMITED",
"ANKUR DECOR PRIVATE LIMITED",
"ANKUR DENIM PRIVATE LIMITED",
"ANKUR ELECTROTRADE PRIVATE LIMITED",
"ANKUR ENTERPRISES AKOLA",
"ANKUR FARMERS PRODUCER COMPANY LIMITED",
"ANKUR FERTILIZERS PRIVATE LIMITED",
"ANKUR FINCON MANAGEMENT PRIVATE LIMITED",
"ANKUR FOUNDATIONS PRIVATE LIMITED",
"ANKUR HEALTHCARE PRIVATE LIMITED",
"ANKUR INFRADEVELOPERS PRIVATE LIMITED",
"ANKUR INFRASPACE PRIVATE LIMITED",
"ANKUR INTERNATIONAL SCHOOL",
"ANKUR MARBLES PRIVATE LIMITED",
"ANKUR MARKETING LIMITED",
"ANKUR MEDIA PRIVATE LIMITED",
"ANKUR NIRMAN PRIVATE LIMITED",
"ANKUR OFFSET PVT LTD",
"ANKUR PACKAGING PRIVATE LIMITED",
"ANKUR PESTICIDES PVT LTD",
"ANKUR PIPES PRIVATE LIMITED",
"ANKUR ROADLINES PRIVATE LIMITED",
"ANKUR SALT PRIVATE LIMITED",
"ANKUR SANITATION PRIVATE LIMITED",
"ANKUR SCIENTIFIC ENERGY TECHNOLOGIES PRIVATE LIMITED",
"ANKUR SEEDS PRIVATE LIMITED",
"ANKUR SHOPPE PRIVATE LIMITED",
"ANKUR SULZ PRIVATE LIMITED",
"ANKUR TELECOM PVT.LTD.",
"ANKUR TRADE LINKS PRIVATE LIMITED",
"ANKUR TRADERS & ENGINEERS PRIVATE LIMITED",
"ANKURA HOSPITALS FOR WOMEN & CHILDRENS",
"ANKURA HOSPITALS KOMPALLY PRIVATE LIMITED",
"ANKURA HOSPITALS LB NAGAR PRIVATE LIMITED",
"ANKURA INSTITUTE OF MEDICAL SCIENCES PRIVATE LIMITED",
"ANKURA MEDICAL & RESEARCH CENTER PRIVATE LIMITED",
"ANKURA TIRUPATHI HOSPITALS PRIVATE LIMITED",
"ANKURAN IVF CENTRE PRIVATE LIMITED",
"ANKURMAITRIKA HOSPITALS (OPC) PRIVATE LIMITED",
"ANKUS ENGINEERS AND CONTRACTORS PRIVATE LIMITED",
"ANKUSAM ENGINEERING PRIVATE LIMITED",
"ANKUSH ENTERPRISES",
"ANKUSH FOODS PRIVATE LIMITED",
"ANKUSH INFRA PRIVATE LIMITED",
"ANKUSH MEDICARE PRIVATE LIMITED",
"ANKUSH PUBLICATIONS PRIVATE LIMITED",
"ANKUSH STEEL CO PVT LTD",
"ANKUSH WAREHOUSING SERVICES PRIVATE LTD",
"ANKUSHISH ENTERPRISES",
"ANKYAH INFINITY PRIVATE LIMITED",
"ANLAGE INFOTECH (INDIA) PRIVATE LIMITED",
"ANLIGHT CONSULTING SERVICES PRIVATE LIMITED",
"ANLINDA GEAR TECHNOLOGIES PRIVATE LIMITED",
"AN-LINE SHIPPING PRIVATE LIMITED",
"ANLON HEALTHCARE PRIVATE LIMITED",
"ANLON TECHNOLOGY RESEARCH ORGANIZATION L LP",
"ANLON TECHNOLOGY SOLUTIONS LIMITED",
"ANM BUILDCON PRIVATE LIMITED",
"ANM HIGH SCHOOL",
"ANM INDUSTRIES PRIVATE LIMITED",
"ANM ISPAT PRIVATE LIMITED",
"ANM PHARMA PRIVATE LIMITED",
"ANM POLYMERS PRIVATE LIMITED",
"ANM SERVICES INDIA PRIVATE LIMITED",
"ANM STEEL INDUSTRIES PRIVATE LIMITED",
"ANMAKE ELECTRICALS PRIVATE LIMITED",
"ANMAKS SUBSCRIPTIONS AND PUBLICATION PRIVATE LIMITED",
"ANMAY SOLUTIONS PRIVATE LIMITED",
"ANMEDA SYSTEMS PRIVATE LIMITED",
"ANMEE TECH PRIVATE LIMITED",
"ANMERKUNG SOLUTIONS PRIVATE LIMITED",
"ANMK ENTERPRISES PRIVATE LIMITED",
"ANMMOL PROCESSORS PRIVATE LIMITED",
"ANMOL AGRIFARMS INPUTS PRIVATE LIMITED",
"ANMOL AGRO",
"ANMOL ASSOCIATES",
"ANMOL BEVERAGES PRIVATE LIMITED",
"ANMOL BIJOUTERIE PRIVATE LIMITED",
"ANMOL BISCUITS LIMITED",
"ANMOL BREWERIES PRIVATE LIMITED",
"ANMOL BUILD MATX PRIVATE LIMITED",
"ANMOL CHAIN PRIVATE LIMITED",
"ANMOL COLORANTS GLOBAL PRIVATE LIMITED",
"ANMOL CONCRETE PRIVATE LIMITED",
"ANMOL CORRUPACK PRIVATE LIMITED",
"ANMOL DYESTUFF PRIVATE LIMITED",
"ANMOL ELECTROPLAST PRIVATE LIMITED",
"ANMOL FEEDS PRIVATE LIMITED",
"ANMOL FINANCIAL SERVICES LIMITED",
"ANMOL FINPRO PRIVATE LIMITED",
"ANMOL FINSEC LIMITED",
"ANMOL FLUID CONTROL PRODUCTS PRIVATE LIMITED",
"ANMOL HEALTHCARE LABORATORY PRIVATE LIMITED",
"ANMOL HEALTHCARE PRIVATE LIMITED",
"ANMOL INDIA LIMITED",
"ANMOL INDUSTRIES LIMITED",
"ANMOL INFRA VENTURES PRIVATE LIMITED",
"ANMOL INFRATECH PRIVATE LIMITED",
"ANMOL KNITTERS PRIVATE LIMITED",
"ANMOL MEDICARE TPA LIMITED",
"ANMOL MINERALS PRIVATE LIMITED",
"ANMOL NAGRI SAHKARI PATSANSTHA LTD",
"ANMOL POLYMERS PRIVATE LIMITED",
"ANMOL PUBLIC SCHOOL",
"ANMOL QUALITY FOODS PRIVATE LIMITED",
"ANMOL RECREATION SERVICES PRIVATE LIMITED",
"ANMOL ROLLER FLOUR MILLS PRIVATE LIMITED",
"ANMOL SAFETY PRODUCTS PRIVATE LIMITED",
"ANMOL SEKHRI CONSULTANTS PRIVATE LIMITED",
"ANMOL SHRUSTI CONTRACTORS ENGINEERS PRIVATE LIMITED",
"ANMOL SOLUTIONS PRIVATE LIMITED",
"ANMOL SOLVEX PRIVATE LIMITED",
"ANMOL SPICES PRIVATE LIMITED",
"ANMOL STAINLESS PRIVATE LIMITED",
"ANMOL SWARN INDIA PRIVATE LIMITED",
"ANMOL TECHNOLOGIES PRIVATE LIMITED",
"ANMOL TECHNOMART PRIVATE LIMITED",
"ANMOL VATIKA PRIVATE LIMITED",
"ANMOL WATCHES AND ELECTRONICS PRIVATE LIMITED",
"ANMP PHARMA PRIVATE LIMITED",
"ANMSOFT TECHNOLOGIES PRIVATE LIMITED",
"ANN FMCG PRIVATE LIMITED",
"ANNA ADARSH COLLEGE FOR WOMEN",
"ANNA ADARSH MATRIC HIGHER SECONDARY SCHOOL",
"ANNA ALUMINIUM COMPANY PRIVATE LIMITED",
"ANNA ASSOCIATES PRIVATE LTD",
"ANNA BULK CARRIERS PVT LTD",
"ANNA GARMENTS PRIVATE LIMITED",
"ANNA INFRASTRUCTURES LIMITED",
"ANNA IT SERVICES PRIVATE LIMITED",
"ANNA SAHEB GUNDELWAR COLLEGE KATOL ROAD",
"ANNA UNIVERSITY",
"ANNABHUMI GREENTECH PRIVATE LIMITED",
"ANNACHI ENTERPRISES PRIVATE LIMITED",
"ANNADA COLD STORAGE PRIVATE LIMITED",
"ANNADAATA AGRO INDUSTRIES PRIVATE LIMITED",
"ANNADAN AGRO INDUSTRIES PRIVATE LIMITED",
"ANNADATA AGRO FARMS PRIVATE LIMITED",
"ANNADATHA RETAIL PRIVATE LIMITED",
"ANNADHATA SEED COMPANY PRIVATE LIMITED",
"ANNAI CONSTRUCTIONS PRIVATE LIMITED",
"ANNAI DHALL MILL PRIVATE LIMITED",
"ANNAI ENTERPRISES PRIVATE LIMITED",
"ANNAI FATHIMA CONSTRUCTIONS PRIVATE LIMITED",
"ANNAI FLOUR MILLS PRIVATE LIMITED",
"ANNAI FOOD PRODUCTS PRIVATE LIMITED",
"ANNAI FRIED GRAMS PRIVATE LIMITED",
"ANNAI INFRA DEVELOPERS PRIVATE LIMITED",
"ANNAI JEWELLERS PRIVATE LIMITED",
"ANNAI MIRA COLLEGE OF ENGINEERING AND TECHNOLOGY",
"ANNAI RESORTS AND SPA PRIVATE LIMITED",
"ANNAI THERESA HOSPITALS PRIVATE LIMITED",
"ANNAI THERESSA INSTITUTE OF PARAMEDICAL SEIENCES",
"ANNAI VEILANKANNI‚ÄôS COLLEGE OF EDUCATION",
"ANNAI VELANKANNI INSTITUTE OF PHARMACY",
"ANNAI VELANKANNI PHARMACY COLLEGE",
"ANNAIBHARATH HOUSING PRIVATE LIMITED",
"ANNAIE INFORMATIONS PRIVATE LIMITED",
"ANNAII HOSPITAL",
"ANNAII MEDICAL COLLEGE AND HOSPITAL",
"ANNAIR DRYCHILL TECH INDIA PRIVATE LIMITED",
"ANNAKOOT PROPERTIES PRIVATE LIMITED",
"ANNAKUT BISCUIT COMPANY PRIVATE LIMITED",
"ANNALAKSHMI CATERING SERVICES PRIVATE LIMITED",
"ANNALAKSHMI FOODS PRIVATE LIMITED",
"ANNALAKSHMI RESTAURANTS PRIVATE LIMITED",
"ANNAM ENTERPRISES",
"ANNAM ORGANICS PRIVATE LIMITED",
"ANNAM SOFTWARE PRIVATE LIMITED",
"ANNAMACHARYA INSTITUTE OF TECHNOLOGY AND SCIENCES",
"ANNAMALAI AGENCIES PRIVATE LIMITED",
"ANNAMALAI HOTELS PRIVATE LIMITED",
"ANNAMALAI MOTORS PRIVATE LIMITED",
"ANNAMALAI UNIVERSITY",
"ANNAMALAIAR MILLS GIRLS HR SEC SCHOOL LOCATION DINDIGUL",
"ANNAMALAIAR MILLS PRIVATE. LIMITED.",
"ANNAMALAIAR SPINNERS PRIVATE LIMITED",
"ANNAMALAIYAR SANKARI CEMENTS PRIVATE LIMITED",
"ANNAMALLAI ENTERPRISE PRIVATE LIMITED",
"ANNAMALLAI RETREADING COMPANY PRIVATE LIMITED",
"ANNAMDEVULA DURGAMAJI",
"ANNANDDHARA COMMOSALES PRIVATE LIMITED",
"ANNANT GLOBAL FORWARDERS PRIVATE LIMITED",
"ANNAPAKSHI CRAFT SOURCES PRIVATE LIMITED",
"ANNAPOORANI TEXTILES PRIVATE LIMITED",
"ANNAPOORNA AGENCIES PRIVATE LIMITED",
"ANNAPOORNA AGRIVENTURE PRIVATE LIMITED",
"ANNAPOORNA CONTAINERS PRIVATE LIMITED",
"ANNAPOORNA RESIDENCY PRIVATE LIMITED",
"ANNAPURNA AGRI-INNOVATION PRIVATE LIMITED",
"ANNAPURNA AGRO INDUSTRIES LLP",
"ANNAPURNA AGRO PRODUCTS",
"ANNAPURNA AGRO-INDIA PRIVATE LIMITED",
"ANNAPURNA AGRONICS MACHINERY PRIVATE LIMITED",
"ANNAPURNA AGROTECH INDUSTRIES PRIVATE LIMITED",
"ANNAPURNA APPARELS LIMITED",
"ANNAPURNA BAKERIES PRIVATE LIMITED",
"ANNAPURNA BUILDCON INFRA PRIVATE LIMITED",
"ANNAPURNA BUILDMART PRIVATE LIMITED",
"ANNAPURNA CARPETS PRIVATE LIMITED",
"ANNAPURNA COMMERCIAL & RESOURCES PVT LTD",
"ANNAPURNA CONSTRUCTIONS AND TRANSMISSIONS PRIVATE LIMITED",
"ANNAPURNA COTEX PRIVATE LIMITED",
"ANNAPURNA CROP CARE PRIVATE LIMITED",
"ANNAPURNA DISPOSABLE PRIVATE LIMITED",
"ANNAPURNA ELECTRONICS AND SERVICES PRIVATE LIMITED",
"ANNAPURNA EXPORT SOLAR DEVELOPMENT PRIVATE LIMITED",
"ANNAPURNA EXPORTS PRIVATE LIMITED (TRANSFER FROM DELHI TO RAJ.)",
"ANNAPURNA FINANCE PRIVATE LIMITED",
"ANNAPURNA FLORIEST PRIVATE LIMITED",
"ANNAPURNA GREEN CONSTRUCTION PRIVATE LIMITED",
"ANNAPURNA HIMGHAR PVT LTD",
"ANNAPURNA HING PRIVATE LIMITED",
"ANNAPURNA HOTELS PVT LTD",
"ANNAPURNA INDUSTRIES PVT LTD",
"ANNAPURNA LEASING & MARKETING PVT LTD",
"ANNAPURNA ORGANICS INDIA PRIVATE LIMITED",
"ANNAPURNA PET PRIVATE LIMITED",
"ANNAPURNA PHARMA AGENCY PRIVATE LIMITED",
"ANNAPURNA SAVINGS & FINANCE CO PRIVATE LTD",
"ANNAPURNA SEEDS PRIVATE LIMITED",
"ANNAPURNA SPINTEX PRIVATE LIMITED",
"ANNAPURNA STONE INDUSTRIES PVT LTD",
"ANNAPURNA STORAGES INDIA PRIVATE LIMITED",
"ANNAPURNA STUDIOS PRIVATE LIMITED",
"ANNAPURNA SWADISHT LIMITED",
"ANNAPURNA TEXOFIN PVT LTD",
"ANNAPURNA UNIVERSAL FOODS PRIVATE LIMITED",
"ANNAPURNA UTILITY SERVICES PRIVATE LIMITED",
"ANNAPURNA VENTURES PRIVATE LIMITED",
"ANNAPURNA VYAPAAR PRIVATE LIMITED",
"ANNAPURNA WELFARE ACADEMY",
"ANNAPURNADHAM AGRO INDUSTRIES PRIVATE LIMITED",
"ANNASAHEB AWATE COLLEGE MANCHARI",
"ANNASAHEB DANGE COLLEGE OF ENGINEERING & TECHNOLOGY",
"ANNASAHEB DANGE INTERNATIONAL SCHOOL",
"ANNASAHEB DANGE PUBLIC SCHOOL & JUNIOR COLLEGE ASHTA",
"ANNASAHEB GUNDEWAR ARTS-COMMERCE COLLEGE",
"ANNASAHEB MAGAR ARTS COMMERCE COLLEGE",
"ANNASAHEB MAGAR MAHAVIDYALAYA",
"ANNASAHEB RAMESH AJMERA COLLEGE OF PHARMACY",
"ANNASAHEB UMBARE FARMERS PRODUCER COMPANY LIMITED",
"ANNAY CONTAINERS PRIVATE LIMITED",
"ANNAYA COFFEE PRODUCTS PRIVATE LIMITED",
"ANNECTOS REWARDS AND RETAIL PRIVATE LIMITED",
"ANNET EDUCATIONAL SERVICES PRIVATE LIMITED",
"ANNEX DESIGN PRIVATE LIMITED",
"ANNEX FINSOLUTIONS PRIVATE LIMITED",
"ANNEX GLASS INDUSTRIES PRIVATE LIMITED",
"ANNEX HYGIENE SERVICES PRIVATE LIMITED",
"ANNEX IT SOLUTIONS",
"ANNEX IT SOLUTIONS PRIVATE LIMITED",
"ANNEX MED PRIVATE LIMITED",
"ANNEX MEDIA MARKETING NETWORK PRIVATE LIMITED",
"ANNEX PHARMACEUTICAL & CHEMICALS PRIVATE LIMITED",
"ANNEXE CHEM PRIVATE LIMITED",
"ANNEXLOGICS SYSTEM PRIVATE LIMITED",
"ANNEXMED PRIVATE LIMITED",
"ANNEXURE OF FINANCE DEPARTMENT",
"ANNEXXE ACRES PRIVATE LIMITED",
"ANNI INDUSTRIES PRIVATE LIMITED",
"ANNIE BESANT WOMENS COLLEGE",
"ANNIE CHEMIE PRIVATE LIMITED",
"ANNIE ELECTRONIC SYSTEMS PRIVATE LIMITED",
"ANNIE IMPEXPO MARKETING PRIVATE LIMITED",
"ANNIE INFRATECH PRIVATE LIMITED",
"ANNKOOT AGRO FOOD PRIVATE LIMITED",
"ANNOOR TEST LABS & ENGINEERING SERVICES PRIVATE LIMITED",
"ANNORA PHARMA PRIVATE LIMITED",
"ANNOVA SOLUTIONS PRIVATE LIMITED",
"ANNPOORNA OVERSEAS",
"ANNPURNA DALL MILL PRIVATE LIMITED",
"ANNPURNA DEALER PRIVATE LIMITED",
"ANNPURNA ELECTRICALS PRIVATE LIMITED",
"ANNPURNA EXIM PRIVATE LIMITED",
"ANNPURNA GINNING AND PRESSING PRIVATE LIMITED",
"ANNPURNA OVERSEAS PRIVATE LIMITED",
"ANNPURNA RICE MILLS",
"ANNS BAKERY & CONFECTIONERY PRIVATE LIMITED",
"ANNU AGROBASE PRIVATE LIMITED",
"ANNU AGROTECH PRIVATE LIMITED",
"ANNU INDUSTRIES PRIVATE LIMITED",
"ANNU PROJECTS PRIVATE LIMITED",
"ANNULUS TECHNOLOGY PRIVATE LIMITED",
"ANNUR A P A SPINNERS PRIVATE LIMITED",
"ANNUR ANNAMALAIAR SPINNING MILLS PRIVATE LIMITED",
"ANNUR CAUVERY SPINTEX PRIVATE LIMITED",
"ANNUR KPK SPINNING MILLS PRIVATE LIMITED",
"ANNUR SATYA TEXTILE LIMITED",
"ANNUR SRI SIVASAKTHI COTTON MILLS PRIVATE. LIMITED.",
"ANNUR SRI VELLINGIRI ANDAVAN TEXTILES PRIVATE LIMITED",
"ANNUR SRIAMBAL FABRICS PRIVATE LIMITED",
"ANNUR SS AGRO FOODS PRIVATE LIMITED",
"ANNUSHREE DIAM PRIVATE LIMITED",
"ANNUVA OVERSEAS TRADE PRIVATE LIMITED",
"ANNVESHAN BUSINESS SOLUTIONS PRIVATE LIMITED",
"ANOD PHARMA PRIVATE LIMITED",
"ANOD PLASMA SPRAY LIMITED",
"ANOFOL FAR EAST ANODIZING PRIVATE LIMITED",
"ANOKHA JEWELS PRIVATE LIMITED",
"ANOKHI DYEING AND PRINTING MILLS PRIVATE LIMITED",
"ANOKHI REALTY PRIVATE LIMITED",
"ANOKHI SONS AGRO INDIA PVT LTD",
"ANOLI HOLDINGS PRIVATE LIMITED",
"ANOM TRADECONTECH PRIVATE LIMITED",
"ANOMALOUS INFRA PRIVATE LIMITED",
"ANOMALY PRODUCTION PRIVATE LIMITED",
"ANON FOOD AND BEVERAGES PRIVATE LIMITED",
"ANON SECURITY SERVICES PRIVATE LIMITED",
"ANONDITA HEALTHCARE",
"ANONDITA HEALTHCARE PRODUCTS PRIVATE LIMITED",
"ANONET COMMUNICATIONS PRIVATE LIMITED",
"ANOOKOOL FACILITIES PRIVATE LIMITED",
"ANOOP CYLINDERS PRIVATE LIMITED",
"ANOOP FORGINGS PRIVATE LIMITED",
"ANOOP LABS PRIVATE LIMITED",
"ANOOP METAL ALLOYS PRIVATE LIMITED",
"ANOOP TEA CO PVT LTD",
"ANOOPAM INDIA PRIVATE LIMITED",
"ANOOPAM POWER TOOLS PRIVATE LIMITED",
"ANOOPAM REALTECH PRIVATE LIMITED",
"ANOORA ENERGY CONCEPTS PRIVATE LIMITED",
"ANOOS ELECTROLSIS & OBESITY P LIMITED",
"ANOPCHAND TILOKCHAND JEWELLERS PRIVATELIMITED",
"ANOPSINGH R JADEJA",
"ANORA FASHIONS PRIVATE LIMITED",
"ANORA INSTRUMENTATION PRIVATE LIMITED",
"ANORA SEMICONDUCTOR LABS PRIVATE LIMITED",
"ANORAK ENTERPRISES PRIVATE LIMITED",
"ANOSALES TECHNOLOGIES LLP",
"ANOUSHKA GOURMET PRIVATE LIMITED",
"ANOVA CORPORATE SERVICES PRIVATE LIMITED",
"ANP ATELIER & ASSOCIATS COMPANY PRIVATE LIMITED",
"ANP CORPORATE SOLUTIONS LLP",
"ANP PROPERTIES LLP",
"ANP TRAVELS INDIA PRIVATE LIMITED",
"ANPHAR LABORATORIES PRIVATE LIMITED",
"ANPHAR ORGANICS PRIVATE LIMITED.",
"ANPI INDIA RESEARCH & DEVELOPMENT PRIVATE LIMITED",
"ANPLIFY SERVICES PRIVATE LIMITED",
"ANPN FASTENERS PRIVATE LIMITED",
"ANPR PROJECTS PRIVATE LIMITED",
"ANPRASH PROJECTS PRIVATE LIMITED",
"ANR AUTOMOBILES PRIVATE LIMITED",
"ANR COTTON TRADERS",
"ANR DELIGHTS & BEVERAGES PRIVATE LIMITED",
"ANR DESIGNER TILES LIMITED",
"ANR ELECTRONOZIX PRIVATE LIMITED",
"ANR FABTEX PRIVATE LIMITED",
"ANR FINLEASE PRIVATE LIMITED",
"ANR INNS PRIVATE LIMITED",
"ANR INTERNATIONAL PRIVATE LIMITED",
"ANR LOCKS PRIVATE LIMITED",
"ANR MOTORS PRIVATE LIMITED",
"ANR SOFTWARE PRIVATE LIMITED",
"ANR TUBES PRIVATE LIMITED",
"ANRA PHARMACEUTICALS PRIVATE LIMITED",
"ANRA TECHNOLOGIES PRIVATE LIMITED",
"ANRAM SOLUTIONS PRIVATE LIMITED",
"ANRANYA TRAVELS PRIVATE LIMITED",
"ANRI SOLUTIONS HR SERVICES PRIVATE LIMITED",
"ANRITSU INDIA PRIVATE LIMITED",
"ANROE PRINTEX SOLUTIONS PRIVATE LIMITED",
"ANROMA TEXCHEM PRIVATE LIMITED",
"ANROSH INDUSTRIES PRIVATE LIMITED",
"ANS AIR AND SEA PRIVATE LIMITED",
"ANS CONSTRUCTIONS PRIVATE LIMITED",
"ANS COURIERS PRIVATE LIMITED",
"ANS DECOR WORKSHOP PRIVATE LIMITED",
"ANS DEVELOPERS PRIVATE LIMITED",
"ANS DIGITAL PRIVATE LIMITED",
"ANS EXPRESS SERVICES PRIVATE LIMITED",
"ANS HOLDING PRIVATE LIMITED",
"ANS INDOTRADE ENTERPRISE PRIVATE LIMITED",
"ANS INFRACON PRIVATE LIMITED",
"ANS LABOUR SERVICES PRIVATE LIMITED",
"ANS PLACEMENT PRIVATE LIMITED",
"ANS PRIVATE LIMITED",
"ANS PROJECTS INDIA PRIVATE LIMITED",
"ANS RPO SOLUTIONS PRIVATE LIMITED",
"ANS STEEL TUBES LIMITED",
"ANS TEMPCONTROL ENGINEERS PRIVATE LIMITED",
"ANSA DECOGLASS PRIVATE LIMITED",
"ANSA FASHION PRIVATE LIMITED",
"ANSA INDIA PRIVATE LIMITED",
"ANSA POLYMERS LIMITED",
"ANSA RETAIL PRIVATE LIMITED",
"ANSAA JEWELLERS PRIVATE LIMITED",
"ANSAI TOOLING SYSTEMS PRIVATE LIMITED",
"ANSAL API INFRASTRUCTURE LIMITED",
"ANSAL CONSTRUCTION PRIVATE LIMITED",
"ANSAL CROWN INFRABUILD PRIVATE LIMITED",
"ANSAL HI-TECH TOWNSHIPS LIMITED",
"ANSAL HOSPITALITY & LEISURE CO. P LIMITED",
"ANSAL HOUSING LIMITED",
"ANSAL JKD PEARL DEVELOPERS PRIVATE LIMITED",
"ANSAL LANDMARK (KARNAL) TOWNSHIP PRIVATE LIMITED",
"ANSAL LANDMARK TOWNSHIPS PRIVATE LIMITED",
"ANSAL UNIVERSITY GURGAON",
"ANSALDO STS TRANSPORTATION SYSTEMS INDIA PRIVATE LIMITED",
"ANSARI ASSOCIATES SERVICES",
"ANSARI SYNTHETICS PRIVATE LIMITED",
"ANSARWADA ORGANIC FARMER PRODUCER COMPANY LIMITED",
"ANSATA COMPUTER SYSTEMS PRIVATE LIMITED",
"ANSATA HOTELS PRIVATE LIMITED",
"ANSATRACK PRIVATE LIMITED",
"ANSCO SYSTEMS PRIVATE LIMITED",
"ANSEC COLLECTION & RECOVERY PRIVATE LIMITED",
"ANSEC HUMAN RESOURCE SERVICES LIMITED",
"ANSELL INDIA PROTECTIVE PRODUCTS PRIVATE LIMITED",
"ANSELM PHARMACEUTICALS PRIVATE LIMITED",
"ANSH COTEX",
"ANSH FINANCIAL SERVICES PRIVATE LIMITED",
"ANSH FOREX PRIVATE LIMITED",
"ANSH HITECH VENTURES PRIVATE LIMITED",
"ANSH HOTEL & RESORTS PRIVATE LIMITED",
"ANSH INFRATECH PRIVATE LIMITED",
"ANSH INTERMEDIATE SERVICES PRIVATE LIMITED",
"ANSH NEURO & MATERNITY CENTER PRIVATE LIMITED",
"ANSH NIRMAN PRIVATE LIMITED",
"ANSH REALINFRA PRIVATE LIMITED",
"ANSH TECHNOVISION LLP",
"ANSH THERAPEUTICS PRIVATE LIMITED",
"ANSH TRADE ENTERPRISES PRIVATE LIMITED",
"ANSH VENTURES PRIVATE LIMITED",
"ANSH YARNS PRIVATE LIMITED",
"ANSHAANKAN (INDIA) PRIVATE LIMITED",
"ANSHI INNOVATIVE SOLUTIONS PRIVATE LIMITED",
"ANSHIKA CONSULTANTS PRIVATE LIMITED",
"ANSHIKA FASTENERS PRIVATE LIMITED",
"ANSHIKA INVESTMENTS PRIVATE LIMITED",
"ANSHIKA MEDIHUB PRIVATE LIMITED",
"ANSHIKA POLLY FAB PRIVATE LIMITED",
"ANSHIKA POLYSURF LIMITED",
"ANSHIKA SOLUTIONS PRIVATE LIMITED",
"ANSHIMA MILLS INDUSTRIES PRIVATE LIMITED",
"ANSHITA TRADING COMPANY PRIVATE LIMITED",
"ANSHU CHEMICALS PRIVATE LIMITED",
"ANSHU HOSPITALS LIMITED",
"ANSHU METALS PRIVATE LIMITED",
"ANSHU OVERSEAS IMPEX PRIVATE LIMITED",
"ANSHU PANT TECH PRIVATE LIMITED",
"ANSHU RETAIL PRIVATE LIMITED",
"ANSHU TECH LABS PRIVATE LIMITED",
"ANSHUL INNOVATIVE CHEMISTRY PRIVATE LIMITED",
"ANSHUL REALTIES LLP",
"ANSHUL SEEDS & PESTICIDE PRIVATE LIMITED",
"ANSHUL SNACKS & BEVERAGES PRIVATE LIMITED",
"ANSHUL SPECIALTY MOLECULES PRIVATE LIMIT ED",
"ANSHUL STRIPS PRIVATE LIMITED",
"ANSHUL SUITINGS PRIVATE LIMITED",
"ANSHULA TECHNOLOGICAL ENGINEERING CONSULTANTS PRIVATE LIMITED",
"ANSHUMAAN TELELINK PRIVATE LIMITED",
"ANSHUMAN AUTO IMPEX PRIVATE LIMITED",
"ANSHUMAN CONSTRUCTION COMPANY PRIVATE LIMITED",
"ANSHUMAN RICE MILL PRIVATE LIMITED",
"ANSHUMAN TECH PRIVATE LIMITED",
"ANSHUMAN TRANSPOWER SYSTEM PRIVATE LIMITED",
"ANSHUTECH AIRCONDITIONING PRIVATE LIMITED",
"ANSIKA TRADING PRIVATE LIMITED",
"ANSIO INDUSTRIES PRIVATE LIMITED",
"ANSIO SOLUTIONS PRIVATE LIMITED",
"ANSON FINCORP PRIVATE LIMITED",
"ANSOX INDUSTRIES PRIVATE LIMITED",
"ANSR CONSULTING INDIA PRIVATE LIMITED",
"ANSR GLOBAL CORPORATION PRIVATE LIMITED",
"ANSR LOGISTICS AND FORWARDERS PRIVATE LIMITED",
"ANSR SOURCE INDIA PRIVATE LIMITED",
"ANSSONS RUBBER PRIVATE LIMITED",
"ANSTEL PRIVATE LIMITED",
"ANSUK POLYMERS PRIVATE LIMITED",
"ANSUL PLASTICS PRIVATE LIMITED",
"ANSUN MULTITECH INDIA LIMITED",
"ANSUN SYSTEM CONSULTING PVT LTD",
"ANSUN ZIPPERS PRIVATE LIMITED",
"ANSURAM INDUSTRIES AND MANUFACTURING PRIVATE LIMITED",
"ANSUYA IMPEX PRIVATE LIMITED",
"ANSUYA SURGICALS LIMITED",
"ANSWERPAL TECHNOLOGIES PRIVATE LIMITED",
"ANSYS ENGINEERING PRIVATE LIMITED",
"ANSYS SOFTWARE PRIVATE LIMITED",
"ANSYSCO ANAND LLP",
"ANT ENGINEERING PRIVATE LIMITED",
"ANT LOGISTICS PRIVATE LIMITED",
"ANT PHARMACUETICALS PRIVATE LIMITED",
"ANTA BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"ANTA VIDALYA PAREGAON",
"ANTAEUS GLOBAL TRADING (INDIA) PRIVATE LIMITED",
"ANTAEUS INFORMATION PRIVATE LIMITED",
"ANTAEUS RENT A CAR PRIVATE LIMITED",
"ANTAK MINERALS PRIVATE LIMITED",
"ANTAL INTERNATIONAL INDIA PRIVATE LIMITED",
"ANTARA HOSPITALS PRIVATE LIMITED",
"ANTARA JEWELLERY PRIVATE LIMITED",
"ANTARA PURUKUL SENIOR LIVING LIMITED",
"ANTARA SENIOR LIVING LIMITED",
"ANTARANG AK PRIVATE LIMITED",
"ANTARANG MEDICAL RESEARCH FOUNDATION P LTD",
"ANTARCTIC INDUSTRIES LIMITED",
"ANTARCTICA EQUIPMENT PRIVATE LIMITED",
"ANTARCTICA PROPERTIES COMPANY LIMITED.",
"ANTARCTICA TRADING COMPANY PRIVATE LIMITED",
"ANTARDHRISHTI CONSULTING PRIVATE LIMITED",
"ANTARES CHEM PRIVATE LIMITED",
"ANTARES FORGE PRIVATE LIMITED",
"ANTARES LOGISTICS PRIVATE LIMITED",
"ANTARES PUBLISHING SERVICES PRIVATE LIMITED",
"ANTARES SYSTEMS LIMITED",
"ANTARIKSH ADVANCED SECURITY SYSTEMS PRIVATE LIMITED",
"ANTARIKSH INDUSTRIES LIMITED",
"ANTARIKSH SOFTTECH PRIVATE LIMITED",
"ANTARIKSH WAREHOUSING AND LOGISTIC PARKS PRIVATE LIMITED",
"ANTARIM HOTEL LLP",
"ANTARIX IMAGING & PRINTING PRIVATE LIMITED",
"ANTEAK CONCEPTS AND DESIGNS PRIVATE LIMITED",
"ANTECH ELECTRONICS PRIVATE LIMITED",
"ANTECH ENGINEERS PRIVATE LIMITED",
"AN-TECH FABRICATION INDIA PRIVATE LIMITED",
"ANTECH IMPEX PRIVATE LIMITED",
"ANTELEC PRIVATE LIMITED",
"ANTELOPE INFRA PRIVATE LIMITED",
"ANTELOPE VENTURES PRIVATE LIMITED. AVPL",
"ANTELOPUS ENERGY PRIVATE LIMITED",
"ANTENNA SOFTWARE INDIA PRIVATE LIMITED",
"ANTER IMPEX PRIVATE LIMITED",
"ANTERIAD PRIVATE LIMITED",
"ANTEVORTA DEVELOPERS PRIVATE LIMITED",
"ANTEX PHARMA PRIVATE LIMITED",
"ANTHARAGANGE POWER PRIVATE. LIMITED.",
"ANTHAYYA EDUCATION PRIVATE LIMITED",
"ANTHEA AROMATICS PRIVATE LIMITED",
"ANTHEA PHARMA PRIVATE LIMITED",
"ANTHEIA ENGINEERS PRIVATE LIMITED",
"ANTHELIO BUSINESS TECHNOLOGIES PRIVATE LIMITED",
"ANTHEM BIO PHARMA PRIVATE LIMITED",
"ANTHEM BIOPHARMA PRIVATE LIMITED",
"ANTHEM BIOSCIENCES PRIVATE LIMITED",
"ANTHEM ENERGY INDIA PRIVATE LIMITED",
"ANTHEM GLOBAL TECHNOLOGY SERVICES PRIVATE LIMITED",
"ANTHEM INFRASTRUCTURE PRIVATE LIMITED",
"ANTHEM INFRATECH PRIVATE LIMITED",
"ANTHER VINIMAY PRIVATE LIMITED",
"ANTHILL SPACES PRIVATE LIMITED",
"ANTHIVE TECHNOLOGIES PRIVATE LIMITED",
"ANTHOLOGY INTERNATIONAL PRIVATE LIMITED",
"ANTHONY CLARET SCHOOL",
"ANTHONY GARMENTS PRIVATE LIMITED",
"ANTHRACITE INFRA PRIVATE LIMITED",
"ANTHRAPER WATERWAYS PRIVATE LIMITED",
"ANTHROPOLOGICAL SURVEY OF INDIA",
"ANTHUS PHARMACEUTICALS PRIVATE LIMITED",
"ANTI CORRUPTION BUREAU",
"ANTIA ELECTRICALS PRIVATE LIMITED",
"ANTIALIAS VENTURES PRIVATE LIMITED",
"ANTICLOCK MEDICAL AND RESEARCH PRIVATE LIMITED",
"ANTICORROSIVE EQUIPMENT PRIVATE LIMITED (PART IX)",
"ANTIEK VITRIFIED LLP",
"ANTIFIRE SYSTEM PRIVATE LIMITED",
"ANTILA APPS PRIVATE LIMITED",
"ANTILA CERAMIC PRIVATE LIMITED",
"ANTILA GENERIC MEDICINE PRIVATE LIMITED",
"ANTILA LIFESCIENCES PRIVATE LIMITED",
"ANTILA WELLNESS PRIVATE LIMITED",
"ANTILIA EDUCATION PRIVATE LIMITED",
"ANTILLA DYNAMIC BUSINESS PRIVATE LIMITED",
"ANTILLA LIFECARE PRIVATE LIMITED",
"ANTILLO CONSULTING PRIVATE LIMITED",
"ANTIMU ENGINEERING COMPANY PRIVATE LIMITED",
"ANTINO LABS PRIVATE LIMITED",
"ANTIQA CERAMIC PRIVATE LIMITED",
"ANTIQUARIAT (INDIA) PRIVATE LIMITED",
"ANTIQUE ART EXPORTS PRIVATE. LIMITED.",
"ANTIQUE COTTEX PRIVATE LIMITED",
"ANTIQUE FINANCE PRIVATE LIMITED",
"ANTIQUE FINSEC PRIVATE LIMITED",
"ANTIQUE INDUSTRIES LIMITED",
"ANTIQUE MARBONITE. PRIVATE. LIMITED",
"ANTIQUE NON WOVEN PRIVATE LIMITED",
"ANTIQUE POWER PRIVATE LIMITED",
"ANTIQUE SECURITIES PRIVATE LIMITED",
"ANTIQUE STOCK BROKING LIMITED",
"ANTIQUE TEXTILE PRIVATE LIMITED",
"ANTIZE FOODS PRIVATE LIMITED",
"ANTLIA FINTECH PRIVATE LIMITED",
"ANTLY LOGISTICS PRIVATE LIMITED",
"ANTO NIXON AUTOMOTIVE PRIVATE LIMITED",
"ANTOLINI LUIGI PRIVATE LIMITED",
"ANTON MOTOCORP PRIVATE LIMITED",
"ANTON PAAR INDIA PRIVATE LIMITED",
"ANTONOV WAREHOUSING PARKS PRIVATE LIMITED",
"ANTONOVA TILES (INDIA) PRIVATE LIMITED",
"ANTONY AUTO COACHBUILDERS PRIVATE LIMITED",
"ANTONY COMMERCIAL VEHICLES PRIVATE LIMITED",
"ANTONY GARAGES PRIVATE LIMITED",
"ANTONY INFRASTRUCTURE & WASTE MANAGEMENT SERVICES PRIVATE LIMITED",
"ANTONY LARA ENVIRO SOLUTIONS PRIVATE LIMITED",
"ANTONY LARA RENEWABLE ENERGY PRIVATE LIMITED",
"ANTONY METALS PRIVATE LIMITED",
"ANTONY MOTORS PRIVATE LIMITED",
"ANTONY ROAD TRANSPORT SOLUTION PRIVATE LIMITED",
"ANTONY THOMAS CONTRACTING PRIVATE LIMITED",
"ANTONY WASTE HANDLING CELL LIMITED",
"ANTONY WASTE HANDLING CELL PRIVATE LIMITED",
"ANTOP HILL WAREHOUSING CO LIMITED",
"ANTORDAYA COMMERCIAL AND HOLDINGS PRIVATE LIMITED",
"ANTRA INFO SOLUTIONS PRIVATE LIMITED",
"ANTRA LIGHTING PRIVATE LIMITED",
"ANTRAWEB TECHNOLOGIES PRIVATE LIMITED",
"ANTRAX TECHNOLOGIES PRIVATE LIMITED",
"ANTRIKSH BARTER PRIVATE LIMITED",
"ANTRIKSH DEVELOPERS & PROMOTERS PRIVATE LIMITED",
"ANTRIKSH ENGINEERS AND BUILDERS PRIVATE LIMITED",
"ANTRIKSH TECHNOSYS PRIVATE LIMITED",
"ANTRIX AUTOMATION PRIVATE LIMITED",
"ANTRIX CONSTRUCTION PRIVATE LIMITED",
"ANTRIX CORPORATION LIMITED",
"ANTRIX FINANCIAL ENGINEERS PRIVATE LIMITED",
"ANTRIX HEALTHCARE PRIVATE LIMITED",
"ANTRIX INFRATEL PRIVATE LIMITED",
"ANTRIX TECHINFO PRIVATE LIMITED",
"ANTS CERAMICS PRIVATE LIMITED",
"ANTS CREW ENTERTAINMENT PRIVATE LIMITED",
"ANTS DIGITAL PRIVATE LIMITED",
"ANTS ENTERPRISES PRIVATE LIMITED",
"ANTS GLOBAL SYSTEMS PRIVATE LIMITED",
"ANTS INNOVATIONS PRIVATE LIMITED",
"ANTS LAB EQUIPMENTS PRIVATE LIMITED",
"ANTS4U INTERNATIONAL PRIVATE LIMITED",
"ANTSTACK TECHNOLOGIES PRIVATE LIMITED",
"ANTU EXIM PRIVATE LIMITED",
"ANTUIT INDIA PRIVATE LIMITED",
"ANTUNES NADI MANUFACTURING INDIA PRIVATE LIMITED",
"ANTWORX EXPERIENCE PRIVATE LIMITED",
"ANTZCO RETAIL PRIVATE LIMITED",
"ANTZLAB TECHNOLOGY SERVICES PRIVATE LIMITED",
"ANU ADITYA INFRA PRIVATE LIMITED",
"ANU ADVANCE COMPOSITE PRODUCTS PRIVATE LIMITED",
"ANU AIRCON PRIVATE LIMITED",
"ANU AVENUES PRIVATE LIMITED",
"ANU BUILDERS (INDIA) PRIVATE LIMITED",
"ANU CASHEWS",
"ANU COCO FOOD PRODUCTS PRIVATE LIMITED",
"ANU COLONISERS LIMITED",
"ANU EXTRUSIONS PRIVATE LIMITED",
"ANU FASTENERS PRIVATE LIMITED",
"ANU FERTILITY AND CONTRACEPTION SERVICES AND RESEARCH INSTITUTE PRIVATE LTD",
"ANU FOREX PRIVATE LIMITED",
"ANU HOSPITAL",
"ANU HOSPITALS",
"ANU INDUSTRIES LIMITED",
"ANU INSTITUTE OF NEURO & CARDIAC SCIENCES",
"ANU INSTITUTE OF NEURO AND CARDIAC SCIENCES",
"ANU INTERNATIONAL",
"ANU MY BABY HOSPITALS",
"ANU MY BABY HOSPITALS PRIVATE LIMITED",
"ANU OVERSEAS PRIVATE LIMITED",
"ANU PRODUCTS LIMITED.",
"ANU PROJECTS CONSULTANTS AND ENGINEERS PVT LTD",
"ANU SACHIV BHASHA DEPARTMENT UP GOVT",
"ANU SANTOSH PRINTS PRIVATE LIMITED",
"ANU SOLAR POWER PRIVATE LIMITED",
"ANU WORLES SOLUTIONS PRIVATE LIMITED",
"ANUBANDANA INFRATECH PRIVATE LIMITED",
"ANUBAVAM TECHNOLOGIES PRIVATE LIMITED",
"ANUBHA AUXICHEM PRIVATE LIMITED",
"ANUBHA BRANDS PRIVATE LIMITED",
"ANUBHA CREATIONS",
"ANUBHA FABRICS PRIVATE LIMITED",
"ANUBHA INDUSTRIES PRIVATE LIMITED",
"ANUBHA POLYWEAVES PRIVATE LIMITED",
"ANUBHA SALES INDIA PRIVATE LIMITED",
"ANUBHAV AGROBASE PRIVATE LIMITED",
"ANUBHAV ALUMINIUM WORK PRIVATE LIMITED",
"ANUBHAV APPARELS PRIVATE LIMITED",
"ANUBHAV AUTOS PRIVATE LTD.",
"ANUBHAV BUILDCON PRIVATE LIMITED",
"ANUBHAV COMPUTER INSTITUTE PRIVATE LIMITED",
"ANUBHAV FAB PRIVATE LIMITED",
"ANUBHAV GEMS PRIVATE LIMITED",
"ANUBHAV HOLIDAYS PRIVATE LIMITED",
"ANUBHAV PACKAGING PRIVATE LIMITED",
"ANUBHAV PLAST PRIVATE LIMITED",
"ANUBHAV ROADLINES PRIVATE LIMITED",
"ANUBHAV SERVICES HR PRIVATE LIMITED",
"ANUBHAV TECHNO SOLUTIONS PRIVATE LIMITED",
"ANUBHAV TUBES & CONDUCTORS PRIVATE LIMITED",
"ANUBHAV VACATIONS PRIVATE LIMITED",
"ANUBHOOTI INFRASTRUCTURES PRIVATE LIMITED",
"ANUBHUTI MERCHANDISE PVT LTD",
"ANUBHUTI PROPERTIES PRIVATE LIMITED",
"ANUCON ENGINEERING PROJECTS PRIVATE LIMITED",
"ANUCOOL INDUSTRIAL AIDS PRIVATE LIMITED",
"ANUDAIT SECONDARY ASHRAM SCHOOL JALKHE",
"ANUDANIK PRATHMIK ASHARAM SHALA KOCHARA",
"ANUDANIT NIVASI PRATHMIK SALA BHALADA",
"ANUDANIT PRATHAMIK AASHRAMSHALA GORAMBA",
"ANUDANIT PRATHAMIK SHALA MUKHED",
"ANUDATT VIDYALAYA",
"ANUDIP FOUNDATION FOR SOCIAL WELFARE",
"ANUERA TECHNOLOGIES PRIVATE LIMITED",
"ANUGRAH CONSTRUCTION PRIVATE LIMITED",
"ANUGRAH INORG PRIVATE LIMITED",
"ANUGRAH MADISON ADVERTISING PRIVATE LIMITED",
"ANUGRAH SUGARS PRIVATE LIMITED",
"ANUGRAHA CONSTRUCTION EQUIPMENT SERVICES AND SUPPORT PVT LTD",
"ANUGRAHA FASHION MILL PRIVATE. LIMITED.",
"ANUGRAHA VALVE CASTINGS LIMITED",
"ANUH PHARMA LIMITED",
"ANUHAR HOMES PRIVATE LIMITED",
"ANUJ COLD STORAGE PRIVATE LIMITED",
"ANUJ DAIRY PRIVATE LIMITED",
"ANUJ ELECTRICALS PRIVATE LIMITED",
"ANUJ ELECTRONICS PVT LTD",
"ANUJ INFRAPROJECTS PRIVATE LIMITED",
"ANUJ INSTITUTE PRIVATE LIMITED",
"ANUJ JEWELLERY PRIVATE LIMITED",
"ANUJ MINES MINERALS AND CHEMICALS PRIVATE LIMITED",
"ANUJ RICE MILLS PRIVATE LIMITED",
"ANUJ WOOLLENS PRIVATE LIMITED",
"ANUJA HEALTHCARE LIMITED",
"ANUJAN POLYMERS PRIVATE LIMITED",
"ANUJKSHITIJ CONSTRUCTIONS PRIVATE LIMITED",
"ANUKALP BEVERAGE PRIVATE LIMITED",
"ANUKALP ENGINEERING INDIA PRIVATE LIMITED",
"ANUKAMPA EXPORTS PRIVATE LIMITED",
"ANUKAMPA HOMES PRIVATE LIMITED",
"ANUKAMPA SOFTWARES PRIVATE LIMITED",
"ANUKAR MEDICALS PRIVATE LIMITED",
"ANUKAR PROJECTS PRIVATE LIMITED",
"ANUKARAN FARMER PRODUCER COMPANY LIMITED",
"ANUKI TECHNOLOGIES PRIVATE LIMITED",
"ANUKOOL FABRICS PRIVATE LIMITED",
"ANUKOOL FURNITURE PRIVATE LIMITED",
"ANUKOOL FURNITURE SYSTEMS LIMITED",
"ANUKOOL INDIA PRIVATE LIMITED",
"ANUKOOL TRAVELS PRIVATE LIMITED",
"ANUKOOLAN SOLUTIONS PRIVATE LIMITED",
"ANUKUL AGROTECH PRIVATE LIMITED",
"ANUKUL CHANDRA FOODS PRIVATE LIMITED",
"ANUKUL ENTERPRISES PRIVATE LIMITED",
"ANUKUL POWER ENGINEERS PRIVATE LIMITED",
"ANULIPI TECHNOLOGIES & SYSTEMS PRIVATE LIMITED",
"ANULOK ENGINEERS PRIVATE LIMITED",
"ANUM TECHNO SOLUTIONS PRIVATE LIMITED",
"ANUMAAN WEAVING MILLS PRIVATE LIMITED",
"ANUMALAV INFRASTRUCTURES AND SOLUTIONS PRIVATE LIMITED",
"ANUMANS CONSTRUCTIONS PRIVATE LIMITED",
"ANUMATI CONSULTANCY & SERVICES PVT. LTD.",
"ANUMAY INDUSTRIES PRIVATE LIMITED",
"ANUMAYA INTERIORS PRIVATE LIMITED",
"ANUMEET TECHNOCRATS (INDIA) PRIVATE LIMITED",
"ANUMITA OVERSEAS PRIVATE LIMITED",
"ANUNA EDUCATION NETWORK PRIVATE LIMITED",
"ANUNAY FAB LIMITED.",
"ANUNTA TECHNOLOGY MANAGEMENT SERVICES LIMITED",
"ANUP HOTELS PRIVATE LIMITED",
"ANUP INDUSTRIES PRIVATE LIMITED",
"ANUP INSULATION PRIVATE. LIMITED.",
"ANUP MALLEABLES LTD",
"ANUP PRINTERS PRIVATE LIMITED",
"ANUP TECH EQUIPMENTS PVT LTD",
"ANUP TRADE & TRANSPORT PRIVATE. LIMITED.",
"ANUP TRANSPORT CO",
"ANUPA TRADE LINKS PRIVATE LIMITED",
"ANUPAM ADVISORY PVT.LTD.",
"ANUPAM AQUA PRIVATE LIMITED",
"ANUPAM CNC MACHINING PRIVATE LIMITED",
"ANUPAM COLD STORAGE PVT LTD",
"ANUPAM COLOURS PRIVATE LIMITED",
"ANUPAM DEALERS PVT LTD",
"ANUPAM EATING HOUSE PRIVATE LIMITED",
"ANUPAM ELECTRONICS PRIVATE LIMITED",
"ANUPAM EMPORIUM PRIVATE LIMITED",
"ANUPAM EYE HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED",
"ANUPAM FINSERV LIMITED",
"ANUPAM FUELS PRIVATE LIMITED",
"ANUPAM HEATERS AND CONTROLS PRIVATE LIMITED",
"ANUPAM HYDRO STANDARD PVT LTD",
"ANUPAM INSULTATING INDS PVT LTD",
"ANUPAM JEWELLERS PRIVATE LIMITED",
"ANUPAM MARKETING PVT LTD",
"ANUPAM MOTOR FINANCE LIMITED",
"ANUPAM NIRMAN PRIVATE LIMITED",
"ANUPAM PLASTO ENGINEERING PRIVATE LIMITED",
"ANUPAM PRODUCTS LIMITED",
"ANUPAM RASAYAN INDIA LIMITED",
"ANUPAM RETAIL LIMITED",
"ANUPAM STATIONERY LIMITED",
"ANUPAM STATIONERY SUPERSTORE PRIVATE LIMITED",
"ANUPAM STOCK BROKING PRIVATE LIMITED",
"ANUPAM STUDIO PRIVATE LIMITED",
"ANUPAM TECHNOLOGIES PRIVATE LIMITED",
"ANUPAM TEX PROCESSORS PRIVATE LIMITED",
"ANUPAMA BIO NATURALS PRIVATE LIMITED",
"ANUPAMA DEVCON PRIVATE LIMITED",
"ANUPAMA DEVELOPER PRIVATE LIMITED",
"ANUPAMA HOSPITAL PRIVATE LIMITED",
"ANUPAMA PRINTING SOLUTIONS PRIVATE LIMITED",
"ANUPAMA STEEL LIMITED",
"ANUPAMA VINTRADE PRIVATE LIMITED",
"ANUPARNA HEALTHCARE PRIVATE LIMITED",
"ANUPM DETERGENT & CHEMICALS PRIVATE LIMITED",
"ANUPRA PACKAGING PRIVATE LIMITED",
"ANUPRITI REAL ESTATES PRIVATE LIMITED",
"ANUPRIYA CONSULTANTS PVT LTD",
"ANUPRIYA MARKETING LIMITED",
"ANUPTECH SKILL DEVELOPMENT CENTRE PRIVATE LIMITED",
"ANUPUMA MOTORS PRIVATE LIMITED",
"ANUPURAV RETAIL PRIVATE LIMITED",
"ANUR INVESTMENTS PRIVATE LIMITED",
"ANURA BIOFUELS PRIVATE LIMITED",
"ANURA INFOTECH PRIVATE LIMITED",
"ANURAAG ENGINEERS PRIVATE LIMITED",
"ANURADHA ENTERPRISES PRIVATE LIMITED",
"ANURADHA FINANCIAL SERVICES PRIVATE LIMITED",
"ANURADHA FOODS PRIVATE LIMITED",
"ANURADHA HOLDINGS PRIVATE LIMITED",
"ANURADHA INDUSTRIES PRIVATE LIMITED",
"ANURADHA IRON AND STEEL PRIVATE LIMITED",
"ANURADHA MOBILES PRIVATE LIMITED",
"ANURADHA PICTURES PRIVATE LIMITED",
"ANURADHA STEELS PRIVATE. LIMITED.",
"ANURAG AIR CONDITIONING PRIVATE LIMITED",
"ANURAG ARCHTECTURAL ASSOCIATES PRIVATE LIMITED",
"ANURAG BROTHERS TRADING PRIVATE LIMITED",
"ANURAG COAL TRANSPORT PRIVATE LIMITED",
"ANURAG ELECTRONICS - GUJARAT - PRIVATE LIMITED",
"ANURAG ENGINEERING COLLEGE",
"ANURAG FINVEST PVT LTD",
"ANURAG GROUP OF INSTITUTIONS CVSR COLEGE OF ENGINEERING",
"ANURAG HEALTHCARE PRIVATE LIMITED",
"ANURAG MANUFACTURING AND AGENCIES PRIVATE LIMITED",
"ANURAG PHARMACEUTICALS PRIVATE LIMITED",
"ANURAG PLASTOCRAFTS PRIVATE LIMITED",
"ANURAG PROJECTS MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"ANURAG RESORT PRIVATE LIMITED",
"ANURAG STRUCTURALS PRIVATE LIMITED",
"ANURAG UNIVERSITY",
"ANURAJ FRAGRANCES PRIVATE LIMITED",
"ANURAJ REAL ESTATES PRIVATE LIMITED",
"ANURAJ SUGARS LIMITED",
"ANURANJAN INFRATECH RESOURCES PRIVATE LIMITED",
"ANURASHI COMMOTRADE PVT LTD",
"ANURODH BUILDERS PRIVATE LIMITED LTD",
"ANURODH EXIM PRIVATE LIMITED",
"ANURON ENTERPRISES PRIVATE LIMITED",
"ANUROOP MATCHING CENTRE PRIVATE LIMITED",
"ANUROOP PACKAGING LIMITED",
"ANURUP DESIGNS PRIVATE LIMITED",
"ANUSANDHAN COMMOTRADE PVT.LTD.",
"ANUSANDHAN TRUST",
"ANUSANG ENTERPRISES PRIVATE LIMITED",
"ANUSAYA AUTO PRESS PARTS PRIVATE LIMITED",
"ANUSAYA FRESH INDIA PRIVATE LIMITED",
"ANUSH SHARES AND SECURITIES PRIVATE LIMITED",
"ANUSHA (INDIA) PRIVATE LIMITED",
"ANUSHA AGENCIES PRIVATE LIMITED",
"ANUSHA HOSPITALITY SERVICES PRIVATE LIMITED",
"ANUSHA PROJECTS PRIVATE LIMITED",
"ANUSHA TECHNOVISION PRIVATE LIMITED",
"ANUSHAKTI ENTERPRISE PRIVATE LIMITED",
"ANUSHAKTI VIDHYUT NIGAM LIMITED",
"ANUSHAM AUTOMOTIVE INDIA PRIVATE LIMITED",
"ANUSHIKHA INVESTMENTS PVT LTD",
"ANUSHKA AUTOMOTIVE PRIVATE LIMITED",
"ANUSHKA BIOTECH PRIVATE LIMITED",
"ANUSHKA BRAND PROMOTION & EVENT PRIVATE LIMITED",
"ANUSHKA CHAINS AND ORNAMENTS PRIVATE LIMITED",
"ANUSHKA COMPUTECH PRIVATE LIMITED",
"ANUSHKA CONSTRUCTIONS PRIVATE LIMITED",
"ANUSHKA INDUSTRIES PRIVATE LIMITED",
"ANUSHKA INFRASTRUCTURE PRIVATE LIMITED",
"ANUSHKAA FOUNDATION FOR ELIMINATING CLUBFOOT",
"ANUSHNA ESTATES PRIVATE LIMITED",
"ANUSHREE BUILDCON PRIVATE LIMITED",
"ANUSHREE COLD STORAGE PRIVATE LIMITED",
"ANUSHREE ELECTRICAL ENGINEERS PRIVATE LIMITED",
"ANUSHREE INFRAPROJECTS PRIVATE LIMITED",
"ANUSHREE INFRASTRUCTURE PRIVATE LIMITED",
"ANUSHREE SAREES PRIVATE LIMITED",
"ANUSHREE SECURITIES PRIVATE LIMITED",
"ANUSHREE TEXTILES PRIVATE LIMITED",
"ANUSHREYA INVESTMENTS PVT LTD",
"ANUSHRI PAPER PACK PRIVATE LIMITED",
"ANUSHRI SYSTECH PRIVATE LIMITED",
"ANUSIKA INDUSTRIES LIMITED",
"ANUSKA ENGINEERING WORKS PRIVATE LIMITED",
"ANUSKA JEWELLERS PRIVATE LIMITED",
"ANUSPA HERITAGE PRODUCTS PRIVATE LIMITED",
"ANUSRI HAPPY HOMES INDIA PRIVATE LIMITED",
"ANUSTUP TRADING PRIVATE LIMITED",
"ANUSUIYA CAPITAL PRIVATE LIMITED",
"ANUSUYA AGRO INFRATECH PRIVATE LIMITED",
"ANUSWARYAA ENTERPRISES PRIVATE LIMITED",
"ANUTA NETWORKS PRIVATE LIMITED",
"ANUTEJ RECREATIONS AND RESORTS PRIVATE LIMITED",
"ANUTESH ESTATES PRIVATE LIMITED",
"ANUTHAM EXIM PRIVATE LIMITED",
"ANUTHAM TRAINERS INDIA PRIVATE LIMITED",
"ANUTONE ACOUSTICS LIMITED",
"ANUTTAMA TRADING PRIVATE LIMITED",
"ANUTTAMA WELLNESS PRIVATE LIMITED",
"ANUTTAR ADVISORY PRIVATE LIMITED",
"ANUTTARA MEDICAL SOLUTIONS PRIVATE LIMIT",
"ANUV ROYAL PLASTIC PRIVATE LIMITED",
"ANUVA RESOURCE SOLUTIONS INDIA PRIVATE LIMITED",
"ANUVARTHH APPARELS PRIVATE LIMITED",
"ANUVEDA LIFE SCIENCES PRIVATE LIMITED",
"ANUVEGA TECHNOLOGIES PRIVATE LIMITED",
"ANUVI CHEMICALS LIMITED",
"ANUVIDYUT PRIVATE LIMITED",
"ANUVRAT TEXTILES PRIVATE LIMITED",
"ANUWRITA REALTY PRIVATE LIMITED",
"ANUYOG HOSPITAL AND RESEARCH CENTER PRIVATE LIMITED",
"ANV DIGI SOLUTIONS PRIVATE LIMITED",
"ANV INDUSTRIES LIMITED",
"ANV PROJECTS INDIA PRIVATE LIMITED",
"ANVA LOGISTICS PRIVATE LIMITED",
"ANVAL VALVES PRIVATE LIMITED",
"ANVAM INDIA PRIVATE LIMITED",
"ANVARAT INDIA ENTERPRISES PRIVATE LIMITED",
"ANVASE EXIM PRIVATE LIMITED",
"ANVATION LABS PRIVATE LIMITED",
"ANVAY IT SOLUTIONS PRIVATE LIMITED",
"ANVAY PHARMA SYSTEMS PRIVATE LIMITED",
"ANVAYA CONSTRUCTION CONSULTANCY PRIVATE LIMITED",
"ANVAYA CONVENTIONS LLP",
"ANVAYAA KIN CARE PRIVATE LIMITED",
"ANVESHAN FARM TECHNOLOGIES PRIVATE LIMITED",
"ANVESHAN TEXTILE LIMITED",
"ANVETA CONSULTING PRIVATE LIMITED",
"ANVEYA LIVING PRIVATE LIMITED",
"ANVI LIFESCIENCES PRIVATE LIMITED",
"ANVI MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"ANVI METALS INDIA PRIVATE LIMITED",
"ANVI METCORP PRIVATE LIMITED",
"ANVI PHARMACEUTICALS PRIVATE LIMITED",
"ANVI PUBLISHING PRIVATE LIMITED",
"ANVI TECHNICAL ADVISORS INDIA PRIVATE LIMITED",
"ANVI TRADING PRIVATE LIMITED",
"ANVIAM SOLUTIONS PRIVATE LIMITED",
"ANVICURE DRUGS PRIVATE LIMITED",
"ANVIDHA TECHNOLOGIES PRIVATE LIMITED",
"ANVIKA ENTERPRISES PRIVATE LIMITED",
"ANVIKA HOSPITALS",
"ANVIL ELECTRICALS PRIVATE LIMITED",
"ANVIL FINTRADE PRIVATE LIMITED",
"ANVIL FORGE PRIVATE LIMITED",
"ANVIL ORE INDIA PRIVATE LIMITED",
"ANVIL REAL ESTATE ANALYTICS PRIVATE LIMITED",
"ANVIL SHARE AND STOCK BROKING PRIVATE LIMITED",
"ANVIL WEALTH MANAGEMENT PRIVATE LIMITED",
"ANVIN ENGINEERS PRIVATE LIMITED",
"ANVIRA SOLUTIONS PRIVATE LIMITED",
"ANVIS DIGITAL PRIVATE LIMITED",
"ANVIS LABORATORIES PRIVATE LIMITED",
"ANVIS MERCANTILE PRIVATE LIMITED",
"ANVISHA SUGAR ENGINEERING PRIVATE LIMITED",
"ANVISTAR TRADELINK PRIVATE LIMITED",
"ANVIT LAMINATORS PRIVATE LIMITED",
"ANVIT SURFACTANT",
"ANVITA CONSTRUCTIONS (INDIA) PRIVATE LIMITED",
"ANVITA TRADING COMPANY PRIVATE LIMITED",
"ANVITECH PRECISION ENGINEERING PRIVATE LIMITED",
"ANVITHA LIFE CARE PRIVATE LIMITED",
"ANVITHA STEELS PRIVATE LIMITED",
"ANWAR UL ULOOM WOMENS COLLEGE",
"ANWARI NELOFER GIRLS INTERMEDIATE COLLEGE",
"ANWARUL ULOOM COLLEGE",
"ANWAU-UL-ULOOM COLLEGE",
"ANWITA BHATI CONTRACTOR PRIVATE LIMITED",
"ANWITA DRUGS & CHEMICALS PRIVATE LIMITED",
"ANY WAY LANDMARK PRIVATE LIMITED",
"ANYA COMPOSITES PRIVATE LIMITED",
"ANYA ENTERPRISES EXIM PRIVATE LIMITED",
"ANYA POLYTECH & FERTILIZERS LIMITED",
"ANYA POLYTECH PRIVATE LIMITED",
"ANYA SECURITY PRIVATE LIMITED",
"ANYAM INDUSTRIAL SOLUTIONS PRIVATE LIMITED",
"ANYCAST TECHNOLOGY PRIVATE LIMITED",
"ANYGLOBAL SERVICES INNOVATION PRIVATE LIMITED",
"ANYONE HOME IT SERVICES PRIVATE LIMITED",
"ANYTHING MAC PRIVATE LIMITED",
"ANYTIME LOGISTIC PRIVATE LIMITED",
"ANYTIME NATURE FOODS LLP",
"ANYTIMEMONEY PRIVATE LIMITED",
"ANZ OPERATIONS AND TECHNOLOGY PRIVATE LIMITED",
"ANZ SECURITY & INFRA PRIVATE LIMITED",
"ANZ SUPPORT SERVICES INDIA PRIVATE LIMITED",
"ANZA BUSINESS SOLUTIONS PRIVATE LIMITED",
"ANZA MEDICODE INDIA PRIVATE LIMITED",
"ANZEN AUTOMOTIVE PRIVATE LIMITED",
"ANZEN EXPORTS PRIVATE LIMITED",
"ANZEN INSURANCE BROKING PRIVATE LIMITED",
"ANZEN MOTOR CAR INDIA PRIVATE LIMITED",
"ANZEN PROJECTS PRIVATE LIMITED",
"ANZERA PROPERTIES PRIVATE LIMITED",
"ANZO CONTROLS PRIVATE LIMITED",
"ANZU TECHNOLOGIES PRIVATE LIMITED",
"ANZY CAREERS PRIVATE LIMITED",
"AO AND DDO CCIT SURAT",
"AO COMM OF IT ITAT NAGPUR",
"AO DIVISION VIII CGST AND CENTRAL EXCISE MUMBAI CENTRAL",
"AO FOR SECRETARY MP BAL ADHIKAR SANRAKCHAN AYOG",
"AO GOVT MP LAW AND LEGISLATIVE AFFAIRS BHOPAL",
"AO INDORE IV DIVISION CGST COMMISSIONERATE INDORE",
"AO O/O THE DIR GEN NATIONAL ACAD OF DIRECT TAXES NAGPUR",
"AOA CONSULTANTS PRIVATE LIMITED",
"AOC INDIA PRIVATE LIMITED",
"AO-G DEVELOPERS PRIVATE LIMITED",
"AOHUA MOBILE INDIA PRIVATE LIMITED",
"AOJ MEDIA PRIVATE LIMITED",
"AOL ONLINE INDIA PRIVATE LIMITED",
"AOM STANDARD DAIRY AND AGROVET OPC PRIVATE LIMITED",
"AOMAN SERVICES PRIVATE LIMITED",
"AOMBRAY ELECTRIC VEHICLE PRIVATE LIMITED",
"AON CONSULTING PRIVATE LIMITED",
"AON ENGINEERS AND CONSULTANTS PRIVATE LIMITED",
"AON FINTECH PRIVATE LIMITED",
"AON INDIA INSURANCE BROKERS PRIVATE LIMITED",
"AON INDIA LIMITED",
"AON SERVICES INDIA PRIVATE LIMITED",
"AON TEXTILES PRIVATE LIMITED",
"A-ONE AGRICULTURE AND ALLIED ACTIVITIES PRIVATE LIMITED",
"AONE AGRO PRODUCTS PRIVATE LIMITED",
"AONE BAR PRIVATE LIMITED",
"A-ONE BIOTECH & TISSUE CULTURE PRIVATE LIMITED",
"A-ONE CHEM-TRADE PRIVATE LIMITED",
"A-ONE COATINGS PRIVATE LIMITED",
"A-ONE COMPUTERS PRIVATE LIMITED",
"A-ONE CONTAINERS PRIVATE LIMITED",
"A-ONE ELECTROMECH PRIVATE LIMITED.",
"A-ONE ENERGIES PRIVATE LIMITED",
"AONE EXPLORATION PRIVATE LIMITED",
"A-ONE EXTRUSION PRIVATE LIMITED",
"A-ONE FIBERS PRIVATE LIMITED",
"A-ONE FOOT ARTS PRIVATE LIMITED",
"A-ONE JEWELLERS (INDIA )PRIVATE LIMITED",
"A-ONE LAMINATORS PRIVATE LIMITED",
"A-ONE NUTS AND EDIBLES PRIVATE LIMITED",
"AONE OUTSOURCING SOLUTIONS PRIVATE LIMITED",
"AONE PHARMA AND SURGICALS PRIVATE LIMITED",
"A-ONE PHTHALO COLORS PRIVATE LIMITED",
"A-ONE POLYPIPES & FITTINGS PRIVATE LIMITED",
"A-ONE SANDS PRIVATE LIMITED",
"A-ONE SHELTERS PRIVATE LIMITED",
"AONE STAFFING PRIVATE LIMITED",
"A-ONE STEEL AND ALLOYS PRIVATE LIMITED",
"A-ONE TYRES PRIVATE LIMITED",
"AONN ENERGY & CONTROLS PRIVATE LIMITED",
"AOP WEBWORLD PRIVATE LIMITED",
"AOR LOGISTICS PRIVATE LIMITED",
"AORATAS TECHNICA ENGINEERING PRIVATE LIMITED",
"AORBORC TECHNOLOGIES PRIVATE LIMITED",
"AORTA HEALTH CARE PRIVATE LIMITED",
"AOS AGRO FOODS PRIVATE LIMITED",
"AOS PRODUCTS PRIVATE LIMITED",
"AOSTA INDIA PRIVATE LIMITED",
"AOSTA SOFTWARE TECHNOLOGIES INDIA LIMITED",
"AOSTAF INDUSTRIES LIMITED",
"AOT INDIA PRIVATE LIMITED",
"AOT TECHNOLOGIES PRIVATE LIMITED",
"AOTWO WEB AND TECHNOLOGY PRIVATE LIMITED",
"AOV AGRO FOODS PRIVATE LIMITED",
"AOV EXPORTS PRIVATE LIMITED",
"AOV FOREX PRIVATE LIMITED",
"AOV INTERNATIONAL LLP",
"AOZORA ENTERPRISES",
"AP 9 BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"AP AGRICULTURAL UNIVERSITY",
"AP CLEARING AGENCY PRIVATE LIMITED",
"AP COMPETENT ENGINEERS PRIVATE LIMITED",
"AP CORPORATION FOR OUTSOURCED SERVICES",
"AP GARMENTS PRIVATE LIMITED",
"AP GOLDEN APPARELS PRIVATE LIMITED",
"AP GOVT VETINARY HOSPITAL",
"AP INTER COLLEGE",
"AP LOGISTICS INDIA PRIVATE LIMITED",
"AP RESIDENCY PRIVATE LIMITED",
"AP RUBBER RECLAIMERS PRIVATE LIMITED",
"AP SPICA INTERNATIONAL PRIVATE LIMITED (OPC)",
"AP STATE GOVERNMENT EMPLOYEES",
"AP TECHPINS PRIVATE LIMITED",
"AP TRADE MARKETING PRIVATE LIMITED",
"AP TRANSCO",
"AP TRANSMISSION SPARES PRIVATE LIMITED",
"AP TULSYAN PROPERTIES PRIVATE LIMITED",
"AP TYAGARAJA MUSIC COLLEGE",
"AP VISION DESIGN & PRINTS PRIVATE LIMITED",
"APA CONSTRUCTIONS PVT LTD",
"APA DECOR PRIVATE LIMITED",
"APA ENGINEERING PRIVATE LIMITED",
"APA HOTELS PRIVATE LIMITED",
"APA INFRAESTATE PRIVATE LIMITED",
"APA RANGERS PRIVATE LIMITED",
"APAAR INFRABUILD PRIVATE LIMITED",
"APAAR INFRATECH PRIVATE LIMITED",
"APAAR PACKAGING PRIVATE LIMITED",
"APAC BUSINESS SOLUTIONS PRIVATE LIMITED",
"APAC CONSULTANTS PRIVATE LIMITED",
"APAC DIGITAL INNOVATION NEWS NETWORK PRIVATE LIMITED",
"APAC FINANCIAL SERVICES PRIVATE LIMITED",
"APAC HOUSING FINANCE PRIVATE LIMITED",
"APAC INSURANCE BROKING SERVICES (I) PRIVATE LIMITED",
"APAC MARINE SERVICES PRIVATE LIMITED",
"APAC SOURCING SOLUTIONS LIMITED",
"APAC VENTURES I PRIVATE LIMITED",
"APACE APPARELS AND EQUIPMENTS PRIVATE LIMITED",
"APACE BUILDERS AND CONTRACTERS PRIVATE LIMITED",
"APACE IMAGING & DIAGNOSTIC CENTRE PRIVATE LIMITED",
"APACE LIFE SCIENCES PRIVATE LIMITED",
"APACE RENT A CAR PRIVATE LIMITED",
"APACE TRANSCO PRIVATE LIMITED",
"APACHE DESIGN SOLUTIONS PRIVATE LIMITED",
"APACHE FACILITIES MANAGEMENT PRIVATE LIMITED",
"APACHE FOOTWEAR INDIA PRIVATE LIMITED",
"APACHE SEZ DEVELOPMENT INDIA PRIVATE LIMITED",
"APAHA WATER INFRASTRUCTURE PRIVATE LIMITED",
"APAK INDUSTRIES PRIVATE LIMITED",
"APAK SOLUTIONS PRIVATE LIMITED",
"APAK TECHNOFILMS PRIVATE LIMITED",
"APAL MANAGEMENT SERVICES PRIVATE LIMITED",
"APAN CARBON PRIVATE LIMITED",
"APAN IMEX PRIVATE LIMITED",
"APANA FINVEST PRIVATE LIMITED",
"APANA HARDWARE SUPPLIERS PRIVATE LIMITED",
"APANA LOGISTICS PRIVATE LIMITED",
"APANA TRUNK FACTORY PRIVATE LIMITED",
"APANI SAHELI PRODUCER COMPANY LIMITED",
"APAP TRADING PRIVATE LIMITED",
"APAR CORPORATION PRIVATE LIMITED",
"APAR DISTRIBUTION & LOGISTICS PRIVATE LIMITED",
"APAR INDUSTRIES LIMITED",
"APAR INNOSYS LLP",
"APAR OVERSEAS PRIVATE LIMITED",
"APAR PEOPLEWORLD SOFTWARE SERV PRIVATE LIMITED",
"APAR TECHNOLOGIES PRIVATE LIMITED",
"APAR TRANSMISSION & DISTRIBUTION PROJECTS PRIVATE LIMITED",
"APARAA DIGITAL PRIVATE LIMITED",
"APARAA INDUSTRIES PRIVATE LIMITED",
"APARAA INFOTECH INDIA PRIVATE LIMITED",
"APARAJEET POLYMERS PRIVATE LIMITED",
"APARAJITA BUSINESS VENTURE PRIVATE LIMITED",
"APARAJITHA CORPORATE SERVICES PRIVATE LIMITED",
"APARAJITHA DYNAMIC SYNERGIES PRIVATE LIMITED",
"APARAJITHA SOFTWARE SERVICES PRIVATE LIMITED",
"APARAMOUS SOLUTIONS PRIVATE LIMITED",
"APARC ATTRACTIONS PRIVATE LIMITED",
"APARC HEALTHCARE PRIVATE LIMITED",
"APARNA AGENCY PRIVATE LIMITED",
"APARNA ARCHITECT AND ENGICONS PRIVATE LIMITED",
"APARNA CARBONS PRIVATE. LIMITED.",
"APARNA CONSTRUCTION PVT LTD",
"APARNA CONSTRUCTIONS AND ESTATES PRIVATE LIMITED",
"APARNA CONTROLS PRIVATE LIMITED",
"APARNA CRAFT EXTERIORS PRIVATE LIMITED",
"APARNA DISTRIBUTORS PVT LTD",
"APARNA ENTERPRISES LIMITED",
"APARNA FOODS PRIVATE LIMITED",
"APARNA HOUSING AND CONSTRUCTION PRIVATE LIMITED",
"APARNA INDUSTRIES & SOLUTIONS PRIVATE LIMITED",
"APARNA INFRA BUILDERS PRIVATE LIMITED",
"APARNA INFRAHOUSING PRIVATE LIMITED (PART IX )",
"APARNA LABELS PRIVATE LIMITED",
"APARNA MARINE EXPORTS",
"APARNA ORGANICS LIMITED",
"APARNA OVERSEAS INDIA PRIVATE LIMITED",
"APARNA PACKAGING CO.PRIVATE LIMITED",
"APARNA PAPER PROCESSING INDUSTRY PVT LTD",
"APARNA PHARMACEUTICALS PRIVATE LIMITED",
"APARNA POLYPLAST PRIVATE LIMITED",
"APARNA PROFILES PRIVATE LIMITED",
"APARNA PROPERTY MANAGEMENT SERVICES PRIVATE LIMITED",
"APARNA TOOLS AND COMPONENTS PRIVATE LIMITED",
"APARNA TRANSMISSION PRIVATE LIMITED",
"APARNAA HANDLOOMS PRIVATE LIMITED",
"APARNAA SAREES PVT LTD",
"APARUPA PPROPERTIES PRIVATE LIMITED",
"APATHAM EDUCATIONAL SERVICES PRIVATE LIMITED",
"APATICS INDIA PRIVATE LIMITED",
"APAV HEALTHCARE PRIVATE LIMITED",
"APAVE ASSESSMENTS INDIA PRIVATE LIMITED",
"APAVI TRADING PRIVATE LIMITED",
"APAX PARTNERS INDIA ADVISERS PRIVATE LIMITED",
"APAY MARKETING PRIVATE LIMITED",
"APAZUC (OPC) PRIVATE LIMITED",
"APB ENGINEERING PROJECTS INDIA PRIVATE LIMITED",
"APB INFFRASTRUCTURE PRIVATE LIMITED",
"APBC PRINT PROVIDERS PRIVATE LIMITED",
"APC AIR SYSTEMS PRIVATE LIMITED",
"APC ALUMINIUM PRIVATE LIMITED",
"APC COLLEGE OF COMMERCE",
"APC DRILLING & CONSTRUCTION PRIVATE. LIMITED.",
"APC DRILLING PRIVATE. LIMITED.",
"APC ENGINEERS & CONSULTANTS PRIVATE LIMITED",
"APC ENGINEERS PRIVATE LIMITED",
"APC IMPEX PRIVATE LIMITED",
"APC IMPORTS PRIVATE LIMITED",
"APC NUTRIENTS PRIVATE LIMITED",
"APC PHARMACEUTICALS AND CHEMICALS PRIVATE LIMITED",
"APCA POWER PRIVATE LIMITED",
"APCER LIFE SCIENCES INDIA LIMITED",
"APCO ARASAVALLI EXPRESSWAY PRIVATE LIMITED",
"APCO AUTOMOBILES PRIVATE LIMITED",
"APCO AUTOSALES PRIVATE LIMITED",
"APCO CARS PRIVATE LIMITED",
"APCO CHEMICALS PRIVATE LIMITED",
"APCO CHETAK EXPRESSWAY PRIVATE LIMITED",
"APCO CHETAK ULTRAWAY PRIVATE LIMITED",
"APCO CONTROL DEVICES PRIVATE LIMITED",
"APCO DYE CHEM PRIVATE LIMITED",
"APCO EXIM PRIVATE LIMITED",
"APCO INFRATECH PRIVATE LIMITED",
"APCO INNOVATIVE AUTO PRIVATE LIMITED",
"APCO MAGADH EXPRESSWAY PRIVATE LIMITED",
"APCO MOTOLINK PRIVATE LIMITED",
"APCO MOTORS INDIA PRIVATE LIMITED",
"APCO NAVKALYAN EXPRESSWAY PRIVATE LIMITED",
"APCO PHARMA LIMITED",
"APCO SHRI AMARNATHJI TUNNELWAY PRIVATE LIMITED",
"APCO VEHICLES INDIA PRIVATE LIMITED",
"APCO VIKRAMSHILA EXPRESSWAY PRIVATE LIMITED",
"APCO WORLDWIDE INDIA PRIVATE LIMITED",
"AP-COATED DRUMS AND BARRELS PRIVATE LIMITED",
"APCOLITE POLYMERS PRIVATE LIMITED",
"APCON INFRATECH PRIVATE LIMITED",
"APCON LINKERS FREIGHT SOLUTIONS PRIVATE LIMITED",
"APCOS NATURALS PRIVATE LIMITED",
"APCOTEX INDUSTRIES LIMITED",
"APD ENGINEERS PRIVATE LIMITED",
"APD FOODS INDIA PRIVATE LIMITED",
"APECO INFRASTRUCTURE (INDIA) PRIVATE LIMITED",
"APEDGI TECHNOLOGIES PRIVATE LIMITED",
"APEE AUTOMOBILES PRIVATE LIMITED",
"APEE ESKAY ENTERPRISES PRIVATE LIMITED",
"APEEJAY COLLEGE OF FINE ARTS",
"APEEJAY EDUCATION ASSOCIATION PVT. LTD.",
"APEEJAY GLOBAL INDUSTRIAL AND LOGISTIC PARK LIMITED",
"APEEJAY HOTELS & RESTAURANTS PRIVATE LIMITED",
"APEEJAY HOUSE PRIVATE LIMITED",
"APEEJAY INDUSTRIES PVT LTD",
"APEEJAY INFRACON PRIVATE LIMITED",
"APEEJAY LOGISTICS PARK PRIVATE LIMITED",
"APEEJAY OXFORD BOOKSTORES PRIVATE LIMITED",
"APEEJAY PRIVATE LIMITED",
"APEEJAY SCHOOL",
"APEEJAY SCHOOL OF MANAGEMENT",
"APEEJAY SECURITIES PRIVATE.LIMITED",
"APEEJAY SHIPPING LIMITED",
"APEEJAY STYA EDUCATION FOUNDATION",
"APEEJAY STYA HEALTHCARE PVT LTD",
"APEEJAY SURRENDRA MANAGEMENT SERVICES PRIVATE LIMITED",
"APEEJAY SURRENDRA PARK HOTELS LIMITED",
"APEEJAY TEA LIMITED",
"APEETEX FABRICS PRIVATE LIMITED",
"APEIRON ENERGY & ENGINEERING PRIVATE LIMITED",
"APEIRON GLOBAL PRIVATE LIMITED",
"APEIRON HEALTHCARE PRIVATE LIMITED",
"APEIRON MANAGEMENT PRIVATE LIMITED",
"APEIRON PROJECTS PRIVATE LIMITED",
"APEIRON STEEL BUILDINGS PRIVATE LIMITED",
"APEIRON TRAVELS PRIVATE LIMITED",
"APEKSHA APPAREL PRIVATE LIMITED",
"APEKSHA FINVEST PVT LTD",
"APEKSHA GOURMET JAR PRIVATE LIMITED",
"APEKSHA HOUSING PRIVATE LIMITED",
"APEKSHA INFRAPROJECTS PRIVATE LIMITED",
"APELLON BIOTECH PRIVATE LIMITED",
"APELO CONSULTING PRIVATE LIMITED",
"APERTUM ONLINE PRIVATE LIMITED",
"APEX ACTSOFT TECHNOLOGIES PRIVATE LIMITED",
"APEX AGENCIES PRIVATE LIMITED",
"APEX AIM PRIVATE LIMITED",
"APEX AIRCARE PRIVATE LIMITED",
"APEX ALLOY STEEL PRIVATE LIMITED",
"APEX ALUMINIUM EXTRUSION PRIVATE. LIMITED.",
"APEX ANALYTIX TECHNOLOGY PRIVATE LIMITED",
"APEX AQUA AGENCIES (INDIA) PRIVATE LIMITED",
"APEX ASIA PACIFIC PRIVATE LIMITED",
"APEX AUTO",
"APEX AUTO PRIVATE LIMITED",
"APEX AUTOLINKS PRIVATE LIMITED",
"APEX BIO SCIENCES",
"APEX BIOCHEMICAL EXPORTS PRIVATE LIMITED",
"APEX BIOTECHNOLOGIES PRIVATE LIMITED",
"APEX BRIGHT BARS CBE PRIVATE LIMITED",
"APEX BUILDTECH LIMITED",
"APEX BUILDWELL PRIVATE LIMITED",
"APEX CABS PRIVATE LIMITED",
"APEX CAPITAL AND FINANCE LIMITED",
"APEX CARE HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED",
"APEX CHEMICALS INDIA PRIVATE LIMITED",
"APEX CHROMATOGRAPHY PRIVATE LIMITED",
"APEX CLUBS INDIA PRIVATE LIMITED",
"APEX COCO AND SOLAR ENERGY LIMITED",
"APEX CONSTRUCTION",
"APEX COPPER TRADE PRIVATE LIMITED",
"APEX CORPORATION INDIA PRIVATE LIMITED",
"APEX COVANTAGE INDIA PRIVATE LIMITED",
"APEX DAIRY TECHNOLOGY INDIA PRIVATE LIMITED",
"APEX DIALYSIS TECHNOLOGIES PRIVATE LIMITED",
"APEX DREAM HOMES PRIVATE LIMITED",
"APEX ECOTECH PRIVATE LIMITED",
"APEX ELECTROWORLD PRIVATE LIMITED",
"APEX ENERGY PRIVATE LIMITED",
"APEX ENERGY RESOURCES PRIVATE LIMITED",
"APEX EXPRESS TRANSCO PRIVATE LIMITED",
"APEX EXTRUSIONS PRIVATE LIMITED",
"APEX FIBRE INDIA LIMITED",
"APEX FIRE PROTECTION PRIVATE LIMITED",
"APEX FLEXIPACK PRIVATE LIMITED",
"APEX FLUIDOMATICS PRIVATE LIMITED",
"APEX FOAMS INDIA PRIVATE LIMITED",
"APEX FORMULATIONS PRIVATE LIMITED",
"APEX FREIGHT SYSTEM PRIVATE LIMITED",
"APEX FROZEN FOODS PRIVATE LIMITED",
"APEX FUELS PRIVATE LIMITED",
"APEX FUND SERVICES LLP",
"HCG ONCOLOGY HOSPITALS LLP",
"APEX HEALTHCARE LIMITED",
"APEX HEART CARE PRIVATE LIMITED",
"APEX HEART HOSPITAL PRIVATE LIMITED",
"APEX HEART INSTITUTE",
"APEX HEIGHTS PRIVATE LIMITED",
"APEX HOMENEEDS PRIVATE LIMITED",
"APEX HOMES PRIVATE. LIMITED.",
"APEX HOSPITAL MANSAROVAR PRIVATE LIMITED",
"APEX HOSPITAL PRIVATE LIMITED",
"APEX HOSPITALS PRIVATE LIMITED",
"APEX HOSPITEX AND NEUROSCIENCE PRIVATE LIMITED",
"APEX HVAC SERVICES PRIVATE LIMTED",
"APEX INDIA CONSORTIUM PRIVATE LIMITED",
"APEX INDIA ENTERPRISES PRIVATE LIMITED",
"APEX INDIA LIMITED",
"APEX INDUSTRIAL PRODUCTS PRIVATE LIMITED",
"APEX INDUSTRIES PRIVATE LIMITED",
"APEX INFOCOM TECHNOLOGY PRIVATE LIMITED",
"APEX INFOVISION PRIVATE LIMITED",
"APEX INFRALINK LIMITED",
"APEX INFRANET PRIVATE LIMITED",
"APEX INFRA-TECH PRIVATE LIMITED",
"APEX INFRAVENTURES PRIVATE LIMITED",
"APEX INSURANCE BROKING SERVICES PRIVATE LIMITED",
"APEX INSURANCE CONSULTANT LIMITED",
"APEX INTERGLOBAL PRIVATE LIMITED",
"APEX INTERNATIONAL SCHOOL",
"APEX ISPAT PRIVATE LIMITED",
"APEX IT SERVICES",
"APEX JOB SOLUTION PRIVATE LIMITED",
"APEX JUNIOR COLLEGE",
"APEX KIDNEY CARE PRIVATE LIMITED",
"APEX KNIVES PRIVATE LIMITED",
"APEX LABORATORIES PRIVATE LIMITED",
"APEX LIQUORS PRIVATE LIMITED",
"APEX LOGISTICS",
"APEX LOGISTICS C/O LARSEN & TOUBRO LIMITED",
"APEX LUBES & FUELS INDIA PRIVATE LIMITED",
"APEX LUBRICANTS PRIVATE LIMITED",
"APEX LUMINAIRES PRIVATE LIMITED",
"APEX MARINE SERVICES PRIVATE LIMITED",
"APEX MATCH CONSORTIUM (INDIA) PRIVATE LIMITED",
"APEX MEADOWS PRIVATE LIMITED",
"APEX MEDICAL SYSTEMS PRIVATE LIMITED",
"APEX MEDICARE PRIVATE LIMITED",
"APEX MEDICHEM PRIVATE LIMITED",
"APEX MEDIEQUIP PRIVATE LIMITED",
"APEX MEDITECH SERVICES PRIVATE LIMITED",
"APEX MEGAPROJECTS PRIVATE LIMITED",
"APEX METAL CHEM PRIVATE LIMITED",
"APEX METAL ENGINEERING PRIVATE LIMITED",
"APEX METCHEM PRIVATE LIMITED",
"APEX PACKING PRODUCTS PRIVATE LIMITED",
"APEX PHARMACHEM PRIVATE LIMITED",
"APEX PIPING SYSTEMS PRIVATE LIMITED",
"APEX POLYMERS PRIVATE LIMITED",
"APEX POLYTEX PRIVATE LIMITED",
"APEX POWER CONTROLS PRIVATE LIMITED",
"APEX POWER TOOLS INDIA PRIVATE LIMITED",
"APEX PRECISION MECHATRONIX PRIVATE LIMITED",
"APEX PRODUCTS PRIVATE LIMITED UNIT NATIONAL PRINTERS",
"APEX PROJECT SOLUTIONS PRIVATE LIMITED",
"APEX PROJECTS INDIA PRIVATE LIMITED",
"APEX REALCON PRIVATE LIMITED",
"APEX REALTY MANAGEMENT PRIVATE LIMITED",
"APEX RESEARCH CENTRE AND HOSPITALS PRIVATE LIMITED",
"APEX RESTAURANTS PRIVATE LIMITED",
"APEX ROLLER FLOUR MILLS PRIVATE LIMITED",
"APEX SECURITY AND SURVEILLANCE SYSTEMS PRIVATE LIMITED",
"APEX SECURITY SERVICE PRIVATE LIMITED",
"APEX SERVICES",
"APEX SHEARS PRIVATE LIMITED",
"APEX SHOE COMPANY PRIVATE LIMITED",
"APEX SOFTCELL (INDIA) PRIVATE LIMITED",
"APEX SOLUTIONS",
"APEX SOURCING & INFO SERVICES PRIVATE LIMITED",
"APEX SPORT SURFACES (I) PRIVATE LIMITED",
"APEX SPORTS PRIVATE LIMITED",
"APEX STEEL & TECHNOLOGY (INDIA) PRIVATE LIMITED",
"APEX STRATEGIC CONSULTING PRIVATE LIMITED",
"APEX STRUCTURE PRIVATE LIMITED",
"APEX SUBSCRIPTION PRIVATE LIMITED",
"APEX SUPERSPECIALITY HOSPITALS PRIVATE LIMITED",
"APEX SURATGARH MULTISPECIALITY HOSPITAL PRIVATE LIMITED",
"APEX SUSPENSION PRIVATE LIMITED",
"APEX TARMAC PRIVATE LIMITED",
"APEX TAVELS & TOURS PRIVATE LIMITED",
"APEX TEA EXPORTS PRIVATE LIMITED",
"APEX TECH WOODS PRIVATE LIMITED",
"APEX TECHNO POLYMER PRIVATE LIMITED",
"APEX TG INDIA PRIVATE LIMITED",
"APEX THERMOCON PRIVATE LIMITED",
"APEX THERMOTECH TECHNOLOGIES PRIVATE LIMITED",
"APEX TRANSWORLD COMPUTERS PRIVATE LIMITED",
"APEX TUBES PRIVATE .LIMITED",
"APEX UNIVERSITY",
"APEX WELCARE PRIVATE LIMITED",
"APEX WELLNESS HOSPITAL",
"APEX WORLD LOGISTICS PRIVATE LIMITED",
"APEX YARN PRIVATE LIMITED",
"APEXA HR SERVICES PRIVATE LIMITED",
"APEXA INFORMATION SYSTEMS PRIVATE LIMITED",
"APEX-DECISIONS.COM PRIVATE LIMITED",
"APEXLYNX MARKETING AND ENGINEERING PRIVATE LIMITED",
"APEXSEMICONDUCTOR INDIA PRIVATE LIMITED",
"APEXSOUND SOLUTIONS PRIVATE LIMITED",
"APEX-TEK PLACEMENT CONSULTANTS PRIVATE LIMITED",
"APF WATER SYSTEMS PRIVATE LIMITED",
"APG ABODE HOMES PRIVATE LIMITED",
"APG AUTOMATION PRIVATE LIMITED",
"APG CHEMIE (INDIA) PRIVATE LIMITED",
"APG INDUSTRIAL CONGLOMERATE PRIVATE LIMITED",
"APG INTELLI HOMES PRIVATE LIMITED",
"APG IRON AND STEEL PRIVATE LIMITED",
"APG LIFESTYLE HOMES PRIVATE LIMITED",
"APG PREMIUM HOMES PRIVATE LIMITED",
"APH AUTO ANCILLIARIES PRIVATE LIMITED",
"APHALI PHARMACEUTICALS LIMITED",
"APHELION FINANCE PRIVATE. LIMITED",
"APHELION SOFTWARE PRIVATE LIMITED",
"APHRODITE 4WHEELS PRIVATE LIMITED",
"APHRODITE RENAISSANCE TALKIES PRIVATE LIMITED",
"API ASSOCIATES PRIVATE LIMITED",
"API BUSINESS SOLUTIONS ASIA PRIVATE LIMITED",
"API HOLDINGS PRIVATE LIMITED",
"API ISPAT AND POWERTECH PRIVATE LIMITED",
"APIAN FINANCE AND INVESTMENT LTD",
"APIBEE NATURAL PRODUCT PRIVATE LIMITED",
"APIC MEDIA CREATION PRIVATE LIMITED",
"APICAL BUILDTECH PRIVATE LIMITED",
"APICAL ENGINEERING & SOLUTIONS PRIVATE LIMITED",
"APICAL HEALTHCARE PRIVATE LIMITED",
"APICAL IMMIGRATION EXPERTS PRIVATE LIMITED",
"APICAL IMPEX PRIVATE LIMITED",
"APICAL INFRASTRUCTURE PRIVATE LIMITED",
"APICAL PHARMACEUTICALS PRIVATE LIMITED",
"APICE ENGINEERING AND CONSULTING PRIVATE LIMITED",
"APICEM RECYCLERS PRIVATE LIMITED",
"APICES INFRA PRIVATE LIMITED",
"APICES STUDIO PRIVATE LIMITED",
"APICHEM LABORATORIES PRIVATE LIMITED",
"APICOM AUTOMATION PRIVATE LIMITED",
"APICORE PHARMACEUTICALS PRIVATE LIMITED",
"APIDEL TECHNOLOGIES PRIVATE LIMITED",
"APIDOR ABRASIVE PRODUCTS PRIVATE LIMITED",
"APIGEE TECHNOLOGIES INDIA PRIVATE LIMITED",
"APIKORE ELECTROBUILD PRIVATE LIMITED",
"APIL POLY INDUSTRIES LIMITED",
"APIM EDUCATIONS PRIVATE LIMITED",
"APIN SECURITY AND MANAGEMENT SERVICES LLP",
"APIND CONSULTANCY SERVICES PRIVATE LIMITED",
"APINDIA BIOTECH PRIVATE LIMITED",
"APIONEX PHARMA PRIVATE LIMITED",
"APIRIA TECHNOLOGIES PRIVATE LIMITED",
"APIS INDIA LIMITED",
"APIS NANDI INSURANCE BROKERS PRIVATE LIMITED",
"APISCRIBE SOFTWARE PRIVATE LIMITED",
"APISCRIPT DEVELOPER PRIVATE LIMITED",
"APISERO GLOBAL INTEGRATION SOLUTIONS PRIVATE LIMITED",
"APISTER LIFESCIENCES PRIVATE LIMITED",
"APIT AUTOMATION PRIVATE LIMITED",
"APITCO LIMITED",
"APITORIA PHARMA PRIVATE LIMITED",
"APJ AUTOMOBILES PRIVATE LIMITED",
"APJ ENTERPRISES PRIVATE LIMITED",
"APJ LINE PRIVATE LIMITED",
"APJ PACKAGING PRIVATE LIMITED",
"APJ REFINERIES PRIVATE LIMITED",
"APJ STEEL IMPEX PRIVATE LIMITED",
"APJ TOURS & TRAVELS PRIVATE LIMITED",
"APKA LOGISTICS PRIVATE LIMITED",
"APKON VENTURES PRIVATE LIMITED",
"APL APOLLO BUILDING PRODUCTS PRIVATE LIMITED",
"APL APOLLO TUBES LIMITED",
"APL CARGO CARRIERS PRIVATE LIMITED",
"APL CORPORATION PRIVATE LIMITED",
"APL GLOBAL SCHOOL",
"APL HEALTHCARE LIMITED",
"APL INFRASTRUCTURE PRIVATE LIMITED",
"APL INTERNATIONAL PRIVATE LIMITED",
"APL LOGISTICS (INDIA) PRIVATE LIMITED",
"APL LOGISTICS VASCOR AUTOMOTIVE PRIVATE LIMITED",
"APL MACHINERY PRIVATE LIMITED",
"APL METALS LIMITED",
"APL RESEARCH CENTRE LIMITED",
"APL VALUECLAY PRIVATE LIMITED",
"APLAB ENGICHEM PRIVATE LIMITED",
"APLAB LIMITED",
"APLAYA FASHIONS LIMITED",
"APLICA TECHNOLOGIES INDIA PRIVATE LIMITED",
"APLINKA SOLUTIONS AND TECHNOLOGIES PRIVATE LIMITED",
"APLOMB CARE PRODUCTS PRIVATE LIMITED",
"APLOMB ENCON (OPC) PRIVATE LIMITED",
"APLOMB MACHINES INDIA PRIVATE LIMITED",
"APLOMB PROJECT SOLUTIONS PRIVATE LIMITED",
"APLOPIO TECHNOLOGY PRIVATE LIMITED",
"APLOS FASHION PRIVATE LIMITED",
"APLOSTECH PRIVATE LIMITED",
"APLUS CORPORATE PROTECTION SERVICES PRIVATE LIMITED",
"APLUS ENTERPRISES PRIVATE LIMITED",
"APLUS TECHNO BUILD PRIVATE LIMITED",
"APLUS TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"APLUS VISION OPC PRIVATE LIMITED",
"APM AUTO PARTS PRIVATE LIMITED",
"APM INDUSTRIES LIMITED",
"APM INFRASTRUCTURE PRIVATE LIMITED",
"APM MARBLE AND GRANITE PRIVATE LIMITED",
"APM MEDICAL BILLERS PRIVATE LIMITED",
"APM PROJECTS PRIVATE LIMITED",
"APM TECHNOLOGIES 3D PRIVATE LIMITED",
"APM TECNOCRAFT PRIVATE LIMITED",
"APM TERMINALS INDIA PRIVATE LIMITED",
"APMG INDIA CERTIFICATIONS PRIVATE LIMITED",
"APMODE INTERNATIONAL PRIVATE LIMITED",
"APMOSYS TECHNOLOGIES PRIVATE LIMITED",
"APMSE SOFTWARE SERVICES PRIVATE LIMITED",
"APMV STOCKS & COMMODITIES PRIVATE LIMITED",
"APN GLOBAL EDUCATION PRIVATE LIMITED",
"APN SOLAR ENERGY PRIVATE LIMITED",
"APNA AWAS CONSTRUCTION PRIVATE LIMITED",
"APNA AWAS REAL ESTATE PRIVATE LIMITED",
"APNA CAR.COM PRIVATE LIMITED",
"APNA CRANE PRIVATE LIMITED",
"APNA DOORSTEP SERVICES PRIVATE LIMITED",
"APNA HOSPITAL",
"APNA INSTRUMENTATION SOLUTIONS PRIVATE LIMITED",
"APNA INSURANCE BROKING CONSULTANTS INDIA PRIVATE LIMITED",
"APNA INTERRIOR",
"APNA LOGISTICS SOLUTIONS PRIVATE LIMITED",
"APNA MUNEEM PRIVATE LIMITED",
"APNA ORGANICS PVT LTD",
"APNA SAPNA CONSTRUCTION AND DEVELOPER PRIVATE LIMITED",
"APNA SWEETS (INDIA) PRIVATE LIMITED",
"APNA TECHNOLOGIES & SOLUTION PRIVATE. LIMITED.",
"APNA TELE LINK PRIVATE LIMITED",
"APNAGHAR BIZCORP PRIVATE LIMITED",
"APNAR PHARMA PRIVATE LIMITED",
"APNARUPEE FIN INDIA PRIVATE LIMITED",
"APNATECH CONSULTANCY SERVICES PRIVATE LIMITED",
"APNAVII N ANOKHII LEISURE PRIVATE LIMITED",
"APNI DHUN PRIVATE LIMITED",
"APNS CORPORATE SERVICES PRIVATE LIMITED",
"APOCALYPSO FILMWORKS PRIVATE LIMITED",
"APOGEE CABLES & CONDUCTORS PRIVATE LIMITED",
"APOGEE HUMAN RESOURCE SOLUTION PRIVATE LIMITED",
"APOGEE LOGISTICS (INDIA) PRIVATE LIMITED",
"APOGEN REMEDIES PRIVATE LIMITED",
"APOKOS REHAB PRIVATE LIMITED",
"APOKOS REHABILITATION HOSPITAL",
"APOLLAZ ACME PRIVATE LIMITED",
"APOLLO ADLUX HOSPITAL",
"APOLLO AEROSPACE COMPONENTS INDIA PRIVATE LIMITED",
"APOLLO AGRO INDUSTRIES LIMITED",
"APOLLO AMRISH ONCOLOGY SERVICES PRIVATE LIMITED",
"APOLLO BANGALORE CRADLE LIMITED",
"APOLLO CANCER HOSPITAL",
"APOLLO CARGO CARRIERS PRIVATE LIMITED",
"APOLLO CARMIX EQUIPMENTS PRIVATE LIMITED",
"APOLLO COMPUTING LABORATORIES PRIVATE LIMITED",
"APOLLO CONCAST PRIVATE LIMITED",
"APOLLO CRADLE HOSPITAL AND APOLLO SPECTRA HOSPITALS",
"APOLLO CREATIONS PRIVATE LIMITED",
"APOLLO CROPSCIENCE PRIVATE LIMITED",
"APOLLO CVHF HEART INSTITUTE",
"APOLLO CVHF LIMITED",
"APOLLO DIALYSIS PRIVATE LIMITED",
"APOLLO DIGITEX PRIVATE LIMITED",
"APOLLO DISTANCE EDUCATION COLLEGE",
"APOLLO EARTHMOVERS LIMITED DEEMED PUBLIC COMPANY",
"APOLLO ENERGY COMPANY LIMITED",
"APOLLO EXIM LIMITED",
"APOLLO FACILITY MANAGEMENT SERVICES PRIV ATE LIMITED",
"APOLLO FACILITY MANAGEMENT SERVICES PRIVATE LIMITE",
"APOLLO FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"APOLLO FERTILITY CENTRE PRIVATE LIMITED",
"APOLLO FINVEST (INDIA) LIMITED",
"APOLLO FLOW CONTROL SYSTEMS PRIVATE LIMITED",
"APOLLO GAUGING PRIVATE LIMITED",
"APOLLO GLENEAGLES PET-CT PRIVATE LIMITED",
"APOLLO GOLD VATAKARA PRIVATE LIMITED",
"APOLLO HAWKEYE PEDERSHAAB CONCRETE TECHNOLOGIES PRIVATE LIMITED",
"APOLLO HEALTH AND LIFESTYLE LIMITED",
"APOLLO HEALTH CARE",
"APOLLO HEALTH RESOURCES LIMITED.",
"APOLLO HEALTHCO LIMITED",
"APOLLO HEAT EXCHANGERS PRIVATE LIMITED",
"APOLLO HOME HEALTHCARE LIMITED",
"APOLLO HOSPITAL CHARITABLE TRUST",
"APOLLO HOSPITALS EDUCATION TRUST",
"APOLLO HOSPITALS ENTERPRISE LIMITED",
"APOLLO HOSPITALS INTERNATIONAL LIMITED",
"APOLLO INDIA SERVICES LLP",
"APOLLO INDUSTRIES AND PROJECTS LIMITED",
"APOLLO INFFRATECH PRIVATE LIMITED",
"APOLLO INFOWAYS PRIVATE LIMITED",
"APOLLO INGREDIENTS INDIA PRIVATE LIMITED",
"APOLLO INSTITUTE OF MEDICAL SCIENCES & RESEARCH",
"APOLLO INTERFABS PRIVATE LIMITED",
"APOLLO GREEN ENERGY LIMITED",
"APOLLO INTERNATIONAL SCHOOL",
"APOLLO INTERNATIONAL SCHOOL & MEDICAL EDUCATION",
"APOLLO JUNIORS SCHOOL",
"APOLLO KH HOSPITAL",
"APOLLO KITCHEN EQUIPMENTS & SERVICES PRIVATE LIMITED",
"APOLLO LAUNDRY AND LINEN SERVICES PRIVATE LIMITED",
"APOLLO LIFE AND HEALTH LIMITED",
"APOLLO LOGISOLUTIONS LIMITED",
"APOLLO MEDI-SERVICES PVT. LTD.",
"APOLLO METACHEM PRIVATE LIMITED",
"APOLLO METALEX PRIVATE LIMITED",
"APOLLO MICRO SYSTEMS LIMITED",
"APOLLO MULTISPECIALITY HOSPITALS LIMITED",
"APOLLO PAINTS PRIVATE LIMITED",
"APOLLO PHARMACIES LIMITED",
"APOLLO PIPES LIMITED",
"APOLLO POWER SYSTEMS PRIVATE LIMITED",
"APOLLO PROCESSORS PRIVATE LIMITED",
"APOLLO PUBLIC SCHOOL",
"APOLLO RADIOLOGY INTERNATIONAL PRIVATE LIMITED",
"APOLLO RAJSHREE HOSPITALS PRIVATE LIMITED",
"APOLLO REACH HOSPITALS ENTERPRISES LIMITED",
"APOLLO RT CORPORATION LTD",
"APOLLO SAGE HOSPITALS",
"APOLLO SCREENS PRIVATE LIMITED",
"APOLLO SHINE FOUNDATION",
"APOLLO SINDOORI HOTELS LIMITED",
"APOLLO SOLUTIONS PRIVATE LIMITED",
"APOLLO SPECIALTY HOSPITALS PRIVATE LIMITED",
"APOLLO STRUCTURAL STEEL INDIA PRIVATE LIMITED",
"APOLLO SUGAR CLINICS LIMITED",
"APOLLO SUPPLY CHAIN PRIVATE LIMITED",
"APOLLO TECHNO FORGE PRIVATE LIMITED",
"APOLLO TECHNO INDUSTRIES PRIVATE LIMITED",
"APOLLO TELEHEALTH SERVICES PRIVATE LIMITED",
"APOLLO TILES & BRICKS PRIVATE LIMITED",
"APOLLO TRADERS PRIVATE LIMITED",
"APOLLO TRADING AND FINANCE PRIVATE LIMITED",
"APOLLO TRAVEL GROUP PRIVATE LIMITED",
"APOLLO TRICOAT TUBES LIMITED",
"APOLLO TYRES CENTRE OF EXCELLENCE LIMITED",
"APOLLO TYRES LIMITED",
"APOLLO VIKAS STEELS PRIVATE LIMITED",
"APOLLO VINTRADE PRIVATE LIMITED",
"APOLLO WORLD CONNECT LIMITED",
"APOLLOFY INC",
"APOLLOMEDICS INTERNATIONAL LIFESCIENCES LIMITED",
"APOLLOTECHNO INDUSTRIES PRIVATE LIMITED",
"APOLLOZENITH CONCRETE TECHNOLOGIES PRIVATE LIMITED",
"APOLO EXTRUSIONS LIMITED",
"APOORV AIR CONTROL PRIVATE LIMITED",
"APOORV ELECTRICALS (INDIA) PRIVATE LIMITED",
"APOORVA EXTRUSION PRIVATE LIMITED",
"APOORVA HEALTH SERVICES PRIVATE LIMITED",
"APOORVA INFRATECH PRIVATE LIMITED",
"APOORVA ISPAT & METALS PRIVATE LIMITED",
"APOORVA IT SOLUTIONS PRIVATE LIMITED",
"APOORVA LEASING FINANCE AND INVESTMENT COMPANY LIMITED",
"APOORVA LOGISTICS PRIVATE LIMITED",
"APOORVA MEDICARE PRIVATE LIMITED",
"APOORVA REALTORS & FINVEST PRIVATE LIMITED",
"APOORVAM TRUST",
"APOORVA'S SANGEETHA RESTAURANTS PRIVATE LIMITED",
"APOP INTERNATIONAL PRIVATE LIMITED",
"APOSTLETECH INDIA PRIVATE LIMITED",
"APOSTOLIC CARMEL HIGH SCHOOL",
"APOSTOLIC CARMEL JUNIOR COLLEGE",
"APOSTROPHE FILMS PRIVATE LIMITED",
"APOSTROPHY BUSINESS SOLUTIONS PRIVATE LIMITED",
"APOTEK MEDICAL PRIVATE LIMITED",
"APOTEX PHARMACHEM INDIA PRIVATE LIMITED",
"APOTEX RESEARCH PRIVATE LIMITED",
"APOTHECARY PHARMACEUTICALS PRIVATE LIMITED",
"APOTHECON PHARMACEUTICALS PRIVATE LIMITED",
"APOXEO SOLUTIONS PRIVATE LIMITED",
"APOXY MEDIA PRIVATE LIMITED",
"APOYO SALES PRIVATE LIMITED",
"APP IDEAS INFOTECH PRIVATE LIMITED",
"APP INDIA PAPER PRIVATE LIMITED",
"APP INNOVATION TECHNOLOGIES PRIVATE LIMITED",
"APP MEDIA PRIVATE LIMITED",
"APP SUPPLIERS (OPC) PRIVATE LIMITED",
"APP XPERTS PRIVATE LIMITED",
"APPAC MEDIATECH PRIVATE LIMITED",
"APPALOFT MERCHANTS PRIVATE LIMITED",
"APPALTO ELECTRONICS PRIVATE LIMITED",
"APPAN DUKAN MARKETING AND SERVICES PRIVATE LIMITED",
"APPAN PACKAGING PRIVATE LIMITED",
"APPAR POWER CABLES PRIVATE LIMITED",
"APPAREL ATTIRE PRIVATE LIMITED",
"APPAREL EVRYWEAR PRIVATE LIMITED",
"APPAREL EXIM PRIVATE LIMITED",
"APPAREL EXPORT PROMOTION COUNCIL",
"APPAREL GROUP INDIA PRIVATE LIMITED",
"APPAREL INDIA PVT LTD",
"APPAREL KRAFT PRIVATE LIMITED",
"APPAREL LININGS AND TEXTILES PRIVATE LIMITED",
"APPAREL MADE-UPS AND HOME FURNISHING SECTOR SKILL COUNCIL",
"APPAREL RESOURCES PRIVATE LIMITED",
"APPAREL TRAINING & DESIGN CENTRE",
"APPARELS AND LINENS INDIA PRIVATE LIMITED",
"APPARELS PRIVATE LIMITED",
"APPARELTREE PRIVATE LIMITED",
"APPARENT MARKETING PRIVATE LIMITED",
"APPARIO RETAIL PRIVATE LIMITED",
"APPASAHEB BIRNALE COLLEGE OF PHARMACY",
"APPASAMY ASSOCIATES PRIVATE LIMITED",
"APPASAMY MEDICARE CENTRE PRIVATE LIMITED",
"APPASAMY OCULAR DEVICES P LIMITED",
"APPASPECT TECHNOLOGIES PRIVATE LIMITED",
"APPASWAMY REAL ESTATES LIMITED",
"APPBELL TECHNOLOGIES PRIVATE LIMITED",
"APPBITS TECHNOLOGIES PRIVATE LIMITED",
"XEBIA APPCINO TECHNOLOGIES PRIVATE LIMITED",
"APPCITO NETWORKS PRIVATE LIMITED",
"APPCLOUD SOFTWARE SOLUTIONS PRIVATE LIMITED",
"APPCON BUILDTECH PRIVATE LIMITED",
"APPCORE LABS INDIA PRIVATE LIMITED",
"APPCURE LABS PRIVATE LIMITED",
"APPDESK SERVICES PRIVATE LIMITED",
"APPDIRECT INDIA PRIVATE LIMITED",
"APPEAL KIDS DREAM INTERNATIONAL PRIVATE LIMITED.",
"APPEAR IMPEX PRIVATE LIMITED",
"APPENA LIFE PRIVATE LIMITED",
"APPENDIT AB",
"APPENING INFOTECH PRIVATE LIMITED",
"APPENTUS TECHNOLOGIES PRIVATE LIMITED",
"APPETALS SOLUTIONS PRIVATE LIMITED",
"APP-EX SEMI CONDUCTOR PRIVATE LIMITED",
"APPEX TECH INNOVATIONS PRIVATE LIMITED",
"APPEX TRADELINK PVT LTD",
"APPEXIGO TECHNOLOGIES PRIVATE LIMITED",
"APPFACE TECHNOLOGIES PRIVATE LIMITED",
"APPFIRE TECHNOLOGIES INDIA PRIVATE LIMITED",
"APPFLOW SOLUTIONS PRIVATE LIMITED",
"APPFOSTER INNOVATIONS PRIVATE LIMITED",
"APPGALLOP PRIVATE LIMITED",
"APPHIE TECHNOLOGIES PRIVATE LIMITED",
"APPIAN ASSOCIATES INFRASTRUCTURE PRIVATE LIMITED",
"APPIAN INFOTECH PRIVATE LIMITED",
"APPIAN MULTIVENTURES PRIVATE LIMITED",
"APPIAN PROPERTIES PRIVATE LIMITED",
"APPICON IT PRIVATE LIMITED",
"APPIDI TECHNOLOGIES PRIVATE LIMITED",
"APPIFY SYSTEMS PRIVATE LIMITED",
"APPINESS INTERACTIVE PRIVATE LIMITED",
"APPINFOINC TRAFFIC INDIA PRIVATE LIMITED",
"APPINVENTIV TECHNOLOGIES PRIVATE LIMITED",
"APPIRIO INDIA CLOUD SOLUTIONS PRIVATE LIMITED",
"APPISTOKI CONSULTING SERVICES PRIVATE LIMITED",
"APPIT SOFTWARE SOLUTIONS PRIVATE LIMITED",
"APPIT VENTURES INDIA PRIVATE. LIMITED",
"APPITSIMPLE INFOTEK PRIVATE LIMITED",
"APPIZION CONSULTING & SOLUTIONS PRIVATE LIMITED",
"APPL DEFENCE AND TELECOMMUNICATIONS PRIVATE LIMITED",
"APPL GLOBAL INFOTECH PRIVATE LIMITED",
"APPL GOR PLASTICS INDIA PRIVATE LIMITED",
"APPL INDUSTRIES LIMITED",
"APPLABS MEDIA PRIVATE LIMITED",
"APPLAUD SOLUTIONS INDIA PRIVATE LIMITED",
"APPLAUNCH BANGALORE PRIVATE LIMITED",
"APPLAUSE APP QUALITY INDIA PRIVATE LIMITED",
"APPLAUSE ENETERTAINMENT PRIVATE LIMITED",
"APPLAUSE EXIM PRIVATE LIMITED",
"APPLE & OLIVE IT SOLUTIONS PRIVATE LIMITED",
"APPLE AGROTECH PRIVATE LIMITED",
"APPLE AIR SYSTEM PRIVATE LIMITED",
"APPLE AIRCON PRIVATE LIMITED",
"APPLE AUTO AGENCY PRIVATE LIMITED",
"APPLE AUTO PRIVATE LIMITED",
"APPLE AUTOMOTIVE PRIVATE LIMITED",
"APPLE BAKERY MACHINERY PRIVATE LIMITED",
"APPLE CHEMIE INDIA PRIVATE LIMITED",
"APPLE CORP LIMITED",
"APPLE CROP PROTECTION (INDIA) PRIVATE LIMITED",
"APPLE ENERGY PRIVATE LIMITED",
"APPLE EQUIPMENTS PRIVATE LIMITED",
"APPLE FACILITY SERVICES PRIVATE LIMITED",
"APPLE FANS & WIRES PRIVATE LIMITED",
"APPLE FLEXIPACK PRIVATE LIMITED",
"APPLE FORMULATIONS PRIVATE LIMITED",
"APPLE FREIGHT AND LOGISTICS LLP",
"APPLE GLOBAL SCHOOL",
"APPLE GRANITES LTD",
"APPLE HOSPITAL",
"APPLE HOSPITALS AND RESEARCH INSTITUTE LIMITED",
"APPLE INDIA PRIVATE LIMITED",
"APPLE INDIA SOLAR PRODUCTS PRIVATE LIMITED",
"APPLE INSULATED WIRES PRIVATE LIMITED",
"APPLE INTERNATIONAL ENGINEERING WORKS PRIVATE LIMITED",
"APPLE ISPAT PRIVATE LIMITED",
"APPLE LIFESTYLE INDUSTRIES LIMITED",
"APPLE MECHANICAL SERVICES INDIA PRIVATE LIMITED",
"APPLE MINES & MINERALS PRIVATE LIMITED",
"APPLE NETWORK PRIVATE LIMITED",
"APPLE OFFICE STATIONERS PRIVATE LIMITED",
"APPLE ORAL AND DENTAL PRIVATE LIMITED",
"APPLE PRINT PACK P LIMITED",
"APPLE PRINTPACK PRIVATE LIMITED",
"APPLE PROMOTERS PRIVATE LIMITED",
"APPLE PUBLISHING INTERNATIONAL PRIVATE LIMITED",
"APPLE REALMART PRIVATE LIMITED",
"APPLE SARASWATI MULTISPECIALITY HOSPITAL",
"APPLE SILK MILLS PRIVATE LIMITED",
"APPLE SPIRE INDIA LLP",
"APPLE SURAIDO FITTINGS PRIVATE LIMITED",
"APPLE THERAPEUTICS PRIVATE LIMITED",
"APPLE THERMO SANITATION PRIVATE LIMITED",
"APPLE TILES PRIVATE LIMITED",
"APPLE VALLEY RESORTS PRIVATE LIMITED",
"APPLE WEIGHINFRA LIMITED",
"APPLEPRO IT SOLUTIONS PRIVATE LIMITED",
"APPLETON CEREALS LIMITED",
"APPLETREE BUILDING MAINTENANCE PRIVATE LIMITED",
"APPLETREE INTERNATIONAL PRIVATE LIMITED",
"APPLEWOODS ESTATE PRIVATE LIMITED",
"APPLEXUS TECHNOLOGIES PRIVATE LIMITED",
"APPLICANTZ SOFTWARE SOLUTIONS LLP",
"APPLICATE IT SOLUTIONS PRIVATE LIMITED",
"APPLICATION CONTROL PANELS PRIVATE LIMITED",
"APPLICATION NEXUS WEBSERVICES PRIVATE LIMITED",
"APPLICATION SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"APPLIED ARTIFICIAL INTELLIGENCE CONSULTING LLP",
"APPLIED AUTO PARTS PRIVATE LIMITED",
"APPLIED AUTOMATION SYSTEMS PRIVATE LIMITED",
"APPLIED CLOUD COMPUTING PRIVATE LIMITED",
"APPLIED COMMUNICATIONS AND CONTROLS",
"APPLIED DATA SYSTEMS PRIVATE LIMITED",
"APPLIED ELECTRO MAGNETICS PRIVATE LIMITED",
"APPLIED ELECTROSTATICS AND CONTROLS PRIVATE LIMITED",
"APPLIED ENGINEERING & TECHNOLOGY PRIVATE LIMITED",
"APPLIED FELTS (INDIA) PRIVATE LIMITED",
"APPLIED INFO SERVICES INDIA PRIVATE LIMITED",
"APPLIED INFORMATION SYSTEMS PRIVATE LIMITED",
"APPLIED INFRASTRUCTURE CONTRACTING AND ENGINEERING PRIVATE LIMITED",
"APPLIED INTELLIGENCE SEMICONDUCTORS PRIVATE LIMITED",
"APPLIED LIFE PRIVATE LIMITED",
"APPLIED MATERIALS INC.",
"APPLIED MATERIALS INDIA PRIVATE LIMITED",
"APPLIED MICRO CIRCUITS INDIA PRIVATE LIMITED",
"APPLIED MOBILE LABS PRIVATE LIMITED",
"APPLIED OPTICAL TECHNOLOGIES PRIVATE LIMITED",
"APPLIED OPTIMIZATION PRIVATE LIMITED SERVICE",
"APPLIED PROMOTIONS AND PUBLICITY PRIVATE LIMITED",
"APPLIED REALTECH SYSTEMS PRIVATE LIMITED",
"APPLIED RESEARCH INTERNATIONAL PRIVATE LIMITED",
"APPLIED RESEARCH WORKS INDIA PRIVATE LIMITED",
"APPLIED SOFTWARE PRIVATE LIMITED",
"APPLIED SOLAR TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"APPLIED STANDARDS & INNOVATIONS TECHNOLOGIES PRIVATE LIMITED",
"APPLIED SYSTEMS INDIA PRIVATE LIMITED",
"APPLIED TEK AND MANAGEMENT CONSULTANCY PRIVATE LIMITED",
"APPLIFT INDIA TECHNOLOGIES PRIVATE LIMITED",
"APPLIFY TECH PRIVATE LIMITED",
"APPLIKON IT SOLUTIONS PRIVATE LIMITED",
"APPLINATION SOFTECH PRIVATE LIMITED",
"APPLITECH INFOTECH PRIVATE LIMITED",
"APPLITEK COMPUTERS PRIVATE LIMITED",
"APPLUENT BUSINESS SOLUTIONS PRIVATE LIMITED",
"APPLUS INDIA PRIVATE LIMITED",
"APPLYBOARD INDIA PRIVATE LIMITED",
"APPLYGATE AU PRIVATE LIMITED",
"APPLYIFI ADVISORS PRIVATE LIMITED",
"APPMAJIX TECHNOLOGIES PRIVATE LIMITED",
"APPMIX TECHNOLOGIES PRIVATE LIMITED",
"APPMOBI IT SERVICES PRIVATE LIMITED",
"APPMONTIZE MEDIA PRIVATE LIMITED",
"APPNIT TECHNOLOGIES PRIVATE LIMITED",
"APPNOMIC SYSTEMS PRIVATE LIMITED",
"APPNOVATION TECHNOLOGY SOLUTIONS PRIVATE LIMITED (OPC)",
"APPOBILE LABS PRIVATE LIMITED",
"APPOHM TECHNOLOGIES PRIVATE LIMITED",
"APPOIDS TECH SOLUTIONS PRIVATE LIMITED",
"APPOINTMENT PLUS SOFTWARE INDIA PRIVATE LIMITED",
"APPOINTY INFORMATION TECHNOLOGY PRIVATE LIMITED",
"APPOLLINE ENERGY PRIVATE LIMITED",
"APPOLLO DISTILLERIES PRIVATE LIMITED",
"APPOLLO DYECHEM PRIVATE LIMITED",
"APPOLLO NURSING COLLEGE",
"APPOLLO SPECIALITY HOSPITAL PRIVATE LIMITED",
"APPOLO COMPUTERS PRIVATE LIMITED",
"APPOLO CRANES PRIVATE LIMITED",
"APPOLO INTERNATIONAL LIMITED",
"APPOLO MOTOR PRIVATE LIMITED",
"APPOLO PACKAGING PRIVATE LIMITED",
"APPOLO TRANSPORT COMPANY PRIVATE LIMITED",
"APPON SOFTWARE PRIVATE LIMITED",
"APPOO TRADING PRIVATE LIMITED",
"APPORCHID INDIA PRIVATE LIMITED",
"APPORIO INFOLABS PRIVATE LIMITED",
"APPORVA DATA SOLUTIONA PRIVATE LIMITED",
"APPOSITE LEARNING SOLUTIONS PRIVATE LIMITED",
"APPPOINT SOFTWARE SOLUTIONS PRIVATE LIMITED",
"APPQUARTERZ TECHNOLOGIES PRIVATE LIMITED",
"APPRECIATE FINCAP PRIVATE LIMITED",
"APPRELS PRIVATE LIMITED",
"APPRENDER PRIVATE LIMITED",
"APPRICK TECHNOLOGIES PRIVATE LIMITED",
"APPRIFFY - DIGITAL IT HUB PRIVATE LIMITED",
"APPRIKART DIGITAL SOLUTIONS PRIVATE LIMITED",
"APPRISTINE TECHNOLOGIES PRIVATE LIMITED",
"APPRO LUBES PRIVATE LIMITED",
"APPROACH ADVERTISING AND EXHIBTERS PRIVATE LIMITED",
"APPROACH MEDIA PRIVATE LIMITED",
"APPROACHABLE EQUIPMENTS PRIVATE LIMITED",
"APPROCOOL AIRCON PRIVATE LIMITED",
"APPROCOPP ENGINEERING PRIVATE LIMITED",
"APPRONEX IT SOLUTIONS PRIVATE LIMITED",
"APPRONIC SOFTWARE PRIVATE LIMITED",
"APPROTECH POROUS PIPES PRIVATE LIMITED",
"APPS AGRO INDIA PRIVATE LIMITED",
"APPS ASSOCIATES (I) PRIVATE LIMITED",
"APPS ASSOCIATES PRIVATE LIMITED",
"APPS BUSINESS IT SOLUTIONS PRIVATE LIMITED",
"APPS10X PRIVATE LIMITED",
"APPSAVIO SOFTWARE PRIVATE LIMITED",
"APPSBEE TECHNOLOGY PRIVATE LIMITED",
"APPSBIZZ DIGITAL SOLUTIONS PRIVATE LIMITED",
"APPSBUILD INFOTECH PRIVATE LIMITED",
"APPSCOOK TECHNOLOGIES PRIVATE LIMITED",
"APP-SCOOP SOLUTIONS PRIVATE LIMITED",
"APPSECCO CONSULTING PRIVATE LIMITED",
"APPSFLYER INDIA PRIVATE LIMITED",
"APPSFREEDOM INDIA PRIVATE LIMITED",
"APPSGURU BUSINESS IT CONSULTING PRIVATE LIMITED",
"APPSHARK SOFTWARE PRIVATE LIMITED",
"APPSIAN TECH PRIVATE LIMITED",
"APPSIERRA SOLUTIONS PRIVATE LIMITED",
"APPSIKA SOFT TECH PRIVATE LIMITED",
"APPSINVO PRIVATE LIMITED",
"APPSMITH SOFTWARE PRIVATE LIMITED",
"APPSNDEVICES TECHNOLOGIES PRIVATE LIMITED",
"APPSNEXT TECHNOLOGIES PRIVATE LIMITED",
"APPSOLEUT CODERS LLP",
"APPSQUADZ SOFTWARE PRIVATE LIMITED",
"APPSRON TECHNOLOGIES PRIVATE LIMITED",
"APPSTATION PRIVATE LIMITED",
"APPSTEK INFORMATION SERVICES PRIVATE LIMITED",
"APPSTEK SOLUTIONS PRIVATE LIMITED",
"APPSTER INFORMATION TECHNOLOGY PRIVATE LIMITED",
"APPSTITCH TECHNOLOGIES PRIVATE LIMITED",
"APPSTRAIL TECHNOLOGY PRIVATE LIMITED",
"APPSUMS TECHNOLOGIES PRIVATE LIMITED",
"APPSYS GLOBAL PRIVATE LIMITED",
"APPTAD TECHNOLOGIES PRIVATE LIMITED",
"APPTIO INDIA LLP",
"APPTIUM TECHNOLOGIES INDIA PRIVATE LIMITED",
"APPTIVO SOFTWARE PRIVATE LIMITED",
"APPTOMATE DIGITAL SOFTWARE SERVICES PRIVATE LIMITED",
"APPU BIRI WORKS PVT LTD",
"APPU INTERNATIONAL",
"APPU VENKATACHALAM MEDICAL RESEARCH CENTRE PRIVATE LIMITED",
"APPUJI LOGISTICS PRIVATE LIMITED",
"APPUNFOLD PRIVATE LIMITED",
"APPV SOFTWARE INDIA PRIVATE LIMITED",
"APPVEEN TECHNOLOGIES PRIVATE LIMITED",
"APPVIEWX PRIVATE LIMITED",
"APPVIRALITY TECHNOLOGIES PRIVATE LIMITED",
"APPWALLET TECHNOLOGIES PRIVATE LIMITED",
"APPWORX IT SOLUTIONS PRIVATE LIMITED",
"APPWRK IT SOLUTIONS PRIVATE LIMITED",
"APPY PIE LLP",
"APPYHAPPY SOFTWARE PRIVATE LIMITED",
"APPYHUB TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"APPZ SOLUTIONS PRIVATE LIMITED",
"APPZCLOUD TECHNOLOGIES PRIVATE LIMITED",
"APPZEN LABS INDIA PRIVATE LIMITED",
"APPZERA (OPC) PRIVATE LIMITED",
"APPZLOGIC MOBILITY SOLUTIONS PRIVATE LIMITED",
"APPZOY TECHNOLOGIES PRIVATE LIMITED",
"APPZUI TECHNOLOGIES PRIVATE LIMITED",
"APR AUTOMOBILES PRIVATE LIMITED",
"APR CONSTRUCTIONS LIMITED",
"APR CONSULTANTS PRIVATE LIMITED",
"APR GLOBAL RECYCLING PRIVATE LIMITED",
"APR JEWELLERS PRIVATE LIMITED",
"APR UDYOG PRIVATE LIMITED",
"APRA AMUSEMENT PRIVATE LIMITED",
"APRA BUILDERS AND PROMOTERS PRIVATE LIMITED",
"APRA LABS PRIVATE LIMITED",
"APRA MOTELS PRIVATE LIMITED",
"APRA SECURITIES AND MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"APRAAVA ENERGY PRIVATE LIMITED",
"APRAAVA WIND ENERGY (KHANDKE) PRIVATE LIMITED",
"APRAMEYA COMMERCIALS PRIVATE LIMITED",
"APRAMEYA LOGISTICS PRIVATE LIMITED",
"APRAMEYA PHARMACHEM PRIVATE LIMITED",
"APRAMEYAH TECHNOLOGIES PRIVATE LIMITED",
"APRANJE JEWELLERS PRIVATE LIMITED",
"APRANT MOTORS PRIVATE LIMITED",
"APRAR INDIA PRIVATE LIMITED",
"APRAS IRRIGATION SYSTEMS LIMITED",
"APRAS POLYMERS AND ENGINEERING COMPANY PRIVATE LIMITED",
"APRAZER HEALTHCARE PRIVATE LIMITED",
"APRC HEALTHCARE PRIVATE LIMITED",
"APRECOMM PRIVATE LIMITED",
"APRESVOUS HOSPITALITY PRIVATE LIMITED",
"APREXP LOGISTICS LLP",
"APRICA HEALTHCARE LIMITED",
"APRICA PHARMACEUTICALS PRIVATE. LIMITED.",
"APRICATE POWER PRIVATE LIMITED",
"APRICOT FOODS PRIVATE LIMITED",
"APRICOT FURNITURE SYSTEM PRIVATE LIMITED",
"APRICOT LOGISTICS SOLUTION",
"APRICOT MEDIA PRIVATE LIMITED",
"APRICOT TILES INDIA PRIVATE LIMITED",
"APRICUS ENERGY SOLUTIONS PRIVATE LIMITED",
"APRICUS PREMIUM SOLAR PRIVATE LIMITED",
"APRIKOSE MARKETING SOLUTION PRIVATE. LIMITED.",
"APRIL MOON RETAIL PRIVATE LIMITED",
"APRIL SOURCING PRIVATE LIMITED",
"APRIL STUDIOS PRIVATE LIMITED",
"APRIL3RD FOODS",
"APRILE INDIA PRIVATE LIMITED",
"APRL PATHLABS PRIVATE LIMITED",
"APRN ENTERPRISES PRIVATE LIMITED",
"APROACT FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"APRON TEST-LABS AND CONSULTANTS PRIVATE LIMITED",
"APROPOS CAREERS PRIVATE LIMITED",
"APROPOS PLANNERS AND DEVELOPERS PRIVATE LIMITED",
"APS BIOTECH PRIVATE LIMITED",
"APS COLLEGE OF ENGINEERING",
"APS CONSULTANCY PRIVATE LIMITED",
"APS CORPORATIONS PRIVATE LIMITED",
"APS DELHI (OPC) PRIVATE LIMITED",
"APS DRUGS PRIVATE LIMITED",
"APS ELECTRICAL ENGINEERING PRIVATE LIMITED",
"APS ENTERPRISES PRIVATE LIMITED",
"APS FOREX SERVICES PRIVATE LIMITED",
"APS GLOBAL PRIVATE LIMITED",
"APS HOLDING PRIVATE LIMITED",
"APS HYDRO PRIVATE LIMITED",
"APS INDUSTRIES LIMITED",
"APS INNOVATIONS PRIVATE LIMITED",
"APS INTERNATIONAL PRIVATE LIMITED",
"APS MANGLAM PRIVATE LIMITED",
"APS MINERAL",
"APS ONLINE EDUCATION PRIVATE LIMITED",
"APS PACKAGING PRIVATE LIMITED",
"APS PETROCHEM PRIVATE LIMITED",
"APS PLAST PRIVATE LIMITED",
"APS POLYMER PRODUCTS PRIVATE LIMITED",
"APS POWER SYSTEMS PRIVATE LIMITED",
"APS POWER TECH INDIA PRIVATE LIMITED",
"APS SOLTECH (OPC) PRIVATE LIMITED",
"APS STRUCTURE PRIVATE LIMITED",
"APS SYNTHETICS PRIVATE LIMITED",
"APS TECH SYSTEMS PRIVATE LIMITED",
"APS TELECOM SERVICES PRIVATE LIMITED",
"APSALAR ANALYTICS PRIVATE LIMITED",
"APSARA ART MATERIALS PVT LTD",
"APSARA CINEMA PRIVATE LIMITED",
"APSARA PLASTICS PRIVATE LIMITED",
"APSARA PLYWOOD INDUSTRIES PRIVATE LIMITED",
"APSARA POLYMERS PRIVATE LIMITED",
"APSARA POWER INDIA PRIVATE LIMITED",
"APSARA RESTAURANT PRIVATE LIMITED",
"APSARA SAREES PRIVATE LIMITED",
"APSARA SELECTIONS LIMITED",
"APS-ASB PRIVATE LIMITED",
"APSC ELECTRONICS PRIVATE LIMITED",
"APSC INFOTECH AND SOFTWARE SOLUTIONS PRIVATE LIMITED",
"APSCO PREFABS PRIVATE LIMITED",
"APSD SEEDS INDIA PRIVATE LIMITED",
"APSENSYS TECHNOLOGIES PRIVATE LIMITED",
"APSG FASTENERS PRIVATE LIMITED",
"APSI LABS INDIA PRIVATE LIMITED",
"APSIDATA SOLUTIONS PRIVATE LIMITED",
"APSL LINES PRIVATE LIMITED",
"APSNP TECHNOLOGIES PRIVATE LIMITED",
"APSOLUT SOFTWARE INDIA PRIVATE LIMITED",
"APSOM INFOTEX LIMITED",
"APSOM TECHNOLOGIES INDIA PRIVATE LIMITED",
"APSONS ENTERTAINMENT PRIVATE LIMITED",
"APSP EXPORTS PRIVATE LIMITED",
"APSS DISTRIBUTORS PRIVATE LIMITED",
"APSS MARKSOL PRIVATE LIMITED",
"APSS TECHNOLOGIES PRIVATE LIMITED",
"APSUJA INFRATECH PRIVATE LIMITED",
"APT (PROJECT & TURNKEY) ENGINEERS PRIVATE LIMITED",
"APT ACADEMY FOR PROFESSIONAL TRAINING PRIVATE LIMITED",
"APT AGROTECH INDUSTRIES PRIVATE LIMITED",
"APT DRIVES SOLUTIONS PRIVATE LIMITED",
"APT ELECTRONICS PRIVATE LIMITED",
"APT ENERGYX SOLAR PRIVATE LIMITED",
"APT ENTERTAINMENT PRIVATE LIMITED",
"APT GLOBAL MARINE ENGINEERING PRIVATE LIMITED",
"APT INFOSOFT PRIVATE LIMITED",
"APT INTERNATIONAL SHIPPING PRIVATE LIMITED",
"APT MEDIA SOLUTIONS PRIVATE LIMITED",
"APT MEDICAL SYSTEMS PRIVATE LIMITED",
"APT ONLINE LIMITED",
"APT PACKAGING LIMITED",
"APT POLYCHEM PRIVATE LIMITED",
"APT POWER ENGINEERING PRIVATE LIMITED",
"APT SOFTWARE AVENUES PRIVATE.LIMITED",
"APT SURVEY SOLUTIONS PRIVATE LIMITED",
"APT TOOLS & MACHINERY INDIA PRIVATE LIMITED",
"APT X-RAY (INDIA) PRIVATE LIMITED",
"APTA MEDICAL IMAGING PRIVATE LIMITED",
"APTAR PHARMA INDIA PRIVATE LIMITED",
"APTARA LEARNING PRIVATE LIMITED",
"APTARA NEW MEDIA PRIVATE LIMITED",
"APTARA TECHNOLOGIES PRIVATE LIMITED",
"APTASK INDIA PRIVATE LIMITED",
"APTCLINCH INFOTECH PRIVATE LIMITED",
"APTCLOUDS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"APTCO (INDIA) PRIVATE LIMITED",
"APTE AND APTE ORGANIC COATINGS PVT LIMITED",
"APTEAN INDIA PRIVATE LIMITED",
"APTECH LIMITED",
"APTEK INSTRUMENTATION PRIVATE LIMITED",
"APTEK PRINT PRIVATE LIMITED",
"APTEL OFFICE CARE PRIVATE LIMITED",
"APTENER MECHATRONICS PRIVATE LIMITED",
"APTER POLY INDIA PRIVATE LIMITED",
"APTE'S SHREE AUTO SERVICE",
"APTIMA CONSULTING INDIA PRIVATE LIMITED",
"APTINA INDIA PRIVATE LIMITED",
"APTITUDE EXPERT COACHING INSTITUTE",
"APTIV COMPONENTS INDIA PRIVATE LIMITED",
"APTIV CONNECTION SYSTEMS INDIA PRIVATE LIMITED",
"APTIVA TECHNOLOGIES INDIA PRIVATE LIMITED",
"APTLOGICA TECHNOLOGIES PRIVATE LIMITED",
"APTLORE TECHNOLOGIES PRIVATE LIMITED",
"APTON WORKS PRIVATE LIMITED",
"APTONLINE LIMITED",
"APTORIS TECHNOLOGY (OPC) PRIVATE LIMITED",
"APTOS INDIA PRIVATE LIMITED",
"APTRA SYNTHESIS PRIVATE LIMITED",
"APTROID CONSULTING INDIA PRIVATE LIMITED",
"APTROID TECHNOLOGIES PRIVATE LIMITED",
"APTRONIX",
"APTSOL GLOBAL TECH PRIVATE LIMITED",
"APTSOURCE SOFTWARE PRIVATE LIMITED",
"APTUDE SOFTWARE SOLUTIONS INDIA PRIVATE LIMITED",
"APTUS EQUIPMENTS PRIVATE LIMITED",
"APTUS ESOLUTIONS PRIVATE LIMITED",
"APTUS FINANCE INDIA PRIVATE LIMITED",
"APTUS PHARMA PRIVATE LIMITED",
"APTUS POLYSTAR PRIVATE LIMITED",
"APTUS RECYCLING PRIVATE LIMITED",
"APTUS SOFTWARE LABS PRIVATE LIMITED",
"APTUS VALUE HOUSING FINANCE INDIA LIMITED",
"APTUS WINDOWS PRIVATE LIMITED",
"APTUSDATALABS TECHNOLOGIES PRIVATE LIMITED",
"APTY SOFTWARE PRIVATE LIMITED",
"APU CORRUMATE PACKAGING PRIVATE LIMITED",
"APU PACKAGING INDIA PRIVATE LIMITED",
"APU RICE MILL PVT. LTD.",
"APURV DIAGNOSTIC AND RESEARCH CENTRE PRIVATE LIMITED",
"APURVA AUTOMOTIVES PRIVATE LIMITED",
"APURVA CHEMICALS PRIVATE LIMITED",
"APURVA CHILDREN HOSPITAL",
"APURVA COMPUTERS TECHNOLOGIES PRIVATE LIMITED",
"APURVA CREATIONS PRIVATE LIMITED",
"APURVA INVESTMENT",
"APURVA NATVAR PARIKH & CO PRIVATE LIMITED",
"APURVA ORGANICS LTD",
"APURVA PRINT INDUSTRIES PRIVATE LIMITED",
"APURVA PULSES PVT LTD",
"APURVA VINIMAY PRIVATE LIMITED",
"APURVA WATER MANAGEMENT SYSTEM PRIVATE LIMITED",
"APURVAI INDIA PRIVATE LIMITED",
"APURVAKRITI INFRASTRUCTURE PRIVATE LIMITED",
"APURWA BUSINESS SOLUTIONS PRIVATE LIMITED",
"APUTURE INDIA PRIVATE LIMITED",
"APV REALTY LIMITED",
"APV TECHNOLOGIES PRIVATE LIMITED",
"APV TRADESOL PRIVATE LIMITED",
"APVM ELECTRONICS PRIVATE LIMITED",
"APXOR TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"APY MEDI SERVICES PRIVATE LIMITED",
"APYL SOFTWARE AND SYSTEMS LIMITED",
"APYRON TECHNOLOGIES INDIA PRIVATE LIMITED",
"AQ INDUCTIVE COMPONENTS INDIA PRIVATE LIMITED",
"AQ MECHANICAL & ELECTRICAL MANUFACTURING INDIA PRIVATE LIMITED",
"AQ SQUARE REALTORS PRIVATE LIMITED",
"AQB SOLUTIONS PRIVATE LIMITED",
"AQC CHEMLAB PRIVATE LIMITED",
"AQC MANAGEMENT PRIVATE LIMITED",
"AQFIT SMART TECHNOLOGY PRIVATE LIMITED",
"AQFQ JEWELLERY MANUFACTURER PRIVATE LIMITED",
"AQGROMALIN FARMTECH SERVICES PRIVATE LIMITED",
"AQJ APPARELS PRIVATE LIMITED",
"AQJ DEGREE COLLEGE",
"AQKODE HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"AQL BIZ CONSULTANTS LLP",
"AQL SOFTWARE SOLUTIONS PRIVATE LIMITED",
"AQM TECHNOLOGIES PRIVATE LIMITED",
"AQOZA TECHNOLOGIES PRIVATE LIMITED",
"AQR CAPITAL INDIA SERVICES LLP",
"AQSA POLYPACK PRIVATE LIMITED",
"AQSACOM INDIA PRIVATE LIMITED",
"AQTRONICS TECHNOLOGIES PRIVATE LIMITED",
"AQUA ALLOYS PVT LTD",
"AQUA BLUE GLOBAL AQUACULTURE SOLUTIONS PRIVATE LIMITED",
"AQUA CENTRIC PRIVATE LIMITED",
"AQUA CHEMICALS AND GASES PRIVATE LIMITED",
"AQUA CHILL SYSTEMS INDIA PRIVATE LIMITED",
"AQUA CLEAN SERVICES PRIVATE LIMITED",
"AQUA CLEAN SYSTEMS PRIVATE LIMITED",
"AQUA CONTROL VALVES PRIVATE LIMITED",
"AQUA COOL CO PRIVATE LIMITED",
"AQUA ECO GREEN TECHNOLOGY PRIVATE LIMITED",
"AQUA ECO SYSTEMS",
"AQUA EMBROIDERIES PRIVATE LIMITED",
"AQUA ENGINEERING & ALLIED SERVICES PRIVATE LIMITED",
"AQUA ENGINEERS AND CONSULTANTS INDIA PRIVATE LIMITED",
"AQUA EXCEL",
"AQUA FACILITY SERVICES PRIVATE LIMITED",
"AQUA FINE INJECTA PVT LTD",
"AQUA FLOW FITTINGS PRIVATE LIMITED",
"AQUA MACHINERIES PRIVATE LIMITED",
"AQUA MARINE MARITIME ACADEMY PRIVATE LIMITED",
"AQUA MATRIX SYSTEM PRIVATE LIMITED",
"AQUA MED PRIVATE LIMITED",
"AQUA MOSAIC PRIVATE LIMITED",
"AQUA O&M SERVICES PRIVATE LIMITED",
"AQUA PLAST INDUSTRIES PRIVATE LIMITED",
"AQUA PLUMBINGS PRIVATE LIMITED",
"AQUA POWER PRIVATE LIMITED",
"AQUA PRODUCTS & SERVICES PRIVATE LIMITED",
"AQUA PROOF CONSTRUCTION CHEMICAL (INDIA) PRIVATE LIMITED",
"AQUA PROOF WALL PLAST PRIVATE LIMITED",
"AQUA PROOFERS PVT LTD",
"AQUA RESORTS AND SPA PRIVATE LIMITED",
"AQUA SANITARY APPLIANCES PRIVATE LIMITED",
"AQUA SEA FOOD (INDIA) PRIVATE LIMITED",
"AQUA SEAL TECH PRIVATE LIMITED",
"AQUA SECURITY SOFTWARE INDIA PRIVATE LIMITED",
"AQUA SPACE DEVELOPERS PRIVATE LIMITED AQUA SPACE",
"AQUA SPECIALITIES PRIVATE LIMITED",
"AQUA SYSTEMS PVT LTD",
"AQUA TERRA ADVENTURES INDIA PRIVATE LIMITED",
"AQUA TERRA COKE & ENERGY LIMITED",
"AQUA TERRA LOGISTICS PRIVATE LIMITED",
"AQUA UTILITY DESIGNS AND MANAGEMENT PRIVATE LIMITED",
"AQUA VITOE LABORATRIES PRIVATE LIMITED",
"AQUA WATER SYSTEMS (INDIA) PRIVATE LIMITED",
"AQUA WAVE BIOTECH PRIVATE. LIMITED.",
"AQUA WORKS PRIVATE LIMITED",
"AQUA WORLD EXPORTS PRIVATE LIMITED",
"AQUAA CARE (SURAT ) RO TECHNOLOGIES PRIVATE LIMITED",
"AQUA-AIR ENVIRONMENTAL ENGINEERS PRIVATE LIMITED",
"AQUAARIUS BATH SOLUTIONS PRIVATE LIMITED",
"AQUAAWORLD GREENTECH PRIVATE LIMITED",
"AQUABRANE WATER TECHNOLOGIES PRIVATE LIMITED",
"AQUABRIM HOMEAPPLIANCE PRIVATE LIMITED",
"AQUACHEM ENVIRO ENGINEERS PRIVATE LIMITED",
"AQUACHEM INDIA PRIVATE LIMITED",
"AQUACHEM INDUSTRIES PRIVATE LIMITED",
"AQUACO INDUSTRIES PRIVATE LIMITED",
"AQUACON CONSULTANTS AND ENGINEERS PRIVATE LIMITED",
"AQUACON RESOURCING PRIVATE LIMITED",
"AQUACURE BHANDARE INDUSTRIES OPC PRIVATE LIMITED",
"AQUACY PRIVATE LIMITED",
"AQUAD VENTURES PRIVATE LIMITED",
"AQUADRY PHARMA PRIVATE LIMITED",
"AQUADUC EQUIPMENTS LIMITED",
"AQUADUCTT CLEAN TECHNOLOGIES PRIVATE LIMITED",
"AQUADYNE APPLIANCES PRIVATE LIMITED",
"AQUAEXCHANGE AGRITECH PRIVATE LIMITED",
"AQUAFIL POLYMERS COMPANY PRIVATE LIMITED (RONAK REGRIG.)",
"AQUAGEL CHEMICALS PRIVATE LIMITED",
"AQUAGRANT WATER PURIFIER PRIVATE LIMITED",
"AQUAGREEN ENGINEERING MANAGEMENT PRIVATE LIMITED",
"AQUAGRI GREENTECH PRIVATE LIMITED",
"AQUAGRI PROCESSING PRIVATE LIMITED",
"AQUAIGNIS TECHNOLOGIES PRIVATE LIMITED",
"AQUAKRAFT PROJECTS PRIVATE LIMITED",
"AQUALAM ENGINEERING SOLUTIONS PRIVATE LIMITED",
"AQUALEAF IT SOLUTIONS PRIVATE LIMITED",
"AQUALIFT ENGINEERS & SOLUTIONS PRIVATE LIMITED",
"AQUALINE PROPERTIES PRIVATE LIMITED",
"AQUALITE INDIA PRIVATE LIMITED",
"AQUALITE INDUSTRIES PRIVATE LIMITED",
"AQUAMALL WATER SOLUTIONS LIMITED",
"AQUAMARINE HEALTHCARE PRIVATE LIMITED",
"AQUAMATE ENGINEERING PRIVATE LIMITED",
"AQUAMAX SYSTEMS INDIA PRIVATE LIMITED",
"AQUANEST PRIVATE LIMITED",
"AQUANOMICS SYSTEMS LIMITED",
"AQUANOSH MARINE PRODUCTS (INDIA) PRIVATE LIMITED",
"AQUANTIA SEMICONDUCTOR INDIA PRIVATE LIMITED",
"AQUANZA INFRASTRUCTURE ENGINEERING PRIVATE LIMITED",
"AQUAPHARM CHEMICALS PRIVATE LIMITED",
"AQUAPLAST INFRACON PRIVATE LIMITED",
"AQUAPROOF BUILDING SOLUTIONS PRIVATE LIMITED",
"AQUAPROOF MINERALS AND CHEMICALS PRIVATE LIMITED",
"AQUAPROOF WALLCARE INDIA PRIVATE LIMITED",
"AQUAPRUFE INDUSTRIES (INDIA) PRIVATE LIMITED",
"AQUARELLE INDIA PRIVATE LIMITED",
"AQUARELLE MARINE OFFSHORE PRIVATE LIMITED",
"AQUAREX PURISYS PRIVATE LIMITED",
"AQUARIAN FIBRECEMENT PRIVATE LIMITED",
"AQUARIAN SHARE BROKING COMPANY PRIVATE LIMITED",
"AQUARII INFRASTRUCTURES PRIVATE LIMITED",
"AQUARIOUS MARKETING PRIVATE LIMITED",
"AQUARIUS APPLIANCES PRIVATE LIMITED",
"AQUARIUS ENGINEERS PRIVATE LIMITED",
"AQUARIUS H2O DYNAMICS PRIVATE LIMITED",
"AQUARIUS INDIA MANUFACTURING & SOURCING PRIVATE LIMITED",
"AQUARIUS LOGISTICS PRIVATE LIMITED",
"AQUARIUS MARITIME PRIVATE LIMITED",
"AQUARIUS PROMOTIONS PRIVATE LIMITED",
"AQUARIUS PURIFICATION PRIVATE LIMITED",
"AQUARIUS SHIPYARD PRIVATE LIMITED",
"AQUARIUS TECHNOLOGIES PRIVATE LIMITED",
"AQUARIUS TEX FAB PRIVATE LIMITED",
"AQUASAIL DISTRIBUTION COMPANY PRIVATE LIMITED",
"AQUASCAPE ENGINEERS PRIVATE LIMITED",
"AQUASCAPE TECHNOLOGIES PRIVATE LIMITED",
"AQUASENSE PRIVATE LIMITED",
"AQUASIS CHEM PRIVATE LIMITED",
"AQUASNS FASHIONS PRIVATE LIMITED",
"AQUASOLVE CONSTRUCTION CHEMICALS PRIVATE LIMITED",
"AQUASPHERE GREENTECH SOLUTIONS PRIVATE LIMITED",
"AQUASTEL WATER PURIFICATION SYSTEMS PRIVATE LIMITED",
"AQUATECH FEED & SEAFOODS PRIVATE LIMITED",
"AQUATECH INFRA PROJECTS PRIVATE LIMITED",
"AQUATECH PLUS PRIVATE LIMITED",
"AQUATECH POLYMER PRODUCTS (INDIA) PRIVATE LIMITED",
"AQUATECH SALES AND SERVICES PRIVATE LIMITED",
"AQUA-TECH SOLUTIONS PRIVATE LIMITED",
"AQUATECH SOLUTIONS PRIVATE. LIMITED",
"AQUATECH STEELCON PRIVATE LIMITED",
"AQUATECH SYSTEMS ASIA PRIVATE LIMITED",
"AQUATECHNICS WATER TREATMENT TECHNOLOGIES PRIVATE LIMITED",
"AQUATEK SANITARY FITTINGS PRIVATE LIMITED",
"AQUATHERM ENGINEERING CONSULTANTS INDIA PRIVATE LIMITED",
"AQUATHERM WATER TREATMENT PRIVATE LIMITED",
"AQUATIC FARMS LIMITED",
"AQUATIC FORMULATIONS (INDIA) LIMITED",
"AQUATIC PIPES AND TUBES PRIVATE LIMITED",
"AQUATIC REMEDIES LIMITED",
"AQUATIC REMEDIES PRIVATE LIMITED",
"AQUATICA FROZEN FOODS GLOBAL PRIVATE LIMITED",
"AQUATRADES GLOBAL LOGISTICS PRIVATE LIMITED",
"AQUATREAT ENGINEERING PVT.LTD.",
"AQUATRO INFOTECH SOLUTIONS PRIVATE LIMITED",
"AQUAVISION AGRO PRIVATE LIMITED",
"AQUAYASH WATER TECH PRIVATE LIMITED",
"AQUAZEN POLYTECH PRIVATE LIMITED",
"AQUEDUCT ADVISORS PRIVATE LIMITED",
"AQUEDUCT PLASTICS PRIVATE LIMITED",
"AQUENT ADVANCE MATERIAL TECHNOLOGIES PRIVATE LIMITED",
"AQUENT POLYMERS PRIVATE LIMITED",
"AQUEOUS FOOD TECHNOLOGIES PVT LTD",
"AQUERALABS INDIA PRIVATE LIMITED",
"AQUEST ADVISORS PRIVATE LIMITED",
"AQUILA CERAMIC PRIVATE LIMITED",
"AQUILA DRILLING PRIVATE LIMITED",
"AQUILA INDIA TECHNOSYS PRIVATE LIMITED",
"AQUILA MERCANTILE PRIVATE LIMITED",
"AQUILA ORGANICS PRIVATE LIMITED",
"AQUILA RO SYSTEMS PRIVATE LIMITED",
"AQUILA SOFTWARE SERVICES HYDERABAD PRIVATE LIMITED",
"AQUILACLOUDS INDIA PRIVATE LIMITED",
"AQUILATECH PRE-FAB PRIVATE LIMITED",
"AQUILINE INFOMEDIA PRIVATE LIMITED",
"AQUIMO SPORTS PRIVATE LIMITED .",
"AQUINAS COLLEGE",
"AQUINNOVA PHARMACEUTICALS PRIVATE LIMITED",
"AQUION SYSTEMS PRIVATE LIMITED",
"AQUIS SEARCH PRIVATE LIMITED",
"AQUITY ENTERPRISE SOLUTIONS PRIVATE LIMITED",
"AQUITY SOLUTIONS INDIA PRIVATE LIMITED.",
"AQUIXIN SERVICES PRIVATE LIMITED",
"AQUNOVA PHARMA PRIVATE LIMITED",
"AQURA ENVIRO PROJECTS PRIVATE LIMITED",
"AQZEN IMPEX PRIVATE LIMITED",
"AR A S APPLIANCES PRIVATE LIMITED",
"AR A S ENTERPRISES PRIVATE LIMITED",
"AR AIRWAYS PRIVATE LIMITED",
"AR AR CHEMICALS PVT LTD",
"AR CHICKEN CENTER",
"AR CONSTRUCTION",
"AR DIGITAL WEALTH PRIVATE LIMITED",
"AR ENTERPRISES",
"AR ES PE INFRA PRIVATE LIMITED",
"AR EX LABORATORIES PRIVATE LIMITED",
"AR GRANDEYE INDIA PRIVATE LIMITED",
"AR INDUSTRIAL MANAGEMENT SERVICES PRIVATE LIMITED",
"AR INFOMATRIX PRIVATE LIMITED",
"AR INFRASTRUCTURE PRIVATE LIMITED",
"AR IRON & ISPAT PRIVATE LIMITED",
"AR KAY MEDICOS PRIVATE LIMITED",
"AR MARITIME SERVICES PRIVATE LIMITED",
"AR MECH PRIVATE LIMITED",
"AR NETWORK NUTS PRIVATE LIMITED",
"AR PRINTS",
"AR RAJU BEVERAGES PRIVATE LIMITED",
"AR RAMASWAMY ESTATES PRIVATE LIMITED",
"AR ROBOTICS INDIAPRIVATE LIMITED",
"AR SHIPPING AGENCY PRIVATE LIMITED",
"AR SOFTECH PRIVATE LIMITED",
"AR SPA ENTERPRISES PRIVATE LIMITED",
"AR SQUARE INFRA SOLUTIONS",
"AR TECHNOPLAST PRIVATE LIMITED",
"AR TRADE EXIM PRIVATE LIMITED",
"AR TRANSFORMERS PRIVATE LIMITED",
"AR VENTURE FUNDS MANAGEMENT PRIVATE LIMITED",
"AR WOOD INDUSTRIES PRIVATE LIMITED",
"AR.A.S.AUTOMOTIVE PRIVATE LIMITED",
"AR.A.S.P.V.P.V AUTOMOBILES PRIVATE LIMITED",
"ARA CARRIER PRIVATE LIMITED",
"ARA ENGINEERING AND CONSTRUCTION PRIVATE LIMITED",
"ARA FINANCIAL SERVICES PRIVATE LIMITED",
"ARA HEALTH CARE PRIVATE LIMITED",
"ARA JEWELLERS PRIVATE LIMITED",
"ARA POLYFAB PRIVATE LIMITED",
"ARA POLYTRADE PRIVATE LIMITED",
"ARA RESOURCES PRIVATE LIMITED",
"ARA TILES PRIVATE LIMITED",
"ARAADHYAM MANUFACTURES PRIVATE LIMITED",
"ARAB GOLD AND DIAMONDS PRIVATE LIMITED",
"ARAB INTERNATIONAL BANK",
"ARABIAN CONSTRUCTION CO - SIMPLEX INFRA PRIVATE LIMITED",
"ARABIAN NIGHTS PRIVATE LIMITED",
"ARABIAN OCEAN DRILLING SUPPLIES & SERVICES PRIVATE LIMITED",
"ARABIAN PETROLEUM LIMITED",
"ARABINDA PACKAGING & MACHINERY PRIVATE LIMITED",
"ARABLE EXIM PRIVATE LIMITED",
"ARABLE FREIGHT FORWARDING PRIVATE LIMITED",
"ARACION TECHNOLOGY PRIVATE LIMITED",
"ARAD VENTURES PRIVATE LIMITED",
"ARADHANA AUTOMOBILES PRIVATE LIMITED",
"ARADHANA BUILDERS PRIVATE LIMITED",
"ARADHANA DISTRIBUTORS PRIVATE LIMITED",
"ARADHANA ENTERPRISES (INDIA) PRIVATE LIMITED",
"ARADHANA FASHIONS PRIVATE LIMITED",
"ARADHANA HOSPITAL PRIVATE LIMITED",
"ARADHANA ORTHOPAEDIC CENTER",
"ARADHAY SHREERAM PRIVATE LIMITED",
"ARADHITA FOODS PRIVATE LIMITED",
"ARADHNA FABRICS PRIVATE LIMITED",
"ARADHNA HERBALS PRIVATE LIMITED",
"ARADHYA BUILDCON PRIVATE LIMITED",
"ARADHYA CARGO PRIVATE LIMITED",
"ARADHYA DOODH SANKALAN",
"ARADHYA ENGINEERS AND CONSTRUCTIONS PRIVATE LIMITED",
"ARADHYA EXPORT IMPORT CONSULTANTS PRIVATE LIMITED",
"ARADHYA FLEET PRIVATE LIMITED",
"ARADHYA FOODS PRIVATE LIMITED",
"ARADHYA HOSPITALITY PRIVATE LIMITED",
"ARADHYAM TRADING PRIVATE LIMITED",
"ARADHYASHAKTI BUILDERS PRIVATE LIMITED",
"ARAFA HOSPITAL PRIVATE LIMITED",
"ARAFAATH EXPORTS PRIVATE LIMITED",
"ARAFAATH TRAVELS PRIVATE LIMITED",
"ARAFAT TRADING PRIVATE LIMITED",
"ARAFIN FINANCIAL SERVICES PRIVATE LIMITED",
"ARAFLEX GASKETS AND JOINTINGS PRIVATE LIMITED",
"ARAGA HOTELS PRIVATE LIMITED",
"ARAGEN LIFE SCIENCES LIMITED",
"ARAGEN LIFE SCIENCES PRIVATE LIMITED",
"ARAGMA SALES PRIVATE LIMITED",
"ARAHA HOSPITALITY PRIVATE LIMITED",
"ARAHANT ENCLOSURES PRIVATE LIMITED",
"ARAHANT FOREX & HOLIDAYS PRIVATE LIMITED",
"ARAIYA PALAMPUR A NORWOOD HEIGHTS RESORT",
"ARAKKATHARA TRANSPORT SERVICES AUTOMOBILES PRIVATE LIMITED",
"ARAKKONAM CO OPERATIVE URBAN BANK",
"ARAKU ORIGINALS PRIVATE LIMITED",
"ARALIA COMMODITIES PRIVATE LIMITED",
"ARALIAS BEVERAGES PRIVATE LIMITED",
"ARALIAS DISTRIBUTION PRIVATE LIMITED",
"ARAMA MANAGEMENT SERVICES PRIVATE LIMITED",
"ARAMA PETRO CHEM KOVAI P LIMITED",
"ARAMBAGH AGRO CHEMICALS PRIVATE LIMITED",
"ARAMBAGH APEXX DIAGNOSTIC AND HEALTH CARE PRIVATE LIMITED",
"ARAMBAGH FOODMART PRIVATE LIMITED",
"ARAMBAGH HOTEL AND RESORT PRIVATE LIMITED",
"ARAMBANS EXPORTERS PRIVATE LIMITED",
"ARAMBH FURNISHING PRIVATE LIMITED",
"ARAMBHA EXIM PRIVATE LIMITED",
"ARAMCO ASIA INDIA PRIVATE LIMITED",
"ARAMCO ENTERTAINMENT & E-COMMERCE PRIVATE LIMITED",
"ARAMDAN SKIN SOLUTIONS PRIVATE LIMITED",
"ARAMEX INDIA PRIVATE LIMITED",
"ARAMUC INDIA LIMITED",
"ARAMUC WORLDWIDE PRIVATE LIMITED",
"ARAN KITCHENWORLD INDIA PRIVATE LIMITED",
"ARAN PHARMACEUTICALS",
"ARANA ENERGY SERVICES PRIVATE LIMITED",
"ARANATH REAL ESTATE PRIVATE LIMITED",
"ARANAUT ARVIND SANITARY PRIVATE LIMITED",
"ARANAX MEDICAL PRIVATE LIMITED",
"ARANAYA JEWELLERS PRIVATE LIMITED",
"ARANAYAK FOOD PRODUCTS PRIVATE LIMITED",
"ARANCA",
"ARANCA MUMBAI PRIVATE LIMITED",
"ARANDI INVESTMENTS PRIVATE LIMITED",
"ARANGERS RETAIL INDIA PRIVATE LIMITED",
"ARANIA SERVICES PRIVATE LIMITED",
"ARANIS BUSINESS PROCESS SERVICES PRIVATE LIMITED",
"A-RANK HOLDINGS PRIVATE LIMITED",
"ARANKA INDUSTRIES PRIVATE LIMITED",
"ARANTHAANGI CHEMICAL PRODUCTS LIMITED",
"ARANYA AGENCIES PRIVATE LIMITED",
"ARANYA EXIM PRIVATE LIMITED",
"ARANYA INFRAPROJECT PRIVATE LIMITED",
"ARAROGYABHARTI MEDICARE NX HOSPITAL",
"ARAS MOTORS PRIVATE LIMITED",
"ARASAN BAKERY AND RESTAURANT COMPANY PRIVATE LIMITED",
"ARASKA DIAMOND PRIVATE LIMITED",
"ARASS INDUSTRIES PRIVATE LIMITED",
"ARASTU SYSTEMS PRIVATE LIMITED",
"ARASU HI TECH INFRA PRIVATE LIMITED",
"ARASU MALAR",
"ARASU RUBBER CORPORATION LIMITED",
"ARATI ELECTRONICS RETAIL PRIVATE LIMITED",
"ARATI INFRATECH PRIVATE LIMITED",
"ARATT ROLLING WHITES",
"ARATTUKULAM DEVELOPERS",
"ARATTUKULAM INFRASTRUCTURE CONSTRUCTION PRIVATE LIMITED",
"ARAUL REFIRGERATION INDUSTRIES PRIVATE LIMITED",
"ARAUNAH FACILITIES PRIVATE LIMITED",
"ARAV EXPORTS PRIVATE LIMITED",
"ARAV INFRATECH PRIVATE LIMITED",
"ARAVA CLOTHING PRIVATE LIMITED",
"ARAVALI AUTOMOBILES PRIVATE LIMITED",
"ARAVALI CABLES AND CONDUCTORS PRIVATE LIMITED",
"ARAVALI CARGO MOVERS PRIVATE LIMITED",
"ARAVALI CHEMTEX PRIVATE LIMITED",
"ARAVALI CONCRETE PRIVATE LIMITED",
"ARAVALI DEISTRIBUTORS PVT LTD",
"ARAVALI DISPOTECH PRIVATE LIMITED",
"ARAVALI ENGINEERS PRIVATE LIMITED",
"ARAVALI FLOORDECOR PRIVATE LIMITED",
"ARAVALI HEIGHT RESIDENT WELFARE ASSOCIATION (AHRWA)",
"ARAVALI INFRA PROJECT PRIVATE LIMITED",
"ARAVALI INTERNATIONAL SCHOOL",
"ARAVALI MARBLE INDUSTRIES PVT LTD",
"ARAVALI MINERALS AND CHEMICAL INDUSTRIES PVT LTD",
"ARAVALI MINROCKS PRIVATE LIMITED",
"ARAVALI POLYART PRIVATE LIMITED",
"ARAVALI POWER COMPANY PRIVATE LIMITED",
"ARAVALI PRINTERS AND PUBLISHERS PRIVATE LIMITED",
"ARAVALI REALTORS PRIVATE LIMITED",
"ARAVALI SILK MILLS PRIVATE LIMITED",
"ARAVALI TECHNICAL SERVICES PRIVATE LIMITED",
"ARAVALI TRADEVISION PRIVATE LIMITED",
"ARAVALI TRANSMISSION SERVICE COMPANY LIMITED",
"ARAVALI VYAPAAR PRIVATE LIMITED",
"ARAVALLI DISTRICT EDUCATION COMMITTEE MANAGED PRIMARY SCHOOL TEACHER",
"ARAVALLY PROCESSED AGROTECH PRIVATE LIMITED",
"ARAVILLE GREEN ENERGY VENTURES PRIVATE LIMITED",
"ARAVIND AVENUES PRIVATE LIMITED",
"ARAVIND CERAMIC INDUSTRIES LIMITED",
"ARAVIND CERAMICS PRIVATE LIMITED",
"ARAVIND EYE HOSPITAL",
"ARAVIND FLEXI PACK (INDIA) PRIVATE LIMITED",
"ARAVIND INDUSTRIES",
"ARAVIND KIDNEY CENTRE",
"ARAVIND KRISHNA HOSPITAL PRIVATE LIMITED",
"ARAVIND LABORATORIES",
"ARAVIND MILKFOODS PRIVATE LIMITED",
"ARAVINDA ELECTRICALS",
"ARAVINDA PLASTICS PRIVATE LIMITED",
"ARAVINDH HERBAL LABS PRIVATE LIMITED",
"ARAVINDKUMAR TEXTILES PRIVATE LIMITED",
"ARAVLI SYNTHETICS PRIVATE LIMITED",
"ARAWALI CROPS NUTRIENTS PRIVATE LIMITED",
"ARAWALI HOME INVESTMENT",
"ARAWALI MASALE PRIVATE LIMITED",
"ARAWALI PHOSPHATE LIMITED",
"ARAWALI TILES PVT. LTD.",
"ARAY CONSULTING LLP",
"ARAYACHERRIL VARKEY & SONS PRIVATE LIMITED",
"ARAYAN ENTERPRISE PRIVATE LIMITED",
"ARAYMOND INDIA PRIVATE LIMITED",
"ARAYNA CONTRACTORS PRIVATE LIMITED",
"ARB ACCESSORIES PRIVATE LIMITED",
"ARB BUILDCON PRIVATE LIMITED",
"ARB HOTELS & RESORTS PRIVATE LIMITED",
"ARB SOFTWARE INDIA PVT.LTD",
"ARBA DEVELOPMENT STUDIOS PRIVATE LIMITED",
"ARBAAZ KHAN PRODUCTION PRIVATE LIMITED",
"ARBAB FASHIONS PRIVATE LIMITED",
"ARBEE AQUATIC PROTEINS PRIVATE LIMITED",
"ARBEE BIOMARINE EXTRACTS PRIVATE LIMITED",
"ARBEITS EXPORTS (INDIA) PRIVATE LIMITED",
"ARBELA TRADING AND SERVICES PRIVATE LIMITED",
"ARBES TOOLS PRIVATE LIMITED",
"ARBHU ENTERPRISES PRIVATE LIMITED",
"ARBIND COLD STORAGE PRIVATE LIMITED",
"ARBIND KUMAR REALCON PRIVATE LIMITED",
"ARBION INFRA SERVICES",
"ARBIT AUTOMOBILES PRIVATE LIMITED",
"ARBIT ENTERPRISES",
"ARBIT ENTERPRISES PRIVATE LIMITED",
"ARBIT INFRATEL PRIVATE LIMITED",
"ARBITRAGE SECURITIES PRIVATE LIMITED",
"ARBITRON TECHNOLOGY SERVICES INDIA PRIVATE LIMITED",
"ARBO GOLD PRIVATE LIMITED",
"ARBOR BREWPUB PRIVATE LIMITED",
"ARBOR VETUM EXIM PRIVATE LIMITED",
"ARBOREAL BIOINNOVATIONS PRIVATE LIMITED",
"ARBOUR BIOTEC PRIVATE LIMITED",
"ARBRO PHARMACEUTICALS PRIVATE LIMITED",
"ARBRO TRADERS PRIVATE LIMITED",
"ARBROWN INDIA TRADING PRIVATE LIMITED",
"ARBS POWER SOLUTIONS PRIVATE LIMITED",
"ARBTECH TRADING PRIVATE LIMITED",
"ARBUDA AGROCHEMICALS PRIVATE LIMITED",
"ARBUDA METAL FAB INDIA PRIVATE LIMITED",
"ARBUDA STONE PRIVATE LIMITED",
"ARBUTUS CONSULTANTS PRIVATE LIMITED",
"ARBUTUS HEALTHCARE PRIVATE LIMITED",
"ARC AND FUSION (INDIA) PRIVATE LIMITED",
"ARC ARORA PROJECTS PRIVATE LIMITED",
"ARC AUTO-TECH PRIVATE LIMITED",
"ARC BIO FUEL PRIVATE LIMITED",
"ARC BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"ARC COMMODITY FUTURES PRIVATE LIMITED",
"ARC COMPSOFT PRIVATE LIMITED",
"ARC CONSULTING (I) PRIVATE LIMITED",
"ARC CRAFT EXPORTS PRIVATE LIMITED",
"ARC DISTRIBUTION INDIA PRIVATE LIMITED",
"ARC DISTRIBUTORS (I) PRIVATE LIMITED",
"ARC DOCUMENT SOLUTIONS INDIA PRIVATE LIMITED",
"ARC ELECTRICALS PRIVATE LIMITED",
"ARC FINANCE LTD",
"ARC FINLE SERVICES PRIVATE LIMITED",
"ARC FINTUBE TECHNOLOGIES PRIVATE LIMITED",
"ARC FOREX & TRAVELS PRIVATE LIMITED",
"ARC HORN GLOBAL SYSTEMS PVT LTD",
"ARC INFOTECH PVT LTD",
"ARC INSULATION & INSULATORS PRIVATE LIMITED",
"ARC INTERNATIONAL FERTILITY AND RESEARCH CENTRE P LIMITED",
"ARC INVESTMENT CONSULTANTS PRIVATE LIMITED",
"ARC MACHINE TOOLS PRIVATE LIMITED",
"ARC OFFSHORE INDIA PRIVATE LIMITED",
"ARC PARCEL SERVICE PRIVATE LIMITED",
"ARC PROPERTY SOLUTIONS PRIVATE LIMITED",
"ARC RENEWABLES PRIVATE LIMITED",
"ARC RETREADING COMPANY PRIVATE LIMITED",
"ARC SECURITY SOLUTIONS PRIVATE LIMITED",
"ARC TECHNOCON PRIVATE LIMITED",
"ARC TRANSLOGISTIC INDIA PRIVATE LIMITED",
"ARC TRENDS DOOR SOLUTIONS PRIVATE LIMITED",
"ARC WELD EQUIPMENTS PRIVATE LIMITED",
"ARC WORLDWIDE LIMITED",
"ARCA AERO SERVICES PRIVATE LIMITED",
"ARCA EDUCATION SOCIETY",
"ARCADIA CONSULTING SERVICES PRIVATE LIMITED",
"ARCADIA DEVELOPERS PRIVATE LIMITED",
"ARCADIA EXIM PRIVATE LIMITED",
"ARCADIA LOGISTICS LIMITED",
"ARCADIA MANAGEMENT SERVICES PRIVATE LIMITED",
"ARCADIA SHIPPING LIMITED",
"ARCADIA TECHNOLOGIES PRIVATE LIMITED",
"ARCADIA TRAVELS PRIVATE LIMITED",
"ARCADIAN PUBLIC SCHOOL",
"ARCADIS CONSULTING INDIA PRIVATE LIMITED",
"ARCADIS DEVBUILD PRIVATE LIMITED",
"ARCADIS INDIA PRIVATE LIMITED",
"ARCADIX INFOTECH PRIVATE LIMITED",
"ARCAIDEA SERVICES (OPC) PRIVATE LIMITED",
"ARCAIDS ARCHITECTURAL CONSULTANTS PRIVATE LIMITED",
"ARCAL INFRATECH PRIVATE LIMITED",
"ARCANUS BUSINESS SOLUTIONS PRIVATE LIMITED",
"ARCATA TRADE-LINKS PRIVATE LIMITED",
"ARCATRON MOBILITY PRIVATE LIMITED",
"ARCBOLT SPACE AND FOODS PRIVATE LIMITED",
"ARCC SOLAR PRIVATE LIMITED",
"ARCCON TRADING PRIVATE LIMITED",
"ARCE POLYMERS PRIVATE LIMITED",
"ARCEDGE SECURITIES PRIVATE LIMITED",
"ARCEDGES BUILDING (INDIA) LLP",
"ARCEE ELECTRONICS",
"ARCEE INDUSTRIES LIMITED",
"ARCEE MARBLES PRIVATE LIMITED",
"ARCELL SENSOTRONIC INDIA PRIVATE LIMITED",
"ARCELORMITTAL NEEL TAILORED BLANKS PRIVATE LIMITED",
"ARCELORMITTAL NEEL TT PRIVATE LIMITED",
"ARCELORMITTAL NIPPON STEEL INDIA LIMITED",
"ARCELORMITTAL PROJECTS INDIA PRIVATE LIMITED",
"ARCELORMITTAL VENTURES INDIA PRIVATE LIMITED",
"ARCESIUM INDIA PRIVATE LIMITED",
"ARCEUS INFOTECH PRIVATE LIMITED",
"ARCH ARCHITECTS PVT LTD",
"ARCH BIOTECH PRIVATE LIMITED",
"ARCH CONCEPT PRIVATE LIMITED",
"ARCH CONSULTANCY SERVICES PRIVATE",
"ARCH EDUCATION SOCEITY",
"ARCH ELEVATORS PRIVATE LIMITED",
"ARCH FINANCE LIMITED",
"ARCH INFRA PROPERTIES PRIVATE LIMITED AIPPL",
"ARCH INTERSOL PRIVATE LIMITED",
"ARCH LINE DESIGNS PRIVATE LIMITED",
"ARCH PHARMALABS LIMITED",
"ARCH PROJECT SOLUTIONS PRIVATE LIMITED",
"ARCH PROTECTION CHEMICALS PRIVATE LIMITED",
"ARCH RETAILS LIMITED",
"ARCH SPICES PRIVATE LIMITED",
"ARCH WING CONSTRUCTION CONSULTANTS PRIVATE LIMITED",
"ARCHA PACKAGING PRIVATE LIMITED",
"ARCHAEOLOGICAL SURVEY OF INDIA",
"ARCHAIC PROPERTIES PRIVATE LIMITED",
"ARCHAME INTERMEDIATE PRIVATE LIMITED",
"ARCHAN POLYFILMS PRIVATE LIMITED",
"ARCHANA ADVERTISING PRIVATE LIMITED",
"ARCHANA APPARELS PRIVATE LIMITED",
"ARCHANA HOSPITALS PRIVATE LIMITED",
"ARCHANA IMAGING & RESEARCH CENTRE PRIVATE LIMITED",
"ARCHANA IRON TRADERS PRIVATE LIMITED",
"ARCHANA KAPIL ASSOCIATES PRIVATE LIMITED",
"ARCHANA LABELS PRIVATE LIMITED",
"ARCHANA OVERSEAS INDIA PRIVATE LIMITED",
"ARCHANA PAPER PRODUCTS PRIVATE LIMITED",
"ARCHANA PRINTING AND CHEMICALS PVT LTD",
"ARCHANA TRADERS PRIVATE LIMITED",
"ARCHANGEL CONSORTIUM PRIVATE LIMITED",
"ARCHANGEL LEASING AND INFOTECH PRIVATE LIMITED",
"ARCHANGEL PROJECTS PRIVATE LIMITED",
"ARCHAPOULE HOLDINGS PVT LTD",
"ARCHATELIE INDIA PRIVATE LIMITED",
"ARCHCON INFRASTRUCTURE INDIA PRIVATE LIMITED",
"ARCHCON STRUCTURAL PRIVATE LIMITED",
"ARCHEAN CHEMICAL INDUSTRIES LIMITED",
"ARCHEAN CHEMICAL INDUSTRIES PRIVATE LIMITED",
"ARCHEAN INDUSTRIES PRIVATE LIMITED",
"ARCHEAN MARBLES AND TILES PRIVATE LIMITED",
"ARCHEE GROUP CONTRACTS PRIVATE. LIMITED.",
"ARCHEE LOGISTICS PRIVATE LIMITED",
"ARCHEES CREATION PRIVATE LIMITED",
"ARCHEESH HEALTH CARE PRIVATE LIMITED",
"ARCHELONS CONSULTING PRIVATE LIMITED",
"ARCHEM TRADEX PRIVATE LIMITED",
"ARCHENTS IT INDIA PRIVATE LIMITED",
"ARCHER DANIELS MIDLAND",
"ARCHER HOSPITALITY PRIVATE LIMITED",
"ARCHER INTEGRATED SERVICES PRIVATE LIMITED",
"ARCHER TECHNOLOGIES PRIVATE LIMITED",
"ARCHER TOURS PRIVATE LIMITED",
"ARCHER TRANSNATIONAL SYSTEMS PRIVATE LIMITED",
"ARCHERON CORPORATE SERVICES LLP",
"ARCHERPOINT INDIA PRIVATE LIMITED",
"ARCHETIVE SOLUTIONS PRIVATE LIMITED",
"ARCHETYPE AGENCY PRIVATE LIMITED",
"ARCHETYPE CONSULTANTS INDIA PRIVATE LIMITED",
"ARCHETYPE ENGINEERING & INDUSTRY PRIVATE LIMITED",
"ARCHETYPE INDIA CONSTRUCTION CONSULTANTS PRIVATE LIMITED",
"ARCHGROUP INTERNATIONAL ARCHITECTS PRIVATE LIMITED",
"ARCHI CIVIL CONSTRUCTION PRIVATE LIMITED",
"ARCHI EXIM PRIVATE LIMITED",
"ARCHI MEDES INDIA CONSULTANTS PRIVATE LIMITED",
"ARCHI STEEL WIRES PVT. LTD.",
"ARCHID POULTRY PRODUCTS PRIVATE LIMITED",
"ARCHIDPLY DECOR LIMITED",
"ARCHIDPLY INDUSTRIES LIMITED",
"ARCHIE AND JUGHEAD INDIA PRIVATE LIMITED",
"ARCHIEDIAM PRIVATE LIMITED",
"ARCHIELECTO",
"ARCHIES LIMITED",
"ARCHIKA ENTERPRISES PRIVATE LIMITED",
"ARCHILUM BUILDING SOLUTIONS PRIVATE LIMITED",
"ARCHIMEDES INDIA ASSOCIATES",
"ARCHIMEDIS HEALTHCARE PRIVATE LIMITED",
"ARCHIMEDIS LABORATORIES PRIVATE LIMITED",
"ARCHIMETRY INFRASTRUCTURES PRIVATE LIMITED",
"ARCHINOVA DESIGN PRIVATE LIMITED",
"ARCHINTEX ARCHITECTURALS PRIVATE LIMITED",
"ARCHIPEL TECHNOLOGIES PRIVATE LIMITED",
"ARCHIS INTERNATIONAL PRIVATE LIMITED",
"ARCHIS PACKAGING INDIA PRIVATE LIMITED",
"ARCHISH FERTILITY SOLUTIONS PRIVATE LIMITED",
"ARCHIT ELECTRICALS PVT LTD",
"ARCHIT EXIM PRIVATE LIMITED",
"ARCHIT NUWOOD INDUSTRIES LIMITED",
"ARCHIT NUWOOD INDUSTRIES PRIVATE LIMITED",
"ARCHIT ORGANOSYS LIMITED",
"ARCHIT PLYWOOD PRIVATE LIMITED",
"ARCHIT TRADING CO.",
"ARCHITA AD WORLD TECHNOLOGIES PRIVATE LIMITED",
"ARCHITA SHUDHI INDUSTRIES PRIVATE LIMITED",
"ARCHITECH HAFEEZ CONTRACTOR",
"ARCHITECT NARRAYAN AND ASSOCIATES PRIVATE LIMITED",
"ARCHITECTURAL ENERGY SOLUTIONS PRIVATE LIMITED",
"ARCHITECTURAL LIGHTING CONCEPTS PRIVATE LIMITED",
"ARCHITECTURE INTERIOR CONSTRUCTION",
"ARCHIVERS EXIM PRIVATE LIMITED",
"ARCHIVISTA ENGINEERING PROJECTS PRIVATE LIMITED",
"ARCHKONS DESIGN PRIVATE LIMITED",
"ARCHMED BIOTECH PRIVATE LIMITED",
"ARCHNA DISTRIBUTORES PVT LTD",
"ARCHNA DYEING AND PRINTING MILLS PRIVATE LIMITED",
"ARCHNA RUBBERS PVT LTD",
"ARCHNIRMAN PVT LTD",
"ARCHOHM CONSULTS PRIVATE LIMITED",
"ARCHON AIRCOMFORT SOLUTION PRIVATE LIMITED",
"ARCHON CONSULTINGSYSTEMS PRIVATE LIMITED",
"ARCHON HEALTHCARE PRIVATE LIMITED",
"ARCHON POWERINFRA INDIA PRIVATE LIMITED",
"ARCHON STEEL BUILDING SYSTEMS PRIVATE LIMITED",
"ARCHONICS TECHNOLOGIES PRIVATE LIMITED",
"ARCHOS CONSULTANTS & ENGINEERS LIMITED",
"ARCHROMA INDIA PRIVATE LIMITED",
"ARCHROMA INTERNATIONAL (INDIA) PRIVATE LIMITED",
"ARCHSONE PROPERTIES (INDIA ) PRIVATE LIMITED",
"ARCHSUNIL INFRA PROJECTS PRIVATE LIMITED",
"ARCHTECH CONSULTANTS PVT LTD",
"ARCHWAY VENTURES INTERNATIONAL PRIVATE LIMITED",
"ARCHWORKX PROSYS PRIVATE LIMITED",
"ARCHY SERVICES PRIVATE LIMITED",
"ARCHY TECHNOVENTURES PRIVATE LIMITED",
"ARCING SOLUTIONS INDIA PRIVATE LIMITED",
"ARCION REVITALIZATION PRIVATE LIMITED",
"ARCIS E SERVICES PRIVATE LIMITED",
"ARCK CONSULTANTS PRIVATE LIMITED",
"ARCL ORGANICS LIMITED",
"ARCLEGUM MANAGEMENT PRIVATE LIMITEE",
"ARCLIGHT FACILITIES PRIVATE LIMITED",
"ARCLIGHTS EVENTZ NETWORK PRIVATE LIMITED",
"ARCLITE BEVERAGES PRIVATE LIMITED",
"ARCO APPARELS PRIVATE LIMITED",
"ARCO ELECTRO TECHNOLOGIES PRIVATE LIMITED",
"ARCO GIFT PRODUCTS PRIVATE LIMITED",
"ARCO INFRACON PRIVATE LIMITED",
"ARCO LAB PRIVATE LIMITED",
"ARCO LIFE SCIENCES (INDIA) PRIVATE LIMITED",
"ARCO PHARMA PRIVATE LIMITED",
"ARCO STEEL PRIVATE LIMITED",
"ARCOFEMI HEALTHCARE PRIVATE LIMITED",
"ARCOM MEDICAL DEVICES PRIVATE LIMITED",
"ARCOM PAPERS PRIVATE LIMITED",
"ARCON CONTAINER PRIVATE LIMITED",
"ARCON HOMEBUILDERS PRIVATE LIMITED",
"ARCON POWERTRANS PRIVATE LIMITED",
"ARCON SEEDS PRIVATE LIMITED",
"ARCON SYSTEMS PRIVATE LIMITED",
"ARCON TECHSOLUTIONS PRIVATE LIMITED",
"ARCONIC OF INDIA PRIVATE LIMITED",
"ARCONIKH INTERNATIONAL PRIVATE LIMITED",
"ARCONS INFRASTRUCTURES AND CONSTRUCTIONS PRIVATE LIMITED",
"ARCONS TECHNOLOGY PRIVATE LIMITED",
"ARCOS SKILL MANAGEMENT SERVICES PRIVATE LIMITED",
"ARCOSIL INDIA PRIVATE LIMITED",
"ARCOT MANIMARK FOODS PRIVATE LIMITED",
"ARCOT R AND D SOFTWARE PRIVATE LIMITED",
"ARCOT SOLES PRIVATE LIMITED",
"ARCOY FINECHEM PRIVATE LIMITED",
"ARCOY INDIA PRIVATE LIMITED",
"ARCOY INDUSTRIES INDIA PRIVATE LIMITED",
"ARCRAFT PLASMA EQUIPMENTS (INDIA) PVT LTD",
"ARCREATION DESIGN PRIVATE LIMITED",
"ARCS TECHNOLOGIES PRIVATE LIMITED",
"ARCSERVE INDIA SOFTWARE SOLUTIONS PRIVATE LIMITED",
"ARCSINE SOFTWARE PRIVATE LIMITED",
"ARCSTONE INFRASTRUCTURE PRIVATE LIMITED",
"ARCTECH SOLAR INDIA PRIVATE LIMITED",
"ARCTELIC INC",
"ARCTERN CONSULTING PRIVATE LIMITED",
"ARCTIC AIRCON PRIVATE LIMITED",
"ARCTIC COOL SALES AND SERVICE PRIVATE LIMITED",
"ARCTIC HVAC ENGINEERING PRIVATE LIMITED",
"ARCTIC INFRA TECH SOLUTIONS PRIVATE LIMITED",
"ARCTIC LOGISTICS INDIA PRIVATE LIMITED",
"ARCTIC REFRIGERATION PRIVATE LIMITED",
"ARCTIC SHIPPING SERVICES PRIVATE LIMITED",
"ARCTIC TERN FARM PRODUCTS PRIVATE LIMITED",
"ARCUM ENGINEERING PRIVATE LIMITED",
"ARCUS AUTOMATION PRIVATE LIMITED",
"ARCUS AUTOTECH PRIVATE LIMITED",
"ARCUS MARKETING PRIVATE LIMITED",
"ARCV HOLDINGS PRIVATE LIMITED",
"ARCVAC FORGE CAST PRIVATE LIMITED",
"ARCWELD ENGINEERS PRIVATE LIMITED",
"ARD ESTATES AND PROJECTS PRIVATE LIMITED",
"ARD INDUSTRIES PRIVATE LIMITED",
"ARD INFORMATION SYSTEMS PRIVATE LIMITED",
"ARD POLYPACKS PRIVATE LIMITED",
"ARDA POLYMERS PRIVATE LIMITED",
"ARDAN PLASTIC INDUSTRIES PRIVATE LIMITED",
"ARDANUY INDIA PRIVATE LIMITED",
"ARDAS CONSTRUCTION AND SUPPLIERS PRIVATE LIMITED",
"ARDAS TELE VENTURES PRIVATE LIMITED",
"ARDEE DRIVES PRIVATE LIMITED",
"ARDEE ENGINEERING PRIVATE LIMITED",
"ARDEE INDUSTRIES PRIVATE LIMITED",
"ARDEE INFRASTRUCTURE PRIVATE LIMITED",
"ARDEE KOMFAB PRIVATE LIMITED",
"ARDEE MAINTENANCE SERVICES PRIVATE LIMITED",
"ARDEE REAL ESTATE & HOUSING PRIVATE LIMITED",
"ARDEEC ENGINEERING (SAURASHTRA) PVT LTD",
"ARDELISYS TECHNOLOGIES PRIVATE LIMITED",
"ARDEM DATA SERVICES PRIVATE LIMITED",
"ARDEN ASIA PACIFIC SOFTWARE PRIVATE LIMITED",
"ARDEN HEALTH CARE PRIVATE LIMITED",
"ARDENT AVENUES LIMITED",
"ARDENT CONTAINER PRIVATE LIMITED",
"ARDENT DEALERS PRIVATE LIMITED",
"ARDENT FACILITIES PRIVATE LIMITED",
"ARDENT IMPEX PRIVATE LIMITED",
"ARDENT INFRA EQUIPMENTS PRIVATE LIMITED",
"ARDENT LIFE SCIENCES PRIVATE LIMITED",
"ARDENT PROPERTIES PRIVATE LIMITED",
"ARDENT SILICON PRIVATE LIMITED",
"ARDENT STEEL LIMITED",
"ARDENT STEEL PRIVATE LIMITED",
"ARDENTIA TECHNOLOGIES PRIVATE LIMITED",
"ARDESHIR B CURSETJEE AND SONS LIMITED",
"ARDEX ENDURA (INDIA) PRIVATE LIMITED",
"ARDH METALS AND ALLOYS PRIVATE LIMITED",
"ARDH SAINIK CANTEEN LIMITED",
"ARDH SAINIK SERVICES PRIVATE LIMITED",
"ARDHA HOLDING PRIVATE LIMITED",
"ARDHAM LOGISTICS AND INFRASTRUCTURE PRIVATE LIMITED",
"ARDHAS TECHNOLOGY INDIA PRIVATE LIMITED",
"ARDHENDU MONDAL",
"ARDHIKA SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"ARDHINUSA DRILLING PRIVATE LIMITED",
"ARDIDRA TECHNOLOGIES PRIVATE LIMITED",
"ARDIKA TECHNO SOLUTIONS PRIVATE LIMITED",
"ARDISONS ASSOCIATES",
"ARDISONS OILS AND ELECTRICALS PVT LTD",
"ARDIT STEELS PRIVATE LIMITED",
"ARDITI INDIA PRIVATE LIMITED",
"ARDMORE HEALTHCARE PRIVATE LIMITED",
"ARDOM TELECOM PRIVATE LIMITED",
"ARDOM TOWERGEN PRIVATE LIMITED",
"ARDONAN PACKAGING INDUSTRIES PRIVATE LIMITED",
"ARDOR DRUGS PRIVATE LIMITED",
"ARDOR ELEVATORS PRIVATE LIMITED",
"ARDOR GLOBAL PRIVATE LIMITED AGPL",
"ARDOR HOSPITALITY PRIVATE LIMITED",
"ARDOUR FINMAN PRIVATE LIMITED",
"ARDOUR PACK PRIVATE LIMITED",
"ARDOZAA FASHIONS PRIVATE LIMITED",
"ARDRA CONSULTING SERVICES PRIVATE LIMITED",
"ARDUR TECHSERV PRIVATE LIMITED",
"ARE ENTERTAINMENT LIMITED",
"ARE INFRA HEIGHTS PRIVATE LIMITED",
"ARE METAL ENGINEERING PRIVATE LIMITED",
"ARE METAL INDIA PRIVATE LIMITED",
"AREA 27 PRIVATE LIMITED",
"AREA SOFTWARE SOLUTIONS INDIA PRIVATE LIMITED",
"AREBEE STAR MARITIME AGENCIES PRIVATE LIMITED",
"ARECA EMBEDDED SYSTEMS PRIVATE LIMITED",
"ARECO CONSULTING AND ENGINEERING (INDIA) PRIVATE LIMITED",
"AREEM TECHNO INDIA PRIVATE LIMITED",
"AREEN ENTRANCE AUTOMATION PRIVATE LIMITED",
"AREETE LIFE SCIENCE PRIVATE LIMITED",
"AREHK HEALTHCARE PRIVATE LIMITED",
"AREION ASSETS MANAGEMENT PRIVATE LIMITED",
"AREION FINSERVE PRIVATE LIMITED",
"AREION HOSPITALS PRIVATE LIMITED",
"AREION INDUSTRIES PRIVATE LIMITED",
"AREION LOGISTICS PRIVATE LIMITED",
"AREIS ELECTRONIC INDUSTRIES PRIVATE LIMITED",
"AREK INDUSTRIES PRIVATE LIMITED",
"ARELI COMMERCE PRIVATE LIMITED",
"AREMPEE COMPRESSORS PRIVATE LIMITED",
"AREN ROCKTECH PRIVATE LIMITED",
"ARENA ANIMATION",
"ARENA EQUIPMENTS PRIVATE LIMITED",
"ARENA FOOD AND AGRO INDUSTRIES PRIVATE LIMITED",
"ARENA ITECH OPC PRIVATE LIMITED",
"ARENA LIFESTYLE PRIVATE LIMITED",
"ARENA MEDICAL CARE PRIVATE LIMITED",
"ARENA MOBILE PRIVATE LIMITED",
"ARENA ORCHARDS PRIVATE LIMITED",
"ARENA OVERSEAS PRIVATE LIMITED",
"ARENA WORLDWIDE LOGISTICS PRIVATE LIMITED",
"ARENDELLE PRIVATE LIMITED",
"ARENE LIFE SCIENCES (UNIT 3) PRIVATE LIMITED",
"ARENE LIFE SCIENCES PRIVATE LIMITED",
"ARENECH MEDICAL ENTERPRISES PRIVATE LIMITED",
"AREO AGENCIES LIMITED",
"ARERA HEALTHCARE & TECHNOLOGIES PRIVATE LIMITED",
"ARES ERECTORS PRIVATE LIMITED",
"ARES OPERATIONS INDIA LLP",
"ARES SAFETY SOLUTIONS PRIVATE LIMITED",
"ARESKO RESTAURANTS PRIVATE LIMITED",
"ARESS HIGH DUTY FORGINGS PVT LTD",
"ARESS SIGN CORP PRIVATE LIMITED",
"ARESS SOFTWARE AND EDUCATION TECHNOLOGIES PRIVATE LIMITED",
"ARETA PROPERTY SERVICES PRIVATE LIMITED",
"ARETAEUS PHARMACEUTICALS PRIVATE LIMITED",
"ARETE AUTOMATION SYSTEMS PRIVATE LIMITED",
"ARETE CAPITAL SERVICE PRIVATE LIMITED",
"ARETE CONSTRUCTIONS PRIVATE LIMITED",
"ARETE CONSULTANTS PRIVATE LIMITED",
"ARETE ENGINEERING PRIVATE LIMITED",
"ARETE HOSPITALS",
"ARETE INDIA PROJECTS PRIVATE LIMITED",
"ARETE MANUFACTURING SERVICES PRIVATE LIMITED",
"ARETE POWERTECH PRIVATE LIMITED",
"ARETE SECURITIES LIMITED",
"ARETE SERVICES PRIVATE LIMITED",
"ARETEINFO TECHNOLOGIES PRIVATE LIMITED",
"ARETE-IR LLP",
"ARETHOS VENTURES PRIVATE LIMITED",
"ARETOVE TECHNOLOGIES INDIA PRIVATE LIMITED",
"AREVA DEVELOPERS",
"AREVA LIFE STYLE PRODUCTS PRIVATE LIMITED",
"AREVA LOGISTICS PRIVATE LIMITED",
"AREVA PAINTS PRIVATE LIMITED",
"AREVA SYSTEM CONSULTANCY PRIVATE LIMITED",
"AREVIN FINE CHEMICALS INDIA PRIVATE LIMITED",
"AREX INDUSTRIES LIMITED",
"AREYA PACKAGING PRIVATE LIMITED",
"AREYA TECHNOLOGIES PRIVATE LIMITED",
"AREZZO SKY INDIA PRIVATE LIMITED",
"ARF DESIGN PRIVATE LIMITED",
"ARF ELECTRODES PRIVATE LIMITED",
"ARFIN INDIA LIMITED.",
"ARG CONSULTING PRIVATE LIMITED",
"ARG DEVELOPERS PRIVATE LIMITED",
"ARG E COM PRIVATE LIMITED",
"ARG ELECTRICALS PRIVATE LIMITED",
"ARG HOUSING PRIVATE LIMITED",
"ARG INFRA DEVELOPERS PRIVATE LIMITED",
"ARG OIL AND GAS INDUSTRIES PRIVATE LIMITED",
"ARG OUTLIER MEDIA PRIVATE LIMITED",
"ARG PACK PLAST PRIVATE LIMITED",
"ARG ROYAL ENSIGN DEVELOPERS PRIVATE LIMITED",
"ARG STEEL AND POWER PRIVATE LIMITED",
"ARGA INVESTMENT MANAGEMENT INDIA PRIVATE LIMITED",
"ARGALI KNOWLEDGE SERVICES PRIVATE LIMITED",
"ARGANIC GREEN POWER PRIVATE LIMITED",
"ARGANO ORGANIC LIMITED",
"ARGANSHE PRIVATE LIMITED",
"ARGEE PLASTICS PVT LTD",
"ARGENT CONSTRUCTIONS PRIVATE LIMITED",
"ARGENT PROPERTIES PRIVATE LIMITED",
"ARGENTIUM INTERNATIONAL PRIVATE LIMITED",
"ARGENTUM ALLOYS PRIVATE LIMITED",
"ARGHA SHARES AND STOCKS PRIVATE LIMITED",
"ARGHA TECHNOLOGY SERVICES INDIA PRIVATE LIMITED",
"ARGHADEEP DEVELOPERS PRIVATE LIMITED",
"ARGHAMA COLD STORAGE PRIVATE LIMITED",
"ARGHODEEP CONSTRUCTIONS PVT LTD",
"ARGHYA ENGINEERING PRIVATE LIMITED",
"ARGIA DESTINATIONS PRIVATE LIMITED",
"ARGIL SPC FLOORING CO.",
"ARGL LIMITED",
"ARGO FOOD STUFF PRIVATE LIMITED",
"ARGO LIGHTING PRIVATE LIMITED",
"ARGO SOLAR PRIVATE LIMITED",
"ARGO TECH INDIA PRIVATE LIMITED",
"ARGO TRADING INDIA PRIVATE LIMITED",
"ARGO TRANSFORMERS COMPANY PRIVATE LIMITED",
"ARGO-HYTOS PRIVATE LIMITED",
"ARGON AIR GASES PRIVATE LIMITED",
"ARGON HOTELS PRIVATE LIMITED",
"ARGON INFOTECH",
"ARGONAUT INVESTMENT ADVISORS PRIVATE LIMITED",
"ARGOS CONSULTANTS PRIVATE LIMITED",
"ARGOS HOSPITALITY LIMITED",
"ARGOS INTERNATIONAL MARKETING PRIVATE LIMITED",
"ARGOS PLASTICS PRIVATE LIMITED",
"ARGOSY TRAVELS PRIVATE LIMITED",
"ARGUNT AGGREGATES PRIVATE LIMITED",
"ARGUS COSMETICS LIMITED",
"ARGUS DYECHEM PRIVATE LIMITED",
"ARGUS ELECTRONIC SECURITY SYSTEMS PRIVATE LIMITED",
"ARGUS EMBEDDED SYSTEMS PRIVATE LIMITED",
"ARGUS INDIA PRICE REPORTING SERVICES LLP",
"ARGUS INTEGRATED SYSTEMS PRIVATE LIMITED",
"ARGUS LOGISTICS PRIVATE LIMITED",
"ARGUS MOTORS PRIVATE LIMITED",
"ARGUSOFT INDIA LIMITED",
"ARGYLE HR SOLUTIONS PRIVATE LIMITED",
"ARH & CLUB PRIVATE LIMITED",
"ARH ELECTROWAVE INDIA PRIVATE LIMITED",
"ARH TECHNOLOGIES PRIVATE LIMITED",
"ARHA ETERNAL JEWELS PRIVATE LIMITED",
"ARHA MEDIA & BROADCASTING PRIVATE LIMITED",
"ARHAAN LIFE STYLE PRIVATE LIMITED",
"ARHAM AGRO PRIVATE LIMITED",
"ARHAM ALLOY & STEEL PRIVATE LIMITED",
"ARHAM BUILDERS PRIVATE LIMITED",
"ARHAM BULLION PRIVATE LIMITED",
"ARHAM CARRIERS PRIVATE LIMITED",
"ARHAM CEMENT & ALLIED PRODUCTS PRIVATE LIMITED",
"ARHAM COLD STORAGE PRIVATE LIMITED",
"ARHAM CRAFT PRIVATE LIMITED",
"ARHAM CREATION PVT LTD",
"ARHAM DRUGS AND CHEMICALS PRIVATE LIMITED",
"ARHAM DYEING & BLEACHINGS PVT LTD",
"ARHAM ENERGY LIMITED",
"ARHAM ENGITECH PRIVATE LIMITED",
"ARHAM FABRICS PRIVATE LIMITED",
"ARHAM INFRABUILD LIMITED",
"ARHAM IRON LIMITED",
"ARHAM IT INFRASTRUCTURE PRIVATE LIMITED",
"ARHAM OIL GAS PRODUCTS AND SERVICES PRIVATE LIMITED",
"ARHAM ORGANOSYS PRIVATE LIMITED",
"ARHAM PETROCHEM PRIVATE. LIMITED.",
"ARHAM PLASTO TECH PRIVATE LIMITED",
"ARHAM POLY PRINTS (I) PRIVATE LIMITED",
"ARHAM POLYMERS PRIVATE LIMITED",
"ARHAM RESOURCES PRIVATE LIMITED",
"ARHAM SHARE PRIVATE LIMITED",
"ARHAM SHUDH WATER & METALS PRIVATE LIMITED",
"ARHAM SOFTWARE LLP",
"ARHAM SUITINGS PRIVATE LIMITED",
"ARHAM TECHNOCAST PRIVATE LIMITED",
"ARHAM TECHNOLOGIES LIMITED",
"ARHAM TECHNOPLAST PRIVATE LIMITED",
"ARHAM TECHNOSOFT PRIVATE LIMITED",
"ARHAM TECHPLAST PRIVATE LIMITED",
"ARHAM TOOLS PRIVATE LIMITED",
"ARHAM TRANSPORTATION PRIVATE LIMITED",
"ARHAM WEALTH MANAGEMENT PRIVATE LIMITED",
"ARHAMANYA VENTURES PRIVATE LIMITED",
"ARHAN POWER PRIVATE LIMITED",
"ARHAN TECHNOLOGIES PRIVATE LIMITED",
"ARHAT ARHAM LIFESPACE REALTORS PRIVATE LIMITED",
"ARHAT CORPORATE PRIVATE LIMITED",
"ARHAT GLOBAL LOGISTICS PRIVATE LIMITED",
"ARHAT TALENT SOLUTIONS PRIVATE LIMITED",
"ARHAT WOOD PRIVATE LIMITED",
"ARHAY NATH STEELS PRIVATE LIMITED",
"ARHCOM BUSINESS VENTURES PRIVATE LIMITED",
"ARHUM ERECTORS LLP",
"ARHYAMA SOLAR POWER PRIVATE LIMITED",
"ARI ARMATUREN STEAMLINE LLP",
"ARI AUROBINDO JR COLLEGE",
"ARI CONSOLIDATED INVESTMENTS PRIVATE LIMITED",
"ARI HEALTHCARE PRIVATE LIMITED",
"ARI INNOVATION AND SKILLS (OPC) PRIVATE LIMITED",
"ARI POLYRUB PRIVATE LIMITED",
"ARIA AERIAL PLATFORMS PRIVATE LIMITED",
"ARIA DAIRY FARMS PRIVATE LIMITED",
"ARIA DIGITAL SOLUTIONS PRIVATE LIMITED",
"ARIA INFRAPROJECTS PRIVATE LIMITED",
"ARIA INTERNATIONAL LIMITED",
"ARIA RETAIL PRIVATE LIMITED",
"ARIA TELECOM SOLUTIONS PRIVATE LIMITED",
"ARIAL SPACE TECHNOLOGIES & SYSTEMS PRIVATE LIMITED",
"ARIANCE ORGACHEM PRIVATE LIMITED",
"ARIANDO INFRA MACHINES INDIA PRIVATE LIMITED",
"ARIANE SEEDS INDIA PRIVATE LIMITED",
"ARIANT VEG PRIVATE LIMITED",
"ARIATRAVEL SERVICES PRIVATE LIMITED",
"ARIBA FOODS PRIVATE LIMITED",
"ARIBA INDIA PRIVATE LIMITED",
"ARIBA TECHNOLOGIES INDIA PRIVATE LIMITED",
"ARIC ENGINEERS PRIVATE LIMITED",
"ARICA HEALTH AND WELLNESS PRIVATE LIMITED",
"ARICENT BUSINESS SOLUTIONS PRIVATE LIMITED",
"ARICENT TECHNOLOGIES HOLDINGS LIMITED",
"ARICENT TECHNOLOGIES PRIVATE LIMITED",
"ARICHA TRADING CO LTD",
"ARICIA INDIA INTERNATIONAL PRIVATE LIMITED",
"ARICIA SOURCING PRIVATE LIMITED",
"ARICO MARINE CONSULTANTS P.LTD.",
"ARICON PAPERS PRIVATE LIMITED",
"ARID COMMUNITIES AND TECHNOLOGIES",
"ARIDHI VANIJYA PVT. LTD.",
"ARIEL SOFTWARE SOLUTIONS PRIVATE LIMITED",
"ARIEL TECHNOLOGIES PRIVATE LIMITED",
"ARIELLE SOURCING PRIVATE LIMITED",
"ARIEM TECHNOLOGIES PRIVATE LIMITED",
"ARIEN GLOBAL LIFESTYLE PRIVATE LIMITED",
"ARIEN IMPEX PRIVATE LIMITED",
"ARIENS NETCOM SOLUTION PRIVATE LIMITED",
"ARIEOTECH SOLUTIONS PRIVATE LIMITED",
"ARIES AGRO LIMITED",
"ARIES COLORCHEM PRIVATE LIMITED",
"ARIES CONTAINER TERMINAL PRIVATE LIMITED",
"ARIES CORPORATE SERVICES PRIVATE. LIMITED.",
"ARIES DRUGS PRIVATE LIMITED",
"ARIES EXIM COMPANY PRIVATE LIMITED",
"ARIES EXPORT PRIVATE LIMITED",
"ARIES FABRICATORS PRIVATE LIMITED",
"ARIES FASHIONS PRIVATE LIMITED",
"ARIES IMMIGRATION SERVICES PRIVATE LIMITED",
"ARIES INDIA EARTHMOVERS PRIVATE LIMITED",
"ARIES MARINE & ENGINEERING SERVICES PRIVATE LIMITED",
"ARIES ORGANICS PRIVATE LIMITED",
"ARIES PLASTICS PRIVATE LIMITED",
"ARIES POWER SYSTEMS (INDIA) PRIVATE LIMITED",
"ARIES RETAIL PRIVATE LIMITED",
"ARIES TANKS AND VESSELS PRIVATE LIMITED",
"ARIES TECHNICAL SALES AND SERVICE PRIVATE LIMITED",
"ARIES TELECASTING PRIVATE LIMITEDARIES TELECASTING PRIVATE LIMITED",
"ARIES TIE-UP PRIVATE LIMITED",
"ARIETIS HEALTHCARE PRIVATE LIMITED",
"ARIF INDUSTRIES LIMITED",
"ARIFEEN D FRESH PRIVATE LIMITED",
"ARIFIC BUSINESS SOLUTIONS PRIVATE LIMITED",
"ARIGEN TECHNOLOGY PRIVATE LIMITED",
"ARIGHT SERVICES PRIVATE LIMITED",
"ARIGHTCO CONSULTING PRIVATE LIMITED",
"ARIGNAR ANNA ENGINEERING COLLEGE",
"ARIGNAR ANNA GOVT HOSP OF IND MEDIC",
"ARIHA DIAMOND JWELLERY PRIVATE LIMITED",
"ARIHAA SOLAR PRIVATE LIMITED",
"ARIHANT",
"ARIHANT 925 JEWELLERY PRIVATE LIMITED",
"ARIHANT AASHIYANA PRIVATE LIMITED",
"ARIHANT ABODE LIMITED",
"ARIHANT ACADEMY LIMITED",
"ARIHANT ADROIT INFOSYSTEMS PRIVATE LIMITED",
"ARIHANT AGRICULTURE PRODUCTTS PRIVATE LIMITED",
"ARIHANT AGRIFOODS PRIVATE LIMITED",
"ARIHANT ALLOYS AND FORGE PRIVATE LIMITED",
"ARIHANT ALU-GLASS SYSTOM PRIVATE LIMITED",
"ARIHANT ANALYTICAL LABORATORY PRIVATE LIMITED",
"ARIHANT APPARELS",
"ARIHANT AYUR COSMO PRIVATE LIMITED",
"ARIHANT BEARING SERVICES PVT LTD",
"ARIHANT BELTING PRIVATE LIMITED",
"ARIHANT BIO FERTICHEM PRIVATE LIMITED",
"ARIHANT BUILDCON PRIVATE LIMITED",
"ARIHANT BUILDERS DEVELOPERS & INVESTORS PVT LTD",
"ARIHANT BUILDTECH PRIVATE LIMITED",
"ARIHANT CAPITAL MARKETS LIMITED",
"ARIHANT CARGO CARRIERS PVT LTD",
"ARIHANT CARRIER INDIA PRIVATE LIMITED",
"ARIHANT CARTONS PRIVATE LIMITED",
"ARIHANT CASTOR EXPORTS LIMITED",
"ARIHANT CHEMICALS INDUSTRIES LTD",
"ARIHANT CHEMOX & LAMINATES PRIVATE LIMITED",
"ARIHANT CLASSIC FINANCE LIMITED",
"ARIHANT CLAYS PRIVATE LIMITED",
"ARIHANT CLOTHING PRIVATE LIMITED",
"ARIHANT CNC PRIVATE LIMITED",
"ARIHANT COMMO-DERIVATIVES PRIVATE LIMITED",
"ARIHANT COMPUTRONICS PRIVATE LIMITED",
"ARIHANT CONSTRUCTION JALGAON",
"ARIHANT CONTRACTORS PRIVATE LIMITED",
"ARIHANT CORPORATE SERVICES LIMITED",
"ARIHANT DENIMS PRIVATE LIMITED",
"ARIHANT DETERGENTS PRIVATE LIMITED",
"ARIHANT DIES & MOULDS PRIVATE LIMITED",
"ARIHANT DIGITAL",
"ARIHANT DIGITAL WORLD PRIVATE LIMITED",
"ARIHANT DREAM INFRA PROJECTS LIMITED",
"ARIHANT DREAM PROJECTS PRIVATE LIMITED",
"ARIHANT DREDGING DEVELOPERS PRIVATE LIMITED",
"ARIHANT DRILLINGS PRIVATE LIMITED",
"ARIHANT DURAPLAST PRIVATE LIMITED",
"ARIHANT DYESTUFF PRIVATE LIMITED",
"ARIHANT EDIFICE PRIVATE LIMITED",
"ARIHANT EDU WEB PRIVATE LIMITED",
"ARIHANT EDUCARE PRIVATE LIMITED",
"ARIHANT EDUCATION FOUNDATION",
"ARIHANT ELECTRICALS PRIVATE. LIMITED",
"ARIHANT ELECTRO TRANSWORLD LLP",
"ARIHANT ELSYS PRIVATE LIMITED",
"ARIHANT ENTERPRISES",
"ARIHANT E-RECYCLING LIMITED",
"ARIHANT ESTATES PRIVATE LIMITED",
"ARIHANT EVERGREEN AGRO PLAST AND TEXTILES PRIVATE LIMITED",
"ARIHANT FABRITEX PRIVATE LIMITED",
"ARIHANT FERROALLOYS PRIVATE LIMITED",
"ARIHANT FERTILISER AND CHEMICALS INDIA LIMITED",
"ARIHANT FINANCIAL SERVICES LIMITED",
"ARIHANT FINVENTURE PRIVATE LIMITED",
"ARIHANT FLEXI PACK",
"ARIHANT FLEXI PACK PRIVATELIMITED",
"ARIHANT FOAM PRIVATE LIMITED",
"ARIHANT FOREX PRIVATE LIMITED",
"ARIHANT FOUNDATIONS & HOUSING LIMITED",
"ARIHANT FUTURES AND COMMODITIES LIMITED",
"ARIHANT GEMS AND JEWELLERIES PRIVATE LIMITED",
"ARIHANT GOLD AND SILVER PRIVATE LIMITED",
"ARIHANT GOLD PLAST PRIVATE LIMITED",
"ARIHANT GRANIMARMO PRIVATE LIMITED",
"ARIHANT HOSPITAL",
"ARIHANT INDUSTRIAL CORPORATION LIMITED",
"ARIHANT INFOMARKETING PRIVATE LIMITED",
"ARIHANT INFRAREALTY PRIVATE LIMITED",
"ARIHANT INFRAWORKS PRIVATE LIMITED",
"ARIHANT INFRRA REALTORS PRIVATE LIMITED",
"ARIHANT INNOCHEM PRIVATE LIMITED",
"ARIHANT INSTITUTE OF BUSINESS MANAGEMENT",
"ARIHANT INTERMEDIATES (MADRAS) PRIVATE LIMITED",
"ARIHANT INTERNATIONAL LTD",
"ARIHANT IRON & STEEL PRODUCT PRIVATE LIMITED",
"ARIHANT JEWELLERS PRIVATE LIMITED",
"ARIHANT JEWELS LIMITED",
"ARIHANT JEWELWORLD PRIVATE LIMITED",
"ARIHANT JUMBO ZEROX AND STATIONERY PRIVATE LIMITED",
"ARIHANT LENS AND OPTICALS PRIVATE LIMITED",
"ARIHANT LIFESPACE INFRA DEVELOPERS PRIVATE LIMITED",
"ARIHANT LUBRICANTS PRIVATE LIMITED",
"ARIHANT MAHIMA INFRADEVELOPERS PRIVATE LIMITED",
"ARIHANT MARBLE AND GRANITE PVT LTD",
"ARIHANT MATTRESS PRIVATE LIMITED",
"ARIHANT MAXSELL TECHNOLOGIES PRIVATE LIMITED",
"ARIHANT MECHANICAL EQUIPMENTS PRIVATE LIMITED",
"ARIHANT MECHPLAST PRIVATE LIMITED",
"ARIHANT METALLOYS PRIVATE LIMITED",
"ARIHANT METALS AND EXTRUDED PRIVATE LIMITED",
"ARIHANT METALWARE INDIA PRIVATE LIMITED",
"ARIHANT MEXIP PRIVATE LIMITED",
"ARIHANT MICROSYSTEM PRIVATE LIMITED",
"ARIHANT MOTORS PRIVATE LIMITED",
"ARIHANT NEXGEN MARKETING PRIVATE LIMITED",
"ARIHANT NON FERROUS METALS PRIVATE LIMITED",
"ARIHANT NX JEWELLERS PRIVATE LIMITED",
"ARIHANT PACKWELL",
"ARIHANT PANEL FITTING PRIVATE LIMITED",
"ARIHANT PARADISE REALTY PRIVATE LIMITED",
"ARIHANT PETROCHEM PRIVATE LIMITED",
"ARIHANT PETROLEUM",
"ARIHANT PLANTATIONS PRIVATE LIMITED",
"ARIHANT POLYPLAST PRIVATE LIMITED",
"ARIHANT POLYSACKS",
"ARIHANT POWER EQUIPMENTS PRIVATE LIMITED",
"ARIHANT PRECISION ENGINEERING PRIVATE LIMITED",
"ARIHANT PRE-FAB PRIVATE LIMITED",
"ARIHANT PRINTERS",
"ARIHANT PUBLICATIONS INDIA LIMITED",
"ARIHANT PUMPS PRIVATE LIMITED",
"ARIHANT RECLAIMATION PRIVATE LIMITED",
"ARIHANT RETAILS PRIVATE. LIMITED.",
"ARIHANT RICE TECH PRIVATE LIMITED",
"ARIHANT SAFE GLASS PRIVATE LIMITED",
"ARIHANT SANITATION PVT LTD",
"ARIHANT SAREE STORE PRIVATE LIMITED",
"ARIHANT SHELTERS (INDIA) LIMITED",
"ARIHANT SHIP BREAKERS",
"ARIHANT SHOPPEE PRIVATE LIMITED",
"ARIHANT SILVER PRODUCTS PRIVATE LIMITED",
"ARIHANT SOLVEX PRIVATE LIMITED",
"ARIHANT SPINTEX PRIVATE LIMITED",
"ARIHANT STEEL POINT PRIVATE LIMITED",
"ARIHANT SUGAR INDUSTRIESS LIMITED",
"ARIHANT SUPERSTRUCTURES LIMITED",
"ARIHANT SYNCOTEX MILLS PRIVATE LIMITED",
"ARIHANT TAPES PRIVATE LIMITED",
"ARIHANT TARPAULIN PRIVATE LIMITED",
"ARIHANT TECHNO PACK PRIVATE LIMITED",
"ARIHANT TECHNOCAST INDIA PRIVATE LIMITED",
"ARIHANT TECHNOMAC PRIVATE LIMITED",
"ARIHANT TEXCHEM PVT LTD",
"ARIHANT TILES AND MARBLES PVT. LTD.",
"ARIHANT TRADERS PRIVATE LIMITED",
"ARIHANT UNIGLOBE PRIVATE LIMITED",
"ARIHANT VASTU NIRMAN PRIVATE LIMITED",
"ARIHANT VATIKA REALTY PRIVATE LIMITED",
"ARIHANT VDEAL INDIA PRIVATE LIMITED",
"ARIHANT VEGOILS PRIVATE LIMITED",
"ARIHANT WAREHOUSING PRIVATE LIMITED",
"ARIHANT WHEELS AND CYCLES PRIVATE. LIMITED.",
"ARIHANT WINDOW SOLUTIONS PRIVATE LIMITED",
"ARIHANT WORLDWIDE LIMITED",
"ARIHANT YARN PROCESSORS PVT LTD",
"ARIHANTA SIDDHA LABORATORIES PVT LTD",
"ARIHANTAM INFRAPROJECTS PRIVATE LIMITED",
"ARIHANTANAM LIFECARE PRIVATE LIMITED",
"ARIHANTH JEWELLERS PRIVATE LIMITED",
"ARIHANTRAJ TRADES PRIVATE LIMITED",
"ARIHANT'S SECURITIES LIMITED",
"ARIISTO REALTORS DEVELOPMENT PRIVATE LIMITED",
"ARIIX PRODUCTS (INDIA) PRIVATE LIMITED",
"ARIJULLAPUR SIDDIKIA HIGH MADRASAH",
"ARIKA TOURS & TRAVEL PRIVATE LIMITED",
"ARIKA WIRES AND NAILS MANUFACTURING PRIVATE LIMITED",
"ARIKAS LOGISTICS PRIVATE LIMITED",
"ARIKUNJ TRADING PRIVATE LIMITED",
"ARIL BIOSCIENCE PRIVATE LIMITED",
"ARIMA ANALYTICS PRIVATE LIMITED",
"ARIMA CONSTRUCTIONS PRIVATE LIMITED",
"ARIMA SOFTWARE SOLUTIONS PRIVATE LIMITED",
"ARIMAK LABORATORIES PRIVATE LIMITED",
"ARIMECH INDIA PRIVATE LIMITED",
"ARIN ALGOS PRIVATE LIMITED",
"ARIN APPARELS PRIVATE LIMITED",
"ARIN TEA PRIVATE LIMITED",
"ARIN WOOD PRODUCTS PRIVATE LIMITED",
"ARINA OFFSHORE MARINE SERVICES PRIVATE LIMITE",
"ARINC INCORPORATED",
"ARINC INDIA PRIVATE LIMITED",
"ARINDAM SOFTWARE SOLUTIONS (INDIA) PRIVATE LIMITED",
"ARINE TECHNOLOGIES PRIVATE LIMITED",
"ARINEM CONSULTANCY SERVICES PRIVATE LIMITED",
"ARING PRODEV PRIVATE LIMITED",
"ARINNA LIFESCIENCES LIMITED",
"ARINOS INFOSOLUTIONS PRIVATE LIMITED",
"ARINSPECT SOFTWARE PRIVATE LIMITED",
"ARINSUN CLEAN ENERGY PRIVATE LIMITED",
"ARIO INFRASTRUCTURE PRIVATE LIMITED",
"ARION AGENCIES PRIVATE LIMITED",
"ARION HEALTHCARE",
"ARION LOGISTICS PRIVATE LIMITED",
"ARION SCAFFOLDING PRIVATE LIMITED",
"ARIPAN AGRO PRIVATE LIMITED",
"ARIPLUTUS METALS PRIVATE LIMITED",
"ARIPOLIS BIOTECH PRIVATE LIMITED",
"ARIQT INTERNATIONAL PRIVATE LIMITED",
"ARIRANG ENTERPRISES INDIA PRIVATE LIMITED",
"ARIRANG RESTAURANT PRIVATE LIMITED",
"ARIRO PRIVATE LIMITED",
"ARIS BIOENERGY PRIVATE LIMITED",
"ARIS CAPITAL PRIVATE LIMITED",
"ARISAIG PARTNERS (INDIA) PRIVATE LIMITED",
"ARISAIG TRADING PRIVATE LIMITED",
"ARISE AUTOMOTIVES PRIVATE LIMITED",
"ARISE BIO- CARE PRIVATE LIMITED",
"ARISE CERAMIC PRIVATE LIMITED",
"ARISE ENGINEERING PRIVATE LIMITED",
"ARISE ENGLISH MEDIUM SCHOOL MHAKAVE",
"ARISE ENTERPRISES",
"ARISE GLOBAL SERVICES PRIVATE LIMITED",
"ARISE HVAC SOLUTIONS PRIVATE LIMITED",
"ARISE IIP INDIA PRIVATE LIMITED",
"ARISE IMPEX PRIVATE LIMITED",
"ARISE INDUSTRIES AND AGENCY PRIVATE LIMITED",
"ARISE LEISURE AND CORPORATE TRAVELS PRIVATE LIMITED",
"ARISE O TECH ELECTRONICS I PRIVATE LIMITED",
"ARISE SEEDS PRIVATE LIMITED",
"ARISE SHINE EXPORTS & IMPORTS LLP",
"ARISE TEXTILE PRIVATE LIMITED",
"ARISE TOURS AND TRAVELS PRIVATE LIMITED",
"ARISH EQUIPMENT MANUFACTURING PRIVATE LIMITED",
"ARISHANAPALLY CHIT FUNDS PRIVATE LIMITED",
"ARISHI PLASTIC PRIVATE LIMITED",
"ARISHINA LIFE SCIENCES PRIVATE LIMITED",
"ARISHTHA SAFETY PRODUCTS (INDIA) PRIVATE LIMITED",
"ARISINFRA SOLUTIONS PRIVATE LIMITED",
"ARISON ASSOCIATES PRIVATE LIMITED",
"ARISSAN POWER LIMITED",
"ARISTA AUTOMATION PRIVATE LIMITED",
"ARISTA CONSULTING SERVICES PRIVATE LIMITED",
"ARISTA NETWORKS INDIA PRIVATE LIMITED",
"ARISTA SECURITY SOLUTIONS PRIVATE LIMITED",
"ARISTA SYSTEMS PRIVATE LIMITED",
"ARISTH FOREX INDIA PRIVATE LIMITED",
"ARISTO BIO-TECH AND LIFESCIENCE LIMITED",
"ARISTO COATINGS PRIVATE LIMITED",
"ARISTO LABORATORIES PRIVATE. LIMITED",
"ARISTO LAMINATES PRIVATE LIMITED",
"ARISTO NX METAL PRIVATE LIMITED",
"ARISTO OIL CHEM PRIVATE LIMITED",
"ARISTO PHARMACEUTICALS PRIVATE LIMITED",
"ARISTO PUBLIC SCHOOL",
"ARISTO SECURITIES PRIVATE LIMITED",
"ARISTO STEEL PRIVATE LIMITED",
"ARISTO TELEMEDIA PRIVATE LIMITED",
"ARISTO TEXCON PVT LTD",
"ARISTO TRADERS PVT LTD",
"ARISTOBRAT RETAIL PRIVATE LIMITED",
"ARISTOCRAFT INTERNATIONAL PVT LTD",
"ARISTOCRAFT PAPERS PRIVATE LIMITED",
"ARISTOCRAT FOODS PVT LTD",
"ARISTOCRAT MARKETING LIMITED",
"ARISTOCRAT TECHNOLOGIES INDIA PRIVATE LIMITED",
"ARISTOCRAT TOURS PRIVATE. LIMITED",
"ARISTOGENE BIOSCIENCES PRIVATE LIMITED",
"ARISTON AGENCY PRIVATE LIMITED",
"ARISTON CAPITAL SERVICES PRIVATE LIMITED",
"ARISTON COMMODITIES PRIVATE LIMITED",
"ARISTON THERMO INDIA PRIVATE LIMITED",
"ARISTON TILES LIMITED",
"ARISTOPLAST PRODUCTS PRIVATE LIMITED",
"ARISTOTLE CONSULTANCY PRIVATE LIMITED",
"ARISTOTLE FINANCIAL CONSULTANTS PRIVATE LIMITED",
"ARISTOTLE INFOTAINMENT PRIVATE LIMITED",
"ARISTRO CAPITAL MARKETS LIMITED",
"ARISTRO FINCORP PRIVATE LIMITED",
"ARISU RETAIL PRIVATE LIMITED",
"ARISUDANA INDUSTRIES LIMITED",
"ARIT HOTELS PRIVATE LIMITED",
"ARITAS VINYL PRIVATE LIMITED",
"ARITEX INDUSTRIES PRIVATE LIMITED",
"ARITHA CONSULTING SERVICES PRIVATE LIMITED",
"ARITHMETIC SYSTEMS AND TECHNOLOGIES PRIVATE LIMITED",
"ARITONE GLOBAL VENTURES LIMITED",
"ARITRON SERVICES PRIVATE LIMITED",
"ARIUS FORMULATIONS PRIVATE LIMITED",
"ARIV EDUCATION PRIVATE LIMITED",
"ARIVATION FASHIONTECH PRIVATE LIMITED",
"ARIVATION HEALTHCARE PRIVATE LIMITED",
"ARIVEGURU TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"ARIVEN SPACE-CRAFT PRIVATE LIMITED",
"ARIVU EDUCATIONAL CONSULTANTS PRIVATE LIMITED",
"ARIWALA MILL STORES PRIVATE LIMITED",
"ARIYA IMPEX INDIA PRIVATE LIMITED",
"ARIYALUR ENGINEERING COLLEGE",
"ARIYANS REALTORS & SOLUTIONS PRIVATE LIMITED",
"ARIZE INDIA BUSINESS MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"ARIZE INFRASPACE PRIVATE LIMITED",
"ARIZEST PHARMA (INDIA) PRIVATE LIMITED",
"ARIZON INFOCOM PRIVATE LIMITED",
"ARIZONA GLOBALSERVICES PRIVATE LIMITED",
"ARIZONA MARKETING PRIVATE LIMITED",
"ARIZONA MARMO IMPEX PRIVATE LIMITED",
"ARJ ASSOCIATES PRIVATE LIMITED",
"ARJ SECURITIES PRIVATE LIMITED",
"ARJA ENERGYS PRIVATE LIMITED",
"ARJAN DASS & SONS PRIVATE LIMITED",
"ARJAN GLOBAL PRIVATE LIMITED",
"ARJAN IMPEX PRIVATE LIMITED",
"ARJAS MODERN STEEL PRIVATE LIMITED",
"ARJAS STEEL PRIVATE LIMITED",
"ARJATE FARMS PRIVATE LIMITED",
"ARJAV DIAMONDS INDIA PRIVATE LIMITED",
"ARJAV VEHICLE PRIVATE LIMITED",
"ARJAVA PROJECTS PRIVATE LIMITED",
"ARJAY APPAREL INDUSTRIES LIMITED",
"ARJEETA COMMODITIES TRADING PRIVATE LIMITED",
"ARJIT INFOTECH PRIVATE LIMITED",
"ARJIT TRADERS",
"ARJJAB TECHNOLOGIES PRIVATE LIMITED",
"ARJOHUNTLEIGH HEALTHCARE INDIA PRIVATE LIMITED",
"ARJUN AIR PRODUCTS PRIVATE LIMITED",
"ARJUN ALLOYS",
"ARJUN ASSOCIATES PVT LTD",
"ARJUN BUILDTECH PRIVATE LIMITED",
"ARJUN CHEMICALS PRIVATE LIMITED",
"ARJUN CONTAINERS PRIVATE LIMITED",
"ARJUN ENGINEERING AND CONSULTING PRIVATE LIMITED",
"ARJUN ENTERPRISES PRIVATE LIMITED",
"ARJUN FINE PRODUCTS PRIVATE LIMITED",
"ARJUN GEMS LLP",
"ARJUN GOVIN ESTATE PRIVATE LIMITED",
"ARJUN INDO AGRO OILS LIMITED",
"ARJUN INFRATEL PRIVATE LIMITED",
"ARJUN INVESTIGATION AND SECURITY SERVICES PRIVATE LIMITED",
"ARJUN JEWELLERS PRIVATE LIMITED",
"ARJUN KKR DEVELOPERS LIMITED",
"ARJUN METALS PRIVATE LIMITED",
"ARJUN MINERALS & TRANSPORTERS LIMITED",
"ARJUN NIRMAN INFRASTRUCTURES PRIVATE LIMITED",
"ARJUN PLYWOOD PRIVATE LIMITED",
"ARJUN PRODUCTION HOUSE PRIVATE LIMITED",
"ARJUN REALTORS PRIVATE LIMITED",
"ARJUN SHEET METALS INDIA PRIVATE LIMITED",
"ARJUN TECHNOLOGIES INDIA LIMITED",
"ARJUN TELECOM PRIVATE LIMITED",
"ARJUN TRANSPORT CO PRIVATE LIMITED",
"ARJUN VAASTU BUILDERS AND ENGINEERS PRIVATE LIMITED",
"ARJUN VASU AUTOMOBILES PRIVATE LIMITED",
"ARJUNA COTTON AND SPINNING MILLS PRIVATE LIMITED",
"ARJUNA ENGINEERING PRIVATE LIMITED",
"ARJUNA GRANITES EXPORTS PRIVATE LIMITED",
"ARJUNA INFRASTRUCTURES PRIVATE LIMITED",
"ARJUNA NATURAL EXTRACTS LIMITED",
"ARJUNA NATURAL PRIVATE LIMITED",
"ARJUNA POULTRY PRIVATE LIMITED",
"ARJUNA SOLVENT EXTRACTION PRIVATE LIMITED",
"ARJUNDAS BUILDCON PRIVATE LIMITED",
"ARJUNDAS ESTATES PRIVATE LIMITED",
"ARJUNLAL AGROCOM PRIVATE LIMITED",
"ARJUNLAL BANWARILAL & COMPANY PRIVATE LIMITED",
"ARJUNVAISHNAVI INFRASTRUCTURE & DEVELOPERS PRIVATE LIMITED",
"ARJUNWADKAR FOUNDRIES PVT LTD",
"ARJYOT CHEMICALS PVT LTD",
"ARJYOTI INFRASTRUCTURE INDIA PRIVATE LIMITED",
"ARK AUTO WHEELS PRIVATE LIMITED",
"ARK BUILDERS",
"ARK BUILDERS & PROPERTIES PROMOTERS PRIVATE LIMITED",
"ARK CARTONS PRIVATE LIMITED",
"ARK CHEMICALS PRIVATE LIMITED",
"ARK DIAGNOSTIC SYSTEM PRIVATE LIMITED",
"ARK DIAGNOSTICS BANGALORE PRIVATE LIMITED",
"ARK ELECTRONIC MOTION CONTROLS INDIA PRIVATE LIMITED",
"ARK ENGINEERING AND POWER CONSULTANTS PRIVATE LIMITED",
"ARK ENGINEERING PRIVATE LIMITED",
"ARK ERGO SPACE DESIGN PRIVATE LIMITED",
"ARK GEHNA PALACE PRIVATE LIMITED",
"ARK GOLDEN INDIA PRIVATE LIMITED",
"ARK HOME INTERIORS AND REALTY PRIVATE LIMITED",
"ARK HOTELS AND RESORTS PRIVATE LIMITED",
"ARK INFOSOLUTIONS PRIVATE LIMITED",
"ARK INFOTECH SPECTRUM INDIA PRIVATE LIMITED",
"ARK INFRA DEVELOPERS PRIVATE LIMITED",
"ARK INFRACON PRIVATE LIMITED",
"ARK MACHTEK PRIVATE LIMITED",
"ARK PLANNERS AND DEVELOPERS INDIA PRIVATE LIMITED",
"ARK POWER CONTROLS PRIVATE LIMITED",
"ARK PRIMARY ADVISORS PRIVATE LIMITED",
"ARK SHIPPING INTERNATIONAL PRIVATE LIMITED",
"ARK SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED",
"ARK TRAVELS PRIVATE LIMITED",
"ARKA ALLIED CHEMICALS INDIA PRIVATE LIMITED",
"ARKA ALUMINIUM PRIVATE LIMITED",
"ARKA AUTOTECH PRIVATE LIMITED",
"ARKA EDUCATIONAL AND CULTURAL TRUST",
"ARKA EDUSERV PRIVATE LIMITED",
"ARKA FERRO ALLOYS PRIVATE LIMITED",
"ARKA FINCAP LIMITED",
"ARKA GREEN POWER PRIVATE LIMITED",
"ARKA HEALTHCARE PRIVATE LIMITED",
"ARKA HOTELS PVT. LTD.",
"ARKA INSURANCE BROKING PRIVATE LIMITED",
"ARKA JAIN UNIVERSITY",
"ARKA MEDIA WORKS ENTERTAINMENT LLP",
"ARKA MEDIAWORKS PRIVATE LIMITED",
"ARKA OPERATIONS PRIVATE LIMITED",
"ARKA SOFTWARES & OUTSOURCING PRIVATE LIMITED",
"ARKA TECHNOLOGY INNOVATION AND SOFTWARE SYSTEMS LLP",
"ARKA VENTURES PRIVATE LIMITED",
"ARKA VITAL SCIENCE PRIVATE LIMITED",
"ARKAA GRENERGY CONSULTING PRIVATE LIMITED",
"ARKAAYE AGROTECH & COLD STORAGE PRIVATE LIMITED",
"ARKADE DEVELOPERS LTD",
"ARKADE DEVELOPERS PRIVATE LIMITED",
"ARKALA REALTY AND INFRASTRUCTURE PRIVATE LIMITED",
"ARKAP KNITS PRIVATE LIMITED",
"ARKAS CV PRIVATE LIMITED",
"ARKAS PHARMA PRIVATE LIMITED",
"ARKASHISH ENTRADE PRIVATE LIMITED",
"ARKAVATHI HORTICULTURE FARMERS PRODUCER COMPANY LIMITED",
"ARKAY DOORS PRIVATE LIMITED",
"ARKAY ENERGY (RAMESWARM) PRIVATE LIMITED",
"ARKAY ENERGY RAMESWARM LIMITED",
"ARKAY GLENROCK PRIVATE LIMITED",
"ARKAY ICONIC PRIVATE LIMITED",
"ARKAY ISPAT PRIVATE LIMITED",
"ARKAY LEATHERS PRIVATE LIMITED",
"ARKAY LOGISTICS LIMITED",
"ARKAY PLEATS PRIVATE LIMITED",
"ARKAY SEA LOGISTICS LIMITED",
"ARKCHEM SYSTEMS PRIVATE LIMITED",
"ARKEL ELECTRONIC INDIA PRIVATE LIMITED",
"ARKEMA CHEMICALS INDIA PRIVATE LIMITED",
"ARKEMA PEROXIDES INDIA PRIVATE LIMITED",
"ARKEN INTERNATIONAL PRIVATE LIMITED",
"ARKEN SOLUTION PRIVATE LIMITED",
"ARKENEA TECHNOLOGIES PRIVATE LIMITED",
"ARKENTECH SOLUTIONS",
"ARKFIN INVESTMENTS PRIVATE LIMITED",
"ARKGEN PHARMA PRIVATE LIMITED",
"ARKHA FARM AND FOODS PRIVATE LIMITED",
"ARKHA SOLAR POWER PRIVATE LIMITED",
"ARKHION DESIGN PRIVATE LIMITED",
"ARKHYA TECH INDIA PRIVATE LIMITED",
"ARKIE ATELIER DESIGN INDIA PRIVATE LIMITED",
"ARKIN CREATIONS PRIVATE LIMITED",
"ARKIN RUBBERS PRIVATE LIMITED",
"ARKIN SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"ARKIND LS PRIVATE LIMITED",
"ARKIS LIGHTINGS PRIVATE LIMITED",
"ARKITECHNO CONSULTANTS INDIA PRIVATE LIMITED",
"ARKLE HEALTHCARE PRIVATE LIMITED",
"ARKLITE SPECIALITY LAMPS LIMITED",
"ARKLITE SPECIALITY LAMPS PRIVATE LIMITED",
"ARKLOGISTICS SERVICES PRIVATE LIMITED",
"ARKOO INFRA AND TRADE PRIVATE LIMITED",
"ARKRAY HEALTHCARE PRIVATE LIMITED",
"ARKSAN LTD",
"ARKSOLUTIONSINK STAFFING PRIVATE LIMITED",
"ARKSUN SYSTEMS SOLUTIONS PRIVATE LIMITED",
"ARKTECH SCIENTIFIC PRIVATE LIMITED",
"ARKTEL NETWORKS PRIVATE LIMITED",
"ARKTRON SOFTWARE SOLUTION PRIVATE LIMITED",
"ARKUS RESEARCH PRIVATE LIMITED",
"ARL FINANCE PRIVATE LIMITED",
"ARL INFRATECH LIMITED",
"ARL RETAIL PRIVATE LIMITED",
"ARL WORLDWIDE EXPRESS PRIVATE LIMITED",
"ARLAK BIOTECH PRIVATE LIMITED",
"ARLAN TECHNOLOGIES PRIVATE LIMITED",
"ARLEX CHEMI PRIVATE LIMITED",
"ARLEX INDUSTRIES PRIVATE LIMITED",
"ARLIG TECHNOLOGIES LLP",
"ARLIGA AZURE PROJECTS PRIVATE LIMITED",
"ARLIGA NORTH STAR PROJECTS PRIVATE LIMITED",
"ARLINGTON INFORMATION SYSTEMS PRIVATE LIMITED",
"ARLO TECHNOLOGIES SERVICES INDIA PRIVATE LIMITED",
"ARM & HAMMER FORGINGS PRIVATE LIMITED",
"ARM COMMERCIAL SERVICES PRIVATE LIMITED",
"ARM CORPORATE SOLUTIONS INDIA PRIVATE LIMITED",
"ARM DIGITAL MEDIA PRIVATE LIMITED",
"ARM EMBEDDED TECHNOLOGIES PRIVATE LIMITED",
"ARM FINTECH CONSULTANTS PRIVATE LIMITED",
"ARM HEALTHCARE PRIVATE LIMITED",
"ARM HOSPITALITY PRIVATE LIMITED",
"ARM INFOSERVE INDIA PRIVATE LIMITED",
"ARM INFRA & UTILITIES PRIVATE LIMITED",
"ARM INFRA PROJECTS PRIVATE LIMITED",
"ARM OVERSEAS PRIVATE LIMITED",
"ARM SOFTECH PRIVATE LIMITED",
"ARM TOURS PVT LTD",
"ARMA PRODUCTS INDIA PRIVATE LIMITED",
"ARMA SOLUTIONS PRIVATE LIMITED",
"ARMAAN INDUSTRIES PRIVATE. LIMITED.",
"ARMAAN MANAGEMENT SERVICES PRIVATE LIMITED",
"ARMAANYA TEXTILES PRIVATE LIMITED",
"ARMACAR HOLDINGS PRIVATE LIMITED",
"ARMACELL INDIA PRIVATE LIMITED",
"ARMACO INFRALINKS PRIVATE LIMITED",
"ARMACOAT PRODUCTS PRIVATE LIMITED",
"ARMADA BAZZAR PRIVATE LIMITED",
"ARMADAA CUCINA PRIVATE LIMITED",
"ARMAK MULTI PLAST PRIVATE LIMITED",
"ARMAMENT RESEARCH AND DEVELOPMENT ESTABLISHMENT",
"ARMAN FINANCIAL SERVICES LIMITED",
"ARMAN FOODTECH PRIVATE LIMITED",
"ARMAN HOLDINGS LIMITED",
"ARMAN LOGISTICS PARK PRIVATE LIMITED",
"ARMAN STEELCON PRIVATE LIMITED",
"ARMANI AGRO PRIVATE LIMITED",
"ARMANI INDUSTRIES INDIA PRIVATE LIMITED",
"ARMANIA AGRO INDUSTRIES",
"ARMANIA FINANCIAL SERVICES PRIVATE LIMITED",
"ARMANTEC SYSTEMS PRIVATE LIMITED.",
"ARMAPORE P G COLLEAGE",
"ARMATIC ENGINEERING PRIVATE LIMITED",
"ARMAYA TRADING PRIVATE LIMITED",
"ARMEC COOLING SYSTEM LIMITED",
"ARMEC COOLING TOWER PRIVATE LIMITED",
"ARMECH ENGINEERS PRIVATE LIMITED",
"ARMECO PRIVATE LIMITED",
"ARMED FORCE MEDICAL STORES DEPOT",
"ARMED FORCES MEDICAL COLLEGE PUNE",
"ARMED FORCES MEDICAL STORES DEPOT",
"ARMEE INFOTECH PRIVATE LIMITED",
"ARMEE TECHNOLOGY SERVICES PRIVATE LIMITED",
"ARMEIN PHARMACEUTICALS PRIVATE LIMITED",
"ARMEKA FINANCIAL CONSULTANTS PRIVATE LIMITED",
"ARMEN TOURS & TRAVELS PRIVATE LIMITED",
"ARMES MAINI STORAGE SYSTEMS PRIVATE LIMITED",
"ARMEX PRO PRIVATE LIMITED",
"ARMIA SYSTEMS PRIVATE LIMITED",
"ARMIEDA MAKEOVER PRIVATE LIMITED",
"ARMINUS SOFTWARE PRIVATE LIMITED",
"ARMIS BUSINESS VENTURES PRIVATE LIMITED",
"ARMITA INDIA SHIPPING PRIVATE LIMITED",
"ARMMAN",
"ARMO SYNTHETICS PRIVATE LIMITED",
"ARMON INTERNATIONAL PRIVATE LIMITED",
"ARMOR INDIA CODING AND IMAGING SUPPLIES PRIVATE LIMITED",
"ARMOR PLAST LIMITED",
"ARMOR PLAST PRIVATE LIMITED",
"ARMOR PROTECTIVE PACKAGING INDIA PRIVATE LIMITED",
"ARMOR SECURITY AND HUMAN RESOURCES SERVICES PRIVATE LIMITED",
"ARMOUR DISPLAY SYSTEMS PRIVATE LIMITED",
"ARMOUR ELECTRONICS PVT.LTD.",
"ARMOUR INFOCOM PRIVATE LIMITED",
"ARMOUR KARTONS PRIVATE LIMITED",
"ARMOUR RAY VENTURES PRIVATE LIMITED",
"ARMOUR SECURITY INDIA PVT LTD",
"ARMOUR STEEL BUILDINGS INDIA PRIVATE LIMITED",
"ARMS ACADEMY PRIVATE LIMITED",
"ARMS COMMUNICATIONS PRIVATE LIMITED",
"ARMS SECURITIES PRIVATE LIMITED",
"ARMSEL MHE PRIVATE LIMITED",
"ARMSTECH ENGINEERS PRIVATE LIMITED",
"ARMSTRONG",
"ARMSTRONG ACMITE INDIA MANUFACTURING PRIVATE LIMITED",
"ARMSTRONG APPAREL MILLS PRIVATE LIMITED",
"ARMSTRONG CAPITAL ADVISORY PRIVATE LIMITED",
"ARMSTRONG DESIGN PRIVATE LIMITED",
"ARMSTRONG EXCHANGE PRIVATE LIMITED",
"ARMSTRONG INTERNATIONAL PRIVATE LIMITED",
"ARMSTRONG MACHINE BUILDERS PRIVATE LIMITED",
"ARMSTRONG POWER PRIVATE LIMITED",
"ARMSTRONG POWER SYSTEMS PRIVATE LIMITED",
"ARMSTRONG PRODUCTS PRIVATE LIMITED",
"ARMSTRONG SPINNING MILLS PRIVATE LIMITED",
"ARMSTRONG TEXTILES PROCESSING PRIVATE LIMITED",
"ARMSTRONG WIRES AND ENGINEERS PRIVATE LIMITED",
"ARMSTRONG WORLD INDUSTRIES",
"ARMSTRONG WORLD INDUSTRIES INDIA PRIVATE LIMITED",
"ARMTECH COMPUTER SERVICES PRIVATE LIMITED",
"ARMUGAM HOTELS & RESORTS PRIVATE LIMITED",
"ARMURE EXPORTS PRIVATE LIMITED",
"ARMY INSTITUTE OF TECHNOLOGY PUNE",
"ARMY ORDNANCE CORPS",
"ARMY PUBLIC SCHOOL BEAS",
"ARMY PUBLIC SCHOOL JHANSI",
"ARMY SKILLING CENTRE OF EXCELLENCE",
"ARMY WAR COLLEGE",
"ARN BUSINESS SOLUTIONS PRIVATE LIMITED",
"ARN SYSTEMS PRIVATE LIMITED",
"ARNA BAKERS PRIVATE LIMITED",
"ARNA ENGINEERING PRIVATE LIMITED",
"ARNA HR MANAGEMENT LLP",
"ARNA INDUSTRIAL SOLUTIONS PRIVATE LIMITED",
"ARNA INFRA SOLUTIONS PRIVATE LIMITED",
"ARNA SOFTECH PRIVATE LIMITED",
"ARNAB EXIM PRIVATE LIMITED",
"ARNAB POULTRY FARM PRIVATE LIMITED",
"ARNAF FUTURISTIC TEECH NOLOGIES P LIMITED",
"ARNAV ANSH PRIVATE LIMITED",
"ARNAV EDIFICES PRIVATE LIMITED",
"ARNAV ENGITECH PRIVATE LIMITED",
"ARNAV FINCORP PRIVATE LIMITED",
"ARNAV FISHERIES PRIVATE LIMITED",
"ARNAV MARITIME PRIVATE LIMITED",
"ARNAV POLYMERS PRIVATE LIMITED",
"ARNAV RENEWABLE ENERGY PRIVATE LIMITED",
"ARNAV SHIPPING PRIVATE LIMITED",
"ARNAV VISHISHTA CONSTRUCTIONS (INDIA) PRIVATE LIMITED",
"ARNAVI GREEN BUILDING MATERIALS PRIVATE LIMITED",
"ARNAY TUBES INDUSTRIES PRIVATE LIMITED",
"ARNEJA CREATION & HOTEL PRIVATE LIMITED",
"ARNEJA INSTITUTE OF CARDIOLOGY PRIVATE LIMITED",
"ARNI ENGINEERING TECH PRIVATE LIMITED",
"ARNI MECH PRODUCTS PRIVATE LIMITED",
"ARNICA ENTERPRISES PRIVATE LIMITED",
"ARNISH LABORATES PRIVATE LIMITED",
"ARNIT CREATIONS PRIVATE LIMITED",
"ARNIT RETAIL PRIVATE LIMITED",
"ARNITA CONSULTANTS PRIVATE LIMITED",
"ARNO EXIM (INDIA) PRIVATE LIMITED",
"ARNOLD CONSULTING PRIVATE LIMITED",
"ARNOLD HOLDINGS LTD",
"ARNON BUILDERS & DEVELOPERS LIMITED",
"ARNOO PROJECTS PRIVATE LIMITED",
"ARNORIS CONTAINER LINES PRIVATE LIMITED",
"ARNTZ TECHSAW PRIVATE LIMITED",
"ARO CERAMICA PRIVATE LIMITED",
"ARO EQUIPMENTS PRIVATE LIMITED",
"ARO GRANITE INDUSTRIES LIMITED",
"AROCANA MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"AROCHAN PROJECTS PRIVATE LIMITED",
"AROCHEM INDUSTRIES PRIVATE LIMITED",
"AROCHEM RATLAM PRIVATE LIMITED",
"AROCHEMA INGREDIENTS PRIVATE LIMITED",
"AROCOM IT SOLUTIONS PRIVATE LIMITED",
"AROCON REAL ESTATE PRIVATE LIMITED",
"ARODEK TECHNOLOGY CONSULTING PRIVATE LIMITED",
"ARODHANA SYNERGY PRIVATE LIMITED",
"ARODHAYA BUILDCOM PRIVATE LIMITED",
"ARODO INDIA PRIVATE LIMITED",
"AROFINE POLYMERS PRIVATE LIMITED",
"AROGYA AHAARA HYGIENE FOOD SERVICES PRIVATE LIMITED",
"AROGYA FORMULATIONS PRIVATE LIMITED",
"AROGYA HEALTH CARE PRIVATE LIMITED",
"AROGYA HOSPITAL",
"AROGYA MULTISPECIALITY HOSPITAL PRIVATE LIMITED",
"AROGYA NIKETAN PVT LTD",
"AROGYA TRADING AND FINANCE LIMITED",
"AROGYA VIBHAG JILHA PARISHAD JALGAON",
"AROGYADHAM HEALTH CARE PRIVATE LIMITED",
"AROGYADHAM HOSPITAL GWALIOR",
"AROGYAM ORGANIC FOODS PRIVATE LIMITED",
"AROHA TECHNOLOGIES",
"AROHAKA INTERNATIONAL TOURS AND TRAVELS PRIVATE LIMITED",
"AROHAN FINANCIAL SERVICES LIMITED",
"AROHATECH IT SERVICES PRIVATE LIMITED",
"AROHI ELEVATORS PRIVATE LIMITED",
"AROHI EYE HOSPITAL",
"AROHI LIFESTYLE",
"AROHI PROVISION STORES",
"AROHI SALES PRIVATE LIMITED",
"AROHUL FOODS PRIVATE. LIMITED.",
"AROINDIA ELECTROMECH PRIVATE LIMITED",
"AROKEE ONLINE SOLUTIONS PRIVATE LIMITED",
"AROKIA IT PRIVATE LIMITED",
"AROKK INTEGRATED MANAGEMENT SERVICES PRIVATE LIMITED",
"AROKYAM CATERING SERVICES PRIVATE LIMITED",
"AROLEAP FITNESS PRIVATE LIMITED",
"AROLY INFRASTRUCTURE PRIVATE LIMITED",
"AROMA AGROTECH PRIVATE LIMITED",
"AROMA CHEMICALS",
"AROMA COLOURS PVT LTD",
"AROMA COMPUTER SYSTEMS PRIVATE LIMITED",
"AROMA CRAFT AND TISSUES PRIVATE LIMITED",
"AROMA ENGINEERING (INDIA) PRIVATE LIMITED",
"AROMA FOODS PRIVATE LIMITED",
"AROMA GREEN TREE SUPER STORES PRIVATE LIMITED",
"AROMA INDIA PRIVATE LIMITED",
"AROMA ORGANICE AGRO PRODUCER COMPANY LIMITED",
"AROMA ORGANICS LIMITED",
"AROMA REALTIES LIMITED",
"AROMA RESTAURANTS AND RESORTS PRIVATE LIMITED",
"AROMA TREASURES PRIVATE LIMITED",
"AROMAAZ INTERNATIONAL PRIVATE LIMITED",
"AROMAS VENDING SERVICES PRIVATE LIMITED",
"AROMATAN COSMETICS PRIVATE LIMITED",
"AROMATHAI SPA (DELHI) PRIVATE LIMITED",
"AROMATHAI SPA PRIVATE LIMITED",
"AROMATHERAPY INTERNATIONAL LIMITED",
"AROMATIC ALLIED AND ORGANICS PRIVATE LIM ITED",
"AROMATIC AND INDUSTRIAL CHEMICALS PRIVATE LIMITED",
"AROMATIC AND MEDICINAL HERBS PRODUCER COMPANY LIMITED",
"AROMATIC ELECTRONICS SOLUTIONS OPC PRIVATE LIMITED",
"AROMATIC GARDEN ESSENCE INDIA PRIVATE LIMITED",
"AROMATIC INGREDIENTS PRIVATE LIMITED",
"AROMATIC RASAYAN PRIVATE LIMITED",
"AROMATIC VEGGIES PRIVATE LIMITED",
"AROMATICS INDIA PRIVATE LIMITED",
"AROMATRIX FLAVOURS AND FRAGRANCES PRIVATE LIMITED",
"AROMATRIX FLORA PRIVATE LIMITED",
"AROMAVALLEY TRADE PRIVATE LIMITED",
"AROMAX COLOURANTS PRIVATE LIMITED",
"AROMAX TRADING PRIVATE LIMITED",
"AROME CONSULTING SERVICES PRIVATE LIMITED",
"AROMEE BRANDS PRIVATE LIMITED",
"ARON HURLEY KONCEPTS PRIVATE LIMITED",
"ARON INFRATECH PRIVATE LIMITED",
"ARON PIPES PRIVATE LIMITED",
"ARON UNIVERSAL LIMITED",
"ARONATION LIFE CARE PRIVATE LIMITED",
"ARONAX ENTERPRISES PRIVATE LIMITED",
"ARONEX LIFE SCIENCES PRIVATE LIMITED",
"ARONI TUBES PRIVATE LIMITED",
"AROOJ HEALTHCARE PRIVATE LIMITED",
"AROON AVIATION SERVICES PRIVATE LIMITED",
"AROOPA TECHNOLOGIES PRIVATE LIMITED",
"AROOSH FOODS PRIVATE LIMITED",
"ARORA ALLOYS LIMITED",
"ARORA AND ASSOCIATES REALTY LIMITED",
"ARORA AND ASSOCIATES REALTY PRIVATE LIMITED",
"ARORA AROMATICS PRIVATE LIMITED",
"ARORA BROTHERS FASHIONS PRIVATE. LIMITED",
"ARORA BUILDWELL PRIVATE LIMITED",
"ARORA CONSTRUCTION CO. PRIVATE LIMITED",
"ARORA CREATION PRIVATE LIMITED",
"ARORA ELECTROMAGNETICS PRIVATE LIMITED",
"ARORA FABRICS PVT LIMITED",
"ARORA FERROS PRIVATE LIMITED",
"ARORA FIBRES LIMITED",
"ARORA FOREIGN EXCHANGE PRIVATE LIMITED",
"ARORA FORGINGS PRIVATE LIMITED",
"ARORA FREIGHT MOVERS PRIVATE LIMITED",
"ARORA GARMENTS INDIA PRIVATE LIMITED",
"ARORA GIFTS PRIVATE LIMITED",
"ARORA HOLIDAYS & RESORTS PRIVATE LIMITED",
"ARORA HOME APPLIANCES PRIVATE LIMITED",
"ARORA HOSPITALE PRIVATE LIMITED",
"ARORA INDUSTRIAL TRADERS PRIVATE LIMITED",
"ARORA INDUSTRIES",
"ARORA INFRAVENTURES PRIVATE LIMITED",
"ARORA INK CO PRIVATE LIMITED",
"ARORA IRON AND STEEL ROLLING MILLS PRIVATE LIMITED",
"ARORA JEWELLERS PRIVATE LIMITED",
"ARORA KNIT FAB PRIVATE. LIMITED.",
"ARORA LAPROSCOPY CENTRE PRIVATE LIMITED",
"ARORA LOGISTIX PRIVATE LIMITED",
"ARORA MATTHEY LIMITED",
"ARORA MEDI LINES PVT. LTD.",
"ARORA MILK PRODUCTS PRIVATE LIMITED",
"ARORA MOTOCORP PRIVATE LIMITED",
"ARORA NEURO CENTRE PVT LTD",
"ARORA OVERSEAS PRIVATE LIMITED",
"ARORA POLYFAB INDIA PRIVATE LIMITED",
"ARORA PROJECTS PRIVATE LIMITED",
"ARORA REFRACTORIES PRIVATE LIMITED",
"ARORA RICE MILLS",
"ARORA SALT COMPANY PRIVATE LIMITED",
"ARORA SAREE SELECTION",
"ARORA SPORTS PRIVATE LIMITED",
"ARORA STOCK BROKERS LIMITED",
"ARORA TECHNOLOGIES PRIVATE LIMITED",
"ARORA TEXTILES PVT. LTD. (TRANSFER FROM U.P. TO RAJASTHAN)",
"ARORA TEXWOOL PRIVATE LIMITED",
"ARORA TOBACCO PRIVATE LIMITED",
"ARORA TOOLS PRIVATE LIMITED",
"ARORA TRADEMART PRIVATE LIMITED",
"ARORA VINYL PRIVATE LIMITED",
"ARORA YARN PRIVATE LIMITED",
"ARORAS COLLEGE",
"ARORAS D.P. ELECTRONICS PRIVATE LIMITED",
"ARORAS J.K. NATURAL MARBLES LIMITED",
"ARORIAN SOLUTION CENTER INDIA (OPC) PRIVATE LIMITED",
"ARO-SAK PLASTICS & ASSEMBLIES PRIVATE LIMITED",
"AROSCAN CARGO TRADE PRIVATE LIMITED",
"AROSE SEEDS PRIVATE LIMITED",
"AROSOL PHARMACEUTICALS PRIVATE LIMITED",
"AROSOLV DISTILLATES PRIVATE LIMITED",
"AROSON PLASTICS PRIVATE LIMITED",
"AROSTAR ENTERPRISES PRIVATE LIMITED",
"AROSYS TECHNOLOGIES PRIVATE LIMITED",
"AROTEE AGRO PRIVATE LIMITED",
"AROUND THE CLOCK FOODS PRIVATE LIMITED",
"AROWANA CONSULTING LIMITED",
"AROWANA SOFTWARE SOLUTIONS PRIVATE LIMITED",
"AROWN PRIVATE LIMITED",
"AROX EXPO PRIVATE LIMITED",
"AROXA CROP SCIENCE PRIVATE LIMITED",
"AROXIDE IMPEX (INDIA )PRIVATE LIMITED",
"AROXO SOFTWARE PRIVATE LIMITED",
"ARP ASSOCIATES PRIVATE LIMITED",
"ARP AUTOMATION PRIVATE LIMITED",
"ARP CONSTRUCTIONS PRIVATE LIMITED",
"ARP FABRICATIONS PRIVATE LIMITED",
"ARP MOTORS PRIVATE LIMITED",
"ARP PROPERTIES PRIVATE LIMITED",
"ARP TECHNOLOGIES PRIVATE LIMITED",
"ARP TEXFIN ENTERPRISE PRIVATE LIMITED",
"ARP VENTURES PRIVATE LIMITED",
"ARP WOVEN SACK PRIVATE LIMITED",
"ARPA FUEL PRIVATE LIMITED",
"ARPA INFRASTRUCTURE DEVELOPERS PRIVATE LIMITED",
"ARPAN BRUSH COMPANY PVT LTD",
"ARPAN EDUCATIONAL VIDHYALAYA",
"ARPAN ENGLISH MEDIUM PRI PRIMARY SCHOOL",
"ARPAN FOODS LIMITED",
"ARPAN INFRASOLUTION PRIVATE LIMITED",
"ARPAN INFRATECH PRIVATE LIMITED",
"ARPAN INTERACTIVE SOLUTIONS PRIVATE LIMITED",
"ARPAN MARKETING CO PVT LTD",
"ARPAN MEDIA PRIVATE LIMITED",
"ARPAN NEW BORN CARE CENTRE PRIVATE LIMITED",
"ARPAN POLYPLAST PRIVATE LIMITED",
"ARPAN PRIVATE LIMITED",
"ARPAN PROPERTIES PRIVATE LIMITED",
"ARPAN SYNTHETICS (GUJARAT) PRIVATE LIMITED",
"ARPAN TECHNOLOGIES PRIVATE LIMITED",
"ARPAN VIDHYA SANKUL",
"ARPAN VIDHYA VIHAR",
"ARPANA PACKAGING PRIVATE LIMITED",
"ARPANA W FLOUR MILLS PRIVATE LIMITED",
"ARPANN GREENESTATES PRIVATE LIMITED",
"ARPANNA MOTORS PRIVATE LIMITED",
"ARPEE BUILDERS & PROMOTERS PVT LTD",
"ARPEE CONSULTANTS PRIVATE LIMITED",
"ARPEE ENERGY MINERALS PRIVATE LIMITED",
"ARPEE METALIKS PRIVATE LIMITED",
"ARPEE SCREEN HOUSE PRIVATE LIMITED",
"ARPEJAY OILS PRIVATE LIMITED",
"ARPHI ELECTRONICS PRIVATE LIMITED",
"ARPI ENTERPRISES (INDIA) PRIVATE LIMITED",
"ARPI ROADWAYS PRIVATE LIMITED",
"ARPIT AGRO INDUSTRIES PRIVATE LIMITED",
"ARPIT ESTATES PVT LTD",
"ARPIT FASHIONS PRIVATE LIMITED",
"ARPIT GRANITES PRIVATE LIMITED",
"ARPIT GUPTA SPARES HOUSE PRIVATE LIMITED",
"ARPIT HOSPITAL PRIVATE LIMITED",
"ARPIT KARTIK CASTINGS PRIVATE LIMITED",
"ARPIT LABOUR SUPPLIERS PRIVATE LIMITED",
"ARPIT MANU AGRO PLAST PRIVATE LIMITED",
"ARPIT PAPERS PRIVATE LIMITED",
"ARPIT PHARMACEUTICALS PRIVATE LIMITED",
"ARPIT PLASTICS PRIVATE LIMITED",
"ARPIT PROJECTS LIMITED",
"ARPIT TECHNO INFRA PRIVATE LIMITED",
"ARPIT TEXTILES PVT. LTD",
"ARPIT WIRE AND ALLIED PRODUCTS PRIVATE LIMITED",
"ARPITA AGRO PRODUCTS PVT LTD",
"ARPITA HEALTHCARE PRIVATE LIMITED",
"ARPITA INFOCOMM PRIVATE LIMITED",
"ARPITA INFOTECH PRIVATE LIMITED",
"ARPITHA INTERIORS PRIVATE LIMITED",
"ARPNA CAPITAL SERVICES PVT LTD",
"ARPORA PROJECTS PRIVATE LIMITED",
"ARPORTABLE CABINS INDIA PRIVATE LIMITED",
"ARPS TEA COMPANY PRIVATE LIMITED",
"ARPWOOD CAPITAL PRIVATE LIMITED",
"ARPWOOD PARTNERS FUND I LLP",
"ARQUBE INDUSTRIES INDIA LIMITED",
"ARR ADVISORY PRIVATE LIMITED",
"ARR BATH & HOME PRIVATE LIMITED",
"ARR ESS BIKES PRIVATE LIMITED",
"ARR ESS LEADING EDGE PRIVATE LIMITED",
"ARR FERRO EQUIPMENTS PRIVATE LIMITED",
"ARR MARITIME & ALLIED SERVICES PRIVATE LIMITED",
"ARR MARITIME INTERNATIONAL TERMINALS (INDIA) PRIVATE LIMITED",
"ARR STONEX PRIVATE LIMITED",
"ARRA HOSPITALITY GROUP PRIVATE LIMITED",
"ARRANT METALS PRIVATE LIMITED",
"ARRAY FASHIONS PRIVATE LIMITED",
"ARRAY INSTITUTE OF MEDICAL SCIENCE",
"ARRAY NETWORKS INDIA PRIVATE LIMITED",
"ARRAY STONE HUB PRIVATE LIMITED",
"ARRAYCOM (INDIA) LIMITED",
"ARRAYCOM INDIA LIMITED.",
"ARRAYTECH TECHNOLOGIES PRIVATE LIMITED",
"ARREDS FINTECH PRIVATE LIMITED",
"ARREMM HOLDINGS PRIVATE LIMITED",
"ARRESTO SOLUTIONS PRIVATE LIMITED",
"ARRIANCE INFRA PRIVATE LIMITED",
"ARRIANCE PROJECTS PRIVATE LIMITED",
"ARRIDAE INFOSEC PRIVATE LIMITED",
"ARRIENT HEALTHCARE PRIVATE LIMITED",
"ARRIER BIOTECH PRIVATE LIMITED",
"ARRIS ENGINEERING SERVICES PRIVATE LIMITED",
"ARRIS GROUP INDIA PRIVATE LIMITED",
"ARRIS TRADING",
"ARRISE BPO SOLUTIONS PRIVATE LIMITED",
"ARRIVA DESIGNS PRIVATE LIMITED",
"ARRIVAA POWER SYSTEM PRIVATE LIMITED",
"ARRIVAL SHOES PRIVATE LIMITED",
"ARRIVE TECHNOLOGIES PRIVATE LIMITED",
"ARRIVIA VACATIONS INDIA PRIVATE LIMITED",
"ARRIXON TECHNOLOGIES PRIVATE LIMITED",
"ARRJAVV BUILDER PRIVATE LIMITED",
"ARRK SOLUTIONS PRIVATE LIMITED",
"ARRKA INFOSEC PRIVATE LIMITED",
"ARRKAY TRANSHIP FORWARDERS PRIVATE LIMITED",
"ARRKP HOSPITALITY PRIVATE LIMITED",
"ARRO SIJA INFRA SERVICES PRIVATE LIMITED",
"ARRON INSURANCE BROKERS PRIVATE LIMITED",
"ARROW ADVANCE MATERIALS PRIVATE LIMITED",
"ARROW ADVERTISING INDIA PRIVATE LIMITED",
"ARROW AIRCRAFT SALES AND CHARTERS PRIVATE LIMITED",
"ARROW AIRCRAFT SERVICES PRIVATE LIMITED",
"ARROW BROGUES PRIVATE LIMITED",
"ARROW CLOTHING PRIVATE LIMITED",
"ARROW COMMERCIAL SERVICES PRIVATE LIMITED",
"ARROW CONSTRUCTION LIMITED",
"ARROW DIGITAL PRIVATE LIMITED",
"ARROW ELECTRICALS INDIA PRIVATE LIMITED",
"ARROW ELECTRONICS INDIA PRIVATE LIMITED",
"ARROW ENGINEERING INDUSTRIES PRIVATE LIMITED",
"ARROW ENGINEERING LIMITED",
"ARROW ENTERPRISE COMPUTING SOLUTIONS INDIA PRIVATE LIMITED",
"ARROW FACILITY MANAGEMENT PRIVATE LIMITED",
"ARROW GLOBAL LOGISTICS PRIVATE LIMITED",
"ARROW GREENTECH LIMITED",
"ARROW INFRAESTATE PRIVATE LIMITED",
"ARROW MINERALS & METALS PRIVATE LIMITED",
"ARROW OPTRONICS PRIVATE LIMITED",
"ARROW PC NETWORK PRIVATE LIMITED",
"ARROW PHARMACEUTICALS PRIVATE LIMITED",
"ARROW POWERTECH PRIVATE LIMITED",
"ARROW PUBLICATIONS PRIVATE LIMITED",
"ARROW SPEED INTERNATIONAL FREIGHT SOLUTIONS PRIVATE LIMITED",
"ARROW TECH CNC PRIVATE LIMITED",
"ARROW TECHNOCAST (GUJARAT) PVT LTD",
"ARROW TECHNOLOGIES PRIVATE LIMITED",
"ARROW TEXTILES LIMITED",
"ARROW TOOLS PRIVATE LIMITED",
"ARROW WEAVING MILLS PRIVATE LIMITED",
"ARROW XPRESS SOLUTIONS PRIVATE. LIMITED",
"ARROWBRAIDS AND TWINE PRIVATE LIMITED",
"ARROWCORE TECHNOLOGIES PRIVATE LIMITED",
"ARROWFAST LOGISTICS PRIVATE LIMITED",
"ARROWGOLD ORNAMENTS PRIVATE LIMITED",
"ARROWHEAD COMMUNICATIONS PRIVATE LIMITED",
"ARROWHEAD PROFESSIONAL SERVICES PRIVATE LIMITED",
"ARROWHEAD SEPERATION ENGINEERING LIMITED",
"ARROWLINE REALESTATE PRIVATE LIMITED",
"ARROWPOINT TECHNOLOGIES PRIVATE LIMITED",
"ARROWSPACE ADVISORS PRIVATE LIMITED",
"ARROWSPACE TREXIM PRIVATE LIMITED",
"ARROYO SERVICES PRIVATE LIMITED",
"ARRTA MOTORS PRIVATE LIMITED",
"ARRUTH TECHNICAL PERFORMANCE WEAR PRIVATE LIMITED",
"ARRYA SCIMAT PRIVATE LIMITED",
"ARS AUTO ACCESSORIES PRIVATE LIMITED",
"ARS DEVELOPERS PRIVATE LIMITED",
"ARS ENERGY PRIVATE LIMITED",
"ARS ENGINEERING PRIVATE LIMITED",
"ARS FOODS INGREDIENTS PRIVATE LIMITED",
"ARS FOREX PRIVATE LIMITED",
"ARS GLOBAL PRIVATE LIMITED",
"ARS GREEN POWER INFRA PRIVATE LIMITED",
"ARS INFRASTEEL PRIVATE LIMITED",
"ARS INFRASTRUCTURE PROJECT PRIVATE LIMITED",
"ARS JASMIN CONSTRUCTIONS PRIVATE LIMITED",
"ARS PULP & PAPERS PRIVATE LIMITED",
"ARS REALBUILD PRIVATE LIMITED",
"ARS SOLUTIONS PRIVATE LIMITED",
"ARS STEELS AND ALLOY INTERNATIONAL PRIVATE LIMITED",
"ARS TECHNOCRATS PRIVATE LIMITED",
"ARS TRANSLOGISTICS PRIVATE LIMITED",
"ARSA ENGINEERING CONSULTANCY SERVICES PRIVATE LIMITED",
"ARSA INFRATECH PRIVATE LIMITED",
"ARSANIK HEALTHCARE PRIVATE LIMITED",
"ARSCENT HEALTH SERVICES PRIVATE LIMITED",
"ARSD RETAIL PRIVATE LIMITED",
"ARSEN INFRA PRIVATE. LIMITED",
"ARSEN INTERIO PRIVATE LIMITED",
"ARSENAL INFOSOLUTIONS PRIVATE LIMITED",
"ARSENAL STEEL SILOS AND MACHINERY PRIVATE LIMITED",
"ARSENALTECH PRIVATE LIMITED",
"ARSH ADITYA FOOTSTEP PRIVATE LIMITED",
"ARSH ALLOYS AND METALS PRIVATE LIMITED",
"ARSH AUTO-WHEELS PRIVATE LIMITED",
"ARSH BREAD AND BAKERY PRIVATE LIMITED",
"ARSH ELECTRICAL COMPANY PRIVATE LIMITED",
"ARSH FASHIONS PRIVATE LIMITED",
"ARSH GOODHOMES PRIVATE LIMITED",
"ARSH INDUSTRIAL SOLUTION PRIVATE LIMITED",
"ARSH INTERNATIONAL INDIA PRIVATE LIMITED",
"ARSH LADIES SUIT PRIVATE LIMITED",
"ARSH RECYCLING PRIVATE LIMITED",
"ARSH SCRAP MART INTERNATIONAL PRIVATE LIMITED",
"ARSH TOWNSHIPS INDIA PRIVATE LIMITED",
"ARSH TRADERS PRIVATE LIMITED",
"ARSHA MARINE PRIVATE LIMITED",
"ARSHA VIDYA MANDIR",
"ARSHAD AUTOBAHN INDIA PRIVATE LIMITED",
"ARSHAD ELECTRONICS PRIVATE LIMITED",
"ARSHEE AUTO PRIVATE LIMITED",
"ARSHIA GLOBAL TRADECOM PRIVATE. LIMITED",
"ARSHIA PASSION BUILDERS PRIVATE LIMITED",
"ARSHIT METAL TRADE & ENGINEERING PRIVATE LIMITED",
"ARSHITA DENTAL SERVICES PRIVATE LIMITED",
"ARSHIYA 3PL SERVICES PRIVATE LIMITED",
"ARSHIYA CENTRAL DOMESTIC DISTRIPARK LIMITED",
"ARSHIYA CONSULTING ENGINEERS PRIVATE LIMITED",
"ARSHIYA DECOR PRIVATE LIMITED",
"ARSHIYA INFOSOLUTIONS PRIVATE LIMITED",
"ARSHIYA LIFESTYLE LIMITED",
"ARSHIYA LOGISTICS SERVICES LIMITED",
"ARSHIYA PANVEL FTWZ SERVICES PRIVATE LIMITED",
"ARSHIYA PANVEL LOGISTICS SERVICES PRIVATE LIMITED",
"ARSHIYA STEEL AND ALLOYS LIMITED",
"ARSHIYA TRANSPORT AND HANDLING LIMITED",
"ARSHYA ENGINEERS & FABRICATIONS PRIVATE LIMITED",
"ARSHYA PIPE FITTINGS PRIVATE LIMITED",
"ARSIGA KONICS PRIVATE LIMITED",
"ARSIGA SOLAR PRIVATE LIMITED",
"ARSIS DEVELOPERS PRIVATE LIMITED",
"ARSIWALA CONSTRUCTIONS PRIVATE LIMITED",
"ARSL INFRA PRIVATE LIMITED",
"ARSLAN SRS INDIA PRIVATE LIMITED",
"ARSOFT BUSINESS SOLUTIONS PRIVATE LIMITED",
"ARSOM CNC PRIVATE LIMITED",
"ARSPORTABLE AGNOSTIC SOLUTIONS (OPC) PRIVATE LIMITED",
"ARSS BIOFUEL PRIVATE LIMITED",
"ARSTEG SOLUTIONS PRIVATE LIMITED",
"ARSTU TRADELINKS LIMITED",
"ART & BEYOND PRIVATE LIMITED",
"ART AGE PRIVATE LIMITED",
"ART AUTO PRIVATE LIMITED",
"ART BLENDS LIMITED",
"ART CAPITAL (INDIA) PRIVATE LIMITED",
"ART CLUB PRIVATE LIMITED",
"ART DECOR FASHION PRIVATE LIMITED",
"ART EXIM PRIVATE LIMITED",
"ART FM AUTO TECH INDIA PRIVATE LIMITED",
"ART FOREVER PRIVATE LIMITED",
"ART HOUSING FINANCE INDIA LIMITED",
"ART INDIA",
"ART INFRASTRUCTURE PRIVATE LIMITED",
"ART IRON ENGINEERING SERVICES PRIVATE LIMITED",
"ART KARAT INTERNATIONAL LTD",
"ART MECANIX PRIVATE LIMITED",
"ART MEDIA ADVERTISING PRIVATE LIMITED",
"ART NIRMAN LIMITED",
"ART O PRINT",
"ART OF TECHNOLOGIES INFRASTRUCTURE LIMITED",
"ART ROOM PROPERTIES PRIVATE LIMITED",
"ART RUBBER INDUSTRIES LIMITED",
"ART SPECIAL SITUATIONS FINANCE (INDIA) LIMITED",
"ART TECHNOLOGY AND SOFTWARE INDIA PRIVATE LIMITED",
"ART TRADE INDIA ENTERPRISES PRIVATE LIMITED",
"ART URBA LANDSCAPE INDIA PRIVATE LIMITED",
"ART VENTURE FINANCE (INDIA) PRIVATE LIMITED",
"ART YARN EXPORTS INDIA PRIVATE LIMITED",
"ARTA BROCH CERAMICS PRIVATE LIMITED",
"ARTAGE MEDIA PRIVATE LIMITED",
"ARTAGE STUDIO PRIVATE LIMITED",
"ARTAXERXES FITNESS AND LIFESTYLE PRIVATE LIMITED",
"ARTCHEM AUXILARIES PRIVATE LIMITED",
"ART-E MEDIATECH PRIVATE LIMITED",
"ART-E -MIDE CONSTRUCTION PRIVATE LIMITED",
"ARTE-ALTER PRIVATE LIMITED",
"ARTEC ADHESIVE PRODUCTS PRIVATE LIMITED",
"ARTEC INFRASTRUCTURE PRIVATE LIMITED",
"ARTEC INKS & GRAPHICS PRIVATE LIMITED",
"ARTEC UTENSILS PRIVATE LIMITED",
"ARTECH CONSTRUCTION ENGINEERS PRIVATE LIMITED",
"ARTECH INFOSYSTEMS PRIVATE LIMITED",
"ARTECH INFRA ENGINEERING PRIVATE LIMITED",
"ARTECH INSTRUMENTS AND CONTROL PRIVATE LIMITED",
"ARTECH INTERNATIONAL PRIVATE LIMITED",
"ARTECH REALTORS PRIVATE LIMITED",
"ARTECH SOLUTIONS PRIVATE LIMITED",
"ARTECH WELDERS PRIVATE LIMITED",
"ARTECHE SMARTGRID INDIA PRIVATE LIMITED",
"ARTECO COOLANTS INDIA PRIVATE LIMITED",
"ARTEE FLOW CONTROLS PRIVATE LIMITED",
"ARTEE SHADES PRIVATE LIMITED",
"ARTEFACT INFRASTRUCTURE LIMITED",
"ARTEFACT PROJECTS LIMITED",
"ARTEFFECTS DECOR PRIVATE LIMITED",
"ARTEK ENTERPRISES PRIVATE LTD.",
"ARTEK EXPORTS LLP",
"ARTEK SURFIN CHEMICALS LIMITED",
"ARTEKER INDIA PRIVATE LIMITED",
"ARTELEX INTERIO AND PROJECTS PRIVATE LIMITED",
"ARTELIA HOME FURNISHINGS PRIVATE LIMITED",
"ARTELIA NAMASTE LIMITED",
"ARTELUXE DESIGNS PRIVATE LIMITED",
"ARTEM HEALTHTECH PRIVATE LIMITED",
"ARTEMIS AUTO INDIA PRIVATE LIMITED",
"ARTEMIS CARDIAC CARE PRIVATE LIMITED",
"ARTEMIS ELECTRICALS AND PROJECTS LIMITED",
"ARTEMIS OPTO ELECTRONIC TECHNOLOGIES PRIVATE LIMITED",
"ARTEMIS PROPERTIES PRIVATE LIMITED",
"ARTEMIS TECH PRIVATE LIMITED",
"ARTEOR AQUACRAFT PRIVATE LIMITED",
"ARTERAS ENGINEERING SERVICES PRIVATE LIMITED",
"ARTERIA TECHNOLOGIES PRIVATE LIMITED",
"ARTERIORS BUILD INDIA PRIVATE LIMITED",
"ARTERY INFRA PROJECTS PRIVATE LIMITED",
"ARTESANO LIFESTYLE PRIVATE LIMITED",
"ARTEX APPARELS PRIVATE LIMITED",
"ARTEX BUILDCON PRIVATE LIMITED",
"ARTEX ENGINEERS PRIVATE LIMITED",
"ARTEX FABRICS PRIVATE LIMITED",
"ARTEX KNITTING INDUSTRIES PRIVATE LIMITED",
"ARTEX OVERSEAS PRIVATE LIMITED",
"ARTEX TEXTILE PRIVAE LIMITED",
"ARTEX TRENDS (INDIA) PRIVATE LIMITED",
"ARTFIRST ENTERPRISES PRIVATE LIMITED",
"ARTH AIR TECHNOLOGIES PRIVATE LIMITED",
"ARTH APPLICATION CONSULTING PRIVATE LIMITED",
"ARTH BIOPLAST PRODUCTS PRIVATE LIMITED",
"ARTH BROADCAST & CINEETAINMENT PRIVATE LIMITED",
"ARTH CONCEPTS INDIA PRIVATE LIMITED",
"ARTH DIAGNOSTIC PRIVATE LIMITED",
"ARTH DISTRIBUTORS PRIVATE LIMITED",
"ARTH EQUIPMENTS PRIVATE LIMITED",
"ARTH FITNESS PRIVATE LIMITED",
"ARTH FOODS AND SERVICES PRIVATE LIMITED",
"ARTH HOUSING DEVELOPMENT P LTD",
"ARTH MICRO FINANCE PRIVATE LIMITED",
"ARTH POLYYARN PRIVATE LIMITED",
"ARTH RURAL CONNECT SERVICES PRIVATE LIMITED",
"ARTH TEKNET PRIVATE LIMITED",
"ARTH UDYOG LIMITED",
"ARTHA DATA SOLUTIONS INDIA PRIVATE LIMITED",
"ARTHA HERBS EXTRACTS AND DERIVATIVES INDIA PRIVATE LIMITED",
"ARTHA INFRATECH PRIVATE LIMITED",
"ARTHA LOGISTICS PRIVATE LIMITED",
"ARTHA MINERAL RESOURCES",
"ARTHA REAL ESTATE CORPORATION LIMITED",
"ARTHACERA TECHNOLOGIES PRIVATE LIMITED",
"ARTHAM FINOMETRY PRIVATE LIMITED",
"ARTHAM FINSERVE PRIVATE LIMITED",
"ARTHAN FINANCE PRIVATE LIMITED",
"ARTHANARI CLOTHING PRIVATE LIMITED",
"ARTHANARI LOOM CENTRE TEXTILE PRIVATE LIMITED",
"ARTHASHASTRA EPAYLATER FINANCIAL PRIVATE LIMITED",
"ARTHASHASTRA FINSEC PROVIDERS PRIVATE LIMITED",
"ARTHASHASTRA INVESTMENTS PRIVATE LIMITED",
"ARTHAV INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"ARTHAVYA MARKINN PRIVATE LIMITED",
"ARTHAYAN BIZFINMART PRIVATE LIMITED",
"ARTHBODH SHARES AND INVESTMENTS PRIVATE LIMITED",
"ARTHEN BUSINESS PROCESS SERVICES LLP",
"ARTHEON BATTERY COMPANY PRIVATE LIMITED",
"ARTHEON EMERGING TECHNOLOGIES PRIVATE LIMITED",
"ARTHIMPACT DIGITAL LOANS PRIVATE LIMITED",
"ARTHIMPACT FINSERVE PRIVATE LIMITED",
"ARTHIT INVESTMENT ADVISORS PRIVATE LIMITED",
"ARTHLABH SERVICES PRIVATE LIMITED",
"ARTHMATE FINANCING INDIA PRIVATE LIMITED",
"ARTHMATETECH PRIVATE LIMITED",
"ARTHOR SERVICES PRIVATE LIMITED",
"ARTHOS BREWERIES LIMITED",
"ARTHROGEN MEDICAL (OPC) PRIVATE LIMITED",
"ARTHRON IMPLANTS PRIVATE LIMITED",
"ARTHTECH CONSULTANTS PRIVATE LIMITED",
"ARTHUR BEST CONSULTING ENGINEERS PRIVATE LIMITED",
"ARTHUR D LITTLE",
"ARTHUR GRAND TECHNOLOGIES PRIVATE LIMITED",
"ARTHUR TURNKEY PROJECTS LIMITED",
"ARTHUR'S FOOD COMPANY PRIVATE LIMITED",
"ARTHYA WEALTH AND INVESTMENTS PRIVATE LIMITED",
"ARTI AGRO OIL PRODUCTS PRIVATE LIMITED",
"ARTI AGROTECH PRIVATE LIMITED",
"ARTI BAKERY PRIVATE LIMITED",
"ARTI ENTERPRISE",
"ARTI FACILITIES SERVICES PRIVATE LIMITED",
"ARTI FILAMENTS PRIVATE LIMITED",
"ARTI FOAM PRIVATE LIMITED",
"ARTI FOOD AND FATS PRIVATE LIMITED",
"ARTI MEDICAL RESEARCH FOUNDATION",
"ARTI PROPERTIES PRIVATE LIMITED",
"ARTI ROLLER FLOUR INDUSTRIES PRIVATE LIMITED",
"ARTI SILK MILLS PRIVATE LIMITED",
"ARTI SPRING AND RINGS INDUSTRIES PRIVATE LIMITED",
"ARTI WEB-DEVELOPERS PRIVATE LIMITED",
"ARTIC AIR CON PRIVATE LIMITED",
"ARTIFICIAL LEARNING SYSTEMS INDIA PRIVATE LIMITED",
"ARTIFICIAL LIMB CENTRE",
"ARTIFICIAL LIMBS MANUFACTURING CORPORATION OF INDIA",
"ARTIFINT TECHNOLOGIES PRIVATE LIMITED",
"ARTIGIANI TECHNOLOGIES (OPC) PRIVATE LIMITED",
"ARTIIFICE INTERIOR PRIVATE LIMITED",
"ARTILIGENCE PRIVATE LIMITED",
"ARTILIGENT SOLUTIONS PRIVATE LIMITED",
"ARTILLA HOTELS PRIVATE LIMITED",
"ARTILLERY CENTER",
"ARTIMAS FASHIONS PRIVATE LIMITED",
"ARTIN VIKRUTHI BRICKS PRIVATE LIMITED",
"ARTINCI ARTISANAL FOODS PRIVATE LIMITED",
"ARTINDIA EXPORT PRIVATE LIMITED",
"ARTINDIA HOME TEXTILE PRIVATE LIMITED",
"ARTIOS HOSPITAL",
"ARTIS AGRO PRIVATE LIMITED",
"ARTIS ANIMAL HEALTH CARE (INDIA) PRIVATE LIMITED",
"ARTIS APPAREL EXPORTS PRIVATE LIMITED",
"ARTIS FACILITY MANAGEMENT PRIVATE LIMITED",
"ARTIS INDUSTRIAL PRIVATE LIMITED",
"ARTIS INTERIORZ PRIVATE LIMITED",
"ARTIS INTERNATIONAL PRIVATE LIMITED",
"ARTIS MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"ARTIS TECHNICAL TEXTILE PRIVATE LIMITED",
"ARTISAN BUSINESS VENTURES PRIVATE LIMITED",
"ARTISAN FURNISHINGS PRIVATE LIMITED",
"ARTISAN GROWN ORGANICS PRIVATE LIMITED",
"ARTISAN IT SOLUTIONS PRIVATE LIMITED",
"ARTISAN SPIRITS PRIVATE LIMITED",
"ARTISANAL DRINKS PRIVATE LIMITED",
"ARTISANE PROJECTS LLP",
"ARTISANO FOODS PRIVATE LIMITED",
"ARTISIGHTS SOLUTION PRIVATE LIMITED",
"ARTIST GOLD PAINTS PRIVATE LIMITED",
"ARTISTERY HOUSE PRIVATE LIMITED",
"ARTISTIC ARTFORUM PRIVATE LIMITED",
"ARTISTIC BRAIN EDUCATION PRIVATE LIMITED",
"ARTISTIC HANDICRAFTS PRIVATE LIMITED",
"ARTISTIQUE CERAMICS PRIVATE LIMITED",
"ARTIUS INTERIOR PRODUCTS PRIVATE LIMITED",
"ARTIZ CERAMICS PRIVATE LIMITED",
"ARTIZEN EXIM PRIVATE LIMITED",
"ARTIZEN INTERIORS PRIVATE LIMITED",
"ARTKONNECT MANAGEMENT PRIVATE LIMITED",
"ARTLAB INDIA PRIVATE LIMITED",
"ARTLAY AGRITECH PRIVATE LIMITED",
"ARTLIFE GLOBAL INDIA PRIVATE LIMITED",
"ARTLIFE WELLNESS PRODUCTS PRIVATE LIMITED",
"ARTLINE COSMETICS PRIVATE LIMITED",
"ARTLINE VINIMAY PVT LTD",
"ARTLITE ILLUMINATION PRIVATE LIMITED",
"ARTMAN ADVERTISING MEDIA PRIVATE LIMITED",
"ARTMED HEALTHCARE PRIVATE LIMITED",
"ARTMICA LAMINATES PRIVATE LIMITED",
"ARTNICO HAND CRAFTS AND DESIGNS PRIVATE LIMITED",
"ARTOON SOLUTIONS PRIVATE LIMITED",
"ART-PAC CORRUGATION PRIVATE LIMITED",
"ARTPALACE EXPORT PRIVATE LIMITED",
"ARTRIKA SOLUTIONS PRIVATE LIMITED",
"ARTRISE ART PRIVATE LIMITED",
"ARTS & COMMERCE MAHAVIDYALAYA",
"ARTS & SCIENCE COLLEGE PATODA",
"ARTS COLLEGE MALKAPUR AKOLA",
"ARTS COMMERCE & SCIENCE COLLEGE DINDORI",
"ARTS EXPRESS SOLUTIONS PRIVATE LIMITED",
"ARTSANA INDIA PRIVATE LIMITED",
"ARTSTREET INTERNATIONAL SOLUTIONS PRIVATE LIMITED",
"ARTUNICO PRIVATE LIMITED",
"ARTUR SCHADE STEEL PRODUCTS INDIA PRIVATE LIMITED",
"ARTURA PHARMACEUTICALS PRIVATE LIMITED",
"ARTVIEW MERCHANTS PRIVATE LIMITED",
"ARTWALK BUILDCON PRIVATE LIMITED",
"ARTWALL DESIGN'S PRIVATE LIMITED",
"ARTWORK DESIGNS PRIVATE LIMITED",
"ARTWORM STUDIO PRIVATE LIMITED",
"ARTYEM HOSPITALS PRIVATE LIMITED",
"ARUABHISHEK REALTORS PRIVATE LIMITED",
"ARUBA NETWORKS INDIA PRIVATE LIMITED",
"ARUDHRA PROPERTIES LIMITED",
"ARUDRA ENGINEERS PRIVATE LIMITED",
"ARUGONDA INFRATECH PRIVATE LIMITED",
"ARUHAT TECHNOLOGIES PRIVATE LIMITED",
"ARUJ BUILDCON PRIVATE LIMITED",
"ARUL ENGINEERING PRIVATE LIMITED",
"ARUL INDUSTRIES",
"ARUL LINU GRABS PRIVATE LIMITED",
"ARUL MURUGAN EDIBLE OILS PRIVATE LIMITED",
"ARUL POLYMERS PRIVATE LIMITED",
"ARUL RUBBERS PRIVATE LIMITED",
"ARULDEVI PAPER MILLS PRIVATE LIMITED",
"ARULJOTHI INFRASTRUCTURE PRIVATE LIMITED",
"ARULPURAM COMMON EFFLUENT TREATMENT COMPANY PRIVATE LIMITED",
"ARUM CONSULTANCY SERVICES PRIVATE LIMITED",
"ARUMAYAAL TEXTILES PRIVATE LIMITED",
"ARUMUGAM SPINNING MILLS PRIVATE LIMITED",
"ARUN ART PRINTERS PRIVATE LIMITED",
"ARUN CANNS PRIVATE LIMITED",
"ARUN COLOURCHEM PRIVATE LIMITED",
"ARUN DEVELOPERS",
"ARUN DISTRIBUTORS PVT LTD",
"ARUN EDUCATIONAL SERVICES PRIVATE LIMITED",
"ARUN ELECTRICALS PRIVATE LIMITED",
"ARUN ENERGIES LIMITED",
"ARUN ENGINEERING PROJECTS PRIVATE LIMITED",
"ARUN ENTERPRISES PRIVATE LIMITED",
"ARUN EXCELLO CONSTRUCTIONS LLP",
"ARUN EXCELLO HOMES PRIVATE LIMITED",
"ARUN EXCELLO REALTY PRIVATE LIMITED",
"ARUN GULAB CHAND SARRAF PRIVATE LIMITED",
"ARUN GUPTA ADVISORS PRIVATE LIMITED",
"ARUN HOMES PRIVATE LIMITED",
"ARUN IMPEX PRIVATE LIMITED",
"ARUN JOSHI EDUCATIONAL COLLEGE",
"ARUN KANNAN AGRO FOODS PRIVATE LIMITED",
"ARUN KIRAN OVERSEAS PRIVATE LIMITED",
"ARUN KUMAR AGARWAL SOLAR PRIVATE LIMITED",
"ARUN LASER OVENS PRIVATE LIMITED",
"ARUN MANUFACTURING SERVICES PRIVATE LIMITED",
"ARUN MOTORS PRIVATE LIMITED",
"ARUN OILS PRIVATE LIMITED",
"ARUN OXYGEN LIMITED",
"ARUN PLASTO MOULDERS INDIA PRIVATE LIMITED",
"ARUN POLYCHEM PRIVATE LIMITED",
"ARUN PRESS PRIVATE LIMITED",
"ARUN REGA BAKERY MACHINERIES PRIVATE LIMITED",
"ARUN SEALS PRIVATE LIMITED",
"ARUN SELVAN LOGISTICS PRIVATE LIMITED",
"ARUN SHANKAR TEXTILE",
"ARUN SIGN SERVICE PRIVATE LIMITED",
"ARUN SMELTERS PRIVATE LIMITED",
"ARUN SOIL LAB PRIVATE LIMITED",
"ARUN SPINNING MILLS PRIVATE LIMITED",
"ARUN TECH INDUSTRIAL SERVICES PRIVATE LIMITED",
"ARUN TECHNICAL PAPERS PRIVATE LIMITED",
"ARUN TEXTILE ENGINEERS PRIVATE LIMITED",
"ARUN TRADE COMBINES",
"ARUN TYRES PVT LTD",
"ARUN VASTRA BHANDAR PRIVATE LIMITED",
"ARUN VIDYA MANDIR ICHALKARANJI WARD NO 5",
"ARUN VIDYUTH PRIVATE LIMITED",
"ARUN VIJAYA HOSPITALS PRIVATE LIMITED",
"ARUN WIND MILLS INDIA PRIVATE LIMITED",
"ARUNA ALLOY STEELS PRIVATE LIMITED",
"ARUNA ASAF ALI HOSPITAL",
"ARUNA BAKERY",
"ARUNA BUILDING TECHNOLOGIES PRIVATE LIMITED",
"ARUNA BUILDWELL PRIVATE LIMITED",
"ARUNA COOLING PRIVATE LIMITED",
"ARUNA FINANCE LIMITED",
"ARUNA HEALTH CARE PRIVATE LIMITED",
"ARUNA HOTELS LIMITED",
"ARUNA INDUSTRIAL PRODUCTS PRIVATE LIMITED",
"ARUNA ISPAT PRIVATE LIMITED",
"ARUNA LOGISTICS INDIA PRIVATE LIMITED",
"ARUNA MEGAMART PRIVATE LIMITED",
"ARUNA MOTORS PRIVATE LIMITED",
"ARUNA PROMOTERS PRIVATE LIMITED",
"ARUNA SAFETY LOCKERS PRIVATE LIMITED",
"ARUNA SCAN & DIAGNOSTICS PRIVATE LIMITED",
"ARUNA THEATRES & ENTERPRISES PRIVATE LIMITED",
"ARUNAAGOLD TEX CORPORATE PRIVATE LIMITED",
"ARUNACHAL BOARDS INDIA PRIVATE LIMITED",
"ARUNACHAL MOTORS PRIVATE LIMITED",
"ARUNACHAL PRADESH POWER CORPORATION PRIVATE LIMITED",
"ARUNACHAL TEA & INDUSTRIES PRIVATE LIMITED",
"ARUNACHAL TIMBER TRADERS PRIVATE. LIMITED.",
"ARUNACHALA CONSULTANTS PRIVATE LIMITED",
"ARUNACHALA GOUNDER TEXTILE MILLS PRIVATE LIMITED",
"ARUNACHALA LOGISTICS PRIVATE LIMITED",
"ARUNACHALA SPINNING MILLS INDIA PRIVATE LIMITED",
"ARUNACHALAM FORWARDERS PRIVATE LIMITED",
"ARUNACHALAM SHIPPING SERVICES PRIVATE LIMITED",
"ARUNAI AGROTECH PRIVATE LIMITED",
"ARUNAI MEDICAL COLLEGE AND HOSPITAL",
"ARUNAM BUSINESS SOLUTIONS PRIVATE LIMITED",
"ARUNAM FOUR-WHEELS PRIVATE LIMITED",
"ARUNAPANCHAMI ESTATES PRIVATE LIMITED",
"ARUNASREE INFRA DEVELOPERS PRIVATE LIMITED",
"ARUNASRK MINES AND MINERALS PRIVATE LIMITED",
"ARUNAV TECHNOLOGY & SYSTEMS PRIVATE LIMITED",
"ARUNAYA INSURANCE BROKERS PRIVATE LIMITED",
"ARUNAYA ORGANICS LIMITED",
"ARUNAYA ORGANICS PRIVATE LIMITED",
"ARUNDHATI ADVISORY SERVICES PRIVATE LIMITED",
"ARUNDHATI JEWELLERS PRIVATE LIMITED",
"ARUNDHATI MOTORS PRIVATE LIMITED",
"ARUNDHATI PAPERS INTERNATIONAL PRIVATE LIMITED",
"ARUNDWATI HOTELS AND RESORTS PRIVATE. LIMITED.",
"ARUNEH SOLUTIONS PRIVATE LIMITED",
"ARUNESHWAR ENGINEERING WORKS PRIVATE LIMITED",
"ARUNI STONE CRUSHER AND TRANSPORT SERVICES PRIVATE LIMITED",
"ARUNIKA SERVICES PRIVATE LIMITED",
"ARUNIL POLYBIZ PRIVATE LIMITED",
"ARUNIL POLYCRAFT PRIVATE LIMITED",
"ARUNIL VENTURES PRIVATE LIMITED",
"ARUNIMA FLAVOURS PRIVATE LIMITED",
"ARUNIS ABODE LIMITED",
"ARUNIS FINANCIAL AND MANAGEMENT CONSULTANT PRIVATE LIMITED",
"ARUNJYOTI BIO VENTURES LIMITED",
"ARUNKUMAR DESIGNERS AND CONSULTANTS PRIVATE LIMITED",
"ARUNLAL HOTELS AND INVESTMENTS PRIVATE LIMITED",
"ARUNNACHALA IMPEX PRIVATE LIMITED",
"ARUNODAY CONSTRUCTION CO PRIVATE LIMITED",
"ARUNODAY ENTERPRISE",
"ARUNODAY HOLDING PVT LTD",
"ARUNODAY SUPERSPECIALITY HOSPITAL AHMEDNAGAR",
"ARUNODAY TEA COMPANY PVT LTD",
"ARUNODAYA BOXES & PAPERS PRIVATE LIMITED",
"ARUNODAYA FOODS PRIVATE LIMITED",
"ARUNODAYA GRAN-TECH PRIVATE LIMITED",
"ARUNODAYA HEALTH CARE PRIVATE LIMITED",
"ARUNODAYA HOSPITALS PRIVATE LIMITED",
"ARUNODAYA NOTEBOOK MANUFACTURERS PRIVATE LIMITED",
"ARUNODAYA POWER PROJECTS PRIVATE LIMITED",
"ARUNODAYA PRINT PACK PRIVATE LIMITED",
"ARUNODAYA PUBLIC SCHOOL",
"ARUNODAYA SEEDS PRIVATE LIMITED",
"ARUNODEEP INFRASTRUCTURE PRIVATE LIMITED",
"ARUNODYA COAL TRADERS PRIVATE LIMITED",
"ARUNODYA FEEDS PRIVATE LIMITED",
"ARUNS KITCHEN CHEF INDIA PRIVATE LIMITED",
"ARUP INDIA PRIVATE LIMITED",
"ARUPADAI ARULMURUGAN SPINNERS PRIVATE LIMITED",
"ARUPPUKOTTAI SHRI RAMALINGA SPINNERS PRIVATE LIMITED",
"ARUPPUKOTTAI SRI JAYA VILAS PRIVATE LIMITED",
"ARUPRI INDUSTRIES PRIVATE LIMITED",
"ARUPRIYA FACILITY MANAGEMENT PRIVATE LIMITED",
"ARUS INFO PRIVATE LIMITED",
"ARUSH FACILITY MANAGEMENT PRIVATE LIMITED",
"ARUSH MANAGEMENT SERVICES INDIA LLP",
"ARUSH METAL CASTING LIMITED",
"ARUSHI ELECTRONICS PRIVATE LIMITED",
"ARUSHI MEDICAL CENTRE PRIVATE LIMITED",
"ARUSHI ORNAMENTS & JEWELLERS PRIVATE LIMITED",
"ARUSHII MORE DESIGN PRIVATE LIMITED",
"ARUSHRUTI ENTERPRISES PRIVATE LIMITED",
"ARUSUVAI ARASU CATERERS PRIVATE LIMITED",
"ARUSUVAI MASALA AND FOODS PRIVATE LIMITED",
"ARUTI AGRITECH INDIA PRIVATE LIMITED",
"ARUVADAI ORGANIC PRODUCE PRIVATE LIMITED",
"ARUVEE DAIRY AND FOODS PRIVATE LIMITED",
"ARV EDUCATORS PRIVATE LIMITED",
"ARV HEALTHCARE PRIVATE LIMITED",
"ARV ISPAT PRIVATE LIMITED",
"ARV TRAVELS PRIVATE LIMITED",
"ARVA FASTENERS PRIVATE LIMITED",
"ARVAIS NATURES PRODUCTS PRIVATE LIMITED",
"ARVAL INDIA PRIVATE LIMITED",
"ARVALLI CASTOR DERIVATIVES PRIVATE LIMITED",
"ARVALLI MRI AND IMAGING CENTRE PRIVATE LIMITED",
"ARVAUTO ECOM PRIVATE LIMITED",
"ARVDEVA ENTERPRISES PRIVATE LIMITED",
"ARVEE ELECTRICALS AND ENGINEERS PVT LTD",
"ARVEE FANS AND APPLIANCES PRIVATE LIMITED",
"ARVEE LABORATORIES INDIA LIMITED",
"ARVEE MARINE PROJECTS PRIVATE LIMITED",
"ARVEN TEXKNIT PRIVATE LIMITED",
"ARVENSE TEXTILES PRIVATE LIMITED",
"ARVENSIS ENERGY PRIVATE LIMITED",
"ARVENSIS JAYAAM INDIA PRIVATE LIMITED",
"ARVENSYS TECHNOLOGIES PRIVATE LIMITED",
"ARVESA ENGINEERING PRIVATE LIMITED",
"ARVEZ ENERGY PRIVATE LIMITED",
"ARVI HITECH PRIVATE LIMITED",
"ARVIA CONSTRUCTIONS PRIVATE LIMITED",
"ARVIAN BUSINESS SOLUTIONS PRIVATE LIMITED",
"ARVIK LABS PRIVATE LIMITED",
"ARVIK LIFE SCIENCES",
"ARVIK PHARMA PRIVATE LIMITED",
"ARVIN ULTIMATE ENERGY RESOURCES PRIVATE LIMITED",
"ARVIND AND COMPANY SHIPPING AGENCIES LIMITED",
"ARVIND ANTICOR LIMITED",
"ARVIND AUTOMOTIVE (INDIA) PRIVATE LIMITED",
"ARVIND BABBAL PRODUCTIONS PRIVATE LIMITED",
"ARVIND BEAUTY BRANDS RETAIL PRIVATE LIMITED",
"ARVIND BRANDS PRIVATE LIMITED",
"ARVIND CERAMICS PRIVATE LIMITED",
"ARVIND CHEMI SYNTHETICS PRIVATE LIMITED",
"ARVIND CONDUCTORS PRIVATE LIMITED",
"ARVIND CONSTRUCTION CO PRIVATE LIMITED",
"ARVIND CORROTECH LIMITED",
"ARVIND COTSYN INDIA LTD",
"ARVIND CREATIONS PRIVATE LIMITED",
"ARVIND DAIRY PRIVATE LIMITED",
"ARVIND DYEING AND BLEACHING MILLS PRIVATE LIMITED",
"ARVIND ENGINEERED COMPOSITE PANELS PRIVATE LIMITED",
"ARVIND ENGINEERING WORKS LIMITED",
"ARVIND EXIM",
"ARVIND FARMS PVT LTD",
"ARVIND FASHIONS LIMITED",
"ARVIND FOOTWEAR PRIVATE LIMITED",
"ARVIND FOUNDATION",
"ARVIND GANDBHIR HIGH SCHOOL",
"ARVIND GAVALI COLLEGE OF ENGINEERING",
"ARVIND GOODHILL SUIT MANUFACTURING PRIVATE LIMITED",
"ARVIND GREEN INFRA PRIVATE LIMITED",
"ARVIND HEBBAL HOMES PRIVATE LIMITED",
"ARVIND HOSPITAL PRIVATE LIMITED",
"ARVIND HYDROPACK PRIVATE LIMITED",
"ARVIND IMPEX INDIA PRIVATE LIMITED",
"ARVIND INDUSTRIALS PRIVATE LIMITED",
"ARVIND INFRADEVELOPERS PRIVATE LIMITED",
"ARVIND INFRASTRUCTURE LIMITED",
"ARVIND INORGANICS PRIVATE LIMITED",
"ARVIND ISPAT TRADING PRIVATE LIMITED",
"ARVIND KUMAR NAND KUMAR LTD",
"ARVIND LIFESTYLE BRANDS LIMITED",
"ARVIND LIMITED",
"ARVIND MANPOWER SOLUTIONS PRIVATE LIMITED",
"ARVIND MECHANICAL AND ELECTRICAL ENGINEERS PRIVATE LIMITED",
"ARVIND MEDICARE PRIVATE LIMITED",
"ARVIND METALS & MINERALS PVT LTD",
"ARVIND MOTORS PRIVATE. LIMITED.",
"ARVIND OG NONWOVENS PRIVATE LIMITED",
"ARVIND PD COMPOSITES PRIVATE LIMITED",
"ARVIND PHARMA CHEM PRIVATE LIMITED",
"ARVIND PRESS CAPS LIMITED",
"ARVIND PUMPS PRIVATE LIMITED",
"ARVIND REALTORS PRIVATE LIMITED",
"ARVIND RUB-WEB CONTROLS LIMITED",
"ARVIND SHARE TRADERS PRIVATE LIMITED",
"ARVIND SMART TEXTILES LIMITED",
"ARVIND SMARTSPACES LIMITED",
"ARVIND SYNTEX PRIVATE LIMITED",
"ARVIND TECHNO ENGINEERS PRIVATE LIMITED",
"ARVIND TECHNO INFRA PRIVATE LIMITED",
"ARVIND TECHNOCRATS & ENGINEERS LLP",
"ARVIND TRUE BLUE LIMITED",
"ARVIND UNIVERSAL TEXTILES PRIVATE LIMITED",
"ARVIND V JOSHI & CO. CFS",
"ARVIND VEHICLES PRIVATE LIMITED",
"ARVIND YOUTH BRANDS PRIVATE LIMITED",
"ARVINDBHAI BECHARDAS JEWELLERS PRIVATE LIMITED",
"ARVINDBHAI KHATRI SONS DESIGNS PRIVATE LIMITED",
"ARVINDO FABNOPLAST PVT LTD",
"ARVINDO HI-TECH PRIVATE LIMITED",
"ARVINTH LOGISTICS INDIA PRIVATE LIMITED",
"ARVITIS BISTRO PRIVATE LIMITED",
"ARVM ENTERPRISES PRIVATE LIMITED",
"ARVOG FOREX PRIVATE LIMITED",
"ARVOS LJUNGSTROM ENERGY INDIA PRIVATE LIMITED",
"ARVS EQUIPMENTS PRIVATE LIMITED",
"ARW INFRA PROJECTS PRIVATE LIMITED",
"ARWA PLASTICS AND ELECTRICALS PRIVATE LIMITED",
"ARWACHIN BHARTI BHAWAN SENIOR SECONDARY SCHOOL",
"ARWACHIN INTERNATIONAL SCHOOL",
"ARWADE INFRASTRUCTURE LIMITED",
"ARWASYS TECHNOKRAFT PRIVATE LIMITED",
"ARWEN FRAGRANCES PRIVATE LIMITED",
"ARWIN EXPORTS PRIVATE LIMITED",
"ARX MINING AND CONSTRUCTION EQUIPMENT PRIVATE LIMITED",
"ARXXUS TECHNOLOGIES INDIA PRIVATE LIMITED",
"ARYA AGROFOODS PRIVATE LIMITED",
"ARYA ALLOYS PRIVATE LIMITED",
"ARYA AND AVYA INFRASTRUCTURE PRIVATE LIMITED",
"ARYA AUSHADHI PHARMA MUMBAI PRIVATE LIMITED",
"ARYA AUTO TECH PRIVATE LIMITED",
"ARYA AUTOWHEELS PRIVATE LIMITED",
"ARYA BUILDCON PRIVATE LIMITED",
"ARYA CAPITAL MANAGEMENT PRIVATE LIMITED",
"ARYA CHANYKA VID PRIMARY SCHOOL BADNAPUR",
"ARYA COKE PRIVATE LIMITED",
"ARYA COLLATERAL WAREHOUSING SERVICES PRIVATE LIMITED",
"ARYA COLLEGE",
"ARYA COLLEGE OF ENGINEERING & IT",
"ARYA COMMUNICATIONS AND ELECTRONICS SERVICES PRIVATE LIMITED",
"ARYA COMPUTECH PRIVATE LIMITED",
"ARYA CONSTRUCTIONS PRIVATE LIMITED",
"ARYA DEBTS MANAGEMENT PRIVATE LIMITED",
"ARYA ELECTRONICS AND CONTROLS PRIVATE LIMITED",
"ARYA ENERGY LIMITED",
"ARYA ENGINEERS AND CONTRACTORS PRIVATE LIMITED",
"ARYA FACILITIES PRIVATE LIMITED",
"ARYA FARM PRODUCTS PRIVATE LIMITED",
"ARYA FILAMENTS PRIVATE LIMITED",
"ARYA FIN-TRADE SERVICES (INDIA) PRIVATE LIMITED",
"ARYA FIN-TRADE SERVICES INDIA PRIVATE LIMITED",
"ARYA FISCAL SERVICES PRIVATE LIMITED",
"ARYA GRUHA PRIVATE LIMITED",
"ARYA GURUKUL",
"ARYA HOMES PRIVATE LIMITED",
"ARYA HOSPITAL",
"ARYA HYBRID SEEDS LIMITED",
"ARYA INFRACEUTICALS PRIVATE LIMITED",
"ARYA INSTITUTE OF ENG. TEC. & MANAGEMENT",
"ARYA IRON & STEEL COMPANY PRIVATE LIMITED",
"ARYA KANYA INTER COLLEGE",
"ARYA KANYA PATHSHALA INTER COLLEGE ROORKEE",
"ARYA KANYA VIDYALAYA HIGH SCHOOL",
"ARYA LABOUR SERVICES PRIVATE LIMITED",
"ARYA LAXMI PRECISION PRIVATE LIMITED",
"ARYA LUMBERS PRIVATE LIMITED",
"ARYA MAIN CAMPUS PRIVATE LIMITED",
"ARYA MARKET RESEARCH PRIVATE LIMITED",
"ARYA METACAST PRIVATE LIMITED",
"ARYA METALS PRIVATE LIMITED",
"ARYA OFFSET PRIVATE LIMITED",
"ARYA OFFSHORE SERVICES PRIVATE LIMITED",
"ARYA OMNITALK WIRELESS SOLUTIONS PRIVATE LIMITED",
"ARYA PAPER PRODUCTS PRIVATE LIMITED",
"ARYA PROJECTS LIMITED",
"ARYA RISK MANAGEMENT SYSTEMS PRIVATE LIMITED",
"ARYA ROADWAYS AND CO PVT LTD",
"ARYA SCIENTIFIC INSTRUMENTS PRIVATE LIMITED",
"ARYA SEA FOODS PRIVATE LIMITED",
"ARYA SHIP CHARTERERS PRIVATE LIMITED",
"ARYA SONS U V COATING PRIVATE LIMITED",
"ARYA SR SEC SCHOOL",
"ARYA STEELS PVT LTD",
"ARYA STEELS ROLLING (INDIA) PRIVATE LIMITED",
"ARYA TANKERS PRIVATE LIMITED",
"ARYA TELELINK PRIVATE LIMITED",
"ARYA TRANSFORMERS PRIVATE LIMITED",
"ARYA TRANSLOGISTICS PRIVATE LIMITED",
"ARYA VAIDIK JHS KUTUBPUR GOLA FATEHABAD",
"ARYA VAIDYA SALA KOTTAKKAL",
"ARYA VAIDYA SALA, KOTTAKKAL",
"ARYA VIDYA MANDIR GROUP OF INSTITUTES",
"ARYA WORLDWIDE PRIVATE LIMITED",
"ARYAA FOREX PRIVATE LIMITED",
"ARYAA MODERN INFRAPROJECTS PRIVATE LIMITED",
"ARYAA NEURO SPINE AND SUPER SPECIALITY HOSPITAL PRIVATE LIMITED",
"ARYAAN ACCOMMODATIONS PRIVATE LIMITED",
"ARYAANSH BIONATURALS PRIVATE LIMITED",
"ARYABHANGY BUILDERS PRIVATE LIMITED",
"ARYABHAT TECNOTRADER PRIVATE LIMITED",
"ARYABHAT VYAPAR PRIVATE LIMITED",
"ARYABHATA BIOMETRIC SYSTEMS PRIVATE LIMITED",
"ARYABHATT POLYTECHNIC",
"ARYABHATT SALES PVT LTD",
"ARYABHATTA ACADEMIC SOCIETY",
"ARYABHATTA COLLEGE OF ENGINEERING & RESEARCH CENTRE",
"ARYABHATTA SOLUTIONS AND IT PARKS LIMITED",
"ARYADEEP SILKY RICE MILL PRIVATE LIMITED",
"ARYADHAN FINANCIAL SOLUTIONS PRIVATE LIMITED",
"ARYADOOT TRANSPORT PRIVATE LIMITED",
"ARYAHI INFRASTRUCTURE PRIVATE LIMITED",
"ARYAINFRATECH INDIA PRIVATE LIMITED",
"ARYAJAN VENTURES PRIVATE LIMITED",
"ARYAKA NETWORKS INDIA PRIVATE LIMITED",
"ARYAM EDUCATIONAL ACADERMY",
"ARYAM STEELS PRIVATE LIMITED",
"ARYAMA COMTRADE PRIVATE LIMITED",
"ARYAMAN BUILDERS PRIVATE LIMITED",
"ARYAMAN CAPITAL MARKETS LIMITED",
"ARYAMAN CIVICON PRIVATE LIMITED",
"ARYAMAN ENTERPRISE PRIVATE LIMITED",
"ARYAMAN FINANCIAL SERVICES LIMITED",
"ARYAMAN INTERIORS (OPC) PRIVATE LIMITED",
"ARYAMAN ISPAT PRIVATE LIMITED",
"ARYAMAN PLASTIC PRIVATE LIMITED",
"ARYAMAN TECHNOLOGIES PRIVATE LIMITED",
"ARYAMAY ENTERPRISES AND CONSULTANTS PRIVATE LIMITED",
"ARYA-METAL ROOFS PRIVATE LIMITED",
"ARYAMMAN INTERIOR SOLUTIONS PRIVATE LIMITED",
"ARYAN AESTHETICS PRIVATE LIMITED",
"ARYAN APPARELS PRIVATE LIMITED",
"ARYAN AQUA (INDIA) PRIVATE LIMITED",
"ARYAN ARCADE LIMITED",
"ARYAN ASSOCIATES PRIVATE LIMITED",
"ARYAN AUTOAGENCIES PRIVATE LIMITED",
"ARYAN AVIATION PRIVATE LIMITED",
"ARYAN BIOTECH PRIVATE LIMITED",
"ARYAN BOILERS PRIVATE LIMITED",
"ARYAN BUILDESTATES PRIVATE LIMITED",
"ARYAN CARE PRIVATE LIMITED",
"ARYAN CLEAN COAL TECHNOLOGIES PRIVATE LIMITED.",
"ARYAN COMPOSITES PRIVATE LIMITED",
"ARYAN CONSTRUCTION & ASSOCIATES",
"ARYAN CROP PROTECTION PRIVATE LIMITED",
"ARYAN CULTURE A INTER COLLEGE",
"ARYAN DHATU PRIVATE LIMITED",
"ARYAN ELECTRICALS PRIVATE LIMITED",
"ARYAN ENERGY PRIVATE LIMITED",
"ARYAN ENTERPRISES PRIVATE LIMITED",
"ARYAN EXPORTERS PRIVATE LIMITED",
"ARYAN FEEDS PRIVATE LIMITED",
"ARYAN FOOD INGREDIENTS LIMITED",
"ARYAN GRANITES AND MONUMENTS PRIVATE LIMITED",
"ARYAN HOSPITAL PRIVATE LIMITED",
"ARYAN HOTELS & RESORTS PRIVATE LIMITED",
"ARYAN HOUSING CORPORATION",
"ARYAN IMAGING AND BUSINESS CONSULTANTS PRIVATE LIMITED",
"ARYAN INFRAGOLD PRIVATE LIMITED",
"ARYAN INFRAHEIGHT PRIVATE LIMITED",
"ARYAN INFRASPACE PRIVATE LIMITED",
"ARYAN INNOVATIVE TECHNO ENGINEERING (I) PRIVATE LIMITED",
"ARYAN INTELLIGENT SECURITY PRIVATE LIMITED",
"ARYAN ISPAT AND POWER PRIVATE LIMITED",
"ARYAN ISPAT PRIVATE LIMITED",
"ARYAN LIFE STYLE PRIVATE LIMITED",
"ARYAN LUBRICANTS PRIVATE LIMITED",
"ARYAN MEDICARE PRIVATE LIMITED",
"ARYAN METALLOYS PRIVATE LIMITED",
"ARYAN MINERALS AND METALS PRIVATE LIMITED",
"ARYAN MINING & TRADING CORP. PRIVATE. LIMITED",
"ARYAN MOTORS PRIVATE LIMITED",
"ARYAN NATURALS PRIVATE LIMITED",
"ARYAN PACKAGING PRODUCTS PRIVATE LIMITED",
"ARYAN PAINTING SOLUTIONS PRIVATE LIMITED",
"ARYAN PAINTS PVT LTD",
"ARYAN PAPER MILLS PRIVATE LIMITED",
"ARYAN PETROCHEMICALS PRIVATE LIMITED",
"ARYAN PLASTIC EXPORTS PRIVATE LIMITED",
"ARYAN PRECISIONS PRIVATE LIMITED",
"ARYAN PUMPS & ENVIRO SOLUTIONS PRIVATE LIMITED",
"ARYAN RESIDENCY LIMITED",
"ARYAN SHARE & STOCK BROKERS LIMITED",
"ARYAN STAINLESS PRIVATE LIMITED",
"ARYAN SUPPLIER & COLONISER PRIVATE LIMITED",
"ARYAN TASK SECURITY SERVICES PRIVATE LIMITED",
"ARYAN TEA PLANTATION PRIVATE LIMITED",
"ARYAN TECHNOLOGIES AND TELECOMMUNICATION PRIVATE LIMITED",
"ARYAN TELECOMMUNICATION & INFOTECH PRIVATE LIMITED",
"ARYAN TOLL ROAD PRIVATE LIMITED",
"ARYAN TRADE WORLD PRIVATE LIMITED",
"ARYAN TRENDS PRIVATE LIMITED",
"ARYAN WELLNESS PRIVATE LIMITED",
"ARYAN WHEELS PRIVATE LIMITED",
"ARYAN WOOD PRODUCTS PRIVATE LIMITED",
"ARYANBAGGA ASSOCIATES PRIVATE LIMITED",
"ARYANGLA VAIDYAK MAHAVIDYALAYA SATARA",
"ARYANN CHEMICAL TRADING PRIVATE LIMITED",
"ARYANS EDUTECH PRIVATE LIMITED",
"ARYANS GROUP OF COLLEGES",
"ARYANS INFRASTRUCTURE PRIVATE LIMITED",
"ARYANS POWERTECH PRIVATE LIMITED",
"ARYANSH ALLOYS PRIVATE LIMITED",
"ARYANSH EXPORTS PRIVATE LIMITED",
"ARYANSH STEELS PRIVATE LIMITED",
"ARYAOMNITALK RADIO TRUNKING SERVICES LIMITED",
"ARYAS GRAINS PRIVATE LIMITED",
"ARYAS PUBLISHERS DISTRIBUTORS PRIVATE LIMITED",
"ARYATECH ENGINEERING AND CONSULTANCY PRIVATE LIMITED",
"ARYATECH MARINE AND OFFSHORE SERVICES PRIVATE LIMITED",
"ARYAUZORA VENTURES PRIVATE LIMITED",
"ARYAV GREEN ENERGY PRIVATE LIMITED",
"ARYAVAAN RENEWABLE ENERGY PRIVATE LIMITED",
"ARYAVANSH LAND INFRATECH PRIVATE LIMITED",
"ARYAVART BANK",
"ARYAVART CHEMICALS PRIVATE LIMITED",
"ARYAVART DYEING PRIVATE LIMITED",
"ARYAVART GLOBAL PRIVATE LIMITED",
"ARYAVART MEDICAL SERVICES PRIVATE LIMITED",
"ARYAVART TRANSPORT COMPANY PRIVATE LIMITED",
"ARYAVARTA CIRCUITS PRIVATE LIMITED",
"ARYAVARTA KHANIJA PRIVATE LIMITED",
"ARYAVARTA ORGANICS PRIVATE LIMITED",
"ARYAVEER HOSPITALITY PRIVATE LIMITED",
"ARYAVIR BUILDCON PRIVATE LIMITED.",
"ARYAVRAT FINANCIAL SERVICES PRIVATE LIMITED",
"ARYAVRAT HOUSING CONSTRUCTIONS PRIVATE LIMITED",
"ARYAVRAT INFOTECH PRIVATE LIMITED",
"ARYAVRAT PROJECT AND DEVELOPERS PRIVATE. LIMITED.",
"ARYAVRAT SAVINGS UNIT PRIVATE LIMITED",
"ARYAVRAT TOLLWAYS PRIVATE. LIMITED.",
"ARYAVRATA STEEL PRIVATE LIMITED",
"ARYAWART ENTERPRISES PRIVATE LIMITED",
"ARYEN MOTORS INDIA PRIVATE LIMITED",
"ARYKITA TRADING PRIVATE LIMITED",
"ARYMAN FOOTWEAR EXPORTS PRIVATE LIMITED",
"ARYODAYA NEXMOVE PRIVATE LIMITED",
"ARYODAYA SALES PRIVATE LIMITED",
"ARYSON TECHNOLOGIES PRIVATE LIMITED",
"ARYSTA LIFESCIENCE INDIA LIMITED",
"ARZ FOOD VENTURES PRIVATE LIMITED",
"ARZION BUSINESS SOLUTIONS PRIVATE LIMITED",
"ARZNEI-ALFA PHARMA PRIVATE LIMITED",
"ARZO PLASTICS PRIVATE LIMITED",
"ARZOO.COM INDIA PRIVATE LIMITED",
"ARZT AND HEALTH PRIVATE LIMITED",
"AS ADVANCE SYSTEMS INDIA PRIVATE LIMITED",
"AS AGRIPAD PRIVATE LIMITED",
"AS AIR SYSTEMS PRIVATE LIMITED",
"AS AIRSPACE TRAVELS PRIVATE LIMITED",
"AS BUILDING SOLUTIONS PRIVATE LIMITED",
"AS BUILDING SYSTEMS PRIVATE LIMITED",
"AS COOLING TECHNOLOGIES INDIA PRIVATE LIMITED",
"AS ENGICON PRIVATE LIMITED",
"AS ENTERPRISES PRIVATE LIMITED",
"AS EQUIPMENT PRIVATE LIMITED",
"AS FOREX & TRAVELS PRIVATE LIMITED",
"AS HOSPITAL PRIVATE LIMITED",
"AS INFORMATION TECHNOLOGY PRIVATE LIMITED",
"AS INFRA AND ENGINEERING PRIVATE LIMITED",
"AS IT CONSULTING PRIVATE LIMITED",
"AS JUTE PRODUCTS PRIVATE. LIMITED.",
"AS KRISHNA ASSOCIATES LIMITED",
"AS MECHFLUID SOLUTIONS PRIVATE LIMITED",
"AS OBEROI LOGISTIC PRIVATE LIMITED",
"AS R MULTIMETALS PRIVATE LIMITED (TR CO)",
"AS REALTY AND INFRASTRUCTURE PRIVATE LIMITED",
"AS T INDIA",
"AS TARPAULINS PRIVATE LIMITED",
"AS TECHSERVICES PRIVATE LIMITED",
"AS TRADE SOLUTIONS PRIVATE LIMITED",
"AS VIDYAPEETH PVT LTD",
"AS4 CREATIONS AND SUPPORT SERVICES PRIVATE LIMITED",
"ASA & ASSOCIATES LLP",
"ASA AGROTECH PRIVATE. LIMITED.",
"ASA ASSEMBLY AUTOMATION PRIVATE LIMITED",
"ASA BHANU TECHNICAL SERVICES LIMITED",
"ASA DECOFUR PRIVATE LIMITED",
"ASA DHAN LAXMI PRIVATE LIMITED",
"ASA DIAGNOSTICS PRIVATE LIMITED",
"ASA GLOBAL IMPEX PRIVATE LIMITED",
"ASA HOLDINGS PRIVATE LIMITED",
"ASA IMPEX PRIVATE LIMITED",
"ASA INDUSTRIES LIMITED",
"ASA INFRASTRUCTURE PRIVATE LIMITED",
"ASA INTERNATIONAL INDIA MICROFINANCE LIMITED",
"ASA PERFECT PACK LIMITED",
"ASA SANITARIES PRIVATE LIMITED",
"ASAAD MARGIN FREE SUPER MARKET PRIVATE LIMITED",
"ASAB POWER SOLUTION PRIVATE LIMITED",
"ASADA DECOR PRIVATE LIMITED",
"ASADEEP FURNISHING PRIVATE LIMITED",
"ASAG ANDROAPPS TECHNOLOGY PRIVATE LIMITED",
"ASAHI BANK",
"ASAHI GLOBAL LINK PRIVATE LIMITED",
"ASAHI INDIA GLASS LIMITED",
"ASAHI KASEI INDIA PRIVATE LIMITED",
"ASAHI MODI MATERIALS PRIVATE LIMITED",
"ASAHI ROPES PRIVATE LIMITED",
"ASAHI SONGWON COLORS LIMITED",
"ASAHI SWITCHGEAR PRODUCTS LIMITED",
"ASAHI TECHNOLOGIES PRIVATE LIMITED",
"ASAHI TENNANTS COLOR PRIVATE LIMITED",
"ASAHI TRAVEL SERVICE PRIVATE LIMITED",
"ASAHIDENSO MULTILINK PRIVATE LIMITED",
"ASAHIDENSO R&D INDIA PRIVATE LIMITED",
"ASAHITEC STENCILS PRIVATE LIMITED",
"ASAI VISHWA SPECIALITY CHEMICALS PRIVATE LIMITED",
"ASAL ENGINEERING SERVICES PRIVATE LIMITED",
"ASAL FOOD PRODUCTS PRIVATE LIMITED",
"ASAL STONES PRIVATE LIMITED",
"ASALYA FOOD INGREDIENTS PRIVATE LIMITED",
"ASAM WHEAT PRODUCTS PRIVATE LIMITED",
"ASAMASUN MICRO FINANCE LIMITED",
"ASAN ENGINEERS PRIVATE LIMITED",
"ASAN MEMORIAL COLLEGE OF ARTS AND SCIENCE",
"ASAN MEMORIAL DENTAL COLLEGE AND HOSPITAL",
"ASAN MEMORIAL SENIOR SECONDARY SCHOOL",
"ASAN STEELS PRIVATE LIMITED",
"ASAN TECHNOLOGIES PRIVATE LIMITED",
"ASANDAS AND SONS PRIVATE LIMITED",
"ASANJO FOOD PRODUCT PRIVATE LIMITED",
"ASANKA BEARINGS PRIVATE LIMITED",
"ASANKHYA TRADING PRIVATE LIMITED",
"ASANSOL ALLOYS PRIVATE LIMITED",
"ASANSOL BOTTLING & PACKAGING CO PRIVATE LIMITED",
"ASANSOL HEALTHWORLD PRIVATE LIMITED",
"ASANSOL MUNICIPAL CORPORATION",
"ASANSOL POLYFABS PRIVATE. LIMITED.",
"ASANSOL STEEL CASTINGS PVT LTD",
"ASANSOL TRANSPORT PRIVATE LIMITED",
"ASANTECH MARKETING SOLUTIONS PRIVATE LIMITED",
"ASAP FLUIDS PRIVATE LIMITED",
"ASAP IMPACT PRIVATE LIMITED",
"ASAP INFO SYSTEMS PRIVATE LIMITED",
"ASAP PREFAB PRIVATE LIMITED",
"ASAP TALENT MANAGEMENT SOLUTIONS PRIVATELIMITED",
"ASAP TUTOR PRIVATE LIMITED",
"ASAP Y SOURCING SOLUTIONS PRIVATE LIMITED",
"ASAPP INFO GLOBAL SERVICES PRIVATE LIMITED",
"ASAR GREEN KABADI PRIVATE LIMITED",
"ASAR SOCIAL IMPACT ADVISORS PRIVATE LIMITED",
"ASARA BIOTECH PRODUCER COMPANY LIMITED",
"ASARA WORLDWIDE LOGISTICS PRIVATE LIMITED",
"ASARAGREEN INFRATECH PRIVATE LIMITED",
"ASARFI HOSPITAL LIMITED",
"ASARVA CHIPS AND TECHNOLOGIES PRIVATE LIMITED",
"ASARVAWALA AKHIL BHARAT TOURS & TRAVELS PRIVATE LIMITED",
"ASAS GLOBAL SERVICES PRIVATE LIMITED",
"ASAS INDUSTRIES PRIVATE LIMITED",
"ASATI RAJKUMAR ROLLER FLOUR MILLS PRIVATE LIMITED",
"ASATROBO TECHNOLOGIES PRIVATE LIMITED",
"ASATSU DK FORTUNE COMMUNICATIONS PRIVATE LIMITED",
"ASAVARI DIE AND MOULDS PRIVATE LIMITED",
"ASAWA INSULATION PRIVATE LIMITED",
"ASAWARA EARTHTECH PRIVATE LIMITED",
"ASAYA HOME STORE PRIVATE LIMITED",
"ASB AUTOMOBILES PRIVATE LIMITED",
"ASB INDUSTRIES PRIVATE LIMITED",
"ASB INFRASTRUCTURE PRIVATE LIMITED",
"ASB INTER COLLEGE",
"ASB INTERNATIONAL PRIVATE LIMITED",
"ASB LOGISTICS INDIA PRIVATE LIMITED",
"ASB MERCHANDISE PRIVATE LIMITED",
"ASB POLYMERS PRIVATE LIMITED",
"ASB PROJECTS LIMITED",
"ASB SYSTEMS PRIVATE. LIMITED",
"ASB TRADING AGENCY PRIVATE LIMITED",
"ASB WIRES AND CABLES PRIVATE LIMITED",
"ASBESCO INDIA PRIVATE LIMITED",
"ASBICON SOLUTIONS PRIVATE LIMITED",
"ASBOLUS GLOBAL PRIVATE LIMITED",
"ASBRI ENERGY & ENVIRO TECHNOLOGIES PRIVATE LIMITED",
"ASC BUILDERS PRIVATE. LIMITED.",
"ASC CONSULTING PRIVATE LIMITED",
"ASC FORGINGS PRIVATE LIMITED",
"ASC IMPEX PRIVATE LIMITED",
"ASC INDEPENDENT PU COLLEGE",
"ASC INFRASTRUCTURE PRIVATE LIMITED",
"ASC INFRATECH PRIVATE LIMITED",
"ASC OPERATIONS PRIVATE LIMITED",
"ASC OUTSOURCING PRIVATE LIMITED",
"ASC POWER PRIVATE. LIMITED.",
"ASC REALINFRA PRIVATE LIMITED",
"ASC RECORDS SOUTH BANGLORE",
"ASC TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"ASCA LOGISTICS PRIVATE LIMITED",
"ASCAN PLYBOARD INDIA PRIVATE LIMITED",
"ASCARD FRANCHISES PRIVATE",
"ASCC INFRA PRIVATE LIMITED",
"ASCELA ADVISORS PRIVATE LIMITED",
"ASCENA GLOBAL INNOVATION CENTER LLP",
"ASCEND AVIATION INDIA PRIVATE LIMITED",
"ASCEND BIZCAP PRIVATE LIMITED",
"ASCEND COWORKS PRIVATE LIMITED",
"ASCEND FLUID TOOLS PRIVATE LIMITED",
"ASCEND INTERNATIONAL SCHOOL",
"ASCEND MEDIA PRIVATE LIMITED",
"ASCEND TELECOM INFRASTRUCTURE PRIVATE LIMITED",
"ASCENDANCY FINANCIAL SERVICES PRIVATE LIMITED",
"ASCENDAS FIRSTSPACE DEVELOPMENT MANAGEMENT PRIVATE LIMITED",
"ASCENDAS INDIA PRIVATE LIMITED",
"ASCENDAS IT PARK (CHENNAI) LIMITED",
"ASCENDAS IT PARK (HADAPSAR) PRIVATE LIMITED",
"ASCENDAS IT PARK (PUNE) PRIVATE LIMITED",
"ASCENDAS MEDIA PRIVATE LIMITED",
"ASCENDAS PANVEL FTWZ PRIVATE LIMITED",
"ASCENDAS SERVICES INDIA PRIVATE LIMITED",
"ASCENDER INDIA PRIVATE LIMITED",
"ASCENDERS BUSINESS SOLUTIONS PRIVATE LIMITED",
"ASCENDEUM PRIVATE LIMITED",
"ASCENDION ENGINEERING PRIVATE LIMITED",
"ASCENDO PROJECTS PRIVATE LIMITED",
"ASCENDS PORTING CORPZ",
"ASCENDUM KPS PRIVATE LIMITED",
"ASCENDUM SOLUTIONS INDIA PRIVATE LIMITED",
"ASCENER FACTORY PRIVATE LIMITED",
"ASCENSIA DIABETES CARE INDIA PRIVATE LIMITED",
"ASCENSIVE DIGIPRINT SOLUTIONS PRIVATE LIMITED",
"ASCENSIVE EDUCARE LIMITED",
"ASCENSO ENVIRO PRIVATE LIMITED",
"ASCENSO TELECOM SOLUTIONS PRIVATE LIMITED",
"ASCENSOR TECHNOLOGIES PRIVATE LIMITED",
"ASCENSUS GLOBAL SERVICES INDIA LLP",
"ASCENT ACADEMY OF TRAINING & DEVELOPMENT PRIVATE LIMITED",
"ASCENT AGROCHEM PRIVATE LIMITED",
"ASCENT AIR PRIVATE. LIMITED.",
"ASCENT AUTO COMPONENTS PRIVATE LIMITED",
"ASCENT BPO SERVICES PRIVATE LIMITED",
"ASCENT BUILDHOME DEVELOPERS LIMITED",
"ASCENT BUILDTECH PRIVATE LIMITED",
"ASCENT BUSINESS SOLUTIONS",
"ASCENT BUSINESS SOLUTIONS INDIA PRIVATE LIMITED",
"ASCENT CAD SERVICES PRIVATE LIMITED",
"ASCENT CIRCUITS PRIVATE LIMITED",
"ASCENT CLEARFORM MOULDING PRIVATE LIMITED",
"ASCENT CONSTRUCTION PRIVATE LIMITED",
"ASCENT CONSTRUCTIONS PRIVATE LIMITED",
"ASCENT HR TECHNOLOGIES PRIVATE LIMITED",
"ASCENT DECOR PRIVATE LIMITED",
"ASCENT DESIGNS PRIVATE LIMITED",
"ASCENT E-DIGIT SOLUTIONS PRIVATE LIMITED",
"ASCENT ELECTRIFICATION ENGINEERS PRIVATE LIMITED",
"ASCENT ENGINEERS AND INFRASTRUCTURES INDIA PRIVATE LIMITED",
"ASCENT ENGITECH PRIVATE LIMITED",
"ASCENT EPC PRIVATE LIMITED",
"ASCENT FINANCIAL SOLUTIONS PRIVATE LIMITED",
"ASCENT FINCON PRIVATE LIMITED",
"ASCENT FINECHEM PRIVATE LIMITED",
"ASCENT GARMENTS PRIVATE LIMITED",
"ASCENT HEALTH & WELLNESS SOLUTIONS PRIVATE LIMITED",
"ASCENT HOTELS PRIVATE LIMITED",
"ASCENT HYDRO PROJECTS LIMITED",
"ASCENT INDIA FOUNDATION",
"ASCENT INFRASPACE PRIVATE LIMITED",
"ASCENT INNOVATIVE MEDICINES PRIVATE LIMITED",
"ASCENT INTELLIMATION PRIVATE LIMITED",
"ASCENT LASER TECHNOLOGIES PRIVATE LIMITED",
"ASCENT LIFE SCIENCES PRIVATE LIMITED",
"ASCENT LIFESTYLE PRIVATE LIMITED",
"ASCENT LIFTS & ESCALATORS PRIVATE LIMITED",
"ASCENT MARKETING PRIVATE.LIMITED",
"ASCENT MEDITECH LIMITED",
"ASCENT MULTI FORMS PVT LTD",
"ASCENT NETWORKS PRIVATE LIMITED",
"ASCENT PUBLIC SCHOOL",
"ASCENT RESILIENCE SOLUTIONS PRIVATE LIMITED",
"ASCENT SIGMAX SPORTSMEDS PRIVATE LIMITED",
"ASCENT SOURCING PRIVATE LIMITED",
"ASCENT STAFFING SOLUTIONS PRIVATE LIMITED",
"ASCENT STRUCTURAL ENGINEERS PRIVATE LIMITED",
"ASCENT SUPPLY CHAIN CONSULTANTS PRIVATE LIMITED",
"ASCENT TECHNOLOGIES PRIVATE LIMITED",
"ASCENT TECHNOSOFT INDIA PRIVATE LIMITED",
"ASCENT TOTAL SOLUTION PRIVATE LIMITED",
"ASCENT WELLNESS AND PHARMA SOLUTIONS PRIVATE LIMITED",
"ASCENT YARNS PRIVATE LIMITED",
"ASCENTECH AERO PRIVATE LIMITED",
"ASCENTECH ENGICON PRIVATE LIMITED",
"ASCENTECH ENGINEERING SOLUTIONS PRIVATE LIMITED",
"ASCENTECH INFORMATION TECHNOLOGY PRIVATE LIMITED",
"ASCENTIQ ENGINEERING SERVICES PRIVATE LIMITED",
"ASCENTIS INDIA PROJECTS PRIVATE LIMITED",
"ASCENTRA HEALTHCARE PRIVATE LIMITED",
"ASCENTREK BUILDING SOLUTIONS PRIVATE LIMITED",
"ASCENTRIK RESEARCH SERVICES",
"ASCENTSPARK SOFTWARE PRIVATE LIMITED",
"ASCENTX SOFTWARE DEVELOPMENT SERVICES PRIVATE LIMITED",
"ASCENWORK TECHNOLOGIES PRIVATE LIMITED",
"ASCETIC EXPORTS",
"ASCHER JEWELS PRIVATE LIMITED",
"ASCLEPIUS HOSPITALS AND HEALTH CARE PRIVATE. LIMITED.",
"ASCLEPIUS WELLNESS FOUNDATION",
"ASCLEPIUS WELLNESS PRIVATE LIMITED",
"ASCO GENERAL SUPPLIES FAR EAST LIMITED - HONG KONG",
"ASCO IMPEX PVT LTD",
"ASCO NUMATICS INDIA PRIVATE LIMITED",
"ASCO SWITCHGEARS PRIVATE LIMITED",
"ASCOM INFOTECH PRIVATE LIMITED",
"ASCOM LEASING & INVESTMENTS LIMITED",
"ASCON ASIA ENERGY PRIVATE LIMITED",
"ASCON INFRASTRUCTURE (INDIA) LIMITED",
"ASCON INFRATECH PRIVATE LIMITED",
"ASCON MEDICAL INSTRUMENTS PRIVATE LIMITED",
"ASCON POLYMET PRIVATE LIMITED",
"ASCON TRAVEL PRIVATE LIMITED",
"ASCORB TECHNOLOGIES PRIVATE LIMITED",
"ASCORP GLOBAL LIMITED",
"ASCOT DIGITAL PRIVATE LIMITED",
"ASCOT ESTATES MANESAR PRIVATE LIMITED",
"ASCOT HOTELS AND RESORTS PRIVATE LIMITED",
"ASCOT SOLAR PRIVATE LIMITED",
"ASCOTT BEVERLY PARK HOSPITALITY (INDIA) PRIVATE LIMITED",
"ASCOTT ELECTRICALS PRIVATE LIMITED",
"ASCOTT INTERNATIONAL MANAGEMENT INDIA PRIVATE LIMITED",
"ASD DIAMONDS PRIVATE LIMITED",
"ASD FOREX AND HOLIDAYS PRIVATE LIMITED",
"ASD GLOBAL INDIA PRIVATE LIMITED",
"ASD INFRATECH PRIVATE LIMITED",
"ASD RAJASTHANI FOODS PRIVATE LIMITED",
"ASDA-EXEM AUTO AIDS PRIVATE LIMITED",
"ASDINTECH SERVICES PRIVATE LIMITED",
"ASDIS DRINKS INDIA PRIVATE LIMITED",
"ASE AUTOMOTIVE SERVICES PRIVATE LIMITED",
"ASE CARGO PRIVATE LIMITED",
"ASE DATA SOLUTIONS PRIVATE LIMITED",
"ASE INSTRUMENTS AGENCY PRIVATE LIMITED",
"ASE PACK LAMINATES LIMITED",
"ASE SERVICES FIRE PRIVATE LIMITED",
"ASE STRUCTURE DESIGN PRIVATE LIMITED",
"ASEAN AGRITECHNOLOGIES INDIA PRIVATE LIMITED",
"ASEAN PLYWOODS PRIVATE LIMITED",
"ASEAR HEALTHCARE PRIVATE LIMITED",
"ASEAS ENERGY INFRA PRIVATE LIMITED",
"ASECSOLUTIONS PRIVATE LIMITED",
"ASEDA PAY CENTER SCHOOL TA DEESA DIST B K",
"ASEEM INFRASTRUCTURE FINANCE LIMITED",
"ASEEM TECHNOLOGIES PRIVATE LIMITED",
"ASEEMA SOFTNET TECHNOLOGIES PRIVATE LIMITED",
"ASEEN POWER PRIVATE LIMITED",
"ASEGO TECHNOLOGIES LLP",
"ASEL CONTAINER MOVERS PRIVATE LIMITED",
"ASENCE PHARMA PRIVATE LIMITED",
"ASENEXT INDIA PRIVATE LIMITED",
"ASENKA REALTY PRIVATE LIMITED",
"ASENSE INSIDE PRIVATE LIMITED",
"ASENTON TECHNOLOGIES PRIVATE LIMITED",
"ASEPTIC FRUIT PRODUCTS INDIA PRIVATE LIMITED",
"ASEPTIC TECHNOCRAFT PRIVATE LIMITED",
"ASEPTIC THERMOPROSYS PRIVATE LIMITED",
"ASERGIS TELECOM SERVICES PRIVATE LIMITED",
"ASERIES ENVIROTEK INDIA PRIVATE LIMITED",
"ASES SECURITY PRIVATE LIMITED",
"ASET INSTITUTE OF TECHNOLOGY",
"ASEURO TECHNOLOGIES PRIVATE LIMITED",
"ASF BUILDCON PRIVATE LIMITED",
"ASF FACILITY MANAGEMENT PRIVATE LIMITED",
"ASF INFOTECH PRIVATE LIMITED",
"ASF INFRASTRUCTURE PRIVATE LIMITED",
"ASF INSIGNIA SEZ PRIVATE LIMITED",
"ASFALTAR INFRASTRUCTURE PRIVATE LIMITED",
"ASFALTRADE PRIVATE LIMITED",
"ASG BIOCHEM PRIVATE LIMITED",
"ASG DEVELOPERS PRIVATE. LIMITED.",
"ASG ENERGY SOLUTIONS PRIVATE LIMITED",
"ASG EYE HOSPITALS",
"ASG HOSPITAL PRIVATE LIMITED",
"ASG INFRATECH PRIVATE LIMITED",
"ASG INNOVATIONS",
"ASG LEATHER PRIVATE LIMITED",
"ASG LOGISTIK PRIVATE LIMITED",
"ASG SECURITY INDIA PRIVATE LIMITED",
"ASG STEEL TEC PRIVATE LIMITED",
"ASG TECHNOLOGIES PRIVATE LIMITED",
"ASG TEXTILES PRIVATE LIMITED",
"ASG WAREHOUSING PRIVATE LIMITED",
"ASG WIN INDIA PRIVATE LIMITED",
"ASG WORLDWIDE PRIVATE LIMITED",
"ASGA UDYOG PRIVATE LIMITED",
"ASGAONKAR AGRO FARMERS PRODUCER COMPANY LIMITED",
"ASGHAR HUSAIN URDU HIGH SCHOOL KHOLAPUR",
"ASGM GLOBAL INFRASTRUCTURES PRIVATE LIMITED",
"ASGN APEX SYSTEMS BIG DATA INDIA PRIVATE LIMITED",
"ASH & ALAIN INDIA PRIVATE LIMITED",
"ASH AMAIRA RETAIL PRIVATE LIMITED",
"ASH INDUSTRIES PRIVATE LIMITED",
"ASH LOGISTICS AND TRADERS PRIVATE LIMITED",
"ASH SOFTWARE PRIVATE LIMITED",
"ASHA ALLWIN AGENCIES PRIVATE LIMITED",
"ASHA AUDIO & COMMUNICATION PRIVATE LIMITED",
"ASHA AUTOMINE PRIVATE LIMITED",
"ASHA AUTOMOBILES PRIVATE LIMITED",
"ASHA BUILDERS & DEVELOPERS PVT. LTD.",
"ASHA BUSINES SCENTRE PRIVATE LIMITED",
"ASHA CARGO MOVERS PRIVATE LIMITED",
"ASHA CATERERS PRIVATE LIMITED",
"ASHA CELLULOSE (INDIA) PRIVATE LIMITED",
"ASHA CLEARING AGENCY PRIVATE LIMITED",
"ASHA COLOURS PRIVATE LIMITED",
"ASHA CONCAST PRIVATE LIMITED",
"ASHA CORRUGATORS PRIVATE LIMITED",
"ASHA DEEP HOSPITALS PRIVATE LIMITED",
"ASHA DEO MEMORIAL SURGICAL AND MATERNITY HOSPITAL PRIVATE LIMITED",
"ASHA DIAMOND",
"ASHA DIAMONDS DESIGNS PRIVATE LIMITED",
"ASHA DYESTUFF INDUSTRIES PRIVATE LIMITED",
"ASHA ELECTRICALS (MADRAS) PRIVATE LIMITED",
"ASHA ENGINEERING CO",
"ASHA ENTERPRISES PRIVATE LIMITED",
"ASHA ENTRADE PVT LTD",
"ASHA EXTRUSIONS PRIVATE LIMITED",
"ASHA FERTILITY SOLUTIONS PRIVATE LIMITED",
"ASHA IMPACT ADVISORY SERVICES PRIVATE LIMITED",
"ASHA INDUSTRIES",
"ASHA INFRAPROJECTS & SERVICES PRIVATE LIMITED",
"ASHA INFRAZONE PRIVATE LIMITED",
"ASHA INSTITUTE OF MEDICAL SCIENCES & RESEARCH CENTRE PRIVATE LIMITED",
"ASHA ISPAT PVT LTD",
"ASHA KAMAL CREATIONS PRIVATE LIMITED",
"ASHA KING MULTILEVEL CAR PARKING SYSTEMS PRIVATE LIMITED",
"ASHA KIRAN HOSPITALS PRIVATE LIMITED",
"ASHA KIRAN TRADING PVT LTD",
"ASHA LEASING AND FINANCE PRIVATE LIMITED",
"ASHA LIFESCIENCES PRIVATE LIMITED",
"ASHA MAA JEWELLERS SAGAR PRIVATE LIMITED",
"ASHA MAHILA MILK PRODUCER COMPANY LIMITED",
"ASHA MEDICARE PRIVATE LIMITED",
"ASHA METALIKS PRIVATE LIMITED",
"ASHA MULTISPECIALITY HOSPITAL",
"ASHA NAND ROSHAN LAL PRIVATE LIMITED",
"ASHA PENN COLOR PRIVATE LIMITED",
"ASHA PUBLICITY PRIVATE LIMITED",
"ASHA RAM AND SONS PRIVATE LIMITED",
"ASHA RAM COLLEGE OF NURSING",
"ASHA REAL ESTATES & DEVELOPERS PVT LTD",
"ASHA REALTY DEVELOPERS PRIVATE LIMITED",
"ASHA RESINS P.LTD.",
"ASHA RICE MILL PRIVATE LIMITED",
"ASHA TEA COMPANY PVT LTD",
"ASHA TILAK VENTURES PRIVATE LIMITED",
"ASHA TRAEXIM PRIVATE LIMITED",
"ASHA UNDERWATER SERVICES PRIVATE LIMITED",
"ASHA VENTURES PRIVATE LIMITED",
"ASHADEEP AQUACULTURE PVT LTD",
"ASHADEEP CONSTRUCTION PRIVATE LIMITED",
"ASHADEEP INTERNATIONAL SCHOOL",
"ASHADEEP VIDYALAYA",
"ASHAHI CHEMICAL INDUSTRIES PRIVATE LIMITED",
"ASHAJYOT MERCANTILE PRIVATE LIMITED",
"ASHAJYOTI MARKETING PRIVATE LIMITED",
"ASHAMANI POLLY PRODUCTS PRIVATE LIMITED",
"ASHANA EXIM PRIVATE LIMITED",
"ASHANAND IT SOLUTIONS PRIVATE LIMITED",
"ASHANI PRODUCTS PRIVATE LIMITED",
"ASHAPURA AGROCOMM PRIVATE LIMITED",
"ASHAPURA ARCADIA LOGISTIC PRIVATE LIMITED",
"ASHAPURA AROMAS PRIVATE LIMITED",
"ASHAPURA BUILDCON LIMITED",
"ASHAPURA CLAYTECH LIMITED",
"ASHAPURA DEVELOPERS PRIVATE LIMITED",
"ASHAPURA FORWARDERS P LIMITED",
"ASHAPURA GREEN POWER PRIVATE LIMITED",
"ASHAPURA INFRATECH PRIVATE LIMITED",
"ASHAPURA INTERNATIONAL LIMITED",
"ASHAPURA MARINETECH INTERNATIONAL",
"ASHAPURA MARITIME PRIVATE LIMITED",
"ASHAPURA MINECHEM LTD",
"ASHAPURA MONEY CHANGER PRIVATE LIMITED",
"ASHAPURA OPTIONS PRIVATE LIMITED",
"ASHAPURA OVERSEAS PRIVATE LIMITED",
"ASHAPURA PERFOCLAY LIMITED",
"ASHAPURA PETROCHEM MARKETING PRIVATE LIMITED",
"ASHAPURA PROTEINS LIMITED",
"ASHAPURA SHIPPING LIMITED",
"ASHAPURA SOFTECH",
"ASHAPURA SOFTECH PRIVATE LIMITED",
"ASHAPURA TRADECOM PRIVATE LIMITED",
"ASHAPURA WAREHOUSING PRIVATE LIMITED",
"ASHAPURI EXIM PRIVATE LIMITED",
"ASHAPURI FABRICS PRIVATE LIMITED",
"ASHAPURI GOLD ORNAMENT LIMITED",
"ASHAPURI INFRACON PRIVATE LIMITED",
"ASHAPURNA BUILDCON LIMITED",
"ASHAR EXPORTS PRIVATE LIMITED",
"ASHAR LOCKER INDIA PRIVATE LIMITED",
"ASHAR LOCKEYS PRIVATE LIMITED",
"ASHAR REALTY PRIVATE LIMITED",
"ASHAR VENTURES",
"ASHARAJ AGRI PRODUCTS PRIVATE LIMITED",
"ASHARAM TEXOLIN PVT LTD",
"ASHARBHI INFRAESTATE PRIVATE LIMITED",
"ASHARI AGENCIES LIMITED",
"ASHAUTTAM FOOD PRIVATE LIMITED",
"ASHAVARI TRADING PRIVATE LIMITED",
"ASHAY HOSPITAL & HEALTH CARE PRIVATE LIMITED",
"ASHBA BOTANICALS PRIVATE LIMITED",
"ASHBEE SYSTEMS LIMITED",
"ASHBEE SYSTEMS PRIVATE LIMITED",
"ASHBEL POLYMERS PRIVATE LIMITED",
"ASHBEN SOURCING AND LOGISTICS PRIVATE LIMITED",
"ASHBOND ENGINEERS PRIVATE LIMITED",
"ASHCON LOGISTICS INDIA PRIVATE LIMITED",
"ASHCON PROJECTS PRIVATE LIMITED",
"ASHCROFT INDIA PRIVATE LIMITED",
"ASHDAN DEVELOPERS PRIVATE LIMITED",
"ASHDAN HOTEL MANAGEMENT PRIVATE LIMITED",
"ASHDAN TOWNSHIP VENTURES PRIVATE LIMITED",
"ASHE CONTROLS PRIVATE LIMITED",
"ASHE MARCOM PRIVATE LIMITED",
"ASHED PROPERTIES AND INVESTMENTS PRIVATE LIMITED",
"ASHFORD CONSTRUCTIONS PRIVATE LIMITED",
"ASHFORD INFOTECH PRIVATE LIMITED",
"ASHGRAPH TECHNOLOGIES PRIVATE LIMITED",
"ASHI CREATION PRIVATE LIMITED",
"ASHI DIAMONDS INDIA PRIVATE LIMITED",
"ASHI HARDWARE PRIVATE LIMITED",
"ASHI IT SOLUTION PRIVATE LIMITED",
"ASHI JEWELLERY PRIVATE LIMITED",
"ASHI LTD",
"ASHI TEXFAB PRIVATE LIMITED",
"ASHIAN OILS PRIVATE LIMITED",
"ASHIANA APPARELS PRIVATE LIMITED",
"ASHIANA AUTOMOBILES PRIVATE LIMITED",
"ASHIANA CLOTHINGS PRIVATE LIMITED",
"ASHIANA CREATORS PRIVATE LIMITED",
"ASHIANA DWELLINGS PRIVATE LIMITED",
"ASHIANA EXPORTS PRIVATE LIMITED",
"ASHIANA FABICON PRIVATE LIMITED",
"ASHIANA GOODS PRIVATE LIMITED",
"ASHIANA HERITAGE HOTELS PRIVATE LIMITED",
"ASHIANA HOUSING LIMITED",
"ASHIANA ISPAT LIMITED",
"ASHIANA LANDCRAFT REALTY PRIVATE LIMITED",
"ASHIANA LOGISTICS PRIVATE LIMITED",
"ASHIANA MAINTENANCE SERVICES LIMITED",
"ASHIANA MAINTENANCE SERVICES LLP",
"ASHIANA MANUFACTURING INDIA LIMITED.",
"ASHIANA MOTORS PRIVATE LIMITED",
"ASHIANA REALTY LLP",
"ASHIDA ELECTRONICS PRIVATE LIMITED",
"ASHIELD TECHNOLOGIES PRIVATE LIMITED",
"ASHIKA CAPITAL LIMITED",
"ASHIKA COMMODITIES AND DERIVATIVES PRIVATE LIMITED",
"ASHIKA CREDIT CAPITAL LIMITED",
"ASHIKA FINTRADE PVT LTD",
"ASHIKA GLOBAL SECURITIES PRIVATE LIMITED",
"ASHIKA INCENSE INC",
"ASHIKA STOCK BROKING LIMITED",
"ASHIM KAR & INDUSTRIES PRIVATE LIMITED",
"ASHIMA ELECTROTECH PRIVATE LIMITED",
"ASHIMA LEENA DESIGN PRIVATE LIMITED",
"ASHIMA SERVICES & ENT PRIVATE LIMITED",
"ASHIMARA HOUSING PRIVATE LIMITED",
"ASHIMORI INDIA PRIVATE LIMITED",
"ASHIND INDUSTRIES PRIVATE LIMITED",
"ASHINE GROUP PRIVATE LIMITED",
"ASHIQUE EXPORTS PRIVATE LIMITED",
"ASHIR JEWELS PRIVATE LIMITED",
"ASHIRBAD AGRO PRODUCTS PRIVATE LIMITED",
"ASHIRBAD EARTH MOVERS PRIVATE LIMITED",
"ASHIRBAD FOOD PROCESSING PRIVATE LIMITED",
"ASHIRBAD HOUSE KEEPING SERVICES PRIVATE LIMITED",
"ASHIRBAD INFRASTRUCTURE SERVICES AND FACILITIES MANAGEMENT PRIVATE LIMITED",
"ASHIRBAD INTCON PRIVATE LIMITED",
"ASHIRBAD PRAKASHAN PRIVATE LIMITED",
"ASHIRBAD REAL ESTATE & TRANSPORT PVT LTD",
"ASHIRVAD FOOD PRODUCTS PRIVATE LIMITED",
"ASHIRVAD PIPES PRIVATE LIMITED",
"ASHIRVAD POLYSAC PRIVATE LIMITED",
"ASHIRVAD SEEDS PRIVATE LIMITED",
"ASHIRWAD CARBONICS (INDIA) PRIVATE LIMITED",
"ASHIRWAD CERAMICS PRIVATE LIMITED",
"ASHIRWAD CINEVISION PRIVATE LIMITED",
"ASHIRWAD COLD STORAGE PRIVATE LIMITED",
"ASHIRWAD ENGICON PRIVATE LIMITED",
"ASHIRWAD EXIM PRIVATE LIMITED",
"ASHIRWAD FACILITIES INDIA PRIVATE LIMITED",
"ASHIRWAD FOUNDRIES PVT LTD",
"ASHIRWAD HEALTH SERVICES PRIVATE LIMITED",
"ASHIRWAD INNOVATIVE COATINGS PRIVATE LIMITED",
"ASHIRWAD IRON AND POWER PRIVATE LIMITED",
"ASHIRWAD ISPAT (RYP) PRIVATE LIMITED",
"ASHIRWAD MATERNITY AND SURGICAL CENTRE PRIVATE LIMITED",
"ASHIRWAD MEGA MART PRIVATE LIMITED",
"ASHIRWAD MISAL HOUSE",
"ASHIRWAD MULTIMEDIA PRIVATE LIMITED",
"ASHIRWAD NURSING HOME",
"ASHIRWAD OILS PRIVATE LIMITED.",
"ASHIRWAD PROCON PRIVATE LIMITED",
"ASHIRWAD PROMOTERS PRIVATE LIMITED.",
"ASHIRWAD RESORTS PVT. LTD.",
"ASHIRWAD ROOFING SOLUTION PRIVATE LIMITED",
"ASHIRWAD SHIPPPING & LOGISTICS PRIVATE LIMITED",
"ASHIRWAD SKY HEIGHTS TOWERS PRIVATE LIMITED",
"ASHIRWAD SMART INFRALINK PRIVATE LIMITED",
"ASHIRWAD STEELS & INDUSTRIES LTD",
"ASHIRWAD STRIPS PRIVATE LIMITED",
"ASHIRWAD TELENETWORK PRIVATE LIMITED",
"ASHIRWAD TOWNSHIP PRIVATE LIMITED",
"ASHIS LIVING PRIVATE LIMITED",
"ASHISA CONSULTING PRIVATE LIMITED",
"ASHISH AGRI FOODS PRIVATE LIMITED",
"ASHISH AGRO-PLAST PVT LTD",
"ASHISH ALLOY CASTINGS PRIVATE LIMITED",
"ASHISH AUTOMOTIVES PRIVATE LIMITED",
"ASHISH BAGS AND FASHIONS PRIVATE LIMITED",
"ASHISH BOOKS PRIVATE LIMITED",
"ASHISH BRASS COMPONENTS PRIVATE LIMITED",
"ASHISH BRIDGECON PRIVATE LIMITED",
"ASHISH CABLES PRIVATE LIMITED",
"ASHISH CANS AND CONTAINERS PRIVATE LIMITED",
"ASHISH CHEMICALS",
"ASHISH DEEP AUTO DISTRIBUTORS PRIVATE LIMITED",
"ASHISH ENTERPRISES",
"ASHISH ESTATES AND PROPERTIES PVT LTD",
"ASHISH EXPORTS",
"ASHISH FERRO-MET PRIVATE LIMITED",
"ASHISH FOILS PRIVATE LIMITED",
"ASHISH FREIGHT CARRIERS PRIVATE LIMITED",
"ASHISH FURNITURE PRIVATE LIMITED",
"ASHISH HOSPITAL",
"ASHISH HR SOLUTIONS PRIVATE LIMITED",
"ASHISH INFOCOM PVT. LTD",
"ASHISH INFRACON PRIVATE LIMITED",
"ASHISH INFRATECH PRIVATE LIMITED",
"ASHISH INTERBUILD PRIVATE LIMITED",
"ASHISH INTERCHEM PRIVATE LIMITED",
"ASHISH ISPAT PRIVATE LIMITED",
"ASHISH JINDAL BUILDERS PRIVATE LIMITED",
"ASHISH JOINT REPLACEMENT CARE PRIVATE LIMITED",
"ASHISH LAND & PROPERTY DEVELOPERS PRIVATE LIMITED",
"ASHISH LIFE SCIENCE PRIVATE LIMITED",
"ASHISH MANUFACTURING COMPANY PRIVATE LIMITED",
"ASHISH MOTOR CYCLES PRIVATE LIMITED",
"ASHISH NX",
"ASHISH PAPERS PRIVATE LIMITED",
"ASHISH PIGMENTS AND ALLOYS PRIVATE LIMITED",
"ASHISH POLYPLAST LIMITED",
"ASHISH PROTEINS & FOOD PRIVATE LIMITED",
"ASHISH PUMPS PRIVATE LIMITED",
"ASHISH RAILS PRIVATE LIMITED",
"ASHISH RENT-A-CAR PRIVATE LIMITED",
"ASHISH SEALS INDIA PRIVATE LIMITED",
"ASHISH SHIP BREAKERS PRIVATE LIMITED",
"ASHISH STEEL",
"ASHISH TECHNICAL SERVICES PVT LTD",
"ASHISH TECHNOCRAT PRIVATE LIMITED",
"ASHISH THEATRES AND PROPERTIES PRIVATE LIMITED",
"ASHISH TIMBER PRIVATE LIMITED",
"ASHISH TRADERS",
"ASHISH TRADING COMPANY PRIVATE LIMITED",
"ASHISH TRANSLINK PRIVATE LIMITED",
"ASHISH VESSEL DEMOLITION PRIVATE LIMITED",
"ASHISH WATER PROOFING INDIA PRIVATE LIMITED",
"ASHIT PACKAGING PRIVATE LIMITED",
"ASHIT SALES PRIVATE LIMITED",
"ASHITA BUSINESS SOLUTIONS PRIVATE LIMITED",
"ASHITA ENTERPRISES PRIVATE LIMITED",
"ASHITECH EQUIPMENTS PRIVATE LIMITED",
"ASHITO HEALTHCARE PRIVATE LIMITED",
"ASHIVA FOREX PRIVATE LIMITED",
"ASHIVSHETKARI AGRO PRODUCER COMPANY LIMITED",
"ASHIYANA CHEMICALS PRIVATE LIMITED",
"ASHIYANA DREAM HOMES PRIVATE LIMITED",
"ASHIYANA INFRADEVELOPERS PRIVATE LIMITED",
"ASHIYANA REALCON PRIVATE LIMITED",
"ASHKA EXIM PRIVATE LIMITED",
"ASHKA PRECEM PRIVATE LIMITED",
"ASHKEM ENTERPRISES (INDIA) PRIVATE LIMITED",
"ASHKOM MEDIA INDIA PRIVATE LIMITED",
"ASHLAND INC.",
"ASHLAND INDIA PRIVATE LIMITED",
"ASHLAR BUILDING SOLUTIONS INDIA PRIVATE LIMITED",
"ASHLAR COMMODITIES PRIVATE LIMITED",
"ASHLAR EDUCATION CONSULTANTS PRIVATE LIMITED",
"ASHLAR SECURITIES PRIVATE LIMITED",
"ASHLESH BRIGHT BARS PRIVATE LIMITED",
"ASHLESHA CORPORATION LIMITED",
"ASHLESHA POWER CONTROLS PRIVATE LIMITED",
"ASHLEY ALTEAMS INDIA LIMITED",
"ASHLEY AVIATION LIMITED",
"ASHLEY F AND S ENGINEERING PRIVATE LIMITED",
"ASHLEY MARKETELLIGENT PRIVATE LIMITED",
"ASHLEY PHARMATECH PRIVATE LIMITED",
"ASHLIN TRAVELS PRIVATE LIMITED",
"ASHLIYA CONSULTANTS PRIVATE LIMITED",
"ASHLOK SAFE EARTHING ELECTRODE LIMITED",
"ASHLYN CHEMUNNOOR INSTRUMENTS PRIVATE LIMITED",
"ASHMA MARITIME SERVICES PRIVATE LIMITED",
"ASHMAR TECHNOLOGIES & RESEARCH PRIVATE LIMITED.",
"ASHMAVIR FINANCIAL CONSULTANTS PRIVATE LIMITED",
"ASHMEC EQUIPMENTS PRIVATE LIMITED",
"ASHMI LOGISTICS",
"ASHMI ROAD CARRIERS PRIVATE LIMITED",
"ASHMIN CARGO SERVICES PRIVATE LIMITED",
"ASHMIT CORPORATION PRIVATE LIMITED",
"ASHMIT HATCHERIES AND FEEDS PRIVATE LIMITED",
"ASHMITA BOUTIQUE PRIVATE LIMITED",
"ASHMOR ELECTRICALS (INDIA) PRIVATE LIMITED",
"ASHNA INTERIORS PRIVATE LIMITED",
"ASHNI LOGISTICS PRIVATE LIMITED",
"ASHNISHA INDUSTRIES LIMITED",
"ASHNOOR TEXTILE MILLS LIMITED.",
"ASHOCA WELLNESS PRIVATE LIMITED",
"ASHOK & CO. NIVAS PRIVATE LIMITED",
"ASHOK AGENCY",
"ASHOK AGRO INPUTS PVT LTD",
"ASHOK ALANKAR PRIVATE LIMITED",
"ASHOK AND COMPANY PAN BAHAR LIMITED",
"ASHOK AND COMPANY PAN BAHAR PRIVATE LIMITED",
"ASHOK AUTO EXCEL PRIVATE LIMITED",
"ASHOK AUTO SALES LIMITED",
"ASHOK AUTOTECH INDIA PRIVATE LIMITED",
"ASHOK BHANAWAT MARBLES PRIVATE LIMITED",
"ASHOK CARDBOARD AND CONTAINERS PRIVATE LIMITED",
"ASHOK CHANDRA RAKHIT PVT LTD",
"ASHOK CHAUHAN CONSTRUCTIONS PRIVATE LIMITED",
"ASHOK COMPOSITE PU COLLEGE",
"ASHOK DESIGN BUILD PRIVATE LIMITED",
"ASHOK DIAMJEWEL PRIVATE LIMITED",
"ASHOK DYESTUFF PRIVATE LIMITED",
"ASHOK ENGINEERING AND FOUNDRY WORKS",
"ASHOK ETRAVEL WORLD PRIVATE LIMITED",
"ASHOK FINE FAB PRIVATE LIMITED",
"ASHOK FOREX PRIVATE LIMITED",
"ASHOK FREIGHT CARRIERS PRIVATE LIMITED",
"ASHOK GNXT PHARMA PRIVATE LIMITED",
"ASHOK GRANITES LIMITED",
"ASHOK GROUP OF HOTELS",
"ASHOK GUPTA & CO",
"ASHOK GUPTA MARKETING PRIVATE LIMITED",
"ASHOK HANDLOOMS FACTORY PRIVATE LIMITED",
"ASHOK HIGH SCHOOL",
"ASHOK HOSPITAL NEURO & TRAUMA CENTER",
"ASHOK INDUSTRIAL AGENCIES PRIVATE LIMITED",
"ASHOK INFRAPROPERTIES PRIVATE LIMITED",
"ASHOK INVESTMENT CORPORATION LTD.",
"ASHOK INVESTORS TRUST LIMITED.",
"ASHOK IRON AND STEEL FABRICATORS PRIVATE LIMITED",
"ASHOK IRON WORKS PRIVATE LIMITED",
"ASHOK JAIN SHAWL EMPORIUM PRIVATE LIMITED",
"ASHOK JEWELLERS PRIVATE LIMITED",
"ASHOK JEWELS PRIVATE LIMITED",
"ASHOK KANYA VID UMRER",
"ASHOK KUMAR AND CO MERCANTILE PRIVATE LIMITED",
"ASHOK KUMAR ASHISH KUMAR GOLD PRIVATE LIMITED",
"ASHOK KUMAR CHHABRA CONSTRUCTIONS PRIVATE LIMITED",
"ASHOK LABORATORY CLINICAL TESTING CENTRE PRIVATE LIMITED",
"ASHOK LEYLAND DEFENCE SYSTEMS LIMITED",
"ASHOK LEYLAND LIMITED",
"ASHOK LEYLAND NISSAN VEHICLES LIMITED",
"ASHOK LEYLAND WIND ENERGY LIMITED",
"ASHOK MATCHES AND TIMBER INDUSTRIES PRIVATE LIMITED",
"ASHOK MILK PROCESSING AND ALLIED INDUSTRIES LIMITED",
"ASHOK NAGARI SAHAKARI BANK LTD",
"ASHOK NANDAVANAM PROPERTIES PRIVATE LIMITED",
"ASHOK NEEL MANUFACTURERS PRIVATE LIMITED",
"ASHOK NURSING HOME & HEALTHCARE PRIVATE LIMITED",
"ASHOK PACK-TECH PRIVATE LIMITED",
"ASHOK PANJLA STEEL PRODUCTS PRIVATE LIMITED",
"ASHOK PUNCH ARTS PRIVATE LIMITED",
"ASHOK PURI AND SONS (INDIA) PRIVATE LIMITED",
"ASHOK RICE MILLS PRIVATE LIMITED",
"ASHOK ROAD AND INFRA EQUIPMENTS (INDIA) PRIVATE LIMITED",
"ASHOK ROAD EQUIPMENTS MANUFACTURES (INDIA) PRIVATE LIMITED",
"ASHOK SALES COMPANY PRIVATE LIMITED",
"ASHOK SHARMA & ASSOCIATES PRIVATE LIMITED",
"ASHOK SHESHERAO DHUMAL",
"ASHOK SILK MILLS PRIVATE LIMITED",
"ASHOK STEEL CRAFT PRIVATE LIMITED",
"ASHOK STOVE PRIVATE LIMITED",
"ASHOK TEA COMPANY PRIVATE LIMITED",
"ASHOK TIMBER TRADING CO.",
"ASHOK UDYOG PRIVATE LIMITED",
"ASHOK V AJMERA & COMPANY",
"ASHOKA ANKLESHWAR MANUBAR EXPRESSWAY PRIVATE LIMITED",
"ASHOKA AURIGA TECHNOLOGIES PRIVATE LIMITED",
"ASHOKA AUTOMOBILLES SERVICES",
"ASHOKA BAGEWADI SAUNDATTI ROAD LIMITED",
"ASHOKA BANWARA BETTADAHALLI ROAD PRIVATE LIMITED",
"ASHOKA BATTERIES PRIVATE LIMITED",
"ASHOKA BEADS CORPORATION PRIVATE LIMITED",
"ASHOKA BEARING HOUSING PRIVATE LIMITED",
"ASHOKA BELGAUM DHARWAD TOLLWAY LIMITED",
"ASHOKA BELGAUM KHANAPUR ROAD PRIVATE LIMITED",
"ASHOKA BETTADAHALLI SHIVAMOGGA ROAD PRIVATE LIMITED",
"ASHOKA BROTHERS SANITATION INDIA PRIVATE LIMITED",
"ASHOKA BUILDCON LIMITED",
"ASHOKA BUILDERS (NASIK) PRIVATE LIMITED",
"ASHOKA BUILDERS INDIA PRIVATE LIMITED",
"ASHOKA CABLES PRIVATE LIMITED",
"ASHOKA CATTLE AND POULTRY FEEDS PRIVATE LIMITED",
"ASHOKA CONCESSIONS LIMITED",
"ASHOKA CREATIONS LIMITED",
"ASHOKA DEVELOPERS & BUILDERS LIMITED",
"ASHOKA DHANKUNI KHARAGPUR TOLLWAY LIMITED",
"ASHOKA DISTILLERS & CHEMICALS PRIVATE LIMITED",
"ASHOKA DRESSES PRIVATE LIMITED",
"ASHOKA DYEING AND PRINTING MILLS PRIVATE LIMITED",
"ASHOKA ENGINEERS (INDIA) PRIVATE LIMITED",
"ASHOKA ENTERPRISES",
"ASHOKA EQUIPMENTS PRIVATE LIMITED",
"ASHOKA FOAM MULTI PLAST LIMITED",
"ASHOKA FOAM PRIVATE LIMITED",
"ASHOKA FOODS AND DEHYDRATES PRIVATE LIMITED",
"ASHOKA FOUNDRY AND EQUIPMENT PRIVATE LIMITED",
"ASHOKA FURNISHINGS PRIVATE LIMITED",
"ASHOKA FURNITURE PVT LTD",
"ASHOKA HAWAI & SHOES PRIVATE LIMITED",
"ASHOKA HIGHTEC PRIVATE LIMITED",
"ASHOKA HIGHWAYS (BHANDARA) LIMITED",
"ASHOKA HIGHWAYS DURG LIMITED",
"ASHOKA HOSIERY PRIVATE LIMITED",
"ASHOKA HUNGUND TALIKOT ROAD LIMITED",
"ASHOKA INDUSTRIES LIMITED",
"ASHOKA INFRACORE PRIVATE LIMITED",
"ASHOKA INFRAWAYS LIMITED",
"ASHOKA INSTITUTE OF ENGINEERING AND TECHNOLOGY",
"ASHOKA KANDI RAMSANPALLE ROAD PRIVATE LIMITED",
"ASHOKA KARADI BANWARA ROAD PRIVATE LIMITED",
"ASHOKA KHAIRATUNDA BARWA ADDA ROAD LIMITED",
"ASHOKA KHARAR LUDHIANA ROAD LIMITED",
"ASHOKA KRISHI UDYOG PRIVATE LIMITED",
"ASHOKA MALLASANDRA KARADI ROAD PRIVATE LIMITED",
"ASHOKA MANUFACTURING PRIVATE LIMITED",
"ASHOKA METAL & POWER LIMITED",
"ASHOKA METCAST LIMITED",
"ASHOKA MOTORS INDIA PRIVATE LIMITED",
"ASHOKA MUDHOL NIPANI ROADS LIMITED",
"ASHOKA NON WOVEN PRIVATE LIMITED",
"ASHOKA P.U. FOAM (INDIA) PRIVATE LIMITED",
"ASHOKA PIGMENTS PRIVATE LIMITED",
"ASHOKA POLY LAMINATORS LIMITED",
"ASHOKA POLYMERS PRIVATE LIMITED",
"ASHOKA PRE-CON PRIVATE LIMITED",
"ASHOKA PRODUCTS PRIVATE LIMITED",
"ASHOKA PULP & PAPER PRIVATE LIMITED",
"ASHOKA PURESTUDY TECHNOLOGIES PRIVATE LIMITED",
"ASHOKA RANASTALAM ANANDAPURAM ROAD LIMITED",
"ASHOKA REFINERIES LIMITED",
"ASHOKA REHAB PRIVATE LIMITED",
"ASHOKA RESCUE AIR AMBULANCE SERVICES PRIVATE LIMITED",
"ASHOKA SAMBALPUR BARAGARH TOLLWAY LIMITED",
"ASHOKA SCRAP TRADERS PRIVATE LIMITED",
"ASHOKA SELECTIONS PRIVATE LIMITED",
"ASHOKA SERVICES",
"ASHOKA SMOKELESS COAL INDUSTRIES PRIVATE LIMITED",
"ASHOKA SPANNERS PRIVATE LIMITED",
"ASHOKA STHAPATYA PRIVATE LIMITED",
"ASHOKA SWITCHGEAR PRIVATE LIMITED",
"ASHOKA TINCANS PRIVATE LIMITED",
"ASHOKA TOOLS PVT LTD",
"ASHOKA TRANSWAYS SERVICE PRIVATE LIMITED",
"ASHOKA TRUST FOR RESEARCH IN ECOLOGY AND THE ENVIRONMENT",
"ASHOKA UNIVERSAL ACADEMY PRIVATE LIMITED",
"ASHOKA UNIVERSAL SCHOOL",
"ASHOKA UNIVERSITY",
"ASHOKA VINIYOGA LTD",
"ASHOKA WEAVING PRIVATE LIMITED",
"ASHOKA WHEAT PRODUCTS PRIVATE LIMITED",
"ASHOKA WOMEN'S ENGINEERING COLLEGE",
"ASHOKA WORLDWIDE PRIVATE LIMITED",
"ASHOKADREAM AUTO PRIVATE LIMITED",
"ASHOKA-DSC KATNI BYPASS ROAD LIMITED",
"ASHOKA'S DUMMY ART (INDIA) PRIVATE LIMITED",
"ASHOKAS RETAIL PRIVATE LIMITED",
"ASHOKASHA EXIM",
"ASHOKJI CONSUMER CARE PRIVATE LIMITED",
"ASHOKKUMAR PROJECTS INDIA PRIVATE LIMITED",
"ASHOKRAO MANE INSTITUTE OF PHARMACEUTICAL SCIENCE AND RESEARCH",
"ASHONUJ CHEM PRIVATE LIMITED",
"ASHOO DECORE INDIA",
"ASHORE SYSTEMS PRIVATE LIMITED",
"ASHPRA INFRA ENGINEERS PRIVATE LIMITED",
"ASHPRA SKILLS PRIVATE LIMITED",
"ASHPRA TEXTILES PRIVATE LIMITED",
"ASHPRO LOGISTICS PRIVATE LIMITED",
"ASHRA CONSULTANTS PRIVATE LIMITED",
"ASHRAE CLEAN ROOM PRESENTATIONS PRIVATE LIMITED",
"ASHRAF COMPUTERS AND JEWELLERY PRIVATE LIMITED",
"ASHRAF MEMORIAL HOSPITAL PRIVATE LIMITED",
"ASHRAJ DEVELOPERS PRIVATE LIMITED",
"ASHRAM COMPUTER CONSULTANCY SERVICES PRIVATE LIMITED",
"ASHRAM PUBLIC SCHOOL",
"ASHRAM SHALA",
"ASHRAM STEELS PRIVATE LIMITED",
"ASHRAY HOMES BUILDWELL PRIVATE LIMITED",
"ASHRAY INN PRIVATE LIMITED",
"ASHRAY PREMISES PRIVATE LIMITED",
"ASHRAYA ENGINEERS & DEVELOPERS PRIVATE LIMITED",
"ASHRAYA HASTHA TRUST",
"ASHREYAKIRAN IT SOLUTIONS PRIVATE LIMITED",
"ASHREYA'S POULTRY FARM PRIVATE LIMITED",
"ASHRI MEDICO SURGICALS PRIVATE LIMITED",
"ASHRI MENTHOL PRIVATE LIMITED",
"ASHRI NATURALS PRIVATE LIMITED",
"ASHRIT HOLDINGS LIMITED",
"ASHRITA TRADING AGENCY PVT LTD",
"ASHRITHA HEALTH CARE PRIVATE LIMITED",
"ASHRIYA INFOTECH PRIVATE LIMITED",
"ASHRO TEXTILES PRIVATE LIMITED",
"ASHTA LAKSHMI RICE INDUSTRY",
"ASHTA LINERS PRIVATE LIMITED",
"ASHTA VINAYAK REALTY PRIVATE LIMITED",
"ASHTAMURTI ENTERPRISES PRIVATE LIMITED",
"ASHTAPATHY HEALTH CARE PRIVATE LIMITED",
"ASHTAVAIDYAN THAIKKATTU MOOSS VAIDYARATNAM OUSHADHALAYAM PRIVATE LIMITED",
"ASHTAVAKRA AUTO PRIVATE LIMITED",
"ASHTAVINAYAK CRITICARE PRIVATE LIMITED",
"ASHTAVINAYAK DAIRY MILK PRIVATE LIMITED",
"ASHTAVINAYAK DEVELOPERS & HOSPITALITY PRIVATE LIMITED",
"ASHTAVINAYAK LOGISTICS",
"ASHTAVINAYAK NURSING HOME PRIVATE LIMITED",
"ASHTAVINAYAK PARTICLE BOARDS PRIVATE LIMITED",
"ASHTAVINAYAKA ENERGY - INFRA PRIVATE LIMITED",
"ASHTAVINAYAKA TECHNOCRAFTS PRIVATE LIMITED",
"ASHTBHUJ OCEAN MOVERS PRIVATE LIMITED",
"ASHTBIT TECHNOLOGIES PRIVATE LIMITED",
"ASHTE LOGISTICS PRIVATE LIMITED",
"ASHTECH INDIA PRIVATE LIMITED",
"ASHTECH INDUSTRIES PRIVATE LIMITED",
"ASHTECH INFOTECH (INDIA) PRIVATE LIMITED",
"ASHTECH TOOLINGS AND STAMPINGS PRIVATE LIMITED",
"ASHTEKAR CONSTRUCTIONS",
"ASHTEKAR PROPERTIES PRIVATE LIMITED",
"ASHTHAVINAYAK NAILS & WIRES PRIVATE LIMITED",
"ASHTI SUGAR LIMITED",
"ASHTIN INDIA PRIVATE LIMITED",
"ASHTMANGAL OILS MARKETING PRIVATE LIMITED",
"ASHTON INTERNATIONAL PRIVATE LIMITED",
"ASHTON PAPER MILL PRIVATE LIMITED",
"ASHTSIDDHI INGREDIENTS PRIVATE LIMITED",
"ASHTVINAYAK ADVISORY SERVICES PRIVATE LIMITED",
"ASHTVINAYAK BULLIONS & JEWELLERS PRIVATE LIMITED",
"ASHTVINAYAK HOSPITALS PRIVATE LIMITED",
"ASHTVINAYAK LEISURE PRIVATE LIMITED",
"ASHTVINAYAK METALS PRIVATE LIMITED",
"ASHU FOREX PRIVATE LIMITED",
"ASHU INFRACREATION PRIVATE LIMITED",
"ASHU ORGANICS INDIA PRIVATE LIMITED",
"ASHU SPINNING MILLS PRIVATE LIMITED",
"ASHUOM ENTERPRISE PRIVATE LIMITED",
"ASHUTEC SOLUTIONS PRIVATE LIMITED",
"ASHUTOR ENTERPRISES PRIVATE LIMITED",
"ASHUTOSH AUTOMOBILES",
"ASHUTOSH COKE PRIVATE LIMITED",
"ASHUTOSH CONTAINER SERVICES PRIVATE LIMITED",
"ASHUTOSH ENTERPRISES",
"ASHUTOSH FABTEX PRIVATE LIMITED",
"ASHUTOSH FIBRE PRIVATE LIMITED",
"ASHUTOSH FINANCIAL KPO PRIVATE LIMITED",
"ASHUTOSH FOODS",
"ASHUTOSH GOWARIKER PRODUCTIONS PRIVATE LIMITED",
"ASHUTOSH HOSPITAL & TRAUMA CENTRE PRIVATE LIMITED",
"ASHUTOSH INFRA PRIVATE LIMITED",
"ASHUTOSH LOGISTICS PRIVATE LIMITED",
"ASHUTOSH METAL PRIVATE. LIMITED.",
"ASHUTOSH MOTORS AND ALLIED BUSINESS PRIVATE LIMITED",
"ASHUTOSH RUBBER PRIVATE LIMITED",
"ASHUTOSH SECURITY SERVICES PRIVATE LIMITED",
"ASHUTOSH STEELS PRIVATE LIMITED",
"ASHUTOSH TEXTILES PRIVATE LIMITED",
"ASHUTOSH TILES PRIVATE LIMITED",
"ASHUTOSHPALLY SATADAL SHIKSHYAYATAN",
"ASHV FINANCE LIMITED",
"ASHVA ENERGY PRIVATE LIMITED",
"ASHVA VENTURES PRIVATE LIMITED",
"ASHVAATHON ENTERPRISES PRIVATE LIMITED",
"ASHVAPURWA MULTI SPECIALITY HOSPITAL",
"ASHVAR AUTOMOBILES PRIVATE LIMITED",
"ASHVAR CARS INDIA PRIVATE LIMITED",
"ASHVEE ELECTRICAL SERVICES",
"ASHVICH INFOTEK PRIVATE LIMITED",
"ASHVIN CHINUBHAI BROKING PRIVATE LIMITED",
"ASHVIN PAREKH ADVISORY SERVICES LLP",
"ASHVINI MAGNETS PRIVATE LIMITED",
"ASHVIRA FASHIONS PRIVATE LIMITED",
"ASHVITA FINE ART & COLLECTIBLES PRIVATE LIMITED",
"ASHVITHA PHARMA PRIVATE LIMITED",
"ASHWA BUILDCON LIMITED",
"ASHWA ENERGY PRIVATE LIMITED",
"ASHWA GLOBAL LOGISTICS PRIVATE LIMITED",
"ASHWAGHOSH EDUCATION AND VYAYAM PRASARAK MANDAL WOMEN'S COLLEGE OF BCA",
"ASHWAM ENTERPRISE PRIVATE LIMITED",
"ASHWAMEDH AGROCHEMICALS PRIVATE LIMITED",
"ASHWAMEDH PROPERTIES PVT LTD",
"ASHWAMEDH SPACES PRIVATE LIMITED",
"ASHWANI AUTOMOBILES PRIVATE LIMITED",
"ASHWANI CABLES PRIVATE LIMITED",
"ASHWANI CARS PRIVATE LIMITED",
"ASHWANI COATING INDIA PRIVATE LIMITED",
"ASHWANI COMMERCIALS PRIVATE LIMITED",
"ASHWANI ENTERPRISES PRIVATE LIMITED",
"ASHWANI GUJRAL INVESTMENT & PORTFOLIO",
"ASHWANI KAPOOR BENIFICIARY TRUST",
"ASHWANI KUMAR AND COMPANY PRIVATE LIMITED",
"ASHWANI KUMAR ASHOK KUMAR PRIVATE LIMITED",
"ASHWANI MARKETING LIMITED",
"ASHWANI METALS PRIVATE LIMITED",
"ASHWANI PAN PRODUCTS PRIVATE LIMITED",
"ASHWANI TYRES PRIVATE LIMITED",
"ASHWARYA ELECTRICALS PRIVATE LIMITED",
"ASHWASURYA REALITIES INDIA PRIVATE LIMITED",
"ASHWATH ENGINEERS AND CONTRACTORS PRIVATE LIMITED",
"ASHWATH INC.",
"ASHWATH INFRAPROJECTS PRIVATE LIMITED",
"ASHWATH INFRATECH PRIVATE LIMITED",
"ASHWATH TECHNOLOGIES PRIVATE LIMITED",
"ASHWATHA CONTRACTS PRIVATE LIMITED",
"ASHWATHI CONTROLS PRIVATE LIMITED",
"ASHWATHY GREEN ENTERPRISE PRIVATE LIMITED",
"ASHWATTHA ADVISORS PRIVATE LIMITED",
"ASHWIK HOSPITALS PRIVATE LIMITED",
"ASHWIN AUTO-CAST PRIVATE LIMITED",
"ASHWIN CAPACITORS PRIVATE LIMITED",
"ASHWIN DIAM POLISHING LLP",
"ASHWIN FASTENERS PRIVATE LIMITED",
"ASHWIN HANUMANT APTE'S SHREE AUTO SERVICE",
"ASHWIN LOGISTICS PRIVATE LIMITED",
"ASHWIN PRECISION METAL BEARING PVT LTD",
"ASHWIN PRECISION PRODUCTS PRIVATE LIMITED",
"ASHWIN STOCKS AND INVESTMENT PRIVATE LIMITED",
"ASHWIN VANASPATI INDUSTRIES PRIVATE LIMITED",
"ASHWIN VANASPATI INDUSTRIES PRIVATE LIMITED(TR.CO.)",
"ASHWINASSOCIATES PRIVATE LIMITED",
"ASHWINI CONTAINER MOVERS PRIVATE LIMITED",
"ASHWINI FINANCE PRIVATE LIMITED",
"ASHWINI FROZEN FOODS",
"ASHWINI HOSPITAL",
"ASHWINI INFRADEVELOPMENTS PRIVATE LIMITED",
"ASHWINI SAHAKARI RUGNALAYA ANI SANSHODHAN KENDRA NIYAMIT",
"ASHWINI TRADERS",
"ASHWINKUMAR ROHITKUMAR TEXTILE PRIVATE LIMITED",
"ASHWINRAM SPINNING MILLS PRIVATE LIMITED",
"ASHWMEGH INDUSTRIES PRIVATE LIMITED",
"ASHWMEGH SPICES PRIVATE LIMITED",
"ASHYA INTERNATIONAL MINERALS PRIVATE LIMITED",
"ASI DATAMYTE INDIA PRIVATE LIMITED",
"ASI ENGINEERING PRIVATE LIMITED",
"ASI FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"ASI INDIA TRAVELS PRIVATE LIMITED",
"ASI SERVICES PRIVATE LIMITED",
"ASIA (CHENNAI) ENGINEERING COMPANY PRIVATE LIMITED",
"ASIA AUTOMATION PRIVATE LIMITED",
"ASIA AUTOMOTIVE LIMITED",
"ASIA BIOTECH PRIVATE LIMITED",
"ASIA BROWN BLEACHCHEM PRIVATE LIMITED",
"ASIA BULK SACKS PRIVATE LIMITED",
"ASIA CAPITAL REINSURANCE GROUP PTE LIMITED",
"ASIA CHEMICALS PRIVATE LIMITED",
"ASIA CHENNAI ENGINEERING COMPANY PRIVATE LIMITED",
"ASIA CRANES PRIVATE LIMITED",
"ASIA CRYSTAL COMMODITY LLP",
"ASIA DUDH UDYOG PRIVATE LIMITED",
"ASIA ENGINEERING & INDUSTRIES CO PVT LTD",
"ASIA EXCEL TRADING LIMITED",
"ASIA HEALTHCARE DEVELOPMENT LIMITED",
"ASIA HOSIERY MILLS PVT LTD",
"ASIA INDEX PRIVATE LIMITED",
"ASIA INSTITUTE OF HAIR TRANSPLANT PRIVATE LIMITED",
"ASIA INTERNATIONAL ADVERTISEMENT & RETAIL SOLUTIONS PRIVATE LIMITED",
"ASIA INVESTMENTS PRIVATE LIMITED",
"ASIA MASTER LOGISTICS (INDIA) PRIVATE LIMITED",
"ASIA MATCH COMPANY PRIVATE LIMITED",
"ASIA METAL COMPONENTS INDIA PRIVATE LIMITED",
"ASIA MINERALS INDIA PRIVATE LIMITED",
"ASIA MOTORWORKS LIMITED",
"ASIA PACIFIC COMMERCE COLLEGE AHMEDABAD",
"ASIA PACIFIC FLIGHT TRAINING ACADEMY LIMITED",
"ASIA PACIFIC GLOBEX PRIVATE LIMITED",
"ASIA PACIFIC INSTITUTE OF MANAGEMENT",
"ASIA PACIFIC IT SOLUTIONS PRIVATE LIMITED",
"ASIA PACIFIC MARBLES LIMITED",
"ASIA PACIFIC TOOLING SOLUTIONS PRIVATE LIMITED",
"ASIA PERFECT SECURE HR SOLUTION PRIVATE LIMITED",
"ASIA PESTICIDES",
"ASIA POWER ELECTRICAL LLP",
"ASIA POWERCOM PRIVATE LIMITED",
"ASIA PULP AND PAPERS PRIVATE LIMITED",
"ASIA RESCUE & MEDICAL SERVICES PRIVATE LIMITED",
"ASIA RESORTS LIMITED",
"ASIA SEED INDIA PRIVATE LIMITED",
"ASIA SHIPPING INTERNATIONAL TRANSPORT PRIVATE LIMITED",
"ASIA SOCIETY INDIA CENTER",
"ASIA SPINTEX LIMITED",
"ASIA WOOD PRIVATE LIMITED",
"ASIAAN METALS & ALUMINIUM CASTING PRIVATE LIMITED",
"ASIACAP INVESTMENT ADVISORS PRIVATE LIMITED",
"ASIAD ENGINEERING WORKS PVT.LTD.",
"ASIAD HOUSING AND PROPERTY DEVELOPMENT SERVICES PRIVATE LIMITED",
"ASIAD PAINTS LIMITED",
"ASIAINNO NETWORK (INDIA) PRIVATE LIMITED",
"ASIALINK AGENCIES PRIVATE LIMITED",
"ASIAN ACADEMY OF PROFESSIONAL TRAINING INDIA PRIVATE LIMITED",
"ASIAN AEROSOL OAN PRIVATE LIMITED",
"ASIAN AGRO INDUSTRIES LIMITED",
"ASIAN ARC ELECTRODES PRIVATE LIMITED",
"ASIAN AUTOMATION (TN) PRIVATE LIMITED",
"ASIAN AZOLES PRIVATE LIMITED",
"ASIAN BARRELS PRIVATE LIMITED",
"ASIAN BEVERAGE PRIVATE LIMITED",
"ASIAN BIKES PRIVATE LIMITED",
"ASIAN BOILER ENGINEERS PRIVATE LIMITED",
"ASIAN BROKING PRIVATE LIMITED",
"ASIAN BUILDING MATERIALS PRIVATE LIMITED",
"ASIAN BUSINESS EXHIBITION & CONFERENCES LIMITED",
"ASIAN CANCER HOSPITAL",
"ASIAN CHECKOUT PRIVATE LIMITED",
"ASIAN CHEM WORKS PRIVATE LIMITED",
"ASIAN CHEMTECH PRIVATE LIMITED",
"ASIAN CINEMA & MULTIPLEXES PRIVATE LIMITED",
"ASIAN CITICARE SUPERSPECIALITY HOSPITAL",
"ASIAN COLLEGE OF JOURNALISM",
"ASIAN COLOUR COATED ISPAT LIMITED",
"ASIAN COLOURS PRIVATE LIMITED",
"ASIAN CONCRETES AND CEMENTS PRIVATE LIMITED",
"ASIAN CONSTRUCTION COMPANY",
"ASIAN CONSULTING ENGINEERS PRIVATE LIMITED",
"ASIAN CONTEC LIMITED",
"ASIAN CONVENTIONS & EXPOSITIONS PRIVATE LIMITED",
"ASIAN CREATIONS PRIVATE LIMITED",
"ASIAN DAIRY FOODS PRIVATE LIMITED",
"ASIAN DEVELOPMENT BANK",
"ASIAN DISTRIBUTORS PRIVATE LIMITED",
"ASIAN DYNASTIES GRACE INDUSTRIES LIMITED",
"ASIAN ECO LIGHTINGS PRIVATE LIMITED",
"ASIAN EDUCATION CHARITABLE SOCIETY",
"ASIAN ENERGY SERVICES LIMITED",
"ASIAN ENGINEERING",
"ASIAN ENGINEERING PVT LTD",
"ASIAN EXCHANGE INDIA PRIVATE LIMITED",
"ASIAN EXTRUSIONS PRIVATE LIMITED",
"ASIAN EYE INSTITUTE & LASER CENTRE PRIVATE LIMITED",
"ASIAN EYECARE HOSPITAL.",
"ASIAN FAB TEC LIMITED",
"ASIAN FABRICX PRIVATE LIMITED",
"ASIAN FERTILIZERS LIMITED",
"ASIAN FILMS TU PRIVATE LIMITED",
"ASIAN FINE CEMENTS PRIVATE LIMITED",
"ASIAN FISHMEAL & FEEDS PRIVATE LIMITED",
"ASIAN FLEXI PACK INDIA PRIVATE LIMITED",
"ASIAN FOOTWEARS PRIVATE LIMITED",
"ASIAN GALAXY PRIVATE. LIMITED.",
"ASIAN GAS AGENCY SOLAPUR",
"ASIAN GLOBAL SHIPPING AGENCIES PRIVATE LIMITED",
"ASIA'N' GLOBAL TECNOTEC PRIVATE LIMITED",
"ASIAN GRANITO INDIA LIMITED",
"ASIAN HANDICRAFTS PRIVATE LIMITED",
"ASIAN HEALTH AND NUTRI FOODS PRIVATE LIMITED",
"ASIAN HEALTHCLINICS PRIVATE LIMITED",
"ASIAN HEART INSTITUTE & RESEARCH CENTRE PRIVATE LIMITED",
"ASIAN HERBEX LIMITED",
"ASIAN HOSPITAL",
"ASIAN HOTELS EAST LIMITED",
"ASIAN HOTELS NORTH LIMITED",
"ASIAN HOTELS WEST LIMITED",
"ASIAN INSTITUTE OF DESIGN",
"ASIAN INSTITUTE OF GASTROENTEROLOGY PRIVATE LIMITED",
"ASIAN INSTITUTE OF INFERTILITY MANAGEMENT PRIVATE LIMITED",
"ASIAN INSTITUTE OF MEDICAL SCIENCES PRIVATE LIMITED",
"ASIAN INSTITUTE OF NEPHROLOGY AND UROLOGY (CHENNAI) PRIVATE LIMITED",
"ASIAN INSTITUTE OF NEPHROLOGY AND UROLOGY (SILIGURI) PRIVATE LIMITED",
"ASIAN INSTITUTE OF NEPHROLOGY AND UROLOGY (VIZAG) PRIVATE LIMITED",
"ASIAN INSTITUTE OF NEPHROLOGY AND UROLOGY PRIVATELIMITED",
"ASIAN INSTITUTE OF ONCOLOGY PRIVATE LIMITED",
"ASIAN INTERNATIONAL SCHOOL",
"ASIAN LAKTO INDUSTRIES LIMITED",
"ASIAN LEATHER PRIVATE LIMITED",
"ASIAN LIFECARE PRIVATE LIMITED",
"ASIAN LIFTS AND ESCALATOR PRIVATE LIMITED",
"ASIAN MACHINE TOOL CORPORATION PRIVATE LIMITED",
"ASIAN MAGNETIC DEVICES PRIVATE LIMITED",
"ASIAN MARKETS SECURITIES PRIVATE LIMITED",
"ASIAN METAL PRINTERS AND CONTAINERS PRIVATE LIMITED",
"ASIAN MILLS PRIVATE LIMITED",
"ASIAN MOTHER AND CHILD HEALTH CARE PRIVATE LIMITED",
"ASIAN MULTIPLEXES PRIVATE LIMITED",
"ASIAN NOBLE HOSPITAL PRIVATE LIMITED",
"ASIAN NUTRITIONS PRIVATE LIMITED",
"ASIAN OILFIELD SERVICES LIMITED",
"ASIAN PACIFIC LEARNING LEVERAGE PRIVATE LIMITED",
"ASIAN PACKING MACHINERY PRIVATE LIMITED",
"ASIAN PAINTS INDUSTRIAL COATINGS LIMITED",
"ASIAN PAINTS LIMITED",
"ASIAN PAINTS PPG PRIVATE LIMITED",
"ASIAN PHOTO PRIVATE LIMITED",
"ASIAN PLASTOWARES PRIVATE LIMITED",
"ASIAN PLYWOOD INDUSTRIES PVT LTD",
"ASIAN POLYCHEM PRIVATE LIMITED",
"ASIAN POWER SYSTEMS (INDIA) PRIVATE LIMITED",
"ASIAN PRE-LAM INDUSTRIES PRIVATE LIMITED",
"ASIAN REPRODUCTIVE CENTRE PRIVATE LIMITED",
"ASIAN REPROGRAPHICS PRIVATE LIMITED",
"ASIAN RESURFACING OF ROAD AGENCY PRIVATE LIMITED",
"ASIAN ROCKS PRIVATE LIMITED",
"ASIAN SALES CORPORATION PRIVATE LIMITED",
"ASIAN SATELLITE BROADCAST PRIVATE LIMITED",
"ASIAN SCHOOL OF BUSINESS INDIA PRIVATE LIMITED",
"ASIAN SCHOOL OF MEDIA STUDIES",
"ASIAN SEALING PRODUCTS PRIVATE LIMITED",
"ASIAN SECURITY AND INTELLIGENCE LIMITED",
"ASIAN SEEDS PRIVATE LIMITED",
"ASIAN SIGNAL INDUSTRY PVT LTD",
"ASIAN SKY INFRASTRUCTURE PRIVATE LIMITED",
"ASIAN SKY SHOP LIMITED",
"ASIAN SOLVOCHEM PRIVATE LIMITED",
"ASIAN STAR COMPANY LIMITED",
"ASIAN STAR JEWELS PRIVATE LIMITED",
"ASIAN SUPER SPECIALITY HOSPITALS PRIVATE LIMITED",
"ASIAN SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED",
"ASIAN SWITCHGEAR PRIVATE LIMITED",
"ASIAN TEA & EXPORTS LIMITED ASIAN TEA GROUP ENTITY",
"ASIAN TEA COMPANY PRIVATE LIMITED",
"ASIAN TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"ASIAN TELECONSTRUCTION ENGINEERS PRIVATE LIMITED",
"ASIAN THAI FOODS INDIA PRIVATE LIMITED",
"ASIAN THAI FOODS LUCKNOW PRIVATE LIMITED",
"ASIAN THEATRES LIMITED",
"ASIAN TOWNSVILLE FARMS LIMITED",
"ASIAN TOWNSVILLE FARMS PRIVATE LIMITED",
"ASIAN TRADELINKS PRIVATE LIMITED",
"ASIAN TRANSCARE",
"ASIAN TUBE LIGHTS(INDIA) PRIVATE LIMITED",
"ASIAN TUBES PRIVATE LIMITED",
"ASIAN VIDHI EVAM NYAYIK VIGYAN MAHAVIDYALAYA",
"ASIAN WAREHOUSING LIMITED",
"ASIAN WIND ENERGY PRIVATE LIMITED",
"ASIAN WIRE FORMING AND SPRINGS PRIVATE LIMITED",
"ASIAN WORLDWIDE SERVICES INDIA PRIVATE LIMITED",
"ASIAN‚ÄìAFRICAN LEGAL CONSULTATIVE ORGANIZATION",
"ASIANCOATINGS N PAINTS PRIVATE LIMITED",
"ASIANET DIGITAL NETWORK PRIVATE LIMITED",
"ASIANET LOGISTICS (INDIA) PRIVATE LIMITED",
"ASIANET NEWS MEDIA & ENTERTAINMENT PRIVATE LIMITED",
"ASIANET NEWS NETWORK PRIVATE LIMITED",
"ASIANET SATELLITE COMMUNICATIONS LIMITED",
"ASIANET STAR COMMUNICATIONS PRIVATE LIMITED",
"ASIANLAK HEALTH FOODS LTD",
"ASIANOL BIOTECH PRIVATE LIMITED",
"ASIANOL LUBRICANTS PRIVATE LIMITED",
"ASIANOL SHIPPING LIMITED",
"ASIANT T V NETWORK PRIVATE LIMITED",
"ASIA-PACIFIC CONSTRUCTION PRIVATE LIMITED",
"ASIAPACIFIC MARKETING AND EVENTS PRIVATE LIMITED",
"ASIA-PACIFIC RISK MANAGEMENT SERVICES PRIVATE LIMITED",
"ASIAPOWER RECRUITMENT CONSULTANTS LIMITED",
"ASIAR SOLUTIONS PRIVATE LIMITED",
"ASIATECH COATINGS PRIVATE LIMITED",
"ASIATECH HOSPITALITY SOLUTIONS PRIVATE LIMITED",
"ASIATEK AUTOMOTIVE SOLUTIONS INDIA PRIVATE LIMITED",
"ASIATEK SPACE DEVELOPERS PRIVATE LIMITED",
"ASIATIC BUILDWELL PRIVATE LIMITED",
"ASIATIC COLOUR CHEM INDUSTRIES LIMITED.",
"ASIATIC COLOURCHEM INDUSTRIES LIMITED",
"ASIATIC COMPOSITE LIMITED",
"ASIATIC CONTAINER LINES INDIA PRIVATE LIMITED",
"ASIATIC DRUGS AND PHARMACEUTICALS PRIVATE LIMITED",
"ASIATIC ELECTRICAL & SWITCHGEAR PRIVATE LIMITED",
"ASIATIC ENTERPRISES",
"ASIATIC GASES LTD",
"ASIATIC GREEN AGRICO PRIVATE LIMITED",
"ASIATIC LOGISTICS PRIVATE LIMITED",
"ASIATIC MARKETING PRIVATE LIMITED",
"ASIATIC METCAST PRIVATE LIMITED",
"ASIATIC OXYGEN LTD",
"ASIATIC ROAD CARRIERS PRIVATE LIMITED",
"ASIATIC SOURCING (OPC) PRIVATE LIMITED",
"ASIATIC STOCK AND SECURITIES LIMITED",
"ASIATIC TRADELINKS PRIVATE LIMITED",
"ASIATISCH WORLDWIDE LOGISTICS PRIVATE LIMITED",
"ASIAVILLE INTERACTIVE PRIVATE LIMITED",
"ASIAWEBGURU PRIVATE LIMITED",
"ASICHEM INDUSTRIES PRIVATE LIMITED",
"ASICS INDIA PRIVATE LIMITED",
"ASICZEN TECHNOLOGIES INDIA PRIVATE LIMITED",
"ASIER METALS PRIVATE LIMITED",
"ASIF AQUBAL LOGISTICS PRIVATE LIMITED",
"ASIFA FOREX PRIVATE LIMITED",
"ASIM MINERALS PRIVATE LIMITED",
"ASIM NAVIGATION INDIA PRIVATE LIMITED",
"ASIMILY INDIA PRIVATE LIMITED",
"ASIMIT FINVEST PRIVATE LIMITED",
"ASINEEMAN FASHIONS PRIVATE LIMITED",
"ASIPIYA CHEMICALS AND SOLVENT PRIVATE LIMITED",
"ASIR AUTOMOBILES PRIVATE LIMITED",
"ASIRVAD MICRO FINANCE LIMITED",
"ASIRVAD MICRO FINANCE PRIVATE LIMITED",
"ASIS CORPORATE ADVISORS LIMITED",
"ASIS DEVELOPERS PRIVATE LIMITED",
"ASIS LOGISTICS LIMITED",
"ASIT C MEHTA COMMODITY SERVICES LIMITED",
"ASIT C MEHTA FINANCIAL SERVICES LIMITED",
"ASIT C MEHTA INVESTMENT INTERRMEDIATES LTD",
"ASIT C MEHTA REAL ESTATE SERVICES PRIVATE LIMITED",
"ASIT ENGICON PRIVATE LIMITED",
"ASITA JEWELLERY MANUFACTURING PRIVATE LIMITED",
"ASITAH OVERSEAS PRIVATE LIMITED",
"ASITE SOLUTIONS PRIVATE LIMITED",
"ASJ GLOBAL LOGISTICS (INDIA) PRIVATE LIMITED",
"ASJ REALTORS PRIVATE LIMITED",
"ASJK CORPORATE SERVICES PRIVATE LIMITED",
"ASJS ENTERPRISES",
"ASK ADVERTISING AIDS PRIVATE LIMITED",
"ASK AGENCIES AND INVESTMENTS PRIVATE LIMITED",
"ASK AGRO COMMODITIES PRIVATE LIMITED",
"ASK ARCHITECTS AND BUILDERS PRIVATE LIMITED",
"ASK AUTO COMPONENTS PRIVATE LIMITED",
"ASK AUTOMOBILES PRIVATE LIMITED",
"ASK AUTOMOTIVE LIMITED",
"ASK AUTOMOTIVE PRIVATE LIMITED",
"ASK BHOOMI DEVELOPERS PRIVATE LIMITED",
"ASK CHEMICALS INDIA PRIVATE LIMITED",
"ASK DIAM PRIVATE LIMITED",
"ASK EHS ENGINEERING & CONSULTANTS PRIVATE LIMITED",
"ASK E-SQUARE BUSINESS SOLUTIONS PRIVATE LIMITED",
"ASK FAMILY OFFICE AND INVESTMENT ADVISERS PRIVATE LIMITED",
"ASK FINANCIAL HOLDINGS PRIVATE LIMITED",
"ASK FOOD AND BEVERAGES PRIVATE LIMITED",
"ASK FRAS-LE FRICTION PRIVATE LIMITED",
"ASK FREEHOLD REALTY PRIVATE LIMITED",
"ASK FREIGHT FORWARDERS PRIVATE LIMITED",
"ASK HOME FURNISHING PRIVATE LIMITED",
"ASK HORIZON EDUCATION AND TECHNOLOGY PRIVATE LIMITED",
"ASK HR SOLUTIONS PRIVATE LIMITED",
"ASK HYDRO HI-TECH SYSTEMS PRIVATE LIMITED",
"ASK INVESTMENT MANAGERS LIMITED",
"ASK INVESTMENT MANAGERS PRIVATE LIMITED",
"ASK IT SOLUTIONS INDIA PRIVATE LIMITED",
"ASK ME LAB-CON SERVICES PRIVATE LIMITED",
"ASK MOULDERS PRIVATE LIMITED",
"ASK OILFIELD SERVICES PRIVATE LIMITED",
"ASK OVERSEAS PRIVATE LIMITED",
"ASK PROPERTY INVESTMENT ADVISORS PRIVATE LIMITED",
"ASK RAJKAMAL INDUSTRIES PRIVATE LIMITED",
"ASK REALTY AND DEVELOPERS LIMITED",
"ASK TECHSOFT CARE PRIVATE LIMITED",
"ASK TRAINING AND LEARNING PRIVATE LIMITED",
"ASK VISION IMPEX PRIVATE LIMITED",
"ASK WEALTH ADVISORS PRIVATE LIMITED",
"ASK4DELI FOOD MERCHANDISING PRIVATE LIMITED",
"ASKA E COMMERCE SOLUTIONS PRIVATE. LIMITED",
"ASKA ENERGY PRIVATE LIMITED",
"ASKA EQUIPMENTS PRIVATE LIMITED (TRANSFERED FROM MAHARASHTRA)",
"ASKA REAL ESTATE PRIVATE LIMITED",
"ASKAN TECHNOLOGIES PRIVATE LIMITED",
"ASKAR MECHATRONICS SYSTEMS PRIVATE LIMITED",
"ASKARA OILFIELD SERVICES PRIVATE LIMITED",
"ASKARAN HIRALAL TEXTILES PRIVATE LIMITED",
"ASKARI MOTORS PRIVATE LIMITED",
"ASKAS PLASTIC PVT LTD",
"ASKI TECHNOLOGIES PRIVATE LIMITED",
"ASKIITIANS WEB PRIVATE LIMITED",
"ASKIO INFOTECH SERVICES PRIVATE LIMITED",
"ASKLEPIOS REMEDIES PVT LTD.",
"ASKLOGGISTICS SERVICES INDIA PRIVATE LIMITED",
"ASL CONVEYOR EQUIPMENTS & CO PRIVATE LIMITED",
"ASL ENTERPRISES",
"ASL ENTERPRISES LIMITED",
"ASL FORTUNE PRIVATE LIMITED",
"ASL HR SOLUTIONS PRIVATE LIMITED",
"ASL INDUSTRIES LIMITED",
"ASL INDUSTRIES PRIVATE LIMITED",
"ASL INFOSYSTEMS PRIVATE LIMITED",
"ASL LOGISTICS PRIVATE LIMITED",
"ASL MARKETING PVT LTD",
"ASL PLASTIC PRIVATE LIMITED",
"ASL POLYMERS PRIVATE LIMITED",
"ASL SCS INDIA PRIVATE LIMITED",
"ASL SHIPPING AND LOGISTICS INDIA PRIVATE LIMITED",
"ASL TEA INDIA PRIVATE LIMITED",
"ASLAM ARCHITECTS AND INTERIOR DESIGNERS PRIVATE LIMITED",
"ASLAM CHAPAL'S",
"ASLAM MOHAMMED PROPERTIES PRIVATE LIMITED",
"ASLAN HEALTHCARE PRIVATE LIMITED",
"ASLINA AGRO & HORTICULTURE PRIVATE LIMITED",
"ASM AERO PRIVATE LIMITED",
"ASM ASSEMBLY SYSTEMS INDIA PRIVATE LIMITED",
"ASM CAREER SOLUTIONS PRIVATE LIMITED",
"ASM CASTINGS PRIVATE LIMITED",
"ASM DIGITAL ENGINEERING PRIVATE LIMITED",
"ASM ENTERPRISE SOLUTIONS PRIVATE LIMITED",
"ASM ENTERPRISES PRIVATE LIMITED",
"ASM GREEN DESIGNS PRIVATE LIMITED",
"ASM HOME FURNISHINGS PRIVATE LIMITED",
"ASM INDUSTRIES",
"ASM INDUSTRIES INDIA PRIVATE LIMITED",
"ASM MARKETING PRIVATE LIMITED",
"ASM PIPES PRIVATE LIMITED",
"ASM S COMMERCE SCIENCE AND INFORMATION TECHNOLOGY JR COLLEGE CHINCHWAD",
"ASM SHIPPING PRIVATE LIMITED",
"ASM TECHNOLOGIES LIMITED",
"ASM THERMAL SPRAY PRIVATE LIMITED",
"ASM TRAXIM PRIVATE LIMITED",
"ASMA NATURAL PRODUCT PRIVATE LIMITED",
"ASMA RESIDENCIES PRIVATE LIMITED",
"ASMA RUBBER PRODUCTS PRIVATE LIMITED.",
"ASMA TRAEXIM PRIVATE LIMITED",
"ASMAA PRESSING PRIVATE LIMITED",
"ASMAA TOOLS INDIA PRIVATE LIMITED",
"ASMACS SKILL DEVELOPMENT LIMITED",
"ASMACS SYSTEMS SOLUTIONS PRIVATE LIMITED",
"ASMADIYA TECHNOLOGIES PRIVATE LIMITED",
"ASMAITHA WIRELESS TECHNOLOGIES PRIVATE LIMITED",
"ASMANAGEMENT OPERATION INDIA PRIVATE LIMITED",
"ASMARA APPARELS INDIA PRIVATE LIMITED",
"ASMARA HOME PRODUCTS INDIA PRIVATE LIMITED",
"ASMARO FABRICATORS PRIVATE LIMITED",
"ASMC CONSULTANTS PRIVATE LIMITED",
"ASME INDIA PRIVATE LIMITED",
"ASMEE CHEMICALS PRIVATE LIMITED",
"ASMEETA INFRATECH LIMITED",
"ASMERA FASHION PRIVATE LIMITED",
"ASMET INDUSTRIES PRIVATE LIMITED",
"ASMI EXPRESS PRIVATE LIMITED",
"ASMI INDUSTRIES PRIVATE LIMITED",
"ASMI INTERNATIONAL PRIVATE LIMITED",
"ASMI LOGISTIC SOLUTIONS PRIVATE LIMITED",
"ASMI PRINTOGRAPHICS PRIVATE LIMITED",
"ASMI SPECIALISED MANUFACTURING INDUSTRIES PRIVATE LIMITED",
"ASMI YOUTH CAREER ADVISOR LLP",
"ASMITA FIRE SAFETY PRIVATE LIMITED",
"ASMITA INDIA LIMITED",
"ASMITHAE VENTURES PRIVATE LIMITED",
"ASMS ALAMGIR SHIP MANAGEMENT & ENGINEERING SERVICES PRIVATE LIMITED",
"ASN AGRI GENETIC PRIVATE LIMITED",
"ASN APPARELS PRIVATE LIMITED",
"ASN CREATIONS PRIVATE LIMITED",
"ASN FLOUR AND EDIBLE PROCESSING PRIVATE LIMITED",
"ASN LOGISTICS & SUPPLY SOLUTIONS PRIVATE LIMITED",
"ASN MANUFACTURING AND SERVICES PRIVATE LIMITED",
"ASN MEDICARE & INFRATECH PRIVATE LIMITED",
"ASN NATURAL RESOURCES PRIVATE LIMITED",
"ASN PACKAGING PRIVATE LIMITED",
"ASN SERVICES PRIVATE LIMITED",
"ASN SHELTERS PRIVATE LIMITED",
"ASN SHIPPING AGENCIES PRIVATE LIMITED",
"ASN TEXTILES PRIVATE LIMITED",
"ASNANI BUILDERS AND DEVELOPERS LTD",
"ASNANI LIFESPACES PRIVATE LIMITED",
"ASNL INDIA PRIVATE LIMITED",
"ASNM CARE PRIVATE LIMITED",
"ASNS INFRASTRUCTURE PRIVATE LIMITED",
"ASO AGRO PRIVATE LIMITED",
"ASOCIATED BITUMENS PRIVATE LIMITED",
"ASOCIETYCONSULTING INDIA PRIVATE LIMITED",
"ASOJ SOFT CAPS PVT LTD",
"ASOKA BETELNUT COMPANY PRIVATE LIMITED",
"ASOKA PROJECTS PRIVATE LIMITED",
"ASOKA SKY METALS PRIVATE LIMITED",
"ASOLUTION PHARMACEUTICALS PRIVATE LIMITED",
"ASONA INDIA PRIVATE LIMITED",
"ASONALS AG-TECH PRIVATE LIMITED",
"ASOPA DECOR PRIVATE LIMITED",
"ASOPA HOSPITAL",
"ASOPALAV CREATIONS PRIVATE LIMITED",
"ASOPALAV ENDEAVOURS LLP",
"ASOPALAV JEWELLERS PRIVATE LIMITED",
"ASOPALAV SILK CREATION",
"ASOPALAV SILK INDIA PRIVATE LIMITED",
"ASP ARVIND STEEL PRIVATE LIMITED",
"ASP COMPUTERS PRIVATE LIMITED",
"ASP CREW MANAGEMENT INDIA PRIVATE LIMITED",
"ASP ENGINEERING PRODUCTS PVT LTD",
"ASP INFRASTRUCTURES PRIVATE LIMITED",
"ASP MEDIA INFOTAINMENT PRIVATE LIMITED",
"ASP OLMEDIA PRIVATE LIMITED",
"ASP PETROCHEMICALS PRIVATE LIMITED",
"ASP SHIP MANAGEMENT INDIA PRIVATE LIMITED",
"ASP WATER AND POWER PROJECTS PRIVATE LIMITED",
"ASPA AUTO LAMPS PRIVATE LIMITED",
"ASPA BANDSONS AUTO PRIVATE LIMITED",
"ASPADA MARKETING PRIVATE LIMITED",
"ASPADE SYSTEMS PRIVATE LIMITED",
"ASPAGTEQ INFOTECH PRIVATE LIMITED",
"ASPAM ACADEMY NOIDA",
"ASPAM CARAVAN LOGISTICS PARKS PRIVATE LIMITED",
"ASPAM FOOD COLD STORAGE PRIVATE LIMITED.",
"ASPARK INFRACON PRIVATE LIMITED",
"ASPARKTECH SOLUTIONS PRIVATE LIMITED",
"ASPDIN CONSTRUCTION PRIVATE LIMITED",
"ASPECT BULLION REFINERY PRIVATE LIMITED",
"ASPECT COATINGS INDIA PRIVATE LIMITED",
"ASPECT CONTACT CENTER SOFTWARE I P LIMITED",
"ASPECT CONTACT CENTRE SOFTWARE INDIA PRIVATE LIMITED",
"ASPECT GLOBAL VENTURES PRIVATE LIMITED",
"ASPECT HOSPITALITY (INDIA) PRIVATE LIMITED",
"ASPECT MANAGEMENT SERVICES PRIVATE LIMITED",
"ASPECT TECHNOLOGY CENTER INDIA PRIVATE LIMITED",
"ASPECTRATIO PRIVATE LIMITED",
"ASPEE AGRO EQUIPMENT PRIVATE LIMITED",
"ASPEE NUTAN ACADEMY",
"ASPEE SPRINGS LIMITED.",
"ASPEK INDIA PRIVATE LIMITED",
"ASPEN ADVENTURES PRIVATE LIMITED",
"ASPEN BUILDTECH LIMITED",
"ASPEN CREW SPORTSGEAR",
"ASPEN DIAGNOSTICS PRIVATE LIMITED",
"ASPEN FASHION PRIVATE LIMITED",
"ASPEN FOODS PRIVATE LIMITED",
"ASPEN INFRA PADUBIDRI PRIVATE LIMITED",
"ASPEN INTERNATIONAL PRIVATE LIMITED",
"ASPEN LABORATORIES PRIVATE LIMITED",
"ASPEN ONLINE PRIVATE LIMITED",
"ASPEN PUMPS INDIA PRIVATE LIMITED",
"ASPEN STEEL PRIVATE LIMITED",
"ASPENOL BIOSCIENCES PRIVATE LIMITED",
"ASPENPARK INFRA COIMBATORE PRIVATE LIMITED",
"ASPENPARK INFRA VADODARA PRIVATE LIMITED",
"ASPET TECHNOPLAST PRIVATE LIMITED",
"ASPG INFRA GLOBAL PRIVATE LIMITED",
"ASPHALT LINEOLUX PRIVATE LIMITED",
"ASPHALT ONE PRIVATE LIMITED",
"ASPHIRE SYSTEM OPC PRIVATE LIMITED",
"ASPI ASSOCIATE (OPC) PRIVATE LIMITED",
"ASPICK ENGINEERING PRIVATE LIMITED",
"ASPIDA LIFE SCIENCES PRIVATE LIMITED",
"ASPIGO FACILITY INDIA PRIVATE LIMITED",
"ASPINO HR SERVICES PRIVATE LIMITED",
"ASPINOR TECHNOLOGIES PRIVATE LIMITED",
"ASPINWALL AND COMPANY LIMITED",
"ASPIRA PATHLAB & DIAGNOSTICS LIMITED",
"ASPIRANT SOFT SOLUTIONS PRIVATE LIMITED",
"ASPIRARE TECHNOLOGIES PRIVATE LIMITED",
"ASPIRATION ADVERTISING PRIVATE LIMITED",
"ASPIRATION ENERGY PRIVATE LIMITED",
"ASPIRATION SOLUTIONS",
"ASPIRATIONS DEVELOPERS PRIVATE LIMITED",
"ASPIRATIONS HIRISE PRIVATE LIMITED",
"ASPIRATIONS PROPERTIES PRIVATE LIMITED",
"ASPIRE & INNOVATIVE ADVERTISING LIMITED",
"ASPIRE AUTOMOBILES PRIVATE LIMITED",
"ASPIRE BUILD PRODUCTS PRIVATE LIMITED",
"ASPIRE CEREBRO PRIVATE LIMITED",
"ASPIRE DISRUPTIVE SKILL FOUNDATION",
"ASPIRE FARMS PRIVATE LIMITED",
"ASPIRE FITNESS PRIVATE LIMITED",
"ASPIRE HOME FINANCE CORPORATION LIMITED",
"ASPIRE HOMESS AND INFRATECH PRIVATE LIMITED",
"ASPIRE HOSPITALS PRIVATE LIMITED",
"ASPIRE HUMAN CAPITAL MANAGEMENT PRIVATE LIMITED",
"ASPIRE INSURANCE BROKERS PRIVATE LIMITED",
"ASPIRE KNOWLEDGE & SKILLS INDIA PRIVATE LIMITED",
"ASPIRE LEARNING COMPANY PRIVATE LIMITED",
"ASPIRE MOULDING & TOOLING PRIVATE LIMITED",
"ASPIRE NETWORKS PRIVATE LIMITED",
"ASPIRE NXT PRIVATE LIMITED",
"ASPIRE ORAL-CARE PRIVATE LIMITED",
"ASPIRE POLYTRADE PRIVATE LIMITED",
"ASPIRE POWER PROJECTS PRIVATE LIMITED",
"ASPIRE PROPTECH CONSULTANTS (OPC) PRIVATE LIMITED",
"ASPIRE REMEDIES PRIVATE LIMITED",
"ASPIRE SALES PRIVATE LIMITED",
"ASPIRE SKAAY PRIVATE LIMITED",
"ASPIRE SOLUTION",
"ASPIRE SYSTEMS DIGITAL PRIVATE LIMITED",
"ASPIRE SYSTEMS INDIA PRIVATE LIMITED",
"ASPIRE TAPES PRIVATE LIMITED",
"ASPIRE TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"ASPIRE TRADING",
"ASPIREAL TECHNOLOGIES PRIVATE LIMITED",
"ASPIREEDGE SOLUTIONS PRIVATE LIMITED",
"ASPIRETECHNO GLOBAL PRIVATE LIMITED",
"ASPIRIFY ENTERPRISES PRIVATE LIMITED",
"ASPIRING MINDS ASSESSMENT PRIVATE LIMITED",
"ASPIRING SMART SOLUTIONS PRIVATE LIMITED",
"ASPIRIS LEAD FLOW PRIVATE LIMITED",
"ASPIRO PHARMA LIMITED",
"ASPL INFO SERVICES PRIVATE LIMITED",
"ASPN INFODYNAMIC PRIVATE LIMITED",
"ASPN INFRATECH PRIVATE LIMITED",
"ASPO TECHNOCAST PRIVATE LIMITED",
"ASPOLITE ENGINEERS INDIA PRIVATE LIMITED",
"ASPPEN OVERSEAS LIMITED",
"ASPPIRE THERMOTEK PRIVATE LIMITED",
"ASPR AGROVALUE (I) LIMITED",
"ASPRI SPIRITS PRIVATE LIMITED",
"ASPV INDUSTRIES PRIVATE LIMITED",
"ASPYRD BUSINESS SOLUTIONS PRIVATE LIMITED",
"ASQI INVESTMENT MANAGERS PRIVATE LIMITED",
"ASQUARE FOOD & BEVERAGES PRIVATE LIMITED",
"ASQUARE HR SOLUTIONS PRIVATE LIMITED",
"ASQUARE WATER ENGINEERING PRIVATE LIMITED",
"ASQUARIAN CONSULTANTS PRIVATE LIMITED",
"ASR ASSOCIATES PRIVATE LIMITED",
"ASR COTTON PRIVATE LIMITED",
"ASR ENGINEERING & PROJECTS LIMITED",
"ASR GLOBAL HOLDINGS PRIVATE LIMITED",
"ASR HOSPITALS (INDIA) PRIVATE LIMITED",
"ASR INDIA PRIVATE LIMITED",
"ASR INFRAPROJECTS PRIVATE LIMITED",
"ASR LOGISTICS I PRIVATE LIMITED",
"ASR MACHINE TOOLS PRIVATE LIMITED",
"ASR MET TECH PRIVATE LIMITED",
"ASR REALTECH LIMITED",
"ASR ROADWAYS PRIVATE LIMITED",
"ASR STEEL DETAILING PRIVATE LIMITED",
"ASR TOOLINGS PRIVATE LIMITED",
"ASRA ISPAT PRIVATE LIMITED",
"ASRA STEELS PRIVATE LIMITED",
"ASRANI PROFILES & PIPES PRIVATE LIMITED",
"ASRANI TUBES LIMITED.",
"ASRD DEVELOPERS PRIVATE LIMITED",
"ASREC (INDIA) LIMITED",
"A-SREE SHIPPING AND TRADING PRIVATE LIMITED",
"ASRIAL INFRA MACHINERY INDIA LLP",
"ASRIT INTERNATIONAL PRIVATE LIMITED",
"ASRO MARKETING PRIVATE LIMITED",
"ASSA ABLOY INDIA PRIVATE LIMITED",
"ASSA ABLOY OPENING SOLUTIONS INDIA PRIVATE LIMITED",
"ASSA MARKETING PRIVATE LIMITED",
"ASSA POLYURETHANES PRIVATE LIMITED",
"ASSA PROJECT & ENGINEERING PRIVATE LIMITED",
"ASSALAMA INSTITUTE OF OPHTHALMOLOGY CALICUT LIMITED",
"ASSAM (ROAD) TRAVELS PVT LTD",
"ASSAM AGRICULTURAL UNIVERSITY",
"ASSAM AIR PRODUCTS PRIVATE LIMITED",
"ASSAM BALLBEARINGS PRIVATE LIMITED",
"ASSAM BEARING PRIVATE LIMITED",
"ASSAM BIO REFINERY PRIVATE LIMITED",
"ASSAM BOMBAY CARRIERS PRIVATE LIMITED",
"ASSAM CANCER CARE FOUNDATION",
"ASSAM CHEMICAL & PHARMACEUTICAL PVT LTD",
"ASSAM COMPANY INDIA LIMITED",
"ASSAM DOWNTOWN UNIVERSITY",
"ASSAM DYEING PLANTS PRIVATE LIMITED",
"ASSAM EDIBLE OILS PRIVATE LIMITED",
"ASSAM ELECTRICITY GRID CORPORATION LIMITED",
"ASSAM ELECTRO DEVEP CORP LIMITED AMTRON",
"ASSAM ENTRADE LIMITED",
"ASSAM EQUIPMENT & ENERGY SERVICES PRIVATE LIMITED",
"ASSAM GAS COMPANY LTD",
"ASSAM GOLD TEA PVT LTD",
"ASSAM GRAMIN VIKASH BANK",
"ASSAM HIRE PURCHASE COMPANY PRIVATE LIMITED",
"ASSAM HOSPITALS LIMITED",
"ASSAM HYDRO- CARBON & ENERGY COMPANY LIMITED",
"ASSAM IMPORT AGENY LIMITED",
"ASSAM INDUSTRIEL INFUSTRUCTURE DEVELOPMENT CORPORATION",
"ASSAM KERALA ROADWAYS PRIVATE LIMITED",
"ASSAM MOTORS",
"ASSAM NEZONE NETWORK PRIVATE LIMITED",
"ASSAM PETRO CHEMICALS LTD",
"ASSAM PLYWOOD LTD",
"ASSAM POLOI TEA PLANTATION PRIVATE LIMITED",
"ASSAM POWER DISTRIBUTION COMPANY LIMITED",
"ASSAM POWER GENERATION CORPORATION LIMITED",
"ASSAM PROGRESSIVE DEVELOPERS LIMITED",
"ASSAM ROOFING LIMITED",
"ASSAM RURAL INFRASTRUCTURE AND AGRICULTURE SERVICES (ARIAS) SOCIETY",
"ASSAM SAII MOTORS PRIVATE LIMITED",
"ASSAM STATE ELECTRICITY BOARD",
"ASSAM TEA BROKERS PRIVATE LIMITED",
"ASSAM TIMBER PRODUCTS PRIVATE LIMITED",
"ASSAM TRIBUNE PRIVATE LIMITED",
"ASSAM TUBES LIMITED",
"ASSAM VALLEY CEREALS PVT LTD",
"ASSAM VALLEY FINANCE AND INVESTMENTS PVT LTD",
"ASSAM VETY & AGRI UNIVERSITY",
"ASSAR IMPEX PRIVATE LIMITED",
"ASSAYING & AUTHENTICITY ALLIANCE PRIVATE LIMITED",
"ASSCHER ENTERPRISES LIMITED",
"ASSEFA DAIRY DEVELOPMENT FEDERATION",
"ASSEMBLAGE ENTERTAINMENT PRIVATE LIMITED",
"ASSEMBLIT FIXTURES INDIA PRIVATE LIMITED",
"ASSEMBLY OF GOD CHURCH SCHOOL SODEPUR",
"ASSENT LIFETECH PRIVATE LIMITED",
"ASSERTIVE INFRASTRUCTURE PRIVATE LIMITED",
"ASSET ANALYTIX PRIVATE LIMITED",
"ASSET AUTO INDIA PRIVATE LIMITED",
"ASSET BUILDERS PRIVATE LIMITED",
"ASSET CARS PRIVATE LIMITED",
"ASSET COMMUNICATIONS PRIVATE LIMITED",
"ASSET ENGINEERS PRIVATE LIMITED",
"ASSET GURU CONSULTING LLP",
"ASSET HOMES PRIVATE LIMITED",
"ASSET INFOTECH LIMITED",
"ASSET MAX WAREHOUSING PRIVATE LIMITED",
"ASSET ONLINE PRIVATE LIMITED",
"ASSET REALTORS INDIA PRIVATE LIMITED",
"ASSET RECONSTRUCTION COMPANY INDIA LIMITED",
"ASSET SAVVY TECHNOLOGIES (OPC) PRIVATE LIMITED",
"ASSET TELEMATICS PRIVATE LIMITED",
"ASSET TOOLING TECHNOLOGIES PRIVATE LIMITED",
"ASSET VANTAGE SYSTEMS PRIVATE LIMITED",
"ASSETINDIA INFRAPROJECTS PRIVATE LIMITED",
"ASSETMINE CAPITAL PRIVATE LIMITED",
"ASSETRAK SOLUTIONS PRIVATE LIMITED",
"ASSETS CARE & RECONSTRUCTION ENTERPRISE LIMITED",
"ASSETS FINANCE PRIVATE LIMITED",
"ASSETSENSE TECHNOLOGIES PRIVATE LIMITED",
"ASSETZ INFRASTRUCTURE PRIVATE LIMITED",
"ASSETZ INVESTMENTS AND HOLDINGS LLP",
"ASSETZ PREMIER WEALTH ADVISORY PRIVATE LIMITED",
"ASSETZ PREMIUM HOLDINGS PRIVATE LIMITED",
"ASSETZ PROPERTY MANAGEMENT SERVICES PRIVATE LIMITED",
"ASSETZ VALUE HOMES NORTH PRIVATE LIMITED",
"ASSETZ WHITEFIELD HOMES PRIVATE LIMITED",
"ASSH INFOTECH PRIVATE LIMITED",
"ASSIDUOUS CONSULTING PRIVATE LIMITED",
"ASSIDUOUS INDUSTRIES PRIVATE LIMITED",
"ASSIDUUS DISTRIBUTION PRIVATE LIMITED",
"ASSIE CAPITAL PRIVATE LIMITED",
"ASSIGN CONSTRUCTION (INDORE) PRIVATE LIMITED",
"ASSIGNMENTS WEB EDUCATIONAL SERVICES PRIVATE LIMITED",
"ASSIMILATE SOLUTIONS INDIA PRIVATE LIMITED",
"ASSISI GARMENTS PRIVATE LIMITED",
"ASSISI MATRICULATION HIGHER SECONDARY SCHOOL RAMAPURAM",
"ASSISI VISION PRIVATE LIMITED",
"ASSIST AMERICA MEDICAL EMERGENCY SERVICES INDIA PRIVATE LIMITED",
"ASSIST ASIA CONSULTANCY PRIVATE LIMITED",
"ASSIST CLICK PRIVATE LIMITED",
"ASSIST COMM FOR COMMISSIONER FOR TRIBAL DEVELOPMENT M P",
"ASSIST COMMISSIONER OF ANIMAL HUSBANDRY",
"ASSIST DIRECTOR OF AGRICULTURE",
"ASSISTANT AGRICULTURE ENGINEER",
"ASSISTANT COMMISSIONER HANDLOOM BAREILLY",
"ASSISTANT COMMISSIONER OF ANIMAL HUSBANDRY VETERINARY POLYCLINIC",
"ASSISTANT COMMISSIONER OF STATE TAX",
"ASSISTANT COMMISSIONER TRIBAL DEVELOPMENT GWALIOR",
"ASSISTANT COMMISSIONER TRIBAL DEVELOPMENT SEONI",
"ASSISTANT DIRECTOR GOVT STATIONARY DEPOT NAGPUR",
"ASSISTANT DIRECTOR LOCAL FUNDA ACCOUNT AUDIT AURANGABAD",
"ASSISTANT DIRECTOR OF AGRICULTURE(HORTICULTURE) BHOPAL",
"ASSISTANT DIRECTOR OF ARCHSEOLOGY",
"ASSISTANT DIRECTOR OF FISHERIES ANAND",
"ASSISTANT DIRECTOR OFFICE OF REGIONAL DIRECTOR BCAS BHOPAL",
"ASSISTANT DIRECTOR VETERNARY SERVICES",
"ASSISTANT ELIMENTARY EDUCATIONAL OFFICE",
"ASSISTANT GARRISON ENGINEER E/M",
"ASSISTANT OFFICE SUPERINTENDENT",
"ASSISTANT REGISTRAR COOPERATIVE SOCIETIES KADEGAON",
"ASSISTANT SOCIAL CONSERVATION OFFICER",
"ASSISTANT SOIL CONSER OFFICER SUB DIVISION",
"ASSISTANT SOIL CONSERVATION OFFICER",
"ASSISTANZ NETWORKS PRIVATE LIMITED",
"ASSISTIAN PRIVATE LIMITED",
"ASSISTIVE NETWORKS AND TECHNOLOGY",
"ASSITT DIR INFORMATION DD",
"ASSIVINI PAPERS PRIVATE LIMITED",
"ASSIZ & SARAH HEALTHCARE PRIVATE LIMITED",
"ASSMAS CONSTRUCTIONS PRIVATE LIMITED",
"ASSMAT MEDIA PRIVATE LIMITED",
"ASSO PROFESOR",
"ASSOCIATE ALLIED CHEMICALS (INDIA) PRIVATE LIMITED",
"ASSOCIATE BUSINESS SERVICE (INDIA) PRIVATE LIMITED",
"ASSOCIATE CREATIVE BREWERIES & HOSPITALITY PRIVATE LIMITED",
"ASSOCIATE FLEXIWELD PRIVATE LIMITED",
"ASSOCIATED ADVERTISING PRIVATE LIMITED",
"ASSOCIATED ALCOHOLS & BREWERIES LTD",
"ASSOCIATED ALUMINIUM INDUSTRIES PRIVATE LIMITED",
"ASSOCIATED ALUMINIUM PRODUCTS PRIVATE LIMITED",
"ASSOCIATED ARCHITTECTS (INDIA) PRIVATE LIMITED",
"ASSOCIATED AUTO SERVICE PRIVATE LIMITED",
"ASSOCIATED AUTO SOLUTIONS INTERNATIONAL PRIVATE LIMITED",
"ASSOCIATED AUTOMATION PRIVATE LIMITED",
"ASSOCIATED BEARING CO PVT LTD",
"ASSOCIATED BISCUIT COMPANY LIMITED",
"ASSOCIATED BLENDERS PRIVATE LIMITED",
"ASSOCIATED BROADCASTING COMPANY PRIVATE LIMITED",
"ASSOCIATED CABLES PRIVATE LIMITED",
"ASSOCIATED CARGO MOVERS AND PACKERS PRIVATE LIMITED",
"ASSOCIATED CARRYING COMPANY PRIVATE LIMITED",
"ASSOCIATED CERAMICS LTD",
"ASSOCIATED CLINICAL AIDS PRIVATE LIMITED",
"ASSOCIATED COLOURS INDUSTRIES PRIVATE LIMITED",
"ASSOCIATED COMMERCIAL ENTERPRISES",
"ASSOCIATED CONES PVT LTD",
"ASSOCIATED CONSOLIDATION SERVICES PRIVATE LIMITED",
"ASSOCIATED CONTAINER LINE PRIVATE LIMITED",
"ASSOCIATED CONTAINER TERMINALS LIMITED",
"ASSOCIATED CONTEK (MUMBAI) PRIVATE LIMITED",
"ASSOCIATED CORPORATE CONSULTANTS INDIA PRIVATE LIMITED",
"ASSOCIATED DAIRY FAB PRIVATE LIMITED",
"ASSOCIATED DECORATORS AND INTERIORS DESIGNERS PRIVATE LIMITED",
"ASSOCIATED DELTAWAY LOGISTICS PRIVATE LIMITED",
"ASSOCIATED DYESTUFF PRIVATE LIMITED",
"ASSOCIATED ELECTRICAL CONSTRUCTION CO (1963) PVT)LTD",
"ASSOCIATED ELECTRICALS (GZB) PRIVATE LIMITED",
"ASSOCIATED ELECTROCHEMICALS PRIVATE LIMITED",
"ASSOCIATED ELECTRONICS RESEARCH FOUNDATION",
"ASSOCIATED ELEKTRODYNE INDUSTRIES PRIVATE LIMITED",
"ASSOCIATED ENGIFAB COMPANY PRIVATE LIMITED",
"ASSOCIATED ENGINEERS AND INDUSTRIALS PRIVATE LIMITED",
"ASSOCIATED EQUIPMENT RENTALS PRIVATE LIMITED",
"ASSOCIATED ERECTORS PVT LTD",
"ASSOCIATED FILM INDUSTRIES PRIVATE LIMITED",
"ASSOCIATED FINCORP & CHITS (I) PRIVATE LIMITED",
"ASSOCIATED FINECHEM PRIVATE LIMITED",
"ASSOCIATED FLEXIBLES AND WIRES PRIVATE LIMITED",
"ASSOCIATED FORESHORE PIPE LINES PRIVATE LIMITED",
"ASSOCIATED FORMULATIONS PRIVATE LIMITED",
"ASSOCIATED GLOBAL LOGISTICS PRIVATE LIMITED",
"ASSOCIATED HOISTS AND ALLIEDS PRIVATE LIMITED",
"ASSOCIATED HOMECREATORS PRIVATE LIMITED",
"ASSOCIATED HUMAN RESOURCE SERVICE PRIVATE LIMITED",
"ASSOCIATED HYDRO-PRESSINGS PRIVATE LIMITED",
"ASSOCIATED INDIA PRIVATE LIMITED",
"ASSOCIATED INDUSTRIAL ENGINEERINGS PRIVATE LIMITED",
"ASSOCIATED INSULATION COMPANY",
"ASSOCIATED LATEX INDIA LIMITED",
"ASSOCIATED LIMESTONE LIMITED",
"ASSOCIATED MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"ASSOCIATED MANUFACTURING LLP",
"ASSOCIATED MARMO AND GRANITES LIMITED",
"ASSOCIATED MINERALS PVT LTD",
"ASSOCIATED PETRO CHEM PVT LTD",
"ASSOCIATED PLASMATRON PRIVATE LIMITED",
"ASSOCIATED PLATES & VESSELS PRIVATE LIMITED",
"ASSOCIATED POLYTECH INDUSTRIES PRIVATE LIMITED",
"ASSOCIATED POWER STRUCTURES PRIVATE LIMITED",
"ASSOCIATED POWER TECH PRIVATE LIMITED",
"ASSOCIATED PRECISSION TOOLS PRIVATE LIMITED",
"ASSOCIATED PRINTERS & PUBLISHERS (M P) PVT LTD",
"ASSOCIATED PRINTERS (MADRAS) PRIVATE LIMITED",
"ASSOCIATED PUBLISHERS (MADRAS) PRIVATE LIMITED",
"ASSOCIATED RADIOLOGIST DIAGNOSTIC PRIVATE LIMITED",
"ASSOCIATED ROAD CARRIERS LIMITED",
"ASSOCIATED RUBBER CHEMICALS KOCHI PRIVATE LIMITED",
"ASSOCIATED SEARCH PROFESSIONALS PRIVATE LIMITED",
"ASSOCIATED SOAP STONE DISTRIBUTING COMPANY PRIVATE LIMITED",
"ASSOCIATED SOFT MEDICAL SERVICES PRIVATE LIMITED",
"ASSOCIATED STEEL INDUSTRIES",
"ASSOCIATED STONE INDUSTRIES KOTAH LIMITED",
"ASSOCIATED STRUCTURAL ENGINEERS LLP",
"ASSOCIATED SWITCHGEARS AND PROJECTS LIMITED",
"ASSOCIATED TEA & AGRO MANAGEMENT SERVICES PRIVATE LIMITED",
"ASSOCIATED TECHNOCRATS PRIVATE LTD",
"ASSOCIATED THERAPEUTIC CARE PRIVATE LIMITED",
"ASSOCIATED TRANSFORMERS PRIVATE LIMITED",
"ASSOCIATED WOODRUMS MANUFACTURING PRIVATE LIMITED",
"ASSOCIATED WORKS INFRA PRIVATE LIMITED",
"ASSOCIATES E SERVICES",
"ASSOCIATES GROUP SECURITY AND SERVICES PRIVATE LIMITED",
"ASSOCIATES INDIA FINANCIAL SERVICES PRIVATELIMITED",
"ASSOCIATES INFRA DEVELOPERS PRIVATE LIMITED",
"ASSOCIATES NONWOVEN",
"ASSOCIATES WINES PRIVATE LIMITED",
"ASSOCIATION FOR BLINDNESS AND LEPROSY ERADICATION",
"ASSOCIATION FOR NUTRITION AND DEVELOPMENT ACTION",
"ASSOCIATION FOR WELFARE ACTIVE RURAL DEVELOPMENT",
"ASSOCIATION OF INDIAN FORGING INDUSTRY",
"ASSOCIATION OF INDIAN UNVERSITIES",
"ASSOCIATION OF LADY ENTREPRENEURS OF INDIA",
"ASSOCIATION OF MULTIMODAL TRANSPORT OPERATORS OF INDIA",
"ASSOCIATION OF MUTUAL FUNDS IN INDIA",
"ASSOCIATION OF NATIONAL EXCHANGES MEMBERS OF INDIA",
"ASSOCIATION OF REGISTERED INVESTMENT ADVISERS",
"ASSOCIATION OF SPINE SURGEONS OF INDIA",
"ASSOCIATION OF STATE ROAD TRANSPORT UNDERTAKINGS",
"ASSOCIATION OF SYNTHETIC FIBRE INDUSTRY",
"ASSOCIATION URDU BOYS HIGH SCHOOL AND JR. COLLEGEARTS",
"ASSOCIATION URDU GIRLS HIGH SCHOOL",
"ASSOCOM-INDIA PRIVATE LIMITED",
"ASSOMAC MACHINES LIMITED.",
"ASSORT STAFFING SERVICES PRIVATE LIMITED",
"ASSORTED FOOD PACKERS PVT LTD",
"ASSORTED INDUSTRIES PRIVATE LIMITED",
"ASSORTED PLASTICS PRIVATE LIMITED",
"ASSORTED PREDICTED STRATEGY PRIVATE LIMITED",
"ASSOTECH ELECTRONICS PRIVATE LIMITED",
"ASSOTECH MOONSHINE URBAN DEVELOPERS PRIVATE LIMITED",
"ASSOTECH REALTY PRIVATE LIMITED",
"ASSPAY DIGITAL SERVICES PRIVATE LIMITED",
"ASST COMMISNER T W D RTM",
"ASST DIR FOR DIRECTOR PENSION MP",
"ASST DIR RAVINDRA BHAVAN DIRECTORETE OF LANGUAGE BHOPAL",
"ASST DIRECTOR AGRICULTURE",
"ASST DIRECTOR DIRECTORATE OF INDUSTRIES BHOPAL",
"ASST DIRECTOR LABOUR BUREAU CALCUTTA",
"ASST DIRECTOR OF HEALTH SERVICESS LEPROSY PUNE",
"ASST DIRECTOR OF TRANSPORT",
"ASST ELEMENTARY EDN OFFICE",
"ASST ENG P W SUB-DIVISION NO LI LATUR",
"ASST SOIL CON OFFICER R V P RATL",
"ASST SURGEN FOR C M O(G R)BHOPAL MADHYA PRADESH",
"ASSTON PHARMACEUTICALS PRIVATE LIMITED",
"ASSTT AGRICULTURE ENGINEER SEHORE MADHYA PRADESH",
"ASSTT CHIEF ACOUNTS OFFICER KOLKATA NORTH HEADQUARTERS",
"ASSTT COMM OF A H TALUKA MINI VETY POLY JAYSINGPUR",
"ASSTT COMM TRI DEV HBAD HOSHANGABAD",
"ASSTT COMMISSIONER COMMERCIAL TAX BPL BHOPAL",
"ASSTT COMMISSIONER OF COMMERCIAL TAX UNIT 25 KALOL",
"ASSTT COMMR ADIWASI VIKAS CWA",
"ASSTT DEV COMMISSONER JANPAD PANCHAYAT GOGANWA",
"ASSTT DGFT FOREIGN TRADE DEVELOPMENT OFFICER",
"ASSTT DIR FOR JD FARMER AGRIL DEV BPL MADHYA PRADESH",
"ASSTT DIRECTOR DERECTORATE OF INDUSTRIES BHOPAL",
"ASSTT DIRECTOR FOR COMMISSIONER COLLEGIATE EDU BHOPAL",
"ASSTT DIRECTOR NATIONAL SAMPLE SURVEY ORGANISATION FIELD OPERATION DIVISION MP",
"ASSTT EXCISR COMMISSIONER FIROZABAD",
"ASSTT REGISTRAR FIRMS SOCITIES CHITS BAREILLY",
"ASSTT RESEARCH OFFICER FOR DIRECTOR SCHEDULE CAST DEV BHOPAL",
"ASSTT SOIL CONSERVATION OFFICER",
"ASSTT SOIL OFFICER BARI MADHYA PRADESH",
"ASSTT SURGEON OF VETERINARY SERVICES (R E S) UJJAIN",
"ASSTT. DIRECTOR FISHRIES",
"ASSTT.REGISTRAR ITAT AHMEDABAD",
"ASSURACARE HEALTHCARE PRIVATE LIMITED",
"ASSURANCE INTL LIMITED",
"ASSURANCE METALLOYD EXIM PRIVATE LIMITED",
"ASSURANT AUTOMOTIVE WARRANTY SOLUTIONS INDIA PRIVATE LIMITED",
"ASSURANT, INC.",
"ASSURCED ELECTRICALS PRIVATE LIMITED",
"ASSURE CONSULTANCY SERVICES",
"ASSURE FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"ASSURE FINANCIAL SERVICES PRIVATE LIMITED",
"ASSURE GALAXY INDORE PRIVATE LIMITED",
"ASSURE INFRAENGINEERING PRIVATE LIMITED",
"ASSURE LIFE SCIENCE PRIVATE LIMITED",
"ASSURE SURGILAB PRIVATE LIMITED",
"ASSURECARE HEALTHTECH LLP",
"ASSURED & PROTECTIVE INDIA PRIVATE LIMITED",
"ASSURED ADVERTISING AND MEDIA PRIVATE LIMITED",
"ASSURED BEST CARE HOSPITAL PRIVATE LIMITED",
"ASSURED CONSOLIDATED CONSTRUCTION PRIVATE LIMITED",
"ASSURED FOREX PRIVATE LIMITED",
"ASSURED HOSPITALITY SERVICES PRIVATE LIMITED",
"ASSURED WORKS PRIVATE LIMITED",
"ASSURETECH BUSINESS SOLUTIONS PRIVATE LIMITED",
"ASSURGEN PHARMA PRIVATE LIMITED",
"ASSYST INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"ASSYST INTERNATIONAL PRIVATE LIMITED",
"ASSYSTEM INDIA PRIVATE LIMITED",
"ASSYSTEM TECHNOLOGIES INDIA PRIVATE LIMITED",
"AST CONSTRUCTIONS PRIVATE LIMITED",
"AST CONSULTANCY SERVICES PRIVATE LIMITED",
"AST TELECOM SOLAR PRIVATE LIMITED",
"AST WATERPROOFING PRIVATE LIMITED",
"ASTA BIOCHEMICALS PRIVATE LIMITED",
"ASTA CERAMIC PRIVATE LIMITED",
"ASTA CRS PRIVATE LIMITED",
"ASTA FILES PRIVATE LIMITED",
"ASTA INDIA PRIVATE LIMITED",
"ASTA VISIONCARE PRIVATE LIMITED",
"ASTAGURU AUCTION HOUSE PRIVATE LIMITED",
"ASTAL INTERBUILD PRIVATE LIMITED",
"ASTALAKSHMI LOYYAL POWER TECH PRIVATE LIMITED",
"ASTALAXMI FABRICS PRIVATE LIMITED",
"ASTALYNX GLOBAL SOLUTIONS PRIVATE LIMITED",
"ASTAM DIAGNOSTICS PRIVATE LIMITED",
"ASTAM HEALTHCARE PRIVATE. LIMITED.",
"ASTAMED HEALTHCARE INDIA PRIVATE LIMITED",
"ASTAQC CONSULTING (OPC) PRIVATE LIMITED",
"ASTAR DATA LLP",
"A-STAR LOGISTICS (INDIA) PRIVATE LIMITED",
"ASTAR MARKETING PRIVATE LIMITED",
"ASTAR MOBILES PRIVATE LIMITED",
"ASTAR NET SOLUTIONS",
"ASTAR REALCON INFRA PRIVATE LIMITED",
"ASTAR ULTRA MODERN PACKING PRIVATE LIMITED",
"ASTARC AGRO AND FOODS PRIVATE LIMITED",
"ASTARC ENTERPRISES PRIVATE LIMITED",
"ASTARC INFRASTRUCTURE PRIVATE LIMITED",
"ASTAREAL (INDIA) PRIVATE LIMITED",
"ASTAVINAYAK TEA COMPANY PRIVATE LIMITED",
"ASTDURGA CONSTRUCTION PRIVATE LIMITED",
"ASTDURGA FOOD & BEVERAGES PRIVATE LIMITED",
"ASTE ENTERPRISES PRIVATE LIMITED",
"ASTEAM TECHNO SOLUTIONS PRIVATE LIMITED",
"ASTEC CROP CARE PRIVATE LIMITED",
"ASTEC LIFESCIENCES LIMITED",
"ASTEC VALVES & FITTINGS PRIVATE LIMITED",
"ASTECH COMPUPOWER PRIVATE LIMITED",
"ASTECH MARKETING PRIVATE LIMITED",
"ASTECH SYSTEMS PRIVATE LIMITED",
"ASTEGIC INFOSOFT PRIVATE LIMITED",
"ASTEK ELECTRIC COMPANY PRIVATE LIMITED",
"ASTEK ELECTRICALS INDIA PRIVATE LIMITED",
"ASTELLAR TECHNOLOGIES PRIVATE LIMITED",
"ASTELLAS PHARMA INDIA PRIVATE LIMITED",
"ASTEMAX BIOTECH PRIVATE LIMITED",
"ASTEN ORTHO PRIVATE LIMITED",
"ASTEN REALTORS PRIVATE LIMITED",
"ASTER AUTOCRAFTS PRIVATE LIMITED",
"ASTER BUSINESS RESEARCH PRIVATE LIMITED",
"ASTER CARGO PRIVATE LIMITED",
"ASTER CLINICAL LAB LLP",
"ASTER CMI HOSPITAL",
"ASTER DM HEALTHCARE LIMITED",
"ASTER DM HEALTHCARE PRIVATE LIMITED",
"ASTER GLOBAL SOLUTIONS PRIVATE LIMITED",
"ASTER HOSPITALS PRIVATE LIMITED",
"ASTER INFRAHOME PRIVATE LIMITED",
"ASTER INFRATEK PRIVATE LIMITED",
"ASTER INSTITUTIONS ASTER PUBLIC SCHOOL",
"ASTER MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"ASTER MEDICINES PRIVATE LIMITED",
"ASTER MEDISPRO PRIVATE LIMITED",
"ASTER MINDS ENTERPRISE SOLUTIONS PRIVATE LIMITED",
"ASTER NETWORKS PRIVATE LIMITED",
"ASTER PHARMACEUTICALS",
"ASTER PRECITUBES PRIVATE LIMITED",
"ASTER PROMOTERS AND DEVELOPERS PRIVATE LIMITED",
"ASTER SPACE TECHNOLOGIES PRIVATE LIMITED",
"ASTER TECHNOLOGIES PRIVATE LIMITED",
"ASTER TOWERS PRIVATE LIMITED",
"ASTER TRAVEL AND HOSPITALITY SERVICES PRIVATE LIMITED",
"ASTER VINIMAY PRIVATE LIMITED",
"ASTER WAYANAD SPECIALITY HOSPITAL",
"ASTERBYTE SOFTWARE SYSTEMS PRIVATE LIMITED",
"ASTERIA AEROSPACE LIMITED",
"ASTERIA REAL ESTATES PRIVATE LIMITED",
"ASTERIMA NUTRICARE PRIVATE LIMITED",
"ASTERIMA PHARMACEUTICALS PRIVATE LIMITED",
"ASTERISK CHEMICALS PRIVATE LIMITED",
"ASTERISK ELECTRONICS PRIVATE LIMITED",
"ASTERISK INDUSTRIES PRIVATE LIMITED",
"ASTERISK LABORATORIES INDIA PRIVATE LIMITED",
"ASTERISK MEDIA INDIA PRIVATE LIMITED",
"ASTERITE PRIVATE LIMITED",
"ASTERIX ENERGY PRIVATE LIMITED",
"ASTERIX INFOTECH PRIVATE LIMITED",
"ASTERN EXPORTS PRIVATE LIMITED",
"ASTERN SHIPPING & LOGISTICS PRIVATE LIMITED",
"ASTEROID INNOVATIONS INDIA PRIVATE LIMITED",
"ASTEROID INTERNATIONAL PRIVATE LIMITED",
"ASTEROID MICRONS PRIVATE LIMITED",
"ASTEROID SHELTERS HOMES PRIVATE LIMITED",
"ASTEROIDS HEALTHCARE PRIVATE LIMITED",
"ASTEROIDS TRADING AND INVESTMENTS PRIVATE LIMITED",
"ASTER-PRIME HOSPITALS",
"ASTHA BEEJ CO.PRIVATE LIMITED",
"ASTHA CEMENT PRIVATE LIMITED",
"ASTHA CREATIONS PRIVATE LIMITED",
"ASTHA CREDIT & SECURITIES PRIVATE LIMITED",
"ASTHA DEPARTMENTAL STORES PRIVATE LIMITED",
"ASTHA FERRO ALLOYS PRIVATE LIMITED",
"ASTHA FERROTECH PRIVATE LIMITED",
"ASTHA FINVEST LIMITED",
"ASTHA HOMES PRIVATE LIMITED",
"ASTHA INDUSTRIES PRIVATE LIMITED",
"ASTHA INFRA ENGG INDIA PRIVATE LIMITED",
"ASTHA INFRAHEIGHTS PRIVATE LIMITED",
"ASTHA INNOVATIONS PRIVATE LIMITED",
"ASTHA INSURANCE SERVICES PRIVATE LIMITED",
"ASTHA PACKAGING PRIVATE LIMITED",
"ASTHA POLYMERS PRIVATE LIMITED",
"ASTHA POWER CORPORATION PRIVATE LIMITED",
"ASTHA SANITATION MARKETING PRIVATE LIMITED",
"ASTHALAKSHMI AGROTECH PRIVATE LIMITED",
"ASTHANA AGRI GENETICS PRIVATE LIMITED",
"ASTHANA BUILDERS LIMITED",
"ASTHANA RURAL DEVELOPMENT & SERVICES PRIVATE LIMITED",
"ASTHAVINAYAK INDUSTRIES PRIVATE LIMITED",
"ASTHAVINAYAK MOTORS PRIVATE LIMITED",
"ASTHAVINAYAK POLYSACKS PRIVATE LIMITED",
"ASTHIKYA ENTERPRISES PRIVATE LIMITED",
"ASTHRA TECHNOLOGIES PRIVATE LIMITED",
"ASTHVINAYAK HEALTHCARE LIMITED",
"ASTI ELECTRONICS INDIA PRIVATE LIMITED",
"ASTICS TECHLABS PRIVATE LIMITED",
"ASTIK (INDIA) PRIVATE LIMITED",
"ASTIK DYESTUFF PRIVATE. LIMITED.",
"ASTIK SUPPLIERS PRIVATE LIMITED",
"ASTIKA SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"ASTILA CERAMIC PRIVATE LIMITED",
"ASTIN TRADELINK PRIVATE LIMITED",
"ASTIR AGRI CHEM PRIVATE LIMITED",
"ASTIR INDIA PRIVATE LIMITED",
"ASTIR IT SOLUTIONS PRIVATE LIMITED",
"ASTIR N LEAP E EXPERTS PRIVATE LIMITED",
"ASTIR SALES PRIVATE LIMITED",
"ASTIRO INFORMATION SYSTEMS PRIVATE LIMITED",
"ASTITV INTERIOR SOLUTIONS LLP",
"ASTITVA CREATIONS PRIVATE LIMITED",
"ASTITVA MUKBADHIR PRABODHINI",
"ASTIX INFOLYTICS PRIVATE LIMITED",
"ASTLAXMI RE-ROLLS JALNA PRIVATE LIMITED",
"ASTM SKILLS PRIVATE LIMITED",
"ASTMANGAL CHAINS PRIVATE LIMITED",
"ASTOL CLEANTECH PRIVATE LIMITED",
"ASTON AGRITECH PRIVATE LIMITED",
"ASTON CERAMIC",
"ASTON GREENS PRIVATE LIMITED",
"ASTON INDIA PRIVATE LIMITED",
"ASTON MULTITRADE PRIVATE LIMITED",
"ASTON PROCESSORS LIMITED",
"ASTON SHOES PRIVATE LIMITED",
"ASTON STEEL PRIVATE LIMITED",
"ASTONEA LABS LIMITED",
"ASTONFIELD SOLAR (RAJASTHAN II) PRIVATE LIMITED",
"ASTONFIELD SOLAR (RAJASTHAN) PRIVATE LIMITED",
"ASTOR CORPORATION PRIVATE LIMITED",
"ASTORIA DECORS & EXPORTS PRIVATE LIMITED",
"ASTORIA HOTEL",
"ASTORIA NIDHI LIMITED",
"ASTORIA SOFTWARE EXPORTS PRIVATE LIMITED",
"ASTORIA TECHNOLOGIES I PRIVATE LIMITED",
"ASTORMUELLER SHOES PRIVATE LIMITED",
"ASTOUND COMMERCE INDIA PRIVATE LIMITED",
"ASTRA AGRITECH PRIVATE LIMITED",
"ASTRA AGRO FOODS PRIVATE LIMITED",
"ASTRA BIOSCIENCE LIMITED",
"ASTRA BUILDING MATERIALS PRIVATE LIMITED",
"ASTRA BUSINESS SERVICES PRIVATE LIMITED",
"ASTRA CHEMTECH PRIVATE LIMITED",
"ASTRA COATINGS LIMITED",
"ASTRA DAIRY FARMS PRIVATE LIMITED",
"ASTRA FASHIONS PRIVATE LIMITED",
"ASTRA FLAVOURS AND FRAGRANCES PRIVATE LIMITED",
"ASTRA GEN-INDIA PRIVATE LIMITED",
"ASTRA INDUSTRIES AND TRADING PRIVATE LIMITED",
"ASTRA INNOVATIONS INDIA PRIVATE LIMITED",
"ASTRA LASER TECH PRIVATE LIMITED",
"ASTRA LIFECARE INDIA PRIVATE. LIMITED.",
"ASTRA MANAGEMENT SERVICES PRIVATE LIMITED",
"ASTRA METAL SYSTEMS PRIVATE LIMITED",
"ASTRA MICROWAVE PRODUCTS LIMITED",
"ASTRA ORTHO N SPINE CENTER PRIVATE LIMITED",
"ASTRA RAFAEL COMSYS PRIVATE LIMITED",
"ASTRA ROCKS AND MINERALS PRIVATE LIMITED",
"ASTRA SOLREN PRIVATE LIMITED",
"ASTRA SPECIALTY COMPOUNDS INDIA PRIVATE LIMITED",
"ASTRA SUPER SPECIALITY HOSPITAL",
"ASTRA SYSTEMS PRIVATE LIMITED",
"ASTRA UNIQUE PROHEALTH PRIVATE LIMITED",
"ASTRA-ASL LOGISOLUTIONS PRIVATE LIMITED",
"ASTRAAZIN PHARMACEUTICALS PRIVATE LIMITED",
"ASTRAEA LIFE SCIENCES PRIVATE LIMITED",
"ASTRAES ENGINEERING PRIVATE LIMITED",
"ASTRAGEN INDIA PRIVATE LIMITED",
"ASTRAGEN LABORATORIES PRIVATE LIMITED",
"ASTRAL ADVERTISING AND MARKETING INDIA PRIVATE LIMITED",
"ASTRAL AUTO PARTS PRIVATE LIMITED",
"ASTRAL BUSINESS CONSULTING LLP",
"ASTRAL CONSULTING LIMITED",
"ASTRAL FLAVOURS PRIVATE LIMITED",
"ASTRAL FOUNDATION",
"ASTRAL INDIA PRIVATE LIMITED",
"ASTRAL INFORMATICS PRIVATE LIMITED",
"ASTRAL INTERNATIONAL PRIVATE LIMITED",
"ASTRAL KNOWLEDGE SERVICES PRIVATE LIMITED",
"ASTRAL LIMITED",
"ASTRAL STERITECH PRIVATE LIMITED",
"ASTRAL TRADELINK PRIVATE LIMITED",
"ASTRAL TRAVELS PRIVATE LIMITED",
"ASTRAL WINDOORS PRIVATE LIMITED",
"ASTRALEUS SERVICES PRIVATE LIMITED",
"ASTRALIS PHARMACY PRIVATE LIMITED",
"ASTRAMEDIX LIFESCIENCES PRIVATE LIMITED",
"ASTRANOVA BIOTECH PRIVATE LIMITED",
"ASTRANTIA TECHNOLOGY SERVICES PRIVATE LIMITED",
"ASTRAPIA UPVC TECH PRIVATE LIMITED",
"ASTRAVIEW CLOTHINGS PRIVATE LIMITED",
"ASTRAZENECA INDIA PRIVATE LIMITED",
"ASTRAZENECA PHARMA INDIA LIMITED",
"ASTRAZURE LEGAL SERVICES PRIVATE LIMITED",
"ASTREA IT SERVICES PRIVATE LIMITED",
"ASTREYA CONSULTANCY INDIA PRIVATE LIMITED",
"ASTRI SALES AND SERVICES PRIVATE LIMITED",
"ASTRIC COMPUTERS (INDIA) PRIVATE LIMITED",
"ASTRICA LABORATORIES PRIVATE LIMITED",
"ASTRIKA INFOTECH PRIVATE LIMITED",
"ASTRIKOS CONSULTING PRIVATE LIMITED",
"ASTRIN TRADERS AND SUPPLIES PRIVATE LIMITED",
"ASTRIOL INDIA PRIVATE LIMITED",
"ASTRIX DEVELOPERS PRIVATE LIMITED",
"ASTRIX PROPERTIES PRIVATE LIMITED",
"ASTRIYA SOLUTIONS PRIVATE LIMITED",
"ASTRO FREIGHT AND LOGISTICS PRIVATE LIMITED",
"ASTRO INDIA AUTOMOBILE PRIVATE LIMITED",
"ASTRO INSURANCE BROKERS LIMITED",
"ASTRO JEWELS PRIVATE LIMITED",
"ASTRO METALLURGICAL (INDIA) PVT LTD",
"ASTRO OPTICS PRIVATE LIMITED",
"ASTRO SCIENCE CLINIC PRIVATE LIMITED",
"ASTRO SECURITY SERVICES PRIVATE LIMITED",
"ASTRO SPORTS PRIVATE LIMITED",
"ASTRO STEELS PRIVATE LIMITED",
"ASTRO VISION FUTURETECH PRIVATE LIMITED",
"ASTROFORME INDIA PRIVATE LIMITED",
"ASTROL TOURS & TRAVELS PRIVATE LIMITED",
"ASTROM VENTURES PRIVATE LIMITED",
"ASTRON E SERVICES PRIVATE LIMITED",
"ASTRON ENGINEERS (INDIA) PRIVATE LIMITED",
"ASTRON HOSPITAL AND HEALTHCARE CONSULTANTS PRIVATE LIMITED",
"ASTRON INTERNATIONAL PRIVATE LIMITED",
"ASTRON MULTIGRAIN LIMITED",
"ASTRON PACKAGING LIMITED",
"ASTRON PAPER & BOARD MILL LIMITED",
"ASTRON PAPER AND BOARD MILL LIMITED",
"ASTRON PHARMACEUTICALS PRIVATE LIMITED",
"ASTRON POLYMERS PRIVATE LIMITED",
"ASTRON PUMPS & EQUIPMENTS PRIVATE LIMITED",
"ASTRON TOURS AND TRAVELS PRIVATE LIMITED",
"ASTRON TRADING PRIVATE LIMITED",
"ASTRON ZIRCON PRIVATE LIMITED",
"ASTRONICS TECHNOLOGY INDIA PRIVATE LIMITED",
"ASTRONOMICAL LOGISTICS PARK PRIVATE LIMITED",
"ASTRONWIZARDS INFOSERVICES PRIVATE LIMITED",
"ASTROPHYSICS INDIA PRIVATE LIMITED",
"ASTROTALK",
"ASTROTECH EQUIPMENTS PRIVATE LIMITED",
"ASTROTECH STEELS PRIVATE. LIMITED.",
"ASTROTEL PRIVATE LIMITED",
"ASTROVED COM PRIVATE LIMITED",
"ASTRUM CHEMICALS PRIVATE LIMITED",
"ASTRUM DEVELOPMENTS PRIVATE LIMITED",
"ASTRUM ELECTRONICS INDIA PRIVATE LIMITED",
"ASTRUM HEALTHCARE PRIVATE LIMITED",
"ASTRUM INDIA TRADE PRIVATE LIMITED",
"ASTRUM PETRO ADDITIONS PRIVATE LIMITED",
"ASTRUM STAMPING PRIVATE LIMITED",
"ASTRUM TRADING PRIVATE LIMITED",
"ASTRUM VALUE HOMES PRIVATE LIMITED",
"ASTRUS RETAIL SOLUTIONS PRIVATE LIMITED",
"ASTS DEVELOPMENT PRIVATE LIMITED",
"ASTT COMMINISNER T W T RATLAM",
"ASTT COMMISSIONER EXCISE BHOPAL",
"ASTT COMMISSIONER TRIBEL WELFARE KHANDWA",
"ASTT ELECTRICAL INSPECTOR DEWAS MADHYA PRADESH",
"ASTTECS COMMUNICATIONS PRIVATE LIMITED",
"ASTUN TECHNOLOGIES PRIVATE LIMITED",
"ASTUS HYBRID SEEDS PRIVATE LIMITED",
"ASTUTE ACADEMY PRIVATE LIMITED",
"ASTUTE CONSULTING PRIVATE LIMITED",
"ASTUTE CORPORATE SERVICES PRIVATE LIMITED",
"ASTUTE ENGINEERING SERVICES PRIVATE LIMITED",
"ASTUTE INFRASTRUCTURE PRIVATE LIMITED",
"ASTUTE INSURANCE SURVEYORS & LOSS ASSESSORS PRIVATE LIMITED",
"ASTUTE MANAGEMENT SOLUTIONS & SERVICES PRIVATE LIMITED",
"ASTUTE OUTSOURCING SERVICES PRIVATE LIMITED",
"ASTUTE REMEDIAL SERVICES I PRIVATE LIMITED",
"ASTUTE TECHNOLOGY PRIVATE LIMITED",
"ASTUTE VALUERS & CONSULTANTS PRIVATE LIMITED",
"ASTUTECH SOLUTIONS INDIA PRIVATE LIMITED",
"ASTUTIX LEARNING PRIVATE LIMITED",
"ASTUTRIX TECHNOLOGIES PRIVATE LIMITED",
"ASUKU INDIA PRIVATE LIMITED",
"ASUMAN NUTRITECH AGRO PRIVATE LIMITED",
"ASUN SOLAR POWER PRIVATE LIMITED",
"ASUN TRACKERS PRIVATE LIMITED",
"ASUNITE TRADERS PRIVATE LIMITED",
"ASURE MANPOWER SERVICES",
"ASUS INDIA. PRIVATE. LIMITED",
"ASUS TECHNOLOGY PRIVATE LIMITED",
"ASUTOSH COLLEGE",
"ASUTOSH ENTERPRISES LTD",
"ASV CONSTRUCTIONS PRIVATE LIMITED",
"ASV ENGINEERING ASSEMBLIES PRIVATE LIMITED",
"ASV ENGINEERS PRIVATE LIMITED",
"ASV INFOTECH PRIVATE LIMITED",
"ASV MANAGEMENT SERVICES PRIVATE LIMITED",
"ASV MULTICHEMIE PRIVATE LIMITED",
"ASV PAPERS PRIVATE LIMITED",
"ASVA COOL SOLUTIONS PRIVATE LIMITED",
"ASVA POWER SYSTEMS INDIA PRIVATE LIMITED",
"ASVASIDH NOVATEUR DEVELOPERS PRIVATE LIMITED",
"ASVIK PHARMA AND CHEMICALS PRIVATE LIMITED",
"ASVIN DIAGNOSTICS PRIVATE LIMITED",
"ASVINI FISHERIES PRIVATE LIMITED",
"ASVINS LIFETECHNOLOGIES PRIVATE LIMITED",
"ASW PROJECTS PRIVATE LIMITED",
"ASWAD SEA FOODS PRIVATE LIMITED",
"ASWANI INDUSTRIES PRIVATE LIMITED",
"ASWARTHA CONDITION MONITORING ENGINEERS PRIVATE LIMITED",
"ASWATH WEAVING PRIVATE LIMITED",
"ASWATHA SPINTEX INDIA PRIVATE LIMITED",
"ASWATHANARAYANA & ESWARA PROJECTS & CONSULTANCY LLP",
"ASWATHI HOSIERIES PRIVATE LIMITED",
"ASWATHI INDUSTRIES LIMITED",
"ASWATHI PACKAGING PRIVATE LIMITED",
"ASWATHY CONSTRUCTIONS",
"ASWATHY GRANITES PRIVATE LIMITED",
"ASWATI INNS PRIVATE LIMITED",
"ASWERA INTERNATIONAL MARKETING PRIVATE LIMITED",
"ASWIN COLD FORGE PRIVATE LIMITED",
"ASWIN FIRE SYSTEM PRIVATE LIMITED",
"ASWIN FOUNDATIONS PRIVATE LIMITED",
"ASWIN POLY CLINIC PRIVATE LIMITED",
"ASWINI AGRO TECH PRIVATE LIMITED",
"ASWINI HEALTH SPECIALITIES (INDIA) PRIVATE LIMITED",
"ASWINI HOMEO AND AYURVEDIC PRODUCTS PRIVATE LIMITED",
"ASWINI HOSPITAL LIMITED",
"ASWINI INTEGRATED TECHNOLOGIES INDIA PRIVATE LIMITED",
"ASWINI TRADERS PRIVATE LIMITED",
"ASWINIPALLY HIGH SCHOOL",
"ASYMMETRIC ENTERTAINMENT PRIVATE LIMITED",
"ASYMMETRIQUE COMMUNICATIONS PRIVATE LIMITED",
"ASYNC SYSTEMS PRIVATE LIMITED",
"ASYSTEMS PRIVATE LIMITED",
"ASZ TECHNOLOGIES PRIVATE LIMITED",
"ASZROH TECHNOLOGIES PRIVATE LIMITED",
"AT & S INDIA PRIVATE LIMITED",
"AT & T COMMUNICATION SERVICES INDIA PRIVATE LIMITED",
"AT & T GLOBAL BUSINESS SERVICES INDIA PRIVATE LIMITED",
"AT AND T ENGINEERS PRIVATE LIMITED",
"AT ASSOCIATES PRIVATE LIMITED",
"AT AZAAD RECORDINGS PRIVATE LIMITED",
"AT BIZ INFRA PRIVATE LIMITED",
"AT BROADBAND PRIVATE LIMITED",
"AT HOME INDIA PRIVATE LIMITED",
"AT INDIA AUTO PARTS PRIVATE LIMITED",
"AT PLUS JEWELLERS PRIVATE LIMITED",
"AT TECHNOLEGAL COMBINE PRIVATE. LIMITED",
"AT YOUR DOORSTEP SERVICES PRIVATE LIMITED",
"AT&T GLOBAL NETWORK SERVICES",
"ATA AGRO COMMODITIES LIMITED",
"ATA BUSINESS VENTURES PRIVATE LIMITED",
"ATA FREIGHT LINE INDIA PRIVATE LIMITED",
"ATA IMPEX PRIVATE LIMITED",
"ATA INDIA RECRUITMENT PRIVATE LIMITED",
"ATA SHANKAR APPARELS PRIVATE LIMITED",
"ATA TECH SOLUTIONS PRIVATE LIMITED",
"ATAGO INDIA INSTRUMENTS PRIVATE LIMITED",
"ATAI FILTERS PVT LTD",
"ATAK INDIA SALES (OPC) PRIVATE LIMITED",
"ATAL BIHARI VAJPAYEE INSTITUTE OF GOOD GOVERNANCE AND POLICY ANALYSIS",
"ATAL HOUSE AND ENGG. WORKS PRIVATE LIMITED",
"ATAL REALTECH LIMITED",
"ATALANTA PUMPS PRIVATE LIMITED",
"ATAM APPARELS PRIVATE LIMITED",
"ATAM ASSOCIATES PRIVATE LIMITED",
"ATAM CONCAST STEELS PVT LTD",
"ATAM DEVKI NIKETAN SEN SEC PUBLIC SCHOOL",
"ATAM GRAPHICS PRIVATE LIMITED",
"ATAM MACHINES PRIVATE LIMITED",
"ATAM MANOHAR SHIP BREAKERS PRIVATE. LIMITED.",
"ATAM ROOP CLOTHINGS PRIVATE LIMITED",
"ATAM TEXTILES PRIVATE LIMITED",
"ATAM VALLABH TUBES PRIVATE LIMITED",
"ATAM VALVES LIMITED",
"ATAM WOOLLEN MILLS PVT LTD",
"ATAMBHU BUILDWELL PRIVATE LIMITED",
"ATAMPRAKASH MULKHRAJ ELECTRONICS PVT LTD",
"ATANDRA ENERGY PRIVATE LIMITED",
"ATARA HOSPITALITY PRIVATE LIMITED",
"ATARASHI DENKA BIJON POWER SYSTEM INDIA PRIVATE LIMITED",
"ATARAXIA PHARMA PRIVATE LIMITED",
"ATARI INFORMATICS LIMITED",
"ATARW TECHNOLOGIES PRIVATE LIMITED",
"ATASEE FIRE INDUSTRIES PRIVATE LIMITED",
"ATBAAN INFRATECH PRIVATE LIMITED",
"ATBS TRADING AND BUSINESS SOLUTION PRIVATE LIMITED",
"ATC CABLES PRIVATE LIMITED",
"ATC CHEMICALS INDIA PRIVATE LIMITED",
"ATC CROP CARE PRIVATE LIMITED",
"ATC CSR FOUNDATION INDIA",
"ATC ELECTRICALS PRIVATE LIMITED",
"ATC ENERGIES SYSTEM PRIVATE LIMITED",
"ATC ENGINEERING SYSTEMS PRIVATE LIMITED",
"ATC ENTERTAINMENT PRIVATE LIMITED",
"ATC FOODS PRIVATE LIMITED",
"ATC GLOBAL LOGISTICS PRIVATE LIMITED",
"ATC INDIA ELECTRONICS PRIVATE LIMITED",
"ATC INDIA INFRASTRUCTURE PRIVATE LIMITED",
"ATC INDIA TOWER CORPORATION PRIVATE LIMITED",
"ATC LIMITED",
"ATC LOGISTICAL SOLUTIONS PRIVATE LIMITED",
"ATC LOGISTICS PRIVATE LIMITED",
"ATC PAINTS PRIVATE LIMITED",
"ATC PHARMA PRIVATE LIMITED",
"ATC PRECISION COMPONENTS PRIVATE LIMITED",
"ATC PROPERTY MAINTENANCE PRIVATE LIMITED",
"ATC SOFTWAY SOLUTIONS PRIVATE LIMITED",
"ATC TELECOM INFRASTRUCTURE PRIVATE LIMITED",
"ATC TELECOM TOWER CORPORATION PRIVATE LIMITED",
"ATC TIRES PRIVATE LIMITED",
"ATC TOOLS PRIVATE LIMITED",
"ATC TOWER COMPANY OF INDIA PRIVATE LIMITED",
"ATC TRADE CO-ORDINATOR PRIVATE LIMITED",
"ATC WAREHOUSING & LOGISTICS PRIVATE LIMITED",
"ATC9 STEELS LIMITED",
"ATCHUTA LABORATORIES PRIVATE LIMITED",
"ATCL LOGISTICS (INDIA) PRIVATE LIMITED",
"ATCO CONTROLS (INDIA) PRIVATE LIMITED",
"ATCO FLEXDUCT PRIVATE LIMITED",
"ATCO INTERIORS PRIVATE LIMITED",
"ATCO PROJECTS PRIVATE LIMITED",
"ATCO TEA COMPANY PRIVATE LIMITED",
"ATCO TOWERS PRIVATE LIMITED",
"ATCON INDIA LIMITED",
"ATCORP GLOBAL PRIVATE LIMITED",
"ATCOST TECHNOLOGY AND SERVICES PRIVATE LIMITED",
"ATD ANALYSIS PRIVATE LIMITED",
"ATDRIVE INFOTECH PRIVATE LIMITED",
"ATE ENVIROTECH PRIVATE LIMITED",
"ATE POWER CONNECTIONS PRIVATE LIMITED",
"ATE WELDING ENGINEERING ROBOTICS AND AUTOMATION PRIVATE LIMITED",
"ATEASE FASHIONS PRIVATE LIMITED",
"ATECH NETWORK SYSTEMS PRIVATE LIMITED",
"A-TECH PNEUMATICS PRIVATE LIMITED",
"ATECH SOLUTIONS PRIVATE LIMITED",
"ATECHNOCRAT WEB SOLUTIONS PRIVATE LIMITED",
"ATELI NARNAUL HIGHWAY PRIVATE LIMITED",
"ATELIER BRUNETTE INDIA PRIVATE LIMITED",
"ATELIER D'ARTS AND ARCHITECTURE PRIVATE LIMITED",
"ATELIER INSTITUTIONS LLP",
"ATELIER PRIVATE LIMITED",
"ATELIERS GLASSEX PRIVATE LIMITED",
"ATEN ADVANCE PRIVATE LIMITED",
"ATEN CAPITAL PRIVATE LIMITED",
"ATEN PAPERS & FOAM PRIVATE LIMITED",
"ATEN PORUS LIFESCIENCES PRIVATE LIMITED",
"ATEN RETAIL MV LIMITED",
"ATENTI ORIGINS PHOTOELECTRICITY CONSORT PRIVATE LIMITED",
"ATEQ SYSTEMS ANALYTIC INDIA PRIVATE LIMITED",
"TRIMCO GROUP (DELHI) PRIVATE LIMITED",
"ATEX OVERSEAS PVT LTD",
"ATEX TEXTILE PRIVATE LIMITED",
"ATFC ADITYATECHNO FAB PRIVATE LIMITED",
"ATFEM KHETIGAADI PRIVATE LIMITED",
"ATG BUSINESS SOLUTIONS PRIVATE LIMITED",
"ATG STEEL STRUCTURES PRIVATE LIMITED",
"ATGC BIOTECH PRIVATE LIMITED",
"ATH HOSPITAL",
"ATH SUPPORT SERVICES PRIVATE LIMITED",
"ATHAANG DEVANAHALLI TOLLWAY PRIVATE LIMITED",
"ATHAANG JAMMU UDHAMPUR HIGHWAY PRIVATE LIMITED",
"ATHAAYU MULTISPECIALITY HOSPITALS LIMITED",
"ATHANI COMPOSITE PU COLLEGE",
"ATHANI SUGARS LIMITED",
"ATHARAV INDUSTRIES PRIVATE LIMITED",
"ATHARAV PREMIUM GRAINS PRIVATE LIMITED",
"ATHARSHI RETAILS PRIVATE LIMITED",
"ATHARV AGRORGANIC PRODUCER COMPANY LIMITED",
"ATHARV CHEMICALS AND FERTILIZERS PRIVATE LIMITED",
"ATHARV ENTERPRISES LIMITED",
"ATHARV EYE HOSPITAL PRIVATE LIMITED",
"ATHARV GOLD PRIVATE LIMITED",
"ATHARV HEALTH SCIENCES PRIVATE LIMITED",
"ATHARV INTERTRADE PRIVATE LIMITED",
"ATHARV MINES PRIVATE LIMITED",
"ATHARV SCAN AND LAB PRIVATE LIMITED",
"ATHARV STAR INDIA PRIVATE LIMITED",
"ATHARV SUGARS PRIVATE LIMITED",
"ATHARV TECH DEVICE AND DISPLAY PRIVATE LIMITED",
"ATHARV TECHNOFIN PRIVATE LIMITED",
"ATHARV WELDING TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"ATHARVA AGRO FOODS PRIVATE LIMITED",
"ATHARVA AGRO TECH PRIVATE LIMITED",
"ATHARVA AGROCHEMICALS PRIVATE LIMITED",
"ATHARVA COLLEGE OF ENGINEERING",
"ATHARVA CONSORTIUM & REALTY PRIVATE LIMITED",
"ATHARVA CONSULTANCY PRIVATE. LIMITED",
"ATHARVA CORRUGATIONS PRIVATE LIMITED",
"ATHARVA DISTRIBUTORS PRIVATE LIMITED",
"ATHARVA EDUCATIONAL TRUST",
"ATHARVA ELASTOMERS INDIA PRIVATE LIMITED",
"ATHARVA ENTERPRISES",
"ATHARVA FOUNDRIES PRIVATE LIMITED",
"ATHARVA HARDWARE & SANITARY",
"ATHARVA LOGISTICS & ENGINEERING PRIVATE LIMITED",
"ATHARVA MARBLES & GRANITES PRIVATE LIMITED",
"ATHARVA METALCRAFT PRIVATE LIMITED",
"ATHARVA METALS & ENGINEERING PRIVATE LIMITED",
"ATHARVA METALS PRIVATE LIMITED",
"ATHARVA MOULDS PRIVATE LIMITED",
"ATHARVA NETRALAYA AND RESEARCH PRIVATE LIMITED",
"ATHARVA PLANNING AND RESEARCH CENTRE PRIVATE LIMITED",
"ATHARVA POLY PLAST PRIVATE LIMITED",
"ATHARVA POLYMERS PRIVATE LIMITED",
"ATHARVA REALINFRA INDIA PRIVATE LIMITED",
"ATHARVA REALTY PRIVATE LIMITED",
"ATHARVA SHIPPING PRIVATE LIMITED",
"ATHARVA SPEECH AND HEARING CARE PRIVATE LIMITED",
"ATHARVA TYRES PRIVATE LIMITED",
"ATHARVAN MINERALS PRIVATE LIMITED",
"ATHARVASHREE BUILDMAT PRIVATE LIMITED",
"ATHARVRAJ TRANSLINKS PRIVATE LIMITED",
"ATHASHRI HOMES PRIVATE LIMITED",
"ATHASIS LIFECARE PRIVATE LIMITED",
"ATHELAS SAVI",
"ATHEM FACILITY PRIVATE LIMITED",
"ATHEM MARKETING PVT LTD",
"ATHEN HOSPITAL PRIVATE LIMITED",
"ATHENA BEHAVIORAL HEALTH SERVICES PRIVATE LIMITED",
"ATHENA BHIWADI SOLAR POWER PRIVATE LIMITED",
"ATHENA BPO PRIVATE LIMITED",
"ATHENA CALL CENTRE SERVICES PRIVATE LIMITED",
"ATHENA CARS & TOURS PRIVATE LIMITED",
"ATHENA CONSTRUCTIONS LIMITED",
"ATHENA DRUG DELIVERY SOLUTIONS PRIVATE LIMITED",
"ATHENA EDUSPARK LIMITED",
"ATHENA EXECUTIVE SEARCH AND CONSULTING PRIVATE LIMITED",
"ATHENA GLOBAL LOGISTICS PRIVATE LIMITED",
"ATHENA GLOBAL SCHOOL",
"ATHENA GLOBAL TECHNOLOGIES LIMITED",
"ATHENA HEALTH CARE PRIVATE LIMITED",
"ATHENA HISAR SOLAR POWER PRIVATE LIMITED",
"ATHENA HOMES & INFRA PRIVATE LIMITED",
"ATHENA HOSPITAL",
"ATHENA INDIA HITECH COMPONENTS PRIVATE LIMITED",
"ATHENA INFONOMICS INDIA PRIVATE LIMITED",
"ATHENA INFORMATION SOLUTIONS PRIVATE LIMITED",
"ATHENA INFRASTRUCTURE LIMITED",
"ATHENA JAIPUR SOLAR POWER PRIVATE LIMITED",
"ATHENA KARNAL SOLAR POWER PRIVATE LIMITED",
"ATHENA PHARMA PRIVATE LIMITED",
"ATHENA RETAIL PRIVATE LIMITED",
"ATHENA SECURITY SOLUTIONS INDIA PRIVATE LIMITED",
"ATHENA SHIPS MANAGEMENT SERVICES PRIVATE LIMITED",
"ATHENA SUPERPACK PRIVATE LIMITED",
"ATHENA TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"ATHENA TRAINING ACADEMY",
"ATHENA TRAINING SOLUTIONS PRIVATE LIMITED",
"ATHENAHEALTH TECHNOLOGY PRIVATE LIMITED",
"ATHENALOGICS SOLUTION PRIVATE LIMITED",
"ATHENATRONIC TECHNOLOGY PRIVATE LIMITED",
"ATHENE TECHNOLOGIES INDIA LLP",
"ATHENESE DX PRIVATE LIMITED",
"ATHENESE ENERGY PRIVATE LIMITED",
"ATHENS LABS LIMITED",
"ATHENTA TECHNOLOGIES PRIVATE LIMITED",
"ATHERA BRANDING PRIVATE LIMITED",
"ATHERIO INDIA PRIVATE LIMITED",
"ATHEROL BUILDERS & DEVELOPERS PRIVATE LIMITED",
"ATHERTON ENGINEERING CO. PRIVATE LIMITED",
"ATHGAON VIDYAMANDIR KON",
"ATHIAPPA CHEMICALS PRIVATE LIMITED",
"ATHIRA ENGINEERING WORKS PRIVATE LIMITED",
"ATHIRAPPILLY RESIDENCY HOTELS INDIA PRIVATE LIMITED",
"ATHIRST AUTO PRIVATE LIMITED",
"ATHIRST FARMER PRODUCER COMPANY LIMITED",
"ATHITHEYA KSHEMA HOTELS PRIVATE. LIMITED.",
"ATHITHYAA GREEN CITY PROMOTERS PRIVATE LIMITED",
"ATHIVINAYAKAR WIRES PRIVATE LIMITED",
"ATHIYA ORGANIZATIONAL COMPETENCIES PRIVATE LIMITED",
"ATHLETICA FITNESS LLP",
"ATHLETICO ROYAAL PRIVATE LIMITED",
"ATHLEX BEVERAGES LIMITED",
"ATHLOS SPORTS INC PRIVATE LIMITED",
"ATHMA HOSPITALS & RESEARCH PRIVATE LIMITED",
"ATHMASHAKTHI MULTI PURPOSE CO-OPERATIVE SOCIETY LTD",
"ATHOM ELECTRIC PRIVATE LIMITED",
"ATHOM TRENDZ PRIVATE LIMITED",
"ATHOME HOSPITALITY SERVICES PRIVATE LIMITED",
"ATHOME MULTIMEDIA PRIVATE LIMITED",
"ATHOS CAPITAL ADVISORS PRIVATE LIMITED",
"ATHOS ENGINEERING INDIA PRIVATE LIMITED",
"ATHREYA HOSPITAL",
"ATHREYA RETAIL PRIVATE LIMITED",
"ATHRVA SYNERGY AND DEVELOPERS PRIVATE LIMITED",
"ATHULITHA LABORATORIES PRIVATE LIMITED",
"ATHULYA ASSISTED LIVING PRIVATE LIMITED",
"ATHULYA BELLOWS AND ENGG.PRIVATE LIMITED",
"ATHULYA GOLD AND DIAMONDS PRIVATE LIMITED",
"ATHULYA MERCHANTS PRIVATE LIMITED",
"ATHULYA SENIOR LIVING PRIVATE LIMITED",
"ATHVITH MOTORS PRIVATE LIMITED",
"ATHYUK AUTOMOTIVE PRIVATE LIMITED",
"ATI BEARINGS PRIVATE LIMITED",
"ATI INFRAPROJECTS PRIVATE LIMITED",
"ATIBIR INDUSTRIES COMPANY LIMITED",
"ATIDAN",
"ATIDIV (INDIA) PRIVATE LIMITED",
"ATIGNAS TRADERS PRIVATE LIMITED",
"ATIIAD TECHNOLOGIES PRIVATE LIMITED",
"ATIK SALT AND CHEMICALS PRIVATE LIMITED",
"ATILUS PHARMA PRIVATE LIMITED",
"ATIMI SOFTWARE INDIA PRIVATE LIMITED",
"ATIN PROMOTIONS & ADVERTISING PRIVATE LIMITED",
"ATINDRA CONSTRUCTION PRIVATE LIMITED",
"ATINDRIYA SYSTEMS PRIVATE LIMITED",
"ATIRA DESIGNS PRIVATE LIMITED",
"ATISFY LABS PRIVATE LIMITED",
"ATISH INFRADEVELOPERS PRIVATE LIMITED",
"ATISHAY COIR FOAM PRIVATE LIMITED",
"ATISHAY EDIBLES PRIVATE LIMITED",
"ATISHAY IMPEX PRIVATE LIMITED",
"ATISHAY JEWELLERS PRIVATE LIMITED",
"ATISHAY LIMITED",
"ATISHAY PHARMA PRIVATE LIMITED",
"ATISHAY RESOURCES PRIVATE LIMITED",
"ATISHAY SPECIALITIES PRIVATE LIMITED",
"ATISHAYA POLY PETT PRIVATE LIMITED",
"ATISHI GEMS & JEWELS INDIA PRIVATE LIMITED",
"ATIT MANAGEMENT SERVICES PRIVATE LIMITED",
"ATITH FIBRE PVT LTD",
"ATITHI DEALERS PVT LTD",
"ATITHI INDUSTRIAL SOLUTIONS PRIVATE LIMITED",
"ATITHI MEDICAL BOOKS PRIVATE LIMITED",
"ATITHYA INN PRIVATE LIMITED",
"ATIVEER FINANCE CONSULTANTS LIMITED",
"ATIVIR FINANCIAL CONSULTANTS PRIVATE LIMITED",
"ATIVIR FINANCIAL SERVICES PRIVATE LIMITED",
"ATIYA HEALTHCARE PRIVATE LIMITED",
"ATIYAS MOBILITY PRIVATE LIMITED",
"ATK MOHUN BAGAN PRIVATE LIMITED",
"ATKINSON HIGH SCHOOL",
"ATKOTIYA ENGINEERING WORKS PRIVATE LIMITED",
"ATL INDIA SOLUTIONS PRIVATE LIMITED",
"ATLABS TEXTILES PRIVATE LIMITED",
"ATLAN TECHNOLOGIES PRIVATE LIMITED",
"ATLANTA BIOLOGICAL PRIVATE LIMITED",
"ATLANTA COASTAL PRIVATE LIMITED",
"ATLANTA CROP PRIVATE LIMITED",
"ATLANTA ELECTRICALS PRIVATE. LIMITED.",
"ATLANTA ELEVATORS & ESCALATORS INDIA PRIVATE LIMITED",
"ATLANTA MEDICINES PRIVATE LIMITED",
"ATLANTA POWER PRIVATE LIMITED",
"ATLANTA PROJECTS AND OVERSEAS PRIVATE LIMITED",
"ATLANTA ROPAR TOLLWAYS PRIVATE. LIMITED.",
"ATLANTA SYSTEMS PRIVATE LIMITED",
"ATLANTA TRAVELS PRIVATE LIMITED",
"ATLANTAS CREW MANAGEMENT PRIVATE LIMITED",
"ATLANTAS TECHNICAL SERVICES INDIA PRIVATE LIMITED",
"ATLANTAS WORLDWIDE PRIVATE LIMITED",
"ATLANTIA POLYFAB PRIVATE LIMITED",
"ATLANTIC AIR AND OCEAN FREIGHT SERVICES PRIVATE LIMITED",
"ATLANTIC APPLIANCES PRIVATE LIMITED",
"ATLANTIC AVIATION PRIVATE LIMITED",
"ATLANTIC BIO MEDICAL PRIVATE LIMITED",
"ATLANTIC BPO SOLUTIONS PRIVATE LIMITED",
"ATLANTIC CARE CHEMICALS PRIVATE LIMITED",
"ATLANTIC CARGO PVT LTD",
"ATLANTIC CONTAINER LINE PRIVATE LIMITED",
"ATLANTIC CROP SCIENCE PRIVATE LIMITED",
"ATLANTIC DATA BUREAU SERVICES PRIVATE LIMITED",
"ATLANTIC EQUIPMENT COMPANY PRIVATE LIMITED",
"ATLANTIC GLOBAL SHIPPING PRIVATE LIMITED",
"ATLANTIC INFOTECH PRIVATE LIMITED",
"ATLANTIC MARINE PRODUCTS PRIVATE LIMITED",
"ATLANTIC MARITIME SERVICES PRIVATE LIMITED",
"ATLANTIC POLYMERS PRIVATE LIMITED",
"ATLANTIC POLYMERS UNIT-II PRIVATE LIMITED",
"ATLANTIC PRIVATE LIMITED",
"ATLANTIC PUBLISHERS & DISTRIBUTORS PRIVATE LIMITED",
"ATLANTIC REALTORS PRIVATE LIMITED",
"ATLANTIC ROAD SERVICES PRIVATE LIMITED",
"ATLANTIC TRADELINKS PRIVATE LIMITED",
"ATLANTIC TRAVELS AND CARGO PRIVATE LIMITED",
"ATLANTICA INFRA PRIVATE LIMITED",
"ATLANTICA SHIPPING AND LOGISTICS PRIVATE LIMITED",
"ATLANTICH INFRATECH PRIVATE LIMITED",
"ATLANTIS AGRITECH PRIVATE LIMITED",
"ATLANTIS BUILDERS INDIA PRIVATE LIMITED",
"ATLANTIS CONSULTING GROUP INDIA PRIVATE LIMITED",
"ATLANTIS ENGINEERING INDIA PRIVATE LIMITED.",
"ATLANTIS EXIM PRIVATE LIMITED",
"ATLANTIS FORMULATION PRIVATE LIMITED",
"ATLANTIS INTELLIGENCE LIMITED",
"ATLANTIS LAB PRIVATE LIMITED",
"ATLANTIS LIGHTING PRIVATE LIMITED",
"ATLANTIS MULTIPLEX PRIVATE LIMITED",
"ATLANTIS NURSING HOME",
"ATLANTIS PERFORMANCE MATERIALS INDIA PRIVATE LIMITED",
"ATLANTIS PRODUCTS PRIVATE LIMITED",
"ATLANTIS ROBOTICS PRIVATE LIMITED",
"ATLAS AVIATION INDIA PRIVATE LIMITED",
"ATLAS CABLES AND ACCESSORIES PRIVATE LIMITED",
"ATLAS CASTALLOY LIMITED",
"ATLAS COLOURS PRIVATE LIMITED",
"ATLAS COMMODITIES PRIVATE LIMITED",
"ATLAS COMNET PRIVATE LIMITED",
"ATLAS CONSTRUCTIONS PRIVATE LIMITED",
"ATLAS CONVERTING EQUIPMENT INDIA PRIVATE LIMITED",
"ATLAS COPCO (INDIA) PRIVATE LIMITED",
"ATLAS COPCO INDIA LIMITED",
"ATLAS CYCLES HARYANA LIMITED",
"ATLAS DISTRIBUTORS PRIVATE LIMITED",
"ATLAS DREDGING PRIVATE LIMITED",
"ATLAS ENGINEERING AND INSPECTION SERVICES PRIVATE LIMITED",
"ATLAS EQUIFIN PRIVATE LIMITED",
"ATLAS EXCHANGE BUREAU PRIVATE LIMITED",
"ATLAS EXPORTS INDIA",
"ATLAS FINANCIAL SERVICES PRIVATE LIMITED",
"ATLAS FISHERIES PRIVATE LIMITED",
"ATLAS FREIGHT FORWARDERS PRIVATE LIMITED",
"ATLAS GEOGRAPHIC DATA PRIVATE LIMITED",
"ATLAS GOLD SUPER MARKETS PRIVATE LIMITED",
"ATLAS HEALTH POINT PRIVATE LIMITED",
"ATLAS HEALTHCARE SOFTWARE INDIA PRIVATE LIMITED",
"ATLAS HOPPERS PRIVATE LIMITED",
"ATLAS INFRASERVE PRIVATE LIMITED",
"ATLAS INFRATECH PRIVATE LIMITED",
"ATLAS INTEGRATED FINANCE LIMITED",
"ATLAS JEWELLERY INDIA LIMITED",
"ATLAS LEARNING PRIVATE LIMITED",
"ATLAS LIFE SCIENCES PRIVATE LIMITED",
"ATLAS LOGISTICS PRIVATE LIMITED",
"ATLAS METAL PROCESSORS PRIVATE LIMITED",
"ATLAS MULTITRADE PRIVATE LIMITED",
"ATLAS ORGANICS PRIVATE LIMITED",
"ATLAS PET PLAS INDUSTRIES LIMITED",
"ATLAS PHARMACHEM INDUSTRIES PRIVATE LIMITED",
"ATLAS RADIO AND ELECTRONIC INDUSTRY PRIVATE LIMITED",
"ATLAS REFINERY PRIVATE LIMITED",
"ATLAS ROADWAYS PRIVATE LIMITED",
"ATLAS SHIPPING SERVICES PRIVATE LIMITED",
"ATLAS SKILLTECH UNIVERSITY",
"ATLAS SMART IMS INDIA PRIVATE LIMITED",
"ATLAS SOFT WEB PRIVATE LIMITED",
"ATLAS SOFTWARE TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"ATLAS STAMPINGS PVT LTD",
"ATLAS SWITCHGEAR MANUFACTURING COMPANY PRIVATE LIMITED",
"ATLAS SYSTEMS PRIVATE LIMITED",
"ATLAS TECHNOLOGIES PRIVATE LIMITED",
"ATLAS TEXTILES EXPORT PRIVATE LIMITED",
"ATLAS TOURS AND TRAVELS PRIVATE LIMITED",
"ATLAS TRANSFORMERS INDIA LIMITED",
"ATLAS WIND FARMS PRIVATE LIMITED",
"ATLASJOB SERVICES PRIVATE LIMITED",
"ATLASPOINT TECH (OPC) PRIVATE LIMITED",
"ATLEK INFRACON PRIVATE LIMITED",
"ATLINA LIFESCIENCES PRIVATE LIMITED",
"ATLIQ TECHNOLOGIES PRIVATE LIMITED",
"ATLURI COMMERCIAL COMPANY PRIVATE LIMITED",
"ATLURI FOODS PRIVATE LIMITED",
"ATLURI TRADERS PRIVATE LIMITED",
"ATM CARGO MOVERS PRIVATE LIMITED",
"ATM EXPORTS PRIVATE LIMITED",
"ATM MOTORS PRIVATE LIMITED",
"ATMA AUTOTECH ENGINEERS PRIVATE LIMITED",
"ATMA DIRECTORATE & SAMETI",
"ATMA LUBRICANTS AND SPECIALITIES LIMITED",
"ATMA MACHINOPLAST PRIVATE LIMITED",
"ATMA MALIK ENGLISH MEDIUM GURUKUL & JR COLLEGE KOKAMTHAN",
"ATMA METCHEM P LTD.",
"ATMA POWERS PRIVATE LIMITED",
"ATMA RAM BUILDERS PVT LTD",
"ATMA RAM MELA RAM STEELS PRIVATE LIMITED",
"ATMA RAM PROPERTIES PVT LTD",
"ATMA RAM SANATAN DHARMA COLLEGE",
"ATMA RAM SOHAN LAL AGENCIES PRIVATE LIMITED",
"ATMABANDHU INDUSTRIES PRIVATE LIMITED",
"ATMABANDHU SALES PRIVATE LIMITED",
"ATMAN IMPEX PRIVATE LIMITED",
"ATMAN OVERSEAS PRIVATE LIMITED",
"ATMAN SOLUTIONS PRIVATE LIMITED",
"ATMANTAN WELLNESS CENTRE (A UNIT OF SPARSH INFRATECH PVT. LTD.)",
"ATMARAM GOYAL AND SONS SALES PRIVATE LIMITED",
"ATMARAM MANEKLAL (EXPORTS) PVT LTD",
"ATMARAM MOTORS PRIVATE LIMITED",
"ATMASANTULANA VILLAGE PRIVATE LIMITED",
"ATMASTCOMPANY LIMITED",
"ATMASUMAN BUILDCON PRIVATE LIMITED",
"ATMC BUSINESS PROCESSING PRIVATE LIMITED",
"ATMECS TECHNOLOGIES PRIVATE LIMITED",
"ATMIKA PAPER MILLS PRIVATE LIMITED",
"ATMIYA UNIVERSITY",
"ATMIYA VIDYA NIKETAN",
"ATMIYA VIDYAPEETH",
"ATMOS FINANCE PRIVATE LIMITED",
"ATMOS POWER PRIVATE LIMITED",
"ATMOSAFE FILTRATION PRIVATE LIMITED",
"ATMOSPHERE REALTY PRIVATE LIMITED",
"ATMOSPHERE WORKSPACE SOLUTIONS PRIVATE LIMITED",
"ATMOSPHERIC COOLING SOLUTION PRIVATE LIMITED",
"ATMOST SYNERGY PRIVATE LIMITED",
"ATMY ANALYTICAL LABS PRIVATE LIMITED",
"ATN ENGINEERING PRIVATE LIMITED",
"ATNA TECHNOLOGIES INDIA PRIVATE LIMITED",
"ATNIS PRIVATE LIMITED",
"ATNU SOLAR PRIVATE LIMITED",
"ATOLL SOLUTIONS PRIVATE LIMITED",
"ATOLOGIST INFOTECH",
"ATOM & MAIN GROUP TECHNOLOGIES INDIA PRIVATE LIMITED",
"ATOM ALLOYS INDIA PRIVATE LIMITED",
"ATOM ENGINEERING PRODUCTS PRIVATE LIMITED",
"ATOM HIBS PRIVATE LIMITED",
"ATOM MEP ENGINEERS PRIVATE LIMITED",
"ATOM POWER PROJECTS PRIVATE LIMITED",
"ATOM POWER SYSTEMS PRIVATE LIMITED",
"ATOM8 IT SOLUTIONS PRIVATE LIMITED",
"ATOMA DEVELOPMENT AND SERVICES PRIVATE LIMITED",
"ATOMBERG TECHNOLOGIES PRIVATE LIMITED",
"ATOMBRIDGE NETWORKS PRIVATE LIMITED",
"ATOMES INDIA CHEMICALS PRIVATE LIMITED",
"ATOMIC ENERGY COMMISSION",
"ATOMIC NORTH PRIVATE LIMITED",
"ATOMICARTS VFX PRIVATE LIMITED",
"ATOMLIFE HEALTHCARE AND RESEARCH PRIVATE LIMITED",
"ATOMPRIVE FINANCIAL SERVICES PRIVATE LIMITED",
"ATOMUS INDUSTRIES PRIVATE LIMITED",
"ATOMY ENTERPRISE INDIA PRIVATE LIMITED",
"ATON REMEDIES LLP",
"ATOP FOOD PRODUCTS PRIVATE LIMITED",
"ATOP PRODUCTS PRIVATE LIMITED",
"ATOQA TEA PRODUCER COMPANY LIMITED",
"ATOR HEALTH CARE PRIVATE LIMITED",
"ATOS GLOBAL IT SOLUTIONS AND SERVICES PRIVATE LIMITED",
"ATOS INDIA HYDRAULICS PRIVATE LIMITED",
"EVIDEN INDIA PRIVATE LIMITED",
"ATOS IT SERVICES PRIVATE LIMITED",
"ATOS LIFESCIENCES PRIVATE LIMITED",
"ATOS MERCANTILE PRIVATE LIMITED",
"ATOS SYNTEL PRAYAS FOUNDATION",
"ATOTECH DEVELOPMENT CENTER PRIVATE LIMITED",
"ATOTECH INDIA PRIVATE LIMITED",
"ATOZ CARGO MOVERS PRIVATE LIMITED",
"ATOZ FURNISHERS PRIVATE LIMITED",
"ATOZ INFOWAY LLP",
"ATOZ INFRACON PRIVATE LIMITED",
"ATOZ INFRAPROJECTS PRIVATE LIMITED",
"ATOZ LOGISTICS LIMITED",
"ATOZ PHARMACEUTICALS PRIVATE LIMITED",
"ATOZ TYRE HUB PRIVATE LIMITED",
"ATP CONSULTANTS PRIVATE LIMITED",
"ATP INFRATECH PRIVATE LIMITED",
"ATP THERMTECH PRIVATE LIMITED",
"ATPI INDIA PRIVATE LIMITED",
"ATPL MANUFACTURING PRIVATE LIMITED",
"ATPM FOREX AND TOURS PRIVATE LIMITED",
"ATQ METRO PRIVATE LIMITED",
"ATR INFRAPROJECTS PRIVATE LIMITED",
"ATR INFRASTRUCTURE PRIVATE LIMITED",
"ATR MALLEABLE CASTING PVT. LTD.",
"ATR REAL ESTATE PRIVATE LIMITED",
"ATR TRADERS PRIVATE LIMITED",
"ATR WAREHOUSING PRIVATE LIMITED",
"ATRA LABS PRIVATE LIMITED",
"ATRADIUS INDIA CREDIT MANAGEMENT SERVICES PRIVATE LIMITED",
"ATRAENTE HEALTH CARE SERVICES LLP",
"ATREJA HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"ATRENTA INDIA PRIVATE LIMITED",
"ATREUM HOSPITALS PRIVATE LIMITED",
"ATREX AUTOMATION PRIVATE LIMITED",
"ATREY PHARMACEUTICALS PRIVATE LIMITED",
"ATREYA HOSPITAL THRISSUR",
"ATREYA INTERNATIONAL PRIVATE LIMITED",
"ATREYA SERVICES PRIVATE LIMITED",
"ATREYI AGENCIES PVT.LTD.",
"ATREYI FINANCIAL SERVICES PRIVATE LIMITED",
"ATREYI VINCOM PVT LTD",
"ATRI PAPERS PRIVATE LIMITED",
"ATRIA BRINDAVAN POWER LIMITED",
"ATRIA BROADBAND SERVICES PRIVATE LIMITED",
"ATRIA CONVERGENCE TECHNOLOGIES LIMITED",
"ATRIA ENERGY SERVICES PRIVATE LIMITED",
"ATRIA HYDEL POWER PRIVATE LIMITED",
"ATRIA INSTITUTE OF TECHNOLOGY",
"ATRIA LOGIC PRIVATE LIMITED",
"ATRIA MALL MANAGEMENT LIMITED",
"ATRIA POWER CORPORATION PRIVATE LIMITED",
"ATRIA SOLAR POWER (BALLARI) PRIVATE LIMITED",
"ATRIA SOLAR POWER (CHAMARAJANAGAR) PRIVATE LIMITED",
"ATRIA SOLAR POWER (RYAPTE) PRIVATE LIMITED",
"ATRIA STAR LOUNGE AND HOTELS PRIVATE LIMITED",
"ATRIA UNIVERSITY",
"ATRIA WIND (KADAMBUR) PRIVATE LIMITED",
"ATRIA WIND POWER (BIJAPUR 1) PRIVATE LIMITED",
"ATRIA WIND POWER (CHITRADURGA 2) PRIVATE LIMITED",
"ATRIA WIND POWER (CHITRADURGA) PRIVATE LIMITED",
"ATRIA WIND POWER (SAVARAKUNDLA) PRIVATE LIMITED",
"ATRIA WIND POWER PRIVATE LIMITED",
"ATRIBS SOFTWARE SYSTEMS PRIVATE LIMITED",
"ATRICA AUTOMOBILES PRIVATE LIMITED",
"ATRIE TECHNOLOGY PVT LTD",
"ATRIMED PHARMACEUTICALS PRIVATE LIMITED",
"ATRINA TECHNOLOGIES PRIVATE LIMITED",
"ATRITEX TECHNOLOGIES PRIVATE LIMITED",
"ATRITY INFO SOLUTIONS PRIVATE LIMITED",
"ATRIWAL INFRASTRUCTURE LIMITED",
"ATRIYA IMPEX PRIVATE LIMITED",
"ATRONIC SYSTEMS PRIVATE LIMITED",
"ATRUN FISCAL PRIVATE LIMITED",
"ATS APARTMENTS PRIVATE LIMITED",
"ATS ASIA PRIVATE LIMITED",
"ATS BUILDING SYSTEMS PRIVATE LIMITED",
"ATS BUSINESS SERVICES PRIVATE LIMITEDN",
"ATS CARGO PRIVATE LIMITED",
"ATS COMPUTERS PRIVATE LIMITED",
"ATS CONVEYORS INDIA PRIVATE LIMITED",
"ATS CREATIONS PRIVATE LIMITED",
"ATS DREAMZONE PRIVATE LIMITED",
"ATS ELGI LIMITED",
"ATS ENERGIES PRIVATE LIMITED",
"ATS ESTATES PRIVATE LIMITED",
"ATS GENETECH PRIVATE LIMITED",
"ATS HOMES PRIVATE LIMITED",
"ATS HOUSING PRIVATE LIMITED",
"ATS INFOTECH PRIVATE LIMITED",
"ATS INFRABUILD PRIVATE LIMITED",
"ATS INFRASTRUCURE LIMITED",
"ATS INFRATECH PRIVATE LIMITED",
"ATS MAINTENANCE SERVICES PRIVATE LIMITED",
"ATS OVERSEAS PRIVATE LIMITED",
"ATS REAL ESTATE BUILDERS PRIVATE LIMITED",
"ATS REALTY PRIVATE LIMITED",
"ATS SAVVY DEVELOPERS LLP",
"ATS SERVICES PRIVATE LIMITED",
"ATS SHARE BROKERS PRIVATE LIMITED",
"ATS TECHNO PRIVATE LIMITED",
"ATS TOWNSHIP PRIVATE LIMITED",
"ATS WORLDWIDE PRIVATE LIMITED",
"ATSALI INFRA SOLUTIONS PRIVATE LIMITED",
"ATSE SOLUTIONS PRIVATE LIMITED",
"ATSG INDIA PRIVATE LIMITED",
"ATSON TOOLS PRIVATE LIMITED",
"ATSPIRE AIR CONDITIONING PRIVATE LIMITED",
"ATSUN BUILDCON PRIVATE LIMITED",
"ATT SOLUTIONS PRIVATE LIMITED",
"ATT SYSTEMS (INDIA) PRIVATE LIMITED",
"ATTAIN HIGHER LLP",
"ATTAL FLEXI PACK PRIVATE LIMITED",
"ATTALIKA PROJECT MANAGEMENT AND CONSULTING SERVICES PRIVATE LIMITED",
"ATTALIKA REAL ESTATE PRIVATE LIMITED",
"ATTALURU PALEM ORGANIC FARMERS PRODUCER COMPANY LIMITED",
"ATTAQUANT CHEMICAL PRIVATE LIMITED",
"ATTAQUANT ENTERPRISES PRIVATE LIMITED",
"ATTAR FINANCE AND INVESTMENT COMPANY PVT LTD",
"ATTAR INFOTECH PRIVATE LIMITED",
"ATTAR LOGISTICS PRIVATE LIMITED",
"ATTAR SAIN JAIN EYE CENTER",
"ATTCON PROJECTS PRIVATE LIMITED",
"ATTENTIO RESEARCH CENTER PRIVATE LIMITED",
"ATTENTIVE AI SOLUTIONS PRIVATE LIMITED",
"ATTERO RECYCLING PRIVATE LIMITED",
"ATTHAH INFO MEDIA PRIVATE LIMITED",
"ATTHARV SAI FLEXIPACK PRIVATE LIMITED",
"ATTHARVA HEALTH TECH INDIA PRIVATE LIMITED",
"ATTIC HOSPITALITY PRIVATE LIMITED",
"ATTICA GOLD PRIVATE LIMITED",
"ATTINAD SOFTWARE PRIVATE LIMITED",
"ATTINKARA ELECTRONICS",
"ATTIRE FABRICS PRIVATE LIMITED",
"ATTIRE HOTELS & RESORTS PRIVATE LIMITED",
"ATTIS HYBRID SEEDS PRIVATE LIMITED",
"ATTITUDE EVENTS PRIVATE LIMITED",
"ATTITUDE EXIM PRIVATE LIMITED",
"ATTITUDE PLASTICS PRIVATE LIMITED",
"ATTIVO NETWORK SECURITY INDIA PRIVATE LIMITED",
"ATTIVO PROTEZIONE PRIVATE LIMITED",
"ATTOLLENT BUSINESS SOLUTION PRIVATE LIMITED",
"ATTORN FABRICATION AND ENGINEERING PRIVATE LIMITED",
"ATTRA INFOTECH PRIVATE LIMITED",
"ATTRACTIVE AUTO PARTS PRIVATE LIMITED",
"ATTRACTIVE CAPITAL SERVICES PRIVATE LIMITED",
"ATTRACTIVE PRICE FOREX PRIVATE LIMITED",
"ATTRAI BEARINGS PRIVATE LIMITED",
"ATTRI TECH MACHINES PRIVATE LIMITED",
"ATTROCK CONSULTANCY PRIVATE LIMITED",
"ATTUKAL DEVI INSTITUTE OF MEDICAL SCIENCES LIMITED",
"ATTUNE CONSULTING INDIA PRIVATE LIMITED",
"ATTUNED POLYMERS PVT LTD",
"ATTUR TEXTILES PRIVATE LIMITED",
"ATUL ADANI FINANCIAL SERVICES PRIVATE LIMITED",
"ATUL ADVERTISEMENT PRIVATE LIMITED",
"ATUL AND KULDEEP CONSTRUCTION PRIVATE LIMITED",
"ATUL AUTO LTD",
"ATUL AUTOCOMP PRIVATE LIMITED",
"ATUL AUTOMATION PRIVATE LIMITED",
"ATUL AYURVEDA LIMITED",
"ATUL BIO SPACE LIMITED",
"ATUL BIOSCIENCE LIMITED",
"ATUL BREWCHEM PRIVATE LIMITED",
"ATUL BUILDTECH PRIVATE LIMITED",
"ATUL CARRIERS LOGISTICS MANAGEMENT PRIVATE LIMITED",
"ATUL COMMODITIES PRIVATE LIMITED",
"ATUL CONSUMER PRODUCTS LIMITED",
"ATUL CROP CARE LIMITED",
"ATUL ELECTRO FORMERS LIMITED",
"ATUL ENGG. UDYOG",
"ATUL EXPRESSCOM (MONEY CHANGERS) PRIVATE LIMITED",
"ATUL FASTENERS PRIVATE LIMITED",
"ATUL FIN RESOURCES LIMITED",
"ATUL FINSERV LIMITED",
"ATUL GEARS PRIVATE LIMITED",
"ATUL GENERATORS PRIVATE LIMITED",
"ATUL GLOBAL PRIVATE LIMITED",
"ATUL GREEN AUTOMOTIVE PRIVATE LIMITED",
"ATUL INFOTECH PRIVATE LIMITED",
"ATUL INSTITUTE OF VOCATIONAL EXCELLENCE",
"ATUL KRISHNA PRESERVATION AND COLD STORAGE PRIVATE LIMITED",
"ATUL LIMITED",
"ATUL LUBRICANTS PRIVATE LIMITED",
"ATUL MACHINERY TRADING (INDIA) PRIVATE LIMITED",
"ATUL METFAB PRIVATE LIMITED",
"ATUL MOTOR TRADING COMPANY PRIVATE LIMITED",
"ATUL MOTORS JAM LLP",
"ATUL MOTORS PRIVATE LIMITED",
"ATUL OIL CAKE INDUSTRIES LIMITED",
"ATUL ORNAMENTS PRIVATE LIMITED",
"ATUL OVERSEAS (INDIA) PRIVATE LIMITED",
"ATUL OXYGEN COMPANY PVT LTD",
"ATUL PAPER PVT LTD",
"ATUL PLASTOWORLD PRIVATE LIMITED",
"ATUL PLYWOOD PVT LTD",
"ATUL POLYMERS PRODUCTS LIMITED",
"ATUL POLYPLAST P LIMITED",
"ATUL PRODUCTS LIMITED",
"ATUL PROJECTS INDIA LIMITED",
"ATUL PROPERTIES PVT LTD",
"ATUL PUBLICITY PVT. LTD",
"ATUL PUMP PRIVATE LIMITED",
"ATUL RAHUL AGRO PRIVATE LIMITED",
"ATUL RAJ BUILDERS PVT LTD",
"ATUL RAJASTHAN DATE PALMS LIMITED",
"ATUL RUBBER PROCESSORS PRIVATE LIMITED",
"ATUL SALES PRIVATE LIMITED",
"ATUL SHARMA SOLAR ENERGY",
"ATUL SHIPPING AGENCY (I) PRIVATE LIMITED",
"ATUL SONS LOGISTICS PRIVATE LIMITED",
"ATUL SUGAR SCREENS PRIVATE LIMITED",
"ATUL TECHNOCAST PRIVATE LIMITED",
"ATUL TEXTILES PRIVATE LIMITED",
"ATUL TIE-UP PRIVATE LIMITED",
"ATUL TRANSPORT PRIVATE LIMITED",
"ATUL WAREHOUSING & PACKAGING PRIVATE LIMITED",
"ATULAH CONTRACTORS AND CONSTRUCTIONS PRIVATE LIMITED",
"ATULAYA HEALTHCARE PRIVATE LIMITED",
"ATULIT CHEMICAL PRODUCTS PRIVATE LIMITED",
"ATULNIYA DESIGNS PRIVATE LIMITED",
"ATULSIA TECHNOLOGIES PRIVATE LIMITED",
"ATULYA BHARAT NIRMAN",
"ATULYA DISCS PRIVATE LIMITED",
"ATULYA EXTRUSIONS PRIVATE LIMITED",
"ATULYA MACHINES PRIVATE LIMITED",
"ATULYA MEDILINK PRIVATE LIMITED",
"ATULYA POLYPACK PRIVATE LIMITED",
"ATULYAA INDUSTRIES",
"ATULYAM INFRA",
"ATUM CAPITAL PRIVATE LIMITED",
"ATUM IT SERVICES INDIA PRIVATE LIMITED",
"ATUOFERT AGRIMATIONS EQUIPMENTS (OPC) PRIVATE LIMITED",
"ATUR INDIA PRIVATE LIMITED",
"ATURA WHEELS PRIVATE LIMITED",
"ATURIA CONSTRUCTION PRIVATE LIMITED",
"ATV PROJECTS INDIA LIMITED",
"ATVARA HVAC SYSTEMS PRIVATE LIMITED",
"ATW (INDIA) PRIVATE LIMITED",
"ATW FOODS PRIVATE LIMITED",
"ATWALS REALESTATE PRIVATE LIMITED",
"ATWIAS INFO SOLUTIONS PRIVATE LIMITED",
"ATXLEARNING PRIVATE LIMITED",
"ATYA SPACES PRIVATE LIMITED",
"ATYAM AGRO PRODUCTS PRIVATE LIMITED",
"ATYAM INFRASTRUCTURE PRIVATE LIMITED",
"ATYAM MINING PRIVATE LIMITED",
"ATYANT CAPITAL ADVISORS PRIVATE LIMITED",
"ATYANTA DEVELOPERS PRIVATE LIMITED",
"ATYANTIK TECHNOLOGIES PRIVATE LIMITED",
"ATYATI TECHNOLOGIES PRIVATE LIMITED",
"ATYETI IT SERVICES PRIVATE LIMITED",
"ATYETI ROBOTICS PRIVATE LIMITED",
"ATZ LAB SOLUTIONS (INDIA) PRIVATE LIMITED",
"ATZ SALESTECH SOLUTIONS PRIVATE LIMITED",
"ATZ SHIPPING TRADE AND TRANSPORT PRIVATE LIMITED",
"AU BON PAIN CAFE INDIA LIMITED",
"AU EXPORTS PRIVATE LIMITED",
"AU GARMENTS PRIVATE LIMITED",
"AU HOLIDAYS & EVENTS PRIVATE LIMITED",
"AU INSURANCE & BROKING SERVICES PRIVATE LIMITED",
"AU METALS PRIVATE LIMITED",
"AU SMALL FINANCE BANK LIMITED",
"AUBERGE HOTELS PRIVATE LIMITED",
"AUBERGINE DESIGNWORKS LLP",
"AUBERGINE PROPERTIES PRIVATE LIMITED",
"AUBERGINE SOLUTIONS PRIVATE LIMITED",
"AUBOTZ LABS PRIVATE LIMITED",
"AUBURN DIGITAL SOLUTIONS PRIVATE LIMITED",
"AUCHLITE CHEMICAL PRIVATE LIMITED",
"AUCKLAND INTERNATIONAL LTD",
"AUCKLAND JUTE CO LIMITED",
"AUCTOR BUSINESS SOLUTIONS PRIVATE LIMITED",
"AUCTOREM SOLUTIONS PRIVATE LIMITED",
"AUCTUS ADVISORS PRIVATE LIMITED",
"AUCTUS CAPITAL SERVICES PRIVATE LIMITED",
"AUCTUS E-RECYCLING SOLUTIONS PRIVATE LIMITED",
"AUCTUS INFOMETRICS PRIVATE LIMITED",
"AUCTUS LABS PRIVATE LIMITED",
"AUCTUS LOGISTICS MANAGEMENT PRIVATE LIMITED",
"AUDACE FORTUNE PRIVATE LIMITED",
"AUDACIA CONSULTANCY PRIVATE LIMITED",
"AUDARYA CONSTRUCTION PRIVATE LIMITED",
"AUDATEX SOLUTIONS PRIVATE LIMITED",
"AUDAX LABS PRIVATE LIMITED",
"AUDAX PROTECTIVE FABRICS PRIVATE LIMITED",
"AUDEN LIGHTS PRIVATE LIMITED",
"AUDENTIA RESEARCH PRIVATE LIMITED",
"AUDENTIUS TRADELINKS INDIA PRIVATE LIMITED",
"AUDENTO DIGITAL PRIVATE LIMITED",
"AUDHYOGIK PRASHIKSHAN SANSTHA NANDURBAR",
"AUDIENCE COMMUNICATIONS SYSTEMS INDIA PRIVATE LIMITED",
"AUDIFY TECH PRIVATE LIMITED",
"AUDIKESH HOSPITALS PRIVATE LIMITED",
"AUDINTEL INDIA PRIVATE LIMITED",
"AUDIO BEAST INDIA PRIVATE LIMITED",
"AUDIO DISTRIBUTION HOUSE PRIVATE LIMITED",
"AUDIO EXCELLENCE ( INDIA ) PRIVATE LIMITED",
"AUDIO TEHCNOLOGIES AND CODECS (INDIA) PRIVATE LIMITED",
"AUDIO VISION INDIA PRIVATE LIMITED",
"AUDIO VISUAL EXPRESS INDIA PRIVATE LIMITED",
"AUDIO VOICE INDIA PRIVATE LIMITED",
"AUDIO WIDE AREA NETWORK INDIA PRIVATE LIMITED",
"AUDIOCODES INDIA PRIVATE LIMITED",
"AUDIO-ONE PRIVATE LIMITED",
"AUDISANKARA GROUP OF INSTITUTIONS",
"AUDIT BUREAU OF CIRCULATIONS",
"AUDITICS PRIVATE LIMITED",
"AUDITIME QUALITY MANAGEMENT PRIVATE LIMITED",
"AUDITIVO HEARING SERVICES PRIVATE LIMITED",
"AUDITOR GENERAL",
"AUDITORIA.AI SOFTWARE PRIVATE LIMITED",
"AUDIX TECHNO CONSULTING SOLUTIONS PRIVATE LIMITED",
"AUDIZONE HEARING CARE PRIVATE LIMITED",
"AUDLINK SOFTWARE PRIVATE LIMITED",
"AUDNEY INFORMATION SYSTEMS PRIVATE LIMITED",
"AUDO VISO PRIVATE LIMITED",
"AUDRA HEALTH TECH PRIVATE LIMITED",
"AUDRA HOTELS & RESORTS PRIVATE LIMITED",
"AUDRA JEWEL INDUSTRY PRIVATE LIMITED",
"AUDREE INFOTECH PRIVATE LIMITED",
"AUDYOGIK PRASHIKSHAN SANSTHA NANDURBAR",
"AUFAIT TECHNOLOGIES PRIVATE LIMITED",
"AUFTRITT HEALTHCARE PRIVATE LIMITED",
"AUGEN TECHNOLOGIES SOFTWARE SOLUTIONS PRIVATE LIMITED",
"AUGEO ASSET MANAGEMENT PRIVATE LIMITED",
"AUGMEDIX SOLUTIONS PRIVATE LIMITED",
"AUGMENS FOREX AND FINANCIAL SERVICES PRIVATE LIMITED",
"AUGMENT FINVEST PRIVATE LIMITED",
"AUGMENT NUTRIENTS PRIVATE LIMITED",
"AUGMENT SOFTSOL INDIA PRIVATE LIMITED",
"AUGMENT SYSTEMS PRIVATE LIMITED",
"AUGMENT TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"AUGMENTED TRANSFORMATIONS PRIVATE LIMITED",
"AUGMENTIX SOFTWARE SOLUTIONS PRIVATE LIMITED",
"AUGMENTO LABS PRIVATE LIMITED",
"AUGMONT ENTERPRISES PRIVATE LIMITED",
"AUGMONT GOLDTECH PRIVATE LIMITED",
"AUGRAY PRIVATE LIMITED",
"AUGTECH NEXTWEALTH IT SERVICES PRIVATE LIMITED",
"AUGUR COMPUTERS PRIVATE LIMITED",
"AUGURS TECHNOLOGIES PRIVATE LIMITED",
"AUGURTRON SYSTEMS & SOLUTIONS PRIVATE LIMITED",
"AUGUST ASSORTMENTS PRIVATE LIMITED",
"AUGUST CONSULTING INDIA PRIVATE LIMITED",
"AUGUST INDUSTRIES PRIVATE LIMITED",
"AUGUST PURPLE SERVICES PRIVATE LIMITED",
"AUGUST VENTURE CORPORATE SOLUTIONS PRIVATE LIMITED",
"AUGUST VENTURES PRIVATE. LIMITED.",
"AUGUSTA CLUB PRIVATE LIMITED",
"AUGUSTA CONSULTANTS AND ADVISORS PRIVATE LIMITED",
"AUGUSTA HITECH SOFT SOLUTIONS PRIVATE LIMITED",
"AUGUSTA MOTORS PRIVATE LIMITED.",
"AUGUSTAN GARMENTS PRIVATE LIMITED",
"AUGUSTAN KNITWEAR PRIVATE LIMITED",
"AUGUSTAN TEXTILE COLOURS LIMITED",
"AUGUSTCODE SOLUTIONS PRIVATE LIMITED",
"AUGUSTINA TRADELINK PRIVATE LIMITED",
"AUGUSTUS HEALTHCARE INDIA LLP",
"AUGVER DIGITAL SOLUTIONS PRIVATE LIMITED",
"AUJ INVESTMENT & CONSULTANTS PVT LTD",
"AUJAS CYBERSECURITY LIMITED",
"AUJAS NETWORKS PRIVATE LIMITED",
"AUJLA BUSINESS SOFWARE PRIVATE LIMITED",
"AUJUS TECHNOLOGY PRIVATE LIMITED",
"AUK COMPUTING PRIVATE LIMITED",
"AUKLAND CERAMIC PRIVATE LIMITED",
"AULI LIFESTYLE CONSULTANCY PRIVATE LIMITED",
"AULTIMATE TEX (INDIA) PRIVATE LIMITED",
"AULTRA PAINTS PRIVATE LIMITED",
"AUM ADHESIVES PRIVATE LIMITED",
"AUM ADVERTISING AND MEDIA PRIVATE LIMITED",
"AUM AIRCONDITIONING SERVICES PRIVATE LIMITED",
"AUM ALANKAR GEM PALACE PRIVATE LIMITED",
"AUM CAPITAL MARKET PRIVATE LIMITED",
"AUM CORPORATE PRIVATE LIMITED",
"AUM CRAFTTECH PRIVATE LIMITED",
"AUM DACRO COATINGS LLP",
"AUM DYES AND CHEMICALS PRIVATE LIMITED",
"AUM ENERCON PRIVATE LIMITED",
"AUM EVENT & PROMOTIONS INDIA PRIVATE LIMITED",
"AUM FARBENCHEM INDIA PRIVATE LIMITED",
"AUM HEALTHCARE VENTURES LLP",
"AUM I ARTISTES PRIVATE LIMITED",
"AUM IMAGINEERING PRIVATE LIMITED",
"AUM IMPEX PRIVATE LIMITED",
"AUM INFOTECH PRIVATE LIMITED",
"AUM INSURANCE BROKERS PRIVATE LIMITED",
"AUM INSURE AND SECURE PRIVATE LIMITED",
"AUM INTERNATIONAL TAPES PRIVATE LIMITED",
"AUM IRYA MARKETING SERVICES PRIVATE LIMITED",
"AUM PAPER PRODUCTS PRIVATE LIMITED",
"AUM PLASTIC MART PRIVATE LIMITED",
"AUM SHRI HOTELS & RESORTS PRIVATE LIMITED",
"AUM SHRI SHRI GHANSHYAM FOOD PROCESSING PRIVATE LIMITED",
"AUM SPORTAINMENT PRIVATE LIMITED",
"AUM STRUCTBUILD PRIVATE LIMITED",
"AUM TECH INFOSOFT PRIVATE LIMITED",
"AUM TRACTORS SOLAPUR",
"AUM UDYOG",
"AUM VIJAYA AGENCIES (INDIA) PRIVATE LIMITED",
"AUM VIJAYA AGENCIES INDIA PRIVATE LIMITED",
"AUMA INDIA PRIVATE LIMITED",
"AUMENTO POLYMER TEKNIKS PRIVATE LIMITED",
"AUMENTO TECHNOLOGIES AND CONSULTING SERVICES PRIVATE LIMITED",
"AUMEX CLEANROOM INDIA PRIVATE LIMITED",
"AUMIT CAPITAL ADVISORS LIMITED",
"AUMJI EXIM PRIVATE LIMITED",
"AUMNATIC SYSTEMS PRIVATE LIMITED",
"AUMNI TRANSMISSION INDUSTRY PVT. LTD.",
"AUMNICS IT SOLUTIONS PRIVATE LIMITED",
"AUMRAJ DESIGN SYSTEMS PRIVATE LIMITED",
"AUMRAJ TECHNOLOGIES PRIVATE LIMITED",
"AUMSAV CREATIVE SOLUTION PRIVATE LIMITED",
"AUMSUN SOLAR PRIVATE LIMITED",
"AUMUND ENGINEERING PRIVATE LIMITED",
"FAZE THREE AUTOFAB LIMITED",
"AUNIK IT SOLUTIONS PRIVATE LIMITED",
"AUNOA SOLUTIONS PRIVATE LIMITED",
"AUPTAG REFINERY PRIVATE LIMITED",
"AUQUAN INDIA PRIVATE LIMITED",
"AURA AGENCIES PRIVATE LIMITED",
"AURA ALKALIES AND CHEMICALS PRIVATE LIMITED",
"AURA ART ECONNECT PRIVATE LIMITED",
"AURA BABY CLOTHING",
"AURA BIOTECHNOLOGIES PRIVATE LIMITED",
"AURA BPO SERVICES PRIVATE LIMITED",
"AURA BRIGHT LIGHT INDIA PRIVATE LIMITED",
"AURA CONTRIVERS PRIVATE LIMITED",
"AURA COSMETICS PRIVATE LIMITED",
"AURA EDIFY GLOBAL SCHOOL¬†CHAPPARA",
"AURA EMANATING TEKNOLOGY PRIVATE LIMITED",
"AURA FACILITIES MANAGEMENT PRIVATE LIMITED",
"AURA GARMAX PRIVATE LIMITED",
"AURA HERBAL PRIVATE LIMITED",
"AURA HOTELS AND RESORTS PRIVATE LIMITED",
"AURA HOTELS PRIVATE LIMITED",
"AURA IMPEX PRIVATE LIMITED",
"AURA INDUSTRIAL EQUIPMENT AND PROJECTS PRIVATE LIMITED",
"AURA INTEGRATED SOLUTIONS PRIVATE LIMITED",
"AURA JEWELLERY PRIVATE LIMITED",
"AURA LASERFAB PRIVATE LIMITED",
"AURA LIFE SCIENCES PRIVATE LIMITED",
"AURA LIFECARE PRIVATE LIMITED",
"AURA NUTRACEUTICALS LIMITED",
"AURA OPTO ELECTRONICS INDIA PRIVATE LIMITED",
"AURA ORCHARDS PRIVATE LIMITED",
"AURA PAPER INDUSTRIES INDIA PRIVATE. LIMITED.",
"AURA PHARMACEUTICALS PRIVATE LIMITED",
"AURA POLYMERS PRIVATE LIMITED",
"AURA POLYPLASTICS PRIVATE LIMITED",
"AURA PRINT SOLUTIONS PRIVATE LIMITED",
"AURA RENEWABLE ENERGY PRIVATE LIMITED",
"AURA SECURITIES PRIVATE LIMITED",
"AURA SEMICONDUCTOR PRIVATE LIMITED",
"AURA SOFTWARE PRIVATE LIMITED",
"AURA SYNERGY INDIA PRIVATE LIMITED",
"AURAA HYBRID SEEDS INDIA PRIVATE LIMITED",
"AURAA METALLICS PRIVATE LIMITED",
"AURACARE PHARMA PRIVATE LIMITED",
"AURAD SOLAR PRIVATE LIMITED",
"AURADECOR PRIVATE LIMITED",
"AURAEDU GROUP LEARNING PRIVATE LIMITED",
"AURAFOX SOLUTIONS PRIVATE LIMITED",
"AURAINE BOTANICALS PRIVATE LIMITED",
"AURAINTERACT PRIVATE LIMITED",
"AURAIYA FARMER PRODUCER COMPANY LIMITED",
"AURAMAH HOTELS PRIVATE LIMITED",
"AURAMINE DYESTUFF PRIVATE LIMITED",
"AURANGABAD - JALNA TOLL WAY PRIVATE LIMITED",
"AURANGABAD ALLOYS PRIVATE LIMITED",
"AURANGABAD AUTO ANCILLIARY PRIVATE LIMITED",
"AURANGABAD AUTO ENGINEERING PRIVATE LIMITED",
"AURANGABAD CARBON PRODUCTS PRIVATE LIMITED",
"AURANGABAD CITY WATER UTILITY COMPANY LIMITED",
"AURANGABAD DISTILLERY LIMITED",
"AURANGABAD DISTRICT CENTRAL CO-OP BANK LTD",
"AURANGABAD FOUNDRIES PVT LTD",
"AURANGABAD GASTRO PRIVATE LIMITED",
"AURANGABAD GYMKHANA CLUB PRIVATE LIMITED",
"AURANGABAD INSTITUTE OF MEDICAL SCIENCES PRIVATE LIMITED",
"AURANGABAD METAL PRODUCTS PRIVATE LIMITED",
"AURANGABAD MUNICIPAL CORPORATION",
"AURANGABAD PLASTICS PVT LTD",
"AURANGABAD POLICE PUBLIC SCHOOL",
"AURANGABAD PUBLIC SCHOOL",
"AURANGABAD SMART CITY DEVELOPMENT CORPORATION LIMITED",
"AURANGABAD STEEL CORPORATION",
"AURANGABAD THERMOCOL PLATES & CONTAINERS PRIVATE LIMITED",
"AURANGABAD WHEELS AND RIMS PRIVATE LIMITED",
"AURAPHYLL INNOVENTURES INDIA PRIVATE LIMITED",
"AURATECH SERVICES INDIA PRIVATE LIMITED",
"AURATHRONE CONSTRUCTIONS PRIVATE LIMITED",
"AURAYA HEALTHCARE",
"AURBIS BUSINESS PARKS PRIVATE LIMITED",
"AURDIA JEWELLERY PRIVATE LIMITED",
"AUREA AVIATION PRIVATE LIMITED",
"AUREA BIOLABS PRIVATE LIMITED",
"AUREAN ESKAR VENTURES LLP",
"AUREATE HEALTHCARE LIMITED",
"AUREATE HEALTHCARE PRIVATE LIMITED",
"AUREATE LABS PRIVATE LIMITED",
"AUREATE TRADDE PRIVATE LIMITED",
"AURECON TECHNOLOGIES PRIVATE LIMITED",
"AUREOLE ATELIER PRIVATE LIMITED",
"AUREOLE ELECTRICALS AND ELECTRONICS PRIVATE LIMITED",
"AUREOLE INSPECS (INDIA) PRIVATE LIMITED",
"AUREOLE NOVA INTEGRATED PRIVATE LIMITED",
"AUREOLE RUBBERS PRIVATE LIMITED",
"AUREOLE TECHNOLOGIES PRIVATE LIMITED",
"AUREUS ANALYTICS PRIVATE LIMITED",
"AUREUS INSTITUTE OF MEDICAL SCIENCES PRIVATE LIMITED",
"AUREUSTECH SYSTEMS PRIVATE LIMITED",
"AUREX LABORATORIES PRIVATE LIMITED",
"AURFIN LEASING LIMITED",
"AURIBANDHU HIGHER SECONDARY SCHOOL",
"AURIC BEAUTY PRODUCTS PRIVATE LIMITED\n",
"AURIC BUILDERS PRIVATE LIMITED",
"AURIC INFRATECH PRIVATE LIMITED",
"AURIC MERCHANDISING SERVICES PRIVATE LIMITED",
"AURIC MOTORS PRIVATE LIMITED",
"AURIC TECHNO SERVICES PRIVATE LIMITED",
"AURICK ELEVATORS PRIVATE LIMITED",
"AURICLE VIBRATION SERVICES PRIVATE LIMITED",
"AURIGA INDUSTRIES PRIVATE LIMITED",
"AURIGA IT CONSULTING PRIVATE LIMITED",
"AURIGA IT SOLUTIONS PRIVATE LIMITED",
"AURIGA RESEARCH PRIVATE LIMITED",
"AURIGAIN CONSULTANTS PRIVATE LIMITED",
"AURIGENE DISCOVERY TECHNOLOGIES LIMITED",
"AURIGENE PHARMACEUTICAL SERVICES LIMITED",
"AURIGO SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"AURIKA FINVEST PRIVATE LIMITED",
"AURINKO DIGITAL STUDIO",
"AURINKO ENERGY PRIVATE LIMITED",
"AURINKO HEALTHCARE PRIVATE LIMITED",
"AURIO PHARMA LABORATORIES PRIVATE LIMITED",
"AURIOLUS FINVEST PRIVATE LIMITED",
"AURIONPRO SOLUTIONS LIMITED",
"AURIONPRO TOSHI AUTOMATIC SYSTEMS PRIVATE LIMITED",
"AURISS TECHNOLOGIES PRIVATE LIMITED",
"AURITAS TECHNOLOGIES INDIA PRIVATE LIMITED",
"AURM APPAREL (OPC) PRIVATE LIMITED",
"AURN STEEL INDUSTRIES PRIVATE LIMITED",
"AURO BUILDERS PRIVATE LIMITED",
"AURO CARE PRIVATE LIMITED",
"AURO CHEMICAL INDUSTRIES PRIVATE LTD",
"AURO COMMERCIAL PRIVATE LIMITED",
"AURO EDUCATION SOCIETY",
"AURO FLOUR MILLS PVT LTD",
"AURO FRUIT AND NUT PRIVATE LIMITED",
"AURO FUEL DOORSTEP DELIVERY PRIVATE LIMITED",
"AURO IMPEX & CHEMICALS LIMITED",
"AURO IMPEX & CHEMICALS PRIVATE. LIMITED.",
"AURO INDUSTRIES LIMITED",
"AURO INFRA PRIVATE LIMITED",
"AURO INTERNATIONAL SCHOOL OF HOSPITALITY MANAGEMENT",
"AURO LABORATORIES LIMITED",
"AURO MACHINES PRIVATE LIMITED",
"AURO MANUFACTURING PRIVATE LIMITED",
"AURO METAL REFINERY PRIVATE LIMITED",
"AURO MILES PRIVATE LIMITED",
"AURO MINERALS PVT LTD",
"AURO MRI CENTRE PRIVATE LIMITED",
"AURO MULTISPECIALITY PET HOSPITAL",
"AURO PEPTIDES LIMITED",
"AURO POLYMERS PRIVATE LIMITED",
"AURO PUMPS PRIVATE LIMITED",
"AURO REALTY PRIVATE LIMITED",
"AURO SALES PRIVATE LIMITED",
"AURO SHRI HR SERVICES PRIVATE LIMITED",
"AURO SUNDRAM INTERNATIONAL PRIVATE LIMITED",
"AURO SUNDRAM PLY AND DOOR PRIVATE LIMITED",
"AURO SWITCHGEAR PRIVATE LIMITED",
"AURO UNIVERSITY",
"AUROBINDO EMERGENCY MEDICAL SERVICES",
"AUROBINDO PHARMA FOUNDATION",
"AUROBINDO PHARMA LIMITED",
"AUROBLISS DESIGNER JEWELS PRIVATE LIMITED",
"AUROCHEM LABORATORIES INDIA PRIVATE LIMITED",
"AUROCHEM PHARMACEUTICALS (INDIA) PRIVATE LIMITED",
"AUROCHS SOFTWARE PRIVATE LIMITED",
"AURODESIGN PRIVATE LIMITED",
"AURODIVINE TECHNOLOGIES PRIVATE LIMITED",
"AUROFIDEL OUTSOURCING LIMITED",
"AUROFOOD PRIVATE LIMITED",
"AUROGLOBAL COMTRADE PRIVATE LIMITED",
"AUROHEAL DRUGS PRIVATE LIMITED",
"AUROILE LOGISTICS PRIVATE LIMITED",
"AUROIN (INDIA) LIMITED",
"AUROKIRAN CAPITAL INVESTMENT ADVISORS PRIVATE LIMITED",
"AUROMA ACCOUNTING SERVICES PRIVATE LIMITED",
"AUROMA GEOTEX PRIVATE LIMITED",
"AUROMA LIFE SCIENCE PRIVATE LIMITED",
"AUROMA LOGISTICS PRIVATE LIMITED",
"AUROMBICA ENGINEERING COMPANY PRIVATE LIMITED",
"AUROMIR FOUNDATION FOR INTEGRAL LEARNING",
"AUROMIRA ENTERTAINMENT PRIVATE LIMITED",
"AURONEXT PHARMA PRIVATE LIMITED",
"AUROPOL INDIA PRIVATE LIMITED",
"AUROPRO SOFT SYSTEMS PRIVATE LIMITED",
"AURORA APPAREL PRIVATE LIMITED",
"AURORA CONTEMPORARY ART PRIVATE LIMITED",
"AURORA E-LABS PRIVATE LIMITED",
"AURORA HIGHER EDUCATION AND RESEARCH ACADEMY",
"AURORA PIPING PRODUCTS LLP",
"AURORA STUDIO PRIVATE LIMITED",
"AURORA SYSTEMS CONSULTING INC",
"AURORA TECH",
"AURORA TRAVELS TOURS PRIVATE LIMITED",
"AURORA‚ÄôS DEGREE & PG COLLEGE",
"AURORA'S ENGINEERING COLLEGE",
"AURORE LIFE SCIENCES PRIVATE LIMITED",
"AURORE PHARMACEUTICALS PRIVATE LIMITED",
"AUROREN BUILDWELL PRIVATE LIMITED",
"AURORIUM INDIA PRIVATE LIMITED",
"AUROSCIENT OUTSOURCING LIMITED",
"AUROSHREE CONSTRUCTIONS PRIVATE LIMITED",
"AUROTECH INFRAPROJECTS PRIVATE LIMITED",
"AUROTRANS MARITIME SERVICES PRIVATE LIMITED",
"AUROUS ENTERPRISE PRIVATE LIMITED",
"AUROUS JEWELS LLP",
"AUROUS PETRO PRIVATE LIMITED",
"AUROVILLE INVESTMENTS PVT. LTD.",
"AURUM (INDIA) SAFETY GLASS PRIVATE LIMITED",
"AURUM ANALYTICA PRIVATE LIMITED",
"AURUM AUTOMOBILES PRIVATE LIMITED",
"AURUM COMMUNICATIONS PRIVATE LIMITED",
"AURUM FACILITY MANAGEMENT PRIVATE LIMITED",
"AURUM FOODS PRIVATE LIMITED",
"AURUM JEWELS LIMITED",
"AURUM LIFESCIENCES PRIVATE LIMITED",
"AURUM LIVING FACILITIES PRIVATE LIMITED",
"AURUM MARINE MANAGEMENT SERVICES PRIVATE LIMITED",
"AURUM PACKAGING SYSTEMS PRIVATE LIMITED",
"AURUM PHARMACHEM PRIVATE LIMITED",
"AURUM REALESTATE DEVELOPERS LIMITED",
"AURUM TRADING INDIA PRIVATE LIMITED",
"AURUM TRANS SOLUTIONS PRIVATE LIMITED",
"AURUM VENTURES PRIVATE LIMITED",
"AURUS INFRASTRUCTURE PRIVATE LIMITED",
"AURUS IT SOLUTIONS PRIVATE LIMITED",
"AURUS TECH PRIVATE LIMITED",
"AURV SOLUTION PRIVATE LIMITED",
"AURVEN TECHNOLOGIES INDIA PRIVATE LIMITED",
"AURYN INDIA PRIVATE LIMITED",
"AUSA MEDICAL DEVICES PRIVATE LIMITED",
"AUSADH VYAPAAR PRIVATE LIMITED",
"AUSCAN CONSULTANTS INDIA LIMITED",
"AUSCANZ OVERSEAS EDUCATION PRIVATE LIMITED",
"AUSDIA SOFTWARE INDIA PRIVATE LIMITED",
"AUSENCO ENGINEERS PRIVATE LIMITED",
"AUSHA EXPORTS (OPC) PRIVATE LIMITED",
"AUSHAD PHARMA DISTRIBUTORS PRIVATE LIMITED",
"AUSHADH LIMITED",
"AUSHTA CONSULTING ENGINEERS INDIA PRIVATE LIMITED",
"AUSIL CORPORATION PRIVATE LIMITED",
"AUSKINCARE",
"AUSLAND SHIP MANAGEMENT SERVICES PRIVATE LIMITED",
"AUSOM ENTERPRISE LIMITED",
"AUSPHARMA PRIVATE LIMITED",
"AUSPICIOUS CONSTRUCTIONS COMPANY PRIVATE LIMITED",
"AUSPIK PHARMACEUTICALS PRIVATE LIMITED",
"AUSREO TECHNICAL SERVICES INDIA PRIVATE LIMITED",
"AUSSEE OATS INDIA LIMITED",
"AUSSIN INTENSIVE CARE PRIVATE LIMITED",
"AUSSIZZ INDIA PRIVATE LIMITED",
"AUSTECH ENGGFAB PRIVATE LIMITED",
"AUSTEN HADFIELD MANUFACTURING COMPANY PRIVATE LIMITED",
"AUSTENITE FORGE PRIVATE LIMITED",
"AUSTENITE TUBE INDUSTRIES PRIVATE LIMITED",
"AUSTENITIC STEELS PVT LTD",
"AUSTEOFIX SURGICAL PRIVATE LIMITED",
"AUSTERE ANALYTICS SOLUTIONS PRIVATE LIMITED",
"AUSTERE LOGISTICS PRIVATE LIMITED",
"AUSTERE SYSTEMS PRIVATE LIMITED",
"AUSTEX PHARMACEUTICAL PRIVATE LIMITED",
"AUSTHAVINAYAK TEXTILE INDIA PRIVATE LIMITED",
"AUSTIN ALLOY CAST PRIVATE LIMITED",
"AUSTIN DISTRIBUTORS PRIVATE LIMITED",
"AUSTIN ENGINEERING COMPANY LIMITED",
"AUSTIN FOODS AND BEVERAGES PRIVATE LIMITED",
"AUSTIN INFO CONSULTANCY PRIVATE LIMITED",
"AUSTIN INFOTECH PRIVATE LIMITED",
"AUSTIN LEDER GARMENTS PRIVATE LIMITED",
"AUSTIN MEDICAL SOLUTIONS PRIVATE LIMITED",
"AUSTIN MONKS PRIVATE LIMITED",
"AUSTIN PHARMACEUTICALS LIMITED",
"AUSTIN PLYWOOD PRIVATE LIMITED",
"AUSTRAK PRIVATE LIMITED",
"AUSTRALIA & NEW ZEALAND BANKING",
"AUSTRALIA AND NEW ZEALAND BANKING GROUP LIMITED",
"AUSTRALIA INDIA INSTITUTE PRIVATE LIMITED",
"AUSTRALIAN CONSULATE GENERAL",
"AUSTRALIAN COUNCIL FOR EDUCATIONAL RESEARCH (INDIA)",
"AUSTRALIAN COUNCIL FOR EDUCATIONAL RESEARCH INDIA",
"AUSTRALIAN FOODS INDIA PRIVATE LIMITED",
"AUSTRALIAN GOVERNMENT",
"AUSTRALIAN PREMIUM SOLAR (INDIA) LIMITED",
"AUSTRALIAN PREMIUM SOLAR INDIA PRIVATE LIMITED",
"AUSTRAX TECHNOLOGIES INDIA PRIVATE LIMITED",
"AUSTRAZEN BIO PHARMACEUTICALS PRIVATE LIMITED",
"AUSTRIAN AIRLINES AG",
"AUSTRIAN EMBASSY",
"AUSTRO CHEMICALS AND BIO TECHNOLOGIES PRIVATE LIMITED",
"AUSTRO LABS LIMITED",
"AUSY TECHNOLOGIES INDIA PRIVATE LIMITED",
"AUTADE INFRAPROJECTS PRIVATE LIMITED",
"AUTADE SPINNERS PRIVATE LIMITED",
"AUTHBRIDGE RESEARCH SERVICES PRIVATE LIMITED",
"AUTHENTIC BUILDING SYSTEMS PRIVATE LIMITED",
"AUTHENTIC DEVELOPERS PRIVATE LIMITED",
"AUTHENTIC ENCON PRIVATE LIMITED",
"AUTHENTIC ENGINEERS INDIA PRIVATE LIMITED",
"AUTHENTIC FINANCE PRIVATE LIMITED",
"AUTHENTIC HEALTHCARE SERVICES PRIVATE LIMITED",
"AUTHENTIC INSURANCE BROKERS INDIA LIMITED",
"AUTHENTIC PACKAGING PRIVATE LIMITED",
"AUTHENTIC STAFFING AGENCY",
"AUTHENTIC TRAVELS PRIVATE LIMITED",
"AUTHENTICA VENTURES PRIVATE LIMITED",
"AUTHENTICID SOLUTIONS INDIA PRIVATE LIMITED",
"AUTHENTICITY",
"AUTHORGEN TECHNOLOGIES PRIVATE LIMITED",
"AUTHUM INVESTMENT & INFRASTRUCTURE LIMITED",
"AUTIOT ENGINEERING & CONSULTING SERVICES PRIVATE LIMITED",
"AUTMEC ENGINEERS (I) PRIVATE LIMITED",
"AUTNEX INDIA PRIVATE LIMITED",
"AUTNHIVE PRIVATE LIMITED",
"AUTO AGRIC INDUSTRIES PRIVATE LIMITED",
"AUTO AIDC TECHNOLOGIES INDIA PRIVATE LIMITED",
"AUTO ASSIST-RECON INDIA PRIVATE LIMITED",
"AUTO AXIS PRIVATE LIMITED",
"AUTO BRASS PRIVATE LIMITED",
"AUTO CARRIAGE PRIVATE LIMITED",
"AUTO CLUSTER DEVELOPMENT AND RESEARCH INSTITUTE",
"AUTO CLUTCHES CASTINGS PRIVATE LIMITED",
"AUTO CNC MACHINING LIMITED",
"AUTO CORP OF GOA",
"AUTO DONUTS PRIVATE LIMITED",
"AUTO FEED (INDIA) PRIVATE LIMITED",
"AUTO GEARS PRIVATE LIMITED",
"AUTO GLASS TRADERS PRIVATE LIMITED",
"AUTO GRAPH CARS (INDIA) PRIVATE LIMITED",
"AUTO HANGAR I PRIVATE LIMITED",
"AUTO HANGAR INSURANCE BROKERS PRIVATE LIMITED",
"AUTO HI-LINK PRIVATE LIMITED",
"AUTO HI-TECH PRIVATE LIMITED",
"AUTO HOUSE INDIA PRIVATE LIMITED",
"AUTO IGNITION LIMITED.",
"AUTO INGRESS INDIA PRIVATE LIMITED",
"AUTO INTERNATIONAL(INDIA) PRIVATE LIMITED",
"AUTO JUNCTION INDIA PRIVATE LIMITED",
"AUTO KASHYAP INDIA PRIVATE LIMITED",
"AUTO MECH INDIA PRIVATE LIMITED",
"AUTO MOBILES STERLING INDIA PRIVATE LIMITED",
"AUTO MOTIVE POWER MOBILITY PRIVATE LIMITED",
"AUTO MUGHALS PRIVATE LIMITED",
"AUTO PARTS DISTRIBUTING INDIA PRIVATE LIMITED",
"AUTO PICKUP PETRO CHEM PRIVATE LIMITED",
"AUTO PINS (INDIA) LIMITED",
"AUTO POWER GEN SYSTEMS PRIVATE LIMITED",
"AUTO PROFILES LIMITED",
"AUTO RECYCLING SYSTEMS PRIVATE LIMITED",
"AUTO REPOWERING WORKS INDIA PRIVATE LIMITED",
"AUTO SALES AGENCIES PRIVATE LIMITED",
"AUTO SALES INDIA LIMITED",
"AUTO SERV EQUIPMENT PRIVATE LIMITED",
"AUTO SHELL CASTS PRIVATE LIMITED",
"AUTO SHELL PERFECT MOULDER LIMITED",
"AUTO SOLUTIONS PRIVATE LIMITED",
"AUTO SONICS (INDIA) PRIVATE LIMITED",
"AUTO SPA",
"AUTO START INDIA PRIVATE LIMITED",
"AUTO START MOTERS PRIVATE LIMITED",
"AUTO STEEL AND RUBBER INDUSTRIES PRIVATE LIMITED",
"AUTO TOOLS PRIVATE LIMITED",
"AUTO TRANSPORT SERVICES",
"AUTO TRICKS PRIVATE LIMITED",
"AUTO WINDOW INDIA PRIVATE LIMITED",
"AUTOADMINS",
"AUTOBAHN AUTOMOTIVE PRIVATE LIMITED",
"AUTOBAHN CARS & ACCESSORIES PRIVATE LIMITED",
"AUTOBAHN ENTERPRISES PRIVATE LIMITED",
"AUTOBAHN MOTOR PRODUCTS PRIVATE LIMITED",
"AUTOBAHN TRUCKING CORPORATION PRIVATE LIMITED",
"AUTOBAT ACCUMULATOR PRIVATE. LIMITED.",
"AUTOBAT BATTERIES PRIVATE LIMITED",
"AUTOBEST AUTOMOTIVE (INDIA) PRIVATE LIMITED",
"AUTOBOT INFOSEC PRIVATE LIMITED",
"AUTOCAL SOLUTIONS PRIVATE LIMITED",
"AUTOCAR COLOUR & COATINGS PRIVATE LIMITED",
"AUTOCLEANZE WASHING SYSTEMS LLP",
"AUTOCOATS",
"AUTOCOMP CORPORATION PANSE PRIVATE LIMITED",
"AUTOCOMP INDIA PRIVATE LIMITED",
"AUTOCONTROL PROCESS INSTRUMENTATION PRIVATE LIMITED",
"AUTOCOP INDIA PRIVATE LIMITED",
"AUTOCORP INDUSTRIES PRIVATE LIMITED",
"AUTOCRACY MACHINERY PRIVATE LIMITED",
"AUTOCRAFT TOWERS PRIVATE LIMITED",
"AUTOCREATES SERVICES PRIVATE LIMITED",
"AUTODATA TECHNOLOGIES PRIVATE LIMITED",
"AUTODEN WHEELS PRIVATE LIMITED",
"AUTODESK INDIA PRIVATE LIMITED",
"AUTODISIR PERFORMANCE PRIVATE LIMITED",
"AUTODYNAMIC TECHNOLOGIES & SOLUTIONS PRIVATE LIMITED",
"AUTOEDGE ADVANCED AUTOMATION TECHNOLOGIES PRIVATE LIMITED",
"AUTOEDGE TRADERS PRIVATE LIMITED",
"AUTOFINITY VENTURES PRIVATE LIMITED",
"AUTOFIT CAR INTERIORS PRIVATE LIMITED",
"AUTOFIT PRIVATE LIMITED",
"AUTOFITS PACKAGING PRIVATE LIMITED",
"AUTOFLOW TECHNOLOGIES PRIVATE LIMITED",
"AUTOFOCUS CONSULTANTS INDIA PRIVATE LIMITED",
"AUTOFORM ENGINEERING INDIA PRIVATE LIMITED",
"AUTOFURNISH TRADING PRIVATE LIMITED",
"AUTOGEN ENGINEERING PRIVATE LIMITED",
"AUTOGEN INDIA PRIVATE LIMITED",
"AUTOGENUINE PROJECTS SALES & SERVICE PRIVATE LIMITED",
"AUTOGISTIC ENGINEERING PRIVATE LIMITED",
"AUTOGRADE INDUSTRIES PRIVATE LIMITED",
"AUTOGRID INDIA PRIVATE LIMITED",
"AUTOGUILD CARS PRIVATE LIMITED",
"AUTOICON VEHICLE LOUNGE PRIVATE LIMITED",
"AUTOINSTRUMENTS CALIBRATION LABORATORY PRIVATE LIMITED",
"AUTOKARTZ INTERNET PRIVATE LIMITED",
"AUTOKAST LTD",
"AUTOLEC INTERNATIONAL PVT LTD",
"AUTOLIGHT GLASS PRIVATE LIMITED",
"AUTOLINE DESIGN SOFTWARE LIMITED",
"AUTOLINE INDUSTRIES LIMITED",
"AUTOLIV INDIA PRIVATE LIMITED",
"AUTOLOGIC MOTORS INDIA PRIVATE LIMITED",
"AUTOLOGIC MOTORSI PRIVATE LIMITED",
"AUTOLOGIX PRIVATE LIMITED",
"AUTOLOGUE MOTOR DESIGNS PRIVATE LIMITED",
"AUTOMAG INDIA PRIVATE LIMITED",
"AUTOMANN AGRO PRIVATE LIMITED",
"AUTOMARK INDIA PRIVATE LIMITED",
"AUTOMARK INDUSTRIES INDIA PRIVATE LIMITED",
"AUTOMARK MOTORS PRIVATE LIMITED",
"AUTOMARK PRIVATE LIMITED",
"AUTOMAT INDUSTRIES PRIVATE LIMITED",
"AUTOMAT IRRIGATION PRIVATE LIMITED",
"AUTOMATAPI SOLUTIONS PRIVATE LIMITED",
"AUTOMATED BUILDING MANAGEMENT SYSTEMS PRIVATE LIMITED",
"AUTOMATED TEST SYSTEM TECHNOLOGIES PRIVATE LIMITED",
"AUTOMATED TOOLING SYSTEMS INDIA PRIVATE LIMITED",
"AUTOMATED WORKFLOW PRIVATE LIMITED",
"AUTOMATIC DATA PROCESSING INC.",
"AUTOMATIC ELECTRIC LIMITED",
"AUTOMATIC INFOTECH PRIVATE LIMITED",
"AUTOMATIC INSTRUMENTS PRIVATE LIMITED",
"AUTOMATIC IT SERVICES PRIVATE LIMITED",
"AUTOMATIC SOFTWARE PRIVATE LIMITED",
"AUTOMATIC TILES AND MARBLES INDUSTRIES PRIVATE LIMITED",
"AUTOMATIC TRANSMISSION PARTS AND SERVICES PRIVATE LIMITED",
"AUTOMATION ANYWHERE SOFTWARE PRIVATE LIMITED",
"AUTOMATION ENGINEERS A B PRIVATE LIMITED",
"AUTOMATION EXCELLENCE PRIVATE LIMITED",
"AUTOMATION INDIA WELDING TECHNOLOGY PRIVATE LIMITED",
"AUTOMATION MANIFOLD SERVICES PRIVATE LIMITED",
"AUTOMATION NETWORK AND SERVICES PRIVATE LIMITED",
"AUTOMATION SYSTEM ENGINEERS PRIVATE LIMITED",
"AUTOMATION SYSTEMS AND SOLUTIONS (INDIA)PRIVATE LIMITED",
"AUTOMATIONEDGE TECHNOLOGIES PRIVATE LIMITED",
"AUTOMECH ENGINEERING INDIA PRIVATE LIMITED",
"AUTOMECH HANDLERS INDIA PRIVATE LIMITED",
"AUTOMECH INDUSTRIES PRIVATE LIMITED",
"AUTOMED MATERIAL HANDLING SOLUTIONS PRIVATE LIMITED",
"AUTOMED SYSTEMS PRIVATE LIMITED",
"AUTOMETERS ALLIANCE LIMITED",
"AUTOMETERS ENERGITEC LIMITED",
"AUTOMETERS LIMITED",
"AUTOMJET SERVICES PRIVATE LIMITED",
"AUTOMOBILE ASSOCIATION OF EASTERN INDIA",
"AUTOMOBILE ASSOCIATION OF SOUTHERN INDIA",
"AUTOMOBILE CORPORATION OF GOA LIMITED",
"AUTOMOBILE PRESS TOOL DESIGNAR",
"AUTOMOTIVE AND INDUSTRIAL SEALS PRIVATE LIMITED",
"AUTOMOTIVE AXLES LIMITED",
"AUTOMOTIVE COMPONENT MANUFACTURERS ASSOCIATION OF INDIA",
"AUTOMOTIVE COMPONENTS TECHNOLOGY INDIA PRIVATE LIMITED",
"AUTOMOTIVE DESIGN AND ENGINEERING SOLUTIONS PRIVATE LIMITED",
"AUTOMOTIVE INSULATIONS PRIVATE LIMITED",
"AUTOMOTIVE MANUFACTURERS PRIVATE LIMITED",
"AUTOMOTIVE MOTORS PRIVATE LIMITED",
"AUTOMOTIVE ROBOTICS INDIA PRIVATE LIMITED",
"AUTOMOTIVE SKILLS DEVELOPMENT COUNCIL",
"AUTOMOTIVE STAMPINGS AND ASSEMBLIES LIMITED",
"AUTOMOTIVE TECHNO PRIVATE LIMITED",
"AUTOMOTIVE TYRE MANUFACTURERS ASSOCIATION",
"AUTOMOTIVE VALVES PRIVATE LTD",
"AUTONATION INC.",
"AUTONET MARKETING PRIVATE LIMITED",
"AUTONEUM INDIA PRIVATE LIMITED",
"AUTONEUM NITTOKU SOUND PROOF PRODUCTS INDIA PRIVATE LIMITED",
"AUTONIC ENERGY SYSTEMS PRIVATE LIMITED",
"AUTONICS AUTOMATION INDIA PRIVATE LIMITED",
"AUTONICS MACHINES INDIA PRIVATE LIMITED",
"AUTONIX AUTO INDUSTRIES PRIVATE LIMITED",
"AUTONIX LIGHTING INDUSTRIES PRIVATE LIMITED",
"AUTONOM8 PRIVATE LIMITED",
"AUTONOMY HOMES PRIVATE LIMITED",
"AUTONOMY SOFTWARE ASIA PRIVATE LIMITED",
"AUTONUM CONTROLS PRIVATE LIMITED",
"AUTOONE ENGINEERING SERVICES PRIVATE LIMITED",
"AUTOPACE NETWORK PRIVATE LIMITED",
"AUTOPACK MACHINES PRIVATE LIMITED",
"AUTOPAL MANUFACTURING PRIVATE LIMITED",
"AUTOPARTS HUB PRIVATE LIMITED",
"AUTOPARTS SOLUTIONS PRIVATE LIMITED",
"AUTOPASSION ENGINEERING PRIVATE LIMITED",
"AUTOPE PAYMENT SOLUTIONS PRIVATE LIMITED",
"AUTOPLANT SYSTEM INDIA PRIVATE LIMITED",
"AUTOPLAST POLYTECH PRIVATE LIMITED",
"AUTOPRESS INDIA PRIVATE LIMITED",
"AUTOPRINT FORMULA SOLUTIONS PRIVATE LIMITED",
"AUTOPRINT MACHINERY MANUFACTURERS PRIVATE LIMITED",
"AUTOPROC TECHNOLOGIES PRIVATE LIMITED",
"AUTORABIT SOFTWARE PRIVATE LIMITED",
"AUTORELLI CARS PRIVATE LIMITED",
"AUTORELLI MOTORS PRIVATE LIMITED",
"AUTORIDERS INTERNATIONAL PRIVATE LIMITED",
"AUTOSCAN INDIA PRIVATE LIMITED",
"AUTOSENSE PRIVATE LIMITED",
"AUTOSHELL ELECTROMECH PRIVATE LIMITED",
"AUTOSMART AGENCIES PRIVATE LIMITED",
"AUTOSOFT INDIA ENGINEERING PRIVATE LIMITED",
"AUTOSOL INDIA PRIVATE LIMITED",
"AUTOSTARKE PRIVATE LIMITED",
"AUTOSTRADE INDIAN INFRASTRUCTURE DEVELOPMENT PRIVATE LIMITED",
"AUTOSYS CONTROL SYSTEMS INDIA PRIVATE LIMITED",
"AUTOSYS INDUSTRIAL SOLUTIONS PRIVATE LIMITED",
"AUTOSYS PRODUCTS AND SERVICES PRIVATE LIMITED",
"AUTO-TEC ENGINEERING SERVICES PRIVATE LIMITED",
"AUTOTEC SYSTEMS PRIVATE LIMITED",
"AUTOTECH ANCILLARIES LIMITED",
"AUTOTECH COMPONENTS PRIVATE LIMITED",
"AUTOTECH INDUSTRIES INDIA PRIVATE LIMITED",
"AUTOTECH NON-WOVENS PRIVATE LIMITED",
"AUTOTECH SIRMAX INDIA PRIVATE LIMITED",
"AUTOTECHNIX CONTROL SYSTEMS PRIVATE LIMITED",
"AUTOTEK STEEL ENGINEERS PRIVATE LIMITED",
"AUTOTEK TOOLS AND COMPONENTS PRIVATE LIMITED",
"AUTOTEST MACHANISMS PRIVATE LIMITED",
"AUTOTEX PRIVATE LIMITED",
"AUTOTRAC FINANCE LIMITED",
"AUTOTRADE AVIATION PRIVATE LIMITED",
"AUTOTRONICS INDUSTRIES PRIVATE LIMITED",
"AUTOTROPIC CLOUD TECHNOLOGIES PRIVATE LIMITED",
"AUTOTURNERS AUTOMATIONS PRIVATE LIMITED",
"AUTOVEER PRIVATE LIMITED",
"AUTOVERT TECHNOLOGIES PRIVATE LIMITED",
"AUTOVIKAS SALES AND SERVICE PRIVATE LIMITED",
"AUTOVOGUE PRIVATE LIMITED",
"AUTOVUE ELECTRONICS (PUNE) P LTD",
"AUTOZONE INC.",
"AUTRONIC SYSTEMS (INDIA) PRIVATE LIMITED",
"AUTUM IMPEX PRIVATE LIMITED",
"AUTUMN ADVERTISING PRIVATE LIMITED",
"AUTUS ENTERPRISES PRIVATE LIMITED",
"AUTUS HEALTHCARE",
"AUTUS SECURITIES PRIVATE LIMITED",
"AUTUS WEALTH PRIVATE LIMITED",
"AUXAGRI FARMER PRODUCER COMPANY LIMITED",
"AUXANO GLOBAL SERVICES PRIVATE LIMITED",
"AUXANO TECHNOLOGIES PRIVATE LIMITED",
"AUXEIN MEDICAL PRIVATE LIMITED",
"AUXEL FTG INDIA PRIVATE LIMITED",
"AUXESIA LIFE SCIENCES PRIVATE LIMITED",
"AUXIBLE INDIA PRIVATE LIMITED",
"AUXILIA TECHNOLOGIES PRIVATE LIMITED",
"AUXILIARIES INDIA PRIVATE LIMITED",
"AUXILIARY POWER SERVICE PRIVATE LIMITED",
"AUXILINK PLASTIC TECHNOLOGIES PRIVATE LIMITED",
"AUXILINK PROJECTS & MACHINERY PRIVATE LIMITED",
"AUXILIUM COLLEGE VELLORE",
"AUXILO FINSERVE PRIVATE LIMITED",
"AUXIN SHIPPING PRIVATE LIMITED",
"AUXINO PRIVATE LIMITED",
"AUXIO SOLUTIONS PRIVATE LIMITED",
"AUXO INDUSTRIES PRIVATE LIMITED",
"AUXO INTERNATIONAL LOGISTICS PRIVATE LIMITED",
"AUXO TECHNOLOGY LABS PRIVATE LIMITED",
"AUXOCHROMOFOURS SOLUTIONS PRIVATE LIMITED",
"AUZEN LIFE SCIENCES PRIVATE LIMITED",
"AUZMA SOLUTIONS PRIVATE LIMITED",
"AUZMOR TECHNOLOGY PRIVATE LIMITED",
"AV ABACUS INTERNATIONAL PRIVATE LIMITED",
"AV AGRITECH INPUTS PRIVATE LIMITED",
"AV CLAYTECH PRIVATE LIMITED",
"AV COLLECTION AND MARKETING PRIVATE LIMITED",
"AV DEGREE COLLEGE",
"AV DESIGN LAB PRIVATE LIMITED",
"AV DEVS SOLUTIONS PRIVATE LIMITED",
"AV FAMILY WEARS PRIVATE LIMITED",
"AV FASTENRS PRIVATE LIMITED",
"AV FINANCIAL EXPERTS NETWORK PRIVATE LIMITED",
"AV FINCORP PRIVATE LIMITED",
"AV GREEN SOLUTIONS PRIVATE LIMITED",
"AV GROUP NB",
"AV INDIA ELASTOMERS PRIVATE LIMITED",
"AV INDIA PLASTO POLYMERS PRIVATE LIMITED",
"AV INFO MEDIA PRIVATE LIMITED",
"AV INSTRUMENTATION PRIVATE LIMITED",
"AV INTEGRATION DISTRIBUTION INDIA PRIVATE LIMITED",
"AV OVERSEASCARGO PRIVATE LIMITED",
"AV PROCESSORS PRIVATE LIMITED",
"AV RELIABLE PRIVATE LIMITED",
"AV RETAIL PRIVATE LIMITED",
"AV SCIENCE & TECHNOLOGIES PRIVATE LIMITED",
"AV SECURITY HOSPITALITY SERVICES",
"AV SOURCING PRIVATE LIMITED",
"AV STAINLESS TUBES PRIVATE LIMITED",
"AV STEEL & POWER LLP",
"AV THOMAS & CO LIMITED",
"AV TRADEMART PRIVATE LIMITED",
"AV VISHWA ENTERPRISES PRIVATE LIMITED",
"AV WIRES PRIVATE LIMITED",
"AV WOOD COATINGS PRIVATE LIMITED",
"AV XPLORE PRIVATE LIMITED",
"AV. MODULAR INDIA PRIVATE LIMITED",
"AVA APPARELS LLP",
"AVA CHEMICALS PRIVATE LIMITED.",
"AVA CHOLAYIL HEALTH CARE PRIVATE LIMITED",
"AVA CONDIMENTS LLP",
"AVA CONDIMENTS PRIVATE LIMITED",
"AVA DESIGN PRIVATE LIMITED",
"AVA ECONOMETRIC SERVICES PRIVATE LIMITED",
"AVA GLOBAL LOGISTICS LLP",
"AVA HANDFAB PRIVATE LIMITED",
"AVA INFOTECH PRIVATE LIMITED",
"AVA INTERNATIONAL PRIVATE LIMITED",
"AVA LIFESTYLE PRODUCTS & SERVICES PRIVATE LIMITED",
"AVA MARINE SERVICES PRIVATE LIMITED",
"AVA NATURALS PRIVATE LIMITED",
"AVA PRODUCTS & SERVICES",
"AVA RETAIL PRIVATE LIMITED",
"AVA SOFTWARE PRIVATE LIMITED",
"AVAADA CLEAN ENERGY PRIVATE LIMITED",
"AVAADA CLEAN PROJECT PRIVATE LIMITED",
"AVAADA CLEAN TNPROJECT PRIVATE LIMITED",
"AVAADA ENERGY PRIVATE LIMITED",
"AVAADA FOUNDATION",
"AVAADA GREEN HNPROJECT PRIVATE LIMITED",
"AVAADA KNSOLAR PRIVATE LIMITED",
"AVAADA MHBULDHANA PRIVATE LIMITED",
"AVAADA MHKHAMGAON PRIVATE LIMITED",
"AVAADA MHSOLAR PRIVATE LIMITED",
"AVAADA MHSUSTAINABLE PRIVATE LIMITED",
"AVAADA MHYAVAT PRIVATE LIMITED",
"AVAADA NON-CONVENTIONAL ENERGY PRIVATE LIMITED",
"AVAADA NON-CONVENTIONAL UPPROJECT PRIVATE LIMITED",
"AVAADA POWER PRIVATE LIMITED",
"AVAADA RJHN PRIVATE LIMITED",
"AVAADA SATARAMH PRIVATE LIMITED",
"AVAADA SOLAR ENERGY PRIVATE LIMITED",
"AVAADA SOLARISE ENERGY PRIVATE LIMITED",
"AVAADA SUNCE ENERGY PRIVATE LIMITED",
"AVAADA SUNRAYS ENERGY PRIVATE LIMITED",
"AVAADA SUNRISE ENERGY PRIVATE LIMITED",
"AVAADA SUSTAINABLE ENERGY PRIVATE LIMITED",
"AVAADA SUSTAINABLE RJPROJECT PRIVATE LIMITED",
"AVAADA VENTURES PRIVATE LIMITED",
"AVAAL TECHNOLOGIES INDIA PRIVATE LIMITED",
"AVAALI SOLUTIONS PRIVATE LIMITED",
"AVAAMO TECHNOLOGIES PRIVATE LIMITED",
"AVAAN INTERNATIONAL PRIVATE LIMITED",
"AVAAPYA CONSULTANCY SERVICES PRIVATE LIMITED",
"AVAC SYSTEMS PRIVATE LIMITED",
"AVACA PHARMA PRIVATE LIMITED",
"AVACADO PROPERTIES AND TRADING INDIA PRIVATE LIMITED",
"AVACARE SHARED SERVICES INDIA PRIVATE LIMITED",
"AVACCI TELAGIO PRIVATE LIMITED",
"AVACEND SOLUTIONS PRIVATE LIMITED",
"AVADAT TRENDZ PRIVATE LIMITED",
"AVADH ALLOYS PRIVATE LIMITED",
"AVADH CLUBS LIMITED",
"AVADH CONSTRUCTION",
"AVADH COTEX PRIVATE LIMITED",
"AVADH COTTON INDUSTRIES- JAMNAGAR",
"AVADH DEVELOPERS PRIVATE LIMITED",
"AVADH ENGINEERING PRIVATE LIMITED",
"AVADH ENGINES AND MACHINES PRIVATE LIMITED",
"AVADH ENTERPRISES",
"AVADH FORGE PRIVATE LIMITED",
"AVADH INFRA PROJECT",
"AVADH INFRASTRUCTURE PRIVATE LIMITED",
"AVADH INFRATECH",
"AVADH KIMBERLY",
"AVADH MULTISPECIALITY HOSPITAL",
"AVADH PLASTOWARES PRIVATE LIMITED",
"AVADH POLYTUBES PRIVATE LIMITED",
"AVADH RAIL INFRA LIMITED",
"AVADH SNACKS PRIVATE LIMITED",
"AVADH SOLVEX PRIVATE LIMITED",
"AVADH SUGAR & ENERGY LIMITED.",
"AVADH TALKIES PICTURES PRIVATE LIMITED",
"AVADHAN FARMERS PRODUCER COMPANY LIMITED",
"AVADHESH MILK PRODUCTS PRIVATE LIMITED",
"AVADHOOT PAPER PRODUCTS PRIVATE LIMITED",
"AVADHOOT PROJECT PRIVATE LIMITED",
"AVADHUT SATHE TRADING ACADEMY PRIVATE LIMITED",
"AVADON PRIVATE LIMITED",
"AVAETA US NETWORKS (OPC) PRIVATE LIMITED",
"AVAHAN MOTORS PRIVATE LIMITED",
"AVAIDS TECHNOVATORS PRIVATE LIMITED",
"AVAIL SECURITIES PRIVATE LIMITED",
"AVAIL SOLUTIONS PRIVATE LIMITED",
"AVAILITY INDIA PRIVATE LIMITED",
"AVAKART TECHNOLOGY SERVICES PRIVATE LIMITED",
"AVAL FASHION HOUSE",
"AVALAMB SERVICES (OPC) PRIVATE LIMITED",
"AVALANCHE FOOD AND BEVERAGES PRIVATE LIMITED",
"AVALANCHE IMPEX PRIVATE LIMITED",
"AVALANCHE OVERSEAS PRIVATE LIMITED",
"AVALARA TECHNOLOGIES PRIVATE LIMITED",
"AVALOKITESHVAR VALINV LIMITED",
"AVALON BUILDERS PRIVATE LIMITED",
"AVALON CONTAINERS PRIVATE LIMITED",
"AVALON COSMETICS PRIVATE LIMITED",
"AVALON FOOTWEARS PRIVATE LIMITED",
"AVALON GROUP PRIVATE LIMITED",
"AVALON HEIGHTS INTERNATIONAL SCHOOL",
"AVALON INFORMATION SYSTEMS PRIVATE LIMITED",
"AVALON PHARMA PRIVATE LIMITED",
"AVALON POWER PRIVATE LIMITED",
"AVALON RESORTS PRIVATE LIMITED",
"AVALON SOLUTIONS PRIVATE LIMITED",
"AVALON TECHNOLOGIES LIMITED",
"AVALON TECHNOLOGIES PRIVATE LIMITED",
"AVALON TECHNOLOGY AND SERVICES PRIVATE LIMITED",
"AVALONMETA VENTURES PRIVATE LIMITED",
"AVALOQ INDIA PRIVATE LIMITED",
"AVALTA GRANITO PRIVATE LIMITED",
"AVAM BUSINESS PRIVATE LIMITED",
"AVAM LOGISTICS PRIVATE LIMITED",
"AVAN FORTUNES PRIVATE LIMITED",
"AVAN VENTURES PRIVATE LIMITED",
"AVANA ELECTRO SYSTEMS PRIVATE LIMITED",
"AVANA LIFESCIENCE PRIVATE LIMITED",
"AVANA LOGISTEK LIMITED",
"AVANA MEDICAL DEVICES PRIVATE LIMITED",
"AVANA SURGICAL SYSTEMS PRIVATE LIMITED",
"AVANCE ENGINEERING AND INFRASTRUCTURES PRIVATE LIMITED",
"AVANCE GLOBALTECH CONSULTANCY PRIVATE LIMITED",
"AVANCE LIGHTING INDUSTRIES PRIVATE LIMITED",
"AVANCE TECHNOHUB PRIVATE LIMITED",
"AVANCE TECHNOLOGIES LIMITED",
"AVANCE-ATLAS INFRATECH PRIVATE LIMITED",
"AVANCER LABS PRIVATE LIMITED",
"AVANCER SOFTWARE SOLUTIONS PRIVATE LIMITED",
"AVANCER TRAVEL SOLUTION PRIVATE LIMITED",
"AVANCIERS TECHNICAL (INDIA) PRIVATE LIMITED",
"AVANEEL KUMKUM PRIVATE LIMITED",
"AVANEESH LOGISTICS PRIVATE. LIMITED.",
"AVANEESH TRADING PRIVATE LIMITED",
"AVANEETHA TEXTILES PRIVATE LIMITED",
"AVANGARDE ENTERPRISES PRIVATE LIMITED",
"AVANGUARDIA LIFESTYLE LLP",
"AVANI ALLOY & STEEL PRIVATE LIMITED",
"AVANI ARTECH COOLING TOWWERS PRIVATE LIMITED",
"AVANI AYURVEDA PRIVATE LIMITED",
"AVANI ENERGY & RESOURCES PRIVATE LIMITED",
"AVANI ENGINEERING CONSULTANCY PRIVATE LIMITED",
"AVANI FERRO ALLOYS PRIVATE LIMITED",
"AVANI FOREX PRIVATE LIMITED",
"AVANI INFOSOFT PRIVATE LIMITED",
"AVANI INTERNATIONAL PRIVATE LIMITED",
"AVANI LEISURE PRIVATE LIMITED",
"AVANI MEDI AID PRIVATE LIMITED",
"AVANI PACK & WRAP PRIVATE LIMITED",
"AVANI PACKAGING PRIVATE LIMITED",
"AVANI PARIDHI ENERGY & COMMUNICATIONS PRIVATE LIMITED",
"AVANI PARIDHI ENTERTAINMENT AND BROADCASTING PRIVATE LIMITED",
"AVANI PARIDHI HEALTH CARE PRIVATE LIMITED",
"AVANI PETROCHEMICALS PRIVATE LIMITED",
"AVANI POLY PRIVATE LIMITED",
"AVANI SEEDS LIMITED",
"AVANI SILICATES PRIVATE LIMITED",
"AVANI SURGICAL PRIVATE LIMITED",
"AVANI TECH SOLUTIONS PRIVATE LIMITED",
"AVANI TEXTILES LIMITED",
"AVANII AGRI PRODUCTS PRIVATE LIMITED",
"AVANIKO TECHNOLOGIES PRIVATE LIMITED",
"AVANISH MOTORS PRIVATE LIMITED",
"AVANITH ENGINEERS PRIVATE LIMITED",
"AVANKIA SOFTWARE PRIVATE LIMITED",
"AVANN BUILDSYS PRIVATE LIMITED",
"AVANOS MEDICAL INDIA PRIVATE LIMITED",
"AVANSA IT SOLUTIONS PRIVATE LIMITED",
"AVANSABER TECHNOLOGIES PRIVATE LIMITED",
"AVANSCURE LIFESCIENCES PRIVATE LIMITED",
"AVANSDOSE PHARMATECH PRIVATE LIMITED",
"AVANSE FINANCIAL SERVICES LIMITED",
"AVANSEUS TECHNOLOGIES PRIVATE LIMITED",
"AVANSHIKA RETAIL SOLUTIONS PRIVATE LIMITED",
"AVANT CAREER PRIVATE LIMITED",
"AVANT EDGE BUSINESS CONSULTING PRIVATE LIMITED",
"AVANT FINWISE PRIVATE LIMITED",
"AVANT FREIGHT SYSTEMS PRIVATE LIMITED",
"AVANT GARDE ADVISORY PRIVATE LIMITED",
"AVANT GARDE BUILDING SOLUTIONS PRIVATE LIMITED",
"AVANT GARDE CARPETS PRIVATE LIMITED",
"AVANT GARDE CLEANROOM & ENGG SOLUTIONS PRIVATE LIMITED",
"AVANT- GARDE ENGINEERS AND CONSULTANTS PRIVATE LIMITED",
"AVANT GARDE FARMERS PRODUCER COMPANY LIMITED",
"AVANT GARDE HEALTHCARE ENGG SOLUTIONS PRIVATE LIMITED",
"AVANT GARDE RE-ENERGY PRIVATE LIMITED",
"AVANT GARDE SILKS PRIVATE LIMITED",
"AVANT GARDE SOFTWARE PRIVATE LIMITED",
"AVANT GARDE SYSTEMS AND CONTROLS PRIVATE LIMITED",
"AVANT PHARMACEUTICALS PRIVATE LIMITED",
"AVANT SANTE INDIA PRIVATE LIMITED",
"AVANT TRADING COMPANY PRIVATE LIMITED",
"AVANTA BUSINESS CENTRE (GURGAON) PRIVATE LIMITED",
"AVANTA BUSINESS CENTRE (MUMBAI) PRIVATE LIMITED",
"AVANTA BUSINESS CENTRE (NP) PRIVATE LIMITED",
"AVANTA BUSINESS CENTRE PRIVATE LIMITED",
"AVANTA ENGINEERINGS PRIVATE LIMITED",
"AVANTA HEALTH CARE PRIVATE LIMITED",
"AVANTA SOLUTIONS BUSINESS CENTRE PRIVATE LIMITED",
"AVANTAGE SERVICES PRIVATE LIMITED",
"AVANTAO TECHNOLOGIES PRIVATE LIMITED",
"AVANTE CODEWORX PRIVATE LIMITED",
"AVANTE EXPO RETAIL PRIVATE LIMITED",
"AVANTE FACADE CONSULTING PRIVATE LIMITED",
"AVANTE GLOBAL SERVICES PRIVATE LIMITED",
"AVANTE MEDICAL",
"AVANTECH BUSINESS SOLUTIONS PRIVATE LIMITED",
"AVANTECH ENGINEERING CONSORTIUM PRIVATE LIMITED",
"AVANTEK PRECISION COMPONENTS PRIVATE LIMITED",
"AVANTEL LIMITED",
"AVANTES PROJECTS ENGINEERING PRIVATE LIMITED",
"AVANTEXP SOLUTIONS PRIVATE LIMITED",
"AVANT-GARDE AGRO PROJECTS LIMITED",
"AVANTGARDE ENTERPRISES PRIVATE LIMITED",
"AVANTGARDE SOLUTIONS PRIVATE LIMITED",
"AVANTHA GROUP COMPANY",
"AVANTHA HOLDINGS LIMITED",
"AVANTHA POWER & INFRASTRUCTURE LIMITED",
"AVANTHA TECHNOLOGIES",
"AVANTHA TECHNOLOGIES LIMITED",
"AVANTHI DEGREE & P G COLLEGE",
"AVANTHI DEGREE COLLEGE",
"AVANTHI SCIENTIFIC AND TECHNOLIGICAL REASEARCH ACADEMY",
"AVANTHI WAREHOUSING SERVICES PRIVATE LIM ITED",
"AVANTHIK SPACES PRIVATE LIMITED",
"AVANTHIKA SCANS AND DIAGNOSTIC CENTRE PRIVATE LIMITED",
"AVANTI ACCOUNTING SERVICES PRIVATE LIMITED",
"AVANTI ADVERTISING PRIVATE LIMITED",
"AVANTI BUFA PRIVATE LIMITED",
"AVANTI BUSINESS MACHINES LIMITED",
"AVANTI COMMUNICATINOS",
"AVANTI EXIM INDIA PRIVATE LIMITED",
"AVANTI FEEDS LIMITED",
"AVANTI FELLOWS",
"AVANTI FINANCE PRIVATE LIMITED",
"AVANTI FROZEN FOODS PRIVATE LIMITED",
"AVANTI HOSPITAL UJJAIN",
"AVANTI INSTITUTE OF CARDIOLOGY PRIVATE LIMITED",
"AVANTI LEARNING CENTRES PRIVATE LIMITED",
"AVANTI LEATHERS LIMITED",
"AVANTI MEDIA LIMITED",
"AVANTI METALS PRIVATE LIMITED",
"AVANTI MILLS WORKERS INDUSTRIAL CO-OPERATIVE LIMITED",
"AVANTI OVERSEAS PRIVATE LIMITED",
"AVANTI PARSHAV MULTIVENTURE PRIVATE LIMITED",
"AVANTI PROTECTIVE SERVICES PRIVATE LIMITED",
"AVANTI WIND SYSTEMS INDIA PRIVATE LIMITED",
"AVANTIKA AATM NIRBHER KRASHAK PRODUCER COMPANY LIMITED",
"AVANTIKA AGRO SERVICES PRIVATE LIMITED",
"AVANTIKA ASSOCIATE PRIVATE LIMITED",
"AVANTIKA CHEMICALS AND METALS PVT LTD",
"AVANTIKA ENTERPTISES PRIVATE LIMITED",
"AVANTIKA INFOSOLUTIONS PRIVATE LIMITED",
"AVANTIKA INNOVATIONS PRIVATE LIMITED",
"AVANTIKA MEDEX PRIVATE LIMITED",
"AVANTIKA PHARMA (DISTRIBUTORS) PRIVATE LIMITED",
"AVANTIKA PRINTERS PRIVATE LIMITED",
"AVANTIKA SCHOOL GONDAL",
"AVANTIKA UNIVERSITY",
"AVANTIS ENTERPRISE",
"AVANTOR PERFORMANCE MATERIALS INDIA PRIVATE LIMITED",
"AVANTTA INFRA PRIVATE LIMITED",
"AVANTTEC LABORATORIES PRIVATE LIMITED",
"AVANZA ENGINEERING PRIVATE LIMITED",
"AVANZA ENTERPRISES PRIVATE LIMITED",
"AVANZAR TECH SOLUTIONS PRIVATE LIMITED",
"AVARIS INDIA BUSINESS SOLUTIONS PRIVATE LIMITED",
"AVARTAN A DIVISION OF RATNA SAGAR PRIVATE LIMITED",
"AVARTAN TECHNOLOGIES PRIVATE LIMITED",
"AVARTANAH INFRASTRUCTURE PRIVATE LIMITED",
"AVARY TECHNOLOGY INDIA PRIVATE LIMITED",
"AVARYA RETAIL PRIVATE LIMITED",
"AVAS HEALTHWAYS",
"AVAS PHOTOS PRIVATE LIMITED",
"AVASANT ADVISORY INDIA PRIVATE LIMITED",
"AVASAR FACILITY SERVICES",
"AVASARA LEADERSHIP INSTITUTE",
"AVASARALA TECHNOLOGIES LIMITED",
"AVASAS PACK AND PRINT PRIVATE LIMITED",
"AVASH BUILDERS AND INFRASTRUCTURE PRIVATE LIMITED",
"AVASO TECH PRIVATE LIMITED",
"AVATA INDIA CONSULTING PRIVATE LIMITED",
"AVATALIFE TRADE INDIA PRIVATE LIMITED",
"AVATAR PETROCHEMICALS PRIVATE LIMITED",
"AVATAR SOLAR PRIVATE LIMITED",
"AVATHI N VENKATEGOWDA EDUCATION TRUST",
"AVATI CONSULTING SOLUTIONS PRIVATE LIMITED",
"AVATOR STEEL PRIVATE LIMITED",
"AVATU PRIVATE LIMITED",
"AVAUNCE FINTRADE PRIVATE LIMITED",
"AVAXPRO TECH PRIVATE LIMITED",
"AVAYA INDIA PRIVATE LIMITED",
"AVAYA INDIA SEZ PRIVATE LIMITED",
"AVAZON BUSINESS SOLUTIONS PRIVATE LIMITED",
"AVB INTERNATIOAL",
"AVB SHARES TRADING PRIVATE LIMITED",
"AVB TECHNOLOGIES PRIVATE LIMITED",
"AVC DIECAST (I) PRIVATE LIMITED",
"AVC INDUSTRIAL SALES PRIVATE LIMITED",
"AVC INFORMATICS PRIVATE LIMITED",
"AVCO CONSULTANCY SERVICES PRIVATE LIMITED",
"AVCO ENGINEERS PRIVATE LTD.",
"AVCO TECH INDIA PRIVATE LIMITED",
"AVCOM INFOTECH PRIVATE LIMITED",
"AVCOM MEDIA PRIVATE LIMITED",
"AVCON CONTROLS PRIVATE LIMITED",
"AVCON SYSTEMS PRIVATE LIMITED",
"AVCON TECHNICS PRIVATE LIMITED",
"AVCS SYSTEMS INDIA PRIVATE LIMITED",
"AVD AGRI FOOD INDUSTRIES PRIVATE LIMITED",
"AVD DRIVES PRIVATE LIMITED",
"AVD INFRA INDIA PRIVATE LIMITED",
"AVDEL (INDIA) PRIVATE LIMITED",
"AVDESH STEEL WORKS PRIVATE. LIMITED.",
"AVDESH TRACKS PVT LTD",
"AVDHA PLAST ALLOYS PRIVATE LIMITED",
"AVDHOOT HOSPITAL & MEDICARE PRIVATE LIMITED",
"AVDHOOT PIGMENTS PVT LTD",
"AVDHOOT TECHNOCRATS PRIVATE LIMITED",
"AVDS CREATIVE TRANSFORMATION PRIVATE LIMITED",
"AVDYNAMICS INDIA OPC PRIVATE LIMITED",
"AVE MARIA SPINNING MILLS PRIVATE LIMITED",
"AVEAN INTERNATIONAL PRIVATE LIMITED",
"AVEC REALTY PRIVATE LIMITED",
"AVEC VOUS IT SERVICES PRIVATE LIMITED",
"AVECO TECHNOLOGIES PRIVATE LIMITED",
"AVEDA RESORTS AND SPA PRIVATE LIMITED",
"AVEDA VENTURES PRIVATE LIMITED AVEDA",
"AVEEKAY EXPORTS PRIVATE LIMITED",
"AVEELON SYNTHETICS INDIA PRIVATE LIMITED",
"AVEENASHI FOOD AND BEVERAGES PRIVATE LIMITED",
"AVEER FOODS LIMITED",
"AVEER RAIL COMPONENTS & PROJECTS PRIVATE LIMITED",
"AVEES BIOCOS PRIVATE LIMITED",
"AVEGA BUSINESS SOLUTIONS PRIVATE LIMITED",
"AVEGEN INDIA PRIVATE LIMITED",
"AVEKSHAA TECHNOLOGIES PRIVATE LIMITED",
"AVELI RETAIL AND TRADE SERVICES PRIVATE LIMITED",
"AVENCH SYSTEMS PRIVATE LIMITED",
"AVENCORE TECH SERVICES PRIVATE LIMITED",
"AVENDATA TECHNOLOGY PRIVATE LIMITED",
"AVENDUS CAPITAL PRIVATE LIMITED",
"AVENDUS FINANCE PRIVATE LIMITED",
"AVENDUS PE INVESTMENT ADVISORS PRIVATE LIMITED",
"AVENDUS WEALTH MANAGEMENT PRIVATE LIMITED",
"AVENER CAPITAL PRIVATE LIMITED",
"AVENG AUTOMINE PRIVATE LIMITED",
"AVENGER PANEL & WOOD PRODUCTS PRIVATE LIMITED",
"AVENGER PLY PRIVATE LIMITED",
"AVENGERS RAYS SOLAR PRIVATE LIMITED",
"AVENGERS SOLAR PRIVATE LIMITED",
"AVENIR BRAND CONNECT PRIVATE LIMITED",
"AVENIR INNOVATIVE SOLUTIONS PRIVATE LIMITED",
"AVENIR PROJECTS PRIVATE LIMITED",
"AVENIR TECH VENTURES PRIVATE LIMITED",
"AVENIRDIGITAL SOLUTIONS PRIVATE LIMITED",
"AVENSIS CROP SCIENCE PRIVATE LIMITED",
"AVENSIS ENGINEERING PRIVATE LIMITED",
"AVENSYS CONSULTING PRIVATE LIMITED",
"AVENT AGRO PRIVATE LIMITED",
"AVENT SERVICES PRIVATE LIMITED",
"AVENTIA AUTOMATION PRIVATE LIMITED",
"AVENTIOR DIGITAL PRIVATE LIMITED",
"AVENTRI EVENT SOFTWARE PRIVATE LIMITED",
"AVENTURA AMUSEMENT PROJECT PRIVATE LIMITED",
"AVENTURE PHARMA PRIVATE LIMITED",
"AVENTUS ESTATE DEVELOPER PRIVATE LIMITED",
"AVENU INSIGHTS INDIA PRIVATE LIMITED",
"AVENUE ASIA ADVISORS PRIVATE LIMITED.",
"AVENUE COMMERCIAL PRIVATE LIMITED.",
"AVENUE E-COMMERCE LIMITED",
"AVENUE FOOD PLAZA PRIVATE LIMITED",
"AVENUE GRAPHICS PRIVATE LIMITED",
"AVENUE OVERSEAS PRIVATE LIMITED",
"AVENUE REMEDIES INDIA PRIVATE LIMITED",
"AVENUE SUPER CHITS PRIVATE LIMITED",
"AVENUE SUPERMARTS LIMITED",
"AVENUE TECHNOLOGIES PRIVATE LIMITED",
"AVENUECORP INDIA PRIVATE LIMITED",
"AVENUES ENTERPRISES PRIVATE LIMITED",
"AVENUES INFINITE PRIVATE LIMITED",
"AVENUES PHARMA DISTRIBUTORS PRIVATE LIMITED",
"AVENUES WORLDWIDE PRIVATE LIMITED",
"AVENUESCAP PRIVATE LIMITED",
"AVENY PROPERTIES LLP",
"AVENZA PHARMACEUTICALS PRIVATE LIMITED",
"AVEO PHARMACEUTICALS PRIVATE LIMITED",
"AVEO REAL ESTATE HOLDINGS PRIVATE LIMITED",
"AVER IMPEX AND TRADING PRIVATE LIMITED",
"AVER SOFTWARE TECHNOLOGIES LIMITED",
"AVER SOLUTIONS AND GLOBAL SERVICES PRIVATE LIMITED",
"AVEREADY SCALE INDIA LIMITED",
"AVERINA INTERNATIONAL RESORTS PRIVATE LIMITED",
"AVEROX INFRASTRUCTURE INDIA PRIVATE LIMITED",
"AVERRILE SURFACTANT PRIVATE LIMITED",
"AVERSAN SYSTEMS PRIVATE LIMITED",
"AVERT ENERGY INDIA PRIVATE LIMITED",
"AVERTIS INFOTECH PRIVATE LIMITED",
"AVERTRA INDIA PRIVATE LIMITED",
"AVERY DENNISON (INDIA) PRIVATE LIMITED",
"AVERY DENNISON RBIS INDIA PRIVATE LIMITED",
"AVERY INDIA LIMITED",
"AVES SHOPPING NETWORK PRIVATE LIMITED",
"AVESA DEVELOPMENT PRIVATE LIMITED",
"AVESTA COMPUTERS PRIVATE LIMITED",
"AVESTA ENTERPRISES PRIVATE LIMITED",
"AVESTA PHARMA PRIVATE LIMITED",
"AVESTA SOLAR PRIVATE LIMITED",
"AVESTA TRAVEL & TOUR PRIVATE LIMITED",
"AVET LIFESCIENCES PRIVATE LIMITED",
"AVETA REMEDIES PRIVATE LIMITED",
"AVETIKYAN HOTELS PRIVATE LIMITED",
"AVETS ENGINEERING INDIA PRIVATE LIMITED",
"AVEVA INFORMATION TECHNOLOGY INDIA PRIVATE LIMITED",
"AVEVA SOLUTIONS INDIA LLP",
"AVF CREATIVE BRAND CONSULTANCY PRIVATE LIMITED",
"AVF DISTRIBUTORS I PRIVATE LIMITED",
"AVFX SOLUTIONS PRIVATE LIMITED",
"AVG GLOBAL INTEGRATED PRIVATE LIMITED",
"AVG LOGISTICS LIMITED",
"AVG MOTORS PRIVATE LIMITED",
"AVG PRINT N PACK PRIVATE LIMITED",
"AVG SCAFFOLDING SYSTEMS PRIVATE LIMITED",
"AVG VEHICLE SALES AND SERVICES PRIVATE LIMITED",
"AVG WIRE SCREENS PRIVATE LIMITED",
"AVGARDE SYSTEMS PRIVATE LIMITED",
"AVGHNI RENEWABLE ENERGY SYSTEM INDIA PRIVATE LIMITED",
"AVGOL INDIA PRIVATE LIMITED",
"AVGRAPHIC DESIGNERS PRIVATE LIMITED",
"AVGROWTH SKILLS PRIVATE LIMITED",
"AVH FREIGHT PRIVATE LIMITED",
"AVH POLYCHEM PRIVATE LIMITED",
"AVH RESOURCES INDIA PRIVATE LIMITED",
"AVHA LIFESCIENCES PRIVATE LIMITED",
"AVHAN TECHNOLOGIES PRIVATE LIMITED",
"AVHE INDIA PRIVATE LIMITED",
"AVHM GLOBAL PRIVATE LIMITED",
"AVHM STEELTECH PRIVATE LIMITED",
"AVI ADDITIVES PRIVATE LIMITED",
"AVI AGRI BUSINESS LIMITED",
"AVI ANSH ENTERPRISES PRIVATE LIMITED",
"AVI ANSH TEXTILE LIMITED",
"AVI ANSH TEXTILES PRIVATE. LIMITED.",
"AVI APPLIANCES PRIVATE LIMITED",
"AVI BRIGHT RAY TECHNOLOGIES PRIVATE LIMITED",
"AVI CEMENT LIMITED",
"AVI CORPORATION PRIVATE LIMITED",
"AVI ELECTRONICS AND NETWORKS PRIVATE LIMITED",
"AVI GLOBAL PLAST PRIVATE LIMITED",
"AVI HEALTHCARE PRIVATE LIMITED",
"AVI NETWORKS INDIA PRIVATE LIMITED",
"AVI OIL INDIA PRIVATE LIMITED",
"AVI OILLESS DIE COMPONENTS INDIA PRIVATE LIMITED",
"AVI POLYMERS LIMITED",
"AVI PRODUCTS INDIA LIMITED",
"AVI ROOT INFO SOLUTIONS PRIVATE LIMITED",
"AVI SALES PRIVATE LIMITED",
"AVI WORLDWIDE PRIVATE LIMITED",
"AVIA AUTO SERVICES PRIVATE LIMITED",
"AVIA CERAMICS PRIVATE LIMITED",
"AVIA PROM SOLUTIONS PRIVATE LIMITED",
"AVIA XPERT PRIVATE LIMITED",
"AVIABIRD TECHNOLOGY PRIVATE LIMITED",
"AVIAGEN INDIA POULTRY BREEDING COMPANY PRIVATE LIMITED",
"AVIAN AUTO PRIVATE LIMITED",
"AVIAN BUILDCON INDIA PRIVATE LIMITED",
"AVIAN INFRASTRUCTURE AND ENERGY PRIVATE LIMITED",
"AVIAN LIFE SCIENCES PRIVATE LIMITED",
"AVIAN MEDIA PRIVATE LIMITED",
"AVIAN PIPES PRIVATE LIMITED",
"AVIAN REMEDIES LIMITED",
"AVIAN TECH SOLUTIONS PRIVATE LIMITED",
"AVIAN TECHNOLOGIES",
"AVIAN WELLNESS PRIVATE LIMITED",
"AVIANA TRAVELS PRIVATE LIMITED",
"AVIANCE HEALTHCARE PRIVATE LIMITED",
"AVIANCE LOGISTICS PRIVATE LIMITED",
"AVIANS INNOVATIONS TECHNOLOGY PRIVATE LIMITED",
"AVIANS POULTRY SOLUTIONS PRIVATE LIMITED",
"AVIAPRO LOGISTIC SERVICES PRIVATE LIMITED",
"AVIAREPS-AVIATION TOURISM & TRAVEL MARKETING PRIVATE LIMITED",
"AVIASAFE AVIATION SERVICES PRIVATE LIMITED",
"AVIAT NETWORKS INDIA PRIVATELIMITED",
"AVIATION & DEFENCE SPARES LIMITED",
"AVIATION CONNECTIVITY AND INFRASTRUCTURE DEVELOPERS PRIVATE LIMITED",
"AVIATION ESPRESS PRIVATE LIMITED",
"AVIATION HOLIDAYS PRIVATE LIMITED",
"AVIATION HOTELS PRIVATE LIMITED",
"AVIATION OVERSEAS SUPPLY LOGISTICS PRIVATE LIMITED",
"AVIATION RESEARCH CENTRE",
"AVIATION SOLUTIONS INDIA PRIVATE LIMITED",
"AVIATION TECH TOOLS PRIVATE LIMITED",
"AVIATIONBABA AERO SERVICES PRIVATE LIMITED",
"AVIATIONGEEKS PRIVATE LIMITED",
"AVIATOR INFOTECH INDIA PRIVATE LIMITED",
"AVIATOR LIFE SCIENCE PRIVATE LIMITED",
"AVIATORS AIRRESCUE PRIVATE LIMITED",
"AVIBHA INDUSTRIES PRIVATE LIMITED",
"AVICHAL BUILDCON PRIVATE LIMITED",
"AVICHAL EMBROIDERY PRIVATE LIMITED",
"AVICHAL ENTERPRISES PRIVATE LIMITED",
"AVICHAL TEXTILE MILLS PRIVATE LIMITED",
"AVICHAL WEAVES PRIVATE LIMITED",
"AVICHEM LIFE SCIENCES PRIVATE LIMITED",
"AVICI INFO ANALYTICS PRIVATE LIMITED",
"AVICO EXIM PRIVATE LIMITED",
"AVICON FILMS PRIVATE LIMITED",
"AVICURA PHARMACEUTICALS PRIVATE LIMITED",
"AVID GREEN ENERGY PRIVATE LIMITED",
"AVID IMPEX PRIVATE LIMITED",
"AVID INDUSTRIES PRIVATE LIMITED",
"AVID ORGANICS PRIVATE LIMITED",
"AVIDAN INFRASTRUCTURES PRIVATE LIMITED",
"AVIEATERS HOSPITALITY PRIVATE LIMITED",
"AVIENCE BIOMEDICALS PRIVATE LIMITED",
"AVIENT TECHNOLOGIES PRIVATE LIMITED",
"AVIENTEK ELECTRONICS TRADING PRIVATE LIMITED",
"AVIGATION INTEGRATED SOLUTIONS PRIVATE LIMITED",
"AVIGHAN A.B. STEELS PRIVATE LIMITED",
"AVIGHNA DAIRY PRODUCTS PRIVATE LIMITED",
"AVIGHNA EPC SERVICES PRIVATE LIMITED",
"AVIGHNA MANPOWER AND LOGISTICS PRIVATE LIMITED",
"AVIGHNA MEDICARE PRIVATE LIMITED",
"AVIGHNA MEDITECH SOLUTIONS PRIVATE LIMITED",
"AVIGHNA SOLARFARMS LIMITED",
"AVIGHNA STEEL PRIVATE LIMITED",
"AVIGHNA SYSTEMS PRIVATE LIMITED",
"AVIGHNAA CONTRACTORS PRIVATE LIMITED",
"AVIGHNAA PLY PRIVATE LIMITED",
"AVIGNA EPC PRIVATE LIMITED",
"AVIGNA HOUSING PRIVATE LIMITED",
"AVIGNA IRRA PRIVATE LIMITED",
"AVIGNA LABORATORIES LLP",
"AVIGNA LOKESH HOTELS PRIVATE LIMITED",
"AVIGNA PRIVATE LIMITED",
"AVIGNA PROPERTIES PRIVATE. LIMITED.",
"AVIGNA SPACE PRIVATE LIMITED",
"AVIGNAAB INDIA PRIVATE LIMITED",
"AVIGNAAI PRIVATE LIMITED",
"AVIGYA BIOSCIENCES PRIVATE LIMITED",
"AVI-HAS ELECTRICALS PRIVATE LIMITED",
"AVIHAS EQUIPMAINTS PRIVATE LIMITED",
"AVIHUB INDIA PRIVATE LIMITED",
"AVIJEET AGENCIES PRIVATE LIMITED",
"AVIJIT ESTATE AND HOLDINGS LIMITED",
"AVIK PHARMACEUTICAL LIMITED",
"AVIK TECHNOLOGIES PRIVATE LIMITED",
"AVIK TELEVENTURES PRIVATE LIMITED",
"AVIKA AGRO PRIVATE LIMITED",
"AVIKA FOODS PRIVATE LIMITED",
"AVIKA POLYFILMS PRIVATE LIMITED",
"AVIKAM BUILDCON LLP",
"AVIKAM LOGISTICS PRIVATE LIMITED",
"AVIKIRAN SOLAR INDIA PRIVATE LIMITED",
"AVIKIRAN SURYA INDIA PRIVATE LIMITED",
"AVILA CONVENT MATRICULATION HIGHER SECONDARY SCHOOL",
"AVILAA EXPORTS PRIVATE LIMITED",
"AVILS INFRA PRIVATE LIMITED",
"AVIMA EXPORTS PVT LTD",
"AVIMUKTA CONSULTANCY PRIVATE LIMITED",
"AVIN BHALCHANDRA PORE (PROP.OF.M/S.AVIM",
"AVIN HEALTHCARE PRIVATE LIMITED",
"AVIN NETWORKS PRIVATE LIMITED",
"AVIN SYSTEMS PRIVATE LIMITED",
"AVINANDAN FASHIONS PRIVATE LIMITED",
"AVINASH BHOSALE GROUP",
"AVINASH BRAHMADEVARA EDUCATIONAL SOCIETY",
"AVINASH BUILDCON INFRASTRUCTURE PRIVATE LIMITED",
"AVINASH CABLES (INDIA) PRIVATE LIMITED",
"AVINASH CARGO PRIVATE LIMITED",
"AVINASH CARRIER PRIVATE LIMITED",
"AVINASH DENTAL LABORATORIES&RESEARCH INSTITUTE PRIVATE LIMIT",
"AVINASH DEVELOPERS PRIVATE LIMITED",
"AVINASH HOSPITALS PRIVATE LIMITED",
"AVINASH INFRA PROJECTS PRIVATE LIMITED",
"AVINASH MARKETING PRIVATE LIMITED",
"AVINASH RAMAKRISHNA DEVELOPERS PRIVATE LIMITED",
"AVINASH TECHNO SOLUTIONS PRIVATE LIMITED",
"AVINASH TWIN CITY PRIVATE LIMITED",
"AVINASHILINGAM INSTITUTE FOR HOME SCIENC",
"AVINASHILINGAM UNIVERSITY-641043",
"AVINASI STEEL PRIVATE LIMITED",
"AVINAV CONSULTING PRIVATE LIMITED",
"AVINEON INDIA PRIVATE LIMITED",
"AVINEX SOFTWARE PRIVATE LIMITED",
"AVINI ADVISORS PRIVATE LIMITED",
"AVINJA BIOTECHNOLOGIES PRIVATE LIMITED",
"AVINO SANITATION PRIVATE LIMITED",
"AVINS INDUSTRIES PRIVATE LIMITED",
"AVINYATECH ELEVATORS PRIVATE LIMITED",
"AVIOHELITRONICS INFOSYSTEMS PRIVATE LIMITED",
"AVIOM INDIA HOUSING FINANCE PRIVATE LIMITED",
"AVIOMI LOGISTICS PRIVATE LIMITED",
"AVION CORPORATION PRIVATE LIMITED",
"AVION DIGITEK PRIVATE LIMITED",
"AVION ELECTRONICS PRIVATE LIMITED",
"AVION ENVIRONMENT PRIVATE LIMITED",
"AVION EXIM PRIVATE LIMITED",
"AVION SHIPPING ENTERPRISES PRIVATE LIMITED",
"AVION TRADELINKS PRIVATE LIMITED",
"AVIONEX SOFTECH PRIVATE LIMITED",
"AVIOSAT TECHNOLOGY PRIVATE LIMITED",
"AVIOX TECHNOLOGIES PRIVATE LIMITED",
"AVIPRO INDIA PRIVATE LIMITED",
"AVIRA POLYMERS PRIVATE LIMITED",
"AVIRAJ CONSTRUCTION PRIVATE LIMITED",
"AVIRAJ HATCHERIES PRIVATE LIMITED",
"AVIRAJ LAXMI PRIVATE LIMITED",
"AVIRAJ WORLD SCHOOL",
"AVIRAL BEVERAGES PRIVATE LIMITED",
"AVIRAL BIO TECH & FERTILISERS PRIVATE LIMITED",
"AVIRAL BULK HANDLING LOGISTICS PRIVATE LIMITED",
"AVIRAL CROP SCIENCE PRIVATE LIMITED",
"AVIRAL FINANCE PRIVATE LIMITED",
"AVIRAL GROWTH PRIVATE LIMITED",
"AVIRAL INDUSTRIES LIMITED",
"AVIRAL INSURANCE MARKETING LLP",
"AVIRAL SALES PRIVATE LIMITED",
"AVIRAL TECHNOLOGIES PRIVATE LIMITED",
"AVIRASOFT DIGITAL TECHNOGIES PRIVATE LIMITED",
"AVIRAT COTTON INDUSTRIES PRIVATE LIMITED",
"AVIRAT CRUCIBLE PRIVATE LIMITED",
"AVIRAT ENERGY PRIVATE LIMITED",
"AVIRAT ENTERPRISES PVT LTD",
"AVIRAT FINANCE PRIVATE LIMITED",
"AVIRAT INFRASTRUCTURE PRIVATE LIMITED",
"AVIRAT METAL PRIVATE LIMITED",
"AVIRATA DEFENCE SYSTEMS LIMITED",
"AVIRATHA BUSINESS SOLUTIONS PRIVATE LIMITED",
"AVIRATHA CHITS PRIVATE LIMITED",
"AVIRUDDHA PRODUCTIVITY PRIVATE LIMITED",
"AVIRUP BUSINESS SOLUTIONS PRIVATE LIMITED",
"AVIS ENERTECH PRIVATE LIMITED",
"AVIS ESOLUTIONS PRIVATE LIMITED",
"AVIS HEALTHCARE PRIVATE LIMITED",
"AVIS HOSPITALS INDIA LIMITED",
"AVIS INDIA MOBILITY SOLUTIONS PRIVATE LIMITED",
"AVIS INDUSTRIES PRIVATE LIMITED",
"AVIS LIFECARE PRIVATE LIMITED",
"AVIS METAL INDUSTRIES LIMITED",
"AVIS MOTOLINK PRIVATE LIMITED",
"AVIS PROJECTS AND INFRASTRUCTURE PRIVATE LIMITED",
"AVIS TRADEWORTH PVT LTD",
"AVIS VISIONTECH PRIVATE LIMITED",
"AVISA BIOTECH PRIVATE LIMITED",
"AVISA DEVELOPERS PRIVATE LIMITED",
"AVISARA INFOTECH PRIVATE LIMITED",
"AVISH AGRO PRIVATE LIMITED",
"AVISH AVIATION EQUIPMENTS PVT LTD",
"AVISH MACHINES PRIVATE LIMITED",
"AVISHA INFRASTRUCTURE PRIVATE LIMITED",
"AVISHAKTI ROOFTOP SOLAR PRIVATE LIMITED",
"AVISHI DEVELOPERS PRIVATE LIMITED",
"AVISHKAAR PROCESSING MILLS PRIVATE LIMITED",
"AVISHKAR AGRIBIZ PRIVATE LIMITED",
"AVISHKAR INDUSTRIES PRIVATE LIMITED",
"AVISHKAR INNOVATIVE PRIVATE LIMITED",
"AVISHKAR REALITY",
"AVISHKAR SAVITA KAMAT VIDYAMANDIR",
"AVISHKARAN INDUSTRIES PRIVATE LIMITED",
"AVISO INFOTECH PRIVATE LIMITED",
"AVISO SOFTWARE INDIA LLP",
"AVISON PHARMACEUTICALS PRIVATE LIMITED",
"AVISOR INDIA PRIVATE LIMITED",
"AVISTA CLINICS PRIVATE LIMITED",
"AVISTA CORPORATE FINANCE ADVISORY PRIVATE LIMITED",
"AVISTA TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"AVISTA WEB TECHNOLOGIES PRIVATE LIMITED",
"AVISTAR LIFESCIENCES PRIVATE LIMITED",
"AVISUN ORGANICS PVT LTD",
"AVISURE SERVICES PRIVATE LIMITED",
"AVISYS SERVICES PRIVATE LIMITED",
"AVIT DIGITAL PRIVATE LIMITED",
"AVITA LABORATORIES PRIVATE LIMITED",
"AVITA POLY FILMS PRIVATE LIMITED",
"AVITECH NUTRITION PRIVATE LIMITED",
"AVITEL POST STUDIOZ LIMITED",
"AVITRI SPICES PRIVATE LIMITED",
"AVITRONICS PROJECTION PRIVATE LIMITED",
"AVITUS INDIA PEST MANAGEMENT PRIVATE LIMITED",
"AVITY AGROTECH PRIVATE LIMITED",
"AVIVA EQUIPMENTS PRIVATE LIMITED",
"AVIVA HEALTHCARE PRIVATE LIMITED",
"AVIVA LIFE INSURANCE COMPANY INDIA LTD",
"AVIVA PHARMATECH PRIVATE LIMITED",
"AVIVA SMART SOLUTIONS PRIVATE LIMITED",
"AVIVA WRITING PRODUCTS PRIVATE LIMITED",
"AVIVITTA FINANCIAL SERVICES PRIVATE LIMITED",
"AVIZEN BIOPHARMA PRIVATE LIMITED",
"AVIZVA SOLUTIONS PRIVATE LIMITED",
"AVJ BIO CHEMICAL PRIVATE LIMITED",
"AVJ STARDOM INDIA LIMITED",
"AVJA EXPORTS PRIVATE LIMITED",
"AVK FRIGHT FORWARDERS PRIVATE LIMITED",
"AVK ISPAT PRIVATE LIMITED",
"AVK SOFTWARE SOLUTIONS PRIVATE LIMITED",
"AVK STEELS & ALLOYS PRIVATE LIMITED",
"AVK VALVES INDIA PRIVATE LIMITED",
"AVKASH TRADERS PRIVATE LIMITED",
"AVKP CONSULTANTS PRIVATE LIMITED",
"AVKS CARE PRIVATE LIMITED",
"AVKT INFRACON PRIVATE LIMITED",
"AVL APPAREL PRIVATE LIMITED",
"AVL BIG DATA INDIA PRIVATE LIMITED",
"AVL CARGO PRIVATE LIMITED",
"AVL INDIA PRIVATE LIMITED",
"AVL TECHNICAL CENTRE PRIVATE. LIMITED",
"AVLAAN PHARMACEUTICAL PRIVATE LIMITED",
"AVLIGHT - ALTRUSTOOLING PRIVATE LIMITED",
"AVLIGHT AUTO COMPONENTS PRIVATE LIMITED",
"AVLIGHT AUTOMOTIVES PRIVATE LIMITED",
"AVLINK TECHNOLOGIES PRIVATE LIMITED",
"AVLOCK INTERNATIONAL INDIA PRIVATE LIMITED",
"AVLOG INFOTECH PRIVATE LIMITED",
"AVLON CERAMIC PRIVATE LIMITED",
"AVLYN PHARMA PRIVATE LIMITED",
"AVM APPARELS PRIVATE LIMITED",
"AVM ART SERVICES PRIVATE LIMITED",
"AVM DATA CARE PRIVATE LIMITED",
"AVM FUELS PRIVATE LIMITED",
"AVM GENERAL TRADING INDIA PRIVATE LIMITED",
"AVM HEALTH CARE PRODUCTS PRIVATE LIMITED",
"AVM HOME & OFFICE SOLUTIONS PRIVATE LIMITED",
"AVM INDUSTRIES PRIVATE LIMITED",
"AVM INFOTECH (INDIA) PRIVATE LIMITED",
"AVM LABS PRIVATE LIMITED",
"AVM LOGISTICS PRIVATE LIMITED",
"AVM MAHASHAKTI AGENCIES PRIVATE LIMITED",
"AVM MANAGEMENT SERVICES PRIVATE LIMITED",
"AVM PRECISION PRIVATE LIMITED",
"AVM PRINT PACK PRIVATE LIMITED",
"AVM SOLAR PRIVATE LIMITED",
"AVMB FUTURETECH PRIVATE LIMITED",
"AVMC CHEMICALS PRIVATE LIMITED",
"AVMH PRIVATE LIMITED",
"AVMS HEALTHCARE PRIVATE LIMITED",
"AVN AROGYA HEALTH CARE LIMITED",
"AVN AYURVEDA FORMULATIONS PRIVATE LIMITED",
"AVN BUSINESS SOLUTIONS PRIVATE LIMITED",
"AVN COLLEGE",
"AVN FREIGHT SYSTEMS PRIVATE LIMITED",
"AVN GRAND HOSPITALITY PRIVATE LIMITED",
"AVN INSTITUTE OF ENGINEERING AND TECHNOLOGY",
"AVN OILS PRIVATE LIMITED",
"AVN PRODUCTS PRIVATE LIMITED",
"AVN REALTORS PRIVATE LIMITED",
"AVN SPICES PRIVATE LIMITED",
"AVN TRADE VENTURES PRIVATE LIMITED",
"AVNET INDIA PRIVATE LIMITED",
"AVNG INFRASTRUCTURES PRIVATE LIMITED",
"AVNI CASTECH PRIVATE LIMITED",
"AVNI CLOTH PRIVATE LIMITED",
"AVNI HEALTHCARE PRIVATE LIMITED",
"AVNI LOGISTICS PRIVATE LIMITED",
"AVNI MOTORS INDIA PRIVATE LIMITED",
"AVNI PHARMACEUTICALS PRIVATE LIMITED",
"AVNI PIPES PRIVATE LIMITED",
"AVNI PLASTCHEM PRIVATE LIMITED",
"AVNI POLYMERS PRIVATE LIMITED",
"AVNI STEELS",
"AVNI TELETALK PRIVATE LIMITED",
"AVNI YARNS PRIVATE LIMITED",
"AVNIALINA MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"AVNIDE SPORTS PRIVATE LIMITED",
"AVNI'S LIFESTYLE PRIVATE LIMITED",
"AVO CARBON INDIA PRIVATE LIMITED",
"AVOCADO PHARMACEUTICALS PRIVATE LIMITED",
"AVOCATION EDUCATIONAL SERVICES PRIVATE LIMITED",
"AVOCET INDUSTRIES PRIVATE LIMITED",
"AVOCET TOURS & TRAVELS PRIVATE LIMITED",
"AVODAH ENTERPRISES PRIVATE LIMITED",
"AVODEN PRIVATE LIMITED",
"AVODHA EDUTECH PRIVATE LIMITED",
"AVOGADRO ELECTRICALS & ELECTRONICS PRIVATE LIMITED",
"AVOK ENGINEERING CONSULTING & CONTRACTING PRIVATE LIMITED",
"AVON AGRO INDUSTRIES PRIVATE LIMITED",
"AVON ALLOYS PRIVATE LIMITED",
"AVON APPLIANCES PRIVATE LIMITED",
"AVON BEAUTY PRODUCTS INDIA PRIVATE LIMITED",
"AVON BICYCLE COMPONENTS PRIVATE LIMITED",
"AVON BIWHEELER ACCESSORIES PRIVATE LIMITED",
"AVON BUILDING PRODUCT PRIVATE LIMITED",
"AVON BUILDING SOLUTIONS PRIVATE LIMITED",
"AVON CONSUMER PRODUCTS PRIVATE LIMITED",
"AVON CONTAINNERS PRIVATE LIMITED",
"AVON COTSYN PRIVATE LIMITED",
"AVON COTTEX PRIVATE. LIMITED.",
"AVON CYCLES LIMITED",
"AVON DATA CABLES PRIVATE LIMITED",
"AVON ENGINEERING",
"AVON ENTERPRISES PRIVATE LIMITED",
"AVON EXPORTS PRIVATE LIMITED",
"AVON FINSERVE PRIVATE LIMITED",
"AVON FITNESS MACHINES PRIVATE LIMITED",
"AVON FOOD LAB PRIVATE LIMITED",
"AVON FOREX PRIVATE LIMITED",
"AVON GLOBAL SOLUTION PRIVATE LIMITED",
"AVON HOLIDAYS PRIVATE LIMITED",
"AVON HYDRAULICS & ENG. PRIVATE LIMITED",
"AVON IND",
"AVON ISPAT & POWER LIMITED",
"AVON LIFESTYLE PRIVATE LIMITED",
"AVON METERS PRIVATE LIMITED",
"AVON MOBILITY SOLUTIONS PRIVATE LIMITED",
"AVON MONEY SOLUTION INDIA LIMITED",
"AVON PACFO SERVICES PRIVATE LIMITED",
"AVON PHARMA MACHINES PRIVATE LIMITED",
"AVON PLASTIC INDUSTRIES PRIVATE LIMITED",
"AVON PRODUCTS INC.",
"AVON PROJECT PRIVATE LIMITED",
"AVON REFRACTORIES PRIVATE LIMITED",
"AVON RIMS PRIVATE LIMITED",
"AVON SEALS PRIVATE LIMITED",
"AVON SOLUTIONS & LOGISTICS PRIVATE LIMITED",
"AVON STEELS INDUSTRIES PRIVATE LIMITED",
"AVON SWITCHGEARS PRIVATE LIMITED",
"AVON TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"AVON TUBETECH PRIVATE LIMITED",
"AVON TUFF GLASS PRIVATE LIMITED",
"AVONFLEX PRIVATE LIMITED",
"AVONMORE CAPITAL & MANAGEMENT SERVICES LIMITED",
"AVONPLAST PVC (BANGALORE)PRIVATE LIMITED",
"AVONTIX GLOBAL PRIVATE LIMITED",
"AVONTIX SOLUTIONS PRIVATE LIMITED",
"AVOOK GLOBAL PRIVATE LIMITED",
"AVOOR NETWORKS PRIVATE LIMITED",
"AVOP DEALCOM PRIVATE LIMITED",
"AVOR CAPITAL ADVISORS PRIVATE LIMITED",
"AVOSINA MEDICAL TECHNOLOGIES INDIA PRIVATE LIMITED",
"AVOSYS TECHNOLOGY PRIVATE LIMITED",
"AVOW LOGISTICS PRIVATE LIMITED",
"AVP HOSPITALITY PRIVATE LIMITED",
"AVP INDUSTRIES PRIVATE LIMITED",
"AVP INFRACON LIMITED",
"AVP POWERINFRA PRIVATE LIMITED",
"AVP RESEARCH FOUNDATION",
"AVR BAKE PRODUCTS PRIVATE LIMITED",
"AVR EDGE NETWORKS PRIVATE LIMITED",
"AVR ELECTRONICS PRIVATE LIMITED",
"AVR FASTENERS PRIVATE LIMITED",
"AVR GENAPPS TECHNOLOGIES PRIVATE LIMITED",
"AVR GOA PROMOTERS PRIVATE LIMITED",
"AVR INDUSTRIES PRIVATE LIMITED",
"AVR INFRA PRIVATE LIMITED",
"AVR INFRATECH PRIVATE LIMITED",
"AVR LOGISTICS PRIVATE LIMITED",
"AVR MARINES PRIVATE LIMITED",
"AVR MILLS PRIVATE LIMITED",
"AVR OVERSEAS PRIVATE LIMITED",
"AVR STORAGE TANK TERMINALS PRIVATE LIMITED",
"AVR SWARNAMAHAL JEWELRY LIMITED",
"AVR SWARNAMAHAL JEWELRY PRIVATE LIMITED",
"AVR SYSTEMS INFRASTRUCTURE PRIVATE LIMITED",
"AVR TECHNOCRATS PRIVATE LIMITED",
"AVR THEJAS INFRA PRIVATE LIMITED",
"AVR VALVES PRIVATE LIMITED",
"AVRA LABORATORIES PRIVATE LIMITED",
"AVRA SYNTHESIS PRIVATE LIMITED",
"AVRIO MOBILITY PRIVATE LIMITED",
"AVRIVA SKINTECH PRIVATE LIMITED",
"AVRM INFRASTRUCTURAL PRIVATE LIMITED",
"AVRO COMMERCIAL CO PRIVATE LIMITED",
"AVRO INDIA LIMITED",
"AVRON CHEMICALS PRIVATE LIMITED",
"AVRON HOSPITALS PRIVATE LIMITED",
"AVRORA INDIA MARINE SYSTEMS PRIVATE LIMITED",
"AVS ADVISORY SERVICES PRIVATE LIMITED",
"AVS AIR-SEA SERVICES PRIVATE LIMITED",
"AVS AYURVEDA MAHAVIDALAYA BIJAPUR",
"AVS CARGO MANAGEMENT SERVICES PRIVATE LIMITED",
"AVS COLLEGE OF TECHNOLOGY",
"AVS CONTRACTORS PRIVATE LIMITED",
"AVS DECOR PRIVATE LIMITED",
"AVS EXPORTS (INDIA) PVT LTD",
"AVS FIZIKS PRIVATE LIMITED",
"AVS FOODS INDIA PRIVATE LIMITED",
"AVS HERBALS PRIVATE LIMITED",
"AVS HOLIDAYS PRIVATE LIMITED",
"AVS INDIA INFRA PRIVATE LIMITED",
"AVS INFORMATICS PRIVATE LIMITED",
"AVS INTERNATIONAL PRIVATE LIMITED",
"AVS LIFESTYLES PRIVATE LIMITED",
"AVS MEDICAL INSTRUMENT PRIVATE LIMITED",
"AVS MILL STORES PRIVATE LIMITED",
"AVS SPIRITS PRIVATE LIMITED",
"AVS TECH BUILDING SOLUTIONS INDIA PRIVATE LIMITED",
"AVS TEXTILES PRIVATE LIMITED",
"AVSL INDUSTRIES LIMITED",
"AVSN INFRASTRUCTURE PRIVATE LIMITED",
"AVSPLUS PHARMA PRIVATE LIMITED",
"AVT GAVIA FOODS PRIVATE LIMITED",
"AVT HOLDINGS PRIVATE LIMITED",
"AVT INFRASTRUCTURE PRIVATE LIMITED",
"AVT MCCORMICK INGREDIENTS PRIVATE LIMITED",
"AVT NATURAL PRODUCTS LIMITED",
"AVTAAR ELECTRIC HUB PRIVATE LIMITED",
"AVTANSH SALES PRIVATE LIMITED",
"AVTAR AND COMPANY",
"AVTAR DEVELOPMENT FOUNDATION",
"AVTAR INSTALMENTS PRIVATE LIMITED",
"AVTAR INTERIORS PRIVATE LIMITED",
"AVTAR IRON AND TUBES PRIVATE LIMITED",
"AVTAR POLYPLAST PRIVATE LIMITED",
"AVTAR STEEL LIMITED",
"AVTE INDIA PRIVATE LIMITED",
"AVTEC LIMITED",
"AVTECH SOFTWARE SERVICES INDIA PRIVATE LIMITED",
"AVTRANS TECHNOLOGIES PRIVATE LIMITED",
"AVU BUSINESS SOLUTIONS PRIVATE LIMITED",
"AVUDAI SURFACE TREATMENTS PRIVATE LIMITED",
"AVUNU LIFESCIENCES PRIVATE LIMITED",
"AVV INFRATECH PRIVATE LIMITED",
"AVVAD TECHNOLOGIES PRIVATE LIMITED",
"AVVAL MULTI TRADERS (OPC) PRIVATE LIMITED",
"AVVANTI ADVISORS PRIVATE LIMITED",
"AVVASHYA CAPITAL PRIVATE LIMITED",
"AVVYUKTA INDUSTRIES PRIVATE LIMITED",
"AVXELLENCE TECHNOLOGIES PRIVATE LIMITED",
"AVYA AUTOMOTIVES (SKODA)",
"AVYA HEALTH AND FITNESS PRIVATE LIMITED",
"AVYA INVENTRAX PRIVATE LIMITED",
"AVYA MODULAR SYSTEMS PRIVATE LIMITED",
"AVYA TECHNOLOGY PRIVATE LIMITED",
"AVYAAN HEIGHTS PRIVATE LIMITED",
"AVYAAN VINTRADE PRIVATE LIMITED",
"AVYAGRA GOLD AND JEWELLERS PRIVATE LIMITED",
"AVYAKTH COLD STORAGES PRIVATE LIMITED",
"AVYAKTYA HOSPITALITY PRIVATE LIMITED",
"AVYAN PASHUPATHY CAPITAL ADVISORS PRIVATE LIMITED",
"AVYAN TECHSERVE PRIVATE LIMITED",
"AVYANSH LOGISTIC SOLUTION PRIVATE LIMITED",
"AVYAYA INTEGRATED BRAND SOLUTIONS PRIVATE LIMITED",
"AVYAYA TECHNOLOGIES PRIVATE LIMITED",
"AVYN ENTERPRISES PRIVATE LIMITED.",
"AVYN IMPEX PRIVATE LIMITED",
"AVYUKT HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"AVYUKTA AGRO IMPEX PRIVATE LIMITED",
"AVYUKTA INTELLICALL CONSULTING PRIVATE LIMITED",
"AVYUKTA OVERSEAS PRIVATE LIMITED",
"AVYYE YARNS PRIVATE LIMITED",
"AVZA ENTERPRISES PRIVATE LIMITED",
"AVZA MOVE PRIVATE LIMITED",
"AW COURIER AND CARGO PRIVATE LIMITED",
"AW INFOSOUL PRIVATE LIMITED",
"AWA LIGHTING DESIGNERS PRIVATE LIMITED",
"AWA POWER COMPANY PVT. LIMITED",
"AWA VISION PRIVATE LIMITED",
"AWACHAT INDUSTRIES LIMITED",
"AWADE INDUSTRIES PRIVATE LIMITED",
"AWADH COAL PRIVATE LIMITED",
"AWADH ENGINEERS PRIVATE LIMITED",
"AWADH ENTERPRISES",
"AWADH ENTERPRISES PRIVATE LIMITED",
"AWADH INSULATION INDIA PRIVATE LIMITED",
"AWADH OILS PRIVATE LIMITED",
"AWADH RISK MANAGEMENT SERVICES PRIVATE LIMITED",
"AWADHESH CONTRACTORS & SUPPLIERS PRIVATE LIMITED",
"AWAGAMAN LOGISTICS PRIVATE LIMITED",
"AWAGAMAN ROAD CARRIERS LIMITED",
"AWAKE FASTENERS PRIVATE LIMITED",
"AWAKEN SECURITY AGENCY INDIA PRIVATE LIMITED",
"AWAMI URDU HIGH SCHOOL",
"AWAN INFOTECH PRIVATE LIMITED",
"AWANISH ANUP INDUSTRIES PRIVATE LIMITED",
"AWANTI POLY MOULDS PRIVATE LIMITED",
"AWARD EXIM PRIVATE LIMITED",
"AWARD KNIT FAB PRIVATE LTD",
"AWARD OFFSET PRINTERS AND PACKAGING PRIVATE LIMITED",
"AWARD SOLUTIONS (INDIA) PRIVATE LIMITED",
"AWARD VELVETS PRIVATE LIMITED",
"AWARDLINK LOGISTICS INDIA PRIVATE LIMITED",
"AWARE AUTOMATION (IND) PRIVATE LIMITED",
"AWARE GROUP",
"AWARE HEALTH AND RESEARCH FOUNDATION",
"AWARE INDIA FOUNDATION",
"AWAREBASE TECHNOLOGY PRIVATE LIMITED",
"AWARI TECHNOLOGIES PRIVATE LIMITED",
"AWASS ENGICON PRIVATE LIMITED",
"AWASTHI EDUCATION SOCIETY",
"AWASTHI SEEDS PRIVATE LIMITED",
"AWATAC CONTAINER LINE PRIVATE LIMITED",
"AWATAC LOGISTICS PRIVATE LIMITED",
"AWATE CONSTRUCTION PRIVATE LIMITED",
"AWATECH ENGINEERING (I) PRIVATE LIMITED",
"AWATECH SOLUTIONS (I) PRIVATE LIMITED",
"AWAZ PRAKASHAN PVT LTD",
"AWAZE LIMITED",
"AWAZONE AGENCIES PRIVATE LIMITED",
"AWB INDIA PRIVATE LIMITED",
"AWC SOFTWARE PRIVATE LIMITED",
"AWCHAT AND OLSEN DESIGN PRIVATE LIMITED",
"AWDHESH NARAIN DHIRENDRA NATH SARRAF PRIVATE LIMITED",
"AWEDIBLE ACOUSTICS PRIVATE LIMITED",
"AWEDIENCE CONNECT PRIVATE LIMITED",
"AWEEN TECHNOLOGIES PRIVATE LIMITED",
"AWELL PUMP & PIPE PRIVATE LIMITED",
"AWESOME BUILDERS PRIVATE LIMITED",
"AWESOME COMPUTECH PRIVATE LIMITED",
"AWESOME DIGITAL PRIVATE LIMITED",
"AWESOME FOODS PRIVATE LIMITED",
"AWESOME MACHINES PRIVATE LIMITED",
"AWESOME PAINT PLANNERS PRIVATE LIMITED",
"AWESOME PLACE FUN PRIVATE LIMITED",
"AWESOME SPARKLERS",
"AWESOMEFAB SHOPPING PRIVATE LIMITED",
"AWETECH WORKS PRIVATE LIMITED",
"AWFFICACY BUSINESS SOLUTIONS PRIVATE LIMITED",
"AWFIS SPACE SOLUTIONS LIMITED",
"AWFIS SPACE SOLUTIONS PRIVATE LIMITED",
"AWIGN ENTERPRISES PRIVATE LIMITED",
"A-WIN ENTERPRISES PRIVATE LIMITED",
"AWIN RESOURCES PRIVATE LIMITED",
"AWINMO INDIA MARKETING PRIVATE LIMITED",
"AWINSA LIFE SCIENCES PRIVATE LIMITED",
"AWK STEELWARES PRIVATE LIMITED",
"AWL INDIA PRIVATE LIMITED",
"AWOK ONLINE SERVICES PRIVATE LIMITED",
"AWON AUTO ANCILLARIES PRIVATE LIMITED",
"AWORKS DESIGN PRIVATE LIMITED",
"AWOT GLOBAL LOGISTICS (INDIA) PRIVATE LIMITED",
"AWP SERVICES INDIA PRIVATE LIMITED",
"AWS CARGO SERVICES PRIVATE LIMITED",
"AWS INFRASTRUCTURE SERVICES PRIVATE LIMITED",
"AWS MACHINE TOOLS PRIVATE LIMITED",
"AWS PROSERVE INDIA LLP",
"AWS TRUEPOWER INDIA LLP",
"AWSM DIGITAL INNOVATIONS PRIVATE LIMITED",
"AWSMOSIS LEARNING & PEOPLE SOLUTIONS PRIVATE LIMITED",
"AWT ENERGY PRIVATE LIMITED",
"AWWAL DEEP JEWELS PRIVATE LIMITED",
"AWZPACT TECHNOLOGIES AND SERVICES PRIVATE LIMITED",
"AXA GLOBAL BUSINESS SERVICES PRIVATE LIMITED",
"AXA ENTERPRISE LLP",
"AXA PARENTERALS LIMITED",
"AXABULL INDUSTRIES PRIVATE LIMITED",
"AXACUS PHARMA PRIVATE LIMITED",
"AXALTA COATING SYSTEMS INDIA PRIVATE LIMITED",
"AXARDEEP POLYMERS PRIVATE LIMITED",
"AXAT TECHNOLOGIES PRIVATE LIMITED",
"AXAY ELECTRICAL INDIA PRIVATE LIMITED",
"AXAYYA ALLOYS PVT LTD",
"AXCEED INDUSTRIES (OPC) PRIVATE LIMITED",
"AXCEL HOSPITALITY SERVICES PRIVATE LIMITED",
"AXCEL SUPPORT SERVICES PRIVATE LIMITED",
"AXCELERATE RCM SOLUTIONS PRIVATE LIMITED",
"AXCELINNO INDIA PRIVATE LIMITED",
"AXCEND AUTOMATION AND SOFTWARE SOLUTIONS PRIVATE LIMITED",
"AXCESS TECH SYSTEMS INDIA PRIVATE LIMITED",
"AXE BPO SERVICES PRIVATE LIMITED",
"AXE SOFTWARE SERVICES PRIVATE LIMITED",
"AXEL & MARC FOOD PRIVATE LIMITED",
"AXEL CONNECTIONS PRIVATE LIMITED",
"AXEL METAL BUILDINGS ( INDIA ) PRIVATE LIMITED",
"AXEL POLYMERS LIMITED",
"AXEL RETAIL PRIVATE LIMITED",
"AXEL TECHNOLOGIES PRIVATE LIMITED",
"AXELERANT TECHNOLOGIES PRIVATE LIMITED",
"AXELIA SOLUTIONS PRIVATE LIMITED",
"AXELON STAFFINGSERVICES PRIVATE LIMITED",
"AXELOR TECHNOLOGIES INDIA PRIVATE LIMITED",
"AXENIC CHEMICALS PRIVATE LIMITED",
"AXENO CONSULTING PRIVATE LIMITED",
"AXENS INDIA PRIVATE LIMITED",
"AXEO FINTECH PRIVATE LIMITED",
"AXESS AIM INDIA PRIVATE LIMITED",
"AXESS ULTRASONICS PRIVATE LIMITED",
"AXESTRACK SOFTWARE SOLUTIONS PRIVATE LIMITED",
"AXHELEON IT SERVICES PRIVATE LIMITED",
"AXHILTH REMEDIES PRIVATE LIMITED",
"AXIA ENTERPRISES PRIVATE LIMITED",
"AXIAL HEALTH CONSULTANT PRIVATE LIMITED",
"AXICON INFRATECH PRIVATE LIMITED",
"AXIDIO TECHNOLOGIES PRIVATE LIMITED",
"AXIEVA TECHNOLOGY PRIVATE LIMITED",
"AXILLY LABS PRIVATE LIMITED",
"AXILOR CAPITAL PRIVATE LIMITED",
"AXILWITS IT SERVICES (OPC) PRIVATE LIMITED",
"AXIMPROVE SOFTWARE SERVICES INDIA PRIVATE LIMITED",
"AXIMSOFT (INDIA) PRIVATE LIMITED",
"AXIND SOFTWARE PRIVATE LIMITED",
"AXINITE CONCRETE PRIVATE LIMITED",
"AXIO BIOSOLUTIONS PRIVATE LIMITED",
"AXIOM BPM SERVICES PRIVATE LIMITED",
"AXIOM CERAMIC PRIVATE LIMITED",
"AXIOM CHEMICALS PRIVATE LIMITED",
"AXIOM CONSULTING LIMITED",
"AXIOM CONSULTING PRIVATE LIMITED",
"AXIOM CORDAGES LIMITED",
"AXIOM ENERGY CONVERSION LIMITED",
"AXIOM EV PRODUCTS PRIVATE LIMITED",
"AXIOM FINANCIAL SERVICES PRIVATE LIMITED",
"AXIOM GAS ENGINEERING PRIVATE LIMITED",
"AXIOM GEN NXT INDIA PRIVATE LIMITED",
"AXIOM GLOBAL TECHNOLOGIES INDIA PRIVATE LIMITED",
"AXIOM HEALTHCARE IT CONSULTING PRIVATE LIMITED",
"AXIOM INFOTECH PRIVATE LIMITED",
"AXIOM INFRACOM PRIVATE LIMITED",
"AXIOM INSURANCE BROKERS PRIVATE LIMITED",
"AXIOM LANDBASE PRIVATE LIMITED",
"AXIOM LOGISTICS INDIA PRIVATE LIMITED",
"AXIOM PHARMA PRIVATE LIMITED",
"AXIOM POLYPACK PRIVATE LIMITED",
"AXIOM POWER PRODUCTS PRIVATE LIMITED",
"AXIOM RESEARCH LABS PRIVATE LIMITED",
"AXIOM SHARE BROKING PRIVATE LIMITED",
"AXIOM THERAPEUTICS PRIVATE LIMITED",
"AXIOM VISUAL COMMUNICATIONS PRIVATE LIMITED",
"AXIOM XCELL MOBILE PRIVATE LIMITED",
"AXIOMATIC ITECH PRIVATE LIMITED",
"AXIOMIO IT SERVICES PRIVATE LIMITED",
"AXIOMMAX ONCOLOGY PRIVATE LIMITED",
"AXIOMRC RECRUITMENT CONSULTANTS PRIVATE LIMITED",
"AXION ENTERPRISES PRIVATE LIMITED",
"AXION LABORATORIES PRIVATE LIMITED",
"AXION MEDITECH AND LIFE SCIENCE PRIVATE LIMITED",
"AXIONCONNECT INFOSOLUTIONS PRIVATE LIMITED",
"AXIOS AVIATION SERVICES PRIVATE LIMITED",
"AXIS ASSET MANAGEMENT COMPANY LIMITED",
"AXIS BANK LIMITED",
"AXIS CAPITAL LIMITED",
"AXIS CARRIERS AND LOGISTICS LIMITED",
"AXIS CARS PRIVATE LIMITED",
"AXIS CLINICALS LIMITED",
"AXIS COGENT GLOBAL LIMITED",
"AXIS COMPUTECH AND PERIPHERALS PRIVATE LIMITED",
"AXIS CONCEPT CONSTRUCTION PRIVATE LIMITED",
"AXIS CONSULTANTS INDIA PRIVATE LIMITED",
"AXIS CONTRACTORS & ENGINEERS PRIVATE LIMITED",
"AXIS CROP SCIENCE PRIVATE LIMITED",
"AXIS DESIGNERS PRIVATE LIMITED",
"AXIS ELECTRICAL COMPONENTS INDIA PRIVATE LIMITED",
"AXIS ENERGY VENTURES INDIA PRIVATE LIMITED",
"AXIS ENGINEERING INDIA PRIVATE LIMITED",
"AXIS ENTERPRISES PRIVATE LIMITED",
"AXIS EPC PRIVATE LIMITED",
"AXIS FINANCE LIMITED",
"AXIS FORMING TECHNOLOGY PRIVATE LIMITED",
"AXIS GARMENT DESIGNER",
"AXIS HOLIDAYS PRIVATE LIMITED",
"AXIS HOUSING PRIVATE LIMITED",
"AXIS HR CONSULTANCY PRIVATE LIMITED",
"AXIS IMPEX",
"AXIS INDUSTRIES PRIVATE LIMITED",
"AXIS INFOLINE PRIVATE LIMITED",
"AXIS INTEGRATED SYSTEMS LIMITED",
"AXIS INTERIORS PVT LTD",
"AXIS LIFE SCIENCE PRIVATE LIMITED",
"AXIS MACHINE WORKS PRIVATE LIMITED",
"AXIS MOTORS PRIVATE LIMITED",
"AXIS MUTUAL FUND",
"AXIS NANO TECHNOLOGIES PRIVATE LIMITED",
"AXIS ORGANICS PRIVATE LIMITED",
"AXIS OVERSEAS LIMITED",
"AXIS PARADIGM SPACES INDIA PRIVATE LIMITED",
"AXIS PETROCHEMICALS PRIVATE LIMITED",
"AXIS PLATING PRIVATE LIMITED",
"AXIS POLYCHROME PRIVATE LIMITED",
"AXIS POLYFILMS PRIVATE LIMITED",
"AXIS RISK CONSULTING SERVICES PRIVATE LIMITED",
"AXIS SECURITIES LIMITED",
"AXIS SERVICE PROVIDER PRIVATE LIMITED",
"AXIS SHIPPING AGENCY PRIVATE LIMITED",
"AXIS SIGHT CARE PRIVATE LIMITED",
"AXIS SOLUTIONS PRIVATE LIMITED",
"AXIS SPACES PRIVATE LIMITED",
"AXIS TECHNICAL GROUP INDIA PRIVATE LIMITED",
"AXIS TRAVELTECH PRIVATE LIMITED",
"AXIS TRUSTEE SERVICES LIMITED",
"AXIS VIDEO SYSTEMS INDIA PRIVATE LIMITED",
"AXIS WIND ENERGY LIMITED",
"AXIS WIND FARMS (ANANTAPUR) PRIVATE LIMITED",
"AXIS WIND FARMS (MPR DAM ) PRIVATE LIMITED",
"AXIS WIND FARMS (RAYALASEEMA) PRIVATE LIMITED",
"AXISCADES AEROSPACE & TECHNOLOGIES PRIVATE LIMITED",
"AXISCADES AEROSPACE INFRASTRUCTURE PRIVATE LIMITED",
"AXISCADES TECHNOLOGIES LIMITED",
"AXISON VITRIFIED PRIVATE LIMITED",
"AXISROOMS TRAVEL DISTRIBUTION SOLUTIONS PRIVATE LIMITED",
"AXITA COTTON PRIVATE LIMITED",
"AXITA EXPORTS PRIVATE LIMITED",
"AXITA INFRASTRUCTURE PRIVATE LIMITED",
"AXITEC ENERGY INDIA PRIVATE LIMITED",
"AXIVA SICHEM PRIVATE LIMITED",
"AXLE ENGINEERING PRIVATE LIMITED",
"AXLE LOGISTICS PRIVATE LIMITED",
"AXLE PAPER PRIVATE LIMITED",
"AXLES INDIA LIMITED",
"AXLETECH INDIA PRIVATE LIMITED",
"AXLETREE SOLUTIONS INDIA PRIVATE LIMITED",
"AXLRATE RESEARCH AND INNOVATIONS LLP",
"AXN NEO BEARINGS PRIVATE LIMITED",
"AXNESS TECHNOLOGIES PRIVATE LIMITED",
"AXO ELEVATORS PRIVATE LIMITED",
"AXODIN PHARMACEUTICALS PRIVATE LIMITED",
"AXODIUM TRADING PRIVATE LIMITED",
"AXOLI TILES PRIVATE LIMITED",
"AXOLO CERAMIC PRIVATE LIMITED",
"AXOM AGRO MACHINERY PRIVATE LIMITED",
"AXOM AUTOMOBILES PRIVATE LIMITED",
"AXON ANAESTHESIA ASSOCIATES PRIVATE LIMITED",
"AXON AUTOMOTIVES PRIVATE LIMITED",
"AXON AUTOTEC PRIVATE LIMITED",
"AXON CONSTRUCTIONS PRIVATE LIMITED",
"AXON CORPORATE SERVICES INDIA PRIVATE LIMITED",
"AXON CROP SCIENCES PRIVATE LIMITED",
"AXON DRUGS PRIVATE LIMITED",
"AXON FINANCE AND SECURITIES LIMITED",
"AXON GLOBAL PRIVATE LIMITED",
"AXON INFRALINK PRIVATE LIMITED",
"AXON INTERCONNECTORS AND WIRES PRIVATE LIMITED",
"AXON LABORATORIES PRIVATE LIMITED",
"AXON MEDICAL SOLUTIONS PRIVATE LIMITED",
"AXON OUTSOURCING PRIVATE LIMITED",
"AXON PACKAGING PAPER BOARDS PRIVATE LIMITED",
"AXON SYSTEMS PRIVATE LIMITED",
"AXOR HOSPITALITY SERVICES PRIVATE LIMITED",
"AXORA RESOURCES LIMITED",
"AXPEDITE SOFTWARE PRIVATE LIMITED",
"AXPLORE TRAVELPLUS PRIVATE LIMITED",
"AXPONENT MEDIA PRIVATE LIMITED",
"AXPRESS LOGISTICS INDIA PRIVATE LIMITED",
"AXPRESS SCM LLP",
"AXPS ( FREIGHT ) PRIVATE LIMITED",
"AXS ONLINE PRIVATE LIMITED",
"AXSYS HEALTH TECH LIMITED",
"AXSYS TECHNOLOGIES LIMITED",
"AXTECHNOSOFT PRIVATE LIMITED",
"AXTEL INDUSTRIES LIMITED",
"AXTER PHARMACEUTICALS PRIVATE LIMITED",
"AXTRIA INDIA PRIVATE LIMITED",
"AXTRICS SOLUTIONS PRIVATE LIMITED",
"AXTRON SOLUTIONS PRIVATE LIMITED",
"AXTRUM SOLUTIONS PRIVATE LIMITED",
"AXV TECHNOLOGIES PRIVATE LIMITED",
"AXWARE INDIA PRIVATE LIMITED",
"AXWELL GRANITO PRIVATE LIMITED",
"AXXELA ADVISORY SERVICES LLP",
"AXXIMUM SERVICES PRIVATE LIMITED",
"AXXONET SOLUTIONS INDIA PRIVATE LIMITED",
"AXXONET SYSTEM TECHNOLOGIES PRIVATE LIMITED",
"AXYKNO CAPITAL SERVICES PRIVATE LIMITED",
"AXYS NUTRITION PRODUCTS PRIVATE LIMITED",
"AXYZ AUTOMATION PRIVATE LIMITED",
"AXZORA PRIVATE LIMITED",
"AYAAN AUTONOMOUS SYSTEMS PRIVATE LIMITED",
"AYAAN BUILDTECH PRIVATE LIMITED",
"AYAAN CONSTRUCTION PRIVATE LIMITED",
"AYAAN ELECTRONICS PRIVATE LIMITED",
"AYAAN IMPORT EXPORT PRIVATE LIMITED",
"AYAAN RESORTS PRIVATE LIMITED",
"AYAAN TRENDZ PRIVATE LIMITED",
"AYAANSH HOSPITAL",
"AYAKSHA HEALTHCARE PRIVATE LIMITED",
"AYAM CONSULTANTS PRIVATE LIMITED",
"AYAM WELDMESH PRIVATE LIMITED",
"AYAMVEDHA INFRAENGINEERING PRIVATE LIMITED",
"AYAN INFOTECH PRIVATE LIMITED",
"AYAN MOTORS PRIVATE LIMITED",
"AYAN TECH SOLUTIONS PRIVATE LIMITED",
"AYANA ANANTHAPURAMU SOLAR PRIVATE LIMITED",
"AYANA ENERGY PRIVATE LIMITED",
"AYANA RENEWABLE POWER FOUR PRIVATE LIMITED",
"AYANA RENEWABLE POWER ONE PRIVATE LIMITED",
"AYANA RENEWABLE POWER PRIVATE LIMITED",
"AYANNA CONSUMER PRODUCTS PRIVATE LIMITED",
"AYANSH ENGINEERING INDIA PRIVATE LIMITED",
"AYANSH INFRA BUILD PRIVATE LIMITED",
"AYANSYS SOLUTIONS PRIVATE LIMITED",
"AYANWORKS TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"AYAS BUILDCON PRIVATE LIMITED",
"AYASHA ROLLER FLOUR MILL PRIVATE LIMITED",
"AYASTO STEELPAC PRIVATE LIMITED",
"AYASYA DIGITAL PRIVATE LIMITED",
"AYATA ENTERPRISE PRIVATE LIMITED",
"AYATACOM TECH SOLUTIONS PRIVATE LIMITED",
"AYATAS SOFTWARE SOLUTIONS INDIA PRIVATE LIMITED",
"AYATI DEVICES PRIVATE LIMITED",
"AYATI GROUP OF EDUCATIONAL INSTITUTIONS",
"AYATI PHARMA PRIVATE LIMITED",
"AYAZ JEWELLERS PRIVATE LIMITED",
"AYB DESIGNS AND CRAFTS PRIVATE LIMITED",
"AYD INFRA PRIVATE LIMITED",
"AYE BEE MACHINERY UDYOG PRIVATE LIMITED",
"AYE FINANCE PRIVATE LIMITED",
"AYE YES FORWARDERS PRIVATE LIMITED",
"AYEENA DEVELOPERS & CONSTRUCTIONS PRIVATE LIMITED",
"AYEGROW BUSINESS SOLUTIONS PRIVATE LIMITED",
"AYEKART FINTECH PRIVATE LIMITED",
"AYEMON STEEL & TUBES",
"AYEMS ENGINEERS PRIVATE LIMITED",
"AYESA INDIA PRIVATE LIMITED",
"AYESHA EXPORT PRIVATE LIMITED",
"AYESHA FASHION PRIVATE LIMITED",
"AYESHA INVESTMENTS PRIVATE LIMITED",
"AYESHA STEELS PVT LTD",
"AYESHAEMBROIDERIES TEXTILES PRIVATE LIMITED",
"AYG REALTY PRIVATE LIMITED",
"AYKON GLOBAL LLP",
"AYLA NETWORKS (INDIA) PRIVATE LIMITED",
"AYLA TRADERS PRIVATE LIMITED",
"AYM SYNTEX LIMITED",
"AYMA CREATIONS PRIVATE LIMITED",
"AYMAN TANNING COMPANY PRIVATE LIMITED",
"AYNIC PRIVATE LIMITED",
"AYODHYA COMMERCE PRIVATE LIMITED",
"AYODHYA FINLEASE LIMITED",
"AYODHYA FLOUR MILLS PRIVATE LIMITED",
"AYODHYA GORAKHPUR SMS TOLLS PRIVATE LIMITED",
"AYOJAN FOOD CREATIONS PRIVATE LIMITED",
"AYOKI CEMBOL ERECTORS PRIVATE LIMITED",
"AYOKI FABRICON PRIVATE LIMITED",
"AYOLEEZA CONSULTANTS PRIVATE LIMITED",
"AYON TECHNOVISION PRIVATE LIMITED",
"AYONA MULTITRADE INTL PRIVATE LIMITED",
"AYONI FOODS PRIVATE LIMITED",
"AYONIH DATA SERVICES PRIVATE LIMITED",
"AYONIZA PROJECTS PRIVATE LIMITED",
"AYOPOP TECHNOLOGY INDIA PRIVATE LIMITED",
"AYOS SCIENCES PRIVATE LIMITED",
"AYOTTA INFOTECH PRIVATE LIMITED",
"AYOTTA TECHNOLOGIES INDIA PRIVATE LIMITED",
"AYOU CINEMAS PRIVATE LIMITED",
"AYPOLS POLYMERS PRIVATE LIMITED",
"AYRA MANAGEMENT CONSULTING PRIVATE LIMITED",
"AYRAS LOGISTICS PRIVATE LIMITED",
"AYRUZ DATAMARKETING PRIVATE LIMITED",
"AYSER ENTERPRISES PRIVATE LIMITED",
"AYSHA CASHEW EXPORTS",
"AYSHA HOSPITAL",
"AYSHA REAL ESTATE PRIVATE LIMITED",
"AYSIT SOLUTIONS PRIVATE LIMITED",
"AYSUN PERSONAL CARE PRIVATE LIMITED",
"AYU DEVICES PRIVATE LIMITED",
"AYU DIGITAL PRIVATE LIMITED",
"AYUBAL FOOD & HERBAL PRIVATE LIMITED",
"AYUGEN BIOSCIENCES PRIVATE LIMITED",
"AYUGEN PHARMA PRIVATE LIMITED",
"AYUKALP UAP PHARMA PRIVATE LIMITED",
"AYULABS PRIVATE LIMITED",
"AYUR COUNTY RESORTS LIMITED",
"AYURADHYA CONSTRUCTION PRIVATE LIMITED",
"AYURDA INFRAPROJECTS PRIVATE LIMITED",
"AYURGREEN AYURVEDA HOSPITALS PRIVATE LIMITED",
"AYURINSTINCT HEALTHCARE PRIVATE LIMITED",
"AYURISH EXPORTS PRIVATE LIMITED",
"AYURNET HEALTHCARE PRIVATE LIMITED",
"AYURON MEDICAL SYSTEMS PRIVATE LIMITED",
"AYURSATVA HERBALS PRIVATE LIMITED",
"AYURSHAKTI AYURVED PRIVATE LIMITED",
"AYURSOUKHYAM HEALTHCARE PRIVATE LIMITED",
"AYURSUNDRA HEALTH CARE PRIVATE LIMITED",
"AYURSUNDRA HOSPITALS GUWAHATI PRIVATE LIMITED",
"AYURVED PRATISHTHAN (NASIK) PRIVATE LIMITED",
"AYURVED SUMSHODHANALAYA PUNE PRIVATE LIMITED",
"AYURVEDA BAZAR PRIVATE LIMITED",
"AYURVEDA COLLEGE",
"AYURVEDA ONE PRIVATE LIMITED",
"AYURVEDA RASASHALA FOUNDATION",
"AYURVEDA YOGASHRAM REMEDIES PRIVATE LIMITED",
"AYURVEDAGRAM HERITAGE WELLNESS CENTRE PRIVATE LIMITED",
"AYURVEDANT PRIVATE. LIMITED",
"AYURVEDASRAMAM PRIVATE LIMITED",
"AYURVET LIMITED",
"AYURVISHWA AUSHADHALAYA PRIVATE LIMITED",
"AYURYA RETAIL PRIVATE LIMITED",
"AYUSH CRANE HIRING PRIVATE LIMITED",
"AYUSH DEPARTMENT",
"AYUSH EDIBLE OIL PRIVATE LIMITED",
"AYUSH ENVIROTECH PRIVATE LIMITED",
"AYUSH FLEXIPACK PRIVATE LIMITED",
"AYUSH FOOD PRODUCT PRIVATE LIMITED",
"AYUSH FOREX SERVICES PRIVATE LIMITED",
"AYUSH HEALTHCARE PRIVATE LIMITED",
"AYUSH HERBS PRIVATE LIMITED",
"AYUSH ICU &MULTISPECIALITY HOSPITAL",
"AYUSH ISPAT TRADING PRIVATE LIMITED",
"AYUSH KASLIWAL DESIGN PRIVATE LIMITED",
"AYUSH MART PRIVATE LIMITED",
"AYUSH MOULDERS PRIVATE LIMITED",
"AYUSH MULTISPECIALITY HOSPITAL",
"AYUSH ORNAMENTS PRIVATE LIMITED",
"AYUSH POLYMERS PVT LTD",
"AYUSH PROCON PRIVATE LIMITED",
"AYUSH RECRUITMENT AND MANAGEMENT PRIVATE LIMITED",
"AYUSH RICE MILL PRIVATE LIMITED",
"AYUSH SALES PRIVATE LIMITED",
"AYUSH SOFTWARE PRIVATE LIMITED",
"AYUSH TEXLENE LIMITED",
"AYUSH TOYS MARKETING PRIVATE LIMITED",
"AYUSHGRO FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"AYUSHI CROP SCIENCE PRIVATE LIMITED",
"AYUSHI DENSITY PRIVATE LIMITED",
"AYUSHI FREIGHT PRIVATE LIMITED",
"AYUSHI INFRAREALITY PRIVATE LIMITED",
"AYUSHI LOGISTICS INDIA PRIVATE LIMITED",
"AYUSHINE BETTER CONCEPT WELLCARE PRIVATE LIMITED",
"AYUSHMAN COLD CHAIN & PRESERVATIONS PRIVATE LIMITED",
"AYUSHMAN COMMOTRADE PRIVATE LIMITED",
"AYUSHMAN FERTILIZERS PRIVATE LIMITED",
"AYUSHMAN HOSPITAL & HEALTH SERVICES",
"AYUSHMAN HOSPITAL AND HEALTH SERVICES",
"AYUSHMAN MEDICAL DIAGNOSTICS PRIVATE. LIMITED.",
"AYUSHMAN MERCHANTS PRIVATE LIMITED",
"AYUSHMAN MULTISPECIALITY HOSPITAL PRIVATE LIMITED",
"AYUSHMAN ROPES & TAPES PRIVATE LIMITED",
"AYUSHMAN SOLUTIONS PRIVATE LIMITED",
"AYUSHMAN SYNERGY PRIVATE LIMITED",
"AYUSHRAJ ENTERPRISES PRIVATE LIMITED",
"AYUSIDDH HEALTH CARE PRIVATE LIMITED",
"AYUSMAN MINERALS & PROPERTIES PRIVATE LIMITED",
"AYUSYA HOME HEALTH CARE PRIVATE LIMITED",
"AYVA APPARELS PRIVATE LIMITED",
"AYYAMAR INFRAPROJECTS INDIA PRIVATE LIMITED",
"AYYAN FIREWORKS FACTORY PRIVATE LIMITED",
"AYYANAR STORE",
"AYYANNA INFRA PRIVATE LIMITED",
"AYYAPPA CNC PRIVATE LIMITED",
"AYYAPPA COTTON MILLS PRIVATE LIMITED",
"AYYAPPA INFRA PROJECTS PRIVATE LIMITED",
"AYZO INTERNATIONAL PRIVATE LIMITED",
"AZ FASHIONSCAPE PRIVATE LIMITED",
"AZ INFOLINK PRIVATE LIMITED",
"AZ TEXSOURCING PRIVATE LIMITED",
"AZ WINDOWS PRIVATE LIMITED",
"AZA FASHIONS PRIVATE LIMITED",
"AZA SHIPPING PRIVATE LIMITED",
"AZAAN INTERNATIONAL SCHOOL",
"AZAD AUTOMOBILES PRIVATE LIMITED",
"AZAD BOOK DEPOT PRIVATE LIMITED",
"AZAD CARRYING PRIVATE LIMITED",
"AZAD COACH BUILDERS PRIVATE LIMITED",
"AZAD COACH PRIVATE LIMITED",
"AZAD ELECTRONICS PRIVATE LIMITED",
"AZAD ENGINEERING LIMITED",
"AZAD ENGINEERING PRIVATE LIMITED",
"AZAD GROUP OF ENGINEERING LUCKNOW",
"AZAD INDUSTRIES",
"AZAD INFRAPOWER PRIVATE LIMITED",
"AZAD INSTITUTE OF PHARMACY AND RESEARCH",
"AZAD ISPAT INDIA PRIVATE. LIMITED.",
"AZAD MAHAVIDYALAYA AUSA",
"AZAD MARKETING AND MFGR PVT LTD",
"AZAD METALS PRIVATE LIMITED",
"AZAD NAURANG INTER COLLEGE SAINTHAL BAREILLY",
"AZAD OFFSET PRINTERS PRIVATE LIMITED",
"AZAD PIPES PRIVATE LIMITED",
"AZADHIND CONSTRUCTION PVT LTD",
"AZAEL MANUFACTURING PRIVATE LIMITED",
"AZAFRAN INNOVACION LIMITED",
"AZAKEM LABS PRIVATE LIMITED",
"AZAKTA TRADING PRIVATE LIMITED",
"AZALEA BIOTEC PRIVATE LIMITED",
"AZALEA CAPITAL PARTNERS LLP",
"AZAM CONSTRUCTION AND DEVELOPERS PRIVATE LIMITED",
"AZAM LAMINATORS PRIVATE LIMITED",
"AZAMIN ENTERPRISES PRIVATE LIMITED",
"AZANS ENTERPRISES PRIVATE LIMITED",
"AZARA JEWELS LIMITED",
"AZAYATEK TECHNOLOGIES PRIVATE LIMITED",
"AZAZO DIVIDERS PRIVATE LIMITED",
"AZAZO PRIVATE LIMITED",
"AZBIL INDIA PRIVATE LIMITED",
"AZBIL TELSTAR INDIA PRIVATE LIMITED",
"AZCOM INFOSOLUTIONS INDIA PRIVATE LIMITED",
"AZCOR TABLEWARE INDIA PRIVATE LIMITED",
"AZE CONSULTING PRIVATE LIMITED",
"AZEAGAIA DEVELOPMENT PRIVATE LIMITED",
"AZEEM MADHYAMIK V UCHHA MADHYAMIK VIDYALAY",
"AZEEM MADHYAMIK V UCHHAMADHYAMIK VIDYALAY AUSA",
"AZEEM URDU SCHOOL",
"AZEEN AGRO PRIVATE LIMITED",
"AZEEN EXIM PRIVATE LIMITED",
"AZEEZ FABRICS PRIVATE LIMITED",
"AZEHA SYSTEMS PRIVATE LIMITED",
"AZEIL HR SOLUTIONS",
"AZELIS INDIA PRIVATE LIMITED",
"AZENA HEALTH CARE PRIVATE.LIMITED.",
"AZENA LIVEPLAY PRIVATE LIMITED",
"AZENTIO",
"AZENTIO SOFTWARE PRIVATE LIMITED",
"AZEOCRYST ORGANICS PRIVATE LIMITED",
"AZHIYUR VENGALAM ROAD PRIVATE LIMITED",
"AZICO BIOPHORE INDIA PRIVATE LIMITED",
"AZIDUS LABORATORIES LIMITED",
"AZILEN TECHNOLOGIES PRIVATE LIMITED",
"AZILIST BUSINESS SOLUTIONS PRIVATE LIMITED",
"AZIM PREMJI FOUNDATION",
"AZIM PREMJI FOUNDATION FOR DEVELOPMENT",
"AZIM PREMJI PHILANTHROPIC INITIATIVES PRIVATE LIMITED",
"AZIM PREMJI TRUSTEE COMPANY PRIVATE LIMITED",
"AZIM PREMJI UNIVERSITY",
"AZIMUDDIN ASHRAF ISLAMIA INTER COLLEGE",
"AZIMUTH BUSINESS ON WHEELS PRIVATE LIMITED",
"AZIMUTH INVESTMENTS LIMITED",
"AZIMUTH SOFTWARE INDIA PRIVATE LIMITED",
"AZINE HEALTHCARE PRIVATE LIMITED",
"AZINE WEB TECHNOLOGIES PRIVATE LIMITED",
"AZISTA INDUSTRIES PRIVATE LIMITED",
"AZIZ AND ASSOCIATES INDIA PRIVATE LIMITED",
"AZIZ ENTERPRISES",
"AZIZ TRADE LINKS PVT LTD",
"AZMARQ TECHNOVATION PRIVATE LIMITED",
"AZOIC WATER PRIVATE LIMITED",
"AZOLE RASAYANAS INDIA PRIVATE LIMITED",
"AZORES INFRASTRUCTURE PRIVATE LIMITED",
"AZOVA DEVELOPMENT PRIVATE LIMITED",
"AZOVA RCM PRIVATE LIMITED",
"AZPIRE PHARMA PRIVATE LIMITED",
"AZTEC AUTO LIMITED",
"AZTEC ENGINEERS PRIVATE LIMITED",
"AZTEC FLUIDS & MACHINERY LIMITED",
"AZTEC FLUIDS & MACHINERY PRIVATE LIMITED",
"AZTEC PROCESS AUTOMATION PRIVATE LIMITED",
"AZTEC RECYCLING HUB PRIVATE LIMITED",
"AZTEC SHIVA HANDICRAFTS AND ARTS PRIVATE LIMITED",
"AZTEC SHOES PRIVATE LIMITED",
"AZTECH INDIA PRIVATE LIMITED",
"AZTECH INDUSTRIES PRIVATE LIMITED",
"AZTECH WATERPROOFING SYSTEMS PRIVATE LIMITED",
"AZTON HEALTHCARE PRIVATE LIMITED",
"AZTRAL AUTOMOTIVE PRIVATE LIMITED",
"AZUGA TELEMATICS PRIVATE LIMITED",
"AZUL ARC INDIA INTERACTIVE PRIVATE LIMITED",
"AZUL SYSTEMS INDIA PRIVATE LIMITED",
"AZURA PROJECTS PRIVATE LIMITED",
"AZURE CLOUD SERVICES PRIVATE LIMITED",
"AZURE DIAMONDS PRIVATE LIMITEDCAT",
"AZURE ENTERTAINMENT PRIVATE LIMITED",
"AZURE JOUEL PRIVATE LIMITED",
"AZURE KNOWLEDGE CORPORATION PRIVATE LIMITED",
"AZURE LOGISTICS PRIVATE LIMITED",
"AZURE MULTITRADE AND VANIJYA PRIVATE LIMITED",
"AZURE POWER (GUJRAT) PRIVATE LIMITED",
"AZURE POWER FORTY FOUR PRIVATE LIMITED",
"AZURE POWER FORTY THREE PRIVATE LIMITED",
"AZURE POWER MERCURY PRIVATE LIMITED",
"AZURE POWER ROOFTOP PRIVATE LIMITED",
"AZURE POWER SATURN PRIVATE LIMITED",
"AZURE POWER THIRTY EIGHT PRIVATE LIMITED",
"AZURE POWER THIRTY SEVEN PRIVATE LIMITED",
"AZURE POWER URANUS PRIVATE LIMITED",
"AZURE PRESS PRIVATE LIMITED",
"AZURE RENEWABLE ENERGY PRIVATE LIMITED",
"AZURE SKYNET SOLUTIONS PRIVATE LIMITED",
"AZURE SOFTWARE PVT LTD",
"AZURE SOLAR SOLUTIONS PRIVATE LIMITED",
"AZURE SUN ENERGY PRIVATE LIMITED",
"AZURE SWITCHGEAR PRIVATE LIMITED",
"AZURE SYSTEMS PRIVATE LIMITED",
"AZURE TREE LANDS PRIVATE LIMITED",
"AZURETALE PRIVATE LIMITED",
"AZURI INDIA PRIVATE LIMITED",
"AZURO PROPERTY MANAGEMENT SERVICES PRIVATE LIMITED",
"AZUS ASPHALTS INDIA PRIVATE LIMITED",
"AZVASA EDUCATION PRIVATE LIMITED",
"AZVEN REALTY VENTURES PRIVATE LIMITED",
"AZVESTON HEALTHCARE PRIVATE LIMITED",
"AZVI CONSTRUCTION PRIVATE LIMITED",
"AZVIK GLASSES PRIVATE LIMITED",
"AZYM TECHNOLOGIES (OPC) PRIVATE LIMITED",
"AZYTUS MATERIAL SCIENCES PRIVATE LIMITED",
"AZZ SPECIALTY WELDING SERVICES INDIA PRIVATE LIMITED",
"AZZAROSOL SOLUTIONS PRIVATE LIMITED",
"AZZURE FOREX AND TRAVELS PRIVATE LIMITED",
"B & A LIMITED",
"B & BARTONI INDIA TRADING PRIVATE LIMITED",
"B & G INFRASTRUCTURE COMPANY PRIVATE LIMITED",
"B & G SOLAR PRIVATE LIMITED",
"B & H LOGISTICS PRIVATE LIMITED",
"B & I TECH SOLUTIONS PRIVATE LIMITED",
"B & M CHEMICALS LTD.",
"B & M HOTBREADS PRIVATE LIMITED",
"B & P AUTO-TECH ENGINEERING PRIVATE LIMITED",
"B & W SEPARATION INDIA PRIVATE LIMITED",
"B 2 B ALLIANCES PRIVATE LIMITED",
"B 2 B COMMODITIES PRIVATE LIMITED",
"B 2 B CONCRETE PRIVATE LIMITED",
"B A AND K R COLLEGE OF PHARMACY",
"B A G CONVERGENCE PRIVATE LIMITED",
"B A MOTORS PRIVATE LIMITED",
"B A SOLUTIONS INDIA PRIVATE LIMITED",
"B AND A PACKAGING INDIA LIMITED",
"B AND B INFRASTRUCTURE LIMITED",
"B AND H ELECTRODES PRIVATE LIMITED",
"B AND L PROJECT CONSTRUCTIONS PRIVATE LIMITED",
"B AND S ENGINEERING CONSULTANTS PRIVATE LIMITED",
"B AND S REALTORS PRIVATE LIMITED",
"B ARUNKUMAR CAPITAL AND CREDIT SERVICES PRIVATE LIMITED",
"B B BANTHIA FINANCE PRIVATE LIMITED",
"B B BANTHIA JEWELLERS LLP",
"B B CORRUGATING PRIVATE LIMITED",
"B B ESTATES & EXPORTS PRIVATE LIMITED",
"B B FATIMA URDU KANYA HIGH SCHOOL DHARWA DIST YAVATMAL",
"B B GEMS AND JEWELS PRIVATE LIMITED",
"B B N ENGINEERING PRIVATE LIMITED",
"B B PROFESSIONALS MARKETING PRIVATE LIMITED",
"B B R GREEN FIELDS PRIVATE LIMITED",
"B B REALTECH PRIVATE LIMITED",
"B B SHAH PRIVATE LIMITED",
"B B TREXIM PRIVATE LIMITED",
"B BRAUN MEDICAL INDIA PRIVATE LIMITED",
"B C BIYANI INFRASTRUCTURE PRIVATE LIMITED",
"B C BIYANI PROJECTS PRIVATE LIMITED",
"B C C AUTO PVT LTD",
"B C C FUBA INDIA LIMITED",
"B C C PROJECTS PVT LTD",
"B C ELECTRICALS PVT LTD",
"B C GROUP",
"B C INDIA SERVICES",
"B C L FABRICS PRIVATE LIMITED",
"B C TECHNOMATION PRIVATE LIMITED",
"B CHINTAMANI DYES PRIVATE LIMITED",
"B CHOKSHI CHEM PRIVATE LIMITED",
"B CHOPDA CONSTRUCTION PRIVATE LIMITED",
"B D AUTOMOBILES PRIVATE LIMITED",
"B D BAJORIA INTER COLLEGE",
"B D CORPORATES PRIVATE LIMITED",
"B D DHALLA TRANSPORT PRIVATE LIMITED",
"B D EDIBLE OILS PRIVATE LIMITED",
"B D ELECTROCOM PRIVATE LIMITED",
"B D FEEDS PRIVATE LIMITED",
"B D GUPTA AND SONS PRIVATE LIMITED",
"B D H DYECHEM PRIVATE LIMITED",
"B D IMPEX PRIVATE LIMITED",
"B D INDUSTRIES INDIA PRIVATE LIMITED",
"B D INDUSTRIES PUNE PRIVATE LIMITED",
"B D INTER COLLEGE KHEDA MUGAL",
"B D LAB SOLUTIONS",
"B D M INTERNATIONAL",
"B D MOTORS LIMITED",
"B D O KHAKNAR",
"B D O PANCHAYAT SAMITI UMRAIN",
"B D PACKAGING & ALLIED INDUSTRIES PRIVATE LIMITED",
"B D PANDEY DISTRICT HOSPITAL",
"B D PATEL QUARRY WORKS PVT LTD",
"B D PETIT PARSEE GEN HOSPITAL",
"B D PHARMACEUTICAL WORKS PRIVATE LIMITED",
"B D PROMOTERS PRIVATE LIMITED",
"B D RAIZADA PROJECTS PRIVATE LIMITED",
"B D S DIAMOND ENTERPRISES PRIVATE LIMITED",
"B D SECURITY LIMITED",
"B D SECURITY PRIVATE LIMITED",
"B D SILK INDUSTRIES PRIVATE LIMITED",
"B D SOMANI INTERNATIONAL SCHOOL",
"B D TEA ESTATES PRIVATE LIMITED",
"B D VANIJYA UDYOG PVT LTD",
"B D V'S HOTELS PRIVATE LIMITED",
"B D YARN PRIVATE LIMITED",
"B DAS & ASSOCIATES PRIVATE LIMITED",
"B DAULAT LTD",
"B DEVCHAND AND SONS SHIPPING PRIVATE LIMITED",
"B DEY (INDIA) PVT LTD",
"B DURGA REDDY INFRASTRUCTURES PRIVATE LIMITED",
"B E & I COMMERCIAL PVT LTD",
"B E BILLIMORIA AND COMPANY LIMITED",
"B E C CHEMICALS PRIVATE LIMITED",
"B E C CONDUITS PRIVATE LIMITED",
"B E O BADNAGAR",
"B E O CHHEGAON MAKHAN KHANDWA",
"B E O CHHINDWARA",
"B E O HARSOOD",
"B E O JAISINAGAR MADHYA PRADESH SAGAR",
"B E O PANDHANA",
"B E O PETLAWAD JHABUA",
"B E O PUNASA",
"B E O TARANA",
"B E OFFICE AUTOMATION PRODUCTS PRIVATE LIMITED",
"B E SOLUTIONS PRIVATE LIMITED",
"B F S CHEMICALS PRIVATE LIMITED",
"B FOUR EXPRESS SERVICES PRIVATE LIMITED",
"B FOURESS P LIMITED",
"B G AQUA PRIVATE LIMITED",
"B G CHITALE DAIRIES PVT LTD",
"B G DISTRIBUTORS PRIVATE LIMITED",
"B G INTERNATIONAL PRIVATE LIMITED",
"B G MANAGEMENT SERVICES PRIVATE LIMITED",
"B G P HEALTHCARE PRIVATE LIMITED",
"B G R REALITIES PRIVATE LIMITED",
"B G S CENTRAL SCHOOL",
"B G SERVICES & EXPORTS PRIVATE LIMITED",
"B G SHIRKE CONSTRUCTION TECHNOLOGY PRIVATE LIMITED",
"B G SOMADDER & SONS PVT LTD",
"B G STEELS PRIVATE LIMITED",
"B G TIMBER PRIVATE LIMITED",
"B GHOSE AND CO PRIVATE LIMITED",
"B GUPTA (TEA) PVT LTD",
"B H FASHION",
"B J BHANDARI PAPERS PRIVATE LIMITED",
"B J ELECTRONICS PRIVATE LIMITED",
"B J HOTELS PRIVATE LIMITED",
"B J MEDICAL COLLEGE PUNE",
"B J PARSANA",
"B J Z EXIM PRIVATE LIMITED",
"B JAIN PUBLISHERS PRIVATE LIMITED",
"B K AGGARWAL AND COMPANY PVT LTD",
"B K ANAND FOODS PRIVATE LIMITED",
"B K AUTOMOBILES PRIVATE LIMITED",
"B K B TRANSPORT PRIVATE LIMITED",
"B K BIRLA CENTRE FOR EDUCATION",
"B K BIRLA PUBLIC SCHOOL",
"B K CHAVAN BUILDERS PRIVATE LIMITED",
"B K CONSTRUCTION AND CONSULTANCY PRIVATE LIMITED",
"B K DEVELOPERS",
"B K ELECTRICALS PRIVATE LIMITED",
"B K FASHIONS",
"B K FOOD PRODUCTS PRIVATE LIMITED",
"B K FREIGHT FORWARDERS PRIVATE LIMITED",
"B K G S INT COLL PARKHAM MATHURA",
"B K GARMENTS PRIVATE LIMITED",
"B K HYDRAULICS",
"B K JEWELLERS CENTRE PRIVATE LIMITED",
"B K LIFTING TACKLES MANUFACTURER PRIVATE LIMITED",
"B K OILS PRIVATE LIMITED",
"B K P MEDIAVISION PRIVATE LIMITED",
"B K P S COLLAGE OF ARCHITECTURE",
"B K R INFRABUILDCON PRIVATE LIMITED",
"B K ROY PVT LTD",
"B K RUBBER INDUSTRIES PRIVATE LIMITED",
"B K SARAF EXIM PRIVATE LIMITED",
"B K SARAF PRIVATE LIMITED",
"B K SHAH TRADEX PRIVATE LIMITED",
"B K SILK MILLS PRIVATE LIMITED",
"B K VINOD & COMPANY PRIVATE LIMITED",
"B L AGRO INDUSTRIES LIMITED",
"B L CONTAINERS PRIVATE LIMITED",
"B L ELECTRICALS LIMITED",
"B L FOUNDRY PVT LTD",
"B L G INTERNATIONAL HING PRIVATE LIMITED",
"B L G PLASTO PRIVATE LIMITED",
"B L GUPTA CONSTRUCTION PRIVATE LIMITED",
"B L HARBERT INTERNATIONAL LLC",
"B L HISSARIA JEWELLERS PRIVATE LIMITED",
"B L INFRA PROJECTS PRIVATE LIMITED",
"B L INTERNATIONAL CLOTHING PRIVATE LIMITED",
"B L INTERNATIONAL PRIVATE LIMITED",
"B L K ENTERPRISES PRIVATE LIMITED",
"B L K FERRITES PRIVATE LTD",
"B L K LIFESTYLE LIMITED",
"B L KASHYAP AND SONS LIMITED",
"B L LIFESCIENCES PRIVATE LIMITED",
"B L MEHTA CONSTRUCTIONS PRIVATE LIMITED",
"B L N MEMORIAL PUBLIC SCHOOL",
"B L R KNITS PRIVATE LIMITED",
"B L SYNTHETIC MILLS PRIVATE LIMITED",
"B L TRANSPORT PRIVATE LIMITED",
"B LAL FABRICS PRIVATE LIMITED",
"B M AIRCONDITIONING PRIVATE LIMITED",
"B M AUTOSALES PRIVATE LIMITED",
"B M C SPINNERS PRIVATE LIMITED",
"B M COLLEGE OF COMMERCE",
"B M CONSTROTECH PRIVATE LIMITED",
"B M D CHEMICALS PRIVATE LIMITED",
"B M DYEING PVT LTD",
"B M FABRICS (INDIA) PRIVATE LIMITED",
"B M FASTENERS PRIVATE LIMITED",
"B M FINANCIAL SERVICES INDIA PRIVATE LIMITED",
"B M G CHEMICALS PRIVATE LIMITED",
"B M G ENTERPRISES LIMITED",
"B M G ENTERPRISES LTD",
"B M GANDHI SECURITIES PRIVATE LIMITED",
"B M GUPTA ESTATES PRIVATE LIMITED",
"B M HOSPITALS",
"B M HOUSE (INDIA) LIMITED",
"B M INSULATIONS PRIVATE LIMITED",
"B M KHANNA AND BROS PVT LTD",
"B M METERS PRIVATE LIMITED",
"B M N ALLOYSTEELS PRIVATE LIMITED",
"B M OILS PRIVATE LIMITED",
"B M P TEXTILE MILLS PRIVATE LIMITED",
"B M PAPERS PRIVATE LIMITED",
"B M PAUL CHOUDHURY & CO PVT LTD",
"B M ROADLINES PRIVATE LIMITED",
"B M RUIA GIRLS COLLEGE",
"B M SHAH HOSPITAL & MEDICAL RESEARCH CENTRE",
"B M TECHNO MACHINES PRIVATE LIMITED",
"B M V FRAGRANCES PRIVATE LIMITED",
"B MORE FASHION PRIVATE LIMITED",
"B N A ENTERPRISES PRIVATE LIMITED",
"B N A INFRASTRUCTURE PRIVATE LIMITED",
"B N B COMMUNICATIONS PRIVATE LIMITED",
"B N B S CEMENTS AND PRODUCTS PVT LTD",
"B N BHOWMICK TEA PROCESSING PRIVATE LIMITED",
"B N BOSE & CO (MARINE ) PVT LTD",
"B N HEALTHCARE PRIVATE LIMITED",
"B N HI-TECH MACHINES PVT LTD",
"B N K MEDICARE PRIVATE LIMITED",
"B N KEDIA & COMPANY PRIVATE LIMITED",
"B N M INSTITUTE OF TECHNOLOGY",
"B N N COLLEGE(A S & C) BHIWANDI",
"B N PAPER AND BOARD PRIVATE LIMITED",
"B N PROJECTS PRIVATE LIMITED",
"B N RATHI SECURITIES LIMITED",
"B N S D INTER COLLEGE",
"B N TEXTILES & INVESTMENTS PVT LTD",
"B N TOOLS AND COMPONENTS PRIVATE LIMITED",
"B NATHA SINGH KARAM SINGH PRIVATE LIMITED",
"B NEW MOBILES PRIVATE LIMITED",
"B O WOOLLEN MILL PRIVATE LIMITED",
"B P ALLOYS LIMITED",
"B P DECON PRIVATE LIMITED",
"B P E S HIGH SCHOOL BHANDUP",
"B P ENGINEERS & ELECTRONICS PVT LTD",
"B P FOOD PRODUCTS PRIVATE LIMITED",
"B P GANGAR CONSTRUCTION PRIVATE LIMITED",
"B P INDUSTRIES PLYBOARDS PRIVATE LIMITED",
"B P M HIGH SCHOOL",
"B P MARINE ACADEMY",
"B P OIL MILLS LIMITED",
"B P PODDAR INSTITUTE OF MANAGEMENT AND TECHNOLOGY",
"B PATEL INFRASTRUCTURE PRIVATE LIMITED",
"B POSITIVE HOUSE KEEPING",
"B PRIMO TELECOMMUNICATIONS PRIVATE LIMITED",
"B R AGENCIES PRIVATE LIMITED",
"B R AGROTECH LIMITED",
"B R BUILDCARE SOLUTIONS PRIVATE LIMITED",
"B R C MANGROL",
"B R D FINANCE LIMITED",
"B R DAIRYCHEM PRIVATE LIMITED",
"B R ENGINEERING PLASTICS PRIVATE LIMITED",
"B R ENTERPRISES",
"B R EQUIPMENTS PRIVATE LIMITED",
"B R FIBERS PRIVATE LIMITED",
"B R FORMALIN PRIVATE LIMITED",
"B R GOYAL INFRASTRUCTURE LIMITED",
"B R GRAINS PRIVATE LIMITED",
"B R I ELECTRICALS PVT LTD",
"B R I O COMMUNICATIONS PRIVATE LIMITED",
"B R INDUSTRIES LIMITED",
"B R INFRAPROMOTERS PRIVATE LIMITED",
"B R IRON FOUNDRY PVT LTD",
"B R JALAN SECURITIES PRIVATE LIMITED",
"B R JEWELLERS",
"B R K EDUCATIONAL SOCIETY",
"B R KAPOOR AND SONS PRIVATE LIMITED",
"B R MAHESWARI & CO LLP",
"B R MANPOWER FACILITY MANAGEMENT PRIVATE LIMITED",
"B R OIL INDUSTRIES PRIVATE LIMITED",
"B R OVERSEAS LIMITED",
"B R PADDY PROCESSORS PRIVATE LIMITED",
"B R PETROCHEM PRIVATE LIMITED",
"B R PLASTIC INDUSTRIES PRIVATE LIMITED",
"B R POUCH PACKING MACHINES PRIVATE LIMITED",
"B R PRODUCTS PRIVATE LIMITED",
"B R RESTAURANTS PRIVATE LIMITED",
"B R ROADLINES (INDIA) PRIVATE LIMITED",
"B R ROY & SONS PVT LTD",
"B R S HOSPITALS PRIVATE LIMITED",
"B R S PRECISION MANUFACTURING PRIVATE LIMITED",
"B R SOFTECH PRIVATE LIMITED",
"B R SOLUTIONS PRIVATE LIMITED",
"B R STEEL PRODUCTS PRIVATE LIMITED",
"B R TYAGI SR SEC SCHOOL",
"B ROSHANLAL CHEMICALS PRIVATE LIMITED",
"B S A COLLEGE OF ENGG & TECHNOLOGY",
"B S A COLLEGE OF ENGINEERING AND TECHNOLOGY",
"B S ABDUR RAHMAN CRESCENT INSTITUTE OF SCIENCE & TECHNOLOGY",
"B S ANANGPURIA EDUCATIONAL INSTITUTE",
"B S ANANGPURIA INSTITUTE OF PHARMACY",
"B S AND SERVICE PRIVATE LIMITED",
"B S B K ENGINEERS PRIVATE LIMITED",
"B S C C EXPLORATION PRIVATE LIMITED",
"B S C PROJECTS PRIVATE LIMITED",
"B S CHADHA FOREX PRIVATE LIMITED",
"B S ENGINEERING MACHINERY PRIVATE LIMITED",
"B S ENTREPRENEURS PRIVATE LIMITED",
"B S ENVIRO N INFRACON PRIVATE LIMITED",
"B S FASTENERS PRIVATE LIMITED",
"B S FOOTWEAR PRIVATE LIMITED",
"B S G HOTELSS LEASINGSS LIMITED",
"B S GEOTECH PRIVATE LIMITED",
"B S GOEL FINANCE COMPANY PRIVATE LIMITED",
"B S INNOVATIVE PRIVATE LIMITED",
"B S K FASHION AND DESIGNERS PRIVATE LIMITED",
"B S M S VARTAKNAGAR MADHYAMIK VIDYALAYA",
"B S N INFOTECH PRIVATE LIMITED",
"B S POLYFILL PRIVATE LIMITED",
"B S PUMPS PRIVATE LTD",
"B S R INFRA VENTURES INDIA PRIVATE LIMITED",
"B S S APPARELS PRIVATE LIMITED",
"B S SANDHU AND ASSOCIATES PRIVATE LIMITED",
"B S SCIENTIFIC PRIVATE LIMITED",
"B S SPONGE PRIVATE LIMITED",
"B S SURGICARE INDIA PRIVATE LIMITED",
"B S Y INFRASTRUCTURE PRIVATE LIMITED.",
"B SEC SERVICES LIMITED",
"B SECURE PROTECTION & GUARDING PRIVATE LIMITED",
"B SHAH IMPEX PRIVATE LIMITED",
"B SIZZLER DRESSES PVT LTD",
"B SOURCE IMPEX PRIVATE LIMITED",
"B SRINIVAS RAO POWER CONSTRUCTIONS PRIVATE. LIMITED.",
"B STRACTORS PRIVATE LIMITED",
"B T ENTERPRISES PRIVATE LIMITED",
"B T INFOSYS PRIVATE LIMITED",
"B T INFRASTRUCTURE PRIVATE LIMITED",
"B T S KNITSS PROCESS PRIVATE LIMITED",
"B T SAVANI KIDNEY HOSPITAL",
"B T WATER TREATMENT PRIVATE LIMITED",
"B U BHANDARI AUTO PRIVATE LIMITED",
"B V C LOGISTICS PRIVATE LIMITED",
"B V C SECURITY TRANSPORTATION PRIVATE LIMITED",
"B V CHINAI AND CO INDIA PRIVATE LIMITED",
"B V COTTON PRIVATE LIMITED",
"B V D U DENTAL COLLEGE & HOSPITAL",
"B V H MANUFACTURING INDIA PRIVATE LIMITED",
"B V L POWER SYSTEMS PRIVATE LIMITED",
"B VIPUL AND CO",
"B& B MARKETING PVT LTD",
"B&B ANALYTICS PRIVATE LIMITED",
"B&B DEVELOPERS & BUILDERS PRIVATE LIMITED",
"B&B GROWING INDUSTRIES PRIVATE LIMITED",
"B&B MACHINES PRIVATE LIMITED",
"B&B TRIPLEWALL CONTAINERS LIMITED",
"B&G INTERNATIONAL INDIA PRIVATE LIMITED",
"B&H TEXFAB PRIVATE LIMITED",
"B&N LOGISTICS PRIVATE LIMITED",
"B&R LEISURE PRIVATE LIMITED",
"B. A. ENTERPRISES PVT LTD",
"B. A. MOHOTA TEXTILES TRADERS PRIVATE LIMITED",
"B. B. COACHTECH INDIA PRIVATE LIMITED",
"B. B. TRADEX PRIVATE LIMITED",
"B. BANSAL AND COMPANY PRIVATE LIMITED",
"B. C. BHUYAN CONSTRUCTIONS PRIVATE LIMITED",
"B. C. DEB ELECTROTRADE PRIVATE LIMITED",
"B. D. AGRO PRODUCTS PRIVATE LIMITED",
"B. D. AGROTECH PRIVATE LIMITED",
"B. D. R. D. ROLLER FLOUR MILLS PRIVATE LIMITED",
"B. G. A. TRADELINK PRIVATE LIMITED.",
"B. G. SHIRKE REDEVELOPMENT AND GAS PRIVATE LIMITED",
"B. H. PACKAGING PRIVATE LIMITED",
"B. H. REVANI PRASAD CONSTRUCTIONS PRIVATE LIMITED",
"B. K. AGRO PRODUCTS PRIVATE LIMITED",
"B. K. COMMOTRADE PRIVATE LIMITED",
"B. K. ENGINEERS INDIA PRIVATE LIMITED",
"B. K. INTERNATIONAL PRIVATE LIMITED",
"B. K. STEELS PVT. LTD.",
"B. K.POLYTECH PRIVATE LIMITED",
"B. L. SUGANDHI MARKETING PRIVATE LIMITED",
"B. M. GUPTA BUILDERS PRIVATE LIMITED",
"B. M. GUPTA DEVELOPERS PRIVATE LIMITED",
"B. M. GUPTA PROMOTERS PRIVATE LIMITED",
"B. M. INFOTRADE PRIVATE LIMITED",
"B. M. MEDICAL AND RESEARCH CENTRE PRIVATE LIMITED",
"B. M. PHARMA & HEALTHCARE PRIVATE LIMITED",
"B. M. PHARMACHEM (INDIA) PRIVATE LIMITED",
"B. M. RAJ INDUSTRIES",
"B. M. S. CORPORATION PRIVATE LIMITED",
"B. M. SHAH CARE PRIVATE LIMITED",
"B. M. SHAH HOSPITAL & MEDICAL RESEARCH CENTER",
"B. N. AGRAWAL CONSTRUCTIONS PRIVATE LIMITED",
"B. N. EXPORTS PRIVATE LIMITED",
"B. N. GLOBAL PRIVATE LIMITED",
"B. N. JEWELLERS",
"B. N. SONS",
"B. P. EDIBLE OILS PRIVATE LIMITED",
"B. P. G. SECURITIES PRIVATE LIMITED",
"B. PAUL FOREX PRIVATE LIMITED",
"B. R. AGRO PRODUCTS PRIVATE LIMITED",
"B. R. CERAMICS PRIVATE LIMITED",
"B. R. METAL AND ALLOYS (GUJ) PRIVATE LIMITED",
"B. R. S. MULTITRADE PRIVATE LIMITED",
"B. R. SPONGE & POWER LIMITED",
"B. RAMARAO & SONS JEWELLERS PRIVATE LIMITED",
"B. RAMESHKUMAR METALS PRIVATE LIMITED",
"B. S. BIOTECH PRIVATE LIMITED",
"B. S. SEA FOODS PRIVATE LIMITED",
"B. S. SHIPPING PRIVATE LIMITED",
"B. S. TAR PRIVATE. LIMITED.",
"B. SHARDA PHARMA PELLETS PRIVATE LIMITED",
"B. SUNDAR RAO HOTELS PRIVATE LIMITED",
"B. T. ENTERPRISES PRIVATE LIMITED",
"B.A.FABRICATORS & ENGINEERS P LIMITED",
"B.A.G. FILMS AND MEDIA LIMITED",
"B.A.G. LIVE ENTERTAINMENT LIMITED",
"B.AGRAWAL STONE PRODUCTS LIMITED",
"B.B. ASIA IMPEX PRIVATE LIMITED",
"B.B. STEELS PVT LTD",
"B.B. STYRO EXTRUSION PRIVATE LIMITED",
"B.B.DASS ICE & COLD STORAGE PRIVATE LIMITED",
"B.B.JEWELLERS AND FINANCE PRIVATE LIMITED",
"B.B.K. LEATHERS PRIVATE LIMITED",
"B.B.KNITTING WORKS PRIVATE LIMITED",
"B.B.M. IMPEX PRIVATE LIMITED",
"B.B.N.OVERSEAS PRIVATE LIMITED",
"B.C. MOHANTY & SONS PRIVATE LIMITED",
"B.C. OILS & FATS PRIVATE LIMITED",
"B.C.JAIN JEWELLERS (VIVEK) PRIVATE LIMITED",
"B.C.JAIN JEWELLERS PVT.LTD.",
"B.D MEMORIAL BLOOD CENTER",
"B.D STEELS PRIVATE. LIMITED.",
"B.D TEXTILE MILLS PRIVATE LIMITED",
"B.D. AGRICARE PRIVATE LIMITED",
"B.D. COLD STORAGE. PVT. LTD.",
"B.D. FOODS PRIVATE LIMITED",
"B.D. GUAR PRIVATE LIMITED",
"B.D. HARDWARES PRIVATE LIMITED",
"B.D. PLASTO FILMS PRIVATE LIMITED",
"B.D. PLYWOODS PRIVATE LIMITED",
"B.D.CREDITS LIMITED",
"B.D.G INTERNATIONAL (INDIA) PVT. LTD",
"B.D.M. PACKAGING PRIVATE LIMITED",
"B.D.R. PACKERS PRIVATE LIMITED",
"B.D.S. JEWELLERS PRIVATE LIMITED",
"B.DAYAL & COMPANY PRIVATE LIMITED",
"B.E. CONTRACTS PRIVATE. LIMITED.",
"B.G. RUBBER PRODUCTS PRIVATE LIMITED",
"B.G.K. INFRASTRUCTURE DEVELOPERS PRIVATE LIMITED",
"B.G.NAIDU SWEETS PRIVATE LIMITED",
"B.H.COTTON PRIVATE LIMITED",
"B.J. MEHTA ARCHITECTURAL & STRUCTURAL CONSULTANTS PRIVATE LIMITED",
"B.J. PERFECT AUTO PARTS PRIVATE LIMITED",
"B.J.EXPO PRIVATE LIMITED",
"B.JAIN EXPORTS (I) PRIVATE LIMITED",
"B.K ENTERPRISES",
"B.K HOSPITAL",
"B.K. AGRAWAL AUTOMOBILES PRIVATE LIMITED",
"B.K. AGRAWAL MERCHANTS PRIVATE LIMITED",
"B.K. EXPORTS",
"B.K. GARG ISPAT PRIVATE LIMITED",
"B.K. INFRASTRUCTURE PRIVATE LIMITED",
"B.K. INFRATECH PRIVATE LIMITED",
"B.K. INVESTMENT SERVICES PVT LTD",
"B.K. POLIMEX INDIA PRIVATE LIMITED",
"B.K. SPICES AND AGRO PRIVATE LIMITED",
"B.K.AROGYAM & RESEARCH PRIVATE LIMITED",
"B.K.ENTERPRISES PRIVATE LIMITED",
"B.K.M METAL & ALLOY PRIVATE LIMITED",
"B.K.ROLLING MILLS PRIVATE LIMITED",
"B.K.S. MOTORS PRIVATE LIMITED",
"B.K.TEXFAB PRIVATE LIMITED",
"B.L AGGARWAL HEALTHCARE PRIVATE LIMITED",
"B.L. INTERNATIONAL PRIVATE LIMITED",
"B.L. ROLLER FLOUR MILLS PRIVATE LIMITED",
"B.L.AUTO INDUSTRIES PRIVATE LIMITED",
"B.L.POLYMERS PRIVATE LIMITED",
"B.M ENGINEERING",
"B.M PRINTING & WRITING PAPERS PRIVATE LIMITED",
"B.M. AUTO WHEELS INDIA PRIVATE LIMITED",
"B.M. GUPTA ESTATE PRIVATE. LIMITED.",
"B.M. OVERSEAS PRIVATE LIMITED",
"B.M.EXPORTS PRIVATE LIMITED",
"B.M.FOODS PRODUCT PRIVATE LIMITED",
"B.M.J. CABLES PRIVATE LIMITED",
"B.M.M.PAPER BOARD PRIVATE LIMITED",
"B.M.R. DISTRIBUTERS PRIVATE LIMITED",
"B.N. GARODIA CONSTRUCTION & ENGINEERING PRIVATE LIMITED",
"B.N. INDUSTRIES",
"B.N. POLYMERS PVT. LTD.",
"B.N.DEVELOPERS PRIVATE LIMITED",
"B.N.K APPARELS PRIVATE LIMITED",
"B.N.SHARMA AYURVED PRIVATE LIMITED",
"B.N.T IMAGING PRIVATE LIMITED",
"B.N.T. CONNECTIONS IMPEX LIMITED",
"B.N.T.INNOVATIONS PRIVATE LIMITED",
"B.N.V.J. ENTERPRISES PRIVATE LIMITED",
"B.P BARIA SCIENCE INSTITUTE NAVSARI",
"B.P IMPEX",
"B.P. AGRI FOODS PRIVATE LIMITED",
"B.P. ENGINEERS PRIVATE LIMITED",
"B.P. FLOUR MILLS PRIVATE LIMITED",
"B.P. IMPEX PRIVATE LIMITED",
"B.P. LOGISTICS PRIVATE LIMITED",
"B.P. TRADING PRIVATE LIMITED",
"B.P.B. PHARMACY PRIVATE LIMITED",
"B.P.G.R ELECTRICAL CONTRACTORS & ENGINEERS PRIVATE LIMITED",
"B.P.PACKAGINGS PRIVATE LIMITED",
"B P PODDAR HOSPITAL AND MEDICAL RESEARCH LIMITED",
"B.P.PROJECTS PVT.LTD.",
"B.R ALUMINIUM PRODUCTS PRIVATE LIMITED",
"B.R. ARORA AND ASSOCIATES PRIVATE LIMITED",
"B.R. CLEARING SERVICES PRIVATE LIMITED",
"B.R. EDIBLE OILS PRIVATE LIMITED",
"B.R. GUAR GUM PRIVATE LIMITED",
"B.R. POLYTECH (INDIA) PRIVATE LIMITED",
"B.R. REALCON PRIVATE LIMITED",
"B.R.B. HOTELS PRIVATE LIMITED",
"B.R.ELASTICS (INDIA) PRIVATE LIMITED",
"B.R.M. MANAGEMENT & CONSULTANCY PRIVATE LIMITED",
"B.R.T. SPINNERS PRIVATE. LIMITED.",
"B.S. HOUSING COMPLEX COMPANY PVT LTD",
"B.S. MEHRA SONS PVT LTD",
"B.S. PULSES PRIVATE LIMITED",
"B.S.ELECTRONICS PRIVATE LIMITED",
"B.S.FLOUR MILLS PRIVATE LIMITED",
"B.S.G. INFRATECH INDIA PRIVATE LIMITED",
"B.S.INDUSTRIES",
"B.S.L. RAILTRACK ENGINEERS PRIVATE LIMITED",
"B.S.PATEL BIDI PVT LTD",
"B.S.R. CORPORATION PRIVATE LIMITED",
"B.S.SHAKTI STEEL PRIVATE LIMITED",
"B.S.SYNTHETICS PVT. LTD",
"B.T. INDUSTRIES PRIVATE LIMITED",
"B.T. PATIL & SONS BELGAUM CONSTRUCTION PRIVATE LIMITED",
"B.T.S.ROLLER FLOUR MILLS PRIVATE LIMITED",
"B.T.V ISPAT PRIVATE LIMITED",
"B.U.BHANDARI AUTO LINES PRIVATE LIMITED",
"B.U.BHANDARI ENERGY PRIVATE LIMITED",
"B.V.N.CHEMICALS PRIVATE LIMITED",
"B.V.R. SILKS PRIVATE LIMITED",
"B.V.S DISTILLERIES PRIVATE LIMITED",
"B.V.THINNER SOLVENTS PRIVATE LIMITED",
"B.Y.C. ONLINE RETAIL PRIVATE LIMITED",
"B:BLUNT-SPRATT HAIRDRESSING PRIVATE LIMITED",
"B22 CAP MANUFACTURING PRIVATE LIMITED",
"B2ALL COMMO TRADE PRIVATE LIMITED",
"B2B BRAND SOLUTIONS PRIVATE LIMITED",
"B2B CLOTHINGS PRIVATE LIMITED",
"B2B DESIGNERS PRIVATE LIMITED",
"B2B HOSPITALITY PRIVATE LIMITED",
"B2B LABYRINTH SOLUTIONS PRIVATE LIMITED",
"B2B MOPS AND BRUSH PRIVATE LIMITED",
"B2B SOFTWARE TECHNOLOGIES LIMITED",
"B2B SOLUTIONS INDIA PRIVATE LIMITED",
"B2B TRADEX PRIVATE LIMITED",
"B2BCITY VENTURES PRIVATE LIMITED",
"B2BE.COM INDIA PRIVATE LIMITED",
"B2C INFOSOLUTIONS PRIVATE LIMITED",
"B2H STUDIOS PRIVATE LIMITED",
"B2K ANALYTICS PRIVATE LIMITED",
"B2R TECHNOLOGIES PRIVATE LIMITED",
"B2U CORPORATE SOLUTIONS PRIVATE LIMITED",
"B2X SERVICE SOLUTIONS INDIA PRIVATE LIMITED",
"B3 INFOTECH PRIVATE LIMITED",
"B3 MACBIS LIMITED",
"B4S INFRATECH PRIVATE LIMITED",
"B4S SOLUTIONS PRIVATE LIMITED",
"B4U BROADBAND INDIA PRIVATE LIMITED",
"B4U TELEVISION NETWORK INDIA LIMITED",
"B62 STUDIOS PRIVATE LIMITED",
"BA CALL CENTRE INDIA PRIVATE LIMITED",
"BA CONTINUUM INDIA PRIVATE LIMITED",
"BA CONTINUUM SOLUTIONS PRIVATE LIMITED",
"BA PRINTER & ADVERTISERS PRIVATE LIMITED",
"BA TEC SERVICES PRIVATE LIMITED",
"BA TECHNOLOGY",
"BAAB CONSTRUCTIONS (INDIA) PRIVATE LIMITED",
"BAABTE SYSTEM TECHNOLOGIES PRIVATE LIMITED",
"BAALAKH HODLING PRIVATAE LIMITED",
"BAALARK MEDITRADE SERVICES PRIVATE LIMITED",
"BAAN INFO PRIVATE LIMITED",
"BAANI LANDBASE PRIVATE LIMITED",
"BAANI MILK PRODUCER COMPANY LIMITED",
"BAANI TECHNOLOGY SERVICES PRIVATE LIMITED",
"BAANYAN SOFTTECH SERVICES INDIA PRIVATE LIMITED",
"BAARBQUEEN CLASSIC HALAL RESTAURANT",
"BAARCO LASERTECH PRIVATE LIMITED",
"BAAS PROJECT SOLUTIONS PRIVATE LIMITED",
"BAASHYAAM CONSTRUCTIONS PRIVATE LIMITED",
"BAAZ CONSTRUCTIONS PRIVATE LIMITED",
"BAAZ DEVELOPERS PRIVATE LIMITED",
"BAAZAR RETAIL LIMITED",
"BAAZAR RETAIL PRIVATE LIMITED",
"BAAZAR STYLE RETAIL LIMITED",
"BAAZI GAMING NETWORK PRIVATE LIMITED",
"BAAZI NETWORKS PRIVATE LIMITED",
"BABA AGRO FOOD LIMITED",
"BABA AKHILA SAI JYOTHI INDUSTRIES PRIVATE LIMITED",
"BABA ALUMINIUM PRODUCTS PVT.LTD.",
"BABA ANANDESHWAR INFRASTRUCTURE PRIVATE LIMITED",
"BABA ARTS LIMITED",
"BABA ASSOCIATES & LOGISTICS PRIVATE LIMITED",
"BABA BAIDHNATH AGRO COLD STORAGE PRIVATE LIMITED",
"BABA BAIJYANATH ISPAT WORKS PRIVATE LIMITED",
"BABA BANDA SINGH BAHADUR CONVENT SCHOOL",
"BABA BAR & ANGLE PRIVATE LIMITED",
"BABA BASUKINATH RICE MILL PRIVATE LIMITED",
"BABA BASUKINATH VINTRADE PRIVATE LIMITED",
"BABA BATESHWAR CONSTRUCTION PRIVATE LIMITED",
"BABA BEARINGS PVT.LTD.",
"BABA BHOOTHNATH TRADE AND COMMERCE LIMITED",
"BABA BHUBANESWAR COLD STORAGE PRIVATE LIMITED",
"BABA BHUMAN SHAH JI RICE MILLS",
"BABA BISWANATH AGRO PRODUCTS PRIVATE LIMITED",
"BABA BUDHA JI CHARITABLE HOSPITAL",
"BABA BUDHA SAHIB CARDIAC CENTRE LTD",
"BABA CHAURANGINATH POWER SYSTEMS PRIVATE LIMITED",
"BABA COMMERCIAL AND FINVEST PVT. LTD.",
"BABA CONSTRUCTION PRIVATE LIMITED",
"BABA CONTAINER MANUFACTURERS",
"BABA DALL MILLS PRIVATE LIMITED",
"BABA DEBRAHA ENTERPRISES PRIVATE LIMITED",
"BABA DEEP SINGH SHUTTERING PRIVATE LIMITED",
"BABA DEVELOPERS PRIVATE LIMITED",
"BABA DISTRIBUTORS PRIVATE LIMITED",
"BABA E QUAM URDU PRIMARY SCHOOL",
"BABA ENTERPRISES PRIVATE LIMITED",
"BABA ENTREPRENEURS PRIVATE LIMITED",
"BABA EQUALITE ELECTRICALS PRIVATE LIMITED",
"BABA EXPO PRIVATE LIMITED",
"BABA FARID INDUSTRIAL TRAINING INSTITUTE GURUHARSAHAI",
"BABA FARID JI MARBLE PRIVATE LIMITED",
"BABA FARID SOLVEX PRIVATE LIMITED",
"BABA FARID SPUN PIPES",
"BABA FOOD PROCESSING (INDIA) LIMITED",
"BABA GHANSHYAM METALS PRIVATE LIMITED",
"BABA GLOBAL LIMITED",
"BABA GOLDEN SHIPPING & LOGISTICS PRIVATE LIMITED",
"BABA GURDITTA RICE AND GENERAL MILLS PRIVATE LIMITED",
"BABA HANS CONSTRUCTIONS PRIVATE LIMITED",
"BABA HANUMAN FINANCE PRIVATE LIMITED",
"BABA HARIDAS ISPAT PRIVATE LIMITED",
"BABA HEALTHCARE PRIVATE LIMITED",
"BABA HOTELS PRIVATE LIMITED",
"BABA INFOTECH PRIVATE LIMITED",
"BABA INSTITUTE OF TECHNOLOGY AND SCIENCES",
"BABA INTEGRATED TECHNOLOGIES PRIVATE LIMITED",
"BABA IRON INDUSTRIES PVT LTD",
"BABA JATADHARI AGRO INDIA PRIVATE LIMITED",
"BABA JEWELLERS PRIVATE LIMITED",
"BABA JHARESHWAR MULTIPURPOSE HIMGHAR PRIVATE LIMITED",
"BABA JI KI BUTI PRIVATE LIMITED",
"BABA JUTE PRODUCTS PRIVATE LIMITED",
"BABA KRUSHI SEVA KENDRA",
"BABA KUSHI NATH FOOD PRODUCTS PRIVATE LIMITED",
"BABA LALDASS FABRIC COATS PRIVATE LIMITED",
"BABA LEASE AND INVESTMENT PRIVATE LIMITED",
"BABA LIFESTYLE JEWELS PRIVATE LIMITED",
"BABA LINGARAJ ENTERPRISES PRIVATE LIMITED",
"BABA LOKENATH AGROTECH INDUSTRIES PRIVATE LIMITED",
"BABA LOKENATH FLOUR MILLS PRIVATE LIMITED",
"BABA LOKNATH DEV CONCRETE PRODUCTS PRIVATE LIMITED",
"BABA LOKNATH LOGISTICS PVT LTD",
"BABA MAHAKAL INFRASTRUCTURE AND DEVLOPERS PRIVATE LIMITED",
"BABA MAKARDHAJ SR. SEC SCHOOL",
"BABA MALLESHWAR AGRO PRODUCTS PRIVATE LIMITED",
"BABA MALLESHWAR RICE MILL PRIVATE LIMITED",
"BABA MULTIMEDIA PRIVATE LIMITED",
"BABA NAGA AGRO PRIVATE LIMITED",
"BABA NANAK SIN HIN P S B GAN",
"BABA NARAYAN RICE MILL PRIVATE LIMITED",
"BABA NARSINGH DAS BUILDCON PRIVATE LIMITED",
"BABA NEEM KAROLI ROLLER FLOUR MILLS PRIVATE LIMITED",
"BABA ONKARNATH MULTIPURPOSE HIMGHAR PRIVATE LIMITED",
"BABA PLYWOOD PRIVATE LIMITED",
"BABA PROJECTS PRIVATE LIMITED",
"BABA PURAN DASS FINANCIAL SERVICES LIMITED",
"BABA RAM DEV SARVODAYA KANYA VIDYALAYA",
"BABA RAMDEV BANGLES ARTS PRIVATE LIMITED",
"BABA RICE MILL",
"BABA ROTOPRINT PRIVATE LIMITED",
"BABA RUPNATH JI FOODS & SPICES P. LIMITED",
"BABA SADANANDA AGROTECH PRIVATE LIMITED",
"BABA SAHEB AMBEDKAR EDUCATION UNIVERSITY",
"BABA SAHEB AMBEDKAR POLYTECHNIC",
"BABA SAHEB AMBEDKAR TECHNICAL EDUCATIONAL SOCITY",
"BABA SAHEB DHABEKAR URDU PRIMARY SCHOOL SOLAPUR",
"BABA SAHIB DASS PUBLIC SENIOR SECONDARY SCHOOL",
"BABA SALES PRIVATE LIMITED",
"BABA SATYANARAYAN HIMGHAR PVT LTD",
"BABA SERVICE TOOLS",
"BABA SEWA SINGH INDUSTRIES",
"BABA SHYAMDASS EDUCATION SOCIETY",
"BABA SIDDH INTER COLLEGE",
"BABA SIDH INTER COLLEGE",
"BABA SPINNERS LIMITED",
"BABA SRI CHAND MAJIK ENTERPRISES INDIA PRIVATE LIMITED",
"BABA STEELS PRIVATE LIMITED",
"BABA STRUCTURAL PRIVATE LIMITED",
"BABA SUPER MINERALS PRIVATE LIMITED",
"BABA TECHNOCRATS AND MANUFACTURERS PRIVATE LIMITED",
"BABA TEXTILE MACHINERY (INDIA) PRIVATE LIMITED",
"BABA VIDYUT ENGINEERS PRIVATE LIMITED",
"BABA WOOD PRODUCTS PRIVATE LIMITED",
"BABADEEP SINGH BUILDERS & DESILTERS PRIVATE LIMITED",
"BABAEXPRESS ECOM PRIVATE LIMITED",
"BABAJI AGRO MART PRIVATE LIMITED",
"BABAJI SHIVRAM 4PL SOLUTIONS PRIVATE LIMITED",
"BABAJI SHIVRAM CLEARING AND CARRIERS PRIVATE LIMITED",
"BABAJI SNACKS PRIVATE LIMITED",
"BABAJI UDYOG PRIVATE LIMITED",
"BABAJI VRIDHA ASHRAM SCHOOL",
"BABAKAILASHPATI AGRO PROCESSING PRIVATE LIMITED",
"BABALOKENATH ENGG. WORKS PRIVATE LIMITED",
"BABAMALLESHWAR OILS PRIVATE LIMITED",
"BABANAGA OVERSEAS PRIVATE LIMITED",
"BABANARAYAN HIMGHAR PRIVATE LIMITED",
"BABANLAL BHIKULAL FIBERS PRIVATE LIMITED",
"BABAREPAIRING TOOLS AND TRAINING PRIVATE LIMITED",
"BABARIA CABLE PRIVATE LIMITED",
"BABAS ELECTRONICS INDUSTRIES PRIVATE LIMITED",
"BABASAHEB AMBEDKAR NTNL SOCIAL SC INSTIT",
"BABASAHEB BHIMRAO AMBEDKAR UNIVERSITY",
"BABASAHEB DESHMUKH INDUSTRIES PRIVATE LIMITED",
"BABASAHEB PATIL HIGHS CHOOL KOTOLI",
"BABBA BIHARI TRANSPORT PRIVATE LIMITED",
"BABBAR WRECKERS PRIVATE LIMITED",
"BABBLER MARKETING PRIVATE LIMITED",
"BABCOCK BORSIG LIMITED",
"BABCOCK POWER APAC PRIVATE LIMITED",
"BABEL E-COMMERCE PRIVATE LIMITED",
"BABEL MEDIA INDIA PRIVATE LIMITED",
"BABELSYS TECHNOLOGY INDIA PRIVATE LIMITED",
"BABEY INFRATECH PRIVATE LIMITED",
"BABIES AND US FERTILITY AND IVF CENTRE INDIA PRIVATE LIMITED",
"BABIN TECHNOLOGIES PRIVATE LIMITED",
"BABINA HEALTHCARE AND HOSPITALITY INDUSTRIES PRIVATE LIMITED",
"BABINA HOSPITALITIES PRIVATE LIMITED",
"BABITA AGRAWAL JEWELLERY PRIVATE LIMITED",
"BABITA LOGISTICS",
"BABITHA CONVEYANCE SOLUTIONS PRIVATE LIMITED",
"BABJI REALTORS PRIVATE LIMITED",
"BABLANI AIRCON PRIVATE LIMITED",
"BABLANI CLEARING FORWARDING AND LOGISTICS COMPANY PRIVATE LIMITED",
"BABRI POLYPET PRIVATE LIMITED",
"BABSHIMOU PRIVATE LIMITED",
"BABSONS BARN FASHIONS INDIA PRIVATE LIMITED",
"BABU BANARSI DAS UNIVERSITY",
"BABU BHAI JEWELLERS PRIVATE LIMITED",
"BABU ENERGY PRIVATE LIMITED",
"BABU ERECTORS PRIVATE LIMITED",
"BABU JAGJIVAN RAM MEMORIAL HOSPITAL",
"BABU LIME PRIVATE LIMITED",
"BABU RAM ICE & COLD STORAGE PRIVATE LIMITED",
"BABU ROTO TECH PRIVATE LIMITED",
"BABU SAREES PRIVATE LIMITED",
"BABU TEX PRIVATE LIMITED",
"BABUBHAI KANAKIA FOUNDATION",
"BABUJI FOODS PRIVATE LIMITED",
"BABUJI TEKNOFLON PRIVATE LIMITED",
"BABUL HOLDINGS PRIVATE LIMITED",
"BABUL PRINTING AND PACKAGING PRIVATE LIMITED",
"BABUL PRODUCTS PRIVATE LIMITED",
"BABUL REDDY JR COLLEGES",
"BABULAL BECHARBHAI ZAVERI GOLDS AND DIAMONDS PRIVATE LIMITED",
"BABULAL EDIBLE OILS PRIVATE LIMITED",
"BABULAL JAWERCHAND KOTHARI PRIVATE LIMITED",
"BABULAL MEHTA ENGINEER PVT LTD",
"BABULAL SUGANDHI COLD STORAGE PRIVATE LIMITED",
"BABULAL VYAPAAR PRIVATE LIMITED",
"BABULINE PHARMA PRIVATE LIMITED",
"BABURAM JEWELLERS PRIVATE LIMITED",
"BABURAM SINGH INTER COLLEGE BABRALA",
"BABUS MEDICENTER PRIVATE LIMITED",
"BABUSO AGRO MARINE COMPANY PRIVATE LIMITED",
"BABY & MOM RETAIL PRIVATE LIMITED",
"BABY ENGINEERING PRIVATE LIMITED",
"BABY ESSENTIALS PRIVATE LIMITED",
"BABY HOSPITAL ANANTAPUR",
"BABY JOY FERTILITY AND IVF CENTRE PRIVATE LIMITED",
"BABY MAYA DEVI STEELS PRIVATE LIMITED",
"BABY MEMORIAL HOSPITAL LIMITED",
"BABYCLICK INDIA PRIVATE LIMITED",
"BABYLON AGRO PRODUCTS PRIVATE LIMITED",
"BABYLON APARTMENTS PVT.LTD.",
"BABYLON HOSPITAL PRIVATE LIMITED",
"BABYLON LOGISTICS PRIVATE LIMITED",
"BABYLON PROPERTIES PRIVATE LIMITED",
"BABYLONIAN TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"BABYMARINE EXPORTS PRIVATE LIMITED",
"BABYMARINE SEAFOOD RETAIL PRIVATE LIMITED",
"BABYQUEST CRYOBANK PRIVATE LIMITED",
"BAC INFRATECH PRIVATE LIMITED",
"BAC PRIVATE LIMITED",
"BACANCY SOFTWARE LLP",
"BACANCY TECHNOLOGY PRIVATE LIMITED",
"BACARDI INDIA PRIVATE LIMITED",
"BACARDI-MARTINI ASIA PACIFIC LIMITED",
"BACC HEALTH CARE PRIVATE LIMITED",
"BACCA BUCCI FASHIONS PRIVATE LIMITED",
"BACCAROSE COSMETICS PRIVATE LIMITED",
"BACCAROSE PERFUMES AND BEAUTY PRODUCTS PRIVATE LIMITED",
"BACCHUS ENTERPRISES LIMITED",
"BACER ENTERPRISES INDIA PRIVATE LIMITED",
"BACFO & KRAUTER HOLDINGS PRIVATE LIMITED",
"BACFO PHARMACEUTICALS (INDIA ) LIMITED",
"BACHA MOTORS PRIVATE LIMITED",
"BACHCHE LALA JEWELLERS PRIVATE LIMITED",
"BACHCHI FINANCE PVT. LTD.",
"BACHHAWAT SAREES PRIVATE LIMITED",
"BACHHER EXPORTS PRIVATE LIMITED",
"BACHHRAJ AND COMPANY PRIVATE LIMITED",
"BACHHRAJ FACTORIES PRIVATE LIMITED",
"BACHHRAJ TRADING CORPORATION PRIVATE LIMITED",
"BACHHUKA TRADING PRIVATE LIMITED",
"BACHI DEVI RAMDEV CHAUBEY MAHAVIDYALAYA",
"BACHI SHOES LIMITED",
"BACHIO TOYS PRIVATE LIMITED",
"BACHMANN INDUSTRIES INDIA LIMITED",
"BACHPAN PLAY SCHOOL",
"BACHRAJ WVG AND MANUFACTURING MILLS PRIVATE LIMITED",
"BACHY SOLETANCHE ENGINEERING PRIVATE LIMITED",
"BACK BENCHERS",
"BACK OFFICE IT SOLUTIONS PRIVATE LIMITED",
"BACK OFFICE SHARED SERVICES INDIA PRIVATE LIMITED",
"BACK STAGE SOLUTION PRIVATE LIMITED",
"BACK TO NATURE EXIM PRIVATE LIMITED",
"BACK2NATURE ORGANIX PRIVATE LIMITED",
"BACKBAY PREMISES CO-OP SOC LIMITED",
"BACKBONE CONSTRUCTION PRIVATE LIMITED",
"BACKBONE ELECTRICALS",
"BACKBONE MNMP HIGHWAY PRIVATE LIMITED",
"BACKBONE PROJECTS LIMITED",
"BACKDROP ADVERTISING PRIVATE LIMITED",
"BACKER PERSONAL CARE PRIVATE LIMITED",
"BACKOFFICE I T SERVICES INDIA PRIVATE LIMITED",
"BACKPACK INTERNATIONAL PRIVATE LIMITED",
"BACKSTAGE PRODUCTIONS PRIVATE LIMITED",
"BACKWATER RIPPLES PRIVATE LIMITED",
"BACKWATER TECHNOLOGIES PRIVATE LIMITED",
"BACS ENERGY PRIVATE.LIMITED",
"BACS HITECH ENGINEERING",
"BACTCOM ENTERPRISES PRIVATE LIMITED",
"BAD BOYS ENTERTAINMENT PRIVATE LIMITED",
"BAD BRAINS CLOTHING PRIVATE LIMITED",
"BADA BAZAAR ENTERPRISES PRIVATE LIMITED",
"BADA BUSINESS PRIVATE LIMITED",
"BADA KE BALAJI AGRO PRODUCER COMPANY LIMITED",
"BADA SAAB DESIGNS PRIVATE LIMITED",
"BADA SAAB PROPERTIES PRIVATE LIMITED",
"BADABYTE INFOTECH PRIVATE LIMITED",
"BADAL FOODS AND BEVERAGES PRIVATE LIMITED",
"BADALIA GEMS PVT LTD",
"BADALIYA ENTERPRISES PRIVATE LIMITED",
"BADAMI LABS LLP",
"BADAMI SUGARS LIMITED",
"BADAMIKAR REALITIES PRIVATE LIMITED",
"BADAR INDUSTRIES PRIVATE LIMITED",
"BADAR TRADING AND INVESTMENT PRIVATE LIMITED",
"BADAWE ENGINEERS PRIVATE LIMITED",
"BADBEAT SOFTWARE PRIVATE LIMITED",
"BADDI FOILS PRIVATE LIMITED",
"BADDI INFRASTRUCTURE",
"BADE SONS MARKETING PRIVATE LIMITED",
"BADEDIA DEVELOPERS PRIVATE LIMITED",
"BADER LEATHER INDIA PRIVATE LIMITED",
"BADERIA METRO PRIME MULTISPECIALITY HOSPITAL",
"BADHE AUTO PRIVATE LIMITED",
"BADHE PACKAGING INDUSTRIES PRIVATE LIMITED",
"BADHE RESTAURANTS & HOTELS PRIVATE LIMITED",
"BADHWANIYA INFRA & TRANSPORT PRIVATE LIMITED",
"BADHWAR CARS PRIVATE LIMITED",
"BADHWAR MOTOCORP PRIVATE LIMITED",
"BADI BAKTARA TOLL PRIVATE LIMITED",
"BADIGER'S CLASSIC INTERIORS PRIVATE LIMITED",
"BADJATE REAL ESTATES PRIVATE LIMITED",
"BADJATE STOCK.BROKING PRIVATE LIMITED CN",
"BADKUL MOTORS PRIVATE LIMITED",
"BADLAPUR COMMON EFFLUENT TREATMENT PLANT ASSOCIATION",
"BADLAPUR TEXTILE INDUSTRIES PRIVATE LIMITED",
"BADMAASH BAWARCHI HOSPITALITY PRIVATE LIMITED",
"BADMINTON GURUKUL PRIVATE LIMITED",
"BADNAGAR FARMER PRODUCER COMPANY LIMITED",
"BADO BUILDTECH PRIVATE LIMITED",
"BADOLA AGRICULTURAL PRIVATE LIMITED",
"BADOLA AUTOMOBILES PRIVATE LIMITED",
"BADOLA CARS PRIVATE LIMITED",
"BADONE MOTORS PRIVATE LIMITED",
"BADONI POWER PRIVATE LIMITED",
"BADOTHERM INSTRUMENTS HOLLAND PRIVATE LIMITED.",
"BADPAR PRIMARY SCHOOL",
"BADRA ESTATES AND INDUSTRIES LIMITED",
"BADRI AUTO SERVICES PRIVATE LIMITED",
"BADRI COTSYN PRIVATE LIMITED",
"BADRI ENTERPRISES PRIVATE LIMITED",
"BADRI EXPORTS PRIVATE LIMITED",
"BADRI INDUSTRIES PRIVATE LIMITED",
"BADRI NARAIN RUBBERS PRIVATE LIMITED",
"BADRI PRASAD GOPAL JI JEWELLERS PRIVATE LIMITED",
"BADRI PRASAD SHUKLA MEMORIAL HOSPITAL PRIVATE LIMITED",
"BADRI RAI & CO.",
"BADRI RAI CONSTRUCTION LIMITED",
"BADRI VISHAL AGRO PRIVATE LIMITED",
"BADRI VISHAL COMMODITY MANAGEMENT SERVICES LIMITED",
"BADRIKA MOTORS PRIVATE LIMITED",
"BADRIKEDAR COMMERCIALS PRIVATE LIMITED",
"BADRINARAYAN BARWALE JUNIOR COLLEGE JALNA",
"BADRINARAYAN STEEL TUBES PRIVATE LIMITED",
"BADRINATH BAKERS PRIVATE LIMITED",
"BADRINATH INFRASTRUCTURE PRIVATE LIMITED",
"BADRINATH PACKWELL PRIVATE LIMITED",
"BADRINATH SALES PRIVATE LIMITED",
"BADRISH AGRO PRODUCTS PRIVATE LIMITED",
"BADRIVAS BIOTECH PRIVATE LIMITED",
"BADRIVISHAL ESTATES PRIVATE LIMITED",
"BADRIVISHAL FASHIONTEX PRIVATE LIMITED",
"BADRIVISHAL TRADING CO. PRIVATE LIMITED",
"BADRUKA COLLEGE OF COMMERCE AND ARTS",
"BADRUKA EXIM PRIVATE LIMITED",
"BADSHAH BIKANER FOOD PRODUCTS PRIVATE LIMITED",
"BADSHAH DEVELOPERS PRIVATE LIMITED",
"BADSHAH INTERNATIONAL PRIVATE LIMITED",
"BADSHAH LOGISTICS (INDIA) PRIVATE LIMITED",
"BADSHAH MASALA PRIVATE LIMITED",
"BADULIPAR LTD",
"BADURIA JUTE PRODUCTS PRIVATE LIMITED",
"BADVE AUTOCOMPS PRIVATE LIMITED",
"BADVE AUTOTECH PRIVATE LIMITED",
"BADVE HELMETS INDIA PRIVATE LIMITED",
"BADWANI - BADHAN HIGHWAY PRIVATE LIMITED",
"BAE SYSTEMS INDIA SERVICES PRIVATE LIMITED",
"BAEHAL SOFTWARE LIMITED",
"BAEKELAND MULTI PRODUCTS PRIVATE LIMITED",
"BAER SHOES INDIA PRIVATE LIMITED",
"BAERLOCHER INDIA ADDITIVES PRIVATE LIMITED",
"BAFFLESOL TECHNOLOGIES PRIVATE LIMITED",
"BAFNA AUTO CARS I PRIVATE LIMITED",
"BAFNA CLOTHING COMPANY PRIVATE LIMITED",
"BAFNA DEVICES PRIVATE LIMITED",
"BAFNA EARTH MOVERS LIMITED",
"BAFNA FOODS INDIA PRIVATE LIMITED",
"BAFNA GINNING AND PRESSING PRIVATE LIMITED",
"BAFNA LIFESTYLES REMEDIES LIMITED",
"BAFNA LOGISTICS PRIVATE LIMITED",
"BAFNA METSTRIPS PRIVATE LIMITED",
"BAFNA MOTORCYCLES PRIVATE LIMITED",
"BAFNA MOTORS MUMBAI PRIVATE LIMITED",
"BAFNA MOTORS PRIVATE LIMITED",
"BAFNA MOTORS PUNE PRIVATE LIMITED",
"BAFNA PHARMACEUTICALS LIMITED",
"BAFNA REALTORS PRIVATE LIMITED",
"BAFNA SURGICALS INDIA PRIVATE LIMITED",
"BAFS HOSPITALITY PRIVATE LIMITED",
"BAG ELECTRONICS INDIA PRIVATE LIMITED",
"BAGADIA BROTHERS",
"BAGADIA CHAITRA INDUSTRIES PRIVATE LIMITED",
"BAGADIYA BROTHERS PRIVATE LIMITED",
"BAGALKOT CEMENT & INDUSTRIES LIMITED.",
"BAGALKOT HEALTH CARE SOLUTIONS PRIVATE LIMITED",
"BAGAMANE VENTURES PRIVATE LIMITED",
"BAGAMBER DEALERS PVT LTD",
"BAGARIA & COMPANY PRIVATE LIMITED",
"BAGARIA AGENCIES PRIVATE LIMITED",
"BAGARIA ALUMINIUM ALLOYS PRIVATE LIMITED.",
"BAGARIA BUSINEES PVT LTD",
"BAGARIA DERIVATIVE SERVICES PRIVATE LIMITED",
"BAGARIA HOTELS AND CONSTRUCTIONS P LTD",
"BAGARIA INFRATECH PRIVATE LIMITED",
"BAGARIA INVESTECH PRIVATE LIMITED",
"BAGARIA KUSUM BEVERAGE PRIVATE LIMITED",
"BAGARIA MEDMARK PRIVATE LIMITED",
"BAGARIA MORE CO LTD",
"BAGARIA MOTORS PRIVATE LIMITED",
"BAGARIA TIMBER PRIVATE LIMITED",
"BAGARIA TRADING PRIVATE LTD",
"BAGARIA VEGETABLE PRODUCTS PRIVATE LIMITED",
"BAGASA INDUSTRIES PVT LTD",
"BAGASA PLANTATIONS PVT LTD",
"BAGAVATHI MACHINE WORKS PRIVATE LIMITED",
"BAGCLUES EXIM PRIVATE LIMITED",
"BAGDI HEALTHCARE PRIVATE LIMITED",
"BAGGA DISTILLERIES HYDERABAD PRIVATE LIMITED",
"BAGGA JEWELLERS PRIVATE LIMITED",
"BAGGA LINK MOTORS LIMITED",
"BAGGA LINK SERVICE LIMITED",
"BAGGA LUXURY MOTORCARS LLP.",
"BAGGA TYRE AND TRANSPORT PRIVATE LIMITED",
"BAGGIT INDIA PRIVATE LIMITED",
"BAGGU SAROJINI DEVI HOSPITAL",
"BAGH BAHAR APPLIANCES PRIVATE LIMITED",
"BAGHBAAN VINIMAY PRIVATE LIMITED",
"BAGHBARI TEA COMPANY PRIVATE LIMITED",
"BAGHBAZAR HIGH SCHOOL",
"BAGHEL INFRAPROJECTS PRIVATE LIMITED",
"BAGHEL INFRASTRUCTURES PRIVATE LIMITED",
"BAGHIRATHI TRAVEL SOLUTIONS PRIVATE LIMITED",
"BAGHLA SANITARYWARE PRIVATE LIMITED",
"BAGHMAR FINANCE LIMITED",
"BAGHMAR FINLEASE PRIVATE LIMITED",
"BAGHMARI TEA CO LTD",
"BAGHPATIA TRADING COMPANY PRIVATE LIMITED",
"BAGKIYA CONSTRUCTIONS PRIVATE LIMITED",
"BAGLA AUTOMOBILES PRIVATE LIMITED",
"BAGLA BEAUTY CARE PRIVATE LIMITED",
"BAGLA COMBINED DISTRICT HOSPITAL",
"BAGLA ELECTRICALS AND ELECTRONICS PRIVATE LIMITED",
"BAGLA INDUSTRIES PRIVATE LIMITED",
"BAGLA JOINT DISTRICT HOSPITAL MAHAMAYA NAGAR",
"BAGLA POLIFILMS LIMITED",
"BAGLA POLYYARN PRIVATE LIMITED",
"BAGLAJEE INFRASTRUCTURE PRIVATE LIMITED",
"BAGLAN DEVELOPERS PRIVATE LIMITED",
"BAGLI KRISHAK PRODUCER COMPANY LIMITED",
"BAGMAN MACHINERY PRIVATE LIMITED",
"BAGMANE DEVELOPERS PRIVATE LIMITED",
"BAGMARI MANICKTALA GOVT SP HS",
"BAGMATI FERTILIZERS & CHEMICALS LIMITED",
"BAGMIBOR NILAMONI PHUKAN H S SCHOOL GOVT OF ASSAM",
"BAGNAN ESTATES PRIVATE LIMITED",
"BAGNAN INFRA PROJECTS PRIVATE LIMITED",
"BAGO CANS PRIVATE LIMITED",
"BAGODARA PRIMARY SCHOOL",
"BAGOOSA FOOD PRODUCTS PRIVATE LIMITED",
"BAGORI POLYMERS PRIVATE LIMITED",
"BAGPAT GREEN ENERGY PRIVATE LIMITED",
"BAGPOLY INTERNATIONAL PRIVATE LIMITED",
"BAGRI AGENCIES PRIVATE LIMITED",
"BAGRODIA CHAI PRIVATE LIMITED",
"BAGRODIA PLANTATIONS AND INDUSTRIES PVT LTD",
"BAGRODIA SUPERMARKETS PRIVATE LIMITED",
"BAGRODIA TEA CO PVT LTD",
"BAGRODIA TEA TRADING COMPANY PVT. LTD.",
"BAGRRYS HOLDING LIMITED",
"BAGRRYS INDIA LIMITED",
"BAGS AND BAGGAGE (INDIA) PRIVATE LIMITED",
"BAGWAN INFRATECH INDIA PRIVATE LIMITED",
"BAGYARADHI JUNIOR COLLEGE",
"BAGZONE LIFESTYLES PRIVATE LIMITED",
"BAHADUR CHAND INVESTMENTS PRIVATE LIMITED",
"BAHADUR KE TEXTILES AND KNITWEARS ASSOCIATION",
"BAHADURGARH AGRO INDUSTRIES PRIVATE LIMITED",
"BAHADURGARH FOOTWEAR DEVELOPMENT SERVICES PRIVATE LIMITED",
"BAHADURGARH GASES PRIVATE LIMITED",
"BAHAL BUILDCON PRIVATE LIMITED",
"BAHAMI PRINTS PRIVATE LIMITED",
"BAHANI TEA CO PVT LTD",
"BAHAR INFOCONS PRIVATE LIMITED",
"BAHARAMPORE-FARAKKA HIGHWAYS LIMITED",
"BAHAVA FOODS & FEEDS PRIVATE LIMITED",
"BAHDL HOSPITALITY LIMITED",
"BAHETI GEMS & JEWELS PRIVATE LIMITED",
"BAHETI HOTELS & LEISURE PRIVATE LIMITED",
"BAHETI INDUSTRIES PRIVATE LIMITED",
"BAHETI INFRA PRIVATE LIMITED",
"BAHETI METAL AND FERRO ALLOYS LIMITED.",
"BAHETI POLYFAB PRIVATE LIMITED",
"BAHETI RECYCLING INDUSTRIES LIMITED",
"BAHETI SILICONES AND METALS PRIVATE LIMITED",
"BAHETI TECH SOLUTIONS PRIVATE LIMITED",
"BAHETI TEXTILES PRIVATE LIMITED",
"BAHETI VYAPAAR PRIVATE LIMITED",
"BAHETY AGENCIES PRIVATE LIMITED",
"BAHETY CHEMICALS AND MINERALS PRIVATE LIMITED",
"BAHETY OVERSEAS PRIVATE LIMITED",
"BAHIA ENTERPRISES PRIVATE LIMITED",
"BAHIRA BHAGYABANTAPUR BM HIGH SCHOOL",
"BAHIST ENTERPRISES PRIVATE LIMITED",
"BAHL BUILDERS PRIVATE. LIMITED.",
"BAHL EXPORTS PRIVATE LIMITED",
"BAHL PAPER MILLS LIMITED.",
"BAHRA CREATIVE INFRASTRUCTURE PRIVATE LIMITED",
"BAHRI ESTATES PRIVATE LIMITED",
"BAHRI GOODS CARRIERS PRIVATE LTD",
"BAHRI REALTY MANAGEMENT SERVICES PRIVATE LIMITED",
"BAHUBALI ALLOYS AND METALS PRIVATE LIMITED",
"BAHUBALI BOARDS PRIVATE LIMITED",
"BAHUBALI BUILDESTATE PRIVATE LIMITED",
"BAHUBALI BULLION & JEWELS PRIVATE LIMITED",
"BAHUBALI COTTONS PRIVATE LIMITED",
"BAHUBALI DIAMONDS PRIVATE LIMITED",
"BAHUBALI DYES LIMITED",
"BAHUBALI ELECTRONICS PRIVATE LIMITED",
"BAHUBALI ENTERPRISES PRIVATE LIMITED",
"BAHUBALI FINANCIAL SERVICES PRIVATE LIMITED (CHAPTER-IX)",
"BAHUBALI JEWELLER PRIVATE LIMITED",
"BAHUBALI METALIC PRIVATE LIMITED",
"BAHUBALI OVERSEAS PRIVATE LIMITED",
"BAHUBALI PRINTS PRIVATE LIMITED",
"BAHUBALI PROPERTIES LTD",
"BAHUBALI RUBBER PRIVATE LIMITED",
"BAHUCHAR ENTERPRISE (OPC) PRIVATE LIMITED",
"BAHUCHARAJI RAIL CORPORATION LIMITED",
"BAHUDDESHIYA KISAN SEWA SEHKARI SAMITI LTD",
"BAHUDDHESHIYE KISAN SEWA SAHKARI SAMITI ROORKEE HARIDWAR UTTARAKHAND",
"BAHULA FINVEST COMPANY PRIVATE LIMITED",
"BAHULEYAN CHARITABLE FOUNDATION",
"BAHULYA VINIYOG VANIJYA PVT LTD",
"BAHUSMARNA CONSTRUCTION PRIVATE LIMITED",
"BAHUUDESIYA PRATHMIK GRAMIN¬†SAHKARI SAMITI BHATOL¬†SAHARANPUR",
"BAHWAN CYBERTEK PRIVATE LIMITED",
"BAHWAN INTERNATIONAL PROJECTS LLC",
"BAI A F PETIT PARSI GIRLS ORPHANAGE SCHOOL",
"BAI AVABAI F PETIT BAFP GIRLS‚Äô HIGH SCHOOL, MUMBAI",
"BAI AVABAI HIGH SCHOOL VALSAD",
"BAI DHUNMAI CAWASJI HIGH SCHOOL KHANDALA",
"BAI INFOSOLUTIONS PRIVATE LIMITED",
"BAI JERBAI WADIA HOSPITAL FOR CHILDREN",
"BAI KAKAJI POLYMERS PRIVATE LIMITED",
"BAI NAVAJIBAI TATA GIRLS'S HIGH SCHOOL",
"BAIBHAB REALCON PRIVATE LIMITED",
"BAIBHABLAXMI ROLLER FLOUR & DAL MILL PRIVATE LIMITED",
"BAID AGRO PRODUCTS PRIVATE LIMITED",
"BAID DENIMAX PRIVATE LIMITED",
"BAID DISTRIBUTORS PVT LTD",
"BAID ENGINEERS PVT. LTD",
"BAID GEMS PRIVATE LIMITED",
"BAID HOLDINGS PVT LTD",
"BAID FINSERV LIMITED",
"BAID MARBLE AND TILES PRIVATE LIMITED",
"BAID ORGANISATION PVT LTD",
"BAID PARIWAHAN LTD",
"BAID POWER SERVICES PRIVATE LIMITED",
"BAID ROTOMOULDERS PRIVATE LIMITED. (PART IX)",
"BAID SANITARYWARE PVT LTD",
"BAID STEEL PRIVATE LIMITED",
"BAID STOCK BROKING SERVICES PRIVATE LIMITED",
"BAID SYNTHETICS PRIVATE LIMITED",
"BAID WIRE AND CABLE INDUSTRIES PRIVATE LIMITED",
"BAIDESWAR INFRA PROJECTS PRIVATE LIMITED",
"BAIDNATH TEXTILES TRADING PRIVATE LIMITED",
"BAIDYANATH AUTOMOBILES PRIVATE LIMITED",
"BAIDYANATH ESTATES PRIVATE LIMITED",
"BAIDYANATH FLOUR INDUSTRIES PRIVATE LIMITED",
"BAIDYANATH IMPEX PRIVATE LIMITED",
"BAIDYANATH LIFE SCIENCES PRIVATE LIMITED",
"BAIDYANATH LNG PRIVATE LIMITED",
"BAIDYANATH MINERALS PRIVATE LIMITED",
"BAIDYANATH POLY TUBES PRIVATE LIMITED",
"BAIDYANATH POWER PRIVATE LIMITED",
"BAIDYANATH REAL FOOD PRIVATE LIMITED",
"BAIDYANATH RESOURCES PRIVATE LIMITED",
"BAIDYAPUR HIMGHAR PRIVATE. LIMITED.",
"BAIF AGRO AND BIO TECHNOLOGY PRIVATE LIMITED",
"BAIF INSTITUTE FOR SUSTAINABLE LIVELIHOODS AND DEVELOPMENT",
"BAIGA CHAK MAHILA KISHAN UTPADAK PRODUCER COMPANY LIMITED",
"BAIHE MEDICAL INDIA PRIVATE LIMITED",
"BAIJAL PACKAGING INDUSTRIES PRIVATE LIMITED",
"BAIJAL SYNTHETICS PRIVATE LIMITED",
"BAIJAY INTERNATIONAL PRIVATE LIMITED",
"BAIJNATH JEWELS PRIVATE LIMITED",
"BAIJNATH KHAITAN J B SCHOOL",
"BAIJNATH NIRMAN INDIA PRIVATE LIMITED",
"BAIJNATH PHARMACEUTICALS PRIVATE LIMITED",
"BAIJNATH PLASTIC PRODUCTS PRIVATE LIMITED",
"BAIJNATH SCRAP CENTRE",
"BAIJNATH TIMBER ENTERPRISES PRIVATE LIMITED",
"BAIJUNDA ELECTRONICS PRIVATE LIMITED",
"BAI KAKAJI AQUASURE SOLUTIONS PRIVATE LIMITED",
"BAIKUNTH PARIGAMAN PRIVATE LIMITED",
"BAIKUNTH RESORTS PVT LTD",
"BAIKUNTHI DEVI KANYA MAHAVIDALAYA",
"BAIKUNTHPUR TEA MANUFACTURING CO PRIVATE LIMITED",
"BAIN & COMPANY INDIA PRIVATE LIMITED",
"BAIN CAPABILITY CENTRE INDIA PRIVATE LIMITED",
"BAIN CAPITAL ADVISORS (INDIA) PRIVATE LIMITED",
"BAINADA MOTORS PRIVATE LIMITED",
"BAINBRIDGE NAVIGATION PRIVATE LIMITED",
"BAINENI MARKETING PRIVATE LIMITED",
"BAINITE MACHINES PRIVATE LIMITED",
"BAINS MEDICAL PRIVATE LIMITED",
"BAINS STEELS PRIVATE LIMITED",
"BAIRATHI BUSINESS PRIVATE LIMITED",
"BAIRATHI SHOE COMPANY PRIVATE. LIMITED.",
"BAIRAVA METAL MANUFACTURAR PRIVATE LIMITED",
"BAIRAVI PROPERTIES AND CONSTRUCTION PRIVATE LIMITED",
"BAIRAVI VINCOM PVT.LTD.",
"BAISAKHI FLOWERS PRIVATE LIMITED",
"BAISAKHI HOTELS & RESORTS PRIVATE LIMITED",
"BAISAKHI RAM GIRDHARILAL PRIVATE LIMITED",
"BAISH TYRES PRIVATE LIMITED",
"BAISHALI STEELS PRIVATE LIMITED",
"BAISIWALA PRE FAB PVT. LTD",
"BAISREE ENTERPRISES PRIVATE LIMITED",
"BAIT LOGITECH PRIVATE LIMITED",
"BAITARANI POWER PROJECT PRIVATE LIMITED",
"BAITARNI WEST COAL COMPANY LIMITED",
"BAJAAO MUSIC PRIVATE LIMITED",
"BAJAJ ALLIANZ FINANCIAL DISTRIBUTORS LIMITED",
"BAJAJ ALLIANZ GENERAL INSURANCE COMPANY LIMITED",
"BAJAJ ALLIANZ LIFE INSURANCE COMPANY LIMITED",
"BAJAJ ALLIANZ STAFFING SOLUTIONS LIMITED",
"BAJAJ APPLIANCES LIMITED",
"BAJAJ ARC ELECTRODES PRIVATE LIMITED",
"BAJAJ AUTO CREDIT LIMITED",
"BAJAJ AUTO FINANCE LIMITED",
"BAJAJ AUTO HOLDINGS LIMITED",
"BAJAJ AUTO LIMITED",
"BAJAJ AUTOTRONIX INDIA PRIVATE LIMITED",
"BAJAJ AVIATION PRIVATE LIMITED",
"BAJAJ BABY PRODUCTS PRIVATE LIMITED",
"BAJAJ CAPITAL FINANCIAL SERVICES LIMITED",
"BAJAJ CAPITAL INS. BROKING LIMITED.",
"BAJAJ CAPITAL INVESTMENT CENTRE LIMITED",
"BAJAJ CAPITAL LIMITED",
"BAJAJ CAPITAL VENTURES PRIVATE LIMITED",
"BAJAJ CARGO CARRIER PRIVATE LIMITED",
"BAJAJ CARPET INDUSTRIES LIMITED",
"BAJAJ COMMUNICATIONS PRIVATE LIMITED",
"BAJAJ CONSULTANTS PRIVATE LIMITED",
"BAJAJ CONSUMER CARE LIMITED",
"BAJAJ CORP LIMITED",
"BAJAJ COTEX PRIVATE LIMITED",
"BAJAJ EARTHS PRIVATE LIMITED",
"BAJAJ ECO TECH PRODUCTS LIMITED",
"BAJAJ ELECTRICALS LIMITED",
"BAJAJ ELECTROPLATERS PRIVATE LIMITED",
"BAJAJ ENERGY PRIVATE LIMITED",
"BAJAJ ENTERPRISES PRIVATE LIMITED",
"BAJAJ EXCLUSIVE PRIVATE LIMITED",
"BAJAJ EXPORTS PRIVATE LIMITED",
"BAJAJ EXPRESS (INDIA) PRIVATE LIMITED",
"BAJAJ FINANCE LIMITED",
"BAJAJ FINANCIAL SECURITIES LIMITED",
"BAJAJ FINSERV ASSET MANAGEMENT LIMITED",
"BAJAJ FINSERV DIRECT LIMITED",
"BAJAJ FINSERV HEALTH LIMITED",
"BAJAJ FINSERV LIMITED",
"BAJAJ FINSERV VENTURES LIMITED",
"BAJAJ FOOD PRODUCTS PVT LTD",
"BAJAJ HEALTHCARE LIMITED",
"BAJAJ HERBALS PRIVATE. LIMITED.",
"BAJAJ HILL RESORTS PRIVATE LIMITED",
"BAJAJ HINDUSTHAN SUGAR LIMITED",
"BAJAJ HOLDINGS & INVESTMENT LIMITED.",
"BAJAJ HOSIERY INDUSTRIES PRIVATE LIMITED",
"BAJAJ HOTELS PRIVATE LIMITED",
"BAJAJ HOUSING FINANCE LIMITED",
"BAJAJ INDUSTRIAL ALLOYS PRIVATE LIMITED",
"BAJAJ INDUSTRIAL FINANCE LTD",
"BAJAJ INDUSTRIES PVT LTD",
"BAJAJ INFRASTRUCTURE DEVELOPMENT COMPANY LIMITED",
"BAJAJ INTERNATIONAL PRIVATE LIMITED",
"BAJAJ INTERNATIONAL REALTY PRIVATE LIMITED",
"BAJAJ JUTE MACHINERY PVT LTD",
"BAJAJ KAGAJ LIMITED",
"BAJAJ LEASING AND FINANCE COMPANY LIMITE",
"BAJAJ MACHINES INDIA PRIVATE LIMITED",
"BAJAJ MASTERBATCHES PRIVATE LIMITED",
"BAJAJ MECHANICALS INDIA PRIVATE LIMITED",
"BAJAJ MEDITRADE PRIVATE LIMITED",
"BAJAJ MOTORS LIMITED",
"BAJAJ PARIVAHAN PRIVATE LIMITED",
"BAJAJ PLAST PRIVATE LIMITED",
"BAJAJ POLYMIN LIMITED",
"BAJAJ POWER EQUIPMENTS PRIVATE LIMITED",
"BAJAJ PROCESSORS LIMITED",
"BAJAJ PROCESSORS PRIVATE LIMITED",
"BAJAJ PROCESSPACK LIMITED",
"BAJAJ REINFORCEMENTS LLP",
"BAJAJ RESOURCES PRIVATE LIMITED",
"BAJAJ RUBBER COMPANY PRIVATE LIMITED",
"BAJAJ SALT PRIVATE LIMITED",
"BAJAJ SEVASHRAM PRIVATE LIMITED",
"BAJAJ SEWING MACHINES PRIVATE LIMITED",
"BAJAJ SEWING OVERSEAS PRIVATE LIMITED",
"BAJAJ SHARE AND STOCK BROKERS PRIVATE LIMITED",
"BAJAJ SILK FAB PRIVATE LIMITED",
"BAJAJ SINDHUDURG RICE MILLS LIMITED",
"BAJAJ SONS LIMITED",
"BAJAJ SPACE PRIVATE LIMITED",
"BAJAJ STEEL INDUSTRIES LIMITED",
"BAJAJ STEELS AND INDUSTRIES LIMITED",
"BAJAJ SUPERPACK INDIA LIMITED",
"BAJAJ SYNTHETICS MILLS PRIVATE LIMITED",
"BAJAJ TEXWORLD (INDIA) PRIVATE LIMITED",
"BAJAJ TRAVELS LIMITED",
"BAJAJ WHEELS PRIVATE LIMITED",
"BAJAJ-G DEVELOPERS AND MARKETING PRIVATE LIMITED",
"BAJARANGA CONSTRUCTIONS & REPAIRS PRIVATE LIMITED",
"BAJARI FILAMENTS PRIVATE LIMITED",
"BAJATO PARTS & SYSTEMS PRIVATE LIMITED",
"BAJI BABA FARMERS PRODUCER COMPANY LIMITED",
"BAJINIA EXPRESS CARGO PRIVATE LIMITED",
"BAJIYA SECURITY SERVICES PRIVATE LIMITED",
"BAJLA AGENCIES PRIVATE LIMITED",
"BAJLA DISTRIBUTORS PVT LTD",
"BAJLA FOOD PRODUCTS PRIVATE LIMITED",
"BAJNA INT COLLEGE BAJNA MATHURA",
"BAJORIA APPARELS PVT LTD",
"BAJORIA APPLIANCES PRIVATE LIMITED",
"BAJORIA FABRICS PRIVATE LIMITED",
"BAJORIA FINANCIAL SERVICES PRIVATE LIMITED",
"BAJORIA FOODS PRIVATE LIMITED",
"BAJORIA IMPEX PRIVATE LIMITED",
"BAJORIYA CONSTRUCTION COMPANY PRIVATE LIMITED",
"BAJPAI REFRIGERATION AND BAKERS COMPANY",
"BAJRANG AGRO INDUSTRIES PRIVATE LIMITED",
"BAJRANG AGROTECH (INDIA) PRIVATE LIMITED",
"BAJRANG AUTOMOBILES PRIVATE LIMITED",
"BAJRANG BALI INTERNATIONAL PRIVATE LIMITED",
"BAJRANG BROTHERS AGRO PRODUCER COMPANY LIMITED",
"BAJRANG COLOUR CORNER PRIVATE LIMITED",
"BAJRANG COTTON PRIVATE. LIMITED.",
"BAJRANG DEALMARK PRIVATE LIMITED",
"BAJRANG DEVCON PRIVATE LIMITED",
"BAJRANG ENGINEERING COLLEGE",
"BAJRANG EXTRUSION PRIVATE LIMITED",
"BAJRANG FINANCE LIMITED",
"BAJRANG FOAMS PRIVATE LIMITED",
"BAJRANG GRAPHICS PRIVATE LIMITED",
"BAJRANG IMPEX PRIVATE LIMITED",
"BAJRANG INFRASTRUCTURE AND CONSTRUCTION PRIVATE LIMITED",
"BAJRANG LOGISTIX PRIVATE LIMITED",
"BAJRANG MOTORS",
"BAJRANG NAMKEEN PRIVATE LIMITED",
"BAJRANG NIRMAN PRIVATE LIMITED",
"BAJRANG PETROCHEMICALS PRIVATE LIMITED",
"BAJRANG PRESTRESSED PRODUCTS PRIVATE LIMITED",
"BAJRANG PROCESSORS PRIVATE LIMITED",
"BAJRANG PULSES AND AGRO PRODUCTS PRIVATE LIMITED",
"BAJRANG REFRACTORIES PRIVATE LIMITED",
"BAJRANG RETAILERS PRIVATE LIMITED",
"BAJRANG ROAD CONSTRUCTION PRIVATE LIMITED",
"BAJRANG STEEL AND ALLOYS PRIVATE LIMITED",
"BAJRANG STEEL SALES CORPORATION",
"BAJRANG STEEL TRADING COMPANY (INDIA) PVT LTD",
"BAJRANG STEELMET TRADING PRIVATE LIMITED",
"BAJRANG TEA AND INDUSTRIES PRIVATE LIMITED",
"BAJRANG TOOLS & ROLLS PRIVATE LIMITED",
"BAJRANG WHEAT PRODUCTS PRIVATE LIMITED",
"BAJRANG WIRE AND INFRA PRIVATE LIMITED",
"BAJRANG WIRE PRODUCTS INDIA PRIVATE LIMITED",
"BAJRANG WOOLTEX PVT LTD",
"BAJRANGALAL PAWAN KUMAR PVT LTD",
"BAJRANGBALI DAL MILL PRIVATE LIMITED",
"BAJRANGBALI FUELS PRIVATE LIMITED",
"BAJRANGBALI IMPEX PRIVATE LIMITED",
"BAJRANGBALI REFRATECH INDIA PRIVATE LIMITED",
"BAJRANGBALI RE-ROLLERS PRIVATE LIMITED",
"BAJRANGBALI SNACKS PRIVATE LIMITED",
"BAJRANGBALI SPONGE AND POWER LIMITED",
"BAJRANGBALI WIRE PRODUCTS PRIVATE LIMITED",
"BAJRANGI SARJAN PRIVATE LIMITED",
"BAJRANGPUR CLONAL TEA PVT LTD",
"BAJRANGSHAKTI PIPES PRIVATE LIMITED",
"BAJWA ARJUN PROPERTY DEVELOPERS PRIVATE LIMITED",
"BAJWA DEVELOPERS LIMITED",
"BAJWA INFRASTRUCTURE PRIVATE LIMITED",
"BAJWA VEGICRAFT PRIVATE LIMITED",
"BAKANAN FOODS PRIVATE LIMITED",
"BAKCOM NETWORKS INDIA PRIVATE LIMITED",
"BAKE MY CAKE FILMS PRIVATE LIMITED",
"BAKE WISH PRIVATE LIMITED",
"BAKEBEST FOODS PRIVATE LIMITED",
"BAKEDIETS PRIVATE LIMITED",
"BAKELITE COATINGS & PAINTS PRIVATE LIMITED",
"BAKELITE ELECTRICAL MANUFACTURING COMPANY PRIVATE LIMITED",
"BAKE-LITE FOOD PROCESSING PRIVATE LIMITED",
"BAKEMAX FOODS PRIVATE LIMITED",
"BAKEMEN FOODS PRIVATE LIMITED",
"BAKER GAUGES INDIA PRIVATE LIMITED",
"BAKER HUGHES ASIA PACIFIC LIMITED",
"BAKER HUGHES INCORPORATED",
"BAKER HUGHES OILFIELD SERVICES INDIA PRIVATE LIMITED",
"BAKER HUGHES SINGAPORE PTE LIMITED",
"BAKERI PROJECTS PRIVATE LIMITED",
"BAKERI URBAN DEVELOPMENT PRIVATE LIMITED",
"BAKERS AGRIFOODS PRIVATE LIMITED",
"BAKERS CIRCLE INDIA PRIVATE LIMITED",
"BAKERS HEAVEN PRIVATE LIMITED",
"BAKERS INN GLOBAL PRIVATE LIMITED",
"BAKERS KRAFT PRIVATE LIMITED",
"BAKERS OVEN N RESTAURANT PRIVATE LIMITED",
"BAKERS SHOPPEE PRIVATE LIMITED",
"BAKERS SPICES & INGREDIENTS PRIVATE LIMITED",
"BAKERSTREET HOSPITALITY PRIVATE LIMITED",
"BAKERSVILLE INDIA PVT LTD",
"BAKEWELL BISCUITS PRIVATE. LIMITED.",
"BAKEWELL INDUSTRIES PRIVATE LIMITED",
"BAKGIYAM ENGINEERING PRIVATE LIMITED",
"BAKI PACKI PRIVATE LIMITED",
"BAKING STATION PRIVATE LIMITED",
"BAKLIWAL AGRO AGENCIES PVT LTD",
"BAKLIWAL FINCOM PVT.LTD.",
"BAKLIWAL HOLDINGS PRIVATE LIMITED",
"BAKLIWAL TEXTILES PRIVATE LIMITED",
"BAKLIWAL TUTORIALS PRIVATE LIMITED",
"BAKLIWAL VYAPAAR PRIVATE LIMITED",
"BAKSHI ASSOCIATES PRIVATE LIMITED",
"BAKSHI BROS. AGENCIES PRIVATE LIMITED",
"BAKSHI CHEMPHARMA EQUIPMENTS PRIVATE LIMITED",
"BAKSHI FOREX AND AIR SERVICES PRIVATE LIMITED",
"BAKSHI KA TALAAB INTER COLLEGE",
"BAKSHI MARK PRIVATE LIMITED",
"BAKSHI SECURITY AND PERSONNEL SERVICES PRIVATE LIMITED",
"BAKSHI TRANSPORT SERVICE PRIVATE LIMITED",
"BAKSHIRAM UDERAM HOLDINGS PVT. LTD.",
"BAKSHU PROPERTY PRIVATE LIMITED",
"BAKSHU TRADING PRIVATE LIMITED",
"BAKSON DRUGS & PHARMACEUTICALS PRIVATE LIMITED",
"BAKTHA MINERALS PRIVATE LIMITED",
"BAKUL AROMATICS AND CHEMICALS PRIVATE LIMITED",
"BAKUL CASTING PRIVATE LIMITED",
"BAKUL PHARMA PRIVATE LIMITED",
"BAKYASHWRI SEA FOOD PRIVATE LIMITED",
"BAL BARI PUBLIC SCHOOL GHAZIABAD",
"BAL BHARATI PUBLIC SCHOOL",
"BAL BHARTI",
"BAL BHARTI SCHOOL",
"BAL BHAVAN INTERNATIONAL SCHOOL",
"BAL BHAWAN SCHOOL",
"BAL CHAND COTSPIN PRIVATE LIMITED",
"BAL CONSULTANCY SERVICES PRIVATE LIMITED",
"BAL GOPAL CHILDREN HOSPITAL",
"BAL GUIDE SCHOOL",
"BAL JESU SEVADAN SEC HIGH SCHOOL",
"BAL KISHAN VINAY KUMAR METAL PRIVATE LIMITED",
"BAL KRISHANA SYNTHATIC LIMITED",
"BAL KRISHNA BHALOTIA CONSTRUCTION PRIVATE LIMITED",
"BAL MARKETING PRIVATE LIMITED",
"BAL PHARMA LIMITED",
"BAL PLUMBING SERVICE PRIVATE LIMITED",
"BAL PROPERTIES PRIVATE LIMITED",
"BAL RAKSHA BHARAT",
"BAL ROADLINES PRIVATE LIMITED",
"BAL VIDYA MANDIR SECONDARY",
"BALA & SONS PRIVATE LIMITED",
"BALA ASSOCIATES ENGINEERS & CONTRACTORS PRIVATE LIMITED",
"BALA ELECTRON PRIVATE LIMITED",
"BALA FACILITY SERVICES PRIVATE LIMITED",
"BALA INDUSTRIES AND ENTERTAINMENT PRIVATE LIMITED",
"BALA SAI EARTH MOVERS PRIVATE LIMITED",
"BALA SECURITY SERVICES PRIVATE LIMITED",
"BALA SUNDRI FOODS",
"BALA TRAVELLINE SOLUTION PRIVATE LIMITED",
"BALA TREEPURA AGRO INDUSTRIES LIMITED",
"BALA VIDYA MANDIR SENIOR SECONDARY SCHOOL",
"BALAA SANMUGA POWER INFRAA PRIVATE LIMITED",
"BALAARK PHARMACEUTICALS PRIVATE LIMITED",
"BALABHARTI INFRASTRUCTURE PRIVATE LIMITED",
"BALACHANDIKA SECURITY FORCE INDIA PRIVATE LIMITED",
"BALADEV SOLAR PARK PRIVATE LIMITED",
"BALAGAN BEEDI COMPANY PRIVATE LIMITED",
"BALAGANGA TEXTILES PRIVATE LIMITED",
"BALAGARH RICE MILL PRIVATE LIMITED",
"BALAHANUMAN PLASTIC INDUSTRIES PRIVATE LIMITED",
"BALAI AGRO INDUSTRIES PRIVATE LIMITED",
"BALAI NANDY AGENCY & CO. PRIVATE LIMITED",
"BALAJAY INFRASTRUCTURE PRIVATE LIMITED",
"BALAJEE ARUN EDUCATIONAL SOCIETY",
"BALAJEE DETECTIVE FORCE PRIVATE LIMITED",
"BALAJEE DEVBUILD PRIVATE LIMITED",
"BALAJEE EXCHEM PRIVATE LIMITED",
"BALAJEE EXPORTS LTD",
"BALAJEE FIBROPLAST PRIVATE LIMITED",
"BALAJEE HITEC ROLLING PRIVATE LIMITED",
"BALAJEE INDUSTRIES PRIVATE LIMITED",
"BALAJEE INFRATECH & CONSTRUCTIONS PRIVATE LIMITED",
"BALAJEE LOHA PRIVATE LIMITED",
"BALAJEE MINI STEELS & REROLLING PRIVATE LIMITED",
"BALAJEE PLY MARKETING PRIVATE LIMITED",
"BALAJEE PLY PRODUCT PRIVATE LIMITED",
"BALAJEE RANG UDYOG PRIVATE LIMITED",
"BALAJEE SPONGE AND POWER PRIVATE LIMITED",
"BALAJEE STRUCTURAL(INDIA) PRIVATE LIMITED",
"BALAJEE STRUCTURALS INDIA LIMITED",
"BALAJEE TECHNO POLYFABS PRIVATE LIMITED",
"BALAJEE WEDDING & EVENTZ PRIVATE LIMITED",
"BALAJI (PURNEA) INFRATECH & DEVELOPERS PRIVATE LIMITED",
"BALAJI ACCU-PRECI PARTS PRIVATE LIMITED",
"BALAJI ACQA AND AGRO PRODUCTS PRIVATE LIMITED",
"BALAJI ACTION BUILDWELL PRIVATE LIMITED",
"BALAJI ACTION WOODDECOR PRIVATE LIMITED",
"BALAJI ADVERTISING LTD",
"BALAJI AGRI BIOTECH PRIVATE LIMITED",
"BALAJI AGRICULTURAL INDUSTRIES PRIVATE LIMITED",
"BALAJI AGRITRADE PRIVATE LIMITED",
"BALAJI AGRO ENGINEERING PRIVATE LIMITED",
"BALAJI AGRO EQUIP PVT LTD",
"BALAJI AGRO FARMERS PRODUCER COMPANY LIMITED",
"BALAJI AGRO OILS LIMITED",
"BALAJI AGRO ORGANICS AND FERTILIZERS PRIVATE LIMITED",
"BALAJI AGRO PRIVATE LIMITED",
"BALAJI AGRO PRODUCTS PVT LTD",
"BALAJI AGRO SYSTEMS PRIVATE LIMITED",
"BALAJI AIRVENT SYSTEMS PRIVATE LIMITED",
"BALAJI ALUMINIUM ALLOYS PRIVATE LIMITED",
"BALAJI ALUMINIUM EXTRUSIONS PRIVATE LIMITED",
"BALAJI AMINES LIMITED",
"BALAJI ASSOCIATES",
"BALAJI ASSOCIATES SV PRIVATE LIMITED",
"BALAJI AUTO CARE PRIVATE LIMITED",
"BALAJI AUTO COMMERCIAL VEHICLES PRIVATE LIMITED",
"BALAJI AUTO ENTERPRISES MYSORE PRIVATE LIMITED,",
"BALAJI AUTO LINKS",
"BALAJI AUTO WORKS PRIVATE LIMITED",
"BALAJI AUTOMART PRIVATE LIMITED",
"BALAJI AUTOMOTIVE",
"BALAJI AUTOPARTS PRIVATE LIMITED",
"BALAJI AUTOTECH PRIVATE LIMITED",
"BALAJI BISONS TAPE PRIVATE LIMITED",
"BALAJI BOOT HOUSE PRIVATE LIMITED",
"BALAJI BOREWELL PRIVATE LIMITED",
"BALAJI BUILDERS",
"BALAJI BUILDING TECHNOLOGIES LIMITED",
"BALAJI BULLIONS & COMMODITIES (INDIA) PRIVATE LIMITED",
"BALAJI CAM SERVICES LLP",
"BALAJI CARBON AND REFRACTORIES PRIVATE LIMITED",
"BALAJI CELLPHONE PRIVATE LIMITED",
"BALAJI CHAWAL MILLS PRIVATE. LIMITED.",
"BALAJI CHEM SOLUTIONS PRIVATE LIMITED",
"BALAJI CLAY PRIVATE LIMITED",
"BALAJI COAL PRIVATE LIMITED",
"BALAJI COMPUTECH PRIVATE LIMITED",
"BALAJI CONSULTANCY",
"BALAJI CONTECH PROJECTS PRIVATE LIMITED",
"BALAJI CONTRACTING COMPANY PRIVATE LIMITED",
"BALAJI CORPORATION PRIVATE LIMITED",
"BALAJI COTTON FIBERS PRIVATE LIMITED",
"BALAJI COURIER LOGISTICS PRIVATE LIMITED",
"BALAJI CURE&CARE HOSPITAL PRIVATE LIMITED",
"BALAJI DALL MILLS AND GODOWNS PRIVATE LIMITED",
"BALAJI DAYALPURA INFRA PRIVATE LIMITED",
"BALAJI DERIVATIVES PRIVATE LIMITED",
"BALAJI DEVELOPERS AND CONSTRUCTION",
"BALAJI DISTILL",
"BALAJI DISTRIBUTORS",
"BALAJI DREAM IT SOLUTION PRIVATE LIMITED",
"BALAJI DRESS MATERIALS PRIVATE LIMITED",
"BALAJI DUROBUILD PRIVATE LIMITED",
"BALAJI EARTH MOVERS (INDIA) PRIVATE LIMITED",
"BALAJI EDU AND CHARITABLE PUBLIC TRUST",
"BALAJI EDUCATION & CHARITABLE TRUST",
"BALAJI ELECTRICAL AND CONDUIT ACCESSORIES PRIVATE LIMITED",
"BALAJI ELECTRICAL AND HARDWARE",
"BALAJI ELECTRO CONTROLS PRIVATE LIMITED",
"BALAJI ELECTRO SMELTERS PRIVATE LIMITED",
"BALAJI ELECTWELD PRIVATE LIMITED",
"BALAJI ENERGY PRIVATE LIMITED",
"BALAJI ENGINEERING",
"BALAJI ENGINEERING AUTOMOTIVE PRIVATE LIMITED",
"BALAJI ENTERPRISES LLP",
"BALAJI ENTERTAINMENT (GUJARAT) PRIVATE LIMITED",
"BALAJI ENZYME & CHEMICAL PRIVATE LIMITED",
"BALAJI EQUITIES LIMITED",
"BALAJI EXIM ENTERPRISES PRIVATE LIMITED",
"BALAJI EXPO INDIA PRIVATE LIMITED",
"BALAJI EXTRUSIONS AND CABLES PRIVATE LIMITED",
"BALAJI FASTNERS (INDIA) PRIVATE LIMITED",
"BALAJI FERTILISERS PRIVATE LIMITED",
"BALAJI FILAMENTS PRIVATE LIMITED",
"BALAJI FINEGOODS PRIVATE LIMITED",
"BALAJI FLEXI PACK PRIVATE LIMITED",
"BALAJI FORMALIN PRIVATE LIMITED",
"BALAJI FREIGHT CARRIERS PRIVATE LIMITED",
"BALAJI FURNITURE",
"BALAJI FURNITURE PRIVATE LIMITED",
"BALAJI GINNING AND PRESSING FACTORY",
"BALAJI GOVINDAM TEXTILES PRIVATE LIMITED",
"BALAJI GRAINS PRIVATE LIMITED",
"BALAJI GREENTECH PRODUCTS LIMITED",
"BALAJI HANDICRAFTS PRIVATE LIMITED",
"BALAJI HARDWARE",
"BALAJI HATCHERIES PRIVATE LIMITED",
"BALAJI HEART HOSPITAL AND DIAGNOSTIC CENTER PRIVATE LIMITED",
"BALAJI HOME DECOR PRIVATE LIMITED",
"BALAJI HOSPITAL",
"BALAJI HYDRO CARBONS PRIVATE LIMITED",
"BALAJI IMPEX PRIVATE LIMITED",
"BALAJI INDUCTION FURNACE PRIVATE LIMITED",
"BALAJI INDUSTRIAL AND AGRICULTURAL CASTINGS PRIVATE LIMITED",
"BALAJI INDUSTRIAL CORPORATION LIMITED",
"BALAJI INDUSTRIAL ENTERPRISES PRIVATE LIMITED",
"BALAJI INDUSTRIAL MANPOWER SERVICES PRIVATE LIMITED",
"BALAJI INFRA PROJECTS LIMITED",
"BALAJI INFRACARE PRIVATE LIMITED",
"BALAJI INFRACONCLAVE PRIVATE LIMITED",
"BALAJI INFRAENGINEERING PRIVATE LIMITED",
"BALAJI INFRALOG PRIVATE LIMITED",
"BALAJI INFRAROADS PRIVATE LIMITED",
"BALAJI INKS AND CHEMICALS PRIVATE LIMITED",
"BALAJI INSTITUTE OF MANAGEMENT AND HUMAN RESOURCE DEVELOPMENT",
"BALAJI INSTITUTE OF TECHNOLOGY AND SCIENCE",
"BALAJI INTEGRATED SHIPPING INDIA PRIVATE LIMITED",
"BALAJI INTERNATIONAL",
"BALAJI INTERNATIONAL CRAFT PRIVATE LIMITED",
"BALAJI IRRITECH PRIVATE LIMITED",
"BALAJI KERAMOS PRIVATE LIMITED",
"BALAJI KHAD CENTRE PRIVATE LIMITED",
"BALAJI KRANTHI HIGH SCHOOL",
"BALAJI KRIPA IRON AND STEEL PRIVATE LIMITED",
"BALAJI LANDCRAFT PRIVATE LIMITED",
"BALAJI LOOMTEX PRIVATE LIMITED",
"BALAJI MAHILA DEGREE & P G COLLEGE",
"BALAJI MAHILA DEGREE &PG COLLEGE",
"BALAJI MALTS PRIVATE LIMITED",
"BALAJI MANAGEMENT SERVICES PRIVATE LIMITED",
"BALAJI MANPOWER RECRUITMENT PRIVATE LIMITED",
"BALAJI MANSION PRIVATE LIMITED",
"BALAJI MARBLES (INDIA) PRIVATE LIMITED",
"BALAJI MARILINE PRIVATE LIMITED",
"BALAJI MARKETING AGENCIES (BOMBAY) PVT LTD",
"BALAJI MATERIAL HANDLING PRIVATE LIMITED",
"BALAJI MATERNITY HOME PRIVATE LIMITED",
"BALAJI MEDICAL AGENCIES",
"BALAJI MEDICAL SERVICES PRIVATE LIMITED",
"BALAJI MEDISCANS PRIVATE LIMITED",
"BALAJI MEDIVISION PRIVATE LIMITED",
"BALAJI MELTERS PRIVATE LIMITED",
"BALAJI MICRO TECHNOLOGIES PRIVATE LIMITED",
"BALAJI MINERALS & REFRACTORIES PRIVATE LIMITED",
"BALAJI MOBITECH PRIVATE LIMITED",
"BALAJI MOTION PICTURES LIMITED",
"BALAJI MOTORS",
"BALAJI MSRM LAAMINATES PRIVATE LIMITED",
"BALAJI MULTIFLEX PRIVATE LIMITED",
"BALAJI MULTIPLEX PRIVATE LIMITED",
"BALAJI MULTISPECIALITY HOSPITAL",
"BALAJI NATIONAL PUBLIC SCHOOL",
"BALAJI NATUROPOWER PRIVATE LIMITED",
"BALAJI NEUROCARE HEALTH SERVICES PRIVATE LIMITED",
"BALAJI NIRYAAT PRIVATE LIMITED",
"BALAJI NUTRIENTS PRIVATE LIMITED",
"BALAJI OIL INDUSTRIES PRIVATE LIMITED",
"BALAJI ORES PRIVATE LIMITED",
"BALAJI ORNAMENTS & BULLIONS INDIA PRIVATE LIMITED",
"BALAJI OVERSEAS",
"BALAJI OVERSEAS OM PRIVATE LIMITED",
"BALAJI PACK & PACK PRIVATE LIMITED",
"BALAJI PACKPLAST PRIVATE LIMITED",
"BALAJI PALLETS PRIVATE LIMITED",
"BALAJI PERIPHERALS PRIVATE LIMITED",
"BALAJI PHARMA",
"BALAJI PHARMACARE PRIVATE LIMITED",
"BALAJI PHARMACHEM PRIVATE LIMITED",
"BALAJI PHOSPHATES LIMITED",
"BALAJI PICK & MOVERS PRIVATE LIMITED",
"BALAJI PIGMENTS PRIVATE LIMITED",
"BALAJI PINEWOOD PRODUCTS PRIVATE LIMITED",
"BALAJI PIPE INDUSTRIES PRIVATE LIMITED",
"BALAJI PIPING PRODUCTS LIMITED",
"BALAJI PLASTOFOIL PRIVATE LIMITED",
"BALAJI PLUMBING SOLUTIONS PRIVATE LIMITED",
"BALAJI PLY SALES PRIVATE LIMITED",
"BALAJI POLYCOT PRIVATE LIMITED",
"BALAJI POLYESTER PRIVATE LIMITED",
"BALAJI POLYFIBERS PRIVATE LIMITED",
"BALAJI POLYPLAST PRIVATE LIMITED",
"BALAJI POLYSTER PRIVATE LIMITED",
"BALAJI POWER (A UNIT HIRA FERRO ALLOYS LTD)",
"BALAJI PRATISTHAN PRIVATE LIMITED",
"BALAJI PRECISION TUBES (INDIA) PRIVATE LIMITED",
"BALAJI PREFAB PRIVATE LIMITED",
"BALAJI PRELAMS PRIVATE LIMITED",
"BALAJI PRESS PRODUCTS INDIA PRIVATE LIMITED",
"BALAJI PRESSURE VESSELS PRIVATE LIMITED",
"BALAJI QUARTZ PRIVATE LIMITED",
"BALAJI RAIL ROAD SYSTEMS LIMITED",
"BALAJI RAIL ROAD SYSTEMS PRIVATE LIMITED",
"BALAJI REALCON PRIVATE LIMITED",
"BALAJI REALITY",
"BALAJI RETAILMART PRIVATE LIMITED",
"BALAJI ROTOMOULDERS PRIVATE LIMITED",
"BALAJI S.S. SHEETS PRIVATE LIMITED",
"BALAJI SALES CORPORATION PRIVATE LIMITED",
"BALAJI SAREE KENDRA PRIVATE LIMITED",
"BALAJI SECURITY SERVICES PRIVATE LIMITED",
"BALAJI SEEDS AND PROCESSING PRIVATE LIMITED",
"BALAJI SENTERY¬†",
"BALAJI SERVICES INFRASTRUCTURE & DEVELOPMENT PRIVATE LIMITED",
"BALAJI SEWING MACHINE PRIVATE LIMITED",
"BALAJI SHIPPING & OFFSHORE SERVICES PRIVATE LIMITED",
"BALAJI SMART ARCADE PRIVATE LIMITED",
"BALAJI SOFTWARE",
"BALAJI SOLUTIONS LIMITED",
"BALAJI SOLUTIONS PRIVATE LIMITED",
"BALAJI SOYA PROTEINS PRIVATE LIMITED",
"BALAJI SPECIALITY CHEMICALS LIMITED",
"BALAJI SPECIALITY CHEMICALS PRIVATE LIMITED",
"BALAJI SPRINGS PRIVATE LIMITED",
"BALAJI STEEL ROLLING MILLS PVT LTD.",
"BALAJI STONE CRUSHING PLANT",
"BALAJI STORAGE BATTERIES LIMITED",
"BALAJI STRUCTURALS PRIVATE LIMITED",
"BALAJI SURVEYORS PRIVATE LIMITED",
"BALAJI SWITCHGEARS PRIVATE LIMITED",
"BALAJI TALENT SERVICES PRIVATE LIMITED",
"BALAJI TARMAT PRIVATE LIMITED",
"BALAJI TECHNO ENGINEERS PRIVATE LIMITED",
"BALAJI TECHNO SCHOOL",
"BALAJI TECHNOMECH PRIVATE LIMITED",
"BALAJI TELEFILMS LIMITED",
"BALAJI TELENETWIRELESS SOLUTIONS PRIVATE LIMITED",
"BALAJI TELESERVE PRIVATE LIMITED",
"BALAJI TELETECH AND POWERTECH PRIVATE LIMITED",
"BALAJI TELEVENTURES PRIVATE LIMITED",
"BALAJI TEXTILE MILLS PRIVATE LIMITED",
"BALAJI THREAD MILLS PRIVATE LIMITED",
"BALAJI TRADING ENTERPRISES PRIVATE LIMITED",
"BALAJI TRADING PRIVATE LIMITED",
"BALAJI TRANS MOVERS PRIVATE LIMITED",
"BALAJI TRANSLINE PRIVATE LIMITED",
"BALAJI TRANSPOWER PRIVATE LIMITED",
"BALAJI TRANSWAYS PRIVATE LIMITED",
"BALAJI TRAVCO INDIA PRIVATE LIMITED",
"BALAJI UNITRADE INDIA PRIVATE LIMITED",
"BALAJI VENTURES PRIVATE LIMITED",
"BALAJI WAFERS PRIVATE. LIMITED",
"BALAJI WAREHOUSE PRIVATE LIMITED",
"BALAJI WAREHOUSING COMPANY PRIVATE LIMITED",
"BALAJI WASHING COMPANY PRIVATE LIMITED",
"BALAJI WEBSOFT TECHNOLOGY PRIVATE LIMITED",
"BALAJI WEFT PRIVATE LIMITED",
"BALAJI WHITE CEMENT PRIVATE LIMITED",
"BALAJI WIRES PRIVATE LIMITED",
"BALAJI WOOL SPINNING MILLS PRIVATE LIMITED",
"BALAJIDHAM TOUR AND TRAVELS SERVICES PRIVATE LIMITED",
"BALAJIGLOBAL MARKETING INDIA PRIVATE LIMITED",
"BALAJIKRUPA ESTATES PRIVATE LIMITED",
"BALAJIKRUPA PROJECTS PRIVATE LIMITED",
"BALAJI-RATNA MULTISERVICES PRIVATE LIMITED",
"BALAJISHAKTI BULLIONS & JEWELLERS PRIVATE LIMITED",
"BALAJISWAMY PREMIUM STEELS PRIVATE LIMITED",
"BALAK CONSTRUCTION PRIVATE LIMITED",
"BALAMBIKA PROPERTIES PRIVATE LIMITED",
"BALAMMAL PROPERTIES AND PUBLICATIONS PRIVATE LIMITED",
"BALAMURUGAN EDUCATION CENTRE GLOBAL PRIVATE LIMITED",
"BALAN AGRO PRODUCTS PRIVATE LIMITED",
"BALAN AND CHHEDA DEVELOPERS PRIVATE LIMITED",
"BALAN ENGINEERING PRIVATE LIMITED",
"BALAN HOTELS PRIVATE LIMITED",
"BALAN NAMBISAN ARCHITECTS",
"BALANCE TECHNOLOGY PRIVATE LIMITED",
"BALANCEHERO INDIA PRIVATE LIMITED",
"BALANCING ACT PRIVATE LIMITED",
"BALANI INFOTECH PRIVATE LIMITED",
"BALANOOR PLANTATIONS AND INDUSTRIES LIMITED",
"BALANS FOODS PRIVATE LIMITED",
"BALAR FABRICS PRIVATE LIMITED",
"BALAR IMPEX PRIVATE LIMITED",
"BALAR MARKETING PRIVATE LIMITED",
"BALAR SYNTHETICS PRIVATE. LIMITED.",
"BALARAM CONSTRUCTION LIMITED",
"BALARAM PAPERS PRIVATE LIMITED",
"BALARAM PROPERTIES PVT.LTD.",
"BALARAM SAHA & SONS PRIVATE LIMITED",
"BALARAMA KRISHNA SPINNING MILLS PRIVATE LIMITED",
"BALARK METALS PRIVATE LIMITED",
"BALARK SOLAR PRIVATE LIMITED",
"BALARKA EMERGING TECH PRIVATE LIMITED",
"BALARKA FABRICON PRIVATE LIMITED",
"BALARKA FABRICS PRIVATE LIMITED",
"BALARKAAY FOREX AND TRAVEL PRIVATE LIMITED",
"BALAS INDUSTRIES PRIVATE LIMITED",
"BALASANKA MOTOR PRIVATE LIMITED",
"BALASARIA AGENCIES PRIVATE LIMITED",
"BALASHREE FOODS PRIVATE LIMITED",
"BALASHRI COMMERCIAL LIMITED",
"BALASIA PHARMACEUTICALS PRIVATE LIMITED",
"BALASON INFRASTRUCTURE SOLUTIONS PRIVATE LIMITED",
"BALASORE CHEMICALS PRIVATE LIMITED",
"BALASORE MARINE EXPORTS PRIVATE LIMITED",
"BALASORE OXYGEN PRIVATE LIMITED",
"BALATELE SYSTEMS PRIVATE LIMITED",
"BALAVENKATANARASIMHA COLD STORAGE PRIVATE LIMITED",
"BALAVIGNA WEAVING MILLS PRIVATE LIMITED",
"BALAXI PHARMACEUTICALS LIMITED",
"BALBHADRA DEVELOPERS PRIVATE LIMITED",
"BALBHAS BUSINESS SYSNOMICS PRIVATE LIMITED",
"BALBIR ALLOYS PRIVATE LIMITED",
"BALBIR HYDRAULIC MACHINES PRIVATE LIMITED",
"BALBIR METALS & POWER PVT LTD",
"BALBIR POWER PRIVATE LIMITED",
"BALBIR ROLLING MILLS PRIVATE LIMITED",
"BALBIX INDIA PRIVATE LIMITED",
"BALBOA TECH PRIVATE LIMITED",
"BALCHA ENTERPRISES PRIVATE LIMITED",
"BALCHAND CONSULTANCY AND TRADING PRIVATE LIMITED",
"BALCHANDRA BUILDERS PRIVATE LIMITED",
"BALCHANDRA HOTELS PRIVATE LIMITED",
"BALCKE DUERR ENGINEERING PRIVATE LIMITED",
"BALCKE-DUERR TECHNOLOGIES INDIA PRIVATE LIMITED",
"BALDAWA PETROLEUM AND TRANSPORTERS PRIVATE LIMITED",
"BALDEEP HOSPITALITY PRIVATE LIMITED",
"BALDEO SAHU INFRA PRIVATE LIMITED",
"BALDEV FINLEASE PRIVATE LIMITED.",
"BALDEV METALS PRIVATE LIMITED",
"BALDEV TEXTILE MILLS PRIVATE LIMITED",
"BALDEWA MANAGEMENT & MARKETING PVT LTD",
"BALDHA INDUSTRIES PRIVATE LIMITED",
"BALDOR TECHNOLOGIES PRIVATE LIMITED",
"BALDOTA BROTHERS PRIVATE LIMITED",
"BALDOTA CONTROL & EQUIPMENTS PRIVATE LIMITED",
"BALDOTA VALVE AND FITTING COMPANY PRIVATE LIMITED",
"BALDWIN BOYS' HIGH SCHOOL",
"BALDWIN INDIA PRIVATE LIMITED",
"BALE BABU ESTATES PRIVATE LIMITED",
"BALENO INDIA TRAVELS PRIVATE LIMITED",
"BALESHWAR AUTO PRIVATE LIMITED",
"BALESHWAR JEE STEELS AND AGRO FOODS PRIVATE LIMITED",
"BALESHWAR KHARAGPUR EXPRESSWAY LIMITED",
"BALESHWAR SYNTHETICS TEXTILES PRIVATE LIMITED",
"BALESWAR FOOD & AGRO PRIVATE LIMITED",
"BALESWAR OILS PVT LTD",
"BALEWADI TECHPARK PRIVATE LIMITED",
"BALFA STEELCO PRIVATE LIMITED",
"BALFOUR BEATTY INFRASTRUCTURE INDIA PRIVATE LIMITED",
"BALGOPAL COMMERCIAL LIMITED",
"BALGOPAL COMMODEAL PRIVATE LIMITED.",
"BALGOPAL FOOD PRODUCTS PRIVATE LIMITED",
"BALGOPAL HOLDINGS AND TRADERS LTD",
"BALGOPAL JEWELLERS PRIVATE LIMITED",
"BALGOPAL TEXTILES PRIVATE LIMITED",
"BALGOTA MARKETING PRIVATE LIMITED",
"BALHANUMAN FABRICS PRIVATE LIMITED",
"BALI AND COMPANY PRIVATE LIMITED",
"BALI DIAMONDS LLP",
"BALI FOODS PRIVATE LIMITED",
"BALI MANTRA EXPORTS PRIVATE LIMITED",
"BALI TEST HOUSE PRIVATE LIMITED",
"BALIAPATAM TILES AND BUSINESS VENTURES LIMITED",
"BALIGA DIAGNOSTICS PRIVATE LIMITED",
"BALIGA EXPORTS PRIVATE LIMITED,",
"BALIGA FISHNET",
"BALIGA LIGHTING EQUIPMENTS PRIVATE LIMITED",
"BALIJAN TEA COMPANY PRIVATE LIMITED",
"BALIN SUPREME FORCE PRIVATE LIMITED",
"BALINEE MILK PRODUCER COMPANY LIMITED",
"BALIOSOFT SOLUTIONS PRIVATE LIMITED",
"BALIRAJA AGROTECH CO PRIVATE LIMITED",
"BALIRAJA SAKHAR KARKHANA LIMITED",
"BALIRAM PATIL VIDYALAYA",
"BALITIKURI CO OPERATIVE BANK LTD",
"BALIWALLA AND HOMI PVT LTD",
"BALJEES HOTELS AND REAL ESTATES PRIVATE LIMITED",
"BALJEET SINGH EDUCATION SOCIETY",
"BALJIT AGROTECH PRIVATE LIMITED",
"BALJIT IRON PRIVATE LIMITED",
"BALJIT SECURITIES PRIVATE LIMITED",
"BALKESHWARNATH EXPORTS PRIVATE LIMITED",
"BALKISHAN BHAIYA AGRO FOODS PRIVATE LIMITED",
"BALKISHAN DASS SUBHASH CHAND ISPAT PRIVATE LIMITED",
"BALKRISHNA BOILERS PRIVATE LIMITED",
"BALKRISHNA BREEDING FARMS PRIVATE LIMITED",
"BALKRISHNA FABRICS",
"BALKRISHNA INDUSTRIES LIMITED",
"BALKRISHNA LIVESTOCK BREEDERS PRIVATE LIMITED",
"BALKRISHNA PAPER MILLS LIMITED",
"BALKRISHNA SPINTEX PRIVATE LIMITED",
"BALKRISHNA STEEL FORGE PRIVATE LIMITED",
"BALKRISHNA SYNTHETICS LIMITED",
"BALKRUSHNA INFRASTRUCTURE PRIVATE LIMITED",
"BALL AEROSOL PACKAGING INDIA PRIVATE LIMITED",
"BALL BEARING AND MACHINERY (INDIA) PRIVATE LIMITED",
"BALL BEVERAGE PACKAGING INDIA PRIVATE LIMITED",
"BALL BEVERAGE PACKAING INDIA PRIVATE LIMTED",
"BALLABH COMMERCIAL LTD",
"BALLABH VYAPAR PRIVATE LIMITED",
"BALLABHA HERBS PRIVATE LIMITED",
"BALLABHJI FOODS PRIVATE LIMITED",
"BALLAL TOURIST HOTEL PRIVATE LIMITED",
"BALLARD PROJECTS PRIVATE LIMITED",
"BALLARI INSTITUTE OF TECHNOLOGY & MANAGEMENT",
"BALLAVPUR PAPER MFG. LIMITED",
"BALLES TOOLING PRIVATE LIMITED",
"BALLESHWAR MOTORS PRIVATE LIMITED",
"BALLISTIC LEARNING PRIVATE LIMITED",
"BALLISTICS CARGO PRIVATE LIMITED",
"BALLOON ONE INDIA PRIVATE LIMITED",
"BALLR APPARELS PRIVATE LIMITED",
"BALLS AND CYLPEBS LTD",
"BALLSY ENGINEERING INDIA PRIVATE LIMITED",
"BALLUFF AUTOMATION INDIA PRIVATE LIMITED",
"BALLUPUR SOLAR POWER PROJECTS PRIVATE LIMITED",
"BALLURAM STEELS PRIVATE LIMITED",
"BALLY EXPORTS LIMITED",
"BALLY JUTE COMPANY LTD",
"BALLY MUNICIPALITY",
"BALLY PENS INDIA PRIVATE LIMITED",
"BALLYFABS INTERNATIONAL LIMITED",
"BALLYGUNGE WINES PRIVATE LIMITED",
"BALMAAN INDUSTRIES PRIVATE LIMITED",
"BALMATTA DIAGNOSTIC AND RESEARCH CENTRE LIMITED",
"BALMEEKIINTER COLLEGE BALUA CHANDAULI",
"BALMER LAWRIE & COMPANY LIMITED",
"BALMER LAWRIE INVESTMENTS LIMITED",
"BALMER LAWRIE-VAN LEER LIMITED",
"BALMITHRA EARLY LEARNING CENTRE PRIVATE LIMITED",
"BALMOHAN VIDYAMANDIR",
"BALMUKUND CEMENT & ROOFINGS PRIVATE LIMI TED",
"BALMUKUND SPONGE & IRON LIMITED",
"BALMUKUND SPONGE AND IRON PRIVATE LIMITE D",
"BALODHAN PAY CENTER SCHOOL",
"BALODIA VENTURE PRIVATE LIMITED",
"BALONI INTERNATIONAL EXPORTS PRIVATE LIMITED",
"BALOTRA CARRYING COMPANY PRIVATE LIMITED",
"BALPRADA BUILDERS PRIVATE LIMITED",
"BALPRADA HOTELS & HOSPITALITY PRIVATE LIMITED",
"BALRAM CORPORATE SERVICES PRIVATE LIMITED",
"BALRAM KRISHAN RANJEET SINGH TEXTILES PRIVATE LIMITED",
"BALRAMPUR AUTOMOBILES PRIVATE LIMITED",
"BALRAMPUR CHINI MILLS LTD",
"BALRAMPUR FLOUR MILLS INDIA PRIVATE LIMITED",
"BALRAMPUR PROFESSIONAL SERVICES PRIVATE LIMITED",
"BALSAM ACADEMY",
"BALSAN WORLD FOREX PRIVATE LIMITED",
"BALSARA ENGINEERING PRODUCTS LIMITED",
"BALSON HEALTHCARE PRIVATE LIMITED",
"BALSON POLYPLAST PRIVATE LIMITED",
"BALSONS JEWELLERS PRIVATE LIMITED",
"BALT INDIA PRIVATE LIMITED",
"BALTIC TECHNOLOGY PRIVATE LIMITED",
"BALTIC TESTING INDIA PRIVATE LIMITED",
"BALTICURI E S I HOSPITAL",
"BALTIMORE AIRCOIL INDIA PRIVATE LIMITED",
"BALU AUTO COMPONENTS PRIVATE LIMITED",
"BALU ENTERPRISES PRIVATE LIMITED",
"BALU FORGE INDUSTRIES LIMITED",
"BALU HERBALS PRIVATE LIMITED",
"BALU INDIA",
"BALUBHAI MOTORS PRIVATE LIMITED",
"BALUNI PUBLIC SCHOOL AGRA",
"BALURGHAT TECHNOLOGIES LIMITED",
"BALUSSERY BENEFIT CHIT FUND PRIVATE LIMITED",
"BALVANTRAY MEHTA VIDYA BHAWAN",
"BALVIKA INDUSTRIAL EQUIPMENTS PRIVATE LIMITED",
"BALVIKRUPA INFRASTRUCTURE PRIVATE LIMITED",
"BALVIR CONTROL PRIVATE LIMITED",
"BALVISHWA FOUNDATION SANCHALIT NEW ERA SCHOOL WATHAR STATION",
"BALWAN AGRO INDUSTRIES PRIVATE LIMITED",
"BALWAN MINES AND MINERALS PRIVATE LIMITED",
"BALWANT AGROTECH PRIVATE LIMITED",
"BALWANT AND DIDAR ENGINEERS INDIA PRIVATE LIMITED",
"BALWANT CONSTRUCTIONS PRIVATE LIMITED",
"BALWANT ENTERPRISES PRIVATE LIMITED",
"BALWANT INTERNATIONAL PRIVATE LIMITED",
"BALWANT PROCESS COMPANY",
"BALWARIA SECURITY SERVICES PRIVATE LIMITED",
"BALYAYA SEA AND AIR LOGISTIC PRIVATE LIMITED",
"BAMAA POWER CONTROL SYSTEM PRIVATE LIMITED",
"BAMAA POWER PROJECTS PRIVATE LIMITED",
"BAMANBORE TOLLWAY PRIVATE LIMITED",
"BAMANDA BIOTEK PRIVATE LIMITED",
"BAMANPUKUR F.P SCHOOL",
"BAMANPUKUR FP SCHOOL",
"BAMB BEATS MUSIC PRIVATE LIMITED",
"BAMBA RESORTS PRIVATE LIMITED",
"BAMBAI DREAMS ENTERTAINMENT PRIVATE LIMITED",
"BAMBEEQ SOLUTIONS PRIVATE LIMITED",
"BAMBINO AGRO INDUSTRIES LIMITED",
"BAMBINO PASTA FOOD INDUSTRIES PRIVATE LIMITED",
"BAMBINOS LEARNING SOLUTIONS PRIVATE LIMITED",
"BAMBOAT PRESS PRIVATE LIMITED",
"BAMBOO & BIRYANI PRIVATE LIMITED",
"BAMBOO ROSE (INDIA) PRIVATE LIMITED",
"BAMBREW PLANT FIBER TECHNOLOGY PRIVATE LIMITED",
"BAMC MEDICAL LIMITED",
"BAMD BUSINESS ADVISORS PRIVATE LIMITED",
"BAMDEV NAYAK INFRASTRUCTURES LIMITED.",
"BAMHNI WADHONA 176 HIGHWAY PRIVATE LIMITED",
"BAMKO INDIA PRIVATE LIMITED",
"BAMLIA STEEL UDYOG PRIVATE LIMITED",
"BAMNI PROTEINS LIMITED",
"BAMPSL SECURITIES LIMITED",
"BAMRAH CONSTRUCTIONS (INDIA) PRIVATE LIMITED",
"BAMRAH INFRASTRUCTURE PRIVATE LIMITED",
"BAMS CONDIMENTS IMPEX PRIVATE LIMITED",
"BAMUL",
"BAMUL BUSINESS GROUP",
"BAMUNARI PRY SCHOOL",
"BAMUNMURA KUSUM KUMARI GIRLS HIGH SCHOOL PRIMARY SECTION",
"BAN LABS PRIVATE LIMITED",
"BANA ENGINEERING PRIVATE LIMITED",
"BANA REFINERY PRIVATE LIMITED",
"BANACO OVERSEAS PRIVATE LIMITED",
"BANACOMBAI TEA PLANTATION PRIVATE LIMITED",
"BANAHOPE HEALTHCARE PRIVATE LIMITED",
"BANAIL HEALTHCARE PRIVATE LIMITED",
"BANAMALIPUR PRIYANATH INSTITUTION",
"BANANA BRANDWORKS PRIVATE LIMITED",
"BANANA CLUB CLOTHING PRIVATE LIMITED",
"BANANA CLUB TRENDS PRIVATE LIMITED",
"BANANA RETAIL PRIVATE LIMITED",
"BANARAS BEADS EXPORTS PRIVATE LIMITED",
"BANARAS BONE AND PROTEINS PRIVATE LIMITED",
"BANARAS ENGINEERING COMPANY PRIVATE LIMITED",
"BANARAS GLASS BEADS PRIVATE LIMITED",
"BANARAS GLASSES PRIVATE LIMITED",
"BANARAS GLOBAL PRIVATE LIMITED",
"BANARAS HINDU UNIVERSITY",
"BANARAS HOUSE ENGINEERING PRIVATE LIMITED",
"BANARAS LOCOMOTIVE WORKS",
"BANARAS MARBLES AND GRANITES LIMITED",
"BANARAS SWARN KALA KENDRA PRIVATE LIMITED",
"BANARAS WEAVE PRIVATE LIMITED",
"BANARASI KUTHI PRIVATE LIMITED",
"BANARASI NIKETAN PRIVATE LIMITED",
"BANARASIDAS RUIYA HIGH SCHOOL",
"BANARASWALA WIRE CRAFTS PRIVATE LIMITED",
"BANARASWALA WIRE MESH PRIVATE LIMITED",
"BANARSHI DAS INTER COLLEGE¬†SAHARANPUR",
"BANARSI DASS COTTON MILLS PRIVATE LIMITED",
"BANARSI DASS STEELS LIMITED",
"BANAS FARMERS PRODUCER COMPANY LIMITED",
"BANAS FINANCE LIMITED",
"BANAS INFRA PROJECTS PRIVATE LIMITED",
"BANAS JEWELS LLP",
"BANAS MEDICAL COLLEGE & RESEARCH INSTITUTE PALANPUR",
"BANAS OIL MILL PRIVATE LIMITED",
"BANAS STONES PRIVATE LIMITED",
"BANAS TECHNOCHEM PRIVATE LIMITED",
"BANASHANKARI CHEMICALS PRIVATE LIMITED",
"BANASHANKARI INDUSTRIES PRIVATE LIMITED",
"BANASHANKARI PIPES PRIVATE LIMITED",
"BANASKANTHA DIST. CO.OP. MILK PRODUCERS UNION LIMITED",
"BANASKANTHA DISTRICT EDUCATION COMMITTEE MANAGED PRIMARY TEACHER",
"BANASTHALI VIDYAPITH",
"BANAVATHY POWER SYSTEMS PRIVATE LIMITED",
"BANAYANTREE SERVICES LIMITED",
"BANBRO METALS PVT.LTD.",
"BANBROS PROFESSIONALS PRIVATE LIMITED",
"BANBURY THE BEST",
"BANCA DI ROMA",
"BANCA SELLA S.P.A.",
"BANCHALIS PRINT PRIVATE LIMITED",
"BANCHHARAM FOOD PRODUCTS PRIVATE LIMITED",
"BANCO ALUMINIUM LIMITED",
"BANCO BILBAO VIZCAYA ARGENTARIA S.A.",
"BANCO CONSTRUCTION PRIVATE LIMITED",
"BANCO GASKETS INDIA LIMITED",
"BANCO PRODUCTS INDIA LIMITED",
"BANCSOL CORPORATE MANAGEMENT SERVICES PRIVATE LIMITED",
"BAND BOX ELECTRONICS PVT LTD",
"BANDA RICE INDUSTRIES PRIVATE LIMITED",
"BANDANA AGRO PRODUCTS PRIVATE LIMITED",
"BANDANA AUTOMOTIVE PRIVATE LIMITED",
"BANDANA INDUSTRIES PRIVATE LIMITED",
"BANDANA TRADE CONCERN PRIVATE LIMITED",
"BANDARAM PHARMA PACKTECH LIMITED",
"BANDARU MOTORS PRIVATE LIMITED",
"BANDAY IMPEX PRIVATE LIMITED",
"BANDEDGE TALENT AGENCY PRIVATE LIMITED",
"BANDEKAR BROTHERS PRIVATE LIMITED",
"BANDHAM MARKETING PRIVATE LIMITED",
"BANDHAN AGRITECH PRIVATE LIMITED",
"BANDHAN AMC LIMITED",
"BANDHAN BANK LIMITED",
"BANDHAN CERAMIC PRIVATE LIMITED",
"BANDHAN CONSULTANCY SERVICES OPC PRIVATE LIMITED",
"BANDHAN FARMERS PRODUCER COMPANY LIMITED",
"BANDHAN FINANCIAL HOLDINGS LIMITED",
"BANDHAN FINANCIAL SERVICES LIMITED",
"BANDHAN FOODS PRIVATE LIMITED",
"BANDHAN JEWELLERY (INDIA) PRIVATE LIMITED",
"BANDHAN KONNAGAR",
"BANDHAN LIFE SCIENCE PRIVATE LIMITED",
"BANDHAN PROTECTION AND INTELLIGENCE SERVICES PRIVATE LIMITED",
"BANDHAV RESORTS PRIVATE LIMITED",
"BANDHRAL CONSTRUCTIONS PRIVATE LIMITED",
"BANDHU MEDICAL HALL PRIVATE LIMITED",
"BANDHU TRAVELS PRIVATE LIMITED",
"BANDI PROJECTS PRIVATE LIMITED",
"BANDI SHREYAS KANNA TRADING PRIVATE LIMITED",
"BANDIT FILMS (OPC) PRIVATE LIMITED",
"BANDLA PUBLICATIONS PRIVATE LIMITED",
"BANDMA EQUIPCORP LIMITED",
"BANDMA INDIA PRIVATE LIMITED",
"BANDOJI KHANDOJI CHAVAN HIGH SCHOOL",
"BANDOOKWALA ISPAT PRIVATE LIMITED",
"BANDRA PAINT AGENCY PRIVATE LIMITED",
"BANDRA RENTALS PRIVATE LIMITED",
"BANDRA SOAP PRIVATE LIMITED",
"BANDRA SPIRIT DEPOT PRIVATE LIMITED",
"BANDRA URDU HIGH SCHOOL",
"BANDUKWALA SALES PRIVATE LIMITED",
"BANDWAGONS MULTITRADE PRIVATE LIMITED",
"BANDYWORKS SOLUTIONS PRIVATE LIMITED",
"BANEJOS DEVELOPMENT PRIVATE LIMITED",
"BANERA SALES PRIVATE LIMITED",
"BANERASOFT INDIA PRIVATE LIMITED",
"BANERJEE AUTO CORPORATION PRIVATE LIMITED",
"BANERJEE AUTOMOBILES PRIVATE LIMITED",
"BANERJEE DISTRIBUTORS PRIVATE LIMITED",
"BANERJEE HEALTH CARE SERVICES PRIVATE LIMITED",
"BANERJEE INN PRIVATE LIMITED",
"BANERJEE MEDICAL STORE",
"BANERJEE POULTRY PRIVATE LIMITED",
"BANERJEE RICE MILL PVT LTD",
"BANFICO INDIA PRIVATE LIMITED",
"BANG BANG FILMS PRIVATE LIMITED",
"BANG BANG MEDIACORP PRIVATE LIMITED",
"BANG DATA FORMS PRIVATE LIMITED",
"BANG DESIGN PRIVATE LIMITED",
"BANG EQUITY BROKING PRIVATE LIMITED",
"BANG FASHION PRIVATE LIMITED",
"BANG IN THE MIDDLE PRIVATE LIMITED",
"BANG OVERSEAS LIMITED",
"BANG PAPER & BOARDS PRIVATE LIMITED",
"BANG PAPERS PRIVATE LIMITED",
"BANG POLYWEAVE PRIVATE LIMITED",
"BANG RUBBER INDUSTRIES PRIVATE LIMITED",
"BANG SECURITIES PRIVATE LIMITED",
"BANG THE TABLE SOFTWARE PRIVATE LIMITED",
"BANGA HOSPITALS PRIVATE LIMITED",
"BANGA INTERNATIONAL",
"BANGA IRON AND STEEL PRIVATE LIMITED",
"BANGA LAXMI HOSIERY MILLS PVT LTD",
"BANGA LUXMI SOAP WORKS PVT LTD",
"BANGA SOLAR PRIVATE LIMITED",
"BANGABASHI MAIN COLLEGE",
"BANGABASI COLLEGE OF COMMERCE",
"BANGABHUMI RICE MILLS PRIVATE LIMITED",
"BANGAD STEELS PRIVATE LIMITED",
"BANGALI BABA FOODS PRIVATE LIMITED",
"BANGALORE AIR PRODUCTS PRIVATE LIMITED.",
"BANGALORE AIRCRAFT INDUSTRIES PRIVATE LIMITED",
"BANGALORE AIRPORT HOTEL LIMITED",
"BANGALORE ALLOY CASTINGS PRIVATE LIMITED",
"BANGALORE ANALYTICAL RESEARCH CENTER PRIVATE LIMITED",
"BANGALORE BAPTIST HOSPITAL",
"BANGALORE BIOTECH LABS PRIVATE LIMITED",
"BANGALORE BLUES ENTERTAINMENT INDIA PRIVATE LIMITED",
"BANGALORE BROADBAND NETWORK PRIVATE LIMITED",
"BANGALORE CABLES PRIVATE LIMITED",
"BANGALORE CITY COLLEGE OF NURSING",
"BANGALORE DATACOM PRIVATE LIMITED",
"BANGALORE DOR-TECH PRIVATE LIMITED",
"BANGALORE DRESS MANUFACTURING COMPANY PRIVATE LIMITED",
"BANGALORE ELECTRICITY SUPPLY COMPANY LIMITED",
"BANGALORE ELEVATED TOLLWAY PRIVATE LIMITED",
"BANGALORE ESTATES AND INVESTMENTS PRIVATE LIMITED",
"BANGALORE FLUID SYSTEM COMPONENTS PRIVATE LIMITED",
"BANGALORE FORT FARMS LIMITED",
"BANGALORE HITECH SERVICES PRIVATE LIMITED",
"BANGALORE HOME NEEDS DEPARTMENTAL STORES PRIVATE LIMITED",
"BANGALORE HOSPITAL KENGERI",
"BANGALORE HYDRO ENGINEERS AND CONSULTANTS PRIVATE LIMITED",
"BANGALORE INSTITUTE OF GASTROENTEROLOGY PRIVATE LIMITED",
"BANGALORE INSTITUTE OF ONCOLOGY",
"BANGALORE INSTITUTE OF TECHNOLOGY",
"BANGALORE INTEGRATED SYSTEM SOLUTIONS PRIVATE LIMITED",
"BANGALORE INTERNATIONAL AIRPORT LIMITED",
"BANGALORE INTERNATIONAL SCHOOL",
"BANGALORE MALLEABLE CASTINGS PRIVATE LIMITED",
"BANGALORE MALUR HIGHWAYS LIMITED",
"BANGALORE MECHATRONICS PRIVATE LIMITED",
"BANGALORE MEDICAL SYSTEMS PRIVATE LIMITED",
"BANGALORE METALLURGICALS PRIVATE LIMITED",
"BANGALORE METRO RAIL CORPORATION LIMITED.",
"BANGALORE METROPOLITANT TRANSPORT CORPORATION",
"BANGALORE MOTORS PRIVATE LIMITED",
"BANGALORE NORTH EDUCATION SOCIETY",
"BANGALORE ORTHOPAEDIC AND SURGICAL HOSPITAL",
"BANGALORE PAINTS LIMITED",
"BANGALORE PETROLEUM AND CHEMICALS PRIVATE LIMITED",
"BANGALORE PHARMACEUTICAL AND RESEARCH LABORATORY PRIVATE LIMITED",
"BANGALORE PLASTICS PRIVATE LIMITED",
"BANGALORE PROTECH CONTROLS PRIVATE LIMITED",
"BANGALORE REFINERY PRIVATE LIMITED",
"BANGALORE REGENCY DEVELOPERS PRIVATE LIMITED",
"BANGALORE RESORTS AND CLUBS PRIVATE LIMITED",
"BANGALORE SAFETY GLASSWORKS PRIVATE LIMITED",
"BANGALORE SCHOOL OF DESIGN",
"BANGALORE SILK AND SILICATES PRIVATE LIMITED",
"BANGALORE SOFTWARE SERVICES PRIVATE LIMITED",
"BANGALORE TECHNOMET PRIVATE LIMITED",
"BANGALORE TURF CLUB LIMITED",
"BANGALORE UNIVERSITY",
"BANGALORE VALVES PRIVATE LIMITED",
"BANGALORE VILLAS PRIVATE LIMITED",
"BANGALORE WATER SUPPLY AND SEWERAGE BOARD",
"BANGALORE WEST UROLOGISTS PRIVATE LIMITED",
"BANGDIWALA AGRO PRODUCTS PRIVATE LIMITED",
"BANGER TECH PRIVATE LIMITED",
"BANGERA OVERSEAS PRIVATE LIMITED",
"BANGERA PRODUCTS PRIVATE LIMITED",
"BANGERA SEAWORLD PRIVATE LIMITED",
"BANGGREEN VYAPAAR PVT. LTD.",
"BANGLA ENTERTAINMENT PRIVATE LIMITED",
"BANGLORE ELECTRICAL SUPPLYE COMPANY LIMITED",
"BANGLORE POLYCOTTERS PRIVATE LIMITED",
"BANGLORE POLYMERS PRIVATE. LIMITED.",
"BANGLORE SHIRT COMPANY PRIVATE LIMITED",
"BANGMETRIC SERVICES PRIVATE LIMITED",
"BANHEM SECURITIES PRIVATE LIMITED",
"BANI SANSAD PUBLISHING HOUSE PRIVATE LIMITED",
"BANICAL INFOTECH PRIVATE LIMITED",
"BANIK CHHABIGHAR PVT LTD",
"BANIK DYEING INDUSTRIES PRIVATE LIMITED",
"BANIK RETAIL PRIVATE LIMITED",
"BANIYA BEST SOLUTION PRIVATE LIMITED",
"BANIYA KI DUKAN PRIVATE LIMITED",
"BANJARA CAMPS AND RETREATS PRIVATE LIMITED",
"BANJARA HOSPITALITIES PRIVATE LIMITED",
"BANJOSH ASSOCIATES",
"BANK INTERNASIONAL INDONESIA",
"BANK NOTE PAPER MILL INDIA PRIVATE LIMITED",
"BANK OF AMERICA",
"BANK OF BAHRAIN AND KUWAIT",
"BANK OF BARODA",
"BANK OF CEYLON",
"BANK OF CHINA",
"BANK OF INDIA",
"BANK OF INDIA INVESTMENT MANAGERS PRIVATE LIMITED",
"BANK OF MAHARASHTA",
"BANK OF MAHARASHTRA",
"BANK OF NEW YORK MELLON CORP",
"BANK OF RAJASTHAN",
"BANKA BIOLOO LIMITED",
"BANKA BULLIONS PVT LTD",
"BANKA WOVEN SACKS PRIVATE LIMITED",
"BANKAA STEELS PRIVATE LIMITED",
"BANKE BEHARI CHEMICALS PRIVATE LIMITED",
"BANKE BEHARI COMPUTERS PRIVATE LIMITED",
"BANKE BEHARI FOODS PRIVATE LIMITED",
"BANKE BIHARI ASSOCIATES",
"BANKE BIHARI DEVELOPERS PRIVATE LIMITED",
"BANKE BIHARI OVERSEAS PRIVATE LIMITED",
"BANKE BIHARI PROCESS PRIVATE LIMITED",
"BANKE BIHARI ROADWAYS PRIVATE LIMITED",
"BANKE TRADECOM SERVICES PRIVATE LIMITED",
"BANKERS CARDIOLOGY PRIVATE LIMITED",
"BANKERS HEART & MULTI SPECIALITY HOSPITAL",
"BANKERS HEART INSTITUTE",
"BANKERS INSTITUTE OF RURAL DEVP",
"BANKEY BEHARI ENGINEERING PRIVATE LIMITED",
"BANKEY BIHARI CHAINS INDIA PRIVATE LIMITED",
"BANKEY BIHARI COMMODITIES PRIVATE LIMITED",
"BANKEY BIHARI INDUSTRIES PRIVATE LIMITED",
"BANKEY BIHARI INFRAHOMES PRIVATE LIMITED",
"BANKEY BIHARI LAMINATOR (INDIA) PRIVATE LIMITED",
"BANKEY BIHARI PACKAGING PRIVATE LIMITED",
"BANKEYBIHARI CONCAST PRIVATE LIMITED",
"BANKEYBIHARI PLYWOOD INDUSTRIES PRIVATE LIMITED",
"BANKIM PLAST PRIVATE LIMITED",
"BANKIM PROSAD GHOSH SEEDS PRIVATE LIMITED",
"BANKIM SARDAR COLLEGE",
"BANKIN PUNCH SYSTEMS PRIVATE LIMITED",
"BANKIT SERVICES PRIVATE LIMITED",
"BANKSATHI TECHNOLOGIES AND INSURANCE CORPORATE AGENCY PRIVATE LIMITED",
"BANKTECH SOFTWARE SERVICES PRIVATE LIMITED",
"BANKTESH CREATIONS PRIVATE LIMITED",
"BANKTESH UDYOG LIMITED",
"BANKTESH VANIJYA PRIVATE LIMITED",
"BANKURA AGRO FARMING PRIVATE LIMITED",
"BANKURA AGRO PROCESSING PVT LTD",
"BANKURA PROJECT PRIVATE LIMITED",
"BANKUTRAMANA BULLION AND DIAMOND PRIVATE LIMITED",
"BANMALA COMMERCIAL PVT.LTD.",
"BANMIT RAMA KRISHNA MARKETING PRIVATE LIMITED",
"BANMORE ELECTRICALS PVT LTD",
"BANMORE FOAM PRIVATE LIMITED",
"BANNA LAL JAT CONSTRUCTIONS PRIVATE LIMITED",
"BANNARI AMMAN AUTOMOBILES PRIVATE LIMITED",
"BANNARI AMMAN EXPORTS PRIVATE LIMITED",
"BANNARI AMMAN FLOUR MILL PRIVATE LIMITED",
"BANNARI AMMAN FOOD PRODUCTS PRIVATE LIMITED",
"BANNARI AMMAN INSTITUTE OF TECHNOLOGY",
"BANNARI AMMAN SPINNING MILLS LIMITED",
"BANNARI AMMAN SUGARS LIMITED",
"BANNARIAMMAN ENGINEERING INDUSTRIES PRIVATE LIMITED",
"BANNER ENGINEERING INDIA PRIVATE LIMITED",
"BANNERET TRADING PRIVATE LIMITED",
"BANNU AROGYADHA PRIVATE LIMITED",
"BANNUR INFRASTRUCTURES PRIVATE LIMITED",
"BANOX EXIM PRIVATE LIMITED",
"BANOX REALTY PRIVATE LIMITED",
"BANQUITY EQUIPMENT SOLUTION PRIVATE LIMITED",
"BANS AEROSOL PRIVATE LIMITED",
"BANSAGAR THERMAL POWER COMPANY LIMITED",
"BANSAL AGRO & TEA MANUFACTURE PVT LTD",
"BANSAL AGRO BEVERAGES PRIVATE LIMITED",
"BANSAL AGRO INDUSTRIES",
"BANSAL AGRO PRODUCTS PRIVATE LIMITED",
"BANSAL ALKALIES PRIVATE LIMITED",
"BANSAL ALLOYS AND CASTING PRIVATE LIMITED",
"BANSAL ALLOYS AND METALS PRIVATE LIMITED",
"BANSAL ARADHYA STEEL PRIVATE LIMITED",
"BANSAL ASSOCIATES PRIVATE LIMITED",
"BANSAL AUDIO-VISUAL SYSTEMS PRIVATE LIMITED",
"BANSAL AUTOMOTIVES PRIVATE LIMITED",
"BANSAL BALL AND ROLLER BEARINGS PRIVATE LIMITED",
"BANSAL BELT & BEARINGS PRIVATE LIMITED",
"BANSAL BRIGHT BAR INDUSTRIES PRIVATE LIMITED",
"BANSAL BROTHERS",
"BANSAL BUILDING MATERIALS PRIVATE LIMITED",
"BANSAL BUILDMART PRIVATE LIMITED",
"BANSAL CANVAS PRIVATE LIMITED",
"BANSAL CARGO MOVERS PRIVATE LIMITED",
"BANSAL CARRIERS PRIVATE LIMITED",
"BANSAL CLASSES PRIVATE LIMITED",
"BANSAL CLOTH STORES PVT LTD",
"BANSAL CNFS PRIVATE LIMITED",
"BANSAL COAL UDYOG PVT LTD",
"BANSAL COLOURS PRIVATE LIMITED",
"BANSAL COMMUNICATIONS PRIVATE LIMITED",
"BANSAL COMTRADE PRIVATE LIMITED",
"BANSAL CONDUCTORS PVT LTD",
"BANSAL CONSTRUCTION WORKS PRIVATE LIMITED",
"BANSAL CONTRACTORS PRIVATE LIMITED",
"BANSAL COTSPIN PRIVATE LIMITED",
"BANSAL CREATIONS PRIVATE LIMITED",
"BANSAL CREDITS LIMITED",
"BANSAL DISTRIBUTORS PRIVATE LIMITED",
"BANSAL DRUGS PRIVATE LIMITED",
"BANSAL DYECHEM PRIVATE LIMITED",
"BANSAL EARTHMOVERS PRIVATE LIMITED",
"BANSAL EDIBLE AND EXPORTS PRIVATE LIMITED",
"BANSAL ELASTOMERS PRIVATE LIMITED",
"BANSAL ELECTROVISION PRIVATE LIMITED",
"BANSAL ENDOCRINOLOGY & CLINICAL LAB",
"BANSAL ENGINEERS (GRAIN MILLING) PRIVATE LIMITED",
"BANSAL EXTRACTION AND EXPORTS PRIVATE LIMITED",
"BANSAL FINE FOODS PRIVATE LIMITED",
"BANSAL FINSTOCK PRIVATE LIMITED",
"BANSAL FLEXIPACK PRIVATE LIMITED",
"BANSAL FLOUR MILLS PRIVATE LIMITED",
"BANSAL FOODS INDIA",
"BANSAL FOREST PRODUCTS PRIVATE LIMITED",
"BANSAL GENERATIONS LIMITED",
"BANSAL GINNING AND PRESSING PRIVATE LIMITED",
"BANSAL HEALTHCURE PRIVATE LIMITED",
"BANSAL HIGHWAY INFRATECH PRIVATE LIMITED",
"BANSAL HI-TECH SYSTEMS PRIVATE LIMITED",
"BANSAL HOSPITAL",
"BANSAL IMPORTER PRIVATE LIMITED",
"BANSAL INFOTECH PRIVATE LIMITED",
"BANSAL INFRAPROJECTS PRIVATE. LIMITED.",
"BANSAL INSTITUTE OF ENGINEERING AND TECHNOLOGY",
"BANSAL INSULATION PRODUCTS PVT LTD",
"BANSAL IRON & STEEL ROLLING MILLS",
"BANSAL IRON PROCESSORS PRIVATE LIMITED",
"BANSAL KAITHAL PRIVATE LIMITED",
"BANSAL KRAFTS PRIVATE LIMITED",
"BANSAL LABORATORIES AND EQUIPMENTS PRIVATE LIMITED",
"BANSAL LUBRICANTS INDIA PRIVATE LIMITED",
"BANSAL LUMBERS PRIVATE LIMITED",
"BANSAL MARINE PRIVATE LIMITED",
"BANSAL MEDILAB PRIVATE LIMITED",
"BANSAL METALLICS (INDIA) PRIVATE LIMITED",
"BANSAL MILK CHILLING CENTRE PRIVATE LIMITED",
"BANSAL NATURAL RESOURCES PRIVATE LIMITED",
"BANSAL NATUREVEST LIMITED",
"BANSAL NURSING AND MATERNITY HOME PRIVATE LIMITED",
"BANSAL OIL MILL LTD.",
"BANSAL OVERSEAS INDIA PRIVATE LIMITED",
"BANSAL PAPERS PRIVATE LIMITED",
"BANSAL PAPERTUBE INDUSTRIES PRIVATE LIMITED",
"BANSAL PATHWAYS ( BETUL-CHICHOLI ) PRIVATE LIMITED",
"BANSAL PATHWAYS (GUNA-SIRONJ) PRIVATE LIMITED",
"BANSAL PATHWAYS (MANGAWAN-CHAKGHAT) PRIVATE LIMITED",
"BANSAL PATHWAYS DAMOH - KATNI PRIVATE LIMITED",
"BANSAL PATHWAYS HABIBGANJ PRIVATE LIMITED",
"BANSAL PATHWAYS PRIVATE LIMITED",
"BANSAL PETRO OIL PRIVATE LIMITED",
"BANSAL PHARMACHEM PVT LTD",
"BANSAL PLASTOPACK PRIVATE LIMITED",
"BANSAL PLYSALES COMPANY PRIVATE LIMITED",
"BANSAL POLES LIMITED",
"BANSAL POLES PRIVATE LIMITED",
"BANSAL POLYCAB PRIVATE LIMITED",
"BANSAL POLYPLAST PRIVATE LIMITED",
"BANSAL PRECISION FORGE PRIVATE LIMITED",
"BANSAL PRECISION SCREWS PRIVATE LIMITED",
"BANSAL RECYCLER PRIVATE LIMITED",
"BANSAL RIDES PRIVATE LIMITED",
"BANSAL ROADWAYS PVT LTD",
"BANSAL ROCKS PRIVATE LIMITED",
"BANSAL ROOFING PRODUCTS LIMITED",
"BANSAL RUGS PRIVATE LIMITED",
"BANSAL SALES CORPORATION PRIVATE LIMITED",
"BANSAL SEEDS PRIVATE LIMITED",
"BANSAL SHAREVEST SERVICES LIMITED",
"BANSAL SHIP BREAKERS PRIVATE. LIMITED.",
"BANSAL SHOES PRIVATE LIMITED",
"BANSAL SOLVENTS PRIVATE LIMITED",
"BANSAL SPINNING MILLS LIMITED",
"BANSAL SPINNING MILLS PRIVATE LIMITED",
"BANSAL STAMPING PRIVATE LIMITED",
"BANSAL STANMART (INDIA) PRIVATE LIMITED",
"BANSAL STARCH AND FOODS PRIVATE LIMITED",
"BANSAL STEEL & POWER LIMITED",
"BANSAL STEEL MANUFACTURING PRIVATE LIMITED",
"BANSAL STRIPS PVT LTD",
"BANSAL TEA PRODUCTS PRIVATE LIMITED",
"BANSAL TELE SHOP PRIVATE LIMITED",
"BANSAL TELECOM PVT LTD",
"BANSAL TEXCO PRIVATE LIMITED",
"BANSAL TEXFAB PRIVATE LIMITED",
"BANSAL TRADING COMPANY",
"BANSAL TRANSLOGISTIC SOLUTIONS PRIVATE LIMITED",
"BANSAL UDYOG PRIVATE LIMITED",
"BANSAL WINDMILLS PRIVATE. LIMITED.",
"BANSAL WIRE INDUSTRIES LIMITED",
"BANSAL WIRES PRIVATE LIMITED",
"BANSAL WOODDECOR PRIVATE LIMITED",
"BANSAL WOOLLENS PRIVATE LIMITED",
"BANSAL YARNS PRIVATE LIMITED",
"BANSARI COMPOSITES PRIVATE LIMITED",
"BANSHI AIRGASES PRIVATE LIMITED",
"BANSHI COTTON PRIVATE LIMITED",
"BANSHIDHAR AGRO COLD STORAGE PRIVATE LIMITED",
"BANSHIDHAR CONSTRUCTION PRIVATE LIMITED",
"BANSHIDHAR TOBACCO PRIVATE LIMITED",
"BANSI AUTOMOTIVE TYRES PRIVATE LIMITED",
"BANSI BUILDERS AND CONTRACTORS PRIVATE LIMITED",
"BANSI COLD STORAGE PVT LTD",
"BANSI FASHION PRIVATE LIMITED",
"BANSI OFFICE SOLUTIONS PRIVATE LIMITED",
"BANSI PULP AND PAPER MILLS PRIVATE LIMITED",
"BANSI SILK MILLS PRIVATE LIMITED",
"BANSIDHAR AGARWALLA & COMPANY PRIVATE LIMITED UNIT",
"BANSIDHAR BADRIDASS MODI PVT LTD",
"BANSIDHAR COTFIBRE INDUSTRIES PRIVATE LIMITED",
"BANSIDHAR ISPAT PRIVATE LIMITED",
"BANSIDHAR NIRMAN PRIVATE LIMITED",
"BANSIDHAR PETROLEUM PRIVATE LIMITED",
"BANSILAL LADURAM AGRAWAL AGRO STORAGES PRIVATE LIMITED",
"BANSILAL RAMNATH AGARWAL CHARITABLE TRUST",
"BANSIWALA FABRICS PRIVATE LIMITED",
"BANSIWALA REALTORS PRIVATE LIMITED",
"BANSIYA MINECHEM PRIVATE LIMITED",
"BANSON PHARMACEUTICALS PRIVATE LIMITED",
"BANSONS IMPEX PRIVATE LIMITED",
"BANSPANI IRON LTD",
"BANSURI HEALTHCARE PRIVATE LIMITED",
"BANSURI POLY PACK PRIVATE LIMITED",
"BANSWARA GARMENTS",
"BANSWARA SYNTEX LTD",
"BANTAIR INDIA PRIVATE LIMITED",
"BANTAM ENTERPRISES PRIVATE LIMITED",
"BANTECH WATER PRIVATE LIMITED",
"BANTHAR INDUSTRIAL POLLUTION CONTROL COMPANY",
"BANTHIA PLASTICS PRIVATE LIMITED",
"BANTHIA UNITRADE PRIVATE LIMITED",
"BANTIA FURNITURES PRIVATE LIMITED",
"BANTOM LABORATORIES PRIVATE LIMITED",
"BANTRA B B P C GIRLS HIGH SCHOOL",
"BANTWAL WAREHOUSING PRIVATE LIMITED",
"BANVARI FOODS PRIVATE LIMITED",
"BANWARI AROMAS PRIVATE LIMITED",
"BANWARI CHEMICALS PVT LTD",
"BANWARI ENTERPRISES PRIVATE LIMITED",
"BANWARI LALL ELECTRICALS PRIVATE LIMITED",
"BANWARI LOGISTICS AND SHIPPING CO P LIMITED",
"BANWARI TRADELINKS ( INDIA) PRIVATE LIMITED",
"BANWARILALS WOOD CRAFTS PRIVATE LIMITED",
"BANYAN CAPITAL ADVISORS LLP",
"BANYAN CORPORATE ADVISORS PRIVATE LIMITED",
"BANYAN DATA SERVICES INDIA PRIVATE LIMITED",
"BANYAN FINEFOODS INDIA PRIVATE LIMITED",
"BANYAN HOSPITAL PRIVATE LIMITED",
"BANYAN HYDRAULICS & PROJECTS PRIVATE LIMITED",
"BANYAN INDUSTRIES PRIVATE LIMITED",
"BANYAN MANAGEMENT SUPPORT SERVICES PRIVATE LIMITED",
"BANYAN NETFAQS PRIVATE LIMITED",
"BANYAN ROOTS ORGANICS PRIVATE LIMITED",
"BANYAN SUSTAINABLE WASTE MANAGEMENT PRIVATE LIMITED",
"BANYAN TOURS AND TRAVELS PRIVATE LIMITED",
"BANYAN TOURS PRIVATE LIMITED",
"BANYAN TREE ADVISORS PRIVATE LIMITED",
"BANYAN TREE EVENTS INDIA PRIVATE LIMITED",
"BANYAN TREE HOLDINGS PRIVATE LIMITED",
"BANYAN TREE SCHOOL",
"BANYAN TREE SCHOOLS PRIVATE LIMITED",
"BANYAN VENTURES & INVESTMENT PRIVATE LIMITED",
"BANYANTREE FINANCE PRIVATE LIMITED",
"BANZAI ESTATES PRIVATE LIMITED",
"BANZAI SOLUTIONS PRIVATE LIMITED",
"BAO THACH INTERNATIONAL (INDIA) PRIVATE LIMITED",
"BAOBAB CLEAN TECHNOLOGIES PRIVATE LIMITED",
"BAOSTEEL INDIA COMPANY PRIVATE LIMITED",
"BAOSTEEL SINGAPORE PTE LIMITED",
"BAP CREATIONS PRIVATE LIMITED",
"BAP EDUCARE PRIVATE LIMITED",
"BAPA RAWAL HR SEC SCH SAHA PHAKOTHA",
"BAPA SITARAM DIAMOND PRIVATE LIMITED",
"BAPA SITARAM EXPORT",
"BAPA SITARAM ROADLINES PRIVATE LIMITED",
"BAPA SITARAM SOLAR POWER PRIVATE LIMITED",
"BAPALAL KESHAVLAL JEWELS PRIVATE LIMITED",
"BAPASHREE AGRO PRIVATE LIMITED BAPL",
"BAPASHREE INFRASTRUCTURE PRIVATE LIMITED",
"BAPAT CONTROLS AND EQUIPMENT PRIVATE LIMITED",
"BAPAT ENGINEERS AND VALUERS PRIVATE LIMITED",
"BAPAT MULTI SPECIALITY HOSPITAL",
"BAPATLA ENGINEERING COLLEGE",
"BAPENDRAM SYSTEMS PRIVATE LIMITED",
"BAPHANA JEWELLERS PRIVATE LIMITED",
"BAPHANA WAREHOUSING PRIVATE LTD",
"BAPHANAS DIAMOND GALAXY PRIVATE LIMITED",
"BAPL INFRABUILD PRIVATE LIMITED",
"BAPL ROTOTECH PRIVATE LIMITED",
"BAPNA PROJECTS PRIVATE LIMITED",
"BAPNA SEEDS",
"BAPORIA GUM INDUSTRIES PRIVATE LIMITED",
"BAPS PRAMUKH SWAMI HOSPITAL SURAT",
"BAPS SHASTRIJI MAHARAJ HOSPITAL",
"BAPS SWAMINARAYAN VIDHYAMANDIR",
"BAPS YOGIJI MAHARAJ HOSPITAL",
"BAPTIST CHURCH TRUST ASSOCIATION",
"BAPUDHAM MILK PRODUCER COMPANY LIMITED",
"BAPUJI CHILD HEALTH INSTITUTE AND RESEARCH CENTRE",
"BAPUJI HOSPITAL",
"BAPUJI INSTITUTE OF ENGINEERING AND TECHNOLOGY",
"BAPUJI RURAL ENLIGHTENMENT AND DEVELOPMENT SOCIETY",
"BAPUNA ALCOBREW PRIVATE LIMITED",
"BAPURAO DESHMUKH PHYSICAL EDUCATION COLL",
"BAPU'S SHIPPING (JAMNAGAR) PRIVATE LIMITED",
"BAPU'S SHIPPING AGENCY PRIVATE LIMITED",
"BAR CODE INDIA LIMITED",
"BAR TECH SYSTEM AND AUTOMATIONS PRIVATE LIMITED",
"BARABANKI AUTO SALES AND SERVICE PRIVATE LIMITED",
"BARABANKI PLANNER & DEVELOPERS PRIVATE LIMITED",
"BARABANKI ZILA SAHAKARI BANK",
"BARABARI TEA AND ALLIED PRIVATE LIMITED",
"BARAD HOLDINGS AND PROPERTIES PVT LTD",
"BARAGARH HYDRO POWER CO.PRIVATE LIMITED",
"BARAHI MARKETING PRIVATE LIMITED",
"BARAK & BRAZOS ENGINEERING LLP",
"BARAK ISPAT PVT LTD",
"BARAK VALLEY CEMENTS LIMITED",
"BARAK VALLEY INFRA PRIVATE LIMITED",
"BARAK WAREHOUSE PVT LTD",
"BARAKA OVERSEAS TRADERS",
"BARAKAAT STEELS PRIVATE LIMITED",
"BARAKAH FOREX TOURS AND TRAVELS PRIVATE LIMITED",
"BARAKAR SREE MARWARI VIDYALAYA",
"BARAKATH ENGINEERING INDUSTRIES PRIVATE LIMITED",
"BARAKATH GARMENTS (INDIA) PRIVATE LIMITED",
"BARAL LOGISTICS PRIVATE LIMITED",
"BARALA HOSPITAL AND RESEARCH CENTRE",
"BARAMALI MUKHERJEE INSTITUTION",
"BARAMATI AGRO LIMITED",
"BARAMATI CATTLEFEEDS PVT LTD",
"BARAMATI ENGINEERING PVT LTD",
"BARAMATI HI-TECH TEXTILE PARK LTD",
"BARAMATI HOSPITALS PRIVATE LIMITED",
"BARAMATI INDUSTRIAL SERVICES PRIVATE LIMITED",
"BARAMATI INDUSTRIES PRIVATE LIMITED",
"BARAMATI METALLURGICAL PRIVATE LIMITED",
"BARAMATI SPECIALITY STEELS LIMITED",
"BARANI GLOBAL FORTUNES PRIVATE LIMITED",
"BARANI HYDRAULICS INDIA PRIVATE LIMITED",
"BARANI SILKS PRIVATE LIMITED",
"BARASAT CABLE TV NETWORK PRIVATE LIMITED",
"BARASAT EVENING COLLEGE",
"BARASAT GOVT COLLEGE",
"BARASAT INDIRA GANDHI MEMORIAL HIGH SCHOOL",
"BARASAT MILLENIUM SPIRAL CT SCAN AND DIAGNOSTIC PRIVATE LIMITED",
"BARASAT MUNICIPALITY",
"BARASAT VIVEKANANDA ADARSHA VIDYAPITH",
"BARASKAR INDUSTRIES PRIVATE LIMITED",
"BARATALA POALI HIGH SCHOOL HS",
"BARATH AGRI INTERNATIONAL TRADING PRIVATE LIMITED",
"BARATHY INDUSTRIES",
"BARBADOS MARITIME AGENCIES PRIVATE LIMITED",
"BARBARIK CABLE AND TRANSMISSION PRIVATE LIMITED",
"BARBARIK STEEL PRIVATE LIMITED",
"BARBARIK TIE-UP PRIVATE LIMITED",
"BARBARIK VENTURE (INDIA) PRIVATE LIMITED",
"BARBATE AUTOMOTIVE INDIA PRIVATE LIMITED",
"BARBEQUE NATION HOSPITALITY LIMITED",
"BARBEQUE VILLAE",
"BARBEQUE-NATION HOSPITALITY LIMITED",
"BARBIL MINING AND INDUSTRIES PRIVATE LIMITED",
"BARBREEK LOGISTIC PRIVATE LIMITED",
"BARBRIK PROJECT LIMITED",
"BARCELONA BAGS PRIVATE LIMITED",
"BARCLAYS BANK PLC",
"BARCLAYS GLOBAL SERVICE CENTRE PRIVATE LIMITED",
"BARCLAYS INVESTMENTS & LOANS (INDIA) PRIVATE LIMITED",
"BARCLAYS INVESTMENTS & LOANS INDIA LIMITED",
"BARCLAYS SECURITIES INDIA PRIVTAE LIMITED",
"BARCLAYS SHARED SERVICES PRIVATE LIMITED",
"BARCLAYS WEALTH TRUSTEES INDIA PRIVATE LIMITED",
"BARCO ELECTRONIC SYSTEMS PRIVATE LIMITED",
"BARCODE EXPERIENTIAL MARKETING LLP",
"BARCODE LOGISTICS PRIVATE LIMITED",
"BARCOM INDUSTRIES LIMITED",
"BARCOS HOSPITALITY INDIA PRIVATE LIMITED",
"BARCOSYS SOFTWARE INDIA PRIVATE LIMITED",
"BARD INDIA HEALTHCARE PRIVATE LIMITED",
"BARD INTERNATIONAL INC",
"BARDANWALA INDUSTRIES PRIVATE LIMITED",
"BARDAYS BANK",
"BARDHAMAN AGRO PRODUCTS (I) PRIVATE LIMITED",
"BARDHAMAN EDIBLE PRIVATE LIMITED",
"BARDHAMAN INSTITUTE OF MEDICAL SCIENCE PRIVATE LIMITED",
"BARDHAMAN RICE UDYOG PRIVATE LIMITED",
"BARDIYA CONSTRUCTION COMPANY PRIVATE LIMITED",
"BARDIYA CORPORATION PRIVATE LIMITED",
"BARDIYA REAL ESTATE DEVELOPERS PRIVATE LIMITED",
"BARDOLI URBAN DEVELOPMENT AUTHORITY(BUDA)",
"BARDOLIA TEXTILES PRIVATE LIMITED",
"BARDUARY FOODGRAIN PRODUCTS PRIVATE LIMITED",
"BARE ASSOCIATES INDIA PRIVATE LIMITED",
"BARE NECESSITIES ZERO WASTE SOLUTIONS PRIVATE LIMITED",
"BAREFOOT COLLEGE INTERNATIONAL",
"BAREFOOT RESORTS AND LEISURE PRIVATE LIMITED",
"BAREFOOT RETREATS AND LEISURE PRIVATE LIMITED",
"BAREILLY ADERSH AGROTECH PRODUCER COMPANY LIMITED",
"BAREILLY DEVELOPMENT AUTHORITY",
"BAREILLY LOGISTICS PRIVATE LIMITED",
"BAREILLY PHARMACEUTICALS PRIVATE LIMITED",
"BAREILLY PLYBOARDS PRIVATE LIMITED",
"BAREILLY PLYWOOD INDUSTRIES PRIVATE LIMITED",
"BAREILLY STONE CRUSHERS PRIVATE LIMITED",
"BAREILY CHEMICALS PRIVATE LIMITED",
"BARELIA COKE INDUSTRIES PVT. LTD.",
"BARENTZ INDIA PRIVATE LIMITED",
"BARFANI AGRO PRODUCTS PRIVATE LIMITED",
"BARFANI INFRATECH PRIVATE LIMITED",
"BARFANI TRADING PRIVATE LIMITED",
"BARFLEX POLYFILMS LIMITED",
"BARG MARINE & INDUSTRIAL PROJECTS PRIVATE LIMITED",
"BARGA INDIA PRIVATE LIMITED",
"BARGACHIA UNION PRIYANATH PATHSALA",
"BARGAIN TECHNOLOGIES PRIVATE LIMITED",
"BARGAIN TEXTILES PRIVATE LIMITED",
"BARGARH RICE MILLERS CONSORTIUM PRIVATE LIMITED",
"BARGEWORKS PRIVATE LIMITED",
"BARHONIA ENGICON PRIVATE LIMITED",
"BARI BUILDERS PRIVATE LIMITED",
"BARI FOODS PRIVATE LIMITED",
"BARI METAL FINISHERS PRIVATE LIMITED",
"BARIL DEVELOPERS PRIVATE LIMITED",
"BARING PRIVATE EQUITY PARTNERS (INDIA) PRIVATE LIMITED",
"BARISHA ASAR VIDYAPITH",
"BARISHA VIVEKANANDA HIGH SCHOOL HS",
"BARISTA COFFEE COMPANY LIMITED",
"BARITECH INFRA PRIVATE LIMITED",
"BARJATYA ENTERPRISES PRIVATE LIMITED",
"BARKAT CRANES AND EQUIPMENTS PRIVATE LIMITED",
"BARKAT EXPORTS PRIVATE LIMITED",
"BARKAT RAJ CAPITAL PRIVATE LIMITED",
"BARKAT TECHNOLOGIES PRIVATE LIMITED",
"BARKAT UDYOG PRIVATE LIMITED",
"BARKATULLAH UNIVERSITY BHOPAL",
"BARKAWI MANAGEMENT CONSULTANTS I P LIMITED",
"BARKHA IMAGE PRIVATE LIMITED",
"BARKYARD PRIVATE LIMITED",
"BARLAY PRODUCTS PRIVATE LIMITED",
"BARLEY LENTIL VITAMINS PRIVATE LIMITED",
"BARLIS LIFESCIENCES PRIVATE LIMITED",
"BARLOTA MEDICARE AND RESEARCH CENTRE PRIVATE LIMITED",
"BARMALT (INDIA) PRIVATE LIMITED",
"BARMALT INDIA PRIVATE LIMITED",
"BARMALT MALTING INDIA PRIVATE LIMITED",
"BARMAN DIABETES SPECIALITIES PRIVATE LIMITED",
"BARMAN POLY PACKERS PRIVATE LIMITED",
"BARMECHA ASSOCIATES (PERMOTORS) PRIVATE LIMITED",
"BARMECHA REALTY PRIVATE LIMITED",
"BARMECHA REFRIGERATION PVT LTD",
"BARMER LIGNITE MINING COMPANY LIMITED",
"BARMER POWER TRANSMISSION SERVICE LIMITED",
"BARMER THERMAL POWER COMPANY LIMITED",
"BARN CLOTHING PRIVATE LIMITED",
"BARNA INTERNATIONAL INDIA LIMITED",
"BARNALA BUILDERS & DEVELOPERS PRIVATE LIMITED",
"BARNALA PIPES PRIVATE LIMITED",
"BARNALA STEEL INDUSTRIES PRIVATE LIMITED",
"BARNDOOR PRODUCTIONS PRIVATE LIMITED",
"BARNEC BRAKE SYSTEM PRIVATE LIMITED",
"BARNES & NOBLE, INC.",
"BARNES INDUSTRIAL GROUP INDIA PRIVATE LIMITED",
"BARNES SCHOOL & JUNIOR COLLEGE",
"BARNET INDIA PRIVATE LIMITED",
"BARNETT POLYPET PRIVATE LIMITED",
"BARNIL CONSTRUCTIONS PRIVATE LIMITED",
"BARNWAL PROPERTIES PRIVATE LIMITED",
"BAROC TECHNOLOGIES PRIVATE LIMITED",
"BAROD HOSPITAL INDORE",
"BAROD MEDICARE & RESEARCH CENTRE PRIVATE LIMITED",
"BARODA AGENTS AND TRADING CO. PRIVATE LIMITED",
"BARODA AGRO CHEMICALS LIMITED",
"BARODA ASSET MANAGEMENT INDIA LIMITED",
"BARODA BNP PARIBAS ASSET MANAGEMENT INDIA PRIVATE LIMITED",
"BARODA CHEMIST PRIVATE LIMITED",
"BARODA CRICKET ASSOCIATION",
"BARODA CROWN HOLDINGS PRIVATE LIMITED",
"BARODA DAIRY",
"BARODA EQUIPMENT AND VESSELS PRIVATE LIMITED",
"BARODA EXTRUSION LIMITED",
"BARODA FLOWTECH PRIVATE LIMITED",
"BARODA GLOBAL SHARED SERVICES LIMITED",
"BARODA GUJARAT GRAMIN BANK",
"BARODA HEART INSTITUTE AND RESEARCH CENTRE",
"BARODA HEATUP CONTROLS PRIVATE LIMITED",
"BARODA HIGH SCHOOL",
"BARODA HI-TECH ALLOYS PRIVATE LIMITED",
"BARODA INDUSTRIAL ELECTRICAL PRODUCTS PRIVATE LIMITED",
"BARODA INDUSTRIES PRIVATE LIMITED",
"BARODA INFORMATICS PRIVATE LIMITED",
"BARODA LIFE MANAGEMENT PRIVATE LIMITED",
"BARODA MACHINERY MANUFACTURERS PVT LTD",
"BARODA MEDICARE PRIVATE LIMITED",
"BARODA METAL STAMPING ENGINEERS PRIVATE LIMITED",
"BARODA PESTIPACK PRIVATE LIMITED",
"BARODA PHARMA PVT LTD",
"BARODA PIONEER MUTUAL FUND",
"BARODA POLYFORM PVT LTD",
"BARODA STEELCAST PRIVATE LIMITED",
"BARODA TAXI CABS PRIVATE LIMITED",
"BARODA U.P.BANK",
"BAROM LOGISTICS PRIVATE LIMITED",
"BAROMETER TECHNOLOGIES PRIVATE LIMITED",
"BARON AVIATION & ALLIED SERVICES PRIVATE. LIMITED.",
"BARON CYBERTECH PRIVATE LIMITED",
"BARON ELCTRONICS PRIVATE LIMITED",
"BARON FOODS PRIVATE LIMITED",
"BARON LEATHER PRIVATE LIMITED",
"BARON LUXURY AND LIFESTYLES PRIVATE LIMITED",
"BARON MINERALS PRIVATE LIMITED",
"BARONE BUDGE AND DOMINICK INDIA PRIVATE LIMITED",
"BARONS AGRICORE PRIVATE LIMITED",
"BAROOAHS AND ASSOCIATES PVT LTD",
"BAROOWA BROTHERS PVT LTD",
"BAROPHAR MARKETING PVT LTD",
"BAROQUE PHARMACEUTICALS PRIVATE LIMITED",
"BAROTA FINANCE LIMITED",
"BAROULIYA FRAGRANCIA PRIVATE LIMITED",
"BARPETA AGROTECH PRIVATE LIMITED",
"BARPHANI CARD COMMERCE PRIVATE LIMITED",
"BARQ GENERAL TRADING PRIVATE LIMITED",
"BARRABAZAR LOGISTICS PRIVATE LIMITED",
"BARRABAZAR TRANSPORT COMPANY PRIVATE LIMITED",
"BARRACKPORE PARK ROAD CHRISTIAN EDUCATION SOCIETY",
"BARRACKPORE RASTRAGURU SURANDRANATH COLL",
"BARRACUDA NETWORKS INDIA PRIVATE LIMITED",
"BARRAGE CONSTRUCTION DIVISION IST",
"BARRAISER PRIVATE LIMITED",
"BARRET COMMODITY TRADERS PRIVATE LIMITED",
"BARRIER FILMS PRIVATE LIMITED",
"BARRIER PACKAGING PVT LTD",
"BARRIERBREAK SOLUTIONS PRIVATE LIMITED",
"BARRINA IMPEX (INDIA) PRIVATE LIMITED",
"BARRIX AGRO SCIENCES PRIVATE LIMITED",
"BARRLA SYSTEMS PRIVATE LIMITED",
"BARRON PLASTICS PRIVATE LIMITED",
"BARROS ENTERPRISES PRIVATE LIMITED",
"BARRY CALLEBAUT COCOA & CHOCOLATE INGREDIENTS INDIA PRIVATE",
"BARRY CALLEBAUT INDIA PRIVATE LIMITED",
"BARRY-WEHMILLER INTERNATIONAL PRIVATE LIMITED",
"BARSAN GLOBAL LOGISTICS PRIVATE LIMITED",
"BARSANA FOODS PRIVATE LIMITED",
"BARSANA PROPERTIES PRIVATE LIMITED",
"BARSCAN SYSTEMS & RIBBONS PRIVATE LIMITED",
"BARSHA FERRO ALLOYS PRIVATE LIMITED",
"BARSOL TECHNOLOGY PRIVATE LIMITED",
"BARSOLUTIONS LLP",
"BARSONS DEVELOPERS PRIVATE LIMITED",
"BARSPELL TECHNOLOGIES INDIA PRIVATE LIMITED",
"BARTAKKE ELECTROFAB PRIVATE LIMITED",
"BARTAMAN (SOUTH BENGAL)PRIVATE LIMITED.",
"BARTAMAN MAGAZINES PRIVATE LIMITED",
"BARTAMAN PRIVATE LIMITED",
"BARTEC INDIA PRIVATE LIMITED",
"BARTECH DATA SYSTEMS PRIVATE LIMITED",
"BARTERSPHERE TRADING PRIVATE LIMITED",
"BARTLEBY TECHNOLOGIES PRIVATE LIMITED",
"BARTON BREEZE PRIVATE LIMITED",
"BARTON FIRTOP ENGINEERING INDIA PRIVATE LIMITED",
"BARTON SON & CO PRIVATE LIMITED",
"BARTRONICS INDIA LIMITED",
"BARUA AND COMPANY PRIVATE LIMITED",
"BARUAH MOTORS PRIVATE. LIMITED.",
"BARUANAGAR TEA ESTATES PRIVATE LIMITED",
"BARUAPARA SK TEA FACTORY PRIVATE LIMITED",
"BARUCH BUSINESS SOLUTIONS INDIA PRIVATE LIMITED",
"BARUNI PROPERTIES PRIVATE LIMITED",
"BARVALIYA WEAVES PRIVATE LIMITED",
"BARWA ADDA EXPRESSWAY LIMITED",
"BARWA MOBLINK LLP",
"BARWAHA TRANSPORT PRIVATE LIMITED",
"BARWIN SHIPPING CO. PRIVATE LIMITED",
"BARYON INFO SOLUTION PRIVATE LIMITED",
"BARYONS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"BARYTON PHARMA PRIVATE LIMITED",
"BAS SHIPPING PRIVATE LIMITED",
"BASA INFRA-BLOCKS PRIVATE LIMITED",
"BASA SILK MILLS PVT LTD",
"BASAI AGROTECH PRIVATE LIMITED",
"BASAK BOTTLING PLANT PRIVATE LIMITED",
"BASAK HOSIERY OPC PRIVATE LIMITED",
"BASALT TOWNS PLANNERS PRIVATE LIMITED",
"BASAN EQUITY BROKING LIMITED",
"BASANT AGRO-TECH INDIA LIMITED",
"BASANT ART PRIVATE LIMITED",
"BASANT BETONS",
"BASANT CABLES & CONDUCTORS PVT LTD",
"BASANT CITY CENTRE MALLS PRIVATE LIMITED",
"BASANT CLEANENVIRO LIMITED",
"BASANT COAL AND COKE PRIVATE LIMITED",
"BASANT DIGITAL SOLUTIONS PRIVATE LIMITED",
"BASANT ENTERPRISES PRIVATE LIMITED",
"BASANT ENTREPRENEUR PRIVATE LIMITED",
"BASANT ENVELOPES-N- PRINT LIMITED",
"BASANT FIBERTEK PRIVATE LIMITED",
"BASANT FLOORING PRIVATE LIMITED",
"BASANT FOOTWEARS PRIVATE LIMITED",
"BASANT FOREX PRIVATE LIMITED",
"BASANT GLOBAL TRADE PRIVATE LIMITED",
"BASANT INFRABUILD PRIVATE LIMITED",
"BASANT LOGISTICS PRIVATE LIMITED",
"BASANT NATURAL STONES PRIVATE LIMITED",
"BASANT PROJECTS LIMITED",
"BASANT PROPERTIES LTD.",
"BASANT RUBBER FACTORY PRIVATE LIMITED",
"BASANT SALES PRIVATE LIMITED",
"BASANT SECURITIES PRIVATE LIMITED",
"BASANT TEXFAB PRIVATE LIMITED",
"BASANT VANIJYA LIMITED",
"BASANT VIHAR HOTELS PRIVATE LIMITED",
"BASANTI AUTO AGENCY PRIVATE LIMITED",
"BASANTI CONFECTIONERS PRIVATE LIMITED",
"BASANTI DEVI RICE MILL PRIVATE LIMITED",
"BASANTI MATA AGRI PRODUCT PRIVATE LIMITED",
"BASANTI PROPERTIES PVT LTD",
"BASANTI REALTORS PRIVATE LIMITED",
"BASANTI SAREES PVT LTD",
"BASANTI SWEETS & SNACKS PRIVATE LIMITED",
"BASANTIPUR TEA CO PVT LTD",
"BASANTLAL BANARSILAL PRIVATE LIMITED",
"BASANTSING AMIL DHARMADA TRUST SCHOOL BUILDING",
"BASAR EXPORTS PRIVATE LIMITED",
"BASAR STEEL PRIVATE LIMITED",
"BASAVA INTERNATIONAL SCHOOL",
"BASAVATARAKAM INDO AMERICAN CANCER HOSPITAL & RESEARCH",
"BASAVESHWAR ELECTRICALS PRIVATE LIMITED",
"BASAVESHWAR SUGAR & ALLIED INDUSTRIES PRIVATE LIMITED",
"BASAWA TECHNOLOGIES LIMITED",
"BASBHUMI REALTORS PRIVATE LIMITED",
"BASCA MOTOR WORKS LLP",
"BASCO FOODS (INDIA) PRIVATE LIMITED",
"BASCO TOOL PRIVATE LIMITED",
"BASE AUTOMATION TECHNOLOGIES P LIMITED",
"BASE CATALYST PRIVATE LIMITED",
"BASE COMPUTERS PRIVATE LIMITED",
"BASE FUMIGATION PRIVATE LIMITED",
"BASE HOSPITAL DELHI CANTT",
"BASE INFORMATION MANAGEMENT PRIVATE LIMITED",
"BASE INFRA ENGINEERS PRIVATE LIMITED",
"BASE METAL CHEMICALS",
"BASE METAL CHLORINATIONS PRIVATE LIMITED",
"BASE PHARMACEUTICALS PRIVATE LIMITED",
"BASE PU COLLEGE",
"BASE REALTY PRIVATE LIMITED",
"BASE VICTUALLING YARD MUMBAI",
"BASE4 ARCHITECTS AND ENGINEERS PRIVATE LIMITED",
"BASECAMP STARTUPS PRIVATE LIMITED",
"BASEL NETWORK SOLUTIONS PRIVATE LIMITED",
"BASELINE IT DEVELOPMENT PRIVATE LIMITED",
"BASELINE PROJECTS & CONSTRUCTIONS PRIVATE. LIMITED",
"BASELINE VENTURES (INDIA) PRIVATE LIMITED",
"BASELIUS COLLEGE",
"BASELL POLYOLEFINS INDIA PRIVATE LIMITED",
"BASERA CITYDEVELOPERS PRIVATE LIMITED",
"BASERA ENCLAVE MAKERS PRIVATE LIMITED",
"BASERA LAND PVT LTD",
"BASEX ADHESIVE INDIA PRIVATE LIMITED",
"BASF CATALYSTS INDIA PRIVATE LIMITED",
"BASF CHEMICALS INDIA PRIVATE LIMITED",
"BASF INDIA LIMITED",
"BASH HEAL HOME HEALTH CARE SERVICES PRIVATE LIMITED",
"BASHGO MAINTENANCE SERVICES PRIVATE LIMITED",
"BASHIR OIL MILLS",
"BASHKO ENGINEERING PVT LTD",
"BASHO REALTORS PRIVATE LIMITED",
"BASHYAM GRAPHIC TECHNOLOGIES PRIVATE LIMITED",
"BASIC CHEMICALS COSMETICS & DYES EXPORT PROMOTION COUNCIL",
"BASIC CLOTHING PRIVATE LIMITED",
"BASIC EDUCATION DEPARTMENT",
"BASIC ENGINEERING PRIVATE LIMITED",
"BASIC FINANCIAL SERVICES PRIVATE LIMITED",
"BASIC GARMENTS FASHION INDIA PRIVATE LIMITED",
"BASIC HITECH FURNITURE PRIVATE LIMITED",
"BASIC INDIA LIGHTING PRIVATE LIMITED",
"BASIC MARKETING AND CONSULTANCY PRIVATE LIMITED",
"BASIC NEEDS HOMEWARE PRIVATE LIMITED",
"BASIC PHARMA LIFE SCIENCE PRIVATE LIMITED",
"BASIC SANITATIONS PRIVATE LIMITED",
"BASIC SECURITY NETWORK PRIVATE LIMITED",
"BASIC SHIKSHA PARISHAD",
"BASIC TRAINING AND RELATED INSTRUCTION CENTRE",
"BASIC-4 ADVERTISING PRIVATE LIMITED",
"BASICS TECHNO SERVICES PRIVATE LIMITED",
"BASIK INNOVATION LLP",
"BASIK MARKETING PRIVATE LIMITED",
"BASIL COMMODITIES PRIVATE LIMITED",
"BASIL COMMUNICATIONS PRIVATE LIMITED",
"BASIL DRUGS AND PHARMACEUTICALS PRIVATE LIMITED",
"BASIL HOTELS PRIVATE LIMITED",
"BASIL NATURAL TECHNICALLY SPECIFIED RUBBER PRIVATE LIMITED",
"BASIL PROMPT VINYL PRIVATE LIMITED",
"BASIL SWEET WATER PRIVATE LIMITED",
"BASILEIA SHIPPING AND LOGISTICS PRIVATE LIMITED",
"BASILIC FLY STUDIO LIMITED",
"BASILIC FLY STUDIO PRIVATE LIMITED",
"BASILICA REALCON PRIVATE LIMITED",
"BASILLIA ORGANICS PRIVATE LIMITED",
"BASILS INDIA PRIVATE LIMITED",
"BASILTREE CONSULTING PRIVATE LIMITED",
"BASIS EXPERT CONSULTING SERVICES PRIVATE LIMITED",
"BASIS LABORATORIES PRIVATE LIMITED",
"BASIS MOLD INDIA PRIVATE LIMITED",
"BASIX ACADEMY FOR BUILDING LIFELONG EMPLOYABILITY LIMITED",
"BASIX EDUCATION PRIVATE LIMITED",
"BASIX ENGINEERING INDIA",
"BASIX HOME FURNITURE PRIVATE LIMITED",
"BASIX MUNICIPAL WASTE VENTURES LIMITED",
"BASIZ FUND SERVICE PRIVATE LIMITED",
"BASIZ FUND SERVICE PRIVATE LIMITED.",
"BASK ENERGY SYSTEMS INDIA PRIVATE LIMITED",
"BASK FASHIONS INDIA PRIVATE LIMITED",
"BASKET OPTION PRIVATE LIMITED",
"BASMATH AGRO VENTURES INDIA PRIVATE LIMITED",
"BASONS INVESTMENTS PRIVATE LIMITED",
"BASPA ENTERPRISES",
"BASR FINE CHEMICALS PRIVATE LIMITED",
"BASRUR UNISEAL PRIVATE LIMITED",
"BASS METAL PRIVATE LIMITED",
"BASS PHARMA DISTRIBUTORS PRIVATE LIMITED",
"BASSEIN CATHOLIC COOPERATIVE BANK LIMITED",
"BASSI ALLOYS PVT LTD",
"BASSI LOGISTICS PRIVATE LIMITED",
"BASSI NURSING HOME PRIVATE LIMITED",
"BASSI STEELS PRIVATE LIMITED",
"BASSI TUBES PRIVATE LIMITED",
"BASSS INFRA PRIVATE LIMITED",
"BASSURE SOLUTIONS PRIVATE LIMITED",
"BASTAR AUTO PRIVATE LIMITED",
"BASTAR DAIRY FARM PRIVATE LIMITED",
"BASTAR INFRASTRUCTURE ENGINEERING SERVICES PRIVATE LIMITED",
"BASTAR RAILWAY PRIVATE LIMITED",
"BASTEX CONSULTANCY SERVICES PRIVATE LIMITED",
"BASTIAN ADVISORY SERVICES PRIVATE LIMITED",
"BASTIAN HOSPITALITY PRIVATE LIMITED",
"BASTIAN SOLUTIONS INDIA PRIVATE LIMITED",
"BASTIRAM NARAYANDAS SARDA PRIVATE LIMITED",
"BASU AGROFARMS PRIVATE LIMITED",
"BASU AUTOMOBILES (INDIA) PRIVATE LIMITED",
"BASU BUSINESS SOLUTIONS INDIA PRIVATE LIMITED",
"BASU CHICKS AND FEED PRIVATE LIMITED",
"BASU HATCHERIES PRIVATE LIMITED",
"BASU JUTEX PRIVATE LIMITED",
"BASU PUMPS & PROJECTS PRIVATE LIMITED",
"BASU SEA FOOD PRIVATE LIMITED",
"BASUBARAL SARASWATI VIHAR SENIOR SECONDARY SCHOOL",
"BASUDEB AUTO LIMITED",
"BASUDEB ENGINEERING ENTERPRISES LIMITED",
"BASUDEBPUR CHAKBRINDABANPUR TS",
"BASUDEO ENTERPRISES PRIVATE LIMITED",
"BASUDEV LOGISTICS TRANSPORT PRIVATE LIMITED",
"BASUDEV MOTORS PRIVATE LIMITED",
"BASUDEV OIL FIELD SERVICES",
"BASUDEV WOOD PRIVATE LIMITED",
"BASUDHA COKE (INDIA) PRIVATE LIMITED",
"BASUKI CIVIL PROJECTS PRIVATE LIMITED",
"BASUKI COMMOTRADE PRIVATE LIMITED",
"BASUKI FABRICS PRIVATE LIMITED",
"BASUKI SALES AND SERVICES PRIVATE LIMITED",
"BASUKI STEELS PRIVATE LIMITED",
"BASUKINATH AGRI TRADE PRIVATE LIMITED",
"BASUKINATH PROPERTIES PVT LTD",
"BASUNDHARA PADDY PROCESSORS PRIVATE LIMITED",
"BASU'S CLINIC HEALTH CARE PRIVATE LIMITED",
"BASUSHREE DIE CASTINGS PVT LTD",
"BASWARE INDIA PRIVATE LIMITED",
"BASWESHWARA PRE UNIVERSITY COLLEGE",
"BAT INDIA PRIVATE LIMITED",
"BAT LOGISTICS SOLUTIONS PRIVATE LIMITED",
"BATA INDIA LIMITED",
"BATA PROPERTIES LTD",
"BATALIK LOGISTICS PRIVATE LIMITED",
"BATAVIA EXIM PRIVATE LIMITED",
"BATAVIA PHARMA PRIVATE LIMITED",
"BATCASH FOREX PRIVATE LIMITED",
"BATCHMASTER SOFTWARE PRIVATE LIMITED",
"BATCO INTEGRATED LOGISTICS PRIVATE LIMITED",
"BATCOTRANS LOGISTICS PRIVATE LIMITED",
"BATELI TEA CO LTD",
"BATEMAN ENGINEERING INDIA PRIVATE LIMITED",
"BATES INDIA PRIVATE LIMITED",
"BATH PALACE DISTRIBUTORS PRIVATE LIMITED",
"BATH SELECTION PRIVATE LIMITED",
"BATH TOUCH METALS PRIVATE LIMITED",
"BATHCO CERAMIC LLP",
"BATHFITT SANITARY WARES PVT LTD",
"BATHINDA AUTOMOBILES PRIVATE LIMITED",
"BATHINDA HEALTH CARE PRIVATE LIMITED",
"BATHINDA INDUSTRIAL GASES PVT LTD",
"BATHINI GREENLANDS & INFRA PROJECTS PRIVATE LIMITED",
"BATHLA ALUMINIUM PRIVATE LIMITED",
"BATHLA INDUSTRIES PRIVATE LIMITED",
"BATHLA MINERALS PRIVATE LIMITED",
"BATHLA TELETECH PRIVATE LIMITED",
"BATHLA TRADING AGENCY PRIVATE LIMITED",
"BATHSHA MARINE EXPORTS PRIVATE LIMITED",
"BATHWAL PLASTICS LTD",
"BATHWAL SERVICES PRIVATE LIMITED",
"BATHWAL TRADECOM PRIVATE LIMITED",
"BATHWELL IMPEX PRIVATE LIMITED",
"BATI NORTH INDIA PRIVATE LIMITED",
"BATIMAT INSULATIONS PRIVATE LIMITED",
"BATISA PRIMARY SCHOOL",
"BATISH CHEMICALS INDIA PRIVATE LIMITED",
"BATISH TECHNOLOGIES PRIVATE LIMITED",
"BATLIBOI ENVIRONMENTAL ENGINEERING LIMITED.",
"BATLIBOI IMPEX LIMITED",
"BATLIBOI INTERNATIONAL LIMITED",
"BATLIBOI LIMITED",
"BATLIBOI RENEWABLE ENERGY SOLUTIONS PRIVATE LIMITED",
"BATLIVALA & KARANI CAPITAL PRIVATE LIMITED",
"BATLIVALA & KARANI SECURITIES INDIA PRIVATE LIMITED",
"BATOI SYSTEMS PRIVATE LIMITED",
"BATON-UBIXI SYSTEMS INDIA PRIVATE LIMITED",
"BATOT HYDRO POWER LIMITED",
"BATRA AND BATRA PRIVATE LIMITED",
"BATRA ASSOCIATES LIMITED",
"BATRA AUTO COMPANY",
"BATRA BANQUETS PRIVATE LIMITED",
"BATRA BROS FOOD AND BEVERAGES PRIVATE LIMITED",
"BATRA BROTHERS PRIVATE LIMITED",
"BATRA BUSINESSES PRIVATE LIMITED",
"BATRA GARMENTS PRIVATE LIMITED",
"BATRA JEWELS PRIVATE LIMITED",
"BATRA LOGISTICS PRIVATE LIMITED",
"BATRA MARKETING PRIVATE LIMITED",
"BATRA PACKERS PRIVATE LIMITED",
"BATRA SILK MILLS PRIVATE LIMITED",
"BATRA TIMBER PRIVATE LIMITED",
"BATRA YARNS PVT LTD",
"BATRAS VISION (OPC) PRIVATE LIMITED",
"BATT HYDRO POWER AND CONSTRUCTIONS PRIVATE LIMITED",
"BATTEN SECURITY PRIVATE LIMITED",
"BATTERY CENTRE PVT LTD",
"BATTLE KRAFTS PRIVATE LIMITED",
"BATTREELECTRIC MOBILITY PRIVATE LIMITED",
"BATTULAL JEWELLERS PRIVATE LIMITED",
"BATUKBHAI SONS JEWELLERS",
"BAUENAD INTERACTIVE PRIVATE LIMITED",
"BAUER CORPORATE SERVICES PRIVATE LIMITED",
"BAUER ENGINEERING INDIA PRIVATE LIMITED",
"BAUER EQUIPMENT INDIA PRIVATE LIMITED",
"BAUER KOMPRESSOREN INDIA PRIVATE LIMITED",
"BAUHAUS DESIGN SOLUTIONS LLP",
"BAULAAS EXIM PRIVATE LIMITED",
"BAULI INDIA BAKES & SWEETS PRIVATE LIMITED",
"BAUMANN SPRINGS & COATING PRIVATE LIMITED",
"BAUMER INDIA PRIVATE LIMITED",
"BAUMER TECHNOLOGIES INDIA PRIVATE LIMITED",
"BAUMULLER INDIA PRIVATE LIMITED",
"BAUNWERT ADVISORS PRIVATE LIMITED",
"BAUSCH & LOMB INDIA PRIVATE LIMITED",
"BAVA TRAVEL POINT PRIVATE LIMITED",
"BAVANE JEWELLERS PRIVATE LIMITED",
"BAVANI SECURITY & NIGHT PATROL PRIVATE LIMITED",
"BAVARIA MOTORS PRIVATE LIMITED",
"BAVDA PHARMACEUTICALS PRIVATE LIMITED",
"BAVIKARA CONSTRUCTIONS PRIVATE LIMITED",
"BAVIS TECHNOLOGIES PRIVATE LIMITED",
"BAVISCON TIE-UP PRIVATE LIMITED",
"BAVISHI FERTILITY INSTITUTE PRIVATE LIMITED",
"BAVTAWALA IRON & STEELS PRIVATE LIMITED",
"BAVYA HEALTH SERVICES PRIVATE LIMITED",
"BAWA AUTO DEALERS PRIVATE LIMITED",
"BAWA CLEARING AND FORWARDING PRIVATE LIMITED",
"BAWA DITTA MAL PARSHOTAM DASS PRIVATE LIMITED",
"BAWA EMBRO PRIVATE LIMITED",
"BAWA FLOAT GLASS LIMITED",
"BAWA H P ENGINEERING PRODUCTS PVT LTD",
"BAWA ICE AND COLD STORAGE PRIVATE LIMITED",
"BAWA INDUSTRIES PRIVATE LIMITED",
"BAWA JEWELLERS PRIVATE LIMITED",
"BAWA LALVANI PUBLIC SCHOOL",
"BAWA MASALA COMPANY PRIVATE LIMITED",
"BAWA PAINTS JAMMU PRIVATE LIMITED",
"BAWA PAINTS PRIVATE LIMITED",
"BAWALI ESTATES PRIVATE LIMITED",
"BAWANA INFRA DEVELOPMENT PRIVATE LIMITED",
"BAWANA PLAST INDUSTRIES PRIVATE LIMITED",
"BAWANA PLAST PRIVATE LIMITED",
"BAWASONS HOLDINGS PRIVATE LIMITED",
"BAWEJA MOVIES PRIVATE LIMITED",
"BAWEJA STUDIOS LIMITED",
"BAWEJA TEXFAB PRIVATE LIMITED",
"BAWHANJIBHAI CHAWHAN HIGH SCHOOL AND JR COLLAGE",
"BAXOM HEALTHCARE PRIVATE LIMITED",
"BAXTER HEALTHCARE FAR EAST PTE LIMITED",
"BAXTER INDIA PRIVATE LIMITED",
"BAXTER INNOVATIONS AND BUSINESS SOLUTIONS PRIVATE LIMITED",
"BAXTER INTERNATIONAL INC.",
"BAXTER PHARMACEUTICALS INDIA PRIVATE LIMITED",
"BAXTURE TECHNOLOGIES PRIVATE LIMITED",
"BAXY LIMITED",
"BAY AREA ADVANCED ANALYTICS INDIA PRIVATE LIMITED",
"BAY CAPITAL ADVISORS PRIVATE LIMITED",
"BAY CAPITAL INVESTMENT ADVISORS PRIVATE LIMITED",
"BAY CONTAINER TERMINAL P LIMITED",
"BAY DATACOM SOLUTIONS PRIVATE LIMITED",
"BAY INFOTECH PRIVATE LIMITED",
"BAY ISLANDS HOTELS LIMITED",
"BAY LEAF INTEGRATED COMMUNICATION SOLUTIONS LLP",
"BAY LEAF WELLNESS PRIVATE LIMITED",
"BAY PETROPLAST PVT LTD",
"BAY TANKERS PRIVATE LIMITED",
"BAY WATCH TRAVELS PRIVATE LIMITED",
"BAY81 STUDIO PRIVATE LIMITED",
"BAYA LOGISOLUTIONS PRIVATE LIMITED",
"BAYAHUT FOODS AND DISPOSABLES PRIVATE LIMITED",
"BAYAN GALIAN ORES PRIVATE LIMITED",
"BAYARD AGRO SCIENCES PRIVATE LIMITED",
"BAYAREA TERMINALS LLP",
"BAYARI VENTURES PRIVATE LIMITED",
"BAYATREE INFOCOMM.PRIVATE.LIMITED",
"BAYAWEAVER LIMITED",
"BAYBERRY PHARMACEUTICALS PRIVATE LIMITED",
"BAYER BIOSCIENCE PRIVATE LIMITED",
"BAYER CROPSCIENCE LIMITED",
"BAYER FOUNDATION INDIA",
"BAYER INVESTMENTS INDIA PRIVATE LIMITED",
"BAYER PHARMACEUTICALS PRIVATE LIMITED",
"BAYER VAPI PRIVATE LIMITED",
"BAYER ZYDUS PHARMA PRIVATE LIMITED",
"BAYERISCHE GESELLSCHAFT FUR INTERNATIONAL WIRTSCHAFTSBEZ MBH - BAYERN INTERNATIONAL",
"BAYFIELD FOOD INGREDIENTS PRIVATE LIMITED",
"BAY-FORGE PRIVATE LIMITED",
"BAYHAM INDIA PRIVATE LIMITED",
"BAYLEAF HR SOLUTIONS PRIVATE LIMITED",
"BAYNEE PROJECTS LTD",
"BAYO AGRO VET PRIVATE LIMITED",
"BAYONE CARGO FORWARDERS PRIVATE LIMITED",
"BAYONE INFOTECH PRIVATE LIMITED",
"BAYONE TECHNO ADVISORS PRIVATE LIMITED",
"BAY-PAC SYSTEMS PRIVATE LIMITED",
"BAYPURE LIFESTYLE PRIVATE LIMITED",
"BAYROCK GRANITES PRIVATE LIMITED",
"BAYSQUARE TECHNOLOGIES PRIVATE LIMITED",
"BAYU HEALTHCARE PRIVATE LIMITED",
"BAYVIEW LOUNGE PRIVATE LIMITED",
"BAZAAR247 MCOMMERCE PRIVATE LIMITED",
"BAZAARI GLOBAL FINANCE LIMITED",
"BAZAARVOICE TECHNOLOGY INDIA PRIVATE LIMITED",
"BAZALONI GROUP LIMITED",
"BAZANA FOODS PRIVATE LIMITED",
"BAZARI EXIM PRIVATE LIMITED",
"BAZARI SYNTHETICS PRIVATE LIMITED",
"BAZEL INTERNATIONAL LTD.",
"BAZIGAR TRADING PVT LTD",
"BAZINGA MEDIA PRIVATE LIMITED",
"BAZINGA SOFTTECH PRIVATE LIMITED",
"BB COMMODITIES PRIVATE LIMITED",
"BB ELECTROTECH PRIVATE LIMITED",
"BB ENTERTAINMENT TRADE PRIVATE LIMITED",
"BB HOSPITALITY VENTURES PRIVATE LIMITED",
"BB INFRA SOLUTIONS PRIVATE LIMITED",
"BB MAKEWELL TECHNOLOGY PRIVATE LIMITED",
"BB SAXENA MEMORIAL HOSPITAL",
"BB SCIMA PRIVATE LIMITED",
"BB VOYAGE PRIVATE LIMITED",
"BB11 TECHNOLABS PRIVATE LIMITED",
"BBC ADARSH VIDYALAYA SOLAIYA",
"BBC ENTERPRISES PRIVATE LIMITED",
"BBC GLOBAL NEWS INDIA PRIVATE LIMITED",
"BBC MEDIA ACTION INDIA LIMITED",
"BBC MINES INDIA PRIVATE LIMITED",
"BBC RICE INDUSTRIES PRIVATE LIMITED",
"BBC STUDIOS INDIA PRIVATE LIMITED",
"BBC WORLD SERVICE INDIA PRIVATE LIMITED",
"BBCL DEVELOPERS INDIA PRIVATE LIMITED",
"BBCL PROPERTIES PRIVATE LIMITED",
"BBCL VENTURES PRIVATE LIMITED",
"BBD EDUCATIONAL SERVICES PRIVATE LIMITED",
"BBDO INDIA PRIVATE LIMITED",
"BBE SOLUTIONS INDIA PRIVATE LIMITED",
"BBG INDIA DEVELOPERS LLP",
"BBG INFRASTRUCTURE PRIVATE LIMITED",
"BBG METAL SYNDICATE PRIVATE LIMITED",
"BBH COMMUNICATIONS INDIA PRIVATE LIMITED",
"BBI FITNESS SERVICES PRIVATE LIMITED",
"BBIGPLAS POLY PRIVATE LIMITED",
"BBK EXPORTS LIMITED",
"BBK EXPORTS PRIVATE LIMITED",
"BBL DAIDO PRIVATE LIMITED",
"BBM ESTATES PRIVATE LIMITED",
"BBM HEAVY MACHINERY PRIVATE LIMITED",
"BBM PROFIN ADVISORS PRIVATE LIMITED",
"BBM TRAVEL RETAIL LIMITED",
"BBN ENERGY SYSTEMS PRIVATE LIMITED",
"BBN SHIPMANAGEMENT PRIVATE LIMITED",
"BBP STUDIO VIRTUAL BHARAT PRIVATE LIMITED",
"BBR INDIA PRIVATE LIMITED",
"BBRC INFRASTRUCTURE PRIVATE LIMITED",
"BBRT INTERNATIONAL SCHOOL",
"BBS EARTHMOVERS PRIVATE LIMITED",
"BBS GLOBAL PRIVATE LIMITED",
"BBS INFRACON PRIVATE LIMITED",
"BBSB STONE CRUSHERS PRIVATE LIMITED",
"BBSI SYSTEMS PRIVATE LIMITED",
"BBT ELEVATED ROAD PRIVATE LIMITED",
"BBW BRUSHES PRIVATE LIMITED",
"BBW DISTRIBUTORS PRIVATE LIMITED",
"BC BROTHERS RETAL PRIVATE LIMITED",
"BC C DEVELOPERS AND PROMOTORS PRIVATE LIMITED",
"BC DISTRIBUTION AND MARKETING PRIVATE LIMITED",
"BC FORWARD INDIA TECHNOLOGIES PRIVATE LIMITED",
"BC INFRA PROJECTS PRIVATE LIMITED",
"BC INSTRUMENTS INDIA PRIVATE LIMITED",
"BC MANAGEMENT SERVICES PRIVATE LIMITED",
"BC POWER CONTROLS LIMITED",
"BC SEN & CO LIMITED",
"BC WEB WISE PRIVATE LIMITED",
"BCA IMPEX PRIVATE LIMITED",
"BCAP ADVISORS INDIA PRIVATE LIMITED",
"BCB BROKERAGE PRIVATE LIMITED",
"BCBKUSHAL SERVICES PRIVATE LIMITED",
"BCC INFRACON PRIVATE LIMITED",
"BCC INFRASTRUCTURES PRIVATE LIMITED",
"BCC PIPES & TUBES PRIVATE LIMITED",
"BCC PRECAST (INDIA) PRIVATE LIMITED",
"BCD AGENCY PRIVATE LIMITED",
"BCD TRAVEL INDIA PRIVATE LIMITED",
"BCE CANCO INC",
"BCES ADMISSIONS ABROAD PRIVATE LIMITED",
"BCFOODS (INDIA) SEASONINGS AND INGREDIENTS PRIVATE LIMITED",
"BCFORWARD INDIA TECHNOLOGIES PRIVATE LIMITED",
"BCG ATTORNEY SEARCH PRIVATE LIMITED",
"BCGS HOSPITALS PRIVATE LIMITED",
"BCH ELECTRIC LIMITED",
"BCI ENGINEERING INDIA PRIVATE LIMITED",
"BCI PACKAGING LLP",
"BCIM ENGINEERING PRIVATE LIMITED",
"BCITS PRIVATE LIMITED",
"BCITS PRIVATE. LIMITED.",
"BCK REALTY LLP",
"BCL ENTERPRISES LIMITED",
"BCL INDIA",
"BCL INDUSTRIES LIMITED",
"BCL SECURE PREMISES PRIVATE LIMITED",
"BCLPLUS SERVICES PRIVATE LIMITED",
"BCM ARYA MODEL SR SEC SCHOOL",
"BCM CLEARING & LOGISTICS LLP",
"BCM COLLEGE",
"BCM EXPORTS (INDIA) PRIVATE LIMITED",
"BCM HEALTHCARE PRIVATE LIMITED",
"BCM HOSPITALS LLP",
"BCM SCHOOL",
"BCN WEARS PRIVATE LIMITED",
"BCOD WEB SOLUTIONS PRIVATE LIMITED",
"BCON CONSTROTECH PRIVATE LIMITED",
"BCOS HEALTHCARE PRIVATE LIMITED",
"BCP ADVISORS PRIVATE LIMITED",
"BCPL CONDUCTORS PRIVATE LIMITED",
"BCPL RAILWAY INFRASTRUCTURE LIMITED",
"BCRE INDIA PRIVATE LIMITED",
"BCS CONSULTING PRIVATE LIMITED",
"BCS INDIA PRIVATE LIMITED.",
"BCS MEDIA AND CONSUMABLES PRIVATE LIMITED",
"BCS SECURITY SERVICES PRIVATE LIMITED",
"BCT CONSULTING PRIVATE LIMITED",
"BCT DIGITAL PRIVATE LIMITED",
"BCUBE IT SERVICES PRIVATE LIMITED",
"BCUBE VENTURES LLP",
"BCV DEVELOPERS PRIVATE LIMITED",
"BCY JEWELLERS PRIVATE LIMITED",
"BD AGARWAL BUILDTECH INDIA PRIVATE LIMITED",
"BD DESIGNBUILD PRIVATE LIMITED",
"BD INDUSTRIES INDIA PRIVATE LIMITED",
"BD INFO MEDIA PRIVATE LIMITED",
"BD INFRA PROJECTS PRIVATE LIMITED",
"BD KALAS EXPORTS AND IMPORTS PRIVATE LIMITED",
"BD KHANNA ESTATES PRIVATE LIMITED",
"BD MEDICO PRIVATE LIMITED",
"BD SHAH SECURITIES LIMITED",
"BD SOFTWARE DISTRIBUTION PRIVATE LIMITED",
"BD TECHNOPARK PRIVATE LIMITED",
"BDA HEALTH CARE PRIVATE LIMITED",
"BDA INDUSTRIAL RESOURCES PRIVATE LIMITED",
"BDA LIMITED",
"BDA PARTNERS LIMITED",
"BDA SKILLS DEVELOPMENT PRIVATE LIMITED",
"BDAGGARWAL CAR CARRIER PRIVATE LIMITED",
"BDAS WEB SYS PRIVATE LIMITED",
"BDB EXIM PRIVATE LIMITED",
"BDB EXPORTS PRIVATE LIMITED",
"BDB INDIA PRIVATE LIMITED",
"BDC DIGIPHOTO IMAGING SOLUTIONS PRIVATE LIMITED",
"BDC DISTRIBUTION PRIVATE LIMITED",
"BDCINFO PRIVATE LIMITED",
"BDCON ENGINEERS PRIVATE LIMITED",
"BDEL WELLNESS PRIVATE LIMITED",
"B'DESIR COSMETICS PRIVATE LIMITED",
"BDFL TECHNOLOGIES PRIVATE LIMITED",
"BDG METAL & POWER LIMITED",
"BDG POLYMERS PRIVATE LIMITED",
"BDG POLYSTEEL LIMITED",
"BDG STEEL & POWER PRIVATE LIMITED",
"BDH AGRO VENTURES PRIVATE LIMITED",
"BDH IMPEX PRIVATE LIMITED",
"BDH INDUSTRIES LIMITED",
"BDH ORGANICS PRIVATE LIMITED",
"BDHRS TALENT 4.0 PRIVATE LIMITED",
"BDI ESTATES PRIVATE LIMITED",
"BDI INDIA PRIVATE LIMITED",
"BDI SYSTEMS AND TECHNOLOGIES PRIVATE LIMITED",
"BDIPLUS LAB PRIVATE LIMITED",
"BDJ IMPLEX PRIVATE LIMITED",
"BDJ OXIDES PRIVATE LIMITED",
"BDM GRANIMARMO PRIVATE LIMITED",
"BDM SOLUTIONS PRIVATE LIMITED",
"BDM STONES PRIVATE LIMITED",
"BDMR AGRO TECH PRIVATE LIMITED",
"BDMV INTERNATIONAL PRIVATE LIMITED",
"BDO INDIA LIMITED LIABILITY PARTNERSHIP",
"BDO INDIA TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"BDO RISE PRIVATE LIMITED",
"BDP DESIGN ENGINEERING PRIVATE LIMITED",
"BDP ENERGY PRIVATE LIMITED",
"BDP UGL GLOBAL LOGISTICS INDIA PRIVATE LIMITED",
"BDR BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"BDR BUILDTECH PRIVATE LIMITED",
"BDR DEVELOPERS PRIVATE LIMITED",
"BDR FINANCE PRIVATE LIMITED",
"BDR FINVEST PRIVATE LIMITED",
"BDR LIFESCIENCES PRIVATE LIMITED",
"BDR PACKAGING PRIVATE LIMITED",
"BDR PHARMACEUTICALS INTERNATIONAL PRIVATE LIMITED",
"BDRD FOODROOT PRIVATE LIMITED",
"BDREAMZ GLOBAL SOLUTIONS PRIVATE LIMITED",
"BDS DECOR AND PREFAB PRIVATE LIMITED",
"BDS MACHINES PRIVATE LIMITED",
"BDS PROJECTS INDIA PRIVATE LIMITED",
"BDS SERVICES PRIVATE LIMITED",
"BDS SHARE BROKERS PRIVATE LIMITED",
"BDS STEEL DETAILERS AUSTRALIA PTY LIMITED",
"BDS THE BEST MARKETING PRIVATE LIMITED",
"BDS VIRCON PRIVATE LIMITED",
"BDX INDIA PRIVATE LIMITED",
"BE BETTER PERSONAL CARE PRIVATE LIMITED",
"BE ENGINEERING SERVICES INDIA PRIVATE LIMITED",
"BE GOLD PRIVATE LIMITED",
"BE JEWELLED INDIA PRIVATE LIMITED",
"BE LIMITED",
"BE NOW INSPIRED PRIVATE LIMITED",
"BE PHARMACEUTICALS PRIVATE LIMITED",
"BE POSITIVE 24 COMMUNICATION DESIGN PRIVATE LIMITED",
"BE WELL HOSPITALS PRIVATE LIMITED",
"BE3 HUMAN RESOURCE MANAGEMENT PRIVATE LIMITED",
"BEACHEM PRIVATE LIMITED",
"BEACHVILLE COFFEE PRIVATE LIMITED",
"BEACHWOOD SCHOOL",
"BEACON ANALYTICS PRIVATE LIMITED",
"BEACON BIO LIFE SCIENCES PRIVATE LIMITED",
"BEACON COURIER AND CARGO INDIA PRIVATE LIMITED",
"BEACON CREDITCAP PRIVATE LIMITED",
"BEACON DIAGNOSTICS PRIVATE LIMITED",
"BEACON ELEVATOR COMPANY PRIVATE LIMITED",
"BEACON GEAR TRANSMISSIONS PRIVATE LIMITED",
"BEACON GREEN TECH LIMITED",
"BEACON HEALTH CARE PRIVATE LIMITED",
"BEACON HIGH SCHOOL & JUNIOR COLLEGE",
"BEACON HIGHER EDUCATION SERVICES PRIVATE LIMITED",
"BEACON INDUSTRIES",
"BEACON INSURANCE BROKERS PRIVATE LIMITED",
"BEACON LIGHT PUBLICATIONS PRIVATE LIMITED",
"BEACON MARINE PRIVATE LIMITED",
"BEACON METALS (INDIA) PVT LTD",
"BEACON PROJECTS PRIVATE LIMITED",
"BEACON SALES PRIVATE LIMITED",
"BEACON TRAVELS PRIVATE LIMITED",
"BEACON TRUSTEESHIP LIMITED",
"BEADCORE INFOTECH PRIVATE LIMITED",
"BEADLETS PHARMA PRIVATE LIMITED",
"BEAHEAD PRIVATE LIMITED",
"BEAL INDIA EXPORT PRIVATE LIMITED",
"BEAM INFOTECH PRIVATE LIMITED",
"BEAM ON SERVICE TECHNOLOGY INDIA PRIVATE LIMITED",
"BEAM RETAIL AND INFRA PRIVATE LIMITED",
"BEAM SOLAR PRIVATE LIMITED",
"BEAMER FOOD AND BEVERAGES PRIVATE LIMITED",
"BEAMEX OY AB",
"BEAMLASER ENGINEERING INDIA PRIVATE LIMITED",
"BEAMTEAM SAFETY PRODUCTS PRIVATE LIMITED",
"BEAM-X MEDICAL SERVICES PRIVATE LIMITED",
"BEAN GOOD PRIVATE LIMITED",
"BEAN TO CHOCOLATIER PRIVATE LIMITED",
"BEANHUB FOODS & BEVERAGES PRIVATE LIMITED",
"BEANSBIT PRIVATE LIMITED",
"BEANT CONSTRUCTION CO. PRIVATE LIMITED",
"BEARDSELL LIMITED",
"BEARING POWER INDIA PRIVATE LIMITED",
"BEARING TRADERS I PRIVATE LIMITED",
"B-EARTH AND SPIRE INDIA PRIVATE LIMITED",
"BEARYS FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"BEARYS GLOBAL RESEARCH TRIANGLE (S) PRIVATE LIMITED",
"BEARYS GOLDEN HARVEST HOLDINGS PRIVATE LIMITED",
"BEARYS INFRASTRUCTURE AND CONSTRUCTION ENGINEERING PRIVATE LIMITED",
"BEARYS INNOMARKETING PRIVATE LIMITED",
"BEARYS INSTITUTE OF TECHNOLOGY",
"BEARYS PROPERTIES AND DEVELOPMENTS PRIVATE LIMITED",
"BEAS CONSULTANCY AND SERVICES PRIVATE LIMITED",
"BEAS VALLEY POWER CORPORATION LIMITED",
"B-EASY SOLUTIONS INDIA PRIVATE LIMITED",
"BEATBOX ENTERTAINMENT PRIVATE LIMITED",
"BEATRIX IMPORT AND EXPORT OVERSEAS PRIVATE LIMITED",
"BEATROOT HR SERVICES PRIVATE LIMITED",
"BEATROUTE INNOVATIONS PRIVATE LIMITED",
"BEATS LIGHT & SOUND PRIVATE LIMITED",
"BEAU JHELUM TRADERS AND DEVELOPERS PRIVATE LIMITED",
"BEAUCIENCE INDIA PRIVATE LIMITED",
"BEAUKNITT INDIA PRIVATE LIMITED",
"BEAULAH ENTERPRISES PVT LTD",
"BEAUMANOIR INDIA PRIVATE LIMITED",
"BEAUTE LAH PRODUCTS PRIVATE LIMITED",
"BEAUTEX COMMUNICATION PRIVATE LIMITED",
"BEAUTEX INDUSTRIES PRIVATE LIMITED",
"BEAUTIFUL AGRO PRODUCTS PRIVATE LIMITED",
"BEAUTIFUL CODE LLP",
"BEAUTIFUL COSMO PRODUCTS PRIVATE LIMITED",
"BEAUTIFUL EXTRUSIONS PRIVATE LIMITED",
"BEAUTIFUL MEGA MART INDIA PRIVATE LIMITED",
"BEAUTIFUL RETAIL PRIVATE LIMITED",
"BEAUTO SYSTEMS PRIVATE LIMITED",
"BEAUTY & HERBS PVT.LTD.",
"BEAUTY & MORE",
"BEAUTY CONCEPTS PRIVATE LIMITED",
"BEAUTY ESSENTIAKS MARKETING PRIVATE LIMITED",
"BEAUTY ETOILE PRIVATE LIMITED",
"BEAUTY IMPEX PRIVATE LIMITED",
"BEAUTY LIFESTYLES PRIVATE LIMITED",
"BEAUTYMARK GOLD PRIVATE LIMITED",
"BEAUVUE STILEDIVITA PRIVATE LIMITED",
"BEAVER INFRA CONSULTANTS PRIVATE LIMITED",
"BEAVER INTERNATIONAL (INDIA) PRIVATE LIMITED",
"BEAVER MARKETING SOLUTIONS PRIVATE LIMITED",
"BEAVER METALS PRIVATE LIMITED",
"BEAVER TRACKS PRIVATE LIMITED",
"BEAVERS EDUVENTURE PRIVATE LIMITED",
"BEAWAR PALI PINDWARA TOLLWAY PRIVATE LIMITED",
"BEBANCO DEVELOPERS LIMITED",
"BEBANCO INFRASTRUCTURE LIMITED",
"BEBANCO NORTHERN CONTRACTS LIMITED",
"BEBBCO COMMERCIAL VEHICLES PRIVATE LIMITED",
"BEBBCO MOTORS PRIVATE LIMITED",
"BEBITZ FLANGES WORKS PRIVATE LIMITED",
"BEBO TECHNOLOGIES PRIVATE LIMITED",
"BE-BONNIE BODYCARE PRIVATE LIMITED",
"BEBYMIL INTERNATIONAL PRIVATE LIMITED",
"BEC CHEMICALS PRIVATE LIMITED",
"BEC ENGINEERS PRIVATE LIMITED",
"BEC FERTILIZERS LIMITED",
"BEC HEALTHCARE (INDIA) PRIVATE LIMITED",
"BEC INFRA PRIVATE LIMITED",
"BEC PROJECTS LIMITED",
"BECARRE SPECIALITY INGREDIENTS PRIVATE LIMITED",
"BECCUN INFRASTRUCTURES LIMITED",
"BECHTEL ENGINEERING AND CONSTRUCTION INDIA PRIVATE LIMITED",
"BECHTEL INDIA PRIVATE LIMITED",
"BECK & POLLITZER INDIA PRIVATE LIMITED",
"BECK ACTUATORS INDIA PRIVATE LIMITED",
"BECKCEM DRUG INTERNATIONAL PRIVATE LIMITED",
"BECKER ROBOTIC EQUIPMENT INDIA PRIVATE LIMITED",
"BECKHAUL DIGITAL TECHNOLOGIES PRIVATE LIMITED",
"BECKHOFF AUTOMATION PRIVATE LIMITED",
"BECKMAN COULTER INDIA PRIVATE LIMITED",
"BECO CHEMICALS PRIVATE LIMITED",
"BECQUER ENERGY INDIA SALES OFFICE PRIVATE LIMITED",
"BECQUEREL INDUSTRIES PRIVATE LIMITED",
"BECTIVE AND WESLEY PRIVATE LIMITED",
"BECTO FLEX CONTAINMENT SYSTEM PRIVATE LIMITED",
"BECTOCHEM CONSULTANTS AND ENGINEERS PRIVATE LIMITED",
"BECTOCHEM LOEDIGE PROCESS TECHNOLOGY PRIVATE LIMITED",
"BECTON DICKINSON INDIA PRIVATE LIMITED",
"BECTON DICKINSON TECHNOLOGY CAMPUS INDIA LLP",
"BECTOR AUTOMATION RML INDIA PRIVATE LIMITED",
"BECTRAN IT SOLUTIONS PRIVATE LIMITED",
"BED AND BEYOND SERVICES PRIVATE LIMITED",
"BEDECK WOODS PRIVATE LIMITED",
"BEDEKAR LIFESPACES LLP",
"BEDI A M PRIVATE LIMITED",
"BEDI INTERNATIONAL SCHOOL",
"BEDI KUMAR PRIMARY 1 SHALA",
"BEDI SALES PRIVATE LIMITED",
"BEDI STEEL ROLLING MILLS PRIVATE LIMITED",
"BEDI STEELS PVT LTD",
"BEDI TRADING PRIVATE LIMITED",
"BEDIA COLD STORAGE PRIVATE LIMITED",
"BEDIA TRADELINK PRIVATE LIMITED",
"BEDMUTHA INDUSTRIES LIMITED.",
"BEDOFF PRIVATE LIMITED",
"BEDROCK ENTERPRISES PRIVATE LIMITED",
"BEDROCK FOOD COMPANY PRIVATE LIMITED",
"BEDROCK VENTURE MANAGEMENT PRIVATE LIMITED",
"BEDSE PAPER MILLS PRIVATE LIMITED",
"BEDSE PULP CONVERSION INDUSTRIES PVT LTD",
"BEE 4 HOSPITALITY PRIVATE LIMITED",
"BEE AAR CONTROLS & ENGINEERING PRIVATE LIMITED",
"BEE CABS INDIA PRIVATE LIMITED",
"BEE CRAFT HONEY AND SPICES PRIVATE LIMITED",
"BEE ELECTRIC PRIVATE LIMITED",
"BEE ESS METAL ENGINEERS (INDIA) PRIVATE LIMITED",
"BEE GEE CREATIONS PRIVATE LIMITED",
"BEE GEE FABRICS PRIVATE LIMITED",
"BEE HIVE FARMS PRIVATE LIMITED",
"BEE INNOVATIONS INDIA PRIVATE LIMITED",
"BEE JAY INDUSTRIAL CORPORATION",
"BEE K BEE PRINTS PRIVATE LIMITED",
"BEE KAY CASTING PRIVATE LIMITED",
"BEE LIFE SCIENCE PRIVATE LIMITED",
"BEE PATH CASTINGS PRIVATE LIMITED",
"BEE PEE BUILDCON PRIVATE LIMITED",
"BEE PEE MOTORS PRIVATE LIMITED",
"BEE PEE ROLLERS PVT LTD",
"BEE PEE SATVAA PRIVATE LIMITED",
"BEE TEE STONES PRIVATE LIMITED",
"BEE VEE GRAPHICS",
"BEE YOU'S CENTURY TRADING PRIVATE LIMITED",
"BEEAAR AUTOWHEELS INDIA PRIVATE LIMITED",
"BEEAM INDUSTRIES PRIVATE LIMITED",
"BEEAM PRODUCTS & SERVICES PRIVATE LIMITED",
"BEEBAY KIDS APPARELS PRIVATE LIMITED",
"BEEBEE ELECTRICALS & ELECTRONICS PRIVATE LIMITED",
"BEEBOM FACILITY MANAGEMENT INDIA PRIVATE LIMITED",
"BEEBOM MEDIA PRIVATE LIMITED",
"BEECH IMPEX PRIVATE LIMITED",
"BEECHTREE SYSTEMS AND SOLUTIONS PRIVATE LIMITED",
"BEEGEE METALS PRIVATE LIMITED",
"BEEGEES CON FAB PRIVATE LIMITED",
"BEEGRU REAL ESTATE PRIVATE LIMITED",
"BEEHIVE CAPITAL ADVISORS PRIVATE. LIMITED",
"BEEHIVE COMMUNICATIONS PRIVATE LIMITED",
"BEEHIVE CONSTRUCTONS PRIVATE LIMITED",
"BEEHIVE FOUNDRY ENGINEERING WORK",
"BEE-HIVE INFRAVENTURES PRIVATE LIMITED",
"BEEHIVE LOGISTICS PRIVATE LIMITED",
"BEEHIVE SHIPPING AND TRADING PRIVATE LIMITED",
"BEEHIVE SOFTWARE SERVICES PRIVATE LIMITED",
"BEEHIVE SYSTEMS PRIVATE LIMITED",
"BEEHYV SOFTWARE SOLUTIONS PRIVATE LIMITED",
"BEEJ SHEETAL RESEARCH PRIVATE LIMITED",
"BEEJ VIGYAN SEED PRODUCER COMPANY LIMITED",
"BEEJA INNOVATIVE VENTURES PRIVATE LIMITED",
"BEEJAY INVESTMENT & FINANCIAL CONSULTANTS PVT. LTD",
"BEEKALENE FABRICS PRIVATE LIMITED",
"BEEKAY AUTO PRIVATE LIMITED",
"BEEKAY AUTOCORP PRIVATE LIMITED",
"BEEKAY DISTRIBUTORS",
"BEEKAY ENGINEERING CORPORATION PRIVATE LTD",
"BEEKAY GRANITES PVT LTD",
"BEEKAY INFRATECH PRIVATE LIMITED",
"BEEKAY NIRYAT LIMITED",
"BEEKAY PARTS BAZAAR PRIVATE LIMITED",
"BEEKAY PLAZA PRIVATE LIMITED",
"BEEKAY STEEL INDUSTRIES LIMITED",
"BEEKAY SUPPLYCHAIN SOLUTIONS PRIVATE LIMITED",
"BEEKAY TEX",
"BEEKAY TRAVELS PRIVATE LIMITED",
"BEEKAY UNIVERSAL IMPEX PRIVATE LIMITED",
"BEEKAY WIRES PRIVATE LIMITED",
"BEEKAYIT NETSEC SOLUTIONS PRIVATE LIMITED",
"BEEKAYLON SYNTHETICS PRIVATE LIMITED",
"BEEKAYLON SYNTHETICS PRIVATE. LIMITED.",
"BEEKAYPEE CREDIT PVT LTD",
"BEEKEYEN FREIGHT SERVICES PRIVATE LIMITED",
"BEELAL SILK MILLS PRIVATE LIMITED",
"BEELINE BROKING LIMITED",
"BEE-LINE BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"BEELINE CAPITAL ADVISORS PRIVATE LIMITED",
"BEELINE IMPEX PRIVATE LIMITED",
"BEELINE TECHNOLOGIES PRIVATE LIMITED",
"BEEMET INSTRUMENTS PVT LTD",
"BEENA CHEMICALS AND FERTILIZERS PRIVATE LIMITED",
"BEENACHEM EQUIPMENTS PRIVATE LTD",
"BEENAFIRE ENGINEERING PRIVATE LIMITED",
"BEEP EXPERIENCE MANAGEMENT PRIVATE LIMITED",
"BEEP INNOVATIONS PRIVATE LIMITED",
"BEEPEE COATINGS PRIVATE LIMITED",
"BEEPEE ENTERPRISE PRIVATE LIMITED",
"BEEPJYOTI ENGINEERING PRIVATE LIMITED",
"BEER WORKS RESTAURANTS AND MICROBREWERY PRIVATE LIMITED",
"BEERBAL PACKAGING PRIVATE LIMITED",
"BEERBICEPS MEDIA WORLD PRIVATE LIMITED",
"BEERENSGAS (INDIA) PRIVATE LIMITED",
"BEES NETWORK LIMITED",
"BEES SOFTWARE SOLUTIONS PRIVATE LIMITED",
"BEESAKOPIE TEA ESTATE",
"BEESAWA INDUSTRIES LIMITED",
"BEESLEY CONSULTANCY PRIVATE LIMITED",
"BEESOLVER TECHNOLOGY PRIVATE LIMITED",
"BEESPHERE CONSULTANCY SERVICES PRIVATE LIMITED",
"BEETA AUTOMAC PRIVATE LIMITED",
"BEETA LOGISTICS PRIVATE LIMITED",
"BEETA MACHINES PRIVATE LIMITED",
"BEETA POLY COATS PRIVATE LIMITED",
"BEETA TRADERS AND AGENCIES PRIVATE LIMITED.",
"BEETEE TEXTILE INDUSTRIES LIMITED",
"BEETEL TELETECH LIMITED",
"BEETEX PVT LTD",
"BEETLE ENTERPRISES LIMITED",
"BEETLE EXPORT",
"BEETLE VENTURES PRIVATE LIMITED",
"BEETLERIM TECHNOLOGIES PRIVATE LIMITED",
"BEETOR ANTIPIRACY TECHNOLOGY PRIVATE LIMITED",
"BEEU INFOTECH PRIVATE LIMITED",
"BEEUP SKILLS FOUNDATION",
"BEEWORKS SOFTWARES PRIVATE LIMITED",
"BEEZ INNOVATION LABS PRIVATE LIMITED",
"BEEZAASAN EXPLOTECH PRIVATE LIMITED",
"BEFACH 4X PRIVATE LIMITED",
"BEFAM PHARMACEUTICALS PVT LTD",
"BEFARED INDIA PRIVATE LIMITED",
"BEFFERENT DIGITAL MEDIA PRIVATE LIMITED",
"BEFREE BUSINESS RESOURCING LLP",
"BEG AND CENTRE ROORKEE",
"BEG HOSPITAL & FAHMY MATERNITY CENTRE",
"BEGANI DYEING MILLS PRIVATE LIMITED",
"BEGANTO SOFTWARE SYSTEMS PRIVATE LIMITED",
"BEGAPT TECH SOLUTIONS PRIVATE LIMITED",
"BEGG COUSLAND PRIVATE LIMITED",
"BEGHOU CONSULTING INDIA PRIVATE LIMITED",
"BEGONIA HOTELS PRIVATE LIMITED",
"BEGORRA INFRASTRUCTURE AND DEVELOPERS PRIVATE LIMITED",
"BEGOTTEN LIFE SCIENCE PRIVATE LIMITED",
"BEGUD BEVERAGES PRIVATE LIMITED",
"BEGUM SHARIFA KALSEKAR GIRLS ENGLISH SCHOOL",
"BEHALA COLLEGE",
"BEHALA HIGH SCHOOL",
"BEHARI COLDS PRIVATE. LIMITED.",
"BEHARI LAL DARSHAN LAL PRIVATE LIMITED",
"BEHARI LAL ISPAT PRIVATE LIMITED",
"BEHARIJI PAPERS PRIVATE LIMITED",
"BEHAVIOURAL INSIGHTS, ARCHITECTURE AND STRATEGY (BIAS) PRIVATE LIMITED",
"BEHERA ASSOCIATES PRIVATE LIMITED",
"BEHERA ENGINEERING WORKS PRIVATE LIMITED",
"BEHERA MULTIPRODUCTS PRIVATE LIMITED",
"BEHERA STORAGE PRIVATE LIMITED",
"BEHEST FAB INDUSTRIES PRIVATE LIMITED",
"BEHIND FORCE TECH SOLUTION PRIVATE LIMITED",
"BEHL AGENCIES PRIVATE LIMITED",
"BEHL COAL FUEL PRIVATE LIMITED",
"BEHL MOTORS PRIVATE LIMITED",
"BEHLSON TRADERS PVT.LTD.",
"BEHR BIRCHER CELLPACK BBC INDIA PRIVATE LIMITED",
"BEHR HELLA THERMOCONTROL INDIA PRIVATE LIMITED",
"BEHR PROCESS PAINTS INDIA PRIVATE LIMITED",
"BEHRA POULTRY PRIVATE LIMITED",
"BEHROR HIGHWAY BUILDCON PRIVATE LIMITED",
"BEHS SUMATI ACADEMY",
"BEI CONFLUENCE COMMUNICATION LIMITED",
"BEICO INDUSTRIES PRIVATE LIMITED",
"BEID HEALTHCARE PRIVATE LIMITED",
"BEIERSDORF INDIA PRIVATE LIMITED",
"BEIERSDORF INDIA SERVICE PRIVATE LIMITED",
"BEIING CORPORATE PRIVATE LIMITED",
"BEIJER ELECTRONICS TECHNOLOGIES PRIVATE LIMITED",
"BEIJER REF INDIA PRIVATE LIMITED",
"BEIL INFRASTRUCTURE LIMITED",
"BEING LIFE HOSPITALITY PRIVATE LIMITED",
"BEING POSH EXHIBITION MANAGEMENT PRIVATE LIMITED",
"BEING VOLUNTEER FOUNDATION",
"BEINGU STUDIOS PRIVATE LIMITED",
"BEING-WELL INDIA PRIVATE LIMITED",
"BEJAN SINGH EYE HOSPITAL PRIVATE LIMITED",
"BEJO SEEDS INDIA PRIVATE LIMITED",
"BEJOBBED INCORPORATION PRIVATE LIMITED",
"BEKAE PROPERTIES PRIVATE LIMITED",
"BEKAERT INDUSTRIES PRIVATE LIMITED",
"BEKAERT MUKAND WIRE INDUSTRIES PRIVATE LIMITED",
"BEKEM INFRA PROJECTS PRIVATE LIMITED",
"BEKO TECHNOLOGIES INDIA PRIVATE LIMITED",
"BEL CIBO HOSPITALITY PRIVATE LIMITED",
"BEL OPTRONIC DEVICES LIMITED",
"BELA FASONADO PRIVATE LIMITED",
"BELA MARKETING PVT LTD",
"BELA MEDICAL AGENCIES PRIVATE LIMITED",
"BELAGAVI SMART CITY LIMITED",
"BELAIR LOGISTICS PRIVATE LIMITED",
"BELAIR TRAVEL AND CARGO PRIVATE LIMITED",
"BELAIRE HOTELS PRIVATE LIMITED",
"BELAKU EYE HOSPITALS PRIVATE LIMITED",
"BELAKUR INNOVITEC SOLUTIONS PRIVATE LIMITED",
"BELAMBE HOSPITALITY",
"BELAMI FINE CHEMICALS PVT LTD",
"BELCAN INDIA PRIVATE LIMITED",
"BELCHEM INDUSTRIES (INDIA) PVT LTD",
"BELCITY HEALTHCARE PRIVATE LIMITED",
"BELCO PHARMA",
"BELCO SPECIAL STEELS PRIVATE LIMITED",
"BELCOSYS INFRA TECH PRIVATE LIMITED",
"BELDEN INDIA PRIVATE LIMITED",
"BELEAST TRAVELS P LIMITED",
"BELENUS INFRASTECTURE PRIVATE LIMITED",
"BELFROST INTERNATIONAL LLP",
"BELGACHIA MONOHAR ACADEMY",
"BELGACHIA SURENDRANATH GHOSH MEMO HIGH SCHOOL",
"BELGAUM CANCER HOSPITAL PRIVATE LIMITED",
"BELGAUM CNC APPLICATIONS PRIVATE LIMITED",
"BELGAUM DIAGNOSTIC AND CARDIAC CENTRE PRIVATE LIMITED",
"BELGAUM FERROCAST INDIA PRIVATE LIMITED",
"BELGAUM GREEN ENVIRONMENTAL MANAGEMENT PRIVATE LIMITED",
"BELGAUM LIFE LINE INTENSIVE CARE CENTRE PRIVATE LIMITED",
"BELGAUM OXYGEN PRIVATE LIMITED",
"BELGAUM RENEWABLE ENERGY PRIVATE LIMITED",
"BELGAUM SILICA PRIVATE LIMITED",
"BELGAUM SUGARS PRIVATE LIMITED",
"BELGAUM WIND FARMS PRIVATE LIMITED",
"BELGEE DIAMONDS PRIVATE LIMITED",
"BELGHARIA HIGH SCHOOL HS",
"BELGHARIA TEXMACO ESTATE SCHOOL",
"BELGIUM GLASS AND CERAMICS PRIVATE LIMITED",
"BELGIUM NY LLC",
"BELGOD MARINE SERVICES PRIVATE LIMITED",
"BELGOTEX INDIA PRIVATE LIMITED",
"BELGRAVIA PROJECTS PRIVATE LIMITED",
"BELHOPAT GLOBAL SERVICES PRIVATE LIMITED",
"BELICIA LIFESCIENCES PRIVATE LIMITED",
"BELIEF BUILDCON PRIVATE LIMITED",
"BELIEF CELLPHONE PRIVATE LIMITED",
"BELIEVANT TECHNOLOGIES PRIVATE LIMITED",
"BELIEVE CREATIVE ITES PRIVATE LIMITED",
"BELIEVE DIGITAL PRIVATE LIMITED",
"BELIEVE INFOTECH PRIVATE LIMITED",
"BELIEVE INFRAPROJECT PRIVATE LIMITED",
"BELIEVE INTERNATIONAL LIMITED",
"BELIEVEIT TECHNOLOGIES PRIVATE LIMITED",
"BELIEVERS CHURCH MEDICAL COLLEGE HOSPITAL",
"BELIFAL INNOVATIONS & TECHNOLOGIES PRIVATE LIMITED",
"BELIFE BUILDCON PRIVATE LIMITED",
"BELIJ HYDRO POWER PRIVATE LIMITED",
"BELIMO ACTUATORS INDIA PRIVATE LIMITED",
"BELINDA LABORATORIES PRIVATE LIMITED",
"BELINDIA FINANCE AND INVESTMENTS PRIVATE LIMITED",
"BELIRAM DEGCHIVALA FOODS PRIVATE LIMITED",
"BELISIA SPA AND SALOON PRIVATE LIMITED",
"BELITA DESIGN SOLUTIONS PRIVATE LIMITED",
"BELKIN INDIA PRIVATE LIMITED",
"BELL ATOZ PRIVATE LIMITED",
"BELL COOLING TOWERS PRIVATE LIMITED",
"BELL FLAVORS & FRAGRANCES (INDIA) PRIVATE LIMITED",
"BELL FLOWER TRADING COMPANY PRIVATE LIMITED",
"BELL FLUID TECHNICS PRIVATE LIMITED",
"BELL GRANITO CERAMICA LIMITED",
"BELL HOTELS PRIVATE LIMITED",
"BELL INDUS FIBRECOM PRIVATE LIMITED",
"BELL IT&SS PRIVATE LIMITED",
"BELL MULTI KRAFT PRIVATE LIMITED",
"BELL PAINTS",
"BELL PHARMA PRIVATE LIMITED",
"BELL PYROTECHNICS PVT LTD",
"BELL SCALES PRIVATE LIMITED",
"BELL SECURITECH PRIVATE LIMITED",
"BELL TELE SERVISES INDIA PRIVATE LIMITED",
"BELL TEXTILES PRIVATE LIMITED",
"BELL WEATHER DEVELOPERS PRIVATE LIMITED",
"BELL WOVEN COMPANY INDIA PRIVATE LIMITED",
"BELLA ACADEMY PRIVATE LIMITED",
"BELLA CASA FASHION & RETAIL LIMITED",
"BELLA VIESTA APPARELS PRIVATE LIMITED",
"BELLAD AND COMPANY PRIVATE LIMITED",
"BELLAD AUTOMOBILES PRIVATE. LIMITED.",
"BELLAD ENGINEERS PRIVATE. LIMITED.",
"BELLAD ENTERPRISES PRIVATE LIMITED",
"BELLADONA PLASTERS LIMITED",
"BELLAFEM PHARMA LLP",
"BELLAPREMIER HAPPY HYGIENECARE PRIVATE LIMITED",
"BELLARY AUTOMOTIVE PRIVATE LIMITED",
"BELLARY IRON ORES PRIVATE LIMITED",
"BELLARY MOTOR SALES PRIVATE LIMITED",
"BELLARY OXYGEN COMPANY PRIVATE LIMITED",
"BELLATRIX INFRASTRUCTURE PRIVATE LIMITED",
"BELLATRIX LOGISTICS",
"BELLATRIX NETWORK COMMUNICATIONS PRIVATE LIMITED",
"BELLAVITA HEALTHCARE PRIVATE LIMITED",
"BELLBOI TECHNOLOGIES PRIVATE LIMITED",
"BELLCIA FASHION (OPC) PRIVATE LIMITED",
"BELLCROSS INDUSTRIES PRIVATE LIMITED",
"BELLE LABORATORIES PRIVATE LIMITED",
"BELLE LINGERIES PRIVATE LIMITED",
"BELLE SANTE DIAGNOSTIC AND THERAPEUTIC INSTITUTE PRIVATE LIMITED",
"BELLE VISION PRIVATE LIMITED",
"BELLE VUE CLINIC",
"BELLE VYAVASAYA SEVA SAHAKARI SANGHA (N) MOODUBELLE",
"BELLE WEARS PRIVATE LIMITED",
"BELLEE SPACE EDGE PRIVATE LIMITED",
"BELLEVUE HOTEL",
"BELLEVUE TRADERS PRIVATE LIMITED",
"BELLEZA COSMETICS AND PHARMACEUTICALS PRIVATE LIMITED",
"BELLEZA ENTERPRISES PRIVATE LIMITED",
"BELLEZZA INDIA PRIVATE LIMITED",
"BELLEZZA RETAIL PRIVATE LIMITED",
"BELLFAST MANAGEMENT PRIVATE LIMITED",
"BELLFAST TECHNOLOGIES PRIVATE LIMITED",
"BELLFLOWER FINANCE PRIVATE LIMITED",
"BELLIS HARDWARE PRIVATE LIMITED",
"BELLISSA PHARMACEUTICALS PRIVATE LIMITED",
"BELLISSIMO VENTURES PRIVATE LIMITED",
"BELLITE SPRINGS PRIVATE LIMITED",
"BELLMAN LOGISTICS INDIA PRIVATE LIMITED",
"BELLMER INDIA PRIVATE LIMITED",
"BELLONA ESTATE DEVELOPERS LIMITED",
"BELLONA NURSING HOME AND DIAGNOSTIC CENTRE PRIVATE LIMITED",
"BELLONA PAPER MILL PRIVATE LIMITED",
"BELLOR ESTATES AND HOTEL PRIVATE LIMITED",
"BELL-O-SEAL VALVES PRIVATE LIMITED",
"BELLOTA AGRISOLUTIONS AND TOOLS PRIVATE LIMITED",
"BELLS ELECTROTECH PVT.LTD.",
"BELLS GREEN FROZEN AND DESSERTS PRIVATE LIMITED",
"BELLS INSULATIONS PVT LTD",
"BELLSOFT INDIA SOLUTIONS PRIVATE LIMITED",
"BELLSOFT INDIA SOLUTIONS PRIVATE LIMITED AN AMERI 100 CO.",
"BELLSONICA AUTO COMPONENT INDIA PRIVATE LIMITED",
"BELLSTAR TRADING PRIVATE LIMITED",
"BELLSTONE HITECH INTERNATIONAL LIMITED",
"BELLURBIS TECHNOLOGIES PRIVATE LIMITED",
"BELLWETHER CAPITAL PRIVATE LIMITED",
"BELLY GEMS PRIVATE LIMITED",
"BELLZOIL OVERSEAS PRIVATE LIMITED",
"BELMAKS AUTOMOTIVES PRIVATE LIMITED",
"BELMAKS METAL ( INDIA ) PRIVATE LIMITED",
"BELMAKS PRIVATE LIMITED",
"BELMAN HOTELS PVT LTD",
"BELMOND HOTELS PRIVATE LIMITED",
"BELMONDO TRADING PRIVATE LIMITED",
"BELMONT GRAINS PRIVATE LIMITED",
"BELMONT RUBBER PRIVATE LIMITED",
"BELOFTE INDIA INTERNATIONAL PRIVATE LIMITED",
"BELOORBAYIR BIOTECH LIMITED",
"BELPUMPS (INDIA) PRIVATE LIMITED",
"BELRISE INDUSTRIES LIMITED",
"BELSAN MULTI-TEX PRIVATE LIMITED",
"BELSARE ENGINEERING PRIVATE LIMITED",
"BELSERI TEA CO. (INDIA) PRIVATE LTD",
"BELSINGHA SIKSHAYATAN HS",
"BELSTAR INVESTMENT AND FINANCE PRIVATE LIMITED",
"BELSTAR MICROFINANCE LIMITED",
"BELT AND BEARING HOUSE PRIVATE LIMITED",
"BELTAS MERCHANTS PVT LTD",
"BELTEC ENERGY RESOURCES PVT.LTD.",
"BELTECH ARTIFICIAL INTELLIGENCE PRIVATE LIMITED",
"BELTECNO INDIA PRIVATE LIMITED",
"BELTEK CANADIAN BEVERAGES PRIVATE LIMITED",
"BELTEK CANADIAN WATER LIMITED",
"BEL-THALES SYSTEMS LIMITED",
"BELTING ENTERPRISES PRIVATE LIMITED",
"BELUR ENGINEERING PRIVATE LIMITED",
"BELUR PADDY PROCESSING PRIVATE LIMITED",
"BELUX INDUSTRIES PRIVATE LIMITED",
"BELVEDERE GOLF AND COUNTRY CLUB PRIVATE LIMITED",
"BELVNUS PROJECTS PRIVATE LIMITED",
"BELWO SERVICES (INDIA) PRIVATE LIMITED",
"BELZ INSTRUMENTS PRIVATE LIMITED",
"BELZABAR SOFTWARE DESIGN INDIA PRIVATE LIMITED",
"BEMCEE PROCESSORS PRIVATE LIMITED",
"BEMCI INDUSTRIES PRIVATE LIMITED",
"BEMCO HYDRAULICS LIMITED",
"BEMCO JACKING SYSTEMS PRIVATE LIMITED",
"BEMCO SLEEPERS LIMITED",
"BEMISAL CONSTRUCTIONS PRIVATE LIMITED",
"BEML LAND ASSETS LIMITED",
"BEML LIMITED.",
"BEMOLAPUR TEA CO PVT LTD",
"BEN & GAWS PRIVATE LIMITED",
"BEN HUR PUBLIC SCHOOL",
"BEN LINE AGENCIESINDIAPRIVATE LIMITED",
"BEN SHERMAN GROUP LIMITED",
"BEN TECHNOLOGIES PRIVATE LIMITED",
"BENA INDIA PRIVATE LIMITED",
"BENAETH TECHNOLOGIES PRIVATE LIMITED",
"BENAIRE ENGINEERING PRIVATE LIMITED",
"BENAKA DEVELOPERS AND PROJECTS PRIVATE LIMITED",
"BENAKA MINERALS TRADING PRIVATE LIMITED",
"BENAPUR CHANDANAPARA HIGH SCH",
"BENARA BEARINGS AND PISTONS LIMITED",
"BENARA INFRASTRUCTURE DEVELOPMENT PRIVATE LIMITED",
"BENARA INTERNATIONAL PRIVATE LIMITED",
"BENARA UDYOG LIMITED",
"BENARAS INORGANICS PRIVATE LIMITED",
"BENARAS MEDIA WORKS PRIVATE LIMITED",
"BENARES HOTELS LIMITED",
"BENATTON PHARMACEUTICAL PRIVATE LIMITED",
"BENAZEER HOLDINGS PRIVATE LIMITED",
"BENCARDO BATHWARE INDIA PRIVATE LIMITED",
"BENCERA RESOURCES PRIVATE LIMITED",
"BENCH BIO PRIVATE LIMITED",
"BENCH MARK INFOTECH SERVICES PRIVATE LIMITED",
"BENCHKART SERVICES PRIVATE LIMITED",
"BENCHMAARKER HR SOLUTIONS PRIVATE LIMITED",
"BENCHMARK AGENCIES PRIVATE LIMITED",
"BENCHMARK BILLING SOLUTION PRIVATE LIMITED",
"BENCHMARK BROADCAST SYSTEMS PRIVATE LIMITED",
"BENCHMARK COMPUTER SOLUTIONS LIMITED",
"BENCHMARK COMPUTER SOLUTIONS PRIVATE LIMITED",
"BENCHMARK DEVELOPERS PRIVATE LIMITED",
"BENCHMARK INCENTIVE AND LEISURE TRAVELS PRIVATE LIMITED",
"BENCHMARK INTERNET GROUP INDIA PRIVATE LIMITED",
"BENCHMARK LIFESTYLE SOLUTIONS PRIVATE LIMITED",
"BENCHMARK MARCOM PRIVATE LIMITED",
"BENCHMARK MOTORS PRIVATE LIMITED",
"BENCHMARK PACKAGING PRIVATE LIMITED",
"BENCHMARK POLYTECHNIK PRIVATE LIMITED",
"BENCHMARK SALES PRIVATE LIMITED",
"BENCHMARK SIX SIGMA PRIVATE LIMITED",
"BENCHMARK SOFTEC PRIVATE LIMITED",
"BENCHMARK TEXTILES PRIVATE LIMITED",
"BENCHMARKING REVOLUTIONS PRIVATE LIMITED",
"BENCHMARRK PROMOTERS & BUILDERS PRIVATE LIMITED",
"BENCO THERMAL TECHNOLOGIES PRIVATE LIMITED",
"BEND JOINTS PRIVATE LIMITED",
"BENDER INDIA PRIVATE LIMITED",
"BENDFLEX MACHINERY INDIA PRIVATE LIMITED",
"BEND-N-FAB ENGINEERING PRIVATE LIMITED",
"BENDRA AEROSPACE PRIVATE LIMITED",
"BENE HYGIENE PRIVATE LIMITED",
"BENE INDIA OFFICE FURNITURE PRIVATE LIMITED",
"BENED SOFTWARE PRIVATE LIMITED",
"BENEDETTO KITCHENS PRIVATE LIMITED",
"BENEDIC PHARMACEUTICALS PRIVATE LIMITED",
"BENEFACTORY VENTURES PRIVATE LIMITED",
"BENEFICENT FLARE SOLUTIONS PRIVATE LIMITED",
"BENEFITALIGN TECHNOLOGIES PRIVATE LIMITED",
"BENEFITHUB INDIA PRIVATE LIMITED",
"BENEFITO INDIA PRIVATE LIMITED",
"BENEFITONE ENGAGEMENT TECHNOLOGIES PRIVATE LIMITED",
"BENEFITSPLUS MEDIA PRIVATE LIMITED",
"BENELEC INFOTECH PRIVATE LIMITED",
"BENENGG DESIGN & MANUFACTURING PRIVATE LIMITED",
"BENEO INDIA PRVATE LIMITED",
"BENEPIK TECHNOLOGY PRIVATE LIMITED",
"BENESTAR HEALTHCARE LLP",
"BENETT COLEMAN CO LIMITED",
"BENETTON ASIA PACIFIC LIMITED",
"BENETTON INDIA PRIVATE LIMITED",
"BENEVOLENCE TECHNOLOGIES PRIVATE LIMITED",
"BENFENLI FOODS PRIVATE LIMITED",
"BENFOCO OVERSEAS PRIVATE LIMITED",
"BENGAL - FAITH HEALTH CARE PRIVATE LIMITED",
"BENGAL & ASSAM COMPANY LIMITED",
"BENGAL AEROTROPOLIS PROJECTS LIMITED",
"BENGAL AGROVET PRIVATE LIMITED",
"BENGAL AMBUJA HOUSING DEVELOPMENT LIMITED",
"BENGAL AMBUJA METRO DEVELOPMENT LIMITED",
"BENGAL ANMOL SOUTH CITY INFRASTRUCTURE LIMITED",
"BENGAL BEVERAGES PRIVATE LIMITED",
"BENGAL BIHAR CARGO CARRIERS PVT LTD",
"BENGAL BIRBHUM COALFIELDS LIMITED",
"BENGAL BONDED WAREHOUSE LIMITED",
"BENGAL BUILDING SOLUTIONS PRIVATE LIMITED",
"BENGAL CHEMICALS AND PHARMACEUTICALS LTD",
"BENGAL COLD ROLLERS PVT LTD",
"BENGAL COLLEGE OF ENGINEERING AND TECHNOLOGY",
"BENGAL CONSTRUCTIONS PRIVATE LIMITED",
"BENGAL DCL HOUSING DEVELOPMENT COMPANY LIMITED",
"BENGAL ENERGY LIMITED",
"BENGAL ENGINEERING AND SCIENCE COLLGE",
"BENGAL ENGINEERING COLLEGE",
"BENGAL FINANCE AND INVESTMENT PRIVATE LIMITED",
"BENGAL GAS COMPANY LIMITED",
"BENGAL GREENFIELD HOUSING DEVELOPMENT COMPANY LIMITED",
"BENGAL HAMMER INDUSTRIES PVT LTD",
"BENGAL INDUSTRIES PRIVATE LIMITED",
"BENGAL INFERTILITY & REPRODUCTIVE THERAPY HOSPITAL PRIVATE LIMITED",
"BENGAL INSTITUTE OF BUSINESS STUDIES",
"BENGAL INSTITUTE OF TECHNOLOGY",
"BENGAL INTELLIGENT PARKS PRIVATE LIMITED",
"BENGAL INVESTMENTS LIMITED",
"BENGAL JUNEJA LEATHER COMPLEX LIMITED",
"BENGAL LUBRICANTS PRIVATE LIMITED",
"BENGAL MEDICAL STORES PRIVATE LIMITED",
"BENGAL MERLIN HOUSING LTD",
"BENGAL MUSIC COLLEGE",
"BENGAL NATIONAL CHAMBER OF COMMERCE & INDUSTRY",
"BENGAL NATURAL RESOURCES PRIVATE LIMITED",
"BENGAL NESTOR'S INDUSTRIES LTD.",
"BENGAL NRI COMPLEX LTD",
"BENGAL OMNITECH NIRMAN LIMITED",
"BENGAL PAPER AND BOX HOSPITALITY SERVICES PRIVATE LIMITED",
"BENGAL PARK CHAMBERS HOUSING DEVELOPMENT LIMITED",
"BENGAL PEERLESS HOUSING DEVELOPMENT COMPANY LTD",
"BENGAL POLYMERS PVT. LTD.",
"BENGAL PUBLISHERS PVT LTD",
"BENGAL QUALITY METAL PRODUCTS PRIVATE LIMITED",
"BENGAL RICE MILL PRIVATE LIMITED",
"BENGAL ROWING CLUB",
"BENGAL RUBBER COMPANY LTD",
"BENGAL SECURITY GUARDS PRIVATE LIMITED",
"BENGAL SEEDS & AGRO INDUSTRIES PRIVATE LIMITED",
"BENGAL SHAPOORJI DEVELOPERS PRIVATE LIMITED",
"BENGAL SHAPOORJI INFRASTRUCTURE DEVELOPMENT PRIVATE LIMITED",
"BENGAL SHELTER HOUSING DEVELOPMENT LIMITED",
"BENGAL SHRACHI HOUSING DEVELOPMENT LIMITED",
"BENGAL SHRIRAM HITECH CITY PRIVATE LIMITED",
"BENGAL SILICATES & CHEMICALS PRIVATE LIMITED",
"BENGAL STORES LTD.",
"BENGAL SUN SOLAR ENERGY I PRIVATE. LIMITED.",
"BENGAL SURGICALS LIMITED",
"BENGAL SWEETS PALACE PRIVATE LIMITED",
"BENGAL TECHNOCRATS PRIVATE LIMITED",
"BENGAL TIGER LINE INDIA PRIVATE LIMITED",
"BENGAL TILES & ART PRIVATE LIMITED",
"BENGAL TRACOM PRIVATE LIMITED",
"BENGAL UNITECH UNIVERSAL INFRASTRUCTURE PRIVATE LIMITED",
"BENGAL WINES PRIVATE LIMITED",
"BENGALCITY NIRMAN PRIVATE LIMITED",
"BENGALURU AIRPORT CITY LIMITED",
"BENGALURU AIRPORT SERVICES LIMITED",
"BENGALURU BIOMEDICALS PRIVATE LIMITED",
"BENGALURU GENOMICS CENTER PRIVATE LIMITED",
"BENGALURU LAW COLLEGE",
"BENGALURU LEISURE PRIVATE LIMITED",
"BENGALURU MEGACABS PRIVATE LIMITED",
"BENGALURU METROPOLITAN TRANSPORT CORPORATION",
"BENGALURU NEURO CENTER PRIVATE LIMITED",
"BENGALURU SMART CITY LIMITED",
"BENGANI COMMODITIES PRIVATE LIMITED",
"BENGANI ROLLER FLOUR MILLS PRIVATE LIMITED",
"BENGO SALES PRIVATE LIMITED",
"BENHADDED PHARMA PRIVATE LIMITED",
"BENHUR JEWELS PRIVATE LIMITED",
"BENI AGRO PRODUCTS PRIVATE LIMITED",
"BENIMADHAB CONSTRUCTION PRIVATE LIMITED",
"BENINCA AUTOMATIONS PRIVATE LIMITED",
"BENIR E STORE SOLUTIONS PRIVATE LIMITED",
"BENISON HEALTHCARE PRIVATE LIMITED",
"BENISON STOCK BROKING PRIVATE LIMITED",
"BENISON TECHNOLOGIES PRIVATE LIMITED",
"BENIT & CO ELECTRONICS PRIVATE LIMITED",
"BENITA GRANITES LIMITED",
"BENITHA TEXTILES PRIVATE LIMITED",
"BENITO BUSINESS DEVELOPMENT LIMITED",
"BENITO CERAMIC PRIVATE LIMITED",
"BENITO THERAPEUTIC PRIVATE LIMITED",
"BENIWAL ASSOCIATES PRIVATE LIMITED",
"BENIWAL CONSTRUCTION COMPANY PRIVATE LIMITED",
"BENKTESH SYNTH PROCESSORS PVT LTD",
"BENLINK (INDIA) PRIVATE LIMITED",
"BENLUX HOTELS INDIA PVT LTD",
"BENMED PHARMA PRIVATE LIMITED",
"BENMOON PHARMA RESEARCH PRIVATE LIMITED",
"BENN ELECTRICALS PVT LTD",
"BENNET AND BERNARD CUSTOM HOMES PRIVATELIMITED",
"BENNET PHARMACEUTICALS LIMITED",
"BENNETT & COLEMANS CO LIMITED",
"BENNETT COLEMAN & COMPANY LIMITED",
"BENNETT INSTITUTE OF HIGHER EDUCATION",
"BENNETT PROPERTY HOLDINGS COMPANY LIMITED",
"BENNETT TECHNOLOGIES PRIVATE LIMITED",
"BENNETT UNIVERSITY",
"BENNETT UNIVESITY",
"BENNEVOLANCE PHARMA PRIVATE LIMITED",
"BENNINGER INDIA PRIVATE LIMITED",
"BENNY IMPEX PRIVATE LIMITED",
"BENNY N BUNNY TOYS INDIA PRIVATE LIMITED",
"BENNY PRODUCTS PRIVATE LIMITED",
"BENNY'S ROYAL TOURS PRIVATE LIMITED",
"BENO SUPPORT TECHNOLOGIES PRIVATE LIMITED",
"BENON CHEMICALS(INDIA) PRIVATE LIMITED",
"BENORI KPO PRIVATE LIMITED",
"BENOVA LABS PRIVATE LIMITED",
"BENQ INDIA PRIVATE LIMITED",
"BENREEZA TRAVEL SERVICES PRIVATE LIMITED",
"BENSAN COMMERCIAL TRADE PRIVATE LIMITED",
"BENSAW TECHNOLOGIES PRIVATE LIMITED",
"BENSERON INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"BENSON ENGINEERS PRIVATE LIMITED",
"BENSON ESTATES PRIVATE LIMITED",
"BENSON MARINE SERVICES PRIVATE LIMITED",
"BENSON MEDICAL EQUIPMENTS PRIVATE LIMITED",
"BENSON MOVERS PRIVATE LIMITED",
"BENSON POLYMERS LIMITED",
"BENSTAR ELECTRONICS PRIVATE LIMITED",
"BENTA CERAMIC PRIVATE LIMITED",
"BENTEC BHARTIA ENGINEERS PVT LTD",
"BENTEC INDIA LIMITED",
"BENTEC ORGANO CLAYS PRIVATE LIMITED",
"BENTEK AUTOMATION PRIVATE LIMITED",
"BENTEL ASSOCIATES REALTY DESIGN CONSULTANTS PRIVATE LIMITED",
"BENTEL RETAIL DESIGN CONCEPTS PRIVATE.LIMITED",
"BENTELER AUTOMOTIVE INDIA PRIVATE LIMITED",
"BENTELER ENGINEERING CHENNAI PRIVATE LIMITED",
"BENTEN DEVELOPERS PRIVATE LIMITED",
"BENTENG (INDIA) PRECISION TECHNOLOGY PRIVATE LIMITED",
"BENTEX BUILDERS PVT LTD",
"BENTEX CONTROL & SWITCHGEAR S PRIVATE LIMITED",
"BENTEX ENGINEERING PRIVATE LIMITED",
"BENTEX INDUSTRIALS PRIVATE LIMITED",
"BENTINCK INDUSTRIES PRIVATE LIMITED",
"BENTLAY FITTINGS LIMITED",
"BENTLAY PIPES PRIVATE LIMITED",
"BENTLEY AND REMINGTON PRIVATE LIMITED",
"BENTLEY COMMERCIAL ENTERPRISES LTD",
"BENTLEY SYSTEMS INDIA PRIVATE LIMITED",
"BENTLY FABRICS PRIVATE LIMITED",
"BENTOCLAY INTERNATIONAL PRIVATE LIMITED",
"BENTOLI AGRINUTRITION INDIA PRIVATE LIMITED",
"BENTON BLEACH-CHEM INDIA PRIVATE LIMITED",
"BENTOOL STEEL PRODUCTS PRIVATE LIMITED",
"BENTRON COMMERCIAL PVT LTD",
"BENU NETWORKS PACKET SWITCH PRIVATE LIMITED",
"BENVIA SOFTWARE INDIA PRIVATE LIMITED",
"BENZ CLOTHING LINE PRIVATE LIMITED",
"BENZ FURNITURE PRIVATE LIMITED",
"BENZ INDIA PRIVATE LIMITED",
"BENZ INDIA WIRES PRIVATE LIMITED",
"BENZ PACKAGING SOLUTIONS PRIVATE LIMITED",
"BENZ SUITING PRIVATE LIMITED",
"BENZE TV PRIVATE LIMITED",
"BENZER DEPARTMENT STORES PRIVATE LIMITED",
"BENZER MULTITECH INDIA PRIVATE LIMITED",
"BENZFAB TECHNOLOGIES PRIVATE LIMITED",
"BENZI INAPEX PRIVATE LIMITED",
"BENZNE CONSULTING PRIVATE LIMITED",
"BENZO CHEM INDUSTRIES PRIVATE LIMITED",
"BENZO PRODUCTS (INDIA) PVT LTD",
"BENZOCHEM LIFE SCIENCES",
"BENZY FOOD AND BEVERAGES PRIVATE LIMITED",
"BENZY HOLIDAYS PRIVATE LIMITED",
"BENZY INFOTECH PRIVATE LIMITED",
"BENZY TOURS AND TRAVELS PRIVATE LIMITED",
"BEO SOFTWARE PRIVATE LIMITED",
"BEOHARI BANSUKLI PATHWAYS PRIVATE LIMITED",
"BEP ENGINEERING PRIVATE LIMITED",
"BEPEC SOLUTIONS (OPC) PRIVATE LIMITED",
"BEPURE TECH PRIVATE LIMITED",
"BEQISOFT TECHNOLOGIES PRIVATE LIMITED",
"BERA CONMAT PRIVATE LIMITED",
"BERACHAH FLEXIPACK PRIVATE LIMITED",
"BERALIA ROADLINES PRIVATE LIMITED",
"BERALMAR INDIA COMBUSTION ENGINEERING & EQUIPMENT PRIVATE LIMITED",
"BERAR FINANCE LIMITED",
"BERAR METAL PROCESSING INDUSTRIES PVT LTD",
"BERATUNG CONSULTANTS PRIVATE LIMITED",
"BERBRICK HEALTHCARE PRIVATE LIMITED",
"BERCO UNDERCARRIAGES INDIA PRIVATE LIMITED",
"BERDIA MARKETING PRIVATE LIMITED",
"BEREICHERN HELPLINE INDIA PRIVATE LIMITED",
"BERG AND SCHMIDT INDIA PRIVATE LIMITED",
"BERG TRADING PRIVATE LIMITED",
"BERGE SPORTS & FASHION PRIVATE LIMITED",
"BERGEN ASSOCIATES PRIVATE LIMITED",
"BERGEN ELECTRONICS LIMITED",
"BERGEN ENGINES INDIA PRIVATE LIMITED",
"BERGEN HEALTHCARE PRIVATE LIMITED",
"BERGEN LED AND SOLAR PRODUCTS PRIVATE LIMITED",
"BERGEN PIPE SUPPORTS INDIAPRIVATE LIMITED",
"BERGEN SOLAR POWER AND ENERGY LIMITED",
"BERGEN SYSTEMS PRIVATE LIMITED",
"BERGER BECKER COATINGS PRIVATE LIMITED",
"BERGER NIPPON PAINT AUTOMOTIVE COATINGS PRIVATE LIMITED",
"BERGER PAINTS INDIA LIMITED",
"BERGER ROCK PAINTS PRIVATE LIMITED",
"BERGGRUEN CAR RENTALS PRIVATE LIMITED",
"BERGGRUEN HOTELS PRIVATE LIMITED",
"BERGGRUEN LOGISTICS INDIA PRIVATE LIMITED",
"BERGNER IMPEX INDIA PRIVATE LIMITED",
"BERGWERFF ORGANIC INDIA PRIVATE LIMITED",
"BERHAMPORE CITY HOSPITAL PRIVATE LIMITED",
"BERHAMPUR AGRO-MED AND DAIRY FARM PRIVATE LIMITED",
"BERHAMPUR MARKETING PRIVATE LIMITED",
"BERI BUILTSPACE DESIGNS PRIVATE LIMITED",
"BERI INFRAPROJECTS PRIVATE LIMITED",
"BERI RESOURCES PRIVATE LIMITED",
"BERI UDYOG PRIVATE LIMITED",
"BERIA BROTHERS PVT LTD",
"BERICAP INDIA PRIVATE LIMITED",
"BERICO SALES AND SERVICES PRIVATE LIMITED",
"BERILISHUS FOODS PRIVATE LIMITED",
"BERINA COSMETICS PRIVATE LIMITED",
"BERIWALA ELECTRONICS PRIVATE LIMITED",
"BERK AUTO LIMITED LIABILITY PARTNERSHIP",
"BERK MOTORCAR LIMITED LIABILITY PARTNERSHIP",
"BERKA INFRASTRUCTURE AND DEVELOPERS PRIVATE LIMITED",
"BERKADIA SERVICES INDIA PRIVATE LIMITED",
"BERKEL INDUSTRIES PRIVATE LIMITED",
"BERKELEY COMMODITIES LIMITED",
"BERKELEY ENERGY INDIA PRIVATE LIMITED",
"BERKELEY ENERGY RENEWABLES INDIA",
"BERKELEY FINANCE LIMITED",
"BERKELEY INSURANCE BROKERS LIMITED",
"BERKELEY MOTORS LIMITED",
"BERKELEY RETAILS LIMITED",
"BERKELEY SECURITIES LIMITED",
"BERKMAN FORWARDING INDIA PRIVATE LIMITED",
"BERKMANN WINE CELLARS INDIA PRIVATE LIMITED",
"BERKSHIRE HATHAWAY",
"BERKSHIRE INDIA LIMITED",
"BERLIA ASSOCIATES PRIVATE LIMITED",
"BERLIA ELECTRICALS PRIVATE LIMITED",
"BERLIA FRESH FOODS & BEVERAGES PRIVATE LIMITED",
"BERLIA MOTORS PRIVATE LIMITED",
"BERMACO ENERGY SYSTEMS LIMITED",
"BERMAD INDIA PRIVATE LIMITED",
"BERN TRADING PVT LTD",
"BERNHARD SCHULTE SHIPMANAGEMENT INDIA PRIVATE LIMITED",
"BERNHARD SCHULTE SHIPPING INDIA PRIVATE LIMITED",
"BERNINA INTERNATIONAL PRIVATE LIMITED",
"BEROE CONSULTING INDIA PRIVATE LIMITED",
"BE'ROLLEX PRIVATE LIMITED",
"BEROMT PRIVATE LIMITED",
"BERONIKA INTERNATIONAL PRIVATE LIMITED",
"BERRIO LOGISTICS (INDIA) PRIVATE LIMITED",
"BERRIO LOGISTICS INDIA PRIVATE LIMITED",
"BERRY & HERBS PHARMA PRIVATE LIMITED",
"BERRY ALLOYS LIMITED",
"BERRY COTTS PVT LTD",
"BERRY DEVELOPERS AND INFRASTRUCTURE PRIVATE LIMITED",
"BERRY FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"BERRY MARBLE INDUSTRIES PRIVATE LIMITED",
"BERRY TEX PRIVATE LIMITED",
"BERRY TRADING LIMITED",
"BERRYBLUE HOSPITALITY PRIVATE LIMITED",
"BERRYLUSH DESIGNS PRIVATE LIMITED",
"BERRYMAN CHEMICAL INDIA PRIVATE LIMITED",
"BERRYS AUTO ANCILLARIES PRIVATE LIMITED",
"BERRYSON INDIA PRIVATE LIMITED",
"BERTECH PRIVATE LIMITED",
"BERTELSMANN CORPORATE SERVICES INDIA PRIVATE LIMITED",
"BERTHOLD TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"BERYL AQUA PRIVATE LIMITED",
"BERYL CONSULTECH PRIVATE LIMITED",
"BERYL DRUGS LIMITED",
"BERYLLINE LABS PRIVATE LIMITED",
"BES CONSULTANTS PRIVATE LIMITED",
"BES DESIGNS PRIVATE LIMITED",
"BESCON BOREWELL COMPRESSOR EQUIPMENTS PRIVATE LIMITED",
"BESET DISTRIBUTION SERVICES PRIVATE LIMITED",
"BESHOP COTTON SCHOOL SHIMLA",
"BESI DRUGS PVT LTD",
"BESIVA LIFESTYLE PRIVATE LIMITED",
"BESMAK COMPONENTS PRIVATE LIMITED",
"BESO ENTERPRISES PRIVATE LIMITED",
"BESOTO STARTING SYSTEMS PRIVATE LIMITED",
"BESPASK ENGINEERS PRIVATE LIMITED",
"BESPOEK TECHNOLOGIES PRIVATE LIMITED",
"BESPOKE BEAUTY PRIVATE LIMITED",
"BESPOKE HOLDINGS PRIVATE LIMITED",
"BESPOKE IT SOLUTIONS PRIVATE LIMITED",
"BESPOKE LOGISTICS PRIVATE LIMITED",
"BESPOKE MANAGEMENT CONSULTING PRIVATE LIMITED",
"BESPOKE PACKAGING INDIA PRIVATE LIMITED",
"BESSOTA INTERNATIONAL PRIVATE LIMITED",
"BEST",
"BEST & BEYOND INFRA",
"BEST ADVERTISING SOLUTION LTD",
"BEST AGROCHEM PRIVATE. LIMITED",
"BEST AGROLIFE LIMITED",
"BEST ALTERNATIVE ADVISORY SERVICES LLP",
"BEST APARTMENTS PRIVATE LIMITED",
"BEST APPS BUSINESS SOLUTIONS PRIVATE LIMITED",
"BEST AUTO LIMITED",
"BEST AUTO PRIVATE LIMITED",
"BEST BARCODE SYSTEM PRIVATE LIMITED",
"BEST BASKET SUPERMARKET PRIVATE LIMITED",
"BEST BOND STEELS PRIVATE LIMITED",
"BEST BRICKS AND TILE WORKS PVT LTD",
"BEST BUILD RETAIL PRIVATE LIMITED",
"BEST BUILDWELL PRIVATE LIMITED",
"BEST BUY CO. INC.",
"BEST BUY MART",
"BEST CAPITAL SERVICES LIMITED",
"BEST CARRIER PRIVATE LIMITED",
"BEST CAST IT LIMITED",
"BEST CHERAN SPINTEX INDIA LIMITED",
"BEST COLOUR SOLUTIONS INDIA PRIVATE LIMITED",
"BEST CONTAINERS PRIVATE LIMITED",
"BEST CORPORATION PRIVATE LIMITED",
"BEST COTTON MILLS PRIVATE LIMITED",
"BEST CRANE & LOGISTICS",
"BEST CRANES PRIVATE LIMITED",
"BEST CREATIVE SOLUTIONS PRIVATE LIMITED",
"BEST DEAL FINANCE COM PRIVATE LIMITED",
"BEST DEAL FOREX PRIVATE LIMITED",
"BEST EASTERN HOTELS LIMITED",
"BEST ENGINEERING AIDS AND CONSULTANCIES PRIVATE. LIMITED",
"BEST ENGINEERS PUMPS PRIVATE LIMITED",
"BEST ENTER TAINMENT PRIVATE LIMITED",
"BEST ENTERTAINMENT PRIVATE LIMITED",
"BEST EXPORTS CENTRE PRIVATE LIMITED",
"BEST FERTICARE PRIVATE LIMITED",
"BEST FINANCE CORPORATION LIMITED",
"BEST FORGINGS INDIA PRIVATE LIMITED",
"BEST GEOTECHNICS PRIVATE LIMITED",
"BEST GOLDEN DEVELOPERS PRIVATE LIMITED",
"BEST HAWK INFOSYSTEMS PRIVATE LIMITED",
"BEST HEALTHCARE PRIVATE LIMITED",
"BEST HOME APPLIANCES",
"BEST HORTICULTURE AND CONSULTANCY PRIVATE LIMITED",
"BEST HOSPITAL",
"BEST HOSPITALITY (INDIA) PRIVATE LIMITED",
"BEST INDIA FOOD PROCESSING PRIVATE LIMITED",
"BEST INDIA LOGISTICSS PRIVATE LIMITED",
"BEST INDIA TOBACCO SUPPLIERS PRIVATE LIMITED",
"BEST INDIANBITES PRIVATE LIMITED",
"BEST INDUSTRIAL ELECTRICALS INDIA PRIVATE LIMITED",
"BEST INDUSTRIAL SECURITY FORCE PRIVATE LIMITED",
"BEST INSTITUTE OF TRAINING & INSTITUTIONS PRIVATE LIMITED BITI",
"BEST INTERNATIONAL PROJECTS PRIVATE LIMITED",
"BEST IT WORLD INDIA PRIVATE LIMITED",
"BEST KNITTING MILLS PRIVATE LIMITED",
"BEST KOKI AUTOMOTIVE PRIVATE LIMITED",
"BEST LABEL COMPANY PRIVATE LIMITED",
"BEST LABELS ENTERPRISES PRIVATE LIMITED",
"BEST LABORATORIES PRIVATE LIMITED",
"BEST LAMINATIONS PRIVATE LIMITED",
"BEST MEDICAL PRIVATE LIMITED",
"BEST MEDILINKS PRIVATE LIMITED",
"BEST MONEY GOLD JEWELLERY LIMITED",
"BEST MULYANKAN CONSULTANTS LIMITED",
"BEST NEWS COMPANY PRIVATE LIMITED",
"BEST OF BREED SOFTWARE SOLUTIONS INDIA PRIVATE LIMITED",
"BEST ONE TOOLS PRIVATE LIMITED",
"BEST OPTION SALES PRIVATE LIMITED",
"BEST PAPER MILLS PRIVATE LIMITED",
"BEST POLYCHEM LIMITED",
"BEST PORTFOLIOS PRIVATE LIMITED",
"BEST POWER EQUIPMENTS INDIA PRIVATE LIMITED",
"BEST PRACTICE WASHROOMS PRIVATE LIMITED",
"BEST PRINT SOLUTIONS LLP",
"BEST PROCESSORS PRIVATE LIMITED",
"BEST PUMPS INDIA PRIVATE LIMITED",
"BEST REALBUILD (INDIA) PRIVATE LIMITED",
"BEST ROADWAYS LIMITED",
"BEST SECURITY SERVICES PRIVATE LIMITED",
"BEST SELLERS APPARELS PRIVATE LIMITED",
"BEST SOURCE INFOTECH CHENNAI PRIVATE LIMITED",
"BEST STAMPING PRIVATE LIMITED",
"BEST STEEL FURNITURE SERVICES",
"BEST STEEL SOLUTIONS PRIVATE LIMITED",
"BEST TECH MECH AND INFRA ENGINEERS PRIVATE LIMITED",
"BEST TECHNO PARKS PRIVATE LIMITED",
"BEST TOURS & FOREX PRIVATE LIMITED",
"BEST TRACKS SHIPPING AND LOGISTICS PRIVATE LIMITED",
"BEST TRUCKERS PRIVATE LIMITED",
"BEST UNITED INDIA COMFORTS PRIVATE LIMITED",
"BEST VALUE CHEM PRIVATE LIMITED",
"BEST VISION EYE HOSPITAL",
"BEST VOYAGE PRIVATE LIMITED",
"BEST WESTERN MERRION AMRITSAR",
"BESTALL MACHINING AND FABRICATION PRIVATE LIMITED",
"BESTBUILT LANDZONE LIMITED",
"BESTCARE FORMULATIONS PRIVATE LIMITED",
"BESTCHEM INSECTICIDES PRIVATE LIMITED",
"BESTCITY ESTATE MANAGEMENT PRIVATE LIMITED",
"BESTCO CABLES PRIVATE LIMITED",
"BESTCONCERN SERVICES PRIVATE LIMITED",
"BESTDEAL MACHINERIES PRIVATE LIMITED",
"BESTDOC TECHNOLOGY PRIVATE LIMITED",
"BESTECH BIOTECH PRIVATE LIMITED",
"BESTECH HOSPITALITIES PRIVATE LIMITED",
"BESTECH HOTELS PRIVATE LIMITED",
"BESTECH INDIA PRIVATE LIMITED",
"BESTECH INDIA PRIVATE. LIMITED",
"BESTECH SEED INDIA PRIVATE LIMITED",
"BESTEK AUTOMATION TECHNOLOGIES PRIVATE LIMITED",
"BESTEK ENGINEERING PRIVATE LIMITED",
"BESTEL LABORATORIES PRIVATE LIMITED",
"BESTEX ENGINEERING INDIA PRIVATE LIMITED",
"BESTEX MM INDIA PRIVATE LIMITED",
"BESTFOLIO SOLUTIONS PRIVATE LIMITED",
"BESTIES TRADING PRIVATE LIMITED",
"BESTIME TRADING COMPANY PRIVATE LIMITED",
"BESTINDIA ROOF PRODUCTS PRIVATE LIMITED",
"BESTINET INDIA PRIVATE LIMITED",
"BESTING COMMUNICATIONS LLP",
"BESTIR SOFTWARE SERVICES PRIVATE LIMITED",
"BESTO ELECTRONICS PRIVATE LIMITED",
"BESTO ICE CREAMS PRIVATE LIMITED",
"BESTO TRADELINK PRIVATE LIMITED",
"BESTOCHEM FORMULATIONS INDIA LIMITED",
"BESTODENT INDIA PRIVATE LIMITED",
"BESTON SKY VISION PRIVATE LIMITED",
"BESTONNE GRANITE METALS PRIVATE LIMITED",
"BESTOPLAST INDUSTRIES PRIVATE LIMITED",
"BESTOVO FOODS PRIVATE LIMITED",
"BESTOW PACKAGING PRIVATE LIMITED",
"BESTOWAL INDUSTRIES PRIVATE LIMITED",
"BESTPAY SOLUTIONS PRIVATE LIMITED",
"BESTPEERS INFOSYSTEM PRIVATE LIMITED",
"BESTSELLER FASHION INDIA PRIVATE LIMITED",
"BESTSELLER RETAIL INDIA PRIVATE LIMITED",
"BESTSELLER VENTURES PRIVATE LIMITED",
"BESTSELLER WHOLESALE INDIA PRIVATE LIMTED",
"BESTSELLERS COCHIN PVT LTD",
"BESTSERVE PEST MANAGEMENT PRIVATE LIMITED",
"BESTVANTAGE TECHNOLOGY INDIA PRIVATE LIMITED",
"BESTWAY AGENCIES PRIVATE LIMITED",
"BESTWAY CABS SERVICES PRIVATE LIMITED",
"BESTWAY HEALTH AND FUTURE PRIVATE LIMITED",
"BESTWAY TOURS AND SAFARIS PRIVATE LIMITED",
"BESTWELL POLYTUBE INDUSTRY PRIVATE LIMITED",
"BESURE (INDIA) PRIVATE LIMITED",
"BESURE HEALTH CARE PRIVATE LIMITED",
"BET MEDICAL PRIVATE LIMITED",
"BETA AGENCIESANDPROJECTS PRIVATE LIMITED",
"BETA AV SYSTEMS PRIVATE LIMITED",
"BETA CAE SYSTEMS INDIA PRIVATE LIMITED",
"BETA COMPUTRONICS PRIVATE LIMITED",
"BETA CONSULTANCY HR SERVICES PRIVATE LIMITED",
"BETA DRUGS LIMITED",
"BETA HEALTH CARE PRODUCTS PRIVATE LIMITED",
"BETA LED LIGHTING PRIVATE LIMITED",
"BETA MASCHINENFABRIK PRIVATE LIMITED",
"BETA MEDIKIT PRIVATE LIMITED",
"BETA POLY PLAST PRIVATE LIMITED",
"BETA SECURITIES PRIVATE LIMITED",
"BETA TECH CONSULTANCY AND MARKETTING PRIVATE LIMITED",
"BETA THREE AUDIO INDIA PRIVATE LIMITED",
"BETA THREE ELECTRONICS INDIA PRIVATE LIMITED",
"BETA WIND FARM PRIVATE LIMITED",
"BETACREW SOLUTIONS PRIVATE LIMITED",
"BETACURA HEALTH SOLUTIONS PRIVATE LIMITED",
"BETAFLEX JOINTING PRIVATE LIMITED",
"BETAFLUX CONSULTING PRIVATE LIMITED",
"BETAL ENGINEERING PRIVATE LIMITED",
"BETALA STOCK BROKING LIMITED",
"BETAM LABORATORIES PRIVATE LIMITED",
"BETAM WIND ENERGY PRIVATE LIMITED",
"BETAMAX REMEDIES PRIVATE LIMITED",
"BETAMONKS TECHNOLOGY FACTORY PRIVATE LIMITED",
"BETATEST SOLUTIONS PRIVATE LIMITED",
"BETEX INDIA LIMITED",
"BETEX INDIA LIMITED (CO TR FROM MAHA )",
"BETH LIFESTYLE PRIVATE LIMITED",
"BETHALA PETROPACKS PRIVATE LIMITED",
"BETHANY EDUCATIONAL SOCIETY",
"BETHANY INSTITUTIONS",
"BETHANY TRUST BETHANY HOSPITAL",
"BE-THE-BEE COM DESIGNS PRIVATE LIMITED",
"BETHEL CASHEW COMPANY",
"BETHEL CONSULTANCY PRIVATE LIMITED",
"BETHEL ENGINEERING PRIVATE LIMITED",
"BETHEL HOSPITAL PRIVATE LIMITED",
"BETHEL MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"BETHEL MATRICULATION HIGHER SECONDARY SCHOOL",
"BETHEL PLANTATIONS PRIVATE LIMITED",
"BETHUADAHARI FOREIGN LIQUOR OFF SHOP PRIVATE LIMITED",
"BETHUNE COLLEGE CALCUTTA",
"BETON STONE SOLUTIONS INDIA PRIVATE LIMITED",
"BETONBATCH PRIVATE LIMITED",
"BETRUST INDUSTRIES PRIVATE LIMITED",
"BETSOL SOFTWARE (INDIA) PRIVATE LIMITED",
"BETTER & BRIGHTER HOMECARE PRIVATE LIMITED",
"BETTER BUILDING PRODUCTS PRIVATE LIMITED",
"BETTER COMFORT PRIVATE LIMITED",
"BETTER COMMUNICATIONS PRIVATE LIMITED",
"BETTER EARTH JEWELS PRIVATE LIMITED",
"BETTER FEEDS PRIVATE LIMITED",
"BETTER POWER SERVICES PRIVATE LIMITED",
"BETTER SERVICES PRIVATE LIMITED",
"BETTER TOMORROW INFRASTRUCTURE AND SOLUTION PRIVATE LIMITED",
"BETTER VALUE HOLDINGS PRIVATE LIMITED",
"BETTER WORLD DIGITAL SOLUTIONS PRIVATE LIMITED",
"BETTER WORLD FOUNDATION",
"BETTER WORLD TECHNOLOGY PRIVATE LIMITED",
"BETTER YOURSELF BOOKS & MEDIA PRIVATE LIMITED",
"BETTERDEAL MACHINERIES PRIVATE LIMITED",
"BETTERFEEL DIAGNOSTICS PRIVATE LIMITED",
"BETTERHALF PRIVATE LIMITED",
"BETTERLYF WELLNESS (OPC) PRIVATE LIMITED",
"BETTERMAN ENGINEERS PRIVATE LIMITED",
"BETTERMAN FERRO CAST PRIVATE LIMITED",
"BETTERPLACE SAFETY SOLUTIONS PRIVATE LIMITED",
"BETTERPLACE SELECT",
"BETTERSERV VENTURES PRIVATE LIMITED",
"BETTERWISER SERVICES PRIVATE LIMITED",
"BETTERWORLD DESIGNS PRIVATE LIMITED",
"BETTINELLI AUTOMATION COMPONENTS PRIVATE LIMITED",
"BETTS INDIA PRIVATE LIMITED",
"BETUL FLUSH DOORS PVT LTD",
"BETUL MINERALS AND CONSTRUCTION PRIVATE LIMITED",
"BETUL OIL LIMITED",
"BETUL WIND FARMS LIMITED",
"BETUL WIND FARMS PRIVATE LIMITED",
"BETWA ICE & COLD STORAGE PRIVATE LIMITED",
"BETWA INFRASTRUCTURES PRIVATE LIMITED",
"BEULAH BIOMEDICS",
"BEUMER INDIA PRIVATE LIMITED",
"BEURER INDIA PRIVATE LIMITED",
"BEVA SILICONES PRIVATE LIMITED",
"BEVCON WAYORS PRIVATE LIMITED",
"BEVEL GEARS INDIA PRIVATE LIMITED",
"BEVEL TRADING & MARKETING PRIVATE LIMITED",
"BEVERLY FARMS PRIVATE LIMITED",
"BEVERLY HOTELS PRIVATE LIMITED",
"BEVYWISE NETWORKS LLP",
"BEW ENGINEERING LIMITED",
"BEWAKOOF BRANDS PRIVATE LIMITED",
"BEWEALTHY CONSULTANTS PRIVATE LIMITED",
"BEWERTEN SOLUTIONS PRIVATE LIMITED",
"BEWGLE TECHNOLOGIES PRIVATE LIMITED",
"BEX TRAVEL INDIA PRIVATE LIMITED",
"BEYANT HOLDING & FINANCE LIMITED",
"BEYBEY ENGINEERING & EXIM PRIVATE LIMITED",
"BEYCOMP ELECTRONICS PRIVATE LIMITED",
"BEYERDYNAMIC INDIA PRIVATE LIMITED",
"BEYNONSMITH PU COLLEGE BELGAUM",
"BEYONCE INFOTECH PRIVATE LIMITED",
"BEYOND ACCOUNTING SOLUTION PRIVATE LIMITED",
"BEYOND BORDERS LOGISTICS PRIVATE LIMITED",
"BEYOND CREATION FABRICS PRIVATE LIMITED",
"BEYOND DESIGN ARCHITECTS & CONSULTANTS PRIVATE LIMITED",
"BEYOND DIGITAL SOLUTIONS PRIVATE LIMITED",
"BEYOND DOORS PRIVATE LIMITED",
"BEYOND DREAMS ENTERTAINMENT PRIVATE LIMITED",
"BEYOND DRILLING AND EXPLORATION PRIVATE LIMITED",
"BEYOND HOME SOLUTIONS PRIVATE LIMITED",
"BEYOND INFINITY BUSINESS SOLUTIONS PRIVATE LIMITED",
"BEYOND KEY SYSTEMS PRIVATE LIMITED",
"BEYOND LIFE FINANCIAL SERVICES LLP",
"BEYOND LOGISTICS PRIVATE LIMITED",
"BEYOND NEXT VENTURES INDIA PRIVATE LIMITED",
"BEYOND REAL ESTATE PRIVATE LIMITED",
"BEYOND RESEARCH AND DEVELOPMENT LIMITED",
"BEYOND SQUAREFEET ADVISORY PRIVATE LIMITED",
"BEYOND TELE PRIVATE LIMITED",
"BEYOND UNIVERSE SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"BEYONDATA SOLUTIONS PRIVATE LIMITED",
"BEYONDEX SOLUTIONS PRIVATE LIMITED",
"BEYONDID MANAGED SERVICES INDIA PRIVATE LIMITED",
"BEYONDSCALE TECHNOLOGIES PRIVATE LIMITED",
"BEYONDSQUARE SOLUTIONS PRIVATE LIMITED",
"BEYONDTECH IT CONSULTING PRIVATE LIMITED",
"BEYONTEC 2NABLE SOLUTIONS PRIVATE LIMITED",
"BEYOUNG FOLKS PRIVATE LIMITED",
"BEZA ENERGY PRIVATE LIMITED",
"BEZARES ALPHA DRIVES INDIA PRIVATE LIMITED",
"BEZEL COMMODITIES PRIVATE LIMITED",
"BEZEL IMPEX PVT LTD",
"BEZEL INDUSTRIES LIMITED",
"BEZWADA BIOMEDICAL RESEARCH PRIVATE LIMITED",
"BF GOODRICH PERFORMANCE MATERIALS ASIA PACIFIC LIMITED",
"BF INDUSTRIAL TECHNOLOGY & SOLUTIONS LIMITED",
"BF INFRASTRUCTURE LIMITED",
"BF INVESTMENT LIMITED",
"BF PRECISION PRIVATE LIMITED",
"BF UTILITIES LIMITED",
"BFC CAPITAL PRIVATE LIMITED",
"BFC FOREX AND FINANCIAL SERVICES PRIVATE LIMITED",
"BFCL TERMINAL PRIVATE LIMITED",
"BFG INTERNATIONAL PRIVATE LIMITED",
"BFL ASSET FINVEST LIMITED",
"BFL INFOTECH LIMITED",
"BFL INVESTMENTS & FINANCIAL CONSULTANTS PRIVATE LIMITED",
"BFL PRIVATE LIMITED",
"BFMS FACILITY MANAGEMENT PRIVATE LIMITED",
"BFN FORGINGS PRIVATE LIMITED",
"BFS PROCESSOR PRIVATE LIMITED",
"BFS TECHNOLOGIES PRIVATE LIMITED",
"BFSI SECTOR SKILL COUNCIL OF INDIA",
"BG (RAJASTHAN) HIGHWAY PRIVATE LIMITED",
"BG ALIGARH KANPUR HIGHWAY PRIVATE LIMITED",
"BG APPLIANCES PRIVATE LIMITED",
"BG BHADRAK BALESHWAR HIGHWAY PRIVATE LIMITED",
"BG CROP SCIENCE AND TECHNOLOGIES PRIVATE LIMITED",
"BG ELEVATORS AND ESCALATORS PRIVATE LIMITED",
"BG EXPLORATION & PRODUCTION INDIA LIMITED",
"BG FARMERS PRODUCER COMPANY LIMITED",
"BG FASTENING AND ENGINEERING INDUSTRIES PRIVATE LIMITED",
"BG LI IN ELECTRICALS LIMITED",
"BG LI-IN ELECTRICALS LIMITED",
"BG MP HIGHWAY PRIVATE LIMITED",
"BG NETWORKS PRIVATE LIMITED",
"BG PACKS PVT LTD",
"BG SENSOR (INDIA) PRIVATE LIMITED",
"BG TEA VYAPAR PRIVATE LIMITED",
"BG WIND POWER LIMITED",
"BGA ELECTRICAL & SERVICES PRIVATE LIMITED",
"BGB INFRASTRUCTURE PRIVATE LIMITED",
"BGCC DEVELOPERS PRIVATE LIMITED",
"BGCC INFRAPROJECTS PRIVATE LIMITED",
"BGFECOMATERIALS INDIA PRIVATE LIMITED",
"BGI ENGITECH PRIVATE LIMITED",
"BGK INFRATECH PRIVATE LIMITED",
"BGM MILLS PRIVATE LIMITED",
"BGM PETROCHEM PRIVATE LIMITED",
"BGM TELECOMMUNICATIONS PRIVATE LIMITED",
"BGN MEDTEX INDIA PRIVATE LIMITED",
"BGN PROPERTIES PRIVATE LIMITED",
"BGN TRADING PRIVATE LIMITED",
"BGPS MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"BGR BOILERS PRIVATE LIMITED",
"BGR CONSTRUCTION LLP",
"BGR ENERGY SYSTEMS LIMITED",
"BGR ENGINEERING SERVICES PRIVATE LIMITED",
"BGR MINING & INFRA LIMITED",
"BGR NEO LIMITED",
"BGR ODISHA POWERGEN LIMITED",
"BGR SUPPLY CHAIN SYSTEMS PRIVATE LIMITED",
"BGR TURBINES COMPANY PRIVATE LIMITED",
"BGRL LOGISTICS PRIVATE LIMITED",
"BGRS GLOBAL INDIA PRIVATE LIMITED",
"BGRS TEXTILES PRIVATE LIMITED",
"BGS CLOTHING COMPANY PRIVATE LIMITED",
"BGS GLOBAL INSTITUTE OF MEDICAL SCIENCES",
"BGS INTERNATIONAL PUBLIC SCHOOL",
"BGS INTERNATIONAL RESIDENTIAL SCHOOL",
"BGS LOGISTICS PRIVATE LIMITED",
"BGS NATIONAL PUBLIC SCHOOL",
"BGS PU COLLEGE",
"BGS PUBLIC SCHOOL",
"BGS SCHOOL OF ARCHITECTURE AND PLANNING",
"BGS STEEL INDUSTRIES PRIVATE LIMITED",
"BGS UNITED SCHOOL",
"BGS WORLD SCHOOL",
"BGSB CONCRETE SOLUTIONS PRIVATE LIMITED",
"BGSE FINANCIALS LIMITED",
"BGSE PROPERTIES AND SECURITIES LIMITED",
"BGSG PACKAGING SOLUTIONS PRIVATE LIMITED",
"BGSS VEHICLES PRIVATE LIMITED",
"BH ADVISORS PRIVATE LIMITED",
"BH FLUX FORCE PRIVATE LIMITED",
"BH SAREE",
"BHA CONSULTING PRIVATE LIMITED",
"BHA HEALTH ANALYTICS SERVICES INDIA PRIVATE LIMITED",
"BHAAGYALAKSHMI VEGETABLE PRODUCTS LIMITED",
"BHAARATH MEDICAL COLLEGE AND HOSPITAL",
"BHAARATHI SPINTEX INDIA PRIVATE LIMITED",
"BHAARTI HR SOLUTIONS PRIVATE LIMITED",
"BHAAVIKA MACHINE TOOLS PRIVATE LIMITED",
"BHAAVYA KAPUR MAKEUP STUDIO PRIVATE LIMITED",
"BHABA ENGINEERING PRIVATE LIMITED",
"BHABANI BLUNT HAIR DRESSING PRIVATE LIMITED",
"BHABANI INTERNATIONAL PRIVATE LIMITED",
"BHABANI PIGMENTS PRIVATE LIMITED",
"BHABANIKINKAR INFRASTRUCTURE PRIVATE LIMITED",
"BHABATARINI FOOD PRODUCTS PRIVATE LIMITED",
"BHABESH MISHRA CONSTRUCTIONS PRIVATE LIMITED",
"BHABHA ATOMIC RESEARCH CENTRE",
"BHABHA CERAMIC PRIVATE LIMITED",
"BHABHA UNIVERSITY",
"BHACHAWAT TRADE VISION PRIVATE LIMITED",
"BHAD ENGINEERS PRIVATE LIMITED",
"BHADANES HI-TECH TECHNOLOGY COMPUTERS PRIVATE LIMITED",
"BHADANI COMMERCIAL PVT LTD",
"BHADANI FINANCERS PVT. LTD.",
"BHADANT DHARMAKIRTI VIDYALAY AND JR COLLEGE",
"BHADAR TECHNOLOGIES PRIVATE LIMITED",
"BHADAURIA CRANES AND TRANSPORT PRIVATE LIMITED",
"BHADERSON TRADERS PVT LTD",
"BHADIYADRA GEMS",
"BHADJA POWERTRANS PRIVATE LIMITED",
"BHADLA RENEWABLE POWER PRIVATE LIMITED",
"BHADOHI CARPETS PVT LTD",
"BHADOHI HOTELS LIMITED",
"BHADOHI WEAVE PRIVATE LIMITED",
"BHADORA INDUSTRIES PRIVATE. LIMITED.",
"BHADORIA ENGINEERING SERVICES PRIVATE LIMITED",
"BHADRA CASTALLOY PRIVATE LIMITED",
"BHADRA ENGIMECH PRIVATE LIMITED",
"BHADRA ESTATES",
"BHADRA HUMAN RESOURCES PRIVATE LIMITED",
"BHADRA INTERNATIONAL INDIA PRIVATE LIMITED",
"BHADRA LANDMARKS PRIVATE LIMITED",
"BHADRA PAPER MILLS LIMITED",
"BHADRA SERVICES PRIVATE LIMITED",
"BHADRADRI AGROS PRIVATE LIMITED",
"BHADRADRI RAMA FARMS PRIVATE LIMITED",
"BHADRAKAALI FIBRES PRIVATE LIMITED",
"BHADRAKALI AUTOCARE PRIVATE LIMITED",
"BHADRASHREE STEEL & POWER LIMITED",
"BHADRESWAR AGRO PRIVATE LIMITED",
"BHADRESWAR AGRO UDYOG PRIVATE LIMITED",
"BHADRRA NATURALL FRUITS PRIVATE LIMITED",
"BHAFRA SPIRITS PRIVATE LIMITED",
"BHAGA SIDH CONSTRUCTION AND ENGINEERING PRIVATE LIMITED",
"BHAGABATI BUILD & CONSTRUCTIONS PRIVATE LIMITED",
"BHAGABATI CEREALS PRIVATE LIMITED",
"BHAGALPUR AUTOMOBILES PRIVATE LIMITED",
"BHAGALPUR ENTERPRISES PRIVATE LIMITED",
"BHAGAM CONSTRUCTIONS PRIVATE LIMITED",
"BHAGAT AROMATICS LIMITED",
"BHAGAT AUTOMOBILES PRIVATE LIMITED",
"BHAGAT AUTOMOTIVE PRIVATE LIMITED",
"BHAGAT CAM LIMITED",
"BHAGAT DEVELOPERS & CONTRACTORS PRIVATE LIMITED",
"BHAGAT DISTILLERIES PRIVATE LTD",
"BHAGAT FORGE PRIVATE LIMITED",
"BHAGAT HOSPITALS PRIVATE LIMITED",
"BHAGAT JEE STEELS PRIVATE LIMITED",
"BHAGAT JI GARMENTS PRIVATE LIMITED",
"BHAGAT MACHINES PRIVATE LIMITED",
"BHAGAT MARKETING PRIVATE LIMITED",
"BHAGAT MOTOR CO PVT LTD",
"BHAGAT NISHAN PRODUCTS PRIVATE LIMITED",
"BHAGAT RAM AND SONS PRIVATE LIMITED",
"BHAGAT SINGH GOVT P G COLLEGE JAORA",
"BHAGAT TIMBER TRADERS PRIVATE LIMITED",
"BHAGATPUR TEA COMPANY LIMITED",
"BHAGATRAM RAWALDAS COLD STORAGE PRIVATE LIMITED",
"BHAGAUR ADVANCE HEALTH CARE PRIVATE LIMITED",
"BHAGAUTI PRASAD ANANT KUMAR SARRAF PRIVATE LIMITED",
"BHAGAVATHI CHITS PRIVATE LIMITED",
"BHAGAVATHI PROPERTIES PRIVATE LIMITED",
"BHAGAVATHI TOOLINGS PRIVATE LIMITED",
"BHAGAVATI RUBBER PRODUCT INDUSTRIES",
"BHAGAWAN MAHAVEER JAIN COLLEGE",
"BHAGAWATI COOLS PRIVATE LIMITED",
"BHAGAWATI DEVELOPMENT SERVICES PRIVATE LIMITED",
"BHAGAWATI ELITE MOTORS PRIVATE LIMITED",
"BHAGAWATI ENTERPRISES",
"BHAGAWATI FRONTLINE MOTORIZER PRIVATE LIMITED",
"BHAGAWATI INDIA MOTORIZER PRIVATE LIMITED",
"BHAGAWATI INFRA EQUIPMENTS PRIVATE LIMITED",
"BHAGAWATI KRIPA COLD CHAINS PRIVATE LIMITED",
"BHAGAWATI MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"BHAGAWATI OXYGEN LIMITED",
"BHAGERIA AGENCIES PRIVATE LIMITED",
"BHAGERIA EXIM PRIVATE LIMITED",
"BHAGERIA INDUSTRIES LIMITED",
"BHAGERIA TRADE-INVEST PVT LTD",
"BHAGESHWAR AGRO FOOD PRODUCTS PRIVATE LIMITED",
"BHAGGYAM CONSTRUCTIONS PRIVATE LIMITED",
"BHAGIA TEXTILE PRIVATE LIMITED",
"BHAGINI NIVEDITA COLLEGE",
"BHAGINI NIVEDITA SAHAKARI BANK LTD",
"BHAGINI UTTAR BUNI VIDHYALAY NARDIP",
"BHAGIRADHA CHEMICALS AND INDUSTRIES LIMITED",
"BHAGIRADHA CHEMICALS AND INDUSTRIES LTD.",
"BHAGIRATH ASSOCIATES",
"BHAGIRATH AUTOMOTIVE PRIVATE LIMITED",
"BHAGIRATH COACH AND METAL FABRICATORS PVT LTD",
"BHAGIRATH CONSTRUCTION COMPANY PRIVATE LIMITED",
"BHAGIRATH DAIRY PRIVATE LIMITED",
"BHAGIRATH FIBRE PVT LTD",
"BHAGIRATH MOTORS (INDIA) PRIVATE LIMITED",
"BHAGIRATH POLYFINS PVT LTD",
"BHAGIRATH WHEELS PRIVATE LIMITED",
"BHAGIRATHA POLYMERS PRIVATE LIMITED",
"BHAGIRATHI AGENCIES PRIVATE LIMITED",
"BHAGIRATHI BAI NARAYAN RAO MANAY COLLEGE",
"BHAGIRATHI BUSINESS PRIVATE LIMITED",
"BHAGIRATHI DISTRIBUTORS PRIVATE LIMITED",
"BHAGIRATHI EXPORTS PRIVATE LIMITED",
"BHAGIRATHI IMPEX PRIVATE LIMITED",
"BHAGIRATHI INFOTECH PRIVATE LIMITED",
"BHAGIRATHI MARKETING PRIVATE LIMITED",
"BHAGIRATHI MECHANICAL PRODUCTS LIMITED",
"BHAGIRATHI METAL INDUSTRIES PVT LTD",
"BHAGIRATHI MODERN RICE MILL PRIVATE LIMITED",
"BHAGIRATHI PACKAGING PRIVATE LIMITED",
"BHAGIRATHI POLYWIN PRIVATE LIMITED",
"BHAGIRTHI SYNTHETICS PRIVATE LIMITED",
"BHAGITHI MEDICAL CHAKUR",
"BHAGRA STEEL SALES PRIVATE LIMITED",
"BHAGTARA JUTE INDUSTRIES P LTD",
"BHAGUBAI CHANGU THAKUR COLLEGE",
"BHAGUDEV FLOUR MILLS PRIVATE LIMITED",
"BHAGVAD DHWAJ MARKETING PRIVATE LIMITED",
"BHAGVAN SHRI STRIPS PRIVATE LIMITED",
"BHAGVANPURA SAMAUNANA PRIMARY SCHOOL",
"BHAGVATI AUTOLINK PRIVATE LIMITED",
"BHAGVATI BEVERAGES PRIVATE LIMITED",
"BHAGVATI COAL MOVERS PRIVATE LIMITED",
"BHAGVATI HERBAL AND HEALTHCARE PRIVATE LIMITED",
"BHAGWAN ALUMINIUM PRIVATE LIMITED",
"BHAGWAN BABU JEWELLERS PRIVATE LIMITED",
"BHAGWAN BUDDH INTER COLLEGE SANDILA",
"BHAGWAN BUDDHA FIRST GRADE COLLEGE",
"BHAGWAN CHEMICALS AND IMPORTS PRIVATE LIMITED",
"BHAGWAN CREATION TEXTILES PRIVATE LIMITED",
"BHAGWAN DASS & SONS FASTNERS PRIVATE LIMITED",
"BHAGWAN DASS AND SONS INDIA PRIVATE LIMITED",
"BHAGWAN DASS ARORA AND CO PRIVATE LIMITED",
"BHAGWAN DASS HARDWARI LAL MERCHANDISE PRIVATE LIMITED",
"BHAGWAN DASS KHANNA ENTERPRISES PVT LTD",
"BHAGWAN DASS TEXTILES PRIVATE LIMITED",
"BHAGWAN DEVI FROZEN FOODS PRIVATE LIMITED",
"BHAGWAN DEVI ICE AND COLD STORAGE PRIVATE LIMITED",
"BHAGWAN ENTERPRISE TEXTILES PVT LTD",
"BHAGWAN FABRIC COLLECTIONS PRIVATE LIMITED",
"BHAGWAN FABRICS EXPORTS PRIVATE LIMITED",
"BHAGWAN MAHAVEER CANCER HOSPITAL AND RESEARCH CENTRE",
"BHAGWAN MAHAVEER JAIN HOSPITAL",
"BHAGWAN MAHAVIR EDUCATION FOUNDATION",
"BHAGWAN MAHAVIR HOSPITAL",
"BHAGWAN MAHAVIR INTERNATIONAL SCHOOL",
"BHAGWAN MET PRIVATE LIMITED",
"BHAGWAN PACKAGING INDUSTRIES PRIVATE LIMITED",
"BHAGWAN PARSHURAM INSTITUTE OF TECHNOLOGY",
"BHAGWAN PRECISION PRIVATE LIMITED",
"BHAGWAN RISHAB NATH RICE MILLS PRIVATE LIMITED",
"BHAGWAN SHANKAR JHS",
"BHAGWAN SHREE POLYFAB PRIVATE LIMITED",
"BHAGWAN STONE WORKS PRIVATE LIMITED",
"BHAGWAN VEER HANUMAN COLD STORAGE LIMITED",
"BHAGWANDAS & SONS JEWELLERS PRIVATE LIMITED",
"BHAGWANDAS DEVSHI PRIVATE LIMITED",
"BHAGWANDAS EDIBLE OILS PRIVATE LIMITED",
"BHAGWANDAS GOENKA EDUCATIONAL INSTITUTION",
"BHAGWANDAS GORDHANDAS FINANCIAL PRIVATE LIMITED",
"BHAGWANDAS METALS LIMITED",
"BHAGWANDAS RETAIL PRIVATE LIMITED",
"BHAGWANJI LOGISTICS PVT. LTD",
"BHAGWANPUR SOLAR PROJECTS PRIVATE LIMITED",
"BHAGWANT HARI INFRATECH PRIVATE LIMITED",
"BHAGWANTI RUBBER AND ALLIED PRODUCTS PRIVATE LIMITED",
"BHAGWAT CHATTELS PRIVATE LIMITED",
"BHAGWAT ENERGY PRIVATE LIMITED",
"BHAGWAT ENGINEERING PRIVATE LIMITED",
"BHAGWAT PRASHAD BANSAL AND SONS JEWELLERS PRIVATE LIMITED",
"BHAGWAT TRANSPORT ORGANISATION LIMITED",
"BHAGWATAM AGRO FOOD PRIVATE LIMITED",
"BHAGWATAM KUNJ ENTERPRISES PRIVATE LIMITED",
"BHAGWATI AGRI COMMODITY PRIVATE LIMITED",
"BHAGWATI AGRO AND SPICES INDIA PRIVATE LIMITED",
"BHAGWATI AIR EXPRESS PRIVATE LIMITED",
"BHAGWATI ASSOCIATES PRIVATE LIMITED",
"BHAGWATI AUTOCAST LIMITED",
"BHAGWATI AUTOZONE PRIVATE LIMITED",
"BHAGWATI AWAS PRIVATE LIMITED",
"BHAGWATI BARDANA TRADING PRIVATE LIMITED",
"BHAGWATI CAPITAL MARKETS PVT LTD",
"BHAGWATI CARRIERS PRIVATE LIMITED",
"BHAGWATI CHEMFOOD PRIVATE LIMITED",
"BHAGWATI CHEMTRADE PRIVATE LIMITED",
"BHAGWATI COKING COALS PRIVATE LIMITED",
"BHAGWATI COLOURS PRIVATE LIMITED",
"BHAGWATI COTTON AND SPINNING MILLS PRIVATE LIMITED",
"BHAGWATI DECOILING AND PROCESSING COMPANY PRIVATE LIMITED",
"BHAGWATI DIAMONDS PRIVATE LIMITED",
"BHAGWATI DISTRIBUTION PRIVATE LIMITED",
"BHAGWATI E COMMERCE INDIA PRIVATE LIMITED",
"BHAGWATI ENTERPRISE",
"BHAGWATI ENVIRO-CARE PRIVATE LIMITED",
"BHAGWATI EXIM PVT. LTD.",
"BHAGWATI FAB-ENGINEERS PRIVATE LIMITED",
"BHAGWATI FASHIONS PRIVATE LIMITED",
"BHAGWATI FATS AND EDIBLE OILS PRIVATE LIMITED",
"BHAGWATI FEEDS PRIVATE LIMITED",
"BHAGWATI FERRO METAL PRIVATE LIMITED",
"BHAGWATI FILTERS PRIVATE LIMITED",
"BHAGWATI FOODS PRIVATE LIMITED",
"BHAGWATI FOOTCARE PRIVATE LIMITED",
"BHAGWATI FOREIGN EXCHANGE PRIVATE LIMITED",
"BHAGWATI FUELS PRIVATE LIMITED",
"BHAGWATI GOURMET FOODS PRIVATE LIMITED",
"BHAGWATI GRAIN MILLS PRIVATE LIMITED",
"BHAGWATI HEALTHCARE PRIVATE LIMITED",
"BHAGWATI HOLDINGS PRIVATE LIMITED",
"BHAGWATI HOSPITALS PRIVATE LIMITED",
"BHAGWATI HOTELS AND RESORTS LIMITED",
"BHAGWATI IMPEX PVT LTD",
"BHAGWATI INDUSTRIES - RAIPUR",
"BHAGWATI INSECTICIDES LIMITED",
"BHAGWATI INTERIOR AND EXTERIOR PRIVATE LIMITED",
"BHAGWATI KRIPA PAPER MILLS PRIVATE LIMITED",
"BHAGWATI KRUPA SOLAR POWER PRIVATE LIMITED",
"BHAGWATI LACTO FOODS PRIVATE LIMITED",
"BHAGWATI LACTO VEGETARIAN EXPORTS PRIVATE LIMITED",
"BHAGWATI LUMBERS PRIVATE LIMITED",
"BHAGWATI MAFATLAL POLY -SVKM",
"BHAGWATI METALLOYS PRIVATE LIMITED",
"BHAGWATI NATURAL STONES PRIVATE LIMITED",
"BHAGWATI ORGANICS PRIVATE LIMITED",
"BHAGWATI ORNAMENT HOUSE PRIVATE LIMITED",
"BHAGWATI PACKERS PRIVATE LIMITED",
"BHAGWATI PARIDHAN PRIVATE LIMITED",
"BHAGWATI PERFECT SANITATION PRIVATE LIMITED",
"BHAGWATI PET (INDIA) PRIVATE LIMITED",
"BHAGWATI PETRO CHEM PRIVATE LIMITED",
"BHAGWATI PLAST INDUSTRIES",
"BHAGWATI PLASTOWORKS PRIVATE LIMITED",
"BHAGWATI PLYBOARD LIMITED",
"BHAGWATI POLYFILL PRIVATE LIMITED",
"BHAGWATI POLYTUBES PRIVATE LIMITED",
"BHAGWATI POLYWEAVE PRIVATE LIMITED",
"BHAGWATI POWER AND STEEL LIMITED",
"BHAGWATI PRASAD INFRATECH PRIVATE LIMITED",
"BHAGWATI PRODUCTS LIMITED",
"BHAGWATI PROJECTS PRIVATE LIMITED",
"BHAGWATI RECYCLING PRIVATE LIMITED",
"BHAGWATI RICE MILL P LIMITED",
"BHAGWATI SAREE PRIVATE LIMITED",
"BHAGWATI SHIPPING PRIVATE LIMITED",
"BHAGWATI SPHEROCAST PRIVATE LIMITED",
"BHAGWATI SPORTEX PRIVATE LIMITED",
"BHAGWATI STEEL AND ALLOYS PRIVATE LIMITED",
"BHAGWATI STEEL CAST LIMITED",
"BHAGWATI STEELMET PRIVATE LIMITED",
"BHAGWATI SYNTEX PRIVATE LIMITED",
"BHAGWATI TECHNO FAB PRIVATE LIMITED",
"BHAGWATI TIRATH POLYCONTAINERS INDUSTRIES PRIVATE LIMITED",
"BHAGWATI TOOLS PRIVATE LIMITED",
"BHAGWATI TRANSLINK PVT LTD",
"BHAGWATI TUBES PRIVATE LIMITED",
"BHAGWATI VIDHYALYA",
"BHAGWATI VINTRADE PRIVATE LIMITED",
"BHAGWATI WOVEN PRIVATE LIMITED",
"BHAGWN SHRI LOCKS PRIVATE LIMITED",
"BHAGYA GOLD LIMITED",
"BHAGYA LAKSHMI ISPAT (INDIA) PRIVATE LIMITED",
"BHAGYA LAKSHMI PROPERTIES PRIVATE LIMITED",
"BHAGYA LAXMI GEMS AND JEWELLERS PRIVATE LIMITED",
"BHAGYA LOGISTICS PRIVATE LIMITED",
"BHAGYA TRAVELS & TOURS PRIVATE LIMITED",
"BHAGYA VEER AGRO INDUSTRIES LIMITED",
"BHAGYADEEP CABLES PRIVATE LIMITED",
"BHAGYADHARA AGROTECH PRIVATE LIMITED",
"BHAGYADIPS WASTE MANAGEMENT PRIVATE LIMITED",
"BHAGYALAKSHMI INFRAVENTURES PRIVATE LIMITED",
"BHAGYALAKSHMI SPINTEX PRIVATE LIMITED",
"BHAGYALAKSHMI VANIJYA PRIVATE LIMITED",
"BHAGYALAXMI",
"BHAGYALAXMI AGENCIES",
"BHAGYALAXMI BRINE CHEM PRIVATE. LIMITED.",
"BHAGYALAXMI COMMOTRADE PRIVATE LIMITED",
"BHAGYALAXMI DAIRY FARMS PRIVATE LIMITED",
"BHAGYALAXMI ELECTRO PLAST PRIVATE LIMITED",
"BHAGYALAXMI ENTERPRISE",
"BHAGYALAXMI FERRO ALLOYS PRIVATE LIMITED",
"BHAGYALAXMI FINANCIAL ADVISORY PRIVATE LIMITED",
"BHAGYALAXMI GEMS & JEWELLERS PRIVATE. LIMITED.",
"BHAGYALAXMI INFRA PROJECTS",
"BHAGYALAXMI MINERAL WATER PRIVATE LIMITED",
"BHAGYALAXMI PRINTS PRIVATE LIMITED",
"BHAGYALAXMI ROLLING MILL PRIVATE LIMITED",
"BHAGYALAXMI STEELTECH PRIVATE LIMITED",
"BHAGYAM GEM & JEWELLERY PRIVATE LIMITED",
"BHAGYANAGAR CHLORIDES PVT LTD",
"BHAGYANAGAR COPPER PRIVATE LIMITED",
"BHAGYANAGAR ENERGY & TELECOM PRIVATE LIMITED",
"BHAGYANAGAR GAS LIMITED",
"BHAGYANAGAR GREEN ENERGY PRIVATE LIMITED",
"BHAGYANAGAR HATCHERIES PRIVATE. LIMITED.",
"BHAGYANAGAR INDIA LIMITED",
"BHAGYANAGAR METALS LIMITED",
"BHAGYANAGAR METALS PRIVATE LIMITED",
"BHAGYANAGAR OIL REFINERIES PRIVATE LIMITED",
"BHAGYANAGAR POLYMERS PVT LTD",
"BHAGYANAGAR PROPERTIES LIMITED",
"BHAGYANAGAR STRIPS PRIVATE LIMITED",
"BHAGYANAGAR WIRE PRODUCTS PRIVATE LIMITED",
"BHAGYANSH BUILDERS & DEVELOPERS PRIVATE LIMITED",
"BHAGYARADHA DEGREE COLLEGE",
"BHAGYARAJ IMPEX PRIVATE LIMITED",
"BHAGYAREKHA ENGINEERS PRIVATE LIMITED",
"BHAGYASHREE BHARTIYA INFRA PRIVATE LIMITED",
"BHAGYASHREE COLOURS PRIVATE LIMITED",
"BHAGYASHREE ENGINEERING PRIVATE LIMITED",
"BHAGYASHREE POLYMERS PRIVATE LIMITED",
"BHAGYASHREE STEEL AND ALLOYS PRIVATE LIMITED",
"BHAGYASHREE VINCOM PRIVATE LIMITED",
"BHAGYASHRI ACCESSORIES PRIVATE LIMITED",
"BHAGYASHRI HOME APPLIANCES PRIVATE LIMITED",
"BHAGYASHRI TEXTILES PRIVATE LIMITED",
"BHAGYASHRI TRAVELS PRIVATE LIMITED",
"BHAGYASREE REALTORS PRIVATE LIMITED",
"BHAGYODAY COTTON INDUSTRIES",
"BHAGYODAY INVESTMENTS PVT LTD",
"BHAGYODAY LOGISTIC SOLUTIONS PRIVATE LIMITED",
"BHAGYODAY MULTISPECIALITY HOSPITAL",
"BHAGYODAY SHARE TRADING COMPANY PRIVATE LIMITED",
"BHAGYODAY TRADING PRIVATE LIMITED (TR. FROM",
"BHAGYODAYA MOTORS PRIVATE LIMITED",
"BHAGYODAYA RICE INDUSTRIES",
"BHAGYODAYA TRADING COMPANY",
"BHAGYODAYA TROKHOS PRIVATE LIMITED",
"BHAGYRAAJ VYAPAAR PVT LTD",
"BHAI BHAI DISTRIBUTORS PRIVATE LIMITED",
"BHAI BHAI ROPE MANUFACTURING PRIVATE LIMITED",
"BHAI GURDAS INSTITUTE OF ENGINEERING AND TECHNOLOGY",
"BHAI PAPERS PRIVATE LIMITED",
"BHAI SAHAB ENTERPRISES PRIVATE LIMITED",
"BHAIA ELECTRONICS & ELECTRICALS PRIVATE LIMITED",
"BHAICHARA LOGISTICS PRIVATE LIMITED",
"BHAIJEE PORTFOLIO PRIVATE LIMITED",
"BHAIJI INFRAPROJECTS PRIVATE LIMITED",
"BHAIKAKA UNIVERSITY",
"BHAILAL AMIN GENERAL HOSPITAL",
"BHAILALBHAI AND BHIKHABHAI INSTITUTE OF TECHNOLOGY",
"BHAIRAAV HOUSING CORPORATION LIMITED",
"BHAIRAB GANGULY COLLEGE",
"BHAIRABI AGRO PRIVATE LIMITED",
"BHAIRABI TEA PRODUCER COMPANY LIMITED",
"BHAIRAV ALLOYS PRIVATE LIMITED",
"BHAIRAV CREATIONS PRIVATE LIMITED",
"BHAIRAV EMBRO DESIGNS PRIVATE LIMITED",
"BHAIRAV EXPORTS INDUSTRY PRIVATE LIMITED",
"BHAIRAV FOREX PRIVATE LIMITED",
"BHAIRAV GEMS PRIVATE LIMITED",
"BHAIRAV KNITTING PRIVATE LIMITED",
"BHAIRAV METAL",
"BHAIRAV RAFFIA PRIVATE LIMITED",
"BHAIRAVDADA AUTOMOBILES PRIVATE LIMITED",
"BHAIRAVI",
"BHAIRAVNATH ENTERPRSIES",
"BHAIRAVNATH EXIM PRIVATE LIMITED",
"BHAIRAVNATH FABRICATION",
"BHAIRAVNATH FARMERS PRODUCER COMPANY LIMITED",
"BHAIRAVNATH HITECH AGRO PRIVATE LIMITED",
"BHAIRAVNATH SUGAR WORKS LIMITED",
"BHAIRUPA COLD STORAGE PRIVATE LIMITED",
"BHAISAJYA SUPPLIERS PRIVATE LIMITED",
"BHAIWANDI NIZAMPUR CITY MUNICIPAL CORPORATION",
"BHAIYA FASHIONS PRIVATE LIMITED",
"BHAIYA LAL INFRASTRUCTURE PRIVATE LIMITED",
"BHAJAN INFRA TECH PRIVATE LIMITED",
"BHAJANA HOME DECOR PRIVATE LIMITED",
"BHAJANKA APPARELS PRIVATE LIMITED",
"BHAJANLAL COMMERCIAL PVT LTD",
"BHAJJANKA ISPAT PRIVATE LIMITED",
"BHAKAT BHAI PVT LTD",
"BHAKKAR MARBLES PRIVATE LIMITED",
"BHAKRA BEAS MANAGEMENT BOARD",
"BHAKRA BEAS MANAGEMENT BOARD BBMB",
"BHAKRA SERVICE STATION PRIVATE. LIMITED.",
"BHAKTAVATSALAM VIDYASHRAM CBSE",
"BHAKTHAVATSALAM MEMORIAL COLLEGE FOR WOM",
"BHAKTI AAKARSH RESIDENCY PRIVATE LIMITED",
"BHAKTI ALLOYS PRIVATE LIMITED",
"BHAKTI CHEMICALS PRIVATE LIMITED",
"BHAKTI CLEFORD PRIVATE LIMITED",
"BHAKTI EXTRACTIONS PRIVATE. LIMITED.",
"BHAKTI GEMS AND JEWELLERY LIMITED",
"BHAKTI HEALTHCARE PRIVATE LIMITED",
"BHAKTI INTERNATIONAL SCHOOL",
"BHAKTI MANAGEMENT SERVICES PRIVATE LIMITED",
"BHAKTI MANUFACTURERS PRIVATE LIMITED",
"BHAKTI METALS PRIVATE LIMITED",
"BHAKTI ORNAMENTS PRIVATE LIMITED",
"BHAKTI PROMOTERS PRIVATE LIMITED",
"BHAKTI VEDANTA HOSPITAL",
"BHAKTIDWAR MEDIA PRIVATE LIMITED",
"BHAKTIVEDANTA SWAMI MISSION SCHOOL",
"BHAKTTIMOYEE COLD STORAGE (PVT) LIMITED",
"BHAL HOTELS PRIVATE LIMITED",
"BHAL REALTY AND INFRASTRUCTURE PRIVATE LIMITED",
"BHALA FINANCE PRIVATE LIMITED",
"BHALA OPERATIONS PRIVATE LIMITED",
"BHALAKIA ASSOCIATES PRIVATE LIMITED",
"BHALALA FOODS PVT LTD",
"BHALANI BIOMEDICALS PRIVATE LIMITED",
"BHALARIA METAL CRAFT PRIVATE LIMITED",
"BHALCHANDRAM CLOTHING LIMITED",
"BHALE RAM MULTISPECIALITY HOSPITAL",
"BHALERAO H S SAONER",
"BHALLA CHEMICAL WORKS PRIVATE. LIMITED.",
"BHALLA DISTRIBUTORS PRIVATE LIMITED",
"BHALLA INTERNATIONAL",
"BHALLA SPORTS PRIVATE LIMITED",
"BHALLA TECHTRAN INDUSTRIES LIMITED",
"BHALOTA TEXTILES PRIVATE LIMITED",
"BHALOTHIA FOODS PRIVATE LIMITED",
"BHALOTIA AUTO PRODUCTS PRIVATE LIMITED",
"BHALOTIA BIKE'S PRIVATE LIMITED",
"BHALOTIA ENGINEERING WORKS PRIVATE LIMITED",
"BHALOTIA FABTEX PRIVATE LIMITED",
"BHALOTIA MULTICAST PRIVATE LIMITED",
"BHALOTIA ONLINE RETAILS PRIVATE LIMITED",
"BHALSAR SEEDS INDIA PRIVATE LIMITED",
"BHAMA ASKHED DAM DIVISION PUNE",
"BHAMA DESIGNS PRIVATE LIMITED",
"BHAMA PRINT & PACK PRIVATE LIMITED",
"BHAMARE INFRASTRUCTURE PRIVATE LIMITED",
"BHAMASA EXPORTS PRIVATE LIMITED",
"BHAMBHANI SHIPPING LIMITED",
"BHAMBRI S SUPER ROADWAYS PRIVATE LIMITED",
"BHAMBRI STEELS PRIVATE LIMITED",
"BHAMINI INFRASTRUCTURES PRIVATE LIMITED",
"BHAMYS CONSTRUCTIONS PRIVATE LIMITED",
"BHAN PRAKASH TRADING PRIVATE LIMITED",
"BHANAMAL UDYOG PRIVATE LIMITED",
"BHANBHORI FOODS PRIVATE LIMITED",
"BHANDAREE CONSUMER PRODUCTS PRIVATE LIMITED",
"BHANDARHATI COLD STORAGE PRIVATE LIMITED",
"BHANDARI AGENCIES PRIVATE LIMITED",
"BHANDARI AGROFEEDS PRIVATE LIMITED",
"BHANDARI AUTOMOBILES PRIVATE LIMITED",
"BHANDARI BUILDCON PRIVATE LIMITED",
"BHANDARI CARGO LOGISTICS PRIVATE LIMITED",
"BHANDARI CHILDREN HOSPITAL & RESEARCH CENTRE",
"BHANDARI CONSTRUCTION AND DEVELOPERS PRIVATE LIMITED",
"BHANDARI COTTONS LIMITED",
"BHANDARI DIAGNOSTIC CENTRE PRIVATE LIMITED",
"BHANDARI DISTRIBUTORS PRIVATE LIMITED",
"BHANDARI ENGINEERING COMPANY PRIVATE. LIMITED.",
"BHANDARI FEEDS PRIVATE LIMITED",
"BHANDARI GOLD AND JEWELLERS PRIVATE LIMITED",
"BHANDARI GRANITES AND MARMO PVT. LTD",
"BHANDARI HEALTH CARE PRIVATE LIMITED",
"BHANDARI HOSIERY EXPORTS LIMITED.",
"BHANDARI HOSPITAL & RESEARCH CENTRE",
"BHANDARI INFRA PROJECTS INDIA PRIVATE LIMITED",
"BHANDARI JEWELLERS",
"BHANDARI JEWELLERY GALAXY PRIVATE LIMITED",
"BHANDARI JEWELS PRIVATE LIMITED",
"BHANDARI MARBLES PRIVATE LIMITED",
"BHANDARI MEDICALS PVT. LTD",
"BHANDARI MOTORS PRIVATE LIMITED",
"BHANDARI POLYCLINIC PVT LTD",
"BHANDARI PRECISION FORGINGS PRIVATE LIMITED",
"BHANDARI PUBLIC SCHOOL",
"BHANDARI UTENSILS PRIVATE LIMITED",
"BHANDARI WAREHOUSING AND LOGISTICS PRIVATE LIMITED",
"BHANDARKAR ORIENTAL RESEARCH INST 411007",
"BHANDARY POWER LINES PRIVATE LIMITED",
"BHANDER POWER LIMITED",
"BHANDERI CORPORATION LIMITED",
"BHANDERI INFRACON LIMITED",
"BHANDERI MANSA PROBUILD PRIVATE LIMITED",
"BHANDERI TRENDZ (INDIA) PRIVATE LIMITED",
"BHANDUP CRITICARE HOSPITAL PRIVATE LIMITED",
"BHANES ENGINEERING PRIVATE LIMITED",
"BHANGALE DISTRIBUTORS",
"BHANGALE GOLD PRIVATE LIMITED",
"BHANGER INSECTICIDES PRIVATE LIMITED",
"BHANI AGRO INDIA PRIVATE LIMITED",
"BHANIX FINANCE AND INVESTMENT LIMITED",
"BHANJA REAL ESTATE PRIVATE LIMITED",
"BHANOBA ENTERPRISES PRIVATE LIMITED",
"BHANODAYA CONSTRUCTIONS PRIVATE LIMITED",
"BHANOO HOSPITAL PRIVATE LIMITED",
"BHANSALI AGRO INDUSTRIES PRIVATE LIMITED",
"BHANSALI BRIGHT BARS PRIVATE LIMITED",
"BHANSALI CERIM (I) PRIVATE LIMITED",
"BHANSALI CHEMICALS PRIVATE LIMITED",
"BHANSALI DIAMONDS",
"BHANSALI ENGINEERING POLYMERS LIMITED",
"BHANSALI FABTEX PRIVATE LIMITED",
"BHANSALI INDUSTRIAL INVESTMENT AND FINANCE PVT LTD",
"BHANSALI INDUSTRIES",
"BHANSALI INFRAHEIGHTS PRIVATE LIMITED",
"BHANSALI INTERNATIONAL PRIVATE LIMITED",
"BHANSALI ISPAT PRIVATE LIMITED",
"BHANSALI NIPPON A&L PRIVATE LIMITED",
"BHANSALI PACKING SERVICE",
"BHANSALI PRODUCTIONS PRIVATE LIMITED",
"BHANSALI SECURITIES PRIVATE LIMITED",
"BHANSALI VALUE CREATIONS PRIVATE LIMITED",
"BHANSALI WHEELS PRIVATE LIMITED",
"BHANU AUTOMOBILES",
"BHANU BIOTECH PRIVATE LIMITED",
"BHANU CERGLAZE PRIVATE LIMITED",
"BHANU DYES PRIVATE LIMITED",
"BHANU EMBROIDERIES PRIVATE LIMITED",
"BHANU FARMS LIMITED",
"BHANU HEALTHCARE PRIVATE LIMITED",
"BHANU ICE AND COLD STORAGE PRIVATE LIMITED",
"BHANU INFRABUILD PRIVATE LIMITED",
"BHANU LOGISTICS PRIVATE LIMITED",
"BHANU PRATAP ANGLO SANSKRIT INTER COLLEGE",
"BHANU SPECIAL CASTINGS PRIVATE LIMITED",
"BHANU TEJA SEA FOODS PRIVATE LIMITED",
"BHANU VYAPAAR PRIVATE LIMITED BVPL",
"BHANUCHANDRA FERROMATE PRIVATE LIMITED",
"BHANUENERGY INDUSTRIAL DEVELOPMENT LIMITED",
"BHANUENERGY INFRASTRUCTURE & POWER LIMITED",
"BHANULAXMI TRADE IMPEX PRIVATE LIMITED",
"BHANUSHALI ENTERPRISES PRIVATE LIMITED",
"BHANUSHALI SILK MILLS PVT LTD",
"BHANWARDEEP COPPER STRIPS PRIVATE LIMITED",
"BHANWARIYA INFRA PROJECTS PRIVATE LIMITED",
"BHANWARLAL RANGLAL OILS PRIVATE LIMITED",
"BHAPKAR AUTO PRIVATE LIMITED",
"BHAR FOODS PRIVATE LIMITED",
"BHARA TECHNOLOGIES PRIVATE LIMITED",
"BHARADIA SYNTHETICS PRIVATE LIMITED",
"BHARADWAJ AUTOTECH PRIVATE LIMITED",
"BHARADWAJ PACKAGING PRIVATE LIMITED",
"BHARAJ MACHINERIES PRIVATE LIMITED",
"BHARAKATH INDUSTRIES",
"BHARALI BROTHERS PVT LTD",
"BHARANI DRESSES",
"BHARANI ENGINEERING INDUSTRIES PRIVATE LIMITED",
"BHARANI ENGINEERS AND CONTRACTORS PRIVATE LIMITED",
"BHARANI HOSPITAL",
"BHARANI PIPES AND TUBES PRIVATE LIMITED",
"BHARANI RICE MILLS PRIVATE LIMITED",
"BHARANI TECHSOL INDIA PRIVATE LIMITED",
"BHARAT AGENCIES PVT LTD",
"BHARAT AGRI FERT & REALTY LIMITED",
"BHARAT AGRO INDUSTRIES",
"BHARAT AGRO MOLECULES LIMITED",
"BHARAT AGROOIL PRIVATE LIMITED",
"BHARAT ALUMINIUM CO LIMITED",
"BHARAT AUTO AGENCIES PRIVATE LIMITED",
"BHARAT AUTO TECH PRIVATE LIMITED",
"BHARAT AUTOMOTIVE PRESSINGS INDIA PRIVATE LIMITED",
"BHARAT AVIATION PRIVATE LIMITED",
"BHARAT BARREL AND DRUM MANUFACTURING COMPANY PRIVATE LIMITED",
"BHARAT BEAMS PRIVATE LIMITED",
"BHARAT BHUSHAN EQUITY TRADERS LIMITED",
"BHARAT BIJLEE LIMITED",
"BHARAT BIKE PRIVATE LIMITED",
"BHARAT BIO GAS ENERGY LIMITED",
"BHARAT BIOSCIENCE PRIVATE LIMITED",
"BHARAT BIOTECH INTERNATIONAL LIMITED",
"BHARAT BOARD MILLS PRIVATE LIMITED",
"BHARAT BOOKING HOLIDAYS INDIA PRIVATE LIMITED",
"BHARAT BPO SERVICES LIMITED",
"BHARAT BROADBAND NETWORK LIMITED",
"BHARAT CANCER HOSPITAL AND RESEARCH INSTITUTE",
"BHARAT CARRIERS LIMITED",
"BHARAT CEREALS PRIVATE LIMITED",
"BHARAT CERTIS AGRISCIENCE LIMITED",
"BHARAT CHAMBER OF COMMERCE",
"BHARAT CHEMICAL",
"BHARAT CLOUDS PRIVATE LIMITED",
"BHARAT CO OPERATIVE BANK ( MUMBAI ) LIMITED",
"BHARAT COACH BUILDERS PVT LTD",
"BHARAT COKING COAL LIMITED",
"BHARAT COLD DRINKS AND TEA HOUSE",
"BHARAT COLLEGE OF ENGINEERING",
"BHARAT CONSTRUCTION COMPANY BOMBAY",
"BHARAT CONSTRUCTION INDIA PRIVATE LIMITED",
"BHARAT CONSTRUCTIONS (INDIA) PRIVATE LIMITED",
"BHARAT CONTAINERS NAGPUR PRIVATE LIMITED",
"BHARAT CONVERTERS PRIVATE LIMITED",
"BHARAT COPY CENTRE PRIVATE LIMITED",
"BHARAT COTTON INDUSTRIES",
"BHARAT CROPSCIENCES INDIA PRIVATE LIMITED",
"BHARAT DEVELOPERS",
"BHARAT DHARAMDAS & ASSOCIATES LLP",
"BHARAT DIAMOND BOURSE",
"BHARAT DRILLING & FOUNDATION TREATMENT PRIVATE LIMITED",
"BHARAT DYNAMICS LIMITED",
"BHARAT EDUCATION SOCIETY'S KARTHIKA HIGH SCHOOL & JUNIOR COLLEGE",
"BHARAT EDUCATION TRUST",
"BHARAT EDUCATIVA TECH LLP",
"BHARAT ELECTRICAL ACCESSORIES PVT.LTD.",
"BHARAT ELECTRO EQUIPMENTS INDUSTRIES PRIVATE LIMITED",
"BHARAT ELECTRONICS LIMITED",
"BHARAT ELECTROTECH PRIVATE LIMITED",
"BHARAT ELEVATORS & ENGINEERS PRIVATE LIMITED",
"BHARAT EMBROIDARIES PRIVATE LIMITED",
"BHARAT ENGINEERING & BODY BUILDING COMPANY PVT LTD",
"BHARAT ENGINEERING COMPANY",
"BHARAT ENGINEERING CONSTRUCTION COMPANY PRIVATE LIMITED",
"BHARAT EXPLOSIVES LIMITED",
"BHARAT EXPORTS LIMITED",
"BHARAT FEEDER AND SHIPPING SERVICES PRIVATE LIMITED",
"BHARAT FEEDS AND EXTRACTIONS LIMITED",
"BHARAT FIH LIMITED",
"BHARAT FINANCIAL INCLUSION LIMITED",
"BHARAT FINANCIAL SERVICES LIMITED",
"BHARAT FLOORINGS & TILES (MUMBAI) PRIVATE LIMITED",
"BHARAT FOILS LIMITED",
"BHARAT FOILS PRIVATE LIMITED",
"BHARAT FOODS CO-OPERATIVE LTD",
"BHARAT FORGE LIMITED",
"BHARAT FRITZ WERNER LIMITED",
"BHARAT GEARS LIMITED",
"BHARAT GLASS AND CROCKERIES",
"BHARAT GLUCOSE PRIVATE LIMITED",
"BHARAT HEAD HUNTERS PRIVATE LIMITED",
"BHARAT HEAVY ELECTRICALS LIMITED",
"BHARAT HEIGHTS LIMITED",
"BHARAT HITECH (CEMENTS) PRIVATE LIMITED",
"BHARAT HOTELS LIMITED",
"BHARAT HYDEL PROJECTS PRIVATE LIMITED",
"BHARAT IMMUNOLOGICALS AND BIOLOGICALS CORPORATION LIMITED",
"BHARAT INDUSTRIAL CORPORATION",
"BHARAT INDUSTRIAL ENTERPRISES LIMITED",
"BHARAT INDUSTRIAL ENTERPRISES PRIVATE LIMITED",
"BHARAT INDUSTRIES",
"BHARAT INFRACEMENT LIMITED",
"BHARAT INFRACON PRIVATE LIMITED",
"BHARAT INSTITUTE OF ENGINEERING AND TECHNOLOGY",
"BHARAT INSTITUTE OF TECHNOLOGY",
"BHARAT INSULATION COMPANY (INDIA) PRIVATE LIMITED",
"BHARAT INSULATION COMPANY INDIA LIMITED",
"BHARAT INTERNATIONAL PRIVATE LIMITED",
"BHARAT INVESTMENT GROWTH LIMITED",
"BHARAT IRON STEELS AND TUBES PRIVATE LIMITED",
"BHARAT IRON SYNDICATE",
"BHARAT IRRIGATION PRIVATE LIMITED",
"BHARAT ISPAT UDYOG",
"BHARAT IT SERVICES LIMITED",
"BHARAT JEWELLERS LLP",
"BHARAT JYOTI DAIRY PRODUCTS LIMITED",
"BHARAT KNITFAB PRIVATE LIMITED",
"BHARAT KOLKATA CONTAINER TERMINALS PRIVATE LIMITED",
"BHARAT KRUSHICARE PRIVATE LIMITED",
"BHARAT KUMAR & CO. PRIVATE LIMITED",
"BHARAT LAW HOUSE PRIVATE LIMITED",
"BHARAT LIGHT AND POWER PRIVATE LIMITED",
"BHARAT LINE LIMITED",
"BHARAT LITHOGRAPHING COMPANY PVT.LTD.",
"BHARAT LOGISTIC SOLUTIONS PRIVATE LIMITED",
"BHARAT LOOMTEX PRIVATE LIMITED",
"BHARAT LUB INDUSTRIES PVT LTD",
"BHARAT LUX INDO AGRIFEEDS PRIVATE LIMITED",
"BHARAT MAINTENANCE SERVICE",
"BHARAT MALLEABLES PRIVATE LIMITED",
"BHARAT MILK PRODUCTS PRIVATE LIMITED",
"BHARAT MONOFILAMENT AND TEXTILES PRIVATE LIMITED",
"BHARAT MOTOCORP PRIVATE LIMITED",
"BHARAT MOTORS LIMITED",
"BHARAT MUMBAI CONTAINER TERMINALS PRIVATE LIMITED",
"BHARAT NIDHI LIMITED",
"BHARAT NURSERY PVT LTD",
"BHARAT OIL & WASTE MANAGEMENT LIMITED",
"BHARAT OMAN REFINERIES LIMITED",
"BHARAT PAPERS AND PULP PRIVATE LIMITED",
"BHARAT PARENTERALS LIMITED",
"BHARAT PESTICIDES INDUSTRIES PRIVATE LIMITED",
"BHARAT PET LIMITED",
"BHARAT PET PRODUCTS PRIVATE LIMITED",
"BHARAT PETROLEUM CORPORATION LIMITED",
"BHARAT PETROLUBES PRIVATE LIMITED",
"BHARAT PETRORESOURCES JPDA LIMITED",
"BHARAT PETRORESOURCES LIMITED",
"BHARAT PLASTOPACK PRIVATE LIMITED",
"BHARAT PLYWOOD AND TIMBER PRODUCTS PVT LTD",
"BHARAT POTTERIES LIMITED",
"BHARAT POWER CORPORATION PRIVATE LIMITED",
"BHARAT PRAKASHAN DELHI LIMITED",
"BHARAT PRECISION INDUSTRIES",
"BHARAT PRODUCTS LIMITED",
"BHARAT PROPACK PRIVATE LIMITED",
"BHARAT PULSES PRIVATE LIMITED",
"BHARAT PUMPS AND COMPRESSORS LIMITED",
"BHARAT RAIL AUTOMATIONS PRIVATE LIMITED",
"BHARAT RAM GLOBAL SCHOOL",
"BHARAT RASAYAN FINANCE LIMITED",
"BHARAT RASAYAN LIMITED",
"BHARAT RATNA LATE SHRI ATAL BIHARI VAJPAYEE MEMORIAL GOVT MEDICAL COLLEGE RAJNANDGAON",
"BHARAT REALTY VENTURE PRIVATE LIMITED",
"BHARAT REFRIGERATIONS PRIVATE LIMITED",
"BHARAT RE-INSURANCE BROKERS PRIVATE LIMITED",
"BHARAT REMEDIES PVT LTD",
"BHARAT RE-ROLLING MILLS LIMITED",
"BHARAT RESHMA DESIGNS PRIVATE LIMITED",
"BHARAT RESINS PRIVATE LIMITED",
"BHARAT ROAD NETWORK LIMITED",
"BHARAT ROADWAYS TRANSPORT LIMITED",
"BHARAT RUBBER WORKS PRIVATE. LIMITED. - HO",
"BHARAT SAFETY GLASS PRIVATE LIMITED",
"BHARAT SALES INDIA PRIVATE LIMITED",
"BHARAT SALT AND CHEMICAL INDUSTRIES (MUNDRA KUTCH) LIMITED",
"BHARAT SAMSKRITI VIDYA PEET COLL FOR WOM",
"BHARAT SANCHAR NIGAM LIMITED",
"BHARAT SEATS LIMITED",
"BHARAT SECURITY AGENCY",
"BHARAT SERUMS AND VACCINES LIMITED",
"BHARAT SEWAK SAMAJ INTER COLLEGE RAJPURI NAWADA BAREILLY",
"BHARAT SHEETGRAH PRIVATE LIMITED",
"BHARAT SILKS",
"BHARAT SPORTS INDIA PRIVATE LIMITED",
"BHARAT STARS SERVICES PRIVATE LIMITED",
"BHARAT STEEL (CHENNAI) PRIVATE LIMITED",
"BHARAT STEEL YARD PRIVATE LIMITED",
"BHARAT SUPPLY COMPANY",
"BHARAT SYNC TECHNOLOGIES PRIVATE LIMITED",
"BHARAT TECHNOLOGIES AUTO COMPONENTS LIMITED",
"BHARAT TECHNOLOGY",
"BHARAT TECHNOPLAST PRIVATE LIMITED",
"BHARAT TEST HOUSE PRIVATE LIMITED",
"BHARAT TEXTILES & PROOFING INDUSTRIES LIMITED",
"BHARAT TILES AND MARBLE PRIVATE LIMITED",
"BHARAT TIMBER & CONSTRUCTION CO.",
"BHARAT TOOL STEEL SYNDICATE",
"BHARAT TRADELINK PRIVATE LIMITED",
"BHARAT TRADING COMPANY",
"BHARAT TRAVEL POINT PRIVATE LIMITED",
"BHARAT TYRES GUJARAT PRIVATE LIMITED",
"BHARAT UDYOG LIMITED",
"BHARAT URBAN INFRA DEVELOPERS PRIVATE LIMITED",
"BHARAT VANIJYA EASTERN PVT LTD",
"BHARAT VEGETABLE OIL REFINERIES PRIVATE LIMITED",
"BHARAT VIDYALAYA AND¬† JR COLLEGE NHAVI",
"BHARAT VYAYASAYA PRIVATE LIMITED",
"BHARAT WHEEL PRIVATE LIMITED",
"BHARAT WIRE MESH PRIVATE LIMITED",
"BHARAT WIRE ROPES LIMITED",
"BHARAT WIRES ROPES LIMITED",
"BHARATALUMUNIUM EXTRUSION PRIVATE LIMITED",
"BHARATAM MECHATRONICS PRIVATE LIMITED",
"BHARATESH EDUCATION TRUST'S",
"BHARATGARV AGRO PRIVATE LIMITED",
"BHARATH ACADEMY OF COLLABORATIVE EDUCATION",
"BHARATH AGRO AGENCIES",
"BHARATH AGROVET INDUSTRIES PRIVATE LIMITED",
"BHARATH AUTO CARS PRIVATE LIMITED",
"BHARATH BEEDI WORKS LIMITED",
"BHARATH CEMENT PRODUCTS",
"BHARATH DASS MATRICULATION HIGHER SEC SCHOOL",
"BHARATH ENGINEERS AND INFRATECH PRIVATE LIMITED",
"BHARATH ENTERPRISES",
"BHARATH HEALTHCARE LABORATORIES PRIVATE LIMITED",
"BHARATH HI-TECCH BUILDERS PRIVATE LIMITED",
"BHARATH HOME MEDICARE PRIVATE LIMITED",
"BHARATH HOSPITAL AND INSTITUTE OF ONOCOL",
"BHARATH INSTITUTE OF HIGHER EDUCATION AND RESEARCH",
"BHARATH INSTITUTE OF SCIENCE&TECHNOLOGY",
"BHARATH INTERNATIONAL TRAVELS PRIVATE LIMITED",
"BHARATH LIFE SCIENCE PRIVATE LIMITED",
"BHARATH PESTCHEM PRIVATE LIMITED",
"BHARATH RUBBER INDIA LIMITED",
"BHARATH SALT REFINERIES LIMITED",
"BHARATH SWIFT LOGISTICS PRIVATE LIMITED",
"BHARATH VEHICLE WORKS PRIVATE LIMITED",
"BHARATH WIND FARM LIMITED",
"BHARATHAN HYPERMART PRIVATE LIMITED",
"BHARATHAN PUBLICATIONS PRIVATE LIMITED",
"BHARATHAPUZHA RUBBERS PVT LTD",
"BHARATHEEYAM SECURITY SERVICES PRIVATE LIMITED",
"BHARATHI & ASSOCIATES ASSET BUILDING PRIVATE LIMITED",
"BHARATHI ACADEMY",
"BHARATHI CARTONS PRIVATE LIMITED",
"BHARATHI CONSUMER CARE PRODUCTS PRIVATE. LIMITED.",
"BHARATHI ELECTRICALS INDIA PRIVATE LIMITED",
"BHARATHI HOMES AND REALTORS PRIVATE LIMITED",
"BHARATHI KIDS KSHETHRALAYA",
"BHARATHI MATRIC HR SEC SCHOOL",
"BHARATHI MRO INDUSTRIAL PRODUCTS PRIVATE LIMITED",
"BHARATHI POLYMERS INDIA PRIVATE LIMITED",
"BHARATHI RAJAA HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED",
"BHARATHI ROCK PRODUCTS INDIA PRIVATE LIMITED",
"BHARATHI RUBBER LINING AND ALLIED SERVICES PVT LTD",
"BHARATHI SEEDS PRIVATE LIMITED",
"BHARATHI SHARE BROKING PRIVATE LIMITED",
"BHARATHI SOLAR PRIVATE LIMITED",
"BHARATHI SWAMI PHYSIOTHERAPHY COLLEGE",
"BHARATHI VIDYALAYA SENIOR SECONDARY SCHOOL",
"BHARATHI VIKAS MATRIC HR SEC SCHOOL",
"BHARATHI WOMEN DEVELOPMENT CENTER",
"BHARATHI WOMENS COLLEGE",
"BHARATHIDASAN INST OF MNGT",
"BHARATHIDASAN MATRICULATION HIGHER SECONDARY SCHOOL",
"BHARATHIYA VIDYA BHAVAN COLLEGE",
"BHARATHY MINERALS PRIVATE LIMITED",
"BHARATI ENERGY & NATURAL RESOURCES PRIVATE LIMITED",
"BHARATI ENGINEERING AND CONSULTANCY PRIVATE LIMITED",
"BHARATI HASTIC ASPHALT COMBINES PRIVATE LIMITED",
"BHARATI HOSPITAL AND RESEARCH CENTER",
"BHARATI INTERNATIONAL PRIVATE LIMITED",
"BHARATI MADHYAVARTI SAHAKARI GRAHAK BHANDAR",
"BHARATI MANUFACTURING PVT LTD",
"BHARATI MINERALS LIMITED",
"BHARATI MOTORS PRIVATE LIMITED",
"BHARATI PARYAVARAN PRIVATE LIMITED",
"BHARATI POLY YARN PRIVATE LIMITED",
"BHARATI POULTRY PRIVATE LIMITED",
"BHARATI SAHAKARI BANK LTD",
"BHARATI SPONGE PRIVATE LIMITED",
"BHARATI TECHNO PROJECTS PRIVATE LIMITED",
"BHARATI TRADING ENTERPRISES PRIVATE LIMITED",
"BHARATI VIDYA BHAVAN PUNE",
"BHARATI VIDYAMANDIR HINDI NIGHT HIGH SCHOOL",
"BHARATI VIDYAPEETH DEEMED TO BE UNIVERSITY MEDICAL COLLEGE & HOSPITAL SANGLI",
"BHARATI VIDYAPEETH DEEMED UNIVERSITY COLLEGE OF ENGINEERING",
"BHARATI VIDYAPEETH DEEMED UNIVERSITY HOMOEOPATHIC MEDICAL COLLEGE",
"BHARATI VIDYAPEETH PRASHALA AND JUNIOR COLLEGE",
"BHARATI VIDYAPEETH S COLL OF ARCHITECTUR",
"BHARATI VIDYAPEETH UNIVERSITY",
"BHARATI VIDYAPEETH‚ÄôS GOD‚ÄôS VALLEY INTERNATIONAL SCHOOL",
"BHARATI VIDYAPEETH'S COLLEGE OF ENGINEERING",
"BHARATI VINAY MANDIR CHAKLASHI",
"BHARATI-AHS POWERTECH PRIVATE LIMITED",
"BHARATIY VIDYA NIKETAN U P S BHANDARA",
"BHARATIYA AGRO PRODUCTS PRIVATE LIMITED",
"BHARATIYA BEEJ NIGAM LIMITED",
"BHARATIYA ISPAT UDYOG PRIVATE LIMITED",
"BHARATIYA NABHIKIYA VIDYUT NIGAM LIMITED",
"BHARATIYA RESERVE BANK NOTE MUDRAN PRIVATE LIMITED",
"BHARATIYA ROAD TRANSPORT PRIVATE LIMITED",
"BHARATIYA ROADLINES PRIVATE LIMITED",
"BHARATIYA VIDYA BHAVAN",
"BHARATIYA VIDYA BHAVAN'S PRANJAPE VIDYA MANDIR",
"BHARATIYA VIDYA BHAVAN'S R K SARDA VIDYA MANDIR",
"BHARATIYA VIDYA BHAVAN'S S P JAIN INSTITUTE OF MANAGEMENT AND RESEARCH",
"BHARATIYA VIDYA BHAVANS SARDAR PATEL INSTITUTE OF TECHNOLOGY",
"BHARATIYAM FOODS AND BEVERAGES PRIVATE LIMITED",
"BHARATKSHETRA SAREES PRIVATE LIMITED",
"BHARATKUMAR INDRASEN TRADING PVT LTD",
"BHARATMATA VIDYAMANDIR SCHOOL NO 33 ICHALKARANJI",
"BHARATPUR ELECTRICITY SERVICES LIMITED",
"BHARATRATNA DR BABASAHEB AMBEDKAR VIDYALAYA AND JUNIOR COLLEGE",
"BHARATRATNA INDIRA GANDHI COLLEGE OF ENGINEERING SOLAPUR",
"BHARATROHAN AIRBORNE INNOVATIONS PRIVATE LIMITED",
"BHARATSHAKTI POLYTUBE PRIVATE LIMITED",
"BHARDWAJ AND MITTAL PRIVATE LIMITED",
"BHARDWAJ CAREWAYS (INDIA) PRIVATE LIMITED",
"BHARDWAJ CONSTRUCTION COMPANY PRIVATE LIMITED",
"BHARDWAJ INFRASTRUCTURE PRIVATE LIMITED",
"BHARDWAJ MEDICARE PRIVATE LIMITED",
"BHARDWAJ NURSING AND MATERNITY HOME PRIVATE LIMITED",
"BHARDWAJ OVERSEAS PRIVATE LIMITED",
"BHARDWAJ PACKAGING AND COMPONENTS PRIVATE LIMITED",
"BHARDWAJ STEELS PRIVATE LIMITED",
"BHARDWAJ UNIBUILD PRIVATE LIMITED",
"BHARGAVA AMMONIA PRIVATE LIMITED",
"BHARGAVA PHYTOLAB PRIVATE LIMITED",
"BHARGAVA POLY VINYLE PRIVATE LIMITED",
"BHARGAVA PROMOTERS PRIVATE LIMITED",
"BHARGAVA ROTOPACK PRIVATE LIMITED",
"BHARGAVA STATIONERY MART PRIVATE LIMITED",
"BHARGAVA'S HI-TECH SURGIMED COMPANY PRIVATE LIMITED",
"BHARGAVAS MUSIK PRIVATE LIMITED",
"BHARGAVE RUBBER PRIVATE LIMITED",
"BHARGAVI AUTOMOBILES PRIVATE LIMITED",
"BHARGAVI BUILDERS AND INVESTMENTS PRIVATE LIMITED",
"BHARGAVI ENTERPRISES PRIVATE LIMITED",
"BHARGAVI HOTELS AND RESORTS PRIVATE LIMITED",
"BHARGO BUILDING MATERIALS PRIVATE LIMITED",
"BHARGOVI GEMS",
"BHARI INDUSTRIAL PROMOTERS PRIVATE LIMITED",
"BHARI INFRA PRIVATE LIMITED",
"BHARNO BARI TEA & INDUSTRIES LTD",
"BHARODIYA BROTHERS PRIVATE LIMITED",
"BHARODIYA FABRICS PRIVATE LIMITED",
"BHARSONS FOOTWEAR PRIVATE LIMITED",
"BHART PLASTO CHEM PRIVATE LIMITED",
"BHARTH ENGINEERING COMPANY",
"BHARTHIAR UNIVERSITY - COIMBATORE",
"BHARTHIDASAN UNIVERSITY - TRICHY",
"BHARTI (SBM) HOLDINGS PRIVATE LIMITED",
"BHARTI AIRTEL LIMITED",
"BHARTI AIRTEL SERVICES LIMITED",
"BHARTI AXA GENERAL INSURANCE COMPANY LIMITED",
"BHARTI AXA LIFE INSURANCE COMPANY LIMITED",
"BHARTI AYURVEDIC HOSPITAL",
"BHARTI BANGAR INTERNATIONAL SCHOOL",
"BHARTI BHAWAN (PUBLISHERS & DISTRIBUTORS)",
"BHARTI BRIGHT BAR PRIVATE LIMITED",
"BHARTI COLLEGE OF ENGINEERING AND TECHNOLOGY",
"BHARTI ENTERPRISES (HOLDING) PRIVATE LIMITED",
"BHARTI ENTERPRISES LIMITED",
"BHARTI ENTERPRISES LIMITED.",
"BHARTI EXIM PRIVATE LIMITED",
"BHARTI FASHIONS PRIVATE LIMITED",
"BHARTI FOUNDATION",
"BHARTI HEALTHCARE LIMITED",
"BHARTI HEXACOM LIMITED",
"BHARTI HOSPITAL",
"BHARTI HYDRO FITTMENTS AND ENGINEERS PRIVATE LIMITED",
"BHARTI HYGIENECARE PRIVATE LIMITED",
"BHARTI INFRACONSTRUCTIONS PRIVATE LIMITED",
"BHARTI INFRASTRUCTURE PRIVATE LIMITED",
"BHARTI INGOT PRIVATE LIMITED",
"BHARTI ISPAT PRIVATE LIMITED",
"BHARTI JEWELLERS PRIVATE LIMITED",
"BHARTI LIFE VENTURES PRIVATE LIMITED",
"BHARTI MANAGEMENT SERVICES LIMITED",
"BHARTI MAXTEL PRIVATE LIMITED",
"BHARTI MEDICARE PRIVATE LIMITED",
"BHARTI MILK FOODS PVT LTD",
"BHARTI REAL ESTATES LIMITED",
"BHARTI REALTY LIMITED.",
"BHARTI RESTAURANTS PRIVATE LIMITED",
"BHARTI SOFT TECH PRIVATE LIMITED",
"BHARTI SYNTEX LIMITED",
"BHARTI TELECOM",
"BHARTI TELEMEDIA LIMITED",
"BHARTI THAKKAR INDIA SECURITIES PRIVATE LIMITED",
"BHARTI VIDYAPEETI INSTITUTE OF MANAGEMEN",
"BHARTI VINAY MANDIR AMRAPUR",
"BHARTI VISHWAVIDYALAYA",
"BHARTI WATERS PRIVATE LIMITED",
"BHARTIA BRIGHT & SEAMLESS STEELS LTD",
"BHARTIA DISTRIBUTORS PRIVATE LIMITED",
"BHARTIA INFRA PROJECTS LIMITED",
"BHARTIA MARBLES PVT. LTD",
"BHARTIA MINI SPRING AND ENGINEERING CO.PVT.LTD.",
"BHARTIA STOCK BROKING PRIVATE LIMITED",
"BHARTIA VIDYUT INDIA PRIVATE LIMITED",
"BHARTIA YARNS PRIVATE LIMITED BYPL",
"BHARTIPAY SERVICES PRIVATE LIMITED",
"BHARTIYA AGROW PHARMA PRIVATE LIMITED",
"BHARTIYA ALLOYS & STEEL CAST LIMITED",
"BHARTIYA BEEJ KHAD BHANDAR PRIVATE LIMITED",
"BHARTIYA CACCIALANZA FIRE SYSTEMS LIMITED",
"BHARTIYA CITY DEVELOPERS PRIVATE LIMITED",
"BHARTIYA DHOOP KARYALAYA PRIVATE LIMITED",
"BHARTIYA GLOBAL MARKETING LIMITED",
"BHARTIYA INTERNATIONAL LIMITED",
"BHARTIYA KALA PRASARINI SABHA COLLEGE",
"BHARTIYA KRUSHAK KRANTI LIMITED",
"BHARTIYA ONLINE SERVICE SYSTEM PRIVATE LIMITED",
"BHARTIYA PARIVAHAN PVT LTD",
"BHARTIYA PASHUPALAN NIGAM LIMITED",
"BHARTIYA PLASTIC UDYOG PRIVATE LIMITED",
"BHARTIYA RAIL BIJLEE COMPANY LIMITED",
"BHARTIYA SAMRUDDHI INVESTMENTS AND CONSULTING SERVICES LIMITED",
"BHARTIYA SECURITY SERVICES",
"BHARTIYA SPINNERS LTD",
"BHARTIYA TRADING & ENTERPRISES LIMITED",
"BHARTIYA URBAN PRIVATE LIMITED",
"BHARTIYA VALVES PRIVATE LIMITED",
"BHARTIYA VEHICLE AND ENGINEERING CO.LIMITED",
"BHARTIYA VIDYA MANDIR SENIOR SECONDARY SCHOOL",
"BHARTIYA YUVA SHAKTI TRUST",
"BHARTIYAM EDUCATIONAL AND SOCIAL WELFARE SOCIETY",
"BHARTPUR DCF",
"BHARTU RAM ASHISH KUMAR",
"BHARUCH DAHEJ RAILWAY COMPANY LIMITED",
"BHARUCH DISTRICT EDUCATION COMMITTEE",
"BEIL RESEARCH AND CONSULTANCY PRIVATE LIMITED",
"BHARUCH HEALTHCARE PRIVATE LIMITED",
"BHARUCH INDUSTRIAL PARK PRIVATE LIMITED",
"BHARUCH JILLA SHIKSHAN SAMITI SANCHALIT PRIMARY SCHOOL",
"BHARUCHA & PARTNERS ADVOCATES & SOLICITORS",
"BHARUCHA AND SONS REALTORS & DEVELOPERS PRIVATE LIMITED",
"BHARUCHA STONE AND SAND WORKS PRIVATE LIMITED",
"BHARUKA CONSTRUCTIONS PRIVATE LIMITED",
"BHARUWA SOLUTIONS PRIVATE LIMITED",
"BHARWADA HEALTHCARE PRIVATE LIMITED",
"BHASEEN SPORTS PVT LTD",
"BHASHYAM BLOOMS SCHOOL",
"BHASHYAM EDUCATIONAL INSTITUTIONS HABSIGUDA",
"BHASHYAM EDUCATIONAL SOCIETY",
"BHASIN AND COMPANY",
"BHASIN CARS PRIVATE LIMITED",
"BHASIN FARMS PVT LTD",
"BHASIN INDUSTRIES PRIVATE. LIMITED",
"BHASIN INFOTECH AND INFRASTRUCTURE PRIVATE LIMITED",
"BHASIN INFRASTRUCTURE DEVELOPERS PRIVATE LIMITED",
"BHASIN MATERIALS PRIVATE LIMITED",
"BHASIN PACKARD ELECTRONICS PVT LTD",
"BHASIN ROADLINES PRIVATE LIMITED",
"BHASIN SPRING INDUSTRIES PVT LTD",
"BHASIN TRAVELS PRIVATE LIMITED",
"BHASKAR AGRO CHEMICALS LIMITED",
"BHASKAR EARTHMOVER PRIVATE LIMITED",
"BHASKAR ENT HOSPITAL",
"BHASKAR FABTEX INDIA PRIVATE LIMITED",
"BHASKAR FERTILISERS PRIVATE LIMITED",
"BHASKAR FOOD PRODUCTS LIMITED",
"BHASKAR FOURWHEELS PRIVATE LIMITED",
"BHASKAR INDUSTRIES PRIVATE LIMITED",
"BHASKAR INFRASTRUCTURE PRIVATE LIMITED",
"BHASKAR INTERNATIONAL PRIVATE LIMITED",
"BHASKAR JYOTI (INDIA) PRIVATE LIMITED",
"BHASKAR JYOTI INDIA OPC PRIVATE LIMITED",
"BHASKAR LUBRICANTS PRIVATE LIMITED",
"BHASKAR MEDICAL COLLEGE",
"BHASKAR METAL FINISHING EQUIPMENTS PRIVATE LIMITED",
"BHASKAR POWER PROJECTS PRIVATE LIMITED",
"BHASKAR PRAKASHAN PRIVATE LIMITED",
"BHASKAR REDDY SOFTWARE LABS PRIVATE LIMITED",
"BHASKAR REFRACTORIES AND SW PIPES PRIVATE LIMITED",
"BHASKAR RESINS PRIVATE LIMITED",
"BHASKAR RESOURCES PRIVATE LIMITED",
"BHASKAR SHETTY AND COMPANY PRIVATE LIMITED",
"BHASKAR SILICON PRIVATE LIMITED",
"BHASKAR SILK MILLS PRIVATE LIMITED",
"BHASKAR STATIONERS PRIVATE LIMITED",
"BHASKAR STEEL AND FERRO ALLOY PRIVATE LI MITED",
"BHASKAR TEA INDUSTRIES LIMITED.",
"BHASKAR TRANSPORT PRIVATE LIMITED",
"BHASKAR VENKATESH PRODUCTS PRIVATE LIMITED",
"BHASKAR WEAVING MILLS PRIVATE LIMITED",
"BHASKARA AUTOMOTION PRIVATE LIMITED",
"BHASKARA MARKETING SERVICES",
"BHASKARI AQUA PRODUCTS PRIVATE LIMITED",
"BHASKARSRINIKETAN FASHION PRIVATE LIMITED",
"BHASKER AGRO MILL PRIVATE LIMITED",
"BHASTRIK MECHANICAL LABS PRIVATE LIMITED",
"BHASYA INTERNATIONAL PRIVATE LIMITED",
"BHAT BIO-TECH INDIA PRIVATE LIMITED",
"BHAT INFRASTRUCTURE PRIVATE LIMITED",
"BHAT POWER PRIVATE LIMITED",
"BHATAWADEKAR BROTHERS PRIVATE LIMITED",
"BHATAWADEKAR INSURANCE SURVEYORS & LOSS ASSESSORS PRIVATE LIMITED",
"BHATE AND RAJE CONSTRUCTION COMPANY PRIVATE LIMITED",
"BHATGAM WASHING GHAT SUDHHIKARAN YOJNA PRIVATE LIMITED",
"BHATI ASSOCIATES PRIVATE LIMITED",
"BHATI HEALTHCARE PRIVATE LIMITED",
"BHATI MARKETING PRIVATE LIMITED",
"BHATI MODERN PUBLIC SCHOOL",
"BHATIA & COMPANY",
"BHATIA ALLOY FORGINGS PVT LTD",
"BHATIA ASHRAM PRIVATE LIMITED",
"BHATIA AUTOWHEELS PRIVATE LIMITED",
"BHATIA BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"BHATIA COAL TRADELINK BCTL",
"BHATIA COLONIZERS PRIVATE LIMITED",
"BHATIA COMMUNICATIONS & RETAIL INDIA LIMITED",
"BHATIA CORPORATION PRIVATE LIMITED (PART IX)",
"BHATIA ELECTRIC STORES PRIVATE LIMITED",
"BHATIA ENDO-SURGERY PRIVATE LIMITED",
"BHATIA ENERGY AND MINERALS PRIVATE LIMITED",
"BHATIA ESTATES PRIVATE LIMITED",
"BHATIA FINVEST PRIVATE LIMITED",
"BHATIA GENERAL HOSPITAL",
"BHATIA GLASS TUFF PRIVATE LIMITED",
"BHATIA GRAPHICA PRIVATE LIMITED",
"BHATIA HOSPITAL",
"BHATIA INFRASTRUCTURES PRIVATE LIMITED",
"BHATIA INFRAVENTURES PRIVATE LIMITED",
"BHATIA PACKERS PRIVATE LIMITED",
"BHATIA PHOTO INDUSTRIES PRIVATE LIMITED",
"BHATIA RASAYAN UDYOG PRIVATE LIMITED",
"BHATIA SHIPPING PRIVATE LIMITED",
"BHATIA SONS JEWELLERS PRIVATE LIMITED",
"BHATIA TECHNOCOM (INDIA) PRIVATE LIMITED",
"BHATIA WINE MERCHANTS PRIVATE LIMITED",
"BHATINDA CERAMICS PRIVATE LIMITED",
"BHATKAWA TEA INDUSTRIES LIMITED.",
"BHATNAGAR CARDIAC CARE PRIVATE LIMITED",
"BHATNAGAR HANDLOOMS PRIVATE LIMITED",
"BHATNAGAR INTERNATIONAL SCHOOL",
"BHATNAGAR TEXTILES PRIVATE LIMITED",
"BHATPARA IRON & STEEL PRIVATE LIMITED",
"BHATPARA MUNICIPALITY",
"BHATPARA TEA ESTATES PRIVATE LIMITED",
"BHATSA DAM MANAGEMENT DIVISION",
"BHATT BROS.",
"BHATT EDUCATIONAL SCIENTIFIC AND TECHNOLOGICAL SERVICES PRIVATE LIMITED",
"BHATT HYDRAULICS PRIVATE LIMITED",
"BHATT MAGNETICS PVT LTD",
"BHATTACHARYA ORTHOPAEDICS RELATED RESEA",
"BHATTAD FACILITIES MANAGEMENT PRIVATE LIMITED",
"BHATTAD GROUP",
"BHATTAD INDUSTRIES PRIVATE LIMITED",
"BHATTAD KITCHENWARE PRIVATE LIMITED",
"BHATTAR HOSPITALS PRIVATE LIMITED",
"BHATTA'S FOODS PRIVATE LIMITED",
"BHATTASALI PRINT & SERVICES PRIVATE LIMITED",
"BHATTER & COMPANY PVT LTD",
"BHATTER AGENCY LTD",
"BHATTER DIABETIC AND MEDICAL CENTRE PRIVATE LIMITED",
"BHATTER METALS PRIVATE LIMITED",
"BHATTER SILVER SMITH PVT LTD",
"BHATTI AGRITECH PRIVATE LIMITED",
"BHATTI INDUSTRIES PRIVATE LIMITED",
"BHATTI MOTORS PRIVATE LIMITED",
"BHATTS LOGISTICS PRIVATE LIMITED",
"BHATU ISPAT PRIVATE LIMITED",
"BHATUKALI DAY CARE CENTER",
"BHAUMIK JEWELLERS PRIVATE LIMITED",
"BHAUMIK OVERSEAS PRIVATE LIMITED",
"BHAUMIK REAL ESTATES PRIVATE LIMITED",
"BHAURAO CHAVAN SAHAKARI SAKHAR KARKHANA LTD",
"BHAUTIK TEXTILE PRIVATE LIMITED",
"BHAUWALA ESTATES PRIVATE LIMITED",
"BHAV AMBAR VILAS PRIVATE LIMITED",
"BHAV TRADE LINKS PRIVATE LIMITED",
"BHAVAM TELEPACK PRIVATE LIMITED",
"BHAVAN DEGREE COLLEGE",
"BHAVAN INFRASTRUCTURES PRIVATE LIMITED",
"BHAVAN IT SERVICES PRIVATE LIMITED",
"BHAVANA DISTRIBUTORS PRIVATE LIMITED",
"BHAVANA ENERGY-INFRASTRUCTURE PRIVATE LIMITED",
"BHAVANA HOLDINGS PRIVATE LIMITED.",
"BHAVANA INFRAPROJECTS PRIVATE LIMITED",
"BHAVANA JINDAL EXIM PRIVATE LIMITED",
"BHAVANA LAYER FARMS PRIVATE LIMITED",
"BHAVANA LIGHTING PRIVATE LIMITED",
"BHAVANA OFFSET PRINTERS PRIVATE LIMITED",
"BHAVANA PLASTICS PRIVATE LIMITED",
"BHAVANA POWER PRIVATE LIMITED",
"BHAVANA TELETECH PRIVATE LIMITED",
"BHAVANA TELEVENTURES LIMITED",
"BHAVANA TEXTILES PRIVATE LIMITED",
"BHAVANAM SPINNING MILLS PRIVATE LIMITED",
"BHAVANAM TEXTILES INDIA PRIVATE LIMITED",
"BHAVANI AGROVET PRIVATE LIMITED",
"BHAVANI APPARELS PRIVATE LIMITED",
"BHAVANI CERAMICS PRIVATE LIMITED",
"BHAVANI COTEX",
"BHAVANI ELECTRODES PRIVATE LIMITED",
"BHAVANI ELEVATORS PRIVATE LIMITED",
"BHAVANI ENVIRO TECHNOLOGIES PRIVATE LIMITED",
"BHAVANI ERECTORS PRIVATE LIMITED",
"BHAVANI FEEDS PRIVATE LIMITED",
"BHAVANI HEALTHCARE SERVICES PRIVATE LIMITED",
"BHAVANI INDUSTRIES INDIA LLP",
"BHAVANI INDUSTRIES PRIVATE LIMITED",
"BHAVANI INFRA STEEL PRIVATE LIMITED",
"BHAVANI IRON INDUSTRIES PVT LTD",
"BHAVANI IRONCHEM TECHNOLOGIES PRIVATE LIMITED",
"BHAVANI PHARMACEUTICALS PRIVATE LIMITED",
"BHAVANI PHARMACHEM PRIVATE LIMITED",
"BHAVANI RENEWABLE ENERGY PRIVATE LIMITED",
"BHAVANI SAHAKARI BANK LTD",
"BHAVANI SEALS PRIVATE LIMITED",
"BHAVANI SHIPPING SERVICES INDIA PRIVATE LIMITED",
"BHAVANI STEEL PRIVATE. LIMITED.",
"BHAVANI TELESERVICES PRIVATE LIMITED",
"BHAVANIKA BUILDCON PRIVATE LIMITED",
"BHAVANS B P VIDYA MANDIR",
"BHAVAN'S BHAGWANDAS PUROHIT VIDYA MANDIR",
"BHAVANS COLLEGE",
"BHAVAN'S COLLEGE",
"BHAVANS GANGABUX KANORIA VIDYAMANDIR",
"BHAVANS MUNSHI VIDYASHRAM",
"BHAVANS RAJAJI VIDYASHRAM",
"BHAVANS VIVEKANANDA COLLEGE OF SCIENCE HUMANITIES AND COMMERCE",
"BHAVASARGA CREATIONS PRIVATE LIMITED",
"BHAVDEEP ENGINEERING WORKS",
"BHAVDIP INVESTMENTS PVT LTD",
"BHAVE ELECTRIC VEHICLES PRIVATE LIMITED",
"BHAVE WAREHOUSING AND STORAGES PRIVATE LIMITED",
"BHAVEEN CONSTRUCTION PRIVATE LIMITED",
"BHAVESH CATERERS & DECORATERS PRIVATE LIMITED",
"BHAVESH ELECTROTECH (INDIA) PRIVATE LIMITED",
"BHAVESH POLYPACK PRIVATE LIMITED",
"BHAVESH PRODUCTS PRIVATE LIMITED",
"BHAVESH PUBLICATIONS PRIVATE LIMITED",
"BHAVESH SILK INDUSTRIES PRIVATE LIMITED",
"BHAVESH TEXO FAB PRIVATE LIMITED",
"BHAVESH TEXTILE PRIVATE LIMITED",
"BHAVESH TRADING-",
"BHAVESHWAR PROPERTIES PRIVATE LIMITED",
"BHAVGEET HOTEL AND MOTEL PRIVATE LIMITED",
"BHAVI INTERNATIONAL PRIVATE LIMITED",
"BHAVI MOTORS PRIVATE LIMITED",
"BHAVI PLAST PRIVATE LIMITED",
"BHAVI TUBES AND CONTAINERS PVT LTD",
"BHAVIK AND NIRAJ ENERGY PRIVATE LIMITED",
"BHAVIK BULK CARRIERS PRIVATE LIMITED",
"BHAVIK CHEM PRIVATE LIMITED",
"BHAVIK ENTERPRISES LIMITED",
"BHAVIK POLYMERS PRIVATE LIMITED",
"BHAVIK PROCESS EQUIPMENT PRIVATE LIMITED",
"BHAVIK PUBLICATION PRIVATE LIMITED",
"BHAVIK SYSTEMS PRIVATE LIMITED",
"BHAVIKA APPARELS PRIVATE LIMITED",
"BHAVIKA PLAS-TEK PRIVATE LIMITED",
"BHAVIN AGRI-INFRA PRIVATE LIMITED",
"BHAVIN CONTAINERS PRIVATE LIMITED",
"BHAVIN INDUSTRIES INDIA PRIVATE LIMITED",
"BHAVIN STEEL PRIVATE LIMITED",
"BHAVIN WHEELS PRIVATE LIMITED",
"BHAVISH PRINT SOLUTIONS PRIVATE LIMITED",
"BHAVISHA PROJECTS PRIVATE LIMITED",
"BHAVISHYA FOODS & BEVERAGES PRIVATE LIMITED",
"BHAVISHYA INVESTSERVE PRIVATE LIMITED",
"BHAVISHYA MEDICAL STORE PRIVATE LIMITED",
"BHAVISRI CLEAN ENERGY PRIVATE LIMITED",
"BHAVISYA IRRIGATION WORKS PRIVATE LIMITED",
"BHAVITHA EDUCATIONAL SOCIETY",
"BHAVMARK SYSTEMS PRIVATE LIMITED.",
"BHAVNA AUTO WHEELS PRIVATE LIMITED",
"BHAVNA AUTOMOBILES PRIVATE LIMITED",
"BHAVNA CHEMTECH PRIVATE LIMITED",
"BHAVNA CREATIONS PRIVATE LIMITED",
"BHAVNA ELECTRIC & MACHINERY STORES PRIVATE LIMITED",
"BHAVNA ENGINEERING COMPANY PRIVATE LIMITED",
"BHAVNA EXIM PRIVATE LIMITED",
"BHAVNA LABORATORIES PVT LTD",
"BHAVNA PROCESSORS PVT LTD",
"BHAVNA PROPERTY DEVELOPERS LIMITED",
"BHAVNA ROADLINES PRIVATE LIMITED",
"BHAVNA SOFTWARE INDIA PRIVATE LIMITED",
"BHAVNAGAR DISTRICT EDUCATION DEPARTMENT",
"BHAVNAGAR ENERGY COMPANY LIMITED",
"BHAVNAGAR EXIM PRIVATE LIMITED",
"BHAVNAGAR FEEDS PVT LTD",
"BHAVNAGAR IRRIGATION PROJECT DIVISON",
"BHAVNAGAR MUNICIPAL CORPORATION",
"BHAVNAGAR UNIVERSITY GAURI SHANKER LAKE",
"BHAVNISH METAL INDIA PRIVATE LIMITED",
"BHAVSAGAR NIRMAN PRIVATE LIMITED",
"BHAVSAGAR VYAPAAR PVT LTD",
"BHAVSAR FOUNDRIES PRIVATE LIMITED",
"BHAVTEJ SYNTEX PRIVATE LIMITED",
"BHAVYA ART PRIVATE LIMITED",
"BHAVYA BROADCAST PRIVATE LIMITED",
"BHAVYA CEMENTS PRIVATE LIMITED",
"BHAVYA CONSTRUCTION PRIVATE LIMITED",
"BHAVYA CONSTRUCTIONS PRIVATE LIMITED",
"BHAVYA CREATORS PRIVATE LIMITED",
"BHAVYA ENTERPRISES",
"BHAVYA FERRO PRODUCTS PRIVATE LIMITED",
"BHAVYA FINANCIAL SERVICES PRIVATE LIMITED",
"BHAVYA IMPEX PRIVATE LIMITED",
"BHAVYA INFOWAY PRIVATE LIMITED",
"BHAVYA INFRA & SYSTEMS PRIVATE LIMITED",
"BHAVYA IRON & STEEL PRIVATE LIMITED",
"BHAVYA MEDICAL CENTRE PRIVATE LIMITED",
"BHAVYA POLYFILMS PRIVATE LIMITED",
"BHAVYA STAINLESS PRIVATE LIMITED",
"BHAVYA TUBES PRIVATE LIMITED",
"BHAVYABHANU ELECTRONICS PRIVATE LIMITED",
"BHAVYABHARAT INFRASTRUCTURE & CONSTRUCTION PRIVATE LIMITED",
"BHAVYAJI COMPUTERS PRIVATE LIMITED",
"BHAVYAKOTI TRADELINK PRIVATE LIMITED",
"BHAVYALAXMI INDUSTRIES PRIVATE LIMITED",
"BHAVYAM ENGINEERING TECHNOLOGIES PRIVATE LIMITED",
"BHAVYAM PHARMACY PRIVATE LIMITED",
"BHAVYANSH INFOTECH INDIA PRIVATE LIMITED",
"BHAVYAS PHARMACEUTICALS PRIVATE LIMITED",
"BHAVYASINDHU INFRA PROJECTS PRIVATE LIMITED",
"BHAVYASRI FARMS PRIVATE LIMITED",
"BHAVYODAYA VENTURES PRIVATE LIMITED",
"BHAWAAL SPINNERS PRIVATE. LIMITED.",
"BHAWAL ELECTRONICS INDIA PRIVATE LIMITED",
"BHAWANI ALUMINA PRODUCTS PRIVATE LIMITED",
"BHAWANI CONCAST (INDIA) PRIVATE LIMITED",
"BHAWANI CONCLAVE PRIVATE LIMITED",
"BHAWANI DEVELOPERS PRIVATE LIMITED",
"BHAWANI DIGITAL SYSTEMS PRIVATE LIMITED",
"BHAWANI DISTRIBUTORS PRIVATE LIMITED",
"BHAWANI E-SERVICES PRIVATE LIMITED",
"BHAWANI EXPORTS PRIVATE LIMITED",
"BHAWANI FASHION FABRICS PRIVATE LIMITED",
"BHAWANI FERROUS PRIVATE LIMITED",
"BHAWANI FINVEST PRIVATE LIMITED",
"BHAWANI FIRE PROTECTION PRIVATE LIMITED",
"BHAWANI FOREX PRIVATE LIMITED",
"BHAWANI FREIGHT & FORWARDER PRIVATE LIMITED",
"BHAWANI GOLD PVT LTD",
"BHAWANI HOMES PROJECTS PRIVATE LIMITED",
"BHAWANI HOUSING & INVESTMENT PRIVATE LIMITED.",
"BHAWANI INDUSTRIES PRIVATE LIMITED",
"BHAWANI INFOCOM PRIVATE LIMITED",
"BHAWANI INTERNATIONAL PRIVATE LIMITED",
"BHAWANI KITCHENWARE PRIVATE LIMITED",
"BHAWANI LEADERS PRIVATE LIMITED",
"BHAWANI MARKETING PVT LTD",
"BHAWANI METALLOY PRIVATE LIMITED",
"BHAWANI MOULDERS PVT LTD",
"BHAWANI PLASTICS PRIVATE LIMITED",
"BHAWANI PLYWOODS PVT LTD",
"BHAWANI PRIVATE INDUSTRIAL TRAINING INSTITUTE",
"BHAWANI RAJESH CABLE & DIGITECH SERVICES PRIVATE LIMITED",
"BHAWANI REALTECH PRIVATE LIMITED",
"BHAWANI ROLLER FLOUR MILLS PRIVATE LIMITED",
"BHAWANI SHANKAR CASTING PRIVATE LIMITED",
"BHAWANI SHANKAR UDYOG PRIVATE LIMITED",
"BHAWANI STEELS PRIVATE LTD",
"BHAWANI TEXFAB PRIVATE LIMITED",
"BHAWANI WIRE PRIVATE LIMITED",
"BHAWANI WOOLTEX PRIVATE LIMITED",
"BHAWANI YARNS PRIVATE LIMITED",
"BHAWAR SALES CORPORATION",
"BHAWIL LIFE STYLES INNOVATIONS PRIVATE LIMITED",
"BHAWNA HOUSING PRIVATE LIMITED",
"BHAWNA IRON PRIVATE LIMITED",
"BHAWSAR CHEMICALS PRIVATE LIMITED",
"BHAWSINGHKA COMMODITY BROKING PRIVATE LIMITED",
"BHAYAJI MERCANTILE PRIVATE LIMITED",
"BHAYANA BUILDERS PRIVATE LIMITED",
"BHAYANI AUXI-CHEM PRIVATE LIMITED",
"BHC DIAM PRIVATE LIMITED",
"BHDM ADVERTISING INDIA PRIVATE LIMITED",
"BHEEM INFORMATICS PRIVATE LIMITED",
"BHEEMA FUELIVERY PRIVATE LIMITED",
"BHEEMA TOLLING & TRAFFIC SOLUTION PRIVATE LIMITED",
"BHEEMAA INFRA SOLUTIONS PRIVATE LIMITED",
"BHEEMAREDDY PROJECTS PRIVATE LIMITED",
"BHEERAM SREEDHAR REDDY INTERNATIONAL SCHOOL",
"BHEESHMAA AGROTECH PRIVATE LIMITED",
"BHEJO ECOMMERCE PRIVATE LIMITED",
"BHEL GE GAS TURBINE SERVICES PRIVATE LIMITED",
"BHEL SHIKSHA MANDAL BHOPAL",
"BHERAWA TEXTILE INDUSTRIES PRIVATE LIMITED",
"BHERGAON TEA INDUSTRIES PRIVATE LIMITED",
"BHERO JI INFRAESTATE PRIVATE LIMITED",
"BHERU BHAWANI MARBLES PRIVATE LIMITED",
"BHERUNATH ENERGY PRIVATE LIMITED",
"BHERWA METALS PRIVATE LIMITED",
"BHESAJ BUSINESS SERVICES PRIVATE LIMITED",
"BHF INTERNATIONAL PRIVATE LIMITED",
"BHG PROPERTIES PRIVATE LIMITED",
"BHH MARKETING PRIVATE LIMITED",
"BHH TECHNOLOGIES LIMITED",
"BHHO TECH SOLUTIONS PRIVATE LIMITED",
"BHIDE AND SONS PVT LTD",
"BHIKAJI CAMA PLACE FIRE STATION",
"BHIKAM CHAND TIMBERS PRIVATE LIMITED",
"BHIKHAN LAL RAJ KUMAR OVERSEAS PRIVATE LIMITED",
"BHIKHARAM CHANDMAL BHUJIAWALA PVT. LTD",
"BHIKHARAM CHANDMAL MITHAI NAMKINS PRIVATE LIMITED",
"BHIKKAMAL CHHOTELAL EXIM PRIVATE LIMITED",
"BHIKKI METALS PRIVATE LIMITED",
"BHIKSHU INNOVATIONS INDIA PRIVATE LIMITED",
"BHIKUSA PAPERS PRIVATE LIMITED",
"BHILAI CARBONS PRIVATE LIMITED",
"BHILAI CHEMICAL PVT LTD",
"BHILAI CONDUCTORS PVT LTD",
"BHILAI DURG WASTE MANAGEMENT PRIVATE LIMITED",
"BHILAI ENGINEERING CORPORATION LIMITED",
"BHILAI ENGINEERING INDUSTRIES LIMITED",
"BHILAI HEAVY STEEL TRADING PRIVATE LIMITED",
"BHILAI INSTITUTE OF TECHNOLOGY DURG",
"BHILAI IRON AND STEEL PROCESSING COMPANY PRIVATE LIMITED",
"BHILAI ISPAT PRIVATE LIMITED",
"BHILAI METAL PRIVATE LIMITED",
"BHILAI STEEL PLANT",
"BHILANGANA HYDRO POWER LIMITED",
"BHILCHEM INDUSTRIES PRIVATE LIMITED",
"BHILOSA INDUSTRIES PRIVATE LIMITED",
"BHILWARA AGRO AUTO SERVICES PRIVATE LIMITED",
"BHILWARA CONSTRUCTIONS PRIVATE LIMITED",
"BHILWARA ENERGY LIMITED",
"BHILWARA FEBPRO PRIVATE LIMITED",
"BHILWARA GREEN ENERGY LIMITED",
"BHILWARA INFOTECHNOLOGY LIMITED",
"BHILWARA MEDICAL COLLEGE",
"BHILWARA POLYSTER PRIVATE LIMITED.",
"BHILWARA SPINNERS LIMITED",
"BHILWARA TECHNICAL TEXTILES LIMITED",
"BHILWARA URBAN CO-OPERATIVE BANK LTD",
"BHILWARA ZILA DUGDH UTPADAK SAHKARI SANGH LIMITED",
"BHILWARA-RAJSAMAND TOLLWAY PRIVATE LIMITED",
"BHIM INDUSTRIES PRIVATE LIMITED",
"BHIM MOTORS PRIVATE LIMITED",
"BHIM POLYFAB INDUSTRIES",
"BHIM PRASAD CONSTRUCTION PRIVATE LIMITED",
"BHIMA AND BROTHER BULLION PRIVATE LIMITED",
"BHIMA GEMS (ADOOR) PRIVATE LIMITED",
"BHIMA JEWELLERS",
"BHIMA JEWELLERY & DIAMONDS PRIVATE LIMITED",
"BHIMA JEWELS PRIVATE LIMITED",
"BHIMA LIFESCIENCES LLP",
"BHIMA RIDDHI INFOTAINMENT PRIVATE LIMITED",
"BHIMA SOFT PRIVATE LIMITED",
"BHIMANI CHEMICALS PRIVATE LIMITED",
"BHIMANI JEWELS PVT LTD",
"BHIMAS HOTELS PRIVATE LIMITED",
"BHIMAS RESIDENCY HOTELS PRIVATE LIMITED",
"BHIMASHANKAR AGRO COLDCHAIN & PROCESSING PRODUCER COMPANY LIMITED",
"BHIMASHANKAR AGRO PRODUCTS PRIVATE LIMITED",
"BHIMASHANKAR ENTERPRISES PRIVATE LIMITED",
"BHIMASHANKAR HYDROLICS",
"BHIMASHANKAR SAHKARI SAKHAR KARKHANA LIMITED",
"BHIMASHANKAR SUGAR MILLS PRIVATE LIMITED",
"BHIMAVARAM HOSPITALS LIMITED",
"BHIMAVARAM INSTITUTE OF ONCOLOGY PRIVATE LIMITED",
"BHIMJI SAREES PRIVATE LIMITED",
"BHIMJI VELJI SORATHIA CONSTRUCTION PRIVATE LIMITED",
"BHIMRAJ EXPORTS PRIVATE LIMITED",
"BHIMRAJ SAMPATLAL TREXIM PRIVATE LIMITED",
"BHIMRAJ SYNTEX PRIVATE LIMITED",
"BHIMSARIA AGENCIES PRIVATE LIMITED",
"BHIMSARIA DOORS PRIVATE LIMITED",
"BHIMSARIA MINERAL PRIVATE LIMITED",
"BHIMSARIA POLYMERS PRIVATE LIMITED",
"BHIMSERIA AGRO PRIVATE LIMITED",
"BHINGARE CASTINGS PRIVATE LIMITED",
"BHINMAL CONTRACTORS PROPERTY AND LAND DEVELOPERS PRIVATE LIMITED",
"BHIRINGHEE COMMERCIAL PRIVATE LIMITED",
"BHIRINGHEE MINING & MINERALS PRIVATE LIMITED",
"BHIRINGHEE TRADING PRIVATE LIMITED",
"BHISE CERAMICS P LTD",
"BHISE INFOELEC PRIVATE LIMITED",
"BHISHAM RAMANI PROPERTIES PRIVATE. LIMITED.",
"BHISHMA AGRI RESEARCH BIOTECH PRIVATE LIMITED",
"BHISHMA AGRO FOOD PRODUCTS PRIVATE LIMITED",
"BHISHMA REALTY LIMITED",
"BHIVARABAI SAWANT INSTITUTE OF TECHNOLOGY & RESEARCH",
"BHIVATE RICE MILLS P LTD",
"BHIVRABAI SAWANT POLYTECHNIC",
"BHIWADI CYLINDERS PRIVATE LIMITED",
"BHIWADI IRON PRIVATE LIMITED",
"BHIWADI JAL PRADUSHAN NIVARAN ASSOCIATION",
"BHIWADI METAL ROLLWELL PVT. LTD.",
"BHIWADI MOTOR CYCLES PRIVATE LIMITED",
"BHIWANDI NIZAMPUR CITY MUNICIPAL COPORATION",
"BHIWANDI SCAN CENTRE PRIVATE LIMITED",
"BHIWANI COLOR CHEM INDIA LTD",
"BHIWANI FOODS PRIVATE LIMITED",
"BHIWANI GENERAL EYE HOSPITAL",
"BHL POWER SYSTEM PRIVATE LIMITED",
"BHL RASAYAN UDYOG INDIA PRIVATE LIMITED",
"BHM AGRIZENTIC PRIVATE LIMITED",
"BHM COMMERCE PVT.LTD.",
"BHN OFFSHORE SERVICES PRIVATE LIMITED",
"BHN PROAGE LIVING PRIVATE LIMITED",
"BHN SURGICALS PRIVATE LIMITED",
"BHOGALE AUTOMOTIVE PRIVATE LIMITED",
"BHOGALE COATING AND PAINTS PRIVATE LIMITED",
"BHOGALI FOODS PRODUCTS PRIVATE LIMITED",
"BHOGALS PRIVATE LIMITED",
"BHOGAR TRADERS PRIVATE LIMITED",
"BHOGI CONSUMER PRODUCT PRIVATE LIMITED",
"BHOGILAL ODHAVJI INDUSTRIAL ENTERPRISE PRIVATE LIMITED",
"BHOIR DREDGING CO PVT LTD",
"BHOJ REDDY ENGINEERING COLLEGE FOR WOMEN",
"BHOJANI PHARMA PRIVATE LIMITED",
"BHOJANTECH PRIVATE LIMITED",
"BHOJESHWAR REALTORS PRIVATE LIMITED",
"BHOJIA CEMENT SERVICES PVT LTD",
"BHOJOHORI MANNA RESTAURANTS INDIA LIMITED",
"BHOJPAL BUILDERS AND DEVELOPERS PVT LTD",
"BHOJPUR MAHADEV HIGHWAYS PRIVATE LIMITED",
"BHOJWANI UNIVERSAL IMPEX PRIVATE LIMITED",
"BHOLA AUTO FINLEASE PRIVATE LIMITED",
"BHOLA ENGINEERS PRIVATE LIMITED",
"BHOLA FOOTWEAR EXPORT PRIVATE LIMITED",
"BHOLA HIGH SCHOOL",
"BHOLA JEWELLERS PRIVATE LIMITED",
"BHOLA JEWELMART PRIVATE LIMITED",
"BHOLA MOHINI MINERALS PRIVATE LIMITED",
"BHOLA MOTOR FINANCE PRIVATE LIMITED",
"BHOLA NATH KHANNA AND CO PVT LTD",
"BHOLA NATH ZAVERI JEWELLERS PRIVATE LIMITED",
"BHOLA RAM AGRO INDUSTRIES PRIVATE LIMITED",
"BHOLA RAM PAPERS & POWER PRIVATE LIMITED",
"BHOLA RAM STEELS PRIVATE LIMITED",
"BHOLA SHANKAR COLD STORAGE PVT LTD",
"BHOLA SINGH JAIPRAKASH CONSTRUCTION LIMITED",
"BHOLA SYNTHETICS PRIVATE LIMITED",
"BHOLANATH COTTON MILLS PVT LTD",
"BHOLANATH PRECISION ENGINEERING PRIVATE LIMITED",
"BHOLARAM IMPEX PRIVATE LIMITED",
"BHOLARAM METAL INDUSTRIES PRIVATE. LIMITED.",
"BHOLASINGH INDUSTRIES PRIVATE LIMITED",
"BHOLASONS JEWELLERS GOLD SOUK",
"BHOLE BABA CONSTRUCTIONS PRIVATE LIMITED",
"BHOLE BABA FRUIT COMPANY PRIVATE LIMITED",
"BHOLE BABA INFRASTRUCTURE PRIVATE LIMITED",
"BHOLE BABA MILK FOOD INDUSTRIES DHOLPUR PRIVATE LIMITED",
"BHOLE BABA MILK FOOD INDUSTRIES LIMITED",
"BHOLE BABA OROGANIC DAIRYMILK PRIVATE LIMITED",
"BHOLE BABA TRADERS PRIVATE LIMITED",
"BHOLE NATH EXIM PRIVATE LIMITED",
"BHOLE NATH FOODS PRIVATE. LIMITED.",
"BHOLE SHANKAR LOGISTICS PRIVATE LIMITED",
"BHOLE SHANKER ROLLER FLOUR MILLS PRIVATE LIMITED",
"BHOLEBABA UTILITIES LIMITED",
"BHOLENATH AGENCY PRIVATE LIMITED",
"BHOLENATH AGRO PRODUCTS PRIVATE LIMITED",
"BHOLENATH FOODS LIMITED",
"BHOLENATH OVERSEAS PRIVATE LIMITED",
"BHOLENATH TRADERS PRIVATE LIMITED",
"BHOLESHANKER ERECTION AND CONSTRUCTION PRIVATE LIMITED",
"BHOLEY BABA INFRACON PRIVATE LIMITED",
"BHOLI HARDWARE AND EXPORTS PRIVATE LIMITED",
"BHOMI RE-ROLLS PRIVATE LIMITED",
"BHOMIA COPPER PVT LTD",
"BHOMIA PUBLICATION PRIVATE LIMITED",
"BHONDEKAR EDUCATIONAL INSTITUTIONS PRIVATE LIMITED",
"BHONWAL SCHOOL OF ENGINEERING LUCKNOW",
"BHOOLOK INTERNATIONAL REALTY PRIVATE LIMITED",
"BHOOMATHA REAL ESTATES & DEVELOPERS PRIVATE LIMITED",
"BHOOMEKA PROCESSORS PRIVATE LIMITED",
"BHOOMI AGRO HI TECH PRIVATE LIMITED",
"BHOOMI AGRO PRODUCE PRIVATE LIMITED",
"BHOOMI AND BUILDINGS PRIVATE LIMITED",
"BHOOMI BUILDERS AND CONTRACTORS PRIVATE LIMITED",
"BHOOMI CONSULTANTS (INDIA) PRIVATE LIMITED",
"BHOOMI DIAGNOSTIC AND HOSPITAL PRIVATE LIMITED",
"BHOOMI EARTHMOVERS PRIVATE LIMITED",
"BHOOMI EVENTS AND PLANNERS PRIVATE LIMITED",
"BHOOMI FABRICATING SOLUTIONS PRIVATE LIMITED",
"BHOOMI FASHION PRIVATE LIMITED",
"BHOOMI HOTELS PRIVATE LIMITED",
"BHOOMI MEGAPROJECT PRIVATE LIMITED",
"BHOOMI METACAST PRIVATE LIMITED",
"BHOOMI MODULAR SYSTEMS PRIVATE LIMITED",
"BHOOMI NATURAL PRODUCTS AND EXPORTS PRIVATE LIMITED",
"BHOOMI PHOSPHATE PRIVATE LIMITED",
"BHOOMI POLYPLAST PRIVATE LIMITED",
"BHOOMI PROCESS MANAGEMENT PRIVATE LIMITED",
"BHOOMI RESOURCES PRIVATE. LIMITED.",
"BHOOMI SERVICE PRIVATE LIMITED",
"BHOOMI SHASHWAT ESTATE PRIVATE LIMITED",
"BHOOMI TEXTILES",
"BHOOMI VIKAS HOUSING PRIVATE LIMITED",
"BHOOMIKA DIGITAL CABLE SERVICES PRIVATE LIMITED",
"BHOOMIKA GARMENTS PRIVATE LIMITED",
"BHOOMINALAM MYHARVEST FARMS PRIVATE LIMITED",
"BHOOMIPOOJA SHELTERS PRIVATE LIMITED",
"BHOOMITRA GLOBAL ASSOCIATES PRIVATE LIMITED",
"BHOOMIVIJAY PROPERTIES PRIVATE LIMITED",
"BHOOP CONSTRUCTION INDIA PRIVATE LIMITED",
"BHOOPALAM MARKETING SERVICES PRIVATE LIMITED",
"BHOOPGARHI WINES PRIVATE LIMITED",
"BHOORATHNOM CONSTRUCTION COMPANY PRIVATE LIMITED",
"BHOOSHAN DEALERS P LTD",
"BHOOTNATH BARTER PRIVATE LIMITED",
"BHOPAL CATTLE FEED PRIVATE LIMITED",
"BHOPAL CITY LINK LIMITED",
"BHOPAL CO-OPERATIVE CENTRAL BANK LTD",
"BHOPAL DHULE TRANSMISSION COMPANY LIMITED",
"BHOPAL E-GOVERNANCE LIMITED",
"BHOPAL ELECTRICAL INSULATION PVT LTD",
"BHOPAL FRACTURE HOSPITAL",
"BHOPAL GLUES AND CHEMICALS PVT LTD",
"BHOPAL INFRASTRUCTURE PRIVATE LIMITED",
"BHOPAL INSTITUTE OF GASTROENTEROLOGY PRIVATE LIMITED",
"BHOPAL INSTITUTE OF TECHNOLIGY AND SCIENCE",
"BHOPAL MEMORIAL HOSPITAL & RESEARCH CENTRE",
"BHOPAL MEMORIAL HOSPITAL RESEARCH CENTRE",
"BHOPAL MOTORS PRIVATE LIMITED",
"BHOPAL SWITCHGEARS PRIVATE LIMITED",
"BHOPAL TRACTORS PRIVATE LIMITED",
"BHOPAL UDYOG LIMITED",
"BHOR CHEMICALS AND PLASTICS PRIVATE LIMITED",
"BHOR COMMUNICATION PRIVATE LIMITED",
"BHOR ENGINEERING PRIVATE LIMITED",
"BHOR TECHTRADE PRIVATE LIMITED",
"BHOR TRANSPORT CORPORATION PRIVATE LIMITED",
"BHORASKAR HOSPITAL",
"BHORUKA EXPRESS CONSOLIDATED LIMITED",
"BHORUKA EXTRUSIONS PRIVATE LIMITED",
"BHORUKA FABCONS PRIVATE LIMITED",
"BHORUKA FINANCE CORPORATION OF INDIA LIMITED",
"BHORUKA INVESTMENT LTD.",
"BHORUKA LOGISTICS PRIVATE LIMITED",
"BHORUKA PARK PRIVATE LIMITED",
"BHORUKA POWER CORPORATION LIMITED",
"BHORUKA POWER INVESTMENTS INDIA PRIVATE LIMITED",
"BHORUKA ROADWAYS INDIA PRIVATE LIMITED",
"BHORUKA SUPPLY CHAIN SOLUTIONS HOLDINGS LIMITED",
"BHOSALE INDUSTRIES",
"BHOSE AGRO PRODUCER COMPANY LIMITED",
"BHOSHO ARCHITECTS PRIVATE LIMITED",
"BHOTIKA ISPAT PRIVATE LIMITED",
"BHOTIKA PIPELINE SERVICES COMPANY PRIVATE LIMITED",
"BHOTIKA TRADE AND SERVICES PRIVATE LIMITED",
"BHOWAL TEXTILES PVT. LTD.",
"BHOWMIK DYEING AND BLEACHING PRIVATE LIMITED",
"BHOWMIK KNIT-FAB PRIVATE LIMITED",
"BHOX AIR GAS PRIVATE LIMITED",
"BHP BILLITON MARKETING SERVICES INDIA PRIVATE LIMITED",
"BHP GRANITES PRIVATE LIMITED",
"BHPC PERSONAL CARE PRIVATE LIMITED",
"BHR COMMUNICATION PRIVATE LIMITED",
"BHR VENTURES PRIVATE LIMITED",
"BHRAMARA POLYMERS PRIVATE LIMITED",
"BHRAMARI HOSPITALITY PRIVATE LIMITED",
"BHRAMARI STEELS PRIVATE LIMITED",
"BHRIGU INFRA PRIVATE LIMITED",
"BHRIGU PHARMA PRIVATE LIMITED",
"BHRIGUNATH COMMERCIAL TRADE PRIVATE LIMITED",
"BHRMAA SOFTWARE SOLUTIONS PRIVATE LIMITED",
"BHRUNDA INFRA PRIVATE LIMITED",
"BHRUNGI HOSPITALS PRIVATE LIMITED",
"BHS CORRUGATED INDIA PRIVATE LIMITED",
"BHS HOSPITALITY PRIVATE LIMITED",
"BHS LAKEVIEW HOSPITAL BELAGAVI",
"BHS-SONTHOFEN (INDIA) PRIVATE LIMITED",
"BHSSYEN SYSTEM PRIVATE LIMITED",
"BHU LAXMI JEWELLERS PRIVATE LIMITED",
"BHUAMRIT FARMER PRODUCER COMPANY LIMITED",
"BHUASUNI PRECAST PRIVATE LIMITED",
"BHUBANESHWAR POWER PRIVATE LIMITED",
"BHUBANESHWARI SEAFOOD PRIVATE LIMITED",
"BHUBANESWAR AGRO & FOOD PRODUCTS PRIVATE LIMITED",
"BHUBANESWAR CLUB",
"BHUBANESWAR DEVELOPMENT AUTHORITY",
"BHUBANESWAR HATCHERIES PRIVATE LIMITED",
"BHUBANESWAR MUNICIPAL CORPORATION",
"BHUBANESWAR MUNICIPAL HOSPITAL",
"BHUBANESWAR STONE PRIVATE LIMITED",
"BHUBANESWAR UDYOG PVT LTD",
"BHUBANESWARI COAL MINING LIMITED",
"BHUBRIGHAT TEA CO PVT LTD",
"BHUDEV ONE STOP SOLUTION PRIVATE LIMITED",
"BHUDEVA POLYMERS PRIVATE LIMITED",
"BHUDEVI COLD STORAGE PRIVATE LIMITED",
"BHUDEVI MEDICARE PRIVATE LIMITED",
"BHUDOLIA MICA MINING PRIVATE LIMITED",
"BHUGAN INFRACON PRIVATE LIMITED",
"BHUGAN LIFESCIENCE PRIVATE LIMITED",
"BHUGARV MINES & MINERALS PRIVATE LIMITED",
"BHUGOL ANALYTICS PRIVATE LIMITED",
"BHUGOL GIS PRIVATE LIMITED",
"BHUJADHARI TREXIM PRIVATE LIMITED",
"BHUJANG INFRA (OPC) PRIVATE LIMITED",
"BHUKHANVALA HOLDINGS PRIVATE LIMITED",
"BHUKHANVALA INDUSTRIES PRIVATE LIMITED",
"BHULABHAI VANMALIBHAI PATEL INSTITUTE OF TECHNOLOGY ( DIPLOMA STUDIES)",
"BHULESHWAR STEEL AND ALLOYS PVT LTD",
"BHULKASAGAR EDUCATION FOUNDATION",
"BHULKU INDUSTRIES PRIVATE LIMITED",
"BHUMAHA SOLUTIONS PRIVATE LIMITED",
"BHUMAPURA MADHYAMIK SHAH",
"BHUMEL PRATHMIK SHALA",
"BHUMGADI MAHILA KRUSHAK PRODUCER COMPANY LIMITED",
"BHUMI COTTEX INDUSTRY PRIVATE LIMITED",
"BHUMI COTTON PRIVATE LIMITED",
"BHUMI DESIGN & ENGITECH PRIVATE LIMITED",
"BHUMI ELECTRO INDIA PRIVATE LIMITED",
"BHUMI ENTECH EQUIPMENTS PRIVATE LIMITED",
"BHUMI E-RETAIL PRIVATE LIMITED",
"BHUMI ESTATE DEVELOPERS PRIVATE LIMITED",
"BHUMI GEOSYNTHETICS PRIVATE LIMITED",
"BHUMI GREEN ENERGY PRIVATE LIMITED",
"BHUMI INFRABUILD PRIVATE LIMITED",
"BHUMI PETROCHEM PVT LTD",
"BHUMI PLASTIC PIPES PRIVATE LIMITED",
"BHUMI POLYMERS PRIVATE LIMITED",
"BHUMI PRAKASH PRIVATE LIMITED",
"BHUMI PROCON PRIVATE LIMITED",
"BHUMI ROADWAYS PRIVATE LIMITED",
"BHUMI SANRAKSHAN ADHIKARI",
"BHUMI SANRAKSHAN ADHIKARI OFFICE JAUNPUR",
"BHUMI SANRAKSHAN ADHIKARI USAR YOJANA VNS",
"BHUMI TECHNOCAST PRIVATE LIMITED",
"BHUMI YARN PRIVATE LIMITED",
"BHUMIJA COLOURANTS PRIVATE LIMITED",
"BHUMIKA",
"BHUMIKA ALLOY CASTINGS PRIVATE LIMITED",
"BHUMIKA CLEAN AND CARE PRIVATE LIMITED",
"BHUMIKA CONSULTANCY PRIVATE LIMITED",
"BHUMIKA ENTERPRISES PRIVATE LIMITED",
"BHUMIKA EXIM PRIVATE LIMITED",
"BHUMIKA HIGHSTREET INDIA PRIVATE LIMITED",
"BHUMIKA ROADLINES PRIVATE LIMITED",
"BHUMIKA UV GLOBAL PRIVATE LIMITED",
"BHUMIPUTRA MILK PRODUCTS PRIVATE LIMITED",
"BHUMISHAKTI NIRMAN PRIVATE LIMITED",
"BHUMISREE CONSULTANCY & MARKETING PRIVATE LIMITED",
"BHUMIT PHARMA PRIVATE LIMITED",
"BHUMYA PRIVATE LIMITED",
"BHUNIRMAN INFRASTRUCTURE PROJECTS PRIVATE LIMITED",
"BHUNIT ENGINEERING CO PRIVATE LIMITED",
"BHUNNA SUGARS LIMITED",
"BHUPAL NOBLES' UNIVERSITY UDAIPUR",
"BHUPATI INFRABUILD SERVICES PRIVATE LIMITED",
"BHUPATI INVESTMENTS AND FINANCE PRIVATE LIMITED",
"BHUPENDER ENTERPRISES PRIVATE LIMITED",
"BHUPENDRA AND BROTHERS (MACHINERY) PRIVA TE LIMITED",
"BHUPENDRA ENGINEERING & CONSTRUCTION PRIVATE LIMITED",
"BHUPENDRA HOUSE CRANE SERVICE PRIVATE LIMITED",
"BHUPENDRA IRON ROLLING MILLS PVT.LTD",
"BHUPENDRA OVERSEAS PRIVATE LIMITED",
"BHUPENDRA STEELS PRIVATE LIMITED",
"BHUPINDER SINGH AND SONS COOKWARE PRIVATE LIMITED",
"BHUPINDRA MACHINES PRIVATE LIMITED",
"BHUPINE HEALTHCARE PRIVATE LIMITED",
"BHUPTANI ASSOCIATES",
"BHURAMAL RAJMAL SURANA AND SONS PRIVATE LIMITED",
"BHURARIA CONSULTANTS LIMITED",
"BHURIA INTERNATIONAL PRIVATE LIMITED",
"BHURJI ELECTRONICS PRIVATE LIMITED",
"BHURJI ELECTRONIKS PRIVATE LIMITED",
"BHURJI SUPER TEK INDUSTRIES LIMITED",
"BHUSAN FLOUR MILLS PRIVATE LIMITED",
"BHUSARI FARMS PRIVATE LIMITED",
"BHUSEVA FARMERS PRODUCER COMPANY LIMITED",
"BHUSHAN AUTOMOBILES PRIVATE LIMITED",
"BHUSHAN AVIATION LIMITED",
"BHUSHAN CAPITAL & CREDIT SERVICES PRIVATE LIMITED",
"BHUSHAN FOODS PVT.LTD.",
"BHUSHAN LAL FABRICS PRIVATE LIMITED",
"BHUSHAN MEDICARE PRIVATE LIMITED",
"BHUSHAN OIL & FATS PRIVATE LIMITED",
"BHUSHAN PHARMACEUTICALS PRIVATE LIMITED",
"BHUSHAN POWER & STEEL LIMITED",
"BHUSHAN RAJIV INFRATECH PRIVATE LIMITED",
"BHUSHAN TUBES PRIVATE LIMITED",
"BHUSHAN WOOLLENS PRIVATE LIMITED",
"BHUSHANCORP PRIVATE LIMITED",
"BHUSHILP MINES AND MINERALS PRIVATE LIMITED",
"BHUSHILPA CHEMICALS PRIVATE LIMITED",
"BHUSWAMI BUILDCON PRIVATE LIMITED",
"BHUTA INDUSTRIAL GASES PRIVATE LIMITED",
"BHUTA SHAH & CO LLP",
"BHUTANI AND COMPANY PRIVATE LIMITED",
"BHUTANI ASSOCIATES PVT LTD",
"BHUTANI AUTOMOBILES PRIVATE LIMITED",
"BHUTANI INTERNATIONAL PRIVATE LIMITED",
"BHUTANI RADIALS PRIVATE LIMITED",
"BHUTANTUFF PLYWOODS INDIA PRIVATE LIMITED",
"BHUTESHWAR NIRMAN PRIVATE LIMITED",
"BHUTNATH REALTY PRIVATE LIMITED",
"BHUTORIA CONSTRUCTION PVT LTD",
"BHUTORIA CONSUMER PRODUCTS PRIVATE LIMITED",
"BHUTORIA REFRIGERATION PRIVATE LIMITED",
"BHUTORIA VALVE UDYOG LTD",
"BHUVA ENGINEERS PRIVATE LIMITED",
"BHUVA POLYPLAST PRIVATE LIMITED",
"BHUVAL INDUSTRIES",
"BHUVAN DEVELOPERS PRIVATE LIMITED",
"BHUVAN LABELS PRIVATE LIMITED",
"BHUVAN MARKETING PRIVATE LIMITED",
"BHUVAN WHEELS PRIVATE LIMITED",
"BHUVANA INFRA PROJECTS PRIVATE LIMITED",
"BHUVANASHREE ELECTRICALS AND CONSTRUCTIONS PRIVATE LIMITED",
"BHUVANESHWARI CONSTRUCTIONS PRIVATE LIMITED",
"BHUVANESHWARI ORGANICS PRIVATE LIMITED",
"BHUVANESHWARI TEXTILES PRIVATE LIMITED",
"BHUVANESWARI CIVIL ENGINEERS PRIVATE LIMITED",
"BHUVANESWARI COTSPIN INDIA PRIVATE LIMITED",
"BHUVANESWARI LINES & LOGISTICS PRIVATE LIMITED",
"BHUVANTRAY INVESTMENT AND TRADING COMPANY PRIVATE LIMITED",
"BHUVEEN INDIA PRIVATE LIMITED",
"BHUVI CARE PRIVATE LIMITED",
"BHUVI INFRACON PRIVATE LIMITED",
"BHUVI PETROLEUM PRIVATE LIMITED",
"BHUVI PHARMACY",
"BHUVIJA INFRA PROJECTS PRIVATE LIMITED",
"BHUVNESHEWARI VYAPAAR PRIVATE LIMITED",
"BHUWAL INSULATION CABLE PRIVATE LIMITED",
"BHUWALKA & SONS PRIVATE LIMITED",
"BHUWALKA ALLOYS PRIVATE LIMITED",
"BHUWALKA CASTINGS & FORGING PRIVATE LIMITED",
"BHUWALKA DEVELOPMENTS PVT LTD",
"BHUWALKA ENTERPRISES PVT LTD",
"BHUWALKA PIPES PRIVATE LIMITED",
"BHUWALKA SALES CORPORATION",
"BHUWALKA STEEL INDUSTRIES LIMITED",
"BHUWALKA TRADING & TEA CO. PVT. LTD.",
"BHUWANESHWAR REFINERIES PRIVATE LIMITED",
"BHUWNESHWAR PATHAK CONSTRUCTION PRIVATE LIMITED",
"BHUYAN ASSOCIATES PRIVATE LIMITED",
"BI BIOTECH INDIA PRIVATE LIMITED",
"BI INDUSTRIES PRIVATE LIMITED",
"BI MARKETING AND SERVICES PRIVATE LIMITED",
"BI MINING PRIVATE LIMITED",
"BI WORLDWIDE INDIA PRIVATE LIMITED",
"BIA VENTURES PRIVATE LIMITED",
"BIAC AND VISTAR (JV) INFRA INDIA PRIVATE LIMITED",
"BIAMP SYSTEMS INDIA PRIVATE LIMITED",
"BIANCHI CASSEFORME ( INDIA ) PRIVATE LIMITED",
"BIANCO TEXTILE SOLUTIONS INDIA PRIVATE LIMITED",
"BIANSH CONSTRUCTION PRIVATE LIMITED",
"BIAORA TO DEWAS HIGHWAY PRIVATE LIMITED",
"BIAS INFOTECH PRIVATE LIMITED",
"BIAS IT CONSULTING PRIVATE LIMITED",
"BIBA APPARELS PRIVATE LIMITED",
"BIBA FASHION LIMITED",
"BIBBY FINANCIAL SERVICES (INDIA) PRIVATE LIMITED",
"BIBHA SUPPLY CHAIN SERVICES PRIVATE LIMITED",
"BIBHASH DISTRIBUTORS PRIVATE LIMITED",
"BIBI ONCOLOGY SERVICES PRIVATE LIMITED",
"BIBLIA IMPEX PRIVATE LIMITED",
"BIBUS INDIA PRIVATE LIMITED",
"BIC CELLO INDIA PRIVATE LIMITED",
"BIC CHEMICALS & PACKAGINGS PRIVATE. LIMITED",
"BIC INFRA PROJECTS PRIVATE LIMITED",
"BIC LOGISTICS LIMITED",
"BICELLI GECO HYDRAULICS INDIA PRIVATE LIMITED",
"BICHAMP CUTTING TECHNOLOGY INDIA PRIVATE LIMITED",
"BI-CHEM (INDIA) PRIVATE LIMITED CN",
"BICHHONNA BEDDING COMPANY PRIVATE LIMITED",
"BICHITRA HOLDINGS PVT LTD",
"BICO TWITEX PRIVATE LIMITED",
"BICONOMY LABS PRIVATE LIMITED",
"BICS INFOTECH PRIVATE LIMITED",
"BID & HAMMER AUCTIONEERS PRIVATE LIMITED",
"BID4BEST TECHNOLOGIES PRIVATE LIMITED",
"BIDADA FOODS PRIVATE LIMITED",
"BIDADI METAL FINISHERS PRIVATE LIMITED",
"BIDAR KISSAN SHAKHAR KARKHANA LIMITED",
"BIDAR RUBBER AND RECLAIMS PRIVATE LIMITED",
"BIDAR SOLAR POWER PRIVATE LIMITED",
"BIDAR TRANSMISSION LIMITED",
"BIDASARIA EXPORTS PVT LTD",
"BIDASS INDUSTRIAL SERVICES ASSOCIATION",
"BIDDLE SAWYER",
"BIDDLEGRIP TECHNOCRATS PRIVATE LIMITED",
"BIDFE INTERNATIONAL AUCTIONEERS PRIVATE LIMITED",
"BIDGELY TECHNOLOGIES PRIVATE LIMITED",
"BIDHAN CHANDRA COLLEGE RISHNA",
"BIDHAN CHANDRA KRISHI VISWAVIDYALAYA",
"BIDHAN JEWELLERS & DIAMOND PRIVATE LIMITED",
"BIDHAN NAGAR COLLEGE",
"BIDHAN NAGAR STATE GENERAL HOSPITAL",
"BIDHAN RESEARCH AND BREEDING FARM PRIVATE LIMITED",
"BIDHATA AGRO FOOD INDUSTRIES PRIVATE LIMITED",
"BIDHATA GARMENTS PRIVATE LIMITED",
"BIDHATA INDUSTRIES PRIVATE LIMITED",
"BIDHATA TEXPORT PRIVATE LIMITED",
"BIDISHA ENTERPRISES PRIVATE LIMITED",
"BIDONHOMES DOTCOM PRIVATE LIMITED",
"BIDSTALK TECHNOLOGIES PRIVATE LIMITED",
"BIDTRACER PRIVATE LIMITED",
"BIDVEST INDUSTRIES PRIVATE LIMITED",
"BIDW TECHNOLOGY PRIVATE LIMITED",
"BIDWAL RENEWABLE PRIVATE LIMITED",
"BIDWAY PROJECTS PRIVATE LIMITED",
"BIDYA 2ND SALE PRIVATE LIMITED",
"BIDYASHREE ELECTRONICS PRIVATE LIMITED",
"BIDYUT AUTOTECH PRIVATE LIMITED",
"BIDYUT PRAVA HEALTHCARE PRIVATE LIMITED",
"BIENSUR TECHNOLOGY PRIVATE LIMITED",
"BIENVILLE ESTATES ENTERPRISE PRIVATE LIMITED",
"BIESSE MANUFACTURING COMPANY PRIVATE LIMITED",
"BIEVENUE TRAVELS INDIA PRIVATE LIMITED",
"BIEXI TECHNO PRIVATE LIMITED",
"BIFOOT INFOTECH PRIVATE LIMITED",
"BIG 3 PRODUCTIONS INDIA PRIVATE LIMITED",
"BIG ANIMATION I PRIVATE LIMITED",
"BIG APOLLO SPECTRA HOSPITAL",
"BIG BAAG AGRO PRIVATE LIMITED",
"BIG BAD WOLF ENTERTAINMENT PRIVATE LIMITED",
"BIG BAGS INTERNATIONAL PRIVATE LIMITED",
"BIG BANG BOOM SOLUTIONS PRIVATE LIMITED",
"BIG BANG MEDIA PRIVATE LIMITED",
"BIG BANG RECORDS PRIVATE LIMITED",
"BIG BANSAL PRIVATE LIMITED",
"BIG BASKET",
"BIG BEAR FOODS PRIVATE LIMITED",
"BIG BINARY SOLUTIONS PRIVATE LIMITED",
"BIG BLUE BANYAN (INDIA) PRIVATE LIMITED",
"BIG BOSS AGRO SOLUTIONS PRIVATE LIMITED",
"BIG BOSS FOODS PVT LTD",
"BIG BOSS GARMENTS PRIVATE LIMITED",
"BIG BOX CONTAINERS PRIVATE LIMITED",
"BIG BOX SERIES PRIVATE LIMITED",
"BIG BOYS CAFE PRIVATE LIMITED",
"BIG BROTHER DESIGNER PRIVATE LIMITED",
"BIG BULL CAPITAL SERVICES PRIVATE LIMITED",
"BIG BULL INFRASTRUCTURE LIMITED",
"BIG BULL TRADER PRIVATE LIMITED",
"BIG C EQUIPMENT HIRING SOLUTIONS PRIVATE LIMITED",
"BIG C MOBILE PRIVATE LIMITED",
"BIG C MOBILES PRIVATE LIMITED",
"BIG C MOBILES T N PRIVATE LIMITED",
"BIG C TECHNOLOGIES PRIVATE LIMITED",
"BIG CARBONDIOXIDE PRIVATE LIMITED",
"BIG CARBONICS PRIVATE LIMITED",
"BIG CASTINGS PRIVATE LIMITED",
"BIG CHARTER PRIVATE LIMITED",
"BIG CHILL CAFE PRIVATE LIMITED",
"BIG CITY PROJECTS PRIVATE LIMITED",
"BIG DADDY EVENT MANAGEMENT PRIVATE LIMITED",
"BIG DADDY PRODUCTIONS PRIVATE LIMITED",
"BIG DREAMS INFRA PRIVATE LIMITED",
"BIG DRUM INDIA PRIVATE LIMITED",
"BIG DUTCHMAN INTERNATIONAL GMBH",
"BIG ELEPHANT SAFETY PRODUCTS PRIVATE LIMITED",
"BIG EYE ADVERTISEMENT PRIVATE LIMITED",
"BIG FACTION CONSULTANCY PRIVATE LIMITED",
"BIG FLICKS PRIVATE LIMITED",
"BIG FLY HYGIENE PRODUCTS LIMITED",
"BIG FOODS PRIVATE LIMITED",
"BIG FOOT MARKETING PRIVATE LIMITED",
"BIG GIANT INFOTECH (INDIA) PRIVATE LIMITED",
"BIG GROWTH DIGITAL PRIVATE LIMITED",
"BIG GUY FREIGHT SYSTEMS PRIVATE LIMITED",
"BIG HEALTHCARE PRIVATE LIMITED",
"BIG IDEAS HR CONSULTING PRIVATE LIMITED",
"BIG INDIAN WEDDING PRIVATE LIMITED",
"BIG INDUSTRIAL ORGANICS PRIVATE LIMITED",
"BIG IT SOLUTIONS PRIVATE LIMITED",
"BIG LIFT INDIA PVT LTD",
"BIG LOGISTICS INDIA PRIVATE LIMITED",
"BIG LOTS INC.",
"BIG MAGIC LIMITED",
"BIG MART RETAIL SOLUTIONS PRIVATE LIMITED",
"BIG OH NOTATION OPC PRIVATE LIMITED",
"BIG OH NOTATION PRIVATE LIMITED",
"BIG PEENYA CARBONICS PRIVATE LIMITED",
"BIG RATTLE TECHNOLOGIES PRIVATE LIMITED",
"BIG RED EDUCATION PRIVATE LIMITED",
"BIG ROAR PRODUCTIONS PRIVATE LIMITED",
"BIG SEA MARCOM (INDIA) PRIVATE LIMITED",
"BIG SKY CAPITAL ADVISORS PRIVATE LIMITED",
"BIG SKY MANAGEMENT CONSULTANATS PRIVATE LIMITED",
"BIG STOCK LOGISTICS PRIVATE LIMITED",
"BIG SYNERGY MEDIA LIMITED",
"BIG TELECOM INFRASTRUCTURE NETWORKS PRIVATE LIMITED (OPC)",
"BIG TREE ENTERTAINMENT PRIVATE LIMITED",
"BIG TREE RESOURCE MANAGEMENT PRIVATE LIMITED",
"BIG TRUNK COMMUNICATIONS PRIVATE LIMITED",
"BIG VISION PRIVATE LIMITED",
"BIG WONG HOSPITALITY PRIVATE LIMITED",
"BIG X RAY DIAGNOSTICS CENTRE LLP",
"BIGAPPLE LIFESTYLE PRIVATE LIMITED",
"BIGBAG POLYMER PRIVATE LIMITED",
"BIGBERRY MEDIA PRIVATE LIMITED",
"BIGBILLION FOOD & BEVERAGES PRIVATE LIMITED",
"BIGBLOC CONSTRUCTION LIMITED",
"BIGBOSS ELEVATORS LIMITED",
"BIGBRANDTHEORY CONSULTING PRIVATE LIMITED",
"BIGBROTHER NUTRA CARE PRIVATE LIMITED",
"BIGBUCKS FINANCIAL SERVICES PRIVATE LIMITED",
"BIGBUILDER PRIVATE LIMITED",
"BIGBUNS INDIA PRIVATE LIMITED",
"BIGCAPITA SECURITIES PRIVATE LIMITED",
"BIGCAT WIRELESS PRIVATE LIMITED",
"BIGCITYGREEN RESIDENCY PRIVATE LIMITED",
"BIGCOOL HOME APPLIANCES PRIVATE LIMITED",
"BIGCUES TECHNOLOGIES PRIVATE LIMITED",
"BIGDREAM PHARMA PRIVATE LIMITED",
"BIGFLEX LIFESCIENCE PRIVATE LIMITED",
"BIGFOOT RETAIL SOLUTIONS PRIVATE LIMITED",
"BIGG INVESTMENTS AND FINANCE PRIVATE LIMITED",
"BIGGEX INDUSTRIES PRIVATE LIMITED",
"BIGHAMMER WORKS PRIVATE LIMITED",
"BIGHAT EVENTS & COMMUNICATIONS PRIVATE LIMITED",
"BIGHNAHANTA CONSTRUCTION PRIVATE LIMITED",
"BIGHUB SOLUTIONS PRIVATE LIMITED",
"BIGICO IPM PRIVATE LIMITED",
"BIGINFO LABS INDIA PRIVATE LIMITED",
"BIGITAL TECHNOLOGIES PRIVATE LIMITED",
"BIGJOS INFRAESTATE LIMITED",
"BIGJOS STORES PRIVATE LIMITED",
"BIGKART HOMEWARE PRIVATE LIMITED",
"BIGLEAP TECHNOLOGIES & SOLUTIONS PRIVATE LIMITED",
"BIGMUSCLES NUTRITION PRIVATE LIMITED",
"BIGNEST AGRO PRIVATE LIMITED",
"BIGNOTE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"BIGPHI TECHNOLOGIES PRIVATE LIMITED",
"BIGPITCHER GURUGRAM PRIVATE LIMITED",
"BIGROCK INFRASTRUCTURES PRIVATE LIMITED",
"BIGS SUPPORT SERVICES PRIVATE LIMITED",
"BIGSCAL TECHNOLOGIES PRIVATE LIMITED",
"BIGSHARE SERVICES PRIVATE LIMITED",
"BIGSHARK RESTAURANTS PRIVATE LIMITED",
"BIGSMALL GIFTS PRIVATE LIMITED",
"BIGSPOON FOODS PRIVATE LIMITED",
"BIGSPRING PRIVATE LIMITED",
"BIGSPRING SERVICES PRIVATE LIMITED",
"BIGSTAR FOODS PRIVATE LIMITED",
"BIGSTEP TECHNOLOGIES PRIVATE LIMITED",
"BIGSTONE PROJECTS PRIVATE LIMITED",
"BIGSUN HOSPITALITY PRIVATE LIMITED",
"BIGSWING AUTOMOBILES PRIVATE LIMITED",
"BIGT EXIM INTERNATIONAL PRIVATE LIMITED",
"BIGTEC PRIVATE LIMITED",
"BIGTECH SOFTWARE PRIVATE LIMITED",
"BIGTHINX SOFTWARE PRIVATE LIMITED",
"BIGTIME DISTRIBUTORS INDIA PRIVATE LIMITED",
"BIGTRUCK TECHNOLOGIES PRIVATE LIMITED",
"BIGUARTECH (INDIA) PRIVATE LIMITED",
"BIGV TELECOM PRIVATE LIMITED",
"BIGWAY EXPORTS PRIVATE LIMITED",
"BIGWAY MARKETING PRIVATE LIMITED",
"BIGWIG CARS PRIVATE LIMITED",
"BIGWIG MEDIA AND EVENTS PRIVATE LIMITED",
"BIGWIG REMEDIES PRIVATE LIMITED",
"BIGWIN BUILDSYS COATED PRIVATE LIMITED",
"BIGWINGS TRADING PRIVATE LIMITED",
"BIGWORKS TECHNOLOGIES PRIVATE LIMITED",
"BIGYAN CONSTRUCTION PRIVATE LIMITED",
"BIGZERO TECHNOLOGY LLP",
"BIHANI AGRO FOODS PRIVATE LIMITED",
"BIHANI AGRO INDUSTRIES PRIVATE LIMITED",
"BIHANI CONSTRUCTIONS PRIVATE LIMITED",
"BIHANI CHEMICAL INDUSTRIES PVT LTD",
"BIHANI IMPEX PVT LTD",
"BIHANI INTERNATIONAL PVT LTD",
"BIHANI MANUFACTURING COMPANY PRIVATE LIMITED",
"BIHANI MARKETING PRIVATE LIMITED",
"BIHANI POLYMERS PRIVATE LTD",
"BIHANI WOOLLENS PRIVATE LIMITED",
"BIHAR AGRO CHEM PRIVATE LIMITED",
"BIHAR AIR PRODUCTS LIMITED",
"BIHAR AUTO AGENCIES PRIVATE LIMITED",
"BIHAR BOTTLERS AND BLENDERS PRIVATE. LIMITED.",
"BIHAR BURN & TRAUMA RESEARCH CENTRE PRIVATE LIMITED",
"BIHAR CARBONS PRIVATE LIMITED",
"BIHAR CARRYING COMPANY PVT LTD",
"BIHAR DISTILLERS & BOTTLERS PRIVATE LIMITED",
"BIHAR FOUNDRY & CASTINGS LIMITED",
"BIHAR GASES LIMITED",
"BIHAR GRID COMPANY LIMITED",
"BIHAR HARD COKE MANUFACTURING CO PRIVATE LIMITED",
"BIHAR HOTELS LIMITED",
"BIHAR INFRAPOWER LIMITED",
"BIHAR MA DURGA AGRO INDUSTRIES PRIVATE LIMITED",
"BIHAR MEDICAL SERVICES AND INFRASTRUCTURE CORPORATION LIMITED",
"BIHAR MEGA POWER LIMITED",
"BIHAR MILK PRODUCTS PRIVATE LIMITED",
"BIHAR RISK MANAGEMENT CONSULTANCY PRIVATE LIMITED",
"BIHAR SCHOOL EXAMINATION BOARD, PATNA",
"BIHAR SPONGE IRON LIMITED",
"BIHAR STATE BEVERAGES CORPORATION LIMITED",
"BIHAR STATE DISASTER MANAGEMENT AUTHORITY PATNA",
"BIHAR STATE EDUCATION FINANCE CORPORATION LIMITED",
"BIHAR STATE MILK CO-OPERATIVE FEDERATION LTD",
"BIHAR STATE POWER (HOLDING) COMPANY LIMITED",
"BIHAR STATE ROAD DEVELOPMENT CORPORATION LIMITED",
"BIHARI AASHRAM BALIKA HIGH SCHOOL",
"BIHARI JI CONTAINERS PRIVATE LIMITED",
"BIHARI JI PRESSURE VESSELS PRIVATE LIMITED",
"BIHARI LAL CHOUDHARY IMPEX PRIVATE LIMITED",
"BIHARI LAL CHOUDHARY TRADELINK PRIVATE LIMITED",
"BIHARI SOYA FOODS PROCESSING PRIVATE LIMITED",
"BIHARIJEE RICE MILLS PRIVATE LIMITED",
"BIHARIJI AGRO FOODS PRIVATE LIMITED",
"BIHARIJI CONSTRUCTIONS (INDIA) LIMITED",
"BIHARIJI DEVELOPERS PRIVATE LIMITED",
"BIHARIJI ISPAT UDYOG LIMITED",
"BIHARIJI SHARE TRADING PRIVATE LIMITED",
"BIHARIJI VANIJYA PRIVATE LIMITED",
"BIIPBYTE TECHNOLOGIES PRIVATE LIMITED",
"BIJ EXPORT PRIVATE LIMITED",
"BIJA AGRIFRESH PRIVATE LIMITED",
"BIJAK AGRO FARMER PRODUCER COMPANY LIMITED",
"BIJAN ADS AND FILMS PRIVATE LIMITED",
"BIJANA HEALTHCARE PRIVATE LIMITED",
"BIJAPUR HUNGUND TOLLWAY PRIVATE LIMITED",
"BIJAPUR RENEWABLE ENERGY INDIA PRIVATE LIMITED",
"BIJAPUR-HUNGUND TOLLWAY PRIVATE LIMITED",
"BIJASANI GINNING AND PRESSING FACTORY",
"BIJAY ENTERPRISES PRIVATE LIMITED",
"BIJAY PAPER TRADERS LIMITED",
"BIJAY PRASAD CONSTRUCTION PRIVATE LIMITED",
"BIJAY ROLLER FLOUR MILLS PRIVATE LIMITED",
"BIJAY SHREE AND SAPNA CONSTRUCTION PRIVATE LIMITED",
"BIJAY TRACTOR SPARES PRIVATE LIMITED",
"BIJAYA LAXMI PADDY & AGRO PRIVATE LIMITED",
"BIJCO HOLDINGS LTD.",
"BIJERAM DEDRAJ OIL MILLS PVT. LTD.",
"BIJIB SOFT PRIVATE LIMITED",
"BIJJARGI AUTOMOTIVES LLP",
"BIJJARGI MOTORS",
"BIJLEE CONSTRUCTIONS PRIVATE LIMITED",
"BIJLEE LED LIGHTING PRIVATE LIMITED",
"BIJLI FOUNDRY PRIVATE LIMITED",
"BIJLI LOGISTICS PRIVATE LIMITED",
"BIJLI REALTY PRIVATE LIMITED",
"BIJNI DOOARS TEA CO LTD",
"BIJNOR ENGINEERING PRIVATE LIMITED",
"BIJOLI GRILL CATERERS",
"BIJON TRADING PVT LTD",
"BIJOUX ARGENT PRIVATE LIMITED",
"BIJOY BUILDCONS PRIVATE LIMITED",
"BIJOY KRISHNA MODERN RICE MILL PRIVATE LIMITED",
"BIJOYGARH JYOTISH ROY COLLEGE",
"BIJOYNAGAR BALIKA VIDYALAYA",
"BIJOYSHREE POLYTEX PRIVATE LIMITED",
"BIJSON INNOVATIONS PRIVATE LIMITED",
"BIJU JEWELLERS PRIVATE LIMITED",
"BIJUR DELIMON INDIA PRIVATE LIMITED",
"BIKAJI FOODS INTERNATIONAL LIMITED",
"BIKAJI HOTELS PVT LTD",
"BIKALPA TRADERS PRIVATE LIMITED",
"BIKANA GARDEN PRIVATE LIMITED",
"BIKANA POWER POLES PRIVATE LIMITED",
"BIKANER AGRICO",
"BIKANER BIKES PRIVATE LIMITED",
"BIKANER CERA PRIVATE LIMITED",
"BIKANER CERAMICS PRIVATE LIMITED",
"BIKANER DISTRIBUTORS PRIVATE LIMITED",
"BIKANER ELECTRICITY SUPPLY LIMITED",
"BIKANER ELECTROPORCELAIN PRIVATE LIMITED",
"BIKANER EXPRESS FOODS PRIVATE LIMITED",
"BIKANER HOUSE LIMITED",
"BIKANER MEGA FOOD PARK PRIVATE LIMITED",
"BIKANER MOTORS PRIVATE LIMITED",
"BIKANER POLYMERS PRIVATE LIMITED",
"BIKANER VALVES PRIVATE LIMITED",
"BIKANER-KHETRI TRANSMISSION LIMITED",
"BIKANERVALA FOODS PRIVATE LIMITED",
"BIKASH ENTERPRISES",
"BIKASHI FERRO METALS TRADING PRIVATE LIMITED",
"BIKAY LIQUERS PRIVATE LIMITED",
"BIKEAFFAIR CYCLING INDIA PRIVATE LIMITED",
"BIKEARK MOBILITY SOLUTIONS PRIVATE LIMITED",
"BIKESTER GLOBAL PRIVATE LIMITED",
"BIKEWO GREEN TECH LIMITED",
"BIKEWO GREEN TECH PRIVATE LIMITED",
"BIKHAM INFORMATION TECHNOLOGY PRIVATE LIMITED",
"BIKHAM PRIVATE LIMITED",
"BI-KI DYES AND CHEMICALS PRIVATE LIMITED",
"BIKING FOOD PRODUCTS PRIVATE LIMITED",
"BIKING FOODS (INDIA) PRIVATE LIMITED",
"BIKMAN CONSULTING PRIVATE LIMITED",
"BIKRAM ADITYA DISTRIBUTORS PRIVATE LIMITED",
"BIKRAM FOREX AND TRAVELS PRIVATE LIMITED",
"BIKRAMPUR TANNERY PVT LTD",
"BIKUTA IT SOLUTION PRIVATE LIMITED",
"BIL METAL INDUSTRIES LIMITED",
"BIL- RYERSON TECHNOLOGY STARTUP INCUBATOR FOUNDATION",
"BILAGI SUGAR MILL LIMITED",
"BILAGOS SOFTWARES PRIVATE LIMITED",
"BILAKHIA HOLDINGS PRIVATE LIMITED",
"BILAL ENTERPRISES PRIVATE LIMITED",
"BILANCIA CONSULTING PRIVATE LIMITED",
"BILANDER LOGISTICS PRIVATE LIMITED",
"BILAS BRICKS AND IRON PRIVATE LIMITED",
"BILASA MEDICALS PRIVATE LIMITED",
"BILASHPUR MINING (INDIA) PRIVATE LIMITED",
"BILASPUR CERAMICS PRIVATE LIMITED",
"BILASPUR MINING INDUSTRIES PRIVATE LIMITED",
"BILASPUR PATHRAPALI ROAD PRIVATE LIMITED",
"BILASRAIKA SPONGE IRON INDIA PRIVATE LIMITED",
"BILATIBARITEA COMPANY PVT LTD.",
"BILAV SOFTWARE PRIVATE LIMITED",
"BILAWAL EXPORTS PRIVATE LIMITED",
"BILBERRY PHARMACEUTICALS PRIVATE LIMITED",
"BILCARE LIMITED",
"BILDAL ELECTRICALS PRIVATE LIMITED",
"BILDON STEELS (INDIA) PRIVATE LIMITED",
"BILDON TRADING INDIA PRIVATE LIMITED",
"BILESHWAR PHARMACEUTICALS PRIVATE LIMITED",
"BILGUNDI AUTOMOTIVES PRIVATE LIMITED",
"BILGUNDI MOTORS PRIVATE LIMITED",
"BILIGIRI GRANITES PRIVATE LIMITED",
"BILIMORIA MEHTA AND CO",
"BILKISH ASSOCIATES PRIVATE LIMITED",
"BILL & MELINDA GATES FOUNDATION",
"BILL FORGE PRIVATE LIMITED",
"BILL PLY AND PLY BOARDS PRIVATE LIMITED",
"BILL ROCK INDIA SERVICES PRIVATE LIMITED",
"BILLA ZAVERI PRIVATE LIMITED",
"BILLABONG HIGH INTERNATIONAL SCHOOL",
"BILLEDRIGHT HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"BILLENNIUM INDIA PRIVATE LIMITED",
"BILLERUDKORNAS PACKAGING INDIA PRIVATE LIMITED",
"BILLETS ELEKTRO WERKE LIMITED",
"BILLIMORIA MARBLES AND STONES PRIVATE LIMITED",
"BILLION BROTHERS NOURISHMENT PRIVATE LIMITED",
"BILLION ENGINEERS PRIVATE LIMITED",
"BILLION HONOUR ACCOUNTING SERVICES PRIVATE LIMITED",
"BILLION ONE APPLIANCE PRIVATE LIMITED",
"BILLION POLYCRAFT PRIVATE LIMITED",
"BILLION PROPERTIES PRIVATE LIMITED",
"BILLIONAGRO MARINE EXPORTS PRIVATE LIMITED",
"BILLIONAIRE BROTHERS PRIVATE LIMITED",
"BILLIONBROTHERS FROZEN FOODS PRIVATE LIMITED",
"BILLIONLIVES BUSINESS INITIATIVES PRIVATE LIMITED",
"BILLIONLOANS FINANCIAL SERVICES PRIVATE LIMITED",
"BILLIONSMILES HOSPITALITY PRIVATE LIMITED",
"BILLIONTAGS CREATIONS PRIVATE LIMITED",
"BILLIYO PRIVATE LIMITED",
"BILLOOMI FASHION PRIVATE LIMITED",
"BILLROTH HOSPITALS LIMITED",
"BILLS BEVERAGES PRIVATE LIMITED",
"BILLS ENTERPRISES PRIVATE LIMITED",
"BILLSON STAINLESS PRIVATE LIMITED",
"BILLTECH ELECTRICALS PRIVATE LIMITED",
"BILLWIN INDUSTRIES LIMITED",
"BILOREE CAST INDIA PRIVATE LIMITED",
"BILT GRAPHIC PAPER PRODUCTS LIMITED",
"BILTECH BUILDING ELEMENTS LIMITED",
"BILTECH ENGINEERS PRIVATE LIMITED",
"BILTRAX CONSTRUCTION DATA RESEARCH INSIGHT & TECHNOLOGIES PRIVATE LIMITED",
"BILTTO OVERSEAS PRIVATE LIMITED",
"BILTUBE INDUSTRIES LIMITED",
"BILVA MOULDS PRIVATE LIMITED",
"BILVA TECHNOLOGIES PRIVATE LIMITED",
"BILVANTIS TECHNOLOGIES LLP",
"BILZ INVESTMENTS LIMITED",
"BILZ TOOL PRIVATE LIMITED",
"BIM & GRAFX INTEGRATED STUDIO PRIVATE LIMITED",
"BIM GLOBAL SOLUTIONS PRIVATE LIMITED",
"BIM INTEGRATED SERVICES PRIVATE LIMITED",
"BIMA DEVELOPERS PRIVATE LIMITED",
"BIMAL AGENCIES PRIVATE LIMITED",
"BIMAL AUTO AGENCY",
"BIMAL CERAMICS PRIVATE LIMITED",
"BIMAL HEALTH SERVICES PRIVATE LIMITED",
"BIMAL HOSPITAL PRIVATE LIMITED",
"BIMAL INFRA CONSTRUCTIONS PRIVATE LIMITED",
"BIMAL KUMAR BIJAY KUMAR PRIVATE LIMITED",
"BIMAL MOTORS PRIVATE LIMITED",
"BIMAL PAPERS PRIVATE LIMITED",
"BIMAL PHARMA PRIVATE LIMITED",
"BIMAL REFRACTORIES PRIVATE LIMITED",
"BIMAL TECHNICAL SERVICES PRIVATE LIMITED",
"BIMAL WATER SOLUTIONS PRIVATE LIMITED",
"BIMALA PROJECTS PVT LTD",
"BIMALA SPICES FOOD INDUSTRIES PRIVATE LIMITED",
"BIMARIAN INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"BIMATIX PRIVATE LIMITED",
"BIMCO AUTO PRIVATE LIMITED",
"BIMETAL BEARINGS LIMITED",
"BIMIX MACHINES PRIVATE LIMITED",
"BIMLA IMPEX PVT LTD",
"BIMLRAJ OUTSOURCING PRIVATE LIMITED",
"BIMPEX MACHINES PVT LTD",
"BIMR HOSPITALS",
"BIMSTREAM INDIA PRIVATE LIMITED",
"BIMSYM TECH SUPPORT PRIVATE LIMITED",
"BIN SARI SPECIALIZED TECHNOLOGIES CORROSION PROTECTION INDIA PRIVATE LIMITED",
"BINA AUTOMOBILES PRIVATE LIMITED",
"BINA CEMENT & MARKETING PRIVATE LIMITED",
"BINA COMMERCIAL PVT LTD",
"BINA KRISHAK PRODUCER COMPANY LIMITED",
"BINA METAL WAY PVT LTD",
"BINA TRADES PVT LTD",
"BINA TUBE PRIVATE LIMITED",
"BINA UDYOG PRIVATE LIMITED",
"BINAGURI TEA CO PVT LTD",
"BINAL JEWELS PRIVATE LIMITED",
"BINANI INDUSTRIES LIMITED",
"BINANI METALS LIMITED",
"BINAPANI SALES PRIVATE LIMITED",
"BINAPANI TIE-UP PRIVATE LIMITED",
"BINARANGG TRAVELS PRIVATE LIMITED",
"BINARY APPAREL PARK PRIVATE LIMITED",
"BINARY ELECTROTECH PRIVATE LIMITED",
"BINARY FOUNTAIN SOLUTIONS INDIA PRIVATE LIMITED",
"BINARY GLOBAL LIMITED",
"BINARY INFOSOLUTIONS PRIVATE LIMITED",
"BINARY INFOTECH PRIVATE LIMITED",
"BINARY LIFESTYLE PRIVATE LIMITED",
"BINARY SEMANTICS LIMITED",
"BINARY SOLUTIONS PRIVATE LIMITED",
"BINARY SYSTEMS PRIVATE LIMITED",
"BINARY TECHSYSTEMS GLOBAL BUSINESS SERVICES PRIVATE LIMITED",
"BINARY WEB SOLUTIONS (INDIA) PRIVATE LIMITED.",
"BINARYFLAKES SOFTWARE PRIVATE LIMITED",
"BINARYLIFE TECHNOLOGY PRIVATE LIMITED",
"BINARYVEDA SOFTWARE SOLUTIONS PRIVATE LIMITED",
"BINATE IT SERVICES PRIVATE LIMITED",
"BINATE SOLUTIONS PRIVATE LIMITED",
"BINATEDIN PRIVATE LIMITED",
"BINATONE TELECOMMUNICATION PRIVATE LIMITED",
"BINAY UDYOG PVT LTD",
"BINAYA INFRATECH PRIVATE LIMITED",
"BINAYAK ALUMINIUM PRIVATE LIMITED",
"BINAYAK CONDEV PRIVATE LIMITED",
"BINAYAK CONSTRUCTION AND ENGINEERS PRIVATE LIMITED",
"BINAYAK FINLAMENTS PRIVATE LIMITED",
"BINAYAK HI-TECH ENGINEERING LIMITED",
"BINAYAK IMAGING & DIAGNOSTIC PRIVATE LIMITED",
"BINAYAK TEX PROCESSORS LTD",
"BINBAG RECYCLING SERVICES PRIVATE LIMITED",
"BINBOW AUTO (INDIA) PRIVATE LIMITED",
"BINCA",
"BINCO CONSTRUCTIONS PRIVATE. LIMITED.",
"BINDA METALS PVT. LTD.",
"BINDA PLYWOOD PRIVATE LIMITED",
"BINDAAS FOODS PRIVATE LIMITED",
"BINDAL AGENCIES PRIVATE LIMITED",
"BINDAL APPARELS PRIVATE LIMITED",
"BINDAL ARCADE PRIVATE LIMITED",
"BINDAL BELTING PRIVATE LIMITED",
"BINDAL COLLECTION PRIVATE LIMITED",
"BINDAL COTEX PRIVATE LIMITED",
"BINDAL ENTERPRISES PRIVATE LIMITED",
"BINDAL EXIM PRIVATE LIMITED",
"BINDAL EXPORTS LIMITED",
"BINDAL HOSPITALS PRIVATE LIMITED",
"BINDAL LIFE STYLE PRIVATE LIMITED",
"BINDAL LOGISTICS PRIVATE LIMITED",
"BINDAL MANUFACTURING CO. PRIVATE LIMITED",
"BINDAL POWERTECH PRIVATE LIMITED",
"BINDAL SMELTING PRIVATE LIMITED",
"BINDAL STAINLESS PRIVATE LIMITED",
"BINDAL TARAI SEEDS PRIVATE LIMITED",
"BINDAL TECHNOPOLYMER PRIVATE LIMITED",
"BINDAL TELECOM PRIVATE LIMITED",
"BINDAL TRANSOLUTIONS PRIVATE LIMITED",
"BINDAL TRANSYSTEMS PRIVATE LIMITED",
"BINDALS PAPERS MILLS LIMITED",
"BINDAN PACKS PRIVATE LIMITED",
"BINDASS APPARELS PRIVATE LIMITED",
"BINDAWALA CABLES & CONDUCTORS LIMITED",
"BINDAYAK HOSPITAL",
"BINDESHWAR YADAV CONSTRUCTION PRIVATE LIMITED",
"BINDEX STATIONERY PRIVATE LIMITED",
"BINDHESWARI FLOUR PRODUCT PRIVATE LIMITED",
"BINDKI PLASTOFAB PRIVATE LIMITED",
"BINDLAS DUPLUX LIMITED",
"BINDLAS INTERNATIONAL LIMITED",
"BINDLYSH BIOTEC LIMITED",
"BINDOOKHADAK SOLAR PROJECTS PRIVATE LIMITED",
"BINDRA ASSOCIATES PRIVATE LIMITED",
"BINDRA BAN RAM DARSHAN PRIVATE LIMITED",
"BINDRA DEVELOPERS PRIVATE LIMITED",
"BINDRA ENGINEERING WORKS PRIVATE LIMITED",
"BINDRA TOURS N TRAVELS PRIVATE LIMITED",
"BINDROO SOFTWARE AND CONSULTANTS PRIVATE LIMITED",
"BINDU DIAGNOSTICS PRIVATE LIMITED",
"BINDU ENTERPRISES PRIVATE LIMITED",
"BINDU FASHION PRIVATE LIMITED",
"BINDU FOOD PROCESSORS PRIVATE LIMITED",
"BINDU MEDIA PRIVATE LIMITED",
"BINDU RECEPIES PRIVATE LIMITED",
"BINDU TECH FLOW SOLUTIONS PRIVATE LIMITED",
"BINDU VAYU URJA PRIVATE LIMITED",
"BINDUMADHAV PHARMA PRIVATE LIMITED",
"BINDUMAIZE MILLING EXPORT PRIVATE LIMITED",
"BINDWEL TECHNOLOGIES PRIVATE LIMITED",
"BINDYA CARGO PRIVATE LIMITED",
"BINDYAVASINI TRADERS PVT LTD",
"BINESH REALTORS AND HOTELIERS PRIVATE LIMITED",
"BINET TECHNOLOGIES PRIVATE LIMITED",
"BINGE BREWERIES PRIVATE LIMITED",
"BINI CHEMICALS AND PHARMACEUTICALS INTERNATIONAL PRIVATE LIMITED",
"BINI LABORATORIES PRIVATE LIMITED",
"BINIT INFRATECH PRIVATE LIMITED",
"BINITA MERCHANTILES PRIVATE LIMITED",
"BINIX ELECTROSYSTEMS PRIVATE LIMITED",
"BINJHABAHAL TO TELEBANI SECTION (KM.414.00 TO KM.491.71) OF NH-6 (NEW NH-49) HIGHWAY PRIVATE LIMITED",
"BINJRAJKA VALUE STEELS PRIVATE LIMITED",
"BINJUSARIA ISPAT PRIVATE LIMITED",
"BINJUSARIA METAL BOX COMPANY PRIVATE LIMITED",
"BINJUSARIA PAPERS PRIVATE LIMITED",
"BINJUSARIA SOLVENTS PRIVATE LIMITED",
"BINJUSARIA SPONGE AND POWER PRIVATE LIMITED",
"BINK HOTELS AND RESORTS PRIVATE LIMITED",
"BINNY AUTOMOBILES PRIVATE LIMITED",
"BINNY WADS PRIVATE LIMITED",
"BINNYS JEWELLERY PRIVATE LIMITED",
"BINOD AUTO PRIVATE LIMITED",
"BINOD CAR WORLD PRIVATE LIMITED",
"BINODINI RICE MILL PRIVATE LIMITED",
"BINODINI TRANSPORT PRIVATE LIMITED",
"BINOLA PHARMA LLP",
"BINORI CARE TAKING PRIVATE LIMITED",
"BINORI HOTELS PRIVATE LIMITED",
"BINOY BIZ PRIVATE LIMITED",
"BINSAR FARMS PRIVATE LIMITED",
"BINTIX WASTE RESEARCH PRIVATE LIMITED",
"BIO ACTION OF VEDA RESEARCH PRIVATE LIMITED",
"BIO ANALYTICAL TECHNOLOGIES INDIA PRIVATE LIMITED",
"BIO BODYFUELZ LIMITED",
"BIO CARE INDIA PRIVATE LIMITED",
"BIO CLEAN TURNKEY SOLUTIONS PRIVATE LIMITED",
"BIO DIGITAL PRIVATE LIMITED",
"BIO FACT RESEARCH PRIVATE LIMITED",
"BIO FORCE AGRI INDUSTRIES PRIVATE LIMITED",
"BIO GEN EXTRACTS PRIVATE LIMITED",
"BIO INDIA INTERVENTIONAL TECHNOLOGIES PRIVATE LIMITED",
"BIO LEAFAGE WELLNESS PRIVATE LIMITED",
"BIO LOGIC AND PSYCHOTROPICS INDIA PRIVATE LIMITED",
"BIO MED INGREDIENTS PRIVATE LIMITED",
"BIO MEDICA LABORATORIES PRIVATE LIMITED",
"BIO MEDICAL SYSTEMS PRIVATE LIMITED",
"BIO MINING INDIA PRIVATE LIMITED",
"BIO NOVA PHARMACEUTICALS PVT LTD",
"BIO NUCLEUS PHARMACEUTICALS PRIVATE LIMITED",
"BIO ORGANIC LIFE SCIENCES PRIVATE LIMITED",
"BIO PETRO CLEAN INDIA PRIVATE LIMITED",
"BIO PHARMA COCHIN PRIVATE LIMITED",
"BIO RESOURCE BIOTECH PRIVATE LIMITED",
"BIO RESUREGE LIFE COACHING HEALTH SERVICES PRIVATE LIMITED",
"BIO TECH ENVIROCARE SYSTEMS PRIVATE LIMITED",
"BIO VEDA FARMACY PRIVATE LIMITED",
"BIO WARRIORS PHARMACEUCTICALS PRIVATE LIMITED",
"BIOAIDE TECHNOLOGIES PRIVATE LIMITED",
"BIOALTUS LABORATORIES PRIVATE LIMITED",
"BIOALTUS PHARMACEUTICALS PRIVATE LIMITED",
"BIOANTHEM DEVICES PRIVATE LIMITED",
"BIOASPIRE PROCESS SOLUTIONS PRIVATE LIMITED",
"BIOAZURE TECHNOLOGIES PRIVATE LIMITED",
"BIOBLISS SOLUTIONS PRIVATE LIMITED",
"BIOBRIDGE HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"BIO-CAPS INDIA LIMITED",
"BIOCARE MEDITECH PRIVATE LIMITED",
"BIOCARE ORGANICS PRIVATE LIMITED",
"BIOCERT INTERNATIONAL PRIVATE LIMITED",
"BIOCEUTICS PHARMACEUTICALS PRIVATE LIMITED",
"BIOCHEM ORGANICS (INDIA) PRIVATE LIMITED",
"BIOCHEMICAL & SYNTHEMETIC PRODUCTS P LIMITED",
"BIOCHEMIX HEALTHCARE PRIVATE LIMITED",
"BIOCIPHER TECHNOLOGIES PRIVATE LIMITED",
"BIOCLEAN SYSTEMS INDIA PRIVATE LIMITED",
"BIOCLIQ TECHNOLOGIES PRIVATE LIMITED",
"BIOCOCTION MANUFACTURING PRIVATE LIMITED",
"BIOCOLL PHARMACEUTICALS PRIVATE LIMITED",
"BIOCON ACADEMY",
"BIOCON BIOLOGICS LIMITED",
"BIOCON CONSULTANCY PRIVATE LIMITED",
"BIOCON ELECTRIC PRIVATE LIMITED",
"BIOCON LIMITED",
"BIOCON ORGANICS PRIVATE LIMITED",
"BIOCON PHARMA LIMITED",
"BIOCON RESEARCH LIMITED",
"BIOCON SWITCHGEAR PRIVATE LIMITED",
"BIOCRAFT SCIENTIFIC SYSTEMS PRIVATE LIMITED",
"BIOCRUX INDIA PRIVATE LIMITED",
"BIOCUBE MATRICS PRIVATE LIMITED",
"BIOCURA LIFE SCIENCES PRIVATE LIMITED",
"BIOCYLL LABORATORIES PRIVATE LIMITED",
"BIOD ENERGY (INDIA) PRIVATE LIMITED",
"BIODEAL PHARMACEUTICALS LIMITED",
"BIODEAL PHARMACEUTICALS PRIVATE LIMITED",
"BIODESIGN INNOVATION LABS PRIVATE LIMITED",
"BIODEV SERVICES PRIVATE LIMITED",
"BIODX HEALTHCARE PRIVATE LIMITED",
"BIODYNAMICS PRODUCTS PRIVATE LIMITED",
"BIODYNE SEEDS PRIVATE LIMITED",
"BIOENABLE TECHNOLOGIES PRIVATE LIMITED",
"BIOFAC INPUTS PRIVATE LIMITED",
"BIOFI MEDICAL HEALTHCARE INDIA PRIVATE LIMITED",
"BIOFICS PRIVATE LIMITED",
"BIOFIELD PHARMA PRIVATE LIMITED",
"BIOFIL CHEMICALS AND PHARMACEUTICALS LIMITED",
"BIOFOOTPRINTS HEALTHCARE PRIVATE LIMITED",
"BIOFOURMIS INDIA PRIVATE LIMITED",
"BIOFUELCIRCLE PRIVATE LIMITED",
"BIOFUELS JUNCTION PRIVATE LIMITED",
"BIOFUSION THERAPEUTICS LIMITED",
"BIOGAIN FEEDS PRIVATE LIMITED",
"BIOGAS ENGINEERING INDIA PRIVATE LIMITED",
"BIOGEN FERTILIZERS INDIA PRIVATE LIMITED",
"BIOGEN IDEC BIOTECH INDIA PRIVATE LIMITED",
"BIOGEN IDEC INC.",
"BIOGEN NUTRICEUTICALS",
"BIOGEN PHARMACHEM INDUSTRIES LIMITED",
"BIOGENE LABS INDIA PRIVATE LIMITED",
"BIOGENERO LABS PRIVATE LIMITED",
"BIOGENESIS HEALTHCARE PRIVATE LIMITED",
"BIOGENETIC DRUGS PRIVATE. LIMITED.",
"BIOGENEX LIFE SCIENCES PRIVATE LIMITED.",
"BIOGENICS LABS PRIVATE LIMITED",
"BIOGENIX INC PRIVATE LIMITED",
"BIOGENUIX MEDSYSTEMS PRIVATE LIMITED",
"BIOGENY DIAGNOSTICS PRIVATE LIMITED",
"BIOGLAZE BIOTECH PRIVATE LIMITED",
"BIOGREEN BIOTECH PRIVATE LIMITED",
"BIOGREEN TECHNOCHEM PRIVATE LIMITED",
"BIOGREEN TECHNOLOGY PRIVATE LIMITED",
"BIOGREENIC POLYMERS PRIVATE LIMITED",
"BIOGRID HEALTHCARE PRIVATE LIMITED",
"BIOGROW SUBSTRATES INDIA PRIVATE LIMITED",
"BIOHALL LIFE SCIENCES PRIVATE LIMITED",
"BIOHEAVEN 360 GENOTEC PRIVATE LIMITED",
"BIO-HERBAL REMEDIES PRIVATE LIMITED",
"BIOHOUSE SOLUTIONS PRIVATE LIMITED",
"BIOHUB LIFESCIENCES PRIVATE LIMITED",
"BIO-INDIA PHARMA PRIVATE LIMITED",
"BIOINFO SYSTEMS PRIVATE LIMITED",
"BIOINGREDIA NATURAL PRIVATE LIMITED",
"BIOINNOVAT RESEARCH SERVICES PRIVATE LIMITED",
"BIOKART INDIA PRIVATE LIMITED",
"BIOKIND HEALTHCARE PRIVATE LIMITED",
"BIOKINDLE LIFESCIENCES PRIVATE LIMITED",
"BIOKLONE BIOTECH PRIVATE LIMITED",
"BIOLAB DIAGNOSTICS INDIA PRIVATE LIMITED",
"BIOLABS AND SCIENCES PRIVATE LIMITED",
"BIOLASE INDIA PRIVATE LIMITED",
"BIOLIFQURE PHARMACEUTICALS PRIVATE LIMITED",
"BIOLINE DENTAL PRIVATE LIMITED",
"BIOLINX LABSYSTEMS PRIVATE LIMITED",
"BIOLITEC INDIA PRIVATE LIMITED",
"BIOLOGIC SCIENCE INSTRUMENTS PRIVATE LIMITED",
"BIOLOGICAL E. LIMITED",
"BIOM MEDICAL TECHNOLOGY PRIVATE LIMITED",
"BIOMAACX NUTRI SCIENCES INDIA PRIVATE LIMITED",
"BIOMADE LIFE CARE PRIVATE LIMITED",
"BIOMARILYN PHARMACEUTICALS PRIVATE LIMITED",
"BIOMASS RESEARCH AND TECHNICAL SOLUTION PRIVATE LIMITED",
"BIOMATRIX HEALTHCARE PRIVATE LIMITED",
"BIOMAX BIOTECHNICS PRIVATE LIMITED",
"BIOME ENVIRONMENTAL SOLUTIONS PRIVATE LIMITED",
"BIOME HEALTHCARE PRIVATE LIMITED",
"BIOME INDUSTRIA PRIVATE LIMITED",
"BIOME LIFE SCIENCES INDIA PRIVATE LIMITED",
"BIOMECH HEALTHCARE PRIVATE LIMITED",
"BIO-MED HEALTH CARE PRODUCTS PRIVATE LIMITED",
"BIOMED HEALTHTECH PRIVATE LIMITED",
"BIO-MED PRIVATE LIMITED",
"BIOMEDICARE LABORATORIES PRIVATE LIMITED",
"BIOMEDICON CARE PRIVATE LIMITED",
"BIOMEDICON SERVICES INDIA PRIVATE LIMITED",
"BIOMEDIX OPTOTECHNIK AND DEVICES PRIVATE LIMITED",
"BIOMERIEUX INDIA PRIVATE LIMITED",
"BIOMET ORTHOPAEDIC INDIA PRIVATE LIMITED",
"BIOMET VISAINDIA PRIVATE LIMITED",
"BIOMEX INSTRUMENTS PRIVATE LIMITED",
"BIOMI LIFE SCIENCES PRIVATE LIMITED",
"BIOMIICRON PHARMA INDIA PRIVATE LIMITED",
"BIOMIRRA BIOGENICS PRIVATE LIMITED",
"BIOMODEX PHARMACEUTICALS PRIVATE LIMITED",
"BIOMORPH LIFESCIENCES PRIVATE LIMITED",
"BIOMYLZ PRIVATE LIMITED",
"BION ANALYTX PRIVATE LIMITED",
"BION ATRIUM MEDICAL CARE PRIVATE LIMITED",
"BION HEALTHCARE PRIVATE LIMITED",
"BION THERAPEUTICS INDIA PRIVATE LIMITED",
"BIONATION IMAGING PRIVATE LIMITED",
"BIONEEDS INDIA PRIVATE LIMITED",
"BIONET INDIA PVT. LTD.",
"BIONEX LIFESCIENCES PRIVATE LIMITED",
"BIONEX PROCESS EQUIPMENT PRIVATE LIMITED",
"BIONEXGEN INNOVATIONS PRIVATE LIMITED",
"BIONIC PROSTHETICS AND ORTHOTICS INDIA PRIVATE LIMITED",
"BIONICS CONSORTIUM PRIVATE LIMITED",
"BIONICS REMEDIES (GUJARAT) LIMITED",
"BIONIVID TECHNOLOGY PRIVATE LIMITED",
"BIONNAR HEALTH CARE PRIVATE LIMITED",
"BIONOVA PAPERCRAFTS PRIVATE LIMITED",
"BIONOVA SOLUTIONS PRIVATE LIMITED",
"BIONS MEDICAL SYSTEMS PRIVATE LIMITED",
"BIONUTRIZ HEALTHCARE PRIVATE LIMITED",
"BIONWORKS TECHNOLOGIES PRIVATE LIMITED",
"BIOORGANICS AND APPLIED MATERIALS PRIVATE LIMITED",
"BIOP STEELS & POWER PRIVATE LIMITED",
"BIOPAPRO CUTLERIES PRIVATE LIMITED",
"BIOPAPRO PRIVATE LIMITED",
"BIOPHAR LIFESCIENCES PRIVATE LIMITED",
"BIOPHARM SOLUTIONS PRIVATE LIMITED",
"BIO-PHARMA LABORATORIES PRIVATE LIMITED",
"BIOPHARMACIEAA PRIVATE LIMITED",
"BIOPHARMAX INDIA PRIVATE LIMITED",
"BIOPHORE INDIA PHARMACEUTICALS PRIVATE LIMITED",
"BIOPLUS HEALTHCARE PRIVATE LIMITED",
"BIOPLUS LIFE SCIENCES PRIVATE LIMITED",
"BIOPODS PRIVATE LIMITED",
"BIOPOLIS LIFESCIENCES PRIVATE LIMITED",
"BIOPRIME AGRISOLUTIONS PRIVATE LIMITED",
"BIOQEM PHARMA",
"BIOQUEST PHARMACEUTICALS PRIVATE LIMITED",
"BIOQUEST SOLUTIONS PRIVATE LIMITED",
"BIO-RAD LABORATORIES (INDIA) PRIVATE LIMITED",
"BIO-RAD LABORATORIES INDIA PRIVATE LIMITED",
"BIORAD MEDISYS PRIVATE LIMITED",
"BIOREX HEALTHCARE PRIVATE LIMITED",
"BIOS CROPCARE PRIVATE LIMITED",
"BIOS LAB PRIVATE LIMITED",
"BIOSAFE LAB INDIA PRIVATE LIMITED",
"BIOSAFE LIFECARE PRIVATE LIMITED",
"BIOSAFE MEDICAL INDIA PRIVATE LIMITED",
"BIOSAFE MEDITECH AND INFORMATICS (I) PRIVATE LIMITED",
"BIOSAFE PHARMACEUTICALS PRIVATE LIMITED",
"BIOSASH BUSINESS PRIVATE LIMITED",
"BIOSCIENCES MEDICAL DEVICES INDIA PRIVATE LIMITED",
"BIO-SCIENTIFIC RESEARCH LABORATORIES INDIA PRIVATE LIMITED",
"BIOSCREEN INSTRUMENTS PRIVATE LIMITED",
"BIOSEED RESEARCH INDI",
"BIOSENSE TECHNOLOGIES PRIVATE LIMITED",
"BIOSENSORS MEDICAL INDIA PRIVATE LIMITED",
"BIOSERVE",
"BIOSHIELD LIFESCIENCES PRIVATE LIMITED.",
"BIOSIS HEALTHCARE PRIVATE LIMITED",
"BIOSIS PLANTS PRIVATE LIMITED",
"BIOSITE RESEARCH PRIVATE LIMITED",
"BIOSKY INDUSTRIES LIMITED",
"BIOSOFT LIFESCIENCES PRIVATE LIMITED",
"BIO-SOLS INDIA PRIVATE LIMITED",
"BIOSOURCING.COM PRIVATE LIMITED",
"BIOSPARK REMEDIES PRIVATE LIMITED",
"BIOSPECIMEN SOLUTIONS PRIVATE LIMITED",
"BIOSPHERE CLINICAL RESEARCH PRIVATE LIMITED",
"BIOSPHERE LIFE SCIENCES PRIVATE LIMITED",
"BIOSPORT PRIVATE LIMITED",
"BIOSQUARE BIOTECHNOLOGIES INDIA PRIVATE LIMITED",
"BIOSTADT INDIA LIMITED",
"BIOSTRAP WEARABLE TECHNOLOGY INDIA PRIVATE LIMITED",
"BIOSTRUM NUTRITECH PRIVATE LIMITED",
"BIOSURGE HEALTHCARE INDIA PRIVATE LIMITED",
"BIOSYN RESEARCH CHEMICALS PRIVATE LIMITED",
"BIOSYNC PHARMACEUTICALS PRIVATE LIMITED",
"BIOSYNERGY LIFECARE PRIVATE LIMITED",
"BIOSYS HEALTH CARE",
"BIOSYSTEMS DIAGNOSTICS PRIVATE LIMITED",
"BIOTA AGRO SOLUTIONS PRIVATE LIMITED",
"BIOTA FARM (OPC) PRIVATE LIMITED",
"BIOTAGE INDIA PRIVATE LIMITED",
"BIOTAVIA LABS PRIVATE LIMITED",
"BIOTECH (INDIA) TECHNOLOGIES PRIVATE LIMITED",
"BIOTECH CONSORTIUM INDIA LIMITED",
"BIOTECH DESK PRIVATE LIMITED",
"BIOTECH INDIA LIMITED",
"BIOTECH INTERNATIONAL LIMITED",
"BIOTECH SOLUTIONS & PHARMACEUTICALS LIMITED",
"BIOTECH VISION CARE PRIVATE LIMITED",
"BIOTECHNOLOGY INDUSTRY RESEARCH ASSISTANCE COUNCIL",
"BIOTECNIKA INFO LABS PRIVATE LIMITED",
"BIOTEK SOLUTIONS PRIVATE LIMITED",
"BIOTEKNIKA HEALTHCARE PRIVATE LIMITED",
"BIOTEKNIX PRIVATE LIMITED",
"BIOTIC HEALTHCARE PRIVATE LIMITED",
"BIOTIC SEEDS PRIVATE LIMITED",
"BIOTIC WASTE LIMITED",
"BIOTIC WASTE SOLUTIONS PRIVATE LIMITED",
"BIOTICS LAB LIFE SERVICES PRIVATE LIMITED",
"BIOTIS HEALTH SCIENCES PRIVATE LIMITED",
"BIOTRACK FOOD P LIMITED",
"BIOTRAK RESEARCH AND DIAGNOSTICS CENTRE PRIVATE LIMITED",
"BIOTRENDS INDIA PRIVATE LIMITED",
"BIOTRIC HEALTHCARE PRIVATE LIMITED",
"BIOTROL LABORATORIES PRIVATE LIMITED",
"BIOTRON HEALTHCARE (INDIA) PRIVATE LIMITED",
"BIOTRONICS EQUIPMENTS PRIVATE LIMITED",
"BIOTRONIK MEDICAL DEVICES INDIA PRIVATE LIMITED.",
"BIOTURE LABS PRIVATE LIMITED",
"BIOURJA INDIA INFRA PRIVATE LIMITED",
"BIOVENCER HEALTHCARE PRIVATE LIMITED",
"BIOVET PRIVATE LIMITED",
"BIO-VISION SECURE SOLUTIONS PRIVATE LIMITED",
"BIOVITAMINS PRIVATE LIMITED",
"BIOVIVID LABS PHARMACEUTICALS PRIVATE LIMITED",
"BIOWELL UNIVERSE PRIVATE LIMITED",
"BIOWIN AGRO RESEARCH",
"BIOWIN CHEMICALS PRIVATE LIMITED",
"BIOWIN HEALTHCARE LIMITED",
"BIOWORLD MERCHANDISING I PRIVATE LIMITED",
"BIOXERA PHARMA PRIVATE LIMITED",
"BIOXGREEN TECHNOLOGY PRIVATE LIMITED",
"BIOZEAL HEALTHCARE PRIVATE LIMITED",
"BIOZED ENGINEERING PRIVATE LIMITED",
"BIOZEN HEALTH PRODUCTS PRIVATE LIMITED",
"BIOZENTA LIFESCIENCE PRIVATE LIMITED",
"BIOZONE RESEARCH TECH PRIVATE LIMITED",
"BIP DEVELOPERS PRIVATE LIMITED",
"BIPASHA AVIATION SERVICES PRIVATE LIMITED",
"BIPHA DRUG LABORATORIES PRIVATE LIMITED",
"BIPICO INDUSTRIES TOOLS PRIVATE LIMITED",
"BIPIN ENGINEERS PRIVATE LIMITED",
"BIPIN FACILITIES MANAGEMENT PRIVATE LIMITED",
"BIPIN INDUSTRIES PRIVATE LIMITED",
"BIPIN MAHENDRA SMRITI VIDYAMANDIR",
"BIPIN SYNTHETICS PVT LTD",
"BIPIN TEXTILE PROCESSING INDUSTRIES PRIVATE LIMITED",
"BIPIRAJ FINANCE PVT LTD",
"BIPL PACTECH PRIVATE LIMITED",
"BIPO SERVICE (INDIA) PRIVATE LIMITED",
"BIPS SYSTEM LIMITED",
"BIPSON PRINTS PRIVATE LIMITED",
"BIPSON SURGICAL PRIVATE LIMITED",
"BIPSUM SOFTWARE SOLUTIONS PRIVATE LIMITED",
"BIPUL DETECTIVE AND SECURITY SERVICES PRIVATE LIMITED",
"BIR BILLING CONSTRUCTION PRIVATE LIMITED",
"BIR CREDIT SOLUTION PRIVATE LIMITED",
"BIR ELECTRONICS PRIVATE LIMITED",
"BIR FINANCE PRIVATE LIMITED",
"BIR FOODS & RESTAURANTS PRIVATE LIMITED",
"BIR HOTELS PRIVATE LIMITED",
"BIR LOGISTICS PRIVATE LIMITED",
"BIR STEELS PRIVATE LIMITED",
"BIRAHI GANGA HYDRO POWER LIMITED",
"BIRAJA INFRA SOLUTION PRIVATE LIMITED",
"BIRAMPUR CONSTRUCTION PRIVATE LIMITED",
"BIRANI SYNTHETICS PRIVATE LIMITED",
"BIRATI VINTNER PRIVATE LIMITED",
"BIRBAL INTERNATIONAL PRIVATE LIMITED",
"BIRBHUM CHEMICALS AND FERTILISERS LTD.",
"BIRBHUM COLD STORAGE PRIVATE LIMITED",
"BIRBHUM ENTERPRISE PRIVATE LIMITED",
"BIRBHUM OILS INDUSTRIES PRIVATE LIMITED",
"BIRD AERO SERVICES PRIVATE LIMITED",
"BIRD AIRPORT HOTEL PRIVATE LIMITED",
"BIRD AIRPORT SERVICES (KONKAN) PRIVATE LIMITED",
"BIRD AIRPORT SERVICES (MOHALI) PRIVATE LIMITED",
"BIRD AUTOMOTIVE PRIVATE LIMITED",
"BIRD CATERING AND LOUNGES PRAIVATE LIMITED",
"BIRD EXECUJET AIRPORT SERVICES PRIVATE LIMITED",
"BIRD HOSPITALITY SERVICES PRIVATE LIMITED",
"BIRD INFORMATION SYSTEMS PRIVATE LIMITED",
"BIRD MACHINES LIMITED",
"BIRD MACHINES PRIVATE LIMITED",
"BIRD RETAIL PRIVATE LIMITED",
"BIRD TRAVELS PRIVATE LIMITED",
"BIRD VOYAGE PRIVATE LIMITED",
"BIRD WORLDWIDE FLIGHT SERVICE MUMBAI PRIVATE LIMITED",
"BIRD WORLDWIDE FLIGHT SERVICES INDIA PRIVATE LIMITED",
"BIRDESHWAR CONSTRUCTIONS PRIVATE LIMTIED",
"BIRDEYE SOFTWARE INDIA PRIVATE LIMITED",
"BIRDHI CHAND GIRDHARI LAL PAPERS PRIVATE LIMITED",
"BIRDIE INVESTMENTS MADRAS PRIVATE LIMITED",
"BIRDRES TECHNOLOGIES PRIVATE LIMITED",
"BIRDS EYE SYSTEMS PRIVATE LIMITED",
"BIRDS MEDIA PRIVATE LIMITED",
"BIRDSEYE ASSET SOLUTIONS PRIVATE LIMITED",
"BIRDVIEW GLOBAL LOGISTICS PRIVATE LIMITED",
"BIRDVIEW WAREHOUSING AND DISTRIBUTION PRIVATE LIMITED",
"BIRDVISION CONSULTING PRIVATE LIMITED",
"BIRDY EXPORTS PRIVATE LIMITED",
"BIRENDRASHOK SEAFOODS PRIVATE LIMITED",
"BIRESHWAR COLD STORAGE PRIVATE LIMITED",
"BIRETAIL SOLUTIONS INDIA PRIVATE LIMITED",
"BIRFA METALS AND MINERALS PRIVATE LIMITED",
"BIRIN SPINNING MILLS LIMITED",
"BIRIYANI ZONE RESTAURANTS PRIVATE LIMITED",
"BIRJHORA ROLLER FLOUR MILLS PVT LTD",
"BIRJU MAHAVIR PRIVATE LIMITED",
"BIRKAN ENGINEERING INDUSTRIES PRIVATE LIMITED",
"BIRKENSTOCK INDIA PRIVATE LIMITED",
"BIRKET MULTIRESOURCE PRIVATE LIMITED",
"BIRLA ARYA GIRLS SR SECONDARY",
"BIRLA BROTHERS PVT LTD",
"BIRLA CARBON INDIA PRIVATE LIMITED",
"BIRLA CELLULOSE",
"BIRLA CELLULOSIC",
"BIRLA CENTURY EXPORTS PRIVATE LIMITED",
"BIRLA COPPER ASOJ PRIVATE LIMITED",
"BIRLA CORPORATION LIMITED",
"BIRLA ELECTRICALS LIMITED",
"BIRLA ERICSSON OPTICAL LIMITED",
"BIRLA ESTATES PRIVATE LIMITED",
"BIRLA FINANCIAL DISTRIBUTION LIMITED",
"BIRLA FURUKAWA FIBRE OPTICS PRIVATE LIMITED",
"BIRLA GLOBAL CORPORATE PRIVATE LIMITED",
"BIRLA GLOBAL UNIVERSITY",
"BIRLA GOLD AND PRECIOUS METALS LIMITED",
"BIRLA GROUP HOLDINGS PRIVATE LIMITED",
"BIRLA HEALTHCARE AYURVEDA PRIVATE LIMITED",
"BIRLA HIGH SCHOOL",
"BIRLA INFRAPROJECTS PRIVATE LIMITED",
"BIRLA INSTITUTE OF MANAGEMENT OF TECHNOLOGY",
"BIRLA INSTITUTE OF TECHNOLOGY",
"BIRLA INSTITUTE OF TECHNOLOGY & SCIENCE COMPANY",
"BIRLA INSTITUTE OF TECHNOLOGY AND SCIENCE,PILANI",
"BIRLA INTERNATIONAL SCHOOL",
"BIRLA JINGWEI FIBRES COMPANY LIMITED",
"BIRLA LIFESTYLE PRIVATE LIMITED",
"BIRLA MANAGEMENT CENTRE SERVICES LIMITED",
"BIRLA MANAGEMENT CENTRE SERVICES PRIVATE LIMITED",
"BIRLA OPEN MINDS INTERNATIONAL SCHOOL",
"BIRLA OPEN MINDS PRESCHOOL",
"BIRLA PRECISION TECHNOLOGIES LIMITED",
"BIRLA PUBLIC SCHOOL",
"BIRLA SHIKSHA KENDRA SCHOOL",
"BIRLA SOFTINDIALIMITED",
"BIRLA TMT HOLDINGS PRIVATE LIMITED",
"BIRLA TYRES LIMITED",
"BIRLA VIDYA NIKETAN",
"BIRLA VISABEIRA PRIVATE LIMITED",
"BIRLA VISHVAKARMA MAHAVIDYALAYA",
"BIRLA VISHVAKARMA MAHAVIDYALAYA ENGINEERING COLLEGE",
"BIRLAMEDISOFTT PRIVATE LIMITED",
"BIRLASOFT LIMITED",
"BIRLI SPINNING MILL PRIVATE LIMITED",
"BIRMA INDUSTRIAL & BUSINESS ENTERPRISE PRIVATE LIMITED",
"BIRMECHA INVESTMENTS PVT LTD",
"BIRMI IMPEX PRIVATE LIMITED",
"BIRMI INDUSTRIES PRIVATE LIMITED",
"BIRMI INTERNATIONAL PRIVATE LIMITED",
"BIRMI OVERSEAS PRIVATE LIMITED",
"BIRMI SPINNING MILS PRIVATE LIMITED",
"BIRMINGHAM INDUSTRIES PRIVATE LIMITED",
"BIRNBAUM KHANDELWAL ADVISORY SERVICES PRIVATE LIMITED",
"BIROKE BUILDERS PRIVATE LIMITED",
"BIRRA FRAGRANCES LLP",
"BIRSA AGRICULTURAL UNIVERSITY",
"BIRTHPLACE HEALTHCARE PRIVATE LIMITED",
"BIRTHRIGHT GAMES & ENTERTAINMENT PRIVATE LIMITED",
"BIRUPUR DEVELOPER PRIVATE LIMITED",
"BIS BHOOMI INDIA PRIVATE LIMITED",
"BIS COMPUTER PRIVATE LIMITED",
"BIS MARCK PHARMACEUTICALS PRIVATE LIMITED",
"BIS RESEARCH PRIVATE LIMITED",
"BISALAXMI RICE MILL PVT.LTD.",
"BISAN CHEMICALS AND ENGINEERS PRIVATE LIMITED",
"BISAPA EXIM PRIVATE LIMITED",
"BISAZZA INDIA PRIVATE LIMITED",
"BISCO METAL & POWER PRIVATE LIMITED",
"BISCO STEEL UDYOG PRIVATE LIMITED",
"BISCUIT BASKET FOODS PRIVATE LIMITED",
"BISEN ENGINEERING PRIVATE LIMITED",
"BISENTECH ZONE PRIVATE LIMITED",
"BISHA DEVELOPERS PRIVATE LIMITED",
"BISHAK PHARMA PRIVATE LIMITED",
"BISHALAKSHMI COMMERCIAL PRIVATE LIMITED",
"BISHAMBHAR EXPORTS PRIVATE LIMITED",
"BISHAMBHER SARAN VINOD KUMAR PRIVATE LIMITED",
"BISHAN INFRASTRUCTURE PRIVATE LIMITED",
"BISHAN LACES PVT. LTD.",
"BISHAN RUKMANI MEMORIAL FOUNDATION",
"BISHANDAYAL INDERCHAND JEWELLERS PRIVATE LIMITED",
"BISHESHWAR MARKETING PRIVATE LIMITED",
"BISHNOI AGRO INDIA PRIVATE LIMITED",
"BISHNOI BROTHERS HOTELS AND RESORTS PRIVATE LIMITED",
"BISHNU CLEARING AGENCY PRIVATE LIMITED",
"BISHNU FLOUR MILLS PRIVATE LIMITED",
"BISHNU JYOTI HEALTH INSTITUTE PRIVATE LIMITED",
"BISHNUDEV NARAYAN AGRO PRIVATE LIMITED",
"BISHNUPRIYA COLD STORAGE PRIVATE LIMITED",
"BISHNUPUR HIMGHAR PRIVATE LIMITED",
"BISHNUPUR TEA COMPANY PRIVATE. LIMITED.",
"BISHOP AMBROSE COLLEGE",
"BISHOP APPASWAMY COLLEGE",
"BISHOP CONRAD SENIOR SECONDARY SCHOOL",
"BISHOP COTTON BOYS SCHOOL",
"BISHOP COTTON SCHOOL",
"BISHOP COTTON WOMENS CHRISTAIN COLLEGE",
"BISHOP HEBER COLLEGE TRICHY",
"BISHOP ROCK CONSULTING PRIVATE LIMITED",
"BISHOP SCOTT GIRLS SCHOOL",
"BISHOP WESTCOTT GIRLS SCHOOL",
"BISHOPS SCIENTIFIC PRIVATE LIMITED",
"BISHWA JYOTI HOUSING DEVELOPMENT AND INFRASTRUCTURE LIMITED",
"BISHWANATH FLOUR MILLS PVT LTD",
"BISHWANATH GEMS AND JEWELS PRIVATE LIMITED",
"BISHWANATH INDUSTRIES LIMITED",
"BISHWANATH PROPERTY PRIVATE LIMITED (TRF.)",
"BISHWANATH TRADERS AND INVESTMENT LIMITED",
"BISIL PLAST LIMITED",
"BISINEER ENGINEERING (INDIA) PRIVATE LIMITED",
"BISISTA PHARMA PRIVATE LIMITED",
"BISKITOS FOODS PRIVATE LIMITED",
"BISLANIA AGRO PRODUCTS PRIVATE LIMITED",
"BISLERI INTERNATIONAL PRIVATE LIMITED",
"BISMI CLINICAL LABORATORY & DIGITAL X RAY",
"BISMI CONNECT PRIVATE LIMITED",
"BISMI FEEDS PRIVATE LIMITED",
"BISMI FISHERIES PRIVATE LIMITED",
"BISMI HOME APPLIANCES LLP",
"BISMI HYPERMART LIMITED",
"BISMI PRAWN FARMS PRIVATE LIMITED",
"BISMILLAH JEWELLERS PRIVATE LIMITED",
"BISMILLAH TIMBER PRIVATE LIMITED",
"BISNU CHEM INDIA PRIVATE LIMITED",
"BISON FITNESS ZONE",
"BISOTECH INDIA PRIVATE LIMITED",
"BISOU COSMETICS PRIVATE LIMITED",
"BISP INFONET PRIVATE LIMITED",
"BISTA SOLUTIONS PRIVATE LIMITED",
"BISTRO HOSPITALITY PRIVATE LIMITED",
"BISTRO-Y FOODS PRIVATE LIMITED",
"BISUI POULTRY PRIVATE LIMITED",
"BISUR HIGHSCHOOL BISUR",
"BISWA BANGLA MARKETING CORPORATION LIMITED",
"BISWA HEALTHCARE PRIVATE LIMITED",
"BISWABANGLA AGRO PRIVATE LIMITED",
"BISWABHOOMI AGROFOODS PRIVATE LIMITED",
"BISWAJANANI COLD STORAGE PRIVATE LIMITED",
"BISWAJIT MINERALS PRIVATE LIMITED",
"BISWAKARMA MACHINERY PRIVATE LIMITED",
"BISWAMATA HEEMGHAR PRIVATE LIMITED",
"BISWAMITA INFRA-SIGN PRIVATE LIMITED",
"BISWANATH HOSIERY MILLS LIMITED",
"BISWAPITA COLD STORAGE PRIVATE LIMITED",
"BISWAS FOREX PRIVATE LIMITED",
"BISWAS MEDIA SOLUTIONS PRIVATE LIMITED",
"BISWAS POLYMER PRIVATE LIMITED",
"BISWATRUPTI AUTOPARTS PRIVATE LIMITED",
"BISWEASHWAR BREEDERS PRIVATE LIMITED",
"BISWESWAR FOODS PRIVATE LIMITED",
"BIT AIR TRAVELS PRIVATE LIMITED",
"BIT BY BIT COMPUTER SERVICES PRIVATE LIMITED",
"BIT BYTE INVESTMENT SERVICES PRIVATE LIMITED",
"BIT FACTOR SOFTWARE INDIA PRIVATE LIMITED",
"BIT INFOMEDIA PVT LTD",
"BIT MAPPER INTEGRATION TECHNOLOGIES PRIVATE LIMITED",
"BIT ORDER TECHNOLOGIES PRIVATE LIMITED",
"BIT SOFT SERVICES PRIVATE LIMITED",
"BIT TUL PRIVATE LIMITED",
"BITARA PRIVATE LIMITED",
"BITBUFFS TECHNOLOGIES PRIVATE LIMITED",
"BITC LOAN SERVICES PRIVATE LIMITED",
"BITCHEM ASPHALT TECHNOLOGIES LIMITED",
"BITCOL ELRICH BITUMINOUS SYSTEMS PRIVATE LIMITED",
"BITCOL LOGISTICS PRIVATE LIMITED",
"BITCOL MODIFIED BITUMEN SYSTEMS PRIVATE LIMITED",
"BITCOMM TECHNOLOGIES PRIVATE LIMITED",
"BITCON INDIA INFRASTRUCTURE DEVELOPERS PRIVATE LIMITED",
"BITFEMME FASHIONS PRIVATE LIMITED",
"BITIBE TEHNOLOGIES PRIVATE LIMITED",
"BITKEA TECHNOLOGIES LLP",
"BITKEMY TECHNOLOGIES PRIVATE LIMITED",
"BITLA SOFTWARE PRIVATE LIMITED",
"BITONIC TECHNOLOGY LABS PRIVATE LIMITED",
"BITOODLE ONLINE SERVICES PRIVATE LIMITED",
"BITPAD TECHNOLOGIES PRIVATE LIMITED",
"BITPASTEL SOLUTION PRIVATE LIMITED",
"BITPLUS SOLUTIONS LLP",
"BITQIT PRIVATE LIMITED",
"BITRU MANUFACTURING COMPONENT PRIVATE LIMITED",
"BITS AND BYTE IT CONSULTING PRIVATE LIMITED",
"BITS AND BYTES CORPORATE SUPPORT SERVICES PRIVATE LIMITED",
"BITS AND BYTES INTEGRATORS PRIVATE LIMITED",
"BITS IN GLASS INDIA PRIVATE LIMITED",
"BITS MECHANICALS PRIVATE LIMITED",
"BITS N BYTER SOFT PRIVATE LIMITED",
"BITS PILANI HYDERABAD CAMPUS",
"BITSCAPE INFOTECH PRIVATE LIMITED",
"BITSILICA PRIVATE LIMITED",
"BITSIO PRIVATE LIMITED",
"BITSLASH TECHNOLOGIES PRIVATE LIMITED",
"BITSNPIXS TECHNOLOGIES PRIVATE LIMITED",
"BITSTREAM MEDIAWORKS PRIVATE LIMITED",
"BITSTREET TECHNOLOGIES PRIVATE LIMITED",
"BITSTRING IT SERVICES PRIVATE LIMITED",
"BITSY INFOTECH PRIVATE LIMITED",
"BITTAR ASPHALT PRIVATE LIMITED",
"BITTINIA MOFA EQUIPMENTS PRIVATE LIMITED",
"BITTRACK CONSULTANTS PRIVATE LIMITED",
"BITTU FOREX PRIVATE LIMITED",
"BITTU SYNTHETICS PRIVATE LIMITED",
"BITUFELT PRIVATE LIMITED",
"BITULINK PRIVATE LIMITED",
"BITUMAG INDUSTRIES PRIVATE LIMITED",
"BITUMEN CORPORATION INDIA PRIVATE LIMITED",
"BITUMINEX COCHIN PVT LTD",
"BITUREKS INFRA PRIVATE LIMITED",
"BITUSH & RAJIB CONSTRUCTION PRIVATE LIMITED",
"BITVOICE SOLUTIONS PRIVATE LIMITED",
"BITWISE SOLUTIONS PRIVATE LIMITED",
"BITZER INDIA PRIVATE LIMITED",
"BIUM INDUSTRIES PRIVATE LIMITED",
"BIVA FOOD PRODUCTS PRIVATE LIMITED",
"BIVAB DEVELOPERS PRIVATE LIMITED",
"BIYANI & SONS",
"BIYANI ALLOYS PRIVATE LIMITED",
"BIYANI FINANCIAL SERVICES PRIVATE LIMITED",
"BIYANI FOODS PRIVATE LIMITED",
"BIYANI IMPEX PRIVATE LIMITED",
"BIYANI INDUSTRIAL TEXTILES PVT LTD",
"BIYANI PAPER CONVERTERS PRIVATE LIMITED",
"BIYANI SHIKSHAN SAMITI",
"BIYANI TECHNOLOGIES PRIVATE LIMITED",
"BIYAR RUBBERS PRIVATE LIMITED",
"BIZ 2 CREDIT INFO SERVICES PRIVATE LIMITED",
"BIZ 4 SOLUTIONS PRIVATE LIMITED",
"BIZ AD OPTIMISER PRIVATE LIMITED",
"BIZ CONTAINER SERVICES PRIVATE LIMITED",
"BIZ FLARE SERVICES PRIVATE LIMITED",
"BIZ HERO INDIA PRIVATE LIMITED",
"BIZ SECURE LABS PRIVATE LIMITED",
"BIZ STAFFING COMRADE PRIVATE LIMITED",
"BIZ TECHNOLOGIES PRIVATE LIMITED",
"BIZ4GROUP",
"BIZACUITY SOLUTIONS PRIVATE LIMITED",
"BIZAMICA SOFTWARE PRIVATE LIMITED",
"BIZANALYTICA SOLUTION LLP",
"BIZANALYTIX TECHNOLOGIES PRIVATE LIMITED",
"BIZANT CHEMIE PRIVATE LIMITED",
"BIZBOX PUBLISHING PRIVATE LIMITED",
"BIZCOLLAB360 TECH PRIVATE LIMITED",
"BIZCON INNOVATIONS PRIVATE LIMITED",
"BIZCONINDIA FACILITIES PRIVATE LIMITED",
"BIZCONINDIA TECHNOLOGIES PRIVATE LIMITED",
"BIZDATA TECHNOLOGIES PRIVATE LIMITED",
"BIZERBA INDIA PRIVATE LIMITED",
"BIZFAC INFOTECH INDIA PRIVATE LIMITED",
"BIZFLAIR VENTURES PRIVATE LIMITED",
"BIZFRAME TECHNOLOGIES PRIVATE LIMITED",
"BIZGAZE LIMITED",
"BIZGURUKUL PRIVATE LIMITED",
"BIZHAWKZ IT SOLUTIONS PRIVATE LIMITED",
"BIZIGHT SOLUTIONS PRIVATE LIMITED",
"BIZIPAC COURIERS PRIVATE LIMITED",
"BIZITZA RETAIL VENTURES PRIVATE LIMITED",
"BIZIURIS COLLEGE OF PROFESSIONAL STUDIES",
"BIZKONNECT SOLUTIONS PRIVATE LIMITED",
"BIZLOAN PRIVATE LIMITED",
"BIZLOGIX CONSULTANCY SERVICES PRIVATE LIMITED",
"BIZMATICS INDIA PRIVATE LIMITED",
"BIZ-METRIC INDIA PRIVATE LIMITED",
"BIZMOBILE IT SOLUTIONS PRIVATE LIMITED",
"BIZNESSFORCE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"BIZNOMY SOLUTIONS PRIVATE LIMITED",
"BIZONESOFT GLOBAL SOLUTIONS PRIVATE LIMITED",
"BIZOTIC COMMERCIAL LIMITED",
"BIZOTIC LIFESCIENCE PRIVATE LIMITED",
"BIZOTIC TALENT SOLUTIONS PRIVATE LIMITED",
"BIZOTICS TECH CONSULTANCY & SERVICES PRIVATE LIMITED",
"BIZPOLE BUSINESS SOLUTIONS PRIVATE LIMITED",
"BIZPRINT MEDIA TECHNOLOGIES PRIVATE LIMITED",
"BIZPRO PROPERTIES PRIVATE LIMITED",
"BIZPROUT CORPORATE SOLUTIONS PRIVATE LIMITED",
"BIZRISE TECHNOLOGIES PRIVATE LIMITED",
"BIZSENSE SOLUTIONS PRIVATE LIMITED",
"BIZSOL TECHNOLOGIES PRIVATE LIMITED",
"BIZSOLINDIA IT SERVICES PRIVATE LIMITED",
"BIZSOLINDIA SERVICES PRIVATE LIMITED",
"BIZ-TECH CONSULTANTS PRIVATE LIMITED",
"BIZTECH IT CONSULTANCY PRIVATE LIMITED",
"BIZTECHNOSYS INFOTECH PRIVATE LIMITED",
"BIZTRANSIGHTS SOLUTIONS LLP",
"BIZTRIP HOSPITALITY PRIVATE. LIMITED.",
"BIZTRON SOFTECH PRIVATE LIMITED",
"BIZTRUSS INTEGRATED SERVICES PRIVATE LIMITED",
"BIZUPON INDIA PRIVATE LIMITED",
"BIZVANTAGE TRAINING & CONSULTING COMPANY PRIVATE LIMITED",
"BIZVIZ TECHNOLOGIES PRIVATE LIMITED",
"BIZWAY SOLUTIONS PRIVATE LIMITED",
"BIZWORKS MARKETING PRIVATE LIMITED",
"BIZZ IMPACT INFOTEC PRIVATE LIMITED",
"BIZZ SOLUTIONS PRIVATE LIMITED",
"BIZZHUB VENTURES PRIVATE LIMITED",
"BJ MEDICAL COLLEGE",
"BJ SECURITY & HOUSEKEEPING SERVICES PRIVATE LIMITED",
"BJ SERVICES CO MIDDLE EAST LIMITED",
"BJAIN PHARMACEUTICALS PRIVATE LIMITED",
"BJD ENGINEERS INDIA PRIVATE LIMITED",
"BJH JEWELS PRIVATE LIMITED",
"BJIRD EXIM PRIVATE LIMITED",
"BJK DESIGNS PRIVATE LIMITED",
"BJM AUTO PRIVATE LIMITED",
"BJM INDUSTRIES LTD",
"BJN HEALTHCARE SERVICES PRIVATE LIMITED",
"BJN PAINTS INDIA LIMITED",
"BJR CONSTRUCTIONS PRIVATE LIMITED",
"BJS DISTRIBUTION & STORAGE & COURIERS PRIVATE LIMITED",
"BJS ENGINEERS PRIVATE LIMITED",
"BJS INTERNATIONAL AGENCY PRIVATE LIMITED",
"BJS MOTORS PRIVATE LIMITED",
"BJSN AGRO IMPEX PRIVATE LIMITED",
"BK BIO-MEDICA PRIVATE LIMITED",
"BK BROS INFRATECH AND NIRMAN PRIVATE LIMITED",
"BK COLLEGE OF ART CRAFTS",
"BK COLLEGE OF EDUCATION",
"BK GARDEN FRESH PRIVATE LIMITED",
"BK INFRASERVICES PRIVATE LIMITED",
"BK INTERIOR PRIVATE LIMITED",
"BK MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"BK SOFTWARE SERVICES INDIA PRIVATE LIMITED",
"BK SOLAR AND BATTERIES PRIVATE LIMITED",
"BK STARLING ELECTRICALS PRIVATE LIMITED",
"BK STRUCTURAL CONTRACTS PRIVATE LIMITED",
"BK SYSTEMS PRIVATE LIMITED",
"BK TECHNO ENGINEERS PRIVATE LIMITED",
"BK THRESHERS PRIVATE LIMITED",
"BKALYANJI CONSTRUCTION INDIA PRIVATE LIMITED",
"BKB EXTRUSION PRIVATE LIMITED",
"BKB INFRA PROJECTS PRIVATE LIMITED",
"BKB MFERT PRIVATE LIMITED",
"BKB SHIP RECYCLERS PRIVATE LIMITED",
"BKC ADVISORS PRIVATE LIMITED",
"BKC CONSULTANTS PRIVATE LIMITED",
"BKC MALL MANAGEMENT PRIVATE LIMITED",
"BKC PROPERTIES PRIVATE LIMITED",
"BKC WEATHERSYS PRIVATE LIMITED",
"BKD AGRO CHEMICALS PRIVATE LIMITED",
"BKD INFRASTRUCTURE PRIVATE. LIMITED",
"BKDJ PACKAGINGS PRIVATE LIMITED",
"BKF EXPORTS PRIVATE LIMITED",
"BKG AUTOMOTIVE PRIVATE LIMITED",
"BKG GLOBAL SCHOOL",
"BKG MINING PRIVATE LIMITED",
"BKG PU COLLEGE",
"BKL AGRO FOODS PRIVATE LIMITED",
"BKLG VENDORS PRIVATE LIMITED",
"BKM FILTERS INDIA PRIVATE LIMITED",
"BKM INDIA PRIVATE LIMITED",
"BKM MINING PRIVATE LIMITED",
"BKN ENTERPRISE PRIVATE LIMITED",
"BKNETWORK SERVICES PRIVATE LIMITED",
"BKP AQUACULTURE PRIVATE LIMITED",
"BKPFOUR TECHNOLOGIES INDIA PRIVATE LIMITED",
"BKR CAPITAL PRIVATE LIMITED",
"BKR COMMODITY TRADING PRIVATE LIMITED",
"BKR DEVELOPERS PRIVATE LIMITED",
"BKRS PHARMA PRIVATE LIMITED",
"BKS GALAXY REALTORS PRIVATE LIMITED",
"BKS HOLDINGS INDIA PRIVATE LIMITED",
"BKS TEXTILES",
"BKSONS INFRASTRUCTURE PRIVATE LIMITED",
"BKT TRADECON PRIVATE LIMITED",
"BKV INFRACON PRIVATE LIMITED",
"BL AND CK PRIVATE LIMITED",
"BL GOEL CONTRACTS I PRIVATE LIMITED",
"BL INTERNATIONAL PRIVATE LIMITED",
"BL KAPUR HOSPITAL",
"BL MINERALS PRIVATE LIMITED",
"BL RICE MILL PRIVATE LIMITED",
"BL&SONS GLOBAL NUTS PRIVATE LIMITED",
"BLA COKE PRIVATE. LIMITED",
"BLA INFRASTRUCTURE PRIVATE. LIMITED",
"BLA INTERNATIONAL PRIVATE LIMITED",
"BLA PACKAGING INDUSTRIES PRIVATE LIMITED",
"BLA PROJECTS PRIVATE LIMITED",
"BLA UDYOG PRIVATE LIMITED",
"BLAACK FOREST BAKERY SERVICES PRIVATE LIMITED",
"BLACK & VEATCH PRIVATE LIMITED",
"BLACK & WHITE ELEPHANT ELEPHANT INNOVATIONS PRIVATE LIMITED",
"BLACK AND WHITE BUSINESS SOLUTIONS PRIVATE LIMITED",
"BLACK AND WHITE OUTSOURCING PRIVATE LIMITED",
"BLACK ARROW GROUPS HOLDING LIMITED",
"BLACK BELT COMMANDOS SECURITY SYSTEMS PRIVATE LIMITED",
"BLACK BELT DETECTIVES PRIVATE LIMITED",
"BLACK BERRETS SERVICES PRIVATE LIMITED",
"BLACK BIRD RETAIL INDIA PRIVATE LIMITED",
"BLACK BOX GPS TECHNOLOGY OPC PRIVATE LIMITED",
"BLACK BOX LIMITED",
"BLACK BOX NETWORK SERVICES INDIA PRIVATE LIMITED",
"BLACK BUCK FASHION PRIVATE LIMITED",
"BLACK BURN & CO PVT LTD",
"BLACK CANYON SEZ PRIVATE LIMITED",
"BLACK CATS PROTECTIONS PRIVATE LIMITED",
"BLACK CAVIAR HOSPITALITY PRIVATE LIMITED",
"BLACK CLOTHING PRIVATE LIMITED",
"BLACK CLOVES CONSULTANCY PRIVATE LIMITED",
"BLACK DIAMOND EQUIPMENTS PRIVATE LIMITED",
"BLACK DIAMOND EXPLOSIVES PRIVATE LIMITED",
"BLACK DIAMOND INDUSTRIES PRIVATE LIMITED",
"BLACK DIAMOND MOTORS PRIVATE LIMITED",
"BLACK DIAMOND PETROPRODUCTS PRIVATE LIMITED",
"BLACK DIAMOND PULSES PRIVATE LIMITED",
"BLACK DIAMOND RESTAURANTS PRIVATE LIMITED",
"BLACK DIAMOND TRACK PARTS PVT LTD",
"BLACK DIAMOND TRADELINK PRIVATE LIMITED",
"BLACK DRAGAON SECURITY PRIVATE LIMITED",
"BLACK ENERGY PRIVATE LIMITED",
"BLACK GOLD INTERNATIONAL PRIVATE LIMITED",
"BLACK HAWK SECURITY SYSTEM PRIVATE LIMITED",
"BLACK HEAVEN TRADING PRIVATE LIMITED",
"BLACK HOUND SECURITY SERVICES PRIVATE LIMITED",
"BLACK JACK INDIA PRIVATE LIMITED",
"BLACK KITE TECHNOLOGIES PRIVATE LIMITED",
"BLACK LABEL FASHIONS PRIVATE LIMITED",
"BLACK LAKE TECHNOLOGIES PRIVATE LIMITED",
"BLACK LIGHT MARKETING PRIVATE LIMITED",
"BLACK MAGIC TONERS PRIVATE LIMITED",
"BLACK MANGO FASHIONS LLP",
"BLACK OLIVE VENTURES PRIVATE LIMITED",
"BLACK OPAL CONSULTANTS PRIVATE LIMITED",
"BLACK ORCHIDS PRIVATE LIMITED",
"BLACK PANTHER GUARDS AND SERVICES PRIVATE LIMITED",
"BLACK PEPPER HOSPITALITY & EVENTS PRIVATE LIMITED",
"BLACK RIVER SERVICES PRIVATE LIMITED",
"BLACK ROCK FINANCIAL SERVICES PRIVATE LIMITED",
"BLACK ROCK REALTY INDIA VENTURES PRIVATE LIMITED",
"BLACK ROSE TRADING PRIVATE LIMITED",
"BLACK SEA CREATION PRIVATE LIMITED",
"BLACK SHEEP ADVERTISING PRIVATE LIMITED",
"BLACK SHEEP HOSPITALITY PRIVATE LIMITED",
"BLACK SPARROW CLOTHING PRIVATE LIMITED",
"BLACK THUNDER THEME PARK PRIVATE LIMITED",
"BLACK TULIP INFOTECH PRIVATE LIMITED",
"BLACK TURTLE INDIA PRIVATE LIMITED",
"BLACK WHITE ORANGE BRANDS PRIVATE LIMITED",
"BLACK&GREEN MOBILE SOLUTIONS PRIVATE LIMITED",
"BLACKBEAR TECHNOLOGIES PRIVATE LIMITED",
"BLACKBELT MULTISOLUTION INDIA PRIVATE LIMITED",
"BLACKBELT SMARTPHONE SECURITY PRIVATE LIMITED",
"BLACKBERRY INDIA PRIVATE LIMITED",
"BLACKBERRY REALCON PRIVATE LIMITED",
"BLACKBERRY TILES PRIVATE LIMITED",
"BLACKBERRY VENTURES PRIVATE LIMITED",
"BLACKBIRD LABS PRIVATE LIMITED",
"BLACKBOARD EDUCATION AND RESEARCH FOUNDATION",
"BLACKBOARD E-LEARNING PRIVATE LIMITED",
"BLACKBOARD INFORMATION TECHNOLOGY INDIA PRIVATE LIMITED",
"BLACKBOARD TECHNOLOGY INDIA PRIVATE LIMITED",
"BLACKBOX ANALYTICS & SOLUTIONS PRIVATE LIMITED",
"BLACKBRYONT PHARMACEUTICALS PRIVATE LIMITED",
"BLACKBUCK INSIGHTS PRIVATE LIMITED",
"BLACKCHERRY COMMOSALE PRIVATE LIMITED",
"BLACKCOFFER OPC PRIVATE LIMITED",
"BLACKCURRANT LABS PRIVATE LIMITED",
"BLACKDIAMOND CEMENTS PRIVATE LIMITED",
"BLACKDOTS INKS AND TONERS PRIVATE LIMITED",
"BLACKFIG TECHNOLOGIES PRIVATE LIMITED",
"BLACKFISH TECHNOLOGIES PRIVATE LIMITED",
"BLACKGOLD PROFILES PRIVATE LIMITED",
"BLACKGOLD TRADERS & DISTRIBUTORS PRIVATE LIMITED",
"BLACKHAWK NETWORK (INDIA) PRIVATE LIMITED",
"BLACKHULL MARITIME SERVICES PRIVATE LIMITED",
"BLACKLEAD INFRATECH PRIVATE LIMITED",
"BLACKLIGHT STUDIO WORKS PRIVATE LIMITED",
"BLACKMART ALLIED SERVICES OPC PRIVATE LIMITED",
"BLACKMELON ADVANCE TECHNOLOGY COMPANY PRIVATE LIMITED",
"BLACKMILK MEDIA PRIVATE LIMITED",
"BLACKNUT AGRIFOOD MACHINERY PRIVATE LIMITED",
"BLACKOAL JAZZ PRIVATE LIMITED",
"BLACKPEARL CREATION",
"BLACKPEARL SHIPPING & LOGISTICS PRIVATE LIMITED",
"BLACKPEARL STEEL AND MINERALS PRIVATE LIMITED",
"BLACKPOND GLOBAL DIGITAL SYSTEMS PRIVATE LIMITED",
"BLACKROCK INC.",
"BLACKROCK SERVICES INDIA PRIVATE LIMITED",
"BLACKSMITH CORPORATION MINING & ALLIED (OPC) PRIVATE LIMITED",
"BLACKSMITH INDUSTRIES PRIVATE LIMITED",
"BLACKSMITH WOVEN CONVERSION PRIVATE LIMITED",
"BLACKSOIL ASSET MANAGEMENT PRIVATE LIMITED",
"BLACKSOIL CAPITAL PRIVATE LIMITED",
"BLACKSPINE PUBLISHING PRIVATE LIMITED",
"BLACKSTONE ADVISORS INDIA PRIVATE LIMITED",
"BLACKSTONE COE INDIA PRIVATE LIMITED",
"BLACKSTONE CORPORATION PRIVATE LIMITED",
"BLACKSTONE ENGINEERING PRIVATE LIMITED",
"BLACKSTONE GROUP TECHNOLOGIES PRIVATE LIMITED",
"BLACKSTONE LOGISTICS PRIVATE LIMITED",
"BLACKSTONE MULTI TRADING PRIVATE LIMITED",
"BLACKSTONE OVERSEAS PRIVATE LIMITED",
"BLACKSTONE RUBBER INDUSTRIES PRIVATE LIMITED",
"BLACKSTONE SHIPPING PRIVATE LIMITED",
"BLACKSTRAW TECHNOLOGIES PRIVATE LIMITED",
"BLACKTIE ECOM PRIVATE LIMITED",
"BLACKTOP INFRASTRUCTURE PRIVATE LIMITED",
"BLACKVELVET HOSPITALITY PRIVATE LIMITED",
"BLACKWOOD DEVELOPERS PRIVATE LIMITED",
"BLACKWOOD SPACE SOLUTIONS PRIVATE LIMITED",
"BLAIN INDIA PRIVATE LIMITED",
"BLAIR REMEDIES PRIVATE LIMITED",
"BLAISE BUILDCON PRIVATE LIMITED",
"BLAIZE NEW COMPUTING TECHNOLOGIES INDIA PRIVATE LI",
"BLAIZE NEW COMPUTING TECHNOLOGIES INDIA PRIVATE LIMITED",
"BLAL STEEL SHREDDING PRIVATE LIMITED",
"BLAN COFFEE CURERS PRIVATE LIMITED",
"BLANCA PROPERTIES PRIVATE LIMITED",
"BLANCA TECHNOLOGY PRIVATE LIMITED",
"BLANCCO DIAGNOSTICS (INDIA) PRIVATE LIMITED",
"BLANCCO SOFTWARE INDIA PRIVATE LIMITED",
"BLANCHARD RESEARCH AND TRAINING INDIA LL P",
"BLANCO STEEL DETAILING SERVICES PRIVATE LIMITED",
"BLANKA ENGINEERING AND CONSTRUCTION PRIVATE LIMITED",
"BLANKCHQ INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"BLASANT INDUSTRIES PRIVATE LIMITED",
"BLAS-CONNECT IT SERVICES PRIVATE LIMITED",
"BLASER SWISSLUBE INDIA PRIVATE LIMITED",
"BLAST ABRASIVE PRIVATE LIMITED",
"BLASTCLEAN SYSTEMS PRIVATE LIMITED",
"BLASTO METAL SPRAY PROCESSORS PRIVATE LIMITED",
"BLAU-I MERCHANDISING PRIVATE LIMITED",
"BLAUMANN INDUSTRIES PRIVATE LIMITED",
"BLAUPLUG INNOVATIONS PRIVATE LIMITED",
"BLAZE AUTOMATION SERVICES PRIVATE LIMITED",
"BLAZE CLOTHING INDIA PRIVATE LIMITED",
"BLAZE DREAM TECHNOLOGIES PRIVATE LIMITED",
"BLAZE ENSOLUTIONS PRIVATE LIMITED",
"BLAZE GOLD JEWELS PRIVATE LIMITED",
"BLAZE POLY-FAB (INDIA) PRIVATE LIMITED",
"BLAZE PRINTING INKS PRIVATE LIMITED",
"BLAZE WEB SERVICES PRIVATE LIMITED",
"BLAZECLAN TECHNOLOGIES PRIVATE LIMITED",
"BLAZEDREAM TECHNOLOGIES PRIVATE LIMITED",
"BLAZELS INFINITY PRIVATE LIMITED",
"BLAZENET LIMITED",
"BLAZEWELL EVENTS PRIVATE LIMITED",
"BLAZING SKILLS DEVELOPMENT PRIVATE LIMITED",
"BLAZO CLOTHING MANUFACTURING COMPANY PRIVATE LIMITED",
"BLAZON BIOTEK PRIVATE LIMITED",
"BLAZON ENGINEERING COMPANY PRIVATE LIMITED",
"BLAZON WHOLESALEMART INDIA PRIVATE LIMITED",
"BLAZONLABS ITECH PRIVATE LIMITED",
"BLB COMMODITIES LIMITED",
"BLB ESTATES PRIVATE LIMITED",
"BLB INFRA PROJECTS PRIVATE LIMITED",
"BLB LIMITED",
"BLB MALL MANAGEMENT COMPANY PRIVATE LIMITED",
"BLBK PHARMACEUTICALS PRIVATE LIMITED",
"BLC AUTOSALES PRIVATE LIMITED",
"BLC FORWARDERD PRIVATE LIMITED",
"BLC INFRASTRUCTURES PRIVATE LIMITED",
"BLC METALS PRIVATE LIMITED",
"BLC TEXTILES PRIVATE LIMITED",
"BLD CONSULTANCY SERVICES PRIVATE LIMITED",
"BLD METAL AND ALLOYS PRIVATE LIMITED",
"BLD PHARMATECH (INDIA) PRIVATE LIMITED",
"BLD STEELS PRIVATE LIMITED",
"BLDE (DEEMED TO BE UNIVERSITY)",
"BLE MEDIA SOLUTIONS PRIVATE LIMITED",
"BLEACH CHEM EXIM (INDIA) PRIVATE LIMITED",
"BLEACH MARKETING PRIVATE LIMITED",
"BLEACH TOURISM PRIVATE LIMITED",
"BLECHTEK SOLUTIONS INDIA PRIVATE LIMITED",
"BLEND ADDITIVES & COMPOUNDS PRIVATE LIMITED",
"BLEND COLOURS PRIVATE LIMITED",
"BLEND CONSULTING & TRAINING INDIA PRIVATE LIMITED",
"BLEND FINANCIAL SERVICES LIMITED",
"BLEND FINANCIAL SOLUTIONS PRIVATE LIMITED",
"BLENDED FOODS & BEVERAGES PRIVATE LIMITED",
"BLENDHUB INDIA PRIVATE LIMITED",
"BLENHEIM CHALCOT IT SERVICES INDIA PRIVATE LIMITED",
"BLESS HOMES PRIVATE LIMITED",
"BLESS PACKAGING PRIVATE LIMITED",
"BLESS PROJECTS PRIVATE LIMITED",
"BLESS SHIPPING AND LOGISTICS PRIVATE LIMITED",
"BLESSAGRIS SUPPLIERS PRIVATE LIMITED",
"BLESSED CONSTRUCTION MASTERS PRIVATE LIMITED",
"BLESSED FLOW ENGINEERS PRIVATE LIMITED",
"BLESSING ENGINEERING PRIVATE LIMITED",
"BLESSING INDIAN REMY HAIR EXPORTS PRIVATE LIMITED",
"BLESSING SEVEN FINSERV",
"BLESSINGS ADVERTISING PRIVATE. LIMITED.",
"BLESSINGS CARGO CARE PRIVATE LIMITED",
"BLESSINGS EXPORTS PRIVATE LIMITED",
"BLESSINGS HEALTHCARE PRIVATE LIMITED",
"BLESSINGS PRIVATE LIMITED",
"BLESSINGS SECURED PRESS LIMITED",
"BLESSINGS SERVICE APARTMENTS PRIVATE LIMITED",
"BLESSINGSALWAYS LIMITED",
"BLESSWAY CARE PRIVATE LIMITED",
"BLEU CONCEPT INDIA PRIVATE LIMITED",
"BLEU NOIR INFRASTRUCTURE DEVELOPMENT PRIVATE LIMITED",
"BLG CONSTRUCTION SERVICE PRIVATE LIMITED",
"BLG ELECTRONICS LTD",
"BLG ENGINEERING PRIVATE LIMITED",
"BLG INFRA PROJECTS PRIVATE LIMITED",
"BLG INTERNATIONAL PRIVATE LIMITED",
"BLG PAREKH LOGISTICS PRIVATE LIMITED",
"BLIMP DESIGN PRIVATE LIMITED",
"BLIND BOYS INSTITUTE",
"BLIND PEOPLE‚ÄôS ASSOCIATION",
"BLINEX FILTER COAT PRIVATE LIMITED",
"BLING ACCESSORIES PRIVATE LIMITED",
"BLING ENTERTAINMENT SOLUTIONS PRIVATE LIMITED",
"BLINK COMMERCE PRIVATE LIMITED",
"BLINK CONSULTING PRIVATE LIMITED",
"BLINK DIGITAL (INDIA) PRIVATE LIMITED",
"BLINK FIX PRIVATE LIMITED",
"BLINK HEALTH INDIA PRIVATE LIMITED",
"BLINKIN TECHNOLOGIES PRIVATE LIMITED",
"BLINX INDIA PRIVATE LIMITED",
"BLIP SNIP CONSULTING PRIVATE LIMITED",
"BLIPPAR COM INDIA PRIVATE LIMITED",
"BLIQ TRADING PRIVATE LIMITED",
"BLISS AEROSPACE COMPONENTS PRIVATE LIMITED",
"BLISS ANAND PRIVATE LIMITED",
"BLISS AYURVEDA PRIVATE LIMITED.",
"BLISS CHOCOLATES INDIA PRIVATE LIMITED",
"BLISS CHOCOLATES PRIVATE LIMITED",
"BLISS DAIRY FRESH PRIVATE LIMITED",
"BLISS ELECTRICALS PRIVATE LIMITED",
"BLISS FINSTOCK PRIVATE LIMITED",
"BLISS GVS PHARMA LIMITED",
"BLISS HOTELS LIMITED",
"BLISS HOTELS LTD.",
"BLISS HVAC PRIVATE LIMITED",
"BLISS IMPEX",
"BLISS INFOSOFT PRIVATE LIMITED",
"BLISS INFUSIONS AND SURGICLES PRIVATE LIMITED",
"BLISS INNERSPACES PRIVATE LIMITED",
"BLISS INNS PRIVATE LIMITED",
"BLISS MANPOWER SERVICES PRIVATE LIMITED",
"BLISS REFRIGERATION PRIVATE LIMITED",
"BLISS RESORT & COUNTRY CLUB PRIVATE LIMITED",
"BLISS SOLAR POWER PRIVATE LIMITED",
"BLISS VANIJYA PRIVATE LIMITED",
"BLISS WEB SOLUTION PRIVATE LIMITED",
"BLISSBERRY BREWS PRIVATE LIMITED",
"BLISSFUL GARMENTS PRIVATE LIMITED",
"BLISSON MEDICA PRIVATE LIMITED",
"BLISSON MEDIPLUS PRIVATE LIMITED",
"BLISSPOINT DEVELOPERS AND INFRASTRUCTURE PRIVATE LIMITED",
"BLISSTERING ELECTRONICS PRIVATE LIMITED",
"BLISSTERING SOLUTIONS PRIVATE LIMITED",
"BLISSWOOD GLOBAL IMPEX PRIVATE LIMITED",
"BLISTER SOLAR ENERGY PRIVATE LIMITED",
"BLITCO IT SOLUTIONS PRIVATE LIMITED",
"BLITZ MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"BLITZKRIEG AUDIO VISUAL PRIVATE LIMITED",
"BLITZPATH INNOVATIONS PRIVATE LIMITED",
"BLITZZIO LABS INDIA PRIVATE LIMITED",
"B-LIVE MUSIC & ENTERTAINMENT PRIVATE LIMITED",
"BLIVE WEB-SOLUTIONS PRIVATE LIMITED",
"BLIX CYCLES AND E-VEHICLES PRIVATE LIMITED",
"BLIX EDUCATION PRIVATE LIMITED",
"BLIZZARD SKILL FACILITY SERVICES PRIVATE LIMITED",
"BLJ OVERSEAS PRIVATE LIMITED",
"BLJ RESOURCES & CHEMICALS PRIVATE LIMITED",
"BLJ SHARE BROKING PRIVATE LIMITED",
"BLK MAX HOSPITAL",
"BLLRO KUMARGRAM GVT OF WEST BENGAL",
"BLM CLOTHING PRIVATE LIMITED",
"BLM INDUSTRIES PRIVATE LIMITED",
"BLM SOFTWARE PRIVATE LIMITED",
"BLM TEXFAB PRIVATE LIMITED",
"BLOB INFOTECH PRIVATE LIMITED",
"BLOBSTATION SOLUTIONS PRIVATE LIMITED",
"BLOCHER BLOCHER INDIA PRIVATE LIMITED",
"BLOCK ARMOUR PRIVATE LIMITED",
"BLOCK CHAIN WAREHOUSING & JUTE PRIVATE LIMITED",
"BLOCK CHIEF MEDICAL OFFICER DIVISION DHOLPUR",
"BLOCK CMHO SALAWAS",
"BLOCK DEVELOPMENT OFFICER",
"BLOCK DEVELOPMENT OFFICER RAGHUNATHPUR",
"BLOCK EDUCATION OFFICE",
"BLOCK EDUCATION OFFICE KHANDWA",
"BLOCK EDUCATION OFFICER ALOTE RATLAM",
"BLOCK EDUCATION OFFICER AMARWARA",
"BLOCK EDUCATION OFFICER BAHANAGA",
"BLOCK EDUCATION OFFICER BANARPAL",
"BLOCK EDUCATION OFFICER BARAMBA",
"BLOCK EDUCATION OFFICER BASUDEVPUR",
"BLOCK EDUCATION OFFICER BHADRAK",
"BLOCK EDUCATION OFFICER BHAGWANPURA",
"BLOCK EDUCATION OFFICER BLOCK INDORE",
"BLOCK EDUCATION OFFICER BONTH",
"BLOCK EDUCATION OFFICER CHANDABALI",
"BLOCK EDUCATION OFFICER CUTTACK",
"BLOCK EDUCATION OFFICER DHAMNAGAR",
"BLOCK EDUCATION OFFICER GOP",
"BLOCK EDUCATION OFFICER JAORA",
"BLOCK EDUCATION OFFICER",
"BLOCK EDUCATION OFFICER KANIHA",
"BLOCK EDUCATION OFFICER KATGHORA",
"BLOCK EDUCATION OFFICER KHAIRA",
"BLOCK EDUCATION OFFICER MAHIDPUR",
"BLOCK EDUCATION OFFICER MORENA",
"BLOCK EDUCATION OFFICER NIMAPARA",
"BLOCK EDUCATION OFFICER ODISHA",
"BLOCK EDUCATION OFFICER PALARI BALODABAZAR BHATAPARA",
"BLOCK EDUCATION OFFICER PARAJANGA",
"BLOCK EDUCATION OFFICER RAGHUNATHPUR",
"BLOCK EDUCATION OFFICER RAT",
"BLOCK EDUCATION OFFICER REAMAL",
"BLOCK EDUCATION OFFICER SALIPUR",
"BLOCK EDUCATION OFFICER TANGI",
"BLOCK EDUCATION OFFICER TIHIDI",
"BLOCK EDUCATION OFFICER,JUJUMARA",
"BLOCK HEALTH & FAMILY WELFARE SAMITI",
"BLOCK HEALTH OFFICE",
"BLOCK HEALTH OFFICER PATAN DISTRICT PANCHAYAT",
"BLOCK MEDICAL OFFICER BILASPUR",
"BLOCK MEDICAL OFFICER C H C",
"BLOCK MEDICAL OFFICER PATAN HEALTH DEPARTMENT",
"BLOCK MEDICAL OFFICER SARANGARH",
"BLOCK PRIMARY EDUCATION OFFICER",
"BLOCK RESOURCE CENTRE ST THOMAS MOUNT URBAN CHENNAI",
"BLOCK SHRINKHALA TECHNOLOGIES LLP",
"BLOCK STACK PRIVATE LIMITED",
"BLOCKBASE CONSULTANTS PRIVATE LIMITED",
"BLOCKCHAIN SOLUTIONS NETWORK",
"BLOCKCUBE TECHNOLOGY LIMITED",
"BLOCKMATRIX IT SOLUTIONS PRIVATE LIMITED",
"BLOCON PLASTOWARE PRIVATE LIMITED",
"B-LOGIC INFOTECH PRIVATE LIMITED.",
"BLONDE N BLISS SALON PRIVATE LIMITED",
"BLONI STUDIOS PRIVATE LIMITED",
"BLOOM CHEMAG PRIVATE LIMITED",
"BLOOM COMBUSTION INDIA PRIVATE LIMITED",
"BLOOM COMPANIES LLC",
"BLOOM CONSULTING SERVICES PRIVATE LIMITED",
"BLOOM DEFENCE ACADEMY",
"BLOOM ELECTRONICS PRIVATE LIMITED",
"BLOOM ENERGY INDIA PRIVATE LIMITED",
"BLOOM EXIM PRIVATE LIMITED",
"BLOOM FOOD ADDITIVES PRIVATE LIMITED",
"BLOOM FOODS AND BEVERAGES PRIVATE LIMITED",
"BLOOM HEALTH CARE",
"BLOOM IMPEX PRIVATE LIMITED",
"BLOOM INDUSTRIES LIMITED",
"BLOOM INFRASTRUCTURE AND LOGISTICS (INDIA) PRIVATE LIMITED",
"BLOOM MEDICAL SUPPLIES PRIVATE LIMITED",
"BLOOM PACKAGING PRIVATE LIMITED",
"BLOOM SEAL CONTAINERS PRIVATE LIMITED",
"BLOOM SOLUTIONS PRIVATE LIMITED",
"BLOOM STONES (INDIA) PRIVATE LIMITED",
"BLOOM SYSTEMS PRIVATE LIMITED",
"BLOOMBAY ENTERPRISES LLP",
"BLOOMBAY ENTERPRISES PRIVATE LIMITED",
"BLOOMBERG DATA SERVICES INDIA PRIVATE LIMITED",
"BLOOMBERG EXIM PRIVATE LIMITED",
"BLOOMCRAFT APPARELS PRIVATE LIMITED",
"BLOOMEN FLORA LIMITED",
"BLOOMFIELD AGRO PRODUCTS PRIVATE LIMITED",
"BLOOMFIELDX ANALYTICS PRIVATE LIMITED",
"BLOOMFLEX PRIVATE LIMITED",
"BLOOMING BLOSSOMS EDUCATIONAL SOCIETY",
"BLOOMING BUD'S COACHING PRIVATE LIMITED",
"BLOOMING DALES GARMENTS INDIA PRIVATE LIMITED",
"BLOOMING FASHIONS PRIVATE LIMITED",
"BLOOMINGDALE INTERNATIONAL SCHOOL",
"BLOOMINGDALE INVESTMENT AND FINANCE PVT LTD",
"BLOOMINGDALE VENDORS PRIVATE LIMITED",
"BLOOMLIFE HOSPITAL",
"BLOOMONT SOLUTIONS PRIVATE LIMITED",
"BLOOMREACH TECHNOLOGIES PRIVATE LIMITED",
"BLOOMS AND GREENS PRIVATE LIMITED",
"BLOOMSBURY INFRASTRUCTURE PRIVATE LIMITED",
"BLOOMSBURY PUBLISHING INDIA PRIVATE LIMITED",
"BLOOMTECH IMPEX PRIVATE LIMITED",
"BLOOMTREE BUSINESS ADVISORS PRIVATE LIMITED",
"BLOOMY DESIGNS & FASHIONS PRIVATE LIMITED",
"BLOOP COMMUNICATIONS PRIVATE LIMITED",
"BLOSOOM MARKETING CONSULTANTS PRIVATE LIMITED",
"BLOSSOM APPLIANCES PRIVATE LIMITED",
"BLOSSOM AUTOMOBILES PRIVATE LIMITED",
"BLOSSOM BATHWARE PRIVATE LIMITED",
"BLOSSOM FABRICS LIMITED",
"BLOSSOM FREIGHT FORWARDING (INDIA) PRIVATE LIMITED",
"BLOSSOM GOLD COLLECTIONS PRIVATE LIMITED",
"BLOSSOM HOSPITALITY PRIVATE LIMITED",
"BLOSSOM INDUSTRIES LIMITED",
"BLOSSOM INNERS PRIVATE LIMITED",
"BLOSSOM KOCHHAR BEAUTY PRODUCTS PRIVATE LIMITED",
"BLOSSOM MERCHANT TRADUNG PRIVATE LIMITED",
"BLOSSOM MOTORS PRIVATE LIMITED",
"BLOSSOM MULTISPECIALTY HOSPITAL",
"BLOSSOM PLASTICS AND PACKAGING COMPANY PRIVATE LIMITED",
"BLOSSOM SCHOOL NAGPUR",
"BLOSSOM SENIOR SECONDARY SCHOOL",
"BLOSSOM SILK MILLS PRIVATE LIMITED",
"BLOSSOM STAYZ PRIVATE LIMITED",
"BLOSSOM VINCOM PRIVATE LIMITED",
"BLOSSOMS CONVENT SCHOOL",
"BLOSSOMS SR SEC SCHOOL",
"BLOW HOT KITCHEN APPLIANCES PRIVATE LIMITED",
"BLOW PACKAGING INDIA PRIVATE LIMITED",
"BLOW PET PRIVATE LIMITED",
"BLOWELL AUTO PRIVATE LIMITED",
"BLOWN STUDIO PRIVATE LIMITED",
"BLOWPACK TECHNOLOGY PRIVATE LIMITED",
"BLOWTECH AIR DEVICES PRIVATE LIMITED",
"BLOWTECH ENGINEERS PRIVATE LIMITED",
"BLOWVACC TRANSMISSION PRIVATE LIMITED",
"BLP EQUITY RESEARCH PRIVATE LIMITED",
"BLP INDUSTRY.AI PRIVATE LIMITED",
"BLP INTERIOR PRIVATE LIMITED",
"BLR BILLIONAIRE INDIA PRIVATE LIMITED",
"BLR FRONTLINE DISTRIBUTION PRIVATE LIMITED",
"BLR LABS PRIVATE LIMITED",
"BLR LOGISTIKS INDIA LIMITED",
"BLR LOUNGE SERVICES PRIVATE LIMITED",
"BLR SUPPLY CHAIN PRIVATE LIMITED",
"BLS DEVELOPER PRIVATE LIMITED",
"BLS ECOTECH LIMITED",
"BLS E-SERVICES LIMITED",
"BLS E-SOLUTIONS PRIVATE LIMITED",
"BLS IMPEX PRIVATE LIMITED",
"BLS INTERNATIONAL SCHOOL",
"BLS INTERNATIONAL SERVICES LIMITED",
"BLS IT SERVICES PRIVATE LIMITED",
"BLS KENDRAS PRIVATE LIMITED",
"BLS POLYMERS LIMITED",
"BLS SOFTWARE PRIVATE LIMITED",
"BLSB FINANCIAL SERVICES PRIVATE LIMITED",
"BLSS INDUSTRIES LIMITED",
"BLT BRILLIANT LIFTS & ESCALATORS PRIVATE LIMITED",
"BLT FLEXITANK LOGISTICS PRIVATE LIMITED",
"BLT LOGISTICS LIMITED",
"BLU COCOON DIGITAL LIMITED",
"BLU OCEANA DENTAL PRIVATE LIMITED",
"BLU POLYMER",
"BLU STREAM PRINTING INDIA PRIVATE LIMITED",
"BLU ULTRABAND INTERNET SERVICES PRIVATE LIMITED",
"BLU WHALE STUDIOZ PRIVATE LIMITED",
"BLUBAY TECHNOLOGIES PRIVATE LIMITED",
"BLUBEE INDUSTRIES PRIVATE LIMITED",
"BLUBELL PHARMA PRIVATE LIMITED",
"BLUBIRD AUTO TRADE PRIVATE LIMITED",
"BLUBUCK PRODUCTS PRIVATE LIMITED",
"BLUCOGNITION PRIVATE LIMITED",
"BLUCRAB PHARMA PRIVATE LIMITED",
"BLUCURSOR INFOTECH PRIVATE LIMITED",
"BLUDOZ DIGITAL MARKETING",
"BLUE ANGEL CONSTRUCTIONS PRIVATE LIMITED",
"BLUE APPLE TECHNOLOGIES PRIVATE LIMITED.",
"BLUE APPS PRIVATE LIMITED",
"BLUE ARROW BUILDCON PRIVATE LIMITED",
"BLUE AUTOWORLD PRIVATE LIMITED",
"BLUE AVES E-HEALTH PRIVATE LIMITED",
"BLUE BARRY PAINTS PRIVATE LIMITED",
"BLUE BASE SOFTWARE SERVICES PVT LTD",
"BLUE BEANS DIGITAL MARKETING LLP",
"BLUE BELL INTEGRATED FACILITY SERVICES PRIVATE LIMITED",
"BLUE BELL LOGISTICS PRIVATE LIMITED",
"BLUE BELL PLAST PRIVATE LIMITED",
"BLUE BELL PUBLIC SCHOOL",
"BLUE BELLS MODEL SCHOOL",
"BLUE BERKHS SHIPPING PRIVATE LIMITED",
"BLUE BERRY E-SERVICES PRIVATE LIMITED",
"BLUE BERRYFUN PRIVATE LIMITED",
"BLUE BIOPHARMA LIMITED",
"BLUE BIRD CARGO PRIVATE LIMITED",
"BLUE BIRD E SOLUTIONS PVT LTD",
"BLUE BIRD ENGLISH SCHOOL PRIVATE LIMITED",
"BLUE BIRD FINSTOCK PVT LTD",
"BLUE BIRD FOOD PRODUCTS PRIVATE LIMITED",
"BLUE BIRD FOODS INDIA PRIVATE LIMITED",
"BLUE BIRD IMAGING PRIVATE LIMITED",
"BLUE BIRD LOGISTICS PRIVATE LIMITED",
"BLUE BIRD PIGMENTS PRIVATE LIMITED",
"BLUE BIRD TECHNICKS PRIVATE LIMITED",
"BLUE BIRD TECHNOLOGIES PRIVATE LIMITED",
"BLUE BLAZE STUDIOS LLP",
"BLUE BLEND WEAVING MILLS PRIVATE LIMITED",
"BLUE BLENDS INDIA LIMITED",
"BLUE BLENDS INDIA LIMITED.",
"BLUE BOOZE PRIVATE LIMITED",
"BLUE BYTES NEWS PRIVATE LIMITED",
"BLUE CARAT PRIVATE LIMITED",
"BLUE CHIP CAPITAL SERVICES PRIVATE LIMITED",
"BLUE CHIP COMPUTER CONSULTANTS PRIVATE LIMITED",
"BLUE CHIP HOSPITALITY PRIVATE LIMITED",
"BLUE CHIP TEX INDUSTRIES LIMITED",
"BLUE CIRCLE MEDI SERVICES PRIVATE LIMITED",
"BLUE CIRCLE ORGANICS PRIVATE LIMITED",
"BLUE CLOUD HOSPITALITY PRIVATE LIMITED",
"BLUE CLOUD SOFTECH SOLUTIONS LIMITED",
"BLUE CLOUD TECHNOLOGIES PRIVATE LIMITED",
"BLUE CLUB COLLECTION PRIVATE LIMITED",
"BLUE COAST HOTELS LIMITED",
"BLUE COAT NETWORK INDIA PRIVATE LIMITED",
"BLUE COLD REFRIGERATION PRIVATE LIMITED",
"BLUE CONSULTING PRIVATE LIMITED",
"BLUE CORPUS SOLUTIONS PRIVATE LIMITED",
"BLUE CREATION RETAIL PRIVATE LIMITED",
"BLUE CREST FROZEN FOODS PRIVATE LIMITED",
"BLUE CROSS LABORATORIES PRIVATE LIMITED",
"BLUE CRYSTAL 3D ENGRAVE PRIVATE LIMITED",
"BLUE DAIMOND PROPERTIES PRIVATE LIMITED",
"BLUE DART AVIATION LIMITED",
"BLUE DART EXPRESS LIMITED",
"BLUE DART FINANCE & CONSULTANCY SERVICES LTD",
"BLUE DIAMOND CARGO SERVICES PRIVATE LIMITED",
"BLUE DIAMOND FOREX & TRAVELS PRIVATE LIMITED",
"BLUE DIAMOND PROPERTIES HOLDINGS PRIVATE LIMITED",
"BLUE DIAMOND PUBLIC SCHOOL",
"BLUE DIAMOND SCHOOL",
"BLUE DIGITAL MEDIA PRIVATE LIMITED",
"BLUE DROP FILMS PRIVATE LIMITED",
"BLUE DUCK TEXTILES PRIVATE LIMITED",
"BLUE EDGE TRADE VENTURE PRIVATE LIMITED",
"BLUE ENERGY COMMERCIAL VEHICLES PRIVATE LIMITED",
"BLUE EYE INDIA PRIVATE LIMITED.",
"BLUE EYED DIGITAL TECHNOLOGIES PRIVATE LIMITED",
"BLUE FEATHER IMPEX PRIVATE LIMITED",
"BLUE FENCE SYSTEMS PRIVATE LIMITED",
"BLUE FISH DESIGNS PRIVATE LIMITED",
"BLUE FLAME LABS PRIVATE LIMITED",
"BLUE FOX MOTION PICTURES",
"BLUE GALAXY MULTIVENTURES PRIVATE LIMITED",
"BLUE GENE PRIVATE LIMITED",
"BLUE HARP TECHNOLOGIES PRIVATE LIMITED",
"BLUE HAT SOLUTIONS PRIVATE LIMITED",
"BLUE HEART JEWELLERY PRIVATE LIMITED",
"BLUE HEAVEN COSMETICS PRIVATE LIMITED",
"BLUE HEAVENS HEALTH CARE PRIVATE LIMITED",
"BLUE HEIGHT DEVELOPERS PRIVATE LIMITED",
"BLUE HERON INDUSTRIES PRIVATE LIMITED",
"BLUE HIGHWAYS TOURS PRIVATE LIMITED",
"BLUE HORIZON HOTELS PRIVATE LIMITED",
"BLUE HORIZON INFOTECH",
"BLUE HORSE SHIPPING PRIVATE LIMITED",
"BLUE INK MEDIA PRIVATE LIMITED",
"BLUE IVORY BUSINESS SOLUTIONS PRIVATE LIMITED",
"BLUE JADE TEXINK PRIVATE LIMITED",
"BLUE JAY FINLEASE PRIVATE LIMITED",
"BLUE JAY TEXOWAD PRIVATE LIMITED",
"BLUE JEANS NETWORK INDIA PRIVATE LIMITED",
"BLUE JET HEALTHCARE LIMITED",
"BLUE JET HEALTHCARE PRIVATE LIMITED",
"BLUE KNOT APPARELS PRIVATE LIMITED",
"BLUE LADDER INFRATECH PRIVATE LIMITED",
"BLUE LAGOON TRADING PRIVATE LIMITED",
"BLUE LAKE CERAMIC",
"BLUE LEAF CORPORATE SOLUTIONS PRIVATE LIMITED",
"BLUE LIGHTNING HOSPITALITY PRIVATE LIMITED",
"BLUE LINE HOSPITALS PRIVATE LIMITED",
"BLUE LINE LOGISTICS AND WAREHOUSING LLP",
"BLUE LOTUS COMMUNICATIONS PRIVATE LIMITED",
"BLUE LOTUS CONSTRUCTION PRIVATE LIMITED",
"BLUE LOTUS CREATIVES PRIVATE LIMITED",
"BLUE LOTUS DESIGNERS PRIVATE LIMITED",
"BLUE LOTUS FACILITY MANAGEMENT PRIVATE LIMITED",
"BLUE LOTUS PAPER CUPS PRIVATE LIMITED",
"BLUE LOTUS REALTORS PRIVATE LIMITED",
"BLUE LOTUS SUPPORT SERVICES PRIVATE LIMITED",
"BLUE LOTUS TECHNOLOGIES PRIVATE LIMITED",
"BLUE MOON LOGISTICS PRIVATE LIMITED",
"BLUE MOON RETAIL PRIVATE LIMITED",
"BLUE MOON TRAVELS PRIVATE LIMITED",
"BLUE MOUNT DAIRY PRIVATE LIMITED",
"BLUE MOUNT UDYOG PRIVATE LIMITED",
"BLUE MOUNTAIN ADVISORS INDIA PRIVATE LIMITED",
"BLUE MOUNTAIN DWELLING PRIVATE LIMITED",
"BLUE MOUNTAIN HOTELS PRIVATE LIMITED",
"BLUE MOUNTAIN TEA AND COMMODITIES PRIVATE LIMITED",
"BLUE MUSHROOM INFOZONE PRIVATE. LIMITED",
"BLUE NEEM MEDICAL DEVICES PRIVATE LIMITED",
"BLUE NILE DEVELOPERS PRIVATE LIMITED",
"BLUE NILE PROPERTIES PRIVATE LIMITED",
"BLUE NILE TRADERS PRIVATE LIMITED",
"BLUE OAK INTERNATIONAL PRIVATE LIMITED",
"BLUE OCEAN BEVERAGES PRIVATE LIMITED",
"BLUE OCEAN BIOTECH PRIVATE LIMITED",
"BLUE OCEAN CATALYST PRIVATE LIMITED",
"BLUE OCEAN DISTRIBUTORS PRIVATE LIMITED",
"BLUE OCEAN E-COMMERCE PRIVATE LIMITED",
"BLUE OCEAN FINANCIAL SERVICES PRIVATE LIMITED",
"BLUE OCEAN IMC PRIVATE LIMITED",
"BLUE OCEAN IMPEX LLP",
"BLUE OCEAN INFO TECHNOLOGIES PRIVATE LIMITED",
"BLUE OCEAN LINE PRIVATE LIMITED",
"BLUE OCEAN MINERALS PRIVATE LIMITED",
"BLUE OCEAN PERSONNEL ALLIED SERVICE PRIVATE LIMITED",
"BLUE OCEAN REACH PRIVATE LIMITED",
"BLUE OCEAN STEELS LLP",
"BLUE OCEAN STRATEGIC ADVISORS PRIVATE LIMITED",
"BLUE OCEAN SYSTEMS INFOTECH PRIVATE LIMITED",
"BLUE OCEAN TECHNOLOGIES PRIVATE LIMITED",
"BLUE OCEAN TRANSTRADE PRIVATE LIMITED",
"BLUE OCEAN TRAVELS PRIVATE LIMITED",
"BLUE OCKTOPUS TECHNOLOGY SYSTEMS PRIVATE LIMITED",
"BLUE ORBIT FORCE (INDIA) PRIVATE LIMITED",
"BLUE PACIFIC SHIPPING & LOGISTICS PRIVATE LIMITED",
"BLUE PAL SOLUTIONS PRIVATE LIMITED",
"BLUE PALM HOTELS PRIVATE LIMITED",
"BLUE PAPILLIONS STUDIOS PRIVATE LIMITED",
"BLUE PARK ACQUATICS PVT LTD",
"BLUE PARK SEAFOODS PRIVATE LIMITED",
"BLUE PEAK SYSTEMS PRIVATE LIMITED",
"BLUE PEARL HEALTHTECH PRIVATE LIMITED",
"BLUE PEBBLE LIMITED",
"BLUE PHOSPHATE LIMITED",
"BLUE PIGEON EXIM SOLUTIONS PRIVATE LIMITED",
"BLUE PLANET FOODS PRIVATE LIMITED",
"BLUE PLANET LOGISTICS PRIVATE LIMITED",
"BLUE PLANET YASASU SOLUTIONS PRIVATE LIMITED",
"BLUE PLATE HOSPITALITY AND SERVICES PRIVATE LIMITED",
"BLUE POINT POWER SYSTEM PRIVATE LIMITED",
"BLUE POPPY HOLIDAYS PRIVATE LIMITED",
"BLUE PRINT DESIGN STUDIO PRIVATE LIMITED",
"BLUE PRINT PHARMACY PRIVATE LIMITED",
"BLUE PRISM INDIA PRIVATE LIMITED",
"BLUE RAY AVIATION PRIVATE LIMITED",
"BLUE RIBBON INDIA PRIVATE LIMITED",
"BLUE RICH VENTURES PRIVATE LIMITED",
"BLUE RIDGE INFRASTRUCTURE PRIVATE LIMITED",
"BLUE RIPPLES TECHNOLOGIES PRIVATE LIMITED",
"BLUE RIVER FINVEST PRIVATE LIMITED",
"BLUE RIVER PROJECTS PRIVATE LIMITED",
"BLUE ROCK HOSPITALITY VENTURES PRIVATE LIMITED",
"BLUE ROOF INFOTAINMENT PRIVATE LIMITED",
"BLUE ROSE COTSPIN LLP",
"BLUE SAPHIRE EXIM PRIVATE LIMITED",
"BLUE SAPPHIRE DYES AND CHEMICALS PRIVATE LIMITED",
"BLUE SAPPHIRE HEALTHCARE PRIVATE. LIMITED.",
"BLUE SAPPHIRE PROPERTIES PRIVATE LIMITED",
"BLUE SAPPHIRE RESIDENCY PRIVATE LIMITED",
"BLUE SEA AQUACULTURE PRIVATE LIMITED",
"BLUE SEA ENTERTAINMENT PRIVATE LIMITED",
"BLUE SEAS PAPERS PRIVATE LIMITED",
"BLUE SKIES TRAVELS AND TOURS",
"BLUE SKY ANALYTICS PRIVATE LIMITED",
"BLUE SKY HR SOLUTIONS PRIVATE LIMITED",
"BLUE SKY INDIA BALLOON PRIVATE LIMITED",
"BLUE SPRING BEVERAGES PRIVATE LIMITED",
"BLUE SQUARE CORPORATE SERVICES PRIVATE LIMITED",
"BLUE SQUARE INFRASTRUCTURE LLP",
"BLUE STALLION EQUIPMENTS PRIVATE LIMITED",
"BLUE STAMPINGS AND FORGINGS LIMITED",
"BLUE STAR AIR TRAVEL SERVICES GUJARAT PRIVATE LIMITED",
"BLUE STAR AUTO COMPONENTS PRIVATE LIMITED",
"BLUE STAR BUILDCON PRIVATE LIMITED",
"BLUE STAR BUILDPROP PRIVATE LIMITED",
"BLUE STAR CASTING PRIVATE LIMITED",
"BLUE STAR CLIMATECH LIMITED",
"BLUE STAR DIAMONDS PRIVATE LIMITED",
"BLUE STAR ENERGY PRIVATE LIMITED",
"BLUE STAR ENGINEERING & ELECTRONICS LIMITED",
"BLUE STAR EXTRUSION PRIVATE LIMITED",
"BLUE STAR INFOTECH LIMITED",
"BLUE STAR LIMITED",
"BLUE STAR MALLEABLE PRIVATE LIMITED",
"BLUE STAR NURSERY & PRIMARY SCHOOL",
"BLUE STAR REALTORS LIMITED",
"BLUE STAR SECURITY AND FACILITY SERVICES",
"BLUE STAUNCH SERVICES PRIVATE LIMITED",
"BLUE STONE COMPANY PRIVATE LIMITED",
"BLUE STONE ENERGY PRIVATE LIMITED",
"BLUE STONE FOUNDATION PRIVATE LIMITED",
"BLUE TEAK LABS PRIVATE LIMITED",
"BLUE TERRA LOGISTICS INDIA PRIVATE LIMITED",
"BLUE TEX (I) PRIVATE LIMITED",
"BLUE TURTLE HOSPITALITY",
"BLUE TYGA FASHIONS PRIVATE LIMITED",
"BLUE TYGA SHOES PRIVATE LIMITED",
"BLUE UMBRELLA INDIA PRIVATE LIMITED",
"BLUE VECTOR CONSULTING PRIVATE LIMITED",
"BLUE WAVE AQUA INDIA PRIVATE LIMITED",
"BLUE WAVE IT SOLUTIONS INDIA PRIVATE LIMITED",
"BLUE WHALE ADVISORY SERVICES PRIVATE LIMITED",
"BLUE WHALE ENTERPRISES (INDIA) PRIVATE LIMITED",
"BLUE WHALE MARITIME PRIVATE LIMITED",
"BLUE WHEEL HOSPITAL BHUBANESWAR",
"BLUE WING GLOBAL FREIGHT PRIVATE LIMITED",
"BLUE WINGS TOURS & TRAVELS PRIVATE LIMITED",
"BLUE WORKS ENGINEERING PRIVATE LIMITED",
"BLUE WORLD CARGO",
"BLUE WORLD SHIPPING AGENCIES PRIVATE LIMITED",
"BLUE YONDER INDIA PRIVATE LIMITED",
"BLUE ZONE ONLINE MARKETING SOLUTIONS PRIVATE LIMITED",
"BLUE ZONE SYSTEM PRIVATE LIMITED",
"BLUEALLY INFOTECH INDIA PRIVATE LIMITED",
"BLUEAPPLE LOGISTIC SOLUTIONS PRIVATE LIMITED",
"BLUEART GRANITO PRIVATE LIMITED",
"BLUEARTH ENERGY PRIVATE LIMITED",
"BLUEAURA ISOLUTIONS PRIVATE LIMITED",
"BLUEAURA OVERSEAS PRIVATE LIMITED",
"BLUEBASH CONSULTING PRIVATE LIMITED",
"BLUEBASIC INDIA LIMITED",
"BLUEBELL DEALER AND STOCKIST PRIVATE LIMITED",
"BLUEBELL ENGINEERING SOLUTIONS PRIVATE LIMITED",
"BLUEBELL ERGONOMICS PRIVATE LIMITED",
"BLUEBELL EXIM PRIVATE LIMITED",
"BLUEBELL OUTSOURCING INDIA PRIVATE LIMITED",
"BLUEBELL POLYMERS PRIVATE LIMITED",
"BLUEBELL PREMIUM WATER PRIVATE LIMITED",
"BLUEBELL TOWNSHIP FACILITY MANAGEMENT LL P",
"BLUEBELLS TECHNOSOLUTIONS PRIVATE LIMITED",
"BLUEBENZ DIGITIZATIONS PRIVATE LIMITED",
"BLUEBERRY AGRO PRODUCTS PRIVATE LIMITED",
"BLUEBERRY ASSOCIATES PRIVATE LIMITED",
"BLUEBERRY DIGITAL LABS PRIVATE LIMITED",
"BLUEBERRY IT SOLUTIONS PRIVATE LIMITED",
"BLUEBERRY SEMICONDUCTORS PRIVATE LIMITED",
"BLUEBINARIES ENGINEERING AND SOLUTIONS PRIVATE LIMITED",
"BLUEBIRD INDIA R&D CENTER PRIVATE LIMITED",
"BLUEBIRD LIGHTS PRIVATE LIMITED",
"BLUEBIRD MERCANTILES PVT LTD.",
"BLUEBIRD POWER CONTROLS PRIVATE LIMITED",
"BLUEBIRD ROADWAYS PRIVATE LIMITED",
"BLUEBIRD SOFTWARE PRIVATE LIMITED",
"BLUEBIRD SOLAR PRIVATE LIMITED",
"BLUEBLAZE SYSTEMS & SERVICES PRIVATE LIMITED",
"BLUEBRICKS TECHNOLOGIES PRIVATE LIMITED",
"BLUEBUG LIFE SCIENCE PRIVATE LIMITED",
"BLUECARE SYSTEMS PRIVATE LIMITED",
"BLUECHIP AMUSEMENTS INDIA PRIVATE LIMITED",
"BLUECHIP COMPUSOFT PRIVATE LIMITED",
"BLUECHIP CONCEPTS INDIA PRIVATE LIMITED",
"BLUECHIP CONCRETE PRIVATE LIMITED",
"BLUECHIP CORPORATE INVESTMENT CENTRE PRIVATE LIMITED",
"BLUECHIP GULF IT SERVICES PRIVATE LIMITED",
"BLUECHIP INFOCORP PRIVATE LIMITED",
"BLUECHIP INSURANCE BROKING PRIVATE LIMITED",
"BLUECHIP MEDIA PRIVATE LIMITED",
"BLUECHIP ONLINE SHARES INDIA PRIVATE LIMITED",
"BLUECHIP SOLUTIONS PPLUS PRIVATE LIMITED.",
"BLUECHIPS TRADING COMPANY PVT LTD",
"BLUECITY BEPL ENERGY PRIVATE LIMITED",
"BLUECLOUD SERVICES PRIVATE LIMITED",
"BLUECOIN IOT SOLUTIONS PRIVATE LIMITED",
"BLUECOLLAR DISTRIBUTORS AND WHOLESALERS PRIVATE LIMITED",
"BLUECOM INFOTECH PRIVATE LIMITED",
"BLUECOM TECHNOLOGIES INDIA PRIVATE LIMITED",
"BLUECOM TECHNOLOGIES PRIVATE LIMITED",
"BLUECORE SOFTWARE PRIVATE LIMITED",
"BLUECRAFT AGRO PRIVATE LIMITED",
"BLUECREST HR CONSULTING PRIVATE LIMITED",
"BLUECREST SOFTWARE & CONSULTANCY SER PRIVATE LIMITED",
"BLUECROSS ANIMAL HEALTHCARE PRIVATE LIMITED",
"BLUEDIAMOND LOGISTICS PRIVATE LIMITED",
"BLUEDOT MEDIA PRIVATE LIMITED",
"BLUEDROP ENVIRO PRIVATE LIMITED",
"BLUEEARTH SOFTWARES PRIVATE LIMITED",
"BLUEED TECHNOLOGY PRIVATE LIMITED",
"BLUEEXPRESS LOGISTICS SERVICES INDIA PRIVATE LIMITED",
"BLUEFEST TRADING PRIVATE LIMITED",
"BLUE-FIN FROZEN FOODS PRIVATE LIMITED",
"BLUEFIRE INTERNATIONAL PRIVATE LIMITED",
"BLUEFISH PHARMACEUTICALS PRIVATE LIMITED",
"BLUEFLAME INDUSTRIES PRIVATE LIMITED",
"BLUEFOX MOTION PICTURES PRIVATE LIMITED",
"BLUEFROG MOBILE TECHNOLOGIES PRIVATE LIMITED",
"BLUEGEM IT SOLUTIONS PRIVATE LIMITED",
"BLUEGLOBE EXPORTS PRIVATE LIMITED",
"BLUEGRASS TECHNOLOGIES PRIVATE LIMITED",
"BLUEGREEN EQUIPMENTS PRIVATE LIMITED",
"BLUEHAT SOFTWARE SOLUTIONS PRIVATE LIMITED",
"BLUEHILL CAPITAL PRIVATE LIMITED",
"BLUEHORSE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"BLUE-ICE CTC PACKAGINGS PRIVATE LIMITED",
"BLUEINFY SOLUTIONS PRIVATE LIMITED",
"BLUEIVY HOSPITALITY PRIVATE LIMITED",
"BLUEJAY ENTERPRISES PRIVATE LIMITED",
"BLUEJAY NUTS PRIVATE LIMITED",
"BLUE-JAY PROJECTS & CONSTRUCTIONS PRIVATE LIMITED",
"BLUEKRAFT DIGITAL FOUNDATION",
"BLUELADDER EPC SOLUTIONS PRIVATE LIMITED",
"BLUELAND AGENCIES PRIVATE LIMITED",
"BLUELINE FOODS (INDIA) PRIVATE LIMITED",
"BLUELINE LOGISTICS PRIVATE LIMITED",
"BLUELINE POWER PRODUCTS PRIVATE LIMITED",
"BLUELUPIN TECHNOLOGIES PRIVATE LIMITED",
"BLUEMAARLIN ENGINEERING PRIVATE LIMITED",
"BLUEMARLIN CONTAINER LINE PRIVATE LIMITED",
"BLUEMART MERCHANTS PRIVATE LIMITED",
"BLUEMATRIX CONSULTANCY PRIVATE LIMITED",
"BLUEMERIC TECHNOLOGIES PRIVATE LIMITED",
"BLUEMIND SOLUTIONS PRIVATE LIMITED",
"BLUEMONK RECYCLING PRIVATE LIMITED",
"BLUEMORPHO LEARNING SOLUTIONS PRIVATE LIMITED",
"BLUEMOTION TRANSPORT PRIVATE LIMITED",
"BLUEMOUNT CASTINGS PRIVATE LIMITED",
"BLUENEBA TECHNOLOGIES PRIVATE LIMITED",
"BLUENEST VENTURES PRIVATE LIMITED",
"BLUENILE REALTY PRIVATE LIMITED",
"BLUENINE INFRA TECHNOLOGIES PRIVATE LIMITED",
"BLUENIXIE (OPC) PRIVATE LIMITED",
"BLUENT E SOLUTIONS PRIVATE LIMITED",
"BLUEOCEAN CONTAINER TERMINALS INDIA PRIVATE LIMITED",
"BLUEOCEAN MARKET INTELLIGENCE SERVICES PRIVATE LIMITED",
"BLUEORCHID METALL PULVER PRIVATE LIMITED",
"BLUEPAY VENTURES PRIVATE LIMITED",
"BLUEPI CONSULTING PRIVATE LIMITED",
"BLUEPINEFOODS PRIVATE LIMITED",
"BLUEPLANET INFRADEVELOPERS PRIVATE LIMITED",
"BLUEPRINT TECHNOLOGIES PRIVATE LIMITED",
"BLUERIBBON BUSINESS PRIVATE LIMITED",
"BLUERIDGE EDUCATIONAL INSTITUTE",
"BLUERIDGE GLOBAL PRIVATE LIMITED",
"BLUERIDGE RETAILS PRIVATE LIMITED",
"BLUERIGGER RETAIL PRIVATE LIMITED",
"BLUERIVER COMMODEAL PVT. LTD.",
"BLUEROCK ESERVICES PRIVATE LIMITED",
"BLUEROCK SYSTEMS PRIVATE LIMITED",
"BLUEROSE AGENCY PRIVATE LIMITED",
"BLUEROSE PUBLISHERS PRIVATE LIMITED",
"BLUEROSE TECHNOLOGIES PRIVATE LIMITED",
"BLUES DEVELOPERS PRIVATE LIMITED",
"BLUES N COPPERS EVENTS PRIVATE LIMITED",
"BLUESAPLING TECHNOLOGIES PRIVATE LIMITED",
"BLUESCOPE AV TECHNOLOGIES PRIVATE LIMITED",
"BLUESCOPE STEEL INDIA PRIVATE LIMITED",
"BLUESEAL AGRO PRIVATE LIMITED",
"BLUESHIELD PROTECTION NETWORK PRIVATE LIMITED",
"BLUESHIELD RO INDUSTRIES PRIVATE LIMITED",
"BLUESIGNS AND DISPLAY PRIVATE LIMITED",
"BLUESKART E-COMMERCE PRIVATE LIMITED",
"BLUESKY DEALERS LIMITED",
"BLUESKY GEOSPATIAL PRIVATE LIMITED",
"BLUESKY INFOTECH",
"BLUESKY INFRACREATIONS PRIVATE LIMITED",
"BLUESKY LEARNING PRIVATE LIMITED",
"BLUEST GOODS & SERVICES PRIVATE LIMITED",
"BLUESTAR AIR TRAVEL SERVICES I PRIVATE LIMITED",
"BLUE-STAR AIR TRAVEL SERVICES(INDIA)PVT LTD",
"BLUESTAR COTTSPIN PRIVATE LIMITED",
"BLUESTAR RESTAURANTS PRIVATE LIMITED",
"BLUESTAR SANITARY INDUSTRIES PRIVATE LIMITED",
"BLUESTAR SECURITY AND FACILITY SERVICES",
"BLUESTAR SOFTWARE PRIVATE LIMITED",
"BLUESTEM GLOBAL SOURCING INDIA PRIVATE LIMITED",
"BLUESTONE ELECTRONICS PRIVATE LIMITED",
"BLUESTONE FARM PRIVATE LIMITED",
"BLUESTONE INTERIORS AND DECORS PRIVATE LIMITED",
"BLUESTONE JEWELLERY AND LIFESTYLE PRIVATE LIMITED",
"BLUESTONE TECH LABS PRIVATE LIMITED",
"BLUESTONEX EDUCATION & SERVICES PRIVATE LIMITED",
"BLUESTREAM INFRASTRUCTURE DEVELOPMENT CONSULTANT PRIVATE LIMITED",
"BLUESTREAM MANUFACTURING SERVICES PRIVATE LIMITED",
"BLUESUN HITECH SOLUTIONS PRIVATE LIMITED",
"BLUETECH DESIGN PRIVATE LIMITED",
"BLUETECH IMPEX PRIVATE LIMITED",
"BLUETHINK IT CONSULTING PRIVATE LIMITED",
"BLUETIDE ESERVICES PRIVATE LIMITED",
"BLUETIGERS SECURITY GUARD SERVICES PRIVATE LIMITED",
"BLUETOWN (INDIA) PRIVATE LIMITED",
"BLUETREE CONSULTANCY SERVICES PRIVATE LIMITED",
"BLUEVIEW COMMERCIAL PRIVATE LIMITED",
"BLUEVISTA INTERNATIONAL LIMITED",
"BLUEWARE TECHNOLOGIES AND SERVICES PRIVATE LIMITED",
"BLUEWATER BUSINESS ASSOCIATES PRIVATE LIMITED",
"BLUE-WATER SHIP MANAGEMENT PRIVATE LIMITED",
"BLUEWATER TRADE WINDS PRIVATE LIMITED",
"BLUEWAVE FISHERIES PRIVATE LIMITED",
"BLUEWAVE TIE-UP PRIVATE LIMITED",
"BLUEWAVES DISTRIBUTORS PRIVATE LIMITED",
"BLUEWEAVE CONSULTING & RESEARCH PRIVATE LIMITED",
"BLUEWING DESIGN AND CONSTRUCTION PRIVATE LIMITED",
"BLUEWINGS CARGO AND LOGISTICS PRIVATE LIMITED",
"BLUEWORLD TOURIST PRIVATE LIMITED",
"BLUEWUD CONCEPTS PRIVATE LIMITED",
"BLUEZONE VITRIFIED PRIVATE LIMITED",
"BLUJAY SOLUTIONS INDIA PRIVATE LIMITED",
"BLULIFE INTERNATIONAL LIMITED",
"BLUM INDIA PRIVATE LIMITED",
"BLUM NOVOTEST MEASURING AND TESTING TECHNOLOGY PRIVATE LIMITED",
"BLUMA APPLIANCES INDIA PRIVATE LIMITED",
"BLUMA ENTERPRISES PRIVATE LIMITED",
"BLUME GLOBAL INDIA PRIVATE LIMITED",
"BLUME VENTURE INVESTMENT MANAGER LLP",
"BLUMEN BIOVITALS HEALTHKARE PRIVATE LIMITED",
"BLUMENBECKER KAT AUTOMATION PRIVATE LIMITED",
"BLUMENOTICS PRIVATE LIMITED",
"BLUMONK TECHNOLOGIES PRIVATE LIMITED",
"BLUMP TECH PRIVATE LIMITED",
"BLUMUSLIN SERVICES PRIVATE LIMITED",
"BLUNUTS DRY FRUITS PRIVATE LIMITED",
"BLUOCEAN INTEGRATED SOLUTIONS PRIVATE LIMITED",
"BLUONE CONSULTANT LLP",
"BLUPAX ENGINEERING AND INDUSTRIAL PRIVATE LIMITED",
"BLUPEAK CAPITAL SERVICES PRIVATE LIMITED",
"BLUPINX FASHIONS PRIVATE LIMITED",
"BLURBPOINT MEDIA TECH LLP",
"BLURHINO SECURE STORAGE PRIVATE LIMITED",
"BLUSAPPHIRE CYBER SYSTEMS PRIVATE LIMITED",
"BLUSH CLINICS PRIVATE LIMITED",
"BLUSH COSMETICS PRIVATE LIMITED",
"BLU-SMART MOBILITY TECH PRIVATE LIMITED",
"BLUTEC VANBUREN INDUSTRIES INDIA PRIVATE LIMITED",
"BLUTEN MARKETING PRIVATE LIMITED",
"BLUTICK SOLUTIONS PRIVATE LIMITED",
"BLUTIM FACILITY SERVICES PRIVATE LIMITED",
"BLUTREE SOLUTIONS PRIVATE LIMITED",
"BLUVOLT ENERGY INDIA PRIVATE LIMITED",
"BLV INFINITY PROJECT SOLUTIONS PRIVATE LIMITED",
"BLW ENGINE VALVES PRIVATE LIMITED",
"BLW HQ UNIT",
"BLYNK MARKETING PRIVATE LIMITED",
"BLYTH METALS INDIA P LIMITED",
"BLYTH WIND PARK PRIVATE LIMITED",
"BM AUTO CASTINGS PRIVATE LIMITED",
"BM AUTOWORLD PRIVATE LIMITED",
"BM BIRLA HEART RESEARCH INSTITUTE",
"BM CONSULTING PRIVATE LIMITED",
"BM ELECTROTECH CASTING PRIVATE LIMITED",
"BM GUPTA HOSPITAL PRIVATE LIMITED",
"BM INTEGRATED INFRA SOLUTIONS PRIVATE LIMITED",
"BM JEWELLERSS PRIVATE LIMITED",
"BM PROFESSIONAL INSTITUTE ( BM GROUP OF INSTITUTION )",
"BM SCIENTIFIC PRIVATE LIMITED",
"BM SPARK INDIA PRIVATE LIMITED",
"BMA FOODS PRIVATE LIMITED",
"BMA PRINTS PRIVATE LIMITED",
"BMA STAINLESS LIMITED",
"BMA TECHNOLOGIES PRIVATE LIMITED",
"BMAN SECURITY SERVICES PRIVATE LIMITED",
"BMAX ENGINEERING PRIVATE LIMITED",
"BMB FOUNDATIONS PRIVATE LIMITED",
"BMC",
"BMC ELECTROPLAST PVT LTD",
"BMC FERROCAST PRIVATE LIMITED",
"BMC INFRA PRIVATE LIMITED",
"BMC METALCAST PRIVATE LIMITED",
"BMC SOFTWARE INDIA PRIVATE LIMITED",
"BMC SUPPORT AND ACCOUNTING SERVICES PRIVATE LIMITED",
"BMCP SOLUTIONS INDIA PRIVATE LIMITED",
"BMCRI SUPER SPECIALITY HOSPITAL",
"BMD ENGINEERING PRIVATE LIMITED",
"BMD INDUSTRIAL STEELS PRIVATE LIMITED",
"BMD INTERNATIONAL PRIVATE LIMITED",
"BMD POWER PRIVATE LIMITED",
"BMD PRIVATE LIMITED",
"BMD SECURITIES LIMITED",
"BMD SYNDICATE PRIVATE LIMITED",
"BMD VENTURE PRIVATE LIMITED",
"BMDC ENTERPRISES PRIVATE LIMITED",
"BMECIMAGING PRIVATE LIMITED",
"BMG FINSERV PRIVATE LIMITED",
"BMG INFORMATICS PRIVATE LIMITED",
"BMG INFRA PRIVATE LIMITED",
"BMG JEWELLERS PRIVATE LIMITED",
"BMG ROPES PRIVATE LIMITED",
"BMH CARE HOSPITAL LIMITED",
"BMH CONCARE TECHNOLOGY PRIVATE LIMITED",
"BMI CABLES PRIVATE LIMITED",
"BMI MINERALS PRIVATE LIMITED",
"BMI OXIDES PRIVATE LIMITED",
"BMI WHOLESALE TRADING PRIVATE LIMITED",
"BMIA COTTON INDUSTRIES PRIVATE LIMITED",
"BMJ INTERIORZ (OPC) PRIVATE LIMITED",
"BMJR AGRO PRIVATE LIMITED",
"BMK BUILDCON PRIVATE LIMITED",
"BMK EXPRESS AUTOMOBILES PRIVATE LIMITED",
"BMK HOSPITALITY SERVICES PRIVATE LIMITED",
"BMK PRIVATE LIMITED",
"BML FACILITY MANAGEMENT PRIVATE LIMITED",
"BML GLOBAL LOGISTICS PRIVATE LIMITED",
"BML INVESTMENTS PRIVATE LIMITED",
"BML MUNJAL UNIVERSITY",
"BML PARENTERAL DRUGS",
"BMM ISPAT LIMITED",
"BMP EGROUP SOLUTION PRIVATE LIMITED",
"BMP ENGINEERING PRIVATE LIMITED",
"BMP HOTELS PRIVATE LIMITED",
"BMP STEELS PRIVATE LIMITED",
"BMQR CERTIFICATIONS PRIVATE LIMITED",
"BMR AND ASSOCIATES",
"BMR BLUE GENETICS PRIVATE LIMITED",
"BMR BUSINESS SOLUTIONS PRIVATE LIMITED",
"BMR COMMERCIAL PRIVATE LIMITED",
"BMR CONSTRUCTIVE SOLUTIONS PRIVATE LIMITED",
"BMR HVAC LIMITED",
"BMR INDUSTRIES PRIVATE LIMITED",
"BMR MARINE PRODUCTS PRIVATE LIMITED",
"BMR MAVEN POINT PRIVATE LIMITED",
"BMRAJ INDUSTRIES PRIVATE LIMITED",
"BMRC HOSPITALS LIMITED",
"BMRC INFRASTRUCTURE PRIVATE LIMITED",
"BMRG PROJECTS (INDIA) PRIVATE LIMITED",
"BMRS INFRASTRUCTURE PRIVATE LIMITED",
"BMS COLLEGE FOR WOMEN",
"BMS COLLEGE OF COMMERCE AND MANAGEMENT",
"BMS COLLEGE OF ENGG",
"BMS COLLEGE OF LAW",
"BMS DIESEL SYSTEMS ( INDIA) PRIVATE LIMITED",
"BMS FOREX PRIVATE LIMITED",
"BMS HOSPITAL AND DIAGNOSTIC",
"BMS IMPEX PRIVATE LIMITED",
"BMS INDUSTRIES LIMITED",
"BMS INDUSTRIES PRIVATE LIMITED",
"BMS INFRATECH PRIVATE LIMITED",
"BMS INSTITUTE OF TECHNOLOGY AND MANAGEMENT",
"BMS PROFESSIONAL SERVICES PRIVATE LIMITED.",
"BMS PROJECTS",
"BMS STARCH PRIVATE LIMITED",
"BMS TALENT MANAGEMENT PRIVATE LIMITED",
"BMS TRADECORP PRIVATE LIMITED",
"BMS TRADELINK PRIVATE LIMITED",
"BMS WELLNESS PRIVATE LIMITED",
"BMSF DESIGN CONSULTANTS PRIVATE LIMITED",
"BMSINDIA MEDICAL RESOURCING PRIVATE LIMITED",
"BMSR TEXOFAB PRIVATE LIMITED",
"BMSS STEEL INDUSTRIES PVT.LTD.",
"BMT CONSULTANTS (INDIA) PRIVATE LIMITED",
"BMT MEDICAL DEVICES PRIVATE LIMITED",
"BMTG ADVISORS INDIA PRIVATE LIMITED",
"BMUSE INDIA TECHNOLOGIES PRIVATE LIMITED",
"BMUSICIAN PRIVATE LIMITED",
"BMW (PURNEA) TRADECOM PRIVATE LIMITED",
"BMW ENTERPRISES PRIVATE LIMITED",
"BMW ENTERPRISES UNIT OF JAI BASUKINATH TRADERS PRIVATE LIMITED",
"BMW FIN - INVEST PRIVATE LIMITED",
"BMW GLOBAL VENTURES PRIVATE LIMITED",
"BMW HOLDINGS PRIVATE LIMITED",
"BMW INDIA FINANCIAL SERVICES PRIVATE LIMITED",
"BMW INDIA LEASING PRIVATE LIMITED",
"BMW INDIA PRIVATE LIMITED",
"BMW INDUSTRIES LIMITED.",
"BMW IRON & STEEL INDUSTRIES LIMITED",
"BMW LOGISTICS PRIVATE LIMITED",
"BMW PHARMACO INDIA PRIVATE LIMITED",
"BMW PROJECT PRIVATE LIMITED",
"BMW VENTURES LIMITED",
"BMW VYAPAR PRIVATE LIMITED",
"BN AGRITECH LIMITED",
"BN BOSE HOSPITAL BARRACKPORE",
"BN LED LIGHTS PRIVATE LIMITED",
"BN PACK CORRUGATED PRIVATE LIMITED",
"BN PRECAST PRIVATE LIMITED",
"BNA AUTOMOTIVE INDIA PRIVATE LIMITED",
"BNA FLEXINET SYSTEMS LIMITED",
"BNA TECHNOLOGY CONSULTING LIMITED",
"BNAL PREFABS PVT LTD",
"BNAS PVT LTD",
"BNAZRUM AGRO EXPORTS PRIVATE LIMITED",
"BNB CONSTRUCTIONS PRIVATE LIMITED",
"BNB FINANCIAL SERVICES PRIVATE LIMITED",
"BNB HOSPITALITY SERVICES PRIVATE LIMITED",
"BNB INFRACON INDIA PRIVATE LIMITED",
"BNB INTERIOR CONSULTANT PRIVATE LIMITED",
"BNB SECURITY AND AUTOMATION",
"BNBS EXPORTS PRIVATE LIMITED",
"BNC EQUIPMENTS INDIA PRIVATE LIMITED",
"BNC INFRASTRUCTURE PRIVATE LIMITED",
"BNC PALSIDDHA INFRA PRIVATE LIMITED",
"BNC POWER PROJECTS LIMITED",
"BNCMC SCHOOL NO. 99 BHIWANDI",
"BND ENERGY PRIVATE LIMITED",
"BND ENGINEERS PVT LTD",
"BNE INFRATECH LIMITED",
"BNF TECHNOLOGY INC",
"BNG ADVISORS PRIVATE LIMITED",
"BNG AUDIOLOGY AND HEARING CARE PRIVATE LIMITED",
"BNG FASHION GEARS PRIVATE LIMITED",
"BNG INFOTECH PRIVATE LIMITED",
"BNG PALACE AND RESORT PRIVATE LIMITED",
"BNH INFRA PROJECTS (INDIA) PRIVATE LIMITED",
"BNI INDIA ENTERPRISES PRIVATE LIMITED",
"BNK ALLOYS PRIVATE LIMITED",
"BNK ENERGY ALTERNATIVES",
"BNK INFOCOM PRIVATE LIMITED",
"BNK INFOTECH PRIVATE LIMITED",
"BNK INTERIOR SOLUTIONS PRIVATE LIMITED",
"BNK MANIFOLD SERVICES PRIVATE LIMITED",
"BNK POWER SOLUTION PRIVATE LIMITED",
"BNK SECURITIES PVT.LTD.",
"BNKM INDIA PRIVATE LIMITED",
"BNL AMMONIA PRIVATE LIMITED",
"BNL EXPRESS CARGO PRIVATE LIMITED",
"BNL LOGISTICS PRIVATE LIMITED",
"BNM CERA PRIVATE LIMITED",
"BNM GLOBAL VENTURES PRIVATE LIMITED",
"BNM INSTITUTE OF TECHNOLOGY",
"BNM ORGANICS PRIVATE LIMITED",
"BNN FOREX PRIVATE LIMITED",
"BNP ENGINEERING PROJECTS PRIVATE LIMITED",
"BNP INTERIORS",
"BNP PARIBAS",
"BNP PARIBAS GLOBAL SECURITIES OPERATIONS PRIVATE LIMITED",
"BNP PARIBAS INDIA FOUNDATION",
"BNP PARIBAS INDIA HOLDING PRIVATE LIMITED",
"BNP PARIBAS INDIA SOLUTIONS PRIVATE LIMITED",
"BNP PARIBAS SECURITIES INDIA PRIVATE LIMITED",
"BNP TRADE BIZ PRIVATE LIMITED",
"BNR CAPITAL SERVICES PRIVATE LIMITED",
"BNR INFRASTRUCTURE PROJECTS PRIVATE LIMITED",
"BNR TOWNSHIPS PRIVATE LIMITED",
"BNR UDYOG LIMITED",
"BNS SOFT PRIVATE LIMITED",
"BNSD SHIKSHA NIKETAN INTER COLLEGE",
"BNSE DESIGN SOLUTIONS PRIVATE LIMITED",
"BNSR INDUSTRIES LIMITED",
"BNT SOFT PRIVATE LIMITED",
"BNX SHIPPING PRIVATE LIMITED",
"BNY MELLON INTERNATIONAL OPERATIONS INDIA PRIVATE LIMITED",
"BNY MELLON TECHNOLOGY PRIVATE LIMITED",
"BOAN COMMUNICATIONS PRIVATE LIMITED",
"BOANG TECHNOLOGY PRIVATE LIMITED",
"BOARD OF APPRENTICESHIP TRAINING",
"BOARD OF SCHOOL EDUCATION HARYANA",
"BOARD OF SECONDARY EDUCATION MADHYA PRADESH BHOPAL",
"BOARD SOFTWARE (INDIA) PRIVATE LIMITED",
"BOARDPAC (PRIVATE) LIMITED",
"BOARDWALKTECH SOLUTIONS PRIVATE LIMITED",
"BOAST TRADERS PRIVATE LIMITED",
"BOAT CRAFT SERVICES PRIVATE LIMITED",
"BOATMAN TECH PRIVATE LIMITED",
"BOAZ PUBLIC SCHOOL",
"BOB CAPITAL MARKETS LIMITED",
"BOB CORRUGATING INDUSTRIES PRIVATE LIMITED",
"BOBCARD LIMITED",
"BOBBA AVIATION CARGO AND GROUND HANDLING SERVICES PRIVATE LIMITED",
"BOBBY MUKHERJEE ASSOCIATES PRIVATE LIMITED",
"BOBBY SUTHAR DESIGNS PRIVATE LIMITED",
"BOBBY TIKKIWALA INDIA PRIVATE LIMITED",
"BOBCAT VALUECHAIN PRIVATE LIMITED",
"BOBCAT VALUECHAIN SOLUTIONS PRIVATE LIMITED",
"BO-BEE HOSIERY PRIVATE LIMITED",
"BOB'S GYM LIMITED",
"BOBSHELL ELECTRODES LIMITED",
"BOBST INDIA PRIVATE LIMITED",
"BOC INDIA LIMITED",
"BODAL CHEMICALS LIMITED",
"BODDY CLOTHING APPAREL PRIVATE LIMITED",
"BODEGA RETAIL PRIVATE LIMITED",
"BODH PHARMA LLP",
"BODHI ART LIMITED",
"BODHI GLOBAL SERVICES PRIVATE LIMITED",
"BODHI HOSPITALITY & SPA PRIVATE LIMITED",
"BODHI HOTEL & RESORTS PRIVATE LIMITED",
"BODHI INTERNATIONAL SCHOOL",
"BODHI PROFESSIONAL SOLUTIONS PRIVATE LIMITED",
"BODHI TREE MULTIMEDIA LIMITED",
"BODHI WELLNESS CENTRE PRIVATE LIMITED",
"BODHISATVA ARTIFICIAL INTELLIGENCE PRIVATE LIMITED",
"BODHITREE TECHNOLOGIES PRIVATE LIMITED",
"BODHIVRIKSH VENTURE PRIVATE LIMITED",
"BODMAS TECHNOLOGIES PRIVATE LIMITED",
"BODO MOELLER CHEMIE INDIA PRIVATE LIMITED",
"BODOLAND TEA COMPANY PRIVATE LIMITED",
"BODOR LASER INDIA PRIVATE LIMITED",
"BODY BASICS RETAIL PRIVATE LIMITED",
"BODY CUPID PRIVATE LIMITED",
"BODY IN HARMONY INDIA PRIVATE LIMITED",
"BODYCARE CREATIONS LIMITED",
"BODYCARE DIAGNOSTIC CENTRE PRIVATE LIMITED",
"BODYCARE INTERNATIONAL LIMITED",
"BODYCRAFT SALON SKIN & COSMETOLOGY PRIVATE LIMITED",
"BODYGEAR INTERNATIONAL PRIVATE LIMITED",
"BODYLINE HOSPITALS PRIVATE LIMITED",
"BODYLINE IMPEX PRIVATE LIMITED",
"BODYPOWER FITNESS PRIVATE LIMITED",
"BODYRHYME APPARELS PRIVATE LIMITED",
"BODYSECRET CLOTHING PRIVATE LIMITED",
"BODYZONE FITNESS & SPA PRIVATE LIMITED",
"BOE INDIA PRIVATE LIMITED",
"BOEHRINGER INGELHEIM INDIA PRIVATE LIMITED",
"BOEING",
"BOEING INDIA DEFENSE PRIVATE LIMITED",
"BOEING INDIA PRIVATE LIMITED",
"BOETTCHER (INDIA) PRIVATE LIMITED",
"BOETTCHER INDIA PRIVATE LIMITED",
"BOFFIN BIOTECH PRIVATE LIMITED",
"BOFFIN CODERS PRIVATE LIMITED",
"BOFFIN IMPEX PRIVATE LIMITED",
"BOFNBROS HOSPITALITY PRIVATE LIMITED",
"BOG TRADING PRIVATE LIMITED",
"BOGANVILLA FURNISHING PRIVATE LIMITED",
"BOGE COMPRESSORS (INDIA) PRIVATE LIMITED",
"BOGHRA EDUCATION AND RESEARCH FOUNDATION",
"BOGHRA INFRASTRUCTURE LLP",
"BOGJHURIKHAN COLD STORAGE PRIVATE LIMITED",
"BOGMALLO ENTERPRISES PRIVATE LIMITED",
"BOHAGI TEA CO PVT LTD",
"BOHARA INFRASTRUCTURE PRIVATE LIMITED",
"BOHEMIA MARKETING SOLUTIONS PRIVATE LIMITED",
"BOHEMIAN HOSPITALITY PRIVATE LIMITED",
"BOHMIS INDUSTRIES PRIVATE LIMITED",
"BOHNIMAN TEA PRIVATE LIMITED",
"BOHOBOSS ENTERTAINMENT PRIVATE LIMITED",
"BOHRA AGRIFILMS PRIVATE LIMITED",
"BOHRA CARS PRIVATE. LIMITED",
"BOHRA CLOTHING PRIVATE LIMITED",
"BOHRA DIAGEM PRIVATE LIMITED",
"BOHRA EXPORTS PRIVATE LIMITED",
"BOHRA FASHIONS PRIVATE LIMITED",
"BOHRA IMPORTS PRIVATE LIMITED",
"BOHRA INDUSTRIAL RESOURCES PRIVATE LIMITED",
"BOHRA LIFESCIENCE PRIVATE LIMITED",
"BOHRA RUBBER PRIVATE LIMITED",
"BOHRA SALES & SERVICES LIMITED",
"BOHRA VEHICLES PRIVATE LIMITED",
"BOI MEDIA &ENTERTAINMENT PRIVATE LIMITED",
"BOI MERCHANT BANKERS LIMITED",
"BOI SHAREHOLDING LIMITED",
"BOIBAN BUSINESS PRIVATE LIMITED",
"BOILERNOVA HM INDIA PRIVATE LIMITED",
"BOILERTECH SYSTEMS PRIVATE LIMITED",
"BOINCHEE COLD STORAGE & INDUSTRIES PVT LTD",
"BOINGG KIDS PRIVATE LIMITED",
"BOIRON LABORATORIES PRIVATE LIMITED",
"BOISAR ELECTRICALS AND APPLIANCES LTD.",
"BOISUR CHEMICALS PRIVATE LIMITED",
"BOIX MACHINERY INDIA PRIVATE LIMITED",
"BOJARAJ TEXTILE MILLS LIMITED",
"BOKAHOLA TEA CO PRIVATE LIMITED",
"BOKAKHAT AGRO ORGANIC PRODUCER COMPANY LIMITED",
"BOKARIA REINFORCING COMPANY PRIVATE LIMITED",
"BOKARO LAMINATE PRIVATE LIMITED",
"BOKARO POWER SUPPLY COMPANY PRIVATE LIMITED",
"BOKARO STUDENTS FRIEND PRIVATE LIMITED",
"BOKCHOY AGRI HUB PRIVATE LIMITED",
"BOKHARA INDUSTRIES PRIVATE LIMITED",
"BOKHARA PALACE PRIVATE LIMITED",
"BOKITTA INDIA PRIVATE LIMITED",
"BOKITTA TRADING PRIVATE LIMITED",
"BOKS BUSINESS SERVICES PRIVATE LIMITED",
"BOKU NETWORK SERVICES IN PRIVATE LIMITED",
"BOL BUM CONSTRUCTIONS",
"BOLAS AGRO PRIVATE LIMITED",
"BOLAS INTELLI SOLUTIONS PRIVATE LIMITED",
"BOLD AND BEAUTIFUL STORE PRIVATE LIMITED",
"BOLD TECHNOLOGY SYSTEMS PRIVATE LIMITED",
"BOLDROCCHI INDIA PRIVATE LIMITED",
"BOLGATTY TECHNOLOGIES PRIVATE LIMITED",
"BOLGURU LEARNING PRIVATE LIMITED",
"BOLLAM SAMPATH KUMAR JEWELLERS PRIVATE LIMITED",
"BOLLFILTER INDIA PRIVATE LMITED",
"BOLLHOFF FASTENINGS PRIVATE LIMITED",
"BOLLINENI CASTINGS AND STEEL PRIVATE LIMITED",
"BOLLINENI DEVELOPERS LIMITED",
"BOLLINENI RAMANAIAH MEMORIAL HOSPITALS PRIVATE LIMITED",
"BOLLORE LOGISTICS INDIA LIMITED",
"BOLLORE LOGISTICS INDIA PRIVATE LIMITED",
"BOLLYBOOM INDIA PRIVATE LIMITED",
"BOLLYWOOD NEWS SERVICE PRIVATE LIMITED",
"BOLLYWOOD TIMES PRIVATE LIMITED",
"BOLORO INDIA PRIVATE LIMITED",
"BOLSTS INTERNATIONAL PRIVATE LIMITED",
"BOLT INNOVATIVE TRANSFORMATIONS INDIA PRIVATE LIMITED",
"BOLTCARGO (INDIA) PRIVATE LIMITED",
"BOLTECH ENGINEERING",
"BOLTON CONSULTING PRIVATE LIMITED",
"BOLTT GAMES PRIVATE LIMITED",
"BOLTTECH DEVICE PROTECTION INDIA PRIVATE LIMITED",
"BOLWINS WOMENS COLLEGE",
"BOLZEN AND MUTTER INDIA PRIVATE LIMITED",
"BOM IND COURIER PRIVATE LIMITED",
"BOMA INFRASTRUCTURE PRIVATE LIMITED",
"BOMAFA SPECIAL VALVE SOLUTIONS PRIVATE LIMITED",
"BOMAG INDIA PRIVATE LIMITED",
"BOMBARDIER AEROSPACE INDIA PRIVATE LIMITED",
"BOMBARDIER TRANSPORTATION INDIA PRIVATE LIMITED",
"BOMBAX COURIERS LLP",
"BOMBAY ACID PRIVATE LIMITED",
"BOMBAY AGENCY COMPANY PRIVATE LIMITED",
"BOMBAY AGRI EXPORT PRIVATE LIMITED",
"BOMBAY ALUMINIUM PRIVATE LIMITED",
"BOMBAY AMUSEMENT RIDES PRIVATE LIMITED",
"BOMBAY ANDHRA ROADWAYS PRIVATE LIMITED",
"BOMBAY BANARAS TRANSPORT COMPANY PRIVATE LIMITED",
"BOMBAY BARONS PRIVATE LIMITED",
"BOMBAY BEDDING PRIVATE LIMITED",
"BOMBAY BLOKES DIGITAL SOLUTIONS LLP",
"BOMBAY BORING WORKS PVT LTD",
"BOMBAY BROTHERS AUDIO VISUAL PRIVATE LIMITED",
"BOMBAY BURMAH TRADING CORPORATION LIMITED",
"BOMBAY CAMBRIDGE GURUKUL EDUCATION TRUST",
"BOMBAY CENTRAL ELECTRICAL DIVISION NO IV",
"BOMBAY CENTRAL ELECTRICAL DIVISION NO.III",
"BOMBAY CHAMBER OF COMMERCE AND INDUSTRY",
"BOMBAY CHARTERED ACCOUNTANTS SOCIETY",
"BOMBAY CHEMICALS PRIVATE LIMITED",
"BOMBAY CITY EYE INSTITUTE & RESEARCH",
"BOMBAY COATED AND SPECIAL STEELS PRIVATE LIMITED",
"BOMBAY COLLEGE OF PHARMACY",
"BOMBAY CONCRETE HOUSE PRIVATE LIMITED",
"BOMBAY CONSTRUCTION AND INFRAPROJECTS PRIVATE LIMITED",
"BOMBAY CREATIVE DISPLAY SOLUTIONS PRIVATE LIMITED",
"BOMBAY CRIMPERS P LIMITED",
"BOMBAY CYCLE AND MOTOR AGENCY LIMITED",
"BOMBAY DEALS PRIVATE LIMITED",
"BOMBAY DENTAL AND SURGICAL PRIVATE LIMITED",
"BOMBAY DESIGN CENTRE PRIVATE LIMITED",
"BOMBAY DUCK DINING COMPANY PRIVATE LIMITED",
"BOMBAY EDUCATION SOCIETY",
"BOMBAY ELECTRICAL PROJECTS AND SUPPLIES INDIA PRIVATE LIMITED",
"BOMBAY ENDOSCOPY ACADEMY AND CENTRE FOR MINIMALLY INVASIVE SURGERY AND RESEARCH COMPANY PVT LIMITED",
"BOMBAY ENGINEER GROUP AND CENTRE KIRKEE",
"BOMBAY ENGINEERING AND MOULDING WORKS PRIVATE LIMITED",
"BOMBAY EXPORT HOUSE PRIVATE LIMITED",
"BOMBAY FLUID SYSTEM COMPONENTS PRIVATE LIMITED",
"BOMBAY FLYING CLUB LIMITED",
"BOMBAY FRUITS AND VEGETABLES IMPORT EXPORT PRIVATE LIMITED",
"BOMBAY GAS COMPANY LIMITED",
"BOMBAY GUJRAT ROADLINES PRIVATE LIMITED",
"BOMBAY GYMKHANA LIMITED",
"BOMBAY HARDWARE PRIVATE LIMITED",
"BOMBAY HEMP COMPANY PRIVATE LIMITED",
"BOMBAY HIGHWAY CARRIERS PRIVATE LIMITED",
"BOMBAY HOSPITAL",
"BOMBAY INDUSTRIAL MARKETING PRIVATE LIMITED",
"BOMBAY INDUSTRIES ASSOCIATION",
"BOMBAY INTEGRATED ASSIGNMENT SOLUTIONS PRIVATE LIMITED",
"BOMBAY INTEGRATED SECURITY (INDIA) LIMITED",
"BOMBAY JCB EARTHMOVERS",
"BOMBAY JEWELLERY MANUFACTURERS",
"BOMBAY KANDLA TRANSPORT PRIVATE LIMITED",
"BOMBAY KUNSTSTOFF PHARMA SUPPLIES PRIVATE LIMITED",
"BOMBAY LAUNCH SERVICE PRIVATE LIMITED",
"BOMBAY LIFTWORKS PRIVATE LIMITED",
"BOMBAY MASALA COMPANY PRIVATE LIMITED",
"BOMBAY MASTER PRINTERS ASSOCIATION",
"BOMBAY MEDICO PRIVATE LIMITED",
"BOMBAY MEMONS EDUCATION SOCIETY FAROOQ PRIMARY SCHOOL",
"BOMBAY MERCANTILE CO OPERATIVE BANK LIMITED",
"BOMBAY METAL WORKS PVT LTD",
"BOMBAY METRICS SUPPLY CHAIN LIMITED",
"BOMBAY MINERALS LIMITED",
"BOMBAY NATURAL HISTORY SOCIETY",
"BOMBAY OXYGEN CORPORATION LIMITED",
"BOMBAY OXYGEN INVESTMENTS LIMITED",
"BOMBAY PARSI PANCHAYET",
"BOMBAY PERFUMERY PRODUCTS PVT LTD",
"BOMBAY PHARMA EQUIPMENTS PRIVATE LIMITED",
"BOMBAY PLAY ENTERTAINMENT PRIVATE LIMITED",
"BOMBAY PLAZA PVT LTD",
"BOMBAY PUBLIC SCHOOL",
"BOMBAY PUBLICITY SERVICE PRIVATE LIMITED",
"BOMBAY RAIPUR LOGITECH INDIA PRIVATE LIMITED",
"BOMBAY REAL ESTATE DEVELOPMENT CO PRIVATE LIMITED",
"BOMBAY ROHA ROADWAYS PRIVATE LIMITED",
"BOMBAY SCIENTIFIC STORES PRIVATE LIMITED",
"BOMBAY SCOOTER AND MOTOR CYCLE PRIVATE LIMITED",
"BOMBAY SCOTTISH ORPHANAGE SOCIETY",
"BOMBAY SCOTTISH SCHOOL",
"BOMBAY SEALINK BUILDERS PVT LTD",
"BOMBAY SECURITY SERVICES PRIVATE LIMITED",
"BOMBAY SELECTION PRIVATE LIMITED",
"BOMBAY STATIONERS PRIVATE LIMITED",
"BOMBAY STEREO PRIVATE LIMITED",
"BOMBAY STOCK EXCHANGE",
"BOMBAY STORE RETAIL COMPANY LIMITED",
"BOMBAY SUPER HYBRID SEEDS PRIVATE LIMITED",
"BOMBAY SWADESHI STORES LIMITED",
"BOMBAY TEST HOUSE PRIVATE LIMITED",
"BOMBAY TOOLS SUPPLYING AGENCY PRIVATE LIMITED",
"BOMBAY TRANSPOTRATION ELECTRICAL COMPONENTS PRIVATE LIMITED",
"BOMBAY WELL PRINT INKS PRIVATE.LIMITED",
"BOMBAYWALLA PURANPOLI PRIVATE LIMITED",
"BOMBAYWORKS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"BOMBINO EXPRESS PRIVATE LIMITED",
"BOMBINO TRAVELS & TOURS PRIVATE LIMITED",
"BOMMIDALA ENTERPRISES PRIVATE LIMITED",
"BOMMIDALA PACKAGINGS LIMITED",
"BOMMIDALA VENTURES PRIVATE LIMITED",
"BOMMU HERBALS PRIVATE LIMITED",
"BOMS PRIVATE LIMITED",
"BON ALUPLAST PVT. LTD.",
"BON APPETIT FOOD CHAIN PRIVATE LIMITED",
"BON CARGOS PRIVATE LIMITED",
"BON FRESH FOODS PRIVATE LIMITED",
"BON INDIA LIMITED",
"BON LON STEELS PRIVATE LIMITED",
"BON MASALA AND FOOD PRODUCTS",
"BON MOYAR (INDIA) PRIVATE LIMITED",
"BON MOYAR COMPUTERS PRIVATE LIMITED",
"BON SHIRTINGS PVT LTD",
"BON VIVANT LIFESTYLE PRIVATE LIMITED",
"BON VOYAGE TAVERN PRIVATE LIMITED",
"BONA SERA HOTELS LIMITED",
"BONACE ENGINEERS PRIVATE LIMITED",
"BONAFIDE ARTS PRIVATE LIMITED",
"BONAFIDE EXPORTS PRIVATE LIMITED",
"BONAGERI CROP SCIENCE LIMITED",
"BONAI INDUSTRIAL COMPANY LIMITED RUNGTA GROUP ENTITY",
"BONAIRE TRAVEL SERVICES PRIVATE LIMITED",
"BONAM VENKATA CHALAMAYYA INSTITUTE OF TECHNOLOGY AND SCIENCE",
"BONAMI SOFTWARE PRIVATE LIMITED",
"BONANZA CAPITAL MARKETS PRIVATE LIMITED",
"BONANZA ENTERPRISES",
"BONANZA HUMAN RESOURCE PRIVATE LIMITED",
"BONANZA INSURANCE BROKER PRIVATE LIMITED",
"BONANZA PORTFOLIO LIMITED",
"BONANZA TEXTILES PRIVATE LIMITED",
"BONANZA TRADING COMPANY PRIVATE LIMITED",
"BONANZO ENGINEERING AND CHEMICALS PRIVATE LIMITED",
"BONAS MARKETING INDIA PRIVATE LIMITED",
"BONATRANS INDIA PRIVATE LIMITED",
"BONAVEN SOFTWARE PRIVATE LIMITED",
"BONAVENTURE SHOES PRIVATE LIMITED",
"BONBLOC TECHNOLOGIES PRIVATE LIMITED",
"BOND BRAND LOYALTY INC",
"BOND REALTORS PRIVATE LIMITED",
"BOND STREET CAPITAL PRIVATE LIMITED",
"BONDADA ABODES PRIVATE LIMITED",
"BONDADA ECOBUILD PRIVATE LIMITED",
"BONDADA ENGINEERING LIMITED",
"BONDADA ENGINEERING PRIVATE LIMITED",
"BONDALAPATI MARKETING PRIVATE LIMITED",
"BONDED TEXTILES PRIVATE LIMITED",
"BONDEVALUE SOFTWARE LABS PRIVATE LIMITED",
"BONDFOREVER JEWELRY PRIVATE LIMITED",
"BONDIA FOOD AND AGRO PRODUCTS PRIVATE LIMITED",
"BONDIOLI & PAVESI INDIA PRIVATE LIMITED",
"BONDIT CONSTRUCTION CHEMICALS PRIVATE LIMITED",
"BONDLOK ADHESIVES PRIVATE LIMITED",
"BONDPRO FOAM INDUSTRIES PRIVATE LIMITED",
"BONDS LOGISTICS PRIVATE LIMITED",
"BONDWELL CORPORATE ADVISOR PRIVATE LIMITED",
"BONDWELL CORPS SOLUTIONS PRIVATE LIMITED",
"BONDWELL RESINS PVT LTD",
"BONE AND JOINT HOSPITAL AND RESEARCH CENTRE (JODHPUR) PRIVATE LIMITED",
"BONE AND JOINT SPINE HOSPITAL PRIVATE LIMITED",
"B-ONE BUSINESS HOUSE PRIVATE LIMITED",
"BONE MEALS INDIANA PRIVATE LIMITED",
"BONENG TRANSMISSION (INDIA) PRIVATE LIMITED",
"BONENG TRANSMISSION INDIA PRIVATE LIMITED",
"BONETECH MEDISYS PRIVATE LIMITED",
"BONFAB TEXTILES INDIA PRIVATE LIMITED",
"BONFIGLIOLI TRANSMISSION PRIVATE LIMITED",
"BONFIRESUPPLY LOGITECH PRIVATE LIMITED",
"BONFLEET SOLUTIONS PRIVATE LIMITED",
"BONGA HOSPITALITY PRIVATE LIMITED",
"BONGAIGAON CONCRETE INDUSTRIES PRIVATE LIMITED",
"BONGCHIE INDIA PRIVATE LIMITED",
"BONHEUR LABORATORY PRIVATE LIMITED",
"BONHOMIE PLASTICS PVT LTD",
"BONHOOGLY COLLEGE OF COMMERCE",
"BONIA INDUSTRIES PRIVATE LIMITED",
"BONICCI INDIA PRIVATE LIMITED",
"BONIE APPARELS PVT. LTD.",
"BONIE ENCLAVE PRIVATE LIMITED",
"BONITA FURNITURE PRIVATE LIMITED",
"BONITAS INFRASTRUCTURE PRIVATE LIMITED",
"BONITAS JEWELS PRIVATE LIMITED",
"BONITAS LIFE SCIENCES PRIVATE LIMITED",
"BONIZ EXIM PRIVATE LIMITED",
"BONJOUR BONHEUR PRIVATE LIMITED",
"BONJOUR HEALTH CARE PRIVATE LIMITED",
"BONLON INDUSTRIES LIMITED",
"BON-LON SECURITIES LIMITED",
"BONMART ENTERPRISES PRIVATE LIMITED",
"BONN NUTRIENTS PVT LTD",
"BONN SCHTERING BIO SCIENCES LLP",
"BONNA-AGELA INDIA PRIVATE LIMITED",
"BONNETERRE FOODS PRIVATE LIMITED",
"BONNEX GLOBAL LOGISTICS INDIA PRIVATE LIMITED",
"BONNY BABY CARE PRIVATE LIMITED",
"BONNY CREATION PRIVATE LIMITED",
"BONNY ENTERPRISES PRIVATE LIMITED",
"BONNY POLYPLAST PRIVATE LIMITED",
"BONNY PRODUCTS PRIVATE LIMITED",
"BONNYS NX",
"BONOBOZ MARKETING SERVICES PRIVATE LIMITED",
"BONORGANIK APPARELS PRIVATE LIMITED",
"BONPHUL AIR PRODUCTS PRIVATE LIMITED",
"BONS LIGHT PRIVATE LIMITED",
"BONSAI BABYCARE PRIVATE LIMITED",
"BONSAI ENTERPRISES PRIVATE LIMITED",
"BONSDAG INDUSTRIES PRIVATE LIMITED",
"BONTAZ AUTOMOTIVE INDIA PRIVATE LIMITED",
"BONTON CABLES INDIA PRIVATE LIMITED",
"BONTON HOLIDAYS PRIVATE LIMITED",
"BONTON PLASTICS PRIVATE LIMITED",
"BONTON TECHNOMAKE PVT LTD",
"BONTOUX NATURALS PRIVATE LIMITED",
"BONUM INDUSTRIES PRIVATE LIMITED",
"BONUS DESK PRIVATE LIMITED",
"BONUS PLASTICS PRIVATE LIMITED",
"BONUS SUITINGS PRIVATE LIMITED",
"BONVILLE FOODS PRIVATE LIMITED",
"BONVIVANT HOTELS PRIVATE LIMITED",
"BONY BUILDTEC PRIVATE LIMITED",
"BONY FLUID SYSTEMS PRIVATE LIMITED",
"BONY POLYMERS PRIVATE LIMITED",
"BONY SYSTEMS AND TECHNOLOGIES LIMITED",
"BONZA VITRIFIED PRIVATE LIMITED",
"BONZAI DIGITAL PRIVATE LIMITED",
"BONZER INTERIORS PRIVATE LIMITED",
"BONZO RESORTS LTD",
"BOOBOO GAMES PRIVATE LIMITED",
"BOOCH BEVERAGES PRIVATE LIMITED",
"BOODLE WEB MART TECHNOLOGY",
"BOOGOOK INDUSTRIES INDIA PRIVATE LIMITED",
"BOOJEE CAF√â",
"BOOK CHEAP FARE FLIGHTS PRIVATE LIMITED.",
"BOOK MAGIC INDIA PRIVATE LIMITED",
"BOOK MY AD PRIVATE LIMITED",
"BOOK MY DIAMOND PRIVATE LIMITED",
"BOOK MY FOREX PRIVATE LIMITED",
"BOOK SYNDICATE PVT LTD",
"BOOKAPROP ESTATES PRIVATE LIMITED",
"BOOKBYAIR (INDIA) PRIVATE LIMITED",
"BOOKCHOR LITERARY SOLUTIONS PRIVATE LIMITED",
"BOOKER INDIA LIMITED",
"BOOKER SATNAM WHOLESALE PRIVATE LIMITED",
"BOOKING COMISUPPORT & MARKETING SERVICE P LIMITED",
"BOOKING JUNCTION PRIVATE LIMITED",
"BOOKINGJINI LABS PRIVATE LIMITED",
"BOOKMYCARGO PRIVATE LIMITED",
"BOOKMYPARTS NETWORKS PRIVATE LIMITED",
"BOOKMYSHOW VENUES MANAGEMENT PRIVATE LIMITED",
"BOOKMYWISH E-COMMERCE PRIVATE LIMITED",
"BOOKNTRAVEL INDIA PRIVATE LIMITED",
"BOOKONSPOT TRAVEL SOLUTION PRIVATE LIMITED",
"BOOKS HARBOR PRIVATE LIMITED",
"BOOM CLOTHING PRIVATE LIMITED",
"BOOM FITNESS PRIVATE LIMITED",
"BOOM JNS PRIVATE LIMITED",
"BOOM ROOMS PRIVATE LIMITED",
"BOOM SYSTEMS PRIVATE. LIMITED",
"BOOM WORKS COMMUNICATIONS INDIA PRIVATE LIMITED",
"BOOMERANG MEDIA PRIVATE LIMITED",
"BOOMERANG SOFT PRIVATE LIMITED",
"BOOMI SOFTWARE INDIA PRIVATE LIMITED",
"BOON CASTLE MEDIA AND ENTERTAINMENT PRIVATE LIMITED",
"BOON DISPLAY PRIVATE LIMITED",
"BOON DISTRIBUTION PRIVATE LIMITED",
"BOON EDAM ENTRANCE TECHNOLOGY INDIA PRIVATE LIMITED",
"BOON ELECTRIC PRIVATE LIMITED",
"BOON INVESTMENT AND TRADING COMPANY PRIVATE LIMITED",
"BOON MAA MEDICAL SERVICES LLP",
"BOON SEEDS (INDIA) PRIVATE LIMITED",
"BOOND ENGINEERING AND DEVELOPMENT PRIVATE LIMITED",
"BOOND MULTIFOODS PROCESSING PRIVATE LIMITED",
"BOONE COMENOR METALIMPEX RECYCLING INDIA PRIVATE LIMITED",
"BOONZE MEDIA SOLUTIONS PRIVATE LIMITED",
"BOORTMALT INDIA HOLDINGS PRIVATE LIMITED",
"BOORUGU INFRA PROJECTS PRIVATE LIMITED",
"BOOST AUTOMOBILES INDIA PRIVATE LIMITED",
"BOOST MARKETING PRIVATE LIMITED",
"BOOSTER PLANT GENETICS PRIVATE LIMITED",
"BOOSTERZZ MARKETING PRIVATE LIMITED",
"BOOT EXPORTS (BOMBAY) PVT LTD",
"BOOTES IMPEX TECH PRIVATE LIMITED",
"BOOTMINDS SYSTEMS PRIVATE LIMITED",
"BOOTS HEALTHCARE PRIVATE LIMITED",
"BOOTS LIFESCIENCES LIMITED",
"BOOTSTART SPACES & HOSPITALITY PRIVATE LIMITED",
"BOP CONSULTANTS PRIVATE LIMITED",
"BOP REALTY PRIVATE LIMITED",
"BOPAL ICU AND TRAUMA CENTER",
"BOPAL MULTISPECIALITY HOSPITAL PRIVATE LIMITED",
"BOPARAI GASES PVT LTD",
"BOPARAI METALS PVT LTD",
"BOPARAI'S MARTIAL SECURITY PRIVATE LIMITED",
"BOPPANA GLOBAL CIVIL CONSTRUCTIONS PRIVATE LIMITED",
"BOPPO TECHNOLOGIES PRIVATE LIMITED",
"BOPPUDI COLD STORAGE PRIVATE LIMITED",
"BOPPUDI ENTERPRISES (INDIA) LIMITED",
"BOPPUDI LOGISTICS & SHIPPING INDIA PRIVATE LIMITED",
"BOPPUDI REFRACTORIES PVT LTD",
"BORA AGRO FOODS",
"BORA FOODS PRIVATE LIMITED",
"BORA HOUSING PRIVATE LIMITED",
"BORA KNITWEAR PRIVATE LTD",
"BORA PHARMA PRIVATE LIMITED",
"BORA POLYCLINIC LTD",
"BORAH AB AUTOMOBILES PRIVATE LIMITED",
"BORAH AGENCIES PRIVATE LIMITED",
"BORAH AUTOMOBILES PRIVATE LIMITED",
"BORAH BROTHERS PRIVATE. LIMITED.",
"BORAH MOTORS PRIVATE LIMITED",
"BORAH TRIAKHYA PRIVATE LIMITED",
"BORAJ INFRASTRUCTURES PRIVATE LIMITED",
"BORAL HIGH SCHOOL HS",
"BORANA DIAM PRIVATE LIMITED",
"BORANA FILAMENTS PRIVATE LIMITED",
"BORANA IMPEX PRIVATE LIMITED",
"BORANA PLASTIC LIMITED",
"BORANA WEAVES PRIVATE LIMITED",
"BORANADA INTERNATIONAL PRIVATE LIMITED",
"BORASTE AGRO INDUSTRIES PRIVATE LIMITED",
"BORAX CHEMI-ALLIANCE PRIVATE LIMITED",
"BORAX MORARJI LIMITED",
"BORBAM INVESTMENTS LIMITED",
"BORDA FABRICS PRIVATE LIMITED",
"BORDER SECURITY FORCE",
"BORDERFREE TECHNOLOGIES PRIVATE LIMITED",
"BORDERLESS ACCESS PANELS PRIVATE LIMITED",
"BORDERLESS ACCESS PRIVATE LIMITED",
"BORDERLESSMIND TECHNOLOGIES PRIVATE LIMITED",
"BOREALIS TRADING PRIVATE LIMITED",
"BOREK IT SOURCING PRIVATE LIMITED",
"BORGANG TEA COMPANY PRIVATE LIMITED",
"BORGAON WATAMBARE HIGHWAYS PRIVATE LIMITED",
"BORGES INDIA P LIMITED",
"BORGHI BRUSH MACHINERY PRIVATE LIMITED",
"BORGOHAIN ENTERPRISES PRIVATE LIMITED",
"BORGWARD AUTOMOTIVE INDIA PRIVATE LIMITED",
"BORGWARNER COOLING SYSTEMS (INDIA) PRIVATE LIMITED",
"BORGWARNER EMISSIONS SYSTEMS INDIA PRIVATE LIMITED",
"BORGWARNER EMISSIONS TALEGAON PRIVATE LIMITED",
"BORGWARNER INDIA PRIVATE LIMITED",
"BORGWARNER MORSE SYSTEMS PRIVATE LIMITED",
"BORING BRANDS PRIVATE LIMITED",
"BORIVATE TRADING PRIVATE LIMITED",
"BORKAR PACKAGING PRIVATE LIMITED",
"BORKAR SURAKSHA PACKAGING PRIVATE LIMITED",
"BORKAR TRADING COMPANY PRIVATE LIMITED",
"BORLAUG INSTITUTE FOR SOUTH ASIA",
"BORLUHIT FTTP SERVICE (OPC) PRIVATE LIMITED",
"BORLUIT BEVERAGES PRIVATE LIMITED",
"BORLUIT TEA PRIVATE LIMITED",
"BORM BRUCKMEIER INFOTECH INDIA PRIVATE LIMITED",
"BORN BABIES INDIA PRIVATE LIMITED",
"BORN COMMERCE PRIVATE LIMITED",
"BORN DIFFERENT INTERNATIONAL PRIVATE LIMITED",
"BORN ENGINEERING SERVICES PRIVATE LIMITED",
"BORN HEALTHCARE PRIVATE LIMITED",
"BORN HIGH DIGITAL PRIVATE LIMITED",
"BORN NATURAL AGRO PRIVATE LIMITED",
"BORN TECHIES PRIVATE LIMITED",
"BORNEO MOTHER AND CHILD CARE HOSPITAL",
"BORNFIRE INNOVATIONS PRIVATE LIMITED",
"BORNFREE FASHIONS PRIVATE LIMITED",
"BORNSEC CONSULTING LLP",
"BOROCHEMIE (INDIA) PRIVATE LIMITED",
"BOROSIL GLASS WORKS LIMITED",
"BOROSIL LIMITED",
"BOROSIL RENEWABLES LIMITED",
"BOROUGE (INDIA ) PRIVATE LIMITED",
"BORPAMBALICHANG TEA PRODUCER COMPANY LIMITED",
"BORQS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"BORRA AUTO MARKETING PRIVATE LIMITED",
"BORREGAARD SOUTH ASIA PRIVATE LIMITED",
"BORRI POWER INDIA PRIVATE LIMITED",
"BORSAD TOBACCO COMPANY PRIVATE LIMITED",
"BORSE BROTHERS ENGINEERS AND CONTRACTORS PRIVATE LIMITED",
"BORSOLA TEA COMPANY PRIVATE LIMITED",
"BORSONS FACILITY SOLUTIONS PRIVATE LIMITED",
"BORTEX TRACOM PVT LTD",
"BORUAH AND BORUAH TEA & TRADING PRIVATE LIMITED",
"BORUNDA MINERALS PRIVATE LIMITED",
"BORZE HEAGER INDIA PRIVATE LIMITED",
"BORZE INDIA PRIVATE LIMITED",
"BOS NATURAL FLAVORS PRIVATE LIMITED",
"BOSCH AUTO MOTIVE ELECTRONIC INDIA LIMITED",
"BOSCH CHASSIS SYSTEMS INDIA PRIVATE LIMITED",
"BOSCH ELECTRICAL DRIVES INDIA PRIVATE LIMITED",
"BOSCH GLOBAL SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"BOSCH LIMITED",
"BOSCH REXROTH INDIA PRIVATE LIMITED",
"BOSCO GRAMIN VIKAS KENDRA",
"BOSE BUILDING MATERIALS AND PREFAB HOUSES PRIVATE LIMITED",
"BOSE CORPORATION INDIA PRIVATE LIMITED",
"BOSE ENGINEERING (INDIA) PRIVATE LIMITED",
"BOSE EYE MICROSURGERY AND LASER CENTRE PRIVATE LIMITED",
"BOSE FOOT FASHIONS PRIVATE LIMITED",
"BOSE MARKETING SERVICES PRIVATE LIMITED",
"BOSE RESEARCH PRIVATE LIMITED",
"BOSE SOFTWARE SERVICES PRIVATE LIMITED",
"BOSHAN DEVELOPERS PRIVATE LIMITED",
"BOSHI TEL INDIA PRIVATE LIMITED",
"BOSHION SERVICES PRIVATE LIMITED",
"BOSKY MART LIMITED",
"BOSLEO TECHNOLOGY PRIVATE LIMITED",
"BOSON INFRA INDIA PRIVATE LIMITED",
"BOSON MOTORS PRIVATE LIMITED",
"BOSON POWER INDIA PRIVATE LIMITED",
"BOSS AGRO CHEMICALS PRIVATE LIMITED",
"BOSS APPLIANCES LLP",
"BOSS COMPUTERS PRIVATE LIMITED",
"BOSS GEARS LIMITED",
"BOSS INFRASTRUCTURES PRIVATE LIMITED",
"BOSS MANAGEMENT SERVICES PRIVATE LIMITED",
"BOSS OF INTELLIGENT SOLUTIONS PRIVATE LIMITED",
"BOSS PACKAGING SOLUTIONS LIMITED",
"BOSS PACKAGING SOLUTIONS PRIVATE LIMITED",
"BOSS REAL ESTATE PRIVATE LIMITED",
"BOSS STAFFING SOLUTIONS (INDIA) PRIVATE LIMITED",
"BOSS TECH RICE AND AGRO PRIVATE LIMITED",
"BOSS TECHNICAL SERVICES PRIVATE LIMITED",
"BOSS TECHNOCAST PRIVATE LIMITED",
"BOSS WEBTECH PRIVATE LIMITED",
"BOSSAN PRIVATE LIMITED",
"BOSSAR PACKAGING PRIVATE LIMITED",
"BOSSCO STEEL INDUSTRIES PRIVATE LIMITED",
"BOSSCODER SOFTWARE SERVICES PRIVATE LIMITED",
"BOSSH TECHNOLOGY INDIA LIMITED",
"BOSTIK INDIA PRIVATE LIMITED",
"BOSTIN ENGINEERS PVT LTD",
"BOSTON BRIAN AND SPINE CARE",
"BOSTON BUSINESS SOLUTIONS PRIVATE LIMITED",
"BOSTON BYTE SOFTWARE PRIVATE LIMITED",
"BOSTON CREST PRIVATE LIMITED",
"BOSTON FINANCIAL ADVISORY SERVICES PRIVATE LIMITED",
"BOSTON HARBOR TECHNOLOGY PRIVATE LIMITED",
"BOSTON IT SOLUTIONS(INDIA) PRIVATE LIMITED",
"BOSTON MATRIX LOGISTICS PRIVATE LIMITED",
"BOSTON SCIENTIFIC CORPORATION",
"BOSTON SCIENTIFIC INDIA PRIVATE LIMITED",
"BOSTON SCIENTIFIC SERVICES PRIVATE LIMITED",
"BOSTON SCIENTIFIC TECHNOLOGY & ENGINEERING SERVICES PRIVATE LIMITED",
"BOSTON SOFTWARE CONSULTANTS INDIA PRIVATE. LIMITED.",
"BOSTONLOGIX (INDIA) PRIVATE LIMITED",
"BOSTONLOGIX TECHNOLOGIES (INDIA) LLP",
"BOT AI ML PRIVATE LIMITED",
"BOT IT SERVICES PRIVATE LIMITED",
"BOT ORGANIC PRIVATE LIMITED",
"BOT VFX INDIA PRIVATE LIMITED",
"BOTANIC HEALTHCARE PRIVATE LIMITED",
"BOTANICAL RESOURCES INDIA PRIVATE LIMITED",
"BOTANICAL SURVEY OF INDIA",
"BOTANICOIR INDIA PRIVATE LIMITED",
"BOTCO PARTS PRIVATE LIMITED",
"BOTCODE TECHNOLOGIES LLP",
"BOTCODE WEB INTEGRATION SOLUTIONS PRIVATE LIMITED",
"BOTG SOLUTIONS PRIVATE LIMITED",
"BOTHARA AGRO EQUIPMENTS PRIVATE LIMITED",
"BOTHE WINDFARM DEVELOPMENT PRIVATE LIMITED",
"BOTHRA AND BAGMAR JEWELLERS PRIVATE LIMITED",
"BOTHRA CAPITAL PRIVATE LIMITED",
"BOTHRA PLASTIC INDUSTRIES PRIVATE LIMITED",
"BOTHRA POLY FILMS PRIVATE LIMITED",
"BOTHRA ROAD LINES PVT LTD",
"BOTHRA SHIPPING SERVICES PRIVATE LIMITED",
"BOTHRA TRADING PRIVATE LIMITED",
"BOTHRA VARIANT PRIVATE LIMITED",
"BOTICS INDUSTRIES PRIVATE LIMITED",
"BOTIL OIL TOOLS INDIA PRIVATE LIMITED",
"BOTLAB DYNAMICS PRIVATE LIMITED",
"BOTMINDS AI TECHNOLOGIES PRIVATE LIMITED",
"BOTREE SOFTWARE INTERNATIONAL PRIVATE LIMITED",
"BOTS CYCLING PRIVATE LIMITED",
"BOTSYNC TECHNOLOGIES PRIVATE LIMITED",
"BOTTLE LAB TECHNOLOGIES PRIVATE LIMITED",
"BOTTLE OPENERS DIGITAL SOLUTIONS PRIVATE LIMITED",
"BOTTMAC INDIA PRIVATE LIMITED",
"BOTTOM LINE MEDIA PRIVATE LIMITED",
"BOTTOMLINE LANGUAGE SOLUTIONS PRIVATE LIMITED",
"BOUDH DISTILLERY PRIVATE LIMITED",
"BOUDHA INFRA VENTURES PRIVATE LIMITED",
"BOUGAIN VILIA ESTATES PRIVATE LIMITED",
"BOUGAINVILLEA MULTIPLEX & ENTERTAINMENT CENTER PRIVATE LIMITED",
"BOUGH CONSULTING (INDIA) PRIVATE LIMITED",
"BOULDER ESTATES PRIVATE LIMITED",
"BOULDER STONE MART PRIVATE LIMITED",
"BOULEVARDS STEEL PRIVATE LIMITED",
"BOULTON SECURITIES LIMITED",
"BOUNCE BOARD CONSULTANTS PRIVATE LIMITED",
"BOUNCE COMMUNICATION & DESIGN PRIVATE LIMITED",
"BOUNDSCRIPT MOTION PICTURES PRIVATE LIMITED",
"BOUNTEOUS BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"BOUNTEOUS DIGITAL PRIVATE LIMITED",
"BOUNTIFUL LIFESCIENCES PRIVATE LIMITED",
"BOURBON SCIENCE PRIVATE LIMITED",
"BOURGAULT ENTERPRISE SOLUTIONS LLP",
"BOURKE CONSOLIDATED INDIA PRIVATE LIMITED",
"BOURN HALL INTERNATIONAL INDIA PRIVATE LIMITED",
"BOURNTEC GLOBAL SOFTWARE CAPABILITY CENTRE PRIVATE LIMITED",
"BOURNTEC SOLUTIONS PRIVATE LIMITED",
"BOUTIQAAT SERVICES PRIVATE LIMITED",
"BOUTIQUE FASHIONS PRIVATE LIMITED",
"BOUTIQUE FOREX PRIVATE LIMITED",
"BOUTIQUE INDIA OVERSEAS PRIVATE LIMITED",
"BOUTIQUE INTERNATIONAL P LIMITED",
"BOUTIQUE SPIRIT BRANDS PRIVATE LIMITED",
"BOUTIQUES ASIA PRIVATE LIMITED",
"BOUYGUES CONSTRUCTION INDIA BUILDING PROJECTS LLP",
"BOVEN TECHNOLOGIES PRIVATE LIMITED",
"BOVIAN PHARMA PRIVATE LIMITED",
"BOVICURE PHARMA PRIVATE LIMITED",
"BOVILLA HEALTHCARE PRIVATE LIMITED",
"BOVISO ANIMAL HEALTH PRIVATE LIMITED",
"BOW BRAND COMMUNICATIONS PRIVATE LIMITED",
"BOW CHICKA WOW WOW FILMS PRIVATE LIMITED",
"BOW LOGISTICS PRIVATE LIMITED",
"BOWERGROUPASIA INDIA PRIVATE LIMITED",
"BOWHEAD INVESTMENT ADVISORS PRIVATE LIMITED",
"BOWLING MACHINES AND GAMES PRIVATE LIMITED",
"BOWLOPEDIA RESTAURANTS INDIA PRIVATE LIMITED",
"BOWMAN & ARCHER PHARMA MACHINES INDIA PRIVATE LIMITED",
"BOWMAN FISCAL SERVICES PVT LTD",
"BOWREAH JUTE MILLS PRIVATE LIMITED",
"BOX AND CARTON INDIA PRIVATE LIMITED",
"BOX CARE LOGISTICS SOLUTION PRIVATE LIMITED",
"BOX CINEMEDIA SERVICES PRIVATE LIMITED",
"BOX CORNER PRIVATE LIMITED",
"BOX CRAFT (INDIA) PRIVATE LIMITED",
"BOX FREIGHT FORWARDING PRIVATE LIMITED",
"BOX INVESTMENT ADVISORS PRIVATE LIMITED",
"BOX LOGY PRIVATE LIMITED",
"BOX MANIA PRIVATE LIMITED",
"BOX -O- PRINT PRIVATE LIMITED",
"BOX STAR LOGISTICS PRIVATE LIMITED",
"BOX4 ANALYTICS PRIVATE LIMITED",
"BOXCO LOGISTICS INDIA PRIVATE LIMITED",
"BOXCO SHIPPING SERVICES PRIVATE LIMITED",
"BOXCOWORLD LOGISTICS INDIA PRIVATE LIMITED",
"BOXINAGAR FREE PRIMARY SCHOOL",
"BOXIT PACKAGING LLP",
"BOXKRAFT PACKAGERS PVT LTD",
"BOXMAN (INDIA) PRIVATE LIMITED",
"BOXMAN LOGISTICS PRIVATE LIMITED",
"BOXMOOR SHIPPING PRIVATE LIMITED",
"BOXNSIGHTS SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"BOXPICK PACKAGING PRIVATE LIMITED",
"BOXPLANK PRIVATE LIMITED",
"BOXSMART SHIPPING PRIVATE LIMITED",
"BOXSMITHS PRIVATE LIMITED",
"BOXTRON INTERNATIONAL PRIVATE LIMITED",
"BOXWELL PACKTECH PRIVATE LIMITED",
"BOY LONDON CLOTHING PRIVATE LIMITED",
"BOYANCE INFRASTRUCTURE PRIVATE LIMITED",
"BOYCE RUBBER ESTATES PRIVATE LIMITED",
"BOYD AND MOORE EXECUTIVE SEARCH INDIA PRIVATE LIMITED",
"BOYD SMITHS PVT LTD",
"BOYD THERMAL SYSTEMS INDIA PRIVATE LIMITED",
"BOYECKI TRADE RESOURCES PRIVATE LIMITED",
"BOYEN HADDIN CONSULTING AND TECHNOLOGY PRIVATE LIMITED",
"BOYINA SOFTCON OPC PRIVATE LIMITED",
"BOYS & MACHINES PRIVATE LIMITED",
"BOYS HIGH SCHOOL AND COLLEGE",
"BOYS TOWN PUBLIC SCHOOL",
"BOYSEN EXHAUST SYSTEMS PUNE PRIVATE LIMITED",
"BOYSEN INDIA LIMITED",
"BOYSEN INDIA PRIVATE LIMITED",
"BOYYS INDUSTRIES PRIVATE LIMITED",
"BOYZONE FOOTCARE INDIA PRIVATE LIMITED",
"BOYZONE POLYMERS INDIA PRIVATE LIMITED",
"BOZZLER ENERGY PRIVATE LIMITED",
"BP AUTOMOBILES LLP",
"BP BUSINESS SOLUTIONS INDIA PRIVATE LIMITED",
"BP COMTRADE PRIVATE LIMITED",
"BP CONSTRUCTIONS AND ENGINEERS PRIVATE LIMITED",
"BP EQUITIES PRIVATE LIMITED",
"BP EXPLORATION ALPHA LIMITED",
"BP FOOTWEAR PRIVATE LIMITED",
"BP HOMES PRIVATE LIMITED",
"BP IMPEX",
"BP INDIA PRIVATE LIMITED",
"BP INDIA SERVICES PRIVATE LIMITED",
"BP LUBRICANTS PRIVATE LIMITED",
"BP METAL PACKS PRIVATE LIMITED",
"BP PODDAR HOSPITAL",
"BP PUMPS PRIVATE LIMITED",
"BPA BUILDERS & DEVELOPERS",
"BPA ENGINEERING EQUIPMENTS PRIVATE LIMITED",
"BPA PROJECTS PRIVATE LIMITED",
"BPA TECHNOLOGIES PRIVATE LIMITED",
"BPBR HOSPITALS PRIVATE LIMITED",
"BPC CONSULTANT INDIA PRIVATE LIMITED",
"BPC PROJECTS AND INFRASTRUCTURE PRIVATE LIMITED",
"BPCL-KIAL FUEL FARM PRIVATE LIMITED",
"BPCSPACIFIC SPECIALITY PETROCHEMICALS PRIVATE LIMITED",
"BPD STEEL SYNDICATE PRIVATE LIMITED",
"BPD VENTURES PRIVATE LIMITED",
"BPDM POWER PROJECTS PRIVATE LIMITED",
"BPE BIOTREE INDIA PRIVATE LIMITED",
"BPE ELECTRONIC SERVICES PRIVATE LIMITED",
"BPE INNOVATIONS PRIVATE LIMITED",
"BPE TECHNOLOGY INDIA PRIVATE LIMITED",
"BPEA ADVISORS PRIVATE LIMITED",
"BPEA INVESTMENT MANAGERS PRIVATE LIMITED",
"BPEA SERVICES PRIVATE LIMITED",
"BPG AQUATECH ENGINEERS PRIVATE LIMITED",
"BPG FARMERS PRODUCER COMPANY LIMITED",
"BPGM INSURANCE SOLUTIONS",
"BPHES SOCIETY AHMEDNAGAR",
"BPI (INDIA) PRIVATE LIMITED",
"BPIN PRIVATE LIMITED",
"BPK TECH SERVICES INDIA PRIVATE LIMITED",
"BPL LIMITED",
"BPL MEDIA LIMITED",
"BPL MEDICAL TECHNOLOGIES PRIVATE LIMITED",
"BPL TELECOM PRIVATE LIMITED",
"B-PLAST PACKAGING PRIVATE LIMITED",
"BPLUGD IOT PRIVATE LIMITED",
"BPLUS HOSPITALITY PRIVATE LIMITED",
"BPMLINKS SOLUTIONS PRIVATE LIMITED",
"BPMV BUSINESS SOLUTION PRIVATE LIMITED",
"BPN MOTORS PRIVATE LIMITED",
"BPO CONNECTINDIA PRIVATE LIMITED",
"BPO CONVERGENCE PRIVATE LIMITED",
"BPO INTEGRA INDIA PRIVATE LIMITED",
"BPO SUPPLY CHAIN MANAGEMENT PRIVATE LIMITED",
"BPOSITIVE TRADEX PRIVATE LIMITED",
"BPR BRASSICA PRIVATE LIMITED",
"BPR INFRASTRUCTURE PRIVATE LIMITED",
"BPR TEX PRINTS PRIVATE LIMITED",
"BPREX PHARMA PACKAGING INDIA PRIVATE LIMITED",
"BPS ANALYTICS PRIVATE LIMITED",
"BPS BUILDING PROTECTION SYSTEMS PRIVATE LIMITED",
"BPS BUSINESS SOLUTIONS PRIVATE LIMITED",
"BPS INTERNATIONAL PRIVATE LIMITED",
"BPS MAHILA VISHWAVIDYALAYA",
"BPS OVERSEAS PRIVATE LIMITED",
"BPS STRUCTURES PRIVATE LIMITED",
"BPSC INFRA PROJECTS PRIVATE LIMITED",
"BPSC PRE UNIVERSITY COLLEGE BELLARY",
"BPT INFRA PROJECTS PRIVATE LIMITED",
"BPT SALES & SERVICES PRIVATE LIMITED",
"BPTP INTERNATIONAL TRADE CENTRE LIMITED",
"BPTP LIMITED",
"BPTP PARKLANDS PRIDE LIMITED",
"BPW TRAILER SYSTEMS INDIA PRIVATE LIMITED",
"BQ INDIA PRIVATE LIMITED",
"BQ TECHNOLOGIES PRIVATE LIMITED",
"BQC ASSESSMENT PRIVATE LIMITED",
"BR BIOCHEM LIFE SCIENCES PRIVATE LIMITED",
"BR BIOMEDICAL PRIVATE LIMITED",
"BR COTTFAB PRIVATE LIMITED",
"BR DESIGNS PRIVATE LIMITED",
"BR FINE CARTONS PRIVATE LIMITED",
"BR GAUTAM POLYTECHNIC INSTITUTE",
"BR GREEN INDUSTRIES PRIVATE LIMITED",
"BR HANDS INVESTMENTS PRIVATE LIMITED",
"BR HARDWARE INDIA PRIVATE LIMITED",
"BR IMEX (INDIA) PRIVATE LIMITED",
"BR INTERNATIONAL SCHOOL",
"BR JEWELS PRIVATE LIMITED",
"BR MEP ENGINEERS PRIVATE LIMITED",
"BR RAYSOFT TECH PRIVATE LIMITED",
"BR RETAIL INDIA PRIVATE LIMITED",
"BR SINGH HOSPITAL SEALDAH",
"BR SOFTWARE SERVICES PRIVATE LIMITED",
"BR STEEL & POWER PRIVATE LIMITED",
"BR TEXTILES PRIVATE LIMITED",
"BR WAREHOUSING PRIVATE LIMITED",
"BR WHITE GOLD INTERNATIONAL PRIVATE LIMITED",
"BRAAHMAM NET SOLUTIONS PRIVATE LIMITED",
"BRAASH LOGISTICS PRIVATE LIMITED",
"BRAASH SHIPPING PRIVATE LIMITED",
"BRABOURNE COMMERCE PVT LTD",
"BRABUS RETAIL TRADERS PRIVATE LIMITED",
"BRACE INFRASTRUCTURE PRIVATE LIMITED",
"BRACE IRON & STEEL PRIVATE LIMITED",
"BRACE PORT LOGISTICS LIMITED",
"BRACES AND PERFECT DENTAL CARE PRIVATE LIMITED",
"BRACIALETO PRIVATE LIMITED",
"BRACING PHARMACEUTICAL PRIVATE LIMITED",
"BRACKISH INDUSTRIES PRIVATE LIMITED",
"BRACKISH MARKETING PRIVATE LIMITED",
"BRACO BUILDERS",
"BRACO ELECTRICALS INDIA PRIVATE LIMITED",
"BRAD AUTOMOTIVE PRIVATE LIMITED",
"BRAD CONTECH SOLUTIONS PRIVATE LIMITED",
"BRADBURY SPG & WVG MILLS LIMITED",
"BRADFORD AVIATION ACADEMY",
"BRADKEN INDIA PRIVATE LIMITED",
"BRADVIP INDUSTRIAL MARKETINGS PRIVATE LIMITED",
"BRADY COMPANY INDIA PRIVATE LIMITED",
"BRADY SERVICES PRIVATE LIMITED",
"BRAEMAR ACM SHIPBROKING INDIA PRIVATE LIMITED",
"BRAGA INDUSTRIES LLP",
"BRAGANZA AND FULARI VENTURES PRIVATE LIMITED",
"BRAHAM DISTRIBUTORS PRIVATE LIMITED",
"BRAHAM HOSIERY PRIVATE LIMITED",
"BRAHAM SHAKTI HOSPITAL",
"BRAHAMBANANDA KESHOBCHANDRA COLLEGE",
"BRAHAMPURI STEELS LIMITED",
"BRAHAMPUTRA CARGO CARRIERS PRIVATE LIMITED",
"BRAHANS POLYMERS PRIVATE LIMITED",
"BRAHASPATI REAL ESTATE PRIVATE LIMITED",
"BRAHM ARPAN ORGANIC PRIVATE LIMITED",
"BRAHM ART PACKERS PRIVATE LIMITED",
"BRAHM CHAITANYA SUPER SPECIALITY HOSPITAL",
"BRAHM DATT INVESTMENTS & FINANCE CO PVT LTD",
"BRAHM PRAKASH DAV SCHOOL",
"BRAHM PRECISION MATERIALS PRIVATE LIMITED",
"BRAHM ROBOTICS PRIVATE LIMITED",
"BRAHM SHAKTI SANJIVANI SUPER SPECIALITY HOSPITAL",
"BRAHM WORKS PRIVATE LIMITED",
"BRAHMA AGROTECH PRIVATE LIMITED",
"BRAHMA AUTO INDUSTRIES PRIVATE LIMITED",
"BRAHMA CENTER DEVELOPMENT PRIVATE LIMITED",
"BRAHMA CITY PRIVATE LIMITED",
"BRAHMA DEV HOLDING AND TRADING LIMITED",
"BRAHMA ENTERPRISES PRIVATE LIMITED",
"BRAHMA FOAM INDUSTRIES PRIVATE LIMITED",
"BRAHMA GARDEN HOTELS AND RESORTS PRIVATE LIMITED",
"BRAHMA INDUSTRIES PRIVATE LIMITED",
"BRAHMA PRINTPACK PRIVATE LIMITED",
"BRAHMA REALTY PRIVATE LIMITED",
"BRAHMA REFRACTORIES PRIVATE LIMITED",
"BRAHMACHAITANYA CHITS PRIVATE LIMITED",
"BRAHMACHAITANYA FOOD PRODUCTS PRIVATE LIMITED",
"BRAHMADANDA HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"BRAHMADANDA IMAGING AND DIAGNOSTICS PRIVATE LIMITED",
"BRAHMADEODADA MANE SAHAKARI BANK¬†LTD",
"BRAHMAGIRI HOLIDAYS PRIVATE LIMITED",
"BRAHMAIAH AGRO FOODS PRIVATE LIMITED",
"BRAHMANAND COLLEGE KANPUR",
"BRAHMANANDA EDUCATIONAL SERVICES PRIVATE LIMITED",
"BRAHMANI DEVELOPERS PRIVATE. LIMITED.",
"BRAHMANI EVENTS AND EXHIBITIONS PRIVATE LIMITED",
"BRAHMANI INFRACON PRIVATE LIMITED",
"BRAHMANI INFRATECH PRIVATE LIMITED",
"BRAHMANI RIVER PELLETS LIMITED",
"BRAHMANI SILK MANUFACTURING PRIVATE LIMITED",
"BRAHMAPUTRA AGRO INDUSTRIES",
"BRAHMAPUTRA AUTOMOBILES PRIVATE LIMITED",
"BRAHMAPUTRA BIOCHEM BOTTLING PRIVATE LIMITED",
"BRAHMAPUTRA BIOCHEM PRIVATE LIMITED",
"BRAHMAPUTRA CARBON LIMITED",
"BRAHMAPUTRA CRACKER AND POLYMER LIMITED",
"BRAHMAPUTRA DIAGNOSTIC AND HOSPITAL LIMITED",
"BRAHMAPUTRA DISTRIBUTORS PRIVATE LIMITED",
"BRAHMAPUTRA FINLEASE PRIVATE LIMITED",
"BRAHMAPUTRA INFRASTRUCTURE LIMITED",
"BRAHMAPUTRA JUNGLE RESORTS PRIVATE LIMITED",
"BRAHMAPUTRA LOGISTICS PRIVATE LIMITED",
"BRAHMAPUTRA MENKENT INDIA PRIVATE LIMITED",
"BRAHMAPUTRA METALLICS LIMITED",
"BRAHMAPUTRA REALTORS PRIVATE LIMITED",
"BRAHMAPUTRA RIVER VALLEY TRADING PRIVATE LIMITED",
"BRAHMAPUTRA TELE PRODUCTIONS PRIVATE LIMITED",
"BRAHMAPUTRA TRADELINK PRIVATE LIMITED",
"BRAHMAPUTRA UDYOG PVT LTD",
"BRAHMAPUTRA VALLEY FERTILIZER CORPORATION LIMITED",
"BRAHMAPUTRA VYAPAR PRIVATE LIMITED",
"BRAHMAS ENGINEERING AND CONSTRUCTION COMPANY PRIVATE LIMITED",
"BRAHMASREE HERBALS PANCHAKARMA TREATMENT CENTRE",
"BRAHMAVARA PROMOTERS PRIVATE LIMITED",
"BRAHMAVARTA INDUSTRIES PRIVATE LIMITED",
"BRAHMCHAITANYA SUPERSPECIALITY HOSPITAL PRIVATE LIMITED",
"BRAHMINS FOODS INDIA PRIVATE LIMITED",
"BRAHMIS INDUSTRIES PRIVATE LIMITED",
"BRAHMKRISHI BIO ENERGY FARMER PRODUCER COMPANY LIMITED",
"BRAHMOS AEROSPACE PRIVATE LIMITED",
"BRAHMOS AEROSPACE THIRUVANANTHAPURAM LIMITED",
"BRAHMOS REALTY PRIVATE LIMITED",
"BRAID TECHNOLOGIES PRIVATE LIMITED",
"BRAIN & SPINE HOSPITALS PRIVATE LIMITED",
"BRAIN ABOVE INFOSOL PRIVATE LIMITED",
"BRAIN BUSINESS PVT LTD",
"BRAIN EVENTS",
"BRAIN MANAGEMENT CONSULTANTS (INDIA) PRIVATE LIMITED",
"BRAIN OAK GLOBAL SOLUTIONS PRIVATE LIMITED",
"BRAIN PACE CONSULTANCY PRIVATE LIMITED",
"BRAIN POINT INVESTMENT CENTRE PRIVATE LIMITED",
"BRAIN POINT TECHNOLOGIES PRIVATE LIMITED",
"BRAIN POWER TECHNOLOGIES PRIVATE LIMITED",
"BRAIN SCRIPT TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"BRAIN STORM AN INTEGRATED MARKETING COMMUNICATION NETWORK",
"BRAIN TECHNOSYS PRIVATE LIMITED.",
"BRAIN TECLABS PRIVATE LIMITED",
"BRAIN4CE EDUCATION SOLUTIONS PRIVATE LIMITED",
"BRAINBEES SOLUTIONS LIMITED",
"BRAINBEES SOLUTIONS PRIVATE LIMITED",
"BRAINCUBE ENTERPRISE SOLUTIONS PRIVATE LIMITED",
"BRAINCURRY TECHNOLOGIES PRIVATE LIMITED",
"BRAINDEZVOUS INFOTECH PRIVATE LIMITED",
"BRAINER INTERNATIONAL",
"BRAINFLOSS PRIVATE LIMITED",
"BRAINGRID TECHNOLOGIES PRIVATE LIMITED",
"BRAINIUM INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"BRAINLAB INDIA PRIVATE LIMITED",
"BRAINLITE EDUCATION SOLUTIONS PRIVATE LIMITED",
"BRAINLYTIC SOLUTIONS PRIVATE LIMITED",
"BRAINMINE WEB SOLUTIONS PRIVATE LIMITED",
"BRAINMOBI TECHNOLOGIES PRIVATE LIMITED",
"BRAINOBRAIN KIDS ACADEMY PRIVATE LIMITED",
"BRAINPAN DIGITAL PRIVATE LIMITED",
"BRAINPOINT INFOTECH PRIVATE LIMITED",
"BRAINPOWER HR MANAGEMENT PRIVATE LIMITED",
"BRAINPOWER TECHNOLOGIES PRIVATE LIMITED",
"BRAINPULSE TECHNOLOGIES PRIVATE LIMITED",
"BRAINROOTS",
"BRAINROOTZ LABS PRIVATE LIMITED",
"BRAINS & MACHINES INNOVATIVE SOLUTIONS PRIVATE LIMITED",
"BRAINS PRIVATE LIMITED",
"BRAINSEARCH CONSULTING PRIVATE LIMITED",
"BRAINSIS ENGINEERING SOLUTIONS PRIVATE LIMITED",
"BRAINSTEM MEDIA PRIVATE LIMITED",
"BRAINSTORM FORCE",
"BRAINSTORM FORCE LLP",
"BRAINSTREAM TECHNOLABS PRIVATE LIMITED",
"BRAINSYS TECHNOLOGIES PRIVATE LIMITED",
"BRAINTONE TECHNOLOGY PRIVATE LIMITED",
"BRAINTREE HR CONSULTING PRIVATE LIMITED",
"BRAINTREE PRODUCTS PRIVATE LIMITED",
"BRAINVALLEY SOFTWARE PRIVATE LIMITED",
"BRAINVIRE INFOTECH PRIVATE LIMITED",
"BRAINWARE CONSULTANCY PVT LTD",
"BRAINWARE UNIVERSITY",
"BRAINWAVE HEALTHCARE PRIVATE LIMITED",
"BRAINWAVE MEDICAL TECHNOLOGIES PRIVATE LIMITED",
"BRAINWIRE TECHNOLOGIES PRIVATE LIMITED",
"BRAINWORK TECHNOLOGIES PRIVATE LIMITED",
"BRAINZ EDU WORLD",
"BRAITHWAITE & CO LIMITED",
"BRAITRIM INDIA PRIVATE LIMITED",
"BRAJ BHOOMI BUILDTECH PRIVATE LIMITED",
"BRAJ BHOOMI INFRABUILD PRIVATE LIMITED",
"BRAJ BHUSHAN DEVELOPERS PRIVATE LIMITED",
"BRAJDEEP TEXTILES PRIVATE LIMITED",
"BRAJDHAM EDUCATIONAL & WELFARE FOUNDATION",
"BRAJDHAM MERCANTILE PRIVATE LIMITED",
"BRAJDHAM POWER PRIVATE LIMITED",
"BRAJENDRA KUMAR BUILDERS PRIVATE LIMITED",
"BRAJESH AUTOMOBILES PRIVATE LIMITED",
"BRAJESHWARI MOTORS PRIVATE LIMITED",
"BRAJKASHI SERVICES PRIVATE LIMITED",
"BRAKE PARTS INDIA PRIVATE LIMITED",
"BRAKES INDIA PRIVATE LIMITED",
"BRAKEWEL AUTOMOTIVE COMPONENTS INDIA PRIVATE LIMITED",
"BRALCO METAL INDUSTRIES PRIVATE LIMITED",
"BRAM HEALTH CARE PRIVATE LIMITED",
"BRAM WOODCRAFTING STUDIO PRIVATE LIMITED",
"BRAMAS INDUSTRIAL SERVICE ASSOCIATION",
"BRAMCO INDIA PRIVATE LIMITED",
"BRAMH BALAJI FOODS PRIVATE LIMITED",
"BRAMHA AYURVEDA SALES PRIVATE LIMITED",
"BRAMHA BUILDPRO PRIVATE LIMITED",
"BRAMHA ISPAT PRIVATE LIMITED",
"BRAMHA MULTICON PRIVATE LIMITED",
"BRAMHACORP LEISURE CLUBS PRIVATE LIMITED",
"BRAMHACORP LIMITED",
"BRAMHALL DEVELOPERS PRIVATE LIMITED",
"BRAMHAN VIDYALAYA PRI SECTION",
"BRAMHAPURI DHANORA HIGHWAY PRIVATE LIMITED",
"BRAMHECHA PLYWOOD PRIVATE LIMITED",
"BRAMMAAS VIDHYALAYA CBSE SENIOR SECONDARY RESIDENTIAL SCHOOL",
"BRANCH ENERGIA POWER INDIA PRIVATE LIMITED",
"BRANCH INTERNATIONAL FINANCIAL SERVICES PRIVATE LIMITED",
"BRANCLEY IMPEX PRIVATE LIMITED",
"BRANCO INDUSTRIES PRIVATE LIMITED",
"BRAND AID EVENTS",
"BRAND ALLOYS LIMITED.",
"BRAND AND BEYOND CONSULTING LLP",
"BRAND AVATAR",
"BRAND AVATAR LLP",
"BRAND AVENUE MEDIA PRIVATE LIMITED",
"BRAND BAZOOKA ADVERTISING PRIVATE LIMITED",
"BRAND BEE MANAGEMENT PRIVATE LIMITED",
"BRAND BLITZ DIGITAL IMAGING PRIVATE LIMITED",
"BRAND BLITZ EVENT MANAGEMENT PRIVATE LIMITED",
"BRAND BOX EXPERIENTIAL MARKETING LLP",
"BRAND BRIGADE MARKETING PRIVATE LIMITED",
"BRAND CONCEPTS LIMITED",
"BRAND CONCEPTS PRIVATE LIMITED",
"BRAND CONNECT INDIA ENTERTAINMENT PRIVATE LIMITED",
"BRAND DAVID COMMUNICATIONS PRIVATE LIMITED",
"BRAND EQUITY TREATIES LIMITED",
"BRAND EXPONENTS CREATIVES PRIVATE LIMITED",
"BRAND EYES DISTRIBUTORS PRIVATE LIMITED",
"BRAND FOREX PRIVATE LIMITED",
"BRAND FUSION",
"BRAND GODAM RETAILS PRIVATE LIMITED",
"BRAND HAWKERS SERVICES PRIVATE LIMITED",
"BRAND IDEA CONSULTANCY PRIVATE LIMITED",
"BRAND IMAGE SOLUTIONS PRIVATE LIMITED",
"BRAND KETTLE PROJECTS PRIVATE LIMITED",
"BRAND KING RETAIL PRIVATE LIMITED",
"BRAND LIAISON INDIA PRIVATE LIMITED",
"BRAND MARKETING INDIA PRIVATE LIMITED",
"BRAND MUSIQ PRIVATE LIMITED",
"BRAND NETWORKS APAC SOLUTIONS PRIVATE LIMITED",
"BRAND NUTRIENT MARKETING SERVICES PRIVATE LIMITED",
"BRAND PLANET CONSULTANTS INDIA PRIVATE LIMITED",
"BRAND PROMOTIONS INDIA PRIVATE LIMITED",
"BRAND REALTY PRIVATE LIMITED",
"BRAND SCIENTIFIC EQUIPMENT PRIVATE LIMITED",
"BRAND SHARE PRIVATE LIMITED",
"BRAND SHELL PRIVATE LIMITED",
"BRAND SOURCE TECHNOLOGIES PRIVATE LIMITED",
"BRAND SPRING INTEGRATED SOLUTIONS PRIVATE LIMITED",
"BRAND STEEL & POWER PRIVATE LIMITED",
"BRAND STEP COMMUNICATIONS PRIVATE LIMITED",
"BRAND STUDIO LIFESTYLE PRIVATE LIMITED",
"BRAND SYSTEM INTEGRATED MARKETING COMMUNICATIONS PRIVATE LIMITED",
"BRAND VALUE COMMUNICATIONS LIMITED",
"BRANDAID EVENTS INDIA PRIVATE LIMITED",
"BRANDALIVE EVENTS PRIVATE LIMITED",
"BRANDBERRY MARCOM PRIVATE LIMITED",
"BRANDBIRD DISTRIBUTORS PRIVATE LIMITED",
"BRANDBUCKET ENTERPRISES PRIVATE LIMITED",
"BRANDBUDDIEZ TECHNOLOGIES PRIVATE LIMITED",
"BRANDCONN DIGITAL PRIVATE LIMITED",
"BRANDCONNECT MARKETING PRIVATE LIMITED",
"BRANDENBURG (INDIA) PRIVATE LIMITED",
"BRANDESQUE MEDIA PRIVATE LIMITED",
"BRANDEX MEDIA NETWORK PRIVATE LIMITED",
"BRANDEX MEDIACOM PRIVATE LIMITED",
"BRANDHANCER PRIVATE LIMITED",
"BRANDHILL MARKETING SOLUTIONS PRIVATE LIMITED",
"BRANDHUES ADVERTISING (OPC) PRIVATE LIMITED",
"BRANDINTELLE SERVICES PRIVATE LIMITED",
"BRANDIO LEATHER PRIVATE LIMITED",
"BRANDISH MEDIA & ENTERTAINMENT PRIVATE LIMITED",
"BRANDIT MARKETING & PROMOTIONS PRIVATE LIMITED",
"BRANDIX APPAREL INDIA PRIVATE LIMITED",
"BRANDIX INDIA APPAREL CITY PRIVATE LIMITED",
"BRANDIX INTIMATE INDIA PRIVATE LIMITED",
"BRANDMAKERR INTERIOR SOLUTIONS PRIVATE LIMITED",
"BRANDMANIA COMMUNICATIONS PRIVATE LIMITED",
"BRANDMAP COMMUNICATION PRIVATE LIMITED",
"BRANDMARK INFRASTRUCTURE PRIVATE LIMITED",
"BRANDMARK SOLUTIONS PRIVATE LIMITED",
"BRANDMIDAS HOSPITALITY & AVIATION SERVICES PRIVATE LIMITED",
"BRANDMINES RETAIL PRIVATE LIMITED",
"BRANDMITRA ADVERTISING PRIVATE LIMITED",
"BRANDMOVERS INTERACTIVE INDIA PRIVATE LIMITED",
"BRANDMUSCLE INDIA PRIVATE LIMITED",
"BRANDNEXT MEDIA PRIVATE LIMITED",
"BRANDON AND CO PVT LTD",
"BRANDS AND BRANCHES PRIVATE LIMITED",
"BRANDS AND MORE PRIVATE LIMITED",
"BRANDS SCALEUP PRIVATE LIMITED",
"BRANDSCAPES CONSULTANCY PRIVATE LIMITED",
"BRANDSMART PACKAGING COMPANY INDIA PRIVATE LIMITED",
"BRANDSOME MEDIA PRIVATE LIMITED",
"BRANDSTIK SOLUTIONS PRIVATE LIMITED",
"BRANDSTORY SOLUTIONS PRIVATE LIMITED",
"BRANDSYSTEMS INDIA PRIVATE LIMITED",
"BRANDTHOUGHT RETAIL PRIVATE LIMITED",
"BRANDTOUCH & ANALYTICS PRIVATE LIMITED",
"BRANDVERTISE INDIA PRIVATE LIMITED",
"BRANDVIDS INFOTECH & ENGINEERING SERVICES PRIVATE LIMITED (OPC)",
"BRANDWEER ENGINEERING PRIVATE LIMITED",
"BRANDWIDTH EVENTS PRIVATE LIMITED",
"BRANDWORKS MEDIA PRIVATE LIMITED",
"BRANDWORKS TECHNOLOGIES PRIVATE LIMITED",
"BRANDYGOLD TECH PRIVATE LIMITED",
"BRANDZ GURU E MARKETING PRIVATE LIMITED",
"BRANDZONE ENTERTAINMENT PRIVATE LIMITED",
"BRANDZSTORM INDIA MARKETING PRIVATE LIMITED",
"BRANDZSTORM INDIA RETAIL MARKETING PRIVATE LIMITED",
"BRANMARK INFOMEDIA PRIVATE LIMITED",
"BRANNIGAN RELOCATION PRIVATE LIMITED",
"BRANOPAC INDIA PRIVATE LIMITED",
"BRANZO PROJECTS PRIVATE LIMITED",
"BRAR ENTERPRISES PRIVATE LIMITED",
"BRAR EYE HOSPITAL PRIVATE LIMITED",
"BRAR INDIA PRIVATE LIMITED",
"BRAR INDUSTRIES PRIVATE LIMITED",
"BRAR PROPERTIES AND HOLDINGS PRIVATE LIMITED",
"BRAR SEEDS PRIVATE LIMITED",
"BRASS COPPER & ALLOY (INDIA) LIMITED",
"BRASSICA PHARMA PRIVATE LIMITED",
"BRASSTECH ENGINEERING PRIVATE LIMITED",
"BRASTEN ENGINEERS & CONSULTANTS PRIVATE LIMITED",
"BRAVAT INDIA PRIVATE LIMITED",
"BRAVE NEW WORLD COMMUNICATIONS PRIVATE LIMITED",
"BRAVERY SECURITY SERVICE PRIVATE LIMITED",
"BRAVES OFFSHORE MANAGEMENT SERVICES PRIVATE LIMITED",
"BRAVIA CAPITAL SERVICES INDIA PRIVATE LIMITED",
"BRAVIA INTERIOR INFRASTRUCTURE PRIVATE LIMITED",
"BRAVIM CHEMICALS AND FERTILIZERS LIMITED",
"BRAVIM ENGINEERING PRIVATE LIMITED",
"BRAVLD ENGINEERING PRIVATE LIMITED",
"BRAVO BUILDERS PRIVATE LIMITED",
"BRAVO CABLE TRAYS PRIVATE LIMITED",
"BRAVO ERECTION PRIVATE LIMITED",
"BRAVO HEALTHCARE LIMITED",
"BRAVO HYDRAULICS PRIVATE LIMITED",
"BRAVO INDUSTRIAL SECURITY PRIVATE LIMITED",
"BRAVO SECURITY SERVICES PRIVATE LIMITED",
"BRAVO SHIP MANAGEMENT PRIVATE LIMITED",
"BRAVO SPONGE IRON PRIVATE LIMITED",
"BRAVOVENTURE INDIA PRIVATE LIMITED",
"BRAVURA PACKERS PRIVATE LIMITED",
"BRAVURA SOLUTIONS INDIA LLP",
"BRAVURA SOLUTIONS INDIA PRIVATE LIMITED",
"BRAVURA TECHNOLOGIES INDIA PRIVATE LIMITED",
"BRAVVURA DIGITAL PRIVATE LIMITED",
"BRAWN BIOTECH LIMITED",
"BRAWN COSMETICS AND HERBALS PRIVATE LIMITED",
"BRAWN ENERGY PRIVATE LIMITED",
"BRAWN GLOBUS TURNKEY SOLUTIONS PRIVATE LIMITED",
"BRAWN HEALTHCARE INDIA PRIVATE LIMITED",
"BRAWN LABORATORIES LIMITED",
"BRAWN TECHNOLOGIES PRIVATE LIMITED",
"BRAWNEPAK",
"BRAY CONTROLS INDIA PRIVATE LIMITED",
"BRAYAN AUTOMATIONS PRIVATE LIMITED",
"BRAYAN ENGINEERING AND CONTRACTING PRIVATE LIMITED",
"BRAYOPTUS PHARMA PRIVATE LIMITED",
"BRAYTON ENGINEERS (INDIA) PRIVATE LIMITED",
"BRAYTON PHARMACEUTICALS PRIVATE LIMITED",
"BRAZA TYRES PRIVATE LIMITED",
"BRAZEN ARROW COMPANY PRIVATE LIMITED",
"BRB ART & JEWELS PRIVATE LIMITED",
"BRB BUILDCON PRIVATE LIMITED",
"BRBS HOLDINGS PRIVATE LIMITED",
"BRC INFRA PRIVATE LIMITED",
"BRC JABALPUR RURAL ¬†JABALPUR",
"BRC METALS PRIVATE LIMITED",
"BRD CAR WORLD LIMITED",
"BRD CONSTRUCTIONS PRIVATE LIMITED",
"BRD INFOTECH PRIVATE LIMITED",
"BRDG INFRA PRIVATE LIMITED",
"BREA FOODS PRIVATE LIMITED",
"BREACH CANDY HOSPITAL TRUST",
"BREACHSAFE SERVICES PRIVATE LIMITED",
"BREAD BASKET PRIVATE LIMITED",
"BREAD FINANCIAL GLOBAL SOLUTIONS INDIA LLP",
"BREADBOX HOSPITALITY PRIVATE LIMITED",
"BREADSLY FOOD PRIVATE LIMITED",
"BREADWORLD PRIVATE LIMITED",
"BREAKING BREAD ENTERTAINMENT & HOSPITALITY PRIVATE LIMITED",
"BREAKTHROUGH MANAGEMENT GROUP INDIA PRIVATE LIMITED",
"BREAKTHROUGH TRUST",
"BREAL ESTATE ONE PRIVATE LIMITED",
"BREATHE AGAIN INDIA PRIVATE LIMITED",
"BREATHE CAREERS AND CONSULTING PRIVATE LIMITED",
"BREATHE INDIA ADVISORS PRIVATE LIMITED",
"BREATHE SOLAR POWER PRIVATE LIMITED",
"BREATHEEASY CONSULTANTS PRIVATE LIMITED",
"BREATHLESS FILMS PRIVATE LIMITED",
"BREATHWELL MEDICARE INDIA PRIVATE LIMITED",
"BREBEN CARGO PRIVATE LIMITED",
"BRECHERS TECHNO INDIA PRIVATE LIMITED",
"BREDENT GROUP INDIA PRIVATE LIMITED",
"BREECH ORALCARE PRIVATE LIMITED",
"BREEZ BUILDERS & DEVELOPERS PRIVATE LIMITED",
"BREEZE CHEMICALS PRIVATE LIMITED",
"BREEZE ENTERPRISES PRIVATE LIMITED",
"BREEZE INNOVATIONS PRIVATE LIMITED",
"BREEZE INTERMEDIATES PRIVATE LIMITED",
"BREEZE MULTIDISCIPLINARY REHABILITATION CENTRE",
"BREEZE PROJECT INDIA PRIVATE LIMITED",
"BREEZE TOOLS PRIVATE LIMITED",
"BREEZEFRESH DAIRY AND AGRO FARMS PRIVATE. LIMITED.",
"BREEZEWARE INDIA PRIVATE LIMITED",
"BREI S BLUE RIDGE PUBLIC SCHOOL",
"BREIT REAL ESTATE PRIVATE LIMITED",
"BREITHORN CONSULTING & TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"BREITLING INDIA PRIVATE LIMITED",
"BREKKIE FOODS PRIVATE LIMITED",
"BREMBO BRAKE INDIA PRIVATE LIMITED",
"BREMELS RUBBER INDUSTRIES PRIVATE LIMITED",
"BREMER INDIA ENGINEERING PRIVATE LIMITED",
"BREMSKERL FRICTION MATERIALS INDIA PRIVATE LIMITED",
"BREN CORPORATION",
"BREN CORPORATION PRIVATE LIMITED",
"BRENNAN IT (INDIA) PRIVATE LIMITED",
"BRENNTAG INGREDIENTS INDIA PRIVATE LIMITED",
"BRENO LABS PRIVATE LIMITED",
"BRENTFORD SERVICES PRIVATE LIMITED",
"BRENTWOOD INDUSTRIES INDIA PRIVATE LIMITED",
"BRENTWOOD INFOSCRIBE PRIVATE LIMITED",
"BRENTWOODS INTERNATIONAL LIMITED",
"BRESCON REALTY PRIVATE LIMITED",
"BRESCON VENTURES PRIVATE LIMITED",
"BRESMED HEALTH SOLUTIONS INDIA PRIVATE LIMITED",
"BRETON INDIA SERVICES PRIVATE LIMITED",
"BRETT ENTERPRISES PRIVATE LIMITED",
"BRETTON WOODS FINLEASE LIMITED",
"BREVERA TECHNOLOGIES PRIVATE LIMITED",
"BREVIANT MARKETING SERVICES (OPC) PRIVATE LIMITED",
"BREVISTAY HOSPITALITY PRIVATE LIMITED",
"BREW KING BEVERAGES PRIVATE LIMITED",
"BREWCRAFT HOSPITALITY PRIVATE LIMITED",
"BREWCRAFTS MICRO BREWING PRIVATE LIMITED",
"BREWENGAGE TECHNOLOGY PRIVATE LIMITED",
"BREWFORCE LIMITED",
"BREWHOUSE ADVERTISING PRIVATE LIMITED",
"BREWING VISION PRIVATE LIMITED",
"BREWKLYN MICROBREWING PRIVATE LIMITED",
"BREWOCRAT SERVICES PRIVATE LIMITED",
"BREWSKY HENNUR BREWERY PRIVATE LIMITED",
"BREWSKY HOSPITALITY PRIVATE LIMITED",
"BRF LIFESCIENCE PRIVATE LIMITED",
"BRFL TEXTILES PRIVATE LIMITED",
"BRFM INDIA PRIVATE LIMITED",
"BRG ENTERPRISE SOLUTIONS INDIA PRIVATE LIMITED",
"BRG GRANITE PRIVATE LIMITED",
"BRGD SPONGE & IRON PRIVATE LIMITED",
"BRGRIH INFRASTRUCTURE PRIVATE LIMITED",
"BRHMA COLDEXT PRIVATE LIMITED",
"BRIANNA KNOWLEDGE RESOURCES PRIVATE LIMITED",
"BRIC DESIGNS PRIVATE LIMITED",
"BRICHEM SCIENCES PRIVATE LIMITED",
"BRICK AND BYTE INNOVATIVE PRODUCTS PRIVATE LIMITED",
"BRICK CAREER EDU PRIVATE LIMITED",
"BRICK RISE DEVELOPERS PRIVATE LIMITED",
"BRICK WAY INFRASTRUCTURE PRIVATE LIMITED",
"BRICK2WALL INFRATECH PRIVATE LIMITED",
"BRICKEX ADVISORS PRIVATE LIMITED",
"BRICKFOLIO SOLUTIONS PRIVATE LIMITED",
"BRICKISHH EXPORTS PRIVATE LIMITED",
"BRICKLITE BLOCKS PRIVATE LIMITED",
"BRICKMART CONSTRUCTIONS AND DEVELOPERS PRIVATE LIMITED",
"BRICKRED DEVELOPERS PRIVATE LIMITED",
"BRICKSCITY DEVELOPERS PRIVATE LIMITED",
"BRICKSQUAD SERVICES PRIVATE LIMITED",
"BRICKSTEEL ENTERPRISES INFO TECH PRIVATE LIMITED",
"BRICKWORK INDIA PRIVATE LIMITED",
"BRICKWORK RATINGS INDIA PRIVATE LIMITED",
"BRICS GILT FINANCE PRIVATE LIMITED",
"BRICS INDIA TRADE PRIVATE LIMITED",
"BRICS POWER GENERATION PRIVATE LIMITED",
"BRICS RENEWABLE ENERGY PRIVATE LIMITED",
"BRICS SECURITIES LIMITED",
"BRICSPAC INDIA PRIVATE LIMITED",
"BRICSPACES PRIVATE LIMITED",
"BRICTECH SOFTWARE PRIVATE LIMITED",
"BRIC-X INFRA PRIVATE LIMITED",
"BRIDGE & ROOF CO (INDIA) LTD",
"BRIDGE 2 TECH CONSULTANCY PRIVATE LIMITED",
"BRIDGE CHEM PRIVATE LIMITED",
"BRIDGE CONNECTIVITY SOLUTIONS PRIVATE LIMITED",
"BRIDGE DATACENTRES MUMBAI LLP",
"BRIDGE DENTAL PRIVATE LIMITED",
"BRIDGE EVENTS AND EXPERIENCES PRIVATE LIMITED",
"BRIDGE FINTECH SOLUTIONS PRIVATE LIMITED",
"BRIDGE GAP LIFESCIENCES PRIVATE LIMITED",
"BRIDGE INTERNATIONAL ACADEMIES INDIA LLP",
"BRIDGE INVESTMENT ADVISORS PRIVATE LIMITED",
"BRIDGE MEDISALES PRIVATE LIMITED",
"BRIDGE PEOPLE TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"BRIDGE POSTWORKS PRIVATE LIMITED",
"BRIDGE SOFT SOLUTIONS PRIVATE LIMITED",
"BRIDGE TO INDIA ENERGY PRIVATE LIMITED",
"BRIDGE TRACK & TOWER PRIVATE LIMITED",
"BRIDGECON INFRACONSULTANTS PRIVATE LIMITED",
"BRIDGECON SYSTEMS PRIVATE LIMITED",
"BRIDGECUBEX INFRATECH PRIVATE LIMITED",
"BRIDGEI2I ANALYTICS SOLUTIONS PRIVATE LIMITED",
"BRIDGEI2P TELECOMMUNICATIONS PRIVATE LIMITED",
"BRIDGELABZ SOLUTIONS LLP",
"BRIDGELINE SOFTWARE",
"BRIDGEMOND TECHNOLOGIES (OPC) PRIVATE LIMITED",
"BRIDGEMONTE ADVISORS PRIVATE LIMITED",
"BRIDGERA INDIA PRIVATE LIMITED",
"BRIDGES EXPRESS (INDIA) PRIVATE LIMITED",
"BRIDGES WORLDWIDE (INDIA) PRIVATE LIMITED",
"BRIDGESTONE INDIA PRIVATE LIMITED",
"BRIDGETHINGS IOT PRIVATE LIMITED",
"BRIDGETOWN CONSULTING SERVICES PRIVATE LIMITED",
"BRIDGETREE RESEARCH SERVICES PRIVATE LIMITED",
"BRIDGEVIEW MARITIME PRIVATE LIMITED",
"BRIDGEWAY MOTORS LLP",
"BRIDGEWAY TEXTILES PRIVATE LIMITED",
"BRIDGING HEALTHCARE TECHNOLOGIES PRIVATE LIMITED",
"BRIDIANT TRADING & MARKETING PVT. LTD.",
"BRIEFS CONTENT SERVICES PRIVATE LIMITED",
"BRIEXO BUSINESS SERVICES PRIVATE LIMITED",
"BRIFO LOGISTICS OPC PRIVATE LIMITED",
"BRIG RESOLUTION SERVICES PRIVATE LIMITED",
"BRIGADE (GUJARAT) PROJECTS PRIVATE LIMITED",
"BRIGADE CORPORATION INDIA PRIVATE LIMITED",
"BRIGADE ENTERPRISES LIMITED",
"BRIGADE FOUNDATION",
"BRIGADE HOSPITALITY SERVICES LIMITED",
"BRIGADE HOTEL VENTURES LIMITED",
"BRIGADE INTELLIGENCE SECURITY PRIVATE LIMITED",
"BRIGADE PROPERTIES PRIVATE LIMITED",
"BRIGADE TETRARCH PRIVATE LIMITED",
"BRIGGS AND STRATTON A G",
"BRIGGS TRADING COMPANY PRIVATE LIMITED",
"BRIGHT & SHINE FACILITY SERVICES PRIVATE LIMITED",
"BRIGHT 4 WHEEL SALES PRAYAGRAJ PRIVATE LIMITED",
"BRIGHT 4 WHEEL SALES PRIVATE. LIMITED.",
"BRIGHT ADVERTISING PRIVATE LIMITED",
"BRIGHT AND BRAND MENS WEAR",
"BRIGHT AUTOMOBILES PRIVATE LIMITED",
"BRIGHT AUTOZONE PRIVATE LIMITED",
"BRIGHT BEGININGS PRIVATE LIMITED",
"BRIGHT BRAIN MARKETING TECHNOLOGIES LLP",
"BRIGHT BRIDGE INFOTECH PRIVATE LIMITED",
"BRIGHT BROTHERS LIMITED",
"BRIGHT BUILDTECH PRIVATE LIMITED",
"BRIGHT BURNISHING TOOLS PRIVATE LIMITED",
"BRIGHT CABLES PRIVATE LIMITED",
"BRIGHT CAREER PUBLIC SCHOOL",
"BRIGHT CASTINGS PRIVATE LIMITED",
"BRIGHT DRIVE HCS PRIVATE LIMITED",
"BRIGHT EDGE EDUSYSTEMS PRIVATE LIMITED",
"BRIGHT ENGINEERING WORKS PRIVATE LIMITED",
"BRIGHT ENTERPRISES PRIVATE LIMITED",
"BRIGHT ENVIRONMENTAL SOLUTIONS PRIVATE LIMITED",
"BRIGHT EXIM PRIVATE LIMITED",
"BRIGHT EYE TECHNOLOGIES INDIA PRIVATE LIMITED",
"BRIGHT FACILITIES AND MANAGEMENT SERVICES PRIVATE LIMITED",
"BRIGHT FINANCE PRIVATE LIMITED",
"BRIGHT FOUNDRIES COIMBATORE PRIVATE LIMITED",
"BRIGHT FUTURE BUSINESS SOLUTION PRIVATE LIMITED",
"BRIGHT GEMS PRIVATE LIMITED",
"BRIGHT GLASS & SILICATE PRIVATE LIMITED",
"BRIGHT HIGH SCHOOL & JR COLLEGE",
"BRIGHT HORIZONS CHILD CARE SERVICES PRIVATE LIMITED",
"BRIGHT HOSPITALITY PRIVATE LIMITED",
"BRIGHT IMPEX & AGENCIES PVT LTD",
"BRIGHT IMPRESSIONS PRIVATE LIMITED",
"BRIGHT INDIA CORP PRIVATE LIMITED",
"BRIGHT INDIA STAINLESS STEEL PRIVATE LIMITED",
"BRIGHT INFRA SYSTEM PRIVATE LIMITED",
"BRIGHT INFRADEV PRIVATE LIMITED",
"BRIGHT INTERNATIONAL SCHOOL",
"BRIGHT KURIES PRIVATE LIMITED",
"BRIGHT LANDS HOTEL PVT LTD",
"BRIGHT MARKETING PVT LTD",
"BRIGHT METALLICS PRIVATE LIMITED",
"BRIGHT METALS INDIA PRIVATE LIMITED",
"BRIGHT MINDS EDUCATION PRIVATE LIMITED",
"BRIGHT MONEY TECHNOLOGY PRIVATE LIMITED",
"BRIGHT OUTDOOR MEDIA LIMITED",
"BRIGHT PACKAGING PRIVATE LIMITED",
"BRIGHT PACKAGING PRIVATE. LIMITED.",
"BRIGHT PHARMA ENGINEERING PRIVATE LIMTED",
"BRIGHT POLYMERS PRIVATE LIMITED",
"BRIGHT PRECISION MACHINING WORKS PRIVATE LIMITED",
"B-RIGHT REALESTATE LIMITED",
"BRIGHT RESIN PRIVATE LIMITED",
"BRIGHT RIDERS LLP",
"BRIGHT RIVER MRC INDIA PRIVATE LIMITED",
"BRIGHT ROADWAYS PRIVATE LIMITED",
"BRIGHT SECURE PRIVATE LIMITED",
"BRIGHT SHIPTRANS PRIVATE LIMITED",
"BRIGHT SKY HEIGHTS BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"BRIGHT SOLAR LIMITED",
"BRIGHT SOLAR PRIVATE LIMITED",
"BRIGHT STAFFING SOLUTIONS LLP",
"BRIGHT STAR GLOBAL TRADING CORPORATION",
"BRIGHT STAR HOSPITALITY SERVICES PRIVATE LIMITED",
"BRIGHT STAR INVESTMENTS PRIVATE LIMITED",
"BRIGHT STAR SYNTEX PRIVATE LIMITED",
"BRIGHT STYLE FABRICS PRIVATE LIMITED",
"BRIGHT SYSTEMS PRIVATE LIMITED",
"BRIGHT TECH INDUSTRIALS INDIA PRIVATE LIMITED",
"BRIGHT TECHNOCRAT INDIA PRIVATE LIMITED",
"BRIGHT UP TECHNOLOGY PRIVATE LIMITED",
"BRIGHT VISION LOGISTICS INDIA PRIVATE LIMITED",
"BRIGHTCAREER CONSULTANCY SERVICES PRIVATE LIMITED",
"BRIGHTCOVE INDIA PRIVATE LIMITED",
"BRIGHTCROP AGRO PRODUCTS PRIVATE LIMITED",
"BRIGHTECH VALVES AND CONTROLS PRIVATE LIMITED",
"BRIGHTEN ARYA LIFESTYLE PRIVATE LIMITED",
"BRIGHTEX BIO-PHOTONICS PRIVATE LIMITED",
"BRIGHTEX ENTERPRISES PRIVATE LIMITED",
"BRIGHTEX FOTOTECH PRIVATE LIMITED",
"BRIGHTEX PHARMACHEM PRIVATE LIMITED",
"BRIGHTEX SYNERGIZER INDIA PRIVATE LIMITED",
"BRIGHTFLEXI INTERNATIONAL PRIVATE LIMITED",
"BRIGHTFLOW ENGINEERS PRIVATE LIMITED",
"BRIGHTFUTURE LIFECARE PRIVATE LIMITED",
"BRIGHTINDIA GENERAL FINANCE PRIVATE LIMITED",
"BRIGHTLAND COLLEGE",
"BRIGHTLAND SCHOOL",
"BRIGHTLEAF BIZ SOLUTIONS INDIA PRIVATE LIMITED",
"BRIGHTLIGHT RENEWABLE TECHNOLOGIES PRIVATE LIMITED",
"BRIGHTLY SOFTWARE INDIA PRIVATE LIMITED",
"BRIGHTMINDSATWORK CONSULTING PRIVATE LIMITED",
"BRIGHTMOON SUPPLY PRIVATE LIMITED",
"BRIGHTNESS SOFTWARE DEVELOPMENT (I) PRIVATE LIMITED",
"BRIGHTO CREDIT INFORMATION PRIVATE LIMITED",
"BRIGHTON INTERNATIONAL SCHOOL",
"BRIGHTPEOPLE HR SOLUTIONS PRIVATE LIMITED",
"BRIGHTPOINT INDIA PRIVATE LIMITED",
"BRIGHTSANDZ CLEAN TECH PRIVATE LIMITED",
"BRIGHTSOLAR RENEWABLE ENERGY PRIVATE LIMITED",
"BRIGHTSPARK SOLUTIONS PRIVATE LIMITED",
"BRIGHTSPOT TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"BRIGHTSTAR HEALTHCARE PRIVATE LIMITED",
"BRIGHTSTAR INFRASTRUCTURE PRIVATE LIMITED",
"BRIGHTSTAR VINCOM PRIVATE LIMITED",
"BRIGHTSTONE DEVELOPERS PRIVATE LIMITED",
"BRIGHTSUN INFRA PRIVATE LIMITED",
"BRIGHTSUN SWITCHGEARS PRIVATE LIMITED",
"BRIGHTSUN TRAVELS PRIVATE LIMITED",
"BRIGHTSWORD IT SERVICES PRIVATE LIMITED",
"BRIGHTVIEW TELECOM PRIVATE LIMITED",
"BRIGHTVISION TECHNOSOFT PRIVATE LIMITED",
"BRIGHTWAY GLOVES PRIVATE LIMITED",
"BRIGHTWELL CORPORATION PRIVATE LIMITED",
"BRIGHTWORKS LIGHTING SOLUTION PRIVATE LIMITED",
"BRIGOSHA TECHNOLOGIES PRIVATE LIMITED",
"BRIH SOLUTIONS PRIVATE LIMITED",
"BRIHAN KARAN SUGAR SYNDICATE PRIVATE LIMITED",
"BRIHANMUMBAI CUSTOM BROKERS ASSOCIATION",
"BRIHANMUMBAI ELECTRIC SUPPLY AND TRANSPORT",
"BRIHANMUMBAI MAHANAGARPALIKA",
"BRIHANMUMBAI MUNICIPAL CORPORATION",
"BRIHANS LABORATORIES PRIVATE LIMITED",
"BRIHANS NATURAL PRODUCTS LIMITED",
"BRIHASPATHI AGQGENEX PRIVATE LIMITED",
"BRIHASPATHI TECHNOLOGIES PRIVATE LIMITED",
"BRIHAT ENERGY PRIVATE LIMITED",
"BRIISK INSUR- FINTECH PRIVATE LIMITED",
"BRIJ BAL NIKETAN UCHH MADHYAM VIDHALAYA",
"BRIJ BHOOMI EXPRESSWAY PRIVATE LIMITED",
"BRIJ BIWHEELERS PRIVATE LIMITED",
"BRIJ FABRICS PRIVATE LIMITED",
"BRIJ FOOTCARE PRIVATE LIMITED",
"BRIJ FOOTWEAR PRIVATE LIMITED",
"BRIJ GOPAL CONSTRUCTION COMPANY P LIMITED",
"BRIJ HEALTH SERVICES (INDIA) PRIVATE LIMITED",
"BRIJ HONEY PRIVATE LIMITED",
"BRIJ INDIA ARCHITECTS",
"BRIJ KISHOR NIRMALA DEVI ICE & COLD STORAGE PRIVATE LIMITED",
"BRIJ KISHORE PRASAD EXPORTS PRIVATE LIMITED",
"BRIJ KISHORE SARAF AND SONS PRIVATE LIMITED",
"BRIJ LAL HOSPITAL & RESEARCH CENTRE PRIVATE LIMITED",
"BRIJ MEDICAL CENTRE PRIVATE LIMITED",
"BRIJ MOHAN BANSAL MEDICARE LOGISTICS PRIVATE LIMITED",
"BRIJ POLYMERS P LIMITED",
"BRIJ POWERTOOLS PRIVATE LIMITED",
"BRIJ PUBLICITY AND ADVERTISING PRIVATE LIMITED",
"BRIJ RAJ FASHION PRIVATE LIMITED",
"BRIJ RAJ MOTORS PRIVATE LIMITED",
"BRIJ RAJ SHARMA AND ASSOCIATES PRIVATE LIMITED",
"BRIJ RANI INTER COLLEGE",
"BRIJ REALTECH PRIVATE LIMITED",
"BRIJ SYSTEMS LIMITED",
"BRIJBASI ART PRESS LIMITED",
"BRIJBASI FIRE SAFETY SYSTEMS PRIVATE LIMITED",
"BRIJBASI HI-TECH UDYOG LIMITED",
"BRIJBHOOMI HOTELS AND RESORTS PRIVATE LIMITED",
"BRIJBIHARI CONCAST PRIVATE LIMITED",
"BRIJDA IMPEX PRIVATE LIMITED",
"BRIJDA ROADLINES PRIVATE LIMITED",
"BRIJDEV REALTIES PRIVATE LIMITED",
"BRIJDHAM POLYMERS PRIVATE LIMITED",
"BRIJEEL FOODS & BEVERAGES PRIVATE LIMITED",
"BRIJESH BANGER MEMORIAL HOSPITAL",
"BRIJESH WOOD PRODUCTS PRIVATE LIMITED",
"BRIJESH WOOLEN INDUSTRIES P LTD",
"BRIJESHWAR ISPAT AND ALLOYS PRIVATE LIMITED",
"BRIJKISHOR TRADING PRIVATE LIMITED",
"BRIJLAX AUTO PRIVATE LIMITED",
"BRIJLAX FOODS PRIVATE LIMITED",
"BRIJLAXMI LEASING AND FINANCE LIMITED",
"BRIJLAXMI PAPER PRODUCTS PRIVATE LIMITED",
"BRIJMECH ENGINEERING PRIVATE LIMITED",
"BRIJMOHAN AZAD SINGH MARKETING PRIVATE LIMITED",
"BRIJMOHAN PACKAGING PRIVATE LIMITED",
"BRIJMOHAN SAGARMAL SECURITIES PRIVATE LIMITED",
"BRIJNANDAN ENTERPRISES PRIVATE LIMITED",
"BRIJRAJ AGRO PRODUCTS PRIVATE LIMITED",
"BRIJRAJ AUTO PRIVATE LIMITED",
"BRIJRAJ INFRASTRUCTURE PRIVATE LIMITED",
"BRIJRAMA HOSPITALITY PRIVATE LIMITED",
"BRIJRAMAN TRADING PRIVATE LIMITED",
"BRIJVAN RETAIL PRIVATE LIMITED",
"BRIJWALA INFRA SOLUTTIONS PRIVATE LIMITED",
"BRIJWASI BAKERY PRIVATE LIMITED",
"BRIJWASI BENGALI SWEETS PRIVATE LIMITED",
"BRIJWASI CHIPS AND SNACKS PRIVATE LIMITED",
"BRIJWASI CONFECTIONERS PRIVATE LIMITED",
"BRIJWASI DEVELOPERS PRIVATE LIMITED",
"BRIJWASI PLASTIC PRIVATE LIMITED",
"BRIJWASI POLYPACK PRIVATE LIMITED",
"BRIJWASI RESORTS PRIVATE LIMITED",
"BRIJWASI SECURITIES PRIVATE LIMITED",
"BRIJWASI SHEETGRAH PRIVATE LIMITED",
"BRIJWASI STEELS INDIA PRIVATE LIMITED",
"BRIJWHEEL AUTOMOBILES PRIVATE LIMITED",
"BRIK OVEN PRIVATE LIMITED",
"BRILHO ENVISION (OPC) PRIVATE LIMITED",
"BRILIANT ENGICON PRIVATE LIMITED",
"BRILIANT PROTECTION SERVICE PRIVATE LIMITED",
"BRILLANTO TEXTILE MILLS PRIVATE LIMITED",
"BRILLARE SCIENCE PRIVATE LIMITED",
"BRILLER BRIGHT BAR PRIVATE LIMITED",
"BRILLER PROJECTS LIMITED",
"BRILLIA FOODS PRIVATE LIMITED",
"BRILLIANCE HOMES PRIVATE LIMITED",
"BRILLIANICS TECHNOLOGIES PRIVATE LIMITED",
"BRILLIANT APPROACH PRIVATE LIMITED",
"BRILLIANT BIO PHARAMA PRIVATE LIMITED",
"BRILLIANT BUILD TECH PRIVATE LIMITED",
"BRILLIANT COATINGS PRIVATE LIMITED",
"BRILLIANT CORPORATE SERVICES PRIVATE LIMITED",
"BRILLIANT ELECTRO SYSTEMS PRIVATE LIMITED",
"BRILLIANT ELEVATOR INDIA CO PRIVATE LIMITED",
"BRILLIANT ESTATES LIMITED.",
"BRILLIANT ETOILE PRIVATE LIMITED",
"BRILLIANT FINANCIAL SERVICES PRIVATE LIMITED",
"BRILLIANT FOUNDATION",
"BRILLIANT GRAMMAR HIGH SCHOOL",
"BRILLIANT HOTEL AND INFRASTRUCTURES PRIVATE LIMITED",
"BRILLIANT INDUSTRIES PRIVATE LIMITED",
"BRILLIANT INFO SYSTEMS PRIVATE LIMITED",
"BRILLIANT INFRAPROJECTS PRIVATE LIMITED",
"BRILLIANT INSTITUTE OF ENGINEERING AND TECHNOLOGY",
"BRILLIANT INSURANCE BROKING SERVICES PRIVATE LIMITED",
"BRILLIANT INTERNATIONAL LLP",
"BRILLIANT JR COLLEGE",
"BRILLIANT LAMINOSYS PRIVATE LIMITED",
"BRILLIANT LED PRIVATE LIMITED",
"BRILLIANT LIFESCIENCES PRIVATE LIMITED",
"BRILLIANT METALS PRIVATE LIMITED",
"BRILLIANT MULTITRADE PRIVATE LIMITED",
"BRILLIANT PACKAGING P LIMITED",
"BRILLIANT POLYMERS PRIVATE LIMITED",
"BRILLIANT PORTFOLIOS LIMITED",
"BRILLIANT PRINTERS PRIVATE LIMITED",
"BRILLIANT PROCESS MACHINERY PRIVATE LIMITED",
"BRILLIANT PUBLIC SCHOOL",
"BRILLIANT SANITARYWARE PRIVATE LIMITED",
"BRILLIANT SEAGULL PRIVATE LIMITED",
"BRILLIANT SEAGULL TM LLP",
"BRILLIANT STONES PRIVATE LIMITED",
"BRILLIO TECHNOLOGIES PRIVATE LIMITED",
"BRILLIUS PRIVATE LIMITED",
"BRILLON CONSUMER PRODUCTS PRIVATE LIMITED",
"BRILLPHARMA PRIVATE LIMITED",
"BRILLTECH ENGINEERS PRIVATE LIMITED",
"BRILTEX FACILITY SERVICES PRIVATE LIMITED",
"BRILVOICE INDIA PRIVATE LIMITED",
"BRILYANT DISTRIBUTION PRIVATE LIMITED",
"BRIMA SAGAR MAHARASHTRA DISTILLERIES LIMITED",
"BRIMAG FASTENERS PRIVATE LIMITED",
"BRIMMA ENGINNERING PRIVATE LIMITED",
"BRIMMA TECH PRIVATE LIMITED",
"BRINC CORPORATE SOLUTIONS PRIVATE LIMITED",
"BRINDA EXPORTS LIMITED",
"BRINDA FEEDS PRIVATE LIMITED",
"BRINDA PHARMA TECHNOLOGIES PRIVATE LIMITED",
"BRINDABAN RICE MILL PRIVATE LIMITED",
"BRINDABANPUR FOOD PRODUCTS PRIVATE LIMITED",
"BRINDAVAN AGENCIES PRIVATE LIMITED",
"BRINDAVAN AGRO INDUSTRIES PRIVATE LIMITED",
"BRINDAVAN BEVERAGES PRIVATE LIMITED",
"BRINDAVAN BOTTLERS PRIVATE LIMITED",
"BRINDAVAN BUILDERS PRIVATE LIMITED",
"BRINDAVAN COLLEGE OF ENGINEERING",
"BRINDAVAN COTTON MILLS PRIVATE LIMITED",
"BRINDAVAN ENTERPRISES PRIVATE LIMITED",
"BRINDAVAN HYDROPOWER PRIVATE LIMITED",
"BRINDAVAN PRINT SOLUTIONS PRIVATE LIMITED",
"BRINDAVAN PURE QUALITY FOODS (INDIA) PRIVATE LIMITED",
"BRINDAVAN ROLLER FLOUR MILLS PRIVATE LIMITED",
"BRINDAVAN SHELTERS PRIVATE LIMITED",
"BRINDAVAN SPIRITS [I] PRIVATE LIMITED",
"BRINDAVAN VIDYALAYA SCHOOL",
"BRINDCO ENTERPRISES PRIVATE LIMITED",
"BRINDCO SALES PRIVATE LIMITED",
"BRINDHA COTTON MILLS PRIVATE LIMITED BCMPL",
"BRINDHA PAPER BOARDS PRIVATE LIMITED",
"BRINDHAVAN DESIGNS AND BUILDWARE PRIVATELIMITED",
"BRINDHAVAN HIGHER SECONDARY SCHOOL",
"BRINDHAVAN NURSERY AND PRIMARY SCHOOL",
"BRINDHAVVAN AREION HOSPITAL",
"BRING WAY INDIA PRIVATE LIMITED",
"BRINGING MUSIC ALIVE PRIVATE LIMITED",
"BRINGLE HEALTHCARE PRIVATE LIMITED",
"BRINK S INDIA PRIVATE LIMITED",
"BRINMOR CONSTRUCTIONS PRIVATE LIMITED",
"BRIN'S INFRA SOLUTIONS PRIVATE LIMITED",
"BRINTON HEALTHCARE LIMITED",
"BRINTON PHARMACEUTICALS LIMITED",
"BRINTONS CARPETS ASIA PRIVATE LIMITED",
"BRIO AGRI PRODUCER COMPANY LIMITED",
"BRIO BLISS LIFE SCIENCE PRIVATE LIMITED",
"BRIO ENERGY PRIVATE LIMITED",
"BRIO HOSPITALITY PRIVATE LIMITED",
"BRIO INTERACTIVE TECHNOLOGIES PRIVATE LIMITED",
"BRIO PACKAGING PRIVATE LIMITED",
"BRIO PHARMA TECHNOLOGIES PRIVATE LIMITED",
"BRIO TECHNOLOGIES PRIVATE LIMITED",
"BRIOS FINVEST INDIA LIMITED",
"BRIOT TECHNOLOGIES PRIVATE LIMITED",
"BRIPROMTPRO SOLUTIONS (OPC) PRIVATE LIMITED",
"BRISA TECHNOLOGIES PRIVATE LIMITED",
"BRISAM RETAIL PRIVATE LIMITED",
"BRISCA ENTERPRISES PRIVATE LIMITED",
"BRISE CHEMICALS PRIVATE LIMITED",
"BRISK ELECTRO SALES PRIVATE LIMITED",
"BRISK ELECTRONICS PRIVATE LIMITED",
"BRISK ELEVATORS & ESCALATORS PRIVATE LIMITED",
"BRISK ENGINEERING CONSULTANTS AND TECHNOCRATS PRIVATE LIMITED",
"BRISK FACILITIES (SUGAR DIVISION) PRIVATE LIMITED",
"BRISK FREIGHT (INDIA) PRIVATE LIMITED",
"BRISK INDIA PRIVATE LIMITED",
"BRISK INDUSTRIES PRIVATE LIMITED",
"BRISK INFONET PRIVATE LIMITED",
"BRISK INFRASTRUCTURE AND DEVELOPERS PRIVATE LIMITED",
"BRISK OLIVE BUSINESS SOLUTIONS PRIVATE LIMITED",
"BRISK SURGICALS COTTON LIMITED",
"BRISK TECHNOVISION LIMITED",
"BRISK TECHNOVISION PRIVATE LIMITED",
"BRISKMINDS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"BRISKON TECHNOLOGIES PRIVATE LIMITED",
"BRISKWIN IT SOLUTIONS PRIVATE LIMITED",
"BRISKWORLD VENTURES PRIVATE LIMITED",
"BRISLOY METALS INDIA PRIVATE LIMITED",
"BRISLOY TOOLS INDIA PRIVATE LIMITED",
"BRISMEK SAFETY TECHNOLOGIES PRIVATE LIMITED",
"BRISTILE OVERSEAS PRIVATE LIMITED",
"BRISTLECONE INDIA LIMITED",
"BRISTOL BOATS PRIVATE LIMITED",
"BRISTOL FINANCE LTD",
"BRISTOL HEALTH CARE SERVICES PRIVATE LIMITED",
"BRISTOL-MYERS SQUIBB COMPANY",
"BRIT SOAP MACHINERY PRIVATE LIMITED",
"BRITA INDIA WATER SOLUTIONS PRIVATE LIMITED",
"BRITACEL SILICONES LIMITED",
"BRITANNIA DAIRY PRIVATE. LIMITED",
"BRITANNIA GARMENT PACKAGING PRIVATE LIMITED",
"BRITANNIA INDUSTRIES LTD",
"BRITANNIA LABELS INDIA PRIVATE LIMITED",
"BRITAS POLYMERS PRIVATE LIMITED",
"BRITCHIP FOODS LIMITED",
"BRITE AUTOWHEELS PRIVATE LIMITED",
"BRITE COATINGS PRIVATE LIMITED",
"BRITE CONNECT PRIVATE LIMITED",
"BRITE DECOR PRIVATE LIMITED",
"BRITE ENGINEERING CONTROL SWITCHGEARS PRIVATE LIMITED",
"BRITE INTERNATIONAL PRIVATE LIMITED",
"BRITE METALLOY PVT. LTD.",
"BRITE NEON SIGNS PRIVATE LIMITED",
"BRITE PROOFINGS PRIVATE LIMITED",
"BRITE RUBBER PROCESSOR PRIVATE LIMITED",
"BRITELITE ELECTRIC INDUSTRIES PRIVATE LIMITED",
"BRITER PROPERTIES PRIVATE LIMITED",
"BRITESKY BUILDCON PRIVATE LIMITED",
"BRITISH ACADEMY",
"BRITISH AGRO PRODUCTS (INDIA) PRIVATE LIMITED",
"BRITISH AIRWAYS",
"BRITISH AMERICAN TOBACCO CO LIMITED",
"BRITISH BIOLOGICALS",
"BRITISH BROADCASTING CORPORATION",
"BRITISH COUNCIL",
"BRITISH ELECTRIC INSULATING CO PVT LTD",
"BRITISH ENGINES INDIA PRIVATE. LIMITED.",
"BRITISH FORT FOUNDATION CBSE AFFILIATED SCHOOL",
"BRITISH GAS PLC",
"BRITISH HEALTH PRODUCTS INDIA LIMITED",
"BRITISH HIGH COMMISSION",
"BRITISH INTERNATIONAL INVESTMENT INDIA ADVISERS PRIVATE LIMITED",
"BRITISH INTERNATIONAL SCHOOL CHENNAI PRIVATE LIMITED",
"BRITISH LIFE SCIENCES PRIVATE LIMITED",
"BRITISH NUTRITIONS PRIVATE LIMITED",
"BRITISH ORIENT INFOTEL PRIVATE LIMITED",
"BRITISH SCAFFOLDING INTERNATIONAL LIMITED",
"BRITISH SCHOOL OF LANGUAGE",
"BRITISH SUPER ALLOYS PRIVATE LIMITED",
"BRITIVE INDIA PRIVATE LIMITED",
"BRITOMATICS ENGINEERS PRIVATE LIMITED",
"BRITOMATICS INDIA PRIVATE LIMITED",
"BRITON INTERIO PRIVATE LIMITED",
"BRITSUN ENERGIES PRIVATE LIMITED",
"BRITT PHARMA PRIVATE LIMITED",
"BRITT WORLDWIDE INDIA PRIVATE LIMITED",
"BRITTAN ELECTRIC PRIVATE LIMITED",
"BRITTMAN INDIA PRIVATE LIMITED",
"BRITTO AMUSEMENTS PRIVATE LIMITED",
"BRITTO SEA FOODS EXPORTS PRIVATE LIMITED",
"BRITTO TIMBERS PRIVATE LIMITED",
"BRIVAN CONSULTANTS PRIVATE LIMITED",
"BRIVAN DIGISOL PRIVATE LIMITED",
"BRIVAS PRIVATE LIMITED",
"BRIX BIOPHARMA PRIVATE LIMITED",
"BRIXO INDUSTRIES",
"BRIXTAL ELECTRO PRIVATE LIMITED",
"BRIYA ENTERPRISE LIMITED",
"BRIYAA PROJECTSS PRIVATE LIMITED",
"BRIYOSIS SOFT CAPS PRIVATE LIMITED",
"BRIZEAL REALTORS AND DEVELOPERS LLP",
"BRIZO GLOBAL LOGISTICS PRIVATE LIMITED",
"BRIZO REALITY COMPANY PRIVATE LIMITED",
"BRK FOODS PRIVATE LIMITED",
"BRK INFOTECH AND DEVELOPERS PRIVATE LIMITED",
"BRK INFRASTRUCTURE PRIVATE LIMITED",
"BRK RICELAND PRIVATE LIMITED",
"BRKR GOVT AYURVEDIC COLLEGE",
"BRL FOODS PRIVATE LIMITED",
"BRL LOGISTIC PRIVATE LIMITED",
"BRLPS NRLM DPCU JEHANABAD",
"BRM CENTRE PRIVATE LIMITED",
"BRM INDUSTRIES PRIVATE LIMITED",
"BRM INFRASTRUCTURES PRIVATE LIMITED",
"BRMK INDIA PRIVATE LIMITED",
"BRMSCO GARMENTS PRIVATE LIMITED",
"BRN COMMODITIES AND TRADING COMPANY PRIVATE LIMITED",
"BRN GLOBAL LOGISTICS PRIVATE LIMITED",
"BRN INFRASTRUCTURES PRIVATE LIMITED",
"BRND STUDIO PRIVATE LIMITED",
"BRND TECHNOLOGIES INDIA LLP",
"BRO LOGISTICS INDIA PRIVATE LIMITED",
"BROACH TECHNOLOGY (INDIA) PRIVATE LIMITED",
"BROACHCUTTER DRILLING MACHINES PRIVATE LIMITED",
"BROAD AIR CONDITIONING INDIA PRIVATE LIMITED",
"BROAD CAST EQUIPMENTS (INDIA) PRIVATE LIMITED.",
"BROAD HOMES PRIVATE LIMITED",
"BROAD MINDS INFRA PRIVATE LIMITED",
"BROAD SON COMMODITIES PVT LTD",
"BROADBAND PACENET INDIA PRIVATE LIMITED",
"BROADBAND TECHNOLOGIES PRIVATE LIMITED",
"BROADBAND TELECOM PRIVATE LIMITED",
"BROADCAST AUDIENCE RESEARCH COUNCIL",
"BROADCAST CONSULTANCY SERVICES (INDIA) PRIVATE LIMITED",
"BROADCAST ENGINEERING CONSULTANTS INDIA LIMITED",
"BROADCAST IMAGING PRIVATE LIMITED",
"BROADCASTING CORPORATION OF INDIA",
"BROADEN SHIPPING MARINES INDIA PRIVATE LIMITED",
"BROADENING HORIZONS SERVICES PRIVATE LIMITED",
"BROADIDEA INFOCOM PRIVATE LIMITED",
"BROADNET TECHNOLOGIES INDIA PRIVATE LIMITED",
"BROADRIDGE FINANCIAL SOLUTIONS INDIA PRIVATE LIMITED",
"BROADRIDGE TRADING AND CONNECTIVITY SOLUTIONS INDIA PRIVATE LIMITED",
"BROADSOFT TECHNOLOGIES PRIVATE LIMITED",
"BROADSTREAM SOLUTIONS (INDIA) PRIVATE LIMITED",
"BROADVIEW CONSTRUCTIONS AND HOLDINGS PRIVATE LIMITED",
"BROADVIEW IMPEX PRIVATE LIMITED",
"BROADVIEW RESEARCH PRIVATE LIMITED",
"BROADVISION PERSPECTIVES INDIA PRIVATE LIMITED",
"BROADVISION SERVICES PRIVATE LIMITED",
"BROADWAY AUTOWORLD PRIVATE LIMITED",
"BROADWAY EXIM PVT LTD",
"BROADWAY FOUNDRY PRIVATE LIMITED",
"BROADWAY HOSPITALITY SERVICES PRIVATE LIMITED",
"BROADWAY INDUSTRIES PRIVATE LIMITED",
"BROADWAY INFOTECH PRIVATE LIMITED.",
"BROADWAY LINKS PRIVATE LIMITED",
"BROADWAY MALYAN INDIA PRIVATE LIMITED",
"BROADWAY OILS & CHEMICALS PRIVATE LIMITED",
"BROADWAY OVERSEAS LIMITED",
"BROADWAY RECRUITERS AND CONSULTANTS PRIVATE LIMITED",
"BROADWAY ROADLINES PRIVATE LIMITED",
"BROADWAYS CHEMTECH PRIVATE LIMITED",
"BROADWAYS MARKETING CO PVT LTD",
"BROADWINGS LOGISTICS PRIVATE LIMITED",
"BROCADE COMMUNICATIONS SYSTEMS PRIVATE LIMITED",
"BROCADE INDIA POLYTEX LIMITED",
"BROCCOLI AND CARROTS GLOBAL SERVICES PRIVATE LIMITED",
"BROCHILL INTERNET PRIVATE LIMITED",
"BROCTAGON IT SOLUTIONS PRIVATE LIMITED",
"BROEKMAN LOGISTICS INDIA PRIVATE LIMITED",
"BROGA BATH FITTING PRIVATE LIMITED",
"BROIL SOLAR ENERGY PRIVATE LIMITED",
"BROJENDRA PLANTATION PRIVATE LIMITED",
"BROKEN HILL ESTATES PRIVATE LIMITED",
"BROKEN HILL MINING COMPANY",
"BROMINENOBLE CHEMTECH PRIVATE LIMITED",
"BROMO CHEM INDUSTRIES PRIVATE LIMITED",
"BRONA TEA PRIVATE LIMITED",
"BRONIKA FOODS PRIVATE LIMITED",
"BRONKHORST INSTRUMENTATION INDIA PRIVATE LIMITED",
"BRONTOBYTE TECHNOLOGIES PRIVATE LIMITED",
"BRONTOO TECHNOLOGY SOLUTIONS INDIA PRIVATE LIMITED",
"BRONX SYSTEMS INDIA PRIVATE LIMITED",
"BRONZE COMMUNICATIONS PRIVATE LIMITED",
"BRONZE INFRA -TECH LIMITED",
"BRONZE POWDER PVT LTD",
"BRONZEAGLE BUSINESS SERVICES PRIVATE LIMITED",
"BROOCH INTERNATIONAL PRIVATE LIMITED",
"BROOKE DISTRIBUTORS PRIVATE LIMITED",
"BROOKE HOSPITAL FOR ANIMALS (INDIA)",
"BROOKEFIELD CONSTRUCTIONS PRIVATE LIMITED",
"BROOKEFIELD SANJEEVINI HEALTHCARE PRIVATE LIMITED",
"BROOKEFIELD TECHNOLOGIES PRIVATE LIMITED",
"BROOKEFIELDS ESTATES PRIVATE LIMITED",
"BROOKFIELD ADVISORS INDIA PRIVATE LIMITED",
"BROOKFIELD INDIA INFRASTRUCTURE MANAGER PRIVATE LIMITED",
"BROOKFIELD MULTIPLEX INDIA PRIVATE LIMITED",
"BROOKFIELD RENEWABLE (OPERATING) INDIA PRIVATE LIMITED",
"BROOKFIELDS AGRO & DEVELOPMENT PRIVATE LIMITED",
"BROOKPROP MANAGEMENT SERVICES PRIVATE LIMITED",
"BROOKS BROTHERS INDIA PRIVATE LIMITED",
"BROOKS CONSULTING PRIVATE LIMITED",
"BROOKS LABORATORIES LIMITED",
"BROOKWIN TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"BROOMEES INDIA PRIVATE LIMITED",
"BROOOMSTICKS PRODUCTIONS PRIVATE LIMITED",
"BROSCO VALVES PRIVATE LIMITED",
"BROSE INDIA AUTOMOTIVE SYSTEMS PRIVATE LIMITED",
"BROSHAN INDIA PRIVATE LIMITED",
"BROSIL SYNTEHTICS PRIVATE LIMITED",
"BROSIS DECOR AND CONSTRUCTION PRIVATE LIMITED",
"BROSTEK INDUSTRIES PRIVATE LIMITED",
"BROTEX SALES PRIVATE LIMITED",
"BROTHER AND BROTHER GARMENTS PRIVATE LIMITED",
"BROTHER INTERNATIONAL INDIA PRIVATE LIMITED",
"BROTHER OPTICIANS PRIVATE LIMITED",
"BROTHERS ACADEMY EDUCATION PRIVATE LIMITED",
"BROTHERS CARBIDE CUTTING TOOLS PRIVATE LIMITED",
"BROTHERS COIR MILLS PRIVATE LIMITED",
"BROTHERS CREATION HARDWARE PRIVATE LIMITED",
"BROTHERS DIGI WORLD INTERNATIONAL SERVICES INDIA PRIVATE LIMITED",
"BROTHERS ENGINEERING AND ERECTORS LIMITED",
"BROTHERS MARINE CONSULTANTS AND ENGINEERS PRIVATE LIMITED",
"BROTHERS MENS WEAR",
"BROTHERS OUTSOURCING SOLUTIONS PRIVATE LIMITED",
"BROTHERS PHARMAMACH INDIA PRIVATE LIMITED",
"BROTHERS STRETCH YARN PRIVATE. LIMITED.",
"BROWAND HEALTHCARE PRIVATE LIMITED",
"BROWN & BLACK BIO PRIVATE LIMITED",
"BROWN AND WHITE HERBAL INDIA PRIVATE LIMITED",
"BROWN AND WHITE NUTRACEUTICALS PRIVATE LIMITED",
"BROWN BELLY PRODUCTS PRIVATE LIMITED",
"BROWN BIRD ENTERPRISES PRIVATE LIMITED",
"BROWN BULL CLEARING PRIVATE LIMITED",
"BROWN BULL LOGISTICS PRIVATE LIMITED",
"BROWN CONSULTANCY SERVICES PRIVATE LIMITED",
"BROWN DIAMONDS MANUFACTURING LLP",
"BROWN LABEL COFFEE PRIVATE LIMITED",
"BROWN OVERSEAS PRIVATE LIMITED",
"BROWN TREE RETAIL PRIVATE LIMITED",
"BROWN VINIMAY PRIVATE LIMITED",
"BROWN WALL FOODS PRIVATE LIMITED",
"BROWNARC ENTERPRISES PRIVATE LIMITED",
"BROWNCOR PAC PRIVATE LIMITED",
"BROWNDOVE FORMULATIONS PRIVATE LIMITED",
"BROWNDOVE HEALTHCARE PRIVATE LIMITED",
"BROWN-FORMAN INDIA PRIVATE LIMITED",
"BROWNGOLD PAPER INDUSTRIES",
"BROWN'S HI-TECH STRUCTURES PVT LTD",
"BROWNTAPE TECHNOLOGIES PRIVATE LIMITED",
"BROWSERSTACK SOFTWARE PRIVATE LIMITED",
"BROYAD REALTY PRIVATE LIMITED",
"BRP ENTERPRISES PRIVATE LIMITED",
"BRP INFOTECH PRIVATE LIMITED",
"BRP SHOPPE PRIVATE LIMITED",
"BRPL - BAKETECH PRIVATE LIMITED",
"BRPLK CONSTRUCTIONS PRIVATE LIMITED",
"BRR ENTERPRISE PRIVATE LIMITED",
"BRR SECURITIES PRIVATE LIMITED",
"BRRGO METALLICS (INDIA) PRIVATE LIMITED",
"BRRING INTEGRATED LOGISTICS PRIVATE LIMITED",
"BRS ALLOYS PRIVATE LIMITED",
"BRS ENGINEERS AND EQUIPMENT PRIVATE LIMITED",
"BRS ENTERTAINMENT PRIVATE LIMITED",
"BRS GLOBAL SCHOOL",
"BRS HEALTH AND RESEARCH INSTITUTE PRIVATE LIMITED",
"BRS REFINERIES PRIVATE LIMITED",
"BRS SOLVEX PRIVATE LIMITED",
"BRSK INTERNATIONAL PUBLIC SCHOOL",
"BRTC MOVERS AND SUPPLIERS OPC PRIVATE LIMITED",
"BRTR COMMUNICATION PRIVATE LIMITED",
"BRU ENTERPRISES PVT LTD",
"BRU SPECIALITY CHEMICALS PRIVATE LIMITED",
"BRUA HYDROWATT PRIVATE LIMITED",
"BRUBECK RESOURCES PVT LTD",
"BRUCE CLAY INDIA PRIVATE LIMITED",
"BRUCE LOGISTICS PRIVATE LIMITED",
"BRUCHI CLUB APPAREL PRIVATE LIMITED",
"BRUCIRA ONLINE SOLUTIONS PRIVATE LIMITED",
"BRUCK PHARMA PRIVATE LIMITED",
"BRUDER PLASTECH PRIVATE LIMITED",
"BRUDERER PRESSES INDIA PRIVATE LIMITED",
"BRUECKE AND GEBAEUDE ENGINEERS PRIVATE LIMITED",
"BRUECKNER GROUP INDIA PRIVATE LIMITED",
"BRUECKNER MACHINERY SERVICE INDIA PRIVATE LIMITED",
"BRUGAROLAS INDIA PRIVATE LIMITED",
"BRUGG CABLES INDIA PRIVATE LIMITED",
"BRUHASPATI ENTERPRISES PRIVATE LIMITED",
"BRUHAT BENGALURU MAHANAGARA PALIKE",
"BRUHAT INFOCOM PRIVATE LIMITED",
"BRUHAT LOGISTICS PRIVATE LIMITED",
"BRUISED FABRIC SOLUTIONS PRIVATE LIMITED",
"BRUKAAN SHIP AND OFFSHORE PRIVATE LIMITED",
"BRUKAR METAL COMPONENTS PRIVATE LIMITED",
"BRUKEM LIFE CARE PRIVATE LIMITED",
"BRUKER DALTONICS LIMITED",
"BRUKER INDIA SCIENTIFIC PRIVATE LIMITED",
"BRUNCH FOODS INDIA PRIVATE LIMITED",
"BRUNDAVAN LABORATORIES PRIVATE LIMITED",
"BRUNEL INDIA PRIVATE LIMITED",
"BRUNEL LOGISTICS (INDIA) PRIVATE LIMITED",
"BRUNEL LOGISTICS SI PRIVATE LIMITED",
"BRUNGA EXPORT IMPORT PRIVATE LIMITED",
"BRUNO SALES PRIVATE LIMITED",
"BRUNO'S PET FOODS PRIVATE LIMITED",
"BRUNSWICK INVESTMENTS PRIVATE LIMITED",
"BRUSH ARTS",
"BRUSH INDIA MFG PRIVATE LIMITED",
"BRUSHION GLOBAL SOLUTION PRIVATE LIMITED",
"BRUSIA AUTOMATION PRIVATE LIMITED",
"BRUSSELS LABORATORIES PVT LTD",
"BRUVENTIS HEALTHCARE PRIVATE LIMITED",
"BRV CONSULTANTS PRIVATE LIMITED",
"BRV DATA SERVE PRIVATE LIMITED",
"BRV LOGISTICS (INDIA) PRIVATE LIMITED",
"BRY AIR ASIA PRIVATE LIMITED",
"BRY PLAST PRIVATE LIMITED",
"BRYAN & CANDY (I) PRIVATE LIMITED",
"BRYKA ELECTROSYSTEMS AND SOFTWARE PRIVATE LIMITED",
"BRYOGEN PHARMACEUTICALS PRIVATE LIMITED",
"BRYS ADVERTISING PRIVATE LIMITED",
"BRYS RESORTS PRIVATE LIMITED",
"BRYTECAM TECHNOLOGIES PRIVATE LIMITED",
"BRYTESIDE TECHNOLOGIES PRIVATE LIMITED",
"BS & B SAFETY SYSTEMS INDIA LIMITED",
"BS AYURVEDA TOURS INDIA PRIVATE LIMITED",
"BS COLLEGE OF PHYSIOTHERAPHY",
"BS ENVI-TECH PRIVATE LIMITED",
"BS FOILS PRIVATE LIMITED",
"BS HR CONSULTANT PRIVATE LIMITED",
"BS INVENTIONS PRIVATE LIMITED",
"BS LAMINATION INDUSTRIES PRIVATE LIMITED",
"BS MINING AND LOGISTICS PRIVATE LIMITED",
"BS OFFSHORE ACCOUNTING SERVICES LLP",
"BS PROJECTS PRIVATE LIMITED",
"BS SALT PRIVATE LIMITED",
"BS TECHNOTRONICS PRIVATE LIMITED",
"BS TRANSMISSION PRIVATE LIMITED",
"BS&B TECHNOLOGIES PRIVATE LIMITED",
"BSA CITI COURIERS PRIVATE LIMITED",
"BSA CORPORATION LIMITED",
"BSA INDIA FOOD INGREDIENTS PRIVATE LIMITED",
"BSA INFOMEDIA PRIVATE LIMITED",
"BSA LOGISTICS PRIVATE LIMITED",
"BSA MARKETING PRIVATE LIMITED",
"BSA POLYCONTAINER PRIVATE LIMITED",
"BSA REALTORS PRIVATE LIMITED",
"BSA STEELS PRIVATE LIMITED",
"BSA TRADEX PRIVATE LIMITED",
"BSAG CONSULTING PRIVATE LIMITED",
"BSAS INFOTECH LIMITED",
"BSATEAM SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED",
"BSB EDGE PRIVATE LIMITED",
"BSB MARKETING PRIVATE LIMITED",
"BSB MARKETING SERVICES PRIVATE LIMITED",
"BSB PAPER PRIVATE LIMITED",
"BSB PHARMA ANALYTIC PRIVATE LIMITED",
"BSB SECURITES PRIVATE LIMITED",
"BSB WOOLLENS PRIVATE LIMITED",
"BSBK ENGINEERS PRIVATE LIMITED",
"BSBK PRIVATE LIMITED",
"BSBP ESTATES PRIVATE LIMITED",
"BSC- C AND C- KURALI TOLL ROAD LIMITED.",
"BSC INFRACON PRIVATE LIMITED",
"BSC INTERIORS PRIVATE LIMITED",
"BSC PAINTS PRIVATE LIMITED",
"BSC SERVICES PRIVATE LIMITED",
"BSCC OFFSHORE PRIVATE LIMITED",
"BSC-C&C‚ÄôJV‚Äô PATNA",
"BSCIC CERTIFICATIONS PRIVATE LIMITED",
"BSCPL AURANG TOLLWAY LIMITED",
"BSCPL INFRASTRUCTURE LIMITED",
"BSD ISPAT PRIVATE LIMITED",
"BSDI CONSULTING PRIVATE LIMITED",
"BSE ADMINISTRATION & SUPERVISION LIMITED",
"BSE CSR INTEGRATED FOUNDATION",
"BSE EBIX INSURANCE BROKING PRIVATE LIMITED",
"BSE INSTITUTE LIMITED",
"BSE LIMITED",
"BSE TECH INFRA SERVICES PRIVATE LIMITED",
"BSE TECHNOLOGIES PRIVATE LIMITED",
"BSEL ALGO LIMITED",
"BSERAIL ENGINEERING PRIVATE LIMITED",
"B S E S (INDIA) PRIVATE LIMITED",
"BSES KERALA POWER LIMITED",
"BSES RAJDHANI POWER LIMITED",
"BSES YAMUNA POWER LIMITED",
"BSF BASE HOSPITAL",
"BSFT LABS INDIA PRIVATE LIMITED",
"BSG BUSINESS SERVICES PRIVATE LIMITED",
"BSG DAILY ESSENTIALS PRIVATE LIMITED",
"BSG ITSOFT PRIVATE LIMITED",
"BSG SOLAR ECO ENERGY PRIVATE LIMITED",
"BSGC FOODS PRIVATE LIMITED",
"BSH AGRITECH PRIVATE LIMITED",
"BSH HOUSEHOLD APPLIANCES MANUFACTURING PRIVATE LIMITED",
"BSHARP SALES ENABLERS PRIVATE LIMITED",
"BSI COMMERCIAL LIMITED",
"BSI GROUP INDIA PRIVATE LIMITED",
"BSIDEU SERVICES PRIVATE LIMITED",
"BSIFS PRIVATE LIMITED",
"BSIT SOFTWARE SERVICES PRIVATE LIMITED",
"BSK AGROFEEDS PRIVATE LIMITED",
"BSK INTERNATIONAL PRIVATE LIMITED",
"BSK POWER TREE PRIVATE LIMITED",
"BSK S SOLUTIONS PRIVATE LIMITED",
"BSK SOLVENTS & CHEMICALS PRIVATE LIMITED",
"BSL AGENCIES PRIVATE LTD",
"BSL CASTINGS PRIVATE LIMITED",
"BSL ENGINEERING SERVICES LIMITED",
"BSL LIMITED.",
"BSL PLACEMENT PRIVATE LIMITED",
"BSL SCAFFOLDING LIMITED",
"BSM BUSINESS SOLUTIONS PRIVATE LIMITED",
"BSM CLINILAB DIAGNOSTIC AND IMAGING CENTRE PRIVATE LIMITED",
"BSM INTER COLLEGE ROORKEE",
"BSM TECHNOLOGIES PRIVATE LIMITED",
"BSM VENTURES LLP",
"BSMART PRIVATE LIMITED",
"BSN BUILDWELL PRIVATE LIMITED",
"BSN INDUSTRIES PRIVATE LIMITED.",
"BSN MEDICAL PRIVATE LIMITED",
"BSOL SYSTEMS PRIVATE LIMITED",
"BSP DIAGNOSTIC SYSTEMS PRIVATE LIMITED",
"BSP EDUCATION SOCIETY",
"BSP LOGISTICS PRIVATE LIMITED",
"BSP MULTIWORTH INDIA PVT. LTD.",
"BSP PACKAGING PRIVATE LIMITED",
"BSP REFINERIS",
"BSPA INFRATECH PRIVATE LIMITED",
"BSPIONEER VEHICLES AND SERVICES PRIVATE LIMITED",
"BSPL INDIA PVT LTD",
"BSR & ASSOCIATES LLP",
"BSR & CO LLP",
"BSR BUILDERS LLP",
"BSR ENGINEERS PRIVATE LIMITED",
"BSR FOREX TOURS & TRAVELS PRIVATE LIMITED",
"BSR INFRATECH INDIA LIMITED",
"BSR MODULAR INDUSTRIES PRIVATE LIMITED",
"BSR VANAS INFRA PRIVATE LIMITED",
"BSRA05",
"BSRR INFRACON PRIVATE LIMITED",
"BSRS LOGISTICS PRIVATE LIMITED",
"BSS BUSINESS CONSULTANCY PRIVATE LIMITED",
"BSS FACILITY SERVICES PRIVATE LIMITED",
"BSS FARMS PRIVATE LIMITED",
"BSS FOODS AND SPICES PRIVATE LIMITED",
"BSS FOUNDATION",
"BSS MICROFINANCE LIMITED",
"BSS MICROFINANCE PRIVATE. LIMITED. BMPL",
"BSST INDIA PRIVATE LIMITED",
"BST AUTO PRIVATE LIMITED",
"BST ELTROMAT INDIA PRIVATE LIMITED",
"BST INFRATECH LIMITED",
"BST SECURITY AND LABOUR SERVICES PRIVATE LIMITED",
"BST STEELS PRIVATE LIMITED",
"BST TEXTILE MILLS PRIVATE LIMITED",
"BSTALENT SOLUTIONS PRIVATE LIMITED",
"BSTO AUTOMOTIVE PARTS INDIA PRIVATE LIMITED",
"BSTR AUTO INDIA PRIVATE LIMITED",
"B-SUSTAIN ENERGY PROJECTS PRIVATE LIMITED",
"BSV AHIR AND CO",
"BSV SHIPPING AGENCIES PRIVATE LIMITED",
"BSW TECHNICAL SERVICES PRIVATE LIMITED",
"BSY DEVELOPERS PRIVATE LIMITED",
"BSY INFRATECH PRIVATE LIMITED",
"BT AUTOMATION PVT LTD",
"BT COVERGENCE TECHNOLOGIES PRIVATE LIMITED",
"BT DATA AND SURVEYING SERVICES INDIA PRIVATE LIMITED",
"BT E SERV (INDIA) PRIVATE LIMITED",
"BT EXIM PRIVATE LIMITED",
"BT FOOD PRODUCTS PRIVATE LIMITED",
"BT GLOBAL BUSINESS SERVICES PRIVATE LIMITED",
"BT GLOBAL COMMUNICATIONS INDIA PRIVATE LIMITED",
"BT INDIA PRIVATE LIMITED",
"BT INTEGRATED SOLUTIONS PRIVATE LIMITED",
"BT POLYMERS PRIVATE LIMITED",
"BT SOLDERS PRIVATE LIMITED",
"BT TECHLAB PRIVATE LIMITED",
"BT TECHNOLOGIES ONLINE PRIVATE LIMITED",
"BT TELECOM INDIA PRIVATE LIMITED",
"BTA CONSULTANTS INDIA PRIVATE LIMITED",
"BTB DIGITAL PRIVATE LIMITED",
"BTB MARKETING PRIVATE LIMITED",
"BTC DOMESTIC APPLIANCES PRIVATE LIMITED",
"BTC ENTERPRISES PRIVATE LIMITED",
"BTC FOODS AND BEVERAGES PRIVATE LIMITED",
"BTC LAUNDRY EQUIPMENT CO PRIVATE LIMITED",
"BTC PRIVATE LIMITED",
"BTC SOFT PRIVATE LIMITED",
"BTC TRADERS PRIVATE LIMITED",
"BTECH PRECISION ENGINEERING INDIA PRIVATE LIMITED",
"B-TECH SECURITY PRIVATE LIMITED",
"BTF GLOBAL SOLUTIONS PRIVATE LIMITED",
"BTI CONSULTANTS INDIA PRIVATE LIMITED",
"BTI COOPERMATICS INDIA PRIVATE LIMITED",
"BTI FERROCAST PRIVATE LIMITED",
"BTI PAYMENTS",
"BTI TEX PRIVATE LIMITED",
"BTJ LOGISTICS PRIVATE LIMITED",
"BTK INDIA SKILLS PRIVATE LIMITED",
"BTL BIOTECHNO LABS PRIVATE LIMITED",
"BTL EPC LIMITED",
"BTL HERBS AND SPICES PRIVATE LIMITED",
"BTL INDIA PRIVATE LIMITED",
"BTL SERVICE PRIVATE LIMITED",
"BTM EXPORTS LIMITED",
"BTM FORGINGS PRIVATE LIMITED",
"BTN-INSULO INDIA PRIVATE LIMITED",
"BTOBIG IMPEX PRIVATE LIMITED",
"BTOS PRODUCTIONS PRIVATE LIMITED",
"BTOS TALENT MANAGEMENT PRIVATE LIMITED",
"BTP ECO PRODUCTS PRIVATE LIMITED",
"BTP INFOSERVE PRIVATE LIMITED",
"BTPL DISTRIBUTION PRIVATE LIMITED",
"BTPTT SYSTEMS PRIVATE LIMITED",
"BTR PACKAGING PRIVATE LIMITED",
"BTS AMRITA INFOTECH PRIVATE LIMITED",
"BTS STRATEGY ALIGNMENT AND EXECUTION PRIVATE LIMITED",
"BTS STRIPS PRIVATE LIMITED",
"BTS TELECOM PRIVATE LIMITED",
"BTSL AUTOMOTIVE INDIA PRIVATE LIMITED",
"BTT FOREX PRIVATE LIMITED",
"BTU TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"BTW ATLANTA TRANSFORMERS INDIA PRIVATE. LIMITED",
"BTW FOODS PRIVATE LIMITED",
"BTW INDIA PRIVATE LIMITED",
"BUBBER INDUSTRIES PRIVATE LIMITED",
"BUBBLE PACAGE PRIVATE LIMITED",
"BUBBLEFINE POLYPACK PRIVATE LIMITED",
"BUBHANDARI MOTORS PRIVATE LIMITED",
"BUBNA COMMERCIAL PRIVATE LIMITED",
"BUBNA MARKETING SERVICES PVT LTD",
"BUBUGAO COMMUNICATION PRIVATE LIMITED",
"BUCH PLASTICS & PACKAGING PRIVATE LIMITED",
"BUCHA EXPORTS PRIVATE LIMITED",
"BUCHANAN TECHNOLOGIES INDIA LLP",
"BUCHEPALLI VENKAYAMMA SUBBAREDDY ENGINEERING COLLEGE",
"BUCHER HYDRAULICS PRIVATE LIMITED",
"BUCHI INDIA PRIVATE LIMITED",
"BUCHI OPERATIONS INDIA PRIVATE LIMITED",
"BUCHIGLAS INDIA PRIVATE LIMITED",
"BUCHIYA CONTROLS PRIVATE LIMITED",
"BUCK CAPABILITY CENTRE PRIVATE LIMITED",
"BUCKBOX TECHNOLOGIES PRIVATE LIMITED",
"BUCKETLST ADVERTISEMENT PRIVATE LIMITED",
"BUCKEYE PARTNERS L.P.",
"BUCKMAN LABORATORIES ASIA PTE. LIMITED",
"BUCKS SOLUTIONS (OPC) PRIVATE LIMITED",
"BUCOLIC DENIZENS PRIVATE LIMITED",
"BUCON ENGINEERS & INFRASTRUCTURE PRIVATE LIMITED",
"BUCON INFRATECH PRIVATE LIMITED",
"BUDA DAL PUBLIC SCHOOL PATIALA",
"BUDDH INCENSE PRIVATE LIMITED",
"BUDDHA CANCER CENTRE PRIVATE LIMITED",
"BUDDHA EXCELLENCE PRIVATE LIMITED",
"BUDDHA FLOUR MILLS PRIVATE LIMITED",
"BUDDHA INDIA HOTELS PRIVATE LIMITED",
"BUDDHA SORTEX RICE INDUSTRIES PRIVATE LIMITED",
"BUDDIES INFOTECH PRIVATE LIMITED",
"BUDDING LEAF INFRATECH PRIVATE LIMITED",
"BUDDING MINDS INTERNATIONAL SCHOOL",
"BUDDTREE ADVISORY SERVICES PRIVATE LIMITED",
"BUDDY (T-1D) RETAIL PRIVATE LIMITED",
"BUDDY (T-3 DELHI) RETAIL PRIVATE LIMITED",
"BUDDY DISTRIBUTION PRIVATE LIMITED",
"BUDDY MANTRA HOSPITALITY PRIVATE LIMITED",
"BUDDY MANTRA RETAIL PRIVATE LIMITED",
"BUDDY RETAIL PRIVATE LIMITED",
"BUDDYS TRADING PRIVATE LIMITED",
"BUDENHEIM INDIA PRIVATE LIMITED",
"BUDGET CARGO INDIA PRIVATE LIMITED",
"BUDGET COURIERS PRIVATE LIMITED",
"BUDGET FOODS PRIVATE LIMITED",
"BUDGET INFO SOLUTIONS PRIVATE LIMITED",
"BUDGET INTEGRATED LOGISTICS PRIVATE LIMITED",
"BUDGET SIGNS",
"BUDHA INFRASTRUCTURE PRIVATE LIMITED",
"BUDHA MOTORS PRIVATE LIMITED",
"BUDHA SMRITI MINING INFRACON PRIVATE LIMITED",
"BUDHAGI ENGINEERS & CONTRACTORS PRIVATE LIMITED",
"BUDHALE ENGINEER PVT LTD",
"BUDHAN ENGINEERINGS PRIVATE LIMITED",
"BUDHIA AGENCIES PRIVATE LIMITED",
"BUDHIA SAREE EMPORIUM PRIVATE LIMITED",
"BUDHINATH ADVISORY SERVICES PRIVATE LIMITED",
"BUDHKAR PUBLICITY PRIVATE LIMITED",
"BUDHPUR BUILDCON PRIVATE LIMITED",
"BUDHRAJA MINING AND CONSTRUCTIONS LIMITED",
"BUDHRAJA PACKAGING PRIVATE LIMITED",
"BUDHRANI BUILDERS PRIVATE LIMITED",
"BUDHRANI FINANCE PRIVATE LIMITED",
"BUDS AND BLOOMS PRESCHOOL",
"BUDS TEA INDUSTRIES LIMITED",
"BUDWHITE TEAS PRIVATE LIMITED",
"BUEN MANEJO DEL CAMPO INDIA PRIVATE LIMITED",
"BUENA LOGICA TECHNOLOGIES PRIVATE LIMITED",
"BUENA VISTA SCM PRIVATE LIMITED",
"BUENAVENTURA HEALTH AND WELLNESS PRIVATE LIMITED",
"BUENO GIG CREDIT BUILDING TECHNOLOGIES PRIVATE LIMITED",
"BUENO SALUD CARE (INDIA) PRIVATE LIMITED",
"BUESOCO ENTERPRISE PRIVATE LIMITED",
"BUFAB INDIA FASTENERS PRIVATE LIMITED",
"BUFFER LOGISTICS (INDIA) PRIVATE LIMITED",
"BUFFER SHIPPING AGENCY PRIVATE LIMITED",
"BUG BUSTER PEST MANAGEMENT SERVICES PRIVATE LIMITED",
"BUGDANE ENGINEERING PRIVATE LIMITED",
"BUGENDAITECH PRIVATE LIMITED",
"BUGHMARI ISLAMIA HIGH MADRASAH HS",
"BUGMEN AND BADGERER PRIVATE LIMITED",
"BUGWORKS RESEARCH INDIA PRIVATE LIMITED",
"BUHARI FACILITY MANAGEMENT PRIVATE LIMITED",
"BUHARIWALA CORPORATION PRIVATE LIMITED",
"BUHARIWALA LOGISTICS",
"BUHL DATA SERVICE PRIVATE LIMITED",
"BUHLER INDIA PRIVATE LIMITED",
"BUILD CARE SERVICES INDIA PRIVATE LIMITED",
"BUILD CON FINANCE LIMITED",
"BUILD HQ DESIGN LLP",
"BUILD OWN DEVELOPERS PRIVATE LIMITED",
"BUILD2LAST INFRASTUCTURE PRIVATE LIMITED",
"BUILDARCH MARKETING (INDIA) PRIVATE LIMITED",
"BUILDASSIST TECHNOLOGIES PRIVATE LIMITED",
"BUILDBYTE.COM. (INDIA) PRIVATE LIMITED",
"BUILDCON CONSTRUCTION COMPANY PRIVATE LIMITED",
"BUILDCON MATERIAL TESTING AND SERVICES PRIVATE LIMITED",
"BUILDCRAFT INTERIOR PRIVATE LIMITED",
"BUILDCUBE CONSTRUCTIONS PRIVATE LIMITED",
"BUILDERS AND CONSTRUCTORS ENTERPRISES INDIA PRIVATE LIMITED",
"BUILDERS BOX (INDIA) PRIVATE LIMITED",
"BUILDERS ENGINEERING COLLEGE",
"BUILDERS SERVE PRIVATE LIMITED",
"BUILDERSMART BUILDING MATERIALS PRIVATE LIMITED",
"BUILDESY INFRA SOLUTIONS PRIVATE LIMITED",
"BUILDFAST REALTY PRIVATE LIMITED",
"BUILDFIC ENGINEERING PRIVATE LIMITED",
"BUILDFLIC PRIVATE LIMITED",
"BUILDFORMULA VSHWAN (INDIA)",
"BUILDGLOBE INFRASTRUCTURE PRIVATE LIMITED",
"BUILDHR MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"BUILDING BLOCKS PROJECTS INDIA PRIVATE LIMITED",
"BUILDING CONTROL SOLUTIONS INDIA PRIVATE LIMITED",
"BUILDING CRAFTS INDIA PRIVATE LIMITED",
"BUILDING ENVELOPE SYSTEMS INDIA LIMITED",
"BUILDING ENVIRONMENT INDIA PRIVATE LIMITED",
"BUILDING MATERIALS AND TECHNOLOGIES PROMOTION COUNCIL",
"BUILDING TECHNOLOGIES INDIA PRIVATE LIMITED",
"BUILDINGBLOCKS SOFTWARE SERVICES PRIVATE LIMITED",
"BUILDIQUE CONSTRUCTIONS PRIVATE LIMITED",
"BUILDMARK BUILDING MATERIALS AND CONSTRUCTIONS PRIVATE LIMITED",
"BUILDMAT TRADES PRIVATE LIMITED",
"BUILDMET FIBRES PRIVATE LIMITED",
"BUILDMET PRIVATE LIMITED",
"BUILDMYINFRA PRIVATE LIMITED",
"BUILDNET ENGINEERS PRIVATE LIMITED",
"BUILDNEXT INFRACON PRIVATE LIMITED",
"BUILDON PLASTERS PRIVATE LIMITED",
"BUILDQUICK INFRASTRUCTURE PRIVATE LIMITED",
"BUILDSCAPE ENGINEERING SOLUTIONS PRIVATE LIMITED",
"BUILDSQUARE CREATION PRIVATE LIMITED",
"BUILDSTAR PROJECTS PRIVATE LIMITED",
"BUILDSUVIDHA INDIA PRIVATE LIMITED",
"BUILDTECH PRODUCTS INDIA PRIVATE LIMITED",
"BUILDTEK POLYMERS PRIVATE LIMITED",
"BUILDTOUGH REAL ESTATES PRIVATE LIMITED",
"BUILDWEALTH TECHNOLOGIES PRIVATE LIMITED",
"BUILDWELL LAND DEVELOPERS PRIVATE LIMITED",
"BUILDWELL PROJECTS INDIA PRIVATE LIMITED",
"BUILDWORTH PVT LTD",
"BUILDX INTERIOR PRODUCTS PRIVATE LIMITED",
"BUILTIT SYNBAGS PRIVATE LIMITED",
"BUILT-TECH DESIGNS PRIVATE LIMITED",
"BUILTUP ENGINEERING PRIVATE LIMITED",
"BUIMERC CORE INVESTMENTS PRIVATE LIMITED",
"BUJJI FABRICS PRIVATE LIMITED",
"BUKALO INDIA PRIVATE LIMITED",
"BUKKUM SPORTS PRIVATE LIMITED",
"BULAND AGRO CHEM PRIVATE LIMITED",
"BULAND HOUSING PRIVATE LIMITED",
"BULAND INFRASTRUCTURE PRIVATE LIMITED",
"BULANDI REALCON PRIVATE LIMITED",
"BULANDSHAHR ROLLER FLOUR MILL PRIVATE LIMITED",
"BULBULCHANDI ATTA & FLOUR MILLS PRIVATE LIMITED",
"BULBULSHOP SHOPPING NETWORK PRIVATE",
"BULCHAND TRADING PRIVATE LIMITED",
"BULDANA URBAN CO-OPERATIVE CREDIT SOCIETY LIMITED",
"BULDANA URBAN MANAGEMENT SERVICES PRIVATE LIMITED",
"BULFRO MONITECH PRIVATE LIMITED",
"BULI CHEMICALS INDIA PRIVATE LIMITED",
"BULJIN ELMEC PRIVATE LIMITED",
"BULK CARGO CONVEYOR",
"BULK CEMENT CORPORATION (INDIA) LIMITED",
"BULK CONTAINERS INDIA PRIVATE LIMITED",
"BULK LIQUID SOLUTIONS PRIVATE LIMITED",
"BULK MRO INDUSTRIAL SUPPLY PRIVATE LIMITED",
"BULK PACKAGING LINERS PRIVATE LIMITED",
"BULKBAZAR INDIA PRIVATE LIMITED",
"BULKCORP INTERNATIONAL PRIVATE LIMITED",
"BULKLINER LOGISTICS LIMITED",
"BULKLOGIX SHIPPING PRIVATE LIMITED",
"BULKMASTER LOGISTICS PRIVATE LIMITED",
"BULKPACK EXPORTS LIMITED",
"BULKTAINER SHIPPING LIMITED",
"BULKTECHS EQUIPMENTS PRIVATE LIMITED",
"BULKTRANS LOGISTICS PRIVATE LIMITED",
"BULL DOORS INDIA LIMITED",
"BULL FORGE PRIVATE LIMITED",
"BULL INVESTMENTS MADRAS PRIVATE LIMITED",
"BULL MACHINES PRIVATE LIMITED",
"BULL PHARMACEUTICALS PRIVATE LIMITED",
"BULL POWER ENERGY PRIVATE LIMITED",
"BULL ROCK DRILLS PRIVATE LIMITED",
"BULLAND CEMENTS PRIVATE LIMITED",
"BULLAYYA COLLEGE",
"BULLDOG CONSULTANCY SERVICES INDIA PRIVATE LIMITED",
"BULLDYERS INTEGRATED SOLUTIONS PRIVATE LIMITED",
"BULLET CARGO MOVERS PRIVATE LIMITED",
"BULLET LOGISTICS INDIA PRIVATE LIMITED",
"BULLET TRANS SOLUTIONS PRIVATE LIMITED",
"BULLEVENTS MANAGEMENT PRIVATE LIMITED",
"BULLFLEX RUBBERS PRIVATE LIMITED",
"BULLION BUSINESS PRIVATE LIMITED",
"BULLOWS PAINT EQUIPMENT PRIVATE LIMITED",
"BULLS EYE KNOWLEDGE SYSTEM PRIVATE LIMITED",
"BULLS EYE LOGISTICS PRIVATE LIMITED",
"BULL'S EYE OUTSOURCING SERVICES PRIVATE LIMITED",
"BULLSEYE CARGO PRIVATE LIMITED",
"BULLVISION ENTERPRISES PRIVATE LIMITED",
"BULLZ AGRI MACHINES INDIA PRIVATE LIMITED",
"BULMAN SERVICES PRIVATE LIMITED",
"BULWARK SHIPPING & LOGISTICS PRIVATE LIMITED",
"BULWARK TECHNOLOGIES PRIVATE LIMITED",
"BULZAI AGRO PRIVATE LIMITED",
"BULZAI INDIA PRIVATE LIMITED",
"BUMAAS ENGINEERING SOLUTIONS & TECHNOLOGIES PRIVATE LIMITED",
"BUMACO FABRICS PRIVATE LIMITED",
"BUMACO MARKETING PRIVATE LIMITED",
"BUMBERRY BABY PRODUCTS PRIVATE LIMITED",
"BUMI HIWAY INDIA PRIVATE LIMITED",
"BUMPADUM MANUFACTURING AND TRADERS PRIVATE LIMITED",
"BUMPER INDIA PRIVATE LIMITED",
"BUMSA TALENT SOLUTIONS PRIVATE LIMITED",
"BUNAAI WHITEOFFICIAL PRIVATE LIMITED",
"BUNAT CONSTRUCTIONS PRIVATE LIMITED",
"BUNDEL SONS VEHICLES PRIVATE LIMITED",
"BUNDELKHAND AUTOMOBILES PRIVATE LIMITED",
"BUNDELKHAND CARS PRIVATE LIMITED",
"BUNDELKHAND COLLEGE JHANSI",
"BUNDELKHAND ENTERPRISES PRIVATE LIMITED",
"BUNDELKHAND INSTITUTE OF ENGINEERING AND TECHNOLOGY JHANSI",
"BUNDELKHAND MEDICAL COLLEGE SAGAR",
"BUNDELKHAND SAUR URJA LIMITED",
"BUNDELKHAND SEEDS PRIVATE LIMITED",
"BUNDY INDIA LIMITED",
"BUNGALOW8 TECHNOLOGIES PRIVATE LIMITED",
"BUNGE INDIA PRIVATE LIMITED",
"BUNGEE FASHIONS PRIVATE LIMITED",
"BUNGEE TECH INDIA PRIVATE LIMITED",
"BUNIYAD BUILDERS PRIVATE LIMITED",
"BUNIYAD CHEMICALS LIMITED",
"BUNIYAD DEVELOPERS PRIVATE LIMITED",
"BUNIYAD REALTY LIMITED",
"BUNKAARI INDIA RETAIL PRIVATE LIMITED",
"BUNKAR (INDIA) PRIVATE LIMITED",
"BUNKERWORKS MARINE SERVICES PRIVATE LIMITED",
"BUNKOTECH SOLUTIONS PRIVATE LIMITED",
"BUNTROCK INTERNATIONAL PRIVATE LIMITED",
"BUNTS HOTELS PRIVATE LIMITED",
"BUNTS INDUSTRIES PRIVATE LIMITED",
"BUNTS SANGHAS BORIVALI EDUCATION PROJECT",
"BUNTS SANGHA'S SM SHETTY HIGH SCHOOL & JUNIOR COLLEGE",
"BUNTS TOOLS PRIVATE LIMITED",
"BUNTSONS ENGINEERING & RUBBER PRIVATE LIMITED",
"BUNTY BAINS PRODUCTIONS PRIVATE LIMITED",
"BUNTY FOODS (INDIA) PRIVATE LIMITED",
"BUNTY OVERSEAS PRIVATE LIMITED",
"BUOYANCY PLASTICS FOR CHANGE RECYCLING PRIVATE LIMITED",
"BUOYANT CAPITAL PRIVATE LIMITED",
"BUOYANT MARKETING PRIVATE LIMITED",
"BUOYANT TECHNOLOGY CONSTELLATIONS PRIVATE LIMITED",
"BUR PLAST PACKAGING PVT LTD",
"BURAAQ TRADE CENTER LIMITED",
"BURAD CHEMICALS PVT LTD",
"BURAD INTERNATIONAL PRIVATE LIMITED",
"BURAK METERING PRIVATE LIMITED",
"BURAKIA TRADES PRIVATE LIMITED",
"BURANSH TECHNOLOGIES PRIVATE LIMITED",
"BURARI HOSPITAL",
"BURBERRY INDIA PRIVATE LIMITED",
"BURCKHARDT COMPRESSION INDIA PRIVATE LIMITED",
"BURDA DRUCK INDIA PRIVATE LIMITED",
"BURDA MEDIA INDIA PRIVATE LIMITED",
"BURDER INDUSTRIES INDIA PRIVATE LIMITED",
"BURDWAN CO OPERATIVE AGRICULTURE & RURAL DEVELOPMENT BANK LIMITED",
"BURDWAN COLD STORAGE PRIVATE LIMITED",
"BURDWAN DIAGNOSTIC & RESEARCH CENTRE PVT LTD",
"BURDWAN FOOD INDUSTRIES PVT LTD",
"BURDWAN IRON & STEEL COMPANY PVT LTD",
"BURDWAN SCAN CENTRE PVT LTD",
"BUREAU OF IMMIGRATION",
"BUREAU OF INDIAN STANDARDS",
"BUREAU OF RES ON INDUSTRY&ECONOMICS FUNDAMENTALS PRIVATE LIMITED",
"BUREAU VERITAS CONSUMER PRODUCTS SERVICES (INDIA) PRIVATE LIMITED",
"BUREAU VERITAS INDIA PRIVATE LIMITED",
"BUREAU VERITAS INDIA TESTING SERVICES PRIVATE LIMITED",
"BUREAU VERITAS INDUSTRIAL SERVICES INDIA PRIVATE LIMITED",
"BUREAUID INDIA PRIVATE LIMITED",
"BURFANI AGENCIES (INDIA) PRIVATE LIMITED",
"BURFI MUSIC PRIVATE LIMITED",
"BURGE ELECTRONICS PRIVATE LIMITED",
"BURGEON CONSULTANCY SERVICES PRIVATE LIMITED",
"BURGEON ENGINEERING PRIVATE LIMITED",
"BURGEON IT SERVICES PRIVATE LIMITED",
"BURGEON PHARMACEUTICALS PRIVATE LIMITED",
"BURGEON SOFTWARE PRIVATE LIMITED",
"BURGEON VERTICLES PRIVATE LIMITED",
"BURGER CLUB FOODS AND KITCHEN PRIVATE LIMITED",
"BURGER CLUB PRIVATE LIMITED",
"BURGER FARM INDIA PRIVATE LIMITED",
"BURGER FOODS AND HOSPITALITY PRIVATE LIMITED",
"BURGER KING INDIA PRIVATE LIMITED",
"BURGESS ENGLISH HIGHER SECONDARY SCHOOL",
"BURGESS MEMORIAL GIRLS HIGHER SECONDARY SCHOOL",
"BURGULA RAMAKRISHNA RAO GIRLS HIGH SCHOOL",
"BURGUNDY HOSPITALITY PRIVATE LIMITED",
"BURGUNDY HOTELS PRIVATE LIMITED",
"BURHANI COLLEGE",
"BURHANI COMPUTER PRIVATE LIMITED",
"BURHANI DEVELOPERS PRIVATE LIMITED",
"BURHANI NATIONAL ENGLISH HIGH SCHOOL",
"BURHANPUR CLOTH WORLD PRIVATE LIMITED",
"BURHANPUR TEXTILES LIMITED",
"BURHANPURTIRUPATI TRADERS INDIA PRIVATE LIMITED",
"BURJ CONSTRUCTION PRIVATE LIMITED",
"BURLINGTON ENGLISH TRAINING (INDIA) PRIVATE LIMITED",
"BURLINGTON FINANCE LTD.",
"BURLYVETS NUTRITIONAL TECHNOLOGIES PRIVATE LIMITED",
"BURMA AUTOMOTIVES PRIVATE LIMITED",
"BURMAN CAPITAL MANAGEMENT PRIVATE LIMITED",
"BURMAN GROUP OF INSTITUTE ROORKEE",
"BURMAN HOSPITALITY PRIVATE LIMITED",
"BURMAN LABORATORIES PRIVATE LIMITED",
"BURNBILL B2B SOLUTIONS PRIVATE LIMITED",
"BURNCODES LLP",
"BURNDY TECHNOLOGIES GLOBAL BUSINESS SERVICES PVR LIMITED",
"BURNER DIGITAL PRIVATE LIMITED",
"BURNISH SOLAR POWER PRIVATE LIMITED",
"BURNPUR CEMENT LIMITED.",
"BURNPUR POLYFABS PRIVATE LIMITED",
"BURNPUR RIVERSIDE SCHOOL",
"BURNS AND MCDONNELL ENGINEERING INDIA PRIVATE LIMITED",
"BURNT UMBER FASHION PRIVATE LIMITED",
"BURNZ TOURS AND TRAVELS PRIVATE LIMITED",
"BURO ENGINEERS INDIA PRIVATE LIMITED",
"BURO HAPPOLD ENGINEERS INDIA PRIVATE LIMITED",
"BURONEED SUPPLIES PRIVATE LIMITED",
"BURO-SYS FURNITURE PRIVATE LIMITED",
"BURR BROWN INDIA",
"BURR PILGER MAYER INDIA PRIVATE LIMITED",
"BURRITO RESTAURANTS PRIVATE LIMITED",
"BURROUGHS WELCOME PHARMACIA PRIVATE LIMITED",
"BURSYS INFOTECH INDIA PRIVATE LIMITED",
"BURZIN AND LEONS AGENTUREN PRIVATE LIMITED",
"BUSABONG & CO. PRIVATE LIMITED",
"BUSCH MANUFACTURING INDIA PRIVATE LIMITED",
"BUSCH VACUUM INDIA PRIVATE LIMITED",
"BUSETTY JEWELLERS PRIVATE LIMITED",
"BUSH ELECTROMECH AND ENGINEERING PRIVATE LIMITED",
"BUSH ELECTRONICS AND HOME APPLIANCES PRIVATE LIMITED",
"BUSH HARDWARE COLLECTIONS PRIVATE LIMITED",
"BUSHAL CHEMI-PHARMA PRIVATE LIMITED",
"BUSHEK INTEGRATED PRIVATE LIMITED",
"BUSHEL TECHNOLOGIES PRIVATE LIMITED",
"BUSHIDO INFOTECH PRIVATE LIMITED",
"BUSINESS ACCESS (INDIA) PVT LTD",
"BUSINESS AIRCRAFT INTERNATIONAL PRIVATE LIMITED",
"BUSINESS ALGORITHMS PRIVATE LIMITED",
"BUSINESS AUTO FINANCE INDIA",
"BUSINESS AUTOMATION INDORE PRIVATE LIMITED",
"BUSINESS AUTOMATION PRIVATE LIMITED",
"BUSINESS BROADCAST NEWS PRIVATE LIMITED",
"BUSINESS CATALYST AND SCALER PRIVATE LIMITED",
"BUSINESS CO ORDINATION HOUSE PRIVATE LIMITED",
"BUSINESS COMBINE LIMITED",
"BUSINESS CORPORATE ADVISORY SERVICES LLP",
"BUSINESS DEVELOPMENT BUREAU INDIA PRIVATE LIMITED",
"BUSINESS DNA INDIA PRIVATE LIMITED",
"BUSINESS DOCTORS PRIVATE LIMITED",
"BUSINESS ECOSYSTEM PRIVATE LIMITED",
"BUSINESS EXCELLENCE ASSESSMENT PRIVATE LIMITED",
"BUSINESS GATEWAYS INTERNATIONAL ( INDIA ) PRIVATE LIMITED",
"BUSINESS INSTRUMENTS INDIA PRIVATE LIMITED",
"BUSINESS INTEGRATION SYSTEMS INDIA PRIVATE LIMITED",
"BUSINESS INTEGRITY SERVICES PRIVATE LIMITED",
"BUSINESS INTELLI SOLUTIONS INDIA PRIVATE LIMITED",
"BUSINESS INTELLIGENCE CONSULTANT AND SER VICES LLP",
"BUSINESS INTELLIGENCE PROFESSIONALS PRIVATE LIMITED",
"BUSINESS MATCH SERVICES (INDIA) PRIVATE LIMITED",
"BUSINESS MEDIA PRIVATE LIMITED",
"BUSINESS MEDICAL MANAGEMENT SOLUTION, INC 1742 MACADAMIA DRIVE FALLBROOK",
"BUSINESS NEWS AND INFORMATION SERVICES PRIVATE LIMITED",
"BUSINESS OBJECTS ASIA PACIFIC PTE LIMITED",
"BUSINESS OCTANE SOLUTIONS PRIVATE LIMITED",
"BUSINESS PARK MAINTENANCE SERVICES PRIVATE LIMITED",
"BUSINESS PROCESS MATRIX PRIVATE LIMITED",
"BUSINESS PROCESS SOLUTIONS (INDIA) PRIVATE LIMITED",
"BUSINESS PROCESS SOLUTIONS INDIA PRIVATE LIMITED",
"BUSINESS STANDARD PRIVATE LIMITED",
"BUSINESS STUDIO PRIVATE LIMITED",
"BUSINESS SWEDEN THE SWEDISH TRADE & INVEST COUNCIL",
"BUSINESS SYSTEM INDIA LIMITED",
"BUSINESS SYSTEM INDIA PRIVATE LIMITED",
"BUSINESS TRANSPORT RESOURCES INDIA PRIVATE LIMITED",
"BUSINESS TRAVELS PRIVATE LIMITED",
"BUSINESS WEBSOFT PRIVATE LIMITED",
"BUSINESS WORLD ENTERPRISES PRIVATE LIMITED",
"BUSINESSMOJOS SERVICES INDIA PRIVATE LIMITED",
"BUSINESSONE TECHNOLOGIES INDIA PRIVATE LIMITED",
"BUSINET-INFINITY INDIA PRIVATE LIMITED",
"BUSISOFT INFOTECH (INDIA) PRIVATE LIMITED",
"BUSSAN AUTO FINANCE INDIA PRIVATE LIMITED",
"BUSY BEE PACKAGINGS PRIVATE LIMITED",
"BUSY INFOTECH PVT LTD",
"BUSYBEES LOGISTICS SOLUTIONS PRIVATE LIMITED",
"BUSYLAND ARADHANA WHOLESALE SHOPPING MALL PRIVATE LIMITED",
"BUSYMEN OFFSET PRINTERS PVT LTD",
"BUSYSOFT SYSTEMS PRIVATE LIMITED",
"BUTANE POLYMERS (OPC) PRIVATE LIMITED",
"BUTLER LEATHER GOODS FACTORY INDIA PRIVATE LIMITED",
"BUTTA HOSPITALITIES PRIVATE LIMITED",
"BUTTAR BIOFUELS PRIVATE LIMITED",
"BUTTERCUPS BRAS PRIVATE LIMITED",
"BUTTERFLY AYURVEDA PRIVATE LIMITED",
"BUTTERFLY BRAND SOLUTIONS PRIVATE LIMITED",
"BUTTERFLY CREATIONS PVT LTD",
"BUTTERFLY DEALERS PVT LTD",
"BUTTERFLY EDUFIELDS PRIVATE LIMITED",
"BUTTERFLY EFFECT VENTURES PRIVATE LIMITED",
"BUTTERFLY GANDHIMATHI APPLIANCES LIMITED",
"BUTTERFLY HOSPITALS PRIVATE LIMITED",
"BUTTERFLY METAL PRIVATE LIMITED",
"BUTTERFLY SPACE PRIVATE LIMITED",
"BUTTERMILK VILLAGE INDIA PRIVATE LIMITED",
"BUTTERNUT VENTURES PRIVATE LIMITED",
"BUTTERWORTH HOLDINGS PRIVATE LIMITED",
"BUTTON INDUSTRIES PRIVATE LIMITED",
"BUTTONPAY TECHNOLOGIES PRIVATE LIMITED",
"BUTYFUL PRODUCTS & SERVICES PRIVATE LIMITED",
"BUWANIWALA SYSTEMS PRIVATE LIMITED",
"BUXI DIAGNOSTICS PRIVATE LIMITED",
"BUXI JAGABANDHU ENGLISH MEDIUM SCHOOL",
"BUXUS MEDIA PRIVATE LIMITED",
"BUY AND SAVE SUPERMARKET PRIVATE LIMITED",
"BUY AND SELL PRINTERS AND TRADERS PRIVATE LIMITED",
"BUY HAPPY MARKETING LLP",
"BUY RIGHT IMPEX LIMITED",
"BUYBULLS INDIA PRIVATE LIMITED",
"BUYCEPS INDIA PRIVATE LIMITED",
"BUYERASSIST.IO INDIA PRIVATE LIMITED",
"BUYERSROAD INDIA PRIVATE LIMITED",
"BUYHATKE INTERNET PRIVATE LIMITED",
"BUYMEC EXPORTS PRIVATE LIMITED",
"BUYOUT RETAIL INDIA PRIVATE LIMITED",
"BUYSELL INTERACTIONS PRIVATE LIMITED",
"BUYSELLTIPS FINANCIAL RESEARCH PRIVATE LIMITED",
"BUYWEL AGENCIES PRIVATE LIMITED",
"BUYWEL HEALTHCARE PRIVATE LIMITED",
"BUZ KREATORZ PRIVATE LIMITED",
"BUZA FOODS PRIVATE LIMITED",
"BUZET WEB DIGITAL (OPC) PRIVATE LIMITED",
"BUZIL ROSSARI PRIVATE LIMITED",
"BUZYBEEZZ ONLINE SERVICES PRIVATE LIMITED",
"BUZZ INTERACTION PRIVATE LIMITED",
"BUZZ RETAIL INDIA PRIVATE LIMITED",
"BUZZ TRAVEL MARKETING INDIA PRIVATE LIMITED",
"BUZZCITY TECHNOLOGIES INDIA PRIVATE LIMITED",
"BUZZCLAN INFO SERVICES PRIVATE LIMITED",
"BUZZIFY MEDIA PRIVATE LIMITED",
"BUZZINGA DIGITAL PRIVATE LIMITED",
"BUZZWORD TECHNOLOGIES PRIVATE LIMITED",
"BUZZYBRAINS SOFTWARE (INDIA) PRIVATE LIMITED",
"BV RAJU INSTITUTE OF TECHNOLOGY",
"BVA AUTO PVT LTD",
"BVALUE SERVICES PRIVATE LIMITED",
"BVAST MANGEMENT CONSULTANTS PRIVATE LIMITED",
"BVB COLLEGE OF ENGINEERING & TECHNOLOGY",
"BVC BRINKS DIAMOND & JEWELLERY SERVICES LLP",
"BVC ENGINEERING COLLEGE",
"BVC ESERVICES PRIVATE LIMITED",
"BVC EXPORTS PRIVATE LIMITED",
"BVC INSTITUTE OF TECHNOLOGY & SCIENCE",
"BVC TOURS AND TRAVELS PRIVATE LIMITED",
"BVC TRADEPORT PRIVATE LIMITED",
"BVC VENTURES PRIVATE LIMITED",
"BVD POWER PRIVATE LIMITED",
"BVG AGROTECH PRIVATE LIMITED",
"BVG BMATRIX LLP",
"BVG CLEAN ENERGY LIMITED",
"BVG EDUCATIONAL TRUST",
"BVG ELECTRONICS (INDIA) PRIVATE LIMITED",
"BVG HEALTH FOOD PRIVATE LIMITED",
"BVG INDIA LIMITED",
"BVG INDUSTRIES PRIVATE LIMITED",
"BVG LIFE SCIENCES LIMITED",
"BVG SKILL ACADEMY",
"BVG SPACETHETICS PRIVATE LIMITED",
"BVK COLLEGE",
"BVK EXPORTS INDIA PRIVATE LIMITED",
"BVK'S BIOSCIENCE PRIVATE LIMITED",
"BVL GRANITES",
"BVM ENERGY AND RESIDENCY PRIVATE LIMITED",
"BVM ENGINEERING COLLEGE",
"BVM GLOBAL GROUP OF SCHOOLS",
"BVM HINDI NIGHT HIGH SCHOOL",
"BVM INTERNATIONAL SCHOOL",
"BVM IT CONSULTING SERVICES INDIA PRIVATE LIMITED",
"BVM MEDITECH PRIVATE LIMITED",
"BVM OUTSOURCING SERVICES PRIVATE LIMITED",
"BVM OVERSEAS LIMITED",
"BVM PACKAGING PRIVATE LIMITED",
"BVM STORAGE SOLUTION PRIVATE LIMITED",
"BVM TECHNOLOGIES PRIVATE LIMITED",
"BVM TEXTILES PRIVATE LIMITED",
"BVN TRADERS AND SUPPLIERS PRIVATE LIMITED",
"BVP INDIA INVESTORS PRIVATE LIMITED",
"BVR ENGINEERING PRIVATE LIMITED",
"BVR MALLS PRIVATE. LIMITED.",
"BVRIT COLLEGE OF ENGINEERING FOR WOMEN",
"BVS CARGO AND MOVERS PRIVATE LIMITED",
"BVS ENGINEERING SERVICE",
"BVS RECOVERIES & BUSINESS SOLUTIONS PRIVATE LIMITED",
"BVS STUDIOS PRIVATE LIMITED",
"BVSP ENERGENIQ PRIVATE LIMITED",
"BVSR CONSTRUCTIONS PRIVATE LIMITED",
"BVSR HARDA BETUL ROAD PROJECTS PRIVATE LIMITED",
"BVSR KP ROAD PROJECTS PRIVATE LIMITED",
"BVSR PAM ROAD PROJECTS PRIVATE LIMITED",
"BVSR PRP ROAD PROJECTS PRIVATE LIMITED",
"BVSR SSG ROAD PROJECTS PRIVATE LIMITED",
"BW BUSINESSWORLD MEDIA PRIVATE LIMITED",
"BW GLOBAL UNITED LPG INDIA PRIVATE LIMITED",
"BW MARITIME PTE. LIMITED.",
"BWC FORWARDERS PRIVATE LIMITED",
"BWC LABS PRIVATE LIMITED",
"BWC LOGISTICS SOLUTION PRIVATE LIMITED",
"BWDA FINANCE LIMITED",
"BWDA MERCANTILE PRIVATE LIMITED",
"BWE ENERGY INDIA PRIVATE LIMITED",
"BWF TEC INDIA PRIVATE LIMITED",
"BWI AUTOMOTIVE TECHNOLOGIES PRIVATE LIMITED",
"BWI EDUCON VENTURES PRIVATE LIMITED",
"BWI LOGISTICS PRIVATE LIMITED",
"BWN ALLOYS PRIVATE LIMITED",
"BWR OVERSEAS PRIVATE LIMITED",
"BWW GLOBAL PRIVATE LIMITED",
"BY DESIGN JEWELLERY PRIVATE LIMITED",
"BY DESIGNER LLP",
"BY HANNA BRAND SOLUTIONS PRIVATE LIMITED",
"BYAS INFRABUILD PRIVATE LIMITED",
"BYCERO SOLUTIONS PRIVATE LIMITED",
"BYD INDIA PRIVATE LIMITED",
"BYDEK PRIVATE LIMITED",
"BYDESIGN INDIA PRIVATE LIMITED",
"BYG VENTURES LLP",
"BYGGING INDIA LIMITED",
"BYGGING INDIA LTD",
"BYGGING INFRASTRUCTURE PRIVATE LIMITED",
"BYICOM TECHNOLOGIES PRIVATE LIMITED",
"BYK COLLEGE OFCOMMERCE SINNAR JDC B",
"BYK INDIA PRIVATE LIMITED",
"BYKEMANIA SOLUTIONS PRIVATE LIMITED",
"BYL NAIR HOSPITAL & MEDICAL COLLEG",
"BYNARIC SYSTEMS PRIVATE LIMITED",
"BYNDR TECHNOLOGIES INDIA PRIVATE LIMITED",
"BYNEMARA ESTATES PRIVATE LIMITED",
"BYNRY TECHNOLOGIES INDIA PRIVATE LIMITED",
"BYOS MEMORY STACK PRIVATE LIMITED",
"BYRAMJEE JEEJEEBHOY PRIVATE LIMITED",
"BYRL MEDICAL INDIA PRIVATE LIMITED",
"BYRNIHAT WOOD INDUSTRIES PRIVATE LIMITED",
"BYS SKILLS PRIVATE LIMITED",
"BYSTRONIC LASER INDIA PRIVATE LIMITED",
"BYTAMORPH ZONA PRIVATE LIMITED",
"BYTE AND GULP RESTAURANTS PRIVATE LIMITED",
"BYTE COMMUNICATIONS PRIVATE LIMITED",
"BYTE CONSULTING PRIVATE LIMITED",
"BYTE DATA TECHNOLOGY SERVICES INDIA PRIVATE LIMITED",
"BYTE INFOSYSTEMS PRIVATE LIMITED",
"BYTE PERIPHERAL SYSTEMS PRIVATE LIMITED",
"BYTE PLUS NETWORKS PRIVATE LIMITED",
"BYTEALLY SOFTWARE SOLUTIONS PRIVATE LIMITED",
"BYTECH INDIA PRIVATE LIMITED",
"BYTEFORZA TECHNOLOGIES PRIVATE LIMITED",
"BYTEIQ ANALYTICS PRIVATE LIMITED",
"BYTEMARK TECHNOLOGY SOLUTIONS INDIA PRIVATE LIMITED",
"BYTEME TECHNOLOGIES LLP",
"BYTERIDERZ INDIA PRIVATE LIMITED",
"BYTERIDGE SOFTWARE PRIVATE LIMITED",
"BYTES EVOLUTION SYSTEMS PRIVATE LIMITED (OPC)",
"BYTES INFRATECH PRIVATE LIMITED",
"BYTES SOFTECH PRIVATE LIMITED",
"BYTESCALE TECHNOLOGIES PRIVATE LIMITED",
"BYTEXL INDIA PRIVATE LIMITED",
"BYTIZE TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"BYUCKSAN INDIA PRIVATE LIMITED",
"BYWELL CONFECTIONERS PRIVATE LIMITED",
"BYZAN SYSTEMS PRIVATELIMITED",
"BYZEN INFRA-TECH PRIVATE LIMITED",
"BZONE ENGINEERING AND CONSTRUCTION PRIVATE LIMITED",
"C & C ALPHA GROUP INDIA PRIVATE LIMITED",
"C & E LIMITED",
"C & I MARKETING PRIVATE LIMITED",
"C & K MANAGEMENT LIMITED",
"C & M DIGITALS PRIVATE LIMITED",
"C & M SWITCHGEAR ENTERPRISES PRIVATE LIMITED",
"C & R LEATHER FASHION PRIVATE LIMITED",
"C & R TEXTTILES PRIVATE LIMITED",
"C & V IMPEX PRIVATE LIMITED",
"C 1 INDIA PRIVATE LIMITED",
"C 4 INFRASTRUCTURES PRIVATE LIMITED",
"C A G ENGINEERING LIMITED",
"C A G HOTELS PRIVATE LIMITED",
"C A GALIAKOTWALA AND COMPANY PRIVATE LIMITED",
"C A LOGISTICS PRIVATE LIMITED",
"C A O DIRECTORATE OF SPORT AND YOUTH WELFARE",
"C A PATEL TEXTILES PVT LTD",
"C A POLYCARE PVT LTD",
"C A POLYTECH PRIVATE LIMITED",
"C AND A AGENCIES PRIVATE LIMITED",
"C AND C HOTELSVENTURE PRIVATE LIMITED",
"C AND F POLYMERS PRIVATE LIMITED",
"C AND G BUILDING CONSULTANCY PRIVATE LIMITED",
"C AND I CALIBRATIONS PRIVATE LIMITED",
"C AND R FAB MEDIA PRIVATE LIMITED",
"C B & SONS CONSTRUCTIONS PRIVATE LIMITED",
"C B ADARSH VIDYA MANDIR HIGHSCHOOL",
"C B DISTRIBUTORS",
"C B ELECTRICS INDIA PRIVATE LIMITED",
"C B M INDUSTRIE LIMITED",
"C B MEMORIAL NURSING HOME",
"C B PATEL ARTS COLLEGE NADIAD",
"C B S PUBLISHERS AND DISTRIBUTORS PRIVATE LIMITED",
"C B SURATWALA & SONS",
"C BHOGILAL WEST END PRIVATE LIMITED",
"C BIDYUT JUNIOR MAHAVIDYALAYA",
"C BYREGOWDA INSTITUTE OF TECHNOLOGY",
"C C L OPTOELECTRONICS PRIVATE LIMITED",
"C C SAHA LTD",
"C CENTRIC SOLUTIONS PRIVATE LIMITED",
"C COM ENTERPRISES PRIVATE LIMITED",
"C D B 24 KARAT INTERNATIONAL JEWELLERS PRIVATE LIMITED",
"C D COMMODITIES BROKING LIMITED",
"C D INDUSTRIES UNIT OF KISAAN ENGINEERING WORKS PRIVATE LIMITED",
"C D INTEGRATED SERVICES LIMITED",
"C D S CONSTRUCTION CO PVT LTD",
"C DINESH & COMPANY PRIVATE LIMITED",
"C DOCTOR INDIA PRIVATE LIMITED",
"C DOT SYSTEMS PRIVATE LIMITED",
"C E ENTERPRISES PRIVATE LIMITED",
"C E INFO SYSTEMS LIMITED",
"C E O JANPAD PANCHAYAT MAHIDPUR",
"C E O JANPAD PANCHAYAT SAILANA RATLAM",
"C E O JANPAD PANCHAYAT UJJAIN",
"C E P W D UJJAIN ZONE UJJAIN",
"C E TESTING COMPANY PVT LTD",
"C E URJA N V D A BHOPAL",
"C EDGE TECHNOLOGIES LIMITED",
"C F C PRODUCTS PRIVATE LIMITED",
"C F S FINANCIAL SERVICES PRIVATE LIMITED",
"C G GOVT SCHOOL EDUCATION DISTRICT EDUCATION OFFICER RAIPUR C G",
"C G LOGISTICS PRIVATE LIMITED",
"C G PARAIVAR PRIVATE LIMITED",
"C G RAJYA VAN VIKAS NIGAM LTD",
"C G STATE POWER TRANSMISSION COMPANY LIMITED",
"C G STATE RENEWABLE ENERGY DEVELOPMENT AGENCY",
"C GEMS AND JEWELS PRIVATE. LIMITED.",
"C H JEWELLERS PRIVATE LIMITED",
"C H ROBINSON WORLDWIDE FREIGHT INDIA PRIVATE LIMITED",
"C H TECHNOLOGY SOLUTIONS INDIA PRIVATE LIMITED",
"C I 2 JEWELLERY PRIVATE LIMITED",
"C I AUTOMOTORS PRIVATE LIMITED",
"C I I E INITIATIVES",
"C I INFOTECH PRIVATE LIMITED",
"C I LIMITED",
"C I NETWORK TECHNOLOGIES PRIVATE LIMITED",
"C I S ECO PRIVATE LIMITED",
"C J INTERNATIONAL HOTELS LIMITED",
"C J JEWELLERIES PRIVATE LIMITED",
"C J ONLINE PRIVATE LIMITED",
"C J POLYTECH PRIVATE LIMITED",
"C J S SPECIALTY CHEMICALS PRIVATE LIMITED",
"C J SHAH & COMPANY",
"C JAIRAM PRIVATE LIMITED",
"C K COTSPIN PRIVATE LIMITED",
"C K EARTHMOVERS PRIVATE LIMITED",
"C K FABRICS PRIVATE LIMITED",
"C K GOYAL JUNIOR COLLEGE",
"C K INFRASTRUCTURES LIMITED",
"C K K RETAIL MART LIMITED",
"C K K RETAIL MART PRIVATE LIMITED",
"C K OXYGEN PRIVATE LIMITED",
"C KRISHNIAH CHETTY & C0 PRIVATE LIMITED",
"C KRISHNIAH CHETTY JEWELLERS PRIVATE LIMITED",
"C L ENTERPRISES PVT LTD",
"C L GUPTA EXPORTS LIMITED",
"C L M INT COLL JANI MEERUT",
"C L PRODUCTS INDIA LIMITED",
"C L PUBLIC SCHOOL",
"C L R N SEKSARIA INT COLL HATHRAS",
"C L S LTD",
"C L SHARMA RESORTS PRIVATE LIMITED",
"C LAL ALLOYS PVT LTD",
"C M AND H O",
"C M AND H O HARDA",
"C M AND H O KHANDWA",
"C M ANGLO BENGALI INTER COLLEGE",
"C M ASSOCIATES PRIVATE LIMITED",
"C M AUTOSALES PRIVATE LIMITED",
"C M CARS PRIVATE LIMITED",
"C M GANDHI CONSTRUCTION PRIVATE LIMITED",
"C M GOENKA CAPITAL MARKETS PRIVATE LIMITED",
"C M INFRASTRUCTURE PRIVATE LIMITED",
"C M JAIN IMPEX AND INVESTMENTS PRIVATE LIMITED",
"C M LOGISTICS INDIA PRIVATE LIMITED",
"C M MARKETING AND RESEARCH PRIVATE LIMITED",
"C M NURSING INSTITUTE",
"C MET PUNE CENTRE FOR MATERIALS FOR ELECTRONICS TECHNOLOGY",
"C METRIC SOLUTIONS PRIVATE LIMITED",
"C MOHAN PRODUCTS PRIVATE LIMITED",
"C MOHANLAL PRIVATE LIMITED",
"C N ARTS AND BD COMMERCE COLLEGE",
"C N C NETWORK PRIVATE LIMITED",
"C N R PROJECTS INDIA PRIVATE LIMITED",
"C N S HOSPITAL PRIVATE LIMITED",
"C N S MOTORS PRIVATE LIMITED",
"C N SANGHAVI AND COMPANY (FORWARDS) PRIVATE LIMITED",
"C N TECH ENGINEERS PRIVATE LIMITED",
"C NET INFOTECH PRIVATE LIMITED",
"C NET SOFTWARE SERVICES PVT LTD",
"C O 24 BATALION MP NCC CWA",
"C P AND ASSOCIATES PRIVATE LIMITED",
"C P AQUACULTURE (INDIA) PRIVATE LIMITED",
"C P BAGAL INFRA PRIVATE LIMITED",
"C P C EQUIPMENTS PVT LTD",
"C P C PRIVATE LIMITED",
"C P CARGO MOVERS PRIVATE LIMITED",
"C P FLUID SYSTEMS PRIVATE LIMITED",
"C P FOOTWEAR PRIVATE LIMITED",
"C P ISPAT (UNIT 2) PRIVATE LIMITED",
"C P ISPAT PVT LTD",
"C P KUKREJA AND ASSOCIATES PRIVATE LIMITED",
"C P MILK AND FOOD PRODUCTS PRIVATE LIMITED",
"C P R CONSTRUCTIONS PRIVATE LIMITED",
"C P S SHAPERS LIMITED",
"C P THAKKAR AND COMPANY (PHARMA) LIMITED",
"C P WORLD LINES PRIVATE LIMITED",
"C PEARL REAL ESTATE CONSULTANTS BUILDERS PRIVATE LIMITED",
"C R AULUCK AND SONS PRIVATE LIMITED",
"C R COMMTRADE PRIVATE LIMITED",
"C R ENTERPRISE",
"C R FOODS (INDIA) PVT LTD",
"C R I AMALGAMATIONS PRIVATE LIMITED",
"C R I PUMPS PRIVATE LIMITED",
"C R IMPEX PRIVATE LIMITED",
"C R KOTHARI AND SONS SHARES AND STOCK BROKERS PRIVATE LIMITED",
"C R KOTHARI AND SONS STOCK BROKING PRIVATE LIMITED",
"C R MALHOTRA APPARELS",
"C R NARAYANA RAO CONSULTANTS PRIVATE LIMITED",
"C R POLYMERS PRIVATE LIMITED",
"C R PRIME FOODS INTERNATIONAL PRIVATE LIMITED",
"C R TOURS & TRAVELS PRIVATE LIMITED",
"C S ADVISORS & CONSULTANTS PRIVATE LIMITED",
"C S CASTINGS PRIVATE LIMITED",
"C S CONSTRUCTION COMPANY PRIVATE LIMITED",
"C S CREAMERY PRIVATE LIMITED",
"C S CUM HOSPITAL SUPDT DIST DEWAS",
"C S CUM HOSPITAL SUPDT DIST UJJAIN",
"C S CUM HOSPITAL SUPDT INDORE MADHYA PRADESH",
"C S CUM HOSPITAL SUPDT SEHORE",
"C S CUM SUPDT HOSPITAL HBAD HOSHANGABAD",
"C S DIESEL ENGINEERING PRIVATE LIMITED",
"C S DIREKT EVENTS AND EXHIBITIONS PRIVATE LIMITED",
"C S FORGINGS PRIVATE LIMITED",
"C S I EWART MATRICULATION HIGHER SECONDARY SCHOOL",
"C S INFOCOMM PRIVATE LIMITED",
"C S J M UNIVERSITY KANPUR",
"C S K REALTORS LIMITED",
"C S LEASE FIN LIMITED",
"C S MECHANICAL WORKS PRIVATE LIMITED",
"C S SOFT SOLUTIONS INDIA PRIVATE LIMITED",
"C S TECH INFOSOLUTIONS PRIVATE LIMITED",
"C S TRAVELS PRIVATE LIMITED",
"C SANKAR TRADING AND CONSULTANCY PRIVATE LIMITED",
"C SHEKHARAZAD UNIV OF AGRI N TECHNO",
"C SQUARE HEALTHCARE PRIVATE LIMITED",
"C SQUARE INFO SOLUTIONS LIMITED",
"C SYSTEMS PRIVATE LIMITED",
"C T ASSOCIATES PRIVATE LIMITED",
"C T C AIR CARRIERS PRIVATE LIMITED",
"C T PUNDOLE AND SONS HOROLOGY PRIVATE LIMITED",
"C T R MANUFACTURING INDUSTRIES PRIVATE LIMITED",
"C TECH NUTRISCIENCE PRIVATE LIMITED",
"C TEL INFOSYSTEMS PRIVATE LIMITED",
"C TEX FAB PRIVATE LIMITED",
"C THREE WEATHER CONTROL P LIMITED",
"C TOURS LIMITED",
"C U INSPECTIONS INDIA PRIVATE LIMITED",
"C U SHAH GOVERNMENT POLYTECHNIC",
"C U SHAH MEDICAL COLLEGE & HOSPITAL",
"C V KARIA CLEARING AND FORWARDING PRIVATE LIMITED",
"C V M HIGHER SECONDARY EDUCATION COMPLEX SCIENCE STREM",
"C V TECHNOLOGIES PRIVATE LIMITED",
"C VISION IT PRIVATE LIMITED",
"C W LOGIX PRIVATE LIMITED",
"C ZONE INFRA PRIVATE LIMITED",
"C&A SOURCING INTERNATIONAL LIMITED",
"C&B ECOGEN PRIVATE LIMITED",
"C&B MASSCON PRIVATE LIMITED",
"C&B POWERGEN PRIVATE LIMITED",
"C&M LAYER FARMS PRIVATE LIMITED",
"C&R VALVES PRIVATE LIMITED",
"C&S ELECTRIC LIMITED",
"C. B. CONSTRACTIONS PRIVATE LIMITED",
"C. B. ONLINE PRIVATE LIMITED",
"C. BHOGILAL TRADING COMPANY PRIVATE LIMITED",
"C. D. S. POLYMERS PRIVATE LIMITED",
"C. J. CHEMICALS PRIVATE LIMITED",
"C. LAL MARKETING PRIVATE LIMITED",
"C. MACKERTICH PRIVATE LIMITED",
"C. MANOHAR INNOVATIONS PRIVATE LIMITED",
"C. MOHAN FABRICS PRIVATE LIMITED",
"C. NET COMMUNICATIONS (INDIA) PRIVATE LIMITED",
"C. R. PROPERTIES TECHNOLOGY PRIVATE LIMITED",
"C. S. DALMIA TEXTILES PRIVATE LIMITED",
"C. S. INFRACONSTRUCTION LIMITED",
"C. S. WIRES PRIVATE LIMITED",
"C T PUNDOLE & SONS PRIVATE LIMITED",
"C.A.C PROJECTS PRIVATE LIMITED",
"C.B. JINDAL ALUMINIUM PRIVATE LIMITED",
"C.B. MACHINERY SOLUTIONS PRIVATE LIMITED",
"C.B.M INDUSTRIES LIMITED",
"C.C. JENSEN FILTRATION PRIVATE LIMITED",
"C.C.S. PROJECTS AND EQUIPMENTS PRIVATE LIMITED",
"C.D. POWER PRIVATE LIMITED",
"C.D.B.24 KARAT GOLD AND DIAMONDS PRIVATE LIMITED",
"C.D.E. HYGIENE PRIVATE LIMITED",
"C.D.ZARDA WORKS PRIVATE LIMITED",
"C.E. INFO SYSTEMS LIMITED",
"C.E. INFO SYSTEMS PRIVATE LIMITED",
"C.G. TECHNOSOFT PRIVATE LIMITED",
"C.G.ISPAT PRIVATE LIMITED",
"C.H.ROBINSON INTERNATIONAL INDIA PRIVATE LIMITED",
"C.H.WOOLLEN MILLS PVT LTD",
"C.I.BUILDERS PRIVATE LIMITED",
"C.I.FINLEASE PRIVATE LIMITED",
"C.J SALES PRIVATE LIMITED",
"C.J. DIAMONDS PRIVATE LIMITED",
"C.J.GELATINE PRODUCTS LIMITED",
"C.K. ELNET PRIVATE LIMITED",
"C.K. INDUSTRIES",
"C.L. PROPERTIES PRIVATE LIMITED",
"C.L.GULHATI AND SONS LIMITED",
"C.L.P.D. INDUSTRIES PRIVATE LIMITED",
"C.LAL BRIGHT STEELS PRIVATE LIMITED",
"C.M. FOODS PRIVATE LIMITED",
"C.M.M. HOTEL PRIVATE LIMITED",
"C.M.R. TRANSPORT CONTRACTORS COMPANY PRIVATE LIMITED",
"C.M.S. IMPEX INDIA PRIVATE. LIMITED.",
"C.N. PAPIER PRIVATE LIMITED",
"C.P. ARORA ENGINEERS-CONTRACTORS PRIVATE LIMITED",
"C.P. MARBLES PRIVATE LIMITED",
"C.P. PATEL FARM SEEDS PRIVATE LIMITED",
"C.P. SPONGE IRON PRIVATE LIMITED",
"C.P.COLD STORAGE PRIVATE LIMITED",
"C.P.K. ENGINEERS PVT. LTD.",
"C.R. CLOTHING PRIVATE LIMITED.",
"C.R. KOTHARI AND SONS STOCK BROKING PRIVATE LIMITED",
"C.S HAWKLER LOGISTICS PRIVATE LIMITED",
"C.S. TECHNOBUILD PRIVATE LIMITED",
"C.S.R INFRATECH INDIA PRIVATE LIMITED",
"C.S.S. VENNAL NAIDU AND SONS PRIVATE LIMITED",
"C.S.SOFT SOLUTIONS (INDIA) PRIVATE LIMITED",
"C.T.O CARRIERS LIMITED",
"C.V. SPINNERS PRIVATE LIMITED",
"C15 MRI IMAGING & DIAGNOSTICS RESEARCH CENTRE LIMITED.",
"C1X ADTECH PRIVATE LIMITED",
"C2C ENGINEERING PRIVATE LIMITED",
"C2C ORGANIZATIONAL DEVELOPMENT PRIVATE LIMITED",
"C2D SOFTWARE PRIVATE LIMITED",
"C2FO FACTORING SOLUTIONS PRIVATE LIMITED",
"C2L BIZ SOLUTIONS PRIVATE LIMITED",
"C2M TECHNOLOGIES INDIA LIMITED",
"C2N IT SERVICES PRIVATE LIMITED",
"C2S TECHNOLOGIES INDIA PRIVATE LIMITED",
"C3 MULTI SPECIALITY HOSPITAL LIMITED",
"C360 DESIGN SOLUTIONS PRIVATE LIMITED",
"C37 HEALTHCARE PRIVATE LIMITED",
"C3CONTROLS INDUSTRIAL AUTOMATION INDIA PRIVATE LIMITED",
"C3I SUPPORT SERVICES PRIVATE LIMITED",
"C3IT SOFTWARE SOLUTIONS PRIVATE LIMITED",
"C4G AUTOMATION PRIVATE LIMITED",
"C4I TECHNOLOGIES PRIVATE LIMITED",
"C5 COLDCHAIN INDIA PRIVATE LIMITED",
"CA (INDIA) TECHNOLOGIES PRIVATE LIMITED",
"CA AND S SOLUTIONS PRIVATE LIMITED",
"CA ENGINEERS PRIVATE LIMITED",
"CA INDIA TECHNOLOGIES PRIVATE LIMITED",
"CA KRISHANALAL JILAL",
"CA MEDIA DIGITAL INDIA PRIVATE LIMITED",
"CA ON WEB PRIVATE LIMITED",
"CA PRIYANKA V SHELAKE AND CO",
"CA TRADING COMPANY",
"CAA SYSTEMS OPC PRIVATE LIMITED",
"CAAN WINGS CONSULTANTS PRIVATE LIMITED",
"CAARA INDIA PRIVATE LIMITED",
"CAARA OVERSEAS PRIVATE LIMITED",
"CAASA LIVING FURNITURE AND FURNISHERS PRIVATE LIMITED",
"CAASTLE TECHNOLOGY AND SERVICES INDIA PRIVATE LIMITED",
"CAAVO LABS INDIA PRIVATE LIMITED",
"CAB CLINICAL SERVICES INDIA PRIVATE LIMITED",
"CAB ENGINEERS PVT LTD",
"CAB INTERNATIONAL",
"CAB PRESTRESS & INFRASOLUTIONS PRIVATE LIMITED",
"CABANA ESTATES PRIVATE LIMITED",
"CABANA HOSPITALITY PRIVATE LIMITED",
"CABANA MANAGEMENT CONSULTANCY PRIVATE LIMITED",
"CABBYTABBY TECHNOLOGIES PRIVATE LIMITED",
"CABCON INDIA PRIVATE. LIMITED.",
"CABE SPRINGS AND FASTENERS INDIA PRIVATE LIMITED",
"CABEATS TECH PRIVATE LIMITED",
"CAB-EEZ INFRA TECH PRIVATE LIMITED",
"CABELAS INDIA EXPORTS PRIVATE LIMITED",
"CABILEX CABLES PRIVATE LIMITED",
"CABINET SECRETARIAT",
"CABINET SYSTEMS AND CONTROLS PRIVATE LIMITED",
"CABISCO PLAST PRIVATE LIMITED",
"CABLE & WIRELESS NETWORKS INDIA PRIVATE LIMITED",
"CABLE AND WIRELESS GLOBAL INDIA PRIVATE LIMITED",
"CABLE AND WIRELESS INDIA LIMITED",
"CABLE AND WIRELESS NETWORKS INDIA PRIVATE LIMITED",
"CABLE CARE PRIVATE LIMITED",
"CABLE CARRIER (EPC) PRIVATE LIMITED",
"CABLE COMBINE COMMUNICATION PRIVATE LIMITED",
"CABLE PROCESSORS INDIA PRIVATE LIMITED",
"CABLE SALES AND SERVICES (INDIA) PRIVATE LIMITED",
"CABLE VISION SYSTEMS PRIVATE LIMITED",
"CABLEAX INSULATORS PRIVATE LIMITED",
"CABLES (INDIA) PVT LTD",
"CABLETECH SERVICES PRIVATE LIMITED",
"CABLEX ASSOCIATES PRIVATE LIMITED",
"CABLING HARNESSES (OPC) PRIVATE LIMITED",
"CABOT INDIA LIMITED",
"CABOT SANMAR LIMITED",
"CABOT TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"CAB-ROLL (INDIA) PRIVATE LIMITED",
"CABSAT CHANNELS PRIVATE LIMITED",
"CABSONS INSULATION PRIVATE LIMITED",
"CAC MERCHANDISING PRIVATE LIMITED",
"CAC SOFTWARE CONSULTANCY PRIVATE LIMITED",
"CACHAR KING PLANTATIONS PVT LTD",
"CACHAR MOTORS PRIVATE LIMITED",
"CACHAR ROLLER FLOUR MILLS LIMITED",
"CACHATTO INDIA PRIVATE LIMITED",
"CACHE DIGITECH PRIVATE LIMITED",
"CACHE INFOTECH PRIVATE LIMITED",
"CACHE PERIPHERALS",
"CACHE PROPERTIES PRIVATE LIMITED",
"CACHE TECHNOLOGIES (KOLHAPUR) PRIVATE LIMITED",
"CACHEBOX INDIA PRIVATE LIMITED",
"CACHET EXPORTS PRIVATE LIMITED",
"CACHET MEDICAL PRACTICE MANAGEMENT RESOURCE P LIMITED",
"CACHET PHARMACEUTICALS PRIVATE LIMITED",
"CACIK BUSINESS DISTRIBUTION PRIVATE LIMITED",
"CACOBEAN CHOCOLATE FACTORY PRIVATE LIMITED",
"CACTUS CLOTHING PRIVATE LIMITED",
"CACTUS COMMUNICATIONS PRIVATE LIMITED",
"CACTUS CREATIVES PRIVATE LIMITED",
"CACTUS MENSWEAR FASHION PRIVATE LIMITED",
"CACTUS PHARMACEUTICALS PRIVATE LIMITED",
"CACTUS VINIMAY PRIVATE LIMITED.",
"CACULO CARS PRIVATE LIMITED",
"CACULO EARTHMOVERS PRIVATE LIMITED",
"CACULO MOTORS PRIVATE LIMITED",
"CACULO RETAILS PRIVATE LIMITED",
"CAD MACRO DESIGN AND SOLUTIONS PRIVATE LIMITED",
"CAD N C FABRICAT PRIVATE LIMITED",
"CAD PAPER MACHINE PVT LTD",
"CAD VENTURES PRIVATE LIMITED",
"CADABAM'S CENTER FOR MENTALLY RETARDED PRIVATE LIMITED",
"CADABAMS MENTAL HEALTHCARE SERVICES PRIVATE LIMITED",
"CADCAMGURU SOLUTIONS PRIVATE LIMITED",
"CADCHEM LABORATORIES LIMITED",
"CADD CENTRE TRAINING SERVICES PRIVATE LIMITED",
"CADD CONSULTING ENGINEERS PRIVATE LIMITED",
"CADDIE HOTELS PRIVATE LIMITED",
"CADDILINE EXIM PRIVATE LIMITED",
"CADELL HEALTH CARE PRIVATE LIMITED",
"CADELL WEAVING MILLS COMPANY PRIVATE LIMITED",
"CADEN SURVEYS PRIVATE LIMITED",
"CADENCE ACADEMY OF DESIGN PRIVATE LIMITED",
"CADENCE BUILDERS & CONSTRUCTIONS PRIVATE LIMITED",
"CADENCE DESIGN SYSTEMS INDIA PRIVATE LIMITED",
"CADENCE ELECTRICAL ENGINEERS PRIVATE LIMITED",
"CADENCE ENTERPRISES PRIVATE LIMITED",
"CADEPLOY ENGINEERING PRIVATE LIMITED",
"CADES STUDEC TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"CADFEM INDIA PRIVATE LIMITED",
"CADGRAF DIGITALS PRIVATE LIMITED",
"CADIF PRIVATE LIMITED",
"CADILA PHARMACEUTICALS LIMITED",
"CADILLAC FILTERS PRIVATE LIMITED",
"CADILLAC GRANITO PRIVATE LIMITED",
"CADIZ PHARMACEUTICALS PRIVATE. LIMITED.",
"CADMACH MACHINERY COMPANY PRIVATE LIMITED",
"CADMAN SECURITY SERVICES PRIVATE LIMITED",
"CADMARC SOFTWARE PRIVATE LIMITED",
"CADMATIC SOFTWARE SOLUTIONS PRIVATE LIMITED",
"CADMAXX SOLUTIONS PRIVATE LIMITED",
"CAD-MECH ENGINEERING PRIVATE LIMITED",
"CADMILE HITECH SERVICES PRIVATE LIMITED",
"CADMOSIL CHEMICALS PRIVATE LIMITED",
"CADMUS HEALTHCARE PRIVATE LIMITED",
"CADMUS INTERNATIONAL HIGH SCHOOL",
"CADOMED PHARMACEUTICALS INDIA PRIVATE LIMITED",
"CADOPT TECHNOLOGIES PRIVATE LIMITED",
"CADOSPHERE ENGINEERING SERVICES PRIVATE LIMITED",
"CADOTECH SOLUTIONS PRIVATE LIMITED",
"CADRAN ICP (INDIA) PRIVATE LIMITED",
"CADRYCHE AUTOMATION AND OFFICE SOLUTIONS PRIVATE LIMITED",
"CADS MAKEITBIM PRIVATE LIMITED",
"CADS SOFTWARE INDIA PRIVATE LIMITED",
"CADSYS ( INDIA ) LIMITED",
"CADSYS INDIA LIMITED",
"CADTECH CONSULTANTS PRIVATE LIMITED",
"CADTECH ENGINEERING SOLUTIONS PRIVATE LIMITED",
"CADTRANS INFOTECH PRIVATE LIMITED",
"CADTRONICS SERVICES PRIVATE LIMITED",
"CADVISION ENGINEERS PRIVATE LIMITED",
"CADWORLD INFOSYSTEMS PRIVATE LIMITED",
"CADX TOOLS AND TECHNOLOGIES PRIVATE LIMITED",
"CAE FLIGHT TRAINING (INDIA) PRIVATE LIMITED",
"CAE INDIA PRIVATE LIMITED",
"CAE SIMULATION TECHNOLOGIES",
"CAE SIMULATION TRAINING PRIVATE LIMITED",
"CAELESTIS TRADING & INDUSTRIES PRIVATE LIMITED",
"CAELIUS CONSULTING IT SERVICES PRIVATE LIMITED",
"CAEPRO TECHNOLOGIES PRIVATE LIMITED",
"CAESAR BUSINESS CENTRE PRIVATE LIMITED",
"CAESARS ENTERTAINMENT CORPORATION",
"CAF INDIA PRIVATE LIMITED",
"CAF MARINE & OFFSHORE SERVICES PRIVATE LIMITED.",
"CAFE BROWN SUGAR PRIVATE LIMITED",
"CAFE BUDDYS FOODS PRIVATE LIMITED",
"CAFE CREME (INDIA) PRIVATE LIMITED",
"CAFE MOON STAR PRIVATE LIMITED",
"CAFE NOIR RESTAURANTS INDIA PRIVATE LIMITED",
"CAFE TOTARAM PRIVATE LIMITED",
"CAFFEINE INTEGRATED SOLUTIONS PRIVATE LIMITED",
"CAFFIL PVT LTD",
"CAFOM SOURCING INDIA PRIVATE LIMITED",
"CAFOMA AUTOPARTS PRIVATE LIMITED",
"CAFOMA ENGINE COMPONENTS PRIVATE LIMITED",
"CAFS INDIA GLOBAL PRIVATE LIMITED",
"CAFTIUS TECHNOLOGIES PRIVATE LIMITED",
"CAG CONSTRUCTION EQUIPMENT PRIVATE LIMITED",
"CAG SHIPPING PRIVATE LIMITED",
"CAGER (INDIA) PRIVATE LIMITED",
"CAGGO STEAM SERVICES PRIVATE LIMITED",
"CAHEAD INFO TECHNOLOGIES INDIA PRIVATE LIMITED",
"CAHOOT TECHNOLOGIES PRIVATE LIMITED",
"CAI INDUSTRIES PRIVATE. LIMITED.",
"CAI INFO INDIA PRIVATE LIMITED",
"CAI SCIENCE LABS PRIVATE LIMITED",
"CAIB LIFESTYLE PRIVATE LIMITED",
"CAIMAN SOLUTIONS PRIVATE LIMITED",
"CAIN TECHNOLOGIES INDIA PRIVATE LIMITED",
"CAIR EUROMATIC AUTOMATION PRIVATE LIMITED",
"CAIRN OIL SOLUTIONS PRIVATE LIMITED",
"CAIRO INTERNATIONAL",
"CAIRS TECHNOLOGY INDIA PRIVATE LIMITED",
"CAIS ENGINEERING SERVICES PVT LTD",
"CAITLYN INDIA PRIVATE LIMITED",
"CAITS INFO SOLUTIONS PRIVATE LIMITED",
"CAIZE REALTY INDIA PRIVATE LIMITED",
"CAJON PLAST (INDIA) PRIVATE LIMITED",
"CAKE POINT PRIVATE LIMITED",
"CAKEBEE DELI FRESH PRIVATE LIMITED",
"CAKESOFT TECHNOLOGIES PRIVATE LIMITED",
"CAKEZONE FOODTECH PRIVATE LIMITED",
"CALABASAS VENTURES PRIVATE LIMITED",
"CALADIUM SYSTEMS PRIVATE LIMITED",
"CALAMA AQUA ENGINEERING PRIVATE LIMITED",
"CALANCE SOFTWARE PRIVATE LIMITED",
"CALANGUTE ADVISORY SERVICES PRIVATE LIMITED",
"CALAVER TECHNOLOGIES PRIVATE LIMITED",
"CALBROS PHARMA INDIA PRIVATE LIMITED",
"CALCAST FERROUS LTD.",
"CALCATTA-HALDIA PORT ROAD COMPANY LIMITED.",
"CALCEUS FASHION PRIVATE LIMITED",
"CALCIFY IT SOLUTIONS PRIVATE LIMITED",
"CALCIMAG CHEMICALS INDIA PRIVATE LIMITED",
"CALCIUMHEALTH PRIVATE LIMITED",
"CALCLAY INDIA PRIVATE LIMITED",
"CALCO MINERALS PRIVATE LIMITED",
"CALCO POLY COMPOUNDS PRIVATE LIMITED",
"CALCO POLY TECHNIK PRIVATE LIMITED",
"CALCO POLYCHEM PRIVATE LIMITED.",
"CALCOM CEMENT INDIA LIMITED",
"CALCOM ELECTRONICS LIMITED",
"CALCOM VISION LIMITED",
"CALCULUS FOODS PRIVATE LIMITED",
"CALCULUS PROPERTIES PRIVATE LIMITED",
"CALCULUS SYSTEMS PRIVATE LIMITED",
"CALCUTTA ART STUDIO PVT LTD",
"CALCUTTA CARBIDE PRIVATE LIMITED",
"CALCUTTA CARPETS PVT.LTD.",
"CALCUTTA CEMENT PRIVATE LIMITED",
"CALCUTTA CENTRAL ELECT DIVISION I CALCUTTA",
"CALCUTTA CLOTHING PRIVATE LIMITED",
"CALCUTTA CLUB LTD",
"CALCUTTA COSMETICS PRIVATE LIMITED",
"CALCUTTA CRICKET & FOOTBALL CLUB",
"CALCUTTA DIES & TOOLS MFG. CO PVT LTD",
"CALCUTTA ELECTRODES PRIVATE LIMITED",
"CALCUTTA EXPRESS ROADLINES PRIVATE LIMITED",
"CALCUTTA FABRICATING CO PVT LTD",
"CALCUTTA FELT INDUSTRIES PVT LTD",
"CALCUTTA FORGINGS & STEEL INDUSTRIES LIMITED",
"CALCUTTA GEARS PVT LTD",
"CALCUTTA GIRLS BT COLLEGE",
"CALCUTTA GIRLS COLLEGE",
"CALCUTTA HEART CLINIC AND HOSPITAL",
"CALCUTTA HOMEOPATHIC MEDICAL COLLEGE",
"CALCUTTA IMAGING AND NEUROLOGY RESEARCH CENTRE PRIVATE LIMITED",
"CALCUTTA INFOTECH PRIVATE LIMITED",
"CALCUTTA INSTITUTE OF ENGG AND MGMT",
"CALCUTTA INTERNATIONAL SCHOOL SOCIETY",
"CALCUTTA INVESTMENT CO LTD",
"CALCUTTA ISPAT PVT LTD",
"CALCUTTA MEDICAL COLLEGE HOSPITAL",
"CALCUTTA MEDICAL IMAGING INSTITUTE LTD",
"CALCUTTA MEDICAL RESEARCH INSTITUTE",
"CALCUTTA MEDISOLUTIONS PRIVATE LIMITED",
"CALCUTTA MINING SEALANTS PVT. LTD.",
"CALCUTTA NATIONAL MEDICAL COLLEGE& HOSPITAL",
"CALCUTTA PAPER INDUSTRIES PRIVATE LIMITED",
"CALCUTTA PAVLOV HOSPITAL",
"CALCUTTA PRINTING INKS PVT LTD",
"CALCUTTA RADIO SERVICE PRIVATE LIMITED",
"CALCUTTA SEA FOODS PVT LTD",
"CALCUTTA SECURITY PRINTERS LIMITED",
"CALCUTTA SOUTH CLUB LTD",
"CALCUTTA SPORTSBOATS MANUFACTURING PVT LTD",
"CALCUTTA SPRINGS LIMITED",
"CALCUTTA SPRINGS LTD",
"CALCUTTA STATE TRANSPORT CORPORATION",
"CALCUTTA TECHNO HEATERS (INDIA) PVT.LTD.",
"CALCUTTA TUBE (INDIA) PRIVATE LIMITED",
"CALCUTTA UDYOG PVT LTD",
"CALCUTTA UNIVERSITY",
"CALCUTTA WIRE NETTING COMPANY PRIVATE LIMITED",
"CALDERYS INDIA REFRACTORIES LIMITED",
"CALDERYS STEELCASTING INDIA PRIVATE LIMITED",
"CALDRON GRAPHICS",
"CALDRON TECHNOLOGIES PRIVATE LIMITED",
"CALEDON TECHNOLOGIES INDIA PRIVATE LIMITED",
"CALEFACTION TECHNO PRIVATE LIMITED",
"CALENDER MANUFACTURERS PVT LTD",
"CALENDULA COMMERCE PRIVATE LIMITED",
"CALEX MARINE AND INDUSTRIAL SERVICES PRIVATE LIMITED",
"CALFAB INDIA LTD",
"CALFUSION LUBRICANTS AND PETROLEUM PRODUCTS PRIVATE LIMITED",
"CALGARA WORLDWIDE PRIVATE LIMITED",
"CALI LABS PRIVATE LIMITED",
"CALI SUPPLY INDIA PRIVATE LIMITED",
"CALIBEHR BUSINESS SUPPORT SERVICES PRIVATE LIMITED",
"CALIBER BRANDS PRIVATE LIMITED",
"CALIBER INDIA APPARELS PRIVATE LIMITED",
"CALIBER INTERCONNECT SOLUTIONS PRIVATE LIMITED",
"CALIBER MERCANTILE PRIVATE LIMITED",
"CALIBER OUTSOURCING SERVICES",
"CALIBER PHARMACEUTICALS PRIVATE LIMITED",
"CALIBER PLASTECH PRIVATE LIMITED",
"CALIBER SCALES ( INDIA) PRIVATE LIMITED",
"CALIBER TECH SOLUTIONS PRIVATE LIMITED",
"CALIBER TECHNOLOGIES PRIVATE LIMITED",
"CALIBER TRADES AND EXPORTS PRIVATE LIMITED",
"CALIBER VALVES PRIVATE LIMITED",
"CALIBO INDIA PRIVATE LIMITED",
"CALIBRAINT TECHNOLOGIES PRIVATE LIMITED",
"CALIBRATED HEALTHCARE SYSTEMS INDIA PRIVATE LIMITED",
"CALIBRATION LAB AND INDUSTRIAL SERVICES PRIVATE LIMITED",
"CALIBRE ACADEMY",
"CALIBRE CHEMICALS PRIVATE LIMITED",
"CALIBRE COMMERCIAL PRIVATE LIMITED",
"CALIBRE NETWORK SOLUTIONS PRIVATE LIMITED",
"CALIBRE PERSONNEL PRIVATE. LIMITED",
"CALIBRE SOUND SYSTEMS PRIVATE LIMITED",
"CALIBRE SPECIALTY ELASTOMERS INDIA PRIVATE LIMITED",
"CALIBRE SYSTECH PRIVATE LIMITED",
"CALIBRE WEBSOL PRIVATE LIMITED",
"CALIBRECODE SOLUTIONS PRIVATE LIMITED",
"CALIBROMEASURE EQUIPMENTS PRIVATE LIMITED",
"CALIBSOFT TECHNOLOGIES PRIVATE LIMITED",
"CALICA BUILDWELL PRIVATE LIMITED",
"CALICO METAL INDUSTRIES PRIVATE LIMITED",
"CALICO TRENDS",
"CALICO VINYL PRIVATE LIMITED",
"CALICUT APOLLO BUILDERS PRIVATE LIMITED",
"CALICUT DECOR PRIVATE LIMITED",
"CALICUT DIESELS PRIVATE LIMITED",
"CALICUT DISTRICT CO-OP BANK",
"CALICUT HYPERMART PRIVATE LIMITED",
"CALICUT LANDMARK BUILDERS AND DEVELOPERS (INDIA) PRIVATE LIMITED",
"CALICUT LULU GOLD PRIVATE LIMITED",
"CALIDAD INDIA PRIVATE LIMITED",
"CALIFORNIA ESTATE PRIVATE LIMITED",
"CALIFORNIA INFO SYSTEMS PRIVATE LIMITED",
"CALIMARA MATTERS PRIVATE LIMITED",
"CALIMENT SOLUTIONS PRIVATE LIMITED",
"CALIPER & CLAMP INTERIOR SOLUTIONS PRIVATE LIMITED",
"CALIPER BUSINESS SOLUTIONS PRIVATE LIMITED",
"CALIPH WORLD FOUNDATION",
"CALIPPUS TECH INDIA PRIVATE LIMITED",
"CALIRON CHEMICALS PVT LTD",
"CALISTA HOTELS AND RESORTS PRIVATE LIMITED",
"CALISTA PROPERTIES PRIVATE LIMITED",
"CALISTO TECHNOCAST PRIVATE LIMITED",
"CALIUM TECHNOLOGIES PRIVATE LIMITED",
"CALIX AGRIGENETICS PRIVATE LIMITED",
"CALIXIR FREIGHT AND LOGISTICS PRIVATE LIMITED",
"CALIXTO SYSTEMS PRIVATE LIMITED",
"CALKEN EDUCATIONAL SERVICES PRIVATE LIMITED",
"CALL 2 CONNECT INDIA PRIVATE LIMITED",
"CALL HEALTH SERVICES PRIVATE LIMITED",
"CALL2CUSTOMERS CALL CENTER PRIVATE LIMITED",
"CALLARITY PRIVATE LIMITED",
"CALLAWAY GOLF INDIA PRIVATE LIMITED",
"CALLEO DISTRIBUTION TECHNOLOGIES PRIVATE LIMITED",
"CALLESTO INTERNATIONAL PRIVATE LIMITED",
"CALLFLEX CORPORATION PRIVATE LIMITED",
"CALLIDA ELECTRICALS PRIVATE LIMITED",
"CALLIDUS RESEARCH LABORATORIES PRIVATE LIMITED",
"CALLIDUS SHOEMAKERS PRIVATE LIMITED",
"CALLIDUS SOLUTIONS PRIVATE LIMITED",
"CALLIDUSCLOUD (INDIA) PRIVATE LIMITED",
"CALLIGO TECHNOLOGIES PRIVATE LIMITED",
"CALLING 24O7 BPO SERVICES PRIVATE LIMITED",
"CALLINGTON INDIA PRIVATE LIMITED",
"CALLINO INDIA PRIVATE LIMITED",
"CALLIRHOE TRUSTEE COMPANY PRIVATE LIMITED",
"CALLISONS FLAVORS INDIA PRIVATE LIMITED",
"CALLISTO INFRASTRUCTURE PRIVATE LIMITED",
"CALLMATE INDIA PRIVATE LIMITED",
"CALLMEDILIFE HEALTHCARE SERVICES PRIVATE LIMITED",
"CALLONE IMPORTS PRIVATE LIMITED",
"CALLOW BUILDMART PRIVATE LIMITED",
"CALLTEKCENTER INDIA PRIVATE LIMITED",
"CALLTEL INFO SOLUTIONS PRIVATE LIMITED",
"CALLUS BIOTECH PRIVATE LIMITED",
"CALM STUDIO DESIGN PRIVATE LIMITED",
"CALMATIVE TRADING PRIVATE LIMITED",
"CALMET ENGINEERING INDIA PRIVATE LIMITED",
"CALMOVE TECHNOLOGIES PRIVATE LIMITED",
"CAL-ON INDUSTRIES LIMITED",
"CALON TECHNOLOGIES PRIVATE LIMITED",
"CALOREX EDUCATION AND RESEARCH FOUNDATION",
"CALORIE ENGINEERING PRIVATE LIMITED",
"CALORX OLIVE INTERNATIONAL SCHOOL",
"CALORX TEACHERS UNIVERSITY",
"CALPEDA PUMPS INDIA PRIVATE LIMITED",
"CALPINE CORPORATION",
"CALPINE INFRASTRUCTURE AND TECH SOLUTIONS PRIVATE LIMITED",
"CALPION SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"CALPRIN ADS PRIVATE LIMITED",
"CALPRO FOOD ESSENTIALS PRIVATE LIMITED",
"CALPRO SPECIALITIES PRIVATE LIMITED",
"CALREN CARE LIFESCIENCES PRIVATE LIMITED",
"CALSCIENTIFIC INDIA PRIVATE LIMITED",
"CALSEA FOOTWEAR PRIVATE LIMITED",
"CALSENS PVT LTD",
"CALSMELT METALIKS PRIVATE LIMITED",
"CALSOFT PRIVATE LIMITED",
"CALSONIC KANSEI MOTHERSON AUTO PRODUCTS PRIVATE LIMITED",
"CALSTAR SPONGE LIMITED",
"CALSYS INDIA PRIVATE LIMITED",
"CALTECH ENGINEERING COMPANY PVT LTD",
"CALTECH POLYMERS PRIVATE LIMITED",
"CALTEK DIAGNOSTICS PVT. LTD.",
"CALTHERM THERMOSTATS PRIVATE LIMITED",
"CALTRADECO STEELS PRIVATE LIMITED",
"CALTRON CLAYS AND CHEMICALS PRIVATE LIMITED",
"CALTRONIC CONTROLS (INDIA) PRIVATE LIMITED",
"CALVIN AND BEAVER SPORTS PRIVATE LIMITED",
"CALVIN ASSOCIATES PRIVATE LIMITED",
"CALVIN INVESTMENT COMPANY PRIVATE LIMITED",
"PVH ARVIND FASHION PRIVATE LIMITED",
"CALVIN TRADE AND DEVELOPERS PRIVATE LIMITED",
"CALVINTEX VENTURES PRIVATE LIMITED",
"CALVINTEX WEARS LIMITED",
"CALYDON TECH SOLUTIONS PRIVATE LIMITED",
"CALYFOX RETAILS PRIVATE LIMITED",
"CALYON BANK",
"CALYPSO AQUATEC PRIVATE LIMITED",
"CALYPSO CERAMIC PRIVATE LIMITED",
"CALYPSO REALTY PRIVATE LIMITED",
"CALYPTO DESIGN SYSTEMS INDIA PRIVATE LIMITED",
"CALYX CONSULTING PRIVATE LIMITED",
"CALYX CONTAINER TERMINALS PRIVATE. LIMITED",
"CALYX LENORA DEVELOPERS LLP",
"CALYX SOLUTIONS",
"CALYXSEEDS PRIVATE LIMITED",
"CALZINI FASHIONS LIMITED",
"CAM AIR DISTRIBUTION PRODUCTS PRIVATE LIMITED",
"CAM DUCT INDIA PRIVATE LIMITED",
"CAM ENGINEERS",
"CAM NEURO PHARMA PRIVATE LIMITED",
"CAM PAK INDIA PRIVATE LIMITED",
"CAM TOOLS INDUSTRIES PRIVATE LIMITED",
"CAM V HOTEL PRIVATE LIMITED",
"CAMA AND ALBLESS HOSPITAL",
"CAMA AUTOMOBILES PRIVATE LTD.",
"CAMA HOTELS LIMITED",
"CAMA INFRA LIMITED",
"CAMAC AUTO SERVICE PVT LTD",
"CAMAC COMMERCIAL COMPANY LIMITED",
"CAMAC LEATHERS PVT LTD",
"CAMARADERIE BRANDS PRIVATE LIMITED",
"CAMARON EXPORTS PRIVATE LIMITED",
"CAMAWI ELECTRICALS AND ELECTRONICS PVT LTD",
"CAMBATA AVIATION PRIVATE LIMITED",
"CAMBAY CONSULTING INDIA PRIVATE LIMITED",
"CAMBAY ORGANICS PRIVATE LIMITED",
"CAMBAY TECHNOPACK PRIVATE LIMITED",
"CAMBELL REALTY PRIVATE LIMITED",
"CAMBERWELL BEVERAGES PRIVATE LIMITED",
"CAMBIANTE TECHNOLOGIES PRIVATE LIMITED",
"CAMBINDIA BIOTECH KITS PRIVATE LIMITED",
"CAMBIO CONSULTING INDIA PRIVATE LIMITED",
"CAMBIUM BIOTECH PRIVATE LIMITED",
"CAMBIUM NETWORKS PRIVATE LIMITED",
"CAMBIUM RETAIL PRIVATE LIMITED",
"CAMBRIA SOLAR PRIVATE LIMITED",
"CAMBRICS NON WOVEN PRIVATE LIMITED",
"CAMBRIDGE CLOTHING COMPANY PRIVATE LIMITED",
"CAMBRIDGE CONSTRUCTION ( DELHI ) PRIVATE LIMITED",
"CAMBRIDGE COURT HIGH SCHOOL",
"CAMBRIDGE COURT WORLD SCHOOL",
"CAMBRIDGE EDUPRENEURS PRIVATE LIMITED",
"CAMBRIDGE GLOBAL SCHOOL",
"CAMBRIDGE HEALTH CARE LIMITED",
"CAMBRIDGE INSTITUTE OF TECHNOLOGY",
"CAMBRIDGE INTERNATIONAL SCHOOL",
"CAMBRIDGE KIDS",
"CAMBRIDGE PUBLISHING CO. PRIVATE LIMITED",
"CAMBRIDGE SCHOOL",
"CAMBRIDGE SYSTEMS (INDIA) PRIVATE LIMITED",
"CAMBRIDGE TECHNOLOGY ENTERPRISE LIMITED",
"CAMBRIDGE TECHNOLOGY ENTERPRISES LIMITED",
"CAMBRIDGE UNIVERSITY PRESS & ASSESSMENT INDIA PRIVATE LIMITED",
"CAMBRO NILKAMAL PRIVATE LIMITED",
"CAMCO CONSTRUCTIONS PRIVATE LIMITED",
"CAMDEN APPAREL SOLUTIONS PRIVATE LIMITED",
"CAMDEN AUTOMATED LOCAL MARKETING SOLUTION INDIA PRIVATE LIMITED",
"CAME INDIA AUTOMATION SOLUTIONS PRIVATE LIMITED",
"CAMEL FOODS PRIVATE LIMITED",
"CAMEL MARKETING PRIVATE LIMITED",
"CAMELIA GRIHA NIRMAN PRIVATE LIMITED",
"CAMELLIA AGRI PRODUCTS PRIVATE LIMITED",
"CAMELLIA CLOTHING LIMITED",
"CAMELLIA INFRASTRUCTURE LIMITED",
"CAMELLIA PRODUCTIONS PRIVATE LIMITED",
"CAMELLIA TEA GROUP PVT LTD",
"CAMELOT CORDIALITY HOTELS PRIVATE LIMITED",
"CAMELOT INTEGRATED LABS PRIVATE LIMITED",
"CAMELOT INTEGRATED SOLUTIONS PRIVATE LIMITED",
"CAMELOT ITLAB PRIVATE LIMITED",
"CAMELPORT PRIVATE LIMITED",
"CAMEO CORPORATE SERVICES LIMITED",
"CAMEO FABRICS PRIVATE LIMITED",
"CAMEO GLOBAL COMMUNICATIONS PRIVATE LIMITED",
"CAMEO HEALTH CARE (INDIA) PRIVATE LIMITED",
"CAMEO SPORTS AGENCIES PRIVATE LIMITED",
"CAMEO TOWN PLANNERS PRIVATE LIMITED",
"CAMERON INTERNATIONAL CORPORATION",
"CAMERON MANUFACTURING (INDIA) PRIVATE LIMITED",
"CAMEX LIMITED",
"CAMEX LIMITED.",
"CAMEX SPECIALITY PRIVATE LIMITED",
"CAMEX WELLNESS LIMITED",
"CAMEY SYNTHETICS PRIVATE LIMITED",
"CAMFIELD ENGINEERS PRIVATE LIMITED",
"CAMFIL INDIA PRIVATE LIMITED",
"CAMINO HERBAL REMEDIES PRIVATE LIMITED",
"CAMINUS EQUIPMENTS PRIVATE LIMITED",
"CAMIO EXPORTS PRIVATE LIMITED",
"CAMION AUTOMOBILES PRIVATE LIMITED",
"CAMIONS LOGISTICS SOLUTIONS PRIVATE LIMITED",
"CAMLIN FINE SCIENCES LIMITED",
"CAMLINE SOLUTIONS INDIA PRIVATE LIMITED",
"CAMLON FREIGHT FORWARDINGS (INDIA) PRIVATE LIMITED",
"CAMOMILE HEALTHCARE VENTURES PRIVATE LIMITED",
"CAMOZZI INDIA PRIVATE LIMITED",
"CAMP CRAFTS PRIVATE LIMITED",
"BHAANE RETAIL PRIVATE LIMITED",
"CAMP SMA PRIVATE LIMITED",
"CAMP SYSTEMS PRIVATE LIMITED",
"CAMPAIGN ADVERTISING SERVICES PVT. LTD.",
"CAMPARI EXPORTS PRIVATE LIMITED",
"CAMPARI INDIA PRIVATE LIMITED",
"CAMPBELL ADVERTISING PVT LTD",
"CAMPBELL AGRO MANUFACTURING INDUSTRIES PVT LTD",
"CAMPBELL HOSPITALITY SERVICES PRIVATE LIMITED",
"CAMPBELL INTERNATIONAL",
"CAMPBELL SCIENTIFIC INDIA PRIVATE LIMITED",
"CAMPBELL SHIPPING COMPANY LIMITED",
"CAMPDEN FAMILY CONNECT PRIVATE LIMITED",
"CAMPHOR AND ALLIED PRODUCTS LIMITED",
"CAMPHOR DISTRIBUTORS PRIVATE LIMITED",
"CAMPING RETREATS OF INDIA PRIVATE LIMITED",
"CAMPION ANGLO INDIAN HIGHER SECONDARY SCHOOL",
"CAMPION SCHOOL",
"CAMPTRA TECHNOLOGIES PRIVATE LIMITED",
"CAMPUS ACTIVEWEAR LIMITED",
"CAMPUS ACTIVEWEAR PRIVATE LIMITED",
"CAMPUS COMPONENT PRIVATE LIMITED",
"CAMPUS EAI INDIA PRIVATE LIMITED",
"CAMPUS GROUP EDUCATION (INDIA) PRIVATE LIMITED",
"CAMPUS GROUP EDUCATION INDIA PRIVATE LIMITED",
"CAMPUS KIDS CORNER",
"CAMPUS LABS PRIVATE LIMITED",
"CAMPUS MALL PRIVATE LIMITED",
"CAMPUS POLYPLAST PRIVATE LIMITED",
"CAMPUS STUDENTS COMMUNITIES PRIVATE LIMITED",
"CAMPUS SUTRA",
"CAMPUSKNOT EDUSOFT PRIVATE LIMITED",
"CAMPUSSUTRA RETAIL PRIVATE LIMITED",
"CAMROLA QUARTZ LIMITED",
"CAMRON FEEDS PRIVATE LIMITED",
"CAMS CARGO ACCOUNTING MANAGEMENT SERVICES PRIVATE LIMITED",
"CAMS INFOTECH PRIVATE LIMITED",
"CAMS INSURANCE REPOSITORY SERVICES LIMITED",
"CAMS INVESTOR SERVICES PRIVATE LIMITED",
"CAMS PAYMENT SERVICES PRIVATE LIMITED",
"CAMSDATA TECHNOLOGIES INDIA PRIVATE LIMITED",
"CAMSKLUB STUDIO PRIVATE LIMITED",
"CAMUS PHARMA PRIVATE LIMITED",
"CAMUS STONES PRIVATE LIMITED",
"CAMY BULK CARRIERS PRIVATE LIMITED",
"CAMY EXPORTS PVT LTD",
"CAN & ABLE ENTERTAINMENT PRIVATE LIMITED",
"CAN FASHION PRIVATE LIMITED",
"CAN FIN HOMES LIMITED",
"CAN OFF SHORE PRIVATE LIMITED",
"CAN TRANS LOGISTICS PRIVATE LIMITED",
"CANA WAREHOUSING AND SUPPLY SOLUTIONS PRIVATE LIMITED",
"CANAAN ENGINEERING PRIVATE LIMITED",
"CANAAN KURIES PRIVATE LIMITED",
"CANADA IMPERIAL BANK",
"CANADA PURE FILLERS PRIVATE LIMITED",
"CANADIAN CRYSTALLINE WATER INDIA LIMITED",
"CANADIAN GLOBAL LIFE AND EDUCARE PRIVATE LIMITED",
"CANADIAN HIGH COMMISSION",
"CANADIAN INTERNATIONAL SCHOOL PRIVATE LIMITED",
"CANADIAN SOLAR ENERGY PRIVATE LIMITED",
"CANAL SOLAR ENERGY PRIVATE LIMITED",
"CANALI INDIA PRIVATE LIMITED",
"CANALS DIVISION",
"CANALTA INDIA PRIVATE LIMITED",
"CANAM INTERNATIONAL PRIVATE LIMITED",
"CANAM KOLKATA INC",
"CANAPPROVE CONSULTANCY SERVICES PRIVATE LIMITED",
"CANARA BANK",
"CANARA BANK RURAL SELF EMPLOYMENT TRAINING INSTITUTE",
"CANARA CARGO SERVICES PRIVATE LIMITED",
"CANARA ENGINEERING COLLEGE",
"CANARA ENGINEERS PRIVATE LIMITED",
"CANARA ENGLISH HIGHER PRIMARY SCHOOL",
"CANARA FACILITIES MANAGEMENT PRIVATE LIMITED",
"CANARA FIRST GRADE COLLEGE MANGALORE",
"CANARA HSBC LIFE INSURANCE COMPANY LIMITED",
"CANARA HYDRAULICS PRIVATE LIMITED",
"CANARA LIGHTING INDUSTRIES PRIVATE LIMITED",
"CANARA PROJECTS INDIA PRIVATE LIMITED",
"CANARA ROBECO ASSET MANAGEMENT COMPANY LIMITED",
"CANARA SECURITY PRESS LIMITED",
"CANARA STEEL LIMITED",
"CANARA TOURS AND TRAVELS PRIVATE LIMITED",
"CANARES AUTOMATION PRIVATE LIMITED",
"CANARY APPARELS PRIVATE LIMITED",
"CANARY ELECTRICALS PRIVATE LIMITED",
"CANARY HIGH INTERNATIONAL SCHOOL",
"CANARY HOTELS PRIVATE LIMITED",
"CANARYS AUTOMATIONS LIMITED",
"CANARYS AUTOMATIONS PRIVATE LIMITED",
"CANASIA CROP CHEMICAL PRIVATE LIMITED",
"CANBANK COMPUTER SERVICES LIMITED",
"CANBANK FACTORS LIMITED",
"CANBANK FINANCIAL SERVICES LIMITED",
"CANBANK VENTURE CAPITAL FUND LIMITED",
"CANBARA CONSTRUCTIONS P LTD",
"CANBARA INDUSTRIES PRIVATE LIMITED",
"CANBARA INTERNATIONAL PRIVATE LIMITED",
"CANBERG GLOBAL SOURCING PRIVATE LIMITED",
"CANBRO PHARMACEUTICALS PRIVATE LIMITED",
"CANCER INSTITUTE",
"CANCER TREATMENT SERVICES HYDERABAD PRIVATE LIMITED",
"CANDAUR PHARMACEUTICALS PRIVATE LIMITED",
"CANDELA ENTERPRISES PRIVATE LIMITED",
"CANDELA HEALTHCARE PRIVATE LIMITED",
"CANDENT TECHNOLOGIES PRIVATE LIMITED",
"CANDI SOLAR IN 1 PRIVATE LIMITED",
"CANDID CASTING & ALLOYS PRIVATE LIMITED",
"CANDID CASUALS (INDIA) PRIVATE LIMITED",
"CANDID CONFECTIONERY PRIVATE LIMITED",
"CANDID FRUITS PRIVATE LIMITED",
"CANDID GUARD SERVICES PRIVATE LIMITED",
"CANDID MANPOWER SOLUTIONS PRIVATE LIMITED",
"CANDID MARKETING PRIVATE LIMITED",
"CANDID MICRON MEASUREMENTS PRIVATE LIMITED",
"CANDID OPTRONIX PRIVATE LIMITED",
"CANDID VENTURES PRIVATE LIMITED",
"CANDIDA BIO SCIENCES PRIVATE LIMITED",
"CANDIDROOT SOLUTIONS PRIVATE LIMITED",
"CANDIIDUS INTERNATIONAL SCHOOL",
"CANDLE ADVISORS PRIVATE LIMITED",
"CANDLE WOOD BANQUETS AND HOTEL PRIVATE LIMITED",
"CANDOR BUSINESS SOLUTIONS PRIVATE LIMITED",
"CANDOR CONSULTING SERVICES PRIVATE LIMITED",
"CANDOR ENVIRO PRIVATE LIMITED",
"CANDOR FOODS PRIVATE LIMITED",
"CANDOR GURGAON ONE REALTY PROJECTS PRIVATE LIMITED",
"CANDOR INDIA OFFICE PARKS PRIVATE LIMITED",
"CANDOR INDIA PRIVATE LIMITED",
"CANDOR INFO SOLUTION PRIVATE LIMITED",
"CANDOR KOLKATA ONE HI-TECH STRUCTURES PRIVATE LIMITED",
"CANDOR LOGISTIC LLP",
"CANDOR MANAGEMENT SERVICES PRIVATE LIMITED",
"CANDOR TEXTILES PRIVATE LIMITED",
"CANDOR VIEW INDIA PRIVATE LIMITED",
"CANDORWORKS PRIVATE LIMITED",
"CANDOUR BRAND PROMOTIONS LLP",
"CANDOUR COMMUNICATIONS PRIVATE LIMITED",
"CANDOUR LONDON FASHION CULTURE PRIVATE LIMITED",
"CANDOUR MACHINERY PRIVATE LIMITED",
"CANDOUR MEDICAL INSTRUMENTS PRIVATE LIMITED",
"CANDOUR SOFTWARE PRIVATE LIMITED",
"CANDOUR TECHTEX LIMITED",
"CANDRIN JEWELLERY INDIA PRIVATE LIMITED",
"CANDURE VISION PRIVATE LIMITED",
"CANDY ENTERPRISES PRIVATE LIMITED",
"CANDY FASHIONS PRIVATE LIMITED",
"CANDY INDUSTRIES PVT LTD",
"CANDY SHADOW ASSOCIATES PRIVATE LIMITED",
"CANDY SPIRITS PRIVATE LIMITED",
"CANDY VYAPAAR PRIVATE LIMITED",
"CANDYLAKE NUTRITIONS PRIVATE LIMITED",
"CANDYTOY CORPORATE PRIVATE LIMITED",
"CANERES ACTIVE FINE CHEMICAL LIMITED",
"CANFAN PRIVATE LIMITED",
"CANGO NETWORKS PRIVATE LIMITED",
"CANGRA TALENTS PRIVATE LIMITED",
"CANGRAFT EQUIPMENT PRIVATE LIMITED",
"CANH INFRASTRUCTURE LIMITED",
"CANI MARKETING PRIVATE LIMITED",
"CANIAS ERP PRIVATE LIMITED",
"CANIS MAJORIS INFRASTRUCTURE PRIVATE LIMITED",
"CANIXA LIFE SCIENCES PRIVATE LIMITED",
"CANKADO INDIA PRIVATE LIMITED",
"CANKIDS KIDSCAN",
"CANLE VALVES PRIVATE LIMITED",
"CANLINX LOGISTICS INDIA PRIVATE LIMITED",
"CANN COPIER SERVICES PRIVATE LIMITED",
"CANN OFFICE EQUIPMENT PRIVATE LIMITED",
"CANNANORE HANDLOOM EXPORTS",
"CANNELS EXPORTS PRIVATE LIMITED",
"CANNIER AUTOMOTIVE PRIVATE LIMITED",
"CANNING S D HOSPITAL",
"CANNON DEVICES PVT LTD",
"CANNON EYE ADVERTISING PRIVATE LIMITED",
"CANNON MANAGEMENT AND SECURITY SERVICES PRIVATE LIMITED",
"CANNON SHIPPING COMPANY LIMITED",
"CANNONBALL TREE ADVISORS PRIVATE LIMITED",
"CANNOTMISS HOSPITALITY PRIVATE LIMITED",
"CANNY COVERAGE PACKAGINGS PRIVATE LIMITED",
"CANNY DIGITAL SOLUTIONS PRIVATE LIMITED",
"CANNY ENGINEERING (INDIA) (OPC) PRIVATE LIMITED",
"CANNY LIFE SPACES PRIVATE LIMITED",
"CANNY MANAGEMENT SERVICES PRIVATE LIMITED",
"CANNYCHOICE HOSPITALITY SERVICES PRIVATE LIMITED",
"CANNYCO PHARMA PRIVATE LIMITED",
"CANOE DESIGN PRIVATE LIMITED",
"CANOLA CONSULTANCY PRIVATE LIMITED",
"CANON GRANITES PRIVATE LIMITED",
"CANON INDIA PRIVATE LIMITED",
"CANON LAMINATORS PVT LTD",
"CANONIC PRIVATE LIMITED",
"CANOO ENGINEERING AG",
"CANOPI INDIA PRIVATE LIMITED",
"CANOPUS CONSULTANCY SERVICES PRIVATE LIMITED",
"CANOPUS MARINE MANAGEMENT SERVICES PRIVATE LIMITED",
"CANOPUS NATURAL GAS PRIVATE LIMITED",
"CANOPUS WATERTECH PRIVATE LIMITED",
"CANOPUS WET WIPES PRIVATE LIMITED",
"CANOPUS-GBS PRIVATE LIMITED",
"CANOPY ESTATES PRIVATE LIMITED",
"CANOPY FINANCE LIMITED",
"CANOPY PROJECTS LIMITED",
"CANOPY RESEARCH LABORATORIES PRIVATE LIMITED",
"CANOPYONE IT SOLUTIONS INDIA PRIVATE LIMITED",
"CANOROUS TECHNOLOGIES PRIVATE LIMITED",
"CANOSSA CONVENT PRIMARY SCHOOL",
"CANOSSA PRE-PRIMARY CENTER",
"CANOSSA PRIMARY SCHOOL",
"CANOSSA SCHOOL",
"CANPAC TRENDS PRIVATE LIMITED",
"CANPACK INDIA PRIVATE LIMITED",
"CANPEX CHEMICALS PRIVATE LIMITED",
"CANPLY INDIA PRIVATE LIMITED",
"CANQUA LIGHTING PRIVATE LIMITED",
"CANRAY",
"CANS & CLOSURES PRIVATE LIMITED",
"CANTABIL RETAIL INDIA LIMITED",
"CANTECH ENGINEERS PRIVATE LIMITED",
"CANTEEN STORES DEPARTMENT",
"CANTEEN STORES DEPARTMENT MINISTRY OF DEFENCE",
"CANTER ENGINEERS PRIVATE LIMITED",
"CANTERBURG TECH - BPO INDIA PRIVATE. LIMITED",
"CANTERBURGTECH BPO INDIA PRIVATE LIMITED",
"CANTERBURY EDUCATION GROUP PRIVATE LIMITED",
"CANTERBURY PUBLIC SCHOOL",
"CANTIK TECHNOLOGIES PRIVATE LIMITED",
"CANTON LABORATORIES PRIVATE LIMITED",
"CANTON SPICE COMPANY PRIVATE LIMITED",
"CANTONA INDUSTRIES PRIVATE LIMITED",
"CANTONMENT BOARD",
"CANTONMENT BOARD AMBALA",
"CANTONMENT BOARD DEHRADUN",
"CANTONMENT BOARD KAMPTEE",
"CANTONMENT BOARD RAMGARH",
"CANTREADS PRIVATE LIMITED",
"CANTUS EXIM PRIVATE LIMITED",
"CANUM INFOTECH PRIVATE LIMITED",
"CANVALOOP FIBRE PRIVATE LIMITED",
"CANVARZYS CARE PRIVATE LIMITED",
"CANVARZYS HEALTHCARE LIMITED",
"CANVAS CROWN DIGITAL PRIVATE LIMITED",
"CANVAS IT SOLUTIONS PRIVATE LIMITED",
"CANVAS TALENT PRIVATE LIMITED",
"CANVASINFRA BUILD PRIVATE LIMITED",
"CANVENDOR SOFTWARE SOLUTIONS PRIVATE LIMITED",
"CANVERA DIGITAL TECHNOLOGIES PRIVATE LIMITED",
"CANWAS AGRO INDIA PRIVATE LIMITED",
"CANWILL TECHNOLOGIES PRIVATE LIMITED",
"CANWIN TECHNOLOGIES PRIVATE LIMITED",
"CANWORK AMENITIES PRIVATE LIMITED",
"CANYON EXPORTS PRIVATE LIMITED",
"CANYON INFRASTRUCTURES PRIVATE LIMITED",
"CAO CUSTOMS HOUSE CHENNAI",
"CAO CUSTOMS JCH NHAVA SHEVA",
"CAO CUSTOMS PREV COMM MUMBAI",
"CAP AND SEAL INDORE PRIVATE LIMITED",
"CAP DIGISOFT SOLUTIONS PRIVATE LIMITED",
"CAP PLASTIC AND TUBES PRIVATE LIMITED",
"CAP SEAFOODS PRIVATE LIMITED",
"CAP VOLT ELECTRICALS AND AUTOMATION PRIVATE LIMITED",
"CAP WORKFORCE DEVELOPMENT INSTITUTE PRIVATE LIMITED",
"CAPACIT'E ENGINEERING PRIVATE LIMITED",
"CAPACITY WEB SOLUTIONS PRIVATE LIMITED",
"CAPAL INDUSTRIES PRIVATE LIMITED",
"CAPALPHA TRADE PRIVATE LIMITED",
"CAPARO ENGINEERING AND CONSTRUCTION LIMITED",
"CAPARO ENGINEERING INDIA LIMITED",
"CAPARO FINANCIAL SOLUTIONS LIMITED",
"CAPARO INDIA LIMITED",
"CAPARO LOGISTICS LIMITED",
"CAPARO MARUTI LIMITED",
"CAPARO MI STEEL PROCESSING PRIVATE LIMITED",
"CAPARO POWER LIMITED",
"CAPARO VEHICLE PRODUCTS INDIA LIMITED",
"CAPART INDUSTRIES PRIVATE LIMITED",
"CAPAZ INDUSTRIES PRIVATE LIMITED",
"CAPAZ INTERIORS PRIVATE LIMITED",
"CAPAZ SPORTS PRIVATE LIMITED",
"CAPCHINS (INDIA) PRIVATE LIMITED",
"CAPCHURE DESIGNS INDIA PRIVATE LIMITED",
"CAPCO ELECTRONICS PRIVATE LIMITED",
"CAPCO INDUSTRIES PRIVATE LIMITED",
"CAPCO TECHNOLOGIES PRIVATE LIMITED",
"CAPCO WATER SOLUTIONS PRIVATE LIMITED",
"CAPCP ENGINEERING SERVICES PRIVATE LIMITED",
"CAP-D INFRA & LOGISTICS PRIVATE LIMITED",
"CAPDEAL REALTY CARE PRIVATE LIMITED",
"CAPE ELECTRIC PRIVATE LIMITED",
"CAPE FLOUR MILLS PRIVATE LIMITED",
"CAPE INFRASTRUCTURE PRIVATE LIMITED",
"CAPE VALOUR SERVICES PRIVATE LIMITED",
"CAPECOM SOLUTIONS PRIVATE LIMITED",
"CAPELINE SHIPPING INDIA PRIVATE LIMITED",
"CAPELLA & ALHENA CLIENT SOLUTIONS PRIVATE LIMITED",
"CAPEQUI BOX VENTURES PRIVATE LIMITED",
"CAPER INDIA PRIVATE LIMITED",
"CAPER TRAVEL COMPANY PRIVATE LIMITED",
"CAPERMINT TECHNOLOGIES PRIVATE LIMITED",
"CAPERS HOSPITALITY PRIVATE LIMITED",
"CAPESTART SOFTWARE PRIVATE LIMITED",
"CAPESTONE VENTURES PRIVATE LIMITED",
"CAPEX AGRICULTURE AND AGRO PRODUCTS PRIVATE LIMITED",
"CAPEX CONSTRUCTION AND ENGINEERING PRIVATE LIMITED",
"CAPEXIL",
"CAPFLOAT FINANCIAL SERVICES PRIVATE LIMITED",
"CAPFRONT TECHNOLOGIES PRIVATE LIMITED",
"CAPGEMINI CONSULTING PRIVATE LIMITED",
"CAPGEMINI INDIA PRIVATE LIMITED",
"CAPGEMINI IT SOLUTIONS INDIA PRIVATE LIMITED",
"CAPGEMINI TECHNOLOGY SERVICES INDIA LIMITED",
"CAPGRID SOLUTIONS PRIVATE LIMITED",
"CAPILLARY TECHNOLOGIES INDIA LIMITED",
"CAPILLARY TECHNOLOGIES INDIA PRIVATE LIMITED",
"CAPINTELS TRANS SOLUTIONS PRIVATE LIMITED",
"CAPIOT SOFTWARE PRIVATE LIMITED",
"CAPIOUS ROADTECH PRIVATE LIMITED",
"CAPIQ ENGINEERING PVT LTD",
"CAPIQAL CONSULTANCY SERVICES PRIVATE LIMITED",
"CAPITA INDIA PRIVATE LIMITED",
"CAPITAL AGENCIES PRIVATE LIMITED",
"CAPITAL AGRO EXPORT PRIVATE LIMITED",
"CAPITAL AIRCOM INDIA ENGINEERING",
"CAPITAL APPARELS TECHNOLOGY PRIVATE LIMITED",
"CAPITAL AUTOMOBILES PRIVATE LIMITED",
"CAPITAL AUTOMOTIVES PRIVATE LIMITED",
"CAPITAL AUTOTECH EXPORTS PRIVATE LIMITED",
"CAPITAL BRICK FINANCIAL SERVICES AND TECHNOLOGIES PRIVATE LIMITED",
"CAPITAL BROADCASTING COMPANY PVT LTD",
"CAPITAL BUILDTECH LIMITED",
"CAPITAL BUSINESS MACHINES PRIVATE LIMITED",
"CAPITAL BUSINESS SYSTEMS PRIVATE LIMITED",
"CAPITAL CABLES INDIA PRIVATE LIMITED",
"CAPITAL CARPET EXIM PRIVATE LIMITED",
"CAPITAL CARS PRIVATE LIMITED",
"CAPITAL CHOWRINGHEE PRIVATE LIMITED",
"CAPITAL CLOTHING COMPANY",
"CAPITAL COLOUR PARK DIGITAL PRESS",
"CAPITAL CONSTRUCTIONS PRIVATE LIMITED",
"CAPITAL CYCLES PVT LTD",
"CAPITAL ELECTECH PRIVATE. LIMITED.",
"CAPITAL ELECTRICALS LIMITED",
"CAPITAL ENGINEERING COLLEGE",
"CAPITAL ENGINEERING CONSULTANCY PRIVATE LIMITED",
"CAPITAL ENGRAVING",
"CAPITAL EQUIPMENT SERVICES LIMITED",
"CAPITAL ESTATE MANAGEMENT SERVICES PRIVATE LIMITED",
"CAPITAL FEEDS PRIVATE LIMITED",
"CAPITAL FINSERVE LIMITED",
"CAPITAL FIRST HOME FINANCE LIMITED",
"CAPITAL FIRST LIMITED",
"CAPITAL FIRST SECURITIES LIMITED",
"CAPITAL FLIGHT SERVICES PRIVATE LIMITED",
"CAPITAL FOAM INDUSTRIES PRIVATE LIMITED",
"CAPITAL FOODS PRIVATE LIMITED",
"CAPITAL FORCE PRIVATE LIMITED",
"CAPITAL FOREX SERVICES PRIVATE LIMITED",
"CAPITAL FORTUNES PRIVATE LIMITED",
"CAPITAL FORTUNES VENTURES PRIVATE LIMITED",
"CAPITAL FUEL COMPANY PRIVATE LIMITED",
"CAPITAL GLASS PRIVATE LIMITED",
"CAPITAL HEALTH SERVICES INDIA PRIVATE LIMITED",
"CAPITAL HIND FINANCE PRIVATE LIMITED",
"CAPITAL HOSPITAL",
"CAPITAL HOSPITAL BHUBANESWAR",
"CAPITAL HOUSING PROJECTS PRIVATE LIMITED",
"CAPITAL IMPEX PRIVATE LIMITED",
"CAPITAL INDIA FINANCE LIMITED",
"CAPITAL INDIA HOME LOANS LIMITED",
"CAPITAL INFOART PRIVATE LIMITED",
"CAPITAL INFRATECHOMES PRIVATE LIMITED",
"CAPITAL INNOTECH PRIVATE LIMITED",
"CAPITAL INTERNATIONAL PRIVATE LIMITED",
"CAPITAL INVESTMENT RESEARCH SERVICES PRIVATE LIMITED",
"CAPITAL ISPAT LIMITED (TRANSFER FROM DELHI TO RAJASTHAN)",
"CAPITAL KNOWLEDGE CONSULTANCY PRIVATE LIMITED",
"CAPITAL LUBRICANTS PRIVATE LIMITED",
"CAPITAL MANAGEMENT COMPANY (INDIA) LIMITED",
"CAPITAL MARKET PUBLISHING INDIA PRIVATE LIMITED",
"CAPITAL METALIKS PRIVATE LIMITED",
"CAPITAL METRICS AND RISK SOLUTIONS PRIVATE LIMITED",
"CAPITAL ONE FINANCIAL CORPORATION",
"CAPITAL ONE HOUSING & INFRASTRUCTURE DEVELOPMENT PRIVATE LIMITED",
"CAPITAL ONE SERVICES INDIA PRIVATE LIMITED",
"CAPITAL ORTHOPAEDIC PRIVATE LIMITED",
"CAPITAL OUTSOURCING & MANAGEMENT SERVICES PRIVATE LIMITED",
"CAPITAL OVERSEASE PRIVATE LIMITED",
"CAPITAL PHOTO SERVICE PRIVATE LIMITED",
"CAPITAL PLUS FINANCE PRIVATE LIMITED",
"CAPITAL POLYFOAM PRIVATE LIMITED",
"CAPITAL POLYPLAST (GUJ ) PRIVATE LIMITED",
"CAPITAL POWER INFRASTRUCTURE PRIVATE LIMITED",
"CAPITAL POWER SYSTEMS LIMITED",
"CAPITAL PROJECT DIVISION NO 2 GANDHINAGAR",
"CAPITAL PROJECT SUB DIVISION 6 GANDHINAGAR",
"CAPITAL PROPMART PRIVATE LIMITED",
"CAPITAL PROTECTION FORCE PRIVATE LIMITED",
"CAPITAL QUANT SOLUTIONS PRIVATE LIMITED",
"CAPITAL RECORD CENTRE PRIVATE LIMITED",
"CAPITAL REGION URBAN TRANSPORT",
"CAPITAL RETAIL PRIVATE LIMITED",
"CAPITAL ROADWAYS & FINANCE PVT LTD",
"CAPITAL SETU PRIVATE LIMITED",
"CAPITAL SHIPPING PRIVATE LIMITED",
"CAPITAL SMALL FINANCE BANK LIMITED",
"CAPITAL SPINDLES (INDIA) PRIVATE LIMITED",
"CAPITAL SUGAR PRIVATE LIMITED",
"CAPITAL SURGICAL COMPANY PRIVATE LIMITED",
"CAPITAL TRADE LINKS LIMITED",
"CAPITAL TREE FINANCIAL SOLUTIONS PRIVATE LIMITED",
"CAPITAL TRUST LIMITED",
"CAPITAL VEHICLES SALES LIMITED",
"CAPITAL VENTURES PRIVATE LIMITED",
"CAPITALAND HOPE FOUNDATION (INDIA)",
"CAPITALAND SERVICES (INDIA) PRIVATE LIMITED",
"CAPITALBOX ADVISORY AND MANAGEMENT SERVICES PRIVATE LIMITED",
"CAPITALCLOUD INDIA PRIVATE LIMITED",
"CAPITALGRAM MARKETING & TECHNOLOGY PRIVATE LIMITED",
"CAPITALMIND FINANCIAL SERVICES PRIVATE LIMITED",
"CAPITALMIND TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"CAPITALNEXT FINTECH PRIVATE LIMITED",
"CAPITALNUMBERS INFOTECH PRIVATE LIMITED",
"CAPITALPLUS FINSALES (I) PRIVATE LIMITED",
"CAPITALSQUARE INSURANCE BROKERS PRIVATE LIMITED",
"CAPITALTREE HEALTH CARE PRIVATE LIMITED",
"CAPITALVIA GLOBAL RESEARCH LIMITED",
"CAPITALWORLD MEDIA SERVICES PRIVATE LIMITED",
"CAPITAO SECURITY SERVICES PRIVATE LIMITED",
"CAPITAX ACCOUNTING PRIVATE LIMITED",
"CAPITOL ESTATES PRIVATE LIMITED",
"CAPITOL FIBRES PRIVATE LIMITED",
"CAPITOL HILL HOTELS PRIVATE LIMITED",
"CAPITOL HOSPITAL",
"CAPITOL NONWOVENS PRIVATE LIMITED",
"CAPITOL NURSING HOME PRIVATE LIMITED",
"CAPITOLINE TRIAD PRIVATE LIMITED",
"CAPIUM SMART ACCOUNTING SOLUTIONS PRIVATE LIMITED",
"CAPL HOTELS AND SPA PRIVATE LIMITED",
"CAPL MOTOR PARTS PRIVATE LIMITED",
"CAPLE INDUSTRIAL SOLUTIONS",
"CAPLET HEALTH CARE PRIVATE LIMITED",
"CAPLET INDIA PRIVATE LIMITED",
"CAPLIN POINT LABORATORIES LIMITED",
"CAPLIN STERILES LIMITED",
"CAPLINE SERVICES PRIVATE LIMITED",
"CAPMAN INDIA CONSUMER PRODUCTS PRIVATE LIMITED",
"CAPNET TECHNOLOGIES PRIVATE LIMITED",
"CAPPELINE PHARMACEUTICALS PRIVATE LIMITED",
"CAPPELLA SPORTS PRIVATE LIMITED",
"CAPPEY INDIA PRIVATE LIMITED",
"CAPREFINDIA PRIVATE LIMITED",
"CAPRESTA INDIA PRIVATE LIMITED",
"CAPRI ACCOUNTING & PROFESSIONAL SERVICES PRIVATE LIMITED",
"CAPRI GLOBAL ADVISORY SERVICES PRIVATE LIMITED",
"CAPRI GLOBAL ASSET RECONSTRUCTION PRIVATE LIMITED",
"CAPRI GLOBAL CAPITAL LIMITED",
"CAPRI GLOBAL HOLDINGS PRIVATE LIMITED",
"CAPRI GLOBAL HOUSING FINANCE LIMITED",
"CAPRI HEALTHCARE AND RESEARCH INSTITUTE PRIVATE LIMITED",
"CAPRI HOSPITALITY SERVICES PRIVATE LIMITED",
"CAPRI SALES AND SERVICES PRIVATE LIMITED",
"CAPRI TRANSFORMERS PRIVATE LIMITED",
"CAPRICANS AQUA PRIVATE LIMITED",
"CAPRICE SERVICES PRIVATE LIMITED",
"CAPRICO FACILITIES SERVICES PRIVATE LIMITED",
"CAPRICOAST HOME SOLUTIONS PRIVATE LIMITED",
"CAPRICOATING SOLUTIONS PVT LTD",
"CAPRICON REALTY LIMITED",
"CAPRICON REALTY PRIVATE LIMITED",
"CAPRICON STYPACK (INDIA) PRIVATE LIMITED",
"CAPRICORN BLENDERS PRIVATE LIMITED",
"CAPRICORN DISTILLERY PRIVATE LIMITED",
"CAPRICORN HOLDINGS PRIVATE LIMITED",
"CAPRICORN IDENTITY SERVICES PRIVATE LIMITED",
"CAPRICORN INVESTECH PRIVATE LIMITED",
"CAPRICORN LIFESTYLE PRIVATE LIMITED",
"CAPRICORN LOGISTICS PRIVATE. LIMITED.",
"CAPRICORN MOTORS PRIVATE LIMITED",
"CAPRICORN OILS LIMITED",
"CAPRICORN REALTY PRIVATE LIMITED",
"CAPRICORN SECURITY & ALLIED SERVICES PRIVATE LIMITED",
"CAPRICORN SOFTWARE INDIA PRIVATE LIMITED",
"CAPRICORN SYSTEMS GLOBAL SOLUTIONS LIMITED",
"CAPRICORN TRANSWAYS PVT LTD",
"CAPRICOT TECHNOLOGIES PRIVATE LIMITED",
"CAPRIHANS INDIA LIMITED",
"CAPRO LABS EXPORTS INDIA PRIVATE LIMITED",
"CAPROFUNDS LLP",
"CAPROLACTAM CHEMICALS LIMITED",
"CAPRON OIL MANAGEMENT & ENGINEERING SOLUTIONS PRIVATE LIMITED",
"CAPRON VITRIFIED PRIVATE LIMITED",
"CAPRUS IT PRIVATE LIMITED",
"CAPS & SHELLS CREATIVES PRIVATE LIMITED",
"CAPS GOLD PRIVATE LIMITED",
"CAPS INTERNATIONAL PRIVATE LIMITED",
"CAPS TALENT TECHNOLOGIES PRIVATE LIMITED",
"CAPS TRADELINK PRIVATE LIMITED",
"CAPSAVE FINANCE PRIVATE LIMITED",
"CAPSHARE IMPEX PRIVATE LIMITED",
"CAPSICUM GLOBAL ADVISORY PRIVATE LIMITED",
"CAPSITECH IT SERVICES PRIVATE LIMITED",
"CAPSLOCK DIGITAL SOLUTIONS PRIVATE LIMITED",
"CAPSOFT HEALTHCARE PRIVATE LIMITED",
"CAPSOL ENERGY PRIVATE LIMITED",
"CAPSOL SUNRAY PRIVATE LIMITED",
"CAPSON TILES PRIVATE LIMITED",
"CAPSTAN METERS (INDIA) LIMITED",
"CAPSTECH NETWORK PRIVATE LIMITED",
"CAPSTOCKS AND SECURITIES INDIA PRIVATE LIMITED",
"CAPSTONE AUTOMOTIVE ASSEMBLIES PRIVATE LIMITED",
"CAPSTONE CONSULTANTS PRIVATE LIMITED",
"CAPSTONE LANDMARKS PRIVATE LIMITED",
"CAPSTONE POLYWEAVE PRIVATE LIMITED",
"CAPSTONE SECURITIES ANALYSIS PRIVATE LIMITED",
"CAPSUGEL HEALTHCARE PRIVATE LIMITED",
"CAPSULATION AND PHARMACEUTICALS PRIVATE LTD",
"CAPSULATION SERVICES PRIVATE LIMITED",
"CAPSYSTEMATIC TECHNOLOGIES PRIVATE LIMITED",
"CAPT S S S REWARI ARI CHARITABLE TRUST",
"CAPTAIN CUBE TECHNOLOGIES",
"CAPTAIN FOX PRIVATE LIMITED",
"CAPTAIN MEDIA PRIVATE LIMITED",
"CAPTAIN MOTO PRIVATE LIMITED",
"CAPTAIN PIPES LIMITED",
"CAPTAIN POLYPLAST LIMITED",
"CAPTAIN RAMESH RICE MILLS PRIVATE LIMITED",
"CAPTAIN STEEL INDIA LIMITED",
"CAPTAIN TECHNOCAST LIMITED",
"CAPTAIN TRACTORS PRIVATE LIMITED",
"CAPTAIN VIDEO PRIVATE LIMITED",
"CAPTECH TECHNOLOGIES PRIVATE LIMITED",
"CAPTECK OVERSEAS PRIVATE LIMITED",
"CAPTEL INTERNATIONAL PRIVATE LIMITED",
"CAPTERNAL SYSTEMS PRIVATE LIMITED",
"CAPTIV TECHNO SOLUTIONS PRIVATE LIMITED",
"CAPTIVA ENERGY SOLUTIONS PRIVATE LIMITED",
"CAPTIVATE SOFTECH PRIVATE LIMITED",
"CAPTIVEAIDE ADVISORY PRIVATE LIMITED",
"CAPTIWATE IT SOLUTIONS & CONSULTING PRIVATE LIMITED",
"CAPTRONIC SYSTEMS PRIVATE LIMITED",
"CAPTUM IT PRIVATE LIMITED",
"CAPTURE NETWORK SYSTEMS PRIVATE LIMITED",
"CAPTUREATRIP INDIA PRIVATE LIMITED",
"CAPULUM ENGINEERING P LTD",
"CAPUP ONLINE SERVICES PRIVATE LIMITED",
"CAPVITAL ADVISORS PRIVATE LIMITED",
"CAPWISE FINANCIAL SERVICES PRIVATE LIMITED",
"CAR AUTOMOTIVE CONSULTANCY INDIA PRIVATE LIMITED",
"CAR AUTOMOTIVE LLP",
"CAR CHASSIS CARRIERS PRIVATE LIMITED",
"CAR PAVILLION PRIVATE LIMITED",
"CAR PLANET WHEELS PRIVATE LIMITED",
"CARAM HEALTH CARE INDIA PRIVATE LIMITED",
"CARAMEL LOGISTICS PRIVATE LIMITED",
"CARAMTECH PRIVATE LIMITED",
"CARAPACE INFRA & FORMLINE TECHNOLOGIES PRIVATE LIMITED",
"CARAT MEDIA SERVICES INDIA PRIVATE LIMITED",
"CARAT TRADELINK PRIVATE LIMITED",
"CARATLANE TRADING PRIVATE LIMITED",
"CARATLINE GEMS PRIVATE LIMITED",
"CARATRED TECHNOLOGIES LLP",
"CARAVAN CARRIERS PRIVATE LIMITED",
"CARAVAN ELECTRICALS PVT LTD",
"CARAVAN FREIGHT CARRIER PRIVATE LIMITED",
"CARAVAN HOTELS PRIVATE LIMITED",
"CARAVAN LOGIPARK PRIVATE LIMITED",
"CARAVAN OIL SUPPLIERS",
"CARAVAN ROADWAYS (PUNJAB) PRIVATE LIMITED",
"CARAVAN ROADWAYS LIMITED",
"CARAVEL LOGISTICS PRIVATE LIMITED",
"CARAVEL MOTORS PRIVATE LIMITED",
"CARAVEL RESOURCES (INDIA) PRIVATE LIMITED",
"CARAWAY DEVELOPMENT CENTRE (INDIA) PRIVATE LIMITED",
"CARBAC HOLDINGS LIMITED",
"CARBEL MERCANTILES LTD",
"CARBIDE CUTTING TOOLS PRIVATE LIMITED",
"CARBINE ENTERPRISES PRIVATE LIMITED",
"CARBO WIND ELECTRICALS PRIVATE LIMITED",
"CARBOLINE INDIA PRIVATE. LIMITED.",
"CARBOLINE TOOLINGS (INDIA) PRIVATE LIMITED",
"CARBON BRUSH COMPANY PRIVATE LIMITED",
"CARBON CHECK (INDIA) PRIVATE LIMITED",
"CARBON CLEAN SOLUTIONS PRIVATE LIMITED",
"CARBON CONSTRUCTIONS (INDIA) PRIVATE LIMITED",
"CARBON CREATION EXPORTS PRIVATE LIMITED",
"CARBON EDGE INDUSTRIES LIMITED",
"CARBON ENTERTAINMENT PRIVATE LIMITED",
"CARBON FINANCE LIMITED",
"CARBON ISPAAT LIMITED",
"CARBON LOOPS PRIVATE LIMITED",
"CARBON MASTERS INDIA PRIVATE LIMITED",
"CARBON REDUCTION TECHNOLOGY INNOVATIONS PRIVATE LIMITED",
"CARBON ROTOFLUID PRIVATE LIMITED",
"CARBON SPECIALITIES LIMITED",
"CARBONAIRE INDUSTRIES MADRAS PRIVATE LIMITED",
"CARBONCAPTURE TECHNOLOGIES PRIVATE LIMITED",
"CARBORUNDUM UNIVERSAL LIMITED",
"CARBOTEC INDIA PRIVATE LIMITED",
"CARBTOOLS INDIA PRIVATE LIMITED",
"CARBURE ACTIVATED CARBON PRIVATE LIMITED",
"CARBYNETECH INDIA PRIVATE LIMITED",
"CARCA RAPID SOLUTIONS PRIVATE LIMITED",
"CARCARE AUTOMOTIVES PRIVATE LIMITED",
"CARCINOVA CANCER HOSPITAL",
"CARCINOVA PRIVATE LIMITED",
"CARCLO TECHNICAL PLASTICS PRIVATE LIMITED",
"CARCREW TECHNOLOGY PRIVATE LIMITED",
"CARD SYSTEMS PRIVATE LIMITED",
"CARDAMOM GROWERSFOREVER PRIVATE LIMITED",
"CARDAMOM LOGISTICS ASSETS (INDIA) PRIVATE LIMITED",
"CARDAMOM PRODUCTS PRIVATE LIMITED",
"CARDEL HEALTHCARE PRIVATE LIMITED",
"CARDIAC CARE AND ALLIED HEALTH PRIVATE LIMITED",
"CARDIAC DESIGN LABS PRIVATE LIMITED",
"CARDIAC RESEARCH AND EDUCATION FOUNDATION",
"CARDIER FOODS AND BEVERAGES PRIVATE LIMITED",
"CARDIN HEALTH CARE PRIVATE LIMITED",
"CARDINAL CHEMICALS PRIVATE LIMITED",
"CARDINAL ENERGY AND INFRASTRUCTURE PRIVATE LIMITED",
"CARDINAL ENGINEERING CONSULTANT PRIVATE LIMITED",
"CARDINAL HEALTH",
"CARDINAL HEALTH INTERNATIONAL INDIA PRIVATE LIMITED",
"CARDINAL MEDICAL TECHNOLOGIES PRIVATE LIMITED",
"CARDINAL MERCANTILE PRIVATE LIMITED",
"CARDINAL TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"CARDINAL WIRE INDUSTRIES PRIVATE LIMITED",
"CARDIO CONSUMABLES PRIVATE LIMITED",
"CARDIO FITNESS INDIA PRIVATE LIMITED",
"CARDIOLABS HEALTHCARE INDIA PRIVATE LIMITED",
"CARDIOMAC INDIA PRIVATE LIMITED",
"CARDIOMED INDIA LIMITED",
"CARDKEM PHARMA PRIVATE LIMITED",
"CARDLYTICS SERVICES INDIA PRIVATE LIMITED",
"CARDO PHARMA PRIVATE LIMITED",
"CARDOLITE SPECIALTY CHEMICALS INDIA LLP",
"CARDONIND SERVICES PRIVATE LIMITED",
"CARDS VALLY INDIA PRIVATE LIMITED",
"CARDTRONICS INDIA LLP",
"CARDUP INDIA PRIVATE LIMITED",
"CARDWELL SPINNING MILLS LIMITED",
"CARE & BEYOND WELLNESS PRIVATE LIMITED",
"CARE 2 EARN SERVICES PRIVATE LIMITED",
"CARE ADVISORY RESEARCH AND TRAINING LIMITED",
"CARE AND CARE SERVICES PRIVATE LIMITED",
"CARE AND CURE MULTISPECIALITY HOSPITAL",
"CARE AND CURE PRIVATE LIMITED",
"CARE BENZORGANICS PRIVATE LIMITED",
"CARE BIOSYSTEMS INDIA PRIVATE LIMITED",
"CARE CARDS INDIA PRIVATE LIMITED",
"CARE CERTIFICATION PRIVATE LIMITED",
"CARE CLEARING AND FORWARDING PRIVATE LIMITED",
"CARE CLEARING HOUSE PRIVATE LIMITED",
"CARE COLLEGE OF NURSING",
"CARE CONCERN HOSPITAL PRIVATE LIMITED",
"CARE CONSULTANTS SECURITY AND MANPOWER SERVICES PRIVATE LIMITED",
"CARE CONTAINER LINES PRIVATE LIMITED",
"CARE DATA INFOMATICS PRIVATE LIMITED",
"CARE DATA INFORMATICS PRIVATE LIMITED",
"CARE DETERGENTS PRIVATE LIMITED",
"CARE EDUCATION AND WELFARE SOCIETY",
"CARE ESG RATINGS LIMITED",
"CARE FERTILITY SOLUTIONS PRIVATE LIMITED",
"CARE FONE PRIVATE LIMITED",
"CARE FORMULATION LABS PRIVATE LIMITED",
"CARE GO LOGISTICS PRIVATE LIMITED",
"CARE HEALTH INSURANCE LIMITED",
"CARE HEALTH NURSES PRIVATE LIMITED",
"CARE HOSPITAL",
"CARE HYGIENE PRIVATE LIMITED",
"CARE INDIA FINVEST LIMITED",
"CARE INDIA SOLUTIONS FOR SUSTAINABLE DEVELOPMENT",
"CARE INTERIO PRIVATE LIMITED",
"CARE INTERNATIONAL MULTI SERVICES PRIVATE LIMITED",
"CARE INTERNATIONAL SCHOOL",
"CARE IO INFOTECH PRIVATE LIMITED",
"CARE LABS",
"CARE MEDICAL DEVICES LIMITED",
"CARE MEDICAL SOLUTION PRIVATE LIMITED",
"CARE MULTI FINANCIAL SERVICES",
"CARE MULTISPECIALITY HOSPITAL",
"CARE ONE SOLUTION",
"CARE PACK PRIVATE LIMITED",
"CARE PHARMACY PRIVATE LIMITED",
"CARE PORTFOLIO MANAGERS PRIVATE LIMITED",
"CARE PRO BIOSCIENCE PRIVATE LIMITED",
"CARE RATINGS LIMITED",
"CARE ANALYTICS AND ADVISORY PRIVATE LIMITED",
"CARE SECURITY PRIVATE LIMITED",
"CARE SOAPS PRIVATE LIMITED",
"CARE TAKERS EXTERIOR & INTERIOR PRIVATE LIMITED",
"CARE TECHNICAL AND FACILITY SERVICES PRIVATE LIMITED",
"CARE TREATMENT CENTRE PRIVATE LIMITED",
"CARE UNIVERSAL BUSINESS SOLUTIONS PRIVATE LIMITED",
"CARE UTILITY PRODUCTS PRIVATE LIMITED",
"CARE VISION FIBER PRIVATE LIMITED",
"CARE WELL RAYON PVT LTD",
"CARE ZEST SERVICES PRIVATE LIMITED",
"CARE4YOU MEDTEC PRIVATE LIMITED",
"CAREANIMATIONS PRIVATE LIMITED",
"CAREASSIST WELLNESS PRIVATE LIMITED",
"CAREATOR TECHNOLOGIES PRIVATE LIMITED",
"CARECENTRA (INDIA) PRIVATE LIMITED",
"CARECOOL SERVICES PRIVATE LIMITED",
"CARECRES SERVICES INDIA PRIVATE LIMITED",
"CAREDOVE INDIA SOFTWARE PRIVATE LIMITED",
"CAREEO HEALTHCARE SERVICES PRIVATE LIMITED",
"CAREER ACADEMY",
"CAREER COMPASS SERVICES PRIVATE LIMITED",
"CAREER CREATORS PRIVATE LIMITED",
"CAREER EDUCOM ACADEMY",
"CAREER ENDEAVOUR ACADEMY PRIVATE LIMITED",
"CAREER HEIGHTS SERVICES",
"CAREER INSTITUTE OF MEDICAL SCIENCES & HOSPITAL",
"CAREER KNOWLEDGE RESOURCES PRIVATE LIMITED",
"CAREER LAUNCHER EDUCATION INFRASTRUCTURE AND SERVICES LIMITED",
"CAREER LAUNCHER INFRASTRUCTURE PRIVATE LIMITED",
"CAREER LEADER EDUCATIONAL SERVICES",
"CAREER LINE COACHING INSTITUTE",
"CAREER MOSAIC PRIVATE LIMITED",
"CAREER PATHMAKERS PRIVATE LIMITED",
"CAREER POINT ACCESSORIES PRIVATE LIMITED",
"CAREER POINT EDUTECH LIMITED",
"CAREER POINT INFRA LIMITED",
"CAREER POINT LIMITED",
"CAREER POINT UNIVERSITY",
"CAREER QUEST CONSULTING INDIA PRIVATE LIMITED",
"CAREER SOFT LINKS PRIVATE LIMITED",
"CAREER SOFT SOLUTIONS PRIVATE LIMITED",
"CAREER SOLUTION PRIVATE LIMITED",
"CAREER TREE HR SOLUTIONS PRIVATE LIMITED",
"CAREER WILL INFORMATION CENTRE PRIVATE LIMITED",
"CAREER ZONE CONSULTING PRIVATE LIMITED",
"CAREERIST MANAGEMENT CONSULTANTS PRIVATE.LIMITED",
"CAREERLABS TECHNOLOGIES PRIVATE LIMITED",
"CAREERLINE EDUCATION FOUNDATION",
"CAREERMAKERS EDUCATION PRIVATE LIMITED",
"CAREERNET TECHNOLOGIES PRIVATE LIMITED",
"CAREERORBITS EPORTALS PRIVATE LIMITED",
"CAREERS N OPTIONS SERVICES PRIVATE LIMITED",
"CAREERSTACK INNOVATIONS PRIVATE LIMITED",
"CAREFINE WOODWORKS PVT LTD",
"CAREFUSION DEVELOPMENT PRIVATE LIMITED",
"CAREGENEX HEALTHCARE PRIVATE LIMITED",
"CAREGROUP SIGHT SOLUTION PRIVATE LIMITED",
"CAREGROWTH BROKING PRIVATE LIMITED",
"CARE-IND CHEM PRIVATE LIMITED",
"CAREINDIA HEALTH PRIVATE LIMITED",
"CAREL ACR SYSTEMS INDIA PRIVATE LIMITED",
"CARELABMED LABORATORY'S AND MEDICAL SUPPLIES PRIVATE LIMITED",
"CARELON GLOBAL SOLUTIONS INDIA LLP",
"CARE-MED PHARMACEUTICALS PRIVATE LIMITED",
"CAREMOLI GUAR INDUSTRY PRIVATE LIMITED",
"CARENCURE PHARMA PRIVATE LIMITED",
"CARENOMICS HEALTHCARE PRIVATE LIMITED",
"CARENOW MEDICAL PRIVATE LIMITED",
"CARENX INNOVATIONS PRIVATE LIMITED",
"CAREON HEALTHCARE SOLUTIONS PRIVATE LIMITED\n",
"CARES RENEWABLES PRIVATE LIMITED",
"CARESOFT CONSULTANCY PRIVATE LIMITED",
"CARESOFT GLOBAL PRIVATE LIMITED",
"CARESOFT GLOBAL TECHNOLOGIES PRIVATE LIMITED",
"CARESOFT INC",
"CARESOURCE HEALTH SERVICES PRIVATE LIMITED",
"CARESS BEAUTY CARE PRODUCTS PRIVATE LIMITED",
"CARESTREAM DENTAL INDIA PRIVATE LIMITED",
"CARESTREAM HEALTH INDIA PRIVATE LIMITED",
"CARET IT SOLUTIONS PRIVATE LIMITED",
"CARETECH PACKAGING PRIVATE LIMITED",
"CARETECH SOLUTIONS INDIA PRIVATE LIMITED",
"CAREVANTIS MEDICARE PRIVATE LIMITED",
"CAREVEE LOGISTICS SOLUTIONS PRIVATE LIMITED",
"CAREVEL MEDICAL",
"CAREVIGIL TECHNOLOGIES PRIVATE LIMITED",
"CAREWAYS TOURS AND TRAVELS PRIVATE LIMITED",
"CAREWEL FACILITIES INDIA PRIVATE LIMITED",
"CAREWELL BIOTECH PRIVATE LIMITED",
"CAREWELL CARGO MOVERS PRIVATE LIMITED",
"CAREWELL GLASS AND AMPOULES PVT LTD",
"CAREWELL HOSPITALS AND RESEARCH CENTRE PVT LTD",
"CAREWELL MEDICAL SYSTEMS PRIVATE LIMITED",
"CAREWELL MOTORS AND INFRA PRIVATE LIMITED",
"CAREWELL REPELLENTS PVT LTD",
"CAREWELL STEUART PHARMA PRIVATE LIMITED",
"CAREWELL TRAVELS AND TOUR PRIVATE LIMITED",
"CAREWIN PHARMACEUTICALS (GUJARAT) PRIVATE LIMITED",
"CAREWISE HEALTH VENTURES PRIVATE LIMITED",
"CAREX CARGO EXPRESS PRIVATE LIMITED",
"CAREX CARGO FORWARDERS PRIVATE LIMITED.",
"CAREXIAA HEALTHCARE PRIVATE LIMITED",
"CARFER COMMODITIES PRIVATE LIMITED",
"CARFU KNITS PRIVATE LIMITED",
"CARGAISON LOGISTICS EXPRESS PRIVATE LIMITED",
"CARGILL BUSINESS SERVICES INDIA PRIVATE LIMITED",
"CARGILL GLOBAL TRADING INDIA PRIVATE LIMITED",
"CARGILL INDIA PRIVATE LIMITED",
"CARGILL SOUTH EAST ASEA LIMITED,",
"CARGO AQUA FAUCETS PRIVATE LIMITED",
"CARGO ASIA LOGISTICS PRIVATE LIMITED",
"CARGO CARE SHIPPING & FORWARDING INDIA PRIVATE LIMITED",
"CARGO CARRIERS INDIA LIMITED",
"CARGO CHANNELS PRIVATE LIMITED",
"CARGO COMMUNITY NETWORK PTE LIMITED",
"CARGO CONCEPTS (BOMBAY) PRIVATE LIMITED",
"CARGO CONSOL INDIA PRIVATE LIMITED",
"CARGO CONSOLIDATORS INDIA PRIVATE LIMITED",
"CARGO CONSTRUCTION COMPANY PRIVATE LIMITED",
"CARGO CONTAINER TERMINAL INDIA PRIVATE LIMITED",
"CARGO EASE PRIVATE LIMITED",
"CARGO EXCHANGE INDIA PRIVATE LIMITED",
"CARGO FLASH INFOTECH PRIVATE LIMITED",
"CARGO GEAR SERVICES INDIA PRIVATE LIMITED",
"CARGO INTERNATIONAL INDIA PRIVATE LIMITED",
"CARGO MAR PRIVATE LIMITED",
"CARGO MARKETING INTERNATIONAL PRIVATE LIMITED",
"CARGO MOTORS (KUTCH) PRIVATE LIMITED",
"CARGO MOTORS AHMEDABAD PRIVATE LIMITED",
"CARGO MOTORS DELHI PRIVATE LIMITED",
"CARGO MOTORS GUJARAT PRIVATE LIMITED",
"CARGO MOTORS PRIVATE LIMITED",
"CARGO MOTORS PUNJAB PRIVATE LIMITED",
"CARGO MOTORS RAJASTHAN PRIVATE LIMITED",
"CARGO MOVERS AND LOGISTICS PRIVATE LIMITED",
"CARGO NAVIGATION SERVICES PRIVATE LIMITED",
"CARGO ONE OCEAN AIR LOGISTICS PRIVATE LIMITED",
"CARGO PARTNER LOGISTICS INDIA PRIVATE LIMITED",
"CARGO PARTNER LOGISTICS INDIA PVT LTD",
"CARGO PLACEMENT SERVICES AND AGENCIES PRIVATE LIMITED",
"CARGO PLAN INTERNATIONAL (INDIA) PRIVATE LIMITED",
"CARGO PLAYERS LOGISTICS INDIA PRIVATE LIMITED",
"CARGO SERVICE CENTER INDIA PRIVATE LIMITED",
"CARGO SERVICES PRIVATE LIMITED",
"CARGO SHIPPING CONSOLIDATORS PRIVATE LIMITED",
"CARGO SOLAR POWER PRIVATE LIMITED",
"CARGO SOLUTIONS LOGISTICS PRIVATE LIMITED",
"CARGO SYSTEMS (INDIA) PRIVATE LIMITED",
"CARGO TRANS INDIA PRIVATE LIMITED",
"CARGO TRANS SHIPPING SERVICES INDIA PRIVATE LIMITED",
"CARGO WORLD LOGISTICS INDIA PRIVATE LIMITED",
"CARGOCARE FREIGHT AND FORWARDING PRIVATE LIMITED",
"CARGOCARE LOGISTICS INDIA PRIVATE LIMITED",
"CARGOES TECHNOLOGY INDIA PRIVATE LIMITED",
"CARGOMAR KOLKATA PRIVATE LIMITED",
"CARGOMASTER INDIA",
"CARGOMEN LOGISTICS INDIA PRIVATE LIMITED",
"CARGOMILE LOGISTICS INDIA PRIVATE LIMITED",
"CARGOMIND LOGISTICS PRIVATE LIMITED",
"CARGOPEDIA INDIA PRIVATE LIMITED",
"CARGOPEOPLE LOGISTICS & SHIPPING PRIVATE LIMITED",
"CARGOSAFE EXPRESS LOGISTICS INDIA PRIVATE LIMITED",
"CARGOSITE VENTURES PRIVATE LIMITED",
"CARGOSOL LOGISTICS LIMITED",
"CARGOSOL LOGISTICS PRIVATE LIMITED",
"CARGOSOL SHIPPING AGENCY PRIVATE LIMITED",
"CARGOTEC INDIA PRIVATE LIMITED.",
"CARGOTRANS MARITIME AGENCIES PRIVATE LIMITED",
"CARGOTRANS MARITIME FORWARDING PRIVATE LIMITED",
"CARGOTRANS MARITIME LIMITED",
"CARIA ELECTRONIC TECHNOLOGY PRIVATE LIMITED",
"CARIANO TELECOM PRIVATE LIMITED",
"CARIBEX AGRI CARE SERVICES PRIVATE LIMITED",
"CARICIMA ENTERPRISES PRIVATE LIMITED",
"CARICO SYSTEMS PRIVATE LIMITED",
"CARICON BUILDING SERVICES PRIVATE LIMITED",
"CARINE KARE MED PRO PRIVATE LIMITED",
"CARINGCO PRIVATE LIMITED",
"CARINO AUTO INFRA PRIVATE LIMITED",
"CARINO HOLDINGS PRIVATE LIMITED",
"CARIQ TECHNOLOGIES PRIVATE LIMITED",
"CARISMA SOLUTIONS PRIVATE LIMITED",
"CARISTAR LABORATORIES PRIVATE LIMITED",
"CARITAS HEALTHCARE PRIVATE LIMITED",
"CARITAS HOSPITAL",
"CARITAS INDIA",
"CARITAS INFRA CONSULTING PRIVATE LIMITED",
"CARITOR SOLUTIONS INDIA PRIVATE LIMITED",
"CARKRAFT AUTOMOBILES AND INFRASTRUCTURE PRIVATE LIMITED",
"CARL ADVERTISING PRIVATE LIMITED",
"CARL BECHEM LUBRICANTS INDIA PRIVATE LIMITED",
"CARL STAHL CRAFTSMAN ENTERPRISES PRIVATE LIMITED",
"CARL ZEISS INDIA BANGALORE PRIVATE LIMITED",
"CARL ZEISS INDIA PRIVATE LIMITED",
"CARLILL ENERGY PRIVATE LIMITED",
"CARLINE TECHNOLOGIES PRIVATE LIMITED",
"CARLISLE TRADING & MANUFACTURING INDIA PRIVATE LIMITED",
"CARLMANN SCHMIDT (INDIA) PVT LTD",
"CARLO TRAVELS INDIA PRIVATE LIMITED",
"CARLRIMA IMPEX PRIVATE LIMITED",
"CARLSBERG INDIA PRIVATE LIMITED",
"CARLSON HALL SOLUTIONS PRIVATE LIMITED",
"CARLSON HOTELS SOUTH ASIA PRIVATE LIMITED",
"CARLTON HILLS PRIVATE LIMITED",
"CARLTON LEISURE TRAVELS PRIVATE LIMITED",
"CARLTON ONE ENGAGEMENT INDIA PRIVATE LIMITED",
"CARLTON OVERSEAS PRIVATE LIMITED",
"CARLTON PHARMACUTICALS AND CHEMICALS PRIVATE LIMITED",
"CARLTON RETAIL PRIVATE LIMITED",
"CARLTON TRAVELS PRIVATE LIMITED",
"CARLYLE INDIA ADVISORS PRIVATE LIMITED",
"CARMA ARTS AND CRAFTS PRIVATE LIMITED",
"CARMA CREATIVE PRIVATE LIMITED",
"CARMA INTERNATIONAL INDIA PRIVATE LIMITED",
"CARMAC TECHNOLOGIES PRIVATE LIMITED",
"CARMALL EXCHANGE PRIVATE LIMITED",
"CARMANN AUTO PRIVATE LIMITED",
"CARMATEC IT SOLUTIONS PRIVATE LIMITED",
"CARMEL CONVENT SCHOOL",
"CARMEL CONVENT SENIOR SECONDARY SCHOOL",
"CARMEL HIGH SCHOOL FOR GIRLS",
"CARMEL HOSPITAL",
"CARMEL ORGANICS PRIVATE LIMITED",
"CARMEL SCHOOL",
"CARMEL SCHOOL HAZARIBAG",
"CARMET TECHNOLOGIES PRIVATE LIMITED",
"CARMINOL LABORATORIES PVT LTD",
"CARMIYA INDUSTRIES PRIVATE LIMITED",
"CARMUL CERAMICS PRIVATE LIMITED",
"CARNA MEDICAL DATABASE PRIVATE LIMITED",
"CARNATION ACREAGE PRIVATE LIMITED",
"CARNATION BUILDTECH LIMITED",
"CARNATION CODE PRIVATE LIMITED",
"CARNATION CREATIONS PRIVATE LIMITED",
"CARNATION DEVELOPERS PRIVATE LIMITED",
"CARNATION HOTELS PRIVATE LIMITED",
"CARNATION INFOTECH PRIVATE LIMITED",
"CARNATION TRADE-LINK PRIVATE LIMITED",
"CARNATION TRAVEL SERVICES PRIVATE LIMITED",
"CARNEA HEALTH CARE PRIVATE LIMITED",
"CARNEGIE ENDOWMENT FOR INTERNATIONAL PEACE INDIA",
"CARNEGIE WORLDWIDE SERVICES PRIVATE LIMITED",
"CARNELIAN ASSET MANAGEMENT & ADVISORS PRIVATE LIMITED",
"CARNERA TECHNOLOGIES PRIVATE LIMITED",
"CARNEX SALES AGENCIES PVT LTD",
"CARNEX TIMBERS PRIVATE LIMITED",
"CARNIVAL ELECTRONICS PRIVATE LIMITED",
"CARNIVAL ENTERTAINMENT AND MEDIA PRIVATE LIMITED",
"CARNIVAL MOTION PICTURES PRIVATE LIMITED",
"CARNIVAL SOFT PRIVATE LIMITED",
"CARNIVAL SUPPORT SERVICES INDIA PRIVATE LIMITED",
"CARNIVAL TECHNO PARK PRIVATE LIMITED",
"CARNIVORE FOODS PRIVATE LIMITED",
"CARNIWAL INVESTMENTS LTD",
"CARNOT TECHNOLOGIES PRIVATE LIMITED",
"CAROA PROPERTIES LLP",
"CAR-O-BAAR RENTALS PRIVATE LIMITED",
"CAROBAR BUSINESS SOLUTIONS INDIA PRIVATE LIMITED",
"CAROL IN BEACH RESORT PRIVATE LIMITED",
"CAROL INFO SERVICES LIMITED",
"CAROL INFRASTRUCTURE PRIVATE LIMITED",
"CAROL PETROLEUM PRIVATE LIMITED",
"CAROL ZIRCOLITE PVT LTD",
"CAROLINA INFRA PROJECTS PRIVATE LIMITED",
"CAROLINA OUTSOURCING PRIVATE LIMITED",
"CAROLINA TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"CAROLINE FURNISHERS PRIVATE LIMITED",
"CAROM CONTAINERS PRIVATE LIMITED",
"CAROMI PRINTS SOLUTIONS PRIVATE LIMITED",
"CARONA INDUSTRIES PRIVATE LIMITED",
"CARONA KNIT WEAR",
"CARONA SELVIN TRAVELS PRIVATE LIMITED",
"CAROUSELL TECHNOLOGY PRIVATE LIMITED",
"CARPEDIEM ADVISORS PRIVATE LIMITED",
"CARPEDIEM INVESTMENT CONSULTANTS PRIVATE LIMITED",
"CARPEL MEDICOS PRIVATE LIMITED",
"CARPENTER & PATERSON INDIA PRIVATE LIMITED",
"CARPENTERS CLASSIC INDIA PRIVATE LIMITED",
"CARPET PALACE",
"CARPL.AI PRIVATE LIMITED",
"CARPLANET ENTERPRISES PRIVATE LIMITED",
"CARPRO SYSTEMS INDIA PRIVATE LIMITED",
"CARPSEA MANAGEMENT AND CONSULTING SERVICE PRIVATE LIMITED",
"CARQS CONSULTING PRIVATE LIMITED",
"CARRARO INDIA PRIVATE LIMITED",
"CARRARO TECHNOLOGIES INDIA PRIVATE LIMITED",
"CARRAT COMMODEAL PVT LTD",
"CARREER COACHING (ALLD.) PRIVATE LIMITED",
"CARREFOUR LOGISTICS INDIA PRIVATE LIMITED",
"CARREFOUR TRADING ASIA LIMITED",
"CARREMAN SILVERCREST CLOTHING INDIA PRIVATE LIMITED",
"CARRIER AIRCONDITIONING & REFRIGERATION LIMITED",
"CARRIER ENGINEERS PRIVATE LIMITED",
"CARRIER MIDEA INDIA PRIVATE LIMITED",
"CARRIER NET PRIVATE LIMITED",
"CARRIER TECHNOLOGIES INDIA LIMITED",
"CARRIERS INDIA PRIVATE LIMITED",
"CARRIS AGRO TECH INDIA PRIVATE LIMITED",
"CARRIS PIPES AND TUBES PRIVATE LIMITED",
"CARRLANE MANUFACTURING INDIA PRIVATE LIMITED",
"CARRON CLOTHING PRIVATE LIMITED",
"CARRON INVESTMENTS PRIVATE LIMITED",
"CARROT TECHNOLOGIES PRIVATE LIMITED",
"CARROTY WEAVING EQUIPMENT PRIVATE LIMITED",
"CARRUS TECHNOLOGY PRIVATE LIMITED",
"CARRUTHERS & PORRIDGE GARMENTS PRIVATE LIMITED",
"CARRY WELL PACKAGING PRIVATE LIMITED",
"CARRYCO PVT LTD",
"CARRYCON INDIA LIMITED",
"CARRYFAST LOGISTICS PRIVATE LIMITED",
"CARRYMORE HOISTS PRIVATE LIMITED",
"CARRYRITE PACKAGING SOLUTIONS PRIVATE LIMITED",
"CARRYSOFT RO SOLUTIONS PRIVATE LIMITED",
"CART 2 INDIA ONLINE RETAIL PRIVATE LIMITED",
"CART INFRALOG LIMITED",
"CARTAFINE WORLDWIDE PRIVATE LIMITED",
"CARTEC MOTORS PRIVATE LIMITED",
"CARTEL CLOTHING PRIVATE LIMITED",
"CARTEL CORPORATE SERVICES PRIVATE LIMITED",
"CARTEL ENGINEERS PRIVATE LIMITED",
"CARTEL HEALTH CARE PRIVATE LIMITED",
"CARTEL INFOSYSTEMS PRIVATE LIMITED",
"CARTEL INFRATECH PRIVATE LIMITED",
"CARTEL TRANSIT SERVICES PRIVATE LIMITED",
"CARTELLO BUSINESS ADVISORY SOLUTIONS PRIVATE LIMITED",
"CARTER CONTAINERS COMPANY PVT LTD",
"CARTHERO TECHNOLOGIES PRIVATE LIMITED",
"CARTHIC CREDITS PRIVATE LIMITED",
"CARTO PRINTS PRIVATE LIMITED",
"CARTON AND CONTAINERS INDIA PRIVATE LIMITED",
"CARTONBOX RETAIL PRIVATE LIMITED",
"CARTOON MANGO STUDIOS PRIVATE LIMITED",
"CARTOON SANITATION PRIVATE LIMITED",
"CARTRABBIT TECHNOLOGIES PRIVATE LIMITED",
"CARTRADE TECH LIMITED",
"CARTRADEEXCHANGE SOLUTIONS PRIVATE LIMITED",
"CARTRAIL TRADEHUB PRIVATE LIMITED",
"CARTREND AUTO PARTS PRIVATE LIMITED",
"CARTRIDGE CARE SERVICES PRIVATE LIMITED",
"CARTRIDGE JUNCTION (INDIA) PRIVATE LIMITED",
"CARTTAL TRADING PRIVATE LIMITED",
"CARTUS INDIA PRIVATE LIMITED",
"CARTWHEEL CREATIVE CONSULTANCY PRIVATE LIMITED",
"CARUS LABORATORIES PRIVATE LIMITED",
"CARVA DIGITAL INNOVATIONS PRIVATE LIMITED",
"CARVECO INDIA PRIVATE LIMITED",
"CARVEMYLIFE COACHING SERVICES PRIVATE LIMITED",
"CARVER ENGINEERING PRIVATE LIMITED",
"CARVER FARMS PRIVATE LIMITED",
"CARVER TECHNOLOGY AND EQUIPMENT PRIVATE LIMITED",
"CARVER TRAINING AND SERVICES PRIVATE LIMITED",
"CARVER WELDING PRIVATE LIMITED",
"CARVERSE MOBILITY SOLUTIONS PRIVATE LIMITED",
"CARVEWING SOLUTIONS LLP",
"CARVEZ INFRA PRIVATE LIMITED",
"CARVINGS INTERIOR CONSULTANTS PRIVATE LIMITED",
"CARY - AIR SYSTEMS PRIVATE LIMITED",
"CARYAIRE EQUIPMENTS INDIA PRIVATE LIMITED",
"CARYOTA LIFESCIENCES INDIA PRIVATE LIMITED",
"CARYSIL ONLINE LIMITED",
"CARZONRENT INDIA PRIVATE LIMITED",
"CARZSPA AUTOFRESH PRIVATE LIMITED",
"CAS ELECTRICAL & AUTOMATION PRIVATE LIMITED",
"CAS LOGISTICS & AVIATION PRIVATE LIMITED",
"CAS PRIVATE LIMITED",
"CAS TECH PRODUCTS PRIVATE LIMITED",
"CAS TRANSGLOBAL LOGISTICS PRIVATE LIMITED",
"CAS WEIGHING INDIA PRIVATE LIMITED",
"CASA BELLA WELLNESS",
"CASA DIAGNOSTICA PRIVATE LIMITED",
"CASA DINERO ENTERPRISES PRIVATE LIMITED",
"CASA FURNITURE PRIVATE LIMITED",
"CASA GEMS PRIVATE LIMITED",
"CASA GRANDE AXIOM PRIVATE LIMITED",
"CASA GRANDE CIVIL ENGINEERING PRIVATE LIMITED",
"CASA GRANDE DISTRIPARKS PRIVATE LIMITED",
"CASA GRANDE GARDEN CITY BUILDERS PRIVATE LIMITED",
"CASA GRANDE GRACE PRIVATE LIMITED",
"CASA GRANDE MILESTONE PRIVATE LIMITED",
"CASA GRANDE PROPCARE PRIVATE LIMITED",
"CASA GRANDE SMART VALUE HOMES PRIVATE LIMITED",
"CASA GRANDE ZEST PRIVATE LIMITED",
"CASA GREENS MAINTENANCE SERVICES PRIVATE LIMITED",
"CASA INFRATECH PRIVATE LIMITED",
"CASA INTERIOR STUDIO PRIVATE LIMITED",
"CASA LAVELLE ESTATE PRIVATE LIMITED",
"CASA MOMENTAA PRIVATE LIMITED",
"CASA MOTORS PRIVATE LIMITED",
"CASA PARADOX PRIVATE LIMITED",
"CASA SERAI RESORTS PRIVATE LIMITED",
"CASA TILES PRIVATE LIMITED",
"CASA2 STAYS PRIVATE LIMITED",
"CASABELLA INTERNATIONAL PRIVATE LIMITED",
"CASABLANCA APPARELS PRIVATE LIMITED",
"CASABLANCA INDUSTRIES PRIVATE LIMITED",
"CASACOPENHAGEN BRANDS PRIVATE LIMITED",
"CASACREDO ENTERPRISES PRIVATE LIMITED",
"CASADEL BUILDERS INDIA PRIVATE LIMITED",
"CASAGRAND AESTHETIC PRIVATE LIMITED",
"CASAGRAND ARUN MN ACADEMY FOUNDATION",
"CASAGRAND BUILDER PRIVATE LIMITED",
"CASAGRAND INTERNATIONAL SCHOOL",
"CASAGRAND MAGICK RUFY PRIVATE LIMITED",
"CASAGRAND PREMIER BUILDER LIMITED",
"CASAGRAND SPACEINTELL PRIVATE LIMITED",
"CASAGRAND STAYLOGY PRIVATE LIMITED",
"CASAGRAND VISTAAZ PRIVATE LIMITED",
"CASAGRANDE INDIA PILING & GEOTECHNICAL EQUIPMENT PRIVATE LIMITED",
"CASAMIA BUILDING MATERIAL TRADING PRIVATE LIMITED",
"CASAPPA HYDRAULICS INDIA PRIVATE LIMITED",
"CASAYA INN PRIVATE LIMITED",
"CASBY GLOBAL AIR PRIVATE LIMITED",
"CASBY LOGISTICS PRIVATE LIMITED",
"CASCA REMEDIES PVT LTD",
"CASCAD PACKAGING PRIVATE LIMITED",
"CASCADE COMMERCE PVT LTD",
"CASCADE GELATI PRIVATE LIMITED",
"CASCADE HELIO THERMICS LIMITED",
"CASCADE INDIA MATERIAL HANDLING PRIVATE LIMITED",
"CASCADE REVENUE MANAGEMENT PRIVATE LIMITED",
"CASCADE STAR INDIA PRIVATE LIMITED",
"CASCADE SYSTEMS AND COMMUNICATION PRIVATE LIMITED",
"CASCADES DATA SOLUTIONS DBA INFOMATICS INDIA PRIVATE LIMITED",
"CASCO ELECTRONICS PRIVATE LIMITED",
"CASE EXTRAMINDS EDUSOCIAL LIMITED",
"CASE NEW HOLLAND CONSTRUCTION EQUIPMENT (INDIA) PRIVATE LIMITED",
"CASE NEW HOLLAND CONSTRUCTION EQUIPMENT INDIA PRIVATE LIMITED",
"CASE WELL DRILLING SERVICES PRIVATE LIMITED",
"CASEPOINT PRIVATE LIMITED",
"CASFISH INTERNATIONAL PRIVATE LIMITED",
"CASH CHEMIST HEALTH CARE PRIVATE LIMITED",
"CASH EDGE INDIA PRIVATE LIMITED",
"CASH FOR GOLD PRIVATE LIMITED",
"CASH LEGISLATIVE DEPTT NEW DELHI",
"CASH UR DRIVE MARKETING LIMITED",
"CASH UR DRIVE MARKETING PRIVATE LIMITED",
"CASH X-RAY PRIVATE LIMITED",
"CASHAPONA TECHNOLOGIES PRIVATE LIMITED",
"CASHCARE TECHNOLOGY PRIVATE LIMITED",
"CASHEW BASKET PRIVATE LIMITED",
"CASHEW EXPORT PROMOTION COUNCIL OF INDIA",
"CASHLESS BAZAR PRIVATE LIMITED",
"CASHLESS TECHNOLOGIES INDIA PRIVATE LIMITED",
"CASHLINK GLOBAL SYSTEMS PRIVATE LIMITED",
"CASHPE AGRI RETAIL PRIVATE LIMITED",
"CASHPOR FINANCIAL AND TECHNICAL SERVICES PRIVATE LIMITED",
"CASHPOR MICRO CREDIT",
"CASID PHARMACEUTICALS PRIVATE LIMITED",
"CASIL HEALTH PRODUCTS",
"CASIL INDUSTRIES LIMITED",
"CASILLA LIVING PRIVATE LIMITED",
"CASILON POLYMERS PRIVATE LIMITED",
"CASINO AIR CATERERS & FLIGHT SERVICES",
"CASINO HOTELS LIMITED",
"CASIO DISTRIBUTORS PRIVATE LIMITED",
"CASIO INDIA COMPANY PRIVATE LIMITED",
"CASPER PHARMA PRIVATE LIMITED",
"CASPER ZAFER PRIVATE LIMITED",
"CASPERON TECHNOLOGIES PRIVATE LIMITED",
"CASPEX TECH LLP",
"CASPIA HOTELS PRIVATE LIMITED",
"CASPIAN CAVIAR AND FINE FOOD PRIVATE LIMITED",
"CASPIAN CORPORATE SERVICES LIMITED",
"CASPIAN FINANCIAL SERVICES LIMITED",
"CASPIAN FOODS LLP",
"CASPIAN GLOBELINK PRIVATE LIMITED",
"CASPIAN IMPACT INVESTMENT ADVISER PRIVATE LIMITED",
"CASPIAN IMPACT INVESTMENTS PRIVATE LIMITED",
"CASPIAN INDIA ENGICON PRIVATE LIMITED",
"CASPIAN LOGISTICS LLP",
"CASPIAN MANAGEMENT SERVICES LLP",
"CASPIAN SUPPLY CHAIN PRIVATE LIMITED",
"CASPO FURNITURE CONCEPTS PRIVATE LIMITED",
"CASPRO DISTRIBUTER P LIMITED",
"CASPRO METAL INDUSTRIES PVT LTD",
"CASS ASSOCIATES",
"CASSETTEWORLD INDIA PRIVATE LIMITED",
"CASSIA SIAMIA TECHNOLOGIES PRIVATE LIMITED",
"CASSIA TRADING PRIVATE LIMITED",
"CASSINI TECHNOLOGY CONSULTING PRIVATE LIMITED",
"CASSIOPAE SOLUTIONS PRIVATE LIMITED",
"CASSIXCOM ENTERPRISES OPC PRIVATE LIMITED",
"CAST ALL TECHNOLOGIES PRIVATE LIMITED",
"CAST AND BLOWER COMPANY GUJARAT PRIVAT E LIMITED",
"CAST CRAFT PRIVATE LIMITED",
"CAST SOFTWARE INDIA PRIVATE LIMITED",
"CAST TECH PRIVATE LIMITED",
"CAST4 ALUMINIUM PRIVATE LIMITED",
"CASTALIAZ TECHNOLOGIES PRIVATE LIMITED",
"CASTAMET WORKS PRIVATE LIMITED",
"CASTECH FOUNDRIES PRIVATE LIMITED",
"CASTER PROJECTS PRIVATE LIMITED",
"CASTFAB ENGINEERING INDIA PRIVATE LIMITED",
"CASTING NETWORKS INDIA PRIVATE LIMITED",
"CASTINGS INDIA PVT LTD",
"CASTLE AND COOK CATERERS LIMITED",
"CASTLE APPARELS PRIVATE LIMITED",
"CASTLE EQUIPMENTS PRIVATE LIMITED",
"CASTLE HOMES PROJECT MANAGEMENT SERVICES PRIVATE LIMITED",
"CASTLE INVESTMENT AND INDUSTRIES PRIVATE LIMITED",
"CASTLE LIQUORS PRIVATE LIMITED",
"CASTLE MEDIA PRIVATE LIMITED",
"CASTLE PARK REALTORS PRIVATE LIMITED",
"CASTLE PROJECTS PRIVATE LIMITED",
"CASTLE RESORTS LIMITED",
"CASTLE ROCK FISHERIES PRIVATE LIMITED",
"CASTLE RUBBER PRIVATE LIMITED",
"CASTLE SHIPS PRIVATE LIMITED",
"CASTLE STUDIO PRIVATE LIMITED",
"CASTLE VALVES PRIVATE LIMITED",
"CASTLEBAY INFOTECH PRIVATE LIMITED",
"CASTLEBRIDGE CONSULTING INDIA PRIVATE LIMITED",
"CASTLEGATE CAPITAL SERVICES PRIVATE LIMITED",
"CASTLEGATE INDUSTRIAL HOLDINGS PRIVATE LIMITED",
"CASTLES INFRASTRUCTURE PRIVATE LIMITED",
"CASTLES VISTA PRIVATE LIMITED",
"CASTLETON CAPITAL PRIVATE LIMITED",
"CASTLETON SPRING PRIVATE LIMITED",
"CASTLEVIEW DEALCOM PRIVATE LIMITED",
"CASTMASTER INDUSTRIES PRIVATE LIMITED",
"CASTMASTER MOBITEC INDIA PRIVATE LIMITED",
"CASTMET PACKAGINGS PRIVATE LIMITED",
"CASTOMACH GLOBAL PRIVATE LIMITED",
"CASTOMATE PRIVATE LIMITED",
"CASTOR ENGINEERING PRIVATE LIMITED",
"CASTOR INVESTMENTS LIMITED",
"CASTORGIRNAR INDUSTRIES PRIVATE LIMITED",
"CASTROCHEM PRIVATE LIMITED",
"CASTROL INDIA LIMITED",
"CASTRON TECHNOLOGIES LIMITED",
"CASTURN VALVES PRIVATE LIMITED",
"CASTUS INFO SOLUTIONS PRIVATE LIMITED",
"CASTWEL AUTO PARTS PRIVATE LIMITED",
"CASTWEL INDUSTRIES",
"CASUAL CREATIONS & FASHIONS PRIVATE LIMITED",
"CASUAL CREATIONS PRIVATE LIMITED",
"CASUAL FASHIONS PRIVATE LIMITED",
"CASUAL PUNCH GAME STUDIOS PRIVATE LIMITED",
"CASUALS TRADING PRIVATE LIMITED",
"CASVA TILES PRIVATE LIMITED",
"CASYON MULTI ELECTRONICS PRIVATE LIMITED",
"CAT COMPUMECH PRIVATE LIMITED",
"CAT LITTER INDIAN PRIVATE LIMITED",
"CATABATIC AUTOMATION TECHNOLOGY PRIVATE LIMITED",
"CATAI INDIA PRIVATE LIMITED",
"CATALER INDIA AUTO PARTS PRIVATE LIMITED",
"CATALEYA INDIA PRIVATE LIMITED",
"CATALINA SYSTEMS PRIVATE LIMITED",
"CATALIS PACKAGING TECHNOLOGIES PRIVATE LIMITED",
"CATALOG IT SOLUTIONS PRIVATE LIMITED",
"CATALOGIC SOFTWARE SOLUTIONS INDIA PRIVATE LIMITED",
"CATALYSER EDUVENTURES INDIA PRIVATE LIMITED",
"CATALYSIS ADVERTISING INDIA PRIVATE LIMITED",
"CATALYSIS EDUCATION PRIVATE LIMITED",
"CATALYST BUSINESS SOLUTIONS PRIVATE LIMITED",
"CATALYST CLINICAL SERVICES PRIVATE LIMITED",
"CATALYST CORPORATE SERVICES PRIVATE LIMITED",
"CATALYST MANAGEMENT SERVICES PRIVATE LIMITED",
"CATALYST MEDIA INTEGRATED LLP",
"CATALYST PUBLIC RELATIONS PRIVATE LIMITED",
"CATALYST ROBOTICS AND AUTOMATION PRIVATE LIMITED",
"CATALYST SERVICE SOLUTIONS PARTNERS PRIVATE LIMITED",
"CATALYST SPECIALITY CHEMICALS PRIVATE LIMITED",
"CATALYST STRATEGIC MARKETING COMMUNICATIONS PRIVATE LIMITED",
"CATALYST TRUSTEESHIP LIMITED",
"CATALYST WEB TRENDZ PRIVATE LIMITED",
"CATALYSTONE INFO SOLUTIONS PRIVATE LIMITED",
"CATALYSTS",
"CATALYSTS BIO-TECHNOLOGIES PRIVATE LIMITED",
"CATALYTIC MANAGEMENT ADVISERS PRIVATE LIMITED",
"CATALYTIC SOLUTION AND MANAGEMENT SERVICES PRIVATE LIMITED",
"CATALYZE CENTER FOR LEARNING PRIVATE LIMITED",
"CATAMARAN BREWING (INDIA) PRIVATE LIMITED",
"CATAMARAN VENTURES LLP",
"CATAPHARMA CHEMICALS PRIVATE LIMITED",
"CATAPHARMA INDIA PRIVATE. LIMITED",
"CATAPULT ENGINEERING SOLUTIONS PRIVATE LIMITED",
"CATAPULT MANAGEMENT RESOURCES PRIVATE LIMITED",
"CATAPULT REALTY PRIVATE LIMITED",
"CATARACT AND IOL HOSPITAL PRIVATE LIMITED",
"CATASYNTH SPECIALITY CHEMICALS PRIVATE LIMITED",
"CATCH MEDIA",
"CATCH OF NORWAY SEAFOOD PRIVATE LIMITED",
"CATCH REALTY PRIVATE LIMITED",
"CATCH TWENTY TWO CLOTHING PRIVATE LIMITED",
"CATCHPOINT SYSTEMS PRIVATE LIMITED",
"CATEGIS SOFTWARE PRIVATE LIMITED",
"CATEINA TECHNOLOGIES PRIVATE LIMITED",
"CATENON INDIA PRIVATE LIMITED",
"CATER PURE ESSENTIALS PRIVATE LIMITED",
"CATERMAN CUISINE CONCEPTS PRIVATE LIMITED",
"CATERPILLAR CARGO SOLUTIONS INDIA PRIVATE LIMITED",
"CATERPILLAR ELECTRIC PRIVATE LIMITED",
"CATERPILLAR FINANCIAL SERVICES INDIA PRIVATE LIMITED",
"CATERPILLAR INDIA ENGINEERING SOLUTIONS PRIVATE LIMITED",
"CATERPILLAR INDIA PRIVATE LIMITED",
"CATERPILLAR SIGNS PRIVATE LIMITED",
"CATEX OVERSEAS IMPORT EXPORT PRIVATE LIMITED",
"CATEYE CONSULTANCY SERVICES PRIVATE LIMITED",
"CATHAY PACIFIC AIRWAYS LIMITED",
"CATHECT TECHNOLOGIES PRIVATE LIMITED",
"CATHEDRAL AND JOHN CONNON SCHOOL",
"CATHEDRAL COLLEGE",
"CATHEDRAL HIGH SCHOOL",
"CATHELCO SYSTEMS INDIA PRIVATE LIMITED",
"CATHELRON COLLEGE",
"CATHERINE BARBIER BUYING HOUSE PRIVATE LIMITED",
"CATHODIC CONTROL COMPANY PRIVATE LIMITED",
"CATHOLIC BISHOPS CONFERENCE OF INDIA",
"CATHOLIC GYMKHANA LIMITED",
"CATNIP INFOTECH PRIVATE LIMITED",
"CATPRO SOFTWARES PRIVATE LIMITED",
"CATS EYE SYSTEMS & SOLUTIONS PRIVATE LIMITED",
"CAT'S WHISKERS PVT. LTD.",
"CATSEYE SYSTEMS AND SOLUTIONS PRIVATE LIMITED",
"CATSKILL INFRA PROJECTS PRIVATE LIMITED",
"CATTLE-VALLEY PRIVATE LIMITED",
"CATTLEWAYS SOLUTIONS PRIVATE LIMITED",
"CATTLEYA TECHNOSYS PRIVATE LIMITED",
"CATTS LABS AND RESEARCH PRIVATE LIMITED",
"CATURA TECH AUTOMATION PRIVATE LIMITED",
"CATVISION LIMITED",
"CATVISION UNITRON PRIVATE LIMITED",
"CATWALK WORLDWIDE PRIVATE LIMITED",
"CAUCHY HARDY AS TECHNOLOGIES PRIVATE LIMITED",
"CAUDAL PENS PRIVATE LIMITED",
"CAULDRON PETROTECH INDIA PRIVATE LIMITED",
"CAURO DIAGNOSTICS PRIVATE LIMITED",
"CAUSEWAY SOFTWARE TECHNOLOGIES INDIA P LIMITED",
"CAUSSA TEC SOLUTIONS PRIVATE LIMITED",
"CAUTONI SWASTIK INSTRUMENTS (INDIA) PRIVATE LIMITED",
"CAUVERI COCO PEAT PRIVATE LIMITED",
"CAUVERY BUILDTECH PRIVATE LIMITED",
"CAUVERY CARBONIC PRIVATE LIMITED",
"CAUVERY COLLEGE FOR WOMEN",
"CAUVERY CONDUCTORS PVT LTD",
"CAUVERY ELECTRICALS PRIVATE LIMITED",
"CAUVERY ENGINEERING ENTERPRISE PRIVATE LIMITED",
"CAUVERY EXTTRUSIONS PRIVATE LIMITED",
"CAUVERY GEARS PRIVATE LIMITED",
"CAUVERY HEART & MULTI-SPECIALITY HOSPITAL",
"CAUVERY INTERNATIONAL SCHOOL",
"CAUVERY IRON AND STEEL (INDIA) LIMITED",
"CAUVERY LAMINATES PRIVATE LIMITED",
"CAUVERY MEDICAL CENTER PRIVATE LIMITED",
"CAUVERY MOTORS PRIVATE LIMITED",
"CAUVERY NEERAVARI NIGAMA LIMITED",
"CAUVERY PETROCHEMICALS PRIVATE LIMITED",
"CAUVERY POWER TRADING CHENNAI PRIVATE LIMITED",
"CAUVERY STEELS PRIVATE LTD",
"CAUVERY STONES IMPEX PRIVATE LIMITED",
"CAUVERY THEATRE COMPLEX PRIVATE LIMITED",
"CAUVERY TIMBER COMPANY PRIVATE LIMITED",
"CAV VENTURES PRIVATE LIMITED",
"CAVALA HOTELS PRIVATE LIMITED",
"CAVALCADE PROPERTIES PRIVATE LIMITED",
"CAVALIER COACHING AND SECURITY NETWORK PRIVATE LIMITED",
"CAVALIER HOSPITALS PRIVATE LIMITED",
"CAVALIER LOGISTICS PRIVATE LIMITED",
"CAVALIER TOOL DESIGN & ENGINEERING SERVICES PRIVATE LIMITED",
"CAVALIER WIRELESS PRIVATE LIMITED",
"CAVALIERINDIA TRAINING AND CONSULTING PRIVATE LIMITED",
"CAVALRY INFO PRIVATE LIMITED",
"CAVANA CLOTHING PRIVATE LIMITED",
"CAVE CATERERS PRIVATE LIMITED",
"CAVEMAN WOOD PRODUCTS PRIVATE LIMITED",
"CAVENDISH INDUSTRIES LIMITED",
"CAVENTIS PHARMA PRIVATE LIMITED",
"CAVEO INFOSYSTEMS INDIA PRIVATE LIMITED",
"CAVIER BATHFITTINGS LIMITED.",
"CAVIN INTERNATIONAL PRIVATE LIMITED",
"CAVIN PHARMACEUTICALS PRIVATE LIMITED",
"CAVINKARE PRIVATE LIMITED",
"CAVINTEK SOFTWARE PRIVATE LIMITED",
"CAVISTA TECHNOLOGY PRIVATE LIMITED",
"CAVITAK MARKETING PRIVATE LIMITED",
"CAVIUM NETWORKS INDIA PRIVATE LIMITED",
"CAVOTEC ENGINEERING SERVICES INDIA PRIVATE LIMITED",
"CAVOTEC INDIA PRIVATE LIMITED",
"CAWASJI BEHRAMJI CATERING SERVICES LIMITED",
"CAWASJI BEHRAMJI CATERING SERVICES PRIVATE LIMITED",
"CAWIN ELECTRIC INDIA PRIVATE LIMITED",
"CAWNPOOR CLOTH AND MANUFACTURING PRIVATE LIMITED",
"CAWNPORES AA TRAVEL WINGS PRIVATE LIMITED",
"CAX SOFTWARE PRIVATE LIMITED",
"CAXITA TECH SOLUTIONS PRIVATE LIMITED",
"CAXPORT PRIVATE LIMITED",
"CAXTON OFFSET PRIVATE LIMITED",
"CAYA CONSTRUCTION INDIA PRIVATE LIMITED",
"CAZAAYAN TECHNOLOGIES PRIVATE LIMITED",
"CAZAN CATSOL PRIVATE LIMITED",
"CAZZANO APPARELS PRIVATE LIMITED",
"CB AGROS AND SHOPPING MALLS PRIVATE LIMITED",
"CB COLD STORAGE PRIVATE LIMITED",
"CB DOCTOR VENTILATORS PRIVATE LIMITED.",
"CB FOODS PROCESSING PRIVATE LIMITED",
"CB GROWTH PRIVATE LIMITED",
"CB IMPEX PRIVATE LIMITED",
"CB INDUSTRIES PRIVATE LIMITED",
"CB&I INDIA PRIVATE LIMITED",
"CBA SERVICES PRIVATE LIMITED",
"CBAS PRIVATE LIMITED",
"CBASE INFOTECH (INDIA) PRIVATE LIMITED",
"CBC CORPORATION INDIA PRIVATE LIMITED",
"CBC FASHIONS ASIA PRIVATE. LIMITED.",
"CBC SOLAR TECHNOLOGIES PRIVATE LIMITED",
"CBCB INFRA PRIVATE LIMITED",
"CBCC GLOBAL RESEARCH LLP",
"CBCL TECHNOLOGIES AND SERVICES PRIVATE LIMITED",
"CBD IT SOLUTIONS PRIVATE LIMITED",
"CBE DYNAMIC MULTIMETAL PRIVATE LIMITED",
"CBF COMPONENTS PRIVATE. LIMITED",
"C-BIA SOLUTIONS & SERVICES LLP",
"CBIC PONNERI INDUSTRIAL TOWNSHIP LIMITED",
"CBIC TUMAKURU INDUSTRIAL TOWNSHIP LIMITED",
"CBIK INDIA PRIVATE LIMITED",
"CBIT IT SOLUTIONS PRIVATE LIMITED",
"CBK ESTATE DEVELOPERS LIMITED",
"CBL DATA SCIENCE PRIVATE LIMITED",
"CBLPRO ESOLUTIONS PRIVATE LIMITED",
"CBM COLLEGE - 641042",
"CBM RETAILS PRIVATE LIMITED",
"CBMEW (INDIA) PRIVATE LIMITED",
"CBN MULTIMEDIA PRIVATE LIMITED",
"CBNITS INDIA PRIVATE LIMITED",
"CBO INFOTECH PRIVATE LIMITED",
"CBRE SOUTH ASIA PRIVATE LIMITED",
"CBREX TECHNOLOGIES PRIVATE LIMITED",
"CBS CORPORATION",
"CBS EDUCATION PRIVATE LIMITED",
"CBS FACILITIES MANAGEMENT PRIVATE LIMITED",
"CBS INTERNATIONAL PROJECTS PRIVATE LIMITED",
"CBS TECHNOLOGIES PRIVATE LIMITED",
"CBSI INDIA PRIVATE LIMITED",
"CBT INFOTECH PRIVATE LIMITED",
"CBTS TECHNOLOGY SOLUTIONS INDIA LLP",
"CBTW INDIA PRIVATE LIMITED",
"CC COMMODITY INFO SERVICES LLP",
"CC LAMINATES PRIVATE LIMITED",
"CCBA DESIGNS PRIVATE LIMITED",
"CCC CARGO & CONTAINER CARRIERS PRIVATE LIMITED",
"CCC DIGITAL INDIA PRIVATE LIMITED",
"CCCL INFRASTRUCTURE LIMITED",
"CCD TECHNICAL SOLUTIONS PRIVATE LIMITED",
"CCE SOFTWARE PRIVATE LIMITED",
"CCEC ASIA ENTERPRISE COMMUNICATIONS PRIVATE LIMITED",
"CCENTRIK INFOTECH PRIVATE LIMITED",
"CCI LOGISTICS LIMTIED",
"CCI PROJECTS PRIVATE LIMITED",
"CCI WORLDWIDE LOGISTICS PRIVATE LIMITED",
"CCIC INDIA PRIVATE LIMITED",
"CCIGMAA LIFESTYLES PRIVATE LIMITED",
"CCIT INDORE",
"CCK INFRA SOLUTIONS PRIVATE LIMITED",
"CCL INTERNATIONAL LIMITED",
"CCL PRODUCTS INDIA LIMITED",
"CCLYTICX SERVICES PRIVATE LIMITED",
"CCM FACILITY MANAGEMENT PRIVATE LIMITED",
"CCM METAL TECH PRIVATE LIMITED",
"CCMK VILLAGE HOSPITAL",
"CCN DIGITAL PRIVATE LIMITED",
"CCP IOT TECHNOLOGIES PRIVATE LIMITED",
"CCPL DEVELOPERS PRIVATE LIMITED",
"CCR LOGISTICS PRIVATE LIMITED",
"CCR TECHNOLOGIES PRIVATE LIMITED",
"CCRT LABORATORIES PRIVATE LIMITED",
"CCS COMPUTERS PRIVATE LIMITED",
"CCS IT PRIVATE LIMITED",
"CCS OSTEM PROJECTS PRIVATE LIMITED",
"CCS SPACEMAKER SI PRIVATE LIMITED",
"CCS SUPPORT INDIA PRIVATE LIMITED",
"CCS TECHNOLOGIES PRIVATE LIMITED",
"CCT DIGISOL PRIVATE LIMITED",
"CCT SOLUTIONS PRIVATE LIMITED",
"CC-TAPIS PRIVATE LIMITED",
"CCTEB INDIA PRIVATE LIMITED",
"CCTY BEARING INDIA PRIVATE LIMITED",
"CCUBE FINTECH GLOBAL SERVICES PRIVATE LIMITED",
"C'CURE BUILDING PRODUCTS PRIVATE LIMITED",
"CD ADAPCO INDIA PRIVATE LIMITED",
"CD BYTE INFO PRIVATE LIMITED",
"CD CLOUDENABLERS PRIVATE LIMITED",
"CD COMMO SEARCH PRIVATE LIMITED",
"CD EQFINANCE PRIVATE LIMITED",
"CD EQUISEARCH PRIVATE LIMITED",
"CD INFOTECH PRIVATE LIMITED",
"CDA JABALPUR",
"CDA PATNA",
"CDA PD MEERUT",
"CDA TECHNOLOGIES INDIA PRIVATE LIMITED",
"CDATA SOFTWARE INDIA PRIVATE LIMITED",
"CDB ESTATES PRIVATE LIMITED",
"CDC DENTAL NETWORKS PRIVATE LIMITED",
"CDC DEVELOPMENT INDIA PRIVATE LIMITED",
"CDC INDUSTRIAL INFRAS LIMITED",
"CDC PRINTERS PRIVATE LIMITED",
"CDE ASIA LIMITED",
"CDEP RESEARCH PRIVATE LIMITED",
"C-DESIGN PRIVATE LIMITED",
"CDET EXPLOSIVE INDUSTRIES PRIVATE LIMITED",
"CDF INFRA CON PRIVATE LIMITED",
"CDG BROADCAST PRIVATE LIMITED",
"CDG PETCHEM LIMITED",
"CDH FOREX PRIVATE LIMITED",
"CDI BLUEPAY PRIVATE LIMITED",
"CDI FOOTWEAR PRIVATE LIMITED",
"CDI SECURITY INDIA PRIVATE LIMITED",
"CDK GLOBAL INDIA PRIVATE LIMITED",
"CDL IT PRIVATE LIMITED",
"CDM PIN POINT SOLUTIONS PRIVATE LIMITED",
"CDM SMITH GLOBAL SERVICES INDIA LLP",
"CDM SMITH INDIA PRIVATE LIMITED",
"CDM TECHNOLOGIES & SOLUTIONS PRIVATE LIMITED",
"CDMO (NORTH DISTT) DGHS",
"CDN ENGINEERING PRIVATE LIMITED",
"CDN FINANCE PRIVATE LIMITED",
"CDN SOFTWARE SOLUTIONS PRIVATE LIMITED",
"CDN SOLUTIONS GROUP",
"CDNA TECHNOLOGIES PRIVATE LIMITED",
"CDNS TECHNOLOGY (INDIA) PRIVATE LIMITED",
"C-DOT ALCATEL-LUCENT RESEARCH CENTRE PRIVATE LIMITED",
"CDP INDIA PRIVATE LIMITED",
"CDP OPERATIONS INDIA PRIVATE LIMITED",
"CDPQ INDIA PRIVATE LIMITED",
"CDR HOSPITAL",
"CDS GARMENTS PRIVATE LIMITED",
"CDS INFRA PROJECTS LIMITED",
"CDS MONEY EXCHANGE BUREAU PRIVATE LIMITED",
"CDS OVERSEAS LOGISTICS PRIVATE LIMITED",
"CDS SOLES PRIVATE LIMITED",
"CDSL COMMODITY REPOSITORY LIMITED",
"CDSL INSURANCE REPOSITORY LIMITED",
"CDSL VENTURES LIMITED",
"CDW CORPORATION",
"CDW TECHNOLOGIES INDIA PRIVATE LIMITED",
"CDYMAX (INDIA) PHARMA PRIVATE LIMITED",
"CE COMFORT ENGINEERS PRIVATE LIMITED",
"CE SERVICED OFFICES PRIVATE LIMITED",
"CEA INDIA INC",
"CEAR INDIA FINANCE PRIVATE LIMITED",
"CEARS DIES AND MOULDS PRIVATE LIMITED",
"CEASEFIRE EXTINGUISHERS AND SYSTEMS INDIA PRIVATE LIMITED",
"CEASEFIRE INDUSTRIES",
"CEASEFIRE INDUSTRIES PRIVATE LIMITED",
"CEASELEZ CONSULTING LLP",
"CEASER ENTERPRISES PRIVATE LIMITED",
"CEAT LIMITED",
"CEAT SPECIALTY TYRES LIMITED",
"CEB INDIA PRIVATE LIMITED",
"CEBON APPAREL PRIVATE LIMITED",
"CEBON CERAMIC PRIVATE LIMITED",
"CEC ITD CEM TPL JOINT VENTURE",
"CEC MOTORS PRIVATE LIMITED",
"CE-CHEM PHARMACEUTICALS PRIVATE LIMITED",
"CECIL WEBBER ENGINEERING LIMITED",
"CECO EMTROL BUELL INDIA PRIVATE LIMITED",
"CECON CONSULTANTS PRIVATE LIMITED",
"CECON POLLUTECH SYSTEMS PRIVATE LIMITED",
"CECUBE ENGINEERING INDIA PRIVATE LIMITED",
"CEDAAR TEXTILE PRIVATE LIMITED",
"CEDAR COMMOTRADE PRIVATE LIMITED",
"CEDAR DECOR PRIVATE LIMITED",
"CEDAR ENGINEERS AND SYSTEM PRIVATE LIMITED",
"CEDAR MANAGEMENT CONSULTING PRIVATE LIMITED",
"CEDAR RETAIL PRIVATE LIMITED",
"CEDAR SUPPORT SERVICES PRIVATE LIMITED",
"CEDAR TIE UP PRIVATE LIMITED",
"CEDCOSS TECHNOLOGIES PRIVATE LIMITED",
"CEDEC ENGINEERING PRIVATE LIMITED",
"CEDGE INDIA SOFTWARE CONSULTANTS LLP",
"CEDGE VENTURES PRIVATE LIMITED",
"CEDONA TECHNOLOGIES PRIVATE LIMITED",
"CEDRATEC INDIA PRIVATE LIMITED",
"CEDRETO MARKETING PRIVATE LIMITED",
"CEDRIC PHARMACEUTICALS PRIVATE LIMITED",
"CEDRUS CONSULTANTS PRIVATE LIMITED",
"CEDRUS SILICONE PRIVATE LIMITED",
"CEE AAR DAIRY PRODUCTS PRIVATE LIMITED",
"CEE BEE CEE TRAVELS AND TOURS PRIVATE LIMITED",
"CEE DEE DIAGNOSTICS PRIVATE LIMITED",
"CEE DEE VACUUM EQUIPMENT PRIVATE LIMITED",
"CEE ENGINEERING PRIVATE LIMITED",
"CEE ENN PROMOTERS AND DEVELOPERS PRIVATE LIMITED",
"CEE KAY MERCANTILE PRIVATE LIMITED",
"CEE PEE LUMBERS PRIVATE LIMITED",
"CEE RISTEE GLOBAL PRIVATE LIMITED",
"CEE TRAK IT SOLUTIONS PRIVATE LIMITED",
"CEE VEE DIAGNOSTICS PRIVATE LIMITED",
"CEEAR REALTY & INFRASTRUCTURE PRIVATE LIMITED",
"CEEBEN TRAVELS AND TOURS PRIVATE LIMITED",
"CEEBROS HOTELS PRIVATE LIMITED",
"CEEBROS PROPERTY DEVELOPMENT PRIVATE LIMITED",
"CEECO TECHNOLOGIES PRIVATE LIMITED",
"CEECON READY MIX CONCRETE PRIVATE LIMITED",
"CEEDEE METALLOYS PRIVATE LIMITED",
"CEEDEEYES HOUSING AND INFRASTRUCTURE PRIVATE LIMITED",
"CEEDEEYES INFRASTRUCTURE DEVELOPMENTPRIVATE LIMITED",
"CEEDEEYES IT PARKS PRIVATE LIMITED",
"CEEDEEYES SOFTWARE TECHNOLOGY PARK PRIVATE LIMITED",
"CEEGO LABS PRIVATE LIMITED",
"CEEJAY FINANCE LIMITED",
"CEEJAY MICROFIN LIMITED",
"CEEJAY REALTY PRIVATE LIMITED",
"CEEJAY TOBACCO LIMITED",
"CEEKAY ASSOCIATES PRIVATE LIMITED",
"CEEKAY EPC PROJECTS PRIVATE LIMITED",
"CEEKAY LOGISTICS PRIVATE LIMITED",
"CEEKEPEE ENGINEERING WORKS PRIVATE LIMITED",
"CEEMULTI INDIA PRIVATE LIMITED",
"CEENIK EXPORTS (INDIA) LIMITED",
"CEEQUENCE TECHNOLOGIES PRIVATE LIMITED",
"CEETEETEX SILK MILLS PRIVATE LIMITED",
"CEEVEES IMAGING AND HEALTHCARE RESEARCH PRIVATE LIMITED",
"CEEYAM HOSPITAL PRIVATE LIMITED",
"CEEZET ELECTRONICS PRIVATE LIMITED",
"CEF BUDHANA ENERGY PRIVATE LIMITED",
"CEF INFRA AND PROJECTS PRIVATE LIMITED",
"CEFA-CILINAS BIOTICS PRIVATE LIMITED",
"CEFIRO INDIA PRIVATE LIMITED",
"CEFTA INDUSTRIES PRIVATE LIMITED",
"CEG TECHNOCONSULT PRIVATE LIMITED",
"CEG TEST HOUSE AND RESEARCH CENTRE PRIVATE LIMITED",
"CEGIS FOUNDATION",
"CEGURA TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"CEHGROUP",
"CEI INDIA PRIVATE LIMITED",
"CEI PRINT- PACK PRIVATE LIMITED",
"CEI PRINT SOLUTIONS PRIVATE LIMITED",
"CEID CONSULTANTS AND ENGINEERING PRIVATE LIMITED",
"CEIDO TOOLING PRIVATE LIMITED",
"CEIFLO TECHNOLOGIES PRIVATE LIMITED",
"CEIGALL INDIA LIMITED",
"CEIGALL INFRA PROJECTS PRIVATE LIMITED",
"CEILING HUB PRIVATE LIMITED",
"CEILING IMPEX PRIVATE LIMITED",
"CEILTEC PROJECTS PRIVATE LIMITED",
"CEINO TECHNOLOGIES PRIVATE LIMITED",
"CEINSYS TECH LIMITED",
"CEIPAL SOFTWARE PRIVATE LIMITED",
"CEIPAL SOLUTIONS PRIVATE LIMITED",
"CEJN PRODUCTS INDIA PRIVATE LIMITED",
"CEL LOGISTICS PRIVATE LIMITED",
"CEL MARKETING PVT LTD",
"CEL PACKAGING PRIVATE LIMITED",
"CEL TRADING AND AGENCIES PRIVATE LIMITED",
"CEL VENTURES PRIVATE LIMITED",
"CELAENO TRADING PRIVATE LIMITED",
"CELANESE CHEMICALS INDIA PRIVATE LIMITED",
"CELARA DIAGNOSTICS PRIVATE LIMITED",
"CELCIUS COOLING PRIVATE LIMITED",
"CELCIUS LOGISTICS SOLUTIONS PRIVATE LIMITED",
"CELCIUS TECHNOLGIES PRIVATE. LIMITED",
"CELCOM SOLUTIONS GLOBAL PRIVATE LIMITED",
"CELEB HOMES PRIVATE LIMITED",
"CELEBAL TECHNOLOGIES PRIVATE LIMITED",
"CELEBI AIRPORT SERVICES INDIA PRIVATE LIMITED",
"CELEBI DELHI CARGO TERMINAL MANAGEMENT INDIA PRIVATE LIMITED",
"CELEBI NAS AIRPORT SERVICES INDIA PRIVATE LIMITED",
"CELEBRATE MOTORS PRIVATE LIMITED",
"CELEBRATINGLIFE INFOTECH PRIVATE LIMITED",
"CELEBRATION CITY PROJECTS PRIVATE LIMITED",
"CELEBRATION CLOTHING PRIVATE LIMITED",
"CELEBRATION COLLECTIONS PRIVATE LIMITED",
"CELEBRATION DIAMONDS PRIVATE LIMITED",
"CELEBRATION RESORTS AND HOTELS INDIA PRIVATE LIMITED",
"CELEBRATION TIMES PRIVATE LIMITED",
"CELEBRATIONS APPAREL LIMITED",
"CELEBRATIONS EVENTS PRIVATE LIMITED",
"CELEBRITIES MANAGMENT PRIVATE LIMITED",
"CELEBRITY BIOPHARMA LIMITED",
"CELEBRITY BREWERIES PRIVATE LIMITED",
"CELEBRITY BUILDERS PRIVATE LIMITED",
"CELEBRITY DWELLINGS PRIVATE LIMITED",
"CELEBRITY ESTATES PRIVATE LIMITED",
"CELEBRITY FASHIONS LIMITED",
"CELEBRITY HOUSING INFRA PROJECTS PRIVATE LIMITED",
"CELEBRITY KONNECTIONS TECH PRIVATE LIMITED",
"CELEBRITY STRUCTURES INDIA PRIVATE LIMITED",
"CELEBRUS COMMODITIES LIMITED",
"CELEC ENTERPRISES",
"CELECTRIC AUTOMOTIVE DRIVES PRIVATE LIMITED",
"CELEGENCE SYSTEMS PRIVATE LIMITED",
"CELEKT GADGETS LLP",
"CELER SOFT SERVICES PRIVATE LIMITED",
"CELERA PHARMA PRIVATE LIMITED",
"CELERAISE ENGINEERING INDIA PRIVATE LIMITED",
"CELERITY CONSULTING PRIVATE LIMITED",
"CELERITY NETWORKS PRIVATE LIMITED",
"CELERIX INFOTECH PRIVATE LIMITED",
"CELERY PHARMA PRIVATE LIMITED",
"CELEST PHARMA LABS PRIVATE LIMITED",
"CELESTE ONLINE SOLUTIONS PRIVATE LIMITED",
"CELESTIAL CONTRACTOR & ENGINEER PRIVATE LIMITED",
"CELESTIAL DIGITAL SOLUTION P LIMITED",
"CELESTIAL DIGITAL SOLUTIONS PRIVATE LIMITED",
"CELESTIAL INDUSTRIES PRIVATE LIMITED",
"CELESTIAL INFRASOLUTIONS PRIVATE LIMITED",
"CELESTIAL KNITS & FABS PRIVATE LIMITED",
"CELESTIAL MERIDIAN SHIPPING PRIVATE LIMITED",
"CELESTIAL PRODUCTS INDIA PRIVATE LIMITED",
"CELESTIAL SOLAR SOLUTIONS PRIVATE LIMITED",
"CELESTIAL SYSTEMS",
"CELESTICA INDIA PRIVATE LIMITED",
"CELESTIEL SOUVENIRS PRIVATE LIMITED",
"CELESTIUM FINANCIAL LIMITED",
"CELESTO FILAMENTS PRIVATE LIMITED",
"CELETRONIX INDIA PRIVATE LIMITED",
"CELETTE INDIA PRIVATE LIMITED",
"CELEX TECHNOLOGIES PRIVATE LIMITED",
"CELGENE CORPORATION",
"CELICA AUTOMOBILES PRIVATE LIMITED",
"CELICA DEVELOPERS PRIVATE LIMITED",
"CELICA MOTOCORP PRIVATE LIMITED",
"CELICA MOTORBIKES PRIVATE LIMITED",
"CELIGO INDIA PRIVATE LIMITED",
"CELINA PROJECTS PRIVATE LIMITED",
"CELINE HEALTH CARE PRIVATE LIMITED",
"CELIO FUTURE FASHIONS PRIVATE LIMITED",
"CELITE TYRE PRIVATE LIMITED",
"CELL 24X7 MEDIA TECHNOLOGIES PRIVATE LIMITED",
"CELL COM TELESERVICES PRIVATE LIMITED",
"CELL DSGN PRIVATE LIMITED",
"CELL LIFE THERAPEUTICS PRIVATE LIMITED",
"CELL N SOFT TELECOM PRIVATE LIMITED",
"CELL POINT (INDIA) LIMITED",
"CELL SITE ENGINEERING WORKS PRIVATE LIMITED",
"CELL WELL EXIM PRIVATE LIMITED",
"CELLA SPACE LIMITED",
"CELLA WAREHOUSING PRIVATE LIMITED",
"CELLAR DOOR PRODUCTIONS PRIVATE LIMITED",
"CELLAR WINES PRIVATE LIMITED",
"CELLARSTONE INDIA PRIVATE LIMITED",
"CELLASIA INFOCOMM PRIVATE LIMITED",
"CELLBAY MOBILES AND ELECTRONICS PRIVATE LIMITED",
"CELLBEANS HEALTHCARE INFORMATICS PRIVATE LIMITED",
"CELLBIOS HEALTHCARE & LIFESCIENCES PRIVATE LIMITED",
"CELLBLESS HEALTHCARE PRIVATE LIMITED",
"CELLCAP INVOFIN INDIA PRIVATE LIMITED",
"CELLCARE PATHOLOGY LAB PRIVATE LIMITED",
"CELLCO LUBE INDIA PRIVATE LIMITED",
"CELLCOM COMMUNICATIONS PRIVATE LIMITED",
"CELLCOMM SOLUTIONS LIMITED",
"CELLCRONIC TECHNOLOGIES PRIVATE LIMITED",
"CELLCURE CANCER CENTRE PRIVATE LIMITED",
"CELLDE INNOVATION LABS PRIVATE LIMITED",
"CELLECOR GADGETS LIMITED",
"CELLEDGE TECHNOLOGIES PRIVATE LIMITED",
"CELLEVER TRADING PRIVATE LIMITED",
"CELLIBER TECHNOLOGIES PRIVATE LIMITED",
"CELLMARK INDIA PRIVATE LIMITED",
"CELLNFRA TECH SOLUTIONS PRIVATE LIMITED",
"CELLO CAPITAL PRIVATE LIMTIED",
"CELLO HOUSEHOLD APPLIANCE PRIVATE LIMITED",
"CELLO HOUSEHOLD PRODUCTS PRIVATE LIMITED",
"CELLO INDUSTRIES PRIVATE LIMITED",
"CELLO MARKETING",
"CELLO PLAST",
"CELLO WORLD LIMITED",
"CELLO WORLD PRIVATE LIMITED",
"CELLO WRITING AIDS PRIVATE LIMITED",
"CELLOTAPE INDUSTRIES PRIVATE LIMITED",
"CELLPAGE VENTURES PRIVATE LIMITED",
"CELLPLAN TECHNOLOGIES PRIVATE LIMITED",
"CELLPOINT MOBILE INDIA LLP",
"CELLPROP PRIVATE LIMITED",
"CELLTICK MOBILE MEDIA INDIA PRIVATE LIMITED",
"CELLTRADE PRIVATE LIMITED",
"CELLTRICKS BIOTECH PRIVATE LIMITED",
"CELLUCOM RETAIL INDIA PRIVATE LIMITED",
"CELLULERA INFOTECH PRIVATE LIMITED",
"CELLULOSE SOLUTIONSS PRIVATE LIMITED",
"CELLWORKS RESEARCH INDIA PRIVATE LIMITED",
"CELMECH ENTERPRISE PRIVATE LIMITED",
"CELOFE PRIVATE LIMITED",
"CELOGEN PHARMA PRIVATE LIMITED",
"CELON LABORATORIES PRIVATE LIMITED",
"CELONA NETWORKS PRIVATE LIMITED",
"CELOX SHIPPING PRIVATE LIMITED",
"CELOXIS TECHNOLOGIES PRIVATE LIMITED",
"CELRICH PRODUCTS PRIVATE LIMITED",
"CELSIA HOTELS PRIVATE LIMITED",
"CELSIUS HEALTHCARE PRIVATE LIMITED",
"CELSTRA INFOCOM PRIVATE LIMITED",
"CELSTREAM SYSTEMS PRIVATE LIMITED",
"CELSTREAM TECHNOLOGIES PRIVATE LIMITED",
"CELSUN ECOENERGY AND INFRATECH HOLDINGS PRIVATE LIMITED",
"CELTECH TELE SERVICES INDIA PRIVATE LIMITED",
"CELTEK BATTERIES PRIVATE LIMITED",
"CELTIC RESEARCH & TECHNOLOGIES PRIVATE LIMITED",
"CELTIC SYSTEMS PRIVATE LIMITED",
"CELTIS COMMODITIES LIMITED",
"CELTYCS OUTSOURCING SERVICES PRIVATE LIMITED",
"CELUSION TECHNOLOGIES PRIVATE LIMITED",
"CELWARE LOGISTICS PRIVATE LIMITED",
"CEM BUSINESS SOLUTIONS PRIVATE LIMITED",
"CEM ELECTROMECH PRIVATE LIMITED",
"CEM SOLUTIONS PRIVATE LIMITED",
"CEMA AUTOMATIONS INDIA PRIVATE LIMITED",
"CEMA ELECTRIC LIGHTING PRODUCTS INDIA PRIVATE LIMITED",
"CEMAC CONSTRUCTION PRIVATE LIMITED",
"CEMAX PLANTS PVT LTD",
"CEMBOND CONSTRUCTIONS PRIVATE LIMITED",
"CEMBOOST INDIA PRIVATE LIMITED",
"CEMCON CASTING PRIVATE LIMITED",
"CEMCON ENGINEERING COMPANY PRIVATE LIMITED",
"CEMCON INFRASTRUCTURE PRIVATE LIMITED",
"CEMENT CORPORATION OF INDIA LIMITED",
"CEMENT DIGITAL PRIVATE LIMITED",
"CEMENT HOUSE PRIVATE LIMITED",
"CEMENT MANUFACTURING COMPANY LIMITED",
"CEMENTATION INDIA PRIVATE LIMITED",
"CEMETRIX IT SERVICES PRIVATE LIMITED",
"CEMEX CONCRETE INDIA PRIVATE LIMITED",
"CEMEX READYMIX PRIVATE LIMITED",
"CEMFIL ENTERPRISES LIMITED",
"CEMFIS INDIA PRIVATE LIMITED",
"CEMSEAL INDUSTRIES LIMITED",
"CEMTAC CEMENTS PRIVATE LIMITED",
"CEMTEX COATINGS PRIVATE LIMITED",
"CEMTICS SOLUTIONS PRIVATE LIMITED",
"VICON SECURITY TECH PRIVATE LIMITED",
"CEN TECHNOLOGIES PRIVATE LIMITED",
"CENDROP MULTILUB SYSTEM PRIVATE LIMITED",
"CENDUIT INDIA SERVICES PRIVATE LIMITED",
"CENDYN INDIA PRIVATE LIMITED",
"CENERG GLOBAL TOOLS PRIVATE LIMITED",
"CENERGY OFFSHORE PRIVATE LIMITED",
"CENEX TECHNOLOGIES PRIVATE LIMITED",
"CENEXT INVESTMENT AND SERVICES PRIVATE LIMITED",
"CENGAGE LEARNING INDIA PRIVATE LIMITED",
"CENGRS GEOTECHNICA PRIVATE LIMITED",
"CENLUB INDUSTRIES LIMITED",
"CENMAR MARITIME AGENCIES INDIA PRIVATE LIMITED",
"CENMARK AGRONOMICS PRIVATE LIMITED",
"CENNET BIOPHARMA PRIVATE LIMITED",
"CENNET MEDIA PRIVATE LIMITED",
"CENNON FACILITY SERVICES PRIVATE LIMITED",
"CENOSPHERE INDIA PRIVATE LIMITED",
"CENOTECH INDIA PRIVATE LIMITED",
"CENOZOIC REMEDIES PRIVATE LIMITED",
"CENSEO TOURS PRIVATE LIMITED",
"CENSHARE INDIA PRIVATE LIMITED",
"CENT BANK HOME FINANCE LIMITED",
"CENT FOR BUDGET&GOVERN ACOUNTBLTY",
"CENT PERCENT FOOD PRODUCTS PRIVATE LIMITED",
"CENTAUR COMPUTER TECHNOLOGY PRIVATE LIMITED",
"CENTAUR FSA PRIVATE LIMITED",
"CENTAUR PHARMACEUTICALS PRIVATE LIMITED",
"CENTAUR TECHPLAST PRIVATE LIMITED",
"CENTAURI POLYFILM PRIVATE LIMITED",
"CENTAURS SEMICONDUCTORS PRIVATE LIMITED",
"CENTAURTEX INDUSTRIES PRIVATE LIMITED",
"CENTAURUS FINANCIAL SERVICES PRIVATE LIMITED",
"CENTAURUS GREEN ENERGY PRIVATE LIMITED",
"CENTAX PUBLICATIONS PRIVATE LIMITED",
"CENTBANK FINANCIAL SERVICES LIMITED",
"CENTEC RRR SYSTEMS AND SENSORS PRIVATE LIMITED",
"CENTECH ENGINEERS PRIVATE LIMITED",
"CENTECTRA SOLUTIONS PRIVATE LIMITED",
"CENTENARY ARCADES PRIVATE LIMITED",
"CENTENARY DISTILLERIES PRIVATE LIMITED",
"CENTENARY POLYTEX PVT LTD",
"CENTENE CORPORATION",
"CENTENIAL SURGICAL SUTURE LIMITED",
"CENTENNIAL COLLEGE OF APPLIED ARTS AND TECHNOLOGY",
"CENTENNIAL FABRICS LIMITED",
"CENTENNIAL MARITIME INDIA PRIVATE LIMITED",
"CENTER FOR ASSISTED REPRODUCTION EMBRYOLOGY & ENDOSCOPY FERTILITY PRIVATE LIMITED",
"CENTER FOR CREATIVE LEADERSHIP INDIA PRIVATE LIMITED",
"CENTER FOR EDUCATIONAL AND SOCIAL STUDIES",
"CENTER FOR ENTREPRENEURSHIP DEVELOPMENT MADHYA PRADESH",
"CENTER FOR ENVIRONMENTAL DEVELOPMENT FOUNDATION",
"CENTER FOR GOOD GOVERNANCE",
"CENTER FOR INCUBATION INNOVATION RESEARCH AND CONSULTANCY",
"CENTER FOR STUDY OF SCIENCE TECHNOLOGY AND POLICY",
"CENTER ONE WOOD VENEER PRIVATE LIMITED",
"CENTERAC EMARKERPLACES PRIVATE LIMITED",
"CENTERAC TECHNOLOGIES LIMITED",
"CENTERLINE INDIA PRIVATE LIMITED",
"CENTERPOINT ENERGY INC.",
"CENTEST PSYCHOMETRIC ASSESSMENT PRIVATE LIMITED",
"CENTEX FABRICS-EXPORT UNIT",
"CENTEX INTERNATIONAL PRIVATE LIMITED",
"CENTIBELL LIGHTING PRIVATE LIMITED",
"CENTIFIC GLOBAL TECHNOLOGIES INDIA PRIVATE LIMITED",
"CENTIGRADEBRAND CREATIVE SOLUTIONS PRIVATE LIMITED",
"CENTILLION CAPITAL PRIVATE LIMITED",
"CENTILLION INSURANCE BROKERS LIMITED",
"CENTILLION NETWORKS PRIVATE LIMITED",
"CENTILLION SOLUTIONS AND SERVICES PRIVATE LIMITED",
"CENTILLIONAIRES ARDOR INDUSTRY PRIVATE LIMITED",
"CENTILLIONZ IT SOLUTIONS PRIVATE LIMITED",
"CENTIME TECHNOLOGY INDIA PRIVATE LIMITED",
"CENTINA SYSTEMS INDIA PRIVATE LIMITED",
"CENTIRO SOLUTIONS PRIVATE LIMITED",
"CENTIUM HOMES PRIVATE LIMITED",
"CENTOGENE INDIA PRIVATE LIMITED",
"CENTOM INDUSTRIES LIMITED",
"CENTOR INDIA AGRI PRIVATE LIMITED",
"CENTOTECH SERVICES PRIVATE LIMITED",
"CENTPRO ENGINEERING PRIVATE LIMITED",
"CENTRA GOVT HEALTH SCHEME",
"CENTRA HUB PRIVATE LIMITED",
"CENTRAL ACADEMY SENIOR SECONDARY SCHOOL",
"CENTRAL ADMINISTRATIVE TRIBUNAL",
"CENTRAL AFV DEPOTCENTRAL GOV",
"CENTRAL AGRI TRADES PRIVATE LIMITED",
"CENTRAL AMMUNITION DEPOT (CAD CAMP) PULGAON",
"CENTRAL ARECANUT AND COCOA MARKETING AND PROCESSING CO-OPERATIVE LIMITED",
"CENTRAL ARID ZONE RESEARCH INSTITUTE",
"CENTRAL ARMORED FIGHTING VEHICLE DEPOT",
"CENTRAL AUTOMOBILES PRIVATE LIMITED",
"CENTRAL AVENUE TRADING COMPANY PRIVATE LIMITED",
"CENTRAL AVIAN RESEARCH INSTITUTE",
"CENTRAL AVIATION SUPPORT DEPOT",
"CENTRAL BANK OF INDIA",
"CENTRAL BIOTECH PRIVATE LIMITED",
"CENTRAL BOARD FOR WORKERS EDUCATION",
"CENTRAL BOARD OF FILM CERTIFICATION",
"CENTRAL BOARD OF SEC EDUCATION",
"CENTRAL BOARD OF SECONDARY EDUCATION OF INDIA",
"CENTRAL BUILDING RESEARCH INSTITUTE",
"CENTRAL BUREAU OF COMMUNICATION REGIONAL OFFICE PUNE",
"CENTRAL BUREAU OF INVESTIGATION",
"CENTRAL CALCUTTA SALES PRIVATE LIMITED",
"CENTRAL CHIEF LABOUR COMMISSIONER",
"CENTRAL CLAIMS ORGANISATION",
"CENTRAL COALFIELDS LIMITED",
"CENTRAL COOPERATIVE BANK LTD",
"CENTRAL COTTAGE INDUSTRIES CORP CCIC",
"CENTRAL COTTAGE INDUSTRIES CORPORATION OF INDIA LIMITED",
"CENTRAL COUNCIL FOR RESEARCH IN AYURVEDIC SCIENCES",
"CENTRAL COUNCIL OF INDIAN MEDICINE",
"CENTRAL COUNCIL OF RESEARCH IN HOMO",
"CENTRAL DAIRY",
"CENTRAL DATA SYSTEMS PRIVATE LIMITED",
"CENTRAL DEFENCE ACADEMY",
"CENTRAL DEPOSITORY SERVICE I LIMITED",
"CENTRAL DEPOSITORY SERVICES INDIA LIMITED",
"CENTRAL DETECTIVE AND SECURITY SERVICES",
"CENTRAL DRUG RESEARCH INSTITUTE",
"CENTRAL DRUGS LABORATORY",
"CENTRAL DRUGS STANDARD CONTROL ORGANIZATION",
"CENTRAL ELECTRICALS AND ELECTRONICS PRIVATE LIMITED",
"CENTRAL ELECTRONICS ENGINEERING RES",
"CENTRAL ELECTRONICS LIMITED",
"CENTRAL ENGINEERING INSTITUTE",
"CENTRAL EQUIPMENT SUPPLIERS PRIVATE LIMITED",
"CENTRAL EXCISE",
"CENTRAL EXCISE AND CUSTOMS BELAPUR",
"CENTRAL EXCISE AND SERVICE TAX AUDIT BHOPAL",
"CENTRAL EXCISE COMMISSION",
"CENTRAL EXCISE COMMISSIONERATE",
"CENTRAL EXCISE JAMSHEDPUR",
"CENTRAL FINANCE SECURITIES PRIVATE LIMITED",
"CENTRAL FINANCIAL CREDIT AND INVESTMENT CO-OPERATIVE INDIA LTD",
"CENTRAL FISHERY EDUCATION DEPARTMENT",
"CENTRAL FOOD LABORATORY",
"CENTRAL FORENSIC SCIENCE LABORATORY",
"CENTRAL GLASS CERMAICS RESEARCH INSTIT",
"CENTRAL GOODS AND SERVICES TAX",
"CENTRAL GOVERNMENT HEALTH SCHEME",
"CENTRAL GOVERNMENT SCHOOL",
"CENTRAL GREEN HOSPITALITY SERVICES",
"CENTRAL GROUND WATER BOARD",
"CENTRAL HEALTH EDUCATION BOARD",
"CENTRAL HOSPITAL ULHASNAGAR",
"CENTRAL HOSPITAL ULHASNAGAR 3",
"CENTRAL INDIA ACADEMY",
"CENTRAL INDIA CARDIOLOGY HOSPITAL & RESEARCH INSTITUTE",
"CENTRAL INDIA CARDIOLOGY HOSPITAL & RESERCH INSTITUTE",
"CENTRAL INDIA ENGINEERING PRIVATE LIMITED",
"CENTRAL INDIA GENERAL AGENTS LTD",
"CENTRAL INDIA INDUSTRIES LTD.",
"CENTRAL INDIA INSTITUTE OF HAEMATOLOGY AND ONCOLOGY PRIVATE LIMITED",
"CENTRAL INDIA INSTITUTE OF MASS COMMUNIC",
"CENTRAL INDIA INSTITUTE OF MEDICAL SCIENCES",
"CENTRAL INDIA PACKAGING COMPANY PRIVATE LIMITED",
"CENTRAL INDIA PAPER & BOARD MILLS PVT LTD",
"CENTRAL INDIA PLASTOFAB PRIVATE LIMITED",
"CENTRAL INDIA POLYESTERS LIMITED",
"CENTRAL INDIA POLYSACK PRIVATE LIMITED",
"CENTRAL INDIA TOBACCO PRODUCTS PVT LTD",
"CENTRAL INDUSTRIAL SECURITY FORCE MINISTRY OF HOME AFFAIRS GOVT OF INDIA",
"CENTRAL INLAND FISHERIES RESEARCH INSTITUTE",
"CENTRAL INST OF COASTAL",
"CENTRAL INST OF ROAD TRANSPORT",
"CENTRAL INST OF VACATION",
"CENTRAL INSTITUTE FOR COTTON RESEARCH",
"CENTRAL INSTITUTE FOR RESEARCH ON COTTON TECHNOLOGY CIRCOT",
"CENTRAL INSTITUTE FOR RESEARCH ON GOATS",
"CENTRAL INSTITUTE OF EDUCATION",
"CENTRAL INSTITUTE OF FISHERIES EDUCATION",
"CENTRAL INSTITUTE OF FISHERIES TECHNOLOGY",
"CENTRAL INSTITUTE OF HIGHER TIBETAN STUDIES",
"CENTRAL INSTITUTE OF HINDI",
"CENTRAL INSTITUTE OF LIBRARY SCIENCE",
"CENTRAL INSTITUTE OF MANAGEMENT & TECHNOLOGY",
"CENTRAL INSTITUTE OF PETROCHEMICALS ENGINEERING AND TECHNOLOGY",
"CENTRAL INSTITUTE OF ROAD TRANSPORT",
"CENTRAL INTEGRATED PEST MANAGEMENT CENTR",
"CENTRAL INVESTIGATION AND SECURITY SERVICES LIMITED",
"CENTRAL JAIL",
"CENTRAL LEATHER REASERCH",
"CENTRAL LIFECARE PRIVATE LIMITED",
"CENTRAL LINEN PARK PRIVATE LIMITED",
"CENTRAL MARINE FISHERIES RESEARCH INSTITUTE",
"CENTRAL MART PRIVATE LIMITED",
"CENTRAL MINE PLANNING & DESIGN INSTITUTE LIMITED",
"CENTRAL MINE PLANNING DESIGN INST",
"CENTRAL MODERN SCHOOL",
"CENTRAL MOTORS",
"CENTRAL NEWS AGENCY PRIVATE. LIMITED.",
"CENTRAL ORDANANCE DEPOT DEHU ROAD",
"CENTRAL ORDNANCE DEPOT JABALPUR",
"CENTRAL ORGANISATION FOR RAILWAY ELECTRIFICATION",
"CENTRAL PARK INFRASTRUCTURE DEVELOPMENT PRIVATE LIMITED",
"CENTRAL PARK REAL ESTATE DEVELOPERS PRIVATE LIMITED",
"CENTRAL POLLUTION CONTRO",
"CENTRAL POLUTION CONTROL BOARD",
"CENTRAL POTATO RESEARCH INSTITUTE",
"CENTRAL POWER REASEARCH INSTITUTE",
"CENTRAL PROOF ESTABLISHMENT",
"CENTRAL PUBLIC WORK DEPARTMENT",
"CENTRAL PUBLIC WORKS DEPARTMENT GOVERNMENT OF INDIA CPWD",
"CENTRAL RAILSIDE WAREHOUSE COMPANY LIMITED",
"CENTRAL RAILWAY",
"CENTRAL RAILWAY BHUSAWAL DIVISION",
"CENTRAL RAILWAY PUNE DIVISION",
"CENTRAL RAILWAYS",
"CENTRAL RAILWAYS BHOPAL",
"CENTRAL RECORD OFFICE",
"CENTRAL REGISTRY OF SECURITISATION ASSET RECONSTRUCTION AND SECURITY INTEREST OF INDIA",
"CENTRAL ROAD RESCH INST",
"CENTRAL SANSKRIT UNIVERSITY",
"CENTRAL SCHOOL GADMUDSHINGI",
"CENTRAL SILK BOARD",
"CENTRAL SOCIAL WELFARE BOARD",
"CENTRAL SOIL AND RESEARCH STATION",
"CENTRAL STAFF TRAINING AND RESEARCH INSTITUTE",
"CENTRAL STATISTICAL ORGANISATION",
"CENTRAL STORES SUPPLIES PVT LTD",
"CENTRAL TOBACCO RESEARCH INSTITUTE",
"CENTRAL TOOL ROOM TRAINING CENTRE",
"CENTRAL TRAINING UNIT KHADKWASALA",
"CENTRAL TRANSMISSION UTILITY OF INDIA LIMITED",
"CENTRAL TUBER CROPS RESEARCH INSTITUTE",
"CENTRAL TYRES PRIVATE LIMITED",
"CENTRAL UNIVERSITY OF GUJARAT",
"CENTRAL UP GAS LIMITED",
"CENTRAL VIGILANCE COMMISSION",
"CENTRAL WAREHOUSING CORPORATION",
"CENTRAL WATER AND POWER",
"CENTRAL WATER AND POWER RESEARCH STATION",
"CENTRAL WATER COMMISSION",
"CENTRALAB HEALTHCARE SERVICES PRIVATE LIMITED",
"CENTRALINE LUBRO-TECH ENGINEERS PRIVATE LIMITED",
"CENTRALISED ACCIDENT AND TRAUMA SER",
"CENTRALOGIC CONSULTANCY PRIVATE LIMITED",
"CENTRANS LOGISTICS PRIVATE LIMITED",
"CENTRAPATH LABS PRIVATE LIMITED",
"CENTRAPRISE GLOBAL PRIVATE LIMITED",
"CENTRAX SERVICES PRIVATE LIMITED",
"CENTRE FOR ADVANCED DENTAL CARE PRIVATE LIMITED",
"CENTRE FOR AEROSPACE RESEARCH",
"CENTRE FOR AQUATIC LIVELIHOOD- JALJEEVIKA",
"CENTRE FOR CELLULAR AND MOLLECULAR PLATFORMS",
"CENTRE FOR CHRONIC DESEASE CONTROL",
"CENTRE FOR CHRONIC DISEASE CONTROL CCDC",
"CENTRE FOR COLLECTIVE DEVELOPMENT",
"CENTRE FOR COMPUTATIONAL TECHNOLOGIES PRIVATE LIMITED",
"CENTRE FOR COOPERATIVE MANAGEMENT,UTTARPARA",
"CENTRE FOR DEVELOPMENT OF ADVANCED COMPUTING",
"CENTRE FOR DEVELOPMENT OF ADVANCED COMPUTING C-DAC",
"CENTRE FOR DEVELOPMENT OF TELEMATICS",
"CENTRE FOR DEVELOPMENTAL RESEARCH",
"CENTRE FOR DIGESTIVE AND KIDNEY DISEASES INDIA PRIVATE LIMITED",
"CENTRE FOR EDUCATION AND COMMUNICATION",
"CENTRE FOR ENVIRONMENT AND DEVELOPMENT",
"CENTRE FOR ENVIRONMENT AND FOOD TECHNOLOGY PRIVATE LIMITED",
"CENTRE FOR ENVOTECH AND MANAGEMENT CONSULTANCY PRIVATE LIMITED",
"CENTRE FOR EQUITY AND QUALITY IN UNIVERSAL EDUCATION",
"CENTRE FOR EXCELLANCE IN PROJECT MANAGEMENT PRIVATE LIMITED",
"CENTRE FOR EXCELLENCE IN ORGANIZATION PRIVATE LIMITED",
"CENTRE FOR GOOD GOVERNANCE",
"CENTRE FOR HEALTH EDUCATION TRAINING & NUTRITION AWARENESS",
"CENTRE FOR HEALTH RESEARCH AND INNOVATION",
"CENTRE FOR INDIAN BAMBOO RESOURCE AND TECHNOLOGY",
"CENTRE FOR INVESTMENT EDUCATION AND LEARNING PRIVATE LIMITED",
"CENTRE FOR LEATHER RESEARCH INSTITUTE",
"CENTRE FOR MARKET RESEARCH AND SOCIAL DEVELOPMENT PRIVATE LIMITED",
"CENTRE FOR MIGRATION MEDICINE INDIA PRIVATE LIMITED",
"CENTRE FOR MONITORING INDIAN ECONOMY PRIVATE LIMITED",
"CENTRE FOR NEUROLOGICAL SURGERY",
"CENTRE FOR NEUROSCIENCES AND TRAUMA",
"CENTRE FOR PROFESSIONAL AND ADVANCED STUDIES",
"CENTRE FOR RAILWAY INFORMATION SYSTEMS",
"CENTRE FOR RECRUITMENT & SELECTION PRIVATE LIMITED",
"CENTRE FOR RESEARCH & INDUSTRIAL STAFF PERFORMANCE",
"CENTRE FOR SCIENCE AND ENVIRONMENT",
"CENTRE FOR SCIENCE OF STUDENT LEARNING",
"CENTRE FOR SHOPPING PRIVATE LIMITED",
"CENTRE FOR SKILLING AND TECHNICAL SUPPORT",
"CENTRE FOR SOCIAL AND BEHAVIOUR CHANGE COMMUNICATION",
"CENTRE FOR SOCIAL STUDIES",
"CENTRE FOR SPACE PHYSICS",
"CENTRE FOR SPORTS EXCELLENCE PRIVATE LIMITED",
"CENTRE FOR STRATEGY AND LEADERSHIP",
"CENTRE FOR TEACHER ACCREDITATION (CENTA) PRIVATE LIMITED",
"CENTRE FOR TECHNOLOGY ASSISSTED RECONSTRUTIVE SURGERY PRIVATE LIMITED",
"CENTRE FOR URBANIZATION BUILDINGS AND ENVIRONMENT",
"CENTRE FOR VOCATIONAL EDUCATION AND WORKFORCE DEVELOPMENT (INDIA) PRIVATE LIMITED",
"CENTRE OF EXCELLENCE IN MARITIME & SHIPBUILDING (CEMS)",
"CENTRE OF RECOGNITION AND EXCELLENCE PRIVATE LIMITED",
"CENTRE POINT EVENTS PRIVATE LIMITED",
"CENTRE POINT GUWAHATI HOTELS PRIVATE LIMITED",
"CENTRE POINT PET HOSPITAL PRIVATE LIMITED",
"CENTREAL BAZAAR",
"CENTREAL BAZAAR INDIA LIMITED",
"CENTREAL CONSULTANCY SERVICES PRIVATE LIMITED",
"CENTREPOINT LIFESTYLE PRODUCTS PRIVATE LIMITED",
"CENTRESTAGE WITH ANAHITA DASTOOR",
"CENTRIC APORRO PRIVATE LIMITED",
"CENTRIC CONSULTING INDIA PRIVATE LIMITED",
"CENTRIC STEEL LIMITED",
"CENTRICA INDIA OFFSHORE PRIVATE LIMITED",
"CENTRICO INDIA PRIVATE LIMITED",
"CENTRIENT PHARMACEUTICALS INDIA PRIVATE LIMITED",
"CENTRIF PRIVATE LIMITED",
"CENTRIX HEALTHCARE LIMITED",
"CENTRIX PROJECT SOLUTION PRIVATE LIMITED",
"CENTRO ENGINEERING & UTILITIES SERVICES PRIVATE LIMITED",
"CENTRODORSTROY INDIA PRIVATE LIMITED",
"CENTROID IT SYSTEMS INDIA PRIVATE LIMITED",
"CENTRON INDUSTRIAL ALLIANCE LIMITED",
"CENTRON INFRA PROJECTS PRIVATE LIMITED",
"CENTRONIC COMPONENTS INDIA PRIVATE LIMITED",
"CENTROTHERM INDIA PRIVATE LIMITED",
"CENTROXY SOLUTION PRIVATE LIMITED",
"CENTRUM BROKING LIMITED",
"CENTRUM CAPITAL ADVISORS LIMITED",
"CENTRUM CAPITAL LIMITED",
"CENTRUM FINANCIAL SERVICES LIMITED",
"CENTRUM HOUSING FINANCE LIMITED",
"CENTRUM INFRASTRUCTURE AND REALTY LIMITED",
"CENTRUM INSURANCE BROKERS LIMITED",
"CENTRUM INVESTMENT ADVISORS LIMITED",
"CENTRUM MICRO CREDIT LIMITED",
"CENTRUM RETAIL SERVICES LIMITED",
"CENTRUM WEALTH LIMITED",
"CENTRUST CONSULTING PRIVATE LIMITED",
"CENTUARY FIBRE PLATES PRIVATE LIMITED",
"CENTUARY PROCESSIING MILL(INDIA) PRIVATE LIMITED",
"CENTUM ELECTRONICS LIMITED",
"CENTUM FINANCE LIMITED",
"CENTUM T&S PRIVATE LIMITED",
"CENTUM TAX SOLUTIONS PRIVATE LIMITED",
"CENTUM WORKSKILLS INDIA LIMITED",
"CENTURIA GLOBAL TAX SERVICES PRIVATE LIMITED",
"CENTURION BANK OF PUNJAB",
"CENTURION EDUCATION PRIVATE LIMITED",
"CENTURION INDUSTRIES PRIVATE LIMITED",
"CENTURION LABORATORIES PRIVATE LIMITED",
"CENTURION PACKAGING PRIVATE LIMITED",
"CENTURION POLYPLAST PRIVATE LIMITED",
"CENTURION POWER CABLES PRIVATE LIMITED",
"CENTURION REAL ESTATE DEVELOPERS PRIVATE LIMITED",
"CENTURION REMEDIES PRIVATE LIMITED",
"CENTURION UNIVERSITY OF TECHNOLOGY AND MANAGEMENT",
"CENTURIONS HOUSING & CONSTRUCTIONS PRIVATE LIMITED",
"CENTURY 21 MALLS PRIVATE LIMITED",
"CENTURY ALUMINIUM MANUFACTURING CO LTD",
"CENTURY APPARELS PRIVATE LIMITED",
"CENTURY APPARELS PRIVATE. LIMITED.",
"CENTURY AUTO ENGINEERING PRIVATE LIMITED",
"CENTURY BIKES PRIVATE LIMITED",
"CENTURY BUSINESS MEDIA PRIVATE LIMITED",
"CENTURY CARGO CARRIER PRIVATE LIMITED",
"CENTURY CHEMICALS",
"CENTURY COLOURS PRIVATE LIMITED",
"CENTURY COMMODEAL PRIVATE LIMITED",
"CENTURY CONTINUOUS STATIONERY PRIVATE LIMITED",
"CENTURY COTTON PRIVATE LIMITED",
"CENTURY CRANE ENGINEERS PRIVATE LIMITED",
"CENTURY CREDITS LTD",
"CENTURY DISTRIBUTORS PRIVATE LIMITED",
"CENTURY DRUGS PRIVATE LIMITED",
"CENTURY ECO SOLUTIONS INDIA PRIVATE LIMITED",
"CENTURY ENGINEERING COMPANY PRIVATE LIMITED",
"CENTURY ENKA LIMITED",
"CENTURY EXTRUSIONS LTD",
"CENTURY FAB TECH PRIVATE LIMITED",
"CENTURY FABRICS PRIVATE LIMITED",
"CENTURY FINVEST PRIVATE LIMITED",
"CENTURY FIREWORKS PRIVATE LIMITED",
"CENTURY FLOUR MILLS LIMITED",
"CENTURY GALAXY DEVELOPERS LIMITED",
"CENTURY GLOBAL LOGISTIC PRIVATE. LIMITED.",
"CENTURY GRAINS AND FOOD PRIVATE LIMITED",
"CENTURY HOSPITAL",
"CENTURY INDUSTRIAL PRODUCTS PRIVATE LIMITED",
"CENTURY INFRAPOWER PRIVATE LIMITED",
"CENTURY INKS PVT LTD",
"CENTURY JOINT DEVELOPMENT PRIVATE LIMITED",
"CENTURY LABELS PRIVATE LIMITED",
"CENTURY LEATHER PVT LTD",
"CENTURY LED LIMITED",
"CENTURY MANAGEMENT AND PROFESSIONAL SERVICES PRIVATE LIMITED",
"CENTURY MART PRIVATE LIMITED",
"CENTURY MERCANTILE PRIVATE LIMITED",
"CENTURY METAL RECYCLING PRIVATE LIMITED",
"CENTURY METAL RECYCLING PRIVATE. LIMITED.",
"CENTURY METERING SYSTEMS & CONTROLS PRIVATE LIMITED",
"CENTURY MOULDINGS PRIVATE LIMITED",
"CENTURY MULTISPECIALITY HOSPITAL AURANGABAD PRIVATE LIMITED",
"CENTURY OILS PRIVATE LIMITED",
"CENTURY OVERSEASE",
"CENTURY PAPER SACKS PRIVATE LIMITED",
"CENTURY PHARMACEUTICALS LIMITED",
"CENTURY PHARMALABS INDIA PRIVATE LIMITED",
"CENTURY PLAZA PRIVATE LIMITED",
"CENTURY PLY & BOARDS PVT. LTD.",
"CENTURY PLYBOARDS INDIA LIMITED",
"CENTURY PULP AND PAPER PROP CENTURY TEXTILES AND INDUSTRIES LIMITED",
"CENTURY RAYON",
"CENTURY REFINERIES PRIVATE LIMITED",
"CENTURY ROAD TRANSPORT PRIVATE LIMITED",
"CENTURY ROPES PRIVATE LIMITED",
"CENTURY SECURITECH PRIVATE LIMITED",
"CENTURY SHELTORS DEVELOPERS PRIVATE LIMITED",
"CENTURY SHIPYARD PRIVATE LIMITED",
"CENTURY SPICES PRIVATE LIMITED",
"CENTURY SUPER SPECIALITY HOSPITALS PRIVATE LIMITED",
"CENTURY TEXOFIN PRIVATE LIMITED",
"CENTURY TEXTILES AND INDUSTRIES LIMITED",
"CENTURY TILES LIMITED",
"CENTURY TRADESERVE LIMITED",
"CENTURY TRANSFORMERS PRIVATE LIMITED",
"CENTURY ULTRAPACK PRIVATE LIMITED",
"CENTURY WINES PRIVATE LIMITED",
"CENTURYPLY",
"CENTURYSOFT PRIVATE LIMITED",
"CENTURYWELLS ROOFING INDIA PRIVATE LIMITED",
"CENTWIN HOUSING PRIVATE LIMITED",
"CENTWIN TEXTILE MILLS PRIVATE LIMITED",
"CENU ENGINEERING WORKS",
"CENZA TECHNOLOGIES P LIMITED",
"CEO CLUBS INDIA",
"CEO ITEC PRIVATE LIMITED",
"CEO JANPAD PANCHAYAT",
"CEO JANPAD PANCHAYAT KHALWA",
"CEO TSG IR AND LABOUR COMPLIANCE SERVICES PRIVATE LIMITED",
"CEOMA CONSULTING PRIVATE LIMITED",
"CEONE INFOSOLUTIONS PRIVATE LIMITED",
"CEPAC PACKAGING PRIVATE LIMITED",
"CEPCO INDUSTRIES PRIVATE LIMITED",
"CEPHAM MILK SPECIALITIES LIMITED",
"CEPHAS INFRASTRUCTURE PRIVATE LIMITED",
"CEPHAS MEDICAL PRIVATE LIMITED",
"CEPHEID INDIA PRIVATE LIMITED",
"CEPL LAND HOLDINGS PRIVATE LIMITED",
"CEPRO BUILDING SYSTEMS PRIVATE LIMITED",
"CEPT RESEARCH & DEVELOPMENT FOUNDATION",
"CEPT RESEARCH AND DEVELOPMENT FOUNDATION",
"CEPT UNIVERSITY",
"CEPTES SOFTWARE PRIVATE LIMITED",
"CERA SANITARYWARE LIMITED",
"CERA THERMAL TECHNOLOGY PRIVATE LIMITED",
"CERA TRADE INDIA PRIVATE LIMITED",
"CERACON CERAMIX INDIA PRIVATE LIMITED",
"CERACON ENGINEERS PRIVATE LIMITED",
"CERAFLUX INDIA PRIVATE LIMITED",
"CERAGEM INDIA PRIVATE LIMITED",
"CERAGON NETWORKS INDIA PRIVATE LIMITED",
"CERAMAX GRANITO LIMITED",
"CERAMED ENGINEERS LIMITED",
"CERAMET CONSULTANTS PVT LTD",
"CERAMIC TABLEWARE PRIVATE LIMITED",
"CERAMIC TOOLS PRIVATE LIMITED",
"CERAMIN INDIA PRIVATE LIMITED",
"CERAMTEC INDIA INNOVATIVE CERAMIC ENGINEERING PRIVATE LIMITED",
"CERANA BEVERAGES PRIVATE LIMITED",
"CERAS INTECH LIMITED",
"CERASUS REALATORS PRIVATE LIMITED",
"CERATEC MARBLE INDIA PRIVATE LIMITED",
"CERATEC TILES INDIA PRIVATE LIMITED",
"CERATHERM TECHNOLOGIES INDIA PRIVATE LIMITED",
"CERATIZIT INDIA PRIVATE LIMITED",
"CERATIZIT INDIA ROUND TOOL SOLUTIONS PRIVATE LIMITED",
"CERBERUS CAPITAL SERVICES PRIVATE LIMITED",
"CERCLE COMPLET PRIVATE LIMITED",
"CEREAL AGROTECH PRIVATE LIMITED",
"CEREBLIS TECHNOLOGIES PRIVATE LIMITED",
"CEREBRA IT SERVICES PRIVATE LIMITED",
"CEREBRAL LEARNING SOLUTIONS PRIVATE LIMITED",
"CEREBRAL LOGIX TECHNOLOGIES PRIVATE LIMITED",
"CEREBRAL TECH VENTURES PRIVATE LIMITED",
"CEREBRATE BUSINESS SOLUTIONS PRIVATE LIMITED",
"CEREBRIK TECH PRIVATE LIMITED",
"CEREBRO REALTORS & CONSULTANTS PRIVATE LIMITED",
"CEREBRUMX LABS PRIVATE LIMITED",
"CEREBRUS CONSULTANTS PRIVATE LIMITED",
"CEREBULB INDIA PRIVATE LIMITED",
"CEREC METALFORM PRIVATE LIMITED",
"CERECON BIO SCIENCES PRIVATE LIMITED",
"CEREMONY HOMES PRIVATE LIMITED",
"CERENCE SERVICES (INDIA) LLP",
"CEREPRO CORPORATE SOLUTIONS PRIVATE LIMITED",
"CERES ESTATE LIMITED",
"CERES HOTELS PRIVATE LIMITED",
"CERES PROJECTS PRIVATE LIMITED",
"CERES PROPERTIES LIMITED",
"CERESTRA ADVISORS PRIVATE LIMITED",
"CERESTRA VENTURES PRIVATE LIMITED",
"CERIGO ADDITIVES PRIVATE LIMITED",
"CERILLION TECHNOLOGIES INDIA PRIVATE LIMITED",
"CERISETECH SOLUTIONS PRIVATE LIMITED",
"CERITA HOLDINGS PRIVATE LIMITED",
"CERIUM TECHNOLOGIES PRIVATE LIMITED",
"CERMET RESISTRONICS PRIVATE LIMITED",
"CEROVENE HEALTHCARE PRIVATE LIMITED",
"CERP SOFTWARE SOLUTIONS PRIVATE LIMITED",
"CERRID SOLUTIONS PRIVATE LIMITED",
"CERT ID INDIA PRIVATE LIMITED",
"CERTAINCURE PHARMA PRIVATE LIMITED",
"CERTAINTY INFOTECH PRIVATE LIMITED",
"CERTARA SOFTWARE INDIA PRIVATE LIMITED",
"CERTENET TECHNOLOGIES PRIVATE LIMITED",
"CERTES NETWORKS (INDIA) PRIVATE LIMITED",
"CERTIFICATION ENGINEERS INTERNATIONAL LIMITED",
"CERTIKIN SWIMMING POOL PRODUCTS INDIA PRIVATE LIMITED",
"CERTUS APAC CONSULTING PRIVATE LIMITED",
"CERULEAN INFORMATION TECHNOLOGY PRIVATE LIMITED",
"CERULEAN INTERIORS PRIVATE LIMITED",
"CERVELLO INDIA PRIVATE LIMITED",
"CERVIN FAMILY OFFICE & ADVISORS PRIVATE LIMITED",
"CERYX DIGITAL PRIVATE LIMITED",
"CES ‚ÄòS FRANCISCAN NERSERY KINDERGARTEN SCHOOL",
"CES ANALYTICAL AND RESEARCH SERVICES INDIA PRIVATE LIMITED",
"CES GLOBAL IT SOLUTIONS PRIVATE LIMITED",
"CES INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"CES INFRA INDIA PRIVATE LIMITED",
"CES LIMITED",
"CES S MICHAEL HIGH SCHOOL & MARCELINE JUNIOR COLLEGE",
"CES TECHNOLOGY SERVICES PRIVATE LIMITED",
"CESARE BONETTI INTERNATIONAL PRIVATE LIMITED",
"CESARI FASHION PRIVATE LIMITED",
"CESC LTD",
"CESIUM PRODUCTS PRIVATE LIMITED",
"CESKA CORMEN LIMITED",
"CESSNA GARDEN DEVELOPERS PRIVATE. LIMITED.",
"CESSNA LIFELINE VETERINARY HOSPITAL",
"CESSUM INFRA PRIVATE LIMITED",
"CESTA SHIPPING PRIVATE LIMITED",
"CET ENVIRO PRIVATE LIMITED",
"CET POWER SOLUTIONS INDIA PRIVATE LIMITED",
"CETAS HEALTHCARE PRIVATE LIMITED",
"CETAS INFORMATION TECHNOLOGY PRIVATE LIMITED",
"CETAS SHIPPING AND LOGISTICS (INDIA) PRIVATE LIMITED",
"CETC RENEWABLE ENERGY TECHNOLOGY (INDIA) PRIVATE LIMITED",
"CETEX PETROCHEMICALS LIMITED",
"CETHAR CONSULTANCY SERVICES LIMITED",
"CETHAR ENERGY LIMITED",
"CETHAR HEALTHCARE SERVICES PRIVATE LIMITED",
"CETKING EDUCATION PRIVATE LIMITED",
"CETPA INFOTECH PRIVATE LIMITED",
"CETUS CONSULTING SOLUTION SERVICES PRIVATE LIMITED",
"CETUS ENGINEERING PRIVATE LIMITED",
"CEV ENGINEERING PRIVATE LIMITED",
"CEVA ESA BSC PRIVATE LIMITED",
"CEVA FREIGHT INDIA PRIVATE LIMITED",
"CEVA POLCHEM PRIVATE LIMITED",
"CEVA SOFTWARE (INDIA) PRIVATE LIMITED",
"CEVIOUS TECHNOLOGIES PRIVATE LIMITED",
"CEX WEBUY ENTERTAINMENT PRIVATE LIMITED",
"C-EXMART TECHNOLOGY PRIVATE LIMITED",
"CEYEN TECHNO PROJECTS PRIVATE LIMITED",
"CEYENAR CHEMICALS PRIVATE LIMITED",
"CEYES ENGLISH MEDIUM SCHOOL",
"CEYLINE SHIPPING SERVICES PRIVATE LIMITED",
"CEYONE FASTENERS PRIVATE LIMITED",
"CEYONE MARKETING PRIVATE LIMITED",
"CEYONE WELLNESS INDIA PRIVATE LIMITED",
"CEZA FORMULATIONS PRIVATE LIMITED",
"CEZEN TECHNOLOGIES PRIVATE LIMITED",
"CEZO INTERNATIONAL PRIVATE LIMITED",
"CF TECHNOLOGIES LIMITED",
"CFA INSTITUTE INDIA PRIVATE LIMITED",
"CFB ADVISORS PRIVATE LIMITED",
"CFB FOODS PRIVATE LIMITED",
"CFB RETAIL PRIVATE LIMITED",
"CFC CARRIERS PRIVATE LIMITED",
"CFC LOGISTICS PRIVATE LIMITED",
"CFC SOFTWARE INDIA PRIVATE LIMITED",
"CFE-HS TECHNOLOGY PRIVATE LIMITED",
"CFF FLUID CONTROL LIMITED",
"CFF FLUID CONTROL PRIVATE LIMITED",
"CFFTED INDIA PRIVATE LIMITED",
"CFG INTERNATIONAL PRIVATE LIMITED",
"CFI VENTURES PRIVATE LIMITED",
"CFIRST BACKGROUND CHECKS INDIA PRIVATE LIMITED",
"CFIRST BACKGROUND CHECKS LLP",
"CFL CROSSFREIGHT PRIVATE LIMITED",
"CFL PHARMACEUTICALS LIMITED",
"CFM ADVISORS PRIVATE LIMITED",
"CFM AIRCRAFT ENGINE SUPPORT SOUTH ASIA PRIVATE LIMITED",
"CFM ASSET RECONSTRUCTION PRIVATE LIMITED",
"CFM INFRATEX LIMITED",
"CFM LOGISTICS PRIVATE LIMITED",
"CFM MARKET LINKAGES PRIVATE LIMITED",
"CFM SCHILLER INDIA ENGINEERING PRIVATE LIMITED",
"CFO BRIDGE SERVICES PRIVATE LIMITED",
"CFO COLLECTIVE PRIVATE LIMITED",
"CFOG SYSTEMS PRIVATE LIMITED",
"CFOLOGIC PRIVATE LIMITED",
"CFR ENGINE SERVICES PRIVATE LIMITED",
"CFS MANAGEMENT PRIVATE LIMITED",
"CFS NETRALAYA PRIVATE LIMITED",
"CFS PHARMA AND OPTICALS PRIVATE LIMITED",
"CG AGRO PROJECTS PRIVATE LIMITED",
"CG CARBON INDIA PRIVATE LIMITED",
"CG FERMENTED FOOD PRODUCTS PRIVATE LIMITED",
"CG FOODS INDIA PRIVATE LIMITED",
"CG INSTITUTE OF EDUCATION PRIVATE LIMITED",
"CG IRON PRIVATE LIMITED",
"CG MARKETING PRIVATE LIMITED",
"CG MINERALS LIMITED",
"CG NUTRACEUTICAL FOODS PRIVATE LIMITED",
"CG PARIVAR IT SOLUTIONS PRIVATE LIMITED",
"CG PARIVAR PRIVATE LIMITED",
"CG POWER AND INDUSTRIAL SOLUTIONS LIMITED",
"CG RAJYA ANTYAVSAI SAHKARI VITTA EVAM VIKAS NIGAM NAYA RAIPUR",
"CG SOYA PRODUCTS PRIVATE LIMITED",
"CG STATE GOVT FOREST DEPT",
"CG TOLLWAY LIMITED",
"CG VAK SOFTWARE AND EXPORTS LIMITED",
"CGAMES CUSTOMER SOLUTIONS LLP",
"CGBIZ SOLUTIONS PRIVATE LIMITED",
"CGC CONVERSE TECHNOLOGIES PRIVATE LIMITED",
"CGC INFRA PROJECTS PRIVATE LIMITED",
"CGD SATHARAI PRIVATE LIMITED",
"CGI INFORMATION SYSTEMS AND MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"CGI STUDIOS PRIVATE LIMITED",
"CGIF IT CONSULTING (INDIA) PRIVATE LIMITED",
"CGK CONSTRUCTIONS AND REAL ESTATE PRIVATE LIMITED",
"CGM INDIA PRIVATE LIMITED",
"CGMP PHARMA'N PLANS PRIVATE LIMITED",
"CGMP PROJECTS PRIVATE LIMITED",
"CGN & ASSOCIATES INDIA PRIVATE LIMITED",
"CGN ACOUSTIC SOLUTIONS PRIVATE LIMITED",
"CGN RESEARCH LABS PRIVATE LIMITED",
"CGNX NETWORKS PRIVATE LIMITED",
"CGPL CORPINESS GLOBAL PRIVATE LIMITED",
"CGPL ELECTROMECH PRIVATE LIMITED",
"CG-PPI ADHESIVE PRODUCTS LIMITED",
"CGR COLLATERAL MANAGEMENT LIMITED",
"CGR LOGISTICS PRIVATE LIMITED",
"CGR METALLOYS PRIVATE LIMITED",
"CGS ADVERTISEMENT & PUBLICITY PRIVATE LIMITED",
"CGS APPAREL PRIVATE. LIMITED",
"CGS INFOTECH SOLUTIONS PRIVATE LIMITED",
"CGSASP PRIVATE LIMITED",
"CGS-CIMB SECURITIES INDIA PRIVATE LIMITED",
"CGTT INDIA PRIVATE LIMITED",
"CGU LOGISTIC LIMITED",
"CGWW CARGO WORLDWIDE INDIA PRIVATE LIMITED",
"CH COMPONENT PRIVATE LIMITED",
"CH DEVI LAL CO-OP SUGAR MILLS LIMITED",
"CH GLOBAL HUB SERVICES PRIVATE LIMITED",
"CH GOWRI SHANKAR INFRA BUILD INDIA PRIVATE LIMITED",
"CH P N S K V INTER COLLEGE MACHHRA MEERUT",
"CH PNS KV INTER COLLEGE MACHHARA",
"CH VEERARAGHAVULU CONSTRUCTION PRIVATE LIMITED",
"CH. MATHAN SINGH AND SONS PRIVATE LIMITED",
"CH. OM PRAKASH IMPERO PRIVATE LIMITED",
"CH2M HILL (INDIA) PRIVATE LIMITED",
"CH2M HILL COMPANIES LIMITED.",
"CH2M HILL INTERNATIONAL LIMITED",
"CHA ENGINEERING AND CONSTRUCTION PRIVATE LIMITED",
"CHA INDICA PRIVATE LIMITED",
"CHAAHAL AUTOMOBILES PRIVATE LIMITED",
"CHAAHAT HOMES INFRATECH PRIVATE LIMITED",
"CHAAIPANI BIZ SUPPORT PRIVATE LIMITED",
"CHAAND MINERALS PRIVATE LIMITED",
"CHAAR DISHAYEN PRINTERS PRIVATE LIMITED",
"CHAARMS ELECTRICAL AND ELECTRONICS PRIVATE LIMITED",
"CHABBRAS ASSOCIATES",
"CHABIL DASS YASAV KUMAR LUBRICANTS(INDIA) PRIVATE LIMITED.",
"CHABRIA INFOTECH PRIVATE LIMITED",
"CHACHA LIFE STYLE PRIVATE LIMITED",
"CHACHA NEHRU BAL CHIKITSALAYA",
"CHACHA NEHRU BAL CHIKITSALYA AVAM ANUSHANDHAN KENDRA INDORE",
"CHACHA NEHRU BAL MANDIR INTER COLLEGE BAREILLY",
"CHACHAN METALS PRIVATE LIMITED",
"CHACHAN SMELTERS PRIVATE LIMITED",
"CHACHAN STEELS PRIVATE LIMITED",
"CHACHE DI HATTI PRIVATE LIMITED",
"CHACKOS PLYWOOD MILLS PRIVATE LIMITED",
"CHADALAWADA RAMANAMMA ENGINEERING COLLEGE",
"CHADARWALA HANDLOOM HOUSE PRIVATE LIMITED",
"CHADDHA JEWELLERS PRIVATE LIMITED",
"CHADHA EXPORTS PVT LTD",
"CHADHA HOLDINGS PRIVATE LIMITED",
"CHADHA INDUSTRIES PRIVATE LIMITED",
"CHADHA INVESTMENT CONSULTANT PRIVATE LIMITED",
"CHADHA LUMBERS PRIVATE LIMITED",
"CHADHA MOBILE HOUSE PRIVATE LIMITED",
"CHADHA MOTOR TRANSPORT COMPANY PRIVATE LIMITED",
"CHADHA PAPERS LIMITED",
"CHADHA SALES PRIVATE LIMITED",
"CHADHA SUGARS & INDUSTRIES LIMITED",
"CHAGI AGRO INDUSTRIES PRIVATE LIMITED",
"CHAHAL ACADEMY PRIVATE LIMITED",
"CHAHAL BOILERS PRIVATE LIMITED",
"CHAHAL FREIGHT CARRIERS PRIVATE LIMITED",
"CHAHAL HOSPITAL PRIVATE LIMITED",
"CHAHAL SPINTEX PRIVATE LIMITED",
"CHAHAT CREATION PRIVATE LIMITED",
"CHAHAT ENTERPRISES PRIVATE LIMITED",
"CHAHAT EXIM PRIVATE LIMITED",
"CHAHAT SECURITY SERVICES PRIVATE LIMITED",
"CHAI DAYS CAFE INDIA PRIVATE LIMITED",
"CHAI SUTTA BAR PRIVATE LIMITED",
"CHAI SUTTA BAR TRADING PRIVATE LIMITED",
"CHAI THELA PRIVATE LIMITED",
"CHAIIM FABTECH PRIVATE LIMITED",
"CHAIKA POLYMERS PRIVATE LIMITED",
"CHAIKAPI SERVICES PRIVATE LIMITED",
"CHAIN CONSULTANTS PRIVATE LIMITED",
"CHAIN HOUSE INTERNATIONAL PRIVATE LIMITED",
"CHAIN IQ INDIA LLP",
"CHAIN N CHAINS JEWELS LIMITED",
"CHAIN TOOLS AND PRODUCTS PRIVATE LIMITED",
"CHAINALYTICS SERVICES PRIVATE LIMITED",
"CHAIN-NINE COMTRADE PRIVATE LIMITED",
"CHAINS CORNER JEWELLERY (INDIA ) PRIVATE LIMITED",
"CHAIN-SYS SOFTWARE EXPORTS PRIVATE LIMITED",
"CHAIR CRAFT INDIA PRIVATE LIMITED",
"CHAIRMAN DISTRICT CONSUMER FORUM CHHINDWARA",
"CHAIRMAN FASHIONS PRIVATE LIMITED",
"CHAIRMAN PROCESSORS PRIVATE LIMITED",
"CHAIRMAN SILK MILLS PRIVATE LIMITED",
"CHAITAINYA METALS PRIVATE LIMITED",
"CHAITANAY MEDICAL FOUNDATION COLLEGE",
"CHAITANYA AGRO-BIO-TECH PRIVATE LIMITED",
"CHAITANYA BARIUM (INDIA) PRIVATE LIMITED",
"CHAITANYA BHARATHI ACADEMY",
"CHAITANYA BHARATHI INSTI OF TECH",
"CHAITANYA BUILDERS & LEASING PRIVATE LIMITED",
"CHAITANYA CHEMICALS",
"CHAITANYA CINE WORLD PRIVATE LIMITED",
"CHAITANYA COLD STORAGE PRIVATE LIMITED",
"CHAITANYA COLLEGE",
"CHAITANYA E/M HIGH SCHOOL",
"CHAITANYA EDUCATIONAL INSTITUTIONS",
"CHAITANYA ENERGY PRIVATE LIMITED",
"CHAITANYA ENTERPRISES",
"CHAITANYA ESTATES PRIVATE LIMITED",
"CHAITANYA FINANCIAL CONSULTANCY PRIVATE LIMITED",
"CHAITANYA FOUNDATIONS PRIVATE LIMITED",
"CHAITANYA GODAVARI GRAMEENA BANK",
"CHAITANYA GOURMET PRIVATE LIMITED",
"CHAITANYA GROUP OF INSTITUTIONS",
"CHAITANYA HI-TECH ENGINEERING COMPANY PRIVATE LIMITED",
"CHAITANYA INDIA FIN CREDIT PRIVATE LIMITED",
"CHAITANYA INFRACON PRIVATE LIMITED",
"CHAITANYA INSTRUMENTS PRIVATE LIMITED",
"CHAITANYA LIFE SCIENCE PRIVATE LIMITED",
"CHAITANYA LOGISTICS PRIVATE LIMITED",
"CHAITANYA PACKAGINGS PVT LTD",
"CHAITANYA PHARMACEUTICALS PVT LTD",
"CHAITANYA POWER SYSTEMS PRIVATE LIMITED",
"CHAITANYA PRECI-TECH PRIVATE LIMITED",
"CHAITANYA PROJECTS CONSULTANCY LIMITED",
"CHAITANYA PROTECTOCOATS PRIVATE LIMITED",
"CHAITANYA REFRACTORY PRIVATE LIMITED",
"CHAITANYA RETAILS PRIVATE LIMITED",
"CHAITANYA SAI PAPER MILLS (INDIA) PRIVATE LIMITED",
"CHAITANYA SALES PRIVATE LIMITED",
"CHAITANYA SEEDS",
"CHAITANYA SOLVEX PRIVATE LIMITED",
"CHAITANYA STEELSHAPE PRIVATE LIMITED",
"CHAITANYA STONECRUSHERS PRIVATE LIMITED",
"CHAITANYA WRITING INDUSTRIES PRIVATE LIMITED",
"CHAITANYAJYOTI FINVEST PRIVATE LIMITED",
"CHAITANYAS FOODCOURT PRIVATE LIMITED",
"CHAITHANYA EYE CARE CENTRE PRIVATE LIMITED",
"CHAITHANYA EYE HOSPITAL & RES INSTT",
"CHAITHANYA FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"CHAITHANYA INFRA PROJECTS INDIA PRIVATE LIMITED",
"CHAITHANYA INTEGRATED HEALTHCARE INDIA PRIVATE LIMITED",
"CHAITHANYA LASIK CENTRE PRIVATE LIMITED",
"CHAITHANYAM BUILDERS PRIVATE LIMITED",
"CHAITRA ASSOCIATES POWER ELECTRONICS PRIVATE LIMITED",
"CHAITRA HOSPITALITY AND DEVELOPMENT SERVICES PRIVATE LIMITED",
"CHAITRA RETAIL SERVICES PRIVATE LIMITED",
"CHAITRI CONSTRUCTION PRIVATE LIMITED",
"CHAIWALA TEA CO. PRIVATE LIMITED",
"CHAK MAKRAMPUR AGRO TRADING PRIVATE LIMITED",
"CHAK PANCHGHORA SITANATH HIGH SCHOOL",
"CHAK RADER FARM EQUIPMENTS PRIVATE LIMITED",
"CHAKAACHAK CLEAN INDIA PRIVATE LIMITED",
"CHAKADOLA CONSTRUCTION PRIVATE LIMITED",
"CHAKADOLA ENTERPRISES PRIVATE LIMITED",
"CHAKADOLA ESTATES PVT LTD",
"CHAKADOLA POLYMERS PRIVATE LIMITED",
"CHAKAN CRITICARE HOSPITAL PRIVATE LIMITED",
"CHAKAN INFRAPROJECTS PRIVATE LIMITED",
"CHAKAN INVESTMENT PRIVATE LIMITED",
"CHAKAN LOGISTICS PARK PRIVATE LIMITED",
"CHAKARA DESIGN AND CONSTRUCTION ENGINEERS PRIVATE LIMITED",
"CHAKDAH RICE MILLS PRIVATE LIMITED",
"CHAKDANA MOTOR FINANCE PRIVATE LIMITED",
"CHAKI LEAVES",
"CHAKIAT AGENCIES PRIVATE LIMITED",
"CHAKIAT SHIPPING SERVICES PRIVATE LIMITED",
"CHAKKACHERIL RUBBERS PVT LTD",
"CHAKKRA COAL INDIA PRIVATE LIMITED",
"CHAKNETAI JUNIOR HIGH SCHOOL CO ED",
"CHAKOLAS SPINNING AND WEAVING MILLS PRIVATE LIMITED",
"CHAKR INNOVATION PRIVATE LIMITED",
"CHAKRA CHAINS JEWELLERY PRIVATE LIMITED",
"CHAKRA DRUGS PRIVATE LIMITED",
"CHAKRA GLASSWORKS PRIVATE LIMITED",
"CHAKRAAVARTHI AGRO FOODS PRIVATE LIMITED",
"CHAKRABORTY ELECTRICALS PRIVATE LIMITED",
"CHAKRADHAR CHEMICALS PRIVATE LIMITED",
"CHAKRADHAR CHEMICALS PRIVATE. LIMITED.",
"CHAKRADHAR CONTRACTORS AND ENGINEERS PRIVATE LIMITED",
"CHAKRADHAR DEALERS SALES AND SERVICES PRIVATE LIMITED",
"CHAKRADHAR ENGINEERING PRIVATE LIMITED",
"CHAKRADHARA AEROSPACE AND CARGO PRIVATE LIMITED",
"CHAKRADHARI WHEELS PRIVATE LIMITED",
"CHAKRAM TRADING & INVESTMENT PVT LTD",
"CHAKRAPANI VYAPAR PRIVATE LIMITED",
"CHAKRASOFT PRIVATE LIMITED",
"CHAKRATH CAREER CONSULTANTS PRIVATE LIMITED",
"CHAKRAVARTHY FABRIC PRIVATE LIMITED",
"CHAKRAVARTHY REALTORS PRIVATE LIMITED",
"CHAKRAYOG FOUNDATION",
"CHAKRESHWARI SHIPPING AGENCY PRIVATE LIMITED",
"CHAKRI FISHERIES PRIVATE LIMITED",
"CHAKSHU PROPERTIES PRIVATE LIMITED",
"CHAKUR LOHA NANDED HIGHWAYS PRIVATE LIMITED",
"CHALAH INFRATECH PRIVATE LIMITED",
"CHALAKUDI HOTELS PRIVATE LIMITED",
"CHALAKUDY METAL TRADERS PRIVATE LIMITED",
"CHALAKUDY PRIYA PHARMA PRIVATE LIMITED",
"CHALAMA INFRAPROPERTIES PRIVATE LIMITED",
"CHALAPATHI CHIT FUND PVT LTD",
"CHALAPATHI EDUCATIONAL SOCIETY",
"CHALAPATHI INSITITUTE OF ENGINEERING & TECHNOLOGY",
"CHALAPATHI INSTITUTE OF PHARMACEUTICAL SCIENCES",
"CHALASANI BIO-PHARMA PRIVATE LIMITED",
"CHALASANI HOSPITALS PRIVATE. LIMITED.",
"CHALCEDONY CONTROLS & INSTRUMENTATION PRIVATE LIMITED",
"CHALDEAN SYRIAN COLLEGE",
"CHALET HOTELS LIMITED",
"CHALIMEDA FEEDS PRIVATE LIMITED",
"CHALK AND CHUCKLES PRODUCTS PRIVATE LIMITED",
"CHALK DIGITAL PRIVATE LIMITED",
"CHALK STUDIO DESIGN PRIVATE LIMITED",
"CHALLA CHLORIDES PVT LTD",
"CHALLA EYE CARE PRIVATE LIMITED",
"CHALLA HEALTH AT HOMES PRIVATE LIMITED",
"CHALLA INFRA PROJECTS PRIVATE LIMITED",
"CHALLANI CAPITAL LIMITED",
"CHALLANI RANKA JEWELLERY",
"CHALLENGE FIXTURES INDIA PRIVATE LIMITED",
"CHALLENGER COMPUTERS PRIVATE LIMITED",
"CHALLENGER EDUCATIONAL SOCIETY",
"CHALLENGER PACKAGING MACHINERY COMPANY PVT LTD",
"CHALLENGER SWEEPERS PRIVATE LIMITED",
"CHALLENGER TRADELINK (INDIA) PRIVATE LIMITED",
"CHALLENGERS EVENTS PRIVATE LIMITED",
"CHALM HOSPITALITY PRIVATE LIMITED",
"CHALMEDA ANAND RAO INSTITUTE OF MEDICAL SCIENCES",
"CHALMERS ENGINEERING INDIA PRIVATE LIMITED",
"CHALO AFRICA TOURS PRIVATE LIMITED",
"CHALUKYA TECHNOLOGIES PRIVATE LIMITED",
"CHAMADIA AGENCY LLP",
"CHAMADIA DISTRIBUTION PRIVATE LIMITED",
"CHAMADIA TRADELINK PRIVATE LIMITED",
"CHAMAK HOLDINGS LIMITED",
"CHAMAK POLYMERS PRIVATE LIMITED",
"CHAMAN BHARTIYA SCHOOL",
"CHAMAN CLASSIC PRIVATE LIMITED",
"CHAMAN KNIT PRIVATE LIMITED",
"CHAMAN LAL BUNKER",
"CHAMAN LAL SETIA EXPORTS LIMITED",
"CHAMAN METALLICS LIMITED",
"CHAMAN VATIKA RESIDENTIAL PUBLIC SCHOOL",
"CHAMARIA FASHIONS PRIVATE LIMITED",
"CHAMARIA INFRASTRUCTURES PRIVATE LIMITED",
"CHAMBAL ALUMS PRIVATE LIMITED",
"CHAMBAL AUTOMOTIVES PRIVATE LIMITED",
"CHAMBAL FERTILISERS AND CHEMICALS LIMITED",
"CHAMBAL INDIA PRIVATE LIMITED",
"CHAMBAL MEDIA PRIVATE LIMITED",
"CHAMBAL MOTORS PRIVATE LIMITED",
"CHAMBAL OIL PRODUCTS PRIVATE LIMITED",
"CHAMBAL TRADINGS PRIVATE LIMITED",
"CHAMBALA TEA FACTORY PRIVATE LIMITED",
"CHAMDOL TRADING AND INVESTMENT SERVICES PRIVATE LIMITED",
"CHAME AGRO INDUSTRIES PRIVATE LIMITED",
"CHAMEAU MANPOWER SOLUTIONS PRIVATE LIMITED",
"CHAMELI DEVI INSTITUTE OF LAW",
"CHAMELI DEVI INTER COLLEGE JARGAWAN",
"CHAMELI DEVI PUBLIC SCHOOL",
"CHAMELIDEVI FLOUR MILLS PRIVATE LIMITED",
"CHAMIERS INVESTMENTS PRIVATE LIMITED",
"CHAMOLI HYDRO POWER PRIVATE LIMITED",
"CHAMOMILES LUBRICATION PRIVATE LIMITED",
"CHAMONG TEE EXPORTS PVT LTD",
"CHAMP ENERGY VENTURES PRIVATE LIMITED",
"CHAMPA AGARWAL GIRLS INTER COLLEGE ALIGARH",
"CHAMPA DEVI FOODS PRIVATE LIMITED",
"CHAMPA LAL AGENCIES PRIVATE LIMITED",
"CHAMPA LAL JEWELLERS PRIVATE LIMITED",
"CHAMPA POLYPLAST PRIVATE LIMITED",
"CHAMPAK CHEMICALS PVT LTD",
"CHAMPAK ENTERPRISES PRIVATE LIMITED",
"CHAMPAK NIKETAN PVT LTD",
"CHAMPALAL K KHINVASARA",
"CHAMPALAL RAJESHKUMAR DENIMS PRIVATE LIMITED",
"CHAMPALI GARDEN PRIVATE LIMITED",
"CHAMPARAN COLD STORAGE PRIVATE LIMITED",
"CHAMPARAN DRESSES PRIVATE LIMITED",
"CHAMPARAN MARKETING CO LTD",
"CHAMPARAN TRADING & WAREHOUSE PRIVATE LIMITED",
"CHAMPDANI ARYA VIDYAPITH",
"CHAMPESHVAR IRON AND STEEL PRIVATE LIMITED",
"CHAMPION ADVANCED MATERIALS PRIVATE LIMITED",
"CHAMPION CAR RENTAL PRIVATE LIMITED",
"CHAMPION CERAMICS PVT LTD.,",
"CHAMPION COATINGS PRIVATE LIMITED",
"CHAMPION COMMERCIAL COMPANY LIMITED",
"CHAMPION COMPONENTS PRIVATE LIMITED",
"CHAMPION COMPUTERS PRIVATE LIMITED",
"CHAMPION DEALERS (MUMBAI) PRIVATE LIMITED",
"CHAMPION DEALERS PRIVATE LIMITED",
"CHAMPION ELCOM PRIVATE LIMITED",
"CHAMPION ELECTRICAL INDUSTRIES PRIVATE LIMITED",
"CHAMPION ELECTRICALS CO PRIVATE LIMITED",
"CHAMPION ENGINEERING EXPORTS PRIVATE LIMITED",
"CHAMPION GRANITES PRIVATE LIMITED",
"CHAMPION INFRATECH PRIVATE LIMITED",
"CHAMPION JOINTINGS PRIVATE LIMITED",
"CHAMPION OM DEV CONSTRUCTION LIMITED",
"CHAMPION PACKAGING INDUSTRIES PRIVATE LIMITED",
"CHAMPION PAINTS PVT LTD",
"CHAMPION PLASTICS INDIA PRIVATE LIMITED",
"CHAMPION REFRATECH PRIVATE LIMITED",
"CHAMPION ROLLING MILL PRIVATE LIMITED",
"CHAMPION SEALS (INDIA) PRIVATE LIMITED",
"CHAMPION SEALS AND PACKINGS PRIVATE LIMITED",
"CHAMPION SOFTWARE TECHNOLOGIES LIMITED",
"CHAMPION TANNERY PRIVATE LIMITED",
"CHAMPION TRAVEL & TOUR PRIVATE LIMITED",
"CHAMPION YATAYAT PRIVATE LIMITED",
"CHAMPIONN GYM FITNESS EQUIPMENTS PRIVATE LIMITED",
"CHAMPIONS YACHT CLUB PRIVATE LIMITED",
"CHAMPIONX DAI-ICHI INDIA PRIVATE LIMITED",
"CHAMPIONX ENERGY INDIA PRIVATE LIMITED",
"CHAMPO CARPET",
"CHAMPS EDUCARE PRIVATE LIMITED",
"CHAMRAIL HIGH SCHOOL",
"CHAMRIA CREATION PRIVATE LIMITED",
"CHAMRIA SILK MILLS PRIVATE LIMITED",
"CHAMUNDA AGRO PRIVATE LIMITED",
"CHAMUNDA ELECTRICAL PRIVATE LIMITED",
"CHAMUNDA FORGINGS PRIVATE LIMITED",
"CHAMUNDA HEALTH CARE PRIVATE LIMITED",
"CHAMUNDA INFRASTRUCTURE LIMITED",
"CHAMUNDA LASSI PRIVATE LIMITED",
"CHAMUNDA PAPERS PRIVATE LIMITED",
"CHAMUNDA PLASTIC PRIVATE LIMITED",
"CHAMUNDA SYNTHETICS PVT LTD",
"CHAMUNDA TECH-NET SERVICES PRIVATE LIMITED",
"CHAMUNDESHWARI ELECTRICITY SUPPLY CORPORATION LIMITED",
"CHAMUNDESHWARI¬† AGENCIES",
"CHAMUNDESWARI BUILD-TECH PRIVATE LIMITED",
"CHAMUNDESWARI ENTERPRISES PRIVATE LIMITED",
"CHAMUNDI DIE CAST PRIVATE LIMITED",
"CHAMUNDI ESTATES PVT LTD",
"CHAMUNDI EXPLOSIVES PVT LTD",
"CHAMUNDI EXTRUSIONS PRIVATE LIMITED",
"CHAMUNDI POWER CONTROLS PRIVATE LIMITED",
"CHAMUNDI TEXTILE SILK MILLS LIMITED.",
"CHAMURCHI AGRO(INDIA) LTD",
"CHANAB ENGINEERS PRIVATE LIMITED",
"CHANAKYA BAKERY PRODUCTS PRIVATE LIMITED",
"CHANAKYA CORPORATE SERVICES PRIVATE LIMITED",
"CHANAKYA DAIRY PRODUCTS PRIVATE LIMITED",
"CHANAKYA DEFENCE COLLEGE PRIVATE LIMITED",
"CHANAKYA FOUNDATION",
"CHANAKYA GLOBAL ACADEMY",
"CHANAKYA INFRAHEIGHTS PRIVATE LIMITED",
"CHANAKYA INSTITUTE PRIVATE LIMITED",
"CHANAKYA INTERNATIONAL PRIVATE LIMITED.",
"CHANAKYA NIRMAN PRIVATE LIMITED",
"CHANAKYA TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"CHANAKYA TECHNOS PRIVATE. LIMITED.",
"CHANAKYA WEAVETECH PRIVATE LIMITED",
"CHANAN COMPONENTS PRIVATE LIMITED",
"CHANAN FABRICATIONS PRIVATE LIMITED",
"CHANAN FASTENERS PRIVATE LIMITED",
"CHANASYA KARLE INFRATECH PRIVATE LIMITED",
"CHANCELLOR ELEVATOR INDIA PRIVATE LIMITED",
"CHANCHAL INFRASTRUCTURE PRIVATE LIMITED",
"CHANCHAL PACKAGERS PRIVATE LIMITED",
"CHANCHAL REALTY PRIVATE LIMITED",
"CHAND AGRO PRIVATE LIMITED",
"CHAND FRUIT COMPANY PRIVATE LIMITED",
"CHAND GLOBAL FUEL (INDIA) PRIVATE LIMITED",
"CHAND NAGAR PARISHAD",
"CHAND SHEETALAYA PRIVATE LIMITED",
"CHAND TARA URDU PRIMARY SCHOOL SOLAPUR",
"CHANDA & CO (ENGINEERING) PVT LTD",
"CHANDA ENTERPRISES PVT LTD",
"CHANDA INVESTMENT AND TRADING COMPANY PRIVATE LIMITED",
"CHANDA ROLLER FLOUR MILLS PRIVATE LIMITED",
"CHANDA STEEL WORKS PRIVATE LIMITED",
"CHANDA YARNS PRIVATE LIMITED",
"CHANDAK BROTHERS",
"CHANDAK CHAI PRIVATE LIMITED",
"CHANDAK CRITICAL CARE HOSPITAL I C C U",
"CHANDAK FOOD PRODUCTS PRIVATE LIMITED",
"CHANDAK FOODS AND BEVERAGES PRIVATE LIMITED",
"CHANDAK GROUP",
"CHANDAK LABORATORIES PRIVATE LIMITED",
"CHANDAK MARBLES PRIVATE LIMITED",
"CHANDAK SPINNING PRIVATE LIMITED",
"CHANDAK TEXTILES PRIVATE LIMITED",
"CHANDAK WOOLLENS PVT. LTD",
"CHANDAN BRIGHT BARS PRIVATE LIMITED",
"CHANDAN COLD STORAGE PRIVATE LIMITED",
"CHANDAN DENTAL PRIVATE LIMITED",
"CHANDAN DIAMOND TOOLS PRIVATE LIMITED",
"CHANDAN FASHIONS PRIVATE LIMITED",
"CHANDAN GINNING AND PRESSING FACTORY PRIVATE LIMITED",
"CHANDAN HEALTHCARE LIMITED",
"CHANDAN HOSPITAL LIMITED",
"CHANDAN INTERMEDIATES AND CHEMICALS PRIVATE LIMITED",
"CHANDAN LITES PRIVATE LIMITED",
"CHANDAN METAL PRODUCTS PRIVATE LIMITED",
"CHANDAN NEURO SCIENCES HOSPITAL",
"CHANDAN PHARMACY LIMITED",
"CHANDAN ROADWAYS PVT LTD",
"CHANDAN SALT WORKS PVT LTD",
"CHANDAN SHEETGRAH PRIVATE LIMITED",
"CHANDAN SINGH INFRASTRUCTURE PRIVATE LIMITED",
"CHANDAN STEEL LIMITED",
"CHANDAN TECH SOLUTIONS PRIVATE LIMITED",
"CHANDAN TRADING COMPANY PRIVATE LIMITED",
"CHANDAN TRANS-CONS PRIVATE LIMITED",
"CHANDAN UDYOG PRIVATE LIMITED",
"CHANDAN YADAV GROUP PRIVATE LIMITED",
"CHANDANA AGRO TECH PRIVATE LIMITED",
"CHANDANA BROTHERS JEWELLERS (KAKINADA) P RIVATE LIMITED",
"CHANDANA BROTHERS MULTICOMPLEX PRIVATE LIMITED",
"CHANDANA BROTHERS TEX AND JEW P LIMITED",
"CHANDANA FASHION PRIVATE LIMITED",
"CHANDANA INFRACON PRIVATE LIMITED",
"CHANDANA RAMESH JEWELLERS AND TEXTILES PRIVATE LIMITED",
"CHANDANBARI TEA PRODUCT PRIVATE LIMITED",
"CHANDANKAR ENGINEERING AND RESEARCH PRIVATE LIMITED",
"CHANDANMAL BOTHARA JEWELLERS PRIVATE LIMITED",
"CHANDANPANI PRIVATE LIMITED",
"CHANDANTARA COMMERCIAL PRIVATE LIMITED",
"CHANDAR LOGISTICS AND TRADING COMPANY (INDIA) PRIVATE LIMITED",
"CHANDARANA INTERMEDIARIES BROKERS PRIVATE LIMITED",
"CHANDARANA SECURITIES PRIVATE LIMITED",
"CHANDAWAT UDYOG CYLINDERS LIMITED",
"CHANDBAGH INVESTMENTS LIMITED",
"CHANDEKAR BUSINESS MEDIA PRIVATE LIMITED",
"CHANDEL AUTOMOTIVES PRIVATE LIMITED",
"CHANDEL COLD STORAGE PRIVATE LIMITED",
"CHANDEL INFRASOLUTION PRIVATE LIMITED",
"CHANDEL PHARMACEUTICALS",
"CHANDER BHAN JAIN INTERNATIONAL PRIVATE LIMITED",
"CHANDER BHAN JEWELER PRIVATE LIMITED",
"CHANDER BHAN OILS PRIVATE LIMITED",
"CHANDER BHAN SHIV NARAIN TALWAR JEWELLERS PRIVATE LIMITED",
"CHANDER PRAKASH TEXFAB PRIVATE LIMITED",
"CHANDER SHAKHER AZAD HR SEC SCHOOL",
"CHANDER TEXFAB PRIVATE LIMITED",
"CHANDERNAGORE LALBAGAN BALIKA VIDYALAYA",
"CHANDERNAGORE MUNICIPAL CORPORATION",
"CHANDERPUR INDUSTRIE PRIVATE LIMITED",
"CHANDERPUR RENEWAL POWER COMPANY PRIVATE LIMITED",
"CHANDERPUR WORKS PRIVATE LIMITED",
"CHANDERSHEEL COAL & ENERGY PRIVATE LIMITED",
"CHANDESWARI SHEETGRAH PRIVATE LIMITED",
"CHANDGI RAM REAL ESTATE CONSULTANTS PRIVATE LIMITED",
"CHANDGOTHIA METALS PRIVATE LIMITED",
"CHANDHOK TEXTILES ENTERPSIES PRIVATE LTD.",
"CHANDI BATTERIES PRIVATE LIMITED",
"CHANDI CHARAN COLD STORAGE PRIVATE LIMITED",
"CHANDI CRANES PRIVATE LIMITED",
"CHANDI MATA COLD STORAGE PRIVATE LIMITED",
"CHANDIGARH ADMINSTRATION",
"CHANDIGARH AGRI TECH PRIVATE LIMITED",
"CHANDIGARH CASTINGS PRIVATE LIMITED",
"CHANDIGARH CLINICAL LABORATORIES PRIVATE LIMITED",
"CHANDIGARH COLONISERS PRIVATE LIMITED",
"CHANDIGARH DISTILLERS & BOTTLERS LIMITED",
"CHANDIGARH DISTILLERS & SERVICES PRIVATE LIMITED",
"CHANDIGARH FIRE AND SAFETY EQUIPMENTS PRIVATE LIMITED",
"CHANDIGARH GROUP OF COLLEGES",
"CHANDIGARH HEALTHCARE PRIVATE LIMITED",
"CHANDIGARH HOUSING BOARD",
"CHANDIGARH INDUSTRIAL & TOURISM DEVELOPMENT CORPORATION LIMITED",
"CHANDIGARH INKS PRIVATE LIMITED",
"CHANDIGARH INTERNATIONAL AIRPORT LIMITED",
"CHANDIGARH LIFT AND SHIFT SYSTEMS PRIVATE LIMITED",
"CHANDIGARH MUSIC CENTRE PRIVATE LIMITED",
"CHANDIGARH ROLLER FLOUR MILLS PRIVATE LIMITED",
"CHANDIGARH ROYALE CITY PROMOTERS PRIVATE LIMITED",
"CHANDIGARH SOFTECH PRIVATE LIMITED",
"CHANDIGARH SPINNING MILLS LTD",
"CHANDIGARH SWEETS LIMITED",
"CHANDIGARH TEXTILES PVT LTD",
"CHANDIGARH TRANSPORT UNION CTU",
"CHANDIGARH UNIVERSITY",
"CHANDIGARH WIRES PVT LTD",
"CHANDIGARH ZINC AND RESIDUES PVT LTD",
"CHANDIGARH-ROHANDA GPUNDERBARASAT-II BLOCK",
"CHANDIKA DEALER PRIVATE LIMITED",
"CHANDIKA PRESS PRIVATE LIMITED",
"CHANDIL TRANSMISSION LIMITED",
"CHANDILYA INFRASTRUCTURE LIMITED",
"CHANDIWALA SALES PRIVATE LIMITED",
"CHANDKHEDA ORTHOPAEDIC & SURGICAL HOSPITAL",
"CHANDLA INDUSTRIAL PLASTICS PRIVATE LIMITED",
"CHANDLER AND PRICE INDIA PRIVATE LIMITED",
"CHANDMANI TEA CO LTD",
"CHANDMARI TEA CO PVT LTD",
"CHANDNA INFRAPROJECTS INDIA PRIVATE LIMITED",
"CHANDNA LOGISTICS PRIVATE LIMITED",
"CHANDNA MEDICAL AGENCIES PRIVATE LIMITED",
"CHANDNA SALES PRIVATE LIMITED",
"CHANDNANI ENTERPRISES PRIVATE LIMITED",
"CHANDNI FOREX TOUR PRIVATE LIMITED",
"CHANDNI HOSPITAL PRIVATE LIMITED",
"CHANDNI INDUSTRIES PRIVATE LIMITED",
"CHANDNI MACHINES LIMITED",
"CHANDNI OVERSEAS PRIVATE LIMITED",
"CHANDNI REALTY PRIVATE LIMITED",
"CHANDNI SILK MILLS PRIVATE LIMITED",
"CHANDNI TRAVELS PRIVATE LIMITED",
"CHANDOK AUTOMOTIVE MANUFACTURES LIMITED",
"CHANDOL FARMERS PRODUCER COMPANY LIMITED",
"CHANDPUR DAKSHINPARA F P SCHOOL",
"CHANDPUR ENTERPRISES LIMITED",
"CHANDRA & SONS PVT LTD",
"CHANDRA AGRI IMPLIMENTS PVT LTD",
"CHANDRA AUTOMOBILE INDIA PRIVATE LIMITED",
"CHANDRA AYURVED BHAWAN PRIVATE LIMITED",
"CHANDRA BHAGAT PHARMA LIMITED",
"CHANDRA BROTHERS INFRAVENTURES PRIVATE LIMITED",
"CHANDRA CASHEW IMPORTS AND EXPORTS PRIVATE LIMITED",
"CHANDRA CFS AND TERMINAL OPERATORS PRIVATE LIMITED",
"CHANDRA CHELLAPPAN INTERNATIONAL SCHOOL",
"CHANDRA COAL PRIVATE LIMITED",
"CHANDRA CREATIVE & CONTENT SOLUTIONS PRIVATE LIMITED",
"CHANDRA DARSHAN PROPERTIES PRIVATE LIMITED",
"CHANDRA DEEP FABRICS & STYLE PRIVATE LIMITED",
"CHANDRA DEVBUILD PRIVATE LIMITED",
"CHANDRA DHALL INDUSTRIES PRIVATE LIMITED",
"CHANDRA ELECTRICALS PRIVATE LIMITED",
"CHANDRA ELECTRONIC APPLIANCES PVT LTD",
"CHANDRA ENGINEERING AND EQUIPMENT SERVICES PRIVATE LIMITED",
"CHANDRA ENGINEERING AND MECHANICAL PVT LTD",
"CHANDRA ENTREPRENEURS PRIVATE LIMITED",
"CHANDRA EXHIBITOR PRIVATE LIMITED",
"CHANDRA FABRICS PRIVATE LIMITED",
"CHANDRA HASNI ISPAT PRIVATE LIMITED",
"CHANDRA KALA PRIVATE LIMITED",
"CHANDRA KIRAN LIBERTY HOTELS PRIVATE LIMITED",
"CHANDRA KOSHA KONSTRUCTIONS PRIVATE LIMITED",
"CHANDRA LAKSHMI FRATERNITY FUND PRIVATE LIMITED",
"CHANDRA LAKSHMI SAFETY GLASS PRIVATE LIMITED",
"CHANDRA LAXMI DEVELOPERS PRIVATE LIMITED",
"CHANDRA LAXMI HOSPITAL PRIVATE LIMITED",
"CHANDRA LAXMI JEWELLERS PRIVATE LIMITED",
"CHANDRA LIFE SCIENCES PRIVATE LIMITED",
"CHANDRA LIMES PRIVATE LIMITED",
"CHANDRA MATS PRIVATE LIMITED",
"CHANDRA METALS LIMITED",
"CHANDRA MINING AND CONSTRUCTION PRIVATE LIMITED",
"CHANDRA MINT PRIVATE LIMITED",
"CHANDRA MODERN BUILDERS (INDIA) PRIVATE LIMITED",
"CHANDRA MOTHER & EYE CARE PRIVATE LIMITED",
"CHANDRA MUKHI IMPEX LTD",
"CHANDRA NIRMAN PRIVATE LIMITED",
"CHANDRA OIL & GAS PROJECT SERVICES PRIVATE LIMITED",
"CHANDRA POLYMER PRIVATE LIMITED",
"CHANDRA POLYPLAST PRIVATE LIMITED",
"CHANDRA PRABHU BUILDTECH PRIVATE LIMITED",
"CHANDRA PRABHU INTERNATIONAL LIMITED",
"CHANDRA PRABHU OFFSET PRINTING WORKS PRIVATE LIMITED",
"CHANDRA PRABHU SECURITIES PRIVATE LIMITED",
"CHANDRA PRESSURE VESSELS AND EVAPORATORS PRIVATE LIMITED",
"CHANDRA PUMPS PRIVATE LIMITED",
"CHANDRA SCANS PRIVATE LIMITED",
"CHANDRA SEEDS PRIVATE LIMITED",
"CHANDRA SHEKHAR AZAD UNIVERSITY OF AGRIC",
"CHANDRA SHEKHAR AZAD UNIVERSITY OF AGRICULTURE & TECHNOLOGY",
"CHANDRA SHIP MANAGEMENT PRIVATE LIMITED",
"CHANDRA SILKS PRIVATE LIMITED",
"CHANDRA SINGH CONTRACTORS",
"CHANDRA SPINNING AND WEAVING MILLS PRIVATE LIMITED",
"CHANDRA SUPER SPECIALITY HOSPITAL ANANTAPURAM",
"CHANDRA TECH BUILD INVESTO PVT. LTD.",
"CHANDRA TECHNICAL SERVICES PRIVATE LIMITED",
"CHANDRA TEXTILES PRIVATE LIMITED",
"CHANDRA TOWERS PRIVATE LIMITED",
"CHANDRA TRANSPORT PRIVATE LIMITED",
"CHANDRA TRIO SERVICES PRIVATE LIMITED",
"CHANDRA WOOLLENS PRIVATE LIMITED",
"CHANDRABALI COMMERCIAL I PRIVATE LIMITED",
"CHANDRABHAGA BABURAO TUPE SADHANA KANYA VIDYALAY",
"CHANDRABHAL PROPERTIES PRIVATE LIMITED",
"CHANDRABHAN SHARMA COLLEGE OF ARTS SCIENCE AND COMMERCE",
"CHANDRADEEP BUILDERS PRIVATE LIMITED",
"CHANDRADEV FOODS PRIVATE LIMITED",
"CHANDRAGUPT ICE & COLD STORAGE PRIVATE LIMITED",
"CHANDRAGUPTA TRADERS PRIVATE LIMITED",
"CHANDRAGUPTA TRADERS PRIVATE. LIMITED",
"CHANDRAJYOTI ESTATE DEVELOPERS PRIVATE LIMITED",
"CHANDRAKALA MONEY AND CAPITAL MANAGEMENT LIMITED",
"CHANDRAKALA UNIVERSAL PRIVATE LIMITED",
"CHANDRAKAMAL MILK & MILK PRODUCTS PRIVATE LIMITED",
"CHANDRAKANTA FOODS PRIVATE LIMITED",
"CHANDRAKONA COLD STORAGE PRIVATE LIMITED",
"CHANDRAKUMAR CONSULTING ENGINEERS PRIVATE LIMITED",
"CHANDRALEELA POWER ENERGY PRIVATE LIMITED",
"CHANDRALEKHA CONSTRUCTIONS PRIVATE LIMITED",
"CHANDRALOK RESIDENCY PRIVATE LIMITED",
"CHANDRALOK SHEETALAYA PRIVATE LIMITED",
"CHANDRALOP FIRE SAFETY PRIVATE LIMITED",
"CHANDRAMANOHAR DISTRIBUTORS PRIVATE LIMITED",
"CHANDRAMATHY AMMA MEMORIAL HOSPITAL",
"CHANDRAMAULI COTTON PRIVATE LIMITED",
"CHANDRAMAULI MOTORS PRIVATE LIMITED",
"CHANDRAMMA EDUCATIONAL SOCIETY",
"CHANDRAMOHAN FOUNDATION",
"CHANDRAMOULI OIL AND ENGINEERING PRIVATE LIMITED",
"CHANDRAMUKHI COMMODITIES PRIVATE LIMITED",
"CHANDRANCHAL BK INDUSTRIES PRIVATE LIMITED",
"CHANDRANCHAL EFFORTS PRIVATE LIMITED",
"CHANDRANCHAL ENTERPRISE PRIVATE LIMITED",
"CHANDRANCHAL INFRASTURCTURE PRIVATE LIMITED",
"CHANDRANI COMPLIMENTS & EXPORT PVT. LTD.",
"CHANDRANI ENTERPRISES PRIVATE LIMITED",
"CHANDRANI PEARLS PRIVATE LIMITED",
"CHANDRAPAL POLYMERS PRIVATE LIMITED",
"CHANDRAPLUS INSTITUTE AND COACHING PRIVATE LIMITED",
"CHANDRAPORE & HEGGDLOO ESTATE",
"CHANDRAPRABHA PUBLIC SCHOOL",
"CHANDRAPRABHU BUILDWELL PRIVATE LIMITED",
"CHANDRAPRABHU ENTERPRISE PRIVATE LIMITED",
"CHANDRAPRABHU INDUSTRIES PRIVATE LIMITED",
"CHANDRAPRABHU TRADELINK PRIVATE LIMITED",
"CHANDRAS CHEMICAL ENTERPRISES PRIVATE LIMITED",
"CHANDRA'S CHEMICAL INDUSTRIES (1973) PVT LTD",
"CHANDRAS GREEN PROJECT LTD.",
"CHANDRAS' REALTOR PVT LTD",
"CHANDRASEKAR BUILDERS PRIVATE LIMITED",
"CHANDRASEKHARA PHARMA PRIVATE LIMITED",
"CHANDRASHEEL CASTINGS PRIVATE LIMITED",
"CHANDRASHEKHAR EXPORTS PRIVATE LIMITED",
"CHANDRAUDAI AUTOMOBILES PRIVATE LIMITED",
"CHANDRAUDYA DYEING & PROCESSING PRIVATE LIMITED",
"CHANDRAVADHANAM EDUCATIONAL TRUST",
"CHANDRAVANSHI CHANDEL COLD STORAGE PRIVATE LIMITED",
"CHANDRAVANSHI REALITY PRIVATE LIMITED",
"CHANDRAVARSHA TRADERS PRIVATE LIMITED",
"CHANDRAWATI CONSTRUCTION PRIVATE LIMITED",
"CHANDRAWATI FREIGHT CARRIER PRIVATE LIMITED",
"CHANDRAWATI HOSPITALITY AND TOURISM",
"CHANDRAWATI RICE MILLS PRIVATE LIMITED",
"CHANDRESH CABLES LIMITED",
"CHANDRESH FINANCE LIMITED",
"CHANDRESH MARKETING PRIVATE LIMITED",
"CHANDRESH SHIPPING AGENCY PRIVATE LIMITED",
"CHANDRI PAPER & ALLIED PRODUCTS PRIVATE LIMITED",
"CHANDRI WAX SPECIALITIES PRIVATE LIMITED",
"CHANDRIKA BEEDI COMPANY PRIVATE LIMITED",
"CHANDRIKA DEVI MA PROPERTIES PRIVATE LIMITED",
"CHANDRIMA MERCANTILES LTD",
"CHANDRIMA TREXIM PVT. LTD.",
"CHANDRODAY SALES & SERVICES PVT LTD",
"CHANDRODAYA AYU PHARMA PRIVATE LIMITED",
"CHANDU KAKASHRI JEWELLERS PRIVATE LIMITED",
"CHANDU LAL VED PARKASH PRIVATE LIMITED",
"CHANDUKA HI-TECH STEELS PRIVATE LIMITED",
"CHANDUKA MINERALS AND CHEMICALS PRIVATE LIMITED",
"CHANDUKAKA SARAF AND SONS PRIVATE. LIMITED",
"CHANDULAL CHAGANLA POBARU TOBACCO PRODUCTS PRIVATE LIMITED",
"CHANDURKAR INVESTMENTS PVT LTD",
"CHANDUSOFT TECHNOLOGIES PRIVATE LIMITED",
"CHANDWASIA EXIM PRIVATE LIMITED",
"CHANEPH BUSINESS SOLUTION PRIVATE LIMITED",
"CHANEYCO REFRATECH PRIVATE LIMITED",
"CHANG CHUN CHEMICAL INDIA PRIVATE LIMITED",
"CHANG HOTELS PRIVATE LIMITED",
"CHANGE ALLIANCE PRIVATE LIMITED",
"CHANGEDIYA OUTDOOR ADVERTISING PRIVATE LIMITED",
"CHANGEJAR TECHNOLOGIES PRIVATE LIMITED",
"CHANGEMASTERS MANAGEMENT CONSULTING PRIVATE LIMITED",
"CHANGEPOND TECHNOLOGIES PRIVATE LIMITED",
"CHANGER VIDYUT KRANTI PRIVATE LIMITED",
"CHANGFANG SEMICONDUCTOR PRIVATE LIMITED",
"CHANGHONG ELECTRIC INDIA PRIVATE LIMITED",
"CHANGING TREE COMMUNICATIONS PRIVATE LIMITED",
"CHANGLANG PLYWOODS PVT LTD",
"CHANGO YANGTHANG HYDRO POWER LIMITED",
"CHANGODAR METALS PRIVATE LIMITED",
"CHANGU KANA THAKUR VIDYALAYA NEW PANVEL",
"CHANGZHENG BMR REFRIGERATION TECHNOLOGY PRIVATE LIMITED",
"CHANGZHOU HAIJI INDIA PRIVATE LIMITED",
"CHANIYA IMPEX PRIVATE LIMITED",
"CHANKYA E-SERVICES PRIVATE LIMITED",
"CHANLONG MANUFACTURING & TRADING PRIVATE LIMITED",
"CHANNA ANGERBERIA F P SCHOOL",
"CHANNABASWESHWAR PHARMACY COLLEGE",
"CHANNAMALLIKARJUN BUILDCON PRIVATE LIMITED",
"CHANNEL 2001 INDIA PRIVATE LIMITED",
"CHANNEL B ENTERTAINMENT",
"CHANNEL BRIDGE SOFTWARE LABS PRIVATE LIMITED",
"CHANNEL FOODS PRIVATE LIMITED",
"CHANNEL FREIGHT SERVICES INDIA PRIVATE LIMITED",
"CHANNEL HEALTH INFRATEK PRIVATE LIMITED",
"CHANNEL III INTERNET PRIVATE LIMITED",
"CHANNEL INFECTION CONTROL SOLUTIONS PRIVATE LIMITED",
"CHANNEL MASTER PRIVATE LIMITED",
"CHANNEL PACKAGING PRIVATE LIMITED",
"CHANNEL PLASTICS PRIVATE LIMITED",
"CHANNEL TECHNOLOGIES PRIVATE LIMITED",
"CHANNEL VENTURES PRIVATE LIMITED",
"CHANNEL WEB CONSULTING PRIVATE LIMITED",
"CHANNELMAX IT SOLUTIONS PRIVATE LIMITED",
"CHANNELONE OUTSOURCING PRIVATE LIMITED",
"CHANNELPLAY LIMITED",
"CHANNELPLUS DISTRIBUTION PRIVATE LIMITED",
"CHANNELSALE SOFTWARE SERVICES PRIVATE LIMITED",
"CHANNELSOFT IT SERVICES PRIVATE LIMITED",
"CHANNI CARPETS AND TEXTILES PRIVATE LIMITED",
"CHANRALOK POLYSTER PRIVATE LIMITED",
"CHANRE RHEUMATOLOGY AND IMMUNOLOGY CENTER AND RESEARCH PRIVATE LIMITED",
"CHANS TEQ INDIA PRIVATE LIMITED",
"CHANSMA NAGARPALIKA",
"CHANSON CAR AT CALL PRIVATE LIMITED",
"CHANSON MOTORS PRIVATE LIMITED.",
"CHANSON SHIPPING AND PACKING CO PVT LTD",
"CHANVIM ENGINEERING INDIA PRIVATE LIMITED",
"CHANVIM PLASTICS PRIVATE LIMITED",
"CHAO SATI YARNS PRIVATE LIMITED",
"CHAOS CONTROL CAFE",
"CHAOS DESIGN PRIVATE LIMITED",
"CHAPERON SECURITY SERVICES PRIVATE LIMITED",
"CHAPHEKAR ENGINEERING PRIVATE LIMITED",
"CHAPHEKAR SUSPENSIONS PRIVATE LIMITED",
"CHAPLOT INVESTMENTS PRIVATE LIMITED",
"CHAPPALY INDUSTRIES PRIVATE LIMITED",
"CHAPRI RESORTS AND HOTELS PRIVATE LIMITED",
"CHAPTER FIVE BRAND SOLUTIONS PRIVATE LIMITED",
"CHAPTER TWO FOUR SEVEN INFOTECH PRIVATE LIMITED",
"CHAQUE JOUR HR SERVICES PRIVATE LIMITED",
"CHAQUE JOUR OUTSOURCING SOLUTIONS PRIVATE LIMITED",
"CHAR CHINAR DESIGNER SHEETS PRIVATE LIMITED",
"CHARA TECHNOLOGIES PRIVATE LIMITED",
"CHARAK AYURVEDIC MEDICAL COLLEGE",
"CHARAK COLLG OF PHARMACY & RESEARCH",
"CHARAK GLOBAL IT SOLUTIONS PRIVATE LIMITED",
"CHARAK HOSPITAL AND RESEARCH CENTRE",
"CHARAK PHARMA PRIVATE LIMITED",
"CHARAKDHAR DIAGNOSTICS PRIVATE LIMITED",
"CHARAKDHAR HEALTH SERVICES PRIVATE LIMITED",
"CHARAM TECHNO CHEMICAL AND EQUIPMENTS PRIVATE LIMITED",
"CHARAN BIOTECH PRIVATE LIMITED",
"CHARAN FLOUR MILL PRIVATE LIMITED",
"CHARAN GUPTA CONSULTNAT PRIVATE LIMITED",
"CHARAN INDUSTRIAL PACKAGERS PRIVATE LIMITED",
"CHARAN LABORATORIES PRIVATE LIMITED",
"CHARAN MAHADEO CONSTRUCTION PRIVATE LIMITED",
"CHARAN SAFE WORKS PRIVATE LIMITED",
"CHARAN SINGH HARYANA AGRICULTURAL UNIVERSITY",
"CHARAN STEEL TUBES PRIVATE LIMITED",
"CHARAN WINDOWS PRIVATE LIMITED",
"CHARANJEET ASSOCIATES PRIVATE LIMITED",
"CHARANKATTU COIR MANUFACTURING CO PVT LTD",
"CHARANSHEELA ADVISORY PRIVATE LIMITED",
"CHARBHUJA AGARBATTI COMPANY PRIVATE LIMITED",
"CHARBHUJA AGROCHEM PRIVATE LIMITED",
"CHARBHUJA COTTON PRIVATE LIMITED",
"CHARBHUJA FRAGRANCE PRIVATE LIMITED",
"CHARBHUJA GEMS AND JEWELLERS PRIVATE LIMITED",
"CHARBHUJA GRANITES PRIVATE LIMITED",
"CHARBHUJA ISPAT (INDIA) PRIVATE LIMITED",
"CHARBHUJA MARMO (INDIA) PRIVATE LIMITED",
"CHARBHUJA PEARLS (INDIA) PRIVATE LIMITED",
"CHARBHUJA SYNTEX PRIVATE LIMITED",
"CHARCHCO ELECTRONICS INDIA PRIVATE LIMITED",
"CHARCHIT APPARELS PRIVATE LIMITED",
"CHARCHIT MARKETING PRIVATE LIMITED",
"CHARCOALEATS FOODTECH PRIVATE LIMITED",
"CHARDIKALA PRINTINTG PRESS PRIVATE LIMITED",
"CHARDIKLA TIME TV PRIVATE LIMITED",
"CHARGEBACK GURUS FINTECH PRIVATE LIMITED",
"CHARGEBEE TECHNOLOGIES PRIVATE LIMITED",
"CHARGEPOINT TECHNOLOGIES INDIA PRIVATE LIMITED",
"CHARGEWAVE ENERGYKEM P LIMITED",
"CHARGOLA TEA CO PVT LTD",
"CHARIOT BEACH RESORT",
"CHARIOT COMPONENTS PRIVATE LIMITED",
"CHARIOT INTERNATIONAL PRIVATE LIMITED",
"CHARIOT PRODUCTIONS MEDIA PRIVATE LIMITED",
"CHARIOT PROPERTIES LLP",
"CHARIOT STEEL & POWER PRIVATE LIMITED",
"CHARIOT WORLD TOURS LIMITED",
"CHARIS IMPEX PRIVATE LIMITED",
"CHARIS INDIA CARE FOUNDATION (UNDER SECTION 25)",
"CHARIS SOFTWARE PRIVATE LIMITED",
"CHARISHMA HOTELS PRIVATE LIMITED",
"CHARISMA APPARELS IMPEX PRIVATE LIMITED",
"CHARISMA BUILDERS",
"CHARISMA GOLDWHEELS PRIVATE LIMITED",
"CHARISMA JEWELLERY PRIVATE LIMITED",
"CHARIT ENGINEERING PRIVATE LIMITED",
"CHARITA TECHNOCENTRA PRIVATE LIMITED",
"CHARITH ENTERPRISES PRIVATE LI",
"CHARITH INFRASTRUCTURE PRIVATE. LIMITED.",
"CHARITON RESEARCH INSTITUTE PRIVATE LIMITED",
"CHARITY COMMISSIONER OFFICE",
"CHARIVUPURAM RUBBERS PRIVATE LIMITED",
"CHARKHA INDUSTRIES PRIVATE LIMITED",
"CHARLANE TRADING PRIVATE LIMITED",
"CHARLENE HOSPITALITY SERVICES PRIVATE LIMITED",
"CHARLES COMMERCIAL PVT LTD",
"CHARLES FIBRES PRIVATE LIMITED",
"CHARLES RIVER LABORATORIES INDIA PRIVATE LIMITED",
"CHARLEY KNITWEARS PRIVATE LIMITED",
"CHARLIE FREIGHT SYSTEMS PRIVATE LIMITED",
"CHARLY FISHERIES",
"CHARM ENGITECH PRIVATE LIMITED",
"CHARM HEALTHCARE PRIVATE LIMITED",
"CHARM INFO SYSTEMS PRIVATE LIMITED",
"CHARM LOGISTICS PRIVATE LIMITED",
"CHARMACY INDIA PRIVATE LIMITED",
"CHARMDELGADO HEALTH CARE PRIVATE LIMITED",
"CHARMI ALUMINIUM PRIVATE LIMITED",
"CHARMI TECHNO SERVICES PRIVATE LIMITED",
"CHARMINAR BOTTLING COMPANY PRIVATE LIMITED",
"CHARMINAR FOODS AND EXPORTS PRIVATE LIMITED",
"CHARMING APPARELS PRIVATE LIMITED",
"CHARMING PRINTING AND GRPHICS PRIVATE LIMITED",
"CHARMING TRIM INDIA PRIVATE LIMITED",
"CHARMONDAL CMPPBK FULMOHAN HIGH SCHOOL",
"CHARMS AGENCIES PRIVATE LIMITED",
"CHARMS CHEM PRIVATE LIMITED",
"CHARMS INDIA PRIVATE LIMITED",
"CHARNOCK EQUIPMENTS PRIVATE LIMITED",
"CHARNOCK HEALTHCARE INSTITUTE",
"CHARNOCK HOSPITALS PRIVATE. LIMITED.",
"CHAROEN POKPHAND SEEDS INDIA PRIVATE LIMITED",
"CHAROEN POKPHAND TRADING (INDIA) PRIVATE LIMITED",
"CHAROTAR GAS SAHAKARI MANDLI LIMITED",
"CHAROTAR UNIVERSITY OF SCIENCE AND TECHNOLOGY",
"CHARRING CROSS HOTELS PRIVATE LIMITED",
"CHARRING CROSS NURSING HOME PRIVATE LIMITED",
"CHARTER BPO SOLUTIONS PRIVATE LIMITED",
"CHARTER COMMUNICATIONS INC.",
"CHARTER GLOBAL TECHNOLOGIES PRIVATE LIMITED",
"CHARTER SCHOOL FOR EDUCATION AND RESEARCH",
"CHARTERED AUTO COMPONENTS PRIVATE LIMITED",
"CHARTERED AUTOZONE PRIVATE LIMITED",
"CHARTERED BIKE PRIVATE LIMITED",
"CHARTERED BUS PRIVATE LIMITED",
"CHARTERED CAPITAL AND INVESTMENT LIMITED",
"CHARTERED FINANCE & LEASING LTD.",
"CHARTERED FINANCE MANAGEMENT PRIVATE LIMITED",
"CHARTERED FORENSIC INVESTIGATORS PRIVATE LIMITED",
"CHARTERED GOLD FINANCIAL SERVICES PRIVATE LIMITED",
"CHARTERED GREENTECH PRIVATE LIMITED",
"CHARTERED HAMPI HOTELS PRIVATE LIMITED",
"CHARTERED HOTELS PRIVATE LIMITED",
"CHARTERED HOUSING PRIVATE LIMITED",
"CHARTERED INFORMATION SYSTEM PRIVATE LIMITED",
"CHARTERED LOGISTICS LIMITED",
"CHARTERED MOTORS PRIVATE LIMITED",
"CHARTERED SPEED LIMITED",
"CHARU AGROPLAST PRIVATE LIMITED",
"CHARU APPEAREL MANUFACTURING CO PRIVATE LIMITED",
"CHARU FISCAL SERVICES LIMITED",
"CHARU INFOTECH PRIVATE LIMITED",
"CHARU INNOVATIONS PRIVATE LIMITED",
"CHARU JEWELS",
"CHARU MERCHANDISING PRIVATE LIMITED",
"CHARU MINDWORKS (INDIA) PRIVATE LIMITED",
"CHARU MOTORS PRIVATE LIMITED",
"CHARU OVERSEAS PRIVATE LIMITED",
"CHARUCHANDRA COLLEGE",
"CHARUTAR AROGYA MANDAL",
"CHARUTAR VIDHYA MANDAL",
"CHARUTAR VIDYAMANDAL",
"CHARUVI DESIGN LABS PRIVATE LIMITED",
"CHARVAK TRADING PRIVATE LIMITED",
"CHARY PUBLICATIONS PRIVATE LIMITED",
"CHARYS INVESTMENTS PRIVATE LIMITED",
"CHARZE INDUSTRIES PRIVATE LIMITED",
"CHAS ENVIRO PRIVATE LIMITED",
"CHASE AVIAN COMMUNICATIONS PRIVATE LIMITED",
"CHASE BRIGHT STEEL LIMITED",
"CHASE DETECTIVE AND SECURITY AGENCY PRIVATE LIMITED",
"CHASE FLY FINCOM PRIVATE LIMITED",
"CHASE LIFESTYLE PRIVATE LIMITED",
"CHASE LOGISTICS PRIVATE LIMITED",
"CHASE MARKETING PRIVATE LIMITED",
"CHASE RESOURCE MANAGEMENT PTE LIMITED",
"CHASER FINANCIAL SERVICES PRIVATE LIMITED",
"CHASER TECHNOLOGIES PRIVATE LIMITED",
"CHASHMITA ENGINEERS PVT LTD",
"CHASKAMAN PROJECT DIVISION",
"CHASS ENGINEERS PRIVATE LIMITED",
"CHASTECH DIGITAL PRIVATE LIMITED",
"CHASTER IT SOLUTIONS PRIVATE LIMITED",
"CHASYS AUTOMOTIVE COMPONENTS PRIVATE LIMITED",
"CHATAK AGRO (INDIA) PRIVATE LIMITED",
"CHATARPURA TOURS AND TRAVELS PRIVATE LIMITED",
"CHATAVADA PRIMARY SCHOOL",
"CHATBUSTERS",
"CHATE TUTORIALS PRIVATE LIMITED",
"CHATHA ELECTRICALS PRIVATE LIMITED",
"CHATHA FOODS LIMITED",
"CHATHA FOODS PRIVATE LIMITED",
"CHATHUR REALTORS PRIVATE LIMITED",
"CHATLY ESTATE PRIVATE LIMITED",
"CHATOUS TECHNOLOGIES INDIA PRIVATE LIMITED",
"CHATPAY COMMERCE PRIVATE LIMITED",
"CHATRABHUJ NARSEE SCHOOL",
"CHATRAD COLD STORAGE PRIVATE LIMITED",
"CHATRAPATI MULTISTATE CO.CREDIT SOCIETY LTD",
"CHATRAPATI MULTISTATE CO-OPERATIVE CREDIT SOCIETY LTD",
"CHATRAPATI RAJARSHI SHAHU MAHARAJ VIDYALAYA BELVALI",
"CHATRAPATI SAMBHAJI MAHARAJ FARMER PRODUCER COMPANY LIMITED",
"CHATRAPATI SHAHU VIDYALAYA NITHUR",
"CHATRATH CAPITAL SERVICES PRIVATE LIMITED",
"CHATTA SUBID ALI INSTITUTE",
"CHATTARPUR OCCASION PRIVATE LIMITED",
"CHATTARY AJWAN INFOTECH PRIVATE LIMITED",
"CHATTEL CONSTRUCTIONS PRIVATE. LIMITED.",
"CHATTELS PROPERTY MANAGEMENT PRIVATE LIMITED",
"CHATTERBOX TECHNOLOGIES PRIVATE LIMITED",
"CHATTERJEE CARRIERS PVT LTD",
"CHATTERJEE CLEANING ARTS SERVICES LIMITED",
"CHATTERJEE CLEANING ARTS SERVICES PRIVATE LIMITED",
"CHATTERJEE MANAGEMENT SERVICES PVT LTD",
"CHATTERJEE ROADWAYS PRIVATE LIMITED",
"CHATTISGARH EARTH MOVERS PRIVATE LIMITED",
"CHATTISGARH HOUSING BOARD DIVISION-3",
"CHATTISGARH POWER & COAL BENEFICATION LT",
"CHATTISGARH PROJECTS INDIA PRIVATE LIMITED",
"CHATTISGARH REAL ESTATE PRIVATE LIMITED",
"CHATUBHUJ AND COMPANY",
"CHATUR BHUJ VARK WALA PRIVATE LIMITED",
"CHATUR ENTERPRISES PRIVATE LIMITED",
"CHATUR KNOWLEDGE NETWORKING PRIVATE LIMITED",
"CHATUR PROPERTIES PRIVATE LIMITED",
"CHATURBHUJ INFRASTRUCTRE INDIA PRIVATE LIMITED",
"CHATURBHUJ LOGISTICS PRIVATE LIMITED",
"CHATURI IMPEX LLP",
"CHATURVED MAHILA SHILP VIDYALAYA",
"CHATURVEDI & SHAH CONSULTING LLP",
"CHATURVEDI & SHAH LLP",
"CHATURYA SKILLS PRIVATE LIMITED",
"CHATWANI IMPEX PRIVATE LIMITED",
"CHAUDHARANA IRON TRADERS PRIVATE LIMITED",
"CHAUDHARI FUTURETECH PRIVATE LIMITED",
"CHAUDHARI LIFESTYLE PRIVATE LIMITED",
"CHAUDHARI MARINE PRODUCTS PRIVATE LIMITED",
"CHAUDHARY AGRICULTURE SERVICES PRIVATE LIMITED",
"CHAUDHARY CHARAN SINGH MAHAVIDYALAYA",
"CHAUDHARY COLONISERS PRIVATE LIMITED",
"CHAUDHARY CONSTRUCTION COMPANY PRIVATE LIMITED",
"CHAUDHARY CRANES PRIVATE LIMITED",
"CHAUDHARY EDIBLES PRIVATE LIMITED",
"CHAUDHARY ENGTECH SERVICES INDIA PRIVATE LIMITED",
"CHAUDHARY ENTERPRISES TURNKEY INDIA PRIVATE LIMITED",
"CHAUDHARY FOREX PRIVATE LIMITED",
"CHAUDHARY GLASS COMPANY PRIVATE LIMITED",
"CHAUDHARY INDUSTRIAL PROJECTS PRIVATE LIMITED",
"CHAUDHARY IRON CO PVT LTD",
"CHAUDHARY JAI RAM COLD STORAGE PRIVATE LIMITED",
"CHAUDHARY LABELS PRIVATE LIMITED",
"CHAUDHARY MOTORS PRIVATE LIMITED",
"CHAUDHARY NURSING HOME PRIVATE LIMITED",
"CHAUDHARY RICE MILLS",
"CHAUDHARY ROAD CARRIERS PRIVATE LIMITED",
"CHAUDHARY SALES AGENCY",
"CHAUDHARY SOLVEX PRIVATE LIMITED",
"CHAUDHARY TEA PROCESSORS AND PACKERS PRIVATE LIMITED",
"CHAUDHARY TIMBER INDUSTRIES PRIVATE LIMITED",
"CHAUDHARY VENTURES PRIVATE LIMITED",
"CHAUDHRI HOTELS AND RESTAURANTS PRIVATE LIMITED",
"CHAUDHRY AND SONS (FORGINGS) PRIVATE LIMITED",
"CHAUDHRY BROTHERS TRADERS AND BUILDERS PRIVATE LIMITED",
"CHAUDHRY INDUSTRIES CI",
"CHAUDHRY STEELS PRIVATE. LIMITED.",
"CHAUHAN BUILDERS",
"CHAUHAN CIVIL STRUCTURES COMPANY PVT LTD",
"CHAUHAN CONSTRUCTION PRIVATE LIMITED",
"CHAUHAN ICE AND COLD STORAGE PRIVATE LIMITED",
"CHAUHAN PAPERS PVT LTD",
"CHAUHAN SECURITY SERVICE",
"CHAURANGINATH AGRO PRODUCER COMPANY LIMITED",
"CHAURAS FARMERS PRODUCER COMPANY LIMITED",
"CHAURASIA ENTERPRISES INDIA PRIVATE LIMITED",
"CHAVAN AUTO WHEELS PRIVATE LIMITED",
"CHAVAN ELECTRICALS",
"CHAVAN MOTORS DIVISION INDIA PRIVATE LIMITED",
"CHAVANS BUSINESS VENTURES PRIVATE LIMITED",
"CHAVARA HIGH SCHOOL",
"CHAVARE ENGINEERING PRIVATE LIMITED",
"CHAVDA INFRA LIMITED",
"CHAVDA INFRA PRIVATE LIMITED",
"CHAVDA SHOES PRIVATE LIMITED",
"CHAVO TEXTILE PRIVATE LIMITED",
"CHAWLA ALLOYS PRIVATE LIMITED",
"CHAWLA AND CHOUDHARY TRADING COMPANY PRIVATE LIMITED",
"CHAWLA BUILDWELL PVT LTD",
"CHAWLA CATERERS PRIVATE LIMITED",
"CHAWLA CYCLE COMPANY PRIVATE LIMITED",
"CHAWLA DIGITAL SYSTEMS PRIVATE LIMITED",
"CHAWLA ENTERPRISES LIMITED",
"CHAWLA FIRE PROTECTION ENGINEERS PRIVATE LIMITED",
"CHAWLA FMCG DISTRIBUTORS PRIVATE LIMITED",
"CHAWLA FRESH FRUITS PRIVATE LIMITED",
"CHAWLA ISPAT PRIVATE LIMITED",
"CHAWLA JEWELLERS",
"CHAWLA JEWELLERS & BULLION PRIVATE LIMITED",
"CHAWLA LOGISTICS SOLUTIONS PRIVATE LIMITED",
"CHAWLA LOOMTEX PRIVATE LIMITED",
"CHAWLA MARKETING PRIVATE LIMITED",
"CHAWLA PACKAGING PRIVATE LIMITED",
"CHAWLA PLASTOPACK PRIVATE LIMITED",
"CHAWLA PUBLICATIONS PRIVATE LIMITED",
"CHAWLA RIDERS PRIVATE LIMITED",
"CHAWLA SONS",
"CHAWLA TECHNO CONSTRUCT LIMITED",
"CHAWLA TEXTILE INDUSTRIES PVT LTD",
"CHAWLA TYRE PRIVATE LIMITED",
"CHAWLA WOOLLEN MILLS PRIVATE LIMITED",
"CHAWNI PARISHAD MHOW",
"CHAWRA TRADING",
"CHAWTECH SOLUTIONS PRIVATE LIMITED",
"CHAYA EDUCATION PRIVATE LIMITED",
"CHAYADEEP PROPERTIES PRIVATE LIMITED",
"CHAYOWO TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"CHAZHIKATTU HOSPITALS PVT LTD",
"CHAZIA TEX PRIVATE LIMITED",
"CHB BUILDCARE PRIVATE LIMITED",
"CHC NAVIGATION INDIA PRIVATE LIMITED",
"CHD CHEMICALS LIMITED",
"CHD HOSPITALITY PRIVATE. LIMITED.",
"CHEAP FLY HUB PRIVATE LIMITED",
"CHEAP MATTING HOUSE PVT LTD",
"CHEAP SILK STORE PRIVATE LIMITED",
"CHEAR INDIA LIMITED",
"CHEAR INDIA PRIVATE LIMITED",
"CHEAY INVESTMENTS PVT LTD",
"CHEBROLU ENGINEERING COLLEGE",
"CHEBROLU HANUMAIAH INSTITUTE OF PHARMACEUTICAL SCIENCES",
"CHECHANI SAREES PVT LTD",
"CHECK N CLICK LEARNING AND TECHNOLOGIES PRIVATE LIMITED",
"CHECK POINT SOFTWARE TECHNOLOGIES INDIA PRIVATE LIMITED",
"CHECKBOX TECHNOLOGY PRIVATE LIMITED",
"CHECKERS INDIA TECHNOLOGY PRIVATE LIMITED",
"CHECKEXPLORE TECHNOLOGIES PRIVATE LIMITED",
"CHECKMARK INDIA PRIVATE LIMITED",
"CHECKMARX INDIA TECHNOLOGY SERVICES PRIVATE LIMITED",
"CHECKMATE COMPUTERS PRIVATE LIMITED",
"CHECKMATE INDUSTRIAL GUARDS PRIVATE LIMITED",
"CHECKMATE INDUSTRIAL SERVICES PRIVATE LIMITED",
"CHECKMATE SECURITY SOLUTIONS PRIVATE LIMITED",
"CHECKMATE SERVICES PRIVATE LIMITED",
"CHECKPOINT APPAREL LABELING SOLUTIONS INDIA PRIVATE LIMITED",
"CHECKPOINT CREDIT AND CAPITAL PRIVATE LIMITED",
"CHECKPOINT SYSTEMS INDIA PRIVATE LIMITED",
"CHECKPOINT TRENDS LIMITED",
"CHECKS AND DOTS FABRICS PRIVATE LIMITED",
"CHECKTRONIX INDIA PRIVATE LIMITED",
"CHEEKA SOLVENT PRIVATE LIMITED",
"CHEELGADI VEG RESTAURANT PRIVATE LIMITED",
"CHEELIZZA PIZZA INDIA PRIVATE LIMITED",
"CHEEMA BOILERS LIMITED",
"CHEEMA PRINTPAC LIMITED",
"CHEEMA TVS INDUSTRIAL VENTURES PRIVATE LIMITED",
"CHEENI LABS PRIVATE LIMITED",
"CHEENU AMMA AALLOY PRIVATE LIMITED",
"CHEEP APP INDIA LLP",
"CHEER BREWERIES LIMITED",
"CHEER SAGAR PRIVATE LIMITED",
"CHEERANS LAB PVT LTD",
"CHEERFUL COMMERCIAL PRIVATE LIMITED",
"CHEERS FINANCIAL SERVICES PVT LTD",
"CHEERS INTERACTIVE (INDIA) PRIVATE LIMITED",
"CHEERS WINE PRIVATE LIMITED",
"CHEERYONTECH PRIVATE LIMITED",
"CHEERZZ SOLUTIONS PRIVATE LIMITED",
"CHEESE BOOKS COMPANY PRIVATE LIMITED",
"CHEETAL GRAND MOTELS PRIVATE LIMITED",
"CHEF BOBBY FOODS PRIVATE LIMITED",
"CHEF SET HOUSEWARES (INDIA) PRIVATE LIMITED",
"CHEF ZONE INTERNATIONAL FOOD PRIVATE LIMITED",
"CHEFAIR INVESTMENT PRIVATE LIMITED",
"CHEFERD FOODS PRIVATE LIMITED",
"CHEFLINE ASSOCIATES PRIVATE LIMITED",
"CHEFS CORPORATE SERVICES PRIVATE LIMITED",
"CHEF'S FROZEN FOODS PRIVATE LIMITED",
"CHEFTALK FOOD AND HOSPITALITY SERVICES PRIVATE LIMITED",
"CHEFWISE VENTURES PRIVATE LIMITED",
"CHEFXO FOODS SOLUTIONS PRIVATE LIMITED",
"CHEGU IMPERIUM PRIVATE LIMITED",
"CHEGURI AGRO FRESH COLD STORAGE PRIVATE LIMITED",
"CHEIF MEDICAL OFFICER",
"CHEIL INDIA PRIVATE LIMITED",
"CHEIRO CATERER PRIVATE LIMITED",
"CHEKKENY COMPOSITES PRIVATE LIMITED",
"CHEKURI CONSTRUCTIONS PRIVATE LIMITED",
"CHELAMMAL VIDHYAASHRAM CBSE SCHOOL",
"CHELAWASIA RETAILS PRIVATE LIMITED",
"CHELLA SOFTWARE PRIVATE LIMITED",
"CHELLAM POULTRY FARM PRIVATE LIMITED",
"CHELLAMMAL VIDYALAYA",
"CHELLAMMAL WOMENS COLLAGE OF THE PACHAIYAPPAS TRUST",
"CHELLAPPA FRUITS PRIVATE LIMITED",
"CHELLARAM DIABETES INSTITUTE",
"CHELLARAM FOUNDATION",
"CHELLARAM MILLS PRIVATE LIMITED",
"CHELLARAM SHIPPING PRIVATE LIMITED",
"CHELLO COMMOTRADE PRIVATE LIMITED",
"CHELLSONS PACKAGING PRIVATE LIMITED",
"CHELMSFORD CLUB LTD",
"CHELOOR BIO-PHARMA & HEALTH CARE LIMITED",
"CHELOOR PROPERTY DEVELOPMENT PROJECTS LIMITED",
"CHELSEA BLOCKS AND PIPES PRIVATE LIMITED",
"CHELSEA ENGINEERING PRIVATE LIMITED",
"CHELSEA MILLS LLP",
"CHELSEA TEXTILES PRIVATE LIMITED",
"CHELSEA WEST ARCHITECTS PRIVATE LIMITED",
"CHELSIO COMMUNICATIONS PRIVATE LIMITED",
"CHEM ACADEMY PRIVATE LIMITED",
"CHEM COLOUR (INDIA) LIMITED",
"CHEM CORPORATION",
"CHEM LUBE INDIA PRIVATE LIMITED",
"CHEM PROCESS SYSTEMS PRIVATE LIMITED",
"CHEM TREND CHEMICALS COMPANY PRIVATE LIMITED",
"CHEMATEK FINECHEMICALS INDIA PRIVATE LIMITED",
"CHEMAX MULTIKOTES (INDIA) PRIVATE LIMITED",
"CHEMAX TECHNOSERVICES PRIVATE LIMITED",
"CHEMBIAN TECHNOLOGIES PRIVATE LIMITED",
"CHEMBIZINTL SOLUTIONS PRIVATE LIMITED",
"CHEMBOND BIOSCIENCES LIMITED",
"CHEMBOND CALVATIS INDUSTRIAL HYGIENE SYSTEMS LIMITED",
"CHEMBOND CHEMICALS LIMITED",
"CHEMBOND CLEAN WATER TECHNOLOGIES LIMITED",
"CHEMBOND DISTRIBUTION LIMITED",
"CHEMBOND WATER TECHNOLOGIES LIMITED",
"CHEMBUR EDUCATION SOCIETY PRIMARY SCHOOL",
"CHEMBUR HOTELS PRIVATE LIMITED",
"CHEMCLEANZIO INDIA PRIVATE LIMITED",
"CHEMCLUES LIFESCIENCE PRIVATE LIMITED",
"CHEMCO INNOVATIVE CHEMIE PRIVATE LIMITED",
"CHEMCO PLASTIC INDUSTRIES PRIVATE LIMITED",
"CHEMCOAT INDIA ENTERPRISE PRIVATE LIMITED",
"CHEMCOMP INFINITY INDIA PRIVATE LIMITED",
"CHEMCON SPECIALITY CHEMICALS LIMITED",
"CHEMCON SPECIALITY CHEMICALS PRIVATE LIMITED",
"CHEMCROWN EXPORTS PRIVATE LTD",
"CHEMCRUX ENTERPRISES LIMITED",
"CHEMDIST MEMBRANE SYSTEMS PRIVATE LIMITED",
"CHEMDIST PROCESS SOLUTIONS PRIVATE LIMITED",
"CHEME TECH DATA ANALYSIS & SERVICES PRIVATE LIMITED",
"CHEMEAST INDIA PRIVATE LIMITED",
"CHEMECCA LABS PRIVATE LIMITED",
"CHEMECOAT PAINTS INDIA PRIVATE LIMITED",
"CHEMEMAN INDIA PRIVATE LIMITED",
"CHEMENERGY BIOFUELS PRIVATE LIMITED",
"CHEMERIC BIOTECH PRIVATE LIMITED",
"CHEMESTER FOOD INDUSTRY PRIVATE LIMITED",
"CHEMET WETS AND FLOWS PRIVATE LIMITED",
"CHEMETALL INDIA PRIVATE LIMITED",
"CHEMEX OIL PVT LTD",
"CHEMEX ORGANOCHEM PRIVATE LIMITED",
"CHEMFAB ALKALIS LIMITED",
"CHEMFIELD CELLULOSE PRIVATE LIMITED",
"CHEMFILLERS PRIVATE LIMITED",
"CHEMFORTE INDIA PRIVATE LIMITED",
"CHEMFUSION CHEMICALS PRIVATE LIMITED",
"CHEMGEMS INDIA PRIVATE LT D",
"CHEMGENIX LABORATORIES PRIVATE LIMITED",
"CHEMI ENTERPRISE",
"CHEMI KLEEN (INDIA) PRIVATE LIMITED",
"CHEMI PACK INDIA PRIVATE LIMITED",
"CHEMI PHARMA DISTRIBUTORS PRIVATE LIMITED",
"CHEMI TECH CONSTRUCTIONS PRIVATE LIMITED",
"CHEMI TECH ENGINEERS PRIVATE LIMITED",
"CHEMI THERM PLANTS AND SYSTEMS PRIVATE LIMITED",
"CHEMIC LIFE SCIENCES PRIVATE LIMITED",
"CHEMICAL AND METALLURGICAL DESIGN COMPANY LIMITED",
"CHEMICAL AND MINERAL INDUSTRIES PVT LTD",
"CHEMICAL BROTHERS ENTERPRISES PRIVATE LIMITED",
"CHEMICAL CONSTRUCTION INTERNATIONAL PVT LTD",
"CHEMICAL CORP PRIVATE LIMITED",
"CHEMICAL PLUS TECHNOLOGY",
"CHEMICAL PROCESS EQUIPMENTS PRIVATE LIMITED",
"CHEMICAL PROCESS PIPING PRIVATE LIMITED",
"CHEMICAL SALTS PRODUCERS PVT LTD",
"CHEMICAL SYSTEMS TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"CHEMICAL UDYOG PRIVATE LIMITED",
"CHEMICALITY INDIA PRIVATE LIMITED",
"CHEMICALS AND FERRO ALLOYS PRIVATE LIMITED",
"CHEMICALS INTERNATIONAL (MUMBAI) PVT LTD",
"CHEMICEA PHARMACEUTICALS PRIVATE LIMITED",
"CHEMICK INDUSTRIES PRIVATE LIMITED",
"CHEMICO HEALTH AND BEAUTY INDIA PRIVATE LIMITED",
"CHEMICO INTERNATIONAL PVT LTD",
"CHEMICO SYNTHETICS LIMITED",
"CHEMICOLOUR INTERNATIONAL PRIVATE LIMITED",
"CHEMICONE CHEMICAL INDUSTRIES PVT LTD",
"CHEMICURE LABORATORIES PRIVATE LIMITED",
"CHEMIE ALLIANCE (INDIA) PRIVATE LIMITED",
"CHEMIE FINE LABORATORIES PRIVATE LIMITED",
"CHEMIE ORGANIC CHEMICALS INDIA PRIVATE LIMITED",
"CHEMIE PRODUCTS PVT LTD",
"CHEMIERESIN INDUSTRIES PRIVATE LIMITED",
"CHEMIESYNTH (VAPI) LIMITED",
"CHEMIE-TECH PROJECTS LIMITED",
"CHEMIETRON CLEAN TECH PRIVATE LIMITED",
"CHEMIFINE FORMULATIONS PRIVATE LIMITED",
"CHEMIK FINECHEM PRIVATE LIMITED",
"CHEMIKER PHARMACEUTICALS PRIVATE LIMITED",
"CHEMILAC PAINTS PRIVATE LIMITED",
"CHEMILIFE TECHNOLOGIES PRIVATE LIMITED",
"CHEMILINE INTERMIDS INDIA PRIVATE LIMITED",
"CHEMILINES HEALTHCARE INDIA PRIVATE LIMITED",
"CHEMILITE COATINGS PRIVATE LIMITED",
"CHEMILOIDS LIFE SCIENCES PRIVATE LIMITED",
"CHEMIN CONTROLS AND INSTRUMENTATION PRIVATE LIMITED",
"CHEMIN ENVIRO SYSTEMS PRIVATE LIMITED",
"CHEMIN SPRINGS INDIA PRIVATE LIMITED",
"CHEMINO PHARMA LIMITED",
"CHEMINOVA INDIA LIMITED",
"CHEMIONIX E-SOLUTIONS PRIVATE LIMITED",
"CHEMIPRIME IMPEX PRIVATE LIMITED",
"CHEMIQUEST RESEARCH INDIA PRIVATE LIMITED",
"CHEMISCHE GLOBAL PRIVATE LIMITED",
"CHEMISIGHT TECHNOLOGIES PRIVATE LIMITED",
"CHEMISOL INDIA",
"CHEMIST BOX PRIVATE LIMITED",
"CHEMISTAR INDIA PRIVATE LIMITED",
"CHEMISTAR INTERMEDIATES PRIVATE LIMITED",
"CHEMISTIK PRIVATE LIMITED",
"CHEMISTRY DESIGN PRIVATE LIMITED",
"CHEMISTRY INDIA PRIVATE LIMITED",
"CHEMITALS PRIVATE LIMITED",
"CHEMITEK PROCESS EQUIPMENTS PRIVATE LIMITED",
"CHEMITEX EXPORTS PVT LTD",
"CHEMITO INFOTECH PRIVATE LIMITED",
"CHEMITO TECHNOLOGIES PRIVATE LIMITED",
"CHEMITOMO INTERNATIONAL PRIVATE LIMITED",
"CHEMKART INDIA PRIVATE LIMITED",
"CHEMLIFE INNOVATIONS PRIVATE LIMITED",
"CHEMLIN PUMPS AND VALVES PRIVATE LIMITED",
"CHEMLINE INDIA LIMITED",
"CHEMM FINANCE LIMITED.",
"CHEMMANUR CREDITS AND INVESTMENTS LIMITED",
"CHEMMANUR GOLD PALACE INTERNATIONAL LIMITED",
"CHEMMANUR IMPEX PRIVATE LIMITED",
"CHEMMANUR INTERNATIONAL HOLIDAYS AND RESORTS LIMITED",
"CHEMMANUR INTERNATIONAL JEWELLERS LIMITED LIABILITY PARTNERSHIP",
"CHEMMANUR JEWELLERIES (BANGALORE) LIMITED",
"CHEMMANUR JEWELLERS LIMITED",
"CHEMMANUR JEWELRY PRIVATE LIMITED",
"CHEMMANUR JEWELS (KARNATAKA) PRIVATE LIMITED",
"CHEMO HEALTHCARE PRIVATE LIMITED",
"CHEMO INDIA FORMULATION PRIVATE LIMITED",
"CHEMO TRIX (INDIA) PVT LTD.",
"CHEMOCID IMPEX PRIVATE LIMITED",
"CHEMOIL ADVANCED MANAGEMENT SERVICES PRIVATE LIMITED",
"CHEMOLEUMS INDIA",
"CHEMOLUTIONS CHEMICALS LIMITED",
"CHEMONIX INDIA PVT. LTD.",
"CHEMOPLAST",
"CHEMOSYN LIMITED",
"CHEMPAKA KINDERGARTEN PRIVATE LIMITED",
"CHEMPES (INDIA) PRIVATE LIMITED",
"CHEMPHAR ORGANIC (INDIA) PVT LTD",
"CHEMPHARM INDUSTRIES INDIA PRIVATE LIMITED",
"CHEMPLAST CUDDALORE VINYLS LIMITED",
"CHEMPLAST SANMAR LIMITED",
"CHEMPRIMO FLOURINE INTERNATIONAL PRIVATE LIMITED",
"CHEMPRO EXPERTISE PRIVATE LIMITED",
"CHEMPRO INSPECTIONS PRIVATE LIMITED",
"CHEMPRO PHARMA PRIVATE LIMITED",
"CHEMPURE PVT LTD",
"CHEMPURE TECHNOLOGIES PRIVATE LIMITED",
"CHEMROSS LIFESCIENCES PRIVATE LIMITED",
"CHEMS DEAL INC PRIVATE LIMITED",
"CHEMSEALS ENGINEERING PRIVATE LIMITED",
"CHEMSHEL ENTERPRISES PRIVATE LIMITED",
"CHEMSOL POLYMER INDUSTRIES PRIVATE LIMITED",
"CHEMSPARK INDIA PRIVATE LIMITED",
"CHEMSPEC CHEMICALS LIMITED",
"CHEMSPEC CHEMICALS PRIVATE LIMITED",
"CHEMSTAR MARKETING PRIVATE LIMITED",
"CHEMSTER INDUSTRIES PRIVATE LIMITED",
"CHEMSYNERGY INDIA PRIVATE LIMITED",
"CHEMSYNTH DRUGS & PHARMACEUTICALS PRIVATE LIMITED",
"CHEMTECH ACIDS AND CHEMICALS PRIVATE LIMITED",
"CHEMTECH AGRO CARE PRIVATE LIMITED",
"CHEMTECH ALKOXIDES PRIVATE LIMITED",
"CHEMTECH ALLOYS PRIVATE LIMITED",
"CHEMTECH FERTILISERS PRIVATE LIMITED",
"CHEMTECH INDUSTRIAL VALVES LIMITED",
"CHEMTECH INTERMEDIATES PRIVATE LIMITED",
"CHEMTECH PRINT SOLUTIONS PRIVATE LIMITED",
"CHEMTECH RUBBER LINING INDIA PRIVATE LIMITED",
"CHEMTECH SPECIALITY INDIA PRIVATE LIMITED",
"CHEMTEK FIBERGLASS PRIVATE LIMITED",
"CHEMTEK SCIENTIFIC PRIVATE LIMITED",
"CHEMTEX CONSULTING OF INDIA PRIVATE LIMITED",
"CHEMTEX ENGINEERING OF INDIA LIMITED",
"CHEMTEX MATERIALS PRIVATE LIMITED",
"CHEMTEX SPECIALITY LIMITED",
"CHEMTRADE OVERSEAS PRIVATE LIMITED",
"CHEMTREAT INDIA LIMITED",
"CHEMTROLS HOLDINGS PRIVATE LIMITED CN",
"CHEMTROLS INDUSTRIES LIMITED",
"CHEMTROLS INDUSTRIES PRIVATE LIMITED",
"CHEMTROLS INFOTECH PRIVATE LIMITED",
"CHEMTROLS SAMIL INDIA PRIVATE LIMITED",
"CHEMTROLS SOLAR PRIVATE LIMITED",
"CHEMTRON ANALYTICAL INSTRUMENTS PRIVATE LIMITED",
"CHEMTRON SCIENCE LABORATORIES PRIVATE LIMITED",
"CHEMTRONICS TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"CHEMVEDA LIFE SCIENCES INDIA PRIVATE LIMITED",
"CHEMVENTURE INDIA PRIVATE LIMITED",
"CHEMVERA SPECIALTY CHEMICALS PRIVATE LIMITED",
"CHEMVIKAS ENGINEERING PRIVATE LIMITED",
"CHEMVISION RESEARCH PRIVATE LIMITED",
"CHEMXZEN LABS PRIVATE LIMITED",
"CHEMY REACH INDIA PRIVATE LIMITED",
"CHEMZ CHEM (INDIA) PRIVATE LIMITED",
"CHEMZIN GRAPHICS PRIVATE LIMITED",
"CHEMZYME HEALTH SOLUTIONS PRIVATE LIMITED",
"CHENAB AGRO CHEM LIMITED",
"CHENAB IMPEX PRIVATE LIMITED",
"CHENAB INFRASTRUCTURE PRIVATE LIMITED.",
"CHENAB MACHINERY & ENGINEERING PRIVATE LIMITED",
"CHENAB PACK PRIVATE LIMITED",
"CHENAB VALLEY POWER PROJECTS PRIVATE LIMITED",
"CHENDAYAD GRANITES PRIVATE LIMITED",
"CHENDHOOR MURUGHAN YARN TEX INDIA PRIVATE LIMITED",
"CHENDU CHICKEN PRIVATE LIMITED",
"CHENDUR INFRASTRUCTURE PRIVATE LIMITED",
"CHENDUR MURUGAN FAB INDIA PRIVATE LIMITED",
"CHENDURAN COTSPIN INDIA PRIVATE LIMITED",
"CHENDURAN ENTERPRISES PRIVATE LIMITED",
"CHENDURAN INFRA PRIVATE LIMITED",
"CHENE CREEK RESORTS PRIVATE LIMITED",
"CHENFENG TECH PRIVATE LIMITED",
"CHENG CHIANG LEATHER PRIVATE LIMITED",
"CHENGALPATTU LOGISTICS PARKS PRIVATE LIMITED",
"CHENGALPATTU WAREHOUSING PARKS PRIVATE LIMITED",
"CHENGANNUR NIDHI LIMITED",
"CHENGMARI TEA CO LTD",
"CHENGUANG NATURAL EXTRACTS (INDIA) PRIVATE LIMITED",
"CHENITAN COLOR-CHEM PRIVATE LIMITED",
"CHENNAI ACADEMY OF ARCHITECTURE AND DESIGN",
"CHENNAI AEROSPACE PARK LIMITED",
"CHENNAI AIRCONTROL PRIVATE LIMITED",
"CHENNAI ALUM CHEMICAL PRIVATE LIMITED",
"CHENNAI AUTO AGENCY PRIVATE LIMITED",
"CHENNAI AUTO ANCILLARY INDUSTRIAL INFRASTRUCTURE UPGRADATION COMPANY",
"CHENNAI AUTO TECH ENGINEERING PRIVATE LIMITED",
"CHENNAI AUTOMATION SYSTEMS PRIVATE LIMITED",
"CHENNAI BIO-FLORA PRIVATE LIMITED",
"CHENNAI BUSINESS SCHOOL LIMITED",
"CHENNAI CENTRAL CO",
"CHENNAI CENTRAL CO OPERATIVE BANK LTD",
"CHENNAI CITI CENTRE HOLDINGS PRIVATE LIMITED",
"CHENNAI CITIZEN SECURITY SERVICES PRIVATE LIMITED",
"CHENNAI CNC SERVOTRONICS PRIVATE LIMITED",
"CHENNAI COMMODITIES PRIVATE LIMITED",
"CHENNAI CONTAINER TERMINAL PRIVATE LIMITED",
"CHENNAI CRITICAL CARE CONSULTANTS PRIVATE LIMITED",
"CHENNAI DELUX INTERNATIONAL HOTEL PRIVATE LIMITED",
"CHENNAI DIAGNOSTIC CENTRE",
"CHENNAI EMERGENCY CARE CENTER",
"CHENNAI ENGINEERING COATING CO.PRIVATE LIMITED",
"CHENNAI ENVIRO SOLUTIONS PRIVATE LIMITED",
"CHENNAI ENVIRONMENTAL MANAGEMENT COMPANY OF TANNERS",
"CHENNAI EXPO PRINTS PRIVATE LIMITED",
"CHENNAI FERROUS INDUSTRIES LIMITED",
"CHENNAI FERTILITY CENTER AND RESEARCH INSTITUTE",
"CHENNAI FORGE PRODUCTS PRIVATE LIMITED",
"CHENNAI HEATREATERS PRIVATE LIMITED",
"CHENNAI HI-TECH ENGINEERING PRIVATE LIMITED",
"CHENNAI INSTITUTE OF TECHNOLOGY",
"CHENNAI INTERACTIVE BUSINESS SERVICES PRIVATE LIMITED",
"CHENNAI INTERNATIONAL CENTRE",
"CHENNAI INTERNATIONAL TERMINALS PRIVATE LIMITED",
"CHENNAI LEISURE PRIVATE. LIMITED.",
"CHENNAI LUXURY HOME DEVELOPERS PRIVATE LIMITED",
"CHENNAI MANAGEMENT SERVICES PRIVATE LIMITED",
"CHENNAI MATHEMATICAL INSTITUTE",
"CHENNAI MEDIPOINT PRIVATE LIMITED",
"CHENNAI MESH ENTERPRISE PRIVATE LIMITED",
"CHENNAI METAL STAMPING PRIVATE LIMITED",
"CHENNAI METCO PRIVATE LIMITED",
"CHENNAI METRO POLITAN WATER & SEWERANCE",
"CHENNAI METRO RAIL LIMITED",
"CHENNAI METRO TRAVELS PRIVATE LIMITED",
"CHENNAI METROPOLITAN WATER SUPPLY AND SEWERAGE BOARD",
"CHENNAI METTEX LAB PRIVATE LIMITED",
"CHENNAI MSW PRIVATE LIMITED",
"CHENNAI MURASU PRIVATE LIMITED",
"CHENNAI NATIONAL HOSPITAL",
"CHENNAI NOBLE HOSPITALS PRIVATE LIMITED",
"CHENNAI OSCAR BIO PHARMACEUTICALS PRIVATE LIMITED",
"CHENNAI PEN PRODUCTS PRIVATE LIMITED",
"CHENNAI PETROLEUM CORPORATION LIMITED",
"CHENNAI PLASTIC SACKS CLUSTER PRIVATE LIMITED",
"CHENNAI POLES PRIVATE LIMITED",
"CHENNAI POLY PACK PRIVATE LIMITED",
"CHENNAI POLYMERS PRIVATE LIMITED",
"CHENNAI PORT AND DOCK EDUCATIONAL TRUST HIGHER SECONDARY SCHOOL",
"CHENNAI PORT TRUST",
"CHENNAI PRIMARY SCHOOL - LL",
"CHENNAI PROFESSTIONAL SECURITY SOLUSTIONS PRIVATE LIMITED",
"CHENNAI PUBLIC SCHOOL",
"CHENNAI PUBLISHING SERVICES PRIVATE LIMITED",
"CHENNAI RADHA ENGINEERING WORKS PRIVATE LIMITED",
"CHENNAI RECLAMATIONS PRIVATE LIMITED",
"CHENNAI RESIDENTIAL DEVELOPERS PRIVATE LIMITED",
"CHENNAI RICE INDUSTRIES INDIA PRIVATE LIMITED",
"CHENNAI ROLLER FLOUR MILLS PRIVATE LIMITED",
"CHENNAI RR MEDICOS PRIVATE LIMITED",
"CHENNAI SMART CITY LIMITED",
"CHENNAI SSSS EQUIPMENTS PRIVATE LIMITED",
"CHENNAI SUPER KINGS CRICKET LIMITED",
"CHENNAI TESTING LABORATORY PRIVATE LIMITED",
"CHENNAI TEXTILE CHEMICALS PRIVATE LIMITED",
"CHENNAI UNITED METAL INDUSTRIES PRIVATE LIMITED",
"CHENNAI UROLOGY AND ROBOTICS INSTITUTE PRIVATE",
"CHENNAI WATER DESALINATION LIMITED",
"CHENNAI WOMEN'S CLINIC & SCAN CENTRE PRIVATE LIMITED",
"CHENNAIANGELS NETWORK ASSOCIATION",
"CHENNAI-ENNORE PORT ROAD COMPANY LIMITED.",
"CHENNAIS AMIRTA INTERNATIONAL INSTITUTE OF HOTEL MANAGEMENT PRIVATE LIMITED",
"CHENNAIYIN F.C. SPORTS PRIVATE LIMITED",
"CHENNAMMAL ENT HOSPITAL",
"CHENNIAPPA YARN SPINNERS PRIVATE LIMITED",
"CHENNOTH PAINTS",
"CHENNOVATE SOLUTIONS PRIVATE LIMITED",
"CHENNUPATI CARGO CARRIERS PRIVATE LIMITED",
"CHENOA INFORMATION AND SOFTWARE SERVICE PRIVATE LIMITED",
"CHENOSA TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"CHENTECH FIRE AND SAFE PRIVATE LIMITED",
"CHEONS SPECIALITY CHEMICALS PRIVATE LIMITED",
"CHEP INDIA PRIVATE LIMITED",
"CHER LIFE HEALTHCARE PRIVATE LIMITED",
"CHER LIFESTYLE PRIVATE LIMITED",
"CHERAMAN FINANCIAL SERVICES LIMITED",
"CHERAN BEAUTY CARE PRODUCTS PRIVATE LIMITED",
"CHERAN FOUNDATION TRUST",
"CHERAN MACHINES INDIA PRIVATE LIMITED",
"CHERAN MATRICULATION HIGHER SECONDARY SCHOOL",
"CHERAN SOFT GOODS PRIVATE LIMITED",
"CHERAN SPINNER LIMITED",
"CHERAN SPINNING MILLS PRIVATE LIMITED",
"CHERAN WEAVES INDIA PRIVATE. LIMITED.",
"CHERESO LIFE SCIENCES PRIVATE LIMITED",
"CHERIAN VARKEY CONSTRUCTION COMPANY PRIVATE LIMITED",
"CHERIC INFORMATION NETWORK TECHNOLOGIES PRIVATE LIMITED",
"CHERISE (INDIA) PRIVATE LIMITED",
"CHERISH AGRO IMPEX PRIVATE LIMITED",
"CHERISH HOSPITAL",
"CHERISH HOSPITALITY SERVICES I PRIVATE LIMITED",
"CHERISH HR SERVICES PRIVATE LIMITED",
"CHERISH PROPERTIES PRIVATE LIMITED",
"CHERKALA CONSTRUCTIONS PRIVATE LIMITED",
"CHERMAS EXQUISITE LTD",
"CHERNG TAY TECHNOLOGY (INDIA) PRIVATE LIMITED",
"CHERO MEDICO AND DEVELOPERS PRIVATE LIMITED",
"CHEROKEE INDIA PRIVATE LIMITED",
"CHERRINGTON FABRICATIONS INDIA PRIVATE LIMITED",
"CHERRY AGENCIES PRIVATE LIMITED",
"CHERRY CHIK HATCHERIES PRIVATE LIMITED",
"CHERRY CONSTRUCTION PRIVATE LIMITED",
"CHERRY E COMMERCE SER PRIVATE LIMITED",
"CHERRY FOODGRAINS PRIVATE LIMITED",
"CHERRY HILL INTERIORS PRIVATE LIMITED",
"CHERRY HYBRIDSEEDS PRIVATE LIMITED",
"CHERRY PAINTS AND POLYMERS PVT LTD",
"CHERRY SAREES PRIVATE LIMITED",
"CHERRY TOMATOES",
"CHERRY TREE SOLUTIONS PRIVATE LIMITED",
"CHERRYLABS TECHNOLOGY PRIVATE LIMITED",
"CHERRYPICK TECHNOLOGIES LIMITED",
"CHERRYROAD SERVICES INDIA PRIVATE LIMITED",
"CHERRYTEC INTELISOLVE LIMITED",
"CHERUB DAIRY PRODUCTS PRIVATE LIMITED",
"CHERUBIM SECURITY FORCE LLP",
"CHERUKARA MOTORS PRIVATE LIMITED",
"CHERUKUPALLY AGRO PRODUCTS PRIVATE LIMITED",
"CHERUSSERY CREDITS PRIVATE LIMITED",
"CHERUVATHOOR KURIES PRIVATE LIMITED",
"CHERY TECH (INDIA) PRIVATE LIMITED",
"CHERYL LABORATORIES PRIVATE LIMITED",
"CHESA DENTAL CARE SERVICES LIMITED.",
"CHESAPEAKE ENERGY CORPORATION",
"CHESHTAA APPARELS INDIA PRIVATE LIMITED",
"CHES'NUT OUTSOURCE PRIVATE LIMITED",
"CHESS GLOBAL ADVISORY SERVICES PRIVATE LIMITED",
"CHESS MANAGEMENT SERVICES PRIVATE LIMITED",
"CHESSBASE INDIA 64 SQUARES PRIVATE LIMITED",
"CHESSLINE APPARELS PRIVATE LIMITED",
"CHESSY FINOPS PRIVATE LIMITED",
"CHESSY KNOWLEDGE QUOTIENT PRIVATE LIMITED",
"CHEST RESEARCH AND TRAINING PRIVATE LIMITED",
"CHET RAM MOTI LAL PRIVATE LIMITED",
"CHETAK CARGO PRIVATE LIMITED",
"CHETAK COATINGS PRIVATE LIMITED",
"CHETAK COOKWARES PVT LTD",
"CHETAK ENTERPRISES LIMITED",
"CHETAK GEARS PRIVATE LIMITED",
"CHETAK GRANI-MARMO PRIVATE LIMITED",
"CHETAK GRANITE PRIVATE LIMITED",
"CHETAK IMPEX PRIVATE LIMITED",
"CHETAK INTERNATIONAL PRIVATE LIMITED",
"CHETAK JAINCO TOLLWAYS LIMITED",
"CHETAK LOGISTICS LIMITED",
"CHETAK MARBLES PVT LTD",
"CHETAK MINING AND MINERALS PRIVATE LIMITED",
"CHETAK MITRA TOLLWAYS LIMITED",
"CHETAK MOTORS PRIVATE LIMITED",
"CHETAK PLASTOELECTRIC PRIVATE LIMITED",
"CHETAK ROADLINES INDIA PRIVATE LIMITED",
"CHETAK SUPPLY CHAIN PRIVATE LIMITED",
"CHETAK TOLLWAYS LIMITED",
"CHETAK TOOLS (INDIA) PRIVATE LIMITED",
"CHETAK TRAVELS PRIVATE LIMITED",
"CHETAK-MARMO PRIVATE LIMITED",
"CHETALI TRADING PVT LTD",
"CHETAN ABRASIVES PRIVATE LIMITED",
"CHETAN BEARINGS PVT LTD",
"CHETAN BUILDERS",
"CHETAN CABLETRONICS PRIVATE LIMITED",
"CHETAN CARS PRIVATE LIMITED",
"CHETAN DAS OM PRAKASH IMPEX PRIVATE LIMITED",
"CHETAN ELECTRIC PRIVATE LIMITED",
"CHETAN GRANITE AND MARBLE PRIVATE LIMITED",
"CHETAN LOGISTICS PVT LTD",
"CHETAN MEDITECH PRIVATE LIMITED",
"CHETAN METALS PRIVATE LIMITED",
"CHETAN ORNAMENTS PVT LTD",
"CHETAN OVERSEAS PRIVATE LIMITED",
"CHETAN PAPERS PRIVATE LIMITED",
"CHETAN ROADLINES PRIVATE LIMITED",
"CHETAN SALES AGENCY PRIVATE LIMITED",
"CHETAN TOURS & TRAVELS PRIVATE LIMITED",
"CHETAN TRADE EXIM PRIVATE LIMITED",
"CHETAN VYAS & ASSOCIATES",
"CHETANA BOOK DEPOT",
"CHETANA CHITS HAVERI PRIVATE LIMITED",
"CHETANA EDUCATION LLP",
"CHETANA FINANCIAL SERVICES LIMITED",
"CHETANA HINDI VIDYAMANDIR",
"CHETANA INLEASE PRIVATE LIMITED",
"CHETANA JEWELS PRIVATE LIMITED",
"CHETANA PRAKASANI PRIVATE LIMITED",
"CHETANA PUBLICATIONS PRIVATE LIMITED",
"CHETANA R K INSTITUTE OF MANAGEMENT ST",
"CHETANKUMAR VIRCHANDBHAI SHAH MULTI SERVICES PRIVATE LIMITED",
"CHETANYA CAREER CONSULTANTS PRIVATE LIMITED",
"CHETARU WEB LINK PRIVATE LIMITED",
"CHETAS FLOWMETERS PRIVATE LIMITED",
"CHETHANA FORMULATIONS PRIVATE LIMITED",
"CHETHANA HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"CHETHANA MEDICAMENTS PVT LTD",
"CHETHANA MERCHANDISE PRIVATE LIMITED",
"CHETHANA PHARMA PRIVATE LIMITED",
"CHETLAL SARITA INFRASTRUCTURE PRIVATE LIMITED",
"CHETMANI GEMS & JEWELS PRIVATE LIMITED",
"CHETMANI ORNAMENTS AND JEWELLERS PRIVATE LIMITED",
"CHETMANI ORNAMENTS PRIVATE. LIMITED.",
"CHETNA ALLOYS PRIVATE LIMITED",
"CHETNA APPARELS PRIVATE LIMITED",
"CHETNA APPLIANCES PRIVATE LIMITED",
"CHETNA ELECTRONICS PRIVATE LIMITED",
"CHETNA FASHION ACCESSORIES PRIVATE LIMITED",
"CHETNA ORGANIC AGRICULTURE PRODUCER COMP ANY LIMITED",
"CHETNA POLYTEX PRIVATE LIMITED",
"CHETNA SPICES (INDIA) PRIVATE LIMITED",
"CHETNA STEEL TUBES PRIVATE LIMITED",
"CHETNA TRADERS PVT LTD",
"CHETRA SEALS PRIVATE LIMITED",
"CHETRAM RICE (INDIA) PRIVATE LIMITED",
"CHETRAN FOODS PRIVATE LIMITED",
"CHETSON FOOD PRODUCTS PRIVATE LIMITED",
"CHETTINAD BUILDERS PRIVATE LIMITED",
"CHETTINAD CEMENT CORPORATION PRIVATE LIMITED",
"CHETTINAD COLLEGE OF ENGINEERING AND TECHNOLOGY",
"CHETTINAD CORPORATION PRIVATE LIMITED",
"CHETTINAD FINANCIAL MANAGEMENT SERVICES PRIVATE LIMITED",
"CHETTINAD HARI SHREE VIDYALAYAM",
"CHETTINAD HEALTH CITY",
"CHETTINAD HERITAGE HOTELS PRIVATE LIMITED",
"CHETTINAD HOLDINGS PRIVATE LIMITED",
"CHETTINAD HOSPITAL AND RESEARCH INSTITUTE",
"CHETTINAD HOSPITALS",
"CHETTINAD HOSPITALS PRIVATE LIMITED",
"CHETTINAD LIGNITE TRANSPORT SERVICES PRIVATE LIMITED",
"CHETTINAD LOGISTICS",
"CHETTINAD LOGISTICS PRIVATE LIMITED",
"CHETTINAD MANGALORE COAL TERMINAL PRIVATE LIMITED",
"CHETTINAD MARINE AND OFFSHORE COMPANY INDIA PRIVATE LIMITED",
"CHETTINAD MORIMURA SEMICONDUCTOR MATERIAL PRIVATE LIMITED",
"CHETTINAD NIYOGAA",
"CHETTINAD PRODUCTS AND SERVICES PRIVATE LIMITED",
"CHETTINAD PROPERTY DEVELOPERS PRIVATE LIMITED",
"CHETTINAD SARVALOKAA EDUCATION",
"CHETTINAD STRUCTURAL & ENGINEERING PRIVATE LIMITED",
"CHETTINAD SUPER SPECIALITY HOSPITAL",
"CHETTINAD VIDYA MANDIR CBSC SCHOOL",
"CHETTINAD VIDYASHRAM",
"CHETU (INDIA) PRIVATE LIMITED",
"CHEVALIER T THOMAS ELIZABETH COLLEGE",
"CHEVAS IMPORTS EXPORTS PRIVATE LIMITED",
"CHEVIOT AGRO INDUSTRIES PRIVATE LIMITED",
"CHEVIOT CO LTD",
"CHEVIOT INTERNATIONAL LIMITED",
"CHEVIREDDY MUNIREDDY ROSAMMA INFRA PRIVATE LIMITED",
"CHEVISANCE SHIPPING PRIVATE LIMITED",
"CHEVON NISSU RADIATORS PRIVATE LIMITED",
"CHEVROLET SALES INDIA PRIVATE LIMITED",
"CHEVRON",
"CHEVRON HOTELS AND RESORTS PRIVATE LIMITED",
"CHEVRON INTERNATIONAL PVT LTD",
"CHEVRON KLASSIK HOTELS PRIVATE LIMITED",
"CHEVRON LUBRICANTS INDIA PRIVATE LIMITED",
"CHEVRON PETROLEUM INDIA PRIVATE LIMITED",
"CHEVRON PHARMA PRIVATE LIMITED",
"CHEVROX CONSTRUCTIONS PRIVATE LIMITED",
"CHEYYAR SEZ DEVELOPERS PRIVATE LIMITED",
"CHEYYUR INFRA LIMITED",
"CHEZZION CONSULTING SOLUTIONS PRIVATE LIMITED",
"CHF INDIA FOUNDATION",
"CHF INDUSTRIES INDIA PRIVATE LIMITED",
"CHH INDIA PRIVATE LIMITED",
"CHHABEE NUTRICOS INDUSTRIES LLP",
"CHHABEELA ENERGY FOODS PRIVATE. LIMITED.",
"CHHABI ELECTRICALS PRIVATE LIMITED",
"CHHABILDAS CBSE SCHOOL",
"CHHABILDAS DEVELOPERS PRIVATE LIMITED",
"CHHABRA CASTINGS PRIVATE LIMITED",
"CHHABRA COLLECTIONS PRIVATE LIMITED",
"CHHABRA EMPIRE PRIVATE LIMITED",
"CHHABRA HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"CHHABRA HOME CONCEPTS PRIVATE LIMITED",
"CHHABRA HOME PRODUCT PRIVATE LIMITED",
"CHHABRA INFOSOLUTIONS PRIVATE LIMITED",
"CHHABRA ISPAT PRIVATE LIMITED",
"CHHABRA NEWS AGENCIES PRIVATE LIMITED",
"CHHABRA POWER LIMITED",
"CHHABRA SONS JEWELLERS PRIVATE LIMITED",
"CHHABRA SYNCOTEX PRIVATE LIMITED",
"CHHABRA SYNTEX PRIVATE LIMITED",
"CHHABRA TEXCO FAB PRIVATE LIMITED",
"CHHABRA TRADING COMPANY LIMITED",
"CHHABRIA BROTHERS PRIVATE LIMITED",
"CHHABRIA TEXTILE MILLS PRIVATE LIMITED",
"CHHABRIA TEXTILE PROCESSORS PRIVATE LIMITED",
"CHHAGAN JEE FOODS (INDIA) PRIVATE LIMITED",
"CHHAGANLAL CHHOGALAL TEXTILE MILLS PVT LTD",
"CHHAGANLAL DAYALJEE SONS PRIVATE LIMITED",
"CHHAI HAZAR EK PAANCH HAZAR EK PACKERS & MOVERS PRIVATE LIMITED",
"CHHAILA LIFESTYLE PRIVATE LIMITED",
"CHHAITANYA DIAGNOSTICS PRIVATE LIMITED",
"CHHAJED AGRI PLASTIC PRIVATE LIMITED",
"CHHAJED BUILDWELL PRIVATE LIMITED",
"CHHAJED FOODS PRIVATE LIMITED",
"CHHAJED GARDEN AGRO SERVICES PRIVATE LIMITED",
"CHHAJED PRINTRY PVT.LTD.",
"CHHAJED STEEL AND ALLOYS PRIVATE LIMITED",
"CHHAJED STEEL LIMITED",
"CHHAJER AGRO PRODUCTS PRIVATE LIMITED",
"CHHAJER COLD STORAGE PRIVATE LIMITED",
"CHHAJER FINANCE LIMITED",
"CHHAJER PACKAGINGS AND PLASTICS PRIVATE LIMITED",
"CHHAJER RICE MILL PRIVATE LIMITED",
"CHHAJER SURGICALS PRIVATE LIMITED",
"CHHAJER TEXTILE MILLS PVT LTD",
"CHHAJLANI PACKMART PRIVATE LIMITED",
"CHHAMICHHA PRATHMIK SHALA",
"CHHAPARIA & ASSOCIATES",
"CHHAPARIA INDUSTRIES PRIVATE LIMITED",
"CHHAPARIA MARKETING PRIVATE LIMITED",
"CHHAPARIA SYNTHETICS PRIVATE LIMITED",
"CHHAPERIA CABLE MATERIAL PRIVATE LIMITED",
"CHHAPERIA ELECTRO COMPONENTS PRIVATE LIMITED",
"CHHAPOLIKA & COMPANY",
"CHHAPRA FARMERS PRODUCER COMPANY LIMITED",
"CHHAPRA-HAJIPUR EXPRESSWAYS LIMITED",
"CHHARIA IMPEX PRIVATE LIMITED",
"CHHATARIYA DYE-STUFF PVT LTD",
"CHHATARIYA VEG EXPO PRIVATE LIMITED",
"CHHATISGARH CHEMICALS PVT LTD",
"CHHATISGARH INVESTMENTS LIMITED",
"CHHATISGARH PURVA SAINIK SECURITY SERVICES PRIVATE LIMITED",
"CHHATRAL ENVIRONMENT MANAGEMENT SYSTEM PRIVATE LIMITED",
"CHHATRAPATI GENNING AND PRESSING PRIVATE LIMITED",
"CHHATRAPATI INDUSTRIES PRIVATE LIMITED",
"CHHATRAPATI MOTORS PRIVATE LIMITED",
"CHHATRAPATI SAMBHAJI RAJE SAKHAR UDYOG LIMITED",
"CHHATRAPATI SHAHU JI MAHARAJ UNIVERSITY",
"CHHATRAPATI SHAHU MAHARAJ CIVIL HOSPITAL JALGAON",
"CHHATRAPATI SHAHU VIDYAKAYA",
"CHHATRAPATI SHIVAJI COLLEGE OF PHARMACY (B.PHARM)",
"CHHATRAPATI SHIVAJI INSTITUTE OF TECHNOLOGY",
"CHHATRAPATI SHIVAJI MAHARAJ VASTU SANGRAHALAYA",
"CHHATRAPATI SHIVAJI VIDYALAYA REVGAON",
"CHHATRAPREETI ESTATE PRIVATE LIMITED",
"CHHATRESHWARY LOGISTICS PRIVATE LIMITED",
"CHHATTISGARH AGRO FOOD CORPORATION LIMITED",
"CHHATTISGARH AGROVET PRIVATE LIMITED",
"CHHATTISGARH ANUSANDHAN AVAM VIKAS FIRM",
"CHHATTISGARH BHAWAN",
"CHHATTISGARH C AND F AGENCY PRIVATE LIMITED",
"CHHATTISGARH COMMERCIAL PRIVATE LIMITED",
"CHHATTISGARH COOPERATIVE CREDIT SOCIETY LIMITED",
"CHHATTISGARH COPPER LIMITED",
"CHHATTISGARH DISTRIBUTORS PRIVATE LIMITED",
"CHHATTISGARH EAST RAILWAY LIMITED",
"CHHATTISGARH EAST-WEST RAILWAY LIMITED",
"CHHATTISGARH FERRO TRADES PRIVATE. LIMITED.",
"CHHATTISGARH GOVERNMENT HEALTH DEPARTMENT",
"CHHATTISGARH HEALTHCARE PRIVATE LIMITED",
"CHHATTISGARH HOUSING BOARD HEAD OFFICE RAIPUR",
"CHHATTISGARH INFRASTRUCTURE DEVELOPMENT CORPORATION LIMITED",
"CHHATTISGARH ISPAT BHUMI LIMITED",
"CHHATTISGARH JEWELLERS PRIVATE LIMITED",
"CHHATTISGARH KATGHORA DONGARGARH RAILWAY LIMITED",
"CHHATTISGARH MARKFED",
"CHHATTISGARH OF CO-OPERATION DEPARTMENT",
"CHHATTISGARH OFFICE STATE WAQF BOARD",
"CHHATTISGARH PLASTICS PVT.LTD.",
"CHHATTISGARH RAILWAY CORPORATION LIMITED",
"CHHATTISGARH RAJYA BEEJ EVAM KRISHI VIKAS NIGAM LIMITED",
"CHHATTISGARH RAJYA GRAMIN BANK",
"CHHATTISGARH RAJYA SAHAKARI BANK MARYADIT",
"CHHATTISGARH REAL ESTATE PRIVATE LIMITED",
"CHHATTISGARH REGIONAL SCIENCE CENTRE",
"CHHATTISGARH ROAD AND INFRASTRUCTURE DEVELOPMENT CORPORATION LIMITED",
"CHHATTISGARH SHASAN SCHOOL SHIKSHA VIBHAG KARYALAY PRAKHAND PADADHIKARI PRAKHAND UDAIPUR SARGUJA AMBIKAPUR",
"CHHATTISGARH STATE AIDS CONTROL SOCIETY",
"CHHATTISGARH STATE BEVERAGES CORPORATION",
"CHHATTISGARH STATE BEVERAGES CORPORATION LIMITED",
"CHHATTISGARH STATE COMPENSATORY AFFORESTATION FUND MANAGEMENT AND PLANNING AUTHORITY",
"CHHATTISGARH STATE COOPERATIVE MARKETING FEDERATION LIMITED",
"CHHATTISGARH STATE ELECTION COMMISSION NIRWACHAN",
"CHHATTISGARH STATE POWER CO LIMITED",
"CHHATTISGARH STATE POWER COMPANIES",
"CHHATTISGARH STATE POWER DISTRIBUTION COMPANY LIMITED",
"CHHATTISGARH STATE POWER GENERATION COMPANY LIMITED",
"CHHATTISGARH STATE POWER HOLDING COMPANY LIMITED",
"CHHATTISGARH STATE POWER TRANSMISSION COMPANY LIMITED",
"CHHATTISGARH STATE RENEWABLE ENERGY DEVELOPMENT AGENCY",
"CHHATTISGARH STEEL AND POWER LIMITED",
"CHHATTISGARH VIDHAN SABHA SECRETARIAT VIDHAN SABHA BHAWAN ZERO POINT RAIPUR (C G)",
"CHHATTISGARH-WR TRANSMISSION LIMITED",
"CHHAVAN ENGINEERING WORKS",
"CHHAVI INTERNATIONAL PRIVATE LIMITED",
"CHHAVI MULTIVENTURES PRIVATE LIMITED",
"CHHAVI TOURISTS PRIVATE LIMITED.",
"CHHAWACHHARIA ENGINEERING PVT LTD",
"CHHAWANI PARISHAD MHOW",
"CHHAYA ADVERTISING PRIVATE LIMITED",
"CHHAYA ASSETLINE PRIVATE LIMITED",
"CHHAYA BOOKS PRIVATE LIMITED",
"CHHAYA DEVELOPMENT SERVICES PRIVATE LIMITED",
"CHHAYA PRAKASHANI LIMITED",
"CHHAYA SOAPS & DETERGENTS PRIVATE LIMITED",
"CHHEDA DRY FRUITS PRIVATE LIMITED",
"CHHEDA ELECTRICALS AND ELECTRONICS PRIVATE LIMITED",
"CHHEDA FINE JEWELLERY PRIVATE LIMITED",
"CHHEDA INTERNATIONAL PRIVATE LIMITED",
"CHHEDA JEWELLERS PRIVATE LIMITED",
"CHHEDA SPECIALITIES FOODS PRIVATE LIMITED",
"CHHEDLAGAN FARMERS PRODUCER COMPANY LIMITED",
"CHHETA AND SHETA LED PRIVATE LIMITED",
"CHHIKARA GOODS TRANSPORT CO PVT LTD",
"CHHINAMASTIKE SANITATION PRIVATE LIMITED",
"CHHINDWARA INFRASTRUCTURE PRIVATE LIMITED",
"CHHINMASTIKA KISAN PRODUCER COMPANY LIMITED",
"CHHIPA PRINTS N CRAFT PRIVATE LIMITED",
"CHHITARMAL BHURAMAL TRADERS PRIVATE LIMITED",
"CHHOTA BAZAAR LIFESTYLE PRIVATE LIMITED",
"CHHOTABHAI JETHABHAI PATEL TOBACCO PRODUCTS CO LTD",
"CHHOTABHAI RETAILING INDIA PRIVATE LIMITED",
"CHHOTANAGPUR ISPAT PRIVATE LIMITED",
"CHHOTANAGPUR PUBLIC SCHOOL",
"CHHOTELAL CONSTRUCTIONS PRIVATE LIMITED",
"CHHOTEY LAL LAXMI PRASAD PRIVATE LIMITED",
"CHHOTIA CONSTRUCTION PRIVATE LIMITED",
"CHHUNNA MAL RAM NATH PRIVATE LIMITED",
"CHI NETWORKS INDIA PRIVATE LIMITED",
"CHIA TECHNOLOGIES PRIVATE LIMITED",
"CHIARO ENTERPRISE PRIVATE LIMITED",
"CHIASMA SOLUTIONS PRIVATE LIMITED",
"CHIC INFOTECH PRIVATE LIMITED.",
"CHIC MANAGEMENT SERVICES PRIVATE LIMITED",
"CHICAGO BLOWER (INDIA) PRIVATE LIMITED",
"CHICAGO CONSTRUCTIONS INTERNATIONAL PRIVATE LIMITED",
"CHICAGO TOWER PRIVATE LIMITED",
"CHICCEM MEDICAL PRIVATE LIMITED",
"CHICHANI TRADELINK PRIVATE LIMITED",
"CHICHLAM BUSINESS SERVICES PRIVATE LIMITED",
"CHICKEN WILD WINGS PRIVATE LIMITED",
"CHICKPET DONNE BIRYANI HOUSE HOSPITALITY PRIVATE LIMITED",
"CHIDAMBARAM FISHNETS PRIVATE LIMITED",
"CHIDAMBARAM MULRAJ AND COMPANY PRIVATE LIMITED",
"CHIDAMBARAM SHIPCARE PRIVATE LIMITED",
"CHIDDARWAR CONSTRUCTION COMPANY PRIVATE LIMITED",
"CHIDRUPI FINANCIAL SERVICES LIMITED",
"CHIE MEDIA PRIVATE LIMITED",
"CHIEF ACCOUNTS OFFICER CUSTOMS",
"CHIEF ACCOUNTS OFFICER MP SECRETARIAT BHOPAL",
"CHIEF ARCHITECT & TOWN PLANNER",
"CHIEF COMMISSIONAL OF STATE TAX",
"CHIEF DISTRICT MEDICAL & PUBLIC HEALTH OFFICER",
"CHIEF DISTRICT VETERINARY OFFICER DISTRICT VETENARY BHADRAK",
"CHIEF ENFORCEMENT OFFICER ENFORCEMENT DIRECTORATE MUMBAI",
"CHIEF ENGINEER DEPT OF WATER SUPPLY AND SANITATION",
"CHIEF ENGINEER FOR SIX EQUIPMENT",
"CHIEF ENGINEER N T BASIN W R D",
"CHIEF ENGINEER P W REGION",
"CHIEF ENGINEER PUBLIC WORKS",
"CHIEF ENGINEER PWD AGRA",
"CHIEF ENGINEER TRAINING & PROJECT",
"CHIEF EVANGE LIST SERVO TECH PRIVATE LIMITED",
"CHIEF EXECUTIVE OFFICER FISHERIES BADAUN",
"CHIEF JUDGE SMALL CAUSES COURT BOMBAY",
"CHIEF JUDICIAL MAGISTRATE",
"CHIEF MEDICAL AND HEALTH OFFICER",
"CHIEF MEDICAL AND HEALTH OFFICER GWALIOR",
"CHIEF MEDICAL AND HEALTH OFFICER KHARGONE",
"CHIEF MEDICAL AND HEALTH OFFICER UJJAIN",
"CHIEF MEDICAL OFFICER BARABANKI",
"CHIEF MEDICAL OFFICER C G H S CIVIL LINE NAGPUR",
"CHIEF MEDICAL OFFICER ESI SCHEME LABOUR AND MEDICAL SERVICES LUCKNOW",
"CHIEF MEDICAL OFFICER KANPUR",
"CHIEF MEDICAL OFFICER PRATAPGARH",
"CHIEF MEDICAL SUPERINTENDENT T B HOSPITAL THAKURGANJ LUCKNOW",
"CHIEF MEDICAL SUPERITENDENT PT DEEN DAYAL UPADHAYAY JOINT HOSPITAL ALIGARH",
"CHIEF METROPOLITAN MAGISTRATE BOMBAY",
"CHIEF SOFTWARE SOLUTIONS PRIVATE LIMITED",
"CHIEF TECHNICAL OFFICER SHEEP WOOL",
"CHIEF TRANSLATER AND INTERPRETER O S HIGH COURT BOMBAY",
"CHIEF VETERINARY OFFICER",
"CHIERZ FOODS AND BEVERAGES PRIVATE LIMITED",
"CHIF ENGINEER P W D CIRCLE INDORE",
"CHIF JUDICIAL MAGISTRATE",
"CHIGURU CANCER CARE PRIVATE LIMITED",
"CHIK FRESH FARMS PRIVATE LIMITED",
"CHIKA OVERSEAS PRIVATE LIMITED",
"CHIKA PRIVATE LIMITED",
"CHIKARA ENTERPRISES PRIVATE LIMITED",
"CHIKHLOLI CHEMICALS PRIVATE LIMITED",
"CHIKINIKI ENTERPRISES INDIA PRIVATE LIMITED",
"CHIKITSA DIAGNOSTIC CENTRE",
"CHIKITSA MEDICARE CENTRE PRIVATE LIMITED",
"CHIKITTSA WELLNESS MANAGEMENT PRIVATE LIMITED",
"CHIKKU ENERGY PRIVATE LIMITED",
"CHILAKALURIPET BYPASS PRIVATE LIMITED",
"CHILAKALURIPET COLD STORAGE PRIVATE LIMITED",
"CHILD CARE BISHOP CONRAD SCHOOL",
"CHILD DEVELOPMENT PROJECT",
"CHILD EMPOWERMENT FOUNDATION INDIA",
"CHILD RIGHTS AND YOU",
"CHILD SPECIALIST CIVIL SERGUON J.P. HOSPITAL BHOPAL",
"CHILDCRAFTHALLMARK PUBLISHERS PRIVATE LIMITED",
"CHILDFUND INTERNATIONAL USA",
"CHILDHOOD TO LIVELIHOOD MAGIC BUS REGIONAL OFFICES INDIA",
"CHILDREN CHOICE PUBLICATION PRIVATE LIMITED",
"CHILDREN FIRST MENTAL HEALTH INST P LIMITED",
"CHILDREN INTERNATIONAL",
"CHILDREN S FUTURE INDIA PRIVATE LIMITED",
"CHILDRENS ACADEMY",
"CHILDREN'S ACADEMY ASHOK NAGAR SECONDARY",
"CHILDREN'S ACADEMY PRIMARY ICSE",
"CHILDRENS EDUCATION SOCIETY",
"CHILDREN'S PARADISE MAT HR SEC SCHOOL",
"CHILDRENS UNIVERSITY",
"CHILDREN'S VOICE PUBLICATIONS PRIVATE LIMITED",
"CHILDSAFE HEALTHCARE INDIA PRIVATE LIMITED",
"CHILIAD PROCONS PRIVATE LIMITED",
"CHILIKA PHARMACEUTICAL PRIVATE LIMITED",
"CHILIKARANI FISH TRADING PRIVATE LIMITED",
"CHILLCO CHILLERS PRIVATE LIMITED",
"CHILLETA FOODS PRIVATE LIMITED",
"CHILLI AND CHA FOOD PRIVATE LIMITED",
"CHILLI FLAKES PRIVATE LIMITED",
"CHILLIBREEZE SOLUTIONS PRIVATE LIMITED",
"CHILLIES ENTERPRISES PRIVATE LIMITED",
"CHILLIES EXPORT HOUSE LIMITED",
"CHILLIEZ MODULAR DESIGNERS PRIVATE LIMITED",
"CHILLMAX TECHNOLOGIES PRIVATE LIMITED",
"CHILLMEK ENGINEERING PRIVATE LIMITED",
"CHILLODA FARMS LIMITED",
"CHILTERN INTERNATIONAL PRIVATE LIMITED",
"CHILTON REFRIGERATION PVT LTD",
"CHILUKURI HEALTH CARE PRIVATE LIMITED",
"CHILUKURI HOUSING PROJECTS PRIVATE LIMITED",
"CHILUKURI INFOSYSTEMS PRIVATE LIMITED",
"CHILUKURI INFRA PRIVATE LIMITED",
"CHILWORTH TECHNOLOGY PRIVATE LIMITED",
"CHIMANIRAM DHIRAJI CHHORIYA PULSES PRIVATE LIMITED",
"CHIMANLAL FEIN PAPER PRIVATE LIMITED",
"CHIMANLAL MANEKLAL SECURITIES PVT LTD",
"CHIMANLAL POPATLAL BROKER PRIVATE LIMITED",
"CHIMANLAL SONS MEDICARE PRODUCTS PRIVATE LIMITED",
"CHIMANLAL SURESH KUMAR TEXTILES PRIVATE LIMITED",
"CHIMATE TECHNOLOGY PRIVATE LIMITED",
"CHIMATECH PROJECTS PRIVATE LIMITED",
"CHIME POLYMERS PRIVATE LIMITED",
"CHIME TOURS PRIVATE LIMITED",
"CHIMERA INDUSTRIAL AND DEVELOPMENT PRIVATE LIMITED",
"CHIMERA INFRASTRUCTURE PRIVATE LIMITED",
"CHIMERA TECHNOLOGIES PRIVATE LIMITED",
"CHIMES AVIATION PRIVATE LIMITED",
"CHIMES PRIVATE LIMITED",
"CHIMIQUE (INDIA) LIMITED",
"CHIMMANESHWAR EXIM PRIVATE LIMITED",
"CHIMP&Z WORLDWIDE LLP",
"CHIMPSATWORK STUDIOS PRIVATE LIMITED",
"CHIMSEN TECHNOLOGY PRIVATE LIMITED",
"CHIMUR PETGAON HIGHWAY PRIVATE LIMITED",
"CHIN MIN DEVELOPERS PRIVATE LIMITED",
"CHINA AIRLINES",
"CHINA COAL NO. 5 CONSTRUCTION INDIA PRIVATE LIMITED",
"CHINA COAL NO.3 MINING (INDIA) PRIVATE LIMITED",
"CHINA CONSTRUCTION SAUSUM (INDIA) PRIVATE LIMITED",
"CHINA MINMETALS CORPORATION",
"CHINA SHOUGANG INDIA PRIVATE LIMITED",
"CHINA SOUTHERN AIRLINES CO. LIMITED",
"CHINA STEEL CORPORATION INDIA PRIVATE LIMITED",
"CHINAGATE RESTAURANT PRIVATE LIMITED",
"CHINAR FORGE LIMITED",
"CHINAR HOMES PRIVATE LIMITED",
"CHINAR MOBILES PRIVATE LIMITED",
"CHINAR PACKAGING PRIVATE LIMITED",
"CHINAR PROMOTERS PRIVATE LIMITED",
"CHINAR PUBLIC SCHOOL",
"CHINAR RETAILS AND INFRASTRUCTURE PVT. LTD.",
"CHINAR ROLLER FLOUR MILLS PRIVATE LIMITED",
"CHINAR STEEL SEGMENT CENTER",
"CHINAR SYNTEX LIMITED",
"CHINAR TRADERS PRIVATE LIMITED",
"CHINAY LOGISTICS PRIVATE LIMITED",
"CHINDALIA INDUSTRIAL PRODUCTS LIMITED",
"CHINDIA LOGISTICS PRIVATE LIMITED",
"CHINDWARA MINES PRIVATE LIMITED",
"CHINEKA INTERNATIONAL PRIVATE LIMITED",
"CHING HWA RESTAURANTS & HOTELS PRIVATE LIMITED",
"CHINIWALAS PRIVATE LIMITED",
"CHINMADHU AGRO SALES PRIVATE LIMITED",
"CHINMASTIKAY MULTI TRADING PRIVATE LIMITED",
"CHINMAY CHEMICALS PVT LTD",
"CHINMAY EQUITY PRIVATE LIMITED",
"CHINMAY FINLEASE LIMITED",
"CHINMAY IMPEX PRIVATE LIMITED",
"CHINMAY MERCANTILES PRIVATE LIMITED",
"CHINMAY PRECISION WORKS PRIVATE LIMITED",
"CHINMAY RESORTS PRIVATE LIMITED",
"CHINMAYA ENGINEERS PRIVATE LIMITED",
"CHINMAYA FINANCE CAPITAL PRIVATE LIMITED",
"CHINMAYA INTERNATIONAL FOUNDATION SHODHA SANSTHAN",
"CHINMAYA INTERNATIONAL RESIDENTIAL SCHOOL",
"CHINMAYA MISSION COLLEGE",
"CHINMAYA MISSION HOSPITAL",
"CHINMAYA SOFTWARE SOLUTIONS PRIVATE LIMITED",
"CHINMAYA VIDYALAYA",
"CHINNAKARAI COMMON EFFLUENT TREATMENT PLANT PRIVATE LIMITED",
"CHINNAMMAL TIMBER COMPANY PRIVATE LIMITED",
"CHINO CORPORATION INDIA PRIVATE LIMITED",
"CHINOY HOLDINGS PRIVATE LIMITED",
"CHINSHA PROPERTY PRIVATE LIMITED",
"CHINSURAH HEIGHTS DEVELOPERS PRIVATE LIMITED",
"CHINT INDIA ENERGY SOLUTION PRIVATE LIMITED",
"CHINTALAPATI ENTERPRISES PRIVATE LIMITED",
"CHINTALAPATI HOLDINGS PRIVATE LIMITED",
"CHINTAMANI AGROTECH INDIA LIMITED",
"CHINTAMANI APPARELS PRIVATE LIMITED",
"CHINTAMANI AUTOCOMP AND ENGINEERING PRODUCTS PRIVATE LIMITED",
"CHINTAMANI CONTROL SYSTEMS PRIVATE LIMITED",
"CHINTAMANI ENCLAVE PRIVATE LIMITED",
"CHINTAMANI ENGINEERING INDUSTRIES INDIA PRIVATE LIMITED",
"CHINTAMANI ENSERVE PRIVATE LIMITED",
"CHINTAMANI ESTATES PVT LTD",
"CHINTAMANI FABRICATION PRIVATE LIMITED",
"CHINTAMANI FINLEASE LIMITED",
"CHINTAMANI INFRASTRUCTURE & PEB SOLUTIONS PRIVATE LIMITED",
"CHINTAMANI JEWELLERS INDIA PRIVATE LIMITED",
"CHINTAMANI JEWELS",
"CHINTAMANI METAL UDYOG PVT LTD",
"CHINTAMANI NIRMAN PRIVATE LIMITED",
"CHINTAMANI NIWASI MATIMAND VIDYALAYA PULGAON",
"CHINTAMANI PAPER PRODUCTS PRIVATE LIMITED",
"CHINTAMANI PARSHWANATH ASSOCIATES PRIVATE LIMITED",
"CHINTAMANI PARSHWANATH INFRA PROJECTS PRIVATE LIMITED",
"CHINTAMANI PROJECTS LIMITED",
"CHINTAMANI THERMAL TECHNOLOGIES PRIVATE LIMITED",
"CHINTAMANI TOURS & TRAVELS PRIVATE LIMITED",
"CHINTAMANIS JEWELLERY ARCADE PRIVATE LIMITED",
"CHINTAN ALLUMINIUM PVT LTD",
"CHINTAN INDUSTRIES PRIVATE LIMITED",
"CHINTAN JEWELS PRIVATE LIMITED",
"CHINTELS CREDIT CORPORATION PRIVATE LIMITED",
"CHINTELS EDUCATION SOCIETY",
"CHINTELS INDIA PRIVATE LIMITED",
"CHINTELS INFRACON PRIVATE LIMITED",
"CHINTHA PRINTING AND PUBLISHING CO PVT LTD",
"CHINTHAMANI FOODS AND FEEDS PRIVATE LIMITED",
"CHINTOO CREATION PRIVATE LTD",
"CHINTPURNI STEEL PRIVATE LIMITED",
"CHINTU LACE HOUSE",
"CHINUBHAI CHIMANLAL DALAL SECURITY PRIVATE LIMITED",
"CHINULAL AND SONS FASHIONS PRIVATE LIMITED",
"CHIP COM TRADERS PRIVATE LIMITED",
"CHIP INFORMATION PLUS",
"CHIPCO BONDING SYSTEMS (INDIA) PRIVATE LIMITED",
"CHIPEDGE TECHNOLOGIES PRIVATE LIMITED",
"CHIPITA INDIA PRIVATE LIMITED",
"CHIPLOGIC SEMICONDUCTOR SERVICES PRIVATE LIMITED",
"CHIPMAX DESIGNS PRIVATE LIMITED",
"CHIPMONK TECHNOLOGIES PRIVATE LIMITED",
"CHIPOTLE MEDIA PRIVATE LIMITED",
"CHIPPER CONSUMER PRIVATE LIMITED",
"CHIPPER HOME ESSENTIALS PRIVATE LIMITED",
"CHIPS EXPRESS PRIVATE LIMITED",
"CHIPSAN AVIATION PRIVATE LIMITED",
"CHIPSLITE FOOD PRODUCTS PRIVATE LIMITED",
"CHIPSOLVE TECHNOLOGIES PRIVATE LIMITED",
"CHIPSPIRIT TECHNOLOGIES PRIVATE LIMITED",
"CHIPTEST ENGINEERING LIMITED",
"CHIPTEST ENGINEERING PRIVATE LIMITED",
"CHIPTRANS EXIM PRIVATE LIMITED",
"CHIP-VALLEY FOODS PRIVATE LIMITED",
"CHIPWARE TECHNOLOGIES PRIVATE LIMITED",
"CHIRAAG LOGISTICS PRIVATE LIMITED",
"CHIRAG (INDIA) AUTOMOTIVE PRIVATE LIMITED",
"CHIRAG AGRO FINS PRIVATE LIMITED",
"CHIRAG BUILDTEC PRIVATE LIMITED",
"CHIRAG CASTINGS PRIVATE LIMITED",
"CHIRAG COMMUNICATION PRIVATE LIMITED",
"CHIRAG CREDIT CAPITAL PVT LTD",
"CHIRAG DIAMOND PRIVATE LIMITED",
"CHIRAG DIE-CAST PRIVATE LIMITED",
"CHIRAG ELECTRONICS PVT LTD",
"CHIRAG FUELS PRIVATE LIMITED",
"CHIRAG GEMS PRIVATE LIMITED",
"CHIRAG GOEL ENTERPRISES PRIVATE LIMITED",
"CHIRAG INFRAPROJECTS PRIVATE LIMITED",
"CHIRAG INTERNATIONAL",
"CHIRAG MEDICARE SOLUTIONS PRIVATE LIMITED",
"CHIRAG ORGANICS PRIVATE LIMITED",
"CHIRAG PACK (INDIA) PRIVATE LIMITED",
"CHIRAG REFRIGERATION PVT LTD",
"CHIRAG RICE & PULSE MILL",
"CHIRAG RURAL DEVELOPMENT FOUNDATION",
"CHIRAG SILK MILLS PRIVATE LIMITED",
"CHIRAG TRADEXPO PRIVATE LIMITED",
"CHIRAG WIRES PRIVATE LIMITED",
"CHIRAGMANGALORE BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"CHIRAHARIT PRIVATE LIMITED",
"CHIRAI SALT (INDIA) PRIVATE LIMITED",
"CHIRAJ APPLIANCES PRIVATE LIMITED",
"CHIRAKEKAREN GLASS HOUSE PRIVATE LIMITED",
"CHIRAKKAL AUTO MOTIVE PRIVATE LIMITED",
"CHIRAKKAL STEELS PRIVATE LIMITED",
"CHIRAL DRUGS PVT LTD",
"CHIRAL ORGANICS PRIVATE LIMITED",
"CHIRALA ENGINEERING COLLEGE",
"CHIRALA HANDLOOMS PRIVATE LIMITED",
"CHIR-AMRIT CORPORATE SOLUTIONS PRIVATE LIMITED",
"CHIRANG LOGISTICS COMPANY PRIVATE LIMITED",
"CHIRANG MOTORS PRIVATE LIMITED",
"CHIRANIA PROJECTS PRIVATE LIMITED",
"CHIRANJEE COLD STORAGE PVT LTD",
"CHIRANJEEV RESTAURANT AND FOODS PRIVATE LIMITED",
"CHIRANJEEVA EXCAVATION AND INFRASTRUCTURE PRIVATE LIMITED",
"CHIRANJEEVI REDDY INSTITUTE OF ENGINEERING AND TECHNOLOGY",
"CHIRANJEEVI TECHNOCRAFTS PRIVATE LIMITED",
"CHIRANJI LAL GIRLS INTER COLLEGE ALIGARH",
"CHIRANJI LAL GUPTA & SONS PRIVATE LIMITED",
"CHIRANJI LAL LIFESTYLE STORES PRIVATE LIMITED",
"CHIRANJILAL PRABHUDAYAL YARNS PRIVATE LIMITED",
"CHIRANJILAL RAYONS PRIVATE. LIMITED.",
"CHIRANJILAL SPINNERS PRIVATE LIMITED",
"CHIRANJILAL YARNS PRIVATE LIMITED",
"CHIRANJIVI INDUSTRIES PVT LTD",
"CHIRANTANA EQUIPACK PRIVATE LIMITED",
"CHIRANTHANA",
"CHIRAP CONSULTANCY SERVICES PRIVATE LIMITED",
"CHIRASTHAAYEE SAURYA LIMITED",
"CHIRATAE VENTURES INDIA ADVISORS PRIVATE LIMITED",
"CHIRAU COMMODITIES PVT.LTD.",
"CHIRAU HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED",
"CHIRAYU AIR PRODUCTS PRIVATE LIMITED",
"CHIRAYU CHITS PRIVATE LIMITED",
"CHIRAYU COMMERCIAL PRIVATE LIMITED",
"CHIR-AYU CONTROLS PRIVATE LIMITED",
"CHIRAYU FOREX PRIVATE LIMITED",
"CHIRAYU HEALTH AND MEDICARE PVT LTD",
"CHIRAYU HOSPITAL",
"CHIRAYU LIFELINE PRIVATE LIMITED",
"CHIRAYU MEDICAL COLLEGE AND HOSPITAL",
"CHIRAYU POWER PRIVATE LIMITED",
"CHIRAYU VINIMOY PVT LTD",
"CHIRAYU WOMEN CROP PRODUCER COMPANY LIMITED",
"CHIRCHIND HYDRO POWER LIMITED",
"CHIREC INTERNATIONAL SCHOOL",
"CHIRIPAL INDUSTRIES LIMITED.",
"CHIRIPAL POLY FILMS LIMITED",
"CHIRIPAL TEXTILE MILLS PRIVATE LIMITED",
"CHIRON BEHRING VACCINES PRIVATE LIMITED",
"CHIRON INDIA MACHINE TOOLS PRIVATE LIMITED",
"CHIRON INSTRUMENTS INDIA P LIMITED",
"CHIRON PHARMACEUTICALS PRIVATE LIMITED",
"CHIROSREE PRIVATE LIMITED",
"CHIRPY UDYOG PRIVATE LIMITED",
"CHIRRA INFRA DEVELOPERS PRIVATE LIMITED",
"CHIRU FENESTRATION PRIVATE LIMITED",
"CHISHTI PLYWOOD INDUSTRIES PRIVATE LIMITED",
"CHISQUARE LABS PRIVATE LIMITED",
"CHISTIYA COMMUNICATION",
"CHITALE AGRICULTURAL PRODUCTS LIMITED",
"CHITALE BANDHU MITHAIWALE",
"CHITALE CFS PRIVATE LIMITED",
"CHITALE CLINIC PRIVATE LIMITED",
"CHITALE GENUS ABS (INDIA) PRIVATE LIMITED",
"CHITALE SWEETS AND SNACKS PRIVATE LIMITED",
"CHITALI BOTTLING LIMITED",
"CHITALKAR MILK PRODUCTS PRIVATE LIMITED",
"CHITAVALSAH JUTE MILLS LIMITED",
"CHITHRAPURI HOTELS INDIA PRIVATE LIMITED",
"CHITIZ METALS AND MINERALS TRADING PRIVATE LIMITED",
"CHITKARA INTERNATIONAL SCHOOL",
"CHITKARA UNIVERSITY",
"CHITOOR INFRA COMPANY PRIVATE LIMITED",
"CHITRA EXCELLENCE SERVICES PRIVATE LIMITED",
"CHITRA EXPORTS",
"CHITRA GRANITES AND MARBLES PRIVATE LIMITED",
"CHITRA IMPEX PRIVATE LIMITED",
"CHITRA INSULTEC PRIVATE LIMITED",
"CHITRA MACHINERIES PRIVATE LIMITED",
"CHITRA PRAKASHAN INDIA PRIVATE LIMITED",
"CHITRA PRINTS PVT LTD",
"CHITRA PUBLICATIONS PRIVATE LIMITED",
"CHITRA PUBLICITY COMPANY PRIVATE LIMITED",
"CHITRA SALES PRIVATE LIMITED",
"CHITRA TECHNOMEC PRIVATE LIMITED",
"CHITRA WINDOW MAKER PRIVATE LIMITED",
"CHITRADURGA ISPAT PRIVATE LIMITED",
"CHITRADURGA RENEWABLE ENERGY INDIA PRIVATE LIMITED",
"CHITRAKALA INVESTMENT TRADE AND BUSINESS FINANCE LIMITED",
"CHITRAKALA MAHAVIDYALAYA",
"CHITRAKAR APPARELS PRIVATE LIMITED",
"CHITRAKOOT CEMENT PVT LTD",
"CHITRAKOOT STEEL AND POWER PRIVATE LIMITED",
"CHITRAKUT ESTATES PRIVATE LIMITED",
"CHITRALEKHA STUDIOS PRIVATE LIMITED",
"CHITRALI FASHION PRIVATE LIMITED",
"CHITRALI PROPERTIES PRIVATE LIMITED",
"CHITRANSH ELECTRICALS",
"CHITRAVASU COLD STORAGE PRIVATE LIMITED",
"CHITRE ESTATE AND HOSPITALITY SERVICES PRIVATE LIMITED",
"CHITRINI INSTITUTE OF NURSHING",
"CHITRUMAL JEWELS PRIVATE LIMITED",
"CHITSONS DESIGN SPACES PRIVATE LIMITED",
"CHITTA FINLEASE PRIVATE LIMITED",
"CHITTARANJAN CANCER RESEARCH INSTITUE",
"CHITTARANJAN LOCOMOTIVE WORKS",
"CHITTARANJAN MEDICAL COLLEGE",
"CHITTARANJAN MULTIPURPOSE HEEMGHAR PRIVATE LIMITED",
"CHITTARANJAN NATIONAL CANCER INSTITUTE",
"CHITTARI AGRICARE PRIVATE LIMITED",
"CHITTHIRALA EDIBLE OILS AND FOODS PRIVATE LIMITED",
"CHITTOR PACKTECH PRIVATE LIMITED",
"CHITTOR POLYFAB PRIVATE LIMITED",
"CHITTORANJAN ADARSHA VIDYAMANDIR",
"CHITTORGARH ENGINEERINGS AND CASTINGS PVT. LTD",
"CHITTORGARH INFOTECH LIMITED",
"CHITTORH TRADECOM PRIVATE LIMITED",
"CHITTURI INFRACON PRIVATE LIMITED",
"CHITTURI PROJECTS PRIVATE LIMITED",
"CHJ SECURITIES PRIVATE LIMITED",
"CHL HOSPITAL INDORE",
"CHL LIMITED",
"CHL STOCK CONCEPTS PRIVATE LIMITED",
"CHLOE BEAUTY SERVICES PRIVATE LIMITED",
"CHLORAL CHEMICALS (INDIA) PRIVATE LIMITED",
"CHLORIDE METALS LIMITED",
"CHLORIDE POWER SYSTEMS & SOLUTIONS LIMITED",
"CHLORIS ENTERPRISES (INDIA) PRIVATE LIMITED",
"CHLORIS FLORA PRIVATE LIMITED",
"CHLORO TECH EQUIPMENTS PRIVATE LIMITED",
"CHLOROPHYLL BRAND AND COMMUNICATIONS CONSULTANCY PRIVATE LTD",
"CHLOROPHYLL TECHNOLOGIES PRIVATE LIMITED",
"CHMEO TRADING PRIVATE LIMITED",
"CHMUNDA PETROCHEMICALS PRIVATE LIMITED",
"CHNHB HEALTH INSURANCE CO. LIMITED",
"CHOCOCRAFT CREATIONS PRIVATE LIMITED",
"CHOCOFLY FOODS PRIVATE LIMITED",
"CHOGORI INDIA RETAIL LIMITED.",
"CHOHAN HVAC SOLUTIONS PRIVATE LIMITED",
"CHOICE BOARDS PRIVATE LIMITED",
"CHOICE BOOKS & PRINTERS PRIVATE LIMITED",
"CHOICE CAPITAL ADVISORS PRIVATE LIMITED",
"CHOICE CARGO AGENCIES PRIVATE LIMITED",
"CHOICE CHEMTECH PRIVATE LIMITED",
"CHOICE CLOTHING COMPANY PRIVATE LIMITED",
"CHOICE CONSULTANCY SERVICES PRIVATE LIMITED",
"CHOICE COPIERS PVT LTD",
"CHOICE CORPORATE SERVICES PRIVATE LIMITED",
"CHOICE ENTERPRISES PRIVATE LIMITED",
"CHOICE EQUITY BROKING PRIVATE LIMITED",
"CHOICE ESTATES AND CONSTRUCTIONS PRIVATE LIMITED",
"CHOICE FINSERV PRIVATE LIMITED",
"CHOICE FOODS PVT LTD",
"CHOICE FOUNDATION",
"CHOICE FURNITURE FIXTURES AND FITOUT INDIA PRIVATE LIMITED",
"CHOICE HATCHERY PRIVATE LIMITED",
"CHOICE HOSPITALITY INDIA PRIVATE LIMITED",
"CHOICE INSURANCE BROKING INDIA PRIVATE LIMITED",
"CHOICE INTERNATIONAL LIMITED.",
"CHOICE MERCHANDISE BROKING PRIVATE LIMITED",
"CHOICE CONNECT PRIVATE LIMITED",
"CHOICE SECURITIES PRIVATE LIMITED",
"CHOICE SOLUTIONS LIMITED",
"CHOICE SUPPLY CHAIN PRIVATE LIMITED",
"CHOICE TECH LAB SOLUTIONS PRIVATE LIMITED",
"CHOICE WEALTH MANAGEMENT PRIVATE LIMITED",
"CHOICE WIRES PRIVATE LIMITED",
"CHOICEFORCE INFOTECH PRIVATE LIMITED",
"CHOICEMMED TECHNOLOGY INDIA PRIVATE LIMITED",
"CHOICEST ENTERPRISES LIMITED",
"CHOICETECH SYSTEMS PRIVATE LIMITED",
"CHOITHRAM HOSPITAL",
"CHOITHRAM INTERNATIONAL",
"CHOKHANI COMPUTERS PRIVATE LIMITED",
"CHOKHI DHANI FOODS(CHOKHI DHANI RESORTS PRIVATE LIMITED)",
"CHOKHI DHANI RESORTS PRIVATE LIMITED",
"CHOKSEY CHEMICALS PRIVATE LIMITED",
"CHOKSHI AND CO LLP",
"CHOKSHI HIRALAL MAGANLAL JEWELLERS PRIVATE LIMITED",
"CHOKSI ASIA PRIVATE LIMITED",
"CHOKSI COLOURS PRIVATE LIMITED",
"CHOKSI FOREX PRIVATE LIMITED",
"CHOKSI HERAEUS PRIVATE LIMITED",
"CHOKSI IMAGING LIMITED",
"CHOKSI LABORATORIES LIMITED",
"CHOKSI ORGANICS PRIVATE LIMITED",
"CHOKSI TWISTERS PRIVATE LIMITED",
"CHOKUS SECURITY PRIVATE LIMITED",
"CHOLA BUSINESS SERVICES LIMITED",
"CHOLA HOTELS PRIVATE LIMITED",
"CHOLA INSURANCE DISTRIBUTION SERVICES",
"CHOLA LOGISTIKS PRIVATE LIMITED",
"CHOLA PACKAGING PRIVATE LIMITED",
"CHOLA PEOPLE AND MARKETING SERVICES PRIVATE LIMITED",
"CHOLA POWER PRIVATE LIMITED",
"CHOLA SPINNING MILLS PRIVATE LIMITED",
"CHOLA TEXTILES PRIVATE LIMITED",
"CHOLA TURBO MACHINERY INTERNATIONAL PRIVATE LIMITED",
"CHOLAMANDALAM DISTRIBUTION SERVICES LIMITED",
"CHOLAMANDALAM FINANCIAL HOLDINGS LIMITED",
"CHOLAMANDALAM HOME FINANCE LIMITED",
"CHOLAMANDALAM INVESTMENT AND FINANCE COMPANY LIMITED",
"CHOLAMANDALAM MS GENERAL INSURANCE COMPANY LIMITED",
"CHOLAMANDALAM MS RISK SERVICES LIMITED",
"CHOLAMANDALAM SECURITIES LIMITED",
"CHOLAN GEARS & PACKERS PRIVATE LIMITED",
"CHOLAN PAPER AND BOARD PRIVATE LIMITED",
"CHOLAN TOURS PRIVATE LIMITED",
"CHOLAS SPICES PRIVATE LIMITED",
"CHOLAYIL PRIVATE LIMITED",
"CHOMU CHANDWAJI TOLLWAYS PRIVATE LIMITED",
"CHONA COMMODITY TRADING SERVICES PRIVATE LIMITED",
"CHONA FINANCIAL SERVICES LIMITED",
"CHONDHE WAREHOUSING PRIVATE LIMITED",
"CHONGQING JIELI INDIA PRIVATE LIMITED",
"CHOOSE PORTAL PRIVATE LIMITED",
"CHOOYAL PRIVATE LIMITED",
"CHOPAL ENGINEERING PRIVATE LIMITED",
"CHOPDA AUTOWHEELS PRIVATE LIMITED",
"CHOPDA MEDICARE AND RESEARCH CENTRE PRIVATE LIMITED",
"CHOPDA STEEL TUBE PVT LTD",
"CHOPRA AUDIO VISUAL PRIVATE LIMITED",
"CHOPRA AUTOTECH PRIVATE LIMITED",
"CHOPRA BULLIONS PRIVATE LIMITED",
"CHOPRA GEMS PRIVATE LIMITED",
"CHOPRA HOSPITALITY PRIVATE LIMITED",
"CHOPRA INDUSTRIES PRIVATE LIMITED",
"CHOPRA LAM PRODUCTS PRIVATE LIMITED",
"CHOPRA PUBLISHING HOUSE PRIVATE LIMITED",
"CHOPRA RETEC RUBBER PRODUCTS LIMITED",
"CHOPRA SOLITAIRES PRIVATE LIMITED",
"CHOPRA STRIPS LIMITED",
"CHOPRA UDYOG PRIVATE LIMITED",
"CHOPRA¬† ENTERPRISES",
"CHORAD FARMERS PRODUCER COMPANY LIMITED",
"CHORAL TECHNOLOGIES PRIVATE LIMITED",
"CHORARIA INDUSTRIES PRIVATE LIMITED",
"CHORDIA BROTHERS PRIVATE LIMITED",
"CHORDIA BUILDCON PRIVATE LIMITED",
"CHORDIA FOOD - PARK & PROPERTIES LIMITED",
"CHORDIA FOOD PRODUCTS LIMITED",
"CHORDIA GEMS PRIVATE LIMITED",
"CHORDIA HOLDINGS AND CONSTRUCTION PRIVATE LIMITED",
"CHORDIA LANDMARKS REALTTY PRIVATE LIMITED",
"CHOREDIGITAL COMMUNICATION LLP",
"CHORI TRADING INDIA PRIVATE LIMITED",
"CHORON DIAMONDS INDIA PRIVATE LIMITED",
"CHORUS AGRO PRIVATE LIMITED",
"CHORUS CALL CONFERENCING SERVICES INDIA PRIVATE LIMITED",
"CHORUS LABS LIMITED",
"CHORUS PHARMACHEM PRIVATE LIMITED",
"CHORUS TOURS AND TRAVELS PRIVATE LIMITED",
"CHOSUN REFRACTORIES INDIA PRIVATE LIMITED",
"CHOTA BABU JEWELLERS PRIVATE LIMITED",
"CHOTA DHOBI LAUNDRY SOLUTIONS PRIVATE LIMITED",
"CHOTA HOSPITAL PRIVATE LIMITED",
"CHOTHANI FOODS LIMITED",
"CHOTHY'S BUILDING PROMOTERS PRIVATE LIMITED",
"CHOTIWALA FOOD AND HOTELS PRIVATE LIMITED",
"CHOTTA SHIMLA PROJECTS PRIVATE. LIMITED.",
"CHOTTU RAM PUBLIC SCHOOL",
"CHOUBATIA CONSTRUCTION PRIVATE LIMITED",
"CHOUBAY AND COMPANY(AGENCIES) PRIVATE LIMITED",
"CHOUBEY TRANSPORT CARRIERS PRIVATE LIMITED",
"CHOUDHARI CONSTRUCTION COMPANY",
"CHOUDHARY ADVISORY SERVICES PRIVATE LIMITED",
"CHOUDHARY AGENCIES PVT LTD",
"CHOUDHARY AND CHOUDHARY INFRATECH PRIVATE LIMITED",
"CHOUDHARY AUTOMOTIVES PRIVATE LIMITED",
"CHOUDHARY AVIATION FACILITIES PRIVATE LIMITED",
"CHOUDHARY BITUMEN AND ALLIED PRODUCTS PRIVATE LIMITED",
"CHOUDHARY BROTHERS AGRI EXPORTS PRIVATE LIMITED",
"CHOUDHARY BUILDMART PRIVATE LIMITED",
"CHOUDHARY CHEMIST",
"CHOUDHARY DIGINETWORK PRIVATE LIMITED",
"CHOUDHARY DOMESTIC APPLIANCES PVT LTD",
"CHOUDHARY FINLEASE PRIVATE LIMITED",
"CHOUDHARY GARMENTS",
"CHOUDHARY HYDRO CARBON PRIVATE LIMITED",
"CHOUDHARY ICE AND COLD STORAGE PVT LTD",
"CHOUDHARY INDUSTRIES PRIVATE LIMITED",
"CHOUDHARY INFRA INDIA PRIVATE LIMITED",
"CHOUDHARY INFRAHEIGHT PRIVATE LIMITED",
"CHOUDHARY INTERNATIONAL PRIVATE LIMITED",
"CHOUDHARY JAMNA DEVI SENIOR SECONDARY SCHOOL",
"CHOUDHARY MARBLE",
"CHOUDHARY MOVERS PRIVATE LIMITED",
"CHOUDHARY MULTISPECIALITY ENGINEERS PRIVATE LIMITED",
"CHOUDHARY MULTISPECIALITY HOSPITAL NAGPUR",
"CHOUDHARY OFFSET PRIVATE LIMITED",
"CHOUDHARY POWER PROJECTS PRIVATE LIMITED",
"CHOUDHARY RUBBERS PRIVATE LIMITED",
"CHOUDHARY STEELS PRIVATE LIMITED",
"CHOUDHARY SWEETS & NAMKEEN PRIVATE LIMITED",
"CHOUDHARY TOURS & TRAVELS PRIVATE LIMITED",
"CHOUDHARY TOURS AND TRAVELS PRIVATE LIMITED",
"CHOUDHARY TRACTORS PRIVATE LIMITED",
"CHOUDHARY TRANS SOLUTION PRIVATE LIMITED",
"CHOUDHARY-N-CHOUDHARY BELTING SERVICES PRIVATE LIMITED",
"CHOUDHERY CHEESE BAZAR PVT LTD",
"CHOUDHRY FINANCE AND INVESTMENTS PRIVATE LIMITED",
"CHOUDHURY COLD STORAGE PRIVATE LIMITED",
"CHOUDHURY DALL MILL PRIVATE LIMITED",
"CHOUGLE SALT WORKS PRIVATE LIMITED",
"CHOUGULE STEELS PRIVATE LIMITED",
"CHOUHAN AUTOMOBILES LLP",
"CHOUHAN HOUSING PRIVATE LIMITED",
"CHOUKI DHANI MOTELS (GUJARAT) PRIVATE LIMITED",
"CHOUKSEY AGRO PRIVATE LIMITED",
"CHOUKSEY ENGINEERING COLLEGE",
"CHOUKSEY ENTERTAINMENT LIMITED.",
"CHOURANGI BUILDERS & DEVELOPERS PRIVATE LIMITED",
"CHOURASIA CONSTRUCTIONS AND INFRASTRUCTURE INDIA PRIVATE LIMITED",
"CHOURASIA ELECTRICALS PRIVATE LIMITED",
"CHOWDARY SPINNERS LIMITED",
"CHOWDHARY ELASTIC PRIVATE LIMITED",
"CHOWDHARY FASHIONS PRIVATE LIMITED",
"CHOWDHARY OVERSEAS LIMITED",
"CHOWDHARY SWEET HOUSE",
"CHOWDHARY TUBES PRIVATE LIMITED",
"CHOWDHURY CEMENT & PAINTS TRADERS PRIVATE LIMITED",
"CHOWDHURY ESTATE PVT LTD",
"CHOWDHURY JEWELLERY MUSEUM PRIVATE LIMITED",
"CHOWDRY ASSOCIATES",
"CHOWGULE ABP COATINGS INDIA PRIVATE LIMITED",
"CHOWGULE AND COMPANY (SALT) PRIVATE LIMITED",
"CHOWGULE AND COMPANY PRIVATE LIMITED",
"CHOWGULE BROS PVT. LTD.,",
"CHOWGULE CONSTRUCTION CHEMICALS PRIVATE LIMITED",
"CHOWGULE EDUCATION SOCIETY",
"CHOWGULE FIBERGLASS SHIPS PRIVATE LIMITED",
"CHOWGULE INDUSTRIES PRIVATE LIMITED",
"CHOWGULE REAL ESTATE AND CONSTRUCTION COMPANY PRIVATE LIMITED",
"CHOWGULE WAREHOUSING & LOGISTICS SERVICES PRIVATE LIMITED",
"CHOWHAN VENTURES PRIVATE LIMITED",
"CHOWMAN HOSPITALITY PRIVATE LIMITED",
"CHOWRIAPPA CONSTRUCTIONS PRIVATE LIMITED",
"CHOWRINGHEE RESIDENCY PRIVATE LIMITED",
"CHR SOLUTIONS INDIA PRIVATE LIMITED",
"CHR.HANSEN INDIA PRIVATE LIMITED",
"CHRESO SERVICES PRIVATE LIMITED",
"CHRIS CANADIAN DEGREE COLLEGE",
"CHRIS MERCHANT PRIVATE LIMITED",
"CHRIS WEALTH MANAGEMENT PRIVATE LIMITED",
"CHRISCARS TOURS AND TRAVELS PRIVATE LIMITED",
"CHRISEL TECHNOLAB PRIVATE LIMITED",
"CHRISLEEN CLEANROOM PROJECTS PRIVATE LIMITED",
"CHRIST ACADEMY",
"CHRIST ARTS AND SCIENCE COLLEGE",
"CHRIST CHURCH COLLEGE",
"CHRIST CHURCH GIRLS HIGH SCHOOL",
"CHRIST CHURCH SCHOOL",
"CHRIST CMI PUBLIC SCHOOL",
"CHRIST HOSPITAL",
"CHRIST SCHOOL",
"CHRIST THE KING ENGINEERING COLLEGE",
"CHRIST THE KING INTER COLLEGE",
"CHRIST THE KING MATRICULATION HR SEC SCHOOL",
"CHRIST UNIVERSITY",
"CHRISTEL HOUSE INDIA",
"CHRISTEL METAL PRIVATE LIMITED",
"CHRISTIAN COLLEGE",
"CHRISTIAN COLLEGE OF ENGINEERING AND TECHNOLOGY",
"CHRISTIAN DIOR FINANCIAL SERVICES LIMITED",
"CHRISTIAN DIOR TRADING INDIA PRIVATE LIMITED",
"CHRISTIAN EMINENT HIGHER SECONDARY SCHOOL",
"CHRISTIAN INTER COLLEGE",
"CHRISTIAN LOUBOUTIN INDIA PRIVATE LIMITED",
"CHRISTIAN MEDICAL COLLEGE",
"CHRISTIAN MEDICAL HOSPITAL",
"CHRISTIAN MISSION SERVICE",
"CHRISTIANI SHARPLINE TECHNICAL TRAINING PRIVATE LIMITED",
"CHRISTIE DIGITAL SYSTEMS INDIA PRIVATE LIMITED",
"CHRISTIE'S INDIA PRIVATE LIMITED",
"CHRISTINE VALMY INSTITUTE PRIVATE LIMITED",
"CHRISTOPHER CHARLES BENNINGER ARCHITECTS PRIVATE LIMITED",
"CHRISTU JYOTHI INSTITUTE OF TECHNOLOGY & SCIENCE",
"CHRISTUDAS HOSPITAL",
"CHRISTUKULA MISSION HIGHER SECONDARY SCHOOL SATNA",
"CHRISTWOOD SCHOOL",
"CHRISTY APPARELS",
"CHRISTY APPARELS PRIVATE LIMITED",
"CHRISTY FABRIC PRIVATE LIMITED",
"CHRISTY FRIEDGRAM INDUSTRY",
"CHRISTY LINENS PRIVATE LIMITED",
"CHRISTY QUALITY FOODS INDIA PRIVATE LIMITED",
"CHRISTY TEXTILE PRODUCTS PRIVATE LIMITED",
"CHRIT MANAGED SERVICES INDIA PRIVATE LIMITED",
"CHROMA POWER SYSTEMS INDIA PRIVATE LIMITED",
"CHROMA-ATOR ENERGY SYSTEMS PRIVATE LIMITED",
"CHROMACHEM INDIA PRIVATE LIMITED",
"CHROMACHEMIE LABORATORY PRIVATE LIMITED",
"CHROMAFLO TECHNOLOGIES INDIA PRIVATE LIMITED",
"CHROMALOX INDIA PRECISION HEAT & CONTROL PRIVATE LIMITED",
"CHROMAPRINT INDIA PRIVATE LIMITED",
"CHROMATIC INFOSYSTEMS PRIVATE LIMITED",
"CHROMATOGRAPHY WORLD",
"CHROMATOPAK ANALYTICAL INSTRUMENTATION INDIA PRIVATE",
"CHROMCORE LIFESCIENCES LLP",
"CHROME AURA PRIVATE LIMITED",
"CHROME CHEMICALS PRIVATE LIMITED",
"CHROME COATERS PRIVATE LIMITED",
"CHROME DATA ANALYTICS & MEDIA PRIVATE LIMITED",
"CHROME INFOSOFT SOLUTIONS PRIVATE LIMITED",
"CHROME INTERNATIONAL COMPANY LIMITED",
"CHROME SILICON LIMITED",
"CHROMEINFO TECHNOLOGIES PRIVATE LIMITED",
"CHROMENI STEELS PRIVATE LIMITED",
"CHROMETAN EXPORTS PRIVATE LIMITED",
"CHROMEWELL ENGINEERING PRIVATE LIMITED",
"CHROMEWELL INDUSTRIES PRIVATE LIMITED",
"CHROMEX ANALYTICALS PRIVATE LIMITED",
"CHROMO HEALTH CARE PRIVATE LIMITED",
"CHROMO LABORATORIES PRIVATE LIMITED",
"CHROMO MEDCARE PRIVATE LIMITED",
"CHROMOGENIC LIFE SCIENCES (INDIA) PRIVATE LIMITED",
"CHROMOLIN CAPITAL CHEMICALS PRIVATE LIMITED",
"CHRONIC WATCH SOFTWARE PRIVATE LIMITED",
"CHRONICLE PUBLICATIONS PRIVATE LIMITED",
"CHRONOS IMAGING INDIA PRIVATE LIMITED",
"CHRONOS TECHNOLOGY PRIVATE LIMITED",
"CHRONOSPHERE TECHNOLOGIES PRIVATE LIMITED",
"CHRONUS SOFTWARE INDIA PRIVATE LIMITED",
"CHROPYNSKA INDIA PRIVATE LIMITED",
"CHRYODEX CONSTRUCTION CHEMICALS PRIVATE LIMITED",
"CHRYSALIS CASTING PRIVATE LIMITED",
"CHRYSALIS DIGITAL SOLUTIONS AND SERVICESPRIVATE LIMITED",
"CHRYSALIS DSS PRIVATE LIMITED",
"CHRYSALIS FINANCE LIMITED",
"CHRYSALIS HOMEN NEEDS PRIVATE LIMITED",
"CHRYSALIS MARKETING & FINANCIAL SERVICES PRIVATE LIMITED",
"CHRYSALIS SOFTWARE & SYSTEMS PRIVATE LIMITED",
"CHRYSALISIS SERVICES PRIVATE LIMITED",
"CHRYSCAPITAL INVESTMENT ADVISORS INDIA PRIVATE LIMITED",
"CHRYSEUS HATHAWAY INVESTMENTS PRIVATE LIMITED",
"CHRYSO HOTELS PRIVATE LIMITED",
"CHRYSO INDIA PRIVATE LIMITED",
"CHRYSTEC MACHINE TOOLS PRIVATE LIMITED",
"CHT INDIA PRIVATE LIMITED",
"CHUAN SHUN ELECTRIC COMPANY INDIA PRIVATE LIMITED",
"CHUAN TIAN HARDWARE IMPORT AND EXPORT PRIVATE LIMITED",
"CHUBB BUSINESS SERVICES INDIA LLP",
"CHUBB BUSINESS SERVICES INDIA PRIVATE LIMITED",
"CHUBB SYSTEMS PRIVATE LIMITED",
"CHUCHU TV STUDIOS LLP",
"CHUCKMATIC PRIVATE LIMITED",
"CHUDASAMA OUTSOURCING PRIVATE LIMITED",
"CHUDIALA SOLAR POWER PROJECTS PRIVATE LIMITED",
"CHUGH BROTHERS PRIVATE LIMITED",
"CHUGH CONSULTING (INDIA) LLP",
"CHUGH CONSULTING SERVICES (INDIA) PRIVATE LIMITED",
"CHUGOKU PAINTS (INDIA) PRIVATE LIMITED",
"CHUKAN BUTSU EXIM (INDIA) PRIVATE LIMITED",
"CHUKNOO SECURITIES LIMITED",
"CHULGIRI ENTERPRISES PRIVATE LIMITED",
"CHULHACHAUKI DA DHABA PRIVATE LIMITED",
"CHUMBAK DESIGN PRIVATE LIMITED",
"CHUNAR CHURK CEMENT LIMITED",
"CHUNCHUN ISPAT PRIVATE LIMITED",
"CHUNDURI FURNITURE PRIVATE LIMITED",
"CHUNG WAH RESTAURANT & HOTEL PVT LTD",
"CHUNGATH BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"CHUNGIBARIE TEA ESTATES PRIVATE LIMITED",
"CHUNILAL GANDHI VIDHYABHAVAN",
"CHUNK RECYCLING INDIA PRIVATE LIMITED",
"CHUNMUN STORES PRIVATE LIMITED",
"CHUNNILAL MEGAMART PRIVATE LIMITED",
"CHUNOBA GOLD PRIVATE LIMITED",
"CHUNRI COLLECTIONS PRIVATE LIMITED",
"CHUNRI SALES PRIVATE LIMITED",
"CHUR TEXTILES LIMITED",
"CHURAMANI HOUSING PVT. LTD.",
"CHURCH CHRIST PRIMARY SCHOOL",
"CHURCH OF SOUTH INDIA TRUST ASSOCIATION",
"CHURCHGATE ADVISORY PRIVATE LIMITED",
"CHURCHILL CONTRACTORS PRIVATE LIMITED",
"CHURIWAL COMMERCIAL COMPANY PVT LTD",
"CHURIWAL TECHNOPACK PRIVATE LIMITED",
"CHURIWALA PROPERTIES AND INVESTMENTS PVT LTD",
"CHURIWALA SECURITIES PRIVATE LIMITED",
"CHURROLTO FOODS PRIVATE LIMITED",
"CHURU FINVEST PRIVATE LIMITED",
"CHURUWALA HOSPITALITY PRIVATE LIMITED",
"CHUZAAR PHARMACEUTICALS PRIVATE LIMITED",
"CHVAC MACHINERY SOLUTIONS PRIVATE LIMITED",
"CHW FORGE PRIVATE LIMITED",
"CHYAWAN AYURVEDA HEALTH CARE PRIVATE LIMITED",
"CI CAPITAL PRIVATE LIMITED",
"CI CAR INTERNATIONAL PRIVATE LIMITED",
"CI GLOBAL TECHNOLOGIES PRIVATE LIMITED",
"CI SCIENTISTS PRIVATE LIMITED",
"CIA ISPAT INDIA PRIVATE LIMITED",
"CIAGA PRIVATE LIMITED",
"CIAL DUTYFREE AND RETAIL SERVICES LIMITED",
"CIAL INFRASTRUCTURES LIMITED",
"CIALFO SUBCONTINENT PRIVATE LIMITED",
"CIAN AGRO INDUSTRIES & INFRASTRUCTURE LIMITED",
"CIAN AGROTECH PRIVATE LIMITED",
"CIAN HEALTHCARE LIMITED",
"CIAN HEALTHCARE PRIVATE LIMITED",
"CIANS ANALYTICS PRIVATE LIMITED",
"CIBA LIFESTYLE AND ASSOCIATES PRIVATE LIMITED",
"CIBA MASALA UDYOG PRIVATE LIMITED",
"CIBANOVA LIFE SCIENCES PRIVATE LIMITED",
"CIBELA CERAMIC PRIVATE LIMITED",
"CIBELES PHARMACEUTICALS PRIVATE LIMITED",
"CIBERSITES INDIA PRIVATE LIMITED",
"CIBERSPRING INTERNATIONAL (INDIA) LLP",
"CIBERSPRING TECHNOLOGIES INDIA PRIVATE LIMITED",
"CIBES LIFT INDIA PRIVATE LIMITED",
"CIBI INTERNATIONAL PRIVATE LIMITED",
"CIBO EDIBLE PRODUCTS PRIVATE LIMITED",
"CIC LOGISTICS PRIVATE LIMITED",
"CIC VISION INDIA PRIVATE LIMITED",
"CICB-CHEMICON PRIVATE LIMITED",
"CICC AUTOMATION TECHNOLOGIES PRIVATE LT",
"CICLO CAFE PRIVATE LIMITED",
"CICLO ESSENTIALS PRIVATE LIMITED",
"CICO TECHNOLOGIES LIMITED",
"CICON ENGINEERS PRIVATE LIMITED",
"CIDAR FACADES PRIVATE LIMITED",
"CIDC PRIVATE LIMITED",
"CIDCO",
"CIDERMATICS PRIVATE LIMITED",
"CIDP BIOTECH INDIA PRIVATE LIMITED",
"CIE ALUMINIUM CASTING INDIA LIMITED",
"CIE AUTOMOTIVE INDIA LIMITED",
"CIEL ET TERRE SOLAR PRIVATE LIMITED",
"CIEL HR SERVICES LIMITED",
"CIEL HR SERVICES PRIVATE LIMITED",
"CIEL PHARMA PRIVATE LIMITED",
"CIEL SALES PRIVATE LIMITED",
"CIEL TECHNOLOGIES PRIVATE LIMITED",
"CIELO BIOTECH PRIVATE LIMITED",
"CIELO FINANCE PRIVATE LIMITED",
"CIELO TALENT INDIA PRIVATE LIMITED",
"CIENA COMMUNICATIONS INDIA PRIVATE LIMITED",
"CIENA INDIA PRIVATE LIMITED",
"CIENTRA TECHSOLUTION PRIVATE LIMITED",
"CIEO REMEDIE",
"CIERA TECHNOLOGIES PRIVATE LIMITED",
"CIESS TEXAUX SPECIALITY CHEMICALS PRIVATE LIMITED",
"CIESTA HOTELS PRIVATE LIMITED",
"CIFA INTEGRATED PROPERTIES PRIVATE LIMITED",
"CIFCO LIMITED",
"CIGFIL LIMITED.",
"CIGFIL RETAIL PRIVATE LIMITED",
"CIGMA EVENTS PRIVATE LIMITED",
"CIGMA MEDICAL CODING PRIVATE LIMITED",
"CIGMA PRODUCTS & DESIGN PRIVATE LIMITED",
"CIGMA TECHNO LAB PRIVATE LIMITED",
"CIGNA FLEX PRIVATE LIMITED",
"CIGNA HEALTH SOLUTIONS INDIA PRIVATE LIMITED",
"CIGNEX DATAMATICS TECHNOLOGIES LIMITED",
"CIGNEX TECHNOLOGIES PRIVATE LIMITED",
"CIGNITI TECHNOLOGIES LIMITED",
"CIGORA EXIM PRIVATE LIMITED",
"CII GUARDIAN INTERNATIONAL LIMITED",
"CIIE ADVISORS PRIVATE LIMITED",
"CIIF LUBRICANTS PRIVATE. LIMITED",
"CIIGMA INSTITUTE OF MEDICAL SCIENCES PRIVATE LIMITED",
"CIIM SERVICES PRIVATE LIMITED",
"CIINDIAPRIVATE LIMITED",
"CIK TELECOM INDIA PRIVATE LIMITED",
"CIKAUTXO INDIA PRIVATE LIMITED",
"CIKIT ELECTRICALS & TECHNOLOGIES INDIA PRIVATE LIMITED",
"CIL INDUSTRIES LIMITED",
"CIL NAVIKARNIYA URJA LIMITED",
"CIL NOVA PETROCHEMICALS LIMITED",
"CIL SECURITIES LIMITED",
"CIL SOLAR PV LIMITED",
"CIL TEXTILES PRIVATE. LIMITED.",
"CILA AGROTECH PRIVATE LIMITED",
"CILA INCUBATOR PRIVATE LIMITED",
"CILANS SYSTEM PRIVATE LIMITED",
"CILANTRO CHEMICALS PRIVATE LIMITED",
"CILANTRO DINERS PRIVATE LIMITED",
"CILICANT PRIVATE LIMITED",
"CILIX CAPITAL ADVISORS PRIVATE LIMITED",
"CIM GLOBAL INDIA PRIVATE LIMITED",
"CIM NATURE CURE HOSPITAL",
"CIM TOOLS PRIVATE LIMITED",
"CIMA GALLERY PRIVATE LIMITED",
"CIMAR HOSPITAL",
"CIMCON INFOTECH PRIVATE LIMITED",
"CIMCON SOFTWARE INDIA PRIVATE LIMITED",
"CIMCORP INDUSTRIAL AUTOMATION INDIA PRIVATE LIMITED",
"CIMEC INFRALABS PRIVATE LIMITED",
"CIMEC TECHNOLOGIES PRIVATE LIMITED",
"CIMECHEL ELECTRIC COMPANY CEC",
"CIMECHEL ELECTRIC PRIVATE LIMITED",
"CIMIC TECH (INDIA) PRIVATE LIMITED",
"CIMMCO VINIMAY PVT LTD",
"CIMMONS INTEGRATED SERVICES PRIVATE LIMITED",
"CIMPEX PACKAGING PRIVATE LIMITED",
"CIMPLYFIVE CORPORATE SECRETARIAL SERVICES PRIVATE LIMITED",
"CIMPRESS INDIA PRIVATE LIMITED",
"CIMS HOSPITAL PRIVATE LIMITED",
"CIMS MEDICA INDIA PRIVATE LIMITED",
"CIMWORKS TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"CINCH BUSINESS SOLUTIONS PRIVATE LIMITED",
"CINCOM REALESTATES PRIVATE LIMITED",
"CINCOM SYSTEMS INDIA PRIVATE LIMITED",
"CINCORP INTERNATIONAL LIMITED",
"CINDA ENGINEERING & CONSTRUCTION PRIVATE LIMITED",
"CINDER METALS PRIVATE LIMITED",
"CINDERELLA FLORA FARMS PVT LTD",
"CINDRAL TECHNOLOGIES PRIVATE LIMITED",
"CINDREBAY INSTITUTE OF DESIGNS PRIVATE LIMITED",
"CINDRELLA HOTELS LTD",
"CINDY ENGINEERING PVT LTD",
"CINE CITY PHOTO EQUIPMENTS PRIVATE LIMITED",
"CINE PARK CINEMAS PRIVATE LIMITED",
"CINE SQUARE ENTERTAINMENT PRIVATE LIMITED",
"CINE TEKK ELECTRONIC & ENGINEERS PRIVATE LIMITED",
"CINE1 STUDIOS PRIVATE LIMITED",
"CINECITA PRIVATE LIMITED",
"CINEGENCE MEDIA PRIVATE LIMITED",
"CINEHIVE WEB TECHNOLOGIES PRIVATE LIMITED",
"CINEKORN ENTERTAINMENT PRIVATE LIMITED",
"CINELINE INDIA LIMITED",
"CINEMA 24X7 PRIVATE LIMITED",
"CINEMA CAPITAL ADVISORY PRIVATE LIMITED",
"CINEMACRAFT INDIA PRIVATE LIMITED",
"CINEMATICA DIGITALS PRIVATE LIMITED",
"CINEMATION MEDIA WORKS PRIVATE LIMITED",
"CINEMEDIA PRIVATE LIMITED",
"CINEMETA ENT. PRIVATE LIMITED",
"CINEOM BROADCAST INDIA LIMITED",
"CINEPLEX PRIVATE LIMITED",
"CINEPOLIS INDIA PRIVATE LIMITED",
"CINERAMA PRIVATE LIMITED",
"CINEREA BIOTECH PRIVATE LIMITED",
"CINESONIC AUDIO-VISUAL PRIVATE LIMITED",
"CINESTAAN DIGITAL PRIVATE LIMITED",
"CINESTAAN FILM COMPANY PRIVATE LIMITED",
"CINETICO HEALTHCARE PRIVATE LIMITED",
"CINETICO TECHNOLOGY PRIVATE LIMITED",
"CINEVISTA LIMITED",
"CINEYUG ENTERTAINMENT PRIVATE LIMITED",
"CINEYUG INTERNATIONAL ENTERTAINMENT PRIVATE LIMITED",
"CINEYUG MEDIA & ENTERTAINMENT PRIVATE LI",
"CINGULARITY TOOLING AND ENGINEERING CONCEPTS INDIA PRIVATE LIMITED",
"CINI CHEM LABORATORIES PRIVATE LIMITED",
"CINI COMMUNITY INITIATIVES",
"CINIMAGE STUDIOS PRIVATE LIMITED",
"CINKO METALIC (INDIA) PRIVATE LIMITED",
"CINNAMON BOUTIQUE PRIVATE LIMITED",
"CINNATOLLIAH TEA LIMITED",
"CINNI PRIVATE LIMITED",
"CINNTRA INFO TECH SOLUTIONS PRIVATE LIMITED",
"CINQ MICRON CHEM PRIVATE LIMITED",
"CINQUE FOODS PRIVATE LIMITED",
"CINQUE SOLUTIONS PRIVATE LIMITED",
"CINTEC STEEL PRIVATE LIMITED",
"CINTELLIGENCE SERVICES PRIVATE LIMITED",
"CINTHAMANI COMPUTER PRIVATE LIMITED",
"CINTRA SOFTWARE PRIVATE LIMITED",
"CINTURONES ALVI (INDIA) PRIVATE LIMITED",
"CINZAC SALES AND SERVICES PRIVATE LIMITED",
"CIO TYRES PVT LTD",
"CIPACA FOUNDATION",
"CIPET CSTS BHOPAL",
"CIPHER - PLEXUS CAPITAL ADVISORS PRIVATE LIMITED",
"CIPHER CAPITAL ADVISORS PRIVATE LIMITED",
"CIPHER DYNAMICS IT SERVICES PRIVATE LIMITED",
"CIPHER ONCOLOGY PRIVATE LIMITED",
"CIPHER RESEARCH PRIVATE LIMITED",
"CIPHERCLOUD INDIA PRIVATE LIMITED",
"CIPHERSQUARE DIGITAL PRIVATE LIMITED",
"CIPIND SOLUTIONS PRIVATE LIMITED",
"CIPIO INDIA PRIVATE LIMITED",
"CIPL INDIA PRIVATE LIMITED",
"CIPLA BIOTECH PRIVATE LIMITED",
"CIPLA CANCER AND AIDS FOUNDATION",
"CIPLA DIGITAL HEALTH LIMITED",
"CIPLA DISTRIBUTORS PVT LTD",
"CIPLA FOUNDATION",
"CIPLA HEALTH LIMITED",
"CIPLA INDUSTRIES PRIVATE LIMITED",
"CIPLA LIMITED",
"CIPLA PALLIATIVE CARE & TRAINING CENTER",
"CIPLA PHARMA AND LIFE SCIENCES LIMITED",
"CIPNA SEED COMPANY PRIVATE LIMITED",
"CIPPO MERCANTILE PRIVATE LIMITED",
"CIPRIANI HARRISON VALVES PRIVATE LIMITED",
"CIPY POLYURETHANES PRIVATE LIMITED",
"CIRA RENEWABLE ENERGY PRIVATE LIMITED",
"CIRBRID GREENOGY (I) PRIVATE LIMITED",
"CIRCLE CARGO PRIVATE LIMITED",
"CIRCLE E INTERNATIONAL PRIVATE LIMITED",
"CIRCLE E RETAIL PRIVATE LIMITED",
"CIRCLE EVENT PRIVATE LIMITED",
"CIRCLE IT SOLUTIONS PRIVATE LIMITED",
"CIRCLE LOGISTICS INDIA PRIVATE LIMITED",
"CIRCLE OUTSOURCING PRIVATE LIMITED",
"CIRCLEWORKS INDIA PRIVATE LIMITED",
"CIRCLIPS TECHNOLOGIE PRIVATE LIMITED",
"CIRCOR FLOW TECHNOLOGIES INDIA PRIVATE LIMITED",
"CIRCUIT SYSTEMS (INDIA) PRIVATE LIMITED",
"CIRCUIT WORLD INDIA PRIVATE LIMITED",
"CIRCUITECT ELECTRONIC SOLUTIONS PRIVATE LIMITED",
"CIRCUITS99 AUTOMOTIVE (OPC) PRIVATE LIMITED",
"CIRCUITSUTRA TECHNOLOGIES PRIVATE LIMITED",
"CIRCULANT SOFTWARE PRIVATE LIMITED",
"CIRCULAR AIRCON SERVICES PRIVATE LIMITED",
"CIRCULAR ANGLE PRIVATE LIMITED",
"CIRCULAR EDGE SOLUTIONS PRIVATE LIMITED",
"CIRCUS ELEPHANTS VIDEO SOLUTIONS PRIVATE LIMITED",
"CIRCUTOR ENERGY MANAGEMENT INDIA PRIVATE LIMITED",
"CIREX PHARMACEUTICALS PRIVATE LIMITED",
"CIRIA INDIA LIMITED",
"CIRIA TANNING CO PVT LTD",
"CIRIFORT ENTERPRISES PRIVATE LIMITED",
"CIRIGHT ENTERPRISE PRIVATE LIMITED",
"CIRKIT ELECTRO-COMPONENTS PRIVATE LIMITED",
"CIRO ENERGY",
"CIRON DRUGS AND PHARMACEUTICALS PRIVATE LIMITED",
"CIR-Q-TECH TAKO TECHNOLOGIES PRIVATE LIMITED",
"CIRRIUS TECHNOLOGIES PRIVATE LIMITED",
"CIRROLOGIX TECHNOLOGIES PRIVATE LIMITED",
"CIRRUS ENGINEERING AND SERVICES PRIVATE LIMITED",
"CIRRUS GRAPHICS PRIVATE LIMITED",
"CIRRUS TRAVELS PRIVATE LIMITED",
"CIRRUSLABS PRIVATE LIMITED",
"CIRRUSRAYS PRIVATE LIMITED",
"CIRSIUM TECHNOLOGIES PRIVATE LIMITED",
"CIRUS SOLAR PRIVATE LIMITED",
"CIRUS SOLAR SYSTEMS PRIVATE LIMITED",
"CIS COMMODITY INSPECTION SERVICES (INDIA) PRIVATE LIMITED",
"CIS CONNECT GLOBAL LOGISTICS PRIVATE LIMITED",
"CIS GLOBAL INFRATECH PRIVATE LIMITED",
"CIS INFOSYS PRIVATE LIMITED",
"CIS SPECILTY CHEMICAL PRIVATE LIMITED",
"CISB & KUSHWAH DEVELOPERS PRIVATE LIMITED",
"CISB SERVICES PRIVATE LIMITED",
"CISCO COMMERCE INDIA PRIVATE LIMITED",
"CISCO SERVICES & SPARES INDIA PRIVATE LIMITED",
"CISCO STEELS PRIVATE LIMITED",
"CISCO SYSTEMS (INDIA) PRIVATE LIMITED",
"CISCO SYSTEMS CAPITAL (INDIA) PRIVATE LIMITED",
"CISCO SYSTEMS INC.",
"CISCOM COMMUNICATIONS PRIVATE LIMITED",
"CISCONS CONSTRUCTIONS PRIVATE LIMITED",
"CISEN PHARMACEUTICALS INDIA PRIVATE LIMITED",
"CISFIBER INFRA SOLUTIONS PRIVATE LIMITED",
"CISIVE INDIA PRIVATE LIMITED",
"CISMAC AUTOMATION PRIVATE LIMITED",
"CISONS EXPORTS PRIVATE LIMITED",
"CISS ACADEMY FOR SKILL HUMAN DEVELOPMENT PRIVATE LIMITED",
"CISTEMS (SOFTWARE) PRIVATE LIMITED",
"CISTRON INFOTEK PRIVATE LIMITED",
"CISTRON SYSTEMS PVT LTD",
"CISTRONICS TECHNOVATIONS PRIVATE LIMITED",
"CISWW ENGINEERING INDIA PRIVATE LIMITED",
"CIT CENTRAL PODDAR COURT KOLKATA",
"CIT INFRATEL PRIVATE LIMITED",
"CIT-1 INDORE",
"CITADEL BUILDING SYSTEM PRIVATE LIMITED",
"CITADEL CONTRACTORS PRIVATE LIMITED",
"CITADEL IMPEX PRIVATE LIMITED",
"CITADEL INTELLIGENT SYSTEMS LIMITED",
"CITADEL INTERIORS PRIVATE LIMITED",
"CITADEL MANAGEMENT CONSULTING PRIVATE LIMITED",
"CITADEL REALTY AND DEVELOPERS LIMITED",
"CITADEL RESEARCH AND SOLUTIONS LIMITED",
"CITADEL RESEARCH AND SOLUTIONS PRIVATE LIMITED",
"CITADEL SWM PROJECT JABALPUR PRIVATE LIMITED",
"CITADEL TEXTILES PRIVATE LIMITED",
"CITADEL TRADECOM PRIVATE LIMITED",
"CITCO GROUP SERVICES (INDIA) LLP",
"CITCO INDIA PVT LTD",
"CITCO SHARED SERVICES INDIA PRIVATE LIMITED",
"CITCO VYAPAAR PVT.LTD.",
"CITEC ENGINEERING INDIA PRIVATE LIMITED",
"CITEL SURGE PROTECTION PRIVATE LIMITED",
"CITELUM INDIA PRIVATE LIMITED",
"CITI ABASAN PRIVATE LIMITED",
"CITI BANK INDIA PAYROLL",
"CITI CARE HOSPITAL PRIVATE LIMITED",
"CITI COLLECTIONS INDIA PRIVATE LIMITED",
"CITI CORP SRVICES INDIA PRIVATE LIMITED",
"CITI HOSPITAL",
"CITI INFRAVENTURES PRIVATE LIMITED",
"CITI LOGISTICS PRIVATE LIMITED",
"CITI MEGA MART PRIVATE LIMITED",
"CITI SOLUTIONS PRIVATE LIMITED",
"CITI SOLUTIONS WAREHOUSING & DISTRIBUTION PRIVATE LIMITED",
"CITI STAR DISTRIBUTORS PRIVATE LIMITED",
"CITI VENTURES PRIVATE LIMITED",
"CITIALERT SECURITY PRIVATE LIMITED",
"CITIBANK",
"CITIC INDUSTRIAL BANK",
"CITICHEM INDIA LIMITED",
"CITICON ENGINEERS LIMITED",
"CITICORP FINANCE INDIA LIMITED",
"CITICORP SERVICES INDIA PRIVATE LIMITED",
"CITIFIX ADHESIVES PRIVATE LIMITED",
"CITIGATE DEWE ROGERSON COMMUNICTIONS PRIVATE LIMITED",
"CITIGIRL LIFESTYLE PRIVATE LIMITED",
"CITIGROUP",
"CITIGROUP GLOBAL MARKETS INDIA PRIVATE LIMITED",
"CITILAB HEALTHCARE INDIA PRIVATE LIMITED",
"CITILIGHTS ESTATES PRIVATE LIMITED",
"CITILINE TEXFAB PRIVATE LIMITED",
"CITIMED LIFECARE PRIVATE LIMITED",
"CITIMEDIA GLOBALSOLUTIONS PRIVATE LIMITED",
"CITINETWORK LOGISTIC PRIVATE LIMITED",
"CITISOLUTIONS HOSPITALITY PRODUCTS PRIVATE LIMITED",
"CITIUS BPO INDIA PRIVATE LIMITED",
"CITIUS COMMUNICATIONS PRIVATE LIMITED",
"CITIUS HOLIDAYS PRIVATE LIMITED",
"CITIUS TECH HEALTHCARE TECHNOLOGY PRIVATE LIMITED",
"CITIUSCLOUD SERVICES LLP",
"CITIUSTECH HEALTHCARE TECHNOLOGY PRIVATE LIMITED",
"CITIXSYS TECH SOLUTIONS PRIVATE LIMITED",
"CITIXSYS TECHNOLOGIES LIMITED",
"CITIZEN BUECHEL BIKETECH PRIVATE LIMITED",
"CITIZEN EXPORTS PRIVATE LIMITED",
"CITIZEN HOTELS PRIVATE LIMITED",
"CITIZEN INDUSTRIES",
"CITIZEN INDUSTRIES LIMITED",
"CITIZEN INDUSTRIES PRIVATE LIMITED",
"CITIZEN INFOLINE LIMITED",
"CITIZEN ISPAT PRIVATE LIMITED",
"CITIZEN MEDICOS PRIVATE LIMITED",
"CITIZEN METALLOYS LIMITED",
"CITIZEN MONEYLINE (INDIA) LIMITED",
"CITIZEN MOTELS INTERNATIONAL LTD",
"CITIZEN PACKAGING INDUSTRIES PVT LTD",
"CITIZEN PRESS COMPONMENTS",
"CITIZEN REMEDIES PRIVATE LIMITED",
"CITIZEN SOLAR PRIVATE LIMITED",
"CITIZEN SYNTHETICS PRIVATE LIMITED",
"CITIZEN UMBRELLA MANUFACTURERS LIMITED.",
"CITIZEN URDU PRIMARY AND MIDDLE SCHOOL LALKHADI AMRAVATI",
"CITIZEN WATCHES INDIA LIMITED",
"CITIZENCREDIT CO OPERATIVE BANK LTD",
"CITIZENPLUS PHARMACEUTICALS PRIVATE LIMITED",
"CITIZENS ALLIANCE PRIVATE LIMITED",
"CITIZENS ASSOCIATION FOR CHILD RIGHTS",
"CITIZENS EDUCATIONAL FOUNDATION",
"CITIZENS FOUNDATION",
"CITIZENS HOSPITALS",
"CITIZEN'S SCHOOL",
"CITIZENS SPECIALITY HOSPITAL",
"CITLAND COMMERCIAL CREDITS LIMITED",
"CITO AUCTUS INFRASTRUCTURE PRIVATE LIMITED",
"CITO CHEM INDUSTRIES PVT.LTD.",
"CITO INFOTECH PRIVATE LIMITED",
"CITO VISION INDIA PRIVATE LIMITED",
"CITOC VENTURES PRIVATE LIMITED",
"CITRA AGRO PEIXE PRIVATE LIMITED",
"CITRA FINANCIALS PRIVATE LIMITED",
"CITRA PANJI CONSTRUCTION PRIVATE LIMITED",
"CITRA PROPERTIES LIMITED",
"CITRA REAL ESTATE LIMITED",
"CITRIC HEALTH CARE PRIVATE LIMITED",
"CITRIN COOPERMAN INDIA LLP",
"CITRINE BUSINESS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"CITRINE FOODS PRIVATE LIMITED",
"CITRINE HOSPITALITY VENTURES PRIVATE LIMITED",
"CITRINE RESOURCES PRIVATE LIMITED",
"CITRIX SYSTEMS INDIA PRIVATE LIMITED",
"CITRO PHARMA PRIVATE LIMITED",
"CITROEN SWITCHGEARS PRIVATE LIMITED",
"CITRON CONSULTING & SOLUTIONS PRIVATE LIMITED",
"CITRON ECOPOWER PRIVATE LIMITED",
"CITRON INFRAPROJECTS LIMITED",
"CITRON MARINE PRIVATE LIMITED",
"CITRON STRATEGIES PRIVATE LIMITED",
"CITRUS FASHIONS PVT LTD",
"CITRUS GLOBAL BRANDS LIMITED",
"CITRUS INFORMATICS INDIA PRIVATE LIMITED",
"CITRUS INFOTECH PRIVATE LIMITED",
"CITRUS INFRASTRUCTURE PRIVATE LIMITED",
"CITRUS LIFE SCIENCES PRIVATE LIMITED",
"CITRUS PACKAGING SOLUTIONS PRIVATE LIMITED",
"CITRUS PAYMENT SOLUTIONS PRIVATE LIMITED",
"CITRUS PROCESSING INDIA PRIVATE LIMITED",
"CITRUS RESORTS PRIVATE LIMITED",
"CITRUS SOLUTIONS PRIVATE LIMITED",
"CITTABASE SOLUTIONS PRIVATE LIMITED",
"CITUS RESEARCH LLP",
"CITY ALLOYS PRIVATE LIMITED",
"CITY AND INDUSTRIAL DEVELOPMENT CORP OF MAHARASHTRA LIMITED",
"CITY AUTO PRIVATE LIMITED",
"CITY AUTOMATION PRIVATE LIMITED",
"CITY BEAUTIFUL HOTELS AND RESORTS PRIVATE LIMITED",
"CITY BOND HOLDINGS PLC",
"CITY BOWL INDIA PRIVATE LIMITED",
"CITY BROADBAND NETWORK PRIVATE LIMITED",
"CITY BUSINESS SERVICES PRIVATE LIMITED",
"CITY CARE HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED",
"CITY CAT INTERNATIONAL LIMITED",
"CITY CEMENT PRIVATE LIMITED",
"CITY CENTRAL HOSPITAL PRIVATE LIMITED",
"CITY CENTRE HOTELS PRIVATE LIMITED",
"CITY CENTRE MALL NASHIK PRIVATE LIMITED",
"CITY CIVIL COURT CALCUTTA",
"CITY CLINIC PVT LTD",
"CITY COLLEGE",
"CITY COLLEGE OF COMMERCE",
"CITY CORPORATION LIMITED",
"CITY CROPS AGRO LIMITED",
"CITY DRUGS PRIVATE LIMITED",
"CITY ELECTRONICS PRIVATE LIMITED",
"CITY ELEVATORS PRIVATE LIMITED",
"CITY EQUIPLINK PRIVATE LIMITED",
"CITY EXPERTS GENERAL TRADING PRIVATE LIMITED",
"CITY FIRST FINANCIAL ADVISOR PRIVATE LIMITED",
"CITY FOOTBALL INDIA PRIVATE LIMITED",
"CITY GOLD ENTERTAINMENT PRIVATE. LIMITED",
"CITY HABITAT PROJECTS PRIVATE LIMITED",
"CITY HAWKS MANPOWER SERVICES AND CONSULTANCY PRIVATE LIMITED",
"CITY HEALTH SOLUTIONS PRIVATE LIMITED",
"CITY HEART HOTELS PRIVATE LIMITED",
"CITY HIGH SCHOOL SHAHADA",
"CITY HOME AFFORDABLE LLP",
"CITY HOME DEVELOPERS PRIVATE LIMITED",
"CITY HOSIERY PRIVATE LIMITED",
"CITY HOSPITAL AND DIAGNOSTIC CENTRE PRIVATE LIMITED",
"CITY HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED",
"CITY HOSPITAL CHARITABLE TRUST",
"CITY HOSPITAL PVT LTD",
"CITY HOUSING NIDHI LIMITED",
"CITY IMAGING AND CLINICAL LABS LLP",
"CITY INN PRIVATE LIMITED",
"CITY INSTITUTE OF MEDICAL SCIENCES",
"CITY INSTITUTE OF MEDICAL SCIENCES KERALA PRIVATE LIMITED",
"CITY INTERNATIONAL SCHOOL",
"CITY KONNECT ENTERPRISES PRIVATE LIMITED",
"CITY LIFELINE TRAVELS PRIVATE LIMITED",
"CITY LIFESTYLES PRIVATE LIMITED",
"CITY LIFTS (INDIA) LIMITED",
"CITY LINE DEVELOPERS PRIVATE LIMITED",
"CITY LINERS GLOBAL LIMITED",
"CITY LINK PORTAL PRIVATE LIMITED",
"CITY LUBRICANTS PRIVATE LIMITED",
"CITY MARKET DEPARTMENTAL STORE PVT. LTD.",
"CITY MONTESSORI SCHOOL",
"CITY MOTELS ANDN RESORTS PRIVATE LIMITED",
"CITY MOTORS PVT LTD",
"CITY MRI CENTRE PRIVATE LIMITED",
"CITY MULTITECH PRIVATE LIMITED",
"CITY NETWORK BROADCAST CONVERGENCE PRIVATE LIMITED",
"CITY NEXT DEVELOPERS PRIVATE LIMITED",
"CITY ONE RESTAURANT PRIVATE LIMITED",
"CITY ONLINE SERVICES LIMITED",
"CITY ORGANISERS PRIVATE LIMITED",
"CITY PHARMA DISTRIBUTORS PRIVATE LIMITED",
"CITY PLUS FUNWORLD PRIVATE LIMITED",
"CITY PRIDE SCHOOL",
"CITY PROMOTER & BUILDWELL PRIVATE LIMITED",
"CITY PROPERTIES MAINTENANCE COMPANY BANGALORE LIMITED",
"CITY PULSE MEDIA (INDIA) LIMITED",
"CITY PULSE THEATRES PRIVATE LIMITED",
"CITY QUILTEX MERCANTILE PRIVATE LIMITED",
"CITY REALTY & DEVELOPMENT PRIVATE LIMITED",
"CITY RESIDENCY (INDIA) PRIVATE LIMITED",
"CITY ROLLING MILLS PRIVATE LIMITED",
"CITY SERVICE CENTRE PRIVATE LIMITED",
"CITY SERVICE CONSULTING PRIVATE LIMITED",
"CITY SQUARE MEGA MALL PRIVATE LIMITED",
"CITY SURVEY SUPRITENDENT",
"CITY SURVEY SUPRITENDENT OFFICE GANDHINAGAR",
"CITY TEA JUNCTION PRIVATE LIMITED",
"CITY THEATRES PVT LTD",
"CITY TOWER HOSPITAL",
"CITY TRADE ARCADE PRIVATE LIMITED",
"CITY TRANSPORT SYNDICATE PRIVATE LIMITED",
"CITY TRENDS PRIVATE LIMITED",
"CITY TUBER DOLOR PRIVATE LIMITED",
"CITY UNION BANK LIMITED",
"CITY VACATIONS PRIVATE LIMITED",
"CITY WALK FOOTWEAR PRIVATE LIMITED",
"CITY X RAY AND SCAN CLINIC PRIVATE LIMITED",
"CITYBAZAAR HUB PRIVATE LIMITED",
"CITYCIRCUIT TECHNOLOGIES PRIVATE LIMITED",
"CITYCON BUILDWEL PRIVATE LIMITED",
"CITYEX LOGITECH PRIVATE LIMITED",
"CITYFURNISH INDIA PRIVATE LIMITED",
"CITYGLIDE TRAVEL SOLUTIONS PRIVATE LIMITED",
"CITYGOLD INVESTMENTS PRIVATE LIMITED",
"CITYGREEN AGRO PRIVATE LIMITED",
"CITYGREEN AUTO AND PETROCHEMICALS PRIVATE LIMITED",
"CITYHEART BUILDCON PRIVATE LIMITED",
"CITYHOSPITAL MEDICARE PRIVATE LIMITED",
"CITYINFO SERVICES PRIVATE LIMITED",
"CITYKART STORES PRIVATE LIMITED",
"CITYKART VENTURES PRIVATE LIMITED",
"CITYLIFE OVERSEAS PRIVATE LIMITED",
"CITYLIFE TECHNOLOGIES PRIVATE LIMITED",
"CITYLINE NETWORKS PRIVATE LIMITED",
"CITYMAKER BUILDERS PRIVATE LIMITED",
"CITYMAN LIMITED",
"CITYMAX HOTELS INDIA PRIVATE LIMITED",
"CITYPLUS AUTOMOBILES PRIVATE LIMITED",
"CITYSTAR INFRASTRUCTURES LIMITED",
"CITYTECH SOFTWARE PRIVATE LIMITED",
"CITYWOOD BUILDERS PRIVATE LIMITED",
"CITYZONE FREIGHT AND FORWARDERS PRIVATE LIMITED",
"CIVCON CONSTRUCTION PVT LTD",
"CIVENTICHEM INDIA PRIVATE LIMITED",
"CIVIC INDIA M FAR HABITAT AND INFRASTRUCTURE PRIVATE LIMITED",
"CIVIC INFRAPROJECTS PRIVATE LIMITED",
"CIVIC SOLUTIONS PRIVATE LIMITED",
"CIVICA RESOURCE PRIVATE LIMITED",
"CIVICDATALAB PRIVATE LIMITED",
"CIVICON HITECH PRIVATE LIMITED",
"CIVIL AND CRIMINAL COURT JUNIOR DIVISION PATAN",
"CIVIL AND CRIMINAL COURT PIMPRI",
"CIVIL CORE PROJECTS (INDIA) PRIVATE LIMITED",
"CIVIL COURT",
"CIVIL COURT DAKOR",
"CIVIL DEFENCE",
"CIVIL GEOTECH CONSOCIATES LLP",
"CIVIL HOSPITAL",
"CIVIL HOSPITAL PULGAON WARDHA",
"CIVIL JUDGE & JUDL MAG DUNI",
"CIVIL JUDGE J D AND JMFC VASHI",
"CIVIL JUDGE JD AND JMFC NILANGA",
"CIVIL JUDGE JD AND JMFC UDGIR",
"CIVIL JUDGE SENIOR DIVISION",
"CIVIL JUDGE SENIOR DIVISION KHED RAJGURUNAGAR DIST PUNE",
"CIVIL JUDGE SENIOR DIVISION NIMAPARA",
"CIVIL JUDGE SR DN SATARA",
"CIVIL PROTECTION FORCE PRIVATE LIMITED",
"CIVIL SURGE0N GENERAL HOSPITAL BEED",
"CIVIL SURGEN CUM SUPDT HOSPITAL MORENA",
"CIVIL SURGEN DISTRICT HOSPITAL VIDISHA",
"CIVIL SURGEON CIVIL HOSPITAL AURANGABAD",
"CIVIL SURGEON CIVIL HOSPITAL JALGAON",
"CIVIL SURGEON CUM CHIEF HOSPITAL SUPDT GWALIOR",
"CIVIL SURGEON CUM HOSPITAL SUPDT MAIN HOSPITAL¬†JABALPUR",
"CIVIL SURGEON CUM SUPDT",
"CIVIL SURGEON CUM SUPDTT DISTT J P HOSPITAL BHOPAL MADHYA PRADESH",
"CIVIL SURGEON DISTRICT HOSPITAL GADCHIROLI",
"CIVIL SURGEON GENERAL HOSPITAL",
"CIVIL SURGEON GENERAL HOSPITAL JALNA",
"CIVIL SURGEON OFFICE CIVIL HOSPITAL NANDED",
"CIVIL SURGEON RATLAM MADHYA PRADESH",
"CIVIL SURGEON SUPTD DISTRICT HOSPITAL CHHINDWARA",
"CIVILBABA INFRA CONSULTANT PRIVATE LIMITED",
"CIVILMANTRA INFRACON PRIVATE LIMITED",
"CIVIMEC ENGINEERING PRIVATE LIMITED",
"CIVIMECH CONSULTANTS PRIVATE LIMITED",
"CIVITECH (INDIA) PRIVATE LIMITED",
"CIVITECH DEVELOPERS PRIVATE LIMITED",
"CIVITECH SERVICES PRIVATE LIMITED",
"CIVTECT INDIA PRIVATE. LIMITED.",
"CIVTRON TRANSFORMERS PRIVATE LIMITED",
"CIZOVA PRIVATE LIMITED",
"CJ CHEILJEDANG CORPORATION",
"CJ DARCL LOGISTICS LIMITED",
"CJ ENTERPRISES (INDIA) PRIVATE LIMITED",
"CJ FEED INDIA PRIVATE LIMITED",
"CJ INFRACON PRIVATE LIMITED",
"CJ KOREA EXPRESS INDIA PRIVATE LIMITED",
"CJ TECH PRIVATE LIMITED",
"CJI PORCELAIN PRIVATE LIMITED",
"CJK KNOWLEDGEWORKS GLOBAL INDIA PRIVATE LIMITED",
"CJN HITECH MOTORS PRIVATE LIMITED",
"CJO SHOPPING CO LIMITED",
"CJP CERAMIC INDUSTRIES PRIVATE LIMITED",
"CJR PRECISION PRODUCTS PRIVATE LIMITED",
"CJSA INTERNATIONAL PRIVATE LIMITED",
"CK 12 SOFTWARE AND TECHNOLOGY CONSULTING INDIA PRIVATE LIMITED",
"CK 12 SOFTWARE TECHNOLOGY CONSULTING PRIVATE TLD",
"CK AIRTECH INDIA PRIVATE LIMITED",
"CK BIRLA CORPORATE SERVICES LIMITED",
"CK BIRLA HEALTHCARE PRIVATE LIMITED",
"CK BIRLA HOSPITAL",
"CK BIRLA HOSPITALS",
"CK INFORMATICS PRIVATE LIMITED",
"CK INFRA EQUIPMENT PRIVATE LIMITED",
"CK LAND-MARKS PRIVATE LIMITED",
"CK PLASTICS PRIVATE LIMITED",
"CK S FOODS PRIVATE LIMITED",
"CK SHAH MUN COMMERCE COLG KALOL",
"CKAARI PACKAGING PRIVATE LIMITED",
"CKARNIVAL PROMOTIONS PRIVATE LIMITED",
"CKB GLOBAL LOGISTICS PRIVATE LIMITED",
"CKB PRECIWAY ENGINEERING PRIVATE LIMITED",
"CKD INDIA PRIVATE LIMITED",
"CKEE ENGINEERING PRIVATE LIMITED",
"CKG CONSTRUCTIONS PRIVATE LIMITED",
"CKG TECHNOLOGIES LLP",
"CKINETICS CONSULTING SERVICES PRIVATE LIMITED",
"CKL SONS INVESTMENT PRIVATE LIMITED",
"CKM CONSULTANTS INDIA PRIVATE LIMITED",
"CKM FASHIONS INDIA PRIVATE LIMITED",
"CKN LOGISTICS PRIVATE LIMITED",
"CKP HOLDINGS PRIVATE LIMITED",
"CKR FISHING TRADE PRIVATE LIMITED",
"CKREDENCE WEALTH MANAGEMENT PRIVATE LIMITED",
"CKRIS LABORATORIES PRIVATE LIMITED",
"CKS CABLE SOLUTIONS PRIVATE LIMITED",
"CKS CONSULTING PRIVATE LIMITED",
"CK'S EDVANTAGE EDUCATION PRIVATE LIMITED",
"CK'S FOODS PRIVATE LIMITED",
"CKS HOSPITAL",
"CKS MEDICARE PRIVATE LIMITED",
"CKS PUJA SERVICES PRIVATE LIMITED",
"CKUENS ANALYTICS PRIVATE LIMITED",
"CL AUGMENTA SERVICES PRIVATE LIMITED",
"CL BAID METHA PHARMACY COLLEGE",
"CL ELECTRONICS PRIVATE LIMITED",
"CL LABORATORIES PRIVATE LIMITED",
"CL MEDIA PRIVATE LIMIETD",
"CL MICROMED PRIVATE.LIMITED",
"CLAAS AGRICULTURAL MACHINERY PRIVATE LIMITED",
"CLAAS INDIA PRIVATE LIMITED",
"CLAB MEDIA PRIVATE LIMITED",
"CLABERT LIFESCIENCES PRIVATE LIMITED",
"CLAD METAL INDIA PRIVATE LIMITED",
"CLADDING PROJECTS PRIVATE LIMITED",
"CLADDWELL SOLUTIONS PRIVATE LIMITED",
"CLAHA INDUSTRIES PRIVATE LIMITED",
"CLAIBORNE VIMAL POLYCON PRIVATE LIMITED",
"CLAIM GENIUS INDIA PRIVATE LIMITED",
"CLAIMBUDDY TECHNOLOGIES PRIVATE LIMITED",
"CLAIR ELECTRONICS PRIVATE LIMITED",
"CLAIR ENGINEERS PRIVATE LIMITED",
"CLAIREHEIGHTS ESTATE SERVICES PRIVATE LIMITED",
"CLAIRVOLEX IP SOLUTIONS PRIVATE LIMITED",
"CLAIRVOYANCE INDUSTRIES PRIVATE LIMITED",
"CLAIRVOYANT INDIA PRIVATE LIMITED",
"CLAISYS SOFTWARE PRIVATE LIMITED",
"CLAMED HEALTHCARE PRIVATE LIMITED",
"CLAMP SHOES PRIVATE LIMITED",
"CLAN LABORATORIES PRIVATE LIMITED",
"CLAN PHARMA PRIVATE LIMITED",
"CLAN VITRIFIED PRIVATE LIMITED",
"CLANEL CORPORATE SERVICES PRIVATE LIMITED",
"CLANIFY MEDIA PRIVATE LIMITED",
"CLANTHIS LIFE SCIENCES PRIVATE LIMITED",
"CLAPINGO EDUCATION PRIVATE LIMITED",
"CLAPPTRON TECHNOLOGIES PRIVATE LIMITED",
"CLAPS INDUSTRIES PRIVATE LIMITED",
"CLAR AQUA ENGINEERING SERVICES PRIVATE LIMITED",
"CLAR AQUA PRIVATE LIMITED",
"CLARA GLOBAL SCHOOL ( KAWADE PATIL EDUCATIONAL FOUNDATION )",
"CLARA SHOES",
"CLARANET INDIA PRIVATE LIMITED",
"CLARCOR INDIA PRIVATE LIMITED",
"CLARE FREIGHT INDIA PRIVATE LIMITED",
"CLARE SOLAR PRIVATE LIMITED",
"CLAREMONT HOME TEXTILES PRIVATE LIMITED",
"CLAREMONT INTERNATIONAL SCHOOL ASHTA",
"CLARENCE HIGH SCHOOL",
"CLARET LIFE SCIENCES LLP",
"CLARIANT IGL SPECIALTY CHEMICALS PRIVATE LIMITED",
"CLARIANT INDIA LIMITED",
"CLARIANT INDIA PRIVATE LIMITED",
"CLARIANT PHARMACEUTICALS PRIVATE LIMITED",
"CLARIANT POWER SYSTEM LIMITED",
"CLARIDGE MOULDED FIBRE LIMITED",
"CLARIDGES HOTEL PRIVATE LIMITED",
"CLARIDGES TRAVELS PRIVATE LIMITED",
"CLARION AGRO PRODUCTS PRIVATE LIMITED",
"CLARION BY CHOICE HOTELS",
"CLARION CASEIN LIMITED",
"CLARION COMPUTERS PRIVATE LIMITED",
"CLARION COSMETICS PRIVATE LIMITED",
"CLARION INDIA PRIVATE LIMITED",
"CLARION INN INDORE",
"CLARION INSURANCE BROKING SERVICES PRIVATE LIMITED",
"CLARION IT PRIVATE LIMITED",
"CLARION LOGISTICS INDIA PRIVATE LIMITED",
"CLARION ORGANICS LIMITED",
"CLARION PROPERTIES LIMITED",
"CLARION TECHNOLOGIES PRIVATE LIMITED",
"CLARION WIND FARM PRIVATE LIMITED",
"CLARIS LIFESCIENCES LIMITED",
"CLARIS LIMITED",
"CLARISITY SOLUTIONS PRIVATE LIMITED",
"CLARISSA FACILITY MANAGEMENT LLP",
"CLARISSA RESORTS PRIVATE LIMITED",
"CLARITAZ TECHLABS LLP",
"CLARITRICS INDIA PRIVATE LIMITED",
"CLARITUS MANAGEMENT CONSULTING PRIVATE LIMITED",
"CLARITY CONSULTING",
"CLARITY FINANCIAL SERVICES LTD.",
"CLARITY IMAGING CENTRE PRIVATE LIMITED",
"CLARITY MEDICAL PRIVATE LIMITED",
"CLARITY ROADLINK PRIVATE LIMITED",
"CLARITY SALES PRIVATE LIMITED",
"CLARITYCX SOLUTIONS & SERVICES PRIVATE LIMITED",
"CLARIVATE ANALYTICS INDIA PRIVATE LIMITED",
"CLARIYA GLOBAL PRIVATE LIMITED",
"CLARKE ENERGY INDIA PRIVATE LIMITED",
"CLARKIA HOSPITALITY PRIVATE LIMITED",
"CLARKS FUTURE FOOTWEAR LIMITED",
"CLARKS INDIA SERVICES PRIVATE LIMITED",
"CLARKS INN SUITES GWALIOR",
"CLARKS RELIANCE FOOTWEAR PRIVATE LIMITED",
"CLARKSON SHIPPING SERVICES INDIA PRIVATE LIMITED",
"CLARO ENERGY PRIVATE LIMITED",
"CLARO FILTRATION PRIVATE LIMITED",
"CLAROID PHARMACEUTICALS PRIVATE LIMITED",
"CLARON FIBREOPTICS PRIVATE LIMITED",
"CLAROPET PACKAGING PRIVATE LIMITED",
"CLARTECH ENGINEERS PRIVATE LIMITED",
"CLARUS BIOENERGY PRIVATE LIMITED",
"CLARUS MEDIA SOLUTIONS PRIVATE LIMITED",
"CLARUS RCM INFOTECH (INDIA) PRIVATE LIMITED",
"CLASIQUE PLASTIC PIPING SYSTEMS PRIVATE LIMITED",
"CLASP BUSINESS SOLUTIONS PRIVATE LIMITED",
"CLASQUIN INDIA PRIVATE LIMITED",
"CLASS ALZONE PRIVATE LIMITED",
"CLASS ONE AGRO BIOTECH & FERTILIZER PRIVATE LIMITED",
"CLASS ONE SYSTEMS SOLUTIONS & TECHNOLOGY PRIVATE LIMITED",
"CLASS WORLDWIDE PRIVATE LIMITED- JEDHRU",
"CLASSCONS INFRATECH PRIVATE LIMITED",
"CLASSIC AIRTECH PRIVATE LIMITED",
"CLASSIC AROMATICS PRIVATE LIMITED",
"CLASSIC ASSOCIATES TELESERVICES PRIVATE LIMITED",
"CLASSIC AUTOMOTIVE",
"CLASSIC AUTOMOTIVE INDUSTRIES PVT LTD",
"CLASSIC AUTOMOTIVES AND ESTATES INDIA PRIVATE LIMITED",
"CLASSIC BUILD PROJECTS PRIVATE LIMITED",
"CLASSIC CAR RENTAL SERVICES PRIVATE LIMITED",
"CLASSIC CARE UTILITIES PRIVATE LIMITED",
"CLASSIC CASUALS INDIA PVT LTD",
"CLASSIC CHEM",
"CLASSIC CHEMISTS PRIVATE LIMITED",
"CLASSIC CITY INFOPARK PRIVATE LIMITED",
"CLASSIC CLEARING AND FORWARDING PRIVATE LIMITED",
"CLASSIC COAL CONSTRUCTION PRIVATE. LIMITED.",
"CLASSIC COLOURS PRIVATE LIMITED",
"CLASSIC COMBUSTIONS INDIA PRIVATE LIMITED",
"CLASSIC COMMERCIAL SERVICES PRIVATE LIMITED",
"CLASSIC COMPONENTS PVT LTD",
"CLASSIC CONCEPTS HOME INDIA PRIVATE LIMITED",
"CLASSIC COOLING SYSTEMS PRIVATE LIMITED",
"CLASSIC CORRUGATIONS PRIVATE LIMITED",
"CLASSIC COTTON PRIVATE LIMITED",
"CLASSIC COURIERS PRIVATE LIMITED",
"CLASSIC DESIGN ENGINEERING SYSTEM PRIVATE LIMITED",
"CLASSIC DIALS PVT LTD",
"CLASSIC DISPLAY SYSTEMS PRIVATE LIMITED",
"CLASSIC ELECTRO COATING PRIVATE LIMITED",
"CLASSIC ELECTRODES (INDIA) LIMITED",
"CLASSIC EMBROIDERY PRIVATE LIMITED",
"CLASSIC ENGINEERING MOTIONS PRIVATE LIMITED",
"CLASSIC ENTERPRISES LIMITED",
"CLASSIC ENTERPRISES LIMITED TRANSFER FROM W.B. TO RAJ.",
"CLASSIC ENTERPRISES PRIVATE LIMITED",
"CLASSIC FINISHERS INDIA PRIVATE LIMITED",
"CLASSIC FIRE SERVICES PRIVATE LIMITED",
"CLASSIC FLOORINGS & INTERIORS PRIVATE LIMITED",
"CLASSIC FLOW CONTROLS PRIVATE LIMITED",
"CLASSIC GRAVURE PRIVATE LIMITED",
"CLASSIC HOME FURNISHING PRIVATE LIMITED",
"CLASSIC HOTEL MANAGEMENT INDIA PRIVATE LIMITED",
"CLASSIC HOUSING PROJECTS PRIVATE LIMITED",
"CLASSIC HYBRID SEEDS PRIVATE LIMITED",
"CLASSIC IMAGE OFFSET PVT LTD",
"CLASSIC IMPORTS PRIVATE LIMITED",
"CLASSIC IN-ART WORKS PRIVATE LIMITED",
"CLASSIC INDUSTRIES AND EXPORTS LIMITED",
"CLASSIC INFORMATICS PRIVATE LIMITED",
"CLASSIC INFRASERVICES PRIVATE LIMITED",
"CLASSIC INFRASTRUCTURE DEVELOPERS PRIVATE LIMITED",
"CLASSIC INTERNET AND CABLE SERVICES PRIVATE LIMITED",
"CLASSIC KARAT ASSAYLAB PRIVATE LIMITED",
"CLASSIC KITCHEN PRIVATE LIMITED",
"CLASSIC LABOUR ADVISORY SERVICES PRIVATE LIMITED",
"CLASSIC LEGENDS PRIVATE LIMITED",
"CLASSIC LIFTS PRIVATE LIMITED",
"CLASSIC LINENS INTERNATIONAL PRIVATE LIMITED",
"CLASSIC LOGISTICS INTERNATIONAL PRIVATE LIMITED",
"CLASSIC MACHINE TOOLS PVT LTD",
"CLASSIC MALL DEVELOPMENT COMPANY LIMITED",
"CLASSIC MALL DEVELOPMENT COMPANY PRIVATE LIMITED",
"CLASSIC MANPOWER OPERATIONS PRIVATE LIMITED",
"CLASSIC MARBLE COMPANY PRIVATE LIMITED",
"CLASSIC MICROTECH PRIVATE LIMITED",
"CLASSIC NETWORK PRIVATE LIMITED",
"CLASSIC ORNAMENTS PRIVATE LIMITED",
"CLASSIC PETRO & ENERGY PRIVATE LIMITED",
"CLASSIC POSHTIK AHAAR PRIVATE LIMITED",
"CLASSIC PRECI-TECH PRIVATE LIMITED",
"CLASSIC PRINTING INK COMPANY PRIVATE LIMITED",
"CLASSIC PRODUCTS PRIVATE LIMITED",
"CLASSIC PRODUCTS PRIVATE. LIMITED",
"CLASSIC PROMOTERS AND BUILDERS PRIVATE LIMITED",
"CLASSIC PROTECTION FORCE PRIVATE LIMITED",
"CLASSIC REALTY PRIVATE LIMITED",
"CLASSIC RESIDENCY INDIA PRIVATE LIMITED",
"CLASSIC RESTAURANT PRIVATE LIMITED",
"CLASSIC RETAIL IMAGING SOLUTIONS PRIVATE LIMITED",
"CLASSIC RMC & AGGREGATES INDIA PRIVATE LIMITED",
"CLASSIC RMC AND INFRASTRUCTURE INDIA PRIVATE LIMITED",
"CLASSIC ROADWAYS PRIVATE LIMITED",
"CLASSIC ROOF INDIA PRIVATE LIMITED",
"CLASSIC SCOOBIKES PRIVATE LIMITED",
"CLASSIC SEARCH PRIVATE LIMITED",
"CLASSIC SERVICEPOINT PRIVATE LIMITED",
"CLASSIC SHOE COMPONENTS (INDIA) PRIVATE LIMITED",
"CLASSIC SIGNAGES PRIVATE LIMITED",
"CLASSIC SOLITAIRES PRIVATE LIMITED",
"CLASSIC SOLVENTS PRIVATE LIMITED",
"CLASSIC SPICES PVT LTD",
"CLASSIC SQUARES REALTY PRIVATE LIMITED",
"CLASSIC STEELS PVT LTD",
"CLASSIC STICKERS & PRINTERS PRIVATE LIMITED",
"CLASSIC STRIPES PRIVATE LIMITED",
"CLASSIC SUPER CONSTRUCTION AND DEVELOPERS PRIVATE LIMITED",
"CLASSIC SYNERGY INDIA PRIVATE LIMITED",
"CLASSIC TANNERY PVT. LTD.",
"CLASSIC TECHNOLINES PRIVATE LIMITED",
"CLASSIC TECHNOMEC PRIVATE LIMITED",
"CLASSIC TECNOLOGISTICS & TRADE PRIVATE LIMITED",
"CLASSIC TOUR & TRAVELS PRIVATE LIMITED",
"CLASSIC TOWER PRIVATE LIMITED",
"CLASSIC TRAVEL AND TOURS PRIVATE LIMITED",
"CLASSIC TRAVEL SHOPPE PRIVATE LIMITED",
"CLASSIC WELDING PRODUCTS PRIVATE LIMITED",
"CLASSIC WINE MALL PRIVATE LIMITED",
"CLASSIC WIRE PRODUCTS PRIVATE LIMITED",
"CLASSICAL NATURAL STONES PRIVATE LIMITED",
"CLASSICART PRINTS PRIVATE LIMITED",
"CLASSICON BUILDERS (INDIA) PRIVATE LIMITED",
"CLASSICON CONSTRUCTION (INDIA) PRIVATE LIMITED",
"CLASSICON PROJECTS I PRIVATE LIMITED",
"CLASSICS TECHNICS PRIVATE LIMITED",
"CLASSICSTAR FASHIONS PRIVATE LIMITED",
"CLASSICTOUCH ELECTRICALS PRIVATE LIMITED",
"CLASSIQUE GUARD SERVICES PRIVATE LIMITED",
"CLASSIQUE INSULATED CONDUCTORS PRIVATE LIMITED",
"CLASSIQUE INTERNATIONAL",
"CLASSIQUE WEAVES PRIVATE LIMITED",
"CLASSLE KNOWLEDGE PRIVATE LIMITED",
"CLASSMETHOD INDIA PRIVATE LIMITED",
"CLASTEK ENGINEERING PRIVATE LIMITED",
"CLASTEQ PRIVATE LIMITED",
"CLASTICON SOLUTIONS PRIVATE LIMITED",
"CLAUDE BRAND RETAIL SOLUTION PRIVATE LIMITED",
"CLAUDIUS PETERS INDIA PRIVATE LIMITED",
"CLAUSE VEGETABLE SEEDS",
"CLAVAX POWER PRIVATE LIMITED",
"CLAVAX TECHNOLOGIES PRIVATE LIMITED",
"CLAVECON ( INDIA) PRIVATE LIMITED",
"CLAVIS PIPES PRIVATE LIMITED",
"CLAVIS TECHNOLOGIES PRIVATE LIMITED",
"CLAVITA PHARMA PRIVATE LIMITED",
"CLAVRIT DIGITAL SOLUTIONS PRIVATE LIMITED",
"CLAY BUSINESS VENTURES PRIVATE LIMITED",
"CLAY CONSULTING SERVICES INDIA PRIVATE LIMITED",
"CLAY CRAFT INDIA PRIVATE LIMITED",
"CLAY LOGIX INDIA PRIVATE LIMITED",
"CLAY SOFTWARE LABS PRIVATE LIMITED",
"CLAY STATION ART STUDIOS PRIVATE LIMITED",
"CLAYFIN TECHNOLOGIES PRIVATE LIMITED",
"CLAYM MEDIA & TECH PRIVATE LIMITED",
"CLAYMINT PRIVATE LIMITED",
"CLAYO TECHNOLOGIES PRIVATE LIMITED",
"CLAYROOT ECO SOLUTIONS PRIVATE LIMITED",
"CLAYROOTS OVERSEAS PRIVATE LIMITED",
"CLAYSOL MEDIA LABS PRIVATE LIMITED",
"CLAYSTONE GRANITO PRIVATE LIMITED",
"CLAYSYS TECHNOLOGIES PRIVATE LIMITED",
"CLAYTON TECHNOLOGIES INDIA PRIVATE LIMITED",
"CLAYWORKS SPACES TECHNOLOGIES PRIVATE LIMITED",
"CLEAN & GREEN EQUIPMENTS PRIVATE LIMITED",
"CLEAN & GREEN FACILITY MANGEMENT I PRIVATE LIMITED",
"CLEAN & SECURE MANAGEMENT CONSULTANCY SERVICES PRIVATE LIMITED",
"CLEAN AGRO FERTILIZER AND CHEMICAL PRIVATE LIMITED",
"CLEAN BOX FACILITY MANAGEMENT PRIVATE LIMITED",
"CLEAN CARBON PRIVATE LIMITED",
"CLEAN COAL ENTERPRISES PRIVATE LIMITED",
"CLEAN COATS PRIVATE LIMITED",
"CLEAN CONCEPT INDIA PRIVATE LIMITED",
"CLEAN CROP INDIA PRIVATE LIMITED",
"CLEAN DROP FILTRATION INDIA PRIVATE LIMITED",
"CLEAN EARTH ENERGY SOLUTION INDIA PRIVATE LIMITED",
"CLEAN ENERGY SYSTEMS INDIA PRIVATE LIMITED",
"CLEAN ENGINEERING PRIVATE LIMITED",
"CLEAN ENVIRO FUELS PRIVATE LIMITED",
"CLEAN HARBORS INDIA LLP",
"CLEAN INDIA VENTURES PRIVATE LIMITED",
"CLEAN MASTER MANAGEMENT SERVICES PRIVATE LIMITED",
"CLEAN MAX ADITYA POWER PRIVATE LIMITED",
"CLEAN MAX COGEN SOLUTIONS PRIVATE LIMITED",
"CLEAN MAX ENVIRO ENERGY SOLUTIONS PRIVATE LIMITED",
"CLEAN MAX MERCURY POWER PRIVATE LIMITED",
"CLEAN MAX PHOTOVOLTAIC PRIVATE LIMITED",
"CLEAN MAX POWER PROJECTS PRIVATE LIMITED",
"CLEAN MAX SCORPIUS PRIVATE LIMITED",
"CLEAN MAX VENT POWER PRIVATE LIMITED",
"CLEAN O PACK PRODUCER COMPANY LIMITED",
"CLEAN SCIENCE AND TECHNOLOGY LIMITED",
"CLEAN SLATE FILMZ PRIVATE LIMITED",
"CLEAN SOLAR POWER (BELLARY) PRIVATE LIMITED",
"CLEAN SOLAR POWER (BHADLA) PRIVATE LIMITED",
"CLEAN SOLAR POWER (BHAINSADA ) PRIVATE LIMITED",
"CLEAN SOLAR POWER (CHITRADURGA) PRIVATE LIMITED",
"CLEAN SOLAR POWER (DHAR) PRIVATE LIMITED",
"CLEAN SOLAR POWER (GULBARGA) PRIVATE LIMITED",
"CLEAN SOLAR POWER (JODHPUR) PRIVATE LIMITED",
"CLEAN SOLAR POWER (TUMKUR) PRIVATE LIMITED",
"CLEAN SOLAR POWER HIRIYUR PRIVATE LIMITED",
"CLEAN SOLAR ROOFTOP PRIVATE LIMITED",
"CLEAN SUSTAINABLE ENERGY PRIVATE LIMITED",
"CLEAN SUSTAINABLE SOLAR ENERGY PRIVATE LIMITED",
"CLEAN SWITCH INDIA PRIVATE LIMITED",
"CLEAN TECH SYNERGY PRIVATE LIMITED",
"CLEAN TECH VENTURE AN ENVIRONMENTAL SERVICES PRIVATE LIMITED",
"CLEAN TOUCH FACILITIES PRIVATE LIMITED",
"CLEAN WIND POWER (ANANTAPUR) PRIVATE LIMITED",
"CLEAN WIND POWER (BABLESHWAR) PRIVATE LIMITED",
"CLEAN WIND POWER (MANVI) PRIVATE LIMITED",
"CLEAN WIND POWER (PRATAPGARH) PRIVATE LIMITED",
"CLEAN WIND POWER (RATLAM) PRIVATE LIMITED",
"CLEAN WIND POWER DEVGARH PRIVATE LIMITED",
"CLEAN WIND POWER PIPLODA PRIVATE LIMITED",
"CLEAN WIND POWER SATARA PRIVATE LIMITED",
"CLEAN WORLD EQUIPMENT PRIVATE LIMITED",
"CLEANEX INDIA PRIVATE LIMITED",
"CLEANFLO INDIA PRIVATE LIMITED",
"CLEANFLOW COOLING TOWER SOLUTIONS PRIVATE LIMITED",
"CLEANFUEL INDIA AUTO GAS PRIVATE LIMITED",
"CLEANING N PERFECTION 4 YOU PRIVATE LIMITED",
"CLEANKO INDIA PRIVATE LIMITED",
"CLEANMART PRIVATE LIMITED",
"CLEANMAX HARSHA SOLAR LLP",
"CLEANMAX IPP 1 PRIVATE LIMITED",
"CLEANMAX IPP 2 PRIVATE LIMITED",
"CLEAN-O-DIESEL SERVICES (INDIA) PRIVATE LIMITED",
"CLEANON HOSPITALITY SERVICES PRIVATE LIMITED",
"CLEANPLUS APPAREL INDUSTRIES PRIVATE LIMITED",
"CLEANPRO SERVICES PRIVATE LIMITED",
"CLEANSEP SYSTEMS PRIVATE LIMITED",
"CLEANSER CHEMICALS AND DRUGS PRIVATE LIMITED",
"CLEANSOLAR RENEWABLE ENERGY PRIVATE LIMITED",
"CLEANSYS VENTURES INDIA PRIVATE LIMITED",
"CLEANTEC INFRA PRIVATE LIMITED",
"CLEANTECH MANAGEMENT SERVICES PRIVATE LIMITED",
"CLEANTECH SOLAR ENERGY (INDIA) PRIVATE LIMITED",
"CLEANTECH SYSTEMS PRIVATE LIMITED",
"CLEANTECH TELE TOWER SERVICES PRIVATE LIMITED",
"CLEANTEK ENERGY PRIVATE LIMITED",
"CLEANWAY MANAGEMENT SYSTEMS INDIA PRIVATE LIMITED",
"CLEAR AQUA TECHNOLOGIES PRIVATE LIMITED",
"CLEAR CHANNEL INDIA PRIVATE LIMITED",
"CLEAR COMMUNICATION SYSTEMS LIMITED",
"CLEAR CREDITS AND INVESTMENT PRIVATE LIMITED",
"CLEAR CUT ABRASIVES INDIA PRIVATE LIMITED",
"CLEAR EDGE FILTRATION INDIA PRIVATE LIMITED",
"CLEAR MEDIA INDIA PRIVATE LIMITED",
"CLEAR PACKAGING PRIVATE LIMITED",
"CLEAR POINT INSTRUMENTATION PRIVATE LIMITED",
"CLEAR POINT PHARMA PRIVATE LIMITED",
"CLEAR POLYPLAST INDIA PRIVATE LIMITED",
"CLEAR SECURED SERVICES PRIVATE LIMITED",
"CLEAR SKIN PRIVATE LIMITED",
"CLEAR SUNBEAMS (OPC) PRIVATE LIMITED",
"CLEAR TOUCH CONNECT PRIVATE LIMITED",
"CLEAR VISION EYE HOSPITAL PRIVATE LIMITED",
"CLEAR WATER COMMODITIES PRIVATE LIMITED",
"CLEAR WATER DYNAMICS PRIVATE LIMITED",
"CLEAR WATER LIMITED",
"CLEARCAR RENTAL PRIVATE LIMITED",
"CLEARCORP DEALING SYSTEMS INDIA LIMITED",
"CLEARDROP ENGINEERING PRIVATE LIMITED",
"CLEAREYE.AI PRIVATE LIMITED",
"CLEARFAST AIR CARGO AGENCIES PRIVATE LIMITED",
"CLEARFAST TRADING COMPANY PRIVATE LIMITED",
"CLEARFORD INDIA PRIVATE LIMITED",
"CLEARGREENS PHARMACEUTICALS PRIVATE LIMITED",
"CLEARIGHT INFOTECH LIMITED",
"CLEAR-ION EXPERTS PRIVATE LIMITED",
"CLEARLANE FASHIONS PRIVATE LIMITED",
"CLEARLINE APPLIANCES LTD",
"CLEARLY BLUE DIGITAL PRIVATE LIMITED",
"CLEARMEDI HEALTHCARE PRIVATE LIMITED",
"CLEARONE INNOVATION INDIA PRIVATE LIMITED",
"CLEARPACK AUTOMATION PRIVATE LIMITED",
"CLEARPACK INDIA PRIVATE LIMITED",
"CLEARPATH HEALTHCARE SERVICES PRIVATE LIMITED",
"CLEARPATH TECHNOLOGY PRIVATE LIMITED",
"CLEARPLUS INDIA PRIVATE LIMITED",
"CLEARPOINT LEARNING SYSTEMS INDIA PRIVATE LIMITED",
"CLEARPRISE TECHNOLOGIES PRIVATE LIMITED",
"CLEARSEP TECHNOLOGIES (INDIA )PRIVATE LIMITED",
"CLEARSHARP TECHNOLOGY PRIVATE LIMITED",
"CLEARSHIP FORWARDERS PRIVATE LIMITED",
"CLEARSKY SOLAR PRIVATE LIMITED",
"CLEARSTONE VENTURE ADVISORS PRIVATE LIMITED",
"CLEARSYNTH LABS LIMITED",
"CLEARTRAIL TECHNOLOGIES PRIVATE LIMITED",
"CLEARTRIP PRIVATE LIMITED",
"CLEARWATER ANALYTICS INDIA PRIVATE LIMITED",
"CLEARWATER POOLS PRIVATE LIMITED",
"CLEARWAY BUILDERS PRIVATE LIMITED",
"CLEAVER AND KNIFE INTEGRATED SERVICES AND SOLUTIONS PRIVATE LIMITED",
"CLEENA INDUSTRIES PRIVATE LIMITED",
"CLEGHORN MFG. CO. PRIVATE LIMITED",
"CLEMATIS TECHNOLOGY SOLUTIONS INDIA PRIVATE LIMITED",
"CLEMATIX SOFTWARE PRIVATE LIMITED",
"CLEMENT ENGINEERS PRIVATE LIMITED",
"CLEMENTIA PHARMACEUTICALS PRIVATE LIMITED",
"CLEMENTINE SECURITY SOFTWARE PRIVATE LIMITED",
"CLENSTA INTERNATIONAL PRIVATE LIMITED",
"CLEO JEWELLERY LLP",
"CLEOH HOMEZ & DEKORZ PRIVATE LIMITED",
"CLEON OPTOBIZ PRIVATE LIMITED",
"CLEON SOLAR ENERGY PRIVATE LIMITED",
"CLERISY SOLUTIONS PRIVATE LIMITED",
"CLERP SOLUTIONS PRIVATE LIMITED",
"CLEVELAND BRIDGE STEEL INDIA PRIVATE LIMITED",
"CLEVER CONSULTANTS PRIVATE LIMITED",
"CLEVER TECH PRIVATE LIMITED",
"CLEVER THINKING SOLUTIONS PRIVATE LIMITED",
"CLEVER WIZARDS SOLUTIONS PRIVATE LIMITED",
"CLEVERBUCK SYSTEMS PRIVATE LIMITED",
"CLEVERBUYZ NETWORKS AND SYSTEMS PRIVATE LIMITED",
"CLEVERMESH INDUSTRIES PRIVATE LIMITED",
"CLEVERTECH PACKAGING AUTOMATION SOLUTIONS PRIVATE LIMITED",
"CLEVERTRUTH LIFESTYLE PRIVATE LIMITED",
"CLEVISION TECHNOLOGIES PRIVATE LIMITED",
"CLF STRUCTURES PRIVATE LIMITED",
"CLG DEGREE COLLEGE SUMERPUR",
"CLG FOODS PRIVATE LIMITED",
"CLG INSTITUTE OF ENGINEERING AND TECHNOLOGY",
"CLG RETAIL PRIVATE LIMITED",
"CLH GASEOUS FUEL APPLICATIONS PRIVATE. LIMITED.",
"CLIANTHA RESEARCH LIMITED",
"CLIC SERVICES PRIVATE LIMITED",
"CLICK AND PLEDGE",
"CLICK AURUM PRIVATE LIMITED",
"CLICK CLOTHING COMPANY PRIVATE LIMITED",
"CLICK E-CHARGE SERVICES PRIVATE LIMITED",
"CLICK FOREX PRIVATE LIMITED",
"CLICK LABS PRIVATE LIMITED",
"CLICK TO TRAVEL PRIVATE LIMITED",
"CLICK2CLINIC HEALTHCARE INDIA PRIVATE LIMITED",
"CLICK2CLOUD TECHNOLOGY SERVICES INDIA PRIVATE LIMITED",
"CLICK2SHIP LOGISTICS PRIVATE LIMITED",
"CLICKATELL INDIA TECHNOLOGIES PRIVATE LIMITED",
"CLICKAWISH ENTERPRISES PRIVATE LIMITED",
"CLICKBLICK DIGITAL PRIVATE LIMITED",
"CLICKINDIA INFOMEDIA PRIVATE LIMITED",
"CLICKLEARN INDIA PRIVATE LIMITED",
"CLICKON TECHNOLOGIES PRIVATE LIMITED",
"CLICKONCARE RETAIL PRIVATE LIMITED",
"CLICKR ESTORE PRIVATE LIMITED",
"CLICKS BAZAAR TECHNOLOGIES PRIVATE LIMITED",
"CLICKSOFTWARE INDIA PRIVATE LIMITED",
"CLICKTECH RETAIL PRIVATE LIMITED",
"CLICKURTRIP.COM PRIVATE LIMITED",
"CLICKWORKS ADTECH PRIVATE LIMITED",
"CLIDEL SERVICES PRIVATE LIMITED",
"CLIENT LINX SOFTWARE PRIVATE LIMITED",
"CLIENTCURVE INFOSYSTEMS PRIVATE LIMITED",
"CLIENTPRO SERVICES",
"CLIENTSERVER SOLUTIONS PRIVATE LIMITED",
"CLIF TOOLS PRIVATE LIMITED",
"CLIFF CLIMBERS (INDIA) PRIVATE LIMITED",
"CLIFF GLOBAL NETWORK PRIVATE LIMITED",
"CLIFF SCAFFOLDINGS PRIVATE LIMITED",
"CLIFF SECURITY SERVICES PRIVATE LIMITED",
"CLIFF TREXIM PVT LTD",
"CLIFF VALLEY PROPERTIES PRIVATE LIMITED",
"CLIFFKUMAR ENGINEERING PVT LTD",
"CLIFFORD CHANCE BUSINESS SERVICES PRIVATE LIMITED",
"CLIFFS NATURAL RESOURCES INC.",
"CLIFFTON INFRASTRUCTURE PRIVATE LIMITED",
"CLIFFTON PACKAGINGS PRIVATE LIMITED",
"CLIFTON BUSINESS PVT. LTD",
"CLIFTON EXPORT PRIVATE LIMITED",
"CLIFTON YARN AND CLOTH MILLS PRIVATE LIMITED",
"CLIMA CONTROL REEFERS PRIVATE LIMITED",
"CLIMA-COOL SYSTEMS PRIVATE LIMITED",
"CLIMATE AGROBOTIX INDIA PRIVATE LIMITED",
"CLIMATE AIRCON ENGINEERS PRIVATE LIMITED",
"CLIMATE AIRCOOL PRIVATE LIMITED",
"CLIMATE CARE PRIVATE LIMITED",
"CLIMATE CHANGERS - TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"CLIMATE CONSULTING SERVICES INDIA PRIVATE LIMITED",
"CLIMATE ETC TECHNOLOGY SERVICES PRIVATE LIMITED",
"CLIMATE HVAC ENGINEERING",
"CLIMATE NATURAL SPICES PRIVATE LIMITED",
"CLIMATE POLICY INITIATIVE INDIA PRIVATE LIMITED",
"CLIMATECH AIRCON ENGINEERS PRIVATE LIMITED",
"CLIMATRONICS TECHNOLOGIES PRIVATE LIMITED",
"CLIMAVENETA CLIMATE TECHNOLOGIES PRIVATE LIMITED",
"CLIMAX APPAREL PRIVATE LIMITED",
"CLIMAX ENTERPRISES PRIVATE LIMITED",
"CLIMAX OVERSEAS PRIVATE LIMITED",
"CLIMAX SYNTHETICS PRIVATE LIMITED",
"CLIMAX WATERPROOFING PRODUCTS PRIVATE LIMITED",
"CLIMB FOODS PRIVATE LIMITED",
"CLIMB MEDIA (INDIA) PRIVATE LIMITED",
"CLIMBAX ENTERTAINMENT PRIVATE LIMITED",
"CLIMBER HUMAN RESOURCE PRIVATE LIMITED",
"CLIMBER KNOWLEDGE & CAREERS PRIVATE LIMITED",
"CLIMBING FEET PRIVATE LIMITED",
"CLIMBTECH INDIA PRIVATE LIMITED",
"CLIMB-UP INFRA PRIVATE LIMITED",
"CLIME FINANCE PRIVATE LIMITED",
"CLIMIC HEALTH PRIVATE LIMITED",
"CLIMINGTON TECHNOLOGY PRIVATE LIMITED",
"CLINASIA LABS PRIVATE LIMITED",
"CLINCHOICE PRIVATE LIMITED",
"CLINCY CONSTRUCTION PRIVATE LIMITED",
"CLINDOX INDIA PRIVATE LIMITED",
"CLINEEDZ INDIA PRIVATE LIMITED",
"CLINEVO TECHNOLOGIES PRIVATE LIMITED",
"CLINFOUND DIAGNOSTICS PRIVATE LIMITED",
"CLINIAPPS PRIVATE LIMITED",
"CLINIC DERMATECH PRIVATE LIMITED",
"CLINICAL AESTHETICS AND INVESTIGATIVE MANAGEMENT SERVICE PRIVATE LIMITED",
"CLINICAL EXCEL COMPUTECH LLP",
"CLINICAL INFOTECH PRIVATE LIMITED",
"CLINICAL SLEEP AND RESPIRATORY SOLUTIONS PRIVATE LIMITED",
"CLINICAL SOFTWARE PRIVATE LIMITED",
"CLINICEA HEALTHCARE INDIA PRIVATE LIMITED",
"CLINICO DIAGNOSTIC CENTRE INDIA PRIVATE LIMITED",
"CLINICO SCAN CENTRE PRIVATE LIMITED",
"CLINICS INDIA PRESS PRIVATE LIMITED",
"CLINIEXPERTS RESEARCH SERVICES PRIVATE LIMITED",
"CLINIEXPERTS SERVICES PRIVATE LIMITED",
"CLINIMED LIFESCIENCES PRIVATE LIMITED",
"CLININVENT RESEARCH PRIVATE LIMITED",
"CLINIOPS TECHSOFT PRIVATE LIMITED",
"CLINIPACE CLINICAL RESEARCH PRIVATE LIMITED",
"CLINIRX RESEARCH PRIVATE LIMITED",
"CLINISYS INDIA PRIVATE LIMITED",
"CLINITECH LABORATORY LIMITED",
"CLINIVEX PHARMACEUTICALS PRIVATE LIMITED",
"C-LINK CONNECT INDIA PRIVATE LIMITED",
"CLINK HR SERVICES PRIVATE LIMITED",
"CLINOVA PATHLABS PRIVATE LIMITED",
"CLINOVI RESEARCH PRIVATE LIMITED",
"CLINSEARCH HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"CLINSPIRE RESEARCH PRIVATE LIMITED",
"CLINSYNC CLINICAL RESEARCH PRIVATE LIMITED",
"CLINTEC INDIA INTERNATIONAL PRIVATE LIMITED",
"CLINTON FOUNDATION",
"CLINTREK RESEARCH PRIVATE LIMITED",
"CLINTS SOLUTIONS LLP",
"CLINTUS NETWORK LIMITED",
"CLINWAVE RESEARCH PRIVATE LIMITED",
"CLINZERV PHARMACEUTICALS PRIVATE LIMITED",
"CLIO TRADING COMPANY P LTD",
"CLIP INFRA PRIVATE LIMITED",
"CLIPPER TOURISM PRIVATE LIMITED",
"CLIPS INDIA PRIVATE LIMITED.",
"CLIQUE BRAND SOLUTIONS PRIVATE LIMITED",
"CLIQUE CONSULTANTS PRIVATE LIMITED",
"CLIQUE DEVELOPMENTS LIMITED",
"CLIQUE EXPORTS PRIVATE LIMITED",
"CLIQUE MEDICAL SOLUTIONS PRIVATE LIMITED",
"CLIVET AIRCONDITIONING SYSTEMS PRIVATE LIMITED",
"CLIVIA PHARMA PRIVATE LIMITED",
"CLIWIS LAB PRIVATE LIMITED",
"CLIX CAPITAL SERVICES PRIVATE LIMITED",
"CLIX FURNITURE PRIVATE LIMITED",
"CLIX HOUSING FINANCE LIMITED",
"CLIXLOGIX TECHNOLOGIES PRIVATE LIMITED",
"CLIXXO BROADBAND PRIVATE LIMITED",
"CLK LOGISTICS INDIA (OPC) PRIVATE LIMITED",
"CLKK BUILDERS PRIVATE LIMITED",
"CLLOVEMED PHARMA PRIVATE LIMITED",
"CLM DEVELOPERS PRIVATE LIMITED",
"CLML AUTO PRIVATE LIMITED",
"CLML MOTORS PRIVATE LIMITED",
"CLML VEHICLES PRIVATE LIMITED",
"CLOCKWORK BUSINESS SOLUTIONS PRIVATE LIMITED",
"CLOCKWORK EVENTS PRIVATE LIMITED",
"CLODPI LABS (INDIA) PRIVATE LIMITED",
"CLODURA SYSTEMS PRIVATE LIMITED",
"CLOGENY TECHNOLOGIES PRIVATE LIMITED",
"CLOHUB IT SERVICES PRIVATE LIMITED",
"CLOMOSO TECHNOLOGIES PRIVATE LIMITED",
"CLOMOTECH PRIVATE LIMITED",
"CLONECT SOLUTIONS PRIVATE LIMITED",
"CLONETAB SOFTSOLUTIONS PRIVATE LIMITED",
"CLOOBEES INDIA PRIVATE LIMITED",
"CLOOD ON LEARNING PRIVATE LIMITED",
"CLOOD ON MUSICA PRIVATE LIMITED",
"CLOOS INDIA WELDING TECHNOLOGY PRIVATE LIMITED",
"CLOOTRACK SOFTWARE LABS PRIVATE LIMITED",
"CLORIS COATING PRIVATE LIMITED",
"CLOSET CLOTHING PRIVATE LIMITED",
"CLOTEQ APPARELS PRIVATE LIMITED",
"CLOTH SHOP",
"CLOTHES RACK PRIVATE LIMITED",
"CLOTHING CULTURE LIMITED",
"CLOTHING INNOVATIONS PRIVATE LIMITED",
"CLOTHWARI PRINTING PRIVATE LIMITED",
"CLOUD 88 INDIA PRIVATE LIMITED",
"CLOUD 9 E-BIZ PRIVATE LIMITED",
"CLOUD 9 INFOSYSTEMS PRIVATE LIMITED",
"CLOUD ANALOGY SOFTECH PRIVATE LIMITED",
"CLOUD ANGLES DIGITAL TRANSFORMATION INDIA PRIVATE LIMITED",
"CLOUD ASSERT TECHNOLOGIES INDIA PRIVATE LIMITED",
"CLOUD BIGDATA TECHNOLOGIES PRIVATE LIMITED",
"CLOUD BUILDCON PRIVATE LIMITED",
"CLOUD CALLINGS SERVICES PRIVATE LIMITED",
"CLOUD CERTITUDE PRIVATE LIMITED",
"CLOUD COLLAB TECHNOLOGIES PRIVATE LIMITED",
"CLOUD DESK TECHNOLOGY PRIVATE LIMITED",
"CLOUD DHABA FOODS PRIVATE LIMITED",
"CLOUD ENERGY SOFTWARE PRIVATE LIMITED",
"CLOUD ETEL",
"CLOUD EZE PRIVATE LIMITED",
"CLOUD INFOTECH PRIVATE LIMITED",
"CLOUD INTERIORS PRIVATE LIMITED",
"CLOUD KINETICS TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"CLOUD LIFESTYLE PRIVATE LIMITED",
"CLOUD MENTOR SOFTWARE PRIVATE LIMITED",
"CLOUD NINE HOSPITALITIES PRIVATE LIMITED",
"CLOUD NINE INTERIORS LLP",
"CLOUD OPERATION PRIVATE LIMITED",
"CLOUD RIPPLES PRIVATE LIMITED",
"CLOUD SCS TECHNOLOGIES PRIVATE LIMITED",
"CLOUD SOFTWARE GROUP INDIA PRIVATE LIMITED",
"CLOUD TECH PRIVATE LIMITED",
"CLOUD VANTAGE SOLUTIONS PRIVATE LIMITED",
"CLOUD VERTEX TECHNOLOGIES INDIA PRIVATE LIMITED",
"CLOUD WAVE TECHNOLOGIES PRIVATE LIMITED",
"CLOUD WELLNESS PRIVATE LIMITED",
"CLOUD24X7 PRIVATE LIMITED",
"CLOUD2SCALE SOLUTIONS PRIVATE LIMITED",
"CLOUD3 TECHNOLOGIES",
"CLOUD4C SERVICES PRIVATE LIMITED",
"CLOUDACCEL SOFT INDIA PRIVATE LIMITED",
"CLOUDACE TECHNOLOGIES PRIVATE LIMITED",
"CLOUDACRES DEVELOPERS PRIVATE LIMITED",
"CLOUDACT BUSINESS SERVICES PRIVATE LIMITED",
"CLOUDACTION TECHNOLOGY SERVICES PRIVATE LIMITED",
"CLOUDACTIVE LABS (INDIA) PRIVATE LIMITED",
"CLOUDAEON PRIVATE LIMITED",
"CLOUDALIO TECHNOLOGIES PRIVATE LIMITED",
"CLOUDBYTE INDIA TECHNOLOGIES PRIVATE LIMITED",
"CLOUDBYZ INDIA PRIVATE LIMITED",
"CLOUDCAST DIGITAL LIMITED",
"CLOUDCASTLE STEEL PRIVATE LIMITED",
"CLOUDCHEF PRIVATE LIMITED",
"CLOUDCRAFTZ SOLUTIONS PRIVATE LIMITED",
"CLOUDELY INDIA PRIVATE LIMITED",
"CLOUDEQ SOFTWARE INDIA PRIVATE LIMITED",
"CLOUDERA DATA PLATFORM INDIA PRIVATE LIMITED",
"CLOUDESTER SOFTWARE LLP",
"CLOUDEX HEALTH CARE PRIVATE LIMITED",
"CLOUDFABRIX SOFTWARE INDIA PRIVATE LIMITED",
"CLOUDFIRST TECHNOLOGY PRIVATE LIMITED",
"CLOUDFOG SOFTWARE SOLUTIONS PRIVATE LIMITED",
"CLOUDFOREST E-COMMERCE PRIVATE LIMITED",
"CLOUDFRONTS TECHNOLOGIES PRIVATE LIMITED",
"CLOUDFULCRUM INDIA PRIVATE LIMITED",
"CLOUDFY ECOMMERCE INDIA PRIVATE LIMITED",
"CLOUDGATE SYSTEMS INDIA PRIVATE LIMITED",
"CLOUDGEN DIGITAL PRIVATE LIMITED",
"CLOUDGEN INFOTECH PRIVATE LIMITED",
"CLOUDGEN SYSTEMS PRIVATE LIMITED",
"CLOUDGENERIC PRIVATE LIMITED",
"CLOUDGO PRIVATE LIMITED",
"CLOUDHEDGE TECHNOLOGIES PRIVATE LIMITED",
"CLOUDHOUSE ANIMATION STUDIOS PRIVATE LIMITED",
"CLOUDIFY SOLUTIONS PRIVATE LIMITED",
"CLOUDIFYOPS PRIVATE LIMITED",
"CLOUDINNOV8 TECHNOLOGIES PRIVATE LIMITED",
"CLOUDINSTA24 SERVICES PRIVATE LIMITED",
"CLOUDINTEGRTR SOFTWARE SERVICES PRIVATE LIMITED",
"CLOUDIO INDIA PRIVATE LIMITED",
"CLOUDIOUS TECH SOLUTIONS PRIVATE LIMITED",
"CLOUDIQ SOLUTIONS PRIVATE LIMITED",
"CLOUDIUM SOFTWARE PRIVATE LIMITED",
"CLOUDIX GLOBAL SOLUTIONS PRIVATE LIMITED",
"CLOUDJET LABS PRIVATE LIMITED",
"CLOUDKAPTAN CONSULTANCY SERVICES PRIVATE LIMITED",
"CLOUDKRATE SOLUTIONS PRIVATE LIMITED",
"CLOUDLABS TECHNOLOGIES PRIVATE LIMITED",
"CLOUDLAND INTERACTIVE PRIVATE LIMITED",
"CLOUDLEOS PRIVATE LIMITED",
"CLOUDLIMS LAB SOLUTIONS (INDIA) PRIVATE LIMITED",
"CLOUDMINISTER TECHNOLOGIES PRIVATE LIMITED",
"CLOUDMOYO INDIA PRIVATE LIMITED",
"CLOUDNEURONS IT CONSULTING SERVICES LLP",
"CLOUDNINE",
"CLOUDNINE GROUP OF HOSPITALS",
"CLOUDNOW TECHNOLOGIES PRIVATE LIMITED",
"CLOUDODYSSEY IT SOLUTIONS PRIVATE LIMITED",
"CLOUDOLOGIC PRIVATE LIMITED",
"CLOUDONE INTERNATIONAL NETWORK LIMITED",
"CLOUDPARADIGM SOFTWARE PRIVATE LIMITED",
"CLOUDPATHS SERVICES PRIVATE LIMITED",
"CLOUDPLUS INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"CLOUDPOINT SYSTEMS PRIVATE LIMITED",
"CLOUDPOINT TECHNOLOGIES PRIVATE LIMITED",
"CLOUDQ IT SERVICES PRIVATE LIMITED",
"CLOUDQ PRIVATE LIMITED",
"CLOUDRAY INDIA PRIVATE LIMITED",
"CLOUDREACH TECHNOLOGIES INDIA PRIVATE LIMITED",
"CLOUDRELISH PRIVATE LIMITED",
"CLOUDREVOLUTE INDIA PRIVATE LIMITED",
"CLOUDRIGHT TECHNOLOGIES PRIVATE LIMITED",
"CLOUDS IMPORT AND EXPORT PRIVATE LIMITED",
"CLOUDS WOOD TECHNOLOGIES PRIVATE LIMITED",
"CLOUDSCOUTS TECHNOLOGY SERVICES INDIA PRIVATE LIMITED",
"CLOUDSEALS PRIVATE LIMITED",
"CLOUDSEK INFORMATION SECURITY PRIVATE LIMITED",
"CLOUDSENSE SOFTWARE PRIVATE LIMITED",
"CLOUDSKILL PRIVATE LIMITED",
"CLOUDSOLUTIONSHUB PRIVATE LIMITED",
"CLOUDSPACE TECHNOLOGIES PRIVATE LIMITED",
"CLOUDSPHERE INDIA PRIVATE LIMITED",
"CLOUDSTEER TECHNOLOGY PRIVATE LIMITED",
"CLOUDSTRATS TECHNOLOGIES PRIVATE LIMITED",
"CLOUDSTUFF TECHNOLOGY PRIVATE LIMITED",
"CLOUDSUFI INDIA PRIVATE LIMITED",
"CLOUDTAIL INDIA PRIVATE LIMITED",
"CLOUDTARU INFOTECH PRIVATE LIMITED",
"CLOUDTECH SOFTWARE LLP",
"CLOUDTECHNER SERVICES PRIVATE LIMITED",
"CLOUDTECHTIQ TECHNOLOGIES PRIVATE LIMITED",
"CLOUDTERN SOLUTIONS LLP",
"CLOUDTHAT TECHNOLOGIES PRIVATE LIMITED",
"CLOUDTHING INDIA PRIVATE LIMITED",
"CLOUDTRADE TECHNOLOGIES PRIVATE LIMITED",
"CLOUDUNICORN PRIVATE LIMITED",
"CLOUDUNO CONSULTING INDIA PRIVATE LIMITED",
"CLOUDVANDANA SOLUTIONS PRIVATE LIMITED",
"CLOUDWALKER LOGISTICS PRIVATE LIMITED",
"CLOUDWALKER STREAMING TECHNOLOGIES PRIVATE LIMITED",
"CLOUDWARE TECHNOLOGIES PRIVATE LIMITED",
"CLOUDWERX SOLUTIONS INDIA PRIVATE LIMITED",
"CLOUDWICK TECHNOLOGIES INDIA PRIVATE LIMITED",
"CLOUDWORX TECHNOLOGIES PRIVATE LIMITED",
"CLOUDY WAVE TECHNOLOGY PRIVATE LIMITED",
"CLOUDYUGA TECHNOLOGIES PRIVATE LIMITED",
"CLOV CHEM INDIA PRIVATE LIMITED",
"CLOVE IT SOLUTIONS PRIVATE LIMITED",
"CLOVE TECHNOLOGIES PRIVATE LIMITED",
"CLOVER BAY TECHNOLOGIES PRIVATE LIMITED",
"CLOVER BUILDERS PRIVATE LIMITED",
"CLOVER DEVELOPERS PRIVATE LIMITED",
"CLOVER ENERGY PRIVATE LIMITED",
"CLOVER GLOBAL SERVICES PRIVATE LIMITED",
"CLOVER GREENS PRIVATE LIMITED",
"CLOVER HOSPITALITY SERVICES PRIVATE LIMITED",
"CLOVER INFOTECH PRIVATE LIMITED",
"CLOVER IT SERVICES PRIVATE LIMITED",
"CLOVER MEDIA PRIVATE LIMITED",
"CLOVER ORGANIC PRIVATE LIMITED",
"CLOVER REALTY AND INFRASTRUCTURE PRIVATE LIMITED",
"CLOVER SOLAR PRIVATE LIMITED",
"CLOVER TECHNOLOGIES PRIVATE LIMITED",
"CLOVER VENTURES PRIVATE LIMITED",
"CLOVERBRIDGE TECHNOLOGIES PRIVATE LIMITED",
"CLOVERLEAF ECOM PRIVATE LIMITED",
"CLOVIRTUAL FASHION PRIVATE LIMITED",
"CLOWNFACE TRAVEL PRIVATE LIMITED",
"CLP POWER INDIA PRIVATE LIMITED",
"CLP WIND FARMS INDIA PRIVATE LIMITED",
"CLP WIND FARMS THENI- PROJECT II PRIVATE LIMITED",
"CLR FACILITY SERVICES PRIVATE LIMITED",
"CLRI KANPUR",
"CLRK INDUSTRIES PRIVATE LIMITED",
"CLS LOGISTICS PRIVATE LIMITED",
"CLSA INDIA LIMITED",
"CLSA TECHNOLOGY & SERVICES LLP",
"CLSA TECHNOLOGY & SERVICES PRIVATE LIMITED",
"CLSQ PRODUCTS PRIVATE LIMITED",
"CLUB COLLECTIONS EXPORTS PRIVATE LIMITED",
"CLUB CONCIERGE SERVICES INDIA PRIVATE LIMITED",
"CLUB DESTINASIA PRIVATE LIMITED",
"CLUB FIRST ROBOTICS PRIVATE LIMITED",
"CLUB LIME FACILITIES PRIVATE LIMITED",
"CLUB LINK (INDIA) PRIVATE LIMITED",
"CLUB M HOLIDAYS PRIVATE LIMITED",
"CLUB MED SERVICES INDIA PRIVATE LIMITED",
"CLUB7 HOLIDAYS",
"CLUBMILLIONAIRE FINANCIAL SERVICES PRIVATE LIMITED",
"CLUBRAMADA HOTELS AND RESORTS PRIVATE LIMITED",
"CLUBSIDE TOURS AND TRAVELS PVT LTD",
"CLUBWISE DEVELOPMENT INDIA PRIVATE LIMITED",
"CLUDOBITS IT SOLUTIONS PRIVATE LIMITED",
"CLUES NETWORK PRIVATE LIMITED",
"CLUEWISE SERVICES PRIVATE LIMITED",
"CLUMAX DIAGNOSTIC AND RESEARCH CENTRE PRIVATE LIMITED",
"CLUNY MATRIC HIGHER SECONDARY SCHOOL",
"CLUSTER INFOTECH PRIVATE LIMITED",
"CLUSTER JEWELLERY LIMITED",
"CLUSTER TOURS & TRAVELS",
"CLUSTERCODE TECHNOLOGY PRIVATE LIMITED",
"CLUTCH INFOTECH PRIVATE LIMITED",
"CLVR MEDIA AGENCY PRIVATE LIMITED",
"CLW LIGHTING INDIA PRIVATE LIMITED",
"CLYBAY PRIVATE LIMITED",
"CLYDE BERGEMANN INDIA PRIVATE LIMITED",
"CLYDE INDUSTRIES INDIA PRIVATE LIMITED",
"CLYDE PHARMACEUTICAL PRIVATE LIMITED",
"CLYDE PUMPS INDIA PRIVATE LIMITED",
"CLYP VIDEO PRIVATE LIMITED",
"CLYPTUS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"CLYVAC MARCOM PRIVATE LIMITED",
"CM AND HO DEWEAS",
"CM AND HO SEHORE MADHYA PRADESH",
"CM AUTO SALES PRIVATE. LIMITED.",
"CM CHAINS PRIVATE LIMITED",
"CM ENVIROSYSTEMS PRIVATE LIMITED",
"CM GLOBAL INGREDIENTS & FOOD PRODUCTS PRIVATE LIMITED",
"CM PUMPS AND SYSTEMS PRIVATE LIMITED",
"CM SECURITIES PRIVATE LIMITED",
"CMA CGM AGENCIES (INDIA) PRIVATE LIMITED",
"CMA CGM AGENCIES INDIA PRIVATE LIMITED",
"CMA CGM GLOBAL BUSINESS SERVICES INDIA PRIVATE LIMITED",
"CMA CGM LOGISTICS INDIA PRIVATE LIMITED",
"CMA CGM LOGISTICS PARK (DADRI) PRIVATE LIMITED",
"CMA PROJECTS PRIVATE LIMITED",
"CMA TURNKEY PROJECTS PRIVATE LIMITED",
"CMANDHAR LOGISTICS PRIVATE LIMITED",
"CMARIX TECHNOLABS PRIVATE LIMITED",
"CMART SOLUTIONS INDIA PRIVATE LIMITED",
"CMAS INDIA PRIVATE LIMITED",
"CMAX METALS INDIA PRIVATE LIMITED",
"CMB INFORMATION PORTAL PRIVATE LIMITED",
"CMB MANAGEMENT SOLUTION PRIVATE LIMITED",
"CMBF TRADING & MANUFACTURING INDIA PRIVATE LIMITED",
"CMC COMMUTATOR PRIVATE LIMITED",
"CMC HEALTHCARE PRIVATE LIMITED",
"CMC LIMITED",
"CMC SHARUB ENTERPRISES PRIVATE LIMITED",
"CMC SKILLS PRIVATE LIMITED",
"CMC TEXTILES PRIVATE LIMITED",
"CMC TEXTILES PRIVATE. LIMITED.",
"CMCEE MEGA SKILLS PRIVATE LIMITED",
"CMD PRECISION PRODUCTS PRIVATE LIMITED",
"CME INDIA TECHNOLOGY AND SUPPORT SERVICES PRIVATE",
"CMEC CONSULTING ENGINEERS PRIVATE LIMITED",
"CMED RADIOLOGY PRIVATE LIMITED",
"CMER EDUCATION AND RESEARCH FOUNDATION",
"CMES INFINITY PRIVATE LIMITED",
"CMES JUPITER PRIVATE LIMITED",
"CMES POWER 1 PRIVATE LIMITED",
"CMETRICS INDUSTRIES LIMITED",
"CMEX MANAGEMENT PRIVATE LIMITED",
"CMG AGRO PRIVATE LIMITED",
"CMG BIOTECH PRIVATE LIMITED",
"CMG HOLDINGS PRIVATE LIMITED",
"CMG LOGISTICS PRIVATE LIMITED",
"CMG STEELS PRIVATE LIMITED",
"CMH TOOLS LIMITED",
"CMHP PRIVATE LIMITED",
"CMI INDUSTRY AUTOMATION PRIVATE LIMITED",
"CMI MACHINES PRIVATE LIMITED",
"CMI SWITCHGEARS PRIVATE LIMITED",
"CMIND INDIA PRIVATE LIMITED",
"CMK ELECTRO POWER PRIVATE LIMITED",
"CMK PROJECTS PRIVATE LIMITED",
"CMK PROMOTERS PRIVATE LIMITED",
"CML BIOTECH LIMITED",
"CML HOSPITALITY PRIVATE LIMITED",
"CML MEDIA SOFTWARES P LIMITED",
"CMM ARENA RETAILS PRIVATE LIMITED",
"CMM GROUP OF COMPANIES",
"CMM HINDUSTAN GOLD PRIVATE LIMITED",
"CMM LOGISTICS PRIVATE LIMITED",
"CMM SERVICES (INDIA) PRIVATE LIMITED",
"CMM TECHNOLOGIES PRIVATE LIMITED",
"CMM TRADELINKS PRIVATE LIMITED",
"CMO AXIS OUTSOURCING SERVICES PRIVATE LIMITED",
"CMO SAHARANPUR",
"CMOBILE TELEMATICS INDIA PRIVATE LIMITED",
"CMODA SOLUTIONS PRIVATE LIMITED",
"CMOTS INTERNET TECHNOLOGIES PRIVATE LIMITED",
"CMP EURO TECHNOPLAST PRIVATE LIMITED",
"CMP PRIVATE LIMITED",
"CMPL AUTOMOBILES PRIVATE LIMITED",
"CMPL MOTORS PRIVATE LIMITED",
"CMPLUS POWER & INFRA PRIVATE LIMITED",
"CMPV ENGINEERING PRIVATE LIMITED",
"CMR ALUMINIUM PRIVATE LIMITED",
"CMR AUTOMOTIVES PRIVATE LIMITED",
"CMR CHIHO INDUSTRIES INDIA PRIVATE LIMITED",
"CMR COLLEGE OF ENGINEERING & TECHNOLOGY",
"CMR CONTROL SYSTEMS INDIA PRIVATE LIMITED",
"CMR CORPORATION PRIVATE LIMITED",
"CMR DESIGN AUTOMATION PRIVATE LIMITED",
"CMR ENGINEERING COLLEGE",
"CMR GANDHI PUBLIC SCHOOL",
"CMR GREEN TECHNOLOGIES LIMITED",
"CMR INFRA (INDIA) PRIVATE LIMITED",
"CMR INFRASTRUCTURE PRIVATE LIMITED",
"CMR INSTITUTE OF MEDICAL SCIENCE",
"CMR INSTITUTE OF TECHNOLOGY",
"CMR LIFESCIENCES PRIVATE LIMITED",
"CMR NATIONAL PU COLLEGE",
"CMR NATIONAL PUBLIC SCHOOLCMRNPS",
"CMR NIKKEI INDIA PRIVATE. LIMITED.",
"CMR SHOPPING MALL PRIVATE LIMITED",
"CMR SURGICAL INDIA PRIVATE LIMITED",
"CMR TECHNICAL CAMPUS",
"CMR TEXTILES & JEWELLERS PRIVATE LIMITED",
"CMR TOYOTSU ALUMINIUM INDIA PRIVATE. LIMITED.",
"CMR UNIVERSITY SCHOOL OF ENGINEERING AND TECHNOLOGY",
"CMRGS INFRASTRUCTURE PROJECTS LIMITED",
"CMRS PROJECTS PRIVATE LIMITED",
"CMS AGRO FOODS PRIVATE LIMITED",
"CMS ASSOCIATES PRIVATE LIMITED",
"CMS CHHIBRAMAU",
"CMS CLINICAL RESEARCH PRIVATE LIMITED",
"CMS COLLEGE OF SCIENCE & COMMERCE",
"CMS ELECTRICALS PRIVATE LIMITED",
"CMS ENERGY CORPORATION",
"CMS IDENT PRIVATE LIMITED",
"CMS INDIA OPERATIONS AND MAINTENANCE COMPANY PRIVATE LIMITED",
"CMS INFO SYSTEMS LIMITED",
"CMS IT SERVICES PRIVATE LIMITED",
"CMS MARSHALL LIMITED",
"CMS SECURITAS LIMITED",
"CMS TRAFFIC SYSTEM LIMITED",
"CMT ARTS (INDIA) PRIVATE LIMITED",
"CMT MECHANISED SYSTEM PRIVATE LIMITED",
"CMTC METALLURGICAL INDIA PRIVATE LIMITED",
"CMV INFORMATICS PRIVATE LIMITED",
"CMV INFRAPROJECTS PRIVATE LIMITED",
"CMW CO2 TECHNOLOGIES PRIVATE LIMITED",
"CMYK GRAPHICS PRIVATE LIMITED",
"CMYK HEALTH BOUTIQUE PRIVATE LIMITED",
"CN ENGINEERS AND SYSTEMS PRIVATE LIMITED",
"CN HYGIENE LLP",
"CN SOFTNET INDIA PRIVATE LIMITED",
"CN WATER SYSTEMS PRIVATE LIMITED",
"CNA ENTERPRISES PRIVATE LIMITED",
"CNB COMMODITIES PRIVATE LIMITED",
"CNB DIAMONDS PRIVATE LIMITED",
"CNB FINWIZ PRIVATE LIMITED",
"CNB LOGITECH PRIVATE LIMITED",
"CNC APOLLO DIE CASTERS PRIVATE LIMITED",
"CNC CONTROL SYSTEMS AND SERVICES",
"CNC DIA JEWELS PRIVATE LIMITED",
"CNC E-SOLUTIONS PRIVATE LIMITED",
"CNC INDIA TOOLS AND SERVICES PRIVATE LIMITED",
"CNC MILL ENGINEERS (INDIA) PRIVATE LIMITED",
"CNC PETRO CHEM PRIVATE LIMITED",
"CNC TECHNICS PVT. LTD.",
"CNCTIMES PRIVATE LIMITED",
"CND ENGINEERING PRIVATE LIMITED",
"CNERG FOODS LIMITED",
"CNERGY GROUP OF COMPANIES",
"CNERGYIS INFOTECH INDIA PRIVATE LIMITED",
"CNET TECHNOLOGIES",
"C-NET TECHNOLOGIES PRIVATE LIMITED",
"CNETRIC ENTERPRISE SOLUTIONS PRIVATE LIMITED",
"CNG AGROCARE PRIVATE LIMITED",
"CNG LOGISTICS PRIVATE LIMITED",
"CNG SUPERSPECIALITY HOSPITAL PRIVATE LIMITED",
"CNH INDUSTRIAL CAPITAL (INDIA) PRIVATE LIMITED",
"CNH INDUSTRIAL INDIA PRIVATE LIMITED",
"CNH MOULDS PRIVATE LIMITED",
"CNI ENTERPRISE INDIA PRIVATE LIMITED",
"CNI RESEARCH LIMITED",
"CNI TEACHER TRAINING INSTITUTE",
"CNIM MARTIN PRIVATE LIMITED",
"C-NINE FOOD PRODUCTS PRIVATE LIMITED",
"CNK AND ASSOCIATES LLP",
"CNLABS TEST SERVICES PRIVATE LIMITED",
"CNM FINVEST PRIVATE LIMITED",
"CNM SCHOOL",
"CNP PUMPS INDIA PRIVATE LIMITED",
"CNPA ELECTRICITY PRIVATE LIMITED",
"CNR INFRATECH",
"CNRG ENERGY INDIA PRIVATE LIMITED",
"CNS COMNET SOLUTION P LIMITED",
"CNS HOSPITAL",
"CNS LABS PRIVATE LIMITED",
"CNV LABS AND TECHNOLOGIES PRIVATE LIMITED",
"CNX CORPORATION LIMITED",
"CNX HEALTHCARE PLUS PRIVATE LIMITED",
"CNX HEALTHCARE PRIVATE LIMITED",
"CNZ BEARINGS PRIVATE LIMITED",
"CO JEWEL HALLMARRKINGS PRIVATE LIMITED",
"CO3 ENTERPRISE PRIVATE LIMITED",
"COA NETWORK INDIA PRIVATE LIMITED",
"COACH INTERNATIONAL TECHNIQUE PRIVATE LIMITED",
"COACH LEATHERWARE INDIA PRIVATE LIMITED",
"COACH NUTRACHEM INDIA PRIVATE LIMITED",
"COACHIEVE SOLUTIONS PRIAVTE LIMITED",
"COACHIEVE SOLUTIONS PRIVATE LIMITED",
"COACHING FOUNDATION INDIA PRIVATE LIMITED",
"COACT IMPRINTS PRIVATE LIMITED",
"COACT SOLUTIONS PRIVATE LIMITED",
"COACTION COMMUNICATION PRIVATE LIMITED",
"COACTION.COM PRIVATE LIMITED",
"COACTUAR COMMUNICATIONS PRIVATE LIMITED",
"COAL HOSPITALITY PRIVATE LIMITED",
"COAL HUB LOGISTICS PRIVATE LIMITED",
"COAL INDIA LIMITED",
"COAL LIGNITE URJA VIKAS PRIVATE LIMITED",
"COAL MAN LOGISTICS INDIA PRIVATE LIMITED",
"COAL MINES ASSOCIATED TRADERS PRIVATE LIMITED",
"COALCHEM TRADELINK PRIVATE LIMITED",
"COALESCE EVENTZ INDIA PRIVATE LIMITED",
"COALMAN TRANSPOTER PRIVATE LIMITED",
"COALSALE COMPANY LIMITED",
"COALTECH ENGINEERS PRIVATE LIMITED",
"COALTWISTER LIMITED",
"COANTUM IMMERSIVE PRIVATE LIMITED",
"COAST LINE SHIPPING (INDIA) PRIVATE LIMITED",
"COAST REDWOOD ADVISORS PRIVATE LIMITED",
"COAST TO COAST DESIGNS PRIVATE LIMITED",
"COASTAL AGRO INDUSTRIES PRIVATE LIMITED",
"COASTAL AMMONIA PVT LTD",
"COASTAL ANDHRA PAPER PRODUCTS",
"COASTAL ANDHRA POWER INFRASTRUCTURE LIMITED",
"COASTAL AQUA",
"COASTAL AUTOMOBILES PRIVATE. LIMITED.",
"COASTAL CARTONS PVT LTD",
"COASTAL CHEMICAL COMPANY PRIVATE LIMITED",
"COASTAL CHIP BOARDS AND LAMS PRIVATE LIMITED",
"COASTAL CLIMATE ENGINEERS PRIVATE LIMITED",
"COASTAL CONSOLIDATED STRUCTURES PRIVATE LIMITED",
"COASTAL CORPORATION LIMITED",
"COASTAL DISTRIBUTION PRIVATE LIMITED",
"COASTAL ENDOCRINE SPECIALTY HOSPITALS PRIVATE LIMITED",
"COASTAL EXPRESS TRANSPORT COMPANY PRIVATE LIMITED",
"COASTAL FAARMS",
"COASTAL FARMS",
"COASTAL FATS & OILS PRIVATE LIMITED",
"COASTAL FOAM PRIVATE LIMITED",
"COASTAL GUJARAT POWER LIMITED",
"COASTAL INFOCOM PRIVATE LIMITED",
"COASTAL INSURANCE BROKERS PRIVATE LIMITED",
"COASTAL LOCAL AREA BANK LIMITED",
"COASTAL MARINE CONSTRUCTION AND ENGINEERING LIMITED",
"COASTAL MEDICARE PRIVATE LIMITED",
"COASTAL P E B SOLUTIONS PRIVATE LIMITED",
"COASTAL PACKAGERS PVT LTD",
"COASTAL PLASTOCHEM PRIVATE LIMITED",
"COASTAL PROFESSIONAL SERVICES PRIVATE LIMITED",
"COASTAL ROADWAYS LIMITED",
"COASTAL RUBBER EQUIPMENTS PRIVATE LIMITED",
"COASTAL SALINITY PREVENTION CELL",
"COASTAL SHIPPING LINKS (INDIA) PRIVATE LIMITED",
"COASTAL SOLVENT OILS INDIA PRIVATE LIMITED",
"COASTAL TAMIL NADU POWER LIMITED",
"COASTAL TRAINING TECHNOLOGIES INDIA PRIVATE LIMITED",
"COASTAL TRANSPORT PRIVATE LIMITED",
"COASTAL WIRE ROPES PRIVATE LIMITED",
"COASTEL SUN VIEW HOTELS PRIVATE LIMITED",
"COASTLINE GARAGES INDIA PRIVATE LIMITED",
"COAT TECH AESTHETICS PRIVATE LIMITED",
"COAT WELL INKS PRIVATE LIMITED",
"COATED SALES COMPANY PRIVATE LIMITED",
"COATINGS AND COATINGS INDIA PRIVATE LIMITED",
"COATSMAN OFFSHORE SERVICES PRIVATE LIMITED",
"COATWELL INDIA PVT LTD",
"COAX BIOREMEDIES PRIVATE LIMITED",
"COBALT EXPERIENTIAL MARKETING PRIVATE LIMITED",
"COBB APPARELS PRIVATE LIMITED",
"COBBLE STONE PRIVATE LIMITED",
"COBESERV SHIP & OFFSHORE SERVICES PRIVATE LIMITED",
"COBIT ENGINEERING PRIVATE. LIMITED",
"COBOT SYSTEMS PRIVATE LIMITED",
"COBRA CABLES PRIVATE LIMITED",
"COBRA CARBIDE PRIVATE LIMITED",
"COBRA INDUSTRIAL SECURITY FORCE (INDIA) LIMITED",
"COBRA INSTALACIONES Y SERVICIOS SA",
"COBRA INSTALACIONES Y-SERVICIOS I P LIMITED",
"COBRA LEGAL SOLUTIONS PRIVATE LIMITED",
"COBRATECTON PRIVATE LIMITED",
"COBRE HOSPITALITY AND EDUCARE PRIVATE LIMITED",
"COBURG ENGINEERING SERVICES PRIVATE LIMITED",
"COBURG EQUIPMENTS PRIVATE LIMITED",
"COCA COLA INDIA PRIVATE LIMITED",
"COCA-COLA ENTERPRISES INC.",
"COCA-COLA INDIA FOUNDATION",
"COCEPTUAL MEDIA PRIVATE LIMITED",
"COCHIN BLUE METAL INDUSTRIES PRIVATE LIMITED",
"COCHIN BUNKERS PRIVATE LIMITED",
"COCHIN CEMENTS LTD",
"COCHIN CHAMBER OF COMMERCE AND INDUSTRY",
"COCHIN CLEARING HOUSE PRIVATE LIMITED",
"COCHIN COLLEGE",
"COCHIN COSMOS FOODS LTD",
"COCHIN DEVASWAM BOARD",
"COCHIN DISTRICT CO-OP BANK",
"COCHIN ENGINEERING AND CONSULTANCY SERVICES PVT LTD",
"COCHIN FIRE TECH INDIA PRIVATE LIMITED",
"COCHIN FOOD TECH PRIVATE LIMITED",
"COCHIN FROZEN FOOD EXPORTS PRIVATE LIMITED",
"COCHIN HALLMARK CO PRIVATE LIMITED",
"COCHIN INTERNATIONAL AIRPORT LIMITED",
"COCHIN INTERNATIONAL AVIATION SERVICES LIMITED",
"COCHIN MINERALS AND RUTILE LIMITED",
"COCHIN MULTIMEDIA SOLUTIONS PRIVATE LIMITED",
"COCHIN PETROMINS PVT LTD",
"COCHIN PLYWOOD PRIVATE LIMITED",
"COCHIN POWER CABLES PRIVATE LIMITED",
"COCHIN PRINTECH PRIVATE LIMITED",
"COCHIN RECLAIM AND RUBBERS PRIVATE LIMITED",
"COCHIN REFINERIES",
"COCHIN RESIDENCY PRIVATE LIMITED",
"COCHIN SHIPYARD LIMITED",
"COCHIN SMART MISSION LIMITED",
"COCHIN UNIVERSITY OF SCIENCE TECHNOLOG",
"COCHLEAR MEDICAL DEVICE COMPANY INDIA PRIVATE LIMITED",
"COCK BRAND SINNAR BIDIS PRIVATE LIMITED",
"COCKATOO SPORTS PRIVATE LIMITED",
"COCKETT MARINE OIL TRADING PRIVATE LIMITED",
"COCLEAN SYSTEMS AND SOLUTIONS",
"COCO AND MORE CHOCOLATES PRIVATE LIMITED",
"COCO CARBONS INDIA PRIVATE LIMITED",
"COCO TUFTERS PRIVATE LIMITED",
"COCOAMELTS CHOCOLATES INDIA PRIVATE LIMITED",
"COCOCART VENTURES PRIVATE LIMITED",
"COCOFIBRE INDUSTRIES PRIVATE LIMITED",
"COCOFOAM MATTRESSES & FURNISHINGS PRIVATE LIMITED",
"COCOGURU COCONUT INDUSTRIES PRIVATE LIMITED",
"COCO-LATEX EXPORTS PRIVATE LIMITED",
"COCONUT GROVE F & B HOSPITALITY PRIVATE LIMITED",
"COCOON BARTER GLOBAL PRIVATE LIMITED",
"COCOON FERTILITY PRIVATE LIMITED",
"COCOON WAREHOUSING AND LOGISTICS PRIVATE LIMITED",
"COCOONA CENTRE OF AESTHETIC TRANSFORMATION",
"COCOONS FASHIONS PRIVATE LIMITED",
"COCOS (AP) PRIVATE LIMITED",
"COCOS INDIA PRIVATE LIMITED",
"COCOSLABS INNOVATIVE SOLUTIONS PRIVATE LIMITED",
"COCOTIER INOVATIVE SOLUTIONS PRIVATE LIMITED",
"COCREATE CLOUD KITCHEN PRIVATE LIMITED",
"COCUBES TECHNOLOGIES PRIVATE LIMITED",
"COCULTURE VALUEFRAME CONSULTING PRIVATE LIMITED",
"COCUSAN FOODS LIMITED",
"COD RESEARCH PRIVATE LIMITED",
"CODA PAYMENTS INDIA PRIVATE LIMITED",
"CODA TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"CODAEMON SOFTWARES PRIVATE LIMITED",
"CODAL SYSTEMS PRIVATE LIMITED",
"CODALIEN TECHNOLOGIES PRIVATE LIMITED",
"CODDIWOMPLE INDIA PRIVATE LIMITED",
"CODDLE TECHNOLOGIES PRIVATE LIMITED",
"CODE ACUITY LLP",
"CODE CABS PRIVATE LIMITED",
"CODE CALIBRE",
"CODE CITY PRIVATE LIMITED",
"CODE FLOW TECH LLP",
"CODE PRODUCT SOLUTIONS INDIA PRIVATE LIMITED",
"CODE RAFT SOLUTION PRIVATE LIMITED",
"CODE RED FILMS PRIVATE LIMITED",
"CODE RESPAWN TECHNOLOGIES PRIVATE LIMITED",
"CODE SHASTRA PRIVATE LIMITED",
"CODE TREE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"CODEA TECHNOLOGIES PRIVATE LIMITED",
"CODEABLE TECHNOLOGIES PRIVATE LIMITED",
"CODEARRAY TECHNOLOGIES PRIVATE LIMITED",
"CODEASTU TECHNOLOGIES PRIVATE LIMITED",
"CODEBASE SOLUTIONS PRIVATE LIMITED",
"CODEBEES TECHNOLOGIES PRIVATE LIMITED",
"CODEBLAZE TECHNOLOGIES PRIVATE LIMITED",
"CODEBOARD TECHNOLOGY PRIVATE LIMITED",
"CODEBRAHMA TECHNOLOGIES PRIVATE LIMITED",
"CODEBREW INNOVATIONS PRIVATE LIMITED",
"CODEBUCKET SOLUTIONS PRIVATE LIMITED",
"CODEBUDDY PRIVATE LIMITED",
"CODEC NETWORKS PRIVATE LIMITED",
"CODECLOUDS IT SOLUTIONS PRIVATE LIMITED",
"CODECRAFT TECHNOLOGIES PRIVATE LIMITED",
"CODEDAMN PRIVATE LIMITED",
"CODEDRILL INFOTECH PRIVATE LIMITED",
"CODEEXPERTS TECHNOLOGIES PRIVATE LIMITED (OPC)",
"CODEFLIES TECHNOLOGIES PRIVATE LIMITED",
"CODEFORCE 360 PRIVATE LIMITED",
"CODEFRONTIER SOFTWARE PRIVATE LIMITED",
"CODEGREEN ENERGY PRIVATE LIMITED",
"CODEHIVE IT SOLUTIONS PRIVATE LIMITED",
"CODEINSIGHT TECHNOLOGIES PRIVATE LIMITED",
"CODEJUDGE IT SOLUTIONS INDIA PRIVATE LIMITED",
"CODELAND INFOSOLUTIONS PRIVATE LIMITED",
"CODELATTICE DIGITAL SOLUTIONS PRIVATE LIMITED",
"CODELOGICX TECHNOLOGIES PRIVATE LIMITED",
"CODELYNKS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"CODEMANCERS TECHNOLOGIES PRIVATE LIMITED",
"CODEMANTRA PRIVATE LIMITED",
"CODEMAX IT SOLUTIONS PRIVATE LIMITED",
"CODEMINES SOLUTIONS PRIVATE LIMITED",
"CODENICELY SOFTWEAR SERVICES LLP",
"CODENOMAD PRIVATE LIMITED",
"CODENOTE IT SOLUTIONS PRIVATE LIMITED",
"CODENTRIX TECHNOLOGIES PRIVATE LIMITED",
"CODEOFDUTY INNOVATIONS PRIVATE LIMITED",
"CODEPARVA TECHNOLOGIES PRIVATE LIMITED",
"CODEQUOTIENT PRIVATE LIMITED",
"CODERS BRAIN TECHNOLOGY PRIVATE LIMITED",
"CODERYTHM TECHNOLOGY PRIVATE LIMITED",
"CODESETS IT SOLUTIONS INDIA PRIVATE LIMITED",
"CODESIRPI SOFTWARE LLP",
"CODESMAN TECHNOLOGIES LLP",
"CODESUSTAIN VENTUURES PRIVATE LIMITED",
"CODETANTRA TECH SOLUTIONS PRIVATE LIMITED",
"CODETHEORY INDIA PRIVATE LIMITED",
"CODETRONIX SOFTWARE SOLUTIONS LLP",
"CODETRU SOLUTIONS PRIVATE LIMITED",
"CODEVALUE TECHNOLOGIES PRIVATE LIMITED",
"CODEVIBEZ IT SOLUTIONS (OPC) PRIVATE LIMITED",
"CODEWALLA SOFTWARE DEVELOPMENT PRIVATE LIMITED",
"CODEWAVE TECHNOLOGIES PRIVATE LIMITED",
"CODEWORK SOLUTIONS PRIVATE LIMITED",
"CODEX SOLUTIONS PRIVATE LIMITED",
"CODEXIAL TECHNOLOGIES PRIVATE LIMITED",
"CODEXIVE IT AND BUSINESS SOLUTIONS PRIVATE LIMITED",
"CODEXIVE SOLUTIONS",
"ASTROTALK SERVICES PRIVATE LIMITED",
"CODEYUG WEB SERVICES PRIVATE LIMITED",
"CODEZERO2PI SOLUTIONS (OPC) PRIVATE LIMITED",
"CODEZEROS TECHNOLOGY PRIVATE LIMITED",
"CODEZEVEN SOFTWARE PRIVATE LIMITED",
"CODEZILLA TECHNOLOGY AND CONSULTANCY PRIVATE LIMITED",
"CODIAMANTAIRES PRIVATE LIMITED",
"CODIANT SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"CODIFYD INC",
"CODIGAMI LABS PRIVATE LIMITED",
"CODIGAMI TECHNOLOGIES PRIVATE LIMITED",
"CODILAR TECHNOLOGIES PRIVATE LIMITED",
"CODINA METALIC PRIVATE LIMITED",
"CODING BLOCKS PRIVATE LIMITED",
"CODING BRAINS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"CODINGAL TECHNOLOGIES PRIVATE LIMITED",
"CODINGMART TECHNOLOGIES PRIVATE LIMITED",
"CODINOVA TECHNOLOGIES PRIVATE LIMITED",
"CODISM INDIA PRIVATE LIMITED",
"CODISSIA INDUSTRIAL PARK LIMITED",
"CODISTE PRIVATE LIMITED",
"CODITAS SOLUTIONS LLP",
"CODITAS TECHNOLOGIES PRIVATE LIMITED",
"CODITATION SYSTEMS PRIVATE LIMITED",
"CODITUDE PRIVATE LIMITED",
"CODIUM TECHLABS PRIVATE LIMITED",
"CODIYA PHARMA LIMITED",
"CODLEO CONSULTING PRIVATE LIMITED",
"CODMERIC INFOTECH PRIVATE LIMITED",
"CODOGNOTTO LOGISTICS INDIA PRIVATE LIMITED",
"CODOID INNOVATIONS PRIVATE LIMITED",
"CODUNITE PRIVATE LIMITED",
"CODZIO CONSULTING",
"COE CREATORS INTERNATIONAL PRIVATE LIMITED",
"COE SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"COEFFICIENT SOFTWARE SYSTEMS PRIVATE LIMITED",
"COELHO CONSTRUCTIONS PRIVATE LIMITED",
"COELHO HOTELS AND ESTATES PVT LTD",
"COELHO SYSTEMS PRIVATE LIMITED",
"COEMPT EDU TECK PRIVATE LIMITED",
"COEP",
"COEPD",
"COEP'S BHAU INSTITUTE OF INNOVATION ENTREPRENEURSHIP AND LEADERSHIP",
"COESIA INDIA PRIVATE LIMITED",
"COEVOLVE ESTATES PRIVATE LIMITED",
"COEXISTENCE HEALTHCARE PRIVATE LIMITED",
"COEXTRIX TECHNOLOGIES PRIVATE LIMITED",
"COFACE INDIA CREDIT MANAGEMENT SERVICES PRIVATE LIMITED",
"COFARMIN FARMER PRODUCER COMPANY LIMITED",
"COFCO INTERNATIONAL INDIA PRIVATE LIMITED",
"COFE IMPEX PRIVATE LIMITED",
"COFFE DAY ECON PRIVATE LIMITED",
"COFFEE CODES INDIA PRIVATE LIMITED",
"COFFEE DAY BEVEREGES",
"COFFEE DAY CONSOLIDATIONS PRIVATE LIMITED",
"COFFEE DAY HOTELS & RESORTS PRIVATE. LIMITED.",
"COFFEE DAY PRIVATE. LIMITED.",
"COFFEE DAY TRADING LIMITED",
"COFFEEBEANS CONSULTING LLP",
"COFFEECO INDIA PRIVATE LIMITED",
"COFFEEDAY HOTELS & RESORTS PRIVATE LIMITED",
"COFFEEGROVE RESORTS PRIVATE LIMITED",
"COFFEELAB LIMITED",
"COFFOR CONSTRUCTION TECHNOLOGY PRIVATE LIMITED",
"COFISER CONSULTANTS PRIVATE LIMITED",
"COFLE TAYLOR INDIA CONTROL CABLES & SYSTEMS PRIVATE LIMITED",
"COFOODS PROCESSORS PRIVATE LIMITED",
"COFORGE BUSINESS PROCESS SOLUTIONS PRIVATE LIMITED",
"COFORGE DPA PRIVATE LIMITED",
"COFORGE LIMITED",
"COFORGE SMARTSERVE LIMITED",
"COFORGE SOLUTIONS PRIVATE LIMITED",
"COG DIGITAL PRIVATE LIMITED",
"COGBOOKS INDIA PRIVATE LIMITED",
"COGEME PRECISION PARTS INDIA PRIVATE LIMITED",
"COGENERATE TECHNOLOGIES PRIVATE LIMITED",
"COGENICS CONSULTING INDIA PRIVATE LIMITED",
"COGENT AUTOMATION PRIVATE LIMITED",
"COGENT CORPORATE PATHFINDERS PRIVATE LIMITED",
"COGENT DATA SOLUTIONS PRIVATE LIMITED",
"COGENT E SERVICES LIMITED",
"COGENT E-SERVICES PRIVATE LIMITED",
"COGENT FOODS PRIVATE LIMITED",
"COGENT GLASS LIMITED",
"COGENT INFOWAY PRIVATE LIMITED",
"COGENT INTEGRATED BUSINESS SOLUTIONS PRIVATE LIMITED",
"COGENT IT SOLUTIONS PRIVATE LIMITED",
"COGENT LIFE SCIENCE PRIVATE LIMITED",
"COGENT LOGISTICS PRIVATE. LIMITED",
"COGENT PROFESSIONALS PRIVATE LIMITED",
"COGENT SAFETY AND SECURITY PRIVATE LIMITED",
"COGENT STEEL AND PIPES PRIVATE LIMITED",
"COGENT TRANSWARE SOLUTIONS PRIVATE LIMITED",
"COGENTHUB PRIVATE LIMITED",
"COGENTIZ SOLUTIONS PRIVATE LIMITED",
"COGENTNEXT TECHNOLOGIES PRIVATE LIMITED",
"COGITATE TECHNOLOGY SOLUTIONS INDIA PRIVATE LIMITED",
"COGITECH SOLUTIONS PRIVATE LIMITED",
"COGMAC TECHNOLOGIES PRIVATE LIMITED",
"COGMAT DIGITAL MEDIA PRIVATE LIMITED",
"COGNAM TECHNOLOGIES PRIVATE LIMITED",
"COGNATE INDIA MEDICAL PRIVATE LIMITED",
"COGNATE IT SERVICES PRIVATE LIMITED",
"COGNEESOL PRIVATE LIMITED",
"COGNEGIC IT SERVICES (OPC) PRIVATE LIMITED",
"COGNERIUM ROBOTIC LABS PRIVATE LIMITED",
"COGNET HR SOLUTIONS PRIVATE LIMITED",
"COGNETRY LABS PRIVATE LIMITED",
"COGNEX SENSORS INDIA PRIVATE LIMITED",
"COGNEXT ANALYTICS PRIVATE LIMITED",
"COGNIAL ARTIFICIAL INTELLIGENCE SOLUTIONS PRIVATE LIMITED",
"COGNIC SYSTEMS PRIVATE LIMITED",
"COGNICOR TECHNOLOGIES PRIVATE LIMITED",
"COGNIGIX DIGITAL LEARNING PRIVATE LIMITED",
"COGNILEMENTS PRIVATE LIMITED",
"COGNILYTICS SOFTWARE AND CONSULTING PRIVATE LIMITED",
"COGNINE TECHNOLOGIES PRIVATE LIMITED",
"COGNIPHI TECHNOLOGIES PRIVATE LIMITED",
"COGNISCIENT BUSINESS SOLUTIONS PRIVATE LIMITED",
"COGNISENSE MEDIA PRIVATE LIMITED",
"COGNISUN INFOTECH PRIVATE LIMITED",
"COGNISURE SOLUTIONS PRIVATE LIMITED",
"COGNITEL TRAINING SERVICES PRIVATE LIMITED",
"COGNITER TECHNOLOGIES PRIVATE LIMITED",
"COGNITIO COMMUNICATIONS PRIVATE LIMITED",
"COGNITIO KNOWLEDGE TECH PRIVATE LIMITED",
"COGNITIONIS MEDED PRIVATE LIMITED",
"COGNITIVE BUSINESS INSIGHTS PRIVATE LIMITED",
"COGNITIVE GARAGE PRIVATE LIMITED",
"COGNITIVE INFOTECH INDIA PRIVATE LIMITED",
"COGNITIVE LIFE SCIENCES PRIVATE LIMITED",
"COGNITIVE PLATFORM SOLUTIONS PRIVATE LIMITED",
"COGNITIVE SKILLS PRIVATE LIMITED",
"COGNITIVECLOUDS SOFTWARE PRIVATE LIMITED",
"COGNITIVEMOBILE TECHNOLOGY PRIVATE LIMITED",
"COGNITIVESCALE SOFTWARE INDIA PRIVATE LIMITED",
"COGNITIVZEN TECHNOLOGIES PRIVATE LIMITED",
"COGNITONIC SYSTEMS (INDIA) PRIVATE LIMITED",
"COGNITREE TECHNOLOGIES PRIVATE LIMITED",
"COGNITREX CONSULTANTS PRIVATE LIMITED",
"COGNITUS CONSULTING IT SERVICES PRIVATE LIMITED",
"COGNIUS.AI (INDIA) PRIVATE LIMITED",
"COGNIWELL PHARMACEUTICALS PRIVATE LIMITED",
"COGNIWIDE TECHNOLOGIES PRIVATE LIMITED",
"COGNIWIZE INFOSYSTEMS PRIVATE LIMITED",
"COGNIZANCE CONSTRUCTIONS PRIVATE LIMITED",
"COGNIZANT CHEMICAL PRIVATE LIMITED",
"COGNIZANT FOUNDATION",
"COGNIZANT GLOBAL SERVICES PRIVATE LIMITED",
"COGNIZANT MORTGAGE SERVICES CORPORATION",
"COGNIZANT TECHNOLOGY SOLUTIONS INDIA PRIVATE LIMITED",
"COGNIZER INDIA PRIVATE LIMITED",
"COGNIZIONE CONSULTING & SOLUTIONS PRIVATE LIMITED",
"COGNOLOGIX TECHNOLOGIES PRIVATE LIMITED",
"COGNOME (INDIA) PRIVATE LIMITED",
"COGNOS INFRA PRIVATE LIMITED",
"COGNOSCENTE INVNTED PRIVATE LIMITED",
"COGNOSYS TECHNOLOGIES PRIVATE LIMITED",
"COGNOTICAI CONSULTING PRIVATE LIMITED",
"COGNOVIT POWER SOLUTIONS PRIVATE LIMITED",
"COGNUS TECHNOLOGY",
"COGO FREIGHT PRIVATE LIMITED",
"COGOPORT FREIGHT FORCE PRIVATE LIMITED",
"COGOPORT PRIVATE LIMITED",
"COGOS TECHNOLOGIES PRIVATE LIMITED",
"COGS INSURANCE SURVEYORS & LOSS ASSESSORS PRIVATE LIMITED",
"COGS RISK MANAGEMENT SERVICES PRIVATE LIMITED",
"COGSCIENTIA PRIVATE LIMITED",
"COGTEST SERVICES PRIVATE LIMITED",
"COGWHEEL FACILITY MANAGEMENT PRIVATE LIMITED",
"COHEN INTERNATIONAL SCHOOL",
"COHERA AUTOMATIONS PRIVATE LIMITED",
"COHERE TECH INDIA PRIVATE LIMITED",
"COHERENT APPLIANCES PRIVATE LIMITED",
"COHERENT INFRASTRUCTURE SOLUTIONS PRIVATE LIMITED",
"COHERENT LASER INDIA PRIVATE LIMITED",
"COHERENT MANAGEMENT SERVICES PRIVATE LIMITED",
"COHERENT MARKET INSIGHTS PRIVATE LIMITED",
"COHERENT PIXELS SYSTEMS PRIVATE LIMITED",
"COHERON SYSTEMS PRIVATE LIMITED",
"COHESION BIOTEC PRIVATE LIMITED",
"COHESITY INDIA PRIVATE LIMITED",
"COHESIVE DIGITAL PRIVATE LIMITED",
"COHESIVE INFRASTRUCTURE DEVELOPERS PRIVATE LIMITED",
"COHEZIA CREATIVE TECHNOLOGY PRIVATE LIMITED",
"COHNREZNICK PROFESSIONAL SERVICES PRIVATE LIMITED",
"COILCRAFT ELECTRONICS MARKETING INDIA PRIVATE LIMITED",
"COILS & TRANSFORMER INDIA PRIVATE LIMITED",
"COILS INDIA ELECTRONICS PRIVATE LIMITED",
"COIM INDIA PRIVATE LIMITED",
"COIMBATORE AERODYNE PRIVATE LIMITED",
"COIMBATORE AIR CONTROL SYSTEMS PRIVATE LIMITED",
"COIMBATORE ANAMALLAIS AGENCIES PRIVATE LIMITED",
"COIMBATORE CANCER FOUNDATION",
"COIMBATORE CAPITAL LIMITED",
"COIMBATORE CHILD TRUST HOSPITAL PRIVATE LIMITED",
"COIMBATORE COTTON CONCEPTS & DESIGNS PRIVATE LIMITED",
"COIMBATORE DIABETES FOUNDATION HOSPITAL PRIVATE LIMITED",
"COIMBATORE INNOVATION AND BUSINESS INCUBATOR",
"COIMBATORE INSTITUTE OF ENGINEERING & IN",
"COIMBATORE INSTITUTE OF MGMNT & TECHNOLO",
"COIMBATORE INSTITUTE OF TECHNOLOGY",
"COIMBATORE INTEGRATED WASTE MANAGEMENT COMPANY PRIVATE LIMITED",
"COIMBATORE KALPANAA TEX MILL LIMITED",
"COIMBATORE KIDNEY CARE AND RESEARCH LIMITED",
"COIMBATORE KITCHEN EQUIPMENTS PRIVATE LIMITED",
"COIMBATORE LAW COLLEGE",
"COIMBATORE MEDICAL COLLEGE",
"COIMBATORE METAL WORKS LIMITED",
"COIMBATORE PIONEER FERTILIZERS LIMITED",
"COIMBATORE PIONEER FERTILIZERS PRIVATE LIMITED",
"COIMBATORE PLUMBING COMPANY PRIVATE LIMITED",
"COIMBATORE POLYTEX PRIVATE LIMITED",
"COIMBATORE ROLLER FLOUR MILLS PRIVATE LIMITED",
"COIMBATORE STEEL HOUSE PRIVATE LIMITED",
"COIMBATORE SUPER ALLOYS PRIVATE LIMITED",
"COIMBATORE TWISTERS PRIVATE LIMITED",
"COIN ELECTRICAL PRODUCTS PRIVATE LIMITED.",
"COIN LAUNDRY EQUIPMENT AND SERVICES PRIVATE LIMITED",
"COIN TECHNOLOGIES PRIVATE LIMITED",
"COINAGE EXIM PRIVATE LIMITED",
"COINBASE INDIA SERVICES PRIVATE LIMITED",
"COIND ANTI-POLLUTION SYSTEMS PRIVATE LIMITED",
"COINFINITIVE SOLUTIONS PRIVATE LIMITED",
"COINFINITY GLOBAL EXCHANGE PRIVATE LIMITED",
"COINSBURG VENTURES PRIVATE LIMITED",
"COINTAB SOFTWARE PRIVATE LIMITED",
"COINTRIBE TECHNOLOGIES PRIVATE LIMITED",
"COIR BOARD COIR HOUSE",
"COIR COMFORT INDUSTRIES INDIA PRIVATE LIMITED",
"COIR ON FOAM PRODUCTS PRIVATE LIMITED",
"COIRFLEX MATTRESS INDIA PRIVATE LIMITED",
"COIRFOAM INDIA PRIVATE LIMITED",
"COJECTIVE DIGITAL PAYMENT AND TRADING SERVICES PRIVATE LIMITED",
"COK EXTERNAL SOLUTIONS PRIVATE LIMITED",
"COKINETIC SYSTEMS INDIA PRIVATE LIMITED",
"COKONET TECHNOLOGIES PRIVATE LIMITED",
"COL RD NIKAM SAINIK SAHAKARI BANK LTD",
"COLAB CLOUD PLATFORMS LIMITED",
"COLABA HOSPITALITY LLP",
"COLAN INFOTECH PRIVATE LIMITED",
"COLCOT PRIVATE LIMITED",
"COLD CARE SERVICES PRIVATE LIMITED",
"COLD CARE TECHNOLOGIES PRIVATE LIMITED",
"COLD LOVE ICE CREAM PRIVATE LIMITED",
"COLD POINT PRIVATE LIMITED",
"COLD STAR REFRIGERATION SALES AND SERVICES PRIVATE LIMITED",
"COLD TECH ENGINEERING PRIVATE LIMITED",
"COLD WELD ENGINEERS PRIVATE LIMITED",
"COLDADGE INDIA PRIVATE LIMITED",
"COLDEX LIMITED",
"COLDEX LOGISTICS PRIVATE LIMITED",
"COLDMAN LOGISTICS PRIVATE LIMITED",
"COLDMATIC FORGE PRIVATE LIMITED",
"COLDRIP STEELS PRIVATE LIMITED",
"COLDSMITHS RETAIL SERVICES PRIVATE LIMITED",
"COLDSTAR LOGISTICS PRIVATE LIMITED",
"COLDWAY INNOVATIONS PRIVATE LIMITED",
"COLDWELL REALITY PRIVATE LIMITED",
"COLDWIRE TECHNOLOGIES PRIVATE LIMITED",
"COLEAGUE SOLUTIONS PRIVATE LIMITED",
"COLEAGUE SYSTEM INTEGRATORS PRIVATE LIMITED",
"COLEDA PRIVATE LIMITED",
"COLENCE INTERNATIONAL PRIVATE LIMITED",
"COLENCON ENGINEERS PVT LTD",
"COLE-PARMER INDIA PRIVATE LIMITED",
"COLGATE GLOBAL BUSINESS SERVICES PRIVATE LIMITED",
"COLGATE PALMOLIVE INDIA LIMITED",
"COLINA TECH SOLUTION PRIVATE LIMITED",
"COLINTE SOLUTIONS PRIVATE LIMITED",
"COLINZ LABORATORIES LTD",
"COLIVING APARTMENTS PRIVATE LIMITED",
"COLIVING STORIES PRIVATE LIMITED",
"COLLAB CUBICLES PRIVATE LIMITED",
"COLLAB SOLUTIONS PRIVATE LIMITED",
"COLLABERA TALENT SOLUTIONS PRIVATE LIMITED",
"COLLABERA TECHNOLOGIES PRIVATE LIMITED",
"COLLABHUT CONSULTING SERVICES PRIVATE LIMITED",
"COLLABORATE SOLUTIONS PRIVATE LIMITED",
"COLLABORATION AND COMMUNICATION TECHNOLOGIES PRIVATE LIMITED",
"COLLABORATION PEOPLE TECHNOLOGIES PRIVATE LIMITED",
"COLLABORATIVE WORKSPACE CONSULTANTS LLP",
"COLLABRAH INDIA PRIVATE LIMITED",
"COLLABRAINS DEVOPS PRIVATE LIMITED",
"COLLAGE DESIGN PRIVATE LIMITED",
"COLLARCAMP SERVICES PRIVATE LIMITED",
"COLLATE STEEL PRIVATE LIMITED",
"COLLATERAL INFRACON PRIVATE LIMITED",
"COLLATERAL MEDICAL PRIVATE LIMITED",
"COLLEAGUES CONSULTANTS PRIVATE LIMITED",
"COLLECT FINANCIAL NUMISMATIC AND ARTS SERVICES PRIVATE LIMITED",
"COLLECTCENT DIGITAL MEDIA PRIVATE LIMITED",
"COLLECTER NAZUL MADHYA PRADESH",
"COLLECTIBLES ANTIQUES (INDIA) PRIVATE LIMITED",
"COLLECTIVE ART PRIVATE LIMITED",
"COLLECTIVE ARTISTS NETWORK INDIA PRIVATE LIMITED",
"COLLECTIVE ARTISTS PRIVATE LIMITED",
"COLLECTIVE GROWTH REALTY PRIVATE LIMITED",
"COLLECTIVE HEADS EXPERIENTIAL MARKETING SOLUTIONS PRIVATE LIMITED",
"COLLECTIVE INDIA PRIVATE LIMITED",
"COLLECTIVE S SOFTWARE PRIVATE LIMITED",
"COLLECTIVE TRADE LINKS PRIVATE LIMITED",
"COLLECTIVES FOR INTEGRATED LIVELIHOOD INITIATIVES¬† CINI",
"COLLECTIVO OILS PRIVATE LIMITED",
"COLLECTOR AND DISTRICT MISSION DIRECTOR SAMAGRA SHIKSHA RAIGARH",
"COLLECTOR HOSHANGABAD",
"COLLECTOR LAND RECORD SECTION",
"COLLECTOR OFFICE SABARKANTHA",
"COLLECTOR OFFICES AMRAVATI",
"COLLECTOR RAISEN MADHYA PRADESH",
"COLLECTOR SEONI",
"COLLECTORATE LKO",
"COLLECTRATE KANPUR DEHAT",
"COLLECTRATE OFFICE O C BILLS",
"COLLECTRATE OFFICE O C BILLS FOR D M FIROZABAD",
"COLLEGE DEVELOPMENT COUNCIL",
"COLLEGE MANTRA PRIVATE LIMITED",
"COLLEGE OF AGRICULTURE GWALIOR",
"COLLEGE OF AGRICULTURE PATHRI",
"COLLEGE OF AGRICULTURE SONAI",
"COLLEGE OF APPLIED EDUCATION AND HEALTH SCIENCES",
"COLLEGE OF ARCHITECTURE SOLAPUR",
"COLLEGE OF BUSINESS STUDIES AGRA",
"COLLEGE OF COMMERCE ARTS & SCIENCE PATNA",
"COLLEGE OF DENTAL SCIENCE & HOSPITAL",
"COLLEGE OF DENTISTRY INDORE",
"COLLEGE OF ENGINEERING KOLHAPUR",
"COLLEGE OF ENGINEERING OSMANABAD",
"COLLEGE OF ENGINEERING ROORKEE",
"COLLEGE OF FISHERY SCIENCE",
"COLLEGE OF INFORMATION TECH MANAGEMEN",
"COLLEGE OF MATERIAL MANAGEMENT JABALPUR",
"COLLEGE OF MILITARY ENGINEERING PUNE",
"COLLEGE OF SOCIAL WORK",
"COLLEGE OF SOCIAL WORK NIRMALA NIKETAN",
"COLLEGE OF VETERINARY SCIENCE AND ANIMAL HUSBANDRY",
"COLLEGEPOND COUNSELLORS PRIVATE LIMITED",
"COLLEGESOURCE CONSULTING (INDIA) PRIVATE LIMITED",
"COLLER SOLUTIONS LLP",
"COLLIERS INTERNATIONAL (INDIA) PROPERTY SERVICES PRIVATE LIMITED",
"COLLIGATE CONSULTANCY PRIVATE LIMITED",
"COLLINS INSTITUTION",
"COLLOQ MARKETING PRIVATE LIMITED",
"COLLOQI CONSULTING (OPC) PRIVATE LIMITED",
"COLLOSSEUM APPARELS PRIVATE LIMITED",
"COLOCUBE TECHNOLOGIES PRIVATE LIMITED",
"COLOGENESIS HEALTHCARE PRIVATE LIMITED",
"COLOGICX SYSTEMS PRIVATE LIMITED",
"COLOMBUS FREIGHT LOGISTICS PRIVATE LIMITED",
"COLOMBUS GLOBAL SERVICES PRIVATE LIMITED",
"COLONEL RESEARCH AND EDUCATION FOUNDATION",
"COLONEL'S BRIGHTLAND PUBLIC SCHOOL",
"COLONELS KABABZ TANDOORI PRIVATE LIMITED",
"COLONELS SECURITY SERVICES PRIVATE LIMITED",
"COLONIA SANTA MARIA HOTELS PRIVATE LIMITED",
"COLONIAL CONSTRUCTIONS PRIVATE LIMITED",
"COLONIAL HARD WOODS PRIVATE LIMITED",
"COLONIAL MINERALS PRIVATE LIMITED",
"COLOP STAMPS INDIA PRIVATE LIMITED",
"COLOPLAST INDIA PRIVATE LIMITED",
"COLOR BOND MARKETING LIMITED",
"COLOR CHEMICALS",
"COLOR CLOUD SOLUTIONS PRIVATE LIMITED",
"COLOR GRANITO PRIVATE LIMITED",
"COLOR INDIA FILMS PRIVATE LIMITED",
"COLOR MASTER PRINT PROCESS PRIVATE LIMITED",
"COLOR N CREATION PACKAGING PRIVATE LIMITED",
"COLOR PALETTE PRIVATE LIMITED",
"COLOR PLUS FASHIONS PRIVATE LIMITED",
"COLOR SORTEX MACHINERY PRIVATE LIMITED",
"COLOR TILES PRIVATE LIMITED",
"COLORAMA PRINTERS PRIVATE LIMITED",
"COLORANT LIMITED",
"COLORANTS CHEM PRIVATE LIMITED",
"COLORBAND DYESTUFF PRIVATE LIMITED",
"COLORBAR COSMETICS PRIVATE LIMITED",
"COLORBOX EXIM PRIVATE LIMITED",
"COLORCHIPS NEW MEDIA LIMITED",
"COLORCON ASIA PRIVATE LIMITED",
"COLOREYES EYECARE PRIVATE LIMITED",
"COLORFLEX GLOBAL PRIVATE LIMITED",
"COLORFUL VACATIONS PRIVATE LIMITED",
"COLORIMETR CONSULTING PRIVATE LIMITED",
"COLORJET INDIA LIMITED",
"COLORLINES CLOTHING INDIA PRIVATE. LIMITED.",
"COLORMAGIX PRINTOPACK PRIVATE LIMITED",
"COLORMANN PRIVATE LIMITED",
"COLOROBBIA CHEMICALS INDIA PRIVATE LIMITED",
"COLOROMATIC ARTS PRIVATE LIMITED",
"COLORON CARE PRIVATE LIMITED",
"COLORPIX STUDIO INDIA PRIVATE LIMITED",
"COLORPLAST SYSTEMS PRIVATE LIMITED",
"COLORPLUS FASHIONS LIMITED",
"COLORS & EFFECTS INDIA PRIVATE LIMITED",
"COLORS CONDOMINIUM PRIVATE LIMITED",
"COLORS FOOT FASHION PRIVATE LIMITED",
"COLORS HOME APPLIANCES PRIVATE LIMITED",
"COLORS INDIA INDUSTRIES PRIVATE LIMITED",
"COLORS INFRA PRIVATE LIMITED",
"COLORS OF INDIA TOURS PRIVATE LIMITED",
"COLORS SULZER PRIVATE. LIMITED.",
"COLORS TRENDZ PRIVATE LIMITED",
"COLORSHINE COATED PRIVATE LIMITED",
"COLORSOUL FASHION PRIVATE LIMITED",
"COLORTEK (INDIA) PRIVATE LIMITED",
"COLORTEK (MEGHALAYA) PRIVATE LIMITED",
"COLORTEX PRODUCTS PRIVATE LIMITED",
"COLORTEXT DIGITAL SOLUTIONS PRIVATE LIMITED",
"COLORTOKENS INDIA LLP",
"COLORTONE MARKETING PRIVATE LIMITED",
"COLORTONE PROCESS PRIVATE LIMITED",
"COLORTONE TEXTILES PRIVATE LIMITED",
"COLORVISION SERVICES PRIVATE LIMITED",
"COLORZ N STYLE PRIVATE LIMITED",
"COLOSCEUM MEDIA PRIVATE LIMITED",
"COLOSSAL FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"COLOSSAL HOSPITALITY AND ENTERTAINMENT PRIVATE LIMITED",
"COLOSSAL LOGISTICS INDIA PRIVATE LIMITED",
"COLOSSAL REAL ESTATES PRIVATE LIMITED",
"COLOSSAL SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"COLOSSEUM PROPERTIES PRIVATE LIMITED",
"COLOSSIANS KNOWLEDGE COMPANY PRIVATE LIMITED",
"COLOSSUS FOURNITURE PRIVATE LIMITED",
"COLOSSUS INFRA-PROJECTS PRIVATE LIMITED",
"COLOSSUS MANPOWER SOLUTIONS PRIVATE LIMITED",
"COLOSSUS TRADE LINKS LIMITED.",
"COLOSSUSTEX PRIVATE LIMITED",
"COLOUR CHROMES PRIVATE LIMITED",
"COLOUR CONCEPT PRIVATE LIMITED",
"COLOUR CREATION PRIVATE LIMITED",
"COLOUR FASHIONS PRIVATE LIMITED",
"COLOUR GRAPHICS PRIVATE LIMITED",
"COLOUR MOON TECHNOLOGIES PRIVATE LIMITED",
"COLOUR PACKS PRIVATE LIMITED",
"COLOUR PLUS ORGANICS PRIVATE LIMITED",
"COLOUR PLUS POLYURETHANES PRIVATE LIMITED",
"COLOUR PRINTS PRIVATE LIMITED",
"COLOUR PUBLICATIONS PRIVATE LIMITED",
"COLOUR ROOF INDIA LIMITED",
"COLOUR SQUARE MARKETING PRIVATE LIMITED",
"COLOUR STREAM (INDIA) PRIVATE LIMITED",
"COLOUR YELLOW PRODUCTIONS PRIVATE LIMITED",
"COLOUR-CHEMINDIA PRIVATE LIMITED",
"COLOURED CHECKERS FILMS AND ENTERTAINMENT PRIVATE LIMITED",
"COLOURED ROCKS TRADING PRIVATE LIMITED",
"COLOURFLEX LAMINATORS LIMITED",
"COLOURGLOB LLP",
"COLOURKART PACKAGING PRIVATE LIMITED",
"COLOURS BIOTECH PRIVATE LIMITED",
"COLOURS INTERNATIONAL LIMITED",
"COLOURSHINE HOSIERY PRIVATE LIMITED",
"COLOURSPACE PACKAGING PRIVATE LIMITED",
"COLOURTECH COATING (INDIA) PRIVATE LIMITED",
"COLOURTECH PRODUCTS PRIVATE LIMITED",
"COLOURTEX INDUSTRIES PRIVATE LIMITED",
"COLRUYT GROUP INDIA PRIVATE LIMITED",
"COLSTON BATH & SPA PRIVATE LIMITED",
"COLT EQUIPMENTS PRIVATE LIMITED",
"COLT INDIA PRIVATE LIMITED",
"COLT TECHNOLOGY SERVICES INDIA PRIVATE LIMITED",
"COLTENE WHALEDENT PRIVATE LIMITED",
"COLTON CARS PRIVATE LIMITED",
"COLTON WELDTEK PRIVATE LIMITED",
"COLUMBIA AURUS SHIP MANAGEMENT PRIVATE LIMITED",
"COLUMBIA DEVELOPERS PRIVATE LIMITED",
"COLUMBIA HOLDINGS PRIVATE LIMITED",
"COLUMBIA INSTITUTE OF PHARMACY",
"COLUMBIA MACHINE ENGINEERING INDIA PRIVATE LIMITED",
"COLUMBIA PETRO CHEM PRIVATE LIMITED",
"COLUMBIA SPORTSWEAR COMPANY",
"COLUMBIA SPORTSWEAR INDIA SOURCING PRIVATE LIMITED",
"COLUMBIAN CHEMICALS COMPANY",
"COLUMBUS ELECTRONICS PRIVATE LIMITED",
"COLUMBUS FASHION FOOTWEAR PRIVATE LIMITED",
"COLUMBUS GLOBAL SERVICES INDIA PRIVATE LIMITED",
"COLUMBUS INDIA PRIVATE LIMITED",
"COLUMBUS INTEGRATION SERVICES PRIVATE LIMITED",
"COLUMBUS INTERNATIONAL SHOES PRIVATE LIMITED",
"COLUMBUS MARKETING PRIVATE LIMITED",
"COLUMBUS PREMIER SHOES PRIVATE LIMITED",
"COLUMBUS PUBLIC SCHOOL",
"COLUMBUS TRAVELS & SERVICES PRIVATE LIMITED",
"PARSEQ ASIA PRIVATE LIMITED",
"NEWROCKET INDIA PRIVATE LIMITED",
"COLVA FOODS PRIVATE LIMITED",
"COLVETA INDIA LIMITED",
"COLVILL RESEARCH PRIVATE LIMITED",
"COLVIN TALUQDARS COLLEGE LUCKNOW",
"COM- 1 COMMUNICATION TECHNOLOGIES PRIVATE LIMITED",
"COM SECURITY SERVICES PRIVATE LIMITED",
"COM TECH SERVICES",
"COM VISION (INDIA) PRIVATE LIMITED",
"COMAC INDIA PRIVATE LIMITED",
"COMANDANT SOLAR ENERGY PRIVATE LIMITED",
"COMAP INDIA PRIVATE LIMITED",
"COMART LITHOGRAPHERS PRIVATE LIMITED",
"COMART ONE PRE-MEDIA PRIVATE LIMITED",
"COMART RETAIL SOLUTIONS PRIVATE LIMITED",
"COMAU INDIA PRIVATE LIMITED",
"COMAVIA SYSTEMS TECHNOLOGIES PRIVATE LIMITED",
"COMAX HOSPITALITY PRIVATE LIMITED",
"COMBAT AGROTECH & FOODS PRIVATE LIMITED",
"COMBAT VEHICLES RESEARCH AND DEVELOPMENT",
"COMBAT VEHICLES RESEARCH AND DEVELOPMENT ESTABLISHMENT",
"COMBII ORGANOCHEM PVT LTD",
"COMBINATOR VENTURE INDIA PRIVATE LIMITED",
"COMBINE CLEARING AND FORWARDING PRIVATE LIMITED",
"COMBINE DIAMONDS PRIVATE LIMITED",
"COMBINE ELEC-MECH ENGINEERS PRIVATE LIMITED",
"COMBINE HOLDING LIMITED",
"COMBINE INFRA SERVICES PRIVATE LIMITED",
"COMBINE OVERSEAS LIMITED",
"COMBINE REALTY PRIVATE LIMITED",
"COMBINED AUTOMOTIVES PRIVATE LIMITED",
"COMBINED ELECTRICALS PRIVATE LIMITED",
"COMBINED GENERAL TRADING PRIVATE LIMITED",
"COMBINED MEDICAL INSTITUTE PRIVATE LIMITED",
"COMBINED PROMOTIONS PRIVATE LIMITED",
"COMBINED PROMOTORS AND INFRASTRUCTURES PRIVATE LIMITED",
"COMBINED SHIPPING SERVICES PRIVATE LIMITED",
"COMBINO INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"COMBITIC GLOBAL CAPLET PRIVATE LIMITED",
"COMBOSEAL INDUSTRIES PRIVATE LIMITED",
"COMBRIDGE INTERNATIONAL SCHOOL",
"COMBUSTION CONCEPTS PRIVATE LIMITED",
"COMBYTE EXPORTS PRIVATE LIMITED",
"COMBYTE TEXTILE PRIVATE LIMITED",
"COMCAST INDIA ENGINEERING CENTER I LLP",
"COMCON ELECTRONICS PRIVATE LIMITED",
"COMCON TECHNOLOGIES LIMITED",
"COMCX IT PRIVATE LIMITED",
"COMECER INDIA PRIVATE LIMITED",
"COMED CHEMICALS LIMITED",
"COMER INDUSTRIES INDIA PRIVATE LIMITED",
"COMESUM RETAIL & HOSPITALITY PRIVATE LIMITED",
"COMET ACCESSORIES PRIVATE LIMITED",
"COMET AUTO INDIA PRIVATE LIMITED",
"COMET CABLES PRIVATE LIMITED",
"COMET CAR SALES AND SERVICE PRIVATE LIMITED",
"COMET CERAMIC PRIVATE. LIMITED.",
"COMET CONVERSION SERVICES INDIA PRIVATE LIMITED",
"COMET ELECTRONICS PRIVATE LTD",
"COMET ENERGY SOLUTIONS INDIA PRIVATE LIMITED",
"COMET EXPORTS",
"COMET GRANITO PRIVATE LIMITED",
"COMET HANDICRAFTS",
"COMET PERFORMANCE CHEMICALS PRIVATE LIMITED",
"COMET POLYPLAST PRIVATE LIMITED",
"COMET POWER PRIVATE LIMITED",
"COMET SURGICALS PRIVATE LIMITED",
"COMET TECHNOCOM PRIVATE LIMITED",
"COMET TOOLS (GUJ ) PVT LTD",
"COMET TRADECOM PRIVATE LIMITED",
"COMETECH COMPONENT PRIVATE LIMITED",
"COMETT STAFFING SOLUTIONS PRIVATE LIMITED",
"COMETWELD PRIVATE LIMITED",
"COMEX SERVICES LIMITED",
"COMEXPOSIUM INDIA LIMITED",
"COMFESTA HOME FURNISHINGS PRIVATE LIMITED",
"COMFFITS INTERIORS AND MARKETING PRIVATE LIMITED",
"COMFIT AND VALVES PRIVATE LIMITED",
"COMFLEX TECHNOLOGIES PRIVATE LIMITED",
"COMFOAMS LIMITED",
"COMFOBAL HOTELS PRIVATE LIMITED",
"COMFONOMICS DESIGN VENTURES LLP",
"COMFORT AC SOLUTIONS",
"COMFORT CAPITAL PRIVATE LIMITED",
"COMFORT CASTLE PRIVATE LIMITED",
"COMFORT CLOTHING PRIVATE LIMITED",
"COMFORT COMMOTRADE LIMITED",
"COMFORT COOL AND SYSTEMS PRIVATE LIMITED",
"COMFORT COTTON TEX PRIVATE LIMITED",
"COMFORT ELEVATORS & ESCALATORS PRIVATE LIMITED",
"COMFORT FASHIONS PRIVATE LIMITED",
"COMFORT FINCAP LIMITED",
"COMFORT GARMENTS PRIVATE LIMITED",
"COMFORT GEOSYNTHETICS AND MARKETING PRIVATE LIMITED",
"COMFORT GRID TECHNOLOGIES PRIVATE LIMITED",
"COMFORT HOLIDAYS PRIVATE LIMITED",
"COMFORT HOSIERY LIMITED",
"COMFORT HOSPITALITY PRIVATE LIMITED",
"COMFORT INSTA-POWER LIMITED",
"COMFORT LEISURE PRIVATE LIMITED",
"COMFORT NET TRADERS (INDIA) PRIVATE LIMITED",
"COMFORT OF JESUS MINISTRIES",
"COMFORT SECURITIES LIMITED",
"COMFORT SHELTERS PRIVATE LIMITED",
"COMFORT TECHNO SERVICES PRIVATE LIMITED",
"COMFORT TOURS PRIVATE LIMITED",
"COMFORT TRIMS PRIVATE LIMITED",
"COMFORT WAREHOUSING PRIVATE LIMITED",
"COMFOTEC ENGINEERING CONSULTING PRIVATE LIMITED",
"COMFY CLOTHING PRIVATE LIMITED",
"COMFY PROBUILD PRIVATE LIMITED",
"COMFY SHOEMAKERS PRIVATE LIMITED",
"COMGEN INDIA SOFTWARE SOLUTION PRIVATE LIMITED",
"COMGEN INFO SYSTEM PRIVATE LIMITED",
"COMGUARD INFOSOL PRIVATE LIMITED",
"COMHARD TECHNOLOGIES PRIVATE LIMITED",
"COMIC CON INDIA PRIVATE LIMITED",
"COMIC HUB PRIVATE LIMITED",
"COMIENZO AGRI SCIENCE LIMITED",
"COMIENZO CLADDINGS PRIVATE LIMITED",
"COMINIX INDIA PRIVATE LIMITED",
"COMINT SYSTEMS AND SOLUTIONS PRIVATE LIMITED",
"COMITASAG PRIVATE LIMITED",
"COMITY DESIGNS PRIVATE LIMITED",
"COMLINE CORPORATE SOLUTIONS PRIVATE LIMITED",
"COMM IT INDIA PRIVATE LIMITED",
"COMM OFF 13TH N C C HOSHANGAB",
"COMM.OF HEALTH& MEDICAL SERVICES HEALTH SECT",
"COMM100 PRIVATE LIMITED",
"COMM4 TELECOM PRIVATE LIMITED",
"COMMA CONSULTING PRIVATE LIMTED",
"COMMAND ALKON INDIA PRIVATE LIMITED",
"COMMAND AREA DEVELOPMENT AUTHORITY AHMEDNAGAR",
"COMMAND HOSPITAL LUCKNOW",
"COMMAND HOSPITAL PUNE",
"COMMAND HOSPITAL SOUTHERN COMMAND PUNE",
"COMMAND POLYMERS LIMITED",
"COMMANDALL TECHNOLOGIES PRIVATE LIMITED",
"COMMANDANT (ADJUTANT)SRP FORCE GROUP3 JALNA",
"COMMANDANT REMOUNT TRAINING SCHOOL AND DEPOT",
"COMMANDANT REMOUNT TRAINING SCHOOL AND DEPOT SAHARANPUR",
"COMMANDANT SRP FORCE GROUP1 PUNE",
"COMMANDENT COMMANDENT 15TH BATALIAN S.A.F INDORE",
"COMMANDER INDUSTRIES PRIVATE LIMITED",
"COMMANDER REALCON PRIVATE LIMITED",
"COMMANDER VITRIFIED PRIVATE LIMITED",
"COMMANDER WATERTECH PRIVATE LIMITED",
"COMMANDER WORKS ENGINEER",
"COMMANDING OFFICER 36 M P BTN N C C COLLECTOR KHANDWA",
"COMMANDING OFFICER 4MP GIRLS BN NCC BHOPAL MADHYA PRADESH",
"COMMANDO CORPORATE SERVICES PRIVATE LIMITED",
"COMMANDO KENNELS AND INDUSTRIAL SECURITY SERVICES PRIVATE LIMITED",
"COMMANDO MUSCLE POWER PRIVATE LIMITED",
"COMMANDO ORGANISATION PLACEMENT SECURITY PRIVATE LIMITED",
"COMMANDO PROTECTION SECURITY (INDIA) PRIVATE LIMITED",
"COMMANDO SECURITY FORCE PRIVATE LIMITED",
"COMMCORP INTERNATIONAL LLP",
"COMMDEL CONSULTING SERVICES PRIVATE LIMITED",
"COMMEASURE SOLUTIONS INDIA PRIVATE LIMITED",
"COMMEDIA SOLUTIONS PRIVATE LIMITED",
"COMMERCE & INDUSTRIES DEPARTMENT GOVERNMENT OF CHHATTISHGARH OFFICE OF THE GENERAL MANAGER DISTRICT TRADE & INDUSTRY CENTRE JANJGIR CHAMPA ( CG ) // KORBA",
"COMMERCE FABRIC SOLUTIONS PRIVATE LIMITED",
"COMMERCE PUNDIT TECHNOLOGIES PRIVATE LIMITED",
"COMMERCE VELOCITY INDIA PRIVATE LIMITED",
"COMMERCIAL AND BUSINESS AVIATION SERVICES PRIVATE LIMITED",
"COMMERCIAL ART ENGRAVERS PRIVATE LIMITED",
"COMMERCIAL AUTO PRODUCTS PRIVATE LIMITED",
"COMMERCIAL AUTO SALES PRIVATE. LIMITED.",
"COMMERCIAL AUTOMOBILES JABALPUR PRIVATE LIMITED",
"COMMERCIAL AUTOMOBILES PRIVATE LIMITED",
"COMMERCIAL AUTOMOTIVES PRIVATE LIMITED",
"COMMERCIAL BANK OF DUBAI",
"COMMERCIAL CARGO MOVERS PVT LTD",
"COMMERCIAL CATTERERS(GUJARAT) PVT LTD",
"COMMERCIAL EXPLOSIVES (INDIA) PRIVATE LTD",
"COMMERCIAL IRON & STEEL COMPANY PRIVATE LIMITED",
"COMMERCIAL LAW PUBLISHERS (INDIA) PRIVATE LIMITED",
"COMMERCIAL METALS INTERNATIONAL AG",
"COMMERCIAL MOTOR SALES PRIVATE LIMITED",
"COMMERCIAL SHELTERS PRIVATE LIMITED",
"COMMERCIAL SYN BAGS LIMITED",
"COMMERCIAL SYNBAGS LIMITED",
"COMMERCIAL TAX DEPARTMENT",
"COMMERCIAL TAX DEPT",
"COMMERCIAL TAX OFFICER DEWAS",
"COMMERCIAL TAXES WEST BENGAL",
"COMMERCIAL TRADE TAX UP LKO GOVT",
"COMMERCIAL UNION ASSURANCE CO. LIMITED",
"COMMERZ BANK",
"COMMISIONER NAGAR NIGAM UDAIPUR",
"COMMISSIONER COM AREA DEVE WRD BHOPAL",
"COMMISSIONER COMMERCIAL TAXES DEPT",
"COMMISSIONER FOOD & CIVIL SUPPLIES UP LUCKNOW",
"COMMISSIONER FOOD AND DRUGS ADMINISTRATION",
"COMMISSIONER FOR COOPERATION AND REGISTRAR OF CO OP SOC",
"COMMISSIONER INDORE DIVISION",
"COMMISSIONER LAND RECORDS NAYA RAIPUR INDRAWATI BHAWAN NAYA RAIPUR",
"COMMISSIONER OF RAILWAY SAFETY",
"COMMISSIONER OF SCHOOLS GANDHINAGAR",
"COMMISSIONER SOIL AND WATER CONSERVATION MAHARASHTRA",
"COMMISSIONER STATE EXCISE",
"COMMISSIONER STATE TAX",
"COMMISSIONERATE OF AGRICULTURE",
"COMMISSIONERATE OF CENTRAL EXCISE",
"COMMISSIONERATE OF HIGHER EDUCATION",
"COMMISSIONERATE OF RURAL DEVELOPMENT GANDHINAGAR",
"COMMIT INDUSTRIES PRIVATE LIMITED",
"COMMIT TECHNOLOGIES PRIVATE LIMITED",
"COMMITMENT FINANCIAL SERVICES PRIVATE LIMITED",
"COMMITTED CARGO CARE LIMITED",
"COMMITTED ISPAT PRIVATE LIMITED",
"COMMITTED LOGISTICS (INDIA) PRIVATE LIMITED",
"COMMLAB INDIA LLP",
"COMMLABS TECHNOLOGY CENTRE PRIVATE LIMITED",
"COMMNET SYSTEMS CONSULTANCY PRIVATE LIMITED",
"COMMODITIES INTERNATIONAL PVT. LTD.",
"COMMODITY ALPHA PRIVATE LIMITED",
"COMMODITY MANDI PRIVATE LIMITED",
"COMMODORE TRADE PRIVATE LIMITED",
"COMMON GROUND PLACEMENT SOLUTIONS PRIVATE LIMITED",
"COMMON WEALTH LABORATORIES INDIA PRIVATE LIMITED",
"COMMONCITY RETAIL PRIVATE LIMITED",
"COMMONFORCE SERVICES PRIVATE LIMITED",
"COMMONWEALTH BANK OF AUSTRALIA",
"COMMONWEALTH CLAY PRIVATE LIMITED",
"COMMONWEALTH GAMES",
"COMMONWEALTH INCLUSIVE GROWTH",
"COMMONWEALTH INCLUSIVE GROWTH SERVICES LIMITED",
"COMMONWEALTH INDUSTRIES BOMBAY PRIVATE LIMITED",
"COMMRAX NETWORKS PRIVATE LIMITED",
"COMMSCOPE INDIA PRIVATE LIMITED",
"COMMSCOPE NETWORKS INDIA PRIVATE LIMITED",
"COMMSCOPE SOLUTIONS INDIA PRIVATE LIMITED",
"COMMSYS INFORMATION SYSTEM PRIVATE LIMITED",
"COMMTEL NETWORKS PRIVATE LIMITED",
"COMMUNE PROPERTIES INDIA PRIVATE LIMITED",
"COMMUNICATION MEDIA PRODUCTS INDIA PRIVATE LIMITED",
"COMMUNICATION MERCHANTS",
"COMMUNICATION PLATFORM INDIA PRIVATE LIMITED",
"COMMUNICATION WORLD INFOMATIC PRIVATE LIMITED",
"COMMUNICATIONS AND SYSTEMS ENGINEERING (CASE) PRIVATE LIMITED",
"COMMUNICATIONS PRIVATE LIMITED",
"COMMUNICATIONS TEST DESIGN INDIA PRIVATE LIMITED",
"COMMUNIQUE MARKETING SOLUTIONS PRIVATE LIMITED",
"COMMUNISIS DIGITAL PRIVATE LIMITED",
"COMMUNITI CONNECT PRIVATE LIMITED",
"COMMUNITY ACTION THROUGH MOTIVATION PROGRAMME CAMP",
"COMMUNITY BRANDS SOFTWARE DEVELOPMENT SOLUTIONS (INDIA) PRIVATE LIMITED",
"COMMUNITY BUSINESS (INDIA) PRIVATE LIMITED",
"COMMUNITY DEVELOPMENT CENTRE",
"COMMUNITY EMPOWERMENT LAB",
"COMMUNITY FINANCE PRIVATE LIMITED",
"COMMUNITY FOUNDATION FOR CHILDREN & AGING",
"COMMUNITY HEALTH CENTER AKHDOL.",
"COMMUNITY HEALTH CENTRE REENGUS (SIKAR)",
"COMMUNITY INDIA HOSPITALITY & RESORTS PRIVATE LIMITED",
"COMMUNITY INSTITUTE OF MANAGEMENT STUDIES",
"COMMUNITY TRIPVER PRIVATE LIMITED",
"COMMUNITY¬†HEALTH¬†CENTRE¬†BISWAN¬†SITAPUR",
"COMMUNITYFORCE SERVICES PRIVATE LIMITED",
"COMMUSOFT PRIVATE LIMITED",
"COMMVAULT SYSTEMS INDIA PRIVATE LIMITED",
"COMMVERSION SOLUTIONS PRIVATE LIMITED",
"COMNET BUSINESS ENHANCED PRIVATE LIMITED",
"COMNET EXHIBITIONS PRIVATE LIMITED",
"COMNET INNOVATIONS PRIVATE LIMITED",
"COMNET PUBLISHERS PRIVATE LIMITED",
"COMNET SOLUTIONS PRIVATE LIMITED",
"COMNET VISION (INDIA) PRIVATE LIMITED",
"COMO INFO SOLUTIONS PRIVATE LIMITED",
"COMO TOYS PRIVATE LIMITED",
"COMODO CERTAUTH INDIA SERVICES PRIVATE LIMITED",
"COMODO SECURITY SOLUTIONS PRIVATE LIMITED",
"COMORIN CONSULTING SERVICES INDIA PRIVATE LIMITED",
"COMP AIR TREATMENT SYSTEM PVT LTD",
"COMP POINT SYSTEMS INDIA PRIVATE LIMITED",
"COMPAC INDUSTRIES PRIVATE LIMITED",
"COMPAC PRINTERS PRIVATE LIMITED",
"COMPAC TECHNOLOGIES INDIA LIMITED",
"COMPACK EXTRUSIONS PRIVATE LIMITED",
"COMPACK FOAM PRIVATE. LIMITED.",
"COMPACK PACKAGING PRIVATE LIMITED",
"COMPACK PRIVATE LIMITED",
"COMPACT BUILDERS AND DEVELOPERS PVT LTD",
"COMPACT DIAGNOSTICS INDIA PRIVATE LIMITED",
"COMPACT FACILITY SERVICES PRIVATE LIMITED",
"COMPACT GIANT (INDIA) PRIVATE LIMITED",
"COMPACT HOMETEL INDIA PRIVATE LIMITED",
"COMPACT INDIA PRIVATE LIMITED",
"COMPACT INNOVATION AVENUES PRIVATE LIMITED",
"COMPACT PLYBOARDS PRIVATE LIMITED",
"COMPACT PRINT TECH PRIVATE LIMITED",
"COMPACT SPINNERS INDIA PRIVATE LIMITED",
"COMPACT SYSTEMS PRIVATE LIMITED",
"COMPAGE AUTOMATION SYSTEMS PRIVATE LIMITED",
"COMPAGE COMPUTERS PRIVATE LIMITED",
"COMPAGNIE INDO-FRENCAISE DE-COMMERCE PVT LTD",
"COMPAGO ENGINEERING & CONSTRUCTIONS PRIVATE LIMITED",
"COMPAL ELECTRONICS INDIA PRIVATE LIMITED",
"COMPAMEDIC INSTRUMENTS PRIVATE LIMITED",
"COMPANIESHOUSE LLP",
"COMPANION ANIMAL HEALTHCARE ALPHAPETS PRIVATE LIMITED",
"COMPANION MINERALS PRIVATE LIMITED",
"COMPANY LAW INSTITUTE OF INDIA PRIVATE LIMITED",
"COMPANY3 METHOD INDIA PRIVATE LIMITED",
"COMPANYHUB IT SOLUTIONS PRIVATE LIMITED",
"COMPAQ COMPUTERS ASIA P LIMITED",
"COMPAQ INTERNATIONAL PRIVATE LIMITED",
"COMPARE POLICY INSURANCE WEB AGGREGATORS PRIVATE LIMITED",
"COMPAREX INDIA PRIVATE LIMITED",
"COMPART PROCESSORS PRIVATE LIMITED",
"COMPASS ENTERPRISES PRIVATE LIMITED",
"COMPASS GLOBAL LOGISTICS PRIVATE LIMITED",
"COMPASS GLOBAL SERVICES INDIA PRIVATE LIMITED",
"COMPASS GROUP (INDIA) PRIVATE LIMITED",
"COMPASS INDIA FOOD SERVICES PRIVATE LIMITED",
"COMPASS INDIA HOLIDAYS PRIVATE LIMITED",
"COMPASS INDIA SUPPORT SERVICES PRIVATE LIMITED",
"COMPASS IT SOLUTIONS AND SERVICES PRIVATE LIMITED",
"COMPASS LOGISTICS INTERNATIONAL PRIVATE LIMITED",
"COMPASS SYSTEMS PRIVATE LIMITED",
"COMPASS TEX INDIA PRIVATE LIMITED",
"COMPASSITES SOFTWARE SOLUTIONS PRIVATE LIMITED",
"COMPATIBLE CONCEPTS PRIVATE LIMITED",
"COMPATIBLE POWER PRIVATE LIMITED",
"COMPATIO INDIA PRIVATE LIMITED",
"COMPAX INDUSTRIAL SYSTEMS PRIVATE LIMITED",
"COMPECT METALS PRIVATE LIMITED",
"COMPEDGE SOLUTIONS (INDIA) PRIVATE LIMITED",
"COMPETE MEDICAL DEVICES PRIVATE LIMITED",
"COMPETE TOOLS PRIVATE LIMITED",
"COMPETENCE EXPORTS PRIVATE LIMITED",
"COMPETENT AUTOMOBILES COMPANY LIMITED",
"COMPETENT CARGO PRIVATE LIMITED",
"COMPETENT CONSTRUCTION COMPANY",
"COMPETENT CONVEYOR SYSTEMS PRIVATE LIMITED",
"COMPETENT CRIMPING MACHINERY PRIVATE LIMITED",
"COMPETENT FINMAN PRIVATE LIMITED",
"COMPETENT FOREX SERVICES PRIVATE LIMITED",
"COMPETENT FORGING LIMITED",
"COMPETENT GROOVE PRIVATE LIMITED",
"COMPETENT HOLDINGS PRIVATE LIMITED",
"COMPETENT HUMAN RESOURCE AND ALLIED SERVICES PRIVATE LIMITED",
"COMPETENT INDUSTRIES PRIVATE LIMITED",
"COMPETENT INFRASTRUCTURE & CONSULTING PRIVATE LIMITED",
"COMPETENT MEDICAL SYSTEM (INDIA) PRIVATE LIMITED",
"COMPETENT PNEUMATIC PRIVATE LIMITED",
"COMPETENT POLYMERS PRIVATE LIMITED",
"COMPETENT SECURITIES PRIVATE LIMITED",
"COMPETENT SENTINELS PRIVATE LIMITED",
"COMPETENT SOFTWARE PRIVATE LIMITED",
"COMPETENT SYNERGIES PRIVATE LIMITED",
"COMPETENT SYNTECH PRIVATE LIMITED",
"COMPETENT TRANSPORTS PRIVATE LIMITED",
"COMPETENT VIDYUT TOWERS PRIVATE LIMITED",
"COMPETENZA INNOVARE PRIVATE LIMITED",
"COMPETITION REVIEW PRIVATE LIMITED",
"COMPETITION TEAM TECHNOLOGY INDIA PRIVATE LIMITED",
"COMPETITIVE CAREERS PRIVATE LIMITED",
"COMPETITIVE TOOLING SOLUTIONS PRIVATE LIMITED",
"COMPEX TECHNOLOGIES PRIVATE LIMITED",
"COMPHOTOSET INDIA PVT LTD",
"COMPILE INDIA PRIVATE LIMITED",
"COMPILECREW TECHNOLOGIES PRIVATE LIMITED",
"COMPINDIA INFOTECH PRIVATE LIMITED",
"COMPLETE CEILING INTERIOR PRODUCTS PRIVATE LIMITED.",
"COMPLETE COMFORT SOLUTIONS PRIVATE LIMITED",
"COMPLETE DEWATERING SYSTEMS PRIVATE LIMITED",
"COMPLETE HEALTH SERVICES PRIVATE LIMITED",
"COMPLETE HEOR SOLUTIONS INDIA PRIVATE LIMITED",
"COMPLETE INSTRUMENTATION SOLUTIONS PRIVATE LIMITED",
"COMPLETE PACKAGE INDIA PRIVATE LIMITED",
"COMPLETE PACKAZING PRIVATE LIMITED",
"COMPLETE SOLUTIONS FACILITY MANAGEMENT PRIVATE LIMITED",
"COMPLETE SOLUTIONS SERVICE APARTMENT PRIVATE LIMITED",
"COMPLETE SOLUTIONS TOUR AND TRAVELS PRIVATE LIMITED",
"COMPLETE SPORTS AND MANAGEMENT INDIA PRIVATE LIMITED",
"COMPLETE SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED",
"COMPLETE SURVEYING TECHNOLOGIES PRIVATE LIMITED",
"COMPLETE VENTURES PRIVATE LIMITED",
"COMPLETION OIL TOOLS PRIVATE LIMITED",
"COMPLETION TRADE & COMMERCE PRIVATE LIMITED",
"COMPLIANCE ENGINEERING PRIVATE LIMITED",
"COMPLIMENTS METAL MILLS PRIVATE LIMITED",
"COMPLINITY TECHNOLOGIES PRIVATE LIMITED",
"COMPLISEC CONSULTING SERVICES PRIVATE LIMITED",
"COMPLITECH SOLUTIONS PRIVATE LIMITED",
"COMPLUS SYSTEMS PRIVATE LIMITED",
"COMPLY GLOBAL CLOUD SOLUTIONS PRIVATE LIMITED",
"COMPLY4HR CONSULTANTS PRIVATE LIMITED",
"COMPLYINDIA TECH SERVICES PRIVATE LIMITED",
"COMPLYKARO SERVICES PRIVATE LIMITED",
"COMPNOVA SOLUTIONS INDIA PRIVATE LIMITED",
"COMPO ADVICS INDIA PRIVATE LIMITED",
"COMPO EXPERT INDIA PRIVATE LIMITED",
"COMPONENCE PORTAL SERVICES PRIVATE LIMITED",
"COMPONENT HUB (INDIA)PRIVATE LIMITED",
"COMPONENT ONLINE ELECTRONICS PRIVATE LIMITED",
"COMPONIX INDIA PRIVATE LIMITED",
"COMPORTEMENT SOFTWARE PRIVATE LIMITED",
"COMPOSITE AQUA SYSTEMS & EQUIPMENT PRIVATE LIMITED",
"COMPOSITE FINANCIAL CONSULTANTS PRIVATE LIMITED",
"COMPOSITE HOSES AND HYDRAULICS PRIVATE LIMITED",
"COMPOSITE INSURANCE BROKERS AND ADVISORS PRIVATE LIMITED",
"COMPOSITE INTERCEPTIVE MED-SCIENCE LABORATORIES PRIVATE LIMITED",
"COMPOSITE INVESTMENTS PRIVATE LIMITED",
"COMPOSITE LAB LINE PRIVATE LIMITED",
"COMPOSITE MECHANICAL WORKS PRIVATE LIMITED",
"COMPOSITE NIRMAN MATERIALS PRIVATE LIMITED",
"COMPOSITE SECURITIES LIMITED",
"COMPOSITE STRAP INDIA PRIVATE LIMITED",
"COMPOSITE TANKS AND VESSELS PRIVATE LIMITED",
"COMPOSITES COMBINE TECHNOCRATS PRIVATE LIMITED",
"COMPOSURE SERVICES PRIVATE LIMITED",
"COMPREHEND IT SOLUTIONS PRIVATE LIMITED",
"COMPREHENSIVE FINANCIAL MANAGEMENT SYSTEM GOVT OF BIHAR",
"COMPREHENSIVE INVESTMENT & FINANCE COMPANY PRIVATE LIMITED",
"COMPREHENSIVE NEOMARKETING SYSTEMS PRIVATE LIMITED",
"COMPRESSOR REFRIGERATION PRIVATE LIMITED",
"COMPRINNO TECHNOLOGIES PRIVATE LIMITED",
"COMPRINT TECH-SOLUTIONS I PRIVATE LIMITED",
"COMPRO TECHNOLOGIES PRIVATE LIMITED",
"COMPROTECH ENGINEERING PRIVATE LIMITED",
"COMPSERV CONSULTANTS PRIVATE LIMITED",
"COMPSOFT BPO SERVICES INDIA PRIVATE LIMITED",
"COMPTAAX E SOFTWARE PRIVATE LIMITED",
"COMPTECH EQUIPMENTS LIMITED",
"COMPTECH INFORMATIC PRIVATE LIMITED",
"COMPTECH SOLUTIONS PRIVATE LIMITED",
"COMPTECH TRAINING & TECHNOLOGIES PRIVATE LIMITED",
"COMPTEK COMPUTER SYSTEMS PRIVATE LIMITED",
"COMPTEK TECHNOLOGY PRIVATE LIMITED",
"COMPTEL COMMUNICATIONS INDIA PRIVATE LIMITED",
"COMPTIA TECHNOLOGY INDIA PRIVATE LIMITED",
"COMPTON BUSINESS SUPPORT SERVICES PRIVATE LIMITED",
"COMPTON COMPUTERS PRIVATE LIMITED",
"COMPTROLLER AUDITOR GENERAL OF INDIA",
"COMPU POWER PVT.LTD.",
"COMPU SALES AND SERVICES PRIVATE LIMITED",
"COMPUAGE INFOCOM LIMITED",
"COMPUCARE INDIA PRIVATE LIMITED",
"COMPUCOM CSI SYSTEMS INDIA PRIVATE LIMITED",
"COMPUGAIN SOLUTIONS INDIA PRIVATE LIMITED",
"COMPUMATRICE MULTIMEDIA PRIVATE LIMITED",
"COMPUNNEL TECHNOLOGY INDIA PRIVATE LIMITED",
"COMPUSCROLL INDIA PRIVATE LIMITED",
"COMPUSOFT ADVISORS INDIA PRIVATE LIMITED",
"COMPUSYSTEMS INDIA PRIVATE LIMITED",
"COMPUTACENTER INDIA PRIVATE LIMITED",
"COMPUTE EDGE WIRELESS INDIA PRIVATE LIMITED",
"COMPUTECH INDIA",
"COMPUTECH PUBLICATIONS LIMITED",
"COMPUTECH SHARECAP LIMITED",
"COMPUTER ACCESS PRIVATE LIMITED",
"COMPUTER AGE MANAGEMENT SERVICES LIMITED",
"COMPUTER BOOK SHOP (INDIA) PRIVATE LIMITED",
"COMPUTER BUSINESS MANAGEMENT (INDIA) PRIVATE LIMITED",
"COMPUTER DISCOVERIES INDIA CDI PRIVATE LIMITED",
"COMPUTER ELEMENTS PRIVATE LIMITED",
"COMPUTER EVOLUTIONS PRIVATE LIMITED",
"COMPUTER EXCHANGE PRIVATE LIMITED",
"COMPUTER FACTORY INDIA PRIVATE LIMITED",
"COMPUTER GALLERY PRIVATE LIMITED",
"COMPUTER GENERATED SOLUTIONS INDIA PRIVATE LIMITED",
"COMPUTER GRAPHICS LIMITED",
"COMPUTER HOME PRIVATE LIMITED",
"COMPUTER INFOTECH INDIA PRIVATE LIMITED",
"COMPUTER INTERNATIONAL PRIVATE LIMITED",
"COMPUTER JUNCTION PRIVATE LIMITED",
"COMPUTER KENDRA",
"COMPUTER KIDS PRIVATE LIMITED",
"COMPUTER PLANET (INDIA) PRIVATE LIMITED",
"COMPUTER PLANET CHENNAI PRIVATE LIMITED",
"COMPUTER POWERHOUSE TECHNOLOGIES PRIVATE LIMITED",
"COMPUTER SCIENCES CORPORATION INDIA PRIVATE LIMITED",
"COMPUTER SHOPPE PRIVATE LIMITED",
"COMPUTER SOLUTIONS (INDIA ) PRIVATE LIMITED",
"COMPUTER SYSTEMS WEST PRIVATE LIMITED",
"COMPUTER TASK GROUP INDIA PRIVATE LIMITED",
"COMPUTER TECHNOLOGIES PRIVATE LIMITED",
"COMPUTER WARE INDIA PRIVATE LIMITED.",
"COMPUTERBILITIES TECHNOLOGY CENTER PRIVATE LIMITED",
"COMPUTERS INDIA LIMITED",
"COMPUTRAIN INFORMATION TECHNOLOGY INDIA",
"COMPUTRICS INTEGRATION TECHNOLOGIES PRIVATE LIMITED",
"COMPUTRONICS FINANCIAL SERVICES INDIA LIMITED",
"COMPUTRONICS MULTIVISION PRIVATE LIMITED",
"COMPUTRONICS SYSTEMS INDIA PRIVATE LIMITED",
"COMPUTRONIX INFOTECH PRIVATE LIMITED",
"COMPUWORLD AUTOMATION & SYSTEM CARE PRIVATE LIMITED",
"COMPUZER SOLUTIONS PRIVATE LIMITED",
"COMP-VAC TECHNOLOGY PRIVATE LIMITED",
"COMPVUE INDIA PRIVATE LIMITED",
"COMRACK INFONET PRIVATE LIMITED",
"COMRADE APPLIANCES LIMITED",
"COMRADE DEVELOPERS PRIVATE LIMITED",
"COMRADE INNS PRIVATE LIMITED.",
"COMSAFE FOOTWEAR INDUSTRIES PRIVATE LIMITED",
"COMSAT SYSTEMS PRIVATE LIMITED",
"COMSCOPE CONNECTIVITY INDIA PRIVATE LIMITED",
"COMSCORE TECHNOLOGIES INDIA PRIVATE LIMITED",
"COMSCRAFT TECHNOLOGY PVT LTD",
"COMSENSE TECHNOLOGIES PRIVATE LIMITED",
"COMSHIP MEDIX AND INFRA PRIVATE LIMITED",
"COMSOFT INFOTECH PRIVATE LIMITED",
"COMSOL DISTRIBUTION SERVICES PRIVATE LIMITED",
"COMSOL ENERGY PRIVATE LIMITED",
"COMSOL MULTIPHYSICS PRIVATE LIMITED",
"COMSOLS COMMUNICATION SOLUTION",
"COMSOLVE MEDIATECH PRIVATE LIMITED",
"COMSTAR AUTOMOTIVE TECHNOLOGIES PRIVATE LIMITED",
"COMSTAR AUTOMOTIVE TECHNOLOGY SERVICES PRIVATE LIMITED",
"COMSYN INDIA PRIVATE LIMITED",
"COMT CONSTRUCTIONS PRIVATE LIMITED",
"COMTECH DEVELOPERS PRIVATE LIMITED",
"COMTECH DIGITRONICS PRIVATE LIMITED",
"COMTECH EFDATA CORP",
"COM-TECH ENGINEERS AND CONSULTANTS PVT LTD",
"COMTECH EXPORTS PRIVATE LIMITED",
"COMTECH INFO SOLUTIONS PRIVATE LIMITED",
"COMTECH METALS PRIVATE LIMITED",
"COMTECH TELESOLUTIONS PRIVATE LIMITED",
"COMTEK BIZSOFT PRIVATE LIMITED",
"COMTEL INFOSYSTEMS PRIVATE LIMITED",
"COMTEL SERVICES PRIVATE LIMITED",
"COMTEL TECHNOLOGIES PRIVATE.LIMITED",
"COMUNUS TECHNOLOGIES PRIVATE LIMITED",
"COMUTI ENERGY PRIVATE LIMITED",
"COMVERSE NETWORK SYSTEMS INDIA PRIVATE LIMITED",
"COMVISION INDIA PRIVATE LIMITED",
"COMVIVA TECHNOLOGIES LIMITED",
"CON WEIGH SYSTEMS PRIVATE LIMITED.",
"CONA CHEMICALS PRIVATE LIMITED",
"CONA FOOTWEAR INDIA PRIVATE LIMITED",
"CONA LIGHTING SOLUTIONS PRIVATE LIMITED",
"CONACENT CONSULTING PRIVATE LIMITED",
"CONAGRA FOODS INC.",
"CONAM TECHNOLOGIES PRIVATE LIMITED",
"CONART ENGINEERS LIMITED",
"CONATIVE IT SOLUTIONS PRIVATE LIMITED",
"CONATUS FINSERVE PRIVATE LIMITED",
"CONAX ACCESS SYSTEMS PRIVATE LIMITED",
"CONBEAU CONSTRUCTIONS PRIVATE LIMITED",
"CONC SHADE CONSTRUCTIONS PRIVATE LIMITED",
"CONCAB TRAVEL SERVICES P LIMITED",
"CONCABS (INDIA) PRIVATE LIMITED",
"CONCAP HOLDINGS PRIVATE LIMITED",
"CONCARE MARINE SERVICES PRIVATE LIMITED",
"CONCAST (INDIA) PRIVATE LIMITED",
"CONCENT TECHNOLOGY DISTRIBUTION PRIVATE LIMITED",
"CONCENTRIC MARKETING CONSULTANTS PRIVATE LIMITED",
"CONCENTRIC PUMPS PUNE PRIVATE LIMITED",
"CONCENTRIC SOFTWARE INDIA PRIVATE LIMITED",
"CONCENTRICA ENTERPRISES PRIVATE LIMITED",
"CONCENTRIS METAL STRATEGIES (INDIA) PRIVATE LIMITED",
"CONCENTRIX CATALYST TECHNOLOGIES PRIVATE LIMITED",
"CONCENTRIX DAKSH SERVICES INDIA PRIVATE LIMITED",
"CONCENTRIX SERVICES INDIA PRIVATE LIMITED",
"CONCENTRIX TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"CONCENTRIX TECHNOLOGIES INDIA PRIVATE LIMITED",
"CONCENTUS SOFTECH PRIVATE LIMITED",
"CONCEPT AGROTECH CONSULTANTS LIMITED",
"CONCEPT AND SOLUTIONS METFAB PRIVATE LIMITED",
"CONCEPT BRANDING PRIVATE LIMITED",
"CONCEPT CARS LIMITED",
"CONCEPT CASTINGS PRIVATE LIMITED",
"CONCEPT CHANNEL SUPPLIERS PRIVATE LIMITED",
"CONCEPT CLASSIC CONVERGE PRIVATE LIMITED",
"CONCEPT CLOTHING",
"CONCEPT CLOTHING PRIVATE LIMITED",
"CONCEPT CLOTHING TEXTILES PRIVATE LIMITED",
"CONCEPT COLOUR TECNIKS PRIVATE LIMITED",
"CONCEPT COMMUNICATION LIMITED",
"CONCEPT CONCIEVERS AND EXECUTORS",
"CONCEPT CONFERENCES PRIVATE LIMITED",
"CONCEPT CONSILIO INDIA PRIVATE LIMITED",
"CONCEPT CORPORATION INDIA PRIVATE LIMITED",
"CONCEPT CREATION GROUP",
"CONCEPT DIVERSIPACK MARKETING PRIVATE LIMITED",
"CONCEPT EATRIES PRIVATE LIMITED",
"CONCEPT ELECTRONIC ENGINEERING SOLUTIONS PRIVATE LIMITED",
"CONCEPT FLAVOURS & FRAGRANCES PRIVATE LIMITED",
"CONCEPT HIGHCON PRIVATE LIMITED",
"CONCEPT HOME TEXTILES PRIVATE LIMITED",
"CONCEPT HOMES INDIA PRIVATE LIMITED",
"CONCEPT HOSPITALITY PRIVATE LIMITED",
"CONCEPT HR SERVICES PRIVATE LIMITED",
"CONCEPT IMAGES PRIVATE LIMITED",
"CONCEPT INFORMATION TECHNOLOGIES INDIA PRIVATE LIMITED",
"CONCEPT INFOWAY PRIVATE LIMITED",
"CONCEPT INFRACON PRIVATE LIMITED",
"CONCEPT INTERIOR SOLUTIONS PRIVATE LIMITED",
"CONCEPT INTERNATIONAL BUSINESS CONSULTING PRIVATE LIMITED",
"CONCEPT INVESTWELL PRIVATE LIMITED",
"CONCEPT MANAGEMENT CONSULTING LIMITED",
"CONCEPT MEDICAL RESEARCH PRIVATE LIMITED",
"CONCEPT MOTOR GARAGE PRIVATE LIMITED",
"CONCEPT MOTORBIKE COMPANY PRIVATE LIMITED",
"CONCEPT MOTORPARTS PRIVATE LIMITED",
"CONCEPT MOTORS INDIA PRIVATE LIMITED",
"CONCEPT PACKAGING INTERNATIONAL PRIVATE LIMITED",
"CONCEPT PHARMACEUTICALS LIMITED",
"CONCEPT PLAST PRIVATE LIMITED",
"CONCEPT POWER SYSTEM PRIVATE LIMITED",
"CONCEPT POWERTECH PRIVATE LIMITED",
"CONCEPT PR",
"CONCEPT PRODUCTIONS LIMITED",
"CONCEPT PUBLIC RELATIONS INDIA LIMITED",
"CONCEPT RF TECHNOLOGY (INDIA) PRIVATE LIMITED",
"CONCEPT SPECIALITY PACK PRIVATE LIMITED",
"CONCEPT SUPERSTRUCTURES P LTD",
"CONCEPT WAREHOUSING & LOGISTIC SERVICES PRIVATE LIMITED",
"CONCEPT WEAVERS PRIVATE LIMITED",
"CONCEPT2SILICON SYSTEMS PRIVATE LIMITED",
"CONCEPTIA SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"CONCEPTPLUS INFOSOLUTIONS PRIVATE LIMITED",
"CONCEPTRENEUR VENTURES PRIVATE LIMITED",
"CONCEPTS & SOLUTIONS EVENT SERVICES PRIVATE LIMITED",
"CONCEPTS HYGIENE PRIVATE LIMITED",
"CONCEPTS INDIA PRIVATE LIMITED",
"CONCEPTS INTERNATIONAL INDIA PRIVATE LIMITED",
"CONCEPTUAL ADVISORY SERVICES LLP",
"CONCEPTUAL PICTURES WORLD WIDE PRIVATE LIMITED",
"CONCEPTUM LOGISTICS INDIA PRIVATE LIMITED",
"CONCEPTWAVES SOFTWARE SOLUTIONS PRIVATE LIMITED",
"CONCERIA INTERNATIONAL PRIVATE LIMITED",
"CONCERIA VIRGINIA CHENNAI PRIVATE LIMITED",
"CONCERN & CARE PHARMACY PRIVATE LIMITED",
"CONCERN INFOTECH PRIVATE LIMITED",
"CONCERT CARE INDIA PRIVATE LIMITED",
"CONCERTANTE LABS LLP",
"CONCERTINA COILS PRIVATE LIMITED",
"CONCERTO SOFTWARE & SYSTEMS PRIVATE LIMITED",
"CONCETTO LABS SOFTWARE SERVICES PRIVATE LIMITED",
"CONCH CERAMIC PRIVATE LIMITED",
"CONCHEM CONSTRUCTION PRIVATE LIMITED",
"CONCIERGE TECHNOLOGIES PRIVATE LIMITED",
"CONCIPIO POWER PRIVATE LIMITED",
"CONCISE KORE INDIA PRIVATE LIMITED",
"CONCLAVE MARKET RESEARCH PRIVATE LIMITED",
"CONCOCT HUMAN RESOURCE PRACTITIONERS INDIA PRIVATE LIMITED",
"CONCOR AIR LIMITED",
"CONCORD ALUMINIUM COMPANY PRIVATE LIMITED",
"CONCORD BIOTECH LIMITED",
"CONCORD CONSTRUCTION PRIVATE LIMITED",
"CONCORD CREATIONS INDIA PRIVATE LIMITED",
"CONCORD DRUGS LIMITED",
"CONCORD ELECTRICALS INDIA PRIVATE LIMITED",
"CONCORD ENGLISH HIGHER SECONDARY SCHOOL",
"CONCORD EXOTIC VOYAGES INDIA PRIVATE LIMITED",
"CONCORD FREIGHT PRIVATE LIMITED",
"CONCORD FUND SYNDICATION PRIVATE LIMITED",
"CONCORD GLOBAL TECH SERVICES PRIVATE LIMITED",
"CONCORD HELMET & SAFETY PRODUCTS PRIVATE LIMITED",
"CONCORD HOSPITALITY PRIVATE LIMITED",
"CONCORD HYDRAULICS PRIVATE LIMITED",
"CONCORD INFRASTRUCTURE PRIVATE LIMITED",
"CONCORD LOGISTICS AND SERVICES",
"CONCORD MARITIME AND LOGISTICS PRIVATE LIMITED",
"CONCORD MARKETING AND FINANCIERS PRIVATE LIMITED",
"CONCORD MEDISYS PRIVATE LIMITED",
"CONCORD NON WOVEN INDUSTRIES PRIVATE LIMITED",
"CONCORD SECURITY AND ALLIED SERVICES PRIVATE LIMITED",
"CONCORD SHIPPING PRIVATE LIMITED",
"CONCORD SILK MILLS PRIVATE LIMITED",
"CONCORD STEEL WORKS PRIVATE LIMITED",
"CONCORD TIE UP PVT LTD",
"CONCORD TREXIM PRIVATE LIMITED",
"CONCORD UNITED PRODUCTS PRIVATE LIMITED",
"CONCORDE AIR HANDLING SERVICES PRIVATE LIMITED",
"CONCORDE AIR LOGISTICS LIMITED",
"CONCORDE CUPPA BEVERAGES PRIVATE LIMITED",
"CONCORDE DESIGNS PRIVATE LIMITED",
"CONCORDE DIGITAL TECHNOLOGIES PRIVATE LIMITED",
"CONCORDE HOUSING CORPORATION PRIVATE. LIMITED.",
"CONCORDE INFRABUILD PRIVATE LIMITED",
"CONCORDE KNITWEARS PRIVATE LIMITED",
"CONCORDE MOTORS INDIA LIMITED",
"CONCRETE ADDITIVES & CHEMICALS PRIVATE LIMITED",
"CONCRETE CARE INDIA PRIVATE LIMITED",
"CONCRETE DEVELOPERS",
"CONCRETE INFRA & MEDIA LIMITED",
"CONCRETE OEM PRIVATE LIMITED",
"CONCRETE PROJECTS PVT.LTD.",
"CONCRETE TECHNO PROJECTS LIMITED",
"CONCRETE UDYOG LIMITED",
"CONCRETE VENTURES OPC PRIVATE LIMITED",
"CONCRETE WORKS CONSTRUCTION CHEMICALS PRIVATE LIMITED",
"CONCRETIO APPS PRIVATE LIMITED",
"CONCUNSMART SHARES AND STOCK BROKER PRIVATE LIMITED",
"CONCUR DESIGNS PRIVATE LIMITED",
"CONCUR IP CONSULTING PRIVATE LIMITED",
"CONCUR PHARMACEUTICALS PRIVATE LIMITED",
"CONCUR TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"CONCURRENT ENGINEERING SOLUTIONS",
"CONDAVARU KANDASWAMI NAIDU COLLEGE",
"CONDE NAST INDIA PRIVATE LIMITED",
"CONDIS INDIA HEALTHCARE PRIVATE LIMITED",
"CONDOR AIR SERVICES PRIVATE LIMITED",
"CONDOR BUILDERS PRIVATE LIMITED",
"CONDOR FOOTWEAR INDIA LIMITED",
"CONDOR FOOTWEAR LIMITED",
"CONDOR POWER PRODUCTS PRIVATE LIMITED",
"CONDOT SYSTEMS PRIVATE LIMITED",
"CONDUCTIX-WAMPFLER INDIA PRIVATE LIMITED",
"CONDUENT BUSINESS SERVICES INDIA LLP",
"CONDUIT SOLUTIONS AND TECHNOLOGIES LLP",
"CONDUIT WORLDWIDE TRADING INDIA PRIVATE LIMITED",
"CONDURA CONSTRUCTION CHEMICALS PRIVATE LIMITED",
"CONE CRAFT PAPER PRIVATE LIMITED",
"CONECC CONCRETE SOLUTIONS PRIVATE LIMITED",
"CONECC INDUSTRIES PRIVATE LIMITED",
"CONECT STAY PRIVATE LIMITED",
"CONELE INFRA PRIVATE LIMITED",
"CONEQ INFRA ENGINEERING PRIVATE LIMITED",
"CONET TECHNOLOGIES PRIVATE LIMITED",
"CONEVET TECHNOLOGIES PRIVATE LIMITED",
"CONEVO TECHNOLOGIES PRIVATE LIMITED",
"CONEX AVIO AUTO PRIVATE LIMITED",
"CONEX METALS INTL",
"CONEX TERMINAL PRIVATE LIMITED",
"CONEXANT SYSTEMS PRIVATE LIMITED",
"CONEXAO TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"CONEXSTRA TECHNOLOGIES PRIVATE LIMITED",
"CONEXUS NETWORK SOLUTIONS PRIVATE LIMITED",
"CONEXUS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"CONEXXION TECH INDIA PRIVATE LIMITED",
"CONFAB METAL PRIVATE LIMITED",
"CONFECT MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"CONFEDERATION FOR AYURVEDIC RENAISSANCE-KERALAM LIMITED",
"CONFEDERATION OF INDIAN ALCOHOLIC BEVERAGE COMPANIES (U/S 25)",
"CONFEDERATION OF INDIAN INDUSTRY",
"CONFEDERATION OF INDIAN TEXTILE INDUSTRY",
"CONFEDERATION OF REAL ESTATE DEVELOPERS ASSOCIATION OF INDIA - SURAT",
"CONFEDERATION OF REAL ESTATE DEVELOPERS' ASSOCIATIONS OF INDIA",
"CONFENGINE EVENTS PRIVATE LIMITED",
"CONFERENCECALL SERVICES INDIA PRIVATE LIMITED",
"CONFERENCES AND EXHIBITIONS PRIVATE LIMITED",
"CONFERENZA NEXT PRIVATE LIMITED",
"CONFETTI EXPORTS PVT LTD",
"CONFETTI HOLDINGS PRIVATE LIMITED",
"CONFFI SANITARYWARE PRIVATE LIMITED",
"CONFIANCE BIZSOL PRIVATE LIMITED",
"CONFIANCE LIFE SCIENCES PRIVATE LIMITED",
"CONFIANZ INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"CONFIANZA ENGINEERING PRODUCTS INDIA PRIVATE LIMITED",
"CONFIANZA REAL ESTATE PRIVATE LIMITED",
"CONFIAR CONSULTANTS INDIA PRIVATE LIMITED",
"CONFIAS PRIVATE LIMITED",
"CONFIDAYS HYGIENE PRODUCTS PRIVATE LIMITED",
"CONFIDENCE AUTOMATION PRIVATE LIMITED",
"CONFIDENCE CARRIERS AND LOGISTICS PRIVATE LIMITED",
"CONFIDENCE ENTERPRISES PRIVATE LIMITED",
"CONFIDENCE FINANCE AND TRADING LIMITED",
"CONFIDENCE FUTURISTIC ENERGETECH LIMITED",
"CONFIDENCE LPG BOTTLING PRIVATE LIMITED",
"CONFIDENCE PETROLEUM INDIA LIMITED",
"CONFIDENCE SHIPPING CO PRIVATE LIMITED",
"CONFIDENCE TECHNOLOGIES PRIVATE LIMITED",
"CONFIDENT DENTAL EQUIPMENTS PRIVATE LIMITED",
"CONFIDENT ENGINEERING INDIA PRIVATE LIMITED",
"CONFIDENT PROJECTS INDIA PRIVATE LIMITED",
"CONFIDENT SALES INDIA PRIVATE LIMITED",
"CONFIDENT VINIMAY PRIVATE LIMITED",
"CONFIDOSOFT SOLUTIONS PRIVATE LIMITED",
"CONFIEX DATA ROOM PRIVATE LIMITED",
"CONFIMIND SOFTWARE SOLUTIONS PRIVATE LIMITED",
"CONFIMIND TECHNOLOGIES PRIVATE LIMITED",
"CONFIO ENGINEERING SOLUTION PRIVATE LIMITED",
"CONFIO TECHNOLOGIES PRIVATE LIMITED",
"CONFIRM REALBUILD PRIVATE LIMITED",
"CONFIRM TICKET ONLINE SOLUTIONS PRIVATE LIMITED",
"CONFLUENCE EDUCATIONAL SERVICES PRIVATE LIMITED",
"CONFLUENCE FOR HEALTH ACTION AND TRANSFORMATION FOUNDATION",
"CONFLUENCE ONLINE VENTURES PRIVATE LIMITED",
"CONFLUENCE PROJECT MANAGEMENT PRIVATE LIMITED",
"CONFLUENCE VALLEY PRIVATE LIMITED",
"CONFLUENT INDIA PRIVATE LIMITED",
"CONFLUO ESOLUTIONS PRIVATE LIMITED",
"CONFLUX INFRATECH PRIVATE LIMITED",
"CONFLUX TECHNOLOGIES PRIVATE LIMITED",
"CONFLUXSYS PRIVATE LIMITED",
"CONFORMITY INDIA INTERNATIONAL PRIVATE LIMITED",
"CONFORMITY TESTING LABS PRIVATE LIMITED",
"CONFREIGHT MARITIME PRIVATE LIMITED",
"CONFRONT SOLUTIONS PRIVATE LIMITED",
"CONGA SOFTWARE PRIVATE LIMITED",
"CONGELAR INTERNATIONAL PRIVATE LIMITED",
"CONGERO CLOUD TECHNOLOGY PRIVATE LIMITED",
"CONGLOMERATEIT SERVICES PRIVATE LIMITED",
"CONGRATS AGROPACK PRIVATE LIMITED",
"CONGROW BPO AND SERVICES (OPC) PRIVATE LIMITED",
"CONGRUENCE TRADE & SERVICES PRIVATE LIMITED",
"CONGRUENT INFO-TECH PRIVATE LIMITED",
"CONGRUENT IT SERVICES PRIVATE LIMITED",
"CONGRUENT PHARMACHEM PRIVATE LIMITED",
"CONGRUENT SOLUTIONS PRIVATE LIMITED",
"CONGRUEX ASIA-PACIFIC LLP",
"CONIC AUTOMOTIVE PRIVATE LIMITED",
"CONIFER INDUSTRIES PRIVATE. LIMITED.",
"CONIFEROUS MULTITRADE PRIVATE LIMITED",
"CONITEX SONOCO INDIA PRIVATE LIMITED",
"CONJOIN NETWORK PRIVATE LIMITED",
"CONJOINIX TOTAL SOLUTIONS PRIVATE LIMITED",
"CONJOINT HEALTHCARE PRIVATE LIMITED",
"CONLECTA CAPITAL ADVISORS PRIVATE LIMITED",
"CONMAT OIL & GAS PRIVATE LIMITED",
"CONMAXX CONSTRUCTION LLP",
"CONMECHAUTO CONSULTANTS INDIA PRIVATE LIMITED",
"CONMIX GYPSUM PRIVATE LIMITED",
"CONMOVE PRIVATE LIMITED",
"CONNAISSANCE ASSET SHOPPE INDIA PRIVATE LIMITED",
"CONNAISSANT CONSULTANCY SERVICES PRIVATE LIMITED",
"CONNAUGHT NETWORK SERVICES PRIVATE LIMITED",
"CONNAUGHT PLACE REGAL THEATRE PRIVATE LIMITED",
"CONNAUGHT PLAZA RESTAURANTS PRIVATE LIMITED",
"CONNECT 1 LIMITED",
"CONNECT 2 CLINIC PRIVATE LIMITED",
"CONNECT AND HEAL PRIMARY CARE PRIVATE LIMITED",
"CONNECT CARGO PRIVATE LIMITED",
"CONNECT CHEMICALS INDIA PRIVATE LIMITED.",
"CONNECT CHILD DEVELOPMENT CENTER",
"CONNECT COMPUSYS PRIVATE LIMITED",
"CONNECT EQUIPMENT LEASING PRIVATE LIMITED",
"CONNECT INDIA E COMMERCE SERVICE PRIVATE LIMITED",
"CONNECT INDIA E-COMMERCE SERVICES PRIVATE LIMITED",
"CONNECT INDIA PIPELINE PROJECTS PRIVATE LIMITED",
"CONNECT INFO SOLUTIONS INDIA PRIVATE LIMITED",
"CONNECT INFOSOFT TECHNOLOGIES PRIVATE LIMITED",
"CONNECT INTERNATIONAL PRIVATE LIMITED",
"CONNECT LIFE SOLUTIONS PRIVATE LIMITED",
"CONNECT ONE FACILITY SERVICE PRIVATE LIMITED",
"CONNECT RESIDUARY PRIVATE LIMITED",
"CONNECT SR INDIA PRIVATE LIMITED",
"CONNECT STEEL PRIVATE LIMITED",
"CONNECT TEXTILE & PROCESSING INDUSTRIES PRIVATE LIMITED",
"CONNECTA INNOVATION PRIVATE LIMITED",
"CONNECTECHO TALENT LABS PRIVATE LIMITED",
"CONNECTED VALUE HEALTH SOLUTIONS PRIVATE LIMITED",
"CONNECTED VENTURES TECHNOLOGY PRIVATE LIMITED",
"CONNECTEDX TECHSOL PRIVATE LIMITED",
"CONNECTESTATESS (OPC) PRIVATE LIMITED",
"CONNECTGLOBALONE SOFTWARE INDIA PRIVATE LIMITED",
"CONNECTGLOBE INTELLIGENCE SOLUTIONS PRIVATE LIMITED",
"CONNECTICUS TECHNOLOGIES PRIVATE LIMITED",
"CONNECTING DREAMS FOUNDATION",
"CONNECTING FOOTCRAFT INDIA PRIVATE LIMITED",
"CONNECTING LOGISTICS PRIVATE LIMITED",
"CONNECTION LOOPS PRIVATE LIMITED",
"CONNECTIONS DIRECT INDIA PRIVATE LIMITED",
"CONNECTIONS SALES AND SERVICES PRIVATE LIMITED",
"CONNECTIVE9 MEDIA LABS PRIVATE LIMITED",
"CONNECTIVITY IT SERVICES PRIVATE LIMITED",
"CONNECTIVITY IT SOLUTIONS PRIVATE LIMITED",
"CONNECTIX SOFTWARE & SERVICES PRIVATE LIMITED",
"CONNECTLIFE PHARMA PRIVATE LIMITED",
"CONNECTOR DEVICES PRIVATE LIMITED",
"CONNECTPRO MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"CONNECTVT INFOSERV PVT LTD",
"CONNECTWELL IMPEX PRIVATE LIMITED",
"CONNECTWELL INDUSTRIES PRIVATE LIMITED",
"CONNECTWISE LLP",
"CONNEDIT BUSINESS SOLUTIONS PRIVATE LIMITED",
"CONNEKT ACCOMMODATIONS PRIVATE LIMITED",
"CONNELL BROS COMPANY INDIA PRIVATE LIMITED",
"CONNEQT BUSINESS SOLUTIONS LIMITED",
"CONNEQTION CONSULTING PRIVATE LIMITED",
"CONNEQTOR CYCLE PRIVATE LIMITED",
"CONNER INSTITUTE OF HEALTH CARE AND RESEARCH CENTRE PRIVATE LIMITED",
"CONNET SECURITIES AND FINANCE PRIVATE LIMITED",
"CONNEX INFO SYSTEMS",
"CONNEX PHARMA PRIVATE LIMITED",
"CONNEXA IT SOLUTIONS PRIVATE LIMITED",
"CONNEXIA RENEWABLE ENERGY PRIVATE LIMITED",
"CONNEXIO SEARCH PRIVATE LIMITED",
"CONNEXIONS AIR TRAVEL SERVICES",
"CONNEXIONS GLOBAL PRIVATE LIMITED",
"CONNEXIS TECHNOLOGIES PRIVATE LIMITED",
"CONNEXUS TECHNOLOGIES PRIVATE LIMITED",
"CONNOISEUR ELECTRONICS PRIVATE LIMITED",
"CONNOISSEUR AGROINFRA PROJECTS PRIVATE LIMITED",
"CONNOISSEUR INFOTECH PRIVATE. LIMITED",
"CONNOISSEUR SHIPPING AND LOGISTICS PRIVATE LIMITED",
"CONNOISSEURS DESK PRIVATE LIMITED",
"CONNUCT LIFESCIENCES PRIVATE LIMITED",
"CONNVERTEX TECHNOLOGIES INDIA PRIVATE LIMITED",
"CONNX COMMUNICATIONS PRIVATE LIMITED",
"CONOR COSMO INDIA PRIVATE LIMITED",
"CONOR GRANITO PRIVATE LIMITED",
"CONOR METALLOYS PRIVATE LIMITED",
"CONORON CREATIONS PRIVATE LIMITED",
"CONPAC MIX PRIVATE LIMITED",
"CONPACK POOLING INDIA PRIVATE LIMITED",
"CONPLEX EXIM PRIVATE LIMITED",
"CONPRO CHEMICALS PRIVATE LIMITED",
"CONQSYS INFORMATION TECHNOLOGY PRIVATE LIMITED",
"CONQUERED EFFORTS INDIA PRIVATE LIMITED",
"CONQUERENT CONTROL SYSTEMS PRIVATE LIMITED",
"CONQUEST DEVELOPERS PRIVATE LIMITED",
"CONQUEST INFRASTRUCTURE PRIVATE LIMITED",
"CONQUEST INTEGRATED SOLUTIONS PRIVATE LIMITED",
"CONQUEST LIFESTYLE PRIVATE LIMITED",
"CONREP SOLUTIONS PRIVATE LIMITED",
"CONREPAIR INDIA P LIMITED",
"CONSAM INDUSTRIES PRIVATE LIMITED",
"CONSCAP CONSULTANTS PRIVATE LIMITED",
"CONSCHEMI CHEMTECH PRIVATE LIMITED",
"CONSCIENCE INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"CONSCIENT INFRASTRUCTURE PRIVATE LIMITED",
"CONSCIENTIA CONSULTANCY PRIVATE LIMITED",
"CONSCIENTIOUS ENGINEERING INFRA PRIVATE LIMITED",
"CONSCIOUS FOOD PRIVATE LIMITED",
"CONSCIOUS MIND SOLUTIONS PRIVATE LIMITED",
"CONSCISCO PRIVATE LIMITED",
"CONSENT PHARMACEUTICALS PRIVATE LIMITED",
"CONSEP ENGINEERING PRIVATE LIMITED",
"CONSERN PHARMA LIMITED",
"CONSERO SOLUTIONS INDIA PRIVATE LIMITED",
"CONSERVA TECHNOLOGIES PRIVATE LIMITED",
"CONSERVATION CORPORATION OF INDIA PRIVATE LIMITED",
"CONSERVATOR OF FOREST",
"CONSERVE BUILDCON LLP",
"CONSERVE INFOTECH PRIVATE LIMITED",
"CONSERVE INFRATECH PRIVATE LIMITED",
"CONSERVE SOLUTIONS LLP S LLP",
"CONSET PHARMA PRIVATE LIMITED",
"CONSILIENT TECHNOLOGIES PRIVATE LIMITED",
"CONSILIO ENGINEERS PRIVATE LIMITED",
"CONSILIO INDIA PRIVATE LIMITED",
"CONSILIUM AUTOMATION & FIRE PROTECTION PRIVATE LIMITED",
"CONSILIUM SAFETY INDIA PRIVATE LIMITED",
"CONSILIUM SFS FIRE & SECURITY SOLUTIONS PRIVATE LIMITED",
"CONSILIUM SOFTWARE PRIVATE LIMITED",
"CONSILIUM TAX MANAGEMENT SERVICES PRIVATE LIMITED",
"CONSINDIA PRIVATE LIMITED",
"CONSINT SOLUTIONS PRIVATE LIMITED",
"CONSISTENT AIRCON PRIVATE LIMITED",
"CONSISTENT ENGINEERING CONSULTANTS PRIVATE LIMITED",
"CONSISTENT INFOSYSTEMS PRIVATE LIMITED",
"CONSISTENT INFRA AND POWER PRIVATE LIMITED",
"CONSISTENT MANAGEMENT CONSULTANTS OPC PRIVATE LIMITED",
"CONSISTENT VYAPAAR PRIVATE LIMITED",
"CONSITE ENGINEERING COMPANY LIMITED",
"CONSLEAGUE CONSULTING PRIVATE LIMITED",
"CONSO4S TECHNOLOGIES PRIVATE LIMITED",
"CONSOL ENERGY INC.",
"CONSOL EXPRESS PRIVATE LIMITED",
"CONSOL FLEXIBLES PRIVATE LIMITED",
"CONSOL LINES INDIA PRIVATE LIMITED",
"CONSOLE SHIPPING SERVICES INDIA PRIVATE LIMITED",
"CONSOLE VAN PRIVATE LIMITED",
"CONSOLIDATE HYGIENE PRIVATE LIMITED",
"CONSOLIDATED ANALYTICS PRIVATE LIMITED",
"CONSOLIDATED CARPET INDUSTRIES LIMITED",
"CONSOLIDATED CONSTRUCTION COPRIVATE LIMITED",
"CONSOLIDATED ENERGY CONSULTANTS LIMITED",
"CONSOLIDATED FINVEST & HOLDINGS LIMITED",
"CONSOLIDATED FREIGHT FORWARDERS PRIVATE LIMITED",
"CONSOLIDATED LEATHERS PRIVATE LIMITED",
"CONSOLIDATED METAL FINISHING PRIVATE LIMITED",
"CONSOLIDATED PREMIUM RETAILERS",
"CONSOLIDATED SHIPPING LINE INDIA PRIVATE LIMITED",
"CONSOLIDATED TECHWARE PRIVATE LIMITED",
"CONSOLIDATED TEKNICS INDIA PRIVATE LIMITED",
"CONSOLIDATED THERMOPLASTIC PRODUCTS PVT LTD",
"CONSOLIDATED TRANSPORT SERVICES (INDIA) PRIVATE LIMITED",
"CONSONA HEALTHCARE TECHNOLOGIES PRIVATE LIMITED",
"CONSONNI CONTRACT INDIA PRIVATE LIMITED",
"CONSORT BUILDERS PRIVATE LIMITED",
"CONSORT DIGITAL PRIVATE LIMITED",
"CONSORT HARDWARE PRIVATE LIMITED",
"CONSORT LABORATORIES PRIVATE LIMITED",
"CONSORT OVERSEAS PRIVATE LIMITED",
"CONSORTEXE PROPERTIES PRIVATE LIMITED",
"CONSORTIUM AUTOMOBILES PRIVATE LIMITED",
"CONSORTIUM CAPITAL PRIVATE LIMITED",
"CONSORTIUM CLINICAL RESEARCH PRIVATE LIMITED",
"CONSORTIUM COMMODITIES PRIVATE LIMITED",
"CONSORTIUM E-LEARNING NETWORK PRIVATE LIMITED",
"CONSORTIUM FOODS PRIVATE LIMITED",
"CONSORTIUM FOR DEWATS DISSEMINATION SOCIETY",
"CONSORTIUM GIFTS PRIVATE LIMITED",
"CONSORTIUM MACHINES PRIVATE LIMITED",
"CONSORTIUM MOTORS PRIVATE LIMITED",
"CONSORTIUM OF ACCREDITED HEALTHCARE ORGANIZATIONS",
"CONSORTIUM SECURITIES PRIVATE LIMITED",
"CONSORTIUM TECHNO SOLUTIONS PRIVATE LIMITED",
"CONSOURCE BUSINESS SOURCING PRIVATE LIMITED",
"CONSPEL CONSTRUCTION PRIVATE LIMITED",
"CONSTA CLOUD PRIVATE LIMITED",
"CONSTA COOL PRIVATE LIMITED",
"CONSTACCENT CONSULTANCY PRIVATE LIMITED",
"CONSTANTIA CORPORATE SHARED SERVICES PRIVATE LIMITED",
"CONSTECH ENGINEERS PRIVATE LIMITED",
"CONSTECH ENTERPRISES PRIVATE LIMITED",
"CONSTECH HEAVY EQUIPMENT PRIVATE LIMITED",
"CONSTELL ASIA PRIVATE LIMITED",
"CONSTELL MANUFACTURING PRIVATE LIMITED",
"CONSTELLATION BLU ADVISORY PRIVATE LIMITED",
"CONSTELLATION BLU MANAGEMENT CONSULTANTS LLP",
"CONSTELLATION CONSULTING GLOBAL SERVICES INDIA PRIVATE LIMITED",
"CONSTELLI SIGNALS PRIVATE LIMITED",
"CONSTERA REALTY PRIVATE LIMITED",
"CONSTFLICK TECHNOLOGIES LIMITED",
"CONSTIENT GLOBAL SOLUTIONS PRIVATE LIMITED",
"CONSTOR SOLUTIONS PRIVATE LIMITED",
"CONSTRO CHEM INDIA PRIVATE LIMITED",
"CONSTRO SOLUTIONS LIMITED",
"CONSTRO SYSTEMS & ENGINEERS PRIVATE LIMITED",
"CONSTROBAZAAR PRIVATE LIMITED",
"CONSTROCARE INDUSTRIES PRIVATE LIMITED",
"CONSTROMAC ENGINEERING PRIVATE LIMITED",
"CONSTROMATS REAL ESTATE SOLUTIONS PRIVATE LIMITED",
"CONSTROMINE EQUIPMENT PRIVATE LIMITED",
"CONSTROVISION ENGINEERING CONSULTANTS PRIVATE LIMITED",
"CONSTRUCTION FEDERATION OF INDIA",
"CONSTRUCTION SPECIALTIES INTERNATIONAL (INDIA) PRIVATE LIMITED",
"CONSTRUCTIVE BUILDERS PRIVATE LIMITED",
"CONSTRUCTIVE PEOPLE INFRA PROJECTS PRIVATE LIMITED",
"CONSTRUCTURE DESIGNS PRIVATE LIMITED",
"CONSTRUE MARKET RESEARCH PRIVATE LIMITED",
"CONSTRUERE SOLUTIONS PRIVATE LIMITED",
"CONSTRUMA CONSULTANCY PVT LTD",
"CONSTRUMART ONLINE PRIVATE LIMITED",
"CONSTRUSOL RESOURCES PRIVATE LIMITED",
"CONSTRUTORA ANDRADE GUTIERREZ SA",
"CONSUL NATURE ELEMENTS GLOBAL PRIVATE LIMITED",
"CONSULARIS TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"CONSULATE GENERAL OF CANADA",
"CONSULATE GENERAL OF ISRAEL IN MUMBAI",
"CONSULATE GENERAL OF MALAYSIA",
"CONSULATE GENERAL OF THE UNITED STATES OF AMERICA",
"CONSULMATE SERVICES PRIVATE LIMITED",
"CONSULT SAMS PRIVATE LIMITED",
"CONSULT TECHNIQUES INDIA PRIVATE LIMITED",
"CONSULTADD SERVICES PRIVATE LIMITED",
"CONSULTGENICS BUSINESS PARTNERS LLP",
"CONSULTICON PRIVATE LIMITED",
"CONSULTING ENGINEERING SERVICES (INDIA) PRIVATE LIMITED",
"CONSULTING ENGINEERS GROUP LIMITED",
"CONSULTING ROOMS PRIVATE LIMITED",
"CONSULTRONICS PRIVATE LIMITED",
"CONSULTSHAH FINANCIAL SERVICES PRIVATE LIMITED",
"CONSUMA VENTURES PRIVATE LIMITED",
"CONSUMAX LIFE EMPOWERING PRIVATE LIMITED",
"CONSUMER DISPUTES REDRESSAL FORUM",
"CONSUMER DISPUTES REDRESSAL FORUM SATARA DISTRICT",
"CONSUMER LINKS MARKETING PRIVATE LIMITED",
"CONSUMER MARKETING INDIA PRIVATE LIMITED",
"CONSUMER SKETCH INFORMATION PRIVATE LIMITED",
"CONSUMER UNITY AND TRUST SOCIETY",
"CONSUMERS PLASTICS PRIVATE LIMITED",
"CONSUMMATE ENGINEERING SERVICES PRIVATE LIMITED",
"CONSUMMATE MATERIALS TESTING AND ENGINEERING PRIVATE LIMITED",
"CONSUMMATE TECHNOLOGIES PRIVATE LIMITED",
"CONSUS GLOBAL PRIVATE LIMITED",
"CONSUS ITECHNOLOGIES PRIVATE LIMITED",
"CONSYNC INFRA PRIVATE LIMITED",
"CONSYSTENT INFOTECH PRIVATE LIMITED",
"CONTACARE OPTHALMIC PRIVATE LIMITED",
"CONTACT BEARING COMPANY PRIVATE LIMITED",
"CONTACT BRIDGE IT ENABLED SERVICES PRIVATE LIMITED",
"CONTACT ELECTROTECH PRIVATE LIMITED",
"CONTACT INK AND COATING PRIVATE LIMITED",
"CONTACT TRADERS PRIVATE LIMITED",
"CONTACTX RESOURCE MANAGEMENT PRIVATE LIMITED",
"CONTAGIOUS CONSULTANCIES PRIVATE LIMITED",
"CONTAGIOUS CONSULTANCY",
"CONTAGIOUS ONLINE MEDIA NETWORK PRIVATE LIMITED",
"CONTAINE TECHNOLOGIES LIMITED",
"CONTAINER CORPORATION OF INDIA LIMITED",
"CONTAINER MARINE AGENCIES PRIVATE LIMITED",
"CONTAINER MOVEMENT BOMBAY TRANSPORT PRIVATE LIMITED",
"CONTAINER RAIL ROAD SERVICES PRIVATE LIMITED",
"CONTAINER SOLUTIONS (INDIA) PRIVATE LIMITED",
"CONTAINER WALA INDIA PRIVATE LIMITED",
"CONTAKT TECH SOLUTIONS INDIA PRIVATE LIMITED",
"CONTATA SOLUTIONS PRIVATE LIMITED",
"CONTCENTRIC IT SERVICES PRIVATE LIMITED",
"CONTEC AIRFLOW PROJECTS PRIVATE LIMITED",
"CONTEC IMPEX PRIVATE LIMITED",
"CONTEC INDIA PRIVATE LIMITED",
"CONTEC SYNDICATE PRIVATE LIMITED",
"CONTECH ENGINEERS PRIVATE LIMITED",
"CONTECH INSTRUMENTS LIMITED",
"CONTECH LOGISTICS SOLUTIONS PRIVATE LIMITED",
"CONTECH OUTSOURCING PRIVATE LIMITED",
"CONTECH PROJECTS AND SOLUTIONS PRIVATE LIMITED",
"CONTEGO FREIGHT AND LOGISTICS PRIVATE LIMITED",
"CONTEGRATE ENTREPOT PRIVATE LIMITED",
"CONTEKNIK ENTERPRISE PRIVATE LIMITED",
"CONTEL MEDICARE SYSTEMS PRIVATE LIMITED",
"CONTEMI TRADING SOLUTIONS (INDIA) PRIVATE LIMITED",
"CONTEMPARY WIN FRAMZ PRIVATE LIMITED",
"CONTEMPORARY BROKERS PRIVATE LIMITED",
"CONTEMPORARY FURNITURES PRIVATE LIMITED",
"CONTEMPORARY INDUSTRIES LIMITED",
"CONTEMPORARY LEATHER PRIVATE LIMITED",
"CONTEMPORARY MANAGEMENT SERVICES PRIVATE LIMITED",
"CONTEMPORARY TARGETT PRIVATE LIMITED",
"CONTEMPORARY TEA AUCTIONEERS PRIVATE LIMITED",
"CONTENDRE GREENERGY PRIVATE LIMITED",
"CONTENDRE INFRATECH PRIVATE LIMITED",
"CONTENT BLOOM INDIA PRIVATE LIMITED",
"CONTENT ED NET PRIVATE LIMITED",
"CONTENT ENABLERS SOFTWARE PRIVATE LIMITED",
"CONTENT MAKERS",
"CONTENTENABLERS INDIA PRIVATE LIMITED",
"CONTENTERRA SOFTWARE PRIVATE LIMITED",
"CONTENTRA TECHNOLOGIES INDIA PRIVATE LIMITED",
"CONTENTSERV TECHNOLOGIES PRIVATE LIMITED",
"CONTENTSTACK INDIA PRIVATE LIMITED",
"CONTENT-WHALE PRIVATE LIMITED",
"CONTER SHIPPING PRIVATE LIMITED",
"CONTERA ENGINEERING PRIVATE LIMITED",
"CONTESSA COMMERCIAL CO PVT LTD",
"CONTESTS2WIN COM INDIA PRIVATE LIMITED",
"CONTEXTAI (INDIA) PRIVATE LIMITED",
"CONTEXTINE SOFTWARE PRIVATE LIMITED",
"CONTICO SHIPPING AGENCY PRIVATE LIMITED",
"CONTIGO SOLUTIONS PRIVATE LIMITED",
"CONTIL INDIA LIMITED",
"CONTILOE PICTURES PRIVATE LIMITED",
"CONTINENTAL AUTOMATION SYSTEMS PRIVATE LIMITED",
"CONTINENTAL AUTOMOTIVE BRAKE SYSTEMS (I) PRIVATE LIMITED",
"CONTINENTAL AUTOMOTIVE COMPONENTS INDIA PRIVATE LIMITED",
"CONTINENTAL AUTONOMOUS MOBILITY INDIA PRIVATE LIMITED",
"CONTINENTAL BELTING PRIVATE LIMITED",
"CONTINENTAL CARBON INDIA PRIVATE LIMITED (TFR.CO. FROM W.B. TO DELHI)",
"CONTINENTAL CARRIERS PRIVATE LIMITED",
"CONTINENTAL CATERERS & CONFECTIONERS PRIVATE LIMITED",
"CONTINENTAL COATINGS PRIVATE LIMITED",
"CONTINENTAL COFFEE PRIVATE LIMITED",
"CONTINENTAL COMMODITIES PRIVATE LIMITED",
"CONTINENTAL CONDUCTORS PVT LTD",
"CONTINENTAL CONSTRUCTION CORPORATION LIMITED",
"CONTINENTAL CONTROLS LIMITED",
"CONTINENTAL CONVEYORS PRIVATE LIMITED",
"CONTINENTAL CORRUGATORS PRIVATE LIMITED",
"CONTINENTAL CROP SCIENCE PRIVATE LIMITED",
"CONTINENTAL CRYOGENICS PRIVATE LIMITED",
"CONTINENTAL DEVICE INDIA LIMITED",
"CONTINENTAL DISTILLERIES PRIVATE LIMITED",
"CONTINENTAL ELECTRICAL INDUSTRIES PRIVATE LIMITED",
"CONTINENTAL ENGINEERING & POWER PRIVATE LIMITED",
"CONTINENTAL ENGINEERING CORPORATION",
"CONTINENTAL ENGINEERING WORKS PRIVATE LIMITED",
"CONTINENTAL ENGINES LIMITED",
"CONTINENTAL ENGINES PRIVATE LIMITED",
"CONTINENTAL EQUIPMENT INDIA PRIVATE LIMITED",
"CONTINENTAL FERTILISERS PRIVATE LIMITED",
"CONTINENTAL FISHERIES INDIA LIMITED",
"CONTINENTAL FORMS PRIVATE LIMITED",
"CONTINENTAL FURNISHERS PRIVATE LIMITED",
"CONTINENTAL HARDWARE PRIVATE LIMITED",
"CONTINENTAL HOSPITALS PRIVATE LIMITED",
"CONTINENTAL INDIA PRIVATE LIMITED",
"CONTINENTAL INDIA PRIVETE LIMITED",
"CONTINENTAL INTER LINK PRIVATE LIMITED",
"CONTINENTAL LIGHTING INDIA PRIVATE LIMITED",
"CONTINENTAL LOGISTICS SOLUTIONS PRIVATE LIMITED",
"CONTINENTAL MILKOSE",
"CONTINENTAL MULTIMODAL TERMINALS LIMITED",
"CONTINENTAL OCEAN VENTURES PRIVATE LIMITED",
"CONTINENTAL PETROLEUMS LIMITED",
"CONTINENTAL PILING & EXCAVATION PRIVATE LIMITED",
"CONTINENTAL PROFILES LTD",
"CONTINENTAL REFRACTORIES PRIVATE LIMITED",
"CONTINENTAL ROADWAYS PRIVATE LIMITED",
"CONTINENTAL SALES EMPORIUM PRIVATE LIMITED",
"CONTINENTAL SECURITIES LIMITED",
"CONTINENTAL SEEDS AND CHEMICALS LIMITED",
"CONTINENTAL SURAKSHA INSURANCE BROKING SERVICES PRIVATE LIMITED",
"CONTINENTAL SURFACE SOLUTIONS INDIA PRIVATE LIMITED",
"CONTINENTAL TELEPOWER INDUSTRIES LIMITED (PART IX)",
"CONTINENTAL THERMAL ENGINEERS PRIVATE LIMITED",
"CONTINENTAL TRANS TECH PRIVATE. LIMITED.",
"CONTINENTAL TRANSPORT ORGANISATION PVT LTD",
"CONTINENTAL TUFFGLASS PRIVATE LIMITED",
"CONTINENTAL VALVES LIMITED",
"CONTINENTAL WAREHOUSE CORPORATION LIMITED",
"CONTINUA KIDS PRIVATE LIMITED",
"CONTINUAL ENGINE PRIVATE LIMITED",
"CONTINUAL RENEWABLE ENERGY PRIVATE LIMITED",
"CONTINUITY 1 TECHNOLOGIES PRIVATE LIMITED",
"CONTINUITY PRINTERS PRIVATE LIMITED",
"CONTINUSERVE SOFTECH INDIA PRIVATE LIMITED",
"CONTINUUM AVIATION PRIVATE LIMITED",
"CONTINUUM BUYING AGENCY PRIVATE LIMITED",
"CONTINUUM CONTENT SOLUTIONS INDIA PRIVATE LIMITED",
"CONTINUUM GREEN ENERGY (INDIA) PRIVATE LIMITED",
"CONTINUUM GREEN ENERGY INDIA PRIVATE LIMITED",
"CONTINUUM INDIA LLP",
"CONTINUUM MANAGED SOLUTIONS PRIVATE LIMITED",
"CONTINUUM MP WINDFARM DEVELOPMENT PRIVATE LIMITED",
"CONTINUUM TRINETHRA RENEWABLES PRIVATE LIMITED",
"CONTIS TECHNOLOGIES PRIVATE LIMITED",
"CONTITECH INDIA PRIVATE LIMITED",
"CONTITEL HOTELS AND RESORTS PRIVATE LIMITED",
"CONTOSO NATURA PRIVATE LIMITED",
"CONTOUR AUTOMOTIVE PRODUCTS LIMITED",
"CONTOUR BUILDCON PRIVATE LIMITED",
"CONTOUR CNC PRODUCTS PRIVATELIMITED",
"CONTOUR CONSTRUCTIONS PRIVATE LIMITED",
"CONTOUR GLOBAL HOLDING PRIVATE LIMITED",
"CONTOUR HOLIDAY RESORTS PRIVATE LIMITED",
"CONTOUR STEEL ENGINEERING INDIA PRIVATE LIMITED",
"CONTRAAST MARKETING (INDIA) PRIVATE LIMITED",
"CONTRACT ADVERTISING (INDIA) PRIVATE LIMITED",
"CONTRACT PHARMACAL CORPORATION INDIA PRIVATE LIMITED",
"CONTRACT WRANGLER INDIA PRIVATE LIMITED",
"CONTRACTING PLUS SOLUTIONS PRIVATE LIMITED",
"CONTRACTOR AND SONS MARKETING PRIVATE LIMITED",
"CONTRACTPOD SOLUTIONS PRIVATE LIMITED",
"CONTRADE INTERNATIONAL PRIVATE LIMITED",
"CONTRADO IMAGING INDIA PRIVATE LIMITED",
"CONTRAIL TECH ADVISORY PRIVATE LIMITED",
"CONTRANS CARGO PRIVATE LIMITED",
"CONTRANS CONTAINER LINE PRIVATE LIMITED",
"CONTRANS INDUSTRIAL PARK PRIVATE LIMITED",
"CONTRANS LOGISTIC PRIVATE LIMITED",
"CONTRANS SHIPPING PRIVATE LIMITED",
"CONTRANSYS PRIVATE LIMITED",
"CONTRARIAN CAPITAL INDIA PARTNERS PRIVATE LIMITED",
"CONTRINEX AUTOMATION PRIVATE LIMITED",
"CONTRIVE CONSULTING PRIVATE LIMITED",
"CONTRIVE INFOTECH PRIVATE LIMITED",
"CONTRIVE INSTRUMENTATION PRIVATE LIMITED",
"CONTRIVE MOULDS PRIVATE LIMITED",
"CONTRO LABS INDIA PRIVATE LIMITED",
"CONTROL & SWITCHGEAR",
"CONTROL COMPONENT INDIA PRIVATE LIMITED",
"CONTROL DESK SOLUTIONS PRIVATE LIMITED",
"CONTROL EFFECTS PUNE PVT LTD",
"CONTROL ELECTRIC COMPANY PRIVATE LIMITED",
"CONTROL INFOTECH PRIVATE LIMITED",
"CONTROL PLUS OIL AND GAS SOLUTIONS PRIVATE LIMITED",
"CONTROL PRINT LIMITED",
"CONTROL RISKS INDIA PRIVATE LIMITED",
"CONTROL SOFT ENGINEERING INDIA PRIVATE LIMITED",
"CONTROL TECHNIQUES INDIA PRIVATE LIMITED",
"CONTROL TECHNOAIDS ELECTRONICS INDIA PRIVATE LIMITED",
"CONTROL4 INDIA PRIVATE LIMITED",
"CONTROLCARE AUTOMATION PRIVATE LIMITED",
"CONTROLCASE INFOSEC PRIVATE LIMITED",
"CONTROLCASE INTERNATIONAL PRIVATE LIMITED.",
"CONTROLLA ELECTROTECH PVT LTD",
"CONTROLLER OF LEGAL METROLOGY",
"CONTROLLER OF MINES I B M NAGPUR",
"CONTROLLER ZAO CBDT AHMEDABAD",
"CONTROLLER ZAO CBDT JABALPUR",
"CONTROLLER ZAO CBDT NAGPUR",
"CONTROLLERATE OF QUALITY ASSURANCE (VEHS) AHMEDNAGAR",
"CONTROLLERATE OF QUALITY ASSURANCEMETALS ICHAPUR",
"CONTROLP TECHNO SOLUTIONS PRIVATE LIMITED",
"CONTROLS AND SCHEMATICS LIMITED",
"CONTROLS INDIA PRIVATE LIMITED",
"CONTROLSOFT ENGINEERING INDIA PRIVATE LIMITED",
"CONTROLWELLINDIA PVT LTD",
"CONTROMET CONSULTANCY SERVICES PRIVATE LIMITED",
"CONTROMOIST TECHNOLOGIES PRIVATE LIMITED",
"CONTRONICS SWITCHGEAR INDIA PRIVATE LIMITED",
"CONTROPEST (INDIA)CHEMICALS PRIVATE LIMITED",
"CONTTEXT RESEARCH PRIVATE LIMITED",
"CONTUS TECH PRIVATE LIMITED",
"CONTYPARK FINANCE CORPORATION LIMITED",
"CONVATE CONSULTANCY SERVICES PRIVATE LIMITED",
"CONVEGENIUS EDU SOLUTIONS PRIVATE LIMITE D",
"CONVELINE SYSTEMS PRIVATE LIMITED",
"CONVENE PHARMA PRIVATE LIMITED",
"CONVENIENCE FOODS PRIVATE LIMITED",
"CONVENIENCE TOURS AND FOREX PRIVATE LIMITED",
"CONVENIENT HOSPITALS LIMITED",
"CONVENIENT LIVING SOLUTIONS PRIVATE LIMITED",
"CONVENIEO SALES PRIVATE LIMITED",
"CONVENIO FOODS INTERNATIONAL PRIVATE LIMITED",
"CONVENT OF JESUS & MARY",
"CONVENTION HOTELS INDIA PRIVATE LIMITED",
"CONVENTIONAL DEVELOPERS AND CONTRACTORS PRIVATE LIMITED",
"CONVENTIONS AND FAIRS INDIA PRIVATE LIMITED",
"CONVENTUS TECHNOLOGIES PRIVATE LIMITED",
"CONVENTYA INDIA PRIVATE LIMITED",
"CONVERGE BIOTECH PRIVATE LIMITED",
"CONVERGE SYSTEMS & SERVICES PRIVATE LIMITED",
"CONVERGE TRANSPRINT SYSTEMS PRIVATE LIMITED",
"CONVERGENCE CHEMICALS PRIVATE LIMITED",
"CONVERGENCE ENERGY SERVICES LIMITED",
"CONVERGENCE INFOTECH PRIVATE LIMITED",
"CONVERGENCE STEEL PRIVATE LIMITED",
"CONVERGENT COMMUNICATIONS INDIA PRIVATE LIMITED",
"CONVERGENT TECHNOLOGIES INDIA PRIVATE LIMITED",
"CONVERGENT TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"CONVERGENT VIEW RESEARCH & CONSULTANCY PRIVATE LIMITED",
"CONVERGENT WIRELESS COMMUNICATIONS PRIVATE LIMITED",
"CONVERGESOFT INTERNATIONAL PRIVATE LIMITED",
"CONVERGIA DIGITAL EDUCATION PRIVATE LIMITED",
"CONVERGING MIINDS MANAGEMENT PRIVATE LIMITED",
"CONVERGINT INDIA PRIVATE LIMITED",
"CONVERGYS INDIA SERVICES PRIVATE LIMITED",
"CONVERGYTICS SOLUTIONS PRIVATE LIMITED",
"EPSILON INDIA DATA AND DIGITAL TECHNOLOGY SOLUTIONS LLP",
"CONVERSANT SOFTWARE SOLUTIONS PRIVATE LIMITED",
"CONVERSENOW SEMANTICS PRIVATE LIMITED",
"CONVERTCART SOLUTIONS PRIVATE LIMITED",
"CONVERTECH EQUIPMENT PRIVATE LIMITED",
"CONVERTEX GASES PRIVATE LIMITED",
"CONVERTEX INDIA PRIVATE LIMITED",
"CONVERTUP MEDIA PRIVATE LIMITED",
"CONVEX DIGITAL SOFTWARE SOLUTIONS PRIVATE LIMITED",
"CONVEX LATEX PRIVATE LIMITED",
"CONVEXITY SOLUTION AND ADVISORS PRIVATE LIMITED",
"CONVINA RESEARCH LAB PRIVATE LIMITED",
"CONVINO SEALS AND TAPES PRIVATE LIMITED",
"CONVIRZA PRIVATE LIMITED",
"CONVISTA CONSULTING INDIA PRIVATE LIMITED",
"CONVIVA APAC PRIVATE LIMITED",
"CONVIVIAL CATERS",
"CONVO RESEARCH & STRATEGY PRIVATE LIMITED",
"CONVOCON INFRAPROJECTS PRIVATE LIMITED",
"CONVONIX SYSTEMS PRIVATE LIMITED",
"CONVOSIGHT ANALYTICS PRIVATE LIMITED",
"CONVOY LOGISTICS PRIVATE LIMITED",
"CONVOY SECURE LIMITED",
"CONVURT ENGINEERING SERVICES LLP",
"CONWAY WATER PURIFIER PRIVATE LIMITED",
"CONWEIGH INDUSTRIES PRIVATE LIMITED",
"CONWOOD CONSTRUCTION & DEVELOPERS PRIVATE LIMITED",
"CONWOOD HOUSING PRIVATE LIMITED",
"CONYBIO HEALTHCARE (INDIA) PRIVATE LIMITED",
"CONZEPTS GLOBAL HR SERVICES PRIVATE LIMITED",
"CONZUMEX INDUSTRIES PRIVATE LIMITED",
"COOCH BEHAR MISSION HOSPITAL PRIVATE LIMITED",
"COOCHBEHAR AGRO-TEA ESTATE PVT. PRIVATE LTD.",
"COOCHBEHAR CABLE OPERATORS NETWORK PRIVATE LIMITED",
"COOCHBEHAR MEDICINE PRIVATE LIMITED",
"COOCHBEHAR TEA COMPANY LIMITED",
"COOEY TECHNOLOGIES PRIVATE LIMITED",
"COOK INDIA MEDICAL DEVICES PRIVATE LIMITED",
"COOKE & KELVEY PRIVATE LIMITED",
"COOKFLIX PRIVATE LIMITED",
"COOKIEGEN INFO TECHNOLOGIES PRIVATE LIMITED",
"COOKIEJAR TECHNOLOGIES PRIVATE LIMITED",
"COOKLINE INDUSTRIES PRIVATE LIMITED",
"COOKSON INDIA PRIVATE LIMITED",
"COOKWELL MARKETING PRIVATE LIMITED",
"COOL AIRWAYS ENGINEERS PRIVATE LIMITED",
"COOL BIRD AIRCON PRIVATE LIMITED",
"COOL BLUES PRIVATE LIMITED",
"COOL BRAIN TRADES PVT LTD",
"COOL CAPS INDUSTRIES LIMITED",
"COOL COMFORT PRIVATE LIMITED",
"COOL COSMETICS PRIVATE LIMITED",
"COOL DIAMONDS JEWELLERY PRIVATE LIMITED",
"COOL EARTH HVAC ENGINEERS PRIVATE LIMITED",
"COOL FASHIONS PRIVATE LIMITED",
"COOL SPRING BEVERAGES PRIVATE LIMITED",
"COOL STOP (INDIA) PRIVATE LIMITED",
"COOL THREAD",
"COOL WORLD ELECTRONICS PRIVATE LIMITED",
"COOL WORLD GLOBAL DISTRIBUTORS PRIVATE LIMITED",
"COOL WORLD RETAIL PRIVATE LIMITED",
"COOLBIRD HIGH SECURITY SERVICES PRIVATE LIMITED",
"COOLBOOTS MEDIA PRIVATE LIMITED",
"COOLBRAIN INVESTMART PRIVATE LIMITED",
"COOLDECK INDUSTRIES PRIVATE. LIMITED.",
"COOLEX INDUSTRIES PRIVATE LIMITED",
"COOLFLO ENGINEERS PVT LTD",
"COOLFLOW COOLING TOWERS PRIVATE LIMITED",
"COOLFREEZ SYSTEMS PRIVATE LIMITED",
"COOLINE MANUFACTURERS PRIVATE LIMITED",
"COOLING PEOPLE (PUNE) PVT LTD",
"COOLING SYSTEMS (INDIA) PRIVATE LIMITED",
"COOLING TOWER FABRICATORS PRIVATE LIMITED",
"COOLKARU INFO SOLUTIONS PRIVATE LIMITED",
"COOLLINE AGENCY PRIVATE LIMITED",
"COOLMATE REFRIGERANTS PRIVATE LIMITED",
"COOLON (INDIA) PRIVATE LIMITED",
"COOLPACK HVAC SYSTEMS PRIVATE LIMITED",
"COOLPEX INTERNATIONAL",
"COOLTECH APPLIANCES PRIVATE LIMITED",
"COOLWAYS CARRIERS PRIVATE LIMITED",
"COOLWAYS CONDITIONING PVT LTD",
"COOLZY FASHION",
"COOPER CORPORATION PRIVATE LIMITED",
"COOPER ELEVATORS INDIA PRIVATE LIMITED",
"COOPER GASKETS PVT LTD",
"COOPER LYBRANTH SERVICES LIMITED",
"COOPER PHARMA LIMITED",
"CO-OPERATION DEPARTMENT",
"COOPERATIVE ELECTRIC SUPPLY SOCIETY SIRCILLA",
"CO-OPERATIVE ELECTRIC SUPPLY SOCIETYCESS-SIRCILLA",
"CO-OPERATIVE RURAL DEVELOPMENT TRUST",
"COOPERS CONCEPT FOUNDATION PRIVATE LIMITED",
"COOPER-STANDARD SERVICES INDIA PRIVATE LIMITED",
"COOPERWIND INDIA PRIVATE LIMITED",
"COORD TECHNOLOGIES PRIVATE LIMITED",
"CO-ORDINATION SERVICES OF INDIA PRIVATE LIMITED",
"COORG HOLIDAY RESORTS PRIVATE LIMITED",
"COORGCLIFFS RESORTS INDIA PRIVATE LIMITED",
"COPA-DATA INDIA PRIVATE LIMITED",
"COPADO INDIA PRIVATE LIMITED",
"COPAINS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"COPAINS TECHNOLOGIES LLP",
"COPART INDIA PRIVATE LIMITED",
"COPASS TECHNOLOGY & SERVICES PRIVATE LIMITED",
"COPC INDIA PRIVATE LIMITED",
"COPCO ENGINEERING PRIVATE LIMITED",
"COPEN CLIMECARE PRIVATE LIMITED",
"COPENHAGEN HOSPITALITY PRIVATE LIMITED",
"COPERION IDEAL PRIVATE LIMITED",
"COPERNICIUM PHARMACEUTICALS PRIVATE LIMITED",
"COPES TECH INDIA PRIVATE LIMITED",
"COPIA MINING PRIVATE LIMITED",
"COPIA PROJECTS LLP",
"COPIA TECHNOLOGIES PRIVATE LIMITED",
"COPIAM VENTURES PRIVATE LIMITED",
"COPIOUS ESSENTIAL PRODUCT PRIVATE LIMITED",
"COPIOUS INTERNET PRIVATE LIMITED",
"COPIOUS SOFTWARE PRIVATE LIMITED",
"COPL PRINT O PACK PRIVATE LIMITED",
"COPMED PHARMACEUTICALS PRIVATE LIMITED",
"COPODS DESIGN TECHNOLOGY SOLUTION LLP",
"COPPER CONNECTIONS LIMITED",
"COPPER DIGITAL (INDIA) PRIVATE LIMITED",
"COPPER FURNISHINGS PRIVATE LIMITED",
"COPPER MOBILE INDIA PRIVATE LIMITED",
"COPPER STRIPS PRIVATE LIMITED",
"COPPERGATE CONSULTANTS PRIVATE LIMITED",
"COPPERPODS COSMETICS PRIVATE LIMITED",
"COPPERSMITH ENERGIES AND PROJECT PRIVATE LIMITED",
"COPPOLA HOLDINGS PVT LTD",
"COPPRROD INDUSTRIES PRIVATE LIMITED",
"COPRAL ENERGY PRIVATE LIMITED",
"COPS SECURITY SERVICES",
"COPTEC PRIVATE LIMITED",
"COPY AND PASTE IT SERVICES (OPC) PRIVATE LIMITED",
"COPYPRO TECHNOLOGIES PRIVATE LIMITED",
"COPYRIGHT INTEGRITY ADVISORY INDIA PRIVATE LIMITED",
"CORA WINDOW SYSTEMS PRIVATE LIMITED",
"CORADIUS TEXTILE AND APPAREL RESOURCES PRIVATE LIMITED",
"CORAL ASSOCIATES",
"CORAL BELLS INTERNATIONAL SCHOOL AND JUNIOR COLLEGE",
"CORAL BIOCALS LLP",
"CORAL CERAMIC PRIVATE LIMITED",
"CORAL COIL INDIA PRIVATE LIMITED",
"CORAL COMMUNICATIONS AND NETWORKS PRIVATE LIMITED",
"CORAL DRUGS PRIVATE LIMITED",
"CORAL FREIGHT LINES PRIVATE LIMITED",
"CORAL FREIGHT SYSTEMS PRIVATE LIMITED",
"CORAL GOLD TILES PRIVATE LIMITED",
"CORAL GRANITO PRIVATE LIMITED",
"CORAL HOMEFURNISHINGS PRIVATE LIMITED",
"CORAL HOSPITAL",
"CORAL HOSPITAL & RESEARCH CENTRE PRIVATE LIMITED",
"CORAL INDIA FINANCE AND HOUSING LIMITED",
"CORAL INFRASTRUCTURE PRIVATE LYD",
"CORAL INFRASTRUCTURES PRIVATE LIMITED",
"CORAL IT SOLUTIONS PRIVATE LIMITED",
"CORAL KNOWLEDGE SERVICES PRIVATE LIMITED",
"CORAL LANDCON PRIVATE LIMITED",
"CORAL LOGISTICS ASSETS (INDIA) PRIVATE LIMITED",
"CORAL MARITIME OF LEARING AND DEVELOPMENT",
"CORAL MOTORS PRIVATE LIMITED",
"CORAL NEWSPRINTS LIMITED",
"CORAL NUTRACEUTICALS PRIVATE LIMITED",
"CORAL PACKAGING PRIVATE LIMITED",
"CORAL PAINTO-CHEM PRIVATE LIMITED",
"CORAL PLUS CERAMIC PRIVATE LIMITED",
"CORAL POLYPACK PRIVATE LIMITED",
"CORAL PRINT PACK PRIVATE LIMITED",
"CORAL PUBLISHERS PRIVATE LIMITED",
"CORAL REALTORS PRIVATE LIMITED",
"CORAL RESIDENCY",
"CORAL REWINDING INDIA PRIVATE LIMITED",
"CORAL SALES PRIVATE LIMITED",
"CORAL SERVICES PRIVATE LIMITED",
"CORAL SOFFWARES LIMITED",
"CORAL SOLUTINS AND TRADING PRIVATE LIMITED",
"CORAL STRUCTURAL SOLUTIONS PRIVATE LIMITED (RENEWAL)",
"CORAL SUPPORT SERVICE PRIVATE LIMITED",
"CORAL TELECOM LIMITED",
"CORALBELLS COTSPIN PRIVATE LIMITED",
"CORALGREENS BUILDTECH PRIVATE LIMITED",
"CORALMANGO SOLUTIONS PRIVATE LIMITED",
"CORAM CHROMEWELL INDIA PRIVATE LIMITED",
"CORAMANDEL INFRASTRUCTURE PRIVATE LIMITED",
"CORAZA TECHNOLOGIES PRIVATE LIMITED",
"CORBEL PRE-LAMINATED BOARDS INDIA PRIVATE LIMITED",
"CORBELO PROJECTS PRIVATE LIMITED",
"CORBION INDIA PRIVATE LIMITED",
"CORBIS SOLUTIONS PRIVATE LIMITED",
"CORBUS INDIA LLP",
"CORBY SALES PRIVATE LIMITED",
"CORDANT ASSOCIATES PRIVATE LIMITED",
"CORDANT ENGINEERINGS INDIA PRIVATE LIMITED",
"CORDCAB ELECTRICS INDIA PRIVATE LIMITED",
"CORDCELL PRIVATE LIMITED",
"CORDELIA CONTAINER SHIPPING LINE PRIVATE LIMITED",
"CORDFLEX ELECTRONICS PRIVATE LIMITED",
"CORDIAL DEVELOPERS PRIVATE LIMITED",
"CORDIAL FOUNDATION PRIVATE LIMITED",
"CORDIAL TECHNOLOGIES PRIVATE LIMITED",
"CORDIALGRAMIN DEVELOPMENT FOUNDATION",
"CORDIANT TECHNOLOGIES PRIVATE LIMITED",
"CORDIS INDIA MEDICAL DEVICES PRIVATE LIMITED",
"CORDIS TECHNOLOGY INDIA PRIVATE LIMITED",
"CORDLIFE SCIENCES INDIA PRIVATE LIMITED",
"CORDOBA ENGINEERING PRIVATE LIMITED",
"CORDON BLEU PROPERTIES & INFRASTRUCTURES PRIVATE LIMITED",
"CORDON CONSTRUCTORS & REALTORS PRIVATE LIMITED",
"CORDOVA EDUCATIONAL SOLUTIONS PRIVATE LIMITED",
"CORDOVA PUBLICATIONS PRIVATE LIMITED",
"CORDRILA INFRASTRUCTURE PRIVATE LIMITED",
"CORDS CABLE INDUSTRIES LIMITED",
"CORDSTRAP INDIA PRIVATE LIMITED",
"CORE ANALYTICALS PRIVATE LIMITED",
"CORE AUTOMATION INDIA PRIVATE LIMITED",
"CORE CABLES PRIVATE LIMITED",
"CORE CARBONS PRIVATE LIMITED",
"CORE CARBONX SOLUTIONS PRIVATE LIMITED",
"CORE COMPETENCY MARINE SERVICES PRIVATE LIMITED",
"CORE COMPETENCY MARINE TRAINING PRIVATE LIMITED",
"CORE COSMETIC PRIVATE LIMITED",
"CORE CRUSHING EQUIPMENTS PRIVATE LIMITED",
"CORE CRUSHTECH PRIVATE LIMITED",
"CORE DIAGNOSTICS PRIVATE LIMITED",
"CORE DOC 2 INFO SERVICES PRIVATE LIMITED",
"CORE EHS SOLUTIONS",
"CORE ENERGY SYSTEMS LIMITED",
"CORE ENERGY SYSTEMS PRIVATE LIMITED",
"CORE ENTRADE INDIA PRIVATE LIMITED",
"CORE ERECTORS PRIVATE LIMITED",
"CORE FAB PROJECTS (UNIT-II) PRIVATE LIMITED",
"CORE FAB PROJECTS PRIVATE LIMITED",
"CORE FITNESS PRIVATE LIMITED",
"CORE GREEN SUGAR AND FUELS PRIVATE LIMITED",
"CORE HYDRAULICS PRIVATE LIMITED",
"CORE IMAGING DIAGNOSTICS",
"CORE INFRARES PRIVATE LIMITED",
"CORE INTEGRA CONSULTING SERVICES PRIVATE LIMITED",
"CORE INTEGRATED MANAGEMENT SYSTEMS PRIVATE LIMITED",
"CORE JEWELLERY PRIVATE LIMITED",
"CORE LEAD INTERACTIVE PRIVATE LIMITED",
"CORE LOGISTIC PRIVATE LIMITED",
"CORE METAL KRAFTS LIMITED",
"CORE METAL KRAFTS LTD",
"CORE MULTISERVICES",
"CORE NUTRILIFE LLP",
"CORE PROJECT ENGINEERS & CONSULTANTS PRIVATE LIMITED",
"CORE PROJECTS PRIVATE LIMITED",
"CORE SOLUCOMM LIMITED",
"CORE SOLUTIONS INC",
"CORE SUN POWER ENGEENERING PRIVATE LIMITED",
"CORE TEAM SOLUTIONS PRIVATE LIMITED",
"CORE TECH AGRI & BIO SOLUTIONS PRIVATE LIMITED",
"CORE TECH AURANGABAD PRIVATE LIMITED",
"CORE TECH IT SERVICES PRIVATE LIMITED",
"CORE TECHIES INDIA PRIVATE LIMITED",
"CORE3D GAME ART PRIVATE LIMITED",
"COREB SALES AND SERVICES PRIVATE LIMITED",
"CORECARD SOFTWARE INDIA PRIVATE LIMITED",
"CORECAT SOLUTIONS OPC PRIVATE LIMITED",
"CORECENTRIC ENGINEERING SOLUTIONS INDIA PRIVATE LIMITED",
"CORECO TECHNOLOGIES PRIVATE LIMITED",
"CORECOMPETE PRIVATE LIMITED",
"CORECON TECHNOLOGIES INDIA PRIVATE LIMITED",
"COREDELIA REALTY PRIVATE LIMITED",
"COREDGE.IO INDIA PRIVATE LIMITED",
"COREEL TECHNOLOGIES INDIA PRIVATE LIMITED",
"COREFLEX SOLUTIONS PRIVATE LIMITED",
"COREFLOW CHEMI PRIVATE LIMITED",
"COREFRAGMENT TECHNOLOGIES PRIVATE LIMITED",
"COREGENES SEED RESEARCH (INDIA) PRIVATE LIMITED",
"COREINTEGRA CONSULTING SERVICES PRIVATE LIMITED",
"COREIP LEGAL SERVICES PRIVATE LIMITED",
"COREIP TECHNOLOGY PRIVATE LIMITED",
"COREIT SERVICES PRIVATE LIMITED",
"COREL OFFSET & PACKAGING PRIVATE LIMITED",
"CORELIFE WHOLEFOODS PRIVATE LIMITED",
"CORELOGIC INDIA SERVICES PRIVATE LIMITED",
"CORELOGIX CONSULTING INDIA PRIVATE LIMITED",
"COREMIND SOFTWARE SERVICES PRIVATE LIMITED",
"CORENT TECHNOLOGY PRIVATE LIMITED",
"COREONE TECHNOLOGIES INDIA PRIVATE LIMITED",
"COREP LIGHTING INDIA PRIVATE LIMITED",
"COREPEELERS PRIVATE LIMITED",
"CORESONANT SYSTEMS PRIVATE LIMITED",
"CORESTAR PRODUCTS PRIVATE LIMITED",
"CORESTRENGTH TRADERS INDIA PRIVATE LIMITED",
"CORETEC ENGINEERING INDIA PRIVATE LIMITED",
"CORETECH REALTY PRIVATE LIMITED",
"CORETECH VENTURES (BANGALORE) PRIVATE LIMITED",
"CORETEGRA TECHNOLOGIES PRIVATE LIMITED",
"CORETOUCH ENTERPRISES PRIVATE LIMITED",
"CORETREE SOLUTIONS PRIVATE LIMITED",
"COREVANCE SYSTEMS PRIVATE LIMITED",
"COREVIEW SYSTEMS PRIVATE LIMITED",
"COREVISION INVESTMENT ADVISORY SERVICES PRIVATE LIMITED",
"COREWELL FOAMS PRIVATE LIMITED",
"COREY ORGANICS PRIVATE LIMITED",
"COREZI TECH PRIVATE LIMITED",
"CORI ENGINEERS PRIVATE LIMITED",
"CORIAL CERAMIC PRIVATE LIMITED",
"CORIANDER INDUSTRIES PRIVATE LIMITED",
"CORIANDER INFRACON PRIVATE LIMITED",
"CORIANT INDIA PRIVATE LIMITED",
"CORIENT BUSINESS SOLUTIONS PRIVATE LIMITED",
"CORIOLIS TECHNOLOGIES PRIVATE LIMITED",
"CORION FERTILITY CLINIC PRIVATE LIMITED",
"CORISE HEALTH CARE PRIVATE LIMITED",
"CORLIM MARINE EXPORTS PRIVATE LIMITED",
"CORLIN HERBALS (OPC) PRIVATE LIMITED",
"CORMIT ELECT PROJECTS PRIVATE LIMITED",
"CORMORANT ENGINEERING PRIVATE LIMITED",
"CORN HILL TEA PRIVATE LIMITED",
"CORNA INFRA LIMITED",
"CORNATION TRADERS PRIVATE LIMITED",
"CORNEL PHARMACEUTICALS PRIVATE LIMITED",
"CORNELL HOUSING AND INFRASTRUCTURE PRIVATE LIMITED",
"CORNELL OVERSEAS PRIVATE LIMITED",
"CORNELL-IN-INDIA PRIVATE LIMITED",
"CORNER HOUSE ICE-CREAMS PRIVATE LIMITED",
"CORNER OFFICE ADVISORS PRIVATE LIMITED",
"CORNER STORE TECHNOLOGIES PRIVATE LIMITED",
"CORNER TREE CONSULTING PRIVATE LIMITED",
"CORNERPIXEL STUDIOS PRIVATE LIMITED",
"CORNERSTONE BAY EAST DEVELOPERS PRIVATE LIMITED",
"CORNERSTONE CARS PRIVATE LIMITED",
"CORNERSTONE COMMUNICATIONS PRIVATE LIMITED",
"CORNERSTONE CONSTRUCTIONS LIMITED",
"CORNERSTONE INDIA CONSULTING PRIVATE LIMITED",
"CORNERSTONE MANAGEMENT SERVICES",
"CORNERSTONE ONDEMAND SERVICES INDIA PRIVATE LIMITED",
"CORNERSTONE PROPERTIES PRIVATE. LIMITED.",
"CORNERSTONE PROPERTY INVESTMENTS PRIVATE. LIMITED.",
"CORNERSTONE PROPERTY MANAGEMENT PRIVATE LIMITED",
"CORNERSTONE SPORT AND ENTERTAINMENT PRIVATE LIMITED",
"CORNERVIEW CONSTRUCTIONS AND DEVELOPERS PRIVATE LIMITED",
"CORNET TECHNOLOGY PRIVATE LIMITED",
"CORNEXT AGRI PRODUCTS PRIVATE LIMITED",
"CORNICHE HOSPITALITY PRIVATE LIMITED",
"CORNILEUS PHARMACEUTICALS PRIVATE LIMITED",
"CORNING FINOLEX OPTICAL FIBRE PRIVATE LIMITED",
"CORNING FRANCE",
"CORNING INCORPORATED",
"CORNING TECHNOLOGIES INDIA PRIVATE LIMITED",
"CORNTECH SEEDS PRIVATE LIMITED",
"COROB INDIA PRIVATE LIMITED",
"COROLLA ESTATE PRIVATE LIMITED",
"COROMANDAL AGRI SCIENCES PRIVATE LIMITED",
"COROMANDEL AGRICO PRIVATE. LIMITED.",
"COROMANDEL AGRO PRODUCTS AND OILS LIMITED CAPOL",
"COROMANDEL CABLES PRIVATE LIMITED",
"COROMANDEL CHEMICALS LIMITED",
"COROMANDEL ENGINEERING COMPANY LIMITED",
"COROMANDEL ESERVICES LIMITED",
"COROMANDEL FERTILIZERS & CHEMICALS PRIVATE LIMITED",
"COROMANDEL INDUSTRIAL GASES PRIVATE LIMITED",
"COROMANDEL INFOTECH INDIA LIMITED",
"COROMANDEL INTERNATIONAL LIMITED",
"COROMANDEL METAL PRODUCTS PRIVATE LIMITED",
"COROMANDEL PACKAGING PRIVATE LIMITED",
"COROMANDEL PAINTS PRIVATE LIMITED",
"COROMANDEL SHIPPING AGENCIES PVT LTD",
"COROMANDEL SQM INDIA PRIVATE LIMITED",
"COROMANDEL STAMPINGS AND STONES LTD",
"COROMANDEL SUGARS LIMITED",
"COROMANDEL TRAVELS LIMITED",
"CORON ENGINEERING SERVICES PRIVATE LIMITED",
"CORONA BUILDCON PRIVATE LIMITED",
"CORONA BUS MANUFACTURERS PRIVATE LIMITED",
"CORONA HOUSING PRIVATE LIMITED",
"CORONA PHARMACEUTICALS PRIVATE LIMITED.",
"CORONA PLASTICS PRIVATE LIMITED",
"CORONA REMEDIES PRIVATE LIMITED",
"CORONA VITRIFIED PRIVATE LIMITED",
"CORONATION AGRO INDUSTRIES LIMITED",
"CORONATION COLURPAK PRIVATE LIMITED",
"CORONATION FINVEST PVT LTD",
"CORONATION VACUUM GLASS PRIVATE LIMITED",
"CORONET DIGISIGN PRIVATE LIMITED",
"CORONET ENGINEERS PRIVATE LIMITED",
"CORONET POLYMER PVT LTD",
"CORONET SOFTWARE PRIVATE LIMITED",
"CORONEY TECHNOLOGIES PRIVATE LIMITED",
"CORONIS AJUBA SOLUTIONS PRIVATE LIMITED",
"CORONIS IT SYSTEMS PRIVATE LIMITED",
"CORONLUBES INDIA PRIVATE LIMITED",
"CORONORY CARE PRIVATE LIMITED",
"COROSEAL CHEMICAL EQUIPMENTS PRIVATE LIMITED",
"CORPAK PACKAGING PRIVATE LIMITED",
"CORPCONNECT ENTERPRISES INDIA PRIVATE LIMITED",
"CORPELSERVE INDIA PRIVATE LIMITED",
"CORPEX ADVISORS PRIVATE LIMITED",
"CORPINT INVESTMENTS PRIVATE LIMITED",
"CORPLEGAL BUSINESS SOLUTIONS PRIVATE LIMITED",
"CORPONE OUTSOURCING PRIVATE LIMITED",
"CORPONE STAFFING SOLUTIONS PRIVATE LIMITED",
"CORPORA CONSULTANTS PRIVATE LIMITED",
"CORPORATE (INDIA) FACILITIES PRIVATE LIMITED",
"CORPORATE ADVIZORY GROUP PRIVATE LIMITED",
"CORPORATE AESTHETIC REFURBISHING ENTERPRISES PRIVATE LIMITED",
"CORPORATE ANALYST & CONSULTANT PRIVATE LIMITED",
"CORPORATE APARTMENTS PRIVATE LIMITED",
"CORPORATE BRIDGE CONSULTANCY PRIVATE LIMITED",
"CORPORATE BUSINESS ADVISORS PRIVATE LIMITED",
"CORPORATE CAPITALVENTURES PRIVATE LIMITED",
"CORPORATE CATALYST INDIA PRIVATE LIMITED",
"CORPORATE CHANNELS (INDIA) PVT. LTD",
"CORPORATE CONCEPTS INFRA PRIVATE LIMITED",
"CORPORATE COOLING SYSTEMS PRIVATE LID",
"CORPORATE COURIER AND CARGO LIMITED",
"CORPORATE DIAGNOSTICS PRIVATE LIMITED",
"CORPORATE EVENTS IPRIVATE LIMITED",
"CORPORATE HOUSE KEEPING SERVICES INDIA PRIVATE LIMITED",
"CORPORATE INCENTIVE SOLUTIONS PRIVATE LIMITED",
"CORPORATE INFOSYSTEMS (INDIA) PRIVATE LIMITED",
"CORPORATE INFOTECH PRIVATE LIMITED",
"CORPORATE INFRASTRUCTURE SERVICES PRIVATE LIMITED",
"CORPORATE INTERIORS PRIVATE LIMITED",
"CORPORATE INTERNATIONAL FINANCIAL SERVICES LIMITED",
"CORPORATE INVESTIGATIONS INDIA PRIVATE LIMITED",
"CORPORATE LADDER CONSULTANTS PRIVATE LIMITED",
"CORPORATE LEAPS PRIVATE LIMITED",
"CORPORATE LEGAL CONSULTING PRIVATE LIMITED",
"CORPORATE LEISURE AND PROPERTY DEVELOPMENTS PRIVATE LIMITED",
"CORPORATE MERGERWARE SOLUTIONS PRIVATE LIMITED",
"CORPORATE POLYASIA INDIA PRIVATE LIMITED",
"CORPORATE PROFESSIONALS (INDIA) PRIVATE LIMITED",
"CORPORATE PROFESSIONALS CAPITAL PRIVATE LIMITED",
"CORPORATE RISKS INDIA INSURANCE BROKERS PRIVATE LIMITED",
"CORPORATE SECURE SERVICE PRIVATE LIMITED",
"CORPORATE SERVICE PLAN INDIA PRIVATE LIMITED",
"CORPORATE SOLUTIONS REDEFINED INDIA PRIVATE LIMITED",
"CORPORATE STATIONERY PRIVATE LIMITED",
"CORPORATE TECHNOLOGY PARTNERS",
"CORPORATE TELESYSTEMS PRIVATE LIMITED",
"CORPORATE TRANSACTION ADVISORY PRIVATE LIMITED",
"CORPORATE TRAVEL PRIVATE LIMITED",
"CORPORATE TRUST PRIVATE LIMITED",
"CORPORATE WARRANTIES INDIA PRIVATE LIMITED",
"CORPORATER ASIA TECHNOLOGIES PRIVATE LIMITED",
"CORPORATESERVE SOLUTIONS PRIVATE LIMITED",
"CORPORATION BANK",
"CORPORATION BANK LIMITED",
"CORPORATION HEALTH OFFICE SALEM",
"CORPORATION OF CITY OF PANAJI",
"CORPORATION OF THE OF PANAJI",
"CORPQLO CLOTHING PRIVATE LIMITED",
"CORPS INDIA HOSPITALITY PRIVATE LIMITED",
"CORPSEED ITES PRIVATE LIMITED",
"CORPSHAALA TECHNOLOGIES PRIVATE LIMITED",
"CORPSOLUTIONS SERVICES PRIVATE LIMITED",
"CORPTRANS COMMTRADE PRIVATE LIMITED",
"CORPUP SPACES PRIVATE LIMITED",
"CORPUS DATA INFORMATION SERVICES PRIVATE LIMITED",
"CORPUS ENTERPRISES PRIVATE LIMITED",
"CORPUS LIFESCIENCE PRIVATE LIMITED",
"CORPUS MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"CORPWIS ADVISORS PRIVATE LIMITED",
"CORRA TECHNOLOGY RESEARCH AND DEVELOPMENT INDIA PRIVATE LIMITED",
"COR-RESIST (NASIK) PRIVATE LIMITED",
"CORRIDOR TECHNOLOGIES PRIVATE LIMITED",
"CORRIGO CONSULTANCY PRIVATE LIMITED",
"CORRIT ELECTRIC PRIVATE LIMITED",
"CORRIVAL CORPORATE SERVICES PRIVATE LIMITED",
"CORROBORATE VENTURES SERVICES PRIVATE LIMITED",
"CORROGANON INDIA PVT LTD",
"CORROHEALTH INFOTECH PRIVATE LIMITED",
"CORROSION ENGINEERS PRIVATE LIMITED",
"CORROSION PROTECTION PRIVATE LIMITED",
"CORROSION TECHNOLOGY SERVICES INDIA PRIVATE LIMITED",
"CORROX REMEDIES PRIVATE LIMITED",
"CORRTECH ENERGY LIMITED",
"CORRTECH INTERNATIONAL LIMITED",
"CORRU CARTONS INDIA PRIVATE LIMITED",
"CORRUPACK MANUFACTURING PRIVATE LIMITED",
"CORRZ TECHNOSOLUTIONS PRIVATE LIMITED",
"CORSA PAPERS (INDIA) PRIVATE LIMITED",
"CORSAN INFRATECH PRIVATE LIMITED",
"CORSET WHOLESALE LIMITED",
"CORSICA SOLUTIONS PRIVATE LIMITED",
"CORTAAL INDIA PRIVATE LIMITED",
"CORTEC CORROSION SOLUTIONS INDIA PRIVATE LIMITED",
"CORTERA SOFTWARE PRIVATE LIMITED",
"CORTEVA AGRISCIENCE INDIA PRIVATE LIMITED",
"CORTEVA AGRISCIENCE SEEDS PRIVATE LIMITED",
"CORTEVA AGRISCIENCE SERVICES INDIA PRIVATE LIMITED",
"CORTEVA CROP INDIA PRIVATE LIMITED",
"CORTEX CONSTRUCTION SOLUTIONS PRIVATE LIMITED",
"CORTEX CONSULTING PRIVATE LIMITED",
"CORTEX LABORATORIES PRIVATE LIMITED",
"CORTEX PRODUCTS SOLUTION PRIVATE LIMITED",
"CORTEX SECURITY SERVICES INDIA PRIVATE LIMITED",
"CORTEX TECHNOLOGIES PRIVATE LIMITED",
"CORTEXCRAFT INNOVATION LABS PRIVATE LIMITED",
"CORTICA MANUFACTURING (INDIA ) PRIVATE LIMITED",
"CORTINA LABORATORIES PRIVATE LIMITED",
"CORTRIS INDIA PRIVATE LIMITED",
"CORUM COMMUNICATION PRIVATE LIMITED",
"CORUM SECURITIES PRIVATE LIMITED",
"CORUS DECOR PRIVATE LIMITED",
"CORUS INFRASTRUCTURE PRIVATE LIMITED",
"CORUS REAL ESTATE LIMITED",
"CORUS STEEL PRIVATE LIMITED",
"CORUS VITRIFIED PRIVATE LIMITED",
"CORUSCANT SYSTEMS PRIVATE LIMITED",
"CORUSCATE SOLUTIONS PRIVATE LIMITED",
"CORVELL LABS PRIVATE LIMITED",
"CORVENTIVE INFRASTRUCTURE DEVELOPMENT AND CONSULTANCY PRIVATE LIMITED",
"CORVETTE TECHNOLOGIES PRIVATE LIMITED",
"CORVI LED LIMITED",
"CORVI LED PRIVATE LIMITED",
"CORVINE CHEMICALS AND PHARMACEUTICALS LIMITED",
"CORVINE CHEMICALS AND PHARMACEUTICALS PRIVATE LIMITED",
"CORYS INDIA SIMULATION SYSTEMS PRIVATE LIMITED",
"COSARA DIAGNOSTICS PRIVATE LIMITED",
"COSBIKE PRIVATE LIMITED",
"COSCO (INDIA) LIMITED",
"COSCO SHIPPING LINES INDIA PRIVATE LIMITED",
"COSERVE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"COSETTE NETWORK PRIVATE LIMITED",
"COSHELL DIGITAL SOLUTION INDIA PRIVATE LIMITED",
"COSIGN INDIA PRIVATE LIMITED",
"COSINE POWER PRIVATE LIMITED",
"COSKILLS.IN",
"COSLIGHT INDIA TELECOM PRIVATE LIMITED",
"COSMAN INDUSTRIES PRIVATE LIMITED",
"COSMAS PHARMACLS LIMITED",
"COSMAS RESEARCH LAB LIMITED",
"COSMAT COMMERCIAL PRIVATE LIMITED",
"COSMAT EXPORTS PRIVATE LIMITED",
"COSMAX PHARMA LLP",
"COSME COSTA CONSTRUCTION PRIVATE LIMITED",
"COSME COSTA HOSPITALITY PRIVATE LIMITED",
"COSME DREAM INTERNATIONAL PRIVATE LIMITED",
"COSME MATIAS MENEZES PRIVATE LIMITED",
"COSMEA FINANCIAL HOLDINGS PRIVATE LIMITED",
"COSMELLA INFINITY PRIVATE LIMITED",
"COSMETIC STORES PRIVATE LIMITED",
"COSMETICS CONCEPT RESEARCH PRIVATE LIMITED",
"COSMIC ADVERTISERS PRIVATE. LIMITED.",
"COSMIC ALLOYS AND METAL WORKS PRIVATE LIMITED",
"COSMIC ARTS PRIVATE LIMITED",
"COSMIC BARCODE SOLUTTIONS PRIVATE LIMITED",
"COSMIC CONSUMER GOODS PRIVATE LIMITED",
"COSMIC COTTEX PRIVATE LIMITED",
"COSMIC DISTRIBUTORS PRIVATE LIMITED",
"COSMIC EAGLE BRANDS PRIVATE LIMITED",
"COSMIC EQUIPMENTS (INDIA) PRIVATE LIMITED",
"COSMIC FERRO ALLOYS LIMITED",
"COSMIC GLOBAL LIMITED",
"COSMIC GRACE AUTO INDIA PRIVATE LIMITED",
"COSMIC INDUSTRIES LTD.",
"COSMIC INFORMATION AND TECHNOLOGY LIMITED",
"COSMIC IT SERVICES PRIVATE LIMITED",
"COSMIC KITCHEN PRIVATE LIMITED",
"COSMIC MEDITECH PRIVATE LIMITED",
"COSMIC MERCHANTS PRIVATE LIMITED",
"COSMIC MOTORS INDIA PRIVATE LIMITED",
"COSMIC NUTRACOS SOLUTIONS PRIVATE LIMITED",
"COSMIC PACKING",
"COSMIC PETROCHEM PRIVATE LIMITED",
"COSMIC POWER SYSTEMS PRIVATE LIMITED",
"COSMIC PV POWER PRIVATE LIMITED",
"COSMIC REFRIGERATION PRIVATE LIMITED",
"COSMIC RUGS PRIVATE LIMITED",
"COSMIC SOFT SOLUTION PRIVATE LIMITED",
"COSMIC STRANDS EPUBLISHING PRIVATE LIMITED",
"COSMIC TRADE AND INVESTMENTS PVT LTD",
"COSMIC TRENDS PRIVATE LIMITED",
"COSMICIT INFORMATICS INDIA PRIVATE LIMITED",
"COSMICS SOUND AND ENTERTAINMENTS PRIVATE LIMITED",
"COSMIQUE PRIVATE LIMITED",
"COSMO CAPITAL & INVESTMENTS PRIVATE LIMITED",
"COSMO CARRYING PRIVATE LIMITED",
"COSMO DIGITEC PRIVATE LIMITED",
"COSMO DIGITECH PRIVATE LIMITED.",
"COSMO DURABLES PRIVATE LIMITED",
"COSMO ECOSYSTEM CARE PRIVATE LIMITED",
"COSMO ELECTRO INDUSTRIES PRIVATE LIMITED",
"COSMO ENERGY PRIVATE LIMITED",
"COSMO FERRITES LIMITED",
"COSMO FINE FOODS PRIVATE LIMITED",
"COSMO FIRST LIMITED",
"COSMO GRANITES PRIVATE LIMITED",
"COSMO HERBALS LIMITED",
"COSMO INDIA PRIVATE LIMITED",
"COSMO INDUSTRIAL PRODUCTS PRIVATE LIMITED",
"COSMO INFRA SOLUTIONS",
"COSMO INSTRUMENTS INDIA PRIVATE LIMITED",
"COSMO METCAB PRIVATE LIMITED",
"COSMO PRINT SOLUTIONS PRIVATE LIMITED",
"COSMO SHIPPING SERVICES PRIVATE LIMITED",
"COSMO SHUOQI IMPEX INDIA PRIVATE LIMITED",
"COSMO SPECIALITY CHEMICALS PRIVATE LIMITED",
"COSMO TEXCORP GLOBAL PRIVATE LIMITED",
"COSMOBLU NUTRIMENT & BEVERAGES (OPC) PRIVATE LIMITED",
"COSMOCRAT SOFTWARE SOLUTIONS (OPC) PRIVATE LIMITED",
"COSMODERM INDIA PRIVATE LIMITED",
"COSMOFIL PLASTISACK PVT LTD",
"COSMOGENIC IT SOLUTIONS PRIVATE LIMITED",
"COSMOGLITZ INTERNATIONAL PRIVATE LIMITED",
"COSMOINDUS PRODUCTS PRIVATE LIMITED",
"COSMONAUT TECHNOLOGIES PRIVATE LIMITED",
"COSMONET SOLUTIONS PRIVATE LIMITED",
"COSMONITE AGRICULTURE PRIVATE LIMITED",
"COSMOPLAST POLYCONTAINER LLP",
"COSMOPOLITAN CLUB",
"COSMOPOLITAN COLLEGE",
"COSMOPOLITAN EDUCATION TRUST",
"COSMOPOLITAN HOSPITAL",
"COSMOPOLITAN INDUSTRIAL SECURITY AND DETECTIVE SERVICES PRIVATE LIMITED",
"COSMOS ADVANCED DIAGNOSTICS LLP",
"COSMOS AGENCIES LLP",
"COSMOS AIRCON PRIVATE LIMITED",
"COSMOS ALUMINIUM PRIVATE LIMITED",
"COSMOS AUTOCAST PVT LTD",
"COSMOS BEVERAGES PRIVATE LIMITED",
"COSMOS BIOSCIENCES PRIVATE LIMITED",
"COSMOS BON-VOYAGE AND FOREX PRIVATE LIMITED",
"COSMOS BUSINESS MACHINES PRIVATE LIMITED",
"COSMOS CONDUCTORS PRIVATE. LIMITED.",
"COSMOS CONGLOMERATE PRIVATE LIMITED",
"COSMOS CONSTRUCTION MACHINERIES AND EQUIPMENTS PRIVATE LIMITED",
"COSMOS ELECTRODES PVT.LTD.",
"COSMOS ENGINE COMPONENTS PRIVATE LIMITED",
"COSMOS ENGITECH PRIVATE LIMITED",
"COSMOS EPC PRIVATE LIMITED",
"COSMOS E-SOLUTIONS & SERVICES PRIVATE LIMITED",
"COSMOS FACILITY SERVICES PRIVATE LIMITED",
"COSMOS FERROUS PRIVATE LIMITED",
"COSMOS FIBRE GLASS LIMITED",
"COSMOS FOOD EXPORTS PVT LTD",
"COSMOS GREEN INDIA BROADCAST PRIVATE LIMITED",
"COSMOS HEALTHTECH PRIVATE LIMITED",
"COSMOS HOMES (INDIA) PRIVATE LIMITED",
"COSMOS HYDRO POWER PRIVATE LIMITED",
"COSMOS IMPEX (INDIA) PVT LTD",
"COSMOS INDUSTRIES LIMITED",
"COSMOS INFRA ENGINEERING (INDIA) PRIVATE LIMITED",
"COSMOS INFRAESTATE PRIVATE LIMITED",
"COSMOS INTEGRATED SOLUTIONS PRIVATE LIMITED",
"COSMOS INTERNATIONAL LIMITED",
"COSMOS INTERNATIONAL PRIVATE LIMITED",
"COSMOS KIDNEY CARE AND RESEARCH PRIVATE LIMITED",
"COSMOS LUBE TECHNIQUE PRIVATE LIMITED",
"COSMOS MANPOWER PRIVATE LIMITED",
"COSMOS MAYA INDIA PRIVATE LIMITED",
"COSMOS MEDIA PRODUCTS PRIVATE LIMITED",
"COSMOS MERCANTILE PVT LTD",
"COSMOS PRECISION ENGINEERING PRIVATE LIMITED",
"COSMOS PREMISES PRIVATE LIMITED",
"COSMOS PRIME PROJECTS LIMITED",
"COSMOS REAL ESTATES PRIVATE LIMITED",
"COSMOS ROLLING MILLS PRIVATE LIMITED",
"COSMOS SECURITY SERVICES PRIVATE LIMITED",
"COSMOS SKYLINE HOMES PRIVATE LIMITED",
"COSMOS SURGICAL EQUIPMENTS PRIVATE LIMITED",
"COSMOS SYSTEM INTEGRATORS PRIVATE LIMITED",
"COSMOS TAPES AND LABELS PRIVATE LIMITED",
"COSMOS TECHNO CAST PRIVATE LIMITED",
"COSMOS TEXTILE MILLS PVT LTD",
"COSMOS TOYS INDIA PRIVATE LIMITED",
"COSMOS TRANSPORT AND ALLIED SERVICES PRIVATE LIMITED",
"COSMOS TWISTERS PRIVATE LIMITED",
"COSMOS WATER SOLUTIONS PRIVATE LIMITED",
"COSMOSAFE HEALTHCARE PRIVATE LIMITED",
"COSMOSIGN CREATIVE SOLUTIONS PRIVATE LIMITED",
"COSMOSOFT TECHNOLOGIES LIMITED",
"COSMOTEC MEDICAMENTS PRIVATE LIMITED",
"COSMOTECH COMMUNICATION PRIVATE LIMITED",
"COSMOTECH IMPEX PRIVATE LIMITED",
"COSMOTONE CONDUCTORS PRIVATE LIMITED",
"COSO PROJECTS PRIVATE LIMITED",
"COSOFT INDIA PRIVATE LIMITED",
"COSPACES OPTECH PRIVATE LIMITED",
"COSPHA CARE CHEMICALS PRIVATE LIMITED",
"COSPHI ENGINEERING INDIA PRIVATE LIMITED",
"COSPOWER ENGINEERING LIMITED",
"COSPOWER ENGINEERING PRIVATE LIMITED",
"COSPOWER INDIA NEW ENERGY PRIVATE LIMITED",
"COSPRO ENERGY PRIVATE LIMITED",
"COSSET TOURS AND TRAVELS PRIVATE LIMITED",
"COSSIO CONSULTING PRIVATE LIMITED",
"COSSMIC PRODUCTS PRIVATE LIMITED",
"COST PRICE DISCOUNT STORES PRIVATE LIMITED",
"COSTA AND COMPANY PRIVATE LIMITED.",
"COSTA COFFEE INDIA PRIVATE LIMITED",
"COSTA EXPORTS & IMPORTS PRIVATE LIMITED",
"COSTA INTERNATIONAL",
"COSTA POWER INDUSTRIES PRIVATE LIMITED",
"COSTAL ANDRA POWER LIMITED",
"COSTAL PARK MARINE EXPORTS PRIVATE LIMITED",
"COSTAL VINCOM PRIVATE LIMITED",
"COSTAN PROJECTS PRIVATE LIMITED",
"COSTER INDIA PACKAGING PRIVATE LIMITED",
"COSTRATEGIX TECHNOLOGIES PRIVATE LIMITED",
"COSVATE SIYARAM TEXTILES PRIVATE LIMITED",
"COSWIG ENTERPRISES PRIVATE LIMITED",
"COSY CORNER INVESTMENTS PVT LTD",
"COSY SHOES INDUSTRIES PRIVATE LIMITED",
"COSY WORLD RESORTS LIMITED",
"COSYN LIMITED",
"COT FAB (INDIA) PRIVATE LIMITED",
"COTEC HEALTHCARE PRIVATE LIMITED",
"COTECNA INSPECTION INDIA PRIVATE LIMITED",
"COTELLIGENT INDIA PRIVATE LIMITED",
"COTENG INDIA PRIVATE LIMITED",
"COTERIE TOURS PRIVATE LIMITED",
"COTEX CHEM PRIVATE LIMITED",
"COTEX LAXMI HEALTHCARE PRIVATE LIMITED",
"COTGIN IT SOLUTION PRIVATE LIMITED",
"COTHAS COFFEE CO",
"COTIVITI INDIA PRIVATE LIMITED",
"COTMAC ELECTRONICS PRIVATE LIMITED",
"COTMAC INDUSTRIAL TRADING PRIVATE LIMITED",
"COTMAX ABSORBENT COTTON PRIVATE LIMITED",
"COTO CERAMIC PRIVATE LIMITED",
"COTSWOLD MANUFACTURING INDIA PRIVATE LIMITED",
"COTSWOLD SEA PRIVATE LIMITED",
"COTTAGE HOSPITAL NEKNOOR BEED",
"COTTAGE IMPEX PRIVATE LIMITED",
"COTTAGE INDUSTRIES EXPOSITION LIMITED",
"COTTON ASSOCIATION OF INDIA",
"COTTON BLOSSOM INDIA PRIVATE LIMITED",
"COTTON CLUB PRIVATE LIMITED",
"COTTON COLLEGE",
"COTTON COTTAGE INDIA PRIVATE LIMITED",
"COTTON COUNTY RESORTS AND ESTATES PRIVATE LIMITED",
"COTTON COUNTY RETAIL LIMITED",
"COTTON CULTURE PRIVATE LIMITED",
"COTTON FAB CREATION PRIVATE LIMITED",
"COTTON NATURALS INDIA PRIVATE LIMITED",
"COTTON WORLD",
"COTTONCITY AGRO FOODS PRIVATE LIMITED",
"COTTONCONNECT SOUTH ASIA PRIVATE LIMITED",
"COTTONGURU MAHA FARMERS PRODUCER COMPANY LIMITED",
"COTTOR PLANTS (INDIA) PVT LTD",
"COUCH PERRY & WILKES INDIA PRIVATE LIMITED",
"COUCHBASE INDIA PRIVATE LIMITED",
"COUGAR SECURITY AND CONSULTANCY PRIVATE LIMITED",
"COUGAR VANIJYA PVT.LTD.",
"COUNCIL FOR AMERICAN EDUCATION",
"COUNCIL FOR LEATHER EXPORTS",
"COUNCIL FOR SOCIAL DEVELOPMENTCENTRAL GOVERNAMENT",
"COUNCIL FOR THE INDIAN SCHOOL CERTIFICATE EXAMINATIONS",
"COUNCIL OF EDUCATION AND SKILL DEVELOPMENT",
"COUNCIL OF PHILANTHROPIES FOR CLIMATE ACTION",
"COUNCIL OF SCIENTIFIC & INDUSTRIAL RESEARCH",
"COUNCIL OF SCIENTIFIC &INDUSTRIAL RESEARCH NEW DELHI",
"COUNFREEDISE RETAIL SERVICES LIMITED",
"COUNSELAGE INDIA PRIVATE LIMITED",
"COUNSELECT SERVICES PRIVATE LIMITED",
"COUNSELINDIA SERVICES PRIVATE LIMITED",
"COUNT N DENIER EXIM PRIVATE LIMITED",
"COUNTER MEASURES TECHNOLOGIES PRIVATE LIMITED",
"COUNTERCULTURE HOSPITALITY PRIVATE LIMITED",
"COUNTERTOPS AND CABINETS (INDIA) PRIVATE LIMITED",
"COUNTFOODIS PRIVATE LIMITED",
"COUNTHQ ACCOUNTING AND TAXATION SERVICES PRIVATE LIMITED",
"COUNTO AUTOMOBILES PRIVATE LIMITED",
"COUNTO MICROFINE PRODUCTS PRIVATE LIMITED",
"COUNTON ACE PRIVATE LIMITED",
"COUNTOUR CONSULTING ENGINEERS",
"COUNTRY COLONISERS PVT. LTD",
"COUNTRY CRICKET CLUB",
"COUNTRY DEVELOPMENT & MANAGEMENT SERVICES LIMITED",
"COUNTRY EXPRESS HOTELS AND RESORTS PRIVATE LIMITED",
"COUNTRY INN & SUITES BY RADDISSON",
"COUNTRY ROADS ENTERTAINMENT PRIVATE LIMITED",
"COUNTRY ROADS HOSPITALITY PRIVATE LIMITED",
"COUNTRY VACATIONS INTERNATIONAL LIMITED",
"COUNTRY VILLA DECOR PRIVATE LIMITED",
"COUNTRYCONSTRUCT BUILDCON PRIVATE LIMITED",
"COUNTRYLINK COMMUNICATION PRIVATE LIMITED",
"COUNTRYSIDE ENTERPRISES PRIVATE LIMITED",
"COUNTRYSIDERS AGRITECH PRIVATE LIMITED",
"COUNTRYWIDE IMMIGRATION PRIVATE LIMITED",
"COUNTRYWIDE INFRASTRUCTURE PRIVATE LIMITED",
"COUNTRYWIDE LOGISTICS INDIA PRIVATE LIMITED",
"COUNTRYWIDE NETWORK PRIVATE LIMITED",
"COUNTRYWIDE PROMOTERS PRIVATE LIMITED",
"COUNTY INFRASTRUCTURES PRIVATE LIMITED",
"COUNTY POLYPACK PRIVATE LIMITED",
"COUPA SOFTWARE INDIA PRIVATE LIMITED",
"COUPLER CONTRIVE PRIVATE LIMITED",
"COUPONDUNIA MEDIA PRIVATE LIMITED",
"COURAGE ENGINEERING PRIVATE LIMITED",
"COURAGE INFRA PRIVATE LIMITED",
"COURGIANT EXPRESS PRIVATE LIMITED",
"COURION IT PRIVATE LIMITED",
"COURSE5 INTELLIGENCE LIMITED",
"COURSELEAP EDUCATION PRIVATE LIMITED",
"COURSERA INDIA PRIVATE LIMITED",
"COURSYS DIGITECH INDIA PRIVATE LIMITED",
"COURTAULDS COATING&STALTANTSIPLIMITED",
"COURTLAND PROPERTIES PRIVATE LIMITED",
"COURTYARD REAL ESTATE PRIVATE LIMITED",
"COUSIN ENTERPRISES PRIVATE LIMITED",
"COUTH INFOTECH PRIVATE LIMITED",
"COUTURE A CRAFT PRIVATE LIMITED",
"COUTURE AI PRIVATE LIMITED",
"COVAI CASTINGSS INDIA PRIVATE LIMITED",
"COVAI PLASTO CONTAINERS PRIVATE LIMITED",
"COVAI PROPERTY CENTRE INDIA PRIVATE LIMITED",
"COVAI PROTECTION SERVICES PRIVATE LIMITED",
"COVAI SENIOR CITIZENS SERVICES PRIVATE LIMITED",
"COVALENCE ENTERPRISES PRIVATE LIMITED",
"COVALENCE ENVIROTECH PRIVATE LIMITED",
"COVALENSE DIGITAL SOLUTIONS PRIVATE LIMITED",
"COVALENSE TECHNOLOGIES PRIVATE LIMITED",
"COVALENT LABORATORIES PRIVATE LIMITED",
"COVALENT POLYMERS PRIVATE LIMITED",
"COVALENT TECHNOLOGIES INDIA PRIVATE LIMITED",
"COVALSYSOFT SOLUTIONS PRIVATE LIMITED",
"COVAN TECH PRIVATE LIMITED",
"COVANTA MADURAI OPERATING PRIVATE LIMITED",
"COVE GLOBAL LOGISTICS PRIVATE LIMITED",
"COVE HOLDINGS PRIVATE LIMITED",
"COVENANT NETWORK TECHNOLOGIES PRIVATE LIMITED",
"COVENANTS DEVELOPERS PRIVATE LIMITED",
"COVENT INDIA PRIVATE LIMITED",
"COVENTRY COIL-O-MATIC HARYANA LIMITED",
"COVENTYA INDIA PRIVATE LIMITED",
"COVER IT UP STUDIOS PRIVATE LIMITED",
"COVER MART PRIVATE LIMITED",
"COVEREDGE MARKETING PRIVATE LIMITED",
"COVERFOX INSURANCE BROKING PRIVATE LIMITED",
"COVERMITRA INSURANCE BROKING PRIVATE LIMITED",
"COVERPLAN TECHNOLOGY PRIVATE LIMITED",
"COVERTEK CERAMICA PRIVATE LIMITED",
"COVESTAYS PRIVATE LIMITED",
"COVESTRO INDIAPRIVATE LIMITED",
"COVET FINANCIAL SERVICES PRIVATE LIMITED",
"COVIAM TECHNOLOGY AND SERVICES PRIVATE LIMITED",
"COVIDIEN HEALTHCARE INDIA PRIVATE LIMITED",
"COVIE VENTURES PRIVATE LIMITED",
"COVIVA ENERGY TERMINALS LIMITED",
"COWCARE PHARMACEUTICAL PRIVATE LIMITED",
"COWI INDIA PRIVATE LIMITED",
"COWLAND AGRO PRIVATE LIMITED",
"COWNPOR GLOBAL SERVICE TECHNOLOGIES PRIVATE LIMITED",
"COWPER LABS PRIVATE LIMITED",
"COWRKS INDIA PRIVATE LIMITED",
"COWRUSH PRIVATE LIMITED",
"COWTOWN INFOTECH SERVICES PRIVATE LIMITED",
"COX INFRATECH PRIVATE LIMITED",
"COX WORLDWIDE CONSULTANTS PRIVATE LIMITED",
"COXMAN MARINE SERVICES PRIVATE LIMITED",
"COXSWAIN PROJECTS AND ESTATES PRIVATE LIMITED",
"COXSWAIN TECHNOLOGIES LIMITED",
"COXWELL DOMES ENGINEERS PRIVATE LIMITED",
"COZENTUS TECHNOLOGIES PRIVATE LIMITED",
"COZMO TRAVEL PRIVATE LIMITED",
"COZMO TRAVEL WORLD PRIVATE LIMITED",
"COZY AUTOTECH PRIVATE LIMITED",
"COZY CASUALS (INDIA) PRIVATE LIMITED",
"COZY FURNITEK PRIVATE LIMITED",
"COZY TRAVELS",
"COZYSTAY TECHNOLOGIES PRIVATE LIMITED",
"COZYTOUCH POLYFOAMS INDIA PRIVATE LIMITED",
"CP AVANT PRIVATE LIMITED.",
"CP BERAR ARTS COMMERCE COLLEGE",
"CP BERAR COLLEGE",
"CP GARMENTS AND WOOLLEN STORE",
"CP GOENKA INTERNATIONAL SCHOOL",
"CP INDIA TEST SYSTEMS PRIVATE LIMITED",
"CP KELCO INDIA PRIVATE LIMITED",
"CP PRIMA AQUACULTURE (INDIA) PRIVATE LIMITED",
"CP TRAVEL AND TOURS PRIVATE LIMITED",
"CP WHOLESALE INDIA PRIVATE LIMITED",
"CPA FASHION PRIVATE LIMITED",
"CPA GLOBAL SUPPORT SERVICES INDIA PRIVATE LIMITED",
"CPA SERVICES PRIVATE LIMITED",
"CPAC EDUCATION PRIVATE LIMITED",
"CPAS TECHNOLOGIES PRIVATE LIMITED",
"CPBOAR ASSAM RIFLES",
"CPC DIAGNOSTICS PRIVATE LIMITED",
"CPC LOGISTICS LIMITED",
"CPC POWER INDIA PRIVATE LIMITED",
"CPC PRECICOMP PRIVATE LIMITED",
"CPC PRECIPARTS PRIVATE LIMITED",
"CPD BANGALORE INFOSYSTEM P LIMITED",
"CPD ENERGY PRIVATE LIMITED",
"CPE ONLINE EDUCATION PRIVATE LIMITED",
"CPF INDIA PRIVATE LIMITED",
"CPG ACADEMIC SERVICES LIMITED",
"CPG BPM SERVICES PRIVATE LIMITED",
"CPG CONSULTANTS INDIA PRIVATE LIMITED",
"CPG IMPEX (I) PRIVATE LIMITED",
"CPH CENTER POINT HOSPITAL & MEDICAL RESEARCH INSTITUTE PRIVATE LIMITED",
"CPI DATA SERVICES[INDIA] PRIVATE LIMITED",
"CPI SATCOM & ANTENNA TECHNOLOGIES ASIA PRIVATE LIMITED",
"CPIT EDUTECH PRIVATE LIMITED",
"CPK FIRE AND SECURITY SYSTEMS PRIVATE LIMITED",
"CPL AROMAS PRIVATE LIMITED",
"CPL BIOLOGICALS PRIVATE LIMITED",
"CPL ELECTRICALS INDIA PRIVATE LIMITED",
"CPL ENERGY INDIA PRIVATE LIMITED",
"CPL TRADING COMPANY PRIVATE LIMITED",
"CPM INDIA SALES & MARKETING PRIVATE LIMITED",
"CPMC RELOCATION & LOGISTICS PRIVATE LIMITED",
"CPOS PAYMENTS SYSTEMS PRIVATE LIMITED",
"CPP ASSISTANCE SERVICES PRIVATE. LIMITED",
"CPPIB INDIA ADVISORS PRIVATE LIMITED",
"CPQ EXPERTS PRIVATE LIMITED",
"CPR DISTRIBUTORS PRIVATE LIMITED",
"CPR KEMPRODUCTS INDIA PRIVATE LIMITED",
"CPR LABORATORIES PRIVATE LIMITED",
"CPS CASH PROCESSING SOLUTIONS PRIVATE LIMITED",
"CPS ELECTRIC PRIVATE LIMITED",
"CPS GLOBAL SCHOOL",
"CPS OIL AND GAS EQUIPMENTS PRIVATE LIMITED",
"CPS SECURITY PRIVATE LIMITED",
"CPS TEXTILES PRIVATE LIMITED",
"CPS VENTURE CHENNAI PRIVATE LIMITED",
"CPT PROJECTS PRIVATE LIMITED",
"CPTS NETWORK PRIVATE LIMITED",
"CQA A CONTROLLERATE OF QUALITY ASSURANCE",
"CQLSYS TECHNOLOGIES PRIVATE LIMITED",
"CQMAX ELECTRONICS PRIVATE LIMITED",
"CQRA PRIVATE LIMITED",
"CQS TRAINING PRIVATE LIMITED",
"C-QUEL MANAGEMENT SERVICES PRIVATE LIMITED",
"CR BHUSAWAL DIVISION",
"CR GARMENTS",
"CR MUMBAI DIVISION",
"CR RAO ADVANCED INSTITUTE OF MATHEMATICS STATISTICS AND COMPUTER SCIENCE",
"CR RETAIL MALLS INDIA LIMITED",
"CR SYSTEMS ENGINEERING PRIVATE LIMITED",
"CR2 SOFTWARE PRIVATE LIMITED",
"CR2 TECHNOLOGIES LIMITED",
"CR3 INDIA PRIVATE LIMITED",
"CRAB AND TAUR",
"CRABTREE TRADECOM PRIVATE LIMITED",
"CRAC INFOSYSTEMS PRIVATE LIMITED",
"CRACKERS INDIA MINING PRIVATE LIMITED",
"CRACKVERBAL EDUTECH PRIVATE LIMITED",
"CRADEL PHARMACEUTICALS PRIVATE LIMITED",
"CRADIANT IT SERVICES PRIVATE LIMITED",
"CRADLE CALICUT MATERNITY CARE PRIVATE LIMITED",
"CRADLE LIFE SCIENCES PRIVATE LIMITED",
"CRADLE RUNWAYS INDIA PRIVATE LIMITED",
"CRADLE VANIJYA PRIVATE LIMITED",
"CRADLEPOINT INDIA PRIVATE LIMITED",
"CRADLEWISE INNOVATIONS PRIVATE LIMITED",
"CRADON TRADERS PRIVATE LIMITED",
"CRAFSOL TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"CRAFT & COMMERCE PRIVATE LIMITED",
"CRAFT 7 TECHNOLOGIES PRIVATE LIMITED",
"CRAFT CORNER PAPER MILLS LIMITED",
"CRAFT ENGINEERING SERVICES PVT LTD",
"CRAFT FINANCIAL ADVISOR PRIVATE LIMITED",
"CRAFT HOSPITAL AND RESEARCH CENTRE",
"CRAFT INFRASTRUCTURE PRIVATE LIMITED",
"CRAFT INT-DECOR PRIVATE LIMITED",
"CRAFT MOLD INDIA PRIVATE LIMITED",
"CRAFT SILICON PRIVATE LIMITED",
"CRAFT SILICON SOFTWARE SERVICES PRIVATE LIMITED",
"CRAFTANY IT SOLUTIONS LLP",
"CRAFTARENA JEWELS (INDIA) PRIVATE LIMITED",
"CRAFTCHEM OVERSEAS PRIVATE LIMITED",
"CRAFTECH PAPER MILLS PRIVATE LIMITED",
"CRAFTLINK MEDICAL DEVICE PRIVATE LIMITED",
"CRAFTOPLEX PRIVATE LIMITED",
"CRAFTPAC CONTAINERS PRIVATE LIMITED",
"CRAFTRED DESIGNS PRIVATE LIMITED",
"CRAFTS PALACE HOTELS INDIA PRIVATE LIMITED",
"CRAFTSMAN AUTOMATION LIMITED",
"CRAFTSMAN AUTOMATION PRIVATE LIMITED",
"CRAFTSMAN GRAPHICS",
"CRAFTSMAN PROJECTS PRIVATE LIMITED",
"CRAFTSMAN SOLUTIONS PRIVATE LIMITED",
"CRAFTSMEN JEWELLERY PRIVATE LIMITED",
"CRAFTSMEN LABELMAKERS PRIVATE LIMITED",
"CRAFTSMITH PRIVATE LIMITED",
"CRAFTSVILLA HANDICRAFTS PRIVATE LIMITED",
"CRAFTSWELL FURNISHERS PRIVATE LIMITED",
"CRAFTVAULT TRADING AND CONSULTANTS PRIVATE LIMITED",
"CRAFTWORLD EVENTS PRIVATE LIMITED",
"CRAIGMORE PLANTATIONS INDIA PRIVATE LIMITED",
"CRALE FOODLINK PRIVATE LIMITED",
"CRAM GROUP INDIA PRIVATE LIMITED",
"CRANBERRY ANALYTICS PRIVATE LIMITED",
"CRANBERRY BRAND HOLDINGS PRIVATE LIMITED",
"CRANBERRY FOODS PRIVATE LIMITED",
"CRANE CONSULTING AND OUTSOURCING PRIVATE LIMITED",
"CRANE FOOD PRODUCTS PVT LTD",
"CRANE GLOBAL SOLUTIONS LIMITED",
"CRANE HEALTHCARE PRIVATE LIMITED",
"CRANE INFRASTRUCTURE LIMITED",
"CRANE PROCESS FLOW TECHNOLOGIES INDIA PRIVATE LIMITED",
"CRANE WORLDWIDE LOGISTICS INDIA PRIVATE LIMITED",
"CRANE-BEL INTERNATIONAL PRIVATE LIMITED",
"CRANEDGE INDIA PRIVATE LIMITED",
"CRANES SOFTWARE INTERNATIONAL LIMITED",
"CRANOIST MATERIAL HANDLING EQUIPMENTS PRIVATE LIMITED",
"CRAPSHOOT R ADVENTURE PRIVATE LIMITED",
"CRASSULA PHARMACEUTICALS PRIVATE LIMITED",
"CRAST GLOBAL AGRO FOOD & BEVERAGES PRIVATE LIMITED",
"CRATER ONLINE RETAIL PRIVATE LIMITED",
"CRATERZONE PRIVATE LIMITED",
"CRATIO SOFTWARE PRIVATE LIMITED",
"CRATIS DESIGNERS PRIVATE LIMITED",
"CRATIS HOSPITALS PRIVATE LIMITED",
"CRAV APPARELS PRIVATE LIMITED",
"CRAVATEX BRANDS LIMITED",
"CRAVATEX LIMITED",
"CRAVE CLOTHING COMPANY PRIVATE LIMITED",
"CRAVE INFORMATION PRIVATE LIMITED",
"CRAVE INFOTECH AND CONSULTANCY SERVICES PRIVATE LIMITED",
"CRAVE VENTURES PRIVATE LIMITED",
"CRAVEMORE FOOD SERVICES PRIVATE LIMITED",
"CRAVINA SYNTHETICS PRIVATE LIMITED",
"CRAVOVA FOOD & BEVERAGES INDIA PRIVATE LIMITED",
"CRAVX SOLUTIONS PRIVATE LIMITED",
"CRAWLEY & ROY FOUNDERS & ENGINEERS PRIVATE LIMITED",
"CRAYON COLOR PRIVATE LIMITED",
"CRAYON DATA INDIA PRIVATE LIMITED",
"CRAYON INFOTECH PRIVATE LIMITED",
"CRAYON IT SERVICES PRIVATE LIMITED",
"CRAYON MOTORS EV PRIVATE LIMITED",
"CRAYON RETAIL PRIVATE LIMITED",
"CRAYON SOFTWARE EXPERTS INDIA PRIVATE LIMITED",
"CRAYOND DIGITAL PRIVATE LIMITED",
"CRAYONFLAKES DESIGN PRIVATE LIMITED",
"CRAYONS ADVERTISING LIMITED",
"CRAYONS ADVERTISING PRIVATE LIMITED",
"CRAYONSYS IT SERVICES PRIVATE LIMITED",
"CRAZA LIFESCIENCES PRIVATE LIMITED",
"CRAZE HOSIERY PRIVATE LIMITED",
"CRAZELINK GADGETS PRIVATE LIMITED",
"CRAZIBRAIN SOLUTIONS PRIVATE LIMITED",
"CRAZY BRUTES PRODUCTION PRIVATE LIMITED",
"CRAZY CUB ANIMATION STUDIO PRIVATE LIMITED",
"CRAZY DENIM INDUSTRY LLP",
"CRAZY EXPORTS PRIVATE LIMITED",
"CRAZY NIB COMMUNICATIONS PRIVATE LIMITED",
"CRAZY OWLS FILMS PRIVATE LIMITED",
"CRAZY PREP PRIVATE LIMITED",
"CRAZY SNACKS PRIVATE LIMITED",
"CRB TECH SOLUTIONS PRIVATE LIMITED",
"CRB VENTURES PRIVATE LIMITED",
"CRBR INDUSTRIES PRIVATE LIMITED",
"CRC CORPORATE SERVICES PRIVATE LIMITED",
"CRC HOMES PRIVATE LIMITED",
"CRC INDIA MANUFACTURING AND DISTRIBUTORS PRIVATE LIMITED",
"CRC INFRATECH PRIVATE LIMITED",
"CRCIT INFOTECH PRIVATE LIMITED",
"CRCL LLP",
"CRD BUILDERS PRIVATE LIMITED",
"CRD FOODS PRIVATE LIMITED",
"CRD PLASTER AND WORKS PRIVATE LIMITED",
"CRE8 CONTRACTORS INDIA PRIVATE LIMITED",
"CRE8 MEDIART PRIVATE LIMITED",
"CREA FLOOR-TECH PRIVATE LIMITED",
"CREA MARKETING SERVICES PRIVATE LIMITED",
"CREADOR ADVISORS INDIA LLP",
"CREADOR WORLD ENTERTAINMENT PRIVATE LIMITED",
"CREAM EVENTS INDIA PRIVATE LIMITED",
"CREAM PACKS PVT LTD",
"CREAMCHOC ICE CREAMS PRIVATE LIMITED",
"CREAMLINE DAIRY PRODUCTS LTD",
"CREAMLITE FOODS PRIVATE LIMITED",
"CREAMY FOODS LIMITED",
"CREAMY FOODS LIMITED. CFL",
"CREAMY TALES FOODS PRIVATE LIMITED",
"CREANDO ASSOCIATES PRIVATE LIMITED",
"CREANOVATION TECHNOLOGIES PRIVATE LIMITED",
"CREANT TECHNOLOGIES PRIVATE LIMITED",
"CREANTUM SECURITY SOLUTIONS PRIVATE LIMITED",
"CREANZA CERAMIC PRIVATE LIMITED",
"CREANZA SOLAR ENERGY PRIVATE LIMITED",
"CREANZA TILES PRIVATE LIMITED",
"CREASE AND CUFF CLOTHING PRIVATE LIMITED",
"CREATE INNOVATE AUGMENT PRIVATE LIMITED",
"CREATECOMM TECH PRIVATE LIMITED",
"CREATERS INDIA PRIVATE LIMITED",
"CREATEZA MARKETING PRIVATE LIMITED",
"CREATIFY WEB SERVICES LLP",
"CREATIGIES COMMUNICATIONS PRIVATE LIMITED",
"CREATIGRITY TECHNOLOGIES PRIVATE LIMITED",
"CREATIIVE INFRA AND CONSTRUCTION PRIVATE LIMITED",
"CREATING ADVANCED FINANCIAL SOLUTIONS PRIVATE LIMITED",
"CREATING SPACE PRIVATE LIMITED",
"CREATION MEDICARE PRIVATE LIMITED",
"CREATION PUBLICITY PRIVATE LIMITED",
"CREATION ROYAL FILM ENTERTAINMENTS PRIVATE LIMITED",
"CREATION SHELTERS PRIVATE LIMITED",
"CREATION TECHNICS INDIA PRIVATE LIMITED",
"CREATION WINDTECH PRIVATE LIMITED",
"CREATIONS BY SHANAGAR",
"CREATIONS ENGINEERS PRIVATE LIMITED",
"CREATIONS INFRA INDIA PRIVATE LIMITED",
"CREATIONS JEWELLERY MANUFACTURING PRIVATE LIMITED",
"CREATIONS STUDENT STATIONERY PRIVATE LIMITED",
"CREATIONS TRADING PRIVATE LIMITED",
"CREATIONS VILLAS & APARTMENTS PRIVATE LIMITED",
"CREATIOSOFT SOLUTIONS PRIVATE LIMITED",
"CREATIQUE ESPORRE PRIVATE LIMITED",
"CREATIV TECH SERVICES PRIVATE LIMITED",
"CREATIVE ACADEMY PRE PRIMARY DADAR",
"CREATIVE ALCOATS PRIVATE LIMITED",
"CREATIVE AND CROFTS INDUSTRIES INDIA PRIVATE LIMITED",
"CREATIVE APPOGRAPHY RESEARCH LABS PRIVATE LIMITED",
"CREATIVE AROMATICS SPECIALITIES PRIVATE LIMITED",
"CREATIVE ARTISANS PRIVATE LIMITED",
"CREATIVE ARTS EDUCATION SOCIETY",
"CREATIVE ASSOCIATES SOLUTIONS PRIVATE LIMITED",
"CREATIVE AWARDS AND REWARDS PRIVATE LIMITED",
"CREATIVE AXIS INTERIORS PRIVATE LIMITED",
"CREATIVE BUILDWELL PRIVATE LIMITED",
"CREATIVE BUSINESS LABS PRIVATE LIMITED",
"CREATIVE CABLE NETWORK PRIVATE LIMITED",
"CREATIVE CAPSULE INFOTECH INDIA PRIVATE LIMITED",
"CREATIVE CAPTURE PRIVATE LIMITED",
"CREATIVE CARBON COMPOSITES PRIVATE LIMITED",
"CREATIVE CARBON PRIVATE LIMITED",
"CREATIVE CARTONS PRIVATE LIMITED",
"CREATIVE CARVE PRIVATE LIMITED",
"CREATIVE CASTINGS LIMITED",
"CREATIVE CASUALS (INDIA) PVT LTD",
"CREATIVE CHANNEL ADVERTISING AND MARKETING PRIVATE LIMITED",
"CREATIVE CLAP CONSULTANTS PRIVATE LIMITED",
"CREATIVE CLOTHEX",
"CREATIVE COLLECTIONS PRIVATE LIMITED",
"CREATIVE COMPONENTS PRIVATE LIMITED",
"CREATIVE COMPUNICS INDIA PRIVATE LIMITED",
"CREATIVE CONCEPTS ADVERTISING PRIVATE LIMITED",
"CREATIVE CONSTRUCTION (INDORE) PRIVATE LIMITED",
"CREATIVE COPIERS PRIVATE LIMITED",
"CREATIVE CORRUGATING INDUSTRIES PRIVATE LIMITED",
"CREATIVE CORRUPACK PRIVATE LIMITED",
"CREATIVE DESIGN CONSULTANTS & ENGINEERS PRIVATE LIMITED",
"CREATIVE DIES & MOULDS PRIVATE LIMITED",
"CREATIVE DIESEL SERVICES PRIVATE LIMITED",
"CREATIVE DIGITAL MARKETERS",
"CREATIVE DRESSES PRIVATE LIMITED",
"CREATIVE DYEING AND PRINTING MILLS PRIVATE LIMITED",
"CREATIVE EDUCATION FOUNDATION",
"CREATIVE EDUCATIONAL AIDS PRIVATE LIMITED",
"CREATIVE EDUCATIONAL SOCIETY'S COLLEGE OF PHARMACY",
"CREATIVE ELECTRO MECHANICALS PRIVATE LIMITED",
"CREATIVE ENGINEERING AND MINING SOLUTIONS PRIVATE LIMITED",
"CREATIVE ENGINEERING CONSULTANTS INDIA PRIVATE LIMITED",
"CREATIVE ENGINEERING SERVICES",
"CREATIVE ENGINEERS AND SERVICES PRIVATE LIMITED",
"CREATIVE ENGINEERS PRIVATE LIMITED",
"CREATIVE ENVIRO CONTROL PRIVATE LIMITED",
"CREATIVE EYE LIMITED",
"CREATIVE EYEGLASSES PRIVATE LIMITED",
"CREATIVE FACTOR INTEGRATED MARKETING PRIVATE LIMITED",
"CREATIVE FIBRE PRODUCTS PRIVATE LIMITED",
"CREATIVE FORGE PRIVATE LIMITED",
"CREATIVE FORGINGS PRIVATE LIMITED",
"CREATIVE FORMULATIONS (INDIA) PRIVATE LIMITED",
"CREATIVE FREE TRADE WAREHOUSING PRIVATE LIMITED",
"CREATIVE FRENZY PRIVATE LIMITED",
"CREATIVE GEMS AND JEWELLERY LIMITED",
"CREATIVE GIFTING SOLUTIONS PRIVATE LIMITED",
"CREATIVE GLOBAL BUSINESS LIMITED",
"CREATIVE GLOBAL SERVICES PRIVATE LIMITED",
"CREATIVE GRAINS PRIVATE LIMITED",
"CREATIVE GRAPHICS SOLUTION INDIA PRIVATE LIMITED",
"CREATIVE GRAPHICS SOLUTIONS INDIA LIMITED",
"CREATIVE HEALTH CARE PRIVATE LIMITED",
"CREATIVE HEIGHTS PRIVATE LIMITED",
"CREATIVE HITECH PRIVATE LIMITED",
"CREATIVE HOTELS PRIVATE LIMITED",
"CREATIVE HOUSEKEEPERS PRIVATE LIMITED",
"CREATIVE HOUSEWARES PRIVATE LIMITED",
"CREATIVE HR SOLUTIONS PRIVATE LIMITED",
"CREATIVE IMPRESSIONS",
"CREATIVE INDIA INFRA CONTRACTS PRIVATE LIMITED",
"CREATIVE INDUSTRIES PRIVATE LIMITED",
"CREATIVE INFOCITY LIMITED",
"CREATIVE INFOCOM PRIVATE LIMITED",
"CREATIVE INFOGRAPHICS PRIVATE LIMITED",
"CREATIVE INFO-LINK PRIVATE LIMITED",
"CREATIVE INFOTECH PRIVATE LIMITED",
"CREATIVE INFOTECH SOLUTIONS PRIVATE LIMITED",
"CREATIVE INFRABUILDTECH PRIVATE LIMITED",
"CREATIVE INFRAPOWER PRIVATE LIMITED",
"CREATIVE INNOVATIONS PRIVATE LIMITED",
"CREATIVE INTECH SERVICES PRIVATE LIMITED",
"CREATIVE INTEGRATED SERVICES PRIVATE LIMITED",
"CREATIVE INTERNATIONAL PRIVATE LIMITED",
"CREATIVE IT INDIA PRIVATE LIMITED",
"CREATIVE KIDS EDU SOLUTIONS PRIVATE LIMITED",
"CREATIVE LABELS PRIVATE LIMITED",
"CREATIVE LAND DEALERS PRIVATE LIMITED",
"CREATIVE LIFESTYLE PRIVATE LIMITED.",
"CREATIVE LINE INTERNATIONAL PRIVATE LIMITED",
"CREATIVE LIPI WEBTECH PRIVATE LIMITED",
"CREATIVE M PORTALS PRIVATE LIMITED",
"CREATIVE MANUFACTURING SOLUTIONS INDIA PRIVATE LIMITED",
"CREATIVE MARKETING SOLUTIONS PRIVATE LIMITED",
"CREATIVE MECH AUTOMATION PRIVATE LIMITED",
"CREATIVE MEDIAPULSE TECHNOLOGIES PRIVATE LIMITED",
"CREATIVE MIND CHILD MENTAL HEALTH SOCIETY",
"CREATIVE MINERALS INDIA PRIVATE LIMITED",
"CREATIVE MUSEUM DESIGNERS",
"CREATIVE NETWORKS",
"CREATIVE NEWTECH LIMITED",
"CREATIVE OFFSET PRINTERS PRIVATE LIMITED",
"CREATIVE OZ AIR INDIA PRIVATE LIMITED",
"CREATIVE PAINTS PRIVATE LIMITED",
"CREATIVE PELT PVT LTD",
"CREATIVE PHARMA TECHNOLOGIES PRIVATE LIMITED",
"CREATIVE PLASTIC PACKAGING PRIVATE LIMITED",
"CREATIVE PLASTICS LIMITED",
"CREATIVE PLASTOPACK AND TRADELINK PRIVATE LIMITED",
"CREATIVE POLYFILMS LIMITED.",
"CREATIVE POLYMERS PRIVATE LIMITED",
"CREATIVE POLYPACK PRIVATE LIMITED",
"CREATIVE PORT DEVELOPMENT PRIVATE LIMITED",
"CREATIVE VASTRADO PRIVATE LIMITED",
"CREATIVE POWER ENGINEERS PRIVATE. LIMITED.",
"CREATIVE PRINTERS PVT LTD",
"CREATIVE PROBERS SOFTWARE AND SERVICES INDIA PRIVATE LIMITED",
"CREATIVE PRODUCTS PVT LTD",
"CREATIVE PROJECTS AND CONTRACTS PRIVATE LIMITED",
"CREATIVE PROPACK LIMITED",
"CREATIVE PROPLAST LIMITED",
"CREATIVE PROPTECH PRIVATE LIMITED",
"CREATIVE REALMART PRIVATE LIMITED",
"CREATIVE RESEARCH LABS PRIVATE LIMITED",
"CREATIVE REWARD TECHNOLOGIES PRIVATE LIMITED",
"CREATIVE RUGS",
"CREATIVE SECURITY AND MANAGEMENT SERVICES PRIVATE LIMITED",
"CREATIVE SHADOWS PROMOTION PRIVATE LIMITED",
"CREATIVE SIGN (INDIA) PRIVATE LIMITED",
"CREATIVE SKILLS DIGITAL PRIVATE LIMITED",
"CREATIVE SOLUTIONS PRIVATE LIMITED",
"CREATIVE SQUARE CONSULTANTS PRIVATE LIMITED",
"CREATIVE STYLO PACKS PRIVATE LIMITED",
"CREATIVE SUPPLIERS PRIVATE LIMITED",
"CREATIVE SYNERGIES CONSULTING INDIA PRIVATE LIMITED",
"CREATIVE TANNERY LIMITED",
"CREATIVE TECHAIR PRIVATE LIMITED",
"CREATIVE TECHNO SOLUTIONS PRIVATE LIMITED",
"CREATIVE TECHNOLOGIES",
"CREATIVE TECHNOSOFT SYSTEMS PRIVATE LIMITED",
"CREATIVE TEXTILE MILLS PRIVATE LIMITED",
"CREATIVE THERMOLITE POWER PRIVATE LIMITED",
"CREATIVE TOOLS & PRESS COMPONENTS PRIVATE LIMITED",
"CREATIVE TOOLS AND COMPONENTS INDIA PRIVATE LIMITED",
"CREATIVE TOUGHENED GLASS PRIVATE LIMITED",
"CREATIVE TRADE & EXPORT PVT LTD",
"CREATIVE TRAVEL PRIVATE LIMITED",
"CREATIVE TRENDZ PRIVATE LIMITED",
"CREATIVE TURNKEY PROJECTS PRIVATE LIMITED",
"CREATIVE VALUERS & ENGINEERS PRIVATE LIMITED",
"CREATIVE VINYLS PRIVATE LIMITED",
"CREATIVE VIRTUAL PRIVATE LIMITED",
"CREATIVE WEB SOLUTIONZ",
"CREATIVE WEBMEDIA PRIVATE LIMITED",
"CREATIVEE BLISS",
"CREATIVELAND ADVERTISING PRIVATE LIMITED",
"CREATIVELAND ASIA PRIVATE LIMITED",
"CREATIVELAND DIGITAL TECHNOLOGIES PRIVATE LIMITED",
"CREATIVELAND PRODUCTIONS PRIVATE LIMITED",
"CREATIVELINE COTSPIN PRIVATE LIMITED",
"CREATIVESTOP (INDIA) PRIVATE LIMITED",
"CREATIVEXPERTS CONSULTING PRIVATE LIMITED",
"CREATIVITY AT BEST TECHNOLOGIES LIMITED",
"CREATIVITY AT BEST TECHNOLOGIES PRIVATE LIMITED",
"CREATNET INSTITUTE OF APPLIED MANAGEMENT PRIVATE LIMITED",
"CREATNET SERVICES LIMITED",
"CREATON CORPORATION PRIVATE LIMITED",
"CREATORBOX SOFTWARES PRIVATE LIMITED",
"CREATOROS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"CREATORS ANAESTHESIA ASSOCIATES PRIVATE LIMITED",
"CREATORS ENGINEERS & INTERIORS PRIVATE LIMITED",
"CREATORS MARKETING SOLUTIONS PRIVATE LIMITED",
"CREATORSTACK PRIVATE LIMITED",
"CREAZIONI DEC PRIVATE LIMITED",
"CREBOS ONLINE SOLUTIONS PRIVATE LIMITED",
"CREBRI TECHNOLOGIES PRIVATE LIMITED",
"CRECENT GARMENTS PRIVATE LIMITED",
"CRECER HEALTHCARE LLP",
"CRECER TECHNOLOGIES PRIVATE LIMITED",
"CRECIENTE DIRECT PRIVATE LIMITED",
"CRECIENTECH INFOSYSTEM PRIVATE LIMITED",
"CRED FOODS PRIVATE LIMITED",
"CREDAI - AHMEDABAD",
"CREDAI BENGAL",
"CREDAI VADODARA",
"CREDAPP SOFTWARE PRIVATE LIMITED",
"CREDBERG ADVISORS INDIA PRIVATE LIMITED",
"CREDENCA DATA SOLUTIONS PRIVATE LIMITED",
"CREDENCE ACOUSTICS & CEILINGS PRIVATE LIMITED",
"CREDENCE ANALYTICS",
"CREDENCE CHEM PRIVATE LIMITED",
"CREDENCE COMMERCE INDUSTRIES PRIVATE LIMITED",
"CREDENCE ENGINEERS PVT LTD",
"CREDENCE ENTERPRISES PRIVATE LIMITED",
"CREDENCE FAMILY OFFICE LLP",
"CREDENCE FAMILY OFFICE PRIVATE LIMITED",
"CREDENCE FORMULATIONS PRIVATE LIMITED",
"CREDENCE GATE INDIA PRIVATE LIMITED",
"CREDENCE HOSPITAL PRIVATE LIMITED",
"CREDENCE INTEGRATED MARKETING PRIVATE LIMITED",
"CREDENCE INTERIOR PRIVATE LIMITED",
"CREDENCE MEDIA SOLUTIONS PRIVATE LIMITED",
"CREDENCE PROPERTY DEVELOPERS PRIVATE LIMITED",
"CREDENCE PROSTHETIC INDIA PRIVATE LIMITED",
"CREDENCE RESOURCE MANAGEMENT PRIVATE LIMITED",
"CREDENCE SECURITY SERVICES AND HOUSEKEEPING SOLUTIONS (OPC) PRIVATE LIMITED",
"CREDENCE WHOLE FOODS PRIVATE LIMITED",
"CREDENCYS SOLUTIONS PRIVATE LIMITED",
"CREDENT ASSET MANAGEMENT SERVICES PRIVATE LIMITED",
"CREDENT COLD CHAIN LOGISTICS PRIVATE LIMITED",
"CREDENT GLOBAL FINANCE LIMITED",
"CREDENT INFRA-TECH SOLUTIONS PRIVATE LIMITED",
"CREDENT INVESTMENT PRIVATE LIMITED",
"CREDENT MANAGEMENTS & CONSULTANTS PRIVATE LIMITED",
"CREDENTEK SOFTWARE & CONSULTANCY PRIVATE LIMITED",
"CREDENTIAL EQUITIES PRIVATE LIMITED",
"CREDEX TECHNOLOGY PRIVATE LIMITED",
"CREDFORCE ASIA LIMITED",
"CREDIBLE CAPITAL SERVICES PRIVATE LIMITED",
"CREDIBLE ENGINEERING CONSTRUCTION PROJECTS LIMITED",
"CREDIBLE HEALTH CARE PRIVATE LIMITED",
"CREDIBLE KNITTING INDIA PRIVATE LIMITED",
"CREDIBLE MANAGEMENT AND CONSULTANTS PRIVATE LIMITED",
"CREDIBLE NIVESH LIMITED",
"CREDIFY ADVISORY SERVICES PRIVATE LIMITED",
"CREDIFY TECHNOLOGIES PRIVATE LIMITED",
"CREDIT AGRICOLE CIB SERVICES PRIVATE LIMITED",
"CREDIT AGRICOLE CORPORATE AND INVESTMENT BANK",
"CREDIT ALLIANCE SERVICES PRIVATE LIMITED",
"CREDIT CONSULTANTS PRIVATE LIMITED",
"CREDIT GATE PRIVATE LIMITED",
"CREDIT HELP INDIA SERVICES PRIVATE LIMITED",
"CREDIT INDUSTRIAL ET COMMERCIAL",
"CREDIT ONE",
"CREDIT ONE PAYMENT SOLUTIONS PRIVATE LIMITED",
"CREDIT SUDHAAR FINANCE PRIVATE LIMITED",
"CREDIT SUDHAAR SERVICES PRIVATE LIMITED",
"CREDIT WISE CAPITAL PRIVATE LIMITED",
"CREDITACCESS GRAMEEN LIMITED",
"CREDITAS SOLUTIONS PRIVATE LIMITED",
"CREDITCHECK PARTNERS PRIVATE LIMITED",
"CREDITLINE SOLUTIONS PRIVATE LIMITED",
"CREDITMANTRI FINSERVE PRIVATE LIMITED",
"CREDITRON SERVICES PRIVATE LIMITED",
"CREDITSAFE TECHNOLOGY PRIVATE LIMITED",
"CREDIWATCH INFORMATION ANALYTICS PRIVATE LIMITED",
"CREDO ADVANCED CHEMICALS LIMITED",
"CREDO ASSETS PRIVATE LIMITED",
"CREDO BRANDS MARKETING LIMITED",
"CREDO BRANDS MARKETING PRIVATE LIMITED",
"CREDO INDIA SOFTECH PRIVATE LIMITED",
"CREDO INFRAPROJECTS PRIVATE LIMITED",
"CREDO LIFE SCIENCES PRIVATE LIMITED",
"CREDO MINERAL INDUSTRIES LIMITED",
"CREDO PHARMA PRIVATE LIMITED",
"CREDO TRANS SERVICES PRIVATE LIMITED",
"CREDO-TECH INDIA PRIVATE LIMITED",
"CREDWYN HOLDINGS (INDIA)PVT LTD",
"CREED ENGINEERS PRIVATE LIMITED",
"CREED INFOTECH PRIVATE LIMITED",
"CREELOTEX ENGINEERS PVT LTD",
"CREEMOS INTERNATIONAL LIMITED",
"CREENCIA TECHNOLOGIES PRIVATE LIMITED",
"CREINTORS AUTOMATION SOLUTIONS PRIVATE LIMITED",
"CREINTORS ENVIRONMENTAL SOLUTIONS PRIVATE LIMITED",
"CREINTORS TEKNOSOL PRIVATE LIMITED",
"CREKK INGENIOUS SOLUTIONS PRIVATE LIMITED",
"CRELIANT SOFTWARE PRIVATE LIMITED",
"CREMAX CONVERTORS PRIVATE LIMITED",
"CREMBERIE FOODS PRIVATE LIMITED",
"CREMEUX BAKERIES PRIVATE LIMITED",
"CREMICA AGRO FOODS LIMITED",
"CREMICA FOOD INDUSTRIES LIMITED",
"CREMICA FOOD PARK PRIVATE LIMITED",
"CRENNOVATIONS 3D TECHNOLOGIES PRIVATE LIMITED",
"CRENNOVATIVE POWERTECH PRIVATE LIMITED",
"CRENOVA PLATING PRIVATE LIMITED",
"CRENSPIRE TECHNOLOGIES",
"CRENZA PHARMACEUTICALS PRIVATE LIMITED",
"CREO CONCEPTS PRIVATE LIMITED",
"CREO DEVELOPERS PRIVATE LIMITED",
"CREO LIFTSTYLES PRIVATE LIMITED",
"CREO SALES INDIA PRIVATE LIMITED",
"CREOSPAN SOLUTIONS PRIVATE LIMITED",
"CRES INTEGRATED SERVICES PRIVATE LIMITED",
"CRESC DATASOFT PRIVATE LIMITED",
"CRESCENDO CLOTHING PRIVATE LIMITED",
"CRESCENDO GLOBAL LEADERSHIP HIRING INDIA PRIVATE LIMITED",
"CRESCENDO LOGISTICS AND SHIPPING SOLUTIONS PRIVATE LIMITED",
"CRESCENDO TRADING PRIVATE LIMITED",
"CRESCENDO TRANSCRIPTION PRIVATE LIMITED",
"CRESCENDO WORLDWIDE PRIVATE LIMITED",
"CRESCENT AUTO REPAIRS AND SERVICES INDIA PRIVATE LIMITED",
"CRESCENT BIOFORMULATIONS PRIVATE LIMITED",
"CRESCENT COLD STORAGE PRIVATE LIMITED",
"CRESCENT COMMERCE PVT LTD",
"CRESCENT COMMUNICATIONS PRIVATE LIMITED",
"CRESCENT CONTRACTORS PRIVATE LIMITED",
"CRESCENT CRUMBS PRIVATE LIMITED",
"CRESCENT DIAMONDS EXIM PRIVATE LIMITED",
"CRESCENT DOTS-N-LINES PRIVATE LIMITED",
"CRESCENT FINANCIAL SERVICES PRIVATE LIMITED",
"CRESCENT FORMULATIONS PRIVATE LIMITED",
"CRESCENT FOUNDRY COMPANY PVT LTD",
"CRESCENT HOSPITAL",
"CRESCENT INNOVATION AND INCUBATION COUNCIL",
"CRESCENT INNOVATIVE PACKAGING PRIVATE LIMITED",
"CRESCENT INSTITUTE OF SCIENCE & TECHNOLOGY",
"CRESCENT JUTE CO. PRIVATE LIMITED",
"CRESCENT LABS PRIVATE LIMITED",
"CRESCENT LIFE SCIENCES PRIVATE LIMITED",
"CRESCENT MALL MANAGEMENT PVT LTD",
"CRESCENT MANAGEMENT SERVICES PRIVATE LIMITED",
"CRESCENT MANUFACTURING PVT LTD",
"CRESCENT MATRICULATION HIGHER SECONDARY SCHOOL FOR GIRLS",
"CRESCENT MATRICULATION SCHOOL",
"CRESCENT MEDICAL CENTRE LIMITED",
"CRESCENT OPTO PRIVATE LIMITED",
"CRESCENT ORGANICS PRIVATE LIMITED",
"CRESCENT PETROCHEM PRIVATE LIMITED",
"CRESCENT POWER LIMITED",
"CRESCENT PPG LINING PRIVATE LIMITED",
"CRESCENT REFRIGERATION PRIVATE LIMITED",
"CRESCENT RESORTS PRIVATE LIMITED",
"CRESCENT ROADWAYS PRIVATE LIMITED",
"CRESCENT SCIENTIFIC PRIVATE LIMITED",
"CRESCENT SHIPPING AGENCY INDIA LIMITED",
"CRESCENT SOLUTIONS PRIVATE LIMITED",
"CRESCENT SPA AND RESORTS INDORE PRIVATE LIMITED",
"CRESCENT TANNERS PRIVATE. LIMITED.",
"CRESCENT TAX COMPLIANCE PRIVATE LIMITED",
"CRESCENT TECHNO SOLUTIONS PRIVATE LIMITED",
"CRESCENT TECHNOLOGIES PRIVATE LIMITED",
"CRESCENT VALVES INTERNATIONAL PRIVATE LIMITED",
"CRESCENT VALVES MANUFACTURING COMPANY PRIVATE LIMITED",
"CRESCENT VENTURES PRIVATE LIMITED",
"CRESCENZA CONSULTING PRIVATE LIMITED",
"CRESCENZIA WELLNESS PRIVATE LIMITED",
"CRESCENZO FINANCIAL ADVISORY PRIVATE LIMITED",
"CRESCERANCE INDIA PRIVATE LIMITED",
"CRESCERE TECHNOLOGIES PRIVATE LIMITED",
"CRESCITA GLOBAL PRIVATE LIMITED",
"CRESCO AGRIBUSINESS PRIVATE LIMITED",
"CRESCO FUTURES LIMITED",
"CRESCO MANAGEMENT PRIVATE LIMITED",
"CRESCO RESEARCH SOLUTIONS PRIVATE LIMITED",
"CRESCOHR PRIVATE LIMITED",
"CRESCON PROJECTS AND SERVICES PRIVATE LIMITED",
"CRESCORE WEALTH MANAGEMENT SERVICES PRIVATE LIMITED",
"CRESENT ENGINEERING COLLEGE",
"CRESHYA TECHNOLOGIES PRIVATE LIMITED",
"CRESMAC FOUNDRY PRIVATE LIMITED",
"CRESSANDA SOLUTIONS LIMITED",
"CRESSCENT INDUSTRIES & ALLIED SERVICES (INDIA) PRIVATE LIMITED",
"CRESSET CONNECTIVITY PRIVATE LIMITED",
"CREST CAPITAL AND INVESTMENT PRIVATE LIMITED",
"CREST CAPITAL GROUP PRIVATE LIMITED",
"CREST CELLULOSE PRIVATE LIMITED",
"CREST COMMERCIAL PROJECTS (INDIA) PRIVATE LIMITED",
"CREST COMPOSITES AND PLASTICS PRIVATE LIMITED",
"CREST CONTAINER LINES PRIVATE LIMITED",
"CREST DATA SYSTEMS PRIVATE LIMITED",
"CREST DESIGN PRIVATE LIMTED",
"CREST DIGITEL PRIVATE LIMITED",
"CREST ENGINEERS PRIVATE LTD.",
"CREST FINSERV LIMITED",
"CREST HYGIENE PRIVATE LIMITED",
"CREST INFOSYSTEMS PRIVATE LIMITED",
"CREST INFRACON PRIVATE LIMITED",
"CREST INTEGRATORS PRIVATE LIMITED",
"CREST IT CONSULTING PRIVATE LIMITED",
"CREST LASHING AND PACKAGING PRIVATE LIMITED",
"CREST LIFESCIENCES PRIVATE LIMITED",
"CREST LOGISTICS & ENGINEERS PRIVATE LIMITED",
"CREST MERCHANDISE PVT LTD",
"CREST PRECISION SCREWS PRIVATE LIMITED",
"CREST PROMOTERS PRIVATE LIMITED",
"CREST SPECIALITY RESINS PRIVATE LIMITED",
"CREST STEEL AND POWER PRIVATE LIMITED",
"CREST SUITES PRIVATE LIMITED",
"CREST TEST SYSTEMS PRIVATE LIMITED",
"CREST TOPICALS PRIVATE LIMITED",
"CREST ULTRASONICS INDIA PRIVATE LIMITED",
"CREST VENTURES LIMITED",
"CREST VENUE AND ENTERTAINMENT SOFTWARE PRIVATE LIMITED",
"CRESTAEROSPACE TECHNOLOGIES PRIVATE LIMITED",
"CRESTCHEM LIMITED",
"CRESTEC DIGITAL SOLUTION INDIA PRIVATE LIMITED",
"CRESTECH SOFTWARE SYSTEMS PRIVATE LIMITED",
"CRESTIA POLYTECH PRIVATE LIMITED",
"CRESTOKART PRIVATE LIMITED",
"CRESTONE CONSTRUCTIONS PRIVATE LIMITED",
"CRESTRA COMMUNICATION PRIVATE LIMITED",
"CRESTRON ELECTRONICS INDIA PRIVATE LIMITED",
"CRESTRON SOFTWARE DEVELOPMENT INDIA PRIVATE LIMITED",
"CRESTT INNOTECH PRIVATE LIMITED",
"CRESTTEK ENGINEERING SOLUTIONS PRIVATE LIMITED",
"CRESTWORTH MANAGEMENT PARTNERS PRIVATE LIMITED",
"CRETEK ENGINEERING PRIVATE LIMITED",
"CRETESTONE PRIVATE LIMITED",
"CREVITA GRANITO PRIVATE LIMITED",
"CREW 4 EVENTS GLOBAL PRIVATE LIMITED",
"CREW AUTOMATION & ELECTRICAL PRIVATE LIMITED",
"CREW PETRO PRIVATE LIMITED",
"CREWKARMA NETWORKS PRIVATE LIMITED",
"CREWMAN SOLUTION PRIVATE LIMITED",
"CREWODIAA AND HOSPITALITY PRIVATE LIMITED",
"CREYA LEARNING AND RESEARCH PRIVATE LIMITED",
"CREZZA DESIGNS PRIVATE LIMITED",
"CRG COTEX PRIVATE LIMITED",
"CRG INDUSTRIES PRIVATE LIMITED",
"CRG SOFTWARE INDIA PRIVATE LIMITED",
"CRG SOLUTIONS PRIVATE LIMITED",
"CRH INDIA MANAGEMENT SERVICES PRIVATE LIMITED",
"CRI EVENTS PRIVATE LIMITED",
"CRI LTD",
"CRI ROADWAYS PRIVATE LIMITED",
"CRIADOR DESIGN LABS PRIVATE LIMITED",
"CRICCLUBS INDIA PRIVATE LIMITED",
"CRICHQ INDIA PRIVATE LIMITED",
"CRICINFO ONLINE INDIA PRIVATE LIMITED",
"CRICKET ACADEMY OF PATHANS PRIVATE LIMITED",
"CRICTRACKER PRIVATE LIMITED",
"CRIF HIGH MARK CREDIT INFORMATION SERVICES PRIVATE LIMITED",
"CRIF SOLUTIONS PRIVATE LIMITED",
"CRIJAF - CENTRAL RESEARCH INSTITUTE FOR JUTE AND ALLIED FIBRE",
"CRIKEY BUSINESS INDIA PRIVATE LIMITED",
"CRILLION FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"CRIMSON ANISHA GLOBAL SCHOOL",
"CRIMSON COMMODITY LIMITED",
"CRIMSON EDUCATION MANAGEMENT SERVICES PRIVATE LIMITED",
"CRIMSON ENERGY EXPERTS PRIVATE LIMITED",
"CRIMSON FINANCIAL SERVICES PRIVATE LIMITED",
"CRIMSON INKS PRIVATE LIMITED",
"CRIMSON INTERACTIVE PRIVATE LIMITED",
"CRIMSON LOGISTICS PRIVATE LIMITED",
"CRIMSON OIL TOOLS PRIVATE LIMITED",
"CRIMSON PAINTS PVT LTD",
"CRIMSON PRINT PACK PRIVATE LIMITED",
"CRIMSON PROPERTY PRIVATE LIMITED",
"CRIMSON SUPPLY CHAIN CONSULTING PRIVATE LIMITED",
"CRIMSON UNI QUEPACK PRIVATE LIMITED",
"CRIMSON WORLD SCHOOL",
"CRIMSONLOGIC INDIA PRIVATE LIMITED",
"CRIMSONLOGIC IT SOLUTIONS PRIVATE LIMITED",
"CRIMSONWAVE PRIVATE LIMITED",
"CRIMSUN ORGANICS PRIVATE LIMITED",
"CRIMZON FASHION ACCESSORIES PRIVATE LIMITED",
"CRINNJAL EXPORTS PRIVATE LIMITED",
"CRINOVA HEALTHCARE PRIVATE LIMITED",
"CRIS PHARMA INDIA LIMITED",
"CRISANA SYNTHETICS PRIVATE LIMITED",
"CRISCO FOODS PRIVATE LIMITED",
"CRISH CREATIONS PRIVATE LIMITED",
"CRISH HEALTHCARE PRIVATE LIMITED",
"CRISH METAL WORKS PRIVATE LIMITED",
"CRISIL LIMITED",
"CRISIL RATINGS LIMITED",
"CRISIL RISK AND INFRASTRUCTURE SOLUTIONS LIMITED",
"CRISKA BUSINESS CONSULTING PRIVATE LIMITED",
"CRISP ANALYTICS PRIVATE LIMITED",
"CRISP MULTIMEDIA SOLUTIONS PRIVATE LIMITED",
"CRISS CROSS LOGISTICS PRIVATE LIMITED",
"CRISS FINANCIAL LIMITED",
"CRIST COLLEGE",
"CRISTAL PHARMA PRIVATE LIMITED",
"CRISTALINE TELE SERVICES PRIVATE LIMITED",
"CRISTIAN SERVICE AGENCY",
"CRITERION EDGE INDIA PRIVATE LIMITED",
"CRITERION NETWORKS INDIA PRIVATE LIMITED",
"CRITERIONSCREENERS GLOBAL PRIVATE LIMITED",
"CRITERIUM CLINICAL RESEARCH INDIA PRIVATE LIMITED",
"CRITICAL ACCESS HEALTH SERVICES & RESEARCH CENTER PRIVATE LIMITED",
"CRITICAL CARE HOSPITAL & RESEARCH INSTITUTE",
"CRITICAL CARE UNIFIED PRIVATE LIMITED",
"CRITICAL MENTION INDIA PRIVATE LIMITED",
"CRITICALOG INDIA PRIVATE LIMITED",
"CRITICALRIVER TECHNOLOGIES PRIVATE LIMITED",
"CRITICALX ESPORTS PRIVATE LIMITED",
"CRITICARE ASIA MULTISPECIALITY HOSPITAL & RESEARCH CENTER",
"CRITICARE MEDISOLUTIONS PRIVATE LIMITED",
"CRITICARE SCAN CENTRE PRIVATE LIMITED",
"CRITIQUE COMMUNICATION PRIVATE LIMITED",
"CRIUS LIFE SCIENCES PRIVATE LIMITED",
"CRIVERA TECHNOLOGIES PRIVATE LIMITED",
"CRIYAGEN AGRI AND BIOTECH PRIVATE LIMITED",
"CRIZAC LIMITED",
"CRIZAC TECHNOLOGIES PRIVATE LIMITED",
"CRIZOL LUBRICANTS PRIVATE LIMITED",
"CRL DIAGNOSTICS PRIVATE LIMITED",
"CRL INTERIOR AND FIT OUT PRIVATE LIMITED",
"CRL TERMINALS PRIVATE LIMITED",
"CRM AUDIO VIDEO PRIVATE LIMITED",
"CRM DIGITAL SYNERGIES PRIVATE LIMITED",
"CRM ENTERPRISES PRIVATE LIMITED",
"CRM HOLDINGS PRIVATE LIMITED",
"CRM INFOTEK INDIA PRIVATE LIMITED",
"CRM ISPAT PRIVATE LIMITED",
"CRM LOANMONEY SERVICES PRIVATE LIMITED",
"CRM SERVICES INDIA PRIVATE LIMITED",
"CRMIT SOLUTIONS PRIVATE LIMITED",
"CRO SPLENDID LAB PRIVATE LIMITED",
"CROCKSY SECURITAS PRIVATE LIMITED",
"CROCKY TECHNOLOGIES PRIVATE LIMITED",
"CROCODILE PRODUCTS PRIVATE LIMITED",
"CROCON TECHNOLOGIES PRIVATE LIMITED",
"CROCS INDIA PRIVATE LIMITED",
"CROCUS TECHNOLOGIES PRIVATE LIMITED",
"CRODA INDIA COMPANY PRIVATE LIMITED",
"CROFCLOUD ONSALE LANDING PRIVATE LIMITED",
"CROFORD HEALTHCARE PRIVATE LIMITED",
"CROIENT PHARMA PRIVATE LIMITED",
"CROISSANCE & APPROFONDIMENT CONSULTANCY (OPC) PRIVATE LIMITED",
"CROISSANCE CLINICAL RESEARCH PRIVATE LIMITED",
"CROISSANCE PROJECTS PRIVATE LIMITED",
"CROMA CAMPUS",
"CROMA CERAMIC PRIVATE LIMITED",
"CROMA LIFESCIENCE PRIVATE LIMITED",
"CROMA PLAST PRIVATE LIMITED",
"CROMLUX ENGINEERS PVT LTD",
"CROMPTECH INTEGRATED SOLUTIONS PRIVATE LIMITED",
"CROMPTON CSR FOUNDATION",
"CROMPTON GREAVES CONSUMER ELECTRICALS LIMITED",
"CROMPTON GREAVES LIMITED",
"CROMWELL INDUSTRIAL SUPPLIES PRIVATE LIMITED",
"CRON INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"CRON SYSTEMS PRIVATE LIMITED",
"CRONA ROLLING MILLS PRIVATE LIMITED",
"CRONIES PHARMA & BIO-SCIENCES PRIVATE LIMITED",
"CRONJ IT TECHNOLOGIES PRIVATE LIMITED",
"CRONUS PHARMA SPECIALITIES INDIA PRIVATE LIMITED",
"CRONUS RESEARCH LABS PRIVATE LIMITED",
"CRONY DESIGN PRIVATE LIMITED",
"CRONY VYAPAR PRIVATE LIMITED",
"CRONZ METAL INDUSTRIES PRIVATE LIMITED",
"CROP CARE FEDERATION OF INDIA",
"CROP CARE PESTICIDES (INDIA) PRIVATE LIMITED",
"CROP CHEMICALS INDIA LIMITED",
"CROP GROWTH (INDIA) PRIVATE LIMITED",
"CROP INDIA AGRO PRIVATE LIMITED",
"CROP LIFE SCIENCE LIMITED",
"CROP ORGANICS PRIVATE LIMITED",
"CROPAC TECHNOLOGY PRIVATE LIMITED",
"CROPBASKET AGRO INNOVATIONS PRIVATE LIMITED",
"CROPBERRY FOODS PRIVATE LIMITED",
"CROPEL INTERNATIONAL PRIVATE LIMITED",
"CROPEL LIFESCIENCES PRIVATE LIMITED",
"CROPEX LIMITED",
"CROPIN TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"CROPISOL ORGANICS PRIVATE LIMITED",
"CROPLAN BIOSCIENCES PRIVATE LIMITED",
"CROPLAND CONDIMENTS PRIVATE LIMITED",
"CROPLIFE INDIA",
"CROPNOSYS INDIA PRIVATE LIMITED",
"CROPRISE AGROCHEM LIMITED",
"CROPSAFE PESTICIDES INDIA PRIVATE LIMITED",
"CROPSARO INDIA PRIVATE LIMITED",
"CROPSCARE INFOTECH PRIVATE LIMITED",
"CROPSLY SOLUTIONS PRIVATE LIMITED",
"CROPWELL SEEDS PRIVATE LIMITED",
"CROPX OVERSEAS PRIVATE LIMITED",
"CROSBY TEXTOR INDIA PRIVATE LIMITED",
"CROSFIELD TEXTILE CHEMICALS (INDIA) PRIVATE LIMITED",
"CROSS BORDER POWER TRANSMISSION COMPANY LIMITED",
"CROSS BOW DESIGN PRIVATE LIMITED",
"CROSS COUNTRY CONTRACTORS PRIVATE LIMITED",
"CROSS COUNTRY INFOTECH PRIVATE LIMITED",
"CROSS GLOBE RESTAURANTS PRIVATE LIMITED",
"CROSS LOOPS LAMINOFAB PRIVATE LIMITED",
"CROSS MATRIX TECHNOLOGIES PRIVATE LIMITED",
"CROSS OCEAN ENTERPRISES PVT LTD",
"CROSS ROAD BUILDCON PRIVATE LIMITED",
"CROSS ROADS INDIA ASSISTANCE PRIVATE. LIMITED",
"CROSS SECTION INTERACTIVE PRIVATE LIMITED",
"CROSS SECTON INTRECTIVE PRIVATE LIMITED",
"CROSS TAB MARKETING SERVICES PRIVATE LIMITED",
"CROSS TRADELINK PRIVATE LIMITED",
"CROSS WHEELS AUTO PRIVATE LIMITED",
"CROSS WINDS RESIDENCY PRIVATE LIMITED",
"CROSS WIRE EXPORTS PRIVATE LIMITED",
"CROSS WORLD IMPORTS & EXPORTS",
"CROSSASYST INFOTECH PRIVATE LIMITED",
"CROSSASYST TECHNOLOGIES PRIVATE LIMITED",
"CROSSBORDER COMMERCE PRIVATE LIMITED",
"CROSSBORDER LOGISTECH PRIVATE LIMITED",
"CROSSBOW LABS LLP",
"CROSSBOW POWER PRIVATE LIMITED",
"CROSSBRIDGE TRADING PRIVATE LIMITED",
"CROSSCHECK TECHNOLOGY SERVICES PRIVATE LIMITED",
"CROSSCRAFT PRIVATE LIMITED",
"CROSSDEV TECHNOLOGIES PRIVATE LIMITED",
"CROSSDOMAIN SOLUTIONS PRIVATE LIMITED",
"CROSSEAS CAPITAL SERVICES PRIVATE LIMITED",
"CROSSFIELDS WATER PURIFIERS PRIVATE LIMITED",
"CROSSFIRE MANAGEMENT SERVICES PRIVATE LIMITED",
"CROSSGATES ENTERPRISES LLP",
"CROSSHAIRS COMMUNICATION PRIVATE LIMITED",
"CROSSINGS INFRASTURCTURE PRIVATE LIMITED",
"CROSSLAND CARS PRIVATE LIMITED",
"CROSSLAND EQUIPCO PRIVATE LIMITED",
"CROSSLAND GRANITES PRIVATE LIMITED",
"CROSSLAND JAICARS PRIVATE LIMITED",
"CROSSLAY REMEDIES LIMITED",
"CROSSLINE SERVICES PRIVATE LIMITED",
"CROSSLINK WHEELS ELECTRONIC PRIVATE LIMITED",
"CROSSLITE INFRA PRIVATE LIMITED",
"CROSSLYNX TECHNOLOGIES SERVICES PRIVATE LIMITED",
"CROSSNET PRODUCTS PRIVATE LIMITED",
"CROSSOVER FOODS PRIVATE LIMITED",
"CROSSPAY TECHNOLOGIES PRIVATE LIMITED",
"CROSSPEAK PRIVATE LIMITED",
"CROSSPOLE LOGISTICS PRIVATE LIMITED",
"CROSSROAD FREIGHT PRIVATE LIMITED",
"CROSSROADS CLOTHING PRIVATE LIMITED",
"CROSSROADS HOSPITAL PRIVATE LIMITED",
"CROSSTAB IT CONSULTING PRIVATE LIMITED",
"CROSSWAY DISTRIBUTORS PRIVATE LIMITED",
"CROSSWAY LOGISTICS PRIVATE LIMITED",
"CROSSWAYS FOODS PRIVATE LIMITED",
"CROSSWAYS VERTICAL SOLUTIONS LIMITED",
"CROSSWORD BOOKSTORES LIMITED",
"CROSSWORD BOOKSTORES PRIVATE LIMITED",
"CROSSWORLD EQUIPMENTS COMPANY PRIVATE LIMITED",
"CROSSWORLD FREIGHT SYSTEMS PRIVATE LIMITED",
"CROSTA PANELS",
"CROTUS TECHNOLOGIES PRIVATE LIMITED",
"CROWDERA VENTURES PRIVATE LIMITED",
"CROWDNETIC TECHNOLOGIES PRIVATE LIMITED",
"CROWDSOURCE TECHNOLOGIES PRIVATE LIMITED",
"CROWDSTRIKE INDIA PRIVATE LIMITED",
"CROWE BODA AND COMPANY PRIVATE LIMITED",
"CROWE HORWATH HTL CONSULTANTS PRIVATE LIMITED",
"CROWE HORWATH IT SERVICES LLP",
"CROWLEYACCORD MARINE MANAGEMENT PRIVATE LIMITED",
"CROWN AGENTS INSPECTIONS PRIVATE LIMITED",
"CROWN BEERS INDIA PRIVATE LIMITED",
"CROWN BIKES PRIVATE LIMITED",
"CROWN BUILDTECH PRIVATE LIMITED",
"CROWN CASHEW IMPEX PRIVATE LIMITED",
"CROWN CHEMICALS PRIVATE LIMITED",
"CROWN CLOSURES PRIVATE LIMITED",
"CROWN CLOTHING PRIVATE LIMITED",
"CROWN CONSULTANTS PRIVATE LIMITED",
"CROWN CORRUGATORS PRIVATE LIMITED",
"CROWN COURIER PRIVATE LIMITED",
"CROWN CRAFT (INDIA) PRIVATE LIMITED",
"CROWN CROPS SCIENCE PRIVATE LIMITED",
"CROWN DECOR PRIVATE LIMITED",
"CROWN DECORS MANAGEMENT PRIVATE LIMITED",
"CROWN ELECTROMECHANICAL PRIVATE LIMITED",
"CROWN ENGINEERING ENTERPRISES",
"CROWN ENTERPRISES PRIVATE LIMITED",
"CROWN EXTRUSIONS PRIVATE LIMITED",
"CROWN FAB MILLS PRIVATE LIMITED",
"CROWN FABRICS AND LACE HOUSE PRIVATE LIMITED",
"CROWN FERRO ALLOYS PRIVATE LIMITED",
"CROWN FLAKES PRIVATE LIMITED",
"CROWN FOREX INDIA PRIVATE LIMITED",
"CROWN GASKETS PRIVATE LIMITED",
"CROWN GLOBAL TRADING PRIVATE LIMITED",
"CROWN GRIP PUMPS PRIVATE LIMITED",
"CROWN HEALTHCARE LIMITED",
"CROWN HOLDINGS INC.",
"CROWN HOME ENGINEERS PRIVATE LIMITED",
"CROWN LIFTERS LIMITED",
"CROWN METAL INDUSTRIES PRIVATE LIMITED",
"CROWN METALS PRIVATE LIMITED",
"CROWN MILK SPECIALITIES PRIVATE LIMITED",
"CROWN PLAZA PUNECITY HOTEL",
"CROWN POLYPACKS PRIVATE LIMITED",
"CROWN PROPBUILD PRIVATE LIMITED",
"CROWN SEALS PRIVATE LIMITED",
"CROWN SOLUTIONS INDIA PRIVATE LIMITED",
"CROWN SYNTHETICS PRIVATE LIMITED",
"CROWN TAPES PRIVATE LIMITED",
"CROWN TECHNOLOGIES PRIVATE LIMITED",
"CROWN TIMBER & FOODS PVT LTD",
"CROWN VETERINARY SERVICES PRIVATE LIMITED",
"CROWN VETERNIRY SERVICES PRIVATE LIMITED",
"CROWN VILLA AND DEVELOPERS PRIVATE LIMITED",
"CROWN WORLDWIDE MOVERS PRIVATE LIMITED",
"CROWN32 DENTAL DESIGN SOLUTIONS PRIVATE LIMITED",
"CROWNE PLAZA A UNIT OF AKRITI HOTEL PRIVATE LIMITED",
"CROWNE PLAZA AHMEDABAD UNIT OF SHIVA SATYA HOTELS PVT LTD",
"CROWNE PLAZA HOTEL",
"CROWNSTACK TECHNOLOGIES PRIVATE LIMITED",
"CROWNTECH SURFACE TREATMENT PRIVATE LIMITED",
"CROX CONSULTING PRIVATE LIMITED",
"CROX OIL & GAS PRIVATE LIMITED",
"CROXLEY DISTRIBUTORS PRIVATE LIMITED",
"CROYANCE QUALITY SERVICES PRIVATE LIMITED",
"CROYEZ IMMIGRATION SERVICE PRIVATE LIMITED",
"CRP INFRASTRUCTURE PRIVATE LIMITED",
"CRP RISK MANAGEMENT LIMITED",
"CRPF PUBLIC SCHOOL ROHINI",
"CRPINDIA PRIVATE LIMITED",
"CRPL INFRA PRIVATE LIMITED",
"CRRC INDIA PRIVATE LIMITED",
"CRRP INFRASTRUCTURE PRIVATE LIMITED",
"CRS CHIT FUND INDIA PRIVATE LIMITED",
"CRS GLOBAL SERVICES PRIVATE LIMITED",
"CRS HEALTH & FITNESS PRIVATE LIMITED",
"CRS TOWERS PRIVATE LIMITED",
"CRT SERVICES PRIVATE LIMITED",
"CRU ANALYSIS AND CONSULTING (INDIA) PRIVATE LIMITED",
"CRUISE APPLIANCES PRIVATE LIMITED",
"CRUISE SHIPS CATERING AND SERVICES INTERNATIONAL N V",
"CRUISER MOTORS PRIVATE LIMITED",
"CRUM & FORSTER SERVICES INDIA PRIVATE LIMITED",
"CRUMBS & CAKES GOURMET PRIVATE LIMITED",
"CRUNCHY MEDIA PRIVATE LIMITED",
"CRUPP BOILERS (INDIA) PRIVATE LIMITED",
"CRUSHTECH MESH PRIVATE LIMITED",
"CRUSO GRANITO PRIVATE LIMITED",
"CRUST CONCEPT MARKETING PRIVATE LIMITED",
"CRUST MINECHEM PRIVATE LIMITED",
"CRUST N CRUMB FOOD INGREDIENTS PRIVATE LIMITED",
"CRUST 'N' CRUMB FOOD INNOVATIONS INDIA LIMITED",
"CRUSTO INNOVATIONS PRIVATE LIMITED",
"CRUTHI CONSULTANTS CONSORTIUM PRIVATE LIMITED",
"CRUX BIOTECH INDIA PRIVATE LIMITED",
"CRUX COMPUTRONIX PRIVATE LIMITED",
"CRUX CREATIVE SOLUTIONS PRIVATE LIMITED",
"CRUX DIGITAL PRIVATE LIMITED",
"CRUX MANAGEMENT SERVICES PRIVATE LIMITED",
"CRUX MOBILITY PRIVATE LIMITED",
"CRUX POWER PRIVATE LIMITED",
"CRUX PRESTRESSING SYSTEMS PRIVATE LIMITED",
"CRUXWELD INDUSTRIAL EQUIPMENTS PRIVATE LIMITED",
"CRUZ AUDIO VISUALS PRIVATE LIMITED",
"CRUZE WATER TECH PRIVATE LIMITED",
"CRVJ INVESTMENT SERVICES PRIVATE LIMITED",
"CRYO GAS MOVERS (INDIA) PRIVATE LIMITED",
"CRYO STEMCELL PRIVATE LIMITED",
"CRYOBANKS INTERNATIONAL",
"CRYOGAS AIR PRODUCTS INDIA PRIVATE LIMITED",
"CRYOGAS EQUIPMENT PRIVATE LIMITED",
"CRYOGEN INSTRUMENTS INDIA PRIVATE LIMITED",
"CRYOGENIC CONCERN PRIVATE LIMITED",
"CRYOGENIC FIRE SECURITY SERVICES PRIVATE LIMITED",
"CRYOGENIC FOOD PROCESSING PRIVATE LIMITED",
"CRYOLITE INDIA SOFTWARES PRIVATE LIMITED",
"CRYOLOR ASIA PACIFIC PRIVATE LIMITED",
"CRYO-SCIENTIFIC SYSTEMS PRIVATE LIMITED",
"CRYOSTAR TANKS AND VESSELS PRIVATE LIMITED",
"CRYOTECH ENGINEERING PRIVATE LIMITED",
"CRYOVAULT BIOTECH INDIA PRIVATE LIMITED",
"CRYOVIVA BIOTECH PRIVATE LIMITED",
"CRYPSIS TECHNOLOGIES PRIVATE LIMITED",
"CRYPTOGRAPH TECHNOLOGIES PRIVATE LIMITED",
"CRYPTOGRAPHIC IT SOLUTIONS PRIVATE LIMITED",
"CRYPTON PIGMENTS PRIVATE LIMITED",
"CRYPTZO ENGINEERING PRIVATE LIMITED",
"CRYSCLOUD PRIVATE LIMITED",
"CRYSRETAIL TRADING PRIVATE LIMITED",
"CRYSTA IVF LIFE PRIVATE LIMITED",
"CRYSTA LED PRIVATE LIMITED",
"CRYSTAL ALLOYS AND CASTINGS PRIVATE LIMITED",
"CRYSTAL ALUMINIUM PRODUCTS PRIVATE LIMITED",
"CRYSTAL AQUA MARINE HATCHERIES PRIVATE LIMITED",
"CRYSTAL AUTOCARS PRIVATE LIMITED",
"CRYSTAL AUTOMATION PRIVATE LIMITED",
"CRYSTAL AUTOMOBILES PRIVATE LIMITED",
"CRYSTAL BI TECHNOLOGIES PRIVATE LIMITED",
"CRYSTAL BOND AND ABSORBENT PRIVATE LIMITED",
"CRYSTAL BUILDTECH PRIVATE LIMITED",
"CRYSTAL CARS PRIVATE LIMITED",
"CRYSTAL CAST PRIVATE LIMITED",
"CRYSTAL CERAMIC INDUSTRIES LIMITED",
"CRYSTAL CERAMIC INDUSTRIES PRIVATE LIMITED",
"CRYSTAL CITY DEVELOPERS PRIVATE LIMITED",
"CRYSTAL CONTAINERS PRIVATE LIMITED",
"CRYSTAL COOK-N-SERVE PRODUCTS PRIVATE LIMITED",
"CRYSTAL CREDIT RISK MANAGEMENT SERVICES PRIVATE LIMITED",
"CRYSTAL CROP PROTECTION LIMITED",
"CRYSTAL CROPSCIENCES LIMITED",
"CRYSTAL DELTA SOLUTIONS PRIVATE LIMITED",
"CRYSTAL DEVCON PRIVATE LIMITED",
"CRYSTAL DIGITAL CONCEPTS PRIVATE LIMITED",
"CRYSTAL ELECTRIC CO. PRIVATE LIMITED",
"CRYSTAL ELECTRODYNAMIX PRIVATE LIMITED",
"CRYSTAL ENGINEERING SYSTEMS PRIVATE LIMITED",
"CRYSTAL ENGINEERS",
"CRYSTAL ENVIRONMENT TECHNOLOGIES PRIVATE LIMITED",
"CRYSTAL FORMS PRIVATE LIMITED",
"CRYSTAL FOUNDRY FLUXES PVT LTD",
"CRYSTAL FRT FORWARDERS PRIVATE LIMITED",
"CRYSTAL GRANITE & MARBLE PRIVATE LIMITED",
"CRYSTAL HATCHERIES PVT LTD",
"CRYSTAL HITECH IT SOLUTIONS PRIVATE LIMITED",
"CRYSTAL HOTEL PRIVATE LIMITED",
"CRYSTAL HR AND SECURITY SOLUTIONS PRIVATE LIMITED",
"CRYSTAL HUES LIMITED",
"CRYSTAL IMPEX LIMITED",
"CRYSTAL INDIA MOPPER PRIVATE LIMITED",
"CRYSTAL INDUSTRIAL SYNDICATE PRIVATE LIMITED",
"CRYSTAL INFO COMMUNICATIONS PRIVATE LIMITED",
"CRYSTAL INFORMATION TECHNOLOGY PRIVATE LIMITED",
"CRYSTAL INFRADEVELOPERS PRIVATE LIMITED",
"CRYSTAL INFRAPROJECTS PRIVATE LIMITED",
"CRYSTAL INTERIOR PRODUCTS PRIVATE LIMITED",
"CRYSTAL INTERNATIONAL PUBLIC SCHOOL",
"CRYSTAL KNITTERS PRIVATE LIMITED",
"CRYSTAL LIQUORS & WINES MARKETING PRIVATE LIMITED",
"CRYSTAL LOGIC PRIVATE LIMITED",
"CRYSTAL LOGISTIC ( COOL CHAIN ) LIMITED",
"CRYSTAL MATFOAM PRIVATE LIMITED",
"CRYSTAL MECHANICALS PRIVATE LIMITED",
"CRYSTAL MEDICAL CENTRE PRIVATE LIMITED",
"CRYSTAL MEDICINES PRIVATE LIMITED",
"CRYSTAL METALS PRIVATE LIMITED",
"CRYSTAL ORGOCHEM PRIVATE LIMITED",
"CRYSTAL PALACE PROPERTIES PRIVATE LIMITED",
"CRYSTAL PERIPHERALS AND SYSTEMS PVT LTD",
"CRYSTAL PLASTICS AND METALLIZING PRIVATE LIMITED",
"CRYSTAL POLYTECH PRIVATE LIMITED",
"CRYSTAL POLYWORKS PRIVATE LIMITED",
"CRYSTAL PRESENTATION SOLUTIONS PRIVATE LIMITED",
"CRYSTAL PRIME ADVISERS PRIVATE LIMITED",
"CRYSTAL PRINT AND PACK PRIVATE LIMITED",
"CRYSTAL QUINONE PRIVATE LIMITED",
"CRYSTAL SANITARY FITTINGS PRIVATE LIMITED",
"CRYSTAL SCREENING SERVICES PRIVATE LIMITED",
"CRYSTAL SEA FOODS PRIVATE LIMITED",
"CRYSTAL SHINE SYSTEMS",
"CRYSTAL SHIPPING COMPANY PRIVATE LIMITED",
"CRYSTAL SILICATES PRIVATE LIMITED",
"CRYSTAL SPACE INDIA PRIVATE LIMITED",
"CRYSTAL SPECIALITY TAPES PRIVATE LIMITED",
"CRYSTAL SPRINGSA UNIT OF DBPL",
"CRYSTAL STEEL DECOR (INDIA) PRIVATE LIMITED",
"CRYSTAL TEA (INDIA) PRIVATE LIMITED",
"CRYSTAL TECHNOLOGIES SYSTEM PRIVATE LIMITED",
"CRYSTAL TECHNOLOGY PRIVATE LIMITED",
"CRYSTAL TELEVENTURES PRIVATE LIMITED",
"CRYSTAL THERMOTECH LIMITED.",
"CRYSTAL TISSUES PRIVATE LIMITED",
"CRYSTAL TOURS AND TRAVELS PRIVATE LIMITED",
"CRYSTAL VENTILATIONS PRIVATE LIMITED",
"CRYSTAL VOXX LIMITED",
"CRYSTALENGINEERING (INDIA) PRIVATE LIMITED",
"CRYSTALINE EXPORTS PRIVATE LIMITED",
"CRYSTALS FACILITIES PRIVATE LIMITED",
"CRYSTALSIGN MEDIA PRIVATE LIMITED",
"CRYSTALTOWN HOSPITALITY SERVICES PRIVATE LIMITED",
"CRYSTAMOND GLOBAL PRIVATE LIMITED",
"CRYSTASOL ENERGY SOLUTIONS PRIVATE LIMITED",
"CRYSTELLIYA LIFESTYLES PRIVATE LIMITED",
"CRYSTIC RESINS INDIA PRIVATE LIMITED",
"CRYSTOLYTE ASSOCIATES INDIA PRIVATE LIMITED",
"CRYSTOPOR IMPEX (CHENNAI) PRIVATE LIMITED",
"CRYSTOR BUSINESS PRIVATE LIMITED",
"CS ACADEMY",
"CS AEROTHERM PRIVATE LIMITED",
"CS BAID METHA PHARMACY COLLEGE",
"CS BAKERY SOLUTIONS PRIVATE LIMITED",
"CS BUSINESS SERVICES INDIA PRIVATE LIMITED",
"CS COMPONENTS PRIVATE LIMITED",
"CS CUM SUPDT DIST HOSPITAL DEWAS",
"CS DATAMATION RESEARCH SERVICES PRIVATE LIMITED",
"CS ENTERPRISES PRIVATE LIMITED",
"CS FINE INTERCHEM PRIVATE LIMITED",
"CS FOODIE ZONE PRIVATE LIMITED",
"CS INDIA",
"CS INTERNATIONAL SCHOOL",
"CS NIRANJAN INDUSTRIES PRIVATE LIMITED",
"CS PERFORMANCE CHEMICALS PRIVATE LIMITED",
"CS RETAIL PRIVATE LIMITED",
"CS SPECIALTY CHEMICALS PRIVATE LIMITED",
"CS TRADE LINK PRIVATE LIMITED",
"CS WATERPROOFING SOLUTIONS PRIVATE LIMITED",
"CS ZIRCON PRODUCTS PVT LTD",
"CS3 PHOTOGRAPHY PRIVATE LIMITED",
"CS5 SECURE SOLUTIONS PRIVATE LIMITED",
"CSA CORPORATION PRIVATE LIMITED",
"CSA INFRATECH PRIVATE LIMITED",
"CSA PHARMA TECH (PVT) LTD",
"CSB BANK LIMITED",
"CSB DATA CONSULTING PRIVATE LIMITED",
"CSB PROJECTS PRIVATE LIMITED",
"CSB SLIDING BEARINGS (INDIA) PRIVATE LIMITED",
"CSB SOLUTIONS PRIVATE LIMITED",
"CSC E GOVERNANCE SERVICES INDIA LIMITED",
"CSC FINANCIAL SERVICES PRIVATE LIMITED",
"CSC GRAMEEN ESTORE PRIVATE LIMITED",
"CSC INDIA PRIVATE LIMITED",
"CSC WI-FI CHOUPAL SERVICES INDIA PRIVATE LIMITED",
"CSD CANTEEN MILITARY HOSPITAL",
"CSD ENGINEERING SERVICES PRIVATE LIMITED",
"CSD STUDIOS PRIVATE LIMITED",
"CSDC INDIA PRIVATE LIMITED",
"CSE DAKSHINA SOLAR PRIVATE LIMITED",
"CSE DECCAN SOLAR PRIVATE LIMITED",
"CSE INDIA PRIVATE LIMITED",
"CSE SOLAR PARKS SATNA PRIVATE LIMITED",
"CSE SOLAR SUNPARK MAHARASHTRA PRIVATE LIMITED",
"CSE SOLAR SUNPARK TAMIL NADU PRIVATE LIMITED",
"CSE SOLUTIONS PRIVATE LIMITED",
"CSE SYSTEMS AND ENGINEERING INDIA PRIVATE LIMITED",
"CSG NETWORKS PRIVATE LIMITED",
"CSG SOLUTIONS INDIA PRIVATE LIMITED",
"CSG SYSTEMS INTERNATIONAL (INDIA) PRIVATE LIMITED",
"CSH POWER HIMOINSA PRIVATE LIMITED\n",
"CSI BAIN MATRICULATION HIGHER SECONDARY SCHOOL",
"CSI CIVIL & STRUCTURAL ENGINEERING PRIVATE LIMITED",
"CSI COMPUTECH INDIA PRIVATE LIMITED",
"CSI ENGINEERING SOFTWARE PRIVATE LIMITED",
"CSI EWART MATRICULATION HIGHER SECONDARY SCHOOL",
"CSI EWARTS WOMEN CARISTIAN COLLEGE",
"CSI GOUDIE HIGHER SECONDARY SCHOOL",
"CSI RAINY HOSPITAL",
"CSI RENTING INDIA PRIVATE LIMITED",
"CSI ST PAULS HR SEC SCHOOL",
"CSI SYNOD",
"CSI TECHNOLOGY SERVICES PRIVATE LIMITED",
"CSI TELECOMS PRIVATE LIMITED",
"CSJ INFRASTRUCTURE PRIVATE LIMITED",
"CSJ VENTURES PRIVATE LIMITED",
"CSJM UNIVERSITY",
"CSK AGENCY PRIVATE LIMITED",
"CSK ELECTRONICS AND AUTOMATION PRIVATE LIMITED",
"CSK FACILITY MANAGEMENT PRIVATE LIMITED",
"CSK HOSPITALITY SERVICES PRIVATE LIMITED",
"CSKA LASER FAB PRIVATE LIMITED",
"CSL CAPITAL PRIVATE LIMITED",
"CSL FINANCE LIMITED",
"CSL FOOD PRODUCTS PRIVATE LIMITED",
"CSL INFOMEDIA PRIVATE LIMITED",
"CSM TECHNOLOGIES PRIVATE LIMITED",
"CSMSS AYURVED MAHAVIDYALAYA & RUGNALAYA",
"CSN DEVELOPERS PRIVATE LIMITED",
"CSOFT TECHNOLOGIES PRIVATE LIMITED",
"CSOIN ARCHITECTURE AND ENGINEERING PRIVATE LIMITED",
"CSON PAPER MILLS PRIVATE LIMITED",
"CSOS CORPORATE SOLUTIONS PRIVATE LIMITED",
"CSP LOGISTICS PRIVATE LIMITED",
"CSP PRODUCTS (INDIA) PRIVATE LIMITED",
"CSPACE ENTERPRISES PRIVATE LIMITED",
"CSPAR ENTERPRISES PRIVATE LIMITED",
"CSPE INDUSTRIES PRIVATE LIMITED",
"C-SPIRE CONSULTING SERVICES PRIVATE LIMITED",
"CSPL COMPUTERS PRIVATE LIMITED",
"CSPM AGRO PRIVATE LIMITED",
"C-SQUARE INFO-SOLUTIONS PRIVATE LIMITED",
"CSR FORGING PRIVATE LIMITED",
"CSR TALENT STAFFING PRIVATE LIMITED",
"CSRL- STRUCTWEL LAB (PUNE) PRIVATE LIMITED",
"CSRM LIFE HEALTHCARE PRIVATE LIMITED",
"CSRV VIDYA ASHRAM",
"CSS INDIA CENTER PRIVATE LIMITED",
"CSSB SECURITIES PRIVATE LIMITED",
"CSSL GLOBAL PRIVATE LIMITED",
"CSTC",
"CSV INVESTMENTS PRIVATE LIMITED",
"CT CONTROL TECHNOLOGY (INDIA) PRIVATE LIMITED",
"CT INFO PRIVATE LIMITED",
"CT PUBLIC SCHOOL JALANDHAR",
"CT SCAN RESEARCH CENTRE PRIVATE LIMITED",
"CT SIGNATURE TOURS PRIVATE LIMITED",
"CT SOLUTIONS PRIVATE LIMITED",
"CT UNIVERSITY",
"CTA APPRALES PRIVATE LIMITED",
"CTA LOGISTICS LIMITED",
"CTACT PRIVATE LIMITED",
"CTAS AIRCON PRIVATE LIMITED",
"CTBC BANK CO LIMITED",
"CTC (INDIA) PRIVATE LIMITED",
"CTC ELECTRICALS PRIVATE LIMITED",
"CTC FREIGHT CARRIERS INDIA PRIVATE LIMITED",
"CTC GEOTECHNICAL PRIVATE LIMITED",
"CTC GLOBAL INDIA PRIVATE LIMITED",
"CTC IMPEX INDIA PRIVATE LIMITED",
"CTC PROJECTS PRIVATE LIMITED",
"CTC PUBLICATIONS PRIVATE LIMITED",
"CTC SPEED LOGISTICS PRIVATE LIMITED",
"CTC TRANSLOGISTIC PRIVATE LIMITED",
"CTD PRIVATE LIMITED",
"CTE INTERNATIONAL PRIVATE LIMITED",
"CTE TEA PRIVATE LIMITED",
"CTECH ENERGY PRIVATE LIMITED",
"C-TECH ENGINEERING & CONSTRUCTION PRIVATE LIMITED",
"C-TECH ENGINEERS PRIVATE LIMITED",
"CTECH INFOSOLUTIONS PRIVATE LIMITED",
"C-TEL INFRA PRIVATE LIMITED",
"CTGA BIOPHARMA INDIA PRIVATE LIMITED",
"CTH URBANA PRIVATE LIMITED",
"CTI INFRASTRUCTURE PRIVATE LIMITED",
"CTI LOGISTICS PRIVATE LIMITED",
"CTL GLOBAL SERVICES PRIVATE LIMITED",
"CTL INFOCOM PRIVATE LIMITED",
"CTL LOGISTICS INDIA PRIVATE LIMITED",
"CTM HOMESTYLE PRIVATE LIMITED",
"CTM INDIA LIMITED",
"CTM TECHNICAL TEXTILES LIMITED",
"CTMK GUJRATI VIDHALAYA",
"CTO SARVASHIKSHA INSTITUTE PRIVATE LIMITED",
"CTR EXPORTS PRIVATE LIMITED",
"CTR HOUSEHOLD TECHNOLOGIES INDIA PRIVATE LIMITED",
"CTR TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"CTRACK SURVEYS PRIVATE LIMITED",
"CTRINE ENGINEERING PRIVATE LIMITED",
"CTRL M PRINT MANAGEMENT INDIA PRIVATE LIMITED",
"CTRL P SOLUTIONS PRIVATE LIMITED",
"CTRL S (INDIA) PRIVATE LIMITED",
"CTRL S DATACENTERS LIMITED",
"CTRL VI TECH SERVICE LLP",
"CTRLA IT SERVICS PRIVATE LIMITED",
"CTRLP SOLUTIONS PRIVATE LIMITED",
"CTS EXPRESS LOGISTICS PRIVATE LIMITED",
"CTS INDIA PRIVATE LIMITED",
"CTS INDUSTRIES LIMITED",
"CTS OFFSHORE AND MARINE INDIA PRIVATE LIMITED",
"CTS OM (INDIA) PRIVATE LIMITED",
"CTS RESTORATION PRODUCTS (INDIA) PRIVATE LIMITED",
"CTSI GLOBAL INDIA PRIVATE LIMITED",
"CTSNET INDIA PRIVATE LIMITED",
"CTSOFTWARE SOLUTIONS PRIVATE LIMITED",
"CTTP INFRASTRUCTURES INDIA PRIVATE LIMITED",
"CTX APPAREL FABRICS",
"CTX LIFESCIENCES PRIVATE LIMITED",
"CU BUILT ENGINEERS PRIVATE LIMITED",
"CU ENERGIES LIMITED",
"CU INSPECTIONS & CERTIFICATIONS INDIA PRIVATE LIMITED",
"CUBANE SPECIALITY CHEMICALS PRIVATE LIMITED",
"CUBASTION CONSULTING PRIVATE LIMITED",
"CUBATIC PROJECTS PRIVATE LIMITED",
"CUBATICS GARMENTS PRIVATE LIMITED",
"CUBE 8 COWORKS PRIVATE LIMITED",
"CUBE BIO-ENERGY PRIVATE LIMITED",
"CUBE CONCRETE SOLUTIONS PRIVATE LIMITED",
"CUBE CONSTRUCTION ENGINEERING LIMITED",
"CUBE CONSUMER SERVICES PRIVATE LIMITED",
"CUBE EDUGAINS PRIVATE LIMITED",
"CUBE ENGITECH CONSULTANT PRIVATE LIMITED",
"CUBE FITNESS PRIVATE LIMITED",
"CUBE HIGHWAYS AND TRANSPORTATION ASSETS ADVISORS PRIVATE LIMITED",
"CUBE HIGHWAYS OPERATIONS MANAGEMENT PRIVATE LIMITED",
"CUBE HIGHWAYS ROOTS FOUNDATION",
"CUBE HOSPITALITY SERVICES PRIVATE LIMITED",
"CUBE LOGISTICS PRIVATE LIMITED",
"CUBE ORNAMENTS PRIVATE LIMITED",
"CUBE SOFTWARE PRIVATE LIMITED",
"CUBE TELECOM PRIVATE LIMITED",
"CUBE27 IT PRIVATE LIMITED",
"CUBE45 ECOMMERCE SERVICES PRIVATE LIMITED",
"CUBELOGIC SOFTWARE INDIA PRIVATE LIMITED",
"CUBES CONTRACTS AND ENGINEERING PRIVATE LIMITED",
"CUBES MEDIA & BRANDING PRIVATE LIMITED",
"CUBESIMPLE PRIVATE LIMITED",
"CUBET TECHNO LABS PRIVATE LIMITED",
"CUBETEQ TECHNOLOGIES PRIVATE LIMITED",
"CUBEVO INSIGHTS PRIVATE LIMITED",
"CUBEWISE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"CUBEX TUBINGS LTD",
"CUBEZOID SOLUTIONS PRIVATE LIMITED",
"CUBIC COMPUTING PRIVATE LIMITED",
"CUBIC LIFESCIENCES PRIVATE LIMITED",
"CUBIC STONE PRIVATE LIMITED",
"CUBIC TRANSMISSIONS PRIVATE LIMITED",
"CUBIC TRANSPORTATION SYSTEMS ( INDIA ) PRIVATE LIMITED",
"CUBIC TURNKEY PRIVATE LIMITED",
"CUBICIT SOLUTION PRIVATE LIMITED",
"CUBICOR INFORMATION SYSTEMS PRIVATE LIMITED",
"CUBICTREE TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"CUBIT BUSINESS CENTRE PRIVATE LIMITED",
"CUBITEX MARKETING PVT LTD",
"CUBIX AUTOMATION PRIVATE LIMITED",
"CUBIX CONTROL SYSTEMS PRIVATE LIMITED",
"CUBIX MICRO SYSTEMS INDIA PRIVATE LIMITED",
"CUBIX TECH INTEGRATION PRIVATE LIMITED",
"CUBIX TECHNO GROUP",
"CUBOT BUSINESS INTELLIGENCE PRIVATE LIMITED",
"CUBRAL ENGINEERING PRIVATE LIMITED",
"CUBS HYDROCHEMICALS PRIVATE LIMITED",
"CUBS INTL PRIVATE. LIMITED.",
"CUBS VITAMIN PRIVATE LIMITED",
"CU-BUILT RENEWABLE ENERGY PRIVATE LIMITED",
"CUBUS BANKING SOLUTIONS INDIA PRIVATE LIMITED",
"CUBYTS TECHNOLOGIES PRIVATE LIMITED",
"CUCKOO APPLIANCES PRIVATE LIMITED",
"CUCUMBER ENTERPRISES PRIVATE LIMITED",
"CUDDAPAH AGRO OILS PRIVATE LIMITED",
"CUDDAPAH SPINNING MILLS LIMITED",
"CUDDLE ARTIFICIAL INTELLIGENCE PRIVATE LIMITED",
"CUE APPARELS PRIVATE LIMITED",
"CUE BLOCKS TECHNOLOGIES PRIVATE LIMITED",
"CUELINKS TECHNOLOGY PRIVATE LIMITED",
"CUELOGIC TECHNOLOGIES PRIVATE LIMITED",
"CUEMBUX SOFTWARE SOLUTIONS PRIVATE LIMITED",
"CUENTA EXIM SOLUTIONS PRIVATE LIMITED",
"CUENTAS CONSULTING PRIVATE LIMITED",
"CUFFE CASTLE TRADING COMPANY ( A PRIVATE COMPANY )",
"CUIDADO MEDICO PRIVATE LIMITED",
"CUIRASS DOORS PRIVATE LIMITED",
"CUISINEART FOOD AND BEVERAGE LIMITED",
"CUISINEC NUTRITION PRIVATE LIMITED",
"CUISINECRAFT HOSPITALITY PRIVATE LIMITED",
"CULAIR (INDIA) PVT LTD",
"CULINARY ACADEMY OF INDIA",
"CULINARY BRANDS PRIVATE LIMITED",
"CULINARY CULTURE INDIA PRIVATE LIMITED",
"CULINARY FOOD AND BEVERAGE PRIVATE LIMITED",
"CULLEN GRUMMITT AND ROE INDIA PRIVATE LIMITED",
"CULMEN LOGISTICS PRIVATE LIMITED",
"CULMINANT EXECUTIVE SERVICES PRIVATE LIMITED",
"CULT OF PRISHA PRIVATE LIMITED",
"CULTGEAR PRIVATE LIMITED",
"CULTHOUSE RAGTRADE (OPC) PRIVATE LIMITED",
"CULTIVATOR NATURAL PRODUCTS PRIVATE LIMITED",
"CULTRARO AUTOCOMP SOLUTIONS PRIVATE LIMITED",
"CULTURAL AFFAIRS ARCHAEOLOGY MUSEUM AND ARCHIVES CULTURE AFFAIRS ARCH MUSEUM",
"CULTURE CLOTHING PRIVATE LIMITED",
"CULTURE COMPANY INDIA PRIVATE LIMITED",
"CULTURE HOLIDAYS INDIA PRIVATE LIMITED",
"CULTURE INDIA CREATIONS PRIVATE LIMITED",
"CULTURE MACHINE MEDIA PRIVATE LIMITED",
"CULTURE SHOP",
"CULTUREGRADE TECHNOLOGIES PRIVATE LIMITED",
"CULTURELYTICS PRIVATE LIMITED",
"CULTUZZ INDIA PRIVATE LIMITED",
"CULVER MAX ENTERTAINMENT PRIVATE LIMITED",
"CUMBERLAND ELECTROCHEMICAL PRIVATE LIMITED",
"CUMBIA SPORTS WEAR PRIVATE LIMITED",
"CUMBUM VALLEY WINERY PRIVATE LIMITED",
"CUMIN FOOD AND BEVERAGE PRIVATE LIMITED",
"CUMIN INFOTECH PRIVATE LIMITED",
"CUMMINS COLLEGE OF ENGINEERING FOR WOMEN",
"CUMMINS GENERATOR TECHNOLOGIES INDIA PRIVATE LIMITED",
"CUMMINS INC.",
"CUMMINS INDIA LIMITED",
"CUMMINS RESEARCH AND TECHNOLOGY INDIA PRIVATE LIMITED",
"CUMMINS SALES & SERVICE PRIVATE LIMITED",
"CUMMINS TECHNOLOGIES INDIA PRIVATE LIMITED",
"CUMULUS SYSTEMS PRIVATE LIMITED",
"CUMULUS TRADING COMPANY PRIVATE LIMITED",
"CUNESOFT INDIA PRIVATE LIMITED",
"CUNIX INFOTECH PRIVATE LIMITED",
"CUNNANCHETTY HINDU COLLEGE",
"CUNNINGHAM LINDSEY INTERNATIONAL INSURANCE SURVEYORS AND LOSS ASSESSORS PRIVATE LIMITED",
"CUNOVA SERVICE INDIA PRIVATE LIMITED",
"CUORETONE FITNESS INDIA PRIVATE LIMITED",
"CUPERTINO TECHVOX SOFTWARE PRIVATE LIMITED",
"CUPID DIAMONDS PRIVATE LIMITED",
"CUPID GREENS PRIVATE LIMITED",
"CUPID LIMITED",
"CUPID TRAVELS&TOURS P.LIMITED",
"CUPOLA TECHNOLOGY PRIVATE LIMITED",
"CUPRO RECYCLING PRIVATE LIMITED",
"CUPRUM BAGRODIA LIMITED",
"CUPRUM INFRASTRUCTURE PRIVATE LIMITED",
"CUPTEA MEDIA (OPC) PRIVATE LIMITED",
"CURA AYURVEDIC & UNANI LIMITED",
"CURA GRC PRIVATE LIMITED",
"CURA HOSPITALS",
"CURA KAMMANAHALLI BRANCH",
"CURADEN INDIA PRIVATE LIMITED",
"CURADEV PHARMA PRIVATE LIMITED",
"CURADIGM DATALYTICS PRIVATE LIMITED",
"CURADOR HEALTHCARE PRIVATE LIMITED",
"CURAM DIAGNOSTIC PRIVATE LIMITED",
"CURAM SOFTWARE INTERNATIONAL PRIVATE LIMITED",
"CURAMEDICO INDUSTRIES PRIVATE LIMITED",
"CURANUM HEALTHCARE PRIVATE LIMITED",
"CURATE EXPERIENCES PRIVATE LIMITED",
"CURATECH PRIVATE LIMITED",
"CURATED FOOD EXPERIENCES PRIVATE LIMITED",
"CURATED MARKETPLACES PRIVATE LIMITED",
"CURATINE CROPS PRIVATE LIMITED",
"CURATIO HEALTH CARE INDIA PRIVATE LIMITED",
"CURATION TECH PRIVATE LIMITED",
"CURATIONS BOUTIQUE PRIVATE LIMITED",
"CURATIVE ENGINEERS PRIVATE LIMITED",
"CURATIVE MICROBES PRIVATE LIMITED",
"CURATIVE ORGANICS PRIVATE LIMITED",
"CURATOR BHOPAL MUSEUM BHOPAL MADHYA PRADESH",
"CURATURE VENTURES PRIVATE LIMITED",
"CURE ALL SUPER SPECIALITY & RADIOTHERAPY CENTRE PRIVATE LIMITED",
"CURE DAY HEALTHCARE PRIVATE LIMITED",
"CURE HERBS HEALTHCARE PRIVATE LIMITED",
"CURE INGREDIENTS PRIVATE LIMITED",
"CURE MEDICINES IPRIVATE LIMITED",
"CURE 'N' CARE HOSPITALS (OPC) PRIVATE LIMITED",
"CURE NUTRACEUTICAL PRIVATE LIMITED",
"CURE PLUS BIOSCIENCES PRIVATE LIMITED",
"CURE TRADE & COMMERCE PRIVATE LIMITED",
"CURE VET HEALTH CARE PRIVATE LIMITED",
"CUREBAY TECHNOLOGIES PRIVATE LIMITED",
"CUREBOAT HEALTHCARE PRIVATE LIMITED",
"CUREFOODS PRIVATE LIMITED",
"CUREFORD HEALTHCARE PRIVATE LIMITED",
"CUREHEALTH PHARMACEUTICALS PRIVATE LIMITED",
"CUREILL PHARMA PRIVATE LIMITED",
"CUREIT HOSPITALS PRIVATE LIMITED",
"CUREJOY MEDIA PRIVATE LIMITED",
"CUREMARK MEDI SCIENCES PRIVATE LIMITED",
"CUREMENS VETCARE PRIVATE LIMITED",
"CURESTAY SERVICES PRIVATE LIMITED",
"CURETECH FORMULATIONS PRIVATE LIMITED",
"CURETECH SKINCARE",
"CURETIC BIOTECHS PRIVATE LIMITED",
"CURETOR GOVT ARCHIOLOGICAL MUSIUM DEWAS",
"CUREWELL (INDIA) LIMITED",
"CUREWELL DIAGNOSTIC CENTRE",
"CUREWELL PACKAGING PRIVATE LIMITED",
"CUREWIN PHARMACEUTICALS PRIVATE LIMITED",
"CUREWIN-HYLICO PHARMA PRIVATE LIMITED",
"CUREX PHARMA PRIVATE LIMITED",
"CUREX SOLUTIONS LIMITED",
"CUREZA HEALTHCARE PRIVATE LIMITED",
"CUREZEN PHARMA PRIVATE LIMITED",
"CUREZIP PHARMA PRIVATE LIMITED",
"CURIA INDIA PRIVATE LIMITED",
"CURIO COTTAGE SILVER PRIVATE LIMITED",
"CURIO CRAFTS PRIVATE LIMITED",
"CURIO GLASS WARES PRIVATE LIMITED",
"CURIOUS COUSINS HOSPITALITY LLP",
"CURIOUS MINDZ",
"CURIS TECHNOLOGIES PRIVATE LIMITED",
"CURLY CRAVINGS PRIVATE LIMITED",
"CURLY TALES DIGITAL MEDIA PRIVATE LIMITED",
"CUROFY PHARMACEUTICALS PRIVATE LIMITED",
"CUROLOGIC SYSTEMS PRIVATE LIMITED",
"CUROSIS HEALTHCARE PRIVATE LIMITED",
"CUROVIS HEALTHCARE PRIVATE LIMITED",
"CURRAN SPECIALTY COATINGS SERVICES PRIVATE LIMITED",
"CURRANT RESEARCH AESTHETICS PRIVATE LIMITED",
"CURRENCIES DIRECT SOLUTIONS PRIVATE LIMITED",
"CURRENCY CABLES PRIVATE LIMITED",
"CURRENCY MANTRA PRIVATE LIMITED",
"CURRENT ADVERTISING PRIVATE LIMITED",
"CURRENT BOOKS ( INDIA ) PRIVATE LIMITED",
"CURRENT INFRAPROJECTS PRIVATE LIMITED",
"CURRENT KING INDUSTRY PRIVATE LIMITED",
"CURRENT TECHNICAL LITERATURE COMPANY PRIVATE LIMITED",
"CURRENT TECHNOLOGIES INDIA PRIVATE LIMITED",
"CURRENTS TECHNOLOGY RETAIL INDIA LIMITED",
"CURREY VASU INDIA PRIVATE LIMITED",
"CURRIE & BROWN INDIA PRIVATE LIMITED",
"CURRIE & BROWN PADGHAM PRIVATE LIMITED",
"CURRY NATION BRAND CONVERSATIONS PRIVATE LIMITED",
"CURRY STONE DESIGN COLLABORATIVE PRIVATE LIMITED",
"CURRY WESTERN MOVIES PRIVATE LIMITED",
"CURSOR SOFT PRIVATE LIMITED",
"CURTAINMAN ONLINE PRIVATE LIMITED",
"CURTAINSPA SOLUTIONS PRIVATE LIMITED",
"CURTIS DRUG POINT PRIVATE LIMITED",
"CURTIS INSTRUMENTS INDIA PRIVATE LIMITED",
"CURTISS WRIGHT SURFACE TECHNOLOGIES INDIA PRIVATE",
"CURVO ELECTRONICS PRIVATE LIMITED",
"CUS DELIGHT CONSULTANCY SERVICES PRIVATE LIMITED",
"CUSHMAN & WAKEFIELD ADVISORY ASIA (INDIA) PRIVATE LIMITED",
"CUSHMAN AND WAKEFIELD INDIA PRIVATE LIMITED",
"CUSHMAN AND WAKEFIELD PROPERTY ADVISERS PRIVATE LIMITED",
"CUSHMAN AND WAKEFIELD PROPERTY MANAGEMENT SERVICES INDIA PRIVATE LIMITED",
"CUSMAT TECHNOLOGIES PRIVATE LIMITED",
"CUSP CONSULTING PRIVATE LIMITED",
"CUSPERA PRIVATE LIMITED",
"CUSROW WADIA INSTITUTE OF TECHNOLOGY",
"CUSTIV MANUFACTURING SOLUTIONS PRIVATE LIMITED",
"CUSTODIAN CORPORATE SERVICES PRIVATE LIMITED",
"CUSTODIAN OF ENEMY PROPERTY FOR INDIA",
"CUSTOLOGIX SOLUTIONS INDIA PRIVATE LIMITED",
"CUSTOM CAPSULES PRIVATE LIMITED",
"CUSTOM CONSTRUCTION PRIVATE LIMITED",
"CUSTOM LOGICS PRIVATE LIMITED",
"CUSTOM MADE FILMS PRIVATE LIMITED",
"CUSTOMELEMENTS PRIVATE LIMITED",
"CUSTOMER ANALYTICS INDIA PRIVATE LIMITED",
"CUSTOMER DYNAMICS INDIA PRIVATE LIMITED",
"CUSTOMER INSIGHT 360 TECHNOLOGIES PRIVATE LIMITED",
"CUSTOMERLABS DIGITAL SOLUTIONS PRIVATE LIMITED",
"CUSTOMERXPS SOFTWARE PRIVATE LIMITED",
"CUSTOMISED INDUSTRIAL SOLUTION",
"CUSTOMISED STEEL BUILDING PRIVATE LIMITED",
"CUSTOMISED TECHNOLOGIES PRIVATE LIMITED",
"CUSTOMIZED ENERGY SOLUTIONS INDIA PRIVATE LIMITED",
"CUSTOMIZED IT SOLUTIONS PRIVATE LIMITED",
"CUSTOMIZED STEAM SOLUTIONS PRIVATE LIMITED",
"CUT AND STICH APPAREL PRIVATE LIMITED",
"CUT QUITE GEMS PRIVATE LIMITED",
"CUTAWAYY FILMS PRIVATE LIMITED",
"CUTCH OIL AND ALLIED INDUSTRIES 1949 PRIVATE LIMITED",
"CUTE CARE LIFE SCIENCES PRIVATE LIMITED",
"CUTE CYCLES PVT LTD",
"CUTE LITTLE FASHIONS PRIVATE LIMITED",
"CUTECH ALLOYS PRIVATE LIMITED",
"CUTECH SOLUTIONS INDIA PRIVATE LIMITED",
"CUTEK BRAZING PRIVATE LIMITED",
"CUTHBERT LOGISTICS SERVICES LIMITED",
"CUTHBERT TRADING HUB LIMITED",
"CUTICHEM PHARMACEUTICAL PRIVATE LIMITED",
"CUTIS INSTITUTE OF MEDICINE AND SURGERY PRIVATE LIMITED",
"CUTIX LIFESCIENCES PRIVATE LIMITED",
"CUTMAC MARKETING PRIVATE LIMITED",
"CUTTACK COLLEGE",
"CUTTACK HOSPITALS PRIVATE LIMITED",
"CUTTING EDGE AGENCIES PRIVATE LIMITED",
"CUTTING EDGE EVENTS PRIVATE LIMITED",
"CUTTING EDGE INFRASTRUCTURE PRIVATE LIMITED",
"CUTTING EDGE PROMOTIONS PRIVATE LIMITED",
"CUTTING EDGE SOFTWARE PRIVATE LIMITED",
"CUTWELL ABRASIVES PRIVATE LIMITED",
"CU-V-KAR GENETIC MEDICINE PRIVATE LIMITED",
"CV CLOUD SERVICES PRIVATE LIMITED",
"CV CORPORATE SERVICES PRIVATE LIMITED",
"CV DESIGNERS INDIA PRIVATE LIMITED",
"CV INFRACON PRIVATE LIMITED",
"CV PROPINFRA PRIVATE LIMITED",
"CV RETAIL PRIVATE LIMITED",
"CVANTUM HEALTHCARE PRIVATE LIMITED",
"CVC ADVISERS (INDIA) PRIVATE LIMITED",
"CVC NETWORK INDIA PRIVATE LIMITED",
"CVC TECHNOLOGIES INDIA PRIVATE LIMITED",
"CVENT INDIA PRIVATE LIMITED",
"CVG SEATING INDIA PRIVATE LIMITED",
"CVI CONTACT LENS INDIA PRIVATE LIMITED",
"CVI SOFTWARE PRIVATE LIMITED",
"CVICE INFOTECH PRIVATE LIMITED",
"CVISION.AI ANALYTICS PRIVATE LIMITED",
"CVK ADVISORS PRIVATE LIMITED",
"CVK CONSTRUCTIONS PRIVATE LIMITED",
"CVK ELECTRICALS INDIA PRIVATE LIMITED",
"CVK INFRASTRUCTURE PRIVATE LIMITED",
"CVK NEW KINNERA COLD STORAGE PRIVATE LIMITED",
"CVK PROJECTS PRIVATE LIMITED",
"CVM PRECISION PRODUCTS PRIVATE LIMITED",
"CVM SOLUTIONS PRIVATE LIMITED",
"C-VOTER NEWS SERVICES PRIVATE LIMITED",
"CVP FOODS PRIVATE LIMITED",
"CVR BIOTECH PRIVATE LIMITED",
"CVR BUILDCON PRIVATE LIMITED",
"CVR CHITS PRIVATE LIMITED",
"CVR COLLEGE OF ENGINEERING",
"CVR IDREAM MEDIA PRIVATE LIMITED",
"CVR LABS PRIVATE LIMITED",
"CVS BIOTECH PRIVATE LIMITED",
"CVS CAREMARK",
"CVS INFRASTRUCTURE PRIVATE LIMITED",
"CVT TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"CW RENEWABLE ENERGY INDIA PRIVATE LIMITED",
"CWAY INDIA FOODS & BEVERAGES PRIVATE LIMITED",
"CWC IMPORT PRIVATE LIMITED",
"CWC MAHARASHTRA (RO)",
"CWC PLYBOARDS PRIVATE LIMITED",
"CWD LIMITED",
"CWE TECHNOLOGY PRIVATE LIMITED",
"CWICK CARGO CARRIERS PRIVATE LIMITED",
"CWICK IMPORT CONSOLIDATIONS PRIVATE LIMITED",
"CWPS LOCHBRIDGE INDIA PRIVATE LIMITED",
"CWRE WIND POWER PRIVATE LIMITED",
"CWS TECHNOLOGY PRIVATE LIMITED",
"CWT INDIA PRIVATE LIMITED",
"CX PRECISION MECHANICAL INDIA PRIVATE LIMITED",
"CX VENTURES PRIVATE LIMITED",
"CXC CONSULTANTS PRIVATE LIMITED",
"CXC INFOTECH PRIVATE LIMITED",
"CXIO TECHNOLOGIES PRIVATE LIMITED",
"CXL LOGISTICS PRIVATE LIMITED",
"CXOSYNC PRIVATE LIMITED",
"CXWAI TECH INDIA PRIVATE LIMITED",
"CY COSMETICS PRIVATE LIMITED",
"CY ENGINEERING INDIA PRIVATE LIMITED",
"CY MYUTEC ANAND PRIVATE LIMITED",
"CY9 INDIA PRIVATE LIMITED",
"CYAN FORMULATORS PRIVATE LIMITED",
"CYAN360 SOLUTION INDIA PRIVATE LIMITED",
"CYANCONNODE PRIVATE LIMITED",
"CYANO PHARMA PRIVATE LIMITED",
"CYANTRON SYNERGIES PRIVATE LIMITED",
"CYBAGE SOFTWARE PRIVATE LIMITED",
"CYBDEER NETWORK PRIVATE LIMITED",
"CYBELE INFRASTRUCTURE PRIVATE LIMITED",
"CYBELE PARADISE PRIVATE LIMITED",
"CYBER ASTRO LIMITED",
"CYBER AUTOMOBILES PRIVATE. LIMITED.",
"CYBER GROUP INDIA PRIVATE LIMITED",
"CYBER INFOSERVICES PRIVATE LIMITED",
"CYBER INFRASTRUCTURE PRIVATE LIMITED",
"CYBER MANAGERS SOFTWARE SERVICES PRIVATE LIMITED",
"CYBER MEDIA RESEARCH & SERVICES LIMITED",
"CYBER METRIC SERVICES (INDIA) PRIVATE LIMITED",
"CYBER OPTIC SOLUTIONS PRIVATE LIMITED",
"CYBER PARK DEVELOPMENT & CONSTRUCTION PRIVATE LIMITED",
"CYBER PARK INDIA PRIVATE LIMITED",
"CYBER PEARL INFORMATION TECHNOLOGY PARK",
"CYBER PERIPHERALS PRIVATE LIMITED",
"CYBER POWER SYSTEMS INDIA PRIVATE LIMITED",
"CYBER PROPERTY MANAGEMENT SERVICES INDIA PRIVATE LIMITED",
"CYBER Q CONSULTING PRIVATE LIMITED",
"CYBER SECURITY WORKS PRIVATE LIMITED",
"CYBER SITES PRIVATE LIMITED",
"CYBER SPACE ABACUS PRIVATE LIMITED",
"CYBER SPACE INFOTAINMENT LIMITED",
"CYBER SPHERE IT SERVICES PRIVATE LIMITED",
"CYBER VILLAGE SOLUTIONS PRIVATE LIMITED",
"CYBER WINDOWS INDIA PRIVATE LIMITED",
"CYBER WORX TECHNOLOGIES PRIVATE LIMITED",
"CYBERABAD CITIZENS HEALTH SERVICES PRIVATE LIMITED",
"CYBERABAD CONVENTION CENTRE PRIVATE LIMITED",
"CYBERABAD EXPRESSWAYS LIMITED",
"CYBERABAD FOODS PRIVATE LIMITED",
"CYBERABAD HITECH INTEGRATED TOWNSHIP DEVELOPMENT CORPORATION PRIVATE LIMITED",
"CYBERACE INFOVISION PRIVATE LIMITED",
"CYBERARK SOFTWARE INDIA PRIVATE LIMITED",
"CYBERAUTICS TECHNOLOGIES (OPC) PRIVATE LIMITED",
"CYBERAX TECH PRIVATE LIMITED",
"CYBERBIT INDIA PRIVATE LIMITED",
"CYBERBOXER AI PRIVATE LIMITED",
"CYBERCAD TECHNOLOGIES PRIVATE LIMITED",
"CYBERCARE INFOWAYS INDIA PRIVATE LIMITED",
"CYBERCITY BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"CYBERCITY HOUSING PRIVATE LIMITED",
"CYBERCITY INFRASTRUCTURE PRIVATE LIMITED",
"CYBERCITY MANGADU PROJECT PRIVATE LIMITED",
"CYBERCOM DATAMATICS INFORMATION SOLUTIONS LIMITED",
"CYBERCUBE SERVICES PRIVATE LIMITED",
"CYBERDESIGN (INDIA) PRIVATE LIMITED",
"CYBERDYNAMICS INDIA PRIVATE LIMITED",
"CYBEREXCELLENCE ACADEMY PRIVATE LIMITED",
"CYBERFENDER INFOTECH PRIVATE LIMITED",
"CYBERFRAME INFOTECH PRIVATE LIMITED",
"CYBERGRID SOLUTIONS INDIA PRIVATE LIMITED",
"CYBERHEIGHTS SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"CYBERKING TECHNOLOGIES PRIVATE LIMITED",
"CYBERKNIGHT IOT TECHNOLOGIES PRIVATE LIMITED",
"CYBERLINKS TECHNOLOGIES PRIVATE LIMITED",
"CYBERMARINE KNOWLEDGE SYSTEMS PRIVATE LIMITED",
"CYBERMERU TECHNOLOGIES PRIVATE LIMITED",
"CYBERMOKSH TECHNOLOGIES PRIVATE LIMITED",
"CYBERMOTION TECHNOLOGIES PRIVATE LIMITED",
"CYBERNET IT PRIVATE LIMITED",
"CYBERNETIC GENESIS PRIVATE LIMITED",
"CYBERNETICS CONSULTANCY SOLUTIONS PRIVATE LIMITED",
"CYBERNETIK TECHNOLOGIES PRIVATE LIMTED",
"CYBERNETIX AUTOMATION P.LTD",
"CYBERNETYX TECHNIK PRIVATE LIMITED",
"CYBERNEXA INFOTECH PRIVATE LIMITED",
"CYBERNEXT PRIVATE LIMITED",
"CYBERNOOR INDIA PRIVATE LIMITED",
"CYBERNOOR SOFTWARE SERVICES PRIVATE LIMITED",
"CYBERNX TECHNOLOGIES PRIVATE LIMITED",
"CYBERPLAT INDIA PRIVATE LIMITED",
"CYBERROOT RISK ADVISORY PRIVATE LIMITED",
"CYBERSEC SERVICES ADVISOR PRIVATE LIMITED",
"CYBERSECON TECHNOLOGIES PRIVATE LIMITED",
"CYBERSECURIST TECHNOLOGIES PRIVATE LIMITED",
"CYBERSITES INDIA TECHNOLOGIES PRIVATE LIMITED",
"CYBERSOFT AND SOFTWARES SOLUTIONS PRIVATE LIMITED",
"CYBERSOL TECHNOLOGIES PRIVATE LIMITED",
"CYBERSPACE NETWORKING SYSTEMS PRIVATE LIMITED",
"CYBERSURF (INDIA) PRIVATE LIMITED",
"CYBERSWIFT INFOTECH PRIVATE. LIMITED",
"CYBERTECH SYSTEMS AND SOFTWARE LIMITED",
"CYBERTHEORY CONSULTING PRIVATE LIMITED",
"CYBERTHINK INFOTECH PRIVATE LIMITED",
"CYBERTRON TECHNOLOGIES",
"CYBERWALK TECH PARK PRIVATE LIMITED",
"CYBERX INFO SYSTEM PRIVATE LIMITED",
"CYBEX EXIM SOLUTIONS PRIVATE LIMITED",
"CYBIZ SUPERBRANDS PRIVATE LIMITED",
"CYBIZCALL (INTERNATIONAL) PRIVATE LIMITED",
"CYBLANCE TECHNOLOGIES PRIVATE LIMITED",
"CYBLE INFOSEC INDIA PRIVATE LIMITED",
"CYBORG IT SERVICES PRIVATE LIMITED",
"CYBORGINTELL PRIVATE LIMITED",
"CYBOTS ENGINEERING LLP",
"CYBRAIN SOFTWARE SOLUTIONS PRIVATE LIMITED",
"CYBRID CROP SCIENCES PRIVATE LIMITED",
"CYBRILLA TECHNOLOGIES PRIVATE LIMITED",
"CYBROSYS TECHNO SOLUTIONS PRIVATE LIMITED",
"CYCLELOGISST INDIA PRIVATE LIMITED",
"CYCLIC ENERGY POWER PRIVATE LIMITED",
"CYCLO TRANSMISSIONS LTD",
"CYCLONE RETAILING &CLOTHING PRIVATE LIMITED",
"CYCLOPS MEDTECH PRIVATE LIMITED",
"CYCLOPS SECURITY AND ALLIED SERVICES PRIVATE LIMITED",
"CYCLOSYSTEM (INDIA) PRIVATE LIMITED",
"CYCLOTRON ROBOTICS AND AUTOMATION PRIVATE LIMITED",
"CYFAST ENTERPRISES PRIVATE LIMITED",
"CYFIRMA INDIA PRIVATE LIMITED",
"CYFUTURE INDIA PRIVATE LIMITED",
"CYGENICA PRIVATE LIMITED",
"CYGENTA CROP PRODUCTION PRIVATE LIMITED",
"CYGNER TECHNOLABS PRIVATE LIMITED",
"CYGNET ENTERPRISE PRIVATE LIMITED",
"CYGNET INDUSTRIES LIMITED",
"CYGNET INFOTECH PRIVATE LIMITED",
"CYGNET INTERNATIONAL PRIVATE LIMITED",
"CYGNET MEDITECH PRIVATE LIMITED",
"CYGNET PROJECTS PRIVATE LIMITED",
"CYGNET TECHNOLOGIES PRIVATE LIMITED",
"CYGNETT HOTELS & RESORTS PRIVATE LIMITED",
"CYGNETT PARK B L",
"CYGNI ENERGY PRIVATE LIMITED",
"CYGNI INDUSTRIAL RESOURCE MANAGEMENT PRIVATE LIMITED",
"CYGNILUX ENGINEERING PRIVATE LIMITED",
"CYGNOR HEALTHCARE PRIVATE LIMITED",
"CYGNUS ADVERTISING (INDIA) PRIVATE LIMITED",
"CYGNUS CORSANTS MEDICARE PRIVATE LIMITED",
"CYGNUS CORSANTS MLS HEALTHCARE PRIVATE LIMITED",
"CYGNUS CROP SCIENCES PRIVATE LIMITED",
"CYGNUS E SOLUTIONS PRIVATE LIMITED",
"CYGNUS HEALTH CARE SPECIALITIES PRIVATE LIMITED",
"CYGNUS HOSPITAL",
"CYGNUS INFORMATION SOLUTIONS PRIVATE LIMITED",
"CYGNUS LOGISTICS PRIVATE LIMITED",
"CYGNUS MAGNUS HEALTHCARE PRIVATE LIMITED",
"CYGNUS MEDICARE P LIMITED",
"CYGNUS MEDICARE PRIVATE LIMITED",
"CYGNUS MICRO SYSTEMS PRIVATE LIMITED",
"CYGNUS MLS SUPERSPECIALITY HOSPITAL",
"CYGNUS NEGRI INVESTMENTS PRIVATE LIMITED",
"CYGNUS ORTHOCARE HOSPITAL",
"CYGNUS PULSUS HEALTHCARE PRIVATE LIMITED",
"CYGNUS SALES & SERVICES PRIVATE LIMITED",
"CYGNUS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"CYGNUS SPLENDID LIMITED",
"CYGNUS TECHNICAL SERVICES PRIVATE LIMITED",
"CYGNUS TECHNOLOGIES PRIVATE LIMITED",
"CYGNUS WORD SCHOOL",
"CYGNUX SOFTTECH PRIVATE LIMITED",
"CYIENT DLM LIMITED",
"CYIENT DLM PRIVATE LIMITED",
"CYIENT INSIGHTS PRIVATE LIMITED",
"CYIENT LIMITED",
"CYKLOP PACKAGING SYSTEMS (INDIA) PRIVATE LIMITED",
"CYLOS CONSULTING PRIVATE LIMITED",
"CYLSYS SOFTWARE SOLUTION PRIVATE LIMITED",
"CYLUS CREATORS PRIVATE LIMITED",
"CYLUX LOGISTICS AND SOFTWARE PRIVATE LIMITED",
"CYMA HOSPITALITY VENTURES PRIVATE LIMITED",
"CYMA LIFE SUNCES PRIVATE LIMITED",
"CYMBIO PHARMA PRIVATE LIMITED",
"CYMBIOTICS BIOPHARMA PRIVATE LIMITED",
"CYMETRIX SOFTWARE PRIVATE LIMITED",
"CYMPL STUDIOS PRIVATE LIMITED",
"CYMUNE CYBER SECURITIES PRIVATE LIMITED",
"CYNAX AANNAAPURNA UDYOG PRIVATE LIMITED",
"CYNERGY TRADING CORP",
"CYNET SYSTEMS PRIVATE LIMITED",
"CYNOR INGREDIENTS PRIVATE LIMITED",
"CYNOSURE BIOTECH PRIVATE LIMITED",
"CYNOSURE ELECTRIC COMPANY PVT LTD",
"CYNOSURE HOMES PRIVATE LIMITED",
"CYNOSURE TECHNOLOGIES PRIVATE LIMITED",
"CYNOTECK TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"CYNTEXA LABS PRIVATE LIMITED",
"CYONICS CYTO SOLUTIONS PRIVATE LIMITED",
"CYPER PHARMA",
"CYPET TECHNOLOGIES INDIA PRIVATE LIMITED",
"CYPHEROX TECHNOLOGIES PRIVATE LIMITED",
"CYPHERTREE TECHNOLOGIES PRIVATE LIMITED",
"CYPLUS TECHNOLOGY PRIVATE LIMITED",
"CYPRESS AUTO PRIVATE LIMITED",
"CYPRESS INDUSTRIES INDIA PRIVATE LIMITED",
"CYPRESS SOFTWARE PRIVATE LIMITED",
"CYPRESS SOLUTIONS PRIVATE LIMITED",
"CYPRESS TRADESERVE PRIVATE LIMITED",
"CYQUATOR MEDIA SERVICES PRIVATE LIMITED",
"CYQUENT INFOTECH PRIVATE LIMITED",
"CYQUREX SYSTEMS PRIVATE LIMITED",
"CYRAAC SERVICES PRIVATE LIMITED",
"CYRAN AI SOLUTIONS PRIVATE LIMITED",
"CYRET TECHNOLOGIES INDIA PRIVATE LIMITED",
"CYRIL AMARCHAND MANGALDAS AND CO",
"CYRIL ROY CONSULTANCY PRIVATE LIMITED",
"CYRIL TRADERS PRIVATE LIMITED",
"CYRIX HEALTHCARE PRIVATE LIMITED",
"CYRIX INFOTECH PRIVATE LIMITED",
"CYRONICS INNOVATION LABS PRIVATE LIMITED",
"CYRUS AUTOMATION INDIA LIMITED",
"CYRUS ELECTRONICS PRIVATE LIMITED",
"CYRUS HOSPITAL",
"CYRUS INVESTMENTS PRIVATE LIMITED",
"CYRUS RECLAIMER AND ENGINEERING SERVICES PRIVATE LIMITED",
"CYRUS TECHNOEDGE SOLUTIONS PRIVATE LIMITED",
"CYRUS YEAST PVT LTD",
"CYRUS-XP HEALTH INFORMATION TECHNOLOGY PRIVATE LIMITED",
"CYSIV SECURITY PRIVATE LIMITED",
"CYSPAN SYSTEMS PRIVATE LIMITED",
"CYSTEMS LOGIC PRIVATE LIMITED",
"CYSTRON PHARMA PRIVATE LIMITED",
"CYTECARE HOSPITALS PRIVATE LIMITED",
"CYTECH COATINGS PRIVATE LIMITED",
"CYTEL STATISTICAL SOFTWARE & SERVICES PRIVATE LIMITED",
"CYTESPACE RESEARCH PRIVATE LIMITED",
"CYTOCARE TECHNOLOGIES PRIVATE LIMITED",
"CYTOCHEM HEALTHCARE INDIA PRIVATE LIMITED",
"CYTOCHROME LIFE SCIENCES PRIVATE LIMITED",
"CYTOCURE MEDICARE PRIVATE LIMITED",
"CYTOX INDIA PRIVATE LIMITED",
"CYWARE LABS INDIA PRIVATE LIMITED",
"CYZA CHEM PRIVATE LIMITED",
"CYZER DISTRIBUTION OPC PRIVATE LIMITED",
"CZAR BUILDCON PRIVATE LIMITED",
"CZAR EXPORTS PRIVATE LIMITED",
"CZAR FAUCETS LIMITED",
"CZAR FURNITURE PRIVATE LIMITED",
"CZAR HOMES PRIVATE LIMITED",
"CZAR INFRASTRUCTURE PRIVATE LIMITED",
"CZAR TECHNOLOGIES PRIVATE LIMITED",
"CZARIAN BUSINESS SOLUTIONS PRIVATE LIMITED",
"CZARTECH INNOVATIONS PRIVATE LIMITED",
"D - SOL FACILITIES PRIVATE LIMITED",
"D & A INTERNATIONAL PRIVATE LIMITED",
"D & C DEVELOPERS PRIVATE LIMITED",
"D & F SHINE SERVICES PRIVATE LIMITED",
"D & G HOLIDAYS PRIVATE LIMITED",
"D & H BLURB COMMUNICATION LIMITED",
"D & H INDIA LIMITED",
"D & H SECHERON ELECTRODES PVT LTD",
"D & J CREATION LLP",
"D & M MACHINE TOOLS",
"D & O VENTURES PRIVATE LIMITED",
"D & T TRADERS PRIVATE LIMITED",
"D .K. B. NIRMAN PRIVATE LIMITED",
"D A CHETNA PRAKASHAN PRIVATE LIMITED",
"D A DISTRIBUTORS PRIVATE LIMITED",
"D A P AGRO PRODUCTS PRIVATE LIMITED",
"D A STUART INDIA PRIVATE LIMITED",
"D A V COLLEGE KANPUR",
"D A V PG COLLEGE",
"D A V POLICE PUBLIC SCHOOL",
"D A V SCHOOL OF BUSINESS MANAGEMENT",
"D AIVA ENGINEERING PRIVATE LIMITED",
"D AMIES TECHNOLOGIES PRIVATE LIMITED",
"D AND A FINANCIAL SERVICES PRIVATE LIMITED",
"D AND B ENTERPRISES PRIVATE LIMITED",
"D AND C HOSPITALITY SERVICES PRIVATE LIMITED",
"D AND G MACHINES TECHNOLOGY PRIVATE LIMITED",
"D AND H SECHERON INFRASTRUCTURE PRIVATE LIMITED",
"D AND J RESORTS PRIVATE LIMITED",
"D AND M BUILDING PRODUCTS PRIVATE LIMITED",
"D AND M CABLES PRIVATE LIMITED",
"D AND U HEALTHAGE PRIVATE LIMITED",
"D B BANDODKAR AND SONS PRIVATE LIMITED",
"D B CORP LIMITED",
"D B ELECTRICALS PRIVATE LIMITED",
"D B GROUP INDIA PRIVATE LIMITED",
"D B INFRASTRUCTURES PRIVATE LIMITED",
"D B INSTITUTE OF MANAGEMENT AND RESEARCH MAHALANGRA",
"D B MALLS PRIVATE LIMITED",
"D B PADHIYAR INFRA PRIVATE LIMITED",
"D B POWER LIMITED",
"D B S COLLEGE KANPUR",
"D B S COMMERCE PRIVATE LIMITED",
"D B S CONSTRUCTIONS PRIVATE LIMITED",
"D B S ENGINEERS PRIVATE LIMITED",
"D B SANTOKH SINGH KHALSA INTER COLLEGE",
"D B V COTTON MILLS PRIVATE LIMITED",
"D C DYES AND PIGMENTS PRIVATE LIMITED",
"D C ENGINEERS PRIVATE LIMITED",
"D C FASTNERS PRIVATE LIMITED",
"D C GURBAXANI INFRASTRUCTURE PRIVATE LIMITED",
"D C JOHAR AND SONS PRIVATE LIMITED",
"D C KASLIWAL AND ASSOCIATES PRIVATE LIMITED",
"D C M LIMITED",
"D C PATEL SCHOOL ARCHITECTURE",
"D C PROJECTS PRIVATE LIMITED",
"D C PROPERTIES PRIVATE LIMITED",
"D C R TRAVELS PRIVATE LIMITED",
"D C STORE PRIVATE LIMITED",
"D C SYNTHETICS PVT LTD",
"D C TEXTILE MILLS PRIVATE LIMITED",
"D C TRANSPORT MANAGEMENT PRIVATE LIMITED",
"D CARNIVAL FOODS & BEVERAGES PRIVATE LIMITED",
"D CORP AGRO FOODS PRIVATE LIMITED",
"D D COTTON PRIVATE LIMITED",
"D D DEVELOPERS PRIVATE LIMITED",
"D D GEARS PRIVATE LTD",
"D D HARDWARE PRIVATE LIMITED",
"D D INDUSTRIES LIMITED",
"D D MARITIME PRIVATE LIMITED",
"D D MARKETING PRIVATE LIMITED",
"D D O PCCITWB AND S KOLKATA",
"D D PHARMACEUTICALS PRIVATE LIMITED",
"D D PLYWOOD PVT LTD",
"D D PROJECT SERVICES PRIVATE LIMITED",
"D D PUBLIC SCHOOL",
"D D SHAH FRAGRANCES PRIVATE LIMITED",
"D D STEEL",
"D D SYNTHETICS PRIVATE LIMITED",
"D D TRADING AND CO",
"D DAHYABHAI AND CO PRIVATE LIMITED",
"D DECOR EXPORTS PRIVATE LIMITED",
"D DECOR HOME FABRICS PRIVATE LIMITED",
"D DECOR HOME STORE LLP",
"D DEVENDRA BROS PRIVATE LIMITED",
"D E C ENGINEERING PRIVATE LIMITED",
"D E C INFRASTRUCTURE AND PROJECTS INDIA PRIVATE LIMITED",
"D E S SECONDARY SCHOOL",
"D E SHAW INDIA PRIVATE LIMITED",
"D E W ELECTRICAL SERVICES PRIVATE LIMITED",
"D ED COLLEGE C/O VINAYAKA EDUCATION SOCIETY D ED COLLEGE",
"D ENGINEERING PRIVATE LIMITED",
"D F S ENTERPRISES PRIVATE LIMITED",
"D FINE ART PRIVATE LIMITED",
"D FOREST OFFICER RATLAM",
"D FREEZO INDIA PRIVATE LIMITED",
"D G COPIERS (PUNE) PRIVATE LIMITED",
"D G EXPORTS PVT LTD",
"D G OIL AND FOODS PRIVATE LIMITED",
"D G TRADERS PRIVATE LIMITED",
"D GIPRO SYSTEMS PRIVATE LIMITED",
"D H EXPORTS PRIVATE LIMITED",
"D H O ALIGARH",
"D H POLYMERS PRIVATE LIMITED",
"D I INFOTECH LEADERS PRIVATE LIMITED",
"D INFO BUSINESS SERVICES LIMITED",
"D J AGRO INDUSTRIAL PROJECT PRIVATE LIMITED",
"D J EXPORTS PRIVATE LIMITED",
"D J GANDHI EDUCATION SOCIETY YAVATMAL",
"D J PROJECTS PRIVATE LIMITED",
"D J S PRINTERS PRIVATE LIMITED",
"D J SHAH SECURITIES PRIVATE LIMITED",
"D K ASSAM ASSOCIATES PRIVATE LIMITED",
"D K BIOPHARMA PRIVATE LIMITED",
"D K BUSINESS PATRON PRIVATE LIMITED",
"D K CERAMIC",
"D K CHEMICALS PRIVATE LIMITED",
"D K CLEARING AND SHIPPING AGENCY PRIVATE LIMITED",
"D K DIESELS PRIVATE LIMITED",
"D K EDIBLE OILS PRIVATE LIMITED",
"D K EXIM PRIVATE LIMITED",
"D K G SALES PRIVATE LIMITED",
"D K HOSPITALITY PRIVATE LIMITED",
"D K INDIA IMPORT-EXPORT PRIVATE LIMITED",
"D K JEWELLERS PRIVATE LIMITED",
"D K PHARMA CHEM PRIVATE LIMITED",
"D K PLYWOOD PRIVATE LIMITED",
"D K POLYPLAST PRIVATE LIMITED",
"D K POWER ENGINEERS PRIVATE LIMITED",
"D K Y SALES PRIVATE LIMITED",
"D KUMAR LAMI TUFF GLASSES PRIVATE LIMITED",
"D L INFRASTRUCTURE PRIVATE LIMITED",
"D L LOGISTICS PRIVATE LIMITED",
"D L MARATHE PRI SCHOOL",
"D L MILLAR & CO LTD",
"D L PATEL B SC NURSING COLLEGE",
"D L TANUMAL PRIVATE LIMITED",
"D L V N INT COLL GONDA ALIGARH",
"D LINK INDIA LIMITED",
"D M AGRO PRODUCTS PRIVATE LIMITED",
"D M ALKALIES PRIVATE LIMITED",
"D M B SWEETS PRIVATE LIMITED",
"D M K CASTINGS PVT LTD",
"D M OFFICE SOLUTIONS PRIVATE LIMITED",
"D M P PROJECTS PVT LTD",
"D M PATEL PHARMA PRIVATE LIMITED",
"D M PHARMA PRIVATE LIMITED",
"D M PLASTOPACK PRIVATE LIMITED",
"D M PUBLIC SCHOOL",
"D M S FOREX PRIVATE LIMITED",
"D M SHAH & COMPANY PVT LTD",
"D M SYSTEMS PRIVATE LIMITED",
"D M TRADING PVT LTD",
"D M W EXPORT PRIVATE LIMITED",
"D MANOHAR LAL (SHELLAC) PVT LTD",
"D MART AVENUE SUPERMARKETS LIMITED",
"D MORE FASHION PRIVATE LIMITED",
"D N AGRO PRODUCTS PRIVATE LIMITED",
"D N C CHITS PRIVATE LIMITED",
"D N CASTECH",
"D N COLD STORAGE PRIVATE LIMITED",
"D N ELECTRICALS PRIVATE LIMITED",
"D N G HOUSING NETWORK PRIVATE LIMITED",
"D N H SPINNERS PRIVATE LIMITED",
"D N HIGH SCHOOL",
"D N HIGH SCHOOL ANAND",
"D N POLYTECHNIC MEERUT",
"D N R SHOPPING PRIVATE LIMITED",
"D N RAMESH MERCHANDISE PRIVATE LIMITED",
"D N S FAB PRIVATE LIMITED",
"D N SECURITY & ALLIED SERVICES PRIVATE LIMITED",
"D N SINHA PVT LTD",
"D NAVINCHANDRA EXPORTS PRIVATE LIMITED",
"D NITIN & CO PRIVATE LIMITED",
"D ORDINAIRE INTERNATIONAL PRIVATE LIMITED",
"D P ABHUSHAN LIMITED",
"D P AUTO PARTS PRIVATE LIMITED",
"D P DESIGNS PRIVATE LIMITED",
"D P ENGINEERING INDUSTRIES LIMITED",
"D P F TEXTILES PRIVATE LIMITED",
"D P FOODS PRIVATE LIMITED",
"D P GARG AND COMPANY PVT LTD",
"D P GOYAL AUTOMOBILES PRIVATE LIMITED",
"D P H ELECTRICALS PRIVATE LIMITED",
"D P I EXIM PRIVATE LIMITED",
"D P JAIN DARIAPUR-JASONDHI ANNUITY ROAD PROJECTS PRIVATE. LIMITED.",
"D P JAIN DATIA - BHANDER TOLL ROAD PROJECTS PRIVATE. LIMITED.",
"D P JAIN UJJAIN PACKAGE ANNUITY ROAD PROJECTS PRIVATE. LIMITED.",
"D P K ENGINEERS PRIVATE LIMITED",
"D P LEATHERS PRIVATE LIMITED",
"D P N C ADVISORS PRIVATE LIMITED",
"D P PETROCHEM PRIVATE LIMITED",
"D P PUBLIC SCHOOL",
"D P R ENTERPRISES PRIVATE LIMITED",
"D P R FOODS PRIVATE LIMITED",
"D P R MOULDS AND MACHINERIES PRIVATE LIMITED",
"D P ROLLING MILLS PRIVATE LIMITED",
"D P WIRES LIMITED",
"D PAL BUILDCON PRIVATE LIMITED",
"D PAULS TRAVEL & TOURS LIMITED",
"D R AMIN MEMORIAL SCHOOL",
"D R B COMMODITIES INDIA PRIVATE LIMITED",
"D R BENFIT FUND LTD",
"D R BRIJMOHAN AND SONS PRIVATE LIMITED",
"D R BUILDERS AND PROMOTERS PRIVATE LIMITED",
"D R COMMODITIES PRIVATE LIMITED",
"D R CONSTRUCTION",
"D R DYECHEM (INDIA) PRIVATE LIMITED",
"D R G D & P M J SARV M P HIGH SCHOOL PARIYA",
"D R IMPEX PRIVATE LIMITED",
"D R INTERNATIONAL PRIVATE LIMITED",
"D R JOHNS LAB PHARMA PRIVATE LIMITED",
"D R JOHNS LAB PRIVATE LIMITED",
"D R MODULAR FURNITURE PRIVATE LIMITED",
"D R P AUTOMOTIVE PRIVATE LIMITED",
"D R PETROCHEM PVT LTD",
"D R PLASTO TECH PRIVATE LIMITED",
"D R POLYMERS PRIVATE LIMITED",
"D R STEEL CONSTRUCTION COMPANY PVT. LTD.",
"D R T PIPES PRIVATE LIMITED",
"D RAJA COTTON PRIVATE LIMITED",
"D RANFLEX INDIA PRIVATE LIMITED",
"D RAVILAL RESOURCE MANAGEMENT PRIVATE LIMITED",
"D S & CO (SREE PRESS) PRIVATE LIMITED",
"D S ACCESSORIES AND FOOTWEAR PRIVATE LIMITED",
"D S ALLOYD PRIVATE LIMITED",
"D S ARGADE PROMOTERS AND BUILDERS",
"D S BARI SCHOOL",
"D S C AUTO ENGINEERING WORKS PRIVATE LIMITED",
"D S CONTRACTORS PRIVATE LIMITED",
"D S D HOMES PRIVATE LIMITED",
"D S DATA SPEC PRIVATE LIMITED",
"D S DOORS (INDIA) LIMITED",
"D S DUCTOFAB SYSTEMS PRIVATE LIMITED",
"D S ENTERPRISES",
"D S FACILITY MANAGEMENT PRIVATE LIMITED",
"D S G CONSULTANTS PRIVATE LIMITED",
"D S HIGH SCHOOL",
"D S HOME CONSTRUCTION PRIVATE LIMITED",
"D S INFOTECH PRIVATE LIMITED",
"D S INKS PRIVATE LIMITED",
"D S INTEGRATED FINSEC PRIVATE LIMITED",
"D S KNIT INDUSTRY PRIVATE LIMITED",
"D S MITTLE AND CO (INDIA) PRIVATE LIMITED",
"D S PNEUMATICS COMPANY PRIVATE LIMITED",
"D S PUBLIC SCHOOL",
"D S R INFRASTRUCTURE PRIVATE LIMITED",
"D S RESEARCH CENTRE PRIVATE LIMITED",
"D S S COTTINFAB LIMITED",
"D S SUITINGS PRIVATE LIMITED",
"D S SYSTEMS PRIVATE. LIMITED.",
"D S TECHNO FEEDS PRIVATE LIMITED",
"D S TOURS & TRAVELS PRIVATE LIMITED",
"D S WOODTECH LTD",
"D SQUARE ASSOCIATES",
"D SQUARE TECH IMPEX PRIVATE. LIMITED.",
"D STRESS RETAIL PRIVATE LIMITED",
"D T I AUTOMATION PRIVATE LIMITED",
"D T MEDIA AND ENTERTAINMENT PRIVATE LIMITED",
"D TECH MEDICAL",
"D TECH SOLUTION INTEGRATORS PRIVATE LIMITED",
"D TECHMONKEY SOLUTION PRIVATE LIMITED",
"D TECHNOLOGY PRIVATE LIMITED",
"D' TRAVEL ACROSS PRIVATE LIMITED",
"D V DIAM PRIVATE LIMITED",
"D V ELECTROMATIC PRIVATE LIMITED",
"D V EQUIPMENTS PRIVATE LIMITED",
"D V FOREX PRIVATE LIMITED",
"D V MEDIA & ENTERTAINMENT PRIVATE LIMITED",
"D V MOTORS PRIVATE LIMITED",
"D V POLYMERS INDIA PRIVATE LIMITED",
"D V PROPERTIES PVT LTD",
"D V S INDUSTRIES PRIVATE LIMITED",
"D V S INSTITUTION",
"D V S MANAGMENT CONSULTING LLP",
"D VIJAY PHARMA PRIVATE LIMITED",
"D VOIS N SSV BROADBAND PRIVATE LIMITED",
"D WELL INFORMATICS AND SERVICES PRIVATE LIMITED",
"D Y PATIL AGRICULTURE AND TECHNICAL UNIVERSITY TALSANDE",
"D Y PATIL COLLEGE OF ENGINEERING & INNOVATION",
"D Y PATIL COLLEGE OF ENGINEERING AND TECHNOLOGY",
"D Y PATIL HOSPITAL",
"D Y PATIL INTERNATIONAL UNIVERSITY",
"D Y PATIL SHIKSHAN SANSTHA",
"D Y PATIL UNIVERSITY AMBI",
"D Y PATIL UNIVERSITY SCHOOL OF MEDICINE",
"D&D HEALTH CARES PRIVATE LIMITED",
"D&R BUSINESS SOLUTIONS PRIVATE LIMITED",
"D&V LOGISTIEK PRIVATE LIMITED",
"D&Y TECHNOLOGIES PRIVATE LIMITED",
"D,TAPINAL CHEMICALS PRIVATE LIMITED",
"D. A. V. KALI CHARAN HIGHER SECONDARY SCHOOL",
"D. ABRAHAM & SONS PRIVATE LIMITED",
"D. B. HEALTHCARE PRIVATE LIMITED",
"D. BALI INFRASTRUCTURES & DEVELOPERS LIMITED",
"D. C. AGENCIES PRIVATE LIMITED",
"D. C. STEELS LIMITED",
"D. CHANDRESH STEELS PRIVATE LIMITED",
"D. D. AGRO INDUSTRIES LIMITED",
"D. E. SHAW INDIA ADVISORY SERVICES PRIVATE LIMITED",
"D. F. EXPORTS PRIVATE LIMITED",
"D. G. LAND DEVELOPERS PRIVATE LIMITED",
"D. G. POLYPACK PRIVATE LIMITED",
"D. H. PROCON PRIVATE LIMITED",
"D. I. PACKAGING PRIVATE LIMITED",
"D. I. STEELS PRIVATE LIMITED",
"D. K. BASAK JEWELLERS PRIVATE LIMITED",
"D. K. CHAUHAN",
"D. K. FOREX PRIVATE LIMITED",
"D. K. GOLD JEWELLERY PRIVATE LIMITED",
"D. K. REALTORS & DEVELOPERS LIMITED",
"D. K. TISSUE & PAPERS PRIVATE LIMITED",
"D. M. SYNFAB PRIVATE LIMITED",
"D. NARESHKUMAR EXPORTS PRIVATE LIMITED",
"D. P. FAB BENGAL SAREES PRIVATE LIMITED",
"D. P. GARG EXPORTS PRIVATE. LIMITED.",
"D. P. PAPERS PRIVATE LIMITED",
"D. R. AGRAWAL INFRAVENTURES PRIVATE LIMITED",
"D. R. AIR BOOST PRIVATE LIMITED",
"D. R. KULKARNI LOGISTICS PRIVATE LIMITED",
"D. R. NOVEL ADVISORS PRIVATE LIMITED",
"D. RANILIA FABRICS PRIVATE LIMITED",
"D. S. DATAMATICS PRIVATE LIMITED",
"D. S. DEVELOPERS",
"D. S. GUPTA CONTRACTS LIMITED",
"D. S. JEWELLERS PRIVATE LIMITED",
"D. S. RANAWAT BUILDMAT PRIVATE LIMITED",
"D. S. TAILORS & READYMADES PRIVATE LIMITED",
"D. S. YARNS PRIVATE LIMITED",
"D. T. INFOCOMM PRIVATE LIMITED",
"D. V. BRAHME & SONS SALES & SERVICE PRIVATE LIMITED",
"D. V. PAWAR",
"D. VANSH ENTERPRISES",
"D. Y. PATIL ACADEMIC EDUCATION EXCELLENCE FEDERATION",
"D. Y. PATIL AGRICULTURE AND TECHNICAL UNIVERSITY",
"D. Y. PATIL EDUCATION SOCIETY",
"D.A.P. CONTAINERS PRIVATE LIMITED",
"D.A.R PARADISE PRIVATE LIMITED",
"D A R JEWELLERY PRIVATE LIMITED",
"D.A.V. CONTAINERS PRIVATE LIMITED",
"D.B TECHNOPLAST PRIVATE LIMITED",
"D.B. INFORMATICS PRIVATE LIMITED",
"D.B. MACHINE TOOLS PRIVATE LIMITED",
"D.B. ZAVERI PRIVATE LIMITED",
"D.C. HOIST & INSTRUMENTS PRIVATE LIMITED",
"D.C. PAUL GROUP CONSTRUCTION PRIVATE LIMITED",
"D.C. TELETRONICS PRIVATE LIMITED",
"D.C.L. DENCARE INDIA PRIVATE LIMITED",
"D.C.MEDIA NETWORKS PRIVATE LIMITED",
"D.C.RAKSHIT & SONS (I) PRIVATE LIMITED",
"D.D. ELECTRONIC EQUIPMENTS PRIVATE LIMITED",
"D.D. INTERNATIONAL INC.",
"D.D. PRADHAN AND CO. PRIVATE LIMITED",
"D.D. STEEL & POWER LIMITED",
"D.D. WAX PRIVATE LIMITED",
"D.D.BUILDERS LIMITED",
"D.D.I. MOTORS PRIVATE LIMITED",
"D.D.M EXPRESS LOGISTICS PRIVATE LIMITED",
"D.D.PACKERS PRIVATE LIMITED",
"D.D.SHAH PETROCHEM PRIVATE LIMITED",
"D.G.FAABS PRIVATE LIMITED",
"D.G.T. ENGINEERS PRIVATE LIMITED",
"D.H.PATEL AND ASSOCIATES PRIVATE LIMITED",
"D.I. MANAGEMENT INTERNATIONAL SERVICES PRIVATE LIMITED",
"D.I. PLAST INDIA PRIVATE LIMITED",
"D.J. BUILDERS PRIVATE LIMITED",
"D.J. ENTERPRISES LTD.",
"D.JAIN HOSIERY FACTORY (P) LTD.",
"D.K. ALLOYS PRIVATE LIMITED",
"D.K. ENTERPRISES GLOBAL LIMITED",
"D.K. POLYMERS PRIVATE LIMITED",
"D.K. PROJECT PRIVATE LIMITED",
"D.K. TEA INDUSTRIES PRIVATE LIMITED",
"D.K. TRIVEDI MARBLES PRIVATE LIMITED",
"D.K.AGENCIES PRIVATE LIMITED",
"D.K.PROCESS PRIVATE LIMITED",
"D.L. STEELS PRIVATE LIMITED",
"D.L.T. PUBLICATIONS PRIVATE LIMITED",
"D.M PREFAB STRUCTURES PRIVATE LIMITED",
"D.M. BUILDERS",
"D.M. INTERNATIONAL PRIVATE LIMITED",
"D.M. METALLOYS PRIVATE LIMITED",
"D.M. PULSES PRIVATE LIMITED",
"D.M.MULTITECH LIMITED",
"D.M.P. LOGISTICS PRIVATE LIMITED",
"D.M.P. NIRMAN PVT. LTD.",
"D.M.SERVICES PRIVATE LIMITED",
"D.N. ORNAMENTS PRIVATE LIMITED",
"D.N. PHARMACEUTICALS PRIVATE LIMITED",
"D.N. PLUMBING CONTRACTORS",
"D.N.A. AGRI SEEDS PRIVATE LIMITED",
"D.N.D. CONSTRUCTIONS PRIVATE LIMITED",
"D.NAVINCHANDRA GEMS LIMITED",
"D.P. BANSAL COMMERCIAL COMPANY PVT LTD",
"D.P. ELECTRICALS PRIVATE LIMITED",
"D.P. MEDICARE CLINICAL LABORATORIES PRIVATE LIMITED",
"D.P. PATEL ENGINEERS (I) PRIVATE LIMITED",
"D.P. SHAW METAL FOUNDRY PRIVATE LIMITED",
"D.P.C. ESTATE PRIVATE LIMITED",
"D.P.WELLNESS PRIVATE LIMITED",
"D.PAL LEASING AND FINANCE COMPANY LIMITED",
"D.R. BUILDESTATE PRIVATE LIMITED",
"D.R. COATS INK & RESINS PRIVATE LIMITED",
"D.R. DISTRIBUTORS PRIVATE LIMITED",
"D.R. G.SECURITY SERVICES PRIVATE LIMITED",
"D.R. SHARE & STOCK BROKERS PRIVATE LIMITED",
"D.R. STRIPS PRIVATE LIMITED",
"D.R.B. COMMERCIAL COMPANY PRIVATE LIMITED",
"D.R.HOTELS (NELLORE ) PRIVATE LIMITED",
"D.R.J. HOSPITAL PRIVATE LIMITED",
"D.S. HIGHWAY HOTELS PRIVATE LIMITED",
"D.S. MACHINE TOOLS PRIVATE LIMITED",
"D.S. METALLOYS PRIVATE LIMITED",
"D.S.E.S. INFRATECH PRIVATE LIMITED",
"D.S.ENTERPRISES PRIVATE.LIMITED",
"D.S.G. SHIP SERVICES PRIVATE LIMITED",
"D.S.GEO SERVICES PRIVATE LIMITED",
"D.S.M. SOLE PRODUCTS PRIVATE LIMITED",
"D.S.M.SOFT PRIVATE LIMITED",
"D.S.NARAYANA AND COMPANY PVT LTD",
"D.SAURABH TREXIM PRIVATE LIMITED",
"D.T.S. SERVICES PRIVATE LIMITED",
"D.V RUBBER INDUSTRIES PRIVATE LIMITED",
"D.V. K FIN-SEC PRIVATE LIMITED",
"D.V. STEEL INDUSTRIES PRIVATE LIMITED",
"D.V. TRADES LIMITED",
"D.V.J. BEARINGS PRIVATE LIMITED",
"D.V.S. STEEL PRIVATE LIMITED",
"D.V.S.ENGINEERING WORKS",
"D+H SOLUTIONS INDIA PRIVATE LIMITED",
"D1 FORTIFICATION PRIVATE LIMITED",
"D2 EXPORTS PRIVATE LIMITED",
"D2 INTERNATIONAL",
"D2C CONSULTING SERVICES PRIVATE LIMITED",
"D2D INTERNATIONAL PRIVATE LIMITED",
"D2D LOGISTICS PRIVATE LIMITED",
"D2H AGRO INPUTS LIMITED",
"D2K TECHNOLOGIES INDIA PRIVATE LIMITED",
"D2L PHARMA RESEARCH SOLUTIONS PRIVATE LIMITED",
"D2S INFRASTRUCTURES PRIVATE LIMITED",
"D2V SOFTWARE SOLUTIONS PRIVATE LIMITED",
"D3D SECURITY PRIVATE LIMITED",
"D3MINDS CYBER SOLUTION PRIVATE LIMITED",
"D3S ENGINEERING AND PROJECTS PRIVATE LIMITED",
"D3T PRIVATE LIMITED",
"D3V TECHNOLOGY SOLUTIONS INDIA PRIVATE LIMITED",
"D4 INSIGHT PRIVATE LIMITED",
"D4D SOFTWARE PRIVATE LIMITED",
"D4T4 SOLUTIONS PLC",
"D5 DESIGN FACTORY PRIVATE LIMITED",
"DA EGG FEEDS PRIVATE LIMITED",
"DA EGG INDUSTRIES PRIVATE LIMITED",
"DA ELECTROMATIONS PRIVATE LIMITED",
"DA MAKEUP LAB PRIVATE LIMITED",
"DA MILANO LEATHERS PRIVATE LIMITED",
"DA PACKAGING PRIVATE LIMITED",
"DA TOLL ROAD PRIVATE LIMITED",
"DA TRADETECH PRIVATE LIMITED",
"DA VINCI CLOTH & CONCEPT PRIVATE LIMITED",
"DA VINCI DESIGN SOLUTIONS PRIVATE LIMITED",
"DAA ELEMENTAL TECHIES PRIVATE LIMITED",
"DAAARTS INCORP PRIVATE LIMITED",
"DAADION HOSPITALITY PRIVATE LIMITED",
"DAALCHINI FOODS & BEVERAGES PRIVATE LIMITED",
"DAALCHINI TECHNOLOGIES PRIVATE LIMITED",
"DAANA FARMERS NETWORK PRIVATE LIMITED",
"DAANISH ELECTRICALS & SALES PRIVATE LIMITED",
"DAANISH SYSCOM LIMITED",
"DAANYA PHARMA PRIVATE LIMITED",
"DAASNAV SOLUTIONS PRIVATE LIMITED",
"DAASTA HOTELS AND RESORTS PRIVATE LIMITED",
"DAAU INDUSTRIES INDIA PRIVATE LIMITED",
"DAAWAT FOODS LIMITED",
"DAAWAT KAMEDA INDIA PRIVATE LIMITED",
"DAB.IRIS PRIVATE LIMITED",
"DABANG DUNIA PUBLICATIONS",
"DABANG EARTH MOVERS PRIVATE LIMITED",
"DABAS SECURITY & ALLIED SERVICES PRIVATE LIMITED",
"DABAWA FARMS LIMITED",
"DABBLE PLAYART PRIVATE LIMITED",
"DABBU TRANSPORT PRIVATE LIMITED",
"DABGRAM AGRO PRODUCTS PRIVATE LIMITED",
"DABIR PRECITECH PRIVATE LIMITED",
"DABLI & SOALI UNIVERSAL PRIVATE LIMITED",
"DABOYA TECHNOLOGIES PRIVATE LIMITED",
"DABRA AGRO PRIVATE LIMITED",
"DABROL KRISHNA DECORS PRIVATE LIMITED",
"DABS PACKAGING PRIVATE LIMITED",
"DABUR INDIA LIMITED",
"DABUR RESEARCH FOUNDATION",
"DABUR SECURITIES PRIVATE LIMITED",
"DABWALI AGRO STORAGE",
"DABWALI TRANSPORT COMPANY LIMITED",
"DAC AUTOMOTIVE PRIVATE LIMITED",
"DAC AVIATION SERVICES PRIVATE LIMITED",
"DAC ORGANICS PRIVATE LIMITED",
"DACAM SYSTEMS PRIVATE LIMITED",
"DACAPO BROKERAGE INDIA PRIVATE LIMITED",
"DACC INTERNATIONAL PRIVATE LIMITED",
"DACCA JEWELLERS PRIVATE LIMITED",
"DACCESS SECURITY SYSTEMS PRIVATE LIMITED",
"DACHEPALLI PUBLISHERS PRIVATE LIMITED",
"DACHSER INDIA PRIVATE LIMITED FORMERLY AFL DACHSER PRIVATE LIMITED",
"DACOTRANS INDIA PRIVATE LIMITED",
"DACOTRANS SUPPLYCHAIN PRIVATE LIMITED",
"DACS ELECTRO SYSTEMS PRIVATE LIMITED",
"DACSS GRANITES PRIVATE LIMITED",
"DACUNHA COMMUNICATIONS PRIVATE LIMITED",
"DAD CONSTRUCTION PRIVATE LIMITED",
"DADA ASSOCIATES",
"DADA BHAGWAN VIGNAN FOUNDATION",
"DADA ENERGIES PRIVATE LIMITED",
"DADA GANPATI GUAR PRODUCTS PRIVATE LIMITED",
"DADA JEETU BUILDCON PRIVATE LIMITED",
"DADA MOTORS PRIVATE LIMITED",
"DADA ORGANICS LIMITED",
"DADA RAMCHAND BAKHRU SINDHU MAHAVIDYALAYA",
"DADADEV MATRIAVUMSHISHU CHIKITSALAY",
"DADAGURU INFRASTRUCTURE PRIVATE LIMITED",
"DADAJEE DHACKJEE INFOTECH PRIVATE LIMITED",
"DADAJI SYSTEMS PRIVATE LIMITED",
"DADAKRUPA GLASS PRIVATE LIMITED",
"DADASAHEB DIGAMBAR SHANKAR PATIL ARTS COMMERCE AND SCIENCE COLLEGE",
"DADASAHEB GULABRAO BORASE AGRI VIDYALAY & JR COLLEGE OF SCIENCE KALAMBU",
"DADDA JI HOSPITALS PRIVATE LIMITED",
"DADDY AND FRIENDS CAFE LLP",
"DADEE CHEMICALS INFRA PRIVATE LIMITED",
"DADHA PHARMA DISTRIBUTION LIMITED",
"DADHA PHARMA PRIVATE LIMITED",
"DADHEECHI FOODS PRIVATE LIMITED",
"DADHI VALA MFRS. & CONSULTANTS PRIVATE LIMITED",
"DADHIBAMAN JEW INFRASTRUCTURE AND SUPPLIERS PRIVATE LIMITED",
"DADHIKAR HOTELS PRIVATE LIMITED",
"DADHIMATI CONTRACTING PRIVATE LIMITED",
"DADHIMATI SYNTEX PRIVATE LIMITED",
"DADI BICYCLE PRIVATE LIMITED",
"DADI INFRASTRUCTURE PRIVATE LIMITED.",
"DADI INSTITUTE OF ENGINEERING AND TECHNOLOGY",
"DADIJEE SALES PRIVATE LIMITED",
"DADIJEE STEEL MANUFACTURING & TRADING PRIVATE LIMITED",
"DADIJI STEELS LIMITED",
"DADMI TECHNOLOGIES PRIVATE LIMITED",
"DADOO CONSTRUCTIONS PRIVATE LIMITED",
"DADRA AND NAGAR HAVELI AND DAMAN AND DIU POWER DISTRIBUTION CORPORATION LIMITED",
"DADRA ANDN.HAVELI DAMAN ANDDIU SC\ST OBC ANDMIN.FIN ANDDEV.CORPN. LTD",
"DADRA EXIMP PRIVATE LIMITED",
"DADRA-NAGAR STEEL PRIVATE LIMITED",
"DADRI COMMERCIAL PRIVATE LIMITED",
"DADU JEWELLERS PRIVATE LIMITED",
"DADU MEDICAL CENTRE PRIVATE LIMITED",
"DADU PIPES PRIVATE LIMITED.",
"DADU PRECISION FASTENERS PRIVATE LIMITED",
"DADU PROCESSORS PRIVATE LIMITED",
"DADU STEEL AND POWER LIMITED",
"DADURAM INDUSTRIES PRIVATE LIMITED",
"DADU'S FASHIONS PRIVATE LIMITED",
"DADYSON TRAVELS PRIVATE LIMITED",
"DAE MYOUNG ENGINEERING INDIA PRIVATE LIMITED",
"DAE MYUNG TECH INDIA PRIVATE LIMITED",
"DAEBU AUTOMOTIVE SEAT INDIA PRIVATE LIMITED",
"DAECHANG INDIA SEAT COMPANY PRIVATE LIMITED",
"DAEDALUS LIFT & ACCESS EQUIPMENTS PRIVATE LIMITED",
"DAEHA PLASTIC COMPOUND INDIA PRIVATE LIMITED",
"DAEHEUNG INDIA AUTO-PARTS PRIVATE LIMITED",
"DAEIOU JEWELS PRIVATE LIMITED",
"DAEIOU PHARMACEUTICALS PRIVATE LIMITED",
"DAEJIN AUTOMOTIVE INDIA PRIVATE LIMITED",
"DAEJOO AUTOMOTIVE INDIA PRIVATE LIMITED",
"DAEJUNG MOPARTS PRIVATE LIMITED",
"DAEMO ENGINEERING INDIA PRIVATE LIMITED",
"DAEMON SOFTWARE AND SERVICES PRIVATE LIMITED",
"DAENYX INTERNATIONAL PRIVATE LIMITED",
"DAETWYLER GRAPHICS INDIA PRIVATE LIMITED",
"DAETWYLER SWISS TEC INDIA PRIVATE LIMITED",
"DAEWON INDIA AUTO PARTS PRIVATE LIMITED",
"DAEWOO COMMERCIAL COMPANY PVT LTD",
"DAEWOO L&T JV",
"DAEWOONG PHARMACEUTICAL (INDIA) PRIVATE LIMITED",
"DAEWOONG PHARMACEUTICAL CO. LIMITED",
"DAEWOOST INDIA PRIVATE LIMITED",
"DAEYOON HOSPITALITY AND CONSULTANCY PRIVATE LIMITED",
"DAF INTERNATIONAL PRIVATE LIMITED",
"DAFFODIL ACCORD TRADERS PRIVATE LIMITED",
"DAFFODIL DESIGNERS AND DEVELOPERS PRIVATE LIMITED",
"DAFFODIL DRUGS PRIVATE LIMITED",
"DAFFODIL ENGRAVERSINDIA PRIVATE LIMITED",
"DAFFODIL PHARMACHEM PRIVATE LIMITED",
"DAFFODIL REALTECH PRIVATE LIMITED",
"DAFFODIL SOFTWARE PRIVATE LIMITED",
"DAFFODILLS PHARMACEUTICAL LIMITED",
"DAFFODILS ENGLISH SCHOOL ASSOCIATION",
"DAFFODILS HIGH SCHOOL",
"DAFFODILS MULTIVENTURES PRIVATE LIMITED",
"DAFFODILS STUDY ABROAD PRIVATE LIMITED",
"DAFFOHILS LABORATORIES PRIVATE LIMITED",
"DAFFOWORTH PHARMACEUTICAL PRIVATE LIMITED",
"DAFFY COSMETICS PRIVATE LIMITED",
"DAFFY ENTERPRISES PRIVATE LIMITED",
"DAFFY HEALTHCARE PRIVATE LIMITED",
"DAFODIL HOSPITALS PRIVATE LIMITED",
"DAFODIL TIE UP PRIVATE LIMITED",
"DAFTARI AGRO BIOTECH PRIVATE LIMITED",
"DAFTARI AGRO PRIVATE LIMITED",
"DAFTARI AUTOMOBILES (INDIA) PRIVATE LIMITED",
"DAFTARI COTSPIN PRIVATE LIMITED",
"DAFTARI DEVELOPERS PRIVATE LIMITED",
"DAFTARI MEGAMART PRIVATE LIMITED",
"DAFTARI TEA ESTATE PVT LTD",
"DAFTARI TEXTILES PRIVATE LIMITED",
"DAFTARY DESCON ENGINEERING PRIVATE LIMITED",
"DAG CONSULTANTS PRIVATE LIMITED",
"DAG PRIVATE LIMITED",
"DAG PROCESS INSTRUMENTS PRIVATE LIMITED",
"DAGA AGRIFARMS PRIVATE LIMITED",
"DAGA AUTO DISTRIBUTORS",
"DAGA AYURVEDIC AND COSMETICS PRIVATE LIMITED",
"DAGA BUSINESS (INTERNATIONAL) STOCK BROKERS (IFSC) PRIVATE LIMITED",
"DAGA CAPITAL MANAGEMENT PRIVATE LIMITED",
"DAGA CERAMICS PRIVATE LIMITED",
"DAGA CLAYS PRIVATE LIMITED",
"DAGA CROP CARE PRIVATE LIMITED",
"DAGA DEVELOPERS PRIVATE LIMITED",
"DAGA FINMARK INDIA LTD",
"DAGA FINVEST PRIVATE LIMITED",
"DAGA GEMS & JEWELLERY PRIVATE LIMITED",
"DAGA GLOBAL CHEMICALS LIMITED",
"DAGA HOSPITAL",
"DAGA IMPEX PRIVATE LIMITED",
"DAGA IMPORTERS & DISTRIBUTORS PRIVATE LIMITED",
"DAGA INFRATECH PRIVATE LIMITED",
"DAGA LOGISTICS PRIVATE LIMITED",
"DAGA MARKETING PVT LTD",
"DAGA POLY CONTAINERS PVT. LTD.",
"DAGA POLY LAMINATORS PRIVATE LIMITED",
"DAGA POLYMERS PRIVATE LIMITED",
"DAGA POLYPACK PRIVATE LIMITED",
"DAGA POWER SYSTEMS & ENGINEERS PRIVATE LIMITED",
"DAGA PROCON PRIVATE LIMITED",
"DAGA SHEETS AND UTENSILS PRIVATE LIMITED",
"DAGA STRIPS PRIVATE LIMITED",
"DAGA SUMATI GHEWAR STEELS PRIVATE LIMITED",
"DAGA TRADING COMPANY PRIVATE LIMITED",
"DAGAR HOSPITALITY AND INFRASTRUCTURE PRIVATE LIMITED",
"DAGAR INDUSTRIES PRIVATE LIMITED",
"DAGAR POWER PROJECTS PRIVATE LIMITED",
"DAGASUMATI STEEL INDUSTRIES PRIVATE LIMITED",
"DAGDAJIRAO DESHMUKH ART COLLEGE",
"DAGGER DIE CUTTING INDIA PRIVATE LIMITED",
"DAGINA JEWELLERS INDIA PRIVATE LIMITED",
"DAGLIA AGRO-VET LIMITED",
"DAGON PHARMACEUTICALS PRIVATE LIMITED",
"DAGROWAVE AGSCIENCE PRIVATE LIMITED",
"DAGUR INFRA REALTY PRIVATE LIMITED",
"DAHARIA POLYCHEM INDUSTRIES PRIVATE LIMITED",
"DAHEJ HARBOUR AND INFRASTRUCTURE LIMITED",
"DAHEJ SEZ LIMITED",
"DAHISAR DISTILLERIES PRIVATE LIMITED",
"DAHISAR TRADERS PRIVATE LIMITED",
"DAHIYA TIMBER PRIVATE LIMITED",
"DAHLIA TECHNOLOGIES PRIVATE LIMITED",
"DAHNAY LOGISTICS PRIVATE LIMITED",
"DAHOD SMART CITY DEVELOPMENT LIMITED",
"DAHUA TECHNOLOGY INDIA PRIVATE LIMITED",
"DAHYABHAI B. PATEL",
"DAI NIPPON TECHNO GRAPHICS PRIVATE LIMITED",
"DAICEL CHIRAL TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"DAICEL CHIRAL TECHNOLOGIES INDIA PRIVATE LIMITED",
"DAICEL SAFETY SYSTEMS INDIA PRIVATE LIMITED",
"DAI-CHI COOLING SOLUTIONS PRIVATE LIMITED",
"DAICHI OVERSEAS PVT LTD",
"DAIDO D.M.S. INDIA PRIVATE LIMITED",
"DAIDO INDIA PRIVATE LIMITED",
"DAIDO KOGYO INDIA PRIVATE LIMITED",
"DAIFUKU INDIA PRIVATE LIMITED",
"DAIFUKU INTRALOGISTICS INDIA PRIVATE LIMITED",
"DAIICHI CHUO SHIPPING (INDIA) PRIVATE LIMITED",
"DAIICHI INFOTAINMENT SYSTEMS PRIVATE LIMITED",
"DAIICHI JITSUGYO INDIA PRIVATE LIMITED",
"DAIICHI JITSUGYO THAILAND CO LIMITED",
"DAI-ICHI KARKARIA LIMITED",
"DAIICHI KOGYO INDIA PRIVATE LIMITED",
"DAIICHI N HORIZON AUTOCOMP PRIVATE LIMITED",
"DAI-ICHI TOOLS CORPORATION PRIVATE LIMITED",
"DAIICHIKOUTSU INDIA PRIVATE LIMITED",
"DAIKAFFIL CHEMICALS INDIA LIMITED",
"DAIKAI ENGINEERING (INDIA) PRIVATE LIMITED",
"DAIKI ALUMINIUM INDUSTRY INDIA PRIVATE LIMITED",
"DAIKI AXIS INDIA PRIVATE LIMITED",
"DAIKIN AIRCONDITIONING INDIA PRIVATE LIMITED",
"DAIKO FROM HERE ON COMMUNICATIONS PRIVATE LIMITED",
"DAIKON PHARMACEUTICALS PRIVATE LIMITED",
"DAILMER INDUSTRIES PRIVATE LIMITED",
"DAILY FRESH FRUITS INDIA PRIVATE. LIMITED.",
"DAILY GONG FINANCIAL SERVICES LIMITED",
"DAILY MILAP PRIVATE LIMITED",
"DAILY MULTIMEDIA LIMITED",
"DAILY NEED EXIM PRIVATE LIMITED",
"DAILY PRABHAT AND POONA DAILY NEWS PRIVATE LIMITED",
"DAILY THANTHI PRIVATE LIMITED",
"DAILYNINJA DELIVERY SERVICES PRIVATE LIMITED",
"DAILYRAVEN TECHNOLOGIES PRIVATE LIMITED",
"DAIMLER INDIA COMMERCIAL VEHICLES PRIVATE LIMITED",
"DAIMLER TRUCK INNOVATION CENTER INDIA PRIVATE LIMITED",
"DAIMOND ENTERPRISES",
"DAIMOND RICE PRIVATE LIMITED",
"DAINICHI COLOR INDIA PRIVATE LIMITED",
"DAINIK BHASKAR GROUP",
"DAINIK JAGRAN-INEXT DJ-INEXT VNS",
"DAINIK RAMPRAHAR UNIT OF MALHAR NETWORK PRIVATE LIMITED",
"DAIPAYAN AGRO FOOD PRODUCT PRIVATE LIMITED",
"DAIROX INDIA PRIVATE LIMITED",
"DAIRY AUTOMATION PRIVATE LIMITED",
"DAIRY CLASSIC ICE CREAMS PRIVATE. LIMITED.",
"DAIRY CROP TECHNOLOGIES PRIVATE LIMITED",
"DAIRY INDIA PRIVATE LIMITED",
"DAIRY SCIENCE COLLEGE",
"DAIRYCRAFT (INDIA) PRIVATE LIMITED",
"DAIRYFLEX PACKAGING SOLUTIONS PRIVATE LIMITED",
"DAIRYKART AGRO PRIVATE LIMITED",
"DAIRYLINE FOOD PRIVATE LIMITED",
"DAIRYMAN PRODUCER COMPANY LIMITED",
"DAIRYWELL ENGINEERING INDIA PRIVATE LIMITED",
"DAISHI PATONA PRIVATE LIMITED",
"DAISY DEVELOPERS PRIVATE LIMITED",
"DAISY HOLDINGS PRIVATE LIMITED",
"DAITARI SATYABHAMA INFRASTRUCTURES PRIVATE LIMITED",
"DAIVYA AAHAR PRIVATE LIMITED",
"DAIVYA INFRAPROJECTS PRIVATE LIMITED",
"DAIWA ASSET MANAGEMENT INDIA PRIVATE LIMITED",
"DAIWA CAPITAL MARKETS INDIA PRIVATE LIMITED",
"DAIWA CORPORATE ADVISORY INDIA PRIVATE LIMITED",
"DAIWA HOUSE INDUSTRY CO LIMITED",
"DAIWA KASEI INDIA PRIVATE LIMITED",
"DAIWIK CREATIONS PRIVATE LIMITED",
"DAIWIK HOTELS PRIVATE. LIMITED.",
"DAIWIK HOUSING PRIVATE LIMITED",
"DAIWIK INFRACON PRIVATE LIMITED",
"DAIWIK JEWELLERS PRIVATE LIMITED",
"DAIWIK PHARMASPHERE PRIVATE LIMITED",
"DAJ JEWELLERS PRIVATE LIMITED",
"DAJIKAKA GADGIL DEVELOPERS PRIVATE LIMITED",
"DAJINA INFRA LLP",
"DAK IT HUB PRIVATE LIMITED",
"DAKA COMPANYC &C PRIVATE.LIMITED",
"DAKA MONOLITHICS PRIVATE LIMITED",
"DAKE HOSPITALS PRIVATE LIMITED",
"DAKHA CEILINGS PRIVATE LIMITED",
"DAKHXESH KHATRI GLOBAL SOURCING PRIVATE LIMITED",
"DAKS INDIA INDUSTRIES PRIVATE LIMITED",
"DAKSH AUTO (INDIA) PRIVATE LIMITED",
"DAKSH AUTOMOTIVE PRIVATE LIMITED",
"DAKSH BUILDCON PRIVATE LIMITED",
"DAKSH DETECTIVE AND SECURITY SERVICES PRIVATE LIMITED",
"DAKSH DREAM HOLIDAYS PRIVATE LIMITED",
"DAKSH ELECTRONICS PRIVATE LIMITED",
"DAKSH ENGINEERING CORPORATION",
"DAKSH ENTERPRISES",
"DAKSH FACILITY PRIVATE LIMITED",
"DAKSH FINANCIAL SERVICES PRIVATE LIMITED",
"DAKSH FINQ PRIVATE LIMITED",
"DAKSH FOODS PRIVATE LIMITED",
"DAKSH GRANISTONE PRIVATE LIMITED",
"DAKSH INFRACON PRIVATE LIMITED",
"DAKSH KNOWLEDGE VENTURE PRIVATE LIMITED",
"DAKSH MINERALS AND MARINE PRIVATE LIMITED",
"DAKSH POLY PACK PRIVATE LIMITED",
"DAKSH SECURITAS PRIVATE LIMITED",
"DAKSH SHIPPING SERVICES PRIVATE LIMITED",
"DAKSH WEAVES PRIVATE LIMITED",
"DAKSH WIRE AND PIN PRIVATE LIMITED",
"DAKSHA GRANITES PRIVATE LIMITED",
"DAKSHA INFRASTRUCTURE PRIVATE LIMITED",
"DAKSHA ONLINE SERVICES PRIVATE LIMITED",
"DAKSHA POLYMERS PRIVATE LIMITED",
"DAKSHABHI IT SOLUTIONS PRIVATE LIMITED",
"DAKSHAH EBIZ CONSULTING PRIVATE LIMITED",
"DAKSHANA INDIA EDUCATIONAL TRUST FUND",
"DAKSHANA INDIAN EDUCATION TRUST FUND",
"DAKSHASHREE INFRA PROJECTS PRIVATE LIMITED",
"DAKSHAYANI INFRACITY PRIVATE LIMITED",
"DAKSHDEV VENTURES PRIVATE LIMITED",
"DAKSHIN BAGUNDI PL HIGH SCHOOL",
"DAKSHIN BHARAT GATEWAY TERMINAL PRIVATE LIMITED",
"DAKSHIN BHARATH AERA SIGNAL COMPANY",
"DAKSHIN BIHAR GRAMIN BANK",
"DAKSHIN CAPITAL PRIVATE LIMITED",
"DAKSHIN DILLI SWACHH INITIATIVES PRIVATE LIMITED",
"DAKSHIN FOUNDRY PRIVATE LIMITED",
"DAKSHIN GUJARAT VIJ COMPANY LIMITED",
"DAKSHIN HARYANA BIJLI VITRAN NIGAM",
"DAKSHIN INFRASTRUCTURES PRIVATE LIMITED",
"DAKSHIN KASHIABAD SIKSHANIKETAN",
"DAKSHIN ODISHA URJA PRIVATE LIMITED",
"DAKSHIN PLASTICS PRIVATE LIMITED",
"DAKSHIN REALITIES PRIVATE. LIMITED.",
"DAKSHINAMURTI GLASS & CERAMIC PRIVATE LIMITED",
"DAKSHINAMURTI PHARMA PRIVATE LIMITED",
"DAKSHINANCHAL VIDYUT VITRAN NIGAM LIMITED",
"DAKSHINESWARI COLD STORAGE PRIVATE LIMITED",
"DAKSHKANYA COLD STORAGE PRIVATE LIMITED",
"DAKSHYA INFRA DEVELOPERS PRIVATE LIMITED",
"DAKSHYA MULTITRADE PRIVATE LIMITED",
"DAL GLOBAL TECHNOLOGY HUB LLP",
"DALAL ADVISORY SERVICES PRIVATE LIMITED",
"DALAL AGRO PRIVATE LIMITED",
"DALAL AND BROACHA PORTFOLIO MANAGERS PRIVATE LIMITED",
"DALAL AND BROACHA STOCK BROKING PRIVATE LIMITED",
"DALAL AND SHAH FISCAL SERVICES LIMITED",
"DALAL ENGINEERING PRIVATE LIMITED",
"DALAL MACHINE TOOLS AGENCY PRIVATE LIMITED",
"DALAL MCKENNA PRIVATE LIMITED",
"DALAL PLASTICS PRIVATE LIMITED",
"DALAL STREET INVESTMENTS LIMITED",
"DALAL TILES PRIVATE LIMITED",
"DALAS BFORMATION PRIVATE LIMITED",
"DALAS BIOTECH LIMITED",
"DALBERG DEVELOPMENT ADVISORS PRIVATE LIMITED",
"DALBIR SONS JEWELLERS PRIVATE LIMITED",
"DALCHEMY LABS INDIA PRIVATE LIMITED",
"DALCO CLOTHING PRIVATE LIMITED",
"DALE AND CARRINGTON INVESTMENTS PVT LTD",
"DALE FILTER SYSTEMS PRIVATE LIMITED",
"DALE MANAGEMENT SERVICES PRIVATE LIMITED",
"DALFO FLEXIPACK PRIVATE LIMITED",
"DALFON CHEMICALS INDIA PRIVATE LIMITED",
"DALGONA TECHNOLOGIES PRIVATE LIMITED",
"DALGREEN AGRO PRIVATE LIMITED",
"DALHA EXPORT PVT LTD",
"DALHOUSIE HOLDINGS LTD",
"DALHOUSIE PROPERTIES LTD",
"DALHOUSIE PUBLIC SCHOOL",
"DALHYD TECHNOLOGY PRIVATE LIMITED",
"DALI & SAMIR ENGINEERING PRIVATE LIMITED",
"DALIA INSTITUTE OF DIPLOMA STUDIES",
"DALIA MOTORS PRIVATE LIMITED",
"DALIAH BEVERAGES INDIA PRIVATE LIMITED",
"DALIAN HUARUI HEAVY INDUSTRY INDIA COMPANY PRIVATE LIMITED",
"DALICHAND KAPURCHAND JEWELLERS PRIVATE LIMITED",
"DALIMGAON AGROTECH PRIVATE LIMITED",
"DALIMSS SUNBEAM SCHOOL",
"DALIP TRADING PRIVATE LIMITED",
"DALISOFT TECHNOLOGIES PRIVATE LIMITED",
"DALIT INDIAN CHAMBER OF COMMERCE AND INDUSTRY",
"DALJEET & CO. PRIVATE LIMITED",
"DALKAN SHIP BREAKING LIMITED",
"DALLAS FORMULATIONS PRIVATE LIMITED",
"DALMATE TECHNOLOGIES PRIVATE LIMITED",
"DALMEC INDUSTRIAL MANIPULATORS INDIA PRIVATE LIMITED",
"DALMIA BHARAT LIMITED",
"DALMIA BHARAT REFRACTORIES LIMITED",
"DALMIA BHARAT SUGAR AND INDUSTRIES LIMITED",
"DALMIA BIZ BULK PRIVATE LIMITED",
"DALMIA BROTHERS PRIVATE LIMITED",
"DALMIA CEMENT BHARAT LIMITED",
"DALMIA CEMENT EAST LIMITED",
"DALMIA CEMENT VENTURES LIMITED",
"DALMIA CHEMICALS LTD",
"DALMIA CONSOLIDATED PRIVATE LIMITED",
"DALMIA CONTINENTAL PRIVATE LIMITED",
"DALMIA DESIGNER INDIA PRIVATE LIMITED",
"DALMIA HEALTHCARE LIMITED",
"DALMIA IMPEX PVT LTD",
"DALMIA IT SOLUTIONS PRIVATE LIMITED",
"DALMIA LAMINATORS LIMITED",
"DALMIA LIFE CARE PRIVATE LIMITED",
"DALMIA POLYAMIDE PRIVATE LIMITED",
"DALMIA POLYMERS LLP",
"DALMIA POLYPRO INDUSTRIES PRIVATE LIMITED",
"DALMIA POWER LIMITED",
"DALMIA PPOLYTEX PRIVATE LIMITED",
"DALMIA REFRACTORIES LIMITED",
"DALMIA RESORTS INTERNATIONAL PRIVATE LIMITED",
"DALMIA SAREES PRIVATE LIMITED",
"DALMIA SECURITIES PRIVATE LIMITED",
"RHI MAGNESITA SEVEN REFRACTORIES LIMITED",
"DALMIA SONS INDIA PRIVATE LIMITED",
"DALMIA TEA MARKETING PRIVATE LIMITED",
"DALMIA TEA PACKAGING PRIVATE LIMITED",
"DALMIA WOVEN SACKS PRIVATE LIMITED",
"DALMIABIZ RETAIL PRIVATE LIMITED",
"DALMORE TEA ESTATE PRIVATE LIMITED",
"DALOWJAN TEA CO PVT LTD",
"DALPAT TEXTILE PRIVATE LIMITED",
"DALSINGPARA TEA ESTATE PRIVATE LIMITED",
"DALSONS CROP SCIENCE PRIVATE LIMITED",
"DALTON INVESTMENT ADVISORY SERVICES PRIVATE LIMITED",
"DALTON JUNIOR COLLEGE",
"DALTON MINES AND MINERALS PRIVATE LIMITED",
"DALVKOT UTILITY ENTERPRISES PRIVATE LIMITED",
"DALWIN MARINE TURBO ENGG PRIVATE LIMITED",
"DALY COLLEGE",
"DALZTEK ONLINE SERVICES INDIA PRIVATE LIMITED",
"DAM CAPITAL ADVISORS LIMITED",
"DAM GOOD RESTAURANTS PRIVATE LIMITED",
"DAMAKA COMMUNICATION AND COLLABORATION PRIVATE LIMITED",
"DAMALIS BUILDERS & DEVELOPERS PRIVATE LIMITED",
"DAMAN GANGA BOARD MILLS PRIVATE LIMITED",
"DAMAN HOSPITALITY PRIVATE LIMITED",
"DAMAN MUNICIPAL COUNCIL DAMAN",
"DAMAN PLASTICS PRIVATE LIMITED",
"DAMAN POLYFAB PRIVATE LIMITED",
"DAMAN POLYTHREAD PRIVATE LIMITED",
"DAMAN RESEARCH & TESTING CENTER",
"DAMANI CASTINGS PRIVATE LIMITED",
"DAMANI DYESTUFF LIMITED",
"DAMANI ESTATES AND FINANCE PVT LTD",
"DAMANI FINANCIAL SERVICES PRIVATE LIMITED",
"DAMANI FREIGHTLINK PRIVATE LIMITED",
"DAMANI PACKAGING PVT LTD",
"DAMANI SHIPPING PRIVATE LIMITED",
"DAMANI SWIFT TRADE PRIVATE LIMITED",
"DAMAR INDIA PRIVATE LIMITED",
"DAMARA GOLD PRIVATE. LIMITED.",
"DAMAS CIVIL CONSTRUCTIONS INDIA PRIVATE LIMITED",
"DAMATI PLASTICS",
"DAMAYANTI ADVERTISING PRIVATE LIMITED",
"DAMAYANTI FARMERS PRODUCER COMPANY LIMITED",
"DAMBIR AND SONS PRIVATE LIMITED",
"DAMBS HOSPITALITY PRIVATE LIMITED",
"DAMCO ENGINEERING INDIA PRIVATE LIMITED",
"DAMCO INDIA PRIVATE LIMITED",
"DAMCO SOFT TECHNOLOGIES PRIVATE LIMITED",
"DAMCO SOLUTIONS PRIVATE LIMITED",
"DAMCOSOFT PRIVATE LIMITED",
"DAMERA MEDIFES PRIVATE LIMITED",
"DAMIAN BATH SOLUTIONS PRIVATE LIMITED",
"DAMIAN CORPORATE PRIVATE LIMITED",
"DAMIANI INDIA PRIVATE LIMITED",
"DAMICO SHIP ISHIMA INDIA PRIVATE LIMITED",
"DAMIKA INSURANCE BROKING COMPANY PRIVATE LIMITED",
"DAMINI FOOD PRODUCTS PRIVATE LIMITED",
"DAMINI RESORTS AND BUILDERS PRIVATE LIMITED",
"DAMINI SEEDS PRIVATE LIMITED",
"DAMJI HARI INFRASTRUCTURE PRIVATE LIMITED",
"DAMODAR AGRO INDUSTRIES PRIVATE LIMITED",
"DAMODAR BOLTS AND NUTS INDIA PRIVATE LIMITED",
"DAMODAR CHAKUBHAI MEWA MASALA PRIVATE LIMITED",
"DAMODAR CHAKUBHAI OIL AND VEGETABLES PRIVATE LIMITED",
"DAMODAR INDUSTRIES LIMITED",
"DAMODAR INTER COLLEGE",
"DAMODAR ISPAT LIMITED",
"DAMODAR MANGALJI AND COMPANY LIMITED",
"DAMODAR MENON INTERNATIONAL PRIVATE LIMITED",
"DAMODAR MENON INTERNATIONAL PRIVATE LTD",
"DAMODAR MINERALS PRIVATE LIMITED",
"DAMODAR PROCESS PLANT PVT LTD",
"DAMODAR ROPEWAYS & INFRA LIMITED",
"DAMODAR SUNIDHI VENTURES PRIVATE LIMITED",
"DAMODAR TRADELINKS PRIVATE LIMITED",
"DAMODAR VALLEY CORPORATION",
"DAMODARA FIXTURES PRIVATE LIMITED",
"DAMODARAM SANJIVAYYA NATIONAL LAW UNIVERSITY",
"DAMON OFFSHORE & ENGINEERING SERVICES PRIVATE LIMITED",
"DAMORE SOLUTIONS PRIVATE LIMITED",
"DAMOS TRADING COMPANY PRIVATE LIMITED",
"DAMPER TECHNOLOGY INDIA PRIVATE LIMITED",
"DAMRO FURNITURE PRIVATE LIMITED",
"DAMS AGRI PRIVATE LIMITED",
"DAMSKART INDIA PRIVATE LIMITED",
"DAMSON TECHNOLOGIES PRIVATE LIMITED",
"DAMSUN INDIA PRIVATE LIMITED",
"DAMTAL FLOUR AND FOOD PVT LTD",
"DAMUL TRADING PRIVATE LIMITED",
"DAMUS TRAVELS PRIVATE LIMITED",
"DAMY ROYAL STYLE PRIVATE LIMITED",
"DAMYAA PJ FOODS PRIVATE LIMITED",
"DAMYANT INDERJIT SINGH ENTERPRISES PRIVATE LIMITED",
"DAN CONSTRUCTIONS PRIVATE LIMITED",
"DAN COTYARN IMPEX PRIVATE LIMITED",
"DAN ELECTRONIC SYSTEM PRIVATE LIMITED",
"DAN HOSPITALITY INDIA PRIVATE LIMITED",
"DAN INFRAPROJECTS PRIVATE LIMITED",
"DAN LOGITECH INSTRUMENTS PRIVATE LIMITED",
"DAN PAL (INDIA) PRIVATE LIMITED",
"DAN SPORTS AND APPAREL PRIVATE LIMITED",
"DANA ANAND INDIA PRIVATE LIMITED",
"DANA CHOGA FOODS AND HOSPITALITY PRIVATE LIMITED",
"DANA INDIA PRIVATE LIMITED",
"DANA INDIA TECHNICAL CENTRE PRIVATE LIMITED",
"DANA INFRATECH PRIVATE LIMITED",
"DANA PHARMACEUTICALS PRIVATE LIMITED",
"DANA TM4 INDIA PRIVATE LIMITED",
"DANABAAGYAM SPINNERS PRIVATE LIMITED",
"DANALAKSHMI PAPER MILLS PRIVATE LIMITED",
"DANAMMADEVI ENTERPRISES PRIVATE LIMITED",
"DANANN INDIA AIR PRIVATE LIMITED",
"DANAOS SHIP MANAGEMENT PRIVATE LIMITED",
"DANAOS SOFTWARE SERVICES INDIA PRIVATE LIMITED",
"DANAPUR FLOUR MILLS LIMITED.",
"DANARM PRESS PRIVATE LIMITED",
"DANASHMAND ORGANIC PRIVATE LIMITED",
"DANAVARSHINI EXPORTS PRIVATE LIMITED",
"DANAY JEWELS PRIVATE LIMITED",
"DANBLOCK BRAKES INDIA PRIVATE LIMITED",
"DANBRO FOOD SOLUTIONS PRIVATE LIMITED",
"DANCAL INDIA PRIVATE LIMITED",
"DANCON SOLUTION PRIVATE LIMITED",
"DANDABATI MULTISERVICES PRIVATE LIMITED",
"DANDAPAT RICE MILLS PRIVATE LIMITED",
"DANDAR NIRMAN PRIVATE LIMITED",
"DANDDELI FERRO PRIVATE LIMITED",
"DANDE HOSPITAL",
"DANDI CHEMFOOD PRIVATE LIMITED",
"DANDM COMPONENTS LIMITED",
"DANDONA FINANCE LIMITED",
"DANDONA INFRASTRUCTURES PRIVATE LIMITED.",
"DANDU ENERGY PRIVATE LIMITED",
"DANDV AGRO PRIVATE LIMITED",
"DANDYAN ENTERPRISES PRIVATE LIMITED",
"DANE REALTORS AND RESORTS PRIVATE LIMITED",
"DANESHWARI FARMER PRODUCER COMPANY LIMITED",
"DANFOSS INDUSTRIES PRIVATE LIMITED",
"DANFOSS POWER SOLUTIONS INDIA PRIVATE LIMITED",
"DANFOSS TECHNOLOGIES PRIVATE LIMITED",
"DANG CHEMICALS PRIVATE LIMITED",
"DANG CONSTRUCTIONS PRIVATE LIMITED",
"DANG DISTRICT EDUCATION COMMITTEE MANAGED PRIMARY SCHOOL TEACHER",
"DANG TALUKA HEALTH OFFICE WAGHAI",
"DANG TRADING COMPANY PRIVATE LIMITED",
"DANGAT MEDIA PRIVATE LIMITED",
"DANGAYACH COLONIZERS PRIVATE LIMITED",
"DANGAYACH HOTELS PRIVATE LIMITED",
"DANGE AGRO PRODUCTS PRIVATE LIMITED",
"DANGEE DUMS LIMITED",
"DANGEROUS GOODS MANAGEMENT INDIA PRIVATE LIMITED",
"DANGI ENTERPRISES",
"DANGI INDUSTRIES PRIVATE LIMITED",
"DANGI POWER SOLUTIONS PRIVATE LIMITED",
"DANGIA LIFESTYLE INTERNATIONAL PRIVATE LIMITED",
"DANGO & DIENENTHAL (INDIA) PRIVATE LIMITED",
"DANGO POULTRIES PRIVATE LIMITED",
"DANGS NATURAL FARMERS PRODUCER COMPANY LIMITED",
"DANI AVIATION SERVICES PRIVATE LIMITED",
"DANI COMMODITIES PRIVATE LIMITED",
"DANI MERCANTILE PRIVATE LIMITED",
"DANI SHARES AND STOCKS PRIVATE LIMITED",
"DANIA ORO JEWELLERY PRIVATE LIMITED",
"DANIAL ENGINEERING PRIVATE LIMITED",
"DANICA AQUA EXPORTS PRIVATE LIMITED",
"DANICA PHARMA PRIVATE LIMITED",
"DANIEL & SONS",
"DANIEL AND SONS PVT LTD",
"DANIEL FURNITURES PRIVATE LIMITED",
"DANIEL MEASUREMENT SOLUTIONS PRIVATE LIMITED",
"DANIEL THOMAS MATRICULATION HIGHER SECONDARY SCHOOL",
"DANIEL VYAPPAR PRIVATE LIMITED",
"DANIELI CENTRO COMBUSTION INDIA PRIVATE LIMITED",
"DANIELI CORUS INDIA PRIVATE LIMITED",
"DANIELI INDIA LIMITED",
"DANIELS GT INDIA PRIVATE LIMITED",
"DANIKA TRADERS PRIVATE LIMITED",
"DANISCO INDIA PRIVATE LIMITED",
"DANISH ADVERTISING PRIVATE LIMITED",
"DANISH HEALTH CARE PRIVATE LIMITED",
"DANISH PRIVATE LIMITED",
"DANISH STEEL CLUSTER PRIVATE LIMITED",
"DANKE TECHNOELECTRO PRIVATE. LIMITED.",
"DANKETSU CONSULTANCY PRIVATE LIMITED",
"DANKO LOGISOLUTIONS PRIVATE LIMITED",
"DANKOSYS TECHNOLOGIES PRIVATE LIMITED",
"DANKOTUWA PROCELAIN LIMITED",
"DANKUNI INFRAVENTURES PRIVATE LIMITED",
"DANKUNI STEELS LIMITED",
"DANLAW ELECTRONICS ASSEMBLY LIMITED",
"DANLAW INC",
"DANMET CHEMICALS PVT LTD",
"DANO VACCINES AND BIOLOGICALS PRIVATE LIMITED",
"DANOBAT GRUPO MACHINE TOOLS INDIA PRIVATE LIMITED",
"DANONE FOODS AND BEVERAGES INDIA PRIVATE LIMITED",
"DANOPHARM CHEMICALS PRIVATE LIMITED",
"DANS ENERGY P LIMITED.",
"DANS VENTURES PRIVATE LIMITED",
"DANSKEIT AND SUPPORT SERVICES INDIA PRIVATE LIMITED",
"DANSN INTERNATIONAL PRIVATE LIMITED",
"DANSON FOODS PRIVATE LIMITED",
"DANSON MOULDS PRIVATE LIMITED",
"DANSY LABS PRIVATE LIMITED",
"DANTA RESINS PRIVATE LIMITED",
"DANTA TECHNOLOGIES PRIVATE LIMITED",
"DANTAL HYDRAULICS PRIVATE LIMITED",
"DANTARA JEWELLERS",
"DANTE ENERGY PRIVATE LIMITED",
"DANTE INVESTMENTS PRIVATE LIMITED",
"DANTESHWARI HOME BUILDTECH PRIVATE LIMITED",
"DANTESHWARI MOTORS PRIVATE LIMITED",
"DANTI MADHYAMIK SHALA DANTI",
"DANTON POWER PRIVATE LIMITED",
"DANU WIND PARKS PRIVATE LIMITED",
"DANUB HOMES PRIVATE LIMITED",
"DANUBE BUILDMART PRIVATE LIMITED",
"DANUBE INDUSTRIES LIMITED",
"DANUBE PROPERTIES CONSULTANTS PRIVATE LIMITED",
"DANVER HYDROMATICS PRIVATE LIMITED",
"DANVITA INDIA PRIVATE LIMITED",
"DANZ FOODS PRIVATE LIMITED",
"DAOMING REFLECTIVE MATERIAL INDIA PRIVATE LIMITED",
"DAON AUTO PARTS INDIA PRIVATE LIMITED",
"DAOXAN PRIVATE LIMITED",
"DAP CONSULTANTS PRIVATE LIMITED",
"DAP E-NNOVATIVE SOLUTIONS PRIVATE LIMITED",
"DAPHNE MULTITRADING PRIVATE LIMITED",
"DAPPER EXPORTS PRIVATE LIMITED",
"DAPPER LOGISTICS PRIVATE LIMITED",
"DAPS ADVERTISING LIMITED",
"DAR AL-HANDASAH CONSULTANTS (SHAIR & PARTNERS) INDIA PRIVATE LIMITED",
"DAR CONSULTANTS INDIA PRIVATE LIMITED",
"DAR CREDIT & CAPITAL LTD",
"DAR HOUSING LIMITED",
"DAR INFRAVENTURES PRIVATE LIMITED",
"DAR KARMOUS RESORTS PRIVATE LIMITED",
"DAR LANDMARKS PRIVATE LIMITED",
"DAR MEDIA PRIVATE LIMITED",
"DARA CHEMICALS",
"DARA CONSTRUCTION CO.",
"DARA CONVERTING INDIA PRIVATE LIMITED",
"DARA ENGINEERING & INFRASTRUCTURES PRIVATE LIMITED",
"DARA HOTELS AND RESORTS PRIVATE LIMITED",
"DARA PROJECTS PRIVATE LIMITED",
"DARAAD ENGICON PRIVATE LIMITED",
"DARAB BAJINA INVESTMENTS PRIVATE LIMITED",
"DARABSHAW B CURSETJEES SONS GUJARAT PVT LTD",
"DARAK TRADING COMPANY PVT LTD",
"DARAMIC BATTERY SEPARATOR INDIA PRIVATE LIMITED",
"DARASGUPPE SSC PRIVATE LIMITED",
"DARASHAW & COMPANY PRIVATE. LIMITED.",
"DARASHAW BLOODSTOCK PRIVATE LIMITED",
"DARASHAW SECURITIES PRIVATE LIMITED",
"DARBAR IMPEX PRIVATE LIMITED",
"DARBAR PAINTS AND HARDWARE PRIVATE LIMITED",
"DARBARI LAL D.A.V MODEL SCHOOL",
"DARBARI LAL DAV MODEL SCHOOL",
"DARBARI LAL FOUNDATION EDUCATIONAL SOCIETY",
"DARBARI PRINT-PRO PVT LTD",
"DARBARI WIRES PRIVATE LIMITED",
"DARBAR'S FINERIES PRIVATE LIMITED",
"DARBHANGA FLOUR PRIVATE LIMITED",
"DARBHANGA-MOTIHARI TRANSMISSION COMPANY LIMITED",
"DARDA INVESTMENT AND PROPERTIES PVT LTD",
"DARDA PRINTOCRATS PRIVATE LIMITED",
"DARE FASHION PRIVATE LIMITED",
"DAREWELL ENERGY PRIVATE LIMITED",
"DARIALAL PRECAST PRIVATE LIMITED",
"DARIL IMPEX PRIVATE LIMITED",
"DARIL LIGHTING PRIVATE LIMITED",
"DARIO EXIM PRIVATE LIMITED",
"DARIYA SHIPPING AGENCIES PRIVATE LIMITED",
"DARIYALAL INDUSTRIES",
"DARJEELING CEMENTS LTD",
"DARJEELING DOOARS PLANTATIONS TEA LIMITED",
"DARJEELING ENTERPRISES PRIVATE LIMITED",
"DARJEELING EXOTIC CUISINES PRIVATE LIMITED",
"DARJEELING FLOUR MILLS PRIVATE. LIMITED.",
"DARJEELING GARDENS PRIVATE LIMITED",
"DARJEELING IMPEX LIMITED",
"DARJEELING ORGANIC TEA ESTATES PRIVATE. LIMITED.",
"DARJEELING POWER LIMITED",
"DARJEELING SPUN PIPE INDUSTRY PVT.LTD.",
"DARJEELING TEA & CHINCHONA ASSOCIATION LTD.",
"DARJEELING TEA SERVICES PVT LTD",
"DARJO RETAIL PRIVATE LIMITED",
"DARJUV9 ENTERPRISES PRIVATE LIMITED",
"DARK BEAR WEB SOLUTIONS PRIVATE LIMITED",
"DARK BEARS SOFTWARE PRIVATE LIMITED",
"DARK FOREST FURNITURE CO P LIMITED",
"DARK HORSE DIGITAL SOLUTIONS PRIVATE LIMITED",
"DARK HORSE IT CONSULTING PRIVATE LIMITED",
"DARK HORSE PORTFOLIO INVESTMENT PRIVATE LIMITED",
"DARK MATTER TECHNOLOGIES INDIA PRIVATE LIMITED",
"DARKS SECURITY CONSULTANT PRIVATE LIMITED",
"DARKWATER CYBERSECURITY SOLUTIONS PRIVATE LIMITED",
"DARKWELL MERCHANDISE PRIVATE LIMITED",
"DARLING MUESCO INDIA PRIVATE LIMITED",
"DARLING PUMPS PRIVATE LIMITED",
"DARNAS ADHESIVE AND SEALANTS PRIVATE LIMITED",
"DARNAX PHARMA PRIVATE LIMITED",
"DARODE JOG HOMES PRIVATE LIMITED",
"DARON ENGINEERING PRIVATE LIMITED",
"DARP MOBLIZE SOFTECH PRIVATE LIMITED",
"DARP NUTRITION FOODS PRIVATE LIMITED",
"DARPAN CERAMICS PRIVATE LIMITED",
"DARPAN CONCLAVE PRIVATE LIMITED",
"DARPAN DIAGNOSTIC CENTRE PRIVATE LIMITED",
"DARPAN INFRASTRUCTURE PRIVATE LIMITED",
"DARPAN ISPAT PRIVATE LIMITED",
"DARPAN JEWELTECH PRIVATE LIMITED",
"DARPAN STONEX PRIVATE LIMITED",
"DARPAN TIMES PRIVATE LIMITED",
"DARPAN VINIMAY PRIVATE LIMITED",
"DARPITA TRADING COMPANY PRIVATE LIMITED",
"DARRAMEKS HOTELS & DEVELOPERS PRIVATE LIMITED",
"DARRICK INSECTICIDES LIMITED",
"DARRUMUGAM PILLAI SILK PRIVATE LIMITED",
"DARSANA ACADEMY",
"DARSH EXIM PRIVATE LIMITED",
"DARSH IMPEX INDIA PRIVATE LIMITED",
"DARSH INFOTECH PRIVATE LIMITED",
"DARSH PHARMACHEM PRIVATE LIMITED",
"DARSH PLASTICS PRIVATE LIMITED",
"DARSH TEXTRADE PRIVATE LIMITED",
"DARSHAN ACADEMY",
"DARSHAN ALLOYS PVT LTD",
"DARSHAN APPARELS PRIVATE LIMITED",
"DARSHAN BOARDLAM LIMITED",
"DARSHAN COTTON INDUSTRIES",
"DARSHAN CREATION PRIVATE LIMITED",
"DARSHAN DIATECH PRIVATE LIMITED",
"DARSHAN DRESSES PRIVATE LIMITED",
"DARSHAN DRUG HOUSE PRIVATE LIMITED",
"DARSHAN EXTRUSIONS PRIVATE LIMITED",
"DARSHAN FINANCIAL SERVICES PRIVATE LIMITED",
"DARSHAN FINE FAB PRIVATE LIMITED",
"DARSHAN FLEXIBLES PRIVATE. LIMITED.",
"DARSHAN FOODS PRIVATE LIMITED",
"DARSHAN GRANI MARMO PRIVATE LIMITED",
"DARSHAN HEALTH CARE PRIVATE LIMITED",
"DARSHAN HOSPITAL ALWAR",
"DARSHAN INSTITUTE OF ENGINEERING AND TECHNOLOGY",
"DARSHAN JEWEL TOOLS PRIVATE LIMITED",
"DARSHAN LAL AND SONS PRIVATE LIMITED",
"DARSHAN LAL SAREES PRIVATE LIMITED",
"DARSHAN LIFTERS PVT LTD",
"DARSHAN ORNA LIMITED",
"DARSHAN OVERSEAS PRIVATE LIMITED",
"DARSHAN PHARMACHEM PRIVATE LIMITED",
"DARSHAN ROADLINES PRIVATE LIMITED",
"DARSHAN SALT WORKS PRIVATE LIMITED",
"DARSHAN SECURITY SERVICES PRIVATE LIMITED",
"DARSHAN SERVICES PRIVATE LIMITED",
"DARSHAN SILVER CREATION 925 PRIVATE LIMITED",
"DARSHAN SINGH AUTO PRIVATE LIMITED",
"DARSHAN SOFT-TECH PRIVATE LIMITED",
"DARSHAN SOLUTIONS PRIVATE LIMITED",
"DARSHAN TEXCOAT INDUSTRIES PRIVATE LIMITED",
"DARSHAN WEIGHING SYSTEM PVT LTD",
"DARSHANAM IMPEX PRIVATE LIMITED",
"DARSHANAM LIFE SPACE PRIVATE LIMITED",
"DARSHANAM SPHERE PRIVATE LIMITED",
"DARSHANI COLD STORAGE PRIVATE LIMITED",
"DARSHANLAL ANAND PRAKASH & SONS PVT LTD",
"DARSHANLAL JAGDISHPARSHAD PRIVATE LIMITED",
"DARSHIKA CONSULTANTS PRIVATE LIMITED",
"DARSHIL FABMET PRIVATE LIMITED",
"DARSHINI OVERSEAS PRIVATE LIMITED",
"DARSHITA AASHIYANA PRIVATE LIMITED",
"DARSHITA INFRASTRUCTURE P",
"DARSHIV WOOD PRIVATE LIMITED",
"DARSHIVAM TRADERS PRIVATE LIMITED",
"DARSHNIK MARKETING AND SERVICES PRIVATE LIMITED",
"DARSHSTAR STONES PRIVATE LIMITED",
"DARSUN HIGHER EDUCATIONAL SOCIETY",
"DART COMMUNICATIONS PRIVATE LIMITED",
"DART ENERGY INDIA PTY LIMITED",
"DART FROG TECHNOLOGY AND SERVICES PRIVATE LIMITED",
"DART GLOBAL LOGISTICS PRIVATE LIMITED",
"DART MANUFACTURING INDIA PRIVATE.LIMITED",
"DART PRIVATE LIMITED",
"DARTMOUR HOLDINGS PRIVATE LIMITED",
"DARTS IT NETWORK PRIVATE LIMITED",
"DARTWELL XPRESS PRIVATE LIMITED",
"DARUKA & COMPANY (MICA) PVT LTD",
"DARUKHANA IRON STEEL AND SCRAP MERCHANTS ASSOCIATION",
"DARUKHANA STEEL PRIVATE LIMITED",
"DARVESH BUSSA REALTORS PRIVATE LIMITED",
"DARVESH CONSTRUCTIONS PRIVATE LIMITED",
"DARVESH OIL CARRIERS PRIVATE LIMITED",
"DARVESH PROPERTIES PRIVATE LIMITED",
"DARWAY MARINE SERVICES PRIVATE LIMITED",
"DARWESH KHAZANA PRIVATE LIMITED",
"DARWIN AGRO CHEMICALS LIMITED",
"DARWIN BOX DIGITAL SOLUTIONS PRIVATE LIMITED",
"DARWISH CYBERTECH INDIA PRIVATE LIMITED",
"DARYA INDUSTRIAL ENGINEERING PRIVATE LIMITED",
"DARYA SHIPPING PRIVATE LIMITED",
"DARYAGANJ HOSPITALITY PRIVATE LIMITED",
"DARYANI INFRA BUILDCON PRIVATE LIMITED",
"DARYANI VENTURES PRIVATE LIMITED",
"DARYANOMAL TOLARAM HINDUJA JEWELLERS PRIVATE LIMITED",
"DARZI-ON-CALL SERVICES PRIVATE LIMITED",
"DAS AIRCONDITIONING PRIVATE LIMITED",
"DAS AIRPORT GROUND SUPPORT SERVICES PRIVATE LIMITED",
"DAS AND BROTHERS ELECTRICALS PRIVATE LIMITED",
"DAS BIOSCIENCES INDUSTRIES PRIVATE LIMITED",
"DAS BROTHERS AGRO INDUSTRIES PVT LTD",
"DAS CAPITAL PRIVATE LIMITED",
"DAS CNC PRODUCTS PRIVATE LIMITED",
"DAS DISTRIBUTORS",
"DAS DISTRIBUTORS PVT LTD",
"DAS DRUGS PRIVATE LIMITED",
"DAS ELECTRONICS WORK PRIVATE LIMITED",
"DAS ENGINEERING",
"DAS FOODTECH PRIVATE LIMITED",
"DAS GARAGE PRIVATE LIMITED",
"DAS GLOBTECH SERVICES PRIVATE LIMITED",
"DAS GOLD PRIVATE LIMITED",
"DAS HARI HOTELS PRIVATE LIMITED",
"DAS MANAGEMENT FACILITY PRIVATE LIMITED",
"DAS MATERIAL TESTINGS PRIVATE LIMITED",
"DAS MOLD-KONN CABLES PRIVATE LIMITED",
"DAS OFFSHORE ENGINEERING PRIVATE LIMITED",
"DAS OFFSHORE LIMITED",
"DAS PENDAWALA FOODS PRIVATE LIMITED",
"DAS PRECISION MACHINE TOOLS PRIVATE LIMITED",
"DAS RICE MILL",
"DAS STYLE PRIVATE LIMITED",
"DAS SUPERFOODS PRIVATE LIMITED",
"DAS SUPPLY AND SERVICES PRIVATE LIMITED",
"DASA INFRA SYSTEMS PRIVATE LIMITED",
"DASAJ TEXTURISING PRIVATE LIMITED",
"DASALDHAN CHEMICALS PRIVATE LIMITED",
"DASAM MOTORS PRIVATE LIMITED",
"DASAMI LAB PRIVATE LIMITED",
"DASAN INDIA PRIVATE LIMITED",
"DASARATHI NAIK AND ENGINEERS PRIVATE LIMITED",
"DASARI BUILDERS PRIVATE LIMITED",
"DASARI CONSTRUCTION",
"DASARI VEER RAJU AND GUNNAM RAM CHANDRA RAO MEMORIAL TRUST",
"DASBHUJA DEALER PRIVATE LIMITED",
"DASCO TRADERS PRIVATE LIMITED",
"DASCO VENTURES PRIVATE LIMITED",
"DASCON SOURAV COMMERCIAL PRIVATE LIMITED",
"DASENLIN INDIA PRIVATE LIMITED",
"DASERA FOOD & BEVERAGES PRIVATE LIMITED",
"DASGHARA HIGH SCHOOL HS",
"DASH FASHIONS PRIVATE LIMITED",
"DASH INFOED PRIVATE LIMITED",
"DASH INSPECTORATE PRIVATE LIMITED",
"DASH SQUARE HOMES LLP",
"DASHA CREATIONS PRIVATE LIMITED",
"DASHA KRIT TECHNOLOGIES PRIVATE LIMITED",
"DASHA PHARMACEUTICALS PRIVATE LIMITED",
"DASHAK PHARMACEUTICALS PRIVATE LIMITED",
"DASHAM MEDICARE PRIVATE LIMITED",
"DASHAMI MARKETING AND SERVICES PRIVATE LIMITED",
"DASHANYA TECH PARKZ PRIVATE LIMITED",
"DASHARATH GHOSH HANDLOOMS PRIVATE LIMITED",
"DASHCLICKS INDIA PRIVATE LIMITED",
"DASHMERUNO STORES PRIVATE LIMITED",
"DASHMESH CABLES",
"DASHMESH CNG IMPEX PRIVATE LIMITED",
"DASHMESH DAIRY",
"DASHMESH FABRICATORS PRIVATE LIMITED",
"DASHMESH FILTER PAPERS PRIVATE LTD",
"DASHMESH FOOD INDUSTRIES PRIVATE LIMITED",
"DASHMESH JACQUARD & POWERLOOM PRIVATE LIMITED",
"DASHMESH MECHANICAL",
"DASHMESH RICE MILLS",
"DASHMESH RUBBER INDUSTRIES PRIVATE LIMITED",
"DASHMESH SOLVEX PRIVATE LIMITED",
"DASHMESH SONAIL HEALTHCARE PRIVATE LIMITED",
"DASHMESH WEAVING & DYEING MILLS PRIVATE LIMITED",
"DASHMILE LUBTECH PRIVATE LIMITED",
"DASHNINJA TECHNOLOGIES PRIVATE LIMITED",
"DASHRATH BABA MADHMIK VIDHALAY",
"DASHRATH PRASAD FERTILIZERS PRIVATE LIMITED",
"DASHRATH PRASAD MAHAVIDYALAYA",
"DASHRATH SILVER ART PRIVATE LIMITED",
"DASKA ESTATE AND BUILDERS PRIVATE LIMITED",
"DASMESH CASTINGS PVT LTD",
"DASMESH GOODS CARRIER PRIVATE LIMITED.",
"DASMESH MECHANICAL WORKS PRIVATE LIMITED",
"DASPALLA GLOBAL HOTELS PRIVATE LIMITED",
"DASPALLA HOTELS PRIVATE LIMITED",
"DASPALLA RESORTS PRIVATE LIMITED",
"DASPAN FOREX PRIVATE LIMITED",
"DASPAN INDUSTRIES LIMITED",
"DASPARA TEA ESTATE PRIVATE LIMITED",
"DASPR INDIA PRIVATE LIMITED",
"DASS BUILDERS PRIVATE LIMITED",
"DASS COLD STORAGE PRIVATE LIMITED",
"DASS EMBROIDERY PRIVATE LIMITED",
"DASS MULTI SERVICE PRIVATE LIMITED",
"DASS POLYMERS PRIVATE LTD",
"DASS PROPERTIES AND CONSTRUCTIONS PRIVATE LIMITED",
"DASS SURGIMED PRIVATE LIMITED",
"DASSAN FASHIONS PRIVATE LIMITED.",
"DASSANI AND SONS PRIVATE LIMITED",
"DASSANI MOTORS PRIVATE LIMITED",
"DASSANI RETAIL MARKET PRIVATE LIMITED",
"DASSAULT AIRCRAFT SERVICES INDIA PRIVATE LIMITED",
"DASSAULT RELIANCE AEROSPACE LIMITED",
"DASSAULT SYSTEM GLOBAL SERVICES",
"DASSAULT SYSTEMES FOUNDATION",
"DASSAULT SYSTEMES GLOBAL SERVICES PRIVATE LIMITED",
"DASSAULT SYSTEMES INDIA PRIVATE LIMITED",
"DASSAULT SYSTEMES SOLUTIONS LAB PRIVATE LIMITED",
"DASSTOSH ADREAL PRIVATE LIMITED",
"DASTAK MEDIA PRIVATE LIMITED",
"DASTANPRIVATE LIMITED",
"DASTUR INFOSCIENCE PRIVATE LIMITED",
"DAT INFORMATICS PRIVATE LIMITED",
"DATA & ANALYTICS SERVICES PRIVATE LIMITED",
"DATA AXLE SOLUTIONS PRIVATE LIMITED",
"DATA BRAINS GLOBAL SOFTWARE PRIVATE LIMITED",
"DATA CARE SYSTEMS PRIVATE LIMITED",
"DATA CIPHER SOLUTIONS PRIVATE LIMITED",
"DATA CIRCLE INFO COMMUNICATIONS PRIVATE LIMITED",
"DATA COLLECTION INFOTECH (INDIA) PRIVATE LIMITED",
"DATA CONTAINERS CONSULTING PRIVATE LIMITED",
"DATA DYNAMICS SOFTWARE SOLUTIONS INDIA PRIVATE LIMITED",
"DATA ERPSYSTEMS INDIA PRIVATE LIMITED",
"DATA EXIM PRIVATE LIMITED",
"DATA FOR DECISIONS TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"DATA GLOVE IT SOLUTIONS PRIVATE LIMITED",
"DATA INGENIOUS GLOBAL LIMITED",
"DATA LIFECYCLE COM PRIVATE LIMITED",
"DATA LOGICS INDIA PRIVATE LIMITED",
"DATA MANAGEMENT SERVICES PRIVATE LIMITED",
"DATA MARSHALL PRIVATE LIMITED",
"DATA MAVEN PRIVATE LIMITED",
"DATA METRICKS CONSULTING PRIVATE LIMITED",
"DATA NOVA INDIA PVT LTD",
"DATA PATROL TECHNOLOGIES PRIVATE LIMITED",
"DATA PATTERNS (INDIA) LIMITED",
"DATA PATTERNS INDIA PRIVATE LIMITED",
"DATA PROCESSING FORMS PVT LTD",
"DATA RAM SONS PRIVATE LIMITED",
"DATA RATINGS INTELLIGENCE PRIVATE LIMITED",
"DATA SEMANTICS PRIVATE LIMITED",
"DATA SHEET & STRUCTURES PRIVATE LIMITED",
"DATA SOFTWARE RESEARCH COMPANY PRIVATE LIMITED",
"DATA TECH COMPUTERS PRIVATE LIMITED",
"DATA TECHNOSYS (ENGINEERS) PRIVATE LIMITED",
"DATA TEMPLATE INFOTECH PRIVATE LIMITED",
"DATA TRAINED EDUCATION PRIVATE LIMITED",
"DATA VISION PRIVATE LIMITED",
"DATA VOICE SOLUTIONS PRIVATE LIMITED",
"DATA WORLD INFORMATION SYSTEMS PRIVATE LIMITED",
"DATAABSOLUTE TECHNOLOGIES PRIVATE LIMITED",
"DATAAEGIS SOFTWARE PRIVATE LIMITED",
"DATAAR FOODS INDIA PRIVATE LIMITED",
"DATABEAT CONSULTING PRIVATE LIMITED",
"DATABILITY TECHNOLOGIES PRIVATE LIMITED",
"DATABIT TECHNOLOGIES PRIVATE LIMITED",
"DATABOROUGH INDIA PRIVATE LIMITED",
"DATABRICKS INDIA PRIVATE LIMITED",
"DATABRIDGE MARKET RESEARCH PRIVATE LIMITED",
"DATABUDDY SERVICES PRIVATE LIMITED",
"DATABYTE EQUIPMENT PRIVATE LIMITED",
"DATABYTES ANALYTICS PRIVATE LIMITED",
"DATACAPTEN TECHNOLOGIES PRIVATE LIMITED",
"DATACEDE CHENNAI PRIVATE LIMITED",
"DATACENTRE DYNAMICS INDIA PRIVATE LIMITED",
"DATACOLOR SOLUTIONS PRIVATE LIMITED",
"DATACOM PRODUCTS INDIA PRIVATE LIMITED",
"DATACOMP WEB TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"DATACORE SOFTWARE INDIA PRIVATE LIMITED",
"DATACORE TECHNOLOGIES PRIVATE LIMITED",
"DATACORP TRAFFIC PRIVATE LIMITED",
"DATACTION ANALYTICS PRIVATE LIMITED",
"DATACURATE TECHNOLOGIES PRIVATE LIMITED",
"DATADIGGERS",
"DATADIRECT NETWORKS INDIA PRIVATE LIMITED",
"DATADRIVEN TECHNOLOGIES PRIVATE LIMITED",
"DATAEAZE SYSTEMS PRIVATE LIMITED",
"DATAECONOMY PRIVATE LIMITED",
"DATAEVOLVE SOLUTIONS OPC PRIVATE LIMITED",
"DATAFACTZ SOLUTIONS PRIVATE LIMITED",
"DATAFIELD INDIA PRIVATE LIMITED",
"DATAFLIX TECHNOLOGIES PRIVATE LIMITED",
"DATAFLOAT TECHNOLOGIES INDIA PRIVATE LIMITED",
"DATAFLOW SERVICES INDIA PRIVATE LIMITED",
"DATAFORCE TECHNOLOGIES PRIVATE LIMITED",
"DATAFORMATICS CONSULTANCY PRIVATE LIMITED",
"DATAFORMIX TECHNOLOGIES PRIVATE LIMITED",
"DATAFORTUNE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"DATAFOUNDRY ARNAVA PRIVATE LIMITED",
"DATAFOUNDRY PRIVATE LIMITED",
"DATAGAMI LLP",
"DATAGEN INTERNET SERVICES PRIVATE LIMITED",
"DATAGENIX SYSTEMS (INDIA) PRIVATE LIMITED",
"DATAGOLD SOFTWARE PRIVATE LIMITED",
"DATAGRAPH SYSTEMS PRIVATE LIMITED",
"DATAGRES IT SOLUTIONS PRIVATE LIMITED",
"DATAGRID SOLUTIONS PRIVATE LIMITED",
"DATAGRIDZIT PRIVATE LIMITED",
"DATAGROKR ANALYTICS PRIVATE LIMITED",
"DATAGUISE INDIA PRIVATE LIMITED",
"DATAINC GLOBAL TECH SOLUTIONS PRIVATE LIMITED",
"DATAKEN TECHNOLOGIES PRIVATE LIMITED",
"DATAKING STATIONERS PRIVATE LIMITED",
"DATALINE IMAGING TECHNOLOGIES PRIVATE LIMITED",
"DATALOG CONTROLS AND SOLUTIONS PRIVATE LIMITED",
"DATALOG TECHNOLOGIES PRIVATE LIMITED",
"DATALYST INDIA PRIVATE LIMITED",
"DATALYSYS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"DATALYZER TECHNOLOGIES PRIVATE LIMITED",
"DATAMAN COMPUTER SYSTEMS PRIVATE LIMITED",
"DATAMARK BPO SERVICE LLP",
"DATAMARK INDIA BPO LLP",
"DATAMATE INFO SOLUTIONS PRIVATE LIMITED",
"DATAMATICS BUSINESS ENABLERS PRIVATE LIMITED",
"DATAMATICS BUSINESS SOLUTIONS LIMITED",
"DATAMATICS DIGITAL LIMITED",
"DATAMATICS GLOBAL SERVICES LIMITED",
"DATAMATICS HR & CONSULTANCY PRIVATE LIMITED",
"DATAMATICS INFOTECH SERVICES PRIVATE LIMITED",
"DATAMATICS ROBOTICS SOFTWARE LIMITED",
"DATAMATICS STAFFING SERVICES LIMITED",
"DATAMATION CONSULTANTS PRIVATE LIMITED",
"DATAMATO TECHNOLOGIES PRIVATE LIMITED",
"DATAMATRIX TECHNOLOGIES PRIVATE LIMITED",
"DATAMETICA SOLUTIONS PRIVATE LIMITED",
"DATAMI MOBILE SOLUTIONS PRIVATE LIMITED",
"DATAMINE INTERNATIONAL LIMITED",
"DATAMINI TECHONLOGIES",
"DATAMOULDS PRIVATE LIMITED",
"DATANET INDIA PRIVATE LIMITED",
"DATANETIIX SOLUTIONS INDIA PRIVATE LIMITED",
"DATANUB TECHNOLOGIES",
"DATAPAGE DIGITAL SERVICES PRIVATE LIMITED",
"DATAPAGE INDIA PRIVATE LIMITED",
"DATAPALM SERVICES INDIA PRIVATE LIMITED",
"DATAPRINTS AND FINANCIAL SERVICES PRIVATE LIMITED",
"DATAPRINTS SERVICES PRIVATE LIMITED",
"DATAPRO COMPUTERS PRIVATE LIMITED",
"DATAPROMPT INTERNATIONAL PRIVATE LIMITED",
"DATAQ RESEARCH PRIVATE LIMITED",
"DATAQUARTER TECHNOLOGIES PRIVATE LIMITED",
"DATAR AND SONS EXPORTS (INDIA) PRIVATE LIMITED",
"DATAR CANCER GENETICS PRIVATE LIMITED",
"DATAR ENGINEERING AND CONSULTANCY PRIVATE LIMITED",
"DATAR PICK & MOVE PRIVATE LIMITED",
"DATAR POWER MANAGEMENT PRIVATE LIMITED",
"DATAR SECURITY SERVICE GROUP",
"DATAR SECURITY SERVICES PRIVATE LIMITED",
"DATAR TRAILER SERVICES PRIVATE LIMITED",
"DATARAINX TECHNOLOGIES PRIVATE LIMITED",
"DATAROBOT SOFTWARE PRIVATE LIMITED",
"DATAROOMS STERLING PRIVATE LIMITED",
"DATARPM INDIA PRIVATE LIMITED",
"DATARYNX PRIVATE LIMITED",
"DATASCIENT CORPORATION LIMITED",
"DATASCRIBE INFOTECH PRIVATE LIMITED",
"DATASEERS TECHNOLOGIES PRIVATE LIMITED",
"DATASENSOR INDIA PRIVATE LIMITED CN",
"DATASERVE INFOTECH PRIVATE LIMITED",
"DATASHAFT TECHNOLOGIES PRIVATE LIMITED",
"DATASHRUBS SOLUTIONS PRIVATE LIMITED",
"DATASOFT COMNET PRIVATE LIMITED",
"DATASOFT COMPUTER SERVICES PRIVATE LIMITED",
"DATASOFT NETWORK SOLUTIONS PRIVATE LIMITED",
"DATASOL BANGALORE PRIVATE LIMITED",
"DATASOL INNOVATIVE LABS PRIVATE LIMITED",
"DATASTREAM RESEARCH AND ANLYSIS PRIVATE LIMITED",
"DATASYNC TECH PRIVATE LIMITED",
"DATATEC METHODEX PRIVATE LIMITED",
"DATATECHNOSYS INFRASTRUCTURE PRIVATE LIMITED",
"DATATERRAIN INDIA PRIVATE LIMITED",
"DATATRACK TECHNOLOGIES PRIVATE LIMITED",
"DATATRACKS SERVICES PRIVATE LIMITED",
"DATAVAIL INFOTECH PRIVATE LIMITED",
"DATAVIDEO TECHNOLOGIES INDIA PRIVATE LIMITED",
"DATAVISION SOFTWARE SOLUTIONS PRIVATE LIMITED",
"DATAVISION SYSTEMS PRIVATE LIMITED",
"DATAWENS TECHNOLOGIES PRIVATE LIMITED",
"DATAWISE CONSULTANTS PRIVATE LIMITED",
"DATAWRKZ BUSINESS SOLUTIONS PRIVATE LIMITED",
"DATAXU INDIA PRIVATE LIMITED",
"DATAZOIC MACHINES PRIVATE LIMITED",
"DATAZYMES ANALYTICS PRIVATE LIMITED",
"DATE ENGINEERING (INDIA) PRIVATE LIMITED",
"DATE WITH SUCCESS PRIVATE LIMITED",
"DATES DISCS PRIVATE LIMITED",
"DATEX OHMEDA INDIA PRIVATE LIMITED",
"DATEX WORLDWIDE PRIVATE LIMITED",
"DATIWARE MARITIME INFRA LIMITED",
"DATIYANA AGRO INDUSTRIES PRIVATE LIMITED",
"DATOPIC TECHNOLOGIES PRIVATE LIMITED",
"DATRE CORPORATION LIMITED",
"DATRI BLOOD STEM CELL DONORS REGISTRY",
"DATRUX SYSTEMS PRIVATE LIMITED",
"DATSONS ELECTRONICS PVT LTD",
"DATSONS ENGINEERING WORKS PRIVATE LIMITED",
"DATT ENTERPRISES PRIVATE LIMITED",
"DATT INFRACREATIONS PRIVATE LIMITED",
"DATT INFRASTRUCTURE AND SERVICES PRIVATE LIMITED",
"DATT MEDIPRODUCTS PRIVATE LIMITED",
"DATT REALINFRA PRIVATE LIMITED",
"DATTA CREATIVE MARKETING PRIVATE LIMITED",
"DATTA FRANKINCENSE INDIA PRIVATE LIMITED",
"DATTA HYDRO-CHEM PRIVATE LIMITED",
"DATTA IRON AND STEEL PRIVATE LIMITED",
"DATTA KRUPA GINING AND PRESSING PRIVATE LIMITED",
"DATTA MEDICARE AND FINANCE (ENTERPRISES) PRIVATE LIMITED",
"DATTA MEGHE AYURVEDIC MEDICAL COLLEGE ,HOSPITAL & RESEARCH CENTER",
"DATTA MEGHE COLLEGE OF ENGINEERING",
"DATTA MEGHE INSTITUTE OF HIGHER EDUCATION AND RESEARCH",
"DATTA MEGHE MEDICAL COLLEGE",
"DATTA MEGHE POLYTECHNIC COLLEGE",
"DATTA POWER INFRA PRIVATE LIMITED",
"DATTAGURU FARMER PRODUCER COMPANY LIMITED",
"DATTAGURU INFRA PRIVATE LIMITED",
"DATTAJIRAO KADAM ARTS SCIENCE AND COMMERCE COLLEGE",
"DATTAKALA SHIKSHAN SANSTHA",
"DATTARAJ CONTRACTORS PRIVATE LIMITED",
"DATTASEVA SAHAKARI PATPEDHI LTD",
"DATTATRAY MAHARAJ KALAMBE JAOLI SAHAKARI BANK LTD",
"DATTATRAY ROADWAYS PRIVATE LIMITED",
"DATTATRAYA BABURAO NADGERI",
"DATTATREYA ENTERPRISES PRIVATE LIMITED",
"DATTATREYA TEXTILES PRIVATE LIMITED",
"DATTOPANTH THENGADI NATIONAL BOARD FOR WORKERS EDUCATION &DEVELOPMENT MINISTRY OF LABOUR AND EMPLOYMENT GOVT OF INDIA",
"DATUM ENERGY SYSTEMS PRIVATE LIMITED",
"DATUM SOFTWARE LAB PRIVATE LIMITED",
"DATUM TECHNOSYS PRIVATE LIMITED.",
"D-ATUM VILCOM PRIVATE LIMITED",
"DATUMLYZE PRIVATE LIMITED",
"DATUMTOOLS PRIVATE LIMITED",
"DATWANI DEVELOPERS PRIVATE LIMITED",
"DATWANI HOSPITALITY PRIVATE LIMITED",
"DATWYLER IT SERVICES INDIA LLP",
"DATWYLER PHARMA PACKAGING INDIA PRIVATE LIMITED",
"DAU SHRI VASUDEV CHANDRAKAR KAMDHENU VISHWAVIDYALAYA",
"DAUJEE ABHUSHAN BHANDAR PRIVATE LIMITED",
"DAUJI ENGINEERING LIMITED",
"DAUJI ISPAT PRIVATE LIMITED",
"DAUJI METAL PRIVATE LIMITED",
"DAUJI MILK FOOD PRIVATE LIMITED",
"DAUJI RESIDENCY PRIVATE LIMITED",
"DAULAL NANDLAL TRADING PRIVATE LIMITED",
"DAULAL TEXTILES PRIVATE LIMITED",
"DAULAT DEALERS PVT LTD",
"DAULAT RAM COLLEGE",
"DAULAT RAM DHARAM BIR AUTO PRIVATE LIMITED",
"DAULAT RAM ENGINEERING SERVICES PRIVATE LIMITED",
"DAULAT RAM INDUSTRIES",
"DAULAT RAM KUNDAN SINGH TRADING CO. PVT LTD",
"DAULAT SECURITIES LTD.",
"DAULATABAD URDU P S KANYA",
"DAUND SUGAR PRIVATE LIMITED",
"DAUPHIN TRAVEL MARKETING PRIVATE LIMITED",
"DAURALA SUGAR WORKS",
"DAUS INFOSPACE PRIVATE LIMITED",
"DAUS PACKAGING INDIA PRIVATE LIMITED",
"DAUSA TRANSFORMER UDHYOG PRIVATE LIMITED",
"DAV BHEL SCHOOL",
"DAV BOYS SENIOR SECONDARY SCHOOL",
"DAV BROADCAST LIMITED",
"DAV CENTENARY COLLEGE",
"DAV CENTENARY PUBLIC SCHOOL",
"DAV COLLEGE OF ENGINEERING & TECHNOLOGY",
"DAV GIRLS SENIOR SECONDARY SCHOOL",
"DAV GLOBAL SCHOOL",
"DAV I C ALAMPUR SISAULI MUZAFFARNAGAR",
"DAV INSTITUTE OF MANAGEMENT",
"DAV INSTITUTE OF PHYSIOTHERAPY & REHABILITATION",
"DAV INTER COLLEGE",
"DAV INTERNATIONAL SCHOOL",
"DAV MATRICULATION HIGHER SECONDARY SCHOOL",
"DAV POLICE PUBLIC SCHOOL",
"DAV POST GRADUATE COLLEGE",
"DAV PUBLIC SCHOOL",
"DAV PUBLIC SR SEC SCHOOL BINA",
"DAV SCHOOL",
"DAV SENIOR SECONDARY SCHOOL",
"DAVA INFOTECH PRIVATE LIMITED",
"DAVADOST PHARMA PRIVATE LIMITED",
"DAVAINIDA HEALTH MART LIMITED",
"DAVALAGIRI PROPERTY DEVELOPERS PRIVATE LIMITED",
"DAVANAM JEWELLERS PRIVATE LIMITED",
"DAVANGERE DISTRICT CENTRAL COOPERATIVE BANK LTD",
"DAVANGERE SUGAR COMPANY LIMITED",
"DAVANGERE WIRE ROPE INDUSTRY PRIVATE LIMITED",
"DAVARIYA BROTHERS PRIVATE LIMITED",
"DAVAT BEVERAGES PRIVATE LIMITED",
"DAVE BUILDERS PVT LTD",
"DAVE EXIM PRIVATE LIMITED",
"DAVE MASALA PRIVATE LIMITED",
"DAVE METAL PRIVATE LIMITED",
"DAVE MULTI SERVICES PRIVATE LIMITED",
"DAVENDRA FEEDS INDIA P LIMITED",
"DAVESMEN INDIA PRIVATE LIMITED",
"DAVI ENGINEERING PRIVATE LIMITED",
"DAVIC SHIP MANAGEMENT (INDIA) PRIVATE LIMITED",
"DAVID BROWN DESIGN CENTRE PRIVATE LIMITED",
"DAVID BROWN GEAR SYSTEMS INDIA PRIVATE LIMITED",
"DAVID LEPROSY HOSPITAL",
"DAVID MEMORIAL EDUCATION SOCIETY",
"DAVID MODEL SENIOR SECONDARY SCHOOL",
"DAVINCI LEATHER PRIVATE LIMITED",
"DAVINCI MEDIA COLLEGE",
"DAVINDER EXPORTS",
"DAVINDER SANDHU IMPEX LIMITED",
"DAVIS CHANDY CONSULT AND SERVICES PRIVATE LIMITED",
"DAVIS FURNITURE SYSTEMS PRIVATE LIMITED",
"DAVIS INDEX PRIVATE LIMITED",
"DAVIS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"DAVISON INSTRUMENTS PRIVATE LIMITED",
"DAVITA CARE INDIA PRIVATE LIMITED",
"DAVSGEMINI VALVES PRIVATE LIMITED",
"DAVULURI INFRATECH PRIVATE LIMITED",
"DAWA DEAL PRIVATE LIMITED",
"DAWAKHANA TIBBIYA COLLEGE AMU",
"DAWAR CEMENTS PRIVATE LIMITED",
"DAWAR INFRABUILD PRIVATE LIMITED",
"DAWELL LIFESCIENCE PRIVATE LIMITED",
"DAWER POLY SOLUTIONS PRIVATE LIMITED",
"DAWER PROPACK PRIVATE LIMITED",
"DAWER SONS PRIVATE LIMITED",
"DAWERTEX PRIVATE LIMITED",
"DAWN AGROVET PRIVATE LIMITED",
"DAWN DIGITAL PRIVATE LIMITED",
"DAWN DUSK CARGO MOVERS PRIVATE LIMITED",
"DAWN E-NETWORKS LIMITED",
"DAWN ENGINEERING INDIA PRIVATE LIMITED",
"DAWN HR SOLUTIONS PRIVATE LIMITED",
"DAWN INDIA RECRUITING PRIVATE LIMITED",
"DAWN MATRICULATION HIGHER SECONDARY SCHOOL",
"DAWN MODELS PRIVATE LIMITED",
"DAWN MOTORS PRIVATE LIMITED",
"DAWNIENS INTERNATIONAL PRIVATE LIMITED",
"DAWNSUN KYOSEI ENGINEERING PRIVATE LIMITED",
"DAWOODBHOY FAZALBHOY HIGH SCHOOL",
"DAWSON BUILDTECH PRIVATE LIMITED",
"DAWSON HEALTHCARE PRIVATE LIMITED",
"DAX CONSULTANTS PRIVATE LIMITED",
"DAXAL COSMETICS PRIVATE LIMITED",
"DAXARCH SOLUTIONS PRIVATE LIMITED",
"DAXEN AGRITECH INDIA PRIVATE LIMITED",
"DAXER TRADING PRIVATE LIMITED",
"DAXESH PETROCHEM PRIVATE LIMITED",
"DAXIN PHARMACEUTICALS PRIVATE LIMITED",
"DAXIN SOFT TECHNOLOGIES PRIVATE LIMITED",
"DAXINAPATH VIVIDHLAKSHI VIDHYALAYA VYARA",
"DAXOR COMMERCIAL TRADE PRIVATE LIMITED",
"DAXRAJ ELECTRICALS PRIVATE LIMITED",
"DAXSH CHEM IMPEX PRIVATE LIMITED",
"DAXV TECHNOLOGIES PRIVATE LIMITED",
"DAY `N' DAY SERVICES PRIVATE LIMITED",
"DAY 2 DAY SERVICES PRIVATE LIMITED",
"DAY LITE INDUSTRIES PRIVATE LIMITED",
"DAY NIGHT FURNITURE AND PROJECTS PRIVATE LIMITED",
"DAY STAR ENVIRO TECHNOLOGIES PRIVATE LIMITED",
"DAY STAR TRADING PRIVATE LIMITED",
"DAY TO DAY SHOPPING MART PRIVATE LIMITED",
"DAY1 ADVISORS PRIVATE LIMITED",
"DAYA CHAND ENGINEERING INDUSTRIES PRIVATE LIMITED",
"DAYA CHARAN AND SONS PRIVATE LIMITED",
"DAYA DECORATIVE LAMINATES PRIVATE LIMITED",
"DAYA ENGINEERING WORKS (POLES) PRIVATE LIMITED",
"DAYA ENGINEERING WORKS (SLEEPER) LIMITED",
"DAYA ENGINEERING WORKS PRIVATE LIMITED",
"DAYA GENERAL HOSPITAL LIMITED",
"DAYA HANDLOOMS PVT. LTD.",
"DAYA LUBRICANTS PRIVATE LIMITED",
"DAYA RAYONS PRIVATE LIMITED",
"DAYA STEEL AGENCIES PRIVATE LIMITED",
"DAYA TEX INDUSTRIES PRIVATE LIMITED",
"DAYA WORLDWIDE LIMITED",
"DAYAJEET NIMAY BUS LOGISTICS PRIVATE LIMITED",
"DAYAKAR ENTERPRISES",
"DAYAKARA SOLAR POWER PRIVATE LIMITED",
"DAYAL AQUA PRIVATE LIMITED",
"DAYAL AQUA SCIENCES PRIVATE LIMITED",
"DAYAL BIOTECH PRIVATE LIMITED",
"DAYAL COMMERCIAL CO PVT LTD",
"DAYAL COTSPIN LIMITED",
"DAYAL ENERGY AND PROTEINS LIMITED",
"DAYAL FARM SCIENCES PRIVATE LIMITED",
"DAYAL FERTILIZERS PRIVATE LIMITED",
"DAYAL GATEWAY",
"DAYAL HITECH ENGINEERS PRIVATE LIMITED",
"DAYAL HOSPITALITY PRIVATE LIMITED",
"DAYAL HOTELS & RESORTS PRIVATE LIMITED",
"DAYAL INDUSTRIES PRIVATE LIMITED",
"DAYAL INFRATECH PRIVATE LIMITED",
"DAYAL INTERNATIONAL",
"DAYAL LUMBERS PRIVATE LIMITED",
"DAYAL MULTISPECIALLITY HOSPITAL",
"DAYAL OPTICALS INDIA PRIVATE LIMITED",
"DAYAL OPTICALS PRIVATE LIMITED",
"DAYAL ORTHOPAEDIC GENERAL HOSPITAL",
"DAYAL PRODUCTS PRIVATE LIMITED",
"DAYAL RESORTS PRIVATE LIMITED",
"DAYAL ROAD WAYS PRIVATE LIMITED",
"DAYAL SEEDS PRIVATE LIMITED",
"DAYAL SP UN PIPES PRIVATE LIMITED",
"DAYAL STEEL AND CONSTRUCTION PRIVATE LIMITED",
"DAYAL STEELS LIMITED",
"DAYAL STEELS PRIVATE LIMITED",
"DAYAL TEXTILE MILLS PRIVATE LIMITED",
"DAYAL TOURS & TRVELS I PRIVATE LIMITED",
"DAYAL VET FOODS PRIVATE LIMITED",
"DAYALAL MEGHJI TOBACCO PRODUCTS PVT LTD",
"DAYALBAGH EDUCATIONAL INSTITUTE",
"DAYALOK TRANSFORMERS PRIVATE LIMITED",
"DAYAMALAM CONSULTINGS & CONSTRUCTION PRIVATE LIMITED",
"DAYANA POLYPLAST PRIVATE LIMITED",
"DAYANAND ARYA GIRLS COLLEGE",
"DAYANAND COLLEGE OF ARCHITECTURE LATUR",
"DAYANAND COLLEGE OF LAW KANPUR",
"DAYANAND CONSULTANCY SERVICE PRIVATE LIMITED",
"DAYANAND EDUCATION SOCIETY LATUR",
"DAYANAND GIRLS P G COLLEGE",
"DAYANAND MEDICAL COLLEGE & HOSPITAL",
"DAYANAND MEDICAL HOSPITAL",
"DAYANAND MUNJAL INVESTMENTS PVT LTD",
"DAYANAND PLASTICS PVT LTD",
"DAYANAND POLYPLAST PRIVATE LIMITED",
"DAYANAND SCIENCE COLLEGE LATUR",
"DAYANAND SUBHASH NATIONAL P G COLLEGE",
"DAYANAND TEXTILE INDUSTRIES PRIVATE LIMITED",
"DAYANAND UCCH PRATHAMIK SHALA",
"DAYANAND UPPER PRIMARY SCHOOL",
"DAYANAND VIDYA MANDIR",
"DAYANANDA COLD STORAGE PRIVATE LIMITED",
"DAYANANDA SAGAR ACADEMY OF TECHNOLOGY AND MANAGEMENT",
"DAYANANDA SAGAR COLLEGE",
"DAYANANDA SAGAR ENTREPRENEURSHIP RESEARCH & BUSINESS INCUBATION FOUNDATION",
"DAYANANDA SAGAR INSTITUTIONS",
"DAYANANDA SAGAR INTERNATIONAL SCHOOL",
"DAYANANDA SAGAR PRE-UNIVERSITY COLLEGE",
"DAYANANDA SAGAR UNIVERSITY",
"DAYANIDHI FOODS PRIVATE LIMITED",
"DAYANIDHI RADHA INFRA CONSTRUCTION PRIVATE LIMITED",
"DAYANIDHI SOLAR POWER PRIVATE LIMITED",
"DAYANIDHI TEXTILES PRIVATE LIMITED",
"DAYARAM CHEMICALS PRIVATE LIMITED",
"DAYAWANT CONSTRUCTIONS PRIVATE LIMITED",
"DAYAWATI BISHWANATH TRADERS PRIVATE LIMITED",
"DAYAWATI FOREX PRIVATE LIMITED",
"DAYBIGEN FASHION AND PERSONAL CARE PRIVATE LIMITED",
"DAYCO POWER TRANSMISSION PRIVATE LIMITED",
"DAYCO SECURITIES PVT LTD",
"DAYFORCE INDIA PRIVATE LIMITED",
"DAYGM VENTURES OPC PRIVATE LIMITED",
"DAYITWA CONSULTANCY SERVICES PRIVATE LIMITED",
"DAYJOY MARKETING PRIVATE LIMITED",
"DAYLON HEALTH CARE PRIVATE LIMITED",
"DAYMA INFOTECH PRIVATE LIMITED",
"DAYMA SECURITY SERVICES PRIVATE LIMITED",
"DAYNIL GROUP SOLUTIONS PRIVATE LIMITED",
"DAYNITE ENGINEERS AND CONTRACTORS PRIVATE LIMITED",
"DAYSCATCH RETAIL TECHNOLOGIES PRIVATE LIMITED",
"DAYSPRING TECHNOLOGIES PRIVATE LIMITED",
"DAYSTAR ENTERPRISES PRIVATE LIMITED",
"DAYTON COOL-TECH PRIVATE LIMITED",
"DAYTON MINING PRIVATE LIMITED",
"DAYTON NATURAL RESOURCES PRIVATE LIMITED",
"DAYTON THERMOSIPHON PRIVATE LIMITED",
"DAYTONA SYSTEMS INDIA PRIVATE LIMITED",
"DAZARO ECO GREEN PRIVATE LIMITED",
"DAZE DIGITAL PRIVATE LIMITED",
"DAZERY RETAIL INDIA PRIVATE LIMITED",
"DAZEWORKS TECHNOLOGIES PRIVATE LIMITED",
"DAZN MEDIA INDIA PRIVATE LIMITED",
"DAZSI SYSTEMS INDIA PRIVATE LIMITED",
"DAZZLE FOOD AND BEVERAGES PRIVATE LIMITED",
"DAZZLE IMPEX PRIVATE LIMITED",
"DAZZLE INCEPTION MARKETING PRIVATE LIMITED",
"DAZZLE INTERNATIONAL PRIVATE LIMITED",
"DAZZLE ORNAMENTS PRIVATE LIMITED",
"DAZZLE OVERSEAS",
"DAZZLE SPORTS WEAR PRIVATE LIMITED",
"DAZZLED ELECTRICALS PRIVATE LIMITED",
"DAZZLER MEDIA AND TOURS PRIVATE LIMITED",
"DAZZLING POOLS PRIVATE LIMITED",
"DAZZLING TRADECOM PRIVATE LIMITED",
"DAZZY PRODUCTS PRIVATE LIMITED",
"DB (INTERNATIONAL) STOCK BROKERS LIMITED",
"DB CLOTHING INDIA PRIVATE LIMITED",
"DB CONSOLIDATED PRIVATE LIMITED",
"DB CONTRACTORS & BUILDERS PRIVATE LIMITED",
"DB CREATIONS PRIVATE LIMITED",
"DB DEVICES PRIVATE LIMITED",
"DB DIXON BATTERY PRIVATE LIMITED",
"DB ENGINEERING & CONSULTING GMBH",
"DB ENGINEERING SOLUTIONS LLP",
"DB FACILITY MANAGEMENT INDIA PRIVATE LIMITED",
"DB FARMS PRIVATE LIMITED",
"DB INFOMEDIA PRIVATE LIMITED",
"DB INFRATECH",
"DB INTERNATIONAL STOCK BROKERS LIMITED",
"DB JAIN COLLEGE",
"DB MOTORS PRIVATE LIMITED",
"DB POWER MADHYA PRADESH LIMITED",
"DB PRECISION COMPONENTS PRIVATE LIMITED",
"DB PUMP TECH INDUSTRIES PRIVATE LIMITED",
"DB ROOFING (INDIA) PRIVATE LIMITED",
"DB RRTS OPERATIONS INDIA PRIVATE LIMITED",
"DB SECURE SOLUTION PRIVATE LIMITED",
"DB STEELS PRIVATE LIMITED",
"DB VIEW INFRACON PRIVATE LIMITED",
"DB WELLNESS PRIVATE LIMITED",
"DBA LOUNGE PRIVATE LIMITED",
"DBA PROPBUILD PRIVATE LIMITED",
"DBACE TECHNOLOGIES PRIVATE LIMITED",
"DB-AIRE INDIA PRIVATE LIMITED",
"DBAUX TECHNOLOGIES PRIVATE LIMITED",
"DBB WORLDWIDE PRIVATE LIMITED",
"DBBR BUILDERS PRIVATE LIMITED",
"DBC ENGINEERING INDIA PRIVATE LIMITED",
"DBC LOGISTICS PRIVATE LIMITED",
"DBD ENTERPRISE PRIVATE LIMITED",
"DBDS ROBOTICS PRIVATE LIMITED",
"DBEST CARS INDIA PRIVATE LIMITED",
"DBFS FINANCE AND LEASING INDIA LIMITED",
"DBFS SECURITIES LIMITED",
"DBG TECHNOLOGY INDIA PRIVATE LIMITED",
"DBGS TRADE INDIA PRIVATE LIMITED",
"DBH INVESTMENT CAPITAL INDIA PRIVATE LIMITED",
"DBIND WIRE PRODUCTS PRIVATE LIMITED",
"DBL ANANDAPURAM ANAKAPALLI HIGHWAYS LIMITED",
"DBL ASHOKNAGAR-VIDISHA TOLLWAYS PRIVATE LIMITED",
"DBL BANGALORE NIDAGATTA HIGHWAYS PRIVATE LIMITED",
"DBL BANKHLAFATA-DOGAWA TOLLWAYS PRIVATE LIMITED",
"DBL BELLARY BYRAPURA HIGHWAYS LIMITED",
"DBL BETUL-SARNI TOLLWAYS PRIVATE LIMITED",
"DBL BYRAPURA CHALLAKERE HIGHWAYS PRIVATE LIMITED",
"DBL CHANDIKHOLE BHADRAK HIGHWAYS LIMITED",
"DBL GORHAR KHAIRATUNDA HIGHWAYS LIMITED",
"DBL HASSAN PERIYAPATNA TOLLWAYS PRIVATE LIMITED",
"DBL HATA-DARGAWON TOLLWAYS PRIVATE LIMITED",
"DBL HIREKERUR RANIBENNUR TOLLWAYS PRIVATE LIMITED",
"DBL INFRA ASSETS PRIVATE LIMITED",
"DBL JAORA-SAILANA TOLLWAYS PRIVATE LIMITED",
"DBL KALMATH ZARAP HIGHWAYS PRIVATE LIMITED",
"DBL LUCKNOW SULTANPUR HIGHWAYS PRIVATE LIMITED",
"DBL MAHAGAON YAVATMAL HIGHWAYS PRIVATE LIMITED",
"DBL MUNDARGI HARAPANAHALLI TOLLWAYS PRIVATE LIMITED",
"DBL MUNDI-SANAWAD TOLLWAYS PRIVATE LIMITED",
"DBL NADIAD MODASA TOLLWAYS PRIVATE LIMITED",
"DBL NIDAGATTA MYSORE HIGHWAYS PRIVATE LIMITED",
"DBL PACHHWARA COAL MINE PRIVATE LIMITED",
"DBL PATAN REHLI TOLLWAYS PRIVATE LIMITED",
"DBL POONDIYANKUPPAM HIGHWAYS LIMITED",
"DBL REWA SIDHI HIGHWAYS PRIVATE LIMITED",
"DBL SANGLI BORGAON HIGHWAYS LIMITED",
"DBL SARDARPUR BADNAWAR TOLL WAYS LIMITED.",
"DBL SARDARPUR BADNAWAR TOLLWAYS PRIVATE LIMITED",
"DBL SILWANI SULTANGANJ TOLL WAYS LIMITED.",
"DBL SILWANI-SULTANGANJ TOLLWAYS PRIVATE LIMITED",
"DBL SITAMAU-SUWASARA TOLLWAYS PRIVATE LIMITED",
"DBL TIKAMGARH-NOWGAON TOLLWAYS PRIVATE LIMITED",
"DBL TULJAPUR AUSA HIGHWAYS PRIVATE LIMITED",
"DBL UCHERA - NAGOD TOLLWAYS PRIVATE LIMITED",
"DBL VENTURES PRIVATE LIMITED",
"DBL VILUPPURAM HIGHWAYS LIMITED",
"DBL WARDHA BUTIBORI HIGHWAYS PRIVATE LIMITED",
"DBL YAVATMAL WARDHA HIGHWAYS PRIVATE LIMITED",
"DBM PROJECTS PRIVATE LIMITED",
"DBM VIRCON SERVICES INDIA PRIVATE LIMITED",
"DBN CHEMICALS PRIVATE LIMITED",
"DBONTE PLYWOOD TRADING PRIVATE LIMITED",
"DBP ENGINEERING WORKS PRIVATE LIMITED",
"DBP OFFSHORE PRIVATE LIMITED",
"DBQ TECHNOLOGIES PRIVATE LIMITED",
"DBR CREDIT CAPITAL ADVISERS PRIVATE LIMITED",
"DBR PLASTICS PRIVATE LIMITED",
"DBR SANJANA KRISHNA HOSPITALS PRIVATE LIMITED",
"DBRA RETAIL PRIVATE LIMITED",
"DBRC LOGISTICS PRIVATE LIMITED",
"DBRE INDIA PRIVATE LIMITED",
"DBRS RATINGS GMBH",
"DBS AUTOMOBILES PRIVATE LIMITED",
"DBS BANK INDIA LIMITED",
"DBS BANK INDIA STAFF COOPERATIVE THIRFT AND CREDIT SOCIETY LTD",
"DBS BANK LIMITED",
"DBS CERTIFICATIONS PRIVATE LIMITED",
"DBS COLLEGE",
"DBS COLLEGE KANPUR",
"DBS CORPORATE SERVICES PRIVATE LIMITED",
"DBS FINANCIAL SERVICES PRIVATE LIMITED",
"DBS LIFESTYLE LLP",
"DBS MINTEK PRIVATE LIMITED",
"DBS PACKAGING PRIVATE LIMITED",
"DBS SECURITY SYSTEMS PRIVATE LIMITED",
"DBS TECHNOLOGY SERVICES INDIA PRIVATE LIMITED",
"DBS TRADELINK AND ADVISORS PRIVATE LIMITED",
"DBTEZ TECHNOLOGIES PRIVATE LIMITED",
"DBUILD INFRA INDIA PRIVATE LIMITED",
"DBUZZ INTERNATIONAL PRIVATE LIMITED",
"DBYDX TECHNOLOGIES PRIVATE LIMITED",
"DC APPARELS PRIVATE LIMITED",
"DC AUTO PARTS PRIVATE LIMITED",
"DC DIAMOND CONSTELLATION PRIVATE LIMITED",
"DC INFOTECH AND COMMUNICATION LIMITED",
"DC MODEL INTERNATIONAL SCHOOL",
"DC MODEL SENIOR SECONDARY SCHOOL",
"DC SOUTH WEST",
"DC WEB SERVICES PRIVATE LIMITED",
"DC WOVENSACK PRIVATE LIMITED",
"DCA ARCHITECTURE AND DESIGN PRIVATE LIMITED",
"DCAMP FOODS AND HEALTH SERVICES PRIVATE LIMITED",
"DCARE TECHNOLOGIES INDIA PRIVATE LIMITED",
"DCARGO OVERSEAS PRIVATE LIMITED",
"DCART LOGISTICS PRIVATE LIMITED",
"DCAS (INDIA) PRIVATE LIMITED",
"DCB BANK LIMITED",
"DCB POWER VENTURES LIMITED",
"DCC BANK",
"DCC BANK LTD BIDAR",
"DCC BUILDCON PRIVATE LIMITED",
"DCC CRAFT DEVELOPMENT PRIVATE LIMITED",
"DCC INFOTECH PRIVATE LIMITED",
"DCC INFRA PROJECTS LIMITED",
"DCC PRINT VISION LLP",
"DCCB KHARGONE",
"DCCI PRIVATE LIMITED",
"DCDC HEALTH SERVICES PRIVATE LIMITED",
"DCE REFRIGERATION PRIVATE LIMITED",
"DCF EXPO PRIVATE LIMITED",
"DCF FINANCIAL SERVICES PRIVATE LIMITED",
"DCF TRADING PRIVATE LIMITED",
"DCF WL MUKUNDARA NATIONAL PARK KOTA",
"DCG CABLES & WIRES LIMITED",
"DCG DATA-CORE SYSTEMS INDIA PRIVATE LIMITED",
"DCG TECH LIMITED",
"D-CHEL OIL & GAS PRODUCTS (OPC) PRIVATE LIMITED",
"DCHICA FASHION LIFESTYLE PRIVATE LIMITED",
"DCI INDIA PRIVATE LIMITED",
"DCI PHARMACEUTICALS",
"DCIPHER TALENTS PRIVATE LIMITED",
"DCIS DOT COM SOLUTIONS INDIA PRIVATE LIMITED",
"DCK MANAGEMENT SERVICES PRIVATE LIMITED",
"DCL BULK TECHNOLOGIES PRIVATE LIMITED",
"DCM BEARINGS PRIVATE LIMITED",
"DCM CONTAINERS & ENGINEERING PRIVATE LIMITED",
"DCM DATA SYSTEMS LIMITED",
"DCM FASHIONS PRIVATE LIMITED",
"DCM FINANCIAL SERVICES LIMITED",
"DCM INDIA",
"DCM INFOTECH LIMITED",
"DCM SHRIRAM AQUA FOODS LIMITED",
"DCM SHRIRAM CREDIT AND INVESTMENTS LIMITED",
"DCM SHRIRAM FOUNDATION",
"DCM SHRIRAM LIMITED",
"DCM VIGILANCE & MAINTENANCE SERVICES PRIVATE LIMITED",
"DCM HYUNDAI LIMITED",
"DCNET SOLUTIONS INDIA PRIVATE LIMITED",
"DCNPL PRIVATE LIMITED",
"DCODE RESEARCH SERVICES PRIVATE LIMITED",
"DCPOWER PRODUCTS PRIVATE LIMITED",
"DCQ LOGISTICS PRIVATE LIMITED",
"DCR COOLING TOWERS",
"DCR DESIGN PRIVATE LIMITED",
"DCR DISTILLERY PRIVATE LIMITED",
"DCREATION STYLE PRIVATE LIMITED",
"DCREW TECHNOLOGY SOLUTIONS (OPC) PRIVATE LIMITED",
"DCS AGRO CARE PRIVATE LIMITED",
"DCS INDUSTRIES PRIVATE LIMITED",
"DCS LIMITED",
"DCS MOTORS PRIVATE LIMITED",
"DCS TECHNO SERVICES PRIVATE LIMITED",
"DCS TRADING AND SERVICES PRIVATE LIMITED",
"DCSPLUS TRAVEL TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"D-CUBE ANALYTICS PRIVATE LIMITED",
"DCW LIMITED",
"DCX CABLE ASSEMBLIES PRIVATE LIMITED",
"DCX SYSTEMS LIMITED",
"DD AGRO FOODS PVT LTD",
"DD FASHION FAB PRIVATE LIMITED",
"DD INDUSTRIES LIMITED",
"DD INFOTECH INDIA PRIVATE LIMITED",
"DD INFRASTRUCTURES PRIVATE LIMITED",
"DD INFRAVENTURE PRIVATE LIMITED",
"DD INTERNATIONAL PRIVATE LIMITED",
"DD IRON AND STEELS PRIVATE LIMITED",
"DD ISPAT UDYOG PRIVATE LIMITED",
"DD KHOSLA TRANSPORT PRIVATE LIMITED",
"DD MOTOCORP PRIVATE LIMITED",
"DD MOTORS",
"DD NUTRITIONS PRIVATE LIMITED",
"DD OILS INDIA PRIVATE LIMITED",
"DD POLYMERS PRIVATE LIMITED",
"DD TARGET PMT PRIVATE LIMITED",
"DDB MARKETING SERVICES PRIVATE LIMITED",
"DDB MUDRA MAX PRIVATE LIMITED",
"DDB MUDRA PRIVATE LIMITED",
"DDC BROADBAND PRIVATE LIMITED",
"DDC CATV NETWORK PRIVATE LIMITED",
"DDC ELECTRONICS PRIVATE LIMITED",
"DDC INTERIORS PRIVATE LIMITED",
"DDD ENGINEERING SOLUTION PRIVATE LIMITED",
"DDE RENEWABLE ENERGY PRIVATE LIMITED",
"DDEN TV PRIVATE LIMITED",
"DDEV PLASTIKS INDUSTRIES LIMITED",
"DDEV SPICES PRIVATE LIMITED",
"DDF CONSULTANTS PRIVATE LIMITED",
"DDI INDIA PRIVATE LIMITED",
"DDI STUDIOS PRIVATE LIMITED",
"DDI VISUALS PRIVATE LIMITED",
"DDL INFRATECH PRIVATE LIMITED",
"DDMM INSTITUTE OF CARDIOLOGY & CVS",
"DDMY ENTERPRISE PRIVATE LIMITED",
"DDN SFA LIMITED",
"DDNMRC PET SCANS PRIVATE LIMITED",
"DDO 10 KOLKATA",
"DDO GMSH CHANDIGARH",
"DDP PUBLICATIONS PRIVATE LIMITED",
"DDP SPECIALITY PRODUCTS INDIA PRIVATE LIMITED",
"DDP TRAVEL FOREX PRIVATE LIMITED",
"DDPL COMMODITIES PRIVATE LIMITED",
"DDPL GLOBAL INFRASTRUCTURE PRIVATE LIMITED",
"DDR AND COMPANY",
"DDR ENTERPRISES PRIVATE LIMITED",
"DDRC AGILUS PATHLABS LIMITED",
"DDRC SRL DIAGNOSTICS PRIVATE LIMITED",
"DDREG PHARMA PRIVATE LIMITED",
"DDRIVEN DATA SCIENCES & ANALYTICS PRIVATE LIMITED",
"DDS - TPM FLAVOURS PRIVATE LIMITED",
"DDS ACADEMY PRIVATE LIMITED",
"DDS JEWELS PRIVATE LIMITED",
"DDS TEC LOG SOLUTIONS PRIVATE LIMITED",
"DDU HOSPITAL",
"DDV MANAGEMENT SERVICES PRIVATE LIMITED",
"DE ANNPURNA CONTRACTS INDIA PRIVATE LIMITED",
"DE ARYANS PRIVATE LIMITED",
"DE BEERS INDIA PRIVATE LIMITED",
"DE CONVERTER INDIA PVT LTD",
"DE DECOR ENGINEERING PRIVATE LIMITED",
"DE DESIGN & INTERIORS PRIVATE. LIMITED.",
"DE DIAMOND ELECTRIC INDIA PRIVATE LIMITED",
"DE DIETRICH PROCESS SYSTEMS INDIA PRIVATE. LIMITED.",
"DE FACTO INFOTECH PRIVATE LIMITED",
"DE HEUS INDIA PRIVATE LIMITED",
"DE INDIAN PUBLIC SCHOOL",
"DE LA RUE INDIA PRIVATE LIMITED",
"DE LAGE LANDEN FINANCIAL SERVICES INDIA PRIVATE LIMITED",
"DE MOLEN EXPORTS PRIVATE LIMITED",
"DE NOBILI MATRICULATION HIGHER SECONDARY SCHOOL",
"DE NOBILI SCHOOL C M R I",
"DE NOBILI SCHOOL MAITHON",
"DE NORA INDIA LIMITED",
"DE NOVA SEEDS PRIVATE LIMITED",
"DE NOVO HEALTHCARE PRIVATE LIMITED",
"DE PAUL SCHOOL",
"DE PESTER COMPANY",
"DE PIPES PRIVATE LIMITED",
"DE RIO HEALTHCARE PRIVATE LIMITED",
"DE SCIENCE INFOWARE PRIVATE LIMITED",
"DE SMET ENGINEERS&CONTRACTORS INDIA PRIVATE LIMITED",
"DE SOTO TECHNOLOGIES PRIVATE LIMITED",
"DE SOUZA LEISURES PRIVATE LIMITED",
"DE SPARROW SOLUTIONS PRIVATE LIMITED",
"DE SPORTSBAY PRIVATE LIMITED",
"DE WORKS COMMUNICATIONS PRIVATE LIMITED",
"DE. SOMA PLASTIC UDYOG PRIVATE LIMITED",
"DEACON INFRASTRUCTURES PRIVATE LIMITED",
"DEACON SOLAR SOLUTIONS PRIVATE LIMITED",
"DEACON'S CROP SCIENCE PRIVATE LIMITED",
"DEAL D R DO",
"DEAL DEPOT BROKERAGE PRIVATE LIMITED",
"DEAL GLOBAL FASHIONS PRIVATE LIMITED",
"DEALBERG TECHNOLOGIES PRIVATE LIMITED",
"DEALERS IN PHARMACEUTICAL RAW MATERIAL CHEMICALS & SOLVENTS",
"DEALERSOCKET (INDIA) PRIVATE LIMITED",
"DEALING BENEFICIAL FINANCIAL SERVICES PRIVATE LIMITED",
"DEALMATRIX SERVICES PRIVATE LIMITED",
"DEALMONEY COMMODITIES PRIVATE LIMITED",
"DEALMONEY REAL ESTATE PRIVATE LIMITED",
"DEALMONEY SECURITIES PRIVATE LIMITED",
"DEALMYTIME SERVICES PRIVATE LIMITED",
"DEALOGIC SUPPORT SERVICES INDIA PRIVATE LIMITED",
"DEALPLUS YARNS TRADING PRIVATE LIMITED",
"DEALS FOR WHEELZ AUTO SOLUTIONS",
"DEALS OF ARYA FINSERV CONSULTANTS PRIVATE LIMITED",
"DEALS SANITATION PRIVATE LIMITED",
"DEALSDRAY ONLINE PRIVATE LIMITED",
"DEALSKART ONLINE SERVICES PRIVATE LIMITED",
"DEALSLAND RETAILS PRIVATE LIMITED",
"DEALSTEALER GODDIES PRIVATE LIMITED",
"DEAN FOODS COMPANY",
"DEAN GOVERNMENT AYURVEDIC HOSPITAL",
"DEAN GOVERNMENT MEDICAL COLLEGE",
"DEAN GOVERNMENT MEDICAL COLLEGE AND GENERAL HOSPITAL LATUR",
"DEAN INFOTECH PRIVATE LIMITED",
"DEAN MEDICAL COLLEGE AND HOSPITAL CANCER RESEARCH CENTER AURANGABAD",
"DEAN MEDICAL COLLEGE AND HOSPITAL CANCER RESERCH CENTER",
"DEANGRO PACKAGING PRIVATE LIMITED",
"DEANTA PUBLISHING SERVICES PRIVATE LIMITED",
"DEAR & DEARS CONSTRUCTION PRIVATE LIMITED",
"DEAR AUTO COMPS PVT LTD",
"DEAR SHARES PRIVATE LIMITED",
"DEARCH DESIGNS AND CONSTRUCTIONS PRIVATE LIMITED",
"DEARLIFE EMPOWER INDIA PRIVATE LIMITED",
"DEASH TRADE-NET PRIVATE LIMITED",
"DEAZZLE SERVICES PRIVATE LIMITED",
"DEB E. I. SHIPPING AGENCY PRIVATE LIMITED",
"DEB INFRA HOMES PRIVATE LIMITED",
"DEB PAINTS PVT LTD",
"DEB REALTORS PRIVATE LIMITED",
"DEB RUPAYAN HOUSING COMPANY LIMITED",
"DEBABRATA PROPERTIES PRIVATE LIMITED",
"DEBAI WALE KAPIL JEWELLERS AND GOLDSMITHS PRIVATE LIMITED",
"DEBAK ENTERPRISES PRIVATE. LIMITED.",
"DEBASHU SERVICES PRIVATE LIMITED",
"DEBASIS AGROVET PRIVATE LIMITED",
"DEBBAS LIGHTING INDIA PRIVATE LIMITED",
"DEBCO PHARMA PRIVATE LIMITED",
"DEBDEEP COMMERCIAL PRIVATE LIMITED",
"DEBEANJANA HARD COKE PRIVATE LIMITED",
"DEBENDRA TEA AND COMPANY PRIVATE LIMITED",
"DEBGIRI AGRO PRODUCTS PRIVATE LIMITED",
"DEBI STEEL TUBES PRIVATE LIMITED",
"DEBIPUR NETRALAYA PRIVATE LIMITED",
"DEBIS INTERNATIONAL TRADING GMBH",
"DEBJYOTI OVERSEAS PRIVATE LIMITED",
"DEBJYOTI PULP AND PAPER PRIVATE LIMITED",
"DEBLINES PVT LTD",
"DEBNAR CORPSOL PRIVATE LIMITED",
"DEBNATH BIRI COMPANY PVT LTD",
"DEBNATH FOREX & TRAVELS PRIVATE LIMITED",
"DEBNATH KAGAJ UDYOG PRIVATE LIMITED",
"DEBNATH TEXTILES PRIVATE LIMITED",
"DEBOCK VENTURES LIMITED",
"DEBON HERBALS PRIVATE LIMITED",
"DEBONAIR MERCHANDISE PRIVATE LIMITED",
"DEBONAIR REALTORS PRIVATE LIMITED",
"DEBONAIR TOURS & TRAVELS PRIVATE LIMITED",
"DEBORAH MILANO INDIA PRIVATE LIMITED",
"DEBOX CONSULTING PRIVATE LIMITED",
"DEBPARA TEA COMPANY LIMITED",
"DEBQEE BIOTEC PRIVATE LIMITED",
"DEBRAJ HOTELS PRIVATE LIMITED",
"DEBRIQUE CREATIVE LABS PRIVATE LIMITED",
"DEBRUP COMMERCIAL PRIVATE LIMITED",
"DEBSON PUMPS PVT LTD",
"DEBTCARE ENTERPRISES PRIVATE LIMITED",
"DEBUG INFOTECH PRIVATE LIMITED",
"DEBUKA INDUSTRIES PRIVATE LIMITED",
"DEBURRING INDIA PRIVATE LIMITED",
"DEBUT INFOTECH PRIVATE LIMITED",
"DEC FACILITY INDIA PRIVATE LIMITED",
"DEC INDUSTRIES PRIVATE LIMITED",
"DEC PROPERTY MANAGEMENT INDIA PRIVATE LIMITED",
"DECA CONTACT (INDIA) PRIVATE LIMITED",
"DECAGON TELECOM PRIVATE LIMITED",
"DECAL PRINT (INDIA) PRIVATE LIMITED",
"DECALOGUE MARKETING PRIVATE LIMITED",
"DECARETAKERS FACILITY SERVICES PRIVATE LIMITED",
"DECATHLON SPORTS INDIA PRIVATE LIMITED",
"DECATHLON SPORTS INDIA PRIVATE. LIMITED",
"DECBECTOCHEM ENGINEERING PRIVATE LIMITED",
"DECCALEAP TECHNOLOGIES LLP",
"DECCAN 360 AIRSEA LOGISTICS PRIVATE LIMITED",
"DECCAN AGRO FARM PRIVAE LIMITED",
"DECCAN AGRO TRADE PRIVATE LIMITED",
"DECCAN ALLOYS PRIVATE LIMITED",
"DECCAN AUTO LIMITED",
"DECCAN AUTOMOBILES PRIVATE LIMITED",
"DECCAN CABLES PVT LTD",
"DECCAN CANS AND PRINTERS PRIVATE LIMITED",
"DECCAN CEMENTS LIMITED",
"DECCAN CHARTERS PRIVATE LIMITED",
"DECCAN COLD STORAGES (INDIA) PRIVATE LIMITED",
"DECCAN COLLEGE OF ENG TECH",
"DECCAN COLLEGE OF MEDICAL SCIENCES HOSPITAL",
"DECCAN COLLEGE POST GRADUATE AND RESEARC",
"DECCAN COLOUR AND CHEMICALS PRIVATE LIMITED",
"DECCAN CONSTRUCTION EQUIPMENTS & MACHINERY PRIVATE LIMITED",
"DECCAN CONSULTING ENGINEERS PRIVATE LIMITED",
"DECCAN CREATIONS PRIVATE LIMITED",
"DECCAN DENTAL DEPOT PRIVATE LIMITED",
"DECCAN DIE CASTINGS PRIVATE LIMITED",
"DECCAN DIGITAL NETWORKS (HYDERABAD) PRIVATE LIMITED",
"DECCAN EDIBLES PRIVATE LIMITED",
"DECCAN ENGINEERING CONSTRUCTIONS PRIVATE LIMITED",
"DECCAN ENTERPRISES LIMITED",
"DECCAN ENTERPRISES PRIVATE LIMITED",
"DECCAN ENVIRONMENTAL CONSULTANTS PRIVATE LIMITED",
"DECCAN ESTATES PRIVATE LIMITED",
"DECCAN EXPLOTECH PRIVATE LIMITED",
"DECCAN FABRICATORS PRIVATE LIMITED",
"DECCAN FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"DECCAN FARM EQUIPMENT P LTD",
"DECCAN FASTENERS PRIVATE LIMITED",
"DECCAN FERRO ALLOYS PRIVATE LIMITED",
"DECCAN FINANCE LIMITED",
"DECCAN FINANCIAL SERIVCE",
"DECCAN FINE CHEMICALS INDIA PRIVATE LIMITED",
"DECCAN GRAINZ PRIVATE LIMITED",
"DECCAN HEALTH CARE LIMITED",
"DECCAN HITECH ENGINEERING PRIVATE LIMITED",
"DECCAN HYDRAULICS PRIVATE LIMITED",
"DECCAN I SERVICES PRIVATE LIMITED",
"DECCAN INDUSTRIES",
"DECCAN INFRABUILD PRIVATE LIMITED",
"DECCAN INFRAVENTURES PRIVATE LIMITED",
"DECCAN INSURANCE & REINSURANCE BROKERS PRIVATE LIMITED",
"DECCAN IRRITECH PRIVATE LIMITED",
"DECCAN JEWELLERS PRIVATE LIMITED",
"DECCAN LIFE SCIENCES PRIVATE LIMITED",
"DECCAN LOGISTICS SOLUTIONS INDIA PRIVATE LIMITED",
"DECCAN MANAGEMENT CONSULTANTS FINISHING SCHOOLS SKILL FOUNDATION",
"DECCAN MECHANICAL AND CHEMICAL INDUSTRIES PRIVATE LIMITED",
"DECCAN MEDICAL COLLEGE",
"DECCAN MEDISALES PRIVATE LIMITED",
"DECCAN METAL PROFILERS PRIVATE LIMITED",
"DECCAN MINING SYNDICATE PRIVATE LIMITED",
"DECCAN MULTISPECIALITY HARDIKAR HOSPITAL",
"DECCAN MUSIC PRIVATE LIMITED",
"DECCAN NUTRACEUTICALS PRIVATE LIMITED",
"DECCAN OVERSEAS PRIVATE LIMITED",
"DECCAN PACKAGING INDIA PRIVATE LIMITED",
"DECCAN PHARMACT PRIVATE LIMITED",
"DECCAN PLAST INDUSTRIES",
"DECCAN PROMOTERS PRIVATE LIMITED",
"DECCAN PUMPS PRIVATE LIMITED",
"DECCAN REAL VENTURES PRIVATE LIMITED",
"DECCAN RESORTS MAHAD PRIVATE LIMITED",
"DECCAN SALES & SERVICE PRIVATE LIMITED",
"DECCAN SMITHS PRIVATE LIMITED",
"DECCAN STAINLESS BHARATH PRIVATE LIMITED",
"DECCAN STRUCTURES PRIVATE LIMITED",
"DECCAN SUGAR PRIVATE LIMITED",
"DECCAN TECHNOSECURITY & UTILITYSERVICES PRIVATE LIMITED",
"DECCAN TOBACCO EXPORTS PRIVATE LIMITED",
"DECCAN TOWNSHIPS PRIVATE LIMITED",
"DECCAN TRANSCON LEASING PRIVATE LIMITED",
"DECCAN VEHICLES PRIVATE LIMITED",
"DECCAN WEAVES PRIVATE LIMITED",
"DECCAN WEB ASSETS PRIVATE LIMITED",
"DECCANFARMS AGRO SAMRUDDHI PRIVATE LIMITED",
"DECCANLOGIC PRIVATE LIMITED",
"DECCANO CASEMENTS PRIVATE LIMITED",
"DECCANPRINCE BIOTECH & CHEMICALS PRIVATE LIMITED",
"DECCANS PARK LIMITED",
"DECCAPEL FASHIONS PRIVATE LIMITED",
"DECCO APPLIANCES PRIVATE LIMITED",
"DECCON MANAGEMENT CONSULTANT FINISHING SCHOOL",
"DECELER VIBROTEK CONTROLS PRIVATE LIMITED",
"DECENT AIR TRANSPORT PRIVATE LIMITED",
"DECENT BUILDWELL PRIVATE LIMITED",
"DECENT CARGO MOVERS PRIVATE LIMITED",
"DECENT COLD STORAGE PRIVATE LIMITED",
"DECENT CONSULTANCY AND MANAGEMENT SERVICES PVT. LTD.",
"DECENT DECOR PRIVATE LIMITED",
"DECENT HUMAN RESOURCES AND SOLUTIONS PRIVATE LIMITED",
"DECENT INDUSTRIES PRIVATE LIMITED",
"DECENT MEDICAL EQUIPMENT SYSTEMS PRIVATE LIMITED",
"DECENT PAPER MILLS PRIVATE LIMITED",
"DECENT SECURITIES PRIVATE LIMITED",
"DECENT SHIPPING PRIVATE LIMITED",
"DECENT SOFTTECH PRIVATE LIMITED",
"DECENT SPINNERS PVT LTD",
"DECENTRO TECH PRIVATE LIMITED",
"DECEUNINCK PROFILES INDIA PRIVATE LIMITED",
"DECG INTERNATIONAL",
"DECHANCASTMAC PRIVATE LIMITED",
"DECHEM CHEMICALS PRIVATE LIMITED",
"DECHEM PLASTICS PRIVATE LIMITED",
"DECHEM RESINS LIMITED",
"DECHEN ENTERPRISES PRIVATE LIMITED",
"DECIBEL AUDIO-SYSTEMS PRIVATE LIMITED",
"DECIBELLS GOLD PROSTHESIS PRIVATE LIMITED",
"DECIBELPRO PRIVATE LIMITED",
"DECIBELS & PIXELS SOLUTIONS PRIVATE LIMITED",
"DECILLION DIGITAL PRIVATE LIMITED",
"DECIMAL POINT ANALYTICS PRIVATE LIMITED",
"DECIMAL TECHNOLOGIES PRIVATE LIMITED",
"DECIMIN CONTROL SYSTEMS PRIVATE LIMITED",
"DECIMUS FINANCIAL LIMITED",
"DECINA PHARMA PRIVATE LIMITED",
"DECIPHER HEALTH RECORDS LLP",
"DECIPHER SOFTWARE SOLUTIONS PRIVATE LIMITED",
"DECISION AUTOMATION AND ANALYTICS SOLUTIONS PRIVATE LIMITED",
"DECISION MACHINES PRIVATE LIMITED",
"DECISION MINDS INDIA PRIVATE LIMITED",
"DECISION POINT PRIVATE LIMITED",
"DECISION SIX PRIVATE LIMITED",
"DECISION TREE ANALYTICS AND SERVICES PRIVATE LIMITED",
"DECISIONCRAFT PRIVATE LIMITED",
"DECISIONNXT PRIVATE LIMITED",
"DECISIONS BPM SERVICES PRIVATE LIMITED",
"DECISIONSLAB INFOTECH PRIVATE LIMITED",
"DECISIVE ANALYTICAL SYSTEMS PRIVATE LIMITED",
"DECISIVEDGE TECHNOLOGY SERVICES PRIVATE LIMITED",
"DE-CIX INTERWIRE INTERNET SERVICES PRIVATE LIMITED",
"DECK COATINGS PRIVATE LIMITED",
"DECK INDIA ENGINEERING PRIVATE LIMITED",
"DECK MOUNT ELECTRONICS PRIVATE LIMITED",
"DECKER DEVICES PRIVATE LIMITED",
"DECKER FORMWORK SOLUTIONS PRIVATE LIMITED",
"DECKER LOGISTICS PRIVATE LIMITED",
"DECKO FLOOR PRIVATE LIMITED",
"DECLAN DESIGNERS & ENGINEERS PRIVATE LIMITED",
"DECMORE PANELS LIMITED",
"DECO EQUIPMENTS PRIVATE LIMITED",
"DECO GOLD GLAZED TILES LIMITED",
"DECO MICA LIMITED",
"DECO PRIDE INDIA PRIVATE LIMITED",
"DECO VALVES PRIVATE LIMITED",
"DECO VINYL PRIVATE LIMITED",
"DECODE ADVERTISING PRIVATE LIMITED",
"DECODE DESIGN STUDIO PRIVATE LIMITED",
"DECODE RESOLVENCY INTERNATIONAL PRIVATE LIMITED",
"DECODEUP PRIVATE LIMITED",
"DECOLAB INDIA PRIVATE LIMITED",
"DECOLENE FIBRES PRIVATE LIMITED",
"DECOLITE PAINTS PVT LTD",
"DECOLUX WINDOW FASHIONS PRIVATE LIMITED",
"DECOMET INDUSTRIES PRIVATE LIMITED",
"DECOMET MARKETING PRIVATE LIMITED",
"DECON AGRI OILS PRIVATE LIMITED",
"DECON CONSTRUCTION COMPANY",
"DECON EQUIPMENTS AND SYSTEMS PRIVATE LIMITED",
"DECON INDIA PLASTICS PRIVATE LIMITED",
"DECON LIGHTING PVT LTD",
"DECON TELECOM SOLUTIONS PRIVATE LIMITED",
"DECOPLAST INDUSTRIES PRIVATE LIMITED",
"DECOPRINT INKS AND COATINGS PRIVATE LIMITED",
"DECOR AVIATION PRIVATE LIMITED",
"DECOR BRASS INDIA PRIVATE LIMITED",
"DECOR INDIA PVT LTD",
"DECOR MODULAR SYSTEMS PRIVATE LIMITED",
"DECOR PAPER MILLS LIMITED",
"DECOR REALTY PRIVATE LIMITED",
"DECOR SECURITIES PRIVATE LIMITED",
"DECORA AUTO FORGE PRIVATE LIMITED",
"DECORA COTTON EXPORTS PRIVATE LIMITED",
"DECORA KITCHEN INTERIORS PRIVATE LIMITED",
"DECORA LIGHTS PRIVATE LIMITED",
"DECORATIVE PANELS & DOORS PRIVATE LIMITED",
"DECORATIVE SLEEVES PRIVATE LIMITED",
"DECORE EXXOILS PRIVATE LIMITED",
"DECOREX PRODUCTS INDIA PRIVATE LIMITED",
"DECORHUT PRIVATE LIMITED",
"DECORIS HOMEZ PRIVATE LIMITED",
"DECORMYPLACE HOME DECORS PRIVATE LIMITED",
"DECORMYSPOT (INDIA) PRIVATE LIMITED",
"DECORNATION PRIVATE LIMITED",
"DECORO SOFTWARE SOLUTIONS PRIVATE LIMITED",
"DECORPAC INDIA PRIVATE LIMITED",
"DECORUM INFRACON PRIVATE LIMITED",
"DECORUM OVERSEAS PRIVATE LIMITED",
"DECOS SOFTWARE DEVELOPMENT PRIVATE LIMITED",
"DECOSTYLE TECHNICS PRIVATE LIMITED",
"DECOTECH ELECTRICALS PRIVATE LIMITED",
"DECOTECH GLASS INDIA PRIVATE LIMITED",
"DECOTECH INNOVATIONS PRIVATE LIMITED",
"DECOTEX FABRICS INDIA PRIVATE LIMITED",
"DECOTOUCH PAINTS LIMITED",
"DECOVITA CERAMICS PRIVATE LIMITED",
"DECOWEL SHOES PRIVATE LIMITED",
"DECRR INTERIO PRIVATE LIMITED",
"DECTREE INFOTECH PRIVATE LIMITED",
"DECURTIS INTERNATIONAL PRIVATE LIMITED",
"DECVIN LABORATORIES PVT. LTD.",
"DEDEEPYA PHARMA PRIVATE LIMITED",
"DEDELTA FIRE AND SAFETY SOLUTIONS PRIVATE LIMITED",
"DEDHIA AGROCHEM PRIVATE LIMITED",
"DEDHIA BUILDERS & DEVELOPERS INDIA LLP",
"DEDHIA POLYMERS PRIVATE LIMITED",
"DEDHIA TRADECOM PRIVATE LIMITED",
"DEDICATED FREIGHT CORRIDOR CORPORATION OF INDIA LIMITED",
"DEE ARE TEXFAB PRIVATE LIMITED",
"DEE BEE ORGANICS PVT. LTD",
"DEE CEE COAL CARRIERS PRIVATE LIMITED",
"DEE CEE ELEVATORS PRIVATE LIMITED",
"DEE COLOR PRODUCERS PRIVATE LIMITED",
"DEE CONTROL AND ELECTRIC PRIVATE LIMITED",
"DEE DEE STEEL CASTINGS PRIVATE LIMITED",
"DEE DEE TECHNO SYSTEMS PRIVATE LIMITED",
"DEE DEVELOPMENT ENGINEERS LIMITED",
"DEE EMM GIKEN PRIVATE LIMITED",
"DEE ESS ASSOCIATES PRIVATE LIMITED",
"DEE FABRICOM INDIA PRIVATE LIMITED",
"DEE FIVE SHRINK INSULATIONS PRIVATE LIMITED",
"DEE GEE FABRICS PRIVATE LIMITED",
"DEE GEE SAW AND METAL WORKS PRIVATE LIMITED",
"DEE HOSPITALITY PRIVATE LIMITED",
"DEE KAY VISION PRIVATE LIMITED",
"DEE MARK HEALTH CARE PRIVATE LIMITED",
"DEE MOTORS PRIVATE LIMITED",
"DEE PEE ENTERPRISE (SURAT) PRIVATE LIMITED",
"DEE RAJ CORPORATION PRIVATE LIMITED",
"DEE RESTAURANTS PRIVATE LIMITED",
"DEE TEC TOOLS LLP",
"DEE TEE INDUSTRIES LIMITED",
"DEE VEE PROJECTS LIMITED",
"DEE WATERNEER EQUIPMENTS PRIVATE LIMITED",
"DEEAR MEDICAL PRIVATE LIMITED",
"DEEBA ENGINEERS AND MARKETING PRIVATE LIMITED",
"DEEBACO PRIVATE LIMITED",
"DEECEE ELECTRO SYSTEMS PVT LTD",
"DEEDWANIA AUTOMOBILES PRIVATE LIMITED",
"DEEDY CHEMICALS PRIVATE LIMITED",
"DEEEJAY MINERALS PRIVATE LIMITED",
"DEEESS ENGINEERS INDIA PROJECTS PRIVATE LIMITED",
"DEEG MARKETINGS PRIVATE LIMITED",
"DEEGEE SOFTWARE PRIVATE LIMITED",
"DEEGEE TECHLYTICS SOLUTIONS PRIVATE LIMITED",
"DEEHER ENGINEERING PRIVATE LIMITED",
"DEEHIVE PRIVATE LIMITED",
"DEEJAY COCONUT FARM PRIVATE LIMITED",
"DEEJAY DISTILLERIES PRIVATE. LIMITED.",
"DEEJAY DYNAMIX EXPLOSIVES PRIVATE LIMITED",
"DEEJAY FACILITY SERVICES PRIVATE LIMITED",
"DEEJAY MULTIPACKS PRIVATE LIMITED",
"DEEJAY NEELAM MARBLE INDUSTRIES PVT LTD",
"DEEJAY PLASTICS PRIVATE LIMITED",
"DEEJAY PROJECTS PRIVATE LIMITED",
"DEEJAY SYSTEM CONSULTANTS PRIVATE LIMITED",
"DEEJOS ENGINEERS AND CONTRACTORS PRIVATE LIMITED",
"DEEKAY BUILDCON PRIVATE LIMITED",
"DEEKAY ELECTRICALS",
"DEEKAY ELECTRICALS INDIA PRIVATE LIMITED",
"DEEKAY MARINE SERVICES PRIVATE LIMITED",
"DEEKAY PINE BOARD PRIVATE LIMITED",
"DEEKAY SPINNING MILLS LIMITED",
"DEEKAY TREXIM INDIA PRIVATE LIMITED",
"DEEKSHA ANALYTICAL PRIVATE LIMITED",
"DEEKSHA CLASSES PRIVATE LIMITED",
"DEEKSHA EXPORTS PRIVATE LIMITED",
"DEEKSHA HOLDING LIMITED",
"DEEKSHA HUMAN RESOURCE INITIATIVES LIMITED",
"DEEKSHA JUNIOR COLLEGE",
"DEEKSHAA INFOSYSTEMS PRIVATE LIMITED",
"DEEL EOR PRIVATE LIMITED",
"DEELAKSHYA ELECTRICALS PRIVATE LIMITED",
"DEELUX CABLES AND WIRES PVT LTD",
"DEEM ROLL-TECH LIMITED",
"DEEM SOFTWARE INDIA PRIVATE LIMITED",
"DEEMAN GROWTH PRIVATE LIMITED",
"DEEMARK BATH FITTINGS",
"DEEMYES SHIPPING AND LOGISTICS PRIVATE LIMITED",
"DEEN BANDHU OIL MILLS PVT.LTD.",
"DEEN DAYAL FOODS PRIVATE LIMITED",
"DEEN DAYAL UPADHYAY HOSPITAL",
"DEEN DAYAL UPADHYAYA GORAKHPUR UNIVERSITY GORAKHPUR",
"DEEN DYAL UPADHAYAY HOSPITAL",
"DEENANATH DEVELOPERS PRIVATE LIMITED",
"DEENANATH MANGESHKAR HOSPITAL & RESEARCH CENTER",
"DEENANATH POLYAMIDE PRIVATE LIMITED",
"DEENBANDHU CHHOTU RAM UNIVERSITY OF SCIENCE & TECHNOLOGY, MURTHAL",
"DEENDAYAL & MODOOM INDUSTRIES PRIVATE LIMITED",
"DEENDAYAL CANCER HOSPITAL",
"DEENDAYAL NAGARI SAHAKARI BANK LTD",
"DEENDAYAL PORT AUTHORITY",
"DEENDAYAL PORT TRUST",
"DEENEE PACKAGING PRIVATE LIMITED",
"DEENOX POLY-YARN PRIVATE LIMITED",
"DEENR INFRATECH PRIVATE LIMITED",
"DEENS ACADEMY",
"DEENS INFRASTRUCTURE INDIA PRIVATE LIMITED",
"DEEP & RANA INFRATECH PRIVATE LIMITED",
"DEEP ALLOYS",
"DEEP ARMOR TECHNOLOGIES PRIVATE LIMITED",
"DEEP AUTO ELECTRICALS PRIVATE LIMITED",
"DEEP AUTOMATION PRIVATE LIMITED",
"DEEP AUTOMOBILES",
"DEEP AUTOMOTIVE PRIVATE LIMITED",
"DEEP AUTOTEC PRIVATE LIMITED",
"DEEP BEVERAGES PRIVATE LIMITED",
"DEEP BLUE APPLIANCES PRIVATE LIMITED",
"DEEP BLUE XPRESS LIMITED",
"DEEP CARPETS MANUFACTURING LTD",
"DEEP CHAND DIALYSIS CENTRE PRIVATE LIMITED",
"DEEP CHAND ONCOLOGY SERVICES PRIVATE LIMITED",
"DEEP COLOUR SCAN PRIVATE LIMITED",
"DEEP COLOURS PRIVATE LIMITED",
"DEEP CONTAINER CARRIERS PRIVATE LIMITED",
"DEEP DARSHAN VIDHYA SANKUL",
"DEEP DIAMOND INDIA LIMITED",
"DEEP DISTILLERIES AND BREWERIES PRIVATE LIMITED",
"DEEP DISTRIBUTORS PRIVATE LIMITED",
"DEEP DREDGING & INFRA PRIVATE LIMITED",
"DEEP ELECTRICALS",
"DEEP ENGINEERING WORKS PRIVATE LIMITED",
"DEEP EXPLO EQUIPMENTS PRIVATE LIMITED",
"DEEP FINANCIAL CONSULTANTS PRIVATE LIMITED",
"DEEP FINCAP PRIVATE LIMITED",
"DEEP FINECHEM PRIVATE LIMITED",
"DEEP FOOD PRODUCTS PRIVATE LIMITED",
"DEEP GIFT CORNER PRIVATE LIMITED",
"DEEP HANDLOOM PRIVATE LIMITED",
"DEEP HOSPITAL",
"DEEP IDENTITY INDIA PRIVATE LIMITED",
"DEEP IMPEX PRIVATE LIMITED",
"DEEP INDIA ENTERPRISES PRIVATE LIMITED",
"DEEP INDUSTRIAL PACK (INDIA) PRIVATE LIMITED",
"DEEP INDUSTRIES",
"DEEP INDUSTRIES LIMITED",
"DEEP INNOVATIVES PRIVATE LIMITED",
"DEEP INVACASTING (GUJARAT) PRIVATE LIMITED",
"DEEP JYOTI DYEING AND PRINTING MILLS PRIVATE LIMITED",
"DEEP JYOTI EXPORTS PRIVATE LIMITED",
"DEEP JYOTI RUBBER PRIVATE LIMITED",
"DEEP JYOTI WAX TRADERS PRIVATE LIMITED",
"DEEP LABORATORIES PRIVATE LIMITED",
"DEEP LEATHER (INDIA) PRIVATE LIMITED",
"DEEP LOGICTECH INDIA PRIVATE LIMITED",
"DEEP MARKETING PRIVATE LIMITED",
"DEEP MASTERBATCH LIMITED",
"DEEP MEDICAL DEVICES PRIVATE LIMITED",
"DEEP MFD PRIVATE LIMITED",
"DEEP MOTORS",
"DEEP NATURAL RESOURCES LIMITED",
"DEEP NURSING HOME & CHILDREN HOSPITAL",
"DEEP ORGANICS PRIVATE LIMITED",
"DEEP PNEUMATICS PRIVATE LIMITED",
"DEEP POLYCHEM PRIVATE LIMITED",
"DEEP POLYMERS LIMITED",
"DEEP PRECISION PRIVATE LIMITED",
"DEEP RED INK CONSULTING PRIVATE LIMITED",
"DEEP RESORTS PVT LTD",
"DEEP SANDS RESORTS PRIVATE LIMITED",
"DEEP SEA DRILLING PRIVATE LIMITED",
"DEEP SEALS INDIALIMITED",
"DEEP SENIOR SECONDARY SCHOOL",
"DEEP SHEET METAL COMPONENTS PRIVATE LIMITED",
"DEEP SHEETAL ENGINEERS PRIVATE LIMITED",
"DEEP SHIKHA FASHIONS PRIVATE LIMITED",
"DEEP SHREE BUILDCON LIMITED",
"DEEP SHREE TOOLS PRIVATE LIMITED",
"DEEP SOLVENTS PRIVATE LIMITED",
"DEEP SPARES PRIVATE LIMITED",
"DEEP VALUE TECHNOLOGY PRIVATE LIMITED",
"DEEP VIDYA AI PRIVATE LIMITED",
"DEEP WHEELS PRIVATE LIMITED",
"DEEP WINES AND AGENCIES PRIVATE LIMITED",
"DEEP WOOD INDUSTRIES PRIVATE LIMITED",
"DEEPA BAGLA FINANCIAL CONSULTANTS PRIVATE LIMITED",
"DEEPA DEVELOPERS",
"DEEPA ENGINEERS PRIVATE LIMITED",
"DEEPA FARM INPUTS PRIVATE LIMITED",
"DEEPA JEWELLERS PRIVATE LIMITED",
"DEEPA MACHINARY MANUFACTURERS PRIVATE LIMITED",
"DEEPA SOLAR POWER GENERATION PRIVATE LIMITED",
"DEEPA SOLAR SYSTEMS PRIVATE. LIMITED.",
"DEEPA STONES AND MINERALS PRIVATE LIMITED",
"DEEPA TEXTILES PRIVATE LIMITED",
"DEEPA TRAVELS (MADRAS) PRIVATE LIMITED",
"DEEPACUMEN CONSUMER TECHNOLOGIES PRIVATE LIMITED",
"DEEPADITYA DEVELOPERS LIMITED",
"DEEPAK & SAHIL ENGCON PRIVATE LIMITED",
"DEEPAK ADVERTISERS PRIVATE LIMITED",
"DEEPAK AGENCIES PRIVATE LIMITED",
"DEEPAK AGRO PRIVATE LIMITED",
"DEEPAK ALUMINIUM AND FURNITURE",
"DEEPAK AND COMPANY INFRA PRIVATE LIMITED",
"DEEPAK ASHISH TRADING COMPANY PRIVATE LIMITED",
"DEEPAK AUTOMOTIVES PRIVATE LIMITED",
"DEEPAK BEARINGS PRIVATE LIMITED",
"DEEPAK BIOSEEDS PRIVATE LIMITED",
"DEEPAK BOXWALA TRADING PRIVATE LIMITED",
"DEEPAK BUILDERS",
"DEEPAK BUILDERS & ENGINEERS INDIA LIMITED",
"DEEPAK BUILDERS PRIVATE LIMITED",
"DEEPAK CARE LIMITED",
"DEEPAK CELLULOSE PRIVATE LIMITED",
"DEEPAK CERAMIC & ALLIED PRODUCTS PRIVATE LIMITED",
"DEEPAK CHAINS PRIVATE LIMITED",
"DEEPAK CHEM TECH LIMITED",
"DEEPAK CHEMTEX LIMITED",
"DEEPAK CHEMTEX PRIVATE LIMITED",
"DEEPAK COLONISERS PVT LTD",
"DEEPAK COLOURANTS PRIVATE LIMITED",
"DEEPAK CONSTRUCTION",
"DEEPAK COSMO LTD",
"DEEPAK CYBIT PRIVATE LIMITED",
"DEEPAK DEVELOPERS PRIVATE LIMITED",
"DEEPAK DIAMONDS PRIVATE LIMITED",
"DEEPAK DRIVES PRIVATE LIMITED",
"DEEPAK DYECHEM PRIVATE LIMITED",
"DEEPAK ENGICON PRIVATE LIMITED",
"DEEPAK ENGINEERING AND TRADING PRIVATE LIMITED",
"DEEPAK ENGINEERING PRIVATE LIMITED",
"DEEPAK FASHIONS PRIVATE LIMITED",
"DEEPAK FASTENERS LIMITED",
"DEEPAK FERRO ALLOYS LIMITED",
"DEEPAK FERTILISERS AND PETROCHEMICALS CORPORATION LIMITED",
"DEEPAK FOUNDATION",
"DEEPAK FRUIT SUPPLIERS",
"DEEPAK GALVANISING ENGINEERING INDUSTRIES PRIVATE LIMITED",
"DEEPAK GARMENTS PRIVATE LIMITED",
"DEEPAK GASES PRIVATE LIMITED",
"DEEPAK HARDWARE INDUSTRIES PRIVATE LIMITED",
"DEEPAK HEALTH AND WELLNESS LIMITED",
"DEEPAK HEART INSTITUTE",
"DEEPAK HINGES PRIVATE LIMITED",
"DEEPAK HITECH MOTORS PRIVATE LIMITED",
"DEEPAK HOSPITALITY PRIVATE LIMITED",
"DEEPAK HOUSEWARE & TOYS PRIVATE LIMITED",
"DEEPAK IMPEX PRIVATE LIMITED",
"DEEPAK INDUSTRIES LTD",
"DEEPAK INFRA AND HOMES PRIVATE LIMITED",
"DEEPAK INFRA PROJECTS PRIVATE LIMITED",
"DEEPAK INSULATION SERVICES (I) PRIVATE LIMITED",
"DEEPAK INTERNATIONAL LIMITED",
"DEEPAK KARAN HOSPITALS PRIVATE LIMITED",
"DEEPAK LOGISTIC PRIVATE LIMITED",
"DEEPAK MANUFACTURING LIMITED",
"DEEPAK MEDICAL FOUNDATIONS",
"DEEPAK NEXGEN FEEDS PRIVATE. LIMITED.",
"DEEPAK NEXGEN INFRASTRUCTURES PRIVATE LIMITED",
"DEEPAK NITRITE LIMITED",
"DEEPAK NOVOCHEM TECHNOLOGIES LIMITED",
"DEEPAK OVERSEAS PRIVATE LIMITED",
"DEEPAK PADMAN IMPEX PRIVATE LIMITED",
"DEEPAK PETRO CHEM LIMITED",
"DEEPAK PHENOLICS LIMITED",
"DEEPAK PLAST PRIVATE LIMITED",
"DEEPAK POLY PIPES PRIVATE LIMITED",
"DEEPAK POLYESTER PRIVATE LIMITED",
"DEEPAK POLY-PLAST PRIVATE LIMITED",
"DEEPAK PRECISION WORKS PRIVATE LIMITED",
"DEEPAK PROTEINS PRIVATE LIMITED",
"DEEPAK RAMMING MASS PRIVATE LIMITED",
"DEEPAK ROOFING PRIVATE LIMITED",
"DEEPAK SCALES PRIVATE LIMITED",
"DEEPAK SEEDS PRIVATE LIMITED",
"DEEPAK SILICATE PRIVATE LIMITED",
"DEEPAK SINGAL ENGINEERS & BUILDERS PRIVATE LIMITED",
"DEEPAK SPINNERS LIMITED",
"DEEPAK STEEL",
"DEEPAK STEEL AND POWER LIMITED",
"DEEPAK SWEETS AND ICECREAM PRIVATE LIMITED",
"DEEPAK TEA PRIVATE LIMITED",
"DEEPAK TRADERS PVT LTD",
"DEEPAK TRANSFORMERS PRIVATE LIMITED",
"DEEPAK USHA HOSPITAL",
"DEEPAK VACUUM TECHNOLOGIES PRIVATE LIMITED",
"DEEPAK VEGPRO PRIVATE LIMITED",
"DEEPAK WHEELS PRIVATE LIMITED",
"DEEPAK WOOLLENS PRIVATE LIMITED",
"DEEPAK YOGIOM ENGINEERS PRIVATE LIMITED",
"DEEPAKNEXGEN FEEDS PRIVATE LIMITED",
"DEEPALI DESIGNS AND EXHIBITS PRIVATE LIMITED",
"DEEPALI GLOBAL PRIVATE LIMITED",
"DEEPALI IMPEX PRIVATE LIMITED",
"DEEPALI INFRATECH PRIVATE LIMITED",
"DEEPALI UNITED MANUFACTURING PRIVATE LIMITED",
"DEEPAM HOSPITAL LIMITED",
"DEEPAM MARKETING ENTERPRISES PRIVATE LIMITED.",
"DEEPAM MOTORS PRIVATE LIMITED",
"DEEPAM PACKAGING & FOOD PRIVATE LIMITED",
"DEEPAM POLY PACKS PRIVATE LIMITED",
"DEEPAM POLYMERS PRIVATE LIMITED",
"DEEPAM SILK RETAIL PRIVATE LIMITED",
"DEEPAN POWER SOLUTIONS (OPC) PRIVATE LIMITED",
"DEEPAN TRADESOLUTIONS PRIVATE LIMITED",
"DEEPANJAN TRADELINKS PRIVATE LIMITED",
"DEEPANK ENTERPRISES",
"DEEPAR PHARMACEUTICALS PRIVATE LIMITED",
"DEEPAVADH HOTELS PRIVATE LIMITED",
"DEEPBLUE LOGISTICS INTERNATIONAL PRIVATELIMITED",
"DEEPCALL INDIA PRIVATE LIMITED",
"DEEPCHAND CHEMICALS PRIVATE LIMITED",
"DEEPCHAND MISHRILAL MARKETING PVT LTD",
"DEEPCHAND RAJESHKUMAR TRADING PRIVATE LIMITED",
"DEEP-CHEM INTERNATIONAL PRIVATE LIMITED",
"DEEPCOMPUTE SOFTWARE INDIA PRIVATE LIMITED",
"DEEPDEAL ELECTRICALS PRIVATE LIMITED",
"DEEPDIVE MEDIA PRIVATE LIMITED",
"DEEPEDGE AI INDIA PRIVATE LIMITED",
"DEEPEE COOLING PRODUCTS PVT. LTD",
"DEEPEEJAY TEXTILES PVT LTD",
"DEEPEEKA EXPORTS PRIVATE LIMITED",
"DEEPESH CHEMICALS PRIVATE LIMITED",
"DEEPFENCE INDIA PRIVATE LIMITED",
"DEEPGANGA TOTAL HEALTH SOLUTIONS PRIVATE LIMITED",
"DEEPIJA TELECOM PRIVATE LIMITED",
"DEEPIKA ENTERPRISES",
"DEEPIKA HOME LINKERS PRIVATE LIMITED",
"DEEPIKA INTERNATIONAL LIMITED",
"DEEPIN PHARMACEUTICALS PRIVATE LIMITED",
"DEEPINTENT INDIA PRIVATE LIMITED",
"DEEPIQ SOFTWARE SOLUTIONS PRIVATE LIMITED",
"DEEPJEE UDYOG PRIVATE LIMITED",
"DEEPJYOT ENGINEERS PRIVATE LIMITED",
"DEEPJYOTI SAREES PRIVATE LIMITED",
"DEEPJYOTI TEXTILES LIMITED",
"DEEPKAMAL AUTOLINK PRIVATE LIMITED",
"DEEPKAMAL EXPORTS PRIVATE LIMITED",
"DEEPKAMAL HEALTH SERVICES PRIVATE LIMITED",
"DEEPKIRAN FOODS PRIVATE LIMITED",
"DEEPLEEN RETAIL PRIVATE LIMITED",
"DEEPLOK FINANCIAL SERVICES LTD",
"DEEPLOK SECURITIES LIMITED",
"DEEPMALA DYEING AND PRINTING MILLS PRIVATE LIMITED",
"DEEPMALA MARINE EXPORTS",
"DEEPMALA PACKAGING AND POLYMERS PRIVATE LIMITED",
"DEEPMINDS BUSINESS SOLUTIONS LLP",
"DEEPMINDZ INNOVATIONS PRIVATE LIMITED",
"DEEPNANDA TECHNOLOGIES PRIVATE LIMITED",
"DEEPODAYA PHARMACEUTICALS PRIVATE LIMITED",
"DEEPRAJ CONSTRUCTION PRIVATE LIMITED",
"DEEPROCK TMS PRIVATE LIMITED",
"DEEPROOT LINUX PRIVATE LIMITED",
"DEEPS TEXSTYLES PRIVATE LIMITED",
"DEEPSEA BLUE GLOBAL LIMITED",
"DEEPSEA TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"DEEPSENSE DIGITAL SOLUTIONS PRIVATE LIMITED",
"DEEPSHA TECHNOCRATS PRIVATE LIMITED",
"DEEPSHIKHA CASTINGS PRIVATE LIMITED",
"DEEPSHIKHA CREATIONS PRIVATE LIMITED",
"DEEPSHIKHA EXIM PRIVATE LIMITED",
"DEEPSHIKHA OVERSEAS PRIVATE LIMITED",
"DEEPSHIKHA PACKAGING SOLUTIONS PRIVATE LIMITED",
"DEEPSHRI MAINTENANCE SERVICE PRIVATE LIMITED",
"DEEPSIGHT AI LABS PRIVATE LIMITED",
"DEEPSONS INDIA PRIVATE LIMITED",
"DEEPSOUNDS HOSPITALITY PRIVATE LIMITED",
"DEEPSOURCE PRIVATE LIMITED",
"DEEPSTAR CABLES (INDIA) PRIVATE LIMITED",
"DEEPSUN CABLE (INDIA) PRIVATE LIMITED",
"DEEPSUN ENERGY PRIVATE LIMITED",
"DEEPSUN INDUSTRIAL CORPORATION",
"DEEPSUN INDUSTRIES",
"DEEPTEC INSTRUMENTS AND INFRASTRUCTURE CONSULTANTS PRIVATE LIMITED",
"DEEPTECH MIND SOLUTIONS PRIVATE LIMITED",
"DEEPTEK MEDICAL IMAGING PRIVATE LIMITED",
"DEEPTHY LABS PRIVATE LIMITED",
"DEEPTI ELECTRONICS AND ELECTRO OPTICS PRIVATE LIMITED",
"DEEPTI FORMULATIONS PRIVATE LIMITED",
"DEEPTI HOUSING PVT LTD",
"DEEPVIJAY TRADING PRIVATE LIMITED",
"DEEPWATER DRILLING & INDUSTRIES PRIVATE LIMITED",
"DEEPWATER PACIFIC 1 INC",
"DEER CREEK INTERSIL INDIA PRIVATE LIMITED",
"DEER SMART INDIA PRIVATE LIMITED",
"DEERAGS ENTERPRISES PRIVATE LIMITED",
"DEERAK SOLUTIONS PRIVATE LIMITED",
"DEERHOMES REALTORS PRIVATE LIMITED",
"DEESAN AGRO-TECH PRIVATE LIMITED",
"DEESAN COTEX PRIVATE LIMITED",
"DEESAN INFRASTRUCTURE PRIVATE LIMITED",
"DEESAN TEX FAB PRIVATE LIMITED",
"DEESH PRINT PACK LIMITED",
"DEESHA ORGANIC PRIVATE LIMITED",
"DEESHA TRADE ENDEAVOURS PVT. LTD.",
"DEESHANT POLSON INDIA PRIVATE LIMITED",
"DEETA CONSTRUCTIONS PRIVATE LIMITED",
"DEETEE INDUSTRIES",
"DEETYA HI-TECH PRIVATE LIMITED",
"DEEVA LOGISTICS PRIVATE LIMITED",
"DEEVEE COMMERCIALS LTD",
"DEEVEE FIRE & SECURITY SOLUTIONS (INDIA) PVT LTD",
"DEEVIA SOFTWARE INDIA PRIVATE LIMITED",
"DEEVIN SEISMIC SYSTEMS PRIVATE LIMITED",
"DEEVITA TECHNOLOGIES INDIA PRIVATE LIMITED",
"DEEVOIR CONSULTING SERVICES PRIVATE LIMITED",
"DEEVYASHAKTI INDIA PRIVATE LIMITED",
"DEEWANI HOSPITAL",
"DEEYA AGROTECH PRIVATE LIMITED",
"DEEYEM CNC MACHINING PRIVATE LIMITED",
"DEEYOG METALS PRIVATE LIMITED",
"DEEZ CREATIONS PRIVATE LIMITED",
"DEEZONE IT SOLUTIONS PRIVATE LIMITED",
"DEEZZ ONLINE SERVICES PRIVATE LIMITED",
"DEF CENTER PRIVATE LIMITED",
"DEF SOLUTIONS PRIVATE LIMITED",
"DEFA LIGHTING SOLUTIONS PRIVATE LIMITED",
"DEFACTO COMPLIANCES PRIVATE LIMITED",
"DEFACTO TECHNOLOGIES PRIVATE LIMITED",
"DEFENCE CAREER ACADEMY",
"DEFENCE CAREER ACADEMY SCHOOL & JUNIOR COLLEGE",
"DEFENCE CIV 128MC",
"DEFENCE CIV OF STN HQ KALKA",
"DEFENCE ELECTRONICS APPLICATION LABORATORY",
"DEFENCE ESTATES OFFICE",
"DEFENCE INSTITUTE OF ADVANCED TECHNOLOGY",
"DEFENCE INSTITUTE OF PHYSIOLOGY AND ALLIED SCIENCES",
"DEFENCE MATERIALS AND STORES R AND D ESTABLISHMENT",
"DEFENCE RESEARCH AND DEVELOPMENT LABORATORY",
"DEFENCE RESEARCH DEVELOPMENT ESTABLISHMENT",
"DEFENCE SERVICES EME DIVISON",
"DEFENCE STANDARDISATION CELL",
"DEFENSE AEROSPACE SUPPORT & SERVICES PRIVATE LIMITED",
"DEFENSE CIVILIAN",
"DEFENSE IN DEPTH SOLUTIONS INDIA PRIVATELIMITED",
"DEFFENCE INSTITUTE OF HIGH ALTITUTE RESEARCH D.R.D.O",
"DEFFREE ENGINEERING PRIVATE LIMITED",
"DEFI HEALTHCARE PRIVATE LIMITED",
"DEFIANCE KNITTING INDUSTRIES PRIVATE LIMITED",
"DEFINE CHITS PRIVATE LIMITED",
"DEFINE LABS PRIVATE LIMITED",
"DEFINE TECHNO SOLUTIONS PRIVATE LIMITED",
"DEFINEDGE SOLUTIONS",
"DEFODILL MOBILES MARKETING PRIVATE LIMITED",
"DEFOX SUPPLIES PRIVATE LIMITED",
"DEFSYS DEVELOPMENT INDIA PRIVATE LIMITED",
"DEFSYS SOLUTIONS PRIVATE LIMITED",
"DEFT ORGANICS LIMITED",
"DEFT ORGANIZERS PRIVATE LIMITED",
"DEFT SEMICONDUCTORS PRIVATE LIMITED",
"DEFT360 IT SOLUTIONS PRIVATE LIMITED",
"DEFTEAM SOLUTIONS PRIVATE LIMITED",
"DEFTECH & GREENINDIA PRIVATE LIMITED",
"DEFY MOTORS PRIVATE LIMITED",
"DEFY NORMS PRIVATE LIMITED",
"DEGALA CONSULTING PRIVATE LIMITED",
"DEGANIA MEDICAL DEVICES PRIVATE LIMITED",
"DEGATECH ENGINEERING SOLUTIONS INDIA PRIVATE LIMITED",
"DEGISA OCEAN AIR SERVICE PRIVATE LIMITED",
"DEGON AGRO PRIVATE LIMITED",
"DEGREE 212 INVESTMENT SERVICES & IMF PRIVATE LIMITED",
"DEGREE 360 SOLUTIONS PRIVATE LIMITED",
"DEGREE COLLEGE OF PHYSICAL EDUCATION",
"DEGREE DAY PRIVATE LIMITED",
"DEGREED APAC PRIVATE LIMITED",
"DEGUSTIBUS HOSPITALITY PRIVATE LIMITED",
"DEHA ASSAM TEA CO PVT LTD",
"DEHAH INDUSTRIES PRIVATE LIMITED",
"DEHLVI AMBAR HERBALS PRIVATE LIMITED",
"DEHMI ENTERPRISES PRIVATE LIMITED",
"DEHN INDIA PRIVATE LIMITED",
"DEHRA DUN CLUB",
"DEHRA METAL TECH PRIVATE LIMITED",
"DEHRADUN AUTOMOBILES PRIVATE LIMITED",
"DEHRADUN CLUB LIMITED",
"DEHRADUN E NET SOLUTIONS PRIVATE LIMITED",
"DEHRADUN PREMIER MOTORS PVT LTD",
"DEHRADUN PUBLIC SCHOOL",
"DEHRADUN RETAILS PRIVATE LIMITED",
"DEHRADUN WASTE MANAGEMENT PRIVATE LIMITED",
"DEHRADUN WORLD SCHOOL",
"DEHU ENGINEERING (INDIA) PRIVATE LIMITED",
"DEHU INDUSTRIES PRIVATE LIMITED",
"DEI GRATIA IMPEX PRIVATE LIMITED",
"DEI GRATIA LOGISTICS PRIVATE LIMITED",
"DEIEM INDIA PRIVATE. LIMITED",
"DEIF INDIA PRIVATE LIMITED",
"DEIFY INFRASTRUCTURES LIMITED",
"DEIFY INFRASTRUCTURES PRIVATE LIMITED",
"DEIFY PHARMA PRIVATE LIMITED",
"DEIN DESTINO TECHNOLOGIES LLP",
"DEINDE ENGINEERING SERVICES PRIVATE LIMITED",
"DEINON RISK SERVICES PRIVATE LIMITED",
"DEION SYSTEMS AND SERVICES PRIVATE LIMITED",
"DEITY LIFE SCIENCES (I) PRIVATE LIMITED",
"DEITY LIFESTYLE PRIVATE LIMITED",
"DEIVASIGAMANI MIDDLE SCHOOL",
"DEJAVU HOLIDAYS PRIVATE LIMITED",
"DEKA BIOLOGICS PRIVATE LIMITED",
"DEKAR ENGINEERS PRIVATE LIMITED",
"DEKARS FIRE AND SECURITY SYSTEMS PRIVATE LIMITED",
"DEKAY FURNISHING PRIVATE LIMITED",
"DEKHO NETWORK PRIVATE LIMITED",
"DEKI ELECTRONICS LIMITED",
"DEKO EXHIBIT SOLUTIONS LLP",
"DEKONIX INDIA PRIVATE LIMITED",
"DEKOR EXCLUSIVE GRANITES PRIVATE LIMITED",
"DEKORATE SOLUTIONS PRIVATE LIMITED",
"DE'KRIMINATORS PRIVATE LIMITED",
"DEKSHA DESIGN STUDIO PRIVATE LIMITED",
"DEKSON CASTINGS LIMITED",
"DEKSON POWER PRIVATE LIMITED",
"DEKSTER LIFE SCIENCES PRIVATE LIMITED",
"DEKTRON INDIA PRIVATE LIMITED",
"DEKTRON TELECOM PRIVATE LIMITED",
"DEKULTURE WORKS PRIVATE LIMITED",
"DEL CAP MANAGED SERVICES INDIA PRIVATE LIMITED",
"DEL CAPITAL PRIVATE LIMITED",
"DEL CORONA & SCARDIGLI INDIA PRIVATE LIMITED",
"DEL DSL INTERNET PRIVATE LIMITED",
"DEL GEARS LIMITED",
"DEL MONTE FOODS PRIVATE LIMITED",
"DEL PROCESS PUMPS PRIVATE LIMITED",
"DEL TRADE INTERNATIONAL PRIVATE LIMITED",
"DELA GRAIN FOODS PRIVATE LIMITED",
"DELA SOFT PRIVATE LIMITED",
"DELAIR INDIA PRIVATE LIMITED",
"DELAN BUSINESSES PRIVATE LIMITED",
"DELAPLEX LIMITED",
"DELAPLEX PRIVATE LIMITED",
"DELASHI CARE PRIVATE LIMITED",
"DELAVAL LIMITED",
"DELBRIDGE SOLUTIONS",
"DELBRUK LIFESCIENCE PRIVATE LIMITED",
"DELBUS MOBILITY PRIVATE LIMITED",
"DELCO ALUMINIUM PRIVATE LIMITED",
"DELCO CONSTRUCTION PRIVATE LIMITED",
"DELCO ELECTRONICS LIMITED",
"DELCO EXPRESS PRIVATE LIMITED",
"DELCO FANS PVT LTD",
"DELCO SHOES PRIVATE LIMITED",
"DELCO SWITCH GEARS PRIVATE LIMITED",
"DELCO TECHNOSOFT PRIVATE LIMITED",
"DELCOM TELESYSTEMS PRIVATE LIMITED",
"DELCON CAPACITORS PRIVATE LIMITED",
"DELCON ELECTRICALS PRIVATE LIMITED",
"DELCON HOMES PRIVATE LIMITED",
"DELCON JSB PRIVATE LIMITED",
"DELCURE LIFESCIENCES LIMITED",
"DELECTABLE TECHNOLOGIES PRIVATE LIMITED",
"DELECTRIK SYSTEMS PRIVATE LIMITED",
"DELEEUW INTERNATIONAL",
"DELEGANCE GROUP PRIVATE LIMITED",
"DELEGATE PROFESSIONALS PRIVATE LIMITED",
"DELENTE TECHNOLOGIES PRIVATE LIMITED",
"DELEX TECHNOLOGIES PRIVATE LIMITED",
"DELEXCEL PHARMA PRIVATE LIMITED",
"DELF CONSULTING ENGINEERS (INDIA) PRIVATE LIMITED",
"DELFI SYSTEMS AND SOLUTION PRIVATE LIMITED",
"DELFIN AUTOMATION SYSTEMS PRIVATE LIMITED",
"DELFIN FINANCE PRIVATE LIMITED",
"DELFINGEN INDIA PRIVATE LIMITED",
"DELFINITY LOGISTICS SOLUTIONS PRIVATE LIMITED",
"DELFOI TANOTI TECHNOLOGIES PRIVATE LIMITED",
"DELHI & DISTT CRICKET ASSOCIATION",
"DELHI ACADEMY OF MEDICAL SCIENCES PRIVATE LIMITED",
"DELHI AGROCOOL PRIVATE LIMITED",
"DELHI AIRPORT PARKING SERVICES PRIVATE LIMITED",
"DELHI AIRPORT SERVICE PRIVATE LIMITED",
"DELHI APARTMENTS PRIVATE LIMITED",
"DELHI AREA PROVOST UNIT",
"DELHI AREA SIGNAL COMPANY",
"DELHI AVIATION FUEL FACILITY PRIVATE LIMITED",
"DELHI AVIATION SERVICES PRIVATE LIMITED",
"DELHI BHIWANI TRANSPORT CO PVT LTD",
"DELHI BOOK COMPANY PRIVATE LIMITED",
"DELHI BRASS AND METAL WORKS PRIVATE LIMITED",
"DELHI BRASS LIGHTING PRIVATE LIMITED",
"DELHI BUILDWELL PRIVATE LIMITED",
"DELHI CABZ & SERVICES PRIVATE LIMITED",
"DELHI CAFE & BAR PRIVATE LIMITED",
"DELHI CARGO SERVICE CENTER PRIVATE LIMITED",
"DELHI CHAIN COMPANY PVT LTD",
"DELHI CHARTERING & SHIPPING SERVICES PRIVATE LIMITED",
"DELHI COLD STORAGE PRIVATE LIMITED",
"DELHI CONSUMERS CO-OPERATIVE WHOLESALE STORE LIMITED",
"DELHI CREATIVE ARTS DEVELOPMENT LIMITED",
"DELHI CRYOGENIC PRODUCTS PRIVATE LIMITED",
"DELHI DEVELOPMENT AUTHORITY",
"DELHI DISTRICT COURTS",
"DELHI DUTY FREE SERVICES PRIVATE LIMITED",
"DELHI ELECTRICITY REGULATORY COMMISISON",
"DELHI ESSENCE CHEM PRIVATE LIMITED",
"DELHI EXTRUSION PRIVATE LIMITED",
"DELHI EYEZONE PRIVATE LIMITED",
"DELHI FINVEST SOLUTION LLP",
"DELHI FIRE SERVICE",
"DELHI FOUNDRY PRIVATE LIMITED",
"DELHI FURNITURE COMPANY PRIVATE LIMITED",
"DELHI GARMENTS PRIVATE LIMITED",
"DELHI GUJARAT FLEET CARRIERS PRIVATE LIMITED",
"DELHI GYMKHANA CLUB LIMITED",
"DELHI HAAT CRAFT COTTAGE INDUSTRIES",
"DELHI HEART INSTITUTE & MULTISPECIALITY HOSPITAL",
"DELHI HIGH COURT",
"DELHI HOSPITAL SUPPLY PRIVATE LIMITED",
"DELHI HOWRAH ROADLINES PRIVATE LIMITED",
"DELHI INSTITUTE OF ENGINEERING & TECHNOLOGY",
"DELHI INSTITUTE OF HERITAGE RESEARCH & MANAGEMENT",
"DELHI INTEGRATED MULTI MODAL TRANSIT SYSTEM LIMITED",
"DELHI INTERNATIONAL AIRPORT LIMITED",
"DELHI INTERNATIONAL AIRPORT PRIVATE LIMITED",
"DELHI INTERNATIONAL CARGO TERMINAL PRIVATE LIMITED",
"DELHI INTERNATIONAL SCHOOL",
"DELHI IRON AND STEEL COMPANY PRIVATE LIMITED",
"DELHI IVF & FERTILITY CLINIC",
"DELHI JAL BOARD",
"DELHI KANNADA EDUCATION SOCIETY",
"DELHI MEDICAL ASSOCIATION",
"DELHI METRO LAST MILE SERVICES LIMITED",
"DELHI METRO RAIL CORPORATION LIMITED",
"DELHI METROPOLITAN EDUCATION",
"DELHI MILK SCHEME",
"DELHI MSW SOLUTIONS LIMITED",
"DELHI PAPER PRODUCTS COMPANY PRIVATE LIMITED",
"DELHI PASAND AGRO PRIVATE LIMITED",
"DELHI PLASTCHEM PRIVATE LIMITED",
"DELHI PLYWOODS PRIVATE LIMITED",
"DELHI PNEOMATIC VALVE MFG CO PVT LTD",
"DELHI POLICE PUBLIC SCHOOL",
"DELHI POLLUTION CONTROL COMMITTEE",
"DELHI POLYMERS AND CHEMICALS PRIVATE LIMITED",
"DELHI PRESS PATRA PRAKASHAN PRIVATE LIMITED",
"DELHI PRESS SAMACHAR PATRA PRIVATE LIMITED",
"DELHI PRINTING AND PUBLISHING COMPANY PRIVATE LIMITED",
"DELHI PUBLIC SCHOOL",
"DELHI PUBLIC SCHOOL JALANDHAR",
"DELHI PUBLIC SCHOOL KALYANPUR",
"DELHI PUBLIC SCHOOL MEGACITY KOLKATA",
"DELHI PUBLIC SCHOOL TAPI",
"DELHI PUNJAB GOODS CARRIER PRIVATE LIMITED",
"DELHI RACE CLUB 1940 LIMITED",
"DELHI RAJASTHAN TRANSPORT COMAPANY LIMITD",
"DELHI REDIMIX CONCRETE PRIVATE LIMITED",
"DELHI SC/ST MINORITY FINA DEVP CORP",
"DELHI SCHOOL OF BUSINESS",
"DELHI SCHOOL OF EXCELLENCE",
"DELHI SCHOOL OF PROFESSIONAL STUDIES AND RESEARCH",
"DELHI SKILL AND ENTREPRENEURSHIP UNIVERSITY",
"DELHI ST INDUSTRIAL INFRAST DEV LIMITED",
"DELHI STATE CANCER INSTITUTE",
"DELHI STATE CIVIL SUPPLIES CORPORATION LIMITED",
"DELHI STATE INDUSTRIAL AND INFRASTRUTURE DEVELOPMENT CORPORATION LTD",
"DELHI STATE LEGAL SERVICES AUTHORITY",
"DELHI STOCK EXCHANGE LIMITED",
"DELHI SURGICAL AND DRESSINGS PRIVATE LIMITED",
"DELHI TEACHER TRAINING COLLEGE",
"DELHI TELECOM PRIVATE LIMITED",
"DELHI TOURISM & TRANSPORTATION DEVELOPMENT CORPORATION LIMITED",
"DELHI TRADING COMMERCIAL PRIVATE LIMITED",
"DELHI TRANSCO LIMITED",
"DELHI TRANSPORT CORPORATION",
"DELHI TRANSPORT INFRASTRUCTURE DEVELOPMENT CORPORATION LIMITED",
"DELHI UNIVERSITY",
"DELHI UNIVERSITY.",
"DELHI URBAN SHELTER INPROVEMENT BOARD",
"DELHI WASTE MANAGEMENT LIMITED",
"DELHI WASTE MANAGEMENT NAJAFGARH PRIVATE LIMITED",
"DELHI WATCH MARKETING PRIVATE LIMITED",
"DELHI WORLD PUBLIC SCHOOL",
"DELHIVERY FREIGHT SERVICES PRIVATE LIMITED",
"DELHIVERY LIMITED",
"DELHIVERY PRIVATE LIMITED",
"DELICARE LIFESCIENCES PRIVATE LIMITED",
"DELICASY CONTINENTAL PRIVATE LIMITED",
"DELICASY INFRATECH PRIVATE LIMITED",
"DELICATE ENGINEERING PRIVATE LIMITED",
"DELICATE SOLAR PRIVATE LIMITED",
"DELICATESSEN ENGINEERING SERVICES PRIVATE LIMITED",
"DELICIA FOODS",
"DELICIA FOODS INDIA PRIVATE LIMITED",
"DELICIOSO GOURMET FOODS PRIVATE LIMITED",
"DELICIOUS AGRO INDIA PRIVATE LIMITED",
"DELICIOUS FOODS & BEVERAGES PRIVATE LIMITED",
"DELICIOUS SECURITIES PRIVATE LIMITED",
"DELIDEAL SUPERMARTS LIMITED",
"DELIGENCE TECHNOLOGIES PRIVATE LIMITED",
"DELIGENT APPARELS PRIVATE LIMITED",
"DELIGENT GINNING MACHINERY PRIVATE LIMITED",
"DELIGENT HOTEL CORPORATION PRIVATE LIMITED",
"DELIGENT INNOVATORS PRIVATE LIMITED",
"DELIGENTIA ENERGY AND INFRASTRUCTURES PRIVATE LIMITED",
"DELIGHT AGRI FRESH PRIVATE LIMITED",
"DELIGHT AQUA EXPORTS PRIVATE LIMITED",
"DELIGHT BIOPHARMA PRIVATE LIMITED",
"DELIGHT CHEMICALS PVT LTD",
"DELIGHT DAIRY LIMITED",
"DELIGHT ENTERPRISES PRIVATE LIMITED",
"DELIGHT GOURMET PRIVATE LIMITED",
"DELIGHT HOTELS PRIVATE LIMITED",
"DELIGHT INDUSTRIAL SOLUTIONS PRIVATE LIMITED",
"DELIGHT INDUSTRIES PRIVATE LIMITED",
"DELIGHT INSTITUTE OF PHARMACY",
"DELIGHT INTERIORS INDIA PRIVATE LIMITED",
"DELIGHT LAYER PRIVATE LIMITED",
"DELIGHT LIFELIKE PRODUCTS PRIVATE LIMITED",
"DELIGHT LOGISTICS PRIVATE LIMITED",
"DELIGHT SERVICES AND MAINTENANCE PRIVATE LIMITED",
"DELIGHT SOLUTIONS PRIVATE LIMITED",
"DELIGHT SUPPLIERS PRIVATE LIMITED",
"DELIGHT SWITCHGEARS PRIVATE LIMITED",
"DELIGHTFUL FOODS PRIVATE LIMITED",
"DELIGHTFUL HOLIDAYS PRIVATE LIMITED",
"DELIGHTS ELECTRICALS PRIVATE LIMITED",
"DELIGHTSUN HEALTHCARE PRIVATE LIMITED",
"DELIGHTWORX TECHNOLOGIES PRIVATE LIMITED",
"DELIMP TECHNOLOGY PRIVATE LIMITED",
"DELITE APPARELS PRIVATE LIMITED",
"DELITE AUTOMAC PRIVATE LIMITED",
"DELITE BUILDWELL PRIVATE LIMITED",
"DELITE COLLECTIONS PRIVATE LIMITED",
"DELITE ENGINEERS PVT LTD",
"DELITE FOODS PRIVATE LIMITED",
"DELITE HI-TECH FURNITURE INDUSTRIES PRIVATE LIMITED",
"DELITE IMPEX PRIVATE LIMITED",
"DELITE INFRASTRUCTURE PRIVATE LIMITED",
"DELITE REFRIGERATION CO.",
"DELITE SALES PRIVATE LIMITED",
"DELITE SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"DELITE SYSTEMS ENGINEERING INDIA PRIVATE LIMITED",
"DELIUM TECHNOLOGIES PRIVATE LIMITED",
"DELIUS PHARMACEUTICALS PRIVATE LIMITED",
"DELIVERAIN TECHNOLOGIES PRIVATE LIMITED",
"DELIVERHEALTH SOLUTIONS INDIA PRIVATE LIMITED",
"DELIVERY ASSISTANCE",
"DELIVERY BLUEPRINTS INDIA PRIVATE LIMITED",
"DELIVERYONTIME LOGISTICS PRIVATE LIMITED",
"DELIVERYWAALA SERVICES PRIVATE LIMITED",
"DELIX NET SOLUTIONS PRIVATE LIMITED",
"DELIXUS SOFTWARE INDIA PRIVATE LIMITED",
"DELIZIA FOOD PRODUCTS PRIVATE LIMITED",
"DELKART INDUSTRIES PRIVATE LIMITED",
"DELKON TEXTILES PRIVATE LIMITED",
"DELL CERAMIC PRIVATE LIMITED",
"DELL INTERNATIONAL SERVICES INDIA PRIVATE LIMITED",
"DELL SOFTWARE INDIA PRIVATE LIMITED",
"DELLA ADVENTURE & RESORTS PRIVATE LIMITED",
"DELLA ENCLAVE PRIVATE LIMITED",
"DELLA LUXURY PRODUCTS PRIVATE LIMITED",
"DELLA TECNICA INTERIOR DESIGN PRIVATE LIMITED",
"DELLA TECNICA OFFICE SYSTEM PRIVATE LIMITED",
"DELLA VILLAS PRIVATE LIMITED",
"DELLAREX BIOTEC PRIVATE LIMITED",
"DELLATECNICA",
"DELLCUBE INTEGRATED SOLUTIONS PRIVATE LIMITED",
"DELLNER BUBENZER INDIA PRIVATE LIMITED",
"DELLNER INDIA PRIVATE LIMITED",
"DELLNER POLYMER SOLUTIONS INDIA PRIVATE LIMITED",
"DELLORTO INDIA PRIVATE LIMITED",
"DELLWICH HEALTHCARE LLP",
"DELMA MARINERS AND SHIPPING PRIVATE LIMITED",
"DELMAR OFFSHORE SERVICES PRIVATE LIMITED",
"DELMAR TOTAL TRANSPORTATION PRIVATE LIMITED",
"DELMECH ENGINEERING SOLUTIONS PRIVATE LIMITED",
"DELMON ENERGY PRIVATE LIMITED",
"DELMON SOLUTIONS PRIVATE LIMITED",
"DELMORE TRADING PVT LTD",
"DELMOS AVIATION PRIVATE LIMITED",
"DELNOR FOODS PRIVATE LIMITED",
"DELOITTE",
"DELOITTE & TOUCHE ASSURANCE & ENTERPRISE RISK SVCS P L",
"DELOITTE CONSULTING INDIA PRIVATE LIMITED",
"DELOITTE FINANCIAL ADVISORY SERVICES INDIA PRIVATE LIMITED",
"DELOITTE GLOBAL FINANCIAL ADVISORY INDIA PRIVATE LIMITED",
"DELOITTE HASKINS & SELLS LLP",
"DELOITTE INDIA ADVISORY SERVICES PRIVATE LIMITED",
"DELOITTE SHARED SERVICES INDIA LLP",
"DELOITTE SHARED SERVICES INDIA PRIVATE LIMITED",
"DELOITTE SPECIAL PROJECTS INDIA PRIVATE LIMITED",
"DELOITTE SUPPORT SERVICES INDIA PRIVATE LIMITED",
"DELOITTE TAX SERVICES INDIA PRIVATE LIMITED",
"DELOITTE TOUCHE TOHMATSU INDIA LLP",
"DELOITTE TOUCHE TOHMATSU INDIA PRIVATE LIMITED",
"DELOS CONSULTING PRIVATE LIMITED",
"DELOSTYLE STUDIO PRIVATE LIMITED",
"DELPHI COMPUTECH PRIVATE LIMITED",
"DELPHI COMPUTECH SOLUTIONS PRIVATE LIMITED",
"DELPHI INFRASPACE PRIVATE LIMITED",
"DELPHI PROPERTIES PRIVATE LIMITED",
"DELPHI RESEARCH SERVICES PRIVATE LIMITED",
"DELPHI SKILL DEVELOPMENT CORPORATION PRIVATE LIMITED",
"DELPHIANLOGIC TECHNOLOGIES PRIVATE LIMITED",
"DELPHIME CONSULTING PRIVATE LIMITED",
"DELPHIQUE FABRICS PRIVATE LIMITED",
"DELPHIQUE INDIA PRIVATE LIMITED",
"DELPHI-TVS TECHNOLOGIES LIMITED",
"DELPHIX SOFTWARE PRIVATE LIMITED",
"DELPHY AUTOMATION PRIVATE LIMITED",
"DELPORT AVIATION PRIVATE LIMITED",
"DELPRO EQUIPMENTS PRIVATE LIMITED",
"DELRIN PRODUCTS (INDIA) PRIVATE LIMITED",
"DELSEA EXPORTS PRIVATE LIMITED",
"DELSEY INDIA PRIVATE LIMITED",
"DELST TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"DELSTAR ESTATES PRIVATE LIMITED",
"DELSTONE CONCRETE PRIVATE LIMITED",
"DELSURE LOGISTICS PRIVATE LIMITED",
"DELSYS AUTOMATION TECHNOLOGIES PRIVATE LIMITED",
"DELSYS INFOTECH PRIVATE LIMITED",
"DELTA AGRIGENETICS PRIVATE LIMITED",
"DELTA AGRO COMMODITES PRIVATE LIMITED",
"DELTA AIR FREIGHT PRIVATE LIMITED",
"DELTA AIR LINES",
"DELTA AIR LINES INC.",
"DELTA AIRCON PRIVATE LIMITED",
"DELTA AIRCON SERVICES PRIVATE LIMITED",
"DELTA AUTOMATION PRIVATE LIMITED",
"DELTA BIOPHARMA PRIVATE LIMITED",
"DELTA BIOSCIENCE PRIVATE LIMITED",
"DELTA CONSTRUCTION SYSTEMS LIMITED",
"DELTA CORP LIMITED",
"DELTA DETAILING OF INDIA LLP",
"DELTA DIAGNOSTIC SERVICES & RESEARCH CENTER PRIVATE LIMITED",
"DELTA ELECTRO MECHANICAL PRIVATE LIMITED",
"DELTA ELECTRO SYSTEMS PRIVATE LIMITED",
"DELTA ELECTRONICS INDIA PRIVATE LIMITED",
"DELTA ELECTRONICS PRIVATE LIMITED",
"DELTA ELMECH SYSTEMS",
"DELTA EMBEDDED SOLUTIONS PRIVATE LIMITED",
"DELTA ENCLAVES PRIVATE LIMITED",
"DELTA ENERGY SYSTEMS INDIA PRIVATE LIMITED",
"DELTA ENGICON PRIVATE LIMITED",
"DELTA ERECTORS PRIVATE LIMITED",
"DELTA FAUCET COMPANY INDIA PRIVATE LIMITED",
"DELTA FILTERS AND SEPARATORS PRIVATE LIMITED",
"DELTA FINOCHEM PRIVATE LIMITED",
"DELTA FLOW TECH ENGINEERS PRIVATE LIMITED",
"DELTA FOODS PRIVATE LIMITED",
"DELTA FROZEN FOODS PRIVATE LIMITED",
"DELTA GALAXY ENGINEERING SERVICES PRIVATE LIMITED",
"DELTA GLOBAL PRIVATE LIMITED",
"DELTA GLOBAL RESOURCES PRIVATE LIMITED",
"DELTA GUARDS PRIVATE LIMITED",
"DELTA HEART CENTRE PRIVATE LIMITED",
"DELTA HITECH COATINGS PRIVATE LIMITED",
"DELTA INFOCOM SOLUTIONS",
"DELTA INFOSOFT PRIVATE LIMITED",
"DELTA INFOSOLUTIONS PRIVATE LIMITED",
"DELTA INFRALOGISTICS WORLDWIDE LIMITED",
"DELTA INFRAVENTURES PRIVATE LIMITED",
"DELTA INTERIORS PRIVATE LIMITED",
"DELTA INVESTMENTS LIMITED",
"DELTA IOT SOLUTIONS PRIVATE LIMITED",
"DELTA IT NETWORK PRIVATE LIMITED",
"DELTA JEWELLERS PRIVATE LIMITED",
"DELTA LENS PRIVATE LIMITED",
"DELTA LIGHT INDIA PRIVATE LIMITED",
"DELTA LTD",
"DELTA MANUFACTURING LIMITED",
"DELTA MARITIME & INDUSTRIAL SKILL TRAINING INSTITUTE PRIVATE LIMITED",
"DELTA MEDIA PRIVATE LIMITED",
"DELTA MEP (INDIA) PRIVATE LIMITED",
"DELTA MOBILITY PRIVATE LIMITED",
"DELTA NETWORKS PRIVATE LIMITED",
"DELTA NUTRITIVES PRIVATE LIMITED",
"DELTA OPTICS",
"DELTA PAPER MILLS LTD",
"DELTA PD PUMPS PRIVATE LIMITED",
"DELTA PLEASURE CRUISE COMPANY PRIVATE LIMITED",
"DELTA PLUS INDIA PRIVATE LIMITED",
"DELTA PLUS LUBRICANTS AND CHEMICALS PRIVATE LIMITED",
"DELTA POWER SOLUTIONS INDIA PRIVATE LIMITED",
"DELTA PROCESS CONTROL INSTRUMENTS PRIVATE LIMITED",
"DELTA PROTECH PRIVATE LIMITED",
"DELTA PURE WATER INDIA LIMITED",
"DELTA RECRUITMENT CONSULTANTS PRIVATE LIMITED",
"DELTA ROTO TECH PRIVATE LIMITED",
"DELTA SALES & SERVICES PRIVATE LIMITED",
"DELTA SARAS PIPING PRIVATE LIMITED",
"DELTA SCIENCE SCHOOL UPLETA",
"DELTA SCIENTIFIC EQUIPMENT PVT LTD",
"DELTA SECURICORP PRIVATE LIMITED",
"DELTA SHOES PRIVATE LIMITED",
"DELTA SMART TECHNOLOGIES PRIVATE LIMITED",
"DELTA SOFTWARE PRIVATE LIMITED",
"DELTA SOUVENIRS PRIVATE LIMITED",
"DELTA STAR POWER PROJECTS SERVICES PRIVATE LIMITED",
"DELTA STEEL STRUCTURES PRIVATE LIMITED",
"DELTA STORAGE SYSTEMS PRIVATE LIMITED",
"DELTA SUGARS LIMITED",
"DELTA SYS-TECH (INDIA) PVT LTD",
"DELTA TECHINVEST PRIVATE LIMITED",
"DELTA TECHNOCARE (INDIA) PRIVATE LIMITED",
"DELTA TEKNOTIDE PRIVATE LIMITED",
"DELTA TILES LIMITED",
"DELTA TOTAL FACILITIES PRIVATE LIMITED",
"DELTA TRANS CONDUCTORS PRIVATE LIMITED",
"DELTA TRANSFORMERS PRIVATE LIMITED",
"DELTA TRAVEL SOLUTIONS PRIVATE LIMITED",
"DELTA TROOPS PRIVATE LIMITED",
"DELTA VEHICLE SUPPORT PRIVATE LIMITED",
"DELTA WATERWAYS PRIVATE LIMITED",
"DELTA WEARTECH ENGINEERS PRIVATE LIMITED",
"DELTABULK SHIPPING INDIA PRIVATE LIMITED",
"DELTACHEM TRADING PRIVATE LIMITED",
"DELTACONS PROJECTS IND PRIVATE LIMITED",
"DELTACUBES PRIVATE LIMITED",
"DELTAF TECHCOMM INDIA PRIVATE LIMITED",
"DELTAFORCE FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"DELTAKEY ELECTRONICS PRIVATE LIMITED",
"DELTAKRAFT SOLUTIONS PRIVATE LIMITED",
"DELTAMED REMEDIES LLP",
"DELTAMIKE SPECIALITY PRODUCTS PRIVATE LIMITED",
"DELTAPURE TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"DELTASAFETY SOLUTIONS PRIVATE LIMITED",
"DELTASPHARMA INDIA PRIVATE LIMITED",
"DELTATECH GAMING LIMITED",
"DELTATECHS CONSTRUCTION PRIVATE LIMITED",
"DELTAVO PRIVATE LIMITED",
"DEL-TECH INSTRUMENTS PRIVATE LIMITED",
"DELTECH PRIAM CHEMICALS INDIA PRIVATE LIMITED",
"DELTECS INFOTECH PRIVATE LIMITED",
"DELTIS PHARMA PRIVATE LIMITED",
"DELTON CABLES",
"DELTON CERAMIC PRIVATE LIMITED",
"DELTOP INFRATECH PRIVATE LIMITED",
"DELTOS INFRA PRIVATE LIMITED",
"DELTRA GLOBAL PROFILES PRIVATE LIMITED",
"DELTRAN DIESELS ENGINEERING PRIVATE LIMITED",
"DELTRON EQUIPMENT & SYSTEMS PVT. LTD.",
"DELURIS BUILDTECH INDIA PRIVATE LIMITED",
"DELUX BEARINGS PRIVATE LIMITED",
"DELUX FEED PRODUCTS PRIVATE LIMITED",
"DELUXE AGRICULTURAL IMPLEMENTS PVT LTD",
"DELUXE BIKES AND ACCESSORIES PRIVATE LIMITED",
"DELUXE CARGO MOVERS (INDORE) PRIVATE LIMITED",
"DELUXE CATERERS PRIVATE LIMITED",
"DELUXE CLEANING SYSTEMS PRIVATE LIMITED",
"DELUXE ENTERTAINMENT DISTRIBUTION INDIA PRIVATE LIMITED",
"DELUXE ENTERTAINMENT SERVICES INDIA PRIVATE LIMITED",
"DELUXE FABRICS (I) LIMITED",
"DELUXE HEALTHCARE PRIVATE LIMITED",
"DELUXE LABORATORIES PRIVATE LIMITED",
"DELUXE LEASING PRIVATE LIMITED",
"DELUXE LOGISTICS PRIVATE LIMITED",
"DELUXE METAL PROCESSING CHEMICALS PVT LTD",
"DELUXE PETROCHEM PRIVATE LIMITED",
"DELUXE RECYCLING (INDIA) PRIVATE LIMITED",
"DELUXE SCIENTIFIC SURGICO PRIVATE LIMITED",
"DELUXE SHIPPING AGENCY PRIVATE LIMITED",
"DELUXEAGRICULTURE INDUSTRIES PRIVATE LIMITED",
"DELVAL FLOW CONTROLS PRIVATE LIMITED",
"DELVE LOGISTICS SOLUTIONS PRIVATE LIMITED",
"DELVE SERWIZ PRIVATE LIMITED",
"DELVEGSCO SALES PRIVATE LIMITED",
"DELVEINSIGHT BUSINESS RESEARCH LLP",
"DELVERSH MINERALS PRIVATE LIMITED",
"DELVIN FORMULATIONS PRIVATE LIMITED",
"DELVIN KLARVOYANT BIOGENICS PRIVATE LIMITED",
"DELVIN PLASTICS PRIVATE LIMITED",
"DELVIT SOLUTIONS PRIVATE LIMITED",
"DELVORTH BEVERAGES PRIVATE LIMITED",
"DELWARA STEEL INDUSTRIES PRIVATE LIMITED",
"DELWIS HEALTHCARE PRIVATE LIMITED",
"DELYAM BAKES N BITE PRIVATE LIMITED",
"DELYVER RETAIL NETWORK PRIVATE LIMITED",
"DEMAC ROOFING PRIVATE LIMITED",
"DEMAC TECHNOLOGIES PVT LTD",
"DEMAG STEEL CASTINGSLTD",
"DEMAND JUNKIES PRIVATE LIMITED",
"DEMAND MEDIA BPM LLP",
"DEMANDBASE INDIA PRIVATE LIMITED",
"DEMANDNXT BUSINESS SERVICES PRIVATE LIMITED",
"DEMANDPROPS COMMUNICATIONS PRIVATE LIMITED",
"DEMANDSHORE SOLUTIONS PRIVATE LIMITED",
"DEMANDWHIZ MARKETING SOLUTIONS PRIVATE LIMITED",
"DEMARC STRAS STRUCTURAL SYSTEMS PRIVATE LIMITED",
"DEMARTE FASHION YARNS",
"DEMBLA TIMBER COMPANY PRIVATE LIMITED",
"DEMBLA VALVES LIMITED",
"DEMCO CONTAINER LINE PRIVATE LIMITED",
"DEMECH CHEMICAL PRODUCTS PRIVATE LIMITED",
"DEMECH POWER & ENGINEERING SERVICES PRIVATE LIMITED",
"DEMEG STUDIOS PRIVATE LIMITED",
"DEMELLO TELEPOWER PRIVATE LIMITED",
"DEMETER SYSTEMS PRIVATE LIMITED",
"DEMEX LOG PRIVATE LIMITED",
"DEMIGOD AGRO FOOD PRIVATE LIMITED",
"DEMIRA FREIGHT LINKERS INDIA PRIVATE LIMITED",
"DEMIURGIC INFRA DEVELOPERS & SUPPLIERS PRIVATE LIMITED",
"DEMLA RETAIL PRIVATE LIMITED",
"DEMM AUTO PRIVATE LIMITED",
"DEMO CASTERS",
"DEMOCRATIC STUDY CENTER",
"DEMOJA ASSOCIATES PVT LTD",
"DEMOLTECH ENGINEERS PRIVATE LIMITED",
"DEMONSTRATIVE SOLAR INDIA PRIVATE LIMITED",
"DEMORGIA CONSULTING SERVICES PRIVATE LIMITED",
"DEMOS INFOTECH PRIVATE LIMITED",
"DEMOS PROJECT PRIVATE LIMITED",
"DEMOSHA CHEMICALS PRIVATE LIMITED",
"DEMOSTHENES TECHNOLOGIES PRIVATE LIMITED",
"DEMPO SHIPBUILDING AND ENGINEERING PRIVATE LIMITED",
"DEMURE INTERIORS PRIVATE LIMITED",
"DEMURIC HOLDINGS PVT LTD(TR CO FROM MAHARASHTRA)",
"DEMYTO AUTOTECH SOLUTIONS PRIVATE LIMITED",
"DEN ABC CABLE NETWORK AMBARNATH PRIVATE LIMITED",
"DEN ADN NETWORK PRIVATE LIMITED",
"DEN AMBEY CABLE NETWORKS PRIVATE LIMITED",
"DEN BROADBAND LIMITED",
"DEN DIGITAL CABLE NETWORK PRIVATE LIMITED",
"DEN DISCOVERY DIGITAL NETWORKS PRIVATE LIMITED",
"DEN ENJOY CABLE NETWORKS PRIVATE LIMITED",
"DEN ENJOY NAVARATAN NETWORK PRIVATE LIMITED",
"DEN F K CABLE TV NETWORK PRIVATE LIMITED",
"DEN NETWORKS LIMITED",
"DEN NEW BROAD COMMUNICATION PRIVATE LIMITED",
"DEN PREMIUM MULTILINK CABLE NETWORK PRIVATE LIMITED",
"DEN RAJKOT CITY COMMUNICATION PRIVATE LIMITED",
"DEN SATELLITE NETWORK PRIVATE LIMITED",
"DEN SAYA CHANNEL NETWORK LIMITED",
"DEN SOCCER PRIVATE LIMITED",
"DENA BANK",
"DENA GUJARAT GRAMIN BANK",
"DENALI AI INDIA PRIVATE LIMITED",
"DENALI CONNECT PRIVATE LIMITED",
"DENALI FINANCE PRIVATE LIMITED",
"DENALI FOODS PRIVATE LIMITED",
"DENALI SOURCING & SOFTWARE SERVICES INDIA PRIVATE LIMITED",
"DENAVE INDIA PRIVATE LIMITED",
"DENCIL FLUIDTEK SYSTEMS PRIVATE LIMITED",
"DENCIL PUMPS AND SYSTEMS PRIVATE LIMITED",
"DENCOL (INDIA) PVT LTD",
"DENEB AIR GASES PRIVATE LIMITED",
"DENEB AND POLLUX HOTELS PRIVATE LIMITED",
"DENEB AND POLLUX TOURS AND TRAVELS PRIVATE LIMITED",
"DENFAB CONSULTING ENGINEERS PRIVATE LIMITED",
"DENFAB ENGINEERS PRIVATE LIMITED",
"DENGENSHA INDIA PRIVATE LIMITED",
"DENIM COLOURCHEM PRIVATE LIMITED",
"DENIM DEVELOPERS LIMITED",
"DENIMATIC (INDIA) PRIVATE LIMITED",
"DENIMAX JEANS INDIA PRIVATE LIMITED",
"DENIMHUB LIFESTYLE PRIVATE LIMITED",
"DENIMO DESIGN WASHING PRIVATE LIMITED",
"DENIMOZ INTERNATIONAL PRIVATE LIMITED",
"DENIS CHEM LAB LIMITED",
"DENIS LEASING AND INFOTECH PRIVATE LIMITED",
"DENIS PLAST LIMITED",
"DENISCO CHEMICALS PRIVATE LIMITED",
"DENIZEN PHARMACEUTICALS INDIA PRIVATE LIMITED",
"DENKEN SOLUTIONS INDIA PRIVATE LIMITED",
"DENKI ENGINEERING CO. PRIVATE LIMITED",
"DENKINO SOLUTIONS PRIVATE LIMITED",
"DEN-MANORANJAN SATELLITE PRIVATE LIMITED",
"DENNEMEYER INDIA PRIVATE LIMITED",
"DENODO TECHNOLOGIES INDIA PRIVATE LIMITED",
"DENOLEX POLYMERS PRIVATE LIMITED",
"DENON INDIA LIMITED",
"DENOTICS INTERNATIONAL PRIVATE LIMITED",
"DENOVO BIOLABS PRIVATE LIMITED",
"DENOVO HITECH SOLUTIONS PRIVATE LIMITED",
"DENOVO SYSTEMS INDIA PRIVATE LIMITED",
"DENPRO TECHNOLOGIES PRIVATE LIMITED",
"DENRO FABRICS PRIVATE LIMITED",
"DENSAT FM SERVICES PRIVATE LIMITED",
"DENSIS TELECOM PRIVATE LIMITED",
"DENSITY REALTY PRIVATE LIMITED",
"DENSITY TRANSFORMERS PRIVATE LIMITED",
"DENSO HARYANA PRIVATE LIMITED",
"DENSO INDIA PRIVATE LIMITED",
"DENSO INTERNATIONAL INDIA PRIVATE LIMITED",
"DENSO KIRLOSKAR INDUSTRIES PRIVATE LIMITED",
"DENSO SUBROS THERMAL ENGINEERING CENTRE INDIA LIMITED",
"DENSO SUBROS THERMAL ENGINEERING CENTRE INDIA PRIVATE LIMITED",
"DENSO THERMAL SYSTEMS PUNE PRIVATE LIMITED",
"DENSOFT INFOTECH PRIVATE LIMITEDCAT",
"DENSOL ENGINEERING PRIVATE LIMITED",
"DENSOL TECHNOLOGIES PRIVATE LIMITED",
"DENTAL AVENUE INDIA PRIVATE LIMITED",
"DENTAL CERAMISTS INDIA PRIVATE LIMITED",
"DENTAL CERAMISTS ZUBLER PRIVATE LIMITED",
"DENTAL COLLEGE",
"DENTAL COLLEGE RESEARCH CENTRE",
"DENTAL COUNCIL OF INDIA",
"DENTAL WORLD SUPER SPECIALITY CLINICS PRIVATE LIMITED",
"DENTALIGN SOLUTIONS (INDIA) PRIVATE LIMITED",
"DENTAMITRA HEALTHCARE TECHNOLOGIES PRIVATE LIMITED",
"DENTCARE DENTAL LAB PRIVATE LIMITED",
"DENTINE INFORMATICS LLP",
"DENTIRA TECH INDIA PRIVATE LIMITED",
"DENTOS (INDIA) PRIVATE LIMITED",
"DENTSPLY INDIA PRIVATE LIMITED",
"DENTSPRO INDIA PRIVATE LIMITED",
"DENTSU CREATIVE IMPACT PRIVATE LIMITED",
"DENTSU INDIA PRIVATE LIMITED",
"DENTSU MEDIA AND HOLDINGS INDIA PRIVATE LIMITED",
"DENTSU ONE PRIVATE LIMITED",
"DENTURE VENTURES PRIVATE LIMITED",
"DENUO SOURCE INDIA PRIVATE LIMITED",
"DENVIK TECHNOLOGY PRIVATE LIMITED",
"DENYO MANUFACTURING INDIA PRIVATE LIMITED",
"DENZAI INNOVATIONS & THERAPEUTICS PRIVATE LIMITED",
"DENZO PAINTS PRIVATE LIMITED",
"DENZONG BREWERIES PRIVATE LIMITED",
"DENZONG CONSTRUCTIONS AND INFRA PROJECTS PRIVATE LIMITED",
"DEO BIZ & SERVICES PRIVATE LIMITED",
"DEO ENTERPRISES PRIVATE LIMITED",
"DEO LEELA FACADE SYSTEMS LLP",
"DEO RESIDENCY & RESORTS PRIVATE LIMITED",
"DEO TRADERS",
"DEOAHANADEO AGRO PRIVATE LIMITED",
"DEOBAND HIGHWAYS PRIVATE LIMITED",
"DEODAP INTERNATIONAL PRIVATE LIMITED",
"DEODARSHAN TEA COMPANY PRIVATE LIMITED",
"DEOGHAR AGROTECH PRIVATE LIMITED",
"DEOGHAR CYCLES PRIVATE LIMITED",
"DEOGHAR FOOD PRIVATE LIMITED",
"DEOGHAR INDUSTRIES PRIVATE LIMITED",
"DEOGHAR INFRA LIMITED",
"DEOGHAR MEGA POWER LIMITED",
"DEOGIRI FERTILISERS LIMITED",
"DEOGIRI INSTITUTE OF ENGINEERING AND MANAGEMENT STUDIES",
"DEOGIRI STONE PRODUCTS PRIVATE LIMITED",
"DEOGUN INDUSTRIES PRIVATE LIMITED",
"DEOKI MILK AND MILK PRODUCTS PRIVATE LIMITED",
"DEOKI TECHNOCRAFTS PRIVATE LIMITED",
"DEOLA AGRO PRODUCER COMPANY LIMITED",
"DEOLA VENTURES PRIVATE LIMITED",
"DEOLAX CABLES PRIVATE LIMITED",
"DEOLEO INDIA PRIVATE LIMITED",
"DEOMIGHT ENTERPRISES PRIVATE LIMITED",
"DEON NETWORKS PRIVATE LIMITED",
"DEON TAPES INDUSTRIES PRIVATE LIMITED",
"DEONAR TEA PLANTATIONS PVT. LTD.",
"DEOPUL ADHAR MEMORIAL HIGH SCHOOL",
"DE-OR METAL INDUSTRIES PRIVATE LIMITED",
"DEORA BUILDCON PRIVATE LIMITED",
"DEORA WIRES N MACHINES PRIVATE LIMITED",
"DEORAH COMMERCIAL PRIVATE LIMITED",
"DEORAHI SOLVENT EXTRACTION PRIVATE LIMITED",
"DEORA-KEDIA DEVELOPMENT COMPANY PRIVATE LIMITED",
"DEORAO PATIL MADYAMIC VIDYALAYA",
"DEORI AND CO PRIVATE LIMITED",
"DEORIA PAPER MILLS LIMITED",
"DEORIA PROJECTS LIMITED",
"DEOSHRI FARMERS PRODUCER COMPANY LIMITED",
"DEOSI SOLUTIONS PRIVATE LIMITED",
"DEP AGRO MACHINERIES PRIVATE LIMITED",
"DEP INDIA PRIVATE LIMITED",
"DEPA INDIA PRIVATE LIMITED",
"DEPAL STAMPINGS PVT LTD",
"DEPANSUM SOLUTIONS PRIVATE LIMITED",
"DEPARTEMENT OF AGRICULTURAL OFFICE OF DEPUTY DIRECTOR AGRICULTURAL AMBIKAPUR SURGUJA",
"DEPARTMENT OF AGRICULTURE",
"DEPARTMENT OF ATOMIC ENERGY",
"DEPARTMENT OF ATOMIC ENERGY HAVY WATER PLANT BARODA",
"DEPARTMENT OF BASIC EDUCATION UTTAR PRADESH",
"DEPARTMENT OF BIOTECHNOLOGY",
"DEPARTMENT OF EDUCATION GOVERNMENT OF HARAYANA",
"DEPARTMENT OF HEALTH AND FAMILY WELFARE",
"DEPARTMENT OF HOME",
"DEPARTMENT OF HORTICULTURE",
"DEPARTMENT OF INTERMEDIATE EDUCATION",
"IRRIGATION AND WATER RESOURCES DEPARTMENT",
"DEPARTMENT OF PER TRAIN",
"DEPARTMENT OF PLANNING",
"DEPARTMENT OF PLANT BREEDING AND GENETICS J.N. KRISHI VISHWA VIDYALAYA JABALPUR",
"DEPARTMENT OF POSTS",
"DEPARTMENT OF PRIMARY EDUCATION SILVASSA",
"DEPARTMENT OF PWD",
"DEPARTMENT OF REVENUE",
"DEPARTMENT OF SCHOOL EDUCATION",
"DEPARTMENT OF SCIENCE AND TECHNOLOGY GOVERNMENT OF INDIA",
"DEPARTMENT OF SECONDARY EDUCATION GOVERNMENT OF ASSAM",
"DEPARTMENT OF SPACE SEMI CONDUCTOR LABORATORY",
"DEPARTMENT OF TELECOM",
"DEPARTMENT OF TOURISM HEAD OFFICE JAIPUR",
"DEPARTMENT OF TUBE WELL",
"DEPARTMENT OF URBAN MINISTRY",
"DEPAVANI METALS PRIVATE LIMITED",
"DEPENDO LOGISTICS SOLUTIONS PRIVATE LIMITED",
"DEPOT REGT CORPS OF SIGNALS JABALPUIR",
"DEPT OF AYUSH GOVT ANDHRA PRADESH",
"DEPT OF HEALTH AND FAMILY WELFARE",
"DEPT OF MANAGEMENT STUDIES NAGPUR",
"DEPTH CONSULTING SERVICES PRIVATE LIMITED",
"DEPTH FILTRATION TECHNOLOGIES PRIVATE LIMITED",
"DEPTT OF INFORMATION TECHNOLOGY",
"DEPUTY CANE COMMISSIONER",
"DEPUTY CHIEF AUDITOR (JUNIOR), LOCAL FUND ACCOUNT SANGLI",
"DEPUTY COMMISSIONER COMMERCIAL TAX INDORE",
"DEPUTY COMMISSIONER OF STATE TAX(ENF) DIV-7 SURAT",
"DEPUTY COMMISSIONER OFFICE",
"DEPUTY COMMISSIONER SALE TAX CHHINDWARA",
"DEPUTY COMMISSIONER SALES TAX KHANDWA",
"DEPUTY CONSERVATOR OF FOREST",
"DEPUTY CONSERVATOR OF FORESTS MEWASI DIVISION TALODA",
"DEPUTY DIRECTOR ANIMAL HUSBANDRY ALLAHABAD CIRCLE",
"DEPUTY DIRECTOR FISHERIES AGRA",
"DEPUTY DIRECTOR GENERAL NATIONAL STATISTICAL OFFICE",
"DEPUTY DIRECTOR GENERAL VTS DIRECTORATE",
"DEPUTY DIRECTOR HORTICULTURE HOSHANGABAD",
"DEPUTY DIRECTOR OF AGRICULTURE",
"DEPUTY DIRECTOR OF ANIMAL HUSBANDERY ICDP AHMEDABAD",
"DEPUTY DIRECTOR OF EDUCATION",
"DEPUTY DIRECTOR OF HORTICULTURE",
"DEPUTY DIRECTOR OF RATIONING BARRACKPORE",
"DEPUTY DIRECTOR PANCHAYAT RAJNANDGAON",
"DEPUTY DIRECTOR SCHEDULE CASTE WELFARE AHMEDABAD",
"DEPUTY DIRECTOR SOCIAL FORESTRY DIVISION CHANDRAPUR",
"DEPUTY DIRECTOR SOCIAL FORESTRY DIVISION SATARA",
"DEPUTY DIRECTOR VETERINARY SERVICES",
"DEPUTY DIRECTOR VETERNARY SERVICES KHANDWA",
"DEPUTY DISTRICT ELECTION OFFICE THANE",
"DEPUTY ENGINEER ELECTRICAL SUBDIVISION AMRAVATI",
"DEPUTY EXCUTIVE ENGINEER P H MECHANICAL STORE SUB DIVISION",
"DEPUTY REGISTRAR CO OPRATIVE SOCITEY",
"DEPUTY SUPERINTENDENT OF LAND RECORDS",
"DEPUTY SUPERINTENDENT OF LANDRECORD KARAD",
"D'ERA FURNISHING PRIVATE LIMITED",
"DERAIYA REALTORS PRIVATE LIMITED",
"DERAJ ENTERPRISES PRIVATE LIMITED",
"DERATECH MACHINES INDIA PRIVATE LIMITED",
"DERAWALA ARTISANS PRIVATE LIMITED",
"DERBY CLOTHING P LIMITED",
"DERBY OVERSEAS PRIVATE LIMITED",
"DERBY PLANTATIONS PVT LTD",
"DEREWALA INDUSTRIES LIMITED",
"DEREWALA JEWELLERY MANUFACTURING COMPANY PRIVATE LIMITED",
"DERIK MART PRIVATE LIMITED",
"DERIK MOTORS PRIVATE LIMITED",
"DERISQ INSURANCE BROKERS PRIVATE LIMITED",
"DERIT INFRASTRUCTURE PRIVATE LIMITED",
"DERIVATIVESAINT PRIVATE LIMITED",
"DERIVE TRADING AND RESORTS PRIVATE LIMITED",
"DERIVIUM TRADITION SECURITIES INDIA PRIVATE LIMITED",
"DER-JOINT HEALTHCARE PRIVATE LIMITED",
"DERMA LASERTECH PRIVATE LIMITED",
"DERMA RAYS PRIVATE LIMITED",
"DERMACARE SURGICALS PRIVATE LIMITED",
"DERMACEUTICS INDIA PRIVATE LIMITED",
"DERMACY HEALTHCARE PRIVATE LIMITED",
"DERMAKARE PHARMACEUTICALS PRIVATE LIMITED",
"DERMAMIRACLE PRIVATE LIMITED",
"DERMAREX HEALTH CARE INDIA PRIVATE LIMITED",
"DERMATICA LABORATORIES PRIVATE LIMITED",
"DERMAWORLD SKIN AND HAIR CLINICS PRIVATE LIMITED",
"DERMCOS SKIN CARE PRIVATE LIMITED",
"DERMIA CONTICARE PRIVATE LIMITED",
"DERMONOVA PHARMA PRIVATE LIMITED",
"DERON PROPERTIES PRIVATE LIMITED",
"DERPA INDUSTRIAL POLYMERS PVT LTD",
"DERRICK SOLUTIONS INDIA PRIVATE LIMITED",
"DERY FOAMS PRIVATE LIMITED",
"DES AMIS FOOD PRIVATE LIMITED",
"DES ELECTRO MECH PRIVATE LIMITED",
"DES RAJ AND SONS BUILDERS PRIVATE LIMITED",
"DES RAJ NAGPAL CONTRACTORS PRIVATE LIMITED",
"DE'S TECHNICO LIMITED",
"DESAI AGRIFOODS PRIVATE LIMITED",
"DESAI AND COMPANY",
"DESAI AUTOCOM INDUSTRIES PRIVATE LIMITED",
"DESAI AUTOMOBILES PRIVATE LIMITED",
"DESAI BROTHERS LIMITED",
"DESAI BROTHERS PAPERS PRIVATE LIMITED",
"DESAI CEMENT COMPANY PRIVATE LIMITED",
"DESAI CONSTRUCTION PRIVATE LIMITED",
"DESAI COTTEX",
"DESAI ELECTRONICS PRIVATE LIMITED",
"DESAI EXIM PRIVATE LIMITED",
"DESAI FASHIONS PRIVATE LIMITED",
"DESAI FOODS PRIVATE LIMITED",
"DESAI FOUNDATION TRUST",
"DESAI GOLD PRIVATE LIMITED",
"DESAI HARIBHAKTI AND CO",
"DESAI HARIBHAKTI CONSULTING PRIVATE LIMITED",
"DESAI HOMES PROPERTIES PRIVATE LIMITED",
"DESAI HOSPITAL",
"DESAI IMPEX PRIVATE LIMITED",
"DESAI INDUSTRIES PRIVATE LIMITED",
"DESAI INFRA PROJECTS INDIA PRIVATE LIMITED",
"DESAI INFRASTRUCTURE PRIVATE LIMITED",
"DESAI JEWELLERS PRIVATE LIMITED",
"DESAI K K SARVAJANIK HIGH SCHOOL DHAMDACHHA",
"DESAI LENO WEAVES PRIVATE LIMITED",
"DESAI METROPOLIS HEALTH SERVICES PRIVATE LIMITED",
"DESAI PHARMA DISTRIBUTORS PRIVATE LIMITED",
"DESAI RESIDENCY PRIVATE LIMITED",
"DESAI VARUN RASAYAN PRIVATE LIMITED",
"DESANA IMPEX LTD",
"DESANA POLY PLASTIC INDUSTRIES",
"DESANA POLYMERS PRIVATE LIMITED",
"DESAPEX ENGINEERING CONSULTANTS LLP",
"DESAR KUMAR PRIMARY SCHOOL",
"DESARA DESIGN PRIVATE LIMITED",
"DESARCH PENTACLE PRIVATE LIMITED",
"DESAROLLO DEVELOPERS PRIVATE LIMITED",
"DESBUILD KRIS COOPER PRIVATE LIMITED",
"DESCENT THREAD INDUSTRIES PRIVATE LIMITED",
"DESCO ENGINEERING PLASTICS INDIA PRIVATE LIMITED",
"DESCO INFRATECH PRIVATE LIMITED",
"DESCON BUILDTECH PRIVATE LIMITED",
"DESCON GREEN TECH PRIVATE LIMITED",
"DESCON INFRASTRUCTURES PRIVATE LIMITED",
"DESCON LIMITED",
"DESCON PRIVATE LIMITED",
"DESEIN PRIVATE LIMITED",
"DESERT ARTISANS HANDICRAFTS JAIPUR LIMITED",
"DESERT GREENS PVT LTD",
"DESERT HOLIDAY RESORT PRIVATE LIMITED",
"DESERT RIVER CAPITAL PRIVATE LIMITED",
"DESERT SPRINGS RESORTS PRIVATE LIMITED",
"DESERVE BUILDERS & DEVELOPERWADHAVALIPRIVATE.LIMITED",
"DESERVE EXIM PRIVATE LIMITED",
"DESERVE LABS PRIVATE LIMITED",
"DESERVE VANIJYA PRIVATE LIMITED",
"DESH BHAGAT SKILLS PRIVATE LIMITED",
"DESH BHAGAT UNIVERSITY",
"DESH BUSINESS VENTURES PRIVATE LIMITED",
"DESH CONSULTANCY SERVICES PRIVATE LIMITED",
"DESH RAJ TEX FAB PRIVATE LIMITED",
"DESH RAKSHAK AUSHDHALAYA LIMITED",
"DESHBANDHU COLLEGE FOR GIRLS",
"DESHBANDHU IMPEX PRIVATE LIMITED",
"DESHBHAKTA ANANDRAO BALWANTRAO NAIK ARTS AND SCIENCE COLLEGE CHIKHALI",
"DESHBHAKTA RATNAPPANNA KUMBHAR PANCHGANGA SAHAKARI SAKHAR KARKHANA LTD",
"DESHDEEPAK CONSTRUCTIONS PRIVATE LIMITED",
"DESHI AMRIT PRIVATE LIMITED",
"DESHKAL NETWORK PRIVATE LIMITED",
"DESHMUKH COTTON INDUSTRIES",
"DESHMUKH ELECTRICAL CONSULTANTS PRIVATE LIMITED",
"DESHMUKH LEAD PRIVATE LIMITED",
"DESHMUKH MADHYAMIK VIDYALAYA HIGNA",
"DESHMUKH MOTORS PRIVATE LIMITED",
"DESHMUKH SOLAR ENERGY PRIVATE LIMITED",
"DESHMUKH TRADING COMPANY PRIVATE LIMITED",
"DESHMUKH UDYOG PRIVATE LIMITED",
"DESHMUKH WAREHOUSING PRIVATE LIMITED",
"DESHNA TEXTILES PRIVATE LIMITED",
"DESHPANDE AUTOMECH PRIVATE LIMITED",
"DESHPANDE DRUGS PRIVATE LIMITED",
"DESHPANDE EDUCATIONAL TRUST DET",
"DESHPANDE FOUNDATION",
"DESHPANDE MEMORIAL HOSPITAL",
"DESHPANDE TOYS PRIVATE LIMITED",
"DESHPANDHU TRANSPORT COMPANY PRIVATE LIMITED",
"DESHPEE INTERNET PRIVATE LIMITED",
"DESHPRAN BIRENDRANATH INSTITUTION FOR BO",
"DESHRAJ SOAP AND CHEMICALS PRIVATE LIMITED",
"DESHRAJ TEXTURISERS PVT LTD",
"DESHWAL WASTE MANAGEMENT PRIVATE LIMITED",
"DESI FUSION INDIA PRIVATE LIMITED",
"DESI MANDI PRIVATE LIMITED",
"DESI MUSIC FACTORY PRIVATE LIMITED",
"DESI TEA TIME LIMITED",
"DESIADDA CRAFTSWORKS LLP",
"DESICCANT ROTORS INTERNATIONAL PRIVATE LIMITED",
"DESICREW SERVICES KAUP PRIVATE LIMITED",
"DESICREW SOLUTIONS PRIVATE LIMITED",
"DESIDEA SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"DESIGN & DEVELOPMENT INDIA PRIVATE LIMITED",
"DESIGN AND DECORE INDIA PRIVATE LIMITED",
"DESIGN AND DETAILS PRIVATE LIMITED",
"DESIGN AND MANUFACTURING VISTA ELECTRONICS PRIVATE LIMITED",
"DESIGN AND PLANNING COUNSEL PRIVATE LIMITED",
"DESIGN BUREAU CONSULTANTS PRIVATE LIMITED",
"DESIGN CENTRE CONSULTING ENGINEERS PRIVATE LIMITED",
"DESIGN CLASSICS EXPORTS PRIVATE LIMITED",
"DESIGN COLLABORATIVE PRIVATE LIMITED",
"DESIGN COLLECTIVE MEDIA AND COMMUNICATIONS PRIVATE LIMITED",
"DESIGN CORE CONSULTANTS PRIVATE LIMITED",
"DESIGN DIALOGUES INDIA PRIVATE LIMITED",
"DESIGN DIMENSION & SPACE PRIVATE LIMITED",
"DESIGN DISPLAY PRIVATE LIMITED",
"DESIGN DYNAMICS INDIA PRIVATE LIMITED",
"DESIGN EDGE INTERIORS PRIVATE LIMITED",
"DESIGN EIGHT PRIVATE LIMITED",
"DESIGN ENGINEER",
"DESIGN EXCELLENCE INDIA PVT LTD",
"DESIGN FACTORY PRIVATE LIMITED",
"DESIGN FOR USE CONSULTING PRIVATE LIMITED",
"DESIGN FORUM INDIA PRIVATE LIMITED",
"DESIGN GORE INDIA PRIVATE LIMITED",
"DESIGN GROUP ENGINEERING CONSULTANTS PRIVATE",
"DESIGN GROUP PROJECT CONSULTANTS PRIVATE LIMITED",
"DESIGN HABIT PRIVATE LIMITED",
"DESIGN HOUSE INDIA PRIVATE LIMITED",
"DESIGN INTERVENTION INDIA PRIVATE LIMITED",
"DESIGN LAB PRINT PRIVATE LIMITED",
"DESIGN LATTICE PRIVATE LIMITED",
"DESIGN MATRIX ASSOCIATED PRIVATE LIMITED",
"DESIGN METAL SECTIONS PRIVATE LIMITED",
"DESIGN MODULE PRIVATE LIMITED",
"DESIGN OFFICE ARCHITECTS PRIVATE LIMITED",
"DESIGN OPTIMIZATION TECHNOLOGY PRIVATE LIMITED",
"DESIGN PARADISE ASSOCIATES PRIVATE LIMITED",
"DESIGN POINT CONSULT PRIVATE LIMITED",
"DESIGN RADIANCE PRIVATE LIMITED",
"DESIGN SMITH PRIVATE LIMITED",
"DESIGN SYMPOSIUM PRIVATE LIMITED",
"DESIGN TO DELIVER STUDIO PRIVATE LIMITED",
"DESIGN TREE SERVICES CONSULTANTS PRIVATE LIMITED",
"DESIGN TRIBE INDIA PRIVATE LIMITED.",
"DESIGN WERKZ ENGINEERING PRIVATE LIMITED",
"DESIGN WORKSHOP INDIA PRIVATE LIMITED",
"DESIGN XPRESS EXPRESS DESIGN COMPANY",
"DESIGN21 PRIVATE LIMITED",
"DESIGNA INDIA PRIVATE LIMITED",
"DESIGNBOAT UI/UX SCHOOL",
"DESIGNBOXED CREATIVES (INDIA) PRIVATE LIMITED",
"DESIGNBREWERY (OPC) PRIVATE LIMITED",
"DESIGNCO PRIVATE LIMITED",
"DESIGNED PRODUCTS LIMITED",
"DESIGNER AUDIO INDIA PRIVATE LIMITED",
"DESIGNER CONCRETE PRIVATE LIMITED",
"DESIGNER EXPORTS",
"DESIGNER HOME ACCESSORIES INDIA PRIVATE LIMITED",
"DESIGNER HOME STEDS PRIVATE LIMITED",
"DESIGNER ROCKS PRIVATE LIMITED",
"DESIGNER WATCHES PRIVATE LIMITED",
"DESIGNERS ELEMENTS GLOBAL SOLUTIONS PRIVATE LIMITED",
"DESIGNERS PAVINGS & TILES PRIVATE LIMITED",
"DESIGNERS POINT INDIA PRIVATE LIMITED",
"DESIGNEST PRIVATE LIMITED",
"DESIGNHAAUS SOLUTIONS PRIVATE LIMITED",
"DESIGNINDYA ADVERTISING PRIVATE LIMITED",
"DESIGNMATE INDIA PRIVATE LIMITED",
"DESIGNNBUY WEBTOPRINT PRIVATE LIMITED",
"DESIGNO LIFE STYLE SOLUTIONS PRIVATE LIMITED",
"DESIGNOWEB TECHNOLOGIES PRIVATE LIMITED",
"DESIGNPLUS ASSOCIATES SERVICES PRIVATE LIMITED.",
"DESIGNPLUS INFRAPROJECTS PRIVATE LIMITED",
"DESIGNPUNDITS INTERIORS PRIVATE LIMITED",
"DESIGNS BY LAVASSA PRIVATE LIMITED",
"DESIGNS IN CHANGE TECHNOLOGY PRIVATE LIMITED",
"DESIGNSHORE TECHNOLOGIES PRIVATE LIMITED",
"DESIGNSTRING SOLUTIONS PRIVATE LIMITED",
"DESIGNTECH SEMICONDUCTORS PRIVATE LIMITED",
"DESIGNTECH SYSTEMS LIMITED",
"DESIGNTECH SYSTEMS PRIVATE LIMITED",
"DESIGNTEK STEELS PRIVATE LIMITED",
"DESIGNTREE SERVICE CONSULTANTS PRIVATE LIMITED",
"DESIGNTUDE STUDIO PRIVATE LIMITED",
"DESIGNWISE INDIA PRIVATE LIMITED",
"DESILUK FASHION PRIVATE LIMITED",
"DESIMATI AGRI TECHNOLOGIES AND SERVICES PRIVATE LIMITED",
"DESIMD HEALTHCARE PRIVATE LIMITED",
"DESIMELODIES PRIVATE LIMITED",
"DESIMOBILE VOICE LAB COMMUNICATIONS PRIVATE LIMITED",
"DESINGA WORLDWIDE PRIVATE LIMITED",
"DESINGANAD AGGREGATES AND SAND PRIVATE LIMITED",
"DESINGANAD MEDICAL LINES PRIVATE LIMITED",
"DESIQUA PVT LTD",
"DESIRE 4 INDIA PRIVATE LIMITED",
"DESIRE CARGO INDIA PRIVATE LIMITED",
"DESIRE CHEMICALS PRIVATE LIMITED",
"DESIRE CONFECTIONERY PRIVATE LIMITED",
"DESIRE DIAGNOSTICS PRIVATE LIMITED",
"DESIRE ENERGY SOLUTIONS PRIVATE LIMITED",
"DESIRE HOLIDAYS PRIVATE LIMITED",
"DESIRE INFOWEB PRIVATE LIMITED",
"DESIRE MOULDINGS PRIVATE LIMITED",
"DESIRE OVERSEAS PRIVATE LIMITED",
"DESIRE RETAIL PRIVATE LIMITED",
"DESIRE SHARE AND COMMODITIES PRIVATE LIMITED",
"DESIRE VINCOM PRIVATE LIMITED",
"DESIREE INFRATECH PRIVATE LIMITED",
"DESIRENEST PROPERTIES PRIVATE LIMITED",
"DESISANDOOK ENTERPRISES PRIVATE LIMITED",
"DESITECH TIRUSTORE PRIVATE LIMITED",
"DESK NINE PRIVATE LIMITED",
"DESKERA SYSTEMS INDIA PRIVATE LIMITED",
"DESKMATE GLOBAL EXPRESS INDIA PRIVATE LIMITED",
"DESKOTEL COMMUNICATIONS PRIVATE LIMITED",
"DESKRIVER BUSINESS CENTRE (OPC) PRIVATE LIMITED",
"DESKZONE OFFICE SYSTEM PRIVATE LIMITED",
"DESMANIA DESIGN PRIVATE LIMITED",
"DESMET BALLESTRA ENGINEERING CENTER PRIVATE LIMITED",
"DESMET BALLESTRA INDIA PRIVATE LIMITED",
"DESMET REAGENT PRIVATE LIMITED",
"DESMI EQUIPMENTS PRIVATE LIMITED.",
"DESMI INDIA PRIVATE LIMITED",
"DESNET ENGINEERS PRIVATE LIMITED",
"DESOCON TECHNOLOGIES PRIVATE LIMITED",
"DESON MARKETING PRIVATE LIMITED",
"DESONS FINVEST PRIVATE LIMITED",
"DESONS HOLDINGS AND FINANCE PVT LTD",
"DESONS THERAPEUTICS PRIVATE LIMITED",
"D-ESPAT PRIVATE LIMITED",
"DESPA-TEL CERAMIC COATS P LTD",
"DESPRO TECHNOLOGIES PRIVATE LIMITED",
"DESQOO ENTERPRISES PRIVATE LIMITED",
"DES'S KIRTI M DOONGURSEE COLLEGE OF ARTS, SCIENCE & COMMERCE",
"DESS TECHNOLOGIES PRIVATE LIMITED",
"DESSERT MARINE SERVICES I PRIVATE LIMITED",
"DESSONS AUTOTECH PRIVATE LIMITED",
"DESSORONO COMMERCE PRIVATE LIMITED",
"DESSUS FITNESS (OPC) PRIVATE LIMITED",
"DESTAN METAL ENGINEERING PRIVATE LIMITED",
"DESTAR CONSULTING PRIVATE LIMITED",
"DESTEL INDIA PRIVATE LIMITED",
"DESTIMONEY DISTRIBUTION & ADVISORY SERVICES P LIMITED",
"DESTIN GLOBAL TRADECOM PRIVATE LIMITED",
"DESTINATION INDUSTRIAL PARKS PRIVATE LIMITED",
"DESTINATION LOGISTICS",
"DESTINATION MOTORS PRIVATE LIMITED",
"DESTINATION OUTDOORS LEARNING SYSTEMS PRIVATE LIMITED",
"DESTINATION PLANNERS PRIVATE LIMITED",
"DESTINATIONNXT PRIVATE LIMITED",
"DESTINATIONS OF THE WORLD SUBCONTINENT",
"DESTINATIONS UNPLUGGED TRAVELS SERVICES PRIVATE LIMITED",
"DESTINI INDIA LIMITED",
"DESTINI MARINE PRIVATE LIMITED",
"DESTINY CERAMIC PRIVATE LIMITED",
"DESTINY CREATIONS PRIVATE LIMITED",
"DESTINY EDUWORLD PRIVATE LIMITED",
"DESTINY ENVIRO SOLUTIONS PRIVATE LIMITED",
"DESTINY FINCO PVTLTD",
"DESTINY LOGISTICS & INFRA LIMITED",
"DESTINY PROMOTERS PRIVATE LIMITED",
"DESTINY RETAIL MALL DEVELOPERS PRIVATE LIMITED",
"DESTO AUTOMATION INDIA PRIVATE LIMITED",
"DESUN HEALTHCARE & RESEARCH INSTITUTE LIMITED",
"DESUN HOSPITAL & HEART INSTITUTE",
"DESWAL HATCHERIES PRIVATE LIMITED",
"DESWAL POULTRY FARMS PRIVATE LIMITED",
"DETAIL CLOTHING LIMITED",
"DETAIL MASTERS PRIVATE LIMITED",
"DETAILING ART PRIVATE LIMITED",
"DETAILING DEVILS",
"DETAILING DEVILS INDIA PRIVATE LIMITED",
"DETAMAN ELECTRICALS PRIVATE LIMITED",
"DETCO TEXTILES PRIVATE LIMITED",
"DETECH DEVICES PRIVATE LIMITED",
"DETECT ELECTRONICS SYSTEMS (INDIA) PRIVATE LIMITED",
"DETECTION INSTRUMENTS INDIA PRIVATE LIMITED",
"DETECVISION TECHNOLOGIES PRIVATE LIMITED",
"DETERGEO CHEM PRIVATE LIMITED",
"DETERMINED TRADEX PRIVATE LIMITED",
"DETINNERS PVT LTD",
"DETOUR ODISHA PRIVATE LIMITED",
"DETOX CORPORATION PRIVATE LIMITED",
"DETOX INDIA PRIVATE LIMITED",
"DETOXFOLKS PRIVATE LIMITED",
"DETPAK INDIA PRIVATE LIMITED",
"DETRIV INSTRUMENTATION AND ELECTRONICS PRIVATE LIMITED",
"DETROIT AUTOMOBILES INDIA PRIVATE LIMITED",
"DETROIT SOFTWARE CONSULTANTS INDIA PRIVATE LIMITED",
"DETROIT SYSTEM PRIVATE LIMITED",
"DETS LIMITED",
"DEUEX SOLUTIONS PRIVATE LIMITED",
"DEUGLO INFOSYSTEM PRIVATE LIMITED",
"DEUGRO PROJECTS INDIA PRIVATE LIMITED",
"DEUS EX MACHINA PRIVATE LIMITED",
"DEUS RRC PRIVATE LIMITED",
"DEUTEK CONTROLS (INDIA) LIMITED",
"DEUTSCH INDIA POWER CONNECTORS PRIVATE LIMITED",
"DEUTSCH QUALITY SYSTEMS INDIA PRIVATE LIMITED",
"DEUTSCHE ASSET MANAGEMENT INDIA PRIVATE LIMITED",
"DEUTSCHE BANK",
"DEUTSCHE CARS PRIVATE LIMITED",
"DEUTSCHE CIB CENTRE PRIVATE LIMITED",
"DEUTSCHE EQUITIES INDIA PRIVATE LIMITED",
"DEUTSCHE GESELLSCHAFT FUR INTERNATIONALE ZUSAMMENARBEIT (GIZ) GMBH",
"DEUTSCHE INDIA HOLDINGS PRIVATE LIMITED",
"DEUTSCHE INDIA PRIVATE LIMITED",
"DEUTSCHE INVESTMENTS INDIA PRIVATE LIMITED",
"DEUTSCHE INVESTOR SERVICES PRIVATE LIMITED",
"DEUTSCHE MASCHINEN INDIA PRIVATE LIMITED",
"DEUTSCHE MOTOREN PRIVATE LIMITED",
"DEUTSCHE SCHULE BOMBAY",
"DEUTSCHE TELEKOM CLINICAL SOLUTIONS INDIA PRIVATE LIMITED",
"DEUTSCHE TELEKOM DIGITAL LABS PRIVATE LIMITED",
"DEUTSCHLAND TRANSFORMERS PRIVATE LIMITED",
"DEV AGRI-TECH PRIVATE LIMITED",
"DEV AGRO (INDIA) CHEMICALS AND FERTILIZERS LIMITED",
"DEV AND ASSOCIATES",
"DEV ARJUNA CAST AND FORGE PRIVATE LIMITED",
"DEV ARJUNA ENTERPRISES PRIVATE LIMITED",
"DEV AUTOMATES PRIVATE LIMITED",
"DEV BHOOMI CARS PRIVATE LIMITED",
"DEV BHOOMI ENGINEERING",
"DEV BHOOMI MOTORS PRIVATE LIMITED",
"DEV BHOOMI UTTARAKHAND UNIVERSITY",
"DEV BHUMI COLD CHAIN PRIVATE LIMITED",
"DEV BHUMI PROPMART PRIVATE LIMITED",
"DEV BUILDERS AND COLONISERS PRIVATE LIMITED",
"DEV CARRIER & MINERALS PRIVATE LIMITED",
"DEV CHEMICALS & PHARMACEUTICALS PRIVATE LIMITED",
"DEV CHEMINDUSTRIES MFG PRIVATE LIMITED",
"DEV COLOUR AND COATINGS PRIVATE LIMITED",
"DEV COMPONENTS PRIVATE LIMITED",
"DEV CONTRACTORS AND ENGINEERS PRIVATE LIMITED",
"DEV COTTON & OIL INDUSTRIES",
"DEV DARSHAN DESIGNS PRIVATE LIMITED",
"DEV DIAMOND PRIVATE LIMITED",
"DEV DIGITAL VADODARA PRIVATE LIMITED",
"DEV DRUGS (INDIA) PRIVATE LIMITED",
"DEV DUTT ENGINEERS PRIVATE LIMITED",
"DEV ENTERTAINMENT VENTURES PRIVATE LIMITED",
"DEV ENVOCARE PRIVATE LIMITED",
"DEV FIBERS PRIVATE LIMITED",
"DEV FINVEST ADVISORY SERVICES PRIVATE LIMITED",
"DEV FLEXIPACK PRIVATE LIMITED",
"DEV INDIA PROJECTS PRIVATE LIMITED",
"DEV INFORMATION TECHNOLOGY LIMITED",
"DEV INFRACITY PRIVATE LIMITED DIPL",
"DEV INSIGHTS PRIVATE LIMITED",
"DEV IT SERV PRIVATE LIMITED",
"DEV KALYAN INDUSTRIES PRIVATE LIMITED",
"DEV LABTECH VENTURE LIMITED",
"DEV LAND & HOUSING PRIVATE LIMITED",
"DEV MANTRA FINANCIAL SERVICES PRIVATE LIMITED",
"DEV MARMO PRIVATE LIMITED",
"DEV MEDICINES PRIVATE LIMITED",
"DEV MILK FOODS PRIVATE LIMITED",
"DEV MILK FOODS PRIVATE LIMITED.",
"DEV MOGRA INFRA PRIVATE LIMITED",
"DEV MOTORS PRIVATE LIMITED",
"DEV PACKAGING INDUSTRIES PRIVATE LIMITED",
"DEV PHARMACY PRIVATE LIMITED",
"DEV PLASPACK EXPORTS PRIVATE LIMITED",
"DEV PLAST PRIVATE LIMITED",
"DEV POLYPLAST PRIVATE LIMITED",
"DEV POOJA BUILDERS PRIVATE LIMITED",
"DEV PRAYAG BUILDTECH PRIVATE LIMITED",
"DEV PRECISION SYSTEMS PRIVATE LIMITED",
"DEV PRINT & PACK PRIVATE LIMITED",
"DEV PRIYA INDUSTRIES PRIVATE LIMITED",
"DEV PRIYA PAPERS PRIVATE LIMITED",
"DEV PRIYA PRODUCTS PRIVATE LIMITED",
"DEV PROCON LIMITED",
"DEV PROJECTS PRIVATE LIMITED",
"DEV RAJ & SONS FABRICS PRIVATE LIMITED",
"DEV READYMIX PRIVATE LIMITED",
"DEV RESINS PRIVATE LIMITED",
"DEV RISHI EDUCATIONAL SOCIETY",
"DEV RUBBER FACTORY PRIVATE LIMITED",
"DEV SAHITYA KUTIR PVT LTD",
"DEV SALT PRIVATE LIMITED",
"DEV SHREE COTSYN PRIVATE LIMITED",
"DEV SOFTWARE AND SERVICES PRIVATE LIMITED",
"DEV SPARES PRIVATE LIMITED",
"DEV STAINLESS STEEL PRIVATE LIMITED",
"DEV STRUCTURAL INDIA PRIVATE LIMITED",
"DEV TECH INDIA PRIVATE LIMITED",
"DEV TECHNOFAB LIMITED",
"DEV TECHNOSYS PRIVATE LIMITED",
"DEV TEX-KNIT PRIVATE LIMITED",
"DEV TRAXIM PRIVATE LIMITED",
"DEV VENTURES INDIA PRIVATE. LIMITED.",
"DEV WIRE DRAWING ENTERPRISE PRIVATE LIMITED",
"DEV YASH PROJECTS AND INFRASTRUCTURE PRIVATE LIMITED",
"DEVA CROP SCIENCE PRIVATE LIMITED",
"DEVA DRILL-TECH INDIA LIMITED",
"DEVA INDIA TEXFAB PRIVATE LIMITED",
"DEVA INSTITUTE OF HEALTHCARE & RESEARCH PRIVATE LIMITED",
"DEVA INTERIORS PRIVATE LIMITED.",
"DEVA INTERNATIONAL EXIM PRIVATE LIMITED",
"DEVA LEASE AND FINANCE PVT LTD",
"DEVA METAL POWDERS PRIVATE LIMITED",
"DEVA PESTICIDES LIMITED",
"DEVA SINGH SHAM SINGH",
"DEVA SINGH SHAM SINGH EXPORTS PRIVATE LIMITED",
"DEVA TRADES AND ESTATES PRIVATE LIMITED",
"DEVADHIPATIH SERVICES PRIVATE LIMITED",
"DEVADITYA TRADE AND LOGISTICS PRIVATE LIMITED",
"DEVADOSS HOSPITAL PRIVATE LIMITED",
"DEVAGABOND OUTDOOR PRIVATE LIMITED",
"DEVAGRA BUILDERS PRIVATE LIMITED",
"DEVAHUTHI SOFTWARE SOLUTIONS PRIVATE LIMITED",
"DEVAKAR INVESTMENT AND TRADING COMPANY PVT LTD",
"DEVAKI ENGINEERING ENTERPRISES PRIVATE LIMITED",
"DEVAKI HI-ENERGY BATTERIES PRIVATE LIMITED",
"DEVAKI HOSPITAL",
"DEVAKI TECHNOLOGIES INDIA PRIVATE LIMITED",
"DEVAL ENERGY RESOURCES PRIVATE LIMITED",
"DEVALOKE DEVELOPERS LTD",
"DEVALYA SERVICES PRIVATE LIMITED",
"DEVAM TOURS AND TRAVELS PRIVATE LIMITED",
"DEVAMATA COMMERCIALS PRIVATE LIMITED",
"DEVAMATHA CMI PUBLIC SCHOOL THRISSUR",
"DEVAMBIKA NURSING HOME PRIVATE LIMITED",
"DEVAN AGROTECH PRIVATE LIMITED",
"DEVANADI CONSULTING SERVICES PRIVATE LIMITED",
"DEVANAND SEEDS PRIVATE LIMITED",
"DEVANG CONSULTANCY SERVICES PRIVATE LIMITED",
"DEVANG PAPER MILLS PRIVATE LIMITED",
"DEVANGA SANGHA",
"DEVANGI INFRASTRUCTURE PRIVATE LIMITED",
"DEVANGI POWER PRIVATE LIMITED",
"DEVANI DEVELOPERS PRIVATE LIMITED",
"DEVANK MILK AND MILK PRODUCTS PRIVATE LIMITED",
"DEVANS MODERN BREWERIES LIMITED",
"DEVANS SOUTH INDIAN COFFEE AND TEA PRIVATE LIMITED",
"DEVANSH CHEMICALS PRIVATE LIMITED",
"DEVANSH ENTERPRISES",
"DEVANSH LOGISTICS PRIVATE LIMITED",
"DEVANSH ORGANICS PRIVATE LIMITED",
"DEVANSH REALTORS PRIVATE LIMITED",
"DEVANSH TESTING AND RESEARCH LABORATORY PRIVATE LIMITED",
"DEVANSH WIRE AND CABLES PRIVATE LIMITED",
"DEVANSHEE REALTY (INDIA) PRIVATE LIMITED",
"DEVANSHEE SYSTEMS PRIVATE LIMITED",
"DEVANSHI AIR & FOREX PRIVATE LIMITED",
"DEVANSHI DESIGNER CREATION PRIVATE LIMITED",
"DEVANSHI ELECTRONICS PRIVATE LIMITED",
"DEVANSHI INTERIOR PRIVATE LIMITED",
"DEVANSHI LAMINATES PRIVATE LIMITED",
"DEVANSHI PLYBOARD INDUSTRIES PRIVATE LIMITED",
"DEVANSHI SAREES PRIVATE LIMITED",
"DEVANSHI SHIPPING AGENCY PRIVATE LIMITED",
"DEVANSHI TRADING AND LOGISTICS PRIVATE LIMITED",
"DEVANSHU INFIN PRIVATE LIMITED",
"DEVANSYS TECHSOL PRIVATE LIMITED",
"DEVARAHIPPARIGI WIND POWER PRIVATE LIMITED",
"DEVARPAN FOODS PRIVATE LIMITED",
"DEVARSH INDUSTRIES PRIVATE LIMITED",
"DEVARSONS INDUSTRIES PRIVATE LIMITED",
"DEVARYA INFOTECH PRIVATE LIMITED",
"DEVARYAA HOSPITALITIES PRIVATE LIMITED",
"DEVAS INDIA PRIVATE LIMITED",
"DEVAS TEXTILES PRIVATE LIMITED",
"DEVASAN INVESTMENTS PRIVATE LIMITED",
"DEVASH PETROLEUMS INDIA PRIVATE LIMITED",
"DEVASHI CREATION PRIVATE LIMITED",
"DEVASHI POLYTEX PRIVATE LIMITED",
"DEVASHISH FOOD PACKAGING AND RESEARCH PRIVATE LIMITED",
"DEVASHISH INFRASTRUCTURE PRIVATE LIMITED",
"DEVASHISH INTERIORS PRIVATE LIMITED",
"DEVASHISH POLYMERS PRIVATE LIMITED",
"DEVASHISH POLYSYNTH PRIVATE LIMITED",
"DEVASHISH TEXTILE MILLS PRIVATE LIMITED",
"DEVASHREE ISPAT PRIVATE. LIMITED.",
"DEVASHRI COTEX PRIVATE LIMITED",
"DEVASTHALI INFOTECH PRIVATE LIMITED",
"DEVASYA INTERNATIONAL SCHOOL",
"DEVASYA METALLICS PRIVATE LIMITED",
"DEVASYA POLYTECHNIC",
"DEVASYA VINIMAY PVT LTD",
"DEVAT RAM & COMPANY PRIVATE LIMITED",
"DEVATS INDIA PRIVATE LIMITED",
"DEVAYA LOGISTICS PRIVATE LIMITED",
"DEVBHOOMI BUILDERS AND STONE CRUSHERS PRIVATE LIMITED",
"DEVBHOOMI CASTING PRIVATE LIMITED",
"DEVBHOOMI CONSTRUCTIONS PRIVATE LIMITED",
"DEVBHOOMI JEWELS PRIVATE LIMITED",
"DEVBHOOMI PULP & PAPER INDUSTRIES PRIVATE LIMITED",
"DEVBHOOMI STEELS PRIVATE LIMITED",
"DEVBHOOMI STONE CO. PRIVATE LIMITED",
"DEVBHUMI BROADCAST PRIVATE LIMITED",
"DEVBHUMI NATURAL PRODUCTS PRODUCERS COMPANY PRIVATE LIMITED",
"DEVBHUMI REALTORS PRIVATE. LIMITED.",
"DEVCHAND ENGINEERS PRIVATE LIMITED",
"DEVCHHAYA INDUSTRIES UTTARAKHAND",
"DEVCLAN SOFT PRIVATE LIMITED",
"DEVCO ENGINEERING AND TECHNOLOGIES PRIVATE LIMITED",
"DEVCON SYSTEMS & PROJECTS PVT.LTD.",
"DEVDARSHAN OVERSEAS",
"DEVDASHRATH INFRATECH PRIVATE LIMITED",
"DEVDASHRATH ROYALTIES PRIVATE LIMITED",
"DEVDATHAM BUILDERS & DEVELOPERS PRIVATE LIMITED",
"DEVDATTA MANAGEMENT SERVICES PRIVATE LIMITED",
"DEVDEEP COTTON INDUSTRIES",
"DEVDEEP DECOR LLP",
"DEVDEEP TEX FAB PRIVATE LIMITED",
"DEVDEVA AUTOMOBILE PRIVATE LIMITED",
"DEVDHAR CHEMICALS PRIVATE LIMITED",
"DEVDIGITAL ELECTRONICS PRIVATE LIMITED",
"DEVDIL HYBRID SEEDS PRIVATE LIMITED",
"DEVDIP BUILDERS PRIVATE LIMITED",
"DEVDRISHTI INFRAHOMES PRIVATE LIMITED",
"DEV-DWARKA WINDPROJECT LIMITED",
"DEVE PAINTS LIMITED",
"DEVE RUS ADVISORY SERVICES PRIVATE LIMITED",
"DEVEE BIOLOGICALS PRIVATE LIMITED",
"DEVEE MULTI FOOD AND TOBACO PRIVATE LIMITED",
"DEVEER DECOR PRIVATE LIMITED",
"DEVELOP EXIM INDIA PRIVATE LIMITED",
"DEVELOP SCRIPTS LLC",
"DEVELOPER GROUP INDIA PRIVATE LIMITED",
"DEVELOPMENT ALTERNATIVES",
"DEVELOPMENT AND RESEARCH SERVICES PRIVATE LIMITED",
"DEVELOPMENT ARCHITECTS PRIVATE LIMITED",
"DEVELOPMENT CONSULTANTS PRIVATE LIMITED",
"DEVELOPMENT ENVIRONERGY SERVICES LIMITED",
"DEVELOPMENT MANAGEMENT FOUNDATION",
"DEVELOPMENT STRATEGIES INDIA PRIVATE LIMITED",
"DEVELOPTECH IT SOLUTION PRIVATE LIMITED",
"DEVELOPWONDERS SOLUTION PRIVATE LIMITED",
"DEVEN INFOTECH PRIVATE LIMITED",
"DEVEN PACKAGING PRIVATE LIMITED",
"DEVEN SUPER CRITICALS PRIVATE LIMITED",
"DEVEN TEXTILE INDUSTRIES PRIVATE LTD",
"DEVENDER JAIN PANSARI PRIVATE LIMITED",
"DEVENDERKUMAR CONSTRUCTIONS PRIVATE LIMITED",
"DEVENDRA & SONS CONSTRUCTION PRIVATE LIMITED",
"DEVENDRA AND DEVENDRA SHELTERS PRIVATE LIMITED",
"DEVENDRA AUTOCOM PRIVATE LIMITED",
"DEVENDRA AUTOMOBILES PRIVATE LIMITED",
"DEVENDRA MERCHANDISE PRIVATE LIMITED",
"DEVENDRA PACKAGING PRIVATE LIMITED",
"DEVENDRAN COAL INTERNATIONAL PRIVATE LIMITED",
"DEVENDRAN PLASTIC PRIVATE LIMITED",
"DEVENDRASINGH WHEELS PRIVATE LIMITED",
"DEVENTHIRA SPINNERS PRIVATE LIMITED",
"DEVENTURE HOTEL AND RESORTS PRIVATE LIMITED",
"DEVERE GROUP INDIA INVESTMENT ADVISORS PRIVATE LIMITED",
"DEVESH DARSHAN INVESTMENT PVT LTD",
"DEVESH FOODS AND AGRO PRODUCTS PRIVATE LIMITED",
"DEVESH MEDICARE PRIVATE LIMITED",
"DEVESH MOTORS PRIVATE LIMITED",
"DEVESH RICE MILLS PRIVATE LIMITED",
"DEVESH SOLUTIONS PRIVATE LIMITED",
"DEVET INDIA PRIVATE LIMITED",
"DEVFOLIO TECHNOLOGIES PRIVATE LIMITED",
"DEVGAD AGRO FOODS PRIVATE LIMITED",
"DEVGANGA CONSTRUCTIONS PRIVATE LIMITED",
"DEVGAURAV FACILITY SERVICES PRIVATE LIMITED",
"DEVGEN SEEDS AND CROP TECHNOLOGY PRIVATE LIMITED",
"DEVGIRI CARPETS PRIVATE LIMITED",
"DEVGIRI FORGINGS PRIVATE LIMITED",
"DEVGIRI OVERSEAS PRIVATE LIMITED",
"DEVGIRI SYNTHETICS PRIVATE LIMITED",
"DEVGREEN DEVELOPERS PRIVATE LIMITED",
"DEVHARSH INFOTECH PRIVATE LIMITED",
"DEVHOMES INFRANIRMAN PRIVATE LIMITED",
"DEVI AHILYA VISHWAVIDYALAYA",
"DEVI ANUSUIYA VIDYA SANSTHAN",
"DEVI AQUA FEEDS PRIVATE LIMITED",
"DEVI AQUATECH PRIVATE LIMITED",
"DEVI BUILDERS PRIVATE LIMITED",
"DEVI CHEMSCIENCE PRIVATE LIMITED",
"DEVI CHEMTECH PRIVATE. LIMITED.",
"DEVI CONSTRUCTION CO. PRIVATE. LIMITED.",
"DEVI CROPSCIENCE PRIVATE LIMITED",
"DEVI DARSAN PROCESSORS PRIVATE LIMITED",
"DEVI DASS RAM DASS COLD STORAGE PRIVATE LIMITED",
"DEVI DAYAL FOODS PRIVATE LIMITED",
"DEVI DAYAL HARI KISHAN",
"DEVI DESIGNS PRIVATE LIMITED",
"DEVI DISTRIBUTORS PVT.LTD.",
"DEVI DUTT TEXTILES PVT.LTD.",
"DEVI EKVEERA VIDYALAYA GOVANDI",
"DEVI ENERGIES PRIVATE LIMITED",
"DEVI ENGINEERING AND CONSTRUCTIONS PRIVATE LIMITED",
"DEVI EXPORTS PRIVATE LIMITED",
"DEVI FASTNERS PRIVATE LIMITED",
"DEVI FERRO & STEELCAST PRIVATE LIMITED",
"DEVI FISHERIES LIMITED",
"DEVI FOAM PRIVATE LIMITED",
"DEVI FREIGHTAGE PRIVATE LIMITED",
"DEVI HI-TECH ENGINEERS PVT. LTD.",
"DEVI HOSPITAL",
"DEVI INFRASPACE PRIVATE LIMITED",
"DEVI INFRAWORLD PRIVATE LIMITED",
"DEVI INNOVENTURES LLP",
"DEVI IRON AND POWER PRIVATE LIMITED",
"DEVI MARKETING PVT LTD",
"DEVI OVERSEAS",
"DEVI OVERSEAS PRIVATE LIMITED",
"DEVI PLANTATIONS PRIVATE LIMITED",
"DEVI POLYMERS PRIVATE LIMITED",
"DEVI POWERS PRIVATE LIMITED",
"DEVI PROCESSORS PRIVATE LIMITED",
"DEVI RATN",
"DEVI SANSTHAN",
"DEVI SCANS PVT LTD",
"DEVI SEA FOODS LIMITED",
"DEVI SILICONE RUBBER PRIVATE LIMITED",
"DEVI SREE TOOL CRAFTS PRIVATE LIMITED",
"DEVI SUPER SPECIALITY EYE HOSPITAL PRIVATE LIMITED",
"DEVI TECHNOCRAFT PRIVATE LIMITED",
"DEVI THREAD PROCESSORS PRIVATE LIMITED",
"DEVI TRADING & HOLDING PVT LTD",
"DEVI TURNOMATICS PRIVATE LIMITED",
"DEVI WOMAN AND CHILD HOSPITAL & RESEARCH CENTER PRIVATE LIMITED",
"DEVIBAG SHOPPING MALL PRIVATE LIMITED",
"DEVICEBOOK INNOVATION PRIVATE LIMITED",
"DEVICEDRIVEN INDIA PRIVATE LIMITED",
"DEVICO SAREES PRIVATE LIMITED",
"DEVIDAYAL CHEMICAL INDUSTRIES PRIVATE LIMITED",
"DEVIDAYAL SOLAR SOLUTIONS PRIVATE LIMITED",
"DEVIDAYAL STAINLESS STEEL INDUSTRIES PVT LTD",
"DEVIGOLD JEWEL PRIVATE LIMITED",
"DEVIHALLI HASSAN TOLLWAY PRIVATE LIMITED",
"DEVIKA CONSTRUCTION & DEVELOPERS PRIVATE LIMITED",
"DEVIKA ESTATE MANAGAEMENT PRIVATE LIMITED",
"DEVIKA FASHION PRIVATE LIMITED",
"DEVIKA FIBRES PVT LTD",
"DEVIKA GOLD HOMZ PRIVATE LIMITED",
"DEVIKA LATEX PRIVATE LIMITED",
"DEVIKA RESOURCES PRIVATE LIMITED",
"DEVIKA SYNTHETICS PRIVATE LIMITED",
"DEVIKA UNIVERSAL LANDS & BUILDING PRIVATE LIMITED",
"DEVIKA VENTURES AND INDUSTRIES PRIVATE LIMITED",
"DEVIKASHI COLD STORAGE INDIA PRIVATE LIMITED",
"DEVIKKESH NOVAMATE BOARDS PRIVATE LIMITED",
"DEVIKRUPA CONSTRUCTION PRIVATE LIMITED",
"DEVILBISS HEALTHCARE PRIVATE LIMITED",
"DEVILOG INFRASTRUCTURES PRIVATE LIMITED",
"DEVIM COMMERCIAL TRADE PRIVATE LIMITED",
"DEVIMAASHAKTI CONSTRUCTIONS & CONSULTANCY SERVICES PRIVATE LIMITED",
"DEVINANDA AGRO FARMER PRODUCER COMPANY LIMITED",
"DEVINCY TECHNOLOGIES OPC PRIVATE LIMITED",
"DEVINDER DAHIYA INFRASTRUCTURE PRIVATE LIMITED",
"DEVINDRA ENGINEERING WORKS PVT LTD",
"DEVINE IMPEX LIMITED",
"DEVINE MEDITECH PRIVATE LIMITED",
"DEVINE REALTY AND CONSTRUCTION PRIVATE LIMITED",
"DEVINE TOUCH EXPORTS PRIVATE LIMITED",
"DEVINENETRA CARE SATARA PRIVATE LIMITED",
"DEVINTEC ELECTRICAL TECHNOLOGIES PRIVATE LIMITED",
"DEVIPRASAD CONSTRUCTIONS PRIVATE LIMITED",
"DEVIPRIYA ENTERPRISES",
"DEVIR ASSETS PRIVATE LIMITED",
"DEVIS HOMES PRIVATE LIMITED",
"DEVISE ELECTRONICS PRIVATE LIMITED",
"DEVISE ENGINEERING PRIVATE LIMITED",
"DEVISE MARAGO SHIPPING PRIVATE LIMITED",
"DEVISH EXIM PRIVATE LIMITED",
"DEVISH OIL INDUSTRIES PRIVATE LIMITED",
"DEVISHA FASHIONS PRIVATE LIMITED",
"DEVISHI RENEWABLE ENERGY PRIVATE LIMITED",
"DEVISHI SOLAR POWER PRIVATE LIMITED",
"DEVISHREE AGRITECH PRIVATE LIMITED",
"DEVISHREE MUDRAN PRIVATE LIMITED",
"DEVISHREE PRINTOPACK PRIVATE LIMITED",
"DEVISONS INFINITI HOUSEWARES PRIVATE. LIMITED.",
"DEVITA ENGINEERING INDIA PRIVATE LIMITED",
"DEVJI KESHAVJI FINSTOCK PRIVATE LIMITED",
"DEVJIG INFRA PRIVATE LIMITED",
"DEVJYOTI BOOKS PRIVATE LIMITED",
"DEVKA BEACH RESORT PVT LTD",
"DEVKA FOOD PRODUCT PVT LTD",
"DEVKALYAN SALES PVT LTD",
"DEVKI AUTO INDUSTRIES PVT.LTD.",
"DEVKI BUILDERS PRIVATE LIMITED",
"DEVKI CLOTHING PRIVATE LIMITED",
"DEVKI DEVI FOUNDATION MAX HOPSITAL",
"DEVKI DEVI JAIN MEMORIAL COLLEGE",
"DEVKI FOODS PRIVATE LIMITED",
"DEVKI METALS PRIVATE LIMITED",
"DEVKINANDAN PAPER MILLS PRIVATE LIMITED",
"DEVKIRAN PAPER MILLS PRIVATE LIMITED",
"DEVKIRAN TELETECH PRIVATE LIMITED",
"DEVKNIT TEXTILES PRIVATE LIMITED",
"DEVKRAFT TECHNOLOGIES PRIVATE LIMITED",
"DEVKRIPA KNITFAB PRIVATE LIMITED",
"DEVKRIPA YARNS PRIVATE LIMITED",
"DEVKRISHNA ENGICONS PRIVATE LIMITED",
"DEVKUNJ INFRA PRIVATE LIMITED",
"DEVLABS ALLIANCE PRIVATE LIMITED",
"DEVLAND INFRACON PRIVATE LIMITED",
"DEVLATA TECHNOLOGIES PRIVATE LIMITED",
"DEVLIFE CORPORATION PRIVATE LIMITED",
"DEVNADI MERCANTILE PRIVATE LIMITED",
"DEVNADI VALLEY AGRICULTURAL PRODUCER COMPANY LIMITED",
"DEVNAGRI AI PRIVATE LIMITED",
"DEVNANDAN GASES PRIVATE LIMITED",
"DEVNANDAN INDUSTRIES PRIVATE LIMITED",
"DEVNANDAN INFRASTRUCTURE PRIVATE. LIMITED.",
"DEVNGI JEWELLERS PRIVATE LIMITED",
"DEVNIDHI AGRO PRODUCER COMPANY LIMITED",
"DEVOILER PRIVATE LIMITED",
"DEVOIR LIFESCIENCES PRIVATE LIMITED",
"DEVOIR TRANS SOLUTION PRIVATE LIMITED",
"DEVON ENERGY CORPORATION",
"DEVON FOODS LIMITED",
"DEVON INNOVATIONS PRIVATE LIMITED",
"DEVON MACHINES P LIMITED",
"DEVON PLANTATIONS AND INDUSTRIES LIMITED",
"DEVON SOFTWARE SERVICES PRIVATE LIMITED",
"DEVOSHRI EXIM PRIVATE LIMITED",
"DEVOSTIK ADHESIVES PRIVATE LIMITED",
"DEVOTION AND DEDICATED CONSULTANCY PRIVATE LIMITED",
"DEVOTTAM MEDICAL INSTITUTE PRIVATE LIMITED",
"DEVPARA PRIMARY SCHOOL",
"DEVPIXEL PRIVATE LIMITED",
"DEVPRABHA CONSTRUCTION PRIVATE LIMITED",
"DEVPRAYAG PAPER MILL PRIVATE LIMITED",
"DEVPRIYA FIBRES PRIVATE. LIMITED.",
"DEVPRIYAJI TEXTILES PRIVATE LIMITED",
"DEVPUJAN LOGISTICS PRIVATE LIMITED",
"DEVPURI CONSTRUCTION PRIVATE LIMITED",
"DEVPURI INFRA PRIVATE LIMITED",
"DEVPUSHP MEDICAL STORE",
"DEVR SOFTWARE SOLUTIONS LLP",
"DEVRA AUTOPARTS PRIVATE LIMITED",
"DEVRA BUILDTECH PRIVATE LIMITED",
"DEVRADA FAMILY NIDHI LIMITED",
"DEVRAHA COMMUNICATIONS LIMITED",
"DEVRAJ COLD STORAGE PRIVATE LIMITED",
"DEVRAJ COMPUTERS PRIVATE LIMITED",
"DEVRAJ HOUSING DEVELOPMENT PRIVATE LIMITED",
"DEVRAJ JEWELLERS PRIVATE LIMITED",
"DEVRAJ LUXURY HOTELS PRIVATE LIMITED",
"DEVRAJ NENSEE JEWELLERS PRIVATE LIMITED",
"DEVRATH FROZEN & FOOD PRODUCTS PRIVATE LIMITED",
"DEVRATH TRADE LINK PRIVATE LIMITED",
"DEVRAYA INDUSTRIES PRIVATE LIMITED",
"DEVREV CLOUD INDIA PRIVATE LIMITED",
"DEVRISHI PAPERS PRIVATE LIMITED",
"DEVRITA EXPORTS PRIVATE LIMITED",
"DEVROOP REAL ESTATE PRIVATE LIMITED",
"DEVSAR AGRO PRODUCTS PRIVATE LIMITED",
"DEVSARAS STAINLESS PRIVATE LIMITED",
"DEVSARIA IMPEX PRIVATE LIMITED",
"DEVSARIA IRON & STEEL COMPANY PRIVATE LIMITED",
"DEVSARU DEVELOPERS & BUILDERS PRIVATE LIMITED",
"DEVSHAKTI FREE ELECTRIC PRIVATE LIMITED",
"DEVSHAR RETAIL PRIVATE LIMITED",
"DEVSHI EARTHMOVERS PRIVATE LIMITED",
"DEVSHILP INFRA PRIVATE LIMITED",
"DEVSHIV MEGACORP PRIVATE LIMITED",
"DEVSHREE INTERNATIONAL PRIVATE LIMITED",
"DEVSHREE SOLAR LIGHTS PRIVATE LIMITED",
"DEVSHRI AGROTECH PVT LTD",
"DEVSHYAM TRADING PRIVATE LIMITED",
"DEVSON CATALYST PRIVATE LIMITED",
"DEVSON IMPEX PRIVATE LIMITED",
"DEVSON PRESSTECH PRIVATE LIMITED",
"DEVSON PRIVATE LIMITED",
"DEVSON SWITCHGEAR AND CONTROLS PVT LTD",
"DEVSONS MEDITEX PRIVATE LIMITED",
"DEVSTREE I.T. SERVICES PRIVATE LIMITED",
"DEVSTRINGX TECHNOLOGY PRIVATE LIMITED",
"DEVSTUTI PROJECTS PRIVATE LIMITED",
"DEVSYNTHESIS INDIA PRIVATE LIMITED",
"DEVSYS EMBEDDED TECHNOLOGIES PRIVATE LIMITED",
"DEVTA APPARELS PRIVATE LIMITED",
"DEVTA GENSETS PRIVATE LIMITED",
"DEVTAA YASH LIFESCAPES PRIVATE LIMITED",
"DEVTARA INDUSTRIES",
"DEVTECH M2M LIMITED",
"DEVTECH PUBLISHERS AND PRINTERS PRIVATE LIMITED",
"DEVTRON LABS PRIVATE LIMITED",
"DEVU TOOLS PRIVATE LIMITED",
"DEVVENTURES PRIVATE LIMITED",
"DEVVRAT DEVELOPERS PRIVATE LIMITED",
"DEVVRAT IMPEX PVT LTD",
"DEVWINGS BUILDANGLE PRIVATE LIMITED",
"DEVYAM MEDICARE PRIVATE LIMITED",
"DEVYANI AIRPORT SERVICES MUMBAI PRIVATE LIMITED",
"DEVYANI FOOD INDUSTRIES LIMITED",
"DEVYANI FOOD STREET PRIVATE LIMITED",
"DEVYANI INTERNATIONAL LIMITED",
"DEVYOG COMMERCIAL LIMITED",
"DEVYOG IMPEX PRIVATE LIMITED",
"DEVYOG SOLUTIONS PRIVATE LIMITED",
"DEW DROPS ACADEMY",
"DEW DROPS LABORATORIES PRIVATE LIMITED",
"DEW EQUIPMENTS PRIVATE LIMITED",
"DEW FOAMS PRIVATE LIMITED",
"DEW INFO-SYSTEMS PRIVATE LIMITED",
"DEW POINT AIR MANAGEMENT SERVICES PRIVATE LIMITED",
"DEW POINT CONSULTANTS PRIVATE LIMITED",
"DEW POINT HVAC SYSTEM PRIVATE LIMITED",
"DEW POND ENGINEERS PRIVATE LIMITED",
"DEW SHREE NETWORK PRIVATE LIMITED",
"DEW SOLUTIONS PRIVATE LIMITED",
"DEW TEA PLANTATION PRIVATE LIMITED",
"DEW WATER ENGINEERS PRIVATE LIMITED",
"DEWA POLYMERS PRIVATE LIMITED",
"DEWA PROPERTIES LIMITED",
"DEWAKIPUR TEA PLANTATION PVT LTD",
"DEWAN AND SONS",
"DEWAN BAHADUR DR. V. VERGHESE HOSPITAL TRUST ASSOCIATION",
"DEWAN CONSULTANTS PRIVATE LIMITED",
"DEWAN FOURWHEELS PRIVATE LIMITED",
"DEWAN GROUP INFRAVENTURES PRIVATE LIMITED",
"DEWAN INSTITUTE OF MANAGEMENT STUDIES",
"DEWAN PACKAGING PRIVATE LIMITED",
"DEWAN RADIOS PRIVATE LIMITED",
"DEWAN STAFF FINDERS PRIVATE LIMITED",
"DEWAN SUGARS LIMITED",
"DEWAN TRAVELS PRIVATE LIMITED",
"DEWAN TYRES LIMITED",
"DEWANCHAND RAMSARAN CORPORATION PRIVATE LIMITED",
"DEWAR'S GARAGE LIMITED",
"DEWARS-GARAGE INSURANCE AGENCIES PRIVATE LIMITED",
"DEWAS AGRITECH PRIVATE LIMITED",
"DEWAS BHOPAL CORRIDOR PRIVATE LIMITED",
"DEWAS BYPASS TOLLWAY PRIVATE LIMITED",
"DEWAS DIAGNOSTICS PRIVATE LIMITED",
"DEWAS HYDROQUIP PVT LTD",
"DEWAS METAL SECTIONS LIMITED",
"DEWAS NAGAR NIGAM",
"DEWAS PRINCIPAL GOVT H.S PATADI DEWAS",
"DEWAS TECHNO PRODUCTS PVT LTD",
"DEWAS TRUCK OPERATORS PRIVATE LIMITED",
"DEWAS UJJAIN HIGHWAY PRIVATE LIMITED",
"DEWAS VIKAS PRADHIKARAN",
"DEWAS WATERPROJECTS WORKS PRIVATE LIMITED",
"DEWCARE CONCEPT PRIVATE LIMITED",
"DEWDROP BOTTLES PRIVATE LIMITED",
"DEWDROPS AGRITECH PRIVATE LIMITED",
"DEWDROPS MERCANTILES PVT LTD",
"DEWKI REALTORS PRIVATE LIMITED",
"DEWMEDIC HEALTHCARE PRIVATE LIMITED",
"DEWPOINT ENGINEERS PROJECTS PRIVATE LIMITED",
"DEWPURE ENGINEERING PRIVATE LIMITED",
"DEWS AIRCON PRIVATE LIMITED",
"DEWSOFT FABRICATION PRIVATE LIMITED",
"DEX AGRO SWEETENERS PRIVATE LIMITED",
"DEX AIR TRANSPORT PRIVATE LIMITED",
"DEX AVIATION PRIVATE LIMITED.",
"DEX CARGO SERVICES PRIVATE LIMITED",
"DEX ENTERPRISES PRIVATE LIMITED",
"DEXA CARE PRIVATE LIMITED",
"DEXBYTES INFOTECH PRIVATE LIMITED",
"DEXCEL ELECTRONICS DESIGNS PRIVATE LIMITED",
"DEXCISS TECHNOLOGY PRIVATE LIMITED",
"DEXLER ENERGY PRIVATE LIMITED",
"DEXLER INFORMATION SOLUTIONS PRIVATE LIMITED",
"DEXLOCK TECHNOLOGIES LLP",
"DEXNINJA PRIVATE LIMITED",
"DEXON ADVERTISING AND MARKETING PRIVATE LIMITED",
"DEXOVIT INTERNATIONAL PRIVATE LIMITED",
"DEXPRO LOGISTICS PRIVATE LIMITED",
"DEXTARA DIGITAL PRIVATE LIMITED",
"DEXTECH ALLIED PRIVATE LIMITED",
"DEXTER APPARELS PRIVATE LIMITED",
"DEXTER BIOCHEM PRIVATE LIMITED",
"DEXTER CONSULTANCY PRIVATE LIMITED",
"DEXTER RETAIL AND DISTRIBUTION PRIVATE LIMITED",
"DEXTER SYSTEMS PRIVATE LIMITED",
"DEXTEREOUS TRADE CONNECT PRIVATE LIMITED",
"DEXTERITY ANSATTE MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"DEXTERITY BUSINESS ANALYSTS PRIVATE LIMITED",
"DEXTERITY TECHSYS PRIVATE LIMITED",
"DEXTEROUS COLLECTION SERVICES PRIVATE LIMITED",
"DEXTEROUS DESIGNERS & ASSOCIATES PRIVATE LIMITED",
"DEXTEROUS DESSINS PROJECTS PRIVATE LIMITED",
"DEXTEROUS EDUTECH PRIVATE LIMITED",
"DEXTEROUS PRODUCTS PRIVATE LIMITED",
"DEXTEROUS SOLUTIONS LIMITED",
"DEXTEROUS STUDIO PRIVATE LIMITED",
"DEXTERS LOGISTICS PRIVATE LIMITED",
"DEXTRA INDIA PRIVATE LIMITED",
"DEXTRA SQUARE PRIVATE LIMITED",
"DEXTRAL CONSTRUCT INDIA PRIVATE LIMITED",
"DEXTRIS INFOSERVICES PRIVATE LIMITED",
"DEXTROUS FOREX PRIVATE LIMITED",
"DEXTROUS PACKAGING PRIVATE LIMITED",
"DEXUNE INDIA CEILING SYSTEM PRIVATE LIMITED",
"DEXUNE MARKETING PRIVATE LIMITED",
"DEY ' S COLD STORAGE PRIVATE LIMITED",
"DEY BROTHERS AUTOFUEL PVT LTD",
"DEY FOREX PRIVATE LIMITED",
"DEY LOGISTICS AND SERVICES PRIVATE LIMITED",
"DEY S MEDICAL (U P) PRIVATE LIMITED",
"DEY TECH SERVICES PRIVATE LIMITED",
"DEYAN GAS PRIVATE LIMITED",
"DEYS INDUSTRIAL DRIER PARBOILING PRIVATE LIMITED",
"DEY'S MEDICAL STORES MANUFACTURING LTD",
"DEY'S MEDICAL STORES PVT LTD",
"DEY'S MEDICO PVT LTD",
"DEZAN SHIRA CONSULTANCY SERVICES PRIVATE LIMITED",
"DEZINE COLLECTIONS PRIVATE LIMITED",
"DEZINEDISPLAY SOLUTIONS PRIVATE LIMITED",
"DEZIRE CLINIC PRIVATE LIMITED",
"DEZIRE JEWELS PRIVATE LIMITED",
"DEZLON INDUSTRIES PRIVATE LIMITED",
"DEZNCON INTERIORS PRIVATE LIMITED",
"DEZTINATION INSURANCE WEB AGGREGATORS PRIVATE LIMITED",
"DF FORGING LIMITED",
"DF PHARMACY LIMITED",
"DF POWER SYSTEMS PRIVATE LIMITED",
"DFA CONSULTANTS PRIVATE LIMITED",
"DFAB STAINLESS SYSTEM PRIVATE LIMITED",
"DFE PHARMA INDIA LLP",
"DFE PHARMA INDIA PRIVATE LIMITED",
"DFI ARCHITECTS PRIVATE LIMITED",
"DFL TECHNOLOGIES PRIVATE LIMITED",
"DFM FOODS LIMITED",
"DFM TECHNOLOGY PRIVATE LIMITED",
"DFMS FACILITY PRIVATE LIMITED",
"DFO DIVISION T DEWAS MADHYA PRADESH",
"DFO EAST TERRITIORIAL CHHINDWARA",
"DFO INDORE",
"DFO KHANDWA (G)",
"DFO PRODUCTION KHANDWA",
"DFO SATNA",
"DFO SOCIAL FORESTRY UJJAIN",
"DFO SOUTH PRODUCTION CHHINDWARA",
"DFO WEST DIVISION TERRITORIAL CHHINDWARA",
"DFO WORKING PLAN UJJAIN",
"D-FORCE SOLAR & ENERGY PRIVATE LIMITED",
"DFR DIRECTORATE OF FLORICULTURAL RESEARCH",
"DFRNT CLOTHING PRIVATE LIMITED",
"DFS AGRI FOODS PRIVATE LIMITED",
"DFS FACILITY & MANAGEMENT PRIVATE LIMITED",
"DFT HELP HUMANITY INTERNATIONAL FOUNDATION",
"DFURN MODULAR SYSTEMS PRIVATE LIMITED",
"DG BIM CONSULTING PRIVATE LIMITED",
"DG CORPORATION PRIVATE LIMITED",
"DG ESTATES PVT LTD",
"DG FUTURETECH INDIA PRIVATE LIMITED",
"DG GROWTH VENTURES PRIVATE LIMITED",
"DG KHETAN INTERNATIONAL SCHOOL",
"DG MICROPRONIX PVT LTD",
"DG MINERALS PRIVATE LIMITED",
"DG MOTORS PRIVATE LIMITED",
"DG PATEL KHANDHALIWALA VIDYALAYA",
"DG STICKERS PRIVATE LIMITED",
"DG VAISHNAV COLLEGE",
"DG4 PROGRAMMING PRIVATE LIMITED",
"DGAINS BHOOMI NIRMAAN LIMITED",
"DGAINS REALTY PRIVATE LIMITED",
"DGAMER PRIVATE LIMITED",
"DGAS SKYWORLD SMS TECHNOLOGY PRIVATE LIMITED",
"DGB CONSTRUCTIONS PRIVATE LIMITED",
"DGBUILDING MATERIAL SOLUTION PRIVATE LIMITED",
"DGC AUTOMOTIVE PRIVATE LIMITED",
"DGC ENGINEERING PRIVATE LIMITED",
"DGC INDUSTRIES PRIVATE LIMITED",
"DGC INFRASTRUCTURE PRIVATE LIMITED",
"DGEN TRANSMISSION COMPANY LIMITED",
"DGL HITECH PRIVATE LIMITED",
"DGL SHIPPING INDIA PRIVATE LIMITED",
"DGLIGER CONSULTING PRIVATE LIMITED",
"DGM AUTOMATION INDIA PRIVATE LIMITED",
"DGM FOODS PRIVATE LIMITED",
"DGM PROPERTY SOLUTIONS PRIVATE LIMITED",
"DGM TUBES PRIVATE LIMITED",
"DGM WATERSMITH'S CONSULTANCY PRIVATE LIMITED",
"DGMARKET INDIA PRIVATE LIMITED",
"DGN FASER PRIVATE LIMITED",
"DGN SERVICES PRIVATE LIMITED",
"DGN SKILLS AND MANAGEMENT PRIVATE LIMITED",
"DGNOTE TECHNOLOGIES PRIVATE LIMITED",
"DGP INTELSIUS COLD CHAIN PRIVATE LIMITED",
"DGP SECURITIES LIMITED",
"DGP STEEL STAR ENGINEERING PRIVATE LIMITED",
"D-G-R- PACKAGING PRIVATE LIMITED",
"DGRAPH LABS INDIA PRIVATE LIMITED",
"DGS NETMAGIC PRIVATE LIMITED",
"DGS REALTORS PRIVATE LIMITED",
"DGS TECHNICAL SERVICES PRIVATE LIMITED",
"DGS TOURS AND TRAVELS PRIVATE.LIMITED",
"DGS TOWNSHIP PRIVATE LIMITED",
"DGS TRANSLOGISTICS INDIA PRIVATE LIMITED",
"DGSHEETMETAL SERVICES PRIVATE LIMITED",
"DGSM FOOD PRIVATE LIMITED",
"DGTECH ELECTRONICS PRIVATE LIMITED",
"DGTG MARKETING & RETAIL PRIVATE LIMITED",
"DGTL MEDIA PRIVATE LIMITED",
"DGTRA CONSULTANCY PRIVATE LIMITED",
"DGX LOGISTICS INDIA PRIVATE LIMITED",
"DH ARCHITECTURE STUDIO PRIVATE LIMITED",
"DH BENITA STORE PRIVATE LIMITED",
"DH BUILDMATE PRIVATE LIMITED",
"DH HEALTHCARE SOFTWARE SERVICES INDIA PRIVATE LIMITED",
"DH LIGHTING INDIA PRIVATE LIMITED",
"DH LIMITED",
"DH MAINTENANCE LIMITED",
"DH MOBILE PRIVATE LIMITED",
"DH PRINTPACK PRIVATE LIMITED",
"DH QUICKFIN PRIVATE LIMITED",
"DHA TEKHNO PRIVATE LIMITED",
"DHAAN ISPAT PRIVATE LIMITED",
"DHABRIYA POLYWOOD LIMITED",
"DHADDA DIAMONDS PRIVATE LIMITED",
"DHADIWAL HOSPITAL & RESEARCH CENTER PRIVATE LIMITED",
"DHADKA NARAYAN CHANDRA LAHIRI VIDYAMANDIR HS",
"DHAGA GHAR THREADS PRIVATE LIMITED",
"DHAI STEP MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"DHAIRYA IT ADVISORY PRIVATE LIMITED",
"DHAIRYAM GUAR GUM INDUSTRIES PRIVATE LIMITED",
"DHAJA RAM GULAB CHAND TRADING PRIVATE LIMITED",
"DHAKAD FASHION PRIVATE LIMITED",
"DHAKAD FOREX PRIVATE LIMITED",
"DHAKAD HOTEL AND ENTERTAINMENT PRIVATE LIMITED",
"DHAKAD PROPERTIES PRIVATE LIMITED",
"DHAKALIA INVESTMENTS LTD",
"DHAKSHA UNMANNED SYSTEMS PRIVATE LIMITED",
"DHAKSHAN TEXTILES PRIVATE LIMITED",
"DHAKSHAYASRI STORE PRIVATE LIMITED",
"DHAKSHHIN ASTC PRIVATE LIMITED",
"DHAKSHITHA SOLVENT EXTRACTIONS PRIVATE LIMITED",
"DHALIWAL-SOBTI SUGAR & CHEMICAL INDUSTRIES PRIVATE LIMITED",
"DHALL ENTERPRISES AND ENGINEERS PRIVATE LIMITED",
"DHALL FOODS AND BEVERAGES PRIVATE LIMITED",
"DHALLSON CYCLES (INDIA) PVT LTD",
"DHALOP CHEMICALS PRIVATE LIMITED",
"DHAM CONSULTANTS PRIVATE LIMITED",
"DHAMA BUILD CON PRIVATE LIMITED",
"DHAMA INNOVATIONS PRIVATE LIMITED",
"DHAMANI TRADELINKS PRIVATE LIMITED",
"DHAMI EYE CARE HOSPITAL",
"DHAMI ROADWAYS P LTD",
"DHAMIJA FINANCE AND LEASING LIMITED",
"DHAMIJA GRINDERS PRIVATE LIMITED",
"DHAMM STEEL SERVICES PRIVATE LIMITED",
"DHAMMANAGI DEVELOPERS PRIVATE LIMITED",
"DHAMOVES VENTURES PRIVATE LIMITED",
"DHAMPUR ALCO-CHEM PRIVATE LIMITED",
"DHAMPUR SUGAR MILLS LIMITED",
"DHAMPURE SPECIALITY SUGARS LIMITED",
"DHAMRA PORT COMPANY LIMITED SENIOR LT DEBT",
"DHAMSONS HEALTHCARE PRIVATE LIMITED",
"DHAMUA BALIKA VIDYALAYA",
"DHAN CHANDRA RETAIL PRIVATE LIMITED",
"DHAN COMMERCIAL PRIVATE LIMITED",
"DHAN GURU TEG BAHADUR SYNTHETICS (OPC) PRIVATE LIMITED",
"DHAN HANS FABRICS PVT LTD",
"DHAN LAMINATES PRIVATE LIMITED",
"DHAN LOGISTICS PRIVATE LIMITED",
"DHAN STEELS PRIVATE. LIMITED.",
"DHAN STOCK AND SHARE BROKERS PRIVATE LIMITED",
"DHAN TECHNOLOGY LABS INDIA PRIVATE LIMITED",
"DHANA CAPITAL AND FINANCE LIMITED",
"DHANA CHIT FUND PRIVATE LIMITED",
"DHANA CROP SCIENCES LIMITED",
"DHANA LAKSHMI PRIVATE LIMITED",
"DHANA LAXMI COTTON INDUSTRIES",
"DHANA RATHNA INFRA PRIVATE LIMITED",
"DHANA RICE MILLS PRIVATE LIMITED",
"DHANACHAKRA LEASING AND HIREPURCHASE COMPANY PRIVATE LIMITED",
"DHANADA CORPORATION LIMITED",
"DHANADAYEE SALES AND SERVICES PVT LTD",
"DHANAJAY PACKAGING",
"DHANALAKSHMI AUTOMOTIVES INDIA PRIVATE LIMITED",
"DHANALAKSHMI AUTOZONE INDIA PRIVATE LIMITED",
"DHANALAKSHMI COLLEGE OF ENGINEERING",
"DHANALAKSHMI HIREPURCHASE AND LEASING LIMITED",
"DHANALAKSHMI OFFSET PRINTER",
"DHANALAKSHMI SEEDS PRIVATE LIMITED",
"DHANALAKSHMI SRINIVASAN CHIT FUNDS PRIVATE LIMITED",
"DHANALAKSHMI SRINIVASAN ENGINEERING COLLEGE",
"DHANALAKSHMI SRINIVASAN HOTELS PRIVATE LIMITED",
"DHANALAKSHMI SRINIVASAN INSTITUTE OF TECHNOLOGY",
"DHANALAKSHMI SRINIVASAN MATRICULATION HR SEC SCHOOL",
"DHANALAKSHMI SRINIVASAN MEDICAL COLLEGE AND HOSPITAL",
"DHANALAKSHMI SRINIVASAN SUGARS PRIVATE LIMITED",
"DHANALAKSHMI SYNTHETICS PRIVATE. LIMITED.",
"DHANALAKSHMI WEAVING WORKS (KANNUR) PRIVATE LIMITED",
"DHANALAXMI DYEING AND PRINTING MILLS PVT LTD",
"DHANALAXMI HOUSING INVESTMENTS AND CHITS PVT LTD",
"DHANALAXMI JEWELLERS (INDIA) PRIVATE LIMITED",
"DHANALAXMI MOTORS FINANCE PRIVATE LIMITED",
"DHANALAXMI PRE ENGINEERED BUILDING SOLUTIONS PRIVATE LIMITED",
"DHANALAXMI ROTO SPINNERS LIMITED",
"DHANAM PUBLICATIONS PRIVATE LIMITED",
"DHANANI AUTO PRIVATE LIMITED",
"DHANANI DIAMONDS PRIVATE LIMITED",
"DHANANI SHOES PRIVATE LIMITED",
"DHANANJAI EQUIPMENTS PVT LTD",
"DHANANJAI LIFESTYLE LIMITED",
"DHANANJAY AUTO CRAFT PRIVATE LIMITED",
"DHANANJAY CONFECTIONERIES PVT LTD",
"DHANANJAY CONSTRUCTION PRIVATE LIMITED",
"DHANANJAY INDUSTRIAL ENGINEER PRIVATE LIMITED",
"DHANANJAY METAL CRAFT PRIVATE LIMITED",
"DHANANJAY ROADWAYS PRIVATE LIMITED",
"DHANANJAY TREXIM PVT LTD",
"DHANANJAYA OVERSEAS PRIVATE LIMITED",
"DHANANJAYRAO GADGIL INSTITUTE OF CO -OPERATIVE MANAGEMENT NAGP",
"DHANARA CHEMICALS PRIVATE LIMITED",
"DHANARAJAN JAYARAMACHANDRAN",
"DHANASHREE AGRO INDUSTRIES",
"DHANASHREE ELECTRONICS LIMITED",
"DHANASHREE HOSPITALITY SERVICE",
"DHANASHREE INDUSTRIES",
"DHANASHREE INSTITUTE OF ENGINEERING AND TECHNOLOGY",
"DHANASHREE INVESTMENTS PRIVATE LIMITED",
"DHANASHREE TECHNOCRATS PRIVATE LIMITED",
"DHANASVI ALUMINIUM PRIVATE LIMITED",
"DHANBAD CLUB LIMITED",
"DHANBAD COLD STORAGE PRIVATE LIMITED",
"DHANBAD FUELS PRIVATE LIMITED",
"DHANBAD INTEGRATED MSW LIMITED",
"DHANBAD ROCK WOOL INSULATION PRIVATE LIMITED",
"DHANCOT FIBRES PRIVATE LIMITED",
"DHAND ENTERPRISES PRIVATE LIMITED",
"DHANDA BREEDING FARM PRIVATE LIMITED",
"DHANDAPANI CEMENTS PRIVATE. LIMITED.",
"DHANDAPANI SPINNING MILLS LIMITED",
"DHANDAPANI STEEL PRIVATE. LIMITED.",
"DHANDAYUTHAPANI FOUNDRY PRIVATE LIMITED",
"DHANDE PATHLAB DIAGNOSTICS PRIVATE LIMITED",
"DHANDHANIA INFOTECH PRIVATE LIMITED",
"DHANDI BUILDERS LIMITED.",
"DHANDU INFRASTRUCTURE PRIVATE LIMITED",
"DHANEKULA COLD STORAGE PRIVATE LIMITED",
"DHANEKULA INSTITUTE OF ENGINEERING & TECHNOLOGY",
"DHANERA DIAMONDS",
"DHANERA TEXCHEM PRIVATE LIMITED",
"DHANES LOGISTICS PRIVATE LIMITED",
"DHANESH WEAVING PRIVATE LIMITED",
"DHANESHWARI COLLEGE OF PHYSIOTHERAPY",
"DHANGAR CONSTRUCTIONS PRIVATE LIMITED",
"DHANGHAR TRADELINKS PRIVATE LIMITED",
"DHANGRA HOTELS & BEACH RESORTS PRIVATE LIMITED",
"DHANI HEALTHCARE LIMITED",
"DHANI LOANS AND SERVICES LIMITED",
"DHANI RAM INFRAPROJECTS PRIVATE LIMITED",
"DHANI RAYON PRIVATE LIMITED",
"DHANI SERVICES LIMITED",
"DHANI STOCKS LIMITED",
"DHANIAKHALI AGRO PRODUCTS PRIVATE LIMITED",
"DHANIK FOOD & BEVERAGES PRIVATE LIMITED",
"DHANIKA NIDHI LIMITED",
"DHANIKUBERJI ASSOCIATES PRIVATE LIMITED",
"DHANISH MATRIC HR SEC SCHOOL",
"DHANJAL ENGINEERS PRIVATE LTD",
"DHANJAL IMPEX PRIVATE LIMITED",
"DHANJIWADI PRATHMIK SHALA",
"DHANKALASH DISTRIBUTORS PRIVATE LIMITED",
"DHANKI SECURITIES PRIVATE LIMITED",
"DHANKOT ENGINEERING PRIVATE LIMITED",
"DHANLABH ENGINEERING WORKS PRIVATE LIMITED",
"DHANLABH STEEL SUPPLIERS PRIVATE LIMITED",
"DHANLABH TRADING PRIVATE LIMITED",
"DHANLAKSHMI BIOCHEM PRIVATE LIMITED",
"DHANLAKSHMI BUILDING DEVELOPMENT PRIVATE LIMITED",
"DHANLAKSHMI PACKAGING INDUSTRIES PRIVATE LIMITED",
"DHANLAV FOREX PRIVATE LIMITED",
"DHANLAXMI AGROMILLS INDIA PRIVATE LIMITED",
"DHANLAXMI BANK",
"DHANLAXMI BOARD AND PAPERS PRIVATE LIMITED",
"DHANLAXMI CONSTRUCTIONS PRIVATE LIMITED",
"DHANLAXMI COTEX LIMITED",
"DHANLAXMI CROP SCIENCE LIMITED",
"DHANLAXMI DYEING AND PRINTING MILLS PVT LTD",
"DHANLAXMI EDIBLES PRIVATE LIMITED",
"DHANLAXMI ELECTRICALS PRIVATE LIMITED",
"DHANLAXMI EQUIPMENTS PRIVATE LIMITED",
"DHANLAXMI FABCOM PRIVATE LIMITED",
"DHANLAXMI INDUSTRIES",
"DHANLAXMI IRON INDUSTRIES PRIVATE LIMITED",
"DHANLAXMI IT SERVICES PRIVATE LIMITED",
"DHANLAXMI MERCHANDISE PRIVATE LIMITED",
"DHANLAXMI MINARETS PRIVATE LIMITED",
"DHANLAXMI PIGMENTS PRIVATE LIMITED",
"DHANLAXMI SAFE PRIVATE LIMITED",
"DHANLAXMI SAREES PRIVATE LIMITED",
"DHANLAXMI TEXTO FAB PRIVATE LIMITED",
"DHANLAXMI TIEUP PRIVATE LIMITED",
"DHANLAXMI TRADERS",
"DHANLAXMI VIDYUT PRIVATE LIMITED",
"DHANLUXMI JEWELLERS PRIVATE LIMITED",
"DHANMATA REALTY PRIVATE LIMITED",
"DHANOL INFRAPROJECT PRIVATE LIMITED",
"DHANPAATRA CAPITAL PRIVATE LIMITED",
"DHANPAT RAI PUBLISHING CO. PVT LTD",
"DHANPATI DYETEX PRIVATE LIMITED",
"DHANPATI POLYPRODUCTS PRIVATE LIMITED",
"DHANPRIYA PRINTS PRIVATE LIMITED",
"DHANPRIYA SYNTHETICS PRIVATE LIMITED",
"DHANRAAJ AGENCIES PRIVATE LIMITED",
"DHANRAJ BAID JAIN COLLEGE",
"DHANRAJ FOODS PRIVATE LIMITED",
"DHANRAJ FOREX PRIVATE LIMITED",
"DHANRAJ GLOBAL CORPORATION PRIVATE LIMITED",
"DHANRAJ HOSPITALITY AND SERVICES PRIVATE LIMITED",
"DHANRAJ JEWELLERS",
"DHANRAJ NEWS AND MEDIA PRIVATE LIMITED",
"DHANRAJ ORGANIC PVT LTD",
"DHANRAJ POWER PRIVATE LIMITED",
"DHANRAJ SOLVEX PRIVATE LIMITED",
"DHANRAJ SUGARS PRIVATE LIMITED",
"DHANRAJ SWITCHGEARS PRIVATE LIMITED",
"DHANSAKTI SUPPLIERS PRIVATE LIMITED",
"DHANSAMRIDHI FINANCE PRIVATE LIMITED",
"DHANSAR CAPITAL LIMITED",
"DHANSAR ENGINEERING COMPANY PRIVATE LIMITED",
"DHANSAR EQUIPMENT PRIVATE LIMITED",
"DHANSHREE FABRICS PRIVATE LIMITED",
"DHANSHREE FASHIONS PRIVATE LIMITED",
"DHANSHREE JEWELLERS PRIVATE LIMITED",
"DHANSINGH KHETSHI",
"DHANSIRI TEA PRIVATE LIMITED",
"DHANSRI AUTO-VENTURES PRIVATE LIMITED",
"DHANSRI ESTATES PRIVATE LIMITED",
"DHANSRI KRAFT PAPERS PRIVATE LIMITED",
"DHANSRI STEELS PVT LTD",
"DHANSU ENGINEERING PRIVATE LIMITED",
"DHANSUBH COMPLEX PRIVATE LIMITED",
"DHANTERASH SUPPLIERS PRIVATE LIMITED",
"DHANTHAK SOAPS PRIVATE LIMITED",
"DHANTURI GROUP OF HOTELS PRIVATE LIMITED",
"DHANUKA AGRITECH LIMITED",
"DHANUKA COLD STORAGE PRIVATE LIMITED",
"DHANUKA ELECTROTECH PRIVATE LIMITED",
"DHANUKA ENTERPRISES PRIVATE LIMITED",
"DHANUKA EXTRACTIONS PRIVATE LIMITED",
"DHANUKA LABORATORIES LIMITED",
"DHANUKA MARBLES PRIVATE LIMITED",
"DHANUKA REALTY LIMITED",
"DHANUKA SOYA PRIVATE LIMITED",
"DHANUKA UDYOG PRIVATE LIMITED",
"DHANUKA YARN PRIVATE LIMITED",
"DHANUNJAYA LODGING HOUSE PRIVATE LIMITED",
"DHANUNJAYA SERVICES",
"DHANUSH ENGGSERVICES INDIA PRIVATE LIMITED",
"DHANUSH HEALTHCARE SYSTEMS PRIVATE LIMITED",
"DHANUSH INFOSOL PRIVATE LIMITED",
"DHANUSH LOGISTICS PRIVATE LIMITED",
"DHANUSHREE TEXPRO LIMITED",
"DHANUSHRI COTTEX PRIVATE LIMITED",
"DHANVANTARI HOSPITAL PRIVATE LIMITED",
"DHANVANTARI MEDICINE & EQUIPMENTS PRIVATE LIMITED",
"DHANVANTARI NANO AYUSHADI PRIVATE LIMITED",
"DHANVANTARI TARAI SEEDS PRIVATE LIMITED",
"DHANVANTHRI ENGINEERS PVT LTD",
"DHANVANTHRI SPECIALITY PHARMA PRIVATE LIMITED",
"DHANVANTRI JEEVAN REKHA LIMITED",
"DHANVANTRI LABORATORIES LIMITED",
"DHANVARSHA COT-TEX PRIVATE LIMITED",
"DHANVARSHA ENTERPRISES & INVESTMENTS PRIVATE LIMITED",
"DHANVARSHA OIL MILLS PRIVATE LIMITED",
"DHANVATE NATIONAL COLLEGE",
"DHANVEEN PIGMENTS PRIVATE LIMITED",
"DHANVEER TOURS AND TRAVELS PRIVATE LIMITED",
"DHANVI AGRI GENETICS PRIVATE LIMITED",
"DHANVI PROJECTS PRIVATE LIMITED",
"DHANVI VENTURES INDIA PRIVATE LIMITED",
"DHANVIJAY TECHNOLOGIES PRIVATE LIMITED",
"DHANVIR FOOD PRODUCTS",
"DHANVRIDHI POLYFABS PRIVATE LIMITED",
"DHANWANTARI DISTRIBUTORS PRIVATE LIMITED",
"DHANWANTARI HOSPITAL",
"DHANWANTARY MEDICARE & RESEARCH CENTRE PRIVATE LIMITED",
"DHANWANTHARI AYURVEDA BHAVAN PRIVATE LIMITED",
"DHANWANTHARI HEALTH AND WELLNESS SOLUTIONS PRIVATE LIMITED",
"DHANWANTRE COLLEGE OF NAGPUR",
"DHANWANTRI NATURAL HERBS CARE PRIVATE LIMITED",
"DHANWARIA INVESTMENTS PRIVATE LIMITED",
"DHANWARSHA REAL ESTATES PRIVATE LIMITED",
"DHANYA AGRO FARMS PRIVATE LIMITED",
"DHANYA BAZAAR PRIVATE LIMITED",
"DHANYA CONSUMERS P LTD",
"DHANYA INDRANI TRADECOM PRIVATE LIMITED",
"DHANYA PLASTICS & FOAMS PRIVATE LIMITED",
"DHANYA PROMOTERS PRIVATE LIMITED",
"DHANYAM SUPERSTORES PRIVATE LIMITED",
"DHAR AUTOMOTIVES PRIVATE LIMITED",
"DHAR COAL PRODUCTS PRIVATE LIMITED",
"DHAR CONSTRUCTION COMPANY",
"DHAR POLYTECHNIC MAHAVIDYALAYA",
"DHAR TOUR & TRAVELS PRIVATE LIMITED",
"DHARA CEMENTS (INDIA) PRIVATE LIMITED",
"DHARA COLOURCHEM PRIVATE LIMITED",
"DHARA ENG CONSULTANTS PRIVATE LIMITED",
"DHARA ENTERPRISE",
"DHARA FOODS PRIVATE LIMITED",
"DHARA INDIA PRIVATE LIMITED",
"DHARA INFRA PROJECTS PRIVATE LIMITED",
"DHARA LIFESCIENCE PRIVATE LIMITED",
"DHARA MOTOR FINANCE LIMITED",
"DHARA PAVITRAM PRIVATE LIMITED",
"DHARA RAIL PROJECTS PRIVATE LIMITED",
"DHARA THREADS PRIVATE LIMITED",
"DHARAA PRECISIONS PRIVATE LIMITED",
"DHARAH MARINE AGENCIES PRIVATE LIMITED",
"DHARAM BHAGWATI CONTAINERS PRIVATE LIMITED",
"DHARAM BHAGWATI FORGE PRIVATE LIMITED",
"DHARAM BHAGWATI STEEL PRIVATE LIMITED",
"DHARAM BIOTECH PRIVATE LIMITED",
"DHARAM CHAND DWARKA DAS STEELS PRIVATE LIMITED",
"DHARAM CHAND ULTRACHEM PRIVATE LIMITED",
"DHARAM CREATION PRIVATE LIMITED",
"DHARAM DIGITAL PRIVATE LIMITED",
"DHARAM ENGINEERING PRIVATE LIMITED",
"DHARAM EXPORT (INDIA) PRIVATE LIMITED",
"DHARAM HINDUJA MATRICULATION HIGHER SECONDARY SCHOOL",
"DHARAM JEWELLERS PRIVATE LIMITED",
"DHARAM NAGAR TEA ESTATE PRIVATE LIMITED",
"DHARAM PAL PREM CHAND LTD",
"DHARAM POWERTRANSMISSION EQUIPMENTS PRIVATE LIMITED",
"DHARAM SAI INFRASTRUCTURE & MARKETING INDIA PRIVATE LIMITED",
"DHARAM SAMAJ INTER COLLEGE ALIGARH",
"DHARAM STAINLESS STEEL PRIVATE LIMITED",
"DHARAM SYNTHETICS LTD",
"DHARAMA MOBITEL INDUSTRIES PRIVATE LIMITED",
"DHARAMABAD AGRO PRODUCER COMPANY LIMITED",
"DHARAMBIR MANOHARLAL PRIVATE LIMITED",
"DHARAMBIR MANOHARLAL PROPERTIES PRIVATE LIMITED",
"DHARAMDASS COMMODITIES PRIVATE LIMITED",
"DHARAMJYOT ENGINEERS AND FABRICATORS PRIVATE LIMITED",
"DHARAMPAL PIPE & TUBES PRIVATE LIMITED",
"DHARAMPAL PREMCHAND LIMITED",
"DHARAMPAL SATYAPAL FOODS LIMITED",
"DHARAMPAL SATYAPAL LIMITED",
"DHARAMPAL SATYAPAL SONS PRIVATE LIMITED",
"DHARAMPETH COLLEGE",
"DHARAMPETH M P DEO SMRUTI SCINECE COLLE",
"DHARAMRAJ CONTRACTS INDIA PRIVATE LIMITED",
"DHARAMRAJ ENERGY PRIVATE LIMITED",
"DHARAMRAJ JEWELLERS",
"DHARAMSHALA ROPEWAY LIMITED",
"DHARAMSHI SECURITIES PRIVATE LIMITED",
"DHARAMSHILA BELTING PRIVATE LIMITED",
"DHARAMSHILA NARAYANA SUPERSPECIALITY HOSPITAL",
"DHARAMSHREE AUTOMOBILES PRIVATE LIMITED",
"DHARAMSONS MARKETING PRIVATE LIMITED",
"DHARAMSONS PROCESSORS PRIVATE LIMITED",
"DHARAMVIR AYURVEDA PRIVATE LIMITED",
"DHARAN CANCER SPECIALITY CENTRE PRIVATE LIMITED",
"DHARAN HOSPITAL",
"DHARAN NURSING COLLEGE",
"DHARAN REALTORS INFRAPROJECTS PRIVATE LIMITED",
"DHARANI DEVELOPERS PRIVATE LIMITED",
"DHARANI HEALTHCARE SERVICES PRIVATE LIMITED",
"DHARANI HI-TECH PROJECTS PRIVATE LIMITED",
"DHARANI INFO TECHNOLOGIES PRIVATE LIMITED",
"DHARANI INFRADEVELOPERS PRIVATE LIMITED",
"DHARANI KRISHNA ENTERPRISES PRIVATE LIMITED",
"DHARANI PIPES PRIVATE LIMITED",
"DHARANI TEXTILES PRIVATE LIMITED",
"DHARANI TURBO ENGINEERING SPARES & SERVICES PRIVATE LIMITED",
"DHARANIDARA SPINNING MILLS PRIVATE LIMITED",
"DHARANII COTTON MILLS PRIVATE LIMITED",
"DHARANVANTH JR DEGREE COLLEGE",
"DHARAP FLEXO PLAST PRIVATE LIMITED",
"DHARAPATI DISTRIBUTORS LIMITED",
"DHARASHIV FOOTWEAR PRIVATE LIMITED",
"DHARASHIV SAKHAR KARKHANA LIMITED",
"DHARATAL GREENS PRIVATE LIMITED",
"DHARATI AGRO-PROTIENS PRIVATE LIMITED",
"DHARATI JANSEVA PRATISHTHAN COLLEGE OF EDUCATION",
"DHARATI PACKAGING PRIVATE LIMITED",
"DHARAV HIGH SCHOOL",
"DHARESHWAR COTTON PRIVATE LIMITED",
"DHARESHWAR GINNING INDUSTRIES",
"DHARESHWAR SHIKSHANSHASTRA MAHAVIDYALAYA",
"DHARGALKAR TECHNOESIS (INDIA) PRIVATE LIMITED",
"DHARIA SWITCHGEARS AND CONTROLS PRIVATE LIMITED",
"DHARINI PORTFOLIOS PRIVATE LIMITED",
"DHARINI RUBBER PRIVATE LIMITED",
"DHARITREE ASSOCIATES PRIVATE LIMITED",
"DHARITRI SEEDS & INPUTS (INDIA) LIMITED",
"DHARIWAL AND CHHORIYA BUILDCON PRIVATE LIMITED",
"DHARIWAL BUILDTECH LIMITED",
"DHARIWAL DEVELOPERS (INDIA) PRIVATE LIMITED",
"DHARIWAL INDUSTRIES PRIVATE LIMITED",
"DHARIWAL INFRASTRUCTURE LIMITED",
"DHARIWAL STEEL PVT LTD",
"DHARIWAL TRADERS PRIVATE LIMITED",
"DHARIWALCORP PRIVATE LIMITED",
"DHARIYA CONSTRUCTION PRIVATE LIMITED",
"DHARIYA INFRASTRUCTURE DEVELOPMENT PRIVATE LIMITED",
"DHARIYA TEXTILE PRIVATE LIMITED",
"DHARIYAL POLYMERS PVT LTD",
"DHARM GROUP LIMITED",
"DHARM REALTECH PRIVATE LIMITED",
"DHARMA AYURVEDA COLLEGE & MEDIACAL HOSPI",
"DHARMA BODKI DIAM PRIVATE LIMITED",
"DHARMA CORPORATION",
"DHARMA INFRAPROJECTS PRIVATE LIMITED",
"DHARMA LUBES PRIVATE LIMITED",
"DHARMA NATH CONSTRUCTION PRIVATE LIMITED",
"DHARMA ORGANIC PRIVATE LIMITED",
"DHARMA PRODUCTIONS PRIVATE LIMITED",
"DHARMA RAJ RICE MILL PRIVATE LIMITED",
"DHARMA SYSTEMS PRIVATE LIMITED",
"DHARMADHIKARI ENTERPRISES PRIVATE LIMITED",
"DHARMAJ CROP GUARD LIMITED",
"DHARMAMURTHI RAO BAHADUR CALAVALA CUNNAN CHETTY HINDU COLLEGE",
"DHARMAMURTHI RAO BHAHADUR CALAVALA CUNNAN CHETTY'S HINDU COLLEGE",
"DHARMANA MOTORS PRIVATE LIMITED",
"DHARMANAGAR VIDHYALAYA",
"DHARMANANDAN DIAMONDS PRIVATE LIMITED",
"DHARMANANDAN TECHNOCAST PRIVATE LIMITED",
"DHARMANANDAN TECHNOPROJECTS PRIVATE LIMITED",
"DHARMANATH COMMERCIAL TRADE PRIVATE LIMITED",
"DHARMARAJ AUTOMOBILES PRIVATE LIMITED",
"DHARMARAJ COLD STORAGE PRIVATE LIMITED",
"DHARMARAJ MOTORS PRIVATE LIMITED",
"DHARMARAJ RICE MILL PRIVATE LIMITED",
"DHARMARATHINA TEXTILE PRIVATE LIMITED",
"DHARMASHAKTI KISAN AGRO PRODUCER COMPANY LIMITED",
"DHARMATIC ENTERTAINMENT PRIVATE LIMITED",
"DHARMAVEERPAUL ENTERPRISES PRIVATE LIMITED",
"DHARMAYUG INVESTMENTS LTD",
"DHARMDEEP COMMODITIES PRIVATE LIMITED",
"DHARMENDRA GUPTA ASSOCIATES PRIVATE LIMITED",
"DHARMESH CONSTRUCTIONS PRIVATE LIMITED",
"DHARMESH FABRICS PRIVATE LIMITED",
"DHARMESH FOOD PROCESS PRIVATE LIMITED",
"DHARMESH JEWELLERS PRIVATE LIMITED",
"DHARMESH SILK MILLS PRIVATE LIMITED",
"DHARMESH STOCK BROKING PRIVATE LIMITED",
"DHARMESH TEXTILES LIMITED",
"DHARMI PROPERTIES PRIVATE LIMITED",
"DHARMIC LIVING PRIVATE LIMITED",
"DHARMIK DIAMONDS INDIA PRIVATE LIMITED",
"DHARMIK EXPORTS PRIVATE LIMITED",
"DHARMIK GEMS PRIVATE LIMITED",
"DHARMIK MEDIA AND ADVERTISING PRIVATE LIMITED",
"DHARMJIVAN OIL CAKE PRIVATE LIMITED",
"DHARMLOK INDUSTRIES",
"DHARMNANDAN POLY FAB PRIVATE LIMITED",
"DHARMPAL PREMCHAND LIMITED",
"DHARMRAJ ENTERPRISE PRIVATE LIMITED",
"DHARMRAJ LOGISTICS INDIA PRIVATE LIMITED",
"DHARMSHALA HYDRO POWER LIMITED",
"DHARMSHIL INDUSTRIES PRIVATE LIMITED",
"DHARMSINH DESAI UNIVERSITY",
"DHARMSONS SILK MILLS PRIVATE LIMITED",
"DHARMYA BUSINESS VENTURES PRIVATE LIMITED",
"DHARNEESH GOLD PRIVATE LIMITED",
"DHARNENDRA STEELMET PRIVATE LIMITED",
"DHARNI CAPITAL SERVICES LIMITED",
"DHARNI SAMPDA PRIVATE LIMITED",
"DHARNIDHAR TRADING PVT LTD",
"DHARNIDHAR VASTU DESIGNERS AND DEVELOPERS PRIVATE LIMITED",
"DHAROYA PHARMACIUTICALES PVT LTD",
"DHARPAT CASTING PRIVATE LIMITED",
"DHARRANEE AND CO",
"DHARSAN DREDGING AND CONSTRUCTIONS PRIVATE LIMITED",
"DHARSHINI ENGINEERING PRIVATE LIMITED",
"DHARTHI SUSTAINABLES PRIVATE LIMITED",
"DHARTI AGRO CHEMICALS PRIVATE LIMITED",
"DHARTI ASSOCIATES PRIVATE LIMITED",
"DHARTI AUTOMATIVE PRIVATE LIMITED",
"DHARTI COMMERCIAL TRADING PRIVATE LIMITED",
"DHARTI COTSPIN PRIVATE LIMITED",
"DHARTI DHAN MARBLE PRIVATE LIMITED",
"DHARTI FOOD PRODUCTS PRIVATE LIMITED",
"DHARTI INDUSTRIES PRIVATE LIMITED",
"DHARTI JV",
"DHARTI KRUSHI SANVARDHAN PRIVATE LIMITED",
"DHARTI MINERALS PRIVATE LIMITED",
"DHARTI MINES PRIVATE LIMITED",
"DHARTI PAPIER (INDIA) LLP",
"DHARTI REALTY PRIVATE LIMITED",
"DHARTI REFRACTORY MINERALS PRIVATE LIMITED",
"DHARTI SPINNING MILL PRIVATE LIMITED",
"DHARTIVARSHA ESTATE HOLDERS PRIVATE LIMITED",
"DHARUHERA PHARMACEUTICALS PRIVATE LIMITED",
"DHARVIK INFRASTRUCTURES PRIVATE LIMITED",
"DHARWAD BIG MISHRA PEDHA PRIVATE LIMITED",
"DHARWAD MISHRA PEDHA & FOOD PROCESSING INDUSTRY",
"DHASH POLYMER TECHNOLOGIES PRIVATE LIMITED",
"DHASH PV TECHNOLOGIES PRIVATE LIMITED",
"DHATARWAL CONSTRUCTION COMPANY PRIVATE LIMITED",
"DHATHRI AYURKENDRA (INDIA) PRIVATE LIMITED",
"DHATHRI AYURVEDA PRIVATE LIMITED",
"DHATHU NIRMAN PRIVATE LIMITED",
"DHATRE UDYOG LIMITED",
"DHATRI INFO SOLUTIONS PRIVATE LIMITED",
"DHATRIINFO SOLUTIONS PRIVATE LIMITED",
"DHATSOL IT SOLUTIONS PRIVATE LIMITED",
"DHATU ORGANICS AND NATURALS PRIVATE LIMITED",
"DHATVIK INDIA PRIVATE LIMITED",
"DHATYA CONSULTING SERVICES PRIVATE LIMITED",
"DHAULADHAR BUILDERS PRIVATE LIMITED",
"DHAULADHAR CEMENTS PRIVATE LIMITED",
"DHAULAGIREE POLYOLEFINS PRIVATE LIMITED",
"DHAULAGIRI POLY ADDITIVES PRIVATE LIMITED",
"DHAVAL AGRI EXPORTS",
"DHAVAL COLOUR CHEM PRIVATE LIMITED",
"DHAVAL DENTAL LAB",
"DHAVAL ELECTRICALS PRIVATE LIMITED",
"DHAVAL PACKAGING PRIVATE LIMITED",
"DHAVDI SONS PRIVATE LIMITED",
"DHAVIT GLOBAL LIFE SCIENCES PRIVATE LIMITED",
"DHAWAL FAB PRIVATE LIMITED",
"DHAWALA ONLINE SOLUTIONS PRIVATE LIMITED",
"DHAWAN BOX SHEET CONTAINERS PRIVATE LIMITED",
"DHAWAN ELECTRICALS PRIVATE LIMITED",
"DHAWAN ENGINEERS PRIVATE LIMITED",
"DHAWAN FOREX PRIVATE LIMITED",
"DHAWAN JEWELLERS PRIVATE LIMITED",
"DHAWAN PRODUCTION PRIVATE LIMITED",
"DHAWAN RETAIL SOLUTIONS PRIVATE LIMITED",
"DHAWAN STAGECRAFTS PRIVATE LIMITED",
"DHAWAN TRANSCON BELTINGS PVT LTD",
"DHB ENTERPRISE PRIVATE LIMITED",
"DHC BUILDWORKS (OPC) PRIVATE LIMITED",
"DHC INTERNATIONAL PRIVATE LIMITED",
"DHC LOGISTICS PRIVATE LIMITED",
"DHC MARKETING PRIVATE LIMITED",
"DHCUBE INDUSTRIES PRIVATE LIMITED",
"DHD INFRACON PRIVATE LIMITED",
"DHEE AUTOMATION PRIVATE LIMITED",
"DHEEMANTH SOLAR INDUSTRIES PRIVATE LIMITED",
"DHEEPHAM BIOFUELS PRIVATE LIMITED",
"DHEER HEALTH CARE PRIVATE LIMITED",
"DHEER HOSPITALITY INDIA PRIVATE LIMITED",
"DHEER PROPERTIES LIMITED",
"DHEERAJ & RAVIRANJAN TRADERS PRIVATE LIMITED",
"DHEERAJ COLD STORAGE PRIVATE LIMITED",
"DHEERAJ FOOTWEAR PRIVATE LIMITED",
"DHEERAJ HOSPITAL PRIVATE LIMITED",
"DHEERAJ KRISHNA CONSTRUCTION PRIVATE LIMITED",
"DHEERAJ KRISHNA RICE MILLS PRIVATE LIMITED",
"DHEERAN CHINNAMALAI INTERNATIONAL RESIDENTIAL SCHOOL",
"DHEETI TECHNOLOGIES PRIVATE LIMITED",
"DHEHRADUN CALCIUM MINERALS PRIVATE LIMITED",
"DHELAKHAT TEA CO LTD",
"DHENDAI TEA & INDUSTRIES PRIVATE LIMITED",
"DHENU INFRASTRUCTURE PRIVATE LIMITED",
"DHENUDHAN MILK PRODUCER COMPANY LIMITED",
"DHERE INDUSTRIES INDIA PRIVATE LIMITED",
"DHEVAKI DIAGNOSTIC PRIVATE LIMITED",
"DHEYA CAREER MENTORS INDIA PRIVATE LIMITED",
"DHEYA ENGINEERING TECHNOLOGIES PRIVATE LIMITED",
"DHFL PRAMERICA ASSET MANAGERS PRIVATE LIMITED",
"DHFL SALES AND SERVICES LIMITED",
"DHFL VYSYA HOUSING FINANCE LIMITED",
"DHI INNOVATIONS PRIVATE LIMITED",
"DHI INVESTIGATION SERVICES PRIVATE LIMITED",
"DHI TATTVA SOLUTIONS PRIVATE LIMITED",
"DHII EDUCATION PRIVATE LIMITED",
"DHI-INDIA WATER AND ENVIRONMENT PRIVATE LIMITED",
"DHIIRA BUSINESS SOLUTIONS PRIVATE LIMITED",
"DHILLON AVIATION PRIVATE LIMITED",
"DHILLON BROTHERS PRIVATE LIMITED",
"DHILLON CONSTRUCTIONS PRIVATE LIMITED",
"DHILLON FREIGHT CARRIER LIMITED",
"DHILLON GOODS TRANSPORT LOGISTICS PRIVATE LIMITED",
"DHILLON KOOL DRINKS & BEVERAGES PRIVATE. LIMITED.",
"DHILLON STONE CRUSHER PRIVATE LIMITED",
"DHIMAHI FOREX PRIVATE LIMITED",
"DHIMAN INDUSTRIAL FABRICATORS & DESIGNERS",
"DHIMAN INDUSTRIES PRIVATE LIMITED",
"DHIMAN IRON AND STEEL INDUSTRIES PRIVATE LIMITED",
"DHIMAN SWITCHGEAR PRIVATE LIMITED",
"DHIMAN WELDING WORKS",
"DHINESH CLOTHING MILLS PRIVATE LIMITED",
"DHINGAR SILK MILLS PRIVATE LIMITED",
"DHINGRA ALLOYS PVT LTD",
"DHINGRA AND SONS AGRO RESTOBAR PRIVATE LIMITED",
"DHINGRA AUTO INDIA PRIVATE LIMITED",
"DHINGRA BUILDCON PRIVATE LIMITED",
"DHINGRA CHEM PRIVATE LIMITED",
"DHINGRA DEVELOPERS PRIVATE LIMITED",
"DHINGRA EXPORTS",
"DHINGRA FABRICS PRIVATE LIMITED",
"DHINGRA GRAPHICS AND PACKAGING PRIVATE LIMITED",
"DHINGRA JEWEL PALACE LIMITED",
"DHINGRA MOTORS PRIVATE LIMITED",
"DHINGRA PLASTIC AND PLASTICISERS PVT LTD",
"DHINGRA POSTER GALLARY PRIVATE LIMITED",
"DHINGRA PRODUCTS PRIVATE LIMITED",
"DHINGRA TRUCKING PRIVATE LIMITED",
"DHINOJ NAGRIK KELAVANI VIKAS MANDAL SANCHALIT P M E M SCHOOL",
"DHIPL PROJECTS PRIVATE LIMITED",
"DHIR AND DHIR ASSOCIATES",
"DHIR AUTOMOBILES PRIVATE LIMITED",
"DHIR FOOD COMPANY PRIVATE LIMITED",
"DHIR HOTELS AND RESORTS PRIVATE LIMITED",
"DHIRAAN INFRASTRUCTURE PRIVATE LIMITED",
"DHIRAJ ALLOY AND STAINLESS STEEL PRIVATE LIMITED",
"DHIRAJ CAN CO PVT LTD",
"DHIRAJ FOUNDATION",
"DHIRAJ GENERAL HOSPITAL",
"DHIRAJ HEAVY EQUIPMENTS PRIVATE LIMITED",
"DHIRAJ HERBS PRIVATE LIMITED",
"DHIRAJ HOTELS PVT LTD",
"DHIRAJ IRON AND STEEL LIMITED",
"DHIRAJ RIGS PRIVATE LIMITED",
"DHIRAJ TRIBOLUBES PRIVATE LIMITED",
"DHIRAJLAL AMICHAND SHAH AND OTHERS",
"DHIRAJLAL GANDHI COLLEGE OF TECHNOLOGY",
"DHIREN ENTERPRISES PRIVATE LIMITED",
"DHIRENDRA CONSTRUCTION PRIVATE LIMITED",
"DHIRENDRA INTERNATIONAL PRIVATE LIMITED",
"DHIRENDRA NARAYAN COLD STORAGE PRIVATE LIMITED",
"DHIRENDRA OUTDOOR MEDIA SOLUTIONS PRIVATE LIMITED",
"DHIRENDRA SOYA AGRO PRIVATE LIMITED",
"DHIROOMAL AND SONS PVT LTD",
"DHIRSONS JEWELLERS PRIVATE LIMITED",
"DHIRUBHAI AMBANI INTERNATIONAL SCHOOL",
"DHIRUBHAI SHAH & CO LLP",
"DHISA PHARMACIES INDIA PRIVATE LIMITED",
"DHITI BIOTECH (INDIA) PRIVATE LIMITED",
"DHITI DIAGNOSTICS PRIVATE LIMITED",
"DHITI LIFE SCIENCES PRIVATE LIMITED",
"DHITI OMICS TECHNOLOGIES PRIVATE LIMITED",
"DHIVAKAR SPINNING MILLS PRIVATE LIMITED",
"DHIWISHA REALTY",
"DHIYA FERTILITY AND MATERNITY CLINIC PRIVATE LIMITED",
"DHIYA FOUNDATION PRIVATE LIMITED",
"DHIYAAN AUTO PRIVATE LIMITED",
"DHK AGRO FEEDS AND FARMS PRIVATE LIMITED",
"DHL ASSOCIATES PVT.LTD.",
"DHL ECOMMERCE INDIA LLP",
"DHL ECOMMERCE INDIA PRIVATE LIMITED",
"DHL EXPRESS INDIA PRIVATE LIMITED",
"DHL GLOBAL FORWARDING FREIGHT SHARED SER VICES (INDIA) LLP",
"DHL INFORMATION SERVICES INDIA LLP",
"DHL INFRABULLS INTERNATIONAL PRIVATE LIMITED",
"DHL INFRATECH PRIVATE LIMITED",
"DHL LOGISTIC PRIVATE LIMITED",
"DHL SUPPLY CHAIN INDIA PRIVATE LIMITED",
"DHN AGENCY PRIVATE LIMITED",
"DHN TECHNOLOGIES PRIVATE LIMITED",
"DHOLA INFRA PROJECTS LIMITED",
"DHOLAI TEA CO PVT LTD",
"DHOLAKIA FOUNDATION",
"DHOLAKIA TECHNOLOGIES LLP",
"DHOLAKIA TOBACCO PRIVATE LIMITED",
"DHOLAKIYA TEXTILE PRIVATE LIMITED",
"DHOLE PATIL COLLEGE OF ENGINEERING",
"DHOLE PATILL COLLEGE AO ARTS COMMERCE AND SCIENCE",
"DHOLERA INDUSTRIAL CITY DEVELOPMENT LIMITED",
"DHOLERA INTERNATIONAL AIRPORT COMPANY LIMITED",
"DHOLI INTEGRATED SPINNING PARK LIMITED",
"DHOLI SPINTEX PRIVATE LIMITED",
"DHOLPUR BUSINESS VENTURES PRIVATE LIMITED",
"DHOLPUR CGD PRIVATE LIMITED",
"DHOLPUR GAS POWER LIMITED",
"DHONE CARS PRIVATE LIMITED",
"DHONE WHEELS PRIVATE LIMITED",
"DHONI ENTERTAINMENT PRIVATE LIMITED",
"DHOOM PAYAL PRIVATE LIMITED",
"DHOOP CHEM (INDIA) P LTD",
"DHOOT AUTO PRIVATE LIMITED",
"DHOOT BUILDERS",
"DHOOT COMPACK PRIVATE LIMITED",
"DHOOT DEVELOPERS PRIVATE LIMITED",
"DHOOT ELECTRICALS SYSTEMS PRIVATE LIMITED",
"DHOOT INDUSTRIAL FINANCE LIMITED",
"DHOOT INFRASTRUCTURE PROJECTS LIMITED",
"DHOOT INFRATECH INDIA PRIVATE LIMITED",
"DHOOT INSTRUMENTS PRIVATE LIMITED",
"DHOOT MOTORS PRIVATE LIMITED",
"DHOOT NIRMITI PRIVATE LIMITED",
"DHOOT POLYFABRIC PRIVATE LIMITED",
"DHOOT REALTORS PRIVATE LIMITED",
"DHOOT RESORTS AND SPA PRIVATE LIMITED",
"DHOOT SANGEMERMER PRIVATE LIMITED",
"DHOOT SERVICES PRIVATE LIMITED",
"DHOOT STONO CRAFTS PRIVATE LIMITED",
"DHOOT TRANSMISSION PRIVATE LIMITED",
"DHOOTMOTORS AUTOTECH PRIVATE LIMITED",
"DHOPAVE COASTAL POWER LIMITED",
"DHORJE INDUSTRIES PRIVATE LIMITED",
"DHOSA CHANDANESWAR BRATYAJANA SAMITY",
"DHOSHI FOREX PRIVATE LIMITED",
"DHOTE OFFSET TECHNOKRAFTS PRIVATE LIMITED",
"DHP INDIA LIMITED",
"DHR HOLDING INDIA PRIVATE LIMITED",
"DHR INTERNATIONAL (INDIA) PRIVATE LIMITED",
"DHRISHTICONE ARCHITECTURAL COMMUNICATIONS PRIVATE LIMITED",
"DHRISTI KIRAN BUILDERS AND DEVELOPERS (OPC) PRIVATE LIMITED",
"DHRITHI SURGICAL SOLUTIONS PRIVATE LIMITED",
"DHRITI AUTOMOTIVE LLP",
"DHRITI ENGITECH PRIVATE LIMITED",
"DHRITI FOODS PRIVATE LIMITED",
"DHRITI LOGISTICS PRIVATE LIMITED",
"DHRITI MINES AND MINERALS PRIVATE LIMITED",
"DHROL BHADRA HIGHWAYS LIMITED",
"DHRUBLOK STEEL PRIVATE LIMITED",
"DHRUMIK LAND DEVELOPERS PRIVATE LIMITED",
"DHRUMISHA INFRASTRUCTURES PRIVATE LIMITED",
"DHRUNA DIGITAL TECHNOLOGY PRIVATE LIMITED",
"DHRUPAD CONSULTANTS PRIVATE LIMITED",
"DHRUSHYAA LOGISTICS PRIVATE LIMITED",
"DHRUTHI INFRA PROJECTS LIMITED",
"DHRUTI CONSTRUCTION & DEVELOPMENT PRIVATE LIMITED",
"DHRUV AGRITECHNOLOGIES PRIVATE LIMITED",
"DHRUV AXON INTERCONNECT PRIVATE LIMITED",
"DHRUV COMPUSOFT CONSULTANCY PRIVATE LIMITED",
"DHRUV CONSULTANCY SERVICES PRIVATE LIMITED",
"DHRUV COTEX PRIVATE LIMITED",
"DHRUV COTTON PROCESSING PRIVATE LIMITED",
"DHRUV CRAFT MILL PRIVATE LIMITED",
"DHRUV CROP PROTECTION CONSULTANCY (OPC) PRIVATE LIMITED",
"DHRUV DISTRIBUTORS PRIVATE LIMITED",
"DHRUV ELECTRICALS P LTD",
"DHRUV EPC SOLUTIONS PRIVATE LIMITED",
"DHRUV FASHIONS PRIVATE LIMITED",
"DHRUV FOOTWEAR PRIVATE LIMITED",
"DHRUV GEMS PRIVATE LIMITED",
"DHRUV GLOBAL SCHOOL",
"DHRUV GLOBALS LIMITED",
"DHRUV ICONIC PRIVATE LIMITED",
"DHRUV INDUSTRIES LIMITED",
"DHRUV INTERIORS PRIVATE LIMITED",
"DHRUV MEDICAL FOUNDATION AND RESEARCH CENTRE PRIVATE LIMITED",
"DHRUV MEDICOS PRIVATE.LIMITED",
"DHRUV MOTORS INDIA PRIVATE LIMITED",
"DHRUV PACKAGINGS PVT LTD",
"DHRUV POLYCHEM PRIVATE LIMITED",
"DHRUV PROCON PRIVATE LIMITED",
"DHRUV REPROCESS PRIVATE LIMITED",
"DHRUV SOFTECH PRIVATE LIMITED",
"DHRUV TARA AUTOMOBILES PRIVATE LIMITED",
"DHRUVA ADVISORS LLP",
"DHRUVA AUTOMATION AND CONTROLS PRIVATE LIMITED",
"DHRUVA IMAGING PRIVATE LIMITED",
"DHRUVA INFOTECH P LIMITED.",
"DHRUVA SAI INFRASTRUCTURE PRIVATE LIMITED",
"DHRUVA SPACE PRIVATE LIMITED",
"DHRUVA TECHNOLOGIES PRIVATE LIMITED",
"DHRUVA WOOLLEN MILLS PRIVATE LIMITED",
"DHRUVAL EXIM PRIVATE LIMITED",
"DHRUVAN AUTOCORP PRIVATE LIMITED",
"DHRUVDESH METASTEEL PRIVATE LIMITED",
"DHRUVDESH MOTORS PRIVATE LIMITED",
"DHRUVEN ENTERPRISES PRIVATE LIMITED",
"DHRUVESH INDUSTRIES PRIVATE LIMITED",
"DHRUVI AQUA PRIVATE LIMITED",
"DHRUVI BUILDCON PRIVATE LIMITED",
"DHRUVI PHARMA PRIVATE LIMITED",
"DHRUVI PROPERTIES PRIVATE LIMITED",
"DHRUVI SECURITIES LIMITED",
"DHRUVISHA HVAC SYSTEMS PRIVATE LIMITED",
"DHRUVNANDA GAUPANCHGAVYA PRIVATE LIMITED",
"DHRUVSOFT SERVICES PRIVATE LIMITED",
"DHRUVTARA CHEMICALS PRIVATE LIMITED",
"DHRUVTARA WIRETECH PRIVATE LIMITED",
"DHS HOTELS PRIVATE LIMITED",
"DHS INFRASTRUCTURE PRIVATE LIMITED",
"DHS MULTI SPECIALTY HOSPITAL",
"DHS ORTHOCARE PRIVATE LIMITED",
"DHTC INDIA LIMITED.",
"DHTC LOGISTICS LIMITED",
"D'HUBB HR AND BUSINESS SOLUTIONS",
"DHUKIA HOSPITAL",
"DHULAGARH LIQUOR MART PRIVATE LIMITED",
"DHULE MUNICIPAL CORPORATION DHULE",
"DHULE PALESNER TOLLWAY PRIVATE LIMITED",
"DHULESHWAR HOSPITAL LASER SKIN CENTRE",
"DHULIYAN DIAGNOSTIC & HEALTH CARE PRIVATE LIMITED",
"DHULLIE TEA PLANTATIONS PRIVATE LIMITED",
"DHUMAL INDUSTRIES INDIA PRIVATE LIMITED",
"DHUMAL METALS PRIVATE LIMITED",
"DHUMMA CONSULTING SERVICES PRIVATE LIMITED",
"DHUNEE TECHNOLOGIES PRIVATE LIMITED",
"DHUNI CONSTRUCTIONS PRIVATE LIMITED",
"DHUNI POLYMERS PRIVATE LIMITED",
"DHUNI PROPERTY DEVELOPERS PRIVATE LIMITED",
"DHUNJIBHOY ICE FACTORY PRIVATE LIMITED",
"DHUNSERI INVESTMENTS LIMITED",
"DHUNSERI TEA AND INDUSTRIES LIMITED",
"DHUPAR BROTHERS TRADING PRIVATE LIMITED",
"DHUPAR CHEMICALS PRIVATE LIMITED",
"DHURI BIZSOLUTIONS PRIVATE LIMITED",
"DHURI PLASTIC PRIVATE LIMITED",
"DHURIA RICE MILLS",
"DHURINA VENTURES PRIVATE LIMITED",
"DHURJYOTI TEA COMPANY PRIVATE LIMITED",
"DHURSAR SOLAR POWER PRIVATE LIMITED",
"DHUSAN MOTORS PRIVATE LIMITED",
"DHUTURDAHA KP HIGH SCHOOL",
"DHV FITTING PRIVATE LIMITED",
"DHVANI ANALYTIC INTELLIGENCE PRIVATE LIMITED",
"DHVANI INDUSTRIES PRIVATE LIMITED",
"DHVANI RESEARCH AND DEVELOPMENT SOLUTIONS PRIVATE LIMITED",
"DHVANI TEREFABS EXPORTS PRIVATE LIMITED",
"DHVY GLOBAL PRIVATE LIMITED",
"DHWAJA COMMODITY SERVICES PRIVATE LIMITED",
"DHWAJA SHARES & SECURITIES PRIVATE LIMITED",
"DHWANI MERCANTILE PRIVATE LIMITED",
"DHWANI OFFSET PRIVATE LIMITED",
"DHWANI POLYPRINTS PRIVATE LIMITED",
"DHWANI RURAL INFORMATION SYSTEMS PRIVATE LIMITED",
"DHWANI SYSTEMS PRIVATE LIMITED",
"DHWANILIFE CARE PRIVATE LIMITED",
"DHY PROMOTERS PRIVATE LIMITED",
"DHYAAN FOODS PRIVATE LIMITED",
"DHYAANI TRADEVENTTURES LIMITED",
"DHYAN JNANA PROBODHINI SAMSHODHON INST",
"DHYAN NETWORKS AND TECHNOLOGIES PRIVATE LIMITED",
"DHYAN PROBODHINI INSTITUTE OF MANAGEMENT",
"DHYANA INFRASTRUCTURE PRIVATE LIMITED",
"DHYANESHWAR TRADERS PRIVATE LIMITED",
"DHYANI INFRASTRUCTURE PRIVATE LIMITED",
"DHYEY CONSULTING SERVICES PRIVATE LIMITED",
"DHYEY TECHNOLOGIES (OPC) PRIVATE LIMITED",
"DHYEYA EDUCATIONAL SERVICES PRIVATE LIMITED",
"DI POWER AND INFRACON PRIVATE LIMITED",
"DI SHIMLA SIZERS PRIVATE LIMITED",
"DI TELECOMMUNICATION PRIVATE LIMITED",
"DIA ALUMINIUM INDIA PRIVATE LIMITED",
"DIA DEVELOPERS INDIA PRIVATE LIMITED",
"DIA FLOW PUMPS & FILTERS PRIVATE LIMITED",
"DIA INFRA SOLUTIONS PRIVATE LIMITED",
"DIA LOGISTICS AND WAREHOUSING PRIVATE LIMITED",
"DIA PRECIOUS JEWELLERY PRIVATE LIMITED",
"DIA RAYS MANUFACTURING LLP",
"DIAB CORE MATERIALS PRIVATE LIMITED",
"DIABETES THYROID HORMONE RESEARCH INSTITUTE PRIVATE LIMITED",
"DIABETIK FOOT CARE INDIA PRIVATE LIMITED",
"DIABETOMICS MEDICAL PRIVATE LIMITED",
"DIABLISS CONSUMER PRODUCTS PRIVATE LIMITED",
"DIABRICKS ENGINEERING PRIVATE LIMITED",
"DIABS INCUBATOR ASSOCIATION",
"DIABU DIAMOND TOOLS (INDIA) PRIVATE LIMITED",
"DIABU DIAMOND TOOLS INDIA PRIVATE LIMITED",
"DIACH CHEMICAL AND PIGMENTS PRIVATE LIMITED",
"DIACHEM HEALTHCARE PRIVATE LIMITED",
"DIACOLOR INDIA PRIVATE LIMITED",
"DIACON HOSPITAL PRIVATE LIMITED",
"DIACORETOOLS PRIVATE LIMITED",
"DIACTINIC DEVELOPERS PRIVATE LIMITED",
"DIACTO TECHNOLOGIES PRIVATE LIMITED",
"DIADEM ENTERPRISES PRIVATE LIMITED",
"DIADORA SHOES PRIVATE LIMITED",
"DIAGAST",
"DIAGEMS EXPORTS PRIVATE LIMITED",
"DIAGEO BUSINESS SERVICES INDIA PRIVATE LIMITED",
"DIAGEO INDIA PRIVATE LIMITED",
"DIAGNO CARE INDIA PRIVATE LIMITED",
"DIAGNO LABS PRIVATE LIMITED",
"DIAGNO SOLUTION PRIVATE LIMITED",
"DIAGNOSEARCH LIFE SCIENCES PRIVATE LIMITED",
"DIAGNOSIS EVALUATION AND RESEARCH PRIVATE LIMITED",
"DIAGNOSTIC AUTOMATION & CONTROLS PRIVATE LIMITED",
"DIAGNOSTIC CARE AND TRADING PRIVATE LIMITED",
"DIAGNOSTIC ENTERPRISES",
"DIAGNOSTIC TECHNOLOGIES INDIA PRIVATE LIMITED",
"DIAGNOSTICS & SCIENTIFIC SUPPLIERS PRIVATE LIMITED",
"DIAGNOSYS ELECTRONICS I PRIVATE LIMITED",
"DIAGOLD CREATION PRIVATE LIMITED",
"DIAGOLD DESIGNS LIMITED",
"DIA-GOLD JEWELS PRIVATE LIMITED",
"DIAGONAL ENGINEERS PRIVATE LIMITED",
"DIAGONAL SOFTWARE PRIVATE LIMITED",
"DIAGRAPH IMPEX PRIVATE LIMITED",
"DIAGRID BUILDERS & CONSULTING ENGINEERS INDIA PRIVATE LIMITED",
"DIAKEM INDIA PVT LTD",
"DIAL A CAKE PRIVATE LIMITED",
"DIAL AUTOMOBILES PVT LTD",
"DIAL DEVELOPERS LIMITED",
"DIAL E- VAHAN PRIVATE LIMITED",
"DIAL EQUIPMENTS PRIVATE LIMITED",
"DIAL HEALTH CARE INDIA PRIVATE LIMITED",
"DIAL LEGAL INDIA PRIVATE LIMITED",
"DIAL LOGISTICS PRIVATE LIMITED",
"DIAL PHARMACEUTICALS PRIVATE LIMITED",
"DIALLO",
"DIALMYTRIP TECH PRIVATE LIMITED",
"DIALPAD SERVICES PRIVATE LIMITED",
"DIALUCK DIAMONDS PRIVATE LIMITED",
"DIAM DISPLAY INDIA PRIVATE LIMITED",
"DIAM RESOURCES PRIVATE LIMITED",
"DIAM STAR JEWELLERY INDIA PRIVATE LIMITED",
"DIAMALT COLLOIDS PRIVATE LIMITED",
"DIAMANT INFRASTRUCTURE DEVLOPERS PRIVATE LIMITED",
"DIAMANT INFRASTRUCTURE LIMITED",
"DIAMANT TRIUMPH METALLPLASTIC PRIVATE LIMITED",
"DIAMANTAIRE EXPORTS PRIVATE LIMITED",
"DIAMANTINE COMPANY PRIVATE LIMITED",
"DIAMANTO 9 GEM AND JEWELS PRIVATE LIMITED",
"DIAMAR DIAMONDS PRIVATE LIMITED",
"DIAMENTO PRECISION PARTS PRIVATE LIMITED",
"DIAMETER CASTING PRIVATE LIMITED",
"DIAMETRIKS CONSULTING PRIVATE LIMITED",
"DIAMEX SOURCING PRIVATE LIMITED",
"DIAMOND ADMINISTRATION INDIA PRIVATE LIMITED",
"DIAMOND AGENCIES PRIVATE LIMITED",
"DIAMOND AGRO ENGINEERINGS PRIVATE LIMITED",
"DIAMOND AIRCON OPC PRIVATE LIMITED",
"DIAMOND AND GEM DEVELOPMENT CORPORATION LIMITED",
"DIAMOND AND GEM LABORATORIES OF AMERICA PRIVATE LIMITED",
"DIAMOND ARCH PAPIER MACHE PRIVATE LIMITED",
"DIAMOND BEVERAGES PRIVATE LIMITED",
"DIAMOND BOTTLING PLANT COMPANY",
"DIAMOND BUCKET INDUSTRIES",
"DIAMOND BUILDING CONCEPT PRIVATE LIMITED",
"DIAMOND CASTINGS PRIVATE LIMITED",
"DIAMOND CHICKEN PRODUCTS PRIVATE LIMITED",
"DIAMOND CITY DEVELOPERS (INDIA) PRIVATE LIMITED",
"DIAMOND CLEARING & FORWARDING PRIVATE LIMITED",
"DIAMOND CONSTRUCTION COMPANY",
"DIAMOND CORRUGATED BOX PRIVATE LIMITED",
"DIAMOND CYCLE PVT LTD",
"DIAMOND DECOR PRIVATE LIMITED",
"DIAMOND DISPLAY SOLUTIONS PRIVATE LIMITED",
"DIAMOND DRUGS PRIVATE LIMITED",
"DIAMOND EDUCATIONAL AND WELFARE SOC-REGD",
"DIAMOND ELEMENTS PRIVATE LIMITED",
"DIAMOND ENERGY SERVICES INDIA PRIVATE LIMITED",
"DIAMOND FABRICATIONS INDIA PRIVATE LIMITED",
"DIAMOND FACTORY PRIVATE LIMITED",
"DIAMOND FLANGES AND FITTINGS PRIVATE LIMITED",
"DIAMOND FOOD AND BEVERAGES PRIVATE LIMITED",
"DIAMOND FOOTCARE UDYOG PRIVATE LIMITED",
"DIAMOND FOOTCARE UDYOG PRIVATE. LIMITED.",
"DIAMOND FOREVER INTERNATIONAL",
"DIAMOND FRAMES PRIVATE LIMITED",
"DIAMOND HATCHERIES PVT LTD",
"DIAMOND HITECH POULTRY FEEDS PRIVATE LIMITED",
"DIAMOND HOSIERY MILLS PVT LTD",
"DIAMOND IMPORTERS EXPORTERS & MANUFACTURERS MCA",
"DIAMOND INDIA LIMITED",
"DIAMOND INFOTECH PRIVATE LIMITED",
"DIAMOND INFRAPROMOTERS PRIVATE LIMITED",
"DIAMOND INTERNATIONAL INEX PRIVATE LIMITED",
"DIAMOND ISPAT PRIVATE LIMITED",
"DIAMOND LIFESCIENCES PRIVATE LIMITED",
"DIAMOND LIQUORS PRIVATE LIMITED",
"DIAMOND MAGAZINES PRIVATE LIMITED",
"DIAMOND MARITIME AGENCY PRIVATE LIMITED",
"DIAMOND MELA JEWELS LIMITED",
"DIAMOND METAL SCREENS PRIVATE LIMITED",
"DIAMOND MINK BLANKETS LIMITED",
"DIAMOND MODULAR PRIVATE LIMITED",
"DIAMOND NANO MICRONS PRIVATE LIMITED",
"DIAMOND PIPE SUPPORTS PRIVATE LIMITED",
"DIAMOND PIPES & TUBES PRIVATE LIMITED",
"DIAMOND PLASTICS PVT.LTD.",
"DIAMOND POCKET BOOKS PRIVATE LIMITED",
"DIAMOND POLYTUBES PRIVATE LIMITED",
"DIAMOND PRINT 'N' PACK PRIVATE LIMITED",
"DIAMOND PRODUCTS LIMITED",
"DIAMOND RESEARCH AND MERCANTILE CITY LIMITED",
"DIAMOND RESORTS PRIVATE LIMITED",
"DIAMOND RETAIL MART PRIVATE LIMITED",
"DIAMOND ROADLINES PRIVATE LIMITED",
"DIAMOND ROLLER FLOUR MILLS PVT LTD",
"DIAMOND SCAFFOLDING CO. PRIVATE LIMITED",
"DIAMOND SCOOTERS & BIKES PRIVATE LIMITED",
"DIAMOND SECURITY PERSONNEL 2",
"DIAMOND SHIPBROKERS PRIVATE LIMITED",
"DIAMOND SHIPPING AGENCIES PRIVATE LIMITED",
"DIAMOND SING AND FOODS PRIVATE LIMITED",
"DIAMOND SOLUTIONS PRIVATE LIMITED",
"DIAMOND SUPERSPECIALITY HOSPITAL",
"DIAMOND TEXFAB INDIA PRIVATE LIMITED",
"DIAMOND TEXWORLD PRIVATE LIMITED",
"DIAMOND THREADS & MACHINES PRIVATE LIMITED",
"DIAMOND TMT & PROCON PRIVATE LIMITED",
"DIAMOND TRADEMART PRIVATE LIMITED",
"DIAMOND TRADEX COMPANY LIMITED",
"DIAMOND TRAEXIM PRIVATE LIMITED",
"DIAMOND TRANS LOGISTICS PRIVATE LIMITED",
"DIAMOND VALLEY GARDENS PRIVATE LIMITED",
"DIAMOND VALLEY INFRASTRUCTURE COMPANY LIMITED",
"DIAMOND VARUN THREAD MILL PRIVATE LIMITED",
"DIAMOND VEHICLES PRIVATE LIMITED",
"DIAMOND WHEELERS PRIVATE LIMITED",
"DIAMOND WORLD PRIVATE LIMITED",
"DIAMONDBLUE SHIPPING SOLUTIONS PRIVATE LIMITED",
"DIAMONDERE PRIVATE LIMITED",
"DIAMONDPICK PRIVATE LIMITED",
"DIAMONDSTAR EXPORTS LIMITED",
"DIAMOUR JEWELS PRIVATE LIMITED.",
"DIANA BUILDWELL PRIVATE LIMITED",
"DIANA FOAMS PVT LIMITED",
"DIANA IMPEX PVT LTD",
"DIANA PRODUCTS PRIVATE LIMITED",
"DIANA WORD TRAVEL PRIVATE LIMITED",
"DIANAMECH ENGINEERS INDIA PRIVATE LIMITED",
"DIANAPPS TECHNOLOGIES PRIVATE LIMITED",
"DIANEXA TECHNOLOGIES PRIVATE LIMITED",
"DIANOVA DIAGNOSTICS PRIVATE LIMITED",
"DIANTHA SYSTEMS PRIVATE LIMITED",
"DIAONICS AUTOMATION I PRIVATE LIMITED",
"DIARCH BUILDCON PRIVATE LIMITED",
"DIARIO INDISHOP HUB PRIVATE LIMITED",
"DIAS MODULAR PRIVATE LIMITED",
"DIASIS AUTOMATION LIMITED",
"DIASON ADVERTISING PRIVATE LIMITED",
"DIASORIN HEALTHCARE INDIA PRIVATE LIMITED",
"DIASPARK INFOTECH PRIVATE. LIMITED.",
"DIASQUA INDIA PRIVATE LIMITED",
"DIASYS DIAGNOSTICS INDIA PRIVATE LIMITED",
"DIAT AGRO HOLDING PRIVATE LIMITED",
"DIATEK HEALTHCARE PRIVATE LIMITED",
"DIATOZ SOLUTIONS PRIVATE LIMITED",
"DIATRENDS JEWELLERY PRIVATE LIMITED",
"DIATX BIOTECH PRIVATE LIMITED",
"DIAVISZ JEWELS PRIVATE LIMITED",
"DIBAKAR BANERJEE PRODUCTIONS PRIVATE LIMITED",
"DIBANG INFRA PROJECTS LIMITED",
"DIBANG SOLUTION INDIA PRIVATE LIMITED",
"DIBD OMII CONSULTING PRIVATE LIMITED",
"DIBON SOFTWARE SOLUTIONS PRIVATE LIMITED",
"DIBRU GARH PHYSIOTHERAPHY CLINIC PVT LTD",
"DIBRUGARH DISTRIBUTORS PRIVATE LIMITED",
"DIBRUGARH UNIVERSITY",
"DIBRUMUKH RICE AND FLOUR MILLS PVT LTD",
"DIBYAANANTA COMPUTERS PRIVATE LIMITED",
"DIC FINE CHEMICALS PRIVATE LIMITED",
"DIC INDIA LIMITED",
"DIC SOUTH ASIA PRIVATE LIMITED",
"DICE ACCELERATION AND EDUTECH SERVICES INDIA PRIVATE LIMITED",
"DICEDOTS PRIVATE LIMITED",
"DICENTRE TECHNOLOGIES PRIVATE LIMITED",
"DICEUS LIFESTYLE PRIVATE LIMITED",
"DICITEX FURNISHINGS PRIVATE LIMITED",
"DICITEX HOME FURNISHINGS PRIVATE LIMITED",
"DICITEX RETAIL PRIVATE LIMITED",
"DICKENSON INTELLINETICS PRIVATE LIMITED",
"DICKEY ASSET MANAGEMENT PRIVATE LIMITED",
"DICKINSON FOWLER PRIVATE LIMITED",
"DICKINSON TECHNOLOGY CONSULTING SERVICES PRIVATE LIMITED",
"DICKSON SERVICES SAS",
"DICKSONS ENGINEERING COMPANY PRIVATE LIMITED",
"DICKSONS MULTI TRADE PRIVATE LIMITED",
"DICO TRANSPORT CORPORATION LTD",
"DICOKI ENTERTAINMENT PRIVATE LIMITED",
"DICOMM TECH PRIVATE LIMITED",
"DICON PRODUCTS PRIVATE LIMITED",
"DICS GEEPEE MACHINES PRIVATE LIMITED",
"DICTASOL INDIA PRIVATE LIMITED",
"DIDA BROTHERS COMPANY PRIVATE LIMITED",
"DIDACTIC MIGRATION CONSULTANTS PRIVATE LIMITED",
"DIDAR STEEL COMPLEX PRIVATE LIMITED",
"DIDEA ARCHITECTS",
"DIDWANIA ASSOCIATES PVT LTD",
"DIDWANIA PAPERS PRIVATE LIMITED",
"DIDYMOUS RETAIL INDIA PRIVATE. LIMITED.",
"DIDYMOUS TRADELINKS PRIVATE. LIMITED.",
"DIE MECH ENGINEERS PRIVATE LIMITED",
"DIE PLAST PRIVATE LIMITED",
"DIEBOLD NIXDORF INDIA PRIVATE LIMITED",
"DIEBOLD SYSTEMS PRIVATE LIMITED",
"DIEFFENBACHER INDIA PRIVATE LIMITED",
"DIEHARD DIES PRIVATE LIMITED",
"DIEHL METAL INDIA PRIVATE LIMITED",
"DIEN CHEMICALS PVT LTD",
"DIESEL (INDIA) NITRIDE PRIVATE LIMITED",
"DIESEL AUTO PARTS CO. PRIVATE LIMITED",
"DIESEL FASHION INDIA RELIANCE PRIVATE LIMITED",
"DIESEL SYNDICATE INDIA PRIVATE LIMITED",
"DIESEL WORLD PRIVATE LIMITED",
"DIET CLINIC HEALTH CARE PRIVATE LIMITED",
"DIET FIBRE 365 FOOD PRODUCTS PRIVATE LIMITED",
"DIETECH INDIA PRIVATE LIMITED",
"DIETICO HEALTH FOOD & ALLIED SERVICES PRIVATE LIMITED",
"DIETRICH ENGINEERING CONSULTANTS INDIA PRIVATE LIMITED",
"DIEU HEALTHCARE PRIVATE LIMITED",
"DIFACTO ROBOTICS AND AUTOMATION PRIVATE LIMITED",
"DIFCY LOGISTICS LIMITED",
"DIFD INDUSTRIES PRIVATE LIMITED",
"DIFFERENT COUNTS PRIVATE LIMITED",
"DIFFERENT GARMENTS PRIVATE LIMITED",
"DIFFERENT HAIR PRIVATE LIMITED",
"DIFFERENT SQUARES VENTURES PRIVATE LIMITED",
"DIFFERENTIAL TECHNOLOGIES LIMITED",
"DIFFERENZ SYSTEM PRIVATE LIMITED",
"DIFFUSION ENGINEERS LIMITED",
"DIFFUSION PACKAGINGS AND PLASTICS PVT LTD",
"DIFI HEALTHCARE PRIVATE LIMITED",
"DIFOT EXPRESS PRIVATE LIMITED",
"DIFTECH TECHNOLOGIES PRIVATE LIMITED",
"DIGAMBAR JAIN COLLEGE",
"DIGAMBARRAO BINDU ARTS COMMERCE AND SCIENCE COLLEGE BHOKAR",
"DIGAMBER BAG PRIVATE LIMITED",
"DIGAMBER CAPFIN LIMITED",
"DIGAMBER INDUSTRIES PRIVATE LIMITED",
"DIGAMBER POLYMERS PRIVATE LIMITED",
"DIGANT TECHNOLOGIES PRIVATE LIMITED",
"DIGANTA INVESTMENT AND FINANCE COMPANY PRIVATE LIMITED",
"DIGANTA MUDRANA LIMITED",
"DIGBOI CARBON PRIVATE LIMITED",
"DIGBOI TEA PRODUCER COMPANY LIMITED",
"DIGEARTH CONSTRUCTION EQUIPMENTS (INDIA) PRIVATE LIMITED",
"DIGEARTH EQUIPMENTS (INDIA) PRIVATE LIMITED",
"DIGESTIVE HEALTH INSTITUTE BY DR. MUFFI PRIVATE LIMITED",
"DIGFINSURE PRIVATE LIMITED",
"DIGGA FOODS PRIVATE LIMITED",
"DIGGA TRADERS PRIVATE LIMITED",
"DIGGER DOWNHOLE TOOLS PRIVATE LIMITED",
"DIGGI HOTELS PRIVATE LIMITED",
"DIGHA SEA FOOD EXPORTS PRIVATE LIMITED",
"DIGHAL TARANG L P SCHOOL",
"DIGHI OIL STORAGE PRIVATE LIMITED",
"DIGHVIJAY PLASTICS AND ALLIED PRODUCTS PRIVATE LIMITED",
"DIGI CABLECOMM SERVICES PRIVATE LIMITED",
"DIGI DISCOVERY PRIVATE LIMITED",
"DIGI GLOBUS TECHNOLOGIES PRIVATE LIMITED",
"DIGI M2M SOLUTIONS INDIA PRIVATE LIMITED",
"DIGI MAHARAJA CABLE NETWORK PRIVATE LIMITED",
"DIGI OSMOSIS PRIVATE LIMITED",
"DIGI SPACE NETWORK PRIVATE LIMITED",
"DIGI TELE NETWORKS PRIVATE LIMITED",
"DIGI TRAVEL SOLUTIONS PRIVATE LIMITED",
"DIGI1 ELECTRONICS PRIVATE LIMITED",
"DIGIAGE DOCUMENT SOLUTIONS PRIVATE LIMITED",
"DIGIANA INDUSTRIES PRIVATE LIMITED",
"DIGIANA PROJECTS PRIVATE LIMITED",
"DIGIBOOK TECHNOLOGIES PRIVATE LIMITED",
"DIGICALL GLOBAL PRIVATE LIMITED",
"DIGICALL TELESERVICES PRIVATE LIMITED",
"DIGICARE HEALTH SOLUTIONS PRIVATE LIMITED",
"DIGICERT SECURITY INDIA PRIVATE LIMITED",
"DIGICHEM INDUSTRIES",
"DIGICHORUS TECHNOLOGIES PRIVATE LIMITED",
"DIGICIDES MARKETING SERVICES PRIVATE LIMITED",
"DIGICLARITY GLOBAL SOLUTIONS PRIVATE LIMITED",
"DIGICLOUD SOLUTIONS PRIVATE LIMITED",
"DIGICOM MANAGEMENT SYSTEMS PRIVATE LIMITED",
"DIGICOM SYSTEMS BANGALORE PRIVATE LIMITED",
"DIGICOM TECHNOLOGIES PRIVATE LIMITED",
"DIGICOMM SEMICONDUCTOR PRIVATE LIMITED",
"DIGICON AUTOMATION PRIVATE LIMITED",
"DIGICON ELECTRONICS PRIVATE LIMITED",
"DIGICON ENGINEERS (INDIA ) PRIVATE LIMITED",
"DIGICONICS ENTERPRISE SOLUTIONS PRIVATE LIMITED",
"DIGICONTENT LIMITED",
"DIGICORE TECHNOLOGIES PRIVATE LIMITED",
"DIGICORP INFORMATIONS SYSTEMS PRIVATE LIMITED",
"DIGICRED TECHNOLOGIES PRIVATE LIMITED",
"DIGICS PRIVATE LIMITED",
"DIGIDARTS MARKETING PRIVATE LIMITED",
"DIGIDINE HOSPITALITY PRIVATE LIMITED",
"DIGIENT TECHNOLOGIES PRIVATE LIMITED",
"DIGIFISH MEDIA PRIVATE LIMITED",
"DIGIFLIC CONTROLS INDIA PRIVATE LIMITED",
"DIGIFOCAL IT SOLUTIONS PRIVATE LIMITED",
"DIGIFRA TECHNOLOGY PRIVATE LIMITED",
"DIGIFY ENGINEERING PRIVATE LIMITED",
"DIGIGLITZ TECHNOLOGIES PRIVATE LIMITED",
"DIGIHIVE TECHNOLOGY PRIVATE LIMITED (OPC)",
"DIGIHOOD MEDIA PRIVATE LIMITED",
"DIGI-IN SYSTEMS PRIVATE LIMITED",
"DIGIINNOVATIONS INDIA PRIVATE LIMITED",
"DIGIKETERS AGENCY LLP",
"DIGIKORE STUDIOS LIMITED",
"DIGIKREDIT FINANCE PRIVATE LIMITED",
"DIGIKULL EDUCATION PRIVATE LIMITED",
"DIGILAB BIO ANALYTICAL INSTRUMENTS PRIVATE LIMITED",
"DIGILE TECHNOLOGIES PRIVATE LIMITED",
"DIGILEARN PRIVATE LIMITED",
"DIGILIFE DISTRIBUTION AND MARKETING SERVICES LIMITED",
"DIGILINE MEDIA PRIVATE LIMITED",
"DIGILINE SYSTEMS PRIVATE LIMITED",
"DIGILIT DIGITAL SOLUTIONS PRIVATE LIMITED",
"DIGILOG TECHNOLOGIES PRIVATE LIMITED",
"DIGILOGIC DISTRIBUTION SERVICES PRIVATE LIMITED",
"DIGILOGIC SYSTEMS PRIVATE LIMITED",
"DIGILOGUE COMMUNICATIONS PRIVATE LIMITED",
"DIGIMAC TECH PRIVATE LIMITED",
"DIGIMAGNUS BUSINESS SOLUTIONS PRIVATE LIMITED",
"DIGIMART EVENTURE PRIVATE LIMITED",
"DIGIMATICS INDIA PRIVATE LIMITED",
"DIGIMECH ENERGY SOLUTIONS PRIVATE LIMITED",
"DIGIMEDIA SOLUTIONS PRIVATE LIMITED",
"DIGIMICRO TECHNOLOGIES",
"DIGIMONK MARKETING PRIVATE LIMITED",
"DIGIMONK TECHNOLOGIES PRIVATE LIMITED",
"DIGIMONKS PRIVATE LIMITED",
"DIGINEOUS TECHNOLOGIES PRIVATE LIMITED",
"DIGINEXT EDUCATION PRIVATE LIMITED.",
"DIGINFLUENZ PRIVATE LIMITED",
"DIGINODE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"DIGIOPTO TECHNOLOGIES PRIVATE LIMITED",
"DIGIORA TECHNOLOGIES PRIVATE LIMITED",
"DIGIOTECH SOLUTIONS PRIVATE LIMITED",
"DIGIPANDA CONSULTING PRIVATE LIMITED",
"DIGIPE FINTECH PRIVATE LIMITED",
"DIGIPE INDIA SOLUTIONS PRIVATE LIMITED",
"DIGIPLUSIT SOFTWARE PRIVATE LIMITED",
"DIGIPRIMA TECHNOLOGIES (OPC) PRIVATE LIMITED",
"DIGIPRO SYSTEMS PRIVATE LIMITED",
"DIGIPROPEL INDIA PRIVATE LIMITED",
"DIGIPROTEK LEARNING SYSTEMS PRIVATE LIMITED",
"DIGIQAL SOLUTION SERVICES PRIVATE LIMITED",
"DIGIQUEST INDIA LIMITED",
"DIGIQUINT SOLUTIONS PRIVATE LIMITED",
"DIGIRAIN MEDIA SERVICES PRIVATE LIMITED",
"DIGISAFE INSURANCE BROKING PRIVATE LIMITED",
"DIGISASTRA MEDIA PRIVATE LIMITED",
"DIGISCAPE TECH SOLUTIONS LIMITED",
"DIGISEC CONSULTANCY SERVICES PRIVATE LIMITED",
"DIGISENSE CUSTOMERIQ PRIVATE LIMITED",
"DIGISMART DIGITAL MEDIA PRIVATE LIMITED",
"DIGISOL NETWORK SERVICES PRIVATE LIMITED",
"DIGISOL SYSTEMS LIMITED",
"DIGISPICE TECHNOLOGIES LIMITED",
"DIGISPRINT SOLUTIONS PRIVATE LIMITED",
"DIGISTREET MEDIA PRIVATE LIMITED",
"DIGISWITCH INFOTECH PRIVATE LIMITED",
"DIGISYS INFOTECH PRIVATE LIMITED",
"DIGIT COMPUTERS PRIVATE LIMITED",
"DIGIT SECURE INDIA PRIVATE LIMITED",
"DIGIT7 INDIA PRIVATE LIMITED",
"DIGIT88 TECHNOLOGIES PRIVATE LIMITED",
"DIGITAAZTRANS TECHNOLOGIES PRIVATE LIMITED",
"DIGITAL 14 INDIA PRIVATE LIMITED",
"DIGITAL ADVISETREE SOLUTION PRIVATE LIMITED",
"DIGITAL AGE RETAIL PRIVATE LIMITED",
"DIGITAL AGENTS INTERACTIVE PRIVATE LIMITED",
"DIGITAL AI SOFTWARE INDIA PRIVATE LIMITED",
"DIGITAL ALCHEMY INDIA PRIVATE LIMITED",
"DIGITAL APTECH PRIVATE LIMITED",
"DIGITAL ARISTOTLE PRIVATE LIMITED",
"DIGITAL ART INDIA PRIVATE LIMITED",
"DIGITAL AVENUES LIMITED",
"DIGITAL BLINC TECHNOLOGIES PRIVATE LIMITED",
"DIGITAL BRAINS TECH",
"DIGITAL CABLE BROADBAND PRIVATE LIMITED",
"DIGITAL CAMPUS SERVICES PRIVATE LIMITED",
"DIGITAL CARE PRIVATE LIMITED",
"DIGITAL CASTLE WEB SOLUTIONS PRIVATE LIMITED",
"DIGITAL CERAMICS PRIVATE LIMITED",
"DIGITAL CHOCOLATE IT AND GAMING SOLUTIONS PRIVATE LIMITED",
"DIGITAL COMMUNICATION & CONTROL PRIVATE LIMITED",
"DIGITAL COMPONENTS PRIVATE LIMITED",
"DIGITAL COMPUSYSTEMS PRIVATE LIMITED",
"DIGITAL CONVERGENCE TECHNOLOGIES INDIA PRIVATE LIMITED",
"DIGITAL CONVERGENCE TECHNOLOGIES PUNE PRIVATE LIMITED",
"DIGITAL CORN",
"DIGITAL CRAFT PRIVATE LIMITED",
"DIGITAL DREAMS CONSULTING PRIVATE LIMITED",
"DIGITAL DRIFTWOOD PRIVATE LIMITED",
"DIGITAL DWARVES PRIVATE LIMITED",
"DIGITAL EARTH COMMUNICATION PRIVATE LIMITED",
"DIGITAL ENTERTAINMENT PRIVATE LIMITED",
"DIGITAL ENTREPRENEURSHIP AND COWORKING CENTER PRIVATE LIMITED",
"DIGITAL F5 MARKETING SERVICES PRIVATE LIMITED",
"DIGITAL FILM RESTORE PRIVATE LIMITED",
"DIGITAL FILM TECHNOLOGIES PRIVATE LIMITED",
"DIGITAL FOOD TALK PRIVATE LIMITED",
"DIGITAL FOREX PRIVATE LIMITED",
"DIGITAL FUTURE OF EDUCATION PRIVATE LIMITED",
"DIGITAL GOLD INDIA PRIVATE LIMITED",
"DIGITAL GROUP INFOTECH PRIVATE LIMITED",
"DIGITAL GUARDIAN TECHNOLOGIES INDIA PRIVATE LIMITED",
"DIGITAL HARBOR PRIVATE LIMITED",
"DIGITAL HUB SOLUTION PRIVATE LIMITED",
"DIGITAL IDENTITY INDIA PRIVATE LIMITED",
"DIGITAL IMPRESSIONS PRIVATE LIMITED",
"DIGITAL INDIA CORPORATION",
"DIGITAL INDIA PAYMENTS LIMITED",
"DIGITAL INFO SOLUTIONS PRIVATE LIMITED",
"DIGITAL INFRATECH PRIVATE LIMITED",
"DIGITAL INSIGHTS & RESEARCH PRIVATE LIMITED",
"DIGITAL INTEGRATED TECHNOLOGIES PRIVATE LIMITED",
"DIGITAL INTEGRATOR PRIVATE LIMITED",
"DIGITAL IP INSIGHTS PRIVATE LIMITED",
"DIGITAL IT SOLUTIONS PRIVATE LIMITED",
"DIGITAL JUICE ANIMATIONS PRIVATE LIMITED",
"DIGITAL KALAKAAR VIDEOS PRIVATE LIMITED",
"DIGITAL LENDERS ASSOCIATION OF INDIA",
"DIGITAL LOGICIEL SOLUTION PRIVATE LIMITED",
"DIGITAL MECHANICS TECHNICAL SOLUTION PRIVATE LIMITED",
"DIGITAL MERIDIAN TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"DIGITAL MESH SOFTECH INDIA PRIVATE LIMITED",
"DIGITAL MIND CONSULTANCY SERVICES PRIVATE LIMITED",
"DIGITAL MINDS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"DIGITAL MINDS TECHNOLOGIES PRIVATE LIMITED",
"DIGITAL MODE EVENTS & EXHIBITIONS PRIVATE LIMITED",
"DIGITAL NAVIGATION PRIVATE LIMITED",
"DIGITAL NETWORK ASSOCIATES PRIVATE LIMITED",
"DIGITAL NEWS PUBLISHERS ASSOCIATION",
"DIGITAL NEXT ECOSYSTEM LLP",
"DIGITAL NIRVANA INFORMATION SYSTEMS (INDIA) PRIVATE LIMITED",
"DIGITAL OBSESSION COMMUNICATION PRIVATE LIMITED",
"DIGITAL OCEAN PERIPHERALS PRIVATE LIMITED",
"DIGITAL ONLINE SOLUTIONS PRIVATE LIMITED",
"DIGITAL PAYMENTS PROCESSING LIMITED",
"DIGITAL PERFORMANCE MEDIA PRIVATE LIMITED",
"DIGITAL POINT SOLUTIONS PRIVATE LIMITED",
"DIGITAL PROMOTERS INDIA PRIVATE LIMITED",
"DIGITAL RADIO (DELHI) BROADCASTING LIMITED",
"DIGITAL RADIO (KOLKATA) BROADCASTING LIMITED",
"DIGITAL RADIO DELHI BROADCASTING LIMITED",
"DIGITAL RADIO KOLKATA BROADCASTING LIMITED",
"DIGITAL REACH PRIVATE LIMITED",
"DIGITAL REFRESH NETWORKS PRIVATE LIMITED",
"DIGITAL REPROGRAPHIC PRINT SERVICES PRIVATE LIMITED",
"DIGITAL RHOMBUS STUDIOS PRIVATE LIMITED",
"DIGITAL RISK MORTGAGE SERVICES LLC",
"DIGITAL SATELLITE CONNECT PRIVATE LIMITED",
"DIGITAL SCIENCE WEB TECHNOLOGIES PRIVATE LIMITED",
"DIGITAL SEMICONDUCTORS PRIVATE LIMITED",
"DIGITAL SHARK TECHNOLOGY PRIVATE LIMITED",
"DIGITAL SIGNAGE NETWORKS INDIA PRIVATE. LIMITED",
"DIGITAL SUBSCRIBER MANAGEMENT AND CONSULTANCY SERVICES PRIVATE LIMITED",
"DIGITAL SYSCOM PRIVATE LIMITED",
"DIGITAL TANTRA MEDIA SOLUTIONS PRIVATE LIMITED",
"DIGITAL TECHLAB PRIVATE LIMITED",
"DIGITAL TECHNOLOGIES LIMITED",
"DIGITAL TRACK SOLUTIONS PRIVATE LIMITED",
"DIGITAL VENTURE PRIVATE. LIMITED.",
"DIGITAL VENTURES PRIVATE LIMITED",
"DIGITAL VIEW INDIA",
"DIGITAL WAVES INTERNATIONAL PRIVATE LIMITED",
"DIGITAL WEB ANALYTICS AND OPTIMIZATION LLP",
"DIGITAL WEB SOLUTIONS PRIVATE LIMITED",
"DIGITAL WEIGHING SYSTEMS PRIVATE LIMITED",
"DIGITAL WOLF LLP",
"DIGITAL WORKSPACE PRIVATE LIMITED",
"DIGITAL YOUTH PRIVATE LIMITED",
"DIGITAL18 MEDIA LIMITED",
"DIGITALAPICRAFT PRIVATE LIMITED",
"DIGITALCORE TECHNOLOGIES PRIVATE LIMITED",
"DIGITALES PR MEDIOS PRIVATE LIMITED",
"DIGITALFORCE ONLINE INDIA PRIVATE LIMITED",
"DIGITALHUB DESIGNS PRIVATE LIMITED",
"DIGITALIST TECHMEDIA PRIVATE LIMITED",
"DIGITALLY INSPIRED MEDIA PRIVATE LIMITED",
"DIGITALMAIN PRIVATE LIMITED",
"DIGITALMATICS TECHNOLOGIES PRIVATE LIMITED",
"DIGITALS INDIA SECURITY PRODUCTS PRIVATE LIMITED",
"DIGITALSOFT INNOVATION LAB PRIVATE LIMITED",
"DIGITALTRUST TECHNOLOGIES PRIVATE LIMITED",
"DIGITALVISION TECHNOLOGY PRIVATE LIMITED",
"DIGITALX ADVERTISING AND EVENTS PRIVATE LIMITED",
"DIGITAM INTELLECTS CONSULTING PRIVATE LIMITED",
"DIGITAMIZE INNOVATIONS PRIVATE LIMITED",
"DIGITAP.AI ENTERPRISE SOLUTIONS PRIVATE LIMITED",
"DIGITATVA SOFTWARE CONSULTANT PRIVATE LIMITED",
"DIGITCOM SYSTEMS PRIVATE LIMITED",
"DIGITE INFOTECH PRIVATE LIMITED",
"DIGITEC ENGINEERS AND COMPUTECH PRIVATE LIMITED",
"DIGITECH CALL SYSTEM PRIVATE LIMITED",
"DIGITECH CONTROLS & AUTOMATIONS (INDIA) PRIVATE LIMITED",
"DIGITECH ELETRONIC SYSTEMS PRIVATE LIMITED",
"DIGITECH EXIM PRIVATE LIMITED",
"DIGITECH GLOBAL PRIVATE LIMITED",
"DIGITECH SERVICES PRIVATE LIMITED",
"DIGITECHNOVISION PRIVATE LIMITED",
"DIGITECTURA TECHNOLOGIES PRIVATE LIMITED",
"DIGITEK FIRE SAFETY PRIVATE LIMITED",
"DIGITEK SOFTWARE PRIVATE LIMITED",
"DIGITEXT TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"DIGITISE IT INDIA PRIVATE LIMITED",
"DIGITIVE SOLUTIONS PRIVATE LIMITED",
"DIGITIZE SOFTWARE PRIVATE LIMITED",
"DIGITIZEBRAND HUB INDIA PRIVATE LIMITED",
"DIGITIZING MART PRIVATE LIMITED",
"DIGITONICA INDIA PRIVATE LIMITED",
"DIGITOONZ MEDIA & ENTERTAINMENT PRIVATE LIMITED",
"DIGITOP DIGITAL TRANSFORMATION CONSULTING SERVICES PRIVATE LIMITED",
"DIGITOUCH TECHNOLOGIES PRIVATE LIMITED",
"DIGITRAL PRIVATE LIMITED",
"DIGITRONICS INFOSOLUTIONS PRIVATE LIMITED",
"DIGITUS TECHNOTRADE PRIVATE LIMITED",
"DIGIUNIVERSE INDIA PRIVATE LIMITED",
"DIGIVAASI INTERACTIVE SERVICES PRIVATE LIMITED",
"DIGIVATION DIGITAL SOLUTIONS PRIVATE LIMITED",
"DIGIVERIFI PRIVATE LIMITED",
"DIGIVERSAL CONSULTANTS PRIVATE LIMITED",
"DIGIVIVE SERVICES PRIVATE LIMITED",
"DIGIWAY NET PRIVATE LIMITED",
"DIGIXPRESS TRADE PRIVATE LIMITED",
"DIGIZURA TECHNOLOGIES PRIVATE LIMITED",
"DIGJAM LIMITED",
"DIGNITAS DIGITAL PRIVATE LIMITED",
"DIGNITY ENTERPRISES PRIVATE LIMITED",
"DIGNITY INNOVATIONS",
"DIGNITY MERCHANTS PRIVATE LIMITED",
"DIGNITY SHIPPING SERVICES PRIVATE LIMITED",
"DIGNIZANT TECNOLOGIES LLP",
"DIGNUS INFRA PRIVATE LIMITED",
"DIGTINCTIVE INDIA PRIVATE LIMITED",
"DIGVENDRA MOTORS PRIVATE LIMITED",
"DIGVIJAY CHEMICALS LIMITED",
"DIGVIJAY COMMERCE & TRADING PRIVATE LIMITED",
"DIGVIJAY CONSTRUCTION PVT LTD",
"DIGVIJAY EXPRESS PRIVATE LIMITED",
"DIGVIJAY FINLEASE LIMITED",
"DIGVIJAY LOGISTICS PRIVATE LIMITED",
"DIGVIJAY MARBLE AND GRANITES PRIVATE LIMITED",
"DIGVIJAY MOTORS ( INDIA) PRIVATE LIMITED",
"DIGVIJAY PHARMA CEUTICALS INDIA PRIVATE LIMITED",
"DIGVIJAY STEELS PRIVATE LIMITED",
"DIGVIJAY SUITINGS PRIVATE LIMITED",
"DIGVIJAY SYSTEMS AND SERVICES PRIVATE LIMITED",
"DIGVIJAY TEXFAB PRIVATE LIMITED",
"DIGZ PLACEMENTS LLP",
"DIHANG EDUTECH INFRASTRUCTURE PRIVATE LIMITED",
"DIJET INDUSTRIAL CO LTD",
"DIKIBI TECHNOLOGIES PRIVATE LIMITED",
"DIKONIA BRINGING VALUE THROUGH INNOVATIVE IT SOLUTIONS",
"DIKORA BULK DRUG PRIVATE LIMITED",
"DIKSAT TRANSWORLD LIMITED",
"DIKSHA CONTAINERS PRIVATE LIMITED",
"DIKSHA CORPORATE SERVICES PRIVATE LIMITED",
"DIKSHA INDUSTRIES LIMITED",
"DIKSHA KNITWEARS PRIVATE LIMITED",
"DIKSHA POLYMERS PRIVATE LIMITED",
"DIKSHA RISING STARS PUBLIC SCHOOL",
"DIKSHA SECURITIES PRIVATE LIMITED",
"DIKSHA SPRINGS PRIVATE LIMITED",
"DIKSHA TECHNOLOGIES PRIVATE LIMITED",
"DIKSHA TEXFAB PRIVATE LIMITED",
"DIKSHA TIMBER PRIVATE. LIMITED.",
"DIKSHANT GLOBAL SCHOOL",
"DIKSHA-VANDITA HOSPITAL PRIVATE LIMITED",
"DIKSHIT DIAGNOSTIC PRIVATE LIMITED",
"DIKUN PACK PRIVATE LIMITED",
"DIL EXIM COMMODITIES PRIVATE LIMITED",
"DIL LIMITED",
"DILA PRINTERS PRIVATE LIMITED",
"DILASA AGRO PROCESSORS PRIVATE LIMITED",
"DILAVAR STEEL PRIVATE LIMITED",
"DILBAHAR ICE CREAM AND FOOD PRODUCTS PRIVATE LIMITED",
"DILEEP INDUSTRIES PRIVATE LIMITED",
"DILEEP POTTERIES PRIVATE LIMITED",
"DILEEPINDUSTRIES PRIVATE LIMITED",
"DILESH LOGISTICS (INDIA) PRIVATE LIMITED",
"DILESH ROADLINES PRIVATE LIMITED",
"DILIGENCE BIO PRIVATE LIMITED",
"DILIGENCE CONSULTING LLP",
"DILIGENCE FINTECH PRIVATE LIMITED",
"DILIGENCE GLOBAL PRIVATE LIMITED",
"DILIGENCE SECURITY & SERVICES",
"DILIGENT FORCE LABS INDIA PRIVATE LIMITED",
"DILIGENT GLOBAL TECH CONSULTING PRIVATE LIMITED",
"DILIGENT HR SERVICES PRIVATE LIMITED",
"DILIGENT INDUSTRIES LIMITED",
"DILIGENT LOGISTICS SOLUTIONS PRIVATE LIMITED",
"DILIGENT MEDIA CORPORATION LIMITED",
"DILIGENT PACKAGING PRIVATE LIMITED",
"DILIGENT PINKCITY CENTER PRIVATE LIMITED",
"DILIGENT PMC PRIVATE LIMITED",
"DILIGENT SCM SOLUTIONS PRIVATE LIMITED.",
"DILIGENT SOLUTIONS TECHNOLOGY SERVICES PRIVATE LIMITED",
"DILIGENT TECH INDIA PRIVATE LIMITED",
"DILIGENT TRANSPORT PRIVATE LIMITED",
"DILIGENTSQUAD TECHNOLOGIES PRIVATE LIMITED",
"DILIP BABU TEXTILE PRIVATE LIMITED",
"DILIP CARRIERS PRIVATE LIMITED",
"DILIP ENGINEERING PRIVATE LIMITED",
"DILIP FABRICS PRIVATE LIMITED",
"DILIP IMPEX PRIVATE LIMITED",
"DILIP PLASTICS PVT LTD",
"DILIP PRESS METAL AND AGROTECH PRIVATE LIMITED",
"DILIP REROLLING PRIVATE LIMITED",
"DILIP TEXTILE PRIVATE LIMITED",
"DILIPKUMAR APPARELS PRIVATE LIMITED",
"DILISO CERAMIC",
"DILKAP RESEARCH INSTITUTE OF ENGINEERING AND MANAGEMENT STUDIES",
"DILKHUSA TEA CO LTD",
"DILKUSH FOREX SOLUTIONS PRIVATE LIMITED",
"DILKUSHA NURSING HOME PRIVATE LIMITED",
"DILLENBURG ELECTRONICS PRIVATE LIMITED",
"DILLI DARBAR FOOD PRIVATE LIMITED",
"DILLI ELECTRIC AUTO PRIVATE LIMITED",
"DILLI KARIGARI LIMITED",
"DILLIGENTA CHEMICALS PRIVATE LIMITED",
"DILLIP CONSTRUCTIONS PRIVATE LIMITED",
"DILLU VENTURE PRIVATE LIMITED",
"DILLY LEARNING PRIVATE LIMITED",
"DILPREET TUBES PRIVATE LIMITED",
"DILRAJMANMEET TRANSPORTATION PRIVATE LIMITED",
"DILSEBOL CUSTOMIZED APPAREL PRIVATE LIMITED",
"DILSHAD DATA FORMS LIMITED",
"DILWARA LEASING AND INVESTMENT LIMITED",
"DILYTICS TECHNOLOGIES PRIVATE LIMITED",
"DILZER CONSULTANTS PRIVATE LIMITED",
"DIMAGI SOFTWARE INNOVATIONS PRIVATE LIMITED",
"DIMAKH CONSULTANTS PRIVATE LIMITED",
"DIMAN ADVISORS PRIVATE LIMITED",
"DIMAN OVERSEAS PRIVATE LIMITED",
"DIMAPUR VENEER & SAW MILLS PVT LTD",
"DI-MASH INDIA PRIVATE LIMITED",
"DIMDIM SOFTWARE PRIVATE LIMITED",
"DIMEBAG SOLUTIONS PRIVATE LIMITED",
"DIMECO KIRPEKAR METAL FORMING SOLUTIONS PRIVATE LIMITED",
"DIMEN TECH PRIVATE LIMITED",
"DIMENSION ADVISORY SERVICES PRIVATE LIMITED",
"DIMENSION CORPORATE SERVICES PRIVATE LIMITED",
"DIMENSION DIGITAL CONTROLLS PRIVATE LIMITED",
"DIMENSION FINANCIAL SOLUTIONS PRIVATE LIMITED",
"DIMENSION INDIA NETWORKS PRIVATE LIMITED.",
"DIMENSION NXG PRIVATE LIMITED",
"DIMENSION POLYPRODUCTS PVT LTD",
"DIMENSION RETAIL SOLUTIONS PRIVATE LIMITED",
"DIMENSION STEEL PRIVATE LIMITED",
"DIMENSIONAL ADVISORY SERVICES PRIVATE LIMITED",
"DIMENSIONAL INSURANCE BROKERS PRIVATE LIMITED",
"DIMENSIONAL SECURITIES PVT. LTD.",
"DIMENSIONLESS TECHNOLOGIES PRIVATE LIMITED",
"DIMENSIONS ARCHITECTS PRIVATE LIMITED",
"DIMENSIONS CORPORATE FINANCE SERVICES PRIVATE LIMITED",
"DIMENSIONS CYBERTECH INDIA PRIVATE LIMITED",
"DIMENSIONS INNOVATION LABS PRIVATE LIMITED",
"DIMENSIONS LOGISTICS SERVICES PRIVATE LIMITED",
"DIMENTRIX TECHNOLOGIES PRIVATE LIMITED",
"DIMER POLY PRIVATE LIMITED",
"DIMERCO EXPRESS INDIA PRIVATE LIMITED",
"DIMERSE CREATIVE SOLUTIONS PRIVATE LIMITED",
"DIMESCO FOOTCARE INDIA PRIVATE LIMITED",
"DIMETRICS CHEMICALS PRIVATE LIMITED",
"DIMEX GRANITES PVT. LTD",
"DIMEX INDIA PRIVATE LIMITED",
"DIMEXON DIAMONDS LIMITED",
"DIMEXON INTEGRATED BUSINESS SERVICES PRIVATE LIMITED",
"DIMEXON JEWELLERY CREATIONS PRIVATE LIMITED",
"DIMI (INDIA) PVT LTD",
"DIMIC TECHNOLOGIES PRIVATE LIMITED",
"DIMIOUR INDIA PRIVATE LIMITED",
"DIMITBRO IVENTURE PRIVATE LIMITED",
"DIMITS INFOTECH PRIVATE LIMITED",
"DIMITY POLYPACK PRIVATE LIMITED",
"DIMO CASTINGS PRIVATE LIMITED",
"DIMPEX JEWELS PRIVATE LIMITED",
"DIMPLE CHEMICALS & SERVICES PRIVATE LIMITED",
"DIMPLE CREATIONS PRIVATE LIMITED",
"DIMPLE DRUMS AND BARRELS PRIVATE LIMITED",
"DIMPLE PACKAGING PRIVATE LIMITED",
"DIMPLE REALTORS PRIVATE LIMITED",
"DIMPLE SALES PRIVATE LIMITED",
"DIMPY INFRA VENTURES PRIVATE LIMITED",
"DIN ENGINEERING SERVICES LLP",
"DINA IRON & STEEL LIMITED",
"DINA MAHABIR RE-ROLLERS PRIVATE LIMITED",
"DINA METALS LTD",
"DINA NATH JAGDISH PRASAD HEALTHCARE AND HOTEL PRIVATE LIMITED",
"DINABANDHU ADARSHA COLLEGE",
"DINAKAR LITHO PRINTERS PVT LTD",
"DINAKAR PROCESS PVT. LTD.",
"DINAKARA LIFE SCIENCES PRIVATE LIMITED",
"DINAMALAR",
"DINAMIC OIL INDIA PRIVATE LIMITED",
"DINAN RESEARCH SERVICES PRIVATE LIMITED",
"DINAR TARCAR RESOURCES INDIA PRIVATE LIMITED",
"DINARA DATIA DPJ-PATHWAYS PRIVATE. LIMITED.",
"DINARNX AGRO PRODUCTS PRIVATE LIMITED",
"DINCO 4 WHEELS LLP",
"DINDAYAL BIYANI EQUITIES PRIVATE LIMITED",
"DINDAYAL BIYANI SECURITIES PRIVATE LIMITED",
"DINDAYAL COMMODITIES PRIVATE LIMITED",
"DINDAYAL INDUSTRIES LIMITED",
"DINDAYAL JALAN RETAILS PRIVATE LIMITED",
"DINDAYAL JALAN TEXTILES LIMITED",
"DINDAYAL MALL MANAGEMENT PRIVATE LIMITED",
"DINDAYAL TEXPRO PRIVATE LIMITED",
"DINDI RESORTS PRIVATE LIMITED",
"DINDIGUL COIR CONSORTIUM PRIVATE LIMITED",
"DINDIGUL COTTON TEXTILE MILLS PRIVATE LIMITED",
"DINDIGUL FARM PRODUCT LIMITED",
"DINDIGUL FARM PRODUCT PRIVATE LIMITED",
"DINDIGUL PARVATHY NATARAJAN HOTEL PRIVATE LIMITED",
"DINDIGUL RENEWABLE ENERGY PRIVATE LIMITED",
"DINDIGUL SCANS PRIVATE LIMITED",
"DINDIGUL STEEL ROLLING MILLS PRIVATE LIMITED",
"DINDORE WINDS PRIVATE LIMITED",
"DINEOUT SERVICES PRIVATE LIMITED",
"DINERO FINANCE AND INVESTMENTS PRIVATE LIMITED",
"DINERS CLUB SERVICES PRIVATE LIMITED.",
"DINERS FOOD PRODUCTS PRIVATE LIMITED",
"DINESH ALLOYS AND ENGINEERS",
"DINESH BROTHERS PVT LTD",
"DINESH CARGO CARRIERS PRIVATE LIMITED",
"DINESH CHAND FINANCE COMPANY PRIVATE LIMITED",
"DINESH COLD STORAGE PRIVATE LIMITED",
"DINESH ENGINEERS LIMITED",
"DINESH ENGINEERS PRIVATE LIMITED",
"DINESH EXPORTS PRIVATE LIMITED",
"DINESH IRRIGATION PRIVATE LIMITED",
"DINESH ISPAT PRIVATE LIMITED",
"DINESH KUMAR SHARMA CONSTRUCTIONS PRIVATE LIMITED",
"DINESH LOGISTICS PRIVATE LIMITED",
"DINESH MINERALS PRIVATE LIMITED",
"DINESH ORES PRIVATE LIMITED",
"DINESH POLYFAB PRIVATE LIMITED",
"DINESH POUCHES PRIVATE LIMITED",
"DINESH REMEDIES LIMITED",
"DINESH TEXTILE MILLS",
"DINESHCHANDRA FULCHAND BATAVIA APPARELS PRIVATE LIMITED",
"DINESHCHANDRA GIRIRAJ INFRA PRIVATE LIMITED",
"DINESHCHANDRA HASMUKHLAL JARIWALA PRIVATE LIMITED",
"DINESHCHANDRA R AGRAWAL INFRACON PRIVATE LIMITED",
"DINESHCHANDRA TANOT INFRA PRIVATE LIMITED",
"DINESHCHANDRA TOLLWAYS PRIVATE LIMITED",
"DINEX EMISSION SOLUTIONS INDIA PRIVATE LIMITED",
"DINEX PLYWOOD PRIVATE LIMITED.",
"DING ENTERTAINMENT PRIVATE LIMITED",
"DING INFINITY PRIVATE LIMITED",
"DING MANPOWER AND SECURITIES SERVICES PRIVATE LIMITED",
"DINGLE VINCOM PRIVATE LIMITED",
"DINILS ADHESIVES PRIVATE LIMITED",
"DINING TABLE CREATIVE SERVICES PRIVATE LIMITED",
"DINJAN ENTERPRISE PRIVATE LIMITED",
"DINJOYE TEA ESTATE PRIVATE LIMITED",
"DINKAL AGRO PRODUCTS PRIVATE LIMITED",
"DINKAR COMMERCIALS PVT LTD",
"DINKAR SEEDS PRIVATE LIMITED",
"DINKAR TECHNOLOGIES LIMITED",
"DINKY LABS INDIA PRIVATE LIMITED",
"DINMAN POLYPACKS PRIVATE LIMITED",
"DINOBANDHU INSTITUTION BRANCH",
"DINODIA TEA & AGRO PRIVATE LIMITED",
"DINOSAUR INDUSTRIES LIMITED",
"DINPATI COMMERCIALS PVT LTD",
"DINRACK MODULAR SYSTEMS PRIVATE LIMITED",
"DINS TECHNOLOGIES PRIVATE LIMITED",
"DINSHA ISPAT PRIVATE LIMITED",
"DINSHAW R HOMAVAZIR AND SONS PRIVATE LIMITED",
"DINSHAW S DAIRY FOODS PRIVATE LIMITED",
"DINSHAWS DAIRY FOODS CG PRIVATE LIMITED",
"DINSHAWS SNACKS & FOODS PRIVATE LIMITED",
"D-INSIGHTS PRIVATE LIMITED",
"DINSON GREEN PRIVATE LIMITED",
"DINSONS SELF STICKS PRIVATE LIMITED",
"DINTECH VALVES PRIVATE LIMITED",
"DINTEX INFORMATION SYSTEMS (INDIA) PRIVATE LIMITED",
"DINURJE JEWELLERY PRIVATE. LIMITED.",
"DINVIN BOOKS EXCELLENCE PRIVATE LIMITED",
"DIO DIGITAL IMPLANT INDIA PRIVATE LIMITED",
"DIOCARD PHARMACEUTICALS PRIVATE LIMITED",
"DIOCESE OF JALANDHAR",
"DIOGRAZIA REALCON PRIVATE LIMITED",
"DIOGY LABORATORIES PRIVATE LIMITED",
"DIOKRONIC MEDISYS PRIVATE LIMITED",
"DIOLOGIC SOFTWARE PRIVATE LIMITED",
"DION AUTOMOTIVES PRIVATE LIMITED",
"DION INFRATECH PRIVATE LIMITED",
"DIONA TECHNOLOGIES INDIA PRIVATE LIMITED",
"DIONYX EDGE PRIVATE LIMITED",
"DIOR PROPERTIES AND INVESTMENTS PRIVATE LIMITED",
"DIOS CASA FLOORING PRIVATE LIMITED",
"DIOS IMPEX PRIVATE LIMITED",
"DIOS INSURANCE BROKERS PRIVATE LIMITED",
"DIOS LIFESCIENCES PRIVATE LIMITED",
"DIOS SAATVIK FOOD AND BEVERAGES PRIVATE LIMITED",
"DIOS SYSTEMS PRIVATE LIMITED",
"DIOSMA LIFESCIENCES PRIVATE LIMITED",
"DIOSNA PROCESS SOLUTIONS PRIVATE LIMITED",
"DIOTEC ELECTRONICS INDIA PRIVATE LIMITED",
"DIP VERSHA BUILDCON INDIA PRIVATE LIMITED",
"DIPAK ACCESSORIES PRIVATE LIMITED",
"DIPAK AGRO OIL MILL PRIVATE LIMITED",
"DIPAK COLOUR LAB PRIVATE LIMITED",
"DIPAK INFIN PRIVATE LIMITED",
"DIPAK TEA PRIVATE LIMITED",
"DIPAK TRENDS PRIVATE LIMITED",
"DIPAKSHI NURSING AND MATERNITY HOME PRIVATE LIMITED",
"DIPALI ENTERPRISES PRIVATE LIMITED",
"DIPAN MEHTA COMMODITIES PRIVATE LIMITED",
"DIPANSHU PROMOTER & BUILDER PRIVATE. LIMITED.",
"DIPAYAN EXPORTS PRIVATE LIMITED",
"DIPCHAND C. PRI. SELOO",
"DIPCHEM¬†INDUSTRIES",
"DIPCO ESTATE PRIVATE LIMITED",
"DIPCO PRIVATE LIMITED",
"DIPCON PROPERTIES PRIVATE LIMITED",
"DIPEN SAFETY EQUIPMENT PRIVATE LIMITED.",
"DIPEN SAREES PRIVATE LIMITED",
"DIPEN SYNTHETICS PRIVATE LIMITED",
"DIPESH SILK MILLS PRIVATE LIMITED",
"DIPESH SUGARS PRIVATE LIMITED",
"DIPIKA FINCON PRIVATE LIMITED",
"DIPIKA PHARMACEUTICALS PRIVATE LIMITED",
"DIPIKA POLYMERS PRIVATE LIMITED",
"DIPIN CHEMICALS PRIVATE LIMITED",
"DIPLOMAT CONSULTANCY SERVICES PRIVATE LIMITED",
"DIPLOMAT ELECTRICALS PRIVATE LIMITED",
"DIPLOMAT EXIM PRIVATE LIMITED.",
"DIPLOMAT LEASING AND FINANCE PRIVATE LIMITED",
"DIPLOMAT LTD",
"DIPLOMAT SHF SERVICES PRIVATE LIMITED",
"DIPLOMATIC TRAVEL POINT PRIVATE LIMITED",
"DIPNA PHARMACHEM LIMITED",
"DIPON GAS & INFRASTRUCTURE PRIVATE LIMITED",
"DIPPER HEALTHCARE PRIVATE LIMITED",
"DIPPY INVESTMENTS PRIVATE LIMITED",
"DIPRA TRANSLINES INDIA PRIVATE LIMITED",
"DIPS BIOSCIENCE PRIVATE LIMITED",
"DIPS FERRO CAST PRIVATE LIMITED",
"DIPSHI CREATION PRIVATE LIMITED",
"DIPSI CHEMICALS AND INDUSTRIES PRIVATE LIMITED",
"DIPSI CHEMICALS PRIVATE LIMITED",
"DIPSON POLYMERS PRIVATE LIMITED",
"DIPSONS CONSULTANCY SERVICES PRIVATE LIMITED",
"DIPTAB VENTURES PRIVATE LIMITED",
"DIPTI BUILDERS UNIVERSAL PRIVATE LIMITED",
"DIPTI DIAMONDS & JEWELLERY PRIVATE. LIMITED.",
"DIPTI HOME MAKERS PRIVATE LIMITED",
"DIPTI MULTI PRODUCT MARKETING PRIVATE LIMITED",
"DIPTI VEGOILS LIMITED",
"DIPTI WAREHOUSING PRIVATE LIMITED",
"DIPTY LAL JUDGE MAL PRIVATE LIMITED",
"DIPU AND SONS POLYTUBES PRIVATE LIMITED",
"DIPU ASSOCIATES PRIVATE LIMITED",
"DIPU ENTERPRISES PRIVATE. LIMITED.",
"DIQU TECH PRIVATE LIMITED",
"DIR GOVT VIDARBHA INSITUTE OF SCIENCE AND HUMANITIES",
"DIRAC INDUSTRIES PRIVATE LIMITED",
"DIRAK INDIA PANEL FITTINGS PRIVATE LIMITED",
"DIRCO POLYMERS PRIVATE LIMITED",
"DIRE SURVEILLANCE PRIVATE LIMITED",
"DIRECT ACCESS (INDIA) PRIVATE LIMITED",
"DIRECT BAZAAR INTERNATIONAL LIMITED",
"DIRECT CREATE PRIVATE LIMITED",
"DIRECT DIALOGUE INITIATIVES INDIA PRIVATE LIMITED",
"DIRECT FIELD SERVICES PRIVATE LIMITED",
"DIRECT FORWARDING SERVICES PRIVATE LIMITED",
"DIRECT GROUP PTY LIMITED",
"DIRECT HOTELS PRIVATE LIMITED",
"DIRECT MEDIA DISTRIBUTION VENTURES PRIVATE LIMITED",
"DIRECT NEWS PRIVATE LIMITED",
"DIRECT NEXTGEN COMMERCE SERVICES PRIVATE LIMITED",
"DIRECT SOURCE INDIA PRIVATE LIMITED",
"DIRECT TO RETAIL LOGISTICS PRIVATE LIMITED",
"DIRECT WHOLESALE PRIVATE LIMITED",
"DIRECTEL ADVISORY PRIVATE LIMITED",
"DIRECTI INTERNET SOLUTIONS PRIVATE LIMITED",
"DIRECTI WEB TECHNOLOGY PRIVATE LIMITED",
"DIRECTION SOFTWARE SOLUTION",
"DIRECTIONS MEDIA PRIVATE LIMITED",
"DIRECTOR ANIMAL HEALTH AND VETERINARY BIOLOGICAL",
"DIRECTOR ARCHAELOGY ARCHIVES MUSEUM LANGUAGE & CULTURE",
"DIRECTOR ARCHAELOGY ARCHIVES MUSEUM LANGUAGE AND CULTURE",
"DIRECTOR CAPITAL HOSPITAL BHUBANESWAR",
"DIRECTOR CENSUS OPERATION,ORISSA,BHUBANESHWAR",
"DIRECTOR CENTRAL GROUND WATER BOARD NORTH CENTRAL REGION BHOPAL",
"DIRECTOR DEPT OF HANDICRAFTS TEXTILE COIR",
"DIRECTOR DIRECTORATE OF LIGHTHOUSE AND LIGHTSHIPS SOUTH GOA",
"DIRECTOR DIRECTORATE OF PULSES DEVELOPMENT",
"DIRECTOR FOREST GAURD TRANING SCHOOL JALNA",
"DIRECTOR GENERAL CENTRAL RESERVE POLICE FORCE",
"DIRECTOR GENERAL OF AUDIT",
"DIRECTOR GENERAL OF AUDIT ENVIRONMENT AND SCIENTIFIC DEPARTMENTS MUMBAI BRANCH",
"DIRECTOR GENERAL OF AUDIT MINES , KOLKATA",
"DIRECTOR GENERAL OF COMMERCIAL AUDIT AND EX-OFFICIO MEMBER AUDIT BOARD-II RANCHI",
"DIRECTOR GENERAL OF SECURITY",
"DIRECTOR GENERAL SCHOOL EDUCATION UTTAR PRADESH",
"DIRECTOR HORTICULTURE AND FARM FORESTRY",
"DIRECTOR INDUSTRIAL TRAINING",
"DIRECTOR LIGHTHOUSES AND LIGHTSHIPS",
"DIRECTOR LOCAL FUND AUDIT ODISHA",
"DIRECTOR MALARIA CHANDIGARH",
"DIRECTOR NDRF ACADEMY NAGPUR",
"DIRECTOR NEIST",
"DIRECTOR OF BASIC EDUCATION",
"DIRECTOR OF MEDICAL AND HEALTH SERVICES",
"DIRECTOR OF MEDICAL EDUCATION",
"DIRECTOR OF PROHIBITION AND EXCISE",
"DIRECTOR OF SECONDARY EDUCATION",
"DIRECTOR OF SOCIAL DEFENCE DEPT",
"DIRECTOR PARAPLEGIA CIVIL HOSPITAL",
"DIRECTOR PARKS AND GARDEN G S GANDHINAGAR",
"DIRECTOR PRINTING EVAM STATIONARY",
"DIRECTOR S I C BALRAMPUR HOSPITAL",
"DIRECTOR STATE SCIENCE EDU INSTITUTE JABALPUR",
"DIRECTOR TRIBAL RESEARCH AND TRAINING INSTITUTE",
"DIRECTOR ZOO BHOPAL",
"DIRECTORATE DISTRICT SPORT AND YOUTH WELFARE",
"DIRECTORATE GENERAL BORDER SECURITY FORCE",
"DIRECTORATE GENERAL CENTRAL RESERVE POLICE FORCE",
"DIRECTORATE GENERAL ITB POLICE",
"DIRECTORATE GENERAL OF CIVIL AVIATION",
"DIRECTORATE GENERAL OF HEALTH SERVICES",
"DIRECTORATE GENERAL OF HOME GUARDS",
"DIRECTORATE GENERAL OF INFORMATION AND PUBLIC RELATIONS",
"DIRECTORATE HEALTH SERVICES GOVT. OF HP",
"DIRECTORATE OF ACCOUNTS",
"DIRECTORATE OF AGRICULTURE GOVERNMENT OF WEST BENGAL",
"DIRECTORATE OF AGRICULTURE KRISHI BHAVAN LUCKNOW",
"DIRECTORATE OF ART",
"DIRECTORATE OF AUDIT",
"DIRECTORATE OF AYURVEDA",
"DIRECTORATE OF BASIC EDUCATION UTTAR PRADESH",
"DIRECTORATE OF CENSUS OPERATION GANDHINAGAR GUJARAT",
"DIRECTORATE OF CENSUS OPERATIONS UTTAR PRADESH",
"DIRECTORATE OF CENSUS OPS GOVT RAJ",
"DIRECTORATE OF CIVIL DEFENCE",
"DIRECTORATE OF COLLEGE EDU GOVT RAJ",
"DIRECTORATE OF COORDINATION POLICE WIRELESS NEW DELHI",
"DIRECTORATE OF DRUGS CONTROL",
"DIRECTORATE OF ECONOMICS AND STATISTICS",
"DIRECTORATE OF ENFORCEMENT ED KOLKATA",
"DIRECTORATE OF ESI MB SCHEME WB",
"DIRECTORATE OF EXTENSION",
"DIRECTORATE OF FIRE SERVICES",
"DIRECTORATE OF FOOD & CIVIL",
"DIRECTORATE OF GOVERNMEN",
"DIRECTORATE OF HEALTH SERVICES",
"DIRECTORATE OF HIGHER EDUCATION",
"DIRECTORATE OF I AND C",
"DIRECTORATE OF INDUSTRIES",
"DIRECTORATE OF INSURANCE",
"DIRECTORATE OF JUTE DEVELOPMENT GOVT OF INDIA",
"DIRECTORATE OF LOCAL GOV",
"DIRECTORATE OF MAHARASHTRA FIRE SERVICES",
"DIRECTORATE OF MEDICAL EDUCATION",
"DIRECTORATE OF MEDICINAL AND AROMATIC PLANTS RESEARCH",
"DIRECTORATE OF MICRO SMALL AND MEDIUM ENTERPRISES",
"DIRECTORATE OF MONITORING AND INSPECTION REGIONAL OFFICE BHOPAL",
"DIRECTORATE OF MSME HARYANA",
"DIRECTORATE OF PURCHASE AND STORES",
"DIRECTORATE OF REVENUE INTELLIGENCE",
"DIRECTORATE OF SCHEDULED CASTE WELFARE",
"DIRECTORATE OF SECURITY",
"DIRECTORATE OF SKILL DEVELOPMENT & ENTREPRENEURSHIP",
"DIRECTORATE OF SORGHUM RESEARCH",
"DIRECTORATE OF TECHNICAL EDUCATION",
"DIRECTORATE OF TOWN PLANNING & VALUATION",
"DIRECTORATE OF WEED SCIENCE RESEARCH (DWSR)",
"DIRECTORATE SOCIAL WELFARE UP",
"DIRECTORE GENERAL SCHOOL EDUCATION",
"DIRECTORE OF AGRICULTURE",
"DIRECTORE OF FIRE AND EMERGENCY SERVICES",
"DIRECTSHIP FULFILLMENT SERVICES PRIVATE LIMITED",
"DIRECTUS CONSULTANTS PRIVATE LIMITED",
"DIREM MARKETING SERVICES BANGALORE PRIVATE LIMITED",
"DIREXIONS MARKETING SOLUTIONS PRIVATE LIMITED",
"DIRGH DIAMOND PRIVATE LIMITED",
"DIRGH JEWELS PRIVATE LIMITED",
"DIRT BUSTERS INDIA PRIVATE LIMITED",
"DIS INSURANCE BROKING PRIVATE LIMITED",
"DIS MRP SEALS PRIVATE LIMITED",
"DISA INDIA LIMITED",
"DISA TECHNOLOGIES PRIVATE LIMITED",
"DISAN ACADEMY",
"DISAN INFRA PRIVATE LIMITED",
"DISC TECHNOLOGY SERVICES PRIVATE LIMITED",
"DISCERN ENGINEERING PRIVATE LIMITED",
"DISCERN LIVING TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"DISCOUNT STORE (INDIA) PRIVATE LIMITED",
"DISCOUNT TADKAA (INDIA) LIMITED",
"DISCOVER ACADEMY",
"DISCOVER AXLE INDIA PRIVATE LIMITED",
"DISCOVER FASHIONS INDIA PRIVATE LIMITED",
"DISCOVER FINANCIAL SERVICES",
"DISCOVER INDIA TOURS PRIVATE LIMITED",
"DISCOVER LEISURE TOURS AND TRAVELS PRIVATE LIMITED",
"DISCOVER PURE PRIVATE LIMITED",
"DISCOVER TRADE AND SERVICES PRIVATE LIMITED",
"DISCOVERTURE SOLUTIONS INDIA PRIVATE LIMITED",
"DISCOVERY 21ST CENTURY AGENCIES PRIVATE LIMITED",
"DISCOVERY BEVERAGES PRIVATE LIMITED",
"DISCOVERY BITES PRIVATE LIMITED",
"DISCOVERY BOOK PALACE PRIVATE LIMITED",
"DISCOVERY COMMUNICATIONS INDIA PRIVATE COMPANY WITH UNLIMITED LIABILITY",
"DISCOVERY DIAGNOSTICS PRIVATE LIMITED",
"DISCOVERY FINANCIAL SERVICES PRIVATE LIMITED",
"DISCOVERY INTERMEDIATES PRIVATE LIMITED",
"DISCOVERY JOURNEYS INDIA PRIVATE LIMITED",
"DISCOVERY LEATHERS PRIVATE LIMITED",
"DISCOVERY LOGISTICS PRIVATE LIMITED",
"DISCOVERY PUBLISHING HOUSE PRIVATE LIMITED",
"DISCOVERY VILLAGE LLP",
"DISCOVERY WEALTH MANAGEMENT SERVICES PRIVATE LIMITED",
"DISCREET (INDIA) MANAGEMENT SERVICES PRIVATE LIMITED",
"DISCREET ART PRODUCTIONS LLP",
"DISCREET SOLUTIONS PRIVATE LIMITED",
"DISCUS IT PRIVATE LIMITED",
"DISDA SECURITY PRIVATE LIMITED",
"DISH HOSPITALITY PRIVATE LIMITED",
"DISH INFRA SERVICES PRIVATE LIMITED",
"DISHA ALLIANCE PRIVATE LIMITED",
"DISHA APIS PRIVATE LIMITED",
"DISHA AUTO COMPONENTS PRIVATE LIMITED",
"DISHA BHARTI COLLEGE OF MANAGEMENT & EDUCATION",
"DISHA CAPITAL INSURANCE BROKERS PRIVATE LIMITED",
"DISHA CAREERS PRIVATE LIMITED",
"DISHA CLOTHINGS PRIVATE LIMITED",
"DISHA COMMUNICATIONS PRIVATE LIMITED",
"DISHA CONCEPTS PRIVATE LIMITED",
"DISHA CONSTRUCTION",
"DISHA CONTRACTS PRIVATE LIMITED",
"DISHA DWELLINGS PRIVATE LIMITED",
"DISHA DYE CHEM PRIVATE LIMITED",
"DISHA DYNAMIC BUILDWELL PRIVATE LIMITED",
"DISHA EYE HOSPITALS PRIVATE LIMITED",
"DISHA FINANCE AND INVESTMENTS PRIVATE LIMITED",
"DISHA FOODS PRIVATE LIMITED",
"DISHA FOUNDATION",
"DISHA GYPSUM PRIVATE LIMITED",
"DISHA HOSPITALITY PRIVATE LIMITED",
"DISHA HOSPITALS PRIVATE LIMITED",
"DISHA HOTELS PRIVATE LIMITED",
"DISHA INDIA MICRO CREDIT",
"DISHA INDUSTRIES LIMITED.",
"DISHA INFIN CONSULTANTS PVT LTD",
"DISHA INFRANIRMAN PRIVATE LIMITED",
"DISHA INTERIORS PRIVATE LIMITED",
"DISHA ISPAT PRIVATE LIMITED",
"DISHA JUTE AND ALLIED PRODUCTS PRIVATE LIMITED",
"DISHA LOHARUKA INFRATECH PRIVATE LIMITED",
"DISHA MEDICAL SERVICES PRIVATE LIMITED",
"DISHA NURSING HOME PRIVATE LIMITED",
"DISHA PAINT PVT. LTD.",
"DISHA PAPER VENTURE PRIVATE LIMITED",
"DISHA PERSONNEL AND SECURITY SERVICES PRIVATE LIMITED",
"DISHA REALCON PRIVATE LIMITED",
"DISHA RESOURCES LIMITED",
"DISHA RETAIL FIXTURES PRIVATE LIMITED",
"DISHA SCHOOL FOR SPECIAL CHILDREN",
"DISHAA IPSUM PRIVATE LIMITED",
"DISHAA POWER CORPORATION PRIVATE LIMITED",
"DISHAAN HOLIDAYS PRIVATE LIMITED",
"DISHAGARDEN VIEW LLP",
"DISHANT IMPEX PRIVATE LIMITED",
"DISHARI HEALTH POINT PRIVATE LIMITED",
"DISHAWAVES INFONET PRIVATE LIMITED",
"DISHINDER INFRASTRUCTURE PRIVATE LIMITED",
"DISHITA VENTURES PRIVATE LIMITED",
"DISHLAA MARKETING PRIVATE LIMITED",
"DISHMAAN ENTERPRISES",
"DISHMAN CARBOGEN AMCIS LIMITED",
"DISHMAN PHARMACEUTICALS AND CHEMICALS LIMITED",
"DISHU EXPORTS (INDIA) PRIVATE LIMITED",
"DISHUM BROADCASTING PRIVATE LIMITED",
"DISHYA TECHNOLOGIES PRIVATE LIMITED",
"DISINFECTO CHEMICAL INDUSTRIES PRIVATE LIMITED",
"DISK FINANCE AND INVESTMENTS PRIVATE LIMITED",
"DISNEY BROADCASTING (INDIA) PRIVATE LIMITED",
"DISNEY BROADCASTING INDIA LIMITED",
"DISNEY ENTERTAINMENT (INDIA) PRIVATE LIMITED",
"DISNEY ENTERTAINMENT INDIA LIMITED",
"DISNEY POULTRY PRIVATE LIMITED",
"DISNEY WORLDWIDE SERVICE",
"DISNIL BIOTECH PRIVATE LIMITED",
"DISNYR FIRE ENTERPRISES PRIVATE LIMITED",
"DISPATCHTRACK INDIA PRIVATE LIMITED",
"DISPATCHTRACK SOFTWARE PRIVATE LIMITED",
"DISPO MEDIPRODUCTS INDIA LIMITED",
"DISPOLINE INDIA PRIVATE LIMITED",
"DISPOSAFE HEALTH & LIFE CARE LIMITED.",
"DISPUR HOSPITALS PRIVATE LIMITED",
"DISPUR POLYCLINIC AND HOSPITALS PRIVATE LIMITED",
"DISRUPTIVE ADVANTAGE INDIA PRIVATE LIMITED",
"DISRUPTIVE HEALTH SOLUTIONS PRIVATE LIMITED",
"DISRUPVATION DIGITAL PRIVATE LIMITED",
"DISS COMPUTERS TECHNOLOGIES PRIVATE LIMITED",
"DISST AND SESSION JUDGE HBAD HOSHANGABAD",
"DISST MALARIYA OFFICER BHOPAL MADHYA PRADESH",
"DIST AND SESSION JUDGE KHANDWA",
"DIST EDN OFF CHHINDWARA",
"DIST EVALUATION OFFICER UDR 391",
"DIST EXCISE OFFICE",
"DIST MALARIA OFFICE SANGLI",
"DIST PLANNING OFFICER",
"DIST RURAL DEV DEPT- GOVT RAJ",
"DIST SAINIK WELFARE OFFICER",
"DIST WOMENANDCHILD DEV OFFICER RTM",
"DISTANT HORIZON ORCHARD PVT LTD",
"DISTI CHEMI PROCESS ENGINEERING PRIVATE LIMITED",
"DISTIL EDUCATION & TECHNOLOGY PRIVATE LIMITED",
"DISTILNFO TECHNOLOGIES PRIVATE LIMITED",
"DISTINCT COMMUNICATIONS PRIVATE LIMITED",
"DISTINCT DESTINATIONS PRIVATE LIMITED",
"DISTINCT IMPEX PRIVATE LIMITED",
"DISTINCT ORIGINS PRIVATE LIMITED",
"DISTINCT PAYROLL SERVICES PRIVATE LIMITED",
"DISTINCT SERVICES PRIVATE LIMITED",
"DISTINCT TECHNOCONCEPT PRIVATE LIMITED",
"DISTINGTON ENGINEERS AND CONSULTANTS PVT LTD",
"DISTO PHARMACEUTICALS PRIVATE LIMITED",
"DISTORTION ENERGY PRIVATE LIMITED",
"DISTRCIT T.B. CENTER MORBI",
"DISTRESS ASSET SPECIALIST LIMITED",
"DISTRIBUTION LOGISTICS INFRASTRUCTURE PRIVATE LIMITED",
"DISTRIBUTORS (BOMBAY) PRIVATE LIMITED",
"DISTRIC AND SESSIONS COURT",
"DISTRIC BACKWARD CLASS WELFARE OFFICER",
"DISTRICO INDIA PRIVATE LIMITED",
"DISTRICT AGRICULTURE DEPARTMENT",
"DISTRICT AND SESSION JUDGE BHILWARA",
"DISTRICT AND SESSION JUDGE JABALPUR",
"DISTRICT AND SESSION JUDGE SAGAR",
"DISTRICT AND SESSIONS COURT AGRA",
"DISTRICT AND SESSIONS COURT AURANGABAD",
"DISTRICT AND SESSIONS COURT JALNA",
"DISTRICT AND SESSIONS COURT JUNAGADH",
"DISTRICT AND SESSIONS COURT LUCKNOW",
"DISTRICT AND SESSIONS COURT PUNE",
"DISTRICT AND SESSIONS COURT SANT KABIR NAGAR",
"DISTRICT AND SESSIONS COURT SOLAPUR",
"DISTRICT ANIMAL HUSBANDRY",
"DISTRICT AYURVED BILASPUR",
"DISTRICT AYURVED OFFICE RAIGARH CHHATTSIGARH",
"DISTRICT AYURVED OFFICE-JAIPUR",
"DISTRICT AYURVEDA MEDICAL OFFICER EASTERN CIRCLE BHUBANESWAR",
"DISTRICT AYURVEDA MEDICAL OFFICERS",
"DISTRICT AYURVEDIC MEDICAL OFFICER BARGARH",
"DISTRICT AYUSH OFFICER RATLAM",
"DISTRICT CENTRAL CO-OPERATIVE BANK RATLAM",
"DISTRICT CHILD PROTECTION UNITS",
"DISTRICT COLLECTORATE JABALPUR",
"DISTRICT COMMANDANT HOMEGUARDS",
"DISTRICT COMMANDENT HOME GUARDS",
"DISTRICT COMMANDENT SDERF RATLAM",
"DISTRICT CONSUMER DISPUTES REDREEAL COMMISSTION",
"DISTRICT CO-OPERATIVE BANK LTD",
"DISTRICT COOPERATIVE BANK RAIPUR",
"DISTRICT COURT",
"DISTRICT DEVELOPMENT OFFICER",
"DISTRICT E GOVERNANCE SOCIETY OFFICE OF THE COLLECTOR",
"DISTRICT E GOVERNANCVE SOCIETY JABALPUR OFFICE OF THE COLLECTOR",
"DISTRICT EDUCATION COMMITEE MAHESANA",
"DISTRICT EDUCATION COMMITTEE BHARUCH",
"DISTRICT EDUCATION COMMITTEE CHHOTAUDEPUR",
"DISTRICT EDUCATION COMMITTEE DANG",
"DISTRICT EDUCATION COMMITTEE MORBI",
"DISTRICT EDUCATION COMMITTEE NAVSARI",
"DISTRICT EDUCATION COMMITTEE RAJKOT",
"DISTRICT EDUCATION COMMITTEE SURAT",
"DISTRICT EDUCATION COMMITTEE VADODARA",
"DISTRICT EDUCATION DEPARTMENT GANDHINAGAR",
"DISTRICT EDUCATION OFFICE",
"DISTRICT EDUCATION OFFICE SAMASTIPUR",
"DISTRICT EDUCATION OFFICER ANGUL",
"DISTRICT EDUCATION OFFICER BALASORE",
"DISTRICT EDUCATION OFFICER BHADRAK",
"DISTRICT EDUCATION OFFICER CUTTACK",
"DISTRICT EDUCATION OFFICER CUTTACK NUABAZAR HIGH SCHOOL",
"DISTRICT EDUCATION OFFICER DHENKANAL",
"DISTRICT EDUCATION OFFICER JAGATSINGHPUR",
"DISTRICT EDUCATION OFFICER KHANDWA",
"DISTRICT EDUCATION OFFICER KHURDA",
"DISTRICT EDUCATION OFFICER ODISHA",
"DISTRICT EDUCATION OFFICER PURI",
"DISTRICT EDUCATION OFFICER VIDISHA MADHYA PRADESH",
"DISTRICT EMPLOYMENT EXCHANGE PURI",
"DISTRICT FEMALE HOSPITAL VARANASI",
"DISTRICT FIGHTER DISASTER MANAGEMENT BHOPAL",
"DISTRICT GENERAL HOSPITAL AMRAVATI",
"DISTRICT HANDICAPPED REHABILITATION CENTRE",
"DISTRICT HEALTH & FAMILY WELFARE SAMITI",
"DISTRICT HEALTH AND FAMILY WELFARE SOCIETY DAKSHINA KANNADA",
"DISTRICT HEALTH OFFICE",
"DISTRICT HEALTH OFFICE SONGADH",
"DISTRICT HEALTH OFFICE ZILLA PARISHAD",
"DISTRICT HEALTH OFFICE ZILLA PARISHAD NASIK",
"DISTRICT HEALTH OFFICER ZILLA PARISHAD",
"DISTRICT HEALTH OFFICER ZILLA PARISHD NUNDURBAR",
"DISTRICT HEALTH SOCIETY LUCKNOW",
"DISTRICT HOMEOPATHIC MEDICAL OFFICER",
"DISTRICT HOMEOPATHIC OFFICER URSHALA PARADE KANPUR NAGAR",
"DISTRICT HOMOEOPATHIC OFFICE AGRA",
"DISTRICT HOMOEOPATHIC OFFICE BARABANKI",
"DISTRICT HOMOEOPATHIC OFFICER KANPUR DEHAT",
"DISTRICT HORTICULTURE OFFICER",
"DISTRICT HOSPITAL",
"DISTRICT INDUSRTIES CENTER",
"DISTRICT INDUSTRIES CENTER BHARUCH",
"DISTRICT INSPECTOR LAND RECORDS",
"DISTRICT INSPECTROR OF SCHOOLS",
"DISTRICT INSTITUTE OF EDUCATION AND TRAINING",
"DISTRICT INSTITUTE OF EDUCATION TECHNO",
"DISTRICT INTEGRATED HEALTH & FAMILY WELFARE SOCIETY CHANDRAPUR",
"DISTRICT INTEGRATED HEALTH & FAMILY WELFARE SOCIETY LATUR",
"DISTRICT INTEGRATED HEALTH & FAMILY WELFARE SOCIETY WARDHA",
"DISTRICT JUDDGE",
"DISTRICT JUDGE",
"DISTRICT LABOUR OFF VIDISHA",
"DISTRICT LEGAL AUTHORITY SABARKANTHA",
"DISTRICT LEPROSY OFFICE NAVSARI",
"DISTRICT MAGISTRATE COLLECTORATE",
"DISTRICT MALARIA OFFICER",
"DISTRICT MALARIA OFFICER SURGUJA AMBIKAPUR",
"DISTRICT MALERIYA OFFICE AMRAVATI",
"DISTRICT MINORITY WELFARE OFFICER ALLAHABAD PRAYAGRAJ",
"DISTRICT MISSION MANAGAMENT UNIT KAMRUP ASSAM STATE RURAL LIVELIHOODS MISSION",
"DISTRICT MISSION MANAGEMENT UNIT AMRAVATI",
"DISTRICT MISSION MANAGEMENT UNIT TNSRLM PUDUKKOTTAI",
"DISTRICT ORGANISER TRIBEL WELFARE INDORE",
"DISTRICT PANCHAYAT ALIGARH",
"DISTRICT PANCHAYAT EDUCATION COMMITTEE NAVSARI",
"DISTRICT PANCHAYAT EDUCATION COMMITTEE VALSAD",
"DISTRICT PANCHAYAT EDUCATION DEPARTMENT VALSAD",
"DISTRICT PANCHAYAT EDUCATION OFFICE",
"DISTRICT PANCHAYAT JAMNAGAR",
"DISTRICT PANCHAYAT MORBI",
"DISTRICT PANCHAYAT NADIAD",
"DISTRICT PANCHAYAT RAJ OFFICER",
"DISTRICT PANCHAYAT RAJKOT",
"DISTRICT PANCHAYAT SURAT (HEALTH DEPT)",
"DISTRICT PLANNING COMMITTEE",
"DISTRICT PLANNING OFFICE NAVSARI",
"DISTRICT PLANNING OFFICER PROJECT KHANDWA",
"DISTRICT PRIMARY EDUCATION COMMITTEE",
"DISTRICT PROBATION & AFTER CARE ASSOCIATION PUNE",
"DISTRICT PROGRAME OFFICER KANPUR",
"DISTRICT PROGRAMME OFFICE",
"DISTRICT PROJECT COORDINATOR AHMEDABAD",
"DISTRICT REGISTRAR CO OPERATIVE SOCIETY",
"DISTRICT RURAL DEVELOPMENT AGENCY",
"DISTRICT RURAL DEVELOPMENT AGENCY BHARUCH",
"DISTRICT SAINIK WELFARE & RESETTLEMENT OFFICE",
"DISTRICT SERCULTURE OFFICE JALNA",
"DISTRICT SKILL DEVELOPMENT EMPLOYMENT AND ENTREPRENEURSHIP GUIDANCE CENTRE SOLAPUR",
"DISTRICT SMALL SAVING OFFICER SAMBALPUR",
"DISTRICT SPECIAL AUDITOR CL-1",
"DISTRICT STATISTICAL OFFICE LATUR",
"DISTRICT STATISTICAL OFFICER T T NAGAR BHOPAL",
"DISTRICT SUPERITENDING AGRICULTURAL OFFICER",
"DISTRICT SUPPLY OFFICE GANDHINAGAR",
"DISTRICT SUPPLY OFFICER",
"DISTRICT TB OFFICE AGRA",
"DISTRICT TB OFFICE UNNAO",
"DISTRICT TEHSIL KHAIR ALIGARH",
"DISTRICT TREASURY OFFICE AMRAVATI",
"DISTRICT TREASURY OFFICE JABALPUR",
"DISTRICT TREASURY OFFICE KHANDWA",
"DISTRICT TREASURY OFFICE PUNE",
"DISTRICT TREASURY OFFICER DEWAS",
"DISTRICT TUBERCULOSIS OFFICE AHMEDNAGAR",
"DISTRICT TUBERCULOSIS OFFICER",
"DISTRICT VOCATIONAL EDUCATION AND TRAINING OFFICER AHMEDNAGAR",
"DISTRICT WELFARE OFFICER",
"DISTRICT WELFARE OFFICER PURI",
"DISTRICT WOMEN AND CHILD DEVELOPMENT OFFICER",
"DISTRICT WOMEN HOSPITAL",
"DISTRINDIA PRIVATE LIMITED",
"DISTROMED BIO CLEAN PRIVATE LIMITED",
"DISTT AAYUSH OFFICER",
"DISTT AND SESSION JUDGE BHOPAL MADHYA PRADESH",
"DISTT AND SESSION JUDGE HOSHANGABAD",
"DISTT AND SESSION JUDGE RATLAM",
"DISTT AND SESSION JUDGE SEHORE MADHYA PRADESH",
"DISTT AND SESSION JUDGE UJJAIN",
"DISTT AYUSH OFFICER CHHINDWARA",
"DISTRICT AYUSH OFFICER UJJAIN",
"DISTT COMMANDENT HOME GUARDS DEWAS",
"DISTT COMMENDENT H G RATLAM",
"DISTT EXCISE OFFICER DEWAS",
"DISTT EXCISE OFFICER KHANDWA",
"DISTT EXCISE OFFICER RATLAM",
"DISTT MALARIA OFFICER",
"DISTT MALARIYA OFFICER BHOPAL",
"DISTT ORGANISOR TRIBAL WELFARE DEPART UJJAIN",
"DISTT PROGRAMME OFFICER WOMEN AND CHILD DEVLOPMENT RAISEN",
"DISTT PROGRAMME OFFICER WOMEN AND CHIND DEV SEHORE",
"DISTT REGISTRAR STAMP RATLAM",
"DISTT SAINIK WELFARE OFFICER UJJAIN",
"DISTT TREASURY OFFICER UJJAIN",
"DISTT.EDUCATION OFFICER JHABUA",
"DEXIAN INDIA TECHNOLOGIES PRIVATE LIMITED",
"DIT EDUCATION FOUNDATION",
"DIT INTERACTIVE PRIVATE LIMITED",
"DIT UNIVERSITY",
"DITAP V AUTOMATION PRIVATE LIMITED",
"DITCON PRIVATE LIMITED",
"DITECH CREATIVE AND DIGITAL MARKETING PRIVATE LIMITED",
"DI-TECH ENGINEERING PRIVATE LIMITED",
"DITECH PROCESS SOLUTIONS PRIVATE LIMITED",
"DITECH PUBLISHING SERVICES PRIVATE LIMITED",
"DITI AUTOMOBILES PRIVATE LIMITED",
"DITI RESOURCES PRIVATE LIMITED",
"DITINUS TECHNOLOGY (OPC) PRIVATE LIMITED",
"DITPRA INDUSTRIES PRIVATE LIMITED",
"DITRING TRADING PRIVATE LIMITED",
"DITRINITY TECHNOLOGIES PRIVATE LIMITED",
"DITSTEK INNOVATIONS PRIVATE LIMITED",
"DITTEX EXPORTZS PRIVATE LIMITED",
"DITVI EXPORTS PRIVATE LIMITED",
"DITYA FINANCE PRIVATE LIMITED",
"DIUS DESIGN CONSULTANTS PRIVATE LIMITED",
"DIUS LANDSCAPE PRIVATE LIMITED",
"DIVA AIR AND RESOURCES (RAICHUR)PRIVATE LIMITED",
"DIVA CHEM-TECH EQUIPMENTS PRIVATE LIMITED",
"DIVA CLASSIC JEWELS AND GEMS PRIVATE LIMITED",
"DIVA ENTERPRISES PRIVATE LIMITED",
"DIVA ENVITEC PRIVATE LIMITED",
"DIVA EXPORTS PRIVATE LIMITED",
"DIVA HEARING SPECIALISTS PRIVATE LIMITED",
"DIVA JYOTE PORTFOLIOS PRIVATE LIMITED",
"DIVA RAVI AGRO & FOUNDERS PRIVATE LIMITED",
"DIVA SPA & WELLNESS PRIVATE LIMITED",
"DIVA TEXLINK PRIVATE LIMITED",
"DIVAA GLAM PRIVATE LIMITED",
"DIVAANTA TRADING LLP",
"DIVAKAR ENGINEERING PRIVATE LIMITED",
"DIVAKAR TECHNO SPECIALITIES & CHEMICALS PRIVATE LIMITED",
"DIVAKARAN STORAGE AND HANDLING SYSTEMS PRIVATE LIMITED",
"DIVAMI DESIGN LABS PRIVATE LIMITED",
"DIVAN BALLUBHAI SECONDARY SCHOOL",
"DIVAR CHEMICALS PRIVATE LIMITED",
"DIVAS MANTRA PRIVATE LIMITED",
"DIVAY ANGELS REALTOR PRIVATE LIMITED",
"DIVEKAR AUTO PRIVATE LIMITED",
"DIVEKAR HOSPITAL",
"DIVEKAR WALLSTABE & SCHNEIDER PRECISION SEALS PRIVATE LIMITED",
"DIVENCE TECHNO PRIVATE LIMITED",
"DIVENSI SOLUTIONS PRIVATE LIMITED",
"DIVERGENT BUSINESS ADVISORY SERVICE INDIA PRIVATE LIMITED",
"DIVERGENT INFOSOFT TECHNOLOGIES PRIVATE LIMITED",
"DIVERGENT SOFTWARE LABS PRIVATE LIMITED",
"DIVERSE BUSINESS HOLDINGS PRIVATE LIMITED",
"DIVERSE DESTINATION TRAVEL PRIVATE LIMITED",
"DIVERSE ED MEDIA PRIVATE LIMITED",
"DIVERSE INFOTECH PRIVATE LIMITED",
"DIVERSE LINE IMPEX PRIVATE LIMITED",
"DIVERSE LYNX INDIA PRIVATE LIMITED",
"DIVERSE RETAILS PRIVATE LIMITED",
"DIVERSE WEB STRATEGIES PRIVATE LIMITED",
"DIVERSEY INDIA HYGIENE PRIVATE LIMITED",
"DIVERSIFIED AV INDIA PRIVATE LIMITED",
"DIVERSIFIED COMMUNICATIONS INDIA PRIVATE LIMITED",
"DIVERSIFIED VYPAR PRIVATE LIMITED",
"DIVERSITECH GENERAL ENGINEERING PVT LTD",
"DIVGI HOLDINGS PRIVATE LIMITED",
"DIVGI TORQTRANSFER SYSTEMS LIMITED",
"DIVGI TORQTRANSFER SYSTEMS PRIVATE LIMITED",
"DIVI ACCOUENTS OFFICER FOR E/A E I RTM MADHYA PRADESH",
"DIVI ENTERPRISES",
"DIVI NUTRITION PRIVATE LIMITED",
"DIVIDER PARTITION SYSTEM PRIVATE LIMITED",
"DIVIJ AGRO ORGANIC PRIVATE LIMITED",
"DIVIJ FINANCE PVT LTD",
"DIVIJ PROJECTS PRIVATE LIMITED",
"DIVIJA COMMERCIAL PROPERTIES PRIVATE LIMITED",
"DI-VINCI INNOVATIVE DESIGN SOLUTIONS PRIVATE LIMITED",
"DIVINE (INDIA) INFRASTRUCTURE PRIVATE LIMITED",
"DIVINE ATMOS PRIVATE LIMITED",
"DIVINE AUTOMOTIVES PRIVATE LIMITED",
"DIVINE AUTOTECH PRIVATE LIMITED",
"DIVINE BACCHUS PRIVATE LIMITED",
"DIVINE BEVERAGES PRIVATE LIMITED",
"DIVINE BLOSSOM PRIVATE LIMITED",
"DIVINE BOARD PRIVATE LIMITED",
"DIVINE CAMPHORS PRIVATE LIMITED",
"DIVINE CHAIRS PRIVATE LIMITED",
"DIVINE CHILD INTERNATIONAL SCHOOL",
"DIVINE COLLECTION EXPORTS PRIVATE LIMITED",
"DIVINE COSMETICS LLP",
"DIVINE CROPS AND ALLIED PRODUCTS PRIVATE LIMITED",
"DIVINE DEVELOPERS LIMITED",
"DIVINE DYESTUFF PRIVATE LIMITED",
"DIVINE EMPIRE INDIA PRIVATE LIMITED",
"DIVINE ENDEAVOURS PRIVATE LIMITED",
"DIVINE ENGINEERING SERVICES PRIVATE LIMITED",
"DIVINE ENGINEERS & INFRA PRIVATE LIMITED",
"DIVINE ENTERPRISES PRIVATE LIMITED",
"DIVINE FINANCIAL MANAGEMENT PRIVATE LIMITED",
"DIVINE FORGE PVT LTD",
"DIVINE FREIGHT SOLUTIONS PRIVATE LIMITED",
"DIVINE FUEL SERVICES PRIVATE LIMITED",
"DIVINE GROCERIES PRIVATE LIMITED",
"DIVINE HEALTH CARE",
"DIVINE HEART HOSPITAL & RESEARCH CENTRE PRIVATE LIMITED",
"DIVINE HOUSING DEVELOPMENT COMPANY PRIVATE LIMITED",
"DIVINE INFRACON PRIVATE LIMITED",
"DIVINE INTERNATIONAL PRIVATE LIMITED",
"DIVINE LABORATORIES PRIVATE LIMITED",
"DIVINE LIFE CARE PRIVATE LIMITED",
"DIVINE LIGHT SCHOOL",
"DIVINE MACHINES PRIVATE LIMITED",
"DIVINE MANTRA PRIVATE LIMITED",
"DIVINE MATERIAL PRIVATE LIMITED",
"DIVINE MEDICAL CENTRE LIMITED",
"DIVINE MEDITECH PRIVATE LIMITED",
"DIVINE MERCY ENGLISH HIGH SCHOOL",
"DIVINE MERCY SCHOOL",
"DIVINE METALLURGICAL SERVICES PRIVATE LIMITED",
"DIVINE MOTORS PRIVATE LIMITED",
"DIVINE ORGANICS LIMITED",
"DIVINE OUTSOURCING SOLUTIONS PRIVATE LIMITED",
"DIVINE OVERSEAS PRIVATE LIMITED",
"DIVINE PALM INTERNATIONAL SCHOOL",
"DIVINE PAPER PRODUCTS PRIVATE LIMITED",
"DIVINE PLANET PRIVATE LIMITED",
"DIVINE POWER ENERGY LIMITED",
"DIVINE PROVIDENCE SCHOOL",
"DIVINE PUBLIC SCHOOL",
"DIVINE REALTECH PRIVATE LIMITED",
"DIVINE SAINIK SCHOOL VARANASI",
"DIVINE SAVIOR PRIVATE LIMITED",
"DIVINE SOFTECH PRIVATE LIMITED",
"DIVINE SOLREN PRIVATE LIMITED",
"DIVINE SOLUTIONS PRIVATE LIMITED",
"DIVINE STAR",
"DIVINE SUITING PRIVATE LIMITED",
"DIVINE SURFACES PRIVATE LIMITED",
"DIVINE SYNTHETICS PRIVATE LIMITED",
"DIVINE TECHNOBUILD PRIVATE LIMITED",
"DIVINE TECHNOZONE PRIVATE LIMITED",
"DIVINE THERMAL WRAP PRIVATE LIMITED",
"DIVINE TITANIUM PRIVATE LIMITED",
"DIVINE TRANS LOGISTICS INDIA PRIVATE LIMITED",
"DIVINE TUBES PRIVATE LIMITED",
"DIVINE UTILITY SERVICES PRIVATE LIMITED",
"DIVINE VISION INFRAESTATE PRIVATE LIMITED",
"DIVINE VISION INFRA-RETAIL PRIVATE LIMITED",
"DIVINI SOFTWARE PRIVATE LIMITED",
"DIVINITEE GENESIS APPAREL PRIVATE LIMITED",
"DIVINITI ENTERPRISES INDIA PRIVATE LIMITED",
"DIVINITY CRAFTS EXPORT PRIVATE LIMITED",
"DIVINITY LIGHTS PRIVATE LIMITED",
"DIVINNE SBR INTERNATIONAL PRIVATE LIMITED",
"DIVINUS EXPRESS LOGISTICS PRIVATE LIMITED",
"DIVINUTTY PRODUCTS PRIVATE LIMITED",
"DIVIPEX OVERSEAS PRIVATE LIMITED",
"DIVI'S BIOTECH PRIVATE LIMITED",
"DIVI'S LABORATORIES LIMITED",
"DIVI'S PROPERTIES PRIVATE LIMITED",
"DIVISH HOTEL AND RESORTS PRIVATE LIMITED",
"DIVISH PACKAGING PVT LTD",
"DIVISION OF PLANT PATHOLOGY",
"DIVISION OFFICE AGRA COOPERATIVE",
"DIVISION OFFICE BOARD OF SECONDARY EDUCATION",
"DIVISIONAL AYURVEDIC & UNANI OFFICER VARANASI",
"DIVISIONAL COMMANDANT HOME GUARDS INDORE DIVISION",
"DIVISIONAL DY COMMISSIONER COMMERCIAL TAX JABALPUR DIV 1 MADHYA PRADESH",
"DIVISIONAL FIRE OFFICE",
"DIVISIONAL FOREST OFFICE",
"DIVISIONAL FOREST OFFICER KHURDA DIVISION",
"DIVISIONAL JOINT DIRECTOR OF AGRI",
"DIVISIONAL JOINT REGISTRAR C S AMRAVATI",
"DIVIT NUTRACEUTICALS PRIVATE LIMITED",
"DIVITIA CONSULTING PRIVATE LIMITED",
"DIVNA LOGISTICS INDIA PRIVATE LIMITED",
"DIVO TV PRIVATE LIMITED",
"DIVON ROCK PRODUCTS PRIVATE LIMITED",
"DIVS POWER TOOLS PRIVATE LIMITED",
"DIVUM CORPORATE SERVICES PRIVATE LIMITED",
"DIVVY SOLAR POWER AND SOLUTIONS PRIVATE LIMITED",
"DIVVYA ADVISORY & CONSULTANCY PRIVATE LIMITED",
"DIVY CARS PRIVATE LIMITED",
"DIVY CONCASTS AND CONSTRUCTIONS PRIVATE LIMITED",
"DIVY POWER PRIVATE LIMITED",
"DIVY ROLLFORM LIMITED",
"DIVYA AGRO ROLLER FLOUR MILLS PRIVATE LIMITED",
"DIVYA AIR PRODUCTS LIMITED",
"DIVYA ALCOBEV PRIVATE LIMITED",
"DIVYA ALOK HOSPITAL PRIVATE LIMITED",
"DIVYA APPARELS PRIVATE LIMITED",
"DIVYA AUTO ENGINEERS PRIVATE LIMITED",
"DIVYA BROADCASTING NETWORK PRIVATE LIMITED",
"DIVYA CAPITAL ONE PRIVATE LIMITED",
"DIVYA CAPITAL SERVICES LIMITED",
"DIVYA CAR RENTAL PRIVATE LIMITED",
"DIVYA CONSTRUCTION COMPANY",
"DIVYA DARSHAN METALLICA",
"DIVYA DIGITAL NETWORK PRIVATE LIMITED",
"DIVYA ELECTRICAL TRANSFORMERS AND SERVICES PRIVATE LIMITED",
"DIVYA ENGG.WORKS PRIVATE LIMITED",
"DIVYA ENGICON PRIVATE LIMITED",
"DIVYA ESTATES PVT LTD",
"DIVYA EXPORTS PRIVATE LIMITED",
"DIVYA FARMING PVT LTD",
"DIVYA FASHIONS PRIVATE LIMITED",
"DIVYA GLOBAL PRIVATE LIMITED",
"DIVYA HIMACHAL PRAKASHAN PRIVATE LIMITED",
"DIVYA HOSPITAL",
"DIVYA INCENSE (INDIA) PRIVATE LIMITED",
"DIVYA INFRA PROPERTIES PRIVATE LIMITED",
"DIVYA INFRAREALITY PRIVATE LIMITED",
"DIVYA JEWELLERS PRIVATE LIMITED",
"DIVYA JYOTHY PRINT&PACKAGING PRIVATE LIMITED",
"DIVYA JYOTI AGRITECH PRIVATE LIMITED",
"DIVYA KITCHENWARE PRIVATE LIMITED",
"DIVYA MAN POWER RESOURCES PRIVATE LIMITED",
"DIVYA MARKETING",
"DIVYA MEDIA PUBLICATIONS PRIVATE LIMITED",
"DIVYA MULTIGRAINS PRIVATE LIMITED",
"DIVYA NEXTGEN ENGICON PRIVATE LIMITED",
"DIVYA PACKING PVT LTD",
"DIVYA PACKMAF PRIVATE LIMITED",
"DIVYA PHARMACY",
"DIVYA PHARMACY RANCHI",
"DIVYA PLY AGENCY PRIVATE LIMITED",
"DIVYA PORTFOLIO PRIVATE LIMITED",
"DIVYA PRABHAT PUBLICATIONS PRIVATE LIMITED",
"DIVYA PRASTHA HOSPITAL",
"DIVYA PRASTHA SUPER MULTISPECIALITY HEALTHCARE PRIVATE LIMITED",
"DIVYA REFINERIES PRIVATE LIMITED",
"DIVYA RESTAURANTS AND HOTELS PRIVATE LIMITED",
"DIVYA SAI LAM PRIVATE LIMITED",
"DIVYA SAI WOOD PANELS PRIVATE LIMITED",
"DIVYA SALT PRIVATE LIMITED",
"DIVYA SHAKTI MARKETING PRIVATE LIMITED",
"DIVYA SHARE SERVICES PRIVATE LIMITED",
"DIVYA SHIPPING AND CLEARING SERVICES PRIVATE LIMITED",
"DIVYA SIMANDHAR CONSTRUCTION PRIVATE LIMITED",
"DIVYA SOAPS PVT LTD",
"DIVYA SPINNING MILL PRIVATE. LIMITED.",
"DIVYA STEEL NAGPUR PRIVATE LIMITED",
"DIVYA SWAROOPA FINANCIAL SERVICES PRIVATE LIMITED",
"DIVYA YOG MANDIR",
"DIVYA-AANCHAL RE-ROLLING PRIVATE LIMITED",
"DIVYABHANU MERCANTILE PRIVATE LIMITED",
"DIVYABHIRAMI AGRO SALES PRIVATE LIMITED",
"DIVYABHUMI INFRA PRIVATE LIMITED",
"DIVYADEEPA AUTO VENTURES PRIVATE LIMITED",
"DIVYADHAN CONSULTANTS PRIVATE LIMITED",
"DIVYADHAN RECYCLING INDUSTRIES PRIVATE LIMITED",
"DIVYADIVINE INDIA PRIVATE LIMITED",
"DIVYADRISHTI BUILDCON PRIVATE LIMITED",
"DIVYADRISHTI EYE CENTRE PRIVATE LIMITED",
"DIVYAGANESH AWAS PRIVATE LIMITED",
"DIVYAGURU SERVICES PRIVATE LIMITED",
"DIVYAGYAN TRADING PRIVATE LIMITED",
"DIVYAKASHI APPARELS PRIVATE LIMITED",
"DIVYAKIRAN AGRO PROCESSING PRIVATE LIMITED",
"DIVYALAKSHMI TEXTILES PRIVATE LIMITED",
"DIVYAM COMMERCIAL PRIVATE LIMITED",
"DIVYAM EDUCOM PRIVATE LIMITED",
"DIVYAM EXPRESS & LOGISTICS PRIVATE LIMITED",
"DIVYAM HOSPITAL",
"DIVYAM PIPES AND TUBE PRIVATE LIMITED",
"DIVYAM REAL ESTATE PRIVATE LIMITED",
"DIVYAM SHIPPING PRIVATE LIMITED",
"DIVYAM TRANSFORMERS PRIVATE LIMITED",
"DIVYAMOTI HOTELS AND RESORTS PRIVATE LIMITED",
"DIVYANCHAL FARMER PRODUCER COMPANY LIMITED",
"DIVYANG INFOWORLD PRIVATE LIMITED",
"DIVYANG SHAKTI KARAN VIBHAG",
"DIVYANK ENGINEERING PRIVATE LIMITED",
"DIVYANSH BUILDTECH PRIVATE LIMITED",
"DIVYANSH EARTH DEVELOPERS PRIVATE LIMITED",
"DIVYANSH EXPORT & IMPORT PRIVATE LIMITED",
"DIVYANSH HOMES PRIVATE LIMITED",
"DIVYANSH INFOTECH PRIVATE LIMITED",
"DIVYANSH INFRAHEIGHT PRIVATE LIMITED",
"DIVYANSH JEWELLERS PRIVATE LIMITED",
"DIVYANSH METAL PRIVATE LIMITED",
"DIVYANSH PROMOTERS & DEVELOPERS PRIVATE LIMITED",
"DIVYANSH REALTORS PRIVATE LIMITED",
"DIVYANSH SERVICES & TRADING PRIVATE LIMITED",
"DIVYANSH STEEL PRIVATE LIMITED",
"DIVYANSH YARN AGENCY PRIVATE LIMITED",
"DIVYANSHI AVIATION SERVICES PRIVATE LIMITED",
"DIVYANSHI CAPITAL INSURANCE MARKETING PRIVATE LIMITED",
"DIVYANSHI CAPITAL PRIVATE LIMITED",
"DIVYANSHI DEVELOPERS PRIVATE LIMITED",
"DIVYANSHI GEMS PRIVATE LIMITED",
"DIVYANSHI TEXTILE MACHINERY PRIVATE LIMITED",
"DIVYANSHU ENTERPRISESS",
"DIVYAPATH COMMTRADE PRIVATE LIMITED",
"DIVYAPATH HIGHER SECONDARY SCHOOL",
"DIVYARAJ FOREX PRIVATE LIMITED",
"DIVYARAM MEDICAL AND RESEARCH INSTITUTE PRIVATE LIMITED",
"DIVYARAM TALKIES PRIVATE LIMITED",
"DIVYAROOPA INFRACON PRIVATE LIMITED",
"DIVYAROSHNI HEALTH CARE AND RESEARCH CENTER PRIVATE LIMITED",
"DIVYASHAKTI FONES PRIVATE LIMITED",
"DIVYASHAKTI FOODS PRIVATE LIMITED",
"DIVYASHAKTI LIMITED",
"DIVYASHRI LOGISTICS INDIA PRIVATE LIMITED",
"DIVYASREE BUILDTECH CONTRACTORS PRIVATE LIMITED",
"DIVYASREE DEVELOPERS PRIVATE LIMITED",
"DIVYASREE HOLDINGS PRIVATE LIMITED",
"DIVYASREE INFRASTRUCTURE DEVELOPERS PRIVATE LIMITED",
"DIVYASREE INFRASTRUCTURE PROJECTS PRIVATE LIMITED",
"DIVYASREE NSL INFRASTRUCTURE PRIVATE LIMITED",
"DIVYASREE R.O.W.PROJECTS PRIVATE LIMITED",
"DIVYASREE TARBUS BUILDERS PRIVATE LIMITED",
"DIVYASREE TECH PARK CONTRACTORS PRIVATE LIMITED",
"DIVYESH GEMS PRIVATE LIMITED",
"DIVYESH POWER PRIVATE LIMITED",
"DIVYYA ESTATE AGENCY",
"DIWA ENVIROMENT PROJECT PRIVATE LIMITED",
"DIWA INNOVATIONS LIMITED",
"DIWAKAR ENTERPRISES PVT LTD",
"DIWAKAR FINVEST PRIVATE LIMITED",
"DIWAKAR JEWELLERS PRIVATE LIMITED",
"DIWAKAR MOTORS PRIVATE LIMITED",
"DIWAKAR RENEWABLE & INFRA PRIVATE LIMITED",
"DIWAKAR'S EMPLOYMENT PRIVATE LIMITED",
"DIWALI MERCANTILE PRIVATE LIMITED",
"DIWAN BALLUBHAI MADHYAMIK SHALA",
"DIWAN CHAND MEDICAL SERVICES PRIVATE LIMITED",
"DIWAN INFRAPROJECTS PRIVATE LIMITED",
"DIWAN MUNDHRA BROTHERS PRIVATE LIMITED",
"DIWAN OVERSEAS & SINGLA SANITARY",
"DIWAN SAHEB FASHIONS PRIVATE LIMITED",
"DIWANKA ENERGY PRIVATE LIMITED",
"DIWANKA IRON AND STEEL COMPANY PRIVATE LIMITED",
"DIWANSONS JEWELLERS PRIVATE LIMITED",
"DIWANTHAM TOLLWAY PRIVATE LIMITED",
"DIX ENGINEERING PROJECT SERVICES PRIVATE LIMITED",
"DIXCON INFRA PRIVATE LIMITED",
"DIXIE AUTO ELECTRIC INDIA PRIVATE LIMITED",
"DIXIT CONSTRUCTIONS PRIVATE LIMITED",
"DIXIT DISTRIBUTORS PRIVATE LIMITED",
"DIXIT HEALTH CARE PRIVATE LIMITED",
"DIXIT ICE AND COLD STORAGE PRIVATE LIMITED",
"DIXIT IMPEX PRIVATE LIMITED",
"DIXIT INDUSTRIAL SECURITY PRIVATE LIMITED",
"DIXIT INFOTECH SERVICES PRIVATE LIMITED",
"DIXON ELECTRO APPLIANCES PRIVATE LIMITED",
"DIXON ELECTRO MANUFACTURING PRIVATE LIMITED",
"DIXON HEALTHCARE NUTRIENTS AND SUPPLEMENTS PRIVATE LIMITED",
"DIXON HEALTHCARE PRIVATE LIMITED",
"DIXON TECHNOLOGIES (INDIA) LIMITED",
"DIXON TECHNOLOGIES INDIA PRIVATE LIMITED",
"DIXONS CARGO CONSOLIDATORS PRIVATE LIMITED",
"DIXQUATRE TECHNOLOGY PRIVATE LIMITED",
"DIY FOOD LABS PRIVATE LIMITED",
"DIYA ADS PRIVATE LIMITED",
"DIYA AGRO COMMODITIES PRIVATE LIMITED",
"DIYA DESIGN STUDIO PRIVATE LIMITED",
"DIYA GOLD PALACE JEWELLERS PRIVATE LIMITED",
"DIYA GREENCITY PRIVATE LIMITED",
"DIYA HYGIENE FLOURS PRIVATE LIMITED",
"DIYA INNOVATIONS PRIVATE LIMITED",
"DIYA INTERNATIONAL PRIVATE LIMITED",
"DIYA MERCHANDISE PRIVATE LIMITED",
"DIYA OMNIA PRIVATE LIMITED",
"DIYA PACKAGING PRIVATE LIMITED",
"DIYA STEELS PRIVATE LIMITED",
"DIYA WIRES (INDIA) PRIVATE LIMITED",
"DIYAN ENGINEERING PRIVATE LIMITED",
"DIYAN FASHIONS PRIVATE LIMITED",
"DIYAN PAPERS LLP",
"DIYAR UNITED PRIVATE LIMITED",
"DIYOS MEN'S HEALTH CENTERS PRIVATE LIMITED",
"DIYOTTA INDIA PRIVATE LIMITED",
"DIYUG FASHIONS PRIVATE LIMITED",
"DIZAN HEALTHCARE",
"DJ (ALAGENDRAN) AUTOMOBILES PRIVATE LIMITED",
"DJ DIGITAL POWER SYSTEMS PRIVATE LIMITED",
"DJ ENERGY PRIVATE LIMITED",
"DJ GREEN STORAGE SOLUTIONS PRIVATE LIMITED",
"DJ INTERACTIVE SOLUTIONS PRIVATE LIMITED",
"DJ MEDIAPRINT & LOGISTICS LIMITED",
"DJ PLUS INDIA PRIVATE LIMITED",
"DJ SONS CONSUMER GOODS PRIVATE LIMITED",
"DJ SWIFT ALLIED SERVICES PRIVATE LIMITED",
"DJ TRADERS",
"DJANGO DIGITAL PRIVATE LIMITED",
"DJCONS ENVOINFRA PRIVATE LIMITED",
"DJDC BATTERY PRIVATE LIMITED",
"DJG IMPEX PRIVATE LIMITED",
"DJH TRADEX PRIVATE LIMITED",
"DJIS DESIGN AND CONSTRUCTION PRIVATE LIMITED",
"DJK INDUSTRIES PRIVATE LIMITED",
"DJO GLOBAL INDIA HEALTHCARE PRIVATE LIMITED",
"DJPR CONSTRUCTIONS PRIVATE LIMITED",
"DJS AQUA PRIVATE LIMITED",
"DJS STOCK AND SHARES LIMITED",
"DJT FINANCIAL SERVICES PRIVATE LIMITED",
"DJT RETAILERS PRIVATE LIMITED",
"DK BAKINGS PRIVATE LIMITED",
"DK CONSTRUCTIONS INDIA PRIVATE LIMITED",
"DK INFRASTRUCTURE PRIVATE LIMITED",
"DK METRO PROCON PRIVATE LIMITED",
"DK SEWAGE PROJECT PRIVATE LIMITED",
"DK SOLAR PROJECTS & VENTURES PRIVATE LIMITED",
"DK WEB-TECH PRIVATE LIMITED",
"DKALRA APPARELS PRIVATE LIMITED",
"DKB OPTICAL INTERNATIONAL PRIVATE LIMITED",
"DKC AGROTECH PRIVATE LIMITED",
"DKC PROJECTS PRIVATE LIMITED",
"DKC TEAHOUSE PRIVATE LIMITED",
"DKC TRADEX PRIVATE LIMITED.",
"DKD FRUITS & VEGETABLES PRIVATE LIMITED",
"DKD IKJOT UNITED PRIVATE LIMITED",
"DKD PROJECTS PRIVATE LIMITED",
"DKG HOTELWARES PRIVATE LIMITED",
"DKI APPAREL PRIVATE LIMITED",
"DKIC PRIVATE LIMITED",
"DKJ SHELTERS PRIVATE LIMITED",
"DKK INDUSTRIAL PRODUCTS INDIA PRIVATE LIMITED",
"DKK PROMOTERS & BUILDERS PRIVATE LIMITED",
"DKM AGRO BIOTECH PRIVATE LIMITED",
"DKM ONLINE PRIVATE LIMITED",
"DKMM CONSTRUCTION MATERIAL PRIVATE LIMITED",
"DKMS BMST FOUNDATION INDIA",
"DKP ENTREPRISES PRIVATE LIMITED",
"DKPL NETWORKS PRIVATE LIMITED",
"DKR IMPEX PRIVATE LIMITED",
"DKS DESICCANTS PRIVATE LIMITED",
"DKS DIGITAL INDIA PRIVATE LIMITED",
"DKS HOSPITALS PRIVATE LIMITED",
"DKS HOTEL PRIVATE LIMITED",
"DKS LOGISTICS PRIVATE LIMITED",
"DKSH INDIA PRIVATE LIMITED",
"DKSORTHO & MEDICAL DEVICES PRIVATE LIMITED",
"DKSORTHO & SHARMA PHARMACEUTICAL PRIVATE LIMITED",
"DKSYT FOODS PRIVATE LIMITED",
"DKT HEALTHCARE INDIA PRIVATE LIMITED",
"DKT TRADING PRIVATE LIMITED",
"DKV FIN LEASE PRIVATE LIMITED",
"DKWEB WORLD",
"DKY LOGISTICS PRIVATE LIMITED",
"DKY PROJECTS PRIVATE LIMITED",
"DL EDUCATIONAL AND HOSPITALITY SERVICES (OPC) PRIVATE LIMITED",
"DL GTPL BROADBAND PRIVATE LIMITED",
"DL GTPL CABNET PRIVATE LIMITED",
"DL JEWEL PRIVATE LIMIETD",
"DL SUPPORT SERVICES INDIA PRIVATE LIMITED",
"DL VALVE PRIVATE LIMITED",
"DLA EQUIPMENTS PRIVATE LIMITED",
"DLA INFRASTRUCTURES PRIVATE LIMITED",
"DLA IRON INDUSTRIES PRIVATE LIMITED",
"DLA METAL INDUSTRIES PRIVATE LIMITED",
"DLAIZ SYSTEMS PRIVATE LIMITED",
"DLC FORWARDERS PRIVATE LIMITED",
"DLECTA FOODS PRIVATE LIMITED",
"DLF ASPINWAL HOTELS PRIVATE LIMITED",
"DLF ASSETS LIMITED",
"DLF ASSETS PRIVATE LIMITED",
"DLF BRANDS LIMITED",
"DLF BRANDS PRIVATE LIMITED",
"DLF BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"DLF BUILDING & SERVICES PRIVATE LIMITED",
"DLF CITY CENTRE LIMITED",
"DLF COMMERCIAL DEVELOPERS LIMITED",
"DLF CYBER CITY DEVELOPERS LIMITED",
"DLF EMPORIO LIMITED",
"DLF EMPORIO RESTAURANTS LIMITED",
"DLF ESTATE DEVELOPERS LIMITED",
"DLF FOUNDATION",
"DLF GARDEN CITY INDORE PRIVATE LIMITED",
"DLF GOLF RESORTS LIMITED",
"DLF HOME DEVELOPERS LIMITED",
"DLF HOMES PANCHKULA PRIVATE LIMITED",
"DLF HOMES SERVICES PRIVATE LIMITED",
"DLF INFO CITY CHENNAI LIMITED",
"DLF INFO CITY DEVELOPERS CHANDIGARH LIMITED",
"DLF INFO CITY DEVELOPERS KOLKATA LIMITED",
"DLF INFO CITY HYDERABAD LIMITED",
"DLF IT OFFICES CHENNAI PRIVATE LIMITED",
"DLF LIMITED",
"DLF LUXURY HOMES LIMITED",
"DLF POWER & SERVICES LIMITED",
"DLF PROJECTS LIMITED",
"DLF PROMENADE LIMITED",
"DLF PROPERTY DEVELOPERS LIMITED",
"DLF PUBLIC SCHOOL GHAZIABAD",
"DLF RESIDENTIAL DEVELOPERS LIMITED",
"DLF RESIDENTIAL PARTNERS LIMITED",
"DLF SOUTHERN HOMES PRIVATE LIMITED",
"DLF SOUTHERN TOWNS PRIVATE LIMITED",
"DLF UNIVERSAL LIMITED",
"DLF UNIVERSAL LIMITED..",
"DLF URBAN PRIVATE LIMITED",
"DLF UTILITIES LIMITED",
"DLG FARMS PRIVATE LIMITED",
"DLG FOOD SERVICES PRIVATE LIMITED",
"DLG INCORPORATION PRIVATE LIMITED",
"DLG TECHNOCRAT PRIVATE LIMITED",
"DLI POWER INDIA PRIVATE LIMITED",
"D-LINE HERBALS INDIA PRIVATE LIMITED",
"DLITE BLOCKS PRIVATE LIMITED",
"DLITE FOAM PRIVATE LIMITED",
"DLJM HOUSEWARE PRIVATE LIMITED",
"DLL GLOBAL BUSINESS SERVICES PRIVATE LIMITED",
"DLL TALWALKARS CLUB PRIVATE LIMITED",
"DLORDS FOOTWEAR AND FASHIONS PRIVATE LIMITED",
"DLORDS RETAIL VENTURES PRIVATE LIMITED",
"DLS PAPERS PRIVATE LIMITED",
"DLT BUSINESS SOUTIONS OPC PRIVATE LIMITED",
"DLT LABS TECHNOLOGIES PRIVATE LIMITED",
"DLTLEDGERS INDIA PRIVATE LIMITED",
"DLXINFINITY DRIVELINE PRIVATE LIMITED",
"DM AUTOMOTIVE PRIVATE.LIMITED",
"DM CORP ASSOCIATES",
"DM ENTERPRISES",
"DM EYE CARE DELHI PRIVATE LIMITED",
"DM FABRICATORS & ENGINEERS PRIVATE LIMITED",
"DM GROUP INVESTMENTS PRIVATE LIMITED",
"DM INDUSTRIES",
"DM INVENT PRIVATE LIMITED",
"DM IT SOLUTIONS PRIVATE LIMITED",
"DM MED CITY HOSPITALS (INDIA) PRIVATE LIMITED",
"DM MEDIA PRODUCTION PRIVATE LIMITED",
"DM PAPER PRODUCTS INDIA PRIVATE LIMITED",
"DM REALTY DEVELOPERS PRIVATE LIMITED",
"DM SHAKTI (OIL) PRIVATE LIMITED",
"DM SOUTH INDIA HOSPITALITY PRIVATE LIMITED",
"DM STEELS PRIVATE LIMITED",
"DM TEXTILES PRIVATE LIMITED",
"DM TRADECOM PRIVATE LIMITED",
"DMA FOREX PRIVATE LIMITED",
"DMACQ SOFTWARE PRIVATE LIMITED",
"DMAG TECHNOLOGIES PRIVATE LIMITED",
"D'MAK ENERGIA PRIVATE LIMITED",
"DMARK FOOD CHEM PRIVATE LIMITED",
"DMAS AUTOMOBILES PRIVATE LIMITED",
"D-MAX IMAGING PRIVATE LIMITED",
"DMAX OVERSEAS PRIVATE LIMITED",
"DMC AUTOMOTIVE PRIVATE LIMITED",
"DMC HOSPITALITY SERVICES PRIVATE LIMITED",
"DMC LEISURE PRIVATE LIMITED",
"DMC MARINE SERVICES PRIVATE LIMITED",
"DMC PRIVATE LIMITED",
"DMC VOLTICS PRIVATE LIMITED",
"DMD DEVELOPERS PRIVATE. LIMITED.",
"DMD INDUSTRIES PRIVATE LIMITED",
"DMD INFRATECH PRIVATE LIMITED",
"DME DEVELOPMENT LIMITED",
"DME INDIA PRIVATE LIMITED",
"DME REMEDIES PRIVATE LIMITED",
"DMED MEDICAL SERVICES PRIVATE LIMITED",
"DMEGC CHENGJI ELECTRONICS INDIA PRIVATE LIMITED",
"DMG AGRO PRODUCTS PRIVATE LIMITED",
"DMG FINANCE AND INVESTMENTS PRIVATE LIMITED",
"DMG INDIA PRIVATE LIMITED",
"DMG INDUSTRIES PRIVATE LIMITED",
"DMG INFRA & CONSULTING PRIVATE LIMITED",
"DMG MORI INDIA PRIVATE LIMITED",
"DMG POLYPACK PRIVATE LIMITED",
"DMH INDIAN INFRA PRIVATE LIMITED",
"DMH SALONS AND SPA PRIVATE LIMITED",
"DMI CAPITAL PRIVATE LIMITED",
"DMI COLLEGE",
"DMI COLLEGE OF ENGINEERING",
"DMI DRAEXLMAIER MANUFACTURING INDIA PRIVATE LIMITED",
"DMI FINANCE PRIVATE LIMITED",
"DMI HOUSING FINANCE PRIVATE LIMITED",
"DMI INNOVATIONS PRIVATE LIMITED",
"DMIA LAND (INDIA) PRIVATE LIMITED",
"DMIA LAND INDIA PRIVATE LIMITED",
"DMJ ENGINEERING SERVICES (OPC) PRIVATE LIMITED",
"DMK AGRO PRIVATE LIMITED",
"DMK INFRASTRUCTURE PRIVATE LIMITED",
"DMK PERSONAL CARE PRIVATE LIMITED",
"DMK PETRO TRADERS AND CARRIER PRIVATE LIMITED",
"DML EXIM PRIVATE LIMITED",
"DMM CREATION PRIVATE LIMITED",
"DMMANPOWER SERVICES PRIVATE LIMITED",
"DMMART AUTOMOTIVE PRIVATE LIMITED",
"DMN INDIA PRIVATE LIMITED",
"DMORPH INDIA PRIVATE LIMITED",
"DMP DIGITAL TECHNOLOGIES PRIVATE LIMITED",
"DMP GLOBAL PRIVATE LIMITED",
"DMP HEALTHCARE PRIVATE LIMITED",
"DMP MULTIMEDIA PRIVATE LIMITED",
"DMR BUILDERS PRIVATE LIMITED",
"DMR ENTERPRISES PRIVATE LIMITED",
"DMR GREEN VALLEY AGRO FRESH PRIVATE LIMITED",
"DMR HEALTH SCIENCES PRIVATE LIMITED",
"DMR HOSPITALS PRIVATE LIMITED",
"DMR HYDROENGINEERING & INFRASTRUCTURES LIMITED",
"DMR MOTORS PRIVATE LIMITED",
"DMR TECH PRIVATE LIMITED",
"DMS CONCRETE PRODUCTS PRIVATE LIMITED",
"DMS CONMIX (INDIA) PRIVATE LIMITED",
"DMS HEALTH PRIVATE LIMITED",
"DMS PROJECTS PRIVATE LIMITED",
"DMS TECHNOLOGIES PRIVATE LIMITED",
"DMSHAO TECHNOLOGIES LLP",
"DMSON'S METAL PRIVATE LIMITED",
"DMSTEK ENGINEERING PRIVATE LIMITED",
"DMT CONSULTING PRIVATE LIMITED",
"DMT INFRATECH PRIVATE LIMITED",
"DMU INFRATECH PRIVATE LIMITED",
"DMV IMPEX PRIVATE LIMITED",
"DMV TEXTILES PRIVATE LIMITED",
"DMW CNC SOLUTIONS INDIA PRIVATE LIMITED",
"DMW CORPORATION INDIA PRIVATE LIMITED",
"DMW INFRASTRUCTURES INDIA PRIVATE LIMITED",
"DMW TYRES PRIVATE LIMITED",
"DMX TECHNOLOGIES INDIA PRIVATE LIMITED",
"DN ENERGY PRIVATE LIMITED",
"DN ENTERPRISES",
"DN HOMES PRIVATE LIMITED",
"DN PERIPHERALS PRIVATE LIMITED",
"DN PRINTEX PRIVATE LIMITED",
"DN SOLUTIONS INDIA PRIVATE LIMITED",
"DN STEELIX INDUSTRY PRIVATE LIMITED",
"DN WIND SYSTEMS INDIA PRIVATE LIMITED",
"DN5 MARINE PRIVATE LIMITED",
"DNA ENTERTAINMENT NETWORKS PRIVATE LIMITED",
"DNA INFOTEL PRIVATE LIMITED",
"DNA SYSTEMS PRIVATE LIMITED",
"DNACONSULT ADVISORY PRIVATE LIMITED",
"DNATA INTERNATIONAL PRIVATE LIMITED",
"DNATA MARKETING SERVICES PRIVATE LIMITED",
"DNAYANJAOT HIGH SCHOOL YOGESH NAGAR JALNA",
"DNB BANK ASA",
"DNB EXIM PRIVATE LIMITED",
"DNB PACKAGING PRIVATE LIMITED",
"DNB TEXTILES PRIVATE LIMITED",
"DNC INFRASTRUCTURE PRIVATE LIMITED",
"DNC TECHNOSOLUTIONS PRIVATE LIMITED",
"DND ADHESIVES TECHNOLOGIES PRIVATE LIMITED",
"DND INFRA PRIVATE LIMITED",
"DND MACHINERY PRIVATE LIMITED",
"DND SECURITY FORCE PRIVATE LIMITED",
"DNDI INDIA LIAISON OFFICE",
"DNECTAR MARKETING SOLUTIONS PRIVATE LIMITED",
"DNEG INDIA MEDIA SERVICES LIMITED",
"DNEXO GLOBAL BPM PRIVATE LIMITED",
"DNG HOSPITAL PRIVATE LIMITED",
"DNH POWER DISTRIBUTION CORPORATION LIMITED",
"DNH PROJECTS LIMITED",
"DNIGHT WINGS YOUNG FOUNDATION",
"DNJ CREATION LLP",
"DNK FASHIONS PRIVATE LIMITED",
"DNK IMPEX PRIVATE LIMITED",
"DNK ROSHANS DEPARTMENTAL STORES PRIVATE LIMITED",
"DNL CORE DESIGN LIMITED",
"DNL ENGINEERS PRIVATE LIMITED",
"DNL POWER GENERATION PRIVATE LIMITED",
"DNM FLORA DISTRIBUTORS PRIVATE LIMITED",
"DNN MEDIA COMMUNICATION PRIVATE LIMITED",
"DNOVA INFRACON PRIVATE LIMITED",
"DNP CONSTRUCTIONS PRIVATE LIMITED",
"DNP ENGINEERS PRIVATE LIMITED",
"DNP FOREX PRIVATE LIMITED",
"DNP INFRASTRUCTURES PRIVATE LIMITED",
"DNP INTERNATIONAL PRIVATE LIMITED",
"DNP LIMITED",
"DNR AQUA PRIVATE LIMITED",
"DNR CORPORATION PRIVATE LIMITED",
"DNR INDIA AUTOTECH PRIVATE LIMITED",
"DNR INFRA DEVELOPERS PRIVATE LIMITED",
"DNR LOGISTICS PRIVATE LIMITED",
"DNS AGRO FOODS PRIVATE LIMITED",
"DNS BANK",
"DNS COMPUTERS PRIVATE LIMITED",
"DNS CONSTRUCTIONS PRIVATE LIMITED",
"DNS DISTRIBUTION PRIVATE LIMITED",
"DNS ELECTRONICS PRIVATE LIMITED",
"DNS FINE CHEMICALS AND LABORATORIES PRIVATE LIMITED",
"DNS HOMES PRIVATE LIMITED",
"DNS HOSPITALS PRIVATE LIMITED",
"DNS MANUFACTURERS PRIVATE LIMITED",
"DNS POLYFAB PRIVATE LIMITED",
"DNS STONES PRIVATE LIMITED",
"DNS VENTURE",
"DNSL TEA & AGRO PRIVATE LIMITED",
"DNT DEVELOPERS PRIVATE LIMITED",
"DNT FARMERS PRODUCER COMPANY LIMITED",
"DNV BUSINESS ASSURANCE INDIA PRIVATE LIMITED",
"DNV FOOD PRODUCTS PRIVATE LIMITED",
"DNV GL AS",
"DNV GL SE",
"DNV GLOBAL PRIVATE LIMITED",
"DNV INDUSTRIAL SYSTEMS PRIVATE LIMITED",
"DNV SHARED SERVICES INDIA PRIVATE LIMITED",
"DNX CARGO INDIA PRIVATE LIMITED",
"DNY HOSPITALITY PRIVATE LIMITED",
"DNYAN AUTOMATION PRIVATE LIMITED",
"DNYAN SAGAR PRI SCHOOL",
"DNYAN UDYA VD KHED(KRISHNANAGAR GOVE",
"DNYANDEEP ENGLISH SCHOOL BEED",
"DNYANDEEP COLLEGE OF ARCHITECTURE",
"DNYANDEEP CO-OPERATIVE CREDIT SOCIETY LTD",
"DNYANESHWAR SHIPPING SERVICES PRIVATE LIMITED",
"DNYANESHWAR VIDYA MANDIR",
"DNYANGANGA ENGLISH MEDIUM SCHOOL",
"DNYANGANGA PRATHAMIK VIDYALAYA ATKONESHWAR NAGAR KALWA THANE",
"DNYANMATA HIGH SCHOOL AMRAVATI",
"DNYANODAYA MARATHI PRI SCHOOL AMRAVATI",
"DNYANRADHA MULTISTATE CO OP CREDIT SOCIETY LTD",
"DNYANRAJ INDUSTRIES PRIVATE LIMITED",
"DNYANRAJ MAHADIK VIDYALAYA KASARWADI",
"DNYANSAGAR CAREER INSTITUTE PRIVATE LIMITED",
"DNYANSAGAR M V BASWANTPUR WARWANTI TQ DIST LATUR",
"DNYANSAGAR PRIMARY SCHOOL",
"DNYANSAMPADA MARATHI VIDYALAY SOLAPUR",
"DNYANVILAS COLLEGE OF PHARMACY",
"DNYNESHKANYA AGRO PRODUCER COMPANY LIMITED",
"DO IT IMPEX PRIVATE LIMITED",
"DO MOBILE INDIA PRIVATE LIMITED",
"DO POINTS MARKETING SERVICES PRIVATE LIMITED",
"DOABA COLD STORAGE PRIVATE LIMITED",
"DOABA FINSERV PRIVATE LIMITED",
"DOABA LUXURY TRAVELS (INDIA) PRIVATE LIMITED",
"DOABA STEEL ROLLING MILLS PRIVATE LIMITED",
"DO-ALL ENGINEERS PVT LTD",
"DOBERMAN SECURITY SOLUTIONS PRIVATE LIMITED",
"DOBERSUN PRODUCTS PRIVATE LIMITED",
"DOBEX ENGINEERS AND CONTRACTORS PRIVATE LIMITED",
"DOBEX FREIGHT AND LOGISTICS PRIVATE LIMITED",
"DOBIEE FOODS INDIA PRIVATE LIMITED",
"DOBLE ENGINEERING PRIVATE LIMITED",
"DOBUY TECHNOLOGIES",
"DOC FARMRAS AGRO (OPC) PRIVATE LIMITED",
"DOC MEDICAL SERVICES PRIVATE LIMITED",
"DOC24 WELLNESS PRIVATE LIMITED",
"DOC90 SOLUTIONS PRIVATE LIMITED",
"DOCEREE MEDIA INDIA PRIVATE LIMITED",
"DOCGIANT SERVICES INDIA PRIVATE LIMITED",
"DOCHANIA & COMPANY PRIVATE LIMITED",
"DOCKENDALE SHIP MANAGEMENT (INDIA) PRIVATE LIMITED",
"DOCKING STATION TECHNOLOGIES PRIVATE LIMITED",
"DOCKYARD FREIGHT MOVERS PRIVATE LIMITED",
"DOCMATION TECHNOLOGIES PRIVATE LIMITED",
"DOCMODE HEALTH TECHNOLOGIES LIMITED",
"DOCMODE HEALTH TECHNOLOGIES PRIVATE LIMITED",
"DOCOMO INTERTOUCH INDIA PRIVATE LIMITED",
"DOCONLINE CONSULTING PRIVATE LIMITED",
"DOCONLINE HEALTH INDIA PRIVATE LIMITED",
"DOCPLEXUS ONLINE SERVICES PRIVATE LIMITED",
"DOCPLUS TECHNOLOGIES PRIVATE LIMITED",
"DOCPRIME TECHNOLOGIES PRIVATE LIMITED",
"DOCPULSE TECHNOLOGIES PRIVATE LIMITED",
"DOCQUITY SERVICES PRIVATE LIMITED",
"DOCSUGGEST HEALTHCARE SERVICES PRIVATE LIMITED",
"DOCSUNS SERVICES PVT LTD",
"DOCTOR 365 HALENESS SERVICES PRIVATE LIMITED",
"DOCTOR BELIRAM AND SONS PRIVATE LTD",
"DOCTOR BISWAS HEALTHWAY PRIVATE LIMITED",
"DOCTOR DIAM PRIVATE LIMITED",
"DOCTOR EYE INSTITUTE PRIVATE LIMITED",
"DOCTOR HARISINGH GOUR VISHWAVIDHYALAYA SAGAR M P",
"DOCTOR ON CALL PRIVATE LIMITED",
"DOCTOR PACK INDIA PRIVATE LIMITED",
"DOCTOR SAND LIMITED",
"DOCTOR SEEDS PRIVATE LIMITED",
"DOCTOR SHRIMP BLUE AQUA INT PRIVATE LIMITED",
"DOCTORS 4 BUILDING PRIVATE LIMITED",
"DOCTORS ACADEMY OF EDUCATIONAL SOCIETY",
"DOCTORS ANALYTICAL LABORATORIES PRIVATE LIMITED",
"DOCTOR'S CROP CARE LIMITED",
"DOCTORS DIAGNOSTIC CENTRE PRIVATE LIMITED",
"DOCTORS DIAGNOSTIC NUCLEAR MEDICINE AND RESEARCH CENTRE PRIVATE LIMITED",
"DOCTOR'S LIFE SCIENCES (INDIA) LIMITED",
"DOCTORS RISK MEDICO LEGAL SERVICES INDIA PRIVATE LIMITED",
"DOCTORS' VET-PHARMA PRIVATE LIMITED",
"DOCTORS WITHOUT BORDERS INDIA PRIVATE LIMITED",
"DOCTORVAHINI PRIVATE LIMITED",
"DOCTORWINDOW PRIVATE LIMITED",
"DOCTROID INDIA PRIVATE LIMITED",
"DOCTUS BUSINESS SOLUTIONS PRIVATE LIMITED",
"DOCTUS DATA SERVICES PRIVATE LIMITED",
"DOCTUS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"DOCTY HEALTHCARE INDIA PRIVATE LIMITED",
"DOCUSES HEALTHCARE INDIA PRIVATE LIMITED",
"DODABALLAPUR HOSKOTE HIGHWAYS LIMITED",
"DODDANAVAR GLOBAL ENERGY PRIVATE. LIMITED.",
"DODECAN SERVICES PRIVATE LIMITED",
"DODHIA CHEM-TEX PRIVATE LIMITED",
"DODHIA SPECIALITY CHEMICALS LLP",
"DODHIA SYNTHETICS LIMITED",
"DODI SOLUTIONS PRIVATE LIMITED",
"DODIA ARCHITECTURAL PRIVATE LIMITED",
"DODIYA HOT DIP COATING PRIVATE LIMITED",
"DODLA DAIRY LIMITED",
"DODSAL ENTERPRISES PRIVATE LIMITED",
"DOEHLER INDIA PRIVATE LIMITED",
"DOER PACKAGING PRIVATE LIMITED",
"DOESHEALTH SYSTEMS PRIVATE LIMITED",
"DOFF LOGISTICS PRIVATE LIMITED",
"DOFORT WORLD MK PRIVATE LIMITED",
"DOGA INDIA PRIVATE LIMITED",
"DOGETECH ENTERPRISE PRIVATE LIMITED",
"DOGETECH MACHINERY MANUFACTURING PRIVATE LIMITED",
"DOGFATHER INDIA PRIVATE LIMITED",
"DOGIPARTHY POLYMERS PRIVATE LIMITED",
"DOGMA SOFT LIMITED",
"DOGMA SYSTEMS INDIA PRIVATE LIMITED",
"DOG-O-BOW PRIVATE LIMITED",
"DOGRA CONSTRUCTION CO. PRIVATE LIMITED",
"DOGRA TECHNOLOGIES PRIVATE LIMITED",
"DOGUS SOMA JV",
"DOHA BANK",
"DOHA BANK Q S C",
"DOHA BROKERAGE AND FINANCIAL SERVICES LIMITED",
"DOHARIA ISPAT PRIVATE LIMITED",
"DOHITHA PROPERTY DEVELOPERS PRIVATE LIMITED",
"DOIT CREATIONSINDIAPRIVATE LIMITEDCAT",
"DOIT CREATIVE CONSUMER VENTURES (INDIA) PRIVATE LIMITED",
"DOIT RESORT (GOA) PRIVATE LIMITED",
"DOIT URBAN VENTURES (INDIA) PRIVATE LIMITED",
"DOITLEAN INDIA PRIVATE LIMITED",
"DOIWALA SUGAR COMPANY LIMITED",
"DOJAHAN TRADING PRIVATE LIMITED",
"DOK AUSHADHI PRIVATE LIMITED",
"DOKA INDIA PRIVATE LIMITED",
"DOKANIA OVERSEAS PRIVATE LIMITED",
"DOKANIA TEXTILES PRIVATE LIMITED",
"DOKSUN POWER PRIVATE LIMITED",
"DOL ELECTRIC COMPANY PVT LTD",
"DOL MOTORS PRIVATE LIMITED",
"DOLACE SOLUTIONS PRIVATE LIMITED",
"DOLAMA MARKETING PRIVATE LIMITED",
"DOLAN TECHNOCRAFTS PRIVATE LIMITED",
"DOLAR ENGG INDUSTRIES PRIVATE LIMITED",
"DOLAR GOLD BELTS & FANS PRIVATE LIMITED",
"DOLAT ALGOTECH LIMITED",
"DOLAT CAPITAL MARKET PVT LIMITED",
"DOLAT INVESTMENTS LIMITED",
"DOLBY PLYBOARDS PRIVATE LIMITED",
"DOLBY TECHNOLOGY INDIA PRIVATE LIMITED",
"DOLCAS BOTANOSYS PRIVATE LIMITED",
"DOLCERA INFORMATION TECHNOLOGY SERVICES PRIVATE LIMITED",
"DOLCI INVESTOR ADVISORS PRIVATE LIMITED",
"DOLD ELECTRIC INDIA PRIVATE LIMITED",
"DOLESHWOR PHARMACEUTICALS PRIVATE LIMITED",
"DOLEX SHIPPING PRIVATE LIMITED",
"DOLF LEASING LIMITED",
"DOLFIN RUBBERS LIMITED",
"DOLI TRADING AND INVESTMENTS PRIVATE LIMITED",
"DOLIN DECOR PRIVATE LIMITED",
"DOLIOSIS HOLISTIC MEDICINE AND FOODS PRIVATE LIMITED",
"DOLL CERAMIC PRIVATE LIMITED",
"DOLLAR CO PRIVATE LIMITED",
"DOLLAR ENERGY PRIVATE LIMITED",
"DOLLAR EYE WEAR PRIVATE LIMITED",
"DOLLAR GENERAL CORPORATION",
"DOLLAR HOLDINGS PRIVATE LIMITED",
"DOLLAR INDUSTRIES LIMITED",
"DOLLAR PLASTMOULD PVT LTD",
"DOLLAR TREE INC.",
"DOLLARBIRD FINTECH PRIVATE LIMITED",
"DOLLARBIRD TECHNOLOGIES PRIVATE LIMITED",
"DOLLARS GRAND CLUB PRIVATE LIMITED",
"DOLLEX AGROTECH LIMITED",
"DOLLFINE DEVELOPERS",
"DOLLPHIN FOOTWEAR PVT LTD",
"DOLLUZ CORPORATION OPC PRIVATE LIMITED",
"DOLLY EXIM PRIVATE LIMITED",
"DOLLY INFRASTRUCTURE PRIVATE LIMITED",
"DOLLY PRINTING AND PACKAGING (INDIA) PRIVATE LIMITED",
"DOLMAX EXIM (CHENNAI) PRIVATE LIMITED",
"DOLOMITE RESTAURANTS PRIVATE LIMITED",
"DOLOO TEA COMPANY INDIA LIMITED",
"DOLOOP TECHNOLOGIES INDIA PRIVATE LIMITED",
"DOLPHIN AUTOWHEELS PRIVATE LIMITED",
"DOLPHIN BIKES PRIVATE LIMITED",
"DOLPHIN CHARTERING SERVICES PRIVATE LIMITED",
"DOLPHIN DEVELOPERS LIMITED",
"DOLPHIN DIE CAST PRIVATE LIMITED",
"DOLPHIN EMBRO INDIA PRIVATE LIMITED",
"DOLPHIN FARMS PRIVATE LIMITED",
"DOLPHIN FINANCE AND INVESTMENT COMPANY LIMITED",
"DOLPHIN FIRE SERVICES PRIVATE LIMITED",
"DOLPHIN FLOATS PRIVATE LIMITED",
"DOLPHIN FOODS INDIA LIMITED",
"DOLPHIN FOOTWEAR PRIVATE LIMITED",
"DOLPHIN GLOBAL AVIATION & TRAVELS PRIVATE LIMITED",
"DOLPHIN GUARDSS AND ALLIED SERVICES PRIVATE",
"DOLPHIN HEAT TRANSFER PRIVATE LIMITED",
"DOLPHIN INFOTEK PVT LTD",
"DOLPHIN INKS PRIVATE LIMITED",
"DOLPHIN INTERNATIONAL GRANITES PRIVATE LIMITED",
"DOLPHIN INTERNATIONAL PRIVATE LIMITED",
"DOLPHIN IRRIGATION SYSTEMS PRIVATE LIMITED",
"DOLPHIN LOGIC SYSTEMS PRIVATE LIMITED",
"DOLPHIN LUBRICANTS AND SPECIALITIES PRIVATE LIMITED",
"DOLPHIN MARINE ENTERPRISES PRIVATE LIMITED",
"DOLPHIN MARINE FOODS & PROCESSORS INDIA PRIVATE LIMITED",
"DOLPHIN MART PRIVATE LIMITED",
"DOLPHIN MEDICARE PRIVATE LIMITED",
"DOLPHIN MONEY PRIVATE LIMITED",
"DOLPHIN NUTRACEUTICALS INDIA PRIVATE LIMITED",
"DOLPHIN OFFSHORE SHIPPING LIMITED",
"DOLPHIN PHARMACEUTICAL LIMITED",
"DOLPHIN PHARMACY INSTRUMENTS PRIVATE LIMITED",
"DOLPHIN PHARMATECH PRIVATE LIMITED",
"DOLPHIN POLYFILL PRIVATE LIMITED",
"DOLPHIN POLYPLAST PRIVATE LIMITED",
"DOLPHIN REALTY PRIVATE LIMITED",
"DOLPHIN SAFETECH SERVICES PRIVATE LIMITED",
"DOLPHIN TWO WHEELERS PRIVATE LIMITED",
"DOLPHIN WIRES PVT LTD",
"DOLPHINE HOSPITAL AND RESEARCH FOUNDATION PRIVATE LIMITED",
"DOLPHY INDIA PRIVATE LIMITED",
"DOLSWAP BUSINESS PRIVATE LIMITED",
"DOLVI MINERALS & METALS PRIVATE. LIMITED.",
"DOLVIS BIO PHARMA PRIVATE LIMITED",
"DOM VENTAS INDIA PRIVATE LIMITED",
"DOMACH TECNOLOGIES INDIA PRIVATE LIMITED",
"DOMACLS ENGINEERING PRIVATE LIMITED",
"DOMAGK SMITH LABORATORIES PRIVATE LIMITED",
"DOMAIN 6 GTSC PRIVATE LIMITED",
"DOMAIN CLINICAL DATA SCIENCES PRIVATE LIMITED",
"DOMAIN EDUTECH PRIVATE LIMITED",
"DOMAIN NETWORKS PRIVATE LIMITED",
"DOMARP PHARMACY PRIVATE LIMITED",
"DOMBIVLI BETTER ENVIRONMENT SYSTEM ASSOCIATION",
"DOMBIVLI COMMON EFFLUENT TREATMENT PLANT",
"DOMBIVLI NAGARI SAHAKARI BANK LIMITED",
"DOMCO PRIVATE LIMITED",
"DOME ENTERTAINMENT PRIVATE LIMITED",
"DOMECH FABRICATORS PRIVATE LIMITED",
"DOMENICA CONSTRUCTIONS & DEVELOPERS PRIVATE LIMITED",
"DOMESTIC CONSTRUCTIONS PRIVATE LIMITED",
"DOMESTIC LOGISTICS PRIVATE LIMITED",
"DOMESTO PVT LTD",
"DOMETECH ART PRIVATE LIMITED",
"DOMEX E-DATA PRIVATE LIMITED",
"DOMEX TECHNICAL INFORMATION PRIVATE LIMITED",
"DOMINANCETECH IT SOLUTIONS PRIVATE LIMITED",
"DOMINANT GLOBAL LOGISTICS PRIVATE LIMITED",
"DOMINANT SYSTEMS PRIVATE LIMITED",
"DOMINIC SAVIO MAT HR SEC SCHOOL",
"DOMINICHE PRODUCTIONS PRIVATE LIMITED",
"DOMINION DEVELOPERS PRIVATE LIMITED",
"DOMINION FACILITY SERVICES PRIVATE LIMITED",
"DOMINION RESOURCES INC.",
"DOMINION TECHNOLOGY SERVICES PRIVATE LIMITED",
"DOMINIONS REALTY PRIVATE LIMITED",
"DOMINO PRINTECH INDIA LLP",
"DOMINOS PIZZA LIMITED",
"DOMINUS AUTOTECH PRIVATE LIMITED",
"DOMINUS HEALTHCARE PRIVATE LIMITED",
"DOMINUS INFRA TECH PRIVATE LIMITED",
"DOMIS TECH PRIVATE LIMITED",
"DOMJUR JEWELLERY SILPOMONDIR PRIVATE LIMITED",
"DOMNIC LEWIS PRIVATE LIMITED",
"DOMO ENGINEERING PLASTICS INDIA PRIVATE LIMITED",
"DOMO GADGETS PRIVATE LIMITED",
"DOMOTICS AUTOMATION PRIVATE LIMITED",
"DOM'S DELICIOUS PRIVATE LIMITED",
"DOMS INDUSTRIES LIMITED",
"DOMS INDUSTRIES PRIVATE LIMITED",
"DOMTEX INDIA PRIVATE LIMITED",
"DOMUS GREENS PRIVATE LIMITED",
"DOMUS REAL ESTATE PRIVATE LIMITED",
"DON BOSCO ACADEMY",
"DON BOSCO ANBU ILLAM SOCIAL SERVICE SOCIETY",
"DON BOSCO COLLEGE OF ARTS AND SCIENCE",
"DON BOSCO HIGH SCHOOL",
"DON BOSCO HR SEC SCHOOL",
"DON BOSCO INSTITUTE OF TECHNOLOGY",
"DON BOSCO MATRIC HR SEC SCHOOL",
"DON BOSCO NURSERY AND PRIMARY SCHOOL",
"DON BOSCO SCHOOL",
"DON BOSCO SCHOOL OF EXCELLENCE EGMORE",
"DON CHEM PRIVATE LIMITED",
"DON CONSTRUCTION CHEMICAL INDIA PRIVATE LIMITED",
"DONALD FASHIONS PRIVATE LIMITED",
"DONALDSON INDIA FILTER SYSTEMS PRIVATE LIMITED",
"DONATUS VICTORIA ESTATES AND HOTELS PRIVATE LIMITED",
"DONBOSCO HIGH SCHOOL",
"DONDAICHA BETAWAD ANNUITY INFRASTRUCTURE PRIVATE LIMITED",
"DONE SOLUTIONS PRIVATE LIMITED",
"DONEAR INDUSTRIES LIMITED",
"DONEAR LAMINATES PRIVATE LIMITED",
"DONEC FASHIONS PRIVATE LIMITED",
"DONERIA ENGINEERING CO LIMITED",
"DONERIA FOOTWEAR LIMITED",
"DONEWELL PHARMACEUTICALS PRIVATE LIMITED",
"DONG A INDIA AUTOMOTIVE PRIVATE LIMITED",
"DONG AH ELECTRIC INDIA PRIVATE LIMITED",
"DONG KWANG TRADING PRIVATE LIMITED",
"DONG SUNG AUTOMOTIVE INDIA PRIVATE. LIMITED.",
"DONG WOO SURFACE TECH INDIA PRIVATE LIMITED",
"DONGA HWASUNG INDIA PRIVATE LIMITED",
"DONGA WATERTECH PRIVATE LIMITED",
"DONGARAI INFRASTRUCTURES PRIVATE LIMITED",
"DONGARGAON PAPER MILLS PVT LTD",
"DONGFANG ELECTRIC (INDIA) PRIVATE LIMITED",
"DONGFANG ELECTRONICS CO. LIMITED",
"DONGFANG ELECTRONICS PRIVATE LIMITED",
"DONGJIN ELECTRONICS INDIA PRIVATE LIMITED",
"DONGKUK STEEL INDIA PRIVATE LIMITED",
"DONGKWANG PRECISION INDIA PRIVATE LIMITED",
"DONGLIM PRECISION (INDIA) PRIVATE LIMITED",
"DONGNAM AUTO INDIA PRIVATE LIMITED",
"DONGNAM LOGISTICS INDIA PRIVATE LIMITED",
"DONGRE PROJECT MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"DONGSAN AUTOMOTIVE INDIA PRIVATE LIMITED",
"DONGSHAN SILICONE PRIVATE LIMITED",
"DONGXING CONTRACTORS PRIVATE LIMITED",
"DONGYANG CONSTRUCTION INDIA PRIVATE LIMITED",
"DONGYANG ELECTRIC AND POWER INDIA PRIVATE LIMITED",
"DONGYANG ENGINEERING AND CONSTRUCTION INDIA PRIVATE LIMITED",
"DONGYUE BRICK ENGINEERING PRIVATE LIMITED",
"DONNA FMCG PRIVATE LIMITED",
"DONNA FOOT CARE PRIVATE LIMITED",
"DONNA INTERNATIONAL PRIVATE LIMITED",
"DONNA PENTA ENTERPRISES PRIVATE LIMITED",
"DONNELLY AND MOORE CONSULTANTS PRIVATE LIMITED",
"DONO CONSULTING PRIVATE LIMITED",
"DONOR MARINE SERVICES PRIVATE LIMITED",
"DONTHI ELECTRODES PRIVATE LIMITED",
"DONTHI ROLLER FLOUR MILLS PRIVATE LIMITED",
"DONUM FOREX PRIVATE LIMITED",
"DONVAND LIMITED",
"DONVEY POWER CONTROL SYSTEMS PRIVATE LIMITED",
"DONY POLO UDYOG LIMITED",
"DOOALL CORPRO (INDIA) PRIVATE LIMITED",
"DOOARS PLANTATION & INDUSTRIES LIMITED",
"DOOARS PLY PRODUCTS PRIVATE LIMITED",
"DOOARS REALTORS PRIVATE LIMITED",
"DOOARS TEA ESTATE PRIVATE LIMITED",
"DOODAM ENGINEERING PRIVATE LIMITED",
"DOODHNATH GROUP OF INSTITUTE",
"DOODLE COLLECTION PRIVATE LIMITED",
"DOODLE DESIGNS PRIVATE LIMITED",
"DOODLEBLUE INNOVATIONS PRIVATE LIMITED",
"DOOGAR AND ASSOCIATES SECURITIES PRIVATE LIMITED",
"DOOK TRAVELS PRIVATE LIMITED",
"DOON BLACK BELT SECURITY & PLACEMENT",
"DOON BUILDCON PRIVATE LIMITED",
"DOON BULDING MATERIAL",
"DOON BUSINESS SCHOOL",
"DOON CONSULTING PRIVATE LIMITED",
"DOON CONTAINERS PRIVATE LIMITED",
"DOON DECORS & EXHIBITS PRIVATE LIMITED",
"DOON DIVINE HOTELS AND DEVELOPERS PRIVATE LIMITED",
"DOON FOREX PRIVATE LIMITED",
"DOON GHATI COLLEGE OF PROFESSIONAL EDUCATION",
"DOON GRANDEMERALD HOTELS PRIVATE LIMITED",
"DOON HATCHERIES LIMITED",
"DOON HERITAGE SCHOOL",
"DOON INFINITY SALES PRIVATE LIMITED",
"DOON INFRAPOWER PROJECTS PRIVATE LIMITED",
"DOON INFRASTRUCTURE",
"DOON INSTITUTE OF MEDICAL SCIENCES FACULTY OF AYURVEDA",
"DOON INTERNATIONAL PUBLIC SCHOOL",
"DOON INTERNATIONAL SCHOOL",
"DOON LOGISTICS PRIVATE LIMITED",
"DOON NATURE FARMS AND RETREATS PRIVATE LIMITED",
"DOON OFFICE SYSTEMS PRIVATE LIMITED",
"DOON PG PARAMEDICAL COLLEGE AND HOSPITAL",
"DOON PUBLIC SCHOOL",
"DOON VALLEY FOODS PRIVATE LIMITED",
"DOON VALLEY PUMPS (INDIA) PVT LTD",
"DOON WHEEL PRIVATE LIMITED",
"DOONDEFENCE DREAMERS (OPC) PRIVATE LIMITED",
"DOONEXPRESS SUITES PRIVATE LIMITED",
"DOONGER VIDHYA PEETH SR SEC SCHOOL",
"DOONGURSEE SALT WORKS PVT LTD",
"DOOR AUTOMATIONS PRIVATE LIMITED",
"DOOR DARSHI ELECTRONICS PRIVATE LIMITED",
"DOOR SABHA NIGAM LIMITED",
"DOOR SANCHAR HYDRO POWER PRIVATE LIMITED",
"DOOR TRAINING AND CONSULTING INDIA PRIVATE LIMITED",
"DOORDARSHAN GOVERNMENT OF INDIA",
"DOORDASH TECHNOLOGIES INDIA PRIVATE LIMITED",
"DOORHAN-IN PRIVATE LIMITED",
"DOORS & MORE WOOD PRODUCTS LIMITED",
"DOORS & SEALS PRIVATE LIMITED",
"DOORS AND DOORS SYSTEM INDIA PRIVATE LIMITED",
"DOORS INDIA PRIVATE LIMITED",
"DOORS N DOORS DECOBUILD PRIVATE LIMITED",
"DOORSTEP HEALTH SERVICES PRIVATE LIMITED",
"DOORWIN TECHNOLOGIES PRIVATE LIMITED",
"DOOSAN BOBCAT INDIA PRIVATE LIMITED",
"DOOSAN POWER SYSTEMS INDIA PRIVATE LIMITED",
"DOOTH INTERNET SERVICES PRIVATE LIMITED",
"DOOWON AUTOMOTIVE SYSTEMS INDIA PRIVATE LIMITED",
"DOOWON AUTOPARTS INDIA PRIVATE LIMITED",
"DOOWON CLIMATE CONTROL INDIA PRIVATE LIMITED",
"DOOWON ELECTRONICS INDIA PRIVATE LIMITED",
"DOPAG INDIA PRIVATE LIMITED",
"DOPAMIN STRATEGIC CONSULTANTS PRIVATE LIMITED",
"DOPPIO GROUP PRIVATE LIMITED",
"DORA INFRASTRUCTURES AND PROPERTIES PRIVATE LIMITED",
"DORA MEDICAL TRADINGINDIA PRIVATE LIMITED",
"DORA PLASTICS PRIVATE LIMITED",
"DORABJEE & COMPANY PRIVATE LIMITED",
"DORADO LEARNING INDIA PRIVATE LIMITED",
"DORALL INFRASTRUCTURES AND DEVELOPERS PRIVATE LIMITED",
"DORANNT SOLUTIONS PRIVATE LIMITED",
"DOREK INTERNATIONAL PRIVATE LIMITED",
"DORF KETAL CHEMICALS INDIA PRIVATE LIMITED",
"DORF-KETAL CHEMICALS INDIA PRIVATE LIMITED",
"ALTORAPRO INFRASTRUCTURE PRIVATE LIMITED",
"DORIC MULTIMEDIA PRIVATE LIMITED",
"DORITE TRACON PVT LTD",
"DORIWALA POLYTEX PRIVATE LIMITED",
"DORIZOE LIFESCIENCES LIMITED",
"DORLING KINDERSLEY PUBLISHING PRIVATE LIMITED",
"DORMAK INTERIO PRIVATE LIMITED",
"DORMAKABA INDIA PRIVATE LIMITED",
"DORMAN ENGINEERING PRIVATE LIMITED",
"DORMANN DOORS PRIVATE LIMITED",
"DORMER TOOLS INDIA PRIVATE LIMITED",
"DORMEUIL INDIA PRIVATE LIMITED",
"DORNBRACHT INDIA PRIVATE LIMITED",
"DORNIER GROUP (INDIA) PRIVATE LIMITED",
"DORNIER MACHINERY INDIA PRIVATE LIMITED",
"DORNIER MEDTECH INDIA PRIVATE LIMITED",
"DORO DESIGNS PRIVATE LIMITED",
"DORSAL EXPOVENTURE PRIVATE LIMITED",
"DORSAN FILTRATION INDIA PRIVATE LIMITED",
"DORSCH CONSULT INDIA PRIVATE LIMITED",
"DORSET INDUSTRIES PRIVATE LIMITED",
"DORSET KABA SECURITY PRIVATE LIMITED",
"DORTMUND LABORATORIES PRIVATE LIMITED",
"DORUPO FINANCIAL SERVICES PRIVATE LIMITED",
"DOSCH PHARMACEUTICALS PRIVATE LIMITED",
"DOSHAHEEN SOLUTIONS PRIVATE LIMITED",
"DOSHI ACCOUNTANTS S PRIVATE LIMITED",
"DOSHI AUTOMOBILES PRIVATE LIMITED",
"DOSHI BROTHERS MARKETING PRIVATE LIMITED",
"DOSHI BROTHERS PRIVATE LIMITED",
"DOSHI CERAMIC INDUSTRIES",
"DOSHI CONSULTANTS PRIVATE LIMITED",
"DOSHI FERRO ALLOYS PRIVATE LIMITED",
"DOSHI HOUSING PRIVATE LIMITED",
"DOSHI MEDICAL SERVICE PRIVATE LIMITED",
"DOSHI MEDICARE PRIVATE LIMITED",
"DOSHI METAL PRODUCTS PRIVATE LIMITED",
"DOSHI SLITTERS PRIVATE LIMITED",
"DOSHI TECHNOLOGIES PRIVATE LIMITED",
"DOSHION ENVIORNMENT WATER SOLUTIONS LLP",
"DOSHION ENVIRONMENT WATER SOLUTIONS INDIA PRIVATE LIMITED",
"DOSHION POLY SCIENCE PRIVATE LIMITED",
"DOSI TOURISM PVT LTD",
"DOSIBAI JEEJEEBHOY HIGH SCHOOL",
"DOSNET TECHNOLOGIES PRIVATE LIMITED",
"DOSOJIN PROPERTY SERVICES PRIVATE LIMITED",
"DOSSA CHEMICALS PRIVATE LIMITED",
"DOSSA INSURANCE & BROKING SERVICES LIMITED",
"DOST FINCAP PRIVATE LIMITED",
"DOST HOSPITALITY SERVICES PRIVATE LIMITED",
"DOSTI ENTERPRISES",
"DOSTI REALTY LIMITED",
"DOSTI SCHOOL FOUNDATION",
"DOT & KEY WELLNESS PRIVATE LIMITED",
"DOT ARTS PRIVATE LIMITED",
"DOT COM INFOWAY LIMITED",
"DOT COMMUNICATIONS AND MARKETING PRIVATE LIMITED",
"DOT DIGITAL PRIVATE LIMITED",
"DOT INFRA BUSINESS DEVELOPMENT CONSULTANTS",
"DOT LABS WEB SOLUTIONS PRIVATE LIMITED",
"DOT ONN BUSINESS SERVICES PRIVATE LIMITED",
"DOT PROFESSIONALS PRIVATE LIMITED",
"DOT TRUCKERS LIMITED",
"DOT WORKPLACE SOLUTIONS PRIVATE LIMITED",
"DOT1 SOLUTIONS PRIVATE LIMITED",
"DOTARRCH BUSINESS SOLUTIONS PRIVATE LIMITED",
"DOTCAD PRIVATE LIMITED",
"DOTCOM TEAM INDIA LLP",
"DOTCOM WEAVERS SOLUTIONS PRIVATE LIMITED",
"DOTEX MERCHANDISE PRIVATE LIMITED",
"DOTKEYS INDIA PRIVATE LIMITED",
"DOTLINE INFORMATICS PRIVATE LIMITED",
"DOTLINE WEB MEDIA PRIVATE LIMITED",
"DOTMAPPERS IT PRIVATE LIMITED",
"DOTO STUDIO PRIVATE LIMITED",
"DOTS INFO SYSTEMS INDIA PRIVATE LIMITED",
"DOTS LIFESCIENCE PRIVATE LIMITED",
"DOTS 'N' ROSES PRIVATE LIMITED",
"DOTS N WRAPS PRIVATE LIMITED",
"DOTS TECHNO-CREATIVE PRIVATE LIMITED",
"DOTS2CONNECT MARKETING PRIVATE LIMITED",
"DOTSMARK SYSTEMS INDIA LIMITED",
"DOTSOLVED INDIA PRIVATE LIMITED",
"DOTSQUARES TECHNOLOGIES INDIA PRIVATE LIMITED",
"DOTT SERVICES LIMITED",
"DOTT SERVICES PRIVATE LIMITED",
"DOTTO BUSINESS SOLUTIONS PRIVATE LIMITED",
"DOTVIK SOLUTIONS PRIVATE LIMITED",
"DOTW DEWAS",
"DOTWISE DIGITAL PRIVATE LIMITED",
"DOUBLE ARROW CONSULTANCY PRIVATE LIMITED",
"DOUBLE EDGE CONSULTING PRIVATE LIMITED",
"DOUBLE ESS ESTATES PRIVATE LIMITED",
"DOUBLE HIRAN OILS PRIVATE LIMITED",
"DOUBLE NEGATIVE INDIA PRIVATE LIMITED",
"DOUBLE SPRING MEDIA INDIA PRIVATE LIMITED",
"DOUBLE TWO INDIA PRIVATE LIMITED",
"DOUBLE VISION SIGNAGE INTERNATIONAL PRIVATE LIMITED",
"DOUBLE8 EVENT AND ADVERTISING PRIVATE LIMITED",
"DOUBLEDOT FINANCE LIMITED",
"DOUBLEKLICK DESIGNS PRIVATE LIMITED",
"DOUBLESTAR MAINTENANCE SERVICES (OPC) PRIVATE LIMITED",
"DOUBLEYOU TECHNOLOGIES PRIVATE LIMITED",
"DOUCE INFOTECH PRIVATE LIMITED",
"DOUGH & CREAM PRIVATE LIMITED",
"DOULOS JEWELS LIMITED",
"DOUNDE LALWANI INFRA PRIVATE LIMITED",
"DOUSE FIRE SYSTEMS PRIVATE LIMITED",
"DOVAL CLOSURES PRIVATE LIMITED",
"DOVE GARMENTS PRIVATE LIMITED",
"DOVE IMAGING PRIVATE LIMITED",
"DOVE INVESTMENTS PRIVATE LIMITED",
"DOVE LOGISTICS PRIVATE LIMITED",
"DOVE REALTORS PRIVATE LIMITED",
"DOVE RESOURCES PRIVATE LIMITED",
"DOVE SOFT LIMITED",
"DOVE SOFT PRIVATE LIMITED",
"DOVEE SOFTECH PRIVATE LIMITED",
"DOVER COMMERCIALS PRIVATE LIMITED",
"DOVER INDIA PRIVATE LIMITED",
"DOVER TEA PRIVATE LIMITED",
"DOVETAIL CAPITAL PRIVATE LIMITED",
"DOVETAIL FURNITURE PRIVATE LIMITED",
"DOVETAIL PROJECTS PRIVATE LIMITED",
"DOVETAIL SUPPLYCHAIN PRIVATE LIMITED",
"DOVETAIL WOODCRAFTERS PRIVATE LIMITED",
"DOVIEW HOLIDAYS INDIA PRIVATE LIMITED",
"DOVLIN TECHNOLOGIES PRIVATE LIMITED",
"DOVOY CHEMICALS INDIA PRIVATE LIMITED",
"DOW AGROSCIENCES INDIA PRIVATE LIMITED",
"DOW CHEMICAL",
"DOW CHEMICAL INTERNATIONAL PRIVATE LIMITED",
"DOW CORNING INDIA PRIVATE LIMITED",
"DOW JONES AND COMPANY INC",
"DOW JONES CONSULTING INDIA PRIVATE LIMITED",
"DOW MEDIA PRIVATE LIMITED",
"DOWC TECHNOLOGIES PRIVATE LIMITED",
"DOWEL ERECTORS PRIVATE LIMITED",
"DOWELL FISCAL SERVICES PVT LTD",
"DOWELL LIFE SCIENCE PRIVATE LIMITED",
"DOWELL MOULDS PRIVATE LIMITED",
"DO-WELL SURGICALS PRIVATE LIMITED",
"DOWELLS CABLE ACCESSORIES PRIVATE LIMITED",
"DOWINS RESOURCES PRIVATE LIMITED",
"DOWN TOWN DINER P LIMITED",
"DOWN TOWN FOOD-TEK PRIVATE LIMITED",
"DOWN TOWN IMPEX PRIVATE LIMITED",
"DOWN TOWN MOTORS PRIVATE LIMITED",
"DOWNHOLE TOOLS PRIVATE LIMITED",
"DOWNTOWN AUTO PRIVATE LIMITED",
"DOWNTOWN HOTELS PRIVATE LIMITED",
"DOWNTOWN TEMPTATIONS PRIVATE LIMITED",
"DOWSON TECHNOLOGY PRIVATE LIMITED",
"DOXTRO TECHNOLOGIES PRIVATE LIMITED",
"DOYAPORE TEA & INDUSTRIES PVT.LTD.",
"DOYEN CONSTRUCTIONS PRIVATE LIMITED",
"DOYEN ENGINEERING SERVICES PRIVATE LIMITED",
"DOYEN INFOSOLUTIONS PRIVATE LIMITED",
"DOYEN OVERSEAS PRIVATE LIMITED",
"DOYEN SOLUTIONS",
"DOYEN SYSTEMS PRIVATE LIMITED",
"DOYENHUB SOFTWARE SOLUTION PRIVATE LIMITED",
"DOYLE ASIA PROFILES PRIVATE LIMITED",
"DOZCO INDIA PVT LTD",
"DOZER WORLD PRIVATE LIMITED",
"DOZO SERVICES PRIVATE LIMITED",
"DP ADVERTISING PRIVATE LIMITED",
"DP AHUJA AND COMPANY",
"DP CHOCOLATES PRIVATE LIMITED",
"DP COCOA PRODUCTS PRIVATE LIMITED",
"DP CONSTEEL",
"DP GENSET",
"DP GOLD PRIVATE LIMITED",
"DP HYDROCARBON SERVICES PRIVATE LIMITED",
"DP INDUSTRIES INDIA PRIVATE LIMITED",
"DP INFRA BUILDTECH PRIVATE LIMITED",
"DP JAGAN",
"DP JAGTAP AND COMPANY",
"DP JAIN MOBILES",
"DP LOGISTICS PRIVATE LIMITED",
"DP POLYMERS & CHEMICALS PRIVATE LIMITED",
"DP REALTECH PRIVATE LIMITED",
"DP TECHNOLOGIES PRIVATE LIMITED",
"DP WOODTECH PRIVATE LIMITED",
"DP WORLD EXPRESS LOGISTICS PRIVATE LIMITED",
"DP WORLD MULTIMODAL LOGISTICS HYDERABAD PRIVATE LIMITED",
"DP WORLD MULTIMODAL LOGISTICS PRIVATE LIMITED",
"DP WORLD PRIVATE LIMITED",
"DP WORLD RAIL LOGISTICS PRIVATE LIMITED",
"DPA CONSULTANTS PRIVATE LIMITED",
"DPAC ELECTRIC TECHNOLOGIES PRIVATE LIMITED",
"DPAC VENTURES LLP",
"DPB ANTIBIOTICS",
"DPB PHARMACEUTICALS LIMITED",
"DPB PRINT INDIA PRIVATE LIMITED",
"DPC INDIA PRIVATE LIMITED",
"DPC INDORE",
"DPC RATLAM",
"DPC SATNA",
"DPC SEHORE",
"DPC UJJAIN",
"DPC UJJAIN DISTRICT PROJECT COORDINATOR UJJAIN",
"DPCS PEST CONTROL PRIVATE LIMITED",
"DPG BEVERAGES PRIVATE LIMITED",
"DPG FINANCE PRIVATE LIMITED",
"DPG INSTITUTE OF TECHNOLOGY & MANAGEMENT",
"DPG KAISER APPLIANCES PRIVATE LIMITED",
"DPG MARKETING PRIVATE LIMITED",
"DPG TEXTILE LIMITED",
"DPH SOFTWARE SERVICES PRIVATE LIMITED",
"DPI DAYLIGHTING PRIVATE LIMITED",
"DPI FASHIONS PRIVATE LIMITED",
"DPIIND SERVICES PRIVATE LIMITED",
"DPJ BIDAR CHINCHOLI (ANNUITY) ROAD PROJECT PRIVATE LIMITED",
"DPJ POLLACHI HAM PROJECT PRIVATE LIMITED",
"DPJAIN (NAGDA-GOGAPUR) BOT ANNUITY PROJECT PRIVATE LIMITED",
"DPJ-DRA TOLLWAYS PRIVATE LIMITED",
"DPL COMTRADE PRIVATE LIMITED",
"DPL GLOBAL PRIVATE LIMITED",
"DPLOI STAFFING PRIVATE LIMITED",
"DPM AGRO AND FOODS PRIVATE LIMITED",
"DPM CORPORATE ADVISORS PRIVATE LIMITED",
"DPM FLOUR MILL LIMITED",
"DPM IMPEX PRIVATE LIMITED",
"DPM INSTRUMENTS PRIVATE LIMITED",
"DPMC HEALTHCARE PRIVATE LIMITED",
"DPMK FERTILIZERS PRIVATE LIMITED",
"DPMU BALANGIF",
"DPPL WORKS PRIVATE LIMITED",
"DPR CARGO PRIVATE LIMITED",
"DPR HEALTH SOLUTIONS PRIVATE LIMITED",
"D'PRO AGRO PRODUCTS PRIVATE LIMITED",
"DPS BEARINGS PRIVATE LIMITED",
"DPS CONSTRUCTION PRIVATE LIMITED",
"DPS CONTRACTORS PRIVATE LIMITED",
"DPS CROP SCIENCE PRIVATE LIMITED",
"DPS EXPORTS PRIVATE LIMITED",
"DPS FOODS PRIVATE LIMITED",
"DPS GANDHINAGAR",
"DPS INFOTECH PRIVATE LIMITED",
"DPS INTERNATIONAL",
"DPS JAJPUR",
"DPT REG CPO SOCITIES AGAR MALWA MADHYA PRADESH",
"DQ DATAQAPPS TECHNOLOGIES PRIVATE LIMITED",
"DQ LABS PRIVATE LIMITED",
"DQAP SYSTEMS PRIVATE LIMITED",
"DQBYDT PRIVATE LIMITED",
"DQS CERTIFICATIONS INDIA PRIVATE LIMITED",
"DQS UL MANAGEMENT SYSTEMS SOLUTIONS INDIA PRIVATE LIMITED",
"DR AADITYA S ADVANCE DENTAL HOSPITAL",
"DR ABHIN CHANDRA HOMOEOPATHIC HOSPITAL",
"DR ACADEMY",
"DR ACHARYA LABORATORIES PRIVATE LIMITED",
"DR AGARWAL'S EYE HOSPITAL LIMITED",
"DR AGARWAL'S HEALTH CARE LIMITED",
"DR AKBAR EYE HOSPITALS",
"DR ALLAMA IQBAL HIGH SCHOOL & JUNIOR COLLEGE OF ARTS SCIENCE & COMMERCE KURUNDWAD",
"DR AMBEDKAR ENGLISH HIGH SCHOOL GOA",
"DR AMBEDKAR GOVT ARTS COLLEGE",
"DR AMBEDKAR INSTITUTE OF TECHNOLOGY",
"DR AMIN CONTROLLERS PRIVATE LIMITED C/N",
"DR ANTONIO DA SILVA HIGH SCHOOL",
"DR APPARELS AND FASHION PRIVATE LIMITED",
"DR ARVIND LIFE SCIENCE PRIVATE LIMITED",
"DR ARVIND VISION CARE PRIVATE LIMITED",
"DR AXION INDIA PRIVATE LIMITED",
"DR B C ROY ENGINEERING COLLEGE",
"DR B L KAPUR MEMORIAL HOSPITAL",
"DR B LAL CLINICAL LABORATORY PRIVATE LIMITED",
"DR B R AMBEDKAR POOJA COLLEGE OF PHARMACY",
"DR B S A HOSPITAL",
"DR B V RAO INSTITUTE OF POULTRY MANAGEMENT AND TECHNOLOGY",
"DR B.R.AMBEDKAR MEDICAL COLLEGE & HOSPITAL",
"DR BABA SAHEB AMBEDKAR MEDICAL COLLEGE",
"DR BABA SAHED AMBEDKAR HOSPITAL",
"DR BABASAHEB AMBEDKAR COMMERCE AND M V R SHINDE ARTS COLLEGE",
"DR BABASAHEB AMBEDKAR OPEN UNIVERSITY",
"DR BABASAHEB AMBEDKAR SAHAKARI SAKHAR KARKHANA LTD",
"DR BALABHAI NANAVATI HOSPITAL",
"DR BALASAHEB SAWANT KONKAN KRISHI VIDYAPEETH",
"DR BANSAL CONSUMER PRODUCTS PRIVATE LIMITED",
"DR BAPUJI SALUNKHE INSTITUTE OF ENGINEERING & TECHNOLOGY",
"DR BARHALE MEDICAL CENTRE PRIVATE LIMITED",
"DR BATRA S POSITIVE HEALTH PRODUCTS LIMITED",
"DR BATRAS' POSITIVE HEALTH CLINIC PRIVATE LIMITED",
"DR BC ROY POST GRADUATE INSTITUTE OF PAEDIATRIC SCIENCES",
"DR BEEDKAR HEART CLINIC",
"DR BHANUBEN NANAVATI COLLEGE OF ARCHITECHTURE",
"DR BHATE HEALTHCARE PRIVATE LIMITED",
"DR BHATIA HOSPITAL",
"DR BHAVANA SHAH FITNESS CARE PRIVATE LIMITED",
"DR BHIMRAO AMBEDKAR POLYTECHNIC COLLEGE GWALIOR",
"DR BHIMRAO AMBEDKAR UNIVERSITY",
"DR BL KAPUR MEMORIAL HOSPITAL",
"DR BR AMBEDKAR UNIVERSITY DELHI",
"DR BV RAO INSTITUTE OF POULTRY MANAGEMENT AND TECHNOLOGY",
"DR C V RAMAN COLLEGE OF ADMINISTRATION & NETWORK SCIENCES",
"DR C V RAMAN INSTITUTE OF TECH",
"DR C V RAMAN UNIVERSITY",
"DR C V S RATNAM AND ASSOCIATES PRIVATE LIMITED",
"DR CHANTIS PHARMACEUTICALS PRIVATE LIMITED",
"DR CHARIARS PETS SPECIALITY CLINIC PRIVATE LIMITED",
"DR CHIRANJI LAL RASHTRIYA INTER COLLEGE",
"DR COURIER EXPRESS PRIVATE LIMITED",
"DR D Y PATIL ARTS COMMERCE & SCIENCE WOMENS COLLEGE",
"DR D Y PATIL COLLEGE OF LAW",
"DR D Y PATIL HOSPITAL & RESEARCH CENTER",
"DR D Y PATIL INSTITUTE OF ENGINEERING MANAGEMENT & RESEARCH AKURDI PUNE",
"DR D Y PATIL INSTITUTE OF PHARMACEUTICAL SCIENCE AND RESEARCH",
"DR D Y PATIL MEDICAL COLLEGE, HOSPITAL & RESEARCH CENTRE",
"DR D Y PATIL PRATISHTHAN'S COLLEGE OF ENGINEERING KOLHAPUR",
"DR DANGS LAB LLP",
"DR DEEPAK GUPTA CHILD HOSPITAL",
"DR DESAS LABORATORIES PVT LTD",
"DR DINESH AND RAMESH ENGINEERS PVT LTD",
"DR DUKLE'S HOSPITAL AND RESEARCH CENTRE",
"DR EBERLE CLEVER CHEMISTRY PRIVATE LIMITED",
"DR ENGINEERS PRIVATE LIMITED",
"DR FRASER BOYS HIGH SCHOOL JALNA",
"DR FRASER BOYS PRIMARY SCHOOL",
"DR G B HEALTHCARE PRIVATE LIMITED",
"DR G D BOSE MEMORIAL HOSPITAL",
"DR G R DAMODARAN COLLEGE OF SCIENCE",
"DR GANDHI'S NURSING HOME PRIVATE LIMITED",
"DR GAUR HARI SINGHANIA INSTITUTE OF MANAGEMENT AND RESEARCH",
"DR GHOSH MODERN COLLEGE",
"DR GOYAL MEDICAL PRIVATE LIMITED",
"DR GOYALS HEALTHCARE PRIVATE LIMITED",
"DR HARDIKARS HOSPITAL",
"DR HEDGEWAR AAROGYA SANSTHAN",
"DR HEDGEWAR COLLEGE OF NURSING & HOSPITAL",
"DR HEDGEWAR INSTITUDE OF MEDICAL SCIENCE & RESEARCH",
"DR HERB HEALTH MARK PRIVATE LIMITED",
"DR HOTELS PVT LTD",
"DR HOWARDS WAY DIET PRIVATE LIMITED",
"DR I T M LIMITED",
"DR J J MAGDUM PHARMACY COLLEGE JAYSINGPUR",
"DR J P KABRA EYE HOSPITAL",
"DR J PHARMACHEM PRIVATE LIMITED",
"DR JACKFRUIT INDIA PRIVATE LIMITED",
"DR JAWAHARLAL ROHATGI SMARAK NETRA CHIKITSALAYA",
"DR JEYASEKHARAN MEDICAL TRUST",
"DR JITENDRA C DUMASWALA",
"DR JIVRAJ MEHTA SMARAK HEALTH FOUNDATION",
"DR JRK'S RESEARCH AND PHARMACEUTICALS PRIVATE LIMITED",
"DR K K R S GOWTHAM SCHOOL",
"DR K M CHERIAN EDUCATIONAL SOCIETY",
"DR K N KATJU HOSPITAL",
"DR K N MODI GLOBAL SCHOOL",
"DR KADAM DIAGNOSTIC CENTRE PRIVATE LIMITED",
"DR KAMAKSHI MEMORIAL HOSPITAL PRIVATE LIMITED",
"DR KAMAT'S LABORATORIES PRIVATE LIMITED",
"DR KANAILAL BHATTACHARYA COLLEGE",
"DR KARAN SINGH INTER COLLEGE",
"DR KELKAR DESIGNS PRIVATE LIMITED",
"DR KHANNAS PATHCARE PRIVATE LIMITED",
"DR KHARE HOSPITAL PRIVATE LIMITED",
"DR KHARWAR HEART CLINIC",
"DR KKBM SUBHARTI HOSPITAL",
"DR KM CHERIAN INSTITUTE OF MEDICAL SCIENCES",
"DR KRISHNAS CANCER HEALER CENTER PRIVATE LIMITED",
"DR KRSHNA LIFE SCIENCES LIMITED",
"DR L H HIRANANDANI HOSPITAL",
"DR LAL PATHLABS LIMITED",
"DR LALCHANDANI LABS LIMITED",
"DR M G R EDUCATIONAL AND RESEARCH INSTITUTE",
"DR M G R JANAKI COLLEGE FOR WOMEN",
"DR M K SHAH MEDICAL COLLEGE AND RESEARCH CENTRE",
"DR M L DHAWALE MEMORIAL HOMEOPATHIC INSTITUTE",
"DR M SUNDARAM HOSPITAL PRIVATE LIMITED",
"DR M V SHETTY MEMORIAL TRUST",
"DR MAHALINGAM COLLEGE OF ENGINEERING AND TECHNOLOGY",
"DR MAKAN SURGICSL MATERNITY AND ACCIDENT HOSPITAL",
"DR MALHOTRA'S NUFACE CLINIC",
"DR MALKOTE JR COLLEGE FOR GIRLS",
"DR MANE MULTISPECIALITY HOSPITAL",
"DR MANIYAR & ASSOCIATES",
"DR MANUFACTURING PRIVATE LIMITED",
"DR MEDITECH SURGICAL AND DIAGNOSTICS (INDIA) PRIVATE LIMITED",
"DR MEHTA'S HOSPITAL",
"DR MGR EDUCATIONAL AND RESEARCH INSTITUTE",
"DR MGR ENGINEERING COLLEGE",
"DR MOBILITY SOLUTIONS PRIVATE LIMITED",
"DR MOHAN'S DIABETES SPECIALITIES CENTRE PRIVATE LIMITED",
"DR MONGA OPTICIANS PRIVATE LIMITED",
"DR MOREPEN LIMITED",
"DR MURJANAKI COLLEGE OF ARTS & SCIENCE",
"DR N D DESAI FACULTY OF MEDICAL SCIENCE AND RESEARCH DHARMSINH DESAI UNIVERSITY",
"DR N G P ARTS AND SCIENCE COLLEGE",
"DR N SAHEWALLA AND COMPANY PVT LTD",
"DR NAMJOSHI HOSPITAL PRIVATE LIMITED",
"DR NARAYANA COLLEGE OF COMMERCE",
"DR NAYAPALLI COLLEGE NAYAPALLY",
"DR NEHA'S MEDICAL AESTHETICS PRIVATE LIMITED",
"DR NTR GASTRO CARE PRIVATE LIMITED",
"DR OETKER INDIA PRIVATE LIMITED",
"DR OPTICAL DISC INDIA PRIVATE LIMITED",
"DR P K GUPTA SUPER SPECIALITY CLINIC PRIVATE LIMITED",
"DR P K SAHA HOSPITAL PRIVATE LIMITED",
"DR P V RAMACHANDRA¬† REDDY‚ÄôS PEOPLE‚ÄôS POLYCLINIC",
"DR PADMAJA FERTILITY CENTRES PRIVATE LIMITED",
"DR PALEP'S MEDICAL RESEARCH FOUNDATION PRIVATE LIMITED",
"DR PANJABRAO ALIAS BHAUSAHEB DESHMUKH MEMORIAL MEDICAL COLLEGE",
"DR PANJABRAO DESHMUKH HIGH SCHOOL AMRAVATI",
"DR PARNERKAR MAHARAJ VIDYALAY",
"DR PAWAR‚ÄôS SHINE",
"DR PINNAMANENI SIDDHARTHA INSTITUTE OF MEDICAL SCIENCES & RESEARCH FOUNDATION",
"DR POSITIVE HEALTH SCIENCES PRIVATE LIMITED",
"DR PRASANTA BANERJI HOMOEOPATHIC RESEARCH FOUNDATION",
"DR R K THAKUR HEALTHCARE PRIVATE LIMITED",
"DR RAFIQ ZAKARIA COLLEGE OF WOMEN",
"DR RAI MEMORIAL CANCER HOSPITAL",
"DR RAI MEMORIAL MEDICAL CENTRE",
"DR RAJENDRA GODE INSTITUDE OF PHARMACY",
"DR RAJENDRA GODE INSTITUTE OF TECHNOLOGY AND RESEARCHI",
"DR RAM MANOHAR LOHIA INSTITUTE OF MEDICAL SCIENCES",
"DR RAM MANOHAR LOHIYA HOSPITAL",
"DR RAMESH CARDIAC AND MULTISPECIALITY HOSPITAL PRIVATE LIMITED",
"DR RAOS ENT SUPER SPECIALITY INTERNATIONAL HOSPITAL PRIVATE LIMITED",
"DR REDDY S FOUNDATION",
"DR REDDY'S INSTITUTE OF LIFE SCIENCES",
"DR REDDYS LABORATORIES LIMITED",
"DR REDDY'S RESEARCH FOUNDATION",
"DR RELA INSTITUTE & MEDICAL CENTRE",
"DR RELA INSTITUTE AND MEDICAL CENTRE CAREERS",
"DR REMEDIES HEALTHCARE INDIA PRIVATE LIMITED",
"DR ROSHAN LAL AGGARWAL AND SONS PRIVATE LTD",
"DR S & S S GHANDHY COLLEGE OF ENGG & TECH",
"DR S K MUKHERJI CARDIOLOGY RESEARCH CENTRE",
"DR S RADHAKRISHNAN EDUCATION SOCIETY",
"DR S RADHAKRISHNAN TEACHERS TRAINING COLLEGE",
"DR SAMIR'S GANGA DIAGNOSTIC AND IMAGING CENTRE PRIVATE LIMITED",
"DR SARUP'S PEST CONTROL PVT LTD",
"DR SB AESTHETICS PRIVATE LIMITED",
"DR SHAKUNTALA MISRA NATIONAL REHABILITATION UNIVERSITY",
"DR SHANKARRAO CHAVAN JAGGERY AND AGRO PRODUCT PRIVATE LIMITED",
"DR SHANTABAI NURSING HOME PRIVATE LIMITED",
"DR SHIVAJIRAO KADAM COLLAGE OF PHARMACY",
"DR SHIVAJIRAO KADAM COLLEGE OF PHARMACY",
"DR SHOPCART PRIVATE LIMITED",
"DR SHROFF CHARITY EYE HOSPITAL",
"DR SHROFFS CHARITY EYE HOSPITAL",
"DR SHYAMA PRASAD MUKHERJEE INTERNATIONAL INSTITUTE OF INFORMATION TECHNOLOGY",
"DR SIDHAN`S AYURMIX PRIVATE LIMITED",
"DR SMILEZ HEALTHCARE PRIVATE LIMITED",
"DR SNS COLLEGE OF EDUCATION",
"DR SNS RAJALAKSHMI COLLEGE OF ARTS AND SCIENCE",
"DR SUNDARARAJAN NEURO HOSPITAL PRIVATE LIMITED",
"DR SURI LAB PRIVATE LIMITED",
"DR TANDON NURSING COLLEGE AGRA",
"DR TANDON PHARMACY COLLEGE",
"DR TURNA MAX SURGICAL HOSPITAL",
"DR TVACHA PRIVATE LIMITED",
"DR V N BEDEKAR INSTITUTE OF MANAGEMENT STUDIES MMS",
"DR VAISHAMPAYAN MEMORIAL GOVERNMENT MEDICAL COLLEGE",
"DR VASAVI‚ÄôS HOSPITAL",
"DR VASAVI'S HOSPITAL CENTRE FOR FERTILITY & BIRTH PRIVATE LIMITED",
"DR VEDPRAKASH PATIL AYURVED MEDICAL COLLEGE & RESEARCH INSTITUTE",
"DR VIKHE PATIL MEDICAL COLLEGE & HOSPITAL",
"DR VINOD SHARMA HOMOEOPATHIC CONSULTANT",
"DR VIRENDRA SWARUP EDUCATION CENTER",
"DR VIRENDRA SWARUP INSTITUTE OF COMPUTER STUDIES",
"DR VIRENDRA SWARUP PUBLIC SCHOOL",
"DR VISHWANATH KARAD MIT WORLD PEACE UNIVERSITY",
"DR VISHWANATH KARAD WORLD PEACE SCHOOL ALANDI",
"DR VITHALRAO VIKHE PATIL COLLEGE OF ENGINEERING",
"DR VITHALRAO VIKHE PATIL FOUNDATIONS COLLEGE OF AGRICULTURE",
"DR VS KRISHNA COLLEGE",
"DR WAMSER + BATRA PRIVATE LIMITED",
"DR WILLMAR SCHWABE INDIA PRIVATE LIMITED",
"DR WRITER'S FOOD PRODUCTS PRIVATE LIMITED",
"DR Y S R HORTICULTURAL UNIVERSITY",
"DR YSR AAROGYASRI HEALTH CARE TRUST",
"DR ZIKRUALLAH KHAN'S HABIB HOSPITAL PRIVATE LIMITED",
"DR. A B G'S PATHO SCAN CENTRE PRIVATE LIMITED",
"DR. A S CLINIC PRIVATE LIMITED",
"DR. A.P.J ABDUL KALAM UNIVERSITY",
"DR. ACHARYA PHARMACEUTICALS PRIVATE LIMITED",
"DR. AGGARWAL'S WELLNESS MULTISPECIALITY HOSPITAL PRIVATE LIMITED",
"DR. AGRAVAT HEALTHCARE LIMITED",
"DR. AGRAWAL'S IMAGING CLINIC PRIVATE LIMITED",
"DR. ALI IRANI HEALTH CARE PRIVATE LIMITED",
"DR. AMBEDKAR COLLEGE OF ARTS AND COMMERCE",
"DR. ANAND'S IMAGING AND NEUROLOGICAL RESEARCH CENTRE",
"DR. ANBU PAUL HOTELS PRIVATE LIMITED",
"DR. ANJI REDDY MULTI SPECIALITY HOSPITALS PRIVATE LIMITED",
"DR. ARORA HEALTH CARE PRIVATE LIMITED",
"DR. BABA SAHEB AMBEDKAR HOSPITAL",
"DR BABASAHEB AMBEDKAR MARATHWADA UNIVERSITY",
"DR. BABASAHEB AMBEDKAR VIDYALAY DIST. YAVATMAL",
"DR. BAJAJ DIAGNOSTICS PRIVATE LIMITED",
"DR. BALRAM HEALTHCARE PRIVATE LIMITED",
"DR. BANSAL IMAGING AND PATHLAB PRIVATE LIMITED",
"DR. BAWASAKAR TECHNOLOGY (AGRO) PRIVATE LIMITED",
"DR. BHIM SAIN'S FAMILY DENTAL CLINIC PRIVATE LIMITED",
"DR. BNTOM LABS PRIVATE LIMITED",
"DR. CHAUDHARY HOSPITAL AND MEDICAL RESEARCH CENTRE P. LTD.",
"DR. CHAUDHRY'S MORAL HOSPITAL PRIVATE LIMITED",
"DR. CHHANG'S SUPER SPECIALTY HOSPITAL PRIVATE LIMITED",
"DR. CHOUDHARY'S VETERINARY CARE & RESEARCH PRIVATE LIMITED",
"DR. D. Y. PATIL ARTS, COMMERCE & SCIENCE COLLEGE",
"DR. D. Y. PATIL VIDYAPEETH SOCIETY",
"DR. DAS ' NURSING HOME & DIAGNOSTIC CENTRE PRIVATE LIMITED",
"DR. DUBES HEALTH CARE PRIVATE LIMITED",
"DR. DWIVEDI CLINIC PRIVATE LIMITED",
"DR. EDWIN MEDILABS PRIVATE LIMITED",
"DR. FIXIT INSTITUTE OF STRUCTURAL PROTECTION & REHABILITATION",
"DR. FRESH ASSETS LIMITED.",
"DR. FRITSCH MACHINES AND POWDERS PRIVATE LIMITED",
"DR. G.K. SRIVASTAVA HOSPITAL PRIVATE LIMITED",
"DR. GABA AND ASSOCIATES MEDICARE PRIVATE LIMITED",
"DR. GOLIVI HOSPITALS PRIVATE LIMITED",
"DR. GOWDS DENTAL HOSPITALS PRIVATE LIMITED",
"DR. GUPTA FUNCTIONAL MEDICINE PRIVATE LIMITED",
"DR. HOLLA'S VITILIGO CENTRE PRIVATE LIMITED",
"DR. ISHWAR CHANDRA SEVA SANSTHAN",
"DR. JAIRAJ'S HEALTH SERVICES PRIVATE LIMITED",
"DR. JAY DESHMUKH HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED",
"DR. JYOTHI'S HEALTH CARE PRIVATE LIMITED",
"DR. K. SRIDHHAR HEALTHCARE PRIVATE LIMITED",
"DR. KAUSHAL ARTHROSCOPY AND SPINAL ENDOSCOPY CENTRE",
"DR. KELKAR CONSULTANTS PRIVATE LIMITED",
"DR. KHUNGER EYE CARE AND RESEARCH CENTRE PRIVATE LIMITED",
"DR. KPC BIOINNOVATIONS & DIAGNOSTICS PRIVATE LIMITED",
"DR. LENIN'S ORTHO INDE HOSPITAL PRIVATE LIMITED",
"DR. MADY'S INNOVATION PRIVATE LIMITED",
"DR. MALAY'S HOSPITAL & NEUROSCIENCES CENTRE PRIVATE LIMITED",
"DR. MANI PHARMACEUTICAL PRIVATE LIMITED",
"DR. MANN LIFESCIENCES PRIVATE LIMITED",
"DR. MILTONS LABORATORIES PRIVATE LIMITED",
"DR. NIRMALS' HEALTHCARE PRIVATE LIMITED",
"DR. NISHITA'S COSMETIC CLINIC PRIVATE LIMITED",
"DR. OM PARKASH EYE INSTITUTE PRIVATE LIMITED",
"DR. P. BANERJI'S HOMOEOPATHIC HEALTHCARE PRIVATE LIMITED",
"DR. P. BHASIN PATHLABS PRIVATE LIMITED",
"DR. PIYUSH MRI & DIAGNOSTIC CENTRE",
"DR. PRATHIBHA PEOPLES HEALTH CARE PRIVATE LIMITED",
"DR. RAJENDRA PRASAD CENTRAL AGRICULTURAL UNIVERSITY",
"DR. RAM MANOHAR LOHIA HOSPITAL",
"DR. RIZVIS SKIN CLINIC AND PUVA THERPY RESEARCH CENTRE PRIVATE LIMITED",
"DR. ROY'S DIAGNOSTIC & IMAGING CENTRE PRIVATE LIMITED",
"DR. S. K. SHARMA HEALTHCARE PRIVATE LIMITED",
"DR. S.SANDEEP PATH AND EYE CLINIC PRIVATE LIMITED",
"DR. SABHARWAL'S MANUFACTURING LABS LIMITED",
"DR. SANDHU AGRITECH PRIVATE LIMITED",
"DR. SANJAY MULTISPECIALITY HOSPITAL PRIVATE LIMITED",
"DR. SANKUNNI'S AYURVEDIC RESEARCH FOUNDATION PRIVATE LIMITED",
"DR. SAYANI'S HEALTHCARE PRIVATE LIMITED",
"DR. SHUKLA'S MEDICITY PRIVATE LIMITED",
"DR. SIMAL SOIN SKINCARE (LUDHIANA) PRIVATE LIMITED",
"DR. SIMAL SOIN SKINCARE PRIVATE LIMITED",
"DR. SMITHS BIOTECH PRIVATE LIMITED",
"DR. SOLANKI EYE HOSPITAL PRIVATE LIMITED",
"DR. SRIVASTHAVI",
"DR. SURESH MEDISCAN SYSTEMS PRIVATE LIMITED",
"DR. TIKAMDAS MEMORIAL HEALTHCARE PRIVATE LIMITED",
"DR. TITORIA'S HEALTHCARE PRIVATE LIMITED",
"DR. TRC LAB PRIVATE LIMITED",
"DR. TRIVEDI'S TOTAL HEALTH CARE PRIVATE LIMITED",
"DR. UPADHYAY CLINICS PRIVATE LIMITED",
"DR. VERMA'S DIAGNOSTIC CLINIC",
"DR. VINOD GUPTA HOSPITAL PRIVATE LIMITED",
"DR. WIESNER TEST & AUTOMATION PRIVATE LIMITED",
"DR.ALLAMA IQBAL HIGH SCHOOL & JR.COLLEGE KURUNDWAD",
"DR.APJ ABDUL KALAM COLLEGE OF PARAMEDICAL & HEALTH SCIENCE",
"DR.BIMAL HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED",
"DR.BRJ ORTHO CENTRE PRIVATE LIMITED",
"DR.CAR PRIVATE LIMITED",
"DR.CHANDRAKANTH MALABAR SUPER SPECIALITY EYE HOSPITAL PRIVATE LIMITED",
"DR.ETHIX'S PRODUCTS AND SERVICES LIMITED",
"DR.GANESAN'S HITECH DIAGNOSTIC CENTRE PRIVATE LIMITED",
"DR.GAYATHRI DEVI HEALTH CARE PRIVATE LIMITED",
"DR.JAIN'S FOREST HERBALS PRIVATE LIMITED",
"DR.JAYARAM'S DIAGNOSTIC CENTRE PRIVATE LIMITED",
"DR.JCR BIO-SCIENCES PRIVATE LIMITED",
"DR.K.M.CHERIAN INSTITUTE OF MEDICAL SCIENCES PRIVATE LIMITED",
"DR.KUTTY'S HEALTHCARE PRIVATE LIMITED",
"DR.M.C.AGARWAL HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED",
"DR.M.K.SHAH MEDICAL COLLEGE AND RESEARCH CENTRE",
"DR.MEHTAS HOSPITALS PRIVATE LIMITED",
"DR.OM PARKASH SATYAM ENTERPRISES",
"DR.ORG HEALTHCARE PRIVATE LIMITED",
"DR.RABINDRAN'S HEALTH CARE CENTRE PRIVATE LIMITED",
"DR.RAMACHANDRAN S DIABETES CARE PRIVATE LIMITED",
"DR.RANE HOSPITAL P.LIMITED.",
"DR.REDDYS HOLDINGS LIMITED",
"DR.S.C.DEB HOMOEO RESEARCH LABORATORY PRIVATE LIMITED",
"DR.S.R.RAMANAGOUDAR MULTISPECIALITY HOSPITAL AND RESEARCH INSTITUTE PRIVATE LIMITED",
"DR.SATESSH'S' HAIR CLINIC AND RESEARCH CENTER PRIVATE LIMITED",
"DR.SHAJIS MRI AND MEDICAL RESEARCH CENTRE PRIVATE LIMITED",
"DR.SHEKAR & SADASHIVA AGRI PRIVATE LIMITED",
"DR.SHETTY S NEW MEDICAL CENTRE PRIVATE LIMITED",
"DR.SUBODH AGARWAL MEMORIAL EYECARE PRIVATE LIMITED",
"DR.THIRU NEURO & MULTISPECIALITY HOSPITAL PRIVATE LIMITED",
"DR.VAISHAMPAYAN MEMORIAL GOVERNMENT MEDICAL COLLEGE",
"DR.VANCHILINGAM HOSPITAL (TANJORE) PRIVATE LIMITED",
"DR.VIRENDRA LASER AND PHACO SURGERY CENTER PRIVATE LIMITED",
"DR.VIVEKS MS RAMS DENTISTRY PRIVATE LIMITED",
"DR-4 SOLUTIONS PRIVATE LIMITED",
"DRA AADITHYA PROJECTS PRIVATE LIMITED",
"DRA AADITHYA SOUTH CITY PROJECTS PRIVATE LIMITED",
"DRA CONSULTANTS LIMITED",
"DRA DHARMAPURI INFRA PRIVATE LIMITED",
"DRA INDUSTRIES",
"DRA PROJECTS PRIVATE LIMITED",
"DRACO ENGINEERS PRIVATE LIMITED",
"DRAEGER INDIA PRIVATE LIMITED",
"DRAEGER SAFETY INDIA PRIVATE LIMITED",
"DRAFT AIR INDIA PRIVATE LIMITED",
"DRAFT CARGOWAYS INDIA PRIVATE LIMITED",
"DRAFT N CRAFT LEGAL OUTSOURCING PRIVATE LIMITED",
"DRAGON AGE REALTORS PRIVATE LIMITED",
"DRAGON EXPRESS FREIGHT PRIVATE LIMITED",
"DRAGON HILL LIFESTYLE PRIVATE LIMITED",
"DRAGON INFRA SERVICES PRIVATE LIMITED",
"DRAGON MARITIMO PRIVATE LIMITED",
"DRAGON PEARL INTERNATIONAL PRIVATE LIMITED",
"DRAGON SHIPPING PRIVATE LIMITED",
"DRAGONWAVE HFCL INDIA PRIVATE LIMITED",
"DRAKE MED-TECH PRIVATE LIMITED",
"DRAKE PROPERTIES PRIVATE LIMITED",
"DRAMA SCHOOLS FOUNDATION MUMBAI",
"DRAMZ WHISKY BAR AND LOUNGE PRIVATE LIMITED",
"DRAPES AND DREAMS LIMITED LIABILITY PART NERSHIP",
"DRAPHANT CONSULTANTS PRIVATE LIMITED",
"DRAPHANT INFOTECH PRIVATE LIMITED",
"DRAPYVINE AGROBIZ PRIVATE LIMITED",
"DRASHTA POWER CONSULTANTS PVT. LTD.",
"DRASHTI COTSPIN PRIVATE LIMITED",
"DRASIS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"DRASTI JEWELS PRIVATE LIMITED",
"DRAUTO TECHNOLOGIES PRIVATE LIMITED",
"DRAV STEVIA COMPANY",
"DRAVIDIAN TRAILS HOLIDAYS PRIVATE LIMITED",
"DRAVYA FINANCIAL SOLUTIONS PRIVATE LIMITED",
"DRAVYAM INDUSTRIES PRIVATE LIMITED",
"DRAWBRIDGE VENTURES PRIVATE LIMITED",
"DRAWCANS PRIVATE LIMITED",
"DRAWEDGE TECHNOLOGIES PRIVATE LIMITED",
"DRAWING AND DISBURSING OFFICER",
"DRAWMET WIRES PRIVATE LIMITED",
"DRAX TRADING PRIVATE LIMITED",
"DRB FOODS PRIVATE LIMITED",
"DRB INTER COLLEGE AGRA ROAD HATHRAS",
"DRBEST PHARMACEUTICALS PRIVATE LIMITED",
"DRBR AGRO PRIVATE LIMITED",
"DRC SYSTEMS INDIA LIMITED",
"DRC SYSTEMS INDIA PRIVATE LIMITED",
"DRD COMMUNICATIONS AND SOFTWARE PRIVATE LIMITED",
"DRD CONSTRUCTION PRIVATE LIMITED",
"DRD RICE EXPORTS PRIVATE LIMITED",
"DRD SOFTWARE AND SYSTEMS INDIA PRIVATE LIMITED",
"DREAM ABODES PRIVATE LIMITED",
"DREAM AND MAGIC MEDIA PRIVATE LIMITED",
"DREAM AUTORIDERS INDIA PRIVATE LIMITED",
"DREAM BAKE PRIVATE LIMITED",
"DREAM BUSINESS VENTURES PRIVATE LIMITED",
"DREAM CARE FURNISHINGS PRIVATE LIMITED",
"DREAM CURIO PRIVATE LIMITED",
"DREAM DESTINATIONZ MANAGEMENT PRIVATE LIMITED",
"DREAM DIGITAL TECHNOLOGY PRIVATE LIMITED",
"DREAM EARTHCON PRIVATE LIMITED",
"DREAM ENCON PRIVATE LIMITED",
"DREAM FACILITY SERVICES PRIVATE LIMITED",
"DREAM FACTORY PRIVATE LIMITED",
"DREAM FIELD CHEMICAL PRIVATE LIMITED",
"DREAM FINCAP PRIVATE LIMITED",
"DREAM FLOWER HOUSING PROJECTS PRIVATE LIMITED",
"DREAM GAINS FINANCIALS INDIA PRIVATE LIMITED",
"DREAM GATEWAY HOTELS PRIVATE LIMITED",
"DREAM HOME CARPETS PRIVATE LIMITED",
"DREAM HOME ENGINEERS PRIVATE LIMITED",
"DREAM HOME INDUSTRIES PRIVATE LIMITED",
"DREAM INFRATECH PRIVATE LIMITED",
"DREAM JOBS STAFFING SOLUTION PRIVATE LIMITED",
"DREAM LAND DESIGNERS PRIVATE LIMITED",
"DREAM LEISURE DESTINATIONS (INDIA) PRIVATE LIMITED",
"DREAM MACHINE PRIVATE LIMITED",
"DREAM MAKER CONSTRUCTION PRIVATE LIMITED",
"DREAM MARINE PRIVATE LIMITED",
"DREAM MERCHANTS CONSULTANCY PRIVATE LIMITED",
"DREAM O TRAVELZ PRIVATE LIMITED",
"DREAM PLAST INDIA PRIVATE LIMITED",
"DREAM POWER INTELLIGENCE AND HOSPITALITY PRIVATE LIMITED",
"DREAM REAL 3D PRIVATE LIMITED",
"DREAM REWARDS 360 PRIVATE LIMITED",
"DREAM ROAD TECHNOLOGIES PRIVATE LIMITED",
"DREAM SEATS PRIVATE LIMITED",
"DREAM SHAPERS BUILDCON PRIVATE LIMITED",
"DREAM SOFT INFOTECH PRIVATE LIMITED",
"DREAM SPORTS FIELDS PRIVATE LIMITED",
"DREAM SPORTS FOUNDATION",
"DREAM STEEL PROJECTS PRIVATE LIMITED",
"DREAM SYNERGY PRIVATE LIMITED",
"DREAM TAG REALTY PRIVATE LIMITED",
"DREAM TECH INFOTEL PRIVATE LIMITED",
"DREAM TELECOMMUNICATION PRIVATE LIMITED",
"DREAM THEATRE PRIVATE LIMITED",
"DREAM TRADING PRIVATE LIMITED",
"DREAM VALLEY GOLF AND RESORTS LIMITED",
"DREAM VALLEY GOLF AND RESORTS PRIVATE LIMITED",
"DREAM VEHICLES PRIVATE LIMITED",
"DREAM WEAVER PRIVATE LIMITED",
"DREAM WEAVERS EDUTRACK PRIVATE LIMITED",
"DREAM WORLD ENGLISH SCHOOL",
"DREAM WORLD INTERNATIONAL SCHOOL",
"DREAMADVANTAGE LANDMARK AND INFRASTRUCTURE LIMITED",
"DREAMAJAX TECHNOLOGIES PRIVATE LIMITED",
"DREAMAX DEVELOPERS PRIVATE LIMITED",
"DREAMAX HEALTHCARE PRIVATE LIMITED",
"DREAMBIG IT SOLUTIONS INDIA PRIVATE LIMITED",
"DREAMBIG NETWORKS PRIVATE LIMITED",
"DREAMBIKES AUTO SALES & SERVICES PRIVATE LIMITED",
"DREAMCANN FOODS PRIVATE LIMITED",
"DREAMCAST DIGITAL WORKS PRIVATE LIMITED",
"DREAMCATCHERS FILMS PRIVATE LIMITED",
"DREAMCRAFT EVENTS AND ENTERTAINMENT PRIVATE LIMITED",
"DREAMFOLKS SERVICES LIMITED",
"DREAMFOLKS SERVICES PRIVATE LIMITED",
"DREAMFORCE IT MEDIAWORKS PRIVATE LIMITED",
"DREAMGUYS TECHNOLOGIES PRIVATE LIMITED",
"DREAMHOME INFRASTRUCTURE PRIVATE LIMITED",
"DREAMHOME REALCON PRIVATE LIMITED",
"DREAMHOMES PROPCON PRIVATE LIMITED",
"DREAMHOUSE REALTORS PRIVATE LIMITED",
"DREAMING AGRO FARMERS PRODUCER COMPANY LIMITED",
"DREAMIYATA ENTERTAINMENT PRIVATE LIMITED",
"DREAMLAND APARTMENTS PVT LTD",
"DREAMLAND HOPE HOSPITAL PRIVATE LIMITED",
"DREAMLIGHT MERCHANT PRIVATE LIMITED",
"DREAMLIGHT VYAPAAR PRIVATE LIMITED",
"DREAMLINE TECHNOLOGIES PRIVATE LIMITED",
"DREAMLINK TECHNOLOGIES PRIVATE LIMITED",
"DREAMORBIT SOFTECH PRIVATE LIMITED",
"DREAMORBIT SOFTTECH PRIVATE LIMITED",
"DREAMS AUTOMOBILES PRIVATE LIMITED",
"DREAMS BIKES & MACHINES PRIVATE LIMITED",
"DREAMS DEBT SOLUTIONS PRIVATE LIMITED",
"DREAMS EDUCATIONAL AND HUMAN WELFARE SOCIETY",
"DREAMS EVENTS AND ADS (INDIA) PRIVATE LIMITED",
"DREAMS IMPORT PRIVATE LIMITED",
"DREAMS LINEN PRIVATE LIMITED",
"DREAMS SUPER SPECIALITY HOSPITAL",
"DREAMS THE FURNISHING GALLERY PRIVATE LIMITED",
"DREAMSCAPE MEDIA PRIVATE LIMITED",
"DREAMSOFT IT SOLUTIONS PRIVATE LIMITED",
"DREAMSOL TELE SOLUTIONS PRIVATE LIMITED",
"DREAMSPACE INTERIORS PRIVATE LIMITED",
"DREAMSTEP SOFTWARE INNOVATIONS PRIVATE LIMITED",
"DREAMSTORIES BUILDERS PRIVATE LIMITED",
"DREAMSUNSHINE DIGITAL PRIVATE LIMITED",
"DREAMVELLY RETAIL PRIVATE LIMITED",
"DREAMVU INDIA PRIVATE LIMITED",
"DREAMWALLS PAINTS PRIVATE LIMITED",
"DREAMWARES IT SOLUTIONS LLP",
"DREAMWORLD INFRAPROJECTS PRIVATE LIMITED",
"DREAMWORLD PACKAGING PRIVATE LIMITED",
"DREAMZ ABROAD CONSULTANTS PRIVATE LIMITED",
"DREAMZ AUTOMATION SYSTEMS PRIVATE LIMITED",
"DREAMZ HOMEWARE PRIVATE LIMITED",
"DREAMZ MOTORS PRIVATE LIMITED",
"DREAMZ OVERSEAS PRIVATE LIMITED",
"DREAMZ PERFUMERS PRIVATE LIMITED",
"DREAMZ SECURITIES & BROKING SERVICES PRIVATE LIMITED",
"DREAMZ SOLUTION PRIVATE LIMITED",
"DREAMZ TECH SOLUTIONS PRIVATE LIMITED",
"DREAMZ TOURS & TRAVLS PRIVATE LIMITED",
"DREAMZSOP ADVERTISING PRIVATE LIMITED",
"DRECHSLER TECHNOLOGIES PRIVATE LIMITED",
"DRECO ENERGY SERVICES ULC",
"DREDGEPRO SOLUTIONS (INDIA) PRIVATE LIMITED",
"DREDGING AND DESILTATION COMPANY PVT LTD",
"DREDGING CORPORATION OF INDIA LIMITED",
"DREESHTI AIRTECH SOLUTIONS PRIVATE LIMITED",
"DREISATZ MYSOLAR24 PRIVATE LIMITED",
"DREMIO SOFTWARE INDIA PRIVATE LIMITED",
"DREPP TECHNOLOGIES PRIVATE LIMITED",
"DRES ENERGY PRIVATE LIMITED",
"DRESS CIRCLE",
"DRESS CODE CLOTHING PRIVATE LIMITED",
"DRESS LAND GLOBAL PRIVATE LIMITED",
"DRESS MASTER APPAREL PRIVATE LIMITED",
"DRESS. COM INDIA PRIVATE LIMITED",
"DRESSING-HUB INDIA PRIVATE LIMITED",
"DRESSUP APPAREL PRIVATE LIMITED",
"DREWRY MARITIME SERVICES PRIVATE LIMITED",
"DREXLER PHARMACEUTICALS PRIVATE LIMITED",
"DREXSPORT INDIA (OPC) PRIVATE LIMITED",
"DRG ANALYTICS & INSIGHTS PRIVATE LIMITED",
"DRG WELLNESS PRIVATE LIMITED",
"DRHL INDIA SERVICES PRIVATE LIMITED",
"DRI INDIA RELAYS PRIVATE LIMITED",
"DRIDA INFOTECH PRIVATE LIMITED",
"DRIFTS LOGISTICS PRIVATE LIMITED",
"DRIFTWOOD HOLIDAYS PRIVATE LIMITED",
"DRILBITS INTERNATIONAL PRIVATE LIMITED",
"DRILEX OILFIELD SERVICES PRIVATE LIMITED",
"DRILL JIG BUSHING CO MADRAS PRIVATE LIMITED",
"DRILL SYSTEMS INDIA PRIVATE LIMITED",
"DRILL WILL CLUBS AND HOSPITALITY PRIVATE LIMITED",
"DRILLCON INFRASTRUCTURE PRIVATE LIMITED",
"DRILLCOTEC ENGINEERING SERVICES PRIVATE LIMITED",
"DRILLTECH ENGINEERS PRIVATE LIMITED",
"DRINKSMART HUB PRIVATE LIMITED",
"DRINKWATER ADVERTISING PRIVATE LIMITED",
"DRIP CAPITAL SERVICES INDIA LLP",
"DRIP INDIA IRRIGATION PRIVATE LIMITED",
"DRIPLEX WATER ENGINEERING INTL. LIMITED",
"DRIPTECH INDIA PRIVATE LIMITED",
"DRISE POWER INFRATECH PRIVATE LIMITED",
"DRISH INFOTECH LIMITED",
"DRISH SHOES LIMITED",
"DRISHTEE DEVELOPMENT AND COMMUNICATION LIMITED",
"DRISHTEE FOUNDATION",
"DRISHTEE MEDICOS AND SURGICALS PRIVATE LIMITED",
"DRISHTEE RURAL APPAREL PRODUCER COMPANY LIMITED",
"DRISHTI APPARELS PRIVATE LIMITED",
"DRISHTI CONSULLTANTS PRIVATE LIMITED",
"DRISHTI DEVCON PRIVATE LIMITED",
"DRISHTI DR R C JAIN INNOVATIVE SENIOR SECONDARY PUBLIC SCHOOL LUDHIANA",
"DRISHTI ENGINEERS LLP",
"DRISHTI EQUIPMENTS PRIVATE LIMITED",
"DRISHTI EYE INSTITUTE",
"DRISHTI GLOBAL PRIVATE LIMITED",
"DRISHTI HOSPITALITY COMPANY PRIVATE LIMITED",
"DRISHTI JEWELLERY PRIVATE LIMITED",
"DRISHTI LIFESAVING PRIVATE LIMITED",
"DRISHTI MANAGERS & ADVISORS PRIVATE LIMITED",
"DRISHTI MOTORS PRIVATE LIMITED",
"DRISHTI MULTI COMMODITY PRIVATE LIMITED",
"DRISHTI OFFSET AND PACKAGING PRIVATE LIMITED",
"DRISHTI SHARES & INVESTMENTS PRIVATE LIMITED",
"DRISHTI SOFT SOLUTIONS PRIVATE LIMITED",
"DRISHTI SPECIAL RESPONSE SERVICES PRIVATE LIMITED",
"DRISHTIPUNJ EYE HOSPITAL PRIVATE LIMITED",
"DRISHYA FOUNDATION RICHMOND BANGALORE",
"DRISHYAM FILMS PRIVATE LIMITED",
"DRISHYAM SEEDS PRIVATE LIMITED",
"DRISTTI STRUCTURAL ENGINEERING PRIVATE LIMITED",
"DRITA TECHNOLOGIES PRIVATE LIMITED",
"DRITHI METALS PRIVATE LIMITED",
"DRIVADO TRANSFERS PRIVATE LIMITED",
"DRIVE HOME PRIVATE LIMITED",
"DRIVE INDIA ENTERPRISE SOLUTION LIMITED",
"DRIVE INDIA ENTERPRISE SOLUTIONS LIMITED",
"DRIVEDAZZ SOLUTIONS PRIVATE LIMITED",
"DRIVEDGE INFOSOLUTIONS PRIVATE LIMITED",
"DRIVEIN INDIA TECHNOLOGIES PRIVATE LIMITED",
"DRIVELIFE AUTOMOBILE PRIVATE LIMITED",
"DRIVER LOGISTICS LLP",
"DRIVES APPLICATION PRIVATE LIMITED",
"DRIVESTREAM INDIA PRIVATE LIMITED",
"DRIVESY LUBRICANTS & GREASE PRIVATE LIMITED",
"DRIVETRON INDIA PRIVATE LIMITED",
"DRIVEWAY SOLUTIONS PRIVATE LIMITED",
"DRIVUS MOTOCORP PRIVATE LIMITED",
"DRJ IMPEX PRIVATE LIMITED",
"DRJ PETROCHEM PRIVATE LIMITED",
"DRJ PLASTTECH PRIVATE LIMITED",
"DRJ RECORDS INDUSTRIES PRIVATE LIMITED",
"DRK COLLEGE OF ENGINEERING AND TECHNOLOGY",
"DRK ENGINEERS PRIVATE LIMITED",
"DRK HYDROCARBONS PRIVATE LIMITED",
"DRK INFOTECH PRIVATE LIMITED",
"DRK INSTITUTE OF SCIENCE & TECHNOLOGY",
"DRK INTERNATIONAL FREIGHT FORWARDERS PRIVATE LIMITED",
"DRK METALLURGICAL PRIVATE LIMITED",
"DRK RETAIL PRIVATE LIMITED",
"DRL LOGISTICS PRIVATE LIMITED",
"DRM ASSOCIATES PRIVATE LIMITED",
"DRM BUILDCON PRIVATE LIMITED",
"DRM FILTER TECHNOLOGY PRIVATE LIMITED",
"DRM OFFICE",
"DRN DEFINITE SOLUTIONS PRIVATE LIMITED",
"DRN HOSPITALITIES PRIVATE LIMITED",
"DRN INFRASTRUCTURE PRIVATE LIMITED",
"DROEGE GROUP INDIA PRIVATE LIMITED",
"DROGEVATE SOLUTIONS PRIVATE LIMITED",
"DROIT STEEL BUILDINGS PRIVATE LIMITED",
"DROLIA AGENCIES PVT LTD",
"DROLIA ELECTROSTEELS PRIVATE LIMITED",
"DROLIA HOSPITAL PRIVATE LIMITED",
"DROLIA MINERAL INDUSTRIES PRIVATE LIMITED.",
"DROM MARBLE PRIVATE LIMITED",
"DROM WORKSHALA PRIVATE LIMITED",
"DRON EDGE INDIA PRIVATE LIMITED",
"DRON PRECISION MECHANICAL",
"DRON PUBLIC SCHOOL",
"DRONA AVIATION PRIVATE LIMITED",
"DRONA FOUNDATION",
"DRONA IMPEX PRIVATE LIMITED",
"DRONA INDUSTRIES PRIVATE LIMITED",
"D'RONA ROHITRA PRIVATE LIMITED.",
"DRONACHARYA COLLEGE OF ENGINEERING",
"DRONE CARGOMOVERS PRIVATE LIMITED",
"DRONE DESTINATION LIMITED",
"DRONE FEDERATION INDIA",
"DRONE POWER PRIVATE LIMITED",
"DRONE TELECOMMUNICATION PRIVATE LIMITED",
"DRONEACHARYA AERIAL INNOVATIONS LIMITED",
"DRONEE MEDIA PRIVATE LIMITED",
"DROOL HOSPITALITY PRIVATE LIMITED",
"DROOLS PET FOOD PRIVATE LIMITED",
"DROOM TECH LOGISTIC PRIVATE LIMITED",
"DROOM TECHNOLOGY LIMITED",
"DROOM TECHNOLOGY PRIVATE LIMITED",
"DROP LUB ENGINEERS PRIVATE LIMITED",
"DROPADI ISPAT PRIVATE LIMITED",
"DROPADI NETRALAYA PRIVATE LIMITED",
"DROPCO MULTILUB SYSTEMS PRIVATE LIMITED",
"DROPEX (INDIA) TAR PRODUCTS PRIVATE LIMITED",
"DROPKAFFE FOOD AND BEVERAGES PRIVATE LIMITED",
"DROPLET OFFSHORE SERVICES PRIVATE LIMITED",
"DROPSHIP FUELS PRIVATE LIMITED",
"DROPSHOP NETWORK PRIVATE LIMITED",
"DROR LABS PRIVATE LIMITED",
"DROSERA INTERNATIONAL PRIVATE LIMITED",
"DROSIA INDIA LIMITED",
"DROVE SECURITY SOLUTION PRIVATE LIMITED",
"DROVIN MANAGEMENT SERVICES PRIVATE LIMITED",
"DRP ENTERPRISES PRIVATE LIMITED",
"DRP PUBLIC SCHOOL",
"DRR EYE CARE AND OCULOPLASTY HOSPITAL",
"DRR MARINE EXPORTS PRIVATE LIMITED",
"DRRK FOODS PRIVATE LIMITED",
"DRRON CHEMICAL INDUSTRIES PRIVATE LIMITED",
"DRRUTEC ENGINEERING SOLUTIONS PRIVATE LIMITED",
"DRS AUTOMOTIVE INDIA PRIVATE LIMITED",
"DRS CARGO MOVERS LIMITED",
"DRS CONSULTANTS PRIVATE LIMITED",
"DRS DILIP ROAD LINES PRIVATE LIMITED",
"DRS EARTHWORK PRIVATE LIMITED",
"DRS ENGINEERING PRODUCTS PVT LTD",
"DRS INFRA PRIVATE LIMITED",
"DRS INFRATECH PRIVATE LIMITED",
"DRS INTERNATIONAL SCHOOL",
"DRS IT CONSULTANCY PRIVATE LIMITED",
"DRS JEWELLERS PRIVATE. LIMITED.",
"DRS MARINE SERVICES PRIVATE LIMITED",
"DRS MILLENNIUM PRIVATE LIMITED",
"DRS S&NR SIDDHARTHA INSTITUTE OF DENTAL SCIENCES",
"DRS WAREHOUSING (NORTH) PRIVATE LIMITED",
"DRS WAREHOUSING NORTH PRIVATE. LIMITED.",
"DRSC SOLUTIONS PRIVATE LIMITED",
"DRSCHUMACHER INDIA PRIVATE LIMITED",
"DRSHTI STRATEGIC RESEARCH SERVICES PRIVATE LIMITED",
"DRSLINX LOGISTICS WORLDWIDE PRIVATE LIMITED",
"DRSM MEDIKARE PRIVATE LIMITED",
"DRSTA MEDIKAMENT DISTRIBUTORS PRIVATE LIMITED",
"DRSTIM ASD PROJECTS PRIVATE LIMITED",
"DRSTORE HEALTHCARE SERVICES INDIA PRIVATE LIMITED",
"DRT ANTHEA AROMA CHEMICALS PRIVATE LIMITED",
"DRUCARE PRIVATE LIMITED",
"DRUCKGRAFEN INDIA",
"DRUFLON ELECTRONICS PRIVATE LIMITED",
"DRUG CENTRE DELHI PRIVATE LIMITED",
"DRUG FIELD PRIVATE LIMITED",
"DRUG FOR LIFE INDIA PRIVATE LIMITED",
"DRUG POINT PRIVATE LIMITED",
"DRUGMART INDIA PRIVATE LIMITED",
"DRUMS FOOD INTERNATIONAL PRIVATE LIMITED",
"DRUPE ENGINEERING PRIVATE LIMITED",
"DRUPEROOT MEDIA PRIVATE LIMITED",
"DRUSHTI REALTORS PRIVATE LIMITED",
"DRUSYA MEDIA PLANNERS PRIVATE LIMITED",
"DRUTA DESIGNS PRIVATE LIMITED",
"DRUTGAMEE ROAD CARRIERS PRIVATE LIMITED",
"DRUVA DATA SOLUTIONS PRIVATE LIMITED",
"DRUVA SOFTWARE PRIVATE LIMITED",
"DRUZBA OVERSEAS PRIVATE LIMITED",
"DRV DRINKS PRIVATE LIMITED",
"DRV ENTERPRISES PRIVATE LIMITED",
"DRV INN LLP",
"DRV OVERSEAS EXPORT PRIVATE LIMITED",
"DRV PORTFOLIO PRIVATE LIMITED",
"DRWS PRIVATE LIMITED",
"DRY AIR INDIA PRIVATE LIMITED",
"DRY BLEND FOODS PRIVATE LIMITED",
"DRY MIX INDUSTRIES PRIVATE LIMITED",
"DRYCHEM INDIA PRIVATE LIMITED",
"DRYCHEM SOLUTIONS PRIVATE LIMITED",
"DRYCOOL SYSTEMS (INDIA) PVT LTD",
"DRYFRUIT FACTORY LLP",
"DRYFRUITVALA FOOD INDUSTRY PRIVATE LIMITED",
"DRYGREEN INDIA PRIVATE LIMITED",
"DRYSTAR INDIA PRIVATE LIMITED",
"DRYTEC INDUSTRIES PRIVATE LIMITED",
"DRYTECH PROCESSES INDIA P LTD",
"DS & JAKS CONSTRUCTIONS PRIVATE LIMITED",
"DS AGRIFOODS PRIVATE LIMITED",
"DS ASSAM HOSPITALITY INDIA LIMITED",
"DS BIOVET PHARMA PRIVATE LIMITED",
"DS CHEWING PRODUCT LLP",
"DS CONNECTORS AND CABLES INDIA PRIVATE LIMITED",
"DS DIGITAL PRIVATE LIMITED",
"DS DRINKS & BEVERAGES PRIVATE LIMITED",
"DS FIRE SYSTEMS PRIVATE LIMITED",
"DS GREEN AGROTECH PRIVATE LIMITED",
"DS LUXURY RETAIL LIMITED",
"DS MAX PROPERTIES PRIVATE LIMITED",
"DS MAX REALTY PRIVATE LIMITED",
"DS MERCHANTS INDIA PRIVATE LIMITED",
"DS MULTIMEDIA PRIVATE LIMITED",
"DS NAMAH HOSPITALITY PRIVATE LIMITED",
"DS PIPELINE PROJECTS PRIVATE LIMITED",
"DS SMART ENERGY PRIVATE LIMITED",
"DS SOLUTIONS PRIVATE LIMITED",
"DS SPICECO PRIVATE LIMITED",
"DS SYSTEMS PRIVATE LIMITED",
"DS TOLL ROAD LIMITED",
"DS TRADERS",
"DS2 TURNKEY SOLUTIONS PRIVATE LIMITED",
"DSA BUILDWELL PRIVATE LIMITED",
"DSA ELECTRO CONTROLS PRIVATE LIMITED",
"DSA ENGINEERING CONSULTANTS PRIVATE LIMITED",
"DSA MINES AND MINERALS PRIVATE LIMITED",
"DSA REMEDIES PRIVATE LIMITED",
"DSAND ANIMAL NUTRITION PRIVATE LIMITED",
"DSANT LIVING PRIVATE LIMITED",
"DSB HOSPITALITY PRIVATE LIMITED",
"DSB INNOVATIVE INDUSTRIES PRIVATE LIMITED",
"DSC INDIA CONTROL & MACHINERIES PRIVATE LIMITED",
"DSC INTERIOR PRIVATE LIMITED",
"DSC LEATHER COMPANY PRIVATE LIMITED",
"DSC PIPES AND TUBES PRIVATE LIMITED",
"DSC TEC PVT LTD",
"DSCIGN BIOSYS PRIVATE LIMITED",
"DSCOVR JOURNEYS PRIVATE LIMITED",
"DSD AND MATWAR SERVICES PRIVATE LIMITED",
"DSD ASPIRING PRIVATE LIMITED",
"DSD INFRATECH MANAGEMENT PVIVATE LIMITED",
"DSD PROPERTIES PVT LTD",
"DSDNA ENGINEERS AND INDUSTRIES PRIVATE LIMITED",
"DSE FINANCIAL SERVICES LIMITED",
"DSF AQUATECH PVT LTD",
"DSF ENTERPRISES PRIVATE LIMITED",
"DSF TECHNOLOGY CONSULTANTS PRIVATE LIMITED",
"DSFS ADVISORY SERVICES PRIVATE LIMITED",
"DSFS WEALTH LLP",
"DSG CORP PRIVATE LIMITED",
"DSG INVESTMENTS PRIVATE LIMITED",
"DSG PAPERS PRIVATE LIMITED",
"DSH AGRO FOODS PRIVATE LIMITED",
"DSH TECHNOLOGIES PRIVATE LIMITED",
"DSI TECHNOLOGIES PRIVATE LIMITED",
"DSIG IT SOLUTIONS PRIVATE LIMITED",
"D'SIGNS WORKSPACE INNOVATIONS PRIVATE LIMITED",
"DSIIDC ENERGY LIMITED",
"DSIIDC LIQUOR LIMITED",
"DSIIDC MAINTENANCE SERVICES LIMITED",
"DSIJ PRIVATE LIMITED",
"DSIRE TECHNOLOGIES SOLUTIONS PRIVATE LIMITED",
"DSK ENTERPRISERS PRIVATE LIMITED",
"DSK FOODS PRIVATE LIMITED",
"DSK GLOBAL EDUCATION AND RESEARCH LIMITED",
"DSK MOTOWHEELS PRIVATE LIMITED",
"DSKY TECHNOLOGY PRIVATE LIMITED",
"DSL EDUTECH PRIVATE LIMITED",
"DSL HYDROWATT LIMITED",
"DSL INFOSYS PRIVATE LIMITED",
"DSL INFRASTRUCTURE & SPACE DEVELOPERS PRIVATE LIMITED",
"DSL MARKETING PRIVATE LIMITED",
"DSL PROPERTIES PRIVATE LIMITED",
"DSL STEELS PRIVATE LIMITED",
"DSM AGENCIES PRIVATE LIMITED",
"DSM ENTERPRISES PRIVATE LIMITED",
"DSM FRESH FOODS PRIVATE LIMITED",
"DSM INDIA PRIVATE LIMITED",
"DSM MERCANTILES PRIVATE LIMITED",
"DSM NUTRITIONAL PRODUCTS INDIA PRIVATE LIMITED",
"DSM PROJECTS PRIVATE LIMITED",
"DSM SHARED SERVICES INDIA PRIVATE LIMITED",
"DSM SOFT PRIVATE LIMITED",
"DSM STEEL & WIRES PRIVATE LIMITED",
"DSMART SYSTEMS PRIVATE LIMITED",
"DSN SECURITIES PRIVATE LIMITED",
"DSOFT INFOTECH PRIVATE LIMITED",
"DSONS SANITARYWARES PRIVATE LIMITED",
"D'SOUZA METAL CUTTING PRIVATE LIMITED",
"DSP ADIKO HOLDINGS PRIVATE LIMITED",
"DSP ASSET MANAGERS PRIVATE LIMITED",
"DSP CORPORATE SERVICES PRIVATE LIMITED",
"DSP CORPORATE SOLUTIONS PRIVATE LIMITED",
"DSP DESIGN ASSOCIATES PRIVATE LIMITED",
"DSP FINANCE PRIVATE LIMITED",
"DSP HMK HOLDINGS PRIVATE LIMITED",
"DSP INVESTMENT MANAGERS PRIVATE LIMITED",
"DSP INVESTMENT PRIVATE LIMITED",
"DSP MERRILL LYNCH CAPITAL LIMITED",
"DSP MERRILL LYNCH LIMITED",
"DSP METALS PRIVATE LIMITED",
"DSP PENSION FUND MANAGERS PRIVATE LIMITED",
"DSP PRECISION PRODUCTS PRIVATE LIMITED",
"DSP TRUSTEE PRIVATE LIMITED",
"DSPACE TECHNOLOGIES PRIVATE LIMITED",
"DSPC ENGINEERING PRIVATE LIMITED",
"DSPI MILK FOODS LIMITED",
"DSPWORKS AUTOMATION AND WIRELESS NETWORK SOLUTIONS PRIVATE LIMITED",
"DSQ ARCHITECTS PRIVATE LIMITED",
"DSQUARE SOLUTIONS PRIVATE LIMITED",
"DSQUARE TECH IMPEX PRIVATE LIMITED",
"DSQUARE TECH LABS (HYD) PRIVATE LIMITED",
"DSR AGRI MEDIA PRIVATE LIMITED",
"DSR AGROTECH PRIVATE LIMITED",
"DSR AQUATECH PRIVATE LIMITED",
"DSR CHARITABLE ORGANISATION",
"DSR DAIRY FOODS PRIVATE LIMITED",
"DSR ECOTECH PRIVATE LIMITED",
"DSR EDUCATIONAL SOCIETY",
"DSR HEALTHCARE PRIVATE LIMITED",
"DSR INFOTECH LIMITED",
"DSR JANATA HINDU HOTEL PRIVATE LIMITED",
"DSR POWER WORLD PRIVATE LIMITED",
"DSR SONS INDIA ENGINEERS PRIVATE LIMITED",
"DSR STEEL PRIVATE. LIMITED.",
"DSRK HOLDINGS (CHENNAI) PRIVATE LIMITED",
"DSS AGRISOLUTIONS PRIVATE LIMITED",
"DSS ENTERPRISES PRIVATE LIMITED",
"DSS IMAGETECH PRIVATE LIMITED",
"DSS SUSTAINABLE SOLUTIONS INDIA PRIVATE LIMITED",
"DSS SYSTEMS AND SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"DSS TAKARA BIO INDIA PRIVATE LIMITED",
"DSS TRANSMISSION GEARS PRIVATE LIMITED",
"DSSG BESPOKE SOLUTIONS PRIVATE LIMITED",
"DSSG INFRA PRIVATE LIMITED",
"DSSI SOLUTIONS INDIA PRIVATE LIMITED",
"DSSWORLD PRIVATE LIMITED",
"DST CHEMICALS INDIA PRIVATE LIMITED",
"DST FINSERV PRIVATE LIMITED",
"DST LOGIPACK SOLUTIONS INDIA PRIVATE LIMITED",
"DST TECH PRIVATE LIMITED",
"DSTA EDUCATION FOUNDATION",
"D-STAR JEWELLERY AND WATCHES PRIVATE LIMITED",
"DSV AIR & SEA INTERNATIONAL PRIVATE LIMITED",
"DSV AIR & SEA PRIVATE LIMITED",
"DSV COLOAD & CLEARANCE PRIVATE LIMITED",
"DSV EXPORTS PRIVATE LIMITED",
"DSV JEWELLERS PRIVATE LIMITED",
"DSV SOLUTIONS PRIVATE LIMITED",
"DT ENTERPRISE PRIVATE LIMITED",
"DT PATH LAB PRIVATE LIMITED",
"DT TECHSOLUTIONS PRIVATE LIMITED",
"DT TRENDZ PRIVATE LIMITED",
"DTALE DECOR PRIVATE LIMITED",
"DTC",
"DTC INDIA LIMITED",
"DTC INFOTECH PRIVATE LIMITED",
"DTC PROJECTS PRIVATE LIMITED DTCPPL",
"DTC SECURITIES LIMITED",
"DTC SECURITIES PRIVATE LIMITED",
"DTC SOUTHERN HEIGHTS ASSOCIATION",
"DTC SYSTEMS PRIVATE LIMITED",
"DTC TECHNOLOGIES PRIVATE LIMITED",
"DTCC ENTERPRISE SERVICES INDIA P LIMITED",
"DTCC SOLUTIONS LLC",
"DTDC EXPRESS LIMITED",
"DTDHI HEALTH INDIA PRIVATE LIMITED",
"DTDS TECHNOLOGY PRIVATE LIMITED",
"DTE EXPORTS PVT LTD",
"DTE OF ANIMAL HUSBANDARY",
"DTE OF HORTICULTURE",
"D-TECH INDIA PRIVATE LIMITED",
"DTECH PRODUCTS PRIVATE LIMITED",
"DTECHFRONT ENGINEERS PRIVATE LIMITED",
"DTEK INNOVATIVE PRIVATE LIMITED",
"DTH INFRA ENGINEERS PRIVATE LIMITED",
"DTK AUTO PRESS COMPS. PRIVATE LIMITED",
"DTL ANCILLARIES LIMITED",
"DTL INDIA HOLDINGS LIMITED",
"D-TOOLS DEVELOPMENT CENTER PRIVATE LIMITED",
"DTOWN ROBOTICS PRIVATE LIMITED",
"DTS CARGO PRIVATE LIMITED",
"DTS HEALTHCARE SERVICES",
"DTS HOUSING AND PROJECTS PRIVATE LIMITED",
"DTS LOGISTICS PRIVATE LIMITED",
"DTS TRAVELS PRIVATE LIMITED",
"DTV INDIA PRIVATE LIMITED",
"DU DATA RACK SYSTEMS PRIVATE LIMITED",
"DU PONT FAR EAST INC.,",
"DUA & BANSAL SOLUTIONS PRIVATE LIMITED",
"DUA AND ASSOCIATES HOTELS PRIVATE. LIMITED",
"DUA AUTOMOBILES PRIVATE LIMITED",
"DUA DIAGNOSTICS PRIVATE LIMITED",
"DUA INFOTECH",
"DUACO EQUIPMENTS PRIVATE LIMITED",
"DUAL MANUFACTURING TECHNOLOGIES PRIVATE LIMITED",
"DUAL MARKETING PRIVATE LIMITED",
"DUAL RINGS PRIVATE LIMITED",
"DUAL STRUCTURALS & INDUSTRIES PRIVATE LIMITED",
"DUAL TECHNOLOGIES PRIVATE LIMITED",
"DUALAPP TECHNOLOGIES PRIVATE LIMITED",
"DUALLIFE SCIENCE PRIVATE LIMITED",
"DUANE PARK PRIVATE LIMITED",
"DUARIKA TRADING & INVESTMENT PRIVATE LIMITED",
"DUARS UNION TEA CO. LIMITED",
"DUARZ HR SERVICES PRIVATE LIMITED",
"DUBAM PRIVATE LIMITED",
"DUBARIA COMPUTERS PRIVATE LIMITED",
"DUBAS ENGINEERING PRIVATE. LIMITED.",
"DUBBAK SOLAR PROJECTS PRIVATE LIMITED",
"DUBEYS INFORMATION POOL AND SOLUTION PRIVATE LIMITED",
"DUBNSUB MEDIA PRIVATE LIMITED",
"DUBOND PRODUCTS (INDIA) PRIVATE LIMITED",
"DUC TOAN MEDICAL (INDIA) PRIVATE LIMITED",
"DUCA INDUSTRIES PRIVATE LIMITED",
"DUCAB EW INDIA PRIVATE LIMITED",
"DUCARA INFO SOLUTIONS PRIVATE LIMITED",
"DUCATI ENERGIA INDIA PRIVATE LIMITED",
"DUCATI INDIA PRIVATE LIMITED",
"DUCCAN ALLOY CASTINGS (I) PRIVATE LIMITED",
"DUCEM TECHNOLOGIES PRIVATE LIMITED",
"ORION INDIA DUCEN PRIVATE LIMITED",
"DUCERE SOFTECH PRIVATE LIMITED",
"DUCERE TECHNOLOGIES PRIVATE LIMITED",
"DUCH ELECTROGUARD PRIVATE LIMITED",
"DUCIMA ANALYTICS PRIVATE LIMITED",
"DUCK CREEK TECHNOLOGIES INDIA LLP",
"DUCK WOO AUTOIND PRIVATE LIMITED",
"DUCKBACK WATERPROOF WORKS PRIVATE LIMITED",
"DUCKER WORLDWIDE MANAGEMENT CONSULTING PRIVATE LIMITED",
"DUCKLING DIAGNOSTIC CENTRE PRIVATE LIMITED",
"DUCLEAN FACILITY SERVICES PRIVATE LIMITED",
"DUCO CONSULTANCY PRIVATE LIMITED",
"DUCOL ORGANICS & COLOURS PRIVATE LIMITED",
"DUCOL ORGANICS AND COLOURS LIMITED",
"DUCOM AEROSPACE TECHNOLOGIES PRIVATE LIMITED",
"DUCOM INSTRUMENTS PRIVATE LIMITED",
"DUCON CONSULTANTS PRIVATE LIMITED",
"DUCON CONTRACTORS PRIVATE LIMITED",
"DUCON INFRATECHNOLOGIES LIMITED",
"DUCON TECHNOLOGIES I PRIVATE LIMITED",
"DUCONT INDIA SYSTEMS PRIVATE LIMITED",
"DUCOTECH INDIA PRIVATE LIMITED",
"DUCTFAB EQUIPMENTS PRIVATE LIMITED",
"DUCTROVE INNOVATIONS PRIVATE LIMITED",
"DUCTUS TECHNOLOGIES PRIVATE LIMITED",
"DUDANI ENTERPRISE PRIVATE LIMITED",
"DUDANI EXPORTS PRIVATE LIMITED",
"DUDANI METALS PRIVATE LIMITED",
"DUDANI RETAIL PRIVATE LIMITED",
"DUDDU FIN-LEASE LIMITED",
"DUDE MULTI SERVICES PRIVATE LIMITED",
"DUDHANE METALLICS PRIVATE LIMITED",
"DUDHAT CHEMEQUIP PRIVATE LIMITED",
"DUDHAT INDUSTRIES PRIVATE LIMITED",
"DUDHAT INFRA PRODUCTS LIMITED",
"DUDHEPUKUR COLD STORAGE PRIVATE LIMITED",
"DUDHERIA APPARELS PRIVATE LIMITED",
"DUDHESHWAR ENGINEERS PRIVATE LIMITED",
"DUDHESHWAR FARMERS PRODUCER COMPANY LIMITED",
"DUDHESHWAR NATURAL HEALTH RESORT PRIVATE LIMITED",
"DUDHI INDUSTRIES PRIVATE LIMITED",
"DUDHSAGAR DAIRY MEHSANA",
"DUDI CONSTRUCTION PRIVATE LIMITED",
"DUDIGITAL GLOBAL LIMITED",
"DUDLEY & BROTHER PVT. LTD.",
"DUDLEY CAPITAL MARKET LTD",
"DUEFUL HEALTHCARE PRIVATE LIMITED",
"DUES MANAGER PRIVATE LIMITED",
"DUET INDIA HOTELS (BANGALORE) PRIVATE LIMITED",
"DUET INDIA HOTELS (NAVI MUMBAI) PRIVATE LIMITED",
"DUET INDIA HOTELS (PUNE) PRIVATE LIMITED",
"DUET INDIA HOTELS AHMEDABAD PRIVATE. LIMITED.",
"DUET INDIA HOTELS CHENNAI OMR PRIVATE LIMITED",
"DUET INDIA HOTELS CHENNAI PRIVATE. LIMITED.",
"DUET INDIA HOTELS JAIPUR PRIVATE LIMITED",
"DUET INDIA HOTELS PRIVATE LIMITED",
"DUET SARE OUTSOURCING PRIVATE LIMITED",
"DUFERCO ASIA PTE LIMITED",
"DUFF AND PHELPS INDIA PRIVATE LIMITED",
"DUFLON INDUSTRIES PRIVATE LIMITED",
"DUFLORA AGRI PRODUCTS PRIVATE LIMITED",
"DUFON LABORATORIES PVT LTD",
"DUFRY BUSINESS SERVICES LLP",
"DUGAD AGRO FOODS PRIVATE LIMITED",
"DUGAD HOSPITAL PRIVATE LIMITED",
"DUGANTA OIL AND NATURAL GAS PRIVATE LIMITED",
"DUGAR AUTOMOBILE FINANCE PRIVATE LIMITED",
"DUGAR AUTOMOTIVES PRIVATE LIMITED",
"DUGAR CONSUMER PRODUCTS PRIVATE LIMITED",
"DUGAR DISTRIBUTORS PRIVATE LIMITED",
"DUGAR FINANCE AND INVESTMENTS LIMITED",
"DUGAR HYDRO POWER LIMITED",
"DUGAR INDVENT PRIVATE LIMITED",
"DUGAR INSULATIONS INDIA PRIVATE LIMITED",
"DUGAR MOTOR CO PVT LTD",
"DUGAR OVERSEAS PRIVATE LIMITED",
"DUGAR POLYMERS LIMITED",
"DUGAR POLYTEX PRIVATE LIMITED",
"DUGAR TUBES PRIVATE LIMITED",
"DUGDAM DAIRY FARMS PRIVATE LIMITED",
"DUGGAD ALUMINIUM PRIVATE LIMITED",
"DUGGAL AUTOMOBILES PRIVATE LIMITED",
"DUGGAL LABELS PRIVATE LIMITED",
"DUGGAR FIBER PVT LTD",
"DUGO POWER AND AUTOMATION PRIVATE LIMITED",
"DUGROS LEATHER (INDIA) PRIVATE LIMITED",
"DUINKOP ENTERPRISES PRIVATE LIMITED",
"DUIS MATERIAL HANDLING PRIVATE LIMITED",
"DUISPORT PACKING LOGISTICS INDIA PRIVATE LIMITED",
"DUJANIA POLYCHEM PRIVATE LIMITED",
"DUJODWALA RESINS AND TERPENES LIMITED",
"DUKAAN RESOURCES PRIVATE LIMITED",
"DUKANE INTELLIGENT ASSEMBLY SOLUTIONS INDIA P LIMITED",
"DUKANLINE INDIA PRIVATE LIMITED",
"DUKE FARBRICS INDIA LIMITED",
"DUKE FASHIONS INDIA LIMITED",
"DUKE INDIA SERVICES PRIVATE LIMITED",
"DUKE OFFSHORE LTD",
"DUKE PIPES PRIVATE LIMITED",
"DUKE PLASTO TECHNIQUE PRIVATE LIMITED",
"DUKE TEA PRIVATE LIMITED",
"DUKE THOMSONS INDIA PRIVATE LIMITED",
"DUKE WELLNESS PRIVATE LIMITED",
"DUKENHENGRA TEA PRIVATE LIMITED",
"DUKES AND SHANTHA HOMES PRIVATE LIMITED",
"DUKES ENGINEERS INDIA PRIVATE LIMITED",
"DUKHIRAM MAURYA ENGINEERING & REFRACTORY WORKS (INDIA) PRIVATE LIMITED",
"DUKRAFT PAPER DISTRIBUTOR PRIVATE LIMITED",
"DULAL JUTE MILLS PRIVATE LIMITED",
"DULAL -SIBU HUMAN HAIR PRIVATE LIMITED",
"DULAM INTERNATIONAL (SUBSEA ENGINEERING) PRIVATE LIMITED",
"DULAM ROCKS PRIVATE LIMITED",
"DULARI EXPORTS PRIVATE LIMITED",
"DULARI ISPAT PRIVATE LIMITED",
"DULDULI MATHBARI DN HIGH SCHOOL",
"DULEVO INDIA PRIVATE LIMITED",
"DULI TRADE & COMMODITIES PRIVATE LIMITED",
"DULICHAND MOTORS PRIVATE. LIMITED",
"DULICHAND SILK MILLS PRIVATE LIMITED",
"DULLAR REAL ESTATE PRIVATE LIMITED",
"DULOCOS CONVEYORS AND MOULDS PRIVATE LIMITED",
"DU-LUCK INVESTMENT & LEASING PRIVATE LIMITED",
"DU-LUK POLYMERS PRIVATE LIMITED",
"DULUTH SOFTWARE SERVICES PRIVATE LIMITED",
"DUM DUM SARVODAYA VIDYAPITH",
"DUMADU GAMES PRIVATE LIMITED",
"DUMAS ELECTRICALS PRIVATE LIMITED",
"DUMDUM BAIDYANATH INST",
"DUMDUM KUMAR ASHUTOH INSTITUTION",
"DUMDUM MUNICIPALITY",
"DUMINI AIR TRAVELS PRIVATE LIMITED",
"DUMKA FOOD PRODUCTS PRIVATE LIMITED",
"DUMKA TRANSMISSION LIMITED",
"DUMPY HOLDINGS LIMITED",
"DUMTCO TRANS FREIGHT PRIVATE LIMITED",
"DUN & BRADSTREET INFORMATION SERVICES INDIA PRIVATE LIMITED",
"DUN & BRADSTREET TECHNOLOGIES & DATA SERVICES PRIVATE LIMITED",
"DUN & BRADSTREET TECHNOLOGY AND CORPORATE SERVICES INDIA LLP",
"DUN INDUSTRIAL SERVICES PRIVATE LIMITED",
"DUNA PANELS PRIVATE LIMITED",
"DUNAC AUTOMOBILES PRIVATE LIMITED",
"DUNAC CARS PRIVATE LIMITED",
"DUNAC MOTORS PRIVATE LIMITED (PART IX)",
"DUNAKHE HOSPITAL PRIVATE LIMITED",
"DUNAMIS VISION PRIVATE LIMITED",
"DUNAR FOODS LIMITED",
"DUNCAN ENGINEERING LIMITED",
"DUNCAN HOSPITAL",
"DUNCAN INTERNATIONAL (INDIA) LTD.",
"DUNCANS AGRO CHEMICALS LIMITED",
"DUNCANS TEA LTD",
"DUNDER MIFFLIN INDIA PRIVATE LIMITED",
"DUNDIGAL WASTE 2 ENERGY PRIVATE LIMITED",
"DUNDUBHI INFRA PRIVATE LIMITED",
"DUNEX ARCHITECTURAL PRIVATE LIMITED",
"DUNEXO CERAMIC PRIVATE LIMITED",
"DUNGARMAL JAIN CONSTRUCTION COMPANY PRIVATE LIMITED",
"DUNGARWAL FINPROP PRIVATE LIMITED",
"DUNGDUGI TEA PRIVATE LIMITED",
"DUNGRA CHEMICALS PRIVATE LIMITED",
"DUNKELBRAUN PRIVATE LIMITED",
"DUNKEN KELVIN PRIVATE LIMITED",
"DUNMAG CONTROLS PRIVATE LIMITED",
"DUNN SOLUTIONS INDIA PRIVATE LIMITED",
"DUNNES INSTITUTE",
"DUNNHUMBY IT SERVICES INDIA PRIVATE LIMITED",
"DUNNRITE GROUPAGE SERVICES PRIVATE LIMITED",
"DUNUNG INDUSTRIES PRIVATE LIMITED",
"DUNZO LOGISTICS PRIVATE LIMITED",
"DUNZO MERCHANT SERVICES PRIVATE LIMITED",
"DUOLOGUE INFOTECH PRIVATE LIMITED",
"DUOS BRAIN MANAGEMENT SUPPORT SERVICES PRIVATE LIMITED",
"DUPATTA WORLD PRIVATE LIMITED",
"DUPEN LABORATORIES PRIVATE LIMITED",
"DUPLETS ELECTRONICS PRIVATE LIMITED",
"DUPLEX CABLES PRIVATE LIMITED",
"DUPONT SPECIALTY PRODUCTS INDIA PRIVATE LIMITED",
"DUPRO CONSULTANCY PRIVATE LIMITED",
"DUPRO ENGINEERING PRIVATE LIMITED",
"DUPTY DIRECTOR VET SER HBAD HOSHANGABAD",
"DURA AUTO SYSTEMS INDIA PRIVATE LIMITED",
"DURA BUILD CARE PRIVATE LIMITED",
"DURA CONVEYOR BELTING PRIVATE LIMITED",
"DURA ENTERPRISES UMDUBA PRIVATE LIMITED",
"DURA EXPORTS PRIVATE LIMITED",
"DURA HEATEX INDIA PRIVATE LTD",
"DURA MAGNETS PVT LTD",
"DURA PUF (SILVASSA) PRIVATE LIMITED",
"DURA ROOF PRIVATE LIMITED",
"DURABLE GAS PRIVATE LIMITED",
"DURABLE ISPAT & ALLOYS PRIVATE LIMITED",
"DURABLE MARKETING PRIVATE LIMITED",
"DURABLE PIPES & FITTINGS PRIVATE LIMITED",
"DURABLE PLOYMER PRODUCTS PRIVATE LIMITED",
"DURABLE POLYMERS",
"DURABLE SYSTEMS PRIVATE LIMITED",
"DURABUILD TECHNOLOGIES PRIVATE LIMITED",
"DURACA PLAST CREATION PRIVATE LIMITED",
"DURACELL INDIA OPERATIONS PRIVATE LIMITED",
"DURACON CEMENT PRODUCT PRIVATE LIMITED",
"DURACON VITRIFIED PRIVATE LIMITED",
"DURAENT LIFESCIENCES LLP",
"DURAFLEX SERVICES AND CONSTRUCTION TECHNOLOGIES LIMITED",
"DURAFON TECHNOLOGIES PRIVATE LIMITED",
"DURAG INDIA INSTRUMENTATION PRIVATE LIMITED",
"DURAGUARD COATINGS PRIVATE LIMITED",
"DURAI SHIPPING AND SERVICES PRIVATE LIMITED",
"DURAI SUITINGS PVT LTD",
"DURAKART MARKETING PRIVATE LIMITED",
"DURAL TRIMS AND PROFILES PRIVATE LIMITED",
"DURALABEL GRAPHICS PRIVATE LIMITED",
"DURA-LINE INDIA PRIVATE LIMITED",
"DURAMAX PACKAGING PRIVATE LIMITED",
"DURAMILE PRIVATE LIMITED",
"DURAMIX CONCRETE INDIA PRIVATE LIMITED",
"DURAND FORMS (INDIA) PRIVATE LIMITED",
"DURANDEL PROPERTY DEVELOPERS PRIVATE LIMITED",
"DURANOVA INDUSTRIES PRIVATE LIMITED",
"DURAROCK PRODUCTS PRIVATE LIMITED",
"DURASIGN CORPORATION",
"DURATECH AUTOMATION PRIVATE LIMITED",
"DURATECH CHEMPLAST PRIVATE LIMITED",
"DURATECH FORGE PRIVATE LIMITED",
"DURATECH TEXTILE INDUSTRIES LLP",
"DURATECH TOOLINGS PRIVATE LIMITED",
"DURATEX APPARELS",
"DURATEX LABORATORIES PRIVATE LIMITED",
"DURATEX SILK MILLS LIMITED",
"DURATEX SILK MILLS PRIVATE LIMITED",
"DURATONE FARMING PRIVATE LIMITED",
"DURATUF GLASS INDUSTRIES PRIVATE LIMITED",
"DURATUF PRODUCTS PRIVATE LIMITED",
"DURATUFF POLYPACKS PRIVATE LIMITED",
"DURATUFF YARNS PRIVATE LIMITED",
"DURAVIT INDIA PRIVATE. LIMITED.",
"DURAVOLT ENGINEERING PRIVATE LIMITED",
"DURAWELD METSYS PRIVATE LIMITED",
"DURBAL MANSK TATHA MATIMAND VIDYA NIKETAN",
"DURCHGEPLANT AND PLANWORK PRIVATE LIMITED",
"DURE TECHNOLOGIES PRIVATE LIMITED",
"DURECO EXPORTS PRIVATE LIMITED",
"DURELO TOOLS & EQUIPMENTS PRIVATE LIMITED",
"DUREZA GRANITO PRIVATE LIMITED",
"DURFERRIT ASEA PRIVATE LIMITED",
"DURFI RETAIL PRIVATE LIMITED",
"DURG EDUCATION & CHARITABLE SOCIETY",
"DURG ENGINEERING VENTURES PRIVATE LIMITED",
"DURG SHIVNATH EXPRESSWAYS PRIVATE LIMITED",
"DURGA AGRONOMY PRIVATE LIMITED",
"DURGA AIRCONDITIONING PRIVATE LIMITED",
"DURGA AUTOCARE PRIVATE LIMITED",
"DURGA AUTOMOTIVES PRIVATE LIMITED",
"DURGA BEARINGS COMPANY PRIVATE LIMITED",
"DURGA BEARINGS PRIVATE LIMITED",
"DURGA BHAVANI MOTORS (INDIA) PRIVATE LIMITED",
"DURGA BONDCHEM PRIVATE LIMITED",
"DURGA BUILDWELL PRIVATE LIMITED",
"DURGA CARRIERS PRIVATE LIMITED",
"DURGA CHARITABLE SOCIETY",
"DURGA COLOUR & CHEM PVT LTD",
"DURGA COMMERCIALS PRIVATE LIMITED",
"DURGA COMPLEX PRIVATE LIMITED",
"DURGA CONCAST PRIVATE LIMITED",
"DURGA CONSTRUCTION COMPANY",
"DURGA CONTROL SYSTEMS (INDIA) PRIVATE LIMITED",
"DURGA COTTEX INDIA PRIVATE LIMITED",
"DURGA DEVI MEMORIAL HOSPITAL",
"DURGA ENTERPRISES",
"DURGA ENTERPRISES PRIVATE LIMITED",
"DURGA EXTRACTION PRIVATE LIMITED",
"DURGA FABRICS PRIVATE LIMITED",
"DURGA FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"DURGA FERROUS PVT. LTD.",
"DURGA FILTERS PRIVATE LIMITED",
"DURGA FINANCIAL SERVICES PRIVATE LIMITED",
"DURGA FORGE PRIVATE LIMITED",
"DURGA GLASS AGENCIES PRIVATE LIMITED",
"DURGA HOLOGRAPHICS PRIVATE LIMITED",
"DURGA ISPAT PVT LTD",
"DURGA KRISHNA STORE PRIVATE LIMITED",
"DURGA LAKSHMI MARKETING PRIVATE LIMITED",
"DURGA LAXMI TECHNO SOLUTIONS PRIVATE LIMITED",
"DURGA MACHTECH PRIVATE LIMITED",
"DURGA MARBLE AND MINERALS",
"DURGA MARBLE AND SANITATIONS PRIVATE LIMITED",
"DURGA MECHATRONICS PRIVATE LIMITED",
"DURGA MILL STORE PRIVATE LIMITED",
"DURGA MOVIES PRIVATE LIMITED",
"DURGA MULTIMETALS PRIVATE LIMITED",
"DURGA POLY THERM PRIVATE LIMITED",
"DURGA POLY YARNS PRIVATE LIMITED",
"DURGA POLYCHEM PRIVATE LIMITED",
"DURGA POLYFLEX INDUSTRIES",
"DURGA POLYPLAST PRIVATE LIMITED",
"DURGA POLYSTERS PRIVATE LIMITED",
"DURGA RECLAIM PHYSIO HOME",
"DURGA REMEDIES HOUSE PVT LTD",
"DURGA RE-ROLLING MILLS PRIVATE LIMITED",
"DURGA SANITILES PRIVATE LIMITED",
"DURGA SCIENTIFIC PRIVATE LIMITED",
"DURGA SECURITY SERVICE",
"DURGA SHIRTINGS PRIVATE LIMITED",
"DURGA SIGNAL INFRA PRIVATE LIMITED",
"DURGA SOLAR ENTERPRISE",
"DURGA SPINTEX INDIA PRIVATE LIMITED",
"DURGA STEEL COMPANY PRIVATE LIMITED",
"DURGA TRANSFORMERS PRIVATE LIMITED",
"DURGA VALVES PRIVATE LIMITED",
"DURGA WEBTEL SERVICES PRIVATE LIMITED",
"DURGA WORLD TRAVEL INDIA PRIVATE LIMITED",
"DURGABAI DESHMUKH HOSPITAL & RESEARCH CE",
"DURGABHAVANI HOSPITALS PRIVATE LIMITED",
"DURGADEVI INFRA MEGA PROJECT PRIVATE LIMITED",
"DURGAGREENS INFRATECH PRIVATE LIMITED",
"DURGAJYOTI PULP MOULDING EQUIPMENT PRIVATE LIMITED",
"DURGAMATA FOOD PRODUCTS PRIVATE LIMITED",
"DURGAMBA CONSTRUCTION",
"DURGAMBA INVESTMENT PRIVATE LIMITED",
"DURGAMRUT FARMERS ORGANIC AGRO PRIVATE LIMITED",
"DURGANSH AUTOMOBILES PRIVATE LIMITED",
"DURGAPRASAD VIDYANIKETAN",
"DURGAPUJA TRADES & COMMERCE PRIVATE LIMITED",
"DURGAPUR CASTING & ALLIED PRODUCTS PVT LTD",
"DURGAPUR CHEMICALS LIMITED",
"DURGAPUR CITY HOSPITAL AND CLINIC PRIVATE LIMITED",
"DURGAPUR COKEOVENS PVT LTD",
"DURGAPUR CORPORATION PRIVATE LIMITED",
"DURGAPUR FREIGHT TERMINAL PRIVATE LIMITED",
"DURGAPUR GOVT COLLEGE",
"DURGAPUR INDUSTRIAL GASES PRIVATE LIMITED",
"DURGAPUR INFRA PROJECTS PRIVATE LIMITED",
"DURGAPUR INSTITUTE OF ADVANCED TECHNOLOGY AND MANAGEMENT",
"DURGAPUR INSTITUTE OF SCIENCE TECHNOLOGY AND MANAGEMENT",
"DURGAPUR IRON & STEEL CO PRIVATE LIMITED",
"DURGAPUR MALL MAINTENANCE SERVICES PRIVATE LIMITED",
"DURGAPUR MEDICAL CENTRE PVT LTD",
"DURGAPUR MUNICIPAL CORPORATION",
"DURGAPUR PACKAGING PRIVATE LIMITED",
"DURGAPUR POLYMERS PVT LTD",
"DURGAPUR PROJECT EMPLOYEES MULTIPURPOSE CO-OPERATIVE SOCIETY LTD",
"DURGAPUR PUBLIC SCHOOL",
"DURGAPUR REAL ESTATE PRIVATE LIMITED",
"DURGAPUR RE-BARS PRIVATE LIMITED",
"DURGAPUR TUBES PVT LTD",
"DURGASHAKTI FOODS PRIVATE LIMITED",
"DURGASHAKTI INFRA PROJECTS PRIVATE LIMITED",
"DURGAWATI GLOBAL PROJECTS PRIVATE LIMITED",
"DURGE LAXMI METAL CRAFT PRIVATE LIMITED",
"DURGESH COMMERCIAL AND MARKETING P LTD.",
"DURGESH IMPEX PRIVATE LIMITED",
"DURGESH MOTORS PRIVATE LIMITED",
"DURGESH SOUND & LIGHTING SYSTEMS PRIVATE LIMITED",
"DURGESH VANIJYA PVT LTD",
"DURGESHWARI FOODS LIMITED",
"DURGESHWARI GARMENTS PRIVATE LIMITED",
"DURGESHWARI MARKETING AND AGENCIES PRIVATE LIMITED",
"DURGESHWARI RUBPLAST PRIVATE LIMITED",
"DURGOTTAM INDUSTRIES PRIVATE LIMITED",
"DURHA INFRACON PRIVATE LIMITED",
"DURIAN INDUSTRIES LIMITED",
"DURJA AGROTECH PRIVATE LIMITED",
"DURJAYA ESTATES PRIVATE LIMITED",
"DURLABH TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"DURLABHSONS EXPORTS PRIVATE LIMITED",
"DURLAX ARCHTECH PRIVATE LIMITED",
"DURLAX TOP SURFACE LIMITED",
"DURLEY SANIWARE",
"DURLUM INDIA PRIVATE LIMITED",
"DURO FORGE PVT LTD",
"DURO MATTRESSES PRIVATE LIMITED",
"DURO PACK LIMITED",
"DURO PIPE INDUSTRIES PRIVATE LIMITED",
"DURO PIPES PVT LTD",
"DUROBAGS PRIVATE LIMITED",
"DUROCAP ROOFING INDIA PRIVATE LIMITED",
"DUROCOAT PAINTS PVT LTD",
"DUROCRETE ENGINEERING SERVICES PRIVATE LIMITED",
"DURODECOR INDIA PRIVATE LIMITED",
"DURODESIGNS HOME DECORS PRIVATE LIMITED",
"DUROFIT TECHNOLOGIES PRIVATE LIMITED",
"DUROFLEX COMMODITIES PVT.LTD.",
"DUROFLEX PRIVATE LIMITED",
"DUROGREEN WASTE MANAGEMENT PRIVATE LIMITED",
"DURON IND-TECH PRIVATE LIMITED",
"DURONTO TECHNOLOGIES PRIVATE LIMITED",
"DUROPLAS (INDIA) PVT LTD",
"DUROPLAST EXTRUSION PVT LTD",
"DUROPLAST FURNITURE SYSTEMS PRIVATE LIMITED",
"DUROPLAST INDIA PRIVATE LIMITED",
"DUROPLY INDUSTRIES LIMITED",
"DUROSHOX PRIVATE LIMITED",
"DUROVALVES INDIA PRIVATE LIMITED",
"DURR INDIA PRIVATE LIMITED",
"DURRUNG TEA ESTATE LIMITED",
"DURST IMAGE TECHNOLOGY INDIA PRIVATE LIMITED",
"DURU COOPERATION PRIVATE LIMITED",
"DURUS CONSULTING PRIVATE LIMITED",
"DURUVA FINANCE PRIVATE LIMITED",
"DURVA ENGINEERING PRIVATE LIMITED",
"DURVA INFRATECH LLP",
"DURVAH IT CONSULTING PRIVATE LIMITED",
"DURVANKUR AUTOCOMPS PRIVATE LIMITED",
"DURVISH INFRA PRIVATE LIMITED",
"DUSAD AGROFOOD PRIVATE LIMITED",
"DUSAD ELECTRICALS",
"DUSAD TRANSFORMERS AND SWITCHGEARS PVT LTD",
"DUSANE INFOTECH INDIA PRIVATE LIMITED",
"DUSHAD CONSTRUCTIONS PRIVATE LIMITED",
"DUSK PROPERTIES PRIVATE LIMITED",
"DUSKAR NATURA PRODUCTS PRIVATE LIMITED",
"DUSKING DEVELOPERS PRIVATE LIMITED",
"DUSKLINE INFRASTRUCTURES PRIVATE LIMITED",
"DUSMER TOOLS PVT LTD",
"DUST BLOWERS FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"DUSTECH DUCT COMPANY PRIVATE LIMITED",
"DUSTECH ENGINEERS PRIVATE LIMITED",
"DUSTER METAL PRODUCTS PRIVATE LIMITED",
"DUSTERS TOTAL SOLUTIONS SERVICES PRIVATE LIMITED",
"DUSTMAN WASTE MANAGEMENT & RECYCLING PRIVATE LIMITED",
"DUTCH PLANTIN COIR INDIA PRIVATE LIMITED,",
"DUTCH TECH TOOLS PRIVATE LIMITED",
"DUTCH VIBRATIONS SOLUTIONS PRIVATE LIMITED",
"DUTRON PLASTICS LIMITED",
"DUTRON PLASTICS PRIVATE LIMITED",
"DUTRON POLYMERS LIMITED",
"DUTSUN ENGINEERING PRIVATE LIMITED",
"DUTTA AGRO PRODUCTS PRIVATE LIMITED",
"DUTTA AUTOMOBILES PRIVATE LIMITED",
"DUTTA BUILDCON PRIVATE LIMITED",
"DUTTA BUILDERS & DEVELOPERS PRIVATE LIMITED",
"DUTTA DAW & CO PVT LTD",
"DUTTA GUINEA MUSEUM PVT LTD",
"DUTTA HERITAGE PRIVATE LIMITED",
"DUTTA LAYER FARM PRIVATE LIMITED",
"DUTTA PRESS PRIVATE LIMITED",
"DUTTA STUDIO COMPANY PRIVATE LIMITED",
"DUTTA TRADING COMPANY PRIVATE LIMITED",
"DUTTCON CONSULTANT & ENGINEERS PRIVATE LIMITED",
"DUTYFREE DISTRIBUTION SERVICES PRIVATE LIMITED",
"DUVA LOGISTICS PRIVATE LIMITED",
"DUVAL ENTERPRISES PRIVATE LIMITED",
"DUVILLE ESTATES PRIVATE LIMITED",
"DUX LINES PRIVATE LIMITED",
"DUXAS GREEN LAND PRIVATE LIMITED",
"DUZONE ADHESIVES INDIA PRIVATE LIMITED",
"DUZTEC ENGINEERING PRIVATE LIMITED",
"DV ANALYTICS PRIVATE LIMITED",
"DV AUTOMOTIVE PRIVATE LIMITED",
"DV CHEM SOLUTIONS PRIVATE LIMITED",
"DV MATRICULATION HIGHER SECONDARY SCHOOL",
"DVA ENGINEERING AND TESTING PRIVATE LIMITED",
"DVA INDIA CHEMICALS PRIVATE LIMITED",
"DVARA E-REGISTRY PRIVATE LIMITED",
"DVARA HOLDINGS",
"DVARA KSHETRIYA GRAMIN FINANCIAL SERVICES PRIVATE LIMITED",
"DVARA RESEARCH FOUNDATION",
"DVARA SMARTGOLD PRIVATE LIMITED",
"DVARA SOLUTIONS PRIVATE LIMITED",
"DVARO MERCHANTILE PRIVATE LIMITED",
"DVB TECHNOLOGIES PRIVATE LIMITED",
"DVDT INTER COLLEGE UNNAO",
"DVG ENGINEERS PRIVATE LIMITED",
"DVG TECH SOLUTIONS PRIVATE LIMITED",
"DVIJ INFOTECH LLP",
"DVIO DIGITAL PRIVATE LIMITED",
"DVK HANDICRAFTS",
"DVKSP IMPEX PRIVATE LIMITED",
"DVL LOGISTICS PRIVATE LIMITED",
"DVM DEGREE PG COLLEGES",
"DVN ENERGY SOLUTIONS PRIVATE LIMITED",
"D-VOIS KARNATAKA PRIVATE LIMITED",
"DVP INFRA PROJECTS PRIVATE LIMITED",
"DVR & DR HS MIC COLLEGE OF TECHNOLOGY",
"DVR BUILDCON PRIVATE LIMITED",
"DVR PHARMA LLP",
"DVR PUBLICATION PRIVATE LIMITED",
"DVR SOFTEK INDIA PRIVATE LIMITED",
"DVS INDIA PRIVATE LIMITED",
"DVS RESEARCH AND CAPITAL SERVICES PRIVATE LIMITED",
"DVSA ARKA EDUCATIONAL INITITUTIONS",
"DVSR ASSOCIATES PRIVATE LIMITED",
"DVSUM INDIA PRIVATE LIMITED",
"DVTEL INDIA PRIVATE LIMITED",
"DVW PRIVATE LIMITED",
"DW AND CDO DEWAS MADHYA PRADESH",
"DW PRACTICE INDIA PRIVATE LIMITED",
"DWA MEDIA PRIVATE LIMITED",
"DWAITH INFOTECH PRIVATE LIMITED",
"DWAITHA INFRACON PRIVATE LIMITED",
"DWALAX ENTERPRISES PRIVATE LIMITED",
"DWARAKA DOSS GOVERDHAN DOSS VAISHNAV COLLEGE",
"DWARAKA HONDA PRIVATE LIMITED",
"DWARAKA INFRASTRUCTURE PRIVATE LIMITED",
"DWARAKA IRON INDUSTRIES PRIVATE LIMITED",
"DWARAKA ISPAT PRIVATE LIMITED",
"DWARAKAMAI BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"DWARAKAMAI CONSTRUCTIONS PRIVATE LIMITED",
"DWARAVATI CREATION AND CONSULTANCY PRIVATE LIMITED",
"DWARIKA AGRO COLD STORAGE PRIVATE LIMITED",
"DWARIKA FOOD PRODUCTS",
"DWARIKA INDUSTRIES LIMITED",
"DWARIKA INFOCOM PRIVATE LIMITED",
"DWARIKA JEWELLERS PRIVATE LIMITED",
"DWARIKA LEELA & SONS PRIVATE LIMITED",
"DWARIKA RETAIL PRIVATE LIMITED",
"DWARIKA RICE MILL LIMITED",
"DWARIKA ROLLER FLOUR MILL PRIVATE LIMITED",
"DWARIKA TECHNOLOGIES PRIVATE LIMITED",
"DWARIKESH INFRATECH PRIVATE LIMITED",
"DWARIKESH SUGAR INDUSTRIES LIMITED",
"DWARIKESH TRADING COMPANY LIMITED",
"DWARKA ART INDIA PRIVATE LIMITED",
"DWARKA CASTINGS AND ENGG PRIVATE LIMITED",
"DWARKA DASS KHOSLA AGENCIES PRIVATE LIMITED",
"DWARKA GEMS LIMITED",
"DWARKA INFRAVENTURES PRIVATE LIMITED",
"DWARKA JEWEL",
"DWARKA KNITTING PRIVATE LIMITED",
"DWARKA LIFESTYLE RESORTS PRIVATE LIMITED",
"DWARKA MALL MANAGEMENT SERVICES PRIVATE LIMITED",
"DWARKA NANDAN DISTRIBUTORS PRIVATE LIMITED",
"DWARKA POWER TRANSMISSION PRIVATE LIMITED",
"DWARKA PRASAD HEALTH CARES RESEARCH PRIVATE LIMITED",
"DWARKA SCHOOL OF EXCELLENCE SECTOR-22",
"DWARKA STEEL INDUSTRIES PVT LTD",
"DWARKA TRADERS PRIVATE LIMITED",
"DWARKADAS J SANGHVI COLLEGE OF ENGINEERING",
"DWARKADAS JHAMANDAS TEXTILE INDUSTRIES PRIVATE LIMITED",
"DWARKADAS MANGALCHAND PRIVATE LIMITED",
"DWARKADAS SHAMKUMAR TEXTILES PVT LTD",
"DWARKADAS TRADING COMPANY PRIVATE LIMITED",
"DWARKADASS CHEMICAL COMPANY PRIVATE LIMITED",
"DWARKADHIS BUILDWELL PRIVATE LIMITED",
"DWARKADHIS PROJECTS PRIVATE. LIMITED.",
"DWARKADHISH COTSPIN PRIVATE LIMITED",
"DWARKADHISH SAKHAR KARKHANA LIMITED",
"DWARKADHISH SECURITY PRIVATE LIMITED",
"DWARKAI SWAYAMROJGAR SEVA SAHAKARI SANSTHA YAVATMAL",
"DWARKAMAI FACILITY SERVICES PRIVATE LIMITED",
"DWARKAMAI RE-ROLLING MILL PRIVATE LIMITED",
"DWARKAMAI SAI PRASAD INFRACON PRIVATE LIMITED",
"DWARKAPATI SPINNING PRIVATE LIMITED",
"DWARKESH ALLOYS PRIVATE LIMITED",
"DWARKESH CHEMICALS PVT LTD",
"DWARKESH ENGINEERING WORKS PVT LTD",
"DWARKESH FINANCE LIMITED",
"DWARKESH FUEL PRIVATE LIMITED",
"DWARKESH HINDI HIGHER SECONDERY SCH",
"DWARKESH PHARMACEUTICAL PVT LTD",
"DWARKESH TRADES PRIVATE LIMITED",
"DWARKESH TRANSPORT SOLUTIONS PRIVATE LIMITED",
"D-WAT GLOBAL PRIVATE LIMITED",
"DWD PHARMACEUTICALS LIMITED",
"DWELLFOX PRIVATE LIMITED",
"DWELLINGS STAR DEVELOPERS PRIVATE LIMITED",
"DWI ARTHA TECHNOLOGY PRIVATE LIMITED",
"DWIBHASHI BAPANNA AYURVEDA NILAYAM PRIVATE LIMITED",
"DWIBROS INFRACON PRIVATE LIMITED",
"DWIJ INDUSTRIES PRIVATE LIMITED",
"DWIJA FOODS PRIVATE LIMITED",
"DWINDO INDIA PRIVATE LIMITED",
"DWIP AGENCIES LIMITED",
"DWISE HEALTHCARE ITSOLUTIONS PRIVATE LIMITED",
"DWISE SOLUTIONS AND SERVICES PRIVATE LIMITED",
"DWISONS PRIVATE LIMITED",
"DWIVEDI ASSOCIATES PRIVATE LIMITED",
"DWIVEDI MEDICAL AND RESEARCH CENTRE PRIVATE LIMITED",
"DWJA COSMETICS PRIVATE LIMITED",
"DWP INTERICS PRIVATE LIMITED",
"DXC TECHNOLOGY INDIA PRIVATE LIMITED",
"DXCORR HARDWARETECHNOLOGIES PRIVATE LIMITED",
"DXD WATCHCAM TECH SOLUTIONS PRIVATE LIMITED",
"DXFACTOR SOLUTIONS PRIVATE LIMITED",
"DXL ELECTRONIC MATERIALS INDIA PRIVATE LIMITED",
"DXN MANUFACTURING (INDIA) PRIVATE LIMITED",
"DXN MARKETING INDIA PRIVATE LIMITED",
"DXSHERPA TECHNOLOGIES PRIVATE LIMITED",
"DY ASST DIRECTOR GENERAL GOVT MEDICAL STORE DEPOT HYDERABAD",
"DY AUTO INDIA PRIVATE LIMITED",
"DY COLLECTOR (EGS) JALGAON",
"DY COLLECTOR ENC REM BORIVALI",
"DY COMM ADMN COMMERCIAL TAX MZN",
"DY COMM OF I T CHANDRAPUR",
"DY COMMISSIONER COMMERCIAL TAX DIV 1 INDORE",
"DY COMMISSIONER LAND RECORDS",
"DY COMMISSIONER OF COMMERCIAL TAX UJJAIN",
"DY CONSER OF FOREST S UDR 5425",
"DY CONSERVATOR OF FOREST ADMN O/O PCCF MP BHOPAL",
"DY CONSERVATOR OF FOREST SURAT",
"DY DIR AGRICULTURE BHOPAL MADHYA PRADESH",
"DY DIR ARCHAEOLOGY AND MUSEUM EASTERN REGION JABALPUR",
"DY DIR CGHS AHMEDABAD",
"DY DIR HYDROMETEROLOGY D D 2 WATER RES DEPT HOSHANGABAD",
"DY DIR OF V S SATNA",
"DY DIR VETERNARY SERVICES SEHORE",
"DY DIRECOTOR OBC CWA",
"DY DIRECTOR AGRICULTURE EXTENSION UNNAO",
"DY DIRECTOR AGRICULTURE RAISEN MADHYA PRADESH",
"DY DIRECTOR AYURVED DEPTT DISTRICT UDAIPUR",
"DY DIRECTOR CENSUS OPERATION",
"DY DIRECTOR CENSUS OPERATION MP CIVIL LINES BHOPAL",
"DY DIRECTOR DIRECTORATE OF ECONOMICS AND STATISTICS BPL BHOPAL",
"DY DIRECTOR GENERAL VTS DIRECTORATE GANDHIDHAM KACHCHH",
"DY DIRECTOR HORTICULTURE",
"DY DIRECTOR INFORMATION",
"DY DIRECTOR NATIONAL FOREST HOSHANGABAD",
"DY DIRECTOR OF FISHRIES HQ DIRCT OF FISHRIES BPL",
"DY DIRECTOR OF TOWN PLANNING AMRAVATI",
"DY DIRECTOR OF VETY SERVICES C W A",
"DY DIRECTOR PANCHAYAT SOCIAL SATNA WELFARE MADHYA PRADESH",
"DY DIRECTOR PANCHYAT AND SOCIAL JUSTICE",
"DY DIRECTOR SOIL MATERIAL TESTING DN WRD BPL MADHYA PRADESH",
"DY DIRECTOR VATERINARY SERVICES UJJAIN",
"DY DIRECTOR VETERNARY SERVICES",
"DY DIRECTOR VETERNARY SERVICES (DISEASE INVEST) BHOPAL MADHYA PRADESH",
"DY DIRECTOR VETERNARY SERVICES INDORE",
"DY DIST ELECTION OFFICE BEED",
"DY PATIL ARTS COMMERCE AND SCIENCE JUNIOR COLLEGE",
"DY PATIL HOMEOPATHIC MEDICAL COLLEGE",
"DY PATIL INTERNATIONAL SCHOOL",
"DY PATIL INTERNATIONAL UNIVERSITY",
"DY PATIL UNIVERSITY",
"DY PATIL UNIVERSITY SCHOOL OF DENTISTRY",
"DY PATIL UNIVERSITY SCHOOL OF HOSPITALITY AND TOURISM STUDIES",
"DY PATIL VIDYA PRATISHTHAN SOCIETY",
"DY PATIL WOMENS MEDICAL COLLEGE",
"DY POWER INDIA PRIVATE LIMITED",
"DY REGIONAL TRANSPORT OFFICE AHMEDNAGAR",
"DY REGISTRAR CO OP SOCEITIES CWA",
"DY REGISTRAR COOP KHARGONE",
"DY SUPERINTENDENT OF LAND RECORDS KAVATHEMAHANKAL",
"DY TECHNICAL ADVISOR FOOD AND NUTIRITION BOARD WR",
"DY. DIRECTOR VETERINARY SERVICES",
"DY.COMMISSIONER OF INCOME TEX CENTRAL CIRCILE VARANASI",
"DYAN ENTERPRISES PRIVATE LIMITED",
"DYANACOM TANKERS MANAGEMENT LIMITED",
"DYANAMIC ENGINEERS LIMITED",
"DYANAMIC OPTIMA SERVICES PRIVATE LIMITED",
"DYANODAY MARATHI PRATHMIK SHALA AMRAVATI",
"DYANPRAKASH VIDYALAYA",
"DYCHEM ENTERPRISES",
"DYCINE PHARMACEUTICALS LIMITED",
"DYCON SYSTEMS PRIVATE LIMITED",
"DYCRON COLOUR CHEM PRIVATE LIMITED",
"DYECHEM INTERNATIONAL PRIVATE LIMITED",
"DYECHEM PROCESS PRIVATE LIMITED",
"DYECON INFRA CORPORATION PRIVATE LIMITED",
"DYFO AUTOMATION PRIVATE LIMITED",
"DYGICOM VISUAL TECHNOLOGY PRIVATE LIMITED",
"DYJ IRON & STEEL PRIVATE LIMITED",
"DYKN INTERNATIONAL PRIVATE LIMITED",
"DYLOG SUPPLIES PRIVATE LIMITED",
"DYMENSIONS COMPUTER TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"DYNA AGRO PRIVATE LIMITED",
"DYNA AIRCON PRIVATE LIMITED",
"DYNA AUTOMATION PRIVATE LIMITED",
"DYNA FILTERS PRIVATE LIMITED",
"DYNA FORCE HYDRAULICS PRIVATE LIMITED",
"DYNA GLYCOLS PRIVATE LIMITED",
"DYNA HITECH POWER SYSTEMS LIMITED",
"DYN K AUTOMOTIVE STAMPINGS PRIVATE LIMITED",
"DYNA ROOF PRIVATE LIMITED",
"DYNA TEMP HVAC SYSTEMS PRIVATE LIMITED",
"DYNABRADE INDIA ABRASIVE POWER TOOLS PRIVATE LIMIED",
"DYNACOM TANKERS MANAGEMENT PRIVATE LIMITED",
"DYNACOMMERCE INDIA PRIVATE LIMITED",
"DYNACON PROJECTS PRIVATE LIMITED",
"DYNACONS SYSTEMS AND SOLUTIONS LIMITED",
"DYNACORP ENGINEERING PRIVATE LIMITED",
"DYNACUT SUPERABRASIVE TOOLS PRIVATE LIMITED",
"DYNAFLEX PRIVATE LIMITED",
"DYNAFUSION TECHNOLOGIES PRIVATE LIMITED",
"DYNALAB WEATHERTECH PRIVATE LIMITED",
"DYNALEC CONTROLS PRIVATE LIMITED",
"DYNALOG INDIA LIMITED",
"DYNAM PRECISION PRESSINGS PRIVATE LIMITED",
"DYNAMATIC MANUFACTURING LIMITED",
"DYNAMATIC TECHNOLOGIES LIMITED",
"DYNAMATIX ANALYTICS PRIVATE LIMITED",
"DYNAMECH ELECTROPOWER PRIVATE LIMITED",
"DYNAMED HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"DYNAMESH MEDICAL INDIA PRIVATE LIMITED",
"DYNAMIC AIR AND SEA CARGO PRIVATE LIMITED",
"DYNAMIC AIR ENGINEERING INDIA PRIVATE LIMITED",
"DYNAMIC AIR SYSTEMS PRIVATE LIMITED",
"DYNAMIC ARCHISTRUCTURES LTD",
"DYNAMIC AURA LLP",
"DYNAMIC BENEFICIAL ACCORD MARKETING PRIVATE LIMITED",
"DYNAMIC BIZ SOFTWARE SOLUTIONS PRIVATE LIMITED",
"DYNAMIC BRANDS PRIVATE LIMITED",
"DYNAMIC BUILDING CONCEPTS PRIVATE LIMITED",
"DYNAMIC BUILDTECH LIMITED",
"DYNAMIC BUILDWELL PRIVATE LIMITED",
"DYNAMIC C.S. BOTTLING PRIVATE LIMITED",
"DYNAMIC CABLES LIMITED",
"DYNAMIC CAFE PRIVATE LIMITED",
"DYNAMIC CFO SERVICES PRIVATE LIMITED",
"DYNAMIC CLOTHING PRIVATE LIMITED",
"DYNAMIC COMPONENTS PRIVATE LIMITED",
"DYNAMIC COMPUTER MARKETING ENTERPRISES PRIVATE LIMITED",
"DYNAMIC CONGLOMERATE PRIVATE LIMITED",
"DYNAMIC CRANE ENGINEERS PRIVATE LIMITED",
"DYNAMIC DIAMOND PRIVATE LIMITED",
"DYNAMIC DIGITAL TECHNOLOGY PVT LTD",
"DYNAMIC DREAMZ",
"DYNAMIC DRILLING & SERVICES PRIVATE LIMITED",
"DYNAMIC DRILLING AND SERVICES PRIVATE LIMITED",
"DYNAMIC ELECPOWER PVT. LTD.",
"DYNAMIC ELECTRICALS AND SWITCHGEAR PRIVATE LIMITED",
"DYNAMIC ELEVATOR PRIVATE LIMITED",
"DYNAMIC ENGINEERS PRIVATE. LIMITED",
"DYNAMIC ENTERPRISES PRIVATE LIMITED",
"DYNAMIC ENTREPRENEUR",
"DYNAMIC EQUIPMENTS PVT LTD",
"DYNAMIC EQUITIES PRIVATE LIMITED",
"DYNAMIC E-WASTE SOLUTIONS PRIVATE LIMITED",
"DYNAMIC EXPORTS",
"DYNAMIC FANS MARKETING PRIVATE LIMITED",
"DYNAMIC FASHIONS PRIVATE LIMITED",
"DYNAMIC FINE PAPER MILL PRIVATE LIMITED",
"DYNAMIC FLOW PRODUCTS PRIVATE LIMITED",
"DYNAMIC FORGE & FITTINGS (I) PRIVATE LIMITED",
"DYNAMIC GAUGES PRIVATE LIMITED",
"DYNAMIC GLOBAL TRADING CORPORATION PRIVATE LIMITED",
"DYNAMIC HEALTHSTAFF PRIVATE LIMITED",
"DYNAMIC HR SOLUTIONS PRIVATE LIMITED",
"DYNAMIC INDIA INFONET PRIVATE LIMITED",
"DYNAMIC INDUSTRIAL FORGINGS PRIVATE LIMITED",
"DYNAMIC INDUSTRIES LIMITED",
"DYNAMIC INFRACON PRIVATE LIMITED",
"DYNAMIC INFRASTRUCTURE PVT LTD",
"DYNAMIC INNOVATIONS PRIVATE LIMITED",
"DYNAMIC IT SOLUTION PRIVATE LIMITED",
"DYNAMIC JOBS PRIVATE LIMITED",
"DYNAMIC KARUNA ENGINEERING PRIVATE LIMITED",
"DYNAMIC LABORATORIES PVT LTD",
"DYNAMIC LIFECARE PRIVATE LIMITED",
"DYNAMIC LINER AND CONTAINER SERVICES PRIVATE LIMITED",
"DYNAMIC MARKING SYSTEMS PRIVATE LIMITED",
"DYNAMIC MEDI WAVES PRIVATE LIMITED",
"DYNAMIC MEMORY PRIVATE LIMITED",
"DYNAMIC MERCANTILE PRIVATE LIMITED",
"DYNAMIC MICROLINK PRIVATE LIMITED",
"DYNAMIC MONO CARTONS PRIVATE LIMITED",
"DYNAMIC MOTORS INDIA PRIVATE LIMITED",
"DYNAMIC MOTORS PRIVATE LIMITED",
"DYNAMIC NETSOFT TECHNOLOGIES PRIVATE LIMITED",
"DYNAMIC PAPER PRODUCTS PVT. LTD.",
"DYNAMIC PLACEMENTS AND INTERIORS",
"DYNAMIC POLYCOATS PRIVATE LIMITED",
"DYNAMIC POLYPET PRIVATE LIMITED",
"DYNAMIC PORTFOLIO MANAGEMENT & SERVICES LTD",
"DYNAMIC POWER PROJECTS PRIVATE LIMITED",
"DYNAMIC POWERTECH PRIVATE LIMITED",
"DYNAMIC PRECISE ENGINEERS PRIVATE LIMITED",
"DYNAMIC PRESTRESS INDIA PVT LTD",
"DYNAMIC PRESTRESS PROJECTS AND SERVICES PRIVATE LIMITED",
"DYNAMIC PRODUCTS INDIA PRIVATE LIMITED",
"DYNAMIC PROPERTIES PVT LTD",
"DYNAMIC PUMP AND PROJECT INDIA PRIVATE LIMITED",
"DYNAMIC REALINFRA PRIVATE LIMITED",
"DYNAMIC REMEDIES PVT LTD",
"DYNAMIC RUBBERS PVT. LTD.",
"DYNAMIC SERVICES & SECURITY LIMITED",
"DYNAMIC SERVICES INDIA PRIVATE LIMITED",
"DYNAMIC SHIP RECYCLERS PRIVATE LIMITED",
"DYNAMIC SOFTLINK PRIVATE LIMITED",
"DYNAMIC SPARE AND SERVICES PRIVATE LIMITED",
"DYNAMIC SS ENGINEERING COMPANY PRIVATE LIMITED",
"DYNAMIC STAFFING SERVICES PRIVATE LIMITED",
"DYNAMIC SUPERWAYS AND EXPORTS LIMITED",
"DYNAMIC SYNERGIES PRIVATE LIMITED",
"DYNAMIC TEAM SECURITY SERVICES PRIVATE LIMITED",
"DYNAMIC TECHNO MEDICALS PRIVATE LIMITED",
"DYNAMIC TOOLS PRIVATE LIMITED",
"DYNAMIC TOURS PRIVATE LIMITED",
"DYNAMIC TRADE SOLUTIONS PRIVATE LIMITED",
"DYNAMIC TRANSMISSION LIMITED",
"DYNAMIC TRANS-SYSTEM PRIVATE LIMITED",
"DYNAMIC VALVES PRIVATE LIMITED",
"DYNAMIC WEAVING PRIVATE LIMITED",
"DYNAMICENGINEERS INFRATRACK PRIVATE LIMITED",
"DYNAMICNEXT TECHNOLOGIES PRIVATE LIMITED",
"DYNAMICRO LABS PRIVATE LIMITED",
"DYNAMIK ENGINEERS PRIVATE LIMITED",
"DYNAMIKO RECRUITMENTS PRIVATE LIMITED",
"DYNAMISCH IT PRIVATE LIMITED",
"DYNAMIST ENGG PRIVATE LIMITED",
"DYNAMITE VENTURES PRIVATE LIMITED",
"DYNAMIX CONTRACTORS & BUILDERS PRIVATE LIMITED",
"DYNAMIX LABS PRIVATE LIMITED",
"DYNAMOVA SOLUTIONS PRIVATE LIMITED",
"DYNANET ONLINE SUPPORT PRIVATE LIMITED",
"DYNAPAC ROAD CONSTRUCTION EQUIPMENT INDIA PRIVATE LIMITED",
"DYNAPAK PACKAGING & SECURING SOLUTIONS PRIVATE LIMITED",
"DYNAPIX DIGITAL MEDIA PRIVATE LIMITED",
"DYNAPRO MOTION CONTROLS PRIVATE. LIMITED",
"DYNARC SYSTEMS PRIVATE LIMITED",
"DYNARX TECHNOLOGY (INDIA) LIMITED",
"DYNASPEDE INTEGRATED SYSTEMS PRIVATE LIMITED",
"DYNASTY ELECTRONICS PRIVATE LIMITED",
"DYNASTY MACHINERIES INDIA PRIVATE LIMITED",
"DYNASTY MODULAR FURNITURES PRIVATE LIMITED",
"DYNASTY OIL & GAS PRIVATE LIMITED",
"DYNASTY PLASTICS PRIVATE LIMITED",
"DYNASTY PROMOTERS PRIVATE LIMITED",
"DYNASTY TRADERS PRIVATE. LIMITED.",
"DYNASTYZ PRINTINGS AND FABRICATIONS PRIVATE LIMITED",
"DYNATECH CONTROLS PRIVATE LIMITED",
"DYNATECH INDUSTRIES PRIVATE LIMITEDCIN",
"DYNATECH SYSTEMS PRIVATE LIMITED",
"DYNATEK HEAVY EQUIPMENT PRIVATE LIMITED",
"DYNA-TEX ENTERPRISE PRIVATE LIMITED",
"DYNATRACE INDIA SOFTWARE OPERATIONS PRIVATE LIMITED",
"DYNATRACK TECHNOLOGIES INDIA PRIVATE LIMITED",
"DYNATREND ENGG PRIVATE LIMITED",
"DYNATRON PRIVATE LIMITED",
"DYNATRON SERVICES PRIVATE LIMITED",
"DYNATRONIX INDIA PRIVATE LIMITED",
"DYNAVAC INDIA PRIVATE LIMITED",
"DYNAVISION DIGITECH PRIVATE LIMITED",
"DYNAVISION LIMITED",
"DYNAVISION TECHNOLOGIES PRIVATE LIMITED",
"DYNAWELD ENGINEERING COMPANY PRIVATE LIMITED",
"DYNAX APPARELS PRIVATE LIMITED",
"DYNAXCEL ENGINEERS PRIVATE LIMITED",
"DYNE INFOTECH PRIVATE LIMITED",
"DYNE MARKETING MEDIA SOLUTIONS PRIVATE LIMITED",
"DYNEMECH SYSTEMS PRIVATE LIMITED",
"DYNEMIC PRODUCTS LIMITED",
"DYNEPRO PRIVATE LIMITED",
"DYNERGIC TRANSPORT PRIVATE LIMITED",
"DYNETIC PRODUCTS PRIVATE LIMITED",
"DYNEX SOLAR PRIVATE LIMITED",
"DYNINNO INDIA LLP",
"DYNO ENGINEERING PRIVATE LIMITED",
"DYNOMERK CONTROLS",
"DYNOX ELECTRONICS INDIA PRIVATE LIMITED",
"DYNPRO INDIA PRIVATE LIMITED",
"DYNZ COOLING INDUSTRIES PRIVATE LIMITED",
"DYOK SYSTEMS PRIVATE LIMITED",
"DYORE GROUP",
"DYP HOSPITALITY PRIVATE LIMITED",
"DYROCON AIRTECH PRIVATE LIMITED",
"DYS IMPEX PRIVATE LIMITED",
"DYS ROYALS PRIVATE LIMITED",
"DYSON TECHNOLOGY INDIA PRIVATE LIMITED",
"DYSTAR INDIA PRIVATE LIMITED",
"DYTE TECHNOLOGIES PRIVATE LIMITED",
"DYTRON MARKETING SERVICES PVT LTD",
"DYULOK TECHNOLOGIES PRIVATE LIMITED",
"DYUMANI CONSTRUCTIONS AND GRANITES PRIVATE LIMITED",
"DYUTHI AUTOMOBILES PRIVATE LIMITED",
"DYUTI ENTERPRISE PRIVATE LIMITED",
"DYUTI TECHNOLOGIES",
"DYWIDAG BRIDGECON INDIA PRIVATE LIMITED",
"DYZEN GREENTECH PRIVATE LIMITED",
"DZ CARD (INDIA) PRIVATE LIMITED",
"DZ CARD INDIA PRIVATE LIMITED",
"DZENNO & DECOR INDIA PRIVATE LIMITED",
"DZINE HUB CREATIONS PRIVATE LIMITED",
"DZINEHOMZ BUILDTECH PRIVATE LIMITED",
"DZIRE CORPORATE SERVICES PRIVATE LIMITED",
"DZIRE SURGICAL INDIA PRIVATE LIMITED",
"DZONGRI TRADERS PRIVATE LIMITED",
"DZS SOLUTIONS INDIA PRIVATE LIMITED",
"E - R3 SOLUTIONS PRIVATE LIMITED",
"E - RAD IMAGING & REPORTING SERVICES (INDIA) PRIVATE LIMITED",
"E - SOFT OUTSOURCING AND SOLUTIONS PRIVATE LIMITED",
"E - SQUARE HOMES PRIVATE LIMITED",
"E & E CO LTD",
"E & H PRECISION INDIA PRIVATE LIMITED",
"E & M ELECTRICAL SOLUTIONS PRIVATE LIMITED",
"E & S FOOD TECHNOLOGIES PRIVATE LIMITED",
"E 2 E SOLUTIONS PRIVATE LIMITED",
"E A CURRIM PRIVATE LIMITED",
"E- AGRO CARE MACHINERIES AND EQUIPMENTS PRIVATE LIMITED",
"E AND M CONSULTANTS PRIVATE LIMITED",
"E AND N F RAILWAY JUNIOR COOPERATIVE CREDIT SOCIETY LTD",
"E B C PUBLISHING PRIVATE LIMITED",
"E B MADHAVI SENIOR COLLEGE",
"E BASE INTERACTIVE INC.",
"E C 7 ENTERPRISES PRIVATE LIMITED",
"E C BLADES AND TOOLS PRIVATE LIMITED",
"E C PACKTECH MACHINES PRIVATE LIMITED",
"E C R BUILDTECH PRIVATE LIMITED",
"E C TRANSPORT LTD",
"E CARE INDIA PRIVATE LIMITED",
"E CHUANG MOBILE SOLUTION PRIVATE LIMITED",
"E COM SECURITY SOLUTIONS PRIVATE LIMITED",
"E COM STREET INFOSERVICES INDIA PRIVATE LIMITED",
"E COMPUTER TECHNOLOGIES PRIVATE LIMITED",
"E CON PACKAGING PRIVATE LIMITED",
"E CON SYSTEMS INDIA PRIVATE LIMITED",
"E CONNECT SOLUTIONS PRIVATE LIMITED",
"E CUBE ACADEMY PRIVATE LIMITED",
"E D STEELS PVT LTD",
"E E E M DN 02 BARGI JABALPUR",
"E E HEAVY MACH DN EM DN GWL MADHYA PRADESH",
"E E LIGHT MACHINARY TUBEWELL AND GATES DIV NARSINGHPUR",
"E E LIGHT MACHINERY TUBE WELL AND GATES E/M DN WRD BHOPAL MADHYA PRADESH",
"E E NAHAR DIVISON CANAL KHARGONE",
"E E NVDA DN 18",
"E E P H E (MECH DIV)SAGAR MADHYA PRADESH",
"E E P H E MAINTENANCE DN BHOPAL",
"E E P H E SEHORE MADHYA PRADESH",
"E E PHE MECHA DN",
"E E PHE SATNA",
"E E PWD ( B AND R)",
"E E PWD DIV NO 1 B/R HBAD MADHYA PRADESH",
"E E R E S RATLAM",
"E E R E S UJJAIN",
"E E RANIAVANTIBAISAGAR QUALITY CONTROL DIV NO 29",
"E E TAWA PROJECT DIVISION ITARSI",
"E E WATER RESOURCES DN BHOPAL MADHYA PRADESH",
"E E WATER RESOURCES DN KHANDWA",
"E E Z FOIL PRIVATE LIMITED",
"E EIGHTEEN.COM LIMITED",
"E EMPHASYS SOLUTIONS PRIVATE LIMITED",
"E EMPHASYS SYSTEMS PRIVATE LIMITED",
"E F C LOGISTICS INDIA PRIVATE LIMITED",
"E F Y ENTERPRISES PRIVATE LIMITED",
"E FACTOR ADVENTURE TOURISM",
"E FACTOR EXPERIENCES LIMITED",
"E FOCUS INSTRUMENTS INDIA PRIVATE LIMITED",
"E G S PILLAY COLLEGE OF PHARMACY",
"E GOVERNANCE SOLUTIONS PRIVATE LIMITED",
"E HEREX TECHNOLOGIES PRIVATE LIMITED",
"E HOMES INFRASTRUCTURE PRIVATE LIMITED",
"E HUB CORPORATE SERVICES PRIVATE LIMITED",
"E I D PARRY (INDIA) LIMITED",
"E I DUPONT INDIA PRIVATE LIMITED",
"E I INSTRUMENTATION PRIVATE LIMITED",
"E I P R INDIA PRIVATE LIMITED",
"E I T A LOGISTICS LIMITED",
"E I TECHNOLOGIES PRIVATE LIMITED",
"E INDIA ELECTRICALS PRIVATE LIMITED",
"E INFOCHIPS PRIVATE LIMITED",
"E K ELECTRONICS PRIVATE LIMITED",
"E K INFRASTRUCTURE PRIVATE LIMITED",
"E L FORGE LIMITED",
"E LABS INFOTECH PRIVATE LIMITED",
"E LAND APPAREL LIMITED",
"E LAND FASHION INDIA PRIVATE LIMITED",
"E LAUNCH SOLUTION PRIVATE LIMITED",
"E M C PROJECTS PVT LTD",
"E M ELECTRO MECHANICALS PRIVATE LIMITED",
"E M PHARMACEUTICALS PRIVATE LIMITED",
"E M SERVICES INDIA PRIVATE LIMITED",
"E M TECHNOLOGIES INDIA PRIVATE LIMITED",
"E MACHINES TECHNOLOGIES INDIA PRIVATE LIMITED",
"E MEDITEK TPA SERVICES LIMITED",
"E MERGE SOLUTION PRIVATE LIMITED",
"E MOX MANUFACTURING PRIVATE LIMITED",
"E N COMMUNICATION PRIVATE LIMITED",
"E N PROJECT AND ENGINEERING INDUSTRIES PRIVATE LIMITED",
"E- NEXT MOBILITY PRIVATE LIMITED",
"E NSX SOFTECH PRIVATE LIMITED",
"E O S POWER INDIA PRIVATE LIMITED",
"E ORCHIDS TECHSOLUTIONS PRIVATE LIMITED",
"E P ELECTRO PRESSINGS PRIVATE LIMITED",
"E P INDUSTRIAL & AGRO PRODUCTS PRIVATE LIMITED",
"E PACK POLYMERS PRIVATE LIMITED",
"E PARISARAA PRIVATE LIMITED",
"E PASS PRODUCTS PRIVATE LIMITED",
"E POSITIVE ENTERTAINMENT PRIVATE LIMITED",
"E PROCUREMENT TECHNOLOGIES LIMITED",
"E QUEST TECHNOLOGIES PRIVATE LIMITED",
"E R AUTO PRIVATE LIMITED",
"E R AUTOMOTIVES LIMITED",
"E R COMPUTERS PRIVATE LIMITED",
"E RESIDENCES PRIVATE LIMITED",
"E RUCHI MARKETING PRIVATE LIMITED",
"E S EVENT SCULPTORS PRIVATE LIMITED",
"E SAMPARK",
"E SHOP MARKETING PRIVATE LIMITED",
"E SOFT TECHNOLOGIES LIMITED",
"E SOFT TECHNOLOGIES PRIVATE LIMITED",
"E SOLLUTIONS CONSULTANCY PRIVATE LIMITED",
"E SOLUTIONS IT SERVICES PRIVATE LIMITED",
"E SQUARE LEISURE PRIVATE LIMITED",
"E SQUARE SYSTEM & TECHNOLOGIES PRIVATE LIMITED",
"E STAR ENGINEERS PRIVATE LIMITED",
"E STONE INFORMATION TECHNOLOGY PRIVATE LIMITED",
"E T C INDUSTRIES LIMITED",
"E T S TOURIST PRIVATE LIMITED",
"E TO E INTERCONNECTIONS PRIVATE LIMITED",
"E TO E TRANSPORTATION INFRASTRUCTURE PRIVATE LIMITED",
"E TRAV TECH LIMITED",
"E TRAVEL ONLINE PRIVATE LIMITED",
"E TRAVELVALUE INDIA PRIVATE LIMITED",
"E TRAXWORLD PRIVATE LIMITED",
"E V HOMES CONSTRUCTIONS PRIVATE LIMITED",
"E V M RUBMIX COMPANY PRIVATE LIMITED",
"E V P ENGINEERING COLLEGE",
"E V P HOUSING CHENNAI PRIVATE LIMITED",
"E VAIDYA PRIVATE LIMITED",
"E VISION TECHNOLOGIES PRIVATE LIMITED",
"E WAY LOGISTICS PRIVATE LIMITED",
"E WAYS SOLUTIONS PRIVATE LIMITED",
"E WORLD TECHLIFE PRIVATE LIMITED",
"E Z BIOXCEL SOLUTIONS PRIVATE LIMITED",
"E ZEST DIGITAL SOLUTIONS PRIVATE LIMITED",
"E&B RUBBER METAL PRODUCTS PRIVATE LIMITED",
"E&C INFRASTRUCTURE PRIVATE LIMITED",
"E&C PROJECTS PRIVATE LIMITED",
"E. BIZ SOLUTION PRIVATE LIMITED.",
"E. C. SOFTWARE INDIA PRIVATE LIMITED",
"E.B.ENVIRO BIOTECH PRIVATE LIMITED",
"E.B.P INDIA PRIVATE LIMITED",
"E.C.C. TRADING PRIVATE LIMITED",
"E.I.P ENVIRO LEVEL CONTROLS PRIVATE LIMITED",
"E.M.A.R & SONS TEXTILES PRIVATE LIMITED",
"E.M.C. SUPER SPECIALITY HOSPITALS PRIVATE LIMITED",
"E.R.S. SERVICES PRIVATE LIMITED",
"E.RM.E. RENGASAMY EDUCATIONAL FOUNDATION",
"E.S. LIGHTING TECHNOLOGIES PRIVATE LIMITED",
"E.SELVAN TEXTILES PRIVATE LIMITED",
"E.V. COLLECTIONS PRIVATE LIMITED",
"E.V.P. ESTATES AND PROPERTIES DEVELOPMENT LIMITED",
"E-1 SECURITY SERVICES PRIVATE LIMITED",
"E2 SOFTWARE INDIA PRIVATE LIMITED",
"E2 SOLUTIONS INDIA PRIVATE LIMITED",
"E24 GLAMOUR LIMITED",
"E2E INFOWARE PRIVATE LIMITED",
"E2E NETWORKS LIMITED",
"E2E PROJECTS PRIVATE LIMITED",
"E2E QUALITY SOLUTIONS PRIVATE LIMITED",
"E2E RESEARCH SERVICES PRIVATE. LIMITED",
"E2E SUPPLY CHAIN SOLUTIONS LIMITED",
"E2E TECHNOCRATS PRIVATE LIMITED",
"E2E TELELINK INDIA PRIVATE LIMITED",
"E2G ENGINEERING SERVICES PRIVATE LIMITED",
"E2LOGY SOFTWARE SOLUTIONS PRIVATE LIMITED",
"E2M SOLUTIONS PRIVATE LIMITED",
"E2O HEALTH INC",
"E2OPEN SOFTWARE INDIA PRIVATE LIMITED",
"E2P MAART PRIVATE LIMITED",
"E2P MAGNUS GLOBAL TECH PRIVATE LIMITED",
"E2SERV VENTURES PRIVATE LIMITED",
"E3 ECOGREEN PRIVATE LIMITED",
"E3 EDGEBAND INDUSTRIES PRIVATE LIMITED",
"E3 EDUSOLUTIONS PRIVATE LIMITED",
"E3 PLASTECH MARKETING PRIVATE LIMITED",
"E3 TECHNOTEX PRIVATE LIMITED",
"E4 SOFTWARE SERVICES PRIVATE LIMITED",
"E5 CONTRACTORS PRIVATE LIMITED",
"E5 INFRASTRUCTURE PRIVATE LIMITED",
"E5 PROPERTIES PRIVATE LIMITED",
"E7 EVENT SOLUTIONS PRIVATE LIMITED",
"E7 PROCESSING SERVICES PRIVATE LIMITED",
"EA FACILITIES SERVICES PRIVATE LIMITED",
"EA GIBSON SHIPBROKERS (INDIA) PRIVATE LIMITED",
"EA LABS INDIA PRIVATE LIMITED",
"EA PACKAGING INDIA PRIVATE LIMITED",
"EA SUPPLIERS INTERNATIONAL PRIVATE LIMITED",
"EAAMA ESTATES PRIVATE LIMITED",
"EAAZ RIDER PRIVATE LIMITED",
"EABYAS INFO SOLUTIONS PRIVATE LIMITED",
"EAC EURO ASIA CONSULTING PRIVATE LIMITED",
"EACHANARI VIGNESHWARA FOOD INDIA PRIVATE LIMITED",
"EADCOSMOS MEDIA AND COMMUNICATION PRIVATE LIMITED",
"EADICCT MOBILITY SOLUTIONS PRIVATE LIMITED (OPC)",
"EAFT TECHNOLOGIES INDIA PRIVATE LIMITED",
"EAGABRIZ SHIPPING PRIVATE LIMITED",
"EAGE EDUSOLUTIONS PRIVATE LIMITED",
"EAGE ELECTRONICS PRIVATE LIMITED",
"EAGE HEALTHCARE PRIVATE LIMITED",
"EAGE SHOPPING PRIVATE LIMITED",
"EAGE TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"EAGLE AIR SEA SERVICES PRIVATE LIMITED",
"EAGLE AMRAVATI CHIKHLI NH-6 PKG-II PRIVATE LIMITED",
"EAGLE AUTOMATION PRIVATE LIMITED",
"EAGLE CABS INDIA PRIVATE LIMITED",
"EAGLE CARGO MOVERS PRIVATE LIMITED",
"EAGLE COATS PRIVATE LIMITED",
"EAGLE CONSULTING PRIVATE LIMITED",
"EAGLE DEEP INFRA INDIA PRIVATE LIMITED",
"EAGLE EARTH MOVERS PRIVATE LIMITED",
"EAGLE ELECTRONICS INDIA PRIVATE LIMITED",
"EAGLE EXPRESS LOGISTICS INDIA LIMITED",
"EAGLE EXTRUSION PRIVATE LIMITED",
"EAGLE EYE MANAGEMENT SERVICES PRIVATE LIMITED",
"EAGLE FASHIONS PVT LTD",
"EAGLE FIBRES LIMITED",
"EAGLE FILAMENT PRIVATE LIMITED",
"EAGLE FILMS PRIVATE LIMITED",
"EAGLE FLEET SERVICES PRIVATE LIMITED",
"EAGLE FORGINGS PRIVATE LIMITED",
"EAGLE FREIGHT FORWARDERS P LTD",
"EAGLE GLASS DECO PRIVATE LIMITED",
"EAGLE HARDWARE PRIVATE LIMITED",
"EAGLE HOME APPLIANCES PRIVATE LIMITED",
"EAGLE HOSPITALITY SERVICES PRIVATE LIMITED",
"EAGLE HUNTER FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"EAGLE HUNTER SOLUTIONS LIMITED",
"EAGLE INDUSTRIAL SERVICES PRIVATE LIMITED",
"EAGLE INFORMATION SYSTEMS PRIVATE LIMITED",
"EAGLE INFRA INDIA LIMITED",
"EAGLE INFRA PRIVATE LIMITED",
"EAGLE INFRA PROJECTS (INDIA) LIMITED",
"EAGLE LACES PVT. LTD.",
"EAGLE MARITIME INC.",
"EAGLE MEDICAL SYSTEMS PRIVATE LIMITED",
"EAGLE NETWORK SUPPLY PRIVATE LIMITED",
"EAGLE OPTICS PRIVATE LIMITED",
"EAGLE PEAK GARAM CHAI PRIVATE LIMITED",
"EAGLE PEAK INTEL PRIVATE LIMITED",
"EAGLE PHOTONICS PRIVATE LIMITED",
"EAGLE PLANT PROTECT PRIVATE LIMITED",
"EAGLE PRESS PRIVATE LIMITED",
"EAGLE QUEST INTERNATIONAL (INDIA) PRIVATE LIMITED",
"EAGLE REGENCY HIGHWAYS PRIVATE LIMITED",
"EAGLE SECURITY & PERSONNEL SERVICE",
"EAGLE SEEDS AND BIOTECH LIMITED",
"EAGLE SHRISHRI JAMNER PRIVATE LIMITED",
"EAGLE SILK MILLS PRIVATE LIMITED",
"EAGLE SOFTWARE INDIA PRIVATE LIMITED",
"EAGLE SPS INDIA PRIVATE LIMITED",
"EAGLE STAR INTERNATIONAL HOTELS PRIVATE LIMITED",
"EAGLE STEEL INDUSTRIES PRIVATE LIMITED",
"EAGLE SYNTHETICS PRIVATE LIMITED",
"EAGLE TECHNOLOGY RESOURCES PRIVATE LIMITED",
"EAGLE TECHSEC COMMUNICATIONS INDIA PRIVATE LIMITED",
"EAGLE TK INFOTECH PRIVATE LIMITED OPC",
"EAGLE TRADELINKS PRIVATE LIMITED",
"EAGLE TRANS SHIPPING & LOGISTICS INDIA PRIVATE LIMITED",
"EAGLE WARDHA HIGHWAYS PRIVATE LIMITED",
"EAGLE YARNS PRIVATE LIMITED",
"EAGLEBURGMANN INDIA PRIVATE LIMITED",
"EAGLEBURGMANN KE PRIVATE LIMITED",
"EAGLEDEEP KOLAGHAT HALDIA OMT PROJECT PRIVATE LIMITED",
"EAGLEEYE SAFEPROTECTION PRIVATE LIMITED",
"EAGLEHITECH PRIVATE. LIMITED.",
"EAGLES FREIGHT PRIVATE LIMITED",
"EAGLESFORD MULTITRADE LLP",
"EAGLESIGHT TELEMEDIA PRIVATE LIMITED",
"EAGLESPEED INTERNATIONAL LOGISTICS PRIVATE LIMITED",
"EAGLESTAR MARINE INDIA PRIVATE LIMITED",
"EAGLESTAR SHIPMANAGEMENT S PTE LIMITED",
"EAGLEVIEW",
"EAI POWER INDIA PRIVATE LIMITED",
"EAI SYSTEMS INDIA PRIVATE LIMITED",
"EAII ADVISORS PRIVATE LIMITED",
"EAINFOBIZ DIGITAL SOLUTIONS PRIVATE LIMITED",
"EAINFOBIZLAB SERVICES PRIVATE LIMITED",
"EAK AUTOMOBILES PRIVATE LIMITED",
"EAKANSH MOTORS PRIVATE LIMITED",
"EAL CONSULTING INDIA PRIVATE LIMITED",
"EALEARN SOLUTIONS PRIVATE LIMITED",
"E-ALLY SECURITIES (INDIA) PRIVATE LIMITED",
"EAMON DRUGS PRIVATE LIMITED",
"EAMON INDUSTRIES PRIVATE LIMITED",
"EAMPERTAA NETWORK SOLUTION PRIVATE LIMITED",
"EAMS ENGINEERING & MANAGEMENT INDIA PRIVATE LIMITED",
"E-ANIMEDIA SOLUTIONS PRIVATE LIMITED",
"EANSWER NETWORK INDIA PRIVATE LIMITED",
"EAP ELECTRO PROJECT PRIVATE LIMITED",
"EAP ELECTRO PROJECTS PRIVATE LIMITED",
"EAP INFRASTRUCTURES PRIVATE LIMITED",
"EAPPLIQUE. COM PRIVATE LIMITED",
"EAPPSYS INFO SOLUTIONS INDIA PRIVATE LIMITED",
"EAPRO GLOBAL LIMITED",
"EAR SOLUTIONS PRIVATE LIMITED",
"EARESPONSE & RESEARCH PRIVATE LIMITED",
"EARL ENGINEERS PRIVATE LIMITED",
"EARLY AUTISM SERVICES PRIVATE LIMITED",
"EARLY BASKET INDIA PRIVATE LIMITED",
"EARLY BIRD EXPORTS PRIVATE LIMITED",
"EARLY CHOICE PRIVATE LIMITED",
"EARLY FOODS PRIVATE LIMITED",
"EARLY MAN FILM PRIVATE LIMITED",
"EARLYSAIL SOFTWARE PRIVATE LIMITED",
"EARLYSALARY SERVICES PRIVATE LIMITED",
"EARNEST GLOBALISATION TECHNOLOGY INDIA PRIVATE LIMITED",
"EARNEST JOHN AND COMPANY LIMITED",
"EARNEST POLYMERS PVT LTD.",
"EARNEST SHIPPING & SHIP BUILDERS LIMITED",
"EARNEST TOWERS PRIVATE LIMITED",
"EARNEST TRAVEL AND HOSPITALITY PRIVATE LIMITED",
"EARNINDIA CONSULTANCY PRIVATE LIMITED",
"EARNWEALTH SOLUTIONS PRIVATE LIMITED",
"EARSHOT MEDIA PRIVATE LIMITED",
"E-ARTH ACCOUNTS FINANCE & MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"EARTH AGRO STRUCTURES PRIVATE LIMITED",
"EARTH AND SKY SECURITY (INDIA) PRIVATE LIMITED",
"EARTH BAUG",
"EARTH BLOCKS INDIA PRIVATE LIMITED",
"EARTH BUILDTECH PRIVATE LIMITED",
"EARTH CARE ( INDIA ) PRIVATE LIMITED",
"EARTH CARE EQUIPMENTS PRIVATE LIMITED",
"EARTH CHEMICAL AND SCIENTIFIC PRIVATE LIMITED",
"EARTH CLASSIC",
"EARTH CONTAINERS PRIVATE LIMITED",
"EARTH CRUST PRIVATE LIMITED",
"EARTH DEVELOPERS PRIVATE LIMITED",
"EARTH ECO SOLUTIONS PRIVATE LIMITED",
"EARTH ELEMENTS DEVELOPMENT COMPANY PRIVATE LIMITED",
"EARTH ENVIRON SYSTEM",
"EARTH ESTATE DEVELOPERS PRIVATE LIMITED",
"EARTH EXPORTS PRIVATE LIMITED",
"EARTH EXPRESS FREIGHT PRIVATE LIMITED",
"EARTH INDIA FINLEASE LTD",
"EARTH METALLURGICAL SERVICES PRIVATE LIMITED",
"EARTH MINERALS COMPANY LIMITED",
"EARTH MINING PRIVATE LIMITED",
"EARTH OCEAN LOGISTICS PRIVATE LIMITED",
"EARTH ON MAPPING CONSULTING",
"EARTH ORGANIC FOODS PRIVATE LIMITED",
"EARTH PAVERS (HYDERABAD) PRIVATE LIMITED",
"EARTH RECYCLER PRIVATE LIMITED",
"EARTH RHYTHM PRIVATE LIMITED",
"EARTH SENSE AGRO PRODUCTS PRIVATE LIMITED",
"EARTH SENSE RECYCLE PRIVATE LIMITED",
"EARTH SENSE VENTURES PRIVATE LIMITED",
"EARTH SOLAR POWER PRIVATE LIMITED",
"EARTH SOLAR PRIVATE LIMITED",
"EARTH SOLUTIONS PRIVATE LIMITED",
"EARTH STEIN PRIVATE LIMITED",
"EARTH SUITES & RESORTS PRIVATE LIMITED",
"EARTH SYSCOM PRIVATE LIMITED",
"EARTH TECHNOCON PRIVATE LIMITED",
"EARTH TECHNOLOGY PRIVATE LIMITED",
"EARTH TEKNIKS PRIVATE LIMITED",
"EARTH TEX PRIVATE LIMITED",
"EARTH UTILITIES PRIVATE LIMITED",
"EARTH WASTE MANAGEMENT PRIVATE LIMITED",
"EARTH WIRES PRIVATE LIMITED",
"EARTH WORTH CONSTRUCTIONS PRIVATE LIMITED",
"EARTHBAGS EXPORT PRIVATE LIMITED",
"EARTHBOX VENTURES PRIVATE LIMITED",
"EARTHCARE ENVIRO SOLUTIONS PRIVATE LIMITED",
"EARTHCHEM LABORATORIES PRIVATE LIMITED",
"EARTHCON CONSTRUCTIONS PRIVATE LIMITED",
"EARTHCON SYSTEMS INDIA PRIVATE LIMITED",
"EARTHEMPIRE REALCON PRIVATE LIMITED",
"EARTHEN CERAMICS PRIVATE LIMITED",
"EARTHEN ENGINEERS PRIVATE LIMITED",
"EARTHEPC PROJECTS PRIVATE LIMITED",
"EARTHGENIX PRO PRIVATE LIMITED",
"EARTHIN PROJECTS LIMITED",
"EARTHING SOLUTIONS PRIVATE LIMITED",
"EARTHINSPIRED COMMUNITIES PRIVATE LIMITED",
"EARTHIO SUSTAINABLE ENERGY PRIVATE LIMITED",
"EARTHLINE INFOCOMM PRIVATE LIMITED",
"EARTHLINE SERVICES PRIVATE LIMITED",
"EARTHLY JOY GLOBAL PRIVATE LIMITED",
"EARTHMAN RUBBER INDUSTRIES PRIVATE LIMITED",
"EARTHON PROJECTS PRIVATE LIMITED",
"EARTHOOD SERVICES PRIVATE LIMITED",
"EARTHPOWER EQUIPMENTS PRIVATE LIMITED",
"EARTHRAYS PRIVATE LIMITED",
"EARTHSAVE PRIVATE LIMITED",
"EARTHSENSE TECHNOLOGIES INDIA PRIVATE LIMITED",
"EARTHSPARES OVERSEAS PRIVATE LIMITED",
"EARTHSTAHL & ALLOYS LIMITED",
"EARTHSTAR RUBBER INDUSTRIES PRIVATE LIMITED",
"EARTHSTONE HOLDING (ONE) PRIVATE LIMITED",
"EARTHSTONE HOLDING (TWO) PRIVATE LIMITED",
"EARTHSTONE INFRA PRIVATE LIMITED",
"EARTHTEK CONSTRUCTION AND FARM EQUIPMENTS PRIVATE LIMITED",
"EARTHTEK PRECISION PRODUCTS PRIVATE LIMITED",
"EARTHWAVE TECHNOLOGY PRIVATE LIMITED",
"EARTHWISE HOSPITALITY AND ENTERTAINMENT HOLDINGS PRIVATE LIMITED",
"EARTHY FOODS PRIVATE LIMITED",
"EARTHZ URBAN SPACES PRIVATE LIMITED",
"EARWYN MARINE SERVICES PRIVATE LIMITED",
"EASA ELEVATORS PRIVATE LIMITED",
"EASA KRUPA ENGINEERING PRIVATE LIMITED",
"EASAN IMPEX PRIVATE LIMITED",
"EASAT RADAR SYSTEMS INDIA PRIVATE LIMITED",
"EASE CONSULTANT ENGINEERS PRIVATE LIMITED",
"EASE DEALCOM PRIVATE LIMITED",
"EASE HOMOEOPATHY AND RESEARCH CENTRE PRIVATE LIMITED",
"EASEBUZZ PRIVATE LIMITED",
"EASEMED ELECTROSURGICAL PRIVATE LIMITED",
"EASEMY BUSINESS PRIVATE LIMITED",
"EASEPLUS HEALTHCARE PRIVATE LIMITED",
"EASETHIS ONLINE SERVICES PRIVATE LIMITED",
"E-ASHWA AUTOMOTIVE ( FARIDABAD) PRIVATE LIMITED",
"E-ASHWA AUTOMOTIVE PRIVATE LIMITED",
"EASOL PRIVATE LIMITED",
"EASS SECURITY SERVICES PRIVATE LIMITED",
"EAST & WEST TRADING CO PVT LTD",
"EAST (INDIA) CONFECTIONERIES LIMITED",
"EAST AFRICAN INDIA OVERSEAS",
"EAST AGRI SEEDS PRIVATE LIMITED",
"EAST AND SOUTH TRADING PRIVATE LIMITED",
"EAST AND WEST SECURITIES PRIVATE LIMITED",
"EAST ASIA EXIM PRIVATE LIMITED",
"EAST AVENUE INFRACON PRIVATE LIMITED",
"EAST BOUND TOURS AND TRAVELS PRIVATE LIMITED",
"EAST BOURNE HOTELS PRIVATE LIMITED",
"EAST BRIDGE ADVISORS PRIVATE LIMITED",
"EAST CENTRAL RAILWAY",
"EAST CENTRAL RAILWAY PATNA",
"EAST COAST ASSOCIATES PRIVATE LIMITED",
"EAST COAST CLOTHING COMPANY PRIVATE LIMITED",
"EAST COAST COCONUT PRODUCTS PRIVATE LIMITED",
"EAST COAST CONSTRUCTIONS AND INDUSTRIES LIMITED",
"EAST COAST DISTRIBUTORS PRIVATE LIMITED",
"EAST COAST ENGINEERING PRIVATE LIMITED",
"EAST COAST ENTERPRISERS LIMITED",
"EAST COAST HOSPITALS LTD",
"EAST COAST INFRASTRUCTURE PRIVATE LIMITED",
"EAST COAST LOGISTICS PRIVATE LIMITED",
"EAST COAST MAGNETS PRIVATE LIMITED",
"EAST COAST NATURAL GAS DISTRIBUTION PRIVATE LIMITED",
"EAST COAST ORGANICS PRIVATE LIMITED",
"EAST COAST PAINTS PRIVATE LIMITED",
"EAST COAST RAILWAY / WALTAIR DIVISION",
"EAST COAST RAILWAY OF WALTAIR DIVISION",
"EAST COAST RUBOCLAIM PVT LTD",
"EAST COAST WAREHOUSING PRIVATE LIMITED",
"EAST COMMERCIAL P LTD.",
"EAST CONSULTANCY SERVICES PRIVATE LIMITED",
"EAST CROP",
"EAST DELHI ADVANCE NICU",
"EAST DELHI FINLEASE COMPANY PRIVATE LIMITED",
"EAST DELHI LEASING PRIVATE LIMITED",
"EAST DELHI MUNCIPAL CORPORATION",
"EAST DELHI SUPERIOR SECURITY SERVICES INDIA PRIVATE LIMITED",
"EAST END SILKS PRIVATE LIMITED",
"EAST HOOGHLY POLYPLAST PRIVATE LIMITED",
"EAST HYDERABAD EXPRESSWAY LIMITED",
"EAST INDIA AGRO COMMODITIES PRIVATE LIMITED",
"EAST INDIA AGRO INDUSTRIES PVT LTD",
"EAST INDIA AUTO TRADERS PVT LTD",
"EAST INDIA AUTOLIGHT PRIVATE LIMITED",
"EAST INDIA BUSINESS CENTRE PRIVATE LIMITED",
"EAST INDIA COATINGS PRIVATE LIMITED",
"EAST INDIA COMMERCIAL CO LIMITED",
"EAST INDIA COMMODITIES PRIVATE LIMITED",
"EAST INDIA COMPANY TRADING PRIVATE LIMITED",
"EAST INDIA ELECTRONICS PRIVATE LIMITED",
"EAST INDIA ELEVATORS LTD",
"EAST INDIA FLOUR MILLS PVT LTD",
"EAST INDIA FURNITURE PRIVATE LIMITED",
"EAST INDIA HOLDINGS PRIVATE LIMITED",
"EAST INDIA INFOTECH PRIVATE LIMITED",
"EAST INDIA INVESTMENT CO PVT LTD",
"EAST INDIA MINERALS LIMITED",
"EAST INDIA PETROLEUM PRIVATE LIMITED",
"EAST INDIA PHARMACEUTICAL WORKS LIMITED",
"EAST INDIA POLYFILMS PRIVATE LIMITED",
"EAST INDIA SALES AND SERVICES PVT LTD",
"EAST INDIA SECURITIES LIMITED",
"EAST INDIA SHIPPING PRIVATE LIMITED",
"EAST INDIA SPINNING PVT LTD",
"EAST INDIA TECHNOLOGIES PRIVATE LIMITED",
"EAST INDIA TECHNOLOGIES PRIVATE LIMITED.",
"EAST INDIA UDYOG LIMITED",
"EAST INDIA UDYOG LTD",
"EAST INDIAN PRODUCE LTD",
"EAST NORTH INTERCONNECTION COMPANY LIMITED",
"EAST POINT COLLEGE OF ENGINEERING AND TECHNOLOGY",
"EAST POINT GROUP OF INSTITUTION",
"EAST RASAYAN CHEMICALS MARKETING PVT LTD",
"EAST RIVER MERCANTILE PRIVATE LIMITED",
"EAST STORY EXPORTING HOUSE PRIVATE LIMITED",
"EAST VILLAGE TECHNOLOGIES PRIVATE LIMITED",
"EAST WEST APPARELS PRIVATE LIMITED",
"EAST WEST AUTOMATION TECHNOLOGIES PRIVATE LIMITED",
"EAST WEST COMBINED INDUSTRIES",
"EAST WEST ENGINEERING AND ELECTRONICS PRIVATE LIMITED",
"EAST WEST ETHNIC FOODS PRIVATE LIMITED",
"EAST WEST FIRE ENGINEERING COMPANY PRIVATE LIMITED",
"EAST WEST FOODS PRIVATE LIMITED",
"EAST WEST FREIGHT CARRIERS LIMITED EWFCL",
"EAST WEST GROUP OF INSTITUTIONS",
"EAST WEST HOLDINGS LIMITED",
"EAST WEST MANUFACTURING LIMITED",
"EAST WEST MEDICAL CENTER PRIVATE LIMITED",
"EAST WEST PHARMA",
"EAST WEST PHARMA INDIA PRIVATE LIMITED",
"EAST WEST PIPELINE PRIVATE LIMITED",
"EAST WEST PRODUCTS LIMITED",
"EAST WEST ROADLINES",
"EAST WEST SEEDS INDIA PRIVATE LIMITED",
"EAST WEST SHIP REPAIRERS PRIVATE LIMITED",
"EAST WEST STONEX (INDIA) PRIVATE LIMITED",
"EAST WEST VANIJYA PVT LTD",
"EAST WIND FOOTWEAR COMPANY LIMITED",
"EASTCOAST STEEL LTD",
"EASTCOAST WATERSPORTS PRIVATE LIMITED",
"EASTCOMPEACE INDIA PRIVATE LIMITED",
"EASTCORP POLYMERS PRIVATE LIMITED",
"EASTEA CHAI PRIVATE LIMITED",
"EASTEND AGENCIES PRIVATE LIMITED",
"EASTERN & NORTH EAST FRONTIER RAILWAY CO-OPERATIVE BANK LTD",
"EASTERN AGENCIES AROMATICS PRIVATE LIMITED",
"EASTERN AGENCIES HEALTHCARE PRIVATE LIMITED",
"EASTERN AGRITECH PRIVATE LIMITED",
"EASTERN AGRO FOODS PRIVATE LIMITED",
"EASTERN ALLOY & ENGINEERING INDUSTRIES PVT. LTD.",
"EASTERN ALLOYS PRIVATE LIMITED",
"EASTERN ANTICORROSIVES LTD",
"EASTERN ARTS PRIVATE LIMITED",
"EASTERN AUTO INVESTO PVT LTD",
"EASTERN AUTOMOBILES PRIVATE LIMITED",
"EASTERN AUTOMOTIVE MACHINE TOOLS PRIVATE LIMITED",
"EASTERN BAKERIES PRIVATE LIMITED",
"EASTERN BEARINGS PRIVATE LIMITED",
"EASTERN BELTING & COTTON MILLS PVT LTD",
"EASTERN BICYCLE PRIVATE LIMITED",
"EASTERN BOOK COMPANY PRIVATE LIMITED",
"EASTERN BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"EASTERN CARGO CARRIERS INDIA PRIVATE LIMITED",
"EASTERN CHEMICAL INDUSTRIAS PVT LTD",
"EASTERN CHEMICALS MUMBAI PRIVATE LIMITED",
"EASTERN COALFIELDS LIMITED",
"EASTERN COATINGS & SERVICES PRIVATE LIMITED",
"EASTERN CONDIMENTS PRIVATE LIMITED",
"EASTERN CONSTRUCTION COMPANY",
"EASTERN COPPER MANUFACTURING COMPANY PVT LTD",
"EASTERN COTTON TRADERS PVT LTD",
"EASTERN DEVCON LIMITED",
"EASTERN DIAGNOSTICS INDIA LIMITED",
"EASTERN DRAPE PRIVATE LIMITED",
"EASTERN DYECHEM PRIVATE LIMITED",
"EASTERN ELECTRODES & COKE PRIVATE LIMITED",
"EASTERN ELECTROLYSER LIMITED",
"EASTERN ENGINEERING COMPANY PRIVATE LIMITED",
"EASTERN ENTERPRISES",
"EASTERN ESTATE CONSTRUCTION & DEVELOPERS PRIVATE LIMITED",
"EASTERN FABRITECH PRIVATE LIMITED",
"EASTERN FINANCIERS LIMITED",
"EASTERN FINE PRINTING INDIA PRIVATE LIMITED",
"EASTERN FOODS PRIVATE LIMITED",
"EASTERN FORMONICS PRIVATE LIMITED",
"EASTERN FUELS PRIVATE LIMITED",
"EASTERN GENERAL INDUSRIES LTD",
"EASTERN GOURMET PRIVATE LIMITED",
"EASTERN HERITAGE",
"EASTERN INDIA BIOFUELS PRIVATE LIMITED",
"EASTERN INDIA BROWN MULTI PRIVATE LIMITED",
"EASTERN INDIA CONSTRUCTION PVT LTD",
"EASTERN INDIA FISHERIES AND AGRO PRODUCTS PVT. LTD.",
"EASTERN INDIA POWERTECH LIMITED",
"EASTERN INDIA SERVICES & MARKETING CO.LIMITED",
"EASTERN INDIA SERVICES & MARKETING CO.LTD.",
"EASTERN INTERNATIONAL HOTELS LIMITED",
"EASTERN INTERNATIONAL INFRASTRUCTURES PRIVATE LIMITED",
"EASTERN INVESTMENTS LTD",
"EASTERN JEWELS PRIVATE LIMITED",
"EASTERN KING GRANITES PRIVATE LIMITED",
"EASTERN LIGHT AND POWER PRIVATE LIMITED",
"EASTERN LOGICA INFOWAY LIMITED",
"EASTERN MEDIA LIMITED",
"EASTERN MEDICAL WELLNESS PRIVATE LIMITED",
"EASTERN MEDICARE PRIVATE LIMITED",
"EASTERN MERCANTILES PVT.LTD.",
"EASTERN METEC PRIVATE. LIMITED.",
"EASTERN MICROPOR PRIVATE LIMITED",
"EASTERN MILLS PRIVATE LIMITED",
"EASTERN NAPHTHA-CHEM PRIVATE LIMITED",
"EASTERN NAVIGATION PVT LTD",
"EASTERN ORGANIC FERTILIZER PRIVATE LIMITED",
"EASTERN PACIFIC SHIPPING INDIA PRIVATE LIMITED",
"EASTERN PAINT WORKS PVT LTD",
"EASTERN PETRO TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"EASTERN PETROLEUM PRIVATE LIMITED",
"EASTERN PHOTO SERVICES PRIVATE LIMITED",
"EASTERN PILLING AND CONSTRUCTION PVT.LTD.",
"EASTERN PLAZA LTD",
"EASTERN POLYCRAFT INDUSTRIES LIMITED",
"EASTERN POLYPORDUCTS PRIVATE LIMITED",
"EASTERN POLYSALES PVT LTD",
"EASTERN POWER DISTRIBUTION COMPANY OF ANDHRA PRADE",
"EASTERN POWER DISTRIBUTION COMPANY OF ANDHRA PRADESH LIMITED",
"EASTERN RAILWAY",
"EASTERN RECLAIM PRIVATE LIMITED",
"EASTERN RED RUBY FOOD PRIVATE LIMITED",
"EASTERN RESOURCES PVT LTD",
"EASTERN ROAD CARRIERS PRIVATE LIMITED",
"EASTERN ROADWAYS PRIVATE LIMITED",
"EASTERN ROLLER FLOUR MILLS PVT LTD",
"EASTERN SAFE ROADWAYS PRIVATE LIMITED",
"EASTERN SOFTWARE SYSTEMS PRIVATE LIMITED",
"EASTERN STEVEDORES PRIVATE LIMITED",
"EASTERN SUPERMARKET PRIVATE LIMITED",
"EASTERN SUPPLYCHAIN AND LOGISTICS LIMITED",
"EASTERN SURGICAL COMPANY",
"EASTERN TEXTILES PVT LTD",
"EASTERN TRACK UDYOG PRIVATE LIMITED",
"EASTERN TRAVELS PRIVATE LIMITED",
"EASTERN TREADS LIMITED",
"EASTERN WELDMESH PVT LTD",
"EASTERN WESTERN ROADWAYS PRIVATE LIMITED",
"EASTERN WINES PRIVATE LIMITED",
"EASTERN WOOD PRODUCTS PVT LTD",
"EASTERN YARNS PVT LTD",
"EASTERNBULK TRADING & SHIPPING PRIVATE LIMITED.",
"EASTERNZONE INDUSTRIES PRIVATE LIMITED",
"EASTGATE EXPORT PRIVATE LIMITED",
"EASTHOOGHLY AGRO PLANTATION PRIVATE LIMITED",
"EASTMADE SPICES AND HERBS PRIVATE LIMITED",
"EASTMAN AGRIPRODUCTS PRIVATE LIMITED",
"EASTMAN AUTO & POWER LIMITED",
"EASTMAN CAST AND FORGE LIMITED",
"EASTMAN CHAMICAL INDIA PRIVATE LIMITED",
"EASTMAN CHEMICAL COMPANY",
"EASTMAN CRUSHER CO.PVT LTD",
"EASTMAN EXPORTS GLOBAL CLOTHING PRIVATE LIMITED",
"EASTMAN EXPORTS PRIVATE LIMITED",
"EASTMAN INDUSTRIES LIMITED",
"EASTMAN INTERNATIONAL LIMITED",
"EASTMAN NEW ENERGY PRIVATE LIMITED",
"EASTMAN POWER TECHNOLOGIES PRIVATE LIMITED",
"EASTMAN SPINNING MILLS PRIVATE LIMITED",
"EAST-NORTH INTERCONNECTION COMPANY LIMITED",
"EASTO PNEUMATIC PRIVATE LIMITED",
"EASTON MARKETING PRIVATE LIMITED",
"EASTREAN RAILWAY",
"EASTWELL INDUSTRIES PRIVATE LIMITED",
"EAST-WEST DESIGN PRIVATE LIMITED",
"EASTWEST HOTELS LIMITED",
"EASUN ENGINEERING COMPANY PRIVATE LIMITED",
"EMR TAP CHANGERS PRIVATE LIMITED",
"EASWARI ENGINEERING COLLEGE",
"EASWARI MOULDS & DIES PRIVATE LIMITED",
"EASY ACADEMIC SOLUTIONS AND TECHNO-LOGICS PRIVATE LIMITED",
"EASY ACCOUNTANTS PRIVATE LIMITED",
"EASY AND SAFE LOGISTICS PRIVATE LIMITED",
"EASY CAM PRIVATE LIMITED",
"EASY CARE CONSUMER SOLUTION PRIVATE LIMITED",
"EASY CARE INTEGRATED SOLUTIONS INDIA PRIVATE LIMITED",
"EASY DESIGN SYSTEMS PRIVATE LIMITED",
"EASY DRIVE MOBILITY SOLUTIONS PRIVATE LIMITED",
"EASY DRY SYSTEMS PRIVATE LIMITED",
"EASY FIX HANDY SOLUTIONS INDIA PRIVATE LIMITED",
"EASY FLUX POLYMERS PRIVATE LIMITED",
"EASY HANDS SOLUTIONS PRIVATE LIMITED",
"EASY HEAR INDIA PRIVATE LIMITED",
"EASY HOME FINANCE LIMITED",
"EASY HOME SOLUTIONS PRIVATE LIMITED",
"EASY LIFE RETAILING PRIVATE LIMITED",
"EASY LIFE STORE PRIVATE LIMITED",
"EASY LIFESTYLE PRIVATE LIMITED",
"EASY LIGHT PRIVATE LIMITED",
"EASY MATS PRIVATE LIMITED",
"EASY NOTE STATIONERY PRIVATE LIMITED",
"EASY OPENENDS INDIA PRIVATE LIMITED",
"EASY PAY PRIVATE LIMITED",
"EASY PHOTO VOLTECH PRIVATE LIMITED",
"EASY PLATFORM SERVICES PRIVATE LIMITED",
"EASY PRODUCTIONS PRIVATE LIMITED",
"EASY SELL SERVICE PRIVATE LIMITED",
"EASY SHIPPING INDIA PRIVATE LIMITED",
"EASY SOLAR SOLUTIONS PRIVATE LIMITED",
"EASY SOLUTION INFOSYSTEMS PRIVATE LIMITED",
"EASY SOURCE HR SOLUTIONS PRIVATE LIMITED",
"EASY SPIRIT ENTERPRISES PRIVATE LIMITED",
"EASY TECH INNOVATION PRIVATE LIMITED",
"EASY TRIP PLANNERS LIMITED",
"EASY TRIP PLANNERS PRIVATE LIMITED",
"EASY WAY FOREX AND TRAVELS PRIVATE LIMITED",
"EASYACCESS FINANCIAL SERVICES LIMITED",
"EASYAUTHORING INDIA PRIVATE LIMITED",
"EASYBIZ CYBERTECH SERVICES PRIVATE LIMITED",
"EASYCARRY TECHNOLOGIES INDIA PRIVATE LIMITED",
"EASYLIFE FRESH TRADING PRIVATE LIMITED",
"EASYLIFT TECHNOLOGIES PRIVATE LIMITED",
"EASYLINK SOFTECH PRIVATE LIMITED",
"EASYMALL ONLINE SHOPPING PRIVATE LIMITED",
"EASYNEXT PROFESSIONAL SERVICES PRIVATE LIMITED",
"EASYPASS LOGISTICS PRIVATE LIMITED",
"EASYREACH SOLUTIONS PRIVATE LIMITED",
"EASYREWARDZ SOFTWARE SERVICES PRIVATE LIMITED",
"EASYSHIP TECHNOLOGIES PRIVATE LIMITED",
"EASYSHOP MARKETING PRIVATE LIMITED",
"EASYSTEPIN IT SERVICES PRIVATE LIMITED",
"EASYTECH INDUSTRIES PRIVATE LIMITED",
"EASYTECH INNOVATIONS PRIVATE LIMITED",
"EASYTECH ITSOLUTIONS PRIVATE LIMITED",
"EASYTECH SERVICES PRIVATE LIMITED",
"EASYWAY 3E SOLUTIONS PRIVATE LIMITED",
"EASYWAY CONSULTANCY PRIVATE LIMITED",
"EASYWAY TECHNOLOGIES PRIVATE LIMITED",
"EASYWAYS FREIGHTS FORWARDERS PRIVATE LIMITED",
"EAT DRINK DESIGN PRIVATE LIMITED",
"EAT INDIA PRIVATE LIMITED",
"EATAGE AGRO PRIVATE LIMITED",
"EATBUD FOOD PRIVATE LIMITED",
"EATEAM SOLUTIONS PRIVATE LIMITED",
"EATECH INDIA PRIVATE LIMITED",
"EATGOOD TECHNOLOGIES PRIVATE LIMITED",
"EATIGO INDIA PRIVATE LIMITED",
"EATINC FOOD & BEVERAGES PRIVATE LIMITED.",
"EATING CIRCLES FINE DINING PRIVATE LIMITED",
"EATMAN FOODS INDIA PRIVATE LIMITED",
"EATON FLUID POWER LIMITED",
"EATON HOLDINGS PRIVATE LIMITED",
"EATON INDIA INNOVATION CENTER LLP",
"EATON INDUSTRIAL SYSTEMS PRIVATE LIMITED",
"EATON POWER QUALITY PRIVATE LIMITED",
"EATON TECHNOLOGIES PRIVATE LIMITED",
"EATREPEAT INDIA PRIVATE LIMITED",
"EAU BATHING SOLUTIONS PRIVATE LIMITED",
"EAU CHEMICAL MANUFACTURING PRIVATE LIMITED",
"EAVAN FASHION PRIVATE LIMITED",
"EAVETOP SOFTTECH PRIVATE LIMITED",
"EAZEE TECH",
"EAZY ASSETS PRIVATE LIMITED",
"EAZY ERP TECHNOLOGIES PRIVATE LIMITED",
"EAZYCORP INDIA PRIVATE LIMITED",
"EAZYDINER PRIVATE LIMITED",
"EAZYMILES INDIA PRIVATE LIMITED",
"EAZYWAYS AROGYA HEALTHCARE PRIVATE LIMITED",
"EAZYWORLD ENGINEERING PRIVATE LIMITED",
"EB SOFTWARE INDIA PRIVATE LIMITED",
"EBA CONSULTANTS PRIVATE LIMITED",
"EBA SOLUTIONS PRIVATE LIMITED",
"EBACO INDIA PRIVATE LIMITED",
"EBAD EXPORTS PRIVATE LIMITED",
"EBALIA E-COMM SERVICES PRIVATE LIMITED",
"EBAOTECH INDIA PRIVATE LIMITED",
"EBARA MACHINERY INDIA PRIVATE LIMITED",
"EBAULLIENT PRIVATE LIMITED",
"EBAXO SHOES PRIVATE LIMITED",
"EBAY INDIA ECOMMERCE SERVICES PRIVATE LIMITED",
"EBB VINTRADE PRIVATE LIMITED",
"EBBSTONE CONSULTING PRIVATE LIMITED",
"EBCO PRIVATE LIMITED",
"EBCOS INDIA SERVICES PRIVATE LIMITED",
"EBEK LANGUAGE LABORATORIES PRIVATE LIMITED",
"EBEN TELECOM PRIVATE LIMITED",
"EBENEFITS SUPPORT SERVICES PRIVATE LIMITED",
"EBENEZER INTERNATIONAL SCHOOL",
"EBENEZER MARCUS INTERNATIONAL SCHOOL AND JUNIOR COLLEGE",
"EBENEZER MEDICAL CENTER PRIVATE LIMITED",
"EBENEZER POLYMERS PRIVATE LIMITED",
"EBENEZER PRINTPACK PRIVATE LIMITED",
"EBENEZER TECHNOLOGIES PRIVATE LIMITED",
"EBENUS DESIGN SOLUTIONS PRIVATE LIMITED",
"EBERSPAECHER SUETRAK BUS CLIMATE CONTROL SYSTEMS INDIA PRIVATE LIMITED",
"EBEST MOBILE TECHNOLOGY PRIVATE LIMITED",
"EBIQUITY INDIA PRIVATE LIMITED",
"EBIX SOFTWARE INDIA PRIVATE LIMITED",
"EBIXCASH PRIVATE LIMITED",
"E-BIZ TECHNOCRATS PRIVATE LIMITED",
"EBIZ.COM PRIVATE LIMITED",
"EBIZFILING INDIA PRIVATE LIMITED",
"EBIZNEEDS INDIA BUSINESS SOLUTIONS PRIVATE LIMITED",
"EBIZNET SOLUTIONS PRIVATE LIMITED",
"EBIZON NETINFO PRIVATE LIMITED",
"EBIZTRAIT TECHNOLABS PRIVATE LIMITED",
"EBIZZBOX ONLINE PRIVATE LIMITED",
"EBLAH MARKETING SERVICES PRIVATE LIMITED",
"EBLITZ CREATIONS INDIA PRIVATE LIMITED",
"EBM ECOMMERCE PRIVATE LIMITED",
"EBM PAPST INDIA PRIVATE LIMITED",
"EBMS SOLUTIONS PRIVATE LIMITED",
"EBNER INDIA PRIVATE LIMITED",
"EBONY AUTOMOBILES PRIVATE LIMITED",
"EBONY ESTATES PRIVATE LIMITED",
"EBONY FOODS PRIVATE LIMITED",
"EBONY HOMES PRIVATE LIMITED",
"EBONY TEXTILES PVT LTD",
"EBORN CONSULTING PRIVATE LIMITED",
"EBPL VENTURES PRIVATE LIMITED",
"EBRANDZ LLP",
"EBRANDZ SOLUTIONS",
"EBREEZ SOFTWARE PRIVATE LIMITED",
"E-BRIDGE OUTSOURCING SERVICES INDIA PRIVATE LIMITED",
"EBRO ARMATUREN INDIA PRIVATE LIMITED",
"EBRO INDIA PRIVATE LIMITED",
"EBRO TILDA PRIVATE LIMITED",
"EBSAVVY INFOTECH PRIVATE LIMITED",
"EBSCO INFORMATION SERVICES INDIA PRIVATE LIMITED",
"EBSL AUTOMAT PRIVATE LIMITED",
"EBSLON INFOTECH PRIVATE LIMITED",
"EBSOLUTE TECHNOLOGIES PRIVATE LIMITED",
"EBULLIENT CABLES PRIVATE LIMITED",
"EBULLIENT CONSTRUCTION PRIVATE LIMITED",
"EBULLIENT CONTENT INTERNATIONAL PRIVATE LIMITED",
"EBULLIENT GAMING INDIA PRIVATE LIMITED",
"EBULLIENT PACKAGING PRIVATE LIMITED",
"EBULLIENT SECURITIES PRIVATE LIMITED",
"EBURON LIFE SCIENCES PRIVATE LIMITED",
"EBURON ORGANICS INDIA PRIVATE LIMITED",
"EBUS SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"EBUSINESS DOTCOM PRIVATE LIMITED",
"EBUTOR DISTRIBUTION PRIVATE LIMITED",
"EBZ SYSTEC INDIA PRIVATE LIMITED",
"EC GROUP DATASOFT PRIVATE LIMITED",
"EC INFO SYSTEMS INDIA PRIVATE LIMITED",
"EC INFOSOLUTIONS PRIVATE LIMITED",
"EC SOFTWARE INDIA PRIVATE LIMITED",
"ECA GLOBAL EDUCATION INDIA PRIVATE LIMITED",
"ECA INFRASTRUCTURE INDIA PRIVATE LIMITED",
"E-CAARD SOLUTIONS PRIVATE LIMITED",
"ECADEMIC TUBE PRIVATE LIMITED",
"ECAPS COMPUTERS INDIA PRIVATE LIMITED",
"ECARE INDIA PRIVATE LIMITED",
"E-CARGOWARE SOFTWARE PRIVATE LIMITED",
"E-CARS INTERNATIONAL PRIVATE LIMITED",
"ECARTES TECHNOLOGY PRIVATE LIMITED",
"ECAVO AGRO DAILY PRIVATE LIMITED",
"ECCEL EXPORTS PRIVATE LIMITED",
"ECCELLA CONSULTING AND SOFTWARE PRIVATE LIMITED",
"ECCELLENTE SERVICES PRIVATE LIMITED",
"ECCELLENZA INFRA BUILD PRIVATE LIMITED",
"ECCENTRIC ENGINE PRIVATE LIMITED",
"ECCENTRIC ENTERPRISES PRIVATE LIMITED",
"ECCENTRIC LOGISTICS PRIVATE LIMITED",
"ECCITARE TECHNOLOGIES PRIVATE LIMITED",
"ECCO FAST LOGISTIC SOLUTION PRIVATE LIMITED",
"ECCO INDIA TRADING PRIVATE LIMITED",
"ECCO SHOES INDIA PRIVATE LIMITED",
"ECCOSTAR AGRI CARE PRIVATE LIMITED",
"ECDM TECHNOLOGY PRIVATE LIMITED",
"ECE (INDIA) ENERGIES PRIVATE LIMITED",
"ECE INDUSTRIES LIMITED",
"E-CELTIC CONSULTING SERVICES PRIVATE LIMITED",
"ECENTRIC DIGITAL LIMITED",
"ECENTRIC DIGITAL PRIVATE LIMITED",
"ECFY CONSULTING PRIVATE LIMITED",
"ECGC LIMITED",
"ECGIT PRIVATE LIMITED",
"ECGREENS RESORTS PRIVATE LIMITED",
"ECHAAR EQUIPMENTS PRIVATE LIMITED",
"ECHANDA URJA PRIVATE LIMITED",
"ECHARGE MOBILITY PRIVATE LIMITED",
"ECHELON BIZTECH PRIVATE LIMITED",
"ECHELON EDGE PRIVATE LIMITED",
"ECHELON METALS PRIVATE LIMITED",
"E-CHEMEX PRIVATE LIMITED",
"ECHIDNA SOFTWARE PRIVATE LIMITED",
"ECHJAY FORGING INDUSTRIES PRIVATE LIMITED",
"ECHJAY FORGINGS PRIVATE LIMITED",
"ECHJAY INDUSTRIES PRIVATE LIMITED",
"ECHLON CORPORATION PRIVATE LIMITED",
"ECHNOLOGIX TECHNICAL SERVICES PRIVATE LIMITED",
"ECHO AIRGASES PRIVATE LIMITED",
"ECHO ENTERTAINMENT PRIVATE LIMITED",
"ECHO GASES PRIVATE LIMITED",
"ECHO INDIA MANAGED SERVICES PRIVATE LIMITED",
"ECHOBOOOM MANAGEMENT & ENTREPRENEURIAL SOLUTIONS PRIVATE LIMITED",
"ECHOKART ERA PRIVATE LIMITED",
"ECHOPAY PAYMENT SOLUTIONS PRIVATE LIMITED",
"ECHOSTAR TRADING PRIVATE LIMITED",
"ECHS HEALTHCARE SERVICES PRIVATE LIMITED",
"ECHS POLYCLINIC BULANDSHAHR",
"ECHS POLYCLINIC MATHURA",
"ECHT CONGLOMERATE PRIVATE LIMITED",
"ECHT FINANCE LIMITED",
"ECHT TECH CONSULTANCY SERVICES PRIVATE LIMITED",
"ECI AGROCHEM PVT LTD",
"ECI INDIA MANAGERS PRIVATE LIMITED",
"ECI SYSTEMS PRIVATE LIMITED",
"ECI TELECOM INDIA PRIVATE LIMITED",
"ECIFM SOLUTIONS INDIA PRIVATE LIMITED",
"ECIL RAPISCAN LIMITED",
"E-CITY BIOSCOPE ENTERTAINMENT PRIVATE LIMITED",
"E-CITY DIGITAL CINEMAS BOMBAY PRIVATE LIMITED",
"E-CITY INVESTMENTS AND HOLDINGS COMPANY PRIVATE LIMITED",
"E-CITY PROJECTS CONSTRUCTION PRIVATE LIMITED",
"E-CITY PROJECTS LUCKNOW PRIVATE.LIMITED",
"E-CITY PROPERTY MANAGEMENT & SERVICES PRIVATE LIMITED",
"ECKLECTIC INTERNATIONAL PRIVATE LIMITED",
"ECKO CABLES PVT LTD",
"ECKSTEIN ENGINEERING BUSINESS SOLUTIONS PRIVATE LIMITED",
"ECL MAGTRONICS PRIVATE LTD.",
"ECL PUYVAST (INDIA) PRIVATE LIMITED",
"E-CLASS EDUCATION SYSTEM LIMITED",
"ECLAT DEVELOPERS PRIVATE LIMITED",
"ECLAT DIAMONDS PRIVATE LIMITED",
"ECLAT ENGINEERING PRIVATE LIMITED",
"ECLAT HEALTH SOLUTIONS (INDIA) PRIVATE LIMITED",
"ECLAT INFOCOM PRIVATE LIMITED",
"ECLAT INFOTECH PRIVATE LIMITED",
"ECLAT NET ADVISORS PRIVATE LIMITED",
"ECLAT PHARMA AND AEROSOLS PVT LTD",
"ECLECTIC FOODS PRIVATE LIMITED",
"ECLECTIC MIND LABS PRIVATE LIMITED",
"ECLERX SERVICES LIMITED",
"ECLERY",
"ECLEVA PRIVATE LIMITED",
"ECLICK SOFTWARE AND SOLUTIONS PRIVATE LIMITED",
"ECLINICAL SOLUTIONS INDIA PRIVATE LIMITED",
"ECLINICALWORKS INDIA PRIVATE LIMITED",
"ECLIPSE COMBUSTION PRIVATE LIMITED",
"ECLIPSE GLOBAL PRIVATE LIMITED",
"ECLIPSE INFOTECH SERVICES INDIA PRIVATE LIMITED",
"ECLIPSE PRISM MEDICAL DEVICES PRIVATE LIMITED",
"ECLIPSE TRADES PVT.LTD.",
"ECLL PRIVATE LIMITED",
"ECLOUD SYSTEM INDIA PRIVATE LIMITED",
"ECLOUDACC SUPPORT SERVICES PRIVATE LIMITED",
"E-CLUB VIZAG PRIVATE LIMITED",
"ECM FURNACE INDIA PRIVATE LIMITED",
"ECM LOGISTICS PRIVATE LIMITED",
"ECMAS CONSTRUCTION CHEMICALS PRIVATE LIMITED",
"ECMAS RESINS PVT LTD",
"ECO 365 PRIVATE LIMITED",
"ECO ADVANCED POLYTECH INDIA PRIVATE LIMITED",
"ECO AGRI SEEDS PRIVATE LIMITED",
"ECO BIRDD RECYCLING COMPANY PRIVATE LIMITED",
"ECO CANE SUGAR ENERGY LIMITED",
"ECO CAR RENTAL SERVICES PRIVATE LIMITED",
"ECO CARE ENGINEERING PRIVATE LIMITED",
"ECO CEMENT INDIA LIMITED",
"ECO CEMENTS LIMITED",
"ECO CHIMNEYS PRIVATE LIMITED",
"ECO CLAY SOLUTIONS PRIVATE LIMITED",
"ECO CLIMATIC SOLUTIONS PRIVATE LIMITED",
"ECO CONSULTANT SERVICES",
"ECO CRYSTAL PRIVATE LIMITED",
"ECO DRILLING FLUIDS PRIVATE LIMITED",
"ECO EMARKET PRIVATE LIMITED",
"ECO EXPEDITIONS & TOURS PRIVATE LIMITED",
"ECO EXPORT",
"ECO FILTERS PRIVATE LIMITED",
"ECO FLEX & ROPES PRIVATE LIMITED",
"ECO FLY E WASTE RECYCLING PRIVATE LIMITED",
"ECO FOREX AND TRAVELS PRIVATE LIMITED",
"ECO FRIENDLY FOOD PROCESSING PARK LIMITED",
"ECO FUEL SYSTEMS (INDIA )PRIVATE LIMITED",
"ECO GREEN AAC PRODUCTS PRIVATE LIMITED",
"ECO GREEN LABS INDIA PRIVATE LIMITED",
"ECO GREEN PAPER PRODUCTS PRIVATE LIMITED",
"ECO GREEN PRODUCTS PRIVATE LIMITED",
"ECO GREEN RECYCLING PRIVATE LIMITED",
"ECO GREEN SOLUTION SYSTEMS PRIVATE LIMITED",
"ECO GUARD TECHNOLOGIES PRIVATE LIMITED",
"ECO HEALTH PRODUCTS PRIVATE LIMITED",
"ECO INDIA PRIVATE LIMITED",
"ECO INNOVATIVE SOLUTIONS PRIVATE LIMITED",
"ECO JUTE PRIVATE LIMITED",
"ECO LOGISTICS SOLUTIONS PRIVATE LIMITED",
"ECO MED LIFESCIENCES PRIVATE LIMITED",
"ECO MED TECHNOLOGIES PRIVATE LIMITED",
"ECO MITRA SOLAR PRIVATE LIMITED",
"ECO NUTRITION PRIVATE LIMITED",
"ECO PACK PRIVATE LIMITED",
"ECO PAPERS (INDIA) PRIVATE LIMITED",
"ECO PARYAVARAN",
"ECO PET INDUSTRIES LLP",
"ECO PLUS PRECAST PRIVATE LIMITED",
"ECO POLYCHEM PRIVATE LIMITED",
"ECO POLYMERS PRIVATE LIMITED",
"ECO POLYPET PRIVATE LIMITED",
"ECO POWER PRIVATE LIMITED",
"ECO PROTECTION ENGINEERS PRIVATE LIMITED",
"ECO REALTIES PRIVATE LIMITED",
"ECO RECYCLING LIMITED",
"ECO ROOTS FOODS INDIA PRIVATE LIMITED",
"ECO SERVICES INDIA PRIVATE LIMITED",
"ECO SMART VEHICLES PRIVATE LIMITED",
"ECO STETISTICS DEPT- GOVT RAJ",
"ECO TASAR SILK PRIVATE LIMITED",
"ECO TEACH FOUNDATION",
"ECO TECH CASTINGS INDIA PRIVATE LIMITED",
"ECO TECH COAL INDUSTRIES PRIVATE LIMITED",
"ECO TECH LABS PRIVATE LIMITED",
"ECO TECH PAPERS",
"ECO TECH SOFTWARE PRIVATE LIMITED",
"ECO TECHFAB PRIVATE LIMITED",
"ECO TECHNOLOGY PRIVATE LIMITED",
"ECO TEXTILE MILLS PRIVATE LIMITED",
"ECO TOOL ROOM PVT LTD",
"ECO TREES INDIA PRIVATE LIMITED",
"ECO TURNKEY SOLUTIONS PRIVATE LIMITED",
"ECO WATER SOLUTIONS TECHNOLOGIES PRIVATE LIMITED",
"ECO WIRES PRIVATE LIMITED",
"ECO-ADDITIVES INDIA PRIVATE LIMITED",
"ECO-AGRIPRENEURS PRIVATE LIMITED",
"ECOAIR COOLING SYSTEMS PRIVATE LIMITED",
"ECOAQUA ENGINEERING SYSTEMS PRIVATE LIMITED",
"ECOAXIS SYSTEMS PRIVATE LIMITED",
"ECOBAGS EXIM PRIVATE LIMITED",
"ECOBHARAT BIOFUEL ENERGY PRIVATE LIMITED",
"ECOBLISS INDIA PRIVATE LIMITED",
"ECOBOARD INDUSTRIES LIMITED",
"ECOBRILLIANCE PRIVATE LIMITED",
"ECO-CARE BUILDING INNOVATIONS PRIVATE LIMITED",
"ECO-CARE BUILDING MATERIALS PRIVATE LIMITED",
"ECOCARE FOODS PRIVATE LIMITED",
"ECOCARE INFRASTRUCTURES PRIVATE LIMITED",
"ECO-CARE MINERALS PRIVATE LIMITED",
"ECOCARE PROCESSING PRIVATE LIMITED",
"ECOCARE TECHSERVE PRIVATE LIMITED",
"ECOCARE VENTURE PRIVATE LIMITED",
"ECOCAT INDIA PRIVATE LIMITED",
"ECO-CENTRIC MANAGEMENT PRIVATE LIMITED",
"ECOCERT INDIA PRIVATE LIMITED",
"ECOCHARCOAL & SPICES INDIA PRIVATE LIMITED",
"ECO-CHEM LABORATORIES PRIVATE LIMITED",
"ECOCIATE CONSULTANTS PRIVATE LIMITED",
"ECOCLAD BUILDSYS PRIVATE LIMITED",
"ECOCLEAN MACHINES PRIVATE LIMITED",
"ECOCLEAN SYSTEMS AND SOLUTIONS",
"ECOCLOUD SERVICES PRIVATE LIMITED",
"ECODEA PROJECTS & CONTROL PRIVATE LIMITED",
"ECODUR WINDOORS PRIVATE LIMITED",
"ECOEARTH SOLUTIONS PRIVATE LIMITED",
"ECOEAT INDIA PRIVATE LIMITED",
"ECOENERGY INSIGHTS LIMITED",
"ECOF INDUSTRIES PRIVATE LIMITED",
"ECOFINE COLOURCHEM PRIVATE LIMITED",
"ECOFINE TREAT WOODS PRIVATE LIMITED",
"ECOFIRST SERVICES LIMITED",
"ECOFLECTION PRIVATE LIMITED",
"ECOFLO SYSTEMS PRIVATE LIMITED",
"ECOFOLD INDUSTRIES PRIVATE LIMITED",
"ECOFOOTFORWARD ENVIRONMENTAL CONSULTANCY AND ENGINEERS PRIVATE LIMITED",
"ECOFORGE ADVISORS PRIVATE LIMITED",
"ECOFRESH COLD STORAGE & WAREHOUSING PRIVATE LIMITED",
"ECOFRIEND CARBON PRIVATE LIMITED",
"ECO-FRIENDLY BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"ECOFRIENDLY CORPACK PRIVATE LIMITED",
"ECO-FRIENDLY INFRA TECHNOLOGY PRIVATE LIMITED",
"ECOFROST TECHNOLOGIES PRIVATE LIMITED",
"ECOGAS IMPEX PRIVATE LIMITED",
"ECOGENICS SOLUTIONS PRIVATE LIMITED",
"ECOGLOBE PACKAGING PRIVATE LIMITED",
"ECOGOLD SOLAR PRODUCTS & SYSTEMS PRIVATE LIMITED",
"ECOGREEN CLEANTECH PRIVATE LIMITED",
"ECOGREEN COIR INDIA PRIVATE LIMITED",
"ECOGREEN ENVIROTECH SOLUTIONS LIMITED",
"ECOGREEN HVAC SYSTEMS PRIVATE LIMITED",
"ECOGREEN IDEAS PRIVATE LIMITED",
"ECOGREEN LANDSCAPE TECHNOLOGIES INDIA PRIVATE LIMITED",
"ECOGUARD PEST CONTROL PRIVATE LIMITED",
"ECOINDIA ELECTROMECH PRIVATE LIMITED",
"ECOINSIGHT BUILDING SOFTWARE SOLUTIONS PRIVATE LIMITED",
"ECOKART TECHNOLOGY PRIVATE LIMITED",
"ECOKEM TECHNOLOGIES PRIVATE LIMITED",
"ECOKRIN HYGIENE PRIVATE. LIMITED",
"ECOLAB GLOBAL SERVICES PRIVATE LIMITED",
"ECOLAB FOOD SAFETY & HYGIENE SOLUTIONS PRIVATE LIMITED",
"ECOLAB INC.",
"ECOLASTIC PRODUCTS PRIVATE LIMITED",
"ECOLE FRANCAISE INTERNATIONAL DE BOMBAY",
"ECOLE GLOBALE INTERNATIONAL GIRLS SCHOOL",
"ECOLE INTUIT LAB EDUCATION PRIVATE LIMITED",
"ECOLEAF ENERGIES PRIVATE LIMITED",
"ECOLED ILLUMINATIONS PRIVATE LIMITED",
"E-COLI WASTE MANAGEMENT PRIVATE LIMITED",
"ECOLIBRIUM ENERGY PRIVATE LIMITED",
"ECOLIFEGREEN SERVICES PRIVATE LIMITED",
"ECOLINE AUTO SYSTEMS PRIVATE LIMITED",
"ECOLINE EXIM PRIVATE LIMITED",
"ECOLINE INFRA PRIVATE LIMITED",
"ECOLITE WIRE PRIVATE LIMITED",
"ECOLOGICA FIBRES PRIVATE LIMITED",
"ECOLOGICAL LABORATORIES PRIVATE LIMITED",
"ECOLOGICS INDIA PRIVATE LIMITED",
"ECOLUTIONS OUTSOURCING PRIVATE LIMITED",
"ECOLUX INDIA PRIVATE LIMITED",
"ECOLUXE POWER SOLUTIONS PRIVATE LIMITED",
"ECO-LUXURIA DEVELOPERS PRIVATE LIMITED",
"ECOM COMMODITIES INDIA PRIVATE LIMITED",
"ECOM EXPRESS LIMITED",
"E-COM SHIPPING SOLUTIONS PRIVATE LIMITED",
"ECOM SOLVER PRIVATE LIMITED",
"ECOM SUPPORT PRIVATE LIMITED",
"ECOMAISTER BEADS INDIA PRIVATE LIMITED",
"ECOMAK SYSTEMS PRIVATE LIMITED",
"ECOMAN ENVIRO SOLUTIONS PRIVATE LIMITED",
"ECOMARK GENERAL FINANCE AND LEASING LIMITED",
"ECOMATE ENERGY SOLUTIONS",
"ECOMATRIX NUTRIENTS PRIVATE LIMITED",
"ECOMECH TECHNOLOGIES PRIVATE LIMITED",
"ECOMED TECHNOLOGIES PRIVATE LIMITED",
"ECOMELECTRON PRIVATE LIMITED",
"ECOMEN LABORATORIES PRIVATE LIMITED",
"ECOMETRIC SURFACE FINISHES PRIVATE LIMITED",
"ECOMETRIX CONSULTANTS PRIVATE LIMITED",
"ECOMITRAM SUSTAINABLE SOLUTIONS PRIVATE LIMITED",
"ECOMMERCE CONSULTANTS PRIVATE LIMITED",
"E-COMMERCE CONSULTANTS PRIVATE LIMITED",
"ECOMOTEL HOTEL LIMITED",
"E-COMPUSELL PRIVATE LIMITED",
"ECOMS METALLURGICALS PRIVATE LIMITED",
"ECON ANTRI LIMITED",
"ECON CYLINDERS PRIVATE LIMITED",
"ECON ELECTRO PVT LTD",
"ECON HEALTHCARE PRIVATE LIMITED",
"ECON LIFE SCIENCE PRIVATE LIMITED",
"ECON MACHINERY PRIVATE LIMITED",
"ECON METALLIC INDIA PRIVATE LIMITED",
"ECON ONE RESEARCH INDIA PRIVATE LIMITED",
"ECON WASTE MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"ECONATURAL CHEMFUEL PRIVATE LIMITED",
"ECONEX PRODUCTS INDIA PRIVATE LIMITED",
"ECONO BROKING PRIVATE LIMITED",
"ECONO MEDICAL PRIVATE LIMITED",
"ECONO TRADE (INDIA) LTD",
"ECONOLYTICS CONSULTANCY PRIVATE LIMITED",
"ECONOMIC ADVISOR ECO AND STATISTICAL ORGANIZATION",
"ECONOMIC AND ENTREPRENEURSHIP DEVELOPMENT FOUNDATION",
"ECONOMIC CARGO PRIVATE LIMITED",
"ECONOMIC EXPLOSIVES LIMITED",
"ECONOMIC FOOD SOLUTIONS PRIVATE LIMITED",
"ECONOMIC FORGE PVT LTD",
"ECONOMIC FREIGHT CARRIERS LIMITED",
"ECONOMIC GLASS HOUSE PVT LTD",
"ECONOMIC LOGISTIC LIMITED",
"ECONOMIC RESEARCH INDIA PRIVATE LIMITED",
"ECONOMIC RETAIL PRIVATE LIMITED",
"ECONOMIC TRANSPORT ORGANIZATION LIMITED.",
"ECONOMICAL LIFE FREEDOM PRIVATE LIMITED",
"ECONOMIZER SERVICES PRIVATE LIMITED",
"ECONOMMERCE VENTURE PRIVATE LIMITED",
"ECONOMODE FOOD EQUIPMENT INDIA PRIVATE LIMITED",
"ECONOMY HOTELS INDIA SERVICES PRIVATE LIMITED ACCOR HOTEL",
"ECONOMY PROCESS SOLUTIONS PRIVATE LIMITED",
"ECONOPACK INDIA PRIVATE LIMITED",
"ECONOPRINT STENCILS PRIVATE LIMITED",
"ECONOVUS PACKAGING PRIVATE LIMITED",
"ECONS CROP PROTECTION PRIVATE LIMITED",
"ECONSHIP MARINE PRIVATE LIMITED",
"ECONSHIP TECH PRIVATE LIMITED",
"ECONSTRUCT DESIGN & BUILD PRIVATE LIMITED",
"ECONTENTI INFOSOLINDIA PRIVATE LIMITED",
"ECONZ IT SERVICE PRIVATE LIMITED",
"ECOPACK INDIA PAPER CUP PRIVATE LIMITED",
"ECOPACK SERVICES PRIVATE LIMITED",
"ECOPEB STEEL STRUCTURE (INDIA) PRIVATE LIMITED",
"ECOPIENS ARECA PLATE PRODUCERS INDIA PRIVATE LIMITED",
"ECOPLAST LIMITED",
"ECOPLUS INDUSTRIES PRIVATE LIMITED",
"ECOPLUS STEELS PRIVATE LIMITED",
"ECOPMIN TECHNOLOGIES PRIVATE LIMITED",
"ECOPOWER SYSTEMS PRIVATE LIMITED",
"ECOPROGETTI PRODUCTION PROCESS INDIA PRIVATE LIMITED",
"ECOPROSUS INDIA PRIVATE LIMITED",
"ECOPURE SPECIALITIES LIMITED",
"ECOR KHURDA ROAD",
"ECORE SYSTEMS PRIVATE LIMITED",
"ECOREA & KURODA ELECTRIC INDIA PRIVATE LIMITED",
"ECO-REL COMPUTER SYSTEMS PRIVATE LIMITED",
"ECOREN ENERGY INDIA PRIVATE LIMITED",
"ECOREN ONE WIND ENERGY PRIVATE LIMITED",
"ECOREX BUILDTECH PRIVATE. LIMITED.",
"ECORGY SOLUTIONS PRIVATE LIMITED",
"ECORIGHT PRIVATE LIMITED",
"ECOS INDIA MOBILITY & HOSPITALITY PRIVATE LIMITED",
"ECOSAFE WASTE MANAGEMENT PRIVATE LIMITED",
"ECOSAN SERVICES FOUNDATION",
"ECOSATTVA ENVIRONMENTAL SOLUTIONS PRIVATE LIMITED",
"ECOSAVE LABS PRIVATE LIMITED",
"ECOSCAPES CONSTRUCTIONS PRIVATE LIMITED",
"ECOSCAPES LANDSCAPING PRIVATE LIMITED",
"ECOSENS LIGHTING PRIVATE LIMITED",
"ECOSENSE SUSTAINABLE SOLUTIONS PRIVATE LIMITED",
"ECOSHOPPE TRADING PRIVATE LIMITED",
"ECOSI ENERGY PRIVATE LIMITED",
"ECOSMOB TECHNOLOGIES PRIVATE LIMITED",
"ECOSOCH SOLAR PRIVATE LIMITED",
"ECOSOFT INDIA PRIVATE LIMITED",
"ECOSOL CRAFT PACK PRIVATE LIMITED",
"ECOSPACE INFRASTRUCTURES PRIVATE LIMITED",
"ECOSPICE INGREDIENTS PRIVATE LIMITED",
"ECOSTAN BIOFUEL PRIVATE LIMITED",
"ECOSTAN INDIA PRIVATE LIMITED",
"ECOSTAR GOEL PROPERTIES LLP",
"ECOSTAR INNOVATION PRIVATE LIMITED",
"ECOSTP TECHNOLOGIES PRIVATE LIMITED",
"ECOSTRUC INFRATECH PRIVATE LIMITED",
"ECOSTRUCT ENGINEERING PRIVATE LIMITED",
"ECOSURE PHARMA PRIVATE LIMITED",
"ECOSURE PULPMOLDING TECHNOLOGIES LIMITED",
"ECOSYS EFFICIENCIES PRIVATE LIMITED",
"ECOSYS INFRATECH PRIVATE LIMITED",
"ECOSYS OOH ADVERTISING PRIVATE LIMITED",
"ECOSYSTEM RESOURCE MANAGEMENT PRIVATE LIMITED",
"ECOSYSTEM VENTURES PRIVATE LIMITED",
"ECOSYSTEMIC (INDIA) PRIVATE LIMITED",
"ECOSYSTM ADVISORY PRIVATE LIMITED",
"ECOTARAS SUSTAINABLE SOLUTIONS PRIVATE LIMITED",
"ECOTECH AQUA-ENVIRO ENGINEERS PRIVATE LIMITED",
"ECOTECH BUILDING SERVICES PRIVATE LIMITED",
"ECOTECH CHUTES PRIVATE LIMITED",
"ECOTECH ENGINEERING CONSULTANCY PRIVATE LIMITED",
"ECOTECH INDUSTRIES PRIVATE LIMITED",
"ECOTECH IT SOLUTIONS PRIVATE LIMITED",
"ECOTECH MONITORING SOLUTIONS PRIVATE LIMITED",
"ECOTECHGREEN ASSOCIATES PRIVATE LIMITED",
"ECOTEQ GREEN ENERGIES FOUNDATION",
"ECOTONE SYSTEMS PRIVATE LIMITED",
"ECOTOPIA PACKAGING PRIVATE LIMITED",
"ECOTRAIL PERSONAL CARE PRIVATE LIMITED",
"ECOTRAILS HOSPITALITY PRIVATE LIMITED",
"ECOVALE INDIA PRIVATE LIMITED",
"ECOVAV INDUSTRIES PRIVATE LIMITED",
"ECOVED TECHNOLOGIES PRIVATE LIMITED",
"ECOVERVA CATCON RECYCLING PRIVATE LIMITED",
"ECOVERVA E-WASTE RECYCLING PRIVATE LIMITED",
"ECOVERVA REFINING PRIVATE LIMITED",
"ECOVINAL INTERNATIONAL PRIVATE LIMITED",
"ECOVIS RKCA ADVISORS LIMITED",
"ECOVORE TABLEWARE PRIVATE LIMITED",
"ECOWALK IMPEX PRIVATE LIMITED",
"ECOWARE SOLUTIONS PRIVATE LIMITED",
"ECOWHITE ARCHITECTURAL ENGINEERING AND TECHNOLOGY SERVICES PRIVATE LIMITED",
"ECOWINGS TABLEWARE PRIVATE LIMITED",
"ECOWISE TRADING PRIVATE LIMITED",
"ECOWOOD DECORE (INDIA) PRIVATE LIMITED",
"ECOWOOD EXPORTS PRIVATE LIMITED",
"ECOZEN SOLUTIONS PRIVATE LIMITED",
"ECP HOUSING (INDIA) PRIVATE LIMITED",
"ECP INDUSTRIES LIMITED",
"ECP LIGHTING SOLUTIONS PRIVATE LIMITED",
"ECP OPTICAL SOLUTIONS PRIVATE LIMITED",
"ECR GROUP OF INSTITUTIONS",
"ECREATE EVENTS PRIVATE LIMITED",
"ECRON ACUNOVA LIMITED",
"E-CROSS VENTURES PRIVATE LIMITED",
"ECRU & BAY TRADING PRIVATE LIMITED",
"ECRU EXPORT PRIVATE LIMITED",
"ECRU LUXURY PRIVATE LIMITED",
"ECS BUSINESS SOLUTIONS PRIVATE LIMITED",
"ECS COMPUTECH PRIVATE LIMITED",
"ECS ENGINEERING (CHD) PRIVATE LIMITED",
"ECS ENGINEERING PRIVATE LIMITED",
"ECS FINANCIAL SERVICES INDIA PRIVATE LIMITED",
"ECS GLOBE AIR CARGO INDIA PRIVATE LIMITED",
"ECS INFOSOLUTIONS PRIVATE LIMITED",
"ECS INFOTECH PRIVATE. LIMITED.",
"ECS PRIVATE LIMITED",
"ECS-ELITE HOSPITALITIES AND CATERING SERVICES PRIVATE LIMITED",
"ECSION RESEARCH LABS PRIVATE LIMITED",
"ECSTASY REALTY PRIVATE LIMITED",
"ECSTATIC MEDIA WORLD PRIVATE LIMITED",
"ECU INTERNATIONAL (ASIA) PRIVATE LIMITED",
"ECUBE CONTROLS PRIVATE LIMITED",
"E-CUBE ENERGY INFRA SERVICES PRIVATE LIMITED",
"ECUBE MEDIA PRIVATE LIMITED",
"ECUBE SALES SOLUTIONS PRIVATE LIMITED",
"ECUMENE HABITAT SOLUTIONS PRIVATE LIMITED",
"ECURE HEALTHCARE PRIVATE LIMITED",
"ECZACIBASI YAPI GERECLERI SANAYI VE TICARET ANONIM SIRKETI",
"ED VENTURES E-LEARNING PRIVATE LIMITED",
"ED&F MAN COMMODITIES INDIA PRIVATE LIMITED",
"EDAC AUTOMATION LIMITED",
"EDAC ENGINEERING LIMITED",
"EDAC SOLUTIONS PRIVATE LIMITED",
"EDAC STAFFING SOLUTION PRIVATE LIMITED",
"EDAG PRODUCTION SOLUTIONS INDIA PRIVATE LIMITED",
"EDAKKARA GOLD PRIVATE LIMITED",
"EDAKKATTUKUDY RESORTS PRIVATE LIMITED",
"EDALA ESTATES PRIVATE LIMITED",
"EDAMANASSERRY SPINE HOSPITAL PRIVATE LIMITED",
"EDAN MEDICAL INDIA PRIVATE LIMITED",
"EDAPPAL HOSPITALS P LTD",
"EDAPPALLY ENGINEERING & CONSTRUCTIONS PRIVATE LIMITED",
"EDARA SIMPLE MEDIA SOLUTIONS PRIVATE LIMITED",
"EDARAN PRECISION INDIA PRIVATE LIMITED",
"EDASSERY ENTERPRISES PRIVATE LIMITED",
"EDASSERY GROUP OF HOTELS PRIVATE LIMITED",
"EDATA GLOBAL SERVICES PRIVATE LIMITED",
"EDATHADAN GRANITES",
"EDATHALA PLY AND BOARDS PRIVATE LIMITED",
"EDATHALA POLYMERS PVT LTD",
"EDAYAR ZINC LIMITED",
"EDC CREATIVE TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"EDC ENGINEERING DESIGN CENTER INDIA PRIVATE LIMITED",
"EDC LIMITED",
"EDCAST ASIA PRIVATE LIMITED",
"EDCIL INDIA LIMITED",
"EDCONS (MKS) CASTINGS PVT LTD",
"EDCONS EXPORTS PRIVATE LIMITED",
"EDCONS FASHIONS PRIVATE LIMITED",
"EDDY BUILDERS PRIVATE LIMITED",
"EDDY CURRENT CONTROLS INDIA LTD",
"EDDY ELECTROMECH PRIVATE LIMITED",
"EDEL FINANCE COMPANY LIMITED",
"EDEL INVESTMENTS LIMITED",
"EDEL LAND LIMITED",
"EDEL TECH PRIVATE LIMITED",
"EDELCAP SECURITIES LIMITED",
"EDELGIVE FOUNDATION",
"EDELMAN INDIA PRIVATE LIMITED",
"EDELMANN PACKAGING INDIA PRIVATE LIMITED",
"EDELWEISS AGRI VALUE CHAIN LIMITED",
"EDELWEISS ALTERNATIVE ASSET ADVISORS LIMITED",
"EDELWEISS ASSET MANAGEMENT LIMITED",
"EDELWEISS BUSINESS SERVICES LIMITED",
"EDELWEISS CAPITAL MARKETS LIMITED",
"EDELWEISS COMMODITIES SERVICES LIMITED",
"EDELWEISS COMTRADE LIMITED",
"EDELWEISS CUSTODIAL SERVICES LIMITED",
"NUVAMA WEALTH FINANCE LIMITED",
"EDELWEISS FINANCIAL SERVICES LIMITED",
"EDELWEISS GLOBAL WEALTH MANAGEMENT LIMITED",
"EDELWEISS INSURANCE BROKERS LIMITED",
"EDELWEISS INVESTMENT ADVISER LIMITED",
"EDELWEISS LIFECARE PRIVATE LIMITED",
"EDELWEISS RETAIL FINANCE LIMITED",
"EDELWEISS RURAL & CORPORATE SERVICES LIMITED",
"EDELWEISS SECURITIES AND INVESTMENTS PRIVATE LIMITED",
"EDELWEISS SECURITIES LIMITED",
"EDELWEISS LIFE INSURANCE COMPANY LIMITED",
"EDELYTICS DIGITAL COMMUNICATIONS PRIVATE LIMITED",
"EDEN CRITICAL CARE HOSPITAL PRIVATE LIMITED",
"EDEN HEALTH CARE PRIVATE LIMITED",
"EDEN HOSPITAL",
"EDEN INFOSOL PRIVATE LIMITED",
"EDEN INNOVATIONS INDIA PRIVATE LIMITED",
"EDEN LOGISTICS PRIVATE LIMITED",
"EDEN MEDIA PRIVATE LIMITED",
"EDEN MOTORS LIMITED",
"EDEN MUMBAI SOLAR PRIVATE LIMITED",
"EDEN REAL ESTATES PRIVATE LIMITED",
"EDEN REALTORS PRIVATE LIMITED",
"EDEN REALTY VENTURES PRIVATE LIMITED",
"EDEN RENEWABLE CITE PRIVATE LIMITED",
"EDEN RENEWABLE RANJI PRIVATE LIMITED",
"EDEN RENEWABLES INDIA LLP",
"EDEN RESIDENCY PRIVATE LIMITED",
"EDEN SAREES PRIVATE LIMITED",
"EDEN SOLAR ENERGY GURGAON PRIVATE LIMITED",
"EDEN SOLAR RAJDHANI PRIVATE LIMITED",
"EDEN SPORTS PRIVATE LIMITED",
"EDEN VINIMAY PVT. LTD.",
"EDENCE LIFE SCIENCES PRIVATE LIMITED",
"EDENRED INDIA PRIVATE LIMITED",
"EDENWELL THERAPEUTICS PRIVATE LIMITED",
"EDER LABS R&D PRIVATE LIMITED",
"EDERNITY INITIATIVES PRIVATE LIMITED",
"EDESK BPO SERVICES",
"EDF INDIA PRIVATE LIMITED",
"EDF JUICES PRIVATE LIMITED",
"EDF RENEWABLES INDIA FINANCING PRIVATE LIMITED",
"EDFORA INFOTECH PRIVATE LIMITED",
"EDG CONSULTING ENGINEERS PRIVATE LIMITED",
"EDG PHARMACEUTICALS (INDIA) PRIVATE LIMITED",
"EDGAR EFILE SOLUTIONS PRIVATE LIMITED",
"EDGAR INTERACTIVE PRIVATE LIMITED",
"EDGE 3D TECHNOLOGIES PRIVATE LIMITED",
"EDGE APPARELS PRIVATE. LIMITED.",
"EDGE AUTOMATION PRIVATE LIMITED",
"EDGE BUSINESS SOLUTIONS PRIVATE LIMITED",
"EDGE CORPORATE SERVICES PRIVATE LIMITED",
"EDGE ESERVICES INDIA PRIVATE LIMITED",
"EDGE EXECUTIVE SEARCH PRIVATE LIMITED",
"EDGE FASHIONS",
"EDGE HEALTHCARE PRIVATE LIMITED",
"EDGE IN ASIA RECRUITEMENT PRIVATE LIMITED",
"EDGE INFOTEL PRIVATE LIMITED",
"EDGE INFRASTRUCTURE PRIVATE LIMITED",
"EDGE INSTITUTE FOR FINANCIAL STUDIES PRIVATE LIMITED",
"EDGE MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"EDGE PACKAGING SYSTEMS PRIVATE LIMITED",
"EDGE PHARMA PRIVATE LIMITED",
"EDGE STEELS PRIVATE LIMITED",
"EDGE STUDIOS PRIVATE LIMITED",
"EDGE TELECOM PRIVATE LIMITED",
"EDGE TELECOMMUNICATIONS PRIVATE LIMITED",
"EDGE TURNKEY SOLUTIONS PRIVATE LIMITED",
"EDGEANDCLOUD (OPC) PRIVATE LIMITED",
"EDGECRAFT SOLUTIONS PRIVATE LIMITED",
"EDGEFLEX ENGINEERING PRIVATE LIMITED",
"EDGEFX TECHNOLOGIES PRIVATE LIMITED",
"EDGE-IN-ASIA RECRUITMENT PRIVATE LIMITED",
"EDGEMAP SOFTWARES PRIVATE LIMITED",
"EDGERISE GLOBAL PRIVATE LIMITED",
"EDGETECH AIR SYSTEMS PRIVATE LIMITED",
"EDGETECH SCIENTIFIC PRIVATE LIMITED",
"EDGEVERVE SYSTEMS LIMITED",
"EDGEWISE TECHNOLOGIES PRIVATE LIMITED",
"EDHAYAM FROZEN FOODS PRIVATE LIMITED",
"EDI BUILDERS PRIVATE LIMITED",
"EDI ENTERPRISE PRIVATE LIMITED",
"EDI PACKAGES DELIVERY SERVICES PRIVATE LIMITED",
"EDI5 SOLUTIONS PRIVATE LIMITED",
"EDIBLE AGRO PRODUCTS LIMITED",
"EDIBLE PRODUCTS INDIA LIMITED",
"EDIBLE ROUTES PRIVATE LIMITED",
"EDICON MINING EQUIPMENT PRIVATE LIMITED",
"EDICON PAPER PRODUCT PRIVATE LIMITED",
"EDICON PNEUMATIC TOOL CO. PRIVATE LIMITED",
"E-DICTATE IT SOLUTIONS PRIVATE LIMITED",
"EDIFAB INFRASTRUCTURE PRIVATE LIMITED",
"EDIFECS TECHNOLOGIES PRIVATE LIMITED",
"EDIFICE BHARAT PRIVATE LIMITED",
"EDIFICE CONSULTANTS PRIVATE LIMITED",
"EDIFICE ENGINEERING ENTERPRISE PVT LTD",
"EDIFICE FINCAP PRIVATE LIMITED",
"EDIFICE PROJECTS PRIVATE LIMITED",
"EDIFICE SOLUTIONS PRIVATE LIMITED",
"EDIFIXIO INDIA PRIVATE LIMITED",
"EDIFY CONSTRUCTIONS PRIVATE LIMITED",
"EDIFY CONSULTANTS PRIVATE LIMITED",
"EDIFY INSURANCE BROKERS PRIVATE LIMITED",
"EDIFY SCHOOL",
"EDIFY TECHNOLOGIES INDIA PRIVATE LIMITED",
"EDIFY WORLD SCHOOL",
"EDIFY WORLD SCHOOL DEHRADUN",
"EDIGISERVE INDIA PRIVATE LIMITED",
"EDII KILLIKULAM AGRIBUSINESS INCUBATION FORUM",
"EDILA BUSINESS WORLD PRIVATE LIMITED",
"EDILE ENGINEERING PRIVATE LIMITED",
"EDIQUE SOLUTIONS PRIVATE LIMITED",
"EDISHER SPECIALITIES PRIVATE LIMITED",
"EDISN MEDIA AND TECH SOLUTIONS PRIVATE LIMITED",
"EDISON EDUCATION PRIVATE LIMITED",
"EDISON G AGORAM MEMORIAL SCHOOL",
"EDISON GENTECH PRIVATE LIMITED",
"EDISON INTERNATIONAL",
"EDISONBRO SMART LABS PRIVATE LIMITED",
"EDISONS INFRAPOWER & MULTIVENTURES PRIVATE LIMITED",
"EDIT 25 LIFESTYLE PRIVATE LIMITED",
"EDIT SYSTEMS PRIVATE LIMITED",
"EDITFX STUDIOS PRIVATE LIMITED",
"EDITORIALIST YX INDIA PRIVATE LIMITED",
"EDITORJI TECHNOLOGIES PRIVATE LIMITED",
"EDIT-PLACE INDIA PRIVATE LIMITED",
"EDIZEL BIOFUELS PRIVATE LIMITED",
"EDIZI TOOLS PRIVATE LIMITED",
"EDJEN RESEARCH LABS LIMITED",
"EDKAL TECHNOLOGIES PRIVATE LIMITED",
"EDKEM PHARMACEUTICALS LIMITED",
"EDMAC ENGINEERING CONSULTANT (INDIA) PRIVATE LIMITED",
"EDMI INDIA PRIVATE LIMITED",
"EDMUND HEALTHCARE PRIVATE LIMITED",
"EDMUND OPTICS INDIA PRIVATE LIMITED",
"EDNET CONSULTANTS PRIVATE LIMITED",
"EDNIT SOFTWARE PRIVATE LIMITED",
"EDNS SOLUTIONS PRIVATE LIMITED",
"EDOC LIFE SCIENCES PRIVATE LIMITED",
"EDOCS SOLUTIONS PRIVATE LIMITED",
"EDOMOTICS SMART SYSTEMS PRIVATE LIMITED",
"EDP SOFTWARE LIMITED",
"EDPULSE EDUCATION TECHNOLOGY PRIVATE LIMITED",
"EDR CONTINUOUS INFORMATION PRIVATE LIMITED",
"EDREAMS EDUSOFT PRIVATE LIMITED",
"EDREAMZ TECHNOLOGIES PRIVATE LIMITED",
"EDS AGRO INDIA PRIVATE LIMITED",
"EDS INTERNATIONAL PRIVATE LIMITED",
"EDS TECHNOLOGIES PRIVATE LIMITED",
"EDSANTA EDUCATION PRIVATE LIMITED",
"EDSCIENCE KNOWLEDGE SOLUTIONS PRIVATE LIMITED",
"EDSHOP TECHNOLOGY PRIVATE LIMITED",
"EDSIX BRAINLAB PRIVATE LIMITED",
"EDSTEM TECHNOLOGIES PRIVATE LIMITED",
"EDTECH ILLUMINATE INDIA PRIVATE LIMITED",
"EDTIA SOLUTIONS PRIVATE LIMITED",
"EDU ASIA PRE-UNIVERSITY COLLEGE",
"EDU SOLUTIONS CONSULTANCY PRIVATE LIMITED",
"EDU VANTAGE PRIVATE LIMITED",
"EDUAIMS EDUCATIONAL SERVICES PRIVATE LIMITED",
"EDUAURAA TECHNOLOGIES PRIVATE LIMITED",
"EDUBOOKS SOLUTIONS PRIVATE LIMITED",
"EDUBRIDGE LEARNING PRIVATE. LIMITED",
"EDUBRISK KNOWLEDGE SOLUTIONS PRIVATE LIMITED",
"EDUCAMPUS TECHNOLOGIES",
"EDUCARE KNOWLEDGE INDIA PRIVATE LIMITED",
"EDUCATION BRANCH DISTRICT PANCHAYAT JAMNAGAR",
"EDUCATION CAREER FOUNDATION",
"EDUCATION CULTURE PRIVATE LIMITED",
"EDUCATION DEPARTMENT",
"EDUCATION DEPARTMENT COMMISSIONER OF SCHOOLS GANDHINAGAR",
"EDUCATION DEPARTMENT GUJARAT UTTAR BUNIYADI VIDYALAYA",
"EDUCATION DEPARTMENT OF TELANGANA",
"EDUCATION DEPARTMENT OFFICE OF THE PRINCIPAL G.H.S.S. KONDPALI",
"EDUCATION DEPARTMENT P S SHIRALA",
"EDUCATION DESIGN ARCHITECTS INDIA PRIVATE LIMITED",
"EDUCATION OFFICE OF THE PRINCIPAL",
"EDUCATION OFFICER CONTINUING EDUCATION ZILLA PARISHAD NAGPUR",
"EDUCATION PRINCIPAL GOVT. HIGHER SECONDARY SCHOOL KOSIR",
"EDUCATION PRINCPLE GHSS DATOUD SAKTI",
"EDUCATION RESEARCH AND DEVELOPMENT FOUNDATION",
"EDUCATIONAL SECTOR",
"EDUCATOR EXTRAORDINAIRE LIMITED",
"EDUCFC INTERNATIONAL INSTITUTE OF ENGINEERING & MANAGEMENT PRIVATE LIMITED",
"EDUCO INTERNATIONAL INDIA PRIVATE LIMITED",
"EDUCO VENTURES PRIVATE LIMITED",
"EDUCOMP LEARNING PRIVATE LIMITED",
"EDUCTION DEPPT OFFICE OF THE BLOCK EDUCATION",
"EDUCTION DEPPT OFFICER OF THE BLOCK EDUCATION OFFICER RAIGARH",
"EDUEXPERT CONSULTANCY PRIVATE LIMITED",
"EDUFEAT PRIVATE LIMITED",
"EDUFICE EDUCATION SERVICES PRIVATE LIMITED",
"EDUFICE INFRASERVICES PRIVATE LIMITED",
"EDUFIQ TECHNOLOGIES PRIVATE LIMITED",
"EDUFLOW LEARNING SYSTEMS AND PUBLISHERS PRIVATE LIMITED",
"EDUGEM TECHNOLOGIES PRIVATE LIMITED",
"EDUGURU INDIA PRIVATE LIMITED",
"EDUGYAN TECHNOLOGIES PRIVATE LIMITED",
"EDUHUB EDUCATION PRIVATE LIMITED",
"EDUISFUN TECHNOLOGIES PRIVATE LIMITED",
"EDUJOBS ACADEMY PRIVATE LIMITED",
"EDUKEMY SERVICES PRIVATE LIMITED",
"EDUKITE LEARNING SERVICES PRIVATE LIMITED",
"EDUKRITI LEARNING SOLUTIONS PRIVATE LIMITED",
"EDUKUL SOLUTIONS PRIVATE LIMITED",
"EDUKYU PRIVATE LIMITED",
"EDULAB EDUCATIONAL EXCHANGE PRIVATE LIMITED",
"EDULINE PUBLISHERS",
"EDUMENTOR IMPERIAL SPORTS LLP",
"EDUMERGE SOLUTIONS PRIVATE LIMITED",
"EDUMORPHS CONSULTANCY SERVICES PRIVATE LIMITED",
"EDUMYSTIC VENTURES INDIA PRIVATE LIMITED",
"EDUNCLE INDIA PRIVATE LIMITED",
"EDUNET FOUNDATION",
"EDUNETWORK PRIVATE LIMITED.",
"EDUNEXT TECHNOLOGIES PRIVATE LIMITED",
"EDUNNOVATE TECHNOLOGIES PRIVATE LIMITED",
"EDUNOVA SCIENCE HIGHER SECONDARY SCHOOL",
"EDUONIX LEARNING SOLUTIONS PRIVATE LIMITED",
"EDUPATH AND INFRASTRUCTURE SERVICES PRIVATE LIMITED",
"EDUPLEX SOLUTIONS PRIVATE LIMITED",
"EDUPOINT SERVICES PRIVATE LIMITED",
"EDUPOLIS TECHNOLOGIES PRIVATE LIMITED",
"EDUPORT ACADEMIC RESEARCH CENTER (OPC) PRIVATE LIMITED",
"EDUPORT DISTRIBUTORS PRIVATE LIMITED",
"EDUPORT GLOBAL PRIVATE LIMITED",
"EDUPULSE MEDIA PRIVATE LIMITED",
"EDUQUITY CAREER TECHNOLOGIES PRIVATE LIMITED",
"EDURA PHARMACEUTICALS PRIVATE LIMITED",
"EPACK PETROCHEM SOLUTIONS PRIVATE LIMITED",
"EDURAMP LEARNING SERVICES PRIVATE LIMITED",
"EDUREV LEARNING PRIVATE LIMITED",
"EDURISER LEARNING SOLUTIONS PRIVATE LIMITED",
"EDUSKILLS TRAINING AND DEVELOPMENT PRIVATE LIMITED",
"EDUSMART ACADEMY PRIVATE LIMITED",
"EDUSOFT HEALTHCARE PRIVATE LIMITED",
"EDUSPARK INTERNATIONAL PRIVATE LIMITED VIBGYOR GROUP ENTITY",
"EDUSTAN PRIVATE LIMITED",
"EDUSTOKE PRIVATE LIMITED",
"EDUSTREAM SOFTWARE PRIVATE LIMITED",
"EDUSUCCESS KNOWLEDGE SYSTEMS PRIVATE LIMITED",
"EDUSYNC SOLUTIONS PRIVATE LIMITED",
"EDUSYS SERVICES PRIVATE LIMITED",
"EDUTECH INDIA PRIVATE LIMITED",
"EDUTECH NTTF INDIA PRIVATE LIMITED-CORP",
"EDUTEL TECHNOLOGIES PRIVATE LIMITED",
"EDUTEST SOLUTIONS PRIVATE LIMITED",
"EDUTOR TECHNOLOGIES INDIA PRIVATE LIMITED",
"EDUTREE PUBLISHERS PRIVATE LIMITED",
"EDUVANTAGE LEARNING SOLUTIONS PRIVATE LIMITED",
"EDUVISION TRADERS AND PRINTERS PRIVATE LIMITED",
"EDUWAY ACADEMY PRIVATE LIMITED",
"EDUWIZARDS INFOSOLUTIONS PRIVATE LIMITED",
"EDVANCE PRE-SCHOOLS PRIVATE LIMITED",
"EDVANCER EDUVENTURES PRIVATE LIMITED",
"EDVANTA TECHNOLOGIES PRIVATE LIMITED",
"EDVANTAGE POINT TECHNOLOGIES PRIVATE LIMITED",
"EDVANTECH SOLUTIONS PRIVATE LIMITED",
"EDVEN SOFT SOLUTIONS INDIA PRIVATE LIMITED",
"EDVENSWA TECH PRIVATE LIMITED",
"EDVENTURE SOFTWARE PRIVATE LIMITED",
"EDVEON TECHNOLOGIES PRIVATE LIMITED",
"EDVOY TECHNOLOGIES PRIVATE LIMITED",
"EDWARD FOOD RESEARCH AND ANALYSIS CENTRE LIMITED.",
"EDWARD KEVENTER PRIVATE LIMITED",
"EDWARDS INDIA PRIVATE LIMITED",
"EDWARDS LIFESCIENCES INDIA PRIVATE LIMITED",
"EDWISE CONSULTANTS PRIVATE LIMITED",
"EDWISE INTERNATIONAL LLP",
"EDX ELECTRONICS PRIVATE LIMITED",
"EDYMAX LIFESCIENCES PRIVATE LIMITED",
"EDZINO DIGITECH PRIVATE LIMITED",
"EE LIGHT MACHINARY TUBEWELL AND GATES",
"EE LIGHT MACHINERY TUBE WELL AND GATES E/M DN WRD BHOPAL",
"EE PHE DEWAS",
"EE PHE DIV VIDISHA",
"EE PHE MAINTENANCE DN 1",
"EE PWD E AND M",
"EE RES NO 1 CHHINDWARA",
"EE WATER RESOURCES DEWAS",
"EE WRD SATNA",
"EECO INSTAPOWER PRIVATE LIMITED",
"EECOGREEN INFRATECH PRIVATE LIMITED",
"E-EDIT INFOTECH PRIVATE LIMITED",
"EEE ENERGY PRIVATE LIMITED",
"EEE-TAXI MOBILITY SOLUTIONS PRIVATE LIMITED",
"EEETECH INFONET PRIVATE LIMITED",
"EEFCO METALS & POWDERS PRIVATE LIMITED.",
"EEGEEBUILD INDIA PRIVATE LIMITED",
"EEJAK HOLDINGS PRIVATE LIMITED",
"EEKI AUTOMATION PRIVATE LIMITED",
"EEKI FARMS PRIVATE LIMITED",
"EEMA CHEM PRIVATE LIMITED",
"E-EMPHASYS INFOTECH PRIVATE LIMITED",
"EENADU TELEVISION PRIVATE LIMITED",
"EENDEE SALES AND SERVICES PRIVATE LIMITED",
"EENVY MOLDS PRIVATE LIMITED",
"EEPC INDIA",
"EEPEE SOLUTIONS PRIVATE LIMITED",
"EESAAR HEALTHCARE PRIVATE LIMITED",
"EESAVYASA TECHNOLOGIES PRIVATE LIMITED",
"EESBEE SHRADDHA ACADEMY",
"EESBEE SHRADDHA GROUP OF INSTITUTIONS",
"EESHA ELECTROMECH PRIVATE LIMITED.",
"EESHA LIFE CARE PRIVATE LIMITED",
"EESHA MULTISPECIALITY HOSPITAL",
"EESHA PACKAGING",
"EESHAN INDUSTRIES HK LIMITED",
"EESUN ENTERPRISES INDIA PRIVATE LIMITED",
"EETAMAX ENERGY SOLUTIONS PRIVATE LIMITED",
"EETEE CLOTHING PRIVATE LIMITED",
"EEVEE ENGINEERING PRIVATE LIMITED",
"EEWA ENGINEERING COMPANY PRIVATE LIMITED",
"EEZ PACK PRIVATE LIMITED",
"EEZAA FOODS INTERNATIONAL PRIVATE LIMITED",
"EF INFORMATION SYSTEMS PRIVATE LIMITED",
"EF MINING & CONSTRUCTION PRIVATE LIMITED",
"EF SITE TECHNOLOGIES PRIVATE LIMITED",
"E-FAB CABLES PRIVATE LIMITED",
"E-FAB POWER CONTROL PRIVATE LIMITED",
"E-FABRIC HOUSE PRIVATE LIMITED",
"E-FABSEW PRIVATE LIMITED",
"EFACEC INDIA PRIVATE LIMITED",
"EFARM INTERNATIONAL PRIVATE LIMITED",
"EFC (I) LIMITED",
"EFC INFRASTRUCTURES PRIVATE LIMITED",
"EFC LIMITED",
"EFC TECH SPACE PRIVATE LIMITED",
"EFCO MASCHINENBAU INDIA PRIVATE LIMITED",
"EFCOM INFOTECH PRIVATE LIMITED",
"EFD INDUCTION PRIVATE LIMITED",
"EFECO SERVICES PRIVATE LIMITED",
"EFEDRA PHARMACEUTICALS PRIVATE LIMITED",
"EFESO CONSULTING PRIVATE LIMITED",
"EFEV CHARGING SOLUTIONS PRIVATE LIMITED",
"EFF N' BEE HOSPITALITY PRIVATE LIMITED",
"EFFCO FINISHES & TECHNOLOGIES PRIVATE LIMITED",
"EFFECTIVE DIGITAL PRIVATE LIMITED",
"EFFECTIVE ENGINEERS LIMITED",
"EFFECTIVE MAN-TECH PRIVATE LIMITED",
"EFFECTIVE MARKETING PRIVATE LIMITED",
"EFFECTIVE TELE SERVICES PRIVATE LIMITED",
"EFFECTIVE TELESERVICES PRIVATE LIMITED",
"EFFECTRON LUMINEX LIMITED",
"EFFECTRONIC TECHNOLOGY PRIVATE LIMITED",
"EFFECTS MANAGEMENT SERVICES PRIVATE LIMITED",
"EFFECTS TECH SETS PRIVATE LIMITED",
"EFFECTS TECH SLT PRIVATE LIMITED",
"EFFECTUAL INFOTECH PRIVATE LIMITED",
"EFFECTUAL KNOWLEDGE SERVICES PRIVATE LIMITED",
"EFFECTUATE CORPORATE SERVICES PRIVATE LIMITED",
"EFFIA TECHNOLOGIES INDIA PRIVATE LIMITED",
"EFFIASOFT PRIVATE LIMITED",
"EFFICACIOUS",
"EFFICACIOUS ADVISORS PRIVATE LIMITED",
"EFFICACIOUS SECURITY AND LABOUR SERVICES PRIVATE LIMITED",
"EFFICACY ACCOUNT MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"EFFICACY INFORMATICS PRIVATE LIMITED",
"EFFICACY WORLDWIDE PRIVATE LIMITED",
"EFFICAX ENGINEERS PRIVATE LIMITED+D77175",
"EFFICIENERGI CONSULTING PRIVATE LIMITED",
"EFFICIENT AGRICHEM PRIVATE LIMITED",
"EFFICIENT ENERTECH PRIVATE LIMITED",
"EFFICIENT ENVIROTECH PRIVATE LIMITED",
"EFFICIENT FIRE AND SECURITY SOLUTIONS PRIVATE LIMITED",
"EFFICIENT FOREX PRIVATE LIMITED",
"EFFICIENT FREIGHT FORWARDERS PRIVATE LIMITED",
"EFFICIENT HOTELS INDIA PRIVATE LIMITED",
"EFFICIENT ILLUMINATION PRIVATE LIMITED",
"EFFICIENT INNOVATIONS PRIVATE LIMITED",
"EFFICIENT INSURANCE BROKERS PRIVATE LIMITED",
"EFFICIENT LIGHT SOURCE TECHNOLOGIES PRIVATE LIMITED",
"EFFICIENT MACHINE ACCESSORIES PRIVATE LIMITED",
"EFFICIENT PLASTECH PRIVATE LIMITED",
"EFFICIENT PRECISION AND SYSTEMS PRIVATE LIMITED",
"EFFICIENT PUMPING SOLUTIONS PRIVATE LIMITED",
"EFFICIENT REALITY PRIVATE LIMITED",
"EFFICIENT ROADLINES PRIVATE LIMITED",
"EFFICIENT TECHNOLOGIES PRIVATE LIMITED",
"EFFICIENT WORK SOLUTIONS PRIVATE LIMITED",
"EFFICIENTLY GLOBAL SOLUTIONS PRIVATE LIMITED",
"EFFICIENZA BUSINESS SOLUTIONS PRIVATE LIMITED",
"EFFIKASIA LIFESCIENCES PRIVATE LIMITED",
"EFFILOR CONSULTING SERVICES PRIVATE LIMITED",
"EFFIMAC EQUIPMENTS PRIVATE LIMITED",
"EFFIPRESS ENGINEERING PRIVATE LIMITED",
"EFFISSION SOFTWARE PRIVATE LIMITED",
"EFFISTACK INDIA PRIVATE LIMITED",
"EFFITEX MACHINES LLP",
"EFFITRAC SOLUTIONS INDIA PRIVATE LIMITED",
"EFFIVITY TECHNOLOGIES PRIVATE LIMITED",
"EFFIXON ENGINEERING PRIVATE LIMITED",
"EFFIZENT SEELE PRIVATE LIMITED",
"EFFLUENT & WATER TREATMENT ENGINEERS PVT LTD",
"EFFONE TECHNOLOGIES PRIVATE LIMITED",
"EFFORE SOLUTIONS PRIVATE LIMITED",
"EFFTRONICS SYSTEMS PRIVATE LIMITED",
"EFFULGENCE FOREX PRIVATE LIMITED",
"EFFULGENCE TRADING AND SERVICES PRIVATE LIMITED",
"EFFWA INFRA AND RESEARCH PRIVATE LIMITED",
"EFIL ADDITIVE PRIVATE LIMITED",
"EFILING INFOTECH PRIVATE LIMITED",
"EFKON INDIA PRIVATE LIMITED",
"EFL EXPRESS PRIVATE LIMITED",
"EFLAIR MANAGEMENT SYSTEMS PRIVATE LIMITED",
"EFLAIR WEBTECH PRIVATE LIMITED",
"EFLEET SYSTEMS PRIVATE LIMITED",
"E-FLEET SYSTEMS PRIVATE LIMITED",
"EFLEX INFRATECH PRIVATE LIMITED",
"EFOL INDIA PRIVATE LIMITED",
"EFOS EDUMARKETERS PRIVATE LIMITED",
"EFRA PROJECTS LLP",
"E-FRONT LINE RECYCLING PRIVATE LIMITED",
"E-FRT AEROCEAN LOGISTICS PRIVATE LIMITED",
"EFS FACILITIES SERVICES INDIA PRIVATE LIMITED",
"EFSEON ENGINEERING PRIVATE LIMITED",
"EFTEC INDIA PRIVATE LIMITED",
"EFTEN ENGINEERING PRIVATE LIMITED",
"E-FUSIONSOFT TECHNOLOGIES PRIVATE LIMITED",
"EG COMMUNICATIONS PRIVATE LIMITED",
"EG INNOVATIONS PRIVATE LIMITED",
"EG KANTAWALLA PRIVATE LIMITED",
"EG LIFECARE SERVICES PRIVATE LIMITED",
"EG POWER ELECTRONICS INDIA PRIVATE LIMITED",
"EGAIN COMMUNICATIONS PRIVATE LIMITED",
"EGANA INDIA PRIVATE LIMITED",
"EGATE INFOTEL PRIVATE LIMITED",
"EGB SYSTEMS & SOLUTIONS PRIVATE LIMITED",
"EGC FACILITY MANAGEMENT PRIVATE LIMITED",
"EGCHEM COMPONENT INDIA PRIVATE LIMITED",
"EGDK INDIA PRIVATE LIMITED",
"EGE GLOBAL EDUCATION PRIVATE LIMITED",
"EGEARZ PRIVATE LIMITED",
"EGEEKS TECHNICAL SERVICES PRIVATE LIMITED",
"EGELHOF CONTROLS INDIA PRIVATE LIMITED",
"E-GEN TRADERS PRIVATE LIMITED",
"EGENCIA TRAVEL INDIA PRIVATE LIMITED",
"EGESTALT TECHNOLOGIES PRIVATE LIMITED",
"EGG COMMUNICATIONS PRIVATE LIMITED.",
"EGGER PUMPS INDIA PRIVATE LIMITED",
"EGGFIRST ADVERTISING AND DESIGN PRIVATE LIMITED",
"EGGONOMY FARMS PRIVATE LIMITED",
"E-GIANTS IT PRIVATE LIMITED",
"EGIS FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"EGIS GEOPLAN PRIVATE LIMITED",
"EGIS INDIA CONSULTING ENGINEERS PRIVATE LIMITED",
"EGIS ROAD OPERATION INDIA PRIVATE LIMITED",
"EGISS TECHNOLOGIES INDIA PRIVATE LIMITED",
"E-GITS INDIA PRIVATE LIMITED",
"EGL & H FACILITIES MANAGEMENT PRIVATE LIMITED",
"EGLO INDIA PRIVATE LIMITED",
"EGLO INDIA PRODUCTION PRIVATE LIMITED",
"EGLOBE IT SOLUTIONS PRIVATE LIMITED",
"EGMORE BENEFIT SOCIETY LIMITED",
"EGNIOL SERVICES PRIVATE LIMITED",
"EGO ELASTOMERS PRIVATE LIMITED",
"EGO MEDIA PRIVATE LIMITED",
"EGO PREMIUM PRODUCTS PRIVATE LIMITED",
"EGOLDEN RESOURCE SOLUTION PRIVATE LIMITED",
"EGON SOFTWARE PRIVATE LIMITED",
"EGON ZEHNDER INFORMATION AND RESEARCH SERVICES PRIVATE LIMITED",
"EGON ZEHNDER INTERNATIONAL PRIVATE LIMITED",
"EGR EVERGREEN ROOFING PRIVATE LIMITED",
"EGRAMSERVE BPO SERVICES PRIVATE LIMITED",
"EGREEK TECHNICAL SERVICES PRIVATE LIMITED",
"EGREMONTZ BUSINESS SOLUTIONS PRIVATE LIMITED",
"EGRON INDIATECH PRIVATE LIMITED",
"EGROVE SYSTEMS PRIVATE LIMITED",
"EGS COMPUTERS INDIA PRIVATE LIMITED",
"EGS CONTACT CENTER SOLUTIONS PRIVATE LIMITED",
"EGS INFO-TECH PRIVATE LIMITED",
"EGSTON ELECTRONICS (INDIA) PRIVATE LIMITED",
"EGUNATH COMMTRADE PRIVATE LIMITED",
"EGURUKUL APP SOLUTIONS PRIVATE LIMITED",
"EGVIT FOOD PROCESSING PRIVATE LIMITED",
"EGWOOD BOARDS AND PANELS PRIVATE LIMITED",
"EGWOOD INDUSTRIES PRIVATE LIMITED",
"EGYSTAR AGROTECH PRIVATE LIMITED",
"EHA AVIATION PRIVATE LIMITED",
"EHAAT LIMITED",
"EHEALTHCONNECT INFORMATICS PRIVATE LIMITED",
"EHEALTHSOURCE",
"EHEART PRIVATE LIMITED",
"EHELIUM ADVISORY SERVICES PRIVATE LIMITED",
"EHES LIMITED",
"EHH STEELS PRIVATE LIMITED",
"EHI INTERNATIONAL PRIVATE LIMITED",
"E-HIREO GLOBAL SOLUTIONS PRIVATE LIMITED",
"EHOMEMAKER SOLUTIONS INDIA PRIVATE LIMITED",
"EHORIZONS SOFT TECH PRIVATE LIMITED",
"EHR HOSPITALITY PRIVATE LIMITED",
"EHSAAS FOOD AND BEVERAGES PRIVATE LIMITED",
"EHSAAS FROZEN FOODS PRIVATE LIMITED",
"EHSAN AGRO WOOD PRODUCTS PRIVATE LIMITED",
"EHWA DIAMOND INDIA PRIVATE LIMITED",
"EHYTE INDIA PRIVATE LIMITED",
"EI AUDITAX SERVICES PRIVATE LIMITED",
"EI CONNECT TRADE ADVISORY SERVICES PRIVATE LIMITED",
"EI CONSTRUCTION & MANAGEMENT PRIVATE LIMITED",
"EI EMS INDIA PRIVATE LIMITED",
"EI MACHINERY PRIVATE LIMITED",
"EI TECHNOLOGIES PRIVATE LIMITED",
"EI WEB SERVICES PRIVATE LIMITED",
"EIBC PRIVATE LIMITED",
"EIBENSTOCK POSITRON ELEKTROWERK PRIVATE LIMITED",
"EIC ASH PRIVATE LIMITED",
"EIC METERS PRIVATE LIMITED",
"EICE CONSULTANTS AND ENGINEERS PRIVATE LIMITED",
"EICHER GOODEARTH INDIA PRIVATE LIMITED",
"EICHER GOODEARTH PRIVATE LIMITED",
"EICHER GOODEARTH PRIVATE LIMITED.",
"EICHER GROUP FOUNDATION",
"EICHER MOTORS LIMITED",
"EICL LIMITED FORMERLY ENGLISH INDIAN CLAYS LIMITED",
"EICORE TECHNOLOGIES PRIVATE LIMITED",
"EICS TECHNOLOGY PRIVATE LIMITED",
"EIDE BAILLY SHARED SERVICES PRIVATE LIMITED",
"EIDELBERG ENGINEERS PRIVATE LIMITED",
"EIDER ELEVATORS PRIVATE LIMITED",
"EIDIKO SYSTEMS INTEGRATORS PRIVATE LIMITED",
"EIDOLON LEARNING PRIVATE LIMITED",
"EIE COMPLETE SOLUTIONS PRIVATE LIMITED",
"EIE INDIA PRIVATE LIMITED",
"EIE INSTRUMENTS PRIVATE LIMITED",
"EIFCO AUTO COMPONENTS PRIVATE LIMITED",
"EIFCO MACHINE TOOLS PRIVATE LIMITED",
"EIFFAGE INFRASTRUCTURES PRIVATE LIMITED",
"EIFFEL INFRADEVELOPERS PRIVATE LIMITED",
"EIFFEL LANDMARKS PRIVATE LIMITED",
"EIGEN TECHNOLOGIES PRIVATE LIMITED",
"EIGENRISK BUSINESS SOLUTIONS INDIA PRIVATE LIMITED",
"EIGENSCHAFT MARKETING SERVICES PRIVATE LIMITED",
"EIGHT ALLOYS PRIVATE LIMITED",
"EIGHT BROTHERS SALES PRIVATE LIMITED",
"EIGHT ROADS INVESTMENT ADVISORS PRIVATE LIMITED",
"EIGHT STAR LOGISTICS PRIVATE LIMITED",
"EIGHTEEN PIXELS INDIA PRIVATE LIMITED",
"EIGHTEEN WOODLAND PROPERTIES PRIVATE LIMITED",
"EIGHTEEN95 TECHNOLOGIES PRIVATE LIMITED",
"EIGHTFOLD AI INDIA PRIVATE LIMITED",
"EIGHTPOINTTHREE ELECTRONICS PRIVATE LIMITED",
"EIGHTY JEWELLERS LIMITED",
"EIGHTY TWO POINTFIVE COMMUNICATIONS PRIVATE LIMITED",
"EIGHTY-EIGHT DB INDIA PRIVATE LIMITED",
"EIGHTYEIGHT PICTURES MEDIA AND ENTERTAINMENT PRIVATE LIMITED",
"EIGHTY-FOUR INVESTMENTS PRIVATE LIMITED",
"EIGHTYTWENTY SUITE PRIVATE. LIMITED",
"EIH ASSOCIATED HOTELS LIMITED",
"EIH LIMITED",
"EIHOBEROI HOTELSLIMITED",
"EIJ CONSULTING PRIVATE LIMITED",
"EIK INVESTMENT AND TRADING LIMITED",
"EIKO LIFESCIENCES LIMITED",
"EIKYOO PRIVATE LIMITED",
"EILA CONSULTING PRIVATE LIMITED",
"EILA PROPERTIES PRIVATE LIMITED",
"EILISYS TECHNOLOGIES PRIVATE LIMITED",
"EIM SOLUTIONS INDIA PRIVATE LIMITED",
"EIMCO ELECON ELECTRICALS LIMITED",
"EIMCO ELECON INDIA LIMITED",
"EIMSIM BABA'S INFRASTRUCTURES PRIVATE LIMITED",
"E-INCARNATION RECYCLING PRIVATE LIMITED",
"EINE MILLIARD INFRA AND TECHNOLOGY PRIVATE LIMITED",
"EINFOCHIPS LIMITED",
"EINFOLGE TECHNOLOGIES PRIVATE LIMITED",
"EINGUR WIND ENERGY PRIVATE LIMITED",
"EINS ENGINEERING SOLUTIONS INDIA PRIVATE LIMITED",
"EINS TECHNIK PRIVATE LIMITED",
"EINZIGARTIG INFONET BPO SERVICES PRIVATE LIMITED",
"EION TELECOM PRIVATE LIMITED",
"EIOSYS PRIVATE LIMITED",
"EIP TECHNOLOGIES PRIVATE LIMITED",
"EIPI MEDIA PRIVATE LIMITED",
"EIPII EXPORTS PRIVATE LIMITED",
"EIPP SOLUTIONS PRIVATE LIMITED",
"EIPROCON INTERNATIONAL (OPC) PRIVATE LIMITED",
"EIQNETWORKS INDIA RESEARCH AND DEVELOPMENT PRIVATE LIMITED",
"EIRA SPECIALITY PRIVATE LIMITED",
"EIRFID SOLUTIONS PRIVATE LIMITED",
"EIRICH INDIA PRIVATE LIMITED",
"EIRIS CONNECT PRIVATE LIMITED",
"EIS TECHINFRA SOLUTIONS (INDIA) PRIVATE LIMITED",
"EIS TECHNOLOGIES PRIVATE LIMITED",
"EISA LIFTS PRIVATE LIMITED",
"EISAI PHARMACEUTICALS INDIA PRIVATE LIMITED",
"EISEN PHARMACEUTICAL COMPANY PRIVATE LIMITED",
"EISENMANN INDIA PRIVATE LIMITED",
"E ISG SOLUTIONS PRIVATE LIMITED",
"EISNERAMPER (INDIA) CONSULTANTS PRIVATE LIMITED",
"EIT POLYTECHNIC COLLEGE",
"E-IT PROFESSIONALS INDIA PRIVATE LIMITED",
"EIT SERVICES INDIA PRIVATE LIMITED",
"EITA INDIA LIMITED",
"EITACIES SOLUTIONS INDIA PRIVATE LIMITED",
"EIWAVE DIGITECH (INDIA) PRIVATE LIMITED",
"EIY SYS PRIVATE LIMITED",
"EJEE PARTS AND TOOLS PRIVATE LIMITED",
"EJEEVA TECHNOLOGIES PRIVATE LIMITED",
"EJEYES COMPONENTS PRIVATE LIMITED",
"EJOT-OCTAQON FASTENING SYSTEMS PRIVATE LIMITED",
"EJYLE TECHNOLOGIES PRIVATE LIMITED",
"EJYOTHI SERVICES PRIVATE LIMITED",
"EK SOFTWARE PRIVATE LIMITED",
"EK WIRELESS PRIVATE LIMITED",
"EKA ARCHIVING SERVICES PRIVATE LIMITED",
"EKA ENGINEERING TECHNICS PRIVATE LIMITED",
"EKA INFRA CONSULTANTS PRIVATE LIMITED",
"EKA PAK GLOBAL (INDIA) PRIVATE LIMITED",
"EKA SOFTWARE SOLUTIONS PRIVATE LIMITED",
"EKA TURNKEY SOLUTIONS PRIVATE LIMITED",
"EKAA ENGINEERS AND INFRASTRUCTURE PRIVATE LIMITED",
"EKAA FURNITURE PRIVATE LIMITED",
"EKAA TRAINING INSTITUTE OF HYPNOTHERAPY PRIVATE LIMITED",
"EKAATRONICS PRIVATE LIMITED",
"EKADANTA PRIVATE LIMITED",
"EKADASH DEVELOPERS PRIVATE LIMITED",
"EKADESIGN STUDIO PRIVATE LIMITED",
"EKAGA FUTURISTICS PRIVATE LIMITED",
"EKAGA INFRASTRUCTURE LLP",
"EKAGRA COTTON CORPORATION PRIVATE LIMITED",
"EKAGRA STEELS PRIVATE LIMITED",
"EKAGRATA FINANCE PRIVATE LIMITED",
"EKAH TRUCKING SERVICES PRIVATE LIMITED",
"EKAKINN IMPORTS AND EXPORTS PRIVATE LIMITED",
"EKAKSH AGRO INDUSTRIES PRIVATE LIMITED",
"EKAKSHAR FINTRADE PRIVATE LIMITED",
"EKAM ADVISORS PRIVATE LIMITED",
"EKAM AGRO PRIVATE LIMITED",
"EKAM AUTO POINT PVT LTD",
"EKAM CONSTRUCTORS PRIVATE LIMITED",
"EKAM PLASTOCHEM PRIVATE LIMITED",
"EKAM ULTRA FARMS PRIVATE LIMITED",
"EKAMEVA CONSULT PRIVATE LIMITED",
"EKAMTEC SYSTEMS LIMITED",
"EKAMTEC SYSTEMS PRIVATE LIMITED",
"EKANA SPORTZ CITY PRIVATE LIMITED",
"EKANEK NETWORKS PRIVATE LIMITED",
"EKANSH CONCEPTS LIMITED",
"EKANSH PETROCHEM PRIVATE LIMITED",
"EKAPAD SOLUTIONS PRIVATE LIMITED",
"EKARD LIFE SCIENCES PRIVATE LIMITED",
"EKASILA EDUCATION SOCIETY",
"EKATA EARTH PRIVATE LIMITED",
"EKATA SHIPPING PRIVATE LIMITED",
"EKATAA COMMERCIAL CENTER PRIVATE LIMITED",
"EKATMIK BAL VIKAS SEVA YOJANA",
"EKATMTA HIGH SCHOOL",
"EKATO INDIA PRIVATE LIMITED",
"EKATVA ENTERPRISES",
"EKAVIDHA CORPORATE SERVICES PRIVATE LIMITED",
"EKAYANAA SCHOOL",
"EKBALPUR NURSING HOME PVT.LTD.",
"EKBOTE INTERIORS PRIVATE LIMITED",
"EKBOTE'S LOGS AND LUMBERS PRIVATE LIMITED",
"EKCO PLASTICS PVT LTD",
"EKCS INDIA PRIVATE LIMITED",
"EKDANT COLONISER PRIVATE LIMITED",
"EKDANT COMMERCIAL PRIVATE LIMITED",
"EKDANT CONSTRUCTIONS AND DEVELOPERS PRIVATE LIMITED",
"EKDANT ENVIRO SERVICES PRIVATE LIMITED",
"EKDANT EQUIPMENTS PRIVATE LIMITED",
"EKDANT MOULDERS AND ENGINEERS PRIVATE LIMITED",
"EKDANT POLY TUBES PRIVATE LIMITED",
"EKDANTA CONSTRUCTIONS AND DEVELOPERS PRIVATE. LIMITED.",
"EKDANTA FABRICS PRIVATE LIMITED",
"EKDANTAYE METALS PRIVATE LIMITED",
"EKHANDE AGRO FERTILIZERS PRIVATE LIMITED",
"EKI ENERGY SERVICES LIMITED",
"EKIALDE SOLAR PRIVATE LIMITED",
"EKIALDE SUN ENERGY PRIVATE LIMITED",
"E-KICK PRIVATE LIMITED",
"EKIDO HOLIDAY TOURS PRIVATE LIMITED",
"EKIN INDIA PRIVATE LIMITED",
"EKINOPS NETWORKS INDIA PRIVATE LIMITED",
"EKJOT TIMBER MERCHANTS PRIVATE LIMITED",
"EKK EAGLE PRODUCTS INDIA PRIVATE LIMITED",
"EKK INFRASTRUCTURE LIMITED",
"EKKAA ELECTRONICS INDUSTRIES PRIVATE LIMITED",
"EKKI HOMA PRIVATE LIMITED",
"EKL CSR FOUNDATION",
"EKLAVAYA STONE & MINES PRIVATE LIMITED",
"EKLAVYA EDUCATION FOUNDATION",
"EKLAVYA ESTATE PRIVATE LIMITED",
"EKLAVYA GLOBAL SCHOOL",
"EKLAVYA INFRA PRIVATE LIMITED",
"EKLAVYA MADHYAMIK VIDYALAY CHIKHALBEED BEED",
"EKLAVYA MODEL RESIDENTIAL SCHOOL",
"EKLAVYA PUBLIC SCHOOL",
"EKLAVYA VIDYALAYA & J G NATAWADKAR JR COLLEGE NANDURBAR",
"EKLAVYA VIDYAMANDIR",
"EKLING SAROVAR RESORT PRIVATE LIMITED",
"EKLINGJEE POLYMERS PRIVATE LIMITED",
"EKLINGNATH MOTORS PRIVATE LIMITED",
"EKM INFOTECH PRIVATE LIMITED",
"EKMAN PULP AND PAPER PRIVATE LIMITED",
"EKMS WORLD EXPORT IMPORT PRIVATE LIMITED",
"EKNOS INDIA PRIVATE LIMITED",
"EKO INDIA FINANCIAL SERVICES PRIVATE LIMITED",
"EKO PRO ENGINEERS PRIVATE LIMITED",
"EKOLOGIE FORTE PRIVATE LIMITED",
"EKOMATE SYSTEMS INDIA PRIVATE LIMITED",
"EKON TECHNOLOGIES AND SECURITY SOLUTIONS PRIVATE LIMITED",
"EKOPAK INDIA PRIVATE LIMITED",
"EKOPATH METROPOLIS LAB SERVICES PRIVATE LIMITED",
"E-KORS PRIVATE LIMITED",
"EKOTRADE GLOBAL LIMITED",
"EKOWEBTECH IT SERVICES PRIVATE LIMITED",
"EKRAM HOTELS PRIVATE. LIMITED.",
"EKRU ALLURING DESIGNS PRIVATE LIMITED",
"EKS FILTER TECHNIK INDIA PRIVATE LIMITED",
"EKS INTEC INDIA PRIVATE LIMITED",
"EKSAATH EVENTS PRIVATE LIMITED",
"EKSOURCE INFOTECH PRIVATE LIMITED",
"EKSOURCE TECHNOLOGIES PRIVATE LIMITED",
"EKSOY CHEMICALS INDIA PRIVATE LIMITED",
"EKSTEP FOUNDATION",
"EKSUTRA MARKETING PRIVATE LIMITED",
"EKTA BUILDERS AND ENGINEERS PRIVATE LIMITED",
"EKTA CARGO MOVERS PRIVATE LIMITED",
"EKTA CHEMICALS PRIVATE LTD",
"EKTA CONTECH PRIVATE LIMITED",
"EKTA COSMETICS LIMITED",
"EKTA EMBROIDERIES PRIVATE LIMITED",
"EKTA ENGINEERING UDYOG PRIVATE LIMITED",
"EKTA FASHIONS PRIVATE LIMITED",
"EKTA FOREX PRIVATE LIMITED",
"EKTA FRESHFOODS PRIVATE LIMITED",
"EKTA FURNITURE PRIVATE. LIMITED.",
"EKTA GROUP GUARDS PRIVATE LIMITED",
"EKTA HIGHWAY CARRIERS PRIVATE LIMITED",
"EKTA HOUSING PRIVATE LIMITED",
"EKTA INDUSTRIAL PRODUCTS PRIVATE LIMITED",
"EKTA INTERNATIONAL PRIVATE LIMITED",
"EKTA OFFSET PRIVATE LIMITED",
"EKTA PARKSVILLE HOMES PRIVATE LIMITED",
"EKTA POLYFAB PRIVATE LIMITED",
"EKTA PRINTS PRIVATE LIMITED",
"EKTA PRODUCTS PRIVATE LIMITED",
"EKTA RESIDENCY PRIVATE LIMITED",
"EKTA VANIJYA PRIVATE LIMITED",
"EKTA WORLD PRIVATE LIMITED",
"EKTAAM SHRAMIK DEVELOPERS AND SUPPLIERS PRIVATE LIMITED",
"EKTAELITE REHAB PRIVATE LIMITED",
"EK-TEK PHARMA",
"EKTELON ENGINEERING AND PROJECTS PRIVATE LIMITED",
"EKTHA INDIA PRIVATE LIMITED",
"EKU PLASTIC INNOVATION PRIVATE LIMITED",
"EKUTIR RURAL MANAGEMENT SERVICES PRIVATE LIMITED",
"EKVEERA VIDHYALYA",
"EKVIRA ALLOYS PRIVATE LIMITED",
"EKVIRA COTEX PRIVATE LIMITED",
"EKVIRA FINE-CHEM PVT LTD",
"EKVIRA GEMS PRIVATE LIMITED",
"EKVIRA PRODUCTIONS PRIVATE LIMITED",
"EKYA SCHOOL",
"EKYA SCHOOL BYRATHI",
"EKYANA HEALTHCARE PRIVATE LIMITED",
"EL CHICO CLUTCH PRIVATE LIMITED",
"EL CORTE INGLES S A",
"EL DORADO MOTELS PRIVATE LIMITED",
"EL ENTERPRISES (INDIA) PRIVATE LIMITED",
"EL FARMACEUTICA INDIA PRIVATE LIMITED",
"EL INFO DESIGNS PRIVATE LIMITED",
"EL TECH POWER SYSTEM PRIVATE LIMITED",
"ELA FOODS AND SNACKS PRIVATE LIMITED",
"ELAAF TECHNOLOGIES PRIVATE LIMITED",
"ELAAR LIFESTYLE PRIVATE LIMITED",
"ELAC MARKETING PRIVATE LIMITED",
"ELAIT IT TECHNOLOGY SERVICES PRIVATE LIMITED",
"ELAM PHARMA PRIVATE LIMITED",
"ELAMA HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"ELAN AGROCHEM PRIVATE LIMITED",
"ELAN AUTO INDIA LIMITED",
"ELAN AUTOMOBILES PRIVATE LIMITED",
"ELAN BUILDCON PRIVATE LIMITED",
"ELAN BUILDTECH PRIVATE LIMITED",
"ELAN COMMUNICATIONS PRIVATE LIMITED",
"ELAN EQUITY SERVICES PRIVATE LIMITED",
"ELAN GREENTECH ENERGIES LIMITED",
"ELAN LIMITED",
"ELAN PHARMA INDIA PRIVATE LIMITED",
"ELAN PROFESSIONAL APPLIANCES PRIVATE LIMITED",
"ELANAD MILK PRIVATE LIMITED",
"ELANADU FOOD PRODUCTS PRIVATE LIMITED",
"ELANCE LEARNING PROVIDER PRIVATE LIMITED",
"ELANCER IT SOLUTIONS PRIVATE LIMITED",
"ELANCO INDIA PRIVATE LIMITED",
"ELANCO INNOVATION AND ALLIANCE CENTRE IN DIA LLP",
"ELANN DRIVE & AUTOMATION PRIVATE LIMITED",
"ELANOR GRAPHICS PRIVATE LIMITED",
"ELANTA AGRO PRIVATE LIMITED",
"ELANTAS BECK INDIA LIMITED",
"ELANTE RESIDENCIES PRIVATE LIMITED",
"ELANVITAL PRINTING SOLUTIONS PRIVATE LIMITED",
"ELANZA EXPORT PRIVATE LIMITED",
"ELANZA PORTFOLIO PRIVATE LIMITED",
"ELAONC PRIVATE LIMITED",
"ELAR MEDICAL PRIVATE LIMITED",
"ELARA CAPITAL INDIA PRIVATE LIMITED",
"ELARA FINANCE (INDIA) PRIVATE LIMITED",
"ELARA SECURITIES (INDIA) PRIVATE LIMITED",
"ELARA TRADING AND SERVICES LIMITED",
"ELASTIC DATA CENTERS (OPC) PRIVATE LIMITED",
"ELASTIC TREE MARKETING SERVICES PRIVATE LIMITED",
"ELASTICRUN",
"ELASTO MILLS PRIVATE LIMITED",
"ELASTOCHEMIE IMPEX PVT LTD",
"ELASTOMET BEARINGS PVT LTD",
"ELASTO-TECH INDUSTRIES PRIVATE LIMITED",
"ELATE INDIA PRIVATE LIMITED",
"ELATE INVESTMENT AND HOLDINGS PRIVATE LIMITED",
"ELATE POLYTEX PRIVATE LIMITED",
"ELATION EDTECH PRIVATE LIMITED",
"ELATION HAIR & SKIN CLINIC PRIVATE LIMITED",
"ELAVIN CHEMTECH PRIVATE LIMITED",
"ELBAS FASHIONS PRIVATE LIMITED",
"ELBEE SECURITIES PVT.LTD.",
"ELBIT MEDICAL DIAGNOSTICS LIMITED",
"ELBIT MEDICAL DIAGNOSTICS PRIVATE LIMITED",
"ELBIT SYSTEMS OF INDIA PRIVATE LIMITED",
"ELBITEC AGRO BIO PRODUCTS PRIVATE LIMITED",
"ELBON CONFERENCES AND EVENTS PRIVATE LIMITED",
"ELBRINA ENTERPRISES PRIVATE LIMITED",
"ELBRIT LIFE SCIENCES PRIVATE LIMITED",
"ELBRUS LABS PRIVATE LIMITED",
"ELCA COSMETICS PRIVATE LIMITED",
"ELCA QUALITY SYSTEMS AND CALIBRATIONS PRIVATE LIMITED",
"ELCAB ENGINEERS PRIVATE LIMITED",
"ELCAMINO SOFTWARE PRIVATE LIMITED",
"ELCAMINO TECHNOLOGIES PRIVATE LIMITED",
"ELCARE SYSTEMS PRIVATE LIMITED",
"ELCE CLINICS AND HOSPITALS PRIVATE LIMITED",
"ELCEN MACHINES PRIVATE LIMITED",
"ELCID INVESTMENTS LIMITED",
"ELCLIFF FORMULATIONS PRIVATE LIMITED",
"ELCO CONSULTANTS PRIVATE LIMITED",
"ELCO ENGINEERING PRIVATE LIMITED",
"ELCO METACHEM PRIVATE LIMITED",
"ELCO PROJECTS PVT. LTD.",
"ELCOM FUTURETECH PRIVATE LIMITED",
"ELCOM INNOVATIONS PRIVATE LIMITED",
"ELCOM INTERNATIONAL PRIVATE LIMITED",
"ELCOM SYSTEM PRIVATE. LIMITED.",
"ELCOM TRADING COMPANY PRIVATE LIMITED",
"ELCOM WEB INDIA PRIVATE LIMITED",
"ELCOME INTEGRATED SYSTEMS PRIVATE LIMITED",
"ELCOME PROPERTIES PRIVATE LIMITED",
"ELCOME TECHNOLOGIES PRIVATE LIMITED",
"ELCOMPO ELECTRONICS INDUSRIES PRIVATE LIMITED",
"ELCOMPONICS SALES PRIVATE LIMITED",
"ELCON ALLOYS PRIVATE LIMITED",
"ELCON CABLE TRAYS PRIVATE LIMITED",
"ELCON COMPONENTS PRIVATE LTD",
"ELCON ENGINEERS PRIVATE LIMITED",
"ELCON EQUIPPMENTS PRIVATE LIMITED",
"ELCON SYSTEMS PRIVATE LIMITED",
"ELCONCONNECTORS CABLES PRIVATE LIMITED",
"ELCORE (INDIA) PRIVATE LIMITED",
"ELCOSOFT PRIVATE LIMITED",
"ELCOTEK INDIA PRIVATE LIMITED",
"ELCRAFT TECHNOLOGIES PRIVATE LIMITED",
"ELDAAS TECHNOLOGIES PRIVATE LIMITED",
"ELDECO GREEN PARK INFRASTRUCTURE LIMITED",
"ELDECO INFRABUILD LIMITED",
"ELDECO INFRASTRUCTURE AND PROPERTIES LIMITED",
"ELDECO SIDCUL INDUSTRIAL PARK LIMITED",
"ELDECO SOHNA PROJECTS LIMITED",
"ELDECO TOWNSHIPS AND HOUSING LIMITED",
"ELDER DRUGS & PHARMACEUTICAL PRIVATE LIMITED",
"ELDER EQUIPMENTS PRIVATE LIMITED",
"ELDER LABS LIMITED",
"ELDER REMEDIES LIMITED",
"ELDERAID WELLNESS PRIVATE LIMITED",
"ELDON CS ENCLOSURES PRIVATE LIMITED",
"ELDORADO CONSULTANTS PRIVATE LIMITED",
"ELDORADO TECHNOLOGIES LIMITED",
"ELDYNE ELECTRO-SYSTEMS PVT LTD",
"ELE ANIMATIONS PRIVATE LIMITED",
"ELE CHEM SYSTEMS PRIVATE LIMITED",
"ELE5 SOLUTIONS PRIVATE LIMITED",
"ELEANOR REALTY HOLDINGS INDIA PRIVATE LIMITED",
"ELECHEM BIO SCIENCES PRIVATE LIMITED",
"ELECMECH ENGINEERS PRIVATE LIMITED",
"ELECON BEVERAGES INDIA LIMITED",
"ELECON CARGO PRIVATE LIMITED",
"ELECON CONDUCTORS PRIVATE LIMITED",
"ELECON CONSTRUCTIONS PRIVATE LIMITED",
"ELECON ENERGY SOLUTIONS PRIVATE LIMITED",
"ELECON ENGINEERING COMPANY",
"ELECON HYDRAULICS PRIVATE LIMITED",
"ELECON INFORMATION TECHNOLOGY LIMITED",
"ELECON PERIPHERALS LIMITED",
"ELECON POLYMERS PRIVATE LIMITED",
"ELECON POWER INFRASTRUCTURE PRIVATE LIMITED",
"ELECON POWER SYSTEMS PRIVATE LIMITED",
"ELECOREV ENERGY PRIVATE LIMITED",
"ELECOS ENGINEERS PRIVATE LIMITED",
"ELECSA INFRATECH PRIVATE LIMITED",
"ELECSERVE TECH SOLUTIONS PRIVATE LIMITED",
"ELECSOL TECHNOLOGY PRIVATE LIMITED",
"ELECT SYSTEMS ENGINEERS PRIVATE LIMITED",
"ELECTECH ENGINEERING PRIVATE LIMITED",
"ELECTECH SWITCHGEAR PRIVATE LIMITED",
"ELECT-EVTEC SOLUTIONS PRIVATE LIMITED",
"ELECTION CENTRE CENTRAL SULTANIA INFANTRY LINES BHOPAL",
"ELECTION DEPARTMENT",
"ELECTOMECH INDUSTRIAL SOLUTION PRIVATE LIMITED",
"ELECTRA DESIGN AUTOMATION PRIVATE LIMITED",
"ELECTRA ELECTRICALS (INDIA) PRIVATE LIMITED",
"ELECTRA ENTERPRISE LLP",
"ELECTRA EVENTS AND EXHIBITIONS INDIA PRIVATE LIMITED",
"ELECTRA KOKO TAWA WELD PRIVATE LIMITED",
"ELECTRA PAPER AND BOARD PRIVATE LIMITED",
"ELECTRA WELDING MACHINE PRIVATE LIMITED",
"ELECTRAA FAB PRIVATE LIMITED",
"ELECTRAA SOLAR ENERGY SYSTEMS PRIVATE LIMITED",
"ELECTRACON PARADISE LIMITED",
"ELECTREV MOBILITY PRIVATE LIMITED",
"ELECTREX INTERNATIONAL PRIVATE LIMITED",
"ELECTRIC ONE MOBILITY PRIVATE LIMITED",
"ELECTRIC POWER EQUIPMENT COMPANY",
"ELECTRICA ENGINEERS (INDIA) PRIVATE LIMITED",
"ELECTRICA ENGINEERS INDIA PRIVATE LIMITED",
"ELECTRICAL CONTROL SYSTEMS PRIVATE LIMITED",
"ELECTRICAL CORPORATION OF INDIA LIMITED",
"ELECTRICAL ENERGY EQUIPMENTS INDIA PRIVATE LIMITED",
"ELECTRICAL RESEARCH AND DEVELOPMENT ASSOCIATION",
"ELECTRICAL ROTATING SYSTEMS PRIVATE LIMITED",
"ELECTRICALS AND ELECTRONICS (INDIA) LTD.",
"ELECTRICALS ENGINEERS PRIVATE LIMITED",
"ELECTRICFOR HEATING SYSTEMS INDIA PRIVATE LIMITED",
"ELECTRICITA ENERGY PRIVATE LIMITED",
"ELECTRICITE DE FRANCE",
"ELECTRICITY SAFETY UP LKO",
"ELECTRICO ENERGIES PRIVATE LIMITED",
"ELECTRIFUEL PRIVATE LIMITED",
"ELECTRIFYING INDIA PRIVATE LIMITED",
"ELECTRIP PRIVATE LIMITED",
"ELECTRO ACOUSTIC INFOTECH PRIVATE LIMITED",
"ELECTRO AIR PRIVATE LIMITED",
"ELECTRO ALLIED PRODUCTS",
"ELECTRO ARO AUTOMOTIVE PRIVATE LIMITED",
"ELECTRO AUTOMATION PRIVATE LIMITED",
"ELECTRO CARE INDIA PRIVATE LIMITED",
"ELECTRO CIRCUIT SYSTEMS",
"ELECTRO CONTROL SYSTEMS INDIA PRIVATE LIMITED",
"ELECTRO CORR DAMP PRIVATE LIMITED",
"ELECTRO DEVICES PRIVATE LIMITED",
"ELECTRO DIAGNO SYSTEMS PRIVATE LIMITED",
"ELECTRO EQUIPMENTS",
"ELECTRO FLUX EQUIPMENTS PRIVATE LIMITED",
"ELECTRO FORCE (INDIA) LIMITED",
"ELECTRO FORCE INDIA PRIVATE LIMITED",
"ELECTRO INTERNATIONAL COMPANY PRIVATE LIMITED",
"ELECTRO INVESTMENT PVT LTD",
"ELECTRO JET MACHINERY PRIVATE LIMITED",
"ELECTRO LUBE SOLUTIONS PRIVATE LIMITED",
"ELECTRO MART STORES PRIVATE LIMITED",
"ELECTRO MATRIX TECHNOLOGIES PRIVATE LIMITED",
"ELECTRO MAX MARKETING PRIVATE LIMITED",
"ELECTRO MEC MACHINERY MANUFACTURERS PRIVATE LIMITED",
"ELECTRO MECHNICO PROJECTS PRIVATE LIMITED",
"ELECTRO MICRO TECHNOLOGY PRIVATE LIMITED",
"ELECTRO OPTIC ASIA PRIVATE LIMITED",
"ELECTRO OPTICAL INSTRUMENTS RESEARCH ACADEMY",
"ELECTRO OPTICS PRIVATE LIMITED",
"ELECTRO PNEUMATICS AND HYDRAULICS INDIA PRIVATE LIMITED",
"ELECTRO POLES PRODUCTS PRIVATE LIMITED",
"ELECTRO PULSE PRIVATE LIMITED",
"ELECTRO RAK INDIA PRIVATE LIMITED",
"ELECTRO RENT INDIA PRIVATE LIMITED",
"ELECTRO SERVICES PRIVATE LIMITED",
"ELECTRO SOLAIRE PRIVATE LIMITED",
"ELECTRO SYSTEMS ASSOCIATES PRIVATE LIMITED",
"ELECTRO TECH INTEGRATORS PRIVATE LIMITED",
"ELECTRO TRAIL TECHNOLOGIES PRIVATE LIMITED",
"ELECTRO VOLT EQUIPMENTS PVT LTD",
"ELECTRO WAVES ELECTRONICS PRIVATE LIMITED",
"ELECTRO WORLD INDIA PRIVATE LIMITED",
"ELECTRO ZAVODINDIAPRIVATE LIMITED",
"ELECTROBOLTZ INDIA PRIVATE LIMITED",
"ELECTROCAST SALES INDIA LTD",
"ELECTROCHEM PLATING PVT LTD",
"ELECTROCHEM TECHNOLOGIES INDIA PRIVATE LIMITED",
"ELECTROCIPHER SYSTEMS PRIVATE LIMITED",
"ELECTROCOM SOFTWARE PRIVATE LIMITED",
"ELECTRODRIVE POWERTRAIN SOLUTIONS PRIVATE LIMITED",
"ELECTROFAB ENGINEERING SERVICES PRIVATE LIMITED",
"ELECTROFAB INNOVATIONS INDIA PRIVATE LIMITED",
"ELECTROFOCUS ELECTRICALS PRIVATE LIMITED",
"ELECTROFRONT TRANSPOWER PRIVATE LIMITED",
"ELECTROGATOR GREEN ENERGY PRIVATE LIMITED",
"ELECTROGRAPHICS SIGN PRIVATE LIMITED",
"ELECTROHMS PRIVATE LIMITED",
"ELECTROKINGS",
"ELECTROLAB INDIA PRIVATE LIMITED",
"ELECTROLEAD PUNE PRIVATE.LIMITED",
"ELECTROLINKS TECHNOLOGIES PRIVATE LIMITED",
"ELECTROLITE SYSTEMS PRIVATE LIMITED",
"ELECTROLOGIC TECHNOLOGIES PRIVATE LIMITED",
"ELECTROLOY (INDIA) PRIVATE LIMITED",
"ELECTROLUX ENERGY INDIA PRIVATE LIMITED",
"ELECTROLUX VOLTAS",
"ELECTROM ENGINEERING (I) PRIVATE LIMITED",
"ELECTROMAC ELECTRICALS PRIVATE LIMITED",
"ELECTROMAG WIRELESS SOLUTIONS PRIVATE LIMITED",
"ELECTROMATE COMPONENTS PRIVATE LIMITED",
"ELECTROMECH & TRANSTECH PRIVATE LIMITED",
"ELECTRO-MECH CONSULTANTS PRIVATE LIMITED",
"ELECTRO-MECH ENTERPRISES PRIVATE LIMITED",
"ELECTROMECH FIRE FIGHTERS PRIVATE LIMITED",
"ELECTROMECH INFRAPROJECTS PRIVATE LIMITED",
"ELECTROMECH INFRASTRUCTURE EQUIPMENT PRIVATE LIMITED",
"ELECTROMECH MARITECH PRIVATE LIMITED",
"ELECTROMECH MATERIAL HANDLING SYSTEMS INDIA PRIVATE LIMITED",
"ELECTROMEK ENGINEERING PRIVATE LIMITED",
"ELECTROMOTIVE POWER DRIVES PRIVATE LIMITED",
"ELECTRON COLOUR CHEM PRIVATE LIMITED",
"ELECTRON ENGINEERS",
"ELECTRON E-SERVICES PRIVATE LIMITED",
"ELECTRONET EQUIPMENTS PRIVATE LIMITED",
"ELECTRONEUMATICS CNC CONTROLS PRIVATE LIMITED",
"ELECTRONIC AND ENGINEERING COMPANY (INDIA) PRIVATE LIMITED",
"ELECTRONIC AND ENGINEERING SERVICES PRIVATE LIMITED",
"ELECTRONIC AUTOMATION PRIVATE LIMITED",
"ELECTRONIC CITY BEST INTERIORS PRIVATE LIMITED",
"ELECTRONIC CONTROLS AND DISCHARGE SYSTEMS PRIVATE LIMITED",
"ELECTRONIC ENAMELS AND GLASSES PVT LTD",
"ELECTRONIC ENTERPRISES INDIA PRIVATE LIMITED",
"ELECTRONIC EQUIPMENT COMPANY PRIVATE LIMITED",
"ELECTRONIC FASTENERS LIMITED",
"ELECTRONIC INSTRUMENTATION AND CONTROL PVT LTD",
"ELECTRONIC PAYMENT AND SERVICES PRIVATE LIMITED",
"ELECTRONIC RELAY (INDIA) PRIVATE LIMITED",
"ELECTRONIC SWITCHES (INDIA) PRIVATE LIMITED",
"ELECTRONICA AUTOMATIONS PRIVATE LIMITED",
"ELECTRONICA FINANCE LIMITED",
"ELECTRONICA HITECH ENGINEERING PRIVATE LIMITED",
"ELECTRONICA HITECH MACHINE TOOLS PRIVATE LIMITED",
"ELECTRONICA INDIA LIMITED",
"ELECTRONICA MACHINE TOOLS LIMITED",
"ELECTRONICA MECHATRONIC SYSTEM INDIA PRIVATE LIMITED",
"ELECTRONICA PLASTIC MACHINES LIMITED",
"ELECTRONICA SEMI CONDUCTOR PRIVATE LIMITED",
"ELECTRONICA TUNGSTEN LIMITED",
"ELECTRONICON SYSTEM ELECTRIC PRIVATE LIMITED",
"ELECTRONICS & INFORMATION TECHNOLOGY DEPARTMENT GOVERNMENT OF ODISHA",
"ELECTRONICS AND CONTROLS POWER SYSTEMS PRIVATE LIMITED",
"ELECTRONICS CENTRE PRIVATE LIMITED",
"ELECTRONICS CORPORATION OF INDIA LIMITED",
"ELECTRONICS CORPORATION OF TAMILNADU LIMTIED",
"ELECTRONICS DEVICES WORLDWIDE PRIVATE LIMITED",
"ELECTRONICS FARMING SOLUTIONS ASSOCIATES (E-FASAL) PRIVATE LIMITED",
"ELECTRONICS MART INDIA LIMITED",
"ELECTRONICS MART INDIA PRIVATE LIMITED",
"ELECTRONICS SECTOR SKILLS COUNCIL OF INDIA",
"ELECTRONICS TECHNOLOGY PARKS- KERALA",
"ELECTRONICTENDER.COM (INDIA) PRIVATE LIMITED",
"ELECTRONO SOLUTIONS PRIVATE LIMITED",
"ELECTROPHILE INDIA PRIVATE LIMITED",
"ELECTROPHOTO EQUIPMENTS PRIVATE LIMITED",
"ELECTROPLAST INDIA PRIVATE LIMITED",
"ELECTROPLAST MAC TOOLS PRIVATE LIMITED",
"ELECTROPLAZA TECHNOLOGIES LIMITED",
"ELECTROPNEUMATICS DRIVES AND CONTROLS PRIVATE LIMITED",
"ELECTROSEMI TECH INDIA PRIVATE LIMITED",
"ELECTROSOFT AUTOMATION PRIVATE LIMITED",
"ELECTROSPARK ENCLOSURES PRIVATE LIMITED",
"ELECTROSTAR SIGNALLING & POWER EQUIPMENTS PRIVATE LIMITED",
"ELECTROSTEEL CASTINGS LTD",
"ELECTROTECH OVERSEAS PRIVATE LIMITED",
"ELECTRO-TECH TRANSMISSION PRIVATE LIMITED",
"ELECTROTEK STATIC CONTROLS PRIVATE LIMITED",
"ELECTROTEKNICA SWITCHGEARS PRIVATE LIMITED",
"ELECTROTHERM INDIA LIMITED",
"ELECTROTHERM INDIA PRIVATE LIMITED",
"ELECTROTHERM SOLAR LIMITED",
"ELECTROVARIANT TECHNOLOGY PRIVATE LIMITED",
"ELECTROVAST SOLUTIONS PRIVATE LIMITED",
"ELECTROVEEN ENGINEERING PRIVATE LIMITED",
"ELECTROWER INDIA PRIVATE LIMITED",
"ELECTROWER TECHNOLOGIES PRIVATE LIMITED",
"ELECTROWING TECHNOLOGIES PRIVATE LIMITED",
"ELECTRUM CAPITAL PRIVATE LIMITED",
"ELECTRUM PORTFOLIO MANAGERS PRIVATE LIMITED",
"ELECTRYONE POWER PRIVATE LIMITED",
"ELEEANORA IMAGES PRIVATE LIMITED",
"ELEEGANCE BAGS PRIVATE LIMITED",
"ELEETPRO TECHNOLOGY PRIVATE LIMITED",
"ELEGANCE AVENUES PRIVATE LIMITED",
"ELEGANCE CAPITAL SERVICES PRIVATE LIMITED",
"ELEGANCE MENWEARS PRIVATE LIMITED",
"ELEGANCE METAL PRIVATE LIMITED",
"ELEGANCE SERVICES PRIVATE LIMITED",
"ELEGANCE SKYZ PRIVATE LIMITED",
"ELEGANCE TMT PRIVATE LIMITED",
"ELEGANCE TRADELINKS PRIVATE LIMITED",
"ELEGANT ASSOCIATES PRIVATE LIMITED",
"ELEGANT AUTO INDIA PRIVATE LIMITED",
"ELEGANT AUTOMOBILES PRIVATE LIMITED",
"ELEGANT BEVERAGES PRIVATE LIMITED",
"ELEGANT BUILDERS & DEVELOPERS",
"ELEGANT BUSINESS SOLUTIONS PRIVATE LIMITED",
"ELEGANT CARS PRIVATE LIMITED",
"ELEGANT CASTING PRIVATE LIMITED",
"ELEGANT CHEMICALS ENTERPRISES PRIVATE LIMITED",
"ELEGANT COATINGS PRIVATE LIMITED",
"ELEGANT COSMED PRIVATE LIMITED",
"ELEGANT CUTTING TECHNIQUES PRIVATE LIMITED",
"ELEGANT DRUGS PRIVATE LIMITED",
"ELEGANT DYEING AND PROCESSING LIMITED",
"ELEGANT DYEING AND PROCESSING PRIVATE LIMITED",
"ELEGANT EDIFICE PRIVATE LIMITED",
"ELEGANT EMBEDDED SOLUTIONS PRIVATE LIMITED",
"ELEGANT ENTERPRISES",
"ELEGANT EXPRESS LOGISTICS PRIVATE LIMITED",
"ELEGANT FACILITY MANAGEMENT PRIVATE LIMITED",
"ELEGANT FASHION FIBER CHEMICALS LIMITED",
"ELEGANT FLORICULTURE & AGROTECH (INDIA) LIMITED",
"ELEGANT FLORICULTURE & AGROTECH INDIA LIMITED",
"ELEGANT FOAM AND FURNISHING PRIVATE LIMITED",
"ELEGANT GALAXY PRIVATE LIMITED",
"ELEGANT HYGIENE PRIVATE LIMITED",
"ELEGANT INFRAWORLD PRIVATE LIMITED",
"ELEGANT ISPAT PVT LTD",
"ELEGANT MARBLES AND GRANI INDUSTRIES LIMITED",
"ELEGANT MARINE SERVICES PRIVATE LIMITED",
"ELEGANT MARK ENGINEERING PRIVATE LIMITED",
"ELEGANT MERCANTILE PRIVATE LIMITED",
"ELEGANT METALS & MINERALS PRIVATE LIMITED",
"ELEGANT MICROWEB TECHNOLOGIES PRIVATE LIMITED",
"ELEGANT MKT PRIVATE LIMITED",
"ELEGANT NETWORK SERVICES PRIVATE LIMITED",
"ELEGANT OFFSET PRINTERS PRIVATE LIMITED",
"ELEGANT PRODUCTS PRIVATE LIMITED",
"ELEGANT ROCKS PRIVATE LIMITED",
"ELEGANT SHIP MANAGEMENT & CONSULTANCY SERVICES PRIVATE LIMITED",
"ELEGANT STONES PRIVATE LIMITED",
"ELEGANT SUPERPOLYPLAST PRIVATE LIMITED",
"ELEGANT TECHNOLOGIES INDIA PRIVATE LIMITED",
"ELEGANT TECHNOSEC INDIA PRIVATE LIMITED",
"ELEGANT VINCOM PRIVATE LIMITED",
"ELEGANT VINYL PRIVATE LIMITED",
"ELEGANTE INTERNATIONAL EXPORTS PRIVATE LIMITED",
"ELEGANZ INTERIORS LIMITED",
"ELEGANZ INTERIORS PRIVATE LIMITED",
"ELEGANZA FURNISHINGS PRIVATE LIMITED",
"ELEGARE BEAUTY PRIVATE LIMITED",
"ELEGENT BUSINESS SOLUTIONS PRIVATE LIMITED",
"ELEGENT INFRASTRUCTURE PRIVATE LIMITED",
"ELEGENT INFRASTRUCTURE PVT LTD",
"ELEKORE SYSTEMS PRIVATE LIMITED",
"ELEKTA MEDICAL SYSTEMS INDIA PRIVATE LIMITED",
"ELEKTRIKA SOLUTIONS PRIVATE LIMITED",
"ELEKTRISOLA INDIA PRIVATE LIMITED",
"ELEKTRO BATTERY SOLUTIONS (INDIA) PRIVATE LIMITED",
"ELEKTROBIT INDIA PRIVATE LIMITED",
"ELEKTROCRAFT (INDIA) PRIVATE LIMITED",
"ELEKTROLITES POWER PRIVATE LIMITED",
"ELEKTROMAG DEVICES PRIVATE LIMITED",
"ELEKTROMAG-JOEST VIBRATION PRIVATE LIMITED",
"ELEKTRON LIGHTING SYSTEMS PRIVATE LIMITED",
"ELEKTRONIK LAB",
"ELEKTRONIKA SALES PRIVATE LIMITED",
"ELEL INTEGRATED FACILITIES MANAGEMENT PRIVATE LIMITED",
"ELEM BUSINESS INDIA PRIVATE LIMITED",
"ELEM HOLDINGS INDIA PRIVATE LIMITED",
"ELEMAC LIFTS PRIVATE LIMITED",
"ELEMATIC INDIA PRIVATE LIMITED",
"ELEMCO",
"ELEMENT CHEMILINK PRIVATE LIMITED",
"ELEMENT HOMES",
"ELEMENT INFOMATICS (INDIA) PRIVATE LIMITED",
"ELEMENT INFOTECH PRIVATE LIMITED",
"ELEMENT K INDIA PRIVATE LIMITED",
"ELEMENT PHARMACEUTICALS PRIVATE LIMITED",
"ELEMENT RETAILS PRIVATE LIMITED",
"ELEMENT SEVEN GARMENT AND TEXTILES PRIVATE LIMITED",
"ELEMENT115 COMPUTECH PRIVATE LIMITED",
"ELEMENT14 INDIA PRIVATE LIMITED",
"ELEMENT8 TRANSFORMATION SOLUTIONS PRIVATE LIMITED",
"ELEMENTAL CONNECTORS PRIVATE LIMITED",
"ELEMENTAL FIXTURES PRIVATE LIMITED",
"ELEMENTAL REALTY PRIVATE LIMITED",
"ELEMENTARY AUTO-TECH PRIVATE LIMITED",
"ELEMENTIS SPECIALTIES INDIA PRIVATE LIMITED",
"ELEMENTS 5 EVENTS PRIVATE LIMITED",
"ELEMENTS EDUCARE PRIVATE LIMITED",
"ELEMENTS ELECTROMECH PRIVATE LIMITED",
"ELEMENTS EXPORTS PRIVATE LIMITED",
"ELEMENTS FINANCIAL SOLUTIONS PRIVATE LIMITED",
"ELEMENTS HOMESTEAD PRODUCTS PRIVATE LIMITED",
"ELEMENTS HR SERVICES PRIVATE LIMITED",
"ELEMENTS LANDSCAPE ARCHITECTURE URBAN DE SIGN & PLANNING STUDIO LLP",
"ELEMENTS LEARNING CENTRE PRIVATE LIMITED",
"ELEMENTS MEDIAWORKS PRIVATE LIMITED",
"ELEMENTS PREFAB PRIVATE LIMITED",
"ELEMENTS PRODUCTION SERVICES PRIVATE LIMITED",
"ELEMENTS TECHNOFAB PRIVATE LIMITED",
"ELEMENTS WELLNESS PRIVATE LIMITED",
"ELEMENTTO LIFE STYLES PRIVATE LIMITED",
"ELEMENTZ ENGINEERS GUILD PRIVATE LIMITED",
"ELEMESH TECH SOLUTIONS PRIVATE LIMITED",
"ELENA GEO SYSTEMS PRIVATE LIMITED",
"ELENA POWER AND INFRASTRUCTURE LIMITED",
"ELENA RENEWABLE ENERGY PRIVATE LIMITED",
"ELENESS LOGISTICS SERVICES PRIVATE LIMITED",
"ELENIUM AUTOMATION PRIVATE LIMITED",
"ELENJICAL SOLUTIONS PRIVATE LIMITED",
"ELENSER ENGINEERING INDIA PRIVATE LIMITED",
"ELENT ELECTRONICS PRIVATE LIMITED",
"ELENTEC INDIA PRIVATE LIMITED.",
"ELENTEC POWER INDIA (EPI) PRIVATE LIMITED",
"ELENTEC TECHNOLOGIES PRIVATE LIMITED",
"ELENVIO SOLUTIONS PRIVATE LIMITED",
"ELEORA ELECTRICALS & ENGINEERS PRIVATE LIMITED",
"ELEPHANT DESIGN PRIVATE LIMITED",
"ELEPHANT GYPSUM PRIVATE LIMITED",
"ELEPHANT INDIA ADVISORS PRIVATE LIMITED",
"ELEPHANT INDIA FINANCE PRIVATE LIMITED",
"ELEPHANTA INDUSTRIES PRIVATE LIMITED",
"ELEPHANTEER PRIVATE LIMITED",
"ELEPHAS ENGINEERING & PROJECTS PRIVATE LIMITED",
"ELEQUIP TOOLS PRIVATE LIMITED",
"ELES VINYL PRIVATE LIMITED",
"ELESA AND GANTER INDIA PRIVATE LIMITED",
"ELEST PRIVATE LIMITED",
"ELESTAR CRANE SYSTEMS PRIVATE LIMITED",
"ELET HOSPITALITY LLP",
"ELETE BIOTECH PRIVATE LIMITED",
"ELETRONEUMATICS AND HYDRAULICS INDIA PRIVATE LIMITED",
"ELETS TECHNOMEDIA PRIVATE LIMITED",
"ELETTA INSTRUMENTATION INDIA PRIVATE LIMITED",
"ELETTROMIL INDIA PRIVATE LIMITED",
"ELETUS VENTURES PRIVATE LIMITED",
"ELEVAR POLYTECH PRIVATE LIMITED",
"ELEVAR SPORTS PRIVATE LIMITED",
"ELEVAR TECHNOLOGIES PRIVATE LIMITED",
"ELEVATE BPO SERVICES PRIVATE LIMITED",
"ELEVATE BUILDCON PRIVATE LIMITED",
"ELEVATE ENTERTAINMENTS PRIVATE LIMITED",
"ELEVATE HVAC ENGINEERS",
"ELEVATE INDIA BUSINESS CONSULTANTS PRIVATE LIMITED",
"ELEVATE SERVICES INDIA PRIVATE LIMITED",
"ELEVATI INFOTECH PRIVATE LIMITED",
"ELEVATION HUMAN PRIVATE LIMITED",
"ELEVATION LAND DEVELOPERS PRIVATE LIMITED",
"ELEVATION SOLUTIONS PRIVATE LIMITED",
"ELEVATOZ LOYALTY PRIVATE LIMITED",
"ELEVE MEDIA PRIVATE LIMITED",
"ELEVEN COURSE HOSPITALITY PRIVATE LIMITED",
"ELEVEN INTERNET SERVICES LLP",
"ELEVENTHD SOLUTIONS PRIVATE LIMITED",
"ELEVENTURE SYSTEMS & SERVICES PRIVATE LIMITED",
"ELEVONDATA LABS PRIVATE LIMITED",
"ELEX ALUMINUM PRODUCTS PRIVATE LIMITED",
"ELEX INDIA PRIVATE LIMITED",
"ELEXES MEDICAL CONSULTING PRIVATE LIMITED",
"ELEZER AUTOMATION INDIA PRIVATE LIMITED",
"ELF ELECTROLUMECH INDIA PRIVATE LIMITED",
"ELF SHIPPING INDIA PRIVATE LIMITED",
"ELF TRADING & CHEMICALS MANUFACTURING LIMITED",
"ELF TRADING AND CHEMICAL MANUFACTURING PRIVATE LIMITED",
"ELFIN AGRO INDIA PRIVATE LIMITED",
"ELFIN DRUGS PRIVATE LIMITED",
"ELFIN INFRA BUILDERS PRIVATE LIMITED",
"ELFIN MANAGEMENT CONSULTANCY SERVICES PRIVATE LIMITED",
"ELFONZE TECHNOLOGIES PRIVATE LIMITED",
"ELFY PRIME PRODUCTS PRIVATE LIMITED",
"ELG INDIA PRIVATE LIMITED",
"ELGAN INDIA MARTRADE PRIVATE LIMITED",
"ELGER CONTROLS INDIA PRIVATE LIMITED",
"ELGI AUTOMOTIVE SERVICES PRIVATE LIMITED",
"ELGI ELECTRIC AND INDUSTRIES LIMITED",
"ELGI EQUIPMENTS LIMITED",
"ELGI RUBBER COMPANY LIMITED",
"ELGI SAUER COMPRESSORS LIMITED",
"ELGI TYRE AND TREAD LIMITED",
"ELGI ULTRA INDUSTRIES LIMITED",
"ELGI ULTRA INDUSTRIES PRIVATE LIMITED",
"ELGI ULTRA PRIVATE LIMITED",
"ELGIN ELECTRONICS PRIVATE LIMITED",
"ELGIN HOTELS PVT.LTD.",
"ELGIVA BUSINESS SOLUTIONS PRIVATE LIMITED",
"ELGREEN RECYCLING PRIVATE LIMITED",
"ELGRIS SOLAR POWER SYSTEMS PRIVATE LIMITED",
"EL-GUARD INDIA PRIVATE LIMITED",
"ELHANAN MANAGEMENT SERVICES PRIVATE LIMITED",
"ELHARD MARKETING LIMITED",
"ELHEAT CERAMIC ENGINEERING PRIVATE LIMITED",
"ELI HEALTH SOLUTIONS PRIVATE LIMITED",
"ELI LILLY AND COMPANY",
"ELI LILLY SERVICES INDIA PRIVATE LIMITED",
"ELI RESEARCH INDIA PRIVATE LIMITED",
"ELI SHARED SERVICES PRIVATE LIMITED",
"ELIAN TRADING COMPANY P LTD",
"ELIANA ART PRIVATE LIMITED",
"ELICA PB WHIRLPOOL KITCHEN APPLIANCES PRIVATE LIMITED",
"ELICA VITRIFIED PRIVATE LIMITED",
"ELICAD PHARMACEUTICALS PRIVATE LIMITED",
"ELICAST PRIVATE LIMITED",
"ELICO HEALTHCARE SERVICES LIMITED",
"ELICO LIMITED",
"ELICO MARKETING PRIVATE LIMITED",
"ELIFACT PRIVATE LIMITED",
"ELIGA INNOVATIVE SERVICES PRIVATE LIMITED",
"E-LIGHTS TECHNO PARK PRIVATE LIMITED",
"ELIGHTWALK TECHNOLOGY PRIVATE LIMITED",
"ELIGIBLE RESEARCH AND DEVELOPMENT CENTER PRIVATE LIMITED",
"ELIKEM PHARMACEUTICALS PRIVATE LIMITED",
"ELIM CHEM PRIVATE LIMITED",
"ELIMS HEALTH CARE PRIVATE LIMITED",
"ELIN APPLIANCES PRIVATE LIMITED",
"ELIN ELECTRONICS LIMITED",
"ELIN ELECTRONICS LTD.",
"ELIN POWERTECH PRIVATE LIMITED",
"ELIND INDUCTION FURNACES P LIMITED",
"ELINK ASSOCIATES PRIVATE LIMITED",
"E-LINK SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"ELINOR PHARMACEUTICALS PRIVATE LIMITED",
"ELINS SWITCHBOARDS PRIVATE LIMITED",
"ELINT VISTAS PRIVATE LIMITED",
"ELINWG INDIA PRIVATE LIMITED",
"ELIO NATURAL RESOURCES PRIVATE LIMITED",
"ELION HEALTHCARE PRIVATE LIMITED",
"ELION TECHNOLOGIES AND CONSULTING PRIVATE LIMITED",
"ELIOR INDIA FOOD SERVICES LLP",
"ELIOS RECRUITMENT INDIA PRIVATE LIMITED",
"ELIPH NUTRITION PRIVATE LIMITED",
"ELIPSE LABS MARKETING PRIVATE LIMITED",
"ELIS HOSPITALITY SERVICE",
"ELIS PHARMACEUTICALS INDIA PRIVATE LIMITED",
"ELIS TECHNO SYSTEMS INDIA PRIVATE LIMITED",
"ELISA BIOTECH PRIVATE LIMITED",
"ELISA HOME APPLIANCES PRIVATE LIMITED",
"ELISAR LIFE SCIENCES PRIVATE LIMITED",
"ELISCRIPTION PRIVATE LIMITED",
"ELISHA LOGISTICS COMPANY",
"ELISION TECHNOLOGIES PRIVATE LIMITED",
"ELISIR LIFESTYLE PRIVATE LIMITED",
"ELITAZ PRIVATE LIMITED",
"ELITE (INDIA) PRIVATE LIMITED",
"ELITE AGRO SPECIALITIES",
"ELITE AIR TECHNIQUES PRIVATE LIMITED",
"ELITE AIRCON SOLUTIONS PRIVATE LIMITED",
"ELITE AQUA TRADERS PRIVATE LIMITED",
"ELITE AUTO ENGINEERS PRIVATE LIMITED",
"ELITE AUTOMOBILES PRIVATE LIMITED",
"ELITE BASKET PRIVATE LIMITED",
"ELITE BUILDCARE PRIVATE LIMITED",
"ELITE BUILDING MATERIALS PRIVATE LIMITED",
"ELITE BUSINESS MACHINES PRIVATE LIMITED",
"ELITE CARBON CREATIONS PRIVATE LIMITED",
"ELITE CARTONS PRIVATE LIMITED",
"ELITE CHILDRENS PARK",
"ELITE COLLECTION INC",
"ELITE COMPUTERS AND COMMUNICATIONS PRIVATE LIMITED",
"ELITE CONTRACTORS CHENNAI PRIVATE. LIMITED.",
"ELITE CREATIONS PRIVATE LIMITED",
"ELITE DECOR PRIVATE LIMITED",
"ELITE DESIGN PRIVATE LIMITED",
"ELITE DHOBILITE LAUNDRY PRIVATE LIMITED",
"ELITE DISTILLERIES PRIVATE LIMITED",
"ELITE ENGINEERING & CONSTRUCTIONS HYD PRIVATE LIMITED",
"ELITE FACILITIES AND SYSTEMS PRIVATE LIMITED",
"ELITE FALCONS TECH SECURITY PRIVATE LIMITED",
"ELITE FITNESS AND ENTERTAINMENT PRIVATE LIMITED",
"ELITE FOAM PRIVATE LIMITED",
"ELITE FOOD SPECIALITIES PRIVATE LIMITED",
"ELITE FOODS PRIVATE LIMITED",
"ELITE FOOTWEAR PVT LTD",
"ELITE FOREX PRIVATE LIMITED",
"ELITE GENERAL INSURANCE SERVICES PRIVATE LIMITED",
"ELITE GLOBAL BUSINESS SERVICES PRIVATE LIMITED",
"ELITE GOODS ENTERPRISE PRIVATE LIMITED",
"ELITE GREEN PRIVATE LIMITED",
"ELITE HAIR STUDIO PRIVATE LIMITED",
"ELITE HOMES PRIVATE LIMITED",
"ELITE HOSPITAL",
"ELITE INDIA CONSTRUCTIONS PRIVATE LIMITED",
"ELITE INDIA PRIVATE LIMITED",
"ELITE INDIA RUBBER PRODUCTS PVT LTD",
"ELITE INDUSTRIES",
"ELITE INFORMATION TECHNOLOGY PRIVATE LIMITED",
"ELITE INFRA ESTATE PRIVATE LIMITED",
"ELITE INSTRUMENTS",
"ELITE LAMINATES PRIVATE LIMITED",
"ELITE LANDBASE PRIVATE LIMITED",
"ELITE MARINERS PRIVATE LIMITED",
"ELITE MARKET RESEARCH PRIVATE LIMITED",
"ELITE MATRICULATION HIGHER SECONDARY SCHOOL",
"ELITE METALIKS PRIVATE LIMITED",
"ELITE MICROSYSTEMS PRIVATE LIMITED",
"ELITE MINDZ PRIVATE LIMITED",
"ELITE MISSION HOSPITAL KOORKENCHERY",
"ELITE MOTORS PRIVATE LIMITED",
"ELITE MULTI SPECIALITY HOSPITAL PRIVATE LIMITED",
"ELITE MULTIHOUSING PRIVATE.LIMITED",
"ELITE NATURAL OILS & FUELS PRIVATE LIMITED",
"ELITE OCEAN LINE PRIVATE LIMITED",
"ELITE OFFSHORE PRIVATE LIMITED",
"ELITE ORGO CHEM PRIVATE LIMITED",
"ELITE ORTHOPAEDICS PRIVATE LIMITED",
"ELITE PALOUME FORWARDERS CHENNAI PRIVATE LIMITED",
"ELITE PLAST AUTOSYSTEMS PRIVATE LIMITED",
"ELITE POWER PROJECTS & CONSTRUCTION PRIVATE LIMITED",
"ELITE POWERTECH PRIVATE LIMITED",
"ELITE PRECISION TECHNOLOGIES PRIVATE LIMITED",
"ELITE PRODUCTS INDIA PRIVATE LIMITED",
"ELITE PROPERTIES",
"ELITE REALTY CONSULTANTS PRIVATE LIMITED",
"ELITE ROADWAYS PRIVATE LIMITED",
"ELITE SHIPPING AGENCIES INDIA PRIVATE LIMITED",
"ELITE SHIPPING SYNERGIES PRIVATE LIMITED",
"ELITE STEELS PRIVATE LIMITED",
"ELITE SURGICAL PRIVATE LIMITED",
"ELITE TECHNOCRATS PRIVATE LIMITED",
"ELITE TECHXPERT INDIA PRIVATE LIMITED",
"ELITE TEKNICA PRIVATE LIMITED",
"ELITE THERMAL ENGINEERS PRIVATE LIMITED",
"ELITE VAM AUXICHEM PRIVATE LIMITED",
"ELITE VINTAGE WINERY INDIA PRIVATE LIMITED",
"ELITE WEALTH LIMITED",
"ELITECH CONSERV PRIVATE LIMITED",
"ELITECH CONSULTING PRIVATE LIMITED",
"ELITECH EARTH SCIENCE PRIVATE LIMITED",
"ELITECON INTERNATIONAL LIMITED",
"ELITECORE TECHNOLOGIES PRIVATE LIMITED",
"ELITEENERGY AUTO MOTIVES PRIVATE LIMITED",
"ELITEERA CONSTRUCTIONS PRIVATE LIMITED",
"ELITES BOOKS PRIVATE LIMITED",
"ELITESOL INNOVATE INDIA PRIVATE LIMITED",
"ELITSER IT SOLUTIONS INDIA PRIVATE LIMITED",
"ELITZ LIFESTYLE PRIVATE LIMITED",
"ELIVE TECHNOCRATS PRIVATE LIMITED",
"ELIVIA LIFESCIENCES PRIVATE LIMITED",
"ELIX FRESHENERS INDIA PRIVATE LIMITED",
"ELIXI HITEC PRIVATE LIMITED",
"ELIXIA PHARMACEUHCAL PRIVATE.LIMITED",
"ELIXIA TECH SOLUTIONS LIMITED",
"ELIXIR BUILDCON PRIVATE LIMITED",
"ELIXIR CAPITAL LIMITED",
"ELIXIR COMPUTECH PRIVATE LIMITED",
"ELIXIR ENGINEERING PRIVATE LIMITED",
"ELIXIR ENTERPRISES AND HOTELS PRIVATE LIMITED",
"ELIXIR ENVIRO SYSTEMS PRIVATE LIMITED",
"ELIXIR EQUITIES PRIVATE LIMITED",
"ELIXIR EXOTIC FOODS AND ALLIED PRODUCTS PRIVATE LIMITED",
"ELIXIR EXTRACTS PRIVATE LIMITED",
"ELIXIR HOME CARE PRIVATE LIMITED",
"ELIXIR INFRASTRUCTURE (INDIA) PRIVATE LIMITED",
"ELIXIR INSURANCE SERVICES PRIVATE LIMITED",
"ELIXIR INTEGRATED BRANDCOMM PRIVATE LIMITED",
"ELIXIR JEWELS PRIVATE LIMITED",
"ELIXIR MEDISERVE PRIVATE LIMITED",
"ELIXIR MET FORM PRIVATE LIMITED",
"ELIXIR NETCONNECT PRIVATE LIMITED",
"ELIXIR SOFTLAB SOLUTIONS PRIVATE LIMITED",
"ELIXIR SOLTEK PRIVATE LIMITED",
"ELIXIR TECHNOLOGIES PRIVATE LIMITED",
"ELIXIR TOOLS AND SPECIALITIES PRIVATE LIMITED",
"ELIXIR WEALTH MANAGEMENT PRIVATE LIMITED",
"ELIZE COMPUTERISED EMBROIDERY",
"ELIZE LIFESTYLE PRIVATE LIMITED",
"ELJAY ENGINEERING INDIA PRIVATE LIMITED",
"ELJAY ENTERPRISES LLP",
"ELK EDUCATION CONSULTANTS PRIVATE LIMITED",
"ELK HILL ESTATES PRIVATE LIMITED",
"ELKART PRIVATE LIMITED",
"ELKAY CHEMICALS PRIVATE LIMITED",
"ELKAY COMMODITIES PRIVATE LIMITED",
"ELKAY COTTON PRIVATE LIMITED",
"ELKAY ELECTROMECH INDIA PRIVATE LIMITED",
"ELKAY LABELS PRIVATE LIMITED",
"ELKAY SPIRITS PRIVATE LIMITED",
"ELKAYEM AUTO ANCILLARIES PRIVATE LIMITED",
"ELKAYPEE SPINNERS PRIVATE LIMITED",
"ELKEM SOUTH ASIA PRIVATE LIMITED",
"ELKEN INTERNATIONAL INDIA PRIVATE LIMITED",
"ELKINS TRADELINK LIMITED",
"ELKO PROPERTIES AND DEVELOPERS PRIVATE LIMITED",
"ELKOM ENTERPRISES PVT LTD",
"ELKOS HEALTHCARE PRIVATE LIMITED",
"ELKOS PENS LIMITED",
"ELKRAFT HEALTH AND NUTRITION PRIVATE LIMITED",
"ELL ESS ENGINEERING PRIVATE LIMITED",
"ELL VEE TEA ESTATE PRIVATE LIMITED",
"ELLA FOODS PRIVATE LIMITED",
"ELLAAR INFOTEK SOLUTIONS PRIVATE LIMITED",
"ELLAILAXMI MONOSET",
"ELLAK CHEM INDUSTRIES (INDIA) PRIVATE LIMITED",
"ELLANTRA AUTOMATION PRIVATE LIMITED",
"ELLAR COFFEE PRIVATE LIMITED",
"ELLARA BUSINESS CENTRE PRIVATE LIMITED",
"ELLBEE HOSPITALITY WORLDWIDE PRIVATE LIMITED",
"ELLE ELECTRICALS PRIVATE LIMITED",
"ELLECHA GLOBAL PRIVATE LIMITED",
"ELLEN INDUSTRIES PRIVATE LIMITED",
"ELLEN PACKAGING PRIVATE LIMITED",
"ELLEN TEXTILES PRIVATE LIMITED",
"ELLENBARRIE CHEMICAL ALLIED PVT LTD",
"ELLENBARRIE INDUSTRIAL GASES LIMITED.",
"ELLENBARRIE TEA & INDUSTRIES PRIVATE LIMITED",
"ELLEYS INDUSTRIES (INDIA) PRIVATE LIMITED",
"ELLFORD FINE CHEMICALS PRIVATE LIMITED",
"ELLFORD IMPEX PRIVATE LIMITED",
"ELLIANCE CONTAINER SERVICES PRIVATE LIMITED",
"ELLIAS INTERNATIONAL PRIVATE LIMITED",
"ELLICIUM SOLUTIONS PRIVATE LIMITED",
"ELLINE TECHMART PRIVATE LIMITED",
"ELLIOTT EBARA TURBOMACHINERY INDIA PRIVATE LIMITED",
"ELLIPSIS INFOTECH",
"ELLIPSOID CONSULTING LLP",
"ELLISBRIDGE TRADING PRIVATE LIMITED",
"ELLISON OILFIELD SERVICES PRIVATE LIMITED",
"ELLJAY TEXTILES PRIVATE LIMITED",
"ELLKRAM VISUAL COMMUNICATION PRIVATE LIMITED",
"ELLORA ASIAN REALTY PRIVATE LIMITED",
"ELLORA BEARING AND PLASTOTECH PRIVATE LIMITED",
"ELLORA CONSTRUCTIONS PRIVATE. LIMITED.",
"ELLORA CREATIONS PRIVATE LIMITED",
"ELLORA ENGLISH SCHOOL IN SCI JN COLLEGE",
"ELLORA GASES PRIVATE LIMITED",
"ELLORA MEDICALS & EDUCATIONAL FOUNDATION AARYANS WORLD SCHOOL",
"ELLORA MILK PRODUCTS LIMITED",
"ELLORA NATURAL SEEDS PRIVATE LIMITED",
"ELLORA PAPER MILLS",
"ELLORA PARK HOSPITAL PVT LTD",
"ELLORA PROJECT CONSULTANTS PRIVATE LIMITED",
"ELLORA PROPERTY SERVICES PRIVATE LIMITED",
"ELLORA SHAWLS PRIVATE LIMITED",
"ELLORAKRITI INFRATECH PRIVATE LIMITED",
"ELLOW TALENT MARKETPLACES PRIVATE LIMITED",
"ELLSWORTH ADHESIVES INDIA PRIVATE LIMITED",
"ELLUCIAN HIGHER EDUCATION SYSTEMS INDIA PRIVATE LIMITED",
"ELLUME SOLAR PRIVATE LIMITED",
"ELLUMINATI",
"ELM DESIGNS PRIVATE LIMITED",
"ELM ENTERPRISES PRIVATE LIMITED",
"ELMA PHARMACEUTICALS PRIVATE LIMITED",
"ELMAC AGRO 'MFG' PRIVATE LIMITED",
"ELMACH PACKAGES INDIA PRIVATE LIMITED",
"ELMACK ENGG SERVICES PRIVATE LIMITED",
"ELMAG DEVICES PRIVATE LIMITED",
"ELMAS MAGNETICS PRIVATE LIMITED",
"ELMEASURE INDIA PRIVATE LIMITED",
"ELMEC TECHNOPAC MACHINERIES PRIVATE LIMITED",
"ELMEC TOOLS AND DEVICES PRIVATE LIMITED",
"ELMECH AUTOMATIONS PRIVATE LIMITED",
"ELMECH CRANES AND COMPONENTS PRIVATE LIMITED",
"ELMECH ENGINEERS",
"ELMECH LABS PRIVATE LIMITED",
"ELMECO PROJECTS PRIVATE LIMITED",
"ELMER PRODUCTS PVT LTD",
"ELMERELECT INDIA PRIVATE LIMITED",
"ELMEX CONTROLS PRIVATE LIMITED",
"ELMEX ELECTRIC PRIVATE LIMITED",
"ELMEX ELECTRICALS AND ELECTRONICS PVT LTD",
"ELMON SYSTEMS PRIVATE LIMITED",
"ELMOR CARES INDIA PRIVATE LIMITED",
"ELMOT ALTERNATORS PRIVATE LIMITED",
"ELMS SPORTS FOUNDATION",
"ELNET TECHNOLOGIES LIMITED",
"ELNOVA PHARMA",
"ELOCITY TECHNOLOGIES INDIA PRIVATE LIMITED",
"ELOF HANSSON (INDIA) PRIVATE LIMITED",
"ELOF HANSSON LIMITED,",
"ELOFIC INDUSTRIES LIMITED",
"ELOFIC INDUSTRIES LIMITED.",
"ELOGIC SOLUTIONS INDIA PRIVATE LIMITED",
"ELOGIC TECHNOLOGIES PRIVATE LIMITED",
"ELOGIST SOLUTIONS PRIVATE LIMITED",
"ELOGIX SOFTWARE PRIVATE LIMITED",
"ELOIT INNOVATIONS PRIVATE LIMITED",
"EL-O-MATIC INDIA PRIVATE LIMITED",
"ELOMATIC-PHARMALAB CONSULTING AND ENGINEERING PRIVATE LIMITED",
"ELON PRECISION ENGINEERING PRIVATE LIMITED",
"ELOQUENCE RESTAURANT PRIVATE LIMITED",
"ELOQUENT ADVISORY PRIVATE LIMITED",
"ELOQUENT EXIM PRIVATE LIMITED",
"ELOQUENT INFO SOLUTIONS PRIVATE LIMITED",
"ELOQUENT STEEL PRIVATE LIMITED",
"ELORA BIOSCIENCES PRIVATE LIMITED",
"ELORA GREEN TECH SYSTEMS PRIVATE LIMITED",
"ELORCE INDUSTRIES PRIVATE LIMITED",
"EL-OS FORMUSOLS INDIA PRIVATE. LIMITED.",
"ELP CONSULTANTS INDIA PRIVATE LIMITED",
"ELP SOLAR ONE PRIVATE LIMITED",
"ELPEE COMMERCIAL LIMITED",
"ELPEE MANAGED PRINT SOLUTIONS PRIVATE LIMITED",
"ELPEE OVERSEAS PVT LTD",
"ELPHA POLYCHEM PRIVATE LIMITED",
"ELPHILL TECHNOLOGY PRIVATE LIMITED",
"ELPHINSTONE COLLEGE",
"ELPHINSTONE TECHNICAL HIGH SCHOOL",
"ELPIDA HOMES PRIVATE LIMITED",
"ELPIS COMPONENTS DISTRIBUTORS PRIVATE LIMITED",
"ELPIS IT SOLUTIONS PRIVATE LIMITED",
"ELPIS TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"ELPOWER CONTROL SYSTEMS PRIVATE LIMITED",
"ELPPE CHEMICALS PRIVATE LIMITED",
"ELPRO ENERGY DIMENSIONS PRIVATE LIMITED",
"ELPRO INTERNATIONAL LIMITED",
"ELPRO INTERNATIONAL SCHOOL",
"ELPRON EXCHANGE WATER ENGINEERING PRIVATE LIMITED",
"ELQUE VENTURES PRIVATE LIMITED",
"ELRICH INTERNATIONAL PRIVATE LIMITED",
"ELRINGKLINGER AUTOMOTIVE COMPONENTS (INDIA) PRIVATE LIMITED",
"ELRKE PRECISIONS PRIVATE LIMITED",
"ELROM ENTERTAINMENT STUDIO 9 PRIVATE LIMITED",
"ELRON INSTRUMENT COMPANY PRIVATE LIMITED",
"ELROY MOTORS PRIVATE LIMITED",
"ELROY SUPERCARS PRIVATE LIMITED",
"ELS INTERNATIONAL EDUCATION PATHWAYS PRIVATE LIMITED",
"ELSA CONCRETING MACHINERY INDIA PRIVATE LIMITED",
"ELSAAN INDUSTRIES PRIVATE LIMITED",
"ELSAMEX MAINTENANCE SERVICES LIMITED",
"ELSAQ EDUCATIONAL SERVICES PRIVATE LIMITED",
"ELSCINT INDIA PRIVATE LIMITED",
"ELSENGARD SECURITY SYSTEMS PRIVATE LIMITED",
"ELSEQ TECHNOLOGIES PRIVATE LIMITED",
"ELSES DIGITAL SYSTEM PRIVATE LIMITED",
"ELSHADDAI TRADING PRIVATE LIMITED",
"ELSKER LIFESCIENCE PRIVATE LIMITED",
"ELSNER TECHNOLOGIES PRIVATE LIMITED",
"ELSON PACKAGING INDUSTRIES PRIVATE LIMITED",
"ELSOURCE CONSULTANCY SERVICES PRIVATE LIMITED",
"ELSPEC ENGINEERING (INDIA) PRIVATE LIMITED",
"ELSTEEL MODULAR PRODUCTS INDIA PRIVATE LIMITED",
"ELSTELLAR INTERNATIONAL PRIVATE LIMITED",
"ELSTER-INSTROMET INDIA PRIVATE LIMITED",
"ELSU REPOINTING ASIA PRIVATE LIMITED",
"ELT CORPORATE PRIVATE LIMITED",
"ELTA FANS INDIA PRIVATE LIMITED",
"ELTECH APPLIANCES PRIVATE LIMITED",
"ELTECH ELECTRODESIGNS AND ENERGY SYSTEMS PRIVATE LIMITED",
"ELTECH ENGINEERS AND CONSULTANTS BOMBAY PRIVATE LIMITED",
"ELTECH ENGINEERS PRIVATE LIMITED",
"ELTECH SERVICES PRIVATE LIMITED",
"ELTEK MOTOR (INDIA) PRIVATE LIMITED",
"ELTEK SGS PRIVATE LIMITED",
"ELTEL POWER PRIVATE LIMITED",
"ELTETE INDIA TRANSPORT PACKAGING COMPANY PRIVATE LIMITED",
"ELTEX INDIA PRIVATE LIMITED",
"ELTON MARKETING INDIA PRIVATE LIMITED",
"ELTRON ENERGY PRIVATE LIMITED",
"ELTRONICS MARKETING PRIVATE LIMITED",
"ELTROPY INDIA PRIVATE LIMITED",
"ELTUS MODE PRIVATE LIMITED",
"ELUCIDATA DATA CONSULTING PRIVATE LIMITED",
"ELUHIM LIMITED",
"ELULA TECH PRIVATE LIMITED",
"ELUMATEC INDIA PRIVATE LIMITED",
"ELUMINA ELEARNING SERVICES PRIVATE LIMITED",
"ELUMINOUS TECHNOLOGIES PRIVATE LIMITED",
"ELURU COLLEGE OF ENGINEERING & TECHNOLOGY",
"ELURU DISTRICT CO-OPERATIVE BANK LTD",
"ELURU JUTE MILLS PRIVATE LIMITED",
"ELVEE ENGINERING PRIVATE LIMITED",
"ELVEE JEWELS PRIVATE LIMITED",
"ELVEE SPRINGS PRIVATE LIMITED",
"ELVEEGO CIRCUITS PRIVATE LIMITED",
"ELVEETY INDUSTRIES PRIVATE LIMITED",
"ELVERA REALTORS PRIVATE LIMITED",
"ELVI BARDAHL INDIA PRIVATE LIMITED",
"ELVI COMERCIO INDIA PRIVATE LIMITED",
"ELVI CORPORATION INDIA PRIVATE LIMITED",
"ELVIA CARE PRIVATE LIMITED",
"ELVIS ELECTRIC INDUSTRIES",
"ELVIS SANITATION PRIVATE LIMITED",
"ELVTECH PRIVATE LIMITED",
"ELVY LIFESTYLE PRIVATE LIMITED",
"ELWICK LIFESCIENCES PRIVATE LIMITED",
"ELWINT LOGISTICS SOLUTIONS PRIVATE LIMITED",
"ELWORLD AGRO & ORGANIC FOODS PRIVATE LIMITED",
"ELXER COMMUNICATIONS DATA CENTRES PRIVATE LIMITED",
"ELXER COMMUNICATIONS PRIVATE LIMITED",
"ELXIRE IT SERVICES PRIVATE LIMITED",
"ELYCTIS INDIA PRIVATE LIMITED",
"ELYMER INTERNATIONAL PRIVATE LIMITED",
"ELYSIAN CONSULTANTS PRIVATE LIMITED",
"ELYSIAN HEALTH CARE PRIVATE LIMITED",
"ELYSIAN STUDIO PRIVATE LIMITED",
"ELYSIUM CAPITAL ADVISORY PRIVATE LIMITED",
"ELYSIUM ENTERTAINMENT PRIVATE LIMITED",
"ELYSIUM LABS PRIVATE LIMITED",
"ELYSIUM NET SOLUTION PRIVATE LIMITED",
"ELYSIUM PHARMACEUTICALS LIMITED",
"ELYSIUM PROPERTIES INDIA PRIVATE LIMITED",
"ELYSIUM REAL PROPERTIES",
"ELYSIUM TECHNOLOGIES PRIVATE LIMITED",
"ELYSSION ECOM PRIVATE LIMITED",
"ELYZIUM GLOBETROTTING PRIVATE LIMITED",
"ELYZIUM TECHNOLOGIES PRIVATE LIMITED",
"ELZA INDIA PRIVATE LIMITED",
"EM 2 INFOTECH INDIA PRIVATE LIMITED",
"EM CEE CEE SPORTS AGENCIES PVT LTD",
"EM ELECTRONIX PRIVATE LIMITED",
"EM EM PERSONAL CARE PRIVATE LIMITED",
"EM INVESTCO CAPITAL ADVISORS PRIVATE LIMITED",
"EM LOGISTICS PRIVATE LIMITED",
"EM PEE MOTORS LIMITED",
"EM RAAGA INFORMATICS LLP",
"EM TECHNIK INDIA PRIVATE LIMITED",
"EM3 AGRISERVICES PRIVATE LIMITED",
"EMA LUBES PVT LTD",
"EMA PARTNERS EXECUTIVE SEARCH PRIVATE LIMITED",
"EMA PARTNERS INDIA PRIVATE LIMITED",
"EMA SOLUTIONS PRIVATE LIMITED",
"EMAAR ALLOYS PRIVATE LIMITED",
"EMAAR DEVELOPERS ANDBUILDERS PRIVATE LIMITED",
"EMAAR DIAMONDS PRIVATE LIMITED",
"EMAAR INDIA COMMUNITY MANAGEMENT PRIVATE LIMITED",
"EMAAR INDIA LIMITED",
"EMAAR MGF CONSTRUCTION PRIVATE LIMITED",
"EMAG INDIA PRIVATE LIMITED",
"EMAGESOFT PRIVATE LIMITED",
"EMAGINE INDIA INC",
"EMAGINE PEOPLE SOLUTIONS PRIVATE LIMITED",
"EMAK GLASS FIBRE AND ACCESSORIES PRIVATE LIMITED",
"EMAKINA INDIA PRIVATE LIMITED",
"EMAMBIT PRIVATE LIMITED",
"EMAMI AGROTECH LIMITED",
"EMAMI ART PRIVATE LIMITED",
"EMAMI CEMENT LIMITED",
"EMAMI ESTATES PRIVATE LIMITED EEPL",
"EMAMI FRANK ROSS LIMITED",
"EMAMI HIGH RISE PRIVATE LIMITED EHRPL",
"EMAMI LIMITED",
"EMAMI PAPER MILLS LIMITED",
"EMAMI REALTY LIMITED",
"EMANTRAS INTERACTIVE TECHNOLOGIES PRIVATE LIMITED",
"EMARGINS PRIVATE LIMITED",
"EMARK ENERGISERS PRIVATE LIMITED",
"EMARK SECURITY SOLUTIONS INDIA PRIVATE LIMITED",
"EMARKET SOLUTIONS PRIVATE LIMITED",
"EMARKETZ INDIA PRIVATE LIMITED",
"EMARKONS AUTO COMPONENTS PRIVATE LIMITED",
"EMARS PERK ALLEN PRIVATE LIMITED",
"EMARSON INFOTECH PRIVATE LIMITED",
"EMART EXIM PRIVATE LIMITED",
"E-MART FOR YOU PRIVATE LIMITED",
"EMART GAMES PRIVATE LIMITED",
"EMART SOLUTIONS INDIA PRIVATE LIMITED",
"EMARTECH COOLING SOLUTIONS PRIVATE LIMITED",
"EMARTI DEVI WOMENS COLLEGE",
"EMARVE PRIVATE LIMITED",
"EMAS EXPRESSWAY PRIVATE LIMITED",
"EMAS OFFSHORE SERVICES PTE LIMITED",
"EMASK RECYCLING PRIVATE LIMITED",
"EMATRIX TECHNOLOGIES PRIVATE LIMITED",
"EMAX ENGINEERING SYSTEMS PRIVATE LIMITED",
"EMAXLABZ SOLUTIONS PRIVATE LIMITED",
"EMAY PETROLEUM DISTRIBUTORS PRIVATE LIMITED",
"EMAZEL TECH PRIVATE LIMITED",
"EMB MATRIMONIAL PRIVATE LIMITED",
"EMBABY GENERAL FINANCE INDIA PRIVATE LIMITED",
"EMBABY TRADING PRIVATE LIMITED",
"EMBARC INFORMATION TECHNOLOGY PRIVATE LIMITED",
"EMBARK LIFESCIENCE PRIVATE. LIMITED.",
"EMBARKATION HEADQUARTERS MUMBAI",
"EMBASS OF ISRAEL",
"EMBASSY BIOGENIC (INDIA) PRIVATE LIMITED",
"EMBASSY ELECTRICALS INDIA PRIVATE LIMITED",
"EMBASSY ENTERPRISES PVT LTD",
"EMBASSY INDUSTRIAL PARKS PRIVATE LIMITED",
"EMBASSY INFRA DEVELOPERS PRIVATE LIMITED",
"EMBASSY INN PRIVATE LIMITED",
"EMBASSY INTERIORS PRIVATE LIMITED",
"EMBASSY INTERNATIONAL RIDING SCHOOL",
"EMBASSY KNOWLEDGE INFRASTRUCTURE PROJECTS PRIVATE LIMITED",
"EMBASSY OF BELGIUM",
"EMBASSY OF FEDERAL DEMOCRATIC REPUBLIC OF ETHIOPIA",
"EMBASSY OF FINLAND",
"EMBASSY OF FRANCE",
"EMBASSY OF ICELAND",
"EMBASSY OF IRELAND",
"EMBASSY OF NORWAY",
"EMBASSY OF SWEDEN OF NEW DELHI",
"EMBASSY OF SWITZERLAND",
"EMBASSY OF THE FEDERAL DEMOCRATIC REPUBLIC OF ETHIOPIA",
"EMBASSY OF THE REPUBLIC OF KOREA",
"EMBASSY OF THE REPUBLIC OF PERU",
"EMBASSY OF THE RUSSIAN FEDERATION CULTURAL DEPARTMENT",
"EMBASSY OF THE STATE OF KUWAIT",
"EMBASSY OF THE STATE OF QATAR",
"EMBASSY OF THE UNITED ARAB EMIRATES",
"EMBASSY OFFICE PARKS MANAGEMENT SERVICES PRIVATE LIMITED",
"EMBASSY OFFICE PARKS PRIVATE LIMITED",
"EMBASSY ONE COMMERCIAL PROPERTY DEVELOPMENTS PRIVATE LIMITED",
"EMBASSY ONE DEVELOPERS PRIVATE LIMITED",
"EMBASSY PRINTING INKS PRIVATE LIMITED",
"EMBASSY PROPERTY DEVELOPMENTS PRIVATE LIMITED",
"EMBASSY PUNE TECHZONE PRIVATE LIMITED",
"EMBASSY SERVICES PRIVATE LIMITED",
"EMBASSY SHELTERS PRIVATE LIMITED",
"EMBASSY SILICONES INDIA PRIVATE LIMITED",
"EMBASSY TRANSPORTATION INDIA PRIVATE LIMITED",
"EMBASSY-ENERGY PRIVATE LIMITED",
"EMBAUCHE INFOTECH SOLUTIONS PRIVATE LIMITED",
"EMBAUCHE RETAILERS PRIVATE LIMITED",
"EMBDES ENGINEERING SOLUTIONS PRIVATE LIMITED",
"EMBE TECH SOLUTION",
"EMBEDDED COMPUTING & POWER INDIA PRIVATE LIMITED",
"EMBEDDED CREATION",
"EMBEDDED DESIGNS SERVICES INDIA PRIVATE LIMITED",
"EMBEDDED IT SOLUTIONS INDIA PRIVATE LIMITED",
"EMBEDDED SYSTEMS SOLUTIONS PRIVATE LIMITED",
"EMBEDINFO TECHNOLOGIES INDIA PRIVATE LIMITED",
"EMBEDTECH SOLUTIONS PRIVATE LIMITED",
"EMBEDUR SYSTEMS(INDIA) PRIVATE LIMITED",
"EMBEE DIAGNOSTICS PRIVATE LIMITED",
"EMBEE FERRO ALLOY PRIVATE LIMITED",
"EMBEE FINANCIAL SERVICES LIMITED",
"EMBEE INSURANCE BROKERS LIMITED",
"EMBEE ROAD SERVICES PRIVATE LIMITED",
"EMBEE SOFTWARE PRIVATE LIMITED",
"EMBEE SOFTWARE PVT LTD",
"EMBELLIS SAREE PRIVATE LIMITED",
"EMBELLISH PHARMA TECH PRIVATE LIMITED",
"EMBELLISH PRODUCT CREATION PRIVATE LIMITED",
"EMBER TECHNOLOGIES PRIVATE LIMITED",
"EMBIEN TECHNOLOGIES INDIA PRIVATE LIMITED",
"EMBIN TECHNOLOGES PRIVATE LIMITED",
"EMBIO LIMITED",
"EMBIOTIC LABORATORIES PRIVATE LIMITED",
"EMBITEL TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"EMBL SHOPPING SERVICES INDIA PRIVATE LIMITED",
"EMBLAZE PLANNERS INDIA PRIVATE LIMITED",
"EMBODY EXIM PRIVATE LIMITED",
"EMBOLDEN CONSULTING SERVICES OPC PRIVATE LIMITED",
"EMBOZA GRANITO PRIVATE LIMITED",
"EMBRACE GAS PIPELINES PRIVATE LIMITED",
"EMBRACE GAS SERVICES PRIVATE LIMITED",
"EMBRACE INNOVATIONS PRIVATE LIMITED",
"EMBRACE METIER PRIVATE LIMITED",
"EMBRACE MULTIPRODUCTS PRIVATE LIMITED",
"EMBRAER ASIA PACIFIC PTE LTD",
"EMBREYO SEEDS PRIVATE LIMITED",
"EMBRIC VENTURES PRIVATE LIMITED",
"EMBRO ARTS PVT LTD",
"EMBROCIA FARMS PVT LTD",
"EMBROS PRINTERS PRIVATE LIMITED",
"EMBROSS SYSTEMS PRIVATE LIMITED",
"EMBRYO HEALTH PRIVATE LIMITED",
"EMBRYYO TECHNOLOGIES PRIVATE LIMITED",
"EMBTECH INNOVA PRIVATE LIMITED",
"EMBYTES SOLUTIONS PRIVATE LIMITED",
"EMC AUTOMATION PRIVATE LIMITED",
"EMC CORPORATION",
"EMC IT SOLUTIONS INDIA PRIVATE LIMITED",
"EMC SOFTWARE AND SERVICES INDIA PRIVATE LIMITED",
"EMC SOLUTIONS WORLDWIDE PRIVATE LIMITED",
"EMC SQUARE TELEINFRA PRIVATE LIMITED",
"EMC TECHNOLOGY INDIA PRIVATE LIMITED",
"EMCAD TECHNOLOGIES LLP",
"EMCEE APPAREL SOURCING PRIVATE LIMITED",
"EMCEE ENGINEERING WORKS",
"EMCEE PHARMACEUTICALS PRIVATE LIMITED",
"EMCER TILES PRIVATE LIMITED",
"EMCIPI ELECTRONICS PVT LTD",
"EMCO BUILDTECH PRIVATE LIMITED",
"EMCO CABLES (INDIA) PRIVATE LIMITED",
"EMCO DYESTUFF PRIVATE LIMITED",
"EMCO DYNATORQ PRIVATE LIMITED CN",
"EMCO ELECTRO DYNE PRIVATE LIMITED",
"EMCO ELECTRONICS LLP",
"EMCO ENGINEERING PRIVATE LIMITED",
"EMCO EXPORTS",
"EMCO GOA PRIVATE LIMITED",
"EMCO LIMITED",
"EMCO POLYWOOD PRIVATE LIMITED",
"EMCO POWER LIMITED",
"EMCO PRECIMA ENGINEERING PRIVATE LIMITED",
"EMCO SWITCHGEARS PVT LTD",
"EMCOR PACKAGING PRIVATE LIMITED",
"EMCUBIX INFRA PRIVATE LIMITED",
"EMCURE PHARMACEUTICALS LIMITED",
"EM-CYBERSPACE SERVICES PRIVATE LIMITED",
"EMD ELECTRONIC INSTRUMENTS LIMITED",
"EMD PROJECTS (INDIA) PRIVATE LIMITED",
"EMD SCAFFOLDING INDIA PRIVATE LIMITED",
"EMD SYSTEMS SOFTWARE PRIVATE LIMITED",
"EMDADIYA INFRA PROJECTS PRIVATE LIMITED",
"EMDEE APPARELS PRIVATE LIMITED",
"EMDEE DIGITRONICS PRIVATE LIMITED",
"EMDEE ELECTRONICS INDIA PRIVATE LIMITED",
"EMDEE LOGISTICS PRIVATE LIMITED",
"EMDEE SALES PRIVATE LIMITED",
"EMDEP TEST BOARDS PRIVATE LIMITED",
"EMDET ENGINEERS PRIVATE LIMITED",
"EMDET JAMSHEDPUR PRIVATE LIMITED",
"EME TECHNOLOGIES AND SERVICES PRIVATE LIMITED",
"EMEASUREMATICS PRIVATE LIMITED",
"EMEC PVT LTD",
"EMECH CREANTEC PRIVATE LIMITED",
"EMECHANICZ TEST SOLUTIONS PRIVATE LIMITED",
"EMECO ENGINEERS AND CONSULTANTS PRIVATE LIMITED",
"EMECON CONTROLS PVT LTD",
"EMEDEVENTS INDIA PRIVATE LIMITED",
"EMEDINOVA MARKETING PRIVATE LIMITED",
"E-MEDITEK GLOBAL PRIVATE LIMITED",
"EMEDLIFE INSURANCE BROKING SERVICES LIMITED",
"EMEE LOGISTICS PRIVATE LIMITED",
"EMELITE TECHNOLOGIES PRIVATE LIMITED",
"EMEM TEQSEMI PRIVATE LIMITED",
"EMENTALIST OUTSOURCING SERVICES PRIVATE LIMITED",
"EMENZA PLASTOFAB INDIA PRIVATE LIMITED",
"EMERAL ENERGY SOLUTIONS PRIVATE LIMITED",
"EMERALD ACRES PRIVATE LIMITED",
"EMERALD BUSINESS VENTURES PRIVATE LIMITED",
"EMERALD COMESTIBLES PRIVATE LIMITED",
"EMERALD COMPANY PRIVATE LIMITED",
"EMERALD DELI HUB PRIVATE LIMITED",
"EMERALD ELECTRONICS PRIVATE LIMITED",
"EMERALD FINANCE LIMITED",
"EMERALD FORGE PRIVATE LIMITED",
"EMERALD GARDEN CLUB LIMITED",
"EMERALD GOLD SOUK INDIA PRIVATE LIMITED",
"EMERALD GROUP PUBLISHING INDIA PRIVATE LIMITED",
"EMERALD HAVEN DEVELOPMENT LIMITED",
"EMERALD HAVEN ESTATES LIMITED",
"EMERALD HAVEN LIFE SPACES (RADIAL ROAD) LIMITED",
"EMERALD HAVEN REALTY DEVELOPERS (PARANIPUTHUR) PRIVATE LIMITED",
"EMERALD HAVEN REALTY LIMITED",
"EMERALD HAVEN TOWN AND COUNTRY PRIVATE LIMITED",
"EMERALD HEIGHTS ACADEMY & REALTY PRIVATE LIMITED",
"EMERALD HEIGHTS INTERNATIONAL SCHOOL",
"EMERALD HOMEDEVELOPERS PRIVATE LIMITED",
"EMERALD INDUSTRIES",
"EMERALD JEWEL INDUSTRY INDIA LIMITED",
"EMERALD JEWELLERY RETAIL LIMITED",
"EMERALD MINISTRATIONS PRIVATE LIMITED",
"EMERALD RELOCATION SERVICES PRIVATE LIMITED",
"EMERALD RESILIENT TYRE MANUFACTURERS PRIVATE LIMITED",
"EMERALD SNACKS PRIVATE LIMITED",
"EMERALD TESTINGS INDIA PRIVATE LIMITED",
"EMERALD TYRE MANUFACTURERS LIMITED",
"EMERALD VYAPAAR PVT LTD",
"EMERGE AUTOMATION INDIA PRIVATE LIMITED",
"EMERGE DIGITECH PRIVATE LIMITED",
"EMERGE GLASS INDIA PRIVATE LIMITED",
"EMERGE INSURANCE BROKER AND CONSULTANCY SERVICES PRIVATE LIMITED",
"EMERGE RETAIL PRIVATE LIMITED",
"E-MERGE TECH GLOBAL SERVICES PRIVATE LIMITED",
"EMERGENCY KITS INDIA PRIVATE LIMITED",
"EMERGENCY24 HOSPITAL PRIVATE LIMITED",
"EMERGENE AGRINOVO PRIVATE LIMITED",
"EMERGENT INDUSTRIAL SOLUTIONS LIMITED",
"EMERGENT MEDI TECH INDIA PRIVATE LIMITED",
"EMERGENT TECHNIX PRIVATE LIMITED",
"EMERGENT VENTURES INDIA PRIVATE LIMITED",
"EMERGERE COMPUTING SOLUTIONS PRIVATE LIMITED",
"EMERGICARE TRAUMA AND LIFE SUPPORT SERVICES PRIVATE LIMITED",
"EMERGING AUTO SOLUTIONS PRIVATE LIMITED",
"EMERGING ENVIRO-TECH SOLUTION & SERVICES PRIVATE LIMITED",
"EMERGING EQUITIES PRIVATE LIMITED",
"EMERGING FARM EQUIPMENTS (INDIA) PRIVATE LIMITED",
"EMERGING FINANCIAL SERVICES PRIVATE LIMITED",
"EMERGING PROJECTS PRIVATE LIMITED",
"EMERGING SECURITIES PRIVATE LIMITED",
"EMERGING STAR INVESTMENT PRIVATE LIMITED",
"EMERGING STAR TRADE & SOLUTIONS PRIVATE LIMITED",
"EMERGING TECHNO KART PRIVATE LIMITED",
"EMERGING UNIVERSE CONCEPTS PRIVATE LIMITED",
"EMERGY ENVIRO PRIVATE LIMITED",
"EMERGYA WIND TURBINES PRIVATE LIMITED",
"EMERGYS SOFTWARE PRIVATE LIMITED",
"EMERITUS PHARMA PRIVATE LIMITED",
"EMERSON CLIMATE TECHNOLOGIES INDIA PRIVATE LIMITED",
"EMERSON ELECTRIC CO.",
"EMERSON ELECTRIC COMPANY (INDIA) PRIVATE LIMITED",
"EMERSON EXPORT ENGINEERING CENTRE",
"EMERSON FORGE PRIVATE LIMITED",
"EMERSON INFORMATION TECHNOLOGY SOLUTIONS",
"EMERSON INNOVATION CENTER",
"EMERSON PROCESS MANAGEMENT CHENNAI PRIVATE LIMITED",
"EMERSON PROCESS MANAGEMENT INDIA PRIVATE LIMITED",
"EMERSON PROCESS MANAGEMENT POWER AND WATER SOLUTIONS INDIA PRIVATE LIMITED",
"EMERTECH RND SOLUTIONS PRIVATE LIMITED",
"EMERTXE INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"EMESA INDIA ELEVATOR COMPONETS PRIVATE LIMITED",
"EMESCO BOOKS PRIVATE LIMITED",
"EMESS REALCON PRIVATE LIMITED",
"EMET TECHNOLOGY",
"EMEW INDIA PRIVATE LIMITED",
"EMF CLINIC PRIVATE LIMITED",
"EMF INNOVATIONS PRIVATE LIMITED",
"EMFASIT DESIGN PRIVATE LIMITED",
"EMFORE JEWELTECH PRIVATE LIMITED",
"EMG AUTOMATION INDIA PRIVATE LIMITED",
"EMGEE ENGINEERING & CONSTRUCTION PRIVATE LIMITED",
"EMGEE PROJECTS PRIVATE LIMITED",
"EMGEE VELVETS PVT LTD",
"EMH CRANE COMPONENTS PRIVATE LIMITED",
"EMI SOLUTIONS PRIVATE LIMITED",
"EMIAC TECHNOLOGIES PRIVATE LIMITED",
"EMICARE PHARMA AND HEALTH CARE PRIVATE LIMITED",
"EMICHEM PRIVATE LIMITED",
"EMIDS TECHNOLOGIES PRIVATE LIMITED",
"EMIGRA IMMIGRATION SERVICES INDIA PRIVATE LIMITED",
"EMIL CSR FOUNDATION",
"EMIL MINES AND MINERAL RESOURCES LIMITED",
"EMIL PHARMACEUTICAL INDUSTRIES PVT LTD",
"EMIL TRADERS PRIVATE LIMITED",
"EMILY THE SCHOOL",
"EMINDS LEGAL LLP",
"EMINENCE CORPORATION PRIVATE LIMITED",
"EMINENCE CREATIVE SOLUTIONS PRIVATE LIMITED",
"EMINENCE ENGINEERING SERVICES PRIVATE LIMITED",
"EMINENCE EQUIPMENTS PRIVATE LIMITED",
"EMINENCE GLOBAL INFRASTRUCTURE PRIVATE LIMITED",
"EMINENCE HEALTH SOLUTIONS PRIVATE LIMITED",
"EMINENCE INNOVATIVE SKILL EDUCATION PRIVATE LIMITED",
"EMINENCE INTERNET TECHNOLOGY PRIVATE LIMITED",
"EMINENCE MENARDS PRIVATE LIMITED",
"EMINENCE QUALIFICATION CHECK PRIVATE LIMITED",
"EMINENCE SHIPPING AGENCIES PRIVATE LIMITED",
"EMINENCE SOFTECH PRIVATE LIMITED",
"EMINENCE TECH SYSTEM PRIVATE LIMITED",
"EMINENCE TECHNOLOGY LIMITED",
"EMINENCE TECHNOSYSTEM",
"EMINENCE YOUTH POWER PRIVATE LIMITED",
"EMINENCEULTRA AGRITECH PRIVATE LIMITED",
"EMINENT AMINES PRIVATE LIMITED",
"EMINENT AUDIO VISUAL PRIVATE LIMITED",
"EMINENT AUTOMOBILES PRIVATE LIMITED",
"EMINENT CABLE NETWORK PRIVATE LIMITED",
"EMINENT CARS PRIVATE LIMITED",
"EMINENT CHEMTECH PRIVATE LIMITED",
"EMINENT CIRCUITS PRIVATE LIMITED",
"EMINENT COLONIZERS PRIVATE LIMITED",
"EMINENT COMPUTERS PRIVATE LIMITED",
"EMINENT DEALERS PRIVATE LIMITED",
"EMINENT ELECTRICITY DISTRIBUTION LIMITED",
"EMINENT ENGINEERING INDUSTRIES PRIVATE LIMITED",
"EMINENT ENTERPRISES PRIVATE LIMITED",
"EMINENT ESTATE FACILITY MANAGEMENT PRIVATE LIMITED",
"EMINENT FASHION PRIVATE LIMITED",
"EMINENT FOREX PRIVATE LIMITED",
"EMINENT GAS TECHNOLOGIES PRIVATE LIMITED",
"EMINENT INDIA PRIVATE LIMITED",
"EMINENT INFRADEVELOPERS PRIVATE LIMITED",
"EMINENT JEWEL ARCADE PRIVATE LIMITED",
"EMINENT PIPE & PROFILES PRIVATE LIMITED",
"EMINENT POWER FRIENDS EQUIPMENT COMPANY PRIVATE LIMITED",
"EMINENT SEAFOODS PVT LTD",
"EMINENT SHIPPING SERVICES LLP",
"EMINENT SOLAR POWER PRIVATE LIMITED",
"EMINENT SOLVSERVE INSURANCE SURVEYORS & LOSS ASSESSORS PRIVATE L",
"EMINENT TEXTILE MILLS PRIVATE LIMITED",
"EMINENT TRADE & EXPORT PRIVATE LIMITED",
"EMINENTLABS SOFTWARE PRIVATE LIMITED",
"EMINI HYDRO POWER PRIVATE LIMITED",
"EMIPRO TECHNOLOGIES PRIVATE LIMITED",
"EMIRATES",
"EMIRATES CEMENTS (INDIA) PRIVATE LIMITED",
"EMIRATES CORPORATION",
"EMIRATES ENGINEERING CONSTRUCTION PRIVATE LIMITED",
"EMIRATES HORIZON COMMODITIES PRIVATE LIMITED",
"EMIRATES LOGISTICS INDIA PRIVATE LIMITED",
"EMIRATES LUBE INDIA PRIVATE LIMITED",
"EMIRATES NBD BANK PJSC",
"EMIRATES RESIDENCY PRIVATE LIMITED",
"EMIRATES SHIPPING AGENCIES INDIA PRIVATE LIMITED 100% FORSUBCO",
"EMIRATES SLEEP SYSTEMS PRIVATE LIMITED",
"EMIRATES STEEL TUBES PRIVATE LIMITED",
"EMIRATES TECHNOLOGIES PRIVATE LIMITED",
"EMIRERRI STEEL MANUFACTURER PRIVATE LIMITED",
"EMIRIND INFRASTRUCTURE PRIVATE LIMITED",
"EMIS HEALTH INDIA PRIVATE LIMITED",
"EMISSION REDUCTION SERVICES PRIVATE LIMITED",
"EMIT GROUP INDIA PRIVATE LIMITED",
"EMIT PERIPHERALS PRIVATE LIMITED",
"EMITEC EMISSION CONTROL TECHNOLOGIES INDIA PRIVATE LIMITED",
"EMITEX EXPORTS PRIVATE LIMITED",
"EMITTANCE PRIVATE LIMITED",
"EMIZA SUPPLY CHAIN SERVICES PRIVATE LIMITED",
"EMIZEN TECH PRIVATE LIMITED",
"EMJAY EXIMP PRIVATE LIMITED",
"EMJAY STEEL UDYYOG PRIVATE LIMITED",
"EMJEE INDIA MONEY CHANGERS PRIVATE LIMITED",
"EMKA INDIA PANEL ACCESSORIES PRIVATE LIMITED",
"EMKAY ALLOYS PRIVATE LIMITED",
"EMKAY APPLIANCES PRIVATE LIMITED",
"EMKAY AUTOMOBILE INDUSTRIES LIMITED",
"EMKAY CASTING FORGING LLP",
"EMKAY COMMOTRADE LIMITED",
"EMKAY ELECTROMECH PRIVATE LIMITED",
"EMKAY FACILITIES SERVICES PRIVATE LIMITED",
"EMKAY FINCAP LIMITED",
"EMKAY FORGINGS PRIVATE LIMITED",
"EMKAY GLOBAL FINANCIAL SERVICES LIMITED",
"EMKAY INSURANCE BROKERS LIMITED",
"EMKAY INVESTMENT MANAGERS LIMITED",
"EMKAY PHARMA PVT LTD",
"EMKAY POLYMERS PRIVATE LIMITED",
"EMKAY TAPS AND CUTTING TOOLS LIMITED",
"EMKOR SOLUTIONS LIMITED",
"EML CONSULTANCY SERVICES PRIVATE LIMITED",
"EML SUPPLIERS PRIVATE LIMITED",
"EML VISCOM INDIA PRIVATE LIMITED",
"EMLINK TECHNOLOGIES PRIVATE LIMITED",
"EMLINQ GLOBAL SERVICES PRIVATE LIMITED",
"EMM AAR EL CONSTRUCTIONS PRIVATE LIMITED",
"EMM DEE R FINANCE LIMITED",
"EMM EMM AGROTECH PRIVATE LIMITED",
"EMM ESS AIRCON PRIVATE LIMITED",
"EMM GEE PACKAGINGS PVT LTD",
"EMM SOFTWARES LIMITED",
"EMMANUEL CONSTRUCTIONS PRIVATE LIMITED",
"EMMANUEL ENGLISH SCHOOL",
"EMMANUEL MATRIC HR SEC SCHOOL",
"EMMANUEL MISSION PUBLIC SCHOOL",
"EMMANUEL MISSION SCHOOL",
"EMMANUEL RESORTS PRIVATE LIMITED",
"EMMAR CHEM INDUSTRIES PVT LTD",
"EMMAR PROJECT CONTRACTORS INDIA PRIVATE LIMITED",
"EMMARDE STEEL PRIVATE LIMITED",
"EMMAY LOGISTICS (INDIA) PRIVATE LIMITED",
"EMMAY PROJECTS (INDIA) PRIVATE LIMITED",
"EMMBI INDUSTRIES LIMITED",
"EMMBROS AUTOCOMP LIMITED",
"EMMBROS AUTOMOTIVES PRIVATE LIMITED",
"EMMBROS FORGINGS PRIVATE LIMITED",
"EMMBROS OVERSEAS LIFESTYLE PRIVATE LIMITED",
"EMMCHAK FORMULATIONS PRIVATE LIMITED",
"EMMCO PACKAGING AND LOGISTICS PRIVATE LIMITED",
"EMMEMM MOTORS INDIA PRIVATE LIMITED",
"EMMENNAR PHARMA CONTAINERS PRIVATE LIMITED",
"EMMERSIVE INFOTECH PRIVATE LIMITED",
"EMMERSIVE TECHNOLOGIES PRIVATE LIMITED",
"EMMES METALS PRIVATE LIMITED",
"EMMES SERVICES PRIVATE LIMITED",
"EMMESSAR BIOTECH AND NUTRITION LTD",
"EMMESSAR TECHNOLOGIES LIMITED",
"EMMKAY SHARE AND STOCK BROKERS LIMITED",
"E-MMORTAL AUTOMOTIVES PRIVATE LIMITED",
"EMMPEE HEALTH CARE PRIVATE LIMITED",
"EMMSONS GROUP PRIVATE LIMITED",
"EMMTEX SYNTHETICS LIMITED",
"EMMVEE PHOTOVOLTAIC POWER PRIVATE LIMITED",
"EMMVEE SOLAR SYSTEMS PRIVATE LIMITED",
"EMNAR PHARMA PRIVATE LIMITED",
"EMNET POLY PRODUCTS PRIVATE LIMITED",
"EMO CONSULTANTS PRIVATE LIMITED",
"EMOJIFI PRIVATE LIMITED",
"EMONICS TECHNOLOGIES PRIVATE LIMITED",
"EMOR STAFFING SOLUTIONS AND SERVICES PRIVATE LIMITED",
"EMORE HORN MACHINERY INDIA PRIVATE LIMITED",
"EMORPHIS SOFTWARE TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"EMORPHOSYS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"EMOTE FINANCE PRIVATE LIMITED",
"EMOTE INVESTMENTS PRIVATE LIMITED",
"EMOTE LEASING AND FINANCE PRIVATE LIMITED",
"EMOTE WEALTH PRIVATE LIMITED",
"EMOUNT VENTURES PRIVATE LIMITED",
"EMPASYS INFO SOLUTIONS PRIVATE LIMITED",
"EMPAXIS DATA MANAGEMENT INDIA PRIVATE LIMITED",
"EMPE DIAGNOSTICS PRIVATE LIMITED",
"EMPEE AGRO FARM PRODUCTS PVT LTD",
"EMPEE CORPORATION PRIVATE LIMITED",
"EMPEE DISTILLERIES LIMITED",
"EMPEE EQUIPMENTS PRIVATE LIMITED",
"EMPEE HOTELS LIMITED",
"EMPEE INST OF HOTEL MNGTAND CATERING TEC",
"EMPEE SYNDICHEM PRIVATE LIMITED",
"EMPEEF CHEMICALS PVT LTD",
"EMPEESIL GLASS WORKS PVT LTD",
"EMPENOFORE TECHNOLOGIES PRIVATE LIMITED",
"EMPERIA ENERGY PRIVATE LIMITED",
"EMPERIUM REALTY PRIVATE LIMITED",
"EMPERIUS INFRALOGISTICS PRIVATE LIMITED",
"EMPEROL COLOURS PRIVATE LIMITED",
"EMPEROR ASSOCIATES PRIVATE LIMITED",
"EMPEROR FOODEX LIMITED.",
"EMPEROR INFRATECH PRIVATE LIMITED",
"EMPEROR SOLUTIONS PRIVATE LIMITED",
"EMPEROR TEXTILES PRIVATE LIMITED",
"EMPEROR TIMBER TRADER PRIVATE LIMITED",
"EMPEZAR GLOBAL MARINE SERVICES PRIVATE LIMITED",
"EMPEZAR LOGISTICS PRIVATE LIMITED",
"EMPEZAR SOFTWARE LABS PRIVATE LIMITED",
"EMPHAATIC PHARMACEUTICALS PRIVATE LIMITED",
"EMPHATIC VANS & TESTING LABS PRIVATE LIMITED",
"EMPHIRE HR SERVICES (OPC) PRIVATE LIMITED",
"EMPHORIA WORKS PRIVATE LIMITED",
"EMPIAI PHARMACEUTICALS PRIVATE LIMITED",
"EMPILON FABRICS PRIVATE LIMITED",
"EMPIRE AIRCONDITIONING PVT LTD",
"EMPIRE AIRCRAFT MANAGEMENT SERVICES PRIVATE LIMITED",
"EMPIRE ALCOBREV PRIVATE LIMITED",
"EMPIRE ALLOYS PRIVATE LIMITED",
"EMPIRE APPARELS PRIVATE LIMITED",
"EMPIRE AUTO PRIVATE LIMITED",
"EMPIRE CABLE INDUSTRIES PRIVATE LIMITED",
"EMPIRE COMPRESSOR PRIVATE LIMITED",
"EMPIRE DYES & PIGMENT INTERMEDIATES PRIVATE LIMITED",
"EMPIRE ELECTRICALS PRIVATE LIMITED",
"EMPIRE FACILITY MANAGEMENT SERVICES",
"EMPIRE FOUNDATION",
"EMPIRE HEALTH CARE PRIVATE LIMITED",
"EMPIRE HOME APPLIANCES PRIVATE LIMITED",
"EMPIRE HOUSING PROJECTS PRIVATE LIMITED",
"EMPIRE INDUSTRIES LIMITED",
"EMPIRE INFORMATION AND INFRASTRUCTURE PRIVATE LIMITED",
"EMPIRE INTERMEDIATES PRIVATE LIMITED",
"EMPIRE LPG INDIA PRIVATE LIMITED",
"EMPIRE MACHINE TOOLS",
"EMPIRE MALL PRIVATE. LIMITED.",
"EMPIRE MEADOWS PRIVATE LIMITED",
"EMPIRE MERCANTILE PRIVATE LIMITED.",
"EMPIRE MULTIPACK PRIVATE LIMITED",
"EMPIRE PACKAGES PRIVATE LIMITED",
"EMPIRE PROJECTS & DEVELOPMENTS PRIVATE LIMITED",
"EMPIRE SPICES AND FOODS LIMITED",
"EMPIRE SPIRITS INDIA PRIVATE LIMITED",
"EMPIRE STONES PRIVATE LIMITED",
"EMPIRE TECHNICAL SERVICES PRIVATE LIMITED",
"EMPIRE TECHNOCOM PRIVATE LIMITED",
"EMPIRE TECHNOENGINEERS PRIVATE LIMITED",
"EMPIRE TUBEWELLS PRIVATE LIMITED",
"EMPIRE WEBTECH PRIVATE LIMITED",
"EMPIRICAL CHEMICAL SOLUTIONS PRIVATE LIMITED",
"EMPIRICAL F & M ACADEMY PRIVATE LIMITED",
"EMPIRICAL MEDIA PRIVATE LIMITED",
"EMPIRICO RESEARCH PRIVATE LIMITED",
"EMPIRIX SOFTWARE SOLUTIONS PRIVATE LIMITED",
"EMPITEX FABRICS PRIVATE LIMITED",
"EMPKEE ENGINEERS PRIVATE LIMITED",
"EMPLAY ANALYTICS PRIVATE LIMITED",
"EMPLIFE INDIA PRIVATE LIMITED",
"EMPLOYEE BASED SOFTWARE PRIVATE LIMITED",
"EMPLOYEE POOLING RESOURCES PRIVATE LIMITED",
"EMPLOYEE STATE INSURANCE CORPORATION",
"EMPLOYEES PROVIDENT FUND ORGANISATION",
"EMPLOYEES STATE INSURANCE CORPORATION",
"EMPLOYEES' STATE INSURANCE CORPORATION",
"EMPLOYEES STATE INSURANCE SCHEME",
"EMPLOYTECH CENTER INDIA PRIVATE LIMITED",
"EMPOISE DESIGN STUDIOS PRIVATE LIMITED",
"EMPOLI OFFSET PVT LTD",
"EMPORIO MARKETING PRIVATE LIMITED",
"EMPORIS PERIPHERALS PRIVATE LIMITED",
"EMPORIUM INDUSTRIAL PARKS (INDIA) PRIVATE LIMITED",
"EMPOROS LINKS PRIVATE LIMITED",
"EMPOVER I-TECH PRIVATE LIMITED",
"EMPOWER ACTIVITY CAMPS PRIVATE LIMITED",
"EM-POWER COSMOS PRIVATE LIMITED",
"EMPOWER CREATIVE CONSULTING LLP",
"EMPOWER DESIGNS PRIVATE LIMITED",
"EMPOWER EDTECH SERVICES PRIVATE LIMITED",
"EMPOWER ENGINEERS PRIVATE LIMITED",
"EMPOWER FOUNDATION",
"EMPOWER INDIA LIMITED",
"EMPOWER INFRAPROJECTS PRIVATE LIMITED",
"EMPOWER INTEGRATED SOLUTIONS P LIMITED",
"EMPOWER IT SYSTEMS PRIVATE LIMITED",
"EMPOWER PRAGATI VOCATIONAL AND STAFFING PRIVATE LIMITED",
"EMPOWER RESEARCH KNOWLEDGE SERVICES PRIVATE LIMITED",
"EMPOWER SCHOOL OF HEALTH LLP",
"EMPOWER XYZ PRIVATE LIMITED",
"EMPOWERA TECHNORGANICS PRIVATE LIMITED",
"EMPOWERTRANS PRIVATE LIMITED",
"EMPR SERVICES PRIVATE LIMITED",
"EMPRADA MINES AND MINERALS PRIVATE LIMITED",
"EMPREE MEDICAMENTS (INDIA) PRIVATE LIMITED",
"EMPREO PRESTIGE PRIVATE LIMITED",
"EMPREO RESOURCES DEVELOPMENT INDIA PRIVATE LIMITED",
"EMPREO WHEELS PRIVATE LIMITED",
"EMPRESS CYBERNETIC SYSTEMS PRIVATE LIMITED",
"EMPRESS GLOBAL LOGISTICS PRIVATE LIMITED",
"EMPRESS TIN FACTORY PRIVATE LIMITED",
"EMPRESSAA MARKETING PRIVATE LIMITED",
"EMPREST INNOVATIONS PRIVATE LIMITED",
"EMPRO PLANT SUPERVISION SERVICES PRIVATE LIMITED",
"EMPRONC SOLUTIONS PRIVATE LIMITED",
"EMPROS LOGISTICS PRIVATE LIMITED",
"EMPROTO TECHNOLOGIES PRIVATE LIMITED",
"EMPTECH SECURITY PRIVATE LIMITED",
"EMPTOR PEDDLER INDIA PRIVATE LIMITED",
"EMPTORIS TECHNOLOGIES INDIA PRIVATE LIMITED",
"EMPULSE RESEARCH AND DATA ANALYTICS INDIA PRIVATE LIMITED",
"EMPYRA SOFTWARE SOLUTIONS PRIVATE LIMITED",
"EMPYREAL LINEAGE PRIVATE LIMITED",
"EMPYREAN CASHEWS PRIVATE LIMITED",
"EMPYREAN SCHOOL",
"EMPYREAN SPIRITS PRIVATE LIMITED",
"EMQOS EMBEDDED ENGINEERING PRIVATE LIMITED",
"EMQUBE CONSULTING PRIVATE LIMITED",
"EMR HEALTHCARE SERVICES PRIVATE LIMITED",
"EMR METALS INDIA PRIVATE LIMITED",
"EMRALD COMMERCIAL LIMITED",
"EMRALD MEDICAL RESEARCH PRIVATE LIMITED",
"EMREACH SOLUTIONS PRIVATE LIMITED",
"EMRI GREEN HEALTH SERVICES",
"EMS INFRASTRUCTURE PRIVATE LIMITED",
"EMS LIMITED",
"EMS MACHINES GLOBAL INDIA PRIVATE LIMITED",
"EMS MANAGEMENT SERVICES PRIVATE LIMITED",
"EMS PROJECTS PRIVATE LIMITED",
"EMS SIMULATIONIQ PRIVATE LIMITED",
"EMS TECHNOLOGIES PRIVATE LIMITED",
"EMSAFE FIRE SAFETY SOLUTIONS PRIVATE LIMITED",
"EMSANG TECHNOLOGIES INDIA PRIVATE LIMTED",
"EMSIG MANUFACTURING INDIA PRIVATE LIMITED",
"EMSON GEARS LIMITED",
"EMSON SOLEXPOR PRIVATE LIMITED",
"EMSON TOOLS MANUFACTURING CORPORATION LIMITED",
"EMSONS EXIM PRIVATE LIMITED",
"EMSONS PRODUCTS PRIVATE LIMITED",
"EM-SOS MEDICAL PRIVATE LIMITED",
"EMST MARKETING PRIVATE LIMITED",
"EMS-TCP JV PRIVATE LIMITED",
"EMSURG HEALTHCARE INDIA PRIVATE LIMITED",
"EMT GLOBAL (INDIA) PRIVATE LIMITED",
"EMT MEGATHERM PRIVATE LIMITED",
"EMTA COAL LIMITED",
"EMTAC LABORATORIES PRIVATE LIMITED",
"EMTARANG TECHLABS PRIVATE LIMITED",
"EMTC ELECTRICALS PRIVATE LIMITED",
"EMTEC SOFTWARE INDIA PRIVATE LIMITED",
"BRIDGENEXT INDIA PRIVATE LIMITED",
"EMTECH AUTOMATION PRIVATE LIMITED",
"EMTECH SOLUTIONS PRIVATE LIMITED",
"EMTEX ENGINEERING PRIVATE LIMITED",
"EMTEX MACHINERY P LIMITED",
"EMTEX MARKETING PRIVATE LIMITED",
"EMTICI ENGINEERING LIMITED",
"EMTICI MARKETING LLP",
"EMTO TECHNOLOGY AND LOGISTICS PRIVATE LIMITED",
"EMU LINES PRIVATE LIMITED",
"EMUDHRA CONSUMER SERVICES LIMITED",
"EMUDHRA LIMITED",
"EMUDHRA TECHNOLOGIES LIMITED",
"E-MUG ENERGY PRIVATE LIMITED",
"E-MUG ENGINEERING SERVICES PRIVATE LIMITED",
"E-MUG TECHNOLOGIES PRIVATE LIMITED",
"EMUGE FRANKEN INDIA PRIVATE LIMITED",
"EMUL TEK PRIVATE LIMITED",
"EMULEX COMMUNICATIONS PRIVATE LIMITED",
"EMULGRAIN INDIA PRIVATE LIMITED",
"EMULSICHEM LUBRICANTS PRIVATE LIMITED",
"EMULSION CHEM INDUSTRIES PRIVATE LIMITED",
"EMURGO LEARNING SOLUTIONS PRIVATE LIMITED",
"EMUST ENTERPRISES PRIVATE LIMITED",
"EMVEE AUTOFORGE PRIVATE LIMITED",
"EMVEEBEE MEDIA PRIVATE LIMITED",
"EMVEEKAY STEEL PRIVATE LIMITED",
"EMVEESS INFRAVENTURES PRIVATE LIMITED",
"EMVIGO TECHNOLOGIES PRIVATE LIMITED",
"EMXCEL COMMERCE ONLINE SOLUTIONS PRIVATE LIMITED",
"EMXCEL HOSPITALITY SOLUTIONS PRIVATE LIMITED",
"EMXCEL TRAVEL SOLUTIONS PRIVATE LIMITED",
"EN AAR GEE ASSOCIATES PRIVATE LIMITED",
"EN DESSUS GLOBAL FORWARDING PRIVATE LIMITED",
"EN EN ELECTRICAL ENGINEERS PRIVATE LIMITED",
"EN INTERACTIVE TECHNOLOGIES PRIVATE LIMITED",
"EN POINTE ADWISERS LLP",
"EN RENEWABLE ENERGY PRIVATE LIMITED",
"EN WIND POWER PRIVATE LIMITED",
"EN3 SUSTAINABILITY SOLUTIONS PRIVATE LIMITED",
"ENA FOOTWEAR PRIVATE LIMITED",
"ENAAR CHEMICALS PRIVATE LIMITED",
"ENABILON LEARNING PRIVATE LIMITED",
"ENABL ENGINEERING PRIVATE LIMITED",
"ENABLE IT SOLUTIONS PRIVATE LIMITED",
"ENABLE MOBILE TECHNOLOGIES PRIVATE LIMITED",
"ENABLERS PROPERTY SERVICES PRIVATE LIMITED",
"ENABLESOFT ERP CONSULTANCY PRIVATE LIMITED",
"ENABLESOFT SOLUTIONS PRIVATE LIMITED",
"ENABLING DIMENSIONS INDIA PRIVATE LIMITED",
"ENACO SAFETY PRODUCTS PRIVATE LIMITED",
"ENACTON TECHNOLOGIES PRIVATE LIMITED",
"ENAGIC INDIA KANGEN WATER PRIVATE LIMITED",
"ENAL DRUGS PRIVATE LIMITED",
"ENALTEC LABS PRIVATE LIMITED",
"ENALTEC PHARMA RESEARCH PRIVATE LIMITED",
"ENAM ASSET MANAGEMENT COMPANY PRIVATE LIMITED",
"ENAM CASTINGS PRIVATE LIMITED",
"ENAM FINANCIAL CONSULTANTS PVT LTD",
"ENAM HOLDINGS PRIVATE LIMITED",
"ENAM SECURITIES",
"ENANTI LABS PRIVATE LIMITED",
"ENAR INDUSTRIAL ENTERPRISES PRIVATE LIMITED",
"ENAR WELD-BRAZE PRIVATE LIMITED",
"ENARAYAN ELEX INDIA PRIVATE LIMITED",
"ENARCH CONSULTANTS PRIVATE LIMITED",
"ENARR ADVISORS PRIVATE LIMITED",
"ENAS TRADE AND SOLUTIONS PRIVATE LIMITED",
"ENATE TECHNOLOGIES INDIA PRIVATE LIMITED",
"ENATION SOLUTIONS PRIVATE LIMITED",
"ENAVIYA INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"ENAYAT AGRO FOODS PRIVATE LIMITED",
"ENBEE EDUCATION CENTER PRIVATE LIMITED",
"ENBEE TRADE AND FINANCE LIMITED",
"ENBEST PUMPS( INDIA )PRIVATE LIMITED",
"ENBOLT LABS PRIVATE LIMITED",
"ENBUILD INFRASTRUCTURE PRIVATE LIMITED",
"ENCARDIO RITE ELECTRONICS PRIVATE LIMITED",
"ENCASA MINES & MINERALS PRIVATE LIMITED",
"ENCEE AROMATICS PRIVATE LIMITED",
"ENCEE RAIL ENGINEERS AND FABRICATORS PRIVATE LIMITED",
"ENCEPT PREMEDIA PRIVATE LIMITEDCAT",
"ENCHANT VINIMAY PRIVATE LIMITED",
"ENCHANTED WOODS CLUB LIMITED",
"ENCIRCLE INNOVATIONS PRIVATE LIMITED",
"EN-CLER BIOMEDICAL WASTE PRIVATE LIMITED",
"ENCLO INDUSTRIES PRIVATE LIMITED",
"ENCLOSURE SYSTEMS INDIA PRIVATE LIMITED",
"ENCO AUTOCOMP PRIVATE LIMITED",
"ENCO ENGINEERS COMBINE (PLANT II) PRIVATE LIMITED",
"ENCO ENGINEERS COMBINE PRIVATE LIMITED",
"ENCO SHOES",
"ENCODE PACKAGING INDIA LIMITED",
"ENCODEX TELESYSTEMS INDIA PRIVATE LIMITED",
"ENCODING ENHANCERS PRIVATE LIMITED",
"ENCOMPASS",
"ENCOMPASS DESIGN INDIA PRIVATE LIMITED",
"ENCOMPASS EVENTS PRIVATE. LIMITED",
"ENCON COOLING TOWERS PRIVATE LIMITED",
"ENCON ENTERPRISES PRIVATE LIMITED",
"ENCON EXPERTISE PRIVATE LIMITED",
"ENCON FABRICATORS PRIVATE LIMITED",
"ENCON FAN (INDIA) PRIVATE LIMITED",
"ENCON FRP FAN PRIVATE LIMITED",
"ENCON FURNACES PRIVATE LIMITED",
"ENCON IMPEX PRIVATE LIMITED",
"ENCON SIMULATION INDIA PRIVATE LIMITED",
"ENCON THERMAL ENGINEERS PRIVATE LIMITED",
"ENCONSYS PRIVATE LIMITED",
"ENCOP WIRES PRIVATE LIMITED",
"ENCORA DIGITAL INDIA PRIVATE LIMITED",
"ENCORA INNOVATION LABS INDIA PRIVATE LIMITED",
"ENCORA SOFTWARE INDIA PRIVATE LIMITED",
"ENCORE ASSET RECONSTRUCTION COMPANY PRIVATE LIMITED",
"ENCORE BUSINESS SYSTEM LIMITED",
"ENCORE CAPITAL GROUP",
"ENCORE CAPITAL MIDLAND CREDIT MANAGEMENT",
"ENCORE CREATIONS PRIVATE LIMITED",
"ENCORE DIGITECH PRIVATE LIMITED",
"ENCORE EVENTS PRIVATE LIMITED",
"ENCORE HEALTHCARE PRIVATE LIMITED",
"ENCORE HEAVY MACHINERY PRIVATE LIMITED",
"ENCORE HOTELS PRIVATE LIMITED",
"ENCORE IT SERVICES SOLUTIONS PRIVATE LIMITED",
"ENCORE METALS PRIVATE LIMITED",
"ENCORE MODULAR FURNITURE PRIVATE LIMITED",
"ENCORE NATURAL POLYMERS PRIVATE LIMITED",
"ENCORE PROJECTS PRIVATE. LIMITED.",
"ENCORE SHIPPING INDIA PRIVATE LIMITED",
"ENCORE THEME TECHNOLOGIES PRIVATE LIMITED",
"ENCORE THEME TECHNOLOGIES PRIVATE LIMITED",
"ENCORESKY TECHNOLOGIES PRIVATE LIMITED",
"ENCORP POWERTRANS PRIVATE LIMITED",
"ENCOSYM SOLUTIONS PRIVATE LIMITED",
"ENCOT FABRICS PRIVATE LIMITED",
"ENCRAFT INDIA PRIVATE LIMITED",
"ENCRUSTD FASHION PRIVATE LIMITED",
"ENCUBE ETHICALS PRIVATE LIMITED",
"ENCUBE VENTURE PARTNERS LLP",
"ENCUREIT SYSTEMS PRIVATE LIMITED",
"END POINT IT SERVICES PRIVATE LIMITED",
"END POVERTY",
"END TO END INFOTECH PRIVATE LIMITED",
"END TO END MARKETING SOLUTIONS PRIVATE LIMITED",
"END TO END WAREHOUSING AND LOGISTICS PRIVATE LIMITED",
"END USER SOFTWARE IT CONSULTING PRIVATE LIMITED",
"END2END FACILITATORS GLOBAL PRIVATE LIMITED",
"END2END HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"END2END LOGISTICS GLOBAL PRIVATE LIMITED",
"ENDEAR LIFE SCIENCE PRIVATE LIMITED",
"ENDEAVOR PUBLISHING COMPANY PRIVATE LIMITED",
"ENDEAVOUR APPARELS PRIVATE LIMITED",
"ENDEAVOUR CHEMICALS PRIVATE LIMITED",
"ENDEAVOUR COMMODITIES PRIVATE LIMITED",
"ENDEAVOUR CONSULTANCY SERVICES & SOLUTIONS PRIVATE LIMITED",
"ENDEAVOUR ERP SOLUTIONS INDIA PRIVATE LIMITED",
"ENDEAVOUR INSTRUMENT PRIVATE LIMITED ENDEAVOUR FIN",
"ENDEAVOUR INTELLIGENT EQUIPMENTS PRIVATE LIMITED",
"ENDEAVOUR SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"ENDEE ENGINEERS PRIVATE LIMITED",
"ENDEKA CERAMICS INDIA PRIVATE LIMITED",
"ENDEL RETAIL AND CUSTOMER CARE PRIVATE LIMITED",
"ENDEMIC EXPORT PRIVATE LIMITED",
"ENDEMOL INDIA PRIVATE LIMITE",
"ENDERS INDUSTRIES LIMITED",
"ENDIRT CLEANING SOLUTIONS PRIVATE LIMITED",
"ENDIYA FUND ADVISORS PRIVATE LIMITED",
"ENDLESS GAIN PRIVATE LIMITED",
"ENDLESS SERVICES PRIVATE LIMITED",
"ENDMARK LOGISTICS PRIVATE LIMITED",
"ENDO KOGYO INDIA PRIVATE LIMITED",
"ENDO LIGHTING ACCESSORIES INDIA PRIVATE LIMITED",
"ENDOC LIFECARE PRIVATE LIMITED",
"ENDOCARD INDIA PRIVATE LIMITED",
"ENDOCRINE AND ALLERGY LABORATORY PRIVATE LIMITED",
"ENDOLIFE SPECIALITY HOSPITALS PRIVATE LIMITED",
"ENDOLITE INDIA LIMITED",
"ENDO-MED TECHNOLOGIES PRIVATE LIMITED",
"ENDOPRIME HEALTHCARE INDIA PRIVATE LIMITED",
"ENDORPHIN GYMNASIUM LLP",
"ENDORPHINS ENTERTAINMENT PRIVATE LIMITED",
"ENDOSOFT SOLUTIONS PRIVATE LIMITED",
"ENDOSYS HEALTHCARE INDIA PRIVATE LIMITED",
"ENDOTHERM FLUIDS INDIA PRIVATE LIMITED",
"ENDOW BUSINESS SYSTEM PRIVATE LIMITED",
"ENDOWORLD HOSPITAL PRIVATE LIMITED",
"ENDRESS + HAUSER INDIA PRIVATE LIMITED",
"ENDRESS + HAUSER INFOSERVE (INDIA) PRIVATE LIMITED",
"ENDRESS + HAUSER WETZER INDIA PRIVATE LIMITED",
"ENDRESS HAUSER FLOWTEC INDIA PRIVATE LIMITED",
"ENDRESS+HAUSER INDIA AUTOMATION INSTRUMENTATION PRIVATE LIMITED",
"ENDROIT DESIGNS PRIVATE LIMITED",
"ENDSVILLE EXPORTS PRIVATE LIMITED",
"ENDURA SUPERABS PRIVATE LIMITED",
"ENDURABLE PHARMACEUTICALS PRIVATE LIMITED",
"ENDURANCE FITNESS PRIVATE LIMITED",
"ENDURANCE HEALTHCARE PRIVATE LIMITED",
"ENDURANCE HEIGHTS PRIVATE LIMITED",
"ENDURANCE INTERNATIONAL GROUP INDIA PRIVATE LIMITED",
"ENDURANCE LOGISTICS PRIVATE LIMITED",
"ENDURANCE MATERIAL HANDLERS PRIVATE LIMITED",
"ENDURANCE SHUBH TECHNOLOGIES PRIVATE LIMITED",
"ENDURANCE TECHNOLOGIES LIMITED",
"ENDURE HEALTH CLUB PRIVATE LIMITED",
"ENDURE REALTY PRIVATE LIMITED",
"ENDURE SOURCING PRIVATE LIMITED",
"ENDUREAIR SYSTEMS PRIVATE LIMITED",
"ENDURIX SOFTWARE SOLUTIONS PRIVATE LIMITED",
"ENDYMION EXPORT PRIVATE LIMITED",
"ENE FLUIDTEK PRIVATE LIMITED",
"ENEED INTEGRATED SERVICES PRIVATE LIMITED",
"ENEFFEN TECHNOLOGIES PRIVATE LIMITED",
"ENEM NOSTRUM REMEDIES PRIVATE LIMITED",
"ENEMTECH CAPITAL INDIA PRIVATE LIMITED",
"ENEN GREEN SERVICES PRIVATE LIMITED",
"ENEOS MATERIALS INDIA PRIVATE LIMITED",
"ENEOS TIDE WATER LUBRICANTS INDIA PRIVATE LIMITED",
"ENER INDUSTRIES PRIVATE LIMITED",
"ENER PANELS PRIVATE LIMITED",
"ENER SAVE CONSULTANTS PRIVATE LIMITED",
"ENERCARE SOLUTIONS PRIVATE LIMITED",
"ENERCON ASIA PACIFIC SYSTEMS PRIVATE LIMITED",
"ENERCON LOGISTICS & SOLUTIONS PRIVATE LIMITED",
"ENERCON WINDENERGY PRIVATE LIMITED",
"ENERDYNE DEVICES PRIVATE LIMITED",
"ENEREFF ENGINEERS PRIVATE LIMITED",
"ENERFRA PROJECTS ( INDIA ) PRIVATE LIMITED",
"ENERGASIA SMART POLES PRIVATE LIMITED",
"ENERGASIA TECHNOLOGIES PRIVATE LIMITED",
"ENERGEC CHEM SPECIALITIES PRIVATE LIMITED",
"ENERGEIA GLOBAL PRIVATE LIMITED",
"ENERGEIA LIFE SCIENCES PRIVATE LIMITED",
"ENERGEIA MICROGRID PRIVATE LIMITED",
"ENERGENIQ SALES AND SERVICES PRIVATE LIMITED",
"ENERGETIC CONSULTING PRIVATE LIMITED",
"ENERGETIC INFO SOLUTIONS PRIVATE LIMITED",
"ENERGETIC MARKETING PRIVATE LIMITED",
"ENERGETIC PROJECTS PRIVATE LIMITED",
"ENERGIA APPLIANCES PRIVATE LIMITED",
"ENERGIA ECOTEC PRIVATE LIMITED",
"ENERGIA ENGINEERING SOLUTIONS PRIVATE LIMITED",
"ENERGIA INFRATECH PRIVATE LIMITED",
"ENERGIA PROCESS TECHNOLOGIES PRIVATE LIMITED",
"ENERGIA STEEL PRIVATE LIMITED",
"ENERGIA SYSTEMS PRIVATE LIMITED",
"ENERGIA WELLBEING PRIVATE LIMITED",
"ENERGICA ADVISORY SERVICES PRIVATE LIMITED",
"ENERGICOMM WIRES PRIVATE LIMITED",
"ENERGID CONTROL AND SOLUTIONS PRIVATE LIMITED",
"ENERGIE HEALTH EQUIPMENT PRIVATE LIMITED",
"ENERGION FUEL PRIVATE LIMITED",
"ENERGIONPOWERMAX BATTERIES PRIVATE LIMITED",
"ENERGIZE PHARMACEUTICALS PRIVATE LIMITED",
"ENERGIZED POLES PRIVATE LIMITED",
"ENERGIZED SOLUTIONS INDIA PRIVATE LIMITED",
"ENERGIZER SPORTS PRIVATE LIMITED",
"ENERGO CONSTRUCTION PRIVATE LIMITED",
"ENERGO PRODUCTS LIMITED",
"ENERGON LABS PRIVATE LIMITED",
"ENERGON MP WIND POWER PRIVATE LIMITED",
"ENERGON POWER RESOURCES PRIVATE LIMITED",
"ENERGON SOLEQ INDIA POWER RESOURCES PRIVATE LIMITED",
"ENERGOS SERVICES INDIA PRIVATE LIMITED",
"ENERGOS TECHNOLOGIES PRIVATE LIMITED",
"ENERGY & FLOW ENGINEERING PRIVATE LIMITED",
"ENERGY AAHAR PRIVATE LIMITED",
"ENERGY ADVISORY SERVICES PRIVATE LIMITED",
"ENERGY AVENUES PRIVATE LIMITED",
"ENERGY BEVERAGES PRIVATE LIMITED",
"ENERGY BUILDING SOLUTIONS PRIVATE LIMITED",
"ENERGY CONSULTANTS PRIVATE LIMITED",
"ENERGY DEVICES",
"ENERGY EFFICIENCY SERVICES LIMITED",
"ENERGY EQUIPMENTS",
"ENERGY EXEMPLAR INDIA PRIVATE LIMITED",
"ENERGY FUTURE HOLDINGS CORP.",
"ENERGY GRID AUTOMATION TRANSFORMERS AND SWITCHGEARS INDIA PRIVATE LIMITED",
"ENERGY INFRACONSULTING INDIA PRIVATE LIMITED",
"ENERGY INFRAPROJECTS PRIVATE LIMITED",
"ENERGY INFRASTRUCTURE INDIA LIMITED",
"ENERGY INFRATECH PRIVATE LIMITED",
"ENERGY LOGISTICS PRIVATE LIMITED",
"ENERGY MACHINE TOOLS PVT LTD",
"ENERGY MACHINES PRIVATE LIMITED",
"ENERGY MISSION MACHINERIES INDIA PRIVATE LIMITED",
"ENERGY O & M SERVICES PRIVATE LIMITED",
"ENERGY OILFIELD TOOLS PRIVATE LIMITED",
"ENERGY PACK BOILERS PVT LTD",
"ENERGY PACK PRIVATE LIMITED",
"ENERGY SAVERS INDIA PRIVATE LIMITED",
"ENERGY SOLUTIONS INTERNATIONAL INDIA PRIVATE LIMITED",
"ENERGY SOLUTIONS PRIVATE LIMITED",
"ENERGY TECHNOCAST PRIVATE LIMITED",
"ENERGY TRANSFER EQUITY L.P.",
"ENERGY UNITED INDIA PRIVATE LIMITED",
"ENERGYCLONES MERCANTILE PRIVATE LIMITED",
"ENERGYCREDIT SOFTWARE SERVICES PRIVATE LIMITED",
"ENERGYGREEN TECHNOPOWER PRIVATE LIMITED",
"ENERGY-MISSION MACHINERIES (INDIA) LIMITED",
"ENERGYPIPE PRIVATE LIMITED",
"ENERGYSCAPE RENEWABLES LLP",
"ENERGYSOLUTION LABS PRIVATE LIMITED",
"ENERGYSPIN PRIVATE LIMITED",
"ENERGYSTAR TECHNOLOGIES PRIVATE LIMITED",
"ENERGYTECH GLOBAL PRIVATE LIMITED",
"ENERGYTEK BOILER PRIVATE LIMITED",
"ENERGYWIN TECHNOLOGIES",
"ENERINFRA PRIVATE LIMITED",
"ENERJAY GREEN PRIVATE LIMITED",
"ENERJET SYSTEMS PRIVATE LIMITED",
"ENERJI SYSTEMS PRIVATE LIMITED",
"ENERKRAFT VENTURE PRIVATE LIMITED",
"ENERLINK PROINT & CONSER PRIVATE LIMITED",
"ENERMECH INDIA PRIVATE LIMITED",
"ENERO TRADING MART PRIVATE LIMITED",
"ENEROIL OFFSHORE DRILLING LIMITED",
"ENERPARC ENERGY PRIVATE LIMITED",
"ENERPARC SOLAR POWER 1 PRIVATE LIMITED",
"ENERPLUS ENERGY PRIVATE LIMITED",
"ENERQUAL TECHNOLOGY PRIVATE LIMITED",
"ENERRGIA INFRASTRUCTURE PRIVATE LIMITED",
"ENERRGIA SKYI DEVOLOPERS",
"ENERSAN POWER PRIVATE LIMITED",
"ENERSAVE LIGHTING SOLUTIONS PRIVATE LIMITED",
"ENERSHELL ALLOYS & STEEL PRIVATE LIMITED",
"ENERSOL SYSTEMS PRIVATE LIMITED",
"ENERSOL TECHNOLOGIES PRIVATE LIMITED",
"ENERSPRIT PRIVATE LIMITED",
"ENERSYS INDIA BATTERIES PRIVATE LIMTED",
"ENERTEC CONTROLS LIMITED",
"ENERTECH CERA PRIVATE LIMITED",
"ENERTECH COMNET PRIVATE LIMITED",
"ENERTECH DISTRIBUTION MANAGEMENT PRIVATE LIMITED",
"ENERTECH ELECTRIC ENTERPRISES PRIVATE LIMITED",
"ENERTECH ELECTRONICS PRIVATE LIMITED",
"ENERTECH ENGINEERING PRIVATE LIMITED",
"ENERTECH FUEL SOLUTIONS PRIVATE LIMITED",
"ENERTECH INFRASTRUCTURE PRIVATE LIMITED",
"ENERTECH PENNAR DEFENSE AND ENGINEERING SYSTEMS PRIVATE LIMITED",
"ENERTECH UPS PRIVATE LIMITED",
"ENERTEK SOLUTIONS INDIA PRIVATE LIMITED",
"ENERTRAK INSTRUMENTS PRIVATE LIMITED",
"ENERTURE TECHNOLOGIES PRIVATE LIMITED",
"ENERZEA POWER SOLUTION PRIVATE LIMITED",
"ENERZI MICROWAVE SYSTEMS PRIVATE LIMITED",
"ENERZINX INDIA PRIVATE LIMITED",
"ENERZYTECH INDUSTRIES PRIVATE LIMITED",
"E-NET SYSTEMS INDIA PRIVATE LIMITED",
"E-NETSOL TECHNOLOGIES PRIVATE LIMITED",
"ENEWATE PROJECTS PRIVATE LIMITED",
"E-NEXCO INDIA PRIVATE LIMITED",
"ENEXIO POWER COOLING SOLUTIONS INDIA PRIVATE LIMITED",
"ENEXION ENERGY PRIVATE LIMITED",
"ENFEC SOLUTIONS PRIVATE LIMITED",
"ENFIN TECHNOLOGIES INDIA PRIVATE LIMITED",
"ENFLEXIS SOLUTIONS PRIVATE LIMITED",
"ENFLUENCE IT SERVICES PRIVATE LIMITED",
"ENFORCE ENGINEERING SOLUTIONS PRIVATE LIMITED",
"ENFORCE TECHNOLOGIES PRIVATE LIMITED",
"ENFORCEMENT AFFILIATES PRIVATE LIMITED",
"ENFORCEMENT DIRECTORATE",
"ENFORTURE INFRA TECH PRIVATE LIMITED",
"ENFRAGY SOLUTIONS INDIA PRIVATE LIMITED",
"ENFROS INDIA SOLUTIONS PRIVATE LIMITED",
"ENFROS TECHNOLOGIES PRIVATE LIMITED",
"ENFROSUN SOLAR PRIVATE LIMITED",
"ENFUSE SOLUTIONS LIMITED",
"ENFUSE SOLUTIONS PRIVATE LIMITED",
"ENFUSION SOFTECH INDIA PRIVATE LIMITED",
"ENGAGE",
"ENGAGE DIGITAL PARTNERS PRIVATE LIMITED",
"ENGAGE IT SERVICES PRIVATE LIMITED",
"ENGAGE MEDIA PRIVATE LIMITED",
"ENGAGE4MORE INDIA PRIVATE LIMITED",
"ENGAGEBAY INDIA PRIVATE LIMITED",
"ENGAGEDLY SOFTWARE INDIA PRIVATE LIMITED",
"ENGATI TECHNOLOGIES PRIVATE LIMITED",
"ENGAUGE INDIA PRIVATE LIMITED",
"ENGEE INFRASTRUCTURES PRIVATE LIMITED",
"ENGEE PROPACK PRIVATE LIMITED",
"ENGEL MACHINERY INDIA PRIVATE LIMITED",
"ENGENDER DEVELOPERS PRIVATE LIMITED",
"ENGENIUS ERECTORS PRIVATE LIMITED",
"ENGENIUS METALS PRIVATE LIMITED",
"ENGENRIN HYDRO POWER LIMITED",
"ENGGSOL PTE LTD",
"ENGGSPIRE PRIVATE LIMITED",
"ENGICON AIRTECH PRIVATE LIMITED",
"ENGIE AXIMA INDIA PRIVATE LIMITED",
"ENGIE ENERGY AND SERVICES INDIA PRIVATE LIMITED",
"ENGINDIA RUBBERS PRIVATE LIMITED",
"ENGINE FACTORY AVADI",
"ENGINEER AI INDIA PRIVATE LIMITED",
"ENGINEER CONSTRUCTIONS PRIVATE LIMITED",
"ENGINEER IN CHIEF RURAL WORKS",
"ENGINEER PHILOSOPHY WEB SERVICES PRIVATE LIMITED",
"ENGINEER.AI CLOUD SERVICES INDIA PRIVATE LIMITED",
"ENGINEERED COMPONENTS AND SYSTEMS INDIA PRIVATE LIMITED",
"ENGINEERED CUSTOMISED CONTROL PANEL SOLUTIONS PRIVATE LIMITED",
"ENGINEERED FOOD CONCEPTS PRIVATE LIMITED",
"ENGINEERED POLYMERS (INDIA) PVT LTD",
"ENGINEERED VALVE PRODUCTS PRIVATE LIMITED",
"ENGINEERING & TECHNOLOGY",
"ENGINEERING AND AGENCIES PVT LTD",
"ENGINEERING AND CHEMICAL INDIA PRIVATE LIMITED",
"ENGINEERING AND ENVIRONMENTAL SOLUTIONS PRIVATE LIMITED",
"ENGINEERING AND MEDIA PRODUCTS PRIVATE LIMITED",
"ENGINEERING COLLEGE BIKANER",
"ENGINEERING CREATIONS CONSULTANCY (INDIA) PRIVATE LIMITED",
"ENGINEERING CREATIONS PUBLIC HEALTH CONSULTANCY PRIVATE LIMITED",
"ENGINEERING DESIGN SOFTWARE AND SERVICES PRIVATE LIMITED",
"ENGINEERING GRAPHIC SERVICES PRIVATE LIMITED",
"ENGINEERING PROFESSIONAL COMPANY PRIVATE LIMITED",
"ENGINEERING PROJECTS INDIA LIMITED",
"ENGINEERING SPECIALITIES PVT LTD",
"ENGINEERING TRADE CENTRE INDIA PVT LTD",
"ENGINEERINGWALA IRON PRODUCTS PRIVATE LIMITED",
"ENGINEERS ACADEMY PRIVATE LIMITED",
"ENGINEERS AND CONSULTANTS PRIVATE LIMITED",
"ENGINEERS AND ENGINEERS ELECTRICALS PRIVATE LIMITED",
"ENGINEERS ASSOCIATES PRIVATE LIMITED",
"ENGINEERS CONTINENTAL PVT LTD",
"ENGINEERS ESTATES MADRAS PRIVATE LIMITED",
"ENGINEERS INDIA LIMITED",
"ENGINEERS INSTITUTE OF INDIA PRIVATE LIMITED",
"ENGINEERS LEAGUE INC",
"ENGINEERS MECH INDIA PRIVATE LIMITED",
"ENGINEERSCONCRETE INDIA PRIVATE LIMITED",
"ENGINEMATES HEAT TRANSFER PRIVATE LIMITED",
"ENGINETECH SYSTEMS PRIVATE LIMITED",
"ENGINIA VEHICLES PRIVATE LIMITED",
"ENGINICS INFRA PRIVATE LIMITED",
"ENGINIUM DESIGNS PRIVATE LIMITED",
"ENGIPRESS INDUSTRIES PRIVATE LIMITED",
"ENGISTONE INDIA PRIVATE LIMITED",
"ENGITECH CONSULTANTS PRIVATE LIMITED",
"ENGLABS INDIA PRIVATE LIMITED",
"ENGLISH HOLIDAYS PRIVATE LIMITED",
"ENGLOBE LOGISTICS PRIVATE LIMITED",
"ENGO TEA COMPANY PRIVATE LIMITED",
"ENGPAR INTERNATIONAL PRIVATE LIMITED",
"ENGRAV AVIATION SERVICES &SYSTEMS PRIVATE LIMITED",
"ENGRAVE ENGINEERING AND SERVICES PRIVATE LIMITED",
"ENGRO TECHNOLOGIES LIMITED",
"ENGROW CARBON ENERGY PRIVATE LIMITED",
"ENGSER LTD.",
"ENGSER TECHNOLOGIES LTD",
"ENGSKO KRISTONE(INDIA) PRIVATE LIMITED",
"ENH ISECURE PRIVATE LIMITED",
"ENHANCE BUSINESS SOLUTIONS PRIVATE LIMITED",
"ENHANCE CONSTRUCTION PRIVATE LIMITED",
"ENHANCE ECOTECH SOLUTION PRIVATE LIMITED",
"ENHANCE LIFESTYLE PRIVATE LIMITED",
"ENHANCE MULTI TRADE PRIVATE LIMITED",
"ENHANCE SYSTEMS P LIMITED",
"ENHANCED I.T. SOLUTIONS PRIVATE LIMITED",
"ENHANCED MANUFACTURING INFORMATION SOLUTIONS INDIA PRIVATE LIMITED",
"ENHANCED SOFTWARE SOLUTIONS PRIVATE LIMITED",
"ENHANCED WAPP SYSTEMS (INDIA) PRIVATE LMITED",
"ENHANCER CONSULTANCY PRIVATE LIMITED",
"ENHANCER SOLUTIONS PRIVATE LIMITED",
"ENHANCER TRADING PRIVATE LIMITED",
"ENHANCESYS INNOVATIONS PRIVATE LIMITED",
"ENHANSAFE INDIA PRIVATE LIMITED",
"ENHAZ BEVERAGES PRIVATE LIMITED",
"ENHIRA SOFTWARE SERVICES LIMITED",
"ENHOPS SOLUTIONS PRIVATE LIMITED",
"ENIA DESIGN PRIVATE LIMITED",
"ENIAC INFOSYS PRIVATE LIMITED",
"ENICAR PHARMACEUTICALS PRIVATE LIMITED",
"ENIF PAPER PRODUCTS PRIVATE LIMITED",
"ENIGMA AUTOMOBILES PRIVATE LIMITED",
"ENIGMA HUMAN CAPITAL SERVICES PRIVATE LIMITED",
"ENIGMATIC WOODWORKS PRIVATE LIMITED",
"ENINJA TECHNOLOGIES PRIVATE LIMITED",
"ENIQUE IT SOLUTIONS PRIVATE LIMITED",
"E-NIRMAAN MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"ENJAY I.T.SOLUTIONS LIMITED",
"ENJAYES SPICES AND NATURAL FLAVOURS LIMITED",
"ENJOY COMMERCIAL PRIVATE LIMITED",
"ENJOY WISHLIST INDIA PRIVATE LIMITED",
"ENKAPTIVATE EVENTS & PROMOTIONS PRIVATE LIMITED",
"ENKASH NEW WAVES PRIVATE LIMITED",
"ENKAY AYURVEDIC VILLAGE PRIVATE LIMITED",
"ENKAY BRAND DISTRIBUTION PRIVATE LIMITED",
"ENKAY COFFEE SHOP PRIVATE LIMITED",
"ENKAY CONVERGED TECHNOLOGIES LLP",
"ENKAY ELECTRICALS PRIVATE LIMITED",
"ENKAY ENVIRO SERVICES PRIVATE LIMITED",
"ENKAY FLORALS PRIVATE LIMITED",
"ENKAY FOAM PRIVATE LIMITED",
"ENKAY GI SMITH ENGINEERING PRIVATE LIMITED",
"ENKAY GLOBAL IMPEX PRIVATE LIMITED",
"ENKAY HOSPITALITIES PRIVATE LIMITED",
"ENKAY HWS INDIA PRIVATE LIMITED",
"ENKAY LIFE REALTORS PRIVATE LIMITED",
"ENKAY SOLAR POWER AND INFRASTRUCTURE PRIVATE LIMITED",
"ENKAY TECHNOLOGIES I PRIVATE LIMITED",
"ENKAY TEXFAB PRIVATE LIMITED",
"ENKEBEE INFRATECH INDIA PRIVATE LIMITED",
"ENKEI WHEELS INDIA LIMITED",
"ENKI LIFE SCIENCE LIMITED",
"ENKIE INTERNATIONAL PRIVATE LIMITED",
"ENKINDLE TECHNOLOGIES PRIVATE LIMITED",
"ENKINLAB INDIA PRIVATE LIMITED",
"ENKRISH WEBTECH PRIVATE LIMITED",
"ENLEARN EDUCATION PRIVATE LIMITED",
"ENLIGHT CAD ENGINEERING",
"ENLIGHT GREEN POWER PRIVATE LIMITED",
"ENLIGHT REALTORS PRIVATE LIMITED",
"ENLIGHT SCHOOL OF NURSING",
"ENLIGHTA SOLUTIONS PRIVATE LIMITED",
"ENLIGHTED ENERGY SYSTEMS PRIVATE LIMITED",
"ENLIGHTEN SOFTWARE SERVICES PRIVATE LIMITED",
"ENLIGHTVISION TECHNOLOGIES PRIVATE LIMITED",
"ENLINK MANAGED SERVICES PRIVATE LIMITED",
"ENLIST MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"ENLITE RESEARCH PRIVATE LIMITED",
"ENLIVEN ESTATE MANAGEMENTS LLP",
"ENLIVENING TECHNOLOGIES PRIVATE LIMITED",
"ENLUME TECHNOLOGIES PRIVATE LIMITED",
"ENLYFT MEDIA PRIVATE LIMITED",
"ENLYFT NETWORKS PRIVATE LIMITED",
"ENMAC SYSTEMS PRIVATE LIMITED",
"ENMAROL PETROLEUM INDIA PRIVATE LIMITED",
"ENMARQ TECHNOLOGIES PRIVATE LIMITED",
"ENMAS ENGINEERING PRIVATE LIMITED",
"ENMAS EPC POWER PROJECTS LIMITED",
"ENMAS G.B. POWER SYSTEMS PRIVATE LIMITED",
"ENMAS INDIA PRIVATE LIMITED",
"ENMAS MINERALS PRIVATE LIMITED",
"ENMAS PROCESS TECHNOLOGIES LIMITED",
"ENMAX ENGINEERING INDIA PRIVATE LIMITED",
"ENMAX EPC PRIVATE LIMITED",
"ENMAX GLOBAL TECHNOLOGIES PRIVATE LIMITED",
"ENMAY WEBMEDIA PRIVATE LIMITED",
"ENMECH MACHINES PRIVATE LIMITED",
"ENMOVIL SOLUTIONS PRIVATE LIMITED",
"ENN ENGINEERS PRIVATE LIMITED",
"ENN ENN CAPITAL PRIVATE LIMITED",
"ENN ENN CORP LIMITED",
"ENN ESS ALLOYS PRIVATE LIMITED",
"ENN ESS POWER COMPANY PRIVATE LIMITED",
"ENN ESS TRADES PRIVATE LIMITED",
"ENN ESS TRAVELS PRIVATE LIMITED",
"ENN KAY HEAVY CONSTRUCTION PRIVATE LIMITED",
"ENN VEE HOLDINGS PRIVATE LIMITED",
"ENNAR SPINNING MILLS PRIVATE LIMITED",
"ENNCON SYNERGIES INDIA PRIVATE LIMITED",
"ENNDEE GRANITES AND STONES PRIVATE LIMITED",
"ENNEM EXCEL ENGINEERING PRIVATE LIMITED",
"ENNESS DESIGNS & INFRASTRUCTURE PRIVATE LIMITED",
"ENNOBLE IP CONSULTANCY PRIVATE LIMITED",
"ENNORE BULK TERMINAL PRIVATE LIMITED",
"ENNORE CARGO CONTAINER TERMINAL PRIVATE LIMITED",
"ENNORE COAL TERMINAL PRIVATE LIMITED",
"ENNORE TANK TERMINALS PRIVATE LIMITED",
"E-NNOVATE SOFTWARE PRIVATE LIMITED",
"ENNOVATORS (INDIA) PRIVATE LIMITED",
"ENNOVENTURE TECHNOLOGIES PRIVATE LIMITED",
"ENNOVI GLOBAL SERVICES PRIVATE LIMITED",
"ENNVEE SOLUTIONS PRIVATE LIMITED",
"ENOAH ISOLUTION INDIA PRIVATE LIMITED",
"ENOCH CONTROLS PRIVATE LIMITED",
"ENOCH NETWORK SYSTEMS PRIVATE LIMITED",
"ENOCH TRADING PRIVATE LIMITED",
"ENOCHIAN DESIGNS PRIVATE LIMITED",
"ENOCH'S INDUSTRIES PRIVATE LIMITED",
"ENOGIC COMMERCIAL TRADE PRIVATE LIMITED",
"ENOIA BABCOCK BORSIG PRIVATE LIMITED",
"ENOLAR SYSTEMS",
"ENOMARK HEALTHCARE PRIVATE LIMITED",
"ENOPECK SEALS INDUSTRIES PRIVATE LIMITED",
"ENOQUE HEALTHCARE SERVICES PRIVATE LIMITED",
"ENORMOUS INDUSTRIAL TRADE PRIVATE LIMITED",
"ENORMOUS IT SERVICES PRIVATE LIMITED",
"ENOTECA BY MADHULOKA PRIVATE LIMITED",
"ENOVA FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"ENOVA MULTITRADE PRIVATE LIMITED",
"ENOVATE BIOLIFE PRIVATE LIMITED",
"ENOVATE IT OUTSOURCING PRIVATE LIMITED",
"ENOVATE LIFESTYLES PRIVATE LIMITED",
"ENOVATE MEDIA SOLUTIONS PRIVATE LIMITED",
"ENOVATEIT INTEGRATED SERVICES PRIVATE LIMITED",
"ENOVUS ENTERPRISES PRIVATE LIMITED",
"ENOVUS HEALTHCARE PRIVATE LIMITED",
"ENP IMPEX PRIVATE LIMITED",
"ENP SOLUTIONZ PRIVATE LIMITED",
"ENPAL AIRCON PRIVATE LIMITED",
"ENPAR STEELS PRIVATE LIMITED",
"ENPARADIGM PERFORMANCE SOLUTIONS PRIVATE LIMITED",
"ENPASS TECHNOLOGIES PRIVATE LIMITED",
"ENPAY TRANSFORMER COMPONENTS INDIA PRIVATE LIMITED",
"ENPEE ENTERPRISES PRIVATE LIMITED",
"ENPEE PRINTING PRESS (INDIA) PRIVATE LIMITED",
"ENPERSOLL IT PRIVATE LIMITED",
"ENPHASE SOLAR ENERGY PRIVATE LIMITED",
"ENPHINITI ENGINEERING SOLUTIONS PRIVATE LIMITED",
"ENPOSSIBILITIES PRIVATE LIMITED",
"ENPRO BIO SCIENCES PRIVATE LIMITED",
"ENPROCON ENTERPRISE LIMITED",
"ENPRO ENVIRO TECH AND ENGINEERS PRIVATE LIMITED",
"ENPRO INDUSTRIAL AUTOMATION PRIVATE LIMITED",
"ENPRO INDUSTRIES PRIVATE LIMITED",
"ENPRO TELECOM PRIVATE LIMITED",
"ENPRODUCTS PRIVATE LIMITED",
"ENPROSYST SOLUTION PRIVATE LIMITED",
"ENPROWESS TECHNOLOGIES PRIVATE LIMITED",
"ENPS INFRA PROJECTS PRIVATE LIMITED",
"ENQOS SOFTWARE TECHNOLOGIES P LIMITED",
"ENQUERO GLOBAL LLP",
"ENQUEST PETRO SOLUTIONS PRIVATE LIMITED",
"ENRATEC CONSULTANCY SERVICES PRIVATE LIMITED",
"ENREAP INDIA PRIVATE LIMITED",
"ENRICA ENTERPRISES PRIVATE LIMITED",
"ENRICH ACADEMY",
"ENRICH ADVISORS PRIVATE LIMITED",
"ENRICH AGRO FOOD PRODUCTS PRIVATE LIMITED",
"ENRICH AGRO PROCESSING INDUSTRY PRIVATE LIMITED",
"ENRICH COMMODITIES INDIA PRIVATE LIMITED",
"ENRICH DATA SERVICES PRIVATE LIMITED",
"ENRICH ENERGY PRIVATE LIMITED",
"ENRICH FINANCIAL MARKET PRIVATE LIMITED",
"ENRICH HAIR AND SKIN SOLUTIONS PRIVATE LIMITED",
"ENRICH POWER CONSULTANCY PRIVATE LIMITED",
"ENRICH RD INFRAPROJECTS PRIVATE LIMITED",
"ENRICH SOLAR SERVICES PRIVATE LIMITED",
"ENRICH UDHYOG PRIVATE LIMITED",
"ENRICHWISE FINANCIAL SERVICES PRIVATE LIMITED",
"ENRIKA TRADES AND SERVICES PRIVATE LIMITED",
"ENRISSION INDIA PRIVATE LIMITED",
"ENROC IT SOLUTIONS PRIVATE LIMITED",
"ENROSE VS PRIVATE LIMITED",
"ENSA ENVIRONICS PRIVATE LIMITED",
"ENSAFEGUARD SECURITY PRIVATE LIMITED",
"ENSAR SOLUTIONS PRIVATE LIMITED",
"ENSATIO FOODS (INDIA) PRIVATE LIMITED",
"ENSAVE ENERGY PRIVATE LIMITED",
"ENSAVIOR TECHNOLOGIES PRIVATE LIMITED",
"ENSEIGNER PRIVATE LIMITED",
"ENSEMBLE TECH PRIVATE LIMITED",
"ENSER COMMUNICATIONS LIMITED",
"ENSER COMMUNICATIONS PRIVATE LIMITED",
"ENSERVE CONSULTANCY SERVICES PRIVATE LIMITED",
"ENSHINE SERVICES PRIVATE LIMITED",
"ENSHRINE LEASING AND INFOTECH PRIVATE LIMITED",
"ENSHU INDIA PRIVATE LIMITED",
"ENSIGHT BUSINESS SOLUTIONS PRIVATE LIMITED",
"ENSIGN INSURANCE BROKERS PRIVATE LIMITED",
"ENSIGNS DIET CARE PRIVATE LIMITED",
"ENSIM INDIA PRIVATE LIMITED",
"ENSINGER INDIA ENGINEERING PLASTICS PRIVATE LIMITED",
"ENSO LOGIC COMMERCE PRIVATE LIMITED",
"ENSOFTEK SOLUTIONS INDIA PRIVATE LIMITED",
"ENSOL CELLS AND BATTERIES PRIVATE LIMITED",
"ENSOL ENERGY PRIVATE LIMITED",
"ENSOL INDUSTRIES PRIVATE LIMITED",
"ENSOL INFRATECH PRIVATE LIMITED",
"ENSONIC COMPUTECH PRIVATE LIMITED",
"ENSONO TECHNOLOGIES LLP",
"ENSOURCE CONSULTING PRIVATE LIMITED",
"ENSOVA ENERTECH SOLUTIONS PRIVATE LIMITED",
"ENSPIREON INDUSTRIES PRIVATE LIMITED",
"ENSTAGE SOFTWARE PRIVATE LIMITED",
"ENSTEAD",
"ENSTECH TECHNOLOGIES PRIVATE LIMITED",
"ENSTIN LABS PRIVATE LIMITED",
"ENSTO INDIA PRIVATE LIMITED",
"ENSTOA INDIA PRIVATE LIMITED",
"ENSTRAPP IT SOLUTIONS PRIVATE LIMITED",
"ENSTYLE CONTRACTS & ENGINEERS PRIVATE LIMITED",
"ENSUING SOLUTIONS PRIVATE LIMITED",
"ENSURE BIOTECH PRIVATE LIMITED",
"ENSURE ENTERPRISES PRIVATE LIMITED",
"ENSURE INNOVATIONS PRIVATE LIMITED",
"ENSURE PHARMACEUTICALS PRIVATE LIMITED",
"ENSURE SECURITY AND STAFFING PRIVATE LIMITED",
"ENSUREDIT TECHNOLOGIES PRIVATE LIMITED",
"ENSURETI INSURANCE BROKING PRIVATE LIMITED",
"ENSURITY TECHNOLOGIES PRIVATE LIMITED",
"ENSYS TECHNOLOGIES INDIA PRIVATE LIMITED",
"ENT HOSPITAL KOTI",
"ENTAB INFOSYSTEM PRIVATE LIMITED",
"ENTAB INFOTECH PRIVATE LIMITED",
"ENTABLATURE INFRASTRUCTURE PRIVATE LIMITED",
"ENTARCHCON INFRATECH PRIVATE LIMITED",
"ENTASIS INDIA PRIVATE LIMITED",
"ENTASIS TECHNOLOGY PRIVATE LIMITED",
"ENTCO MEDIA PRIVATE LIMITED",
"ENTCO SOFTWARE INDIA PRIVATE LIMITED",
"ENTEC INDUSTRIAL FERNACES PRIVATE LIMITED",
"ENTECH CONSTRUCTION CO",
"ENTECH CONSULTANCY BUREAU MADRAS PRIVATE LIMITED",
"ENTECH CONTROLS",
"ENTECH KUNSTSTOFFE SOLUTIONS PRIVATE LIMITED",
"ENTECH SIGNS AND DISPLAYS INDIA PRIVATE LIMITED",
"ENTECNIA CONSULTING PRIVATE LIMITED",
"ENTECO ENGINEERS PRIVATE LIMITED",
"ENTECRES LABS PRIVATE LIMITED",
"ENTEK INSTRUMENTS (INDIA) PRIVATE LIMITED",
"ENTEL FOOD PRODUCTS PVT LTD",
"EN-TEL NETWORK SYSTEMS PRIVATE LIMITED",
"ENTELECHY AUTOMATION PRIVATE LIMITED",
"ENTELECHY GLOBAL TECHNOLOGY PRIVATE LIMITED",
"ENTELLUS BUSINESS SOLUTIONS PRIVATE LIMITED",
"ENTELLUS SECURITY AND ALLIED SERVICES PRIVATE LIMITED",
"ENTELYGLOBAL SOLUTIONS PRIVATE LIMITED",
"ENTER 10 TELEVISION PRIVATE LIMITED",
"ENTER TECH ENTERTAINMENT PRIVATE LIMITED",
"ACTIOHX SOLUTIONS PRIVATE LIMITED",
"ENTERO HEALTHCARE SOLUTIONS LIMITED",
"ENTERO HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"ENTERPI SOFTWARE SOLUTIONS PRIVATE LIMITED",
"ENTERPRISE ADVERTISING PVT LTD",
"ENTERPRISE BUSINESS TECHNOLOGIES PRIVATE LIMITED",
"ENTERPRISE COMMUNICATION SUITE INDIA PRIVATE LIMITED",
"ENTERPRISE CUBE PRIVATE LIMITED",
"ENTERPRISE INTERNATIONAL LTD",
"ENTERPRISE LOGIC INDIA PRIVATE LIMITED",
"ENTERPRISE LOGISTICS PRIVATE LIMITED",
"ENTERPRISE OPTHALMICS PRIVATE LIMITED",
"ENTERPRISE PRODUCT INTEGRATION PRIVATE LIMITED",
"ENTERPRISE PROJECT MANAGEMENT SOLUTIONS INDIA PRIVATE LIMITED",
"ENTERPRISE SOCIAL MEDIA PRIVATE LIMITED",
"ENTERPRISE SOFTLABS PRIVATE LIMITED",
"ENTERPRISE SOFTLABS SERVICES PRIVATE LIMITED",
"ENTERPRISE SOFTWARE SOLUTIONS LAB PRIVATE LIMITED",
"ENTERPRISE SYSTEM SOLUTIONS PRIVATE LIMITED",
"ENTERPRISE360 MANAGEMENT & TECHNOLOGY CONSULTANTS LLP",
"ENTERPRISEDB SOFTWARE INDIA PRIVATE LIMITED",
"ENTERPRISEMINDS INDIA PRIVATE LIMITED",
"ENTERPRISING ENTERPRISES",
"ENTERSLICE PRIVATE LIMITED",
"ENTERSOFT INFORMATION SYSTEMS PRIVATE LIMITED",
"ENTERSTELLAR SOFTWARES PRIVATE LIMITED",
"ENTERTAINMENT 7 CREATIVE VENTURES PRIVATE LIMITED",
"ENTERTAINMENT AMP PRIVATE LIMITED",
"ENTERTAINMENT CITY LIMITED",
"ENTERTAINMENT NETWORK INDIA LIMITED",
"ENTERTAINMENT PRIVATE LIMITED",
"ENTERTAINMENT SOLUTION PROVIDERS INDIA PRIVATE LIMITED",
"ENTERTAINMENT SPORTZ PRIVATE LIMITED",
"ENTES ENERGY MANAGEMENT SYSTEMS PRIVATE LIMITED",
"ENTEX PRIVATE LIMITED",
"ENTHALPY SOLUTIONS PRIVATE LIMITED",
"ENTHRAL SERVICES & AVIATION PRIVATE LIMITED",
"ENTHRALL COMMUNICATIONS PRIVATE LIMITED",
"ENTHRALL FOODS PRIVATE LIMITED",
"ENTHRALLTECH PRIVATE LIMITED",
"ENTHU TECHNOLOGY SOLUTIONS INDIA PRIVATE LIMITED",
"ENTHUSE ANSWERS COMMUNICATIONS PRIVATE LIMITED",
"ENTHUSE TECHNOLOGIES PRIVATE LIMITED",
"ENTHUSE-ANSWERS TRAVEL & TOURS PRIVATE LIMITED",
"ENTHUSIASM STRATEGIC MARKETING PRIVATE LIMITED",
"ENTHUSIAST GLOBAL PRIVATE LIMITED",
"ENTICE WAY TRADELINK PRIVATE LIMITED",
"ENTICEMENT INFRASTRUCTURE PRIVATE LIMITED",
"ENTIGENCE SOLUTIONS INDIA PRIVATE LIMITED",
"ENTIGRITY OFFSHORE SERVICE LLP",
"ENTIGRITY PRIVATE LIMITED",
"ENTIOVI TECHNOLOGIES PRIVATE LIMITED",
"ENTIRE ENGINEERING SOLUTIONS PRIVATE LIMITED",
"ENTIRE ESTATES PRIVATE LIMITED",
"ENTIRE FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"ENTIRE IT DESIGN PRIVATE LIMITED",
"ENTIT CONSULTANCY SERVICES PRIVATE LIMITED",
"ENTITY DIGITAL SPORTS PRIVATE LIMITED",
"ENTITY EXIM PRIVATE LIMITED",
"ENTO PROTEINS PRIVATE LIMITED",
"ENTOD PHARMACEUTICALS LIMITED",
"ENTOS DE-PEST SOLUTIONS PRIVATE LIMITED",
"ENTOURAGE FILMS PRIVATE LIMITED",
"ENTRA SOLUTIONS PRIVATE LIMITED",
"ENTRACO POWER SYSTEMS PVT. LTD.",
"ENTRACO-BKS BUSDUCTS PRIVATE LIMITED",
"ENTRAK INTERNATIONAL TRADING PRIVATE LIMITED",
"ENTRANS TECHNOLOGIES PRIVATE LIMITED",
"ENTRANSYS PRIVATE LIMITED",
"ENTRANT TECHNOLOGIES PRIVATE LIMITED",
"ENTRATA INDIA PRIVATE LIMITED",
"ENTRE NOUS EXPERIENCES PRIVATE LIMITED",
"ENTREMET CAKECRAFT PRIVATE LIMITED",
"ENTREMONDE POLYCOATERS LIMITED",
"ENTREPOT CARGO PRIVATE LIMITED",
"ENTREPRENEUR",
"ENTREPRENEUR INDIA MEDIA PRIVATE LIMITED",
"ENTREPRENEURS ORGANISATION (NEW DELHI)",
"ENTREPRENEURS ORGANISATION INDORE",
"ENTREPRENEURS ORGANIZATION",
"ENTREPRENEURS' ORGANIZATION MUMBAI",
"ENTREPRENEURS' ORGANIZATION PUNE",
"ENTREPRENEURSHIP DEVELOPMENT AND INNOVATION INSTITUTE",
"ENTREPRENEURSHIP DEVELOPMENT CENTER",
"ENTREPRENEURSHIP DEVELOPMENT INSTITUTE OF INDIA",
"ENTREPRENEURSHIP IMMERSION PROGRAM ENTERPRISE",
"ENTREPRENEURSHIP IMMERSION PROGRAM ENTERPRISES",
"ENTRIB ANALYTICS TECHNOLOGY PRIVATE LIMITED",
"ENTRO LABS IT SOLUTIONS PRIVATE LIMITED",
"ENTROPIA ENERGY PRIVATE LIMITED",
"ENTROPIK TECHNOLOGIES PRIVATE LIMITED",
"ENTROPY DESIGNS PRIVATE LIMITED",
"ENTRUST COMMUNICATIONS PRIVATE LIMITED",
"ENTRUST ENCORE SERVICES PRIVATE LIMITED",
"ENTRUST FAMILY OFFICE INVESTMENT ADVISORS PRIVATE LIMITED",
"ENTRUST FAMILY OFFICE SERVICES LLP",
"ENTRUST GRANITES PRIVATE LIMITED",
"ENTRUST HEALTHCARE PRIVATE LIMITED",
"ENTRUST SECURITY SOLUTIONS INDIA PRIVATE LIMITED",
"ENTRUST SHIPPING SERVICES PRIVATE LIMITED",
"ENTRUST SOFTWARE AND SERVICES PRIVATE LIMITED",
"ENTRY INDIA PROJECTS PRIVATE LIMITED",
"ENTRYWATCH TECHNOLOGIES PRIVATE LIMITED",
"ENTRYWAY SHIPPING AND LOGISTICS PRIVATE LIMITED",
"ENTUNE IT CONSULTING PRIVATE LIMITED.",
"ENTUPLE TECHNOLOGIES PRIVATE LIMITED",
"ENTURA HYDRO TASMANIA INDIA PRIVATE LIMITED",
"ENTUTO TECHNOLOGIES PRIVATE LIMITED",
"ENTWINE SOLUTIONS LLP",
"ENTYTLE INDIA PRIVATE LIMITED",
"ENUKE SOFTWARE PRIVATE LIMITED",
"ENV DEVELOPMENTAL ASSISTANCE SYSTEMS INDIA PRIVATE LIMITED",
"ENVA WATER TECHNOLOGIES PRIVATE LIMITED",
"ENVAC ENVIRONMENTAL TECHNOLOGY PRIVATE LIMITED",
"ENVAIR ELECTRODYNE LIMITED",
"ENVANA LIFESCIENCES PRIVATE LIMITED",
"ENVEAN LEASING AND INVESTMENTS PRIVATE LTD.",
"ENVECON GLOBAL SOLUTIONS PRIVATE LIMITED",
"ENVECON IT SYSTEMS PRIVATE LIMITED",
"ENVEDA THERAPEUTICS INDIA PRIVATE LIMITED",
"ENVEE DRUGS PRIVATE LIMITED",
"ENVEE INFORMATION TECHNOLOGY PRIVATE LIMITED",
"ENVENT WORLD WIDE PRIVATE LIMITED",
"ENVENTA POWER TECHNOLOGIES PRIVATE LIMITED",
"ENVENTION SOLUTIONS (INDIA) PRIVATE LIMITED",
"ENVENTURE ENGINEERING LLP",
"ENVENTURE TECHNOLOGY SERVICES INDIA PRIVATE LIMITED",
"ENVEON PROJECTS PRIVATE LIMITED",
"ENVERGY PROJECTS LIMITED",
"ENVERTIS INFOSOFT PRIVATE LIMITED",
"ENVERTIZ CONSULTANCY PRIVATE LIMITED",
"ENVERUS INDIA PRIVATE LIMITED",
"ENVESTNET ASSET MANAGEMENT INDIA PRIVATE LIMITED",
"ENVESTOR VENTURES PRIVATE LIMITED",
"ENVIABLY ME INDIA PRIVATE LIMITED",
"ENVIART PRIVATE LIMITED",
"ENVICARE SOLUTIONS PRIVATE LIMITED",
"ENVICARE TECHNOLOGIES PRIVATE LIMITED",
"ENVICON TECHNOLOGIES INDIA PRIVATE LIMITED",
"ENVIFLOW ENGINEERING PRIVATE LIMITED",
"ENVIGAURD ENGINEERING AND TURNKEY PROJECTS PRIVATE LIMITED",
"ENVIGO MARKETING PRIVATE LIMITED",
"ENVIIRO BULKK HANDLING SYSTEMS PRIVATE LIMITED",
"ENVILON ELECTRO PRIVATE LIMITED",
"ENVIORNMENT DEPTT LUCKNOW",
"ENVIPRO ENGINEERING PRIVATE LIMITED",
"ENVIRAD EDUCATION",
"ENVIRAD PROJECTS PRIVATE LIMITED",
"ENVIREX INDIA PRIVATE LIMITED",
"ENVIRO ANALYSTS AND ENGINEERS PRIVATE LIMITED",
"ENVIRO BUILDMATE PRIVATE LIMITED",
"ENVIRO CHEM ENGINEERS & CONSULTANTS INDIA PRIVATE LIMITED",
"ENVIRO CHEMICAL CRAFTS PRIVATE LIMITED",
"ENVIRO CONTROL PRIVATE LIMITED",
"ENVIRO FIBERS PRIVATE LIMITED",
"ENVIRO GREEN ALLOYS INC.",
"ENVIRO GREEN RECYCLING PRIVATE LIMITED",
"ENVIRO HEIGHTS PRIVATE LIMITED",
"ENVIRO INFRA ENGINEERS LIMITED",
"ENVIRO INFRA ENGINEERS PRIVATE. LIMITED.",
"ENVIRO INFRA SOLUTIONS PRIVATE LIMITED",
"ENVIRO INFRAFACILITY PRIVATE LIMITED",
"ENVIRO INFRASTRUCTURE COMPANY LIMITED",
"ENVIRO INTEGRATED FACILITY SERVICES PRIVATE LIMITED",
"ENVIRO METALS RECYCLERS PRIVATE LIMITED",
"ENVIRO O&M SERVICES PRIVATE LIMITED",
"ENVIRO POLICY RESEARCH INDIA PRIVATE LIMITED",
"ENVIRO RECYCLEAN PRIVATE LIMITED",
"ENVIRO ROOTS DEVICES PRIVATE LIMITED",
"ENVIRO SAFETY PRIVATE LIMITED",
"ENVIRO SERVE PRIVATE LIMITED",
"ENVIRO SOLAIRE PRIVATE LIMITED",
"ENVIRO SOLUTIONS",
"ENVIRO TECH INSTRUMENTS PVT LTD",
"ENVIRO TECH VENTURES LIMITED",
"ENVIRO TECHNOLOGY LIMITED",
"ENVIRO WAY BIO-SCIENCE PRIVATE LIMITED",
"ENVIROCAL INDIA PRIVATE LIMITED",
"ENVIROCARE INFRASOLUTION PRIVATE LIMITED",
"ENVIROCARE LABS PRIVATE LIMITED",
"ENVIROCARE RECYCLING PRIVATE LIMITED",
"ENVIROCARE TECHNOCRATS PRIVATE LIMITED",
"ENVIROCHEM TECH SOLUTIONS (INDIA) PRIVATE LIMITED",
"ENVIROCOAT POWDERS PRIVATE LIMITED",
"ENVIROFIT (INDIA) PRIVATE LIMITED",
"ENVIROGREEN CONSULTANTS (INDIA) PRIVATE LIMITED",
"ENVIROGREEN FENESTRATION PRIVATE LIMITED",
"ENVIROKARE RECYCLING SOLUTIONS PRIVATE LIMITED",
"ENVIRON ENGINEERS",
"ENVIRON SOFTWARE PRIVATE LIMITED",
"ENVIRON SPECIALITY CHEMICALS PRIVATE LIMITED",
"ENVIRONMENTAL DYNAMICS INDIA PRIVATE LIMITED",
"ENVIRONMENTAL ENGINEERING FILTERS PRIVATE LIMITED",
"ENVIRONMENTAL PROTECTION SERVICE COMPANY (DELHI) PRIVATE LIMITED",
"ENVIRONMENTAL RESOURCES FOUNDATION",
"ENVIRONMENTAL SYSTEMS PRODUCTS INDIA PRIVATE LIMITED",
"ENVIRONMENTAL TECHNICAL SERVICES PRIVATE LIMITED",
"ENVIRONMENTAL VISION PRIVATE LIMITED",
"ENVIRONNEMENT SA INDIA PRIVATE LIMITED",
"ENVIRONS INDIA PRIVATE LIMITED",
"ENVIRONS MANAGEMENT (BANGALORE) PRIVATE LIMITED",
"ENVIROPOL ENGINEERS PRIVATE LIMITED",
"ENVIROS INDIA PRIVATE LIMITED",
"ENVIROTEC ENGINEERS INDIAPRIVATE LIMITED",
"ENVIROTECH AKVA PRIVATE LIMITED",
"ENVIROTECH DESIGN PRIVATE LIMITED",
"ENVIROTECH EAST PVT. LTD.",
"ENVIROTECH ONLINE EQUIPMENTS PRIVATE LIMITED",
"ENVIROTECH RESEARCH PRIVATE LIMITED",
"ENVIROTECH SYSTEMS LIMITED",
"ENVIROTECH SYSTEMS PRIVATE LIMITED",
"ENVIRO-TREAT ENGINEERS PRIVATE LIMITED",
"ENVIROX PROTECTION COMPANY PRIVATE LIMITED",
"ENVISAGE BPO SERVICES",
"ENVISAGE INSIGHTS LLP",
"ENVISECURE CONSTRUCTIONS PRIVATE LIMITED",
"ENVISION ASSOCIATES LLP",
"ENVISION BUSINESS SOLUTION PRIVATE LIMITED",
"ENVISION COATING SOLUTIONS PRIVATE LIMITED",
"ENVISION ENTERPRISE SOLUTIONS PRIVATE LIMITED",
"ENVISION ENVIRO TECHNOLOGIES PRIVATE LIMITED",
"ENVISION EXIM PRIVATE LIMITED",
"ENVISION EXPORTS PRIVATE LIMITED",
"ENVISION FINANCIAL SYSTEMS (INDIA) PRIVATE LIMITED",
"ENVISION INTEGRATED SERVICES PRIVATE LIMITED",
"ENVISION NETWORK TECHNOLOGIES PRIVATE LIMITED",
"ENVISION RESOURCES PRIVATE LIMITED",
"ENVISION SCIENTIFIC PRIVATE LIMITED",
"ENVISION SOFTWARE ENGINEERING PRIVATE LIMITED",
"ENVISION WIND POWER SERVICES INDIA PRIVATE LIMITED",
"ENVISION ENERGY INDIA PRIVATE LIMITED",
"ENVISIONARD SOFTWARE SERVICES PRIVATE LIMITED",
"ENVISIOR CONSULTING PRIVATE LIMITED",
"ENVISTA CONSULTING AND INNOVATIVE TECH SERVICES PL",
"ENVISYS TECHNOLOGIES PRIVATE LIMITED",
"ENVITEC AGROTRADE PRIVATE LIMITED",
"ENVITECH CHEMICAL SPECIALITIES PRIVATE LIMITED",
"ENVITECT COMPOSITE PRIVATE LIMITED",
"ENVI-TELECON SERVICES PRIVATE LIMITED",
"ENVITRO LABORATORIES PRIVATE LIMITED",
"ENVIU IMPACT INNOVATION SERVICES PRIVATE LIMITED",
"ENVIZION CREATIVE SOLUTION PRIVATE LIMITED",
"ENVOCARE PEST CONTROL SERVICES PRIVATE LIMITED",
"ENVOCRYSTAL INDIA PRIVATE LIMITED",
"ENVOGUE FURNISHINGS INDIA PRIVATE LIMITED",
"ENVOGUE WOOD WORKING PRIVATE LIMITED",
"ENVOMIN ORES PRIVATE LIMITED",
"ENVOQUE SOLUTIONS PRIVATE LIMITED",
"ENVOTEL HOTELS HIMACHAL PRIVATE LIMITED",
"ENVOTIONS TECHNOLOGY SERVICES INDIA PRIVATE LIMITED",
"ENVOY CARRIER PRIVATE LIMITED",
"ENVOY MORTGAGE (INDIA) PRIVATE LIMITED",
"ENVOY TECHNOSYS PRIVATE LIMITED",
"ENVOYS ELECTRONICS PRIVATE LIMITED",
"ENVOZYME TECHNOLOGIES PRIVATE LIMITED",
"ENVYRONS INFRASTRUCTURE PRIVATE LIMITED",
"ENVYTEE INFO SOLUTIONS PRIVATE LIMITED",
"ENWIDTH TECHNOLOGIES PRIVATE LIMITED",
"ENXUM DIGITAL SECURITY PRIVATE LIMITED",
"ENY MINNY PRIVATE LIMITED",
"ENYOTA LEARNING PRIVATE LIMITED",
"ENZA ZADEN INDIA PRIVATE LIMITED",
"ENZAL CHEMICALS INDIA LIMITED",
"ENZEN TECHNOLOGIES PRIVATE LIMITED",
"ENZENE BIOSCIENCES LIMITED",
"ENZIE BRANDS PRIVATE LIMITED",
"ENZIGMA SOFTWARE PRIVATE LIMITED",
"ENZL CRAFT PRIVATE LIMITED",
"ENZO CERAMIC PRIVATE LIMITED",
"ENZOSYNTH PRIVATE LIMITED",
"ENZOTECH SOLUTIONS PRIVATE LIMITED",
"ENZU.LIFE PRIVATE LIMITED",
"ENZYMCO PRIVATE LIMITED",
"ENZYME BIOSCIENCE PRIVATE LIMITED",
"ENZYME ENGINEERING & SERVICES PRIVATE LIMITED",
"ENZYME INDIA PRIVATE LIMITED",
"ENZYME OVERSEAS PRIVATE LIMITED",
"EO ENERGY PRIVATE LIMITED",
"EOC POLYMERS INDIA PRIVATE LIMITED",
"EODDLEY MEDICALS PRIVATE LIMITED",
"EODIS INDIA PRIVATE LIMITED",
"EOK TECHNOLOGIES INFOSYSTEMS PRIVATE LIMITED",
"EOLITH NATURAL STONES PRIVATE LIMITED",
"EON ELEVATORS PRIVATE LIMITED",
"EON HADAPSAR INFRASTRUCTURE PRIVATE LIMITED",
"EON INFOTECH LIMITED",
"EON KHARADI INFRASTRUCTURE PRIVATE LIMITED",
"EON MEDITECH PRIVATE LIMITED",
"EON NETWORKS PRIVATE LIMITED",
"EON PROPERTIES PRIVATE LIMITED",
"EON SALES ENTERPRISES PRIVATE LIMITED",
"EON TECHNOLOGIES PRIVATE LIMITED",
"EON-HINJEWADI INFRASTRUCTURE PRIVATE LIMITED",
"EONIAN SOFTWARE SOLUTIONS PRIVATE LIMITED",
"EONN PLAST INDIA PRIVATE LIMITED",
"EOPL VENTURES PRIVATE LIMITED",
"EORBITOR TECHNOLOGIES PRIVATE LIMITED",
"EORIGAMI SOFTWARE PRIVATE LIMITED",
"EOS CAPITAL ADVISORS PRIVATE LIMITED",
"EOS ELECTRO OPTICAL SYSTEMS INDIA PRIVATE LIMITED",
"EOS HOSPITALITY PRIVATE LIMITED",
"EOX VANTAGE PRIVATE LIMITED",
"EOXIS RENEWABLE ENERGY INDIA PRIVATE LIMITED",
"EOXYS SYSTEMS INDIA PRIVATE LIMITED",
"EP BIOCOMPOSITES LIMITED",
"EP ELECTRONIC PARADISE PRIVATE LIMITED",
"EP INFOWAYS PRIVATE LIMITED",
"EP&M INDIA PRIVATE LIMITED",
"EPAC FLEXIBLES PRIVATE LIMITED",
"EPACE TECHNOLOGIES PRIVATE LIMITED",
"EPACIFIC SERVICES PRIVATE LIMITED",
"EPACK COMPONENTS PRIVATE LIMITED",
"EPACK DURABLE LIMITED",
"EPACK DURABLE PRIVATE LIMITED",
"EPACK POLYMERS PRIVATE LIMITED",
"EPAISA SOE PRIVATE LIMITED",
"EPALMLEAF ITES PRIVATE LIMITED",
"EPAM SYSTEMS INDIA PRIVATE LIMITED",
"EPARI GOVINDAM PRIVATE LIMITED",
"EPARK PLACES PRIVATE LIMITED",
"EPARK PROPERTY PRIVATE LIMITED",
"EPARK STRUCTURE PRIVATE LIMITED",
"EPAY INFOSERVE PRIVATE LIMITED",
"EPAY TECHNO SOLUTIONS PRIVATE LIMITED",
"EPC CONTRACTS (INDIA) PRIVATE LIMITED",
"EPC INFRACON PRIVATE LIMITED",
"EPC INTERNATIONAL PRIVATE LIMITED",
"EPC PERFECT PRIVATE LIMITED",
"EPC TECH PRIVATE LIMITED",
"EPCOAT SPRAY TECH PRIVATE LIMITED",
"EPCOAT SURFACE FINISHING TECHNOLOGIES PRIVATE LIMITED",
"EPCON WATER TECHNOLOGIES PRIVATE LIMITED",
"EPE INDUSTRIES INDIA PRIVATE LIMITED",
"EPE PROCESS FILTERS AND ACCUMULATORS PRIVATE LIMITED",
"EPEE METAL GOA PRIVATE LIMITED",
"EPEOPLE BESPOKE CONSULTING PRIVATE LIMITED",
"EPHATH ALLMED PRIVATE LIMITED",
"EPHESOFT INDIA PRIVATE LIMITED",
"EPHICACY LIFESCIENCE ANALYTICS PRIVATE LIMITED",
"EPHPHATHA HEARING SOLUTIONS PRIVATE LIMITED",
"EPHPHATHA MEDICAL SERVICES PRIVATE LIMITED",
"EPHRON SYSTEMS PRIVATE LIMITED",
"EPI ELECTRICALS PRIVATE LIMITED",
"EPI ENGINEERING AND PROJECT INDIA PRIVATE LIMITED",
"EPI SOURCE INDIA PRIVATE LIMITED",
"EPI SWITCHGEARS PRIVATE LIMITED",
"EPIANCE SOFTWARE PRIVATE LIMITED",
"EPIC (INDIA) TOURS AND EVENTS PRIVATE LIMITED",
"EPIC ADMINISTRATION PRIVATE LIMITED",
"EPIC AGRO PRODUCTS PRIVATE LIMITED",
"EPIC ALLOY STEEL PRIVATE LIMITED",
"EPIC BRANDS PRIVATE LIMITED",
"EPIC CHEMICALS PRIVATE LIMITED",
"EPIC CONSULTING SERVICES",
"EPIC ELEVATORS PRIVATE LIMITED",
"EPIC ENERGY LIMITED",
"EPIC ENGITECH PRIVATE LIMITED",
"EPIC FOOD PRODUCTS PRIVATE LIMITED",
"EPIC GLOBAL HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"EPIC GLOBAL SERVICES PRIVATE LIMITED",
"EPIC HOSPITAL",
"EPIC HOTELS PRIVATE LIMITED",
"EPIC INDIA PRIVATE LIMITED",
"EPIC SUSTAINABILITY SERVICES PRIVATE LIMITED",
"EPIC TECHNOLOGY RESEARCH PRIVATE LIMITED",
"EPIC YARNS PRIVATE LIMITED",
"EPICENTER TECHNOLOGIES PRIVATE LIMITED",
"EPICERIE BRANDS PRIVATE LIMITED",
"EPICLE SOLUTIONS PRIVATE LIMITED",
"EPICMINDS INFORMATION TECHNOLOGY PRIVATE LIMITED",
"EPICMINDS SERVICES LLP",
"EPICODE PRIVATE LIMITED",
"EPICOMM TECHNOLOGIE LIMITED",
"EPICON CONSTRUCTIONS PRIVATE LIMITED",
"EPICONS CONSULTANTS PRIVATE LIMITED",
"EPICONS INFRASTRUCTURE PRIVATE LIMITED",
"EPICOR SOFTWARE INDIA PRIVATE LIMITED",
"EPICROP ORGANICS LIMITED",
"EPICTENET CONSULTANCY PRIVATE LIMITED",
"EPICTUS SOLUTIONS INDIA PRIVATE LIMITED",
"EPICU AGRO PRODUCTS PRIVATE LIMITED",
"EPICU BEVRAGES PRIVATE LIMITED",
"EPICURE FROZEN FOODS & BEVERAGES PRIVATE LIMITED",
"EPICURIAN FOODS PRIVATE LIMITED",
"EPIGENERES BIOTECH PRIVATE LIMITED",
"EPIGON MEDIA TECHNOLOGIES PRIVATE LIMITED",
"EPIGRAL LIMITED",
"EPIKINDIFI SOFTWARE & SOLUTIONS PRIVATE LIMITED",
"EPIKSO INDIA PRIVATE LIMITED",
"EPIMONEY PRIVATE LIMITED",
"EPINET INFO PRIVATE LIMITED",
"EPIONE HEALTHCARE PRIVATE LIMITED",
"EPIONE LABS PRIVATE LIMITED",
"EPIONE MED RX PHARMACY PRIVATE LIMITED",
"EPIONE PAINCARE PRIVATE LIMITED",
"EPIONE PHARMACEUTICALS PRIVATE LIMITED",
"EPIPHANY HOSPITALITY PRIVATE LIMITED",
"EPIPHANY IP SOLUTIONS PRIVATE LIMITED",
"EPIQ CAPITAL INVESTMENT ADVISORY LLP",
"EPIQ SIFTECH PRIVATE LIMITED",
"EPIQSYSTEMS INDIA PRIVATE LIMITED",
"EPIROC MINING INDIA LIMITED",
"EPIROC MINING INDIA PRIVATE LIMITED",
"EPISTEMO VIKAS LEADERSHIP SCHOOL",
"EPISTIC TECHNOLOGIES PRIVATE LIMITED",
"EPITOME AUTOMOBILES PRIVATE LIMITED",
"EPITOME COMPONENTS PRIVATE LIMITED",
"EPITOME CONSULTANCY SERVICES",
"EPITOME DIGITECH INDIA PRIVATE LIMITED",
"EPITOME ENGINEERING PRIVATE LIMITED",
"EPITOME GEOTECHNICAL SERVICES PRIVATE LIMITED",
"EPITOME GLOBAL SERVICES PRIVATE LIMITED",
"EPITOME INFOTECH SOLUTIONS PRIVATE LIMITED",
"EPITOME PETROPACK LIMITED",
"EPITOME PLAST-O-PACK PRIVATE LIMITED",
"EPITOME PROPACKAGE PRIVATE LIMITED",
"EPITOME PUBLISHING SOLUTIONS PRIVATE LIMITED",
"EPITOME RESEARCH SERVICES LLP",
"EPITOME RETAIL PRIVATE LIMITED",
"EPITOME SUSTAINABLE ENERGY PRIVATE LIMITED",
"EPITOME SYSTEMS PRIVATE LIMITED",
"EPITOMECLOUD TECHNOLOGY PRIVATE LIMITED",
"EPITRANS SWITCHGEAR PRIVATE LIMITED",
"EPI-USE INDIA PRIVATE LIMITED",
"EPIXEL SOLUTIONS PRIVATE LIMITED",
"EPK BEARINGS INDIA PRIVATE LIMITED",
"EPL CATERECO PRIVATE LIMITED",
"EPL INDIA LIMITED",
"EPL LIMITED",
"EPL TECHNOLOGIES PRIVATE LIMITED",
"EPLAN SOFTWARE & SERVICES PRIVATE LIMITED",
"EPLANET IT PRIVATE LIMITED",
"EPLAZA WHEELS PRIVATE LIMITED",
"EPLUS PROJECTS PRIVATE LIMITED",
"E-PLUS TECHNOLOGIES INDIA PRIVATE LIMITED",
"E-PLUSONE HOME MAKERS PRIVATE LIMITED",
"EPNOVATE TECHNOLOGY PRIVATE LIMITED",
"EPOCH AUTOMATION PRIVATE LIMITED",
"EPOCH BRAND SERVICES INDIA PRIVATE LIMITED",
"EPOCH ELDER CARE PRIVATE LIMITED",
"EPOCH INSTRUMENTS & CONTROLS PRIVATE LIMITED",
"EPOCH INSURANCE BROKERS PRIVATE LIMITED",
"EPOCH MERCANTILES PVT LTD",
"EPOCH RESEARCH INSTITUTE INDIA PRIVATE LIMITED",
"EPOCH SYNTHETICS PVT.LTD.",
"EPOCH TECHNOLOGIES PRIVATE LIMITED",
"EPOCKETPAY SOLUTION PRIVATE LIMITED",
"EPOQUE VENTURES PRIVATE LIMITED",
"E-PORT LOGISTICS PRIVATE LIMITED",
"EPOS AUDIO INDIA PRIVATE LIMITED",
"EPOS GURU PRIVATE LIMITED",
"EPOTHANE CIVELEC ENGINEERS PRIVATE LIMITED",
"EPOXY TERMINAL AND EQUIPMENT PRIVATE LIMITED",
"EPP COMPOSITES PRIVATE LIMITED",
"EPPCON LUBRICANTS INDIA LIMITED",
"EPPELTONE ENGINEERS PRIVATE LIMITED",
"EPPENDORF INDIA PRIVATE LIMITED",
"EPPEOK SOLUTIONS PRIVATE LIMITED",
"EPPING ROYALTY PRIVATE LIMITED",
"EPPINGER TECHNOLOGY ASIA PRIVATE LIMITED",
"EPPINGER TOOLING ASIA PRIVATE LIMITED",
"EPPION LIFESCIENCES PRIVATE LIMITED",
"EPPIX ESOLUTION (INDIA) PRIVATE LIMITED",
"EPPS INFOTECH PRIVATE LIMITED",
"EPR SOLUTIONS PRIVATE LIMITED",
"EPR VENTURE INDIA PRIVATE LIMITED",
"EPRENTISE SOFTWARE PRIVATE LIMITED",
"EPRILLA LIFESTYLE PRIVATE LIMITED",
"E-PROFITBOOSTER UK PRIVATE LIMITED",
"EPROPELLED SYSTEMS PRIVATE LIMITED",
"EPRSS PREPAID RECHARGE SERVICES INDIA PRIVATE LIMITED",
"EPS INFOTECH",
"EPS INSTRUMENTATION PRIVATE LIMITED",
"EPS POLYMERS PRIVATE LIMITED",
"EPS PROJECTS PRIVATE LIMITED",
"EPS TRANSFORMERS PRIVATE LIMITED",
"EPS WORLDWIDE INTEGRATED LOGISTICS PRIVATE LIMITED",
"EPS WORLDWIDE PRIVATE LIMITED",
"EPSILON AEROSPACE PRIVATE LIMITED",
"EPSILON AUTOMOTIVE P LTD",
"EPSILON CARBON PRIVATE LIMITED",
"EPSILON CLINICAL RESEARCH PRIVATE LIMITED",
"EPSILON DESIGN CONSULTANCY PRIVATE LIMITED",
"EPSILON DIAGNOSTICS PRIVATE LIMITED",
"EPSILON ELECTRONICS PRIVATE LIMITED",
"EPSILON ENGINEERING LIMITED",
"EPSILON EYE CARE PRIVATE LIMITED",
"EPSILON GRAPHITE PRIVATE LIMITED",
"EPSILON HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"EPSILON INDIA PRIVATE LIMITED",
"EPSILON INFRAPROJECTS PRIVATE LIMITED",
"EPSILON MARKETING AND CONSULTANCY PRIVATE LIMITED",
"EPSILON PUBLISHING HOUSE PRIVATE LIMITED",
"EPSILON ULTRA AUTOMATION PRIVATE LIMITED",
"EPSILON VENTURES PRIVATE LIMITED",
"EPSL TRIGENERATION PRIVATE LIMITED",
"EPSOFT SOLUTIONS PRIVATE LIMITED",
"EPSOM SHIPPING INDIA PRIVATE LIMITED",
"EPSON INDIA PRIVATE LIMITED",
"EPSTOM SPEC CHEM PRIVATE LIMITED",
"EPT EXIM SERVICES PRIVATE LIMITED",
"EPT GLOBAL LOGISTICS PRIVATE LIMITED",
"EPTA INDIA PRIVATE LIMITED",
"EPTISA SERVICIOS DE INGENIERIA S.L",
"EPTURA INDIA PRIVATE LIMITED",
"EPX POLYMERS PRIVATE LIMITED",
"EPYGEN BIOTECH PRIVATE LIMITED",
"EQ TECHNOLOGIC INDIA PRIVATE LIMITED",
"EQBAL INN AND HOTELS LIMITED",
"EQG GLASSMACH PRIVATE LIMITED",
"EQIC DIES AND MOULDS ENGINEERS PRIVATE LIMITED",
"EQISOL SERVICES PRIVATE LIMITED",
"EQL FINANCIAL TECHNOLOGIES PRIVATE LIMITED",
"EQMS GLOBAL PRIVATE LIMITED",
"EQMS INDIA PRIVATE LIMITED",
"EQMS INGENUITY PRIVATE LIMITED",
"EQQUS LEATHERWARE PRIVATE LIMITED",
"EQS WEB TECHNOLOGIES PRIVATE LIMITED",
"EQSOL INDIA PRIVATE LIMITED",
"EQUADRIGA SOFTWARE PRIVATE LIMITED",
"EQUAL COMMOSALE PRIVATE LIMITED",
"EQUAL EXPERTS INDIA PRIVATE LIMITED",
"EQUAL INFOTECH PRIVATE LIMITED",
"EQUALSIGN LEARNING PRIVATE LIMITED",
"EQUALSTAR INVESTMENT & FINANCE PRIVATE LIMITED",
"EQUANT CONSULTINGS PRIVATE LIMITED",
"EQUATION CALIBRATION SERVICES PRIVATE LIMITED",
"EQUATIONS WORK IT SERVICES PRIVATE LIMITED",
"EQUATOR FREIGHT & LOGISTICS PRIVATE LIMITED",
"EQUATOR GLOBAL TRADING PRIVATE LIMITED",
"EQUATOR PROPERTY MANAGERS PRIVATE LIMITED",
"EQUATORIAL ENTERPRISES PRIVATE LIMITED",
"EQUBOT AI INDIA PRIVATE LIMITED",
"EQUENCE TECHNOLOGIES PRIVATE LIMITED",
"EQUENTIA FINANCIAL SERVICE PRIVATE LIMITED",
"EQUENTIA NATURAL RESOURCES PRIVATE LIMITED",
"EQUENTIA SCF TECHNOLOGIES PRIVATE LIMITED",
"EQUENTIS WEALTH ADVISORY SERVICES LIMITED",
"EQUENTIS WEALTH ADVISORY SERVICES PRIVATE LIMITED",
"EQUES CAPITAL MANAGEMENT PRIVATE LIMITED",
"EQUICAP ASIA MANAGEMENT PRIVATE LIMITED",
"EQUIDEM DEALERS PRIVATE LIMITED",
"EQUIFAX ANALYTICS PRIVATE LIMITED",
"EQUIFAX CREDIT INFORMATION SERVICES PRIVATE LIMITED",
"EQUIFAX SOFTWARE SYSTEM PRIVATE LIMITED",
"EQUIKNOX VENTURES PRIVATE LIMITED",
"EQUILATERAL ENTERPRISES LIMITED",
"EQUILIBRATED VENTURE CFLOW PRIVATE LIMITED",
"EQUILIBRIUM SOLUTIONS PRIVATE LIMITED",
"EQUILINK CAPITAL MANAGEMENT SERVICES LIMITED",
"EQUINE BREEDING STUD BABUGARH CANTT",
"EQUINE GOLD CONSULTING PRIVATE LIMITED",
"EQUINITI INDIA PRIVATE LIMITED",
"EQUINOMICS RESEARCH PRIVATE LIMITED",
"EQUINOX BUSINESS PARKS PRIVATE LIMITED",
"EQUINOX CONSULTING PRIVATE LIMITED",
"EQUINOX EPC ENGINEERING (INDIA) PRIVATE LIMITED",
"EQUINOX FILMS PRIVATE LIMITED",
"EQUINOX HOSPITALITY PRIVATE LIMITED",
"EQUINOX IMPEX",
"EQUINOX IMPLANTS LLP",
"EQUINOX LABS PRIVATE LIMITED",
"EQUINOX LIFECYCLE MARKETING PRIVATE LIMITED",
"EQUINOX LOGISTICS PRIVATE LIMITED",
"EQUINOX MEDICAL EQUIPMENTS PRIVATE LIMITED",
"EQUINOX OVERSEAS PRIVATE LIMITED",
"EQUINOX PRECISION TECHNOLOGIES PRIVATE LIMITED",
"EQUINOX REALTY & INFRASTRUCTURE PRIVATE LIMITED",
"EQUINOX RESEARCH PRIVATE LIMITED",
"EQUINOX SOFTWARE AND SERVICES PRIVATE LIMITED",
"EQUINOX SOLAR PRIVATE LIMITED",
"EQUINOX SOLUTIONS LIMITED",
"EQUIP RESOURCE ONCE CHECK",
"EQUIPAGE INFRACORE PRIVATE LIMITED",
"EQUIPLINE TECHNOLOGIES PRIVATE LIMITED",
"EQUIPLUS INDIA EXPORT PRIVATE LIMITED",
"EQUIPMART KITCHENTECH PRIVATE LIMITED",
"EQUIPMENT ENGINEERS PVT LTD",
"EQUIPMENT INSTALLATION AND SERVICES PRIVATE LIMITED",
"EQUIPMENT SALES INDIA PRIVATE LIMITED",
"EQUIPMENTS & INTERIORS PRIVATE LIMITED",
"EQUIPMENTS & SPARES ENGINEERING INDIA PRIVATE LIMITED",
"EQUIPNET INDIA PRIVATE LIMITED",
"EQUIPPP SOCIAL IMPACT TECHNOLOGIES LIMITED",
"EQUIPRO SOLUTIONS PRIVATE LIMITED",
"EQUIPTRANS LOGISTICS PRIVATE LIMITED",
"E-QUIRE TECHNOLOGIES PRIVATE LIMITED",
"EQUIRUS CAPITAL PRIVATE LIMITED",
"EQUIRUS SECURITIES PRIVATE LIMITED",
"EQUIRUS WEALTH PRIVATE LIMITED",
"EQUISOFT INDIA PRIVATE LIMITED",
"EQUISPORT MANAGEMENT PRIVATE LIMITED",
"EQUITAS FINANCE PRIVATE LIMITED",
"EQUITAS HOLDINGS LIMITED",
"EQUITAS HOUSING FINANCE PRIVATE LIMITED",
"EQUITAS MICRO FINANCE LIMITED",
"EQUITAS SMALL FINANCE BANK LIMITED",
"EQUITOR VALUE ADVISORY PRIVATE LIMITED",
"EQUITOS SERVICES PRIVATE LIMITED",
"EQUITREE CAPITAL ADVISORS PRIVATE LIMITED",
"EQUITREND MEDICAL EQUIPMENT PRIVATE LIMITED",
"EQUITRON MEDICA PRIVATE LIMITED",
"EQUITY CAPITAL ADVISORS INDIA PRIVATE LIMITED",
"EQUITY DATA SCIENCE INDIA PRIVATE LIMITED",
"EQUITY FINANCIAL SERVICES PRIVATE LIMITED",
"EQUITY LNT AUTOHUB PRIVATE LIMITED",
"EQUITY MOTORS RAJKOT PRIVATE LIMITED",
"EQUITY PACKAGING INC",
"EQUITYMASTER AGRORA RESEARCH PRIVATE LIMITED",
"EQUITYSOFT TECHNOLOGIES PRIVATE LIMITED",
"EQUUS ENGINEERS INDIA PRIVATE LIMITED",
"EQUUS ICT SERVICES INDIA PRIVATE LIMITED",
"EQUUS INFRA PROJECTS PRIVATE LIMITED",
"EQUUS SIGNALLING SYSTEMS PRIVATE LIMITED",
"EQVIMECH PRIVATE LIMITED",
"EQVITY HOTELS PRIVATE LIMITED",
"EQX ANALYTICS PRIVATE LIMITED",
"ER AUTO COMPONENTS PRIVATE LIMITED.",
"ER AUTOMOTIVES LIMITED",
"ER CONSULTING",
"ER P P PAREEK",
"ER PERUMAL MANIMEKALAI POLYTECHNIC COLLEGE",
"ERA CELL PRIVATE LIMITED",
"ERA COLONIZERS PROMOTERS AND DEVELOPERS INDIA PRIVATE LIMITED",
"ERA FISHERY PRODUCTS PRIVATE LIMITED",
"ERA GLOBAL STANDARDS CERTIFICATION PRIVATE LIMITED",
"ERA HYDRO BIOTECH ENERGY PRIVATE LIMITED",
"ERA INTERNATIONAL SCHOOL",
"ERA PHARMACEUTICALS PRIVATE LIMITED",
"ERA REALTORS PRIVATE LIMITED",
"ERA RESORTS PRIVATE LIMITED",
"ERA S LUCKNOW MEDICAL COLLEGE & HOSPITAL",
"ERA SOLUTIONS PRIVATE LIMITED",
"ERA T & D LIMITED",
"ERA TOUR AND TRAVELS INDIA PRIVATE LIMITED",
"ERA TRADECOM PRIVATE LIMITED",
"ERAA PET GROOMING",
"E-RAA SOLUTIONS PRIVATE LIMITED",
"ERAAVAT CAPITAL PRIVATE LIMITED",
"ERABLUE TECHNOLOGY PRIVATE LIMITED",
"ERAGON INFRASTRUCTURE PRIVATE LIMITED",
"ERAL INDIA PRIVATE LIMITED",
"ERAM EXCELLENCE CENTRE PRIVATE LIMITED",
"ERAM INFOTECH MUMBAI",
"ERAM MAGNAFLUX SYSTEMS PRIVATE LIMITED",
"ERAM MOTORS PRIVATE LIMITED",
"ERAM SCIENTIFIC SOLUTIONS PRIVATE LIMITED",
"ERAM SUPPORT SERVICE PRIVATE LIMITED",
"ERAMED PHARMACEUTICALS PRIVATE LIMITED",
"ERAMET INDIA PRIVATE LIMITED",
"ERAN INDIA MANUFACTURING PRIVATE LIMITED",
"ERANKEY IT SERVICES PRIVATE LIMITED",
"ERANTHUS DEVELOPERS PRIVATE LIMITED",
"ERA'S COLLEGE OF NURSING",
"ERASMIC CONSULTING PRIVATE LIMITED",
"ERASMITH TECHNOLOGIES PRIVATE LIMITED",
"ERASMUS TRAINING SERVICES PRIVATE LIMITED",
"ERASTEEL INDIA PRIVATE LIMITED",
"ERATRONICS PRIVATE LIMITED",
"ERAVAT MARKETINGS PRIVATE LIMITED",
"ERAWAT ENGINEERING PVT LTD",
"ERAWATI FABRICS PRIVATE LIMITED",
"ERB TEXTILE PRIVATE LIMITED",
"ERBATECH MACHINERY PRIVATE LIMITED.",
"ERBE MEDICAL INDIA PRIVATE LIMITED",
"ERBETUFF GLASS PRIVATE LIMITED",
"ERBIR VENTURES PRIVATE LIMITED",
"ERBIS ENGINEERING CO LTD",
"ERBRAINS IT SOLUTIONS PRIVATE LIMITED",
"ERC INFRATECH PRIVATE LIMITED",
"ERCO TRAVELS PRIVATE LIMITED",
"ERCON INTERNATIONAL PRIVATE LIMITED",
"ERD INFOTECH PRIVATE LIMITED",
"ERD TECHNOLOGIES PRIVATE LIMITED",
"ERDE EXPORTS PRIVATE LIMITED",
"ERDOL RAHMEN ENGINEERS PRIVATE LIMITED",
"ERDSTER INFORMATION SYSTEMS PRIVATE LIMITED",
"ERE INSURTECH INDIA PRIVATE LIMITED",
"E-REALTY DOTCOM PRIVATE LIMITED",
"ERECON SPACES PRIVATE LIMITED",
"ERECTOMAINT",
"ERECTOR INFRA PROJECTS PRIVATE LIMITED",
"EREGON IMPEX PRIVATE LIMITED",
"EREHWON INNOVATION CONSULTING PRIVATE LIMITED",
"ERELEGO PIGI MEDIA PRIVATE. LIMITED",
"ERELEGO TECHNOLOGIES PRIVATE LIMITED",
"EREMEDIUM PRIVATE LIMITED",
"ERENCO (INDIA) LIMITED",
"ERESOURCE INFOTECH PRIVATE LIMITED",
"ERETAIL CYBERTECH PRIVATE LIMITED",
"EREVMAX TECHNOLOGIES PRIVATE LIMITED",
"EREVU VENTURES PRIVATE LIMITED",
"ERFOLG GANAR PRIVATE LIMITED",
"ERGAM LABORATORIES PRIVATE LIMITED",
"ERGIN IMAGING SYSTEMS PRIVATE LIMITED",
"ERGO AUTO LIMITED",
"ERGO DESIGN PRIVATE LIMITED",
"ERGO WOODLINES PRIVATE LIMITED",
"ERGOBITE TECH SOLUTIONS PRIVATE LIMITED",
"ERGOCOMP PLASTIC INDIA PRIVATE LIMITED",
"ERGODE IT SERVICES PRIVATE LIMITED",
"ERGODE TRADING PRIVATE LIMITED",
"ERGOFORM CONSULTING PRIVATE LIMITED",
"ERGOLOGIC PRIVATE LIMITED",
"ERGOMAXX INDIA PRIVATE LIMITED",
"ERGOMED CLINICAL RESEARCH INDIA PRIVATE LIMITED",
"ERGON CONSTRUCTIONS PRIVATE LIMITED",
"ERGONOM PRODUCTS AND SERVICES PRIVATE LIMITED",
"ERGONOMICS MODULAR AND INTERIOR SOLUTIONS PRIVATE LIMITED",
"ERGOS BUSINESS SOLUTIONS PRIVATE LIMITED",
"ERGOS LIFE SCIENCES PRIVATE LIMITED",
"ERGOS LOGISTICS AND SHIPPING PRIVATE LIMITED",
"ERGOTALENT SOLUTIONS PRIVATE LIMITED",
"ERHARDT + LEIMER INDIA PRIVATE LIMITED",
"ERIC APPAREL PRIVATE LIMITED",
"ERIC MOTORS PRIVATE LIMITED",
"ERIC SECURITY & MAINTENANCE SERVICES PRIVATE LIMITED",
"ERIC STRUCTURES AND INFRASTRUCTURE CONSULTANTS PRIVATE LIMITED",
"ERICA ENTERPRISES PRIVATE LIMITED.",
"ERICA STEELS PRIVATE LIMITED",
"ERICSON & RICHARDS SURVEYORS PRIVATE",
"ERICSON HEALTHCARE PRIVATE LIMITED",
"ERICSON INSURANCE TPA PRIVATE LIMITED",
"ERICSSON INDIA PRIVATE LIMITED",
"ERICURE REMEDIES PRIVATE LIMITED",
"ERIDIUM DIGITAL PRIVATE LIMITED",
"ERIE INSURANCE GROUP",
"ERIEZ MAGNETICS INDIA PRIVATE LIMITED",
"ERIGO HEALTHCARE PRIVATE LIMITED",
"ERINA ECO CRAFT PRIVATE LIMITED",
"E-RING IT SOLUTIONS PRIVATE LIMITED",
"ERINOME INFO INDIA PRIVATE LIMITED",
"ERINYLE HEALTHCARE PRIVATE LIMITED",
"ERIS HEALTHCARE PRIVATE LIMITED",
"ERIS LIFESCIENCES LIMITED",
"ERIS OAKNET HEALTHCARE PRIVATE LIMITED",
"ERIS THERAPEUTICS LIMITED",
"ERISA ENERGY SOLUTIONS PRIVATE LIMITED",
"ERISHA AGRITECH PRIVATE LIMITED",
"E-RISING (INDIA) PRIVATE LIMITED",
"E-RISK SOLUTIONS PRIVATE LIMITED",
"ERI-TECH LIMITED",
"ERKOMA TOOLBOX PRIVATE LIMITED",
"ERM INDIA PRIVATE LIMITED",
"ERMA ESTATE TRADING CO PVT LTD",
"ERMOTEC INTERNATIONAL PRIVATE LIMITED",
"ERNAD NIDHI LIMITED",
"ERNAKULAM MEDICAL CENTRE PRIVATE LIMITED",
"ERNST & YOUNG ASSOCIATES LLP",
"ERNST & YOUNG LLP",
"ERNST & YOUNG MERCHANT BANKING SERVICES LLP",
"ERNST & YOUNG SERVICES PRIVATE LIMITED",
"ERO POWER LLP",
"EROBERER PRIVATE LIMITED",
"EROCARE RETAILS PRIVATE LIMITED",
"EROCKETMALL ONLINE ASIA LIMITED",
"ERODE AIR PRODUCTS PRIVATE LIMITED",
"ERODE AMARNATH MILLS PRIVATE LIMITED",
"ERODE CRITICAL AND EMERGENCY CARECENTRE PRIVATE LIMITED",
"ERODE DISTRICT CENTRAL CO-OPERATIVE BANK LTD",
"ERODE PRECISION FARM PRODUCER COMPANY LIMITED",
"ERODE SENGUNTHAR ENGINEERING COLLEGE",
"ERODE SRI PALANI MURUGAN SPINNING MILLS PRIVATE LIMITED",
"EROL EXPORTS PRIVATE LIMITED",
"EROMA PETROCHEMICALS PRIVATE LIMITED",
"EROOKA PRIVATE LIMITED",
"EROS AGRO & FARMS PRIVATE LIMITED",
"EROS CITY DEVELOPERS P LIMITED",
"EROS ELEVATORS & ESCALATORS PRIVATE LIMITED",
"EROS ENVIROTECH PRIVATE LIMITED",
"EROS ESTATES PRIVATE LIMITED",
"EROS GENERAL AGENCIES PRIVATE LIMITED",
"EROS GRAND RESORTS AND HOTELS PRIVATE LIMITED",
"EROS HEALTHCARE PRIVATE LIMITED",
"EROS HOTEL NEW DELHI NEHRU PLACE",
"EROS INFRASTRUCTURES PRIVATE LIMITED",
"EROS INTERNATIONAL FILMS PRIVATE LIMITED",
"EROS INTERNATIONAL MEDIA LIMITED",
"EROS JEWELLERY & FASHIONS PRIVATE LIMITED",
"EROS METAL WORKS PRIVATE LIMITED",
"EROS MOTORS PRIVATE LIMITED",
"EROS OIL MILLS PRIVATE LIMITED",
"EROS RESORTS AND HOTELS PRIVATE LIMITED",
"EROS TECHNOLOGIES INDIA PRIVATE LIMITED",
"EROS TELEVISION INDIA PRIVATE LIMITED",
"EROS THEATRE AND RESTAURANT PRIVATE LIMITED",
"EROSTEPS PRIVATE LIMITED",
"EROTH TECHNOLOGIES PRIVATE LIMITED",
"EROW PRECISION PRIVATE LIMITED",
"EROYCE MOTORS INDIA PRIVATE LIMITED",
"ERP ANALYSTS INDIA PRIVATE LIMITED",
"ERP FUSIONTECH SOLUTIONS INDIA PRIVATE LIMITED",
"NOBL Q PRIVATE LIMITED",
"ERP OUTSOURCING PRIVATE LIMITED",
"ERP SOFT SYSTEMS LIMITED",
"ERP STAFFING SOLUTIONS PRIVATE LIMITED",
"ERPDIRECT SOLUTIONS INDIA PRIVATE LIMITED",
"ERPL WAREHOUSING PARK PRIVATE LIMITED",
"ERPMECHSOFT TECHNOLOGIES PRIVATE LIMITED",
"ERPMENU INDIA PRIVATE LIMITED",
"ERRAND ENTERPRISES PRIVATE LIMITED",
"ERSHKA EXIM OPC PRIVATE LIMITED",
"ERT SHIPPING & WAREHOUSING PVT LTD",
"ERTC MEDIA PRIVATE LIMITED",
"ERUDITE ASSETS PRIVATE LIMITED",
"ERUDITE FINANCIAL SERVICES PRIVATE LIMITED",
"ERUDITE SOFT PRIVATE LIMITED",
"ERUDITE WORKS PRIVATE LIMITED",
"ERUM EXPORTS PRIVATE LIMITED",
"ERUVAKA TECHNOLOGIES PRIVATE LIMITED",
"ERVA HEALTHCARE PRIVATE LIMITED",
"ERVIKA GLOBAL PRIVATE LIMITED",
"ERWIN INDIA PRIVATE LIMITED",
"ERWIN JUNKER MASCHINENFABRIK GMBH",
"ERYTHRO PHARMA PRIVATE LIMITED",
"ERYX ENGINEERING PVT LTD",
"ES ELECTRICALSWITCHGEARS AND CONTROLS PRIVATE LIMITED",
"ES ENERGY PRIVATE LIMITED",
"ES INFRASERVE PRIVATE LIMITED",
"ES MAGICO EXPERIENCES PRIVATE LIMITED",
"ES PE YES AUTO COMPONENTS PRIVATE LIMITED",
"ES SOLAR PRIVATE LIMITED",
"ES SUN POWER PRIVATE LIMITED",
"ESA MANUFACTURING PRIVATE LIMITED",
"ESA SOFTWARE AND AUTOMATION INDIA PRIVATE LIMITED",
"ESAAD TELECOM PRIVATE LIMITED",
"ESAAR INDIA LTD",
"ESAB INDIA LIMITED",
"ESAC TECHNOLOGIES INDIA PRIVATE LIMITED",
"ESAF FINANCIAL HOLDINGS PRIVATE LIMITED",
"ESAF MICROFINANCE AND INVESTMENTS PRIVATE LIMITED",
"ESAF SMALL FINANCE BANK LIMITED",
"ESAF SWASRAYA MULTI STATE AGRO CO-OPERATIVE SOCIETY LTD",
"ESAF SWASRAYA MULTISTATE AGRO CO-OPERATIVE SOCIETY LTD",
"ESAF SWASRAYA MUTISTATE AGRO CO-OPERATIVE SOCIETY LIMITED",
"ESAF SWASRAYA PRODUCERS COMPANY LIMITED",
"ESAGE IT SERVICES PRIVATE LIMITED",
"ESALES TECHNOLOGIES PRIVATE LIMITED",
"ESAM SHARES AND STOCK BROKERS PRIVATE LIMITED",
"ESAOTE ASIA PACIFIC DIAGNOSTIC PRIVATE LIMITED",
"ESAOTE INDIA NS LIMITED",
"ESARAL VENTURES PRIVATE LIMITED",
"ESARCO EXIM PRIVATE LIMITED",
"ESARJEY MEDIA VENTURE PRIVATE LIMITED",
"ESARVI NETWORK INDIA PRIVATE LIMITED",
"ESBEE DYNAMED PRIVATE LIMITED",
"ESBEE ELECTROTECH LLP",
"ESBEE ENGINEERING EQUIPMENTS PRIVATE LIMITED",
"ESBEE MACHINERY PRIVATE LIMITED",
"ESBEE POWER SOLUTIONS PRIVATE LIMITED",
"ESC EDU VENTURES CHENNAI PRIVATE LIMITED",
"ESC UTILITY SERVICES PRIVATE LIMITED",
"ESCALATE GLOBAL IT SOLUTIONS PRIVATE LIMITED",
"ESCALATES TECH INDIA PRIVATE LIMITED",
"ESCALE INNOVATIVE SOLUTIONS PRIVATE LIMITED",
"ESCALENT CONSULTING INDIA PRIVATE LIMITED",
"ESCALON BUSINESS SERVICES PRIVATE LIMITED",
"ESCAPADE REAL ESTATE PRIVATE LIMITED",
"ESCAPADE RESORTS PRIVATE LIMITED",
"ESCAPE",
"ESCAPE VELOCITY DIGITAL PRIVATE LIMITED",
"ESCECION TECHNOLOGIES PRIVATE LIMITED",
"ESCEE INDUSTRIES PRIVATE LIMITED",
"ESCEE INFRASTRUCTURE PRIVATE LIMITED",
"ESCENT DIAGNOSTICS PRIVATE LIMITED",
"ESCENZA WELLNESS LLP",
"ESCHMANN TEXTURES INDIA PRIVATE LIMITED",
"ESCIENTIA ADVANCED SCIENCES PRIVATE LIMITED",
"ESCIENTIA BIOPHARMA PRIVATE LIMITED",
"ESCO BIOTECH PRIVATE LIMITED",
"ESCO COUPLINGS & TRANSMISSIONS PRIVATE LIMITED",
"ESCO PIPES PRIVATE LIMITED",
"ESCO STEAMCON PRIVATE LIMITED",
"ESCON BUILDERS PRIVATE LIMITED",
"ESCON ELEVATORS PRIVATE LIMITED",
"ESCON GENSETS PRIVATE LIMITED.",
"ESCON INFRATECH PRIVATE LIMITED",
"ESCON INTERNATIONAL PRIVATE LIMITED",
"ESCON PARKING SYSTEMS PRIVATE LIMITED",
"ESCONET TECHNOLOGIES LIMITED",
"ESCONET TECHNOLOGIES PRIVATE LIMITED",
"ESCORP ASSET MANAGEMENT LIMITED",
"ESCORT BEARING INDIA PRIVATE LIMITED",
"ESCORT DEVELOPERS PRIVATE LIMITED",
"ESCORT FINANCE",
"ESCORT FINVEST P LTD",
"ESCORT INTELLIGENCE AND SECURITY SERVICES PRIVATE LIMITED",
"ESCORTS ASSET MANAGEMENT LIMITED",
"ESCORTS CROP SOLUTIONS LIMITED",
"ESCORTS DEALERS DEVELOPMENT ASSOCIATION LIMITED",
"ESCORTS HEART AND SUPER SPECIALITY HOSPITAL LIMITED",
"ESCORTS HEART INSTITUTE AND RESSEARCH CENTRE LIMITED",
"ESCORTS KUBOTA INDIA PRIVATE LIMITED",
"ESCORTS KUBOTA LIMITED",
"ESCORTS SECURITIES LIMITED",
"ESCOTT APPARELS PRIVATE LIMITED",
"ESCRIBE ACCOUNTING SERVICES PRIVATE LIMITED",
"ESCRIBE OUTSOURCING SERVICES PRIVATE LIMITED",
"ESCROWTECH INDIA PRIVATE LIMITED",
"ESCUBE AIRCONDITIONING PRIVATE LIMITED",
"ESCUBE IT SERVICES (INDIA) PRIVATE LIMITED",
"ESCV CONSULTING SERVICES PRIVATE LIMITED",
"ESD KANKINARA",
"ESDEE BUSINESS MACHINE PRIVATE LIMITED",
"ESDEE INFRACON PRIVATE LIMITED",
"ESDEE PAINTS LIMITED",
"ESDI MARITIME PRIVATE LIMITED",
"ESDOTCOM SUPPORT AND SOFTWARE SERVICES P LIMITED",
"ESDS INTERNET SERVICES PRIVATE LIMITED",
"ESDS SOFTWARE SOLUTION LIMITED",
"ESDS SOFTWARE SOLUTION PRIVATE LIMITED",
"ESDY LUBES PRIVATE LIMITED",
"ESEARCH LOGIX TECHNOLOGIES PRIVATE LIMITED",
"ESEC FORTE TECHNOLOGIES PRIVATE LIMITED",
"ESEC SECURITY CONSULTANTS PRIVATE LIMITED",
"E-SECURE ELECTRONICS MANUFACTURING SERVICES PRIVATE LIMITED",
"ESECURITY AUDIT PRIVATE LIMITED",
"ESEMBS SILK MILLS PRIVATE LIMITED",
"ESENNAR TRANSFORMERS PRIVATE LIMITED",
"ESENPRO POWER TRANSMISSION PRIVATE LIMITED",
"ESENTE HEALTHCARE PRIVATE LIMITED",
"ESENTHIAA BIOTECH PRIVATE LIMITED",
"ESEO SOLUTIONS PRIVATE LIMITED",
"ESER HOTEL AND RESORTS PRIVATE LIMITED",
"ESERVE INFOTECH PRIVATE LIMITED",
"ESERVECLOUD SOLUTIONS PRIVATE LIMITED",
"ESES BIO- WEALTH PRIVATE LIMITED",
"ESES COUTURE PRIVATE LIMITED",
"ESEYE GLOBAL SERVICES PRIVATE LIMITED",
"ESG DATA SOLUTIONS PRIVATE LIMITED",
"ESGAUGE PRIVATE LIMITED",
"ESGEE DESIGN AND BUILD PRIVATE LIMITED",
"ESGI GARMENTS PRIVATE LIMITED",
"ESGI TOOLS PRIVATE LIMITED",
"ESH ISPAT PRIVATE. LIMITED.",
"ESHA AGRI SEEDS PRIVATE LIMITED",
"ESHA KOUL PRIVATE LIMITED",
"ESHAA COMMUNICATIONS PRIVATE LIMITED",
"ESHAAN ENTERPRISES PRIVATE LIMITED",
"ESHAAN EXPORTS",
"ESHAAN HOLDINGS PRIVATE LIMITED",
"ESHAAN PACKCRAFT PRIVATE LIMITED",
"ESHAAN RAIL TECHNOLOGIES PRIVATE LIMITED",
"ESHAANI FASHIONS PRIVATE LIMITED",
"E-SHAKTI BINARY CURRENTS PRIVATE LIMITED",
"ESHAN FINANCIAL SERVICES PRIVATE LIMITED",
"ESHAN LOGISTICS PRIVATE LIMITED",
"ESHAN MINERALS PRIVATE LIMITED",
"ESHAN TYRES PRIVATE LIMITED",
"ESHANPUTRA SWEET HOMES PRIVATE LIMITED",
"ESHANYA HOTELS PRIVATE LIMITED",
"ESHAR HEALTHCARE PRIVATE LIMITED",
"E-SHARP SOLAR SOLUTION PRIVATE LIMITED",
"ESHEIN AGRO LIVESTOCK PRIVATE LIMITED",
"ESHIA SOLUTIONS PRIVATE LIMITED",
"ESHIAM SOFTWARE PRIVATE LIMITED",
"ESHITA RUBBER PRIVATE LIMITED",
"ESHMUN PHARMACIES PRIVATE LIMITED",
"ESHNA CONSTRUCTION PRIVATE LIMITED",
"ESHNAM CARGO LOGISTICS PRIVATE LIMITED",
"ESHOPBOX E-COMMERCE PRIVATE LIMITED",
"ESHWA GLOBAL LOGISTICS PRIVATE LIMITED",
"ESHWAR AGRO INDUSTRIES",
"ESHWAR PHARMACEUTICALS PRIVATE LIMITED",
"ESHWARI TEXTILE PROCESSING PRIVATE LIMITED",
"ESHWARR STEEL TECH PRIVATE LIMITED",
"ESHYASI PHARMA LIMITED",
"ESI DESPENSARY JUHI 2 KANPUR",
"ESI HOSPITAL",
"ESI SOFTWARE INDIA PRIVATE LIMITED",
"ESI SPORTS INDIA PRIVATE LIMITED",
"ESIC HOSPITAL",
"ESIC HOSPITAL KANPUR",
"ESIC MEDICAL COLLEGE CHENNAI",
"ESIC MODEL HOSPITAL",
"ESIGELEC SOUTH ASIA OFFICE (OPC) PRIVATE LIMITED",
"ESIGN GENIE SOFTWARE PRIVATE LIMITED",
"ESIGN WEB SERVICES PRIVATE LIMITED",
"ESIS GENERAL HOSPITAL",
"ESJAY INTERNATIONAL PRIVATE LIMITED",
"ESJAYPEE MERCANTILE GLOBAL PRIVATE LIMITED",
"ESK SOFTWARE SERVICES PRIVATE LIMITED",
"ESK TECHNOLOGIES PRIVATE LIMITED",
"ESKAAR DECOR & FAIRFIT PRIVATE LIMITED",
"ESKAG PHARMA PRIVATE LIMITED",
"ESKAG SANJEEVANI PRIVATE LIMITED",
"ESKAPS (INDIA) PVT LTD",
"ESKAY BROTHERS STEELS LTD.",
"ESKAY CARTONS PRIVATE LIMITED",
"ESKAY DYESTUFFS & ORGANIC CHEMICALS PRIVATE LIMITED",
"ESKAY ELEVATORS INDIA PRIVATE LIMITED",
"ESKAY ENCLAVE PRIVATE LIMITED",
"ESKAY ENGICHEM PRIVATE LIMITED",
"ESKAY ENGINEERS PVT LTD",
"ESKAY EXPRESS CARRIERS PRIVATE LIMITED",
"ESKAY GOODS & SUPPLIERS PVT LTD",
"ESKAY HEAT TRANSFERS PRIVATE LIMITED",
"ESKAY HERBAL FORMULATIONS PRIVATE LIMITED",
"ESKAY HOSPITALITY SERVICES INDIA PRIVATE LIMITED",
"ESKAY INFRASTRUCTURE DEVELOPMENT P LIMITED",
"ESKAY IODINE PRIVATE LIMITED",
"ESKAY MANAGEMENT SERVICES LIMITED",
"ESKAY NONWOVEN PRIVATE LIMITED",
"ESKAY SILK INDUSTRIES PVT LTD",
"ESKAY YARNTEX PRIVATE LIMITED",
"ESKAYDESK SOLUTIONS PRIVATE. LIMITED",
"ESKAYEM CONSULTANTS PRIVATE LIMITED",
"ESKAYJAY DIAMOND PRODUCTS PRIVATE LIMITED",
"ESKAYS CONSTRUCTIONS PVT LTD",
"ESKIMO CONTROLS & TECHNOLOGIES PRIVATE LIMITED",
"ESKO CASTING AND ELECTRONICS PRIVATE LIMITED",
"ESKO GRAPHICS INDIA PRIVATE LIMITED",
"ESKYRISE INTERIORS PRIVATE LIMITED",
"ESL STEEL LIMITED",
"E-SLATE TECHNOLOGIES PRIVATE LIMITED",
"ESM ENTERPRISES (INDIA) PRIVATE LIMITED",
"ESM SYS PRIVATE LIMITED",
"ESM TRANSLOGISTICS PRIVATE LIMITED",
"ESM VENTURES PRIVATE LIMITED",
"ESMA FORMULATIONS PRIVATE LIMITED",
"ESMA INDUSTRIES PRIVATE LIMITED",
"ESMARIO EXPORT ENTERPRISES PRIVATE LIMITED",
"ESMART CONSULTING CHENNAI PRIVATE LIMITED",
"ESMART ENERGY SOLUTIONS LIMITED",
"ESMATRIX LIFE SCIENCES PRIVATE LIMITED",
"ESME CONSUMER PRIVATE LIMITED",
"ESMECH EQUIPMENT PRIVATE LIMITED",
"ESMERO RESEARCH PRIVATE LIMITED",
"ESN FINANCE AND CAPITAL SERVICES LIMITED",
"ESNEXT IMPORTS & EXPORTS",
"ESNEXT IMPORTS AND EXPORTS",
"ESOFTSOL INFOCOM PRIVATE LIMITED",
"E-SOLUTION INFOTECH PRIVATE LIMITED",
"E-SOLVE SOLUTIONS PRIVATE LIMITED",
"ESOLVE TECHNOLOGIES PRIVATE LIMITED",
"ESOLVIT INDIA PRIVATE LIMITED",
"ESOLZ TECHNOLOGIES PRIVATE LIMITED",
"ESOTERIC REALTY PRIVATE LIMITED",
"ESP 360 DEGREE SOLUTION PRIVATE LIMITED",
"ESP CONSULTANT INDIA PRIVATE LIMITED",
"ESP ENGINEERED COMPONENTS PRIVATE LIMITED",
"ESP FILMS PRIVATE LIMITED",
"ESP PORT SOLUTIONS PRIVATE LIMITED",
"ESP SAFETY PRIVATE LIMITED",
"ESP URJA PRIVATE LIMITED",
"ESPA WATER SYSTEMS PRIVATE LIMITED",
"ESPACES RETAIL FIXTURES PRIVATE LIMITED",
"ESPAN INFRASTRUCTURE I LIMITED",
"ESPANA CERAMICS PRIVATE LIMITED",
"ESPARKBIZ TECHNOLOGIES PRIVATE LIMITED",
"ESPARKLIGHT SOFTWARE SYSTEMS PRIVATE LIMITED",
"ESPEE DYNAMED EQUIPMENTS PRIVATE LIMITED",
"ESPEE ENTERPRISES PRIVATE LIMITED",
"ESPEE FORMULATION PRIVATE LIMITED",
"ESPEE INTERNATIONAL FINECHEMPHARMA PRIVATE LIMITED",
"ESPEE KUMARAN TEXTILES",
"ESPEE PHARMA CHEM PRIVATE LIMITED",
"ESPEE SOLAAR PRIVATE LIMITED",
"ESPEEYARE ENTERPRISES INDIA PRIVATE LIMITED",
"ESPELHO FASHIONS PRIVATE LIMITED",
"ESPER.IO SOFTWARE SERVICES PRIVATE LIMITED",
"ESPERANZA CONSULTING PRIVATE LIMITED",
"ESPERANZA GLOBAL ECO SOLUTIONS PRIVATE LIMITED",
"ESPERER BIO-RESEARCH PRIVATE LIMITED",
"ESPERTO CONSULTANTS PRIVATE LIMITED",
"ESPERTO DIGITAL SOLUTIONS PRIVATE LIMITED",
"ESPI INDUSTRIES AND CHEMICALS PVT LTD",
"ESPI POWER PRODUCTS PRIVATE LIMITED",
"ESPI VISA CONSULTANTS PRIVATE LIMITED",
"ESPIC CONSULTING PRIVATE LIMITED",
"ESPIEM ENGINES AND MACHINES PRIVATE LIMITED",
"ESPIES FACILITIES PRIVATE LIMITED",
"E-SPIN NANOTECH PRIVATE LIMITED",
"ESPIRE CONGLOMERATE PRIVATE LIMITED",
"ESPIRE HOSPITALITY LIMITED",
"ESPIRE INFOLABS PRIVATE LIMITED",
"ESPIRE INFOSERVE PRIVATE LIMITED",
"ESPIRE INFRASTRUCTURE CORPORATION LIMITED",
"ESPIRE INFRASTRUCTURE CORPORATION PRIVATE LIMITED",
"ESPIRE RESORTS PRIVATE LIMITED",
"ESPIRIT TRUCKING MUZAFFARNAGAR",
"E-SPIRITS IT SERVICES",
"ESPLORER VENTURES PRIVATE LIMITED",
"ESPM SENSE PRIVATE LIMITED",
"ESPN DIGITAL MEDIA (INDIA) PRIVATE LIMITED",
"ESPOIR PLAST INDIA PRIVATE LIMITED",
"ESPRANZA INNOVATIONS PRIVATE LIMITED",
"ESPRESSIF SYSTEMS (INDIA) PRIVATE LIMITED",
"ESPRIM SYSTEMS PRIVATE LIMITED",
"ESPRINT INDIAN HOLIDAYS PRIVATE LIMITED",
"ESPRIT CONTAINER LINE PRIVATE LIMITED",
"ESPRIT INDIA PRIVATE LIMITED",
"ESPRIT STONES LIMITED",
"ESPRIT STONES PRIVATE LIMITED",
"ESPY PROTECTION PRIVATE LIMITED",
"ESQ MANAGEMENT SOLUTIONS INDIA PRIVATE LIMITED",
"ESQUARE ENERGY EQUIPMENTS PRIVATE LIMITED",
"ESQUARE EVENTZ PROMOS PRIVATE LIMITED",
"ESQUBE COMMUNICATION SOLUTIONS PRIVATE LIMITED",
"ESQUIRE CARGO MANAGEMENT PRIVATE LIMITED",
"ESQUIRE DECOR PVT.LTD.",
"ESQUIRE ELECTROVISION PRIVATE LIMITED",
"ESQUIRE ESTATES PRIVATE LIMITED",
"ESQUIRE EXPRESS INDIA PRIVATE LIMITED",
"ESQUIRE HEALTH CARE & LOGISTICS PRIVATE LIMITED",
"ESQUIRE INFOCOMM INDIA PRIVATE LIMITED",
"ESQUIRE INFRAAHEIGHT PRIVATE LIMITED",
"ESQUIRE IVF EQUIPMENTS PRIVATE LIMITED",
"ESQUIRE MACHINES PRIVATE LIMITED",
"ESQUIRE MULTIPLAST PRIVATE LIMITED",
"ESQUIRE SHIPPING AND TRADING PRIVATE LIMITED",
"ESQUIRE SYSTEMS PRIVATE LIMITED",
"ESQUIRE TRANSPORT & LOGISTICS PRIVATE LIMITED",
"ESQUISSE MARQUISE (INDIA) PRIVATE LIMITED",
"ESQUVI TECHNOLOGIES PRIVATE LIMITED",
"ESR ADVISERS INDIA PRIVATE LIMITED",
"ESR DEVELOPMENT PARTNERS LLP",
"ESR GMR LOGISTICS PARK PRIVATE LIMITED",
"ESR INDUSTRIAL PARK REALTY PRIVATE LIMITED",
"ESR JHAJJAR WAREHOUSING AND INDUSTRIAL PARK PRIVATE LIMITED",
"ESR NAGPUR WAREHOUSING AND INDUSTRIAL PARK PRIVATE LIMITED",
"ESR PUNE ESTATES PRIVATE LIMITED",
"ESR PUNE INDUSTRIAL PARK PRIVATE LIMITED",
"ESR RANJANGAON R1 LOGISTICS AND INDUSTRIAL PARK PRIVATE LIMITED",
"ESR WAREHOUSING PRIVATE LIMITED",
"ESRI INDIA TECHNOLOGIES PRIVATE LIMITED",
"ESRI R&D CENTER INDIA PRIVATE LIMITED",
"ESS & ESS HRM SERVICES PRIVATE LIMITED",
"ESS AAR AUTOMOTIVE PRIVATE LIMITED",
"ESS AAR ENGINEERING PRIVATE LIMITED",
"ESS AAR INFRATECH PRIVATE LIMITED",
"ESS AAR PETROCHEM PRIVATE LIMITED",
"ESS AAR TOOLS PRIVATE LIMITED",
"ESS AAR UNIVERSAL PRIVATE LIMITED",
"ESS AAY AGENCIES INDIA PRIVATE LIMITED",
"ESS AND ESS INFRASTRUCTURE PRIVATE LIMITED",
"ESS AY ELECTRONICS PRIVATE LIMITED",
"ESS BEE CYBER SPACE PRIVATE LIMITED",
"ESS BEE POLY TARPS PVT LTD",
"ESS BUILDTECH PRIVATE LIMITED",
"ESS CEE BIOTECH (INDIA) PRIVATE LIMITED",
"ESS DEE INFORMATICS PRIVATE LIMITED",
"ESS DISTRIBUTION PRIVATE LIMITED",
"ESS ELL DIAGNOSTICS PRIVATE LIMITED",
"ESS ELL FOODS PRIVATE LIMITED",
"ESS ELL MOTORS",
"ESS ELL SONS PRIVATE LIMITED",
"ESS ENN AUTO CNC PRIVATE LIMITED",
"ESS ENN EXTRUSIONS PRIVATE LIMITED",
"ESS ESS CHEMITECH PRIVATE LIMITED",
"ESS ESS CONCLAVE PRIVATE LIMITED",
"ESS ESS FOOTWEARS PRIVATE LIMITED",
"ESS ESS KAY ENGINEERING COMPANY PRIVATE LIMITED",
"ESS ESS KAY MARKETING COMPANY PRIVATE LIMITED",
"ESS ESS STEEL CASTINGS AND ROLLING MILLS PRIVATE LIMITED",
"ESS ESS TECHNOFABS PRIVATE LIMITED",
"ESS ESS WINDOWS PRIVATE LIMITED",
"ESS FLEXI TUBES PRIVATE LIMITED",
"ESS GEE AGRO TECH PRIVATE LIMITED",
"ESS GEE COLLECTIONS PRIVATE LIMITED",
"ESS GEE ENTERPRISES PRIVATE LIMITED",
"ESS GEE REAL ESTATE DEVELOPERS PRIVATE LIMITED",
"ESS GEE TRADEFIN PVT LTD",
"ESS GEE TRENDZ PRIVATE LIMITED",
"ESS GEE TRENDZ RETAIL PRIVATE LIMITED",
"ESS GLOBAL PRIVATE LIMITED",
"ESS INFRAPROJECT PRIVATE LIMITED",
"ESS JAY GLOBAL VENTURES PRIVATE LIMITED",
"ESS KAY BEAUTY RESOURCES PRIVATE LIMITED",
"ESS KAY COMPONENTS PRIVATE LIMITED",
"ESS KAY LEELA RESOURCES PRIVATE LIMITED",
"ESS KAY LOOMTEX PRIVATE LIMITED",
"ESS KAY MERCANTILES LIMITED",
"ESS KAY PROPACK PRIVATE LIMITED",
"ESS LIFE SCIENCE INDIA PRIVATE LIMITED",
"ESS MATRIX INFO TECH PRIVATE LIMITED",
"ESS N ESS AGENCIES PRIVATE LIMITED",
"ESS NEE MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"ESS PEE INFRAHEIGHTS PRIVATE LIMITED",
"ESS TECH SOLUTIONS INDIA PRIVATE LIMITED",
"ESS TECHNOSYS PRIVATE LIMITED",
"ESS TEE AGRO OILS PRIVATE LIMITED",
"ESS TEE POWER CONTROLS PRIVATE LIMITED",
"ESSA GARMENTS PRIVATE LIMITED",
"ESSAA SYNTEX PRIVATE LIMITED",
"ESSAAR COATINGS INDIA LIMITED",
"ESSAAR ELEVATOR INDIA PRIVATE LIMITED",
"ESSABHAI FIREWORKS PRIVATE LIMITED",
"ESSAE DIGITRONICS PRIVATE LIMITED",
"ESSAE ELECTRONICS PRIVATE LIMITED",
"ESSAE GEARS AND TRANSMISSIONS PRIVATE LIMITED",
"ESSAE TECHNOLOGIES PRIVATE LIMITED",
"ESSAE TERAOKA PRIVATE LIMITED",
"ESSAI EDUCATION SERVICES PRIVATE LIMITED",
"ESSAI INFRATECH PRIVATE LIMITED",
"ESSAI SOLUTIONS PRIVATE LIMITED",
"ESSAL INFRASTRUCTURE PRIVATE LIMITED",
"ESSAR ADVISORY SERVICES LIMITED",
"ESSAR AGROTECH LIMITED",
"ESSAR BULK TERMINAL (SALAYA) LIMITED",
"ESSAR BULK TERMINAL LIMITED",
"ESSAR CAPITAL ADVISORY INDIA PRIVATE LIMITED",
"ESSAR CONSTRUCTIONS INDIA LIMITED",
"ESSAR ELECTRIC POWER DEVELOPMENT CORPORATION LIMITED",
"ESSAR EXPLORATION & PRODUCTION INDIA LIMITED",
"ESSAR INFORMATION TECHNOLOGY",
"ESSAR INFRASTRUCTURE SERVICES LIMITED",
"ESSAR INTERNATIONAL SCHOOL",
"ESSAR LAB MATE PRIVATE LIMITED",
"ESSAR MANAGEMENT SERVICES PRIVATE LIMITED",
"ESSAR OIL AND GAS EXPLORATION AND PRODUCTION LIMITED",
"ESSAR PACKAGINGS PRIVATE LIMITED",
"ESSAR PORTS LIMITED",
"ESSAR POWER GUJARAT LIMITED",
"ESSAR POWER HAZIRA LIMITED",
"ESSAR POWER LIMITED",
"ESSAR POWER ORISSA LIMITED",
"ESSAR POWER TRANSMISSION COMPANY LIMITED",
"ESSAR PRAJESH MARKETING LIMITED",
"ESSAR REALTY PRIVATE LIMITED",
"ESSAR STEEL METAL TRADING LIMITED",
"ESSAR UK SERVICES PRIVATE LIMITED",
"ESSAR VIZAG TERMINALS LIMITED",
"ESSARFAB GREEN INDIA PRIVATE LIMITED",
"ESSAY COMMERCIAL RESOURCES PRIVATE LIMITED",
"ESSAY MENSWEAR PRIVATE LIMITED",
"ESSAY PETROLEUM INDIA PRIVATE LIMITED",
"ESSBEE INTECH PRIVATE LIMITED",
"ESSCHEM OVERSEAS PRIVATE LIMITED",
"ESSCHEM PRIVATE LIMITED",
"ESSCO FURNACES PRIVATE LIMITED",
"ESSCON INFRATECH PRIVATE LIMITED",
"ESSCON INTEGRATED SECURITY SOLUTIONS PRIVATE LIMITED",
"ESSCON SALES PRIVATE LIMITED",
"ESSCUBES MEDISIENCES PRIVATE LIMITED",
"ESSDEE CONNECTIVITY PRIVATE LIMITED",
"ESSDEE INFRASTRUCTURE PRIVATE LIMITED",
"ESSDEE KNITTING MILLS PRIVATE LIMITED",
"ESSDEE PROJECTS ENGINEERING PRIVATE LIMITED",
"ESSE NATURALS AND NUTRITION PRIVATE LIMITED",
"ESSEE METAL CONTAINERS PRIVATE LIMITED",
"ESSEE NETWORKS PRIVATE LIMITED",
"ESSEE PACKAGINGS PRIVATE LIMITED",
"ESSEH TURNKEY EPC PRIVATE LIMITED",
"ESSEL BAGALKOT SOLAR ENERGY PRIVATE LIMITED",
"ESSEL BAGALKOT SOLAR ENERGY PRIVATE. LIMITED.",
"ESSEL BATH FITTINGS PRIVATE LIMITED",
"ESSEL BUSINESS EXLNCE LIMITED",
"ESSEL ENVIRO SYSTEM PRIVATE LIMITED",
"ESSEL FABRICATORS PRIVATE LIMITED",
"ESSEL FIN WEALTH ZONE P LIMITED",
"ESSEL FINANCE BUSINESS LOANS LIMITED",
"ESSEL FINANCE HOME LOANS LIMITED",
"ESSEL FINANCE MANAGEMENT LLP",
"ESSEL FINANCE VKC FOREX LIMITED",
"ESSEL FOUNDRIES PRIVATE LIMITED",
"ESSEL GREEN ENERGY PRIVATE LIMITED",
"ESSEL GULBARGA SOLAR POWER PRIVATE LIMITED",
"ESSEL GULBARGA SOLAR POWER PRIVATE. LIMITED.",
"ESSEL HIGHWAYS LIMITED",
"ESSEL HOUSING PROJECTS PRIVATE LIMITED",
"ESSEL INDUSTRIES PRIVATE LIMITED",
"ESSEL KITCHENWARE LIMITED",
"ESSEL LEISURE SERVICES PRIVATE LIMITED",
"ESSEL MARKETING & PROMOTIONS PRIVATE LIMITED",
"ESSEL MINING & INDUSTRIES LTD",
"ESSEL MP ENERGY LIMITED.",
"ESSEL PALLAVAPURAM TAMBARAM MSW PRIVATE. LIMITED.",
"ESSEL PLYWOOD PVT LTD",
"ESSEL PROJECTS PRIVATE LIMITED",
"ESSEL SAURYA URJA COMPANY OF RAJASTHAN LIMITED",
"ESSEL SHYAM TECHNOLOGIES LIMITED",
"ESSEL SYNERG TECH PRIVATE LIMITED",
"ESSEL THERMOWARE PRIVATE LIMITED",
"ESSEL TOWER MAINTENANCE PRIVATE LIMITED",
"ESSEL TRANSPORT PVT LTD",
"ESSEL URJA PRIVATE LIMITED",
"ESSEL UTILITIES DISTRIBUTION COMPANY LIMITED",
"ESSEL VIDYUT VITARAN MUZAFFARPUR PRIVATE. LIMITED",
"ESSEL VIDYUT VITARAN SAGAR PRIVATE. LIMITED.",
"ESSEL WORLD LEISURE PRIVATE LIMITED",
"ESSEL YARNS PRIVATE LIMITED",
"ESSELL CONSULTANTS PRIVATE LIMITED",
"ESSELS FUNDS MANAGEMENT PVT.LTD.",
"ESSEM AUTO ELECTRICALS PRIVATE LIMITED",
"ESSEM COMPLIANCE SOLUTIONS PRIVATE LIMITED",
"ESSEM ENTERTAINMENT PRIVATE LIMITED",
"ESSEM HIGH-TECH PRIVATE LIMITED",
"ESSEM JUTE INDUSTRIES LTD.",
"ESSEM LOGISTICS LIMITED",
"ESSEM POLYALLOYS PRIVATE LIMITED",
"ESSEM REALTY PRIVATE LIMITED",
"ESSEM TECHNODESIGN PRIVATE LIMITED",
"ESSEM TEKNO SERVICES PVT.LTD.",
"ESSEM UDYOG PRIVATE LIMITED",
"ESSEM18 DEVELOPERS PRIVATE LIMITED",
"ESSEMM FINCAP LIMITED",
"ESSEMM FOODTECH INNOVATIONS PRIVATE LIMITED",
"ESSEMM SPECCHEM PRIVATE LIMITED",
"ESSEMMAGROPRODUCTS TRADING PRIVATE LIMITED",
"ESSEN BRIGHT STEEL PRIVATE LIMITED",
"ESSEN CONNECTORS PRIVATE LIMITED",
"ESSEN DEINKI",
"ESSEN ELECTRONIC SYSTEMS PRIVATE LIMITED",
"ESSEN FABRICATORS PVT LTD",
"ESSEN FOODDIES INDIA PRIVATE LIMITED",
"ESSEN FORGE PRIVATE LIMITED",
"ESSEN INDPRO PRIVATE LIMITED",
"ESSEN INDUSTRIES PRIVATE LIMITED",
"ESSEN LUBRICANTS PRIVATE LIMITED",
"ESSEN MULTIPACK LIMITED",
"ESSEN PLASTICS PRIVATE LIMITED",
"ESSEN PRODUCTS INDIA LIMITED",
"ESSEN REALTORS",
"ESSEN SPECIALITY DISPOSABLES LLP",
"ESSEN SPECIALITY FILMS LIMITED",
"ESSEN SPECIALITY FILMS PRIVATE. LIMITED.",
"ESSEN VISION SOFTWARE PRIVATE LIMITED",
"ESSEN WELDING ALLOYS PRIVATE LIMITED",
"ESSENCE BIOTECH PRIVATE LIMITED",
"ESSENCE BUILDWARE PRIVATE LIMITED",
"ESSENCE CELLCOM PRIVATE LIMITED",
"ESSENCE COLLECTIONS PRIVATE LIMITED",
"ESSENCE COMMUNICATIONS PRIVATE LIMITED",
"ESSENCE FACILITY SOLUTIONS PRIVATE LIMITED",
"ESSENCE GLOBAL SERVICES PRIVATE LIMITED",
"ESSENCE HOME DECOR PRIVATE LIMITED",
"ESSENCE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"ESSENCE TAPE INTERNATIONAL PRIVATE LIMITED",
"ESSENCE TRANSMEDIA PRIVATE LIMITED",
"ESSENN POWER CONTROLS PRIVATE LIMITED",
"ESSENS RENEWABLE PRIVATE LIMITED",
"ESSENS WELLNESS TECHNOLOGIES PRIVATE LIMITED",
"ESSENTIA FOOD INGREDIENTS AND SOLUTIONS PRIVATE LIMITED",
"ESSENTIA FRGNCE FLVR AND SEASONINGS P L",
"ESSENTIA LUXURY HOTEL",
"ESSENTIA SOFTSERV LLP",
"ESSENTIAL ENERGY INDIA PRIVATE LIMITED",
"ESSENTIAL ENGINEERING SOLUTIONS PRIVATE LIMITED",
"ESSENTIAL FIVE LEARNING SOLUTIONS PRIVATE LIMITED",
"ESSENTIAL INNOVATIONS ENTERPRISES PRIVATE LIMITED",
"ESSENTIAL INTERIOR DESIGNS PRIVATE LIMITED",
"ESSENTIAL LOGISTICS PRIVATE LIMITED",
"ESSENTIAL MARKETPLACE SOLUTIONS INDIA PRIVATE LIMITED",
"ESSENTIAL OUTSOURCING SERVICES",
"ESSENTIAL PHARMACEUTICALS BAREILLY",
"ESSENTIAL TOURS AND TRAVELS (INDIA) PRIVATE LIMITED",
"ESSENTIO SOLUTIONS PRIVATE LIMITED",
"ESSENTRA INDIA PRIVATE LIMITED",
"ESSENWARE PRIVATE LIMITED",
"ESSENZAA NUTRITION PRIVATE LIMITED",
"ESSENZAA SOLUTIONS PRIVATE LIMITED",
"ESSES PIPES PRIVATE LIMITED",
"ESSEX FARMS PRIVATE LIMITED",
"ESSEX MARINE PRIVATE LIMITED",
"ESSFOUR ENGINEERING PRIVATE LIMITED",
"ESSGI FABRICATION AND ENGINEERING PRIVATE LIMITED",
"ESSGI INFOTECH PRIVATE LIMITED",
"ESSI INTEGRATED TECHNOLOGIES PRIVATE LIMITED",
"ESSILOR 20 20 OPTICS PRIVATE LIMITED",
"ESSILOR INDIA PRIVATE LIMITED",
"ESSILOR LENS & SPECTS PRIVATE LIMITED",
"ESSILOR MANUFACTURING INDIA PRIVATE LIMITED",
"ESSILOR SANKAR & CO OPTICS PRIVATE LIMITED",
"ESSITY INDIA PRIVATE LIMITED",
"ESSITY OPERATIONS GOA LIMITED",
"ESSIX BIOSCIENCES LIMITED",
"ESSJAY COPIER PRIVATE LIMITED",
"ESSJAY ERICSSON PRIVATE LIMITED",
"ESSJAY TECHNOMEASURE PRIVATE LIMITED.",
"ESSKAI (INDIA) PRIVATE LIMITED",
"ESS-KAY AUTO FINANCE PRIVATE LIMITED",
"ESSKAY COMPUSERVICES PRIVATE LIMITED",
"ESSKAY CONCAST AND MINERALS PRIVATE LIMITED",
"ESSKAY DESIGN AND STRUCTURES PRIVATE LIMITED",
"ESSKAY ELECTRICALS PRIVATE LIMITED",
"ESSKAY MACHINERY PRIVATE LIMITED",
"ESSKAY WIRE & CABLE PRIVATE LIMITED",
"ESSKEYEM EXPRESS SOLUTIONS PRIVATE LIMITED",
"ESSLO FABRICS & TEXTILE PRIVATE. LIMITED.",
"ESSMA TEXTILES PVT. LIMITED",
"ESSMA WOOLLEN MILLS PRIVATE LIMITED",
"ESSMARK OIL INDUSTRIES PRIVATE LIMITED",
"ESSOBIGI ENGINEERS PRIVATE LIMITED",
"ESSP MEDITEK PVT LTD",
"ESSPAL INTERNATIONAL PRIVATE. LIMITED.",
"ESSPAL SHEET METAL INDIA PRIVATE LIMITED",
"ESS-PEE AUTOMOTIVES PRIVATE LIMITED",
"ESSPEE GLASS STUDIO PRIVATE LIMITED",
"ESSPEE HITECH PRIVATE LIMITED",
"ESSPEE SYNTHETICS INDIA PVT LTD",
"ESSRBEE PACKERS & MOVERS INDIA PRIVATE LIMITED",
"ESSTAIN DEVELOPERS PRIVATE LIMITED",
"ESSTEE EXPORTS",
"ESSTEE GRANGES PRIVATE LIMITED",
"ESSTEX ENGINEERING AND TRADING COMPANY PRIVATE LIMITED",
"ESSVEE PRIVATE LIMITED",
"ESSVEE URBAN DEVELOPMENT PRIVATE LIMITED",
"ESSVEE WIRES INDIA PRIVATE LIMITED",
"ESSVEEPEE MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"ESSVY CONSTRUCTIONS INDIA PRIVATE. LIMITED.",
"ESSWIN ELECTRO CONTROLS PRIVATE LIMITED",
"ESSYEN ELECTRICALS PRIVATE LIMITED",
"EST TOOL STEEL PRIVATE LIMITED",
"ESTAA GEMS PRIVATE LIMITED",
"ESTABLISH OFFI JOINT COMM OF SALES TAX VAT DHULE",
"ESTABLISHMENT OFFICER DY COMM OF SALES TAX VAT ADM RATNAGIRI",
"ESTABLISHMENT OFFICER JOINT COMMER OF SALES TAX",
"ESTABLISHMENT OFFICER JOINT COMMER.OF SALES TAX",
"ESTAFF CONNECT PRIVATE LIMITED",
"ESTAMPAR COATS PRIVATE LIMITED",
"ESTANCIA IT PARK PRIVATE LIMITED",
"ESTANICHA TRANSPACIFIC PRIVATE LIMITED",
"ESTATE DEPARTMENT MANTRALAYA",
"ESTATE DEPARTMENT UTTAR PRADESH GOVERNMENT",
"ESTATE JEWELRY ENSEMBLE PRIVATE LIMITED",
"ESTATEMAN ENERGY PRIVATE LIMITED",
"ESTATES TODAY PROPERTIES PRIVATE LIMITED",
"ESTATIC INFOTECH PRIVATE LIMITED",
"ESTEAM APPAREL SERVICES PRIVATE LIMITED",
"ESTEC SYSTEMS & SOLUTIONS PRIVATE LIMITED",
"ESTECO SOFTWARE INDIA PRIVATE LIMITED",
"ESTEE ADVISORS PRIVATE LIMITED",
"ES-TEE AUTO PRESSINGS PRIVATE LIMITED",
"ESTEE DEALERS PRIVATE LIMITED",
"ESTEE FINANCIAL SERVICES PRIVATE LIMITED",
"ESTEE MOVERS PRIVATE LIMITED",
"ESTEE TRANSWAYS PRIVATE LIMITED",
"ESTEEDEE AUTOCOM ENGINEERS PRIVATE LIMITED",
"ESTEEM AUTO PRIVATE LIMITED",
"ESTEEM BIO ORGANIC FOOD PROCESSING LIMITED",
"ESTEEM BUILDWELL PRIVATE LIMITED",
"ESTEEM CREDITS & INVESTMENT PRIVATE LIMITED,",
"ESTEEM ESTATES PRIVATE LIMITED",
"ESTEEM GASES PRIVATE LIMITED",
"ESTEEM INDUSTRIES PRIVATE LIMITED.",
"ESTEEM INTEGRATED LOGISTICS PRIVATE LIMITED",
"ESTEEM LABELS PRIVATE LIMITED",
"ESTEEM PACKERS PRIVATE LIMITED",
"ESTEEM PEOPLE GRAPHICS SOLUTIONS PRIVATE LIMITED",
"ESTEEM POLYMER PRODUCTS PRIVATE LIMITED",
"ESTEEM POWER EQUIPMENTS INDIA PRIVATE LIMITED",
"ESTEEM PROJECTS PRIVATE LIMITED",
"ESTEL TECHNOLOGIES PRIVATE LIMITED",
"ESTELA ENTERPRISES PRIVATE LIMITED",
"ESTELAR CONSTRUCTIONS PRIVATE LIMITED",
"ESTELE ACCESSORIES PRIVATE LIMITED",
"ESTELLE CHEMICALS PRIVATE LIMITED",
"ESTELLE FOREX PRIVATE LIMITED",
"ESTER BUILDERS PRIVATE LIMITED",
"ESTER CHEMICAL INDUSTRIES PVT LTD",
"ESTER FILMTECH LIMITED",
"ESTER INDUSTRIES LIMITED",
"ESTERKOTE PRIVATE LIMITED",
"ESTERN GLOBAL TRADING LIMITED",
"ESTERS AND SOLVENTS LLP",
"ESTEVAN SERVICES PRIVATE LIMITED",
"ESTEVE PHARMA LIMITED",
"ESTEX TELECOM PRIVATE LIMITED",
"ESTHANA DESIGNS (OPC) PRIVATE LIMITED",
"ESTHE WELLNESS PRIVATE LIMITED",
"ESTHELL CONTINENTAL HOTELS AND RESORTS",
"ESTHENOS TECHNOLOGIES PRIVATE LIMITED",
"ESTHER PROMOTERS PRIVATE LIMITED",
"ESTHETIC BUILDTECH PRIVATE LIMITED",
"ESTHETIC INSIGHTS PRIVATE LIMITED",
"ESTHETICA SPA & SALON RESOURCES PRIVATE LIMITED",
"ESTIC REALTY PRIVATE LIMITED",
"ESTILO MODERNO REALTY PRIVATE LIMITED",
"ESTIMATING INTERNATIONAL (INDIA) PRIVATE LIMITED",
"ESTIMATORS ON LINE PRIVATE LIMITED",
"ESTIRE RESEARCH & ANALYTICS PRIVATE LIMITED",
"ESTO BROADBAND PRIVATE LIMITED",
"ESTO INTERNET PRIVATE LIMITED",
"ESTOCORP INDIA PRIVATE LIMITED",
"ESTOCOTT PHARMA PRIVATE LIMITED",
"ESTOKE PRIVATE LIMITED",
"ESTON AMENITIES PRIVATE LIMITED",
"ESTONE VTOWN PRIVATE LIMITED",
"ESTOR POWER SOLUTIONS PRIVATE LIMITED",
"ESTRA AUTOMOTIVE SYSTEMS INDIA PRIVATE LIMITED",
"ESTRA ENTERPRISES PRIVATE LIMITED",
"ESTRAGEN PHARMA PRIVATE LIMITED",
"ESTRELA BATTERIES LIMITED",
"ESTRELLA DESIGNS AND HOSPITALITY SERVICES PRIVATE LIMITED",
"ESTRELLA JEWELS LLP",
"ESTRELLAS LIFE SCIENCES PRIVATE LIMITED",
"ESTUAR MARKETING AND SOLUTION PRIVATE LIMITED",
"ESTUATE SOFTWARE PRIVATE LIMITED",
"ESURVEYING SOFTECH (INDIA) PRIVATE LIMITED",
"ESVASTICA TECHNOLOGIES PRIVATE LIMITED",
"ESVE DESIGN SOLUTIONS PRIVATE LIMITED",
"ESVEE PRECISION COMPONENTS LIMITED",
"ESVEEAAR DISTILLERIES PRIVATE LIMITED (PART IX )",
"ESWAR BIO BRIQUETTE INDIA PRIVATE LIMITED",
"ESWAR COLLEGE OF ENGERING",
"ESWAR PRINT N PACK PRIVATE. LIMITED.",
"ESWAR RUBBER PRODUCTS PRIVATE LIMITED",
"ESWAR THERAPEUTICS PRIVATE LIMITED",
"ESWARA KAMADHENU RESTAURANT PRIVATE LIMITED",
"ESWARI ELECTRICALS PRIVATE LIMITED",
"ESWARI ENGINEERING COLLEGE FOR WOMEN",
"ESWARI GLOBAL METAL INDUSTRIES PRIVATE LIMITED",
"ESY TECH RESOURCES INDIA PRIVATE LIMITED",
"ESYASOFT TECHNOLOGIES PRIVATE LIMITED",
"ESYNERGY TECHNOLOGIES PRIVATE LIMITED",
"ESYS INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"ET AMUSEMENTS PVT LTD",
"ET DEVASSY AND SONS FINANCE PRIVATE LIMITED",
"ET ELASTOMER TECHNIK INDIA PRIVATE LIMITED",
"ET ELEVATOR TECHNOLOGIES PRIVATE LIMITED",
"ET MARLABS PRIVATE LIMITED",
"ET MEDIALABS PRIVATE LIMITED",
"ETA AEROSPACE PRIVATE LIMITED",
"ETA BUILDERS PRIVATE LIMITED",
"ETA BUSINESS PRIVATE LIMITED",
"ETA CONSTRUCTIONS INDIA LIMITED",
"ETA ENGINEERS BANGALORE PRIVATE LIMITED",
"ETA GENERAL PRIVATE LIMITED",
"ETA KARNATAKA ESTATES LIMITED",
"ETA MANUFACTURERS PRIVATE LIMITED",
"ETA PROPERTIES AND INVESTMENTS PRIVATE LIMITED",
"ETA STAR FACILITIES MANAGEMENT SERVICES PRIVATE LIMITED",
"ETA STAR PROPERTY DEVELOPERS LIMITED",
"ETA STAR TECHCITY PRIVATE LIMITED",
"ETA TECHNOLOGY PRIVATE LIMITED",
"ETA TECHNOPARK LIMITED.",
"ETA TRAVEL AGENCY PRIVATE LIMITED",
"ETAASH TALENT SOLUTIONS PRIVATE LIMITED",
"ETAG SOFTWARE SOLUTIONS PRIVATE LIMITED",
"ETAH MOTORS PRIVATE LIMITED",
"ETAIL CONSULTANTS PRIVATE LIMITED",
"E-TAIL EXPRESS PRIVATE LIMITED",
"ETAIL MARKETING PRIVATE LIMITED",
"ETAIN IMMODO RENEWABLES LIMITED",
"ETAL ENSER PRIVATE LIMITED",
"ETALIN HYDRO ELECTRIC POWER COMPANY LIMITED",
"ETA-MELCO ENGINEERING COMPANY PRIVATE LIMITED",
"ETANDSS PRIVATE LIMITED",
"ETAP AUTOMATION PRIVATE LIMITED",
"ETAPRO TECHNOLOGIES PRIVATE LIMITED",
"ETAS AUTOMOTIVE INDIA PRIVATE LIMITED",
"ETASH DELIVERY TECHNOLOGIES PRIVATE LIMITED",
"ETASHA BATTERIES PRIVATE LIMITED",
"ETAWAH-CHAKERI (KANPUR) HIGHWAY PRIVATE LIMITED",
"ETAXWAY SERVICES LIMITED",
"ETC AGRO PROCESSING INDIA PRIVATE LIMITED",
"ETC CONSULTANTS INDIA PRIVATE LIMITED",
"ETC ELECTRIC PRIVATE LIMITED",
"ETC MANAGEMENT SERVICES INDIA PRIVATE LIMITED",
"ETCO DIGITAL PRIVATE LIMITED",
"ETCO E - WASTE RECYCLER PRIVATE LIMITED",
"ETCO MOTOR AGENCIES PRIVATE LIMITED",
"ETCO MOTORS PRIVATE LIMITED",
"ETCO TEXTILES PRIVATE LIMITED",
"ETE ELECTRO GEARS PVT LTD",
"ETE ROBOTIC SYSTEMS INTEGRATOR PRIVATE LIMITED",
"E-TEAM INFO SERVICES PRIVATE LIMITED",
"E-TEAM INFORMATICA INDIA PRIVATE LIMITED",
"ETEAM INFOSERVICES PRIVATE LIMITED",
"E-TECH INNOVATIVE SERVICES PRIVATE LIMITED",
"ETECH IT SOLUTIONS LLP",
"E-TECH SERVICES PRIVATE LIMITED",
"ETECHACES MARKETING AND CONSULTING PRIVATE LIMITED",
"ETEILY TECHNOLOGIES INDIA PRIVATE LIMITED",
"ETEK IT SOLUTIONS PRIVATE LIMITED",
"ETELLIGENS TECHNOLOGIES PRIVATE LIMITED",
"ETENGY PRIVATE LIMITED",
"ETERA SOLUTIONS (INDIA) PRIVATE LIMITED",
"ETERNA BUILDING AUTOMATION PRIVATE LIMITED",
"ETERNA CROP SCIENCES PRIVATE LIMITED",
"ETERNAL ALLOY CAST PRIVATE LIMITED",
"ETERNAL AVENUES AND INFRASTRUCTURES PRIVATE LIMITED",
"ETERNAL BUILDING ASSETS PRIVATE LIMITED",
"ETERNAL CONSULTING INDIA PRIVATE LIMITED",
"ETERNAL DESIGN PRIVATE LIMITED",
"ETERNAL ECOBLOCKS PRIVATE LIMITED",
"ETERNAL HEART CARE CENTRE AND RESEARCH INSTITUTE PRIVATE LIMITED",
"ETERNAL HOSPITALITY PRIVATE LIMITED",
"ETERNAL HR SERVICES PRIVATE LIMITED",
"ETERNAL INFRASOLUTIONS PRIVATE LIMITED",
"ETERNAL MOTORS PRIVATE LIMITED",
"ETERNAL RENEWABLE ENERGY SOLUTIONS",
"ETERNAL RENEWABLES PRIVATE LIMITED",
"ETERNAL SUNSHINE PRODUCTIONS PRIVATE LIMITED",
"ETERNAL UNIVERSITY",
"ETERNAL WEB PRIVATE LIMITED",
"ETERNALIA CREATIVE & MERCHANDISING PRIVATE LIMITED",
"ETERNIA TRADING PRIVATE LIMITED",
"ETERNIS FINE CHEMICALS LIMITED",
"ETERNITE ELEMENTS PRIVATE LIMITED",
"ETERNITY DEVELOPERS PRIVATE LIMITED",
"ETERNITY FOOTWEAR PRIVATE LIMITED",
"ETERNITY FOREX PRIVATE LIMITED",
"ETERNITY INVESTMENT SERVICES PRIVATE LIMITED",
"ETERNITY LIFESTYLES PRIVATE LIMITED",
"ETERNITY POOLS AND GARDENS PRIVATE LIMITED",
"ETERNITY POWER SOLUTIONS PRIVATE LIMITED",
"ETERNO DISTRIBUTORS PRIVATE LIMITED",
"ETERNO INFOTECH PRIVATE LIMITED",
"ETERNUS PERFORMANCE MATERIALS PRIVATE LIMITED",
"ETERNUS SOLUTIONS PRIVATE LIMITED",
"ETESIAN URJA LIMITED",
"ETEVA CONSULTING PRIVATE LIMITED",
"ETEX HEALTHCARE PRIVATE LIMITED",
"ETG GLOBAL SERVICES PRIVATE LIMITED",
"ETH INFRA PRIVATE LIMITED",
"ETHAMES DEGREE COLLEGE",
"ETHAN ENERGY INDIA PRIVATE LIMITED",
"ETHAN ENGINEERING PRIVATE LIMITED",
"ETHAN PACKERS PRIVATE LIMITED",
"ETHAN POWER PRIVATE LIMITED",
"ETHAN TEXTILE INDIA PRIVATE LIMITED",
"ETHEL GORDON JUNIOR COLLEGE OF EDUCATION PUNE",
"ETHELBARI TEA CO (1932)LTD",
"ETHELWOLD ESTATE PRIVATE LIMITED",
"ETHENIC BUILDWELL PRIVATE LIMITED",
"ETHERBIT PRIVATE LIMITED",
"ETHEREAL AUTO PRIVATE LIMITED",
"ETHEREAL CONSTRUCTIONS PRIVATE LIMITED",
"ETHEREAL INGREDIENTS PRIVATE LIMITED",
"ETHEREAL PORTFOLIO PRIVATE LIMITED",
"ETHEREAL TURNKEY PROJECTS PRIVATE LIMITED",
"ETHERIUM ENTERPRISE PRIVATE LIMITED",
"ETHERIUM ENTERPRISE (OPC) PRIVATE LIMITED",
"ETHERNETXPRESS INDIA PRIVATE LIMITED",
"ETHICAL ENERGY PETROCHEM STRATEGIES PRIVATE LIMITED",
"ETHICAL INTELLIGENT TECHNOLOGIES LLP",
"ETHICALHAT CYBER SECURITY PRIVATE LIMITED",
"ETHICARE CLINICAL TRIAL SERVICES (OPC) PRIVATE LIMITED",
"ETHICARE FACILITY SERVICES INDIA PRIVATE LIMITED",
"ETHICARE PHARMACEUTICALS PRIVATE LIMITED",
"ETHICO PHARMA PRIVATE LIMITED",
"ETHICS ASSETS PRIVATE LIMITED",
"ETHICS COMMERCIALS LTD",
"ETHICS EXPORTS PRIVATE LIMITED",
"ETHICS HEALTH-CARE PRIVATE LIMITED",
"ETHICS INFOTECH LLP",
"ETHICS INFRADEVELOPMENT PRIVATE LIMITED",
"ETHICS INNOVATIONS PRIVATE LIMITED",
"ETHICS MARKETING PRIVATE LIMITED",
"ETHICS PROSPERITY PRIVATE LIMITED",
"ETHIKA INSURANCE BROKING PRIVATE LIMITED",
"ETHINIC ART OVERSEAS PRIVATE LIMITED",
"ETHINKROOT IT SERVICES PRIVATE LIMITED",
"ETHINOS DIGITAL MARKETING PRIVATE LIMITED",
"ETHIO PLASTICS PVT LTD",
"ETHIOS ENVIRO SOLUTIONS PRIVATE LIMITED",
"ETHIQUAL GLOBAL PRIVATE LIMITED",
"ETHIRAJ ASSOCIATES PRIVATE LIMITED",
"ETHIRAJ COLLEGE TRUST",
"ETHIRAJ CONSTRUCTION PRIVATE LIMITED",
"ETHIX REALTORS PRIVATE LIMITED",
"ETHNA ATTRIBUTES SOFT TECHNOLOGIES PRIVATE LIMITED",
"ETHNIC BUILDINFRA PRIVATE LIMITED",
"ETHNIC FOOD AND HOSPITALITY PRIVATE LIMITED",
"ETHNIC FOOD PRODUCTS SOLUTION LIMITED",
"ETHNIC OVERSEAS PRIVATE LIMITED",
"ETHNIC STYLIST",
"ETHNIC WEAVES EMPORIUM PRIVATE LIMITED",
"ETHNOGRAPHIC MEDICAL RESEARCH PRIVATE LIMITED",
"ETHNOTECH ACADEMIC SOLUTIONS PRIVATE LIMITED",
"ETHNUS CONSULTANCY SERVICES PRIVATE LIMITED",
"ETHOS CAPITAL ADVISORS PRIVATE LIMITED",
"ETHOS ELITE GARMENTS PRIVATE LIMITED",
"ETHOS HR MANAGEMENT AND PROJECTS PRIVATE LIMITED",
"ETHOS HVAC SYSTEMS LTD",
"ETHOS JEWELRY DESIGNS LLP",
"ETHOS LIMITED",
"ETHOS POWER PRIVATE LIMITED",
"ETHOSDATA INDIA PRIVATE LIMITED",
"ETHOSH DESIGNS PRIVATE LIMITED",
"ETIBAR INVESTMENTS PVT.LTD.",
"ETICA DEVELOPERS PRIVATE LIMITED",
"ETICA SOLAR ENERGY PRIVATE LIMITED",
"ETICA WEALTH PRIVATE LIMITED",
"ETICO LIFESCIENCES PRIVATE LIMITED",
"ETIHAD AIRWAYS",
"ETIHAD TRAVEL PRIVATE LIMITED",
"ETIN IMPEX PRIVATE LIMITED",
"ETINSURE INSURANCE WEB AGGREGATOR LIMITED",
"ETIOS TECHNOLOGIES PRIVATE LIMITED",
"ETIYASH FOODS AND SPICES PRIVATE LIMITED",
"ETM LOGISTICS PRIVATE LIMITED",
"ETN SERVICES PRIVATE LIMITED",
"ETNA AUTO COMPONENTS PRIVATE LIMITED",
"ETNA HARDWARE OPC PRIVATE LIMITED",
"ETNA MOTORS (INDIA) PRIVATE LIMITED",
"ETO MAGNETIC INDIA PRIVATE LIMITED",
"ETO MOTORS PRIVATE LIMITED",
"ETON CLOTHING COMPANY PRIVATE LIMITED",
"ETON SOLUTIONS AND TECHNOLOGIES INDIA LL P",
"ETON TECHNOLOGIES PRIVATE LIMITED",
"ETONE INDIA PRIVATE LIMITED",
"ETOOS EDUCATION PRIVATE LIMITED",
"ETOS ELEVATORS INDIA PRIVATE LIMITED",
"ETOUCH SYSTEMS INDIA PRIVATE LIMITED",
"ETP EARTHING & LPS SOLUTION PRIVATE LIMITED",
"ETP INTERNATIONAL PRIVATE LIMITED",
"ETP SERVICES PRIVATE LIMITED",
"ETRADE MARKETING PRIVATE LIMITED",
"ETRAIN EDUCATION PRIVATE LIMITED",
"ETRANBIZ GLOBAL TECHNOLOGIES PRIVATE LIMITED",
"ETRANS SOLUTIONS PRIVATE LIMITED",
"ETRAVEL VALUE INDIA PRIVATE LIMITED",
"ETRAVELI INDIA PRIVATE LIMITED",
"ETRELUXE INDIA PRIVATE LIMITED",
"ETRENDS TECHNOLOGIES PRIVATE LIMITED",
"ETRICALS ENGINEERS PRIVATE LIMITED",
"ETRIO AUTOMOBILES PRIVATE LIMITED",
"ETRMSERVICES INDIA PRIVATE LIMITED",
"ETROIT TECH PRIVATE LIMITED",
"ETRONICS GLOBAL DISTRIBUTORS LLP",
"ETS CONVEYEORS INDIA PRIVATE LIMITED",
"ETS LINDGREN ENGINEERING INDIA PRIVATE LIMITED",
"ETS SAFETY SYSTEMS PRIVATE LIMITED",
"ETSC COMPUTERS PRIVATE LIMITED",
"ETSYSTORE PRIVATE LIMITED",
"ETT CAREERMOVE PRIVATE LIMITED",
"ETT LIMITED",
"ETTORE CONSUMER SERVICES PRIVATE LIMITED",
"ETUTORWORLD LEARNING SOLUTIONS PRIVATE LIMITED",
"ETV BHARAT",
"EUCHNER (INDIA) PRIVATE LIMITED",
"EUCLID INFOTECH LIMITED",
"EUCLID INNOVATIONS PRIVATE LIMITED",
"EUCLION ENERGY PRIVATE LIMITED",
"EUCRASIA HEALTHCARE PRIVATE LIMITED",
"EUDAEMON CLOTHING PRIVATE LIMITED",
"EUFORICO TRIPS PRIVATE LIMITED",
"EUGEN PRINTING & PACKAGING PRIVATE LIMITED",
"EUGENE TECHNOLOGIES SERVICES PRIVATE LIMITED",
"EUGENICS MEDI SCIENCES PRIVATE LIMITED",
"EUGENICS PHARMA PRIVATE LIMITED",
"EUGENIE TECHNOLOGIES PRIVATE LIMITED",
"EUGENIX HAIR SCIENCES PRIVATE LIMITED",
"EUGIA PHARMA SPECIALITIES LIMITED",
"EUGIA SEZ PRIVATE LIMITED",
"EUI LIMITED",
"EUJEN LIFESCIENCES PRIVATE LIMITED",
"EUKILD BRAND SOLUTION PRIVATE LIMITED",
"EUKLEIA TECHNOLOGIES PRIVATE LIMITED",
"EULER HERMES SERVICES INDIA PRIVATE LIMITED",
"EULOGIA INN LLP",
"EUMARK PHARMACEUTICALS PRIVATE LIMITED",
"EUMAXINDIA PRIVATE LIMITED",
"EUMENTIS INFORMATICS PRIVATE LIMITED",
"EUNICE ENTERPRISES PRIVATE LIMITED",
"EUNIKA THERAPEUTICS PRIVATE LIMITED",
"EUNOIA DESIGNS PRIVATE LIMITED",
"EUNSUNG TECH INDIA PRIVATE LIMITED",
"EUPHONIOUS INNOVATIONS PRIVATE LIMITED",
"EUPHORIA INFOTECH (INDIA) LIMITED",
"EUPHORIA TECHNOLOGIES PRIVATE LIMITED",
"EUPHORIA WORLD TRAVELS PRIVATE LIMITED",
"EUPHORIC BEVERAGES PRIVATE LIMITED",
"EUPHORIC ENTERTAINMENT PRIVATE LIMITED",
"EUPHORIC INNOVATIONS PRIVATE LIMITED",
"EUPHORIYA HOSPITALITY PRIVATE LIMITED",
"EUPRAXIUS BUSINESS SOLUTINS PRIVATE LIMITED",
"EURASIA AGRO FOODS PRIVATE LIMITED",
"EURASIA DOOR DEVICES LIMITED",
"EURASIA MARBLES PRIVATE LIMITED",
"EURASIA SPECIAL TECHNOLOGIES PRIVATE LIMITED",
"EURASIA TEMAC PRIVATE LIMITED",
"EURASIA TRAVEL SERVICES PRIVATE LIMITED",
"EURECAT INDIA CATALYST SERVICES PRIVATE LIMITED",
"EURECON PUMPS INDIA PRIVATE LIMITED",
"EUREKA BUILDERS PRIVATE LIMITED",
"EUREKA COMMODITY BROKERAGE PRIVATE LIMITED",
"EUREKA CONVEYOR BELTINGS PRIVATE LIMITED",
"EUREKA COSMO PRIVATE LIMITED",
"EUREKA CREDIT FINANCE PRIVATE LIMITED",
"EUREKA D SOFT PRIVATE LIMITED",
"EUREKA DESIGN INDIA PRIVATE LIMITED",
"EUREKA DIAGNOSTIC AND RESEARCH CENTRE PRIVATE LIMITED",
"EUREKA DIGITISATION & AUTOMATION SERVICES PRIVATE LIMITED",
"EUREKA FABRICATORS PRIVATE LIMITED",
"EUREKA FORBES LIMITED",
"EUREKA GLOBAL HEALTHCARE PRIVATE LIMITED",
"EUREKA HOSPITAL & RESEARCH CENTRE PRIVATE LIMITED",
"EUREKA INDUSTRIAL EQUIPMENTS PVT LTD",
"EUREKA INDUSTRIES LIMITED",
"EUREKA IRON AND ENERGY PRIVATE LIMITED",
"EUREKA LABS LIMITED",
"EUREKA LOGISTICS PRIVATE LIMITED",
"EUREKA MEDICARE PRIVATE LIMITED",
"EUREKA OUTSOURCING SOLUTIONS PRIVATE LIMITED",
"EUREKA POLY PRODUCTS PRIVATE LIMITED",
"EUREKA PUBLIC SCHOOL",
"EUREKA SOLUTION",
"EUREKA STOCK & SHARE BROKING SERVICES LIMITED",
"EUREKA SYSTEMS AND ELECTRODES PRIVATE LIMITED",
"EUREKA WINDOOR SYSTEMS PRIVATE LIMITED",
"EURIZONE EDUCATION PRIVATE LIMITED",
"EURO CAB SERVICES PRIVATE LIMITED",
"EURO CARS INDIA PRIVATE LIMITED",
"EURO CUBIC CREATIONS PRIVATE LIMITED",
"EURO DECOR PRIVATE LIMITED",
"EURO DEVELOPERS PRIVATE LIMITED",
"EURO DIAGNOSTIC SYSTEMS PRIVATE LIMITED",
"EURO DIESEL SERVICES PRIVATE LIMITED",
"EURO EXIM SERVICES PRIVATE LIMITED",
"EURO EXPORTS PRIVATE LIMITED",
"EURO FLOORING PRIVATE LIMITED",
"EURO FOODS PRIVATE LIMITED",
"EURO FOOTWEAR LIMITED",
"EURO FORGE PRIVATE LIMITED",
"EURO FRUITS PVT LTD",
"EURO GLOBAL GAS-CYLINDERS LLP",
"EURO INDIA CONSUMER PRODUCTS PRIVATE LIMITED",
"EURO INDIA FRESH FOODS LIMITED",
"EURO INFRA SOLUTIONS PRIVATE LIMITED",
"EURO INTERNATIONAL SCHOOL",
"EURO JEWELS (INDIA) PRIVATE LIMITED",
"EURO KIDS",
"EURO LEDER FASHION LIMITED",
"EURO LIFECARE PRIVATE LIMITED",
"EURO MARINE POWER & PARTS SUPPLY PRIVATE LIMITED",
"EURO MARINE SHIPPING SERVICES PRIVATE LIMITED",
"EURO MEDI TOOLS PRIVATE LIMITED",
"EURO MERCHANDISE INDIA LIMITED",
"EURO NEXTECH PRIVATE LIMITED",
"EURO PALLETS PRIVATE LIMITED",
"EURO PANEL PRODUCTS LIMITED",
"EURO PANEL PRODUCTS PRIVATE LIMITED",
"EURO POLY FOAMS PRIVATE LIMITED",
"EURO PRATIK ISPAT (INDIA) PRIVATE LIMITED",
"EURO PRATIK ISPAT PRIVATE LIMITED",
"EURO PRATIK SALES PRIVATE LIMITED",
"EURO PREMIUM SOLAR SYSTEM (INDIA) PRIVATE LIMITED",
"EURO SAFETY EQUIPMENTS PRIVATE LIMITED",
"EURO SAFETY FOOTWEAR (INDIA) LIMITED",
"EURO SAFETY FOOTWEAR INDIA PRIVATE LIMITED",
"EURO SAFETY NONWOVENS PRIVATE LIMITED",
"EURO SCHOOL",
"EURO SCHOOL EDUCATION TRUST",
"EURO SECURITY & PLACEMENT PRIVATE LIMITED",
"EURO SHOE COMPONENTS LIMITED",
"EURO SMILE FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"EURO SOLAR POWER PRIVATE LIMITED",
"EURO SOLAR SYSTEM",
"EURO STAR CONTAINER LINES PRIVATE LIMITED",
"EURO STAR DIAMONDS INDIA PRIVATE LIMITED",
"EURO STONE PRIVATE LIMITED",
"EURO SUN INDIA PRIVATE LIMITED",
"EURO TEXTILE SPARES PRIVATE LIMITED",
"EURO THREADS PRIVATE LIMITED",
"EURO VISTAA INDIA LIMITED",
"EUROALLOY SPECIALITY STEELS PRIVATE LIMITED",
"EUROAMER GARUDA RESORTS INDIA PRIVATE LIMITED",
"EURO-ANCHOR SANITARYWARE INDUSTRIES PRIVATE LIMITED",
"EUROAQUA PLUMTEK PRIVATE LIMITED",
"EUROASIA HOLDINGS PRIVATE LIMITED",
"EUROASIA'S INGREDIENTS PRIVATE LIMITED",
"EUROBA FOODS AND HOSPITALITY SERVICES PRIVATE LIMITED",
"EUROBEARINGS INDIA PRIVATE LIMITED",
"EUROBELT BELTING SOLUTIONS PRIVATE LIMITED",
"EUROBUILD INDIA PRIVATE LIMITED",
"EUROCEIL SYSTEMS PRIVATE LIMITED",
"EUROCERT INSPECTION SERVICES PRIVATE LIMITED",
"EUROCLIMA (INDIA) PRIVATE LIMITED",
"EUROCOIN CERAMICS PRIVATE LIMITED",
"EUROCON INSTRUMENTS PRIVATE LIMITED",
"EUROCOT TEXTILES INDIA PRIVATE LIMITED",
"EUROCOUSTIC PRODUCTS LIMITED",
"EUROFAB ELECTRONICS PRIVATE LIMITED",
"EUROFINS ADVINUS AGROSCIENCES SERVICES INDIA PRIVATE LIMITED",
"EUROFINS ADVINUS BIOPHARMA SERVICES INDIA PRIVATE LIMITED",
"EUROFINS ADVINUS LIFESCIENCES PRIVATE LIMITED",
"EUROFINS ADVINUS LIMITED",
"EUROFINS AMAR IMMUNODIAGNOSTICS PRIVATE LIMITED",
"EUROFINS ANALYTICAL SERVICES INDIA PRIVATE LIMITED",
"EUROFINS ASSURANCE INDIA PRIVATE LIMITED",
"EUROFINS BPO INDIA PRIVATE LIMITED",
"EUROFINS CLINICAL DIAGNOSTICS BANGALORE PRIVATE LIMITED",
"EUROFINS GENOMICS INDIA PRIVATE LIMITED",
"EUROFINS HOODI RESOURCES PRIVATE LIMITED",
"EUROFINS IT SOLUTIONS INDIA PRIVATE LIMITED",
"EUROFINS NSC INDIA PRIVATE LIMITED",
"EUROFINS PEENYA RESOURCES PRIVATE LIMITED",
"EUROFINS PHARMA SERVICES INDIA PRIVATE LIMITED",
"EUROFINS PRODUCT TESTING INDIA PRIVATE LIMITED",
"EUROFLEX TRANSMISSIONS INDIA PRIVATE LIMITED",
"EUROFRAGANCE INDIA PRIVATE LIMITED",
"EUROGEAR ASIA PRIVATE LIMITED",
"EUROGROUP FAR EAST LIMITED",
"EUROKEM LABORATORIES PRIVATE LIMITED",
"EUROKON GLOBAL EXPORTS PRIVATE LIMITED",
"EUROLANDCOM INDIA PRIVATE LIMITED",
"EUROLIFE HEALTHCARE PRIVATE LIMITED",
"EUROLINEN INDUSTRIES PRIVATE LIMITED",
"EUROLUX FRAGRANCES PRIVATE LIMITED",
"EUROMATE FOODTECH PRIVATE LIMITED",
"EUROMONITOR RESEARCH & CONSULTING INDIA PRIVATE LIMITED",
"EURONET INFINITIUM SOLUTIONS PRIVATE LIMITED",
"EURONET SERVICES INDIA PRIVATE LIMITED",
"EURONEXT INDIA PRIVATE LIMITED",
"EURONICS INDUSTRIES PRIVATE LIMITED",
"EUROP ASSISTANCE INDIA PRIVATE LIMITED",
"EUROPA BIOCARE PRIVATE LIMITED",
"EUROPA CHEMICALS ASIA PRIVATE LIMITED",
"EUROPA DIGITAL LIMITED",
"EUROPA FOAMS PRIVATE LIMITED",
"EUROPA HEALTHCARE",
"EUROPE INCOMING",
"EUROPE STUDY CENTRE PRIVATE LIMITED",
"EUROPEAN EXTRUTECH PRIVATE LIMITED",
"EUROPEAN FLAVOURS & FRAGRANCE PRIVATE LIMITED",
"EUROPEAN FOODS INDIA PRIVATE LIMITED",
"EUROPEAN FREIGHT INDIA PRIVATE LIMITED",
"EUROPEAN MOTOR WORKS PRIVATE LIMITED",
"EUROPER PERFUMES INDIA PRIVATE LIMITED",
"EUROPET PRODUCTS PRIVATE LIMITED",
"EUROPLAK SV CUCINE INDIA LIMITED",
"EUROPLUS ONE REALITY PRIVATE LIMITED",
"EUROSCHOOL FOUNDATION",
"EUROSENSE ANALYTICALS PRIVATE LIMITED",
"EUROSHINE JEWELLERY WORKS PRIVATE LIMITED",
"EUROSIA BIM SERVICES PRIVATE LIMITED",
"EUROSIA HOLIDAY CLUB PRIVATE LIMITED",
"EUROSOFT PHARMA PRIVATE LIMITED",
"EUROSPA TERRYTOWEL PRIVATE LIMITED",
"EUROSTAR COMMUNICATIONS PRIVATE LIMITED",
"EUROSTAR CONTAINER LINES PRIVATE LIMITED",
"EUROSTAR DIAMONDS INDIA PRIVATE LIMITED",
"EUROSTAR DIAMONDS INDIA PRIVATE. LIMITED.",
"EUROSTAR ENGINEERING PRIVATE LIMITED",
"EUROSTEEL OFFICE FURNITURE SYSTEMS PRIVATE LIMITED",
"EURO-SUITS MANUFACTURING CO PRIVATE LIMITED",
"EUROSYNTEC CHEMICALS PRIVATE LIMITED",
"EUROSYS SPA PRIVATE LIMITED",
"EUROTECH ASSESMENT AND CERT SER PRIVATE LIMITED",
"EUROTECH CONTROLS & INSTRUMENTS PRIVATE LIMITED",
"EUROTECH CYLINDERS PRIVATE LIMITED",
"EUROTECH DESIGN SYSTEMS PRIVATE LIMITED",
"EUROTECH GLOBAL SOLUTION INDIA PRIVATE LIMITED",
"EUROTECH TECHNICAL SOLUTIONS PRIVATE LIMITED",
"EUROTECH TECHNOLOGIES PRIVATE LIMITED",
"EUROTECK ENVIRONMENTAL PRIVATE LIMITED",
"EUROTECNICHE INDIA PRIVATE LIMITED",
"EUROTEK ENVIRONMENTAL PRIVATE LIMITED",
"EUROTEX INDUSTRIES AND EXPORTS LIMITED",
"EUROTHERM INDIA PRIVATE LIMITED",
"EUROVESION SYSTEMS PRIVATE LIMITED",
"EUROVILLE PRIVATE LIMITED",
"EUROZAPP TECHNOLOGIES PRIVATE LIMITED",
"EURRO-GRANITE MARBLE PRIVATE LIMITED",
"EURUS GLOBAL ADVISORS LLP",
"EURUS INTERNETWORKS PRIVATE LIMITED",
"EURUS MANAGEMENT SERVICES PRIVATE LIMITED",
"EURUS NETWORK SERVICES PRIVATE LIMITED.",
"EURYS INFOSYSTEMS PRIVATE LIMITED",
"EUSTOMA ADVISORS PRIVATE LIMITED",
"EUSTON INDUSTRIES LIMITED",
"EUSU LOGISTICS INDIA PRIVATE LIMITED",
"EUT HUB TECHNOLOGIES PRIVATE LIMITED",
"EUTECH INDIA PRIVATE LIMITED",
"EUTHORIA DEVELOPERS PRIVATE LIMITED",
"EUV BUSINESS SERVICES PRIVATE LIMITED",
"EV MOTORS INDIA PRIVATE LIMITED",
"EVA ALU PANEL LIMITED",
"EVA AUTOMOTIVE INDUSTRIES PRIVATE LIMITED",
"EVA COLLEGE OF AYURVED MENG TRILOK SEVA",
"EVA DEVELOPERS PRIVATE LIMITED",
"EVA EXOTICA PRIVATE LIMITED",
"EVA FUELS PRIVATE LIMITED",
"EVA MEDICARE PRIVATE LIMITED",
"EVA SOFT PRIVATE LIMITED",
"EVAAN ELEVATORS PRIVATE LIMITED",
"EVAC ENGINEERING PROJECTS PRIVATE LIMITED",
"EVAGE VENTURES PRIVATE LIMITED",
"EVAIO DIAMOND PRIVATE LIMITED",
"EVALUABLE INFOSERVE PRIVATE LIMITED",
"EVALUATIONZ INDIA PRIVATE LIMITED",
"EVALUESERVE COM PRIVATE LIMITED",
"EVALUESERVE SEZ (GURGAON) PRIVATE LIMITED",
"EVAM HOSPITALITY PRIVATE LIMITED",
"EVAM TECH LABS PRIVATE LIMTED",
"EVAN AUTOMATION PRIVATE LIMITED",
"EVAN ENTERPRISES",
"EVANA ELECTRICALS PRIVATE LIMITED",
"EVANGEL PUBLISHING PRIVATE LIMITED",
"EVANGELICAL LUTHERAN CHURCH NAGPUR",
"EVANGELICAL TRUST ASSOCIATION OF SOUTH INDIA.",
"EVANGELIST TECHNOLOGY PRIVATE LIMITED",
"EVANGELOS VENTURES PRIVATE LIMITED",
"EVANIK NETWORKS PRIVATE LIMITED",
"EVANS CATALYSTS PRIVATE LIMITED",
"EVANS CHEM INDIA PRIVATE LIMITED",
"EVANS ELECTRIC LIMITED",
"EVANS ELECTRIC PRIVATE LIMITED",
"EVANTAGE IT CONSULTING SERVICES PRIVATE LIMITED",
"EVANTHA DEVELOPERS PRIVATE LIMITED",
"EVANTI RETAIL SOLUTION PRIVATE LIMITED",
"EVAPROV COOLING TECHNOLOGIES PRIVATE LIMITED",
"EVAREX PHARMACEUTICALS PRIVATE LIMITED",
"EVATO TECHNOLOGY PRIVATE LIMITED",
"EXC MANAGED SERVICES PRIVATE LIMITED",
"EVE SPARK INTEGRATED SOLUTIONS PRIVATE LIMITED",
"EVELTA ELECTRONICS PRIVATE LIMITED",
"EVELYN ENTERPRISES PRIVATE LIMITED",
"EVELYN LEARNING SYSTEMS PRIVATE LIMITED",
"EVELYN ONLINE LEARNING PRIVATE LIMITED",
"EVEN FLOW EVENTS AND EXPERIENCES LLP",
"EVEN LIVELIHOODS PRIVATE LIMITED",
"EVENDIGITS BUSINESS ADVISORY PRIVATE LIMITED",
"EVENFORCE TECHNOLOGIES PRIVATE LIMITED",
"EVENOR INFO SOLUTIONS PRIVATE LIMITED",
"EVENT ELECTRIC PRIVATE LIMITED",
"EVENTELL GLOBAL ADVISORY PRIVATE LIMITED",
"EVENTENO OCCASIONS PRIVATE LIMITED",
"EVENTFAQS MEDIA PRIVATE LIMITED",
"EVENTFUL",
"EVENTILA TECHNOLOGIES PRIVATE LIMITED",
"EVENTIVE MARKETING PRIVATE LIMITED",
"EVENTOSS ENTERTAINMENT PRIVATE LIMITED",
"EVENTRIP PRIORITY PRIVATE LIMITED",
"EVENTS BY EXPERTS PRIVATE LIMITED",
"EVENTSNOW PRIVATE LIMITED",
"EVENTTAN PRIVATE LIMITED",
"EVENTUAL POLYCHEM PRIVATE LIMITED",
"EVENTUALLY BRAND SERVICES PRIVATE LIMITED",
"EVENTURE SOFTSOL PRIVATE LIMITED",
"EVENTURERS SOLUTIONS PRIVATE LIMITED",
"EVENTURES UNLIMITED",
"EVENTUS SOFTWARE SERVICES PRIVATE LIMITED",
"EVENTUS TECHSOL PRIVATE LIMITED",
"EVENTXPRESS MANAGEMENT SERVICES PRIVATE LIMITED",
"EVENUS SECURITY SYSTEMS PRIVATE LIMITED",
"EVER ASSAM TEA PVT LTD",
"EVER BAGS PACKAGING PRIVATE LIMITED",
"EVER BRIGHT PRODUCTS",
"EVER BRIGHT STEEL PVT LTD",
"EVER CARGO LOGISTICS PRIVATE LIMITED",
"EVER CLEAR FILMS PRIVATE LIMITED",
"EVER ELECTRONICS PRIVATE LIMITED",
"EVER FAST GLOBAL LOGISTICS PRIVATE LIMITED",
"EVER FRESH NUTRIMENT INDUSTRIES",
"EVER FRUIT EXPORTS PRIVATE LIMITED",
"EVER GREEN BUILDING PRODUCTS PRIVATE LIMITED",
"EVER GREEN FABRIC PROCESS PRIVATE LIMITED",
"EVER HEALTH LIFE SCIENCES PRIVATE LIMITED",
"EVER INFRAPROJECTS PRIVATE LIMITED",
"EVER MELLOW",
"EVER ON POWER LIMITED",
"EVERAIN GLOBALSERVICES PRIVATE LIMITED",
"EVERBEST CONSULTANCY SERVICES PRIVATE LIMITED",
"EVERBEST TREXIM PRIVATE LIMITED",
"EVERBLINK STEEL PRIVATE LIMITED",
"EVERBLUE APPAREL LIMITED",
"EVERBLUE SEAFOODS PRIVATE LIMITED",
"EVERBLUE TRAVIN PVT. LTD.",
"EVERBRIDGE LOGISTICS PRIVATE LIMITED",
"EVERBRIDGE TECHNOLOGIES INDIA PRIVATE LIMITED",
"EVERBRITE JEWELLERY & DIAMONDS PRIVATE LIMITED",
"EVERCLEAN TECHNOLOGIES PRIVATE LIMITED",
"EVERCON DEVELOPERS PRIVATE LIMITED",
"EVERCREST PROJECTS PRIVATE LIMITED",
"EVERDATA TECHNOLOGIES PRIVATE LIMITED",
"EVERDEW ENGINEERING PRIVATE LIMITED",
"EVEREADY EXIM",
"EVEREADY INDUSTRIES INDIA LIMITED",
"EVEREADY POWER SYSTEM (P) LTD.",
"EVEREADY SPINNING MILLS PRIVATE LIMITED",
"EVEREN HEALTHCARE",
"EVERENVIRO RESOURCE MANAGEMENT PRIVATE LIMITED",
"EVEREST ABROAD SERVICES PRIVATE LIMITED",
"EVEREST ALUMINIUM PRIVATE LIMITED",
"EVEREST BEVERAGES AND FOOD INDUSTRIES PRIVATE LIMITED",
"EVEREST BLOWER SYSTEMS PRIVATE LIMITED",
"EVEREST BLOWERS PRIVATE LIMITED",
"EVEREST BRAND SOLUTIONS PRIVATE LIMITED",
"EVEREST BUSINESS ADVISORY INDIA PRIVATE LIMITED",
"EVEREST CABLES & CONNECTORS PRIVATE LIMITED",
"EVEREST CASTINGS PVT LTD",
"EVEREST COMMOTRADE PRIVATE LIMITED",
"EVEREST COMPOSITES PRIVATE LIMITED",
"EVEREST CONSTRUCTION COMPANY",
"EVEREST CONSULTING GROUP INDIA PRIVATE LIMITED",
"EVEREST DISTRIBUTIONS PRIVATE LIMITED",
"EVEREST EDIBLE PRODUCTS PRIVATE LIMITED",
"EVEREST EDUSYS AND SOLUTIONS PRIVATE LIMITED",
"EVEREST ELECTRICAL ENTERPRISES PRIVATE LIMITED",
"EVEREST ENGINEERING & ALLIED PRODUCTS PRIVATE LIMITED",
"EVEREST ENGINEERING EQUIPMENT PRIVATE LIMITED",
"EVEREST EQUIPMENTS PRIVATE LIMITED",
"EVEREST FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"EVEREST FARM HOUSES PVT LTD",
"EVEREST FERTILIZERS AND CHEMICALS PVT LTD",
"EVEREST FINANCE AND INVESTMENTS PRIVATE LIMITED",
"EVEREST FLAVOURS LIMITED",
"EVEREST FLEET NORTH PRIVATE LIMITED",
"EVEREST FLEET PRIVATE LIMITED",
"EVEREST FOOD PRODUCTS PRIVATE LIMITED",
"EVEREST GOLD MART PRIVATE LIMITED",
"EVEREST HOLOVISIONS LIMITED",
"EVEREST INDUSTRIES LIMITED",
"EVEREST INFONET PRIVATE LIMITED",
"EVEREST INFRA ENERGY LIMITED",
"EVEREST INFRA VENTURES INDIA PRIVATE LIMITED",
"EVEREST INFRAHEIGHTS PRIVATE LIMITED",
"EVEREST INSTRUMENTS PRIVATE LIMITED",
"EVEREST IT SERVICES PRIVATE LIMITED",
"EVEREST KANTO CYLINDER LIMITED",
"EVEREST MARKETING AGENCY",
"EVEREST MEDICAL TECHNOLOGIES PRIVATE LIMITED",
"EVEREST NISARG GREENLAND DEVELOPERS PRIVATE LIMITED",
"EVEREST PAPER DISTRIBUTING COMPANY PRIVATE LIMITED",
"EVEREST PAPER MILLS PVT LTD",
"EVEREST PLY & VENEERS P LIMITED.",
"EVEREST POLYFILLERS PRIVATE LIMITED",
"EVEREST POWER PRIVATE LIMITED",
"EVEREST PROJECTS PRIVATE LIMITED",
"EVEREST PROTECTION FORCE PRIVATE LIMITED",
"EVEREST RECLAIM RUBBER INDUSTRIES",
"EVEREST REFRACTORIES PRIVATE LIMITED",
"EVEREST RENTALS PRIVATE LIMITED",
"EVEREST ROAD EQUIPMENTS PRIVATE LIMITED",
"EVEREST ROLLING MILLS PRIVATE LIMITED",
"EVEREST SEA FOODS PRIVATE LIMITED",
"EVEREST SPARES AND AUTO ELECTRICAL INDUSTRIES PRIVATE LIMITED",
"EVEREST SPINNERS INDIA PRIVATE LIMITED",
"EVEREST STABILISERS PRIVATE LIMITED",
"EVEREST STARCH (INDIA) PRIVATE LIMITED",
"EVEREST SUDARSHAN PRIVATE LIMITED",
"EVEREST TANNERY PRIVATE LIMITED",
"EVEREST TRADERS AND ENGINEERS PRIVATE LIMITED",
"EVEREST WEB SOLUTIONS PRIVATE LIMITED",
"EVEREST WELDING PRIVATE LIMITED",
"EVEREST YARN AGENCY PVT LTD",
"EVERESTDX (INDIA) PRIVATE LIMITED",
"EVERESTEK TECHNOSOFT SOLUTIONS PRIVATE LIMITED",
"EVERESTGUPTAJI TEXPORTS PRIVATE LIMITED",
"EVERESTIMS TECHNOLOGIES PRIVATE LIMITED",
"EVERESTT CHILLERS PRIVATE LIMITED",
"EVERETT (INDIA) PVT LTD",
"EVERETT CONSULTANTS PVT LTD",
"EVEREX INFOTECH PRIVATE LIMITED",
"EVEREXPANSE PRIVATE LIMITED",
"EVERFAST FREIGHT FORWARDERS PRIVATE LIMITED",
"EVERFINE PLASTIC INDUSTRIES PRIVATE LIMITED",
"EVERFORCE SOFTWARE INDIA PRIVATE LIMITED",
"EVERFRESH FROZEN CARRIERS PRIVATE LIMITED",
"EVERGE SOFTWARE & TECHNOLOGY SERVICES PRIVATE LIMITED",
"EVERGENT TECHNOLOGIES PRIVATE LIMITED",
"EVERGLADES REALTY PRIVATE LIMITD",
"EVERGOOD BLENDERS PRIVATE LIMITED",
"EVERGREEN ADVERTISING PRIVATE LIMITED",
"EVERGREEN BAMBOO INDIA PRIVATE LIMITED",
"EVERGREEN BOARDLAM PRIVATE LIMITED",
"EVERGREEN CABLES PRIVATE LIMITED",
"EVERGREEN CHEMIST PRIVATE LIMITED",
"EVERGREEN CLEANTECH FACILITIES MANAGEMENT INDIA LIMITED",
"EVERGREEN COLDCHAIN SOLUTIONS PRIVATE LIMITED",
"EVERGREEN COLOURS INDIA PRIVATE LIMITED",
"EVERGREEN CONSTRUCTION (DURGAPUR) PVT LTD",
"EVERGREEN CONTRACTORS (INDIA) PRIVATE LIMITED",
"EVERGREEN DEALCOM PVT LTD",
"EVERGREEN DOOARS TEA PRIVATE LIMITED",
"EVERGREEN DRUMS AND CANS PRIVATE LIMITED",
"EVERGREEN DRY DECOR PRIVATE LIMITED",
"EVERGREEN EDUCATION (INDIA) PRIVATE LIMITED",
"EVERGREEN ELECTRICALS PRIVATE LIMITED",
"EVERGREEN ENGINEERING COMPANY PRIVATE LIMITED",
"EVERGREEN ENVINRONMENTAL SOLUTION",
"EVERGREEN FAIR-TRADE PRIVATE LIMITED",
"EVERGREEN FOODS PVT LTD",
"EVERGREEN HABITATS AND REALTIES PRIVATE LIMITED",
"EVERGREEN HARVEST AGRO PRODUCTS PRIVATE LIMITED",
"EVERGREEN HOME APPLIANCES PRIVATE LIMITED",
"EVERGREEN HOSIERY INDUSTRIES PRIVATE LIMITED",
"EVERGREEN HOUSE KEEPING SERVICES PRIVATE LIMITED",
"EVERGREEN INDIA MART PRIVATE LIMITED",
"EVERGREEN INDUSTRIES PRIVATE LIMITED",
"EVERGREEN INFRABUILD PRIVATE LIMITED",
"EVERGREEN INTERNATIONAL LIMITED",
"EVERGREEN LAND MARK PRIVATE LIMITED",
"EVERGREEN LANDSCAPES INDIA PRIVATE LIMITED",
"EVERGREEN LITHIUM RECYCLING PRIVATE LIMITED",
"EVERGREEN MANAGEMENT SERVICES INDIA PRIVATE LIMITED",
"EVERGREEN MICRONUTRIENTS PRIVATE LIMITED",
"EVERGREEN MOVERS PRIVATE LIMITED",
"EVERGREEN MRUDULA AGRO-VET PRIVATE LIMITED",
"EVERGREEN NATURAL PRODUCTS PRIVATE LIMITED",
"EVERGREEN PLYWOOD INDUSTRIES PVT LTD",
"EVERGREEN PUBLIC SCHOOL",
"EVERGREEN PUBLICATIONS INDIA LIMITED",
"EVERGREEN RECYCLEKARO INDIA PRIVATE LIMITED",
"EVERGREEN RICE MILL PRIVATE LIMITED",
"EVERGREEN SEAMLESS PIPES & TUBES PRIVATE LIMITED",
"EVERGREEN SHIPPING AGENCY (INDIA) PRIVATE LIMITED",
"EVERGREEN SOLAR SYSTEMS INDIA PRIVATE LIMITED",
"EVERGREEN TECHNOLOGIES PRIVATE LIMITED",
"EVERGREEN VENEERS PRIVATE LIMITED",
"EVERGROW MARKETING PRIVATE LIMITED",
"EVERGROW TRACOM PRIVATE LIMITED",
"EVERGROWING IRON & FINVEST PRIVATE LIMITED",
"EVERGY ENGINEERING INDIA PRIVATE LIMITED",
"EVERI INDIA PRIVATE LIMITED",
"EVERINFRA ENGICON PRIVATE LIMITED",
"EVERLAST ENGINEERING PRIVATE LIMITED",
"EVERLAST PROJECTS PRIVATE LIMITED,",
"EVERLAST ROOFING",
"EVERLASTING CHEMICALS PRIVATE LIMITED",
"EVERLEDGER SYSTEMS PRIVATE LIMITED",
"EVERLIGHT ELECTRONICS INDIA PRIVATE LIMITED",
"EVERLIKE FOOD PRODUCTS INDIA PRIVATE LIMITED",
"EVERLINK INVESTMENT ADVISORY PRIVATE LIMITED",
"EVERLLOYD CONTAINER LINES PRIVATE LIMITED",
"EVERLON FINANCIALS LIMITED",
"EVERLOVE COSMETICS & BEAUTY CARE PRIVATE LIMITED",
"EVERLUX AUTOMOTIVES PRIVATE LIMITED",
"EVERMARK NEUTRACEUTICALS LLP",
"EVERMARK POLYMERS PRIVATE LIMITED",
"EVERMINE DIAMOND PRIVATE LIMITED",
"EVERMORE COMMODITY BROKERS PRIVATE LIMITED",
"EVERMORE INDIA PRIVATE LIMITED",
"EVERMORE SHARE BROKING PRIVATE LIMITED",
"EVERMORE STOCK BROKERS PRIVATE LIMITED",
"EVERNAL PROPERTIES PRIVATE LIMITED",
"EVERNEST ASSETS PRIVATE LIMITED",
"EVERNEST COMMERCIAL ASSETS PRIVATE LIMITED",
"EVERNEST COMMERCIAL PARKS PRIVATE LIMITED",
"EVERNEST GAINS PROPERTIES PRIVATE LIMITED",
"EVERNEW PROJECTS PRIVATE LIMITED",
"EVERNOVA ENTERPRISES PRIVATE LIMITED",
"EVERNOVA HOME SOLUTIONS PRIVATE LIMITED",
"EVERO CONSULTING SERVICES INDIA PRIVATE LIMITED",
"EVERON EDUCATIONAL SOCIETY",
"EVERON GEARS PRIVATE LIMITED",
"EVERON LOGISTICS PRIVATE LIMITED",
"EVERON SMART SOLUTIONS INDIA PRIVATE LIMITED",
"EVERON THREADS PRIVATE LIMITED",
"EVER-ONE PROPERTIES INDIA PRIVATE LIMITED",
"EVERONN BUSINESS EDUCATION LIMITED",
"EVERPLUS PLASTICS PRIVATE LIMITED",
"EVERPRIME SHIPPING PRIVATE LIMITED",
"EVERREADY PACKAGING INDUSTRIES PVT LTD",
"EVERRENEW ENERGY PRIVATE LIMITED",
"EVERRISE INFOSOLUTION PRIVATE LIMITED",
"EVERSAFE PROTECT SYSTEMS PRIVATE LIMITED",
"EVERSAI FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"EVERSANA INDIA PRIVATE LIMITED",
"EVERSEEN INDIA PRIVATE LIMITED",
"EVERSENDAI CONSTRUCTION PRIVATE LIMITED",
"EVERSENDAI FRONTIERS PRIVATE LIMITED",
"EVERSHEEN PAINTS PRIVATE LIMITED",
"EVERSHINE APPLIANCES PRIVATE LIMITED",
"EVERSHINE BPO INDIA PRIVATE LIMITED",
"EVERSHINE BUILD INDIA PRIVATE LIMITED",
"EVERSHINE BUILDERS",
"EVERSHINE BUSINESS VENTURES PRIVATE LIMITED",
"EVERSHINE CARGO MOVERS (BOMBAY) PRIVATE LIMITED",
"EVERSHINE CORROSION CONTROLS PRIVATE LIMITED",
"EVERSHINE DECOR PRIVATE LIMITED",
"EVERSHINE DRUG PRODUCT PRIVATE LIMITED",
"EVERSHINE DWELLINGS PRIVATE LIMITED",
"EVERSHINE DYNAMIC CORPORATION LIMITED",
"EVERSHINE ENGLISH SCHOOL",
"EVERSHINE FOOD PRODUCTS PRIVATE LIMITED",
"EVERSHINE LIFESCIENCES PRIVATE LIMITED",
"EVERSHINE MARBLES AND EXPORTERS PRIVATE LIMITED",
"EVERSHINE METAL INDUSTRIES PRIVATE LIMITED",
"EVERSHINE MINERALS (INDIA) PRIVATE LIMITED",
"EVERSHINE OLEOCHEM LIMITED",
"EVERSHINE PHARMACEUTICAL DISTRIBUTORS PRIVATE LIMITED",
"EVERSHINE RESOURCE MANAGEMENT PRIVATE LIMITED",
"EVERSHINE RUBBERS PRIVATE LIMITED",
"EVERSHINE SMELTING ALLOY PRIVATE LIMITED",
"EVERSHINE TAPES PRIVATE LIMITED",
"EVERSHINE TEA COMPANY PRIVATE LIMITED",
"EVERSHINE VINIMAY PRIVATE LIMITED",
"EVERSMILE CONSTRUCTION CO PRIVATE LIMITED",
"EVERSMILE LEARNING PRIVATE LIMITED",
"EVERSMILE PROPERTIES PRIVATE LIMITED",
"EVERSOURCE CAPITAL PRIVATE LIMITED",
"EVERSTONE CAPITAL ADVISORS PRIVATE LIMITED",
"EVERSTONE MINERALS LLP",
"EVERSTRONG MARKETING PRIVATE LIMITED",
"EVERSTRONG METAL PRIVATE LIMITED",
"EVERSTYLE HOTEL SUPPLIES INDIA PRIVATE LIMITED.",
"EVERSTYLISH LIFESTYLE PRIVATE LIMITED",
"EVERSUB INDIA PRIVATE LIMITED",
"EVERSUN MARINE TRADE PRIVATE LIMITED",
"EVERSURE AQUA SERVICES PRIVATE LIMITED",
"EVERSURE INDUSTRIES PRIVATE LIMITED",
"EVERTECH TECHNOLOGIES PRIVATE LIMITED",
"EVERTOGEN LIFE SCIENCES LIMITED",
"EVERTON TEA INDIA PRIVATE LIMITED",
"EVERTZ INDIA PRIVATE LIMITED",
"EVERTZ MICROSYSTEMS LIMITED",
"EVERUP BATTERY INDIA PRIVATE LIMITED",
"EVERVOLT GREEN ENERGY PRIVATE LIMITED",
"EVERWELL BUILDCON PRIVATE LIMITED",
"EVERWELL HEALTH SOLUTIONS PRIVATE LIMITED",
"EVERWELL PHARMA PRIVATE LIMITED",
"EVERWIN COTTONS KARUR PRIVATE LIMITED",
"EVERWIN MATRIC HR SEC SCHOOL",
"EVERWIN MATRICULATION HIGHER SECONDARY SCHOOL",
"EVERWIN SECURITY SERVICES PRIVATE LIMITED",
"EVERWIN VIDHYASHRAM",
"EVERY DAY SHOPPING MART PRIVATE LIMITED",
"EVERY WEAR IMPORT AND EXPORT PRIVATE LIMITED",
"EVERYDAY BANKING SOLUTIONS",
"EVERYDAY ETHICAL GLOBAL LIMITED",
"EVERYDAY FACILITY SERVICES PRIVATE LIMITED",
"EVERYDAY HEALTH INDIA PRIVATE LIMITED",
"EVERYDAY STEEL STORAGE PRIVATE LIMITED",
"EVERYMARKET OVERSEAS PRIVATE LIMITED",
"EVERYMEDIA TECHNOLOGIES PRIVATE LIMITED",
"EVERYONDR CAPITAL ADVISORS PRIVATE LIMITED",
"EVERYOUTH FASHION FOOTWEAR LIMITED",
"EVERYSPEND INDIA PRIVATE LIMITED",
"EVERYTHING AGRO PRIVATE LIMITED",
"EVERYWHERE TRANSPORT ORGANISATION PRIVATE LIMITED",
"EVETIS STONE INDIA PRIVATE LIMITED",
"EVETS PACKAGING PRIVATE LIMITED",
"EVEX AUTO INDIA PRIVATE LIMITED",
"EVEXIA LIFECARE LIMITED",
"EVEXIA NUTRITIONS PRIVATE LIMITED",
"EVEXIA SOLUTIONS PRIVATE LIMITED",
"EVEXIUS PRIVATE LIMITED",
"EVEY TRANS (JAB) PRIVATE LIMITED",
"EVEY TRANS (KTC) PRIVATE LIMITED",
"EVEY TRANS (NGP) PRIVATE LIMITED",
"EVEY TRANS (SIL) PRIVATE LIMITED",
"EVEY TRANS (SMC) PRIVATE LIMITED",
"EVEY TRANS (UKS) PRIVATE LIMITED",
"EVEY TRANS PRIVATE LIMITED",
"EVG ENGICON AIRTECH PRIVATE LIMITED",
"EVGATEWAY INDIA PRIVATE LIMITED",
"EVI FINISHING INDIA PRIVATE LIMITED",
"EVI TECHNOLOGIES PRIVATE LIMITED",
"EVIA INFORMATION SYSTEMS PRIVATE LIMITED",
"EVIALIS INDIA LIMITED",
"EVIAN ENGINEERING PRIVATE LIMITED",
"EVIDENT LASER AUTO PRIVATE LIMITED",
"EVIDENT SCIENTIFIC PRIVATE LIMITED",
"EVIEW SOLUTIONS PRIVATE LIMITED",
"EVIGO CHARGE PRIVATE LIMITED",
"EVIMERIA AGENCIES PRIVATE LIMITED",
"EVINCE DEVELOPMENT PRIVATE LIMITED",
"EVINCERE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"EVINOS BUILDERS LIMITED",
"EVIO PRIVATE LIMITED",
"EVIONIX SYSTEMS PRIVATE LIMITED",
"EVIRIS HEALTH SERVICES PRIVATE LIMITED",
"EVIROCOR PACKAGING INDIA PRIVATE LIMITED",
"EVIRTUAL IT SERVICES PRIVATE LIMITED",
"EVISCO SYSTEMS PRIVATE LIMITED",
"E-VISION",
"E-VISION IMPLEMENTATION SERVICES PRIVATE LIMITED",
"EVISION INFOTECH SOLUTION PRIVATE LIMITED",
"EVISIONS TELEINFRA PRIVATE LIMITED",
"EVISKA INFOTECH PRIVATE LIMITED",
"EVISTA EYE CARE CENTRE PRIVATE LIMITED",
"EVITA HOMES PRIVATE LIMITED",
"EVITALIFE PHARMA PRIVATE LIMITED",
"EVITAMIN BUSINESS CONSULTING PRIVATE LIMITED",
"EVITERRA TRAVEL DESK PRIVATE LIMITED",
"EVIVE SOFTWARE ANALYTICS PRIVATE LIMITED",
"EVM AUTOKRAFT INDIA PRIVATE LIMITED",
"EVM AUTOMOBILES PRIVATE LIMITED",
"EVM AUTOMOTIVE INDIA PRIVATE LIMITED",
"EVM ENTERPRISES PRIVATE LIMITED",
"EVM HOTELS PRIVATE LIMITED",
"EVM MOTELS PRIVATE LIMITED",
"EVM MOTORS & VEHICLES INDIA PRIVATE LIMITED",
"EVM PASSENGER CARS INDIA PRIVATE LIMITED",
"EVM PREMIUM CARS INDIA PRIVATE LIMITED",
"EVO DIGITAL TECHNOLOGIES PRIVATE LIMITED",
"EVOC COMMUNICATIONS CONSULTING PRIVATE LIMITED",
"EVODIGITAL TECHNOLOGIES PRIVATE LIMITED",
"EVOGENE AGRITECH PRIVATE LIMITED",
"EVOGREEN DECORATIVES PRIVATE LIMITED",
"EVOKE HR SOLUTIONS PRIVATE LIMITED",
"EVOKE TECHNOLOGIES PRIVATE LIMITED",
"EVOLENT HEALTH INTERNATIONAL PRIVATE LIMITED",
"EVOLET HEALTH CARE PRIVATE LIMITED",
"EVOLET PHARMACEUTICALS PRIVATE LIMITED",
"EVOLGENCE TELECOM SYSTEMS PRIVATE LIMITED",
"EVOLICS BIO PRIVATE LIMITED",
"EVOLIS CARD PRINTER INDIA PRIVATE LIMITED",
"EVOLKO SYSTEMS PRIVATE LIMITED",
"EVOLTECH INDIA PRIVATE LIMITED",
"EVOLTIK INTERNATIONAL PRIVATE LIMITED",
"EVOLUTE CLEANTECH SOLUTIONS PRIVATE LIMITED",
"EVOLUTE FINTECH INNOVATIONS PRIVATE LIMITED",
"EVOLUTEIQ SOLUTIONS PRIVATE LIMITED",
"EVOLUTION DIGITAL INDIA PRIVATE LIMITED",
"EVOLUTION ELEKTROTECH PRIVATE LIMITED",
"EVOLUTION SPORTS NUTRITION PRIVATE LIMITED",
"EVOLUTIONARY ALGORITHMS PRIVATE LIMITED",
"EVOLUTIONARY SYSTEMS PRIVATE LIMITED",
"EVOLUTIONCO DIGITAL & INTERACTIVE CONSULTANCY PRIVATE LIMITED",
"EVOLUTIS INDIA PRIVATE LIMITED",
"EVOLUTYZ IT SERVICES PRIVATE LIMITED",
"EVOLUZN INDIA PRIVATE LIMITED",
"EVOLV CLOTHING COMPANY PRIVATE LIMITED",
"EVOLVAN INFO SOLUTIONS PRIVATE LIMITED",
"EVOLVE ACCOUNTING SYSTEMS PRIVATE LIMITED",
"EVOLVE BRANDS PRIVATE LIMITED",
"EVOLVE DIGITAL SOLUTIONS PRIVATE LIMITED",
"EVOLVE INFRATECH PRIVATE LIMITED",
"EVOLVE IT SOLUTIONS PRIVATE LIMITED",
"EVOLVE PROMOTERS PRIVATE LIMITED",
"EVOLVE RESIDENCY PRIVATE LIMITED",
"EVOLVE SNACKS PRIVATE LIMITED",
"EVOLVE SQUARE TECHNOLOGY PRIVATE LIMITED",
"EVOLVE TECHNOLOGIES & SERVICES PRIVATE LIMITED",
"EVOLVE TECHNOLOGIES & SERVICES PRIVATE. LIMITED",
"EVOLVE TRADINGS PRIVATE LIMITED",
"EVOLVEMENT EXPRESS LOGISTIC SERVICE (OPC) PRIVATE LIMITED",
"EVOLVER TECHNIQUES PRIVATE LIMITED",
"EVOLVEWARE INFORMATION TECHNOLOGY (INDIA) PRIVATE LIMITED",
"EVOLVING SYSTEMS NETWORKS INDIA PRIVATE LIMITED",
"EVOLVUS SOLUTIONS PRIVATE LIMITED",
"EVOLVUS TECHNOLOGIES PRIVATE LIMITED",
"EVON TECHNOLOGIES PRIVATE LIMITED",
"EVONENCE INDIA PRIVATE LIMITED",
"EVONIK CATALYSTS INDIA PRIVATE LIMITED",
"EVONIK INDIA PRIVATE LIMITED",
"EVONIK SPECIALTY SILICA INDIA PRIVATE LIMITED",
"EVONITH METALLICS LIMITED",
"EVONITH VALUE STEEL LIMITED",
"EVONIX TECHNOLOGIES PRIVATE LIMITED",
"EVONNE INDUSTRIES PRIVATE LIMITED",
"EVONSYS INDIA PRIVATE LIMITED",
"EVOPLUS IT SERVICES PRIVATE LIMITED",
"EVOQ REMEDIES LIMITED",
"EVOQUA WATER TECHNOLOGIES INDIA PRIVATE LIMITED",
"EVOQUE ADVISORY PRIVATE LIMITED",
"EVORA IT SOLUTIONS PRIVATE LIMITED",
"EVOS DESIGN LIVING PRIVATE LIMITED",
"EVOSPORTS EDUCATION AND TECHNOLOGIES PRIVATE LIMITED",
"EVOTECH HYDRO PRIVATE LIMITED",
"EVOXYZ TECHNOLOGIES PRIVATE LIMITED",
"EVOZARD CONSULTING SERVICES PRIVATE LIMITED",
"EVOZONE TECHNOLABS PRIVATE LIMITED",
"EVP CONVEYOR PRODUCTS PRIVATE LIMITED",
"EVPL INDUSTRIES PRIVATE LIMITED",
"EVR ELECTRICALS PRIVATE LIMITED",
"EVRA ENERGY INDIA PRIVATE LIMITED",
"EVRON BIOCRAFT PRIVATE LIMITED",
"EVRY INDIA PRIVATE LIMITED",
"EVS DISTRIBUTORS INDIA LIMITED",
"EVTRIC MOTORS PRIVATE LIMITED",
"EVYAPAR SELLERHELP PRIVATE LIMITED",
"EVYAVAN GLOBAL PRIVATE LIMITED",
"EVYTAA LIFESTYLE PRIVATE LIMITED",
"EW INSPECTION AND NDT PRIVATE LIMITED",
"EW NUTRITION INDIA PRIVATE LIMITED",
"EW ZONE SOLUTIONS PRIVATE LIMITED",
"EWAC ALLOYS LIMITED",
"EWALT TECHNOLOGIES PRIVATE LIMITED",
"EWART INVESTMENTS LIMITED",
"EWASTE PEOPLE INDIA PRIVATE LIMITED",
"E-WASTE SOCIAL PRIVATE LIMITED",
"E-WATER MISSION INDIA PRIVATE LIMITED",
"E-WAY FURNITURE SYSTEMS PRIVATE LIMITED",
"E-WAY LIPIDS PRIVATE LIMITED",
"EWDS PRIVATE LIMITED",
"E-WEBCITY PRIVATE LIMITED",
"EWEBCORE TECHNOLOGIES PRIVATE LIMITED",
"E-WEBLINK SYSTEMS & CLOUD CONSULTING PRIVATE LIMITED",
"EWELLIX INDIA PRIVATE LIMITED",
"EWG IT CONSULTANCY SERVICES PRIVATE LIMITED",
"E-WHIZ SOLUTIONS PRIVATE LIMITED",
"EWIG TECHNOLOGIES PRIVATE LIMITED",
"EWING ¬†CHRISTIAN PUBLIC SCHOOL",
"EWING CHRISTIAN PUBLIC SCHOOL PRAYAGRAJ",
"EWIRE SOFTTECH PRIVATE LIMITED",
"E-WISH RETAIL",
"EWIT INFOTECH PRIVATE LIMITED",
"EWNS TRADING PRIVATE LIMITED",
"EWORKPLACE APPS INDIA PRIVATE LIMITED",
"EWR LOGISTICS PRIVATE LIMITED",
"EWS EXPERTS PRIVATE LIMITED",
"EWS FINANCE AND INVESTMENTS PRIVATE LIMITED",
"EWS GREENTECH PRIVATE LIMITED",
"EWTC WORLD TOURISM CENTRE PRIVATE LIMITED",
"EWYN SERVICES PRIVATE LIMITED",
"EX ENG IRRIGATION DIV FAIZABAD",
"EX ENG NARMADA DEVELOPMENT HALON DN",
"EX ENG PWT RATLAM",
"EX ENGG CAPITAL PROJECT NO 2 PHE DEPTT BHOPAL MADHYA PRADESH",
"EX ENGG CONSTRUCTION DN¬† C P A BHOPAL",
"EX ENGG NARMADA VIKAS E M DN NO 15 INDORE MADHYA PRADESH",
"EX ENGG P H E D MECHANICAL BHOPAL MADHYA PRADESH",
"EX ENGG PWD MAINTENANCE DIV NO 2 BHOPAL",
"EX ENGI PH ENGINEERING BALAGHAT MADHYA PRADESH",
"EX ENGINEER CAPITAL PROJECT DIVISION NO 1 GANDHINAGAR",
"EX ENGINEER NAGPUR ELECTRICAL DIVISION NAGPUR",
"EX ENGR BHIMA DEVELOPMENT DIVISION NO 2 SOLAPUR",
"EX ENGR IRR MECHANICAL DIVISION NO 1 BHANDARA",
"EX ENGR MULA IRRIGATION DIVISION AHMEDNAGAR",
"EX ENGR SPECIAL PROJECT P W DIVISION KOLHAPUR",
"EX P W DIVISION NANDURBAR",
"EX SERVICEMEN INDUSTRIAL GURADS PVT LTD",
"EX SERVICEMENS AIRLINK TRANSPORT SERVICES PRIVATE LIMITED",
"EX SQUARED SOLUTIONS INDIA PRIVATE LIMITED",
"EXA AG INDIA PRIVATE LIMITED",
"EXA INDIA PRIVATE LIMITED",
"EXA INFRASTRUCTURE INDIA PRIVATE LIMITED",
"EXA MENDY LAB PRIVATE LIMITED",
"EXA MOBILITY INDIA PRIVATE LIMITED",
"EXA SPECIALITIES AND LIFECARE PRIVATE LIMITED",
"EXA TELECOMMUNICATION PRIVATE LIMITED",
"EXA THERMOMETRICS INDIA PRIVATE LIMITED",
"EXABEAM INDIA PRIVATE LIMITED",
"EXACRAFT TECHNOLOGIES PRIVATE LIMITED",
"EXACT ACCOUNTS CONSULTANCY PRIVATE LIMITED",
"EXACT MARKETING & DISTRIBUTION PRIVATE LIMITED",
"EXACT MONEY CHANGERS PRIVATE LIMITED",
"EXACT PIPES AND MOULDS PRIVATE LIMITED",
"EXACT SOFTWARE INDIA PRIVATE LIMITED",
"EXACTECH INDIA PRIVATE LIMITED",
"EXACTUS CORPORATION PRIVATE LIMITED",
"EXAFLUENCE GLOBAL ANALYTICS PRIVATE LIMITED",
"EXAGRES INTERNATIONAL PRIVATE LIMITED",
"EXAINFOTECH (I) PRIVATE LIMITED",
"EXAL PEN PRIVATE LIMITED",
"EXALCA TECHNOLOGIES PRIVATE LIMITED",
"EXALEAP SEMICONDUCTOR PRIVATE LIMITED",
"EXALOGICO SYSTEMS AND SERVICES PRIVATE LIMITED",
"EXALON PROMOTION PRIVATE LIMITED",
"EXALT PHARMACEUTICALS PRIVATE LIMITED",
"EXALTER BUILDTECH PRIVATE LIMITED",
"EXALTER DEVELOPERS PRIVATE LIMITED",
"EXALTSOFT SOLUTIONS PRIVATE LIMITED",
"EXAMITY INDIA ON-LINE PROCTORING LLP",
"EXARCA CONSULTING PRIVATE LIMITED",
"EX-ARMYMEN'S PROTECTION SERVICES PRIVATE LIMITED",
"EXATHOUGHT TECHNOLOGY CONSULTING PRIVATE LIMITED",
"EXATO TECHNOLOGIES PRIVATE LIMITED",
"EXAVALU SOLUTIONS INDIA PRIVATE LIMITED",
"EXAZE PRIVATE LIMITED",
"EX-BUZZ FIRE & SECURITY PRIVATE LIMITED",
"EXCALIBUR HEALTHCARE PRIVATE LIMITED",
"EXCALIBUR INDIA PRIVATE LIMITED",
"EXCANDCA TECHNOLOGIES PRIVATE LIMITED",
"EXCAVATE RESEARCH & ANALYSIS PRIVATE LIMITED",
"EXCEAM INDIA BRANCH PRIVATE LIMITED",
"EXCEDOR VALUERS PRIVATE LIMITED",
"EXCEED CROP SCIENCE PRIVATE LIMITED",
"EXCEED ENTERTAINMENT PRIVATE LIMITED",
"EXCEED MANAGEMENT PRIVATE LIMITED",
"EXCEL",
"EXCEL ABRASIVES PRIVATE LIMITED",
"EXCEL ADHESIVE TAPES PRIVATE LIMITED (CN)",
"EXCEL AGENCIES PVT LTD",
"EXCEL AGRI BUSINESS PRIVATE LIMITED",
"EXCEL AIRCON PVT LTD",
"EXCEL ALLOYS PRIVATE LIMITED",
"EXCEL ALUGRAPHICS PRIVATE LIMITED",
"EXCEL ANAESTHESIA AND PAIN MANAGEMENT SERVICES PRIVATE LIMITED",
"EXCEL AUTO TUBE PRIVATE LIMITED",
"EXCEL AUTOCOMP INDUSTRIES PRIVATE LIMITED",
"EXCEL BAKERY EQUIPMENT PRIVATE LIMITED",
"EXCEL BIOLIFE PRIVATE LIMITED",
"EXCEL BIOTECH PRIVATE LIMITED",
"EXCEL BOOKS PRIVATE LIMITED",
"EXCEL BUSINESS LINKS PVT LTD",
"EXCEL CALIBRATION PRIVATE LIMITED",
"EXCEL CALLNET PRIVATE LIMITED",
"EXCEL CARDIAC DEVICES PRIVATE LIMITED",
"EXCEL CERAMIC PRIVATE LIMITED",
"EXCEL CHEMICALS INDUSTRIES",
"EXCEL COLLEGE OF HOTEL MANAGEMENT AND CATERING TECHNOLOGY",
"EXCEL COLOURS AND FRITS LIMITED",
"EXCEL COMPOSITES PVT LTD",
"EXCEL CONTROLINKAGE PRIVATE LIMITED",
"EXCEL COTSPIN INDIA PRIVATE LIMITED",
"EXCEL CRAFT PRIVATE LIMITED",
"EXCEL CROP CARE LIMITED",
"EXCEL DEALS",
"EXCEL DEBT BROKING PRIVATE LIMITED",
"EXCEL DIE CASTERS PRIVATE LIMITED",
"EXCEL DIESEL PRIVATE LIMITED",
"EXCEL ECO LPG INDUSTRIES PRIVATE LIMITED",
"EXCEL EDUCATIONAL INSTITUTION PRIVATE LIMITED",
"EXCEL ELECTROTECHNIK PRIVATE LIMITED",
"EXCEL ENERGY SYSTEMS PRIVATE LIMITED",
"EXCEL ENGINEERING INDUSTRIES PRIVATE LIMITED",
"EXCEL ENTERTAINMENT PRIVATE LIMITED",
"EXCEL EXIM SERVICES INDIA PRIVATE LIMITED",
"EXCEL EXPOTRADE PRIVATE LIMITED",
"EXCEL FINCREDITS SOLUTIONS PRIVATE LIMITED",
"EXCEL FOODS PRIVATE LIMITED",
"EXCEL FREIGHT PRIVATE LIMITED",
"EXCEL GAS & EQUIPMENTS PRIVATE LIMITED",
"EXCEL GENERATORS PRIVATE LIMITED",
"EXCEL GENETICS LIMITED",
"EXCEL GEOMATICS PRIVATE LIMITED",
"EXCEL GREENTECH PRIVATE LIMITED",
"EXCEL GROUP INSTITUTIONS",
"EXCEL GSA PRIVATE LIMITED",
"EXCEL HEALTH TECH DEVICES PRIVATE LIMITED",
"EXCEL HI-TECH PRIVATE LIMITED",
"EXCEL HONE MANUFACTURING (INDIA) PRIVATE LIMITED",
"EXCEL HOSPITALS PRIVATE LIMITED",
"EXCEL HYDRO PNEUMATICS PRIVATE LIMITED",
"EXCEL HYDRO PNEUMATICS PVT LTD",
"EXCEL IMAGING CENTRE",
"EXCEL IMPEX INDIA PRIVATE LIMITED",
"EXCEL IMPORT PRIVATE LIMITED",
"EXCEL INDIA PROTECTIVE PAINTS PRIVATE LIMITED",
"EXCEL INDUSTRIAL PACKAGINGS PRIVATE LIMITED",
"EXCEL INDUSTRIES LIMITED",
"EXCEL INFO SOFT SOLUTIONS PRIVATE LIMITED",
"EXCEL INFOCOM PVT LTD",
"EXCEL INFORMATICS PRIVATE LIMITED",
"EXCEL INFRALOGISTICS PRIVATE LIMITED",
"EXCEL INFRAPOWER PRIVATE LIMITED",
"EXCEL INFRAVENTURES PRIVATE LIMITED",
"EXCEL INT EXT PRIVATE LIMITED",
"EXCEL INTERIORS PRIVATE LIMITED",
"EXCEL IT SERVICES PRIVATE LIMITED",
"EXCEL JUNIOR COLLEGE",
"EXCEL KRISHI CROP CARE PRIVATE LIMITED",
"EXCEL LASER TECHNOLOGY PRIVATE LIMITED",
"EXCEL LIFE SCIENCES PRIVATE LIMITED",
"EXCEL LIFE SCIENCES PRIVATE. LIMITED",
"EXCEL LIFECARE PRIVATE LIMITED",
"EXCEL LOGISOLUTIONS PRIVATE LIMITED",
"EXCEL MARITIME & LOGISTICS PRIVATE LIMITED",
"EXCEL MEDIA & ENTERTAINMENT LLP",
"EXCEL MEDICAL COLLEGE FOR NATUROPATHY AND YOGA",
"EXCEL MEHTA EXPORTS PRIVATE LIMITED",
"EXCEL MERCANTILE PRIVATE LIMITED",
"EXCEL METAL ENGINEERING PRIVATE LIMITED",
"EXCEL MICRON (POONA) PVT LTD",
"EXCEL NET SOLUTIONS PRIVATE LIMITED",
"EXCEL ONE STOP SOLUTION PRIVATE LIMITED",
"EXCEL OPTICS PRIVATE LIMITED",
"EXCEL ORGANICS PRIVATE LIMITED",
"EXCEL OVERSEAS PRIVATE LIMITED",
"EXCEL PACK PRIVATE LIMITED",
"EXCEL PETRO-TECH AND ENGINEERING PRIVATE LIMITED",
"EXCEL PHARMACEUTICALS PRIVATE LIMITED",
"EXCEL PHOSPHATES PRIVATE LIMITED",
"EXCEL PLANT LINK PRIVATE LIMITED",
"EXCEL PLANTS AND EQUIPMENT PRIVATE LIMITED",
"EXCEL POLISH COMPANY PRIVATE LIMITED",
"EXCEL PRECAST SOLUTIONS PRIVATE LIMITED",
"EXCEL PRIME COMMODITIES PRIVATE LIMITED",
"EXCEL PRINTERS PRIVATE LIMITED",
"EXCEL PRINTMEN PRIVATE LIMITED",
"EXCEL PROCESS (BANGALORE) PRIVATE LIMITED",
"EXCEL PROCESS PRIVATE LIMITED",
"EXCEL PRODUCTIONS AUDIOVISUALS PRIVATE LIMITED",
"EXCEL PROJECT CONSULTANTS PRIVATE LIMITED",
"EXCEL PUBLIC SCHOOL MYSORE",
"EXCEL RADIO FREQUENCY TECHNOLOGIES PRIVATE LIMITED",
"EXCEL RADITORS PRIVATE LIMITED",
"EXCEL RASAYAN PVT.LTD.",
"EXCEL REALTY N INFRA LIMITED",
"EXCEL SHINE PRIVATE LIMITED",
"EXCEL SOFT LIMITED",
"EXCEL SOFT SERVICES (INDIA) PRIVATE LIMITED",
"EXCEL SOFTWARE AND SYSTEMS PRIVATE LIMITED",
"EXCEL SOFTWARE CONSULTANCY PRIVATE LIMITED",
"EXCEL SPRINGS PRIVATE LIMITED",
"EXCEL STOCK BROKING PRIVATE. LIMITED",
"EXCEL STONE DEVELOPERS PRIVATE LIMITED",
"EXCEL STYROPACK PRIVATE LIMITED",
"EXCEL SURVEYORS PRIVATE LIMITED",
"EXCEL TEA MACHINERY PRIVATE LIMITED",
"EXCEL TECHNICAL SERVICES PRIVATE LIMITED",
"EXCEL TEKNIKA LIMITED",
"EXCEL TELECOM PRIVATE LIMITED",
"EXCEL TELESONIC INDIA PRIVATE LIMITED",
"EXCEL TIMBERS PRIVATE LIMITED",
"EXCEL TRAFFIC LOGISTICS PRIVATE LIMITED",
"EXCEL VEHICLE PRIVATE LIMITED",
"EXCEL VENTURE CONSTRUCTION PRIVATE. LIMITED.",
"EXCEL VYAPAAR PRIVATE LIMITED",
"EXCEL WAREHOUSING PRIVATE LIMITED",
"EXCEL WORLDWIDE PRIVATE LIMITED",
"EXCEL WOVEN SACKS PRIVATE LIMITED",
"EXCELA JUTE PACKAGING PRIVATE LIMITED",
"EXCELACOM TECHNOLOGIES PRIVATE LIMITED",
"EXCELENCIA ITECH CONSULTING PRIVATE LIMITED",
"EXCELENCIA VENTURES INDIA PRIVATE LIMITED",
"EXCELERON SOFTWARE PRIVATE LIMITED",
"EXCELEX BIOPOLYMERS PRIVATE LIMITED",
"EXCELEX LOGISTICS PRIVATE LIMITED",
"EXCELFRONT BIZCON PRIVATE LIMITED",
"EXCEL-GLOBAL FASHION & APPAREL PRIVATE LIMITED",
"EXCELGOODIES SOFTWARE PRIVATE LIMITED",
"EXCELIZE ARCHITECTURAL SERVICES PRIVATE LIMITED",
"EXCELJUTA TALENT SOLUTION PRIVATE LIMITED",
"EXCELL AUTOVISTA PRIVATE LIMITED",
"EXCELL ENMARK PRIVATE LIMITED",
"EXCELL IMPEX (GUJARAT) PRIVATE LIMITED",
"EXCELL MEDIA PRIVATE LIMITED",
"EXCELL TECHNOLOGY VENTURES PRIVATE LIMITED",
"EXCELLA BUSINESS SERVICES PRIVATE LIMITED",
"EXCELLA INFRAZONE LLP",
"EXCELLA LIFE SCIENCES PRIVATE LIMITED",
"EXCELLA PENCILS PRIVATE LIMITED",
"EXCELLAMED LABORATORIES PRIVATE LIMITED",
"EXCELLAR HEALTHCARE PRIVATE LIMITED",
"EXCELLAR INFO SERVICES LLP",
"EXCELLARATE SOFTECH PRIVATE LIMITED",
"EXCELLECT KPO CONSULTANTS PRIVATE LIMITED",
"EXCELLEDIA DIGITAL INNOVATIONS PRIVATE LIMITED",
"EXCELLENCE CORPORATE SOLUTIONS PRIVATE LIMITED",
"EXCELLENCE ENGIMAC PRIVATE LIMITED",
"EXCELLENCE GLOBAL INDUSTRIES PRIVATE LIMITED",
"EXCELLENCE HEALTH PRIVATE LIMITED",
"EXCELLENCE INDIA RICE MILL PRIVATE LIMITED",
"EXCELLENCE INFOCOM PRIVATE LIMITED",
"EXCELLENCE IT SOLUTIONS PRIVATE LIMITED",
"EXCELLENCE ORGANISATION PRIVATE LIMITED",
"EXCELLENCE OUTSOURCING PRIVATE LIMITED",
"EXCELLENCE SHELTERS PRIVATE LIMITED",
"EXCELLENCE TECHNOSOFT PRIVATE LIMITED",
"EXCELLENCE4U RESEARCH SERVICES PRIVATE LIMITED",
"EXCELLENCIA JUNIOR COLLEGE",
"EXCELLENCY RESORTS PRIVATE LIMITED",
"EXCELLENT AUTO CARE PRIVATE LIMITED",
"EXCELLENT BETELNUT PRODUCTS PRIVATE LIMITED",
"EXCELLENT CIRCLE OF STUDIES",
"EXCELLENT CONTACT PRIVATE LIMITED",
"EXCELLENT ELECTRONICS PRIVATE LIMITED",
"EXCELLENT ENGICON PRIVATE LIMITED",
"EXCELLENT ENTERTAINMENT NETWORKS PRIVATE LIMITED",
"EXCELLENT ENVIRO LABORATORY & RESEARCH CENTRE PRIVATE LIMITED",
"EXCELLENT FABTEX PRIVATE LIMITED",
"EXCELLENT FIRE SERVICES INDIA PRIVATE LIMITED",
"EXCELLENT FISHERIES PRIVATE LIMITED",
"EXCELLENT FOOTWEAR PRIVATE LIMITED",
"EXCELLENT FORGE PVT LTD",
"EXCELLENT GASKET PRIVATE LIMITED",
"EXCELLENT GLASS AND CERAMICS PRIVATE LIMITED",
"EXCELLENT GRAVURE INDUSTRIES PRIVATE LIMITED",
"EXCELLENT HANDLING SYSTEMS PRIVATE LIMITED",
"EXCELLENT INFORMATIC PRIVATE LIMITED",
"EXCELLENT INFRASTRUCTURE PRIVATE LIMITED",
"EXCELLENT INNOVATIVE EQUIPMENTS PRIVATE LIMITED",
"EXCELLENT INSURANCE BROKING SERVICES LIMITED",
"EXCELLENT INTERIOR DESIGNERS PRIVATE LIMITED",
"EXCELLENT INTERNATIONAL SCHOOL MOSHI",
"EXCELLENT MERCANTILE PRIVATE LIMITED",
"EXCELLENT POLY PRODUCTS PRIVATE LIMITED",
"EXCELLENT POLYCON PRIVATE LIMITED",
"EXCELLENT POWER CABLE PRIVATE LIMITED.",
"EXCELLENT POWER CONTROLS (INDIA) PRIVATE LIMITED",
"EXCELLENT PU COLLEGE",
"EXCELLENT REALBUILD PRIVATE LIMITED",
"EXCELLENT SHOES PRIVATE LTD",
"EXCELLENT SPARTA SERVICES PRIVATE LIMITED",
"EXCELLENT STRUCTURES PRIVATE LIMITED",
"EXCELLENT TELECOM INFRASTRUCTURE BUILDTECH PRIVATE LIMITED",
"EXCELLENT TIMBER IMPORTS AND EXPORTS PRIVATE LIMITED",
"EXCELLENT TOOLS AND COMPONENTS PRIVATE LIMITED",
"EXCELLENT VINCOM PRIVATE LIMITED",
"EXCELLENT WASTE MANAGEMENT PRIVATE LIMITED",
"EXCELLENT WEBWORLD PRIVATE LIMITED",
"EXCELLENT WIRES AND PACKAGING PRIVATE LIMITED",
"EXCELLER MANAGEMENT CONSULTANCY LLP",
"EXCELLERATE ENTERPRISES",
"EXCELLERE TECHNOLOGIES PRIVATE LIMITED",
"EXCELLEX TECHNOLOGIES PRIVATE LIMITED",
"EXCELLIEN EXPERTISE SERVICES INDIA PRIVATE LIMITED",
"EXCELLING GEO & ENGINEERING CONSULTANT PRIVATE LIMITED",
"EXCELLINK INFRASERVICES PRIVATE LIMITED",
"EXCELLIS IT PRIVATE LIMITED",
"EXCELLON SOFTWARE PRIVATE LIMITED",
"EXCELLUS DISTRIBUTION PRIVATE LIMITED",
"EXCELMAX TECHNOLOGIES PRIVATE LIMITED",
"EXCELOID SOFT SYSTEMS PRIVATE LIMITED",
"EXCELORR SERVICES PRIVATE LIMITED",
"EXCEL-PAR ELECTRONICS PRIVATE LIMITED",
"EXCELPOINT SYSTEMS INDIA PRIVATE LIMITED",
"EXCELR SOLUTIONS",
"EXCELRA KNOWLEDGE SOLUTIONS PRIVATE LIMITED",
"EXCELSIA SHIPPING INDIA PRIVATE LIMITED",
"EXCELSIOR BUSINESS LINK LIMITED",
"EXCELSIOR CREATIONS PRIVATE LIMITED",
"EXCELSIOR EDUCATION SOCIETY K C COLLEGE OF ENGINEERING AND MANAGEMENT STUDIES AND RESEARCH",
"EXCELSIOR ENGINEERS PRIVATE LIMITED",
"EXCELSIOR FREIGHT SOLUTION PRIVATE LIMITED",
"EXCELSIOR LEATHERS PVT LTD",
"EXCELSIOR MERCHANTS PVT.LTD.",
"EXCELSIOR RESEARCH PRIVATE LIMITED",
"EXCELSIOR SOFTWARES PRIVATE LIMITED",
"EXCELSIOR TRAVELS PRIVATE LIMITED",
"EXCELSIS BUSINESS SOLUTIONS PRIVATE LIMITED",
"EXCELSOFT TECHNOLOGIES PRIVATE LIMITED",
"EXCELSOURCE INTERNATIONAL PRIVATE LIMITED",
"EXCELTECH CONSULTANCY AND PROJECTS PRIVATE LIMITED",
"EXCELTECH ENGINEERS PRIVATE LIMITED",
"EXCELTECH INDIA PRIVATE LIMITED",
"EXCELUS FOODBEV PRIVATE LIMITED",
"EXCELUS LEARNING SOLUTIONS PRIVATE LIMITED",
"EXCEPTIONAIRE TECHNOLOGIES PRIVATE LIMITED",
"EXCERO SERVICES PRIVATE LIMITED",
"EXCERS TECHNOLOGIES PRICATE LIMITED",
"EXCESS HOLOGRAPHICS PRIVATE LIMITED",
"EXCESS RENEW TECH PRIVATE LIMITED",
"EXCETRA WORKSPACE SOLUTIONS PRIVATE LIMITED",
"EXCHANGE DATA INTERNATIONAL INDIA PRIVATE LIMITED",
"EXCHIMIOUS TECHNOLOGIES PRIVATE LIMITED",
"EXCIPIENTS HOUSE LLP",
"EXCIS COMPLIANCE INDIA PRIVATE LIMITED",
"EXCISE OFFICE",
"EXCISE OFFICER PREVENTIVE FORCE ZONE JAIPURCITY",
"EXCITARE MERCHANDISE PRIVATE LIMITED",
"EXCITING FASHIONS AND EMB PRIVATE LIMITED",
"EXCL INDUSTRIAL PRODUCTS PRIVATE LIMITED",
"EXCLE PAPER PACKAGING PRIVATE LIMITED",
"EXCLUSIVE ADVERTISING PVT LTD",
"EXCLUSIVE CAPITAL LIMITED",
"EXCLUSIVE DESIGN PRIVATE LIMITED",
"EXCLUSIVE INDIA JOURNEYS PRIVATE LIMITED",
"EXCLUSIVE INFOTECH PRIVATE LIMITED",
"EXCLUSIVE INFRASTRUCTURE PRIVATE LIMITED",
"EXCLUSIVE INSURANCE BROKING SERVICES LIMITED",
"EXCLUSIVE LEAD ALLOYS PRIVATE LIMITED",
"EXCLUSIVE LINEN FABRIC PRIVATE LIMITED",
"EXCLUSIVE MARMO PRIVATE LIMITED",
"EXCLUSIVE MOTORS PRIVATE LIMITED",
"EXCLUSIVE NETWORKS SALES INDIA PRIVATE LIMITED",
"EXCLUSIVE OR XOR LABS PRIVATE LIMITED",
"EXCLUSIVE SECURITIES LIMITED",
"EXCLUSIVE SOFT SOLUTIONS PRIVATE LIMITED",
"EXCLUSIVE STEEL & CASTING PRIVATE. LIMITED.",
"EXCLUSIVE VISION BROADCAST PRIVATE LIMITED",
"EXCO GRAPHIC INDIA PRIVATE LIMITED",
"EXCOINAGE FOREX PRIVATE LIMITED",
"EXCRIN THINK LABS LLP",
"EXCUTIEVE ENGINEER E G S ( P W ) DN GONDIA",
"EXCUTIVE ENGINEER PHE MAINTAINCE DN 2 INDORE(MUNICIPAL) MADHYA PRADESH",
"EXDION SOLUTIONS PRIVATE LIMITED",
"EXDON TRADING COMPANY LIMITED",
"EXE ENGG P H E ENGINEER DEVISION UJJAIN",
"EXE ENGG P H E MECHENICAL DEVISION UJJAIN",
"EXE ENGG SAMRAT ASHOK SAGAR DIV2 VIDISHA",
"EXE ENGINEER & T A TO S E WESTERN CIRCLE-IIRRIGATIONGOVERNMENT OF WEST BENGAL",
"EXEALA HEALTHCARE INDUSTRIES PRIVATE LIMITED",
"EXECHON PROP. SHIVANI TRUST",
"EXECHUNT INDIA PRIVATE LIMITED",
"EXECUTION-MIH SOLUTIONS PRIVATE LIMITED",
"EXECUTIVE ACCESS INDIA PRIVATE LIMITED",
"EXECUTIVE CENTRE INDIA PRIVATE LIMITED",
"EXECUTIVE ENG NARMADA DEV DIV 23 BHOPAL",
"EXECUTIVE ENG NVDA FIELD DIV BHOPAL",
"EXECUTIVE ENGG P W D KHANDWA",
"EXECUTIVE ENGG RABSL CANAL DIV DISNET",
"EXECUTIVE ENGINEER (GOV)",
"EXECUTIVE ENGINEER BARRABANKI DN SHARADA CANAL BBK GVT",
"EXECUTIVE ENGINEER CAPITAL PROJECT DIVISION GANDHINAGAR",
"EXECUTIVE ENGINEER CGWB BHOPAL",
"EXECUTIVE ENGINEER CHATRAPATI SHIVAJI MAHARAJ SMARAK PROJECT DIVISION",
"EXECUTIVE ENGINEER CONSTRUCTION",
"EXECUTIVE ENGINEER DHULE IRRIGATION DIVISION",
"EXECUTIVE ENGINEER DHULE MEDIUM PROJECT DIVISION DHULE",
"EXECUTIVE ENGINEER EASTERN GANGA CANAL DIVISION",
"EXECUTIVE ENGINEER GIRNA RIVER VALLEY PROJECT DIVISION NASHIK",
"EXECUTIVE ENGINEER HYDROLOGY PROJECT DIVISION KALWA THANE",
"EXECUTIVE ENGINEER HYDROLOGY PROJECT DIVISION NAGPUR",
"EXECUTIVE ENGINEER INTEGRATED UNIT PWD BYCULLA",
"EXECUTIVE ENGINEER IRRIGATION DIVISION IST",
"EXECUTIVE ENGINEER LOWER DIV AGRA CANAL AGRA",
"EXECUTIVE ENGINEER N H DIVISION",
"EXECUTIVE ENGINEER NARMADA PROJECT DN NO 1 PHE BHOPAL",
"EXECUTIVE ENGINEER PANCHAYAT ROAD AND BULDING DIVISION",
"EXECUTIVE ENGINEER PENCH DIV CANAL DN SINGNA",
"EXECUTIVE ENGINEER PROVINCIAL DIVISION PWD BBK",
"EXECUTIVE ENGINEER PUBLIC WORKS DEPARTMENT",
"EXECUTIVE ENGINEER PWD DIVISION",
"EXECUTIVE ENGINEER PWD E AND M DIV UJJAIN MADHYA PRADESH",
"EXECUTIVE ENGINEER R E S DIV LUCKNOW",
"EXECUTIVE ENGINEER R E S KHANDWA",
"EXECUTIVE ENGINEER R P DIVISION YAVATMAL",
"EXECUTIVE ENGINEER SURAT CANAL DIVISON",
"EXECUTIVE ENGINEER TUBEWELL BAREILLY",
"EXECUTIVE ENGINEER TUBEWELL DIVISION",
"EXECUTIVE ENGINEER TUBEWELL DIVISION 1ST AMBALA ROAD MEGH CHAPPAR SHARNAPUR",
"EXECUTIVE ENGINEER U L B C INV",
"EXECUTIVE ENGINEER WATER MANAGEMENT DIVISION N0.1 RAIPUR CG",
"EXECUTIVE ENGINEER WATER RESOUCE BARRAGR",
"EXECUTIVE ENGINEER WATER RESOURCESS DEPARTMENT KORBA DISTT ‚Äì KORBA",
"EXECUTIVE ENGINEER WATER RESOURCESS KHARGONE MADHYA PRADESH",
"EXECUTIVE ENGINEER, NVDA, DIV. NO. 19 BHIKANGAON",
"EXECUTIVE FOREX PRIVATE LIMITED",
"EXECUTIVE FREIGHT SERVICES PRIVATE LIMITED",
"EXECUTIVE GARMENTS PROCESSORS PRIVATE LIMITED",
"EXECUTIVE HOMES PRIVATE LIMITED",
"EXECUTIVE MOVERS PRIVATE LIMITED",
"EXECUTIVE PROTECTION FORCE PRIVATE LIMITED",
"EXECUTIVE SECURITY SERVICE PRIVATE LIMITED",
"EXECUTIVE SHIP MANAGEMENT PRIVATE LIMITED",
"EXECUTIVE SHIP MANANGEMENT PTE LIMITED SINGAPORA",
"EXECUTIVE SHIPPING SERVICES (INDIA) PRIVATE LIMITED",
"EXECUTIVE SOFTWAY GUILD INDIA PRIVATE LIMITED",
"EXECUTIVE TOWER PROPERTIES PRIVATE LIMITED",
"EXECUTIVE TRACKS ASSOCIATES PRIVATE LIMITED",
"EXECUTIVE81 HR SOLUTIONS PRIVATE LIMITED",
"EXECUZEN CONSULTANTS PRIVATE LIMITED",
"EXEDY CLUTCH INDIA PRIVATE LIMITED",
"EXEDY INDIA LIMITED",
"EXEED ENGINEERS INDIA PRIVATE LIMITED",
"EXEGESIS INFOTECH I PRIVATE LIMITED",
"EXEL CHEMICALS (INDIA) PRIVATE LIMITED.",
"EXEL FINISHING PRIVATE LIMITED",
"EXEL TREND PRIVATE LIMITED",
"EXELA TECHNOLOGIES INDIA PRIVATE LIMITED",
"EXELANZ TECHNOLOGY PRIVATE LIMITED",
"EXELINK MANAGEMENT PRIVATE LIMITED",
"EXELITY SKILL TRAINING ACADEMY PRIVATE LIMITED",
"EXELLOR SOFTWARE SOLUTIONS PRIVATE LIMITED",
"EXELON CORPORATION",
"EXELON TECH LIMITED",
"EXEMACHINE INFORMATION TECHNOLOGY PRIVATE LIMITED",
"EXEMPLAR CORPORATE SERVICES PRIVATE LIMITED",
"EXEMPLAR DEALCOM PRIVATE LIMITED",
"EXEMPLAR E SOLUTIONS PRIVATE LIMITED",
"EXEMPLARY TRADING AND AGENCIES LIMITED",
"EXENITY SYSTEMS PRIVATE LIMITED",
"EXEQMODE ANALYTICS PRIVATE LIMITED",
"EXERCISE STRATEGIST PRIVATE LIMITED",
"EXERGY HEATING SOLUTIONS PRIVATE LIMITED",
"EXERTION HR SOLUTIONS PRIVATE LIMITED",
"EXETER METBIZ INDIA PRIVATE LIMITED",
"EXETER PREMEDIA SERVICES PRIVATE LIMITED",
"EXFAQ SYSTEMS PRIVATE LIMITED",
"EXFILE INFOTECH PRIVATE LIMITED",
"EXFIN MARKETING PRIVATE LIMITED",
"EXFINITY TECHNOLOGIES PRIVATE LIMITED",
"EXFO ELECTRO OPTICAL ENGINEERING I PLV LIMITED",
"EXFO SALES & SERVICES (INDIA) PRIVATE LIMITED",
"EXHAUST TECHNOLOGY PRIVATE LIMITED",
"EXHEAT PROCESS HEAT INDIA PRIVATE LIMITED",
"EXHIBIT TECHNOLOGIES PRIVATE LIMITED",
"EXHIBITIONS INDIA PRIVATE LIMITED",
"EXHICON EVENTS MEDIA SOLUTIONS LIMITED",
"EXHICON EVENTS MEDIA SOLUTIONS PRIVATE LIMITED",
"EXHILAR INNOVATIVE SOLUTIONS PRIVATE LIMITED",
"EXICOM TELE-SYSTEMS LIMITED",
"EXICON CONSULTING PRIVATE LIMITED",
"EXICON MEDIA SOLUTIONS PRIVATE LIMITED",
"EXIDE HEALTHCARE PHARMACEUTICALS PRIVATE LIMITED",
"EXIDE INDUSTRIES LIMITED",
"EXIDE LECLANCHE ENERGY PRIVATE LIMITED",
"EXIDE LIFE INSURANCE COMPANY LIMITED",
"EXIGENT GLOBAL LOGISTICS PRIVATE LIMITED",
"EXIGENT SERVICES PRIVATE LIMITED",
"EXIGER TECHNOLOGIES PRIVATE LIMITED",
"EXIGO INTERNATIONAL PRIVATE LIMITED",
"EXIGO RECYCLING PRIVATE LIMITED",
"EXIGOTECH TSP INDIA PRIVATE LIMITED",
"EXILANT TECHNOLOGIES PRIVATE LIMITED",
"EXILE CREATIONS PRIVATE LIMITED",
"EXIM ALERT SOFTWARE SOLUTIONS PRIVATE LIMITED",
"EXIM CONNECT PRIVATE LIMITED",
"EXIM DISTRIBUTORS PRIVATE LIMITED",
"EXIM FREIGHT LINE PRIVATE LIMITED",
"EXIM INFOTEK INDIA PRIVATE LIMITED",
"EXIM INFRASTRUCTURE INDIA PRIVATE LIMITED",
"EXIM KNITS PRIVATE LIMITED",
"EXIM LOGISTICS PRIVATE LIMITED",
"EXIM MULTIMEDIA INDIA PRIVATE LIMITED",
"EXIM OVERSEAS PRIVATE LIMITED",
"EXIM PLANNERS & TRAVELS",
"EXIM ROUTES PRIVATE LIMITED",
"EXIM SCRIPS DEALERS PVT LTD",
"EXIM TRADE SERVICE PRIVATE LIMITED",
"EXIM TRANSTRADE INDIA PRIVATE LIMITED",
"EXIMCAN ENTERPRISES PRIVATE LIMITED",
"EXIMCORP INDIA PRIVATE LIMITED",
"EXIMIIUS AUTOCOMPS PRIVATE LIMITED",
"EXIMIO SERVICES AND SOLUTIONS PRIVATE LIMITED",
"EXIMIOUS GLOBAL PRIVATE LIMITED",
"EXIMIOUS VENTURES PRIVATE LIMITED",
"EXIMIUS BUSINESS SERVICES PRIVATE LIMITED",
"EXIMIUS CAPITAL VENTURES PRIVATE LIMITED",
"EXIMIUS FINANCIAL ADVISORY PRIVATE LIMITED",
"EXIMIUS INNOVATIVE PRIVATE LIMITED",
"EXIMIUS MANAGEMENT PRIVATE LIMITED",
"EXIMIUS PROJECTS PRIVATE LIMITED",
"EXIMIUS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"EXIMP MEASUREMENT PRIVATE LIMITED",
"EXIMPULSE SERVICES PRIVATE LIMITED",
"EXIMSERVE RECKONERS PRIVATE LIMITED",
"EXIMUS WALLPAPER PRIVATE LIMITED",
"EXIN CERTIFICATION INDIA PRIVATE LIMITED",
"EXIN CONSULTANCY LIMITED",
"EXINENT INFO SOLUTIONS PRIVATE LIMITED",
"EXINT SOLUTIONS PRIVATE LIMITED",
"EXION (INDIA) PRIVATE LIMITED",
"EXIT GERMANY (INDIA) PRIVATE LIMITED",
"EXITO MEDIA CONCEPTS PRIVATE LIMITED",
"EXITOLIGHTS ELECTRO PRIVATE LIMITED",
"EXIUM INDIA PRIVATE LIMITED",
"EXIVISION INFOTECH PRIVATE LIMITED",
"EXKLUSIV PAPERS PRIVATE LIMITED",
"EXL SERVICE COM(INDIA) PRIVATE LIMITED",
"EXM PROJECT MOVERS PRIVATE LIMITED",
"EXMA TRADERS PRIVATE LIMITED",
"EXMAN SECURITY SERVICES PRIVATE LIMITED",
"EXMAR SHIPMANAGEMENT INDIA PVT. LTD.",
"EXMARK DISTRIBUTORS PRIVATE LIMITED",
"EXMART INTERNATIONAL PRIVATE LIMITED",
"EXMO BIOGENICS PRIVATE LIMITED",
"EXO EDGE ADVANTAGE INDIA PRIVATE LIMITED",
"EXO EDGE INDIA LLP",
"EXODUS CHEMTANK PRIVATE LIMITED",
"EXODUS FUTURA KNIT PRIVATE LIMITED",
"EXODUS INFORMATION TECHNOLOGY PRIVATE LIMITED",
"EXODUS KNITWEAR PVT LTD",
"EXODUS MARINE COMPANY PRIVATE LIMITED",
"EXODUS OVERSEAS SERVICES PRIVATE LIMITED",
"EXOL CORPORATION LIMITED",
"EXOL INFRASTRUCTURE INDIA LIMITED",
"EXON SOLUTIONS PRIVATE LIMITED",
"EXOR INDIA PRIVATE LIMITED",
"EXORA BUSINESS PARK PRIVATE LIMITED",
"EXORA BUSINESS PARKS PRIVATE LIMITED",
"EXOS IT MANAGEMENT PRIVATE LIMITED",
"EXOT ELEVATOR COMPANY PRIVATE LIMITED",
"EXOTALENT CONSULTANCY SERVICES LLP",
"EXOTECH PLASTICS PRIVATE LIMITED",
"EXOTECH ZANINI INDUSTRIES PRIVATE LIMITED",
"EXOTHERM INSTRUMENTS PRIVATE LIMITED",
"EXOTIC AGRO PRIVATE LIMITED",
"EXOTIC BIOSOLUTIONS PRIVATE LIMITED",
"EXOTIC BUILDCON PRIVATE LIMITED",
"EXOTIC CONTRACTORS PRIVATE LIMITED",
"EXOTIC CUISINES PRIVATE LIMITED",
"EXOTIC DECOR PRIVATE LIMITED",
"EXOTIC EXPORTS PRIVATE LIMITED",
"EXOTIC FABTECH PRIVATE LIMITED",
"EXOTIC FASHIONS PVT LTD",
"EXOTIC FOODWORKS PRIVATE LIMITED",
"EXOTIC FRESH PRODUCE PRIVATE LIMITED",
"EXOTIC FRUITS PRIVATE LIMITED",
"EXOTIC GLOBAL TRADES PRIVATE LIMITED",
"EXOTIC GRANITE LLP",
"EXOTIC GRILLS PRIVATE LIMITED",
"EXOTIC HOSPITALITY (NAGPUR) PRIVATE LIMITED",
"EXOTIC INDIA ART PRIVATE LIMITED",
"EXOTIC INFRAVENTURES PRIVATE LIMITED",
"EXOTIC INNOVATIONS PRIVATE LIMITED",
"EXOTIC INTERIORS PRIVATE LIMITED",
"EXOTIC JOURNEYS PRIVATE LIMITED",
"EXOTIC MILE PRIVATE LIMITED",
"EXOTIC MUSHROOMS PRIVATE LIMITED",
"EXOTICA CERAMICS PRIVATE LIMITED",
"EXOTICA EXPORTS INDIA PRIVATE LIMITED",
"EXOTICA HOLIDAYS PRIVATE LIMITED",
"EXOTICA HOUSING & INFRASTRUCTURE PROJECTS PRIVATE LIMITED",
"EXOTICA HOUSING PRIVATE LIMITED",
"EXOTICA TEXTILES PRIVATE LIMITED",
"EXOTICA VENTURES PRIVATE LIMITED",
"EXOTRON THERMAL PRIVATE LIMITED",
"EXOUSIA DIANOMI INDIA PRIVATE LIMITED",
"EXOUSIA POWER PRIVATE LIMITED",
"EXOWAYS WEB TECHNOLOGIES PRIVATE LIMITED",
"EXOWEAVES RETAIL PRIVATE LIMITED",
"EXP GLOBAL INDIA PRIVATE LIMITED",
"EXPAND SOFTWARE SOLUTIONS PRIVATE LIMITED",
"EXPANDABLE ENTERPRISES PRIVATE LIMITED",
"EXPANDED POLYMER SYSTEMS PRIVATE. LIMITED.",
"EXPANDYS CONSULTING PRIVATE LIMITED",
"EXPANSE ESTATES PRIVATE LIMITED",
"EXPANSE INDIA BUILDCON PRIVATE LIMITED",
"EXPANSIONJS TECHNOLOGIES PRIVATE LIMITED",
"EXPANTURE ELECTRICAL AND AUTOMATION PRIVATE LIMITED",
"EXPAT DIRECTION CONSULTANCY SERVICES PRIVATE LIMITED",
"EXPAT ENGINEERING INDIA LIMITED",
"EXPAT IMMIGRATION SERVICES PRIVATE LIMITED",
"EXPAT PROJECTS AND DEVELOPMENT PRIVATE LIMITED",
"EXPAT PROPERTIES INDIA LIMITED",
"EXPECT MORE BPO SOLUTIONS PRIVATE LIMITED",
"EXPEDIEN E SOLUTIONS LIMITED",
"EXPEDIENT MATERIAL HANDLING INDIA PRIVATE LIMITED",
"EXPEDISE TRAVEL PRIVATE LIMITED",
"EXPEDITE SOFTWARE SERVICES PRIVATE LIMITED",
"EXPEDITION JOURNEYS INDIA PRIVATE LIMITED",
"EXPEDITORS INTERNATIONAL (INDIA) PRIVATE LIMITED",
"EXPEE ENGINEERING PRIVATE LIMITED",
"EXPE-INFO GLOBAL SOLUTIONS PRIVATE LIMITED",
"EXPEL PHARMA PRIVATE LIMITED",
"EXPEL PROSYS PRIVATE LIMITED",
"EXPENSEANYWHERE TECHNOLOGIES PRIVATE LIMITED",
"EXPER EXECUTIVE EDUCATION PRIVATE LIMITED",
"EXPERDEL SOFTWARE AND CONSULTING SERVICES PRIVATE LIMITED",
"EXPERIA HOMES PRIVATE LIMITED",
"EXPERIA MARKETING SOLUTIONS PRIVATE LIMITED",
"EXPERIAN CREDIT INFORMATION COMPANY OF INDIA PRIVATE LIMITED",
"EXPERIAN SERVICES INDIA PRIVATE LIMITED",
"EXPERIAN TECHNICAL SERVICES PRIVATE LIMITED",
"EXPERIENCE (INDIA) TOURS AND TRAVELS PRIVATE LIMITED",
"EXPERIENCE ANDAMANS TOURS PRIVATE LIMITED",
"EXPERIENCE BOX 21 MEDIA SOLUTIONS PRIVATE LIMITED",
"EXPERIENCE COMMERCE SOFTWARE PRIVATE LIMITED",
"EXPERIENCE FACTORY PRIVATE LIMITED",
"EXPERIENCE GLOBAL MOBILE TECHNOLOGIES PRIVATE LIMITED",
"EXPERIENCE INVESTMENT & FINANCE PRIVATE LIMITED",
"EXPERIENCE PLATFORM PRIVATE LIMITED",
"EXPERIENCE PROJECTS PRIVATE LIMITED",
"EXPERIENCEFLOW SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"EXPERIENCES.DIGITAL PRIVATE LIMITED",
"EXPERIENTIAL HUB PRIVATE LIMITED",
"EXPERIENTIAL TRAVEL JOURNEYS PRIVATE LIMITED",
"EXPERIFUN EDUCATIONAL SOLUTIONS PRIVATE LIMITED",
"EXPERIO TECH PRIVATE LIMITED",
"EXPERIOM (INDIA) PRIVATE LIMITED",
"EXPERION CAPITAL PRIVATE LIMITED",
"EXPERION DEVELOPERS PRIVATE LIMITED",
"EXPERION HOSPITALITY PRIVATE LIMITED",
"EXPERION TECHNOLOGIES INDIA PRIVATE LIMITED",
"EXPERIS IT PRIVATE LIMITED",
"EXPERT AIRCON PRIVATE LIMITED",
"EXPERT AVIATION PRIVATE LIMITED",
"EXPERT BIO-.PRODUCTS PRIVATE LIMITED",
"EXPERT CAPITAL SERVICES PRIVATE LIMITED",
"EXPERT CNG SOLUTIONS PRIVATE LIMITED",
"EXPERT CREDIT AND HOLDINGS PRIVATE LIMITED",
"EXPERT DE TOURS PRIVATE LIMITED",
"EXPERT EDUFRONT PRIVATE LIMITED",
"EXPERT ENGINEERS INDIA PRIVATE LIMITED",
"EXPERT FACILITY",
"EXPERT GENETICS PRIVATE LIMITED",
"EXPERT GLOBAL CONSULTANTS PRIVATE LIMITED",
"EXPERT GLOBAL CORPORATE ADVISORS PRIVATE LIMITED",
"EXPERT GLOBAL SOLUTIONS PRIVATE LIMITED",
"EXPERT GLOBAL VENTURES PRIVATE LIMITED",
"EXPERT HEALTHCARE & DIAGNOSTICS PRIVATE LIMITED",
"EXPERT IMMIGRATION SERVICES PRIVATE LIMITED",
"EXPERT INDUSTRIAL SECURITY PRIVATE LIMITED",
"EXPERT INDUSTRIES PRIVATE LIMITED",
"EXPERT INFOTECH (INDIA) PRIVATE LIMITED",
"EXPERT INSTRUMENTS PRIVATE LIMITED",
"EXPERT LOGISTICS INDIA PRIVATE LIMITED",
"EXPERT METALTECH PRIVATE LIMITED",
"EXPERT PARKING SYSTEMS PRIVATE LIMITED",
"EXPERT PHARMACEUTICALS PRIVATE LIMITED",
"EXPERT PRE-UNIVERSITY COLLEGE",
"EXPERT PROFESSIONAL ACADEMY PRIVATE LIMITED",
"EXPERT PUBLICITY PRIVATE LIMITED",
"EXPERT REALTORS PRIVATE LIMITED",
"EXPERT REALTY PROFESSIONALS PRIVATE LIMITED",
"EXPERT SALES AND CONTRACT SERVICES PRIVATE LIMITED",
"EXPERT SEEDS PRIVATE LIMITED",
"EXPERT SKILL DEVELOPMENT PRIVATE LIMITED",
"EXPERT SOLUTION",
"EXPERT TIME INDUSTRIES PRIVATE LIMITED",
"EXPERT VALUE PACK LLP",
"EXPERT VALVE AND EQUIPMENT PRIVATE LIMITED",
"EXPERT VISION LABS PRIVATE LIMITED",
"EXPERT WEB WORX PRIVATE LIMITED",
"EXPERTCALLERS SOLUTIONS PRIVATE LIMITED",
"EXPERTCONNECT GLOBAL RESEARCH PRIVATE LIMITED",
"EXPERTISE CREST PRIVATE LIMITED",
"EXPERTPRO REALTY PRIVATE LIMITED",
"EXPERTRONS TECHNOLOGIES PRIVATE LIMITED",
"EXPERTS MIND IT EDUCATIONAL PRIVATE LIMITED",
"EXPERTSOURCE GLOBAL SERVICES PRIVATE LIMITED",
"EXPERTZON IT SOLUTIONS PRIVATE LIMITED",
"EXPIAN TECHNOLOGIES PRIVATE LIMITED",
"EXPICIENT SOFTWARE PRIVATE LIMITED",
"EXPICO ENGINEERING PRIVATE LIMITED",
"EXPLARITY SOLUTIONS PRIVATE LIMITED",
"EXPLEO INDIA INFOSYSTEMS PRIVATE LIMITED",
"EXPLEO SOLUTIONS LIMITED",
"EXPLEO TECHNOLOGIES INDIA PRIVATE LIMITED",
"EXPLICIT CHEMICALS PRIVATE LIMITED",
"EXPLICIT LEATHERS",
"EXPLICIT LOGISTICS INDIA PRIVATE LIMITED",
"EXPLODESIGN GARMENT EXPORTS PRIVATE LIMITED",
"EXPLOFAB METALS INDIA PRIVATE LIMITED",
"EXPLORA INFOTECH LIMITED",
"EXPLORE ENERGIES SOLUTIONS PRIVATE LIMITED",
"EXPLORE ENGINEERING CONSULTANTS PRIVATE LIMITED",
"EXPLORE INDIA HOTELS AND RESORTS PRIVATE LIMITED",
"EXPLORE INDIA TOURISM PRIVATE LIMITED",
"EXPLORE INDIAN VACATIONS PRIVATE LIMITED",
"EXPLORE INTERNATIONAL SCHOOL",
"EXPLORE MARKETING & SALES INDIA PRIVATE LIMITED",
"EXPLORE SYNERGY SYNOCARE PRIVATE LIMITED",
"EXPLORE TRAVELMILES PRIVATE LIMITED",
"EXPLORE WATEK SYSTEMS PRIVATE LIMITED",
"EXPLORER ASSOCIATES PRIVATE LIMITED",
"EXPLORER MEDIA NETWORK PRIVATE LIMITED",
"EXPLORER TRAVELS",
"EXPLORERS MARKETING PVT LTD",
"EXPLOREX TECHNOLOGIES PRIVATE LIMITED",
"EXPLORIDES ENTERPRISES PRIVATE LIMITED",
"EXPLOR-INDIA MARKETING PRIVATE LIMITED",
"EXPLOSHAKTI CHEMICALS PRIVATE LIMITED",
"EXPLOSOFT TECH SOLUTIONS PRIVATE LIMITED",
"EXPO FORGINGS PRIVATE LIMITED",
"EXPO FREIGHT PRIVATE LIMITED",
"EXPO GAS CONTAINERS LIMITED",
"EXPO GLOVES PRIVATE LIMITED",
"EXPO MACHINE TOOLS PRIVATE LIMITED",
"EXPO MEDIA DEVELOPERS PRIVATE LIMITED",
"EXPO PROJECT ENGINEERING SERVICES PRIVATE LIMITED",
"EXPO SALES INDIA PRIVATE LIMITED",
"EXPO THERMOCONTROLS PRIVATE LIMITED",
"EXPO TRANS INDIA LIMITED",
"EXPOBIZ IT SOLUTIONS OPC PRIVATE LIMITED",
"EXPOCITY TRAVELS PRIVATE LIMITED",
"EXPODE INNOVATIONS PRIVATE LIMITED",
"EXPONENTIA DATALABS PRIVATE LIMITED",
"EXPONENTIAL AI SOFTWARE PRIVATE LIMITED",
"EXPONENTIAL DIGITAL SOLUTIONS PRIVATE LIMITED",
"EXPONENTIAL ENGINEERING PRIVATE LIMITED",
"EXPONENTIAL INTERACTIVE INDIA PRIVATE LIMITED",
"EXPONENTIAL PUBLIC SCHOOL",
"EXPONIQ ENGINEERING SERVICES PRIVATE LIMITED",
"EXPONUS EVENTS PRIVATE LIMITED",
"EXPONUS PAPERS PRIVATE LIMITED",
"EXPORA DATABASE CONSULTING SERVICES PRIVATE LIMITED",
"EXPORT GENIUS PRIVATE LIMITED",
"EXPORT IMPORT BANK OF INDIA",
"EXPORT INDIA CORPORATION PRIVATE LIMITED",
"EXPORT PROMOTION COUNCIL FOR HANDICRAFTS",
"EXPORT-IMPORT BANK OF INDIA",
"EXPOSURE MEDIA MARKETING PRIVATE LIMITED",
"EXPOTEC INTERNATIONAL PRIVATE LIMITED",
"EXPOTRADE CORPORATION",
"EXPOUND TECHNIVO PRIVATE LIMITED",
"EXPOVISION T&M PRIVATE LIMITED",
"EXPRESOLV LIMITED",
"EXPRESS ADLINE PRIVATE LIMITED",
"EXPRESS BPO SERVICES PRIVATE LIMITED",
"EXPRESS BUILDERS AND PROMOTERS PRIVATE LIMITED",
"EXPRESS CARGO CARRIERS PRIVATE LIMITED",
"EXPRESS CARGO LOGISTICS PRIVATE LIMITED",
"EXPRESS CLINICS PRIVATE LIMITED",
"EXPRESS COLOUR SCAN PRIVATE LIMITED",
"EXPRESS CONFECTIONERS PRIVATE LIMITED",
"EXPRESS DAILYCARE SERVICES PRIVATE LIMITED",
"EXPRESS ELECTRO ELEVATORS CO",
"EXPRESS ELEVATORS PRIVATE LIMITED",
"EXPRESS ENGINEERING CONSTRUCTION PRIVATE LIMITED",
"EXPRESS ENGINEERS AND SPARES PRIVATE LIMITED",
"EXPRESS EQUIPMENT RENTAL & LOGISTICS PRIVATE LIMITED",
"EXPRESS FACILITY PRIVATE LIMITED",
"EXPRESS FOODS PRIVATE LIMITED",
"EXPRESS FREIGHT SYSTEM INDIA PRIVATE LIMITED",
"EXPRESS FRESHFOOD PRIVATE LIMITED",
"EXPRESS GENSETS CONSORTIUM PRIVATE LIMITED",
"EXPRESS GLOBAL LOGISTICS PRIVATE LIMITED",
"EXPRESS HOSPITALITY & FACILITY MANAGEMENT SERVICE",
"EXPRESS HOTELS PRIVATE LIMITED",
"EXPRESS HOUSEKEEPER PRIVATE LIMITED",
"EXPRESS INDUSTRY COUNCIL OF INDIA",
"EXPRESS INFOCOM PRIVATE LIMITED",
"EXPRESS INFRA FINANCIAL CONSULTANCY PRIVATE LIMITED",
"EXPRESS INFRASTRUCTURE PRIVATE LIMITED",
"E-XPRESS INTERACTIVE SOFTWARE PRIVATE LIMITED",
"EXPRESS KARGO FORWARDERS PRIVATE LIMITED",
"EXPRESS KITCHEN PRIVATE LIMITED",
"EXPRESS KNOWLEDGE COMMUNICATION SOLUTIONS PRIVATE LIMITED",
"FUJITEC EXPRESS LIMITED",
"EXPRESS LOGISTICS AND TRADE PRIVATE LIMITED",
"EXPRESS LORRYVALA HAUL LLP",
"EXPRESS MACHINES AND SCAFFOLDING PRIVATE LIMITED",
"EXPRESS MARKETING PRIVATE LIMITED",
"EXPRESS MONEY FINANCIAL SERVICES PRIVATE LIMITED",
"EXPRESS NETWORK PRIVATE LIMITED",
"EXPRESS NEWSPAPERS PRIVATE LIMITED",
"EXPRESS OCEAN TERMINAL SERVICES PRIVATE LIMITED",
"EXPRESS ONE CREDIT CONSULTANTS PRIVATE LIMITED",
"EXPRESS PARCEL SERVICES PRIVATE LIMITED",
"EXPRESS PESTICIDES PRIVATE LIMITED",
"EXPRESS PROJECTS PRIVATE LIMITED",
"EXPRESS PUBLICATIONS MADURAI PRIVATE LIMITED",
"EXPRESS RESORTS AND HOTELS LIMITED",
"EXPRESS RETAIL SERVICES PRIVATE LIMITED",
"EXPRESS ROADMOVERS PRIVATE LIMITED",
"EXPRESS ROADWAYS PRIVATE LIMITED",
"EXPRESS SEAWAYS LOGISTICS PRIVATE LIMITED",
"EXPRESS SECURITIES PRIVATE LIMITED",
"EXPRESS SHARES AND CAPITAL PRIVATE LIMITED",
"EXPRESS SPICE PRIVATE LIMITED",
"EXPRESS TOLL ROADS LIMITED",
"EXPRESS TOWERS PRIVATE LIMITED",
"EXPRESS TRADECOM PRIVATE LIMITED",
"EXPRESS TRAVSHIP SERVICES PRIVATE LIMITED",
"EXPRESS VYAPAAR PRIVATE LIMITED",
"EXPRESS WAREHOUSING LIMITED",
"EXPRESS WAY TRUCK TERMINUS PRIVATE LIMITED",
"EXPRESSION 360 SERVICES INDIA PRIVATE LIMITED",
"EXPRESSION BUILDTECH PRIVATE LIMITED",
"EXPRESSION NOVELTIES PRIVATE LIMITED",
"EXPRESSION OF INDIA",
"EXPRESSIONS ARTS AND CRAFTS PRIVATE LIMITED",
"EXPRESSRCM PRIVATE LIMITED",
"EXPRESSSTORES INFO RETAIL PRIVATE LIMITED",
"EXPRESSWAY CARGO MOVERS PRIVATE LIMITED",
"EXPRESSWAY CONTAINER LINE LLP",
"EXPRESSWAY LOGISTIC PRIVATE LIMITED",
"EXPRESSWAY SERVICES PRIVATE LIMITED",
"EXPREZY LOGISTICS PRIVATE LIMITED",
"EXPRO INFORMATICS INDIA PRIVATE LIMITED",
"EXPRO NORTH SEA LIMITED",
"EXQUIRO LOGIX PRIVATE LIMITED",
"EXQUISITE COLOR KRAFT PRIVATE LIMITED",
"EXQUISITE ENTERPRISES PRIVATE LIMITED",
"EXQUISITE PACKAGING PRIVATE LIMITED",
"EXQUISITE PRINT AND PACK PRIVATE LIMITED",
"EXSELL LABORATORIES PRIVATE LIMITED",
"EXSILIO CONSULTING INDIA PRIVATE LIMITED",
"EXSIVA PHARMA PRIVATE LIMITED",
"EXSOL ENERGY SYSTEMS PRIVATE LIMITED",
"EXTARC SOFTWARE SOLUTIONS PRIVATE LIMITED.",
"EXTEND FUTURE SOLUTIONS PRIVATE LIMITED",
"EXTENDED VENTIV RISK SERVICES PRIVATE LIMITED",
"EXTENDED WARRANTY INDIA PRIVATE LIMITED",
"EXTENDED WEB APPTECH LLP",
"EXTENDEDITARMS SOLUTIONS PRIVATE LIMITED",
"EXTENSIBLE IT SOLUTION PRIVATE LIMITED",
"EXTENSION FOR COMMUNITY HEALTHCARE OUTCOMES",
"EXTENSIVE HOST PRIVATE LIMITED",
"EXTENT RETAIL PRIVATE LIMITED",
"EXTENT SERVICES PRIVATE LIMITED",
"EXTENTIA INFORMATION TECHNOLOGY PRIVATE LIMITED",
"EXTENTO EVENTS PRIVATE LIMITED",
"EXTERNETWORKS (INDIA) PRIVATE LIMITED\n",
"EXTERPRISE SERVICES",
"EXTERRAN ENERGY SOLUTIONS INDIA PRIVATE LIMITED",
"EXTERRO R AND D PRIVATE LIMITED",
"EXTEX TEXTILES PRIVATE LIMITED",
"EXTINCT FIRE ENGINEERS PRIVATE LIMITED",
"EXTO PROJECT SOLUTIONS PRIVATE LIMITED",
"EXTOL INFRACON INDIA PRIVATE LIMITED",
"EXTOL TECHNOLOGIES PRIVATE LIMITED",
"EXTRA COLD STORAGE PRIVATE LIMITED",
"EXTRA COVER INSURANCE BROKERS PRIVATE LIMITED",
"EXTRAAEDGE TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"EXTRAAN REALTY (INDIA) PRIVATE LIMITED",
"EXTRACO COMPOSITES INDIA PRIVATE LIMITED",
"EXTRAEDGE MULTISERVICES PRIVATE LIMITED",
"EXTRAMILE ENGAGEMENT PRIVATE LIMITED",
"EXTRANET SOFTWARE SOLUTIONS PRIVATE LIMITED",
"EXTRANET SUPPORTS PRIVATE LIMITED",
"EXTRAPAISA INFOTECH PRIVATE LIMITED",
"EXTRAPRENEURS INDIA PRIVATE LIMITED",
"EXTRATECH INDIA AUTOMATION PRIVATE LIMITED",
"EXTRAWEAVE PRIVATE LIMITED",
"EXTREME AGILE PRIVATE LIMITED",
"EXTREME COMPUTE TECHNOLOGIES PRIVATE LIMITED",
"EXTREME FEEDSCREW COATINGS PRIVATELIMITED",
"EXTREME INNOVATIONS TECHNOSYS INDIA PRIVATE LIMITED",
"EXTREME MOTORS LLP",
"EXTREME NETWORKS INDIA PRIVATE LIMITED",
"EXTREMUS EPC PRIVATE LIMITED (OPC)",
"EXTRIEVE TECHNOLOGIES PRIVATE LIMITED",
"EXTRON ELECTRONICS PRIVATE LIMITED",
"EXTROVERT INFORMATION TECHNOLOGY PRIVATE LIMITED",
"EXTROVIS PRIVATE LIMITED",
"EXTRUDE HONE INDIA PRIVATE LIMITED",
"EXTRUSION PROCESSES PRIVATE LIMITED",
"EXUBERO SEALING TECHNOLOGY PRIVATE LIMITED",
"EXULT AGENCY PRIVATE LIMITED UNIT: JOY ELECTRONICS",
"EXULT IT SERVICES PRIVATE LIMITED",
"EXULT LOGISTICS PRIVATE LIMITED",
"EXULT REALTY PRIVATE LIMITED",
"EXULTSOFT TECHNOLOGIES PRIVATE LIMITED",
"EXUN BIOCELL PRIVATE LIMITED",
"EXUSIA INDIA PRIVATE LIMITED",
"EXWAY MICRO CREDIT PRIVATE LIMITED",
"EXXARO TILES LIMITED",
"EXXAT SYSTEMS PRIVATE LIMITED",
"EXXELO EXIM PRIVATE LIMITED",
"EXXONMOBIL COMPANY INDIA PRIVATE LIMITED",
"EXXONMOBIL GAS (INDIA) PRIVATE LIMITED",
"EXXONMOBIL LUBRICANTS PRIVATE LIMITED",
"EXXONMOBIL SERVICES & TECHNOLOGY PRIVATE LIMITED",
"EXYTE SOLUTIONS PRIVATE LIMITED",
"EXZA CHEMICAL PRIVATE LIMITED",
"EXZAKTA MECCANICA LIMITED",
"EXZATECH CONSULTING AND SERVICES PRIVATE LIMITED",
"EXZEO SOFTWARE PRIVATE LIMITED",
"EXZOD INDIA PRIVATE LIMITED",
"EY ACTUARIAL SERVICES LLP",
"EY GLOBAL DELIVERY SERVICES INDIA LLP",
"EY GLOBAL DELIVERY SERVICES INDIA PRIVATE LIMITED",
"EY RESTRUCTURING LLP",
"EYAL COMMODEAL PRIVATE LIMITED",
"EYANTRA INDUSTRIES PRIVATE LIMITED",
"EYANTRA VENTURES LIMITED",
"EYE 4 MEDIA PRIVATE LIMITED",
"EYE 7 HOSPITALS PRIVATE LIMITED",
"EYE AUTOMOBILES PRIVATE LIMITED",
"EYE CANDY VISUALS PRIVATE LIMITED",
"EYE CARE HOSPITAL PRIVATE LIMITED",
"EYE FOCUS PRODUCTIONS PRIVATE LIMITED",
"EYE FOUNDATION LIMITED",
"EYE OPENER",
"EYEBALL PROMOTIONS PRIVATE LIMITED",
"EYECON ANIMATION PRIVATE LIMITED",
"EYECON DESIGN PRIVATE LIMITED",
"EYECONIC MEDIA PRODUCTION PRIVATE LIMITED",
"EYEDEA SOLUTIONS PRIVATE LIMITED",
"EYEDEAL PHARMA PRIVATE LIMITED",
"EYEDENTIFY SYSTEMS PRIVATE LIMITED",
"EYEDOT MEDISOLUTIONS PRIVATE LIMITED",
"EYEFOCUS TECHNOLOGY PRIVATE LIMITED",
"EYEGLOBAL SOLUTIONS PRIVATE LIMITED",
"EYEGLOBAL TECHNOLOGIES PRIVATE LIMITED",
"EYEPLAYER FASHION ACCESSORIES PRIVATE LIMITED",
"EYEQ TECHNOLOGIES PRIVATE LIMITED",
"EYE-Q VISION PRIVATE LIMITED",
"EYEQUBE STUDIOS PRIVATE LIMITED",
"EYESDEAL EYEWEAR PRIVATE LIMITED",
"EYESKAPE MEDICALS PRIVATE LIMITED",
"EYESLINE TELEMATICS PRIVATE LIMITED",
"EYETALK MEDIA COMMUNICATION PRIVATE LIMITED",
"EYEVAM OPTICIANS PRIVATE LIMITED",
"EYEVET CLINICS PRIVATE LIMITED",
"EYEVIEW MULTINATIONAL PRIVATE LIMITED",
"EYEVIZ DIGITAL SOLUTIONS (INDIA) PRIVATE LIMITED",
"EYEWAY ECOMMERCE PRIVATE LIMITED",
"EYEWEARLABS INNOVATIONS PRIVATE LIMITED",
"EYGBS INDIA LLP",
"EYLEX FILMS PRIVATE LIMITED",
"EYN EXPORTS PRIVATE LIMITED",
"EYNOS BUSINESS SOLUTIONS PRIVATE LIMITED",
"EYOTA ENGINEERING PRIVATE LIMITED",
"EYP CREATIONS PRIVATE LIMITED",
"EYSYS PHARMACEUTICAL PRIVATE LIMITED",
"EYTAN LABS LIMITED",
"EYTE TECHNOLOGIES PRIVATE LIMITED",
"EYVO SOFTWARES INDIA PRIVATE LIMITED",
"EYWA PHARMA PRIVATE LIMITED",
"EYWA SOLUTIONS PRIVATE LIMITED",
"EYYANI ELECTRIC MACHINES PRIVATE LIMITED",
"EZ- ENGINEERS PRIVATE LIMITED",
"EZ LAB PRIVATE LIMITED",
"EZ LIFE RETAIL PRIVATE LIMITED",
"EZ RANKING IT SERVICES PRIVATE LIMITED",
"EZ XBRL SOLUTIONS PRIVATE LIMITED",
"EZBEEZ SOLUTIONS PRIVATE LIMITED",
"EZCRED TECHNOLOGIES PRIVATE LIMITED",
"EZDATA MUNCH PRIVATE LIMITED",
"EZDEBT CREDIT SERVICES PRIVATE LIMITED",
"EZE CASTLE INTEGRATION INDIA PRIVATE LIMITED",
"EZEE FLIGHT TRAVEL PRIVATE LIMITED.",
"EZEE FLY SOLUTIONS PRIVATE LIMITED",
"EZEE NURSING SOLUTION PRIVATE LIMITED",
"EZEE PAY SERVICES PRIVATE LIMITED",
"EZEE TECHNOSYS PRIVATE LIMITED",
"EZEEBEE OVERSEAS PRIVATE LIMITED",
"EZEEFIT MODULAR FURNITURE PRIVATE LIMITED",
"EZEEFLEX PLASTICS PRIVATE LIMITED",
"EZEEINFO CLOUD SOLUTIONS PRIVATE LIMITED",
"EZEEROOMS ACCOMODATION PRIVATE LIMITED",
"EZEEWELL LIFESCIENCE PRIVATE LIMITED",
"EZEIATECH SYSTEMS PRIVATE LIMITED",
"EZEMRX INDIA PRIVATE LIMITED",
"EZEN COMPUTER SERVICES PRIVATE LIMITED",
"EZENTECH INDIA PRIVATE LIMITED",
"EZERX HEALTH TECH PRIVATE LIMITED",
"EZESOFTWARE INDIA PRIVATE LIMITED",
"EZETAP MOBILE SOLUTIONS PRIVATE LIMITED",
"EZGROW PLANTS PRIVATE LIMITED",
"EZHIL AGENCIES PRIVATE LIMITED",
"EZHOMZ SOLUTIONS PRIVATE LIMITED",
"EZI DRIVE TOURS AND TRAVELS PRIVATE LIMITED",
"EZIMAX TECHNOLOGIES PRIVATE LIMITED",
"EZIT CONNECT INDIA PRIVATE LIMITED",
"EZ-MALL ONLINE LIMITED",
"EZON ENERGY SOLUTIONS PRIVATE LIMITED",
"EZONE SECURITY SOLUTIONS I PRIVATE. LIMITED.",
"EZOPS TECHNOLOGIES INDIA PRIVATE LIMITED",
"EZPZ SOLUTIONS INDIA PRIVATE LIMITED",
"EZSWYPE BUSINESS SOLUTIONS PRIVATE LIMITED",
"EZULIX SOFTWARE PRIVATE LIMITED",
"EZYDRILL EQUIPMENT PRIVATE LIMITED",
"EZYLOAD NETWORK PRIVATE LIMITED",
"EZYLOADS LOGISTICS PRIVATE LIMITED",
"EZYPAY ONLINE SERVICES PRIVATE LIMITED",
"EZYTEK CLEAN PRIVATE LIMITED",
"EZYTEK CONSULTING PRIVATE LIMITED",
"EZZY BIO SCIENCES PRIVATE LIMITED",
"F & C AUDIT OFFICE JAIPUR",
"F & F ENTERPRISES PRIVATE LIMITED",
"F & R DATA ANALYTICAL SYSTEM AND SOLUTIONS PRIVATE LIMITED",
"F & S HOTELS PRIVATE LIMITED",
"F A SYSTEMS PRIVATE LIMITED",
"F AND F GLOBAL PRIVATE LIMITED",
"F AND K AGRO PRIVATE LIMITED",
"F B AXLES PRIVATE LIMITED",
"F C WHITTEN AND COMPANY ENTERPRISES PRIVATE LIMITED",
"F D ARTS COLLEGE FOR WOMEN",
"F D HIGH SCHOOL FOR GIRLS JAMALPUR",
"F E INDUSTRIES PRIVATE LIMITED",
"F F V SERVICES PRIVATE LIMITED",
"F G T EXIM PRIVATE LIMITED",
"F HARLEY & COMPANY PVT LTD",
"F I HOME PRIVATE LIMITED",
"F I PRECISION COMPONENTS PRIVATE LIMITED",
"F J RUBBER PRODUCTS PRIVATE LIMITED",
"F K BAGASRAWALA EXPORTS PRIVATE LIMITED",
"F L B ENGINEERS PRIVATE LIMITED",
"F L LOGISTICS PRIVATE LIMITED",
"F M COSMETICS INDIA LLP",
"F M HAMMERLE TEXTILES LIMITED",
"F M T ENGINEERS PRIVATE LIMITED",
"F M TEXTILES PRIVATE LIMITED",
"F N Z JEWELS PRIVATE LIMITED",
"F PUDUMJEE INVESTMENT COMPANY PRIVATE LIMITED",
"F R ISLAMIA INTER COLLEGE",
"F R RATNAGAR AND COMPANY PRIVATE LIMITED",
"F ROBIN POLYMERS PRIVATE LIMITED",
"F S CHEMICALS PRIVATE LIMITED",
"F S MULTISPECIALITY HOSPITAL",
"F T TEXTILES PRIVATE LIMITED",
"F TCONSUMER PRODUCTS INDIA PRIVATE LIMITED",
"F&C AUDIT OFFICE KOLKATA",
"F&F GLOBAL PRIVATE LIMITED",
"F&S",
"F(X) DATA LABS PRIVATE LIMITED",
"F. M. J. SAREES PRIVATE LIMITED",
"F.A CONSTRUCTION PRIVATE.LIMITED",
"F.N.CONSTRUCTION PVT.LTD.",
"F.R.ENTERPRISES PRIVATE LIMITED",
"F.T. SOLUTIONS PRIVATE LIMITED",
"F/X WIRELESS TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"F1 INFO SOLUTIONS & SERVICES PRIVATE LIMITED",
"F-1 INFOTECH PRIVATE LIMITED",
"F1CIRCLE DESIGNS PRIVATE LIMITED",
"F1F9 INDIA PRIVATE LIMITED",
"F2 FUN AND FITNESS INDIA PRIVATE LIMITED",
"F2 FUNDS PRIVATE LIMITED",
"F2I NUTRITION AND HEALTH PRIVATE LIMITED",
"F2R BUSINESS PRIVATE LIMITED",
"F3 CORPORATE HOSPITALITY SERVICES PRIVATE LIMITED",
"F3 FIRST FRAME FILMS PRIVATE LIMITED",
"F360 FACILITY SERVICES PRIVATE LIMITED",
"F-365 AGRO PRIVATE LIMITED",
"F4 INDUSTRIAL AND PIPELINE ENGINEERS INDIA PRIVATE LIMITED",
"F5 NETWORKS INDIA PRIVATE LIMITED",
"F5 NETWORKS INNOVATION PRIVATE LIMITED",
"F5 TECHNO SOLUTIONS PRIVATE LIMITED",
"F7 BROADCAST PRIVATE LIMITED",
"FA CAPITAL MANAGEMENT PRIVATE LIMITED",
"FA EVENTS AND MEDIA PRIVATE LIMITED",
"FA GIFTS PRIVATE LIMITED",
"FA PREMIUM INSURANCE BROKING PRIVATE LIMITED",
"FA SOFTWARE SERVICES PRIVATE LIMITED",
"FA WIZARD PRIVATE LIMITED",
"FAALCON CONCEPTS LIMITED",
"FAAR BETTER FILMS",
"FAAT CITY TECH PRIVATE LIMITED",
"FAAZ AGRICULTURE PRIVATE LIMITED",
"FAAZ ELECTRICAL PRIVATE LIMITED",
"FAB ANALYTICS PRIVATE LIMITED",
"FAB CARS PRIVATE LIMITED",
"FAB CHEMICALS PVT LTD",
"FAB CONSULTANTS AND ENGINEERS PRIVATE LTD",
"FAB DAIRY AND TRADING (INDIA) PRIVATE LIMITED",
"FAB DEZINE ATELIER PRIVATE LIMITED",
"FAB ELECTRONIC ENGINEERS PVT LTD",
"FAB ENERGY SOLUTIONS PRIVATE LIMITED",
"FAB FURNISHERS PRIVATE LIMITED",
"FAB GLOBAL BUSINESS SERVICES PRIVATE LIMITED",
"FAB HOMES PRIVATE LIMITED",
"FAB HOTELS PRIVATE LIMITED",
"FAB ICON FACADE SYSTEMS PRIVATE LIMITED",
"FAB INDIA",
"FAB INDUSTRIES GLOVES OF INDIA PRIVATE LIMITED",
"FAB INDUSTRIES PRIVATE LIMITED",
"FAB INFOTECH PRIVATE LIMITED",
"FAB MONDIAL PRIVATE LIMITED",
"FAB PHARMACEUTICALS PRIVATE LIMITED",
"FAB STUDIO DIGITAL LLP",
"FAB TECH WORKS & CONSTRUCTIONS PRIVATE LIMITED",
"FAB TEXERE INDIA PRIVATE LIMITED",
"FAB TRADE PRIVATE LIMITED",
"FAB-5 MERCHANDISE COMPANY LIMITED",
"FABA ECO FORCE ENERGY SOLUTIONS PRIVATE LIMITED",
"FABALL FITNESS PRIVATE LIMITED",
"FABARON SUCROTECH PRIVATE LIMITED",
"FABCAFE FOODS PRIVATE LIMITED",
"FABCARE (INDIA) PRIVATE LIMITED",
"FABCO FASHIONOLOGY PRIVATE LIMITED",
"FABCON AGRO OILS PRIVATE LIMITED",
"FABCOTT TEXTILES PRIVATE LIMITED",
"FABCURATE PRIVATE LIMITED",
"FABEL SERVICES PRIVATE LIMITED",
"FABEN INDIA PRIVATE LIMITED",
"FABER CAPITAL PRIVATE LIMITED",
"FABER CASTELL INDIA PRIVATE LIMITED",
"FABEX FABRICS PRIVATE LIMITED",
"FABEX STEEL STRUCTURES PRIVATE LIMITED",
"FABFACT HEAVY ENGINEERING PRIVATE LIMITED",
"FABFIT APPARELS INDIA PRIVATE LIMITED",
"FABIANO APPLIANCES PRIVATE LIMITED",
"FABINDIA LIMITED",
"FABINDIA OVERSEAS PRIVATE LIMITED",
"FABINO LIFE SCIENCES LIMITED",
"FABIO GREENS PRIVATE LIMITED",
"FABIO NETWORKS PRIVATE LIMITED",
"FABIONIX (INDIA) PRIVATE LIMITED",
"FABIRON ENGINEERS PRIVATE LIMITED",
"FABJEWELS PRIVATE LIMITED",
"FABKING SOLUTIONS PRIVATE LIMITED",
"FABLAS IMPEX PRIVATE LIMITED",
"FABLE FOOD PRODUCTS PRIVATE. LIMITED.",
"FABLED MINDS- MICE & EVENTS PRIVATE LIMITED",
"FABLIFE PROCESS TECHNOLOGIES LLP",
"FABLINO TEXTILE PRIVATE LIMITED",
"FABLON SYSTEMS PRIVATE LIMITED",
"FABLOOK INTERNATIONAL PRIVATE LIMITED",
"FABMART CREATIONS PRIVATE LIMITED",
"FABMAX PIPE FABRICATION MACHINES PRIVATE LIMITED",
"FABON ENGINEERING PRIVATE LIMITED",
"FABONEST FOOD & BEVERAGES PRIVATE LIMITED",
"FABPANDA PRIVATE LIMITED",
"FABQUEST INDUSTRIAL TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"FABREKO ENGINEERING PRIVATE LIMITED",
"FABREKO INDUSTRIES PRIVATE LIMITED",
"FABRIC CONSULTANCY SERVICES PRIVATE LIMITED",
"FABRIC MONDE MARKETING PRIVATE LIMITED",
"FABRIC PANDIT PRIVATE LIMITED",
"FABRIC PLUS PVT LTD",
"FABRICASTO PRIVATE LIMITED",
"FABRICH OVERSEAS PRIVATE LIMITED",
"FABRICLORE RETAIL PRIVATE LIMITED",
"FABRICO CLEANING SOLUTIONS PRIVATE LIMITED",
"FABRICO COTTEX INDUSTRIES PRIVATE LIMITED",
"FABRICO INDIA PRIVATE LIMITED",
"FABRICOLOR PVT LTD",
"FABRICRAFT IMPEX PRIVATE LIMITED",
"FABRIKEN AGENCIES PRIVATE LIMITED",
"FABRIMAX ENGINEERING PRIVATE LIMITED",
"FABRIMECH ENGINEERS PRIVATE LIMITED",
"FABRIQUE LAUNDROMAT SERVICES PRIVATE LIMITED",
"FABRITECH ENGINEERING",
"FABRI-TEK EQUIPMENTS PRIVATE LIMITED",
"FABRIWORLD STRUCTURAL ENGINEERING PRIVATE LIMITED",
"FABRIZIO INDUSTRIES PRIVATE LIMITED",
"FABRRINOX POTNIS PRIVATE LIMITED",
"FABSAFE TECHNOLOGIES PRIVATE LIMITED",
"FABSOL",
"FABSTECH PVT LTD",
"FABSTORE PRIVATE LIMITED",
"FABSTRACT CLOTHING INDIA PRIVATE LIMITED",
"FABTECH BUILDING SYSTEMS PRIVATE LIMITED",
"FABTECH CABLES PRIVATE LIMITED",
"FABTECH CONSULTING ENGINEERS PRIVATE LIMITED",
"FABTECH ENGINEERING PRIVATE LIMITED",
"FABTECH INDUSTRIES PRIVATE LIMITED",
"FABTECH INTERNATIONAL HOSIERIES PRIVATE LIMITED",
"FABTECH TECHNOLOGIES CLEANROOMS PVT LTD",
"FABTECH TECHNOLOGIES INTERNATIONAL LIMITED",
"FABTECH TECHNOLOGIES PRIVATE LIMITED",
"FABTEQ SYSTEMS PRIVATE LIMITED",
"FABTOOL INDIA PRIVATE LIMITED",
"FABULA COATINGS INDIA PRIVATE LIMITED",
"FABULA TRADING COMPANY PRIVATE LIMITED",
"FABULLA CERAMICS PRIVATE LIMITED",
"FABULOUS BUSINESS CENTRE PRIVATE LIMITED",
"FABULOUS COMMERCIAL PRIVATE LIMITED",
"FABULOUS LOGISTICS PRIVATE LIMITED",
"FABULOUS TRAVEL SERVICES PRIVATE LIMITED",
"FABURA HARDWARES PRIVATE LIMITED",
"FABWORLD PLY DECORS PRIVATE LIMITED",
"FABWORTH PROMOTERS PRIVATE LIMITED",
"FABZ FABRICOM INDIA PRIVATE LIMITED",
"FABZIN PRIVATE LIMITED",
"FACAADE",
"FACADE ALU TECH PRIVATE LIMITED",
"FACADE CONCEPT DESIGN PRIVATE LIMITED",
"FACADE DESIGN HOUSE PRIVATE LIMITED",
"FACADE ONE SYSTEMS PRIVATE LIMITED",
"FACC SOLUTIONS PRIVATE LIMITED",
"FACE CARE CLINICS PRIVATE LIMITED",
"FACE IMPEX PRIVATE LIMITED",
"FACEBOOK INDIA ONLINE SERVICES PRIVATE LIMITED",
"FACE-IT SERVICES PRIVATE LIMITED",
"FACEMAP INFOTECHNOLOGIES PRIVATE LIMITED",
"FACES COSMETICS INDIA PRIVATE LIMITED",
"FACET FACADE CONSULTANCY PRIVATE LIMITED",
"FACETS GEMS POLISHING WORKS PRIVATE LIMITED",
"FACETS LIFESTYLE PRIVATE LIMITED",
"FACHARA PLASTECH PRIVATE LIMITED",
"FACILE CONSULTING PRIVATE LIMITED",
"FACILE INFO SERV PRIVATE LIMITED",
"FACILE TECHNOLAB PRIVATE LIMITED",
"FACILICOM SOLUTIONS PRIVATE LIMITED",
"FACILIO TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"FACILITECHS TRADES AND SERVICES PRIVATE LIMITED",
"FACILITIES AND BUILDING SOLUTIONS PRIVATE LIMITED",
"FACILITIES TOURS & TRAVELS PRIVATE LIMITED",
"FACILITY LIFE SOLUTIONS PRIVATE LIMITED",
"FACILITY PLUS ESTATE MANAGEMENT PRIVATE LIMITED",
"FACILITY PLUS MANAGEMENT PRIVATE LIMITED",
"FACILIUS MEDIA SOLUTIONS PRIVATE LIMITED",
"FACILLIMA SOFTWARE PRIVATE LIMITED",
"FACIT COMMOSALES PVT LTD",
"FACKELMANN INDA KITCHENWARE PRIVATE LIMITED",
"FACLON LABS PRIVATE LIMITED",
"FACOR ALLOYS LIMITED",
"FACOR POWER LIMITED",
"FACS LUBRICATION PRIVATE LIMITED",
"FACSTORY MEDIA PRIVATE LIMITED",
"FACT ADVISORY AND COMMERCIAL SERVICES LLP",
"FACT PERSONNEL PRIVATE LIMITED",
"FACT SOFTWARE PRIVATE LIMITED",
"FACT SOLUTIONS INDIA PRIVATE LIMITED",
"FAC-TECH ENGINEERING ASSOCIATES PRIVATE LIMITED",
"FACTENTRY DATA SOLUTIONS PRIVATE LIMITED",
"FACTION COMMUNICATION PRIVATE LIMITED",
"FACTION HOSPITALITY PRIVATE LIMITED",
"FACTOCAD ROBOTICS AND AUTOMATION INDIA PRIVATE LIMITED",
"FACTORIAL SOLUTIONS PRIVATE LIMITED",
"FACTORY AUTOMATION PRIVATE LIMITED",
"FACTOTUM SERVICES PRIVATE LIMITED",
"FACTOTUM TECHNOLOGIES PRIVATE LIMITED",
"FACTS PROFESSIONAL SERVICES PRIVATE LIMITED",
"FACTSET SYSTEMS INDIA PRIVATE LIMITED",
"FACTSPAN ANALYTICS PRIVATE LIMITED",
"FACTUAL KNOWLEDGE PROCESSING SERVICES PRIVATE LIMITED",
"FACULTY OF ALLIED HEALTH SCIENCES",
"FACULTY OF ENGINEERING AND TECHNOLOGY",
"FACXO TECHNOLOGIES PRIVATE LIMITED",
"FADLE CHEM PRIVATE LIMITED",
"FAEB CRUNCH PRIVATE LIMITED",
"FAERING CAPITAL PRIVATE LIMITED",
"FAES PACKAGING SOLUTIONS PRIVATE LIMITED",
"FAFALUX GLOBAL PRIVATE LIMITED",
"FAGIOLI INDIA PRIVATE LIMITED",
"FAGNE SONGADH EXPRESSWAY LIMITED",
"FAGNE TARSOD CORRIDOR PRIVATE LIMITED",
"FAGNIA IMPEX PRIVATE LIMITED",
"FAGODIYA BORWELLS",
"FAGU JAI MANGAL INFRA PRIVATE LIMITED",
"FAHRENHEIT CHEMOLEUMS PRIVATE LIMITED",
"FAHRENHEIT CLOTHING INDIA PRIVATE LIMITED",
"FAHRENHEIT ENTERPRISES",
"FAI ENGINEERING PRIVATE LIMITED",
"FAICHI SOLUTIONS PRIVATE LIMITED",
"LESER INDIA PRIVATE LIMITED",
"FAIR BEAT HERBALS COSMETICS PRIVATE LIMITED",
"FAIR BROTHERS REALTIES PRIVATE LIMITED",
"FAIR CHEMS PRIVATE LIMITED",
"FAIR CONSULTING INDIA PRIVATE LIMITED",
"FAIR DEAL CAR PRIVATE LIMITED",
"FAIR DEAL IMPEX PRIVATE LIMITED",
"FAIR DEAL INSURANCE BROKERS PRIVATE LIMITED",
"FAIR DEAL PREMIUM WHEELS PRIVATE LIMITED",
"FAIR DEAL PUBLISHERS & DISTRIBUTORS",
"FAIR DEAL VENTURES PRIVATE LIMITED",
"FAIR DEAL WHEELS PRIVATE LIMITED",
"FAIR ENGINEERING PRIVATE LIMITED",
"FAIR EXPORTS INDIA PRIVATE LIMITED FAIR GROUP ENTITY",
"FAIR FAB ENGINEERING PVT LTD",
"FAIR FLOW (INDIA) PRIVATE LIMITED",
"FAIR FLUX PVT LTD.",
"FAIR FOOD OVERSEAS LTD",
"FAIR FOOD PVT LTD",
"FAIR FOREX DEALERS PRIVATE LIMITED",
"FAIR INTERMEDIATE INVESTMENT PRIVATE LIMITED",
"FAIR INTERMEDIATE PRODUCTS PRIVATE LIMITED",
"FAIR ISAAC INDIA SOFTWARE PRIVATE LIMITED",
"FAIR LADY DESIGNER PRIVATE LIMITED",
"FAIR LOG WAREHOUSING & TRADING PRIVATE LIMITED",
"FAIR LOGISTICS PRIVATE LIMITED",
"FAIR MINT TRADING PRIVATE LIMITED",
"FAIR N FLAIR GARMENTS",
"FAIR POWER AGE PRIVATE LIMITED",
"FAIR PROFESSIONAL SALON SPA PRIVATE LIMITED",
"FAIR VALUE INFORMATION TECHNOLOGY SERVICES PRIVATE LIMITED",
"FAIR VALUE RESEARCH PRIVATE LIMITED",
"FAIR VALUE TRADERS PRIVATE LIMITED",
"FAIRAIR ENGINEERS (MUMBAI) PRIVATE LIMITED",
"FAIRAIR ENGINEERS PRIVATE LIMITED",
"FAIRASSETS TECHNOLOGIES INDIA PRIVATE LIMITED",
"FAIRBANKS MORSE INDIA LIMITED",
"FAIRBRIDGE CAPITAL PRIVATE LIMITED",
"FAIRCHEM ORGANICS LIMITED",
"FAIRCONNECTS SOLUTIONS PRIVATE LIMITED",
"FAIRDEAL AGENCIES PRIVATE LIMITED",
"FAIRDEAL AUTOMOBILES PRIVATE LIMITED",
"FAIRDEAL COMPONENTS LIMITED",
"FAIRDEAL CONSUMER DURABLES PRIVATE LIMITED",
"FAIRDEAL CORPORATE ADVISORS PRIVATE LIMITED",
"FAIRDEAL ELECTRICALS AND ENGINEERING PVT LTD",
"FAIRDEAL ENTERPRISES",
"FAIRDEAL HEALTH CARE PRIVATE LIMITED",
"FAIRDEAL LUMBERS PRIVATE LIMITED",
"FAIRDEAL MOTORS AND WORKSHOP PRIVATE LIMITED (T)",
"FAIRDEAL ORGANIC PRIVATE LIMITED",
"FAIRDEAL PAPER MERCHANTS PRIVATE LIMITED",
"FAIRDEAL PHARMECO PRIVATE LIMITED",
"FAIRDEAL POLYMERS PRIVATE LIMITED",
"FAIRDEAL PRINT PACK INDIA PRIVATE LIMITED",
"FAIRDEAL PROCESS AUTOMATION PRIVATE LIMITED",
"FAIRDEAL PROJECTS PRIVATE LIMITED",
"FAIRDEAL STEELS PRIVATE LIMITED",
"FAIRDEAL STUDIOS PRIVATE LIMITED",
"FAIRDEAL TECHNOLOGIES PRIVATE LIMITED",
"FAIRDEAL TEXTILE PARK PRIVATE LIMITED",
"FAIRDEAL TRACTOR PRIVATE LIMITED",
"FAIRDEAL TRANSFORMERS AND SWITCHGEARS PRIVATE. LIMITED.",
"FAIRDEALS FASHIONETTES PRIVATE LIMITED",
"FAIRFAW TECHNOLOGIES PRIVATE LIMITED",
"FAIRFAX SOLUTION INDIA PRIVATE LIMITED",
"FAIRFEST MEDIA LIMITED",
"FAIRFIELD BY MARRIOTT",
"FAIRFIELD INSTITUTE OF MANAGEMENT AND TECHNOLOGY",
"FAIRFIX LABELS PRIVATE LIMITED",
"FAIRFREIGHT LINES PRIVATE LIMITED",
"FAIRGAZE SKILLS PRIVATE LIMITED",
"FAIRGRAPHICS MEDIA SERVICES PRIVATE LIMITED",
"FAIRGROWTH MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"FAIRKRAFT CREATIONS PRIVATE LIMITED",
"FAIRLADY EXPORTS INDIA PRIVATE LIMITED",
"FAIRLANDS TECHNOLOGY SERVICES PRIVATE LIMITED",
"FAIRLEAD INSPECTION & TESTING PRIVATE LIMITED",
"FAIRLEAF REAL ESTATE PRIVATE LIMITED",
"FAIRLIE EXPORTS PRIVATE LIMITED",
"FAIRLIE HOTELS & RESORTS PRIVATE LIMITED",
"FAIRLIE SERVICES PRIVATE LIMITED",
"FAIRMACS SHIPPING & TRANSPORT SERVICES PRIVATE LIMITED",
"FAIRMACS SHIPSTORES PRIVATE LIMITED",
"FAIRMACS TRADING COMPANY PRIVATE LIMITED",
"FAIRMATE CHEMICALS PRIVATE LIMITED",
"FAIRMONT",
"FAIRMONT POLYMERS INDIA PRIVATE LIMITED",
"FAIRMONT PREMISES PRIVATE LIMITED",
"FAIRMOUNT DEVELOPERS PRIVATE LIMITED",
"FAIRMOUNT HOTELS PRIVATE LIMITED",
"FAIRMOUNT MARKETING LIMITED",
"FAIRMOUNT SHIP MANAGEMENT PRIVATE LIMITED",
"FAIRPLAY FINANCIAL CALIBRATORS PRIVATE LIMITED",
"FAIRPLAY SHIPPING AND LOGISTICS PRIVATE LIMITED",
"FAIRPRICE BUILDMART PRIVATE LIMITED",
"FAIRSPACE MEDIA SERVICES PRIVATE LIMITED",
"FAIRSQUARE TRADING PRIVATE LIMITED",
"FAIRSUN SOLAR PRIVATE LIMITED",
"FAIRSYS INFOTECH PRIVATE LIMITED",
"FAIRTALES BUSINESS SERVICES PRIVATE LIMITED",
"FAIRTECH ENGINEERS INDIA PRIVATE LIMITED",
"FAIRTECH MARKETING SERVICES PRIVATE LIMITED",
"FAIRWAY ENTERPRISES COMPANY LIMITED",
"FAIRWAY SPORTS PRIVATE LIMITED",
"FAIRWAY TRADING CO PRIVATE LIMITED",
"FAIRWAYS TOLL AND SECURITY SERVICES PRIVATE LIMITED",
"FAIRWINDS ASSET MANAGERS LIMITED",
"FAIRWOOD INFRA & SERVICES PRIVATE LIMITED",
"FAIRY FOOD PRODUCTS PRIVATE LIMITED",
"FAIRY LAND FOOD AND DAIRY PRODUCTS LLP",
"FAIRYLAND FOUNDATION PRIVATE LIMITED",
"FAIRYLAND HOTELS AND RESORTS PRIVATE LIMITED",
"FAISAL ROOFING SOLUTION (I) PRIVATE LIMITED",
"FAISH SPINNING MILLS PRIVATE LIMITED",
"FAITH ACADEMY",
"FAITH AGRI SOLUTIONS PRIVATE LIMITED",
"FAITH APPARELS INDIA PRIVATE LIMITED",
"FAITH AUTOMATION SYSTEMS & TOOLING PRIVATE LIMITED",
"FAITH BIOTECH PRIVATE LIMITED",
"FAITH BUILD PHARMACEUTICALS PRIVATE LIMITED",
"FAITH BUILDTECH PRIVATE LIMITED",
"FAITH FINANCIALS PRIVATE LIMITED",
"FAITH HOSPITAL & ICU",
"FAITH HOSPITAL AND ICU",
"FAITH INDUSTRIES LIMITED",
"FAITH LUMBER PRIVATE. LIMITED.",
"FAITH MERCANTILE PRIVATE LIMITED",
"FAITH PHARMACEUTICALS LIMITED",
"FAITH SERVICES PRIVATE LIMITED",
"FAITH UNIVERSAL PRIVATE LIMITED",
"FAITHFUL COMMERCIAL LIMITED.",
"FAITHFULLY YOURS MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"FAIVELEY TRANSPORT RAIL TECHNOLOGIES INDIA LIMITED",
"FAIVELEY TRANSPORT RAIL TECHNOLOGIES INDIA PRIVATE LIMITED",
"FAIYAZ DRESSES PRIVATE LIMITED",
"FAIZ FALKON LOGISTICS INDIA PRIVATE LIMITED",
"FAIZ INDUSTRIES",
"FAIZ RETAIL PRIVATE LIMITED",
"FAIZ TANNING COMPANY PRIVATE LIMITED",
"FAIZAL AND SHABANA FOUNDATION",
"FAIZAL TRADERS PRIVATE LIMITED",
"FAK CARGO DYNAMICS PRIVATE LIMITED",
"FAKEEH TECHNOLOGIES PRIVATE LIMITED",
"FAKHOURY CONSULTANTS PRIVATE LIMITED",
"FAKIRSONS PAPCHEM PRIVATE LIMITED",
"FALABELLA CORPORATE SERVICES INDIA PRIVATE LIMITED",
"FALAINA INDIA PRIVATE LIMITED",
"FALAK FROZEN FOOD EXPORTS PRIVATE LIMITED",
"FALAK INDUSTRIALS FUELS PRIVATE LIMITED",
"FALAK INDUSTRIES PRIVATE LIMITED",
"FALAK INVESTMENT PRIVATE LIMITED",
"FALAKATA AGRO FOOD PRODUCTS PRIVATE LIMITED",
"FALAKATA HEALTH CARE PRIVATE LIMITED",
"FALANX FLOOR SOLUTIONS PRIVATE LIMITED",
"FALCA E SOLUTIONS PRIVATE LIMITED",
"FALCK INDIA PRIVATE LIMITED",
"FALCO ROBOTICS PRIVATE LIMITED",
"FALCON (CHENNAI) SECURITY SERVICES PRIVATE LIMITED",
"FALCON ABASAN PVT. LTD.",
"FALCON ACADEMY",
"FALCON ACOUSTICS AND PASSIVE FIRE SOLUTIONS PRIVATE LIMITED",
"FALCON AGENCIES PRIVATE LIMITED",
"FALCON AGRONOMICS PRIVATE LIMITED",
"FALCON AIR CARGO AND TRAVELS PRIVATE LTD",
"FALCON AUTOTECH PRIVATE LIMITED",
"FALCON BIOTECH PRIVATE LIMITED",
"FALCON BUILDWELL PRIVATE LIMITED",
"FALCON BUS LINES PRIVATE LIMITED",
"FALCON BUSINESS RESOURCES PRIVATE LIMITED",
"FALCON BUSINESS SOLUTION PRIVATE LIMITED",
"FALCON CARGO SERVICES INDIA PRIVATE LIMITED",
"FALCON CHEMOX PRIVATE LIMITED",
"FALCON COINS GALLERY PRIVATE LIMITED",
"FALCON CONTRACTS PRIVATE LIMITED",
"FALCON COURIERS PRIVATE LIMITED",
"FALCON CROP SCIENCE PRIVATE LIMITED",
"FALCON ELECTRO-TEK PRIVATE LIMITED",
"FALCON ELEVATORS INDIA PRIVATE LIMITED",
"FALCON ENTREPRENEUR LIMITED",
"FALCON EXIM PRIVATE LIMITED",
"FALCON EXTRUSIONS PRIVATE LIMITED",
"FALCON FACILITIES INDIA PRIVATE LIMITED",
"FALCON FACILITY MANAGEMENT PRIVATE LIMITED",
"FALCON FIGHTER FORCE LLP",
"FALCON FINANCE LIMITED",
"FALCON FORCE PRIVATE LIMITED",
"FALCON GARDEN TOOLS PRIVATE LIMITED",
"FALCON GLOBAL SALES PRIVATE LIMITED",
"FALCON GOLD HOUSE PRIVATE LIMITED",
"FALCON HR CONSULTING PRIVATE LIMITED",
"FALCON INTERIOR SOLUTIONS (INDIA) PRIVATE LIMITED",
"FALCON INTERNAL SAFETY AND FIRE SERVICES PRIVATE LIMITED",
"FALCON ISBA ENGINEERING PRIVATE LIMITED",
"FALCON IT ENABLED SERVICES PRIVATE LIMITED",
"FALCON MACHINERIES",
"FALCON MARINE EXPORTS LIMITED",
"FALCON MARKETING PRIVATE LIMITED",
"FALCON MOBIKES PRIVATE LIMITED",
"FALCON MULTI SERVICES LIMITED",
"FALCON NESTBUILT PRIVATE LIMITED",
"FALCON OFFSHORE SERVICES INDIA PRIVATE LIMITED",
"FALCON PAYTECH PRIVATE LIMITED",
"FALCON PIPES INDUSTRIES PRIVATE LIMITED",
"FALCON PIPES PRIVATE LIMITED",
"FALCON PROGRESSIVE VENTURES PRIVATE LIMITED",
"FALCON PUMPS PRIVATE LIMITED",
"FALCON REAL ESTATE PRIVATE LIMITED",
"FALCON RESTO MULTICUISINE RESTAURANT",
"FALCON SECURITY AND MANPOWER CONSULTANTS PRIVATE LIMITED",
"FALCON TECHNOPROJECTS INDIA LIMITED",
"FALCON TECHNOPROJECTS INDIA PRIVATE LIMITED",
"FALCON TUBES PVT LTD",
"FALCON YARNS PRIVATE LIMITED",
"FALCON18 IMPORTS PRIVATE LIMITED",
"FALCONNECT TECHNOLOGIES PRIVATE LIMITED",
"FALCONS GARAGE SOLUTIONS PRIVATE LIMITED",
"FALGU SOLUTIONS PRIVATE LIMITED",
"FALGUN EXPORT PVT LTD",
"FALGUNI DRESSES",
"FALGUNI INFRAVISION PRIVATE LIMITED",
"FALKEN TYRE INDIA PRIVATE LIMITED",
"FALKONRY SOFTWARE PRIVATE LIMITED",
"FALL ARREST SYSTEMS & TECHNOLOGIES PRIVATE LIMITED",
"FALOD DRY FRUITS PRIVATE LIMITED",
"FALODI SUPER MARKET PRIVATE LIMITED",
"FALSHAJAM INVESTMENT AND FINANCE COMPANY PRIVATE LIMITED",
"FAM MATERIALS HANDLING SYSTEMS INDIA PRIVATE LIMITED",
"FAMAK INDIA PRIVATE LIMITED",
"FAMCARE INDIA PRIVATE LIMITED",
"FAMCOM LABS PRIVATE LIMITED",
"FAME BUILDERS PRIVATE LIMITED",
"FAME CHEM (INDIA) PRIVATE LIMITED",
"FAME DIGITAL PRIVATE LIMITED",
"FAME HOTELS PRIVATE LIMITED",
"FAME KEEDA NETWORKS PRIVATE LIMITED",
"FAME LIFESTYLE PRIVATE LIMITED",
"FAMECO ENGINEERING CONTRACTORS PRIVATE LIMITED",
"FAMELINE ARCHITECTURAL PRODUCTS PRIVATE LIMITED",
"FAMEPOSTER CAREER SERVICES PRIVATE LIMITED",
"FAMETEX INDUSTRIES PRIVATE LIMITED",
"FAMETOONZ PRIVATE LIMITED",
"FAMHEALTH PRIVATE LIMITED",
"FAMIC TECHNOLOGIES PRIVATE LIMITED",
"FAMILY CARE HOME CARE PRIVATE LIMITED",
"FAMILY CARE HOSPITALS LIMITED",
"FAMILY COURT BANDRA MUMBAI",
"FAMILY COURT GANDHINAGAR",
"FAMILY COURT MADHYA PRADESH",
"FAMILY HEALTH INDIA",
"FAMILY HEALTH PLAN INSURANCE TPA LIMITED",
"FAMILY HEALTH PLAN TPA LIMITED",
"FAMILY HEALTHCARE HOSPITAL",
"FAMILY HOME CONSULTANCY SERVICES PRIVATE LIMITED",
"FAMILY HOME FINANCE PRIVATE LIMITED",
"FAMILY HOSPITAL PRIVATE LIMITED",
"FAMILY MEDICARE PLUS (INDIA) PRIVATE LIMITED",
"FAMILY PLASTIC PRIVATE LIMITED",
"FAMILY PLASTICS AND THERMOWARE PRIVATE LIMITED",
"FAMILY WELFARE DEPARTMENT",
"FAMILYCARE CONSUMER PRIVATE LIMITED",
"FAMN PHARMA PRIVATE LIMITED",
"FAMOUS DIGITAL STUDIOS PRIVATE LIMITED",
"FAMOUS ENGINEERING PRIVATE LIMITED",
"FAMOUS FASHION PRIVATE LIMITED",
"FAMOUS FOAM & MATTRESSES PRIVATE LIMITED",
"FAMOUS GEMS PRIVATE LIMITED",
"FAMOUS INNOVATIONS DIGITAL CREATIVE PRIVATE LIMITED",
"FAMOUS METAL INDIA PRIVATE LIMITED",
"FAMOUS MINERALS AND CHEMICALS PRIVATE LIMITED",
"FAMOUS REINFORCED PLASTICS PVT LTD",
"FAMOUS STUDIOS LIMITED",
"FAMOUS TRANSPORT COMPANY PRIVATE LIMITED",
"FAMOUS VITRIFIED PRIVATE LIMITED",
"FAMS CONSUMER PRODUCTS PRIVATE LIMITED",
"FAMY CARE PRIVATE LIMITED",
"FAMY ENERGY PRIVATE LIMITED",
"FAMY FINVEST PRIVATE LIMITED",
"FAMY LIFE SCIENCES PRIVATE LIMITED",
"FAMY STERI PRIVATE LIMITED",
"FAMYANANTA CAPITAL INVESTMENT PRIVATE LIMITED",
"FAMYSHINE PRIVATE LIMITED",
"FAN HOSPITALITY SERVICES PRIVATE LIMITED",
"FANA LEATHER TRADE PRIVATE LIMITED",
"FANAIR INDIA PRIVATE LIMITED",
"FANATIC SPORTS PRIVATE LIMITED",
"FANATICS E-COMMERCE INDIA LLP",
"FANCY CAP HOUSE",
"FANCY CREATIONS PRIVATE LIMITED",
"FANCY DECOR PRIVATE LIMITED",
"FANCY DIAMONDS INDIA PRIVATE LIMITED",
"FANCY FITTINGS LIMITED",
"FANCY FOAM PRIVATE LIMITED",
"FANCY GLASS INDUSTRIES PRIVATE LIMITED",
"FANCY MFG LLP",
"FANCY SHOE STORE",
"FANCYMONK TECHNOLOGIES PRIVATE LIMITED",
"FANCYYS EXPORTS PRIVATE LIMITED",
"FANEM MEDICAL DEVICES INDIA PRIVATE LIMITED",
"FANGS TECHNOLOGY PRIVATE LIMITED",
"FANIDHAR AGROTECH PRIVATE LIMITED",
"FANIDHAR ENTERPRISES PRIVATE LIMITED",
"FANIDHAR MEGA FOOD PARK PRIVATE LIMITED",
"FANKAAR INTERRIORS PRIVATE LIMITED",
"FANNIE MAE",
"FANPLAY GAMES AND MEDIA PRIVATE LIMITED",
"FANS ON STANDS SPORTS PRIVATE LIMITED",
"FANTABEE IOE LABS PRIVATE LIMITED",
"FANTABULOUS TOWN DEVELOPERS PRIVATE LIMITED",
"FANTASIA HOSPITALITY PRIVATE LIMITED",
"FANTASIA TRADE PRIVATE LIMITED",
"FANTASTIC FACILITY MANAGEMENT PRIVATE LIMITED",
"FANTASTICO RESTAURANTS PRIVATE LIMITED",
"FANTASY BUILDWELL PRIVATE LIMITED",
"FANTASY LIFE STYLE INTERIORS PRIVATE LIMITED",
"FANTASY PACKAGING PRIVATE LIMITED",
"FANTASY SPORTS MYFAB11 PRIVATE LIMITED",
"FANTASY WORLD PRIVATE LIMITED",
"FANTREE ENTERPRISE PRIVATE LIMITED",
"FANUC INDIA PRIVATE LIMITED",
"FANZINEINDIA MEDIA PRIVATE LIMITED",
"FAPAL ROOFS INDIA PRIVATE LIMITED",
"FAR LEFT RETAIL PRIVATE LIMITED",
"FAR N PAR INDIA PRIVATE LIMITED",
"FAR REACH AUTO IMPEX PRIVATE LIMITED",
"FAR SHIPPING (INDIA) PRIVATE LIMITED",
"FAR SHORE SOFTWARE DEVELOPMENT PRIVATE LIMITED",
"FARADAY ELECTRICALS PVT LTD",
"FARADAY OZONE PRODUCTS PRIVATE LIMITED",
"FARADAYS MICRO TECHNOLOGIES PRIVATE LIMITED",
"FARADAYTEK SOLUTIONS INDIA PRIVATE LIMITED",
"FARAH KHAN FINE JEWELLERY PRIVATE LIMITED",
"FARAH POLYSACK PRIVATE LIMITED",
"FARAH URDU PRIMARY SCHOOL SOLAPUR",
"FARAKKA-RAIGANJ HIGHWAYS LIMITED",
"FARAN TEPPICH EXPORTS PRIVATE LIMITED",
"FARAWAY TREE HOSPITALITY PRIVATE LIMITED",
"FARCAST BIOSCIENCES INDIA PRIVATE LIMITED",
"FARCOM CABLE SYSTEMS PRIVATE LIMITED",
"FARE DESTINATION PRIVATE LIMITED",
"FARE LABS PRIVATE LIMITED",
"FARE PORTAL INDIA PRIVATE LIMITED",
"FAREAST ENGINEERING AND CONSTRUCTION CO PRIVATE LIMITED",
"FAREAST EXIM VENTURE PRIVATE LIMITED",
"FAREAST OFFSHORE HEAVY ENGINEERING PRIVATE LIMITED",
"FAREAST SYNERGY PRIVATE LIMITED",
"FAREDEAL SHIPPING AGENCIES MUMBAI PRIVATE LIMITED",
"FAREEDSONS ALUMINIUM PRIVATE LIMITED",
"FAREMART TRAVELS PRIVATE LIMITED",
"FARENEXUS SOLUTIONS PRIVATE LIMITED",
"FAREPAYER PRIVATE LIMITED",
"FAREPOOL TRAVEL INDIA PRIVATE LIMITED",
"FARFETCH INDIA PRIVATE LIMITED",
"FARGANIC AGRO LIFE SCIENCE PRIVATE LIMITED",
"FARGO FACILITIES MANAGEMENT PRIVATE LIMITED",
"FARGO MANTLE PRODUCTS PRIVATE LIMITED",
"FARIA FABRICS PRIVATE LIMITED",
"FARIAWALA INTERIO PRIVATE LIMITED",
"FARIDA CLASSIC SHOES PRIVATE LIMITED",
"FARIDA GUPTA RETAIL PRIVATE LIMITED",
"FARIDA PRIME TANNERY PRIVATE LIMITED",
"FARIDA SHOES PRIVATE LIMITED",
"FARIDABAD AUTOCOMP SYSTEMS PRIVATE LIMITED",
"FARIDABAD COMMUNICATION INDIA PRIVATE LIMITED",
"FARIDABAD CONTROL ELECTRICALS PVT LTD",
"FARIDABAD FURNACE MANUFACTURER PRIVATE LIMITED",
"FARIDABAD HOTELS DELITE PRIVATE LIMITED",
"FARIDABAD INDUSTRIES ASSOCIATION",
"FARIDABAD METAL UDYOG PRIVATE LIMITED",
"FARIDABAD PAPER MILLS PRIVATE LIMITED",
"FARIDABAD STAMPINGS PRIVATE LIMITED",
"FARIDABAD STEEL MONGERS PRIVATE LIMITED",
"FARIDI IMPEX PRIVATE LIMITED",
"FARIDIYA URDU UPPER PRIMARY SCHOOL TIMKI",
"FARINNI LEATHER PRIVATE LIMITED",
"FARISTA VANIJYA PRIVATE LIMITED",
"FARIYAS HOTEL PRIVATE LIMITED",
"FARKIA CONSTRUCTION PRIVATE LIMITED",
"FARLEX PHARMACEUTICALS PRIVATE LIMITED",
"FARLEY HGTECH LASER TECHNOLOGY PRIVATE LIMITED",
"FARM & FIELD ORGANIC FERTILIZERS PRIVATE LIMITED",
"FARM AGRO EXIM PRIVATE LIMITED",
"FARM AND GARDEN TECHNOLOGIES PRIVATE LIMITED",
"FARM DIRECT IMPEX PRIVATE LIMITED",
"FARM FRESH FOODS PVT LTD",
"FARM GAS PRIVATE LIMITED",
"FARM IMPLEMENTS INDIA PRIVATE LIMITED",
"FARM INDIA IMPEX PRIVATE LIMITED",
"FARM METRIX INDIA PRIVATE LIMITED",
"FARM PRESS PRIVATE LIMITED",
"FARM PROSPERITY SOLUTIONS PRIVATE LIMITED",
"FARM SUZZANNE PRIVATE LIMITED",
"FARM TEA & CHEMICALS PRIVATE LIMITED",
"FARM TECH BIOGENE PRIVATE LIMITED",
"FARMACHEM LIFE PRIVATE LIMITED",
"FARMACHEM PRIVATE LIMITED",
"FARMACROSS INDIA PRIVATE LIMITED",
"FARMAGAIN AGRO PRIVATE LIMITED",
"FARMAGRO EXPRESS VENTURES PRIVATE LIMITED",
"FARMAGUDI GOVT INDUSTRIAL TRAINING INSTITUDE",
"FARMAI INDIA PRIVATE LIMITED",
"FARMAKAL HEALTH CARE PRIVATE LIMITED",
"FARMAR TACTICAL SERVICES PRIVATE LIMITED",
"FARMAX TECHNOLOGIES PRIVATE LIMITED",
"FARMBASE PRODUCTS PRIVATE LIMITED",
"FARMCRAFT NATURAL SEEDS PRIVATE LIMITED",
"FARMEDIBLE PRODUCTS PRIVATE LIMITED",
"FARMENT INTERNATIONAL PRIVATE LIMITED",
"FARMER 2 CONSUMER FOODS PRIVATE LIMITED",
"FARMERS AGRICULTURE CREDIT CO-OPERATIVE SOCIETY LIMITED",
"FARMER'S BRIDGE BASKET RETAIL LLP",
"FARMERS FIRST FARM PRODUCTS PRIVATE LIMITED",
"FARMERS FRESHZONE PRIVATE LIMITED",
"FARMERS HYBRID SEEDS PRIVATE LIMITED",
"FARMER'S PHARMA PRIVATE LIMITED",
"FARMERSFIELD AGRO & FLOUR MILL PRIVATE LIMITED",
"FARMERSFORTUNE (INDIA) PRIVATE LIMITED",
"FARMERSFORTUNE INDIA PRIVATE LIMITED",
"FARMFIELDS PRIVATE LIMITED",
"FARMFOLKS AGRO PRIVATE LIMITED",
"FARMGATE AGRO MILCH PRIVATE LIMITED",
"FARMGATE TECHNOLOGIES PRIVATE LIMITED",
"FARMICO COLD CHAIN & LOGISTICS LIMITED",
"FARMICO COLD CHAIN PRIVATE LIMITED",
"FARMICO EXPORTS PRIVATE LIMITED",
"FARMILA VENTURES PRIVATE LIMITED",
"FARMING SOLUTIONS PRIVATE LIMITED",
"FARMING TREE CHEMICAL & POLYMERS PRIVATE LIMITED",
"FARMISSION FARMER PRODUCER COMPANY LIMITED",
"FARMJUNCTION MARKETING PRIVATE LIMITED",
"FARMKING FOOD PRODUCTS PRIVATE LIMITED",
"FARMLINK AGRI DISTRIBUTION & MARKLETING LINKAGE PRIVATE LIMITED",
"FARMONIC BIOTECH PRIVATE LIMITED",
"FARMORIGIN AGROSCIENCE PRIVATE LIMITED",
"FARMOST FOODS PRIVATE LIMITED",
"FARMOVA CHEMICALS & FERTILIZERS PRIVATE LIMITED",
"FARMPAL TECHLOGI PRIVATE LIMITED",
"FARMROOT AGRITECH PRIVATE LIMITED",
"FARMS2FORK TECHNOLOGIES PRIVATE LIMITED",
"FARMSETU TECHNOLOGIES PRIVATE LIMITED",
"FARMSON BASIC DRUGS PRIVATE LIMITED",
"FARMSON ENVIRO CARE",
"FARMSON PHARMACEUTICAL GUJARAT PRIVATE LIMITED",
"FARMSONS AGRI SOLUTIONS PRIVATE LIMITED",
"FARMSONS CROP CARE PRIVATE LIMITED",
"FARMSONS FABRICS PVT LTD",
"FARMSONS FERTICHEM PRIVATE LIMITED",
"FARMSONS FILATEX PRIVATE LIMITED",
"FARMTERIA AGRO PRODUCER COMPANY LIMITED",
"FARMTHEORY PRIVATE LIMITED",
"FARMVET AGRO PRIVATE LIMITED",
"FARMVILLA FOOD INDUSTRIES PRIVATE LIMITED",
"FARMWICK COMMODITIES PRIVATE LIMITED",
"FARMWISEAI PRIVATE LIMITED",
"FARNOD EXIM PRIVATE LIMITED",
"FARO BUSINESS TECHNOLOGIES INDIA PRIVATE LIMITED",
"FAROHAR CONTAINER LINES PRIVATE LIMITED",
"FAROHAR TRAVELS PRIVATE LIMITED",
"FAROOSH INDUSTRIES PRIVATE LIMITED",
"FARRAH APARTMENTS PRIVATE LIMITED",
"FARRIER TECHNOLOGIES LIMITED",
"FARRY EDUCATIONAL FOUNDATION PRIVATE LIMITED",
"FARS ROBOSYS PRIVATE LIMITED",
"FARSEEN RUBBER INDUSTRIES LTD",
"FARSIGHT SECURITIES LIMITED",
"FARSIGHTED SYSTEMS PRIVATE LIMITED",
"FARTHEST LOGISTICS PRIVATE LIMITED",
"FARUKHABAD FLOOR MILLS PRIVATE LIMITED",
"FAR-VISION SERVICES PRIVATE LIMITED",
"FARWIN LIMITED",
"FARWOOD INDUSTRIES LIMITED",
"FARZI CAFE",
"FASCET SERVICES PRIVATE LIMITED",
"FASCINATE GRANITES PRIVATE LIMITED",
"FASCINATE TEXTILES PRIVATE LIMITED",
"FASCINATING STEEL STRIPS PRIVATE LIMITED",
"FASCINO EXPORTS PRIVATE LIMITED",
"FASCINUS SERVICES PRIVATE LIMITED",
"FASDERMA INDIA PRIVATE LIMITED",
"FASHION 365 DISTRIBUTION PRIVATE LIMITED",
"FASHION ACCESSORIES",
"FASHION ACCESSORIES INDIA PRIVATE LIMITED",
"FASHION AVANT GARDE DESIGNS PRIVATE LIMITED",
"FASHION BAZAAR SALES PRIVATE LIMITED",
"FASHION BULL (INDIA) RETAIL PRIVATE LIMITED",
"FASHION CAMP PRIVATE LIMITED",
"FASHION EARTH GARMENTS PRIVATE LIMITED",
"FASHION ENGINEERING COMPANY PRIVATE LIMITED",
"FASHION EXIM INDIA PRIVATE LIMITED",
"FASHION FACTORY INTERNATIONAL",
"FASHION FAIR APPARELS PRIVATE LIMITED",
"FASHION FLARE INTERNATIONAL PRIVATE LIMITED",
"FASHION IDENTITY PRIVATE LIMITED",
"FASHION JEWELLERY PRIVATE LIMITED",
"FASHION LIFESTYLES INDIA PRIVATE LIMITED",
"FASHION LINE APPARELS",
"FASHION MARMO PRIVATE LIMITED",
"FASHION ORBIT APPARELS (INDIA) PVT LTD",
"FASHION QUEEN PRIVATE LIMITED",
"FASHION REFLEXION PRIVATE LIMITED",
"FASHION ROKZZZ MYSORE PRIVATE LIMITED",
"FASHION SAFETY FOOTWEAR PRIVATE LIMITED",
"FASHION SMITH SOURCING PRIVATE LIMITED",
"FASHION TV HOSPITALITY PRIVATELIMITED",
"FASHION TV INDIA PRIVATE LIMITED",
"FASHION WORLD GARMENTS PRIVATE LIMITED",
"FASHIONAGE CORPORATION PRIVATE LIMITED",
"FASHIONKING BRANDS PRIVATE LIMITED",
"FASHIONMANIAZ MEDIA AND ENTERTAINMENT PRIVATE LIMITED",
"FASHIONS BRANDS INDIA PRIVATE LIMITED",
"FASHIONS FLASHER (INDIA) PRIVATE LIMITED",
"FASHOR LIFESTYLE PRIVATE LIMITED",
"FASIN INDIA PRIVATE LIMITED",
"FAS-INERGEIA SOLAR PRIVATE LIMITED",
"FASLA PRODUCTS PRIVATE LIMITED",
"FASPIN TECHNOLOGIES PRIVATE LIMITED",
"FASSCO INTERNATIONAL INDIA PRIVATE LIMITED",
"FAST CAPITAL MARKETS LTD.",
"FAST CONNECT LOGISTICS PRIVATE LIMITED",
"FAST CONNECT SERVICES PRIVATE LIMITED",
"FAST FIND MANAGEMENT SERVICES PRIVATE LIMITED",
"FAST FORWARD AGENCIES PRIVATE LIMITED",
"FAST FORWARD LOGISTICS INDIA PRIVATE LIMITED",
"FAST FREIGHT FORWARDING & LOGISTICS SOLUTIONS PRIVATE LIMITED",
"FAST INFRASTRUCTURE PRIVATE LIMITED",
"FAST LANE AUTOMOTIVE PRIVATE LIMITED",
"FAST LINK INFOTECH PRIVATE LIMITED",
"FAST PHARMA PRIVATE LIMITED",
"FAST RAIL CARGO PRIVATE LIMITED",
"FAST TRACK AUTO CARE (INDIA) PRIVATE LIMITED",
"FAST TRACK AUTOCARS PRIVATE LIMITED",
"FAST TRACK CFS PRIVATE LIMITED",
"FAST TRACK FURNITURE & INTERIORS INDIA PRIVATE LIMITED",
"FAST TRACK LOGISTICS (INDIA) PRIVATE LIMITED",
"FAST TRACK SOFTWARE SERVICES PRIVATE LIMITED",
"FAST TRACK TECHNOLOGIES PRIVATE LIMITED",
"FAST TRAIN CARGO LIMITED",
"FAST TRANSPORT CARRIER PRIVATE LIMITED",
"FASTARISE MANUFACTURING INDUSTRIES PRIVATE LIMITED",
"FASTBUILD BLOCKS PRIVATE LIMITED",
"FASTCOLLAB SYSTEMS PRIVATE LIMITED",
"FASTCURVE SERVICES PRIVATE LIMITED",
"FASTECH PROJECTS PRIVATE LIMITED",
"FASTECH TELECOMMUNICATIONS (INDIA) PRIVATE LIMITED",
"FASTEK INNOVATIVE TOOLINGS (INDIA) PRIVATE LIMITED",
"FASTEK ZIPPERS INDIA PRIVATE LIMITED",
"FASTENAL INDIA SOURCING IT AND PROCUREMENT PRIVATE LIMITED",
"FASTENER MANUFACTURERS PVT LTD",
"FASTENERS AND ALLIED PRODUCTS PRIVATE LIMITED",
"FASTENERS AND FORGINGS PVT LTD",
"FASTENERS ENGINEERING PRIVATE LIMITED",
"FASTENERS MULTITRADE INDIA PRIVATE LIMITED",
"FASTENEX PRIVATE LIMITED",
"FASTER HYDRAULICS PRIVATE LIMITED",
"FASTER INFRASTRUCTURE AND ENGINEERING SERVICES PRIVATE LIMITED",
"FASTFERRY SERVICES PRIVATE LIMITED",
"FASTFLOW COMMODITIES PRIVATE LIMITED",
"FASTICO WIRELESS PRIVATE LIMITED",
"FASTINFO LEGAL SERVICES PRIVATE LIMITED",
"FASTIST LOGISTIC SOLUTIONS (OPC) PRIVATE LIMITED",
"FASTLINK CONNECTIONS PRIVATE LIMITED",
"FASTMOVE AGENCIES PVT LTD",
"FASTO ENGINEERING PRIVATE LIMITED",
"FASTRACK DEALCOMM PRIVATE LIMITED",
"FASTRACK LOGISTICS & SERVICES PRIVATE LIMITED",
"FASTRACK WORLD WIDE PRIVATE LIMITED",
"FASTRAX INFOTECH PRIVATE LIMITED",
"FASTRAX POLYPLAST PRIVATE LIMITED",
"FASTRONIC TELESERVICES PRIVATE LIMITED",
"FASTSOLUTIONS FINTECH PRIVATE LIMITED",
"FASTSPEED AUTOMOBILE PRIVATE LIMITED",
"FASTSPEED BUSINESS PRIVATE LIMITED",
"FASTSPEED LOGISTICS PRIVATE LIMITED",
"FASTSPEED NIKETAN PRIVATE LIMITED",
"FASTSTREAM TECHNOLOGIES PRIVATE LIMITED",
"FASTTRACK HOUSING FINANCE LIMITED",
"FASTTRACK HOUSING FINANCE PRIVATE LIMITED",
"FASTTRACK HR SERVICES PRIVATE LIMITED",
"FASTTRACK PACKERS PRIVATE LIMITED",
"FASTTRACK WHEELS PRIVATE LIMITED",
"FASTVDO RICH MEDIA COMMUNICATIONS PRIVATE LIMITED",
"FASTWAAY DELIVERY PRIVATE LIMITED",
"FASTWAY MEDIA CABLE NETWORK PRIVATE LIMITED",
"FASTWAY SHINE STAR NETWORK PRIVATE LIMITED",
"FASTWAY SHREE NEELKANTH NETWORK PRIVATE LIMITED",
"FASTWAY TRANSMISSIONS PRIVATE LIMITED",
"FASTWAY VERSATILE STRATEGICS PRIVATE LIMITED",
"FASTWELL ENGINEERING PRIVATE LIMITED",
"FASTWELL HEALTHCARE PRIVATE LIMITED",
"FAT CHERRY INTERNATIONAL PRIVATE LIMITED",
"FAT MAMMA'S KITCHEN PRIVATE LIMITED",
"FATAFAT DIGITAL PRIVATE LIMITED",
"FATBOY FOODS SERVICES LLP",
"FATCAT INFRASTRUCTURE PRIVATE. LIMITED",
"FATEH AGRO BUILDERS PRIVATE LIMITED",
"FATEH BUSINESS HOUSE PRIVATE LIMITED",
"FATEH CHAND CHARITABLE TRUST",
"FATEH EDUCATION CONSULTING PRIVATE LIMITED",
"FATEH ENVIRO ENGINEERS PRIVATE LIMITED",
"FATEH GRANITES LIMITED",
"FATEH INDUSTRIES PRIVATE LIMITED",
"FATEH OVERSEAS PRIVATE LIMITED",
"FATEH RURAL PRIVATE LIMITED",
"FATEH STONES INTERNATIONAL PRIVATE LIMITED",
"FATEHABAD AUTOMOTORS PRIVATE LIMITED",
"FATEHGARH-BHADLA TRANSMISSION LIMITED",
"FATEHPUR COLD STORAGE AND ALLIED INDUSTRIES PRIVATE LIMITED",
"FATEHPURIA BUSINESS ASSOCIATES PRIVATE LIMITED",
"FATEHPURIA HYGIENE PRIVATE LIMITED",
"FATEHPURIA ISPAT PRIVATE LIMITED",
"FATEHPURIA MACHINES PRIVATE LIMITED",
"FATEHPURIA TRANSFORMERS AND SWITCHGEARS PRIVATE LIMITED",
"FATEHPURIA VIDYUT UDYOG PRIVATE LIMITED",
"FATEMA GIRLS PRIMARY SCHOOL",
"FATHER AGNEL TECHNICAL COLLEGE",
"FATHER MULLER CHARITABLE INSTITUTIONS",
"FATHER MULLERS MEDICAL COLLEGE HOSPITAL",
"FATHER WORLDWIDE PRIVATE LIMITED",
"FATHIMA AGENCIES",
"FATHIMA ENGINEERING COMPANY PRIVATE LIMITED",
"FATHIMA TRADERS PRIVATE LIMITED",
"FATHIMA TYRES PRIVATE LIMITED",
"FATHIMUTHU AMMA MILLS PRIVATE LIMITED",
"FATI GENERAL EQUIPMENTS PRIVATE LIMITED",
"FATIDICAL PROJECTS PRIVATE LIMITED",
"FATIK CHANDRA TEA COMPANY PRIVATE LIMITED",
"FATIMA CONVENT PUBLIC SCHOOL",
"FATIMA CONVENT SCHOOL",
"FATIMA HIGH SCHOOL",
"FATIMA HOSPITAL",
"FATMAN TECHNOLOGY PRIVATE LIMITED",
"FATPIPE NETWORKS PRIVATE LIMITED",
"FATSUN TECHNOLOGY PRIVATE LIMITED",
"FATTON LOGISTICS PRIVATE LIMITED",
"FAUCET METAL MASTER PRIVATE LIMITED",
"FAUJI EXIM PRIVATE LIMITED",
"FAUNASHAW LIFE LLP",
"FAURECIA AUTOMOTIVE SEATING INDIA PRIVATE LIMITED",
"FAURECIA EMISSIONS CONTROL TECHNOLOGIES INDIA PRIVATE LIMITED",
"FAURECIA INDIA PRIVATE LIMITED",
"FAVEO MANAGEMENT SERVICES PRIVATE LIMITED",
"FAVEO MICROFINANCE FEDERATION",
"FAVIEN EXPORTS PRIVATE LIMITED",
"FAVOURITE CONSTRUCTIONS PRIVATE LIMITED",
"FAVOURITE FABRICATORS PRIVATE LIMITED",
"FAVOURITE FRUIT PRESERVATION PRIVATE LIMITED",
"FAVOURITE LIFESTYLES PRIVATE LIMITED",
"FAVOURITE PLUS CERAMIC PRIVATE LIMITED",
"FAVOURITE SWITCHGEAR PRIVATE LIMITED",
"FAWAQ BUSINESS SOLUTION PRIVATE LIMITED",
"FAXLE LOGISTICS PRIVATE LIMITED",
"FAXONICS TECHNOLOGIES PRIVATE LIMITED",
"FAXTEL SYSTEMS (INDIA) PRIVATE LIMITED",
"FAY WEAR PRIVATE LIMITED",
"FAYAJ INFRATECH PRIVATE LIMITED",
"FAYTECH PRIVATE LIMITED",
"FAYTH HEART AND TEENS CARE PRIVATE LIMITED",
"FAZE CREATIVE MANAGEMENT PRIVATE LIMITED",
"FAZE THREE LIMITED",
"FAZILKA AGROS PVT LTD",
"FAZILKA DABWALI TRANSPORT CO PVT LTD",
"FAZILKA FOODS PRIVATE LIMITED",
"FAZIM IMPEX PRIVATE LIMITED",
"FAZLANI ACADEMY OF BUSINESS SCIENCES PRIVATE LIMITED",
"FAZLANI ENTERPRISES PRIVATE LIMITED",
"FAZLANI EXPORTS PRIVATE LIMITED",
"FAZLANI LACAD√âMIE GLOBALE",
"FB FASHION INTERNATIONAL PRIVATE LIMITED",
"FBA CONSULTING INDIA P LIMITED",
"FBC TECHNOLOGIES PRIVATE LIMITED",
"FBF ENTERTAINMENT PRIVATE LIMITED",
"FBF HOMOGENIZERS (I) PRIVATE LIMITED",
"FBO INFRA REALTY PRIVATE LIMITED",
"FBS BUSINESS SCHOOL",
"FBT PRIVATE LIMITED",
"FC EDUCATION SERVICES PRIVATE LIMITED",
"FC II LIFESTYLE RETAIL PRIVATE LIMITED",
"FC SOFTWARE PRIVATE LIMITED",
"FC TECNRGY PRIVATE LIMITED",
"FC-15 TRADERS PRIVATE LIMITED",
"FCA ENGINEERING INDIA PRIVATE LIMITED",
"FCA INDIA AUTOMOBILES PRIVATE LIMITED",
"FCAIT AUTOMOTIVE INDIA PRIVATE LIMITED",
"FCAP TECHNOLOGIES PRIVATE LIMITED",
"FCB GARMENT TEX INDIA PRIVATE LIMITED",
"FCBINTERFACE COMMUNICATIONS PRIVATE LIMITED",
"FCBULKA ADVERTISING PRIVATE LIMITED",
"FCC CLUTCH INDIA PRIVATE LIMITED",
"FCG FLAMEPROOF CONTROL GEARS PRIVATE LIMITED",
"FCG FOUNDRY PRIVATE LIMITED",
"FCG HI-TECH PRIVATE LIMITED",
"FCG POWER INDUSTRIES PRIVATE LIMITED",
"FCH TRAVEL SERVICES PRIVATE LIMITED",
"FCI ARAVALI GYPSUM AND MINERALS INDIA LIMITED",
"FCI GBS INDIA PRIVATE LIMITED",
"FCI OEN CONNECTORS LIMITED",
"FCM TRAVEL SOLUTIONS (INDIA) PRIVATE LIMITED",
"FCMD INDIA GEARS & CASTINGS PRIVATE LIMITED",
"FCML DISTRIBUTORS PRIVATE LIMITED",
"FCML PROJECTS PRIVATE LIMITED",
"FCML SURFACES PRIVATE LIMITED",
"FCOM TECHNOLOGY PRIVATE LIMITED",
"FCOOS TECHNOLOGIES PRIVATE LIMITED",
"FCS FLUORO CARBON SEALS PRIVATE LIMITED",
"FCS MANUFACTURING INDIA PRIVATE LIMITED",
"FCS SOFTWARE SOLUTIONS LIMITED",
"FCSONDHI AND CO. INDIA PRIVATE LIMITED",
"FCW TILES PRIVATE LIMITED",
"FDC LIMITED",
"FDC WEB TECHNOLOGIES PRIVATE LIMITED",
"FDCM GOREWADA ZOO LIMITED",
"FDHR PROTEIN FOODS PRIVATE LIMITED",
"FDI SERVICES AND FACILITIES LLP",
"FDR PROPERTY SERVICES PRIVATE LIMITED",
"FDRT CONSULTANCY SERVICES LIMITED",
"FE FUNDINFO INDIA PRIVATE LIMITED",
"FE GLOBAL TECHNOLOGY SERVICES PRIVATE LIMITED",
"FE SECURITIES PRIVATE LIMITED",
"FE TECHNO ENGINEERING & POWER SOLUTIONS LLP",
"FE26 FABRICATION PRIVATE LIMITED",
"FEAFU TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"FEAG ENGINEERS AND CONSTRUCTIONS PRIVATE LIMITED",
"FEARNLEYS SHIPBROKING PRIVATE LIMITED",
"FEAST SOFTWARE PRIVATE LIMITED",
"FEASTIC SERVICES PRIVATE LIMITED",
"FEASTLO ENTERPRISES PRIVATE LIMITED",
"FEASTY ENTERPRISES PRIVATE LIMITED",
"FEAT SYSTEMS PRIVATE LIMITED",
"FEATHER GRAPHICS INDIA PRIVATE LIMITED",
"FEATHER INFRACON PRIVATE LIMITED",
"FEATHER MEDIA PRIVATE LIMITED",
"FEATHER SPINTEX PRIVATE LIMITED",
"FEATHER TOUCH COATING PRIVATE LIMITED",
"FEATHER TOUCH IMPEX PRIVATE LIMITED",
"FEATHERFEEL NONWOVEN PRIVATE LIMITED",
"FEATHERLITE",
"FEATHERLITE COLLECTION KOLKATA",
"FEATHERLITE COLLECTIONS IN CHENNAI",
"FEATHERLITE OFFICE SYSTEMS PRIVATE LIMITED",
"FEATHERLITE PRODUCTS PRIVATE LIMITED",
"FEATHERLITE SOFTECH PRIVATE LIMITED",
"FEATHERS AUTO DISTRIBUTORS PRIVATE LIMITED",
"FEATHERS COOKWARE PRIVATE LIMITED",
"FEATHERS MANAGEMENT SERVICES PRIVATE LIMITED",
"FEATHERSOFT INFO SOLUTIONS PRIVATE LIMITED",
"FEATURE PLANET OPC PRIVATE LIMITED",
"FEATURETEK IT SOLUTIONS (OPC) PRIVATE LIMITED",
"FEBAZMART INFOTECH PRIVATE LIMITED",
"FEBCHEM ENGINEERING PRIVATE LIMITED",
"FEBIN MARINE FOODS",
"FEBO ENGINEERING PRIVATE LIMITED",
"FEBRUARY COMMUNICATIONS PRIVATE LIMITED",
"FEC CLEARING PRIVATE LIMITED",
"FEC ENGINEERING PROJECTS PRIVATE LIMITED",
"FEC GLOBAL LOGISTICS PRIVATE LIMITED",
"FEC INDIA PRIVATE LIMITED",
"FEC SHIPPING PRIVATE LIMITED",
"FECON ENGINEERING PVT LTD",
"FECPI INDIA PRIVATE LIMITED",
"FECUND SOFTWARE SERVICES PRIVATE LIMITED",
"FEDBANK FINANCIAL SERVICES LIMITED",
"FEDE INDUSTRIES PRIVATE LIMITED",
"FEDELE AUTOCORE PRIVATE LIMITED",
"FEDELTY HEALTHCARE PRIVATE LIMITED",
"FEDERAL AGRO INDUSTRIES PRIVATE. LIMITED.",
"FEDERAL BANK",
"FEDERAL ENGINEERS",
"FEDERAL EXPRESS CORPN",
"FEDERAL INSTITUTE OF TECHNOLOGY",
"FEDERAL MOGUL BEARINGS INDIA LIMITED",
"FEDERAL MOGUL GOETZE INDIA LIMITED",
"FEDERAL MOGUL IGNITION PRODUCTS INDIA LIMITED",
"FEDERAL MOGUL POWERTRAIN SOLUTIONS INDIA PRIVATE LIMITED",
"FEDERAL MOGUL SEALINGS INDIA LIMITED",
"FEDERAL OPERATIONS AND SERVICES LIMITED",
"FEDERAL PUBLIC SCHOOL",
"FEDERAL SECURITY PRIVATE LIMITED",
"FEDERAL SOFT SYSTEMS PRIVATE LIMITED",
"FEDERAL SYNERGIES (INDIA) PRIVATE LIMITED",
"FEDERAL TRANSPORT PRIVATE LIMITED",
"FEDERAL-MOGUL MOTORPARTS (INDIA) LIMITED",
"FEDERAL-MOGUL POWERTRAIN SOLUTIONS INDIA PRIVATE LIMITED",
"FEDERAL-MOGUL TPR (INDIA) LIMITED",
"FEDERATE CONSULTING PRIVATE LIMITED",
"FEDERATION OF AUTOMOBILE DEALERS ASSOCIATIONS TFR.FROM MUMBAI TO DELHI",
"FEDERATION OF INDIA MINERAL INDUSTRIES",
"FEDERATION OF INDIAN ANIMAL PROTECTION ORGANISATIONS",
"FEDERATION OF INDIAN CHAMBER OF COMMERCE AND INDUSTRY",
"FEDERATION OF INDIAN EXPORT ORGANISATIONS",
"FEDERATION OF INDIAN SPICE STAKEHOLDERS",
"FEDERATION OF INDUSTRIES OF INDIA-TMA",
"FEDERATION OF KUTCH INDUSTRIES ASSOCIATIONS",
"FEDERATION OF MIGROS COOPERATIVES",
"FEDERATION OF MOTOR SPORTS CLUB OF INDIA PRIVATE LIMITED",
"FEDERATION OF SEED INDUSTRY OF INDIA",
"FEDERTEK SOLUTIONS PRIVATE LIMITED",
"FEDEX CORPORATION",
"FEDEX EXPRESS TRANSPORTATION AND SUPPLY CHAIN SERVICES (INDIA) PRIVATE LIMITED",
"FEDEX EXPRESS TRANSPORTATION AND SUPPLY CHAIN SERVICES INDIA PRIVATE LIMITED",
"FEDEX EXPRESS TSCS PRIVATE LIMITED",
"FEDEX FINANCE PRIVATE LIMITED",
"FEDEX SECURITIES PRIVATE LIMITED",
"FEDEX TRADER NETWORKS TRANSPORTS AND BROKERAGE PRIVATE LIMITED",
"FEDIFY TECHNOLOGIES PRIVATE LIMITED",
"FEDIN ENGINEERING PRIVATE LIMITED",
"FEDLEY HEALTHCARE PRIVATE LIMITED",
"FEDORA SEA FOODS PRIVATE. LIMITED.",
"FEDORA SOLUTIONS LLP",
"FEDRUS CONSULTANCY LLP",
"FEED FORWARD TECHNOLOGIES PRIVATE LIMITED",
"FEEDBACK ADVISORY SERVICES PRIVATE LIMITED",
"FEEDBACK BUSINESS CONSULTING SERVICES PRIVATE LIMITED",
"FEEDBACK BUSINESS INSIGHTS PRIVATE LIMITED",
"FEEDBACK COMMUNICATION PVT LTD",
"FEEDBACK ENERGY DISTRIBUTION COMPANY LIMITED",
"FEEDBACK HIGHWAYS OMT PRIVATE LIMITED",
"FEEDBACK INFRA PRIVATE. LIMITED.",
"FEEDBACK POWER OPERATIONS & MAINTENANCE SERVICES PRIVATE LIMITED",
"FEEDING BILLIONS PRIVATE LIMITED",
"FEEDKART PROTEINS PRIVATE LIMITED",
"FEEDPRO AGRO PRIVATE LIMITED",
"FEEDPRO HATCHERIES & FARMS PRIVATE LIMITED",
"FEEDX FOODS PRIVATE LIMITED",
"FEEGRADE & COMPANY PRIVATE. LIMITED RUNGTA GROUP ENTITY",
"FEEL BOOKS PRIVATE LIMITED",
"FEELINGS FASHION INDIA PRIVATE LIMITED",
"FEELIT APPARELS PRIVATE LIMITED",
"FEELWELL GARMENTS & ACCESSORIES PRIVATE LIMITED",
"FEENIX PRINT PACK PRIVATE LIMITED",
"FEENIXX HOSPITALS PRIVATE LIMITED",
"FEEWA ENERGY PRIVATE LIMITED",
"FEG INDIA SOLUTIONS PRIVATE LIMITED",
"FEI CARGO LIMITED",
"FEIN POWER TOOLS INDIA PRIVATE LIMITED",
"FELDER UK LIMITED",
"FELDER WOODWORKING MACHINES PRIVATE LIMITED",
"FELDON DEVELOPERS PRIVATE LIMITED",
"FELGUERA GRUAS INDIA PRIVATE LIMITED",
"FELICITAS DIGITECH PRIVATE LIMITED",
"FELICITY ADOBE LLP",
"FELICITY PROJECTS PRIVATE LIMITED",
"FELIDAE INFOSEC PRIVATE LIMITED",
"FELIS CREATIONS PRIVATE LIMITED",
"FELIX ADVISORY PRIVATE LIMITED",
"FELIX FASHION RETAILERS LLP",
"FELIX GENERICS PRIVATE LIMITED",
"FELIX HEALTHCARE PRIVATE LIMITED",
"FELIX HYPERSTORE AND RETAIL PRIVATE LIMITED",
"FELIX IMPEX PRIVATE LIMITED",
"FELIX INDUSTRIES LIMITED",
"FELIX INFOTECH PRIVATE LIMITED",
"FELIX SOLUTIONS.AI",
"FELIX TOOLS PRIVATE LIMITED",
"FELIZ ENVIO INDUSTRIES PRIVATE LIMITED",
"FELLA TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"FELLER CONSULTING ENGINEERS PRIVATE LIMITED",
"FELLOWSHIP MISSION SCHOOL",
"FELSOMAT INDIA PRIVATE LIMITED",
"FELTRON INDUSTRIES PRIVATE LIMITED",
"FELURIAN TECHNOLOGY PRIVATE LIMITED",
"FEM CONSTRUCTIONS INDIA PRIVATE LIMITED",
"FEMCITY HOSPITAL PRIVATE LIMITED",
"FEMCO DISTRIBUTION PRIVATE LIMITED",
"FEMCO FILTERS PRIVATE LIMITED",
"FEMELIFE FERTILITY FOUNDATION PRIVATE LIMITED",
"FEMELLA FASHIONS LIMITED",
"FEMERELL APPLIANCES PRIVATE LIMITED",
"FEMI INTERNATIONAL PRIVATE LIMITED",
"FEMINA INSTRUMENT PRIVATE LIMITED",
"FEMINA SHOPPING MALL (HYPER) PRIVATE LIMITED",
"FEMINA SHOPPING MALL PRIVATE LIMITED",
"FEMININE AND INFANT HEALTHCARE PRIVATE LIMITED",
"FEMMEVISTA TECHNOLOGIES PRIVATE LIMITED",
"FEMORA INDIA PRIVATE LIMITED",
"FEMOTECH ENTERPRISES PRIVATE LIMITED",
"FEMSTEX TRADING COMPANY PRIVATE LIMITED",
"FEMURA PHARMACEUTICALS PRIVATE LIMITED",
"FENA P LIMITED",
"FENASIA LIMITED",
"FENCER SERVICES PRIVATE LIMITED",
"FENCEWORKS PRODUCTION PRIVATE LIMITED",
"FENDA AUDIO INDIA PRIVATE LIMITED",
"FENDAHL TECHNOLOGY PRIVATE LIMITED",
"FENDERCARE MARINE OMEGA INDIA PRIVATE LIMITED",
"FENESTA BUILDING SYSTEMS",
"FENESTEC TOOLS & DIES PRIVATE LIMITED",
"FENESTRA PHARMACEUTICALS PRIVATE LIMITED",
"FENESTRATION SYSTEMS PRIVATE LIMITED",
"FENETRE UPVC PRIVATE LIMITED",
"FENG HUA NEW ENERGY PRIVATE LIMITED",
"FENGYUAN INDIA PRIVATE LIMITED",
"FENICIA HOSPITALITY SERVICES PRIVATE LIMITED",
"FENIX ART",
"FENIX COMMERCE PLATFORMS PRIVATE LIMITED",
"FENIX COMPUTECH PRIVATE LIMITED",
"FENIX PROCESS TECHNOLOGIES PRIVATE LIMITED",
"FENIX ROCKSTONE INDIA PRIVATE LIMITED",
"FENIX SYSTEMS AND PROJECTS PRIVATE LIMITED",
"FENIX TOURS AND TRAVELS PRIVATE LIMITED",
"FENIX WATER SOLUTIONS INDIA PRIVATE LIMITED",
"FENMAN TECHNOLOGIES INDIA PRIVATE LIMITED",
"FENNEL DEVELOPERS PRIVATE LIMITED",
"FENNER CONVEYOR BELTING PRIVATE LIMITED",
"FENNY CHEM INDUSTRIES P LTD",
"FENO BUSINESS SOLUTIONS PRIVATE LIMITED",
"FENOMENA FURNITURES PRIVATE LIMITED",
"FENOPIX TECHNOLOGIES PRIVATE LIMITED",
"FENOPLAST LIMITED.",
"FENPRO SOLUTIONS PRIVATE LIMITED",
"FENSTERBAU LINGEL INDIA PRIVATE LIMITED",
"FENTINO FABRICS PRIVATE LIMITED",
"FENZGARD INDIA PRIVATE LIMITED",
"FENZY STYLES PRIVATE LIMITED",
"FERANI HOTELS PRIVATE LIMITED",
"FERCO SHUTTERS AND SEATING SYSTEMS PRIVATE LIMITED",
"FERGUS SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"FERGUSON COLLEGE",
"FERIS SPINTEX PRIVATE LIMITED",
"FERMAT MACHINERY PRIVATE LIMITED",
"FERMAT PRIME ENTERPRISES PRIVATE LIMITED",
"FERMENTA BIOTECH LIMITED",
"FERMENTIS LIFE SCIENCES PRIVATE LIMITED",
"FERMENTRAS INDIA PRIVATE LIMITED",
"FERMI SOLARFARMS PRIVATE LIMITED",
"FERMISH CLINICAL TECHNOLOGIES PRIVATE LIMITED",
"FERMIUM CONSTRUCTIONS LLP",
"FERMWELL FOODS PRIVATE LIMITED",
"FERMYON TECHNOLOGIES INDIA PRIVATE LIMITED",
"FERN AGRI SOLUTIONS PRIVATE LIMITED",
"FERN AND HAZEL ADVISORY PRIVATE LIMITED",
"FERN AVIATION INDIA PRIVATE LIMITED",
"FERN AVIATION PRIVATE LIMITED",
"FERN BIS SOFTWARE PRIVATE LIMITED",
"FERN TECHNOCAST PRIVATE LIMITED",
"FERNANDES BROTHERS",
"FERNANDEZ FOUNDATION",
"FERNANDEZ HOSPITAL PRIVATE LIMITED",
"FERNHILL HOTELS PRIVATE LIMITED",
"FERNS CARGO EXPRESS PRIVATE LIMITED",
"FERNS EQUITY ADVISORS PRIVATE LIMITED",
"FERNS FINE FOODS PRIVATE LIMITED",
"FERNS FOREST SALES PRIVATE LIMITED",
"FERNS N PETALS INDIA PRIVATE LIMITED",
"FERNS N PETALS PVT LTD",
"FERNTASTICA GARDENS LIMITED",
"FEROAI FREIGHT TECHNOLOGIES LLP",
"FEROCAST FOUNDRIES COIMBATORE PRIVATE LIMITED",
"FEROKE BOARDS LIMITED",
"FEROLITE JOINTINGS LIMITED.",
"FEROZE CONSTRUCTION PRIVATE LIMITED",
"FEROZEPUR FOODS PVT LTD",
"FERRA AEROSPACE PRIVATE LIMITED",
"FERRAGAMO RETAIL INDIA PRIVATE LIMITED",
"FERRAILLE GLOBAL PRIVATE LIMITED",
"FERRARI EASTERN FANS INDIA PRIVATE LIMITED",
"FERRARI SHOES INDIA PRIVATE LIMITED",
"FERRENZO INDIA PRIVATE LIMITED",
"FERRERO INDIA PRIVATE LIMITED",
"FERRERO VINYL TECHNOLOGIES PRIVATE LIMITED",
"FERRETERRO HOISTS PRIVATE LIMITED",
"FERRETERRO INDIA PRIVATE LIMITED",
"FERRGRA ENTERPRISES PRIVATE LIMITED",
"FERRI LABS (OPC) PRIVATE LIMITED",
"FERRICO ELECTRONICS PRIVATE LIMITED",
"FERRICON EQUIPMENTS INDIA PRIVATE. LIMITED",
"FERRIE TRADERS PRIVATE LIMITED",
"FERRING LABORATORIES PRIVATE LIMITED",
"FERRING PHARMACEUTICALS PRIVATE LIMITED",
"FERRING THERAPEUTICS PRIVATE LIMITED",
"FERRITE METAL SOLUTIONS PRIVATE LIMITED",
"FERRITE STRUCTURAL STEELS PRIVATE LIMITED",
"FERRO ALLOYS CORPORATION LIMITED",
"FERRO CONCRETE CONSTRUCTION INDIAPVT LTD",
"FERRO CUT AND BEND CENTRE PRIVATE LIMITED",
"FERRO FOUNDRIES PRIVATE LIMITED",
"FERRO INDIA PRIVATE LIMITED",
"FERRO OILTEK PRIVATE LIMITED",
"FERRO SCRAP NIGAM LIMITED",
"FERRO SONA GARMENTS PRIVATE LIMITED",
"FERRO TECH INDIA PRIVATE LIMITED",
"FERROCARE MACHINES PRIVATE LIMITED",
"FERROCHEM NDT SYSTEMS PRIVATE LIMITED",
"FERRODYNAMICS PRIVATE LIMITED",
"FERROLI HEATING SOUTH ASIA PRIVATE LIMITED",
"FERROMAR SHIPPING PRIVATE LIMITED",
"FERROMATRICS HEAT TREATMENT PRIVATE LIMITED",
"FERROMAX FOUNDRIES INDIA PRIVATE LIMITED",
"FERROMET FORGE PRIVATE LIMITED",
"FERROMET MARKETING COMPANY PRIVATE LIMITED",
"FERROMONK STEEL STRUCTURES PRIVATE LIMITED",
"FERRON EQUIPMENTS PRIVATE LIMITED",
"FERRON LIFECARE PRIVATE LIMITED",
"FERRON TUBES PRIVATE LIMITED",
"FERRONITE METAL TREATMENT INDIA PRIVATE LIMITED",
"FERROTECH STRUCTURALS INDIA PRIVATE LIMITED",
"FERROTHERM INDUCTION PRIVATE LIMITED",
"FERROUS CRETE INDIA PRIVATE LIMITED",
"FERROUS TOWNSHIP PRIVATE LIMITED",
"FERROVIA TECH PRIVATE LIMITED",
"FERROVIA TRANSRAIL SOLUTIONS PRIVATE. LIMITED.",
"FERROX CHEMICALS PRIVATE LIMITED",
"FERRUM ALLOYS PRIVATE LIMITED",
"FERRUM EXTREME ENGINEERING PRIVATE LIMITED",
"FERRUM METALS PRIVATE LIMITED",
"FERRUM TECHNOLOGIES INDIA PRIVATE LIMITED",
"FERRYMILL FINANCIAL TECHNOLOGY PRIVATE LIMITED",
"FERTICARE IVF CENTRE",
"FERTICHEM (INDIA) VENTURES PRIVATE LIMITED",
"FERTICHEM ENTERPRISES PRIVATE LIMITED",
"FERTICHEM PLANT SHAKTI AGRO PRIVATE LIMITED",
"FERTICITY IVF CLINICS PRIVATE LIMITED",
"FERTILE AGROCHEM LIMITED",
"FERTILISERS AND CHEMICALS TRAVANCORE LTD",
"FERTILITY CARE INDIA ART SERVICES PRIVATE LIMITED",
"FERTILIZER CORPORATION OF INDIA LIMITED",
"FERTILSERS & CHEM - TRAVANCORE",
"FERTILTREE PRIVATE LIMITED",
"FERTIN INDIA PRIVATE LIMITED",
"FERTINAGRO INDIA PRIVATE LIMITED",
"FERTINVEST SERVICES PRIVATE LIMITED",
"FERTIPLANT ENGINEERING COMPANY PRIVATE LIMITED",
"FERTIS INDIA PRIVATE LIMITED",
"FERTIS VENTURES PRIVATE LIMITED",
"FERTIVISION HEALTHCARE PRIVATE LIMITED",
"FERVENT COMMUNICATION PRIVATE LIMITED",
"FERVENT SYNERGIES LIMITED",
"FERVID PRO IT SOLUTIONS PRIVATE LIMITED",
"FERVID SMART SOLUTIONS PRIVATE LIMITED",
"FERYEZ POLYMER PVT LTD",
"FESIC FORGING PRIVATE LIMITED",
"FESOLVE ENGINEERING SERVICES PRIVATE LIMITED",
"FESSIL MINERALS PRIVATE LIMITED",
"FEST HOMES DEVELOPERS PRIVATE LIMITED",
"FESTA SOLAR PRIVATE LIMITED",
"FESTAL CONSULTING ENGINEERS PRIVATE LIMITED",
"FESTAL INFRASTRUCTURE PRIVATE LIMITED",
"FESTEX INDIA PRIVATE LIMITED",
"FESTINO MARKETING COMPANY PVT LTD",
"FESTINO VINCOM LIMITED",
"FESTIVA GLOBAL BEVERAGES PRIVATE LIMITED",
"FESTIVAL TRADERS LTD",
"FESTIVE FASHION PRIVATE LIMITED",
"FESTO INDIA PRIVATE LIMITED",
"FESTUS PROPERTIES PRIVATE LIMITED",
"FETCH CONSULTING PRIVATE LIMITED",
"FETOMED LABORATORIES PRIVATE LIMITED",
"FETTE COMPACTING MACHINERY INDIA PRIVATE LIMITED",
"FETTLE CONSTRUCTIONS PRIVATE LIMITED",
"FEV INDIA PRIVATE LIMITED",
"FEVER INDIA LIMITED",
"FEW ENGINEERING PRIVATE LIMITED",
"FEWAL CHEM PRIVATE LIMITED",
"FEX MULTICHEM PRIVATE LIMITED",
"FEXLE SERVICES PRIVATE LIMITED",
"FEZCO FASTENERS PRIVATE LIMITED",
"FF AND E FITOUT PRIVATE LIMITED",
"FF BIOWORKS (INDIA) PRIVATE LIMITED",
"FF INTERNATIONAL LIMITED",
"FFA TRAVELS PRIVATE LIMITED",
"FFAB CREATTIONS PRIVATE LIMITED",
"FFC AROMAS PVT LTD",
"FFD INFORMATION SOLUTION PRIVATE LIMITED",
"FFFC PRIVATE LIMITED",
"FFL CUISINES PRIVATE LIMITED",
"FFLYBIRD SHIPPING SOLUTIONS PRIVATE LIMITED",
"FFP ECO TECHNOLOGIES PRIVATE LIMITED",
"FFREEDOM INTERMEDIARY INFRASTRUCTURE PRIVATE LIMITED",
"FFS INDUSTRIES PRIVATE LIMITED",
"FFSERVICES PRIVATE LIMITED",
"FFT HIMALAYAN FRESH PRODUCE PRIVATE LIMITED",
"FG FACILITY SERVICES PRIVATE LIMITED",
"FG GLASS INDUSTRIES PRIVATE LIMITED",
"FG MOTORCYCLES PRIVATE LIMITED",
"FG PHARMA PRIVATE LIMITED",
"FG&G DISTRIBUTION PRIVATE LIMITED",
"FGDC INDIA PRIVATE LIMITED",
"FGK THERMAL PVT LTD",
"F-GRADE GLOBAL SERVICES PRIVATE LIMITED",
"FHHL PRIVATE LIMITED",
"FHS ACCELERATOR CONSULTANCY AND SERVICES PRIVATE LIMITED",
"FI ES SYSTEMS PRIVATE LIMITED",
"FI HAVOCK DIGITAL PRIVATE LIMITED",
"FI HI FINTECH PRIVATE LIMITED",
"FI TEK PRIVATE LIMITED",
"FIABILA INDIA PRIVATE LIMITED",
"FIABILTE NETWORK SOLUTIONS PRIVATE LIMITED",
"FIABLE CLEANTECH PRIVATE LIMITED",
"FIADO INDUSTRIES PRIVATE LIMITED",
"FIARE SOFTWARE PRIVATE LIMITED",
"FIAT ACCORD FABRIC PRIVATE LIMITED",
"FIAT AGROPOWER PRIVATE LIMITED",
"FIAT INDIA AUTOMOBILES PRIVATE LIMITED",
"FIAT INTERNATIONAL SPA",
"FIAWIN INTERNATIONAL PRIVATE LIMITED",
"FIB 2 FAB",
"FIBA HARDWYN LOCKS LIMITED",
"FIBA NEW FIELD GAS TECHNOLOGY PRODUCTS PRIVATE LIMITED",
"FIBACT CONSULTING AND COMPLIANCE SERVICES PRIVATE LIMITED",
"FIBAS EXCLUSIVE KITCHENWARE PRIVATE LIMITED",
"FIBCONNECT PRIVATE LIMITED",
"FIBCORP POLYWEAVE PRIVATE LIMITED",
"FIBER FAMILY PRODUCTS PRIVATE LIMITED",
"FIBER OPTIC SENSING SOLUTIONS PRIVATE LIMITED",
"FIBER OPTIKA TECHNOLOGIES PRIVATE LIMITED",
"FIBER PLUS INDUSTIES LIMITED",
"FIBERFILL INSULATIONS (INDIA) PRIVATE LIMITED",
"FIBERFILL INTERIORS & CONSTRUCTIONS (INDIA) PRIVATE LIMITED.",
"FIBERHOME INDIA PRIVATE LIMITED",
"FIBERLINK SOFTWARE PRIVATE LIMITED",
"FIBERMITE COMPOSITES LIMITED",
"FIBERR DIGITAL NETWORK PRIVATE LIMITED",
"FIBERTECH COMPOSITE PRIVATE LIMITED",
"FIBERTEK COMMUNICATION PRIVATE LIMITED",
"FIBERTEX PRIVATE LIMITED",
"FIBERX NETWORKS PRIVATE LIMITED",
"FIBOVIL PHARMACEUTICALS PRIVATE LIMITED",
"FIBOX INDIA PRIVATE LIMITED",
"FIBRE ABRASIVE MACHINERIES PRIVATE LIMITED",
"FIBRE AIR SERVICES PRIVATE LIMITED",
"FIBRE DYNAMICS INDIA PRIVATE LIMITED",
"FIBRE FOILS LIMITED",
"FIBRE IMPEX PRIVATE LIMITED",
"FIBRE MANUFACTURER & EXPORTERS PVT LTD",
"FIBRE QUEEN MATTRESSES PRIVATE LIMITED",
"FIBRE SHAKTI INDUSTRIES PRIVATE LIMITED",
"FIBRE TRADE LINC PRIVATE LIMITED",
"FIBRE2FASHION RETAIL PRIVATE LIMITED",
"FIBREMARX PAPERS PRIVATE LIMITED",
"FIBRES AND FABRICS INTERNATIONAL PRIVATE LIMITED",
"FIBRETECH LEATHERS PRIVATE LIMITED",
"FIBRETEX INDIA PRIVATE LIMITED",
"FIBREX CONSTRUCTION CHEMICALS PRIVATE LIMITED",
"FIBRIL TEX PRIVATE LIMITED",
"FIBRO EDTECH PRIVATE LIMITED",
"FIBRO GRATS PRIVATE LIMITED",
"FIBRO INDIA PRECISION PRODUCT PRIVATE LIMITED",
"FIBRO PACKS PRIVATE LIMITED",
"FIBRO PAPER TUBE PVT LTD",
"FIBRO PLAST CORPORATION",
"FIBRO PLASTICHEM INDIA PRIVATE LIMITED",
"FIBRO REINFORCED PLASTICS PRIVATE LIMITED",
"FIBROFLEX INDIA PRIVATE LIMITED",
"FIBROL NON - IONICS PRIVATE LIMITED",
"FIBROPLAST MARINE PRIVATE LIMITED",
"FIBROUS VILLA PRIVATE LIMITED",
"FIBRSOL GLOBAL NETWORK LIMITED",
"FIBS LOGISTICS INDIA PRIVATE LIMITED",
"FIBZY INFRASOLUTIONS PRIVATE LIMITED",
"FIC ENGINEERING PRIVATE LIMITED",
"FICC CAPITAL PRIVATE LIMITED",
"FICCI RESERCH AND ANALYSIS CENTRE",
"FICE EDUCATION PRIVATE LIMITED",
"FICHTNER CONSULTING ENGINEERS INDIA PRIVATE LIMITED",
"FICKLE CONSULTANCY (INDIA) PRIVATE LIMITED",
"FICOM ENGINEERING PRIVATE LIMITED",
"FICON ALLUMINIUM PRIVATE LIMITED",
"FICOSA INDIA ENGINEERING CENTER PRIVATE LIMITED",
"FICOSA RETAIL SERVICES PRIVATE LIMITED",
"FICS AUTOMATION PRIVATE LIMITED",
"FICTION2FACT SOLUTIONS PRIVATE LIMITED",
"FICUS E LOGIC PRIVATE LIMITED",
"FICUS MERCANTILE LIMITED",
"FICUS PAX PRIVATE LIMITED",
"FICUS VENTURES PRIVATE LIMITED",
"FIDA FILM AND HOTEL COMPANY PRIVATE LIMITED",
"FIDALGO ESTATES PRIVATE LIMITED",
"FIDALGO LABORATORIES PVT LTD",
"FIDATO BUILDCON PRIVATE LIMITED",
"FIDATO CAR SERVICES PRIVATE LIMITED",
"FIDATO CONSULTANTS PRIVATE LIMITED",
"FIDDOS CARE PRIVATE LIMITED",
"FIDEL PUMP PRIVATE LIMITED",
"FIDEL SOFTECH LIMITED",
"FIDEL SOFTECH PRIVATE LIMITED",
"FIDELIS BUSINESS SERVICES PRIVATE LIMITED",
"FIDELIS GLOBAL SERVICES PRIVATE LIMITED",
"FIDELIS HEALTHCARE PRIVATE LIMITED",
"FIDELIS INTERNATIONAL PRIVATE LIMITED",
"FIDELIS MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"FIDELIS TECHNOLOGY SERVICES PRIVATE LIMITED",
"FIDELISGLOBAL MOVING & STORAGE PRIVATE LIMITED",
"FIDELITAS RCM PRIVATE LIMITED",
"FIDELITE FACILITIES AND SERVICES PRIVATE LIMITED",
"FIDELITUS CORP PROPERTY SERVICES PRIVATE LIMITED",
"FIDELITY AGRO PRIVATE LIMITED",
"FIDELITY BUILDERS AND PROMOTERS PRIVATE LIMITED",
"FIDELITY BUSINESS SERVICES INDIA PRIVATE LIMITED",
"FIDELITY DIAGNOSTICS PRIVATE LIMITED",
"FIDELITY ENTERPRISES PRIVATE LIMITED",
"FIDELITY FORGE PRIVATE LIMITED",
"FIDELITY INFORMATION SERVICES INDIA PRIVATE LIMITED",
"FIDELITY INVESTMENTS LIMITED",
"FIDELITY LIFE SCIENCES PRIVATE LIMITED",
"FIDELITY MANAGEMENT AND SERVICES PRIVATE LIMITED",
"FIDELITY MANPOWER SERVICES PRIVATE LIMITED",
"FIDELITY MARKETING PVT LTD",
"FIDELITY NATIONAL FINANCIAL",
"FIDELITY TRADELINK PRIVATE LIMITED",
"FIDELO FARMS PRIVATE LIMITED",
"FIDERE FACILITIES MANAGEMENT PRIVATE LIMITED",
"FIDES CHEMICALS AND COMMODITIES PRIVATE LIMITED",
"FIDES DISTRIBUTION PRIVATE LIMITED",
"FIDES ELECTRONICS PRIVATE LIMITED",
"FIDES IT SERVICES PRIVATE LIMITED",
"FIDES SALES PRIVATE LIMITED",
"FIDES TEA IMPEX PRIVATE LIMITED",
"FIDESTA LOGISTICS PRIVATE LIMITED",
"FIDESTO PROJECTS PRIVATE LIMITED",
"FIDO PHARMA PRIVATE LIMITED",
"FIDROX TECHNOLOGIES PRIVATE LIMITED",
"FIDUCIA ACCOUNTING SERVICES PRIVATE LIMITED",
"FIDUCIAL INSURANCE BROKERS INDIA PRIVATE LIMITED",
"FIDUCIARY EUROMAX CAPITAL MARKETS PRIVATE LIMITED",
"FIDUCIARY SENIOR LIVING SERVICES PRIVATE LIMITED",
"FIDUCIVE TECH PRIVATE LIMITED",
"FIDUS ACHATES ENGINEERING PRIVATE LIMITED",
"FIDUS FINANCE PVT LTD",
"FIDUS HEALTH CARE LLP",
"FIDUS INDIA AUTOMATION PRIVATE LIMITED",
"FIDUS TRADING LTD",
"FIE REFINERIES AND CHEMICAL PRIVATE LIMITED",
"FIELD (RESEARCH UP PWD LKO)",
"FIELD DIVISION RESEARCH INSTITUTE UP PWD LKO",
"FIELD INTERACTIVE MR PRIVATE LIMITED",
"FIELD MOTOR LIMITED",
"FIELD PUMP PRIVATE LIMITED",
"FIELDCORE SERVICE SOLUTIONS INTERNATIONAL INDIA PRIVATE LIMITED",
"FIELDEZ TECHNOLOGIES PRIVATE LIMITED",
"FIELDGLOBAL MARKET RESEARCH PRIVATE LIMITED",
"FIELDKING POLYMERS",
"FIELDMAN ENGINEERS PRIVATE LIMITED",
"FIELDSTONE CONSTRUCTION PRIVATE LIMITED",
"FIELDTRACK EARTHMOVERS PRIVATE LIMITED",
"FIEM INDUSTRIES LIMITED",
"FIERA CAPITAL INVESTMENT ADVISORS INDIA PRIVATE LIMITED",
"FIERCE HOME APPLIANCES PRIVATE LIMITED",
"FIERY DIGITAL IMAGING INDIA PRIVATE LIMITED",
"FIESTA CAR RENTALS & LOGISTICS PRIVATE LIMITED",
"FIESTA EATERY PRIVATE LIMITED",
"FIESTA ENETERTINMENT PRIVATE LIMITED",
"FIESTA ENTERTAINMENT PRIVATE LIMITED",
"FIESTA PROPBUILD PRIVATE LIMITED",
"FIESTRO HOLIDAYS PRIVATE LIMITED",
"FIESTTA FAB PRIVATE LIMITED",
"FIETA SALES & SERVICES LIMITED",
"FIFO FUTURE PRIVATE LIMITED",
"FIFTH AVENUE IMPEX PRIVATE LIMITED",
"FIFTH AVENUE PROMOTERS PRIVATE LIMITED",
"FIFTH DIMENSION STUDIO PRIVATE LIMITED",
"FIFTH ESTATE COMMUNICATIONS PRIVATE LIMITED",
"FIFTH GEAR VENTURES LIMITED",
"FIFTH GENERATION TECHNOLOGIES INDIA PRIVATE LIMITED",
"FIFTH QUARTER INFOMEDIA PRIVATE LIMITED",
"FIFTH SENSE NATURALS PRIVATE LIMITED",
"FIFTH THIRD BANCORP",
"FIFTHTRY PRIVATE LIMITED",
"FIFTY PLUS SCIENTIFIC ENTERPRISES PRIVATE LIMITED",
"FIFTYFIVE TECHNOLOGIES PRIVATE LIMITED",
"FIGEIT E-MARKETPLACE PRIVATE LIMITED",
"FIGHTER FIRST ARMY STATE INDUSTRIAL SECURITY FORCE REWA MADHYA PRADESH",
"FIGHTER SUCCESS SYSTEM PRIVATE LIMITED",
"FIGHTING FOUR SECURITY SERVICES PRIVATE LIMITED",
"FIGMD (INDIA) PRIVATE LIMITED",
"FIGMENT GLOBAL SOLUTIONS PRIVATE LIMITED",
"FIGOMED HEALTH CARE PRIVATE LIMITED",
"FIGROVIN COMMUNICATION SERVICES PRIVATE LIMITED",
"FIGTREE FOODS PRIVATE LIMITED",
"FIGURE 99 MEGA MART PRIVATE LIMITED",
"FIH INDIA DEVELOPER PRIVATE LIMITED",
"FIH INDIA PRIVATE LIMITED",
"FIIT JEE FOUNDATION FOR EDUCATION RESEARCH AND TRAINING",
"FIIT JEE LIMITED",
"FIITJEE FOUNDATION FOR EDUCATION RESEACH AND TRAINING",
"FIL FUND MANAGEMENT PRIVATE LIMITED",
"FIL INDIA BUSINESS AND RESEARCH SERVICES PRIVATE LIMITED",
"FIL INDUSTRIES LIMITED",
"FIL LOGISTICS PRIVATE LIMITED",
"FIL SEP EQUIPMENTS PRIVATE LIMITED",
"FILARIA SURVEY UNIT",
"FILARUB PRIVATE LIMITED",
"FILATECH ENTERPRISE PRIVATE LIMITED",
"FILATEX FASHIONS LIMITED",
"FILATEX INDIA LIMITED",
"FILATEX INDIA LIMITEDTR.CO.FROM DELHI",
"FILATEX VCT PRIVATE LIMITED",
"FILATEX-VECHUKUNNEL PRIVATE LIMITED",
"FILBERTS INFRAPROJECTS PRIVATE LIMITED",
"FILCATEX INDUSTRIES PRIVATE LIMITED",
"FILCO TRADE CENTRE PRIVATE LIMITED",
"FILEX SYSTEMS PRIVATE LIMITED",
"FILFULL VENTURES PRIVATE LIMITED",
"FILIX CONSULTING PRIVATE LIMITED",
"FILLENPAC INDUSTRIES PRIVATE LIMITED",
"FILLING SPACE INDIA PRIVATE LIMITED",
"FILLINGSPOT SERVICES PRIVATE LIMITED",
"FILLON TECHNOLOGIES INDIA PRIVATE LIMITED",
"FILM & TELEVISION INSTITUTE OF INDIA",
"FILM AND TELEVISION INSTITUTE OF INDIA",
"FILM ELECTRONICS PRIVATE LIMITED",
"FILM FARM INDIA PRIVATE LIMITED",
"FILM HERITAGE FOUNDATION",
"FILMALAYA PRIVATE LIMITED",
"FILMAN FILTRATIONS PRIVATE LIMITED",
"FILMBOARD MOVIE TECHNOLOGIES PRIVATE LIMITED",
"FILMEDIA COMMUNICATION SYSTEMS PRIVATE LIMITED",
"FILMLAB I PRIVATE LIMITED",
"FILMORE LED PRIVATE LIMITED",
"FILMPAC PRIVATE LIMITED",
"FILMQUEST ENTERTAINMENT PRIVATE LIMITED",
"FILMS DIVISION",
"FILMTEC SOLAR PRIVATE LIMITED",
"FILMY KEEDA PRODUCTIONS PRIVATE LIMITED",
"FILMYCURRY PRIVATE LIMITED",
"FILOS HOSPITALITY VENTURES PRIVATE LIMITED",
"FILOS HOTELS PRIVATE LIMITED",
"FILOSHA FIBRES PRIVATE LIMITED",
"FILOSHA INFOTECH PRIVATE LIMITED",
"FILPAK (INDIA) PRIVATE LIMITED",
"FILPRO SENSORS PRIVATE LIMITED",
"FILSILPEK SOLUTIONS PRIVATE LIMITED",
"FILTECH FABRICS PRIVATE LIMITED",
"FILTER CONCEPT PRIVATE LIMITED",
"FILTER FLOW ENGINEERING PRIVATE LIMITED",
"FILTER MACHINES PRIVATE LIMITED",
"FILTER MAX IMPEX PRIVATE LIMITED",
"FILTER MEDIA PRIVATE LIMITED",
"FILTERATION ENGINEERS INDIA PRIVATE LIMITED",
"FILTERCAT PRODUCTS PRIVATE LIMITED",
"FILTRA CATALYSTS & CHEMICALS LIMITED",
"FILTRA CONSULTANTS AND ENGINEERS LIMITED",
"FILTRATION PRODUCTS",
"FILTRATION SYSTEM SOLUTIONS (INDIA) PRIVATE LIMITED",
"FILTRATION TECHNIK INDIA PRIVATE LIMITED",
"FILTREC BHARAT MANUFACTURING PRIVATE LIMITED",
"FILTREX TECHNOLOGIES PRIVATE LIMITED",
"FILTRON ENGINEERS LIMITED",
"FILTRUM AUTOCOMP PRIVATE LIMITED",
"FILTRUM TOOLS AND COMPONENTS PRIVATE LIMITED",
"FIMA JAL FAUCETS PRIVATE LIMITED",
"FIMAKEM INDIA LIMITED",
"FIME INDIA PRIVATE LIMITED",
"FIMEN FIBER PRODUCTS PRIVATE LIMITED",
"FIMER INDIA PRIVATE LIMITED",
"FIMO INDIA MANUFACTURING PRIVATE LIMITED",
"FIMOSYS INFRASTRUCTURE PRIVATE LIMITED",
"FIMS HOSPITAL",
"FIN INFOCOM PRIVATE LIMITED",
"FIN LABS AUDIO PRIVATE LIMITED",
"FIN POWER AIRCON SYSTEMS PRIVATE LIMITED",
"FIN TRESTLE PRIVATE LIMITED",
"FINACCT TECHNOLOGIES PRIVATE LIMITED",
"FINACPLUS GLOBAL SERVICES PRIVATE LIMITED",
"FINACRI ADVISORY INTERMEDIARY & RESOURCES PRIVATE LIMITED",
"FINACUS SOLUTIONS PRIVATE LIMITED",
"FINADVANTAGE CONSULTING PRIVATE LIMITED",
"FINAGG TECHNOLOGIES PRIVATE LIMITED",
"FINAIR AIRCONDITIONING PRIVATE LIMITED",
"FINAKS ADVISORY SERVICES PRIVATE LIMITED",
"FINAL HEALTHCARE AND DIAGNOSIS PRIVATE LIMITED",
"FINAL MILE CONSULTANTS PRIVATE LIMITED",
"FINAL TECHNOLOGIES PRIVATE LIMITED",
"FINANCE DEPARTMENT GOVT OF ODISHA",
"FINANCE DEPARTMENT P S KADEGAON",
"FINANCE DEPT.GOVT.",
"FINANCE DOCTOR PRIVATE LIMITED",
"FINANCE MONITOR (INDIA) PVT LTD",
"FINANCIAL AGENCY CONSULTANTS INDIA PRIVATE LIMITED",
"FINANCIAL BENCHMARKS INDIA PRIVATE LIMITED",
"FINANCIAL EDGE FINTECH PRIVATE LIMITED",
"FINANCIAL SOFTWARE & SYSTEMS P LIMITED",
"FINANCIAL SOFTWARE SYSTEM PRIVATE LIMITED",
"FINANCIAL TECHNOLOGIES COMMUNICATIONS LIMITED",
"FINAR LIMITED",
"FINARB ANALYTICS CONSULTING (OPC) PRIVATE LIMITED",
"FINASTRA SOFTWARE SOLUTIONS INDIA PRIVATE LIMITED",
"FINATEL TECHNOLOGIES PRIVATE LIMITED",
"FINATICS TECHNOLOGY PRIVATE LIMITED",
"FINAVAL S.P.A",
"FINAVI CFO PRIVATE LIMITED",
"FINAXAR TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"FINBIZ CROSSBORDER CONSULTING PRIVATE LIMITED",
"FINBONACCI SOFTSYS PRIVATE LIMITED",
"FINBRAINE FINTECH PRIVATE LIMITED",
"FINBROS MARKETING",
"FINBUD FINANCIAL SERVICES PRIVATE LIMITED",
"FINBYZ TECH PRIVATE LIMITED",
"FINCANA SOLUTIONS PRIVATE LIMITED",
"FINCANTIERI INDIA PRIVATE LIMITED",
"FINCARE MARKETING",
"FINCARE SMALL FINANCE BANK LIMITED",
"FINCART FINVEST PRIVATE LIMITED",
"FINCFRIENDS PRIVATE LIMITED",
"FINCH IT SOLUTIONS PRIVATE LIMITED",
"FINCITY REALTORS PRIVATE LIMITED",
"FINCLUB TECHNOLOGIES PRIVATE LIMITED",
"FINCOVI SERVICES INDIA PRIVATE LIMITED",
"FINCRED INVESTMENTS LIMITED",
"FINCREST INFORMATION SERVICES PRIVATE LIMITED",
"FINCRUISE CREDIT SERVICES PRIVATE LIMITED",
"FINCURO SOLUTIONS PRIVATE LIMITED",
"FIND AGENCIES PVT LTD",
"FINDABILITY SCIENCES PRIVATE LIMITED",
"FINDEAL INVESTMENTS PRIVATE LIMITED",
"FINDEED SOLUTIONS PRIVATE LIMITED",
"FINDEM TECHNOLOGIES PRIVATE LIMITED",
"FINDER INDIA PRIVATE LIMITED",
"FINDERBRIDGE TOURISM PRIVATE LIMITED",
"FINDOC FINVEST PRIVATE LIMITED",
"FINDOC INVESTMART (IFSC) PRIVATE LIMITED",
"FINDOC INVESTMART PRIVATE LIMITED",
"FINDOC WEALTHMART PRIVATE LIMITED",
"FINDTRIP TOURS & TRAVEL PRIVATE LIMITED",
"FINE AROMATICS AND HERBAL EXTRACTS PRIVATE LIMITED",
"FINE ART DIGITAL IMAGING PRIVATE LIMITED",
"FINE ART SCALE MODELS PRIVATE LIMITED",
"FINE AUTOMOTIVE AND INDUSTRIAL RADIATORS PVT LTD",
"FINE BIO-SCIENCE PRIVATE LIMITED",
"FINE BLANKINGS PRIVATE LIMITED",
"FINE BLOW POLYMERS PRIVATE LIMITED",
"FINE CAST (GUJ) PRIVATE LIMITED",
"FINE CATERERS & SUPPLIERS",
"FINE COMPONENTS AND TOOLS PRIVATE LIMITED",
"FINE DIES AND MOULDS (INDIA) PRIVATE LIMITED",
"FINE DIEWAX CASTINGS LIMITED",
"FINE DYEING PRIVATE LIMITED",
"FINE EQUIPMENTS INDIA PRIVATE LIMITED",
"FINE ESTATES PRIVATE LIMITED",
"FINE FAB PRIVATE LIMITED",
"FINE FEATHERS HOSPITAL PRIVATE LIMITED",
"FINE FELTS AND FIBRE PRIVATE LIMITED",
"FINE FILTERATION TECHNOLOGY PRIVATE LIMITED",
"FINE FILTERS PRIVATE LIMITED",
"FINE FINISH ORGANICS PRIVATE LIMITED",
"FINE FLOUR MILLS PVT. LTD.",
"FINE FLOW INDUSTRIES PRIVATE LIMITED",
"FINE FOOTWEAR PRIVATE LIMITED",
"FINE FORGE LTD.",
"FINE FORTUNATE TRADING LIMITED",
"FINE FRAGRANCES PRIVATE LIMITED",
"FINE FURNISHINGS PRIVATE LIMITED",
"FINE GLASS INJECTABLE CONTAINERS PRIVATE LIMITED",
"FINE HANDLING AND AUTOMATION PRIVATE LIMITED",
"FINE HOME CONSTRUCTIONS PRIVATE LIMITED",
"FINE INDIAN ARTSNJEWELS PRIVATE LIMITED",
"FINE INTERBUILD PRIVATE LIMITED",
"FINE IT SOLUTIONS (INDIA) PRIVATE LIMITED",
"FINE JEWELLERY (INDIA) LIMITED",
"FINE JEWELLERY GOLD PRIVATE LIMITED",
"FINE JEWELLERY MANUFACTURING LIMITED",
"FINE LINES",
"FINE MARKETING (INDIA) PRIVATE LIMITED",
"FINE NON-WOVEN INDIA PRIVATE. LIMITED.",
"FINE OPTICS PRIVATE LIMITED",
"FINE ORGANIC INDUSTRIES LIMITED",
"FINE ORGANICS",
"FINE ORGOKEM PRIVATE LIMITED",
"FINE PACKAGING PRIVATE LIMITED",
"FINE PAPER SOURCE PRIVATE LIMITED",
"FINE PEARLS (INDIA) PRIVATE LIMITED",
"FINE PEST SULPHUR (INDIA) PRIVATE LIMITED",
"FINE POLYCOLLOIDS P LTD",
"FINE PROCESSORS PRIVATE LIMITED",
"FINE PRODUCTS PRIVATE LIMITED",
"FINE REFINERS PRIVATE LIMITED",
"FINE SCOPE DIGITAL MEDIA PRIVATE LIMITED",
"FINE SOLUTIONS FACILITY MANAGEMENT PRIVATE LIMITED",
"FINE SPAVY ASSOCIATES & ENGINEERS PRIVATE. LIMITED",
"FINE SPIRITS PRIVATE LIMITED",
"FINE SUPPORT SERVICES PRIVATE LIMITED",
"FINE TASTE FOODS PRIVATE LIMITED",
"FINE TECH CORPO PRIVATE LIMITED",
"FINE TECH RESOURCES LIMITED",
"FINE TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"FINE TOOLS INDIA PRIVATE LIMITED",
"FINE TRANSFERPRINTS (INDIA) PRIVATE LIMITED",
"FINE TURN AUTO PRIVATE LIMITED",
"FINE VISION CARE COMPANY PRIVATE LIMITED",
"FINE VITRIFIED PRIVATE LIMITED",
"FINE WOOD PRODUCTS PRIVATE. LIMITED.",
"FINE YARNS",
"FINE ZEELANDIA PRIVATE LIMITED",
"FINE ZONE INFRA PRIVATE LIMITED",
"FINEARC SYSTEMS PRIVATE LIMITED",
"FINEARTS COMMUNICATORS INDIA PRIVATE LIMITED",
"FINEBIOTICS PHARMA LIMITED",
"FINECAB WIRES & CABLES PRIVATE LIMITED",
"FINECHO ENGINEERING PRIVATE LIMITED",
"FINECOM COMMUNICATION PRIVATE LIMITED",
"FINECONS LIMITED",
"FINECONS PRIVATE LIMITED",
"FINECRETE ECO-BLOCKS PRIVATE LIMITED",
"FINECURE PHARMACEUTICALS LIMITED",
"FINEDGE ENGISOLS PRIVATE LIMITED",
"FINEDGE INDIA PRIVATE LIMITED",
"FINE-ETHNIC COLLECTION PRIVATE LIMITED",
"FINEFACILIS MANAGEMENT PRIVATE LIMITED",
"FINEFAIR INDIA PRIVATE LIMITED",
"FINEGROW HOME CARE PRIVATE LIMITED",
"FINEHOPE ALLIED ENGINEERING PRIVATE LIMITED",
"FINELAB WEB SERVICES PRIVATE LIMITED",
"FINE-LINE CIRCUITS LIMITED",
"FINELINE INDIA ID SOLUTIONS PRIVATE LIMITED",
"FINELINE INFRA PRIVATE LIMITED",
"FINEOS INDIA PRIVATE LIMITED",
"FINEOTEX CHEMICAL LIMITED",
"FINEPAC STRUCTURES PRIVATE LIMITED",
"FINEPUNCH FAB PRIVATE LIMITED",
"FINER SURFACES PRIVATE LIMITED",
"FINERICH KNITWEAR PRIVATE LIMITED",
"FINESHAPE ENGINEERS PRIVATE LIMITED",
"FINESSE ADVISORY SERVICES PRIVATE LIMITED",
"FINESSE FASHIONS PRIVATE.LIMITED",
"FINESSE GRAPHICS AND PRINTS PRIVATE LIMITED",
"FINESSE INFORMATION SYSTEMS PRIVATE LIMITED",
"FINESSE INTERNATIONAL DESIGN PRIVATE LIMITED",
"FINESSE ITLABS PRIVATE LIMITED",
"FINESSE JEWELS PRIVATE LIMITED",
"FINESSE MARKET LINK PRIVATE LIMITED",
"FINESSE PHARMACEUTICALS PRIVATE LIMITED",
"FINESTAR JEWELLERY & DIAMONDS PRIVATE LIMITED",
"FINETECH FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"FINETECH LAND SHAPERS PRIVATE LIMITED",
"FINETECH PARKCON INDIA PRIVATE LIMITED",
"FINETHICAL TRADING PRIVATE LIMITED",
"FINETONE ACOUSTIC PRIVATE LIMITED",
"FINEWORTHY SOFTWARE SOLUTIONS LIMITED",
"FINEX FOREX & EQUITY SERVICES PRIVATE LIMITED",
"FINEX KITCHEN PRIVATE LIMITED",
"FINEX MERCHANTS PRIVATE LIMITED",
"FINEX SHIPPING SERVICES PRIVATE LIMITED",
"FINEXPERTS ADVISORY SERVICES PRIVATE LIMITED",
"FINEXTA INFOTECH PRIVATE LIMITED",
"FINEZZA INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"FINFABRIC SOFTWARE & SERVICES PRIVATE LIMITED",
"FINFETINDTRONICS PRIVATE LIMITED",
"FINFOOT LIFESTYLE PRIVATE LIMITED",
"FINFORT INFOTECH LLP",
"FINFORTUNE FINANCIAL SERVICES PRIVATE LIMITED",
"FINGENT GLOBAL SOLUTIONS PRIVATE LIMITED",
"FINGENT TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"FINGERCROSS VENTURES PRIVATE LIMITED",
"FINGERPRINTS CREATIVE PRIVATE LIMITED",
"FINGERPRINTS FASHIONS PRIVATE LIMITED",
"FINGERTIPPLUS TECHNOLOGIES PRIVATE LIMITED",
"FINGRID BUSINESS SOLUTIONS PRIVATE LIMITED",
"FINGRO FINSERV PRIVATE LIMITED",
"FINGROW CAPITAL PRIVATE LIMITED",
"FINGROWTH CO - OPERATIVE BANK LIMITED",
"FINICITY TECHNOLOGIES PRIVATE LIMITED",
"FINIQ CONSULTING INDIA PRIVATE LIMITED",
"FINIQ SOLUTIONS I PRIVATE LIMITED",
"FINIQE TECHNOLOGIES PRIVATE LIMITED",
"FINISAR TECHNOLOGY INDIA PRIVATE LIMITED",
"FINITE 4 ENGINEERING CONSULTANCY SERVICES PRIVATE LIMITED",
"FINITIATIVES LEARNING INDIA PRIVATE LIMITED",
"FINITO COMMUNICATIONS PRIVATE LIMITED",
"FINIVIS DIGITAL SERVICES PRIVATE LIMITED",
"FINIX CROP CARE PRIVATE LIMITED",
"FINIX ENTERPRISES PRIVATE LIMITED",
"FINIX FILTERS PRIVATE LIMITED",
"FINKURVE COMMODITIES PRIVATE LIMITED",
"FINKURVE FINANCIAL SERVICES LIMITED",
"FINLABS INDIA PRIVATE LIMITED",
"FINLAW CONSULTANCY PRIVATE LIMITED",
"FINLEARN EDUTECH PRIVATE LIMITED",
"FINLINKERS SOLUTIONS PRIVATE LIMITED",
"FINLOGIC TECHNOLOGIES INDIA PRIVATE LIMITED",
"FINLORD MARKETING PVT LTD",
"FINMAN FINANCE INDIA PVT LTD",
"FINMAX CREDIT & FINANCE PRIVATE LIMITED",
"FINMAX TECHNOLOGIES (OPC) PRIVATE LIMITED",
"FINMECH BUSINESS SERVICES PRIVATE LIMITED",
"FINMECHANICS INDIA PRIVATE LIMITED",
"FINMEN ADVISORS AND CONSULTANTS PRIVATE LIMITED",
"FINMEN ADVISORS PRIVATE LIMITED",
"FINMOR CORPORATE COMMUNICATIONS PRIVATE LIMITED",
"FINNABLE CREDIT PRIVATE LIMITED",
"FINNASTRA PRIVATE LIMITED",
"FINNEX BUSINESS SERVICES PRIVATE LIMITED",
"FINNMED BIOTECH PRIVATE LIMITED",
"FINNOVATE FINANCIAL SERVICES PRIVATE LIMITED",
"FINNOVATION TECH SOLUTIONS PRIVATE LIMITED",
"FINNOVATORS SERVICES PRIVATE LIMITED",
"FINNOVENTURES FINANCIALSERVICES PRIVATE LIMITED",
"FINNOVITY GLOBAL PAYMENTS PRIVATE LIMITED",
"FINNRECO CORPORATE SOLUTIONS PRIVATE LIMITED",
"FINO FINANCE PRIVATE LIMITED",
"FINO FOODS PRIVATE LIMITED",
"FINO PAYMENTS BANK LIMITED",
"FINO PAYTECH LIMITED",
"FINO TRUSTEESHIP SERVICES LIMITED",
"FINOIT TECHNOLOGIES I PRIVATE LIMITED",
"FINOKOATS & COLOURS PRIVATE LIMITED",
"FINOLEX ACADEMY OF MANAGEMENT & TECHNOLOGY",
"FINOLEX CABLES LIMITED",
"FINOLEX INDUSTRIES LIMITED",
"FINOLEX J-POWER SYSTEMS LIMITED",
"FINOLEX J-POWER SYSTEMS PRIVATE LIMITED",
"FINOLEX PLASSON INDUSTRIES PRIVATE LIMITED",
"FINOLOGY VENTURES PRIVATE LIMITED",
"FINOMAX SCAFFOLDING (I) PRIVATE LIMITED",
"FINOMAX STEEL TUBE PRIVATE LIMITED",
"FINONYX SOFTWARE SOLUTIONS PRIVATE LIMITED",
"FINOPLAST (SURAT) PVT LTD",
"FINOPTIONS INSTITUTE OF FINANCIAL STUDIES PRIVATE LIMITED",
"FINOQ EDUVERSITY PRIVATE LIMITED",
"FINOR PIPLAJ CHEMICALS LIMITED",
"FINORA TECHNOLOGIES PRIVATE LIMITED",
"FINORCHEM LIMITED",
"FINORGA (INDIA) PVT LTD",
"FINORION PHARMA INDIA PRIVATE LIMITED",
"FINORNIC CHEMICALS (INDIA) PVT LTD",
"FINOSO PHARMA PRIVATE LIMITED",
"FINOTEX FIBRECAST PRIVATE LIMITED",
"FINOUX SOLUTION PRIVATE LIMITED",
"FINOVA CAPITAL PRIVATE LIMITED",
"FINOVA HEALTHCARE PRIVATE LIMITED",
"FINOVATE CONSULTING PRIVATE LIMITED",
"FINOZOL SPECIALITY CHEMICALS PRIVATE LIMITED",
"FINPOWER AIRCON SYSTEMS PRIVATE LIMITED",
"FINPROJECT INDIA PRIVATE LIMITED",
"FINQUEST FINANCIAL SOLUTIONS PRIVATE LIMITED",
"FINQUEST SECURITIES PRIVATE LIMITED",
"FINS CORPORATION",
"FINS ENGINEERS AND CONTRACTORS PRIVATE LIMITED",
"FINSALL NETWORK PRIVATE LIMITED",
"FINSBRIDGE COMMERCIAL PRIVATE LIMITED",
"FINSEC AA SOLUTIONS PRIVATE LIMITED",
"FINSEN RITTER TECHNOLOGIES PRIVATE LIMITED",
"FINSERIN ONLINE SERVICES PRIVATE LIMITED",
"FINSERVE SHARED SERVICES LIMITED",
"FINSET FINCARE SERVICES PRIVATE LIMITED",
"FINSHORE MANAGEMENT SERVICES LIMITED",
"FINSIGHT GLOBAL ADVISORY PRIVATE LIMITED",
"FINSIGMA INCLUSIVE SERVICES PRIVATE LIMITED",
"FINSMART ACCOUNTING PRIVATE LIMITED",
"FINSOL CONSULTANCY PRIVATE LIMITED",
"FINSOL MARKETING PRIVATE LIMITED",
"FINSOL TECHNOLOGIES PRIVATE LIMITED",
"FINSPOT TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"FINSQ PROFESSIONALS PRIVATE LIMITED",
"FINSTARS CAPITAL LIMITED",
"FINSTAT EDUCATION SERVICES PRIVATE LIMITED",
"FINSTEIN ADVIZORY SERVICE LLP",
"FINSTEM INFRASTRUCTURE INDIA PRIVATE LIMITED",
"FINSTER BLACK PRIVATE LIMITED",
"FINSTER CARBON PRIVATE LIMITED",
"FINSTONE GRANITO PRIVATE LIMITED",
"FINSTREAM PRIVATE LIMITED",
"FINSURGE PRIVATE LIMITED",
"FINSYS INFOTECH LIMITED",
"FINT SOLUTIONS PRIVATE LIMITED",
"FINTAGS TECHNOLOGIES PRIVATE LIMITED",
"FINTAX CORPORATE ADVISORS PRIVATE LIMITED",
"FINTAX EXPERTS",
"FINTECH BLUE SOLUTIONS PRIVATE LIMITED",
"FINTECH COMMERCIAL PRIVATE LIMITED",
"FINTECH COMPU SYSTEMS LIMITED",
"FINTECH CORP PRIVATE LIMITED",
"FINTEK SOFTWARE SERVICES PRIVATE LIMITED",
"FINTELEKT ADVISORY SERVICES PRIVATE LIMITED",
"FINTELIUS ENGINEERING PRIVATE LIMITED",
"FINTELLIGENCE DATA SCIENCE PRIVATE LIMITED",
"FINTELLIX INDIA PRIVATE LIMITED",
"FINTERMIX SOFTWARE PRIVATE LIMITED",
"FINTEX FLOORINGS PVT LTD",
"FINTRANS SOLUTIONS PRIVATE LIMITED",
"FINTREE EDUCATION PRIVATE LIMITED",
"FINTREE FINANCE PRIVATE LIMITED",
"FINULENT SOLUTIONS LLP",
"FINURA MOULD PRIVATE LIMITED",
"FINVASIA SECURITIES PRIVATE LIMITED",
"FINVENT FINANCE AND INVESTMENTS LIMITED",
"FINVIN INVESTOR PRIVATE LIMITED",
"FINVISTA ADVISORS (INDIA) PRIVATE LIMITED",
"FINWAVE FOREX PRIVATE LIMITED",
"FINWIZZ FINANCIAL SERVICES PRIVATE LIMITED",
"FINWIZZ MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"FINXER TECHNOLOGIES PRIVATE LIMITED",
"FINXSOFTWARE LIMITED",
"FINZLY INDIA R &D PRIVATE LIMITED",
"FINZOOMERS SERVICES PRIVATE LIMITED",
"FIONA INFRA AND COMMERCIALS PRIVATE LIMITED",
"FIONA SOLITAIRES PRIVATE LIMITED",
"FIONA TRAVELS PRIVATE LIMITED",
"FIONAA GOLD PRIVATE LIMITED",
"FIONIS FITNESS SERVICES PRIVATE LIMITED",
"FIOR INDUSTRIES PRIVATE LIMITED",
"FIORA BUSINESS SUPPORT SERVICES LIMITED",
"FIORA HYPERMARKET LIMITED",
"FIORA ONLINE LIMITED",
"FIORA SERVICES LIMITED",
"FIORANO SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"FIORENZA GRANITO PRIVATE LIMITED",
"FIORI CREATIONS PRIVATE LIMITED",
"FIPORT SOFTWARE INDIA PRIVATE LIMITED",
"FIPSAR TECHNOLOGIES PRIVATE LIMITED",
"FIPSAR TECHNOLOGY SOLUTIONS",
"FIRDOOS COLD STORAGE PRIVATE LIMITED",
"FIRDOUS GOLD CHEMMAD PRIVATE LIMITED",
"FIRE ARCOR INFRASTRUCTURE PRIVATE LIMITED",
"FIRE BALL SECURITAS AND CONSULTANTS PRIVATE LIMITED",
"FIRE BOWL RESTAURANTS PRIVATE LIMITED",
"FIRE BRIGADE SERVICES",
"FIRE CAPITAL FUND PRIVATE LIMITED",
"FIRE FLOAT INDIA PRIVATE LIMITED",
"FIRE FOREX PRIVATE LIMITED",
"FIRE HUT COMMERCIAL EQUIPMENT PRIVATE LIMITED",
"FIRE LUXUR DEVELOPERS PRIVATE LIMITED",
"FIRE PROJECTS PRIVATE LIMITED",
"FIRE SAFE INDIA FOUNDATION",
"FIRE SAFETY DEVICES PRIVATE LIMITED",
"FIRE SCAN TECHNOLOGIES PRIVATE LIMITED",
"FIRE SERVICES DEPARTMENT",
"FIRE STATION",
"FIRE STONE METAL PRIVATE LIMITED",
"FIRE STREAM WORLD WIDE INC",
"FIRE TRACK SYSTEM",
"FIRE TRIX ENGINEERING & SYSTEMS PRIVATE LIMITED",
"FIREBELLY PROPERTIES LIMITED",
"FIRECOMPASS TECHNOLOGIES PRIVATE LIMITED",
"FIRECON CONSULTANTS PRIVATE LIMITED",
"FIRECRACKER ENTERTAINMENT PRIVATE LIMITED",
"FIREEYE TECHNOLOGIES INDIA PRIVATE LIMITED",
"FIREFLY CREATIVE STUDIO PRIVATE LIMITED",
"FIREFLY E VENTURES LIMITED",
"FIREFLY FIREPUMPS PRIVATE LIMITED",
"FIREFLY LIGHTING PRIVATE LIMITED",
"FIREFLY LOGISTICS PRIVATE LIMITED",
"FIREFLY MARKET RESEARCH INDIA PRIVATE LIMITED",
"FIREFLY NETWORKS LIMITED",
"FIREFORCE SAFETY & SECURITIES PRIVATE LIMITED",
"FIREFOX BIKES PRIVATE LIMITED",
"FIREFOX ELEVATORS PRIVATE LIMITED",
"FIREFOX PRODUCTIONS PRIVATE LIMITED",
"FIREGATE SECURITY PRIVATE LIMITED",
"FIRENET INDIA PRIVATE LIMITED",
"FIRENIX TECHNOLOGIES PRIVATE LIMITED",
"FIREONE TECHNOLOGIES PRIVATE LIMITED",
"FIREPRO SYSTEMS PRIVATE LIMITED",
"FIREQI AUTOMATION PRIVATE LIMITED",
"FIRESEC INDIA SYSTEMS PRIVATE LIMITED",
"FIRESENSE TECHNOLOGIES (OPC) PRIVATE LIMITED",
"FIRESKY MEDIA AND TECHNOLOYIES PRIVATE LIMITED",
"FIRESTORM ELECTRONICS CORPORATION PRIVATE LIMITED",
"FIRETECH EQUIPMENT AND SYSTEMS PRIVATE LIMTIED",
"FIRETECH REFRACTORIES PRIVATE LIMITED",
"FIRETEX PROTECTIVE TECHNOLOGIES PRIVATE LIMITED",
"FIRETIDE NETWORKS PRIVATE LIMITED",
"FIRETRONICS (INDIA) PRIVATE LIMITED",
"FIREWINGS INFRACON SERVICES PRIVATE LIMITED",
"FIREX TECHNOCON PRIVATE LIMITED",
"FIRKEE ACCESSORIES PRIVATE LIMITED",
"FIRKI WHOLESALE PRIVATE LIMITED",
"FIRM FOUNDATIONS AND HOUSING PRIVATE LIMTED",
"FIRMEDGE PLASTIC MANUFACTURING PRIVATE LIMITED",
"FIRMENICH AROMATICS PRODUCTION (INDIA) PRIVATE LIMITED",
"FIRMINIQ SYSTEMS PRIVATE LIMITED",
"FIRMROOTS PRIVATE LIMITED",
"FIRMUS INFRASTRUCTURES PRIVATE LIMITED",
"FIRMUS LABORATORIES PRIVATE LIMITED",
"FIRMUS WORLDWIDE LOGISTICS PRIVATE LIMITED",
"FIRMWARE INFOTECH PVT LTD",
"FIRMWISE SERVICES INDIA PRIVATE LIMITED",
"FIROZABAD CERAMICS PRIVATE LIMITED",
"FIROZE FABRICATORS",
"FIRST & BEST SERVICES INDIA PRIVATE LIMITED",
"FIRST & FAST CARRIERS PRIVATE LIMITED",
"FIRST ABU DHABI BANK PJSC",
"FIRST ADVANTAGE FINANCE AND INVESTMENTS PRIVATE LIMITED",
"FIRST ADVANTAGE GLOBAL OPERATING CENTER PRIVATE LIMITED",
"FIRST ADVANTAGE PRIVATE LIMITED",
"FIRST ADVISOR INSURANCE BROKERS PRIVATE LIMITED",
"FIRST AID COUNCIL OF INDIA",
"FIRST AMERICAN FINANCIAL CORPORATION",
"FIRST AMERICAN INDIA PRIVATE LIMITED",
"FIRST AVENUE REAL ESTATE PRIVATE LIMITED",
"FIRST BASE SOLUTIONS PRIVATE LIMITED",
"FIRST CALL ADVISORY INDIA PRIVATE LIMITED",
"FIRST CALL TELE SERVICES PRIVATE LIMITED",
"FIRST CANVAS VENTURES PRIVATE LIMITED",
"FIRST CARE INDIA PRIVATE LIMITED",
"FIRST CARS PRIVATE LIMITED",
"FIRST CHOICE EXPRESS PRIVATE LIMITED",
"FIRST CHOICE MARINE PRIVATE LIMITED",
"FIRST CHOICE PEST CONTROL PRIVATE LIMITED",
"FIRST CIRCLE MANAGEMENT SERVICES PRIVATE LIMITED",
"FIRST CITY RESORTS PRIVATE LIMITED",
"FIRST CONNECT HEALTH IT SOLUTIONS PRIVATE LIMITED",
"FIRST CONNECT SOLUTIONS PRIVATE LIMITED",
"FIRST COUNTRY WIDE CONSULTANTS PRIVATE LIMITED",
"FIRST CREDIT ITES PRIVATE LIMITED",
"FIRST CURE HOSPITAL LLP",
"FIRST CUT DESIGN STUDIO INDIA PRIVATE LIMITED",
"FIRST DATA (INDIA) PRIVATE LIMITED",
"FIRST DATA CORPORATION",
"FIRST DATA DEVELOPMENT PRIVATE LIMITED",
"FIRST DATA INDIA PRIVATE LIMITED",
"FIRST DECOR SOLUTIONS PRIVATE LIMITED",
"FIRST DIVINITY DIAMONDS PRIVATE LIMITED",
"FIRST ECONOMY PRIVATE LIMITED",
"FIRST ENERGY PRIVATE LIMITED",
"FIRST ENGINEERING PLASTICS INDIA PRIVATE LIMITED",
"FIRST ESCO INDIA PRIVATE LIMITED",
"FIRST EUROPEAN INFOTECH INDIA LIMITED",
"FIRST FIDDLE F&B PRIVATE LIMITED",
"FIRST FINANCIAL SERVICES LTD",
"FIRST FINTEC LIMITED",
"FIRST FISCAL SERVICES INDIA LIMITED",
"FIRST FISCAL SERVICES INDIA PRIVATE LIMITED",
"FIRST FORGE LIMITED",
"FIRST FRAME ENTERTAINMENTS PRIVATE LIMITED",
"FIRST GARMENT MANUFACTURING COMPANY INDIA PRIVATE LIMITED",
"FIRST GLOBAL ENGINEERING SERVICES PRIVATE LIMITED",
"FIRST GLOBAL SECURITIES PRIVATE LIMITED",
"FIRST GRADE FORCE PRIVATE LIMITED",
"FIRST HEALTH CARE PRIVATE LIMITED",
"FIRST IMPRESSION CONSULTING PRIVATE LIMITED",
"FIRST IMPRESSION CORPORATE SERVICES PRIVATE LIMITED",
"FIRST INDIA NEWS INTERNATIONAL PRIVATE LIMITED",
"FIRST INDIA SECURITIES PRIVATE LIMITED",
"FIRST INFRACON PRIVATE LIMITED",
"FIRST INK TECHNOLOGIES PRIVATE LIMITED",
"FIRST INSIGHT SOFTWARE SOLUTIONS INDIA PRIVATE LIMITED",
"FIRST LAB CHEMICALS PRIVATE LIMITED",
"FIRST LEAGUE RETAIL OUTLETS PRIVATE LIMITED",
"FIRST LEGION CONSULTING PRIVATE LIMITED",
"FIRST LSI CONSULTING PRIVATE LIMITED",
"FIRST MAN MANAGEMENT SERVICES PRIVATE LIMITED",
"FIRST MARITIME PRIVATE LIMITED",
"FIRST MEDIA INDIA PRIVATE LIMITED",
"FIRST MEDICAL DIAGNOSTICS PRIVATE LIMITED",
"FIRST METAL TRADING PRIVATE LIMITED",
"FIRST MOBITAL PRIVATE LIMITED",
"FIRST OBJECT PRIVATE LIMITED",
"FIRST OIL AND GAS SERVICES PRIVATE LIMITED",
"FIRST OPINIONS ONLINE SOLUTIONS PRIVATE LIMITED",
"FIRST ORGACON PRIVATE LIMITED",
"FIRST PARTNER CONSULTING PRIVATE LIMITED",
"FIRST PLUMBING PRIVATE LIMITED",
"FIRST POLICY INSURANCE BROKERS PRIVATE LIMITED",
"FIRST QUADRANT SOLUTIONS PRIVATE LIMITED",
"FIRST RAIN EXHIBITS INDIA PRIVATE LIMITED",
"FIRST RATE INVESTMENTS PRIVATE LIMITED",
"FIRST RESPONDERS PRIVATE LIMITED",
"FIRST RITE IT SERVICES PRIVATE LIMITED",
"FIRST SCREENING SOLUTIONS PRIVATE LIMITED",
"FIRST SOLAR POWER INDIA PRIVATE LIMITED",
"FIRST SOURCE ENERGY INDIA PRIVATE LIMITED",
"FIRST SOURCE FINTECH PRIVATE LIMITED",
"FIRST SOURCE IMPEX PRIVATE LIMITED",
"FIRST SOURCE LABORATORY SOLUTIONS LLP",
"FIRST SOURCE SOLUTIONS LIMITED",
"FIRST STAGE VENTURES PRIVATE LIMITED",
"FIRST STEEL COMPANY PRIVATE LIMITED",
"FIRST STEP ENGLISH MEDIUM SCHOOL",
"FIRST STEP PROJECTS PRIVATE LIMITED",
"FIRST STEPS BABYWEAR PRIVATE LIMITED",
"FIRST STONE CORPORATE SERVICES PRIVATE LIMITED",
"FIRST SWITCHTECH RELAY COMPONENTS PRIVATE LIMITED",
"FIRST TECHNOLOGIES I PRIVATE LIMITED",
"FIRST TEK SERVICES PRIVATE LIMITED",
"FIRST TIME RESOLVER PRIVATE LIMITED",
"FIRST TIME US PHARMACEUTICALS INDIA PRIVATE LIMITED",
"FIRST TOURS INDIA PRIVATE. LIMITED",
"FIRST VAC MET CORPORATION PRIVATE LIMITED",
"FIRST VOYAGER ADVISORS PRIVATE LIMITED",
"FIRST WALKIN TECHNOLOGIES PRIVATE LIMITED",
"FIRSTBIT DIGITAL TECHNOLOGIES PRIVATE LIMITED",
"FIRSTCALL AUTOMATION PRIVATE LIMITED",
"FIRSTCALL H RESOURCE PRIVATE LIMITED",
"FIRSTCARE SURGICAL PRIVATE LIMITED",
"FIRSTCHOICE PROPERTIES (INDIA) PRIVATE LIMITED",
"FIRSTCHOICE READY MIX PRIVATE LIMITED",
"FIRSTEAGLE ADVISORS PRIVATE LIMITED",
"FIRSTECH SOLUTIONS PRIVATE LIMITED",
"FIRSTEDGE MARKETING PRIVATE LIMITED",
"FIRSTFLY TRAVEL PRIVATE LIMITED",
"FIRSTFOCUS BUSINESS SOLUTIONS PRIVATE LIMITED",
"FIRSTFORCE TECHNOLOGIES PRIVATE LIMITED",
"FIRSTGEN DISTRIBUTION PRIVATE LIMITED",
"FIRSTHANDLE PRIVATE LIMITED",
"FIRSTHOUSE BUDGET HOMES PRIVATE LIMITED",
"FIRSTINSIGHT TECHNOLOGIES INDIA PRIVATE LIMITED",
"FIRSTLINE INFOTECH PRIVATE LIMITED",
"FIRSTMAN EDUCATION PRIVATE LIMITED",
"FIRSTMAN MANAGEMENT SERVICES PRIVATE LIMITED",
"FIRSTMED SERVICES PRIVATE LIMITED",
"FIRSTMED THERAPEUTICS PRIVATE LIMITED",
"FIRSTMERIDIAN BUSINESS SERVICES PRIVATE LIMITED",
"FIRSTMERIDIAN GLOBAL SERVICES PRIVATE LIMITED",
"FIRSTMOVE LOGISTICS PRIVATE LIMITED",
"FIRSTMR BUSINESS ANALYTICS PRIVATE LIMITED",
"FIRSTOUCH SOLUTIONS PRIVATE LIMITED",
"FIRSTPARTNERS COMMUNICATIONS PRIVATE LIMITED",
"FIRSTPAY TECHNOLOGIES PRIVATE LIMITED",
"FIRSTPOINT SOLUTIONS PRIVATE LIMITED",
"FIRSTRAND BANK LIMITED",
"FIRSTRAND SERVICES PRIVATE LIMITED",
"FIRSTRATE INFOTECH PRIVATE LIMITED",
"FIRSTSCALE ENTERPRISES & ENGINEERS PRIVATE LIMITED",
"FIRSTSHOP ONLINE RETAILS PRIVATE LIMITED",
"FIRSTSOURCE SOLUTIONS LIMITED",
"FIRSTSPACE DEVELOPMENT MANAGEMENT PRIVATE LIMITED",
"FIRSTVIEW CONFERENCES PRIVATE LIMITED",
"FIRSTVIEW CONSULTANTS (INDIA) PRIVATE LIMITED",
"FIRSTVIEW TRADING PRIVATE LIMITED",
"FIS GLOBAL BUSINESS SOLUTIONS INDIA PRIVATE LIMITED",
"FIS INVESTOR SERVICES INDIA PRIVATE LIMITED",
"FIS PAYMENT SOLUTIONS AND SERVICES INDIA PRIVATE LIMITED",
"FIS SOLUTIONS INDIA PRIVATE LIMITED",
"FIS SOLUTIONS SOFTWARE (INDIA) PRIVATE LIMITED",
"FISAGE SOLUTIONS PRIVATE LIMITED",
"FISCAL FINSERVE SOLUTION PRIVATE LIMITED",
"FISCAL POLICY INSTITUTE",
"FISCHER BUILDING MATERIALS INDIA PRIVATE LIMITED",
"FISCHER CONNECTORS INDIA PRIVATE LIMITED",
"FISCHER MEASUREMENT TECHNOLOGIES INDIA PRIVATE LIMITED",
"FISCHER SYSTEMS INDIA PRIVATE LIMITED",
"FISEN INDIA PRIVATE LIMITED",
"FISERV CE PRIVATE LIMITED",
"FISERV INDIA PRIVATE LIMITED",
"FISH CURRY RICE PRIVATE LIMITED",
"FISHBOWL INDIA PRIVATE LIMITED",
"FISHER & PAYKEL HEALTHCARE INDIA PRIVATE LIMITED",
"FISHER BIOPHARMA SERVICES INDIA PRIVATE LIMITED",
"FISHER CHENNAI ENGINEERING CENTER (A UNIT OF EMERSON ELECTRIC CO. INDIA)",
"FISHER PUMPS PRIVATE. LIMITED",
"FISHERIES DEPARTMENT",
"FISHEYE CREATIVE SOLUTIONS PRIVATE LIMITED",
"FISHFA AGRI WORLD LIMITED",
"FISHFA RUBBERS LIMITED",
"FISHIN' INDIA PRIVATE LIMITED",
"FISHING MEDIA PRIVATE LIMITED",
"FISSION COMPUTER LABS PRIVATE LIMITED",
"FISSION INFOTECH PRIVATE LIMITED",
"FISSION TECHNOSOLUTION PRIVATE LIMITED",
"FIT & GLOW HEALTHCARE PRIVATE LIMITED",
"FIT 3PL WAREHOUSING PRIVATE LIMITED",
"FIT BPO",
"FIT CONSULTING & SERVICES PRIVATE LIMITED",
"FIT INDIA ORGANIC PRIVATE LIMITED",
"FIT TECH INDUSTRIES PRIVATE LIMITED",
"FIT TIGHT FASTENERS PRIVATE LIMITED",
"FIT7 GLOBAL VENTURES PRIVATE LIMITED",
"F-ITALIA (INDIA) PRIVATE LIMITED",
"FITBIT INDIA PRIVATE LIMITED",
"FITCAST FOUNDERS AND ENGINEERS PRIVATE LIMITED",
"FITCH METALS ENGINEERING INDIA PRIVATE LIMITED",
"FITCO ORINGS PRIVATE LIMITED",
"FITCORE TECH-SOLUTIONS PRIVATE LIMITED",
"FITDAY PRIVATE LIMITED",
"FI-TEC POWER SOLUTIONS PRIVATE LIMITED",
"FITECH CONSULTANTS PRIVATE LIMITED",
"FITECH ENGINEERS PVT LTD",
"FITECH EQUIPMENTSINDIAPRIVATE LIMITED",
"FITECH SYSTEMS PRIVATE LIMITED",
"FITESA PUNE PRIVATE LIMITED",
"FITEX INDUSTRIES LIMITED",
"FITFACTORY TECHNOLOGY INDIA PRIVATE LIMITED",
"FITFOR INNERWEAR PRIVATE LIMITED",
"FITGO EQUIPMENT PRIVATE LIMITED",
"FITKIDS EDUCATION TRAINING PRIVATE LIMITED",
"FITLINE RETAILS PRIVATE LIMITED",
"FITLY HEALTH FOODS PRIVATE LIMITED",
"FITMET INDUSTRIAL FITTINGS PRIVATE LIMITED",
"FITNESS CANVAS PRIVATE LIMITED",
"FITNESS FIRST INDIA PRIVATE LIMITED",
"FITNESS ONE GROUP INDIA LIMITED",
"FITNESS RENAISSANCE PRIVATE LIMITED",
"FITNESS SPAREFIT PRIVATE LIMITED",
"FITNESSTACK INDIA PRIVATE LIMITED",
"FITPACK TEXTILE MILLS LIMITED",
"FIT-RIGHT ENGINEERING PRIVATE LIMITED",
"FITRIGHT EXPORTS PVT LTD",
"FITS ENGINEERING PRODUCTS PRIVATE LIMITED",
"FITS MARKETING PVT LTD",
"FITSHIT HEALTH SOLUTIONS PRIVATE LIMITED",
"FITSOL LOGISTICS PRIVATE LIMITED",
"FITSOURCE INDIA PRIVATE LIMITED",
"FITSPARK INDIA PRIVATE LIMITED",
"FITTERNITY HEALTH E-SOLUTION PRIVATE LIMITED",
"FITVILLA FITNESS CENTRE PRIVATE LIMITED",
"FITWEL GASKET COMPANY (INDIA) PRIVATE LIMITED",
"FITWEL PHARMACEUTICALS PRIVATE LIMITED",
"FITWEL TOOLS AND FORGINGS PRIVATE LIMITED",
"FITWELL GLASS & CERAMICS PRIVATE LIMITED",
"FITWELL POLYTECHNIK PRIVATE LIMITED",
"FITWELL POWER PROJECTS PRIVATE LIMITED",
"FITWELL TECH INDIA PRIVATE LIMITED",
"FIUNEX CONSULTANTS PRIVATE LIMITED",
"FIVD INDIA CONSULTING PRIVATE LIMITED",
"FIVE ARMS MANAGEMENT SERVICES PRIVATE LIMITED",
"FIVE BY SEVEN SOLUTIONS PRIVATE LIMITED",
"FIVE DATA PRODUCTS AND SOLUTIONS PRIVATE LIMITED",
"FIVE ELEMENTS BUSINESS SOLUTIONS PRIVATE LIMITED",
"FIVE ELEMENTS MARKETING AND CONSULTANT PRIVATE LIMITED",
"FIVE EXCEPTIONS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"FIVE FATE INFRASTRUCTURE PRIVATE LIMITED",
"FIVE FINGERS EDUCATION PRIVATE LIMITED",
"FIVE FORCE SECURITY SOLUTIONS PRIVATE LIMITED",
"FIVE M&T INFRA DEVELOPERS PRIVATE LIMITED",
"FIVE NET SERVICE PROVIDER PRIVATE LIMITED",
"FIVE NETWORK BROADBAND SOLUTION PRIVATE LIMITED",
"FIVE NETWORK SOLUTION (INDIA) LIMITED",
"FIVE OCEANS SHIPPING AND LOGISTICS PRIVATE L",
"FIVE P VENTURE INDIA PRIVATE LIMITED",
"FIVE PILLAR EDUCATION TRUST",
"FIVE PILLARS MANUFACTURING AND TRADING PRIVATE LIMITED",
"FIVE RIVERS IT SOLUTIONS PRIVATE LIMITED",
"FIVE S MANPOWER SERVICES PRIVATE LIMITED",
"FIVE SHIPS REALTY PRIVATE LIMITED",
"FIVE SPICE RESTAURANTS PRIVATE LIMITED",
"FIVE SPLASH INFOTECH PRIVATE LIMITED",
"FIVE STAR AGRO IMPLEMENTS PRIVATE LIMITED",
"FIVE STAR BUSINESS FINANCE LIMITED",
"FIVE STAR CARGO SHIPPING PRIVATE LIMITED",
"FIVE STAR CONSTRUCTIONS PRIVATE LIMITED",
"FIVE STAR DEHYDRATION PRIVATE LIMITED",
"FIVE STAR ENTERPRISES PRIVATE LIMITED",
"FIVE STAR FITNESS CLUB",
"FIVE STAR GREEN FARMERS PRODUCER COMPANY LIMITED",
"FIVE STAR LOGISTICS PRIVATE LIMITED",
"FIVE STAR METALS PVT LTD",
"FIVE STAR TRAVEL AND MONEY PRIVATE LIMITED",
"FIVE STARS SHIPPING COMPANY PRIVATE LIMITED",
"FIVE WINGS FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"FIVEBROS FORGINGS PRIVATE LIMITED",
"FIVERIVERS DEVELOPERS PRIVATE LIMITED",
"FIVES CAIL KCP LIMITED",
"FIVES COMBUSTION SYSTEMS PRIVATE LIMITED",
"FIVES INDIA ENGINEERING & PROJECTS PRIVATE LIMITED",
"FIVES STEIN INDIA PROJECTS PRIVATE LIMITED",
"FIVESKY INDIA PRIVATE LIMITED",
"FIVESTAR BRASS INDIA LIMITED",
"FIVE-STAR BUSINESS FINANCE LIMITED",
"FIVETRAN INDIA PRIVATE LIMITED",
"FIVETWO SUPPORTS PRIVATE LIMITED",
"FIX FIT FASTENERS MFG PVT LTD",
"FIX FLYER INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"FIX91 INFRASTRUCTURE SERVICES PRIVATE LIMITED",
"FIXDAX TECHNOLOGY PRIVATE LIMITED",
"FIXDERMA INDIA PRIVATE LIMITED",
"FIXEM CEMENT PRIVATE LIMITED",
"FIXIT AUTO PRIVATE LIMITED",
"FIXITY TECHNOLOGIES PRIVATE LIMITED",
"FIXMARK INFRA INDIA PRIVATE LIMITED",
"FIXOTECH ENGINEERING SYSTEMS PRIVATE LIMITED",
"FIXTURE ENGINEERING INDIA PRIVATE LIMITED",
"FIXX-A-PHONE (OPC) PRIVATE LIMITED",
"FIZA DEVELOPERS & INFRASTRUCTURE PRIVATE LIMITED",
"FIZA ENGINEERING WORKS PRIVATE LIMITED",
"FIZA HEALTHCARE PRIVATE LIMITED",
"FIZA POLYMERS PRIVATE LIMITED",
"FIZAKA INTERNATIONAL IMPEX LLP",
"FIZDI ECOMMERCE PRIVATE LIMITED",
"FIZIKEM LABORATORIES PRIVATE LIMITED",
"FIZZ CLOTHING COMPANY PRIVATE LIMITED",
"FJM CYLINDERS PRIVATE LIMITED",
"FK AGRO EXPORTS PRIVATE LIMITED",
"FKP IMPEX PVT. LTD.",
"FKS GLOBAL PRIVATE LIMITED",
"FLAB INTERNATIONAL PRIVATE LIMITED",
"FLABIA FRESH PRIVATE LIMITED",
"FLAG TRAVEL SERVICES",
"FLAGS COMMUNICATIONS PRIVATE LIMITED",
"FLAGS HOTELS PRIVATE LIMITED",
"FLAGSHIP BIOTECH INTERNATIONAL PRIVATE LIMITED",
"FLAGSHIP INFRASTRUCTURE PRIVATE LIMITED",
"FLAGSHIP MARINE INDIA PRIVATE LIMITED",
"FLAIR AGILE TECHNOLOGIES PRIVATE LIMITED",
"FLAIR EXPORTS PVT LTD",
"FLAIR HOTELS AND RESORTS PRIVATE LIMITED",
"FLAIR MANAGEMENT COMPANY PRIVATE LIMITED",
"FLAIR NETWORK SYSTEMS PRIVATE LIMITED",
"FLAIR PENS LIMITED",
"FLAIR WRITING EQUIPMENTS PRIVATE LIMITED",
"FLAIR WRITING INDUSTRIES LIMITED",
"FLAIR WRITING INDUSTRIES PRIVATE LIMITED",
"FLAIRE UNMANNED SYSTEMS PRIVATE LIMITED",
"FLAIRSOFT CONSULTING GROUP",
"FLAKE ICE AND REFRIGERATION SYSTEMS PVT. LTD.",
"FLAMAGAS INDIA PRIVATE LIMITED",
"FLAMBERGE SERVICES PRIVATE LIMITED",
"FLAMBOYANT STUDIOS PRIVATE LIMITED",
"FLAMBOYANT TECHNOLOGIES PRIVATE LIMITED",
"FLAMCO COMBUSTIONS PRIVATE LIMITED",
"FLAME ADVERTISING COMPANY PRIVATE LIMITED",
"FLAME CARE",
"FLAME FACILITIES PRIVATE LIMITED",
"FLAME MEDIA SERVICES PRIVATE LIMITED",
"FLAME OUT FIRE PROTECTION PRIVATE LIMITED",
"FLAME SOLREN PRIVATE LIMITED",
"FLAME UNIVERSITY",
"FLAMEBIRDS STUDIO PRIVATE LIMITED",
"FLAMENCO TECH INDIA PRIVATE LIMITED",
"FLAMEPROOF EQUIPMENTS PRIVATE LIMITED",
"FLAMERING (INDIA) PRIVATE LIMITED",
"FLAMESUN SOLAR PRIVATE LIMITED",
"FLAME-TAO KNOWARE PRIVATE LIMITED",
"FLAMETECH (MADRAS) PRIVATE LIMITED",
"FLAMEX FOODS AND DRINKS PRIVATE LIMITED",
"FLAMINCO REFRACTORIES PRIVATE LIMITED",
"FLAMINGO BUILDERS PRIVATE LIMITED",
"FLAMINGO DIGITAL PRIVATE LIMITED",
"FLAMINGO FILTERS PRIVATE LIMITED",
"FLAMINGO METAL PROCESSORS PRIVATE LIMITED",
"FLAMINGO MULTIFACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"FLAMINGO MULTIPORTS PRIVATE LIMITED",
"FLAMINGO PHARMACEUTICALS LIMITED",
"FLAMINGO SHIPPING AND FORWARDERS PRIVATE LIMITED",
"FLAMINGO TRANSWORLD PRIVATE LIMITED",
"FLAMINQO SHRIMPEX PRIVATE LIMITED",
"FLANDERS CHEESE PRIVATE LIMITED",
"FLANGETECH MANUFACTURING INDUSTRIES PRIVATE LIMITED",
"FLAPS AVIATION PRIVATE LIMITED",
"FLARE CHEMICALS PRIVATE LIMITED",
"FLARE LUMINAIRES PRIVATE LIMITED",
"FLARE REALTY ENGINEERS PRIVATE. LIMITED.",
"FLAREPATH SOLUTIONS PRIVATE LIMITED",
"FLARING FORMULATIONS PRIVATE LIMITED",
"FLASH CAPITAL PRIVATE LIMITED",
"FLASH DYE CHEM PRODUCTS PRIVATE LIMITED",
"FLASH ELECTRONICS (INDIA) PRIVATE LIMITED",
"FLASH FORGE PRIVATE LIMITED",
"FLASH POINT EQUIPMENTS PRIVATE LIMITED",
"FLASH SOLUTIONS PRIVATE LIMITED",
"FLASH VIVEN MACHINING TECHNOLOGIES PRIVATE LIMITED",
"FLASHKART INDIA PRIVATE LIMITED",
"FLASHWAY IMPEX PRIVATE LIMITED",
"FLAT WORLD DESIGN & DEVELOPMENT PRIVATE LIMITED",
"FLAT WORLD INTERACTIVE SERVICES PRIVATE LIMITED",
"FLATCUT DIAMONDS PRIVATE LIMITED",
"FLATHEAD DESIGNS PRIVATE LIMITED",
"FLATIRONS SOLUTIONS INDIA PRIVATE LIMITED",
"FLATROX TECHNOSOLUTIONS (INDIA) PRIVATE LIMITED",
"FLATWORLD BILLING SERVICES PRIVATE LIMITED",
"FLATWORLD BOOKS PRIVATE LIMITED",
"FLATWORLD HEALTHCARE SERVICES PRIVATE LIMITED",
"FLATWORLD MORTGAGE PROCESSING PRIVATE LIMITED",
"FLATWORLD SOLUTIONS PRIVATE LIMITED",
"FLAUNT SOLAR ENERGY PRIVATE LIMITED",
"FLAURA TEK PRIVATE LIMITED",
"FLAV FOOD BEVERAGES LIMITED",
"FLAVAROMA FLAVOURS AND FRAGRANCES PRIVATE LIMITED",
"FLAVIANT NETWORK PRIVATE LIMITED",
"FLAVICON ECO BOARDS PRIVATE LIMITED",
"FLAVONES EXTRACTS PRIVATE LIMITED",
"FLAVOR N FUSION INGREDIENTS PRIVATE LIMITED",
"FLAVOR PALATE PRIVATE LIMITED",
"FLAVORA FROZEN FOODS PRIVATE LIMITED",
"FLAVORITE TECHNOLOGIES PRIVATE LIMITED",
"FLAVOUR BUCKET PRIVATE LIMITED",
"FLAVOUR POT FOODS LLP",
"FLAVOURELLA FL PRIVATE LIMITED",
"FLAVOURIT SPICES TRADING LIMITED",
"FLAVOURS AND FRAGRANCES PRIVATE LIMITED",
"FLAVRICH FLAVOURS ANDFRAGRANCES PRIVATE LIMITED",
"FLAWLESS CASTINGS PRIVATE LIMITED",
"FLAWLESS CRAFTS PRIVATE LIMITED",
"FLAWLESS ENGINEERING SOLUTIONS PRIVATE LIMITED",
"FLAWLESS HOLDINGS AND INDUSTRIES PRIVATE LIMITED",
"FLAWLESS PHARMA PRIVATE LIMITED",
"FLAX APPARELS PRIVATE LIMITED",
"FLAXEN TEXTILES PRIVATE LIMITED",
"FLDEC SYSTEMS PRIVATE LIMITED",
"FLE FAST LINE EXPRESS PRIVATE LIMITED",
"FLECTO CERAMIC PRIVATE LIMITED",
"FLEECA INDIA PRIVATE LIMITED",
"FLEEK IT SOLUTIONS PRIVATE LIMITED",
"FLEEK SEATING INDIA PRIVATE LIMITED",
"FLEET GASKETS INDIA PVT. LTD.",
"FLEET MANAGEMENT INDIA PRIVATE LIMITED",
"FLEET MANAGEMENT MARITIME EDUCATION ACADEMY",
"FLEET STUDIO TECHNOLOGIES PRIVATE LIMITED",
"FLEET WORTH AUTOMOTIVES PRIVATE LIMITED",
"FLEETGUARD FILTERS PRIVATE LIMITED",
"FLEETGUARD SEPARATION SOLUTIONS PRIVATE LIMITED",
"FLEETONCLICK INDIA PRIVATE LIMITED",
"FLEEZIO IT SERVICES PRIVATE LIMITED",
"FLEISSIG SOLUTION PRIVATE LIMITED",
"FLEMING FABTEX PRIVATE LIMITED",
"FLEMING INDIA MANAGEMENT SERVICES PRIVATE LIMITED",
"FLEMING INDIA PRIVATE LIMITED",
"FLEMING LABORATORIES LIMITED",
"FLEMINGO (DFS) PRIVATE LIMITED",
"FLEMINGO CORPORATE SERVICES PRIVATE LIMITED",
"FLEMINGO DFS PRIVATE LIMITED",
"FLEMINGO DUTYFREE SHOP PRIVATE LIMITED",
"FLEMINGO TRAVEL RETAIL LIMITED",
"FLEMINGO TRAVEL RETAIL PRIVATE LIMITED",
"FLEMS TECHNOLOGY INDIA PRIVATE LIMITED",
"FLENDER DRIVES PRIVATE LIMITED",
"FLENTAS TECHNOLOGIES PRIVATE LIMITED",
"FLENTIS CORPORATION",
"FLEQA ONLINE TRADING PRIVATE LIMITED",
"FLEUR HOTELS PRIVATE LIMITED",
"FLEURDELIS TECHNOLOGIES PRIVATE LIMITED",
"FLEX CG SERVICES PRIVATE LIMITED",
"FLEX FOODS LIMITED",
"FLEX INTERNATIONAL PRIVATE LIMITED",
"FLEX MEDICARE SYSTEMS PRIVATE LIMITED",
"FLEX PRO ELECTRICALS PRIVATE LIMITED",
"FLEX RETAIL & LOGISTICS INDIA PRIVATE LIMITED",
"FLEX SIGNS INDIA PRIVATE LIMITED",
"FLEX STUDIOS PRIVATE LIMITED",
"FLEX VANIJYA PVT LTD",
"FLEXABILITY HR SOLUTIONS PRIVATE LIMITED",
"FLEXALGO SYSTEMS PRIVATE LIMITED",
"FLEXBINZONE",
"FLEXELL ENGITECH PRIVATE LIMITED",
"FLEXER RUBBERS PVT LTD",
"FLEXERA SOFTWARE INDIA LLP",
"FLEXI CAPS AND POLYMERS PRIVATE LIMITED",
"FLEXI CAREERS INDIA PRIVATE LIMITED",
"FLEXI CODE TECHNOLOGIES PRIVATE LIMITED",
"FLEXI EFFICADS PRIVATE LIMITED",
"FLEXI FOREX PRIVATE LIMITED",
"FLEXI FUSION SYSTEM PRIVATE LIMITED",
"FLEXI INFOSOURCE PRIVATE LIMITED",
"FLEXI PACK INDIA PVT LTD",
"FLEXI PAPER CONTAINERS (INDIA) PRIVATE LIMITED",
"FLEXI SEATING SYSTEMS PRIVATE LIMITED",
"FLEXI SOLUTIONS PRIVATE LIMITED",
"FLEXI TEMPLATES PRIVATE LIMITED",
"FLEXI TOURS PRIVATE LIMITED",
"FLEXI VENTURES PRIVATE LIMITED",
"FLEXI WORLD LOGISTICS PRIVATE LIMITED",
"FLEXIBEES BUSINESS SERVICES PRIVATE LIMITED",
"FLEXIBLE ABRASIVES PRIVATE LIMITED",
"FLEXIBLE AUTOMATION SYSTEMS PRIVATE LIMITED",
"FLEXIBLE FOAM PRODUCTS PRIVATE LIMITED",
"FLEXIBLE MACHINING CENTRE PRIVATE LIMITED",
"FLEXIBLE STEEL LACING COMPANY PRIVATE LIMITED",
"FLEXIBOND INDUSTRIES PRIVATE LIMITED",
"FLEXICAN BELLOWS AND HOSES PRIVATE LIMITED",
"FLEXICARE MEDICAL (INDIA) PRIVATE LIMITED",
"FLEXIELE CONSULTING SERVICES PRIVATE LIMITED",
"FLEXIFLO INDIA PRIVATE LIMITED",
"FLEXIFLOW INDUSTRIES PRIVATE LIMITED",
"FLEXIFOIL PACKAGING PRIVATE LIMITED",
"FLEXILE PUMPS & ENGINEERING INDIA PRIVATE LIMITED",
"FLEXILIS PRIVATE LIMITED",
"FLEXIM FLOW INDIA PRIVATE LIMITED",
"FLEXING IT SERVICES PRIVATE LIMITED",
"FLEXIPLE TECH PRIVATE LIMITED",
"FLEXIPOL FOAMS PRIVATE LIMITED",
"FLEXIRURAL URJA JALGAON LIMITED",
"FLEXIS INDIA PRIVATE LIMITED",
"FLEXIS IT PRIVATE LIMITED",
"FLEXISALES MARKETING PRIVATE LIMITED",
"FLEXISMILE PRIVATE LIMITED",
"FLEXISPACE BUSINESS SOLUTIONS PRIVATE LIMITED",
"FLEXITUFF VENTURES INTERNATIONAL LIMITED",
"FLEXIWARE SOLUTIONS PRIVATE LIMITED",
"FLEXLI TECHNOLOGIES PRIVATE LIMITED",
"FLEXM PRIVATE LIMITED",
"FLEXMAG CRAFTS PRIVATE LIMITED",
"FLEXMONEY TECHNOLOGIES PRIVATE LIMITED",
"FLEXO AUTOS PRIVATE LIMITED",
"FLEXO CONTRA PVT. LTD.",
"FLEXO FOAM PRIVATE LIMITED",
"FLEXO IMAGE GRAPHICS PRIVATE LIMITED",
"FLEXO PACK MACHINES PRIVATE LIMITED",
"FLEXO YARNS PRIVATE LIMITED",
"FLEXOL PACKAGING INDIA LIMITED",
"FLEXOMATIC VARIETY PACKAGINGS PRIVATE LIMITED",
"FLEXON ENGINEERS PRIVATE LIMITED",
"FLEXROUTE CHIT FUND PRIVATE LIMITED",
"FLEXSIN TECHNOLOGIES PRIVATE LIMITED",
"FLEXSTORE TECH PRIVATE LIMITED",
"FLEXTON BUSINESS SOLUTIONS PRIVATE LIMITED",
"FLEXTRADE INDIA PRIVATE LIMITED",
"FLEXTRONICS TECHNOLOGIES INDIA PRIVATE LIMITED",
"FLEXUR SYSTEMS PRIVATE LIMITED",
"FLEXUS LOGISTIC PRIVATE LIMITED",
"FLEXXON BIOSCIENCES PRIVATE LIMITED",
"FLFL ATHLEISURE LIMITED",
"FLFL LIFESTYLE BRANDS LIMITED",
"FLIC MICROWAVES PRIVATE LIMITED",
"FLICK STUDIOS PRIVATE LIMITED",
"FLICK2KNOW TECHNOLOGIES PRIVATE LIMITED",
"FLICKA COSMETICS PRIVATE LIMITED",
"FLICKER PROJECTS PRIVATE LIMITED",
"FLICKSTREE PRODUCTIONS PRIVATE LIMITED",
"FLIGEN SYSTEMS PRIVATE LIMITED",
"FLIGHT DESPATCH COURIER AND CARGO (INDIA) PRIVATE LIMITED",
"FLIGHT FAREHUB PRIVATE LIMITED",
"FLIGHT HUB EXCURSION PRIVATE LIMITED",
"FLIGHT SIMULATION TECHNIQUE CENTRE PRIVATE LIMITED",
"FLIGHT XPERT PRIVATE LIMITED",
"FLIGHTCASE IT SERVICES PRIVATE LIMITED",
"FLIGHTS GURU INFOTECH SERVICES PRIVATE LIMITED",
"FLIGHTS MOJO BOOKINGS PRIVATE LIMITED",
"FLIKSOFT TECHNOLOGIES PRIVATE LIMITED",
"FLIMS DIVISION MUMBAI",
"FLIN TECHNOLOGIES PRIVATE LIMITED",
"FLING CREATORS PRIVATE LIMITED",
"FLING PHARMACEUTICALS PRIVATE LIMITED",
"FLINGO FOOD AND AGRO PRIVATE LIMITED",
"FLINT GROUP INDIA PRIVATE LIMITED",
"FLINTO LEARNING SOLUTIONS PRIVATE LIMITED",
"FLIP CONCEPT INDIA PRIVATE LIMITED",
"FLIP IT TECHNOLOGIES PRIVATE LIMITED",
"FLIP MEDIA PRIVATE LIMITED",
"FLIPCHIP ELECTRONICS PRIVATE LIMITED",
"FLIPICK PRIVATE LIMITED",
"FLIPKART ADVANZ PRIVATE LIMITED",
"FLIPKART HEALTH LIMITED",
"FLIPKART INDIA PRIVATE LIMITED",
"FLIPKART INTERNET PRIVATE LIMITED",
"FLIPKART ONLINE SERVICES PRIVATE LIMITED",
"FLIPLEARN EDUCATION PRIVATE LIMITED",
"FLIPNFOLD INTERNET PRIVATE LIMITED",
"FLIPPER CLIPP POWER SYSTEMS PRIVATE LIMITED",
"FLIPPER CODE PRIVATE LIMITED",
"FLIPPER PUMPS PRIVATE LIMITED",
"FLIPPER TECH(INDIA) PRIVATE LIMITED",
"FLIPSIDE SYSTEMS & CONSULTANCY PRIVATE LIMITED",
"FLIPSPACES TECHNOLOGY LABS PRIVATE LIMITED",
"FLIR SYSTEMS INDIA PRIVATE LIMITED",
"FLITPAY PRIVATE LIMITED",
"FLIVE CONSULTING PRIVATE LIMITED",
"FLM TALENT MANAGEMENT AGENCY PRIVATE LIMITED",
"FLO IT SERVICES PRIVATE LIMITED",
"FLOATELS INDIA PRIVATE LIMITED",
"FLOATEX SOLAR PRIVATE LIMITED",
"FLOATING WALLS PRIVATE LIMITED",
"FLOCAREER INDIA PRIVATE LIMITED",
"FLO-CERT SOCIAL & ECONOMIC DEVELOPMENT INDIA PRIVATE LIMITED",
"FLOCK SOFTWARE PRIVATE LIMITED",
"FLOCKER ARTS PRIVATE LIMITED",
"FLOCKSUR INDIA PRIVATE LIMITED",
"FLO-DYNE CONTROLS INDIA PRIVATE LIMITED",
"FLOETER INDIA RETORT-POUCHES PRIVATE LIMITED",
"FLOHUREL & RII PRIVATE LIMITED",
"FLOKING PIPES PRIVATE LIMITED",
"FLOMETALLIC INDIA PRIVATE LIMITED",
"FLOMIC CARGO PRIVATE LIMITED",
"FLOMIC GLOBAL LOGISTICS LIMITED",
"FLOMIC LOGISTICS SERVICE PRIVATE LIMITED",
"FLONEX OIL INDIA PRIVATE LIMITED",
"FLONEX OIL TECHNOLOGIES PRIVATE LIMITED",
"FLOOD CONTROL INTERNATIONAL (INDIA) PRIVATE LIMITED",
"FLOOID LLP",
"FLOOR & FURNISHINGS INDIA PRIVATE LIMITED",
"FLOOR DEAL FLOORING DESTINATION PRIVATE LIMITED",
"FLOOR GUARD SOLUTION PRIVATE LIMITED",
"FLOOR SPACE (INDIA) PRIVATE LIMITED",
"FLOORKOTES PRIVATE LIMITED",
"FLOORMATE RUBBER PRODUCTS PRIVATE LIMITED",
"FLOORPOINT TRADING PRIVATE LIMITED",
"FLOORSCAPES CARPETS PRIVATE LIMITED",
"FLOORTECH POLYCOATINGS PRIVATE LIMITED",
"FLOPRESSURE TECHNOLOGIES PRIVATE LIMITED",
"FLORA & FAUNA HOUSING & LAND DEVELOPMENTS PRIVATE LIMITED",
"FLORA AGROTECH PRIVATE LIMITED",
"FLORA AND FAUNA HOUSING AND LAND DEVELOPEMENTS PRIVATE LIMITED",
"FLORA BIOCHEM PRIVATE LIMITED",
"FLORA CORPORATION LIMITED",
"FLORA ENTERPRISE INDIA PRIVATE LIMITED",
"FLORA EXPORTS",
"FLORA FACILITIES PRIVATE LIMITED",
"FLORA FOUNTAIN PROPERTIES LTD",
"FLORA LAMINATE",
"FLORA LEATHER FASHIONS PRIVATE LIMITED",
"FLORA MARMO INDUSTRIES PRIVATE LIMITED",
"FLORA NATURAL FLAVOURS AND EXTRACTS PRIVATE LIMITED",
"FLORA PACKAGING PRIVATE LIMITED",
"FLORA PHARMA PRIVATE LIMITED",
"FLORA STEELS PRIVATE LIMITED",
"FLORA VALLEY SCHOOL AND JUNIOR COLLEGE",
"FLORACHEM AROMATICS PRIVATE LIMITED",
"FLORADESIGN INDIA PRIVATE LIMITED",
"FLORAISON INDIA STRATEGIC CONSULTING PRIVATE LIMITED",
"FLORAL AROMATICS(INDIA) PRIVATE LIMITED",
"FLORAL ELECTRICAL PRIVATE LIMITED",
"FLORAL REALCON PRIVATE LIMITED",
"FLORAWARE INDIA PRIVATE LIMITED",
"FLOREAT INVESTMENTS LIMITED",
"FLOREAT MEDICA PRIVATE LIMITED",
"FLORENCE FENNEL INFORMATICA PRIVATE LIMITED",
"FLORENCE LIFE CARE PRIVATE LIMITED",
"FLORENCE PUBLIC SCHOOL",
"FLORENCE SHOE COMPANY PRIVATE LIMITED",
"FLORENCE TOBACCO PRIVATE LIMITED",
"FLORENS FOOTWEAR INDAI PRIVATE LIMITED",
"FLORENS FRESH SUPPLY SOLUTIONS PRIVATE LIMITED",
"FLORENTIS PHARMACEUTICALS PRIVATE LIMITED",
"FLORESSENCE PERFUMES PRIVATE LIMITED",
"FLORESTA REAL INDIA PRIVATE LIMITED",
"FLORET CONSULTANT PRIVATE LIMITED",
"FLORET IMPEX PRIVATE LIMITED",
"FLORET TRADES PRIVATE LIMITED",
"FLORETZ ACADEMY PRIVATE LIMITED",
"FLOREX CERAMIC PRIVATE LIMITED",
"FLORIAN VENTURE PRIVATE LIMITED",
"FLORICAL POLYMERS PRIVATE LIMITED",
"FLORID PRINT & PACK PRIVATE LIMITED",
"FLORID TECHNOLOGIES PRIVATE LIMITED",
"FLORIDA ELECTRICAL INDUSTRIES LIMITED",
"FLORIDA FACILITIES MANAGEMENT PRIVATE LIMITED",
"FLORIO VENTURES PRIVATE LIMITED",
"FLO-RITE BABY PRODUCTS PRIVATE LIMITED",
"FLORMARINA PRIVATE LIMITED",
"FLORTON INFRASTRUCTURE PRIVATE LIMITED",
"FLOSYS PUMPS PRIVATE LIMITED",
"FLOSYS WATER SOLUTIONS PRIVATE LIMITED",
"FLOTECH ENGINEERING PRIVATE LIMITED",
"FLOTECH MACHINERIES PRIVATE LIMITED",
"FLOTECH VELVETS PRIVATE LTD",
"FLOTHERM ENGINEERS PRIVATE LIMITED",
"FLOTO INDUSTRIES PRIVATE LIMITED",
"FLOTONIC METALS PRIVATE LIMITED",
"FLOUR DANIEL INDIA INC.",
"FLOUR TECH ENGINEERS PRIVATE LIMITED",
"FLOURINE CHEMICALS PRIVATE LIMITED",
"FLOURISH FOODPRODUCTS PRIVATE LIMITED",
"FLOURISH PAPER AND CHEMICALS LIMITED",
"FLOURISH PUREFOOD PRIVATE LIMITED",
"FLOURISH RETAIL PRIVATE LIMITED",
"FLOURISHING JOE PRIVATE LIMITED",
"FLOUSER ENGINEERING PRIVATE LIMITED",
"FLOVEL ENERGY PRIVATE LIMITED",
"FLOVEL HYDRO TECHNOLOGIES PRIVATE LIMITED",
"FLOVEL VALVES PRIVATE LIMITED",
"FLOW ART PRIVATE LIMITED",
"FLOW BANGALORE WATERJET PRIVATE LIMITED",
"FLOW CHEM PUMPS PRIVATE LIMITED",
"FLOW CONTROL PUMPS AND SYSTEMS PRIVATE LIMITED",
"FLOW EDGE SECURITIES PRIVATE LIMITED",
"FLOW FOSSIL FUEL CONSULTANCY AND SERVICES PRIVATE LIMITED",
"FLOW INK AND COATINGS PVT LTD",
"FLOW LINK INDUSTRIES PVT LTD",
"FLOW LINK SYSTEMS PRIVATE LIMITED",
"FLOW MATICS PRIVATE LIMITED",
"FLOW METERING TECHNOLOGY PRIVATE LIMITED",
"FLOW OIL PUMPS PRIVATE LIMITED",
"FLOW P&E INDIA PRIVATE LIMITED",
"FLOW TECH CHEMICALS PRIVATE LIMITED",
"FLOW TECHNIQUES PRIVATE LIMITED",
"FLOWACE TECHNOLOGIES PRIVATE LIMITED",
"FLOWAIR TECHNOLOGIES PRIVATE LIMITED",
"FLOWAY VALVES PRIVATE LIMITED",
"FLOWBIZ EXPORTS PRIVATE LIMITED",
"FLOWCENTRIC TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"FLOWCHAR INDIA PRIVATE LIMITED",
"FLOWCODE AUTOMATION PRIVATE LIMITED",
"FLOWCON AUTO SYSTEMS PRIVATE LIMITED",
"FLOWCON ENGINEER INDIA PRIVATE LIMITED",
"FLOWER KNITTING MILLS",
"FLOWER VALLEY AGRO-TECH PRIVATE LIMITED",
"FLOWER VALLEY FOODS FARMS PRIVATE LIMITED",
"FLOWER VALLEY RETREAT AND RESORTS PRIVATE LIMITED",
"FLOWERS BY DESIGN PRIVATE LIMITED",
"FLOWERS VALLEY PRIVATE LIMITED",
"FLOWEZY HYDRAULICS PRIVATE LIMITED",
"FLOWFORM ALLOYS PVT LTD",
"FLOWGAIN ENGINEERING PRIVATE LIMITED",
"FLOWGIC INDIA PRIVATE LIMITED",
"FLOWJET VALVES PRIVATE LIMITED",
"FLOWKEM POLY PLAST PRIVATE LIMITED",
"FLOWKRAFT TECHNOLOGIES PRIVATE LIMITED",
"FLOWLINE SERVICES PRIVATE LIMITED",
"FLOWLINE SYSTEMS PRIVATE LIMITED",
"FLOWLINES ENGINEERING PRIVATE LIMITED",
"FLOWMECH ENGINEERS PRIVATE LIMITED",
"FLOWMECH PUMPS PRIVATE LIMITED",
"FLOWMORE LIMITED",
"FLOWNIX VALVES PRIVATE LIMITED",
"FLOWRITHM SOLUTION PRIVATE LIMITED",
"FLOWSERVE INDIA CONTROLS PRIVATE LIMITED",
"FLOWSERVE MICROFINISH PUMPS PRIVATE LIMITED",
"FLOWSERVE MICROFINISH VALVES PRIVATE LIMITED",
"FLOWSERVE SANMAR LIMITED",
"FLOWSERVE SANMAR PRIVATE LIMITED",
"FLOWSTAR ENGINEERING PRIVATE LIMITED",
"FLOWTECH AUTOMATION PRIVATE LIMITED",
"FLOWTECH EQUIPMENTS (INDIA) PRIVATE LIMITED",
"FLOWTECH FLUID SYSTEMS PRIVATE LIMITED",
"FLOWTECH INDUSTRIAL PROJECTS PRIVATE LIMITED",
"FLOWTECH MEASURING INSTRUMENTS PRIVATE LIMITED",
"FLOWTECH PIPES PRIVATE LIMITED",
"FLOWTECH POLY PRODUCTS PRIVATE LIMITED",
"FLOWTECH SOLUTIONS LLP",
"FLOWTECH WATER METERS AND INSTRUMENTS PRIVATE LIMITED",
"FLOWWELL CASTINGS PRIVATE LIMITED",
"FLOWWRAP TECHNOLOGY PRIVATE LIMITED",
"FLP TRADING PRIVATE LIMITED",
"FLQ MANAGEMENT SERVICE PRIVATE LIMITED",
"FLSMIDTH PRIVATE LIMITED",
"FLT LT RAJAN DHALL CHARITABLE TRUST",
"FLUCON COMPONENTS PRIVATE LIMITED",
"FLUCONN ROTARY DEVICES PRIVATE LIMITED",
"FLUENCE PHARMA PRIVATE LIMITED",
"FLUENT HYDROSYSTEMS PRIVATE LIMITED",
"FLUENTGRID LIMITED",
"FLUERON INKS PRIVATE LIMITED",
"FLUFFYS INTERNATIONAL PRIVATE LIMITED",
"FLUICONNECTO INDIA PRIVATE LIMITED",
"FLUID AND POWER AUTOMATIONS LLP",
"FLUID CONTROL EQUIPMENTS PVT. LTD.",
"FLUID CONTROL RESEARCH INSTITUTE",
"FLUID CONTROLS PVT LTD",
"FLUID DYNAMICS PRIVATE LIMITED",
"FLUID ENERGY SYSTEM PRIVATE LIMITED",
"FLUID HAMMER CONSULTANCY SERVICES PRIVATE LIMITED",
"FLUID HARDWARE INDIA PRIVATE LIMITED",
"FLUID LINE ENGINEERS AND FABRICATORS PRIVATE LIMITED",
"FLUID MACHINE CONTROL PRIVATE LIMITED",
"FLUID METALS (INDIA) PRIVATE LIMITED",
"FLUID POWER SEALS. LIMITED",
"FLUID POWER TECHNOLOGIES PRIVATE LIMITED",
"FLUID PUMPS AND EQUIPMENT INDIA PRIVATE LIMITED",
"FLUID TOUCH PRIVATE LIMITED",
"FLUID WAYMARK PRIVATE LIMITED",
"FLUID3 INFOTECH PRIVATE LIMITED",
"FLUIDCHEM VALVES INDIA PRIVATE LIMITED",
"FLUIDCON BOILERS EQUIPMENTS PRIVATE LIMITED",
"FLUIDECH IT SERVICES PRIVATE LIMITED",
"FLUIDFIT ENGINEERS PRIVATE LIMITED",
"FLUIDHYDRO SYSTEMS PRIVATE LIMITED",
"FLUIDICS ENGINEERS PRIVATE LIMITED",
"FLUIDLINE SYSTEMS & CONTROLS PRIVATE LIMITED",
"FLUIDLINE VALVES COMPANY PRIVATE LIMITED",
"FLUIDLINE VALVES INTERNATIONAL PRIVATE LIMITED",
"FLUIDLOGIC SYSTEMS PRIVATE LIMITED",
"FLUIDMASTER INDIA PRIVATE LIMITED",
"FLUIDOMAT LIMITED",
"FLUIDONOMICS SOLUTIONS LLP",
"FLUIDPACK MACHINERY CO PRIVATE LIMITED",
"FLUIDPOWER MACHINES PRIVATE LIMITED",
"FLUIDSCAPES CONSULTANTS OPC PRIVATE LIMITED",
"FLUIDSTON MOTORS ENGINEERING PRIVATE LIMITED",
"FLUIDTECQ PNEUMATICS PRIVATE LIMITED",
"FLUIDTHERM DESIGN & DEVELOPMENT PRIVATE LIMITED",
"FLUIDTHERM TECHNOLOGY PRIVATE LIMITED",
"FLUIDYNE CONTROL SYSTEMS PRIVATE LIMITED",
"FLUIDYNE INSTRUMENTS PRIVATE LIMITED",
"FLUIIDMASK STUDIOS PRIVATE LIMITED",
"FLUKE INDUSTRIAL PRIVATE LIMITED",
"FLUKE TECHNOLOGIES PRIVATE LIMITED",
"FLUOBOR INDIA PRIVATE LIMITED",
"FLUOR CORPORATION",
"FLUOR DANIEL INDIA PRIVATE LIMITED",
"FLUOR PROJECTS INC.",
"FLUORESCENCE COMMUNICATIONS PRIVATE LIMITED",
"FLUORESCENT CHEMICAL INDUSTRIES PRIVATE LIMITED",
"FLUOROKRAFT PRIVATE LIMITED",
"FLUOROLINED EQUIPMENT PRIVATE LIMITED",
"FLUOROPLAST ENGINEERS PRIVATE LIMITED",
"FLUOROPLAST SOLUTIONS PRIVATE LIMITED",
"FLUOROPOLYMER PACKINGS AND SEALS PVT LTD",
"FLUOROTECH ENGINEERING PRIVATE LIMITED",
"FLUOROTECH POLYMERS PRIVATE LIMITED",
"FLUOROTECH TOOLING PRIVATE LIMITED",
"FLUOUS SOLUTIONS PRIVATE LIMITED",
"FLUPER LIMITED",
"FLUREE SOFTWARE INDIA PRIVATE LIMITED",
"FLURO ENGINEERING PRIVATE LIMITED",
"FLURY S SWISS CONFECTIONERY PRIVATE LIMITED",
"FLUTE DEVELOPERS PVT LTD",
"FLUTECH ENGINEERING PRIVATE LIMITED",
"FLUTECH INTERIORS INDIA PRIVATE LIMITED",
"FLUTRON BUILD & INFRA PRIVATE LIMITED",
"FLUTRON MOVIES & ENTERTAINMENT PRIVATE LIMITED",
"FLUTRON SOCIALS PRIVATE LIMITED",
"FLUTTER MEDIA PRIVATE LIMITED",
"FLUTURA BUSINESS SOLUTIONS PRIVATE LIMITED",
"FLUX CAPITAL PRIVATE LIMITED",
"FLUX FITNESS PRIVATE LIMITED",
"FLUX PUMPS INDIA PRIVATE LIMITED",
"FLUXCON INFRATECK PRIVATE LIMITED",
"FLUXIAN BUSINESS ENGINEERING PRIVATE LIMITED",
"FLUXLITE NIMS PRIVATE LIMITED",
"FLUXMIN METAL PRIVATE LIMITED",
"FLUXON APPS PRIVATE LIMITED",
"FLUXONIX EDUCATIONAL SERVICES PRIVATE LIMITED",
"FLUXPRO LIQUITEC PRIVATE LIMITED",
"FLUXTEEL INSULATIONS PRIVATE LIMITED",
"FLUXTRANS LOGISTICS PRIVATE LIMITED",
"FLUXURA ELITE VENTURES PRIVATE LIMITED",
"FLXBL DESIGN CONSULTANCY PRIVATE LIMITED",
"FLY AEROLINK TRAVEL TRADE PRIVATE LIMITED",
"FLY ANY MOMENT TRAVEL SOLUTIONS PRIVATE LIMITED",
"FLY ASH MOVERS (INDIA) PRIVATE LIMITED",
"FLY BIRD TECHNOLOGIES PRIVATE LIMITED",
"FLY BY ME TOURS & TRAVELS PRIVATE LIMITED",
"FLY EDGE CARGO PRIVATE LIMITED",
"FLY HELI AVIATION PRIVATE LIMITED",
"FLY HI MARINE TRAVELS PRIVATE LIMITED",
"FLY HIND TOURS AND TRAVELS PRIVATE LIMITED",
"FLY HUB TRAVEL PRIVATE LIMITED",
"FLY INDIA EXPRESS PRIVATE LIMITED",
"FLY INDUSTRIES (I) PRIVATE LIMITED",
"FLY LEMON TRAVEL & FOREX PRIVATE LIMITED",
"FLY MEDIA PRIVATE LIMITED",
"FLY MOBILES PRIVATE LIMITED",
"FLY N FEEL HOLIDAYS (INDIA) PRIVATE LIMITED",
"FLY NET TOURS AND TRAVELS PRIVATE LIMITED",
"FLY ON IT INDIA PRIVATE LIMITED",
"FLY OVER CARGO PRIVATE LIMITED",
"FLYAUDIO SERVICES INDIA PRIVATE LIMITED",
"FLYBERRY INTER-TRADE PRIVATE LIMITED",
"FLYBLADE INDIA PRIVATE LIMITED",
"FLYBUNCH VENTURES PRIVATE LIMITED",
"FLY-BY-WIRE INTERNATIONAL PRIVATE LIMITED",
"FLYCATCHER FOODS PRIVATE LIMITED",
"FLYCO AUTO PRIVATE LIMITED.",
"FLYCREATIVE ONLINE PRIVATE LIMITED",
"FLYDOCS INDIA PRIVATE LIMITED",
"FLYDUBAI AVIATION SERVICES PRIVATE LIMITED",
"FLYER FREIGHT SYSTEMS PRIVATE LIMITED",
"FLYERS SOFT PRIVATE LIMITED",
"FLYFIN SOFTWARE INDIA PRIVATE LIMITED",
"FLYFOT PUBLIC SCHOOL",
"FLYFOX FOREX PRIVATE LIMITED",
"FLYFOX SOLUTIONS PRIVATE LIMITED",
"FLYGA AUTO PRIVATE LIMITED",
"FLYGA RESORTS PRIVATE LIMITED",
"FLYGUISE APPARELS COMPANY PRIVATE LIMITED",
"FLY-HIGH LOGISTICS PRIVATE LIMITED",
"FLYHOMES RESIDENTIAL INDIA PRIVATE LIMITED",
"FLYING BIRDS EDUCATIONAL RESEARCH AND DEVELOPMENT FOUNDATION.",
"FLYING CURSOR INTERACTIVE",
"FLYING DOCTORS (INDIA) PRIVATE LIMITED",
"FLYING ELEPHANT STUDIOS PRIVATE LIMITED",
"FLYING FIRE SERVICES PRIVATE LIMITED",
"FLYING FREIGHT CARRIERS PRIVATE LIMITED",
"FLYING GREEN CARRIERS PRIVATE LIMITED",
"FLYING HORSE IMPEX PRIVATE LIMITED",
"FLYING PIGS PRODUCTION PRIVATE LIMITED",
"FLYING SAMURAI SOLUTIONS PRIVATE LIMITED",
"FLYING TOADS ENTERTAINMENT PRIVATE LIMITED",
"FLYING TRADE (INDIA) PRIVATE LIMITED",
"FLYINGBEE TECHNOLOGIES PRIVATE LIMITED",
"FLYINGBIZ BUYING SOLUTIONS PRIVATE LIMITED",
"FLYJAC LOGISTICS PRIVATE LIMITED",
"FLYJET AIR WAYS PRIVATE LIMITED",
"FLYKING COURIER SERVICES PVT LTD",
"FLYLITE LUGGAGE (INDIA) PRIVATE LIMITED",
"FLYNAVA TECHNOLOGIES PRIVATE LIMITED",
"FLYOLA INDIA PRIVATE LIMITED",
"FLYONE JUSJUMP PRIVATE LIMITED",
"FLYONTECH SOLUTION",
"FLYOVER DISTILLERS & BOTTLERS PRIVATE LIMITED",
"FLYOVER LODGE PVT LTD",
"FLYSBS AVIATION PRIVATE LIMITED",
"FLYSCANNER HOLIDAYS PRIVATE LIMITED",
"FLYSEA CLEARING & FORWARDING PRIVATE LIMITED",
"FLYTBASE LABS PRIVATE LIMITED",
"FLYTECH AVIATION LIMITED",
"FLY-TECH ENGINEERS PRIVATE LIMITED",
"FLYTRON ELECTRICALS PRIVATE LIMITED",
"FLYTXT MOBILE SOLUTIONS PRIVATE LIMITED",
"FLYVI TECHNOLOGIES PRIVATE LIMITED",
"FLYWELL AVIATION PRIVATE LIMITED",
"FLYWHEEL RING GEARS PRIVATE LIMITED",
"FLYWING FREIGHT PRIVATE LIMITED",
"FLYYON SOLUTIONS PRIVATE LIMITED",
"FM ADVISORY SERVICES PRIVATE LIMITED",
"FM GLOBAL LOGISTICS INDIA PRIVATE LIMITED",
"FM INDIA SUPPLY CHAIN PRIVATE LIMITED",
"FM INFRACITY PRIVATE LIMITED",
"FMC HEALTHCARE PRIVATE LIMITED",
"FMC INDIA PRIVATE LIMITED",
"FMC TECHNOLOGIES INDIA PRIVATE LIMITED",
"FMG APPARELS PRIVATE LIMITED",
"FMG CLOTHING PRIVATE LIMITED",
"FMG EXPORTS PRIVATE LIMITED",
"FMI AUTOMOTIVE COMPONENTS PRIVATE LIMITED",
"FMI LIMITED",
"FMK VENTURES PRIVATE LIMITED",
"FMS FR MEYER'S SOHN INDIA PRIVATE LIMITED",
"FMS MEDIA SOLUTIONS",
"FMS SOLUTIONS INDIA PRIVATE LIMITED",
"FN MATHLOGIC CONSULTING SERVICES PRIVATE LIMITED",
"FNB PACKAGING PRIVATE LIMITED",
"FNBNEEDS FOODS PRIVATE LIMITED",
"FNC INVESTMENT PRIVATE LIMITED",
"FNF INDIA PRIVATE LIMITED",
"FNG CLEAN & HYGIENE PRIVATE LIMITED",
"FNINE INFRA SOLUTIONS PRIVATE LIMITED",
"FNK SERVICES INDIA PRIVATE LIMITED",
"FNKSTYLE PRIVATE LIMITED",
"FNM PROPERTY SERVICES PRIVATE LIMITED",
"FNP WEDDINGS & EVENTS INDIA PRIVATE LIMITED",
"FNV RETAIL PRIVATE LIMITED",
"FOA RESEARCH PRIVATE LIMITED",
"FOAB SOLUTIONS PRIVATE LIMITED",
"FOAM HOME (INDIA ) PRIVATE LIMITED",
"FOAM MATTINGS INDIA LIMITED",
"FOAM PALACE TRADING (INDIA) PRIVATE LIMITED",
"FOAM SALES (INDIA) PRIVATE LIMITED",
"FOAM SPECIALTIES INDIA PRIVATE LIMITED",
"FOAM SUPPLIES INDIA PRIVATE LIMITED",
"FOAMPACK INDIA PRIVATE LIMITED",
"FOAMTECH ANTIFIRE PRIVATE LIMITED",
"FOCAL AUDIO SYSTEMS P.LTD.",
"FOCAL IMAGE INDIA PRIVATE LIMITED",
"FOCAL PHOTOVOLTAIC INDIA PRIVATE LIMITED",
"FOCAL RENEWABLE ENERGY TWO INDIA PRIVATE LIMITED",
"FOCAL SKILL DEVELOPMENT PRIVATE LIMITED",
"FOCAL3 SOFTWARE PRIVATE LIMITED",
"FOCALOID TECHNOLOGIES PRIVATE LIMITED",
"FOCALPOINT CONSULTANCY SERVICES PRIVATE LIMITED",
"FOCALWORKS SOLUTIONS PRIVATE LIMITED",
"FOCE INDIA LIMITED",
"FOCLO TECHNOLOGIES PRIVATE LIMITED",
"FOCUS 4D CAREER EDUCATION PRIVATE LIMITED",
"FOCUS AGROTECH PRIVATE LIMITED",
"FOCUS AUTO DESIGNWORKS PRIVATE LIMITED",
"FOCUS BRANDS TRADING INDIA PRIVATE LIMITED",
"FOCUS BUSINESS SOLUTION LIMITED",
"FOCUS COMBINE MARKETING PRIVATE LIMITED",
"FOCUS COMPUTECH PRIVATE LIMITED",
"FOCUS COMPUTERS PRIVATE LIMITED",
"FOCUS COMTRADE PRIVATE LIMITED",
"FOCUS CONSULTANCY SERVICES",
"FOCUS CONTROLS PRIVATE LIMITED",
"FOCUS DENTAL SERVICES PRIVATE LIMITED",
"FOCUS EDU-CARE PRIVATE LIMITED",
"FOCUS ENERGY LIMITED",
"FOCUS EYE TECHNOCRAFT PRIVATE LIMITED",
"FOCUS FITNESS PRIVATE LIMITED",
"FOCUS GEOSPATIAL PRIVATE LIMITED",
"FOCUS HEALTH CARE PRIVATE LIMITED",
"FOCUS IAS ACADEMY",
"FOCUS IMAGING & RESEAECH CENTRE PRIVATE LIMITED",
"FOCUS INBOX PACKAGING PRIVATE LIMITED",
"FOCUS INFOSOFT PRIVATE LIMITED",
"FOCUS INFRA ENGINEERING INDIA PRIVATE LIMITED",
"FOCUS LABELS PRIVATE LIMITED",
"FOCUS LENSES (INDIA ) PRIVATE LIMITED",
"FOCUS LIFESTYLE PRIVATE LIMITED",
"FOCUS LIGHTING AND FIXTURES PRIVATE LIMITED",
"FOCUS MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"FOCUS MEDICA INDIA PRIVATE LIMITED",
"FOCUS MEDISALES PRIVATE LIMITED",
"FOCUS MERCHANTS LIMITED",
"FOCUS MOTORS PRIVATE LIMITED",
"FOCUS MULTI-SPECIALITY CENTRE LLP",
"FOCUS PHARMA PRIVATE LIMITED",
"FOCUS POLYMERS AND EMULSION LIMITED",
"FOCUS PRISM PRIVATE LIMITED",
"FOCUS ROBOTOMATION PRIVATE LIMITED",
"FOCUS SHARES & SECURITIES PRIVATE LIMITED",
"FOCUS SHOES PRIVATE LIMITED",
"FOCUS TOURS & TRAVELS PRIVATE LIMITED",
"FOCUS TRADE FAIRS PRIVATE LIMITED",
"FOCUS TRANS TECH SHIPPING PRIVATE LIMITED",
"FOCUSCRAFT TECH PRIVATE LIMITED",
"FOCUSON INTERIOR DECORATORS PRIVATE LIMITED",
"FOCUSTEK MANUFACTURING SERVICES PRIVATE LIMITED",
"FOCUZ AUTOMOBILE SERVICES PRIVATE LIMITED",
"FOCUZ PARTS MART PRIVATE LIMITED",
"FODERY RETAIL PRIVATE LIMITED",
"FOERSTER BHUPATHI CONSULTING PRIVATE LIMITED",
"FOETRON CONSULTANCY SERVICES PRIVATE LIMITED",
"FOFO TECHNOLOGIES PRIVATE LIMITED",
"FOGAAT PUBLIC SCHOOL",
"FOGAAT PUBLIC SR SEC SCHOOL",
"FOGGERS INDIA PRIVATE LIMITED",
"FOGGERWALA PRIVATE LIMITED",
"FOGGIA IMPEX PRIVATE LIMITED",
"FOGLA ENTERPRISES PRIVATE LIMITED",
"FOGO ENERGY VENTURES PRIVATE LIMITED",
"FOGTEC FIRE PROTECTION PRIVATE LIMITED",
"FOIL HUB PRIVATE LIMITED",
"FOIL KONCEPTS PRIVATE LIMITED",
"FOJI FREIGHT CARRIER PRIVATE LIMITED",
"FOKAL ANALYTICS PRIVATE LIMITED",
"FOKKER ELMO SASMOS INTERCONNECTION SYSTEMS LIMITED",
"FOLD PACK INDIA PRIVATE LIMITED",
"FOLEY DESIGNS PRIVATE LIMITED",
"FOLIAGE CROP SOLUTIONS PRIVATE LIMITED",
"FOLIUM TRADING PRIVATE LIMITED",
"FOLLOWEL ENGINEERING LTD",
"FOLLY SYSTEMS PRIVATE LIMITED",
"FOM ALUMINIUM MACHINES PRIVATE LIMITED",
"FOMAR CV BRAKES INDIA PRIVATE LIMITED",
"FOMAR PRIVATE LIMITED.",
"FOMENTO RESORTS AND HOTELS LIMITED",
"FOMENTO RESOURCES PRIVATE LIMITED",
"FOMEX PACKAGING PRIVATE LIMITED",
"FOMEX PETPACK PRIVATE LIMITED",
"FOMO FOODS INTERNATIONAL PRIVATE LIMITED",
"FOMRA ELECTRICALS PRIVATE LIMITED",
"FOMRA HOUSING AND INFRASTRUCTURE PRIVATE LIMITED",
"FONA RUBBER PVT LTD",
"FONANTRIX SOLUTIONS LLP",
"FONCER PHARMA PRIVATE LIMITED",
"FONDEMENT BITUMENOUS INDUSTRIES PRIVATE LIMITED",
"FONDOS TECHNOLOGIES PRIVATE LIMITED",
"FONE KING (COMMUNICATION) PRIVATE LIMITED",
"FONE ZONE NXT SOLUTION PRIVATE LIMITED",
"FONE4 COMMUNICATIONS(INDIA) LIMITED",
"FONEBOX RETAIL LIMITED",
"FONECITY RETAILS PRIVATE LIMITED",
"FON-ESS INDIA PRIVATE LIMITED",
"FONEZ 4 U PRIVATE LIMITED",
"FONEZELA INDIA PRIVATE LIMITED",
"FONG'S TECHNICAL SERVICES PRIVATE LIMITED",
"FONSARK TRADERS PVT. LTD.",
"FONTAL FLEXIPACK LIMITED",
"FONTANA FASTENERS INDIA PRIVATE LIMITED",
"FONTANA IMPEX PRIVATE LIMITED",
"FONTE FASHIONS INDIA PRIVATE LIMITED",
"FONTERRA FUTURE DAIRY PRIVATE LIMITED",
"FONTY SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED",
"FONZEL OFFICE SOLUTIONS PRIVATE LIMITED",
"FONZONE EXPORTS PRIVATE LIMITED",
"FOOD AND BEVERAGES",
"FOOD AND BIOTECH ENGINEERS INDIAPRIVATE LIMITED",
"FOOD AND CIVIL SUPPLIES CONTROLLER",
"FOOD AND CIVIL SUPPLIES DEPARTMENT OF FOOD UTTAR PRADESH",
"FOOD AND DRUGS LABORATORY GOVT OF GUJARAT",
"FOOD ART HOSPITALITY PRIVATE LIMITED",
"FOOD BARN (INDIA) PRIVATE LIMITED",
"FOOD CIVIL SUPPLIES AND CONSUMER AFFAIRS",
"FOOD CLOUD PRIVATE LIMITED",
"FOOD CORPORATION OF INDIA",
"FOOD CRAFT INSTITUTE ALIGARH",
"FOOD CRAFT INSTITUTE CHANDIGARH",
"FOOD CRAFTS INDIA PRIVATE LIMITED",
"FOOD CREATIONS PRIVATE LIMITED",
"FOOD DEPARTMENT CG RAIPUR",
"FOOD EDGE GOURMET SOLUTIONS PRIVATE LIMITED",
"FOOD FIESTA CAFE LLP",
"FOOD FREAKS INDIA PRIVATE LIMITED",
"FOOD HUB SOFTWARE SOLUTIONS INDIA PRIVATE LIMITED",
"FOOD INDUSTRIES",
"FOOD INGREDIENT SPECIALITIES PRIVATE LIMITED",
"FOOD INTELLECT INDIA PRIVATE LIMITED",
"FOOD KING IMPEX PRIVATE LIMITED",
"FOOD LIVE & FUN PRIVATE LIMITED",
"FOOD MATRIX PRIVATE LIMITED",
"FOOD MATTERS INDIA PRIVATE LIMITED",
"FOOD PACK INDUSTRIES PRIVATE LIMITED",
"FOOD PLANET PRIVATE LIMITED",
"FOOD PRINTER PRIVATE LIMITED",
"FOOD SAFETY AND STANDARDS AUTHORITY OF INDIA",
"FOOD SECURITY FOUNDATION INDIA",
"FOOD SERVICE INDIA PRIVATE LIMITED",
"FOOD SOLUTION INDIA LIMITED",
"FOOD SUPPLIES & CONSUMER AFFAIRSHQ",
"FOOD SUPPLIES DEPTT",
"FOOD WORLD HOSPITALITY PRIVATE LIMITED",
"FOOD ZEST CATERING AND HOSPITALITY SERVICES",
"FOODALE INDIA PRIVATE LIMITED",
"FOODAY SPICES INDIA PRIVATE LIMITED",
"FOODBURY RETAIL PRIVATE LIMITED",
"FOODCO EXPORTS PRIVATE LIMITED",
"FOODCOAST INTERNATIONAL",
"FOODCRAFT INDIA PRIVATE LIMITED",
"FOODEXOCHENNAI PRIVATE LIMITED",
"FOODFESTA WELLCARE PRIVATE LIMITED",
"FOODGRAIN DISTRIBUTION OFFICER",
"FOODIES ET AL INDIA PRIVATE LIMITED",
"FOODIEVERSE INDIA PRIVATE LIMITED",
"FOODIMENTARY INDIA LIMITED",
"FOODIZ INTERNATIONAL PRIVATE LIMITED",
"FOODLAND CEREALS PRIVATE LIMITED",
"FOODLINE ENTERPRISES PRIVATE LIMITED",
"FOODLINK RESTAURANTS INDIA PRIVATE LIMITED",
"FOODLINK SERVICES INDIA PRIVATE LIMITED",
"FOODLOOKING DIGITAL PRIVATE LIMITED",
"FOODNOLOGY INDIA PRIVATE LIMITED",
"FOODOMOTIVE INDUSTRIES PRIVATE LIMITED",
"FOODPEDIA PRIVATE LIMITED",
"FOODPRO PACKAGING PRIVATE LIMITED",
"FOODQUEST PRIVATE LIMITED",
"FOODS AND INNS LIMITED",
"FOODSTA SUPPLY CHAIN PRIVATE LIMITED",
"FOODSUTRA ART OF SPICES PRIVATE LIMITED",
"FOODSWING ENTERPRISES",
"FOODTRON TECHNOLOGIES PRIVATE LIMITED",
"FOODVILLE HOSPITALITY SERVICES PRIVATE LIMITED",
"FOODVILLE OVERSEAS PRIVATE LIMITED",
"FOODVISTA INDIA PRIVATE LIMITED",
"FOOT PRINTS COLLATERAL SERVICES PRIVATE LIMITED",
"FOOT STEPS (INDIA) PRIVATE LTD",
"FOOTAGE FASHION WEAR PRIVATE LIMITED",
"FOOTBALL SPORTS DEVELOPMENT LIMITED",
"FOOTMATE POLYMERS INDIA PRIVATE LIMITED",
"FOOTPRINTS ADVERTISING PRIVATE LIMITED",
"FOOTPRINTS CHILDCARE PRIVATE LIMITED",
"FOOTPRINTS EDUCATION PRIVATE LIMITED",
"FOOTPRO SOLUTIONS PRIVATE LIMITED",
"FOOTROO PRIVATE LIMITED",
"FOOTWEAR (KLICK) INDIA PRIVATE LIMITED",
"FOOTWEAR DESIGN AND DEVELOPMENT INSTITUTE",
"FOR EVER DESIGNERS AND BUILDERS PRIVATE LIMITED",
"FOR RAJU IAS STUDY CIRCLE",
"FOR U INTERNATIONAL PRIVATE LIMITED",
"FOR U KIDS RETAIL PRIVATE LIMITED",
"FOR U SERVICES PRIVATE LIMITED",
"FOR-A INDIA PRIVATE LIMITED",
"FORACE POLYMERS PRIVATE LIMITED",
"FORACE SPECIALITY CHEM PRIVATE LIMITED",
"FORADIAN TECHNOLOGIES PRIVATE LIMITED",
"FORAGEN SEEDS PRIVATE LIMITED",
"FORAY NETWORK SERVICES PRIVATE LIMITED",
"FORAY PHARMA DISTRIBUTORS PRIVATE LIMITED",
"FORAY SOFTWARE PRIVATE LIMITED",
"FORAY UNIVERSAL CONSULTANCY SERVICES PRIVATE LIMITED",
"FORAYS SERVICES AND CONSTRUCTIONS PRIVATE LIMITED",
"FORBCORP PRIVATE LIMITED",
"FORBES AND COMPANY LIMITED",
"FORBES AQUATECH LIMITED",
"FORBES AUTOMATION TECHNOLOGIES PRIVATE LIMITED",
"FORBES BUILDING SOLUTIONS INDIA PRIVATE LIMITED",
"FORBES BUMI ARMADA LIMITED",
"FORBES CAMPBELL SERVICES LIMITED",
"FORBES EWART AND FIGGIS PVT LTD",
"FORBES MARSHALL (HYD) PRIVATE LIMITED",
"FORBES MARSHALL ARCA PRIVATE LIMITED",
"FORBES MARSHALL PRIVATE LIMITED",
"FORBES PHARMACEUTICALS PRIVATE LIMITED",
"FORBES TECHNOLOGIES INDIA PRIVATE LIMITED",
"FORBES TECHNOSYS LIMITED",
"FORBESGUNJ FOOD PROCESSING PRIVATE LIMITED",
"FORBESVYNCKE PRIVATE LIMITED",
"FORBIDDEN FOODS PRIVATE LIMITED",
"FORBO FLOORING B. V.",
"FORBO SIEGLING MOVEMENT SYSTEMS INDIA PRIVATE LIMITED",
"FORBOND METALS PRIVATE LIMITED",
"FORBRO LIFESTYLES LIMITED",
"FORCAS IMPEX PRIVATE LIMITED",
"FORCE - STRAIN SENSORS PRIVATE LIMITED",
"FORCE 1 GUARDING SERVICES PRIVATE LIMITED",
"FORCE ACTUATORS PRIVATE LIMITED",
"FORCE CONSTRUCTION PRIVATE LIMITED",
"FORCE FITNESS INDIA PRIVATE LIMITED",
"FORCE IDENTIFICATION PRIVATE LIMITED",
"FORCE MACHINERY INDIA PRIVATE LIMITED",
"FORCE MOTORS EARLEIR KNOWN AS BAJAJ TEMPO",
"FORCE MOTORS LIMITED",
"FORCE MTU POWER SYSTEMS PRIVATE LIMITED",
"FORCE PRO LOGISTICS PRIVATE LIMITED",
"FORCE REALTORS PRIVATE LIMITED",
"FORCE SCIENTIFIC TECHNOLOGIES PRIVATE LIMITED",
"FORCE STRUCTURAL ENGINEERS PRIVATE LIMITED",
"FORCE TECH SECURITY INDIA PRIVATE LIMITED",
"FORCE TEN TECHNOLOGIES PRIVATE LIMITED",
"FORCE UNIVERSAL PRIVATE LIMITED",
"FORCE10 INTEGRATED SERVICES PRIVATE LIMITED",
"FORCE18 ACADEMY AND SECURITY SERVICES PRIVATE LIMITED",
"FORCEACADEMY RECRUITMENTS PRIVATE LIMITED",
"FORCECRAVER TECHNOLOGIES PRIVATE LIMITED",
"FORCEFOX TECHNOLOGIES PRIVATE LIMITED",
"FORCEPOINT SECURITY SERVICES PRIVATE LIMITED",
"FORCEPOINT SOFTWARE CONSULTING INDIA PRIVATE LIMITED",
"FORCEPRO LOGISTICS PRIVATE LIMITED",
"FORCETO INDIA PRIVATE LIMITED",
"FORCON INFRA PRIVATE LIMITED",
"FORD CREDIT INDIA PRIVATE LIMITED",
"FORD FOOTWEAR (INDIA) PRIVATE LIMITED",
"FORD HOSPITAL AND RESEARCH CENTER PRIVATE LIMITED",
"FORD SMART MOBILITY INDIA PRIVATE LIMITED",
"FORDELA IMPEX PRIVATE LIMITED",
"FORDHAM CONSULTANCY PRIVATE LIMITED",
"FORE AGRO PRIVATE LIMITED",
"FORE BRAIN TECHNOLOGIES PRIVATE LIMITED",
"FORE CONSULTANTS PRIVATE LIMITED",
"FORE EXCEL PRIVATE LIMITED",
"FORE REPRESENTATIONS&TRAVELS PRIVATE.LIMITED",
"FORE SCHOOL OF MANAGEMENT",
"FORE SOLUTIONS PRIVATE LIMITED",
"FORE SUPPORT SERVICES INDIA PRIVATE LIMITED",
"FORE VISION INSTRUMENTS INDIA PRIVATE LIMITED",
"FORE VISION TECHNOLOGIES PRIVATE LIMITED",
"FOREBROS TOOLS PRIVATE LIMITED",
"FORECAST ADVERTISING PRIVATE LIMITED",
"FORECAST EARTHINGS PRIVATE LIMITED",
"FORECH CONVEYORS PRIVATE LIMITED",
"FORECH INDIA LIMITED",
"FORECH INDIA PRIVATE LIMITED",
"FORECOM INFRATECH SYSTEMS PRIVATE LIMITED",
"FOREFRONT HEALTHCARE PRIVATE LIMITED",
"FOREFRONT LOGISTICS PRIVATE LIMITED",
"FOREFRONT PROPERTY DEVELOPERS PRIVATE LIMITED",
"FOREGEN HEALTHCARE LIMITED",
"FOREIN CROP SCIENCE PRIVATE LIMITED",
"FOREINFRA PRIVATE LIMITED",
"FOREL LABS PRIVATE LIMITED",
"FOREMAN MACHINE TOOLS PRIVATE LIMITED",
"FOREMATIC TECHNEOW SOLUTION PRIVATE LIMITED",
"FOREMOST BRANDS PRIVATE LIMITED",
"FOREMOST EXIMS PRIVATE LIMITED",
"FOREMOST HEALTH CARE PRIVATE LIMITED",
"FOREMOST INFORMATION AND DATA INTERCHANGE LIMITED",
"FOREMOST REALTORS PRIVATE LIMITED",
"FORENSIC CYBERTECH PRIVATE LIMITED",
"FORENSIC SCIENCE LABORATORY GANDHINAGAR",
"FORENTEC ENGINEERS PRIVATE LIMITED",
"FORERUN COMPUTERS AND SYSTEMS PRIVATE LIMITED",
"FORERUN GLOBAL SOLUTIONS PRIVATE LIMITED",
"FORERUN TECHNOLOGIES INDIA PRIVATE LIMITED",
"FORES TUBULAR PRIVATE LIMITED",
"FORESCOUT TECHNOLOGIES INDIA PRIVATE LIMITED",
"FORESEE AVIATION PRIVATE LIMITED",
"FORESEEMAX INDIA PRIVATE LIMITED",
"FORESEER AI SYSTEMS INDIA PRIVATE LIMITED",
"FORESH RESEARCH INSTITUTE - DEHRA DOON",
"FORESIGHT BULLION INDIA PRIVATE LIMITED",
"FORESIGHT FAMILY OFFICE PRIVATE LIMITED",
"FORESIGHT HEALTHCARE INNOVATIONS PRIVATE LIMITED",
"FORESIGHT HOLDINGS PRIVATE LIMITED",
"FORESIGHT HOSPITALS PRIVATE LIMITED",
"FORESIGHT INFRATECH PRIVATE LIMITED",
"FORESIGHT IT SOLUTIONS AND CONSULTING INDIA PRIVATE LIMITED",
"FORESIGHT REALTECH PRIVATE LIMITED",
"FORESIGHT SOFTWARE SOLUTIONS PRIVATE LIMITED",
"FORESIGHT SURVEY SUPPORT INDIA PRIVATE LIMITED",
"FORESIGHT VISION CARE COMPANY PRIVATE LIMITED",
"FORESIGHTCFO PRIVATE LIMITED",
"FORESITE TECHNOLOGIES PRIVATE LIMITED",
"FORESS IMPEX PRIVATE LIMITED",
"FORESS WORLDCLASS HOSPITALITY PRIVATE LIMITED",
"FOREST CORPORATION",
"FOREST CREATIVE COMMUNICATIONS PRIVATE LIMITED",
"FOREST DEPARTMENT",
"FOREST DEPARTMENT GIR WEST DIVISION JUNAGADH",
"FOREST DEPARTMENT SURGUJA DIVISION AMBIKAPUR C.G",
"FOREST DEVELOPMENT CORPORATION OF MAHARASHTRA LIMITED",
"FOREST ENVIRONMENT DEPT",
"FOREST GOLD PRODUCTS PRIVATE LIMITED",
"FOREST HILL RESORT PRIVATE LIMITED",
"FOREST RESEARCH CENTRE FOR SKILL DEVELOPMENT",
"FOREST RESEARCH INSTITUTE",
"FOREST SETTLEMENT OFFICER, KONKAN BHAVAN NAVI MUMBAI",
"FOREST SURVEY OF INDIA",
"FORESTREE INDIA PRIVATE LIMITED",
"FORESTRY INNOVATION CONSULTING INDIA PRIVATE LIMITED",
"FORESTVEDA PRODUCTS PRIVATE LIMITED",
"FORETECH COMPUTER SYSTEMS PRIVATE LIMITED",
"FORETEK MARKETING PRIVATE LIMITED",
"FORETEL DOORVANI PRIVATE LIMITED",
"FORETHOUGHT VENTURES PRIVATE LIMITED",
"FOREVER BEADS N JEWEL PRIVATE LIMITED",
"FOREVER BUILDTECH PRIVATE LIMITED",
"FOREVER BUSINESS SOLUTIONS PRIVATE LIMITED",
"FOREVER DISTILLERY PRIVATE LIMITED",
"FOREVER ENGINEERING SYSTEMS PRIVATE LIMITED",
"FOREVER EXIM INDIA PRIVATE LIMITED",
"FOREVER FASHIONS PRIVATE LIMITED",
"FOREVER FREEDOM IMPEX PRIVATE LIMITED",
"FOREVER GEMS PRIVATE LIMITED",
"FOREVER HERBAL PRODUCTS PRIVATE LIMITED",
"FOREVER LIFESCIENCE PRIVATE LIMITED",
"FOREVER LIVING IMPORTS INDIA PRIVATE LIMITED",
"FOREVER LIVING PRODUCTS INDIA PRIVATE LIMITED",
"FOREVER MERCHANTS PRIVATE LIMITED",
"FOREVER NEW APPARELS PRIVATE LIMITED",
"FOREVER TOY MAKER PRIVATE LIMITED",
"FOREVER YOOUNG WELLNESS PRIVATE LIMITED",
"FOREX FASTENERS PRIVATE. LIMITED.",
"FOREX FASTNERS PRIVATE LIMITED",
"FOREX LEAFIN PRIVATE LIMITED",
"FORG3D METALS PRIVATE LIMITED",
"FORGE 2000 PRIVATE LIMITED",
"FORGE AND FORGE PRIVATE LIMITED",
"FORGE CAST ALLOY PRIVATE LIMITED",
"FORGEMAX AUTO COMPONENTS PRIVATE LIMITED",
"FORGEPRO INDIA PRIVATE LIMITED",
"FORGERON INDUSTRIES PRIVATE LIMITED",
"FORGEWELL LIMITED",
"FORGING AND STAMPING PRIVATE LIMITED",
"FORGIX PRIVATE LIMITED",
"FORGO PHARMACEUTICALS PRIVATE LIMITED",
"FORGOFIN FASTNERS INDIA PRIVATE LIMITED",
"FORGUL THERMA FARMING PRIVATE LIMITED",
"FORI AUTOMATION INDIA PRIVATE LIMITED",
"FORIN CONTAINER LINE PRIVATE LIMITED",
"FORIND NUTRIENTS PRIVATE LIMITED",
"FORK MEDIA PRIVATE LIMITED",
"FORLIFE TRADING INDIA PRIVATE LIMITED",
"FORM3D SOLUTIONS PRIVATE LIMITED",
"FORMA CHEM PVT LTD",
"FORMAN MEDICS PRIVATE LIMITED",
"FORMATIVE ENGINEERING PRIVATE LIMITED",
"FORMATIVE FASHIONS PRIVATE LIMITED",
"FORMAX ELECTRONICS PRIVATE LIMITED",
"FORMCEPT TECHNOLOGIES & SOLUTIONS PRIVATE LIMITED",
"FORME COMMUNICATIONS TECHNOLOGY INDIA PRIVATE LIMITED",
"FORMECA INDUSTRIES PRIVATE LIMITED",
"FORMERTRON ENGINEERING(INDIA) PRIVATE LIMITED",
"FORMICA LAMINATES INDIAPRIVATE LIMITED",
"FORMIDABLE MERCHANDISE PRIVATE LIMITED",
"FORMING INDIA PRIVATE LIMITED",
"FORMOCID PRIVATE LIMITED",
"FORMONIC TECHNOLOGIES PRIVATE LIMITED",
"FORMOPLASTIC CONTROLS PRIVATE LIMITED",
"FORMOSA SYNTHETICS PRIVATE LIMITED",
"FORMOST GRANITE EXPORTS PRIVATE LIMITED",
"FORMOSUS PHARMACEUTICALS",
"FORMPRO ENGINEERS PRIVATE LIMITED",
"FORMS & SURFACES WATER PROOFERS PRIVATE LIMITED",
"FORMS AND SURFACES INDIA PRIVATE LIMITED",
"FORMULA CORPORATE SOLUTIONS INDIA PRIVATE LIMITED",
"FORMULA LIGHTING (INDIA) PRIVATE LIMITED",
"FORMULA MANPOWER SOLUTIONS PRIVATE LIMITED",
"FORMULA NEXT EXPRESS PRIVATE LIMITED",
"FORMULA8 AUTOSERV PRIVATE LIMITED",
"FORMULAIC ENGINEERS PRIVATE LIMITED",
"FORMULATED POLYMERS LIMITED",
"FORMURA OFFSHORE SERVICES PRIVATE LIMITED",
"FORNNAX TECHNOLOGY PRIVATE LIMITED",
"FOROLY COMMERCIO PRIVATE LIMITED",
"FORRESTER RESEARCH INDIA PRIVATE LIMITED",
"FORRET INDIA PRIVATE LIMITED",
"FORSAN FOODS CONSUMER PRODUCTS INDIA PRIVATE LIMITED",
"FORSEE POWER INDIA PRIVATE LIMITED",
"FORSENIA ENGINEERING PRIVATE LIMITED",
"FORSKOLIN PHARMA PRIVATE LIMITED",
"FORSTAR FROZEN FOODS PRIVATE LIMITED",
"FORSTAR HARIOM AGRO FOODS PRIVATE LIMITED",
"FORSTAR INSTAFOODS PRIVATE LIMITED",
"FORSYS SOFTWARE INDIA PRIVATE LIMITED",
"FORT CAPITAL INVESTMENT ADVISORY PRIVATE LIMITED",
"FORT CHAIR PRIVATE LIMITED",
"FORT FINANCE LIMITED",
"FORT GATE HOTELS & RESORTS PRIVATE LIMITED",
"FORT GLOSTER INDUSTRIES LIMITED",
"FORT KNOX MERCHANDISING PRIVATE LIMITED",
"FORT KOCHI HOTELS PRIVATE LIMITED",
"FORT MARKETING PRIVATE LIMITED",
"FORT POINT AUTOMOTIVE CARS PRIVATE LIMITED",
"FORT RESORTS PVT LTD",
"FORT SHARE BROKING PRIVATE LIMITED",
"FORTAG HOSPITALITY PRIVATE LIMITED",
"FORTANIX TECHNOLOGIES INDIA PRIVATE LIMITED",
"FORTBELL GADGETS PRIVATE LIMITED",
"FORTCAPS HEALTHCARE LIMITED",
"FORTCITY MINES PRIVATE LIMITED",
"FORTE FOLIAGE PRIVATE LIMITED",
"FORTE FURNITURE PRODUCTS INDIA PRIVATE LIMITED",
"FORTE MANAGEMENT SERVICES PRIVATE LIMITED",
"FORTE TECH SOLUTIONS PRIVATE LIMITED",
"FORTEASIA REALTY PRIVATE LIMITED",
"FORTEK I T SOLUTIONS PRIVATE LIMITED",
"FORTEL HOTEL PRIVATE LIMITED",
"FORTEM INFRA INDIA PRIVATE LIMITED",
"FORTH NETTING MANUFACTURING PRIVATE LIMITED",
"FORTHRIGHT ASSETS PRIVATE LIMITED",
"FORTIFORI PLASTICS PRIVATE LIMITED",
"FORTIGO NETWORK LOGISTICS PRIVATE LIMITED",
"FORTIGO SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED",
"FORTIGO TRANSPORT AGENCY PRIVATE LIMITED",
"FORT-IN INFRA DEVELOPERS PRIVATE LIMITED",
"FORTINET TECHNOLOGIES INDIA PRIVATE LIMITED",
"FORTIO LOGISOLUTIONS PRIVATE LIMITED",
"FORTIRA SOFTWARE INDIA PRIVATE LIMITED",
"FORTIS C DOC HEALTHCARE LIMITED",
"FORTIS CABLES PRIVATE LIMITED",
"FORTIS CHEMICALS PRIVATE. LIMITED.",
"FORTIS EMERGENCY SERVICES LIMITED",
"FORTIS HEALTH MANAGEMENT LIMITED",
"FORTIS HEALTH MANAGEMENT NORTH LIMITED",
"FORTIS HEALTHCARE HOLDINGS PRIVATE LIMITED",
"FORTIS HEALTHCARE LIMITED",
"FORTIS HEART INSTITUTE",
"FORTIS HOSPITALS LIMITED",
"FORTIS HOSPOTEL LIMITED",
"FORTIS INFRA PROJECTS PRIVATE LIMITED",
"FORTIS MALAR HOSPITALS LIMITED",
"FORTITUDE ENVIRO PRIVATE LIMITED",
"FORTITUDE SECURITIES PRIVATE LIMITED",
"FORTITUDE STAINLESS PRIVATE LIMITED",
"FORTIUS FACILITIES PRIVATE LIMITED",
"FORTIUS INFOCOM PRIVATE LIMITED (OPC)",
"FORTIUS MACHINING SOLUTIONS PRIVATE LIMITED",
"FORTIUS MINE CHEM PRIVATE LIMITED",
"FORTIUS PROPERTY DEVELOPERS PRIVATE LIMITED",
"FORTIZEN MARKCOM SERVICES PRIVATE LIMITED",
"FORTLAND TRADING AND POLYPACKS PRIVATE LIMITED",
"FORTOFINO LIFESTYLE PRIVATE LIMITED",
"FORTPOINT AUTOMOTIVE CARS PRIVATE LIMITED",
"FORTPOINT AUTOMOTIVE MUMBAI PRIVATE LIMITED",
"FORTPOINT AUTOMOTIVE PVT LTD",
"FORTRAN CIRKIT ELECTRONIC PRIVATE LIMITED",
"FORTRAN STEEL PRIVATE LIMITED",
"FORTREA CLINICAL DEVELOPMENT PRIVATE LIMITED",
"FORTREA DEVELOPMENT INDIA PRIVATE LIMITED",
"FORTREA SCIENTIFIC PRIVATE LIMITED",
"FORTRESS CONSTRUCTIONS PRIVATE LIMITED",
"FORTRESS ENVIRA CLIMATE CHANGE TECHNOLOGY PRIVATE LIMITED",
"FORTRESS FINANCIAL SERVICES LIMITED",
"FORTRESS INFRACON LIMITED",
"FORTRESS WELFARE FOUNDATION",
"FORTSCHRITT HEALTHCARE LIMITED",
"FORTUM FINNSURYA ENERGY PRIVATE LIMITED",
"FORTUM INDIA PRIVATE LIMITED",
"FORTUNA BUILDING SYSTEMS PRIVATE LIMITED",
"FORTUNA CONSTRUCTIONS INDIA PRIVATE LIMITED",
"FORTUNA CONTROL AND AUTOMATIONS PRIVATE LIMITED",
"FORTUNA ENGINEERING PRIVATE LIMITED",
"FORTUNA IDENTITY PRIVATE LIMITED",
"FORTUNA IMPEX PRIVATE LIMITED",
"FORTUNA INDUSTRIES PRIVATE LIMITED",
"FORTUNA PUBLIC RELATIONS PRIVATE LIMITED",
"FORTUNA RETAIL PRIVATE LIMITED",
"FORTUNA SKILL MANAGEMENT PRIVATE LIMITED",
"FORTUNAPIX PRIVATE LIMITED",
"FORTUNATE AGRO SOLUTION PRIVATE LIMITED",
"FORTUNATE TECHNOLOGIES PRIVATE LIMITED",
"FORTUNE ABODES PRIVATE LIMITED",
"FORTUNE AGROCHEM PRIVATE LIMITED",
"FORTUNE AGROMART PRIVATE LIMITED",
"FORTUNE AIRFREIGHT SOLUTIONS PRIVATE LIMITED",
"FORTUNE ASSETS PVT.LTD",
"FORTUNE ASSOCIATES PRIVATE LIMITED",
"FORTUNE BATH AND INTERIORS PRIVATE LIMITED",
"FORTUNE BELL COMMODITIES PVT LTD",
"FORTUNE BIOSERVICES PRIVATE LIMITED",
"FORTUNE BISCUITS PRIVATE LIMITED",
"FORTUNE BROKING INTERMEDIARY PRIVATE LIMITED",
"FORTUNE BUILDERS PRIVATE LTD",
"FORTUNE BUTTERFLY CITY LIMITED",
"FORTUNE CAPITAL SERVICES PRIVATE LIMITED",
"FORTUNE CAPS & PAILS PRIVATE LIMITED",
"FORTUNE CARS PRIVATE LIMITED",
"FORTUNE CONTROLS PRIVATE LIMITED",
"FORTUNE DEVELOPCON PRIVATE LIMITED",
"FORTUNE DREAM-CON PRIVATE LIMITED",
"FORTUNE ELASTOMERS PRIVATE LIMITED",
"FORTUNE EMPIRE GLOBAL PRIVATE LIMITED",
"FORTUNE ESTATE DEVELOPERS PRIVATE LIMITED",
"FORTUNE EXTRUSION PRIVATE LIMITED",
"FORTUNE FACILITY SERVICES PRIVATE LIMITED",
"FORTUNE FINSEC PRIVATE LIMITED",
"FORTUNE FISCAL LIMITED",
"FORTUNE FIVE HYDEL PROJECTS PRIVATE LIMITED",
"FORTUNE FOAM PRIVATE LIMITED",
"FORTUNE FOODS LIMITED",
"FORTUNE GILTS PRIVATE LIMITED",
"FORTUNE GLOBAL TRADE PRIVATE LIMITED",
"FORTUNE GOURMET SPECIALITIES PRIVATE LIMITED",
"FORTUNE INFO SOLUTIONS PRIVATE LIMITED",
"FORTUNE INFRA DEVELOPERS PRIVATE LIMITED",
"FORTUNE INFRA SERVICES PRIVATE LIMITED",
"FORTUNE INFRACREATORS PRIVATE LIMITED",
"FORTUNE INFRAPROPERTIES PRIVATE LIMITED",
"FORTUNE INFRATRADE PRIVATE LIMITED",
"FORTUNE INTERCONTINENTAL PRIVATE LIMITED",
"FORTUNE INVESTMENT CONSULTANTS PRIVATE LIMITED",
"FORTUNE ISPAT PRIVATE LIMITED",
"FORTUNE KENCES HOTEL",
"FORTUNE LANDMARK AHMEDABAD WEST INN LIMITED",
"FORTUNE MALL PRIVATE LIMITED",
"FORTUNE MARKETING PRIVATE LIMITED",
"FORTUNE MEDCARE HOSPITALS PRIVATE LIMITED",
"FORTUNE METALIKS LIMITED.",
"FORTUNE METALS LIMITED",
"FORTUNE MONEY CONTROL PRIVATE LIMITED",
"FORTUNE MOTORS",
"FORTUNE MOTORS PRIVATE LIMITED",
"FORTUNE MULTI SPECIALITY HOSPITAL PRIVATE LIMITED",
"FORTUNE MULTITECH PRIVATE LIMITED",
"FORTUNE PAINTS PRIVATE LIMITED",
"FORTUNE PANEL SYSTEMS (INDIA) PRIVATE LIMITED",
"FORTUNE PARK HOTELS LIMITED",
"FORTUNE PARK HOUSING PROJECTS PRIVATE LIMITED",
"FORTUNE PARK LAND INN AND SUITES PRIVATE LIMITED",
"FORTUNE PARK RESIDENCY PRIVATE LIMITED",
"FORTUNE PETROCHEM PRIVATE LIMITED",
"FORTUNE PHARMACEUTICALS INDIA PRIVATE LIMITED",
"FORTUNE PHARMACEUTICALS PRIVATE LIMITED",
"FORTUNE PLUS MARKETING SOLUTIONS PRIVATE LIMITED",
"FORTUNE POLYTECH PRIVATE LIMITED",
"FORTUNE PRINTS 'N' BIND PRIVATE LIMITED",
"FORTUNE PROCURATORS INDIA PRIVATE LIMITED",
"FORTUNE RECYCLYING PRIVATE LIMITED",
"FORTUNE RESOURCES & PROPERTIES LLP",
"FORTUNE RICE LIMITED",
"FORTUNE RICELAND PRIVATE LIMITED",
"FORTUNE SALES PRIVATE LIMITED",
"FORTUNE SEA CARRIERS PRIVATE LIMITED",
"FORTUNE SECURITY PRIVATE LIMITED",
"FORTUNE SELECT GLOBAL",
"FORTUNE SHIPPING SERVICES PRIVATE LIMITED",
"FORTUNE SMART LIFESTYLE PRIVATE LIMITED",
"FORTUNE SPIRIT LIMITED",
"FORTUNE STONES LIMITED",
"FORTUNE SUPPLY CHAIN SOLUTION PRIVATE LIMITED",
"FORTUNE SYNFAB PRIVATE LIMITED",
"FORTUNE SYNTEX PRIVATE LIMITED",
"FORTUNE TECHNOBUILD PRIVATE LIMITED",
"FORTUNE TECHNOCOMPS PVT LTD",
"FORTUNE TIRE TECH LIMITED",
"FORTUNE TRADE HOUSE PRIVATE LIMITED",
"FORTUNE TRANSLOGIC PRIVATE LIMITED",
"FORTUNE WEALTH MANAGEMENT COMPANY INDIA PRIVATE LIMITED",
"FORTUNE WIRE PRIVATE LIMITED",
"FORTUNEA INFRASTRUCTURE LLP",
"FORTUNEARRT LED LIGHTING PRIVATE LIMITED",
"FORTUNEARRT WIRES & CABLES PRIVATE LIMITED",
"FORTUNEAVERE PHARMACEUTICALS PRIVATE LIMITED",
"FORTUNEPLUS IT NETWORKS PRIVATE LIMITED",
"FORTUNE'S SPARSH HEALTHCARE PRIVATE LIMITED",
"FORTUNESOFT IT INNOVATIONS PRIVATE LIMITED",
"FORTUNEXT ENTERPRISES PRIVATE LIMITED",
"FORTWISE CAPITAL PRIVATE LIMITED",
"FORTY TWO AND MORE DIGITAL SOLUTIONS LLP",
"FORTY WINKS MATTRESS INDUSTRIES INDIA PRIVATE LIMITED",
"FORTYTWO42 TECHNOLOGY INNOVATIONS PRIVATE LIMITED",
"FORUM BUSINESS RESEARCH PRIVATE LIMITED",
"FORUM COSMETICS PRIVATE LIMITED",
"FORUM FOR HEALTH SYSTEMS DESIGN AND TRANSFORMATION",
"FORUM HOMES PRIVATE LIMITED",
"FORUM I AVIATION PRIVATE LIMITED",
"FORUM INDIA LEARNING SOLUTIONS PRIVATE LIMITED",
"FORUM MALL MANAGEMENT SERVICES PRIVATE LIMITED",
"FORUM PROJECT HOLDINGS PRIVATE LIMITED",
"FORUM PROJECTS PRIVATE LIMITED",
"FORUM RIVIERA CONSTRUCTIONS PRIVATE LIMITED",
"FORUM SHOPPING MALL PRIVATE LIMITED",
"FORUS ELECTRIC PRIVATE LIMITED",
"FORUS HEALTH PRIVATE LIMITED",
"FORVOL INTERNATIONAL SERVICES LIMITED",
"FORWARD CROP PROTECTION PRIVATE LIMITED",
"FORWARD MANUFACTURING COMPANY PRIVATE LIMITED",
"FORWARD PRECISION ENGINEERS PVT LTD",
"FORWAY PIPES PRIVATE LIMITED",
"FORWAY SHIPPING AND LOGISTICS PRIVATE LIMITED",
"FORWEST ESTATES PRIVATE LIMITED",
"FORXAR INDUSTRIES PRIVATE LIMITED",
"FORYOUR RESQUE PRIVATE LIMITED",
"FORYSTA VENTURES LIMITED",
"FORZA CASTING PRIVATE LIMITED",
"FORZA ENTERPRISES PRIVATE LIMITED",
"FORZA INDUSTRIES PRIVATE LIMITED",
"FORZA INTERIORS PRIVATE LIMITED",
"FORZA LOGISTICS TECHLABS PRIVATE LIMITED",
"FORZA MEDI PRIVATE.LIMITED",
"FORZIA TECH PRIVATE LIMITED",
"FORZZA REALTORS PRIVATE LIMITED",
"FOS DESIGNS & SERVICES PRIVATE LIMITED",
"FOSBEL INDIA PRIVATE LIMITED",
"FOSCHIA RESORTS PRIVATE LIMITED",
"FOSECO INDIA LIMITED",
"FOSERRA PHOTOVOLTAIC PRIVATE LIMITED",
"FOSHAN INFRASTRUCTURE PRIVATE LIMITED",
"FOSHAN TEEHOO H INOX PRIVATE LIMITED",
"FOSI FEEL DESIGNS PRIVATE LIMITED",
"FOSMA MARITIME INSTITUTE AND RESEARCH ORGANISATION",
"FOSROC CHEMICALS (INDIA) PRIVATE LIMITED",
"FOSS INDIA PRIVATE LIMITED",
"FOSS INFOTECH PRIVATE LIMITED",
"FOSSIL BUSINESS SOLUTION PRIVATE LIMITED",
"FOSSIL ENERGY(INDIA) PRIVATE LIMITED",
"FOSSIL GLOBAL SERVICES INDIA LLP",
"FOSSIL INDIA PRIVATE LIMITED",
"FOSSIL LIQUID AND MINERALS EXIM PRIVATE LIMITED",
"FOSSIL LOGISTICS PRIVATE LIMITED",
"FOSSILSHALE EMBEDDED TECHNOLOGIES PRIVATE LIMITED",
"FOSTER DEVELOPMENT SCHOOL OF MANAGEMENT",
"FOSTER GEOTECH PRIVATE LIMITED",
"FOSTER HEALTHCARE PRIVATE LIMITED",
"FOSTER TOOLS (INDIA) PRIVATE LIMITED",
"FOSTERING LINUX SERVICES PRIVATE LIMITED",
"FOSTERTECHS PRIVATE LIMITED",
"FOSTIIMA INTEGRATED LEARNING RESOURCES PRIVATE LIMITED",
"FOSUN MANAGEMENT (INDIA) PRIVATE LIMITED",
"FOTIS LIFESCIENCES PRIVATE LIMITED",
"FOTO BEST PRIVATE LIMITED",
"FOTO CENTRE TRADING PRIVATE LIMITED",
"FOTO FLUX SYSTEMS PRIVATE LIMITED",
"FOTOFAST PUNE PRIVATE LIMITED",
"FOTOFLASH DIGITAL LAB PRIVATE LIMITED",
"FOTOGRAFIK ENTERPRISES PRIVATE LIMITED",
"FOTOSET TRADING PRIVATE LIMITED",
"FOTOTENTIA DIAGNOSTICS PRIVATE LIMITED",
"FOUNDATION ADVERTISING SERVICE PRIVATE LIMITED",
"FOUNDATION ENGINEERING COMPANY",
"FOUNDATION FINVEST LEASE LIMITED",
"FOUNDATION FOR CSR @ REDINGTON",
"FOUNDATION FOR DEVELOPMENT OF RURAL VALUE CHAINS",
"FOUNDATION FOR ECOLOGICAL SECURITY",
"FOUNDATION FOR EDEQUITY",
"FOUNDATION FOR INDEPENDENT JOURNALISM",
"FOUNDATION FOR INNOVATION & RESEARCH IN SCIENCE & TECHNOLOGY",
"FOUNDATION FOR INNOVATIVE NEW DIAGNOSTIC S (FIND)",
"FOUNDATION FOR INNOVATIVE NEW DIAGNOSTICS INDIA",
"FOUNDATION FOR INTEGRATED SUPPORT AND SOLUTION",
"FOUNDATION FOR ORGANISATION RESEARCH AND EDUCATION",
"FOUNDATION FOR PROGRESSIVE NARRATIVE",
"FOUNDATION FOR PROMOTION OF SPORTS AND GAMES",
"FOUNDATION FOR REPRODUCTIVE HEALTH SERVICES INDIA",
"FOUNDATION FOR RURAL ENTREPRENEURSHIP DEVELOPMENT",
"FOUNDATION FOR VITAL HEALING",
"FOUNDATION FUTURISTIC TECHNOLOGIES PVT LTD",
"FOUNDATION ONE INFRASTRUCTURES PRIVATE LIMITED",
"FOUNDATION TERRE DES HOMMES",
"FOUNDEVER BUSINESS SERVICES OF INDIA PRIVATE LIMITED",
"FOUNDEVER CRM INDIA PRIVATE LIMITED",
"FOUNDFUL FOREX PRIVATE LIMITED",
"FOUNDING YEARS EDTECH PRIVATE LIMITED",
"FOUNDINGMINDS SOFTWARE PRIVATE LIMITED",
"FOUNDRY ENTERPRISES PRIVATE LIMITED",
"FOUNDRY WELLNESS PRIVATE LIMITED",
"FOUNDTECH INTERNATIONAL IMPEX PRIVATE LIMITED",
"FOUNTAIN ENTERTAINMENT PRIVATE LIMITED",
"FOUNTAIN HEAD PVT LTD",
"FOUNTAIN HILL SYSTEMS PRIVATE LIMITED",
"FOUNTAIN HOSPITALITY PRIVATE LIMITED",
"FOUNTAIN PIXEL ANIMATIONS PRIVATE LIMITED",
"FOUNTAIN WIRE INDUSTRIES PVT LTD",
"FOUNTAIN9 PRIVATE LIMITED",
"FOUNTAINHEAD AGRO FARMS PRIVATE LIMITED",
"FOUNTAINHEAD ENTERTAINMENT PRIVATE LIMITED",
"FOUNTAINHEAD FOODS PRIVATE LIMITED",
"FOUNTAINHEAD INTEGRATED COMMUNICATION PRIVATE LIMITED",
"FOUNTAINHEAD MOTELS PRIVATE LIMITED",
"FOUNTAINHEAD SCHOOL",
"FOUNTAINHEAD SOLUTIONS PRIVATE LIMITED",
"FOUNTANE MAKERSPACE PRIVATE LIMITED",
"FOUNTIL LIFE SCIENCES P LIMITED",
"FOUNTLAB SOLUTIONS PRIVATE LIMITED",
"FOUR ACES FASHION HOUSE PRIVATE LIMITED",
"FOUR ARMED RESIDENCY PRIVATE LIMITED",
"FOUR AXES BUSINESS SOLUTIONS PRIVATE LIMITED",
"FOUR BROS. MOVERS & PACKERS PRIVATE LIMITED",
"FOUR BROTHERS APPARELS PRIVATE LIMITED",
"FOUR BROWN FOLK DECOR PRIVATE LIMITED",
"FOUR C PLUS INTERNET COMPANY LIMITED",
"FOUR CEESS DIAMONDS PRIVATE LIMITED",
"FOUR CIRCLE INVESTMENTS PRIVATE LIMITED",
"FOUR CORNERS ISPAT PRIVATE LIMITED",
"FOUR CORNERS MULTIMEDIA PRIVATE LIMITED",
"FOUR DIMENSIONS RETAIL DESIGN INDIA PRIVATE LIMITED",
"FOUR DIMENSIONS SECURITIES INDIA LIMITED",
"FOUR EF RENEWABLES PRIVATE LIMITED",
"FOUR ESS STEEL PRODUCTS PRIVATE LIMITED",
"FOUR HEALTHCARE (INDIA) PRIVATE LIMITED",
"FOUR ITS PRIVATE LIMITED",
"FOUR KEYS CREATIVE DEVELOPMENT PRIVATE LIMITED",
"FOUR LEAF CLOVER AGRO PRIVATE LIMITED",
"FOUR M PROPACK PRIVATE LIMITED",
"FOUR NINE MEDIA PRIVATE LIMITED",
"FOUR P INTERNATIONAL PRIVATE LIMITED",
"FOUR PILLARS INFOTECH INDIA PRIVATE LIMITED",
"FOUR PLUS ADVERTISING PRIVATE LIMITED",
"FOUR POINTS BY SHERATON",
"FOUR S BUSINESS ASSOCIATE PRIVATE LIMITED",
"FOUR SEASONS AUTOMOBILES PRIVATE LIMITED",
"FOUR SEASONS DESIGNER PRIVATE LIMITED",
"FOUR SEASONS INDIA HOTEL MANAGEMENT COMPANY PRIVATE LIMITED",
"FOUR SEASONS INTERIORS & DEVELOPERS PRIVATE LIMITED",
"FOUR SEASONS PHARMACEUTICALS PRIVATE LIMITED",
"FOUR SEASONS SALES PRIVATE LIMITED",
"FOUR SEASONS WINES LIMITED",
"FOUR SIG COY NCC MUMBAI",
"FOUR SIGHT OPTICIANS PRIVATE LIMITED",
"FOUR SKILLS MANPOWER CONTRACTORS PRIVATE LIMITED",
"FOUR SOLAR ENERGY SYSTEMS PRIVATE LIMITED",
"FOUR SQUARE MULTI LOGISTICS PRIVATE LIMITED",
"FOUR SQUARE SECURE SERVICES PRIVATE LIMITED",
"FOUR SQUARE SHIPPING & LOGISTICS PRIVATE LIMITED",
"FOUR STAR INTERNATIONAL LIMITED",
"FOUR STAR REALTY PRIVATE LIMITED",
"FOUR STONES HOSPITALITY SERVICES PRIVATE LIMITED",
"FOUR VEDAS HOTEL AND RESORTS PRIVATE LIMITED",
"FOUR W TECHNOLOGIES PRIVATE LIMITED",
"FOUR WHEEL GROUP INDIA PRIVATE LIMITED",
"FOUR WINGS INTERNATIONAL TRAVELS PRIVATE LIMITED",
"FOUR X 4 CONSULTING PRIVATE LIMITED",
"FOUR40 HEALTHCARE PRIVATE LIMITED",
"FOURBRO PHARMA DISTRIBUTOR PRIVATE LIMITED",
"FOURBYFOUR EXPERIENCES PRIVATE LIMITED",
"FOURCELL ENERGY PRIVATE LIMITED",
"FOUR-D MANAGEMENT CONSULTING PRIVATE LIMITED",
"FOUREN TECHNOLOGIES PRIVATE LIMITED",
"FOURESS INSURANCE BROKING SERVICES PRIVATE LIMITED",
"FOURFRONT PRIVATE LIMITED",
"FOURKITES INDIA PRIVATE LIMITED",
"FOURMAX LIMITED",
"FOURMENS TRADING PRIVATE LIMITED",
"FOURNIKS MULTIFUNCTIONAL ENTERPRIZES PRIVATE LIMITED",
"FOURNINE CLOUD SOLUTIONS PRIVATE LIMITED",
"FOURP ENERGIES PRIVATE LIMITED",
"FOURPLUS ADVERTISING PRIVATE LIMITED",
"FOURQ BUSINESS SUPPORT SERVICES INDIA PRIVATE LIMITED",
"FOURQUADRANTS MATRIX PRIVATE LIMITED",
"FOURRTS INDIA LABORATORIES PRIVATE LIMITED",
"FOURSEASONS MARKETING AND PROJECTS LIMITED",
"FOURSIGHT REALTY INDIA PRIVATE LIMITED",
"FOURSIX AUTO PRIVATE LIMITED",
"FOURSOME FOODS PRIVATE LIMITED",
"FOURTECKH ENVIRO (INDIA) PRIVATE LIMITED",
"FOURTEENDREAMS HOLDING INDIA PRIVATE LIMITED",
"FOURTEK IT SOLUTIONS PRIVATE LIMITED",
"FOURTEK SYSTEMS PRIVATE LIMITED",
"FOURTH APPLE FILMS PRIVATE LIMITED",
"FOURTH DIMENSION ARCHITECTS PRIVATE LIMITED",
"FOURTH DIMENSION INDIA PRIVATE LIMITED",
"FOURTH DIMENSION INFRA & POWER LIMITED",
"FOURTH DIMENSION MEDIA SOLUTIONS PRIVATE LIMITED",
"FOURTH DIMENSION SOFTWARE SYSTEMS INDIA PRIVATE LIMITED",
"FOURTH DIMENSION TECHNOLOGIES PRIVATE LIMITED",
"FOURTH ESTATE COMMUNICATIONS PRIVATE LIMITED",
"FOURTH ESTATE LIMITED",
"FOURTH FRONTIER TECHNOLOGIES PRIVATE LIMITED",
"FOURTH PARTNER ENERGY PRIVATE LIMITED",
"FOURTH QUADRANT LABS PRIVATE LIMITED",
"FOURTH SECOND PRIVATE LIMITED",
"FOURTH SIGNAL (INDIA) PRIVATE LIMITED",
"FOURTHGEN LIFESTYLES PRIVATE LIMITED",
"FOURTHPOINTER SERVICES PRIVATE LIMITED",
"FOURTREK HEALTHCARE PRIVATE LIMITED",
"FOURTUNE COMPUTERS TECHNOLOGIES PRIVATE LIMITED",
"FOURTY SEVEN BILLION INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"FOURUS RASAYAN PRIVATE LIMITED",
"FOURUS SALES SOLUTIONS PRIVATE LIMITED",
"FOURVOLT SOLAR PRIVATE LIMITED",
"FOURWAYS MOVERS PVT LTD",
"FOURWAYS TRAVELS PRIVATE LIMITED",
"FOURWAYZ DISTRIBUTORS PRIVATE LIMITED",
"FOUZDAR CARS PRIVATE LIMITED",
"FOV FASHION PRIVATE LIMITED",
"FOVERA ORTHODESIGN PRIVATE LIMITED",
"FOWLER WESTRUP INDIA PRIVATE LIMITED",
"FOX EXPORTS PRIVATE LIMITED",
"FOX EXPRESS PRIVATE LIMITED",
"FOX IT SOLUTIONS PRIVATE LIMITED",
"FOX MANDAL SERVICES PRIVATE LIMITED",
"FOX PASS VENTURES LLP",
"FOX PETROSPECIALITIES PRIVATE LIMITED",
"FOX SOLUTIONS PRIVATE LIMITED",
"FOX STAR STUDIOS PRIVATE LIMITED",
"FOX TRADELINKS PRIVATE LIMITED",
"FOX&MANDAL",
"FOXBASE TECHNOLOGIES PRIVATE LIMITED",
"FOXBERRY TECHNOLOGIES PRIVATE LIMITED",
"FOXBOX RETAIL PRIVATE LIMITED",
"FOXCELL COMMUNICATION PRIVATE LIMITED",
"FOXCON ELEMENTS PRIVATE LIMITED",
"FOXCONN HON HAI TECHNOLOGY INDIA MEGA DEVELOPMENT PRIVATE LIMITED",
"FOXCONN TECHNOLOGY INDIA PRIVATE LD",
"FOXFIRE EVENTS & ACTIVATIONS PRIVATE LIMITED",
"FOXFIRE TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"FOXFIRE TECHNOLOGIES INDIA LIMITED",
"FOXGLOVE BUSINESS SERVICES PRIVATE LIMITED",
"FOXGLOVE CONNECT PRIVATE LIMITED",
"FOXGLOVES MANPOWER SERVICES PRIVATE LIMITED",
"FOXHILL CYLINDERS PRIVATE LIMITED",
"FOXLINK INDIA ELECTRIC PRIVATE LIMITED",
"FOXLINK TECHNICAL INDIA PRIVATE LIMITED",
"FOXSENSE INNOVATIONS PRIVATE LIMITED",
"FOXSKY ELECTRONICS INDIA PRIVATE LIMITED",
"FOXTEL INFRA PRIVATE LIMITED",
"FOXTEQ SERVICES INDIA PRIVATE LIMITED",
"FOXTROT BEVERAGES PRIVATE LIMITED",
"FOXTROT INTERACTIVE PRIVATE LIMITED",
"FOXTROT OUTSOURCING & TECHNOLOGIES PRIVATE LIMITED",
"FOXTURF INDUSTRIES PRIVATE LIMITED",
"FOXX LIFE SCIENCES PRIVATE LIMITED",
"FOXYMORON DIGITAL MARKETING PRIVATE LIMITED",
"FOXYMORON MEDIA SOLUTIONS PRIVATE LIMITED",
"FOYER MINES AND MINERALS PRIVATE LIMITED",
"FOYER TECHNOLOGY PRIVATE LIMITED",
"FP INDIA PROJECT MANAGEMENT CONSULTANCY SERVICES PRIVATE LIMITED",
"FP SEATING SYSTEMS PRIVATE LIMITED",
"FP TECH SCIENCE PRIVATE LIMITED",
"FPA EDUTECH PRIVATE LIMITED",
"FPC UNIPRO PRIVATE LIMITED",
"FPEL MAHA 2 PRIVATE LIMITED",
"FPEL TRINITY ENERGY PRIVATE LIMITED",
"FPEL WRPL MH PRIVATE LIMITED",
"FPG HEALTHCARE PRIVATE LIMITED",
"FPI AUTO PARTS INDIA PRIVATE LIMITED",
"FPI INDIA PRIVATE LIMITED",
"FPL AUTOMOBILES PRIVATE LIMITED",
"FPL VEHICLES PRIVATE LIMITED",
"FPP PRIVATE LIMITED",
"FPS INNOVATION LABS PRIVATE LIMITED",
"FPS LOGISTICS PRIVATE LIMITED",
"FPT INDIA PRIVATE LIMITED",
"FPT SOFTWARE",
"FQC CERTIFICATION PRIVATE LIMITED",
"FR AGNEL MULTIPURPOSE SCHOOL AND JUNIOR COLLEGE",
"FR AGNEL SCHOOL DELHI",
"FR ANGEL VIDYANKUR SCHOOL SAINIKWAD VADGAON SHERI",
"FR C RODRIGUES INSTITUTE OF TECHNOLOGY",
"FR CHEM PRIVATE LIMITED",
"FR CONCEICAO RODRIGUES COLLEGE OF ENGINEERING",
"FR JOSEPH PRE PRIMARY SCHOOL",
"FR MULLER MEDICAL COLLEGE MANGALORE",
"FR SOLUTIONS PRIVATE LIMITED",
"FRACKTAL WORKS PRIVATE LIMITED",
"FRACTAL ANALYTICS PRIVATE LIMITED",
"FRACTAL ENTERPRISES LLP",
"FRACTAL ESTATES PRIVATE LIMITED",
"FRACTAL INDUSTRIES PRIVATE LIMITED",
"FRACTAL INK DESIGN STUDIO PRIVATE LIMITED",
"FRACTAL PICTURE PRIVATE LIMITED",
"FRACTALIO DATA PRIVATE LIMITED",
"FRACTION CHEMICALS PRIVATE LIMITED",
"FRACTION TECHNOLOGY PRIVATE LIMITED",
"FRAGMA DATA SYSTEMS PRIVATE LIMITED",
"FRAGMENTS AND FLAKES CCD PRIVATE LIMITED",
"FRAGOMATRIX FRAGRANCE AND FLAVORS PRIVATE LIMITED",
"FRAGOMATRIX GLOBAL PRIVATE LIMITED",
"FRAGOMEN IMMIGRATION SERVICES INDIA PRIVATE LIMITED",
"FRAGRANCE AND AROMA (EASTLAND) PRIVATE LIMITED",
"FRAGRANCE DREAM HOMES PRIVATE LIMITED",
"FRAGRANCE FOODS PRIVATE LIMITED",
"FRAGRANCE SHOP PRIVATE LIMITED",
"FRAKTAL IT INNOVATION PRIVATE LIMITED",
"FRAMAL TECHNOLOGY LLP",
"FRAME COLLEGE FOR GIRLS",
"FRAME INTERNATIONAL SCHOOL",
"FRAMEBOXX ANIMATION AND VISUAL EFFECTS PRIVATE LIMITED",
"FRAMED REVER PRIVATE LIMITED",
"FRAMEROCK GYP PROFILE INDIA PRIVATE LIMITED",
"FRAMES BAY PRIVATE LIMITED",
"FRAMES PROCESS & ENERGY SYSTEMS INDIA PRIVATE LIMITED",
"FRAMES PRODUCTION COMPANY PRIVATE LIMITED",
"FRAMES TWENTYFOUR COMMUNICATIONS PRIVATE LIMITED",
"FRAMESBUY COMMERCE PRIVATE LIMITED",
"FRAMESOOH ADVERTISING PRIVATE LIMITED",
"FRAMESTORE INDIA PRIVATE LIMITED",
"FRAMEWORK CONSULTANTS PRIVATE LIMITED",
"FRAMEWORKPE INVESTMENT DATA MANAGEMENT SERVICES PRIVATE LIMITED",
"FRAMING INDIA INFRASTRUCTURE PRIVATE LIMITED",
"FRAMSIKT TECHNOLOGIES PRIVATE LIMITED",
"FRANCE TELECOM DEVELOPMENT INTERNATIONAL",
"FRANCH EXPRESS COURIER PRIVATE LIMITED",
"FRANCHISE INDIA HOLDING LIMITED",
"FRANCHISEINDIA.COM PRIVATE LIMITED",
"FRANCIS KLEIN & CO PRIVATE LIMITED",
"FRANCIS KLEIN AND COMPANY BOMBAY PRIVATE LIMITED",
"FRANCIS LE SLIE AND CO PRIVATE LIMITED",
"FRANCIS REMEDIES (INDIA) PRIVATE LIMITED",
"FRANCIS SHIPPING AGENCY PRIVATE LIMITED",
"FRANCIS WACZIARG FASHION PRIVATE LIMITED",
"FRANCIS WACZIARG PRIVATE LIMITED",
"FRANCIS WACZIARS AGENCIES PRIVATE LIMITED",
"FRANCIS XAVIER ENGINEERING COLLEGE",
"FRANCISCAN SOLUTIONS PRIVATE LIMITED",
"FRANCISKOTTACKAL EXIM PRIVATE LIMITED",
"FRANCIUM TECHNOLOGIES PRIVATE LIMITED",
"FRANCO INDIAN PHARMACEUTICALS PRIVATE LIMITED",
"FRANCO INDIAN REMEDIES PRIVATE LIMITED",
"FRANCO INDIAN RESEARCH PRIVATE LIMITED",
"FRANCO LEONE LIMITED",
"FRANCOIS COMPRESSORS INDIA PRIVATE LIMITED",
"FRANCONNECT INDIA SOFTWARE PRIVATE LIMITED",
"FRANCORP ADVISORS PRIVATE LIMITED",
"FRANGLOBAL PRIVATE LIMITED",
"FRANGO LIFE SCIENCE PRIVATE LIMITED",
"FRANK ALKANES INDIA PRIVATE LIMITED",
"FRANK BUILDING SOLUTIONS PRIVATE LIMITED",
"FRANK COPIER PRIVATE LIMITED",
"FRANK DELA PVT LTD",
"FRANK EDUCATIONAL AIDS PRIVATE LIMITED",
"FRANK LEISURE AND EVENTS PRIVATE LIMITED",
"FRANK LIFECARE PRIVATE LIMITED",
"FRANK LLOYD TECH MANAGEMENT SERVICES LIMITED",
"FRANK SUPER SPECIALITY HOSPITAL",
"FRANKE FABER INDIA PRIVATE LIMITED",
"FRANKEL HEALTHCARE PRIVATE LIMITED",
"FRANKFINN AVIATION SERVICES PRIVATE LIMITED",
"FRANKFINN INSTITUTE OF AIR HOSTESS TRAINING",
"FRANKFURT PHARMACEUTICALS PRIVATE LIMITED",
"FRANKLIN ELECTRIC INDIA PRIVATE LIMITED",
"FRANKLIN FUELING SYSTEMS INDIA PRIVATE LIMITED",
"FRANKLIN HEALTHCARE PRIVATE LIMITED",
"FRANKLIN INDUSTRIES LIMITED",
"FRANKLIN LABORATORIES INDIA PVT LTD",
"FRANKLIN LEASING AND FINANCE LIMITED",
"FRANKLIN RESOURCES INC.",
"FRANKLIN TEMPLETON ASSET MANAGEMENT INDIA PRIVATE LIMITED",
"FRANKLIN TEMPLETON INTERNATIONAL SERIVCES INDIA PRIVATE LIMITED",
"FRANKLIN TEMPLETON SERVICES (INDIA) PRIVATE LIMITED",
"FRANKLIN TEMPLETON TRUSTEE SERVICES PRIVATE LIMITED",
"FRANKLINCOVEY TRAINING AND CONSULTING LLP",
"FRANKNIGHTS SERVICES PRIVATE LIMITED",
"FRANKOJULIA CREATIONS PRIVATE LIMITED",
"FRANKONIA INDIA EMC SOLUTIONS PRIVATE LIMITED",
"FRANKWINN FORMULATIONS LIMITED",
"FRANKY SPIRITS PRIVATE LIMITED",
"FRANKZON INDIA SERVICES PRIVATE LIMITED",
"FRANS GLOBAL INFOTECH PRIVATE LIMITED",
"FRANSALIAN SCHOOL OF EXCELLENCE",
"FRANSTEK BELTS PRIVATE LIMITED",
"FRANWORK BRANDS PRIVATE LIMITED",
"FRAPKS SANITARY WARE PRIVATE LIMITED",
"FRAPPE TECHNOLOGIES PRIVATE LIMITED",
"FRARES VENTURE PRIVATE LIMITED",
"FRASCOLD INDIA PRIVATE LIMITED",
"FRASER &COMPANY LIMITED",
"FRASER TECHNO CIRCUITS LIMITED",
"FRATELLI SINGH PRIVATE LIMITED",
"FRATELLI WINES PRIVATE LIMITED",
"FRATERNAL INVESTMENTS PRIVATE LIMITED",
"FRAUSCHER RAIL SIGNALLING SYSTEMS INDIA PRIVATE LIMITED",
"FRAUSCHER SENSOR TECHNOLOGY INDIA PRIVATE LIMITED",
"FRAVASHI INTERNATIONAL ACADEMY",
"FRAZER FOODS INDIA PRIVATE LIMITED",
"FRAZER GOODS & SUPPLY PVT LTD",
"FRAZIL WATER PRIVATE LIMITED",
"FREAKEAT FOODS (OPC) PRIVATE LIMITED",
"FREAKIEE FASHIONS INDIA PRIVATE LIMITED",
"FRECH INDIA MACHINERY PRIVATE LIMITED",
"FREDDIE MAC",
"FREDDO AGROTECH PRIVATE LIMITED",
"FREDDY FOODS PRIVATE LIMITED",
"FREDUN HEALTHCARE PRIVATE LIMITED",
"FREDUN PHARMACEUTICALS LIMITED",
"FREDYSONS AND COMPANY PRIVATE LIMITED",
"FREE INDIA ASSURANCE SERVICES LIMITED",
"FREE POWER TECHNOLOGY PRIVATE LIMITED",
"FREE PRESS HOUSE",
"FREE PRESS HOUSE PRIVATE LIMITED",
"FREE SCALE SEMICONDUCTOR INDIA PRIVATE LIMITED",
"FREE SPIRITS GREEN LABS PRIVATE LIMITED",
"FREEBALANCE SOFTWARE SOLUTIONS INDIA PRIVATE LIMITED",
"FREEBIE SOLUTIONS PRIVATE LIMITED",
"FREECHARGE PAYMENT TECHNOLOGIES PRIVATE LIMITED",
"FREEDA APARTMENTS PRIVATE LIMITED",
"FREEDA HOME MAKERS PRIVATE LIMITED",
"FREEDOM AIR SERVICES PRIVATE LIMITED",
"FREEDOM CERAMIC PRIVATE LIMITED",
"FREEDOM FOOTWEAR PRIVATE LIMITED",
"FREEDOM FROM DIABETES PRIVATE LIMITED",
"FREEDOM FROM DIABETES RESEARCH FOUNDATION",
"FREEDOM HOLIDAYS AND LEISURE TRAVEL PRIVATE LIMITED",
"FREEDOM INDUSTRIES LTD",
"FREEDOM INFRADEVELOPERS PRIVATE LIMITED",
"FREEDOM OPHTHALMIC DEVICES PRIVATE LIMITED",
"FREEDOM OPTHALMIC PRIVATE LIMITED",
"FREEDOM PLAST PRIVATE LIMITED",
"FREEDOM RETAIL PRIVATE LIMITED",
"FREEDOMPOINT EXPRESSWAY PRIVATE LIMITED",
"FREEFLOW CREATIVE SERVICES INDIA PRIVATE LIMITED",
"FREEGO BIKES PRIVATE LIMITED",
"FREEION ENGINEERING PRIVATE LIMITED",
"FREELANCE FISH MEAL AND OIL PRIVATE LIMITED",
"FREELANCER ONLINE INDIA PRIVATE LIMITED",
"FREEMAN I.T SERVICES PRIVATE LIMITED",
"FREEMANS MEASURES PRIVATE LIMITED",
"FREEMEDIA INTERACTIVE PRIVATE LIMITED",
"FREEPORT-MCMORAN COPPER & GOLD INC.",
"FREESET BAGS & APPAREL PRIVATE LIMITED",
"FREESOCIETY FASHION PRIVATE LIMITED",
"FREESTONE INFOTECH PRIVATE LIMITED",
"FREETIME HOSPITALITY INDIA PRIVATE LIMITED",
"FREEWAY EXPORTS INDIA PRIVATE LIMITED",
"FREEWILL INFRASTRUCTURES PRIVATE LIMITED",
"FREEWILL SPORTS PRIVATE LIMITED",
"FREEZE DRYING SYSTEMS PRIVATE LIMITED",
"FREEZE ENGINEERING INDUSTRIES PVT LTD",
"FREEZE EXIM",
"FREEZE INDIA MANUFACTURING PRIVATE LIMITED",
"FREEZECO PRIVATE LIMITED",
"FREEZEEX COLD STORAGE & WAREHOUSING PRIVATE LIMITED",
"FREEZEKING INDUSTRIES PRIVATE LIMITED",
"FREEZEOTECH AIRCONDITIONING PRIVATE LIMITED",
"FREEZTECH LOGISTICS PRIVATE LIMITED",
"FREEZWALL INDIA AGRO FOODS PRIVATE LIMITED",
"FREIGHT AG PRIVATE LIMITED",
"FREIGHT BAZAAR INDIA PRIVATE LIMITED",
"FREIGHT BRIDGE LOGISITICS PRIVATE LIMITED",
"FREIGHT CARE LOGITECH PRIVATE LIMITED",
"FREIGHT CARRIERS OF INDIA LTD",
"FREIGHT CARRIERS PRIVATE LIMITED",
"FREIGHT COMMERCE SOLUTIONS PRIVATE LIMITED",
"FREIGHT CONNECTION INDIA PRIVATE LIMITED",
"FREIGHT CONSOLIDATORS MADRAS PRIVATE LIMITED",
"FREIGHT DESK AGENCIES PRIVATE LIMITED",
"FREIGHT EXPEDITE CLEARING AGENCY PRIVATE LIMITED",
"FREIGHT EXPEDITE LOGISTICS INDIA PRIVATE LIMITED",
"FREIGHT EXPRESS INTERNATIONAL PRIVATE LIMITED",
"FREIGHT FIELD MADRAS PRIVATE LIMITED",
"FREIGHT HANDLERS (INDIA) LIMITED",
"FREIGHT INVESTOR SERVICES PRIVATE LIMITED",
"FREIGHT LINES INDIA PRIVATE LIMITED",
"FREIGHT MANAGEMENT INDIA PRIVATE LIMITED",
"FREIGHT MART LOGISTICS PRIVATE LIMITED",
"FREIGHT NET PRIVATE LIMITED",
"FREIGHT ON WHEELS PRIVATE LIMITED",
"FREIGHT PLAN INDIA PRIVATE LIMITED",
"FREIGHT SYSTEMS INDIA PRIVATE LIMITED",
"FREIGHT WING LOGISTICS PRIVATE LIMITED",
"FREIGHT WINGS PRIVATE LIMITED",
"FREIGHTAGE LOGISTICS INDIA PRIVATE LIMITED",
"FREIGHTAIDS (INDIA) PRIVATE LIMITED",
"FREIGHTBRIDGE LOGISTICS PRIVATE LIMITED",
"FREIGHTCAN LOGISTICS INDIA PRIVATE LIMITED",
"FREIGHTCO 3PL PRIVATE LIMITED",
"FREIGHTCO INDIA LIMITED",
"FREIGHTCRATE TECHNOLOGIES PRIVATE LIMITED",
"FREIGHT-EX LOGISTICS PRIVATE LIMITED",
"FREIGHTGATE LOGISTICS PRIVATE LIMITED",
"FREIGHTLINKS INTERNATIONAL INDIA PRIVATE LIMITED",
"FREIGHTOS INDIA PRIVATE LIMITED",
"FREIGHT-RIDERS LOGISTICS INDIA PRIVATE LIMITED",
"FREIGHTWAYS LOGISTICS PRIVATE LIMITED",
"FREIGHTWINGS AND TRAVELS PRIVATE LIMITED",
"FREIGHTWORKS LOGISTICS PRIVATE LIMITED",
"FREINS METAL LIMITED",
"FRELIT ENERGY PRIVATE LIMITED",
"FRELLO TECHNOLOGY PRIVATE LIMITED",
"FREMANTLE INDIA TELEVISION PRODUCTIONS PRIVATE LIMITED",
"FRENCH BUILDMART PRIVATE LIMITED",
"FRENCH CONNECTION LIMITED",
"FRENCH EMBASSY",
"FRENCH EMBASSY IN INDIA",
"FRENCH MOTOR CAR CO LIMITED",
"FRENCH MOTOR CAR CO LTD",
"FRENCH REMEDIES PRIVATE LIMITED",
"FRENDI FASHIONS PRIVATE LIMITED",
"FRENTANIA REAL-TOUCH BUILDERS PRIVATE LIMITED",
"FRENUSTECH PRIVATE LIMITED",
"FRENZELIT INDIA PRIVATE LIMITED",
"FREQUENCE SOFTWARE LLP",
"FREQUENCY ADVERTISING PRIVATE LIMITED",
"FREQUENT FOREX SERVICES PRIVATE LIMITED",
"FREQUENT RESEARCH FIELDWORK SOLUTIONS PRIVATE LIMITED",
"FRESCA FOOD PRIVATE LIMITED",
"FRESCCO NUTRITIONS PRIVATE LIMITED",
"FRESCO CERAMIC PRIVATE LIMITED",
"FRESCO GLOBAL PRIVATE LIMITED",
"FRESCO NZ (INDIA) PRIVATE LIMITED",
"FRESCO POLYMERS PRIVATE LIMITED",
"FRESCO PRINT PACK PRIVATE LIMITED",
"FRESCO PRINTPACK PRIVATE LIMITED",
"FRESCO RADIATOR PRIVATE LIMITED",
"FRESENIUS KABI INDIA PRIVATE LIMITED",
"FRESENIUS KABI ONCOLOGY LIMITED",
"FRESENIUS MEDICAL CARE DIALYSIS SERVICES INDIA PRIVATE LIMITED",
"FRESENIUS MEDICAL CARE INDIA PRIVATE LIMITED",
"FRESH & HEALTHY ENTERPRISES LIMITED",
"FRESH AIR WASTE MANAGEMENT SERVICES PRIVATE LIMITED",
"FRESH AND HONEST CAFE LIMITED",
"FRESH AND HONEST CAFE PRIVATE LIMITED",
"FRESH AND SELECT GROCERIES PRIVATE LIMITED",
"FRESH BITES HOSPITALITY PRIVATE LIMITED",
"FRESH BOWL HORTICULTURE PRIVATE LIMITED",
"FRESH BOX MEDIA PRIVATE LIMITED",
"FRESH DAIRY PRODUCTS INDIA LIMITED",
"FRESH E KART SOLUTIONS PRIVATE LIMITED",
"FRESH EXPRESS FARMERS PRODUCER COMPANY LIMITED",
"FRESH FEAST PRIVATE LIMITED",
"FRESH FIELD FARMER PRODUCER COMPANY LIMITED",
"FRESH FOCUS CONSUMER PRODUCTS PRIVATE LIMITED",
"FRESH FOOD CONCEPTS PRIVATE LIMITED",
"FRESH GRAIN AND SPICES PRIVATE LIMITED",
"FRESH GRAVITY SOFTWARE SERVICES INDIA PRIVATE LIMITED",
"FRESH GREENS PRIVATE LIMITED",
"FRESH HILITES MEDICAMENTS PRIVATE LIMITED",
"FRESH KAICURRY PRODUCTS PRIVATE LIMITED",
"FRESH MAKERS FOOD & BEVERAGES PRIVATE LIMITED",
"FRESH MEALS INDIA PRIVATE LIMITED",
"FRESH N FINE PRODUCTS INDIA PRIVATE LIMITED",
"FRESH O GOLD AGRO PRIVATE LIMITED",
"FRESH -O- VEG PRIVATE LIMITED",
"FRESH PET PRIVATE LIMITED",
"FRESH PRODUCE LOGISTICS PRIVATE LIMITED",
"FRESH PRODUCE VALUE CREATION SERVICES PRIVATE LIMITED",
"FRESH TELEVISION PRIVATE LIMITED",
"FRESH WELKIN FARM & FOODS PRIVATE LIMITED",
"FRESH WORKS TECH PRIVATE LIMITED",
"FRESH2DAY PRIVATE LIMITED",
"FRESHALICIOUS SUPER BAZAAR PRIVATE LIMITED",
"FRESHCARTONS RETAIL AND DISTRIBUTION PRIVATE LIMITED",
"FRESHCO FOODWORLD PRIVATE LIMITED",
"FRESHCORE PROVISIONS PRIVATE LIMITED",
"FRESHCUT ORGANIC PRODUCTS PRIVATE LIMITED",
"FRESHET SPRING PRIVATE LIMITED",
"FRESHGREEN AGRO EXPORTS PRIVATE LIMITED",
"FRESHGROVE AGRO PRIVATE LIMITED",
"FRESHLEE RETAIL PRIVATE LIMITED",
"FRESHLINE FLORICULTURE PRIVATE LIMITED",
"FRESHNET FARMS PRIVATE LIMITED",
"FRESHOKARTZ AGRI PRODUCTS PRIVATE LIMITED",
"FRESHPLAZA EXIM PRIVATE LIMITED",
"FRESHPRO AGRI SOLUTIONS PRIVATE LIMITED",
"FRESHPRO AGRO PRODUCER COMPANY LIMITED",
"FRESHTM RETAIL PRIVATE LIMITED",
"FRESHTOHOME FOODS PRIVATE LIMITED",
"FRESHTROP FRUITS LIMITED",
"FRESHVILLE FROZEN & GROCERIES PRIVATE LIMITED",
"FRESITA FOOD PRIVATE LIMITED",
"FRESKO CHOICE MEAT PRODUCTS PRIVATE LIMITED",
"FRESKO FARMS PRIVATE LIMITED",
"FRETLOG INDIA PRIVATE LIMITED",
"FRETUS FOLKS INDIA PRIVATE LIMITED",
"FREUDENBERG FILTRATION TECHNOLOGIES INDIA PRIVATE LIMITED",
"FREUDENBERG GALA HOUSEHOLD PRODUCT PRIVATE LIMITED",
"FREUDENBERG PERFORMANCE MATERIALS INDIA PRIVATE LIMITED",
"FREUDENBERG REGIONAL CORPORATE CENTER INDIA PRIVATE LIMITED",
"FREUDENBERG-NOK PRIVATE LIMITED",
"FREYA TOURS AND TRAVELS PRIVATE LIMITED",
"FREYER INTERNATIONAL LOGISTICS PRIVATE LIMITED",
"FREYR ENERGY SERVICES PRIVATE LIMITED",
"FREYR SOFTWARE SERVICES PRIVATE LIMITED",
"FREYSSINET MENARD INDIA PRIVATE LIMITED",
"FRIBZI MULTI TECHNOLOGIES PRIVATE LIMITED",
"FRICK INDIA LIMITED",
"FRICON ENGINEERS PRIVATE LIMITED",
"FRICTION METAL FIBRES INDIA PRIVATE LIMITED",
"FRICTION WELDING TECHNOLOGIES PRIVATE LIMITED",
"FRIDAY FILM HOUSE PRIVATE LIMITED",
"FRIDAY FILMWORKS PRIVATE LIMITED",
"FRIDAY MEDIA TECH INDIA PRIVATE LIMITED",
"FRIDAY TRADING PRIVATE LIMITED",
"FRIEDEN TRADING PRIVATE LIMITED",
"FRIEMANN & WOLF INDIA PRIVATE LIMITED",
"FRIEND S MANAGEMENT & CONSULTANTS PVT LTD",
"FRIENDICOES SECA GURGAON ANIMAL HOSPITAL & SANCTUARY",
"FRIENDLY AUTOMOTIVES INDIA PRIVATE LIMITED",
"FRIENDLY FINANCIAL SERVICES PVT LTD",
"FRIENDLY IT CONSULTANTS INDIA PRIVATE LIMITED",
"FRIENDLY LOGISTICS INDIA PRIVATE LIMITED",
"FRIENDLY MOTORS INDIA PRIVATE LIMITED",
"FRIENDS AGRICHEM PRIVATE LIMITED",
"FRIENDS AGRO INDUSTRIES",
"FRIENDS AUTO INDIA LIMITED.",
"FRIENDS BOX FACTORY PRIVATE LIMITED",
"FRIENDS BROTHERS ENTERPRISES PRIVATE LIMITED",
"FRIENDS BUSINESS SOLUTIONS PRIVATE LIMITED",
"FRIENDS CAPITAL SERVICES LIMITED",
"FRIENDS CARGO & LOAD SERVICES PRIVATE LIMITED",
"FRIENDS CASTING PRIVATE LIMITED",
"FRIENDS CLEARING AGENCY PRIVATE LIMITED",
"FRIENDS CLUB LIMITED",
"FRIENDS COLOR IMAGES PRIVATE LIMITED",
"FRIENDS CONCAST LIMITED",
"FRIENDS CONSOLIDATIONS PRIVATE LIMITED",
"FRIENDS DISTILLERIES & BREWERIES (OPC) PRIVATE LIMITED",
"FRIENDS ENGINEERING INDUSTRIES PRIVATE LIMITED",
"FRIENDS FAB FORM PRIVATE LIMITED",
"FRIENDS FORGINGS PRIVATE LIMITED",
"FRIENDS GLASS & GLAZING PRIVATE LIMITED",
"FRIENDS GRAIN FLAKE PRODUCTS PRIVATE LIMITED",
"FRIENDS HOSPICARE PRIVATE LIMITED",
"FRIENDS INDUSTRIES PRIVATE LIMITED",
"FRIENDS INFORMATICS PRIVATE LIMITED",
"FRIENDS INFRACON PRIVATE LIMITED",
"FRIENDS INTERNATIONAL",
"FRIENDS ISPAT LIMITED",
"FRIENDS LAND DEVELOPERS",
"FRIENDS MEDICOS PRIVATE LIMITED",
"FRIENDS METALS PRIVATE LIMITED",
"FRIENDS OIL AND CHEMICAL TERMINALS PRIVATE LIMITED",
"FRIENDS POLYTECH PRIVATE LIMITED",
"FRIENDS SEEDS PRIVATE LIMITED",
"FRIENDS SPECIALITY MEDICINE PRIVATE LIMITED",
"FRIENDS TIMBER PRIVATE LIMITED",
"FRIENDS TWISTERS PRIVATE LIMITED",
"FRIENDS UNITY HOSPITAL AND RESEARCH CENTRE PRIVATE. LIMITED.",
"FRIENDS URDU HIGH SCHOOL",
"FRIENDSHIPTIME.COM PRIVATE LIMITED",
"FRIENDZ AUTOTECH PRIVATE LIMITED",
"FRIENDZZ RISING SERVICES PRIVATE LIMITED",
"FRIGATE ENGINEERING SERVICES PRIVATE LIMITED",
"FRIGATE LOGISTICS PRIVATE LIMITED",
"FRIGATE TEKNOLOGIES PRIVATE LIMITED",
"FRIGEL INTELLIGENT COOLING SYSTEMS INDIA PRIVATE LIMITED",
"FRIGERIO CONSERVA ALLANA PRIVATE LIMITED",
"FRIGG INFRASTRUCTURE PRIVATE LIMITED",
"FRIGID ENGINEERING ENTERPRISES INDIA PRIVATE LIMITED",
"FRIGOGLASS INDIA PRIVATE LIMITED",
"FRIGORIFICO ALLANA PRIVATE LIMITED",
"FRILL ASSETS INDIA PRIVATE LIMITED",
"FRIMLINE PRIVATE LIMITED",
"FRINZE LABORATORIES PRIVATE LIMITED",
"FRIO WAREHOUSING PRIVATE LIMITED",
"FRISCA FACILITY SERVICES PRIVATE LIMITED",
"FRISCH MEDICAL DEVICES PRIVATE LIMITED",
"FRISCHEMIE SPECIALITY PERFORMANCE MATERIALS PRIVATE LIMITED",
"FRISCHMANN PRABHU INDIA DESIGN SERVICES PRIVATE LIMITED",
"FRISCON POLYFAB PRIVATE LIMITED",
"FRISK PROJECTS PRIVATE LIMITED",
"FRISKA NUTRACEUTICALS PRIVATE LIMITED",
"FRISTAM PUMPS INDIA PVT LTD",
"FRISTER FOODS PRIVATE LIMITED",
"FRISTINE INFOTECH PRIVATE LIMITED",
"FRITA CERAMIC PRIVATE LIMITED",
"FRITFOOD PRIVATE LIMITED",
"FRITTA INDIA PRIVATE LIMITED",
"FRITWARE SOLUTIONS PRIVATE LIMITED",
"FRITZ GAITRI CLOTHING COMPANY PRIVATE LIMITED",
"FRITZMEIER MOTHERSON CABIN ENGINEERING LIMITED",
"FRIULAIR INDIA PRIVATE LIMITED",
"FRIZAIR PRIVATE LIMITED",
"FRIZO INDIA PRIVATE LIMITED",
"FRIZZON SERVICES PRIVATE LIMITED",
"FRM TECHNO SOLUTIONS PRIVATE LIMITED",
"FROBSCOTTLE EDUCATION PRIVATE LIMITED",
"FROG CELLSAT LIMITED",
"FROG SERVICES PRIVATE LIMITED",
"FROGXO EXIM PRIVATE LIMITED",
"FROLIC EXPORTS PRIVATE LIMITED",
"FROLIC INDUSTRIES PRIVATE LIMITED",
"FROMAGERIES BEL INDIA PRIVATE LIMITED",
"FROMM PACKAGING SYSTEMS INDIA PRIVATE LIMITED",
"FRONEX AGRO PRIVATE LIMITED",
"FRONIUS INDIA PRIVATE LIMITED",
"FRONS ENGINEERING SOLUTIONS PRIVATE LIMITED",
"FRONT RUNNER IMPEX PRIVATE LIMITED",
"FRONTAGE HOMES PRIVATE LIMITED",
"FRONTAGE INSTITUTE OF INFORMATION TECHNOLOGY & SERVICES PRIVATE LIMITED",
"FRONTAL SOFTWARE PRIVATE LIMITED",
"FRONTARCH ENGINEERS PRIVATE LIMITED",
"FRONTDOOR INDIA PRIVATE LIMITED",
"FRONTEDGE COOLING SOLUTIONS PRIVATE LIMITED",
"FRONTEK SALES PVT LTD",
"FRONTENDERS HEALTHCARE SERVICES PRIVATE LIMITED",
"FRONTENDERS SENIOR HEALTH SERVICES PRIVATE LIMITED",
"FRONTERA IMMIGRATION SERVICES PRIVATE LIMITED",
"FRONTFOOT SPORTS MANAGEMENT PRIVATE LIMITED",
"FRONTIER AGENCIES PRIVATE LIMITED",
"FRONTIER AGROTECH PRIVATE LIMITED",
"FRONTIER ALLOY STEELS LIMITED",
"FRONTIER AUTOMOTIVES PRIVATE LIMITED",
"FRONTIER AUTOWORLD PRIVATE LIMITED",
"FRONTIER BAZZAR PRIVATE LIMITED",
"FRONTIER BISCUIT FACTORY PRIVATE LIMITED",
"FRONTIER BUSINESS SYSTEMS PRIVATE LIMITED",
"FRONTIER COMMERCIAL VEHICLES PRIVATE LIMITED",
"FRONTIER CORPORATE SERVIES PRIVATE LIMITED",
"FRONTIER EMPORIO",
"FRONTIER EXIM PRIVATE LIMITED",
"FRONTIER FORWARDING COMPANY PRIVATE LIMITED",
"FRONTIER GROWTH ADVISORS PRIVATE LIMITED",
"FRONTIER HOLIDAYS PRIVATE LIMITED",
"FRONTIER HOLYDAYS PRIVATE LIMITED",
"FRONTIER INFORMATICS LIMITED",
"FRONTIER KNITTERS PRIVATE LIMITED",
"FRONTIER LEASING & FINANCE LIMITED",
"FRONTIER LIFELINE PRIVATE LIMITED",
"FRONTIER LOGISTICS",
"FRONTIER LOGISTICS PRIVATE LIMITED",
"FRONTIER MARKETS CONSULTING PRIVATE LIMITED",
"FRONTIER MODULAR DESIGNS PRIVATE LIMITED",
"FRONTIER MOTORS PRIVATE LIMITED",
"FRONTIER POLYMERS PVT LTD",
"FRONTIER PROTECTIVEWEAR PRIVATE LIMITED",
"FRONTIER RAAS EXPORTS PRIVATE LIMITED",
"FRONTIER RAAS PRIVATE LIMITED",
"FRONTIER ROLL LABELS PRIVATE LIMITED",
"FRONTIER SOFTWARE PRIVATE LIMITED",
"FRONTIER SPRINGS LIMITED",
"FRONTIER STRIPS PRIVATE LIMITED",
"FRONTIER TECHNOLOGIES PRIVATE LIMITED",
"FRONTIER TRUCKS PRIVATE LIMITED",
"FRONTIER VEHICLES AND MOTORS INDIA LIMITED",
"FRONTIER VEHICLES PRIVATE LIMITED",
"FRONTIER VENTURES PRIVATE LIMITED",
"FRONTIER WAREHOUSING LIMITED",
"FRONTIER WAREHOUSING PRIVATE LIMITED",
"FRONTIZO BUSINESS SERVICES PRIVATE LIMITED",
"FRONTLINE BIZSOL INDIA PRIVATE LIMITED",
"FRONTLINE CAPITAL ANALYSTS PRIVATE LIMITED",
"FRONTLINE CAPITAL SERVICES LIMITED",
"FRONTLINE CAPITAL SERVICES PRIVATE LIMITED",
"FRONTLINE CONSULTANTS PVT LTD",
"FRONTLINE CONTAINERS PRIVATE LIMITED",
"FRONTLINE CORPORATION LIMITED",
"FRONTLINE ELECTRONICS LIMITED",
"FRONTLINE ELECTRONICS PRIVATE LIMITED",
"FRONTLINE ELETROMEDICAL LIMITED",
"FRONTLINE EXPORTS PVT LTD",
"FRONTLINE EYE HOSPITAL",
"FRONTLINE FINANCIAL SERVICES LIMITED",
"FRONTLINE GUARDS PRIVATE LIMITED",
"FRONTLINE HR SOLUTIONS LIMITED",
"FRONTLINE IMAGING PRIVATE LIMITED",
"FRONTLINE MILLENNIUM SCHOOL",
"FRONTLINE NCR BUSINESS SOLUTIONS PRIVATE LIMITED",
"FRONTLINE PHARMACEUTICALS PRIVATE LIMITED",
"FRONTLINE POLYMERS PVT LTD",
"FRONTLINE SALES LIMITED",
"FRONTLINE SALESMART PRIVATE LIMITED",
"FRONTLINE SECURITIES LIMITED",
"FRONTLINE SECURITY SERVICES PRIVATE LIMITED",
"FRONTLINE STEEL PRIVATE LIMITED",
"FRONTLINE SYSTEMS & SERVICES PRIVATE LIMITED",
"FRONTLINE TECHNOCRATS PRIVATE LIMITED",
"FRONTLINE TEX-O-FAB PRIVATE LIMITED",
"FRONTLINE TRAVELS PRIVATE LIMITED",
"FRONTLINE VR INDIA VENTURES PRIVATE LIMITED",
"FRONTLINE VR TOTAL SOLUTIONS PRIVATE LIMITED",
"FRONTLINE WEAVETECH PRIVATE LIMITED",
"FRONTWAY ADVERTISING AND MARKETING CONSULTANT PRIVATE LIMITED",
"FROOTLE INDIA PRIVATE LIMITED",
"FROQ FAR EAST BRAND SERVCIES PRIVATE LIMITED",
"FRORE REFTEK PRIVATE LIMITED",
"FROST AND SULLIVAN (INDIA) PRIVATE LIMITED",
"FROST FALCON DISTILLERIES LIMITED",
"FROST INTERACTIVE SERVICES PRIVATE LIMITED",
"FROST NATIONAL BANK",
"FROSTA FROZEN FOODS PRIVATE LIMITED",
"FROSTEE FROZEN FOODS PRIVATE LIMITED",
"FROSTEES INDIA PRIVATE LIMITED",
"FROSTIDE INDUSTRIES PRIVATE LIMITED",
"FROSTY BOY INDIA PRIVATE LIMITED",
"FROTAMILES PRIVATE LIMITED",
"FROTHY TALES HOSPITALITY PRIVATE LIMITED",
"FROZEN FOOD PROCESSING PRIVATE LIMITED",
"FROZEN SEMEN BANK",
"FROZEN TROPICALS PRIVATE LIMITED",
"FRP ENGINEERS PRIVATE LIMITED",
"FRP PULTRUSION & COMPOSITES PRIVATE LIMITED",
"FRP SERVICES & CO.INDIA PRIVATE LIMITED",
"FRPTECH INDIA PRIVATE LIMITED",
"FRQ BRO PRIVATE LIMITED",
"FRR FOREX PRIVATE LIMITED",
"FRR SHARES AND SECURITIES LIMITED",
"FRRIZZLE FOODS PRIVATE LIMITED",
"FRRUTTO FRESH INDIA PRIVATE LIMITED",
"FRS E-COMMERCE PRIVATE LIMITED",
"FRS ROYALTY MASTERS PRIVATE LIMITED",
"FRSLABS RESEARCH SYSTEMS PRIVATE LIMITED",
"FRUGAL HEALTHCARE BUSINESS SOLUTIONS PRIVATE LIMITED",
"FRUGAL LABS TECH SOLUTIONS PRIVATE LIMITED",
"FRUGALHACKS PRIVATE LIMITED",
"FRUGES IT SERVICES INDIA PRIVATE LIMITED",
"FRUIT JUMP INDIA PRIVATE LIMITED",
"FRUIT MASTER AGRO FRESH PRIVATE LIMITED",
"FRUIT OF THE LOOM INDIA PRIVATE LIMITED",
"FRUITBAE FOOD PRODUCTS PRIVATE LIMITED",
"FRUITBEE AGRITECH PRIVATE LIMITED",
"FRUITBOWL DIGITAL MEDIA PRIVATE LIMITED",
"FRUITFAL TECHNOLOGIES INDIA PRIVATE LIMITED",
"FRUITFUL BUILDCON PRIVATE LIMITED",
"FRUITFUL ENTERPRISES (INDIA) PRIVATE LIMITED",
"FRUITION INDIA PRIVATE LIMITED",
"FRUITION NATURAL EXTRACTS PRIVATE LIMITED",
"FRUITION VENTURE LIMITED",
"FRUITOFARM SUPPLY CHAIN PRIVATE LIMITED",
"FRUMAR AGRI FOODS PRIVATE LIMITED",
"FRUTA FRESH IMPEX PRIVATE LIMITED",
"FRUX TECHNOLOGIES PRIVATE LIMITED",
"FRVAT INDIA PRIVATE LIMITED",
"FRYSTAL PET PRIVATE. LIMITED.",
"FRY-TECH FOOD EQUIPMENTS PRIVATE LIMITED",
"FS COMPRESSORS INDIA PRIVATE LIMITED",
"FS INDIA DEVCO PRIVATE LIMITED",
"FSAIA INTERNATIONAL PRIVATE LIMITED",
"FSD BUILDING MATERIALS PRIVATE LIMITED",
"FSG ADVISORY SERVICES PRIVATE LIMITED",
"FSH AUTOMATION & ENGINEERING PRIVATE LIMITED",
"FSH BUSINESS VENTURES PRIVATE LIMITED",
"FSK BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"FSL SOFTWARE TECHNOLOGIES LIMITED",
"FSN BRANDS MARKETING PRIVATE LIMITED",
"FSN E COMMERCE VENTURES LIMITED",
"FSN E-COMMERCE VENTURES PRIVATE LIMITED",
"FSN INTERNATIONAL LIMITED",
"FSP DESIGN PRIVATE LIMITED",
"FSP POWER ELECTRONICS INDIA PRIVATE LIMITED",
"FSP SOLUTIONS PRIVATE LIMITED",
"FSP TECHNOLOGY INC",
"FSPL SPECIALITIES PRIVATE LIMITED",
"FSR TRAVELS PRIVATE LIMITED",
"FST INFORMATION TECHNOLOGY PRIVATE LIMITED",
"FSTONE TECHNOLOGIES PRIVATE LIMITED",
"FSU TOURISM & SPORTS ORG. PRIVATE LIMITED",
"FT INDUSTRIES PRIVATE LIMITED",
"FT KNOWLEDGE MANAGEMENT COMPANY LIMITED",
"FT STUDIOS INDIA PRIVATE LIMITED",
"FTA ELEVATOR INDIA PRIVATE LIMITED",
"FTA HSRP SOLUTIONS PRIVATE LIMITED",
"FTA MARKETING PRIVATE LIMITED",
"FTB COMMUNICATIONS PRIVATE LIMITED",
"FTBL HOME TRENDS PRIVATE LIMITED",
"FTC CONCRETE PRIVATE LIMITED",
"FTC EXIM PRIVATE LIMITED",
"FTC SWITCHGEAR PRIVATE LIMITED",
"FTC TALENT MEDIA AND ENTERTAINMENT PRIVATE LIMITED",
"FTD AUTOMATION PRIVATE LIMITED",
"FTD INDIA PRIVATE LIMITED",
"FTD INFOCOM PRIVATE LIMITED",
"FTF PHARMA PRIVATE LIMITED",
"FTHN HEALTHCARE PRODUCTS PRIVATE LIMITED",
"FTI CONSULTING INDIA PRIVATE LIMITED",
"FTR PROCON PRIVATE LIMITED",
"FTRON ENERGY PRIVATE LIMITED",
"FTS INDIA PRIVATE LIMITED",
"FTT CABS PRIVATE LIMITED",
"FTTC PROJECTS PRIVATE LIMITED",
"FTTX BROADBAND PRIVATE LIMITED",
"FU PAO INDIA PRIVATE LIMITED",
"FUBEUS TECHNOLOGY PRIVATE LIMITED",
"FUCHS LUBRICANTS INDIA PRIVATE LIMITED",
"FUCHSIA VINE DESIGNS PRIVATE LIMITED",
"FUDO AUTOMATION SYSTEMS PRIVATE LIMITED",
"FUEGO FURNITURE PRIVATE LIMITED",
"FUEL INSTRUMENTS AND ENGINEERS PVT LTD",
"FUEL MEDIA SOLUTIONS PRIVATE LIMITED",
"FUEL SOURCE MANPOWER SOLUTIONS PRIVATE LIMITED",
"FUEL WINGS INDIA PRIVATE LIMITED",
"FUELADREAM ONLINE VENTURES PRIVATE LIMITED",
"FUELBOX SERVICES PRIVATE LIMITED",
"FUELCOAL CORPORATION INDIA LIMITED",
"FUELCRAFT SOLUTIONS PRIVATE LIMITED",
"FUELOCITY TECH PRIVATE LIMITED",
"FUELPRO SYSTEMS PRIVATE LIMITED",
"FUELSAVE SYSTEMS & DEVICES PRIVATE LIMITED",
"FUEVATION TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"FUGEN LABORATORIES PRIVATE LIMITED",
"FUGEN STONE PRIVATE LIMITED",
"FUGENIC ENGINEERING SERVICES INDIA PRIVATE LIMITED",
"FUGO CREATIVE PRIVATE LIMITED",
"FUGRO GEOTECH (INDIA) PRIVATE LIMITED",
"FUGRO GEOTECH INDIA PRIVATE LIMITED",
"FUGRO SURVEY INDIA PRIVATE LIMITED",
"FUJI BANK",
"FUJI ELECTRIC CONSUL NEOWATT PRIVATE LIMITED",
"FUJI ELECTRIC INDIA PRIVATE LIMITED",
"FUJI GEMCO PRIVATE LIMITED",
"FUJI INDIA CORPORATION PRIVATE LIMITED",
"FUJI INFRASTRUCTURE TECHNOLOGIES PRIVATE LIMITED",
"FUJI PHOTO FILMS COMPANY LIMITED",
"FUJI SILVERTECH CONCRETE PRIVATE LIMITED",
"FUJI SYSTEMS INDIA PRIVATE LIMITED",
"FUJI TECH PRODUCTS PRIVATE LIMITED",
"FUJI TECHNICAL SERVICES PRIVATE LIMITED",
"FUJI YUSOKI KOGYO CO LIMITED",
"FUJIFILM INDIA PRIVATE LIMITED",
"FUJIFILM SERICOL INDIA PRIVATE LIMITED",
"FUJIFILM SONOSITE INDIA PRIVATE LIMITED",
"FUJIKAWA POWER",
"FUJIKURA GRAPHICS INDIA PRIVATE LIMITED",
"FUJIKURA KASEI COATING INDIA PRIVATE LIMITED",
"FUJIN CORPORATION PRIVATE LIMITED",
"FUJIN WIND PARKS PRIVATE LIMITED",
"FUJISAKURA TECHNOLOGIES PRIVATE LIMITED",
"FUJISAN TECHNOLOGIES LIMITED",
"FUJISOFT VARA PRIVATE LIMITED",
"FUJITA CORPORATION",
"FUJITA ENGINEERING INDIA PRIVATE LIMITED",
"FUJITEC INDIA PRIVATE LIMITED",
"FUJITSU CONSULTING INDIA PRIVATE LIMITED",
"FUJITSU GENERAL INDIA PRIVATE LIMITED",
"FUJITSU INDIA PRIVATE LIMITED",
"FUJITSU RESEARCH OF INDIA PRIVATE LIMITED",
"FUJITSU SOLUTIONS INDIA PRIVATE LIMITED",
"FUJITSU TEN MINDA INDIA PRIVATE LIMITED",
"FUJIYAMA POWER INFRA PRIVATE LIMITED",
"FUJIYAMA POWER SYSTEMS PRIVATE LIMITED",
"FUJIYAMA SOFTWEARESOLUTIONS PRIVATE LIMITED",
"FUJO MACHINE TOOLS P LTD",
"FUKOKU INDIA PRIVATE LIMITED",
"FUKUAMI WIRING INDIA PRIVATE LIMITED",
"FULAMBRI TEXT COM PRIVATE LIMITED",
"FULCHAND ENTERPRISES PRIVATE LIMITED",
"FULCRO CONSULTING PRIVATE LIMITED",
"FULCRUM AGENCIES PRIVATE LIMITED",
"FULCRUM ALM SOLUTIONS PRIVATE LIMITED",
"FULCRUM COMMERCIAL REAL ESTATE SERVICES PRIVATE LIMITED",
"FULCRUM DIGITAL PRIVATE LIMITED",
"FULCRUM GLOBAL INFO SERVICES",
"FULCRUM GLOBAL TECHNOLOGIES PRIVATE LIMITED",
"FULCRUM INTERNATIONAL PRIVATE LIMITED",
"FULCRUM LIFT COMPONENTS PRIVATE LIMITED",
"FULCRUM MARKETING PRIVATE LIMITED",
"FULCRUM SHIPPING & LOGISTICS PRIVATE LIMITED",
"FULCRUM VENTURE INDIA LLP",
"FULCRUM WORLDWIDE SOFTWARE PRIVATE LIMITED",
"FULENA CONSTRUCTION PRIVATE LIMITED",
"FULETRA SNACKS PRIVATE LIMITED",
"FULFILL DAIRY PRODUCTS PRIVATE LIMITED",
"FULFILLMENT IQ PRIVATE LIMITED",
"FULFORD (INDIA) LIMITED",
"FULFORD INDIA PRIVATE LIMITED",
"FULHAM INDIA PRIVATE LIMITED",
"FULKI COMMUNICATIONS PRIVATE LIMITED",
"FULL BASKET PROPERTY SERVICES PRIVATE LIMITED",
"FULL CIRCLE PUBLISHING PRIVATE LIMITED",
"FULL CREATIVE PRIVATE LIMITED",
"FULL HOUSE MEDIA PRIVATE LIMITED",
"FULL MARK FACILITIES MANAGEMENT PRIVATE LIMITED",
"FULL MARK PROMOTERS AND DEVELOPERS PRIVATE LIMITED",
"FULL SEA EXPORTS PRIVATE LIMITED",
"FULL STOP ENTERTAINMENT LLP",
"FULLARTON DISTILLERIES PRIVATE LIMITED",
"FULLCONTACT TECHNOLOGIES PRIVATE LIMITED",
"FULLCYCLE PRIVATE LIMITED",
"FULLFILL FABRICS PRIVATE LIMITED",
"FULLIFE HEALTHCARE PRIVATE LIMITED",
"FULLMARK MARKETING PRIVATE LIMITED",
"FULLOTOYS EDUTAINMENT PRIVATE LIMITED",
"FULLSTOP SOLUTIONS PRIVATE LIMITED",
"FULLY SUN CHINA LIMITED",
"FULZ TECHNOLOGIES PRIVATE LIMITED",
"FUMA UMBRELLA PRIVATE LIMITED",
"FUMAKILLA INDIA PRIVATE LIMITED",
"FUMENIX PEST SOLUTIONS PRIVATE LIMITED",
"FUMES INTERNATIONAL PRIVATE LIMITED",
"FUMIGATION SERVICES PRIVATE LIMITED",
"FUMITEC MINERALS PRIVATE LIMITED",
"FUMO CHEM PRIVATE LIMITED",
"FUMOTIVES PRIVATE LIMITED",
"FUMR AGRO EXPORTS PRIVATE LIMITED",
"FUN CATCHERS TOYS PRIVATE LIMITED",
"FUN FASHION INDIA PRIVATE LIMITED",
"FUN JOY FOOD PRODUCTS PRIVATE LIMITED",
"FUN PLAY SYSTEMS PRIVATE LIMITED",
"FUN TRIPS & EVENTS PRIVATE LIMITED",
"FUNARIUM PLAY CENTERS PRIVATE LIMITED",
"FUNCELL GAMES PRIVATE LIMITED",
"FUNCTION DISTRIBUTORS PRIVATE LIMITED",
"FUNCTION TRADELINK PRIVATE LIMITED",
"FUNCTIONAL & INNOVATIVE FOODS PRIVATE LIMITED",
"FUNCTIONAL HEALTH PRIVATE LIMITED",
"FUNCTIONAL PARADIGMS PRIVATE LIMITED",
"FUNCTIONIZE SOFTWARE PRIVATE LIMITED",
"FUNDAMENT SERVICES PRIVATE LIMITED",
"FUNDAMENTAL ELECTRONICS PVT LTD",
"FUNDAMENTAL PICTURES PRIVATE LIMITED",
"FUNDAMENTAL PRAKASHAN PRIVATE LIMITED",
"FUNDERMAX INDIA PRIVATE LIMITED",
"FUNDFINA MARKETPLACE PRIVATE LIMITED",
"FUNDFUEL MANAGEMENT SERVICES PRIVATE LIMITED",
"FUNDMART INDIA PRIVATE LIMITED",
"FUNDS FOR NGOS INDIA PRIVATE LIMITED",
"FUNDSAXIS INDIA PRIVATE LIMITED",
"FUNDTECH INDIA PRIVATE LIMITED",
"FUNDTRENDZ INDIA PRIVATE LIMITED",
"FUNDWAVE TECHNOLOGIES PRIVATE LIMITED",
"FUNFACTORY TOYS PRIVATE LIMITED",
"FUNFINITY LEARNING SOLUTIONS PRIVATE LIMITED",
"FUNFIRST FUNTRONIC PRIVATE LIMITED",
"FUNFIRST GLOBAL SKILLERS PRIVATE LIMITED",
"FUNG BUSINESS SERVICES INDIA PRIVATE LIMITED",
"FUNGIBLE INDIA PRIVATE LIMITED",
"FUNJIO FOODS PRIVATE LIMITED",
"FUNKE HEATEX ENGINEERING INDIA PRIVATE LIMITED",
"FUNKY MONKEYS PLAY CENTERS PRIVATE LIMITED",
"FUNMAGIC PLAYSYSTEMS PRIVATE LIMITED",
"FUNNMEDIA",
"FUNONGO ENTERTAINMENT PRIVATE LIMITED",
"FUNONGO MEDIA AND ENTERTAINMENT LLP",
"FUNPLI CITY CLUB AND RESORT PRIVATE LIMITED",
"FUNRIDERS LEISURE & AMUSEMENT PRIVATE LIMITED",
"FUNSAGA PRIVATE LIMITED",
"FUNSCHOLAR INNOVATIONS PRIVATE LIMITED",
"FUNSIGN HOUSING PRIVATE LIMITED",
"FUNSKOOL INDIA LIMITED",
"FUNTOP FOODS AND BEVERAGES PRIVATE LIMITED",
"FUNVENTION LEARNING PRIVATE LIMITED",
"FUNWAVE FOODS LLP",
"FUNWISE CONSULTING PRIVATE LIMITED",
"FUNZONE AMUSEMENTS PRIVATE LIMITED",
"FUNZONE FAMILY ENTERTAINMENT CENTERS (VIZAG) PRIVATE LIMITED",
"FURAAT EARTH PRIVATE LIMITED",
"FUREIN CONSTRUCTION ENGINEERING PRIVATE LIMITED",
"FURFUR AGRO OILS PRIVATE LIMITED",
"FURGO GEOTECH INDIA PRIVATE LIMITED",
"FURION ANALYTICS RESEARCH & CONSULTING LLP",
"FURIOUS COMPUTER SOLUTIONS PRIVATE LIMITED",
"FURIOUS NUTRITIONS PRIVATE LIMITED",
"FURLONG INFRA PROJECTS PRIVATE LIMITED",
"FURMATS MARKETING PRIVATE LIMITED",
"FURMECH ENGINEERS (INDORE) LIMITED",
"FURN BAMBU PRIVATE LIMITED",
"FURN COUCH PRIVATE LIMITED",
"FURN PLANET INTERIORS INDIA PRIVATE LIMITED",
"FURNACE FABRICA INDIA LIMITED",
"FURNEST DECOR PRIVATE LIMITED",
"FURNISCAPES (INDIA) PRIVATE LIMITED",
"FURNISCO RETAIL PRIVATE LIMITED",
"FURNITECH SEATING SYSTEMS INDIA PRIVATE LIMITED",
"FURNITURE & INTERIOR RENTAL PRIVATE LIMITED",
"FURNITURE KRAFT INTERNATIONAL PRIVATE LIMITED",
"FURNITURE TECH PRIVATE LIMITED",
"FURNITURE WORLD MODULAR",
"FURNITURE WORLD PRIVATE LIMITED",
"FURNOTHERM GLASS PROJECTS INDIA PRIVATE LIMITED",
"FURNOVA POLYMERS LTD",
"FURNTECK ENGINEERS PRIVATE LIMITED",
"FURRIOUS PROTECTIVE SECURITY PRIVATE LIMITED",
"FURTADOS HIGH MUSIC PRIVATE LIMITED",
"FURTADOS MUSIC INDIA PRIVATE LIMITED",
"FURTHERANCE TECHNOTREE PRIVATE LIMITED",
"FURUKAWA MINDA ELECTRIC PRIVATE LIMITED",
"FURUKAWA ROCK DRILL INDIA PRIVATE LIMITED",
"FURUKAWA SANGYO KAISHA INDIA PRIVATE LIMITED",
"FURUS PACKAGING PRIVATE LIMITED",
"FUSE+ MEDIA PRIVATE LIMITED",
"FUSED MINERALS INTERNATIONAL",
"FUSELAGE INNOVATIONS PRIVATE LIMITED",
"FUSEPRO INTERLININGS PRIVATE LIMITED",
"FUSHUN CRANES AND EQUIPMENTS INDIA PRIVATE LIMITED",
"FUSIL MANUFACTURING AND TRADING PRIVATE LIMITED",
"FUSION 3PL LOGISTIC PARK PRIVATE LIMITED",
"FUSION AGROCARE PRIVATE LIMITED",
"FUSION BRANDS PRIVATE LIMITED",
"FUSION BUILDING MATERIALS (VIZAG) PRIVATE LIMITED",
"FUSION BUILDTECH PRIVATE LIMITED",
"FUSION BUSINESS SOLUTIONS PRIVATE LIMITED",
"FUSION CHEMICAL AND PRODUCTS PVT LTD",
"FUSION CLOTHING COMPANY",
"FUSION CONCEPTS EVENTS & SALES PRIVATE LIMITED",
"FUSION CONSULTING INDIA PRIVATE LIMITED",
"FUSION CORPORATE SOLUTIONS PRIVATE LIMITED",
"FUSION COSMECEUTICS PRIVATE LIMITED",
"FUSION DEALTRADE PRIVATE LIMITED",
"FUSION ELECTRONICS PRIVATE LIMITED",
"FUSION EVENTS LIMITED",
"FUSION FINSERV PRIVATE LIMITED",
"FUSION FLIGHTS PRIVATE LIMITED",
"FUSION FOODS AND CATERING PRIVATE LIMITED",
"FUSION FOODS INDIA PRIVATE LIMITED",
"FUSION GLOBAL TECHNOLOGIES AND SOLUTIONS PRIVATE LIMITED",
"FUSION GRANITO PRIVATE LIMITED",
"FUSION HEALTH CARE PRIVATE LIMITED",
"FUSION HOSPITALITY PRIVATE LIMITED",
"FUSION HRTECHNO SERVICES PRIVATE LIMITED",
"FUSION HVAC SOLUTIONS PRIVATE LIMITED",
"FUSION INDUS TECSON PRIVATE LIMITED",
"FUSION INDUSTRIES LIMITED",
"FUSION INFORMATICS LIMITED",
"FUSION INTERIORS PRIVATE LIMITED",
"FUSION JEWELRY MANUFACTURING COMPANY PRIVATE LIMITED",
"FUSION KITCHENS",
"FUSION KLASSROOM EDUTECH PRIVATE LIMITED",
"FUSION FINANCE LIMITED",
"FUSION MICROFINANCE PRIVATE LIMITED",
"FUSION PARYATAN VOYAGES PRIVATE LIMITED",
"FUSION PRACTICES TECHNOLOGIES PRIVATE.LIMITED",
"FUSION PROTECTIVE COATINGS PRIVATE LIMITED",
"FUSION SCIENTIFIC LABORATORIES PRIVATE LIMITED",
"FUSION SCIENTIFIC TECHNOLOGIES PRIVATE LIMITED",
"FUSION SIGNS PRIVATE LIMITED",
"FUSION SOFTWARE SOLUTIONS (INDIA) PRIVATE LIMITED",
"FUSION SOFTWARES AND SYSTEMS PRIVATE LIMITED",
"FUSION TECHNOPLAST PRIVATE LIMITED",
"FUSION VOICE SOLUTIONS PRIVATE LIMITED",
"FUSION3 EXPERIENTIAL MARKETING PRIVATE LIMITED",
"FUSIONFORTE SOLUTIONS PRIVATE LIMITED",
"FUSIONGREEN HEALTHCARE PRIVATE LIMITED",
"FUSIONI TECHNOLOGIES PRIVATE LIMITED",
"FUSIONITE INFRATEL PRIVATE LIMITED",
"FUSIONNET WEB SERVICES PRIVATE LIMITED",
"FUSIONPLUS SOLUTIONS PRIVATE LIMITED",
"FUSIONSTOR TECHNOLOGIES PRIVATE LIMITED",
"FUSO GLASS INDIA PRIVATE LIMITED",
"FUSSION BASKET COMMUNICATION PRIVATE LIMITED",
"FUSSION IMPORT EXPORT PRIVATE LIMITED",
"FUTABA INDUSTRIAL GUJARAT PRIVATE LIMITED",
"FUTE TRADERS PRIVATE LIMITED",
"FUTECH INTERNET PRIVATE LIMITED",
"FUTECH IOT PRIVATE LIMITED",
"FUTECH PROJECTS INDIA PRIVATE LIMITED",
"FUTEK DIGITAL CONNECT PRIVATE LIMITED",
"FUTIGODA HIGH SCHOOL",
"FUTNANI STEELS PRIVATE LIMITED",
"FUTOMIC CONSULTANCIES PRIVATE LIMITED",
"FUTOPS TECHNOLOGIES INDIA PRIVATE LIMITED",
"FUTRAN TECH SOLUTIONS PRIVATE LIMITED",
"FUTUR DECOR SOLUTIONS PRIVATE LIMITED",
"FUTURA APSOL PRIVATE LIMITED",
"FUTURA AUTOMATION PRIVATE LIMITED",
"FUTURA BIOPLANTS PRIVATE LIMITED",
"FUTURA CERAMICS P LIMITED",
"FUTURA COMMERCIALS PRIVATE LIMITED",
"FUTURA CONSTRUCTIONS PRIVATE LIMITED",
"FUTURA CONVEYOR SYSTEM PRIVATE LIMITED",
"FUTURA ENGINEEIRNG PRIVATE LIMITED",
"FUTURA GLOBAL VENTURES LIMITED",
"FUTURA KITCHEN SINKS INDIA PRIVATE LIMITED",
"FUTURA PETRO SOLUTIONS PRIVATE LIMITED",
"FUTURA SURGICARE PRIVATE LIMITED",
"FUTURA TECHPARK PRIVATE LIMITED",
"FUTURA TRAVELS LIMITED",
"FUTURAGE CORPORATE SOLUTIONS PRIVATE LIMITED",
"FUTURE & OPTIONS KARD SERVICES PRIVATE LIMITED",
"FUTURE ACCESSORIES LLP",
"FUTURE ACCOUNTING SOLUTIONS PRIVATE LIMITED",
"FUTURE AGRO SOLUTIONS PRIVATE LIMITED",
"FUTURE AGROFOCUS PRIVATE LIMITED",
"FUTURE AGROTECH PRIVATE LIMITED",
"FUTURE AUTO WHEELS PRIVATE LIMITED",
"FUTURE AUTOMATION PRIVATE LIMITED",
"FUTURE AUTOMOBILE AGENCY PRIVATE LIMITED",
"FUTURE BATH PRODUCTS PRIVATE LIMITED",
"FUTURE BIO-SCIENCE PRIVATE LIMITED",
"FUTURE BOOKS PRIVATE LIMITED",
"FUTURE BRANDS LIMITED",
"FUTURE BUSINESSTECH INDIA PRIVATE LIMITED",
"FUTURE CARE HR SERVICES PRIVATE LIMITED",
"FUTURE CARE PHARMA PRIVATE LIMITED",
"FUTURE CARGO LOGISTICS PRIVATE LIMITED",
"FUTURE CHEM AGRO PRIVATE LIMITED",
"FUTURE CHOICE HOSPITALITY INDIA LIMITED",
"FUTURE CITY DEVELOPERS PRIVATE LIMITED",
"FUTURE CONSOLE INFOTECH PRIVATE LIMITED",
"FUTURE CONSUMER LIMITED",
"FUTURE CONSUMER PRODUCTS LIMITED",
"FUTURE DOMAIN SERVICES PRIVATE LIMITED",
"FUTURE EDUCARE PRIVATE LIMITED",
"FUTURE ELCTRONICS INC DISTRIBUTION PTE L TD",
"FUTURE ELCTRONICS INDIA",
"FUTURE ELECTROTECH PRIVATE LIMITED",
"FUTURE ENTERPRISES LIMITED",
"FUTURE ENTERTAINMENT PRIVATE LIMITED",
"FUTURE FACTORY LLP",
"FUTURE FERTILITY PRIVATE LIMITED",
"FUTURE FINANCIAL SERVICES LIMITED",
"FUTURE FINSERVE PRIVATE LIMITED",
"FUTURE FINVEST COMPANY PRIVATE. LIMITED.",
"FUTURE FLEX PRIVATE LIMITED",
"FUTURE FOCUS INFOTECH PRIVATE LIMITED",
"FUTURE GAMING AND HOTEL SERVICES PRIVATE LIMITED",
"FUTURE GENERALI INDIA INSURANCE COMPANY LIMITED",
"FUTURE GENERALI INDIA LIFE INSURANCE COMPANY LIMITED",
"FUTURE GREEN FACILITY MANAGEMENT INDIA PRIVATE LIMITED",
"FUTURE GREEN POWER SOLUTIONS PRIVATE LIMITED",
"FUTURE HI-TECH BATTERIES LIMITED",
"FUTURE HOUSING INFRA PRIVATE LIMITED",
"FUTURE HUMAN DEVELOPMENT LIMITED",
"FUTURE ICONIC INDIA PRIVATE LIMITED",
"FUTURE IDEAS COMPANY LIMITED",
"FUTURE INDUSTRIES PRIVATE LIMITED",
"FUTURE INFO EDGE PRIVATE LIMITED",
"FUTURE INFOMEDIA PRIVATE LIMITED",
"FUTURE INFORMATICS PRIVATE LIMITED",
"FUTURE INSTITUTE OF ENGINEERING AND MANA",
"FUTURE INSTITUTE OF MEDICAL SCIENCES",
"FUTURE IP LABS LLP",
"FUTURE KIDS PUBLICATIONS PRIVATE LIMITED",
"FUTURE LAMINATES PRIVATE LIMITED",
"FUTURE LEATHER CHEMICALS PRIVATE LIMITED",
"FUTURE LIFESTYLE FASHIONS LIMITED",
"FUTURE LIGHTING SOLUTIONS PRIVATE LIMITED",
"FUTURE LUBRICANTS (INDIA) PRIVATE LIMITED",
"FUTURE MARKET INSIGHTS GLOBAL & CONSULTING PRIVATE LIMITED",
"FUTURE MARKET NETWORKS LIMITED",
"FUTURE MEDIA INDIA LIMITED",
"FUTURE METAL ALLOYS PRIVATE LIMITED",
"FUTURE MINING TOOLS PRIVATE LIMITED",
"FUTURE MOBILE AND ACCESSORIES LIMITED",
"FUTURE MONK INVESTMENTS PRIVATE LIMITED",
"FUTURE NETWINGS SOLUTIONS PRIVATE LIMITED",
"FUTURE OILS AND LUBRICANTS PRIVATE LIMITED",
"FUTURE PACE ENTERPRISE PRIVATE LIMITED",
"FUTURE PAPERS PRIVATE LIMITED",
"FUTURE PARKING PRIVATE LIMITED",
"FUTURE PHARMA PRIVATE LIMITED",
"FUTURE PIPE INDUSTRIES SERVICES PRIVATE LIMITED",
"FUTURE POINT PRIVATE LIMITED",
"FUTURE POLYCOATS PRIVATE LIMITED",
"FUTURE PRIME AND BEVERAGES PRIVATE LIMITED",
"FUTURE RESEARCH DESIGN COMPANY PRIVATE LIMITED",
"FUTURE RETAIL LIMITED",
"FUTURE RETAILS LIMITED",
"FUTURE SALES PRIVATE LIMITED",
"FUTURE SMILE FINANCIAL SERVICES LLP",
"FUTURE SPECIALITY RETAIL LIMITED",
"FUTURE STAR ENERGY SOLUTIONS PRIVATE LIMITED",
"FUTURE STONE WORKS PRIVATE LIMITED",
"FUTURE SUPPLY CHAIN SOLUTIONS LIMITED",
"FUTURE TECH CEMENTS LIMITED",
"FUTURE TECH DESIGN SOLUTIONS PRIVATE LIMITED",
"FUTURE TECH DESING PRODUCT LIFECYCLE MANAGEMENT SOLUTION",
"FUTURE TECH ELECTRONICS PRIVATE LIMITED",
"FUTURE TECH9 INNOVATIONS LLP",
"FUTURE TECHNO DESIGNS PRIVATE LIMITED",
"FUTURE TECHNOLOGY PRIVATE.LIMITED",
"FUTURE TECHNOLOGY SKILLS FOUNDATION",
"FUTURE TELE VAS PRIVATE LIMITED",
"FUTURE TEXTILE SOLUTIONS PRIVATE LIMITED",
"FUTURE TEXWEAR EXPORTS PRIVATE LIMITED",
"FUTURE TRADELINKS PRIVATE LIMITED",
"FUTURE TYRES PRIVATE. LIMITED.",
"FUTURE U INDIA LIMITED",
"FUTURE UDAY COMMUNICATIONS PRIVATE LIMITED",
"FUTURE VENTURES PRIVATE LIMITED",
"FUTURE WAREHOUSE SOLUTIONS PRIVATE LIMITED",
"FUTURE WINGS VISA ADVISORS PRIVATE LIMITED",
"FUTURE WIZ ADVERTISING PRIVATE LIMITED",
"FUTURE WORLD RETAIL PRIVATE LIMITED",
"FUTURE ZIPPERS PRIVATE LIMITED",
"FUTURE101 DESIGN PRIVATE LIMITED",
"FUTUREACE HEALTHCARE PRIVATE LIMITED",
"FUTUREADY SERVICES PRIVATE LIMITED",
"FUTUREBAZAAR INDIA LIMITED",
"FUTUREBIT CREATIVE LABS PRIVATE LIMITED",
"FUTURECALLS TECHNOLOGY PRIVATE LIMITED",
"FUTURECAREER SOLUTIONS PRIVATE LIMITED",
"FUTUREEYE INFOTECH PRIVATE LIMITED",
"FUTUREFACTOR GLOBAL ADVISORY PRIVATE LIMITED",
"FUTURE'GATE TECHNOLOGIES PRIVATE LIMITED",
"FUTUREGENIC ENGINEERING PRIVATE LIMITED",
"FUTUREGLOBAL CAPITAL VENTURES PRIVATE LIMITED",
"FUTUREGOLD AGROTECH PRIVATE LIMITED",
"FUTUREGREEN EV PRIVATE LIMITED",
"FUTUREGROW SPECTRUM RADIATION PRIVATE LIMITED",
"FUTURELIFE FOODS PRIVATE LIMITED",
"FUTURELINE TECHNOLOGIES LIMITED",
"FUTUREMINDS CONSULTING PRIVATE LIMITED",
"FUTURENET TECHNOLOGIES INDIA PRIVATE LIMITED",
"FUTURENSE TECHNOLOGIES PRIVATE LIMITED",
"FUTUREPLAN ENTERPRISES PRIVATE LIMITED",
"FUTUREPUMP INDIA PRIVATE LIMITED",
"FUTURES FIRST INFO SERVICES PRIVATE LIMITED",
"FUTURESAFE SERVICE PRIVATE LIMITED",
"FUTURESOFT INDIA PRIVATE LIMITED",
"FUTURESOFT SOLUTION PRIVATE LIMITED",
"FUTURESTAR MINES AND MINERALS PRIVATE LIMITED",
"FUTURESTEP RECRUITMENT SERVICES PRIVATE LIMITED",
"FUTURETECH ENGINEERING PRIVATE LIMITED",
"FUTURETECH ENVIRONMENT CONSORTIUM PRIVATE LIMITED",
"FUTURETECH INFRASTRUCTURES",
"FUTURETEK COMMERCE PRIVATE LIMITED",
"FUTURETEL ENERGY PRIVATE LIMITED",
"FUTURETRUCKS LOGISTICS PRIVATE LIMITED",
"FUTUREWORKS CONSULTING PRIVATE LIMITED",
"FUTUREWORKS MEDIA LIMITED",
"FUTUREX MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"FUTUREX TRADE FAIR AND EVENTS PRIVATE LIMITED",
"FUTURISK INSURANCE BROKING CO. PRIVATE LIMITED",
"FUTURISM TECHNOLOGIES PRIVATE LIMITED",
"FUTURISTIC ALLOYS & METALS PRIVATE LIMITED",
"FUTURISTIC CIRCUIT SERVICES PRIVATE LIMITED",
"FUTURISTIC CLIMATE CONTROLS PRIVATE LIMITED",
"FUTURISTIC CONVERGENCE SERVICES (OPC) PRIVATE LIMITED",
"FUTURISTIC DIAGNOSTIC IMAGING CENTRE PRIVATE LIMITED",
"FUTURISTIC GLOBAL RESOURCES PRIVATE LIMITED",
"FUTURISTIC HOSPITALITY PRIVATE LIMITED",
"FUTURISTIC IDC PRIVATE LIMITED",
"FUTURISTIC INNOVATIVE SYSTEMS PRIVATE LIMITED",
"FUTURISTIC LED PRIVATE LIMITED",
"FUTURISTIC MEDIA AND ENTERTAINMENT LIMITED",
"FUTURISTIC MEDICARE PRIVATE LIMITED",
"FUTURISTIC PACKAGING PRIVATE LIMITED",
"FUTURISTIC PRINT VISION PRIVATE LIMITED",
"FUTURISTIC RELOCATION SOLUTIONS PRIVATE LIMITED",
"FUTURISTIC SKILLVILLE PRIVATE LIMITED",
"FUTURISTIC SOLUTIONS LIMITED",
"FUTURISTIC TAPES PRIVATE LIMITED",
"FUTURISTIC TRANSINDIA DEVELOPMENT PRIVATE LIMITED",
"FUTURISTICS METAL TRADING PRIVATE LIMITED",
"FUTURISTICS MOTOR DEALERS PRIVATE LIMITED",
"FUTURISTIK PRIVATE LIMITED",
"FUTURLYTIC PRIVATE LIMITED",
"FUTURO COMPONENTS PRIVATE LIMITED",
"FUTURZ HUMAN RESOURCES SOLUTIONS PRIVATE LIMITED",
"FUTURZ INFRASTRUCTURE INDIA PRIVATE LIMITED",
"FUTURZ NEXT SERVICES PRIVATE LIMITED",
"FUTURZ STAFFING",
"FUTURZ STAFFING SOLUTIONS PRIVATE LIMITED",
"FUTURZ TRAVELS AND LOGISTICS PRIVATE LIMITED",
"FUTUUREMED PRIVATE LIMITED",
"FUTX IT PRIVATE LIMITED",
"FUTZEN ETECHNOLOGIES PRIVATE LIMITED",
"FUWEI TECHNOLOGY PRIVATE LIMITED",
"FUZAIL SHOES PRIVATE LIMITED",
"FUZEN PHARMACEUTICALS PRIVATE LIMITED",
"FUZEN SOFTWARE PRIVATE LIMITED",
"FUZHIO HEALTH AND BUSINESS SERVICES PRIVATE LIMITED",
"FUZI CLASSIC ELEVATORS PRIVATE LIMITED",
"FUZION JEWELS PRIVATE LIMITED",
"FUZION PUBLICRELATIONS PRIVATE LIMITED",
"FUZZI GLOBAL VENTURE PRIVATE LIMITED",
"FWCLOUD TECHNOLOGIES PRIVATE LIMITED",
"FX MART PRIVATE LIMITED",
"FX MULTITECH PRIVATE LIMITED",
"FX PIGMENTS PRIVATE LIMITED",
"FX5 INTERNATIONAL PRIVATE LIMITED",
"FXB INDIA SURAKSHA",
"FXBYTES TECHNOLOGIES PRIVATE LIMITED",
"FXPROS ADVISORS LLP",
"FXTRADE CONSULTING PRIVATE LIMITED",
"FY TRADING COMPANY PRIVATE LIMITED",
"FYBER SOFT TECHNOLOGIES PRIVATE LIMITED",
"FYBROS MODDULAR PRIVATE LIMITED",
"FYC TECH PRIVATE LIMITED",
"FYD INTERIORS PRIVATE LIMITED",
"FYDOX TECHNOLOGIES PRIVATE LIMITED",
"FYERS INVESTMENT ADVISORS PRIVATE LIMITED",
"FYERS SECURITIES PRIVATE LIMITED",
"FYIENT GLOBAL SERVICES PRIVATE LIMITED",
"FYLFOT CABLE INDUSTRIES PRIVATE LIMITED",
"FYLFOT EDUCATION SOCIETY",
"FYLFOT ENTERPRISES PRIVATE LIMITED",
"FYLFOT TECHNOLOGIES PRIVATE LIMITED",
"FYN TECHNOLOGIES PRIVATE LIMITED",
"FYNAMICS TECHNO SOLUTIONS PRIVATE LIMITED",
"FYNAMICS TRAINING SOLUTIONS PRIVATE LIMITED",
"FYNDUS INDIA PRIVATE LIMITED",
"FYNSEA LINES AND LOGISTICS PRIVATE LIMITED",
"FYRETRACK SYSTEMS & SERVICES PRIVATE LIMITED",
"FYTOCARE CHEMICALS PRIVATE LIMITED",
"G & B FOOT CORP PRIVATE LIMITED",
"G & C GLOBAL CONSORTIUM PRIVATE LIMITED",
"G & D GIFTS PRIVATE LIMITED",
"G & G FASHIONS PRIVATE LIMITED",
"G & G INNOVATIVE SOLUTIONS PRIVATE LIMITED",
"G & G INTERNATIONAL PRIVATE. LIMITED.",
"G & G MEDIA PRIVATE LIMITED",
"G & G SURVEYORS PRIVATE LIMITED",
"G & L PROFILE AND EQUIPMENTS PRIVATE LIMITED",
"G & T OILFIELD AND OFFSHORE SERVICES PRIVATE LIMITED",
"G 2 K MOBILES AND ELECTRONICS PRIVATE LIMITED",
"G 4 SALES AND MARKETING ASSOCIATES PRIVATE LIMITED",
"G 6 SECURITY & CONSULTANCY SERVICES PRIVATE LIMITED",
"G A BHILARE CONSULTANTS PRIVATE LIMITED",
"G A D PANCHYAYAT SAMITI MAHABALESHWAR",
"G A FOODS(INDIA) PRIVATE LIMITED",
"G A INDUSTRIES",
"G A MORGAN DYNAMICS PRIVATE LIMITED",
"G A NAIDU HOSPITALS PRIVATE LIMITED",
"G A SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"G AMPHRAY PHARMACEUTICALS PRIVATE LIMITED",
"G AND V EXPORTS PRIVATE LIMITED",
"G B BUILDWELL PRIVATE LIMITED",
"G B ENTERPRISES PRIVATE LIMITED",
"G B ENTERPRISESS TRANSPORT PRIVATE LIMITED",
"G B EXTRUSIONS PRIVATE LIMITED",
"G B LAWNS PRIVATE LIMITED",
"G B OVERSEAS PRIVATE LIMITED",
"G B PETRO CONSULTANTS PRIVATE LIMITED",
"G B R METALS PRIVATE LIMITED",
"G B RICE MILLS PRIVATE LIMITED",
"G B RUBBER PRODUCTS",
"G B TECHNICAL SERVICES",
"G B TIMBER INDUSTRIES PRIVATE LIMITED",
"G B TRANSPORT (INDIA) PVT LTD",
"G B VAGHANI MULTISPECIALIST HOSPITAL",
"G B WHEELERS PRIVATE LIMITED",
"G C COSMETICS PRIVATE LIMITED",
"G C EMBROIDERY COLLECTIONS PRIVATE LIMITED",
"G C FOODS PRIVATE LIMITED",
"G C G SILK MILLS PRIVATE LIMITED",
"G C N INFOTECH PRIVATE LIMITED",
"G C RAJ FABRICS PRIVATE LIMITED",
"G C S COMPUTER TECHNOLOGY PRIVATE LIMITED",
"G C S EXPORTS PRIVATE LIMITED",
"G C SPINTEX PRIVATE LIMITED",
"G CORP DEVELOPERS P LIMITED",
"G CORP DEVELOPERS PRIVATE LIMITED",
"G CORP HOMES PRIVATE LIMITED",
"G CORP PRIVATE LIMITED",
"G CORP PROPERTY MANAGEMENT PRIVATE LIMITED",
"G D A SECURITY PRIVATE LIMITED",
"G D ASSOCIATES",
"G D BIRLA CENTRE FOR EDUCATION",
"G D ENGINEERS AND CONTRACTORS PRIVATE LIMITED",
"G D FOODS MANUFACTURING (INDIA) PRIVATE LIMITED",
"G D GENERAL HOSPITAL",
"G D GOENKA GLOBAL SCHOOL",
"G D GOENKA INTERNATIONAL SCHOOL",
"G D GOENKA PUBLIC SCHOOL",
"G D GOENKA UNIVERSITY",
"G D GOENKA WORLD SCHOOL",
"G D H PHARMA PRIVATE LIMITED",
"G D M MANAGEMENT SERVICES PRIVATE LIMITED",
"G D METSTEEL PRIVATE LIMITED",
"G D MOTORS PRIVATE LIMITED",
"G D NAIDU CHARITIES",
"G D PHARMACEUTICALS PRIVATE LIMITED",
"G D R PROJECTS & PROPERTIES (INDIA) PRIVATE LIMITED",
"G D ROLLING AND ENGINEERING WORKS PVT LTD",
"G D SEIGELL AND CO PRIVATE LTD",
"G D SOMANI MEMORIAL SCHOOL",
"G D SPRING MANUFACTURING COMPANY PVT LTD",
"G D TEXTILES (MADURAI) PRIVATE LIMITED",
"G DAS & CO PVT LTD",
"G DAS CAPITAL MARKETS PRIVATE LIMITED",
"G DECOR PLYLAM PRIVATE LIMITED",
"G E S HITECH AUTOMATIONS INDIA PRIVATE LIMITED",
"G E TRADECOM PRIVATE LIMITED",
"G EMPOWER BROADCASTING PRIVATE LIMITED",
"G ENG ADVISORY SERVICES PRIVATE LIMITED",
"G EXPRESS COURIER AND LOGISTICS PRIVATE LIMITED",
"G FORCE DENTAL",
"G G AGRAWAL PRI SCH BODWAD",
"G G AUTOMOTIVE GEARS LIMITED",
"G G FIBRES PRIVATE LIMITED",
"G G INSTRUMENTS PRIVATE LIMITED",
"G G MARINE CONTAINERS PRIVATE LIMITED",
"G G MEDICAL HEALTH CARE PRIVATE LIMITED",
"G G ORGANICS EXPORTS PRIVATE LIMITED",
"G G S INFORMATION SERVICES INDIA PRIVATE LIMITED",
"G G TRONICS INDIA PRIVATE LIMITED",
"G G VALVES PRIVATE LIMITED",
"G GALAXY INFRASPACE PRIVATE LIMITED",
"G GLOBAL SHIPPING INDIA PRIVATE LIMITED",
"G GMS HEERA MILL KI CHAAL",
"G H INSULATION INDIA PRIVATE LIMITED",
"G H RAISONI COLLEGE OF ENGINEERING",
"G H RAISONI UNIVERSITY",
"G I GROUP NETWORK SECURITY TECHNOLOGY PRIVATE LIMITED",
"G I HEALTHCARE PRIVATE LIMITED",
"G I INFOTECH LIMITED",
"G I R ESTATES PRIVATE LIMITED",
"G I R LOGISTICS PRIVATE LIMITED",
"G I SECURITY PRIVATE LIMITED",
"G I SERVICES INDIA LIMITED",
"G INFRA PROJECTS LIMITED",
"G J BULK CARRIERS PRIVATE LIMITED",
"G J CHEMICALS PVT LTD",
"G J ELASTIKA PVT LTD",
"G J HEALTHCARE PRIVATE LIMITED",
"G J JAIN ENTERPRISES PRIVATE LIMITED",
"G J LOGISTICS PRIVATE LIMITED",
"G J MULTI CLAVE (INDIA) PRIVATE LIMITED",
"G J SECURITIES PRIVATE LIMITED",
"G J SR SECONDARY SCHOOL KALWAS( HISAR)",
"G K & SONS AUTOMOBILES PRIVATE LIMITED",
"G K ALLOYS PRIVATE LIMITED",
"G K AUTOWHEELS PRIVATE LIMITED",
"G K BURMAN HERBAL INDIA PRIVATE LIMITED",
"G K CONSTRUCTIONS",
"G K CONTROLS PRIVATE LIMITED",
"G K DAIRY AND MILK PRODUCTS PRIVATE LIMITED",
"G K FASHIONS PRIVATE LIMITED",
"G K FOUNDERS PRIVATE. LIMITED.",
"G K G INFOTECH PRIVATE LIMITED",
"G K GREEN POWER PRIVATE LIMITED",
"G K HOTELS LTD",
"G K INFRATECH",
"G K IRON AND STEEL COMPANY LIMITED",
"G K ISPAT PRIVATE LIMITED",
"G K MANAGEMENT SERVICES INDIA LIMITED",
"G K OUTSOURCING OPC PRIVATE LIMITED",
"G K PLASTICS PVT LTD",
"G K PUBLICATIONS PRIVATE LIMITED",
"G K RESIDENCY PRIVATE LIMITED",
"G K S PROPERTIES PRIVATE LIMITED",
"G K SAFETY AND SECURITY SYSTEMS PRIVATE LIMITED",
"G K SHETTY BUILDERS PRIVATE LIMITED",
"G K SHETTY VIVEKANANDA VIDYALAYA MATRIC HIGHER SECONDARY SCHOOL",
"G K SYNTEXT PRIVATE LIMITED",
"G K TOBACCO INDUSTRIES PRIVATE LIMITED",
"G K TRADING PVT LTD",
"G K V COMPUTERS AND SOLUTIONS PRIVATE LIMITED",
"G KUPPUSWAMY NAIDU MEMORIAL HOSPITAL",
"G L ENGINEERING INDUSTRIES PRIVATE LIMITED",
"G L FOODS PRIVATE LIMITED",
"G L HOSPITAL PRIVATE LIMITED",
"G L INTERIORS PRIVATE LIMITED",
"G L INTERNATIONAL",
"G L MARKETING PRIVATE LIMITED",
"G L METALLICA PRIVATE. LIMITED",
"G L O PITHAMPUR",
"G L PLYWOOD PVT LTD",
"G L POLYURETHENE PROCESSING COMPANY PRIVATE LIMITED",
"G L SAREES PRIVATE LIMITED",
"G M AGRO & BEVERAGES INDIA PRIVATE LIMITED",
"G M ALLOYS PRIVATE LIMITED",
"G M ARCH PRIVATE LIMITED",
"G M BIOCHEM PRIVATE LIMITED",
"G M BREWERIES LIMITED",
"G M C MARKETING SOLAPUR",
"G M COLD STORAGE PRIVATE LIMITED",
"G M CONTRACTORS PRIVATE LIMITED",
"G M D T I C",
"G M D T I C UJJAIN",
"G M ELECTRONICS",
"G M ENCLAVE PRIVATE LIMITED",
"G M ENGINEERING PRIVATE LIMITED",
"G M EXIM PRIVATE LIMITED",
"G M FABRICS PRIVATE LIMITED",
"G M FLOWLINES PRIVATE LIMITED",
"G M FLOWTECH PRIVATE LIMITED",
"G M GOLD PRIVATE LIMITED",
"G M K STEELS PRIVATE LIMITED",
"G M KNITTING INDUSTRIES PVT LTD",
"G M MOMIN WOMENS COLLEGE BHIWANDI",
"G M POLYPLAST LIMITED",
"G M R VARALAKSHMI FOUNDATION",
"G M S BADAVADA",
"G M S PROCESSORS PRIVATE LIMITED",
"G M S WORLDWIDE EXPRESS PRIVATE LIMITED",
"G M SYNTEX PRIVATE LIMITED",
"G M TEA PACKERS PRIVATE LIMITED",
"G M TECHNOCHEM PRIVATE LIMITED",
"G M TRADERS",
"G M VALVE PRIVATE LIMITED",
"G M VIDYANIKETAN PUBLIC SCHOOL",
"G MAHESH BABU ENTERTAINMENT PRIVATE LIMITED",
"G MAMUJI PACKAGING INDUSTRIES PRIVATE LIMITED",
"G MART LIMITED",
"G MECH FURNITURE INDUSTRIES",
"G MOBILE DEVICES PRIVATE LIMITED",
"G N BROS SAREES PRIVATE LIMITED",
"G N BUILDEV PRIVATE LIMITED",
"G N DESIGNER HANDLOOMS PRIVATE LIMITED",
"G N G AUTO AIDS PRIVATE LIMITED",
"G N G COOLDON PRIVATE LIMITED",
"G N INDIA SALES PRIVATE LIMITED",
"G N INDUSTRIES",
"G N P AGROSCIENCES PRIVATE LIMITED",
"G N P APPARELS PRIVATE LIMITED",
"G N R C LIMITED",
"G N SOLUTIONS PRIVATE LIMITED",
"G N TEXTILE PRIVATE LIMITED",
"G NARAYANAMMA INSTI OF SCIENCE AND TECH",
"G NEXT MEDIA PRIVATE LIMITED",
"G NEXT VENTURE SOLUTIONS PRIVATE LIMITED",
"G NINE BIOCEUTICALS PRIVATE LIMITED",
"G NINE MODULAR PRIVATE LIMITED",
"G O MOBILE TRADING PRIVATE LIMITED",
"G ONE AGRO PRODUCTS LIMITED",
"G P AUTOMECH PRIVATE LIMITED",
"G P CIVICON PRIVATE LIMITED",
"G P COMBINES PRIVATE LIMITED",
"G P FREIGHT CARRIER PRIVATE LIMITED",
"G P G CATTLE FEED PRIVATE LIMITED",
"G P GLOBAL SOFT TECH PRIVATE LIMITED",
"G P GREEN ENERGY SYSTEMS PRIVATE LIMITED",
"G P JEWELLERS INDIA PRIVATE LIMITED",
"G P MANGLANI FOODS PVT LTD",
"G P MONDAL & SONS (WINE) PVT LTD",
"G P MOTORS PRIVATE LIMITED",
"G P S MARKETING PRIVATE LIMITED",
"G P S PROCUREMENT (INDIA) PRIVATE LIMITED",
"G P SAREES PRIVATE LIMITED",
"G P T PHARMACEUTICALS PRIVATE LIMITED",
"G PEE POWER PRIVATE LIMITED",
"G PLAST PRIVATE LIMITED",
"G POLY FLEX PRIVATE LIMITED",
"G PRAXEN AND CO PRIVATE LIMITED",
"G PULLA REDDY COLLEGE OF PHARMACY JR DEG",
"G PULLA REDDY ENGINEERING COLLEGE",
"G PULLAIAH COLLEGE OF ENGINEERING AND TECHNOLOGY",
"G R B TECHNOLOGIES PRIVATE LIMITED",
"G R CARBON PRIVATE LIMITED",
"G R CONSTRUCTIONS",
"G R CONSULTANTS PRIVATE LIMITED",
"G R EDUCATION TRUST",
"G R ENGINEERING PRIVATE LIMITED",
"G R ENTERPRISE PRIVATE LIMITED",
"G R EXIM PRIVATE LIMITED",
"G R FASHIONS PRIVATE LIMITED",
"G R FILMS",
"G R GUPTA & BROS.",
"G R HEALTH AIDS PRIVATE LIMITED",
"G R INFRAPROJECTS LIMITED",
"G R INTERNATIONAL SCHOOL",
"G R K THEATRES PRIVATE LIMITED",
"G R KRISHNA FERRO ALLOYS PRIVATE LIMITED",
"G R M FOODS PRIVATE LIMITED",
"G R MINERALS AND INDUSTRIES PRIVATE. LIMITED.",
"G R P JIVAN VIKAS VIDYALAYA",
"G R PHARMA PRIVATE LIMITED",
"G R R INDUSTRIES PRIVATE LIMITED",
"G R RUBY JEWELLERS INDIA PRIVATE LIMITED",
"G R S ROADLINES PRIVATE LIMITED",
"G R SPONGE AND POWER LIMITED",
"G R THANGAMALIGAI AND SONS JEWELLERS LLP",
"G RAMAMOORTHI CONSTRUCTIONS INDIA PRIVATE LIMITED",
"G S ALLOY CASTINGS LIMITED",
"G S ATWAL & CO ENGINEERS PVT LTD",
"G S AUTOCOMP PRIVATE LIMITED",
"G S B A BUILDERS PRIVATE LIMITED",
"G S B INFRASTRUCTURES PRIVATE LIMITED",
"G S BODY BUILDERS PRIVATE LIMITED",
"G S BUILD ESTATE PRIVATE LIMITED",
"G S BUILDTECH PRIVATE LIMITED",
"G S COMMODITIES PRIVATE LIMITED",
"G S COMPUTER CONSULTANCY PRIVATE LIMITED",
"G S CONBUILD PRIVATE LIMITED",
"G S DEVELOPERS AND CONTRACTORS PVT LTD",
"G S ENTERPRISE",
"G S EXIM PRIVATE LIMITED",
"G S EXPORTS PRIVATE LIMITED",
"G S FAB PRIVATE LIMITED",
"G S FILAMENTS PVT LTD",
"G S G PROPERTIES PRIVATE LIMITED",
"G S HI TECH FABRICATORS PRIVATE LIMITED",
"G S INFRAPORT PRIVATE LIMITED",
"G S JUTE PRIVATE LIMITED",
"G S K INT COLL KIRAOLI AGRA",
"G S LOGISTICS PRIVATE LIMITED",
"G S M ALLOYS PRIVATE LIMITED",
"G S M SURGICALS PRIVATE LIMITED",
"G S MAJESTIC DEVELOPERS PRIVATE LIMITED",
"G S MULTI SERVICES",
"G S N PACKAGING PRIVATE LIMITED",
"G S PHARMBUTOR PRIVATE LIMITED",
"G S PROPERTIES & MANAGEMENT PRIVATE LIMITED",
"G S PULSES PRIVATE LIMITED",
"G S R BUILDERS & DEVELOPERS PRIVATE LIMITED",
"G S R FREIGHT FORWARDERS PRIVATE LIMITED",
"G S R HOTELS LIMITED",
"G S R SHIPPING SERVICES PRIVATE",
"G S REFRIGERATION PRIVATE LIMITED",
"G S SAREES PRIVATE LIMITED",
"G S SETTIA & BROS PRIVATE LIMITED",
"G S SILK MILLS PRIVATE LIMITED",
"G S STAFFING SOLUTIONS PRIVATE LIMITED",
"G S T CORPORATION LIMITED",
"G S TELE COMMUNICATION LIMITED",
"G S TRAVELS PRIVATE LIMITED",
"G S V INT COLL CHHATIKARA MATHURA",
"G S V M MEDICAL COLLEGE KANPUR",
"G S VIDYUT FINANCIAL SERVICES PRIVATE LIMITED",
"G SQUARE INTERNATIONAL PRIVATE LIMITED",
"G SQUARE MOTORS PRIVATE LIMITED",
"G SQUARE REALTORS PRIVATE LIMITED",
"G SQUARE TECHSYSTEMS PRIVATE LIMITED",
"G SURGIWEAR LIMITED",
"G T M SEALS PRIVATE LIMITED",
"G T P GRANITES LIMITED",
"G T PRODUCTS PRIVATE LIMITED",
"G T R CO PVT LTD",
"G T TRADELINK PRIVATE LIMITED",
"G T Z INDIA PVT LTD",
"G TEX PRINTS PRIVATE LIMITED",
"G U FINANCIAL SERVICES PRIVATE LIMITED",
"G UEGS MAJRA BAGUDI",
"G V ACHARYA INSTITUTE OF ENGINEERING & TECHNOLOGY",
"G V C COLLEGE OF EDUCATION",
"G V D TEXTILES PRIVATE LIMITED",
"G V ELECTRICALS PRIVATE LIMITED",
"G V G IMPERIAL TEX PRIVATE LIMITED",
"G V G INDUSTRIES PRIVATE LIMITED",
"G V G KRAFT PRIVATE LIMITED",
"G V G PAPER MILLS PRIVATE LIMITED",
"G V MEDITECH PRIVATE LIMITED",
"G V PARIVAAR RETAILS PRIVATE LIMITED",
"G V TEL PRIVATE LIMITED",
"G VENTURE TECHNOLOGY PRIVATE LIMITED",
"G WILLIAMS (FABRICATIONS) PRIVATE LIMITED",
"G&A INFRASTRUCTURE INDIA PRIVATE LIMITED",
"G&CC MANAGEMENT SERVICES PRIVATE LIMITED",
"G&G INFRATECH PRIVATE LIMITED",
"G&G POLYMAC PRIVATE LIMITED",
"G&G SKILLS DEVELOPERS PRIVATE LIMITED",
"G&J PLEADER APPLIANCES PRIVATE LIMITED",
"G&L SCIENTIFIC INDIA PRIVATE LIMITED",
"G&T INDUSTRIES PRIVATE LIMITED",
"G. BAPPA ORGOCHEM PRIVATE LIMITED",
"G. C. DIAMONDS PRIVATE LIMITED",
"G. C. DIVINE ESTATE PRIVATE LIMITED",
"G. G. DANDEKAR PROPERTIES LIMITED",
"G. GANDEVIKAR JEWELLERS PRIVATE LIMITED",
"G. J. MINERALS PRIVATE LIMITED",
"G. J. POULTRY PRIVATE LIMITED",
"G. K. & SONS PVT LTD",
"G. K. CASTING PRIVATE LIMITED",
"G. K. INVESTMENTS LTD",
"G. K. P. PRINTING & PACKAGING LIMITED",
"G. KHANNA & COMPANY",
"G. L. SALES PRIVATE LIMITED",
"G. M. K. SYSTEM AND LOGISTICS PRIVATE LIMITED",
"G. N. 9. SECURITY SOLUTIONS PRIVATE LIMITED",
"G. N. FASHION PRIVATE LIMITED",
"G. N. G. INVESTMENT LIMITED",
"G. O. STEEL PRIVATE LIMITED",
"G. PULLAIAH COLLEGE OF ENGINEERING AND TECHNOLOGY AUTONOMOUS",
"G. R. CARGO MOVERS PRIVATE LIMITED",
"G. R. HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED",
"G. R. METALLOYS PRIVATE LIMITED",
"G. R. MINING AND LOGISTICS PRIVATE LIMITED",
"G. S. AGROTECH PRIVATE LIMITED",
"G. S. D. COMPONENTS PRIVATE LIMITED",
"G. S. ENTERPRISES PRIVATE LIMITED",
"G. S. OBEROI STRUCTURES PRIVATE LIMITED",
"G. S. TRACON PRIVATE LIMITED",
"G.A STEELMET (INDIA) PRIVATE LIMITED",
"G.A. APPAREL PRIVATE LIMITED",
"G.A. FUTURE EDUCORE PRIVATE LIMITED",
"G.A. REALTY PRIVATE LIMITED",
"G.A.PROJECTS PRIVATE LIMITED",
"G.A.RANDERIAN PRIVATE LIMITED",
"G.B. CHOWDHURY HOLDINGS PRIVATE. LIMITED.",
"G.B. COTTON INDUSTRIES",
"G.B.PROJECTS AND DEVELOPERS PRIVATE LIMITED",
"G.B.R. ENTERPRISES PRIVATE LIMITED",
"G.C INTERACTIVE PRIVATE LIMITED",
"G.C. CONSTRUCTION AND DEVELOPMENT INDUSTRIES PRIVATE LIMITED",
"G.C. CONSUMER PRODUCTS PRIVATE LIMITED",
"G.C. ELECTRICAL & HVAC PRIVATE LIMITED",
"G.C. FIBRES LIMITED",
"G.C. STEELS (INDIA) PRIVATE LIMITED",
"G.C. THREADS PRIVATE. LIMITED.",
"G.C.ANOOP BAKES AND SNACKS PRIVATE LIMITED",
"G.C.JEWELLERS PRIVATE LIMITED",
"G.C.LEASING & TRADING COMPANY PRIVATE LIMITED",
"G.C.STRIPS LIMITED",
"G.C.T. TOURS & TRAVELS PRIVATE LIMITED",
"G.CORAL GRAPHICS PRIVATE LIMITED",
"G.D. BUILDTECH PRIVATE LIMITED",
"G.D. GOENKA TOURISM CORP.LIMITED",
"G.D. LABORATORIES (INDIA) PRIVATE LIMITED",
"G.D. POWER EQUIPMENTS (I) PRIVATE LIMITED",
"G.D. SADEKAR PRIVATE LIMITED.",
"G.D.BIRLA MEDICAL RESEARCH AND EDUCATION FOUNDATION",
"G.D.DIAMOND INDIA PRIVATE LIMITED",
"G.D.GOENKA HEALTHCARE",
"G.D.GOENKA INDIA LIMITED",
"G.D.M.FOODS PRIVATE LIMITED",
"G.D.SOOT BLOWERS (INDIA) PRIVATE LIMITED",
"G.DAS COMMODITY AND DERIVATIVES BROKER PRIVATE LIMITED",
"G.DASS & SONS (REXINE) PRIVATE LIMITED",
"G.E.S.COLLEGE OF EDUCATION & RESEARCH",
"G.G. ORGANICS PRIVATE LIMITED",
"G.G. PIPES PRIVATE LIMITED",
"G.G. TRONICS INDIA PRIVATE LIMITED",
"G.G.R HOUSING INDIA PRIVATE LIMITED",
"G.G.R. BULLIONS PRIVATE LIMITED",
"G.G.S. INDIA TRADEWINGS PRIVATE LIMITED",
"G.H. AGENCIES PRIVATE LIMITED",
"G.H.P. BUILDCON PRIVATE LIMITED",
"G.I. ENTERPRISES PRIVATE LIMITED",
"G.I. EXPORTS PRIVATE LIMITED",
"G.IDS INFORMATION SYSTEMS PRIVATE LIMITED",
"G.J. MULTI GASES PRIVATE LIMITED",
"G.J.CONSTRUCTION PRIVATE LIMITED",
"G.K. ANAND BROS. BUILDWELL PRIVATE LIMITED",
"G.K. CARS & BIKES PRIVATE LIMITED",
"G.K. LOOMS PRIVATE LIMITED",
"G.K. MOTOCORP PRIVATE LIMITED",
"G.K. MOTORS",
"G.K. PRINTHOUSE PRIVATE LIMITED",
"G.K. RANGWALA & CO. PRIVATE LIMITED",
"G.K. ROLLER FLOUR MILLS PRIVATE LIMITED",
"G.K. ROOFINGS INDIA PRIVATE LIMITED",
"G.K. VENTURES PRIVATE LIMITED",
"G.K. WINDING WIRES LIMITED",
"G.K.DIAMONDS LIMITED",
"G.K.MICRO METALS PVT LTD",
"G.K.SA NUMERRUS HOTELS PRIVATE LIMITED",
"G.K.SHIPPING SERVICES PRIVATE LIMITED",
"G.KUMAR ELECTRO PRIVATE LIMITED",
"G.KUPPUSWAMY NAIDU MEMORIAL HOSPITAL",
"G.L. & SONS (M & P) PRIVATE LIMITED",
"G.L. BAJAJ INSTITUTE OF TECHNOLOGY AND MANAGEMENT",
"G.L. COMMUNICATIONS INDIA PRIVATE LIMITED",
"G.L. GEMS LIMITED",
"G.M MACHINERY TOOLS PRIVATE LIMITED",
"G.M WIRE AND ROPES PRIVATE LIMITED",
"G.M. CHEMIE PRIVATE LIMITED",
"G.M. CONDUCTORS PRIVATE LTD",
"G.M. DALUI & SONS PRIVATE LIMITED",
"G.M. ENGINEERS & FABRICATORS PRIVATE LIMITED",
"G.M. PAPER PRODUCTS COMPANY PRIVATE LIMITED",
"G.M.G. PACK-AIDS PVT LTD",
"G.M.G. PLYWOODS PVT LTD.",
"G.M.P. PROPERTIES PRIVATE LIMITED",
"G.N. COLD STORAGE PRIVATE LIMITED",
"G.N. CYCLES PRIVATE LIMITED",
"G.N. POLYMERS PRIVATE LIMITED",
"G.N. SILK ESTATE PRIVATE LIMITED",
"G.N. VOGUE SALES PRIVATE LIMITED",
"G.P MEDICOS CENTRE PRIVATE. LIMITED",
"G.P TRONICS PRIVATE LIMITED",
"G.P. COMPANY PLYTECH PRIVATE LIMITED",
"G.P. HOUSING PRIVATE LIMITED",
"G.P. MOULDS AND TOOLS PRIVATE LIMITED",
"G.P. PATIL SEC. SCH. KOLGAON",
"G.P. PRODUCTS PRIVATE LIMITED",
"G.P. TRAVELS PRIVATE LIMITED",
"G.P.AGROTECH PRIVATE LIMITED",
"G.P.DESIGNS PRIVATE LIMITED",
"G.P.H.P. HOLDINGS PVT. LTD.",
"G.P.K. ENGINEERING COMPANY PRIVATE LIMITED",
"G.P.PROJECTS LIMITED",
"G.P.S ARTS PRIVATE LIMITED",
"G.P.S. MIGLANI INSURANCE SURVEYORS & LOSS ASSESSORS PRIVATE LIMITED",
"G.R. KRISHNA FERRO ALLOYS PRIVATE LIMITED",
"G.R. MAINTENANCE AND SERVICES LIMITED",
"G.R. WEAVERS PRIVATE LIMITED",
"G.R.BIOURE SURGICAL SYSTEM PRIVATE LIMITED",
"G.R.C.INFRA PRIVATE LIMITED",
"G.R.FABRICS PRIVATE LIMITED",
"G.R.G. STEELS PRIVATE LIMITED",
"G.R.POLYMERS PRIVATE LIMITED",
"G.R.T. ASSOCIATES PRIVATE LIMITED",
"G.RAM BOOKS PRIVATE LIMITED.",
"G.S. AUTO INTERNATIONAL LIMITED",
"G.S. ELECTROCOM PRIVATE LIMITED",
"G.S. ELECTRONICS PRIVATE LIMITED",
"G.S. GEARS INDIA PRIVATE LIMITED",
"G.S. KHURANA MOTORS PRIVATE LIMITED",
"G.S. PAL AUTOWHEELS PRIVATE LIMITED",
"G S S PHARMA PRIVATE LIMITED",
"G.S. PROCON PRIVATE LIMITED",
"G.S. ROLLERS PRIVATE LIMITED",
"G.S. SORTEX (I) PRIVATE LIMITED",
"G.S.DASS APPARELS PRIVATE LIMITED",
"G.S.G.BUILDERS & INFRASTRUCTURE LIMITED",
"G.S.IRON PRIVATE LIMITED",
"G.S.P. ELECTRONICS PRIVATE LIMITED",
"G.S.R. MOTORS PRIVATE LIMITED",
"G.S.ROLLER FLOUR MILLS PRIVATE LIMITED",
"G.S.T. IMPORTS PRIVATE LIMITED",
"G.S.T. STEEL TUBES PRIVATE LIMITED",
"G.S.V. AGRO PRIVATE LIMITED",
"G.S.V. SECURITIES PRIVATE LIMITED",
"G.T. CHAINS PRIVATE LIMITED",
"G.T. CINEMAS PRIVATE LIMITED",
"G.T. FRUITECH PRIVATE LIMITED",
"G.T. JAYANTI AGROCHEM (INDIA) PRIVATE LIMITED",
"G.T. MAGNETICS PRIVATE LIMITED",
"G.T. NOVA EQUIPMENTS PRIVATE LIMITED",
"G.T.B ENCLAVE",
"G.T.B.AGRO CHEMICALS PVT LTD",
"G.T.C. MARKETING PRIVATE LTD.",
"G.T.R. ALUMINIUM PRIVATE LIMITED",
"G.T.REALITY PRIVATE LIMITED",
"G.T.S. EXPORTS PRIVATE LIMITED",
"G.U.D FOOD PRODUCT PRIVATE LIMITED",
"G.V CONTRACTORS PRIVATE LIMITED",
"G.V PRATAP REDDY PRIVATE LIMITED",
"G.V. (GOD VISHNU) RICE EXPORTS PRIVATE LIMITED",
"G.V.S. SPINNERS PRIVATE LIMITED",
"G.VARADAN ENGINEERING PRIVATE LIMITED",
"G:CORP PROPERTIES PRIVATE LIMITED",
"G1 INDUSTRIES GLOBAL PRIVATE LIMITED",
"G1 OFFSHORE & MARINE PRIVATE LIMITED",
"G10 ENTERPRISES PRIVATE LIMITED",
"G10 LOGISTICS PRIVATE LIMITED",
"G1S SECURE SOLUTIONS PRIVATE LIMITED",
"G2 COM INDIA PRIVATE LIMITED",
"G2 HEALTHCARE PRIVATE LIMITED",
"G2 STEEL SERVICES PRIVATE LIMITED",
"G2 TECHNOLOGY SOLUTIONS INDIA PRIVATE LIMITED",
"G2A SERVICES PRIVATE LIMITED",
"G2C PARTNERS",
"G2CS FACILITIES PRIVATE LIMITED",
"G2G ENGINEERING SERVICES PRIVATE LIMITED",
"G2MHUB GLOBAL PRIVATE LIMITED",
"G2S FACILITIES PRIVATE LIMITED",
"G3 MEDIA WORKS PRIVATE LIMITED",
"G3 MEDICAL SYSTEMS PRIVATE LIMITED",
"G3S BUILDERS PRIVATE LIMITED",
"G3S FOODSHALA PRIVATE LIMITED",
"G3S INFRA HOMES PRIVATE LIMITED",
"G4C MANAGEMENT PRIVATE LIMITED",
"G4S CASH SOLUTIONS INDIA PRIVATE LIMITED",
"G4S CORPORATE INDIA PRIVATE LIMITED",
"G4S FACILITY SERVICES INDIA PRIVATE LIMITED",
"G4S IT SERVICES INDIA I PRIVATE LIMITED",
"G4S SECURE SOLUTIONS INDIA PRIVATE LIMITED",
"G4S SECURITY SYSTEMS INDIA PRIVATE LIMITED",
"G5 SWITCHGEAR AND CONTROLS PRIVATE LIMITED",
"G5K PETRO PRODUCTS PRIVATE LIMITED",
"G6 TECHNOLOGY SERVICES INDIA LLP",
"G7 CR TECHNOLOGIES INDIA PRIVATE LIMITED",
"G7 SYNERGON PRIVATE LIMITED",
"G7 TELE SERVICES PRIVATE LIMITED",
"G8 INFOTECH PRIVATE LIMITED",
"G9 FITNESS PRIVATE LIMITED",
"G9 INFRATECH PRIVATE LIMITED",
"G97 NETWORK PRIVATE LIMITED",
"GA DESIGN CONSULTANTS LLP",
"GA DIGITAL WEBWORD PRIVATE LIMITED",
"GA GCC LLP",
"GA INFRA PRIVATE LIMITED",
"GA INSTRUMENTS PRIVATE LIMITED",
"GA SOLUTIONS PRIVATE LIMITED",
"GA TECHNOCARE TECHNOLOGY PRIVATE LIMITED",
"GAADI WEB PRIVATE LIMITED",
"GAAIA CONTRACTORS PRIVATE LIMITED",
"GAAMES MERCHANDISE PRIVATE LIMITED",
"GAANESHKARTIKEY CONSTRUCTION PRIVATE LIMITED",
"GAANGEY MINERALS PRIVATE LIMITED",
"GAARMAN ENTERPRISES PRIVATE LIMITED",
"GABA APPARELS PRIVATE LIMITED",
"GABA GOLDEN CARRIERS PVT. LTD.",
"GABA HOMETEX PRIVATE LIMITED",
"GABA OVERSEAS P LIMITED",
"GABA SANITARY PRIVATE LIMITED",
"GABA TIMES PVT LTD",
"GABATI AHM SENIOR MADRASAH",
"GABBANA FASHIONS PRIVATE LIMITED",
"GABBAR INDUSTRIES PRIVATE LIMITED",
"GABBAR PLASTIC AND PACKAGING MACHINE CO",
"G-ABI ELECTRONICS PRIVATE LIMITED",
"GABION INDUSTRIES PRIVATE LIMITED",
"GABION TECHNOLOGIES INDIA PRIVATE LIMITED",
"GABLE CONSTRUCTION PRIVATE LIMITED",
"GABLES (INDIA) PRIVATE LIMITED",
"GABLES PROMOTERS PRIVATE LIMITED",
"GABON SERAMIK PRIVATE LIMITED",
"GABRIEL INDIA LIMITED",
"GABRIEL VENTURES INDIA PRIVATE LIMITED",
"GABRIEL-BROS INDIA PRIVATE LIMITED",
"GABRIELS TECHNOLOGY SOLUTIONS INDIA PRIVATE LIMITED",
"GABRIL INDUSTRIES PRIVATE LIMITED",
"GABRY ALUMINIUM COMPANY PRIVATE LIMITED",
"GABS INVESTMENTS PRIVATE LIMITED",
"GABS LAB PRIVATE LIMITED",
"GABS MEGACORP LIMITED",
"GAC DIGITAL PRIVATE LIMITED",
"GAC ECOMMERCE PRIVATE LIMITED",
"GAC ENERGY & AUTOMATION PRIVATE LIMITED",
"GAC LOGISTICS PRIVATE LIMITED",
"GAC SHIPPING INDIA PRIVATE LIMITED",
"GACK BILLING SERVICES (OPC) PRIVATE LIMITED",
"GACL FINANCE PRIVATE LIMITED",
"GACL-NALCO ALKALIES & CHEMICALS PRIVATE LIMITED",
"GAD FASHIONS INDIA PRIVATE LIMITED",
"GAD LOGISTICS I PRIVATE LIMITED",
"GAD PANCHAYAT SAMITI SHAHADA",
"GADA & HARIA PRIVATE LIMITED",
"GADA ESTATES PRIVATE LIMITED",
"GADA MARKETING PRIVATE LIMITED",
"GADA OPTICALS PRIVATE LIMITED",
"GADADHAR VANIJYA PRIVATE LIMITED",
"GADAG TRANSMISSION LIMITED",
"GADARWARA PULSES PRIVATE LIMITED",
"GADDAM SREENIVASA HANDLOOM SILK SAREES PRIVATE LIMITED",
"GADFLYZONE INDIA PRIVATE LIMITED",
"GADGEON LIFESTYLE PRIVATE LIMITED",
"GADGEON SMART SYSTEMS PRIVATE LIMITED",
"GADGET BOX RETAIL PRIVATE LIMITED",
"GADGET SOFTWARE INDIA PRIVATE LIMITED",
"GADGETWOOD ESERVICES PRIVATE LIMITED",
"GADGIL HOTELS PRIVATE LIMITED",
"GADHIRAJU CONSTRUCTIONS PRIVATE LIMITED",
"GADHIYA FAB PRIVATE LIMITED",
"GADHPAT TECHNOFAB PRIVATE LIMITED",
"GADHVI HANDLING SERVICES",
"GADIA ALUMINIUM PRIVATE LIMITED",
"GADIA MERCANTILE PRIVATE LIMITED",
"GADIA SAREES PRIVATE LIMITED",
"GADIA STRUCTURALS PRIVATE LIMITED",
"GADIYA FABRICS PRIVATE LIMITED",
"GADIYA MARBLES PRIVATE LIMITED",
"GADIYA PHARMACEUTICALS PRIVATE LIMITED",
"GADRE AQUACULTURE PRIVATE LIMITED",
"GADRE AUTOCON PRIVATE LIMITED",
"GADRE EYE CARE CENTRE",
"GADRE FOODS AND BEVERAGES PRIVATE LIMITED",
"GADRE INFOTECH PRIVATE LIMITED",
"GADRE MARINE EXPORT PRIVATE LIMITED",
"GADS SIGNAGE PRIVATE LIMITED",
"GADSCO INDUSTRIAL ENTERPRISES PRIVATE LIMITED",
"GAE CARGO MOVERS PRIVATE LIMITED",
"GAE IMPEX PRIVATE LIMITED",
"GAE PROJECTS PRIVATE LIMITED",
"GAEA TAX AND MANAGEMENT SERVICES PRIVATE LIMITED",
"GAEA TECHNOLOGIES INDIA PRIVATE LIMITED",
"GAEKWAR ENTERPRISE PRIVATE LIMITED",
"GAEKWAR MILLS LIMITED",
"GAERISH LOGISTICS PRIVATE LIMITED",
"GAF GLOBAL LOGISTICS PRIVATE LIMITED",
"GAFFNEY KROESE SUPPLY INDIA PRIVATE LIMITED",
"GAG INFORMATICS SYSTEMS PRIVATE LIMITED",
"GAGAN AEROSPACE LIMITED",
"GAGAN AGRO AND RICE EXPORTERS",
"GAGAN AUTO LLP",
"GAGAN BUILDTECH LIMITED",
"GAGAN COAL PRIVATE LIMITED",
"GAGAN CREDITS PRIVATE LIMITED",
"GAGAN DEEP SHUTTERING PRIVATE LIMITED",
"GAGAN ENTREPRENEUR PRIVATE LIMITED",
"GAGAN FERROTECH LIMITED",
"GAGAN FIBRES PRIVATE. LIMITED.",
"GAGAN FITNESS WELCARE COMPANY",
"GAGAN FOOD PROCESSORS PRIVATE LIMITED",
"GAGAN GASES LIMITED.",
"GAGAN IMPEX PRIVATE LIMITED",
"GAGAN INFRAENERGY LIMITED",
"GAGAN MEDIA PRIVATE LIMITED",
"GAGAN PATHOLOGY AND IMAGING PRIVATE LIMITED",
"GAGAN PUBLIC SCHOOL",
"GAGAN RESOURCES PVT LTD",
"GAGAN SILK MILLS PVT LTD",
"GAGAN SPICES PRIVATE LIMITED",
"GAGAN TEXTILES PRIVATE LIMITED",
"GAGAN TRADING CO.",
"GAGAN TRADING COMPANY PRIVATE LIMITED TFR. FROM MUMBAI TO DELHI",
"GAGAN TRANSMISSIONS PRIVATE LIMITED",
"GAGAN TRANSPORTS CO PVT LTD",
"GAGAN TREXPO PRIVATE LIMITED",
"GAGAN UDYOG PRIVATE LIMITED",
"GAGAN VASU CINELINKS PRIVATE. LIMITED.",
"GAGAN WAREHOUSE & LOGISTICS PRIVATE LIMITED",
"GAGANBASE VINCOM PVT LTD",
"GAGANDEEP CONSULTANCY PRIVATE LIMITED",
"GAGANDEEP CREDIT CAPITAL PRIVATE LIMITED",
"GAGANDEEP HOTEL AND RESTAURANT PRIVATE LIMITED",
"GAGANDEEP PHOTO LITH PROCESS PVT. LTD.",
"GAGANGIRI EXIMS PRIVATE LIMITED",
"GAGANGIRI HOUSING & INFRASTRUCTURE PRIVATE LIMITED",
"GAGANGIRI PHARMA CHEM PRIVATE LIMITED",
"GAGAR FOODS PRIVATE LIMITED",
"GAGGAR ENTERPRISES PRIVATE LIMITED",
"GAGLERS SOFTWARE PRIVATE LIMITED",
"GAGREE ISPAT PRIVATE LIMITED",
"GAHALOT FARMS PRIVATE LIMITED",
"GAHAN INFRA PRIVATE LIMITED",
"GAHIR AGRO INDUSTRIES LTD",
"GAHLOT AGENCIES PVT LTD",
"GAHLOT ELECTRONICS PRIVATE LIMITED",
"GAHMAR ADMARK SERVICES PRIVATE LIMITED",
"GAI TECHNOLOGIES PRIVATE LIMITED",
"GAIA CONSULTING AND SOLUTION PRIVATE LIMITED",
"GAIA DEVELOPERS PRIVATE LIMITED",
"GAIA INFORMATION TECHNOLOGY ENABLED SERVICES PRIVATE LIMITED",
"GAIA PROPERTIES AND INFRASTRUCTURE INDIA PRIVATE LIMITED",
"GAIA SMART CITIES SOLUTIONS PRIVATE LIMITED",
"GAIADIGITAL DESIGN PRIVATE LIMITED",
"GAIAGEN TECHNOLOGIES PRIVATE LIMITED",
"GAIAN SOLUTIONS INDIA PRIVATE LIMITED",
"GAIANYA DESIGNS PRIVATE LIMITED",
"GAIASYS PRIVATE LIMITED",
"GAIDU ELECTRICALS PRIVATE LIMITED",
"GAIJ FOOTWEAR PRIVATE LIMITED",
"GAIKAN MULTI SERVICES PRIVATE LIMITED",
"GAIKWAD ENTERPRISES PRIVATE LIMITED",
"GAIL GAS LIMITED",
"GAIL INDIA LIMITED",
"GAIN CAPITAL PRIVATE LIMITED",
"GAIN INFOSYSTEMS PRIVATE LIMITED",
"GAIN THEORY CONSULTING PRIVATE LIMITED",
"GAINAGAIN INFRASTRUCTURE PRIVATE LIMITED",
"GAINFUL INVESTMENTS AND ADVISORS PRIVATE LIMITED",
"GAINING GROUND INVESTMENT SERVICES PRIVATE LIMITED",
"GAININSIGHTS SOLUTIONS PRIVATE LIMITED",
"GAINMAX FERROCAST PRIVATE LIMITED",
"GAINSIGHT SOFTWARE PRIVATE LIMITED",
"GAINT LOGISTIC PRIVATE LIMITED",
"GAINTEXTILE PRIVATE LIMITED",
"GAINUP INDUSTRIES INDIA PRIVATE LIMITED",
"GAINWELL COMMOSALES PRIVATE LIMITED",
"GAIT NAURISH (INDIA) LIMITED",
"GAITONDE LEATHERS AND ACCESSORIES PRIVATE LIMITED",
"GAJ ALLOYS PRIVATE LIMITED",
"GAJ CONSTRUCTIONS PRIVATE LIMITED",
"GAJ KESARI POLYMERS PRIVATE LIMITED",
"GAJA ALTERNATIVE ASSET MANAGEMENT PRIVATE LIMITED",
"GAJA CORPORATE ADVISORS PRIVATE LIMITED",
"GAJA ENGINEERING PRIVATE LIMITED",
"GAJA STEEL PRO PRIVATE LIMITED",
"GAJAANANDA JEWELLERY MART INDIA PRIVATE LIMITED",
"GAJALAXMI BUSINESS ENTERPRISES PRIVATE LIMITED",
"GAJALAXMI CONSTRUCTION PRIVATE LIMITED",
"GAJALAXMI FOOD & RICE PROCESSING PVT LTD",
"GAJALAXMI TRADING PRIVATE LIMITED",
"GAJAM INDIA PRIVATE LIMITED",
"GAJANAN & SONS FIRE SAFETY PRIVATE LIMITED",
"GAJANAN AGRO FEEDS PRIVATE LIMITED",
"GAJANAN AGRO FOODS PRIVATE LIMITED",
"GAJANAN APPLIANCES PRIVATE LIMITED",
"GAJANAN AUTOMOBILES PRIVATE LIMITED",
"GAJANAN AUTOMOTIVE (SATARA) PRIVATE LIMITED",
"GAJANAN BAUXITE PRIVATE LIMITED",
"GAJANAN CONSTRUCTION PRIVATE LIMITED",
"GAJANAN DIGITAL CABLE SERVICES PRIVATE LIMITED",
"GAJANAN EXTRACTION LIMITED",
"GAJANAN FERRO PRIVATE LIMITED",
"GAJANAN FOOTCARE INDIA PRIVATE LIMITED",
"GAJANAN HOME DECOR PRIVATE LIMITED",
"GAJANAN INFRA ENGINEERING PRIVATE LIMITED",
"GAJANAN IRON AND STEEL (INDIA) PRIVATE LIMITED",
"GAJANAN IRON PRIVATE LIMITED",
"GAJANAN ISPAT PRIVATE LIMITED",
"GAJANAN MINCHEM PRIVATE LIMITED",
"GAJANAN MINERALS PRIVATE LIMITED",
"GAJANAN ORES PRIVATE LIMITED",
"GAJANAN OVERSEAS PRIVATE LIMITED",
"GAJANAN PACKWELL PRIVATE LIMITED",
"GAJANAN POLYPLAST PRIVATE LIMITED",
"GAJANAN PUMPS AND SYSTEMS PRIVATE LIMITED",
"GAJANAN REALCON PRIVATE LIMITED",
"GAJANAN REFRACTORY PRIVATE LIMITED",
"GAJANAN TAMRA INDUSTRIES PRIVATE LIMITED",
"GAJANAN TECHNICAL SERVICES",
"GAJANAN TRADECOM PRIVATE LIMITED",
"GAJANAN TUBES PVT LTD",
"GAJANANA MENS WEAR PRIVATE LIMITED",
"GAJANAND CREATION PRIVATE LIMITED",
"GAJANAND FOODS PRIVATE. LIMITED.",
"GAJANAND FOODS PVT LTD",
"GAJANAND GINNING AND PRESSING PRIVATE LIMITED",
"GAJANAND INTERNATIONAL LIMITED",
"GAJANAND MOTORS PRIVATE LIMITED",
"GAJANAND RICE MILLS",
"GAJANAND ROCKS PRIVATE LIMITED",
"GAJANAND SUNDERLAL PRIVATE LIMITED",
"GAJANAND TRADERS PRIVATE LIMITED",
"GAJANAND TRADES AND TRANSPORTS PRIVATE LIMITED",
"GAJANAND UDYOG PVT LTD",
"GAJANANSAI FARMER PRODUCER COMPANY LIMITED",
"GAJAVELLI SPINNING MILLS PRIVATE LIMITED",
"GAJBALA ECO FRIENDLY PRIVATE LIMITED",
"GAJ-CHANDRA POLYMERS PRIVATE LIMITED",
"GAJDANTI INDUSTRIAL INVESTMENT PRIVATE LIMITED",
"GAJENDER INFRATECH PRIVATE LIMITED",
"GAJENDRA FINVEST PVT LTD",
"GAJENDRA MERCANTILES PVT LTD",
"GAJERA GLOBAL SCHOOL",
"GAJGAMINI INVESTMENTS AND FINANCE PRIVATE LIMITED",
"GAJGANPATI FABRICS PRIVATE LIMITED",
"GAJGATI STEEL AND ENERGY PRIVATE LIMITED",
"GAJIWALA SAREES",
"GAJJAN MAJRA FEED LIMITED",
"GAJJAR COMPRESSORS PRIVATE LIMITED",
"GAJJAR EQUIPMENTS PRIVATE LIMITED",
"GAJJAR VENTURE PRIVATE LIMITED",
"GAJKESARI STEELS AND ALLOYS PRIVATE LIMITED",
"GAJLAXMI CONCRETES PRIVATE LIMITED",
"GAJLAXMI STEEL PRIVATE LIMITED",
"GAJLAXMI STEEL PRIVATE. LIMITED.",
"GAJMAL TULSHIRAM PATIL ARTS COMMERCE SCIENCE COLLEGE NANDURBAR",
"GAJMATTIA INFRASTRUCTURE PRIVATE LIMITED",
"GAJMUKH VINIMAY PRIVATE LIMITED",
"GAJRA DIFFERENTIAL GEARS LIMITED",
"GAJRA GLASSFIBRE PRIVATE LIMITED",
"GAJRA HOME MAKERS PRIVATE LIMITED",
"GAJRA RAJA MEDICAL COLLEGE GWALIOR",
"GAJRAJ AUTOMOBILES PRIVATE LIMITED",
"GAJRAJ COTSPIN PRIVATE LIMITED",
"GAJRAJ FLOUR MILL",
"GAJRAJ INDIA PRIVATE LIMITED",
"GAJRAJ JEWELLERS (OPC) PRIVATE LIMITED",
"GAJRAJ MINING PRIVATE. LIMITED.",
"GAJRAJ TEXTILES PRIVATE LIMITED",
"GAJRAJ VAHAN PRIVATE LIMITED",
"GAJRAJ WILDLIFE RESORTS PRIVATE LIMITED",
"GAJRAJA SOYA EXTRACTIONS PRIVATE. LIMITED.",
"GAJRAULA ROLLER FLOUR MILLS PRIVATE LIMITED",
"GAURIK SOUTH PRIVATE LIMITED",
"GAJSHIELD INFOTECH INDIA PRIVATE LIMITED",
"GAJUMAL MULCHAND FRUITS PRIVATE LIMITED",
"GAJURMUKHI TRADE SERVICES PRIVATE LIMITED",
"GAJUWAKA HOSPITALS PRIVATE LIMITED",
"GAJUWAKA PHARMACEUTICALS PRIVATE LIMITED",
"GAJVAKRA REALTY PRIVATE LIMITED",
"GAK E SOLUTION PRIVATE LIMITED",
"GAK EXCHANGE INDIA SERVICES PRIVATE LIMITED",
"GAK FARMS PRIVATE LIMITED",
"GAK PLAST CONTAINERS PRIVATE LIMITED",
"GAKHAL FITNESS STATION PRIVATE LIMITED",
"GAKHAR SALES PRIVATE LIMITED",
"GAL ALUMINIUM EXTRUSION PRIVATE LIMITED",
"GAL AVIATION SOLUTIONS PRIVATE LIMITED",
"GAL CARE PHARMACEUTICALS PRIVATE LIMITED",
"GAL COTTEX PRIVATE LIMITED",
"GAL INTERNATIONAL LIMITED",
"GALA ALUPLAST PRIVATE LIMITED",
"GALA BRUSH LIMITED",
"GALA FOODS PVT LTD",
"GALA GLOBAL PRODUCTS LIMITED",
"GALA INFRASTRUCTURE PRIVATE LIMITED",
"GALA LANDMARKS PRIVATE LIMITED",
"GALA LEASING AND FINANCE PRIVATE LIMITED",
"GALA MARKETING INDIA PRIVATE LIMITED",
"GALA PRECISION ENGINEERING LIMITED",
"GALA PRECISION ENGINEERING PRIVATE. LIMITED.",
"GALA PRINT CITY LIMITED",
"GALA PROJECTS LLP",
"GALA SPRINGS PRIVATE LIMITED",
"GALACON INFRASTRUCTURE AND PROJECTS PRIVATE LIMITED",
"GALACTIC ELECTRIC PRIVATE LIMITED",
"GALACTIC HOSPITALITIES",
"GALACTICO CORPORATE SERVICES LIMITED",
"GALACUS HEALTHCARE PRIVATE LIMITED",
"GALANI AGRO PRIVATE LIMITED",
"GALANI DEVELOPERS PRIVATE LIMITED",
"GALANTA ALMAS PRIVATE LIMITED",
"GALASSI & ORTOLANI INDIA PRIVATE LIMITED",
"GALATA CHEMICALS INDIA PRIVATE LIMITED",
"GALATTA MEDIA PRIVATE LIMITED",
"GALAX ACCRUE TECH PRIVATE LIMITED",
"GALAX E SOLUTIONS INDIA PRIVATE LIMITED",
"GALAXIE AGRITECH PRIVATE LIMITED",
"GALAXKEY INDIA PRIVATE LIMITED",
"GALAXMIAL PREDERA COMMUNICATION PRIVATE LIMITED",
"GALAXUS PHARMACEUTICALS",
"GALAXY",
"GALAXY AGRICO EXPORTS LIMITED",
"GALAXY AGROSPECIALITY PRIVATE LIMITED",
"GALAXY ALLOYS PRIVATE LIMITED",
"GALAXY ALUMINIUM INDUSTRIES PRIVATE LIMITED",
"GALAXY ASHIANA PRIVATE LIMITED",
"GALAXY AUTOMOBILES",
"GALAXY AUTOMOBILES PRIVATE LIMITED",
"GALAXY AVIATION PRIVATE LIMITED",
"GALAXY BEARINGS LIMITED",
"GALAXY BHOPAL VEHICLES PRIVATE LIMITED",
"GALAXY BOXES PRIVATE LIMITED",
"GALAXY BUILDCON",
"GALAXY BUILDCON PRIVATE LIMITED",
"GALAXY CARE MULTISPECIALITY HOSPITAL PRIVATE LIMITED",
"GALAXY CARGO SERVICES (INDIA) LLP",
"GALAXY CHAINS PRIVATE LIMITED",
"GALAXY CLOUD KITCHENS LIMITED",
"GALAXY COMMERCIAL LIMITED",
"GALAXY COMPONENTS PVT LTD",
"GALAXY COMPUTECH PRIVATE LIMITED",
"GALAXY CONCAB INDIA PRIVATE LIMITED",
"GALAXY CONVEYORS PRIVATE LIMITED",
"GALAXY CROP CARE PRIVATE LIMITED",
"GALAXY DIAMONDS (INDIA) PRIVATE LIMITED",
"GALAXY DIESEL PRIVATE LIMITED",
"GALAXY DREAM HOME DEVELOPERS PRIVATE LIMITED",
"GALAXY ELEGANT FASHIONS P L",
"GALAXY ENCLAVE PRIVATE LIMITED",
"GALAXY ENTERTAINMENT CORPORATION LIMITED",
"GALAXY EXPORTS PRIVATE LIMITED",
"GALAXY FOOD INDUSTRIES PRIVATE LIMITED",
"GALAXY FOOTWEARS PRIVATE LTD.",
"GALAXY FORMS LIMITED.",
"GALAXY FREIGHT PRIVATE LIMITED",
"GALAXY GLASS PRODUCTS PRIVATE LIMITED",
"GALAXY GLOBAL PRIVATE LIMITED",
"GALAXY GRANITES PRIVATE LIMITED",
"GALAXY HEART INSTITUTE MEHSANA",
"GALAXY HOMES PRIVATE LIMITED",
"GALAXY HOSPITAL",
"GALAXY ICE IND PRIVATE LIMITED",
"GALAXY IEC INDIA PRIVATE LIMITED",
"GALAXY INDICATORS INDIA PRIVATE LIMITED",
"GALAXY INDUSTRIAL EQUIPMENTS PRIVATE LIMITED",
"GALAXY INDUSTRIAL SERVICES PRIVATE LIMITED",
"GALAXY INFOSERV PRIVATE LIMITED",
"GALAXY INFOSYSTEMS PRIVATE LIMITED",
"GALAXY INFRA & ENGINEERING PRIVATE LIMITED",
"GALAXY INFRA CREATIONS PRIVATE LIMITED",
"GALAXY INFRACON",
"GALAXY INSTRUMENTS PVT LTD",
"GALAXY INTELLIGENTIA PRIVATE LIMITED",
"GALAXY INTERNATIONAL REALTECH PRIVATE LIMITED",
"GALAXY INTERVENTIONS PRIVATE LIMITED",
"GALAXY LABORATORIES PRIVATE LIMITED",
"GALAXY LIFE CARE SERVICES PRIVATE LIMITED",
"GALAXY LIFESTYLE PRIVATE LIMITED",
"GALAXY LIGHTING SYSTEMS PRIVATE LIMITED",
"GALAXY LUBE INDIA PRIVATE LIMITED",
"GALAXY MACHINERY PRIVATE LIMITED",
"GALAXY MAGNUM INFRAHEIGHTS LIMITED",
"GALAXY MALL PRIVATE LIMITED",
"GALAXY MEDICARE LTD",
"GALAXY MICA PRIVATE LIMITED",
"GALAXY MINING AND ROYALTIES PRIVATE LIMITED",
"GALAXY MINING PRIVATE LIMITED",
"GALAXY MOLDPLAST PRIVATE LIMITED",
"GALAXY MULTISPECIALITY HOSPITAL",
"GALAXY OFFICE AUTOMATION PVT LTD",
"GALAXY OFFSET INDIA PRIVATE LIMITED",
"GALAXY ONCOLOGY ASSOCIATES PRIVATE LIMITED",
"GALAXY ONLINE POWER SYSTEMS PRIVATE LIMITED",
"GALAXY ORNATE CREATION PRIVATE LIMITED",
"GALAXY PACKING INDUSTRY PRIVATE LIMITED",
"GALAXY PACKTECH PRIVATE LIMITED",
"GALAXY PAPERS PRIVATE LIMITED",
"GALAXY PHARMA & HEALTHCARE PRIVATE LIMITED",
"GALAXY PIGMENTS PRIVATE LIMITED",
"GALAXY PLYWOOD INDUSTRIES PRIVATE LIMITED",
"GALAXY PRINT PROCESS PRIVATE LIMITED",
"GALAXY PROCESS AUTOMATION PRIVATE LIMITED",
"GALAXY RATLAM VEHICLES PRIVATE LIMITED",
"GALAXY REAL ESTATE DEVELOPERS (GUJ) PRIVATE LIMITED",
"GALAXY REAL ESTATE DEVELOPERS AND BUILDERS PRIVATE LIMITED",
"GALAXY REALMART PRIVATE LIMITED",
"GALAXY REFINERY PRIVATE LIMITED",
"GALAXY RICE INDUSTRIES PRIVATE LIMITED",
"GALAXY RISK INSURANCE BROKERS PRIVATE LIMITED",
"GALAXY ROOFING INDIA PRIVATE LIMITED",
"GALAXY SCALES & SYSTEMS PRIVATE LIMITED",
"GALAXY SECURITY AND MENPOWER SERVICES PRIVATE LIMITED",
"GALAXY SIVTEK PRIVATE LIMITED",
"GALAXY SOLAR ENERGY PRIVATE LIMITED",
"GALAXY SPORTS SHOE CO PRIVATE LIMITED",
"GALAXY SQUARE PRIVATE LIMITED",
"GALAXY STAMPING PRIVATE LIMITED",
"GALAXY STONEMART PRIVATE LIMITED",
"GALAXY SUPERSPECIALITY HOSPITAL",
"GALAXY SUPERSPECIALITY HOSPITAL AND HEALTHCARE PRIVATE LIMITED",
"GALAXY SURFACTANTS LIMITED",
"GALAXY SURFACTANTS LTD",
"GALAXY SYNERGY PRIVATE LIMITED",
"GALAXY TAPS PRIVATE LIMITED",
"GALAXY TECHNO PROJECTS PRIVATE LIMITED",
"GALAXY TECHNOFORGE (INDIA) PRIVATE LIMITED",
"GALAXY THERMO PLAST PRIVATE LIMITED",
"GALAXY TILES PRIVATE LIMITED",
"GALAXY TOOLS PPRIVATE LIMITED",
"GALAXY TRACOM PVT LTD",
"GALAXY TRICHY AIR PRIVATE LIMITED",
"GALAXY VENTURES PVT LTD",
"GALAXY WEBLINKS LIMITED",
"GALAXYFRESH PRIVATE LIMITED",
"GALAXYHITECH ENGINEERS PRIVATE LIMITED",
"GALAXYSTAR PHARMA DISTRIBUTORS PRIVATE LIMITED",
"GALAXYVIEW HOTEL PRIVATE LIMITED",
"GALAXYWING IT SOLUTION",
"GALBEANER INSTITUTE",
"GALBRAITH SHIPPING SERVICES INDIA PRIVATE LIMITED",
"GALBRO ISPAT GALVANISERS PRIVATE LIMITED",
"GALCO EXTRUSIONS PRIVATE LIMITED",
"GALCO INDUSTRIES PRIVATE LIMITED",
"GALCON ENGINEERING PRIVATE LIMITED",
"GALDERMA INDIA PRIVATE LIMITED",
"GALE CREATIVE AGENCY PRIVATE LIMITED",
"GALE SOLARFARMS LIMITED",
"GALENA METALS PRIVATE LIMITED",
"GALENA SERVICES PRIVATE LIMITED",
"GALENTIC PHARMA INDIA PRIVATE LIMITED",
"GALENTIC TECHNOLOGIES PRIVATE LIMITED",
"GALESTORM DISTILLERY PRIVATE LIMITED",
"GALFAN ENGINEERS PRIVATE LIMITED",
"GALFAR ENGINEERING & CONTRACTING INDIA PRIVATE LIMITED",
"GALGOTIA PUBLICATIONS PRIVATE LIMITED",
"GALGOTIA UNIVERSITY",
"GALGOTIAS COLLEGE OF ENGINEERING & TECH",
"GALGOTIAS HOTELS AND RESORTS PRIVATE LIMITED",
"GALGOTIAS UNIVERSITY",
"GALIAKOTWALA ENGINEERING COMPANY PRIVATE LIMITED",
"GALIFE & STILE BRANDS PRIVATE LIMITED",
"GALILEI SOLAR INDIA PRIVATE LIMITED",
"GALILEO INDIA PRIVATE. LIMITED",
"GALILEO S R L",
"GALINA CONSULTANCY SERVICES PRIVATE LIMITED",
"GALIPOGLU HIDROMAS INDIA MANUFACTURING PRIVATE LIMITED",
"GALITOS RESTAURANTS PRIVATE LIMITED",
"GALLAGHER AND MOHAN PRIVATE LIMITED",
"GALLAGHER CENTER OF EXCELLENCE",
"GALLAGHER INSURANCE BROKERS PRIVATE LIMITED",
"GALLAGHER SECURITY PRIVATE LIMITED",
"GALLAGHER SERVICE CENTER LLP",
"GALLANT 7 GUARDING INDIA PRIVATE LIMITED",
"GALLANT GRANITES PRIVATE LIMITED",
"GALLANT INTELLIGENCE SERVICE PRIVATE LIMITED",
"GALLANT SPORTS & INFRA PRIVATE LIMITED",
"GALLANTRY INDUSTRIAL INDIA PRIVATE LIMITED",
"GALLANTT INDUSTRY PRIVATE LIMITED",
"GALLANTT ISPAT LIMITED",
"GALLANTT METAL LIMITED",
"GALLANTT UDHYOG PRIVATE LIMITED",
"GALLANTT UDYOG LIMITED",
"GALLARD STEEL LIMITED",
"GALLARDO APPLIANCES PRIVATE LIMITED",
"GALLARI CREATIONS PRIVATE LIMITED",
"GALLAY INDIA PRIVATE LIMITED",
"GALLBERRY LIFE SCIENCES PRIVATE LIMITED",
"GALLENT SECURITY SERVICES PRIVATE LIMITED",
"GALLEON ALUMINIUM EXTRUSIONS PRIVATE LIMITED",
"GALLEON INSTRU-TECH PRIVATE LIMITED",
"GALLERI5 TECHNOLOGIES PRIVATE LIMITED",
"GALLERIA DI LUX PRIVATE LIMITED",
"GALLERIA PROPERTY MANAGEMENT SERVICES PRIVATE LIMITED",
"GALLESSIA GLOBAL FASHIONS PRIVATE LIMITED",
"GALLEU HILL RESORTS PVT LTD",
"GALLIARD FREIGHT SOLUTIONS PRIVATE LIMITED",
"GALLICTRANS CARGO LOGISTICS PRIVATE LIMITED",
"GALLINA INDIA PRIVATE LIMITED",
"GALLIUM EQUIPMENT PRIVATE LIMITED",
"GALLIUM MECHATRONICS PRIVATE LIMITED",
"GALLON BUILDERS INDIA PRIVATE LIMITED",
"GALLOP ESTATES PRIVATE LIMITED",
"GALLOPS AUTOHAUS PRIVATE LIMITED",
"GALLOPS AUTOLINK PRIVATE LIMITED",
"GALLOPS AUTOMOBILES PRIVATE LIMITED",
"GALLOPS AUTOMOTIVE PRIVATE LIMITED",
"GALLOPS ENGINEERING PRIVATE LIMITED",
"GALLOPS GALVANIZING PRIVATE LIMITED",
"GALLOPS MOTORS PRIVATE LIMITED",
"GALLUP INDIA PRIVATE LIMITED",
"GALO ENERGY PRIVATE LIMITED",
"GALORE FACILITY & PROTECTION PRIVATE LIMITED",
"GALORE FOODS PRIVATE LIMITED",
"GALORE NETWORKS PRIVATE LIMITED",
"GALOREKART MARKETPLACE PRIVATE LIMITED",
"GALPHA LABORATORIES LIMITED",
"G-ALPHA RESINS PRIVATE LIMITED",
"GALSTAR ENGINEERING PRIVATE LIMITED",
"GALTA INTERNATIONAL PRIVATE LIMITED",
"GALTECH INFOSOLUTIONS PRIVATE LIMITED",
"GALTEX COATINGS PRIVATE LIMITED",
"GALTRON ELECTROMEDICAL PRIVATE LIMITED",
"GALUKU EXPORTS (INDIA) PRIVATE LIMITED",
"GALUNDIA TEXTILES PVT LTD",
"GALVA DECO PARTS PRIVATE LIMITED",
"GALVALINNE INDUSTRIES PRIVATE LIMITED",
"GALVANO CASTINGS PRIVATE. LIMITED.",
"GALVANO INDIA PRIVATE. LIMITED.",
"GALVANO STRUCTURES INDIA PVT LTD",
"GALVANO TRACK SOLUTIONS PRIVATE LIMITED",
"GALVANOTEK INDUSTRIES PVT LTD",
"GALVAWIRE AGENCIES PRIVATE LIMITED",
"GALVESTON HEALTHCARE PRIVATE LIMITED",
"GALVI ENGINEERING PRIVATE LIMITED",
"GALVIN MARKETING SOLUTIONS PRIVATE LIMITED",
"GALVO FAB ENGINEERS PRIVATE LIMITED",
"GALWALIA ISPAT UDYOG LIMITED",
"GALWAN AGRI INDIA PRIVATE LIMITED",
"GALYTIX ANALYTICS PRIVATE LIMITED",
"GAM PAS PLASTECH PRIVATE LIMITED",
"GAMA CORPORATE VENTURES PRIVATE LIMITED",
"GAMA FACILITY MANAGEMENT PRIVATE LIMITED",
"GAMA GUARD SERVICES PRIVATE LIMITED",
"GAMA INFRAPROP PRIVATE LIMITED",
"GAMA NEON SIGNS PRIVATE LIMITED",
"GAMA ORGANOMED PLUS PRIVATE LIMITED",
"GAMAINMENT SOLUTIONS (OPC) PRIVATE LIMITED",
"GAMAN HEALTH CARE PRIVATE LIMITED",
"GAMAN MULTISPECIALITY HOSPITALS PRIVATE LIMITED",
"GAMANA SOLUTIONS LLP",
"GAMANI ENGINEERING PRIVATE LIMITED",
"GAMAPP SPORTSWIZZ TECH PRIVATE LIMITED",
"GAMARAM SYNTHETICS PVT LTD",
"GAMASHIP INFO TECH PRIVATE LIMITED",
"GAMATA BIOGREENERY AQUA ENGINEERING PRIVATE LIMITED",
"GAMBHIR COLD STORAGE PRIVATE LIMITED",
"GAMBHIRA KUMAR PRIMARY SCHOOL",
"GAMBIT LEASING AND FINANCE PRIVATE LIMITED",
"GAMBIT SPORTS PRIVATE LIMITED",
"GAME BABA",
"GAME CHANGERS TEXFAB PRIVATE LIMITED",
"GAME ON SPORTS MANAGEMENT PRIVATE LIMITED",
"GAME PLAN SPORTS PRIVATE LIMITED",
"GAMEADZONE PRIVATE LIMITED",
"GAMEANAX STUDIO PRIVATE LIMITED",
"GAMEBERRY LABS PRIVATE LIMITED",
"GAMECHANGER BUSINESS SERVICES (I) PRIVATE LIMITED",
"GAMEDIA PRIVATE. LIMITED",
"GAMENEXA STUDIOS PRIVATE LIMITED",
"GAMEOPEDIA DATA SOLUTIONS PRIVATE LIMITED",
"GAMES2WIN INDIA PRIVATE LIMITED",
"GAMESFLY TECHNOLOGIES PRIVATE LIMITED",
"GAMESHASTRA SOLUTIONS PRIVATE LIMITED",
"GAMETE PHARMA PRIVATE LIMITED",
"GAMETION TECHNOLOGIES PRIVATE LIMITED",
"GAMI AND SATYAM VENTURES PRIVATE LIMITED",
"GAMISONS & BARVADIYA REALTY PRIVATE LIMITED",
"GAMIX LABS PRIVATE LIMITED",
"GAMLAA BIOSCAPES PRIVATE LIMITED",
"GAMMA AGRO-MEDICAL PROCESSINGS PRIVATE LIMITED",
"GAMMA CAE TECHNOLOGIES PRIVATE LIMITED",
"GAMMA COATINGS PRIVATE LIMITED",
"GAMMA CONSTRUCTIONS PRIVATE LIMITED",
"GAMMA CORPORATE SERVICES PRIVATE LIMITED",
"GAMMA GAANA LIMITED",
"GAMMA GREEN POWER PRIVATE LIMITED",
"GAMMA IRON INDIA LIMITED",
"GAMMA MARINE TRAINING INSTITUTE PRIVATE LIMITED",
"GAMMA MOBILE (INDIA) PRIVATE LIMITED",
"GAMMA PIZZAKRAFT (OVERSEAS) PRIVATE LIMITED",
"GAMMA PIZZAKRAFT PRIVATE LIMITED",
"GAMMA PROCESS HUB INDIA LIMITED",
"GAMMA ROTORS PRIVATE LIMITED",
"GAMMA TECHNOPLAST PRIVATE LIMITED",
"GAMMA TRADE LINKS PRIVATE LIMITED",
"GAMMAVISION DIAGNOSTICS PRIVATE LIMITED",
"GAMMEL MUNK PRIVATE LIMITED",
"GAMMON ENGINEERS AND CONTRACTORS PRIVATE LIMITED",
"GAMMON ROAD INFRASTRUCTURE LIMITED",
"GAMO FORGINGS PRIVATE LIMITED",
"GAMOOGA SOFTWARE PRIVATE LIMITED",
"GAMP TECHNOLOGIES PRIVATE LIMITED",
"GAMPA ALCOATS LIMITED",
"GAMS IMPEX PRIVATE LIMITED",
"GAMSON INDIA PRIVATE LIMITED",
"GAMUDA-WCT (INDIA) PRIVATE LIMITED",
"GAMUT BUILDCON PRIVATE LIMITED",
"GAMUT ELECTRONICS PRIVATE LIMITED",
"GAMUT INFOSYSTEMS LIMITED",
"GAMUT READY MIX CONCRETE PRIVATE LIMITED",
"GAMUT TECHNOLOGIES PRIVATE LIMITED",
"GAMYA VISION",
"GAMZEN INFRASTRUCTURE PRIVATE LIMITED",
"GAMZEN PLAST PRIVATE LIMITED",
"GAN LAX EXPORT HOUSE PRIVATE LIMITED",
"GAN SAGAR PUBLIC SCHOOL",
"GAN STUDIO PRIVATE LIMITED",
"GANA OUTSOURCING PRIVATE LIMITED",
"GANA YANTRIKA ENTERPRISES PRIVATE LIMITED",
"GANADHAR INFRA DEVELOPERS PRIVATE LIMITED",
"GANADHI PATI CONSTRUCTION PRIVATE LIMITED",
"GANADHIPATI INFRAPROJECT PRIVATE LIMITED",
"GANADHIPATI PURUSOTTAM SHEKHAWATI EDUCATION FOUNDATION",
"GANADIPATHY TULSI'S JAIN ENGINEERING COLLEGE",
"GANAPALAI PROPERTIES PVT.LTD.",
"GANAPATH QUARRY PRIVATE LIMITED",
"GANAPATHI GARMENTS LIMMITTED",
"GANAPATHI POLYMATS PRIVATE LIMITED",
"GANAPATHI STONE CRUSHERS PRIVATE LIMITED",
"GANAPATHY GRANITE IMPEX PRIVATE LIMITED",
"GANAPATI AGRO PRODUCTS PRIVATE LIMITED",
"GANAPATI ALUMINIUM INDUSTRIES PRIVATE LIMITED",
"GANAPATI BIO- TECH LIMITED",
"GANAPATI BUILDERS LIMITED",
"GANAPATI CHEMISYS LIMITED",
"GANAPATI FISHING LINE PRIVATE LIMITED",
"GANAPATI INDIA INTERNATIONAL PRIVATE LIMITED",
"GANAPATI JEWELLERS CRAFTS PRIVATE LIMITED",
"GANAPATI LEATHER PRODUCTS PRIVATE LIMITED",
"GANAPATI PARKS LIMITED",
"GANAPATI PIPES & INDUSTRIES PRIVATE LIMITED",
"GANAPATI SILK MILLS LTD",
"GANAPATI VILLA MANSION PRIVATE LIMITED",
"GANAPATI WAREHOUSE PRIVATE LIMITED",
"GANATECH SYSTEMS PRIVATE LIMITED",
"GANATRA INVESTMENT HOLDINGS PRIVATE LIMITED",
"GANATRA TERMINALS PRIVATE LIMITED",
"GANBAK FOOD PRODUCTS AND EXPORTS PRIVATE LIMITED",
"GANDALF IT SERVICES LLP",
"GANDARAM AND SONS JEWELLERS PRIVATE LIMITED",
"GANDEVIKAR JEWELLERS PVT LTD",
"GANDHALIKAR AGROTECH PRIVATE LIMITED",
"GANDHAR OIL REFINERY INDIA LIMITED",
"GANDHAR SHIPPING & LOGISTIC PRIVATE LIMITED",
"GANDHAR SILK MILLS PRIVATE LIMITED",
"GANDHARV LAND AND FINANCE PVT LTD",
"GANDHARV SHIKSHARTH EDUCATIONAL CHARITABLE TRUST",
"GANDHARVA ENGINEERS PRIVATE LIMITED",
"GANDHARVA INFRASTRUCTURE AND PROJECTS LIMITED",
"GANDHARVI BUILDERS PRIVATE LIMITED",
"GANDHEKAR ELECTRICALS PRIVATE LIMITED",
"GANDHI AGRO SEEDS PRIVATE LIMITED",
"GANDHI ASSOCIATS",
"GANDHI AUTOMATIONS PRIVATE LIMITED",
"GANDHI BADHIR MAHAVIDHYALAYA",
"GANDHI BAFNA CONSTRUCTION PRIVATE LIMITED",
"GANDHI CANVAS PRIVATE LIMITED",
"GANDHI COLONY MADHAYMIK VIDHYALA",
"GANDHI DEGREE COLLEGE",
"GANDHI ESTATE PRIVATE LIMITED",
"GANDHI EYE HOSPITAL",
"GANDHI HERBAL INDIA PRIVATE LIMITED",
"GANDHI HIGHER SECONDARY SCHOOL",
"GANDHI HOSPITAL",
"GANDHI INSTITUTE OF TECHNOLOGY MANAGEM",
"GANDHI INTER COLLEGE SHAHI BAREILLY",
"GANDHI MEDICAL COLLEGE",
"GANDHI NATURE CURE COLLEGE",
"GANDHI NIKETAN JHS GEHTOLI NIRMAL",
"GANDHI REALTY (INDIA) PRIVATE LIMITED",
"GANDHI REFRACTORIES PRIVATE LIMITED",
"GANDHI SECURITIES AND INVESTMENT PRIVATE LIMITED",
"GANDHI SMARAK INT COLL JAINGARA AGRA",
"GANDHI SPECIAL TUBES LIMITED",
"GANDHI SPICES PRIVATE LIMITED",
"GANDHI VIDYALAYA INTER COLLEGE",
"GANDHIDHAM DEVELOPERS PRIVATE LIMITED",
"GANDHIDHAM JAIN SEVA SAMITI",
"GANDHIDHAM SPINNING AND MANUFACTURING COMPANY LIMITED",
"GANDHINAGAR DISTRICT CO OPERATIVE MILK PRODUCERS UNION LTD",
"GANDHINAGAR DISTRICT PRIM EDU BOARD",
"GANDHINAGAR ELECTRONICS ZONE INDUSTRIES ASSOCIATION",
"GANDHINAGAR HOSPITAL",
"GANDHINAGAR HOSPITALITIES PRIVATE LIMITED",
"GANDHINAGAR HOTELS LIMITED",
"GANDHINAGAR INTERNATIONAL PUBLIC SCHOOL",
"GANDHINAGAR JILLA SHIKSHAN SAMITI PAY CENTRE JINDVA SCHOOL",
"GANDHINAGAR MUNICIPAL CORPORATION",
"GANDHINAGAR RAILWAY AND URBAN DEVELOPMENT CORPORATION LIMITED",
"GANDHINAGAR SMART CITY DEVELOPMENT LIMITED",
"GANDHINAGAR UNIVERSITY",
"GANDHINAGAR WASTEFUELS LIMITED",
"GANDHU CHHAPAR CONSTRUCTION PRIVATE LIMITED",
"GANDIV BUILDER AND ENGINEERS PRIVATE LIMITED",
"GANDOUR INDIA FOOD PROCESSING PRIVATE LIMITED",
"GANERIWALA BROTHERS PRIVATE LIMITED",
"GANES METPLAST PRIVATE LIMITED",
"GANESA ENTERPRISES PRIVATE LIMITED",
"GANESAN BUILDERS LIMITED",
"GANESAN BUILDERS PRIVATE LIMITED",
"GANESH AGENCIES PRIVATE LIMITED",
"GANESH AGRO PACK PRIVATE LIMITED",
"GANESH AGROUDYOG PRIVATE LIMITED",
"GANESH AUTO PARTS PVT LTD",
"GANESH BAKERS PRIVATE LIMITED",
"GANESH BENZOPLAST LIMITED",
"GANESH BHEL AND CHAAT PRODUCTS PRIVATE LIMITED",
"GANESH CAPFIN LIMITED",
"GANESH CARS PRIVATE LIMITED",
"GANESH CARTONS INDIA PRIVATE LIMITED",
"GANESH CATERERS PRIVATE LIMITED",
"GANESH CONTRACTING",
"GANESH COTTON TRADERS",
"GANESH DECOR INDIA PRIVATE LIMITED",
"GANESH DEVCON PRIVATE LIMITED",
"GANESH DIAGNOSTIC AND IMAGING CENTRE PRIVATE LIMITED",
"GANESH DIGITAL NETWORKS PRIVATE LIMITED",
"GANESH ELECTRICALS PVT LTD",
"GANESH ELECTRONICS DISTRIBUTION HOUSE PRIVATE LIMITED",
"GANESH EXHAUST SYSTEM PRIVATE LIMITED",
"GANESH FABROTECH PRIVATE LIMITED",
"GANESH FACILITIES MANAGEMENT SERVICES PRIVATE LIMITED",
"GANESH FERTICHEM (INDIA) PRIVATE LIMITED",
"GANESH FILM EQUIPMENTS PRIVATE LIMITED",
"GANESH FM SERVICES PRIVATE LIMITED",
"GANESH FOOD PRODUCTS PRIVATE LIMITED",
"GANESH FOUNDRY & CASTINGS LIMITED",
"GANESH GINNING FACTORY PRIVATE LIMITED",
"GANESH GRAINS LIMITED",
"GANESH GREEN BHARAT LIMITED",
"GANESH GRINDING MILLS PRIVATE LIMITED",
"GANESH HEGDE ENTERTAINMENT PRIVATE LIMITED",
"GANESH HIRE PURCHASE & LEASING FINANCE PRIVATE LIMITED",
"GANESH HOSPITAL",
"GANESH HOSPITALS PRIVATE LIMITED",
"GANESH HOUSING CORPORATION LIMITED",
"GANESH IRON WORKS PRIVATE LIMITED",
"GANESH JEWELLERY (INDIA) PRIVATE LIMITED",
"GANESH KARTHI TEXTILE PRIVATE LIMITED",
"GANESH LAM PLY PRIVATE LIMITED",
"GANESH LAXMI PROCESSORS PRIVATE LIMITED",
"GANESH MOVERS & LOGISTICS PRIVATE LIMITED",
"GANESH MRI CENTRE PRIVATE LIMITED",
"GANESH MULTITECH ENGINEERING PRIVATE LIMITED",
"GANESH ORES PRIVATE LIMITED",
"GANESH ORTHO TRAUMA & MEDICAL CENTRE PRIVATE LIMITED",
"GANESH PADAM SANITARY PRIVATE LIMITED",
"GANESH PARK CENTRE PRIVATE LIMITED",
"GANESH PHARMA TECH PRIVATE LIMITED",
"GANESH PLYWOOD PRODUCTS PRIVATE LIMITED",
"GANESH POLY FILMS PRIVATE LIMITED",
"GANESH POLYCHEM LIMITED",
"GANESH PRECICOMS INDUSTRIES PRIVATE LIMITED",
"GANESH PRECISION WORKS PRIVATE LIMITED",
"GANESH PREMIUM TEA PRIVATE LIMITED",
"GANESH PRESERVATION PRIVATE LIMITED",
"GANESH PRODUCTS PVT LTD",
"GANESH REALTY AND MALL DEVELOPMENT PRIVATE LIMITED",
"GANESH ROADLINES PRIVATE LIMITED",
"GANESH SAI CONTRACTOR & CONSTRUCTION PRIVATE LIMITED",
"GANESH SAW MILLS PRIVATE LIMITED",
"GANESH SHANKAR ENVIRONMENTAL SOLUTIONS PRIVATE LIMITED",
"GANESH SHOE INDUSTRIES PRIVATE LIMITED",
"GANESH SOLAR SOLUTION",
"GANESH SPINNING MILLS PRIVATE LIMITED",
"GANESH SPINTEX PRIVATE LIMITED",
"GANESH SPONGE PRIVATE LIMITED",
"GANESH STEEL AND ALLOYS LIMITED",
"GANESH STEEL RE-ROLLING MILLS PRIVATE LIMITED",
"GANESH STOCKINVEST PRIVATE LIMITED",
"GANESH TAMULI ENGINEERING PRIVATE. LIMITED.",
"GANESH TEST TUBE BABY CENTRE PRIVATE LIMITED",
"GANESH TRANSMISSION PRIVATE. LIMITED.",
"GANESH VENEER PRIVATE LIMITED",
"GANESH ZINC INDUSTRIES PRIVATE LIMITED",
"GANESHA ALUMINIUM EXTRUSIONS PRIVATE LIMITED",
"GANESHA ECOSPHERE LIMITED",
"GANESHA PERSONAL CARE PRODUCTS PRIVATE LIMITED",
"GANESHA REALESTATE DEVELOPERS INFRATECH PRIVATE LIMITED",
"GANESHA SOLAR SOLUTIONS",
"GANESHA WOODEN HUB PRIVATE LIMITED",
"GANESHAM ELECTROTECH SUPERMARKET PRIVATE LIMITED",
"GANESHAM KRIPA ENTERPRISES PRIVATE LIMITED",
"GANESHAYAN GREEN AGRO PRIVATE LIMITED",
"GANESHDASS RAMGOPAL PRIVATE LIMITED",
"GANESHDHAM BUSINESS PRIVATE LIMITED",
"GANESHGADH P. SCHOOL",
"GANESHJI MAHARAJ JEWELLERS PRIVATE LIMITED",
"GANESHKA KONOI TEA CO PVT LTD",
"GANESHKRUPA CHEMICALS AND FERTILISERS PRIVATE LIMITED",
"GANESHLAKSHMI CEMENTS PRIVATE LIMITED",
"GANESHMFG PRIVATE LIMITED",
"GANESHPRASAD IMPEX PRIVATE LIMITED",
"GANESHVANI MERCHANDISE PRIVATE LIMITED",
"GANESHVANI TRADELINK PRIVATE LIMITED",
"GANESHWARAM PRIVATE LIMITED",
"GANGA & SONS TRADE PRIVATE LIMITED",
"GANGA & UMA STEEL ENTERPRISES PRIVATE LIMITED",
"GANGA ACROWOOLS LIMITED",
"GANGA AGRO TECH PRIVATE LIMITED",
"GANGA ALLOYS PRIVATE LIMITED",
"GANGA ASHRAM PVT. LTD.",
"GANGA BAG UDYOG PRIVATE. LIMITED.",
"GANGA BANIJYA WAREHOUSING PVT LTD",
"GANGA BANKS RESORTS PRIVATE LIMITED",
"GANGA BUILDTECH PRIVATE LIMITED",
"GANGA CARE HOSPITALS LIMITED",
"GANGA CARRIERS PVT LTD",
"GANGA CARTONS PRIVATE LIMITED",
"GANGA CONSUMER DURABLES LIMITED",
"GANGA DAIRY LIMITED",
"GANGA DARSHAN FOREX PRIVATE LIMITED",
"GANGA DESIGN STUDIO PRIVATE LIMITED",
"GANGA DEVCON PRIVATE LIMITED",
"GANGA DEVI COLD STORAGE PRIVATE LIMITED",
"GANGA DIAGNOSTIC & MEDICAL RESEARCH CENTRE PRIVATE LIMITED",
"GANGA ELECONS INDIA PRIVATE LIMITED",
"GANGA EXTRUSION PRIVATE LIMITED",
"GANGA FASHIONS PRIVATE LIMITED",
"GANGA FERROALLOYS PRIVATE LIMITED",
"GANGA FOREX PRIVATE LIMITED",
"GANGA FORGING LIMITED",
"GANGA GEMS PRIVATE LIMITED",
"GANGA GLOBAL HOMES PRIVATE LIMITED",
"GANGA GYAN VIKAS SAMITI",
"GANGA HOTELS LIMITED",
"GANGA ICE FACTORY AND COLD STORAGE PRIVATE LIMITED",
"GANGA INFRABUILD PRIVATE LIMITED",
"GANGA INFRAPROJECTS PRIVATE LIMITED",
"GANGA INFRASOLUTIONS PRIVATE LIMITED",
"GANGA INSTITUTE OF TECHNOLOGY & MANAGEMENT",
"GANGA INTERNATIONAL LIMITED",
"GANGA IRON & GALVANIZING WORKS LIMITED",
"GANGA IRON AND STEEL TRADING COMPANY LIMITED",
"GANGA ISPAT PVT LTD.",
"GANGA KAVERI SEEDS PRIVATE LIMITED",
"GANGA MATA PRI MARKETYARD LATUR",
"GANGA MEDICAL CENTRE AND HOSPITALS PRIVATE LIMITED",
"GANGA NAGAR COMMODITY LIMITED",
"GANGA NURSING HOME",
"GANGA OVERSEAS PRIVATE LIMITED",
"GANGA PADDY & RICE PRIVATE LIMITED",
"GANGA PHARMA TRADING PRIVATE LIMITED",
"GANGA POLYESTER LIMITED",
"GANGA PULP AND PAPERS PRIVATE LIMITED",
"GANGA RAM SYNTHETICS PRIVATE LIMITED",
"GANGA RASAYANIE PRIVATE LIMITED",
"GANGA RK INDUSTRIES PRIVATE LIMITED",
"GANGA ROLLER FLOUR MILLS PRIVATE LIMITED",
"GANGA SAGAR AGRO PIPES PRIVATE LIMITED",
"GANGA SEEDS PRIVATE LIMITED",
"GANGA SERVICES PRIVATE LIMITED",
"GANGA SPINTEX LIMITED",
"GANGA SPINTEX PRIVATE LIMITED",
"GANGA SPRINKLER PIPES PRIVATE LIMITED",
"GANGA SRIRAM HITECH AGRO PRIVATE LIMITED",
"GANGA STP PROJECT PRIVATE LIMITED",
"GANGA TEA INDUSTRIES PVT LTD",
"GANGA TEX TRENDZ PRIVATE LIMITED",
"GANGA THERMOPACK",
"GANGA TOURIST INDIA PRIVATE LIMITED",
"GANGA VINIMAY PRIVATE LIMITED",
"GANGA YAMUNA TRADERS PRIVATE LIMITED",
"GANGABARI TEA COMPANY PRIVATE LIMITED",
"GANGABISHAN BHIKULAL INVESTMENT AND TRADING LIMITED",
"GANGADEEP ESTATES PRIVATE LIMITED",
"GANGADEEP TIE-UP PVT LTD",
"GANGADHAR AGENCIES PRIVATE LIMITED",
"GANGADHAR JENA",
"GANGADI INVESTMENTS PRIVATE LIMITED",
"GANGAGEN BIOTECHNOLOGIES PRIVATE LIMITED",
"GANGAHERITAGE RESORTS PRIVATE LIMITED",
"GANGAJALI ENGINEERS PRIVATE LIMITED",
"GANGAJAMUNA STEEL PRIVATE LIMITED",
"GANGALAXMI HOSPITALS PRIVATE LIMITED",
"GANGAMAA VINTRADE PRIVATE LIMITED",
"GANGAMAI COLLEGE OF PHARMACY DHULE",
"GANGAMAI EDUCATION TRUST‚ÄôS ARTS COMMERCE AND SCIENCE COLLEGE NAGAON",
"GANGAMAI HEIGHTS PRIVATE LIMITED",
"GANGAMAI HIGH SCHOOL WAGADI BK",
"GANGAMAI INDUSTRIES AND CONSTRUCTIONS LIMITED",
"GANGAMAI INDUSTRIES AND CONSTRUCTIONS PRIVATE LIMITED",
"GANGAMAI KALYAN ACR PRIVATE LIMITED",
"GANGAMANI ENTERPRISE PRIVATE LIMITED",
"GANGAMAULI SUGAR & ALLIED INDUSTRIES PRIVATE LIMITED",
"GANGANAGAR AUTOMOBILES PRIVATE LIMITED",
"GANGANAGAR BEHARILAL GHOSH VIDYAPITH",
"GANGANAGAR COMMERCIAL PRIVATE LIMITED",
"GANGANAGAR MOTORS. LIMITED",
"GANGANAGAR VEHICLES PRIVATE LIMITED",
"GANGANGA VIDHYAPITH",
"GANGANIA BUILDCON PRIVATE LIMITED",
"GANGANPATI VYAPAAR PRIVATE LIMITED",
"GANGAPADA SUPER SPECIALITY HOSPITAL PRIVATE LIMITED",
"GANGAPUR PRIMARY SCHOOL",
"GANGAPUR TAHSIL OFFICE",
"GANGAR OPTICIANS PRIVATE LIMITED",
"GANGARAM PRAKASHAN (REGD.)",
"GOQUEST SOLUTION PRIVATE LIMITED",
"GANGASHEEL ADVANCED MEDICAL RESEARCH INSTITUTE",
"GANGASINGH ENGINEERNG PRIVATE LIMITED",
"GANGATIKA TECHNOLOGIES PRIVATE LIMITED",
"GANGAUR EXPORTS PRIVATE LIMITED",
"GANGAVARAM PORT LIMITED",
"GANGAVARAM PORT SERVICES (INDIA) LIMITED",
"GANGAVARAM PORT SERVICES INDIA PRIVATE LIMITED",
"GANGDARI HYDRO POWER PRIVATE LIMITED",
"GANGEET INVESTMENTS AND REALITY PRIVATE LIMITED",
"GANGES CLUB LIMITED",
"GANGES FORD PROP: LEXICON COMMERCIAL ENTERPRISES LIMITED.",
"GANGES GREEN ENERGY PRIVATE LIMITED",
"GANGES HEALTH BIOTECH PRIVATE LIMITED",
"GANGES INTERNATIONALE PRIVATE LIMITED",
"GANGES JUTE PRIVATE LIMITED",
"GANGES SECURITIES LIMITED",
"GANGES VALLEY SCHOOL",
"GANGES WATER TRANSPORT CO PVT LTD",
"GANGESH ENTERPRISES",
"GANGESH PHARMA PRIVATE LIMITED",
"GANGESHWARI METALS PRIVATE LIMITED",
"GANGESVALLEY CONSTRUCTIONS PRIVATE LIMITED",
"GANGIDI INDUSTRIES LIMITED",
"GANGIKA INFRASTRUCTURE PRIVATE LIMITED",
"GANGNAM STREET RETAIL LLP",
"GANGOTARI DAIRY PRODUCTS PRIVATE LIMITED",
"GANGOTHRI NUTRIENTS AND FERTILIZERS PRIVATE LIMITED",
"GANGOTHRI STUDIOS PRIVATE LIMITED",
"GANGOTREE SWEETS AND SNACKS PRIVATE LIMITED",
"GANGOTRI CHLOROCHEM PRIVATE LIMITED",
"GANGOTRI DEVELOPERS PRIVATE LIMITED",
"GANGOTRI ELECTRONICS PRIVATE LIMITED",
"GANGOTRI FLEXITUBES PRIVATE LIMITED",
"GANGOTRI HEALTH CARE & RESEARCH PRIVATE LIMITED",
"GANGOTRI HOLY PRODUCTS PRIVATE LIMITED.",
"GANGOTRI INORGANIC PRIVATE LIMITED",
"GANGOTRI INTERNATIONAL SCHOOL",
"GANGOTRI IRON & STEEL COMPANY LIMITED",
"GANGOTRI MERCHANTS PVT LTD",
"GANGOTRI METAL & ALLOYS ( INDIA) PRIVATE LIMITED",
"GANGOTRI MILK AND AGRO PRODUCTS PRIVATE LIMITED",
"GANGOTRI PAPER MILLS PRIVATE. LIMITED.",
"GANGOTRI PIPES PRIVATE LIMITED",
"GANGOTRI POLYMERS PRIVATE LIMITED",
"GANGOTRI RUBBER LIMITED",
"GANGOTRI SAREES PRIVATE LIMITED",
"GANGOTRI SHEET GRIH PRIVATE LIMITED",
"GANGOTRI STEELS INDIA PRIVATE LIMITED",
"GANGOTRI SYNTEX PVT LTD",
"GANGOTRI TEA & INDUSTRIES PRIVATE LIMITED",
"GANGOTRI TRACON PVT LTD",
"GANGOTRI TRADELINK PRIVATE LIMITED",
"GANGOTRI TURBO TECH ENGINEERING SERVICES PRIVATE LIMITED",
"GANGOTRI VENTURES PRIVATE LIMITED",
"GANGOTRI VIDYALAYA",
"GANGOUR INVESTMENTS LIMITED",
"GANGOUR LOGISTICS PRIVATE LIMITED",
"GANGPUR RESOURCES PRIVATE LIMITED",
"GANGSHENG FOOTWEAR PRIVATE LIMITED",
"GANGTOTRI HOSPITALITY PRIVATE LIMITED",
"GANGULY AGENCY PRIVATE LIMITED",
"GANGULY HOME SEARCH PRIVATE LIMITED",
"GANGWAL CHEMICALS PRIVATE LIMITED",
"GANGWAL COMMODITIES PRIVATE LIMITED",
"GANGWAL HEALTHCARE PRIVATE LIMITED",
"GANGWAL INDUSTRIES PRIVATE LIMITED",
"GANGWAL IRON & STEEL PRIVATE LIMITED",
"GANGWAL UDYOG PVT LTD",
"GANGWANI ODHNA BICHONA PRIVATE LIMITED",
"GANGWANI REALESTATE AND RESORTS PRIVATE LIMITED",
"GANINATH FLOUR MILLS PRIVATE LIMITED",
"GANIT BUSINESS SOLUTIONS PRIVATE LIMITED",
"GANITA TECHNOLOGIES AND SERVICES PRIVATE LIMITED",
"GANITARTH TECHNOLOGIES PRIVATE LIMITED",
"GANIX NUTRICARE PRIVATE LIMITED",
"GANIX RUBBER RECYCLING PRIVATE LIMITED",
"GANJAM HOSPITALITY PRIVATE. LIMITED.",
"GANJAM JEWELLERS PRIVATE LIMITED",
"GANJAWALLA FABRIPRO PRIVATE LIMITED",
"GANKAR ENTERPRISES PRIVATE LIMITED",
"GANNA N GOLD PRIVATE LIMITED",
"GANNATH COMMERCE PRIVATE LIMITED",
"GANNAYAK CARS PRIVATE LIMITED",
"GANNAYAK COAL AND CONSTRUCTION PRIVATE LIMITED",
"GANNETT CO. INC.",
"GANNON DUNKERLEY AND COMPANY LIMITED",
"GANOBIS INDIA PRIVATE LIMITED",
"GANON PRODUCTS LIMITED",
"GANORKAR FACILITY MANAGEMENT (OPC) PRIVATE LIMITED",
"GANPAT METALS PRIVATE LIMITED",
"GANPAT RAI KEWAL RAM TRADING CO. PRIVATE LIMITED",
"GANPAT SINGH AND COMPANY PRIVATE LIMITED",
"GANPAT UNIVERSITY",
"GANPATHY INTEGRATED FACILITIES SOLUTIONS PRIVATE LIMITED",
"GANPATI ADDITIVES PRIVATE LIMITED",
"GANPATI AGENCIES PRIVATE LIMITED",
"GANPATI AGRI BUSINESS PRIVATE LIMITED",
"GANPATI ARCADE PRIVATE LIMITED",
"GANPATI AUTOTECH PRIVATE LIMITED",
"GANPATI BEVERAGES PRIVATE LIMITED",
"GANPATI BOARDS PRIVATE LIMITED",
"GANPATI CARRYING CORPORATION LIMITED",
"GANPATI CASTINGS PRIVATE LIMITED",
"GANPATI COMMODEAL PRIVATE LIMITED",
"GANPATI COTTEX LIMITED",
"GANPATI COTTON AND FIBRES PRIVATE LIMITED",
"GANPATI DAIRY PRODUCTS PRIVATE LIMITED",
"GANPATI DEALCOM PRIVATE LIMITED",
"GANPATI DWELLINGS PRIVATE LIMITED",
"GANPATI ELECTRICALS PRIVATE LIMITED",
"GANPATI ENERGY PRIVATE LIMITED",
"GANPATI ENTERPRISES",
"GANPATI EXCLUSIVE DESIGNER SAREES PRIVATE LIMITED",
"GANPATI FABCON (INDIA) PRIVATE LIMITED",
"GANPATI FABRICS PVT LTD",
"GANPATI FIN-LEASE PRIVATE LIMITED",
"GANPATI FINSEC PRIVATE LIMITED",
"GANPATI FLOATGLASS PRIVATE LIMITED",
"GANPATI FOUR WHEELS PRIVATE LIMITED",
"GANPATI FURNITURE SYSTEMS PRIVATE LIMITED",
"GANPATI GARTEX PRIVATE LIMITED.",
"GANPATI HERBAL CARE PRIVATE LIMITED",
"GANPATI HITECH DISTRIBUTORS PRIVATE LIMITED",
"GANPATI INDUSTRIAL PVT LTD",
"GANPATI INDUSTRIES PRIVATE LIMITED",
"GANPATI INFRA SOLUTION PRIVATE LIMITED",
"GANPATI INFRAPOWER PRIVATE LIMITED",
"GANPATI INFRASTRUCTURE DEVELOPMENT COMPANY LIMITED",
"GANPATI INFRATECH PRIVATE LIMITED",
"GANPATI INTERGLOBE PRIVATE LIMITED",
"GANPATI ISPAT PRIVATE LIMITED",
"GANPATI LAM & PLY PRIVATE LIMITED",
"GANPATI LAMINATORS AND PACKAGERS PVT.LTD.",
"GANPATI LENO BAGS PRIVATE LIMITED",
"GANPATI MACHINE AND SPARES PRIVATE LIMITED",
"GANPATI MANGLA JEWEL AND DIAMONDS PRIVATE LIMITED",
"GANPATI MARBLES AND GRANITES PRIVATE LIMITED",
"GANPATI MEGA BUILDERS (INDIA) PRIVATE LIMITED",
"GANPATI MERCANTILE COMPANY PVT LTD",
"GANPATI MILK PRODUCTS PRIVATE LIMITED",
"GANPATI MINETECH PRIVATE LIMITED",
"GANPATI MIN-VENTURES PRIVATE LIMITED",
"GANPATI MOTEL PRIVATE LIMITED",
"GANPATI MOTOR WHEELS PRIVATE LIMITED",
"GANPATI MOULDERS PRIVATE LIMITED",
"GANPATI MULTI COMMODITY BUSINESS (INDIA) PRIVATE LIMITED",
"GANPATI PACKAGING PVT LTD",
"GANPATI PLY AND DOORS PRIVATE LIMITED",
"GANPATI PLYBOARDS PRIVATE LIMITED",
"GANPATI PROJECTS PRIVATE LIMITED",
"GANPATI RESIDENCY PRIVATE LIMITED",
"GANPATI RESOURCES PRIVATE LIMITED",
"GANPATI ROPEWAYS PRIVATE LIMITED",
"GANPATI SEEDS COMPANY PRIVATE LIMITED",
"GANPATI SHOPPING MALL PRIVATE LIMITED",
"GANPATI SPONGE IRON PRIVATE LIMITED",
"GANPATI STOCKS PVT LTD",
"GANPATI STRUCTURES PRIVATE LIMITED",
"GANPATI SULZ TEX PRIVATE LIMITED",
"GANPATI SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED",
"GANPATI SYNTHETICS LIMITED",
"GANPATI TASTY FOODS PRIVATE LIMITED",
"GANPATI TEXERE PRIVATE LIMITED",
"GANPATI TOWNSHIPS LIMITED",
"GANPATI TRADECOM PRIVATE LIMITED",
"GANPATI TUBES AND FABRICATORS PRIVATE LIMITED",
"GANPATIKRIPA BUILDCON PRIVATE LIMITED",
"GANPATISHAKTI SMELTERS PRIVATE LIMITED",
"GANPATPURA PRI SCHOOL",
"GANRAJ CLINIC AND AYURVEDIC CENTER",
"GANRAJ COMPUTER RAJUR",
"GANRAJ ISPAT PRIVATE LIMITED",
"GANRUPAVINAYAK FOODS PRODUCTS PRIVATE LIMITED",
"GANS LIFESTYLE PRIVATE LIMITED",
"GANSIVM MERCHANDISE PRIVATE LIMITED",
"GANSONS ENGINEERS PRIVATE LIMITED",
"GANSONS PRIVATE LIMITED",
"GANSONS RADIATORS PVT LTD",
"GANSUN GLOBAL SOLUTIONS (INDIA) PRIVATE LIMITED",
"GANTEC PUBLISHING SOLUTIONS PRIVATE LIMITED",
"GANTI COLD STORAGE PRIVATE LIMITED",
"GANTNER INFOTEC INDIA PRIVATE LIMITED",
"GANTNER INSTRUMENTS INDIA PRIVATE LIMITED",
"GANTREX INDIA CRANE RAILS PRIVATE LIMITED",
"GANTS MANUFACTURING & TRADING COMPANY PRIVATE LIMITED",
"GANUCHI FASHIONS PRIVATE LIMITED",
"GANWARI SILICA PRIVATE LIMITED",
"GAON CONNECTION PRIVATE LIMITED",
"GAP ENTERTAINMENT PRIVATE LIMITED",
"GAP INTERNATIONAL SOURCING INDIA PRIVATE LIMITED",
"GAP IT SERVICES INDIA PRIVATE LIMITED",
"GAP LOGISTICS PRIVATE LIMITED",
"GAPBLUE SOFTWARE LABS PRIVATE LIMITED",
"GAPL AUTOMOTIVE PRIVATE LIMITED",
"GAPMETA VENTURES PRIVATE LIMITED",
"GAPP TELESERVICES PRIVATE LIMITED",
"GAPS GREENS INDUSTRIES PRIVATE LIMITED",
"GAPVAK TECHNOLOGIES PRIVATE LIMITED",
"GAR CORPORATE SERVICES PRIVATE LIMITED",
"GAR CORPORATION PRIVATE LIMITED",
"GAR TECHNOLOGIES PRIVATE LIMITED",
"GARA AUTOZONE PRIVATE LIMITED",
"GARAGE MEDIA PRIVATE LIMITED",
"GARAGE PRODUCTIONS PRIVATE LIMITED",
"GARAGEPRENEURS INTERNET PRIVATE LIMITED",
"GARANTIR TECHNOLOGIES PRIVATE LIMITED",
"GARAPATI AUTOVENTURES PRIVATE LIMITED",
"GARAVA DEVELOPERS PRIVATE LIMITED",
"GARBA STEELS PRIVATE LIMITED",
"GARBBAA RAKSHAMBIGAI FERTILITY CENTRE PRIVATE LIMITED",
"GARBHA GUDI IVF CENTRE PRIVATE LIMITED",
"GARBHA GUDI PHARMA PRIVATE LIMITED",
"GARBI FINVEST LIMITED",
"GARCIA PROMOTERS & DEVELOPERS PRIVATE LIMITED",
"GARDEN CITY COLLEGE",
"GARDEN CITY FASHIONS PRIVATE LIMITED",
"GARDEN COURT DISTILLERIES PRIVATE LIMITED",
"GARDEN FLAVOURS COMPANY PRIVATE LIMITED",
"GARDEN HIGH SCHOOL IISER KOLKATA CAMPUS",
"GARDEN KITCHENWARE PRIVATE LIMITED",
"GARDEN OF EDEN PROPERTY DEVELOPERS PRIVATE LIMITED",
"GARDEN REACH SHIP BUILDERS & ENGINEERS LIMITED.",
"GARDEN SILK MILLS PRIVATE LIMITED",
"GARDEN TEXTILES PRIVATE LIMITED",
"GARDEN VIEW MEADOWS PRIVATE LIMITED",
"GARDEN VIEW NURSING HOME PRIVATE LIMITED",
"GARDENCITY REALTY PRIVATE LIMITED",
"GARDENIA COSMOCARE PRIVATE LIMITED",
"GARDENIA COSMOTRADE LLP",
"GARDENIA TELECOM PRIVATE LIMITED",
"GARDEN'S NEED PRIVATE LIMITED",
"GARDENS OF THE EARTH PRIVATE LIMITED",
"GARDEX INDIA PRIVATE LIMITED",
"GARDGIL VOHRA VENTURES PRIVATE LIMITED",
"GARDLER LIGHTING INDIA PRIVATE LIMITED",
"GARDLER MANUFACTURING & TECH SERVICES PRIVATE LIMITED",
"GARDNER AEROSPACE - BENGALURU PRIVATE LIMITED",
"GARDNER DENVER ENGINEERED PRODUCTS INDIA PRIVATE",
"GARDNER DENVER ENGINEERED PRODUCTS INDIA PRIVATE LIMITED",
"GARE PELMA III COLLIERIES LIMITED",
"GARG ACRYLICS LIMITED",
"GARG AD VISION PRIVATE LIMITED",
"GARG AGRI FOODS PRIVATE LIMITED",
"GARG AND COMPANY PRIVATE LIMITED",
"GARG APPLIANCES PRIVATE LIMITED",
"GARG ASSOCIATES PRIVATE LIMITED",
"GARG AVIATIONS LIMITED.",
"GARG BEVERAGES PVT LTD",
"GARG BROTHERS PVT LTD",
"GARG BROTHERS TRADING AND SERVICES PRIVATE LIMITED",
"GARG CABLES & SILICONES PRIVATE LIMITED",
"GARG CASTEELS PRIVATE LIMITED",
"GARG CHAINS PRIVATE LIMITED",
"GARG CONSULTANCY PRIVATE LIMITED (OPC)",
"GARG COTEX PRIVATE LIMITED",
"GARG DATA INFORMATION PRIVATE LIMITED",
"GARG DUPLEX & PAPER MILLS P LIMITED",
"GARG FOOTWEAR PRIVATE LIMITED",
"GARG FOREX PRIVATE LIMITED",
"GARG GARMENTS PRIVATE LIMITED",
"GARG GAS APPLIANCES PRIVATE LIMITED",
"GARG GRANITES PVT. LTD",
"GARG HEART & MULTISPECIALITY HOSPITAL PRIVATE LIMITED",
"GARG HEART CENTRE AND NURSING HOME PRIVATE LIMITED",
"GARG HOLIDAYS PRIVATE LIMITED",
"GARG HOSPITAL & PATHLABS PRIVATE LIMITED",
"GARG HOTELS & REAL ESTATE PRIVATE LIMITED",
"GARG INDUSTRIES",
"GARG INDUSTRIES PRIVATE LIMITED",
"GARG INSULATORS PRIVATE LIMITED",
"GARG KNIT FAB PRIVATE LIMITED",
"GARG LUMBERS PRIVATE LIMITED",
"GARG MATTRESSES INDIA PRIVATE LIMITED",
"GARG POLYPACKS PRIVATE LIMITED",
"GARG POLYPLAST PRIVATE LIMITED",
"GARG POWER PRODUCTS PRIVATE LIMITED",
"GARG REAL ESTATE DEVELOPERS PRIVATE LIMITED",
"GARG REDIMIX PRIVATE LIMITED",
"GARG REROLLERS PRIVATE LIMITED",
"GARG SEAMLESS ( INDIA ) PRIVATE LIMITED",
"GARG SECURITIES PRIVATE LIMITED",
"GARG SONS ESTATE PROMOTERS PRIVATE LIMITED",
"GARG SONS INDIA PRIVATE LIMITED",
"GARG SPORTS INTERNATIONAL PRIVATE LIMITED",
"GARG STEEL TUBES PRIVATE LIMITED",
"GARG STEELS",
"GARG STEELS UDYOG INDIA PRIVATE LIMITED",
"GARG STONES PRIVATE LIMITED",
"GARG SURGICAL POINT PRIVATE LIMITED",
"GARG TRANSLINK INDIA PRIVATE LIMITED",
"GARG TRANSPORT AND FLEET OWNERS PRIVATE LIMITED",
"GARG TREXIM OMNISCIENT PRIVATE LIMITED",
"GARG VANIJYA PRIVATE LIMITED",
"GARG VILLAS PRIVATE LIMITED",
"GARG ZINC (INDIA) PVT. LTD",
"GARGA INTERNATIONAL PRIVATE LIMITED",
"GARGA PROCESSORS PRIVATE LIMITED",
"GARGA ROADLINES PRIVATE LIMITED",
"GARGI CHEMICALS PRIVATE LIMITED",
"GARGI COATED PAPERS PRIVATE LIMITED",
"GARGI ENGINEERING ENTERPRISES PRIVATE LIMITED",
"GARGI HUTTENES ALBERTUS PRIVATE LIMITED",
"GARGI MEMORIAL INSTITUTE OF TECHNOLOGY",
"GARGI PRECAST AND INFRA PRIVATE LIMITED",
"GARGI TEXOFEB PRIVATE LIMITED",
"GARGI TRAVELS PRIVATE LIMITED",
"GARGOTI INDIAN MINERALS LIMITED",
"GARGS ENGINEERS LIMITED",
"GARGSON AUTOMOBILE PRIVATE LIMITED",
"GARGSON PROPERTIES PVT LTD",
"GARGSONS LOGISTICS PRIVATE LIMITED",
"GARGYA AUTOCITY PRIVATE LIMITED",
"GARH BHAWANIPUR R.P INSTITUTION",
"GARHA UTILBROCCE TOOLS LIMITED",
"GARHWAL AIRCON SERVICES PRIVATE LIMITED",
"GARHWAL MANDAL VIKAS NIGAM LIMITED",
"GARHWAL MARBLES PRIVATE LIMITED",
"GARIMA ADVERTISING AND MARKETING PRIVATE LIMITED",
"GARIMA ASSOCIATES PRIVATE LIMITED",
"GARIMA CAPITAL PRIVATE LIMITED",
"GARIMA CASTINGS PRIVATE LIMITED",
"GARIMA FASHIONS PRIVATE LIMITED",
"GARIMA GLOBAL PRIVATE LIMITED",
"GARIMA HEALTHCARE PRIVATE LIMITED",
"GARIMA INVESTMENT AND TRADING CO PRIVATE LIMITED",
"GARIMA LEATHER EXPORTS PRIVATE LIMITED",
"GARIMA MANAGEMENT PVT LTD",
"GARIMA MILK AND FOODS PRODUCTS LIMITED",
"GARIMA MOTORS PRIVATE LIMITED",
"GARIMA NATURAL RESOURCES PRIVATE LIMITED",
"GARIMA PVT LTD",
"GARIMA STHAPATYA PRIVATE LIMITED",
"GARIMA TAX FAB PRIVATE LIMITED",
"GARIMA TRADE SERVICES PRIVATE LIMITED",
"GARIMA TRADERS PRIVATE LIMITED",
"GARINNO GLOBAL PRIVATE LIMITED",
"GARIR AUTOMOTIVES PRIVATE LIMITED",
"GARISHTHA CONSULTANCY PRIVATE LIMITED",
"GARKHALI F P SCHOOL",
"GARLE IMPEX PRIVATE LIMITED",
"GARLOCK INDIA PRIVATE LIMITED",
"GARMIN TECHNOLOGIES PRIVATE LIMITED",
"GARMINEX INDUSTRIES PRIVATE LIMITED",
"GARMON SOUTH ASIA CHEMICALS PRIVATE LIMITED",
"GARNE THREADS PRIVATE LIMITED",
"GARNER FINANCE AND SECURITIES PRIVATE LIMITED",
"GARNET CONSTRUCTION LIMITED",
"GARNET INTERIORS PRIVATE LIMITED",
"GARNET INTERNATIONAL LIMITED",
"GARNET MOTORS INDIA PRIVATE LIMITED",
"GARNET POWERTECH PRIVATE LIMTED",
"GARNISH PAINTS PVT LTD",
"GARODIA AGRI FOODS INDIA LIMITED",
"GARODIA CREATION LIMITED",
"GARODIA INTERNATIONAL CENTRE FOR LEARNING MUMBAI",
"GARODIA POLYESTERS PRIVATE LIMITED",
"GARODIA POLYMERS PRIVATE LIMITED",
"GARODIA SECURITIES LTD",
"GARODIA SYNTEX PRIVATE LIMITED",
"GAROL PRIMARY SCHOOL",
"GARON DEHYDRATES PRIVATE LIMITED",
"GARPHI BIOSCIENCES PRIVATE LIMITED",
"GARRETT MOTION ENGINEERING SOLUTIONS PRIVATE LIMITED",
"GARRETT MOTION TECH I PRIVATE LIMITED",
"GARRISON DEVELOPERS PRIVATE LIMITED",
"GARRISON ENGINEER",
"GARRISON INFRA AND SECURITY PRIVATE LIMITED",
"GARRUDA TECHNOVATE PRIVATE LIMITED",
"GARSONS PRIVATE LIMITED",
"GARTECH EQUIPMENTS PRIVATE LIMITED",
"GARTELS WERKE LIMITED",
"GARTEX EXPORTS (INDIA) PRIVATE LIMITED",
"GARTNER INDIA RESEARCH & ADVISORY SERVICES PRIVATE LIMITED",
"GARUD FIRE AND SECURITY",
"GARUDA ADVERTISING PRIVATE LIMITED",
"GARUDA AEROSPACE PRIVATE LIMITED",
"GARUDA AUTOCRAFT PRIVATE LIMITED",
"GARUDA AVIATION SERVICES PRIVATE LIMITED",
"GARUDA BIKES PRIVATE LIMITED",
"GARUDA COAL AGENCY PRIVATE LIMITED",
"GARUDA CONSTRUCTION AND ENGINEERING LIMITED",
"GARUDA CONTRUCTION & ENGINEERING PRIVATE LIMITED",
"GARUDA CRANES PRIVATE LIMITED",
"GARUDA DEVELOPERS PRIVATE LIMITED",
"GARUDA FASHIONS PRIVATE LIMITED",
"GARUDA FINANCIAL CONSULTANCY SERVICES PRIVATE LIMITED",
"GARUDA INSURANCE BROKER PRIVATE LIMITED",
"GARUDA LOGISTICS SERVICES PRIVATE LIMITED",
"GARUDA LOGISTICS SOLUTION PRIVATE LIMITED",
"GARUDA METALS AND CHEMICALS PVT LTD",
"GARUDA MINERALIA PRIVATE LIMITED",
"GARUDA NIRMAN PRIVATE LIMITED",
"GARUDA POWER PRIVATE LIMITED",
"GARUDA PUMPS PRIVATE LIMITED",
"GARUDA TEXTILES PRIVATE LIMITED",
"GARUDA THERMAL POWER PRIVATE LIMITED",
"GARUDAAS IMPORTS AND EXPORTS PRIVATE LIMITED",
"GARUDACHALA ESTATES PRIVATE LIMITED",
"GARUDACORP SYSTEMS PRIVATE LIMITED",
"GARUDADHWAJA STRUCTURES PRIVATE LIMITED",
"GARUDADRI GLOBAL VOYAGES PRIVATE LIMITED",
"GARUDAPALLY INFRASTRUCTURES PRIVATE LIMITED",
"GARUDAUAV SOFT SOLUTIONS PRIVATE LIMITED",
"GARUDAVEGA INFRA PROJECTS PRIVATE LIMITED",
"GARUDAVENKATA SAI COLD STORAGE PRIVATE LIMITED",
"GARUDON MEDICAL SYSTEMS PRIVATE LIMITED",
"GARUNA HEALTHCARE PRIVATE LIMITED",
"GARUTI AVIATION PRIVATE LIMITED",
"GARV DEVELOPERS PRIVATE LIMITED",
"GARV INFRA PROJECTS PRIVATE LIMITED",
"GARV LOGISTICS PRIVATE LIMITED",
"GARVA LAND DEAL PRIVATE LIMITED",
"GARVANSH REDESIGN STITCHING SOLUTIONS PRIVATE LIMITED",
"GARVE CAR MANIA PRIVATE LIMITED",
"GARVEISH HERBACEUTICALS PRIVATE LIMITED",
"GARVIT DIAMONDS PRIVATE LIMITED",
"GARVIT GLOBAL DISTRIBUTORS PRIVATE LIMITED",
"GARVIT HOSPITALITY & INFRACON PRIVATE LIMITED",
"GARVIT INNOVATIVE TRADERS PRIVATE LIMITED",
"GARVITH ORGANIC FARMS LIMITED",
"GARWAL PROPERTIES PRIVATE LIMITED",
"GARWARE BESTRETCH LIMITED",
"GARWARE CLUB HOUSE",
"GARWARE FULFLEX INDIA PRIVATE LIMITED",
"GARWARE FULFLEX SOCIAL FOUNDATION",
"GARWARE HI TECH FILMS LIMITED",
"GARWARE INDUSTRIEES PRIVATE LIMITED",
"GARWARE MARINE INDUSTRIES LIMITED",
"GARWARE PAINTS LIMITED",
"GARWARE SYNTHETICS LIMITED",
"GARWARE TECHNICAL FIBRES LIMITED",
"GARWARE WALL ROPES LIMITED",
"GARY PHARMACEUTICALS PRIVATE LIMITED",
"GARYSON AUTO PRIVATE LIMITED",
"GAS GRAPHIC AUTOMATION SOLUTIONS INDIA PRIVATE LIMITED",
"GAS JEANS PRIVATE LIMITED",
"GAS ONE ENERGY INDIA PRIVATE LIMITED",
"GAS POINT BOTTLING PRIVATE LIMITED",
"GAS PROCESSING EQUIPMENT PRIVATE LIMITED",
"GAS PROJECTS INDIA PRIVATE LIMITED",
"GAS TURBINE CONTROLS (INDIA) PRIVATE LIMITED",
"GASARY EXPORTS INDIA PRIVATE LIMITED",
"GASBUDDY INDIA PRIVATE LIMITED",
"GASGEN FERRO ALLOYS LLP",
"GASGROWS SOLUTIONS PRIVATE LIMITED",
"GASHA STEELS PRIVATE LIMITED",
"GASION AIRTEC PRIVATE LIMITED",
"GASL PRIVATE LIMITED",
"GASLITE SHIPPING PRIVATE LIMITED",
"GASOLEC APPLIANCES PRIVATE LIMITED",
"GASOLENE SERVICE PRIVATE LIMITED",
"GASOREX INDIA PRIVATE LIMITED",
"GASP ENGINEERING PRIVATE LIMITED",
"GASPOINT PETROLEUM INDIA LIMITED",
"GASSAFE INDIA LIMITED",
"GASSOL SOLUTIONS PRIVATE LIMITED",
"GASTECH ELECTRONIC PRODUCTS PRIVATE LIMITED",
"GASTEK ENGINEERING PRIVATE LIMITED",
"GASTON ENERGY INDIA PRIVATE LIMITED",
"GASTRO GOURMET EXPERTS PRIVATE LIMITED",
"GASTRO MEDICAL CENTRE TRICHY PRIVATE LIMITED",
"GASTROCARE LIVER & DIGESTIVE DISEASE CENTER",
"GASTROLAB INDIA PRIVATE LIMITED",
"GASTRONOMYLEGACY FRESH FOOD PRIVATE LIMITED",
"GASTROPLUS DIGESTIVE DISEASE CENTRE PRIVATE LIMITED",
"GATALA DEVELOPERS AND PROPERTIES PRIVATE LIMITED",
"GATE FOODS PRIVATE LIMITED",
"GATE GOURMET INDIA PRIVATE LIMITED",
"GATEB SERVICES PRIVATE LIMITED",
"GATEE XPRESS CARGO PRIVATE LIMITED",
"GATES INDIA PRIVATE LIMITED",
"GATES INSTITUTE OF TECHNOLOGY",
"GATES METAL EXPERTS PRIVATE LIMITED",
"GATES UNITTA INDIA COMPANY PRIVATE LIMITED",
"GATESIX TECHNOLOGIES INDIA PRIVATE. LIMITED",
"GATEWAY CHEMISTS PRIVATE LIMITED",
"GATEWAY CLINICS AND HOSPITALS PRIVATE LIMITED",
"GATEWAY CONSTRO PRODUCTS PRIVATE LIMITED",
"GATEWAY DISTRIPARKS (KERALA) LIMITED",
"GATEWAY DISTRIPARKS LIMITED",
"GATEWAY EAST INDIA PRIVATE LIMITED",
"GATEWAY EDUCATION AND CHARITABLE SOCIETY",
"GATEWAY ELEPHANTA PLEASURE TOURS AND TRAVELS LIMITED",
"GATEWAY FINANCIAL SERVICES LIMITED",
"GATEWAY GLOBAL BUILDWELL PRIVATE LIMITED",
"GATEWAY HIRISE LIMITED",
"GATEWAY HR SOLUTIONS PRIVATE LIMITED",
"GATEWAY INTERNATIONAL SCHOOL",
"GATEWAY INTERNET PROTOCOL MANAGEMENT PRIVATE LIMITED",
"GATEWAY LEASING PVT LTD",
"GATEWAY MALABAR HOLIDAYS PRIVATE LIMITED",
"GATEWAY MARITIME PRIVATE LIMITED",
"GATEWAY MEDIA PRIVATE LIMITED",
"GATEWAY OFFICE PARKS PRIVATE LIMITED",
"GATEWAY OFFSHORE PRIVATE LIMITED",
"GATEWAY ORANGE CAFETERIA PRIVATE LIMITED",
"GATEWAY PERIPHERALS PRIVATE LIMITED",
"GATEWAY POLYMER PRIVATE LIMITED",
"GATEWAY PROPMART PRIVATE LIMITED",
"GATEWAY RAIL FREIGHT LIMITED",
"GATEWAY SHELTERS PRIVATE LIMITED",
"GATEWAY SOFTTECH PRIVATE LIMITED",
"GATEWAY TAPROOMS LLP",
"GATEWAY TECHNOLABS PRIVATE LIMITED",
"GATEWAY TERMINALS INDIA PRIVATE LIMITED",
"GATHI ANALYTICS PRIVATE LIMITED",
"GATI BATTERY TECH PRIVATE LIMITED",
"GATI EXPRESS & SUPPLY CHAIN PRIVATE LIMITED",
"GATI KAUSAR INDIA LIMITED",
"GATI KINTETSU EXPRESS PRIVATE LIMITED",
"GATI LIMITED",
"GATI MOTORS PRIVATE LIMITED",
"GATIK TEA CO PRIVATE LIMITED",
"GATIL PROPERTIES PRIVATE LIMITED",
"GATILEK PRIVATE LIMITED",
"GATIM FASHIONS PRIVATE LIMITED",
"GATIMAAN TOURS & TRAVELS PRIVATE LIMITED",
"GATIMAN AUTO PVT LTD",
"GATOR SYSTEMS PRIVATE LIMITED",
"GATRAD CAL-TEST LABORATORIES AND RESEARCH PRIVATE LIMITED",
"GATSBY COLLECTION PRIVATE LIMITED",
"GATTANI OVERSEAS PRIVATE LIMITED",
"GATTANI RESORTS PRIVATE LIMITED",
"GATTEFOSSE INDIA PRIVATE LIMITED",
"GATX INDIA PRIVATE LIMITED",
"GAU VETERNIRY COLLEGE",
"GAUAMRIT NUTRICARE PRIVATE LIMITED",
"GAUDEEP TRADING PRIVATE LIMITED",
"GAUDIUM EDUCATIONAL SERVICES PRIVATE LIMITED",
"GAUDIUM IVF AND WOMEN HEALTH PRIVATE LIMITED",
"GAUECOGRAM AGROVIKAS PRODUCER COMPANY LIMITED",
"GAUGE ADVERTISING & MARKETING PRIVATE LIMITED",
"GAUGE DATA SOLUTIONS PRIVATE LIMITED",
"GAUGES BOURDON INDIA PRIVATE LIMITED",
"GAUGES INDUSTRIES PRIVATE LIMITED",
"GAUHATI ROLLER FLOUR MILLS LIMITED",
"GAUHATI TEA WAREHOUSING PVT LTD",
"GAUHATI UNVIERSITY",
"GAUHITA MILK PRODUCER COMPANY LIMITED",
"GAUKARAN FARMERS PRODUCER COMPANY LIMITED",
"GAUNIL HOLDINGS PRIVATE LIMITED",
"GAUR AND NAGI LIMITED",
"GAUR FOODS PRIVATE LIMITED",
"GAUR HYDRO POWER PRIVATE LIMITED",
"GAUR INDUSTRIAL SERVICES PRIVATE LIMITED",
"GAUR PLASTIC & PAPERS PRIVATE LIMITED",
"GAURA BUILDERS PRIVATE LIMITED",
"GAURA ELECTRIC VEHICLES PRIVATE LIMITED",
"GAURAANGANA TRADE PRIVATE LIMITED",
"GAURANG ENVIRONMENTAL SOLUTIONS PRIVATE LIMITED",
"GAURANG FABTEX PRIVATE LIMITED",
"GAURANG HEAT TREATERS PRIVATE LIMITED",
"GAURANG INDUSTRIES PRIVATE LIMITED",
"GAURANG INFRATECH INTERNATIONAL LLP",
"GAURANG METALS PRIVATE LIMITED",
"GAURANG PRODUCTS PRIVATE LIMITED",
"GAURANG TEXTILES PRIVATE LIMITED",
"GAURANGA SOFT-TECH PRIVATE LIMITED",
"GAURANGA SYSTEMS PRIVATE LIMITED",
"GAURAS MILK PRODUCTS PRIVATE LIMITED",
"GAURAV & PUSHKER TELECOMS PRIVATE LIMITED",
"GAURAV AGENCIES PVT LTD",
"GAURAV AIRCON COMPUTERS PRIVATE LIMITED",
"GAURAV APPARELS PRIVATE LIMITED",
"GAURAV AUTO PRIVATE LIMITED",
"GAURAV CHIT FUND PRIVATE LIMITED",
"GAURAV COLDSTORAGE PRIVATE LIMITED",
"GAURAV COMMODEAL PRIVATE LIMITED",
"GAURAV CONSUMER PRODUCTS PRIVATE LIMITED",
"GAURAV CONTRACTS CO.",
"GAURAV DUPLEX PRIVATE LIMITED",
"GAURAV ELECTRONICS",
"GAURAV FABRICS PVT LTD",
"GAURAV FINANCE LTD",
"GAURAV FOODS AND COOL CONNECTIONS PRIVATE LIMITED",
"GAURAV GOODS CARRIER PRIVATE LIMITED",
"GAURAV HEAVY ENGINEERING (INDIA) PRIVATE LIMITED",
"GAURAV HOSPITAL PRIVATE LIMITED",
"GAURAV HOSPITALITY AND SERVICES PRIVATE LIMITED",
"GAURAV HOTELS PVT LTD",
"GAURAV ICE AND COLD STORAGE PRIVATE LIMITED",
"GAURAV IMPEX",
"GAURAV INK PRIVATE LIMITED",
"GAURAV INTERNATIONAL",
"GAURAV INTERNATIONAL LLP",
"GAURAV LAMINATES PRIVATE LIMITED",
"GAURAV LOGISTICS PRIVATE LIMITED",
"GAURAV MEMORIAL INTERNATIONAL SCHOOL",
"GAURAV MINCHEM PVT LTD",
"GAURAV MULTILAYERS PRIVATE LIMITED",
"GAURAV PROTECTION SERVICES PRIVATE LIMITED",
"GAURAV RAIMALANI REALTY PRIVATE LIMITED",
"GAURAV RESIDENCY PRIVATE LIMITED",
"GAURAV RICE & FOOD PROCESSING PRIVATE LIMITED",
"GAURAV ROSE REAL ESTATE PVT LTD",
"GAURAV SPORTS",
"GAURAV TRANS ENGINEERS PRIVATE LIMITED",
"GAURAV TREE & AGRO PRODUCTS PRIVATE LIMITED",
"GAURAV WORLDWIDE TRADING PRIVATE LIMITED GWTPL",
"GAURAVH WINES PRIVATE. LIMITED.",
"GAURAVI STEELS PRIVATE LIMITED",
"GAUREESA INDUSTRIES PRIVATE LIMITED",
"GAURI ACIDS PRIVATE LIMITED",
"GAURI ART PALACE PRIVATE LIMITED",
"GAURI AUTO INDIA PRIVATE LIMITED",
"GAURI BUILDCON PRIVATE LIMITED",
"GAURI CEMENTS PVT. LTD",
"GAURI COMPONENTS PRIVATE LIMITED",
"GAURI DEVI HOSPITAL & RESEARCH INSTITUTE",
"GAURI FASHIONS PRIVATE LIMITED",
"GAURI FOREX PRIVATE LIMITED",
"GAURI FORGE PRIVATE LIMITED",
"GAURI GASES PRIVATE LIMITED",
"GAURI INKK-TEC PRIVATE LIMITED",
"GAURI INTERIOR PRIVATE LIMITED",
"GAURI KESHAR ENTERPRISES PRIVATE LIMITED",
"GAURI LEATHERS PRIVATE LIMITED",
"GAURI SAREES PRIVATE LIMITED",
"GAURI SHANKAR AGRIPRODUCTS PRIVATE LIMITED",
"GAURI SHANKAR FARMS PVT LTD",
"GAURI SHANKAR JEWELLERS PRIVATE LIMITED",
"GAURI SHANKAR PROCESSORS PRIVATE LIMITED",
"GAURI SWITCHGEAR INDIA PRIVATE LIMITED",
"GAURI TECHNOLOGIES PRIVATE LIMITED",
"GAURI VINAYAK BUILDER AND DEVELOPERS PRIVATE LIMITED",
"GAURIK FASHIONS PRIVATE LIMITED",
"GAURIK IMPORTS PRIVATE LIMITED",
"GAURIK LIFESTYLE PRIVATE LIMITED",
"GAURIKA MUILTITRADE PRIVATE LIMITED",
"GAURINAND FARMERS PRODUCER COMPANY LIMITED",
"GAURINATH AGRO PRODUCTS PRIVATE LIMITED",
"GAURINATH REAL ESTATE PRIVATE LIMITED",
"GAURIPUR HOSPITAL PRIVATE LIMITED",
"GAURIPUTRA ESTATE HOLDERS PRIVATE LIMITED",
"GAURIPUTRA INVESTMENTS AND TRADING COMPANY PRIVATE LIMITED",
"GAURISH INDUSTRIES PRIVATE LIMITED",
"GAURISH STEELS PRIVATE. LIMITED.",
"GAURISH TECHNOLOGIES PRIVATE LIMITED",
"GAURISHA FACILITIES MANAGEMENT PRIVATE LIMITED",
"GAURISHANKER BIHANI",
"GAURISONS AGRO OVERSEAS PRIVATE LIMITED",
"GAURISUTA AGRO INDUSTRIES PRIVATE LIMITED",
"GAURISUTA ENTERPRISES PRIVATE LIMITED",
"GAURS INTERNATIONAL SCHOOL",
"GAURSONS EDUCATIONAL INSTITUTIONS PRIVATE LIMITED",
"GAURSONS HI-TECH INFRASTRUCTURE PRIVATE LIMITED",
"GAURSONS INDIA PRIVATE LIMITED",
"GAURSONS PROMOTERS PRIVATE LIMITED",
"GAURSONS REAL TECH PRIVATE LIMITED",
"GAURSONS REALTY PRIVATE.LIMITED",
"GAURSONS SPORTSWOOD PRIVATE LIMITED",
"GAUSH TELEMEDIA PRIVATE LIMITED",
"GAUSIA COLD STORAGE PRIVATE LIMITED",
"GAUSIYA EXPORTS PRIVATE LIMITED",
"GAUSS TURBO POWER INDIA PRIVATE LIMITED",
"GAUSSIAN NETWORKS PRIVATE LIMITED",
"GAUSSIAN OPTIXS PRIVATE LIMITED",
"GAUTAM ARYAN BUILD-WELL PRIVATE LIMITED",
"GAUTAM AUTOARENA CARS PRIVATE LIMITED",
"GAUTAM BUDDH MANUFACTURING PRIVATE LIMITED",
"GAUTAM BUDDHA EDUCATIONAL AND CHARITABLE TRUST",
"GAUTAM BUDDHA UNIVERSITY",
"GAUTAM CASTING INDUSTRIES PRIVATE LIMITED",
"GAUTAM CHLOROALKALIES PRIVATE LIMITED",
"GAUTAM DARDA HOSPITAL",
"GAUTAM DETECTIVE AND SECURITY SERVICES PRIVATE LIMITED",
"GAUTAM ENTERPRISES JALGAON",
"GAUTAM EXIM LIMITED",
"GAUTAM FIBRE GLASS (INDIA) PRIVATE LIMITED",
"GAUTAM FIN INVEST PRIVATE LIMITED",
"GAUTAM FREIGHT PRIVATE LIMITED",
"GAUTAM FURNISHINGS PRIVATE LIMITED",
"GAUTAM HEALTHCARE PRIVATE LIMITED",
"GAUTAM IMPEX PRIVATE LIMITED",
"GAUTAM INDUSTRIAL CORPORATION PRIVATE LIMITED",
"GAUTAM INFRASTRUCTURE & CONSTRUCTION EQUIPMENTS PRIVATE LIMITED",
"GAUTAM JEWELS PRIVATE LIMITED",
"GAUTAM KAMAT HOTELS PRIVATE LIMITED",
"GAUTAM PLYWOOD INDUSTRIES PRIVATE LIMITED",
"GAUTAM PNEUMATICS PRIVATE LIMITED",
"GAUTAM POLYMERS PRIVATE LIMITED",
"GAUTAM RESTAURANTS PRIVATE LIMITED",
"GAUTAM SOLAR PRIVATE LIMITED",
"GAUTAM STAINLESS PRIVATE LIMITED",
"GAUTAM SYNTEX PVT. LTD.",
"GAUTAM TEA PLANTATIONS PVT LTD",
"GAUTAM TECHNOCAST",
"GAUTAM TOURS SERVICES PRIVATE LIMITED",
"GAUTAM TRADE & COMMERCE LIMITED",
"GAUTAM TRADING COMPANY PRIVATE. LIMITED",
"GAUTAM TRUCKING PRIVATE LIMITED",
"GAUTAM U P S",
"GAUTAM VANIJYA PRIVATE LIMITED",
"GAUTAMBUDH CARS PRIVATE LIMITED",
"GAUTAMI CHEMICALS & PESTICIDES PRIVATE. LIMITED.",
"GAUTAMI COLLEGE",
"GAUTAMI JUNIOR COLLEGE",
"GAUTAMI OIL N CHEMICALS PRIVATE LIMITED",
"GAUTAMPURA NAGAR PARISHAD",
"GAUTAMSWAMI EXTRUSION PRIVATE LIMITED",
"GAUTHAM COLLEGE OF PHARMACY",
"GAUTHAM HEALTH CARE PRIVATE LIMITED",
"GAUTHAM HOSPITAL",
"GAUVINS HOME PRIVATE LIMITED",
"GAV INTERPRISES",
"GAVAKSHA GLOBAL FREIGHT PRIVATE LIMITED",
"GAVESHANA GEOSCIENCES PRIVATE LIMITED",
"GAVI SIDDESWARA STEELS(INDIA) PRIVATE LIMITED",
"GAVI TRADERS PRIVATE LIMITED",
"GAVIGAN TECHNOLOGY PRIVATE LIMITED",
"GAVIKO PRIVATE LIMITED",
"GAVIN PUBLISHERS PRIVATE LIMITED",
"GAVRILL METAL PRIVATE LIMITED",
"GAVS INFORMATION SERVICE PRIVATE LIMITED",
"GAVS TECHNOLOGIES PRIVATE LIMITED",
"GAVSON POWER PRIVATE LIMITED",
"GAVSON STEEL PRIVATE LIMITED",
"GAVYA MILK SPECIALITIES PRIVATE LIMITED",
"GAVYACORPORATION PRIVATE LIMITED",
"GAVYADHAR ORGANIC PRIVATE LIMITED",
"GAW PAPER COATING SYSTEMS INDIA PRIVATE LIMITED",
"GAWANDE CONSULTANTS PRIVATE LIMITED",
"GAWAR CONSTRUCTION LIMITED",
"GAWAR INFRA PRIVATE LIMITED",
"GAWAR KHAJUWALA BAP HIGHWAY PRIVATE LIMITED",
"GAWAR KIRATPUR NERCHOWK HIGHWAY PRIVATE LIMITED",
"GAWAR NARNAUL HIGHWAY PRIVATE LIMITED",
"GAWAR ROHNA JHAJJAR HIGHWAY PRIVATE LIMITED",
"GAWAR ROHNA SONEPAT HIGHWAYS PRIVATE LIMITED",
"GAY TRAVELS PRIVATE LIMITED",
"GAYA A.B. ENTERPRISES PRIVATE LIMITED",
"GAYAM MOTOR WORKS PRIVATE LIMITED",
"GAYATHRI AND NAMITH ARCHITECTS PRIVATE LIMITED",
"GAYATHRI AQUA SEA FOOD EXPORTS PRIVATE LIMITED",
"GAYATHRI COTTON PRESSING MILLS PRIVATE LIMITED",
"GAYATHRI EXPORTS",
"GAYATHRI HOSPITAL PRIVATE LIMITED",
"GAYATHRI JUNIOR KALASALA",
"GAYATHRI LIFE SCIENCES PRIVATE LIMITED",
"GAYATHRI MILK DAIRY PRIVATE LIMITED",
"GAYATHRI ROOFING SYSTEMS",
"GAYATHRI VEDIC SERVICES PRIVATE LIMITED",
"GAYATRAM TRADE PRIVATE LIMITED",
"GAYATRI AGENCIES PRIVATE LTD",
"GAYATRI AGRO OIL AND FOOD PRODUCTS",
"GAYATRI AIRCON PRIVATE LIMITED",
"GAYATRI AQUA PRODUCTS PRIVATE LIMITED",
"GAYATRI AUTOMATION SYSTEMS PRIVATE LIMITED",
"GAYATRI BIOORGANICS LIMITED",
"GAYATRI CHEM-PLAST INDIA PRIVATE LIMITED",
"GAYATRI CHEMSYNTH PRIVATE LIMITED",
"GAYATRI COATING PVT LTD",
"GAYATRI COMMODEAL PRIVATE LIMITED",
"GAYATRI COMTEKLAB PRIVATE LIMITED",
"GAYATRI CONSUMER PRODUCTS PRIVATE LIMITED",
"GAYATRI CONTROL AND AUTOMATION PRIVATE LIMITED",
"GAYATRI COTTON PRIVATE. LIMITED.",
"GAYATRI CRL PRIVATE LIMITED",
"GAYATRI DEGREE AND PG COLLEGE TIRUPATI",
"GAYATRI DEGREE COLLEGE",
"GAYATRI DHAM COLONISERS AND CONSTRUCTIONS (INDIA) LIMITED",
"GAYATRI DIGITAL PRIVATE LIMITED",
"GAYATRI DOORS PRIVATE LIMITED",
"GAYATRI EDUCATION ACADEMY BANGALORE",
"GAYATRI ELECMECH PRIVATE LIMITED",
"GAYATRI ELECTROTECH COMPANY PRIVATE LIMITED",
"GAYATRI ENGIMECH PRIVATE LIMITED",
"GAYATRI ENGINEERING CO PVT LTD",
"GAYATRI ENGINEERING COLLEGE",
"GAYATRI ENGINEERING CONSTRUCTION AND CONSULTANCY PRIVATE LIMITED",
"GAYATRI ENTERPRISES",
"GAYATRI ENTERPRISES INDIA PRIVATE LIMITED",
"GAYATRI FACILITIES AND CORPORATE SERVICES PRIVATE LIMITED",
"GAYATRI FERTIPLANTS INTERNATIONAL PRIVATE LIMITED",
"GAYATRI FOODS PRIVATE LIMITED",
"GAYATRI FORGE PVT LTD",
"GAYATRI GRANITES PRIVATE LIMITED",
"GAYATRI HEALTHCARE PRIVATE LIMITED",
"GAYATRI HERBALS PRIVATE LIMITED",
"GAYATRI HIGHWAYS LIMITED",
"GAYATRI HI-TECH HOTELS LIMITED",
"GAYATRI HOSPITALITY PRIVATE LIMITED",
"GAYATRI HOTELS AND THEATRES PVT LTD",
"GAYATRI INDUSTRIES",
"GAYATRI INFOTECH PRIVATE LIMITED",
"GAYATRI INFRASTRUCTURE LIMITED",
"GAYATRI INSECTICIDE INDIA PRIVATE LIMITED",
"GAYATRI INTERNATIONAL LIMITED",
"GAYATRI IRON & STEELS",
"GAYATRI ISPAT PRIVATE LIMITED",
"GAYATRI JHANSI ROADWAYS LIMITED.",
"GAYATRI LALITPUR ROADWAYS LIMITED.",
"GAYATRI MEGHA INFRASTRUCTURE PRIVATE LIMITED",
"GAYATRI MICRONS LIMITED",
"GAYATRI MULTITEK PRIVATE LIMITED",
"GAYATRI PACKAGING HOUSE PRIVATE LIMITED",
"GAYATRI PAPER MILLS PVT LTD",
"GAYATRI PETROLEUM PRIVATE LIMITED",
"GAYATRI PHARMA",
"GAYATRI PLASTICS PVT LTD",
"GAYATRI POLY PLAST PRIVATE LIMITED",
"GAYATRI POLYCHEM PRIVATE LIMITED",
"GAYATRI POLYRUB PRIVATE LIMITED",
"GAYATRI POULTRIES PRIVATE LIMITED",
"GAYATRI PRIVATE LIMITED",
"GAYATRI PUBLIC SCHOOL AGRA",
"GAYATRI ROADLINES PRIVATE LIMITED",
"GAYATRI ROLLING MILLS PRIVATE LIMITED",
"GAYATRI SANDS PRIVATE LIMITED",
"GAYATRI SATYA INFRAWORKS (INDIA) PRIVATE LIMITED",
"GAYATRI SEEDS AGRO PRIVATE LIMITED",
"GAYATRI SOFTWARE SERVICES PRIVATE LIMITED",
"GAYATRI SPINNERS LIMITED",
"GAYATRI SUPERSILK PVT. LTD.",
"GAYATRI TIMBER PRIVATE LIMITED",
"GAYATRI VIDYA PARISHAD COLLEGE OF ENGINEERING",
"GAYATRI VIDYA PARISHAD COLLEGE OF ENGINEERING FOR WOMEN",
"GAYATRI VIDYA PARISHAD DEGREE COLLEGE",
"GAYATRI VIDYA PARISHAD INSTITUTE OF HEALTHCARE & MEDICAL TECHNOLOGY",
"GAYATRI WEAVERS PRIVATE LIMITED",
"GAYATRI WEBTECH PRIVATE LIMITED",
"GAYATRIDEVI FOODS AND BEVERAGES PRIVATE LIMITED",
"GAYATRIDEVI FURNITURE STUDIO PRIVATE LIMITED",
"GAYATRISHAKTI PAPER & BOARDS LIMITED",
"GAYATRITEX ENGINEERS PRIVATE LIMITED",
"GAYATRREE DOCUTECHS PRIVATE LIMITED",
"GAYESHPUR MUNICIPALITY",
"GAYI ADI HOLDINGS PRIVATE LIMITED",
"GAYLAND HOTELS PRIVATE LIMITED",
"GAYLORD DISTROPOLIS PRIVATE LIMITED",
"GAYLORD SALES PVT LTD",
"GAYLORD SANITARIES PRIVATE LIMITED",
"GAYLORD SPECIALITY FILMS PRIVATE LIMITED",
"GAYMED LABS PRIVATE LIMITED",
"GAYSON & CO PVT LTD",
"GAYTES INFORMATION SYSTEMS PRIVATE LIMITED",
"GAYTRI INDUSTRIAL CORPORATION",
"GAYTRI INDUSTRIAL CORPORATION PRIVATE LIMITED",
"GAZDAR PRIVATE LIMITED",
"GAZE FASHIONTRADE LIMITED",
"GAZEBO CONSTRUCTIONS PRIVATE LIMITED",
"GAZEBO INDUSTRIES PRIVATE LIMITED",
"GAZEL ARCHITECTURES PRIVATE LIMITED",
"GAZELLE INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"GAZIBABA INFRATECH PRIVATE LIMITED",
"GAZICK PRIVATE LIMITED",
"GAZILLIO CONCEPTS PRIVATE LIMITED",
"GAZIPUR BALIKA VIDYALAYA",
"GAZIR MAHAL G C HIGH SCHOOL",
"GAZOLE COLD STORAGE PRIVATE LIMITED",
"GAZON COMMUNICATIONS INDIA LIMITED",
"GAZOOLE TECHNOLOGIES PRIVATE LIMITED",
"GAZPROM EP INTERNATIONAL SERVICES B.V.",
"GAZRAJ SECURITY GUARDS PRIVATET LIMITED",
"GAZROOP ADVERTISING AND COMMUNICATIONS PRIVATE LIMITED",
"GAZTECH ENGINEERING PRIVATE LIMITED",
"GAZTRON ENGINEERING PRIVATE LIMITED",
"GB BAKERS INDUSTRIES PRIVATE LIMITED",
"GB BUILDERS &CONTRACTORS PRIVATE LIMITED",
"GB HOSPITALITY INDIA PRIVATE LIMITED",
"GB INGENEURE PRIVATE LIMITED",
"GB INTERNATIONAL PRIVATE LIMITED",
"GB KORE ARC PRIVATE LIMITED",
"GB LOGISTICS LIMITED",
"GB MULTI CARE HOSPITAL PRIVATE LIMITED",
"GB ORGANIC RICH FOODS PRIVATE LIMITED",
"GB PACK PRIVATE LIMITED",
"GB PANT HOSPITAL",
"GB POWER PROJECTS PRIVATE LIMITED",
"GB RETAILERS PRIVATE LIMITED",
"GB TEX PRIVATE LIMITED",
"GB TOUR AND TRAVELS PRIVATE LIMITED",
"GBAPPA PROJECTS AND SERVICES (OPC) PRIVATE LIMITED",
"GBC INFRASTRUCTURE PRIVATE LIMITED",
"GBC PACKAGING PRIVATE LIMITED",
"GBCC LOGISTICS PRIVATE LIMITED",
"GBEES MART PRIVATE LIMITED",
"GBG SERVICES INDIA PRIVATE LIMITED",
"GBI OILS PRIVATE LIMITED",
"GBIM TECHNOLOGIES PRIVATE LIMITED",
"GBIT INDIA PRIVATE LIMITED",
"GBK TEKSTIL PRIVATE LIMITED",
"GBL CHEMICAL LIMITED",
"GBL LPG PRIVATE LIMITED",
"GBM MANUFACTURING PVT.LTD.",
"GBM MATERIALS PRIVATE LIMITED",
"GBM VAHAAN PRIVATE LIMITED",
"GBMM HIGH SCHOOL VA KANISHTHA MAHAVIDYALAYA HINGANGHAT",
"GBO FREIGHT FORWARDING INTERNATIONAL PRIVATE LIMITED",
"GBP AND ASSOCIATES",
"GBP COTTON PRIVATE LIMITED",
"GBR CLINIC AND FERTILITY CENTRE PRIVATE LIMITED",
"GBR FREIGHT FOREARDERS PRIVATE LIMITED",
"GBR HATCHERIES PRIVATE LIMITED",
"GBR ROBOCOLOR PRIVATE LIMITED",
"GBR SEEDS PRIVATE LIMITED",
"GBS ASSOCIATES",
"GBS ASSOCIATES SC OF THYSSENKRUPP",
"GBS COAL CARRIERS PRIVATE LIMITED",
"GBS HOSPITALITY PRIVATE LIMITED",
"GBS INDIA PRIVATE LIMITED",
"GBS JEWELLERY PRIVATE LIMITED",
"GBS PLUS PRIVATE LIMITED",
"GBS SECURITY SERVICES PRIVATE LIMITED",
"GBS SYSTEMS & SERVICES PRIVATE LIMITED",
"GBS UTILITY AND SERVICES PRIVATE LIMITED",
"GBSM CONSULTING PRIVATE LIMITED",
"GBSSS BHAJAN PURA GOVT SR SECONDERY SCHOOL",
"GBT COMPOSITES TECNOLOGY LIMITED",
"GBT INDIA PRIVATE LIMITED",
"GBTL LIMITED",
"GC CHEMIE PHARMIE LIMITED",
"GC DIAMOND JEWELS PRIVATE LIMITED",
"GC INDIA DENTAL PRIVATE LIMITED",
"GC MEDIA PRIVATE LIMITED",
"GC RAJORIA PRECAST PRIVATE LIMITED",
"GC WEB VENTURES PRIVATE LIMITED",
"GCA CHEMICALS PRIVATE LIMITED",
"GCA TRANSPORT PRIVATE LIMITED",
"GCAK TRADING PRIVATE LIMITED",
"GCAS QUALITY CERTIFICATIONS PRIVATE LIMITED",
"GCB OVERSEAS PRIVATE LIMITED",
"GCB WIRES PRIVATE LIMITED",
"GCC BIOTECH (INDIA) PRIVATE LIMITED.",
"GCC HOTELS PRIVATE LIMITED",
"GCC NORTHSIDE HOTELS PRIVATE LIMITED",
"GCC ORGANIC FOOD PACKING & TRADING PRIVATE LIMITED",
"GCD CONSTRUCTIONS PRIVATE LIMITED",
"GCD ENERGY CONSULTANTS PRIVATE LIMITED",
"GCE INDIA PRIVATE LIMITED",
"GCELL TECHNOLOGIES PRIVATE LIMITED",
"GCENTRI FORCE ENGINEERING PRIVATE LIMITED",
"GCEP SOLAR PRIVATE LIMITED",
"GCET ENGINEERING COLLEGE",
"GCF LOGISTICS PRIVATE LIMITED",
"GCF SHIPPING PRIVATE. LIMITED.",
"GCH INDIA PRIVATE LIMITED",
"G-CHARGE IMPEX PRIVATE LIMITED",
"GCI CASTINGS INDIA PRIVATE LIMITED",
"GCI CONCRETE PIPE MACHINERY PRIVATE LIMITED",
"GCI EXPORTS PRIVATE LIMITED",
"GCJ SHARE BROKERS LIMITED",
"GCK JEWELLERS PRIVATE LIMITED",
"GCK MARKETING PRIVATE LIMITED",
"GCKC PROJECTS AND WORKS PRIVATE LIMITED",
"GCL COMMODITIES PRIVATE LIMITED",
"GCL INTERNATIONAL ASSESSMENT PRIVATE LIMITED",
"GCL SECURITIES PRIVATE LIMITED",
"GCL SYSTEM INTEGRATION TECHNOLOGY (INDIA) PRIVATE LIMITED",
"GCM CAPITAL ADVISORS LIMITED",
"GCM CONVENT SCHOOL",
"GCMC INTERNATIONAL PRIVATE LIMITED",
"GCO TECHNOLOGY CENTER PRIVATE LIMITED",
"GCOOP INDIA PRIVATE LIMITED",
"GCORP BUILDWELL PRIVATE LIMITED",
"G-CORP POWER PRIVATE LIMITED",
"GCORP SPACES PRIVATE LIMITED",
"GCP APPLIED TECHNOLOGIES INDIA PRIVATELIMITED",
"GCPA PRIVATE LIMITED",
"GCR READYMIX CONCRETE PRIVATE LIMITED",
"GCRG GROUP OF INSTITUTIONS",
"GCS AUTOMATION PRIVATE LIMITED",
"GCS MANAGEMENT SOLUTIONS INDIA PRIVATE LIMITED",
"GCS MEDICAL COLLEGE HOSPITAL & RESEARCH CENTRE",
"GCS TRAINING AND SPORTS PRIVATE LIMITED",
"GCT PHARMA RESEARCH (INDIA) PRIVATE LIMITED",
"GCV LIFE PRIVATE LIMITED",
"GCX INDIA SERVICES LIMITED",
"GCX TECHNOLOGIES PRIVATE LIMITED",
"GD DYESTUFF INDUSTRIES LIMITED",
"GD ENVIRONMENTAL PRIVATE LIMITED",
"GD GOENKA GLOBAL PUBLIC SCHOOL",
"GD GOENKA INTERNATIONAL SCHOOL",
"GD GOENKA PRIVATE LIMITED",
"GD GOENKA PUBLIC SCHOOL",
"GD HOSPITAL & DIABETES INSTITUTE A UNIT OF PATAKA IND PVT LTD",
"GD INNOVATIVE SOLUTIONS PRIVATE LIMITED",
"GD LAB SOLUTIONS PRIVATE LIMITED",
"GD RESEARCH CENTER PRIVATE LIMITED",
"GD SCHOOL",
"GD TECH INDIA PRIVATE LIMITED",
"GD. POWER AND CONTROL PRIVATE LIMITED",
"GDA FOODS PRIVATE LIMITED",
"GDA OWNERSHIP PRIVATE LIMITED",
"GDAUTO SERVICES PRIVATE LIMITED",
"GDB FRUITS PRIVATE LIMITED",
"GDB SHARE & STOCK BROKING SERVICES LIMITED",
"GDC BUILDCON PRIVATE LIMITED",
"GDC DIMENSION DATA PRIVATE LIMITED",
"GDC FINE CRAFTED DENTAL PRIVATE LIMITED",
"GDC TECHNOLOGY INDIA PRIVATE LIMITED",
"GDECOR INDUSTRIES INDIA PRIVATE LIMITED",
"GDF EXPORTS PRIVATE LIMITED",
"GDHC TEXTILES PRIVATE LIMITED",
"GDJD EXPORTS",
"GDK JEWELS PRIVATE LIMITED",
"GDK TURBO CARE PRIVATE LIMITED",
"GDKN TECHNOLOGIES INDIA PRIVATE LIMITED",
"GDM PACKAGING PRIVATE LIMITED",
"GDMM COLLEGE OF ENGINEERING & TECHNOLOGY",
"GDN ENTERPRISES PRIVATE LIMITED",
"GDO IT WEB PRIVATE LIMITED",
"GDP AGRO AND FOOD PRODUCTS PRIVATE LIMITED",
"GDPK RETURNABLE SOLUTIONS INDIA PRIVATE LIMITED",
"GDR EDUCATIONAL SOCIETY",
"GDR FABRICS PRIVATE LIMITED",
"GDR MEKTEK PRIVATE LIMITED",
"GDRIVE MOTORS PRIVATE LIMITED",
"GDS CHEMICALS & FERTILISERS PRIVATE LIMITED",
"GDS STERLING GAS AND EQUIPMENTS PRIVATE LIMITED",
"GDSK IMPEX PRIVATE LIMITED",
"GDT INDIA PRIVATE LIMITED",
"GDX FACILITY & MANAGEMENT SERVICES PRIVATE.LIMITED",
"GE (MCTE) MHOW",
"GE BE PRIVATE LIMITED",
"GE CAPITAL SERVICES INDIA",
"GE DRILLING ENGINEERING SERVICES OF INDIA PRIVATE LIMITED",
"GE GLOBAL SOURCING INDIA PRIVATE LIMITED",
"GE GLOBAL TECHNOLOGY SOLUTIONS",
"GE HEALTHCARE GLOBAL PRIVATE LIMITED",
"GE INDIA BUSINESS SERVICES PRIVATE LIMITED",
"GE INDIA INDUSTRIAL PRIVATE LIMITED",
"GE INTELLIGENT PLATFORMS",
"GE LIFE SPACE PRIVATE LIMITED",
"GE OIL & GAS INDIA PRIVATE LIMITED.",
"GE POWER CONVERSION INDIA PRIVATE LIMITED",
"GE POWER ELECTRONICS INDIA PRIVATE LIMITED",
"GE POWER INDIA LIMITED",
"GE POWER SERVICES INDIA LIMITED",
"GE POWER SYSTEMS INDIA PRIVATE LIMITED",
"GE PROJECTS PRIVATE LIMITED",
"GE RENEWABLE R&D INDIA PRIVATE LIMITED",
"GE T&D INDIA LIMITED",
"GE TEK ELECTRONICS PRIVATE LIMITED",
"GE TRIVENI LIMITED",
"GEA BGR ENERGY SYSTEM INDIA LIMITED",
"GEA PROCESS ENGINEERING INDIA PRIVATE LIMITED",
"GEA REFRIGERATION INDIA PRIVATE LIMITED",
"GEA WESTFALIA SEPARATOR INDIA PRIVATE LIMITED",
"GEAKMINDS TECHNOLOGIES PRIVATE LIMITED",
"GEALAN PRIVATE LIMITED",
"GEANIS HOLIDAYS PRIVATE LIMITED",
"GEAR MERCHANDISE PRIVATE LIMITED",
"GEARS AND PINIONS PRIVATE LIMITED",
"GEARS ENERGY SOLUTIONS PRIVATE LIMITED",
"GEARS TECH MICRO SOLUTIONS PRIVATE LIMITED",
"GEARSOFT TECHNOLOGIES PRIVATE LIMITED",
"GEARSPECT INDIA PRIVATE LIMITED",
"GEARTECH ENGINEERS PRIVATE LIMITED",
"GEAR-UP ELECTRIC PRIVATE LIMITED",
"GEAZY TECHNOLOGIES LLP",
"GEBA CABLES AND WIRES INDIA PRIVATE LIMITED",
"GEBBS HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"GEBERIT ELECTRONICS PRIVATE LIMITED",
"GEBERIT INDIA MANUFACTURING PRIVATE LIMITED",
"GEBERIT PLUMBING TECHNOLOGY INDIA PRIVATE LIMITED",
"GEBI PLASTIC PRIVATE LIMITED",
"GEBI PRODUCTS PRIVATE LIMITED",
"GEBR.PFEIFFER INDIA PRIVATE LIMITED",
"GEBURT PLAST PRIVATE LIMITED",
"GECO COIR PRODUCTS PRIVATE LIMITED",
"GECO TRADING CORPORATION PRIVATE LIMITED",
"GECOM INTERNATIONAL PRIVATE LIMITED",
"GECON INDUSTRIES PRIVATE LIMITED",
"GEDCOL SAIL POWER CORPORATION LIMITED",
"GEDEE WEILER PRIVATE LIMITED",
"GEDIA INDIA AUTOMOTIVE COMPONENTS PRIVATE LIMITED",
"GEDORE INDIA PRIVATE LIMITED",
"GEE 7 GRAPHICS PRIVATE LIMITED",
"GEE 7 PRINTEK PRIVATE LIMITED",
"GEE AAR LAMOCOAT PRIVATE LIMITED",
"GEE AAR POWER STEEL INDIA PRIVATE LIMITED",
"GEE BEE LOGISTICS PRIVATE LIMITED",
"GEE BEE NIRMAN CO. PRIVATE LIMITED",
"GEE BEE SECURITIES PRIVATE LIMITED",
"GEE CEE CYCLE BALLS PRIVATE LIMITED",
"GEE CEE HYDRO POWER PRIVATE LIMITED",
"GEE DEE ADVERTISING PRIVATE LIMITED",
"GEE DEE MINING PRIVATE LIMITED",
"GEE EMM SPINFAB PRIVATE LIMITED",
"GEE EMM STEEL INDUSTRIES INDIA PRIVATE LIMITED",
"GEE EMPIRE PRIVATE LIMITED",
"GEE ENN SALES PRIVATE LIMITED",
"GEE ESS EMM JEWELLERS PRIVATE LIMITED",
"GEE ESS PRECISION ENGINEERING PRIVATE LIMITED",
"GEE ESS STEELS PRIVATE LIMITED",
"GEE FILAMENTS PRIVATE LIMITED",
"GEE GEE FABRICS PRIVATE LIMITED",
"GEE GEE FOUNDATIONS PRIVATE LIMITED",
"GEE GEE HIRE PURCHASE & LEASING PRIVATE LIMITED",
"GEE GEE KAY PRIVATE LIMITED",
"GEE GEE ROLLER FLOUR MILLS PVT LTD",
"GEE KAY TRADECOM LIMITED",
"GEE LIMITED",
"GEE PEE AEROSPACE AND DEFENCE PRIVATE LIMITED",
"GEE PEE INTERNATIONAL PRIVATE LIMITED",
"GEE PEE REINFORCED PRODUCTS PRIVATE LIMITED",
"GEE PEE SECURITY SERVICES PRIVATE LIMITED",
"GEE S R INFRA BUILDERS PRIVATE LIMITED",
"GEE SQUARE ELECTRICALS PRIVATE LIMITED",
"GEE SURGICALS PRIVATE LIMITED.",
"GEE TECH AND TRANS PRIVATE LIMITED",
"GEE TEE CEE CARRIERS PRIVATE LIMITED",
"GEE VEE CONSTRUCTIONS LIMITED",
"GEE YESS INDIA ENGINEERING TECHNOLOGY PRIVATE LIMITED",
"GEEBEE EDUCATION PRIVATE LIMITED",
"GEEBEE HOTELS AND RESORTS PRIVATE LIMITED",
"GEEBINCO FOODS PRIVATE LIMITED",
"GEECEE FINCAP LIMITED",
"GEECEE VENTURES LIMITED",
"GEECO ENERCON PRIVATE LIMITED",
"GEECON SYSTEMS PRIVATE LIMITED",
"GEECY ENGINEERING PRIVATE LIMITED",
"GEECY VINCOTTE INDIA PRIVATE LIMITED",
"GEE-DIAMOND STEELS PRIVATE LIMITED",
"GEEK INFORMATIC AND TECHNOLOGIES PRIVATE LIMITED",
"GEEK PICTURES PRIVATE LIMITED",
"GEEK SQUAD PLUS TECHNOLOGIES PRIVATE LIMITED",
"GEEKASSURED TECHNOLOGIES PRIVATE LIMITED",
"GEEKAY BUSINESS ENTERPRISES PRIVATE LIMITED",
"GEEKAY FACILITY MANAGEMENT PRIVATE LIMITED",
"GEEKAY HATCHERIES PRIVATE LIMITED",
"GEEKAY INFOTECH",
"GEEKAY METALS PVT LTD",
"GEEKAY SECURITY SERVICES PRIVATE LIMITED",
"GEEKAY TRARPAULINS AND POLUMERS PRIVATE LIMITED",
"GEEKAY WIRES LIMITED",
"GEEKEN DESIGN CONCEPTS PRIVATE LIMITED",
"GEEKEN SEATING COLLECTION PRIVATE LIMITED",
"GEEKEYES LOGISTICS PRIVATE LIMITED",
"GEEKOM LOGISTECH PRIVATE LIMITED",
"GEEKS INVENTION PRIVATE LIMITED",
"GEEKSOFT CONSULTING PRIVATE LIMITED",
"GEEKTEK CONSULTING INDIA PRIVATE LIMITED",
"GEEKYANTS INDIA PRIVATE LIMITED",
"GEELON INDUSTRIES PRIVATE LIMITED",
"GEENEX SEEDS INDIA PRIVATE LIMITED",
"GEENTANJALI GROUP OF SCHOOLS",
"GEEP INDUSTRIES INDIA PRIVATE LIMITED",
"GEEP POLYMERS INDIA PRIVATE LIMITED",
"GEEPEE SHIPPING AGENCIES PRIVATE LIMITED",
"GEESON ASSOCIATES PRIVATE LIMITED",
"GEESYS TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"GEET DEVELOPERS PRIVATE LIMITED",
"GEET DWELLERS PRIVATE LIMITED",
"GEET FOOD DISTRIBUTOR INDIA PRIVATE LIMITED",
"GEET IMPEX PRIVATE LIMITED",
"GEET SAGAR FOODS PRIVATE LIMITED",
"GEETA ALUMINIUM COMPANY PRIVATE LIMITED",
"GEETA APEX MARKETING LLP",
"GEETA AUTOWHEELS PRIVATE LIMITED",
"GEETA BRIGHT BAR WORKS PRIVATE LIMITED",
"GEETA CARRIERS PRIVATE LIMITED",
"GEETA CONSTRUCTION AND CO",
"GEETA COTTON COMPANY PRIVATE LIMITED",
"GEETA DISTRIBUTORS PRIVATE LIMITED",
"GEETA EDUCATIONAL TRUST",
"GEETA ENGINEERING WORKS PRIVATE LIMITED",
"GEETA FASHIONS PRIVATE LIMITED",
"GEETA FREIGHT FORWARDERS PRIVATE LIMITED",
"GEETA GANESH PROMOTERS PRIVATE LIMITED",
"GEETA GLASS WORKS",
"GEETA GLASSES (INDIA) PRIVATE LIMITED",
"GEETA INDUSTRIES PRIVATE LIMITED",
"GEETA INFOTECH INDIA PRIVATE LIMITED",
"GEETA INTERFAB PRIVATE LIMITED",
"GEETA LABORATORIES PRIVATE LIMITED",
"GEETA MACHINE TOOLS PRIVATE LIMITED",
"GEETA MEDICAL CENTRE PRIVATE LIMITED",
"GEETA MERCHANDISING COMPANY PRIVATE LIMITED",
"GEETA MONITORS PRIVATE LIMITED",
"GEETA POLYMERS PRIVATE LIMITED",
"GEETA POLYPLAST PRIVATE LIMITED",
"GEETA PRECISION COMPONENTS I PRIVATE LIMITED",
"GEETA PRINTS PRIVATE LIMITED",
"GEETA PUMPS PRIVATE LIMITED",
"GEETA SHYAM JEWELLERS PRIVATE LIMITED",
"GEETA SIGNAGES PRIVATE LIMITED",
"GEETA SPINNING MILLS PVT LTD",
"GEETA SURFACE COATINGS PRIVATE LIMITED",
"GEETA TECHNOLOGIES PRIVATE LIMITED",
"GEETA THREADS LIMITED",
"GEETA UDYOG",
"GEETA VIDYALAYA",
"GEETADEVI STEEL INDUSTRIES PRIVATE LIMITED",
"GEETAI PROMOTERS PRIVATE LIMITED",
"GEETAI STEELS PRIVATE LIMITED",
"GEETALAKSHMI MODERN RICE MILL PRIVATE LIMITED",
"GEETANJALI AGRO INDUSTRIES",
"GEETANJALI BULK CARRIERS PRIVATE LIMITED",
"GEETANJALI GROUP OF SCHOOLS",
"GEETANJALI HOSPITAL",
"GEETANJALI INDUSTRIAL MINERALS PRIVATE LIMITED",
"GEETANJALI ISPAT & POWER PRIVATE LIMITED",
"GEETANJALI JR DEGREE PG COLLEGE",
"GEETANJALI MEDICAL COLLEGE & HOSPITAL",
"GEETANJALI PLAST ENGINEERING PRIVATE LIMITED",
"GEETANJALI REALTECH PRIVATE LIMITED",
"GEETANJALI SCHOOL",
"GEETANJALI SOLAR ENTERPRISE",
"GEETANJALI SPICES AND FLAVOURS PRIVATE LIMITED",
"GEETANJALI STUDIO PRIVATE LIMITED",
"GEETANJALI TRADERS PRIVATE LIMITED",
"GEETANJALI TRADING AND INVESTMENTS PRIVATE LIMITED",
"GEETANJALI URBANX PRIVATE LIMITED",
"GEETANJALI VATIKA PRIVATE LIMITED",
"GEETANJALI WOOLLENS PRIVATE LIMITED",
"GEETANJLI SUPERFOOD PRIVATE LIMITED",
"GEETANSH CABLES AND CONDUCTORS PRIVATE LIMITED",
"GEETEE CARRIERS PRIVATE LIMITED",
"GEETEE ENTERPRISES PRIVATE LIMITED",
"GEETEE TOURS PRIVATE LIMITED",
"GEETEE TRAVELS PRIVATE LIMITED",
"GEETESH TOUR AND TRAVELS PRIVATE LIMITED",
"GEETGANGA INVESTMENT PRIVATE LIMITED",
"GEETHA AGENCY",
"GEETHA AGRI SCIENCES INDIA PRIVATE LIMITED",
"GEETHA BOREWELLS PRIVATE LIMITED",
"GEETHA ENGINEERING CONSTRUCTIONS PRIVATE LIMITED",
"GEETHA ENTERTAINMENT PRIVATE LIMITED",
"GEETHA HOSPITALITY SERVICES PRIVATE LIMITED",
"GEETHA KRISHNA SPINNING MILLS PRIVATE LIMITED",
"GEETHA POULTRY PRIVATE LIMITED",
"GEETHA TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"GEETHA TIMBER",
"GEETHAANJALI ALL INDIA SENIOR SECONDARY SCHOOL",
"GEETHALAYA APPARELS PRIVATE LIMITED",
"GEETHAM SOFTWARE PRIVATE LIMITED",
"GEETHANJALI CHIT FUNDS PRIVATE LIMITED",
"GEETHANJALI COLLEGE OF ENGINEERING AND TECHNOLOGY",
"GEETHANJALI HIGH SCHOOL",
"GEETHANJALI MODEL SCHOOL",
"GEETHANJALI PAPER AND BOARDS P LTD",
"GEETHIK TECHNOLOGIES PRIVATE LIMITED",
"GEETIKA BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"GEETIKA PACKAGING INDUSTRIES (INDIA) PRIVATE LIMITED",
"GEETIKA STEEL TRADERS",
"GEETPRIYA HOTELS AND RESORTS PVT.LTD.(TRANS.FROM NCTOFDELHI)",
"GEETRAJ ENGINEERING PRIVATE LIMITED",
"GEETU CONSTRUCTIONS PRIVATE LIMITED",
"GEEVEEAR RUBBERS PRIVATE LIMITED",
"GEEWIZ TECHNOLOGIES PRIVATE LIMITED",
"GEEYAE SYSTEMS PRIVATE LIMITED",
"GEF ADVISORS INDIA PRIVATE LIMITED",
"GEFAB FACADE SOLUTIONS PRIVATE LIMITED",
"GEFCO INDIA PRIVATE LIMITED",
"GEFIT INDIA TECHNOLOGIES PRIVATE LIMITED",
"GEFRAN INDIA PRIVATE LIMITED",
"GEGA INFOTECH PRIVATE LIMITED",
"GEHANA GOLD PALACE PRIVATE LIMITED",
"GEHLOT ENTERPRISES PRIVATE LIMITED",
"GEHLOT MOTORS PRIVATE LIMITED",
"GEHLOT TRACTORS PRIVATE LIMITED",
"GEHNAGOLD PRIVATE LIMITED",
"GEHRING TECHNOLOGIES INDIA PRIVATE LIMITED",
"GEICO PAINT SHOP INDIA PRIVATE LIMITED",
"GEIDEA INFOTECH PRIVATE LIMITED",
"GEIE SOLAR PRODUCTS INDIA PRIVATE LIMITED",
"GEINE TECHNOLOGIES INDIA PRIVATE LIMITED",
"GEISHA DESIGNS PRIVATE LIMITED",
"GEISMAR INDIA PRIVATE LIMITED",
"GEISSEL INDIA PRIVATE LIMITED",
"GEISTLICH PHARMA INDIA PRIVATE LIMITED",
"GEKATEX INDIA PRIVATE LIMITED",
"GEL BUILDREAL PRIVATE LIMITED",
"GEL CRAFT HEALTHCARE PRIVATE LIMITED",
"GEL ENGINEERING (INDIA ) PRIVATE LIMITED",
"GELATO PRINT SERVICES INDIA PRIVATE LIMITED",
"GELCAPS INDUSTRIES",
"GELCO ELECTRONICS PRIVATE LIMITED",
"GELKAPS SPORTS PRIVATE LIMITED",
"GELMEK HEALTHCARE PRIVATE LIMITED",
"GELNOVA LABORATORIES INDIA PRIVATE LIMITED",
"GELOOF SOLUTIONS PRIVATE LIMITED",
"GELRA MINERALS PRIVATE LIMITED",
"GELTEC PRIVATE LIMITED",
"GELTRON TECHNO SYSTEMS PRIVATE LIMITED",
"GEM AGROFOODS PRIVATE LIMITED",
"GEM AIR COMPRESSOR (INDIA) PRIVATE LIMITED",
"GEM ALLIED INDUSTRIES PRIVATE LIMITED",
"GEM AROMATICS LIMITED",
"GEM BUILDHOMES PRIVATE LIMITED",
"GEM CENTRE",
"GEM CLAD WIRES PRIVATE LIMITED",
"GEM CORPOCHEM PRIVATE LIMITED",
"GEM CRAFTS ENTERPRISES PRIVATE LIMITED",
"GEM DRESSWALLA PRIVATE LIMITED",
"GEM EDIBLE OILS PRIVATE. LIMITED.",
"GEM ELECTRICAL TECHNOLOGIES PRIVATE LIMITED",
"GEM ELECTRO MECHANICALS PVT LTD",
"GEM ENGINEERING INDUSTRIES INDIA PRIVATE LIMITED",
"GEM ENGSERV PRIVATE LIMITED",
"GEM ENVIRO MANAGEMENT LIMITED",
"GEM EQUIPMENTS PRIVATE LIMITED",
"GEM EXPORTS PVT LTD",
"GEM FACILITY SERVICES PRIVATE LIMITED",
"GEM FORGINGS PVT LTD",
"GEM GRANIMARMO PRIVATE LIMITED",
"GEM GRANITES PRIVATE LIMITED",
"GEM HOLIDAY RESORTS LIMITED.",
"GEM HOSPITAL AND RESEARCH CENTRE (THRISSUR) PRIVATE LIMITED",
"GEM HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED",
"GEM INTEGRATIONS SERVICES PRIVATE LIMITED",
"GEM INTERNATIONAL PRIVATE LIMITED",
"GEM LABORATORIES PRIVATE LIMITED",
"GEM MACHINING CENTRE PRIVATE LIMITED",
"GEM MANUFACTURERS PRIVATE LIMITED",
"GEM MARBLES (INDIA) PVT LTD",
"GEM MOTORS ( INDIA) PRIVATE LIMITED",
"GEM ORION MACHINERY PRIVATE LIMITED",
"GEM PLANTATIONS AND AGRO PRODUCTS PRIVATE LIMITED",
"GEM PLAZA JEWELLERY MANUFACTURING COMPANY PRIVATE LIMITED",
"GEM POLYTECH INDUSTRIES PRIVATE LIMITED",
"GEM PRECISION TOOL PRIVATE LIMITED",
"GEM PRESSURE SYSTEMS (INDIA) PRIVATE LIMITED",
"GEM PROPERTIES PRIVATE LIMITED",
"GEM RECORDS ENTERTAINMENT PRIVATE LIMITED",
"GEM REFINERIES (1997) PVT. LTD.",
"GEM SANITARY APPLIANCES PRIVATE LIMITED",
"GEM SOFTWARE SOLUTIONS LIMITED",
"GEM STONE BEACH RESORTS PRIVATE LIMITED",
"GEM STONE PRODUCTS PRIVATE LIMITED",
"GEM SUGARS LIMITED",
"GEM SURG EQUIPMENTS PRIVATE LIMITED",
"GEM THREADS (INDIA) PRIVATE LIMITED",
"GEM TREADS PRIVATE LIMITED",
"GEM VIVENDAS PRIVATE LIMITED",
"GEM3S TECHNOLOGIES PRIVATE LIMITED",
"GEMALTO DIGITAL SECURITY PRIVATE LIMITED",
"GEMBEL TRADE ENTERPRISES PRIVATE LIMITED",
"GEMBRILL TECHNOLOGIES INDIA PRIVATE LIMITED",
"GEMBRIO MEDIA & ENTERTAINMENT PRIVATE LIMITED",
"GEMCARE APPLIANCES PRIVATE LIMITED",
"GEMCO CONTROLS LIMITED",
"GEMCO DESIGNS",
"GEMCO ENERGY LIMITED",
"GEMCO KATI EXPLORATION PRIVATE LIMITED",
"GEMCO RUBBER PRIVATE LIMITED",
"GEMCO TECHNOLOGIES PRIVATE LIMITED",
"GEMCORP RECYCLING & TECHNOLOGIES PRIVATE LIMITED",
"GEMCROWN JEWELLERY PRIVATE LIMITED",
"GEMFIELDS (INDIA) PRIVATE LIMITED",
"GEMINI COMMERCE PRIVATE LIMITED",
"GEMINI CONDUCTORS PRIVATE LIMITED",
"GEMINI CONSULTING & SERVICES INDIA PRIVATE LIMITED",
"GEMINI CONTINENTAL PVT LTD",
"GEMINI COOLING SYSTEMS PROJECTS PRIVATE LIMITED",
"GEMINI DAIRY PRODUCTS PRIVATE LIMITED",
"GEMINI DEALCOMM PVT LTD",
"GEMINI DEVELOPERS",
"GEMINI DISTILLERIES (GOA) PRIVATE LIMITED",
"GEMINI DISTILLERIES (JHARKHAND) PRIVATE LIMITED",
"GEMINI DISTILLERIES (TRIPURA) PRIVATE LIMITED",
"GEMINI DYEING & PRINTING MILLS LIMITED.",
"GEMINI DYEING AND PRINTING MILLS LIMITED",
"GEMINI EDIBLES & FATS INDIA LIMITED",
"GEMINI EDIBLES & FATS INDIA PRIVATE LIMITED",
"GEMINI ENGI FAB LIMITED",
"GEMINI ENGI-FAB PRIVATE LIMITED",
"GEMINI EQUIPMENT AND RENTALS PRIVATE LIMITED",
"GEMINI GRAAPHICS PRIVATE LIMITED",
"GEMINI INFRA (INDIA) PRIVATE LIMITED",
"GEMINI INSTRATECH LIMITED",
"GEMINI INTERNATIONAL PRIVATE LIMITED",
"GEMINI MEDICAL NETWORKS PRIVATE LIMITED",
"GEMINI PACKTECH PRIVATE LIMITED",
"GEMINI POWER HYDRAULICS PRIVATE LIMITED",
"GEMINI PROMOTERS AND BUILDERS PRIVATE LIMITED",
"GEMINI SCANS PRIVATE LIMITED",
"GEMINI SECURITY & ALLIED SERVICES PRIVATE LIMITED",
"GEMINI SEEDS PRIVATE LIMITED",
"GEMINI SOFTWARE SOLUTIONS PRIVATE LIMITED",
"GEMINI SOLUTIONS PRIVATE LIMITED",
"GEMINI VALVES AND PUMPS PRIVATE LIMITED",
"GEMINI VET-MIN INDUSTRIES PVT LTD",
"GEMINITEX INDUSTRIES PRIVATE LIMITED",
"GEMINY INDUSTRIAL ENTERPRISES PRIVATE LIMITED",
"GEMINY SEWING MACHINES CO PRIVATE LIMITED",
"GEMIXX EXPORTS PRIVATE LIMITED",
"GEMKO THERMO MECHANIKS PRIVATE LIMITED",
"GEMMA DESIGNER JEWELS PRIVATE LIMITED",
"GEMMED PHARMACEUTICALS PRIVATE LIMITED",
"GEMNIK MANAGEMENT SERVICES PRIVATE LIMITED",
"GEMPACK SYSTEMS PRIVATE LIMITED",
"GEMPERE RENEWABLES PRIVATE LIMITED",
"GEMPULSE INFOTECH PRIVATE LIMITED",
"GEMROSE TEXTILES INDIA PRIVATE LIMITED",
"GEMS & JEWELLERY SKILL COUNCIL OF INDIA",
"GEMS CAMBRIDGE INTERNATIONAL SCHOOL",
"GEMS COMMERCIAL CO LTD",
"GEMS ENGINEERING ENTERPRISES PRIVATE LIMITED",
"GEMS ESSENCE INFOTECH PRIVATE LIMITED",
"GEMS FOREX PRIVATE LIMITED",
"GEMS GENESIS INTERNATIONAL SCHOOL",
"GEMS MEDITECH PRIVATE LIMITED",
"GEMS PRECISION CASTINGS PRIVATE LIMITED",
"GEMSCAB INDUSTRIES LIMITED",
"GEMSCAP GLOBAL ANALYST PRIVATE LIMITED",
"GEMSHI PHARMACEUTICALS PRIVATE LIMITED",
"GEMSICON PRIVATE LIMITED",
"GEMSONS PRECISION ENGINEERING PRIVATE LIMITED",
"GEMSOURCE IT CONSULTING PRIVATE LIMITED",
"GEMSTAR BUILDERS & DEVELOPERS PRIVATE LIMITED",
"GEMSTONE GLASS PRIVATE LIMITED",
"GEMSTONE INVESTMENTS LIMITED",
"GEMTECH POWER CONTROL PRIVATE LIMITED",
"GEMTRACK E-PROCUREMENT PRIVATE LIMITED",
"GEMTREE NATURAL PRODUCE PRIVATE LIMITED",
"GEN ADMIN DEPT Z P CHANDRAPUR",
"GEN CO BANK",
"GEN ENGINEERING SERVICES PRIVATE LIMITED",
"GEN REAL PROPERTY ADVISERS PRIVATE LIMITED",
"GEN X COMMODITIES PRIVATE LIMITED",
"GEN X HOMES PRIVATE LIMITED",
"GEN Y COMMODITIES PRIVATE LIMITED",
"GEN Z SOFTWARE SOLUTIONS PRIVATE LIMITED",
"GENAAUE ENGINEERING PRIVATE LIMITED",
"GENASHI GEMS PRIVATE LIMITED",
"GENAU EXTRUSIONS LIMITED",
"GENAU EXTRUSIONS PRIVATE LIMITED",
"GENAXY SCIENTIFIC PRIVATE LIMITED",
"GENBA SOPANRAO MOZE COLLEGE OF ENGINEERING",
"GENBAND TELECOMMUNICATIONS PRIVATE LIMITED",
"GENBIOCA SCIENCES PRIVATE LIMITED",
"GEN-BIOTEC PRIVATE LIMITED",
"GENCHI INDIA PRIVATE. LIMITED",
"GENCO POWER SWITCHGEARS PRIVATE LIMITED",
"GENCOM LIFESCIENCES PRIVATE LIMITED",
"GENCON ENGINEERING AND CONSTRUCTION PRIVATE LIMITED",
"GENCON INDIA PRIVATE LIMITED",
"GENCOR PACIFIC AUTO ENGINEERING PRIVATE LIMITED",
"GENCOR PACIFIC ORGANICS INDIA PRIVATE LIMITED",
"GENCORP BUSINESS VENTURES LLP",
"GENCOVAL STRATEGIC SERVICES PRIVATE LIMITED",
"GENDASINGH THAKUR PUBLIC SCHOOL TAJBAD 24",
"GENDOX HEALTHCARE PRIVATE LIMITED",
"GENDROIT SR SOLUTION PRIVATE LIMITED",
"GENE LAB BIOTECHNOLOGIES P LIMITED",
"GENEBIO HEALTHCARE PRIVATE LIMITED",
"GENEES PHARMACEUTICAL PRIVATE LIMITED",
"GENEFIED BRAND PROTECTION SOLUTIONS PRIVATE LIMITED",
"GENEHEALTH DIAGNOSTICS PRIVATE LIMITED",
"GENEI LABORATORIES PRIVATE LIMITED",
"GENELAB BIOTECHNOLOGIES PRIVATE LIMITED",
"GENELEK TECH PVT LTD",
"GENELEX INDIA PRIVATE LIMITED",
"GENEMS SYSTEMS PRIVATE LIMITED",
"GENENEST BIOTECH PRIVATE LIMITED",
"GENEOUS PAINT PRIVATE LIMITED",
"GENEPATH DIAGNOSTICS INDIA PRIVATE LIMITED",
"GENER8 INDIA MEDIA SERVICES LIMITED",
"GENERA ONLINE PRIVATE LIMITED",
"GENERACION EOLICA INDIA PRIVATE LIMITED",
"GENERAL ADMINISTRATION DEPARTMENT",
"GENERAL AERONAUTICS PRIVATE LIMITED",
"GENERAL AGENCIES (KOLKATA) PRIVATE LIMITED",
"GENERAL ALLIANCE CONSULTING LLP",
"GENERAL ATLANTIC PRIVATE LIMITED",
"GENERAL AUTOMATION PVT LTD",
"GENERAL AWARI SMRUTI ADHYAPAK COLLEGE",
"GENERAL BLADE TECHNOLOGY PRIVATE LIMITED",
"GENERAL CABLE ENERGY INDIA PRIVATE LIMITED",
"GENERAL COMMERCE LIMITED",
"GENERAL COMMODITIES PRIVATE LIMITED",
"GENERAL CONNECTORS (INDIA) PRIVATE LIMITED",
"GENERAL DATA PVT LTD",
"GENERAL DATUM PRODUCT DESIGN PRIVATE LIMITED",
"GENERAL DIAGNOSTICS INTERNATIONAL PRIVATE LIMITED",
"GENERAL DRUG PRIVATE LIMITED",
"GENERAL EDUCATION DEPARTMENT KERALA",
"GENERAL EDUCATION INSTITUTE",
"GENERAL ELECTION COLLECTORATE KORBA",
"GENERAL ELECTRIC",
"GENERAL ELECTRIC INTERNATIONAL OPERATIONS COMPANY INC.",
"GENERAL ENERGY MANAGEMENT SYSTEMS PRIVATE LIMITED",
"GENERAL ENGINEERING WORKS",
"GENERAL ENVIRO TECH PRIVATE LIMITED",
"GENERAL FOODS AND INGREDIENTS PRIVATE LIMITED",
"GENERAL HOSPITAL ANAND",
"GENERAL HOSPITAL KHEDA",
"GENERAL HOSPITAL SIDHPUR",
"GENERAL HOSPITAL VYARA",
"GENERAL IMPORT COMPANY (INDIA) PRIVATE LIMITED",
"GENERAL IMSUBS PRIVATE LIMITED",
"GENERAL INDUSTRIAL CONTROLS PRIVATE LIMITED",
"GENERAL INFRA PROJECTS PRIVATE LIMITED",
"GENERAL INSURANCE CORPN OF INDIA",
"GENERAL INSURANCE CORPORATION OF INDIA",
"GENERAL MANAGER DISTRICT INDUSTRIES CENTRE NAGPUR",
"GENERAL MANAGER DISTRICT INDUSTRIES CENTRE UTTAR PRADESH",
"GENERAL MANAGER GOVT MILK SCHEME MIRAJ",
"GENERAL MARITIME INDIA PRIVATE LIMITED",
"GENERAL METALLISERS PRIVATE LIMITED",
"GENERAL MILLS INDIA PRIVATE LIMITED",
"GENERAL MOBILE TECHNOLOGY INDIA PRIVATE LIMITED",
"GENERAL MOTORS TECHNICAL CENTRE INDIA PRIVATE LIMITED",
"GENERAL OFFSET PRINTING PRESS PRIVATE LIMITED",
"GENERAL OPTICS ASIA LIMITED",
"GENERAL PETROCHEMICALS LIMITED",
"GENERAL PRODUCE & OILSEEDS PRIVATE LIMITED",
"GENERAL PUMPS PRIVATE LIMITED",
"GENERAL SEAL CO PVT LTD",
"GENERAL SECURITY AND INFORMATION SERVICES INDIA PRIVATE LIMITED",
"GENERAL STORES & AGENCY PVT LTD",
"GENERAL STORES & ENGINEERING COMPANY PRIVATE LIMITED",
"GENERAL STREET MARKETING PRIVATE LIMITED",
"GENERAL TECHNOLOGIES INDIA PRIVATE LIMITED",
"GENERAL TRAVELS (INDIA) PRIVATE LIMITED",
"GENERAL TYRE AND TREADS PRIVATE LIMITED",
"GENERAL WIRE INDUSTRIES PRIVATE LIMITED",
"GENERALE BANK",
"GENERATION FOUR ENGITECH LIMITED",
"GENERATION INDIA FOUNDATION",
"GENERATION NXT COMPMART PRIVATE LIMITED",
"GENEREX PHARMASSIST PRIVATE LIMITED",
"GENERGY BUILDING SYSTEMS PRIVATE LIMITED",
"GENERIC CROP SCIENCES PRIVATE LIMITED",
"GENERIC FASHIONS (INDIA) PRIVATE LIMITED",
"GENERIC HEALTHCARE PRIVATE LIMITED",
"GENERIC SOLUTIONS INDIA PRIVATE LIMITED",
"GENERIC SUPERMART INDIA PRIVATE LIMITED",
"GENERICA INDIA LIMITED",
"GENERICART MEDICINE PRIVATE LIMITED",
"GENERICPLUS PHARMACY PRIVATE LIMITED",
"GENERILIFE PRIVATE LIMITED",
"GENERIS TEK STAFFING PRIVATE LIMITED",
"GENERIX LIFESCIENCES PRIVATE LIMITED",
"GENERONS ENERGY PRIVATE LIMITED",
"GENEROUS BUILDWELL PRIVATE LIMITED",
"GENES 2ME PRIVATE LIMITED",
"GENESIA PHARMACEUTICALS (INDIA) PRIVATE LIMITED",
"GENESIS ADVERTISING PVT LTD",
"GENESIS ARCHITECTS PRIVATE LIMITED",
"GENESIS ARTIFICIAL INTELLIGENCE PRIVATE LIMITED",
"GENESIS BCW PRIVATE LIMITED",
"GENESIS BUILDWELL PRIVATE LIMITED",
"GENESIS CARGO PRIVATE LIMITED",
"GENESIS CLASSES PRIVATE LIMITED",
"GENESIS COLORS LIMITED",
"GENESIS COLORS PRIVATE LIMITED",
"GENESIS COMPUSERVE PRIVATE LIMITED",
"GENESIS CONTAINER LINE (INDIA) PRIVATE LIMITED",
"GENESIS COUTURE PRIVATE LIMITED",
"GENESIS CROP SCIENCES (INDIA) PRIVATE LIMITED",
"GENESIS DREAM MERCHANTS PRIVATE LIMITED",
"GENESIS ELECTRICALS PRIVATE LIMITED",
"GENESIS EVALUATIONS PRIVATE LIMITED",
"GENESIS FACILITIES MANAGEMENT PRIVATE LIMITED",
"GENESIS FINANCE COMPANY LIMITED",
"GENESIS GAS SOLUTIONS PRIVATE LIMITED",
"GENESIS GLOBAL SCHOOL",
"GENESIS HEALTHCARE INDIA PRIVATE LIMITED",
"GENESIS HOSPITAL PRIVATE LIMITED",
"GENESIS INFOSERVE PRIVATE LIMITED",
"GENESIS INFOSOFT PRIVATE LIMITED",
"GENESIS INSTITUTE OF MEDICAL SCIENCE PRIVATE LIMITED",
"GENESIS INTERNATIONAL SCHOOL",
"GENESIS IT INNOVATIONS LIMITED.",
"GENESIS LA MODE PRIVATE LIMITED",
"GENESIS LEARNING INITIATIVES PRIVATE LIMITED",
"GENESIS LUXURY FASHION PRIVATE LIMITED",
"GENESIS MEDIA PRIVATE LIMITED",
"GENESIS MEMBRANE SEPRATECH PRIVATE LIMITED",
"GENESIS PACASSIST PRIVATE LIMITED",
"GENESIS PACKAGING PRIVATE LIMITED",
"GENESIS PAPER ART PRIVATE LIMITED",
"GENESIS PLANNERS PRIVATE LIMITED",
"GENESIS PORTFOLIO PRIVATE LIMITED",
"GENESIS POWER EQUIPMENTS PRIVATE LIMITED",
"GENESIS POWERONICS INDIA PRIVATE LIMITED",
"GENESIS RISK MITIGATION SERVICES PRIVATE LIMITED",
"GENESIS ROYAL INFIRMARY PRIVATE LIMITED",
"GENESIS SALES PRIVATE LIMITED",
"GENESIS SCADA SOLUTIONS PRIVATE LIMITED",
"GENESIS SYNTHETICS PRIVATE LIMITED",
"GENESIS VITAL PROCESSORS PRIVATE LIMITED",
"GENESIS WASTE HANDLING PRIVATE LIMITED",
"GENESIS WINDOORS PRIVATE LIMITED",
"GENESIS WORKFORCE PRIVATE LIMITED",
"GENEST ENGINEERS PVT LTD",
"GENESTORE INDIA PRIVATE LIMITED",
"GENESTRINGS DIAGNOSTIC CENTRE PRIVATE LIMITED",
"GENESYS PROJECTS & ASSOCIATES PRIVATE LIMITED",
"GENETEK LIFESCIENCES PRIVATE LIMITED",
"GENETIC INDUSTRIES PRIVATE LIMITED",
"GENETIC SEEDS PRIVATE LIMITED",
"GENETIX BIOTECH ASIA PRIVATE LIMITED",
"GENEV CAPITAL PRIVATE LIMITED",
"GENEW INDIA TELECOM PRIVATE LIMITED",
"GENEX CONTAINERS PRIVATE LIMITED",
"GENEX CORPORATE SERVICES PRIVATE LIMITED",
"GENEX HOTELS PRIVATE LIMITED",
"GENEX INDIA BIOSCIENCE PRIVATE LIMITED",
"GENEX LABORATORIES PRIVATE LIMITED",
"GENEX LIFE SCIENCES PRIVATE LIMITED",
"GENEX LOGISOLUTIONS PRIVATE LIMITED",
"GENEX POLYTECH PRIVATE LIMITED",
"GENEXIS AUTOMOBILE SOLUTIONS PRIVATE LIMITED",
"GENEXIS BIOTECH PRIVATE LIMITED",
"GENEXIS BUSINESS PROCESS SERVICES PRIVATE LIMITED",
"GENEXPLORE DIAGNOSTICS AND RESEARCH CENTER PRIVATE LIMITED",
"GENEXT BUILDCON PRIVATE LIMITED",
"GENEXT GREEN POWER SOLUTIONS PRIVATE LIMITED",
"GENEXT HARDWARE & PARKS PRIVATE LIMITED",
"GENEXT INTERNATIONAL PRIVATE LIMITED",
"GENEXT LOGISTICS PRIVATE LIMITED",
"GENEXT PRECISION AUTO INDIA PRIVATE LIMITED",
"GENEXT PRECISION AUTO TECH PRIVATE LIMITED",
"GENEXT STUDENTS PRIVATE LIMITED",
"GENEZA SOLUTIONS PRIVATE LIMITED",
"GENFO BIOCEUTICALS PRIVATE LIMITED",
"GENFORD DRUGS PRIVATE LIMITED",
"GENI TRAINING SERVICES PRIVATE LIMITED",
"GENIAL POLYMERS PRIVATE LIMITED",
"GENICON BUSINESS SOLUTIONS PRIVATE LIMITED",
"GENICS ELECTROTECH PRIVATE LIMITED",
"GENICS TECHSOL PRIVATE LIMITED",
"GENICUS RETAIL INDIA PRIVATE LIMITED",
"GENID SHIPPING & LOGISTICS PRIVATE LIMITED",
"GENIE AUTO PRODUCTS PRIVATE LIMITED",
"GENIE BAZAAR PRIVATE LIMITED",
"GENIE COMMERCIAL VENTURES PRIVATE LIMITED",
"GENIE EXPORTS PRIVATE LIMITED",
"GENIE INFOTECH PRIVATE LIMITED",
"GENIE PRECISION PRIVATE LIMITED",
"GENIE SOFTSYSTEM PRIVATE LIMITED",
"GENIE TRANSVISIONS PRIVATE LIMITED",
"GENIEHR SOLUTIONS PRIVATE LIMITED",
"GENIELAND KREATIONS PRIVATE LIMITED",
"GENIEMODE PRIVATE LIMITED",
"GENIETALK PRIVATE LIMITED",
"GENII ENGINEERING & SERVICES PRIVATE LIMITED",
"GENIIES IT & SERVICES PRIVATE LIMITED",
"GENIKO AGROVET PRIVATE LIMITED",
"GENINS INDIA INSURANCE TPA LIMITED",
"GENINVO TECHNOLOGIES PRIVATE LIMITED",
"GENIP PHARMACEUTICALS PRIVATE LIMITED",
"GENIQE ENGINEERING AND ELECTRONICS PRIVATE LIMITED",
"GENIQUE MEDCROP PRIVATE LIMITED",
"GENIST TECHNOCRACY PRIVATE LIMITED",
"GENISUN POWER SOLUTION PRIVATE LIMITED",
"GENISYS INFORMATION SYSTEMS INDIA PRIVATE LIMITED",
"GENISYS INTEGRATING SYSTEM INDIA PRIVATE LIMITED",
"GENITUS HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"GENIUIS COLLEGE",
"GENIUS AIRCON PRIVATE LIMITED",
"GENIUS ATTESTATION SERVICES AND IT SOLUTIONS PRIVATE LIMITED",
"GENIUS BUSINESS SOLUTIONS INDIA PRIVATE LIMITED",
"GENIUS CONSULTANTS LIMITED",
"GENIUS CORNER EDUCOM PRIVATE LIMITED",
"GENIUS EDUCATIONAL ACADEMY",
"GENIUS ELECTRICALS & ELECT.PRIVATE LIMITED",
"GENIUS ENGINEERING PVT LTD",
"GENIUS FABRICS PRIVATE LIMITED",
"GENIUS FOODS PRIVATE LIMITED",
"GENIUS INDUSTRIES LIMITED",
"GENIUS KIDS INTERNATIONAL PRE PRIMARY SCHOOL",
"GENIUS MONEY CHANGERS PRIVATE LIMITED",
"GENIUS ORTHO PRIVATE LIMITED",
"GENIUS PRESENTATION PRIVATE LIMITED",
"GENIUS PROTECTION SYSTEM PRIVATE LIMITED",
"GENIUS PUBLIC SCHOOL",
"GENIUS TALENTS & SERVICES PRIVATE LIMITED",
"GENIUS VANGUARD PRIVATE LIMITED",
"GENIUSCRATE EDUTAINMENT PRIVATE LIMITED",
"GENIUSENERGY CRITICAL INNOVATION PRIVATE LIMITED",
"GENIUSU WEB SERVICES PRIVATE LIMITED",
"GENIX HEALTH CARE PRIVATE LIMITED",
"GENIX LIFESCIENCE PRIVATE LIMITED",
"GENIX SPECIALITIES PRIVATE LIMITED",
"GENIX TECHNOLOGIES PRIVATE LIMITED",
"GENIXO INFO SOLUTIONS PRIVATE LIMITED",
"GENLABS HEALTHCARE PRIVATE LIMITED",
"GENLEAP ECOSYSTEM PRIVATE LIMITED",
"GENLISH EDUCATION PRIVATE LIMITED",
"GENLITE ENGINEERING PRIVATE LIMITED",
"GENMARC RESEARCH PRIVATE LIMITED",
"GENMART GENERIC PRIVATE LIMITED",
"GENMED SHOPPES PRIVATE LIMITED",
"GENMEDIC HEALTHCARE PRIVATE LIMITED",
"GENMICE MEDIA PRIVATE LIMITED",
"GENN CONTROLS INDIA PRIVATE LIMITED",
"GENNEW TECHNOLOGY PRIVATE LIMITED",
"GENNEXT ABASAN PRIVATE. LIMITED.",
"GENNEXT CONCRETE PRIVATE LIMITED.",
"GENNEXT CROP SCIENCE PRIVATE LIMITED",
"GENNEXT DIAGNOSTICS & RESEARCH PRIVATE LIMITED",
"GENNEXT INSURANCE BROKERS PRIVATE LIMITED",
"GENNEXT LAB TECHNOLOGIES PRIVATE LIMITED",
"GENNEXT MOTORS(ANDAMANS) PRIVATE LIMITED",
"GENNEXT PLM PRIVATE LIMITED",
"GENNOVA BIOPHARMACEUTICALS LIMITED",
"GENNX360 INDIA ADVISORS PRIVATE LIMITED",
"GEN-NXT PLASTIC TECHNOLOGIES PRIVATE LIMITED",
"GENO BIOSCIENCES PRIVATE LIMITED",
"GENO PHARMACEUTICALS PRIVATE LIMITED",
"GENOA MARITIME LIMITED",
"GENOME AGRITECH PRIVATE LIMITED",
"GENOME DIAGNOSTICS PRIVATE LIMITED",
"GENOME INTERNATIONAL INDIA PRIVATE LIMITED",
"GENOMELABS BIO PRIVATE LIMITED",
"GENOMIX AGRI GENETICS PRIVATE LIMITED",
"GENOMIX PHARMACEUTICALS PRIVATE LIMITED",
"GENONE OPTECH PRIVATE LIMITED",
"GENOTECH PHARMACEUTICALS PRIVATE LIMITED",
"GENOTYPIC TECHNOLOGY PRIVATE LIMITED",
"GENOVA BIO TECHNIQUES PRIVATE LIMITED",
"GENOVA FORGING & AUTOMATION PRIVATE LIMITED",
"GENOVO DEVELOPMENT SERVICES LIMITED",
"GENPACT ENTERPRISE RISK CONSULTING LLP",
"GENPACT HEADSTRONG CAPITAL MARKETS",
"GENPACT INDIA PRIVATE LIMITED",
"GENPACT MOBILITY SERVICES INDIA PRIVATE LIMITED",
"GENPACT SERVICES LLC",
"GENPHARMASEC LIMITED",
"GENPRO RESEARCH PRIVATE LIMITED",
"GENPURE TECHNOLOGIES PRIVATE LIMITED",
"GENPURE ZHENG FILTERS PRIVATE LIMITED",
"GENRAL ADMINISTRATION",
"GENRET ENERGY SOLUTIONS PRIVATE LIMITED",
"GENRIC SOLUTIONS PRIVATE LIMITED",
"GENRICH MEMBRANES PRIVATE LIMITED",
"GENRISE GLOBAL STAFFING PRIVATE LIMITED",
"GENROBOTIC INNOVATIONS PRIVATE LIMITED",
"GENS ELECTRICAL SOLUTIONS PRIVATE LIMITED",
"GENSCRIPT HEALTHCARE INDIA PRIVATE LIMITED",
"GENSER AEROSPACE AND INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"GENSET INDIA PVT LTD",
"GENSIG SOFTWARE SERVICES INDIA PRIVATE LIMITED",
"GENSLER DESIGN INDIA PRIVATE LIMITED",
"GENSOL CONSULTANTS PRIVATE. LIMITED.",
"GENSOL ENGINEERING LIMITED",
"GENSOL ENGINEERING PRIVATE LIMITED",
"GENSOL VENTURES PRIVATE LIMITED",
"GENSOURCE PHARMA SOLUTIONS PRIVATE LIMITED",
"GENSTAR NETWORK SOLUTIONS PRIVATE LIMITED",
"GENSTRU CONSULTANTS PRIVATE LIMITED",
"GENSUN RENEWABLES PRIVATE LIMITED",
"GENSYNTH LABORATORIES PRIVATE LIMITED",
"GENSYS TECHNOLOGIES PRIVATE LIMITED",
"GENTEC EPC PRIVATE LIMITED",
"GENTECH CROP SCIENCES PRIVATE LIMITED",
"GENTECH HEALTHCARE PRIVATE LIMITED",
"GENTECH MARKETING AND DISTRIBUTION PRIVATE LIMITED",
"GENTECH TOOLINGS PRIVATE LIMITED",
"GENTEX MERCHANTS PRIVATE LIMITED",
"GENTILS ORGANICS PRIVATE LIMITED",
"GENTING CROP SCIENCES PRIVATE LIMITED",
"GENTING LANCO POWER (INDIA) PRIVATE LIMITED",
"GENTING LANCO POWER INDIA PRIVATE LIMITED",
"GENTLE BIO-SCIENCES PRIVATE LIMITED",
"GENTLE ENTERTAINMENT PRIVATE LIMITED",
"GENTLE FOOTCARE PRIVATE LIMITED",
"GENTLEMAN PRODUCTS PRIVATE LIMITED",
"GENTLEMAN SUITINGS PVT. LTD.",
"GENTLEMAN1 MANAGEMENT SERVICES PRIVATE LIMITED",
"GENTRUST CONSUMER DURABLES PRIVATE LIMITED",
"GENU PATH LABS LIMITED",
"GENUINE AGENCIES PRIVATE LIMITED",
"GENUINE ASSETS OPERATORS PRIVATE LIMITED",
"GENUINE BIOSYSTEM PRIVATE LIMITED",
"GENUINE CERAMIC PRIVATE LIMITED",
"GENUINE CNC AND AUTOMATION SERVICES PRIVATE LIMITED",
"GENUINE COMMODEAL PRIVATE LIMITED",
"GENUINE ELECTRIC COMPANY PRIVATE LIMITED",
"GENUINE FERT & PEST PRIVATE LIMITED",
"GENUINE INNOVATIONS PRIVATE LIMITED",
"GENUINE ITES PRIVATE LIMITED",
"GENUINE MEDICA PRIVATE LIMITED",
"GENUINE PARTS COMPANY",
"GENUINE SEEDS PRIVATE LIMITED",
"GENUINE SHELL CARB PRIVATE LIMITED",
"GENUINE STOCK BROKERS PRIVATE LIMITED",
"GENUINE TELE INFRA PRIVATE LIMITED",
"GENUINE TRAVELS PRIVATE LIMITED",
"GENUINE X-RAY AND RADIOLOGICAL EQUIPMENTS PRIVATE LIMITED",
"GENUS APPARELS LIMITED",
"GENUS BREEDING INDIA PRIVATE LIMITED",
"GENUS ELECTROTECH LIMITED",
"GENUS INNOVATION LIMITED",
"GENUS PAPER & BOARDS LIMITED",
"GENUS PAPER AND COKE LIMITED",
"GENUS POWER INFRASTRUCTURES LIMITED",
"GENUUS BRAND ADVISORY PRIVATE LIMITED",
"GENVOLT INDIA PRIVATE LIMITED",
"GENWI TECHNOLOGY INDIA PRIVATE LIMITED",
"GENWORKS HEALTH PRIVATE LIMITED",
"GENWORTH FINANCIAL INC.",
"GEN-X ABODE PRIVATE LIMITED",
"GENX DIAGNOSTICS LIMITED",
"GENX DIAGNOSTICS PRIVATE LIMITED",
"GENX INFO TECHNOLOGIES PRIVATE LIMITED",
"GENX PHARMA LIMITED",
"GENX PHARMA PRIVATE LIMITED",
"GENXBIO HEALTH SCIENCES PRIVATE LIMITED",
"GENXLEAD RETAIL PRIVATE LIMITED",
"GENXLEAD SOLUTIONS PRIVATE LIMITED",
"GENZEON TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"GENZYME INDIA PRIVATE LIMITED",
"GEO ADITHYA TECHNOLOGIES PRIVATE LIMITED",
"GEO CARGO EXPRESS PRIVATE LIMITED",
"GEO CHEM LABORATORIES PRIVATE LIMITED",
"GEO CLIMATE RISK SOLUTIONS PRIVATE LIMITED",
"GEO CLOTHING PRIVATE LIMITED",
"GEO CONNECT LIMITED",
"GEO CONSTECH PRIVATE LIMITED",
"GEO DESIGNS AND RESEARCH PRIVATE LIMITED",
"GEO ENGINEERING CO PRIVATE LIMITED",
"GEO ENGINEERRING SOLUTION PRIVATE LIMITED",
"GEO ENVIRO ENGINEERS PRIVATE LIMITED",
"GEO EXPLORATION SERVICESS",
"GEO FOUNDATIONS & STRUCTURES PRIVATE. LIMITED.",
"GEO GRAPHICS INTERIORS PRIVATE LIMITED",
"GEO INFORMATICS CONSULTANTS PRIVATE LIMITED",
"GEO MEDIA ENGINEERING & CONSULTANCY SERVICES PRIVATE LIMITED",
"GEO METAL RESOURCES PRIVATE LIMITED",
"GEO MILLER AND COMPANY PRIVATE LIMITED TRANS W B TO DELHI",
"GEO NATURAL FIBERS (INDIA) PRIVATE LIMITED",
"GEO NUTRI FOODS PRIVATE LIMITED",
"GEO PLANET SOLUTION PRIVATE LIMITED",
"GEO RESOURCE MAPPING PRIVATE LIMITED",
"GEO SALES PRIVATE LIMITED",
"GEO TRANS INTERNATIONAL PRIVATE LIMITED",
"GEO VPL FINANCE PRIVATE LIMITED",
"GEOADS MEDIA PRIVATE LIMITED",
"GEOALGO TECHNOLOGIES PRIVATE LIMITED",
"GEOAMPS INDIA PRIVATE LIMITED",
"GEOAQUATIC PRODUCTS PRIVATE LIMITED",
"GEOBRUGG INDIA PRIVATE LIMITED",
"GEOCENTROID PRIVATE LIMITED",
"GEO-CHEM INSURANCE SURVEYORS AND LOSS ASSESSORS PRIVATE LIMITED",
"GEO-CHEM LABORATORIES RAJKOT PRIVATE LIMITED",
"GEOCITY NETWORK SOLUTIONS PRIVATE LIMITED",
"GEOCON INTERNATIONAL PRIVATE LIMITED",
"GEOCONSULT INDIA PRIVATE LIMITED",
"GEOCUBE LOGISTICS PRIVATE LIMITED",
"GEOCULT PRODUCTS EXIM PRIVATE LIMITED",
"GEODESIC STRUCTURALS PRIVATE LIMITED",
"GEODESY MAPPING SOLUTIONS PRIVATE LIMITED",
"GEODIGITAL MEDIA PRIVATE LIMITED",
"GEODIS INDIA PRIVATE LIMITED",
"GEODIS OVERSEAS PRIVATE LIMITED",
"GEODRAFT CONSULTANCY INDIA PRIVATE LIMITED",
"GEOEDGE TECHNOLOGIES PRIVATE LIMITED",
"GEOENIX SOLUTIONS PRIVATE LIMITED",
"GEOENPRO PETROLEUM LIMITED",
"GEOEPC MANAGEMENT ADVISORS PRIVATE LIMITED",
"GEOFAST FLOUR MILLS PRIVATE LIMITED",
"GEOFAST INDUSTRIES (INDIA) LIMITED",
"GEOFAST PRIVATE LIMITED",
"GEOFFERY MANNERS AND CO LIMITED",
"GEOFIN COMTRADE LIMITED",
"GEOFIN INVESTMENTS PRIVATE LIMITED",
"GEOFLAIR GREENTECH INDIA PRIVATE LIMITED",
"GEOFLUID PROCESSORS PRIVATE LIMITED",
"GEO-FRESH ORGANIC PRIVATE LIMITED",
"GEOGEMMS GENUINE PRIVATE LIMITED",
"GEOGICAL STRUCTIAL INFRA PRIVATE LIMITED",
"GEOGRAPHICAL INDICATIONS TAGGED WORLD PREMIUM PRODUCTS PRIVATE LIMITED",
"GEOGRAPHICS INFRASTRUCTURE PRIVATE LIMITED",
"GEOGRAPHIS (INDIA) PRIVATE LIMITED",
"GEOID CONSULTANCY PRIVATE LIMITED",
"GEOID RESOURCES PRIVATE LIMITED",
"GEOJIT CREDITS PRIVATE LIMITED",
"GEOJIT FINANCIAL SERVICES LIMITED",
"GEOJIT TECHNOLOGIES PRIVATE LIMITED",
"GEOK ENERGY PRIVATE LIMITED",
"GEOKNO INDIA PRIVATE. LIMITED.",
"GEOLIFE AGRITECH INDIAD PRIVATE LIMITED",
"GEOLOGICAL SURVEY OF INDIA",
"GEOLOGICAL SURVEY OF INDIA NORTHERN REGION LUCKNOW",
"GEOLOGICAL SURVEY OFINDIA",
"GEOLOGISTS SYNDICATE PVT LTD",
"GEOLOGIX LIMITED",
"GEOLOGIX TECHNOSOFT PRIVATE LIMITED",
"GEOMARINE DYNAMICS (INDIA) PRIVATE LIMITED",
"GEOMATRIX MACHINING SOLUTION PRIVATE LIMITED",
"GEOMATT EQUIPMENT RENTALS PRIVATE LIMITED",
"GEOMAX PLASTCHEM (INDIA) PRIVATE LIMITED",
"GEOMAX POSITIONING SYSTEMS PRIVATE LIMITED",
"GEOMETRIC RESULTS INTERNATIONAL INDIA PRIVATE LIMITED",
"GEOMETRIC STEELS ROLL FORMING PRIVATE LIMITED",
"GEOMETRICS AIRFIELDS PRIVATE LIMITED",
"GEOMETRICS SPACE STRUCTURES PRIVATE LIMITED",
"GEOMETRIX AUTOMATION AND ROBOTICS PRIVATE LIMITED",
"GEOMETRY GLOBAL INDIA PRIVATE LIMITED",
"GEOMETRY METAL TECH PRIVATE LIMITED",
"GEOMIN INDUSTRIES PRIVATE LIMITED",
"GEOMIN METALLOY PRIVATE LIMITED",
"GEOMOVERS INFRA PRIVATE LIMITED",
"GEOMYSORE SERVICES INDIA PRIVATE LIMITED",
"GEONAIR AIRCONDITION AND REFRIGERATION MANUFACTURERS PRIVATE LIMITED",
"GEONE SOLAR PRIVATE LIMITED",
"GEONET IT MALL PRIVATE LIMITED",
"GEONIX INTERNATIONAL PRIVATE LIMITED",
"GEONXT INFO SOLUTIONS PRIVATE LIMITED",
"GEOPOWER INDIA PRIVATE LIMITED",
"GEOPRENEUR CORP PRIVATE LIMITED",
"GEORG FISCHER PIPING SYSTEMS PRIVATE LIMITED",
"GEORGE & GEM'S PHARMACEUTICALS PRIVATE LIMITED",
"GEORGE AND GEORGE HYGIENE PRODUCTS PRIVATE LIMITED",
"GEORGE CLINICAL INDIA PRIVATE LIMITED",
"GEORGE COLLEGE OF MANAGEMENT AND SCIENCE",
"GEORGE INSOFT PVT LTD",
"GEORGE INSTITUTE FOR GLOBAL HEALTH",
"GEORGE MAIJO AUTOMOBILES PRIVATE LIMITED",
"GEORGE MAIJO INDUSTRIES PRIVATE LIMITED",
"GEORGE OAKES LIMITED",
"GEORGE P JOHNSON EVENT MARKETING PRIVATE LIMITED",
"GEORGE RAO AND COMPANY ENGG PRIVATE LIMITED",
"GEORGE TOWN CO-OPERATIVE URBAN BANK LIMITED",
"GEORGIAN ENTERPRISES PRIVATE LIMITED",
"GEORGIAN FOOD PRODUCTS PRIVATE LIMITED",
"GEORSON TECH PRIVATE LIMITED",
"GEOSANSAR ADVISORS PRIVATE LIMITED",
"GEOSERVEX HUB INDIA PRIVATE LIMITED",
"GEOSERVICES MARITIME PRIVATE LIMITED",
"GEOSHINE GEMS INDIA PRIVATE LIMITED",
"GEOSMATIC COSMECEUTICALS & COSMOCARE PRIVATE LIMITED",
"GEOSMINFARMS PRIVATE LIMITED",
"GEOSPATIAL DATA ANALYTICS PRIVATE LIMITED",
"GEOSPATIAL DELHI LIMITED",
"GEOSPATIAL MEDIA AND COMMUNICATIONS PRIVATE LIMITED",
"GEOSPHERE INDUSTRIES PRIVATE LIMITED",
"GEOSPOT MEDIA PRIVATE LIMITED",
"GEOSTAR SURVEYS INDIA PRIVATE LIMITED",
"GEOSTAT INFORMATICS (INDIA) PRIVATE LIMITED",
"GEOSTAT TECHNOLOGIES PRIVATE LIMITED",
"GEOSTEP IT INDIA PRIVATE LIMITED",
"GEOSTORM INFRAINDIA PRIVATE LIMITED",
"GEOSYS INDIA INFRASTRUCTURES LIMITED",
"GEOSYSTEMS AND SURVEY SOFTWARES PRIVATE LIMITED",
"GEO-TEC INTERNATIONAL PRIVATE LIMITED",
"GEOTECH GEOSPATIAL PRIVATE LIMITED",
"GEOTECH INDUSTRIES PRIVATE LIMITED",
"GEOTECH INFOSERVICES PRIVATE LIMITED",
"GEOTECH INFRAHOMES PRIVATE LIMITED",
"GEOTECH TECHNICALASSOCIATES PRIVATE LIMITED",
"GEOTEX TEXTILE PRIVATE LIMITED",
"GEOTEX WEAVES INDIA PRIVATE LIMITED",
"GEOTEXT APPLICATIONS PRIVATE LIMITED",
"GEOTRACKERS MOBILE RESOURCE MANAGEMENT PRIVATE LIMITED",
"GEOTRIX BUILDING ENVELOPE PRIVATE LIMITED",
"GEOTRON ELECTRONICS PRIVATE LIMITED",
"GEOVALE SERVICES PRIVATE LIMITED",
"GEOVISTA SOFTWARE SOLUTIONS PRIVATE LIMITED",
"GEOVISTA TECHNOLOGIES PRIVATE LIMITED",
"GEOWN CASPER PROPERTIES PRIVATE LIMITED",
"GEOWORK INFRA PROJECTS PRIVATE LIMITED",
"GEP SOLUTIONS PRIVATE LIMITED",
"GEPDEC INFRATECH LIMITED",
"GEPIL INFRASTRUCTURE PRIVATE LIMITED",
"GEPL CAPITAL PRIVATE LIMITED",
"GEPL COMMODITIES PRIVATE LIMITED",
"GEPL FINANCE PRIVATE LIMITED",
"GEPL INSURANCE BROKING PRIVATE LIMITED",
"GEPPERT HYDRO INDIA PRIVATE LIMITED",
"GERA DEVELOPMENTS PRIVATE LIMITED",
"GERA HOLDINGS PRIVATE LIMITED",
"GERA POULTRY FARM PRIVATE LIMITED",
"GERA WEALTH PRIVATE LIMITED",
"GERAB INDIA ENGINEERING PRODUCTS PRIVATE LIMITED",
"GERAD INDIA PRIVATE LIMITED",
"GERAD INTERNATIONAL RESOURCES PRIVATE LIMITED",
"GERAH ENTERPRISES PRIVATE LIMITED",
"GERATEX MACHINERY PRIVATE LIMITED",
"GERB VIBRATION CONTROL SYSTEMS PRIVATE LIMITED",
"GERBERA TECHNOLOGIES PRIVATE LIMITED",
"GERESH ELECTRICALS PRIVATE LIMITED",
"GERI HOME CARE SERVICES PRIVATE LIMITED",
"GERMA SANITARYWARE PRIVATE LIMITED",
"GERMAN EMBASSY",
"GERMAN EXPRESS SHIPPING AGENCY INDIA PRIVATE LIMITED",
"GERMAN HOMOEO CARE & CURE PRIVATE LIMITED",
"GERMAN HOMOEO LABORATORIES PRIVATE LIMITED",
"GERMAN HOMOEOPATHIC DISTRIBUTORS PRIVATE LIMITED",
"GERMAN LAUNDRY PRIVATE LIMITED",
"GERMAN MAGNETIC WATER SOLUTIONS PRIVATE LIMITED",
"GERMAN POLYMERS AND COATINGS PRIVATE LIMITED",
"GERMAN PROJECT MANAGEMENT INDIA PRIVATE LIMITED",
"GERMAN REMEDIES PHARMACEUTICALS PRIVATE LIMITED",
"GERMANIUM TECHNOLOGIES LIMITED",
"GERMICIDE HOUSEKEEPING AGENCY PRIVATE LIMITED",
"GERMINAIT SOLUTIONS PRIVATE LIMITED",
"GERMINAL TECHNOLOGIES PRIVATE LIMITED",
"GERMINIT INNOVATIONS PRIVATE LIMITED",
"GERNOTICS EQUIPMENTS & CONSULTANCY PRIVATE LIMITED",
"GERON ENGINEERING PRIVATE LIMITED",
"GERP TECHNOLOGIES PRIVATE LIMITED",
"GERRESHEIMER PHARMACEUTICAL PACKAGING MUMBAI PRIVATE LIMITED",
"GERSON LEHRMAN GROUP INDIA PRIVATE LIMITED",
"GERVIGREIND DATA SCIENCE PRIVATE LIMITED",
"GES HYDRO TECHNOLOGIES PRIVATE LIMITED",
"GES POLYMERS PRIVATE LIMITED",
"GESA GREENS PRIVATE LIMITED",
"GESCHAFT FORMULAE INDIA OVT LIMITED",
"GESCO DEVELOPERS PRIVATE LIMITED.",
"GESCO HEALTHCARE PRIVATE LIMITED",
"GESCOM GOVERNAMENT OF KARNATAKA",
"GESCONS 1961 PVT LTD",
"GESCRAP INDIA PRIVATE LIMITED",
"GESHUR INFRA PRIVATE LIMITED",
"GESM ENVIRONMENT SERVICES",
"GESON PHARMA PRIVATE LIMITED",
"GESSMANN CONTROLLERS INDIA PRIVATE LIMITED",
"GESSWEIN TRADING PRIVATE LIMITED",
"GESTALT DESIGNS PRIVATE LIMITED",
"GESTALT POLYMERS PRIVATE LIMITED",
"GESTAMP AUTOMOTIVE CHENNAI PRIVATE LIMITED",
"GESTAMP AUTOMOTIVE INDIA PRIVATE LIMITED",
"GESTAMP PUNE AUTOMOTIVE PRIVATE LIMITED",
"GESTIONE MINISTRATION PRIVATE LIMITED",
"GESTURE APPARELS PRIVATE LIMITED",
"GESTURE HOTELS AND FOODS PRIVATE LIMITED",
"GESU CHEMICALS PRIVATE LIMITED",
"GET AHEAD EDUCATION LIMITED",
"GET ENERGIETECHNIK INDIA PRIVATE LIMITED",
"GET LIFE HEALTH CARE PRIVATE LIMITED",
"GET MARINE MANAGEMENT (INDIA) PRIVATE LIMITED",
"GET SET HEALTHY PRIVATE LIMITED",
"GET WELL CHEMIST AND DRUGGIST PRIVATE LIMITED",
"GET WISE SYSTEMS PRIVATE LIMITED",
"GET YOUR VENUE EVENTS PRIVATE LIMITED",
"GETACALL INDIA OPC PRIVATE LIMITED",
"GETALONG ENTERPRISE LIMITED",
"GETAM PROJECTS PRIVATE LIMITED",
"GETCO",
"GETECH ELECTRONICS PRIVATE LIMITED",
"GETERP BUSINESS TECH PRIVATE LIMITED",
"GETFAST PHARMACEUTICALS PRIVATE LIMITED",
"GETIN SOLUTION",
"GETINGE INDIA PRIVATE LIMITED",
"GETINGE MEDICAL INDIA PRIVATE LIMITED",
"GETIT INFOMEDIARY LIMITED",
"GETIXHEALTH INDIA PRIVATE LIMITED",
"GETLOOK BEAUTY PRIVATE LIMITED",
"GETMEP SOLUTIONS PRIVATE LIMITED (OPC)",
"GETMYUNI EDUCTION SERVICES PRIVATE LIMITED",
"GETNER HOTELS PVT LTD",
"GETRAG TRANSMISSIONS INDIA PRIVATE LIMITED",
"GETRONICS SOLUTIONS INDIA PRIVATE LIMITED",
"GETS AUTOMOTIVES PRIVATE LIMITED",
"GETSMART EDUCATION PRIVATE LIMITED",
"GETSO CONSTRUCTION PRIVATE LIMITED",
"GETTY IMAGES MEDIA INDIA PRIVATE LIMITED",
"GETUPFORCHANGE SERVICES PRIVATE LIMITED",
"GETVANTAGE TECH PRIVATE LIMITED",
"GET-WAY IMMIGRATION SERVICES PRIVATE LIMITED",
"GETWELL BOARD AND PAPER PRIVATE LIMITED",
"GETWELL HEALTH AND RESEARCH PRIVATE LIMITED",
"GETWELL HOSPITAL AND ULTRASOUND PRIVATE LIMITED",
"GETWELL MEDICARE SOLUTION PRIVATE LIMITED",
"GETWELL ONCOLOGY PRIVATE LIMITED",
"GETWINS SECURITY SERVICES PRIVATE LIMITED",
"GETZ IT SOLUTIONS PRIVATE LIMITED",
"GETZ SHOPPE AND EXIM PRIVATE LIMITED",
"GETZ TRANSPORT LOGISTICS PRIVATE LIMITED",
"GETZNER INDIA PRIVATE LIMITED",
"GETZSPACE GLOBAL PRIVATE LIMITED",
"GEVAL 6 TECHNOLOGIES INDIA PRIVATE LIMITED",
"GEVASOL INDUSTRIES PRIVATE LIMITED",
"GEW (INDIA) PRIVATE LIMITED",
"GEW ELECTRONICS PRIVATE LIMITED",
"GEW RADIATORS INDIA PRIVATE LIMITED",
"GE-WINN FINANCIAL SERVICES PRIVATE LIMITED",
"GEWIS ENGINEERING INDIA PRIVATE LIMITED",
"GEWIS RENEWPOWER PRIVATE LIMITED",
"GEX GARMENTS PRIVATE LIMITED",
"GEXCON INDIA PRIVATE LIMITED",
"GEYA TRANSPORT PRIVATE LIMITED",
"GEYLORDS YARNS PRIVATE LIMITED",
"GEZE INDIA PRIVATE LIMITED",
"GEZELLIG HOSPITALITY PRIVATE LIMITED",
"GF IMPEX PRIVATE LIMITED",
"GF TOLL ROAD PRIVATE LIMITED",
"GFACTORS SENTICHECK SOLUTIONS PRIVATE LIMITED",
"GFCP PRIVATE LIMITED",
"GFE BUSINESS SERVICES PRIVATE LIMITED",
"GFI INFORMATIQUE INDIA PRIVATE LIMITED",
"GFK MODE PRIVATE LIMITED",
"GFK NIELSEN INDIA PRIVATE LIMITED",
"GFL LIMITED",
"GFLURO COATINGS PRIVATE LIMITED",
"GFM RETAIL P LIMITED",
"GFORGE TECHSOLUTIONS INDIA PRIVATE LIMITED",
"GFRESH AGROTECH PRIVATE LIMITED",
"GFS FINANCIAL SOLUTIONS PRIVATE LIMITED",
"GFS INDIA PRIVATE LIMITED",
"GG CHEMICALS AND PHARMACEUTICALS PRIVATE LIMITED",
"GG HOSPITAL",
"GG ORGANICS CARE PRIVATE LIMITED",
"GG ORGANICS PRIVATE LIMITED",
"GG POLYPLAST PRIVATE LIMITED",
"GG PRO RETAIL PRIVATE LIMITED",
"GG TYRES AND TUBES PRIVATE LIMITED",
"GG WASTECH PRIVATE LIMITED",
"GGA INDIA PRIVATE LIMITED",
"GGB AUTOMOTIVE PRIVATE LIMITED",
"GGC DISTRIBUTORS PRIVATE LIMITED",
"GGC GUJRAT GOLD CENTRE PRIVATE LIMITED",
"GGC INDUSTRIES PRIVATE LIMITED",
"GGE GENSET PRIVATE LIMITED",
"GGE POWER PRIVATE LIMITED",
"GGF INDUSTRIES PRIVATE LIMITED",
"GGG REALTY PRIVATE LIMITED",
"GGI CLEARING AND FORWARDING PRIVATE LIMITED",
"GGICO TRENDS PRIVATE LIMITED",
"GGN INTERNATIONAL",
"GGN SHIPPING (INDIA) PRIVATE LIMITED",
"GGP AUTO SOLUTIONS INDIA PRIVATE LIMITED",
"GGPL VENTURES PRIVATE LIMITED",
"GGR AGRO FOOD PRODUCTS PRIVATE LIMITED",
"GGR HOUSING INDIA PRIVATE LIMITED",
"GGR INFRA DEVELOPERS PRIVATE LIMITED",
"GGR INFRA PRIVATE LIMITED",
"GGRACE LEASING COMPANY PRIVATE LIMITED",
"GGS COMMERCE PRIVATE LIMITED",
"GGS DESIGNERS AND FABRICATORS PRIVATE LIMITED",
"GGS ENGINEERING SERVICES INDIA PRIVATE LIMITED",
"GGS GROUP PRIVATE LIMITED",
"GGS INFOSOLUTIONS PRIVATE LIMITED",
"GGS INFRASTRUCTURES PRIVATE LIMITED",
"GGSBY INDUSTRIES PRIVATE LIMITED",
"GGT LOGISTICS PRIVATE LIMITED",
"GGTRADING ENTERPRISE PRIVATE LIMITED",
"GGV MANAGERIAL SERVICES PRIVATE LIMITED",
"GGWP INDIA PRIVATE LIMITED",
"GH CROP PROTECTION PRIVATE LIMITED",
"GH ENERGY PRIVATE LIMITED",
"GH GRAPHICS PRIVATE LIMITED",
"GH INDIA AUTO PARTS PRIVATE LIMITED",
"GH INDUCTION INDIA PRIVATE LIMITED",
"GH PACKAGING PRIVATE LIMITED",
"GH RAISONI INSTITUTE OF INFORMATION &",
"GH REDDY AND ASSOCIATES CONSTRUCTION PRIVATE LIMITED",
"GH2 SOLAR PRIVATE LIMITED",
"GHAAS TECHNOLOGIES PRIVATE LIMITED",
"GHACK TECHNOLOGIES PRIVATE LIMITED",
"GHADAI TECHNOLOGY PRIVATE LIMITED",
"GHADKAN SECONDARY SCHOOL",
"GHAGGAR BIOTECH PRIVATE LIMITED",
"GHAI CONSTRUCTION LIMITED",
"GHAI CONSTRUCTION PRIVATE LIMITED",
"GHAI MINING TOOLS COMPANY PRIVATE LIMITED",
"GHAI OVERSEAS PRIVATE LIMITED",
"GHALLA AND BHANSALI SECURITIES PRIVATE LIMITED",
"GHALLA BHANSALI STOCK BROKERS PRIVATE LIMITED",
"GHALSASI CONSTRUCTIONS PRIVATE LIMITED",
"GHALSASI SMELTING PRIVATE LIMITED",
"GHAN SHYAM OILS PRIVATE LIMITED",
"GHANAMANI INFRABUILDERS AND DEVELOPERS PRIVATE LIMITED",
"GHANARAM CONSTRUCTION COMPANY PRIVATE LIMITED",
"GHANARAM INFRAENGINEERS PRIVATE LIMITED",
"GHANASAI ISPAT PRIVATE LIMITED",
"GHANASHYAM MISRA & SONS PVT LTD",
"GHANASINGH FINE JEWELS PRIVATE LIMITED",
"GHANASINGH JEWELS AND GEMS PRIVATE LIMITED",
"GHANATI PROJECTS PRIVATE LIMITED",
"GHANKUN STEELS PRIVATE LIMITED",
"GHANSHYAM AGRIGENETICS PRIVATE LIMITED",
"GHANSHYAM CULTIVATORS PRIVATE LIMITED",
"GHANSHYAM DALL MILL",
"GHANSHYAM DASS SHIV KUMAR H S SCHOOL",
"GHANSHYAM DINESHKUMAR SONI PRIVATE LIMITED",
"GHANSHYAM ENG-MECH PRIVATE LIMITED",
"GHANSHYAM FORWARDER PRIVATE LIMITED",
"GHANSHYAM MULTIPLAST PRIVATE LIMITED",
"GHANSHYAMDAS & COMPANY",
"GHANTA FOODS PRIVATE LIMITED",
"GHANTA RAJENDRAPRASAD TOBACCO COMPANY PRIVATE LIMITED",
"GHANTESWARI RICE MILL PRIVATE LIMITED",
"GHANWAT DEVELOPERS PRIVATE LIMITED",
"GHAR SANSAR RETAILS PRIVATE LIMITED",
"GHARANA FOODS LIMITED",
"GHARANA REALTORS PRIVATE LIMITED",
"GHARAUNDHA DREAM CITY PRIVATE LIMITED",
"GHARDA CHEMICALS LIMITED",
"GHARDA SCIENTIFIC RESEARCH FOUNDATION",
"GHARKUL CONSTRUCTION COMPANY PRIVATE LIMITED",
"GHARONDA BUILDCON PRIVATE LIMITED",
"GHARONDAA ADVISORS PRIVATE LIMITED",
"GHARPURE ENGINEERING AND CONSTRUCTIONS PRIVATE LIMITED",
"GHARRKUL INDUSTRIES PRIVATE LIMITED",
"GHASIRAM TEXOFIN PVT.LTD.",
"GHASIRAM VNM INDUSTRIES PRIVATE LIMITED",
"GHATA MEHNDIPUR BALAJI AGRIEXTRACTIONS PRIVATE LIMITED",
"GHATAGE FOOD AND MILK PRODUCTS PRIVATE LIMITED",
"GHATAMPUR TRANSMISSION LIMITED",
"GHATGE LOGISTICS PRIVATE LIMITED",
"GHATGE PATIL CONSULTANCY SERVICES PVT LTD",
"GHATGE PATIL INDUSTRIES LIMITED",
"GHATGE PATIL POWERTECH PRIVATE LIMITED",
"GHATGE PATIL TRANSPORTS PRIVATE LIMITED",
"GHATIHARA F P",
"GHATKOPAR CLOTH STORES PRIVATE LIMITED",
"GHATPRABHA FERTILISERS PRIVATE LIMITED",
"GHAZAL ROADWAYS PVT LTD",
"GHAZIABAD ALIGARH EXPRESSWAY PRIVATE LIMITED",
"GHAZIABAD CONTAINERS PRIVATE LIMITED",
"GHAZIABAD DEVELOPMENT AUTHORITY",
"GHAZIABAD GRANITES PRIVATE LIMITED",
"GHAZIABAD MECHFAB PRIVATE LIMITED",
"GHAZIABAD NAGAR NIGAM",
"GHAZIABAD NURSING HOME PRIVATE LIMITED",
"GHAZIABAD ORGANICS LIMITED",
"GHAZIABAD PAPER MILLS PRIVATE LIMITED",
"GHAZIABAD PRECISION PRODUCTS PRIVATE LIMITED",
"GHAZIABAD PRINTING AND PACKING INDUSTRIES PRIVATE LIMITED",
"GHAZIABAD REAL ESTATE PRIVATE LIMITED",
"GHAZIABAD SHIP BREAKERS PRIVATE LIMITED",
"GHAZIABAD TECHNOCRATE CONSULTANTS PRIVATE LIMITED",
"GHAZIABAD TESTING LABORATORIES PRIVATE LIMITED",
"GHAZIABAD WATER SOLUTIONS PRIVATE LIMITED",
"GHB OIL PRIVATE LIMITED",
"GHC HOSPITALS",
"GHCL LIMITED",
"GHCL TEXTILES LIMITED",
"GHEESIBAI MEMORIAL MITTAL HOSPITAL AND RESEARCH CENTRE",
"GHERZI CONSULTING ENGINEERS PRIVATE LIMITED",
"GHEVAR INVESTMENTS AND TRADING COMPANY PVT LTD",
"GHEWOBA KNIT FAB PRIVATE LIMITED",
"GHF ROAD CONTRACT WORKS PRIVATE LIMITED",
"GHH BUMI MINING SERVICES PRIVATE LIMITED",
"GHH INDIA MINING AND TUNNELLING EQUIPMENT PRIVATE LIMITED",
"GHI ENERGY PRIVATE LIMITED",
"GHI TECHNOLOGY PRIVATE LIMITED",
"GHIBELLINES SECURITY SOLUTIONS LIMITED",
"GHIDIA AGRO PRIVATE LIMITED",
"GHIYA OIL PRODUCT PRIVATE LIMITED",
"GHL EXPORTS PRIVATE LIMITED",
"GHM WORKS PRIVATE LIMITED",
"GHNANDIP VIDYALAYA SOBHASAN",
"GHODAWAT AGRO PRIVATE LIMITED",
"GHODAWAT CONSUMER LIMITED",
"GHODAWAT EDUSERVE LLP",
"GHODAWAT ENERGY PRIVATE. LIMITED.",
"GHODAWAT ENTERPRISES PRIVATE LIMITED",
"GHODAWAT FOODS INTERNATIONAL PRIVATE LIMITED",
"GHODAWAT FRESHENERS LLP",
"GHODAWAT GRAINS PRIVATE LIMITED",
"GHODAWAT INDUSTRIES (INDIA) PRIVATE LIMITED",
"GHODAWAT INFRA LLP",
"GHODAWAT REALTY PRIVATE LIMITED",
"GHODAWAT RETAIL LLP",
"GHODU INFOTECH PRIVATE LIMITED",
"GHOGARPALLI INTEGRATED POWER COMPANY LIMITED",
"GHOGHARI FABRICS PRIVATE LIMITED",
"GHOLA JUNIOR BASIC SCHOOL",
"GHOORONIA TEA CO PVT LTD",
"GHORAD SELOO HAM ROAD PROJECT PRIVATE LIMITED",
"GHORI POULTRY PRODUCT PRIVATE LIMITED",
"GHOSH AGRI TECH PRIVATE LIMITED",
"GHOSH BROTHERS MOTORS PRIVATE LIMITED",
"GHOSH CHATTERJEE & CO PVT LTD",
"GHOSH ENGINEERING & FURNITURE PRIVATE LIMITED",
"GHOSH EXPORTS PRIVATE LIMITED",
"GHP INDIA SERVICES PRIVATE LIMITED",
"GHPULSE SOLUTIONS PRIVATE LIMITED",
"GHRIAN RENEWABLES PRIVATE LIMITED",
"GHRIX TECHNOLOGIES PRIVATE LIMITED",
"GHRUSHNESHWAR SHETKARI AGRO PRODUCER COMPANY LIMITED",
"GHRUSHNESHWAR SUGARS PRIVATE LIMITED",
"GHS MARKETING PRIVATE LIMITED",
"GHS ZINC ALLOYS PRIVATE LIMITED",
"GHULE INFRA PROJECTS PRIVATE LIMITED",
"GHUMMAN DISTRIBUTORS PRIVATE LIMITED",
"GHUNGUR IMPEX PRIVATE LIMITED",
"GHV HOSPITALITY INDIA PRIVATE LIMITED RADISSON HOTEL",
"GHV HOTEL INDIA PRIVATE LIMITED",
"GHV INDIA PRIVATE LIMITED",
"GHW KNITWEARS PRIVATE LIMITED",
"GHYAN SAGAR GIRLS INTERNATIONAL",
"GI AGRO TECHNOLOGIES PRIVATE LIMITED",
"GI GLOBAL CHEMICAL PRIVATE LIMITED",
"GI HUMAN RESOURCES AND SERVICES PRIVATE LIMITED",
"GI HYDRO PRIVATE LIMITED",
"GI INDIA AUTOMATION AND SYSTEMS PRIVATE LIMITED",
"GI INDUSTRIES PRIVATE. LIMITED.",
"GI INFOTECH PRIVATE LIMITED",
"GI LONG PRIVATE LIMITED",
"GI NATURAL FIBRE COMPOSITES PRIVATE LIMITED",
"GI POWER CORPORATION LIMITED",
"GI RETAIL PRIVATE LIMITED",
"GI STAFFING SERVICES PRIVATE LIMITED",
"GI TECH I GAME INDIA PRIVATE LIMITED",
"GI TECHNOLOGY PRIVATE LIMITED",
"GI TRADE PRIVATE LIMITED",
"GI TRANS SERVICES PRIVATE LIMITED",
"GI WIND FARM ASSETS LIMITED",
"GIA INDIA LABORATORY PRIVATE LIMITED",
"GIA INFRA PROJECTS PRIVATE LIMITED",
"GIACCA & ABITO SARTORIALE FASHION PRIVATE LIMITED",
"GIACOMINI INDIA PRIVATE LIMITED",
"GIAMITI METAL FORMERS PRIVATE LIMITED",
"GIAN CASTINGS PRIVATE LIMITED",
"GIAN FINANCE LTD",
"GIAN JYOTI INSTITUTE OF MANAGEMENT & TEC",
"GIAN LIFE CARE LIMITED",
"GIAN NIRMAN PRIVATE LIMITED",
"GIAN P MATHUR AND ASSOCIATES PRIVATE LIMITED",
"GIAN RESIDENCY PRIVATE LIMITED",
"GIAN STEEL ROLLING MILLS PRIVATE LIMITED",
"GIANI ICE CREAM PRIVATE LIMITED",
"GIANI'S FOODS PRIVATE LIMITED",
"GIANNA AGRO PRIVATE LIMITED",
"GIANT CEMENT TRADING PRIVATE LIMITED",
"GIANT EAGLE GLOBAL CAPABILITY CENTER LLP",
"GIANT ENGINEERING P LIMITED",
"GIANT INTERNATIONAL PRIVATE LIMITED",
"GIANT LEAP SYSTEMS PRIVATE LIMITED",
"GIANTCELL WELLNESS PRIVATE LIMITED",
"GIANTEAGLE INFRA PRIVATE LIMITED",
"GIANTLOK INDIA PRIVATE LIMITED",
"GIANTVIEW PRIVATE LIMITED",
"GIASK IT SOLUTIONS PRIVATE LIMITED",
"GIAUTO PRIVATE LIMITED",
"GIBBOUS FILMS PRIVATE LIMITED",
"GIBOR INFRASTRUCTURES PRIVATE LIMITED",
"GIBRALTAR AIRSPRINGS PRIVATE LIMITED",
"GIBRALTAR GLASS AND CERAMICS PRIVATE LIMITED",
"GIBS BUSINESS SCHOOL",
"GIBSON HEALTHCARE PRIVATE LIMITED",
"GIBSON INNOVATIONS INDIA PRIVATE LIMITED",
"GIBSONS TECHNOLOGIES INDIA PRIVATE LIMITED",
"GIBU FABRICATIONS PRIVATE LIMITED",
"GIC CORPORATE LEADERS' FOUNDATION",
"GIC HOUSING FINANCE LIMITED",
"GIC INSUFLEX CONDUCTORS PRIVATE. LIMITED.",
"GICHLY SHOE KNITZ PRIVATE LIMITED",
"GICIA INDIA PRIVATE LIMITED",
"GICSOL CONSULTING PRIVATE LIMITED",
"GID GLOBAL VENTURES PRIVATE LIMITED",
"GIDEONS DIGITAL AGENCY PRIVATE LIMITED",
"GIDS ENTERPRISES PRIVATE LIMITED",
"GIE GOLD CREATIONS PRIVATE LIMITED",
"GIE JEWELS",
"GIEOM BUSINESS SOLUTIONS PRIVATE LIMITED",
"GIESECKE & DEVRIENT INDIA PRIVATE LIMITED",
"GIESECKE & DRIVENT MS INDIA PRIVATE LIMITED",
"GIESSE S.P.A.",
"GIF TECHNOLOGIES PRIVATE LIMITED",
"GIFFY INFOTECH PRIVATE LIMITED",
"GIFT GOLD PRIVATE LIMITED",
"GIFT LINKS INDIA PRIVATE LIMITED",
"GIFT POWER COMPANY LIMITED",
"GIFT SEZ LIMITED",
"GIFTECH SOFTWARE SOLUTIONS PRIVATE LIMITED",
"GIFTING DELIGHT PRIVATE LIMITED",
"GIFTING IDEAS PRIVATE LIMITED",
"GIFTOSIS ONLINE SERVICES PRIVATE LIMITED",
"GIFTS 2 YOU (INDIA) PRIVATE LIMITED",
"GIFTS OF LOVE RETAIL PRIVATE LIMITED",
"GIFTS ON AIR ONLINE SOLUTION PRIVATE LIMITED",
"GIFTS PLANET PRIVATE LIMITED",
"GIG CONSTRUCTIONS PRIVATE LIMITED",
"GIG HOSPITALITY PRIVATE LIMITED",
"GIG INTERNATIONAL SCHOOL",
"GIGA NET-TECHNOLOGIES PRIVATE LIMITED",
"GIGA SHIPPING INDIA PRIVATE LIMITED",
"GIGA SOLAR POWER PRIVATE LIMITED",
"GIGA VISION PROJECTS PRIVATE LIMITED",
"GIGABIT TECHNOLOGIES PRIVATE LIMITED",
"GIGABYTE INVESTMENT ADVISORY PRIVATE LIMITED",
"GIGABYTE NETWORKS PRIVATE LIMITED",
"GIGABYTE TECHNOLOGY INDIA PRIVATE LIMITED",
"GIGAFORCE SOFTWARE PRIVATE LIMITED",
"GIGAHERTZ COMPUTING (INDIA) PRIVATE LIMITED",
"GIGAME INFOTECH SOLUTIONS PRIVATE LIMITED",
"GIGAMON SOLUTIONS INDIA PRIVATE LIMITED",
"GIGANTIC COMMODITIES PRIVATE LIMITED",
"GIGANTIC INFOTEL PRIVATE LIMITED",
"GIGAPLEX ESTATE PRIVATE LIMITED",
"GIGATEL SOLUTIONS PRIVATE LIMITED",
"GIGATRONICS INDIA PRIVATE LIMITED",
"GIGAWATT SOLAR PRIVATE LIMITED",
"GIGCONNECT STAFFING SERVICES LLP",
"GIGGLE GALAXY PRIVATE LIMITED",
"GIGI PRIVATE LIMITED",
"GIGIL RESOURCES PRIVATE LIMITED",
"GIGLABZ PRIVATE LIMITED",
"GIGSKY INDIA PRIVATE LIMITED",
"GIGU HOSPITALITY PRIVATE LIMITED",
"GIIFT PLUS INDIA PRIVATE LIMITED",
"GIIR COMMUNICATIONS INDIA PRIVATE LIMITED",
"GIJAS RUBBERS PRIVATE LIMITED",
"GIL SHARED SERVICES PRIVATE LIMITED",
"GIL SHIPPING SERVICES PRIVATE LIMITED",
"GILA LABORATORIES PRIVATE LIMITED",
"GILADA FINANCE AND INVESTMENTS LIMITED",
"GILARD ELECTRONICS PRIVATE LIMITED",
"GILAT SATELLITE NETWORKS INDIA PRIVATE LIMITED",
"GILBARCO VEEDER ROOT INDIA PRIVATE LIMITED",
"GILBARCO VEEDER- ROOT INDIA PRIVATE. LIMITED",
"GILBERT AND MAXWELL ELECTRICALS PVT LTD",
"GILBERT AND MAXWELL TRANSFORMERS PVT.LTD.",
"GILBILE¬†AND¬†COMPANY",
"GILCON PROJECT SERVICES LIMITED",
"GILEAD SCIENCES INC.",
"GILEAD SCIENCES INDIA PRIVATE LIMITED",
"GILGAL EDIFICES & ENGINEERS PRIVATE LIMITED",
"GILL AGRICULTURAL IMPLEMENTS PRIVATE LIMITED",
"GILL AND COMPANY PRIVATE LIMITED",
"GILL BROKING PRIVATE LIMITED",
"GILL CHEMICALS PVT LTD",
"GILL ENGINEERING PRIVATE LIMITED",
"GILL MEDICARE PRIVATE LIMITED",
"GILL PACKAGING PRIVATE LIMITED",
"GILL SIR OVERSEAS AND EDUCATION PRIVATE LIMITED",
"GILLAPUKRI TEA CO. LIMITED",
"GILLCO CONSTRUCTIONS PRIVATE LIMITED",
"GILLCO DEVELOPERS AND BUILDERS PRIVATE LIMITED",
"GILLDEN PAINTS PRIVATE LIMITED",
"GILLETTE DIVERSIFIED OPERATIONS PRIVATE LIMITED",
"GILLETTE INDIA LIMITED",
"GILLSEITH TESTING AND CONTROL INDIA PRIVATE LIMITED",
"GILLSONS CONSTRUCTIONS LIMITED",
"GILLURKAR MULTI SPECIALITY HOSPITAL",
"GILNDGREWLZ HOSPITALITY PRIVATE LIMITED",
"GILO ADVISORS PRIVATE LIMITED",
"GILPIN TOURS AND TRAVEL MANAGEMENT INDIA PRIVATE LIMITED",
"GILTEDGED INDUSTRIAL SECURITIES LIMITED",
"GILWOOD FASHIONS PRIVATE LIMITED",
"GIM INFO SOLUTIONS PRIVATE LIMITED",
"GIM RECYPA PRIVATE LIMITED",
"GIMA COTEX INDUSTRIES PRIVATE LIMITED",
"GIMA MANUFACTURING PRIVATE LIMITED",
"GIMATEX INDUSTRIES PRIVATE. LIMITED.",
"GIMATIC AUTOMATION INDIA PRIVATE LIMITED",
"GIMCO GLOBAL SERVICES PRIVATE LIMITED",
"GIMEX INDIA PROJECTS AND ENGINEERING PRIVATE LIMITED",
"GIMPEX IMERYS INDIA PRIVATE LIMITED",
"GIMPEX OVERSEAS PRIVATE LIMITED",
"GIMPEX PRIVATE LIMITED",
"GIMSAK DEVELOPERS PRIVATE LIMITED",
"GINA ENGINEERING COMPANY PRIVATE LIMITED",
"GINAT WAVE INDIA PRIVATE LIMITED",
"GIND INFRA PRIVATE LIMITED",
"GINDORIA INDUSTRIES LIMITED",
"GINDRE INDIA COMPONENTS PRIVATE LIMITED",
"G-INFO TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"GINGA RESTAURANTS PRIVATE LIMITED",
"GINGER FASHIONS PRIVATE LIMITED",
"GINGER MAGICB IMPEX (OPC) PRIVATE LIMITED",
"GINGER MUMBAI AIRPORT",
"GINGER PROPERTIES PRIVATE LIMITED",
"GINGER WEBS PRIVATE LIMITED",
"GINGLANI DISTILLERS PRIVATE LIMITED",
"GINI & JONY LIMITED",
"GINI CITICORP REALTY LLP",
"GINI CONSTRUCTION PRIVATE LIMITED",
"GINI SILK MILLS LIMITED",
"GINI TEX PRIVATE LIMITED",
"GINIMINDS SOLUTIONS PRIVATE LIMITED",
"GINIR ORCHARDS PRIVATE LIMITED",
"GINNI AGRO",
"GINNI EXPORTS PRIVATE LIMITED",
"GINNI FASHIONS PRIVATE LIMITED",
"GINNI FILAMENTS LIMITED",
"GINNI FINANCE PVT. LTD.",
"GINNI GLOBAL PRIVATE LIMITED",
"GINNI GOLD FINANCIALS PRIVATE LIMITED",
"GINNI GOPAL BOARDS PRIVATE LIMITED",
"GINNI HOLDINGS",
"GINNI INDIA PVT LTD",
"GINNI INTERNATIONAL LIMITED TRANSFER FROM DELHI TO RAJ.",
"GINNI METALS INDUSTRIES PVT LTD",
"GINNI REFRACTORIES PRIVATE LIMITED",
"GINNI SPECTRA PVT. LTD",
"GINNI STEELS PRIVATE LIMITED",
"GINNI SYSTEMS LIMITED",
"GINNI TEA INDUSTRIES LIMITED",
"GINNI TEXTILE PRIVATE LIMITED",
"GINNI TRADELINKS PRIVATE LIMITED",
"GINOX CONCEPTS PRIVATE LIMITED",
"GINSBURG DRUGS AND FORMULATIONS PRIVATE LIMITED",
"GINTER FORGING PVT LTD",
"GINVANI MERCHANTS PVT LTD",
"GINWALA ADVANCED FARM EQUIPMENTS PRIVATE LIMITED",
"GINZA INDUSTRIES LIMITED",
"GINZA INTERNATIONAL PVT LTD",
"GINZER INFRASTRUCTURE PRIVATE LIMITED",
"GIONEE INDIA PRIVATE LIMITED",
"GIORDANO FASHIONS INDIA PRIVATE LIMITED",
"GIOSTAR REGEN PRIVATE LIMITED",
"GIOTTUS TECHNOLOGIES PRIVATE LIMITED",
"GIOVANNI FOOD COMPANY PRIVATE LIMITED",
"GIOVENZANA CONTROLS INDIA PRIVATE LIMITED",
"GIP TECHNOLOGIES PRIVATE LIMITED",
"GIPFEL AND SCHNELL CONSULTINGS PRIVATE LIMITED",
"GIPL EIEPL SAS JV PRIVATE LIMITED",
"GIPLANNER TECHNOLOGIES PRIVATE LIMITED",
"GIPS HOSPITAL PRIVATE LIMITED",
"GIPSKARTON INDIA PRIVATE LIMITED",
"GIPSY MANAGEMENT PVT LTD",
"GIR DAIRY FARMING PRODUCTS PRIVATE LIMITED",
"GIR MOVERS PRIVATE LIMITED",
"GIRA INTERNATIONAL PRIVATE LIMITED",
"GIRAFFE ADVERTISING AND MARKETING PRIVATE LIMITED",
"GIRAFFE DEVELOPERS PRIVATE LIMITED",
"GIRAFFE FOODLINKS PRIVATE LIMITED",
"GIRAL LIGNITE POWER LIMITED",
"GIRANA POULTRY FARM PRIVATE LIMITED",
"GIRANAKATH FARMERS PRODUCER COMPANY LIMITED",
"GIRASOLI INFRA PRIVATE LIMITED",
"GIRDHAL FOOD PRODUCTS PRIVATE LIMITED",
"GIRDHAR CHEMICALS PRIVATE LIMITED",
"GIRDHAR COLD STORAGE PRIVATE LIMITED",
"GIRDHAR EMPORIUM PRIVATE LIMITED",
"GIRDHAR FASHIONS PRIVATE LIMITED",
"GIRDHAR FASTENERS PRIVATE LIMITED",
"GIRDHAR FIBRES PRIVATE LIMITED",
"GIRDHAR FISCAL SERVICES PVT LTD",
"GIRDHAR GARMENTS INDIA PRIVATE LIMITED",
"GIRDHAR HOSPITAL RESEARCH CENTRE",
"GIRDHAR JEWELLERS PRIVATE LIMITED",
"GIRDHAR NATURAL RESOURCES PRIVATE LIMITED",
"GIRDHAR PLASTICS PRIVATE LIMITED",
"GIRDHAR POLYMERS PRIVATE LIMITED",
"GIRDHAR ROLL WRAP PRIVATE LIMITED",
"GIRDHAR TENTS PVT LTD",
"GIRDHAR TEXFAB PRIVATE LIMITED",
"GIRDHAR TRACTORS PRIVATE LIMITED",
"GIRDHARGOPAL AGENCIES PRIVATE LIMITED",
"GIRDHARI AUTOMOBILES PRIVATE LIMITED",
"GIRDHARI CHEMICALS & RESINS PRIVATE LIMITED",
"GIRDHARI INTERNATIONAL PRIVATE LIMITED",
"GIRDHARI LAL & SONS SPORTS PRIVATE LIMITED",
"GIRDHARI LAL AGGARWAL CONTRACTORS PRIVATE LIMITED",
"GIRDHARI LAL CHOPRA AGENTS PRIVATE LIMITED",
"GIRDHARI LAL CONSTRUCTIONS PRIVATE LIMITED",
"GIRDHARI MOTORS PRIVATE LIMITED",
"GIRDHARI SINGH INDER KUNWAR INTER COLLEGE",
"GIRDHARILAL JEWELLERS PRIVATE LIMITED",
"GIRDHARWAL CLOTHING COMPANY PRIVATE LIMITED",
"GIRDHER MARKETING PRIVATE LIMITED",
"GIRHINDA MOTOR PRIVATE LIMITED",
"GIRI EXPRESS SERVICE PRIVATE LIMITED",
"GIRI LAL PREM CHAND SAREES PRIVATE LIMITED",
"GIRI MERCHANTILE PRIVATE LIMITED",
"GIRI ORGANIC VILLAGES PRIVATE LIMITED",
"GIRI POWERLINE",
"GIRI RAJ CASTING PRIVATE LIMITED",
"GIRI ROLLS PRIVATE LIMITED",
"GIRI STONES PRIVATE LIMITED",
"GIRI STRUCTURE ENGINEERING PRIVATE LIMITED",
"GIRI TECHNOLOGIES PRIVATE LIMITED",
"GIRI TEXTILES PRIVATE LIMITED",
"GIRI TRADING AGENCY PRIVATE LIMITED",
"GIRI ZEVER MAHAL PRIVATE LIMITED",
"GIRIAS INVESTMENT PRIVATE LIMITED",
"GIRIBABA TRADELINK PRIVATE LIMITED",
"GIRICHAR TRADECOM PRIVATE LIMITED",
"GIRICK SHIPPING AGENCIES PRIVATE LIMITED",
"GIRIDEV REALTORS & INFRASTRUCTURE PRIVATE LIMITED",
"GIRIDHAN METAL PRIVATE LIMITED",
"GIRIDHARA SOFTWARE SERVICES PRIVATE LIMITED",
"GIRIDHARI CONSTRUCTIONS PRIVATE LIMITED",
"GIRIDHARI EXPLOSIVES PRIVATE LIMITED",
"GIRIDHARI HOMES PRIVATE LIMITED",
"GIRIGANGA INFRASOLUTIONS PRIVATE LIMITED",
"GIRIJA BUILDERS PRIVATE LIMITED",
"GIRIJA CONSULTANCY SERVICES PRIVATE LIMITED",
"GIRIJA CRAFT PRIVATE LIMITED",
"GIRIJA FABRICS PRIVATE LIMITED",
"GIRIJA HARI RICE MILLS PRIVATE LIMITED",
"GIRIJA MARINE SERVICES PRIVATE LIMITED",
"GIRIJAN CO-OPERATIVE CORPORATION LTD",
"GIRIJANANDA CHOWDHURY INSTITUTE OF MANAGEMENT AND TECHNOLOGY",
"GIRIJANANDA CHOWDHURY UNIVERSITY",
"GIRIJASHANKAR COTTON PRIVATE LIMITED",
"GIRIK SHIPPING PRIVATE LIMITED",
"GIRIK WEALTH ADVISORS PRIVATE LIMITED",
"GIRIKAND LOGISTICS PRIVATE LIMITED",
"GIRIKAND TRAVELS PRIVATE LIMITED",
"GIRIKON SOLUTIONS PRIVATE LIMITED",
"GIRILON EXPORTS PRIVATE LIMITED",
"GIRIMALIKA LAYERS PRIVATE LIMITED",
"GIRINAR TAXTILE PRIVATE LIMITED",
"GIRINDRA HOSPITALITY PRIVATE LIMITED",
"GIRIPRIYA TEXTILES PRIVATE LIMITED",
"GIRIRAAJ GENSETS PRIVATE LIMITED",
"GIRIRAJ APARTMENTS PRIVATE LIMITED",
"GIRIRAJ BUILDWELL PRIVATE LIMITED",
"GIRIRAJ CIVIL DEVELOPERS LIMITED",
"GIRIRAJ ENTERPRISES",
"GIRIRAJ EXIM PRIVATE. LIMITED.",
"GIRIRAJ FOILS PRIVATE LIMITED",
"GIRIRAJ GASES PRIVATE LIMITED",
"GIRIRAJ HRSD PRIVATE LIMITED",
"GIRIRAJ HYDRAULICS PVT LTD",
"GIRIRAJ INDUSTRIES",
"GIRIRAJ IRON LIMITED",
"GIRIRAJ ISPAT PRIVATE LIMITED",
"GIRIRAJ LABOUR AGENCY",
"GIRIRAJ MILK PRODUCTS PRIVATE LIMITED",
"GIRIRAJ NAMKEENS PRIVATE LIMITED",
"GIRIRAJ PRECISION SCREWS PRIVATE LIMITED",
"GIRIRAJ PRESTRESSED PRIVATE LIMITED",
"GIRIRAJ PROMOTERS PRIVATE LIMITED",
"GIRIRAJ RE-ROLLS PRIVATE LIMITED",
"GIRIRAJ SECURITY PRIVATE LIMITED",
"GIRIRAJ SOLVENT EXTRACTIONS PRIVATE LIMITED",
"GIRIRAJ SPINTEX PRIVATE LIMITED",
"GIRIRAJ TEXO FAB",
"GIRIRAJ TOURS & TRAVELS PRIVATE LIMITED",
"GIRIRAJ VYAPAAR PRIVATE LIMITED",
"GIRIRAJ WATER SOLUTIONS PRIVATE LIMITED",
"GIRIRAJ WOOLLEN MILLS PRIVATE LIMITED",
"GIRIRAJDHARAN MARBLES PRIVATE LIMITED",
"GIRIRAJJI GREEN POWER PRIVATE LIMITED",
"GIRISH AGRO PRIVATE LIMITED",
"GIRISH CHANACHUR AND SNACKS PRIVATE LIMITED",
"GIRISH ENTERPRISES PRIVATE LIMITED",
"GIRISH FABRICATORS PRIVATE LIMITED",
"GIRISH KIDARNATH OPTICS PRIVATE LIMITED",
"GIRISH MEDICO PRIVATE LIMITED",
"GIRISH PAPER PACKAGING PRIVATE LIMITED",
"GIRISH TRANSPORTS PRIVATE LIMITED",
"GIRISHWARI HOSPITAL PRIVATE LIMITED",
"GIRISON TRADERS",
"GIRISONS FABRICS PUNE PRIVATE LIMITED",
"GIRISONS IMPEX",
"GIRISONS RETAILING PRIVATE LIMITED",
"GIRISTHAN NAGAR PARISHAD SCHOOL NO 1",
"GIRIVARYA NON-WOVEN FABRICS PRIVATE LIMITED",
"GIRIWAR MARKETING PRIVATE LIMITED",
"GIRJAI INFRASTRUCTURES PRIVATE LIMITED",
"GIRL EFFECT ENTERPRISE INDIA PRIVATE LIMITED",
"GIRLIE FASHION PRIVATE LIMITED",
"GIRLS HIGH SCHOOL VA KANISHTHA MAHAVIDYALAYA ANJI MOTHI",
"GIRMITI SOFTWARE PRIVATE LIMITED",
"GIRNA VIDYA PRASARAK MANDAL MADHYAMIK VIDYALAYA MEHUNBARE",
"GIRNAR ALLOYS PRIVATE LIMITED",
"GIRNAR AUTOVENTURES PRIVATE LIMITED",
"GIRNAR AYURVEDIC PHARMACY PRIVATE LIMITED",
"GIRNAR CAPITAL PRIVATE LIMITED",
"GIRNAR CARE PRIVATE LIMITED",
"GIRNAR CARS PRIVATE LIMITED",
"GIRNAR COLD STORAGE AND WAREHOUSING PRIVATE. LIMITED.",
"GIRNAR CORRUGATORS PVT LTD",
"GIRNAR DAIRY FOODS PRIVATE LIMITED",
"GIRNAR ENGINEERING WORKS PRIVATE LIMITED",
"GIRNAR EXTRUSIONS PVT LTD",
"GIRNAR FOOD & BEVERAGES PRIVATE LIMITED",
"GIRNAR FOOD AND BE ERAGES PRIVATE LIMITED",
"GIRNAR GARMENT PRIVATE LIMITED",
"GIRNAR GEARS PRIVATE LIMITED",
"GIRNAR HOTELS PVT LTD",
"GIRNAR MOTORS",
"GIRNAR NEWTEL SOLUTIONS PRIVATE LIMITED",
"GIRNAR REALTY PRIVATE LIMITED",
"GIRNAR RUBBER PRIVATE LIMITED",
"GIRNAR SOFTWARE SEZPRIVATE LIMITED",
"GIRNAR SPARE AND LUBRICANT PRIVATE LIMITED",
"GIRNAR SPINTEX INDUSTRIES LIMITED",
"GIRNAR TEXTILES PRIVATE LIMITED",
"GIRNARSOFT AUTOMOBILES PRIVATE LIMITED",
"GIRNITA IMPEX PRIVATE LIMITED",
"GIROTA FARMER PRODUCER COMPANY LIMITED",
"GIROVO INFO PRIVATE LIMITED",
"GIRRAJJI STONE CRUSHERS PRIVATE LIMITED",
"GIRRAJMULTI COMMODITY PRIVATE LIMITED",
"GIRVAR & SONS BIO ENERGY PRIVATE LIMITED",
"GIRVARDHARI INFRA TRADE PRIVATE LIMITED",
"GIS CONSORTIUM INDIA PRIVATE LIMITED",
"GIS ENGIENEER",
"GIS MUMBAI PRIVATE LIMITED",
"GISF ENGINEERING PRIVATE LIMITED",
"GISKARD DATATECH PRIVATE LIMITED",
"GISLEN SOFTWARE PRIVATE LIMITED",
"GISSS AGRO INDUSTRY LIMITED",
"GIST ADVISORY PRIVATE LIMITED",
"GIST MINERALS TECHNOLOGIES LIMITED",
"GISUL SOFTWARE SERVICES PRIVATE LIMITED",
"GIT ELECTRIC PRIVATE LIMITED",
"GITA AGRO FOOD PRIVATE LIMITED",
"GITA BHAWAN HOSPITAL",
"GITA DEVI FLOUR MILLS PRIVATE LIMITED",
"GITA DEVI TECHNO-CON PRIVATE LIMITED",
"GITA GAZEBO INFRA PRIVATE LIMITED",
"GITA HEALTHCARE PRIVATE LIMITED",
"GITA INFOVISION PRIVATE LIMITED",
"GITA METALS PVT LTD",
"GITA OFFSET PRINTERS PRIVATE LIMITED",
"GITA POWER & INFRASTRUCTURE PRIVATE LIMITED",
"GITA PRASAD SINGH & COMPANY PRIVATE LIMITED",
"GITA PRIMARY SCHOOL",
"GITA PUMPS INDIA PRIVATE LIMITED",
"GITA REFRACTORIES PRIVATE LIMITED",
"GITAI FARMER PRODUCER COMPANY LIMITED",
"GITAM DENTAL COLLEGE AND HOSPITAL",
"GITAM JUNIOR COLLEGE",
"GITAM SCHOOL OF ARCHITECTURE",
"GITAM UNIVERSITY",
"GITANJALI AWARDS PRIVATE LIMITED",
"GITANJALI BUILDERS PVT LTD",
"GITANJALI CHEMICALS PRIVATE LIMITED",
"GITANJALI DISPLAY PRIVATE LIMITED",
"GITANJALI ECO FARMS PRIVATE LIMITED",
"GITANJALI INTERNATIONAL SCHOOL",
"GITANJALI JEWELLERY RETAIL LIMITED",
"GITANJALI MEDICAL CENTER PRIVATE LIMITED",
"GITANJALI POLY-FAB PRIVATE LIMITED",
"GITANJALI SYSTEMS",
"GITANSH AUTOS PRIVATE LIMITED",
"GITANSH AUTOWHEELS PRIVATE LIMITED",
"GITANSH INTERNTIONAL PRIVATE LIMITED",
"GITANSH MOTORS PRIVATE LIMITED",
"GITANSHI PACKAGING PRIVATE LIMITED",
"GITARAM HOSPITAL PVT LTD",
"GITCO TRADERS PRIVATE LIMITED",
"GITE SOFT SOLUTIONS PRIVATE LIMITED",
"GITEC-IGIP INDIA PRIVATE LIMITED",
"GITESH TEXTILES PRIVATE LIMITED",
"GITHALA CORPORATION PRIVATE LIMITED",
"GITHUB INDIA PRIVATE LIMITED",
"GITIKA OVERSEAS PRIVATE LIMITED",
"GITS FOOD PRODUCTS PRIVATE LIMITED",
"GITS RECRUITMENT PRIVATE LIMITED",
"GITVIN REMEDIES (GR) PRIVATE LIMITED",
"GITWAKO FARMS INDIA PRIVATE LIMITED",
"GIULIANI STEERING CYLINDERS INDIA PRIVATE LIMITED",
"GIVAUDAN INDIA PRIVATE LIMITED",
"GIVE INDIA",
"GIVE VINDUET WINDOWS AND DOORS PRIVATE LIMITED",
"GIVI MISURE PRIVATE LIMITED",
"GIVINGFORCE TECHNOLOGIES PRIVATE LIMITED",
"GIVO FASHIONS PRIVATE LIMITED",
"GIW INDIA PRIVATE LIMITED",
"GIYAAN PHARMA PRIVATE LIMITED",
"GIZ GMBH",
"GIZA MARKETING PRIVATE LIMITED",
"GIZMEON TECHNOLOGIES PRIVATE LIMITED",
"GIZMOS RETAIL PRIVATE LIMITED",
"GJ BOOK WORLD PRIVATE LIMITED",
"GJ INNOVATIONS & TEXTILE NETWORK PRIVATE LIMITED",
"GJ INSULATIONS PRIVATE LIMITED",
"GJ PAPERS PRIVATE LIMITED",
"GJ PLANTATIONS PRIVATE LIMITED",
"GJ PLY MARKETING PRIVATE LIMITED",
"GJ SHIPPING SOLUTIONS PRIVATE LIMITED",
"GJ WIRES INDIA PRIVATE LIMITED",
"GJEWELCRAFT LIMITED",
"GJG INDIA PRIVATE LIMITED",
"GJS AUTOWHEELS SERVICES PRIVATE LIMITED",
"GK AIR SOLUTION",
"GK ARENAS PRIVATE LIMITED",
"GK CHEMICALS AND FERTILIZERS LIMITED",
"GK CNC AXIS SOLUTIONS",
"GK COLD CHAIN SOLUTIONS PRIVATE LIMITED",
"GK ENERGY MARKETERS PRIVATE LIMITED",
"GK ENTERPRISES PRIVATE LIMITED",
"GK HOSPITAL",
"GK HR CONSULTING INDIA PRIVATE LIMITED",
"GK INDUSTRIAL PARK PRIVATE. LIMITED.",
"GK INFRA PRIVATE LIMITED",
"GK MACHINERIES & ROBOTICS PRIVATE LIMITED",
"GK MART PRIVATE LIMITED",
"GK POWER EXPERTISE PRIVATE LIMITED",
"GK RESEARCH FOUNDATION",
"GK RICKSHAW LIMITED",
"GK SONS ENGINEERING ENTERPRISES PRIVATE. LIMITED.",
"GK SUPPLY CHAIN PRIVATE LIMITED",
"GK TRADERS MANUFACTURERS & SUPPLIERS",
"GK XIANGHE ELECTRICALS PRIVATE LIMITED",
"GKB EYECARE PRIVATE LIMITED",
"GKB HI-TECH LENSES PRIVATE LIMITED",
"GKB LENS PRIVATE LIMITED",
"GKB OPHTHALMICS LIMITED",
"GKB OPTIC TECHNOLOGIES PRIVATE LIMITED",
"GKB OPTICALS LIMITED",
"GKB OPTOLAB PRIVATE LIMITED",
"GKB SECURITIES PRIVATE LIMITED",
"GKB VISION PRIVATE LIMITED",
"GKC ADVISORY SERVICES PRIVATE LIMITED",
"GKC CONSULTANTS OPC PRIVATE LIMITED",
"GKC FOOD PRODUCTS PRIVATE LIMITED",
"GKC MANAGEMENT SERVICES PRIVATE LIMITED",
"GKC SHIPPING & LOGISTICS PRIVATE LIMITED",
"GKCL STOCK BROKING PRIVATE LIMITED",
"GKD INDIA LIMITED",
"GKD MARKETING SERVICES PRIVATE LIMITED",
"GKD SPACE CONCEPTS LLP",
"GKE PROJECTS AND CONSTRUCTIONS PRIVATE LIMITED",
"GKG CANVAS PRIVATE LIMITED",
"GKG SCAFFS PRIVATE LIMITED",
"GKJ SPECIAL FOODS PVT LTD",
"GKJ STONE WORKS PRIVATE LIMITED",
"GKK CAPITAL MARKETS PRIVATE LIMITED",
"GKKWORKS CONSULTANTS PRIVATE LIMITED",
"GKM COLLEGE OF ENGINEERING",
"GKM ENERGY PRIVATE LIMITED",
"GKM GLOBAL SERVICES PRIVATE LIMITED",
"GKM HOSPITAL PRIVATE LIMITED",
"GKM IT PRIVATE LIMITED",
"GKM POWER PROJECTS PRIVATE LIMITED",
"GKMC PRODUCTS PRIVATE LIMITED",
"GKMS COTTON PRESSING PRIVATE LIMITED",
"GKN AEROSPACE ENGINE SYSTEMS INDIA PRIVATE LIMITED",
"GKN DRIVELINE INDIA LIMITED",
"GKN FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"GKN FOKKER ELMO INDIA PRIVATE LIMITED",
"GKN SINTER METALS PRIVATE LIMITED",
"GKNM HOSPITAL",
"GKON ELECTRIC MOTOR VEHICLES PRIVATE LIMITED",
"GKP CONSTRUCTIONS INDIA PRIVATE LIMITED",
"GKP SNACKS PRIVATE LIMITED",
"GKR ENTERPRISES PRIVATE LIMITED",
"GKR FREIGHT CARRIER INDIA PRIVATE LIMITED",
"GKR INFRACON (INDIA) PRIVATE LIMITED",
"GKR TECHNOPLAST INDIA PRIVATE LIMITED",
"GKS BUSINESS ASSOCIATES PRIVATE LIMITED",
"GKS ENGINEERING PRIVATE LIMITED",
"GKS INFOTECH PRIVATE LIMITED",
"GKS TECHNOLOGY PARK PRIVATE LIMITED",
"GKTECVISION PRIVATE LIMITED",
"GKV CONSTRUCTIONS INDIA PRIVATE LIMITED",
"GKV HOTELS PRIVATE LIMITED",
"GKV INFRASTRUCTURE PRIVATE LIMITED",
"GKW CONSULT GMBH",
"GKW RETAIL SOLUTIONS PRIVATE LIMITED",
"GL & V INDIA PRIVATE LIMITED",
"GL BAJAJ INSTITUTE OF MANAGEMENT",
"GL BAJAJ INSTITUTE OF TECHNOLOGY AND MANAGEMENT",
"GL CONSTRUCTIONS PRIVATE LIMITED",
"GL KUNDU & SONS STEEL PRIVATE LIMITED",
"GL MANAGEMENT SERVICES PRIVATE LIMITED",
"GL SHIPPING SERVICES INDIA PRIVATE LIMITED",
"GL TRADELINK PRVATE LIMITED",
"GL TRADEX PRIVATE LIMITED",
"GL1 INNOMOLD INDIA PRIVATE LIMITED",
"GLA ELECTRONICS PRIVATE LIMITED",
"GLA INDUSTRIES (OPC) PRIVATE LIMITED",
"GLA UNIVERSITY",
"GLACIAL INTERNATIONAL PRIVATE LIMITED",
"GLACIER AGRO FOOD PRODUCTS PRIVATE LIMITED",
"GLACIER AIR SYSTEMS PRIVATE LIMITED",
"GLACIER COMMERCE PRIVATE LIMITED",
"GLACIER CONCERN ADVERTISING PRIVATE LIMITED",
"GLACIER HOLIDAYS PRIVATE LIMITED",
"GLACIER ICE CREAMS PRIVATE LIMITED",
"GLACIER IMPEX PRIVATE LIMITED",
"GLACIER INFRASTRUCTURE PRIVATE LIMITED",
"GLACIER PHARMACEUTICALS PRIVATE LIMITED",
"GLADE INDIA PRIVATE LIMITED",
"GLADE MINERAL RESOURCES PRIVATE LIMITED",
"GLADES ENGINEERING AND CONTRACTING PRIVATE LIMITED",
"GLADIATA ENGINEERING MAKERS PRIVATE LIMITED",
"GLADIATOR VYAPAAR PVT.LTD.",
"GLADIOLUS ENERGY SOLUTIONS PRIVATE LIMITED",
"GLADIOLUS FINANCE CONSULTANTS PRIVATE LIMITED",
"GLADIOLUS MICRO SERVICES PRIVATE LIMITED",
"GLADIOS PRODUCTS PRIVATE LIMITED",
"GLADIUS MEDITECH PRIVATE LIMITED",
"GLADJE PHARMACEUTICALS PRIVATE LIMITED",
"GLADMINDS SOLUTIONS PRIVATE LIMITED",
"GLADOWL WEB SOLUTIONS PRIVATE LIMITED",
"GLADS HOME APPLIANCES PRIVATE LIMITED",
"GLADSTONE AGENCIES LIMITED",
"GLADSTONE PHARMA INDIA PRIVATE LIMITED",
"GLADWAY HOUSING PRIVATE LIMITED",
"GLADWIN TECHGEN PRIVATE LIMITED",
"GLAM INDIA PRIVATE LIMITED",
"GLAM ONLINE PRIVATE LIMITED",
"GLAM SHACK FASHION HOUSE PRIVATE LIMITED",
"GLAMAC INTERNATIONAL PRIVATE LIMITED",
"GLAMANTECH INDIA PRIVATE LIMITED",
"GLAMFLAME PHOTOGRAPHY AND BRAND COMMUNICATION PRIVATE LIMITED",
"GLAMFOLIO INDIA PRIVATE LIMITED",
"GLAMIC HYGIENE PRODUCTS PRIVATE LIMITED",
"GLAMO RETAIL PRIVATE LIMITED",
"GLAMOROUS PROPERTIES PRIVATE LIMITED",
"GLAMOUR BUILDING SOLUTIONS INDIA PRIVATE LIMITED",
"GLAMOUR CREATIONS PRIVATE LIMITED",
"GLAMOUR GLOBAL LIMITED",
"GLAMOUR GRAPHICS PRIVATE LIMITED",
"GLAMOUR SALES PRIVATE LIMITED",
"GLAMOUR SHOES PRIVATE LIMITED",
"GLAMOUR TIN INDUSTRIES PVT LTD",
"GLAMOUR WORLD AYURVEDIC-CO PRIVATE LIMITED",
"GLAMS SECRETS PRIVATE LIMITED",
"GLAMY CANDY PRIVATE LIMITED",
"GLANBIA INDIA PRIVATE LIMITED",
"GLANBIA PERFORMANCE NUTRITION (INDIA) PRIVATE LIMITED",
"GLANCE CARE PRIVATE LIMITED",
"GLANCE DESIGNERS & INTERIORS PRIVATE LIMITED",
"GLANCE DIGITAL EXPERIENCE PRIVATE LIMITED",
"GLANCE FINANCE LIMITED",
"GLANCE INMOBI PTE LTD",
"GLANCE PACKAGING PRIVATE LIMITED",
"GLAND CELSUS BIO CHEMICALS PRIVATE LIMITED",
"GLAND CHEMICALS PRIVATE LIMITED",
"GLAND PHARMA LIMITED",
"GLAND PHARMA LIMITED.",
"GLAND PHARMA LTD",
"GLANDER INTERNATIONAL BUNKERING (INDIA) PRIVATE LIMITED",
"GLANZ DECO- TRENDS PRIVATE LIMITED",
"GLANZ WINDOWS PRIVATE LIMITED",
"GLANZE ENGINEERING COMPANY PVT LTD",
"GLARE AGRO PRIVATE LIMITED",
"GLARE APPLIANCES PRIVATE LIMITED",
"GLARE ESTATES PRIVATE LIMITED",
"GLARE HOME PRODUCTS PRIVATE LIMITED",
"GLARE LIGHTERS PRIVATE LIMITED",
"GLASCO PHARMACEUTICALS PRIVATE LIMITED",
"GLASGOW HOSPITAL PRIVATE LIMITED",
"GLASIER INC",
"GLASS & WALL EXPRESSIONS INDIA PRIVATE LIMITED",
"GLASS AND GLAZING SYSTEMS PRIVATE LIMITED",
"GLASS AND GLAZING TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"GLASS GUARD INDIA PRIVATE LIMITED",
"GLASS POLISH INDIA LIMITED",
"GLASS WALL SYSTEMS",
"GLASSBEAM SOFTWARE INDIA PRIVATE LIMITED",
"GLASSBOX SOLUTIONS PRIVATE LIMITED",
"GLASSCO LABORATORY EQUIPMENTS PRIVATE LIMITED",
"GLASSEX INDIA PRIVATE LIMITED",
"GLASSEYE INFRAPLAZA PRIVATE LIMITED",
"GLASSFINN FACADE ENGINEERING PRIVATE LIMITED",
"GLASSIERS ENTERPRISE PRIVATE LIMITED",
"GLASSIFY TUFF INDIA PRIVATE LIMITED",
"GLASSO PACK PRIVATE LIMITED",
"GLASSPAANE ALUMINIUM (INDIA) PRIVATE LIMITED",
"GLASSTECH INDUSTRIES INDIA PRIVATE LIMITED",
"GLASSWAY INTERIORS PRIVATE LIMITED",
"GLASSWOOD REALTY PRIVATE LIMITED",
"GLASTAL ENGINEERS PRIVATE LTD",
"GLASTONE MOSAIC PRIVATE LIMITED",
"GLASTRONIX LLP",
"GLATT CERAMICS PRIVATE LIMITED",
"GLATT INDIA ENGINEERING PRIVATE LIMITED",
"GLATT SOLUTIONS PRIVATE LIMITED",
"GLATT SYSTEMS PRIVATE LIMITED",
"GLAUBEN DESIGNS PRIVATE LIMITED",
"GLAUBENTREE INFRA SERVICES PRIVATE LIMITED",
"GLAUCUS AGROCHEM PRIVATE LIMITED",
"GLAUCUS SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED",
"GLAUM ENCLOSURES PRIVATE LIMITED",
"GLAVE MARKETING PRIVATE LIMITED",
"GLAVES INNOVATIONS PRIVATE LIMITED",
"GLAXCI PAINTS PRIVATE LIMITED",
"GLAXO FINANCE PRIVATE LIMITED",
"GLAXOSMITHKLINE ASIA PRIVATE LIMITED",
"GLAXOSMITHKLINE CONSUMER PRIVATE LIMITED",
"GLAXOSMITHKLINE PHARMACEUTICALS LIMITED",
"GLAZE ARCHITECTURE PRIVATE LIMITED",
"GLAZE DIAM JEWELLERS PRIVATE LIMITED",
"GLAZE EXTRUSION PRIVATE LIMITED",
"GLAZE TECHNO FACADE SYSTEMS PRIVATE LIMITED",
"GLAZE TRADING INDIA PRIVATE LIMITED",
"GLAZE VENTURES PRIVATE LIMITED",
"GLAZE WOOD INDUSTRY PRIVATE LIMITED",
"GLAZEMEN INFRA PRIVATE LIMITED",
"GLAZETECH INDUSTRIES PRIVATE LIMITED",
"GLAZONOID AUTOMATES PRIVATE LIMITED",
"GLAZY REALTY PRIVATE LIMITED",
"GLB ASSURE PRIVATE LIMITED",
"GLC PARIWAR OPC PRIVATE LIMITED",
"GLD INFRAPROJECTS PRIVATE LIMITED",
"GLD INTERNATIONAL LIMITED",
"GLD SUGAR PRIVATE LIMITED",
"GLEAM BUSINESS PRIVATE LIMITED",
"GLEAM GLOBAL SERVICES INDIA PRIVATE LIMITED",
"GLEAM METALS PRIVATE LIMITED",
"GLEAMS SECURITIES PRIVATE LIMITED",
"GLEANORE INDIA PRIVATE LIMITED",
"GLEASON WORKS INDIA PRIVATE LIMITED",
"GLECO INTERNATIONAL PRIVATE LIMITED",
"GLEDO ADVERTISING AGENCY PRIVATE LIMITED",
"GLEE BIOTECH LIMITED",
"GLEECUS TECHLABS PRIVATE LIMITED",
"GLEEDS CONSULTING INDIA PRIVATE LIMITED",
"GLEESERVE TECHNOLOGY PRIVATE LIMITED",
"GLEEVOAZ CONSULTING PRIVATE LIMITED",
"GLEG ENGINEERS PRIVATE LIMITED",
"GLEMTECH PLAST PRIVATE LIMITED",
"GLEN APPLIANCES PRIVATE LIMITED",
"GLEN INDUSTRIES PRIVATE LIMITED",
"GLENBURN HOSPITALITY PRIVATE LIMITED",
"GLENCORE INDIA PRIVATE LIMITED",
"GLENCORE INFORMATION SERVICES PRIVATE LIMITED",
"GLENDALE ACADEMY INTERNATIONAL",
"GLENDALE BIOMED PRIVATE LIMITED",
"GLENDALE EDUTAINMENT PRIVATE LIMITED",
"GLENEAGLES AWARE HOSPITAL",
"GLENEAGLES GLOBAL HOSPITALS",
"GLENFIN CHEMICALS PRIVATE LIMITED",
"GLENFORD PHARMACEUTICALS PRIVATE LIMITED",
"GLENHAWK SECURITY SERVICES PRIVATE LIMITED",
"GLENMARK LIFE SCIENCES LIMITED",
"GLENMARK PHARMACEUTICALS LIMITED",
"GLENNINFO TECHINDIA PRIVATE LIMITED",
"GLENROCK RUBBER PRODUCTS PRIVATE LIMITED",
"GLENS INNOVATION LABS PRIVATE LIMITED",
"GLENSION AGRO LIMITED",
"GLENSMITH LABS PRIVATE LIMITED",
"GLENTECH INDUSTRIES PRIVATE LIMITED",
"GLENWORTH ESTATE LIMITED",
"GLEZ ART FACADE SOLUTION PRIVATE LIMITED",
"GLF LIFESTYLE BRANDS PRIVATE LIMITED",
"GLIDE CHEM PRIVATE LIMITED",
"GLIDE INTERNATIONAL PRIVATE LIMITED",
"GLIDE TECHNOLOGY PRIVATE LIMITED",
"GLIDEPATH INDIA PRIVATE LIMITED",
"GLIDER BUILDCON REALTORS PRIVATE LIMITED",
"GLIDER TECHNOLOGIES PRIVATE LIMITED",
"GLIDERS INDIA LIMITED",
"GLIDING GARMENTS PRIVATE LIMITED",
"GLIMPSE ELECTRONICS PRIVATE LIMITED",
"GLINT ASSISTANCE AND SUPPORT PRIVATE LIMITED",
"GLINT COSMETICS PRIVATE LIMITED",
"GLINT ENTERTAINMENT PRIVATE LIMITED",
"GLINT INFRAPROJECTS PRIVATE LIMITED",
"GLISTEN GOLD COLLECTIONS PRIVATE LIMITED",
"GLISTEN SHRIMP PRODUCTS PRIVATE LIMITED",
"GLISTEN SOFTWARE PRIVATE LIMITED",
"GLISTEN TINS PRIVATE LIMITED",
"GLISTER SACHET INDIA PRIVATE LIMITED",
"GLITCH MEDIA PRIVATE LIMITED",
"GLITORIUM (INDIA) PRIVATE LIMITED",
"GLITTEK GRANITES LIMITED",
"GLITTER DEALCOM PRIVATE LIMITED",
"GLITTER PAINTS AND CHEMICALS PRIVATE LIMITED",
"GLITTERMOUNT INDIA PROPERTY DEVELOPERS PRIVATE LIMITED",
"GLITVAC FACILITY SERVICES PRIVATE LIMITED",
"GLITZ",
"GLITZ BLITZ PROMOTIONS PRIVATE LIMITED",
"GLITZ DESIGN DIAMOND JEWELERY PRIVATE LIMITED",
"GLITZ FINISHING SOLUTIONS PRIVATE LIMITED",
"GLITZ MODELLING AND PRODUCTION PRIVATE LIMITED",
"GLIVITA PHARMA PRIVATE LIMITED",
"GLM INFRATECH PRIVATE. LIMITED.",
"GLO COLOUR LABS PRIVATE LIMITED",
"GLO IND LOGISTICS PRIVATE LIMITED",
"GLO LED PRIVATE LIMITED",
"GLO PANELS PRIVATE LIMITED",
"GLO SEAIR CARGO PRIVATE LIMITED",
"GLO SURGE PRIVATE LIMITED",
"GLOB PLAST PRIVATE LIMITED",
"GLOBAAS FASTENERS PRIVATE LIMITED",
"GLOBAL (INDIA) ENVIRONMENT SOLUTIONS PRIVATE LIMITED",
"GLOBAL ACCOUNTING SOLUTIONS PRIVATE LIMITED",
"GLOBAL ACQUA PRIVATE LIMITED",
"GLOBAL ACTIVES PRIVATE LIMITED",
"GLOBAL ADJUSTMENTS SERVICES PRIVATE LIMITED",
"GLOBAL ADSORBENTS PRIVATE LIMITED",
"GLOBAL ADVANCE PRIVATE LIMITED",
"GLOBAL ADVERTISEMENT SERVICES PRIVATE LIMITED",
"GLOBAL ADVERTISERS PRIVATE LIMITED",
"GLOBAL ADVERTISING MEDIA PRIVATE LIMITED",
"GLOBAL AGRI RESOURCES PRIVATE LIMITED",
"GLOBAL AGRI SYSTEM PRIVATE LIMITED",
"GLOBAL AGRIGENETICS INDIA PRIVATE LIMITED",
"GLOBAL AGRITRADE INDIA PRIVATE LIMITED",
"GLOBAL AIR-COOL INDIA PRIVATE LIMITED",
"GLOBAL AIRPORT AND GROUND SERVICES PRIVATE LIMITED",
"GLOBAL AIRTECH INDIA PRIVATE LIMITED",
"GLOBAL ALUMINIUM PRIVATE LIMITED",
"GLOBAL ANALYTICS INDIA PRIVATE LIMITED",
"GLOBAL APPLIANCES PRIVATE LIMITED",
"GLOBAL AQUA TREATMENT TECHNOLOGY PRIVATE LIMITED",
"GLOBAL ARK CONSULTANCY SERVICES PRIVATE LIMITED",
"GLOBAL ART EXPORTS",
"GLOBAL ASSETS LEASING AND FINANCE PRIVATE LIMITED",
"GLOBAL ASSOCIATES",
"GLOBAL ASSURANCE SOLUTIONS INDIA PRIVATE LIMITED",
"GLOBAL ATTIRE PRIVATE LIMITED",
"GLOBAL AUDIO TEXT SOLUTIONS PRIVATE LIMITED",
"GLOBAL AUDIOLOGY SERVICES PRIVATE LIMITED",
"GLOBAL AUTO",
"GLOBAL AUTO INDUSTRIES",
"GLOBAL AUTO TECH LIMITED",
"GLOBAL AUTOELECTRIC PRIVATE LIMITED",
"GLOBAL AUTOIMPEX & INDUSTRIES PRIVATE LIMITED",
"GLOBAL AUTOMATION INDIA PRIVATE LIMITED",
"GLOBAL AUTOMOTIVE COMPONENTS PRIVATE LIMITED",
"GLOBAL AUTOMOTIVE RESEARCH CENTRE",
"GLOBAL AUTOTECH LIMITED",
"GLOBAL AUTOWHEELS PRIVATE LIMITED",
"GLOBAL AVIANAUTICS LIMITED",
"GLOBAL AVIATION SERVICES PRIVATE LIMITED",
"GLOBAL BIORESEARCH SOLUTIONS PRIVATE LIMITED",
"GLOBAL BIZ LINKS PRIVATE LIMITED",
"GLOBAL BLEACH CHEM PRIVATE LIMITED",
"GLOBAL BRAND RESOURCES PRIVATE LIMITED",
"GLOBAL BUILDCON PRIVATE LIMITED",
"GLOBAL BUILDESTATE PROJECTS PRIVATE LIMITED",
"GLOBAL BUSINESS INROADS PRIVATE LIMITED",
"GLOBAL BUSINESS SOLUTIONS LIMITED",
"GLOBAL BUSINESS TRAVELS PRIVATE LIMITED",
"GLOBAL CALCIUM PRIVATE LIMITED",
"GLOBAL CAMBAYMARINE SERVICES PRIVATE LIMITED",
"GLOBAL CANESUGAR SERVICES PRIVATE LIMITED",
"GLOBAL CARGO LOGISTIX PRIVATE LIMITED",
"GLOBAL CARGO SERVICES P LIMITED",
"GLOBAL CAST SOLUTIONS PRIVATE LIMITED",
"GLOBAL CASTINGS PRIVATE. LIMITED.",
"GLOBAL CERAMICS PRIVATE LIMITED",
"GLOBAL CHARTS & NAVAIDS PRIVATE LIMITED",
"GLOBAL CHEMICALS LIMITED",
"GLOBAL CITY INTERNATIONAL SCHOOL",
"GLOBAL CLASSROOM PRIVATE LIMITED",
"GLOBAL CLOTHING PRIVATE LIMITED",
"GLOBAL CNC PRIVATE LIMITED",
"GLOBAL COAL AND MINING PRIVATE LIMITED",
"GLOBAL COAL VENTURES PRIVATE LIMITED",
"GLOBAL COCONUT FARMERS PRODUCER COMPANY LIMITED",
"GLOBAL COLOUR STEELS PRIVATE LIMITED",
"GLOBAL COLOURS AND CHEMICALS LIMITED",
"GLOBAL COMMUNICATIONS INDIA PRIVATE LIMITED",
"GLOBAL COMPOSITES AND STRUCTURALS LIMITED",
"GLOBAL CONNECT ADVISORY LLP",
"GLOBAL CONNECT HOSPITALITY LLP",
"GLOBAL CONT CARE SERVICES PRIVATE LIMITED",
"GLOBAL CONTAINER LINES INDIA PRIVATE LIMITED",
"GLOBAL CONTAINER LINES KOLKATA PRIVATE LIMITED",
"GLOBAL CONTENT TRANSFORMATION PRIVATE LIMITED",
"GLOBAL CONVEYOR SYSTEMS PRIVATE LIMITED",
"GLOBAL COPPER LIMITED",
"GLOBAL COTON PRIVATE LIMITED",
"GLOBAL CREDIT CAPITAL LIMITED",
"GLOBAL CREDIT MANAGEMENT SERVICES",
"GLOBAL DECORATORS INDIA PRIVATE LIMITED",
"GLOBAL DELIGHT TECHNOLOGIES PRIVATE LIMITED",
"GLOBAL DENIMS PRIVATE LIMITED",
"GLOBAL DENT AIDS PRIVATE LIMITED",
"GLOBAL DIAGNOSTIC",
"GLOBAL DISBURSEMENT & ACCOUNTING SOLUTIONS PRIVATE LIMITED",
"GLOBAL DISPLAY SYSTEM PRIVATE LIMITED",
"GLOBAL DRILLING FLUIDS AND CHEMICALS LIMITED",
"GLOBAL E BUSINESS OPERATIONS PRIVATE LIMITED",
"GLOBAL E- SOFTSYS PRIVATE LIMITED",
"GLOBAL E TECH INDIA LIMITED",
"GLOBAL E TELE SERVICES PRIVATE LIMITED",
"GLOBAL E TRAVEL SOLUTIONS PRIVATE LIMITED",
"GLOBAL EARTH ENGINEERING SERVICES PRIVATE LIMITED",
"GLOBAL EASYWATER PRODUCTS PRIVATE LIMITED",
"GLOBAL ECOCARB PRIVATE LIMITED",
"GLOBAL EDGE SOFTWARE LIMITED",
"GLOBAL EDUCATION FOUNDATION",
"GLOBAL EDUCATION LIMITED",
"GLOBAL EDUCATIONAL CONSULTANCY SERVICES PRIVATE LIMITED",
"GLOBAL EGDE LLP",
"GLOBAL ELECTRICAL & CONTROL PRIVATE LIMITED",
"GLOBAL ELECTRODES PRIVATE LIMITED",
"GLOBAL ELECTRONICS",
"GLOBAL ELEVATORS PRIVATE LIMITED",
"GLOBAL ENERGY CONSULTING ENGINEERS PRIVATE LIMITED",
"GLOBAL ENERGY PRIVATE LIMITED",
"GLOBAL ENERGY TECHNOLOGIES PRIVATE LIMITED",
"GLOBAL ENERGYFOOD INDUSTRIES PRIVATE LIMITED",
"GLOBAL ENERSOL TECHNOLOGIES PRIVATE LIMITED",
"GLOBAL ENETWORKS LIMITED",
"GLOBAL ENGINEERS LIMITED",
"GLOBAL ENTERPRISE",
"GLOBAL ENTROPOLIS VIZAG PRIVATE LIMITED",
"GLOBAL ENVIRO AIR SYSTEMS PRIVATE LIMITED",
"GLOBAL ENVIROTECH ENGINEERS PRIVATE LIMITED",
"GLOBAL ETREE SERVICES PRIVATE LIMITED",
"GLOBAL EXCHANGE COMPANY PRIVATE LIMITED",
"GLOBAL EXPRESS MULTILOGISTICS PRIVATE LIMITED",
"GLOBAL EXTRUSIONS PRIVATE LIMITED",
"GLOBAL EYE AND LASER HOSPITAL PRIVATE LIMITED",
"GLOBAL EYE SECURITY SERVICES INDIA PRIVATE LIMITED",
"GLOBAL FAIRS MEDIA PRIVATE LIMITED",
"GLOBAL FARM FRESH PRIVATE LIMITED",
"GLOBAL FASHIONS INTERNATIONAL PRIVATE LIMITED",
"GLOBAL FEDIGRAIN PRIVATE LIMITED",
"GLOBAL FIBC PRIVATE LIMITED",
"GLOBAL FIBRETECH PRIVATE LIMITED",
"GLOBAL FIELD AND FARM SEEDS PRIVATE LIMITED",
"GLOBAL FINSOL PRIVATE LIMITED",
"GLOBAL FLAVOURS AND INGREDIENTS PRIVATE LIMITED",
"GLOBAL FLEET SOLUTIONS (I) PRIVATE LIMITED",
"GLOBAL FLIGHT HANDLING SERVICES (PUNE) PRIVATE LIMITED",
"GLOBAL FOODS SOLUTIONS PRIVATE LIMITED",
"GLOBAL FOOTWEAR",
"GLOBAL FOOTWEARS LIMITED",
"GLOBAL FORCE MANAGEMENT SERVICES PRIVATE LIMITED",
"GLOBAL FRANCHISE ARCHITECTS INDIA PRIVATE LIMITED",
"GLOBAL FUEL SOLUTIONS PRIVATE LIMITED",
"GLOBAL GARNER SALES SERVICES LIMITED",
"GLOBAL GASES INDIA PRIVATE LIMITED",
"GLOBAL GATEWAY INFRATECH PRIVATE LIMITED",
"GLOBAL GENE CORP PRIVATE LIMITED",
"GLOBAL GOAL HOSPITALITY PRIVATE LIMITED",
"GLOBAL GOURMET PRIVATE LIMITED",
"GLOBAL GREEN COMPANY LIMITED",
"GLOBAL GREEN CONCEPTS PRIVATE LIMITED",
"GLOBAL GREEN DESIGN STUDIO PRIVATE LIMITED",
"GLOBAL GREEN POWER RENEWABLE ENERGY SOLUTIONS PRIVATE LIMITED",
"GLOBAL GREENFUELS PRIVATE LIMITED",
"GLOBAL GUJARAT COMPETENCIES PRIVATE LIMITED",
"GLOBAL GYPSUM PRIVATE LIMITED",
"GLOBAL HEALTH CARE INDIA PRIVATE LIMITED",
"GLOBAL HEALTH CARE PRODUCTS",
"GLOBAL HEALTH LIMITED",
"GLOBAL HEALTH PRIVATE LIMITED",
"GLOBAL HEALTH STRATEGIES EMERGING ECONOMIES PRIVATE LIMITED",
"GLOBAL HEALTH STRATEGIES INSTITUTE",
"GLOBAL HEALTHCARE BILLING PARTNERS PRIVATE LIMITED",
"GLOBAL HEALTHLINE PRIVATE LIMITED",
"GLOBAL HEARING AID CENTRE PRIVATE LIMITED",
"GLOBAL HEAT TRANSFER DESIGNTECH PRIVATE LIMITED",
"GLOBAL HEAT-TREATMENT AND SERVICES PRIVATE LIMITED",
"GLOBAL HOME AND HEARTH PRIVATE LIMITED",
"GLOBAL HOSPITAL & RESEARCH INSTITUTE",
"GLOBAL HOSPITAL JALANDHAR",
"GLOBAL HOSPITAL NORTH LIMITED",
"GLOBAL HOSPITALITY BRANDS PRIVATE LIMITED",
"GLOBAL HOSPITALS PRIVATE LIMITED",
"GLOBAL HR OUTSOURCING SOLUTIONS INDIA LL P",
"GLOBAL HYDRAULICS PRIVATE LIMITED",
"GLOBAL IEEE INSTITUTE FOR ENGINEERS",
"GLOBAL IMAGES INDIA PRIVATE LTD",
"GLOBAL IMPEX PRIVATE LIMITED",
"GLOBAL INCUBATION SERVICES",
"GLOBAL INDIA TELE - INFRA PRIVATE LIMITED",
"GLOBAL INDIAN INTERNATIONAL SCHOOL",
"GLOBAL INDIAN SCHOOL EDUCATION SERVICES PRIVATE LIMITED",
"GLOBAL INFONET INC",
"GLOBAL INFORMATION SYSTEMS TECHNOLOGY PRIVATE LIMITED",
"GLOBAL INFOTAINMENT PRIVATE LIMITED",
"GLOBAL INFOVENTURES PRIVATE LIMITED",
"GLOBAL INFOVISION PRIVATE LIMITED",
"GLOBAL INFRABUILD PRIVATE LIMITED",
"GLOBAL INFRACOMMUNICATION PRIVATE LIMITED",
"GLOBAL INNOVATION AND TECHNOLOGY ALLIANCE",
"GLOBAL INNOVSOURCE SOLUTIONS",
"GLOBAL INSTILE SOLID INDUSTRIES LIMITED",
"GLOBAL INSTITUTE OF BUSINESS STUDIES",
"GLOBAL INSTITUTE OF ENGINEERING & TECHNOLOGY",
"GLOBAL INSTITUTE OF HOTEL MANAGEMENT",
"GLOBAL INSTITUTE OF INTEGRAL MANAGEMENT STUDIES",
"GLOBAL INSTITUTE OF MANAGEMENT AND TECHNOLOGY",
"GLOBAL INSTITUTE OF MEDICAL SCIENCE & HEALTH CARE",
"GLOBAL INSURANCE BROKERS PRIVATE LIMITED",
"GLOBAL INSURANCE SERVICES (BROKERS) PRIVATE LIMITED",
"GLOBAL INTEGRATED SERVICES INDIA PRIVATE LIMITED",
"GLOBAL INTELLECTUALS VENTURES PRIVATE LIMITED",
"GLOBAL INTERNATIONAL IMEX PRIVATE. LIMITED.",
"GLOBAL IP SERVICES PRIVATE LIMITED",
"GLOBAL IRONTRADING PRIVATE LIMITED",
"GLOBAL ISPAAT PRIVATE LIMITED",
"GLOBAL ISPAT LIMITED GIL",
"GLOBAL IT NETWORK LIMITED",
"GLOBAL JAPAN AAP CONSULTING PRIVATE LIMITED",
"GLOBAL JEWELLERY PRIVATE LIMITED",
"GLOBAL JINDAL FIN-INVEST LIMITED",
"GLOBAL KCLOUD INFOTECH PRIVATE LIMITED",
"GLOBAL KITCHENS PRIVATE LIMITED",
"GLOBAL KNOWLEDGE PUBLIC SCHOOL LATUR",
"GLOBAL KNOWLEDGE RESEARCH FOUNDATION",
"GLOBAL KONNECT AVIATION SERVICES PRIVATE LIMITED",
"GLOBAL LANDMARK PRIVATE LIMITED",
"GLOBAL LEATHERS PRIVATE LIMITED",
"GLOBAL LIFE CARE PRIVATE LIMITED",
"GLOBAL LIFESTYLE INTERIOR PRIVATE LIMITED",
"GLOBAL LOGISTICS SOLUTIONS INDIA PRIVATE LIMITED",
"GLOBAL LONGLIFE HOSPITAL AND RESEARCH LIMITED",
"GLOBAL LONGLIFE HOSPITAL AND RESEARCH PRIVATE LIMITED",
"GLOBAL MAGIC CONSULTING PRIVATE LIMITED",
"GLOBAL MAINTENANCE SERVICES PRIVATE LIMITED",
"GLOBAL MANAGEMENT CERTIFICATION SERVICES PRIVATE LIMITED",
"GLOBAL MARINE INFRATECH PRIVATE LIMITED",
"GLOBAL MARINE SAFETY INDIA PRIVATE LIMITED",
"GLOBAL MARKET INSIGHTS RESEARCH PRIVATE LIMITED",
"GLOBAL MATCH MAKERS PRIVATE LIMITED",
"GLOBAL MEDIA VENTURES INDIA PRIVATE LIMITED",
"GLOBAL MEDICAL SERVICES PRIVATE LIMITED",
"GLOBAL MEDICINES LIMITED",
"GLOBAL MEDIKIT LIMITED",
"GLOBAL MEDITRONIC PRIVATE LIMITED",
"GLOBAL MEDIVERSITY PRIVATE LIMITED",
"GLOBAL METAL AND ENERGY PRIVATE LIMITED",
"VALVEWORKS FORGE LIMITED",
"GLOBAL MINETEC LIMITED",
"GLOBAL MODE AND ACCESSORIES PRIVATE LIMITED\n",
"GLOBAL MOTION SOLUTIONS PRIVATE LIMITED",
"GLOBAL MOTOCORP LLP",
"GLOBAL MUSIC INSTITUTE PRIVATE LIMITED",
"GLOBAL MUSIC JUNCTION PRIVATE LIMITED",
"GLOBAL NAVIGATORS",
"GLOBAL NEST CONSULTING PRIVATE LIMITED",
"GLOBAL NETWORKS PRIVATE LIMITED",
"GLOBAL NISHI TELESERVICES INDIA PRIVATE LIMITED",
"GLOBAL NUTRITION PRODUCTS PRIVATE LIMITED GRACE COSMETICS",
"GLOBAL OCEAN CLEARING PRIVATE LIMITED",
"GLOBAL OCEAN LOGISTICS INDIA PRIVATE LIMITED",
"GLOBAL OIL FIELD SERVICES PRIVATE LIMITED",
"GLOBAL ONE ENTERPRISES PRIVATE LIMITED",
"GLOBAL ONE TECHNOLOGIES PRIVATE LIMITED",
"GLOBAL OPHTHALMIC PRIVATE LIMITED",
"GLOBAL OPPORTUNITIES PRIVATE LIMITED",
"GLOBAL ORES & ALLOYS INDUSTRIES PRIVATE LIMITED",
"GLOBAL OUTLOOK PRIVATE LIMITED",
"GLOBAL PACKAGING",
"GLOBAL PALLETS SERVICES INDIA PRIVATE LIMITED",
"GLOBAL PARASOL RE-INSURANCE BROKERS PRIVATE LIMITED",
"GLOBAL PARKING AND SECURITY SERVICES PRIVATE LIMITED",
"GLOBAL PARTNERS LP",
"GLOBAL PASSAGES PRIVATE LIMITED",
"GLOBAL PASSIVE SAFETY SYSTEMS INDIA PRIVATE LIMITED",
"GLOBAL PATHWAYS MATRICULATION HIGHER SECONDARY SCHOOL",
"GLOBAL PAYEX PRIVATE LIMITED",
"GLOBAL PAYMENT SERVICES PRIVATE LIMITED",
"GLOBAL PAYMENTS ASIA-PACIFIC INDIA PRIVATE LIMITED",
"GLOBAL PEO SERVICE INDIA PRIVATE LIMITED",
"GLOBAL PERIPHERAL SOLUTION PRIVATE LIMTED",
"GLOBAL PERSONNEL SERVICES LLP",
"GLOBAL PET INDUSTRIES LIMITED",
"GLOBAL PHARMA HEALTHCARE PRIVATE LIMITED",
"GLOBAL POLYPET PRIVATE LIMITED",
"GLOBAL POLYTECH (INDIA) PRIVATE LIMITED",
"GLOBAL POLYTECH AFRICA PRIVATE LIMITED",
"GLOBAL POWER ELECTRONICS",
"GLOBAL POWER SYSTEMS",
"GLOBAL PRECISION PRIVATE LIMITED",
"GLOBAL PREMIUM LIFESTYLE PRIVATE LIMITED",
"GLOBAL PRINTING AND PACKAGING COMPANY PRIVATE LIMITED",
"GLOBAL PROJEKT LOGISTIQUE PRIVATE LIMITED",
"GLOBAL PROTECTION AND SECURITY SERVICES PRIVATE LIMITED",
"GLOBAL PUBLIC SCHOOL",
"GLOBAL QUALITY TRAINING & ASSESSORS PRIVATE LIMITED",
"GLOBAL REFINERY PRIVATE LIMITED",
"GLOBAL REMOTE INTEGRATED ACCESS SOLUTIONS PRIVATE LIMITED",
"GLOBAL ROTTAARY",
"GLOBAL SAFETYWEARS PRIVATE LIMITED",
"GLOBAL SCHOOLS FOUNDATION",
"GLOBAL SCIENTIFIC INC",
"GLOBAL SCREENING SERVICES (BANGALORE) PRIVATE LIMITED",
"GLOBAL SEAMLESS TUBES & PIPES PRIVATE LIMITED",
"GLOBAL SECUREX PRIVATE LIMITED",
"GLOBAL SECURITECH SOLUTION PRIVATE LIMITED",
"GLOBAL SECURITY & PLACEMENT SERVICES",
"GLOBAL SHIKSHA INDIA PRIVATE LIMITED",
"GLOBAL SHINE INDUSTRIES PRIVATE LIMITED",
"GLOBAL SHIRTBOX (INDIA) PRIVATE LIMITED",
"GLOBAL SIGHTSEEING PRIVATE LIMITED",
"GLOBAL SILK MILLS PRIVATE LIMITED",
"GLOBAL SMELTER LIMITED",
"GLOBAL SOCIAL (INDIA) FOUNDATION",
"GLOBAL SOFTWARE SOLUTIONS( TVL) PRIVATE LIMITED",
"GLOBAL SOLUTION & COMPLIANCE PRIVATE LIMITED",
"GLOBAL SOLUTION LOGISTICS PRIVATE LIMITED",
"GLOBAL SOURCES EXHIBITION AND EVENTS INDIA PRIVATE LIMITED",
"GLOBAL SPARES & SEALS PRIVATE LIMITED",
"GLOBAL SPECIAL SPRINGS PRIVATE LIMITED",
"GLOBAL SPECIALITY HOSPITAL",
"GLOBAL SS BEAUTY BRANDS LIMITED",
"GLOBAL STAR REALTERS PRIVATE LIMITED",
"GLOBAL STAR SPECIALITY FOODS PRIVATE LIMITED",
"GLOBAL STARS LOGISTICS PRIVATE LIMITED",
"GLOBAL STATIONERS INDIA PRIVATE LIMITED",
"GLOBAL STEEL & POWER",
"GLOBAL STONES PRIVATE LIMITED",
"GLOBAL STONES PRIVATE. LIMITED.",
"GLOBAL SURFACES LIMITED",
"GLOBAL SUSTAINABLE ENERGY SOLUTIONS INDIA PRIVATE LIMITED",
"GLOBAL SW INNOVATIONS INDIA PRIVATE LIMITED",
"GLOBAL SYSTEMS AND INFORMATION TECHNOLOGY GLOBALSYSINFO",
"GLOBAL TALENT TRACK PRIVATE LIMITED",
"GLOBAL TEA ASSAM PVT LTD",
"GLOBAL TECH (INDIA) PRIVATE LIMITED",
"GLOBAL TECH INDIA PRIVATE LIMITED",
"GLOBAL TECH INSTITUTE OF MANAGEMENT PRIVATE LIMITED",
"GLOBAL TECH INTEGRATED SYSTEMS PRIVATE LIMITED",
"GLOBAL TECH PARK PRIVATE. LIMITED.",
"GLOBAL TECH SOLUTIONS",
"GLOBAL TECHNO SERVICES",
"GLOBAL TECHNOCRATS PRIVATE LIMITED",
"GLOBAL TELECASTING PRIVATE LIMITED",
"GLOBAL TELELINKS PRIVATE LIMITED",
"GLOBAL TELUGU CHRISTIAN MINISTRIES",
"GLOBAL TEXMART PRIVATE LIMITED",
"GLOBAL TEXTILE ALLIANCE INDIA PRIVATE LIMITED",
"GLOBAL TIGER FORUM",
"GLOBAL TIGER INDIA PRIVATE LIMITED",
"GLOBAL TRADEX LIMITED",
"GLOBAL TRAILORS (INDIA) PRIVATE LIMITED",
"GLOBAL TRANSFORM PRIVATE LIMITED",
"GLOBAL TRANSPORTATION SERVICES PRIVATE LIMITED",
"GLOBAL TRAVELS",
"GLOBAL TRAVELTECH PRIVATE LIMITED",
"GLOBAL TREATMENT SERVICES PRIVATE LIMITED",
"GLOBAL TREE CAREERS PRIVATE LIMITED",
"GLOBAL TRENDZ PRIVATE LIMITED",
"GLOBAL TUBE AND STEEL SOLUTIONS PRIVATE LIMITED",
"GLOBAL TVS BUS BODY BUILDERS LIMITED",
"GLOBAL UNITED CHARTERING & SHIPBROKING SOLUTIONS PRIVATE LIMITED",
"GLOBAL UNITED SHIPPING INDIA PRIVATE LIMITED",
"GLOBAL UNITEKS PRIVATE LIMITED",
"GLOBAL UPSIDE INDIA PRIVATE LIMITED",
"GLOBAL UPSIDE SERVICES INDIA PRIVATE LIMITED",
"GLOBAL VALVES AND FITTINGS (INDIA) PRIVATE LIMITED",
"GLOBAL VANTEDGE PRIVATE LIMITED",
"GLOBAL VECTRA HELICORP LIMITED",
"GLOBAL VELOCITY VENTURES PRIVATE LIMITED",
"GLOBAL VENTURA CONSULTING PRIVATE LIMITED",
"GLOBAL VISA SERVICES",
"GLOBAL VISION DIRECT PRIVATE LIMITED",
"GLOBAL VISION SECURITIES PVT.LTD.",
"GLOBAL VISION SHIPPING AGENCIES INDIA PRIVATE LIMITED",
"GLOBAL VISO TRADING PRIVATE LIMITED",
"GLOBAL VISUAL EFFECTS INDIA PRIVATE LIMITED",
"GLOBAL WASTE MANAGEMENT CELL PRIVATE LIMITED",
"GLOBAL WASTE RECYCLERS PRIVATE LIMITED",
"GLOBAL WATER SOLUTIONS INDIA PRIVATE LIMITED",
"GLOBAL WATER SOLUTIONS TR PRIVATE LIMITED",
"GLOBAL WIND INFRASTRUCTURE AND SERVICES PRIVATE LIMITED",
"GLOBAL WINGS SERVICES PRIVATE LIMITED",
"GLOBAL WINGS TOURS INDIA PRIVATE LIMITED",
"GLOBAL WOOD INDIA PRIVATE LIMITED",
"GLOBALAGRO CORPORATION PRIVATE LIMITED",
"GLOBALART COLLECTION PRIVATE LIMITED",
"GLOBALAXIS ENGINEERING SERVICES PRIVATE LIMITED",
"GLOBALBOND ADHESIVES PRIVATE LIMITED",
"GLOBALCONCEPTS AND DESIGN PRIVATE LIMITED",
"GLOBALCONNECT TRAVELS PRIVATE LIMITED",
"GLOBALCORE PACKAGING PRIVATE LIMITED",
"GLOBALDIAL SERVICES PRIVATE LIMITED",
"GLOBALE STC PRIVATE LIMITED",
"GLOBALE TESSILE PRIVATE LIMITED",
"GLOBALFOUNDRIES ENGINEERING PRIVATE LIMITED",
"GLOBALFTI PRIVATE LIMITED",
"GLOBALFUR IMPEX PRIVATE LIMITED",
"GLOBALGALAXY GEMS PRIVATE LIMITED",
"GLOBALGATE FOREX PRIVATE LIMITED",
"GLOBALGREEN ECO TECHNOLOGIES PRIVATE LIMITED",
"GLOBALGYAN ACADEMY OF MANAGEMENT EDUCATION PRIVATE LIMITED",
"GLOBALHUNT INDIA PRIVATE LIMITED",
"GLOBAL-INDIA INSURANCE BROKERS PRIVATE LIMITED",
"GLOBALISE CAPITAL INDIA PRIVATE LIMITED",
"GLOBALITE BPO SERVICES PRIVATE LIMITED",
"GLOBALIZATION HR SOLUTIONS INDIA PRIVATE LIMITED",
"GLOBALLOGIC INDIA PRIVATE LIMITED",
"GLOBALLOGIC TECHNOLOGIES LIMITED",
"GLOBALLOGIC TECHNOLOGIES PRIVATE LIMITED",
"GLOBALLY MANAGED SERVICES INDIA PRIVATE LIMITED",
"GLOBALLY RECRUIT EDUCATION PRIVATE LIMITED",
"GLOBALMET INDUSTRIES PRIVATE LIMITED",
"GLOBALOGIX INDIA PRIVATE LIMITED",
"GLOBALPEERS SKILLING AND DEVELOPMENT INITIATIVES PRIVATE LIMITED",
"GLOBALPLAY MEDIA TECHNOLOGIES PRIVATE LIMITED",
"GLOBALPOWER INDUSTRIES PRIVATE LIMITED",
"GLOBALPRIME HEALTHCARE PRIVATE LIMITED",
"GLOBALREACH SKILL TRAINING INDIA PRIVATE LIMITED",
"GLOBALS ITES PRIVATE LIMITED",
"GLOBALSIGN.IN INDIA PRIVATE LIMITED",
"GLOBALSPACE HEALTHCARE TECHNOLOGIES PRIVATE LIMITED",
"GLOBALSPACE TECHNOLOGIES LIMITED",
"GLOBALSTAR AUTO LLP",
"GLOBALSTEP SERVICES PRIVATE LIMITED",
"GLOBALSTROY ENGINEERING INDIA PRIVATE LIMITED",
"GLOBALSYNC PRIVATE LIMITED",
"GLOBALTHERM LUBE PRIVATE LIMITED",
"GLOBALVISION INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"GLOBALVOX VENTURES PRIVATE LIMITED",
"GLOBALWASH CREATION PRIVATE LIMITED",
"GLOBALWATER SOLUTIONS INDIA PRIVATE LIMITED",
"GLOBALWAVE SOFTECH PRIVATE LIMITED",
"GLOBALWAVE TECHNOLOGIES PRIVATE LIMITED",
"GLOBALWORTH SECURITIES LIMITED",
"GLOBALXPERTS TECHNOLOGY PRIVATE LIMITED",
"GLOBALYDK ELECTRIC PRIVATE LIMITED",
"GLOBALZONE SANITORY INFRASTRUCTURE PRIVATE LIMITED",
"GLOBANT INDIA PRIVATE LIMITED",
"GLOBARENA TECHNOLOGIES PRIVATE LIMITED",
"GLOBATE 360 SOLUTIONS PRIVATE LIMITED",
"GLOBATRONIXBOMBAYPRIVATE. LIMITED",
"GLOBATT INDIA PRIVATE LIMITED",
"GLOBAUX IMPEX PRIVATE LIMITED",
"GLOBAX INDIA BIO PHARMACEUTICAL PRIVATE LIMITED",
"GLOBCOM SOLUTIONS PRIVATE LIMITED",
"GLOBCON INDUSTRIES PRIVATE LIMITED",
"GLOBE ARTWARES IMPEX PRIVATE LIMITED",
"GLOBE AUTO PARTS REGD",
"GLOBE AUTOMOBILES PRIVATE LIMITED",
"GLOBE AUTOPARTS PRIVATE LIMITED",
"GLOBE BIOMED PRIVATE LIMITED",
"GLOBE BROADCASTING PRIVATE LIMITED",
"GLOBE CALIBER PRIVATE LIMITED",
"GLOBE CAPACITORS LIMITED",
"GLOBE CAPACITORS PRIVATE LIMITED",
"GLOBE CAPITAL (IFSC) LIMITED",
"GLOBE CAPITAL MARKET LIMITED",
"GLOBE CIVIL PROJECTS PRIVATE LIMITED",
"GLOBE COMMODITIES LIMITED",
"GLOBE COMPONENTS PRIVATE LIMITED",
"GLOBE COTYARN PRIVATE LIMITED",
"GLOBE CV PRIVATE LIMITED",
"GLOBE DENWASH PRIVATE LIMITED",
"GLOBE DERIVATIVES AND SECURITIES LIMITED",
"GLOBE DETECTIVE AGENCY PRIVATE LIMITED",
"GLOBE ECOLOGISTICS PRIVATE LIMITED",
"GLOBE ENVIRO CARE LIMITED",
"GLOBE EXPRESS SERVICES PRIVATE LIMITED",
"GLOBE EXPRESS TRAVELS PRIVATE LIMITED",
"GLOBE FINCAP LIMITED.",
"GLOBE ALL INDIA SERVICES LIMITED",
"GLOBE FORWARDING AGENCIES PRIVATE LIMITED",
"GLOBE GAS EQUIPMENTS INDUSTRY PRIVATE LIMITED",
"GLOBE HOLIDAYS & VISA SERVICES PRIVATE LIMITED",
"GLOBE INFRACONSTRUCTIONS PRIVATE LIMITED",
"GLOBE INTERNATIONAL CARRIERS LIMITED",
"GLOBE LINE SHIPPING SERVICES PRIVATE LIMITED",
"GLOBE LINK CREDIT SOLUTION",
"GLOBE METAL INDUSTRY",
"GLOBE MOBILITY PRIVATE LIMITED",
"GLOBE MOVIEZ PRIVATE LIMITED",
"GLOBE MOVING & SOTAGE CO PRIVATE LIMITED",
"GLOBE MULTI VENTURES LIMITED",
"GLOBE NOBLE ENGINEERING PRIVATE LIMITED",
"GLOBE OF FINANCIAL SERVICES",
"GLOBE OVERSEAS PRIVATE LIMITED",
"GLOBE PANEL INDUSTRIES INDIA PRIVATE LIMITED",
"GLOBE POWER SOLUTIONS PRIVATE LIMITED",
"GLOBE PRECISION INDUSTRIES PRIVATE LIMITED",
"GLOBE PROMOTERS PRIVATE LIMITED",
"GLOBE PUBLICATION PRIVATE LIMITED",
"GLOBE ROLLER FLOUR MILLS LIMITED",
"GLOBE SCOTT MOTORS PVT LTD",
"GLOBE SECURITY SOLUTIONS PRIVATE LIMITED",
"GLOBE STEEL AND ALLOYS PRIVATE LIMITED",
"GLOBE STEELS PRIVATE LIMITED",
"GLOBE TECH FORTUNE INDUSTRIES PRIVATE LIMITED",
"GLOBE TECH SOLUTIONS CONSULTANCY PRIVATE LIMITED",
"GLOBE TEXTILE INDIA PRIVATE. LIMITED.",
"GLOBE TRACTORS PRIVATE LIMITED",
"GLOBE TROTTERS PRIVATE LIMITED",
"GLOBE7 MEDIA PRIVATE LIMITED",
"GLOBEAM RADIANT PRIVATE LIMITED",
"GLOBECO TECHNOLOGIES PRIVATE LIMITED",
"GLOBECOAST SHIPPING & LOGISTICS PRIVATE LIMITED",
"GLOBECOM ONE COMMUNICATIONS PRIVATE LIMITED",
"GLOBECON COMMERCIAL SERVICES PRIVATE LIMITED",
"GLOBECORP IMPEX PRIVATE LIMITED",
"GLOBEDGE EXIM PRIVATE LIMITED",
"GLOBEEXPRESS FREIGHT SYSTEMS PRIVATE LIMITED",
"GLOBEFLEX RESEARCH INDIA PRIVATE LIMITED",
"GLOBEGROUND INDIA PRIVATE LIMITED",
"GLOBEIN TRADING PRIVATE LIMITED",
"GLOBELA PHARMA PRIVATE LIMITED",
"GLOBELINK CREDIT SOLUSTIONZ PRIVATE LIMITED",
"GLOBELINK TRAVEL PRIVATE LIMITED",
"GLOBELINK WW INDIA PRIVATE LIMITED",
"GLOBENTIS INTERNATIONAL PRIVATE LIMITED",
"GLOBEONE CONSULTING PRIVATE LIMITED",
"GLOBEOP FINANCIAL SERVICES (INDIA) PRIVATE LIMITED",
"GLOBEPOINT MULTIMODAL LOGISTICS PRIVATE LIMITED",
"GLOBESECURE INSURANCE BROKERS PRIVATE LIMITED",
"GLOBESECURE TECHNOLOGIES LIMITED",
"GLOBESTAR ENGINEERS (INDIA) PRIVATE LIMITED",
"GLOBESTAR GROUPAGE SERVICES PRIVATE LIMITED",
"GLOBETECH CREATIONS PRIVATE LIMITED",
"GLOBETEK INDIA PRIVATE LIMITED",
"GLOBETOR GAMING PROJECTS PRIVATE LIMITED",
"GLOBETRANS WORLDWIDE PRIVATE LIMITED",
"GLOBETROTTERS EDUCATIONAL INNOVENTIONS PRIVATE LIMITED",
"GLOBEV PRIVATE LIMITED",
"GLOBEWAYS LOGISTICS PRIVATE LIMITED",
"GLOBEX DIGITAL SOLUTIONS PRIVATE LIMITED",
"GLOBEX INNOVATIVE FACILITY MANAGEMENT PRIVATE LIMITED",
"GLOBEX LABORATORIES R&D LIMITED",
"GLOBEX SOLUTION",
"GLOBEXI PRIVATE LIMITED",
"GLOBGRID FASHION HUB PRIVATE LIMITED",
"GLOBICHAIN LOGISTICS PRIVATE LIMITED",
"GLOBIN PHARMACEUTICALS PRIVATE LIMITED",
"GLOBION INDIA PRIAVATE LIMITED",
"GLOBIVA SERVICES PRIVATE LIMITED",
"GLOBIZNET SHOPPING PRIVATE LIMITED (OPC)",
"GLOBIZZ SHIPPING PRIVATE LIMITED",
"GLOBIZZ SYNERGY PRIVATE LIMITED",
"GLOBLE INFO PACK PRIVATE LIMITED",
"GLOBO SOURCE PRIVATE LIMITED",
"GLOBOCOM INFOTECH PRIVATE LIMITED",
"GLOBOLIVE 3D PRIVATE LIMITED",
"GLOBOMED PRIVATE LIMITED",
"GLOBOMOTIVE INDIA LIMITED",
"GLOBOSE SYSTEMS AND SOLUTION PRIVATE LIMITED",
"GLOBOSPORT INDIA PRIVATE LIMITED",
"GLOBOTRANS CLEARING AND FORWARDING PRIVATE LIMITED",
"GLOBOTRANS PROLOGISTIX PRIVATE LIMITED",
"GLOBOZOR INTERNATIONAL TRADE PRIVATE LIMITED",
"GLOBRIN SYSTEMS AND SOLUTIONS LIMITED",
"GLOBSYN IT SERVICES PRIVATE LIMITED",
"GLOBTECH CONSULTANCY & ENGINEERING PRIVATE LIMITED",
"GLOBTECH CONTRACTING (OPC) PRIVATE LIMITED",
"GLOBTIER INFOTECH PRIVATE LIMITED",
"GLOBUS AGROFOODS PRIVATE LIMITED",
"GLOBUS CARS PRIVATE LIMITED",
"GLOBUS FAMILY OF BRANDS (INDIA) PRIVATE LIMITED",
"GLOBUS HOUSING PRIVATE. LIMITED.",
"GLOBUS INDUSTRIES AND SERVICES LIMITED",
"GLOBUS INFOCOM LIMITED",
"GLOBUS INFORMATICS INDIA PRIVATE LIMITED",
"GLOBUS INFOSYS PRIVATE LIMITED",
"GLOBUS INTERNATIONAL COATERS PRIVATE LIMITED",
"GLOBUS LIFESTYLE PRIVATE LIMITED",
"GLOBUS LOGISYS PRIVATE LIMITED",
"GLOBUS MANAGEMENT SERVICES PRIVATE LIMITED",
"GLOBUS MEDICAL INDIA PRIVATE LIMITED",
"GLOBUS MOTORS PRIVATE LIMITED",
"GLOBUS OUTSOURCING PRIVATE LIMITED",
"GLOBUS OVERSEAS CONSULTING PRIVATE LIMITED",
"GLOBUS PETROADDITIONS PRIVATE LIMITED",
"GLOBUS PLASTICS INDIA PRIVATE LIMITED",
"GLOBUS POWER GENERATION LIMITED",
"GLOBUS PRIMARY SCHOOL",
"GLOBUS PROJECTS PRIVATE LIMITED",
"GLOBUS REALCON PRIVATE LIMITED",
"GLOBUS RUBCHEM PRIVATE LIMITED",
"GLOBUS SPARES PRIVATE LIMITED",
"GLOBUS SPIRITS JHARKHAND LIMITED",
"GLOBUS SPIRITS LIMITED",
"GLOBUS STEEL & POWER PRIVATE LIMITED",
"GLOBUS STORES PRIVATE LIMITED.",
"GLOBUS TECHNOFAB (I) PRIVATE LIMITED",
"GLOBUS THENKEN PRIVATE LIMITED",
"GLOBUS TRANSITOS PRIVATE LIMITED",
"GLOBUSE REALTORS PRIVATE LIMITED",
"GLOBUSSOFT TECHNOLOGIES PRIVATE LIMITED",
"GLOCAL HEALTHCARE SYSTEMS PRIVATE LIMITED",
"GLOCAL ICD PRIVATE LIMITED",
"GLOCAL INFOMART PRIVATE LIMITED",
"GLOCAL PINNACLE SOLUTIONS PRIVATE LIMITED",
"GLOCAL RETAIL PRIVATE LIMITED",
"GLOCAL SERVICES PRIVATE LIMITED",
"GLOCAL SKILL MANAGEMENT PRIVATE LIMITED",
"GLOCAL VISION PRIVATE LIMITED",
"GLOCALVIEW INFOTECH PRIVATE LIMITED",
"GLOCHEM INDUSTRIES PRIVATE LIMITED",
"GLOCOM IMPEX PRIVATE LIMITED",
"GLOCOT CHEMICALS PRIVATE LIMITED",
"GLOCOT INDUSTRIES PRIVATE LIMITED",
"GLOCOT SILICONE PRIVATE LIMITED",
"GLODESI TECHNOLOGIES PRIVATE LIMITED",
"GLOED INDIA PRIVATE LIMITED",
"GLOENFIELD TECHNOLOGIES PRIVATE LIMITED",
"GLOIND CONTRACT LOGISTICS PRIVATE LIMITED",
"GLOITEL CONSULTING PRIVATE LIMITED",
"GLOITT CONSULTING PRIVATE LIMITED",
"GLOKAL ADVERTISING PRIVATE LIMITED",
"GLOLINE AIR PRIVATE LIMITED",
"GLOLINE EQUIPMENTS PRIVATE LIMITED",
"GLOMANTRA ESERVICES PRIVATE LIMITED",
"GLOMART PUBLICITY PRIVATE LIMITED",
"GLOMED HEALTHCARE PRIVATE LIMITED",
"GLOMET TECHNOLOGIES PRIVATE LIMITED",
"GLOMIUM TECHNOLOGIES PRIVATE LIMITED",
"GLOMORE ELECTRO-TECH SOLUTIONS LLP",
"GLONET MARKETING PVT LTD",
"GLOOB INTERIOR DESIGN PRIVATE LIMITED",
"GLOOCAL COMMUNICATIONS PRIVATE LIMITED",
"GLOOMY VINCOM PVT LTD",
"GLOPACK INDUSTRIES PRIVATE LIMITED",
"GLOPHARM LABORATORIES PRIVATE LIMITED",
"GLOPLAST ADVERTISING PRIVATE LIMITED",
"GLOPSS MEDIA PRIVATE LIMITED",
"GLOREC INTERNATIONAL PRIVATE LIMITED",
"GLORIA ALLUMINIUM INDIA PRIVATE LIMITED",
"GLORIA BATH PRIVATE LIMITED",
"GLORIA EXTRUSIONS PRIVATE LIMITED",
"GLORIA GEMS TRADING PRIVATE LIMITED",
"GLORIA INTERCHEM PRIVATE LIMITED",
"GLORIA MARK ELECTRICS PRIVATE LIMITED",
"GLORICH INDIA PRIVATE LIMITED",
"GLORIFARM BOTANICALS PRIVATE LIMITED",
"GLORIOR BIOTECH PRIVATE LIMITED",
"GLORIOSA INFOTEL IT SERVICES INDIA PRIVATE LIMITED",
"GLORIOUS AGRO EXIM PRIVATE LIMITED",
"GLORIOUS CREATIONS PRIVATE LIMITED",
"GLORIOUS ELECTRONICS I PRIVATE LIMITED",
"GLORIOUS GLOBAL SERVICES PRIVATE LIMITED",
"GLORIOUS HEALTHCARE PRIVATE LIMITED",
"GLORIOUS INSIGHT PRIVATE LIMITED",
"GLORIOUS INSTAY (OPC) PRIVATE LIMITED",
"GLORIOUS JEWELLERY (INDIA) PRIVATE LTD.",
"GLORIOUS MARINEFUELS PRIVATE LIMITED",
"GLORIOUS PRODUCTS (INDIA) PRIVATE LIMITED",
"GLORIOUS PUBLIC SCHOOL",
"GLORIOUS SYNTHETICS PRIVATE LIMITED",
"GLORIOUS TRADEWINGS PRIVATE LIMITED",
"GLORIOUS TRADING PRIVATE LIMITED",
"GLORISHINE IMPEX PRIVATE LIMITED",
"GLORY DYEING MILLS PRIVATE LIMITED",
"GLORY ENGLISH MEDIUM SCHOOL",
"GLORY FINE PAPERS PRIVATE LIMITED",
"GLORY FOOTWEAR PRIVATE LIMITED",
"GLORY GLOBAL SOLUTIONS SOUTH ASIA PRIVATE LIMITED",
"GLORY KNITWEARS PRIVATE LIMITED",
"GLORY PHARMACHEM INDIA PRIVATE LIMITED",
"GLORY PRODUCTS PRIVATE LIMITED",
"GLORY RADHA TEA PRIVATE LIMITED",
"GLORY SHIPMANAGEMENT PRIVATE LIMITED",
"GLORYBIRD INDIA PRIVATE LIMITED",
"GLORYWEBS CREATIVES PRIVATE LIMITED",
"GLOSAP SYSTEMS PRIVATE LIMITED",
"GLOSEC SUB BROKER AND MARKETING SERVICES PRIVATE LIMITED",
"GLOSEL INDIA IMPEX PRIVATE LIMITED",
"GLOSENT INDIA PRIVATE LIMITED",
"GLOSHIPPING & LOGISTICS PRIVATE LIMITED",
"GLOSIL INTERNATIONAL PRIVATE LIMITED",
"GLOSIL SILICAWARE PRIVATE LIMITED",
"GLOSS COATINGS PRIVATE LIMITED",
"GLOSS PHARMACEUTICALS PRIVATE LIMITED",
"GLOSS STUDIO PRIVATE LIMITED",
"GLOSSAREAD TECHNOLOGIES PRIVATE LIMITED",
"GLOSSY COLOR AND PAINTS PRIVATE LIMITED",
"GLOSSY COTEX",
"GLOSSY IMPEX PRIVATE LIMITED",
"GLOSSY PAINTS (INDIA) PRIVATE LIMITED",
"GLOSTER CABLES LIMITED.",
"GLOSTER LIMITED",
"GLOSTREAM TECHNOLOGIES PRIVATE LIMITED",
"GLOSUN PHARMACEUTICALS PRIVATE LIMITED",
"GLO-TECH ENTERPRISES PRIVATE LIMITED",
"GLOTECH EXIM PRIVATE LIMITED",
"GLOTECH FIRE EQUIPMENTS & SERVICES PRIVATE LIMITED",
"GLOTECH MOLD INDIA PRIVATE LIMITED",
"GLOTELLIGENCE INDIA PRIVATE LIMITED",
"GLOTEX SOLUTIONS PRIVATE LIMITED",
"GLOTIC OUTSOURCING INDIA PRIVATE LIMITED",
"GLOVAL MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"GLOVETECH SAFETY INDIA PRIVATE LIMITED",
"GLOVIA PACIFIC SERVICES (OPC) PRIVATE LIMITED",
"GLOVIS INDIA ANANTAPUR PRIVATE LIMITED",
"GLOVIS INDIA PRIVATE LIMITED",
"GLOVISION TECHNO SERVICES PRIVATE LIMITED",
"GLOW FREIGHT LOGISTICS P LTD",
"GLOW GREEN ENERGY LIMITED",
"GLOW NETWORKS PRIVATE LIMITED",
"GLOW PET PRODUCTS PRIVATE LIMITED",
"GLOW PHARMA PRIVATE LIMITED",
"GLOW RIGHT ELECTRIC SOURCE PRIVATE LIMITED",
"GLOW TRANSFORMER COMPONENTS PRIVATE LIMITED",
"GLOWARE SOFTECH PRIVATE LIMITED",
"GLOWAY INFRATECH PRIVATE LIMITED",
"GLOWBIRD INFRA PRIVATE LIMITED",
"GLOWDERMA LAB PRIVATE LIMITED",
"GLOWFAB FASHIONS PRIVATE LIMITED",
"GLOWFAST ELECTRONICS PRIVATE LIMITED",
"GLOWIALED PRIVATE LIMITED",
"GLOWIN IDEAS PRIVATE LIMITED",
"GLOWMAC LIGHTING PRIVATE LIMITED",
"GLOWMORE FINANCE PVT.LTD.",
"GLOWORLD ENERGY PRIVATE LIMITED",
"GLOWRIA LIFECARE PRIVATE LIMITED",
"GLOWSTAR",
"GLOWSTAR TEXTILE INDUSTRIES PRIVATE LIMITED",
"GLOWSTONE INDUSTRIES PRIVATE LIMITED",
"GLOWSUN INDIA LABS PRIVATE LIMITED",
"GLOWTOUCH TECHNOLOGIES PRIVATE LIMITED",
"GLOWTRONICS PRIVATE LIMITED",
"GLP IMPACT PRIVATE LIMITED",
"GLR IMPEX PRIVATE LIMITED",
"GLR LABORATORIES PRIVATE LIMITED",
"GLR MINES AND MINERALS PRIVATE LIMITED",
"GLR NEW MODEL JR COLLEGE",
"GLR REAL ESTATE PRIVATE LIMITED",
"GLS BUSINESS INDIA PRIVATE LIMITED",
"GLS FILMS INDUSTRIES PRIVATE. LIMITED.",
"GLS INFRACON PRIVATE LIMITED",
"GLS INFRAPROJECTS PRIVATE LIMITED",
"GLS INFRATECH PRIVATE LIMITED",
"GLS LOGISTICS PRIVATE LIMITED",
"GLS PHARMA LIMITED",
"GLS POLYMERS PRIVATE LIMITED",
"GLS REALTY PRIVATE LIMITED",
"GLS SADGUNA AND B D COLLEGE FOR GIRLS",
"GLS SWITCHGEAR PRIVATE LIMITED",
"GLS UNIVERSITY",
"GLTECH SOLUTIONS PRIVATE LIMITED",
"GLTT INTERNATIONAL PRIVATE LIMITED",
"GLUE BRANDWORKS PRIVATE LIMITED",
"GLUE KING IMPEX LLP",
"GLUED ENTERTAINMENT PRIVATE LIMITED",
"GLUKEM BIOCARE PRIVATE LIMITED",
"GLUTAPE INDIA PRIVATE LIMITED",
"GLV ENTERPRISES PRIVATE LIMITED",
"GLYCO BIO PHARMA PRIVATE LIMITED",
"GLYDEL TECH PRIVATE LIMITED",
"GLYNC TECH PRIVATE. LIMITED.",
"GLYNK INDIA PRIVATE LIMITED",
"GLYNORE PHARMA PRIVATE LIMITED",
"GLYPHIS BY PRODUCT PRIVATE LIMITED",
"GM BIOCIDES PRIVATE LIMITED",
"GM CABLES & SWITCHES PRIVATE LIMITED",
"GM COATINGS PRIVATE LIMITED",
"GM CONCRETE ENGINEERING PRIVATE LIMITED",
"GM CORPORATE CONSULTANTS INDIA LIMITED",
"GM ELECTRICAL SYSTEMS INDIA PRIVATE LIMITED",
"GM ELEKTRA PRIVATE LIMITED",
"GM EMBROIDERY PRIVATE LIMITED",
"GM EXPORTS",
"GM GROUP",
"GM INFINITE DWELLING INDIA PRIVATE LIMITED",
"GM INFRA ENGINEERS PRIVATE LIMITED",
"GM INFRA VENTURES PRIVATE LIMITED",
"GM INSIGHTS SOLUTIONS PRIVATE LIMITED",
"GM INSTITUTE OF TECHNOLOGY",
"GM IRON & STEEL COMPANY LIMITED",
"GM MACHINE TOOLS PRIVATE LIMITED",
"GM MEDIVISION PRIVATE LIMITED",
"GM MODULAR PRIVATE LIMITED",
"GM OUTSOURCING PRIVATE LIMITED",
"GM POWER TRADERS PRIVATE LIMITED",
"GM REDDY COTTON INDUSTRIES PRIVATE LIMITED",
"GM SAREES PRIVATE LIMITED",
"GM SEEDS PRIVATE LIMITED",
"GM SHIPTECH TRAINING PRIVATE LIMITED",
"GM SPL INFRA DEVELOPERS PRIVATE LIMITED",
"GM STONES AND CRUSHURS PRIVATE LIMITED",
"GM TECHNICAL CENTRE INDIA PRIVATE LIMITED",
"GM TELECOM BSNL GUWAHATI",
"GMA ADVISORY LLP",
"GMA PINNACLE AUTOMOTIVES PRIVATE LIMITED",
"GMAC20TH CENTURY FINCORPNPRIVATELIMITED",
"GMAG EXIM PRIVATE LIMITED",
"G-MART FOODS PRIVATE LIMITED",
"GMATS MACHINERIES INDIA PRIVATE LIMITED",
"GMAX AUTO LIMITED",
"GMB MARBLES PRIVATE LIMITED",
"GMB TEXTILES MILLS INDIA PRIVATE LIMITED",
"GMBELL HEALTHCARE INDIA PRIVATE LIMITED",
"GMCI PRIVATE LIMITED",
"GMD BUSINESS LINK PRIVATE LIMITED",
"GMD ENGINEERING CONSULTANTS PRIVATE LIMITED",
"GMD INFRATECH PRIVATE LIMITED",
"GMD VENTURE PRIVATE LIMITED",
"GMDM GLOBAL ENERGY PRIVATE LIMITED",
"GMDT MARINE & INDUSTRIAL ENGINEERING PRIVATE LIMITED",
"GMERS GENERAL HOSPITAL",
"GMERS MEDICAL COLLEGE AND HOSPITAL",
"GMETRI STUDIO PRIVATE LIMITED",
"GMFC LABS PRIVATE LIMITED",
"GMG SALES INDIA PRIVATE LIMITED",
"GMG TECHNOTRADES PRIVATE LIMITED",
"GMGR BATH FITTINGS PRIVATE LIMITED",
"GMGR SANITARY AND ALLIED PRIVATE LIMITED",
"GMH LOAD CRUISER PRIVATE LIMITED",
"GMH PHARMACEUTICALS PVT LTD",
"GMI BUILDERS PRIVATE LIMITED",
"GMI IMPLANTOLOGY INDIA PRIVATE LIMITED",
"GMI ZARHAK MOULDERS PRIVATE LIMITED",
"GMJ SYSTEMS & AUTOMATION PRIVATE LIMITED",
"GMK (CONCRETE MIXING) PRIVATE LIMITED",
"GMK BUILDERS PRIVATE LIMITED",
"GMK HOSPITALITY SERVICES PRIVATE LIMITED",
"GMK LABS PRIVATE LIMITED",
"GMK MANAGEMENT CONSULTANCY PRIVATE LIMITED",
"GMK PLASTICS PRIVATE LIMITED",
"GMK RESEARCH LABORATORIES PRIVATE LIMITED",
"GMK TECH BPO SERVICES PRIVATE LIMITED",
"GMK TECHNO AND SERVICES PRIVATE LIMITED",
"GMKT AND SSC INDIA PRIVATE LIMITED",
"GML INDIA FASHION PRIVATE LIMITED",
"GML INFRASTRUCTURES PRIVATE LIMITED",
"GMM BILLING SOLUTIONS PRIVATE LIMITED",
"GMM COATINGS PRIVATE LIMITED",
"GMM CONSTRUCTION PRIVATE LIMITED",
"GMM HUMAN CARE PRIVATE LIMITED",
"GMM PFAUDLER LIMITED",
"GMMCO LIMITED",
"GMN GARMENTS",
"GMN HEALTHCARE PRIVATE LIMITED",
"GMNC TECHNOLOGIES PRIVATE LIMITED",
"GMO GLOBALSIGN CERTIFICATE SERVICES PRIVATE LIMITED",
"GMO MEDIA PRIVATE LIMITED",
"GMO RESEARCH PRIVATE LIMITED",
"GMO-Z.COM PAYMENT GATEWAY INDIA PRIVATE LIMITED",
"GMP EQUIPMENTS PRIVATE LIMITED",
"GMP REELS INDIA PRIVATE LIMITED",
"GMP SOLUTIONS PRIVATE LIMITED",
"GMP SYSTECH ENGINEERING PRIVATE LIMITED",
"GMP TECHNICAL SOLUTIONS PRIVATE LIMITED",
"GMP WEAVING MILLS PRIVATE LIMITED",
"GMR AIR CARGO AND AEROSPACE ENGINEERING LIMITED",
"GMR AIRPORT DEVELOPERS LIMITED",
"GMR AIRPORTS INFRASTRUCTURE LIMITED",
"GMR AIRPORTS LIMITED",
"GMR AMBALA CHANDIGARH EXPRESSWAYS PRIVATE LIMITED",
"GMR AVIATION PRIVATE LIMITED",
"GMR BAJOLI HOLI HYDROPOWER PRIVATE LIMITED",
"GMR BANNERGHATTA PROPERTIES PRIVATE LIMITED",
"GMR BUNDELKHAND ENERGY PRIVATE LIMITED",
"GMR BUSINESS PROCESS AND SERVICES PRIVATE LIMITED",
"GMR CHENNAI OUTER RING ROAD PRIVATE LIMITED",
"GMR CONSULTING SERVICES LIMITED",
"GMR CORPORATE CENTER LIMITED",
"GMR CORPORATE SERVICES LIMITED",
"GMR ENERGY LIMITED",
"GMR ENERGY TRADING LIMITED",
"GMR ENTERPRISES PRIVATE LIMITED",
"GMR GENERATION ASSETS LIMITED",
"GMR GOA INTERNATIONAL AIRPORT LIMITED",
"GMR GROUP OF COMPANIES",
"GMR GUJARAT SOLAR POWER LIMITED",
"GMR HIGHWAYS LIMITED",
"GMR HOLDINGS PRIVATE. LIMITED.",
"GMR HOSPITALITY AND RETAIL LIMITED",
"GMR HYDERABAD AEROTROPOLIS LIMITED",
"GMR HYDERABAD AIR CARGO AND LOGISTICS PRIVATE LIMITED",
"GMR HYDERABAD AVIATION SEZ LIMITED",
"GMR HYDERABAD INTERNATIONAL AIRPORT LIMITED",
"GMR HYDERABAD VIJAYAWADA EXPRESSWAYS PRIVATE LIMITED",
"GMR INFRA DEVELOPERS LIMITED",
"GMR INFRA SERVICES PRIVATE LIMITED",
"GMR INFRASTRUCTURE LIMITED",
"GMR INFRATECH PRIVATE LIMITED",
"GMR KAMALANGA ENERGY LIMITED",
"GMR KANNUR DUTY FREE SERVICES LIMITED",
"GMR KRISHNAGIRI SEZ LIMITED",
"GMR LEAGUE GAMES PRIVATE LIMITED",
"GMR POCHANPALLI EXPRESSWAYS LIMITED",
"GMR POWER AND URBAN INFRA LIMITED",
"GMR RAJAHMUNDRY ENERGY LIMITED",
"GMR RAJAM SOLAR POWER PRIVATE LIMITED",
"GMR SEZ & PORT HOLDINGS LIMITED",
"GMR SOLAR ENERGY PRIVATE LIMITED",
"GMR SPORTS PRIVATE LIMITED",
"GMR TAMBARAM TINDIVANAM EXPRESSWAYS LIMITED",
"GMR TUNI ANAKAPALLI EXPRESSWAYS LIMITED",
"GMR VEMAGIRI POWER GENERATION LIMITED",
"GMR VISAKHAPATNAM INT AIR",
"GMR WARORA ENERGY LIMITED",
"GMS AGRITECH PRIVATE LIMITED",
"GMS BIOMAX MEDICARE PRIVATE LIMITED",
"GMS CONSULTANT PRIVATE LIMITED",
"GMS ELEGANT BUILDERS INDIA PRIVATE LIMITED",
"GMS MANAGEMENT SERVICES PRIVATE LIMITED",
"GMS PRODUCTS PVT.LTD.",
"GMS SOFTWARE SOLUTIONS",
"GMSAI AGRO PRODUCTS PRIVATE LIMITED",
"GMS-GANESH MACHINERY STORE PRIVATE LIMITED",
"GMSRA INFRACON PRIVATE LIMITED",
"GMT ENGINEERS PRIVATE LIMITED",
"GMT ICE & CREAM ART (INDIA) PRIVATE LIMITED",
"GMT INDUSTRIES LIMITED",
"GMT INFOTECH PRIVATE LIMITED",
"GMT INTERNATIONAL PUBLIC SCHOOL",
"GMT PIPES & TUBES PRIVATE LIMITED",
"GMT TELETECH PRIVATE LIMITED",
"GMV ENGINEERING PRIVATE LIMITED",
"GMV INDIA PRIVATE LIMITED",
"GMV PROJECTS AND SYSTEMS",
"GMVR HI-TECH ENTERPRISES PRIVATE LIMITED",
"GMW ENGINEERS PRIVATE LIMITED",
"GMW PRIVATE LIMITED",
"GN AUDIO INDIA PRIVATE LIMITED",
"GN HEARING INDIA PRIVATE LIMITED",
"GN INFRASOLUTION PRIVATE LIMITED",
"GN IT SOLUTIONS PRIVATE LIMITED",
"GN LAND DEVELOPERS LIMITED",
"GN SECURITY AND LOGISTICS PRIVATE LIMITED",
"GN SERVICES PRIVATE LIMITED",
"GN TRENDS & TRADE PRIVATE LIMITED",
"GNA AXLES LIMITED",
"GNA DRIVELINES LIMITED",
"GNA GEARS LIMITED",
"GNA UNIVERSITY",
"GNANA JYOTHI SCHOOL AND PU COLLEGE",
"GNANA PRIYA SCHOOL",
"GNANA SHALE SOUHARDA CO OPERATIVE LIMITED",
"GNANA VIKASA PU COLLEGE",
"GNANABELLA LOGISTICS",
"GNANADHAMA SCHOOL",
"GNANAGURU CONSTRUCTIONS PRIVATE LIMITED",
"GNANAM INSTITUTE FOR TRAINING IN ADVANCED ANALYTICS PRIVATE LIMITED",
"GNANAMBIGA HOSPITALITY SERVICES PRIVATE LIMITED",
"GNANAMBIKAI MILLS LIMITED",
"GNANI INNOVATIONS PRIVATE LIMITED",
"GNANYAGNA HIGH SCHOOL",
"GNANYOG EDUCATION AND WELFARE TRUST",
"GNAP SERVICES PRIVATE LIMITED",
"GNAPIKA ENTERTAINMENTS PRIVATE LIMITED",
"GNAT FOUNDRY PRIVATE LIMITED",
"GNAT TECHNOLOGIES PRIVATE LIMITED",
"GNB MOTORS PRIVATE LIMITED",
"GNBTECH SOFTWARE SOLUTIONS PRIVATE LIMITED",
"GND AUTOMOTIVE LLP",
"GND DESIGN CONSULTANTS PRIVATE LIMITED",
"GND ISPAT PRIVATE LIMITED",
"GND SOLUTIONS INDIA PRIVATE LIMITED",
"GNE EXPORTS PRIVATE LIMITED",
"GNESH MANPOWER SERVICES PRIVATE LIMITED",
"GNET IMPEX PRIVATE LIMITED",
"G-NET TECHNOLOGIES PRIVATE LIMITED",
"GNET TRADELINKS PRIVATE LIMITED",
"GNEX BUILDTECH PRIVATE LIMITED",
"GNEX INFRABUILD PRIVATE LIMITED",
"GNEX PROJECTS PRIVATE LIMITED",
"GNEX REALTECH PRIVATE LIMITED",
"GNEXAA INFO SOLUTIONS PRIVATE LIMITED",
"GNEXT TRADING COMPANY PRIVATE LIMITED",
"GNG CARTONS PRIVATE LIMITED",
"GNG CONSULTANCY SERVICES MADRAS P LIMITED",
"GNG ELECTRONICS PRIVATE LIMITED",
"GNG IMPORT & EXPORT PRIVATE LIMITED",
"GNG IT SERVICES PRIVATE LIMITED",
"GNG MEDICAL PRIVATE LIMITED",
"GNG STOCK HOLDINGS PRIVATE LIMITED",
"GNH INDIA PHARMACEUTICALS LIMITED",
"GNI INFRASTRUCTURE LIMITED",
"GNI INFRASTRUCTURE PRIVATE LIMITED",
"GNINE MARMOGRANI IMPEX PRIVATE LIMITED",
"GNJ ENGINEERING PRIVATE LIMITED",
"GNK E SERVICES PRIVATE LIMITED",
"GNK FOREX PRIVATE LIMITED",
"GNM INFRASOLUTION PRIVATE LIMITED",
"GNOSCH FOODS PRIVATE LIMITED",
"GNOSIS PHARMACEUTICALS PRIVATE LIMITED",
"GNOSIS SERVICES PRIVATE LIMITED",
"GNOSTICE INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"GNP CONSULTANCY & SOLUTIONS PRIVATE LIMITED",
"GNP GROUP",
"GNP REALTY LLP",
"GNP TECH CONSULTING PRIVATE LIMITED",
"GNR COLD STORAGE PRIVATE LIMITED",
"GNR LOGISTICS PRIVATE LIMITED",
"GNR SHIPPING & FORWARDING PRIVATE LIMITED",
"GNR SOLUTION PRIVATE LIMITED",
"GNR TRANSWAYS PRIVATE LIMITED",
"GNRC COMMUNITY HOSPITALS LIMITED",
"GNRC MEDISHOP PRIVATE LIMITED",
"GNRL OIL & GAS LIMITED",
"GNS ENGINEERING INDIA PRIVATE LIMITED",
"GNS NIRMAN PRIVATE LIMITED",
"GNS STEELS PRIVATE LIMITED",
"GNS TELECOM PRIVATE LIMITED",
"GNUTTI CARLO INDIA PRIVATE LIMITED",
"GNV COMMODITIES PRIVATE LIMITED",
"GNV METAL INDUSTRIES PRIVATE LIMITED",
"GNXT LOGISTICS PRIVATE LIMITED",
"GO 2 MARKET INDIA PRIVATE LIMITED",
"GO AND GROW GLOBAL PRIVATE LIMITED",
"GO CONNECT PRIVATE LIMITED",
"GO CRAZY TRAVELS PRIVATE LIMITED",
"GO DADDY INDIA DOMAINS AND HOSTING SERVICES PRIVATE LIMITED",
"GO DESI DESIGNER WEAR PRIVATE LIMITED",
"GO DIGIT GENERAL INSURANCE LIMITED",
"GO DIGIT INFOWORKS SERVICES PRIVATE LIMITED",
"GO FASHION INDIA LIMITED",
"GO FOR TRANSFORMATION PRIVATE LIMITED",
"GO FOREX PRIVATE LIMITED",
"GO GO INTERNATIONAL PRIVATE. LIMITED.",
"GO GREEN INFRASTRUCTURE PRIVATE LIMITED",
"GO GREEN MECHANISMS PRIVATE LIMITED",
"GO GREEN TECHNOLOGIES PRIVATE LIMITED",
"GO GU RYEO HOTELS PRIVATE LIMITED",
"GO INDIA VACATION PRIVATE LIMITED",
"GO INVESTMENTS & TRADING PRIVATE LIMITED",
"GO IP GLOBAL SERVICES PRIVATE LIMITED",
"GO LIFESTYLE RETAIL PRIVATE LIMITED",
"GO LOGISTICS PRIVATE LIMITED",
"GO LORRY PRIVATE LIMITED",
"GO NATURAL AQUA PRIVATE LIMITED",
"GO PAY DIGITAL WORLD PRIVATE LIMITED",
"GO PLACES HOLIDAYS & MEDIA PRIVATE LIMITED",
"GO PRIME HEIGHT PRIVATE LIMITED",
"GO PROCESSING LIMITED",
"GO RURALINDIA PRIVATE LIMITED",
"GO SHARP TECHNOLOGIES AND CONSULTING PRIVATE LIMITED",
"GO SOLAR ENERGY SOLUTIONS PRIVATE LIMITED",
"GO TRAVELLISM PRIVATE LIMITED",
"GO VEG GO GREEN CLUB PRIVATE LIMITED",
"GO WELL MULTI TRADE PRIVATE LIMITED",
"GO2GROUP TECHNOLOGIES PRIVATE LIMITED",
"GO2NEW.COM INDIA PRIVATE LIMITED",
"GO4GURU PRIVATE LIMITED",
"GO4LIFE ORGANIC MILK PRIVATE LIMITED",
"GOA ANTIBIOTICS AND PHARMACEUTICALS LIMITED",
"GOA ART PRINTERS PRIVATE LIMITED",
"GOA BREWCRAFTS PRIVATE LIMITED",
"GOA CARBON LIMITED",
"GOA COASTAL RESORTS AND RECREATION PRIVATE LIMITED",
"GOA COLD STORAGE PRIVATE LIMITED",
"GOA CONTAINERS PRIVATE LIMITED",
"GOA ELECTRONICS LIMITED",
"GOA EXPRESS CARGO PRIVATE LIMITED",
"GOA GLASS FIBRE LIMITED",
"GOA GOLF CLUB PRIVATE LIMITED",
"GOA GOVERNMENT",
"GOA GOVERNMENT DIRECTOR OF TRANSPORT",
"GOA INSTITUTE OF MANAGEMENT",
"GOA INSTRUMENTS INDUSTRIES PRIVATE LIMITED",
"GOA ISPAT LIMITED",
"GOA ISPAT PRIVATE LIMITED",
"GOA MEDICAL COLLEGE",
"GOA MEDICOS PRIVATE LIMITED",
"GOA MINERALS PRIVATE LIMITED",
"GOA MOTORS PRIVATE LIMITED",
"GOA MOULD CRAFTERS PVT LTD",
"GOA NATURAL GAS PRIVATE LIMITED",
"GOA OCEANARIUM PRIVATE LIMITED",
"GOA PAINTS AND ALLIED PRODUCTS PRIVATE LIMITED",
"GOA RAJEE AUTO PRIVATE LIMITED",
"GOA ROLLER FLOUR MILLS PRIVATE LIMITED",
"GOA SHIPYARD LIMITED",
"GOA STATE INFRASTRUCTURE DEVELOPMENT CORPORATION LIMITED",
"GOA STATE POLLUTION CONTROL BOARD",
"GOA THERMOSTATIC INSTRUMENTS PRIVATE LIMITED",
"GOA TOURISM DEVELOPMENT CORPORATION LIMITED",
"GOA UNIVERSITY",
"GOABERIA HIGH SCHOOL",
"GOACCELERATE INDIA PRIVATE LIMITED",
"GOAHEAD SOFTWARE INDIA PRIVATE LIMITED",
"GOAL CORPORATION PRIVATE LIMITED",
"GOAL EDUCATIONAL SERVICES PRIVATE LIMITED",
"GOAL GAS PRIVATE LIMITED",
"GOAL IMPEX PRIVATE LIMITED",
"GOAL INFORMATION",
"GOAL PETROLEUM PRODUCTS COMPANY PRIVATE LIMITED",
"GOALCOAST TRADING PRIVATE LIMITED",
"GOALCRYST INDIA PRIVATE LIMITED",
"GOALPATH EDUCATION PRIVATE LIMITED",
"GOALPOST INDUSTRIES LIMITED",
"GOALS101 DATA SOLUTIONS PRIVATE LIMITED",
"GOALSTER PRIVATE LIMITED",
"GOALTORE COLD STORAGE PRIVATE LIMITED",
"GOAN CARNIVAL AND LEISURE PRIVATE LIMITED",
"GOAN FRESH MARINE EXPORTS PRIVATE LIMITED",
"GOAN HOTELS & REALTY PRIVATE LIMITED",
"GOAN REAL ESTATE AND CONSTRUCTION PRIVATE LIMITED",
"GOAN RECREATION CLUBS PRIVATE LIMITED",
"GOAPPTIV PRIVATE LIMITED",
"GOARKHA SECURITIES",
"GOA-TAMNAR TRANSMISSION PROJECT LIMITED",
"GOAUDITS PRIVATE LIMITED",
"GOAUGMENT PRIVATE LIMITED",
"GOAVEGA SOFTWARE INDIA PRIVATE LIMITED",
"GOBAIN CERAMIC PRIVATE LIMITED",
"GOBARDHAN WIRE PRODUCTS PRIVATE LIMITED",
"GOBI ENTERPRISES PVT LTD",
"GOBILLION SERVICES PRIVATE LIMITED",
"GOBIND ALLOYS LIMITED",
"GOBIND BHAWAN KARYALAYA",
"GOBIND ELECTRICAL AGENCIES PRIVATE LIMITED",
"GOBIND GLOBAL MART PRIVATE LIMITED",
"GOBIND GOPAL LPG INDUSTRIES LIMITED",
"GOBIND INDUSTRIES PRIVATE LIMITED",
"GOBIND SUGAR MILLS LTD",
"GOBINDA DISTRIBUTORS PRIVATE LIMITED",
"GOBINDAS ENTERTAINMENT PRIVATE LIMITED",
"GOBINDO COLD STORAGE PVT LTD",
"GOBLIN INDIA LIMITED",
"GOBLU INDIA PRIVATE LIMITED",
"GOC PETROCHEMICALS PRIVATE LIMITED",
"GOC SERVICES INDIA PRIVATE LIMITED",
"GOCARGO FORWARDING PRIVATE LIMITED",
"GOCHAR MAHAVIDYALAYA",
"GOCHEAP AUTOPARTS PRIVATE LIMITED",
"GOCHWAL LEASING AND FINANCE PRIVATE LIMITED",
"GOCL CORPORATION LIMITED.",
"GOCOMET INDIA PRIVATE LIMITED",
"GOCON LOGISTICS PRIVATE LIMITED",
"GOCOOP SOLUTIONS AND SERVICES PRIVATE LIMITED",
"GOD GIFT PROPERTIES PRIVATE LIMITED",
"GOD GRANITES",
"GOD JAY LABORATORIES PRIVATE LIMITED",
"GODA FARMS AGRO RETAILS PRIVATE LIMITED",
"GODAAMRUT FARMERS PRODUCER COMPANY LIMITED",
"GODAAVARI LABS PRIVATE LIMITED",
"GODABARI AGRO MACHINERY AND SERVICES INDIA PRIVATE LIMITED",
"GODAMWALE TRADING AND LOGISTICS PRIVATE LIMITED",
"GODANI EXPORT PRIVATE LIMITED",
"GODANI INFRATECH PRIVATE LIMITED",
"GODARA CONSTRUCTION (OPC) PRIVATE LIMITED",
"GODARA INFRASTRUCTURE PRIVATE LIMITED",
"GODARA ROADWAYS PRIVATE LIMITED",
"GODAVARI AGRO SERVICES PRIVATE LIMITED",
"GODAVARI AGROTECH PRIVATE LIMITED",
"GODAVARI BIOREFINERIES LIMITED",
"GODAVARI COLLEGE OF NURSING",
"GODAVARI COMMODITIES LTD",
"GODAVARI COTTON INDUSTRIES",
"GODAVARI DEVI JAJU HOSPITAL - JAIPUR",
"GODAVARI DRUGS LIMITED",
"GODAVARI EDIBLE BRAN OIL LIMITED.",
"GODAVARI EDIBLE BRAN OIL PRIVATE LIMITED",
"GODAVARI EQUIPMENTS PRIVATE LIMITED",
"GODAVARI FARM CHEMICAL INDUSTRIES PRIVATE LIMITED",
"GODAVARI GARMENTS LIMITED",
"GODAVARI GAS PRIVATE LIMITED",
"GODAVARI HIGHER SECONDARY SCHOOL HUDCO AURANGABAD",
"GODAVARI HIGHWAYS PRIVATE LIMITED",
"GODAVARI INDUSTRIAL PRODUCTS PRIVATE LIMITED",
"GODAVARI INSTITUTE OF ENGINEERING AND TECHNOLOGY",
"GODAVARI KRISHNA CO-OP SOCIETY LTD",
"GODAVARI MEGA AQUA FOOD PARK PRIVATE LIMITED",
"GODAVARI NUTRIFOODS PRIVATE LIMITED",
"GODAVARI PETROPRODUCTS PVT LTD",
"GODAVARI PIPES PRIVATE LIMITED",
"GODAVARI PLANT SCIENCES PRIVATE LIMITED",
"GODAVARI PLASTO CONTAINERS PRIVATE LIMITED",
"GODAVARI POLYMERS PRIVATE LIMITED",
"GODAVARI PROJECTS PRIVATE LIMITED",
"GODAVARI PUBLIC SCHOOL",
"GODAVARI PULP AND PAPER MILLS PRIVATE LIMITED",
"GODAVARI REALISTIC AGRO EXPORTS PRIVATE LIMITED",
"GODAVARI ROLLER FLOUR MILLS PRIVATE LIMITED",
"GODAVARI SHILPKALA LIMITED",
"GODAVARI URBAN MULTISTATE CREDIT CO OP SOC LTD NANDED",
"GODAVARI VALLEY FARMERS PRODUCER COMPANY LIMITED",
"GODAVARI VIDYALAY PIMPALGAON",
"GODAVARI VYAPAAR PVT LTD",
"GODAVARIBAI PODAR MARATHI PRI SHALA",
"GODAVARIGANGA SEEDS PRIVATE LIMITED",
"GODAVARTHY NARASIMHA MURTHY HEALTH CARE PRIVATE LIMITED",
"GODAVARY IMAGING SCIENCES AND RESEARCH CENTRE PRIVATE LIMITED",
"GODAVARY INDUSTRIES",
"GODAVRI PAINTS PRIVATE LIMITED",
"GODAWARI ADVANCED TECHNOLOGY PRIVATE LIMITED",
"GODAWARI EMOBILITY PRIVATE LIMITED",
"GODAWARI ESTATES PVT LTD",
"GODAWARI FARMS AND SERVICES",
"GODAWARI GREEN ENERGY LIMITED",
"GODAWARI GREEN ENERGY PRIVATE LIMITED",
"GODAWARI INFRAESTATE PRIVATE LIMITED",
"GODAWARI KHORE CANE TRANSPORT COMPANY PRIVATE LIMITED",
"GODAWARI NATURAL RESOURCES LIMITED",
"GODAWARI POWER AND ISPAT LIMITED",
"GODAWARI SILK MILLS PRIVATE LIMITED",
"GODAWARI TECHNO SOLUTION PRIVATE LIMITED",
"GODAWRI CAPITAL PRIVATE LIMITED",
"GODAWRI SPHEROCAST LIMITED",
"GODAWRI SPHEROCAST PRIVATE LIMITED",
"GODAWRI TRADING COMPANY PRIVATE LIMITED",
"GODB TECH PRIVATE LIMITED",
"GODDARD TECHNICAL SOLUTIONS PRIVATE LIMITED",
"GODDESS ADVERTISING PRIVATE LIMITED",
"GODDESS TEXTILES PRIVATE LIMITED",
"GODDRES PHARMACEUTICALS PRIVATE LIMITED",
"GODE ENGINEERING PRIVATE LIMITED",
"GODEC CONSTRUCTION PVT LTD",
"GODESI MANDI PRIVATE LIMITED",
"GODFREY PHILLIPS INDIA LIMITED",
"GODHA CABCON & INSULATION LIMITED",
"GODHA ENTERPRISES PRIVATE LIMITED",
"GODHA INFRASTRUCTIONS INDIA PRIVATE LIMITED",
"GODHAM PANCHGAVYA UTPAD PRIVATE LIMITED",
"GODHAN MASALA FOODS PRIVATE LIMITED",
"GODHANI EXPORTS LIMITED",
"GODHEAD AGRO AND FOOD & BEVERAGES PRIVATE LIMITED",
"GODHOOD DEVELOPERS PRIVATE LIMITED",
"GODHRA EXPRESSWAYS PRIVATE LIMITED",
"GODHRA RE-ROLLING MILL PRIVATE LIMITED",
"GODIL SYNTHETICS PRIVATE LIMITED",
"GODIVA FEEDS AND FOODS PRIVATE LIMITED",
"GODIVA PROPERTIES PRIVATE LIMITED",
"GODOCTOR SOLUTIONS PRIVATE LIMITED",
"GODOLO AND GODOLO EXPORTS PRIVATE LIMITED",
"GODOT ENTERTAINMENT AND MEDIA PRIVATE LIMITED",
"GODREJ & BOYCE",
"GODREJ AND BOYCE MANUFACTURING COMPANY LIMITED",
"GODREJ AGROVET LIMITED",
"GODREJ CAPITAL LIMITED",
"GODREJ CATTLE GENETICS PRIVATE LIMITED",
"GODREJ CONSUMER PRODUCTS LIMITED",
"GODREJ FINANCE LIMITED",
"GODREJ FUND MANAGEMENT AND INVESTMENT ADVISERS PRIVATE LIMITED",
"GODREJ GARDEN CITY PROPERTIES PRIVATE LIMITED",
"GODREJ GENESIS FACILITIES MANAGEMENT PRIVATE LIMITED",
"GODREJ GREEN HOMES PRIVATE LIMITED",
"GODREJ GREENVIEW HOUSING PRIVATE LIMITED",
"GODREJ HIGHVIEW LLP",
"GODREJ HOME CONSTRUCTIONS LIMITED",
"GODREJ HOUSING FINANCE LIMITED",
"GODREJ INDUSTRIES LIMITED",
"GODREJ INFOTECH LIMITED",
"GODREJ KOERBER SUPPLY CHAIN LIMITED",
"GODREJ LIVING PRIVATE LIMITED",
"GODREJ MEMORIAL HOSPITAL",
"GODREJ ONE PREMISES MANAGEMENT PRIVATE LIMITED",
"GODREJ PRAKRITI FACILITIES PRIVATE LIMITED",
"GODREJ PROJECTS DEVELOPMENT LIMITED",
"GODREJ PROPERTIES LIMITED",
"GODREJ REAL VIEW DEVELOPERS PRIVATE LIMITED",
"GODREJ REDEVELOPERS (MUMBAI) PRIVATE LIMITED",
"GODREJ SEEDS & GENETICS LIMITED",
"GODREJ SKYLINE DEVELOPERS PRIVATE LIMITED",
"GODREJ TELECOM LIMITEDC A",
"GODREJ TYSON FOODS LIMITED",
"GODRIWALA PLASTICS PRIVATE LIMITED",
"GODRIX ANALYTICS AND MOBILITY SOLUTIONS PRIVATE LIMITED",
"GODS OWN BA PRIVATE LIMITED",
"GODS OWN COUNTRY HOMES PRIVATE LIMITED",
"GODSENT ENGINEERING PRIVATE LIMITED",
"GODSMATTHEW TRADING INDIA PRIVATE LIMITED",
"GODSON AUTO PRIVATE LIMITED",
"GODSON PUBLIC SCHOOL",
"GODSON TAPES PRIVATE LIMITED",
"GODSPEED GAMING SOLUTIONS PRIVATE LIMITED",
"GODSPEED IMMIGRATION AND STUDY ABROAD PRIVATE LIMITED",
"GODSPEED INFRAVENTURES PRIVATE LIMITED",
"GODSPEED MOTORCYCLE PRIVATE LIMITED",
"GODUTCH TECHNOLOGIES PRIVATE LIMITED",
"GODVET AGROCHEM LIMITED",
"GODWAYS LOGISTICS PRIVATE LIMITED",
"GODWILL ENERGY PRODUCTS PRIVATE LIMITED",
"GODWIN AGRO PRODUCTS LIMITED",
"GODWIN CONSTRUCTION PRIVATE LIMITED",
"GODWIN HOSPITALITY PRIVATE LIMITED",
"GODWIN MEDIA VENTURES PRIVATE LIMITED",
"GODWIN STEELS PRIVATE LIMTED",
"GODWITT CONSTRUCTION PRIVATE LIMITED",
"GO-EAST ADVISORS INDIA PRIVATE LIMITED",
"GOEBAZAR RETAILS PRIVATE LIMITED",
"GOEKA BATHING INDIA PRIVATE LIMITED",
"GOEL & ANDERSON IMMIGRATION SERVICES PRIVATE LIMITED",
"GOEL AGENCIES TELESERVICES PRIVATE LIMITED",
"GOEL ALLOY & STEEL PRIVATE. LIMITED.",
"GOEL AND ASSOCIATES",
"GOEL BINDING ENTERPRISES PRIVATE LIMITED",
"GOEL BROTHERS RAIL INFRA PRIVATE LIMITED",
"GOEL CARGO PRIVATE. LIMITED.",
"GOEL COAL SIZING PRIVATE. LIMITED.",
"GOEL CONSTRUCTION COMPANY PRIVATE LIMITED",
"GOEL COTTS PRIVATE LIMITED",
"GOEL CREATIVE ARTS PRIVATE LIMITED",
"GOEL DECORS INDIA PRIVATE LIMITED",
"GOEL DYECHEM PRIVATE LIMITED.",
"GOEL ENTERPRISES PRIVATE LIMITED",
"GOEL FLOUR MILLS LIMITED",
"GOEL FOAM & FURNISHING PRIVATE LIMITED",
"GOEL FOOD PRODUCTS LIMITED",
"GOEL FORGINGS PRIVATE LIMITED",
"GOEL GANGA CORPORATION PRIVATE LIMITED",
"GOEL GANGA DEVELOPERS INDIA PRIVATE LIMITED",
"GOEL GANGA DEVELOPMENTS LLP",
"GOEL GANGA FOUNDATION",
"GOEL GANGA INDIA PRIVATE LIMITED",
"GOEL GARMENTS PRIVATE LIMITED",
"GOEL GEMS & JEWELS PRIVATE LIMITED",
"GOEL HANDICRAFTS PRIVATE LIMITED",
"GOEL HOSIERY MILLS PRIVATE LIMITED",
"GOEL INTERNATIONAL PRIVATE LIMITED",
"GOEL KNITS INDIA PRIVATE LIMITED",
"GOEL LAMIPACKS PRIVATE LIMITED",
"GOEL METACHEM PRIVATE LIMITED",
"GOEL MINERALS PRIVATE LIMITED",
"GOEL MULTITRADE PRIVATE LIMITED",
"GOEL OVERSEAS",
"GOEL PETRO ENERGY LIMITED",
"GOEL PETROCHEM PRIVATE LIMITED",
"GOEL PLANTATIONS PRIVATE LIMITED",
"GOEL POWER CONTROLS PRIVATE LIMITED",
"GOEL PULP & PAPER PRIVATE LIMITED",
"GOEL PULSES PRIVATE LIMITED",
"GOEL REFRIGERATIONS PRIVATE LIMITED",
"GOEL RETAIL PRODUCTS PRIVATE LIMITED",
"GOEL ROAD CARRIERS PRIVATE LIMITED",
"GOEL ROADWAYS PVT LTD",
"GOEL SCIENTIFIC GLASS WORKS LIMITED",
"GOEL SELECTION PRIVATE LIMITED",
"GOEL SINKS (INDIA) PRIVATE LIMITED",
"GOEL SONS JEWELLERS PRIVATE LIMITED",
"GOEL SPECIAL STEELS & ENGINEERING PRIVATE LIMITED",
"GOEL SPINTEX PRIVATE LIMITED",
"GOEL SUPERSPECIALITY MEDICAL CENTRE PRIVATE LIMITED",
"GOEL TEA PRODUCTS PRIVATE LIMITED",
"GOEL TRADECON PRIVATE LIMITED",
"GOEL VET PHARMA PRIVATE LIMITED",
"GOEL ZENITH AGRO PVT LTD",
"GOELA ELECTRONICS PRIVATE LIMITED",
"GOELS COIR FOAM (INDIA) PRIVATE LIMITED",
"GOELSUN INDUSTRIES PRIVATE LIMITED",
"GOEMENEASZ CONFORMITY ASSESSMENT SERVICES PRIVATE LIMITED",
"GOENCA RESORTS PRIVATE LIMITED",
"GOENKA & ASSOCIATES EDUCATIONAL TRUST",
"GOENKA & CO. SALES PVT LTD",
"GOENKA AUTO PRIVATE LIMITED",
"GOENKA AUTOSALES PRIVATE LIMITED",
"GOENKA BRICKS PRIVATE LIMITED",
"GOENKA BUSINESS & FINANCE LTD",
"GOENKA CAST ENGINEERING (INDIA) PRIVATE LIMITED",
"GOENKA DECOR PRIVATE LIMITED",
"GOENKA ENGINEERING AND INDUSTRIAL PVT LTD",
"GOENKA EXIM PRIVATE LIMITED",
"GOENKA GLITTERATII PRIVATE LIMITED",
"GOENKA INSTITUTE OF EDUCATION AND RESEARCH",
"GOENKA LIFESTYLES PRIVATE LIMITED",
"GOENKA MOTORS PRIVATE LIMITED",
"GOENKA OFFSET PRINTERS PVT LTD",
"GOENKA PROTEINS PRIVATE LIMITED",
"GOENKA READYMADES PRIVATE LIMITED",
"GOENKA REALTORS PRIVATE LIMITED",
"GOENKA ROCKWOOL (INDIA) PRIVATE LIMITED",
"GOENKA SECURITIES PVT LTD",
"GOENKA SWITCHGEARS PRIVATE LIMITED",
"GOENKA SYNDICATE PRIVATE LIMITED",
"GOENKA TRADING PRIVATE LIMITED",
"GOEPEL ELECTRONICS INDIA PRIVATE LIMITED",
"GOER TECHNO INFRA PRIVATE LIMITED",
"GOETHE-INSTITUT MAX MUELLER BHAVAN",
"GOEX FREIGHT SOLUTIONS PRIVATE LIMITED",
"GOF EDUCATION FOUNDATION",
"GOFIN LABS INDIA PRIVATE LIMITED",
"GOFLEX LIMITED",
"GOFLY DIGITAL PRIVATE LIMITED",
"GOFORTH ADVENTURES PRIVATE LIMITED",
"GOFRESHO RETAIL SERVICES PRIVATE LIMITED",
"GOFRUGAL TECHNOLOGIES PRIVATE LIMITED",
"GOFX FOREX AND TRAVELS PRIVATE LIMITED",
"GOGA FOODS LIMITED",
"GOGAD FABRICS PRIVATE LIMITED",
"GOGARS MANUFACTURING PRIVATE LIMITED",
"GOGATE ELECTROSYSTEMS (NASIK) PRIVATE LIMITED",
"GOGIA CAPITAL SERVICES LIMITED",
"GOGIA CHEMICAL INDUSTRIES PRIVATE LIMITED",
"GOGIA COMMODITY TRADING PRIVATE LIMITED",
"GOGIA FLAVOURS AND FRAGRANCES PRIVATE LIMITED",
"GOGIA FLOUR MILLS PRIVATE LIMITED",
"GOGIA FRAGRANCES PRIVATE LIMITED",
"GOGIA LEASING LIMITED",
"GOGIA PLASTIC TRADERS PRIVATE LIMITED",
"GOGLIO FLEX PACK SYSTEM INDIA PRIVATE LIMITED",
"GOGLOBAL INDIA PRIVATE LIMITED",
"GOGO FASHIONS PRIVATE LIMITED",
"GO-GO FOODS PRIVATE LIMITED",
"GO-GO TRAVELS PRIVATE LIMITED",
"GOGOAL HYDRO PRIVATE LIMITED",
"GOGOAL-ENERGO PRIVATE LIMITED",
"GOGOVAN INDIA PRIVATE LIMITED",
"GOGREEN BIKES PRIVATE LIMITED",
"GO-GREEN CONSTRUCTION SOLUTIONS PRIVATE LIMITED",
"GOGREEN LABORATORY AND SURVEYOR PRIVATE LIMITED",
"GOGREEN SOLUTIONS PRIVATE LIMITED",
"GOGREEN WAREHOUSES PRIVATE LIMITED",
"GOGRI MARKETING PVT LTD",
"GOGROUND BEANS & SPICES PRIVATE LIMITED",
"GOGTE INFRASTRUCTURE DEVELOPMENT CORPORATION LIMITED",
"GOGULA CONSTRUCTIONS PRIVATE LIMITED",
"GOHANA SONEPAT HIGHWAY PRIVATE LIMITED",
"GO-HEIGHTS REAL ESTATE PRIVATE LIMITED",
"GOHIL ENTERPRISES PRIVATE LIMITED",
"GOHINA FOODS PRIVATE LIMITED",
"GOHINOOR PIPES PRIVATE LIMITED",
"GOHYPE TECHNOLOGIES PRIVATE LIMITED",
"GOICONIC CARE AND BUSINESS MANAGEMENT PRIVATE LIMITED",
"GOINDI MACHINES PRIVATE LIMITED",
"GOINGNUTS TRADING INDIA PRIVATE LIMITED",
"GO-ISH REMEDIES LIMITED",
"GOIT DISTRIBUTION PRIVATE LIMITED",
"GOITREND SETTER (INDIA) PRIVATE LIMITED",
"GOJIS LIFESTYLE PRIVATE LIMITED",
"GOJITAL PRIVATE LIMITED",
"GOKA ENGINEERING CO PRIVATE LIMITED",
"GOKAK POWER & ENERGY LIMITED",
"GOKAK SUGARS LIMITED",
"GOKAK TEXTILES LIMITED",
"GOKALCHAND RATTANCHAND WOOLLEN MILLS PRIVATE LIMITED",
"GOKALDAS EXPORTS LIMITED",
"GOKALDAS MURLIMANOHAR JOHRI PRIVATE LIMITED",
"GOKALDAS PACKAGING SOLUTIONS PRIVATE LIMITED",
"GOKALIBAI P P HIGH SCHOOL",
"GOKANN INTERNATIONAL MEDIA PRIVATE LIMITED",
"GOKARAJU RANGARAJU INSTITUTE OF ENGINEERING & TECHNOLOGY",
"GOKARE LPO PRIVATE LIMITED",
"GOKELP HR SERVICES PRIVATE LIMITED",
"GOKHALE EDUCATION SOCIETY'S",
"GOKHALE INFRADEVELOPERS PRIVATE LIMITED",
"GOKHALE INSTITUTE OF POLITICS ECONOMIC",
"GOKHALE MEMORIAL GIRLS COLLEGE",
"GOKIR JEWELS CREATORS PRIVATE LIMITED",
"GOKUL AGRI INTERNATIONAL LIMITED",
"GOKUL AGRO RESOURCES LIMITED",
"GOKUL AUTOTECH PRIVATE LIMITED",
"GOKUL COATS INDIA PRIVATE LIMITED",
"GOKUL COTTON PRIVATE LIMITED",
"GOKUL DAIRY PRODUCTS",
"GOKUL ENTERPRISE PRIVATE LIMITED",
"GOKUL EXIM PRIVATE LIMITED",
"GOKUL FERROCAST PRIVATE LIMITED",
"GOKUL FINANCE AND INVESTMENT COMPANY PRIVATE LIMITED",
"GOKUL FLEXIBAG PRIVATE LIMITED",
"GOKUL FOODS PRIVATE LIMITED",
"GOKUL FOOTWEAR PRIVATE LIMITED",
"GOKUL FRUITS PRIVATE LIMITED",
"GOKUL FUELCHEM PRIVATE LIMITED",
"GOKUL GARDEN BANQUETS PRIVATE LIMITED",
"GOKUL GEMS AND JEWELS PRIVATE LIMITED",
"GOKUL GLOBAL UNIVERSITY",
"GOKUL HEALTH CARE PRIVATE LIMITED",
"GOKUL HYTECH INFRA PRIVATE LIMITED",
"GOKUL INFRACON PRIVATE LIMITED",
"GOKUL KESARI FOODS PRIVATE LIMITED",
"GOKUL KNITT FABS",
"GOKUL KRIPA COLONIZERS AND DEVELOPERS PRIVATE LIMITED",
"GOKUL LIFE CARE PRIVATE LIMITED",
"GOKUL METALS & ENGINEERING PRIVATE LIMITED",
"GOKUL OFFSET PRIVATE LIMITED",
"GOKUL POLY VALVES PRIVATE LIMITED",
"GOKUL REFOILS & SOLVENTS LIMITED",
"GOKUL RESOLUTION SERVICES PRIVATE LIMITED",
"GOKUL STEELS PRIVATE LIMITED",
"GOKUL STONES & TILES PRIVATE LIMITED",
"GOKUL TANKER SERVICES PRIVATE LIMITED",
"GOKUL TEXPRINTS PRIVATE LIMITED",
"GOKUL VRINDA DAIRY & FARM PVT LTD",
"GOKULAM CHIT",
"GOKULAM LIFESCIENCE PRIVATE LIMITED",
"GOKULAM SHEITERS PRIVATE LIMITED",
"GOKULAMRUT MILK PRODUCTS PRIVATE LIMITED",
"GOKULANAND PETROFIBERS",
"GOKULDAS EDUCATION SOCIETY",
"GOKULDAS HOSPITALS PRIVATE LIMITED",
"GOKULDAS MATERNITY HOSPITAL",
"GOKULDHAM HIGH SCHOOL & JR COLLEGE",
"GOKULE'S MODULAR INDUSTRIES PRIVATE LIMITED",
"GOKULESH COMMERCIAL PVT LTD",
"GOKULESH STEEL PRIVATE LIMITED",
"GOKULKRIPA BUILDTECH PRIVATE LIMITED",
"GOL PURIA POLYESTER PRIVATE LIMITED",
"GOL VENTURES PRIVATE LIMITED",
"GOLA STEEL AND CASTINGS PRIVATE LIMITED",
"GOLANI BROTHERS",
"GOLANK JEWELS AND FOREX PRIVATE LIMITED",
"GOLARS ENVIRONMENTAL ENGINEERS PRIVATE LIMITED",
"GOLBIO PACKS PRIVATE LIMITED",
"GOLCHA CINETALE PVT LIMITED",
"GOLCHA FINANCIAL CONSULTANTS PRIVATE LIMITED",
"GOLCHA FINGROWTH PRIVATE LIMITED",
"GOLCHA MINERALS (INDIA) PRIVATE LIMITED",
"GOLCHHA ENTERPRISES PRIVATE LIMITED",
"GOLCHHA FLOUR MILLS PRIVATE LIMITED",
"GOLCHHA OXIDES PRIVATE LIMITED",
"GOLCHHA PIGMENTS PVT LTD",
"GOLCON TECHNOLOGIES PRIVATE LIMITED",
"GOLD BEACH RESORTS",
"GOLD BERRIES CONSULTING PRIVATE LIMITED",
"GOLD BLEND PRIVATE LIMITED",
"GOLD BOX ENTERTAINMENTS PRIVATE LIMITED",
"GOLD CHICK HATCHERIES AND FOODS LIMITED",
"GOLD COAST IT SOLUTIONS PRIVATE LIMITED",
"GOLD COIN ENGINEERS PRIVATE LIMITED",
"GOLD CRAFT INDIA PRIVATE LIMITED",
"GOLD DIAGNOSTICS",
"GOLD DIGITECH THEATERS PRIVATE LIMITED",
"GOLD FILAMENTS PRIVATE LIMITED",
"GOLD FINGER EST. PRIVATE LIMITED",
"GOLD FITNESS PRIVATE LIMITED",
"GOLD FLAKE CORPORATION LIMITED",
"GOLD FOIL TOWN PLANNERS PRIVATE LIMITED",
"GOLD GHAR CONSTRUCTIONS PRIVATE LIMITED",
"GOLD GRAIN (INDIA) PRIVATE LIMITED",
"GOLD HOUSE JEWELLERS PRIVATE LIMITED",
"GOLD LEAF PRIVATE LIMITED",
"GOLD LIFE ENGINEERS REGD.",
"GOLD LINE INTERNATIONAL FINVEST LIMITED",
"GOLD LORD INDUSTRIES PRIVATE LIMITED",
"GOLD METAL EXTRUSION",
"GOLD MINAR DEVELOPERS PRIVATE LIMITED",
"GOLD MOHAR PRODUCTS PRIVATE LIMITED",
"GOLD MOHUR PROFILES LIMITED",
"GOLD NEWS MONITORING SERVICE PRIVATE LIMITED",
"GOLD PARKS PRIVATE LIMITED",
"GOLD PLAST INTERNATIONAL PRIVATE LIMITED",
"GOLD PLUS FLOAT GLASS PRIVATE LIMITED",
"GOLD PLUS GLASS INDUSTRY LIMITED",
"GOLD RANGE CASTINGS PRIVATE LIMITED",
"GOLD ROCK INVESTMENTS LIMITED",
"GOLD SACK PRIVATE LIMITED",
"GOLD SEAL AVON POLYMERS PRIVATE LIMITED",
"GOLD SEAL ENGINEERING PRODUCTS PRIVATE LIMITED",
"GOLD SPIN INDIA PRIVATE LTD.",
"GOLD STAR ASSOCIATES PRIVATE LIMITED",
"GOLD STAR CORPORATE SOLUTIONS PRIVATE LIMITED",
"GOLD STAR DIAMOND PRIVATE LIMITED",
"GOLD STAR ELITE JEWELS PRIVATE LIMITED",
"GOLD STAR FINE JEWELLERY LLP",
"GOLD STAR GARMENT ACCESSORIES PRIVATE LIMITED",
"GOLD STAR GREEN SEEDS PRIVATE LIMITED",
"GOLD STAR INDUSTRIES",
"GOLD STAR INFRATECH PRIVATE LIMITED",
"GOLD STAR JEWELLERY INDIA PRIVATE LIMITED",
"GOLD STAR JEWELLERY PRIVATE LIMITED",
"GOLD STAR POLY WEAVE LIMITED",
"GOLD STAR POWDERS PRIVATE LIMITED",
"GOLD STAR REALTORS LIMITED",
"GOLD STAR RE-ROLLERS PRIVATE LIMITED",
"GOLD STAR RUBBERS PRIVATE LIMITED",
"GOLD STAR STEELS PRIVATE.LIMITED",
"GOLD STAR STRIPS (GUJARAT) PRIVATE LIMITED",
"GOLD STAR WAREHOUSING AND POLYMER COMPANY PRIVATE LIMITED",
"GOLD SYSTEMS AND COMMUNICATIONS PRIVATE LIMITED",
"GOLD TAG ASSIST SERVICES PRIVATE LIMITED",
"GOLD TELECOMMUNICATIONS INDIA PRIVATE LIMITED",
"GOLD VANLINES PRIVATE LIMITED",
"GOLDBRICKS INFRASTRUCTURE PRIVATE LIMITED",
"GOLDCASH LIMITED",
"GOLDCOIN ABRASIVE PRIVATE LIMITED",
"GOLDCOIN ANGEL CPP FILM PRIVATE LIMITED",
"GOLDCOIN CORPORATION PRIVATE LIMITED",
"GOLDCOIN FOAM PRIVATE LIMITED",
"GOLDCOIN INDUSTRIES PRIVATE LIMITED",
"GOLDCOIN MICRO BENEFIT FOUNDATION",
"GOLDCOIN MULTIPACK PRIVATE LIMITED",
"GOLDCOIN PACKAGING PRIVATE LIMITED",
"GOLDCOIN POLYPLAST",
"GOLDCORP GLOBAL LOGISTICS PRIVATE LIMITED",
"GOLDCREST CORPORATION LIMITED",
"GOLDCREST GLOBAL TRADING PRIVATE LIMITED",
"GOLDCREST HIGH INTERNATIONAL SCHOOL",
"GOLDE BENGALURU INDIA PRIVATE LIMITED",
"GOLDELLA PRECIOUS METALS PRIVATE LIMITED",
"GOLDEN AERO LOGISTICS AND CONCIERGE SERVICES PRIVATE LIMITED",
"GOLDEN AGE DWELLERS & LIVING PRIVATE LIMITED",
"GOLDEN AGE INFRASTRUCTURE PRIVATE LIMITED",
"GOLDEN AGRI RESOURCES (INDIA) PRIVATE LIMITED",
"GOLDEN AGRIGENETIC INDIA LIMITED",
"GOLDEN ALKALIES AND CHEMICALS PRIVATE LIMITED",
"GOLDEN ALLIANCE HOSPITALITIES PRIVATE LIMITED",
"GOLDEN ALMONDS INDIA PRIVATE LIMITED",
"GOLDEN ANCHOR PRIVATE LIMITED",
"GOLDEN APPARELS EXPORTS PRIVATE LIMITED",
"GOLDEN APPLE",
"GOLDEN APPLE FRUITMART PRIVATE LIMITED",
"GOLDEN ARROW CONSTRUCTIONS PRIVATE LIMITED",
"GOLDEN ART EXPORTS PRIVATE LIMITED",
"GOLDEN ASSETBAY CONSULTANTS PRIVATE LIMITED",
"GOLDEN BELLS PUBLIC SCHOOL",
"GOLDEN BRICKS CONSTRUCTIONS PRIVATE LIMITED",
"GOLDEN BRICKS PROMOTERS PRIVATE LIMITED",
"GOLDEN BRICKS WEEKEND HOMES PRIVATE LIMITED",
"GOLDEN CARAT PRIVATE LIMITED",
"GOLDEN CARPETS",
"GOLDEN CASHEW PRODUCTS PRIVATE LIMITED",
"GOLDEN CENTURY FOOD PRODUCTS PRIVATE LIMITED",
"GOLDEN CHARIOT HOSPITALITY SERVICES PRIVATE LIMITED",
"GOLDEN CHARIOT PUBLIC SCHOOL",
"GOLDEN CHARIOT RETREATS AND INFRA PRIVATE LIMITED",
"GOLDEN CHARIOT TRAVEL SOLUTIONS PRIVATE LIMITED",
"GOLDEN CHEMICALS PRIVATE LIMITED",
"GOLDEN CHERI FOODS PRIVATE LIMITED",
"GOLDEN CHOCOLATES PRIVATE LIMITED",
"GOLDEN COAST GLOBAL (INDIA) PRIVATE LIMITED",
"GOLDEN COLLECTIONS (INDIA) PRIVATE LIMITED",
"GOLDEN CORPORATE SERVICES PRIVATE LIMITED",
"GOLDEN COTTON INDUSTRIES",
"GOLDEN CREST MARKETING NETWORK PRIVATE LIMITED",
"GOLDEN DAIRY PRODUCTS PRIVATE LIMITED",
"GOLDEN DIGITECH PRIVATE LIMITED",
"GOLDEN DIVINE CREATIONS PRIVATE LIMITED",
"GOLDEN DRUGS PRIVATE LIMITED",
"GOLDEN EAGLE IT TECHNOLOGIES PRIVATE LIMITED",
"GOLDEN EAGLE WASTE MANAGEMENT COMPANY LL P",
"GOLDEN EARTH HOTELS INDIA PRIVATE LIMITED",
"GOLDEN EDGE ENGINEERING PRIVATE LIMITED",
"GOLDEN ELECTROWORLD PRIVATE LIMITED",
"GOLDEN ENGINEERING COMPANY PVT LTD",
"GOLDEN ENGINEERING TECHNOLOGIES PRIVATE LIMITED",
"GOLDEN ENTERPRICES",
"GOLDEN ENTERPRISES",
"GOLDEN EPAULETTES AVIATION PRIVATE LIMITED",
"GOLDEN ERA HOSPITALITY LIMITED",
"GOLDEN ERA INDUSTRIES PRIVATE LIMITED",
"GOLDEN ESTUARY TRADING PRIVATE LIMITED",
"GOLDEN FACILITATION SERVICES PRIVATE LIMITED",
"GOLDEN FALCON INDIA PRIVATE LIMITED",
"GOLDEN FALCON INDUSTRIES LIMITED",
"GOLDEN FALCON OVERSEAS PRIVATE LIMITED",
"GOLDEN FALCON PACIFIC LIMITED",
"GOLDEN FASHIONS INDIA PRIVATE LIMITED",
"GOLDEN FIBRES LLP",
"GOLDEN FLOOR FURNISHING PRIVATE LIMITED",
"GOLDEN FORK HOSPITALITY PRIVATE LIMITED",
"GOLDEN GALAXY HOTELS AND RESORTS PRIVATE LIMITED",
"GOLDEN GAMING INTERNATIONAL PRIVATE LIMITED",
"GOLDEN GATE BEAUTY DREAMZ",
"GOLDEN GATE VENTURES PRIVATE LIMITED",
"GOLDEN GATES EDUCATIONAL TRUST",
"GOLDEN GATES VIDYASHRAM SENIOR SECONDARY SCHOOL",
"GOLDEN GLOBE ADVISORY PRIVATE LIMITED",
"GOLDEN GLOBE HOTELS PRIVATE LIMITED",
"GOLDEN GOENKA COMMERCE PRIVATE LIMITED",
"GOLDEN GOENKA CREDIT PRIVATE LIMITED",
"GOLDEN GREENS GOLF & RESORTS LIMITED",
"GOLDEN HAWK DEBT MANAGEMENT AND LEGAL SERVICES PRIVATE LIMITED",
"GOLDEN HAWK RETAIL INDIA",
"GOLDEN HILLS CAPITAL INDIA PRIVATE LIMITED",
"GOLDEN HILLS ESTATES PRIVATE LIMITED",
"GOLDEN HIPPO TECHNOLOGY PRIVATE LIMITED",
"GOLDEN HOMES PRIVATE LIMITED",
"GOLDEN HOSIERY MFG CO PRIVATE LIMITED",
"GOLDEN HOSPITALITY SERVICES PRIVATE LIMITED",
"GOLDEN HOTELS & RESORTS PRIVATE LIMITED",
"GOLDEN HOUSE RESORTS PVT LTD",
"GOLDEN IKON FLEET MANAGEMENT PRIVATE LIMITED",
"GOLDEN INDIA CITYSCAPES PRIVATE LIMITED",
"GOLDEN INFOSYS",
"GOLDEN INFRAVENTURES PRIVATE LIMITED",
"GOLDEN INN PRIVATE LIMITED",
"GOLDEN INTERNATIONAL PRIVATE LIMITED",
"GOLDEN KITCHENS PRIVATE LIMITED",
"GOLDEN LEAF COUNTY PRIVATE LIMITED",
"GOLDEN LEAF INTERNATIONALS PRIVATE LIMITED",
"GOLDEN LIQUID SOLUTIONS PRIVATE LIMITED",
"GOLDEN LUBES PRIVATE LIMITED",
"GOLDEN MAJESTIC HOSPITALITY PRIVATE LIMITED",
"GOLDEN MANDHIR RETAIL PRIVATE LIMITED",
"GOLDEN METAL PRIVATE LIMITED",
"GOLDEN MONEY CHANGER PRIVATE LIMITED",
"GOLDEN MOTORS PRIVATE LIMITED",
"GOLDEN NEST FARMS PRIVATE LIMITED",
"GOLDEN NIMBUS INDIA PRIVATE LIMITED",
"GOLDEN NON-CONVENTIONAL ENERGY SYSTEMS PRIVATE LIMITED",
"GOLDEN OASIS HOTELS PRIVATE LIMITED",
"GOLDEN OPPORTUNITIES PRIVATE LIMITED",
"GOLDEN PALMS (INDIA) PRIVATE LIMITED",
"GOLDEN PALMS FACILITY MANAGEMENT PRIVATE. LIMITED.",
"GOLDEN PEACE HOTELS AND RESORTS PRIVATE LIMITED",
"GOLDEN PEACE INFRASTRUCTURE PRIVATE LIMITED",
"GOLDEN PEAKOCK OVERSEAS LIMITED",
"GOLDEN PHOENIX TRAVELS PRIVATE LIMITED",
"GOLDEN PIGMENTS PVT.LTD.",
"GOLDEN PLANET ENTERPRISES LLP",
"GOLDEN PORCH ENTERTAINMENT PRIVATE LIMITED",
"GOLDEN POULTRY FLAPPY BIRDS PRIVATE LIMITED",
"GOLDEN POWER ENERGY SOLUTIONS PRIVATE LIMITED",
"GOLDEN PRECISION PRODUCTS PRIVATE LIMITED",
"GOLDEN PRESS PRIVATE LIMITED",
"GOLDEN PRINCE BHATIA GROUP ENTITY",
"GOLDEN PRINCE WINES INDIA PRIVATE LIMITED",
"GOLDEN PROFIN PRIVATE LIMITED",
"GOLDEN PULSES PRIVATE LIMITED",
"GOLDEN RABBIT COMMUNICATIONS PRIVATE LIMITED",
"GOLDEN RATIO FILMS PRIVATE LIMITED",
"GOLDEN REFINERIES PRIVATE LIMITED",
"GOLDEN REFRACTORIES PRIVATE LIMITED",
"GOLDEN RELIEF RESOURCES INDIA PRIVATE LIMITED",
"GOLDEN ROADWAYS & LOGISTICS PRIVATE LIMITED",
"GOLDEN ROCK GRANITES PRIVATE LIMITED",
"GOLDEN ROLLS PRIVATE LIMITED",
"GOLDEN ROYAL WAREHOUSE PRIVATE. LIMITED.",
"GOLDEN ROYALE HOSPITALITY PRIVATE LIMITED",
"GOLDEN SAFETY SERVICES PRIVATE LIMITED",
"GOLDEN SEAMS INDUSTRIES PRIVATE LIMITED",
"GOLDEN SECUITY GUARDS",
"GOLDEN SHELTERS PRIVATE LIMITED",
"GOLDEN SHOPPING MALL & HOTELS PRIVATE LIMITED",
"GOLDEN SPARROW DEVELOPERS PRIVATE. LIMITED.",
"GOLDEN SPINNING MILLS PRIVATE LIMITED",
"GOLDEN SPIRITS (GOA) PRIVATE LIMITED",
"GOLDEN SPIRITS PRIVATE LIMITED",
"GOLDEN STAMPINGS PRIVATE LIMITED",
"GOLDEN STAR CAPITAL TECH LIMITED",
"GOLDEN STAR PROMOTERS PRIVATE LIMITED",
"GOLDEN STAR SURGICAL INDUSTRIES PRIVATE LIMITED",
"GOLDEN STREAK DRUGS AND PHARMACEUTICALS LIMITED",
"GOLDEN SUBRAMANYA FLOUR MILLS PRIVATE LIMITED",
"GOLDEN SUN AGRO FOODS PRIVATE LIMITED",
"GOLDEN SUN TECHNOLOGY PRIVATE LIMITED",
"GOLDEN TEMPLE FORGING PRIVATE LIMITED",
"GOLDEN TERRY TOWEL PRIVATE LIMITED",
"GOLDEN TIME WATCHES (INDIA) PRIVATE LIMITED",
"GOLDEN TIPS TEA COMPANY P LTD",
"GOLDEN TOBACCO MANUFACTURING COMPANY PRIVATE LIMITED",
"GOLDEN TOBIE LIMITED",
"GOLDEN TOUCH ARTWARE PRIVATE LIMITED",
"GOLDEN TOUCH DEVELOPMENTS PRIVATE LIMITED",
"GOLDEN TOUCH IMPORTS INC",
"GOLDEN TOWER INFRATECH PRIVATE LIMITED",
"GOLDEN TRIANGLE FORT AND PALACE PRIVATE LIMITED",
"GOLDEN TUFF PRIVATE LIMITED",
"GOLDEN TULIP GRAND VIEW RESORT",
"GOLDEN TULIP HOSPITALITY PRIVATE LIMITED",
"GOLDEN TYRES PRIVATE LIMITED",
"GOLDEN VALLEY AGROTECH PRIVATE LIMITED",
"GOLDEN VIEW RESTAURANT PRIVATE LIMITED",
"GOLDEN WAVE INFRATECH PRIVATE LIMITED",
"GOLDEN WEALTH ADVISORY PRIVATE LIMITED",
"GOLDEN WEAVE PRIVATE LIMITED",
"GOLDEN WHEAT AND ALLIED MILLS PRIVATE LIMITED",
"GOLDEN WHEEL HOTELS PRIVATE LIMITED",
"GOLDEN WINGS INTERNATIONAL TRAVELS PRIVATE LIMITED",
"GOLDEN WINGS TOURS PRIVATE. LIMITED",
"GOLDENARCH CONSUMER ELECTRONICS PRIVATE LIMITED",
"GOLDENARCH INFRATECH PRIVATE LIMITED",
"GOLDENAVATAR VENTURES PRIVATE LIMITED",
"GOLDENBRICKS CONSUMER PRODUCTS PRIVATE LIMITED",
"GOLDENCROSS PHARMA LIMITED",
"GOLDENCROSS PHARMA PRIVATE LIMITED",
"GOLDENDAYS CREATIONS PRIVATE LIMITED",
"GOLDENDAYS PLASTECH PRIVATE LIMITED",
"GOLDENDUNES BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"GOLDENDUNES BUILDHOME PRIVATE LIMITED",
"GOLDENDUNES COLONIZERS PRIVATE LIMITED",
"GOLDENEYE GUARDING SOLUTION PRIVATE LIMITED",
"GOLDENGLOBE INFRA PRIVATE LIMITED",
"GOLDENHUB CONPRO PRIVATE LIMITED",
"GOLDENIZE FOREX AND TRAVELS PRIVATE LIMITED",
"GOLDENJUBILIES MOTORS PRIVATE LIMITED",
"GOLDENKEY AQUA PRIVATE LIMITED",
"GOLDENKEY ENGINEERING INDUSTRIES PRIVATE LIMITED",
"GOLDENKEY STEELS PRIVATE LIMITED",
"GOLDENKEY VENTURES PRIVATE LIMITED",
"GOLDENKEYS PRIVATE LIMITED",
"GOLDENLIGHT VLSI PRIVATE LIMITED",
"GOLDENLINE DEVELOPERS PRIVATE LIMITED",
"GOLDENLION CONSULTING SERVICES PRIVATE LIMITED",
"GOLDENMEN STUDIOS PRIVATE LIMITED",
"GOLDENOAK FOOD AND BEVERAGES PRIVATE LIMITED",
"GOLDENOAK PROJECTS PRIVATE LIMITED",
"GOLDENORANGE INFRATEL PRIVATE LIMITED",
"GOLDENORCHID MARKETING PRIVATE LIMITED",
"GOLDENPALM MANUFACTURERS PRIVATE LIMITED",
"GOLDENPI TECHNOLOGIES PRIVATE LIMITED",
"GOLDENPINT HOSPITALITY PRIVATE LIMITED",
"GOLDENSIGHT MERCHANTS PRIVATE LIMITED",
"GOLDENSOURCE INTERNATIONAL PRIVATE LIMITED",
"GOLDENSUN COSMOS MACHINERY PRIVATE LIMITED",
"GOLDENTOES PRIVATE LIMITED",
"GOLDENVIEW ESTATES PRIVATE LIMITED",
"GOLDER ASSOCIATES CONSULTING INDIA PRIVATE LIMITED",
"GOLDFACE INTERIO INDIA PRIVATE LIMITED",
"GOLDFARMS PLANT TECH PRIVATE LIMITED",
"GOLDFEATHER VENTURES PRIVATE LIMITED",
"GOLDFIELD FRAGRANCES PRIVATE LIMITED",
"GOLDFILL INDUSTRIES PRIVATE LIMITED",
"GOLDFIN POULTRIES PRIVATE LIMITED",
"GOLDFINCH COLLEGE OF NURSINH",
"GOLDFINCH ENGINEERING SYSTEMS PRIVATE LIMITED",
"GOLDFINCH HOTELS PRIVATE LIMITED",
"GOLDFINCH HYGENIC FOODS PRIVATE LIMITED",
"GOLDFINCH PRODUCTS PRIVATE LIMITED",
"GOLDFINCH RESORTS PRIVATE LIMITED",
"GOLDFINGER TRAVELS PRIVATE LIMITED",
"GOLDFISH ABODE PRIVATE LIMITED",
"GOLDFISH CAPITAL ADVISORS PRIVATE LIMITED",
"GOLDFISH IT SOLUTIONS INDIA PRIVATE LIMITED",
"GOLDFISHH SUPPLYCHAIN TECHNOLOGIES PRIVATE LIMITED",
"GOLDFLAKES JEWELS PRIVATE LIMITED",
"GOLDFLEX AUTO PARTS PRIVATE LIMITED",
"GOLDI & VIPUL MEDICARE PRIVATE LIMITED",
"GOLDI GREEN TECHNOLOGIES PRIVATE LIMITED",
"GOLDI SOLAR PRIVATE LIMITED",
"GOLDI SUN PRIVATE LIMITED",
"GOLDI THREADS",
"GOLDIAM INTERNATIONAL LIMITED",
"GOLDIAM JEWELLERY LIMITED",
"GOLDIEE MASALE PRIVATE LIMITED",
"GOLDILOCKS PREMIUM RESEARCH PRIVATE LIMITED",
"GOLDKART JEWELS LIMITED",
"GOLDKING BIOGENE PRIVATE LIMITED",
"GOLDLEAF ENTERPRISE PRIVATE LIMITED",
"GOLDLINE AUTOS PRIVATE LIMITED",
"GOLDLINE COMPUTERS PRIVATE LIMITED",
"GOLDLINE FINANCE PRIVATE LIMITED",
"GOLDLINE PHARMACEUTICAL LIMITED",
"GOLDLITES INDIA PRIVATE LIMITED",
"GOLDMAN AGENT PRIVATE LIMITED",
"GOLDMAN COMMUNICATIONS PRIVATE LIMITED",
"GOLDMAN DEVELOPERS PRIVATE LIMITED.",
"GOLDMAN INFRA PRIVATE LIMITED",
"GOLDMAN RUBBERS PRIVATE LIMITED",
"GOLDMAN SACHS (INDIA) ALTERNATIVE INVESTMENT MANAGEMENT PRIVATE LIMITED",
"GOLDMAN SACHS ASSET MANAGEMENT INDIA PRIVATE LIMITED",
"GOLDMAN SACHS INDIA CAPITAL MARKETS PRIVATE LIMITED",
"GOLDMAN SACHS INDIA FINANCE PRIVATE. LIMITED.",
"GOLDMAN SACHS INDIA SECURITIES PRIVATE LIMITED",
"GOLDMAN SACHS SERVICES PRIVATE LIMITED",
"GOLDMARINE EXPORTS PRIVATE LIMITED",
"GOLDMART JEWELS PRIVATE LIMITED",
"GOLDMEDAL ELECTRICALS PRIVATE LIMITED",
"GOLDMEDIA ENTERTAINMENT PRIVATE LIMITED",
"GOLDMINE ADVERTISING",
"GOLDMINE ADVERTISING PRIVATE LIMITED",
"GOLDMINE DEVELOPERS LIMITED",
"GOLDMINE JEWELLERS PRIVATE LIMITED",
"GOLDMINE LOGISTICS INDIA PRIVATE LIMITED",
"GOLDMINE MULTITRADE PRIVATE LIMITED",
"GOLDMINE PROJECT CONSULTANTS PRIVATE LIMITED",
"GOLDMINE STOCKS PRIVATE LIMITED",
"GOLDMINES TELEFILMS PRIVATE LIMITED",
"GOLDMOUNT ADVISORS",
"GOLDPLUS FOOTCARE PRIVATE LIMITED",
"GOLDPRINCE FASHION JEWELLERY PRIVATE LIMITED",
"GOLDPRISM REALTY PRIVATE LIMITED",
"GOLDQUEST GLOBAL HR SERVICES PRIVATE LIMITED",
"GOLDRATT CONSULTING INDIA PRIVATE LIMITED",
"GOLDRIPE INTERNATIONAL PRIVATE LIMITED",
"GOLDRUSH SALES AND SERVICES LIMITED",
"GOLD'S SHAPES AND CURVES PRIVATE LIMITED",
"GOLDSEAL-SAARGUMMI INDIA PRIVATE LIMITED",
"GOLDSHIELD REAL ESTATE PRIVATE LIMITED",
"GOLDSIKKA LIMITED",
"GOLDSMITH COMMERCIAL PRIVATE LIMITED",
"GOLDSPUN FABTEX PRIVATE LIMITED",
"GOLDSQUARE SALES INDIA PRIVATE LIMITED",
"GOLDSTAB ORGANICS PRIVATE LIMITED",
"GOLDSTAIN JEWELS PRIVATE LIMITED",
"GOLDSTAR CHEMICALS PRIVATE LIMITED",
"GOLDSTAR COTTEX LIMITED",
"GOLDSTAR DRY OFFSET PRIVATE LIMITED",
"GOLDSTAR FABRICS PRIVATE LIMITED",
"GOLDSTAR FASHIONS PRIVATE LIMITED",
"GOLDSTAR FOOTWEARS PRIVATE LIMITED",
"GOLDSTAR INTERNATIONAL PRIVATE LIMITED",
"GOLDSTAR KNITS PRIVATE LIMITED",
"GOLDSTAR METALS LIMITED.",
"GOLDSTAR NUTRITION PRIVATE LIMITED",
"GOLDSTAR TELE NETWORK PRIVATE LIMITED",
"GOLDSTONE ADVISORS PRIVATE LIMITED",
"GOLDSTONE CEMENTS LIMITED",
"GOLDSTONE HOTELS & RESORTS",
"GOLDSTONE INFRATECH LIMITED",
"GOLDSTONE TECHNOLOGIES LIMITED",
"GOLDSTONE TRADING COMPANY PRIVATE LIMITED",
"GOLDSUN GARMENTS PRIVATE LIMITED",
"GOLDTAP LUBRICANT SPECIALITIES PRIVATE LIMITED",
"GOLDTECH ALUMINIUM INDIA PRIVATE LIMITED",
"GOLDTECH GRAPHICS PRIVATE LIMITED",
"GOLDTECH SYSTEMS PRIVATE LIMITED",
"GOLDTHEME GEMS PRIVATE LIMITED",
"GOLDTREE BULLION INDIA PRIVATE LIMITED",
"GOLDVIEW VYAPAAR PRIVATE LIMITED",
"GOLDVIP TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"GOLDVITA FOODS PRIVATE LIMITED",
"GOLDWAVE COMMODITIES PRIVATE LIMITED",
"GOLDWAY FOODS PRIVATE LIMITED",
"GOLDWIN MEDICARE LIMITED",
"GOLDWOOD PLY INDUSTRY PRIVATE LIMITED",
"GOLDWYN LIMITED",
"GOLDY AUTO STAMPINGS (INDIA) PRIVATE LIMITED",
"GOLDY FINEPACKS PRIVATE LIMITED",
"GOLDY PRECISION STAMPINGS PRIVATE LIMITED",
"GOLDY PROJECTS PRIVATE LIMITED",
"GOLE ELECTRICAL TECHNOLOGIES PRIVATE LIMITED",
"GOLE PRECISION TOOLS PVT LTD",
"GOLECHA DISTRIBUTORS PRIVATE LIMITED",
"GOLECHA TRADERS PRIVATE LIMITED",
"GOLECHHA EQUIPMENT PRIVATE LIMITED",
"GOLECHHA GLOBAL FINANCE LIMITED",
"GOLECHHA HOUSING AND INFRASTRUCTURE PRIVATE LIMITED",
"GOLF CERAMICS PRIVATE LIMITED",
"GOLF CONSTRUCTION COMPANY INDIA PRIVATE LIMITED",
"GOLF FASHION KNITS PRIVATE LIMITED",
"GOLF LAND DEVELOPERS PRIVATE LIMITED",
"GOLF LINK PROJECTS PRIVATE LIMITED",
"GOLF VIEW CLUB AND RESORTS PRIVATE LIMITED",
"GOLF VIEW HOMES LIMITED",
"GOLFGREEN BUILDCON PRIVATE LIMITED",
"GOLFGREEN INFRA PRIVATE LIMITED",
"GOLFGREEN MANSIONS PRIVATE.LIMITED.",
"GOLFGREEN RESIDENCY PRIVATE LIMITED",
"GOLFGREEN SUPERSTRUCTURES PRIVATE LIMITED",
"GOLFLAN TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"GOLFLINKS SOFTWARE PARK PRIVATE LIMITED",
"GOLGIUSA RESEARCH LABORATORIES LLP",
"GOLI VADA PAV PRIVATE LIMITED",
"GOLIATH EXIM PRIVATE LIMITED",
"GOLKONDA HOTELS AND RESORTS LIMITED",
"GOLKONDA RESORTS PRIVATE LIMITED",
"GOLKUNDA DIAMONDS & JEWELLERY LIMITED",
"GOLLUM ENTERPRISES PRIVATE LIMITED",
"GOLMURI CLUB",
"GOLOKA DAIRY PRODUCTS PRIVATE LIMITED",
"GOLOKSOFT GLOBAL PRIVATE LIMITED",
"GOLTENS INDIA PRIVATE LIMITED",
"GOLTS SPECIALITIES PRIVATE LIMITED",
"GOLU AUTOMOBILES & CONSTRUCTION PRIVATE LIMITED",
"GOLYAN EXIM PRIVATE LIMITED",
"GOMA CLEANTECH PRIVATE LIMITED",
"GOMA ENGINEERING PRIVATE LIMITED",
"GOMA ENGINEERING PVT LTD",
"GOMA PROCESS TECHNOLOGIES PRIVATE LIMITED",
"GOMAATHI COTSPIN (COVAI) PRIVATE LIMITED",
"GOMANTAK PRIVATE LIMITED",
"GOMAS SYSTEMS AND CONTROLS PRIVATE LIMITED",
"GOMASSIVE INCUBATORS PRIVATE LIMITED",
"GOMATESH POLYTECHNIC",
"GOMATHI SPINNING MILLS INDIA PRIVATE LIMITED",
"GOMATI CHEMICALS PRIVATE LIMITED",
"GOMATI IMPEX PRIVATE LIMITED",
"GOMATI TIMBERS PRIVATE LIMITED",
"GOMEC INDUSTRIES PRIVATE LIMITED",
"GOMEDII TECHNOLOGIES PRIVATE LIMITED",
"GOMES FOREX SERVICES (INDIA) PRIVATE LIMITED",
"GOMILESTONE PRIVATE LIMITED",
"GOMINI CONSTRUCTIONS PRIVATE LIMITED",
"GOMMATESHWARA GRANITES PRIVATE LIMITED",
"GOMO DIGITAL BUSINESS SOLUTIONS PRIVATE LIMITED",
"GOMO MARKETING SERVICES INDIA PRIVATE LIMITED",
"GOMOBILE TELE SERVICES PRIVATE LIMITED",
"GOMOTO TEXTILES PRIVATE LIMITED",
"GOMOVERS INDIA PRIVATE LIMITED",
"GOMS ELECTRICALS PRIVATELIMITED",
"GOMS INTEGRATED FACILITY MANAGEMENT PRIVATE LIMITED",
"GOMSELMASH INDIA PRIVATE LIMITED",
"GOMTEE FASHIONS LLP",
"GOMTESH GINNING AND PRESSING PRIVATE. LIMITED.",
"GOMTESHWAR REAL ESTATE PRIVATE LIMITED",
"GOMTESHWARA DEVELOPERS PRIVATE LIMITED",
"GOMTI AUTO SALES & SERVICES PRIVATE LIMITED",
"GOMTI CAPITAL MARKETS INDIA LIMITED",
"GOMTI FOOD AND SPICES PRIVATE LIMITED",
"GOMTI HEALTHY NUTRIENTS PRIVATE LIMITED",
"GOMTI HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED",
"GOMTI INN PRIVATE LIMITED",
"GOMTI INSURANCE BROKING PRIVATE LIMITED",
"GOMTI MALTS PRIVATE LIMITED",
"GOMTI RESEARCH AND PHARMACHEM PRIVATE LIMITED",
"GOMTI TEXTILES PRIVATE LIMITED",
"GOMUKHESHWAR MADHYAMIK VIDHYALAYA",
"GOMUKHI INDUS CAPITAL ADVISORY PRIVATE LIMITED",
"GOMUKI SPINNING MILLS PRIVATE LIMITED",
"GOMUR FABRIC MILLS PVT LTD",
"GOMUR FABRICS PRIVATE LIMITED",
"GONAG SOLUTIONS PRIVATE LIMITED",
"GONARD INFRACON INDIA PRIVATE LIMITED",
"GONAUR CHOUDHARY FOODS PRIVATE LIMITED",
"GONDALS PRESS INDIA LIMITED",
"GONDOR ANALYTICS PRIVATE LIMITED",
"GONDWANA ENGINEERS LTD",
"GONDWANA ENTERPRISES PRIVATE LIMITED",
"GONDWANA GLOBAL MERCANTILE PRIVATE LIMITED",
"GONDWANA METALLURGICAL SERVICES PRIVATE LIMITED",
"GONESHBARI TEA CO PVT LTD",
"GONEX BUILDWELL PRIVATE LIMITED",
"GONG CHENG COMMUNICATIONS PRIVATE LIMITED",
"GONGLU AGRO PRIVATE LIMITED",
"GONITEO ENTERPRISE PRIVATE LIMITED",
"GONSAI LOGISTICS PRIVATE LIMITED",
"GONTERMANN PEIPERS INDIA LIMITED",
"GOOD AND KIND FOODS PRIVATE LIMITED",
"GOOD ANT RETAIL PRIVATE LIMITED",
"GOOD BAKERY PRIVATE LIMITED",
"GOOD BAKERY STORE AND CAFE PRIVATE LIMITED",
"GOOD BRANDS FOR A HEALTHY LIFE PRIVATE LIMITED",
"GOOD BUSINESS LAB FOUNDATION",
"GOOD DAY INFORMATION SYSTEMS PRIVATE LIMITED",
"GOOD DROP WINE CELLARS PRIVATE LIMITED",
"GOOD EARTH ECO DEVELOPMENTS PRIVATE LIMITED",
"GOOD EARTH ECO FUTURES PRIVATE LIMITED",
"GOOD EARTH INDIA INFRA PRIVATE LIMITED",
"GOOD EARTH PLOTTED DEVELOPMENT PRIVATE LIMITED",
"GOOD EARTH RENEWABLE SERVICES PRIVATE LIMITED",
"GOOD EARTH TRAVEL GROUP INDIA PRIVATE LIMITED",
"GOOD FAITH INSURANCE BROKER PRIVATE LIMITED (CN)",
"GOOD FETTLE PRIVATE LIMITED",
"GOOD FLIPPIN FOODS PRIVATE LIMITED",
"GOOD FOOD HOTELS PVT LTD",
"GOOD FOOD RETAIL PRIVATE LIMITED",
"GOOD GRAIN POULTRY FEED PRIVATE LIMITED",
"GOOD GREENS INDIA PRIVATE LIMITED",
"GOOD HAIR PROFESSIONAL LLP",
"GOOD HEALTH ESSENTIALS PRIVATE LIMITED",
"GOOD HEALTH HOSPITAL PVT LTD",
"GOOD HEALTH TPA SERVICES LIMITED",
"GOOD HOPE HEALTHCARE PRIVATE LIMITED",
"GOOD HOPES HOSPITALS PRIVATE LIMITED",
"GOOD HOST SPACES (JAGDISHPUR) PRIVATE LIMITED",
"GOOD HOST SPACES (SHOOLINI) PRIVATE LIMITED",
"GOOD HOST SPACES PRIVATE LIMITED",
"GOOD IMAGE PVT.LTD.",
"GOOD INSURANCE BROKERS PRIVATE LIMITED",
"GOOD INVESTMENTS(INDIA)LTD.",
"GOOD LEATHER SHOES PRIVATE LIMITED",
"GOOD LIVING PLAZA PRIVATE LIMITED",
"GOOD LUCK CAPITAL PRIVATE LIMITED",
"GOOD LUCK DESIGNERS AND INTERIORS PRIVATE LIMITED",
"GOOD LUCK ENGINEERING CO.",
"GOOD LUCK FINANCIAL INCLUSION PRIVATE LIMITED",
"GOOD LUCK HOSIERY MILLS PVT LTD",
"GOOD LUCK PUBLISHERS LIMITED",
"GOOD MARK AGENCIES PRIVATE LIMITED",
"GOOD MEDIA NEWS PRIVATE LIMITED",
"GOOD MEMORIES PRIVATE LIMITED",
"GOOD METHODS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"GOOD MORNING INDIA MEDIA PRIVATE LIMITED",
"GOOD NIGHT SERVICE PRIVATE LIMITED",
"GOOD NOSH RETAIL PRIVATE LIMITED",
"GOOD POWER INDUSTRIES PRIVATE LIMITED",
"GOOD RASAYAN PRIVATE LIMITED",
"GOOD RELATIONS CONSULTANTS PRIVATE LIMITED",
"GOOD RELATIONS INDIA PRIVATE LIMITED",
"GOOD RIM PRIVATE LIMITED",
"GOOD ROOTS KITCHENWARE PRIVATE LIMITED",
"GOOD SAMARITAN PRIMARY SCHOOL",
"GOOD SEARCH KNOWLEDGE NETWORK PRIVATE LIMITED",
"GOOD SHEPHERD EDUCATIONAL TRUST",
"GOOD SHEPHERD MATRICULATION HIGHER SECONDARY SCHOOL",
"GOOD SHEPHERED INTERNATIONL SCHOOL",
"GOOD SHOW EVENTS AND EXHIBITIONS PRIVATE LIMITED",
"GOOD TIMES CORPORATE AND SECURITY PRIVATE LIMITED",
"GOOD TO GO FOODWORKS PRIVATE LIMITED",
"GOOD VALUE FINANCIAL SERVICES PRIVATE LIMITED",
"GOOD WIN TRAVELS",
"GOOD WORD PUBLIC SCHOOL",
"GOODBUILD (INDIA) PRIVATE LIMITED",
"GOODBUY SOAPS AND COSMETICS PRIVATE LIMITED",
"GOODCARE INVESTMENT PRIVATE LIMITED",
"GOODCARE IT MANAGEMENT SERVICES PRIVATE LIMITED",
"GOODCARE PHARMA PVT LTD",
"GOODCORE SPINTEX PRIVATE LIMITED",
"GOODDOT ENTERPRISES PRIVATE LIMITED",
"GOODDOT FOODS PRIVATE LIMITED",
"GOODDOT SPICES PRIVATE LIMITED",
"GOODEARTH AGROCHEM PRIVATE LIMITED",
"GOODEARTH DESIGN STUDIO PRIVATE LIMITED",
"GOODEARTH MARITIME PRIVATE LIMITED",
"GOODEARTH MINCHEM PRIVATE LIMITED",
"GOODEDGE ADVISORY PRIVATE LIMITED",
"GOODFAITH DEALERS PRIVATE LIMITED",
"GOODFARMER FOODS LLP",
"GOODFARMS MILK PRIVATE LIMITED",
"GOODFIELD TECHNOLOGY PRIVATE LIMITED",
"GOODFLOW SECURITIES PRIVATE LIMITED",
"GOODHEALTH INDUSTRIES PRIVATE LIMITED",
"GOODHOME REALTY LIMITED",
"GOODHOPE CLEARING AND FORWARDING PVT.LTD.",
"GOODHOPE SOFTWARE PRIVATE LIMITED",
"GOODHUMS LIFESCIENCES PRIVATE LIMITED",
"GOODIE INTERNATIONAL PRIVATE LIMITED",
"GOODIX TECHNOLOGY (INDIA) PRIVATE LIMITED",
"GOODKARMA HOSPITALITY PRIVATE LIMITED",
"GOODLAND SURVEYS PRIVATE LIMITED",
"GOODLAYS CREATIONS PRIVATE LIMITED",
"GOODLIFE INFRASTRUCTURE PRIVATE LIMITED",
"GOODLIFE TECHNOLOGIES PRIVATE LIMITED",
"GOODLIVING CONSULTANTS PRIVATE LIMITED",
"GOODLIVING INDIA PRIVATE LIMITED",
"GOODLUCK ADVANCES AND FINLEASE LIMITED",
"GOODLUCK CAFE PRIVATE LIMITED",
"GOODLUCK FACILITIES PRIVATE LIMITED",
"GOODLUCK INDIA LIMITED",
"GOODLUCK INDUSTRIES LIMITED",
"GOODLUCK INFRADEVELOPERS PRIVATE LIMITED",
"GOODLUCK METALLICE",
"GOODLUCK OVERSEAS PRIVATE LIMITED",
"GOODLUCK PACKAGING PRIVATE LIMITED",
"GOODLUCK POLY FABRICS",
"GOODLUCK PUBLISHERS LIMITED",
"GOODLUCK STAINLESS PRIVATE LIMITED",
"GOODLUCK STEEL TUBES LIMITED",
"GOODLUCK TECHNO MECH PRIVATE LIMITED",
"GOODLUCK TRADERS PRIVATE LIMITED",
"GOODMAN GILMAN'S LIFE SCIENCES PRIVATE LIMITED",
"GOODMAN INVESTORS RELATION SERVICES PVT LTD",
"GOODMAN PHARMACEUTICALS",
"GOODMEN INDUSTRIES PRIVATE LIMITED",
"GOODNESS MEDIA PRIVATE LIMITED",
"GOODNEWS CHANNEL PRIVATE LIMITED",
"GOODNICK ELECTRONICS PRIVATE LIMITED",
"GOODONE SECURITY SERVICE PRIVATE LIMITED",
"GOODPOINT TEA PRIVATE LIMITED",
"GOODPOINT TEXFAB PRIVATE LIMITED",
"GOODRICH AEROSPACE SERVICES PRIVATE LIMITED",
"GOODRICH CARBOHYDRATES LIMITED",
"GOODRICH CONSULTANCY SERVICES PRIVATE LIMITED",
"GOODRICH FOODTECH LIMITED",
"GOODRICH GASKET PRIVATE LIMITED",
"GOODRICH GLOBAL FURNISHING INDIA PRIVATE LIMITED",
"GOODRICH INGREDIENTS & CHEMICALS LIMITED",
"GOODRICH LOGISTICS PRIVATE LIMITED",
"GOODRICH MARITIME PRIVATE LIMITED",
"GOODRICH NUTRISTERS PRIVATE LIMITED",
"GOODS AND SERVICES TAX NETWORK",
"GOODS CARRYING CARGO PRIVATE LIMITED",
"GOODS TRANSPORT LABOUR BOARD FOR GREATER BOMBAY",
"GOODSARVE TREXIM PVT LTD",
"GOODSKILL SECURITIES AND SERVICES LIMITED",
"GOODSTONE DEVELOPERS PRIVATE LIMITED",
"GOODSUN INDUSTRIES PRIVATE LIMITED",
"GOODTIME REAL ESTATE DEVELOPMENT PRIVATE LIMITED",
"GOODVALUE CHEMICALS PRIVATE LIMITED",
"GOODVALUE CHEMOX PRIVATE LIMITED",
"GOODVIEW FASHION PRIVATE LIMITED",
"GOODVITAMIN FOODS PRIVATE LIMITED",
"GOODWATTS SOLAR MODASA 2MW PRIVATE LIMITED",
"GOODWATTS SOLAR MODASA PRIVATE LIMITED",
"GOODWATTS WTE JAMNAGAR PRIVATE LIMITED",
"GOODWAY CHEMICALS PRIVATE LIMITED",
"GOODWEAR FASHIONS PRIVATE LIMITED",
"GOODWEAVE CERTIFICATION PRIVATE LIMITED",
"GOODWILL",
"GOODWILL ADVANCE CONSTRUCTION COMPANY PRIVATE LIMITED",
"GOODWILL ALLOYS PRIVATE LIMITED",
"GOODWILL APARTMENTS PRIVATE LIMITED",
"GOODWILL CABLES & PROJECTS PRIVATE LIMITED",
"GOODWILL CRESEC PRIVATE LIMITED",
"GOODWILL DESIGNCRAFT PRIVATE LIMITED",
"GOODWILL EMPIRE PRIVATE LIMITED",
"GOODWILL ENGINEERING SERVICES PRIVATE LIMITED",
"GOODWILL ENTERTAINMENTS PRIVATE LIMITED",
"GOODWILL EX SERVICEMEN S CO OPERATIVE COCIETY LTD",
"GOODWILL FABRICS PRIVATE LIMITED",
"GOODWILL FIBRES COMPANY PRIVATE LIMITED",
"GOODWILL HERITAGE BUSINESS PRIVATE LIMITED",
"GOODWILL HYBRID SEEDS NDIA PRIVATE LIMITED",
"GOODWILL HYDRAULICS PRIVATE LIMITED",
"GOODWILL IMPEX LIMITED",
"GOODWILL INNOVATION IN RETAIL PRIVATE LIMITED",
"GOODWILL MEDICAL CENTRE PRIVATE LIMITED",
"GOODWILL NON-WOVENS PRIVATE LIMITED",
"GOODWILL POWER GENERATORS PRIVATE LIMITED",
"GOODWILL POWERTECH EQUIPMENTS PRIVATE LIMITED",
"GOODWILL QUEST INDIA PRIVATE LIMITED",
"GOODWILL SOLUTIONS PRIVATE LIMITED",
"GOODWILL STRUCTURES PRIVATE LIMITED",
"GOOD-WILL TEA AND INDUSTRIES LTD",
"GOODWILL TRANSPORT PRIVATE LIMITED",
"GOODWILL VANIJYA PRIVATE LIMITED",
"GOODWILL WAREHOUSING PRIVATE LIMITED",
"GOODWILL WEALTH MANAGEMENT PRIVATE LIMITED",
"GOODWIN BUSINESS PRIVATE LIMITED",
"GOODWIN PUMPS INDIA PRIVATE LIMITED",
"GOODWIN REFRACTORY SERVICES INDIA PRIVATE LIMITED",
"GOODWIN WEALTH CONSULTANCY PRIVATE LIMITED",
"GOODWINGS MARITIME PRIVATE LIMITED",
"GOODWOOD MARINE SERVICES PRIVATE LIMITED",
"GOODWOOD SHIP MANAGEMENT PRIVATE LIMITED",
"GOODWORD MEDIA SERVICES PRIVATE LIMITED",
"GOODWORK DESIGNS PRIVATE LIMITED",
"GOODWORKLABS SERVICES PRIVATE LIMITED",
"GOODWORKS SPACES PRIVATE LIMITED",
"GOODWORTH ENTERPRISES PRIVATE LIMITED",
"GOODWORTH INFRACON PRIVATE LIMITED",
"GOODX INSURANCE BROKERS PRIVATE LIMITED",
"GOODYEAR INDIA LIMITED",
"GOODYEAR SOUTH ASIA TYRES PRIVATE LIMITED",
"GOOFFY KNITS PRIVATE LIMITED",
"GOOFY INFO SYSTEM PRIVATE LIMITED",
"GOOGLE CAPITAL ADVISORS INDIA PRIVATE LIMITED",
"GOOGLE CERAMICS PRIVATE LIMITED",
"GOOGLE CLOUD INDIA PRIVATE LIMITED",
"GOOGLE CONNECT SERVICES INDIA PRIVATE LIMITED",
"GOOGLE INDIA DIGITAL SERVICES PRIVATE LIMITED",
"GOOGLE INDIA PRIVATE LIMITED",
"GOOGLE IT SERVICES INDIA PRIVATE LIMITED",
"GOOGLE PAYMENT INDIA PRIVATE LIMITED",
"GOOGNU DATA SERVICES PRIVATE LIMITED",
"GOOJAR MAL GANPAT RAI PRIVATE LIMITED",
"GOOLEAN TECHNOLOGIES PRIVATE LIMITED",
"GOOLESTAN INVESTMENTS PRIVATE LIMITED",
"GOOMBIRA TEA COMPANY LIMITED",
"GOOMO HOLDING SERVICES PRIVATE LIMITED",
"GOORU INDIA FOUNDATION FOR LEARNING INNOVATION",
"GOOSE SHARES AND SECURITIES PRIVATE LIMITED",
"GOOSE SUPPORT SERVICES PRIVATE LIMITED",
"GOOSEBUMPS BRAND SOLUTIONS PRIVATE LIMITED",
"GOPA INVESTMENT CO PVT LTD",
"GOPAISA NETVENTURES PRIVATE LIMITED",
"GOPAL AUTO (INDIA) PRIVATE LIMITED",
"GOPAL AUTO MOTORS PRIVATE LIMITED",
"GOPAL BIRI FACTORY PRIVATE LIMITED",
"GOPAL BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"GOPAL CELLS PRIVATE LIMITED",
"GOPAL CHANDRA MEMORIAL COLLEGE OF EDUCAT",
"GOPAL CORPORATES LLP",
"GOPAL COTTON INDUSTRIES PVT LTD",
"GOPAL CREATION PRIVATE LIMITED",
"GOPAL DAS REALTY & INFRASTRUCTURE PRIVATE LIMITED",
"GOPAL DIAMONDS PRIVATE LIMITED",
"GOPAL EMPORIUM PRIVATE LIMITED",
"GOPAL FERROUS PRIVATE LIMITED",
"GOPAL FOREX PRIVATE LIMITED",
"GOPAL GEMS PRIVATE LIMITED",
"GOPAL GLASS WORKS LIMITED",
"GOPAL GLOBAL DEVELOPERS PRIVATE LIMITED",
"GOPAL GOBINDA AGRO PRODUCT PRIVATE LIMITED",
"GOPAL HOLIDAYS PRIVATE LIMITED",
"GOPAL IRON AND STEELS COMPANY GUJARAT LIMITED",
"GOPAL JI GARMENTS PRIVATE LIMITED",
"GOPAL KRISHAN FABRICS PRIVATE LIMITED",
"GOPAL KRISHNA AGRO PRODUCTS PRIVATE LIMITED",
"GOPAL KRISHNA PAPERS PRIVATE LIMITED",
"GOPAL KRISHNA RICE MILLS",
"GOPAL KRISHNA SYNTHETICS PRIVATE LIMITED",
"GOPAL KRISHNA TEA CO PVT LTD",
"GOPAL LIFE SCIENCE UNIT -II",
"GOPAL MAHESHWARI ASSOCIATES",
"GOPAL METAL CONTAINERS PRIVATE LIMITED",
"GOPAL MILK PRODUCTS PRIVATE LIMITED",
"GOPAL NURSING HOME SERVICES PRIVATE LIMITED",
"GOPAL OIL INDUSTRIES",
"GOPAL ORGCHEM PRIVATE LIMITED",
"GOPAL ORNAMENTS PRIVATE LIMITED",
"GOPAL PRINT & PROCESSORS PRIVATE LIMITED",
"GOPAL PRINT PACK SOLUTION",
"GOPAL PRINTERS PVT LTD",
"GOPAL PULSE PROCESSORS PRIVATE LIMITED",
"GOPAL RICE MILL PRIVATE LIMITED",
"GOPAL SAREE CREATIONS PRIVATE LIMITED",
"GOPAL SNACKS LIMITED",
"GOPAL SNACKS PRIVATE LIMITED",
"GOPAL SONS LINGERIE PRIVATE LIMITED",
"GOPAL SONS MARKETING PVT LTD",
"GOPAL SONS SELECTION",
"GOPAL SPICES",
"GOPAL SPICES PRIVATE LIMITED",
"GOPAL SPONGE AND POWER PRIVATE LIMITED",
"GOPAL SWEETS PRIVATE LIMITED",
"GOPAL UDHYOG",
"GOPAL VILLAS PRIVATE LIMITED",
"GOPAL YARNS PRIVATE LIMITED",
"GOPALA COLORS PRIVATE LIMITED",
"GOPALA FRESH PRODUCE PRIVATE LIMITED",
"GOPALA HOTELS PRIVATE LIMITED",
"GOPALA KRAFT PACK PRIVATE LIMITED",
"GOPALA MINES AND MINERALS PRIVATE LIMITED",
"GOPALA SALES PRIVATE LIMITED",
"GOPALA THERMOPACKS INDIA PRIVATE LIMITED",
"GOPALAKRISHNA TEXTILE MILLS PRIVATE LIMITED",
"GOPALAN AEROSPACE INDIA PRIVATE LIMITED",
"GOPALAN ENTERPRISES (INDIA) PRIVATE LIMITED",
"GOPALAN INTERNATIONAL SCHOOL",
"GOPALAN NATIONAL SCHOOL",
"GOPALAN TWINKLERS SCHOOL",
"GOPALDAS HIRANAND PRIVATE LIMITED",
"GOPALDAS JHAMATMAL ADVANI LAW COLLEGE",
"GOPALDAS VISRAM & COMPANY LIMITED.",
"GOPALDAS VISRAM AND COMPANY LIMITED",
"GOPALDHARA TEA CO PVT LTD",
"GOPALJEE COMMUNICATION PRIVATE LIMITED",
"GOPALJEE DAIRY FOODS PRIVATE. LIMITED.",
"GOPALJEE HEALTHY PRODUCTS PRIVATE LIMITED",
"GOPALJEE MOULDS PRIVATE LIMITED",
"GOPALPRIY MILK PRODUCTS PRIVATE LIMITED",
"GOPALPUR PORTS LIMITED",
"GOPANI FILTERS PRIVATE LIMITED",
"GOPANI INTERNATIONAL PRIVATE LIMITED",
"GOPANI IRON AND POWER INDIA PRIVATE LIMITED.",
"GOPANI METAL INDUSTRIES PRIVATE. LIMITED.",
"GOPANI PRODUCT SYSTEMS PRIVATE LIMITED",
"GOPANI SECURITIES AND INVESTMENTS PRIVATE LIMITED",
"GOPE TEA PLANTATION PVT LTD",
"GOPESH PROTIENS PRIVATE LIMITED",
"GOPESHWAR IRON & STEEL WORKS PRIVATE LIMITED",
"GOPESHWARI SYNTHETICS PRIVATE LIMITED",
"GOPHERS LAB TECHNOLOGIES PRIVATE LIMITED",
"GOPI ALLOYS PRIVATE LIMITED",
"GOPI CONSTECH PRIVATE LIMITED",
"GOPI DEHYDRATES PRIVATE LIMITED",
"GOPI FABRICS P LIMITED.",
"GOPI IRON & STEELS PVT LTD",
"GOPI KNITTING PRIVATE LIMITED",
"GOPI KRISHNA PROCESSORS PRIVATE LIMITED",
"GOPI RAM AGRO PRIVATE LIMITED",
"GOPI RAM INDUSTRIES PRIVATE LIMITED",
"GOPI SYNTHETICS PRIVATE LIMITED",
"GOPI TEXTILE PRIVATE LIMITED",
"GOPIBAN LOGISTICS PRIVATE LIMITED",
"GOPIKA ELECTRICALS PRIVATE LIMITED",
"GOPIKRISHNA MINERALS AND METALS PRIVATE LIMITED",
"GOPILAL MODI ESTATES PRIVATE LIMITED",
"GOPIMAL KAUR SAIN INDUSTRIES PRIVATE LIMITED",
"GOPINATH CHEM-TECH LIMITED",
"GOPINATH DHAM CONSTRUCTION & INFRASTRUCTURE PRIVATE LIMITED",
"GOPINATH ENTERPRISE PRIVATE LIMITED",
"GOPINATH GEMS",
"GOPINATH HOSPITAL",
"GOPINATH KNITFAB PRIVATE LIMITED",
"GOPINATH MINCHEM PRIVATE LIMITED",
"GOPINATH MOTOR PRIVATE LIMITED",
"GOPINATH SOLAR ENERGY PRIVATE LIMITED",
"GOPISETTI INTERNATIONAL SERVICES AND TRANNING PRIVATE LIMITED",
"GOPISON TECHNOLOGIES PRIVATE LIMITED",
"GOPISONS ATTIRES AND LIFESTYLES PRIVATE LIMITED",
"GOPOWER ELECTECH PRIVATE LIMITED",
"GOPRODUCTS ENGINEERING INDIA LIMITED LIABILITY PARTNERSHIP",
"GOPROTOZ DESIGN PRIVATE LIMITED",
"GOPSI PHARMA PRIVATE LIMITED",
"GOPSONS PAPERS PRIVATE LIMITED",
"GOPSONS PRINTERS PRIVATE LIMITED",
"GOPSUN DEALTRADE PRIVATE LIMITED",
"GOPSUN LEATHER & FOOTWEAR PRIVATE LIMITED",
"GOPU INFRASTRUCTURE",
"GOPURA COMMODITIES PVT.LTD.",
"GOPURAM AGRO INDUSTRIES PRIVATE LIMITED",
"GOQII TECHNOLOGIES PRIVATE LIMITED",
"GOQUEST MEDIA VENTURES PRIVATE LIMITED",
"GOQUO TECHNICAL SERVICES PRIVATE LIMITED",
"GORABDANGA HINDU COLLEGE",
"GORADIA INDUSTRIES PRIVATE LIMITED",
"GORADIA SPECIAL STEELS LIMITED",
"GORAJ AUTO MATION PRIVATE LIMITED",
"GORAKH NATH FORMULATIONS PRIVATE LIMITED",
"GORAKHANATH V CHODHI CHONDHI BU",
"GORAKHNATH AGRO INDUSTRIES PRIVATE LIMITED",
"GORAKHPUR CONSTRUCTION CO PRIVATE LIMITED",
"GORAKHPUR EXPRESSWAY LIMITED",
"GORAKHPUR INFRASTRUCTURE COMPANY PRIVATE LIMITED",
"GORAKHPUR KASIA TOLLWAYS PRIVATE LIMITED",
"GORAKHPUR MOTORS PRIVATE LIMITED",
"GORAKHPUR RESOURCES PRIVATE LIMITED",
"GORAN PHARMA PVT LTD",
"GORANI INDUSTRIES LIMITED",
"GORANTLA GEOSYNTHETICS PRIVATE LIMITED",
"GORANTLA SARATH CHANDRA",
"GORAS DAIRY PRODUCTS PRIVATE LIMITED",
"GORASIA EDUCATION SOCIETY",
"GORASIA INDUSTRIES PRIVATE LIMITED",
"GORAYA STRAW BOARD MILLS PRIVATE. LIMITED.",
"GORBANDH MARBLES PRIVATE LIMITED",
"GORDON WOODROFFE LOGISTICS LIMITED",
"GORE NATURALS & LIFESTYLE PRIVATE LIMITED",
"GORECHA METAL TECH PRIVATE LIMITED",
"GOREE POLYTECH PRIVATE LIMITED",
"GOREEN E-MOBILITY PRIVATE LIMITED",
"GORI ESTATES AND ADVISORS PRIVATE LIMITED",
"GORICH ENERGY PRIVATE LIMITED",
"GORJA INTERNATIONAL PRIVATE LIMITED",
"GORKAP PROPERTIES AND INVESTMENTS PRIVATE LIMITED",
"GORKHA AGRO - BIO FERTILIZER PRIVATE LIMITED",
"GORKHA SECURITAS",
"GORKHALAND TERRITORIAL ADMINISTRATION",
"GORLAN INDIA SWITCHGEARS PRIVATE LIMITED",
"GOROMPANI AGRO INDUSTRIES PRIVATE LIMITED",
"GORSAN IMPEX PRIVATE LIMITED",
"GORSIA PRIVATE LIMITED",
"GORUR INFRA PROJECTS PRIVATE LIMITED",
"GORURAL FOODS & BEVERAGES PRIVATE LIMITED",
"GORVIND DAIRY FARMS PRIVATE LIMITED",
"GOS ENTERTAINMENT PRIVATE LIMITED",
"GOS ISPAT PRIVATE LIMITED",
"GOSAR INDUSTRIES PRIVATE LIMITED",
"GOSEVIT SOFTWARE DEVELOPMENT PRIVATE LIMITED",
"GOSHAR INFRA PROJECTS PRIVATE LIMITED",
"GOSHI INDIA AUTO PARTS PRIVATE LIMITED",
"GOSHIES APARELS PRIVATE LIMITED",
"GOSIL EXPORTS PRIVATE LIMITED",
"GOSOFT ESOLUTIONS PRIVATE LIMITED",
"GOSOKA PHARMACEUTICALS PRIVATE LIMITED",
"GOSOLAR VENTURES PRIVATE LIMITED",
"GOSOURCEMED PRIVATE LIMITED",
"GOSPEL HOME SCHOOL",
"GOSPEL INFRACON PRIVATE LIMITED",
"GOSPELL DIGITAL TECHNOLOGY PRIVATE LIMITED",
"GOSRANI IMPEX PRIVATE LIMITED",
"GOSREE FINANCE LIMITED",
"GOSSNER EVANGELICAL LUTHERAN CHURCH CHOTANAGPUR AND ASSAM",
"GOSTHANI HI-TECH CARTONS PRIVATE LIMITED",
"GOSTO BEHARI DEY BHAGABATI CHARAN DEY & CO PRIVATE LIMITED",
"GOSTOL TST INDIA PRIVATE LIMITED",
"GOSUKI TECH PRIVATE LIMITED",
"GOSWAMI ENGINEERING PRIVATE LIMITED",
"GOSWAMI GANESH DUTTA SANATAN DHARMA COLLEGE",
"GOSWAMI INFRATECH PRIVATE LIMITED",
"GOSWAMI SECURITY SERVICES PRIVATE LIMITED",
"GOSWAMI STORES PRIVATE LIMITED",
"GOT PRINT PRIVATE LIMITED",
"GOTAN STONE LIME PRIVATE LIMITED",
"GOTECH SALES PRIVATE LIMITED",
"GOTER WEB SERVICES (OPC) PRIVATE LIMITED",
"GOTHAM CREATIVE SERVICES PRIVATE LIMITED",
"GOTHISONS ENTERPRISES PRIVATE LIMITED",
"GOTO TECHNOLOGIES INDIA PRIVATE LIMITED",
"GOTRANS LOGISTICS PRIVATE LIMITED",
"GOTTLOB SCHULER PROJECT AND SITE MANAGEMENT PRIVATE LIMITED",
"GOUGER FRANZMANN & REDMAN TAX SERVICES PRIVATE LIMITED",
"GOUPALAK MILK PRODUCER COMPANY LIMITED",
"GOUR BANGA COMMERCIALS PRIVATE LIMITED",
"GOUR FLOUR MILLS PRIVATE LIMITED",
"GOUR NITYE TEA & INDUSTRIES LTD",
"GOUR ROAD TAR COAT PRIVATE LIMITED",
"GOURAB UTSAV SEAFOODS PRIVATE LIMITED",
"GOURANG PAPER PRODUCTS PRIVATE LIMITED",
"GOURANGA RICE MILL PRIVATE LIMITED",
"GOURAV EDIBLE OIL PRIVATE LIMITED",
"GOURAV ENERGEN INDIA PRIVATE LIMITED",
"GOURAV FINANCE PRIVATE LIMITED",
"GOURAV INDUSTRIES BUILDING SYSTEMS PRIVATE LIMITED",
"GOURAV LUMINARIES PRIVATE LIMITED",
"GOURAV MACHINE TOOLS PRIVATE LIMITED",
"GOURAV POULTRIES INDIA PRIVATE LIMITED",
"GOURAV ROSHNI LIMITED",
"GOURAV SUITINGS PRIVATE LIMITED",
"GOURAV TRANSLOGISTIC PRIVATE LIMITED",
"GOURHARI MULTIPURPOSE COLD STORAGE PRIVATE LIMITED",
"GOURI HOSPITAL LIMITED",
"GOURI MAA WALLPAPER STUDIO PRIVATE LIMITED",
"GOURIK JEWELS PRIVATE LIMITED",
"GOURIKA INDIA LIMITED",
"GOURINANDAN PRINTS PRIVATE LIMITED",
"GOURISARIA SAREE KENDRA PRIVATE LIMITED",
"GOURISHANKAR DIAGNOSTICS & RESEARCH CENTRE PRIVATE LIMITED",
"GOURMET BROTHERS LLP",
"GOURMET GELATO COMPANY PRIVATE LIMITED",
"GOURMET INVESTMENTS PRIVATE LIMITED",
"GOURMET POPCORNICA LLP",
"GOURMET PRODUCT RETAIL PRIVATE LIMITED",
"GOURMET PURSUITS PRIVATE LIMITED",
"GOURMET RESTAURANT CONCEPTS PRIVATE LIMITED",
"GOUSIYA EGGS",
"GOUT AND ARIGATO PRIVATE LIMITED",
"GOUTAM IMPEX INDIA PRIVATE LIMITED",
"GOUTAM STORES PRIVATE LIMITED",
"GOUTAMI SEEDS PRIVATE LIMITED",
"GOUTHAM RESIDENCY PRIVATE LIMITED",
"GOUTHAMI EXPLOSIVES PRIVATE LIMITED",
"GOUTHAMI INFRASTRUCTURES PRIVATE LIMITED",
"GOVA REALTORS PRIVATE LIMITED",
"GOVAAN STEELS PRIVATE LIMITED",
"GOVAN'S QUALITY FOODS PRIVATE LIMITED",
"GOVARDHAN CARS PRIVATE LIMITED",
"GOVARDHAN CROP SCIENCE PRIVATE LIMITED",
"GOVARDHAN ISPAT INDIA PRIVATE. LIMITED.",
"GOVARDHAN OVERSEAS PRIVATE LIMITED",
"GOVARDHAN PLASTO PACK PRIVATE LIMITED",
"GOVARDHAN POLYPLAST PRIVATE LIMITED",
"GOVARDHAN SHELTERS PRIVATE LIMITED",
"GOVARDHAN SILK PRIVATE LIMITED",
"GOVARDHAN SINGH BHADORIYA VIDYALAY",
"GOVARDHAN TRADING COMPANY PVT LTD",
"GOVAXO PHARMA SALES PRIVATE LIMITED",
"GOVCHE INDIA P LIMITED",
"GOVE FINANCE LIMITED",
"GOVENDHAN METALS PRIVATE LIMITED",
"GOVERDHAN COLD AND ICE PRIVATE LIMITED",
"GOVERDHAN COTTEX",
"GOVERDHAN ENERGY AND PETROCHEMICALS PRIVATE LIMITED",
"GOVERDHAN INTER COLLEGE",
"GOVERDHAN LAL RASTOGI JEWELLERS PRIVATE LIMITED",
"GOVERDHAN MERCANTILE PRIVATE LIMITED",
"GOVERDHAN ORCHARDS PRIVATE LIMITED",
"GOVERDHAN POLYGRAN PRIVATE LIMITED",
"GOVERDHAN PROMOTERS PRIVATE LIMITED",
"GOVERDHAN RETAIL INDIA PRIVATE LIMITED",
"GOVERDHAN SHEETALAY PRIVATE LIMITED",
"GOVERDHAN TRANSFORMERS UDYOG PRIVATE LIMITED",
"GOVERDHAN TRANSPORT COMPANY PRIVATE LIMITED",
"GOVERDHAN VENTURES PRIVATE LIMITED",
"GOVERDHAN VERMA PUNJAB JEWELLERS PRIVATE. LIMITED.",
"GOVERDHANDHAM ESTATE PRIVATE LIMITED",
"GOVERMENT OF CHHATISGARH HEALTH & FAMILY WELFARE DEPARTMENT",
"GOVERMENT OF CHHATTISGARH BLOCK EDUCATION OFFICER DHAMTARI (C.G.)",
"GOVERMENT OF CHHATTISGARH MAN POWER PLANNING DEPARTMENTOFFICE OF THE PRINCIPAL GOVT. POLYTECHNIC KORBA CHHATTISGARH",
"GOVERMENT OF CHHATTISGARH OFFICE OF THE ASSISTANT DIRECTOR HORTICULTURE DISTRIC SOUTH BASTAR DANTEWADA CG",
"GOVERMENT OF CHHATTISGARH PROJECT IMPLEMENTION UNIT NO.-01 AMBIKAPUR SURGUJA(C.G.)",
"GOVERMENT OF CHHATTISGHAR HOURTICULTURE DEPARTMENT OFFICE OF THE ASSIT DIRECTOR HOURTICULTURE",
"GOVERMENT OF CHHATTISHGARH SCHOOL EDUCATION DEPORTMENT",
"GOVERMENT OF TAMILNADU",
"GOVERMENT PHOTO LITHO PRESS GUJARAT",
"GOVERNMENT ARTS COLLEGE BHESAN",
"GOVERNMENT AYURVEDIC MAHAVIDYALYA",
"GOVERNMENT BOYS SENIOR SECONDARY SCHOOL NO 2 SAMALKA",
"GOVERNMENT CENTRAL PRESS",
"GOVERNMENT CHHATTISGARH DEPARTMENT OF HOME V.I.P SECURITY",
"GOVERNMENT CHHATTISGARH HEALTH AND FAIMLY WELFARE DIPARTMENT",
"GOVERNMENT COIMBATORE MEDICAL COLLEGE HOSPITAL",
"GOVERNMENT COLLEGE OF ENGINEERING JALGAON",
"GOVERNMENT DEGREE COLLEGE",
"GOVERNMENT DISTRICT LIBRARY",
"GOVERNMENT DIVISIONAL LIBRARY",
"GOVERNMENT DOON MEDICAL COLLEGE",
"GOVERNMENT ENGINEERING COLLEGE KUTCH(BHUJ)",
"GOVERNMENT ENGINEERING COLLEGE NAGPUR",
"GOVERNMENT ENGINEERING COLLEGE VALSAD",
"GOVERNMENT GIRLS COLLEGE SEONI",
"GOVERNMENT GIRLS INTER COLLEGE",
"GOVERNMENT GIRLS POLYTECHNIC",
"GOVERNMENT HIGH SCHOOL",
"GOVERNMENT HIGHER SECONDARY SCHOOL",
"GOVERNMENT HIGHER SECONDARY SCHOOL JHURREMAL PARASIA",
"GOVERNMENT HOMEOPATHIC MEDICAL COLLEGE AND HOSPITAL",
"GOVERNMENT HOSPATIAL",
"GOVERNMENT HOSPITAL",
"GOVERNMENT HOSPITAL BARDOLI",
"GOVERNMENT HOSPITAL MANDVI DI-SURAT",
"GOVERNMENT INDUSTRIAL TRAINING INSTITUTE ALIGARH",
"GOVERNMENT INDUSTRIAL TRAINING INSTITUTE KOLHAPUR",
"GOVERNMENT INDUSTRIAL TRAINING INSTITUTE MUZAFFARNAGAR",
"GOVERNMENT INDUSTRIAL TRAINING INSTITUTE PANDHARPUR",
"GOVERNMENT INDUSTRIAL TRAINING INSTITUTE PANDU NAGAR KANPUR",
"GOVERNMENT INST OF HMCT",
"GOVERNMENT INTER COLLEGE GIC",
"GOVERNMENT ITI ANNANDPUR JARKHI FIROZABAD",
"GOVERNMENT MATERNTY AND HOSPITAL ULHASNAGAR",
"GOVERNMENT MEDICAL COLLEGE & HOSPITAL AURANGABAD",
"GOVERNMENT MEDICAL COLLEGE AND HOSPITAL",
"GOVERNMENT MEDICAL COLLEGE AND HOSPITAL MIRAJ",
"GOVERNMENT MEDICAL COLLEGE AND HOSPITAL NAGPUR",
"GOVERNMENT MEDICAL COLLEGE",
"GOVERNMENT MEDICAL COLLEGE SURAT",
"GOVERNMENT MILK SCHEME",
"GOVERNMENT MILK SCHEME PUNE",
"GOVERNMENT MODEL SENIOR SECONDARY SCHOOL",
"GOVERNMENT OF ANDHRA PRADESH",
"GOVERNMENT OF ARUNACHAL PRADESH",
"GOVERNMENT OF BIHAR",
"GOVERNMENT OF CHHATTISGARH ADDITIONAL DIRECTOR",
"GOVERNMENT OF CHHATTISGARH AGRICULTURE DEPARTMENT",
"GOVERNMENT OF CHHATTISGARH CHIEF ENGINEER",
"GOVERNMENT OF CHHATTISGARH COMISIONR T& C DEVELOPMENT PROJECT INTRIGRATED TRIBLE DEVELOPMENT PROJECT",
"GOVERNMENT OF CHHATTISGARH DEPARTMENT OF HOME",
"GOVERNMENT OF CHHATTISGARH DEPARTMENT OFFICE OF DEPUTY DIRECTOR VETERINARY SERVICE DISTT SURAJPUR",
"GOVERNMENT OF CHHATTISGARH DEPUTY DIRECTOR OF AGRICULTURE",
"GOVERNMENT OF CHHATTISGARH DISTRIC PLANNING AND STATISTICAL OFFICE",
"GOVERNMENT OF CHHATTISGARH DISTRICT ELECTION",
"GOVERNMENT OF CHHATTISGARH DIVISIONAL FOREST OFFICER KATGHORA DIVISION DIST KORBA",
"GOVERNMENT OF CHHATTISGARH E S I SERVICES LABOUR DEPARTMENT",
"GOVERNMENT OF CHHATTISGARH EDUACTION DEPARTMENT PRINCIPAL GOVT KANYA SHIKCHA PARISAR",
"GOVERNMENT OF CHHATTISGARH EDUCATION DEPARTMENT OFFICE OF PRINCIPAL GOVT BOYS H.S.S",
"GOVERNMENT OF CHHATTISGARH EDUCATION DEPARTMENT OFFICE OF THE PRINCIPAL CHHATTISGARH",
"GOVERNMENT OF CHHATTISGARH EXECUTIVE ENGINEER",
"GOVERNMENT OF CHHATTISGARH GENERAL ADMINISTRATION DEPARTMENT",
"GOVERNMENT OF CHHATTISGARH GOVT GIRLS HR SEC SCHOOL KATGHORA KORBA",
"GOVERNMENT OF CHHATTISGARH GOVT. BASIC TRAINING INSTITUTE",
"GOVERNMENT OF CHHATTISGARH LAW AND LEGAL AFFAIRS",
"GOVERNMENT OF CHHATTISGARH MANPOWER PLANNING DIRECTOR ATE OF EMPLOYMENT AND TRAINING",
"GOVERNMENT OF CHHATTISGARH MEDICAL EDUCATION DEPARTMENT",
"GOVERNMENT OF CHHATTISGARH MINISTRY OF HEALTH PUBLICHEALTH&FAMILEYWAIFEAR OFFICE OF BLOCK MEDICAL OFFICER SURAJPUR",
"GOVERNMENT OF CHHATTISGARH OFFICE OF CHIEF MEDICAL & HEALTH OFFICER",
"GOVERNMENT OF CHHATTISGARH OFFICE OF THE DISTRICT PUBLIC RELATION OFFICE",
"GOVERNMENT OF CHHATTISGARH OFFICE OF THE DY DIRECTOR VETY SERVICES AMBIKAPUR DISTT SURGUJA",
"GOVERNMENT OF CHHATTISGARH OFFICE OF THE TAHSILDAR",
"GOVERNMENT OF CHHATTISGARH OFFICE OF THE TAHSILDAR PONDIUPRORA DISTT",
"GOVERNMENT OF CHHATTISGARH PANCHAYAT RULAR DEVELOPMENT",
"GOVERNMENT OF CHHATTISGARH PASUPALAIN DEPARTMENT OFFICE OF DEPUTY DIRECTOR VETY SERVICE DISTT KORBA",
"GOVERNMENT OF CHHATTISGARH PASUPALANLN DEPARTMENT OFFICE OF DEPUTY DIRECTOR VETY SERVICE DISTT KORBA CG",
"GOVERNMENT OF CHHATTISGARH PH & FW DEPARTMENT OFFICE OF C.M.O BALRAMPUR DIST",
"GOVERNMENT OF CHHATTISGARH PROFESSOR J.N PANDEY GOVT MULTIPULIPURPOSE",
"GOVERNMENT OF CHHATTISGARH PROJECT IMPIEMENTION UNIT NO 0 1 AMBIKAPUR",
"GOVERNMENT OF CHHATTISGARH PUBLIC HEALTH & FAMILY WELFARE & MEDICAL EDUCATION DISTRICT AYURVED OFFICER",
"GOVERNMENT OF CHHATTISGARH PUBLIC OF WORK DEPARTMENT OFFICE",
"GOVERNMENT OF CHHATTISGARH PWD DEPARTMENT OFFICE OF THE EXECUTIVE ENGINEER CHAMPA DN. CHAMPA JANJGIR",
"GOVERNMENT OF CHHATTISGARH REVENUE DEPARTMENT",
"GOVERNMENT OF CHHATTISGARH SUB DIVISIONAL AGRICULTURE OFFICE KATGHORA DIST KORBA",
"GOVERNMENT OF CHHATTISGARH TRIBAL DEPARTMENT",
"GOVERNMENT OF CHHATTISGARH WATER RESOURCES DEPARTMENT",
"GOVERNMENT OF CHHATTISGARH WOMEN AND CHILD DEVELOPMENT DEPARTMENT",
"GOVERNMENT OF CHHATTISGHAR LAND RECORD COLLECTORATE KORBA",
"GOVERNMENT OF CHHATTISGHAR PUBLIC HEALTH ENGINEERING DEPARTMENGT OFFICE OF THE EXECUTIVE ENGINEER KORBA CG",
"GOVERNMENT OF CHHATTISHGARH MINISTERY OF HEALTH PUBLICHEALTH&FAMILEYWAIFEAR OFFICE OF BLOCK MEDICAL OFFICER SURAJPUR",
"GOVERNMENT OF GOA",
"GOVERNMENT OF GOA ELECTRICITY DEPT",
"GOVERNMENT OF GUJARAT",
"GOVERNMENT OF GUJARAT DIRECTOR OF PRINTING AND STATIONARY",
"GOVERNMENT OF GUJARAT GENERAL ADMINISTRATION DEPARTMENT",
"GOVERNMENT OF GUJARAT TALUKA PANCHAYAT DEHGAM",
"GOVERNMENT OF GUJARATA FINANCE DEPARTMENT",
"GOVERNMENT OF HARYANA",
"GOVERNMENT OF HIMACHAL PRADESH",
"GOVERNMENT OF INDIA ARCHAEOLOGICAL SURVEY OF INDIA",
"GOVERNMENT OF INDIA CENTRAL PWD",
"GOVERNMENT OF INDIA DEPARTMENT OF ATOMIC ENERGY",
"GOVERNMENT OF INDIA DIRECTORATE OF PURCHASE AND STORES",
"GOVERNMENT OF INDIA MINISTERY OF ELECTRONICS ADN INFORMATION TECHNOLOGY",
"GOVERNMENT OF INDIA MINISTERY OF FINANCE",
"GOVERNMENT OF INDIA MINISTRY OF DEFENCE",
"GOVERNMENT OF INDIA PRASAR BHARATI",
"GOVERNMENT OF KARNATAKA",
"GOVERNMENT OF KERALA",
"GOVERNMENT OF KERALA HEALTH SERVICES",
"GOVERNMENT OF KERALA INDIAN SYSTEMS OF MEDICINE",
"GOVERNMENT OF KERALA INDUSTRIAL TRAINING",
"GOVERNMENT OF MADHYAPRADESH",
"GOVERNMENT OF MAHARASHTRA",
"GOVERNMENT OF PUNDUCHERRY",
"GOVERNMENT OF TAMIL NADU",
"GOVERNMENT OF TAMIL NADU INSTITUTE OF PRINTING TECHNOLOGY",
"GOVERNMENT OF TELANGANA",
"GOVERNMENT OF UTTARAKHAND",
"GOVERNMENT OF WEST BANGAL BDO OFFICE",
"GOVERNMENT OF WEST BENGAL",
"GOVERNMENT OF WEST BENGAL BELUR ESI TB HOSPITAL",
"GOVERNMENT OF WEST BENGAL CALCUTTA NATIONAL MEDICAL COLLEGE & HOSPITAL",
"GOVERNMENT OF WEST BENGAL CHAMPDANY MUNICIPALITY",
"GOVERNMENT OF WEST BENGAL DIRECTORATE OF TECHNICAL EDUCATION",
"GOVERNMENT OF WEST BENGAL DISTRICT JUDGES COURT",
"GOVERNMENT OF WEST BENGAL FINANCE DEPARTMENT ACCOUNTS BRANCH",
"GOVERNMENT OF WEST BENGAL HOME & HILL AFFAIRS DEPARTMENT",
"GOVERNMENT OF WEST BENGAL ID AND BG HOPSITAL BELIGHATA",
"GOVERNMENT OF WEST BENGAL MEDICAL COLLEGE & HOSPITAL KOLKATA",
"GOVERNMENT OF WEST BENGAL OFFICE OF THE BMOH AHAMEDPUR BPHC BALAGARH HOOGHLY",
"GOVERNMENT OF WEST BENGAL OFFICE OF THE PCCF,WILDLIFE & CWLW, WEST BENGAL",
"GOVERNMENT OF WEST BENGAL OFFICE OF THE SUB INSPECTOR OF SCHOOLS",
"GOVERNMENT PERIPHERAL HOSPITAL",
"GOVERNMENT PLEADER HIGH COURT",
"GOVERNMENT POLYTECHNIC",
"GOVERNMENT POLYTECHNIC BAREILLY",
"GOVERNMENT POLYTECHNIC NAGPUR",
"GOVERNMENT POLYTECHNIC RATNAGIRI",
"GOVERNMENT POLYTECHNIC VADNAGAR",
"GOVERNMENT PRESS",
"GOVERNMENT PRESS AND BOOK DEPOT",
"GOVERNMENT PRIMARY ASHRAM SCHOOL PILANJE TALUKA BHIWANDI",
"GOVERNMENT PRIMARY SCHOOL",
"GOVERNMENT SCHOOL",
"GOVERNMENT SCHOOL HAJIPUR",
"GOVERNMENT SCIENCE COLLEGE GANDHINAGAR",
"GOVERNMENT SECONDARY ASHRAMSCHOOL RUPAPETH",
"GOVERNMENT SENIOR SECONDARY SCHOOL",
"GOVERNMENT TECHNICAL HIGH SCHOOL",
"GOVERNMENT TECHNICAL INSTITUTE",
"GOVERNMENT VIDARBHA INSTITUTE OF SCIENCE AND HUMANITIES",
"GOVERNMENT VIDYANIKETAN AMRAVATI",
"GOVERNOR'S SECRETARIAT",
"GOVIANU WEALTH MANAGEMENT PRIVATE LIMITED",
"GOVIK INDUSTRIES PRIVATE LIMITED",
"GOVIL MARBLES PRIVATE LIMITED",
"GOVIND AGRITECH PRIVATE LIMITED",
"GOVIND AGRO FOODS",
"GOVIND AGROFIN PRIVATE LIMITED",
"GOVIND ALLUMINIUM PRIVATE LIMITED",
"GOVIND BALLABH PANT HOSPITAL",
"GOVIND BALLABH PANT UNIVERSITY OF AGRICULTURE & TECHNOLOGY",
"GOVIND CABLE INDUSTRIES",
"GOVIND COMMERCIAL CO LTD",
"GOVIND ENCLAVE PRIVATE LTD",
"GOVIND EXTRUSION PRIVATE LIMITED",
"GOVIND FOODS INDIA PRIVATE LIMITED",
"GOVIND FORGINGS PVT LTD",
"GOVIND GANGA AGRO PROJECTS PRIVATE LIMITED",
"GOVIND GREENHOUSE PRIVATE LIMITED",
"GOVIND INFRAPLANNER PRIVATE LIMITED",
"GOVIND JEE DAIRYMILK PRIVATE LIMITED",
"GOVIND KNOWLEDGE VENTURES PRIVATE LIMITED",
"GOVIND KOLTE FOODS PRIVATE LIMITED",
"GOVIND KRIPA INFRATECH PRIVATE LIMITED",
"GOVIND MILK AND MILK PRODUCTS PRIVATE LIMITED",
"GOVIND OIL CARRIER PRIVATE LIMITED",
"GOVIND PARIKH SECURITIES PRIVATE LIMITED",
"GOVIND POLYMERS PRIVATE LIMITED",
"GOVIND POY OXYGEN LIMITED",
"GOVIND PULSES PRIVATE LIMITED",
"GOVIND RAJ PROJECTS PRIVATE LIMITED",
"GOVIND RICE MILL AND COLD STORAGE PRIVATE LIMITED",
"GOVIND RUBBER LIMITED",
"GOVIND SANGITAA CONSTRUCTION PRIVATE LIMITED",
"GOVIND STEEL CO LIMITED",
"GOVIND VALLABH FINANCIAL SERVICES PRIVATE LIMITED",
"GOVINDA DASA COLLEGE",
"GOVINDA EDUCATIONAL SERVICES",
"GOVINDA ENTERPRISES PRIVATE LIMITED",
"GOVINDA POLYTEX INDIA PRIVATE LIMITED",
"GOVINDA SHARES & SECURITIES PRIVATE LIMITED",
"GOVINDADAS COLLEGE",
"GOVINDAH NUTRITION PRIVATE LIMITED",
"GOVINDAM BRJ INFRA PROJECTS PRIVATE LIMITED",
"GOVINDAM CHEMICALS PRIVATE LIMITED",
"GOVINDAM CLEARING AGENCIES PRIVATE LIMITED",
"GOVINDAM ENVIRO ENGINEERING PRIVATE LIMITED",
"GOVINDAM FOOD PRODUCTS PRIVATE LIMITED",
"GOVINDAM GLASS SALES PRIVATE LIMITED",
"GOVINDAM GRANY AND MARBO PRIVATE LIMITED",
"GOVINDAM PROJECTS PRIVATE LIMITED",
"GOVINDAM TEXFAB PRIVATE LIMITED",
"GOVINDARAJA MUDALIAR SONS PRIVATE LIMITED",
"GOVINDDAS SARAF JEWELLERS PRIVATE LIMITED",
"GOVINDEVJI VENTURES PRIVATE LIMITED",
"GOVINDLAL ALOKKUMAR TRADING PRIVATE LIMITED",
"GOVINDRAJ AGRO PRIVATE LIMITED",
"GOVINDRAJ PAPER MILLS PRIVATE LIMITED",
"GOVINDRAM BROTHERS PRIVATE LIMITED",
"GOVINDRAO UMAP JR COLLEGE",
"GOVINDSHREE SECURITIES FISCAL LIMITED",
"GOVINDSONS FLASHLIGHT INDUSTRIES PRIVATE LIMITED",
"GOVISORY SERVICES PRIVATE LIMITED",
"GOVT ARTS COLLEGE- TRICHY-620022",
"GOVT ARTS COMMERCE COLLEGE INDORE",
"GOVT ASST ENGI AGRICULTURE OFFICE",
"GOVT ASTT COMM TRIBAL OFFICE",
"GOVT AUTONOMOUS AYURVED COLLEGE AND HOSPITAL GWALIOR",
"GOVT AYUSH DEPARTMENT MP",
"GOVT B E O OFFICE",
"GOVT BLIND BOYS INTER COLLEGE MEERUT",
"GOVT BOYS SENIOR SECONDARY SCHOOL BADARPUR TAJPUR PAHARI",
"GOVT BOYS SENIOR SECONDARY SCHOOL SHIV VIHAR",
"GOVT BOYS SR SEC SCHOOL",
"GOVT BULDELKHAND HOSPITAL SAGAR",
"GOVT C E O JANPAD PANCHAYAT CHHATARPUR",
"GOVT C E O JANPAD PANCHAYAT OFFICE",
"GOVT CANCER HOSPITAL INDORE",
"GOVT CIVIL SURGEON AND MAIN HOSPITAL SUPDT OFFICE",
"GOVT CM AND HO CHHATARPUR OFFICE",
"GOVT CO ED SR SEC SCHOOL",
"GOVT COLLECTOR CHHATARPUR OFFICE",
"GOVT COLLEGE OF EDUCATION AURANGABAD",
"GOVT D A AND S J SAGAR",
"GOVT D D V S CHHATARPUR",
"D F O CHHATARPUR",
"GOVT D F O CHHATARPUR OFFICE",
"GOVT D F O NORTH",
"GOVT DEPARTMENT DIST ATYASAYI DEVLOPE SEMITI MARYADIT CHHATARPUR",
"GOVT DEPARTMENT OF POSTS",
"GOVT DIST EMPLOYMENT OFFICER OFFICE",
"GOVT DIST S AND SESSION JUDGE CHHATARPUR MADHYA PRADESH",
"GOVT DISTRICT FOREST OFFICER CHHATARPUR OFFICE",
"GOVT DY DIRECTOR NATIONAL PARK OFFICE",
"GOVT DY DIRECTOR PANCHAYAT AND SOCIAL WELFARE CHHATARPUR OFFICE",
"GOVT E E PWD B AND R",
"GOVT E E PWD NO 1",
"GOVT ENGINEERING KIDANGOOR",
"GOVT GIRLS DEGREE COLLEGE KOTA",
"GOVT GIRLS H S S ARANG DISTT RAIPUR C G",
"GOVT GIRLS H S S UNHEL NAGDA",
"GOVT GIRLS SR SEC SCHOOL",
"GOVT GIRTS INTER COTTEGE KAJROTH IGLAS",
"GOVT GRAMYA BHARTI COLLEGE HARDIBAZAR KORBA",
"GOVT H S S BELGAON",
"GOVT H S SCHOOL KHARSODKALA BADNAGAR",
"GOVT HIGH SCHOOL KARAGHOGHA",
"GOVT HIGHER SECONDARY SCHOOL LAL BAHADUR SHASTRI SCHOOL BILASPUR",
"GOVT HIGHER SECONDRY SCHOOL",
"GOVT HOSPITAL FOR CHEST CD",
"GOVT HOSPITAL FOR MENTAL CARE",
"GOVT HOSPITAL SINGARVA",
"GOVT HSS GIRLS PIPLODA DISTRICT RATLAM",
"GOVT INDUSTRIAL TRAINING INSTITUTE",
"GOVT INDUSTRIAL TRAINING INSTITUTE ANDIPATTY THENI",
"GOVT INSTITUTE OF TEXTILE TECH",
"GOVT INTER COLLEGE AGRAS",
"GOVT INTER COLLEGE RAKSHA",
"GOVT JAI PRAKASH HOSPITAL",
"GOVT JANPAD PANCHYAT OFFICE",
"GOVT LADY NOYCE SR. SEC SCHOOL",
"GOVT MADHAV ARTS AND COMMERCE COLLEGE UJJAIN",
"GOVT MATERNITY HOSPITAL,NELLORE",
"GOVT MATIMANDA BOYS SANMAT KENDRA",
"GOVT MEDICAL COLLEGE AND S G G S M HOSPITAL NANDED",
"GOVT MEDICAL COLLEGE HOSPITAL GMC",
"GOVT MEMBER SECRETARY OFFICE",
"GOVT MIDDLE SCHOOL",
"GOVT MRTB HOSPITAL INDORE",
"GOVT NAGAR PARISHAD OFFICE",
"GOVT OF ANDHRA PRADESH",
"GOVT OF ASSAM OFFICE OF THE TRADE ADVISER AND DIRECTOR OF MOVEMENTS",
"GOVT OF CHHATTISGARH AGRECULURE DEPARTMENT OFFICE OF THE SUB DIVISIONAL OFFICER KHAIRAGARH",
"GOVT OF CHHATTISGARH AGRICULTURE DEPARTMENT OF THE SUB JANJGIR CHAMPA",
"GOVT OF CHHATTISGARH BLOCK EDUCATION OFFICE",
"GOVT OF CHHATTISGARH BLOCK MEDICAL OFFICEER",
"GOVT OF CHHATTISGARH DEPARTMENT OF FINANCE",
"GOVT OF CHHATTISGARH DEPARTMENT OF HEALTH",
"GOVT OF CHHATTISGARH DIRECTORATE CHHATTISGARH STATE AUDIT",
"GOVT OF CHHATTISGARH EDUCATION DEPARTMENT",
"GOVT OF CHHATTISGARH EDUCATION DEPARTMENT BLOCK EDUCATION OFFICER DABHARA",
"GOVT OF CHHATTISGARH EDUCATION DEPARTMENT COMMANDING OFFICER 1 CG BN NCC RAJGAMARG KOSABADI KORBA",
"GOVT OF CHHATTISGARH FINANCE DEPARTMENT OFFICE OF THE DISTRICT TREASURY",
"GOVT OF CHHATTISGARH GENERAL ADMINISTRATION DEPARTMENT",
"GOVT OF CHHATTISGARH HEALTH AND FAMILY WALFARE DEPARTMENT",
"GOVT OF CHHATTISGARH MANPOWER PLANNING",
"GOVT OF CHHATTISGARH OFFICE OF THE ASSISTANCE COMMISSINER TRIBLE¬† DEVELOPMENT KORBA",
"GOVT OF CHHATTISGARH OFFICE OF THE BLOCK EDUCATION OFFICER SARANGARH",
"GOVT OF CHHATTISGARH OFFICE OF THE DISTRICT & SESTION JUDGE KORBA DISTRICT KORBA",
"GOVT OF CHHATTISGARH OFFICE OF THE SUB DIVISIONAL OFFICER SITAPUR SURGUJA (C.G.)",
"GOVT OF CHHATTISGARH PUBLIC HEALTH AND FAMILY WELFARE DEPARTMENT",
"GOVT OF CHHATTISGARH PUBLIC RELATION DEPARTMENT",
"GOVT OF CHHATTISGARH SCHOOL EDUCATION",
"GOVT OF CHHATTISGARH SCHOOL EDUCATION DEPARTMENT OFFICE OF THE PRINCIPAL GOVT HIGHER SEC SCHOOL TILKEJA DISTT KORBA",
"GOVT OF CHHATTISGARH SCHOOL EDUCATION DEPORTMENT PRINCIPAL GOVT HR SEC SCHOOL JAIJAIPUR DIST JANJGIR CHAMPA [C G ]",
"GOVT OF CHHATTISGARH SCHOOL EDUCATION PRINCIPAL GOVT HR SEC SCHOOL DHURKOT",
"GOVT OF CHHATTISGARH SUPERINTENDENT",
"GOVT OF CHHATTISGARH TRIBLE WELFARE DEPARTMENT PRINCIPAL OF GOVT.HR.SEC.SCHOOL DEONAGAR DISTT-SURAJPUR (C.G.)",
"GOVT OF CHHATTISGARH VETY DEPARTMENT",
"GOVT OF CHHATTISGARH WOMEN & CHILD DEVELOPMENT DEPARTMENT OFFICE OF PROJECT OFFICER I C D S",
"GOVT OF CHHATTISGHAR FOREST DEPARTMENT OFFICE OF DIVISIONAL FOREST OFFICER DIVISION",
"GOVT OF CHHATTISHGARH GRAMODYOG DEPARTMENT",
"GOVT OF CHHATTSIGARH OFFICE OF THE BLOCK EDUCATION OFFICER",
"GOVT OF HARAYANA EXCISES AND TAXATION",
"GOVT OF HARYANA AYUSH DEPARTMENT",
"GOVT OF INDIA PRESS",
"GOVT OF INDIA T W DEPARTMENT OFFICE OF THE PRINCIPAL GOVT HR SEC SCHOOL BHAISMA DISTT KORBA",
"GOVT OF JHARKHAND",
"GOVT OF JHARKHAND ASSEMBLY DORANDA",
"GOVT OF JHARKHAND IRRIGATION",
"GOVT OF MADHYA PRADESH",
"GOVT OF MP LAB AND LEGISLATIVE AFFAIRS DEPARTMENT",
"GOVT OF NCT , DELHI",
"GOVT OF NCT OF DELHI",
"GOVT OF ODISHA HOME DEPARTMENT",
"GOVT OF PUNJAB",
"GOVT OF TAMIL NADU MEDICAL SERVICES DEPT",
"GOVT OF TAMILNADU TRANSPORT DEPT",
"GOVT OF WB DEPARTMENT OF HEALTH & FAMILY WELFARE DISTRICT FAMILY WELFARE BUREAU STORE",
"GOVT OF WB SERAMPORE MUNICIPALITY",
"GOVT OF WEST BENGA OFFICE OF THE SUB INSPECTOR OF SCHOOLS",
"GOVT POLYTECHNC",
"GOVT POLYTECHNIC AWASARI KHURD",
"GOVT POLYTECHNIC COLLEGE",
"GOVT POLYTECHNIC NAGPUR",
"GOVT POST BASIC ASHRAM SCHOOL LOBHANI",
"GOVT POST BASIS ASHRAM SCHOOL JAMBHAI",
"GOVT PRIMARY HEALTH CENTER",
"GOVT PRIMARY SCHOOL",
"GOVT PRIMARY SCHOOL AARI",
"GOVT PRIN GOVT DIVISIONAL ITI SAGAR",
"GOVT PRIN POLETECHNIC NOWGONG",
"GOVT S T BOYS HOSTEL",
"GOVT SARVODAYA BAL VIDYALAYA A-BLOCK JAHANGIRPURI DELHI",
"GOVT SARVODAYA CO ED VIDHALAYA",
"GOVT SCHLS & HIGH SCHLS ,COLGS",
"GOVT SDO (M E S) NOWGONG CHHATARPUR OFFICE",
"GOVT SEC AND HIGHER SEC SCHOOL JORAPURA TA DEESA DI B K",
"GOVT SECONDARY AND HIGHER SECONDARY ASHRAM SCHOOL KAWDAS",
"GOVT SENIOR SECONDARY SCHOOL BHADIYANA SAIPAU DHAULPUR",
"GOVT SENIOR SECONDARY SCHOOL DHANG KOTDA UDAIPUR",
"GOVT SIDDHA MEDICAL COLLEGE",
"GOVT SR SEC SCHOOL",
"GOVT SR SECONDARY SCHL, KHUKRAIN",
"GOVT ST BOYS HOSTEL NIZAMPUR",
"GOVT T B HOSPITAL NOWGAON CHHATARPUR",
"GOVT TAHSIL OFFICE",
"GOVT TAHSILDAR TEHSIL OFFICE",
"GOVT TAMILNADU INST OF MENTAL HLT",
"GOVT TEHSILDAR OFFICE",
"GOVT TOOL ROOM & TRAINING CENTRE",
"GOVT UNANI DISPENSARY",
"GOVT WCR OFFICE",
"GOVT WOMEN'S COLLEGE PURI",
"GOVT¬†DISTRICT COMDT H G SAGAR",
"GOVT. BOYS SENIOR SECONDARY SCHOOL GOKALPUR",
"GOVT. COLLECTOR OFFICE",
"GOWARDHAN BIOCHEM PRIVATE LIMITED",
"GOWARSONS PUBLISHERS PRIVATE LIMITED",
"GOWATR PRIVATE LIMITED",
"GOWDURBAR NATURAL PRODUCTS PRIVATE LIMITED",
"GOWEBEZ",
"GOWELNEXT SOLUTIONS PRIVATE LIMITED",
"GOWIF TECHNOLOGIES PRIVATE LIMITED",
"GOWISH EXPORT PRIVATE LIMITED",
"GOWRA AEROSPACE TECHNOLOGIES PRIVATE LIMITED",
"GOWRA BITS & BYTES PRIVATE LIMITED",
"GOWRA ENGINEERING TECHNOLOGIES PRIVATE LIMITED",
"GOWRA LEASING AND FINANCE LIMITED",
"GOWRA METALS & POLYMERS PRIVATE LIMITED",
"GOWRA PALLADIUM PRIVATE LIMITED",
"GOWRA PETROCHEM PRIVATE LIMITED",
"GOWRA VENTURES PRIVATE LIMITED",
"GOWRI GOPAL HOSPITALS PRIVATE LIMITED",
"GOWRI INFRAENGINEERS PRIVATE LIMITED",
"GOWRI TEXTILES INDIA PRIVATE LIMITED",
"GOWRIE HEALTHCARE PRIVATE LIMITED",
"GOWRIE RESEARCH PRIVATE LIMITED",
"GOWRINATH CHITS PRIVATE LIMITED",
"GOWTAMI CONSTRUCTIONS PRIVATE LIMITED",
"GOWTHAM CEMENTS PRIVATE LIMITED",
"GOWTHAMI BIO-ENERGIES PRIVATE LIMITED",
"GOWTHAMI HYDRO ELECTRIC COMPANY PRIVATE LIMITED",
"GOWTHAMI SOLVENT OILS PRIVATE LIMITED",
"GOWTHAMI SPINTEX (INDIA) PRIVATE LIMITED",
"GOWTHAMI SPINTEX INDIA LIMITED",
"GOYA AGRO INDUSTRIES PRIVATE LIMITED",
"GOYAL ACHAL SAMPATTI VIKAS AND NIYOJAN NIGAM LIMITED",
"GOYAL AGRITRADE PRIVATE LIMITED",
"GOYAL AGROCHEM INDUSTRIES PRIVATE LIMITED",
"GOYAL ALLOYS P LTD",
"GOYAL ALUMINIUMS LIMITED",
"GOYAL AND CO CONSTRUCTIONS PRIVATE LIMITED",
"GOYAL ASSOCIATES LIMITED",
"GOYAL AUTO PRODUCTS PRIVATE LIMITED",
"GOYAL AUTOCORP PRIVATE LIMITED",
"GOYAL AUTOHOUSE (INDIA) PRIVATE LIMITED",
"GOYAL AUTOMOTIVE PRIVATE LIMITED",
"GOYAL BATH PALACE PRIVATE LIMITED",
"GOYAL BROTHERS PRAKASHAN",
"GOYAL CAPITAL SERVICES (INDIA) PRIVATE LIMITED",
"GOYAL CARS AJMER PRIVATE LIMITED",
"GOYAL CHEMI TRADE PRIVATE LIMITED",
"GOYAL CREATIONS PRIVATE. LIMITED.",
"GOYAL DAL MILLS PRIVATE LIMITED",
"GOYAL DAL PRODUCTS PRIVATE LIMITED",
"GOYAL DEVELOPERS",
"GOYAL DHATU UDYOG PRIVATE LIMITED",
"GOYAL EDIBLE PRODUCT PRIVATE LIMITED",
"GOYAL EDIBLES PRIVATE LIMITED",
"GOYAL ENDOSCOPY SURGERY AND RESEARCH CENTER PRIVATE LIMITED",
"GOYAL ENERGY AND STEEL PRIVATE LIMITED",
"GOYAL ENGINEERING POLYMERS PRIVATE LIMITED",
"GOYAL EXPRESS",
"GOYAL FASHIONS PVT.LTD.TRANSFERRED FROM MAHARASHTRA",
"GOYAL FINCAP PRIVATE LIMITED",
"GOYAL FINE JEWELS PRIVATE LIMITED",
"GOYAL FUELS PRIVATE LIMITED",
"GOYAL FURNACE PRIVATE LIMITED",
"GOYAL GLASSWARE PRIVATE LIMITED",
"GOYAL GLOBAL METALMART PRIVATE LIMITED",
"GOYAL GLOBAL PULSES PRIVATE LIMITED",
"GOYAL GUMS PRIVATE LIMITED",
"GOYAL HANDLOOM PRIVATE LIMITED",
"GOYAL HOSPITAL AND RESEARCH CENTRE PVT LTD",
"GOYAL IMPEX AND INDUSTIRES LTD",
"GOYAL INDUSTRIES",
"GOYAL INFOTRONICS INDIA PRIVATE LIMITED",
"GOYAL INSTITUTE OF MEDICAL SCIENCES PRIVATE LIMITED",
"GOYAL IRON & STEEL (NAGPUR) PRIVATE LIMITED",
"GOYAL ISPAT PRIVATE LIMITED",
"GOYAL IT CONSULTANCY PRIVATE LIMITED",
"GOYAL KITCHEN & GRILL PRIVATE LIMITED",
"GOYAL KNITFAB PRIVATE. LIMITED.",
"GOYAL MALLEABLES PRIVATE LIMITED",
"GOYAL MARBLES PRIVATE LIMITED",
"GOYAL MARMO IMPEX PRIVATE LIMITED",
"GOYAL MEHAR CHAND GLOBAL INDUSTRIES LIMITED",
"GOYAL MERCHANTS PRIVATE LIMITED",
"GOYAL METALLICS PRIVATE LIMITED",
"GOYAL MG GASES PRIVATE. LIMITED",
"GOYAL MINERAL PRIVATE LIMITED",
"GOYAL MOTOCORP PRIVATE LIMITED",
"GOYAL MOTORS PRIVATE. LIMITED.",
"GOYAL OFFSET WORKS PRIVATE LIMITED",
"GOYAL ORNAMENTS PRIVATE LIMITED",
"GOYAL PETROFILS YARNS PRIVATE LIMITED",
"GOYAL PLY-N-WOOD PRIVATE LIMITED",
"GOYAL POLY UDYOG PVT LTD",
"GOYAL PROTEINS LIMITED",
"GOYAL PUBLISHERS AND DISTRIBUTORS PRIVATE LIMITED",
"GOYAL PULVERISER & CHEMICALS PRIVATE LIMITED",
"GOYAL REALTY VENTURES PRIVATE LIMITED",
"GOYAL RECREATIONAL CENTER LIMITED",
"GOYAL RICE MILLS",
"GOYAL SALES PRIVATE LIMITED",
"GOYAL SALT LIMITED",
"GOYAL SANITARY AND PAINTS PRIVATE LIMITED",
"GOYAL SEEDS PRIVATE LIMITED",
"GOYAL SOFTWARE",
"GOYAL SONS JEWELS PRIVATE LIMITED",
"GOYAL SONS ZAVERI PRIVATE LIMITED",
"GOYAL SPACEBUILD INDIA PRIVATE LIMITED",
"GOYAL TEA AGENCIES PRIVATE LIMITED",
"GOYAL TECHNOCHEM PRIVATE LIMITED",
"GOYAL TEXFAB PRIVATE LIMITED",
"GOYAL TOBACCO COMPANY PRIVATE LIMITED",
"GOYAL TRADERS (INDIA) PRIVATE LIMITED",
"GOYAL TRAVELS & IMMIGRATION PRIVATE LIMITED",
"GOYAL UDYOG INDIA PRIVATE LIMITED",
"GOYAL VEGOILS LIMITED",
"GOYAL WEAVING MILLS PRIVATE LIMITED",
"GOYAL YARN AGENCY",
"GOYALA INFRA PROJECTS PRIVATE LIMITED",
"GOYALKA BROTHERS PVT LTD",
"GOYAL'S CENTRAL GOODS TRANSPORT PVT LTD",
"GOYAM FOREX PRIVATE LIMITED",
"GOYAM KNITWEARS PRIVATE LIMITED",
"GOYOLENE FIBRES (INDIA) PRIVATE LIMITED (TRF)",
"GOYUM TECHNICAL HOLDINGS PRIVATE LIMITED",
"GOZARIA ORGANIZERS PRIVATE LIMITED",
"GOZING TECHNOLOGY PRIVATE LIMITED",
"GOZO TECHNOLOGIES PRIVATE LIMITED",
"GOZOOP ONLINE PRIVATE LIMITED",
"GOZOOP RED INTERNET SERVICES PRIVATE LIMITED",
"GP AGRO FOOD PRODUCTS PRIVATE LIMITED",
"GP CROP CARE PRIVATE LIMITED",
"GP ECO SOLUTIONS INDIA LIMITED",
"GP HOMES PRIVATE LIMITED",
"GP INFOTECH PRIVATE LIMITED",
"GP LOIDA PHARMACEUTICAL PRIVATE LIMITED",
"GP MARKETING PRIVATE LIMITED",
"GP PARSIK SAHAKARI BANK LTD",
"GP PETROLEUMS LIMITED",
"GP SOURCING PRIVATE LIMITED",
"GP SPIRA DUCT PRIVATE LIMITED",
"GP STALLION INDUSTRIES PRIVATE LIMITED",
"GP STRATEGIES INDIA PRIVATE LIMITED",
"GP SUPER MARKETS PRIVATE LIMITED",
"GP TAX SOLUTIONS PRIVATE LIMITED",
"GP TECHNOLOGIES PRIVATE LIMITED",
"GP TELECOM PRIVATE LIMITED",
"GP WIND (JANGI) PRIVATE LIMITED",
"GPA CAPITAL FOODS PRIVATE LIMITED",
"GPA FOODS PRIVATE LIMITED",
"GPA FOREX PRIVATE LIMITED",
"GPA MEDIWORLD PRIVATE LIMITED",
"GPANCHAMUKHI INFRASTRUCTURE PRIVATE LIMITED",
"GPC FOODS PRIVATE LIMITED",
"GPC INFRASTRUCTURE LIMITED",
"GPC REGULATORY INDIA PRIVATE LIMITED",
"GPF SECURITY PRIVATE LIMITED",
"GPI PROJECTS PRIVATE LIMITED",
"GPI TEXTILES",
"GPJC SOLUTIONS PRIVATE LIMITED",
"GPK SUPERBAZAAR PRIVATE LIMITED",
"GPL EXPORTS LIMITED",
"GPL TECHNICAL SOLUTIONS PRIVATE LIMITED",
"GPLD INFRA PROJECTS PRIVATE LIMITED",
"GPOHEALTH INDIA PRIVATE LIMITED",
"G-POWER ENERGY & TECHNOLOGY PRIVATE LIMITED",
"GPOWER ENGINEERING AND SERVICES PRIVATE LIMITED",
"GPOWER GLOBAL STAFFING SERVICES PRIVATE LIMITED",
"GPR ELECTRICAL AND AUTOMATION PRIVATE LIMITED",
"GPR INDUSTRIES PRIVATE LIMITED",
"GPR INFRA PROJECTS PRIVATE LIMITED",
"GPR IT SOLUTIONS PRIVATE LIMITED",
"GPR RESOURCE PRIVATE LIMITED",
"GPR TEXTILES PRIVATE LIMITED",
"GPRACTA TECHNOLOGY SERVICES PRIVATE LIMITED",
"GPRO SERVICES INDIA PRIVATE LIMITED",
"GPS AUTOMOBILES PRIVATE LIMITED",
"GPS INDIA NETWORKS PRIVATE LIMITED",
"GPS INDIA TECHVENTURES PRIVATE LIMITED",
"GPS INTEGRATED FMS PRIVATE LIMITED",
"GPS OFFICE EQUIPMENT PRIVATE LIMITED",
"GPS PRIME PROJECTS PRIVATE LIMITED",
"GPS REAL JEWELLERS PRIVATE LIMITED",
"GPS RENEWABLES PRIVATE LIMITED",
"GPS TECHNOLOGIES PRIVATE LIMITED",
"GPSAR HEALTHCARE LIMITED",
"GPSK CAPITAL PRIVATE LIMITED",
"GPT CASTINGS LIMITED",
"GPT ESTATE PRIVATE LIMITED",
"GPT HEALTHCARE LIMITED",
"GPT INFRAPROJECTS LIMITED",
"GPT SONS PRIVATE LIMITED",
"GPX INDIA PRIVATE LIMITED",
"GPX INDIA SERVICES PRIVATE LIMITED",
"GPZ ENGINEERS PRIVATE LIMITED",
"GR AKKALKOT SOLAPUR HIGHWAY PRIVATE LIMITED",
"GR ALIGARH KANPUR HIGHWAY PRIVATE LIMITED",
"GR BAHADURGANJ ARARIA HIGHWAY PRIVATE LIMITED",
"GR BILASPUR URGA HIGHWAY PRIVATE LIMITED",
"GR DWARKA DEVARIYA HIGHWAY PRIVATE LIMITED",
"GR ENA KIM EXPRESSWAY PRIVATE LIMITED",
"GR ENGINEERING PRIVATE LIMITED",
"GR GALGALIA BAHADURGANJ HIGHWAY PRIVATE LIMITED",
"GR GATEWAY LABELS PRIVATE LIMITED",
"GR GUNDUGOLANU DEVARAPALLI HIGHWAY PRIVATE LIMITED",
"GR GUPTA BROTHERS PVT LTD",
"GR INFRASTRUCTURE PRIVATE LIMITED",
"GR INTRACHEM LIMITED",
"GR LABORATORIES PRIVATE LIMITED",
"GR LIVING SPACES PRIVATE LIMITED",
"GR LOGISTICS (INDIA)PRIVATE LIMITED",
"GR PHAGWARA EXPRESSWAY LIMITED",
"GR POLYGLOV PRIVATE LIMITED",
"GR POWER SWITCHGEAR LIMITED",
"GR SANGLI SOLAPUR HIGHWAY PRIVATE LIMITED",
"GR SHIRSAD MASVAN EXPRESSWAY PRIVATE LIMITED",
"GR SPICES AND FOOD PRODUCTS PRIVATE LIMITED",
"GR TECH SERVICES PRIVATE LIMITED",
"GR TRANSPORT SOLUTION PRIVATE LIMITED",
"GR TUTORS SERVICES PRIVATE LIMITED",
"GR8 CAR BAAZAR AUTOMOTIVES PRIVATE LIMITED",
"GR8 ENTERTAINMENT LIMITED",
"GRA ESTATES LLP",
"GRA INNS PRIVATE LIMITED",
"GRAAND PRIX ELEVATORS INDIA PRIVATE LIMITED",
"GRAAND PRIX ENTERPRISES PRIVATE LIMITED",
"GRAASS MHE PRIVATE LIMITED",
"GRAAVITY MULTISPECIALITY HOSPITAL PRIVATE LIMITED",
"GRAB A GRUB SERVICES LIMITED",
"GRAB GRECO LLP",
"GRAB IN SPORTS PRIVATE LIMITED",
"GRABEN TECHNOLOGIES LIMITED",
"GRABHOME CONSULTING PRIVATE LIMITED",
"GRABIO INDUSTRIES PRIVATE LIMITED",
"GRABONRENT INTERNET PRIVATE LIMITED",
"GRACE",
"GRACE ACADEMY",
"GRACE BEAUTY CLINIC PRIVATE LIMITED",
"GRACE BIO-CARE PRIVATE LIMITED",
"GRACE CASTINGS LTD",
"GRACE CEMENTS PRIVATE LIMITED",
"GRACE COLONIZERS PRIVATE LIMITED",
"GRACE COMMUNICATIONS PRIVATE LIMITED",
"GRACE DAVISON CHEMICALS INDIA PRIVATE LIMITED",
"GRACE DRINKS PRIVATE LIMITED",
"GRACE ELECTRICAL & CONTRACTORS PRIVATE LIMITED",
"GRACE FURNISHINGS PRIVATE LIMITED",
"GRACE GLOBAL LOGISTICS PRIVATE LIMITED",
"GRACE GREEN INFRA PRIVATE LIMITED",
"GRACE GROUPS",
"GRACE HOME STYLE TRADE PRIVATE LIMITED",
"GRACE HOTELS AND BANQUETS PRIVATE LIMITED",
"GRACE IN ART WORKS PRIVATE LIMITED",
"GRACE INFOTECH PRIVATE LIMITED",
"GRACE INFRASTRUCTURE PRIVATE LIMITED",
"GRACE JEWELS PRIVATE LIMITED",
"GRACE LIFESTYLE PRIVATE LIMITED",
"GRACE LIGHT CONSTRUCTIONS PRIVATE LIMITED",
"GRACE LOCKS LIMITED",
"GRACE MARBLES AND GRANITES PRIVATE LIMITED",
"GRACE MEDICAL SERVICES PRIVATE LIMITED",
"GRACE MEDTRADE PRIVATE LIMITED",
"GRACE MONARK PROPERTIES PRIVATE LIMITED",
"GRACE NUTRIENTS (INDIA) PRIVATE LIMITED",
"GRACE ORGANICS PRIVATE LIMITED",
"GRACE PACKAGE",
"GRACE POWER PRIVATE LIMITED",
"GRACE REFINERY PRIVATE LIMITED",
"GRACE RELOCATIONS PRIVATE LIMITED",
"GRACE RENEWABLE ENERGY PRIVATE LIMITED",
"GRACE RETAIL PRIVATE LIMITED",
"GRACE SALES PRIVATE LIMITED",
"GRACE SUPPLIERS PRIVATE LIMITED",
"GRACE SYSTEM TECHNOLOGY LABS INDIA PRIVATE LIMITED",
"GRACE TRAVELS INDIA PRIVATE LIMITED",
"GRACE WORLDWIDE MOVERS PRIVATE LIMITED",
"GRACEDERMA HEALTHCARE PRIVATE LIMITED",
"GRACEFUL MEDIA (INDIA) PRIVATE LIMITED",
"GRACELAND HABITATS SERENE PRIVATE LIMITED",
"GRACES RESORT",
"GRACEUNITED DEVELOPERS PRIVATE LIMITED",
"GRACEWORKS REALTY & LEISURE PRIVATE. LIMITED.",
"GRACIA CHEMICALS PRIVATE LIMITED",
"GRACIA COLORS PRIVATE LIMITED",
"GRACIA METALS PRIVATE LIMITED",
"GRACIOUS COFFEE PRIVATE LIMITED",
"GRACIOUS FABRICATIONS PRIVATE LIMITED",
"GRACIOUS LEGAL SERVICES LLP",
"GRACIOUS PHARMACEUTICALS PRIVATE LIMITED",
"GRACIOUS VENEERS PRIVATE LIMITED",
"GRACO HONG KONG LIMITED",
"GRACO INDIA PRIVATE LIMITED",
"GRACO JUTE PRIVATE LIMITED",
"GRACURE PHARMACEUTICALS LIMITED",
"GRADATIM IT VENTURES INDIA PRIVATE LIMITED",
"GRAD-DREAMS EDUCATION CONSULTING PRIVATE LIMITED",
"GRADE ELECTRICALS PRIVATE LIMITED",
"GRADE ONE EVENTS PRIVATE LIMITED",
"GRADIANT INDIA RIVATE LIMITED",
"GRADIANT KURNOOL ETP PRIVATE LIMITED",
"GRADICO SIKH TEACHING PRODUCTION PRIVATE LIMITED",
"GRADIENT CHEMICALS COMPANY PRIVATE LIMITED",
"GRADIENT COMMERCIAL PRIVATE LIMITED",
"GRADIENT ENGINEERS PRIVATE LIMITED",
"GRADIENT WIRE PRODUCTS PRIVATE LIMITED",
"GRADIENTM IT CONSULTING AND SERVICES PRIVATE LIMITED",
"GRADMENER TECHNOLOGY PRIVATE LIMITED",
"GRADS INTERNATIONAL SCHOOL",
"GRADUATE AGRO & MECHANICAL ENGINEERS",
"GRADUATE MANAGEMENT ADMISSION COUNCIL (INDIA) PRIVATE LIMITED",
"GRADUATE MANAGEMENT GLOBAL CONNECTION (INDIA) PRIVATE LIMITED",
"GRADUATE SCHOOLOF BUSINESS ADMINISTRATIO",
"GRADWELL OILFIELD PRIVATE LIMITED",
"GRAEBEL RELOCATION INDIA CENTRE PRIVATE LIMITED",
"GRAEBERT INDIA SOFTWARE PRIVATE LIMITED",
"GRAEPEL PERFORATIONS INDIA PRIVATE LIMITED",
"GRAF DIGITAL TECHNOLOGIES PRIVATE LIMITED",
"GRAF PUBLISHING PRIVATE LIMITED",
"GRAFAX GARMENTS PRIVATE LIMITED",
"GRAFAX KNITWEARS LIMITED",
"GRAFAX TEXTILES PRIVATE LIMITED",
"GRAFFIAS POLYMERS PRIVATE LIMITED",
"GRAFFIC INFRASTRUCTURE PRIVATE LIMITED",
"GRAFFITI EXPORTS",
"GRAFFITI LAMINATES PRIVATE LIMITED",
"GRAFFITI SIGNGRAPHICS PVT LTD",
"GRAFICA FLEXTRONICA PRIVATE LIMITED",
"GRAFIQE PRINTERS PRIVATE LIMITED",
"GRAFITE CERAMICS PRIVATE LIMITED",
"GRAFITECH ABRASIVES PRIVATE LIMITED",
"GRAFITEL ORGANICS INDIA PRIVATE LIMITED",
"GRAFIX ENGINEERING CONSULTANTS PRIVATE LIMITED",
"GRAFLEX CASTINGS PRIVATE LIMITED",
"GRAH AVAS VIKAS PRIVATE LIMITED",
"GRAH BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"GRAH SAJJA BUILDING CONCEPTS PRIVATE LIMITED",
"GRAHAM INDIA PRIVATE LIMITED",
"GRAHAM INFORMATION SYSTEMS PRIVATE LIMITED",
"GRAHAMS PHARMACEUTICALS PRIVATE LIMITED",
"GRAHASTHI AGRO FOODS PRIVATE LIMITED",
"GRAHATI SOLAR ENERGY PRIVATE LIMITED",
"GRAIL CONSULTING AND PROJECT MANAGEMENT SERVICES PRIVATE LIMITED",
"GRAIN & PULSES ENGINEERS PRIVATE LIMITED",
"GRAIN CONSERVATION AND WAREHOUSING INDUSTRIES PVT LTD",
"GRAIN EMPIRE PRIVATE LIMITED",
"GRAIN FLOUR INDIA PRIVATE LIMITED",
"GRAIN IMPEX PRIVATE LIMITED",
"GRAIN MART FOODS PRIVATE LIMITED",
"GRAIN MILLING COMPANY PRIVATE LIMITED",
"GRAIN 'N' GRACE FOOD INGREDIENTS PRIVATE LIMITED",
"GRAIN PROCESSING INDUSTRIES (INDIA) PVT LTD",
"GRAIN RICE AND OIL SEEDS MERCHANTS ASSOCIATION",
"GRAINCORP INDIA PRIVATE LIMITED",
"GRAINDESK COMMODITIES INDIA PRIVATE LIMITED",
"GRAINGER INDIA PRIVATE LIMITED.",
"GRAINLANE RETAIL PRIVATE LIMITED",
"GRAINO MART INDIA PRIVATE LIMITED",
"GRAINORA INDIA PRIVATE LIMITED",
"GRAINOTCH INDUSTRIES LIMITED",
"GRAINPRO INDIA POSTHARVEST TECHNOLOGY PRIVATE LIMITED",
"GRAINSPAN NUTRIENTS PRIVATE LIMITED",
"GRAINTEC INDIA LIMITED",
"GRAINTECH FOODS INDIA PRIVATE LIMITED",
"GRAINTEX INTERNATIONAL (INDIA) PRIVATE LIMITED",
"GRAM BHARTI SHIKSHA SAMITI MALWA",
"GRAM ENVOSOLUTION PRIVATE LIMITED",
"GRAM MOOLIGAI CO LIMITED",
"GRAM OORJA SOLUTIONS PRIVATE LIMITED",
"GRAM PANCHAYAT KARYALAY KAREGAON",
"GRAM PANCHAYAT KORBA",
"GRAM PANCHAYAT NAVIPARDI",
"POLARIS SMART METERING PRIVATE LIMITED",
"GRAM SACHIVALAYAM",
"GRAM SAMAJ U M V UTVARA ALIGARH",
"GRAM SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED",
"GRAM TARANG EMPLOYABILITY TRAINING SERVICES PRIVATE LIMITED",
"GRAM UNNATI FOUNDATION",
"GRAM VIKAS SHIKSHAN MANDALS PRAGATI VIDYALAY VADGAONPIR",
"GRAM VIKAS VID METPANJARA",
"GRAM VIKAS VIDYALAY RIDHORA",
"GRAMA SACHIVALAYAM POLURU",
"GRAMA VIDIYAL ENTERPRISES PRIVATE LIMITED",
"GRAMALAYA ENTREPRENEURS ASSOCIATES TIRUCHIRAPPALLI PRIVATE LIMITED",
"GRAMALAYA URBAN & RURAL DEVELOPMENT INITIATIVES AND NETWORK",
"GRAMCO INFRATECH PRIVATE LIMITED",
"GRAMCOVER INSURANCE BROKERS PRIVATE LIMITED",
"GRAMCOVER TECHNOLOGIES PRIVATE LIMITED",
"GRAMEEN DEVELOPMENT & FINANCE PRIVATE LIMITED",
"GRAMEEN FOUNDATION INDIA PRIVATE LIMITED",
"GRAMEEN IMPACT INVESTMENTS INDIA PRIVATE LIMITED",
"GRAMEEN IMPACT VENTURES PRIVATE LIMITED",
"GRAMEEN PASHUPALAN NIGAM LIMITED",
"GRAMEEN SHAKTI MICROFINANCE SERVICES PRIVATE LIMITED",
"GRAMEENA VIKAS KENDRAM SOCIETY FOR RURUAL DEVELOPMENT",
"GRAMENER IT SERVICES PRIVATE LIMITED",
"GRAMENER TECHNOLOGUY SOLUTIONS PRIVATE LIMITED",
"GRAMERCY SOFT TECHNOLOGIES PRIVATE LIMITED",
"GRAMI AGRO PVT. LTD.",
"GRAMIN ARYAVART BANK",
"GRAMIN TECHNICAL MANAGEMENT CAMPUS",
"GRAMIN VIKAS SEWA SANSTHAN",
"GRAMIN VIKAS VIDYALAYA JUNIOR & JUNIOR COLLEGE SALWA",
"GRAMMY COMMUNICATIONS PRIVATE LIMITED",
"GRAMODAYA SEVA SANSTHAN HIGHER SECONDARY SCHOOL",
"GRAMONNATI MANDAL'S GURUVARYA R P SABNIS VIDYAMANDIR NARAYANGAON --SHAINA",
"GRAMOS CHEMICALS INDIA PRIVATE LIMITED",
"GRAMOX PAPER AND BOARDS PRIVATE LIMITED",
"GRAMPRO BUSINESS SERVICES PRIVATE LIMITED",
"GRAMPRO DISTRIBUTION SERVICES PRIVATE LIMITED",
"GRAMPS AUTOTEC PRIVATE LIMITED",
"GRAMPUS IMPEX PRIVATE LIMITED",
"GRAMPUS SHIPPING & LOGISTICS PRIVATE LIMITED",
"GRAMS AND KILOZ PRIVATE LIMITED",
"GRAMS ELECTRICAL PRIVATE LIMITED",
"GRAMS INFRATECH INDIA PRIVATE. LIMITED.",
"GRAMSERV PRIVATE LIMITED",
"GRAMSEVAK PRASHIKHAN KENDRA",
"GRAMSHREE AGRI SERVICES PRIVATE LIMITED",
"GRAMSS RETAIL TRADING PRIVATE LIMITED",
"GRAMYA AGRITECH PRIVATE LIMITED",
"GRAN INTERNATIONAL PRIVATE LIMITED",
"GRANADA AIR SERVICES PRIVATE LIMITED",
"GRANADA INVESTMENTS & FINANCE PRIVATE LIMITED",
"GRANADA SERVICES PRIVATE LIMITED",
"GRANARY WHOLESALE PRIVATE LIMITED",
"GRANCHIO SECURITY SERVICES PRIVATE LIMITED",
"GRAND AFFAIRS HOSPITALITY PRIVATE LIMITED",
"GRAND ARK LOGISTICS PRIVATE LIMITED",
"GRAND AUTO UDYOG PRIVATE LIMITED",
"GRAND BAKERS PRIVATE LIMITED",
"GRAND BANQUET HALL PRIVATE LIMITED",
"GRAND BRAND SOLUTIONS PRIVATE LIMITED",
"GRAND BUILDTECH LIMITED",
"GRAND BUSINESS VENTURES INDIA PRIVATE LIMITED",
"GRAND CANYON SEZ PRIVATE LIMITED",
"GRAND CHANAKYA HOSPITALITY PRIVATE LIMITED",
"GRAND CITY HOSPITALITY PRIVATE LIMITED",
"GRAND CONSTRUCTION CO",
"GRAND CONTINENT HOTELS PRIVATE LIMITED",
"GRAND CONTINENTAL HOTEL",
"GRAND CUISINES BANQUETS PRIVATE LIMITED",
"GRAND DE HIMALAYA HOTELS AND RESORTS PRIVATE LIMITED",
"GRAND FILAMENTS PRIVATE LIMITED",
"GRAND GUMBER ENTERTAINMENT AND EVENTS (INDIA) PRIVATE LIMITED",
"GRAND HIMALAYA CLUB LIMITED",
"GRAND HIRA RESORTS PRIVATE LIMITED",
"GRAND HOLIDAY PARK VACATION PRIVATE LIMITED",
"GRAND HOTEL (BOMBAY) PVT LTD",
"GRAND HOUSING PRIVATE LIMITED",
"GRAND HYATT",
"GRAND HYUNDAI",
"GRAND INFRABUILTEC PRIVATE LIMITED",
"GRAND INFRADEVELOPERS PRIVATE LIMITED",
"GRAND LIFESTYLES PRIVATE LIMITED",
"GRAND LILLY MOTELS LIMITED",
"GRAND LIVING (INDIA) PRIVATE LIMITED",
"GRAND LUXE HOTELS LIMITED",
"GRAND MAGNUM HOUSING PRIVATE LIMITED",
"GRAND MALL (AFM) INFRATECH PRIVATE LIMITED",
"GRAND MANPOWER AND INFRATECH PRIVATE LIMITED",
"GRAND MOTORS SALES AND SERVICES PRIVATE LIMITED",
"GRAND NOTTING HILLS HOTEL & RESORTS PRIVATE LIMITED",
"GRAND OAK TRADING AND SOURCING PRIVATE LIMITED",
"GRAND ORGANICS PRIVATE. LIMITED",
"GRAND ORTUS SOLUTIONS PRIVATE LIMITED",
"GRAND PLAZA HOTEL PRIVATE LIMITED",
"GRAND POLYCOATS COMPANY PRIVATE LIMITED",
"GRAND POLYMERS PRIVATE LIMITED",
"GRAND PORT HOSPITAL",
"GRAND PRIME FOREX PRIVATE LIMITED",
"GRAND PRINTS PRIVATE LIMITED",
"GRAND PRIX ENGINEERING PRIVATE LIMITED",
"GRAND RAIL VENTURES INDIA PRIVATE LIMITED",
"GRAND RESOURCE FACTORY PRIVATE LIMITED",
"GRAND ROYAL TOURS PRIVATE LIMITED",
"GRAND ROYALE ENTERPRISES LIMITED",
"GRAND SAPPHIRE INFRATECH PRIVATE LIMITED",
"GRAND SKIES TRAVELS PRIVATE LIMITED",
"GRAND SLAM EXPRESS PRIVATE LIMITED",
"GRAND SLAM FITNESS PRIVATE LIMITED",
"GRAND SLEEP PRODUCTS PRIVATE LIMITED",
"GRAND SOLAR PRIVATE LIMITED",
"GRAND SOURCING PRIVATE LIMITED",
"GRAND SPEED NETWORK PRIVATE LIMITED",
"GRAND SURBHI PRIVATE LIMITED",
"GRAND TOURIO HOLIDAY SOLUTIONS PRIVATE LIMITED",
"GRAND TOWER HOTEL RESTAURANT PRIVATE LIMITED",
"GRAND UTSAV HOTELS & RESORTS PRIVATE LIMITED",
"GRAND VEHICLES PRIVATE LIMITED",
"GRAND VENEZIA COMMERCIAL TOWERS PRIVATE LIMITED",
"GRAND VENTURES PRIVATE LIMITED",
"GRAND VIEW ESTATES PRIVATE LIMITED",
"GRAND VIEW HOTELS PRIVATE LIMITED",
"GRAND VIEW RESEARCH INDIA PRIVATE LIMITED",
"GRAND VILLE REALTORS PRIVATE LIMITED",
"GRAND WINDSOR RESORTS LIMITED",
"GRAND WORLD ELDER CARE PRIVATE LIMITED",
"GRANDBAY BUILDCON PRIVATE LIMITED",
"GRANDBULL IMPEX PRIVATE LIMITED",
"GRANDCURE HEALTHCARE PRIVATE LIMITED",
"GRANDE SHIPPING AND CHARTERING (INDIA) PRIVATE LIMITED",
"GRANDEUR AGROTECH PRIVATE LIMITED",
"GRANDEUR BUSINESS SOLUTIONS PRIVATE LIMITED",
"GRANDEUR ENGINEERING PRIVATE LIMITED",
"GRANDEUR INTERIORS PRIVATE LIMITED",
"GRANDEUR PHARMA PRIVATE LIMITED",
"GRANDEUR SPACE SOLUTION PRIVATE LIMITED",
"GRANDEUR VIBES PRIVATE LIMITED",
"GRANDG CABLE INDIA PRIVATE LIMITED",
"GRANDHI ENTERPRISES PRIVATE LIMITED",
"GRANDHI INFRA DEVELOPERS PRIVATE LIMITED",
"GRANDHI THEATRES PVT LTD",
"GRANDIANA UNIVERSAL PRIVATE LIMITED",
"GRANDIOSE BUILDTECK PRIVATE LIMITED",
"GRANDIOSE IMPORTS AND EXPORTS PRIVATE LIMITED",
"GRANDIOSE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"GRANDLAKES ENGINEERING WORKS PRIVATE LIMITED",
"GRANDLIFE HEALTHCARE PRIVATE LIMITED",
"GRANDMAA INTERNATIONAL LIMITED",
"GRANDMARK DEVELOPERS PRIVATE LIMITED",
"GRANDMARK INFRASTRUCTURES PRIVATE LIMITED",
"GRANDMASTER INNOVATIONS PRIVATE LIMITED",
"GRANDMAX WEAVES PRIVATE LIMITED",
"GRAND-MIX CONCRETE PRIVATE LIMITED",
"GRANDPAW PET RESORTS PRIVATE LIMITED",
"GRANDPITSTOP PRIVATE LIMITED",
"GRANDSLAM DEVELOPERS PRIVATE LIMITED",
"GRANDSLAM FABRICATIONS PRIVATE LIMITED",
"GRANDSPIRE MEDIA PRIVATE LIMITED",
"GRANDTRUST INFOTECH PRIVATE LIMITED",
"GRANDUS INFRA PROJECTS PRIVATE LIMITED",
"GRANDWAY TECHNOLOGIES PRIVATE LIMITED",
"GRANFISHER NETS PRIVATE LIMITED",
"GRANGE HOTELS AND PROPERTIES PRIVATE LIMITED",
"GRANGE MANAGEMENT SERVICES PRIVATE LIMITED",
"GRANGES INDIA PRIVATE LIMITED",
"GRANITE PALACE (INDIA) PRIVATE LIMITED",
"GRANITE RIVER LABS TECHNOLOGY PRIVATE LIMITED",
"GRANITE ZONE INDIA PRIVATE LIMITED",
"GRANITECH PRIVATE LIMITED",
"GRANITO BRUSHES PRIVATE LIMITED",
"G-RANK DIGITAL SERVICES PRIVATE LIMITED",
"GRANMED PHARMA PRIVATE LIMITED",
"GRANNUS WATER & ENVIRONMENTAL SOLUTIONS PRIVATE LIMITED",
"GRANORA CROP SEED SCIENCE PRIVATE LIMITED",
"GRANROCK TILES PRIVATE LIMITED",
"GRANT INSTRUMENTS INDIA PRIVATE LIMITED",
"GRANT MEDICAL COLLEGE MUMBAI",
"GRANT THORNTON ADVISORY PRIVATE LIMITED",
"GRANT THORNTON BHARAT LLP",
"GRANT THORNTON GLOBAL DELIVERY PRIVATE LIMITED",
"GRANT THORNTON US KNOWLEDGE & CAPABILITY CENTRE INDIA",
"GRANTH BRANDING & CONTENT MARKETING AGENCY",
"GRANTOOLS PRIVATE LIMITED",
"GRANTRAIL WHOLESALE PRIVATE LIMITED",
"GRANULA MASTERBATCHES INDIA PRIVATE LIMITED",
"GRANULAR INFRA PROJECTS PRIVATE LIMITED",
"GRANULES INDIA LIMITED",
"GRANULES OMNICHEM PRIVATE LIMITED",
"GRAP REALTY PRIVATE LIMITED",
"GRAPE EVENTS PRIVATE LIMITED",
"GRAPE MARKETING PRIVATE LIMITED",
"GRAPE MASTER ORGANIC FARMERS PRODUCER COMPANY LIMITED",
"GRAPE TO GLASS WINE COMPANY PRIVATE LIMITED",
"GRAPEBAN SOLUTIONS PRIVATE LIMITED",
"GRAPECITY INDIA PRIVATE LIMITED",
"GRAPECON TECHNOLOGIES PRIVATE LIMITED",
"GRAPES DIGITAL PRIVATE LIMITED",
"GRAPES FABRICS PRIVATE LIMITED",
"GRAPES TELECOM PRIVATE LIMITED",
"GRAPEVINE REALTY PRIVATE LIMITED",
"GRAPEWINE NETWORKING PRIVATE LIMITED",
"GRAPH CONSULTANTS AND MARKETING PRIVATE LIMITED",
"GRAPHCO PRINT AND PACKAGING PRIVATE LIMITED",
"GRAPHENE HEALTH TECH PRIVATE LIMITED",
"GRAPHENE MEDIA PRIVATE LIMITED",
"GRAPHENE SEMI CONDUCTOR SERVICES PRIVATE LIMITED",
"GRAPHHENE SOFTWARE PRIVATE LIMITED",
"GRAPHIC ADS PRIVATE LIMITED",
"GRAPHIC CONNECTIONS ADVERTISING (MADRAS) PRIVATE LIMITED",
"GRAPHIC DIGITAL PRIVATE LIMITED",
"GRAPHIC ERA DEEMED TO BE UNIVERSITY",
"GRAPHIC ERA EDUCATIONAL SOCIETY",
"GRAPHIC ERA HILL UNIVERSITY",
"GRAPHIC ERA INSTITUTE OF MEDICAL SCIENCES",
"GRAPHIC ERA INSTITUTE OF TECHNOLOGY",
"GRAPHIC GARMENT LABELS PRIVATE LIMITED",
"GRAPHIC INNOVATORS INDIA PRIVATE LIMITED",
"GRAPHIC LEATHERS PRIVATE LIMITED",
"GRAPHIC PROMOTERS AND DEVELOPERS PRIVATE LIMITED",
"GRAPHIC REPRODUCTION SYNDICATE PRIVATE LIMITED",
"GRAPHIC SYSTEMS PRIVATE LIMITED",
"GRAPHIC TECHNOLOGIES SIGN PARK PRIVATE LIMITED",
"GRAPHIC TRADES PRIVATE LIMITED",
"GRAPHICAL MONITORING & INFORMATION SYSTEMS CONSULTANTS PRIVATE LIMITED",
"GRAPHICS INTERNATIONAL PRIVATE LIMITED",
"GRAPHINET SOLUTIONS PRIVATE LIMITED",
"GRAPHIPACKSS PRIVATE LIMITED",
"GRAPHISADS LIMITED",
"GRAPHISADS PRIVATE LIMITED",
"GRAPHITE & CARBON INDUSTRIES (INDIA) PRIVATE LIMITED",
"GRAPHITE DESIGNS PRIVATE LIMITED",
"GRAPHITE INDIA LIMITED",
"GRAPHITE REFMIN PRIVATE LIMITED",
"GRAPHITI MULTIMEDIA PRIVATE LIMITED",
"GRAPHLINE COMPUTERS PRIVATE LIMITED",
"GRAPHONET ADVERTISING PRIVATE LIMITED",
"GRAPHSON TECHNOLOGY PRIVATE LIMITED",
"GRAPHSTATS TECHNOLOGIES PRIVATE LIMITED",
"GRAPHTONE INDIA PRIVATE LIMITED",
"GRAPHX SOLUTION INDIA PRIVATE LIMITED",
"GRAPNEL SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"GRAPPLE INFO SOLUTIONS PRIVATE LIMITED",
"GRAPPLE LIFESCIENCES PRIVATE LIMITED",
"GRAPPLE SOFTWARE AND OUTSOURCING PRIVATE LIMITED",
"GRAS IMPEX PRIVATE LIMITED",
"GRASIM BUSINESS SERVICES PRIVATE LIMITED",
"GRASIM INDUSTRIES LIMITED",
"GRASIM JANASEVA TRUST HOSPITAL KUMARAPATNAM",
"GRASKO SOLUTIONS PRIVATE LIMITED",
"GRASKY INDIA PRIVATE LIMITED",
"GRASMICROBE PRIVATE LIMITED",
"GRASP ACADEMY PRIVATE LIMITED",
"GRASP ELECTRIC PRIVATE LIMITED",
"GRASPER GLOBAL PRIVATE LIMITED",
"GRASS ROOT LEISURES AND HOSPITALITY PRIVATE LIMITED",
"GRASS VALLEY INDIA PRIVATE LIMITED",
"GRASSDOOR LOGISTICS TECHNOLOGIES PRIVATE LIMITED",
"GRASSET KUNTAL CONSULTING PRIVATE LIMITED",
"GRASSHOPPER MEDIA PRIVATE LIMITED",
"GRASSHOPPER VANLINES PRIVATE LIMITED",
"GRASSMILE GLOBAL PRIVATE LIMITED",
"GRASSROOT ENTERTAINMENT PRIVATE LIMITED",
"GRASSROOT MANAGEMENT AND RESEARCH SERVICES PRIVATE",
"GRASSROOT MANAGEMENT AND RESEARCH SERVICES PRIVATE LIMITED",
"GRASSROOTS SOLUTIONS AND SERVICES PRIVATE LIMITED",
"GRASSROOTS SPORTS ACADEMY LLP",
"GRATEFIX FASTENING SOLUTIONS PRIVATE LIMITED",
"GRATEFUL APPARELS PRIVATE LIMITED",
"GRATEFUL BREAD HOSPITALITY PRIVATE LIMITED",
"GRATEX INDUSTRIES LIMITED",
"GRATIK TUBES PRIVATE LIMITED",
"GRATISCO WATER PRIVATE LIMITED",
"GRATITUDE HOLIDAYS PRIVATE LIMITED",
"GRATITUDE INDIA MANPOWER CONSULTANTS PRIVATE LIMITED",
"GRATITUDE PLASTICS",
"GRATS IT SERVICES PRIVATE LIMITED",
"GRAUER AND WEIL INDIA LIMITED",
"GRAVEIENS EDUSERVICES PRIVATE LIMITED",
"GRAVIN EARTHING & LIGHTNING PROTECTION SYSTEM PRIVATE LIMITED",
"GRAVISS DAIRY PRIVATE LIMITED",
"GRAVISS FOOD SOLUTIONS PRIVATE LIMITED",
"GRAVISS FOODS PRIVATE LIMITED",
"GRAVISS HOLDINGS PRIVATE LIMITED",
"GRAVISS HOSPITALITY LIMITED",
"GRAVISS HOTELS & RESORTS LIMITED",
"GRAVISS RETAIL PRIVATE LIMITED",
"GRAVITA INDIA LIMITED",
"GRAVITAS ENTERPRISES PRIVATE LIMITED",
"GRAVITAS GLOBAL SOLUTIONS PRIVATE LIMITED",
"GRAVITAS INFRA EQUIPMENT PRIVATE LIMITED",
"GRAVITAS TECHNOLOGY PRIVATE LIMITED",
"GRAVITASQ STORIES PRIVATE LIMITED",
"GRAVITECH SOLUTIONS PRIVATE LIMITED",
"GRAVITI PHARMACEUTICALS PRIVATE LIMITED",
"GRAVITIE KNOWLEDGE SERVICES PRIVATE LIMITED",
"GRAVITON LIFE CARE PRIVATE LIMITED",
"GRAVITON MEDICAL TECHNOLOGIES PRIVATE LIMITED",
"GRAVITON RESEARCH CAPITAL LLP",
"GRAVITOUS POWER PRIVATE LIMITED",
"GRAVITY (INDIA) LIMITED",
"GRAVITY BATH PRIVATE LIMITED",
"GRAVITY CAST PRIVATE LIMITED",
"GRAVITY CHICK FARMS PRIVATE LIMITED",
"GRAVITY CONSULTING ENGINEERS INDIA PRIVATE LIMITED",
"GRAVITY CYBERTECH PRIVATE LIMITED",
"GRAVITY DEALCOM PRIVATE LIMITED",
"GRAVITY DEVELOPERS PRIVATE LIMITED",
"GRAVITY DIE CASTERS PRIVATE LIMITED",
"GRAVITY EDUCATIONS PRIVATE LIMITED",
"GRAVITY ELECTRICALS PRIVATE LIMITED",
"GRAVITY ELEMENTS PRIVATE LIMITED",
"GRAVITY ENTERTAINMENT PRIVATE LIMITED",
"GRAVITY FACILITY MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"GRAVITY FERROUS PRIVATE LIMITED",
"GRAVITY GADGETS INDIA PRIVATE LIMITED",
"GRAVITY GLOBAL HOSPITALITY PRIVATE LIMITED",
"GRAVITY HEALTHCARE PRIVATE LIMITED",
"GRAVITY INDIA TECHNOLOGIES PRIVATE LIMITED",
"GRAVITY INDUSTRIES PRIVATE LIMITED",
"GRAVITY INFRA PROMOTERS PRIVATE LIMITED",
"GRAVITY INFRASTRUCTURES PRIVATE LIMITED",
"GRAVITY LOGI-CON PRIVATE LIMITED",
"GRAVITY ONE LIVING SPACE PRIVATE LIMITED",
"GRAVITY ORIENTING INTELLIGENCE",
"GRAVITY PRINTECH INDIA PRIVATE LIMITED",
"GRAVITY SANDS CRUSHER PRIVATE LIMITED",
"GRAVITY TREXIM PVT LTD",
"GRAVITY WORK ENTERTAINMENT AND HOSPITALITIES PRIVATE LIMITED",
"GRAVITYHOUSE PRIVATE LIMITED",
"GRAVOLITE INDIA PRIVATE LIMITED",
"GRAVOTECH ENGINEERING PRIVATE LIMITED",
"GRAVS INDIA OVERSEAS PRIVATE LIMITED",
"GRAVURE CILS (INDIA) PRIVATE LIMITED",
"GRAVURE CRAFTS MADRAS S PRIVATE LIMITED",
"GRAY HAT PRIVATE LIMITED",
"GRAY LINES ENGINEERS AND CONTRACTORS PVT LIM",
"GRAY MATTER SOFTWARE SERVICES PRIVATE LIMITED",
"GRAY SOLUTIONS PRIVATE LIMITED",
"GRAY TECHNOLOGIES PRIVATE LIMITED",
"GRAYEYE IT SYSTEMS PRIVATE LIMITED",
"GRAYGRAPH TECHNOLOGIES PRIVATE LIMITED",
"GRAYLINE MEDICAL PRIVATE LIMITED",
"GRAYLINX PRIVATE LIMITED",
"GRAYLOGIC TECHNOLOGIES PRIVATE LIMITED",
"GRAYMAN WOOD PRIVATE LIMITED",
"GRAYMATRIX SOLUTIONS PRIVATE LIMITED",
"GRAYMATTER SOFTWARE SERVICES PRIVATE LIMITED",
"GRAYSCALE INTERVENTION & DIAGNOSTICS CENTER PRIVATE LIMITED",
"GRAYSON DISTILLERS AND VINTNERS PRIVATE LIMITED",
"GRAYSTONE INFRA TECH PRIVATE LIMITED",
"GRAYTITUDE",
"GRAZIA TULIO LIFESTILE PRIVATE LIMITED",
"GRAZIANO TRASMISSIONI INDIA PRIVATE LIMITED",
"GRAZITTI INTERACTIVE LLP",
"GRAZZO HOSPITALITY PRIVATE LIMITED",
"GRB DAIRY FOODS PRIVATE LIMITED",
"GRB INDUSTRIES PRIVATE LIMITED",
"GRC BUSINESSDATA PROCESSING PRIVATE LIMITED",
"GRC EXPRESS AND LOGISTICS PRIVATE LIMITED",
"GRC GARMENTS PRIVATE LIMITED",
"GRC INFRA PRIVATE LIMITED",
"GRD COMMODITIES LIMITED",
"GRD FINANCE PRIVATE LIMITED",
"GRD SECURITIES IFSC LIMITED",
"GRD SECURITIES LIMITED",
"GRD STEEL INDUSTRIES PRIVATE LIMITED",
"GRE RENEW ENERTECH PRIVATE LIMITED",
"GREA ROOF INDUSTRIES PRIVATE LIMITED",
"GREAM TRADERS & EXPORTERS PVT LTD",
"GREASES AND LUBRICANTS PRIVATE LIMITED",
"GREAT CHAMP TECHNOLOGY LIMITED",
"GREAT CHAMP TECHNOLOGY PRIVATE LIMITED",
"GREAT CIRCLE CONSULTANCY PRIVATE LIMITED",
"GREAT CIRCLE SHIPPING PRIVATE LIMITED",
"GREAT CITY DEVELOPERS PRIVATE LIMITED",
"GREAT CLUB & RESORTS PRIVATE LIMITED",
"GREAT DATA SOLUTIONS INDIA PRIVATE LIMITED",
"GREAT DEVELOPERS INFO TECH PRIVATE LIMITED",
"GREAT EASTERN CSR FOUNDATION",
"GREAT EASTERN ENERGY CORPORATION LIMITED",
"GREAT EASTERN HIRE PURCHASE PRIVATE LIMITED",
"GREAT EASTERN HOUSING PRIVATE LIMITED",
"GREAT EASTERN IDTECH PRIVATE LIMITED",
"GREAT EASTERN INFRACON PRIVATE LIMITED",
"GREAT EASTERN PROCESSORS PRIVATE LIMITED",
"GREAT EASTERN RETAIL PRIVATE LIMITED",
"GREAT EASTERN TEA INDUSTRIES PRIVATE LIMITED",
"GREAT FIN LEASING & CREDIT LIMITED",
"GREAT FINTRADE PRIVATE LIMITED",
"GREAT FORTUNE INFOTECH PRIVATE LIMITED",
"GREAT GALLEON VENTURES LIMITED",
"GREAT GRANITES PVT. LTD.",
"GREAT GRANULE PRIVATE LIMITED",
"GREAT HIMALAYA ELEVATOR AND ESCALATOR PRIVATE LIMITED",
"GREAT INDIA CEMENT PRIVATE LIMITED",
"GREAT INDIA PIPES PRIVATE LIMITED",
"GREAT INDIA STEEL FABRICATORS",
"GREAT INDIAN INSURANCE WEB AGGREGATORS PRIVATE LIMITED",
"GREAT INDIAN JOURNEY PRIVATE LIMITED",
"GREAT INDIAN OUTDOORS PRIVATE LIMITED",
"GREAT INNOVUS SOLUTIONS PRIVATE LIMITED",
"GREAT LAKES INSTITUTE OF MANAGEMENT",
"GREAT LIFE ENTRADE PRIVATE LIMITED",
"GREAT MANAGER RESEARCH & CONSULTANCY PRIVATE LIMITED",
"GREAT MARKET AGGREGATOR PRIVATE LIMITED",
"GREAT MEDIA TECHNOLOGIES PVT LTD",
"GREAT MOUNT RESORT PRIVATE LIMITED",
"GREAT NORTHERN LIMITED",
"GREAT PACIFIC EXPORTS PRIVATE LIMITED",
"GREAT PLACE IT SERVICES PRIVATE LIMITED",
"GREAT PLACE RESEARCH AND CONSULTANCY PRIVATE LIMITED",
"GREAT PLACE TO WORK",
"GREAT PLASTIC PRIVATE LIMITED",
"GREAT RETAIL BRANDS PRIVATE LIMITED",
"GREAT ROCKSPORT PRIVATE LIMITED",
"GREAT SANDS CONSULTING PRIVATE LIMITED",
"GREAT SHERLOCK EX -SERVICEMEN'S FACILITY AND SECURITY MANAGEMENT SERVICES PRIVATE LIMITED",
"GREAT SKILLED FACILITY & SECURITY PRIVATE LIMITED",
"GREAT SOFTWARE LABORATORY PRIVATE LIMITED",
"GREAT SPORTS INFRA PRIVATE LIMITED",
"GREAT SPORTSTECH LIMITED",
"GREAT VALUE BUILDCON PRIVATE LIMITED",
"GREAT VALUE FUELS PRIVATE LIMITED",
"GREAT VALUE TRADEMART PRIVATE LIMITED",
"GREAT VALUES SOURCING HUB PRIVATE LIMITED",
"GREAT VIEW REAL ESTATES PRIVATE LIMITED",
"GREAT WALL INDIA RESEARCH & DEVELOPMENT PRIVATE LIMITED",
"GREAT WEST EMPOWER",
"GREAT WEST GLOBAL BUSINESS SERVICES INDIA PRIVATE LIMITED",
"GREAT WESTERN PROJECTS PRIVATE LIMITED",
"GREAT WHITE GLOBAL PRIVATE LIMITED",
"GREATDOLPHIN SECURITY SERVICES PRIVATE LIMITED",
"GREATEASTERN UDYOG PRIVATE LIMITED",
"GREATECH EASY SOLUTION PRIVATE LIMITED",
"GREATER CALCUTTA GAS SUPPLY CORPORATION LTD",
"GREATER CHENNAI CORPORATION",
"GREATER DELHI PLANNERS PRIVATE LIMITED",
"GREATER FEED CARE PRIVATE LIMITED",
"GREATER HEIGHTS PUBLIC SCHOOL",
"GREATER HYDERABAD MUNICIPAL CORPORATION",
"GREATER INFRA PROJECTS PRIVATE LIMITED",
"GREATER KAILASH HOSPITALS PRIVATE LIMITED",
"GREATER KOLKATA COLLEGE OF ENGG & MANAGEMENT",
"GREATER MUNICIPAL CORPORATION GANDHINAGAR",
"GREATER NOIDA HOSTELS AND INFRASTRUCTURE PRIVATE LIMITED",
"GREATER NOIDA INDUSTRIAL DEVELOP",
"GREATER NOIDA INSTITUTE OF MANAGEMENT",
"GREATER NOIDA INSTITUTE OF TECHNOLOGY",
"GREATER PACIFIC CAPITAL INDIA PRIVATE LIMITED",
"GREATER SITAPURA DEVELOPERS PRIVATE LIMITED",
"GREATER VALLEY SCHOOL",
"GREATER VISAKHAPATNAM MUNICIPAL CORPORATION",
"GREATER WARANGAL MUNICIPAL CORPORATION",
"GREATEX SYNTHETICS PRIVATE LIMITED",
"GREATFOUR SYSTEMS PRIVATE LIMITED",
"GREATHEALTH TREXIM PRIVATE LIMITED",
"GREATOO INDIA PRIVATE LIMITED",
"GREATSHIP INDIA LIMITED",
"GREATSKY FROFOO PRIVATE LIMITED",
"GREATVALUE INDUSTRIES PRIVATE LIMITED",
"GREATVALUE PROJECTS INDIA LIMITED",
"GREATWAY AGRO FARMS PRIVATE. LIMITED.",
"GREATWAY BUILDCON INDIA PRIVATE LIMITED",
"GREATWAY LIGHTS INDIA PRIVATE LIMITED",
"GREATWAY PVT LTD",
"GREATWAYS BUILDTECH LIMITED",
"GREATWAYS LOGISTICS PRIVATE LIMITED",
"GREATWAYS TRANSPORT PRIVATE LIMITED",
"GREATWHITE HARDWARE PRIVATE LIMITED",
"GREAVES COTTON LIMITED",
"GREAVES ELECTRIC MOBILITY PRIVATE LIMITED",
"GREAVES FINANCE LIMITED",
"GREAVES TECHNOLOGIES LIMITED",
"GREAVES TRAVEL INDIA PRIVATE LIMITED",
"GREB CLOUD PRIVATE LIMITED",
"GREBAL CAPITAL SERVICES PRIVATE LIMITED",
"GRECIAN PRIVATE LIMITED",
"GRECIAN SUOERSPECIALITY HOSPITAL",
"GREE INDIA AIR CONDITIONERS AND APPLIANCES LIMITED",
"GREE-CA",
"GREECO ELECTRONICS PRIVATE LIMITED",
"GREEDYGAME MEDIA PRIVATE LIMITED",
"GREEK LOOKS COSMETIC PRIVATE LIMITED",
"GREEKA IMPEX PRIVATE LIMITED",
"GREEKSOFT TECHNOLOGIES PRIVATE LIMITED",
"GREELUX INTERIORS PRIVATE.LIMITED",
"GREEN AGRI CORP PRIVATE LIMITED",
"GREEN AGRO PACK PRIVATE LIMITED",
"GREEN AGROPLAST PRIVATE LIMITED",
"GREEN AID LANDSCAPES PRIVATE LIMITED",
"GREEN AIMS INFOTECH PRIVATE LIMITED",
"GREEN AIR TRADING ENTERPRISES (INDIA) PRIVATE LIMITED",
"GREEN APEX TECHNOLABS LLP",
"GREEN APOLLO BIO SCIENCES PRIVATE LIMITED",
"GREEN APPLE EXIM PRIVATE LIMITED",
"GREEN APPLE HEALTH CARE PRIVATE LIMITED",
"GREEN APPLE HOTELS & RESORTS PRIVATE LIMITED",
"GREEN APPLE PRIVATE LIMITED",
"GREEN APPLE SOLUTIONS PRIVATE LIMITED",
"GREEN APPLES TECHSYSTEMS PRIVATE LIMITED",
"GREEN AQUA ENVIRO PROJECTS PRIVATE LIMITED",
"GREEN ART LANDSCAPE PRIVATE LIMITED",
"GREEN ASIA IMPEX PRIVATE LIMITED",
"GREEN ASSAM COMPANY PVT LTD",
"GREEN ASSETS MAHADEVAPURA PRIVATE LIMITED",
"GREEN AUTOMOBILES PVT LTD",
"GREEN BACK COMMODITIES PRIVATE LIMITED",
"GREEN BAY INFRASTRUCTURE PRIVATE LIMITED",
"GREEN BIOTECH ECOSOLUTIONS PRIVATE LIMITED",
"GREEN BOOKS PRIVATE LIMITED",
"GREEN BRICK BUILDCON PRIVATE LIMITED",
"GREEN BRICK ECO SOLUTIONS PRIVATE LIMITED",
"GREEN BRICK PROJECT PRIVATE LIMITED",
"GREEN BRIDGE CAPITAL ADVISORY PRIVATE LIMITED",
"GREEN BUILDESTATE PRIVATE LIMITED",
"GREEN BUILDING TECHNOLOGIES PRIVATE LIMITED",
"GREEN BUSINESS CERTIFICATION INSTITUTE PRIVATE LIMITED",
"GREEN BYTE WEB PRIVATE LIMITED",
"GREEN CANOPY INITIATIVES PRIVATE LIMITED",
"GREEN CARBON FUELS & FEEDS PRIVATE LIMITED",
"GREEN CELLS INFRASTRUCTURES PRIVATE LIMITED",
"GREEN CHANNEL CARGO CARE PRIVATE LIMITED",
"GREEN CHANNEL FORWARDERS PRIVATE LIMITED",
"GREEN CHANNEL INFOTECH PRIVATE LIMITED",
"GREEN CHANNEL PUBLICATIONS INDIA PRIVATE LIMITED",
"GREEN CHARIOT PRIVATE LIMITED",
"GREEN CHEMICAL TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"GREEN CHILLI ADVERTISING PRIVATE LIMITED",
"GREEN CHILLYZ CATERING & FOODS PRIVATE LIMITED",
"GREEN CINEMAS GLOBAL PRIVATE LIMITED",
"GREEN CIRCLE ENVIRONMENT PRIVATE LIMITED",
"GREEN CITY CERAMIC",
"GREEN CITY FARMS PVT LTDE",
"GREEN CITY HOSPITAL",
"GREEN CITY TRANSPORT CORPORATION PRIVATE LIMITED",
"GREEN CLIMATE SOLUTION PRIVATE LIMITED",
"GREEN COTSYN PRIVATE LIMITED",
"GREEN COUPES PRIVATE LIMITED",
"GREEN CREDIT MANAGEMENT PRIVATE LIMITED",
"GREEN CROP BIO - SEEDS PRIVATE LIMITED",
"GREEN CROP INTERNATIONAL PRIVATE LIMITED",
"GREEN CROSS GENETICS LAB PRIVATE LIMITED",
"GREEN CUBES TECHNOLOGY ( POWER SOLUTIONS) PRIVATE LIMITED",
"GREEN DART LOGISTICS PRIVATE LIMITED",
"GREEN DELHI BQS LIMITED",
"GREEN DESIGN AND ENGINEERING SERVICES PRIVATE LIMITED",
"GREEN DHARI SEEDS PRIVATE LIMITED",
"GREEN DOT ELECTRIC LIMITED",
"GREEN DRIVE AUTO SERVICES PRIVATE LIMITED",
"GREEN DYE CHEM PRIVATE LIMITED",
"GREEN EARTH COAL AND LOGISTICS PRIVATE LIMITED",
"GREEN EARTH ENGINEERING INDIA PRIVATE LIMITED",
"GREEN EARTH FRESH PRODUCE PRIVATE LIMITED",
"GREEN EARTH INFRASTRUCTURE PRIVATE LIMITED",
"GREEN EARTH SHELTERS INDIA PRIVATE LIMITED",
"GREEN EARTH STAFFING SOLUTIONS PRIVATE LIMITED",
"GREEN EARTH SYSTEMS PRIVATE LIMITED",
"GREEN EARTH TRANSLOGISTICS PRIVATE LIMITED",
"GREEN ECONOMY INITIATIVES PRIVATE LIMITED",
"GREEN EDGE TECHNOLOGIES PRIVATE LIMITED",
"GREEN EDIFICE INFRAVENTURES PRIVATE LIMITED",
"GREEN ELECTRICALS PRIVATE LIMITED",
"GREEN ELEPHANT INDIA PRIVATE LIMITED",
"GREEN EN SOLUTIONS PRIVATE LIMITED",
"GREEN ENABLED IT SOLUTIONS PRIVATE LIMITED",
"GREEN ENERGY",
"GREEN ENERGY DEVELOPMENT CORPORATION OF ODISHA LIMITED",
"GREEN ENERZON PRIVATE LIMITED",
"GREEN ENVIRO GAS PRIVATE LIMITED",
"GREEN ENVIRO INTERNATIONAL PRIVATE LIMITED",
"GREEN ENVIROSAFE ENGINEERS & CONSULTANT PRIVATE LIMITED",
"GREEN ERA ENERTECH PRIVATE LIMITED",
"GREEN ERA MANAGEMENT PRIVATE LIMITED",
"GREEN EVOLUTION ARCHITECTURAL CONSULTANCY PRIVATE LIMITED",
"GREEN EVOLVE PRIVATE LIMITED",
"GREEN EXPRESS CARRIERS PRIVATE LIMITED",
"GREEN FACADE SOLUTIONS PRIVATE LIMITED",
"GREEN FARM AGRI EXPORTS",
"GREEN FIBRE FOODS (INDIA) PRIVATE LIMITED",
"GREEN FIELD CONTROL SYSTEM (I) PRIVATE LIMITED",
"GREEN FIELD EDUCATION SOCIETY",
"GREEN FIELD FARM PVT LTD",
"GREEN FIELD HIGHER SECONDARY SCHOOL",
"GREEN FIELD MATERIAL HANDLING PRIVATE LIMITED",
"GREEN FIELD NUTRITIOUS PRIVATE LIMITED",
"GREEN FIELD PUBLIC SCHOOL",
"GREEN FIELD RESOURCES PRIVATE LIMITED",
"GREEN FIELD SOLAR SOLUTION PRIVATE LIMITED",
"GREEN FIELDS ACADEMY",
"GREEN FINCH TEXTILE PRIVATE LIMITED",
"GREEN FINGERS INDIA PRIVATE LIMITED",
"GREEN FINGERS LANDSCAPERS PRIVATE LIMITED",
"GREEN FLAME PRIVATE LIMITED",
"GREEN FMC ADVERTISING PRIVATE LIMITED",
"GREEN FORCE ENGINEERS PRIVATE LIMITED",
"GREEN FORTUNE COMMUNICATIONS PRIVATE LIMITED",
"GREEN FREIGHT PRIVATE LIMITED",
"GREEN FUEL ALTERNATIVES PRIVATE LIMITED",
"GREEN FUELS GLOBAL TRADING PRIVATE LIMITED",
"GREEN GAP ENVIRO SOLUTIONS PRIVATE LIMITED",
"GREEN GENE ENVIRO PROTECTION AND INFRASTRUCTURE PRIVATE LIMITED",
"GREEN GENOME INDIA PRIVATE LIMITED",
"GREEN GHAR INFRASTRUCTURE & CONSTRUCTION PRIVATE LIMITED",
"GREEN GLAZE INDIA PRIVATE LIMITED",
"GREEN GLOBAL ENTERPRISES",
"GREEN GLOBAL FOREX PRIVATE LIMITED",
"GREEN GLOBAL LOGISTICS AND INFRA PRIVATE LIMITED",
"GREEN GLOBE IMPEX PRIVATE LIMITED",
"GREEN GLOBE METAL PRIVATE LIMITED",
"GREEN GLOBE TEXTILES LIMITED",
"GREEN GLOBUS MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"GREEN GOLD ANIMATION PRIVATE LIMITED",
"GREEN GOLD ASSAM PVT LTD",
"GREEN GOLD DEVELOPERS PRIVATE LIMITED",
"GREEN GOLD GLOBAL RESOURCES PRIVATE LIMITED",
"GREEN GOLD LICENSING AND MERCHANDISING INDIA PRIVATE LIMITED",
"GREEN GOLD MERCANTILE PVT. LTD.",
"GREEN GOLD SEEDS PRIVATE LIMITED",
"GREEN GOLD TIMBER PRIVATE. LIMITED.",
"GREEN GOLD TREE FARMERS PRIVATE LIMITED",
"GREEN GOODNESS ENTERPRISES PRIVATE LIMITED",
"GREEN GOOSE DESIGN PRIVATE LIMITED",
"GREEN GROVE PUBLIC SCHOOL",
"GREEN GROW NUTRIENTS PRIVATE LIMITED",
"GREEN HABIT ORGANIC PRIVATE LIMITED",
"GREEN HAMMER PRIVATE LIMITED",
"GREEN HEALS HOSPITAL PRIVATE LIMITED",
"GREEN HEART TECHNOLOGIES",
"GREEN HEAVEN LANDSCAPE PRIVATE LIMITED",
"GREEN HILL PACKAGINGS PRIVATE LIMITED",
"GREEN HILL RESORTS PRIVATE LIMITED",
"GREEN HOME FARMS AND RESORTS PRIVATE LIMITED",
"GREEN HOME LANDSCAPE PRIVATE LIMITED",
"GREEN HOME VILLAS INDIA PRIVATE LIMITED",
"GREEN HOPPER HOTELS & RESORTS PRIVATE LIMITED",
"GREEN HOTELS (PEHALGAM) PRIVATE LIMITED",
"GREEN HOUSE AGRO PRODUCTS",
"GREEN ICE SOLUTIONS PRIVATE LIMITED",
"GREEN INCREDIBLE FOODS PRIVATE LIMITED",
"GREEN INDIA EQUIPMENTS PRIVATE LIMITED",
"GREEN INDIA INITIATIVE PRIVATE LIMITED",
"GREEN INFRA BTV LIMITED",
"GREEN INFRA CORPORATE SOLAR LIMITED",
"GREEN INFRA CORPORATE WIND LIMITED",
"GREEN INFRA RENEWABLE ENERGY LIMITED",
"GREEN INFRA RENEWABLE PROJECTS LIMITED",
"GREEN INFRA SOLAR ENERGY LIMITED",
"GREEN INFRA SOLAR FARMS LIMITED",
"GREEN INFRA SOLAR PROJECTS LIMITED",
"GREEN INFRA WIND ENERGY ASSETS LIMITED",
"GREEN INFRA WIND ENERGY LIMITED",
"GREEN INFRA WIND ENERGY PROJECT LIMITED",
"GREEN INFRA WIND ENERGY THENI LIMITED",
"GREEN INFRA WIND FARM ASSETS LIMITED",
"GREEN INFRA WIND FARMS LIMITED",
"GREEN INFRA WIND GENERATION LIMITED",
"GREEN INFRA WIND POWER GENERATION LIMITED",
"GREEN INFRA WIND POWER LIMITED",
"GREEN INFRA WIND POWER PROJECT LIMITED",
"GREEN INFRA WIND POWER THENI LIMITED",
"GREEN INFRA WIND SOLUTIONS LIMITED",
"GREEN INNOVATIVE POWER PRIVATE LIMITED",
"GREEN INTERIO FUSION PRIVATE LIMITED",
"GREEN IP SERVICES PRIVATE LIMITED",
"GREEN IT RECYCLING CENTRE PRIVATE LIMITED",
"GREEN IVY VENTURES PRIVATE LIMITED",
"GREEN KALAM INTERIOR DESIGNERS PRIVATE LIMITED",
"GREEN KART LOGISTICS PRIVATE LIMITED",
"GREEN KERALA PLANTATION PRIVATE LIMITED",
"GREEN KEYS PLANTATION LIMITED",
"GREEN LAB ANALYSIS & RESEARCH CENTRE PRIVATE LIMITED",
"GREEN LAND AGRI MARKETING INDIA PRIVATE LIMITED",
"GREEN LAND BIO-SCIENCE PRIVATE LIMITED",
"GREEN LAND CONVENT SCHOOL",
"GREEN LAND HOSPITALITY PRIVATE LIMITED",
"GREEN LAND SR SEC SCHOOL",
"GREEN LANTERN ENGINEERING PRIVATE LIMITED",
"GREEN LAVA ECO SOLUTIONS PRIVATE LIMITED",
"GREEN LEAF CHEM TECH PRIVATE LIMITED",
"GREEN LEAF HOSPITAL",
"GREEN LEAF TOBACCO THRESHERS LIMITED",
"GREEN LEAP PROJECTS PRIVATE LIMITED",
"GREEN LEAVES INFRATECH LIMITED",
"GREEN LED TECHNOLOGY PRIVATE LIMITED",
"GREEN LIFE RESEARCH AND DIAGNOSTIC CARE PRIVATE LIMITED",
"GREEN LIFE SAVE AND PROTECT PRIVATE LIMITED",
"GREEN LIFE SOLUTIONS PRIVATE LIMITED",
"GREEN LIGHT FOODS PRIVATE LIMITED",
"GREEN LINE LAMINATES PRIVATE LIMITED",
"GREEN LINE WINDOWS PRIVATE LIMITED",
"GREEN LINEN PRIVATE LIMITED",
"GREEN MALLEABLES PRIVATE LIMITED",
"GREEN MANUFACTURING CO LIMITED",
"GREEN MARBLE HOUSE PRIVATE LIMITED",
"GREEN MARKER EDUTECH PRIVATE LIMITED",
"GREEN MAX ESTATE PRIVATE LIMITED",
"GREEN MEADOWS INFRASTRUCTURE PRIVATE LIMITED",
"GREEN MEP PRIVATE LIMITED",
"GREEN METHOD ENGINEERING PRIVATE LIMITED",
"GREEN MICRO ELECTRONICS INDIA PRIVATE LIMITED",
"GREEN MIRROR BUILDCON PRIVATE LIMITED",
"GREEN NATURAL EXTRACTS PRIVATE LIMITED",
"GREEN NETWORK TELECOM PRIVATE LIMITED",
"GREEN NOIDA HEALTH AND RESEARCH INSTITUTE HOSPITALS PRIVATE LIMITED",
"GREEN O VISION PAPER PRODUCTS PRIVATE LIMITED",
"GREEN OCEAN LOGISTICS PRIVATE LIMITED",
"GREEN OLIVES FOODS PRIVATE LIMITED",
"GREEN ONE DRIVE PRIVATE LIMITED",
"GREEN ORBIT APPARELS PVT LTD",
"GREEN ORBIT REAL ESTATE DEVELOPMENT PRIVATE LIMITED",
"GREEN PACK FOILS PRIVATE LIMITED",
"GREEN PACKAGING INDUSTRIES PRIVATE LIMITED",
"GREEN PARK COACHING CENTER",
"GREEN PARK EDUCATIONAL INSTITUTIONS",
"GREEN PARK HOSPITALITY SERVICES PRIVATE LIMITED",
"GREEN PARK INDEPENDENT LIVING FACILITY PRIVATE LIMITED",
"GREEN PARK INTERNATIONAL SCHOOL",
"GREEN PARK SHOE PRIVATE LIMITED",
"GREEN PARK SMART SCHOOL",
"GREEN PC WORLD PRIVATE LIMITED",
"GREEN PEARL EDUCATION MANAGEMENT CORPORATION PRIVATE LIMITED",
"GREEN PEARL ELECTRONICS PRIVATE LIMITED",
"GREEN PEARL ENGINEERING CONSTRUCTION CORPORATION LIMITED",
"GREEN PEARL PUBLICATIONS PRIVATE LIMITED",
"GREEN PEPPER RESORTS PRIVATE LIMITED",
"GREEN PET STRAP PRIVATE LIMITED",
"GREEN PICKLES PRIVATE LIMITED",
"GREEN PIPELINERS PRIVATE LIMITED",
"GREEN PLANET ENERGY PRIVATE LIMITED",
"GREEN PLANET MACHINES PRIVATE LIMITED",
"GREEN PLUS CONSTRUCTION PRIVATE LIMTED",
"GREEN POINT ACADEMY",
"GREEN POINT TECHNOLOGY SERVICES I PRIVATE LIMITED",
"GREEN POINT TECHNOLOGY SERVICES INDIA LIMITED",
"GREEN POLYTUBES PRIVATE LIMITED",
"GREEN PORTFOLIO PRIVATE LIMITED",
"GREEN POWER CONSORTIUM MANAGEMENT CO PRIVATE LIMITED",
"GREEN POWER INTERNATIONAL PRIVATE LIMITED",
"GREEN POWER SUGARS LIMITED",
"GREEN POWER SYSTEM",
"GREEN POWER TRANSMISSION PRIVATE LIMITED",
"GREEN PRINTING SOLUTION PRIVATE LIMITED",
"GREEN PUMPS AND EQUIPMENTS PRIVATE LIMITED",
"GREEN READYMADE STEEL PRODUCTS INDIA PRIVATE LIMITED",
"GREEN REALCON PRIVATE LIMITED",
"GREEN REGNUM AGRO PRIVATE LIMITED",
"GREEN ROADWAYS PVT LTD",
"GREEN ROADWAYS TRANSPORT DELHI PRIVATE LIMITED",
"GREEN ROOM MEDIA & EVENT MANAGEMENT SERVICES PRIVATE LIMITED",
"GREEN ROSHNI INDIA PRIVATE LIMITED",
"GREEN ROYALE RETAIL HOLDINGS PRIVATE LIMITED",
"GREEN RUBBER CRUMB PRIVATE LIMITED",
"GREEN RUBBER GRANULES PRIVATE LIMITED",
"GREEN SAFETY SYSTEMS PRIVATE LIMITED",
"GREEN SCIENTIFIC DEVELOPMENT (I) PRIVATE LIMITED",
"GREEN SECURE ENERGY PRIVATE LIMITED",
"GREEN SECURE POWER SYSTEMS PRIVATE LIMITED",
"GREEN SEEDS PRIVATE LIMITED",
"GREEN SEVEN RESORTS PRIVATE LIMITED",
"GREEN SHAKTI ENERGIES PRIVATE LIMITED",
"GREEN SHEPHERD ENERGY PRIVATE LIMITED",
"GREEN SHUTTLE TECHNOLOGY PRIVATE LIMITED",
"GREEN SKY ENERGY",
"GREEN SMART INFRACON PRIVATE LIMITED",
"GREEN SOLUTIONS (INDIA) PRIVATE LIMITED",
"GREEN SOLUTIONS PRIVATE LIMITED",
"GREEN SOURCES PRIVATE LIMITED",
"GREEN SPACE DEVELOPERS PRIVATE LIMITED",
"GREEN STACK MARKETING PRIVATE LIMITED",
"GREEN STAR APC TECH PRIVATE LIMITED",
"GREEN STAR GAS SUPPLING COMPANY PRIVATE LIMITED",
"GREEN STARS SA PRIVATE LIMITED",
"GREEN STEPS AGRO FARMS PRIVATE LIMITED",
"GREEN SUPPLY MANAGEMENT (KOLKATA) PRIVATE LIMITED",
"GREEN SURFACE COATING INDIA PRIVATE LIMITED",
"GREEN SURFER PRIVATE LIMITED",
"GREEN SWM INFRA PRIVATE LIMITED",
"GREEN TEAK INDIA PRIVATE LIMITED",
"GREEN TECH MATRICULATION HIGHER SECONDARY SCHOOL",
"GREEN TECH NET COM PRIVATE LIMITED",
"GREEN TECH RESIDENCIES PRIVATE LIMITED",
"GREEN TECHCONNECT PRIVATE LIMITED",
"GREEN TECHNOCRAFT PRIVATE LIMITED",
"GREEN THERMO POWER PRIVATE LIMITED",
"GREEN TONERS PRIVATE LIMITED",
"GREEN TOP HOTELS (PATNITOP) PRIVATE LIMITED",
"GREEN TOURIST SERVICES PRIVATE LIMITED",
"GREEN TREET AUTOMOTIVES PRIVATE LIMITED",
"GREEN TRUCK PRIVATE LIMITED",
"GREEN URJA PRIVATE LIMITED",
"GREEN VALET PARKING SOLUTIONS (OPC) PRIVATE LIMITED",
"GREEN VALLEY BEVERAGES INDIA PRIVATE LIMITED",
"GREEN VALLEY BIO- ENERGY PRIVATE LIMITED",
"GREEN VALLEY BIO NATURALS PRIVATE LIMITED",
"GREEN VALLEY CEREALS PRIVATE LIMITED",
"GREEN VALLEY CIDER PRIVATE LIMITED",
"GREEN VALLEY DIAGNOSTICS & HOSPITALS PRIVATE LIMITED",
"GREEN VALLEY ENERGY VENTURES PRIVATE LIMITED",
"GREEN VALLEY FOOD PROCESSORS PVT LTD",
"GREEN VALLEY PRIDE PRIVATE LIMITED",
"GREEN VALLEY PUBLIC SCHOOL",
"GREEN VALLEY RICE TECH PRIVATE LIMITED",
"GREEN VALLEY SCHOOL FOR CHILDREN",
"GREEN VALLEY SEEDS PRIVATE LIMITED",
"GREEN VALLEY TRAVELS PVT LTD",
"GREEN VALLEYS SHELTERS PRIVATE LIMITED",
"GREEN VALLIEY INDUSTRIES LIMITED",
"GREEN VATIKA CONSTRUCTIONS PRIVATE LIMITED",
"GREEN VEGE EXPORTS PRIVATE LIMITED",
"GREEN VELLY GEMS PRIVATE LIMITED",
"GREEN VIEW",
"GREEN VIEW CLINIC PRIVATE LIMITED",
"GREEN VIEW MARKETING PRIVATE LIMITED",
"GREEN VIEW PUBLIC SCHOOL",
"GREEN VIEW UDYOG PRIVATE LIMITED",
"GREEN VIEW VENTURES PRIVATE LIMITED",
"GREEN VILLAGE AGROS PRIVATE LIMITED",
"GREEN VILLAGE RESORTS LIMITED",
"GREEN VISION LIFE SCIENCES PRIVATE LIMITED",
"GREEN VORTEX WASTE MANAGEMENT PRIVATE LIMITED",
"GREEN WAYS SHIPPING AGENCIES PRIVATE LIMITED",
"GREEN WEALTH AGRO INDIA LIMITED",
"GREEN WINDOWS PRIVATE LIMITED",
"GREEN WOOD FOUR SEASONS PRIVATE LIMITED",
"GREEN WOODCRAFTS PRIVATE LIMITED",
"GREEN WOODS PALACES & RESORTS PRIVATE LIMITED",
"GREEN WORK INTEGRATED TECHNOLOGIES PRIVATE LIMITED",
"GREEN WORLD BUILDCON AND INFRA PRIVATE LIMITED",
"GREEN WORLD MANAGEMENT CONSULTANT & TRAINING INSTITUTE",
"GREEN WORLD PUBLICATIONS (INDIA) PRIVATE LIMITED",
"GREEN WORLD RENEWABLE ENERGY",
"GREEN WORLD WASTE MANAGEMENT PRIVATE LIMITED",
"GREEN ZONE AGROCHEM PRIVATE LIMITED",
"GREEN ZONE INFRASTRUCTURE DEVELOPERS PRIVATE LIMITED",
"GREENACRE CHEMICALS PVT LTD",
"GREENACRE HOLDINGS LTD",
"GREENAGE ECOPACK PRIVATE LIMITED",
"GREENAGE GRIHA NIRMAN PRIVATE LIMITED",
"GREENAGE IMPEX PRIVATE LIMITED",
"GREENAGE INDIA RESOURCES PRIVATE LIMITED",
"GREENAGERS ENVIRO SOLUTIONS & SERVICES PRIVATE LIMITED",
"GREENAGRO BAZAR EXPORTS PRIVATE LIMITED",
"GREENAM ENERGY PRIVATE LIMITED",
"GREENANDGROW WATER TREATMENT PRIVATE LIMITED",
"GREENARCH SOLAR PRIVATE LIMITED",
"GREENARK ENERSOL PRIVATE LIMITED",
"GREENASIA FACILITY MANAGEMENT PRIVATE LIMITED",
"GREENATIVE PETROCHEM PRIVATE LIMITED",
"GREENAVIOM PRIVATE LIMITED",
"GREENAWARE ECOPRODUCTS PRIVATE LIMITED",
"GREENBACK ADVISORY SERVICES PRIVATE LIMITED",
"GREENBACK FINANCIAL AND FX SERVICES PRIVATE LIMITED",
"GREENBAND FOODS (INDIA) PRIVATE LIMITED",
"GREENBAUM PROJECTIONS INDIA PRIVATE LIMITED",
"GREENBAY BIOTECH INTERNATIONAL PRIVATE LIMITED",
"GREENBAY TECH PRIVATE LIMITED",
"GREENBERRY FOILS INDIA LIMITED",
"GREENBERRY RG HEALTHCARE INDIA PRIVATE LIMITED",
"GREENBILLS TECHNOLOGY SERVICES PRIVATE LIMITED",
"GREENBOXCO HVACR PRIVATE LIMITED",
"GREENBRILLIANCE ENERGY PRIVATE LIMITED",
"GREENBROOK ENGINEERING SERVICES INDIA PRIVATE LIMITED",
"GREENBUBBLE ALGALWORKS PRIVATE LIMITED",
"GREENBUCKET VENTURES PRIVATE LIMITED",
"GREENBUCKS COMTRADE PRIVATE LIMITED",
"GREENBYTE TECHNOLOGIES PRIVATE LIMITED",
"GREENCELL EV PRIVATE LIMITED",
"GREENCELL EXPRESS PRIVATE LIMITED",
"GREENCELL MOBILITY PRIVATE LIMITED",
"GREENCELL RUBBER INDIA PRIVATE LIMITED",
"GREENCEM PRODUCTS PRIVATE LIMITED",
"GREENCHEF APPLIANCES LIMITED",
"GREENCITY FOODS PRIVATE LIMITED",
"GREENCITY INFRAESTATE PRIVATE LIMITED",
"GREENCITY SURVEYORS PRIVATE LIMITED",
"GREENCO BIOLOGICALS PRIVATE LIMITED",
"GREENCO SYSTEMS PRIVATE LIMITED",
"GREENCOAT CHEMICALS PRIVATE LIMITED",
"GREENCORE PAPER CONVERSION PRIVATE LIMITED",
"GREENCORE PRODUCER COMPANY LIMITED",
"GREENCREST FINANCIAL SERVICES LIMITED",
"GREENCROP INTERNATIONAL PRIVATE LIMITED",
"GREENCROSS AGRO CHEMICALS PRIVATE LIMITED",
"GREENCROSS CHEMISTS PHARMA PRIVATE LIMITED",
"GREENCROSS EXPORT PRIVATE LIMITED",
"GREENCUBE ENERGIES PRIVATE LIMITED",
"GREENCUBE SOLUTIONS PRIVATE LIMITED",
"GREENDAY INFOTECH PRIVATE LIMITED",
"GREENDOT HEALTH FOODS LIMITED",
"GREENEARTH BIOGAS PRIVATE LIMITED",
"GREENEARTH DEVELOPERS PRIVATE LIMITED",
"GREENEARTH INFRAVENTURES PRIVATE. LIMITED.",
"GREENEARTH ORGANIC PRODUCTS PRIVATE LIMITED",
"GREENEARTH PUBLICATIONS PRIVATE LIMITED",
"GREENEDGE AIRCONDITIONING PRIVATE LIMITED",
"GREENEDGE CAPITAL ADVISORS PRIVATE LIMITED",
"GREENEDGE ENTERPRISES PRIVATE LIMITED",
"GREENEEM AGRI PRIVATE LIMITED",
"GREENER PRIVATE LIMITED",
"GREENERGY FUELS PRIVATE LIMITED",
"GREENERGY SOLAR ENTERPRISE PRIVATE LIMITED",
"GREENERGY SOLUTION PRIVATE LIMITED",
"GREENERGY WIND CORPORATION PRIVATE LIMITED",
"GREENERI PAPER TRADELINKS PRIVATE LIMITED",
"GREENERIA RENEWABLE TECHNOLOGIES PRIVATE LIMITED",
"GREENESOL POWER SYSTEMS PRIVATE LIMITED",
"GREEN-ESTEP TECHNOLOGIES PRIVATE LIMITED",
"GREENETICS INDUSTRIES PRIVATE LIMITED",
"GREENF HYGIENE FOOD PRIVATE LIMITED",
"GREENFAY FARM FOODS PRIVATE LIMITED",
"GREENFERN LEADERSHIP & STRATEGIC CONSULTING PRIVATE LIMITED",
"GREENFIELD AGRICHEM INDUSTRIES PRIVATE LIMITED",
"GREENFIELD COMMODITIES SERVICES PRIVATE LIMITED",
"GREENFIELD EXPORTS LTD",
"GREENFIELD HOUSING INDIA PRIVATE LIMITED",
"GREENFIELD NURSERY AND LANDSCAPES PRIVATE LIMITED",
"GREENFIELDS DERIVATIVES PRIVATE LIMITED",
"GREENFIELDS PETRICHOR PRIVATE LIMITED",
"GREENFIELDS PUBLIC SCHOOL",
"GREENFIRST POWER VENTURES PRIVATE LIMITED",
"GREENFIZZ BEVERAGES PRIVATE LIMITED",
"GREENFOREST HERBOTEK PRIVATE LIMITED",
"GREENFUEL ENERGY SOLUTIONS PRIVATE LIMITED",
"GREENFUEL SUPPLIES PRIVATE LIMITED",
"GREENGAIN ENERGY SOLUTIONS PRIVATE LIMITED",
"GREENGANGA INFRACITY PRIVATE LIMITED",
"GREENGLOBE AUTOTECH PRIVATE LIMITED",
"GREENGLOBE EXPORTS INDIA PRIVATE LIMITED",
"GREENGOLD SALES PRIVATE LIMITED",
"GREENHAWK FACILITY MANAGEMENT PRIVATE LIMITED",
"GREENHEART FLOORS PRIVATE LIMITED",
"GREENHECK INDIA PRIVATE LIMITED",
"GREENHIGHWAY INFRA PRIVATE LIMITED",
"GREENHORIZON INFRAESTATE PRIVATE LIMITED",
"GREENHOUSE CARDAMOM MARKETING INDIA PRIVATE LIMITED",
"GREENHOUSE INFOCOM PRIVATE LIMITED",
"GREENHOUSE VENTURES PRIVATE LIMITED",
"GREENICHE HEALTHCARE",
"GREENICHE HERBAL PRODUCTS PRIVATE LIMITED",
"GREENIFYI ECO TECHNOLOGIES PRIVATE LIMITED",
"GREENIKK SUSTAINABLE VENTURES PRIVATE LIMITED",
"GREENIMPACT SOLAR POWER (SHIROL) PRIVATE LIMITED",
"GREENINNOVIOR TECHNOSOLUTIONS PRIVATE LIMITED",
"GREENISH (INDIA) TRADES PRIVATE LIMITED",
"GREENITCO TECHNOLOGIES PRIVATE LIMITED",
"GREENITY LOGISTICS PRIVATE LIMITED",
"GREENITY SOFTWARE SOLUTIONS PRIVATE LIMITED",
"GREENIUM INDUSTRIES PRIVATE LIMITED",
"GREENIVA RECYCLER PRIVATE LIMITED",
"GREENIX TECHNOLOGIES LLP",
"GREENIZON AGRITECH CONSULTANCY PRIVATE LIMITED",
"GREENJASPER FABRICS PRIVATE LIMITED",
"GREENJASPER TEXTILES PRIVATE LIMITED",
"GREENJOULES PRIVATE LIMITED",
"GREENKASHI BIO ENERGY PRIVATE LIMITED",
"GREENKEM ORGANICS PRIVATE LIMITED",
"GREENKO AGAR WIND POWER PRIVATE LIMITED",
"GREENKO ANANTAPUR WIND POWER PRIVATE LIMITED",
"GREENKO ANUBHAV HYDEL POWER PRIVATE LIMITED",
"GREENKO ASTHA PROJECTS (INDIA) PRIVATE LIMITED",
"GREENKO AT HYDRO PRIVATE LIMITED",
"GREENKO BAGEWADI WIND ENERGIES PRIVATE LIMITED",
"GREENKO BERCHA WIND POWER PRIVATE LIMITED",
"GREENKO CHARANKA SOLAR ENERGY PRIVATE LIMITED",
"GREENKO CIMARON CONSTRUCTIONS PRIVATE LIMITED",
"GREENKO DND WIND POWER PRIVATE LIMITED",
"GREENKO ENERGIES PRIVATE LIMITED",
"GREENKO ENERGY PROJECTS PRIVATE LIMITED",
"GREENKO GODAVARI POWER PROJECTS PRIVATE LIMITED",
"GREENKO HATKOTI ENERGY PRIVATE LIMITED",
"GREENKO HIM KAILASH HYDRO POWER PRIVATE LIMITED",
"GREENKO HYDRO PROJECTS PRIVATE LIMITED",
"GREENKO JAISALMER WIND ENERGY PRIVATE LIMITED",
"GREENKO MAHA WIND ENERGY PRIVATE LIMITED",
"GREENKO MAMATKHEDA WIND PRIVATE LIMITED",
"GREENKO RAYALA WIND POWER PRIVATE LIMITED",
"GREENKO SIRONJ WIND POWER PRIVATE LIMITED",
"GREENKO SOLAR ENERGY PRIVATE LIMITED",
"GREENKO SOLAR POWER (DHARMAVARAM) LIMITED",
"GREENKO SRI SAI KRISHNA HYDRO ENERGIES PRIVATE LIMITED",
"GREENKO SUVAAN ENERGY PRIVATE LIMITED",
"GREENKO TARELA POWER PRIVATE LIMITED",
"GREENKO TEJASSARNIKA HYDRO ENERGIES PRIVATE LIMITED",
"GREENKO URAVAKONDA WIND POWER PRIVATE LIMITED",
"GREENLAB DIAMONDS LLP",
"GREENLABS SOLUTIONS PRIVATE LIMITED",
"GREENLAM INDUSTRIES LIMITED",
"GREENLANCE ENERGY PRIVATE LIMITED",
"GREENLAND AMERICA INC",
"GREENLAND COMMODITIES PVT LTD",
"GREENLAND EXPORTS PRIVATE LIMITED",
"GREENLAND FINANCE AND LEASING PRIVATE LIMITED",
"GREENLAND HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED",
"GREENLAND INVESTMENT MANAGEMENT LLP",
"GREENLAND MOTORS",
"GREENLAND PAPER MILLS LIMITED",
"GREENLAND PARTICLE BOARDS PRIVATE LIMITED",
"GREENLAND TEA INDUSTRIES PRIVATE LIMITED",
"GREENLAND TILES LIMITED",
"GREENLAND TOWERS PVT LTD",
"GREENLANDS A&M CORPORATION",
"GREENLAWN HOSPITALITY PRIVATE LIMITED",
"GREENLEAF CORPORATE SERVICES PRIVATE LIMITED",
"GREENLEAF EXTRACTIONS PRIVATE LIMITED",
"GREENLEAF IT CONSULTING PRIVATE LIMITED",
"GREENLEAF RESORTS PRIVATE LIMITED",
"GREENLET RECYCLERS PRIVATE LIMITED",
"GREENLEY HI-TECH ENGINEERS PRIVATE LIMITED",
"GREENLIGHT PLANET INDIA PRIVATE LIMITED",
"GREENLIGHT TECHNOLOGIES PRIVATE LIMITED",
"GREENLIME TRADES PRIVATE LIMITED",
"GREENLINE DEALMARK PRIVATE LIMITED",
"GREENLINE ECOFAB PRIVATE. LIMITED GEPL",
"GREENLINE ENERGY EQUIPMENTS PRIVATE LIMITED",
"GREENLINE MOBILITY SOLUTIONS LIMITED",
"GREENLINE TEA & EXPORTS LIMITED",
"GREENLINE TRACON PVT LTD",
"GREENMAN LIFE SCIENCE PRIVATE LIMITED",
"GREENMANIA AGROHERBS PRIVATE LIMITED",
"GREENMARK DEVELOPERS PRIVATE LIMITED",
"GREENMAX EXPORTS PRIVATE LIMITED",
"GREENMAYUR AGRIFRESH PRIVATE LIMITED",
"GREENMEADOWS FEEDS AND FOODS PRIVATE LIMITED",
"GREENMEK HORTITECH PRIVATE LIMITED",
"GREENMILE SKILLWILL LLP",
"GREENMOUNT SPICES PRIVATE LIMITED",
"GREENNETIC RENEWABLE PRIVATE LIMITED",
"GREENNSURE POWER PRIVATE LIMITED",
"GREENO TECH SOLUTIONS PRIVATE LIMITED",
"GREENOBIN RECYCLING PRIVATE LIMITED",
"GREENOCARE SOLUTIONS PRIVATE LIMITED",
"GREENOCEAN TECHNOLOGY PRIVATE LIMITED",
"GREENOMICS TECHNOLOGIES PRIVATE LIMITED",
"GREENOMICS TRADING PRIVATE LIMITED",
"GREENONESTA INDIA PRIVATE LIMITED",
"GREENOVATIVE ENERGY PRIVATE LIMITED",
"GREENOVERA INDIA PRIVATE LIMITED",
"GREENOVOC SPECIALTY COATINGS PRIVATE LIMITED",
"GREENOZ VENTILATION SYSTEM PRIVATE LIMITED",
"GREENPACK INDIA PRIVATE LIMITED",
"GREENPACK INDUSTRIES",
"GREENPANEL INDUSTRIES LIMITED",
"GREENPARK AUTOTRACK PRIVATE LIMITED",
"GREENPARK EXPORTS PRIVATE LIMITED",
"GREENPARK HOSPTALITY SERVICES PRIVATE LIMITED",
"GREENPARK HOTELS AND RESORTS LIMITED",
"GREENPAY OUTSOURCING SERVICES PRIVATE LIMITED",
"GREENPEDIA BIKE SHARE PRIVATE LIMITED",
"GREENPETAL INFRA & RESOURCES PRIVATE LIMITED",
"GREENPHYLL EXIM PRIVATE LIMITED",
"GREENPIECE LANDSCAPES INDIA PRIVATE LIMITED",
"GREENPILL RENEWABLE ENERGY PRIVATE LIMITED",
"GREENPLY INDUSTRIES LIMITED",
"GREENPLY INDUSTRIES LTD",
"GREENPOLE POWER SOLUTIONS INDIA PRIVATE LIMITED",
"GREENPRINT TECHNOLOGIES PRIVATE LIMITED",
"GREENPRO CONSTRUCTIONS PRIVATE LIMITED",
"GREENPRO INDIA CONSULTANTS PRIVATE LIMITED",
"GREENPRO VENTURES PRIVATE LIMITED",
"GREENRAY GRANITO PRIVATE LIMITED",
"GREENROOF SOLAR PRIVATE LIMITED",
"GREENROOTS RENEWABLE ENERGY PRIVATE LIMITED",
"GREENROSE COMPUTER SERVICES PRIVATE LIMITED",
"GREENS BIO INDUSTRIES AND ENGINEERING (OPC) PRIVATE LIMITED",
"GREENS GEARS PRIVATE LIMITED",
"GREENS POWER EQUIPMENT INDIA PRIVATE LIMITED",
"GREENS SURGICALS PRIVATE LIMITED",
"GREENSANGAADI AGRO PRIVATE LIMITED",
"GREENSAT INNOVATION LABS PRIVATE LIMITED",
"GREENSBORO POLYCHEM PRIVATE LIMITED",
"GREENSCAPE DEVELOPERS PRIVATE LIMITED",
"GREENSCAPE ECO MANAGEMENT PRIVATE LIMITED",
"GREENSEA INDUSTRIES PRIVATE LIMITED",
"GREENSENSE ENERGY SYSTEMS PRIVATE LIMITED",
"GREENSHANK INFRASTRUCTURE PRIVATE LIMITED",
"GREENSHOPGO INDIA PRIVATE LIMITED",
"GREENSIGNAL BIO PHARMA PRIVATE LIMITED",
"GREENSKY DYECHEM LIMITED",
"GREENSOFT SOLUTIONS PRIVATE LIMITED",
"GREENSOL RENEWABLE POWER PRIVATE LIMITED",
"GREENSOLE FOOTWEAR PRIVATE LIMITED",
"GREENSPACE HOUSING AND ENGINEERS PRIVATE LIMITED",
"GREENSPAN AGRI-TECH PRIVATE LIMITED",
"GREENSPECIALITIES PRIVATE LIMITED",
"GREENSTAR APPLIANCES INDIA PRIVATE LIMITED",
"GREENSTAR FERTILIZERS LIMITED",
"GREENSTAR IRRIGATION & EQUIPMENTS PRIVATE LIMITED",
"GREENSTAR LANDSCAPE PRIVATE LIMITED",
"GREENSTAR RESEARCH AND DEVELOPMENT INDIA PRIVATE LIMITED",
"GREENSTARLINE UDYOG PRIVATE LIMITED",
"GREENSTATE FOREX ADVISORY PRIVATE LIMITED",
"GREENSTONE BUILDING PRODUCTS PRIVATE LIMITED",
"GREENSTONE ENTERPRISE PRIVATE LIMITED",
"GREENSTONE INVESTMENTS PRIVATE LIMITED",
"GREENTECH AGRISECTOR PRIVATE LIMITED",
"GREENTECH CREATIONS PRIVATE LIMITED",
"GREENTECH ENVIRON MANAGEMENT PRIVATE LIMITED",
"GREENTECH INDUSTRIES INDIA PRIVATE LIMITED",
"GREENTECH INFRA PRIVATE LIMITED",
"GREENTECH INFRATEL PRIVATE LIMITED",
"GREENTECH IT CITY PRIVATE LIMITED",
"GREENTECH ITS TRANSPORT SOLUTIONS SIMPLIFIED",
"GREENTECH KNOWLEDGE SOLUTIONS PRIVATE LIMITED",
"GREENTECH LABORATORIES PRIVATE LIMITED",
"GREENTECH MEGA FOOD PARK PRIVATE LIMITED",
"GREENTECH MEGAWATT PRIVATE LIMITED",
"GREENTECH MINERALS PRIVATE LIMITED",
"GREENTECH POWER PRIVATE LIMITED",
"GREENTECH SUNSHINE PRIVATE LIMITED",
"GREENTECH UPVC INDIA PRIVATE LIMITED",
"GREENTECH WIND ENERGY SERVICES PRIVATE LIMITED",
"GREENTEK CONTRACTS PRIVATE LIMITED",
"GREENTEK INDIA LIMITED",
"GREENTEK INDIA PRIVATE LIMITED",
"GREENTEK NORTHERN INDIA PRIVATE LIMITED",
"GREENTEK REMAN PRIVATE LIMITED",
"GREENTHINK VENTURES PRIVATE LIMITED",
"GREENTOKRI FARMS PRIVATE LIMITED",
"GREENTORUS ORGANICS PRIVATE LIMITED",
"GREENTREE ADVISORY SERVICES PRIVATE LIMITED",
"GREENTREE BUILDING ENERGY PRIVATE LIMITED",
"GREENTREE FRESH PRODUCE PRIVATE LIMITED",
"GREENTREE STUD & AGRICULTURAL FARMS PRIVATE LIMITED.",
"GREENTURN CLEAN AND WASTE ENERGY PRIVATE LIMITED",
"GREENUP FARMER PRODUCER COMPANY LIMITED",
"GREENVAC SOLUTIONS PRIVATE LIMITED",
"GREENVALE ECO PRODUCTS PRIVATE LIMITED",
"GREENVALLEY INFRALAND PRIVATE LIMITED",
"GREENVENT ACOUSTIC PRIVATE LIMITED",
"GREENVIEW HEALTH CARE PRIVATE LIMITED",
"GREENVIEW TEA CO PVT LTD",
"GREENVIRO INFRATECH PRIVATE LIMITED",
"GREENVIRONMENT INNOVATION & MARKETING INDIA PRIVATE LIMITED",
"GREENVISION TECHNOLOGIES PRIVATE LIMITED",
"GREENVISION TRADERS PRIVATE LIMITED",
"GREENWASH SERVICES PRIVATE LIMITED",
"GREENWATT GLOBAL VENTURES PRIVATE LIMITED",
"GREENWAVE PRODUCTS PRIVATE LIMITED",
"GREENWAVE SOLUTIONS PRIVATE LIMITED",
"GREENWAVE TECHNOLOGIES INDIA PRIVATE LIMITED",
"GREENWAVE TRADERS PRIVATE LIMITED",
"GREENWAY CLOTHINGS INDIA PRIVATE LIMITED",
"GREENWAY GRAMEEN INFRA PRIVATE LIMITED",
"GREENWAY HEALTH INDIA PRIVATE LIMITED",
"GREENWAY MODERN SCHOOL",
"GREENWAY MODERN SENIOR SECONDARY SCHOOL",
"GREENWAY MULTI-VENTURES PRIVATE LIMITED",
"GREENWAY TRADECOM LIMITED",
"GREENWAY-MODERN-SCHOOL",
"GREENWAYS TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"GREENWELL RENEWABLES PRIVATE LIMITED",
"GREENWELL SPECIALTY HEALTHCARE PRIVATE LIMITED",
"GREENWEY CREATION PRIVATE LIMITED",
"GREENWHEELS AUTOMOBILE PRIVATE LIMITED",
"GREENWICH MERIDIAN LOGISTICS INDIA PRIVATE LIMITED",
"GREENWINGS INNOVATIVE FINANCE PRIVATE LIMITED",
"GREENWIRE EARTH CONDUCTORS PRIVATE LIMITED",
"GREENWIRE POWER SOLUTIONS PRIVATE LIMITED",
"GREENWIRE TECHNOLOGIES AND CONSULTANTS PRIVATE LIMITED",
"GREENWONDER HEALTHY FOOD CHAIN PRIVATE LIMITED",
"GREENWOOD HIGH SCHOOL",
"GREENWOOD HIGH TRUST",
"GREENWOOD PESTICIDES PRIVATE LIMITED",
"GREENWOOD RESORTS PRIVATE LIMITED",
"GREENWOODS EDU FACILITIES PRIVATE LIMITED",
"GREENWOODS HOSPITALITY PRIVATE LIMITED",
"GREENWOODS SPARKING EDUCATION PRIVATE LIMITED",
"GREENWORLD CONSTRUCTION PRIVATE LIMITED",
"GREENWORLD DEVELOPERS PRIVATE LIMITED",
"GREENWORLD INFRASTRUCTURES (MUMBAI) PRIVATE LIMITED",
"GREENWORLD SOLARWARES PRIVATE LIMITED",
"GREENWORTH INFRASTRUCTURES PRIVATE LIMITED",
"GREENYANA SUNSTREAM PRIVATE LIMITED",
"GREENZ PROJECTS PRIVATE LIMITED",
"GREENZEN BIO PVT LTD",
"GREENZEST SOLAR PRIVATE LIMITED",
"GREENZEST SUN PARK PRIVATE LIMITED",
"GREENZON RECYCLING PRIVATE LIMITED",
"GREENZONE GRANITO PRIVATE LIMITED",
"GREENZZ ENVIROTECH SOLUTIONS",
"GREESHMA FOODS PRIVATE LIMITED",
"GREESHMAM RESORTS PRIVATE LIMITED",
"GREET TECHNOLOGIES PRIVATE LIMITED",
"GREET WELL CARDS [INDIA] PRIVATE LIMITED",
"GREETING MARKETING PRIVATE LIMITED",
"GREETINGS KNIT WEARS",
"GREETS BUILDING SERVICES PRIVATE LIMITED",
"GREETWELL PROPERTIES PRIVATE LIMITED",
"GREEVA SOFTWARE SOLUTIONS PRIVATE LIMITED",
"GREFUEL PRIVATE LIMITED",
"GREINER BIO-ONE INDIA PRIVATE LIMITED",
"GREINER PACKAGING INDIA PRIVATE LIMITED",
"GREKON INFRATECH PRIVATE LIMITED",
"GREMALTES REFERRAL HOSPITAL",
"GRENEITY INFOCOM SERVICE PRIVATE LIMITED",
"GRENEL POWERS PRIVATE LIMITED",
"GRENERA NUTRIENTS PRIVATE LIMITED",
"GRENESIIS CONSTRO PRIVATE LIMITED",
"GRENIC TILES PRIVATE LIMITED",
"GRENOTECH POWER PRIVATE LIMITED",
"GRENOVE SERVICES PRIVATE LIMITED",
"GRENTECH INDIA PRIVATE LIMITED",
"GRENTEX & COMPANY PRIVATE LIMITED",
"GRENVO LUBETECH PRIVATE LIMITED",
"GRENZO FARMS PRIVATE LIMITED",
"GREOTS LIFESCIENCES PRIVATE LIMITED",
"GREP RUBY WEBTECH PRIVATE LIMITED",
"GREPIX INFOTECH PRIVATE LIMITED",
"GRES DESIGN AND DECOR STUDIOS PRIVATE LIMITED",
"GRESCASA INDIA PRIVATE LIMITED",
"GRESHMA FINVEST PRIVATE LIMITED",
"GRESHMA SHARES &STOCKS LIMITED",
"GRESS CERAMICA PRIVATE LIMITED",
"GRETA DOOR SOLUTION PRIVATE LIMITED",
"GRETA ENERGY LIMITED",
"GRETEX CORPORATE SERVICES LIMITED",
"GRETEX IMPEX (INDIA) PVT LTD",
"GRETEX INDUSTRIES LIMITED",
"GRETEX SHARE BROKING LIMITED",
"GRETIS INDIA PRIVATE LIMITED",
"GREVES PROTECTION MANAGEMENT PRIVATE LIMITED",
"GREVIS HEALTHCARE PRIVATE LIMITED",
"GREW INDUSTRIES PRIVATE LIMITED",
"GREWAL EYE INSTITUTE PRIVATE LIMITED",
"GREWAL HOTELS PVT LTD",
"GREWAL ROLLERS PVT LTD",
"GREWAL TRADING COMPANY PRIVATE LIMITED",
"GREWSYS TECHNOLOGIES PRIVATE LIMITED",
"GREXIT SOFTWARE PRIVATE LIMITED",
"GREY & WHITE HR CONSULTANTS PRIVATE LIMITED",
"GREY B RESEARCH PRIVATE LIMITED",
"GREY CAPS INDIA PRIVATE LIMITED",
"GREY CHAIN TECHNOLOGY PRIVATE LIMITED",
"GREY EARTH CONSTRUCTIONS PRIVATE LIMITED",
"GREY GRASS (INDIA) PRIVATE LIMITED",
"GREY HEAD MEDIA PRIVATE LIMITED",
"GREY HEADS FOREX PRIVATE LIMITED",
"GREY IRON FOUNDRY JABALPUR",
"GREY MATTER",
"GREY MATTER ACADEMICS PRIVATE LIMITED",
"GREY MATTER ENTERTAINMENT PRIVATE LIMITED",
"GREY MATTER RESOURCES PRIVATE LIMITED",
"GREY MATTER ROBOTICS PRIVATE LIMITED",
"GREY NODULES INDUCTOCAST PRIVATE LIMITED",
"GREY ORANGE INDIA PRIVATE LIMITED",
"GREY SIM LEARNINGS FOUNDATION",
"GREY SWIFT PRIVATE LIMITED",
"GREY TICKET PRIVATE LIMITED",
"GREY WATER SOLUTIONS PRIVATE LIMITED",
"GREY WORLDWIDE (INDIA) PRIVATE LIMITED",
"GREYANAS INDUSTRIES PRIVATE LIMITED",
"GREYATOM EDUTECH PRIVATE LIMITED",
"GREYCAMPUS EDUTECH PRIVATE LIMITED",
"GREYCAPS INDIA PRIVATE LIMITED",
"GREYCELLS LIFESCIENCES PRIVATE LIMITED",
"GREYCELLS RESEARCH SERVICES PRIVATE LIMITED",
"GREYCELLS18 MEDIA LIMITED",
"GREYFALCON HEALTHCARE PRIVATE LIMITED",
"GREYFORCE INDUSTRIES LIMITED",
"GREYHOUND ENGINEERS INDIA PRIVATE LIMITED",
"GREYLALIT INFRA PRIVATE LIMITED",
"GREYM MARINE PRIVATE LIMITED",
"GREYMATTERS COMMUNICATIONS & CONSULTING PRIVATE LIMITED",
"GREYNIUM INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"GREYS EXIM PRIVATE LIMITED",
"GREYSELL MARKETING PROMOTIONS PRIVATE LIMITED",
"GREYSOFT SOLUTIONS PRIVATE LIMITED",
"GREYSPRINGS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"GREYSTONE BUILDWELL PRIVATE LIMITED",
"GREYSTONE ENERGY SYSTEMS PRIVATE LIMITED",
"GREYSTONE IMPEX PRIVATE LIMITED",
"GREYSTONE MARKETING PRIVATE LIMITED",
"GREYTIP SOFTWARE PRIVATE LIMITED",
"GREYTRIX INDIA PRIVATE LIMITED",
"GREYY ELEPHANT IDEAZ PRIVATE LIMITED",
"GREZON CRAFTOPACK PRIVATE LIMITED",
"GRG ACCESSORIES LIMITED",
"GRG ATM PVT LTD",
"GRG COTSPIN LIMITED",
"GRG ENVIRO SOUND SOLUTIONS PRIVATE LIMITED",
"GRG FARMS PRIVATE LIMITED",
"GRG FINE FOODS PRIVATE LIMITED",
"GRG GLOBAL TEXTILES LIMITED",
"GRG PIPES INDIA PRIVATE LIMITED",
"GRG POLYDYNAMICS PRIVATE LIMITED",
"GRG POLYTECHNIC COLLEGE",
"GRHOMBUS TECHNOLOGIES PRIVATE LIMITED",
"GRI TOWERS INDIA PRIVATE LIMITED",
"GRIC CLOTHING PRIVATE LIMITED",
"GRID 2 CHIP PRIVATE LIMITED",
"GRID CONTROLLER OF INDIA LIMITED",
"GRID DESIGN SOLUTIONS PRIVATE LIMITED",
"GRID ENGINEERS PRIVATE LIMITED",
"GRID EQUIPMENTS PRIVATE LIMITED",
"GRID FLOORS PRIVATE LIMITED",
"GRID INFOCOM PRIVATE LIMITED",
"GRID INFRACON PRIVATE LIMITED",
"GRID INFRATECH PRIVATE LIMITED",
"GRID INTERIORS PRIVATE LIMITED",
"GRID LOGIC SOFTWARE PRIVATE LIMITED",
"GRIDAGE TECHNOLOGIES PRIVATE LIMITED",
"GRIDCO LIMITED",
"GRIDLINES INDIA PRIVATE LIMITED",
"GRIDLOGIC GAMES PRIVATE LIMITED",
"GRIDLOGICS TECHNOLOGIES PRIVATE LIMITED",
"GRIEBS ORGANICS PRIVATE LIMITED",
"GRIFFIN INTELLECTUAL PROPERTY SERVICES PRIVATE LIMITED",
"GRIFFIN PRODUCTS PRIVATE LIMITED",
"GRIFFITH FOODS PRIVATE LIMITED",
"GRIFFYN ROBOTECH PRIVATE LIMITED",
"GRIFOLS INDIA HEALTHCARE PRIVATE LIMITED",
"GRIH BHOOMI NIRMAN PRIVATE LIMITED",
"GRIH LAKSHMI CAPITAL FINANCE PRIVATE LIMITED",
"GRIHA PRAVESH BUILDTECK PRIVATE. LIMITED.",
"GRIHA PROMOTERS PRIVATE LIMITED",
"GRIHA SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"GRIHALAKSHMI TRADING PRIVATE LIMITED",
"GRIHAM FOOD & HOTEL PRIVATE LIMITED",
"GRIHANI FABRICS INDIA PRIVATE LIMITED",
"GRIHASHAKTI STEELS PRIVATE LIMITED",
"GRIHASTHA SAVING & SERVICES PRIVATE LIMITED",
"GRIHASTHI UDYOG PRIVATE LIMITED",
"GRIHLAXMI SYNTHETICS PRIVATE LIMITED",
"GRIHO UDYOG PRIVATE LIMITED",
"GRIHUM HOUSING FINANCE LIMITED",
"GRILL SPLENDOUR SERVICES LIMITED",
"GRIM- TECH PROJECTS (I) PRIVATE LIMITED",
"GRIN PRODUCTS PRIVATE LIMITED",
"GRIND MASTER MACHINE PRIVATE LIMITED",
"GRINDCO ABRASIVES AND TOOLS PRIVATE LIMITED",
"GRINDLAYS ENGINE PARTS PRIVATE LIMITED",
"GRINDLY GASES AND PETROCHEMICALS P.LTD.",
"GRINDWELL NORTON LIMITED",
"GRINDWELL STEEL AND ALLIED PRODUCTS PRIVATE LIMITED",
"GRINFRANET SERVICES PRIVATE LIMITED",
"GRINGO ENTERTAINMENTS LLP",
"GRINIBHRIT SOLAR POWER PRIVATE LIMITED",
"GRINNTECH MOTORS AND SERVICES PRIVATE LIMITED",
"GRINTEX INDIA LIMITED",
"GRIP ENGINEERS PRIVATE LIMITED",
"GRIP IMPEX PRIVATE LIMITED",
"GRIP INTERNATIONAL PRIVATE LIMITED",
"GRIP MECHATRONICS PRIVATE LIMITED",
"GRIP NETWEB SOLUTIONS PRIVATE LIMITED",
"GRIP REALTORS PRIVATE LIMITED",
"GRIP REHABILITATION PRIVATE LIMITED",
"GRIP STRAPPING TECHNOLOGIES PRIVATE. LIMITED.",
"GRIP TECHNOLOGIES PRIVATE LIMITED",
"GRIP TIGHT PACKAGING INDIA PRIVATE LIMITED",
"GRIPEX PACKING INDIA PRIVATE LIMITED",
"GRIPHOLD TOOLS PRIVATE. LIMITED",
"GRIPIL PHARMACEUTICALS PRIVATE LIMITED",
"GRIPKING TAPES INDIA PRIVATE LIMITED",
"GRIPOTEX INDIA PRIVATE LIMITED",
"GRIPPLE HANGER & JOINER SYSTEMS (INDIA )PRIVATE LIMITED",
"GRIPPO EOAT INDIA PRIVATE LIMITED",
"GRIPTONITE GAMES INDIA PRIVATE LIMITED",
"GRIPTRONICS INDIA WIRES & CABLES PRIVATE LIMITED",
"GRIPWEL FASTENERS PRIVATE LIMITED",
"GRIPWELL ENGINEERING COMPANY PVT LTD",
"GRIPWELL FORGING & TOOLS",
"GRIPWELL MULTI TECH PRIVATE LIMITED",
"GRISAILLE ADTECH SOLUTIONS PRIVATE LIMITED",
"GRISHMA EXTRADE PRIVATE LIMITED",
"GRISHNESHWAR COTTON CORPORATION",
"GRIT AND MOXIE INFRA PRIVATE LIMITED",
"GRIT ARCHITECTURAL CONSULTANCY PRIVATE LIMITED",
"GRIT INNOVATION SOFTWARE PRIVATE LIMITED",
"GRIT RETAIL CONCEPTS PRIVATE LIMITED",
"GRITIK TECHNOLOGIES PRIVATE LIMITED",
"GRITSYS TECHNOLOGIES",
"GRITTOWIN KNOWLEDGE SERVICES PRIVATE LIMITED",
"GRITTY FOODS LLP",
"GRIVETY GLOBAL PRIVATE LIMITED",
"GRK CHEMICALS PRIVATE LIMITED",
"GRK FORGE PRIVATE LIMITED",
"GRK RESEARCH LABORATORIES PRIVATE LIMITED",
"GRK TRANSPORTS PRIVATE LIMITED",
"GRL BALAJI ENTERPRISES INDIA PRIVATE LIMITED",
"GRL CARGO MOVERS PRIVATE LIMITED",
"GRL EDIBLES PRIVATE LIMITED",
"GRL ENGINEERS PRIVATE LIMITED",
"GRL INTERNATIONAL LIMITED",
"GRM ENGINEERS PRIVATE LIMITED",
"GRM FOODKRAFT PRIVATE LIMITED",
"GRM INFRASTRUCTURE PRIVATE LIMITED",
"GRM INVESTMENT AND HOLDINGS PRIVATE LIMITED",
"GRM MET MASH PROJECTS PRIVATE LIMITED",
"GRM OVERSEAS LIMITED",
"GRM SECURITIES PRIVATE LIMITED",
"GRMAK EQUIPMENT PRIVATE LIMITED",
"GRN AUTO SALES PRIVATE LIMITED",
"GRN CONSTRUCTIONS PRIVATE LIMITED",
"GRNRM TALENT NETWORK PRIVATE LIMITED",
"GRO DIGITAL PLATFORMS LIMITED",
"GRO KIDS INTERNATIONAL PRIVATE LIMITED",
"GRO SOLAR ENERGY PRIVATE LIMITED",
"GROAG PRODUCTS PRIVATE LIMITED",
"GROB MACHINE TOOLS INDIA PRIVATE LIMITED",
"GROB TEA COMPANY LIMITED THE",
"GROBEST FEEDS CORPORATION INDIA PRIVATE LIMITED",
"G-ROC MINING AND CONSTRUCTION PRIVATE LIMITED",
"GROCERY 4 U RETAIL PRIVATE LIMITED",
"GROCERY MARKETS & SHOPS BOARD",
"GROCERY SHOP",
"GROCMART INDIA PRIVATE LIMITED",
"GROCURV PRIVATE LIMITED",
"GRODOT INFRASTRUCTURE LIMITED",
"GROFORCE INDIA LLP",
"GROFRESH AGROFOODS PRIVATE LIMITED",
"GROHE INDIA PRIVATE LIMITED",
"GROHEALTHY PROCESSORS PRIVATE LIMITED",
"GROLIER INTERNATONAL PRIVATE LIMITED",
"GROLMAN INDIA CHEMICAL PRIVATE LIMITED",
"GROMA GLOBAL LIMITED",
"GROMAX ACADEMY OF PROFESSIONAL STUDIES PRIVATE LIMITED",
"GROMAX AGRI EQUIPMENT LIMITED",
"GROMAX HEALTHCARE PRIVATE LIMITED",
"GROMAX TECHNOLOGIES PRIVATE LIMITED",
"GROMAX THERAPEUTICS PRIVATE LIMITED",
"GROMAXFORMULATIONS PRIVATE LIMITED",
"GROMOR OVERSEAS LIMITED",
"GRONEXT FUTURE PRIVATE LIMITED",
"GROOM INDIA SALON AND SPA PRIVATE LIMITED",
"GROOMING HUB INDIA PRIVATE LIMITED",
"GROOMING NATURALS PRIVATE LIMITED",
"GROOTAN TECHNOLOGIES PRIVATE LIMITED",
"GROOTS SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"GROOVE SOFTWARE PRIVATE LIMITED",
"GRORICH HORIVERT PRIVATE LIMITED",
"GROSPINZ FABZ LIMITED",
"GROSS EDUCARE PRIVATE LIMITED",
"GROSSMACHT ENGINEERS PRIVATE LIMITED",
"GROSVENOR CONSTRUCTION LLP",
"GROTECH LANDSCAPE DEVELOPERS PRIVATE LIMITED",
"GROTEK ENTERPRISES PRIVATE LIMITED",
"GROTH CONTINENTAL MANUFACTURING PRIVATE LIMITED",
"GROTTO INDIA PRIVATE LIMITED",
"GROUND CARE PRIVATE LIMITED",
"GROUND CRAFTS INFRA PRIVATE LIMITED",
"GROUND CRAFTS PRIVATE LIMITED",
"GROUND ECA3G PRIVATE LIMITED",
"GROUND INFRA TECHNOLOGY PRIVATE LIMITED",
"GROUND WATER DEPT",
"GROUND WATER RESOURCE DEPARTMENT",
"GROUNDBREAKERS TECHNOLOGIES (OPC) PRIVATE LIMITED",
"GROUNDHOGS PRIVATE LIMITED",
"GROUNDTRUTH INDIA PRIVATE LIMITED",
"GROUP 2 CARE SERVICES PRIVATE LIMITED",
"GROUP 7 GUARDS (INDIA) PRIVATE LIMITED",
"GROUP A LOGISTICS INDIA PRIVATE LIMITED",
"GROUP FIO INDIA PRIVATE LIMITED",
"GROUP HR SERVICES PRIVATE LIMITED",
"GROUP M MEDIA INDIA PRIVATE LIMITED",
"GROUP OF ENGINEERS SERVICES PRIVATE LIMITED",
"GROUP PHARMACEUTICALS LIMITED",
"GROUP R MINING AND EXPLORATION INDIA PRIVATE LIMITED",
"GROUP SURYA",
"GROUP10 TECHNOLOGIES PRIVATE LIMITED",
"GROUPE PRESIDENT ELECTRONICS INDIA PRIVATE LIMITED",
"GROUPE SEB INDIA PRIVATE LIMITED",
"GROUPL SERVICES PRIVATE LIMITED",
"GROUPNINE CONSULTING (OPC) PRIVATE LIMITED",
"GROUPON SHARED SERVICES PRIVATE LIMITED",
"GROUPON TECHNOLOGIES PRIVATE LIMITED",
"GROUPS FACILITY AND SERVICES",
"GROUPTRUE MANAGEMENT LLP",
"GROUPWARE INFORMATION SYSTEMS LIMITED",
"GROVALUE COMMODITY PRIVATE LIMITED",
"GROVE BUSINESS PRIVATE LIMITED",
"GROVE LIMITED",
"GROVE OMR PROPERTIES PRIVATE LIMITED",
"GROVEL PRECICOMP PRIVATE LIMITED",
"GROVER AGRO FOOD PRIVATE LIMITED",
"GROVER AUDIO VISUAL SARVICE",
"GROVER AUTOMOBILES PRIVATE LIMITED",
"GROVER DEVCON PRIVATE LIMITED",
"GROVER FUELS PRIVATE LIMITED",
"GROVER HANDLOOM PRIVATE LIMITED",
"GROVER HOSPITALS PRIVATE LIMITED",
"GROVER IMPEX PRIVATE LIMITED",
"GROVER INFRASTRUCTURE & PLANNER PRIVATE LIMITED",
"GROVER INTERNATIONAL",
"GROVER KNITTERS PRIVATE LIMITED",
"GROVER LIGHT SOURCE PRIVATE LIMITED",
"GROVER METALLOYS LIMITED",
"GROVER MOTORS PRIVATE LIMITED",
"GROVER STAINLESS PRIVATE LIMITED",
"GROVER TEX PRINTS PRIVATE LIMITED",
"GROVER TRADE LINKS PRIVATE LIMITED",
"GROVER ZAMPA VINEYARDS LIMITED",
"GROVERSONS INDUSTRIES PRIVATE LIMITED",
"GROVERSONS SHIPPING SERVICES PRIVATE LIMITED",
"GROVSTA PRIVATE LIMITED",
"GROVY INDIA LIMITED",
"GROW EVER STEEL (INDIA) PRIVATE LIMITED",
"GROW GREEN COIRS PRIVATE LIMITED",
"GROW INDIA VENTURES PRIVATE LIMITED",
"GROW INDIGO PRIVATE LIMITED",
"GROW MAX INDIA PRIVATE LIMITED",
"GROW MONEY CAPITAL PRIVATE LIMITED",
"GROW MORE BIO TECH PRIVATE LIMITED",
"GROW MORE IT AND SLOAR SOLUTION PRIVATE LIMITED",
"GROW PACK INDIA PRIVATE LIMITED",
"GROW SAFE CHEMICALS PRIVATE LIMITED",
"GROW TALENT COMPANY LIMITED",
"GROW WELL MERCANTILE PRIVATE LIMITED",
"GROW WELL ORGANIC AND ECO PRODUCTS PRIVATE LIMITED",
"GROW YOGA PRIVATE LIMITED",
"GROWATT ENERGY PROJECTS PRIVATE LIMITED",
"GROWBOOST TECHNO PRIVATE LIMITED",
"GROWEL FEEDS PRIVATE LIMITED",
"GROWEL FORMULATIONS PRIVATE LIMITED",
"GROWEL IMPEX PRIVATE. LIMITED",
"GROWEL PROCESSORS PRIVATE LIMITED",
"GROWEL REMEDIES LIMITED",
"GROWEL SALES PRIVATE LIMITED",
"GROWEL SECURITAS AND MANPOWER MANAGMENT SERVICES PRIVATE LIMITED",
"GROWEL SOFTECH PRIVATE LIMITED",
"GROWELL H R SOLUTIONS PRIVATE LIMITED",
"GROWELL RESOURCES AND MANAGEMENT PRIVATE LIMITED",
"GROWERS FRESH DRY FRUITS PRIVATE LIMITED",
"GROWEVER LOGISTICS PRIVATE LIMITED",
"GROWEVER POLYMERS PRIVATE LIMITED",
"GROWFAST FERTILIZER LIMITED",
"GROWFAST ORGANIC DIAMOND PRIVATE LIMITED",
"GROWFAST PLANTTECH LIMITED",
"GROWFAST SECURITIES AND CREDIT PRIVATE LIMITED",
"GROWFIN",
"GROWFINN WEALTH PRIVATE LIMITED",
"GROWGRAIN AGRO PRIVATE LIMITED",
"GROWGREEN AGRONOMICS PRODUCER COMPANY LIMITED",
"GROWHERE AGRI SOLUTIONS PRIVATE LIMITED",
"GROWIA FACILITY SERVICES PRIVATE LIMITED",
"GROWIDE FINSERVE PRIVATE LIMITED",
"GROWING CODES SOLUTIONS PRIVATE LIMITED",
"GROWING OPPORTUNITY FINANCE INDIA PRIVATE LIMITED",
"GROWING RETAIL EXCELLENCE AND TECHNOLOGY PRIVATE LIMITED",
"GROWING STARS INFOTECH PRIVATE LIMITED",
"GROWING VENTURES PRIVATE LIMITED",
"GROWINGTON VENTURES INDIA LIMITED",
"GROWINTELLI TECHNOLOGIES PRIVATE LIMITED",
"GROWLAM OFFICE PRIVATE LIMITED",
"GROWMAN RESEARCH AND CONSULTING PRIVATE LIMITED",
"GROWMANTRA MULTICARE PRIVATE LIMITED",
"GROWMATE SERVICES PRIVATE LIMITED",
"GROWMAX ENTERPRISES PRIVATE LIMITED",
"GROWMAX MEDICARE PRIVATE LIMITED",
"GROWME ENVIOUS DIGITAL SOLUTIONS PRIVATE LIMITED",
"GROWMECH INDUSTRIES PRIVATE LIMITED",
"GROWMED NUTRITION PRIVATE LIMITED",
"GROWMIN AGROTECH PRIVATE LIMITED",
"GROWMORE CERAMICS PRIVATE LIMITED",
"GROWMORE ENTERPRISES PRIVATE LIMITED",
"GROWMORE HATHWAY EQUITY RESERCH PRIVATE LIMITED",
"GROWMORE INTERNATIONAL LIMITED",
"GROWMORE INVESTMENTS AND DEVELOPERS PRIVATE LIMITED",
"GROWMORE LOGISTICS PRIVATE LIMITED",
"GROWMORE SPACE SOLUTIONS PRIVATE LIMITED",
"GROWN DIAMOND INDIA PRIVATE LIMITED",
"GROWNBURY PHARMACEUTICALS PRIVATE LIMITED",
"GROWNEX MINERALS PRIVATE LIMITED",
"GROWNEX PRIVATE LIMITED",
"GROWNMIND EDUCATIONAL SERVICES PRIVATE LIMITED",
"GROWNOUT SOLUTIONS PRIVATE LIMITED",
"GROWPRO COMPOUNDS PRIVATE LIMITED",
"GROWQ PRIVATE LIMITED",
"GROWRICH AGROTECH INDIA PRIVATE LIMITED",
"GROWRITE SUBSTRATES (INDIA) PRIVATE LIMITED",
"GROWSMART FARMER PRODUCER COMPANY LIMITED",
"GROWSMART SMB SOLUTIONS PRIVATE LIMITED",
"GROWTECH AGRI SCIENCE AND RESEARCH PRIVATE LIMITED",
"GROWTECH SEEDS (INDIA) PVT LTD",
"GROWTH 24X7 PRIVATE LIMITED",
"GROWTH ACCELERATOR TECHNOLOGIES PRIVATE LIMITED",
"GROWTH CENTRE INDIA PRIVATE LIMITED",
"GROWTH ENGINE PRIVATE LIMITED",
"GROWTH FACILITY SERVICE PRIVATE LIMITED",
"GROWTH PORTFOLIO PRIVATE LIMITED",
"GROWTH SECURITIES PRIVATE LIMITED",
"GROWTH SOLUTIONS",
"GROWTH SPURTS AND BEYOND PRIVATE LIMITED",
"GROWTH STREET SOLAR PRIVATE LIMITED",
"GROWTH WINGS MARKETING PRIVATE LIMITED",
"GROWTHALLY ADVISORS PRIVATE LIMITED",
"GROWTHENABLER INDIA PRIVATE LIMITED",
"GROWTHLIFT INVESTMENT ADVISORIES PRIVATE LIMITED",
"GROWTHPATH SOLUTIONS PRIVATE LIMITED",
"GROWTHTRACK INFO TECH PRIVATE LIMITED",
"GROWTHTREE VENTURES PRIVATE LIMITED",
"GROWTHWELL CONSULTING PRIVATE LIMITED",
"GROW-VED INDIA PRIVATE LIMITED",
"GROWVENTURE FUTURE PRIVATE LIMITED",
"GROWVY TECHNOLOGY PRIVATE LIMITED",
"GROWW ASSET MANAGEMENT LIMITED",
"GROW-WEL ENGINEERING EXPORT PRIVATE LIMITED",
"GROZ BECKERT ASIA PRIVATE LIMITED",
"GROZ ENGINEERING TOOLS PRIVATE LIMITED",
"GROZ-BECKERT CARDING INDIA PRIVATE LIMITED",
"GROZON AUTO FORGINGS PRIVATE LIMITED",
"GRP LIMITED",
"GRP SECURITY PRIVATE LIMITED",
"GRR GINNING MILLS PRIVATE LIMITED",
"GRR INDUSTRIES PRIVATE LIMITED",
"GRRAS SOLUTIONS PRIVATE LIMITED",
"GRROWWIDE BUSINESS ADVISORS PRIVATE LIMITED",
"GRS ENGINEERING PRIVATE LIMITED",
"GRS GRAPHITE PRIVATE LIMITED",
"GRS IMPEX PRIVATE LIMITED",
"GRS MOTORS PRIVATE LIMITED",
"GRS PHARMACEUTICALS PRIVATE LIMITED",
"GRS PROJECTS PRIVATE LIMITED",
"GRS SHELTERS PRIVATE LIMITED",
"GRSM FABTRADE PRIVATE LIMITED",
"GRT FUSION PRIVATE LIMITED",
"GRT HOTELS AND RESORTS PRIVATE LIMITED",
"GRT INSTITUTE OF PHARMACEUTICAL EDUCATION AND RESEARCH",
"GRT JEWELLERS INDIA PRIVATE LIMITED",
"GRT LOGISTICS (DELHI) PRIVATE LIMITED",
"GRTC EQUIPMENTS PRIVATE LIMITED",
"GRTM INDUSTRIES PRIVATE LIMITED",
"GRUBSTAKE INITIATIVES PRIVATE LIMITED",
"GRUESS AGRISERVE PRIVATE LIMITED",
"GRUH FINANCE LIMITED",
"GRUHA IBC PRIVATE LIMITED",
"GRUHAM DEVELOPERS PRIVATE LIMITED",
"GRUHAM ICON",
"GRUHASHILPI CONSTRUCTIONS PRIVATE LIMITED",
"GRUHLAXMI LIFE SPACE PRIVATE LIMITED",
"GRUN UMWELT ENERGY PRIVATE LIMITED",
"GRUNDFOS PUMPS INDIA PRIVATE LIMITED",
"GRUNE DESIGNS PRIVATE LIMITED",
"GRUNER INDIA PRIVATE LIMITED",
"GRUNLABS INNOVATES PRIVATE LIMITED",
"GRUNMECH TECHNOLOGIES PRIVATE LIMITED",
"GRUPO ANTOLIN CHAKAN PRIVATE LIMITED",
"GRUPO ANTOLIN INDIA PRIVATE LIMITED",
"GRUPO COSMOS INDIA PRIVATE LIMITED",
"GRUPO WISCO INDIA PRIVATE LIMITED",
"GRUPPO BIOKIMICA INDIA PRIVATE LIMITED",
"GRV BISCUITS PRIVATE LIMITED",
"GRV JUNCTION AGRITECH PRIVATE LIMITED",
"GRV KREATIONS PRIVATE LIMITED",
"GRV SALVEX PRIVATE LIMITED",
"GRV SPINTEX PRIVATE LIMITED",
"GRV STEELS PRIVATE LIMITED",
"GRV VENTURES PRIVATE LIMITED",
"GRYPHON CERAMICS PRIVATE LIMITED",
"GRYTFIT TECH PRIVATE LIMITED",
"GS AUTOMAX PRIVATE LIMITED",
"GS AUTOWORLD PRIVATE LIMITED",
"GS BUILDERS & CONTRACTORS PRIVATE LIMITED",
"GS CALTEX INDIA PRIVATE LIMITED",
"GS CONTROL PRIVATE LIMITED",
"GS COOLING TOWERS & COMPONENTS PRIVATE LIMITED",
"GS DIGITAL TECHNOLOGY PRIVATE LIMITED",
"GS ENGINEERING & CONSTRUCTION DELHI PRIVATE LIMITED",
"GS ENGINEERING & CONSTRUCTION MUMBAI PRIVATE LIMITED",
"GS ENGITECH PRIVATE LIMITED",
"GS FOODSTUDIO PRIVATE LIMITED",
"GS GLOBAL VENTURES PRIVATE LIMITED",
"GS HOSPITAL",
"GS INFOVISION PVT LTD",
"GS INTERNATIONAL PRIVATE LIMITED",
"GS MAHANAGAR CO OP BANK LTD",
"GS MALLS PRIVATE LIMITED",
"GS MANAGEMENT SERVICES PRIVATE LIMITED",
"GS MEDICAL COLLEGE & HOSPITAL",
"GS MOTORS PRIVATE LIMITED",
"GS PEB AND CIVIL WORKS PRIVATE LIMITED",
"GS PROFESSIONAL MANAGEMENT SER",
"GS REWARDS & LOYALTY SOLUTIONS P LIMITED",
"GS SHETTY INTERNATIONAL SCHOOL",
"GS STEEL TRADING PRIVATE LIMITED",
"GS TECHNO INNOVATIONS PRIVATE LIMITED",
"GS WORLD IAS INSTITUTE",
"GSA FOREX AND TRAVELS PRIVATE LIMITED",
"GSA INDUSTRIES",
"GSA ISPAT PRIVATE LIMITED",
"GSA RETAIL LIMITED",
"GSA SURGICAL & MEDICINES PRIVATE LIMITED",
"GSAC PRIVATE LIMITED",
"GSAR AMUSEMENT PARK PRIVATE LIMITED",
"GSAS MICRO SYSTEMS PRIVATE LIMITED",
"G-SAT INTERNATIONAL PRIVATE LIMITED",
"GSB CAPITAL MARKETS LIMITED",
"GSB CONSTRUCTIONS PRIVATE LIMITED",
"GSB FINANCE LIMITED",
"GSB HOSPITALITY PRIVATE LIMITED",
"GSB INFRA & REALTORS PRIVATE LIMITED",
"GSB SECURITIES PRIVATE LIMITED",
"GSB TEXTEC PRIVATE LIMITED",
"GSBA BUILDERS PRIVATE LIMITED",
"GSBE SOLAR PRIVATE LIMITED",
"GSC ENERGY SOLUTIONS PRIVATE LIMITED",
"GSC GLASS PRIVATE LIMITED",
"GSC PROPERTY 2 LLP",
"GSC TECHNOLABS PRIVATE LIMITED",
"GSCARD KHETI BANK",
"GSCC AUDITS & CERTIFICATIONS PRIVATE LIMITED",
"GSCI SERVICES PRIVATE LIMITED",
"GSCO INFRASTRUCTURE PRIVATE LIMITED",
"GSD CONSTRUCTIONS INDORE PRIVATE LIMITED",
"GSD TECH19 PRIVATE LIMITED",
"GSD TRADING AND FINANCIAL SERVICES PVT LTD",
"GSE FILTER PRIVATE LIMITED",
"GSE RENEWABLES INDIA PRIVATE LIMITED",
"GSE SUPPORT INDIA PRIVATE LIMITED",
"GSEC LIMITED",
"GSEC LOGISTICS LIMITED",
"GSEVEN COMPUTER BUSINESS PRIVATE LIMITED",
"GSF STEELS PRIVATE LIMITED",
"GSFC AGROTECH LIMITED",
"GSFC MEDICAL COLLEGE",
"GSFG MICROLOG PRIVATE LIMITED",
"GSG CONSTRUCTIONS PRIVATE. LIMITED.",
"GSG CONSULTING SERVICES PRIVATE LIMITED",
"GSG INTERNATIONAL S P A INDIA BRANCH OFFICE",
"GSG LOGISTICS PRIVATE LIMITED",
"GSG READYMIX CONCRETE PRIVATE LIMITED",
"GSH (INDIA) PRIVATE LIMITED",
"GSH FACILITIES MANAGEMENT SERVICES PRIVATE LIMITED",
"GSH UTILITIES SERVICES PRIVATE LIMITED",
"GSHARP MEDIA PRIVATE LIMITED",
"GSI ENGINEERING PRIVATE LIMITED",
"GSI ENTERPRISES PRIVATE LIMITED",
"GSI LOGISTICS PRIVATE LIMITED",
"GSIA INDIA PRIVATE LIMITED",
"GSJ ENVO LIMITED",
"GSK ENTERPRISES PRIVATE LIMITED",
"GSK ESTRUCTURAL INDIA PRIVATE LIMITED",
"GSK FABTECH (INDIA) PRIVATE LIMITED",
"GSK INDIA GLOBAL SERVICES PRIVATE LIMITED",
"GSK INDUSTRIES PRIVATE LIMITED",
"GSK LOGISTIC PRIVATE LIMITED",
"GSK PHARMA INDIA PRIVATE LIMITED",
"GSK POWER TECH PRIVATE LIMITED",
"GSK SOLUTIONS INDIA PRIVATE LIMITED",
"GSK TECHNOLOGIES PRIVATE LIMITED",
"GSK WATER ENVIRO PRIVATE LIMITED",
"GSKR BUSINESS SERVICES PRIVATE LIMITED",
"GSKS FOOD FLAVOURS PRIVATE LIMITED",
"GSL ASSOCIATES PRIVATE LIMITED",
"GSL EDUCATIONAL SOCIETY",
"GSL FREIGHT PRIVATE LIMITED",
"GSL LOGISTICS INDIA PRIVATE LIMITED",
"GSL TEXTILE INDIA PRIVATE LIMITED",
"GSM COTSPIN PRIVATE LIMITED",
"GSM MEGA INFRASTRUCTURES PRIVATE LIMITED",
"GSM PHARMA PRIVATE LIMITED",
"GSM PLUS INDIA",
"GSM SECURITY SOLUTIONS PRIVATE LIMITED",
"GSM SHIPPING AND LOGISTICS PRIVATE LIMITED",
"GSM SOLUTION",
"GSM TECHNOLOGIES PRIVATE LIMITED",
"GSN GAMES INDIA PRIVATE LIMITED",
"GSN GLOBAL FILMS PRIVATE LIMITED",
"GSN LIFE SCIENCES PRIVATE LIMITED",
"GSN UDYOG PRIVATE LIMITED",
"GSN WORLDWIDE LOGISTICS LLC",
"GSNR RICE INDUSTRIES PRIVATE LIMITED",
"GSNSUBH MERCHANDISE PRIVATE LIMITED",
"G'SONS RETAIL PRIVATE LIMITED",
"GSOT SOFTWARE SERVICES PRIVATE LIMITED",
"GSOURCE TECHNOLOGIES PRIVATE LIMITED",
"GSP CROP SCIENCE PRIVATE LIMITED",
"GSP DYES AND CHEMICALS PRIVATE LIMITED",
"GSP EDUCATION SERVICES PRIVATE LIMITED",
"GSP HUMAN RESOURCE PRIVATE LIMITED",
"GSP IMPEX PRIVATE LIMITED",
"GSP INTEGRATED LOGISTICS PRIVATE LIMITED",
"GSP LABELS PRIVATE LIMITED",
"GSP PILING CONSTRUCTIONS PRIVATE LIMITED",
"GSPAN AUTOMATION TECHNOLOGIES LLP",
"GSPC (JPDA) LIMITED",
"GSPC ENERGY LIMITED",
"GSPC LNG LIMITED",
"GSPC PIPAVAV POWER COMPANY LIMITED",
"GSPEED ECOM SOLUTIONS (OPC) PRIVATE LIMITED",
"GSPHARMACEUTICAL DISTRIBUTORS PRIVATE LIMITED",
"GSPL INDIA GASNET LIMITED",
"GSPL INDIA TRANSCO LIMITED",
"GSPR DEVELOPERS PRIVATE LIMITED",
"GSR AIROTECH DUCT PRIVATE LIMITED",
"GSR AVENUES PRIVATE LIMITED",
"GSR BUSINESS SERVICES PRIVATE LIMITED",
"GSR CHEMICALS PRIVATE LIMITED",
"GSR COLD STORAGE PRIVATE LIMITED",
"GSR DEVELOPERS PRIVATE LIMITED",
"GSR ECO BRICKS PRIVATE LIMITED",
"GSR FARMS PRIVATE LIMITED",
"GSR INFOTECH PRIVATE LIMITED",
"GSR METALS PRIVATE LIMITED",
"GSR MOVIES",
"GSR TRADEFIN PRIVATE LIMITED",
"GSR VENTURES PRIVATE LIMITED",
"GSS COLLEGE BELGAUM",
"GSS ENGG PRIVATE LIMITED",
"GSS HEALTHCARE IT SOLUTIONS PRIVATE LIMITED",
"GSS HR SOLUTIONS PRIVATE LIMITED",
"GSS INDUSTRIES LIMITED",
"GSS INFOTECH LIMITED",
"GSS ISPAT PVT LTD",
"GSS POWERSERVE PRIVATE LIMITED",
"GSS PROJECT CONSULTANTS PRIVATE LIMITED",
"GSS QUICK GARAGE INDIA PRIVATE LIMITED",
"GSS STRUCTURES PRIVATE LIMITED",
"GSSC INFRADEVELOPMENT PRIVATE LIMITED",
"GSSG NIRMAN PRIVATE LIMITED",
"GSSS BIRDHOLIYA MAWALI",
"GSSS BODIWALI",
"GSSS DHANG KOTDA UDAIPUR",
"GSSS DHOLIMAGRI MAWLI",
"GSSS LAKHAWALI",
"GSSS MERTAMAWALI",
"GSSS PRATAPPURA",
"GSSS TANNA",
"GSSS UNHEL NAGESHWNAR",
"GST EFILING AND CONSULTANCY SEVICES LLP",
"GST INFRATECH PRIVATE LIMITED",
"GST LOGISTICS PRIVATE LIMITED",
"GST PROMOTERS PRIVATE LIMITED",
"GSTECH SOFTWARE SYSTEMS PRIVATE LIMITED",
"GSTP (HFS) PRIVATE LIMITED",
"GSV ELECTINFRA PROJECTS PRIVATE LIMITED",
"GSV PROJECTS PRIVATE LIMITED",
"GSW ENTREPRISES PRIVATE LIMITED",
"GSW FACILITY MANAGEMENT PRIVATE LIMITED",
"GSW INDUSTRIES INDIA PRIVATE LIMITED",
"GSW MINING & RECYCLING PRIVATE LIMITED",
"GSY TECHNOLOGIES PRIVATE LIMITED",
"GT AUTOMOTIV PRIVATE LIMITED",
"GT CARGO FITTINGS INDIA PRIVATE LIMITED",
"GT ELECTRONIC INDIA PRIVATE LIMITED",
"GT GEETA TEXTILES INDIA PRIVATE LIMITED",
"GT HOLIDAYS PRIVATE LIMITED",
"GT INDIA PRIVATE LIMITED",
"GT INDUSTRIAL SALES PRIVATE LIMITED",
"GT MECHATRONICS PRIVATE LIMITED",
"GT PADOLE HOSPITAL",
"GT RESTRUCTURING SERVICES LLP",
"GT SHIPYARD PRIVATE LIMITED",
"GT US SHARED SERVICES CENTER INDIA PRIVATE LIMITED",
"GT VALUE FOODS PRIVATE LIMITED",
"GT VIDHYA MANDIR",
"GTA OILS PRIVATE LIMITED",
"GTA VIDHYA MANDIR",
"GTAP SERVICES PRIVATE LIMITED",
"GTARA TEXTILES PRIVATE LIMITED",
"GTARB ENGINEERING PRIVATE LIMITED",
"GTB GLOBAL SERVICES PRIVATE LIMITED",
"GTB HOSPITAL COMPLEX",
"GTB MEGA MART PRIVATE LIMITED",
"GTC FOODS PRIVATE LIMITED",
"GTC FRAGRANCES PRIVATE LIMITED",
"GTC INDIA PVT LTD.",
"GTC OILFIELD SERVICES LIMITED",
"GTC PETROTECH PRIVATE LIMITED",
"GTC TECHNO EXPLORATION PRIVATE LIMITED",
"GTD TECHNOLOGIES PRIVATE LIMITED",
"GTECH APPLICATION INTELLIGENCE PRIVATE LIMITED",
"G-TECH BUSINESS SOLUTIONS",
"GTECH INFRA ENGINEERS PRIVATE LIMITED",
"GTECH LEARN PRIVATE LIMITED",
"GTECH PACKAGING INDIA PRIVATE LIMITED",
"G-TECH SOLUTIONS",
"GTECH WEB MARKETING PRIVATE LIMITED",
"GTECHGRO BUSINESS HUB PRIVATE LIMITED",
"GTEE BOTANICAL EXTRACT PRIVATE LIMITED",
"G-TEK CORPORATION PRIVATE LIMITED",
"G TEKT INDIA PRIVATE LIMITED",
"GTEN CONSULTANCY DIGITAL PRIVATE LIMITED",
"GTEN TECHNOLOGIES PRIVATE LIMITED",
"GTEUROGROOVE PRIVATE LIMITED",
"GTEX FABRICS PRIVATE LIMITED",
"GTF MARINE TECHNOLOGY INDIA PRIVATE LIMITED",
"GTF PRIVATE LIMITED",
"GTFC LIMITED",
"GTFC PRIVATE LIMITED",
"GTFS MULTI SERVICES LIMITED",
"GTG FASHIONS PRIVATE LIMITED",
"GTI INFOTEL RPIVATE LIMITED",
"GTI JEWELLERY INDIA PRIVATE LIMITED",
"GTI TRAVELS PRIVATE LIMITED",
"GTIS TELECOM & CIVIL CONTRACTORS PRIVATE LIMITED",
"GTJAYANTI PERFUMERY WORKS PRIVATE LIMITED",
"GTKONNECT INDIA PRIVATE LIMITED",
"GTL ADHESIVE TAPES INDIA PRIVATE LIMITED",
"GTL LIMITED",
"GTM INDUSTRIES PRIVATE LIMITED",
"GTM SUPPORT SOLUTIONS PRIVATE LIMITED",
"GTM SYNTHETICS LIMITED",
"GTN ENGINEERING INDIA LIMITED",
"GTN ENTERPRISES LIMITED",
"GTN INDUSTRIES LIMITED",
"GTN TEXTILES LIMITED",
"GTPL ABHILASH COMMUNICATION PRIVATE LIMITED",
"GTPL ACT PRIVATE LIMITED",
"GTPL AHMEDABAD CABLE TELE LINK PRIVATE LIMITED",
"GTPL BANSIDHAR TELELINK PRIVATE LIMITED",
"GTPL BROADBAND PRIVATE LIMITED",
"GTPL DCPL PRIVATE LIMITED",
"GTPL HATHWAY LIMITED",
"GTPL HATHWAY PRIVATE LIMITED",
"GTPL JAY SANTOSHIMA NETWORK PRIVATE LIMITED",
"GTPL JUNAGADH NETWORK PRIVATE LIMITED",
"GTPL KAIZEN INFONET PRIVATE LIMITED",
"GTPL KCBPL BROAD BAND PRIVATE LIMITED",
"GTPL KOLKATA CABLE & BROAD BAND PARISEVA LIMITED",
"GTPL LINK NETWORK PRIVATE LIMITED",
"GTPL NARMADA CYBERZONE PRIVATE LIMITED",
"GTPL RAJWADI NETWORK PRIVATE LIMITED",
"GTPL SK NETWORK PRIVATE LIMITED",
"GTPL SMC NETWORK PRIVATE LIMITED",
"GTPL SOLANKI CABLE NETWORK PRIVATE LIMITED",
"GTPL SORATH TELELINK PRIVATE LIMITED",
"GTPL SPN DIGITAL NETWORK PRIVATE LIMITED",
"GTPL V & S CABLE PRIVATE LIMITED",
"GTPL VIDEO BADSHAH PRIVATE LIMITED",
"GTPL VISION SERVICES PRIVATE LIMITED",
"GTPL VVC NETWORK PRIVATE LIMITED",
"GTROPY SYSTEMS PRIVATE LIMITED",
"GTS ALLOYS PRIVATE LIMITED",
"GTS CONTROLS & ENERGY SYSTEMS PRIVATE LIMITED",
"GTS ENGINEERING SOLUTION PRIVATE LIMITED",
"GTS E-SERVICES PRIVATE LIMITED",
"GTS FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"GTS FOOD PRODUCTS PRIVATE LIMITED",
"GTS LOGISTICS PRIVATE LIMITED",
"GTS TECHNOSOFT PRIVATE LIMITED",
"GTS TELECOM SERVICES(I) PRIVATE LIMITED",
"GTS TRANSPORT SERVICE PRIVATE LIMITED",
"GTSINC PRIVATE LIMITED",
"GTSOFT TECHNOLOGIES INDIA PRIVATE LIMITED",
"GTT COMMUNICATIONS INDIA PRIVATE LIMITED",
"GTV ENGINEERING LIMITED",
"GTV POWER PRIVATE LIMITED",
"GTV SEZ PHASE I PRIVATE LIMITED",
"GTVISION PROJECTS PRIVATE LIMITED",
"GTX PRIVATE LIMITED",
"GU SHIPPING INDIA PRIVATE LIMITED",
"GUARAN CHEMICALS PRIVATE LIMITED",
"GUARANTORS INFRASTRUCTURE PRIVATE LIMITED",
"GUARDELL INDIA PRIVATE LIMITED",
"GUARDEX FIRE SYSTEMS (INDIA) PRIVATE LIMITED",
"GUARDFORCE SECURITY SOLUTIONS PRIVATE LIMITED",
"GUARDIAN ADVISORS PRIVATE LIMITED",
"GUARDIAN ANGEL HOMECARE PRIVATE LIMITED",
"GUARDIAN ANTICORROSIVES PRIVATE LIMITED",
"GUARDIAN CABLES AND CONDUCTORS PRIVATE LIMITED",
"GUARDIAN CAPITAL INVESTMENT ADVISORS PRIVATE LIMITED",
"GUARDIAN CASTINGS PRIVATE LIMITED",
"GUARDIAN CONTROLS LIMITED",
"GUARDIAN GENERATORS PRIVATE LIMITED",
"GUARDIAN HEALTHCARE SERVICES PRIVATE LIMITED",
"GUARDIAN INDIA OPERATIONS PRIVATE LIMITED",
"GUARDIAN INDIA SOLUTIONS PRIVATE LIMITED",
"GUARDIAN INFRATECH PRIVATE LIMITED",
"GUARDIAN INTEGRATED SECURITY SERVICE (INDIA) PRIVATE LIMITED",
"GUARDIAN INTERNATIONAL PRIVATE LIMITED",
"GUARDIAN MEDIA AND ENTERTAINMENT PRIVATE LIMITED",
"GUARDIAN NUTRITION AND HEALTH SUPPLEMENTS PRIVATE LIMITED",
"GUARDIAN PLASTICOTE LIMITED",
"GUARDIAN PROMOTERS AND DEVELOPERS PRIVATE LIMITED",
"GUARDIAN TEXTILES PRIVATE LIMITED",
"GUARDSMARK SECURITY INDIA PRIVATE LIMITED",
"GUARDWEL INDUSTRIES PRIVATE LIMITED",
"GUARDWELL DETECTIVE SERVICES PRIVATE LIMITED",
"GUARDWELL PRIME SERVICES PRIVATE LIMITED",
"GUARDWELL SECURITY SERVICES PVT LTD",
"GUARENTED RENTALS PRIVATE LIMITED",
"GUARNIFLON INDIA PRIVATE LIMITED",
"GUAVA CREATIVE SOLUTIONS PRIVATE LIMITED",
"GUAVUS NETWORK SYSTEMS PRIVATE LIMITED",
"GUBBA AGRO FRESH PRIVATE LIMITED",
"GUBBA COLD PRIVATE LIMITED",
"GUBBA COLD STORAGE PRIVATE LIMITED",
"GUBBA GREEN COLD PRIVATE LIMITED",
"GUBBACCI APPAREL PRIVATE LIMITED",
"GUBBACHI LEARNING COMMUNITY",
"GUBBANNA SILK PRIVATE LIMITED",
"GUBBI CIVIL ENGINEERS LIMITED",
"GUBBI PAVERS & TILESINDIA PRIVATE. LIMITED",
"GUBBI TECHNOLOGIES PRIVATE LIMITED",
"GUBBIASTRA CONSULTANTS PRIVATE LIMITED",
"GUDAGE HOSPITAL",
"GUDDERA CONSULTANCY SERVICES PRIVATE LIMITED",
"GUDDI PLASTCON PRIVATE LIMITED",
"GUDDU FASHION PRIVATE LIMITED",
"GUDEL INDIA PRIVATE LIMITED",
"GUDEX GLASS INDUSTRIES PRIVATE LIMITED",
"GUDI EXPORTS PRIVATE LIMITED",
"GUDLIG SERVICES PRIVATE LIMITED",
"GUDNES HEALTHCARE PRIVATE LIMITED",
"GUDUCHI AYURVEDA PRIVATE LIMITED",
"GUDWANI FOREX PRIVATE LIMITED",
"GUENSTIGER INDIA PRIVATE LIMITED",
"GUERBET INDIA PRIVATE LIMITED",
"GUERIR PHARMACEUTICALS PRIVATE LIMITED",
"GUERRILLA INFRA SOLUTIONS PRIVATE LIMITED",
"GUEST GLOBAL ENG SERVICES",
"GUEST HOSPITAL",
"GUESTLINE HOSPITALITY MANAGEMENT AND DEVELOPEMENT SERVICES LIMITED",
"GUETERMANN INDIA PRIVATE LIMITED",
"GUFF CREATIONS PRIVATE LIMITED",
"GUFIC BIOSCIENCES LIMITED",
"GUGAJI COMPUTERS PRIVATE LIMITED",
"GUGALE WAREHOUSING PRIVATE LIMITED",
"GUGAN KNITWEARS PRIVATE LIMITED",
"GUGGENHEIM CAPITAL MANAGEMENT ASIA PRIVATE LIMITED",
"GUGGILAP EDUCATION PRIVATE LIMITED",
"GUGHANE INFRASTRUCTURE PRIVATE LIMITED",
"GUGNANI AUTOCARS PRIVATE LIMITED",
"GUGNANI MOTO PRIVATE LIMITED",
"GUGUSYS SMART SOLUTIONS PRIVATE LIMITED",
"GUHA CONTROL GEARS PRIVATE LIMITED",
"GUHA INFRASTRUCTURES PRIVATE LIMITED",
"GUHAN BUILDERS AND PROMOTERS PRIVATE LIMITED",
"GUHAN ENGINEERING PRIVATE LIMITED",
"GUHAN TEXTILE MILLS PRIVATE LIMITED",
"GUHILOT ENTERPRISE PRIVATE LIMITED",
"GUHRING INDIA PRIVATE LIMITED",
"GUIDE TOWARDS SOLUTIONS PRIVATE LIMITED",
"GUIDED GATEWAY PRIVATE LIMITED",
"GUIDEHOUSE INDIA PRIVATE LIMITED",
"GUIDEWIRE SOFTWARE SOLUTIONS INDIA PRIVATE LIMITED",
"GUIDING STAR DIGITAL PUBLISHERS LLP",
"GUILD ADVISORS LLP",
"GUILD BUILDERS PRIVATE LIMITED",
"GUILD ENGINEERING TURNKEY SOLUTIONS PRIVATE LIMITED",
"GUILD INFRA STRUCTURES PRIVATE LIMITED",
"GUILTFREE INDUSTRIES LIMITED",
"GUINDY MACHINE TOOLS LIMITED",
"GUINDY PROPERTIES PRIVATE LIMITED",
"GUINEA MOTORS PRIVATE LIMITED",
"GUINNESS REMEDIES PRIVATE LIMITED",
"GUIRES SOLUTIONS PRIVATE LIMITED",
"GUITCOM CONSULTING PRIVATE LIMITED",
"GUJ INFO PETRO LIMITED",
"GUJAR INDUSTRIES INDIA PRIVATE LIMITED",
"GUJARA PSYLLIUM PRODUCTS PRIVATE LIMITED",
"GUJARAT ACETYLENE PVT LTD",
"GUJARAT ADANI INSTITUTE OF MEDICAL SCIENCES",
"GUJARAT AGRI-CHEM INDUSTRIES PRIVATE LIMITED",
"GUJARAT AGROCHEM LIMITED",
"GUJARAT AIR CARGOES & TRAVELS PRIVATE LIMITED",
"GUJARAT ALKALIES AND CHEMICALS LIMITED",
"GUJARAT ALLOYS CAST PRIVATE LIMITED",
"GUJARAT ALUMINIUM EXTRUSION PVT LTD",
"GUJARAT AMBUJA EXPORTS LIMITED",
"GUJARAT AMPOULES AND VIALS PVT LTD",
"GUJARAT APOLLO INDUSTRIES LIMITED",
"GUJARAT AYURVED UNIVERSITY",
"GUJARAT BIO ORGANICS PRIVATE LIMITED",
"GUJARAT BIO-TECH (P) LTD",
"GUJARAT BORON DERIVATIVES PVT LTD",
"GUJARAT BULLION REFINERY PRIVATE LIMITED",
"GUJARAT CABLES AND ENAMELLED PRODUCTS PRIVATE LIMITED",
"GUJARAT CHEMICAL PORT TERMINAL COMPANY LIMITED",
"GUJARAT CLAY MILLS P LTD",
"GUJARAT CLUTCH PRIVATE LIMITED",
"GUJARAT COLOURLAM PRIVATE LIMITED",
"GUJARAT COLOURS AND COATINGS PRIVATE LIMITED",
"GUJARAT COMMERCIAL TAXES",
"GUJARAT CONTAINERS LIMITED",
"GUJARAT CO-OPERATIV MILK MARKETING PEDERATION LIMITED",
"GUJARAT COOPERATIVE MILK MARKETING FEDERATION LIMITED",
"GUJARAT COPPER ALLOYS LIMITED",
"GUJARAT CORK AND RUBBER PRIVATE LIMITED",
"GUJARAT COTEX LIMITED",
"GUJARAT COUNCIL OF PRIMARY EDUCATION",
"GUJARAT CRAFT INDUSTRIES LIMITED",
"GUJARAT CREDIT CORPORATION",
"GUJARAT CREDO ALUMINA CHEMICALS LIMITED",
"GUJARAT CREDO MINERAL INDUSTRIES LIMITED",
"GUJARAT DECOR PRIVATE LIMITED",
"GUJARAT DYESTUFF INDUSTRIES PRIVATE LIMITED",
"GUJARAT DYESTUFF INDUSTRIES PVT LTD",
"GUJARAT ECO MICROBIAL TECHNOLOGIES PRIVATE LIMITED",
"GUJARAT ECO TEXTILE PARK LIMITED",
"GUJARAT EMBROIDERIES PRIVATE LIMITED",
"GUJARAT ENERGY RESEARCH AND MANAGEMENT INSTITUTE",
"GUJARAT ENERGY TRANSMISSION CORPORATION LIMITED",
"GUJARAT ENVIRONMENT MANAGEMENT INSTITUTE",
"GUJARAT ENVIRO-PROTECTION AND INFRASTRUCTURE PRIVATE LIMITED",
"GUJARAT ENVIRO-PROTECTION AND INFRASTRUCTURE(HARYANA) PRIVATE LIMITED",
"GUJARAT FARM SEEDS PRIVATE LIMITED",
"GUJARAT FIBRE GRID NETWORK LIMITED",
"GUJARAT FLOTEX PRIVATE. LIMITED.",
"GUJARAT FLUOROCHEMICALS LIMITED",
"GUJARAT FORGINGS PRIVATE LIMITED",
"GUJARAT FOUNDATION FOR ENTREPRENEURIAL EXCELLENCE",
"GUJARAT FOUNDRIES PRIVATE LIMITED",
"GUJARAT GAS LIMITED GGL",
"GUJARAT GENERAL FOOD-CHEM PRIVATE LIMITED",
"GUJARAT GOPALAK DEVELOPMENT CORPORATION LIMITED",
"GUJARAT GREEN REVOLUTION COMPANY LIMITED",
"GUJARAT GUARDIAN LIMITED",
"GUJARAT HEAVY ELECTRICAL & INSULATORS PRIVATE LIMITED",
"GUJARAT HIRA BOURSE",
"GUJARAT HOTELS LIMITED",
"GUJARAT HY - SPIN LIMITED",
"GUJARAT IMEX LABS PRIVATE LIMITED",
"GUJARAT INDUSTRIAL AND TECHNICAL CONSULTANCY ORGANISATION LIMITED",
"GUJARAT INDUSTRIAL CATERERS PVT LTD",
"GUJARAT INDUSTRIAL CHEMICALS CO.PRIVATE LIMITED",
"GUJARAT INDUSTRIAL DEVELOPMENT CORP",
"GUJARAT INDUSTRIAL INVESTMENT CORPORATION LIMITED",
"GUJARAT INDUSTRIAL SECURITY FORCE SOCIETY",
"GUJARAT INDUSTRIES POWER CO LIMITED",
"GUJARAT INFOTECH LIMITED",
"GUJARAT INFRAPIPES PRIVATE LIMITED",
"GUJARAT INFRAPROJECT PRIVATE LIMITED",
"GUJARAT INSTITUTE OF DISASTER MANAGMENT",
"GUJARAT INTERNATIONAL FINANCE TEC-CITY COMPANY LIMITED",
"GUJARAT INTRUX LIMITED",
"GUJARAT ION EXCHANGE AND CHEMICALS LIMITED",
"GUJARAT ISP SERVICES LIMITED",
"GUJARAT JHM HOTELS LIMITED",
"GUJARAT JHM HOTELS PRIVATE LIMITED",
"GUJARAT KIRAN POLYTEX LIMITED",
"GUJARAT LABOUR WELFARE BOARD",
"GUJARAT LIFE SCIENCES PRIVATE LIMITED",
"GUJARAT LIVELIHOOD PROMOTION COMPANY LIMITED",
"GUJARAT MACHINERY PRIVATE LIMITED",
"GUJARAT MALL MGT CO P LIMITED",
"GUJARAT MARINE PRIVATE LIMITED",
"GUJARAT MARITIME BOARD GANDHINAGAR",
"GUJARAT MARITIME BOARD JAMNAGAR",
"GUJARAT MARITIME BOARD NAVLAKHI",
"GUJARAT MARITME BOARD OKHA",
"GUJARAT MEDICAL COUNCIL",
"GUJARAT MEDICAL EDUC RESEARCH SOC",
"GUJARAT MEDICRAFT PRIVATE LIMITED",
"GUJARAT METHODIST CHURCH CARDIOTHORALIC & VASCULAR RESEARCH SOCIETY",
"GUJARAT METRO RAIL CORPORATION GMRC LIMITED",
"GUJARAT MILK PRODUCTS LIMITED",
"GUJARAT MINERAL DEVP. CORPN. LIMITED.",
"GUJARAT MITRA PRIVATE LIMITED",
"GUJARAT MOTORS PRIVATE LIMITED",
"GUJARAT MRI CENTRE PVT LTD",
"GUJARAT MULTI GAS BASE CHEMICALS PRIVATE LIMITED",
"GUJARAT NARMADA VALLEY FERTILIZERS & CHEMICALS LIMITED",
"GUJARAT NATIONAL LAW UNIVERSITY",
"GUJARAT NATIONAL LAW UNIVERSITY GANDHINAGAR",
"GUJARAT NEWS BROADCASTERS PRIVATE LIMITED",
"GUJARAT NIPPON INTERNATIONAL PRIVATE LIMITED",
"GUJARAT OFFSET PRIVATE LIMITED",
"GUJARAT ORGANICS LIMITED",
"GUJARAT ORGANICS PRIVATE LIMITED",
"GUJARAT PAPER PRODUCTS PRIVATE LIMITED",
"GUJARAT PARAFFINS PRIVATE LIMITED",
"GUJARAT PEANUT PRODUCTS PRIVATE LIMITED",
"GUJARAT PERFECT ENGINEERING LIMITED",
"GUJARAT PETCOKE AND PETROPRODUCTS SUPPLY PRIVATE LIMITED",
"GUJARAT PETROCHEMICALS LIMITED",
"GUJARAT PETROSYNTHESE LIMITED",
"GUJARAT PHARMALAB PRIVATE LIMITED",
"GUJARAT PHOTO SUPPLIERS PRIVATE LIMITED",
"GUJARAT PIPAVAV PORT LIMITED",
"GUJARAT PLUG-IN DEVICES PVT LTD",
"GUJARAT POLLUTION CONTROL BOARD",
"GUJARAT POLY AVX ELECTRONICS LIMITED",
"GUJARAT POLYBONDS PRIVATE LIMITED",
"GUJARAT POLYETHELENE PRIVATE LIMITED",
"GUJARAT POLYFILMS PRIVATE LIMITED",
"GUJARAT POLYFILMS PRIVATE. LIMITED.",
"GUJARAT POLYPLAST PRIVATE LIMITED",
"GUJARAT POLYSOL CHEMICALS LIMITED",
"GUJARAT POLYSOL CHEMICALS PRIVATE LIMITED",
"GUJARAT POLYTEX PVT LTD",
"GUJARAT PORTS INFRASTRUCTURE AND DEVELOPMENT COMPANY LIMITED",
"GUJARAT POWER CORPORATION LIMITED",
"GUJARAT POWERFIELD PVT LTD",
"GUJARAT PRINT-PACK PUBLICATIONS PRIVATE LIMITED",
"GUJARAT PUBLIC SERVICE COMMISSION",
"GUJARAT RAFFIA INDUSTRIES LIMITED",
"GUJARAT RAIL INFRASTRUCTURE DEVELOPMENT CORPORATION LIMITED",
"GUJARAT ROAD AND INFRASTRUCTURE COMPANY LIMITED",
"GUJARAT RURAL INDUS MAKTG CORP LIMITED",
"GUJARAT RURAL WORKERS WELFARE BOARD",
"GUJARAT SHALIMAR HOTELS PVT LTD",
"GUJARAT SIDHEE CEMENT LIMITED",
"GUJARAT SILICON PRIVATE LIMITED",
"GUJARAT STATE & AFTERCARE ASSOCIATION GANDHINAGAR",
"GUJARAT STATE AIDS CONTROL SOCIETY",
"GUJARAT STATE AVIATION INFRASTRUCTURE COMPANY LIMITED",
"GUJARAT STATE ELECTRICITY CORPORATION LIMITED",
"GUJARAT STATE ENERGY GENERATION LIMITED",
"GUJARAT STATE FERTILISERS & CHEMICALS LIMITED",
"GUJARAT STATE FINANCIAL CORPORATION",
"GUJARAT STATE FINANCIAL SERVICES LIMITED",
"GUJARAT STATE HANDLOOM AND HANDICRAFTS DEVELOPMENT CORPORATION LIMITED",
"GUJARAT STATE INVESTMENT LIMITED",
"GUJARAT STATE LAND DEVELOPMENT CORPORATION LIMITED",
"GUJARAT STATE MACHINE TOOLS CORPORATION LIMITED",
"GUJARAT STATE PETROLEUM CORPORATION LIMITED",
"GUJARAT STATE PETRONET LIMITED",
"GUJARAT STATE ROAD TRANSPORT CORPORATION",
"GUJARAT STATE TRANSPORT CORPORATION",
"GUJARAT SWITCHGEARS PVT LTD",
"GUJARAT TEA PROCESSORS AND PACKERS LIMITED",
"GUJARAT TECH CAST PRIVATE LIMITED",
"GUJARAT TELEVISION PRIVATE LIMITED",
"GUJARAT TERCE LABORATORIES LIMITED",
"GUJARAT THEMIS BIOSYN LIMITED",
"GUJARAT TIMBER INDUSTRIES PRIVATE LIMITED",
"GUJARAT TOOLROOM LIMITED",
"GUJARAT TOUGHNED GLASS PRIVATE LIMITED",
"GUJARAT TRAILS PRIVATE LIMITED",
"GUJARAT TRANSFORMERS PVT LTD",
"GUJARAT TRIBAL RESEARCH AND TRAINING SOCIETY",
"GUJARAT TV9 PRIVATE LIMITED",
"GUJARAT UNIVERSITY",
"GUJARAT UNIVERSITY NAVRANGPURA AHD",
"GUJARAT URBAN DEVELOPMENT COMPANY LIMITED",
"GUJARAT URJA VIKAS NIGAM LIMITED",
"GUJARAT VIDYAPITH",
"GUJARAT WATER INFRASTRUCTURE LIMITED",
"GUJARAT WATER RESOURCES DEVELOPMENT CORPORATION LIMITED",
"GUJARAT WATER SUPPLY AND SEWERAGE",
"GUJARAT WEDGE WIRE SCREENS LIMITED",
"GUJARAT WOODLAM PRODUCTS PRIVATE LIMITED",
"GUJARATA STATE ELECTRICITY CORPORATION",
"GUJARATHI SAHAYKARI HOSPITAL",
"GUJARMAL MODI HOSPITAL & RESEARCH CENTRE FOR MEDICAL SCIENCES",
"GUJARMAL MODI HOSPITAL AND RESEARCH CENTRE FOR MEDICAL SCIENCES",
"GUJCAN SURFACE PRIVATE LIMITED",
"GUJCHEM SURFACTANTS PRIVATE. LIMITED.",
"GUJJADI SWARNA JEWELLERS PRIVATE LIMITED",
"GUJJU FASHION WORLD PRIVATE LIMITED",
"GUJPRO AGRIBUSINESS CONSORTIUM PRODUCER COMPANY LIMITED",
"GUJRAL EDUCATION AND BEYOND",
"GUJRAL HOTELS PRIVATE LIMITED",
"GUJRAL POLISH AND LUBRICANTS PRIVATE LIMITED",
"GUJRAL ROADWAAYS PRIVATE LIMITED",
"GUJRAL TOURS & TRAVELS PRIVATE LIMITED",
"GUJRALS RESTAURANTS & HOTELS LIMITED",
"GUJRAT CANS WORKS PRIVATE LIMITED",
"GUJRAT GROWMED MARKETING INDIA PRIVATE LIMITED",
"GUJRAT INSTITUTE OF DEVELOPEMENT RESEARCH",
"GUJRAT INTERNATIONAL FINANCE TEC-CITY",
"GUJRAT STELCO PRIVATE LIMITED",
"GUJRAT TECHNO CASTINGS PRIVATE LIMITED",
"GUJRAT UNIVERSITY",
"GUJRI INDUSTRIES INTERNATIONAL PRIVATE LIMITED",
"GUL PROPERTIES PRIVATE LIMITED",
"GULAAB FIBRES PRIVATE LIMITED",
"GULAB BUILDTECH PRIVATE LIMITED",
"GULAB FASHION PRIVATE LIMITED",
"GULAB INDUSTRIES PRIVATE LIMITED",
"GULAB INVESTMENTS COMPANY PRIVATE LIMITED",
"GULAB MARIA HIGH SCHOOL",
"GULAB MOULDS MANUFACTURING COMPANY PRIVATE LIMITED",
"GULAB OIL AND FOOD (AHMEDABAD) PRIVATE LIMITED",
"GULAB OIL AND FOODS PRIVATE LIMITED",
"GULAB PAINT MANUFACTURING COMPANY PRIVATE LIMITED",
"GULAB SUITINGS PRIVATE LIMITED",
"GULAB VALLEY HOMES PRIVATE LIMITED",
"GULABCHAND PRINTS PRIVATE LIMITED",
"GULABDAS INTERNATIONAL TRADING LLP",
"GULABI HIGHER PRIMARY SCHOOL",
"GULABPREM AGRO PROCESSING PRIVATE LIMITED",
"GULABRAI & SONS INFRA PRIVATE LIMITED",
"GULACHI ENGINEERS PRIVATE LIMITED",
"GULAM MUSTAFA ENTERPRISES PRIVATE LIMITED",
"GULATI AGENCIES PRIVATE LIMITED",
"GULATI AUTO ELECTRICALS PRIVATE LIMITED",
"GULATI EXTRUSIONS PRIVATE LIMITED",
"GULATI FOODS PVT LTD",
"GULATI LABELS PRIVATE LIMITED",
"GULATI OILS (INDIA) PRIVATE LIMITED",
"GULATI RESTAURANT AND FOODS PRIVATE LIMITED",
"GULATI REXINE EMPORIUM PRIVATE LIMITED",
"GULATI STEEL FAB PRIVATE LIMITED",
"GULBADAN TALKIES PRIVATE LIMITED",
"GULBARGA ELECTRICITY SUPPLY COMPANY LIMITED",
"GULBARGA POWER PRIVATE LIMITED",
"GULBARGA TRADING AND INVESTMENT PRIVATE LIMITED",
"GULBRANDSEN CATALYSTS PRIVATE LIMITED",
"GULBRANDSEN CHEMICALS PRIVATE LIMITED",
"GULBRANDSEN PRIVATE LIMITED",
"GULBRANDSEN TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"GULERMAK INDIA PRIVATE LIMITED",
"GULERMAK SAM INDIA KANPUR METRO JV",
"GULERMAK-TPL PUNE METRO JOINT VENTURE",
"GULF AIR B S C C",
"GULF ASHLEY MOTOR LIMITED",
"GULF ASIA CONTRACTING COMPANY PRIVATE LIMITED",
"GULF ASPHALT PRIVATE LIMITED",
"GULF ASSOCIATES",
"GULF AUTOMATION TECHNOLOGIES PRIVATE LIMITED",
"GULF ENGINEERS & CONSTRUCTORS PRIVATE LIMITED",
"GULF ENTERPRISES EXPORTS PRIVATE LIMITED",
"GULF EXCHANGE AND FINANCIAL SERVICES PRIVATE LIMITED",
"GULF HEAVY EQUIPMENTS RENTAL PRIVATE LIMITED",
"GULF KITCHEN EQUIPMENTS AND REFRIGERATION PRIVATE LIMITED",
"GULF LLOYDS INDUSTRIAL SERVICES (INDIA) PRIVATE LIMITED",
"GULF OCEAN SHIPPING PRIVATE LIMITED",
"GULF OIL LUBRICANTS INDIA LIMITED",
"GULF ORIENT SHIPPING",
"GULF PETROCHEM (INDIA) PRIVATE LIMITED",
"GULF PLASTICS INDUSTRIES PVT LTD",
"GULF STONE ENGINEERING PRIVATE LIMITED",
"GULF TOURS AND TRAVELS PRIVATE LIMITED",
"GULGULIA TRADE PRIVATE LIMITED",
"GULIA INFRATECH PRIVATE LIMITED",
"GULIA LAMINATES PVT LTD",
"GULIKA APPAREL PRIVATE LIMITED",
"GULISTAN TV NETWORK PRIVATE LIMITED",
"GULITA WEALTH ADVISORS PRIVATE LIMITED",
"GULJAG AIR PRODUCTS PRIVATE LIMITED",
"GULJAG GASES PRIVATE LIMITED",
"GULJAG HEALTH CARE PRIVATE LIMITED",
"GULJAG INDUSTRIES LIMITED.",
"GULJAG PROPERTIES AND LEASINGS PRIVATE LIMITED",
"GULKAS PHARMA PVT LTD",
"GULLCO INTERNATIONAL INDIA PRIVATE LIMITED",
"GULLY NETWORK RETAIL PRIVATE LIMITED",
"GULLYBABA PUBLISHING HOUSE PRIVATE LIMITED",
"GULMESHWAR AGRO PRODUCER COMPANY LIMITED",
"GULMOHAR CHEMICAL & PAINT INDUSTRIES PRIVATE LIMITED",
"GULMOHAR COMFORTS PRIVATE LIMITED",
"GULMOHAR DEALERS PRIVATE LIMITED",
"GULMOHAR FRAGRANCES LIMITED",
"GULMOHAR GREENS-GOLF AND COUNTRY CLUB LIMITED",
"GULMOHAR INFRADEVELOPERS PRIVATE LIMITED",
"GULMOHAR PACK-TECH INDIA PRIVATE LIMITED",
"GULMOHAR PARK MALL PRIVATE LIMITED",
"GULMOHAR TOWNSHIP INDIA PRIVATE LIMITED",
"GULNAR DRESSES PRIVATE LIMITED",
"GULNAR PLASTICS PRIVATE LIMITED",
"GULRAJ HOTELS PRIVATE LIMITED",
"GULSHAN CHEMICALS LIMITED",
"GULSHAN CHEMICALS PRIVATE LIMITED",
"GULSHAN E MILLAT URUDU PRIMARY SCHOOL",
"GULSHAN EXIM PRIVATE LIMITED",
"GULSHAN FASHIONS",
"GULSHAN GALLERY PRIVATE LIMITED",
"GULSHAN HOMES AND INFRASTRUCTURE PRIVATE LIMITED",
"GULSHAN ICE AND COLD STORAGE PRIVATE LIMITED",
"GULSHAN INDIA INFRASTRUCTURE PRIVATE LIMITED",
"GULSHAN INTERNATIONAL PRIVATE LIMITED",
"GULSHAN INVESTMENT COMPANY PRIVATE LIMITED",
"GULSHAN LAMEE PACK PRIVATE LIMITED",
"GULSHAN POLYMERS PRIVATE LTD",
"GULSHAN POLYOLS LIMITED",
"GULSHAN PRINTS PRIVATE LIMITED",
"GULSHAN RAI JAIN-II",
"GULSHAN VALVETS PRIVATE LIMITED",
"GULZAR AUTOMOBILES PRIVATE LIMITED",
"GULZAR EDUCATIONAL & CHARITABLE TRUST",
"GULZAR HIRE PURCHASE PVT LTD",
"GULZAR MOTORS PRIVATE LIMITED",
"GULZARI LAL GROVER AND SONS PRIVATE LIMITED",
"GULZARI LAL KANTHI RAM PRIVATE LIMITED",
"GULZARI LAL STEELS PRIVATE LIMITED",
"GULZARILAL ENGINEERING PRIVATE LIMITED",
"GUMANSINGH ENGINEERING & EXPORTS PRIVATE LIMITED",
"GUMBERG INDIA PRIVATE LIMITED",
"GUMBI SOFTWARE PRIVATE LIMITED",
"GUMLET TECHNOLOGIES PRIVATE LIMITED",
"GUMMADIDALA SOLAR PRIVATE LIMITED",
"GUMMALA INFRA PROJECTS PRIVATE LIMITED",
"GUMMI METALL TECHNIK INDIA PRIVATE LIMITED",
"GUMPRO DRILLING FLUIDS PRIVATE LIMITED",
"GUMPTION LABS FINSERVE PRIVATE LIMITED",
"GUN AND SHELL FACTORY COSSIPORE",
"GUN CARRIAGE FACTORY",
"GUNA DEVELOPERS PRIVATE LIMITED",
"GUNA ENGINEERING PRIVATE LIMITED",
"GUNA SAI LIFE SCIENCE PRIVATE. LIMITED.",
"GUNA SHEOPUR PATHWAYS PRIVATE LIMITED",
"GUNA SOLAR PRIVATE LIMITED",
"GUNAATITA TECHNOLOGY PRIVATE LIMITED",
"GUNADHISH TEA PROCESSOR PRIVATE LIMITED",
"GUNADHYA SOFTWARE SOLUTIONS PRIVATE LIMITED",
"GUNASEKARAN HOSPITALS PRIVATE LIMITED",
"GUNASHEELA AND ASSOCIATES",
"GUNASHEELA SURGICAL AND MATERNITY HOSPITAL",
"GUNASHREE VIDYALAYA HIGH SCHOOL ADYAR",
"GUNATHEETHA EARTHMOVING SOLUTIONS PRIVATE LIMITED",
"GUNATIT ELECTROPOWER PRIVATE LIMITED",
"GUNDECHA BUILDERS",
"GUNDECHA CONSTRUCTION PRIVATE LIMITED",
"GUNDECHA EDUCATION ACADEMY",
"GUNESH (INDIA) PRIVATE LIMITED",
"GUNG HO MARKETING SERVICES PRIVATE LIMITED",
"GUNGUN TEXTILES PRIVATE LIMITED",
"GUNGUNWALA FOOD EQUIPMENT PRIVATE LIMITED",
"GUNHILL VENTURES PRIVATE LIMITED",
"GUNI HOSPITALITY PRIVATE LIMITED",
"GUNINA ALLOY AND STEEL PRIVATE LIMITED",
"GUNINA COMMERCIALS PRIVATE LIMITED",
"GUNINA MEDICAL MARKETING PRIVATE LIMITED",
"GUNJAL GASTROENTROLOGY AND CHILDRENS CLINIC",
"GUNJAM HOSPITALITY PRIVATE LIMITED",
"GUNJAN CAB INDIA PRIVATE LIMITED",
"GUNJAN CEMENT PVT LTD",
"GUNJAN CHEMICALS INDUSTRIES PRIVATE LIMITED",
"GUNJAN COMMOTRADE PVT LTD",
"GUNJAN DRILLING ASSOCIATES PRIVATE LIMITED",
"GUNJAN EXPORTS PRIVATE LIMITED",
"GUNJAN INFRASTRUCTURE PRIVATE LIMITED",
"GUNJAN JEWELS PRIVATE LIMITED",
"GUNJAN MARKETING PVT LTD",
"GUNJAN MINERALS PRIVATE LIMITED",
"GUNJAN PAINTS LIMITED",
"GUNJAN'S IVF WORLD PRIVATE LIMITED",
"GUNJESHWARI FASHION PRIVATE LIMITED",
"GUNLAKSHMI METALLICS PRIVATE LIMITED",
"GUNMETAL STITCHES PRIVATE LIMITED",
"GUNN AGRI FOODS PRIVATE LIMITED",
"GUNNAM INFRA PROJECTS PRIVATE LIMITED",
"GUNNEBO INDIA PRIVATE LIMITED",
"GUNNO APPARELS PRIVATE LIMITED",
"GUNNO FASHIONS PRIVATE LIMITED",
"GUNNO KNITS PRIVATE LIMITED",
"GUNNYTEX INDIA PRIVATE LIMITED",
"GUNPATROY PVT LTD",
"GUNRAAJ AQUA PRIVATE LIMITED",
"GUNSITE SERVICES PRIVATE LIMITED",
"GUNTUR AUTO SERVICES PRIVATE LIMITED",
"GUNTUR INSTITUTE OF ONCOLOGY PRIVATE LIMITED",
"GUNTUR MUNICIPAL CORPORATION",
"GUNTUR SPINNING MILLS PRIVATE LIMITED",
"GUNTUR SUBBIAH PILLAI T NAGAR GIRLS HR SEC SCHOOL",
"GUNTUR VIKAS JR SR COLLEGE",
"GUNWANSH BUILDERS PRIVATE LIMITED",
"GUO TECHNO FILAMENTS PRIVATE LIMITED",
"GUOJING TECHNOLOGY INDIA PRIVATE LIMITED",
"GUOZHONG INTERNATIONAL PRIVATE LIMITED",
"GUPS BHIM KAKHEDA",
"GUPSHUP TECHNOLOGY INDIA PRIVATE LIMITED",
"GUPT GANESH ASSETS HOLDINGS PRIVATE LIMITED",
"GUPTA AGENCIES",
"GUPTA AND COMPANY DEVELOPERS PRIVATE LIMITED",
"GUPTA AND COMPANY PRIVATE LIMITED",
"GUPTA AND GUPTA PRIVATE LIMITED",
"GUPTA AND SAHA TRAVELS AND FOREX PRIVATE LIMITED",
"GUPTA AROMATICS PRIVATE LIMITED",
"GUPTA AUTO SERVICE (ALLAHABAD) PRIVATE LIMITED",
"GUPTA AYURVEDIC PHARMACY PVT LTD.,",
"GUPTA BIKES PRIVATE LIMITED",
"GUPTA BROS DRUGGIST PRIVATE LIMITED",
"GUPTA BROTHER NAINI CONTRACTORS PRIVATE LIMITED",
"GUPTA BROTHERS (ABAR KHABO SHOP) PRIVATE LIMITED",
"GUPTA BROTHERS SALES PRIVATE LIMITED",
"GUPTA BROTHERS SWEETS & SNACKS PRIVATE LIMITED",
"GUPTA BUILDERS & DEVELOPERS",
"GUPTA BUILDERS AND PROMOTERS PRIVATE LIMITED",
"GUPTA BUILDING SOLUTION PRIVATE LIMITED",
"GUPTA CARRIERS PVT LTD",
"GUPTA CHEMICALS PVT LTD",
"GUPTA COLLEGE OF TECHNOLOGICAL SCIENCES",
"GUPTA CONSTRUCTIONS PRIVATE LIMITED",
"GUPTA CONTRACTORS PRIVATE LIMITED",
"GUPTA CRANES AND STORAGE PRIVATE LIMITED",
"GUPTA CREATIONS PRIVATE LIMITED",
"GUPTA ELECTROTRADE PRIVATE LIMITED",
"GUPTA ENTERTAINMENTS PRIVATE LIMITED",
"GUPTA ESTABLISHMENTS PRIVATE LIMITED",
"GUPTA EXPRESS PRIVATE LIMITED",
"GUPTA EXTRUSIONS PRIVATE LIMITED",
"GUPTA EYE HOSPITAL LLP",
"GUPTA FABRICS PRIVATE LIMITED",
"GUPTA FASTENERS PRIVATE LIMITED",
"GUPTA FERTILIZERS AND CHEMICALS PRIVATE LIMITED",
"GUPTA FILTERS PRIVATE LIMITED",
"GUPTA FOREX PRIVATE LIMITED",
"GUPTA H C OVERSEAS (I) PRIVATE LIMITED",
"GUPTA HAIR PRODUCTS PRIVATE LIMITED",
"GUPTA HOSPITALITY SERVICES PRIVATE LIMITED",
"GUPTA INDUSTRIAL GASES PRIVATE LIMITED",
"GUPTA INDUSTRIAL MAINTENANCE SERVICES PRIVATE LIMITED",
"GUPTA INDUSTRIES",
"GUPTA INFOTECH",
"GUPTA INTER-CHEM PRIVATE LIMITED",
"GUPTA JEE TENT SERVICES PRIVATE LIMITED",
"GUPTA JEWELLERS PRIVATE LIMITED",
"GUPTA JI BROTHERS RICE MILL PRIVATE LIMITED",
"GUPTA LEGAL SERVICES PRIVATE LIMITED",
"GUPTA LOOMTEX PRIVATE LIMITED",
"GUPTA METACAST PRIVATE LIMITED",
"GUPTA METAL MART PRIVATE LIMITED",
"GUPTA METAL SHEETS LTD",
"GUPTA MOBILES PRIVATE LIMITED",
"GUPTA MODERN RICE PRODUCTS PRIVATE LIMITED",
"GUPTA MOTORS INDIA PRIVATE LIMITED",
"GUPTA MULTISPECIALITY HOSPITAL",
"GUPTA NUTRITIONS PRIVATE LIMITED",
"GUPTA OVERSEAS PRIVATE LIMITED",
"GUPTA OXYGEN PRIVATE LIMITED",
"GUPTA PAPER HOUSE PRIVATE LIMITED",
"GUPTA POLYTUBES PRIVATE LIMITED",
"GUPTA POWER INFRASTRUCTURE LIMITED",
"GUPTA POWER TECHNOLOGIES PRIVATE LIMITED",
"GUPTA PRIME ISPAT PRIVATE LIMITED",
"GUPTA PRIME RESORTS PRIVATE LIMITED",
"GUPTA PROMOTERS PRIVATE LIMITED",
"GUPTA PROTEIN PRIVATE LIMITED",
"GUPTA PUBLISHING HOUSE PRIVATE. LIMITED.",
"GUPTA RESIDENCY PRIVATE LIMITED",
"GUPTA RETAIL TRADE ZONE PRIVATE LIMITED",
"GUPTA RICE AND GENERAL MILLS",
"GUPTA SAREES PRIVATE LIMITED",
"GUPTA SOLVENT PRIVATE LIMITED",
"GUPTA SPARES INDUSTRIES PRIVATE LIMITED",
"GUPTA STAINLESS PRIVATE LIMITED",
"GUPTA STEEL & POWER PRIVATE LIMITED",
"GUPTA STEEL & STRIPS PRIVATE LIMITED",
"GUPTA STEEL CORPORATION PRIVATE LIMITED",
"GUPTA STEEL SHIP BREAKERS",
"GUPTA STUDIO PRIVATE LIMITED",
"GUPTA SYNTEX PRIVATE LIMITED",
"GUPTA TEA PVT LTD",
"GUPTA TEX PRINTS PRIVATE LIMITED",
"GUPTA THREADS LIMITED",
"GUPTA TIMBERTRADER PRIVATE LIMITED",
"GUPTA TRADEMART PRIVATE LIMITED",
"GUPTA TRADING COMPANY",
"GUPTA TRANSFORMER PRODUCTS",
"GUPTA TYRE MART PRIVATE LIMITED",
"GUPTA UDYOG",
"GUPTACERAMICS PRIVATE LIMITED",
"GUPTAS GOLD HOUSE",
"GUPTESWAR FLOUR MILLS PRIVATE LIMITED",
"GUPTHA INFRAVENTURES AND CONSTRUCTIONS PRIVATE LIMITED",
"GUR DAS KAPUR & SONS PRIVATE LIMITED",
"GURAMAR FOREX SERVICES PRIVATE LIMITED",
"GURAP SITAL KUMAR BALIKA VIDYALAYA",
"GURAV MARINE SERVICES PRIVATE LIMITED",
"GURBANI MEDIA PRIVATE LIMITED",
"GURBAXANI ENGINEERING & CONSTRUCTIONS PRIVATE LIMITED",
"GURBAXANI INFRAVENTURES PRIVATE LIMITED",
"GURCHARAN JEWELLERS PRIVATE LIMITED",
"GURCHARAN MICA (INDIA) PRIVATE LIMITED",
"GURCHIT INTERNATIONAL PRIVATE LIMITED",
"GURDASHMESH CYCLES PRIVATE LIMITED",
"GURDAYAL NIRMAN UDYOG PRIVATE LIMITED",
"GURDEEP REFRIGERATION PRIVATE LIMITED",
"GURDEEP ROLLING SHUTTER PRIVATE LIMITED",
"GURDEEP SINGH AND SONS PRIVATE LIMITED",
"GURDEV ENGINEERING AND INDUSTRIES PRIVATE LIMITED",
"GURDEV HOSPITAL",
"GURERA SYNTHETICS PVT LIMITED",
"GURERA TEXTILES PRIVATE LIMITED",
"GURGAON ASSOCIATES PRIVATE LIMITED",
"GURGAON INFO PARKS LIMITED.",
"GURGAON INFOSPACE LIMITED",
"GURGAON ON WHEELS TOURS PRIVATE LIMITED",
"GURGAON PACKAGING PRIVATE LIMITED",
"GURGAON REALTECH LIMITED",
"GURGAON RECREATION PARK LIMITED",
"GURGAON SOHNA HIGHWAY PRIVATE LIMITED",
"GURGAON TECHNOLOGY PARK LIMITED",
"GURGAON TRAVELS & LOGISTIC SERVICES PRIVATE LIMITED",
"GURGAON WASTE MANAGEMENT SYSTEM PRIVATE LIMITED",
"GURGAON-PALWAL TRANSMISSION LIMITED",
"GURIND INDIA PRIVATE LIMITED",
"GURIND SYSTEMS PRIVATE LIMITED",
"GURIT INDIA PRIVATE LIMITED",
"GURIT WIND PRIVATE LIMITED",
"GURIYA CREATIONS PRIVATE LIMITED",
"GURJANGJHORA TEA & INDUSTRIES LTD",
"GURJAR CHEMICALS PRIVATE LIMITED",
"GURJAR GEMS PRIVATE LIMITED",
"GURJAR HOSPITAL AND ENDOSCOPY CENTRE PRIVATE LIMITED",
"GURJAR IMAGES PRIVATE LIMITED",
"GURKIRPA SPINNING AND WEAVING MILLS PVT LTD",
"GURKUL VIMUKAT JATI UCCH PRATHMIK AASHRAM SHALA",
"GURMAAN AUTOMOBILES PRIVATE LIMITED",
"GURMAT CONSTRUCTION COMPANY PRIVATE LIMITED",
"GURMEET MOTORS PRIVATE LIMITED",
"GURMEHAR TRADING PRIVATE LIMITED",
"GURMON HOTELS PRIVATE LIMITED",
"GURNANI METALS PRIVATE LIMITED",
"GURNOOR ENTERPRISES PRIVATE LIMITED",
"GURPREET DEVELOPERS AND PROMOTERS PRIVATE LIMITED",
"GURPREET GALVANIZING PRIVATE LIMITED",
"GURPRIT ENTERPRISES PRIVATE LIMITED",
"GURR JOHNS INDIA PRIVATE LIMITED",
"GURRAM VENKATESHWARLU TEXTILES PRIVATE LIMITED",
"GURRISHMA INTERNATIONAL PRIVATE LIMITED",
"GURSAI MOTORS PRIVATE LIMITED",
"GURTEJ STEELS PRIVATE LIMITED",
"GURU AMAR DAS PUBLIC SCHOOL",
"GURU AMAR INDUSTRY LIMITED",
"GURU AMARDASS INTERNATIONAL PRIVATE LIMITED",
"GURU ASHISH SHIPBREAKERS",
"GURU ASSOCIATESS",
"GURU AT HOME",
"GURU COMMODITY SERVICES PRIVATE LIMITED",
"GURU COMPUTERS PRIVATE LIMITED",
"GURU DRY FRUITS PRIVATE LIMITED",
"GURU FABTECH PRIVATE LIMITED",
"GURU FILMS PRIVATE LIMITED",
"GURU GAME DIGITAL PRIVATE LIMITED",
"GURU GANESH MISHRI JAIN ARTS & SCIENCE COLLEGE ALEGAON",
"GURU GHASIDAS VISHWAVIDYALAYA",
"GURU GOBIND MOTORS PRIVATE LIMITED",
"GURU GOBIND SINGH COLLEGE OF ENGG RESEARCH CENTRE",
"GURU GOBIND SINGH EDUCATIONAL SOCIETY",
"GURU GOBIND SINGH GOVT HOSPITAL",
"GURU GOUTAM INFOTECH PRIVATE LIMITED",
"GURU GOWRI KRUPA TECHNOLOGIES PRIVATE LIMITED",
"GURU HARKISHAN CHARITABLE HOSPITAL",
"GURU HARKRISHAN PUBLIC SCHOOL",
"GURU INDUSTRIAL VALVES PRIVATE LIMITED",
"GURU INFO SOLUTION PRIVATE LIMITED",
"GURU INFOCOMM INDIA PRIVATE LIMITED",
"GURU INTEGRATED SERVICES INDIA PRIVATE LIMITED",
"GURU KIRPA ENTERPRISES",
"GURU KIRPA POLYMERS LLP",
"GURU KIRPA SCAFF PRIVATE LIMITED",
"GURU KIRPA TEXCO FAB PRIVATE LIMITED",
"GURU KRIPA ADLINKS PRIVATE LIMITED",
"GURU KRIPA ADVERTISING PRIVATE LIMITED",
"GURU KRIPA CARGO MOVERS (INDIA) PRIVATE LIMITED",
"GURU KRIPA FASHIONS PRIVATE LIMITED",
"GURU KRIPA HOSPITAL RESEARCH CENTRE PRIVATE LIMITED",
"GURU KRIPA ICE AND COLD STORAGE WAREHOUSING INDIA PRIVATE LIMITED",
"GURU KRUPA SALT AND CHEMICAL PRIVATE LIMITED",
"GURU LAXMI COTTEX PRIVATE LIMITED",
"GURU MAHARAJ COMPUTER SERVICE",
"GURU MAHIMA AGROS PRIVATE LIMITED",
"GURU MANN VENTURES PRIVATE LIMITED",
"GURU MEHAR AGENCIES PRIVATE LIMITED",
"GURU MOVERS PRIVATE LIMITED",
"GURU NAMAN MOTORS PRIVATE LIMITED",
"GURU NANAK AGENCIES PRIVATE LIMITED",
"GURU NANAK AUTO ENTERPRISES LIMITED",
"GURU NANAK AYURVEDIC MEDICAL COLLEGE AND RESEARCH INSTITUTE",
"GURU NANAK CARGO PRIVATE LIMITED",
"GURU NANAK COLLEGE CHENNAI",
"GURU NANAK COLLEGE OF EDUCATION",
"GURU NANAK COLLEGE, OF ARTS SCIENCE AND COMMERCE GTB NAGAR",
"GURU NANAK DEV ENGINEERING COLLEGE BIDAR",
"GURU NANAK DEV HOSPITAL AMRITSAR",
"GURU NANAK DEV UNIVERSITY",
"GURU NANAK ENJINEERING COLLEGE LUDHIANA",
"GURU NANAK EYE CENTRE",
"GURU NANAK FOREX PRIVATE LIMITED",
"GURU NANAK FORGING PRIVATE LIMITED",
"GURU NANAK FOUNDATION",
"GURU NANAK GIRLS P G COLLEGE UDAIPUR",
"GURU NANAK HANDLOOM PRIVATE LIMITED",
"GURU NANAK HIGH SCHOOL MAHIM",
"GURU NANAK HOSPITAL & RESEARCH CENTRE",
"GURU NANAK INDEPENDENT PRE UNIVERSITY COLLEGE",
"GURU NANAK INSTITUTE OF MANAGEMENT",
"GURU NANAK INSTITUTE OF TECHNOLOGY",
"GURU NANAK INSTITUTIONS TECHNICAL CAMPUS",
"GURU NANAK INTER COLLEGE",
"GURU NANAK INTERNATIONAL PRIVATE LIMITED",
"GURU NANAK MANAGEMENT SERVICES PRIVATE LIMITED",
"GURU NANAK MAT HR SEC SCHOOL",
"GURU NANAK MEDICOS PRIVATE LIMITED",
"GURU NANAK MISSION HOSPITAL",
"GURU NANAK MODERN ENGLISH SCHOOL",
"GURU NANAK MODERN SCHOOL",
"GURU NANAK OVERSEAS CO PVT LTD",
"GURU NANAK PRINTING PRESS",
"GURU NANAK PUBLIC SCHOOL",
"GURU NANAK PUBLIC SENIOR SECONDARY SCHOOL UDAIPUR",
"GURU NANAK RICE MILLS",
"GURU NANAK STONE INDUSTRIES",
"GURU NANAK STORES PVT LTD",
"GURU NANAK UNIVERSITY",
"GURU NANAK WORKSHOP SERVICES PRIVATE LIMITED",
"GURU OVERSEAS PRIVATE LIMITED",
"GURU PRASAD ROLLER FLOUR MILLS PRIVATE LIMITED",
"GURU PROCESS EQUIPMENTS PRIVATE LIMITED",
"GURU RAGAVENDRA HOSPITAL",
"GURU RAGHAVENDRA FOUNDATIONS PRIVATE LIMITED",
"GURU RAJENDRA METALLOYS INDIA PRIVATE LIMITED",
"GURU RAJENDRA METALS PRIVATE LIMITED",
"GURU RAM DAS ENGINEERING WORKS PRIVATE LIMITED",
"GURU RAM DASS PUBLIC SCHOOL SHAHDIN WALA FZR",
"GURU RAMDAS JI STONE CRUSHER",
"GURU RAMDASS ACADEMY",
"GURU SAI AGRO INDUSTRIES",
"GURU SDB PRIVATE LIMITED",
"GURU SEWAK PARIVAAR FOUNDATION",
"GURU SEWAK TEXTILES PRIVATE LIMITED",
"GURU SHOES TECH PRIVATE LIMITED",
"GURU SHREE SHANTIVIJAI COLLEGE FOR WOMEN",
"GURU SHREE SHANTIVIJAI JAIN VIDYALAYA",
"GURU SOYA FOODS PRIVATE LIMITED",
"GURU SWEETS & SNACKS PRIVATE LIMITED",
"GURU SYNTHETICS PRIVATE LIMITED",
"GURU TECH BAHADUR PUBLIC SCHOOL",
"GURU TEG BHADUR HOSPITAL",
"GURU TEG ENTERPRISES (OPC) PRIVATE LIMITED",
"GURU TEGH BAHADUR INSTITUTE OF TECHNOLOGY",
"GURU TEGH BAHADUR PUBLIC SCHOOL",
"GURU TRANSLINES PRIVATE LIMITED",
"GURU UV PROCESS PRIVATE LIMITED",
"GURU99 TECH PRIVATE LIMITED",
"GURUAMRUT INFRASTRUCTURE & MANAGEMENT SERVICES PRIVATE LIMITED",
"GURUAPPA HOTELS PRIVATE LIMITED",
"GURUASHISH EXIM PRIVATE LIMITED",
"GURUASHISH LOGISTICS PRIVATE LIMITED",
"GURUBAL ENGINEERING COMPANY PRIVATE LIMITED",
"GURUCHARAN GASES LIMITED (AMBAJI OXYGEN)",
"GURUCUL SOLUTIONS PRIVATE LIMITED",
"GURUDAS AGRO PRIVATE. LIMITED.",
"GURUDAS COLLEGE OF COMMERCE700007",
"GURUDASHMESH MOTORS INDIA PRIVATE LIMITED",
"GURUDATTA ELECTRICALS",
"GURUDEO EXPORTS CORPORATION PRIVATE LIMITED",
"GURUDEO PACKAGING AND PRINTING PRIVATE LIMITED",
"GURUDEV CONSTRUOTIONS",
"GURUDEV CONTAINERS PRIVATE LIMITED",
"GURUDEV DEALTRADE PRIVATE LIMITED",
"GURUDEV DYE-CHEM PRIVATE LIMITED",
"GURUDEV DYESTUFF (INDIA) PRIVATE LIMITED",
"GURUDEV ENGICON PRIVATE LIMITED",
"GURUDEV ENTERTAINMENT PRIVATE LIMITED",
"GURUDEV FILMS PRIVATE LIMITED",
"GURUDEV FINANCIAL SERVICES PRIVATE LIMITED",
"GURUDEV HANDLING PRIVATE LIMITED",
"GURUDEV HOSPITAL",
"GURUDEV IMPEX PRIVATE LIMITED",
"GURUDEV MAHILA CROP PRODUCER COMPANY LIMITED",
"GURUDEV MARBLES PRIVATE LIMITED",
"GURUDEV MOTORS CHENNAI LLP",
"GURUDEV MOTORS PRIVATE LIMITED",
"GURUDEV OVERSEAS LIMITED",
"GURUDEV PLASTICS PRIVATE LIMITED",
"GURUDEV PLASTOPACK INDIA PRIVATE LIMITED",
"GURUDEV REALCON PRIVATE LIMITED",
"GURUDEV SEMI ENGLISH SCHOOL & COLLEGE OF SCIENCE SUPA MIDC",
"GURU-DEV SPRINGS PVT LTD",
"GURUDEV TRADING & SERVICES PRIVATE LIMITED",
"GURUDHARMAM MISSION HOSPITAL LIMITED",
"GURUGOVIND PULSES PRODUCTS PRIVATE LIMITED",
"GURUGRAM METROPOLITAN CITY BUS LIMITED",
"GURUGRAM UNIVERSITY",
"GURUHARSAHAI AGRO PRIVATE LIMITED",
"GURUJI ENTERPRISES PVT LTD",
"GURUJI INFRASTRUCTURE PRIVATE LIMITED",
"GURUJI PRODUCTS PRIVATE LIMITED",
"GURUJI PRODUCTS PVT LTD",
"GURUJI THANDAIWALA PVT LTD",
"GURUJI TRAVELS PRIVATE LIMITED",
"GURUKANTH AND SAJID INFRASTRUCTURE PRIVATE LIMITED",
"GURUKRIPA CAREER INSTITUTE",
"GURUKRIPA DEVELOPERS & INFRASTRUCTURES PRIVATE LIMITED",
"GURUKRIPA MANUFACTURING PRIVATE LIMITED",
"GURUKRIPA MARINE SERVICES PRIVATE LIMITED",
"GURUKRIPA PIPE FITTINGS PRIVATE LIMITED",
"GURUKRIPA PUMP PRIVATE LIMITED",
"GURUKRIPA TARPAULINS PRIVATE LIMITED",
"GURUKRIPA WOVENSACK PRIVATE LIMITED",
"GURUKRIPAA TOOLS PRIVATE LIMITED",
"GURUKRU KRUSHI SEVA KENDRA",
"GURUKRUPA BINDING WORKS",
"GURUKRUPA CHICKS TO CHICKEN PRIVATE LIMITED",
"GURUKRUPA COTGIN PRIVATE LIMITED",
"GURUKRUPA ENGINERS PRIVATE LIMITED",
"GURUKRUPA ENTERPRISES",
"GURUKRUPA FROZEN GOODS CARRIER PRIVATE LIMITED",
"GURUKRUPA INFRA PROJECTS",
"GURUKRUPA KRAFTS PRIVATE LIMITED",
"GURUKRUPA MACHINING WORKS PRIVATE LIMITED",
"GURUKRUPA MOTORS PRIVATE LIMITED",
"GURUKRUPA OVERSEAS PRIVATE LIMITED",
"GURUKRUPA POLYPLAST LTD",
"GURUKRUPA REALCON DEVELOPERS PRIVATE LIMITED",
"GURUKRUPA REALITIES PRIVATE LIMITED",
"GURUKRUPA SAREES PRIVATE LIMITED",
"GURUKRUPA TRADERS",
"GURUKRUPAN AGRO LIMITED",
"GURUKUL EDUCATION SOCIETY SATARA",
"GURUKUL EDUCATIONAL INSTITUTES PRIVATE LIMITED",
"GURUKUL FITTINGS PRIVATE LIMITED",
"GURUKUL GLOBAL SCHOOL",
"GURUKUL GRAMMAR SENIOR SECONDARY SCHOOL",
"GURUKUL INSTITUTE OF ENGINEERING AND TECHNOLOGY",
"GURUKUL INTERNATION SCHOOL",
"GURUKUL KANGRI DEEMED TO BE UNIVERSITY",
"GURUKUL MANAGEMENT STUDIES",
"GURUKUL PRIMARY SCHOOL",
"GURUKUL PUBLIC SCHOOL BEED",
"GURUKUL PUBLICATIONS PRIVATE LIMITED",
"GURUKULA PUBLIC SCHOOL",
"GURUKULAM MATRIC HR SEC SCHOOL",
"GURUKULAM WORLD SCHOOL",
"GURUKULGYAN LEARNINGS PRIVATE LIMITED",
"GURUKULONLINE LEARNING SOLUTIONS PRIVATE LIMITED",
"GURUKULWAVE RESEARCH DIATRIBA PRIVATE LIMITED",
"GURULAXMI EXIM PRIVATE LIMITED",
"GURUMAHARAJ ENGICON PRIVATE LIMITED",
"GURUMEHAR HOUSING AND FINANCE PRIVATE LIMITED",
"GURUNANAK AGRICULTURE INDIA PRIVATE LIMITED",
"GURUNANAK AIRTECH PRIVATE LIMITED",
"GURUNANAK AUTOTECH PRIVATE LIMITED",
"GURUNANAK BUILDCON PRIVATE LIMITED",
"GURUNANAK ENGINEERING COLLEGE",
"GURUNANAK HYDRAULICS SERVICES PRIVATE LIMITED",
"GURUNANAK INSTITUTE OF DENTAL SCIENCE & RESEARCH",
"GURUNANAK INSTITUTE OF HOTEL MANAGEMENT",
"GURUNANAK PAINTS INDIA PRIVATE LIMITED",
"GURUNANAK POLYTECHNIC FOUNDATION",
"GURUNANAK ROLLER FLOUR MILLS PRIVATE LIMITED",
"GURUNANAK SCIENTIFIC DEVICES PRIVATE LIMITED",
"GURUNANAK TECHNICAL FOUNDATION",
"GURUNATH PHARMA PRIVATE LIMITED",
"GURUNATH TRAVELS PRIVATE LIMITED",
"GURUPRAKIRITHI AGRO FARM PRIVATE LIMITED",
"GURUPRASAD POWER CONTROLS PRIVATE LIMITED",
"GURUPRASAD SALT PRIVATE LIMITED",
"GURUPRIYA HOUSING PRIVATE LIMITED",
"GURUPRIYA TELE-AUTO PRIVATE LIMITED",
"GURURAJ IMPEX PRIVATE LIMITED",
"GURURAJ RADIATORS PRIVATE LIMITED",
"GURURAJA PRECITECH INDUSTRIES PRIVATE LIMITED",
"GURURAJGOVIND LIFESCIENCES WHITEFIELD LLP",
"GURURAYA HOSPITALS PRIVATE LIMITED",
"GURURAYA SOLUTIONS PRIVATE LIMITED",
"GURUSHANKAR GOVT HIGHER SECONDARY",
"GURUSHREE INDUSTRIES PRIVATE LIMITED",
"GURUSHREE MINERALS PRIVATE LIMITED",
"GURUSONS COMMUNICATIONS PRIVATE LIMITED",
"GURUTECH PROJECTS PRIVATE LIMITED",
"GURUTEK ESTATE PRIVATE LIMITED",
"GURUTEK INDIA PRIVATE LIMITED",
"GURUTVAA SYSTEMS PRIVATE LIMITED",
"GURUVAANI FOUNDATION",
"GURUVARYA ACADEMY SCHOOL",
"GURUVAYOOR INFRASTRUCTURE PRIVATE LIMITED",
"GURUVAYUR HOTELS PVT LTD",
"GURUVAYUR INFRATECH PRIVATE LIMITED",
"GURUVAYURAPPAN TEXTILES PRIVATE LIMITED",
"GURUVEDA MARKETING PRIVATE LIMITED",
"GURUWILLING INFRASTRUCTURE PRIVATE LIMITED",
"GUS GLOBAL SERVICES (INDIA) PRIVATE LIMITED",
"GUS GLOBAL SERVICES INDIA PRIVATE LIMITED",
"GUSKARA HIMGHAR PRIVATE LIMITED",
"GUSTAV WOLF SPECIALITY CORDS LIMITED",
"GUSTI TOOL WORKS LLP",
"GUSTIA KHETRA NATH UPPER PRIMARY SCHOOL",
"GUSTO IMPORTS PRIVATE LIMITED",
"GUSTORA FOODS PRIVATE LIMITED",
"GUT GI & LIVER HOSPITAL",
"GUTAM UCCHA PRATHAMIK SHADA",
"GUTE REISE INDIA PRIVATE LIMITED",
"GUTENBERG COMMUNICATIONS PRIVATE LIMITED",
"GUTI UDAYCHAND VIDYAMANDIR",
"GUTS CIRCUIT BREAKERS PRIVATE LIMITED",
"GUTS ELECTRO-MECH LIMITED",
"GUTSHOT ENTERTAINMENT PRIVATE LIMITED",
"GUTSY ENGINEERING PVT LTD",
"GUTTA ENGINEERS PRIVATE LIMITED",
"GUTTASEEMA WIND ENERGY COMPANY PRIVATE LIMITED",
"GUTTERMAN DRAIN INDIA PRIVATE LIMITED",
"GUTTU AGRO FOOD PRIVATE LIMITED",
"GUTURI PHARMA PRIVATE LIMITED",
"GUWAHATI CARBON LIMITED",
"GUWAHATI INTERNATIONAL AIRPORT LIMITED",
"GUWAHATI MEDICAL COLLEGE AND HOSPITAL",
"GUWAHATI METRO HOSPITALS PRIVATE LIMITED",
"GUWAHATI SMART CITY LIMITED",
"GUWAHATI UNIVERSITY",
"GUYBRO ANIMAL HEALTH PRIVATE LIMITED",
"GV AUDIO VISIONN PRIVATE. LIMITED.",
"GV ENERGY SOLUTION PRIVATE LIMITED",
"GV ESTATES AND HOTELS PRIVATE LIMITED",
"GV HIGHER SECONDARY SCHOOL",
"GV KNITS PRIVATE LIMITED",
"GV PHARMA TECHNOLOGIES (OPC) PRIVATE LIMITED",
"GV RESEARCH CENTERS PRIVATE LIMITED",
"GV ROAD PROJECTS PRIVATE LIMITED",
"GVA BUSINESS SOLUTIONS PRIVATE LIMITED",
"GVA INDUSTRIES PRIVATE LIMITED",
"GVANS BIOTECH PRIVATE LIMITED",
"GVECTOR REALTECH PRIVATE LIMITED",
"GVEE INFRA PRIVATE LIMITED",
"GVEENA PACKAGING PRIVATE LIMITED",
"GVFL LIMITED",
"G-VIN PRODUCTS LIMITED",
"GVISION HOSPITALITIES PRIVATE LIMITED",
"GVJ ENTERPRISE INDIA PRIVATE LIMITED",
"GVK CITY PRIVATE LIMITED",
"GVK DEOLI KOTA EXPRESSWAY PRIVATE LIMITED",
"GVK DEVELOPMENTAL PROJECTS PRIVATE LIMITED",
"GVK EMERGENCY MANAGEMENT AND RESEARCH INSTITUTE",
"GVK EMRI UP",
"GVK ENERGY LIMITED",
"GVK JAIPUR EXPRESSWAY LIMITED",
"GVK LOGISTICS PRIVATE LIMITED",
"GVK OIL & GAS LIMITED",
"GVK POWER & INFRASTRUCTRE LIMITED",
"GVK POWER (GOINDWAL SAHIB) LIMITED",
"GVK POWER AND INFRASTRUCTURE LIMITED",
"GVK PROJECTS AND TECHNICAL SERVICES LIMITED",
"GVK TECHNICAL AND CONSULTANCY SERVICES PRIVATE LIMITED",
"GVL ELECTRO CONTROLS PRIVATE LIMITED",
"GVM PUBLICATIONS PRIVATE LIMITED",
"GVM RAIL PRIVATE LIMITED",
"GVMS GGPR COLLAGE OF COMMERCE AND ECONOM",
"GVN FUELS LTD",
"GVN HOSPITAL PRIVATE LIMITED",
"GVN MATERIAL HANDLING PRIVATE LIMITED",
"GVN THE GLOBAL SCHOOL",
"GVOLTS TRANSFORMERS PRIVATE LIMITED",
"GVP FORWARDER PRIVATE LIMITED",
"GVP INFOTECH LIMITED",
"GVP INFRA PROJECTS PRIVATE LIMITED",
"GVP MERCHANTS PRIVATE LIMITED",
"GVP SOFTWARE INDIA PRIVATE LIMITED",
"GVP VIDEO PRIVATE LIMITED",
"GVPR ENGINEERS LIMITED.",
"GVR AJMER NAGAUR TOLLWAY PRIVATE LIMITED",
"GVR AND S COLLEGE OF ENGINEERING AND TECHNOLOGY",
"GVR ASHOKA CHENNAI ORR LIMITED",
"GVR ASSOCIATES PRIVATE LIMITED",
"GVR AUTOMOTIVES PRIVATE LIMITED",
"GVR BEHARI HANUMANA TOLLWAY PRIVATE LIMITED",
"GVR CORPORATE SERVICES PRIVATE LIMITED",
"GVR ELECTRONICS PRIVATE LIMITED",
"GVR ENGINEERING PRIVATE LIMITED",
"GVR INFRA CONSTRUCTIONS INDIA PRIVATE LIMITED",
"GVR INFRATECH PRIVATE LIMITED",
"GVR INSURANCE BROKERS PRIVATE LIMITED",
"GVR KHANDAPHOD BIJWAD ROAD PROJECT PRIVATE LIMITED",
"GVR NUTRIES PRIVATE LIMITED",
"GVR PANNA AMANGANJ TOLLWAY PRIVATE LIMITED",
"GVR PHARMA PRIVATE LIMITED",
"GVR RMN HUBLI LAKSHMESHWAR ROAD PROJECT PRIVATE LIMITED",
"GVR& S COLLEGE OF ENGINEERING & TECHNOLOGY",
"GVS AIR SERVICES INDIA PRIVATE LIMITED",
"GVS ENVICON TEGNOLOGIES PVT. LTD",
"GVS FILTER INDIA PRIVATE LIMITED",
"GVS PROJECTS PRIVATE LIMITED",
"GVV CONSTRUCTIONS PRIVATE LIMITED",
"GVW TECHNOLOGIES PRIVATE LIMITED",
"GW GLOBAL TELECOM INNOVATIONS PRIVATE LIMITED",
"GW IMPEX PRIVATE LIMITED",
"GWALA AGRO STORAGE INDIA PRIVATE LIMITED",
"GWALEC ELECTRICALS PRIVATE LTD",
"GWALIA SWEETS PVT LTD",
"GWALIOR DEVELOPMENT AUTHORITY GWALIOR",
"GWALIOR DISTILLERIES PRIVATE LIMITED",
"GWALIOR FINANCE CORPORATION LIMITED",
"GWALIOR HOTELS PRIVATE LIMITED",
"GWALIOR PATHWAYS PRIVATE LIMITED",
"GWALIOR POLYPIPES LIMITED",
"GWALIOR REGENCY RESORTS INDIA PRIVATE. LIMITED.",
"GWALIOR SAHAKARI DUGDH SANGH MARYADIT",
"GWALIOR SMART CITY DEVELOPMENT CORPORATION LIMITED",
"GWALIOR WEBBING CO. PVT. LTD.",
"GWAMBO STUDIOS PRIVATE LIMITED",
"GWASF QUALITY CASTINGS PRIVATE LIMITED",
"G-WAY FARMS AND RESORTS PRIVATE LIMITED",
"GWB IT SOLUTIONS PRIVATE LIMITED",
"GWC FINANCIAL SERVICES PRIVATE LIMITED",
"GWE INFRA PROJECTS PRIVATE LIMITED",
"GWET AQUA MANAGEMENT PRIVATE LIMITED",
"GWL PROPERTIES LIMITED",
"GWP SOLUTIONS PRIVATE LIMITED",
"GWS ENGINEERS & FABRICATORS PRIVATE LIMITED",
"GX GLASS SALES & SERVICES LIMITED",
"GX INDIA PRIVATE LIMITED",
"GXCI COATINGS PRIVATE LIMITED",
"GXO LOGISTICS INDIA PRIVATE LIMITED",
"GXPRESS SOLUTIONS INDIA PRIVATE LIMITED",
"GXS INDIA TECHNOLOGY CENTRE PRIVATE LIMITED",
"G10X TECHNOLOGY PRIVATE LIMITED",
"GYAANA RETREAT & SERVICES PRIVATE LIMITED",
"GYAANANDA SCHOOL",
"GYAANTECH SOFTWARE SOLUTIONS PRIVATE LIMITED",
"GYAN BHARTI BALIKA INTER COLLEGE",
"GYAN BHARTI M S INTER COLLEGE",
"GYAN BHARTI PUBLIC SCHOOL",
"GYAN BOOKS PRIVATE LIMITED",
"GYAN CIRKITRONICS PRIVATE LIMITED",
"GYAN DATA PRIVATE LIMITED",
"GYAN DEVI SALWAN PUBLIC SCHOOL",
"GYAN ENGINEERING AND MANAGEMENT SERVICES PRIVATE LIMITED",
"GYAN ENTERPRISES PRIVATE LIMITED",
"GYAN ESH TECHTONICS PRIVATE LIMITED",
"GYAN FOOD PRODUCTS PRIVATE LIMITED",
"GYAN FRESH PRIVATE LIMITED",
"GYAN GANGA EDUCATIONAL INSTITUTE PVT LTD",
"GYAN GANGA LIMITED",
"GYAN INFRASTRUCTURE COMPANY PRIVATE LIMITED",
"GYAN INTERNATIONAL PRIVATE LIMITED",
"GYAN KENDRA SECONDARY SCHOOL",
"GYAN LEARNING PRIVATE LIMITED",
"GYAN MARKETING ASSOCIATES PRIVATE LTD.",
"GYAN MATA VIDYA VIHAR",
"GYAN PLANTATIONS PRIVATE LIMITED",
"GYAN PRAKASH FOUNDATION",
"GYAN SAGAR PUBLIC SCHOOL",
"GYAN SARITA VIDHYALAY",
"GYAN SCIENTIFIC TRADERS INDIA PRIVATE LIMITED",
"GYAN STHAL PRIVATE LIMITED",
"GYAN VALLEY CO-ED SCHOOL",
"GYAN VISHNU HOSPITAL PRIVATE LIMITED",
"GYANA DEEP PRODUCTS PRIVATE LIMITED",
"GYANANDA ENGINEERING PRIVATE LIMITED",
"GYANDEEP GLOBAL SCHOOL",
"GYANDEEP KHEMKA COMMODITIES PRIVATE LIMITED",
"GYANDEEP STOCKS PRIVATE LIMITED",
"GYANDEEP VIDHYALAY",
"GYANDHAN FINANCIAL SERVICES PRIVATE LIMITED",
"GYANDHARA EDUCATION PRIVATE LIMITED",
"GYANDHARA INDUSTRIES PRIVATE LIMITED",
"GYANESH HOTELS AND RESORTS PRIVATE LIMITED",
"GYANESHWAR MULTITRADE PRIVATE LIMITED",
"GYANGEETA PRIMARY SCHOOL",
"GYANI INFRATECH PRIVATE LIMITED",
"GYANJYOT ENTERPRISES PRIVATE LIMITED",
"GYANKEER TOBACCO PRODUCTS PRIVATE LIMITED",
"GYANLAXMI SUGAR PRIVATE LIMITED",
"GYANMANJARI SECONDARY AND HIGHER SECONDARY SCHOOL",
"GYANMANJARI VIDHYAPEETH",
"GYANMATA ENGLISH HIGH SCHOOL KHANVEL",
"GYANMATA HIGH SCHOOL (MARATHI)",
"GYANMATA TRADING PRIVATE LIMITED",
"GYANMATRIX TECHNOLOGIES PRIVATE LIMITED",
"GYANMUDRA EDUCATION FOUNDATION",
"GYANMUDRA EDUCATION MAHUVA FOUNDATION",
"GYANODAYA SHIKSHAN PRACHARAK SAMITI",
"GYANS MAESTROS PRIVATE LIMITED",
"GYANSAGAR SEASONINGS & SPICES PRIVATE LIMITED",
"GYANSAGAR TEXTILE PRIVATE LIMITED",
"GYANSAMHITA TECH PRIVATE LIMITED",
"GYANSHANKAR INVESTMENT AND TRADING CO.PVT LTD",
"GYANSHREE SCHOOL",
"GYANSYS INFOTECH PRIVATE LIMITED",
"GYANTI MULTISERVICES PRIVATE LIMITED",
"GYANWAVE IT CONSULTANCY PRIVATE LIMITED",
"GYANWAVE TECHNOLOGY PRIVATE LIMITED",
"GYARSHI DEBIAUTO SERVICES PRIVATE LIMITED",
"GYAYAK ENTERPRISES LIMITED",
"GYAYAK HOSPITAL PRIVATE LIMITED",
"GYAYAK MARKETING PRIVATE LIMITED",
"GYD DIAGNOSTICS AND REFERENCE LABORATORIES PRIVATE LIMITED",
"GYEONGGI BUSINESS CENTER PRIVATE LIMITED",
"GYFT INDIA PVT LTD",
"GYM SOLUTIONS INDIA PRIVATE LIMITED",
"GYMAN CHEMICAL INDIA PVT.LTD.",
"GYMLINE PLUS PRIVATE LIMITED",
"GYMNA UNIPHY INDIA PRIVATE LIMITED",
"GYMPAC FITNESS SYSTEMS PRIVATE LIMITED",
"GYMPAC VENTURES PRIVATE LIMITED",
"GYMS FOR ALL INDIA LIMITED",
"GYMS FOR ALL INDIA LLP",
"GYMTREKKER FITNESS PRIVATE LIMITED",
"GYNOCARE SERVICES PRIVATE LIMITED",
"GYNOFEM HEALTHCARE PRIVATE LIMITED",
"GYNOVEDA FEMTECH PRIVATE LIMITED",
"GYONG XC INDIA PRIVATE LIMITED",
"GYPARCH CEILINGS PRIVATE LIMITED",
"GYPCORE INDIA PRIVATE LIMITED",
"GYPELITE INDIA PRIVATE LIMITED",
"GYPSONITE INDUSTRIES PRIVATE LIMITED",
"GYPSOPIEA PHARMACEUTICAL PRIVATE LIMITED",
"GYPSTAR INDIA PRIVATE LIMITED",
"GYPSUM CLOTHING PRIVATE LIMITED",
"GYPSUM STRUCTURAL INDIA PRIVATE LIMITED",
"GYPSY LOGISTICS PRIVATE LIMITED",
"GYPTECH SYSTEMS PRIVATE LIMITED",
"GYR CAPITAL ADVISORS PRIVATE LIMITED",
"GYRO SCANNING SERVICES PRIVATE LIMITED",
"GYSCOAL ENTERPRISE PRIVATE LIMITED",
"GYU BEEN HOTELS PRIVATE LIMITED",
"H & B STORES LIMITED.",
"H & H INFOTECH AND CONSULTANCY PRIVATE LIMITED",
"H & J EXIM PRIVATE LIMITED",
"H & K ROLLING MILL ENGINEERS PRIVATE LIMITED",
"H & M AVENUE PROJECTS PRIVATE LIMITED",
"H & M HENNES & MAURITZ INDIA PRIVATE LIMITED",
"H & M HENNES & MAURITZ RETAIL PRIVATE LIMITED",
"H & R BLOCK INDIA PRIVATE LIMITED",
"H & R INFRAHEIGHTS PRIVATE LIMITED",
"H & R JOHNSON INDIA TBK LIMITED",
"H & R STEEL DETAILING PRIVATE LIMITED",
"H & S SUPPLY CHAIN SERVICES PRIVATE LIMITED",
"H & W LABS PRIVATE LIMITED",
"H A LOGISTICS PRIVATE LIMITED",
"H A M CONSTRUCTIONS PRIVATE LIMITED",
"H AND FRIENDS GTL (INDIA) PRIVATE LIMITED",
"H AND H EXPORTS (GUJARAT) PRIVATE LIMITED",
"H AND H MECHTECH PRIVATE LIMITED",
"H AND H PHARMACEUTICA PRIVATE LIMITED",
"H AND H PRECISION PRIVATE LIMITED",
"H AND H TECHNOLOGIES PRIVATE LIMITED",
"H AND M HOUSING FINANCE AND LEASING PRIVATE LIMITED",
"H AND R BLOCK INDIA PRIVATE LIMITED",
"H AND V PROJECTS PRIVATE LIMITED",
"H B FULLER INDIA ADHESIVES PRIVATE LIMITED",
"H B INFRA SOLUTIONS PRIVATE LIMITED",
"H B KANWANTIA HOSPITAL - JAIPUR",
"H B POLYMER INDUSTRIES PRIVATE LIMITED",
"H B R CHEMICALS PRIVATE LIMITED",
"H B RUBBER PVT LTD",
"H B S ALLOYS PRIVATE LIMITED",
"H B S SYSTEMS PRIVATE LIMITED",
"H B SHAH PRIVATE LIMITED",
"H B STOCK HOLDINGS",
"H B WOOLTEX PRIVATE LIMITED",
"H C AGRI FRESH PRIVATE LIMITED",
"H C B S PROMOTERS AND DEVELOPERS PRIVATE LIMITED",
"H C BUILDCON PRIVATE LIMITED",
"H C COMMERCIAL LTD",
"H D CONSORTIUM INDIA LIMITED",
"H D ENTERPRISES",
"H D S STEEL TRADERS PRIVATE LIMITED",
"H D SYSTEM SALES PRIVATE LIMITED",
"H D WIRE PRIVATE LIMITED",
"H E C INFRA PROJECT LTD",
"H E GLOBAL PRIVATE LIMITED",
"H ENERGY PRIVATE LIMITED",
"H F ENGINEERING PRIVATE LIMITED",
"H F FLEX PRIVATE LIMITED",
"H FILLUNGER AND COMPANY PRIVATE LIMITED",
"H G CONSULTANCY AND AGROPRODUCE PRIVATE LIMITED",
"H G GRAPHICS PRIVATE LIMITED",
"H G INFRA ENGINEERING LIMITED PART IX",
"BRIDGE GLOBAL SOFTWARE SOLUTIONS PRIVATE LIMITED",
"H H OIL & FLOUR MILLS PRIVATE LIMITED",
"H H TRADERS P.LTD.",
"H HORIZON SUPPORT AND SERVICES PRIVATE LIMITED",
"H J AROCHEM PRIVATE LIMITED",
"H J DOSHI GHATKOPAR HINDUSABHA HOSPITAL",
"H J HIGH SCHOOL",
"H J INDUSTRIES INDIA PRIVATE LIMITED",
"H J PROPERTIES PVT LTD",
"H J REFRIGERATION PRIVATE LIMITED",
"H J SECURITIES PRIVATE LIMITED",
"H J SOFTWARE PRIVATE LIMITED",
"H K CABLE PRIVATE LIMITED",
"H K D DIAMOND LABORATORIES CANADA PRIVATE LIMITED",
"H K DAS AGRWAL PRIVATE LIMITED",
"H K DUTTA & COMPANY PVT LTD",
"H K ENZYMES AND BIOCHEMICALS PRIVATE LIMITED",
"H K EXTRADE PRIVATE LIMITED",
"H K GOEL AND COMPANY PRIVATE LIMITED",
"H K INFRAVISION PRIVATE LIMITED",
"H K JEWELS PRIVATE LIMITED",
"H K MARINES PRIVATE LIMITED",
"H K MERCHANDISE PRIVATE LIMITED",
"H K OFFICE EQUIPMENT COMPANY PRIVATE LIMITED",
"H K PARAKH WELFARE FOUNDATION",
"H K POLYMERS",
"H K POLYPLAST PRIVATE LIMITED",
"H K PRIMARY TRAINING COLLEGE",
"H K PRINTERS PRIVATE LIMITED",
"H K PROFESSIONAL PRIVATE LIMITED",
"H K S IMPEX PRIVATE LIMITED",
"H K T COMMERCIALS PRIVATE LIMITED",
"H L A INVESTMENTS PRIVATE LIMITED",
"H L AGRO PRODUCTS PRIVATE LIMITED",
"H L GANDHI ENTERPRISES PRIVATE LIMITED",
"H L JAIN ICE AND COLD STORAGE PRIVATE LIMITED",
"H L PASSEY ENGINEERING PRIVATE LIMITED",
"H L RESIDENCY PRIVATE LIMITED",
"H L SETT & SONS PVT LTD",
"H L STEEL PVT LTD",
"H L TEXTILES LIMITED",
"H M A UDYOG PRIVATE LIMITED",
"H M AGRIEXPORTS PRIVATE LIMITED",
"H M B S TEXTILES PRIVATE LIMITED",
"H M CASTLON PRIVATE LIMITED",
"H M CONDUCTORS AND ENGINEERS PRIVATE LIMITED",
"H M ENTERPRISE",
"H M F CARPETS PVT LTD",
"H M FOODS INDIA PRIVATE LIMITED",
"H M GOVT POST BASIC ASHRAM SCHOOL NALA",
"H M GOVT SEC SCHOOL GIRWA",
"H M GRAINS AND PULSES PROCESSING PRIVATE LIMITED",
"H M HOSPITAL",
"H M IMPOEXPO PRIVATE LIMITED",
"H M INDUSTRIES",
"H M INTERCRAFTS PRIVATE LIMITED",
"H M MOTORS PRIVATE LIMITED",
"H M PATEL INSTITUTE",
"H M RAJE STRUCTURAL CONSULTANTS PRIVATE LIMITED",
"H M S INFOTECH PRIVATE LIMITED",
"H M STEELS LIMITED",
"H M T LIMITED",
"H M TALAT HIGH SCHOOL",
"H M TEXTILES PRIVATE LIMITED",
"H M TOWERS PRIVATE LIMITED",
"H M W METAL WORKS PVT LTD",
"H MUKERJI & BANERJEE SURGICAL P LTD",
"H N CONSTRUCTION PRIVATE LIMITED",
"H N COTEX PRIVATE LIMITED",
"H N KUNDU & ASSOCIATES PRIVATE LIMITED",
"H N PROTECH PRIVATE LIMITED",
"H NYALCHAND REALTY PRIVATE LIMITED",
"H ONE INDIA PRIVATE LIMITED",
"H P AUTOMATION PRIVATE LIMITED",
"H P CHILDRENS ACADEMY",
"H P DOSHI CLOTHING PRIVATE LIMITED",
"H P G CONSULTING INDIA PRIVATE LIMITED",
"H P I HOTELS AND PROPERTIES PRIVATE LIMITED",
"H P IMPORTS PRIVATE LIMITED",
"H P ISPAT PRIVATE LIMITED",
"H P UNIVERSITY",
"H P VALVES & FITTINGS INDIA PRIVATE LIMITED",
"H PARSON PRIVATE LIMITED",
"H PRAKASH",
"H R ASSOCIATES PRIVATE LIMITED",
"H R B FOOD PRODUCTS PRIVATE LIMITED",
"H R D AGRO PRIVATE LIMITED",
"H R EXPORTS PRIVATE LIMITED",
"H R HERBALS PRIVATE LIMITED",
"H R HOSPITAL AND TRAUMA CENTRE",
"H R HYGIENE PRODUCTS PRIVATE LIMITED",
"H R ISPAT PRIVATE LIMITED",
"H R ORGANO CHEM PRIVATE LIMITED",
"H R PIPES PRIVATE LIMITED",
"H R PROPERTIES PRIVATE LIMITED",
"H R RICE MILLS PRIVATE LIMITED",
"H R TREE OUTSOURCING SOLUTION PRIVATE LIMITED",
"H S & E INSTITUTE PRIVATE LIMITED",
"H S B P V T GOI FACULTY OF ENGINEERING KASHTI",
"H S BRANDS PRIVATE LIMITED",
"H S BUILDERS",
"H S CONTAINERS PRIVATE LIMITED",
"H S EXIM PRIVATE LIMITED",
"H S INDIA LIMITED",
"H S INFRATECH PRIVATE LIMITED",
"H S JEWELS BUDAUN PRIVATE LIMITED",
"H S KANTHI INDUSTRIAL GASES PRIVATE LIMITED",
"H S MASS MEDIA PRIVATE LIMITED",
"H S MEDIA AND FILMS PRIVATE LIMITED",
"H S MEHTA INFRA PRIVATE LIMITED",
"H S MERCANTILE LIMITED",
"H S NAG AND ASSOCIATES PRIVATE LIMITED",
"H S OVERSEAS PRIVATE LIMITED",
"H S PATHOLOGY LUCKNOW LAB",
"H S PATHOLOGY PRIVATE LIMITED",
"H S POLYMERS PRIVATE LIMITED",
"H S PORTFOLIO PRIVATE LIMITED",
"H S POWER PROJECTS PRIVATE LIMITED",
"H S R REROLLERS PRIVATE LIMITED",
"H S SANGHAVI PRIVATE LIMITED",
"H S SERVICES PRIVATE LIMITED",
"H S SONS CONTRACTS PRIVATE LIMITED",
"H S STRIPS PRIVATE LIMITED",
"H S WOOLLEN MILLS PVT LTD",
"H T C DIESEL ENGINES PRIVATE LIMITED",
"H T ENGINEERS(GUJ)PRIVATE LIMITED",
"H T L LOGISTICS INDIA PRIVATE LIMITED",
"H T NANAVATI SECURITIES PRIVATE LIMITED",
"H T PAREKH FOUNDATION",
"H THIRTY SIX ENTERPRISES PRIVATE LIMITED",
"H V AIRCONDITIONING SYSTEMS PRIVATE LIMITED",
"H V GLOBAL PRIVATE LIMITED",
"H V IMPEX PRIVATE LIMITED",
"H V INFRABUILD PRIVATE LIMITED",
"H V INFRATEX LIMITED",
"H V PROJECTS PVT LTD",
"H W OUTSOURCING MARKETING PRIVATE LIMITED",
"H&B HR SOLUTIONS PRIVATE LIMITED",
"H&C DISTRIBUTORS PRIVATE LIMITED",
"H&K INFOSOFT SOLUTION PRIVATE LIMITED",
"H&M SERVICES PRIVATE LIMITED",
"H&R BLOCK INDIA PRIVATE LIMITED",
"H&R INDIA SALES PRIVATE LIMITED",
"H&R JOHNSONINDIA",
"H&S SOFTWARE DEVELOPMENT AND KNOWLEDGE MANAGEMENT CENTRE PRIVATE LIMITED",
"H&V ADVANCED MATERIALS (INDIA) PRIVATE LIMITED",
"H&V AGRI SEEDS PRIVATE LIMITED",
"H. B. METAL PRIVATE LIMITED",
"H. B. METALS",
"H. B. VYAS AUTOMOTIVE PRIVATE LIMITED",
"H. DAYA ENTERPRISES PRIVATE LIMITED",
"H. ENGINEERING MARINE COMPANY PRIVATE LIMITED",
"H. G. INFRA TOLL WAY PRIVATE LIMITED",
"H. H. KNITFAB PRIVATE LIMITED",
"H. K. BUTTONS PRIVATE LIMITED",
"H. K. FASHIONS (INDIA) PRIVATE LIMITED",
"H. K. ISPAT PRIVATE. LIMITED.",
"H. K. SURANA JEWELLERS PRIVATE LIMITED",
"H. L. HANDA CONST. PRIVATE LIMITED",
"H. L. PRINTECH SOLUTIONS PRIVATE LIMITED",
"H. M. & COMPANY MEDISALES PRIVATE LIMITED",
"H. M. DIWAN JEWELLERS PRIVATE LIMITED",
"H. M. X. EXPORTS PRIVATE LIMITED",
"H. N. ABDUL MATIN & CO. FABRICS PRIVATE LIMITED",
"H. N. AGRI SERVE PRIVATE LIMITED",
"H. P. BUILDERS PRIVATE. LIMITED.",
"H. P. FABTEX PRIVATE LIMITED",
"H. P. GUPTA & SON ADVISORY PRIVATE LIMITED",
"H. P. SINGH AGENCIES PRIVATE LIMITED",
"H. P. VALVES PRIVATE LIMITED",
"H. R. AGROCON PRIVATE LIMITED",
"H. R. ONE MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"H. R. STEEL INDUSTRIES PRIVATE LIMITED",
"H. R. THREADS PRIVATE LIMITED",
"H. S. JOGANI & SONS PRIVATE LIMITED",
"H. SARKER & COMPANY VALVES PRIVATE LIMITED",
"H. V. R. INDUSTRIES PRIVATE LIMITED",
"H.A.G. PROPERTIES & BUILDERS PRIVATE LIMITED",
"H.A.G.CARPETS PRIVATE LIMITED",
"H.B. RICE MILL PRIVATE LIMITED",
"H.C. GUPTA EDUCATIONAL FOUNDATION",
"H.D. TRAILERS PRIVATE LIMITED",
"H.E.A.L. INSTITUTE PRIVATE LIMITED",
"H.F STEEL AND ALLOYS PRIVATE LIMITED",
"H.G. INFRA ENGINEERING PRIVATE LIMITED PART IX",
"H.G. INFRATECH PRIVATE LIMITED",
"H.G. LUXURY HOTELS PRIVATE LIMITED",
"H.G. REWARI BYPASS PRIVATE LIMITED",
"H.G.S.MACHINES PRIVATE LIMITED",
"H.GURU INSTRUMENTS (NORTH INDIA) PVT LTD",
"H.H. INFRACON PRIVATE LIMITED",
"H.I.S. TRAVEL (INDIA) PRIVATE LIMITED",
"H.J. HEINZ COMPANY",
"H.J. WELFARE FOUNDATION",
"H.J.C.FOODS PRIVATE LIMITED",
"H.J.FASHIONS PRIVATE LIMITED",
"H.J.S. COMMERCIAL PRIVATE LIMITED",
"H.J.S.GRANITES PRIVATE LIMITED",
"H.K. FABRICS PRIVATE LIMITED",
"H.K.TUBES PRIVATE LIMITED",
"H.L. GAHLOT BUILDERS PRIVATE LIMITED",
"H.L. POLYPACKS PRIVATE LIMITED",
"H.L.HEALTHCARE PRIVATE LIMITED",
"H.M PREPARATORY SCHOOL",
"H.M. ELECTRO MECH LIMITED",
"H.M. SAREE PRIVATE LIMITED",
"H.M. TUBES AND CONTAINERS PVT. LTD. (TRANSFER FROM DELHI TO RA",
"H.M.G. ECO-CARE RECYCLING PRIVATE LIMITED",
"H.M.S.BUILDCON PRIVATE LIMITED",
"H.M.T. (INTERNATIONAL) LIMITED",
"H.M.YARNS PRIVATE LIMITED",
"H.MAHENDRA TOWELS PRIVATE LIMITED",
"H.N AGRICHAIN PRIVATE LIMITED",
"H.N. INFRASTRUCTURE PRIVATE LIMITED",
"H.P. BUILDERS PRIVATE LIMITED",
"H.P. FASTENERS PRIVATE LIMITED",
"H.P.CARGO MOVERS LIMITED",
"H.P.INVESTMENTS PRIVATE LIMITED",
"H.P.R. CARGO PRIVATE LIMITED",
"H.P.R. TRANSPORTS LIMITED",
"H.P.R. TRANSWAYS PRIVATE LIMITED",
"H.P.S. AIR SYSTEMS PRIVATE LIMITED",
"H.P.SHUKLA CONTRACTORS AND FINVEST PVT LTD",
"H.P.SINGH MACHINERY PVT LTD",
"H.Q LAMPS MANUFACTURING CO PRIVATE LIMITED",
"H.R. BUILDTECH PRIVATE LIMITED",
"H.R. CONSTRUCTION PRIVATE LIMITED",
"H.R. EDUCATIONAL FOUNDATION TRUST",
"H.R. POWER PROJECTS PRIVATE LIMITED",
"H.R. ROLLER FLOUR MILLS PRIVATE LIMITED",
"H.R. SOLAR SOLUTION PRIVATE LIMITED",
"H.R.& CO. PRIVATE LIMITED",
"H.R.D.SPECIALTIES HEALTH CARE PRIVATE LIMITED",
"H.R.ENGINEERING WORKS PRIVATE LIMITED",
"H.R.M. POLYPLAST PRIVATE LIMITED",
"H.R.VINIMAY PRIVATE LIMITED",
"H.S. PRINT SERVICE PRIVATE LIMITED.",
"H.S.S INDUSTRIES PRIVATE LIMITED",
"H.T. POLYMER AND RECLAIM RUBBER INDUSTRIES PRIVATE LIMITED",
"H.T.TEA & ALLIED PRODUCTS PRIVATE LIMITED",
"H.U.GUGLE BIOTECH PRIVATE LIMITED",
"H.V. AROMATIC PRIVATE LIMITED",
"H.V. TEXT AND GARMENTS PRIVATE LIMITED",
"H.V.EQUIPMENTS PRIVATE LIMITED",
"H.V.POLYFILMS PRIVATE LIMITED",
"H/MS GOVT HIGH SCHOOL",
"H1 HR SOLUTIONS PRIVATE LIMITED",
"H2 ADVISORY & MARKETING PRIVATE LIMITED",
"H2E POWER SYSTEMS PRIVATE LIMITED",
"H2O GRAPHICS AND DESIGNS PRIVATE LIMITED",
"H2O GRAPHIX PRIVATE LIMITED",
"H2O MANAGEMENT SERVICES PRIVATE LIMITED",
"H2O MANTRA PRIVATE LIMITED",
"H2O MINERAL WATER PVT. LTD",
"H2O POOLS PRIVATE LIMITED",
"H2O TAPS PRIVATE LIMITED",
"H2O TECH LABS PRIVATE LIMITED",
"H5 ASIA PACIFIC PRIVATE LIMITED",
"HA HIRELING PRIVATE LIMITED",
"HA4.0 MANUFACTURING PRIVATE LIMITED",
"HAACT DC SOLUTIONS INDIA PRIVATE LIMITED",
"HAAD INDUSTRIES PRIVATE LIMITED",
"HAAD SERVICES AND CONSTRUCTION PRIVATE LIMITED",
"HAAMI VENTURES PRIVATE LIMITED",
"HAAMID REAL ESTATES PRIVATE LIMITED",
"HAARDIK ISHANI FABRICATIONS PRIVATE LIMITED",
"HAARDIK NAYAK FINANCIAL PRODUCTS DISTRIBUTION PRIVATE LIMITED",
"HAARDIK TEXTILES PRIVATE LIMITED",
"HAARISH EQUIPMENTS PRIVATE LIMITED",
"HAARTZ AUTOMOTIVE INDIA PRIVATE LIMITED",
"HAARTZ ORGANICS PRIVATE LIMITED",
"HAAS ENGINEERING SYSTEMS & SOLUTIONS PRIVATE LIMITED",
"HAAT INCINERATORS INDIA PRIVATE LIMITED",
"HAB PHARMACEUTICALS AND RESEARCH LIMITED",
"HABANERO FOODS INTERNATIONAL PRIVATE LIMITED",
"HABASIT INDIA PRIVATE LIMITED",
"HABEEB TANNING COMPANY",
"HABEEBEE FOODS & BEVERAGES PRIVATE LIMITED",
"HABEN DEVELOPERS PRIVATE LIMITED",
"HABHIT WELLNESS PRIVATE LIMITED",
"HABIB COLD STORAGE PRIVATE LIMITED",
"HABIB SOLVEX PRIVATE LIMITED",
"HABIB TANNERY PRIVATE LIMITED",
"HABIB TEXTILE PRIVATE LIMITED",
"HABIBA ENTERPRISES PRIVATE LIMITED",
"HABIBS COSMETICS PRIVATE LIMITED",
"HABILELABS PRIVATE LIMITED",
"HABILISS SYSTEMS PRIVATE LIMITED",
"HABITAAT TEXTILDECORS PRIVATE LIMITED",
"HABITARE HOTERU PRIVATE LIMITED",
"HABITARE PHARMA PRIVATE LIMITED",
"HABITAT DESIGN & ARTS PRIVATE LIMITED",
"HABITAT DESIGN CONSULTANTS PRIVATE LIMITED",
"HABITAT DEVELOPERS INC",
"HABITAT ENVIRO SOLUTIONS PRIVATE LIMITED",
"HABITAT GENOME IMPROVEMENT PRIMARY PRODUCER COMPANY LIMITED",
"HABITAT INFRASTRUCTURE PRIVATE LIMITED",
"HABITAT MICRO BUILD INDIA HOUSING FINANCE COMPANY PRIVATE LIMITED",
"HABITATE GARDEN PRIVATE LIMITED",
"HABITECH INFRASTRUCTURE LIMITED",
"HABITUS HR SOLUTIONS PRIVATE LIMITED",
"HABLIS HOTELS PRIVATE LIMITED",
"HABOG CONSULTANTS PRIVATE LIMITED",
"HABOR PAUL INTERNATIONAL PRIVATE LIMITED",
"HABRA MUNICIPALITY",
"HABRA SHREE LAKSHMI NARAYAN ROLLAR FLOUR AND DALL MILL PRIVATE LIMITED",
"HABSONS BUILDERS AND INFRASTRUCTURE LTD",
"HABSONS INFORMATION TECHNOLOGY SERVICES PRIVATE LIMITED",
"HABSONS JOBSUP LIMITED",
"HABTEQ PROJECTS PRIVATE LIMITED",
"HABUFA MEUBELEN BV",
"HABULUS BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"HABY ENGINEERING WORKS PRIVATE LIMITED",
"HAC HEARING AID CENTRE PRIVATE LIMITED",
"HACER RAIL TECHNOLOGIES PRIVATE LIMITED",
"HACH OTT INDIA PRIVATE LIMITED",
"HACHETTE BOOK PUBLISHING INDIA PRIVATE LIMITED",
"HACIENDA ESTATES PRIVATE LIMITED",
"HACKETT GROUP (INDIA) PRIVATE PRIVATE LIMITED",
"HACKMYWAY TECHNOLOGIES PRIVATE LIMITED",
"HACKOVA DIGITAL PRINT",
"HACKOVA DIGITAL PRINTS",
"HACO MACHINERY PRIVATE LIMITED",
"HACS SECURITY SERVICES AND INFRA-TEL PRIVATE LIMITED",
"HACTCOM AGRO PRIVATE LIMITED",
"HADAS CBSC SCHOOL",
"HADDOWS INFOTECH PRIVATE LIMITED",
"HADEE FORGINGS PRIVATE LIMITED",
"HADEED ENGINEERING INDIA PRIVATE LIMITED",
"HADEN SYSTEMS PRIVATE LIMITED",
"HADHAD PREMIUM STEELS PRIVATE LIMITED",
"HADI TEHERANI PROJECT CONSULTANTS (INDIA) PRIVATE LIMITED",
"HADIPUR SAHA ANOWARUL ULUM ISLAMIA SR MADRASAH",
"HADIRAH STEELS PRIVATE LIMITED",
"HADISO CONSTRUCTIONS PRIVATE LIMITED",
"HADOTI MAHILA KISAN PRODUCER COMPANY LIMITED",
"HADOTI METALS AND MINERALS PRIVATE LIMITED",
"HADOTI POWER TRANSMISSION SERVICE LIMITED",
"HADRON SYSTEM PRIVATE LIMITED",
"HADWOK EXPORTS PRIVATE LIMITED",
"HAEAL ENTERPRISES PRIVATE LIMITED",
"HAEBEACH FOOD AND AGRO PRIVATE LIMITED",
"HAECOM TELESYS PRIVATE LIMITED",
"HAESOK SHIPPING INDIA PRIVATE LIMITED",
"HAFA FROZEN FOODS INTERNATIONAL PRIVATE LIMITED",
"HAFED",
"HAFEEZ LIFESTYLE PRIVATE LIMITED",
"HAFEEZ SONS TANNERY PRIVATE LIMITED",
"HAFELE INDIA PRIVATE LIMITED",
"HAFFER ELECTRO PLAST PRIVATE LIMITED",
"HAFFKINE AJINTHA PHARMACEUTICALS LIMITED",
"HAFFKINE BIO-PHARMACEUTICAL CORPORATION LIMITED",
"HAFFKINE INSTITUTE FOR TRAINING RESEARCH AND TESTING",
"HAFI ELEKTRA PRIVATE LIMITED",
"HAFIZ AGRO INTERNATIONAL PRIVATE LIMITED",
"HAFIZ CONSTRUCTION COMPANY PRIVATE LIMITED",
"HAFIZIA ART AND CRAFTS PRIVATE LIMITED",
"HAFLONG BUSINESS SOLUTIONS PRIVATE LIMITED",
"HAFSHA TRADING PRIVATE LIMITED",
"HAGEN AQUA PRIVATE LIMITED",
"HAGER ELECTRO PRIVATE LIMITED",
"HAGES BUSINESS SOLUTIONS PRIVATE LIMITED",
"HAGG MILL STORE PRIVATE LIMITED",
"HAGGS IT SOLUTIONS PRIVATE LIMITED",
"HAGIWARA ELECTRONICS INDIA PRIVATE LIMITED",
"HAGNOS MARKETING AND CONSULTING PRIVATE LIMITED",
"HAGNOUS BIOCEUITICALS PRIVATE LIMITED",
"HAGUR TECH PRIVATE LIMITED",
"HAH FREIGHT PRIVATE LIMITED",
"HAHN KOLB TOOLS PRIVATE LIMITED",
"HAHNEMANN PUBLISHING CO PVT LTD",
"HAHNTEC SECURITY NETWORKS PRIVATE LIMITED",
"HAI MEDI-CARE AND RESEARCH INSTITUTE PRIVATE LIMITED",
"HAICHENG VIVO MOBILE INDIA PRIVATE LIMITED",
"HAIDEN TECHNOLOGY PRIVATE LIMITED",
"HAIER APPLIANCES INDIA PRIVATE LIMITED",
"HAIER SMART SOLUTION PRIVATE LIMITED",
"HAIFEI SOLAR INTERNATIONAL PRIVATE LIMITED",
"HAIGER INDIA AIR CONDITIONING PRIVATE LIMITED",
"HAIJIN TRADE INDIA PRIVATE LIMITED",
"HAIKAWA APPLIANCES PRIVATE LIMITED",
"HAIKO LOGISTICS INDIA PRIVATE LIMITED",
"HAIKU MOTORS PRIVATE LIMITED",
"HAIL MEDIPRODUCTS PRIVATE LIMITED",
"HAILEYBURIA TEA ESTATES LTD",
"HAILSTONE INNOVATIONS PRIVATE LIMITED",
"HAIMA POLYMERS PVT LTD",
"HAIMA PROJECTS PRIVATE LIMITED",
"HAIMAVATHY PROPERTIES PRIVATE LIMITED",
"HAIMER INDIA PRIVATE LIMITED",
"HAIMI AGRO CHEMICALS PRIVATE LIMITED",
"HAIMISH WINDOWS PRIVATE LIMITED",
"HAIN CELESTIAL INDIA PRIVATE LIMITED",
"HAIN FUTURE NATURAL PRODUCT PRIVATE LIMITED",
"HAINOR NUTRITION PRIVATE LIMITED",
"HAIQI EXHIBITION PRIVATE LIMITED",
"HAIR MASTERS SALON PRIVATE LIMITED",
"HAIR WIG HOUSE PRIVATE LIMITED",
"HAIRBITAT HAIR TREATMENT INDIA PRIVATE LIMITED",
"HAIRFREE & HAIRGROW CLINIC",
"HAIRLINE DIAGNOSTICS AND HEALTH CARE PRIVATE LIMITED",
"HAIRPRO INDIA PRIVATE LIMITED",
"HAITECH MEDICAL SOLUTIONS PRIVATE LIMITED",
"HAITECH SOLUTIONS PRIVATE LIMITED",
"HAITEK INDUSTRIAL FABRICS PRIVATE LIMITED",
"HAITIAN HUAYUAN MACHINERY INDIA PRIVATE LIMITED",
"HAITONG SECURITIES INDIA PRIVATE LIMITED",
"HAJ COMMITEE OF INDIA",
"HAJ COMMITTEE OF INDIA",
"HAJARE SALES PRIVATE LIMITED",
"HAJARIA SECURITY SERVICE",
"HAJARIA SOFT SERVICES PRIVATE LIMITED",
"HAJEE AP BAVA INFRA PRIVATE LIMITED",
"HAJEE MOOSA FABRICS PRIVATE LIMITED",
"HAJI ANOWAR RICE MILL PRIVATE LIMITED",
"HAJI BADLU SARDAR URDU PRIMARY SCHOOL",
"HAJI DALLKHAN U B HIGH SCHOOL HODKA",
"HAJI HOHAMMAD USMAN MARATHI PRIMARY SCHOOL",
"HAJI MAJIDULLAH FASHION PRIVATE LIMITED",
"HAJI NAIMUDDIN URDU PRIMARY SCHOOL LATUR",
"HAJI TEXTILES PRIVATE LIMITED",
"HAJRA MEDICAL AGENCY PRIVATE LIMITED",
"HAJWANE'S HEALTHCARE PRIVATE LIMITED",
"HAK HOSPITAL PRIVATE LIMITED",
"HAK TURNKEY SOLUTIONS PRIVATE LIMITED",
"HAKAM FLUID POWER PRIVATE LIMITED",
"HAKANSSON SAWS INDIA PRIVATE LIMITED",
"HAKASA WOOD DECORS PRIVATE LIMITED",
"HAKE AGRO PRODUCER COMPANY LIMITED",
"HAKICO FOODS PRIVATE LIMITED",
"HAKIM AALIM HAIR LOUNGE PRIVATE LIMITED",
"HAKIM KISHORI LAL HOSPITAL PRIVATE LIMITED",
"HAKIM SYED UL GOVT UNANI MEDI COLG",
"HAKITA FEEDS PRIVATE LIMITED",
"HA-KO INDUSTRIES PRIVATE LIMITED",
"HAKUHODO SYNC PRIVATE LIMITED",
"HAKUHODO.LYNC PRIVATE LIMITED",
"HAKUHODO.WYNG PRIVATE LIMITED",
"HAKUNA MATATA SOLUTIONS PRIVATE LIMITED",
"HAL EDUCATION COMMITTEE",
"HAL OFFSHORE LIMITED",
"HAL OFFSHORE LIMITED.",
"HALA INFOSEC PRIVATE LIMITED",
"HALA MOBILITY INDIA PRIVATE LIMITED",
"HALADHAR FARM PRODUCER COMPANY LIMITED",
"HALAL INDIA PRIVATE LIMITED",
"HALANI FOODS PRIVATE LIMITED",
"HALAPLAY TECHNOLOGIES PRIVATE LIMITED",
"HALASURU REFERRAL HOSPITAL",
"HALBIT AVIONICS PRIVATE LIMITED",
"HALCOM MARKETING PRIVATE LIMITED",
"HALCON ELEVATORS PRIVATE LIMITED",
"HALCROW CONSULTING INDIA PRIVATE LTD",
"HALCYON AIR PRODUCTS PRIVATE LIMITED",
"HALCYON BUSINESS SOLUTION",
"HALCYON FOOD AND BEVERAGES PRIVATE LIMITED",
"HALCYON INN HOPITALITY SERVICES PRIVATE LIMITED",
"HALCYON LABS PRIVATE LIMITED",
"HALCYON SOFT SOLUTIONS PRIVATE LIMITED",
"HALCYON TECHNOLOGIES PRIVATE LIMITED",
"HALCYON TRADING PRIVATE LIMITED",
"HALCYONMINDS TECH LLP",
"HALDEN GLOBAL BIZ PRIVATE LIMITED",
"HALDER VENTURE LIMITED",
"HALDEX ANAND INDIA PRIVATE LIMITED",
"HALDHAR DEVELOPERS PRIVATE LIMITED",
"HALDHAR INFRASTRUCTURE PRIVATE LIMITED",
"HALDHAR PRODUCER COMPANY LIMITED",
"HALDHAR SEEDS & AGROTECH PRIVATE LIMITED",
"HALDI RAM PRODUCTS PRIVATE LIMITED",
"HALDIA AGRO PRIVATE LIMITED",
"HALDIA DOWN STREAM POLYMERS (P) LTD.",
"HALDIA FLOATING TERMINAL PRIVATE LIMITED",
"HALDIA INTERNATIONAL CONTAINER TERMINAL PRIVATE LIMITED",
"HALDIA INVESTMENT CO LTD",
"HALDIA LOGISTICS PRIVATE LIMITED",
"HALDIA NIRMAN PROJECTS PRIVATE LIMITED",
"HALDIA PETROCHEMICALS LIMITED",
"HALDIA PRECISION ENGINEERING PVT LTD",
"HALDIA RIVERSIDE ESTATES LIMITED",
"HALDIA STEELS LIMITED.",
"HALDIA THERMOPACK PRIVATE LIMITED",
"HALDIA WATER SERVICES PRIVATE LIMITED",
"HALDIRAM BHUJIAWALA LTD",
"HALDIRAM ETHNIC FOODS PRIVATE LIMITED",
"HALDIRAM FOODS INTERNATIONAL PRIVATE LIMITED",
"HALDIRAM INCORPORATION PRIVATE LIMITED",
"HALDIRAM MANUFACTURING COMPANY PRIVATE LIMITED",
"HALDIRAM MARKETING PRIVATE LIMITED",
"HALDIRAM MARKETING PVT LTD",
"HALDIRAM PRODUCTS PRIVATE LIMITED",
"HALDIRAM SNACKS PRIVATE LIMITED",
"HALDOR TOPSOE INDIA PRIVATE LIMITED",
"HALDYN GLASS LIMITED",
"HALDYN HEINZ FINE GLASS PRIVATE LIMITED",
"HALE LIFE SCIENCES PRIVATE LIMITED",
"HALEF INTERNATIONAL PRIVATE LIMITED",
"HALEN CERAMICS PVT LTD",
"HALEWOOD LABORATORIES PRIVATE LIMITED",
"HALF & HALF SHOES PRIVATE LIMITED",
"HALF CIRCLES MEDIA PRIVATE LIMITED",
"HALFEN MOMENT INDIA PRIVATE LIMITED",
"HALFMIND PRIVATE LIMITED",
"HALFTONE DIE MAKERS PRIVATE LIMITED",
"HALIDES CHEMICALS PRIVATE LIMITED",
"HALIDON LOGISTICS LIMITED",
"HALISCAPE BUSINESS SOLUTIONS PRIVATE LIMITED",
"HALKIN HOLDINGS PRIVATE LIMITED",
"HALKYN FOOD TECHNOLOGIES PRIVATE LIMITED",
"HALL OF MEAT PRIVATE LIMITED",
"HALLBRIDGE EDUCATION CONSULTANCY PRIVATE LIMITED",
"HALLELU CLM FOOTWEAR LLP",
"HALLELU GLOBAL DISTRIBUTION PRIVATE LIMITED",
"HALLEYS BLUE STEELS PRIVATE LIMITED",
"HALLEYS MOTORS PRIVATE LIMITED",
"HALLI LABS PRIVATE LIMITED",
"HALLIBURTON DEVELOPMENT CENTER INDIA LLP",
"HALLIBURTON ENERGY SERVICES INC.",
"HALLIBURTON INDIA OPERATIONS PRIVATE LIMITED",
"HALLIBURTON OFFSHORE SERVICES INC",
"HALLIBURTON TECHNOLOGY INDIA PRIVATE LIMITED",
"HALLIM PRECISION CONSTRUCTION & TRADING PRIVATE LIMITED",
"HALLITE SEALING SOLUTIONS INDIA PRIVATE LIMITED",
"HALLMARK ADVANCED TECHNOLOGY PRIVATE LIMITED",
"HALLMARK AGRO PACKING (INDIA) PRIVATE LIMITED",
"HALLMARK AQUAEQUIPMENT PRIVATE LIMITED",
"HALLMARK AUTOMATION PRIVATE LIMITED",
"HALLMARK AUTOMOTIVE PRIVATE LIMITED",
"HALLMARK BOILERS PRIVATE LIMITED",
"HALLMARK BUILDERS",
"HALLMARK DEALER PRIVATE LIMITED",
"HALLMARK ELEVATORS PRIVATE LIMITED",
"HALLMARK GLOBAL TECHNOLOGIES LIMITED",
"HALLMARK INDIA PRIVATE LIMITED",
"HALLMARK INDUSTRIES",
"HALLMARK INDUSTRIES PVT.LTD.",
"HALLMARK INFRASTRUCTURE PRIVATE LIMITED",
"HALLMARK IT HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"HALLMARK LOGISTICS PRIVATE LIMITED",
"HALLMARK METALS PRIVATE LIMITED",
"HALLMARK POLYMERS PRIVATE LIMITED",
"HALLMARK TECHNICAL SERVICES PVT LTD",
"HALLMARK TOWNSHIPS PRIVATE LIMITED",
"HALLMARK VYAPAAR PRIVATE LIMITED",
"HALLOW SECURITIES PVT LTD",
"HALLWORTHY SHIPPING LIMITED S.A",
"HALMA INDIA PRIVATE LIMITED",
"HALO AIRWAYS PRIVATE LIMITED",
"HALO ENERGIE CHALLAKI PRIVATE LIMITED",
"HALO ENERGIE CHITRADURGA PRIVATE LIMITED",
"HALO ENERGIE PRIVATE LIMITED",
"HALO MEDIA WORKS PRIVATE LIMITED",
"HALO NUTRITION PRIVATE LIMITED",
"HALODOC TECHNOLOGIES LLP",
"HALOL LEATHER CLOTH PRIVATE LIMITED",
"HALOMAX LIGHTING SOLUTIONS PRIVATE LIMITED",
"HALONIX TECHNOLOGIES PRIVATE LIMITED",
"HALOOCOM TECHNOLOGIES PRIVATE LIMITED",
"HALOPOLY INDUSTRIES PRIVATE LIMITED",
"HALOS CREATIONS PRIVATE LIMITED",
"HALOSOURCE TECHNOLOGIES PRIVATE LIMITED",
"HALPAWAT INDIA PRIVATE LIMITED",
"HALS BLUE OVERSEAS PRIVATE LIMITED",
"HALSTON SOFTWARE",
"HALSYS IT SOLUTIONS PRIVATE LIMITED",
"HALT DOS.COM PRIVATE LIMITED",
"HALTECH PROJECTS PRIVATE LIMITED",
"HALTECH SWITCHGEAR INDIA PRIVATE LIMITED",
"HALTEN ROOFING PRIVATE LIMITED",
"HALTON HEALTHCARE PRIVATE LIMITED",
"HALTON INDIA PRIVATE LIMITED",
"HALWASIYA DEVELOPMENTS PRIVATE LIMITED",
"HALWASIYA PROPERTIES PRIVATE LIMITED",
"HALWASIYA PVT LTD",
"HALYARD HEALTH INDIA PRIVATE LIMITED",
"HAMABO INDIA PRIVATE LIMITED",
"HAMAL HYDEL LIMITED",
"HAMAL PANCHAYAT KASHTKARI VIDHYALAY",
"HAMARA HOTELS PRIVATE LIMITED",
"HAMARA INDUSTRIES PRIVATE LIMITED",
"HAMARA SHELTERS PRIVATE LIMITED",
"HAMARA VENTURES PRIVATE LIMITED",
"HAMBARDE AGROVET PRIVATE LIMITED",
"HAMBIRRAO INFRASTRUCTURES LIMITED",
"HAMBURG SUD INDIA PRIVATE LIMITED",
"HAMCO ISPAT PRIVATE LIMITED",
"HAMCO POWER VENTURES PRIVATE LIMITED",
"HAMDAAN AGRO INDUSTRIES PRIVATE LIMITED",
"HAMDAAN TRAVELS PRIVATE LIMITED",
"HAMDARD INSTITUTE OF MEDICAL SCIENCES & RESEARCH",
"HAMDARD LABORATORIES INDIA",
"HAMDARD LABORATORY INDIA",
"HAMDULE ENGINEERS PRIVATE LIMITED",
"HAMEED LIFESTYLE MERCHANDISE PRIVATE LIMITED",
"HAMEED MARINE PRIVATE LIMITED",
"HAMEED STORE",
"HAMEEDHEEN ENTERPRISES PRIVATE LIMITED",
"HAMEER MINES PRIVATE LIMITED",
"HAMESHA VISUALS PRIVATE LIMITED",
"HAMEX FUEL CELL PRIVATE LIMITED",
"HAMIASTO TRADING PRIVATE LIMITED",
"HAMID MEMORIAL HOSPITAL",
"HAMIDIA ARTS AND COMMERCE COLLEGE",
"HAMIDIA HOSPITAL BHOPAL",
"HAMIDKHAN PATHAN URDU SEC LATUR",
"HAMILTON ELECTRONICS PRIVATE LIMITED",
"HAMILTON HEIGHTS PRIVATE LIMITED",
"HAMILTON HOUSEWARES PRIVATE LIMITED",
"HAMILTON INDUSTRIES PRIVATE LIMITED",
"HAMILTON LAND DEVELOPERS PRIVATE LIMITED",
"HAMILTON MEDICAL INDIA PRIVATE LIMITED",
"HAMILTON RESEARCH & TECHNOLOGY PRIVATE LIMITED",
"HAMILTON TECHNOLOGIES (INDIA) PRIVATE LIMITED.",
"HAMILTON WRITING INSTRUMENTS PRIVATE LIMITED",
"HAMIR REAL ESTATE PRIVATE LIMITED",
"HAMIRANI METALS PRIVATE LIMITED.",
"HAMLAI INDUSTRIES PRIVATE LIMITED",
"HAMLET APARTMENT PRIVATE LIMITED",
"HAMLET CONSTRUCTIONS (INDIA ) PRIVATE LIMITED",
"HAMLET HOMES PRIVATE LIMITED",
"HAMMAC ENGINEERING PRIVATE LIMITED",
"HAMMER COMMUNICATIONS PRIVATE LIMITED",
"HAMMER HEAD EXPERIENCES PRIVATE LIMITED",
"HAMMER LIFESTYLE PRIVATE LIMITED",
"HAMMERPLAY STUDIOS PRIVATE LIMITED",
"HAMMOCK LEISURE HOLIDAYS PRIVATE LIMITED",
"HAMMOND HARDWARE PRIVATE LIMITED",
"HAMMOND POWER SOLUTIONS PRIVATE LIMITED",
"HAMMOQ INFOSYSTEMS PRIVATE LIMITED",
"HAMON COOLING SYSTEM PVT LTD",
"HAMON INDIA THERMAL ENGINEERS AND CONTRACTTORS PRIVATE LIMITED",
"HAMON RESEARCH COTTRELL INDIA PRIVATE LIMITED",
"HAMOUR MARINE SOLUTIONS PRIVATE LIMITED",
"HAMPAN ASSOCIATES PRIVATE LIMITED",
"HAMPI EXPRESSWAYS PRIVATE LIMITED",
"HAMPLE ASSOCIATES PRIVATE LIMITED",
"HAMPRI IMPEX PRIVATE LIMITED",
"HAMPS BIO LIMITED",
"HAMPSHIRE HOTELS AND RESORTS (INDIA) PRIVATE LIMITED",
"HAMPTON SKY REALTY LIMITED",
"HAMRAZ DEVELOPERS PRIVATE LIMITED",
"HAMS BIOTECH PRIVATE LIMITED",
"HAMSA ENVIRONMENTAL SOLUTIONS PRIVATE LIMITED",
"HAMSA MEDICAL SERVICES PRIVATE LIMITED",
"HAMSA MINERALS (INDIA) PRIVATE LIMITED",
"HAMSA MINERALS AND EXPORTS LLP",
"HAMSA MOTORS PRIVATE LIMITED",
"HAMSA SHIPS PRIVATE LIMITED",
"HAMSINI ENTERPRISES PRIVATE LIMITED",
"HAMSOL SERVICES PRIVATE LIMITED",
"HAMSTECH ACADEMIC TRUST",
"HAMSTECH INDIA LIMITED",
"HAMSTECH INDIA PRIVATE LIMITED",
"HAMTECH ENGINEERING PRIVATE LIMITED",
"HAMTEK TECHNOLOGIES INDIA PRIVATE LIMITED",
"HAMUKJAN TEA PRIVATE LIMITED",
"HAMY STEEL PRIVATE LIMITED",
"HAMZA FRUITS TRADERS PRIVATE LIMITED",
"HAN DAIRY AND FOODS PRIVATE LIMITED",
"HAN DIGITAL SOLUTION PRIVATE LIMITED",
"HAN GANG INTERNATIONAL HOSPITALITY PRIVATE LIMITED",
"HAN KHAN CONSTRUCTION PRIVATE LIMITED",
"HAN RIVER TECHNOLOGY PRIVATE LIMITED",
"HANA ADVISORS INDIA PRIVATE LIMITED",
"HANA GLOBALKART INDIA PRIVATE LIMITED",
"HANA HOSPITALITY PRIVATE LIMITED",
"HANA PLATE ENGINEERING PRIVATE LIMITED",
"HANAENI SERVICES PRIVATE LIMITED",
"HANAFI TELECOM PRIVATE LIMITED",
"HANAPROTECH MOULDING & TOOLS PRIVATE LIMITED",
"HANATECH SOLUTIONS PRIVATE LIMITED",
"HANBAO INDUSTRIES INDIA PRIVATE LIMITED",
"HANBOO INDIA PRIVATE LIMITED",
"HANCHANG INDIA PRIVATE LIMITED",
"HANCO CHEMICALS PRIVATE LIMITED",
"HANCO MARINE SERVICES PRIVATE LIMITED",
"HANCO PROPERTY DEVELOPERS PRIVATE LIMITED",
"HANCOCK MEDIA PRIVATE LIMITED",
"HANCY FOREX AND SERVICES PRIVATE LIMITED",
"HAND ERP SOLUTIONS INDIA PRIVATE LIMITED",
"HAND IN HAND INCLUSIVE DEVELOPMENT AND SERVICES",
"HAND IN HAND INDIA",
"HAND MADE WORKS PRIVATE LIMITED",
"HANDA AND CHOPRA SALES PRIVATE LIMITED",
"HANDA FLOAT GLASS PRIVATE LIMITED",
"HANDA PLYWOOD PRIVATE LIMITED",
"HANDAS RUBBERS PRIVATE LIMITED",
"HANDC POLYMATE PRIVATE LIMITED",
"HANDC SERVICE PRIVATE LIMITED",
"HANDFAB HOME",
"HANDFUL INVESTRADE PRIVATE LIMITED",
"HANDICAP INTERNATIONAL",
"HANDIMAN SERVICES LIMITED",
"HANDL HARDWARES PRIVATE LIMITED",
"HANDLAIR ENGINEERS PRIVATE LIMITED",
"HANDLOOM COTTAGE PRIVATE LIMITED",
"HANDLOOM DIRECTORATE UP KANPUR",
"HANDLOOM EMPORIUM TEXTILES PRIVATE LIMITED",
"HANDLOOM EXPORT PROMOTION COUNCIL",
"HANDLOOM LUNGI AGENCY PRIVATE LIMITED",
"HANDO PRECISION PRIVATE LIMITED",
"HANDORF INDIA PRIVATE LIMITED",
"HANDS ON TRADES PRIVATE LIMITED",
"HANDS ONDESK SOLUTIONS PRIVATE LIMITED",
"HANDSOME INDIA CONSTRUCTIONS PRIVATE LIMITED",
"HANDUJA BAKERS PRIVATE LIMITED",
"HANDY - WATERBASE INDIA PRIVATE LIMITED",
"HANDY HOME SOLUTIONS PRIVATE LIMITED",
"HANDY HOSPITAL",
"HANDY ONLINE SOLUTIONS PRIVATE LIMITED",
"HANDY VYAPAAR PRIVATE LIMITED",
"HANE TECH SOLUTIONS PRIVATE LIMITED",
"HANEIL SOYA-TECH PRIVATE LIMITED",
"HANESBRANDS APPAREL INDIA PRIVATE LIMITED",
"HANGAL COFFEE EXPORTING PRIVATE LIMITED",
"HANGAR 17 INFORMATION AND COMMUNICATION TECHNOLOGIES PRIVATE LIMITED",
"HANGERS PLUS (INDIA) PRIVATE LIMITED",
"HANGERS PLUS INDIA PRIVATE LIMITED",
"HANGING GARDENS OWNERS",
"HANGLA'S RESTAURANTS PRIVATE LIMITED",
"HANGS PLAST INDIA PRIVATE LIMITED",
"HANGYO GOURMET PRIVATE LIMITED",
"HANGYO ICECREAMS PRIVATE LIMITED",
"HANI SOLUTIONS PRIVATE LIMITED",
"HANIA TRADE INVEST PRIVATE LIMITED",
"HANIFA SILK PRIVATE LIMITED",
"HANIL TUBE INDIA P LIMITED",
"HANIN TECH INDIA PRIVATE LIMITED",
"HANISAN HEALTHCARE PRIVATE LIMITED",
"HANJER BIOTECH PRIVATE LIMITED",
"HANJIN CHEMICAL INDIA PRIVATE LIMITED",
"HANJIN SHIPPING INDIA PRIVATE LIMITED",
"HANJUNG EXIM PRIVATE LIMITED",
"HANKER MEDIA PRIVATE LIMITED",
"HANKHUL PACKWELL PRIVATE LIMITED",
"HANKUK CONSTRUCTION & TRADING PRIVATE LIMITED",
"HANKYU HANSHIN EXPRESS INDIA PRIVATE LIMITED",
"HANLIM E&C INDIA PRIVATE LIMITED",
"HANNA EQUIPMENTS INDIA PRIVATE LIMITED",
"HANNA IMPEX",
"HANNA ROCK PRODUCTS PRIVATE LIMITED",
"HANNAH JOSEPH HOSPITAL PRIVATE LIMITED",
"HANNING MOTORS INDIA PRIVATE LIMITED",
"HANNOVER MILANO FAIRS INDIA PRIVATE LIMITED",
"HANNU KNITTERS PRIVATE LIMITED",
"HANNU MARKETING PRIVATE LIMITED",
"HANNU STEEL PRIVATE LIMITED",
"HANNU'S FURNISHINGS PRIVATE LIMITED",
"HANNUTECH IT CONSULTANTS PRIVATE LIMITED OPC",
"HANON AUTOMOTIVE SYSTEMS INDIA PRIVATE LIMITED",
"HANON CLIMATE SYSTEMS INDIA PRIVATE LIMITED",
"HANOVER INTERNATIONAL SUPPORT SERVICES PRIVATE LIMITED",
"HANRAG METALLURGICAL PRIVATE LIMITED",
"HANS AIR SERVICES PRIVATE LIMITED",
"HANS BUILDWELL PRIVATE LIMITED",
"HANS CHEMICALS PRIVATE LIMITED",
"HANS INDUSTRIES PRIVATE LIMITED",
"HANS INFOMATIC PRIVATE LIMITED",
"HANS INFRASOLUTIONS PRIVATE LIMITED",
"HANS INNS PRIVATE LIMITED",
"HANS INTERIORS INDIA PRIVATE LIMITED",
"HANS MARITIME SERVICES PRIVATE LIMITED",
"HANS MODERN AGRISEEDS PRIVATE LIMITED",
"HANS NURSING HOME PRIVATE LIMITED",
"HANS RAJ AGROS PRIVATE LIMITED",
"HANS RAJ MAHILA MAHA VIDYALAYA",
"HANS RAJ TUBES PRIVATE LIMITED",
"HANS ROAD CARRIERS PRIVATE LIMITED",
"HANS RUBBER & SPORTS PRIVATE LIMITED",
"HANS SERVICES",
"HANS TRAVELS (I) PRIVATE LIMITED",
"HANS VINYLS PRIVATE LIMITED",
"HANS VYAPAAR PRIVATE LIMITED",
"HANSA AGENCIES PRIVATE. LIMITED",
"HANSA AGROCOM PRIVATE LIMITED",
"HANSA BUSINESS SERVICES PRIVATE LIMITED",
"HANSA CINE EQUIPMENTS PRIVATE LIMITED",
"HANSA CITY BUS SERVICES (NAGPUR) PRIVATE LIMITED",
"HANSA CITY BUS SERVICES MUMBAI PRIVATE LIMITED",
"HANSA CITY BUS SERVICES PRIVATE LIMITED",
"HANSA CUSTOMER EQUITY PRIVATE LIMITED",
"HANSA DECOR PRIVATE LIMITED",
"HANSA DIRECT PRIVATE LIMITED",
"HANSA ESTATES PRIVATE LIMITED",
"HANSA GREEN MARKETING PRIVATE LIMITED",
"HANSA INDUSTRIES PRIVATE LIMITED",
"HANSA MARBLE AND GRANITE PRIVATE LIMITED",
"HANSA METALLICS LIMITED",
"HANSA MUSIC PRIVATE LIMITED",
"HANSA PICTURES PRIVATE LIMITED",
"HANSA POWER & INFRA PRIVATE LIMITED",
"HANSA RESEARCH GROUP PRIVATE LIMITED",
"HANSA SOLUTIONS INDIA PRIVATE LIMITED",
"HANSA SPORT N ADVENTURE PRIVATE LIMITED",
"HANSA TEXTRADE PRIVATE LTD.",
"HANSA TUBES PRIVATE LIMITED",
"HANSA VAHAN INDIA PRIVATE LIMITED",
"HANSA-FLEX INDIA PRIVATE LIMITED",
"HANSAL STEELS PRIVATE LIMITED",
"HANSALAYA PROPERTIES RIVATE LIMITED",
"HANSAMUKH SOFTWARE SOLUTIONS PRIVATE LIMITED",
"HANSARIA FOOD PRIVATE LIMITED",
"HANSAZONE PRIVATE LIMITED",
"HANSCNC TECH PRIVATE LIMITED",
"HANSCO IRON AND STEELS PRIVATE LIMITED",
"HANSDEEP INDUSTRIES & TRADING COMPANY LIMITED",
"HANSEM BUILDING SYSTEMS INDIA PRIVATE LIMITED",
"HANSEN SYSTEMS PRIVATE LIMITED",
"HANSEN TECHSOL PRIVATE LIMITED",
"HANSESWARI CORPORATE MANPOWER MANAGEMENT LIMITED",
"HANSGROHE INDIA PRIVATE LIMITED",
"HANSHA TRADECOM PRIVATE LIMITED",
"HANSI CLOTHING CO. PRIVATE LIMITED",
"HANSIN BIO-INFRA INDIA PRIVATE LIMITED",
"HANSINI MANAGEMENT CONSULTANT PRIVATE LIMITED",
"HANSLAXMI CHARITABLE TRUST",
"HANSMUKHI AGRO EXPORTS LIMITED",
"HANSNEEL IMPEX PRIVATE LIMITED",
"HANSOGE ENTERPRISES PRIVATE LIMITED",
"HANSOL CNP INDIA PRIVATE LIMITED",
"HANSOL LOGISTICS INDIA PRIVATE LIMITED",
"HANSON AGRO LIMITED",
"HANSON PLASTICS PRIVATE LIMITED",
"HANSPARK INDUSTRIES PRIVATE LIMITED",
"HANSRAJ HEALTHCARE PRIVATE LIMITED",
"HANSRAJ LOGISTICS PRIVATE LIMITED",
"HANSRAJ MATHURADAS INSURANCE SURVEYORS AND LOSS ASSESSORS PRIVATE LIMITED",
"HANSRAJ MODELSCOOL PUNJABI BAGH",
"HANSRAJ PRAGJI WAREHOUSING PRIVATE LIMITED",
"HANSTRONICS MEDICAL EQUIPMENTS PRIVATE LIMITED",
"HANSUM INDIA ELECTRONICS PRIVATE LIMITED",
"HANSVAHINI AUTO INTERIOR PRIVATE LIMITED",
"HANTECH ENGINEERING AND TECHNOLOGY PRIVATE LIMITED",
"HANTO WORKSPACE TECHNOLOGIES PRIVATE LIMITED",
"HANU CREATION PRIVATE LIMITED",
"HANU INFRASTRUCTURE PRIVATE LIMITED",
"HANU KRIPA ISPAT PRIVATE LIMITED",
"HANU MERCHANDISE AND BEVERAGES PRIVATE LIMITED",
"HANU POLYMERS PRIVATE LIMITED",
"HANU PRINTS PRIVATE LIMITED",
"HANU PROCON PRIVATE LIMITED",
"HANU REDDY REALTY INDIA PRIVATE LIMITED",
"HANU SOFTWARE SOLUTIONS (INDIA) PRIVATE LIMITED",
"HANUDEV INFOPARK PRIVATE LIMITED",
"HANUGEN THERAPEUTICS PRIVATE LIMITED",
"HANUJA TECHNOLOGIES PRIVATE LIMITED",
"HANUKA TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"HANUMAN AGRO INDUSTRIES LIMITED.",
"HANUMAN AGRO INDUSTRIES PRIVATE LIMITED",
"HANUMAN AGROFOOD PRIVATE LIMITED",
"HANUMAN AUTOMATION PRIVATE LIMITED",
"HANUMAN BAGS & CONTAINERS LTD",
"HANUMAN CONCRETE PRODUCTS PRIVATE LIMITED",
"HANUMAN COTEX PRIVATE LIMITED",
"HANUMAN CREATIONS PRIVATE LIMITED",
"HANUMAN ECOVERO PRIVATE LIMITED",
"HANUMAN ENTERPRISES (INDIA) PRIVATE LIMITED",
"HANUMAN FABRICS PRIVATE LIMITED",
"HANUMAN FASHIONS PRIVATE LIMITED",
"HANUMAN FINANCE LTD",
"HANUMAN FOODS",
"HANUMAN FREIGHT & CARRIERS PVT. LTD.",
"HANUMAN GRAPHICS PVT.LTD.",
"HANUMAN ISPAT PRIVATE LIMITED",
"HANUMAN MINES & MINERALS PRIVATE LIMITED",
"HANUMAN OXYGEN PRIVATE LIMITED",
"HANUMAN PLANTATIONS LTD",
"HANUMAN PLY PRODUCTS PRIVATE LIMITED",
"HANUMAN POLYESTER PRIVATE LIMITED",
"HANUMAN POWER TRANSMISSION EQUIPMENTS PRIVATE LIMITED",
"HANUMAN PRASAD DHANUKA SARASWATI BALIKA VIDYA MANDIR",
"HANUMAN PULSES PRIVATE LIMITED",
"HANUMAN RICE MILLS",
"HANUMAN ROLLER FLOUR MILLS LTD",
"HANUMAN SCHOOL ARTS & SCIENCE HIGHER SECONDARY SCHOOL",
"HANUMAN SPICES AND HERBS PRIVATE LIMITED",
"HANUMAN TRANSPORT COMPANY PRIVATE LIMITED",
"HANUMAN VIDYALAY ARTS & SCIENCE HIGHER EDUCATIONAL SCHOOL",
"HANUMANPRASAD TEXTILE PRIVATE LIMITED",
"HANUMANT AGRI HUB INDIA LIMITED",
"HANUMANT ALLOYS (INDIA) PRIVATE LIMITED",
"HANUMANT HOMES PRIVATE LIMITED",
"HANUMANT KRIPA STEELS PRIVATE LIMITED",
"HANUMANT POLYMERS PRIVATE LIMITED",
"HANUMANT SUGARS PRIVATE LIMITED",
"HANUMANTA FOOD PRODUCTS PRIVATE LIMITED",
"HANUMANTH DEALTRADE PRIVATE LIMITED",
"HANUMANTVIJAY ENGITECH PRIVATE LIMITED",
"HANUMAT AGENCIES PRIVATE LIMITED",
"HANUMAT AGRI PRODUCTS PRIVATE LIMITED",
"HANUMAT NIKETAN SEWA SANSTHAN",
"HANUMAT WIRES UDYOG PRIVATE LIMITED",
"HANURAM FOODS PRIVATE LIMITED",
"HANURANG VINIMAY PVT LTD",
"HANUTECH ENGINEERS PRIVATE LIMITED",
"HANVIKA ORGANIC INNOVATIONS PRIVATE LIMITED",
"HANWA INDIA PRIVATE LIMITED",
"HANWANT FASTNERS PRIVATE LIMITED",
"HANWHA CHEMICAL INDIA PRIVATE LIMITED",
"HANWHA CORPORATION",
"HANWHA INTERNATIONAL INDIA PRIVATE LIMITED",
"HANYANG (INDIA) PRIVATE LIMITED",
"HANYANG ADVANCED MATERIALS INDIA PRIVATE LIMITED",
"HANZALA BUSINESS HOUSE PRIVATE LIMITED",
"HAO BUILDHOME PRIVATE LIMITED",
"HAOKUN TECHNOLOGY (INDIA) PRIVATE LIMITED",
"HAOSEN AUTOMATION INDIA PRIVATE LIMITED",
"HAP GANTRY AND ENGINEERING SERVICES PRIVATE LIMITED",
"HAP INFRASTRUCTURE PRIVATE LIMITED",
"HAP LIFESCIENCES PRIVATE LIMITED",
"HAPA FASHIONS PRIVATE LIMITED",
"HAPAG LIOYD INDIA PRIVATE LIMITED",
"HAPAG LLOYD GLOBAL SERVICES PRIVATE LIMITED",
"HAPAG-LLOYD BUSINESS SERVICES LLP",
"HAPANA INDIA PRIVATE LIMITED",
"HAPBCO MOTORCYCLES PRIVATE LIMITED",
"HAPG HOLDINGS LIMITED",
"HAPJOY TECHNOLOGIES PRIVATE LIMITED",
"HAPLOOS PLYBOARDS PRIVATE LIMITED",
"HAPP TECH PRIVATE LIMITED",
"HAPPENINGS ADVERTISING PRIVATE LIMITED",
"HAPPENSTORE RETAIL PRIVATE LIMITED",
"HAPPHO SOLUTIONS V-MART PRIVATE LIMITED",
"HAPPIEST CURATORS PRIVATE LIMITED",
"HAPPIEST MINDS TECHNOLOGIES LIMITED",
"HAPPILO INTERNATIONAL PRIVATE LIMITED",
"HAPPILY UNMARRIED MARKETING PRIVATE LIMITED",
"HAPPY AUTOCOMP PRIVATE LIMITED",
"HAPPY AUTOMOTIVES PRIVATE LIMITED",
"HAPPY AXLE AND GEAR MANUFACTURING PRIVATE LIMITED",
"HAPPY BEE FILMS PRIVATE LIMITED",
"HAPPY BENGAL VENTURES PRIVATE LIMITED",
"HAPPY BEVERAGES AND FOODS PRIVATE LIMITED",
"HAPPY BIRDS ORGANIC FARMING PRIVATE LIMITED",
"HAPPY BRICK BUILDING PRIVATE LIMITED",
"HAPPY CASH & CARRY GROCERY PRIVATE LIMITED",
"HAPPY CASTLES PRIVATE LIMITED",
"HAPPY COW DAIRY COMPANY PRIVATE LIMITED",
"HAPPY CREATIVE SERVICES INDIA PRIVATE LIMITED",
"HAPPY ENGLISH SCHOOL",
"HAPPY FAMILY PRODUCTIONS PRIVATE LIMITED",
"HAPPY FINISH INDIA PRIVATE LIMITED",
"HAPPY FORGINGS LIMITED",
"HAPPY GAANA ENTERTAINMENT PRIVATE LIMITED",
"HAPPY GREEN MART PRIVATE LIMITED",
"HAPPY HARDWARE PRIVATE LIMITED",
"HAPPY HOME CORPORATION",
"HAPPY HOME FINANCE PRIVATE LIMITED",
"HAPPY HOME TEXTILES LLP",
"HAPPY HOURS SCHOOL",
"HAPPY JARS PRIVATE LIMITED",
"HAPPY LUCK SPINNING MILLS PRIVATE LIMITED",
"HAPPY MEDICARE PRIVATE LIMITED",
"HAPPY MINDS MANPOWER SOLUTIONS PRIVATE LIMITED",
"HAPPY MODEL PUBLIC SCHOOL",
"HAPPY MODEL SCHOOL",
"HAPPY NIKETAN PRIVATE LIMITED",
"HAPPY NURSING HOME GENERAL HOSPITAL",
"HAPPY OJO LIFESTYLE PRIVATE LIMITED",
"HAPPY PETS PRIVATE LIMITED",
"HAPPY PLANET AMUSEMENT PRIVATE LIMITED",
"HAPPY RELIABLE SURGERIES PRIVATE LIMITED",
"HAPPY SOLAR PRIVATE LIMITED",
"HAPPY SQUARE OUTSOURCING SERVICES PRIVATE LIMITED",
"HAPPY STARSTELL.COM PRIVATE LIMITED",
"HAPPY STEELS PRIVATE LIMITED",
"HAPPY THAI INDIA PRIVATE LIMITED",
"HAPPY UNICORN CREATIVE COMMUNICATION PRIVATE LIMITED",
"HAPPY VISITORS ESOLUTIONS PRIVATE LIMITED",
"HAPPY.RENTALS INDIA PRIVATE LIMITED",
"HAPPYEASYGO INDIA PRIVATE LIMITED",
"HAPPYFEST SOLUTIONS PRIVATE LIMITED",
"HAPPYFINT CONSULTING PRIVATE LIMITED",
"HAPPYHOMESS CONSULTANCY PRIVATE LIMITED",
"HAPPYKID APPARELS LLP",
"HAPPYLOCATE RELOCATION SERVICES PRIVATE LIMITED",
"HAPPYMATE FOODS LIMITED",
"HAPPYMONGO ONLINE SOLUTION PRIVATE LIMITED",
"HAPPYMONTY'S REAL ESTATES PRIVATE LIMITED",
"HAPPYSEED INDIA PRIVATE LIMITED",
"HAPRO HOMEO-CHEM P LTD",
"HAPTIC TECHNOLOGIES PRIVATE LIMITED",
"HAQ STEELS AND METALIKS LIMITED",
"HAQ STEELS PRIVATE LIMITED",
"HAQDARSHAK EMPOWERMENT SOLUTIONS PRIVATE LIMITED",
"HAQUE LOGISTICS PRIVATE LIMITED",
"HAR BAI MATA TRADING COMPANY PRIVATE LIMITED",
"HAR BEDI WONDER CRAFTS INDIA PRIVATE LIMITED",
"HAR HAR MAHADEV COMBINED INDUSTRIES PRIVATE LIMITED",
"HAR KALYAN CASTWELL PRIVATE LIMITED",
"HAR MAHADEV ENGINEERING WORKS",
"HAR PARSHAD AND COMPANY PRIVATE LIMITED",
"HAR PRASAD RAJARAM ADARSH INTER COLLEGE BAH AGRA",
"HAR SHAKTI INFRA PRIVATE LIMITED",
"HAR WASSERTEC PRIVATE LIMITED",
"HARA GOURI HIMGHAR PRIVATE LIMITED",
"HARA PARBATI POTATO COLD STORAGE PRIVATE LIMITED",
"HARA PARBATI RICE MILLS PRIVATE LIMITED",
"HARAGOVIND ENTERPRISES PRIVATE LIMITED",
"HARA-HER HYGIENE PRIVATE LIMITED",
"HARAK CHANDRA FLOUR MILLS PRIVATE LIMITED",
"HARAKH CHAND GLASS PRIVATE LIMITED",
"HARAKH CHAND TUFF GLASS PRIVATE LIMITED",
"HARALALKA TYRE AGENCIES PVT LTD",
"HARAMBA STEELS PVT LTD",
"HARANATH PAINT MART PVT LTD",
"HARANCHANDRA COLD STORAGE PRIVATE LIMITED",
"HARAPARBATI AGRITECH PRIVATE LIMITED",
"HARAPARVATI REALTORS PVT LTD",
"HARAPPA TEXTILE MILLS PRIVATE LIMITED",
"HARAREI INDIA PRIVATE LIMITED",
"HARASHA PHARMA PRIVATE LIMITED",
"HARBAN SINGH & SONS ENTERPRISES PRIVATE LIMITED",
"HARBANIS PRIVATE LIMITED",
"HARBANS LAL MALHOTRA & SONS (SHAVING) PRIVATE LIMITED",
"HARBANSH DAIRY PRIVATE LIMITED",
"HARBANSH LAL FOODS PRIVATE LIMITED",
"HARBANSHRAM BHAGWANDAS AYURVEDIC SANSTHAN PRIVATE LIMITED",
"HARBANSLAL MALHOTRA & SONS PRIVATE. LIMITED",
"HARBAUER (INDIA) PRIVATE LIMITED",
"HARBILAS CINE COMPANY PRIVATE LIMITED",
"HARBINGER BUSINESS SOLUTIONS (INDIA) PRIVATE LIMITED",
"HARBINGER GROUP INC.",
"HARBINGER INTERACTIVE LEARNING PRIVATE LIMITED",
"HARBINGER SEMICONDUCTORS PRIVATE LIMITED",
"HARBINGER SYSTEMS PRIVATE LIMITED",
"HARBINGER TECHAXES PRIVATE LIMITED",
"HARBINGER TECHVENTURES PRIVATE LIMITED",
"HARBIR AGROTECH PRIVATE LIMITED",
"HARBIR AUTOMOBILE PRIVATE LIMITED",
"HARBIR SINGH CONTRACTOR PRIVATE LIMITED",
"HARBOUR AND HILLS FINANCIAL SERVICES (INDIA) PRIVATE LIMITED",
"HARBOUR MEDICAL TECHNOLOGIES PRIVATE LIMITED",
"HARBOUR SALES PRIVATE LIMITED",
"HARBOUR TRENDZ PRIVATE LIMITED",
"HARBOUR VIEW RESIDENCY PRIVATE LIMITED",
"HARBOUR VILLE HOTEL PRIVATE LIMITED",
"HARCEPT IT SERVICES PRIVATE LIMITED",
"HARCHAND MAL JAIN INTER COLLEGE",
"HARCOMP AIRFLEX PRIVATE LIMITED",
"HARCOURT BUTLER TECHNICAL UNVIERSITY",
"HARD AND SHINE CHEMICALS PRIVATE LIMITED",
"HARD COATS (INDIA) PRIVATE LIMITED",
"HARD N SOFT TECHNOLOGIES PRIVATE LIMITED",
"HARD ROCK PRIVATE LIMITED",
"HARD SHELL TECHNOLOGIES PRIVATE LIMITED",
"HARDA PATHWAYS PRIVATE LIMITED",
"HARDAYAL CONSTRUCTIONS PRIVATE LIMITED",
"HARDAYAL ICE AND COLD STRAGE PRIVATE LIMITED",
"HARDAYAL INFRA PROJECTS PRIVATE LIMITED",
"HARDAYAL MILK PRODUCTS PRIVATE LIMITED",
"HARDAYAL PRESERVATIONS PRIVATE LIMITED",
"HARDCASE ENGINEERING WORKS PVT LTD",
"HARDCASTLE AND WAUD MANUFACTURING COMPANY LIMITED",
"HARDCASTLE PETROFER PRIVATE LIMITED",
"HARDCASTLE RESTAURANTS PRIVATE LIMITED",
"HARDCORE FINANCIAL ENGINEERS AND SYNDICATORS PRIVATE LIMITED",
"HARDEE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"HARDEN BRICKS PRIVATE LIMITED",
"HARDEODAS JAGANNATH PVT LTD",
"HARDESH ORES PRIVATE LIMITED",
"HARDFORK MEDIA PRIVATE LIMITED",
"HARDIAL SINGH & COMPANY ESTATES PRIVATE LIMITED",
"HARDIB TECHNOLOGY PRIVATE LIMITED",
"HARDIK AGRITRADE PRIVATE LIMITED",
"HARDIK DISTRIBUTOR PRIVATE LIMITED",
"HARDIK FILMS ENTERTAINMENTS PRIVATE LIMITED (OPC)",
"HARDIK FIN TRADE PRIVATE LIMITED",
"HARDIK IMPEX PRIVATE LIMITED",
"HARDIK INFOTECH PRIVATE LIMITED",
"HARDIK INTERNATIONAL PRIVATE LIMITED",
"HARDIK IRON AND STEEL PRIVATE LIMITED",
"HARDIK POLYCONTAINERS PRIVATE LIMITED",
"HARDIK STEELS PRIVATE LIMITED",
"HARDIK TELECOMMUNICATION PRIVATE LIMITED",
"HARDIK TEXTILES PRIVATE LIMITED",
"HARDIK TRANSFORMERS PRIVATE LIMITED",
"HARDIKA ENTERPRISES PRIVATE LIMITED",
"HARDIKA INTERNATIONAL PRIVATE LIMITED",
"HARDIP PLYWOOD & VENEERS PRIVATE LIMITED",
"HARDIP SHIPPING LOGISTICS PRIVATE LIMITED",
"HARDIT INDUSTRIES PRIVATE LIMITED",
"HARDIYA HASANPUR HIGHWAY PRIVATE LIMITED",
"HARDKORE SECURITY PRIVATE LIMITED",
"HARDOI BANSAL GOODS CARRIER PRIVATE LIMITED",
"HARDOI KISAN PRODUCER COMPANY LIMITED",
"HARDOLI PAPER MILLS LIMITED",
"HARDROCK ATTACHMENTS PRIVATE LIMITED",
"HARDROCK FABRICATION PRIVATE LIMITED",
"HARDTRAC COMPUTER SERVICES PRIVATE LIMITED",
"HARDUTTRAI RANGLAL PRIVATE LIMITED",
"HARDWARE CONCEPTS INDIA PRIVATE LIMITED",
"HARDWARE TOOLS AND MACHINERY PROJECTS PRIVATE LIMITED",
"HARDWARILAL & SONS PRIVATE LIMITED",
"HARDWIN CONSTRUCTION PRIVATE LIMITED",
"HARDWIN SOFTWARE SOLUTIONS PRIVATE LIMITED",
"HARDWYN INDIA LIMITED",
"HARDY EXPLORATION & PRODUCTION INDIA I NC",
"HARDY INFOTECH",
"HARDY SMITH DESIGNS PRIVATE LIMITED",
"HARE INFORMATION TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"HARE KRISHNA AUTO PRIVATE LIMITED",
"HARE KRISHNA BOXES PRIVATE LIMITED",
"HARE KRISHNA ENTERPRISES PRIVATE LIMITED",
"HARE KRISHNA FOAMTECH PRIVATE LIMITED",
"HARE KRISHNA FOODS LIMITED",
"HARE KRISHNA FURNISHING PRIVATE LIMITED",
"HARE KRISHNA JEWELLERS PRIVATE LIMITED",
"HARE KRISHNA JEWELLERY HOUSE PRIVATE LIMITED",
"HARE KRISHNA MEDIA TECH PRIVATE LIMITED",
"HARE KRISHNA METALLICS PRIVATE. LIMITED",
"HARE KRISHNA SYNTEX PRIVATE LIMITED",
"HARE KRISHNA THREADS PVT LTD",
"HARE KRSNA CONTENT BROADCAST PRIVATE LIMITED",
"HARE RAM ROADWAYS PRIVATE LIMITED",
"HAREENA FOODS PRIVATE LIMITED",
"HAREKRISHAN CLASSIC CAR CARES PRIVATE LIMITED",
"HAREKRISHNA POLYFILMS PRIVATE LIMITED",
"HAREKRISHNA RICE EXPO PRIVATE LIMITED",
"HAREKRISHNA STEEL PIPES PRIVATE LIMITED",
"HAREKRISHNA WEAVES PRIVATE LIMITED",
"HAREMBECHANDRA COLLEGE",
"HAREN TEXTILES PRIVATE LIMITED",
"HARENDRA D. MEHTA SHARE AND STOCK BROKER PRIVATE LIMITED",
"HARE-RAMA EXPORTS PRIVATE LIMITED",
"HARESH ACIDS AND CHEMICALS PVT LTD",
"HARESH ENTERPRISE",
"HARESH HOUSING PRIVATE LIMITED",
"HARESH OVERSEAS PRIVATE LIMITED",
"HARESH PETROCHEM PRIVATE LIMITED",
"HARESH ROLLER FLOUR MILLS PVT. LTD.",
"HAREVA TRADING PRIVATE LIMITED",
"HAREY KRISHNA CABLES PRIVATE LIMITED",
"HARF FOREX PRIVATE LIMITED",
"HARGAON INVESTMENT & TRADING CO LTD",
"HARGAV SHELTER",
"HARGOPAL MACHINES PRIVATE LIMITED",
"HARGOURI BARTER PRIVATE LIMITED",
"HARGOURI TRADING PRIVATE LIMITED",
"HARGUN AGRO INDUSTRIES PRIVATE LIMITED",
"HAR-HAL PLASTIC ENGINEERING PRIVATE LIMITED",
"HARHARMAHADEV AGRO INDUSTRIES PRIVATE LIMITED",
"HARI & CO INTERNATIONAL LLP",
"HARI & SRIDHAR JEWELLERS PRIVATE LIMITED",
"HARI ABRASIVES PRIVATE LIMITED",
"HARI AND COMPANY INVESTMENTS MADRAS PRIVATE LIMITED",
"HARI BANDHU HOSPITAL PRIVATE LIMITED",
"HARI BELTS ANDCONVEYORS PRIVATE LIMITED",
"HARI BHARI MORADABAD WASTE MANAGEMENT PRIVATE LIMITED",
"HARI BHOG FOODS PRIVATE. LIMITED",
"HARI BHOOMI COMMUNICATIONS PRIVATE LIMITED",
"HARI BOL WOOD PRODUCTS PRIVATE LIMITED",
"HARI CONSOLIDATED PRIVATE LIMITED",
"HARI CONSTRUCTION AND ASSOCIATES PRIVATE LIMITED",
"HARI DARSHAN EXPORTS PRIVATE LIMITED",
"HARI DARSHAN SALES PVT LTD.",
"HARI DARSHAN SEVASHRAM PRIVATE LIMITED",
"HARI DISTRIBUTORS PRIVATE LIMITED",
"HARI FINANCE & TRADE PVT LTD",
"HARI GALVANIZERS PRIVATE LIMITED",
"HARI HARA AGRI BIOTECH PRIVATE LIMITED",
"HARI HARA CHIT FUND MANCHERIAL PRIVATE LIMITED",
"HARI HARIBOL DAIRY PRODUCTS PRIVATE LIMITED",
"HARI INDO ENGINEERING PRIVATE LIMITED",
"HARI IRON (INDIA) LIMITED",
"HARI IRON TRADING INDIA PRIVATE LIMITED",
"HARI KRISHNA ENGINEERING PRIVATE LIMITED",
"HARI KRISHNA EXPORTS PRIVATE LIMITED",
"HARI KRISHNA METALLIC",
"HARI KRISHNAA SPINNING MILLS PRIVATE LIMITED",
"HARI LANDMARKS PRIVATE LIMITED",
"HARI MARINE PRIVATE LIMITED",
"HARI MEDI PHARMA PRIVATE LIMITED",
"HARI MOTORS PRIVATE LIMITED",
"HARI OHM PAPER MILLS PVT LTD",
"HARI OIL AND GENERAL MILLS",
"HARI OM ASSOCIATES PRIVATE LIMITED",
"HARI OM BIO FOOD PRODUCTS INDIA PRIVATE LIMITED",
"HARI OM BUILDHOMES PRIVATE LIMITED",
"HARI OM CASTING COMPANY PRIVATE LIMITED",
"HARI OM DECOR PRIVATE LIMITED",
"HARI OM LABELS PRIVATE LIMITED",
"HARI OM LOGISTICS PRIVATE LIMITED",
"HARI OM METAL TUBES PRIVATE LIMITED",
"HARI OM MOTORRAD PRIVATE LIMITED",
"HARI OM MULTIVISION CORPORATION (INDIA) PRIVATE LIMITED",
"HARI OM PRECISION ALLOYS PRIVATE. LIMITED",
"HARI OM RETAIL PRIVATE LIMITED",
"HARI OM SRI AUTOMOBILES PRIVATE LIMITED",
"HARI OM STEEL PRIVATE LIMITED",
"HARI OM SUGARS PRIVATE LIMITED",
"HARI OM WIRES PRIVATE LIMITED",
"HARI ORGOCHEM PVT LTD",
"HARI PARVAT FINANCIAL ADVISORS AND CONSULTANTS PRIVATE LIMITED",
"HARI PRABHU GASES AND REFRIGERATION LIMITED",
"HARI PRASAD BAL KRISHNA JEWELLERS PRIVATE LIMITED",
"HARI PRASAD CONVERGENCES PRIVATE LIMITED",
"HARI PRASAD GOPI KRISHNA JEWELLERS PRIVATE LIMITED",
"HARI PRASAD GOPI KRISHNA SARAF PRIVATE LIMITED",
"HARI RAM AUTOS PRIVATE LIMITED",
"HARI RAM GULAB RAI PRIVATE LIMITED",
"HARI SHANKAR SINGANIA ELASTOMER AND TYRE RESEARCH INSTITUTE",
"HARI SHANKAR SINGHANIA HOLDINGS PRIVATE LIMITED",
"HARI SHANKER JEWELLERS PRIVATE LIMITED",
"HARI SHARANAM TRADELINKS PRIVATE LIMITED",
"HARI SMRITI PROPERTIES PRIVATE LIMITED",
"HARI TAPES PVT LTD",
"HARI TRAFIN PVT.LTD.",
"HARI UDYOG PRIVATE LIMITED",
"HARI VEGETABLE PRODUCTS PRIVATE LIMITED",
"HARIA APPARELS LIMITED",
"HARIA COT-WOOD PRIVATE LIMITED",
"HARIA L G ROTARY HOSPITAL",
"HARIAKSH INDUSTRIES PRIVATE LIMITED",
"HARIANA IRON WORKS PVT LTD",
"HARIBAL TOURS AND TRAVELS PRIVATE LIMITED",
"HARIBHAI V DESAI COLLEGE PUNE",
"HARIBHAKTI & CO. LLP",
"HARIBOL STEELS PRIVATE LIMITED",
"HARICARE SERVICES PRIVATE LIMITED",
"HARICHANDANA AGRO-TECH LIMITED",
"HARICHANDANA COTTONS PRIVATE LIMITED",
"HARICOM VYAPAR PRIVATE LIMITED",
"HARIDARSHAN STEEL PRIVATE LIMITED",
"HARIDASPUR PARADIP RAILWAY COMPANY LIMITED.",
"HARIDHAN SEEDS PRIVATE LIMITED",
"HARIDREAM SOLUTIONS PRIVATE LIMITED",
"HARIDWAR FOILS PRIVATE LIMITED",
"HARIDWAR MEDICARE HOSPITAL",
"HARIDWAR NATURAL GAS PRIVATE LIMITED",
"HARIDWAR PRECISION AUTO PVT LTD",
"HARIDWAR SOLAR PROJECTS PRIVATE LIMITED",
"HARIGOPAL PROPERTIES PRIVATE LIMITED",
"HARIGOPAL STEELS & METALS PRIVATE LIMITED",
"HARIHANS MINERALS PRIVATE LIMITED",
"HARIHAR ENERGY SERVICES PRIVATE LIMITED",
"HARIHAR FOODS PVT LTD",
"HARIHAR INDUSTRIES - KADI",
"HARIHAR INVESTMENTS PRIVATE LIMITED",
"HARIHAR IRON AND STEEL PRIVATE LIMITED",
"HARIHAR MARBLES PRIVATE LIMITED",
"HARIHAR MEDICAL AGENCIES PRIVATE LIMITED",
"HARIHAR PHARMACEUTICALS PRIVATE LIMITED",
"HARIHAR REFRIGERATION AND AGRO PRODUCTS PRIVATE LIMITED",
"HARIHAR SECURITIES PRIVATE LIMITED",
"HARIHAR STONE CRUSHER PRIVATE LIMITED",
"HARIHARAN DIABETES & HEART CARE HOSPITALS PRIVATE LIMITED",
"HARIHARAN FOUNDATIONS PRIVATE LIMITED",
"HARIHARAN SPINNERS LIMITED",
"HARIHARAN STEELS PRIVATE LIMITED",
"HARIHARBHAI PATEL HIGH SCHOOL KHATIYA",
"HARIHARESHWAR AUTO TECH PRIVATE LIMITED",
"HARIHARESHWARA ASSOCIATES PRIVATE LIMITED",
"HARIHARGANJ - PARWA HIGHWAYS PRIVATE LIMITED",
"HARIKA DRUGS PRIVATE LIMITED",
"HARIKA PACKAGES PRIVATE LIMITED",
"HARIKA TRADING PRIVATE LIMITED",
"HARIKANTA OVERSEAS PRIVATE LIMITED",
"HARIKRISH PRIVATE LIMITED",
"HARIKRISHNA CHARITABLE FOUNDATION",
"HARIKRISHNA INFRATECH",
"HARIKRISHNA TECHNOMECH ENGINEERING PRIVATE LIMITED",
"HARIKRUPA AUTOMATION PRIVATE LIMITED",
"HARIKRUSHNA COTCLEAN PRIVATE LIMITED",
"HARIKRUSHNA GRAPHICS AND PRINT PRIVATE LIMITED",
"HARIKRUSHNA INFRASTRUCTURE PRIVATE LIMITED",
"HARIKRUSHNA PROCESSING PRIVATE LIMITED",
"HARILAL LAKHAMSHI INDUSTRIES PRIVATE LIMITED",
"HARILAL LAKHAMSHI JEWELLERS PRIVATE LIMITED",
"HARILAL VENTURES PRIVATE LIMITED",
"HARILAXMI ALLOYS PRIVATE LIMITED",
"HARIMAN EXPORTS",
"HARIMAN LABORATORIES PVT LTD",
"HARIMOHAN GHOSH COLLEGE",
"HARINA BIOCULTURE PRIVATE LIMITED",
"HARINAGAR SUGAR MILLS LIMITED",
"HARINARAYANAN STRUCTURALS PRIVATE LIMITED",
"HARINATH BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"HARINATH SYNTEX PRIVATE LIMITED",
"HARIND CHEMICALS AND PHARMACEUTICALS PRIVATE LIMITED",
"HARINDER MEDICARE & SOLUTIONS PRIVATE LIMITED",
"HARINEE INFOTECH PRIVATE LIMITED",
"HARINETRA INFRASTRUCTURE PRIVATE LIMITED",
"HARINI CONSTRUCTIONS PRIVATE LIMITED",
"HARINI HATCHERIES AND FARMS PRIVATE LIMITED",
"HARINI PROMOTERS PRIVATE LIMITED",
"HARINI SMART PROJECTS AND SERVICES PRIVATE LIMITED",
"HARINIM TRADE AND TRAVELS PRIVATE LIMITED",
"HARIOM ACID AND CHEMICAL PRIVATE LIMITED",
"HARIOM AGRI INTERNATIONAL PRIVATE LIMITED",
"HARIOM AGRO FOODS PRIVATE LIMITED",
"HARIOM AQUA CULTURE PRIVATE LIMITED",
"HARIOM CARTONS PRIVATE LIMITED",
"HARIOM COMMUNICATION LLP",
"HARIOM CONCAST & STEELS PRIVATE. LIMITED.",
"HARIOM DISTRIBUTORS PRIVATE LIMITED",
"HARIOM DRESSES PRIVATE LIMITED",
"HARIOM ENGINEERING PRIVATE LIMITED",
"HARIOM ENGITECH PRIVATE LIMITED",
"HARIOM FEEDS PRIVATE LIMITED",
"HARIOM FILAMENTS PRIVATE LIMITED",
"HARIOM FORGINGS PRIVATE LIMITED",
"HARIOM HOSPITALITY AND ESTATES PRIVATE LIMITED",
"HARIOM INDUSTRIES LIMITED.",
"HARIOM INGOTS & POWER PRIVATE. LIMITED.",
"HARIOM MASALA PRIVATE LIMITED",
"HARIOM MEDICALS PRIVATE LIMITED",
"HARIOM MOBILE PRIVATE LIMITED",
"HARIOM PIPE INDUSTRIES LIMITED",
"HARIOM POLYPACKS LIMITED",
"HARIOM PROJECTS PRIVATE LIMITED",
"HARIOM SARASWATI P G COLLEGE",
"HARIOM SMELTERS PRIVATE LIMITED",
"HARIOM STAINLESS PIPES PRIVATE LIMITED",
"HARI-OM TECHNOCRATS PVT LTD",
"HARIOM VANIJYA PVT LTD",
"HARIOM YAMAHA",
"HARIOM ZARILON PRIVATE LIMITED",
"HARIOMKAR FOOD PRODUCTS PRIVATE LIMITED",
"HARIPACK EXTRUSIONS (VIDARBHA) PRIVATE LIMITED",
"HARIPACK GLOBAL VISION PRIVATE LIMITED",
"HARIPACK POLYMERS PRIVATE LIMITED",
"HARIPADA COLD STORAGE PVT LTD",
"HARIPADA DUTTA PAINTS PRIVATE LIMITED",
"HARIPRAKASH CHEMICALS INDUSTRIES PRIVATE LIMITED",
"HARIPRIYA SUGAR AND AGRO PRODUCTS PRIVATE LIMITED",
"HARIPRIYA SYNTEX PRIVATE LIMITED",
"HARIPUR PAPER COMPANY",
"HARIPUSHP DEVCON PRIVATE LIMITED",
"HARIRAM CHEMICALS PRIVATE LIMITED",
"HARIRAM DIE CASTING PIVATE LIMITED",
"HARIRAM PACKAGING AND POLYMERS",
"HARIRAM ROCHIRAM AUTO PRIVATE LIMITED",
"HARIRAM VENTURES PRIVATE LIMITED",
"HARIS MARINE PRODUCTS PRIVATE LIMITED",
"HARIS SENSOR TECHNOLOGIES PRIVATE LIMITED",
"HARISANKAR PAPERBOARDS PRIVATE LIMITED",
"HARISAR BOARD PRIVATE LIMITED",
"HARISH & BINA SHAH FOUNDATION",
"HARISH & COMPANY LOGISTICS PRIVATE LIMITED",
"HARISH ACRO POLYMERS PRIVATE LIMITED",
"HARISH BAKERS AND CONFECTIONERS PRIVATE LIMITED",
"HARISH C KHOSLA AND COMPANY PRIVATE LIMITED",
"HARISH CHANDRA INTERMEDIATE COLLEGE VARANASI",
"HARISH CHANDRA RESEARCH INSTITUTE JHUNSI",
"HARISH CHEMICALS PRIVATE LIMITED",
"HARISH FOREX SERVICES PRIVATE LIMITED",
"HARISH HOSPITAL PRIVATE LIMITED",
"HARISH MOTORS PRIVATE LIMITED",
"HARISH NICKEL-SCREENS PRIVATE LIMITED",
"HARISH PACKERS PRIVATE LIMITED",
"HARISH PLYWOOD PRIVATE LIMITED",
"HARISH PROCESSORS PRIVATE LIMITED",
"HARISH PROJECT CONTRACTOR PRIVATE LIMITED",
"HARISH SARAN POLYNULES PRIVATE LIMITED",
"HARISH TEX-MACH PRIVATE LIMITED",
"HARISH TEXTILE ENGINEERS LIMITED",
"HARISHAKTI FLOAT GLASSES PRIVATE LIMITED",
"HARISHCHANDRA HEALTHCARE PRIVATE LIMITED",
"HARISHCHANDRAPUR FLOUR MILLS PRIVATE LIMITED",
"HARISHPUR TEA CO PVT LTD",
"HARISHREE POLYMERS PRIVATE LIMITED",
"HARISIVA LAKSHMI BUILDERS PRIVATE LIMITED",
"HARISON AGRO RASAYAN PRIVATE LIMITED",
"HARISON GENERATORS PRIVATE LIMITED",
"HARISON PACKAGING PVT LTD",
"HARISON PUMPS PRIVATE LIMITED",
"HARISONS & HARLAJ LIMITED",
"HARISONS DIAMONDS PRIVATE LIMITED",
"HARISONS HYDEL CONSTRUCTION CO PRIVATE LIMITED",
"HARISONS PHARMACEUTICALS LIMITED",
"HARISONS STEEL LIMITED",
"HARISREE FOOD PRODUCTS",
"HARISSONS BAGS PRIVATE LIMITED",
"HARISUN CERAMIC PRIVATE LIMITED",
"HARIT EXPORTS PRIVATE LIMITED",
"HARIT FABTEX INDIA PRIVATE LIMITED",
"HARIT INDUSTRIES PRIVATE LIMITED",
"HARIT PATH PRIVATE LIMITED",
"HARIT POLYTECH PRIVATE LIMITED",
"HARIT SHAKTI FARMERS PRODUCER COMPANY LIMITED",
"HARIT TRANSFORMERS PRIVATE. LIMITED.",
"HARIT VATIKA PROJECTS PRIVATE LIMITED",
"HARIT YAMUNA MISSION FOUNDATION",
"HARITA FEHRER LIMITED",
"HARITA INSURANCE BROKING LLP",
"HARITA POLYTEX (INDIA) PRIVATE LIMITED",
"HARITA RECEIVABLES AND COLLECTION SERVICES LLP",
"HARITA SEATING SYSTEMS LIMITED",
"HARITA TECHSERV PRIVATE LIMITED",
"HARITASA ELECTRONICS SOLUTIONS PRIVATE LIMITED",
"HARITHA AUTOMATION PRIVATE LIMITED",
"HARITHA BIO AND INFRA PRIVATE LIMITED",
"HARITIMA FOOD PRODUCTS PRIVATE LIMITED",
"HARITSONS DESIGNS PRIVATE LIMITED",
"HARITSONS MINTECH PRIVATE LIMITED",
"HARIVANDANA COLLEGE",
"HARIVARDHAN STEEL AND ALLOYS PRIVATE LIMITED",
"HARIVIGNESH MARKETING PRIVATE LIMITED",
"HARIVU CREATIONS PRIVATE LIMITED",
"HARIWALLABH INTERNATIONAL PRIVATE LIMITED",
"HARIWANSH PACKAGING PRIVATE LIMITED",
"HARIWILL ELECTRONICS INDIA PRIVATE LIMITED",
"HARIYALI FOODS CO. PRIVATE LIMITED",
"HARIYALI HOTELS PRIVATE LIMITED",
"HARIYALI INFRAVENTURES PRIVATE LIMITED",
"HARIYALI KISAN SAMRIDDHI PRODUCER COMPANY LIMITED",
"HARIYANA SHIP DEMOLITION PRIVATE LIMITED",
"HARIYANA SHIP-BREAKERS LIMITED",
"HARIYANA VENTURES LIMITED",
"HARJAI COMPUTERS PRIVATE LIMITED",
"HARJAS CONTRACTORS & SUPPLIERS PRIVATE LIMITED",
"HARJAS GLOBAL DEALS PRIVATE LIMITED",
"HARJAS INTERNATIONAL PRIVATE LIMITED",
"HARJAS LOGIC SYSTEMS PRIVATE LIMITED",
"HARJASE PRODUCTS PRIVATE LIMITED",
"HARJASE REAL ESTATE PROMOTERS & DEVELOPERS PRIVATE LIMITED",
"HARJASE SUPPORT SERVICES LIMITED",
"HARJEET TEXTILES PRIVATE LIMITED",
"HARJI ENGINEERING WORKS PRIVATE LIMITED",
"HARJIT PAPER AND MACHINERY PRIVATE LIMITED",
"HARJIT SINGH DUGAL",
"HARJIVANDAS MOHANDAS AND COMPANY-INDIA PRIVATE LIMITED",
"HARK ENGINEERS PRIVATE LIMITED",
"HARK INDUSTRIES PRIVATE LIMITED",
"HARKANTH MEDI PRIVATE LIMITED",
"HARKESH AGROTECH PRIVATE LIMITED",
"HARKESH DAS BROTHERS (PAPER) PVT LTD",
"HARKESHWAR REALTORS PRIVATE LIMITED",
"HARKI PROPERTIES AND INVESTMENTS PRIVATE LIMITED",
"HARKIN GLOBAL SOLUTIONS PRIVATE LIMITED",
"HARKISHAN TEXTILE MILLS PRIVATE LIMITED",
"HARKRISH REALTY PRIVATE LIMITED",
"HARKRISHANJI PRODUCTS PRIVATE LIMITED",
"HARLAL SEEDS PRIVATE LIMITED",
"HARLALJI SONS PACKAGING PRIVATE LIMITED",
"HARLALKA MINERALS PRIVATE LIMITED",
"HARLALKA RESTAURANTS PRIVATE LIMITED",
"HARLALKA SERVICES INDIA PRIVATE LIMITED",
"HARLAND CLARKE HOLDING SOFTWARE INDIA PRIVATE LIMITED",
"HARLEM POLYCONTAINERS PRIVATE LIMITED",
"HARLEQUIN LOGISTICS INDIA PRIVATE LIMITED",
"HARLEQUIN PAINTS PRIVATE LIMITED",
"HARLEY CARMBEL COMMODITIES PRIVATE LIMITED",
"HARLEY SECURITIES PRIVATE LIMITED",
"HARLEYS CLINIC PRIVATE LIMITED",
"HARLOK SUPER SKILLS PRIVATE LIMITED",
"HARMAIN POLYFAB PRIVATE LIMITED",
"HARMAN AUTOPLAST PRIVATE LIMITED",
"HARMAN BAWA PRIVATE LIMITED",
"HARMAN CONNECTED SERVICES CORPORATION INDIA PRIVATE LIMITED",
"HARMAN CONNECTED SERVICES TECHNOLOGIES PRIVATE LIMITED",
"HARMAN COTTEX & SEEDS PRIVATE LIMITED",
"HARMAN FINOCHEM LIMITED",
"HARMAN INTERNATIONAL INDIA PRIVATE LIMITED",
"HARMAN LOGISTICS LLP",
"HARMAN MARKETING PRIVATE LIMITED",
"HARMAN RICE PRIVATE LIMITED",
"HARMAN SALES PRIVATE LIMITED",
"HARMEEN INFONET PRIVATE LIMITED",
"HARMEET CARS PRIVATE LIMITED",
"HARMILAP MEDIA PRIVATE LIMITED",
"HARMILAP ROSHNI LIMITED",
"HARMLESS PRIVATE LIMITED",
"HARMON ASSOCIATES INDIA PRIVATE LIMITED",
"HARMONEY FINSERV INDIA PRIVATE LIMITED",
"HARMONY ADDITIVES PRIVATE LIMITED.",
"HARMONY BUILDING AUTOMATION PRIVATE LIMITED",
"HARMONY COLONISERS PRIVATE LIMITED",
"HARMONY COMPUTER PRIVATE LIMTIED",
"HARMONY CREATION PRIVATE LIMITED",
"HARMONY DISTRIBUTORS PRIVATE LIMITED",
"HARMONY ECOTECH PRIVATE LIMITED",
"HARMONY EDUSERVE PRIVATE LIMITED",
"HARMONY EKMA COTFAB PRIVATE LIMITED",
"HARMONY FACILITY MANAGEMENT PRIVATE LIMITED",
"HARMONY FOODS PRIVATE LIMITED",
"HARMONY HEALTH SERVICES PRIVATE LIMITED",
"HARMONY INFRASOLUTIONS PRIVATE LIMITED",
"HARMONY INKS & COATINGS PRIVATE LIMITED",
"HARMONY INSURANCE BROKING PRIVATE LIMITED",
"HARMONY LAMINATES PRIVATE LIMITED",
"HARMONY LEATHER IMPEX PRIVATE LIMITED",
"HARMONY LIFE SCIENCE PRIVATE LIMITED",
"HARMONY LIFESCIENCE PRIVATE LIMITED",
"HARMONY LIFESTYLE STRUCTURES PRIVATE LIMITED",
"HARMONY MEDICARE PRIVATE LIMITED",
"HARMONY MERCHANDISE PRIVATE LIMITED",
"HARMONY METAL ARTS PRIVATE LIMITED",
"HARMONY MOTELS PRIVATE LIMITED",
"HARMONY MOTORS PRIVATE LIMITED",
"HARMONY MULTIMEDIA PRIVATE LIMITED",
"HARMONY MULTISPECIALITY HOSPITAL",
"HARMONY MUSICAL INSTRUMENTS MADRAS PRIVATE LIMITED",
"HARMONY ORGANICS PRIVATE LIMITED",
"HARMONY PLANNING SERVICES PRIVATE LIMITED",
"HARMONY PLASTICS PRIVATE LIMITED",
"HARMONY PLY-LAM LIMITED",
"HARMONY RESIDENCES PRIVATE LIMITED",
"HARMONY SYSTEMS PRIVATE LIMITED.",
"HARMONY UNITED MEDSOLUTIONS PRIVATE LIMITED OPC",
"HARMONY VINIMAY PRIVATE LIMITED",
"HARMONY YARNS PRIVATE LIMITED",
"HARMUKH INFRASTRACTURE PRIVATE LIMITED",
"HARNAM DAS FOODS PRIVATE LIMITED",
"HARNAM SINGH BISHAN SINGH JEWELLERS PVT LTD",
"HARNATH CROP GENITICS PRIVATE LIMITED",
"HARNESS CABLE CONNECTOR P.LTD.",
"HARNESS DIGITECH PRIVATE LIMITED",
"HARNESS INDIA PRIVATE LIMITED",
"HARNESS OVERSEAS PRIVATE LIMITED",
"HARNESS TECHNIQUES INDIA PRIVATE LIMITED",
"HARNESSIO R&D LABS INDIA PRIVATE LIMITED",
"HARNEX SYSTEMS PRIVATE LIMITED",
"HARNIK GENERAL FOODS PRIVATE LIMITED",
"HARNISH PHARMA PRIVATE LIMITED",
"HARNOOR LOGISTICS PRIVATE LIMITED",
"HARNS TECHNOLOGIES PRIVATE LIMITED",
"HARO GOURI AGRO PRODUCTS",
"HAROLD INDUSTRIES PRIVATE LIMITED",
"HAROON CARS PRIVATE LIMITED",
"HARP RESORTS PRIVATE LIMITED",
"HARPERCOLLINS PUBLISHERS INDIA PRIVATE LIMITED",
"HARPREET COLOR VISION PRIVATE LIMITED",
"HARPREET CRYOGENICS PRIVATE LIMITED",
"HARPREET MOTORS PRIVATE LIMITED",
"HARPRITAM INDUSTRIES PRIVATE LIMITED",
"HARPYARI DEVI WELFARE SOCIETY",
"HARRA POLYFLEX PRIVATE. LIMITED.",
"HARRI SOFTWARE DEVELOPMENT AND SOLUTIONS INDIA PRIVATE LIMITED",
"HARRIER INFORMATION SYSTEM PRIVATE LIMITED",
"HARRIER SECURITY SERVICES PRIVATE LIMITED",
"HARRINGTON HOTELS PRIVATE LIMITED",
"HARRIS AND MENUK CHEMICALS PRIVATE LIMITED.",
"HARRIS BRUSHES INDIA PRIVATE LIMITED",
"HARRIS CORPORATION",
"HARRIS PHARMA LLP",
"HARRIS PYE ENGINEERING INDIA PRIVATE LD",
"NUCOR REBAR FABRICATION DETAILING AND ESTIMATING SERVICES PRIVATE LIMITED",
"HARRISON ASSESSMENTS INDIA PRIVATE LIMITED",
"HARRISON MEDICAL INSTRUMENTS COMPANY PRIVATE LIMITED",
"HARRISON MILLER HEALTHCARE PRIVATE LIMITED",
"HARRISONS MALAYALAM LIMITED",
"HARRISSA HEALTHCARE PRIVATE LIMITED",
"HARRIT HEALTH CARE PRIVATE LIMITED",
"HARRO HOEFLIGER PACKAGING SYSTEMS PRIVATE LIMITED",
"HARRODS HEALTH PRIVATE LIMITED",
"HARROF CONCEPTS INDIA PRIVATE LIMITED",
"HARRSHA INFRA CONS PRIVATE LIMITED",
"HARRSHA INFRA PROJECTS PRIVATE LIMITED",
"HARRY CONSULTANCY SERVICES PRIVATE LIMITED",
"HARRY'S BREEDING FARMS PRIVATE LIMITED",
"HARRYS FEEDS PVT LTD",
"HARRYSON INFOTECH SERVICES PRIVATE LIMITED",
"HARRYSONS CONSULTANTS PVT LTD",
"HARSACHI SOLUTIONS PRIVATE LIMITED",
"HARSAHAIMAL SHIAMLAL JEWELLERS LUCKNOW PRIVATE LIMITED",
"HARSAHAIMAL SHIAMLAL JEWELLERS PRIVATE LIMITED",
"HARSCO INDIA METALS PRIVATE LIMITED",
"HARSCO INDIA PRIVATE LIMITED",
"ENVIRI INDIA SERVICES PRIVATE LIMITED",
"HARSH AUTOMOBILES PRIVATE LIMITED",
"HARSH BEAUTY CARE AND PACKAGING PRIVATE LIMITED",
"HARSH CARRIERS PRIVATE LIMITED",
"HARSH CARS PRIVATE LIMITED",
"HARSH CLEAN DHAN PRIVATE LIMITED",
"HARSH COMMODITIES PRIVATE LIMITED",
"HARSH CONSTRUCTIONS PRIVATE LIMITED",
"HARSH ENTERPRISES",
"HARSH EXIM PRIVATE LIMITED",
"HARSH FEB PRIVATE LIMITED",
"HARSH FUELS PRIVATE LIMITED",
"HARSH FUTURES COMMODITIES PRIVATE LIMITED",
"HARSH GATHANI ENTERPRISE PRIVATE LIMITED",
"HARSH GLOBAL PRIVATE LIMITED",
"HARSH HOUSE PRIVATE LIMITED",
"HARSH HYDROMECH PRIVATE LIMITED",
"HARSH IMPEX PVT LTD",
"HARSH INFINITY FLAVOUR PRIVATE LIMITED",
"HARSH INTERNATIONAL INDUSTRIES PRIVATE LIMITED",
"HARSH INTERTRADE PRIVATE. LIMITED.",
"HARSH INVESTMENTS PVT LTD",
"HARSH JAIN CONSTRUCTIONS PRIVATE LIMITED",
"HARSH LIFE SCIENCE PRIVATE LIMITED",
"HARSH LOGISTICS PRIVATE LIMITED",
"HARSH MEDICAL CENTRE PRIVATE LIMITED",
"HARSH MEDICOSE PRIVATE LIMITED",
"HARSH NUTRICARE PRIVATE LIMITED",
"HARSH ORGANO-CHEM (INDIA) PRIVATE LIMITED",
"HARSH PAN PRODUCTS PRIVATE LIMITED",
"HARSH PLASTO METALIZERS PRIVATE LIMITED",
"HARSH POLYFABRIC PRIVATE LIMITED",
"HARSH POLYPACK PRIVATE LIMITED",
"HARSH PRANJAL INSTRUMENT & POWER PRIVATE LIMITED",
"HARSH PRECIOUS METALS PRIVATE LIMITED",
"HARSH SUPPLIERS PRIVATE LIMITED",
"HARSH SYNTEX PRIVATE LIMITED",
"HARSH TEJAS NUTRITION PRIVATE LIMITED",
"HARSH TRACON PRIVATE LIMITED",
"HARSH TRANS SOLUTION",
"HARSH TRANSPORT PRIVATE LIMITED",
"HARSH VIDYA MANDIR",
"HARSH VINIMAY PVT LTD",
"HARSHA ABAKUS SOLAR PRIVATE LIMITED",
"HARSHA ASSOCIATES PRIVATE LIMITED",
"HARSHA AUTO AGENCIES PRIVATE LIMITED",
"HARSHA AUTO ENTERPRISES PRIVATE LIMITED",
"HARSHA AUTO MARTS PRIVATE LIMITED",
"HARSHA AUTOMOBILES PRIVATE LIMITED",
"HARSHA AUTOMOTIVE PRIVATE LIMITED",
"HARSHA CARS PRIVATE LIMITED",
"HARSHA CONSTRUCTIONS PRIVATE LIMITED",
"HARSHA ENGINEERS INTERNATIONAL LIMITED",
"HARSHA HOMES & INFRA PRIVATE LIMITED",
"HARSHA INFRA POWER PRIVATE LIMITED",
"HARSHA INFRA PROJECTS PRIVATE LIMITED",
"HARSHA LEATHER GOODS PRIVATE LIMITED",
"HARSHA LOGISTIC (INDIA) PRIVATE LIMITED",
"HARSHA MANAGEMENT SERVICES PRIVATE LIMITED",
"HARSHA MILLHARD PRIVATE LIMITED",
"HARSHA MOTORS SERVICES PRIVATE LIMITED",
"HARSHA MULTISERVICES PRIVATE LIMITED",
"HARSHA STONE INDUSTRIES",
"HARSHA SUGARS LIMITED",
"HARSHA TRADELINKS PRIVATE LIMITED",
"HARSHA URBAN BRICKS PRIVATE LIMITED",
"HARSHA VARDHAN AIR CONDITIONING ENGINEERS PRIVATE LIMITED",
"HARSHA WELDING SYSTEMS PRIVATE LIMITED",
"HARSHAD APARTMENT BUILDER PRIVATE LIMITED",
"HARSHAD MACHINERY PRIVATE LIMITED",
"HARSHAD MANGO PRODUCTS PRIVATE LIMITED",
"HARSHAD PACKWELL PRIVATE LIMITED",
"HARSHADRAY PRIVATE LIMITED",
"HARSHAL CONTROL SYSTEMS PRIVATE LIMITED",
"HARSHAL ELECTRICAL PRIVATE LIMITED",
"HARSHAL INDUSTRIES PRIVATE LIMITED",
"HARSHAL PROPERTIES PRIVATE LIMITED",
"HARSHALA ENTERPRISES PRIVATE LIMITED",
"HARSHALI INFRA SOLUTIONS PRIVATE LIMITED",
"HARSHALI OPTOELECTRONICS PRIVATE LIMITED",
"HARSHAM HOSPITALITIES PRIVATE LIMITED",
"HARSHAMITRA ONCOLOGY PRIVATE LIMITED",
"HARSHANT INVESTMENTS PRIVATE LIMITED",
"HARSHAYUSH CONSTRUCTIONS PRIVATE LIMITED",
"HARSHDEEP AUTOSPRING PRIVATE LIMITED",
"HARSHDEEP INDUSTRIES (I) PRIVATE LIMITED",
"HARSHFINE CHEMOPHARMA PRIVATE LIMITED",
"HARSHIL AGROTECH LIMITED",
"HARSHIL HOTEL PRIVATE LIMITED",
"HARSHIL MOTORS PRIVATE LIMITED",
"HARSHIL TEXTILES",
"HARSHINI EPC PRIVATE LIMITED",
"HARSHINI RICEMILLS PRIVATE LIMITED",
"HARSHINII MOBILES",
"HARSHINIMOUNIKA INFRA PRIVATE LIMITED",
"HARSHIT FINVEST PRIVATE LIMITED",
"HARSHIT GEMS LIMITED",
"HARSHIT HERBAL PRIVATE LIMITED",
"HARSHIT INFO SOLUTIONS PRIVATE LIMITED",
"HARSHIT LOGISTICS PRIVATE LIMITED",
"HARSHIT MACHINES PRIVATE LIMITED",
"HARSHIT POLYMERS (INDIA) PRIVATE LIMITED",
"HARSHIT STEEL EXPRESS MART PRIVATE LIMITED",
"HARSHIT TIE-UP PRIVATE LIMITED",
"HARSHIT TRADE LINK PRIVATE LIMITED",
"HARSHITA DISTRIBUTORS PRIVATE LIMITED",
"HARSHITA ELECTRO & TELECOM PRIVATE LIMITED",
"HARSHITA POLYPACK",
"HARSHITA PULSES PRIVATE LIMITED",
"HARSHITH MOTORS PRIVATE LIMITED",
"HARSHITHA ENGINEERING INDUSTRIES PRIVATE LIMITED",
"HARSHITHA HOSPITALS PRIVATE LIMITED",
"HARSHITHA POLYMERS INDIA PRIVATE LIMITED",
"HARSHIV PIPES PRIVATE LIMITED",
"HARSHNA FRUITS",
"HARSHNAD INTERNATIONAL PRIVATE LIMITED",
"HARSHNI TEXTILES LIMITED",
"HARSHPRIYA CONSTRUCTION PRIVATE LIMITED",
"HARSHSMIT PLASTICS PRIVATE LIMITED",
"HARSHUBH TECH PRIVATE LIMITED",
"HARSHUL CHEMICALS PRIVATE LIMITED",
"HARSHVARDHAN RETAILING PRIVATE LIMITED",
"HARSHVIJAY EXIM OPC PRIVATE LIMITED",
"HARSHWARDHAN STEELS PRIVATE LIMITED",
"HARSIDDH ELECTRO MECH PRIVATE LIMITED",
"HARSIDDH PHARMAMACH PRIVATE LIMITED",
"HARSIDDHI AUTO COMPONENTS PRIVATE LIMITED",
"HARSIDDHI HEALTH CARE PRIVATE LIMITED",
"HARSIDDHI OIL MILL PRIVATE LIMITED",
"HARSIM AGRO TECH PRIVATE LIMITED",
"HARSIMRAN ENTERPRISES PRIVATE LIMITED",
"HARSO STEELS PRIVATE LIMITED",
"HARSOLIA BROTHERS",
"HARSON LABORATORIES INDIA PRIVATE LIMITED",
"HARSON LABS PRIVATE LIMITED",
"HARSORIA HEALTHCARE PRIVATE LIMITED",
"HARSORIA MEDICAL PRIVATE LIMITED",
"HARSYAN FACILITY SOLUTIONS PRIVATE LIMITED",
"HARTECH PLASTICS PRIVATE LIMITED",
"HARTEK DESIGN AND SOFTWARE SOLUTIONS PRIVATE LIMITED",
"HARTEK INDIA PRIVATE LIMITED",
"HARTEK POWER PRIVATE LIMITED",
"HARTEK SOLAR PRIVATE LIMITED",
"HARTEX RUBBER PRIVATE LIMITED",
"HARTING INDIA PRIVATE LIMITED",
"HARTING MANUFACTURING INDIA PRIVATE LIMITED",
"HARTON PRIVATE LIMITED",
"HARTREE ENERGY SYSTEMS PRIVATE LIMITED",
"HARTRON COMMUNICATIONS LIMITED",
"HARU WORLDWIDE LIMITED",
"HARUDEVS MINES AND MINERALS PRIVATE LIMITED",
"HARUSHKA ENGINEERS PRIVATE LIMITED",
"HARVARD BUSINESS SCHOOL PUBLISHING INDIA PRIVATE LIMITED",
"HARVARD GLOBAL LOGISTICS LIMITED",
"HARVARD GLOBAL RESEARCH SUPPORT CENTRE INDIA",
"HARVE METALS INDIA PRIVATE LIMITED",
"HARVEL AGUA INDIA PRIVATE LIMITED",
"HARVEL IRRIGATIONS PRIVATE LIMITED",
"HARVEN INFRA PRIVATE LIMITED",
"HARVEST AGRO FARM EQUIPMENTS PRIVATE LIMITED",
"HARVEST CATERERS PRIVATE LIMITED",
"HARVEST GOLD INDUSTRIES PRIVATE LIMITED",
"HARVEST HEALTHCEUTICALS PRIVATE LIMITED",
"HARVEST HI-TECH EQUIPMENTS (INDIA) PRIVATE LIMITED",
"HARVEST HYBRID SEEDS INDIA PRIVATE LIMITED",
"HARVEST ICE AND COLD STORAGE PRIVATE LIMITED",
"HARVEST INTERNATIONAL CONSORTIUMS INDIA LIMITED",
"HARVEST INTERNATIONAL SCHOOL",
"HARVEST PACKAGING PRIVATE LIMITED",
"HARVEST PRINTING SERVICES PRIVATE LIMITED",
"HARVEST SUCCESS ACADEMY PRIVATE LIMITED",
"HARVEST TRADELINK PRIVATE LIMITED",
"HARVESTDEAL SECURITIES LIMITED",
"HARVESTING INDIA PRIVATE LIMITED",
"HARVESTRUPEE FINANCIAL SERVICES PRIVATE LIMITED",
"HARVESTWILD ORGANIC SOLUTIONS PRIVATE LIMITED",
"HARVEY BONVOY PRIVATE LIMITED",
"HARVEY INDIA TOURS AND TRAVELS",
"HARVEY LABORATORIES PRIVATE LIMITED",
"HARVEY NASH INDIA PRIVATE LIMITED",
"HARVEY WORLD DESTINATIONS PRIVATE LIMITED",
"HARVIN HOSPITALITY PRIVATE LIMITED",
"HARVINDER FINANCE COMPANY PVT LTD",
"HARVINS CONSTRUCTIONS PRIVATE LIMITED",
"HARVITEC ENTERPRISES PRIVATE LIMITED",
"HARWARD ADVERTISING AND COMMUNICATIONS PRIVATE LIMITED",
"HARYALI AGROSEEDS AND FERTILIZERS PRIVATE LIMITED",
"HARYANA AGRO INDS. CORPN. LIMITED",
"HARYANA CAPFIN LIMITED.",
"HARYANA CIRCLIP PVT LTD",
"HARYANA CITY GAS (KCE) PRIVATE LIMITED",
"HARYANA CITY GAS DISTRIBUTION LIMITED",
"HARYANA COATING PRIVATE LIMITED",
"HARYANA COLD RETREADS PRIVATE LIMITED",
"HARYANA COMTRADE PRIVATE LIMITED",
"HARYANA CONCRETE PRODUCTS LIMITED",
"HARYANA CONDUCTORS PVT LTD",
"HARYANA DISTILLERY LIMITED",
"HARYANA FACADE PRIVATE LIMITED",
"HARYANA FOOD & GENERAL MILLS",
"HARYANA FOREST DEVELOPMENT CORPORATION LIMITED",
"HARYANA FORESTS LIMITED",
"HARYANA FREIGHT CARRIERS PRIVATE LIMITED",
"HARYANA GLOBAL LIMITED",
"HARYANA HARDWARE STORE PRIVATE LIMITED",
"HARYANA INST OF PUBLIC ADMINISTRAT",
"HARYANA INSTITUTE OF CIVIL AVIATION",
"HARYANA INTERNATIONAL HORTICULTURAL MARKETING CORPORATION LIMITED",
"HARYANA JEWELLERS PRIVATE LIMITED",
"HARYANA KAUSHAL ROZGAR NIGAM LIMITED",
"HARYANA KESRI RICE MILL",
"HARYANA KNOWLEDGE CORPORATION LIMITED",
"HARYANA LEATHER CHEMICALS LIMITED",
"HARYANA LINKAGES PVT LTD",
"HARYANA LIQUORS PRIVATE LIMITED",
"HARYANA LUBRICANTS (INDIA) LIMITED",
"HARYANA MALLEABLE AND ALLOY CASTINGS PRIVATE LIMITED",
"HARYANA METALLOYS LIMITED",
"HARYANA ORBITAL RAIL CORPORATION LIMITED",
"HARYANA PETROCHEMICALS LIMITED",
"HARYANA PIPES PRIVATE LIMITED",
"HARYANA PLAST PRIVATE LIMITED",
"HARYANA POLYMERS LIMITED.",
"HARYANA POWER GENERATION CORPORATION LIMITED",
"HARYANA PRESSURE COOKERS PRIVATE LIMITED",
"HARYANA PROMOTERS PRIVATE LIMITED",
"HARYANA RAIL INFRASTRUCTURE DEVELOPMENT CORPORATION LIMITED",
"HARYANA RASAYAN UDYOG PVT.LTD.",
"HARYANA REFRACTORIES PVT LTD",
"HARYANA ROADWAYS",
"HARYANA ROLLING MILLS (BHILAI) PRIVATE LIMITED",
"HARYANA SEEDS DEVELOPMENT CORPORATION LIMITED",
"HARYANA SHAHRI VIKAS PRADHIKARAN",
"HARYANA SHAKTI SR SEC SCHOOL",
"HARYANA SHEHRI VIKAS PRADHIKARAN",
"HARYANA STATE COOPERATIVE SUPPLY & MARKETING FEDERATION LIMITED",
"HARYANA STATE ELECTRONICS DEVELOPMENT CORPORATION LIMITED",
"HARYANA STATE ROADS AND BRIDGES DEVELOPMENT CORPORATION LIMITED",
"HARYANA STATE WAREHOUSING CORPORATION",
"HARYANA STEEL MONGERS PVT LTD",
"HARYANA STEEL SUPPLY COMPANY PRIVATE LIMITED",
"HARYANA STONE MILLS PRIVATE LIMITED",
"HARYANA STORES PRIVATE LIMITED",
"HARYANA TEST HOUSE",
"HARYANA TEXPRINTS OVERSEAS LIMITED",
"HARYANA TOURISM",
"HARYANA TRADERS PVT LTD",
"HARYANA VIDHAN SABHA",
"HARYANA VIDYUT PRASARAN NIGAM LIMITED",
"HARYANA WHEEL TYRES PRIVATE LIMITED",
"HARYROCK ENGINEERING PRIVATE LIMITED",
"HAS LIFESTYLE LIMITED",
"HASAN ASSOCIATES PRIVATE LIMITED",
"HASAN ELECTRICALS AND INFRASTRUCTURE PRIVATE LIMITED",
"HASAN TANKERS PRIVATE LIMITED",
"HASBRO CLOTHING PRIVATE LIMITED",
"HASCO INDIA PRIVATE LIMITED",
"HASEEB PHARMACEUTICALS PRIVATE LIMITED",
"HASGEEK LEARNING PRIVATE LIMITED",
"HASH CONNECT INTEGRATED SERVICES PRIVATE LIMITED",
"HASH INCLUDE IO TECHNOLOGY SOLUTIONS LLP",
"HASH TAG VENTURES PRIVATE LIMITED",
"HASH1TECH PRE-PRESS PRIVATE LIMITED",
"HASHA LAKHMA PATIL HIGH SCHOOL",
"HASHAM INVESTMENT AND TRADING CO PRIVATE LIMITED",
"HASHBROWN SYSTEMS PRIVATE LIMITED",
"HASHBUN MEDIA PRIVATE LIMITED",
"HASHBYTE STUDIO PRIVATE LIMITED",
"HASHCUBE SOFTWARE PRIVATE LIMITED",
"HASHDONE TECHNOLOGIES PRIVATE LIMITED",
"HASHEDIN TECHNOLOGIES PRIVATE LIMITED",
"HASHICORP (INDIA) PRIVATE LIMITED",
"HASHINCLUDE COMPUTECH PRIVATE LIMITED",
"HASHLOG SOLUTIONS PRIVATE LIMITED",
"HASHMAP TECH INDIA PRIVATE LIMITED",
"HASHMI ENTERPRISES PRIVATE LIMITED",
"HASHROOT TECHNOLOGIES PRIVATE LIMITED",
"HASHSTUDIOZ TECHNOLOGIES PRIVATE LIMITED",
"HASHTAG EDUCATION & CAREER PRIVATE LIMITED",
"HASHTAG HUMAN RESOURCES PRIVATE LIMITED",
"HASHTAG INDIA PRIVATE LIMITED",
"HASHTAG INFOSYSTEM",
"HASHTAG LOYALTY PRIVATE LIMITED",
"HASHTAG MARKETING PRIVATE LIMITED",
"HASHTECH SYSTEMS PRIVATE LIMITED",
"HASIMARA INDUSTRIES LTD",
"HASIRU DALA INNOVATIONS PRIVATE LIMITED",
"HASIRU FOODS PRIVATE LIMITED",
"HASITA AROMATICS PRIVATE LIMITED",
"HASITHA INFRASTRUCTURE PRIVATE LIMITED",
"HASKONINGDHV CONSULTING PRIVATE LIMITED",
"HASLE REFRACTORIES INDIA PRIVATE LIMITED",
"HASMAG EQUIPMENTS PRIVATE LIMITED",
"HASMUKH GOSWAMI COLLEGE OF ENGINEERING",
"HASMUKH INTERIORS PRIVATE LIMITED",
"HASMUKH TRAVEL AGENT PUNE PRIVATE LIMITED",
"HASOLON NYLON PRODUCTS PVT LTD",
"HASPACES IT AND HOSPITALITY PRIVATE LIMITED",
"HASS VENTURES INDIA PRIVATE LIMITED",
"HASSAN COFFEE CURING WORKS PRIVATE LIMITED",
"HASSAN HOTELS PRIVATE LIMITED",
"HASSAN MANGALORE RAIL DEVELOPMENT COMPANY LIMITED",
"HASSAN MILLERS PRIVATE LIMITED",
"HASSAN ROAD CONSTRUCTION COMPANY PRIVATE LIMITED",
"ROVEMA INDIA PRIVATE LIMITED",
"HASSONJEE ELECTRICALS PRIVATE LIMITED",
"HASTA SILLOD TOLLWAYS PRIVATE LIMITED",
"HASTA TRADELINK PRIVATE LIMITED",
"HASTAGIRI SAREE PRIVATE LIMITED",
"HASTALLOY INDIA LIMITED",
"HASTAND EXPORT MARKETING PRIVATE LIMITED",
"HASTEE SMART RETAIL PRIVATE LIMITED",
"HASTEN EXPRESS PRIVATE LIMITED",
"HASTEN EXTRUSIONS PRIVATE LIMITED",
"HASTEN FOREX AND TRAVEL PRIVATE LIMITED",
"HASTI COMPUTERS PRIVATE LIMITED",
"HASTI FINANCE LIMITED",
"HASTI INDIA LIMITED",
"HASTI PETRO CHEMICAL AND SHIPPING LIMITED",
"HASTI PIPES PRIVATE LIMITED",
"HASTINAPUR INFRATECH PRIVATE LIMITED",
"HASTINGS MILL LIMITED",
"HASTINI FEED AND AGRO PRIVATE LIMITED",
"HASTMILAP PRIVATE LIMITED",
"HASTWELL TECHNOLOGIES INDIA PRIVATE LIMITED",
"HASU INVESTMENTS PRIVATE LIMITED",
"HASYA SOFTWARE PRIVATE LIMITED",
"HAT PLATINUM HOTELS PRIVATE LIMITED",
"HATARI RESTAURANT PRIVATE LIMITED",
"HATCH ASSOCIATES INDIA PRIVATE LIMITED",
"HATCHERY SOFTWARE PRIVATE LIMITED",
"HATCHNHACK SOLUTIONS PRIVATE LIMITED",
"HATCHWAY WINDOOR PRIVATE LIMITED",
"HATCO FOODSERVICE EQUIPMENT INDIA PRIVATE LIMITED",
"HATDIA BUILDERS PRIVATE LIMITED",
"HATEC STOLZ INDIA PRIVATE LIMITED",
"HATGACHA HARIDAS VIDYAPITH",
"HATGAD RESORT PRIVATE LIMITED",
"HATHA HOMES PRIVATE LIMITED",
"HATHI BARANI INTER COLLEGE",
"HATHIPURA PRIMARY SCHOOL",
"HATHIPURA PRIMERY SCHOOL",
"HATHISARA FASHION PRIVATE LIMITED",
"HATHWAY BHAWANI CABLETEL AND DATACOM LIMITED",
"HATHWAY CABLE & DATACOM LIMITED",
"HATHWAY CABLE MCN NANDED PRIVATE LIMITED",
"HATHWAY DATTATRAY CABLE NETWORK PRIVATE LIMITED",
"HATHWAY DIGITAL LIMITED",
"HATHWAY DIGITAL PRIVATE LIMITED",
"HATHWAY INVESTMENTS",
"HATHWAY KOKAN CRYSTAL CABLE NETWORK LIMITED",
"HATHWAY LATUR MCN CABLE & DATACOM PRIVATE LIMITED",
"HATHWAY MANTRA CABLE & DATACOM LIMITED",
"HATHWAY MCN PRIVATE LIMITED",
"HATHWAY PATIALA CABLE PRIVATE LIMITED",
"HATHWAY SAI STAR CABLE & DATACOM PRIVATE LIMITED",
"HATIM CARBON CO PVT LTD",
"HATIM DIELECTRICS PVT LTD",
"HATKESH MULTISPACIALTY HOSPITAL",
"HATKESH MULTISPECIALITY HOSPITAL",
"HATORKI MOTORS PRIVATE LIMITED",
"HATS OFF PRODUCTIONS LIMITED",
"HATS ON ADVERTISING PRIVATE LIMITED",
"HATS-OFF DIGITAL PRIVATE LIMITED",
"HATSOFF HELICOPTER TRAINING PRIVATE LIMITED",
"HATSUMEI TECHNO INTERNATIONAL PRIVATE LIMITED",
"HATSUN AGRO PRODUCT LIMITED",
"HATTEN LABS PRIVATE LIMITED",
"HATTI FOOD AND BEVERAGES PRIVATE LIMITED",
"HATTRICK IMC PRIVATE LIMITED",
"HAULOTTE INDIA PRIVATE LIMITED",
"HAULWAYS TRANSPORT AND LOGISTICS PRIVATE LIMITED",
"HAUS CENTRIFUGE TECHNOLOGIES PRIVATE LIMITED",
"HAUSBERG PRIVATE LIMITED",
"HAUSE HOLDINGS",
"HAUSER CIVIL CONSULTING PRIVATE LIMITED",
"HAUSTIER VENTURES PRIVATE LIMITED",
"HAUTE SILVER JEWELS PRIVATE LIMITED",
"HAUZ PHARMA PRIVATE LIMITED",
"HAV AUTOMOBILES PRIVATE LIMITED",
"HAV CREATORS PRIVATE LIMITED",
"HAVAS LIFE SORENTO PRIVATE LIMITED",
"HAVAS MEDIA INDIA PRIVATE LIMITED",
"HAVAS WORLDWIDE INDIA PRIVATE LIMITED",
"HAVELI AMUSEMENT PARKS PRIVATE LIMITED",
"HAVELI GRANITES PRIVATE LIMITED",
"HAVELI IMPEX PRIVATE LIMITED",
"HAVELI MARBLE PRIVATE LIMITED",
"HAVELI RESTAURANT & RESORTS LIMITED",
"HAVELI STONES PVT. LTD",
"HAVELLS ELECTRONICS PRIVATE LIMITED",
"HAVELLS INDIA LIMITED",
"HAVEMORE REALTY PRIVATE LIMITED",
"HAVEN INFOLINE LLP",
"HAVEN INFRA PROJECTS AND POWER LIMITED",
"HAVER & BOECKER INDIA PRIVATE LIMITED",
"HAVER STANDARD INDIA PRIVATE LIMITED",
"HAVEUS AEROTECH INDIA LIMITED",
"HAVEUS AEROTECH INDIA PRIVATE LIMITED",
"HAVEUS SOLUTIONS PRIVATE LIMITED",
"HAVI ENGINEERING INDIA PRIVATE LIMITED",
"HAVINHOMES REALTY & CONSULTING SERVICES PRIVATE LIMITED",
"HAVISH INTERNATIONALS EDUCATION PRIVATE LIMITED",
"HAVISH MEDIA PRIVATE LIMITED",
"HAVISOLUTIONS PRIVATE LIMITED",
"HAVIT REMEDIES PRIVATE LIMITED",
"HAVMOR ICE CREAM PRIVATE LIMITED",
"HAVMOR PLAST PRIVATE LIMITED",
"HAVOC CONSULTANTS PRIVATE LIMITED",
"HAVOLENE MOBIL TECHNO PRIVATE LIMITED",
"HAVUKAL TEA & PRODUCE COMPANY PRIVATE. LIMITED.",
"HAVYA TECHNOLOGIES",
"HAWA ENGINEERS LTD",
"HAWA VALVES AND TUBES PRIVATE LIMITED",
"HAWA VALVES INDIA PRIVATE LIMITED",
"HAWABAGH WOMEN'S COLLEGE",
"HAWAI MAHAL MARKETING PRIVATE LIMITED",
"HAWARE ENGINEERS & BUILDERS PRIVATE. LIMITED.",
"HAWARE FINANCE PRIVATE LIMITED",
"HAWARE VENTURES PRIVATE LIMITED",
"HAWARE'S HOUSING DEVELOPMENT FINANCE CORPORATION LIMITED",
"HAWE HYDRAULICS PRIVATE LIMITED",
"HAWELIA BULLDERS PRIVATE LIMITED",
"HAWK CAPITAL PRIVATE LIMITED",
"HAWK CLEANING SERVICES PRIVATE LIMITED",
"HAWK COMMANDOS PROTECTION GROUP PRIVATE LIMITED",
"HAWK CONSULTANCY PRIVATE LIMITED",
"HAWK CYCLES PRIVATE LIMITED",
"HAWK EYE PROTECTION SERVICES PRIVATE LIMITED",
"HAWK EYE REALTY VENTURES PRIVATE LIMITED",
"HAWK EYE SECURITIES AND FACILITIES PRIVATE LIMITED",
"HAWK GRANITO PRIVATE LIMITED",
"HAWK SECURITY SERVICES PVT LTD",
"HAWK VISION PROTECTION SERVICES PRIVATE LIMITED",
"HAWK WIRE MANUFACTURING PRIVATE LIMITED",
"HAWK-EYE INVESTIGATION SERVICES PRIVATE LIMITED",
"HAWKINS COOKERS LIMITED",
"HAWKS EYE SECURITY SERVICES PRIVATE LIMITED",
"HAWKS INTERNATIONAL SECURITY SERVICES PRIVATE LIMITED",
"HAWKS PAINTS & COATINGS PRIVATE LIMITED",
"HAWKSVALE CIVIL INDIA PRIVATE LIMITED",
"HAWORTH INDIA PRIVATE LIMITED",
"HAXAR INSURANCE SERVICES PRIVATE LIMITED",
"HAY CONSULTANTS INDIA PRIVATE LIMITED",
"HAY HOUSE PUBLISHERS (INDIA) PRIVATE LIMITED",
"HAYAAT PHARMACY",
"HAYAGREEVA CONSULTING PRIVATE LIMITED",
"HAYAGREEVAS FABRICS PRIVATE LIMITED",
"HAYAGREV CIVIL ENGINEERING PRIVATE LIMITED",
"HAYAJAMI PORTA SOLUTIONS PRIVATE LIMITED",
"HAYASA E-MOBILITY (INDIA) PRIVATE LIMITED",
"HAYAT HOSPITAL PRIVATE LIMITED",
"HAYAT MULTISPECIALITY HOSPITAL",
"HAYAT PUMPS PRIVATE LIMITED",
"HAYAT UNANI MEDICAL COLLEGE AND RESERCH CENTRE",
"HAYATH ZAIN VENTURES PRIVATE LIMITED",
"HAYDEN TRADING PRIVATE LIMITED",
"HAYEN HYDEL POWER COMPANY PRIVATE LIMITED",
"HAYGOT SERVICES PRIVATE LIMITED",
"HAYLIDE CHEMICALS PRIVATE LIMITED",
"HAYMARKET MEDIA INDIA PRIVATE. LIMITED",
"HAYMARKET SAC PUBLISHING INDIA PRIVATE LIMITED",
"HAYRE REGENCY HOTELS PRIVATE LIMITED",
"HAYS BUSINESS SOLUTIONS PRIVATE LIMITED",
"HAYS SPECIALIST RECRUITMENT PRIVATE LIMITED",
"HAYSTACK MARKETING SERVICES PRIVATE LIMITED",
"HAYSTACKANALYTICS PRIVATE LIMITED",
"HAYWARD TECHNOLOGIES PRIVATE LIMITED",
"HAYWARD TYLER INDIA PRIVATE LIMITED",
"HAYYMED HEALTHCARE PRIVATE LIMITED",
"HAZARD SAFE (INDIA) LTD",
"HAZARGO INDUSTRIES PRIVATE LIMITED",
"HAZARI IMPEX PRIVATE LIMITED",
"HAZARIBAG COMMERCIAL LAYERS AND AGRO PRIVATE LIMITED",
"HAZARIBAG HOMES PRIVATE LIMITED",
"HAZARIBAG HOPE AND HEALTH CARE PRIVATE LIMITED",
"HAZARIBAGH RANCHI EXPRESSWAY LIMITED",
"HAZARIBAGH TOLLWAY PRIVATE LIMITED",
"HAZARILAL SHYAMLAL STEELS PRIVATE LIMITED",
"HAZARIMULL EXPORTERS PVT LTD",
"HAZCO PRIVATE LIMITED",
"HAZE DISTRIBUTORS PRIVATE LIMITED",
"HAZEL A UNIT OF ZEBA ARTS PVT LTD",
"HAZEL LIGHTING SYSTEMS PRIVATE LIMITED",
"HAZEL LOGISTICS PRIVATE LIMITED",
"HAZEL MERCANTILE LIMITED",
"HAZEL REALTY PRIVATE. LIMITED.",
"HAZELNUT FACTORY FOOD PRODUCTS PRIVATE LIMITED",
"HAZELO LAB PRIVATE LIMITED",
"HAZELSPHERE DEALERS PRIVATE LIMITED",
"HAZEMAG ALLMINERAL INDIA PRIVATE LIMITED",
"HAZEMAG INDIA PRIVATE LIMITED",
"HAZI AZAD BUILDERS PRIVATE LIMITED",
"HAZIRA CONTAINER FREIGHT STATION PRIVATE LIMITED",
"HAZIRA PORT PRIVATE LIMITED",
"HAZIRA REFRACTORY WORKS PRIVATE LIMITED",
"HAZLOC EQUIPMENTS PRIVATE LIMITED",
"HAZOOR MULTI PROJECTS LIMITED",
"HAZOORILAL AND SONS JEWELLERS PRIVATE LIMITED",
"HAZOORILAL JEWELLERS PRIVATE LIMITED",
"HAZRAT INAYAT KHAN FOUNDATION",
"HAZZALE BLUE TRADING PRIVATE LIMITED",
"HAZZEL DAIRY PRODUCTS PRIVATE LIMITED",
"HB EDUCATION AND CONSULTING SERVICES PRIVATE LIMITED",
"HB ENVIRO PRIVATE LIMITED",
"HB ESMECH PRIVATE LIMITED",
"HB ESTATE DEVELOPERS LIMITED",
"HB POLYMERS PRIVATE LIMITED",
"HB PORTFOLIO LIMITED",
"HB SOLUTIONS PRIVATE LIMITED",
"HB TRADERS PRIVATE LIMITED",
"HBA INTERNATIONAL INDIA PRIVATE LIMITED",
"HBA STUDIO PRIVATE LIMITED",
"HBC LIFESCIENCES PRIVATE LIMITED",
"HBC PROJECTS PRIVATE LIMITED",
"HBCDERMIZA HEALTHCARE PRIVATE LIMITED",
"HBC-RADIOMATIC INDIA PRIVATE LIMITED",
"HBD PACKAGING PRIVATE LIMITED",
"HBE AVIOSEC PRIVATE LIMITED",
"HBEONLABS TECHNOLOGIES PRIVATE LIMITED",
"HBG KNOWLEDGE SERVICES PRIVATE LIMITED",
"HBHM PRIVATE LIMITED",
"HBL POWER SYSTEMS LIMITED",
"HBM GARMENTS PRIVATE LIMITED",
"HBMK GLOBAL PRIVATE LIMITED",
"HBML INDIA PROPERTIES PRIVATE LIMITED",
"HBN CHEMICALS PRIVATE LIMITED",
"HBNT PACKAGING AND MANUFACTURING PRIVATE LIMITED",
"HBR SOLAR PRIVATE LIMITED",
"HBR TRANSPORT PRIVATE LIMITED",
"HBS FERTILISERS & CHEMICALS INDUSTRIES PRIVATE LIMITED",
"HBS INFRA ENGINEERS INDIA PRIVATE LIMITED",
"HBS VIEW PRIVATE LIMITED",
"HBS WOOLLEN MILLS PVT LTD",
"HBT TEXTILES PRIVATE LIMITED",
"HC DYESTUFF INDUSTRIES LIMITED",
"HC FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"HC GLOBAL FUND SERVICES LLP",
"HC INTELLECT PRIVATE LIMITED",
"HC MILKCO FOODS INDUSTRIES PRIVATE LIMITED",
"HC ROBOTICS PRIVATE LIMITED",
"HC VISA APPLICATION SERVICES PRIVATE LIMITED",
"HCA AUTOMATION SEWING SYSTEM PRIVATE LIMITED",
"HCA ENGINEERING PRIVATE LIMITED",
"HCA GARMENT MACHINERY PRIVATE LIMITED",
"HCA HOLDINGS INC.",
"HCAPITAL BUSINESS CONSULTING PRIVATE LIMITED",
"HCC HAPPINESS CARE & CURE MULTISPECIALITY HOSPITAL LLP",
"HCC HDC JOINT VENTURE",
"HCC INFRASTRUCTURE COMPANY LIMITED",
"HCC LIMITED",
"HCC OPERATIONS & MAINTENANCE LIMITED",
"HCCR BUSINESS INTELLIGENCE CENTRE PRIVATE LIMITED",
"HCD SOLAR SOLUTIONS PRIVATE LIMITED",
"HCENTIVE TECHNOLOGY INDIA PRIVATE LIMITED",
"HCG CANCER CENTRE",
"HCG EKO CANCER CENTRE",
"HCG HOSPITAL",
"HCG MANAVTA CANCER CENTER",
"HCG MEDI-SURGE HOSPITALS PRIVATE LIMITED",
"HCG ONCOLOGY LLP",
"HCG PANDA CANCER HOSPITAL",
"HCG(KCE)PRIVATE LIMITED",
"HCH BEARING INDIA PRIVATE LIMITED",
"HCH PEDIATRIC AND NEONATAL CENTER PRIVATE LIMITED",
"HCI RMC PRIVATE LIMITED",
"HCIL COMTEL LIMITED",
"HCIN NETWORKS PRIVATE LIMITED",
"HCK INFRATECH PRIVATE LIMITED",
"HCL AVITAS PRIVATE LIMITED",
"HCL CAPITAL PRIVATE LIMITED",
"HCL COAL INTERNATIONAL PRIVATE LIMITED",
"HCL COMNET LIMITED",
"HCL COMNET SYSTEM AND SERVICES LIMITED",
"HCL CORPORATION PRIVATE LIMITED",
"HCL FOUNDATION",
"HCL GLOBAL PROCESSING SERVICES LIMITED",
"HCL HEALTHCARE",
"HCL INFOSYSTEMS LIMITED",
"HCL INFOTECH LIMITED",
"HCL IT CITY LUCKNOW PRIVATE LIMITED",
"HCL LEARNING LIMITED",
"HCL TALENTCARE PRIVATE LIMITED",
"HCL TECHNOLOGIES LIMITED",
"HCL TRAINING & STAFFING SERVICE PRIVATE. LIMITED",
"HCLOUD HEALTH CARE (OPC) PRIVATE LIMITED",
"HCM AGRO PRODUCTS PRIVATE LIMITED",
"HCM IBEX ENGINEERING PRIVATE LIMITED",
"HCM ORTHOCARE PRIVATE LIMITED",
"HCMI EDUCATION PRIVATE LIMITED.",
"HCO HOTEL AND HOME CONCEPTS PRIVATE LIMITED",
"HCP DESIGN PLANNING AND MANAGEMENT PRIVATE LIMITED",
"HCP ENTERPRISE LIMITED",
"HCP INTERIOR DESIGN PRIVATE LIMITED",
"HCP PLASTENE BULKPACK LIMITED",
"HCP PRINTS PRIVATE LIMITED",
"HCP WELLNESS PRIVATE LIMITED",
"HCPL ELECTRICALS PRIVATE LIMITED",
"HCR INFO CONSUMABLES PRIVATE LIMITED",
"HCRI TECHNOLOGIES OF INDIA PRIVATE LIMITED",
"HCS AC&R ENGINEERS (I) PRIVATE LIMITED",
"HCS INDUSTRIAL SERVICES PRIVATE LIMITED",
"HCS INFORMATION TECHNOLOGIES PRIVATE. LIMITED",
"HCUBE WOWCARZ PRIVATE LIMITED",
"HCV DIGITAL ENTERTAINMENT PRIVATE LIMITED",
"HCV PROJECTS INDIA PRIVATE LIMITED",
"HCY INDUSTRIAL PARKS PRIVATE LIMITED",
"HCY WAREHOUSING PRIVATE LIMITED",
"HD BUSINESS SERVICES PRIVATE LIMITED",
"HD COMMUNICATIONS PRIVATE LIMITED",
"HD FIRE PROTECT PRIVATE LIMITED",
"HD HYUNDAI CONSTRUCTION EQUIPMENT INDIA PRIVATE LIMITED",
"HD HYUNDAI TECHNOLOGY CENTER INDIA PRIVATE LIMITED",
"HD INFOMATRIX SOLUTIONS PRIVATE LIMITED",
"HD JEWELLERY MARVELS PRIVATE LIMITED",
"HD MARKETING PRIVATE LIMITED",
"HD MEDICAL SERVICES INDIA PRIVATE LIMITED.",
"HD MICRONS LIMITED",
"HD MOTOR COMPANY INDIA PRIVATE LIMITED",
"H-D MOTOR COMPANY INDIA PRIVATE LIMITED",
"HD SUPPLY HOLDINGS INC.",
"HD TECHNOLOGY PRIVATE LIMITED",
"HDA BUILDCON PRIVATE LIMITED",
"HDA MOTORS PRIVATE LIMITED",
"HDA TECH GROWTH PRIVATE LIMITED",
"HDB FINANCIAL SERVICES LIMITED",
"HDC HOLDINGS PRIVATE LIMITED",
"HDC POWER SYSTEMS PRIVATE LIMITED",
"HDD SOLUTION PRIVATE LIMITED",
"HDFC ASSET MANAGEMENT COMPANY LIMITED",
"HDFC BANK CSE AND COEX EMPLOYEES",
"HDFC BANK LIMITED",
"HDFC CAPITAL ADVISORS LIMITED",
"HDFC CREDILA FINANCIAL SERVICES LIMITED",
"HDFC CREDILA FINANCIAL SERVICES PRIVATE LIMITED",
"HDFC DEVELOPERS LIMITED",
"HDFC EDUCATION AND DEVELOPMENT SERVICES PRIVATE LIMITED",
"HDFC ERGO GENERAL INSURANCE COMPANY LIMITED",
"HDFC ERGO HEALTH INSURANCE LIMITED",
"HDFC HOME LOAN",
"HDFC LIFE INSURANCE COMPANY LIMITED",
"HDFC PENSION MANAGEMENT COMPANY LIMITED",
"HDFC REALTY LIMITED",
"HDFC SALES PRIVATE LIMITED",
"HDFC SECURITIES LIMITED",
"HDFC STANDARD LIFE INSURANCE COMPANY LIMITED",
"HDFC TRUSTEE COMPANY LIMITED",
"HDG VENTURES PRIVATE LIMITED",
"HDK IMPEX PRIVATE LIMITED",
"HDK INTERNATIONAL PRIVATE LIMITED",
"HDK MIC TESTING PRIVATE LIMITED",
"HDN MOTORS PRIVATE LIMITED",
"HDN PROSEAL PRIVATE LIMITED",
"HDN TELECOM PRIVATE LIMITED",
"HDPL INFRASTRUCTURE LIMITED.",
"HDR IMPORT EXPORT PRIVATE LIMITED",
"HDS FACILITIES PRIVATE LIMITED",
"HDS INFRATOLL PRIVATE LIMITED",
"HDT SALES PRIVATE LIMITED",
"HDU HEALTHCARE PRIVATE LIMITED",
"HE SURYA NEW DELHI",
"HE TERMINALS PRIVATE LIMITED",
"HEAD DIGITAL WORKS PRIVATE LIMITED",
"HEAD FIELD SOLUTIONS PRIVATE LIMITED",
"HEAD HUNTERS PLACEMENT PRIVATE LIMITED",
"HEAD INFOTECH INDIA PRIVATE LIMITED",
"HEAD MASTER GOVT SEC & HIGHER SEC ASHRAM SCHOOL WADESHWAR PUNE",
"HEAD MASTER GOVT TECHNICAL HIGH SCHOOL THANE",
"HEAD POST OFFICE",
"HEAD START EDUCATIONAL ACADEMY",
"HEAD START EDUCATIONAL TRUST",
"HEAD START MONTESSORI SCHOOL",
"HEADER SYSTEMS INDIA LIMITED",
"HEADFITTED SOLUTIONS PRIVATE LIMITED",
"HEADHUNTERS HR PRIVATE LIMITED",
"HEADING WEDDING EVENTS PRIVATE LIMITED",
"HEADLINERS ADVERTISING SERVICES PVT. LTD.",
"HEADLONG NEWSROOM POST INDIA PRIVATE LIMITED",
"HEADMAN LABS PRIVATE LIMITED",
"HEADMASTER VIVEKANANDA VIDYAPITHA BAHUGRAM SALIPUR",
"HEADMASTERS LUDHIANA SALONS & SPA PRIVATE LIMITED",
"HEADPHONE ZONE PRIVATE LIMITED",
"HEADQUARTERS MAHARASHTRA GUJARAT AND GOA",
"HEADRUN TECHNOLOGIES PRIVATE LIMITED",
"HEADRUSH MARKETING PRIVATE LIMITED",
"HEADRUSH VENTURES PRIVATE LIMITED",
"HEADS GLOBAL PRIVATE LIMITED",
"HEADS UP CONSULTING PRIVATE LIMITED",
"HEADSAIL MEDIA SERVICES PRIVATE LIMITED",
"HEADSNMINDS CONSULTANTS PRIVATE LIMITED",
"HEADSPACE HR PRIVATE LIMITED",
"HEADSPIN TECHNOLOGIES PRIVATE LIMITED",
"HEADSTART GLOBAL PRIVATE LIMITED",
"HEADSTART NETWORK FOUNDATION",
"HEADSTRONG PETROCHEM PRIVATE LIMITED",
"HEADSTRONG SERVICES INDIA PRIVATE LIMITED",
"HEADSUP B2B PRIVATE LIMITED",
"HEADSUP CORPORATION PRIVATE LIMITED",
"HEADWAY FORWARD AVANT GRADE PRIVATE LIMITED",
"HEADWAY KREATIONS PRIVATE LIMITED",
"HEADWAY PRODUCTS PRIVATE LIMITED",
"HEADWAY RESOLUTION AND INSOLVENCY SERVICES PRIVATE LIMITED",
"HEADWAY TECHNOLOGY AND SERVICES PRIVATE LIMITED",
"HEADWAY X-CALIBUR CONSTRUCTION CHEMICALS PRIVATE LIMITED",
"HEADWORD PUBLISHING COMPANY PRIVATE LIMITED",
"HEADY TECHNOLOGIES CONSULTANCY PRIVATE LIMITED",
"HEAGER INDIA PRIVATE LIMITED",
"HEAK AUTO PRIVATE LIMITED",
"HEAL INDIA LABORATORIES PRIVATE LIMITED",
"HEAL LIFE MULTI-SPECIALITY HOSPITAL AND HEART CARE CENTRE",
"HEAL MY FAMILY HEALTH CARE SERVICES",
"HEAL SURE LIFESCIENCES PRIVATE LIMITED",
"HEALALL PHARMACEUTICALS PRIVATE LIMITED",
"HEALERS HOSPITAL PRIVATE LIMITED",
"HEALERSARK RESOURCES PRIVATE LIMITED",
"HEALING GARDENS PRIVATE LIMITED",
"HEALING HANDS & HERBS PRIVATE LIMITED",
"HEALING HANDS CLINIC PRIVATE LIMITED",
"HEALING LIVES SOLUTIONS PRIVATE LIMITED",
"HEALING PHARMA INDIA PRIVATE LIMITED",
"HEALING TOUCH HOSPITAL AND INSTITUTE OF CHILD HEALTH PRIVATE LIMITED",
"HEALING TOUCH HOSPITALS PRIVATE. LIMITED.",
"HEALING TOUCH LASIK LASER CENTER PRIVATE LIMITED",
"HEALING TREE HOSPITAL",
"HEALINGCROSS PHARMA PRIVATE LIMITED",
"HEALIOS INFRA PRIVATE LIMITED",
"HEALIS SEKHSARIA INSTITUTE FOR PUBLIC HEALTH",
"HEALIUS PATHOLOGY INDIA PRIVATE LIMITED",
"HEALIX HEALTHCARE PRIVATE LIMITED",
"HEALIX HOSPITALS",
"HEALIX VENTURES PRIVATE LIMITED",
"HEALKRAFT PHARMA (INDIA) PRIVATE LIMITED",
"HEALLO ONLINE HEALTH LLP",
"HEALTH & FAMILLY WELFAIRE DARTMENT CIVIL SURGEON CUM MAIN HOSPITAL SUPDT",
"HEALTH & GLOW PRIVATE LIMITED",
"HEALTH & GLOW RETAILING PRIVATE LIMITED",
"HEALTH & HAPPINESS PRIVATE LIMITED",
"HEALTH & MEDICAL SERVICES BHAVNAGAR",
"HEALTH & WELFAIRE DARTMENT CIVIL SURGEON CUM",
"HEALTH AIR COOLING SYSTEMS PRIVATE LIMITED",
"HEALTH AND BEYOND FOODS PRIVATE LIMITED",
"HEALTH AND CARE FOUNDATION",
"HEALTH AND FAMILY WELFARE DEPARTMENT",
"HEALTH AND FAMILY WELFARE DEPARTMENT CHHATTISGARH",
"HEALTH AND FAMILY WELFARE DEPTT",
"HEALTH AND FAMILY WELFARE TRAINING CENTRE",
"HEALTH AND HOPES MEDICAL ASISTANCE PRIVATE LIMITED",
"HEALTH AND HYGIENE PRODUCTSINDIALIMITED",
"HEALTH AND WELLNESS INDIA PRIVATE LIMITED",
"HEALTH ASYST PRIVATE LIMITED",
"HEALTH AURIC CARE PRIVATE LIMITED",
"HEALTH BERRY LIFESCIENCES PRIVATE LIMITED",
"HEALTH BIOTECH LIMITED",
"HEALTH BOOSTER FOODS PRIVATE LIMITED",
"HEALTH CARE (INDIA) LIMITED",
"HEALTH CARE AT HOME INDIA PRIVATE LIMITED",
"HEALTH CARE FORMULATIONS PRIVATE LIMITED",
"HEALTH CARE MEDICAL DEVICES PRIVATE LIMITED",
"HEALTH CARE PROCESS SOLUTIONS INDIA PRIVATE LIMITED",
"HEALTH CARE SERVICES INDIA PRIVATE LIMITED",
"HEALTH CARE SERVICES PRIVATE LIMITED",
"HEALTH CLICK LABORATORY",
"HEALTH DEPARTMENT",
"HEALTH DEPARTMENT DISTRICT AHMEDABAD",
"HEALTH DEPARTMENT GOVT OF BIHAR",
"HEALTH DEPARTMENT GOVT OF TAMILNADU",
"HEALTH DEPARTMENT GOVT. OF HARYANA",
"HEALTH DEPARTMENT PANCHAYAT SAMITI VASAI",
"HEALTH DEPARTMENT UP",
"HEALTH DEPARTMENT Z P SOLAPUR",
"HEALTH DEPARTMENT, PHC NANDGAON, PANCHAYAT SAMITI JAWHAR",
"HEALTH DEPT - A P",
"HEALTH EXPRESS DIAGNOSTICS PRIVATE LIMITED",
"HEALTH FOOD PRODUCT PRIVATE LIMITED",
"HEALTH FW DEPARTMENT",
"HEALTH GRAPH INDIA PRIVATE LIMITED",
"HEALTH GUARD INDIA PRIVATE LIMITED",
"HEALTH GUARD PACKAGING PRIVATE LIMITED",
"HEALTH IMPETUS PRIVATE LIMITED",
"HEALTH INNOVATION SOLUTIONS LLP",
"HEALTH INNOVATION SOLUTIONS PRIVATE LIMITED",
"HEALTH INSURANCE TPA OF INDIA LIMITED",
"HEALTH LINE PHARMACEUTICALS PRIVATE LIMITED",
"HEALTH MEDIVISION PRIVATE LIMITED",
"HEALTH METER SERVICES PRIVATE LIMITED",
"HEALTH N AGE PRIVATE LIMITED",
"HEALTH N U THERAPEUTICS PRIVATE LIMITED",
"HEALTH OFFICER DISTRICT INTEGRATED HEALTH AND FAMILY WELFARE SOCIETY SANGLI",
"HEALTH PLUS DIAGNOSTIC PRIVATE LIMITED",
"HEALTH PLUS MULTISPECIALITY HOSPITAL & RESEARCH CENTRE",
"HEALTH PORIUM HEALTH CARE OPC PRIVATE LIMITED",
"HEALTH PRIME SERVICES INDIA PRIVATE LIMITED",
"HEALTH PUBLIC HEALTH AND FAMILY WELFARE DEPARTMENT",
"HEALTH RESTORATION AND CLEFT CARE PRIVATE LIMITED",
"HEALTH SCOPE REMEDIES PRIVATE LIMITED",
"HEALTH SECURE HOSPITAL CARE & SOLUTIONS PRIVATE LIMITED",
"HEALTH SENSEI INDIA PRIVATE LIMITED",
"HEALTH SERVICES",
"HEALTH SUPERHIWAY PRIVATE LIMITED",
"HEALTH TECH CHHATTISGARH PRIVATE LIMITED",
"HEALTH TECHSMART SOLUTIONS PRIVATE LIMITED",
"HEALTH VISTA INDIA PRIVATE LIMITED",
"HEALTH VITALS PRIVATE LIMITED",
"HEALTH WATCH TELE DIAGNOSTICS PRIVATE LIMITED",
"HEALTH WEALTH MANAGEMENT PRIVATE LIMITED",
"HEALTH WELL DIAGNOSTICS PRIVATE LIMITED",
"HEALTH WHEELS PRIVATE LIMITED",
"HEALTHATM INDIA PRIVATE LIMITED",
"HEALTHBIOTICS PRIVATE LIMITED",
"HEALTHBURG MULTISPECIALITY HOSPITALS PRIVATE LIMITED",
"HEALTHCARE ASSOCIATES PRIVATE LIMITED",
"HEALTHCARE DAIRY PRODUCTS PRIVATE LIMITED",
"HEALTHCARE ENERGY FOODS PRIVATE LIMITED",
"HEALTHCARE GLOBAL ENTERPRISES LIMITED",
"HEALTHCARE INFORMATICS PRIVATE LIMITED",
"HEALTHCARE MEDI-SURGE HOSPITALS PRIVATE LIMITED",
"HEALTHCARENLP SOFTECH LLP",
"HEALTHCELL SERVICES PRIVATE LIMITED",
"HEALTHCLOUDAILABS PRIVATE LIMITED",
"HEALTHCUBED INDIA PRIVATE LIMITED",
"HEALTHDEKHO HEALTHCARE PRIVATE LIMITED",
"HEALTHEDGE SOFTWARE PRIVATE LIMITED",
"HEALTHEDGE TECHNOLOGIES INDIA PRIVATE LIMITED",
"HEALTHFAB PRIVATE LIMITED",
"HEALTHFACE PRIVATE LIMITED",
"HEALTHFIRST TECHNOLOGIES PRIVATE LIMITED",
"HEALTHFORE TECHNOLOGIES LIMITED",
"HEALTHGENIC CHEMICALS PRIVATE LIMITED",
"HEALTHGENIE INDIA PRIVATE LIMITED",
"HEALTHICO QUALITY PRODUCTS PRIVATE LIMITED",
"HEALTHINDIA INSURANCE TPA SERVICES PRIVATE LIMITED",
"HEALTHIPASS PRIVATE LIMITED",
"HEALTHIUM MEDTECH LIMITED",
"HEALTHIUM MEDTECH PRIVATE LIMITED",
"HEALTHKEY LIFE SCIENCE PRIVATE LIMITED",
"HEALTHKIND LABS PRIVATE LIMITED",
"HEALTHKIT WELLNESS PRIVATE LIMITED",
"HEALTHLANE TECHNOLOGIES PRIVATE LIMITED",
"HEALTHLICIOUS BASIL FOODTECH PRIVATE LIMITED",
"HEALTHMAP DIAGNOSTICS PRIVATE LIMITED",
"HEALTHMUG PRIVATE LIMITED",
"HEALTHNET GLOBAL LIMITED",
"HEALTHNEXT IMPEX PRIVATE LIMITED",
"HEALTHNODE BIOSCIENCE PRIVATE LIMITED",
"HEALTHON LIFE SCIENCES PRIVATE LIMITED",
"HEALTHQUAD CAPITAL ADVISORS PRIVATE LIMITED",
"HEALTHSCAPE TECHNOLOGY LLP",
"HEALTHSETGO SERVICES PRIVATE LIMITED",
"HEALTHSIGNZ TECHNOLOGIES PRIVATE LIMITED",
"HEALTHTAP SOFTWARE PRIVATE LIMITED",
"HEALTHTECH ENGINEERS PRIVATE LIMITED",
"HEALTHTRACK INFO SOLUTIONS PRIVATE LIMITED",
"HEALTHUNBOX PRIVATE LIMITED",
"HEALTHVISER PRIVATE LIMITED",
"HEALTHVISTA INDIA LIMITED",
"HEALTHVISTA INDIA PRIVATE LIMITED",
"HEALTHWARE PRIVATE LIMITED",
"HEALTHWAY HOSPITALS PRIVATE LIMITED",
"HEALTHWAY INDIA PRIVATE LIMITED",
"HEALTHWAYS MILK PRODUCT PRIVATE LIMITED",
"HEALTHY COUNTY RESORTS PRIVATE LIMITED",
"HEALTHY HARVESTED FOODS PRIVATE LIMITED",
"HEALTHY LIFE AGRITEC LIMITED",
"HEALTHY LIFE FOODTECH PRIVATE LIMITED",
"HEALTHY LIFE PHARMA PRIVATE LIMITED",
"HEALTHY MERCHANTS PRIVATE LIMITED",
"HEALTHY PLANET LIFE SCIENCES PRIVATE LIMITED",
"HEALTHY REFINERIES PRIVATE LIMITED",
"HEALTHY SAGA PRIVATE LIMITED",
"HEALTHY SNACKS PRIVATE LIMITED",
"HEALTHYCHOICE AGRO (INDIA) LIMITED",
"HEALTHYWAYS PHARMACEUTICALS PRIVATE LIMITED",
"HEALUX INTERNATIONAL PRIVATE LIMITED",
"HEALVIBE HEALTHCARE PRIVATE LIMITED",
"HEALWARE SOLUTIONS PRIVATE LIMITED",
"HEALWELL INTERNATIONAL LIMITED",
"HEALWISE THERAPEUTICS PRIVATE LIMITED",
"HEAPRO INDIA SAFETY PRODUCTS PRIVATE LIMITED",
"HEAPTRACE TECHNOLOGY PRIVATE LIMITED",
"HEARFON SYSTEMS PRIVATE LIMITED",
"HEARING SOLUTIONS PRIVATE LIMITED",
"HEARING SOLUTIONS TECHNOLOGIES PRIVATE LIMITED",
"HEARMO TECH PRIVATE LIMITED",
"HEART CARE LIFESCIENCE PRIVATE LIMITED",
"HEART DISEASE RESEARCH ORGANIZATION PRIVATE LIMITED",
"HEART HOSPITAL PRIVATE LIMITED",
"HEARTBRO HYGIENE PRIVATE LIMITED",
"HEARTCARE ASSOCIATES PRIVATE LIMITED",
"HEARTFULNESS INSTITUTE",
"HEARTKIND PHARMACEUTICALS PRIVATE LIMITED",
"HEARTLINE HEALTHCARE SERVICES PRIVATE LIMITED",
"HEARTLINK MEDICAL SOLUTIONS PRIVATE LIMITED",
"HEARTS MALABAR CLINICAL SOLUTIONS PRIVATE LIMITED",
"HEARTSANJIVANI MULTIMEDICAL RESEARCH INSTITUTE PRIVATE LIMITED",
"HEARTSRING MEDIPHARMA PRIVATE LIMITED",
"HEARTWARES MEDICALS INDIA PRIVATE LIMITED",
"HEARTY MART ENTERPRISE PRIVATE LIMITED",
"HEARTYMART MARKETING & LOGISTICS PRIVATE LIMITED",
"HEARTYMART PACKAGING PRIVATE LIMITED",
"HEAT & LIGHT RENEWABLE ENERGY PRIVATE LIMITED",
"HEAT AND CONTROL SOUTH ASIA PRIVATE LIMITED",
"HEAT APPLICATIONS INDIA PRIVATE LIMITED",
"HEAT CRAFT ENGINEERS PRIVATE LIMITED",
"HEAT MAX PROJECTS PRIVATE LIMITED",
"HEAT NUTRACEUTICALS PRIVATE LIMITED",
"HEAT SOLUTIONS PRIVATE LIMITED",
"HEAT TECHNOLOGIES PRIVATE LIMITED",
"HEAT THERM PRIVATE LIMITED",
"HEAT TRACE INDIA PRIVATE LIMITED",
"HEAT TRAVELS & TOURS (INDIA) PRIVATE LIMITED",
"HEATCHEM ENGINEERS PRIVATE LIMITED",
"HEATCON SENSORS PRIVATE LIMITED",
"HEATEX INDUSTRIES LIMITED",
"HEATEX TOOLS PRIVATE LIMITED",
"HEATFLEX CABLES PRIVATE LIMITED",
"HEATH VIEW HOLIDAY RESORTS LTD",
"HEATHER CONSTRUCTIONS",
"HEATHER INFRASTRUCTURE PRIVATE LIMITED",
"HEATHERGREY COLLECTIVE LLP",
"HEATMAN PRODUCTS PRIVATE LIMITED",
"HEATO CYCLES PRIVATE LIMITED",
"HEATON ENGINEERING PRIVATE LIMITED",
"HEATRANZ SOLUTIONS PRIVATE LIMITED",
"HEATRAY SOLAR PRIVATE LIMITED",
"HEATWORKS PRIVATE LIMITED",
"HEAVEN AHEAD VOYAGE PRIVATE LIMITED",
"HEAVEN BLANC ENERGY PRIVATE LIMITED",
"HEAVEN CITY DEVELOPERS LIMITED",
"HEAVEN CONSTRUCTION AND ENGINEERING PRIVATE LIMITED",
"HEAVEN DIAMONDS PVT LTD",
"HEAVEN EXPORTS PRIVATE LIMITED",
"HEAVEN FOREX PRIVATE LIMITED",
"HEAVEN HOLIDAYS AND RESORT PRIVATE LIMITED",
"HEAVEN PROPERTIES DEVELOPERS PRIVATE LIMITED",
"HEAVEN REAL ESTATE AND DEVELOPERS PRIVATE LIMITED",
"HEAVEN SOLAR ENERGY PRIVATE LIMITED",
"HEAVEN STRUCTURES PRIVATE LIMITED",
"HEAVEN TECHNO SYSTEM PRIVATE LIMITED",
"HEAVENLY ADVISORS PRIVATE LIMITED",
"HEAVENLY FOODS PRIVATE LIMITED",
"HEAVENLY HOSPITALITY PRIVATE LIMITED",
"HEAVENS INDIA PRIVATE LIMITED",
"HEAVEN'S VIEW SCHOOL",
"HEAVENSKY INFRATECH PRIVATE LIMITED",
"HEAVY ENGINEERING CORPORATION PRIVATE LIMITED",
"HEAVY HONED PIPES PRIVATE LIMITED",
"HEAVY LIFTERS OF INDIA PVT LTD",
"HEAVY METAL AND TUBES INDIA PRIVATE LIMITED",
"HEAVY TRANSLINES PRIVATE LIMITED",
"HEAVY VEHICLES FACTORY",
"HEAVY ZINOY INDIA PRIVATE LIMITED",
"HEBAN CHEMICALS PRIVATE LIMITED",
"HEBBAL PROJECT PRIVATE LIMITED",
"HEBBALE LABS PRIVATE LIMITED",
"HEBBAR CHEMICALS PRIVATE LIMITED",
"HEBE HEALTHCARE PRIVATE LIMITED",
"HEBEN CHARTERED RESOURCES PRIVATE LIMITED",
"HEBERT BIOTECH PRIVATE LIMITED",
"HEBRON PROPERTIES PRIVATE LIMITED",
"HEC HOSPITALITY PRIVATE LIMITED",
"HEC INDIA LLP",
"HEC INFRA PROJECTS PRIVATE LIMITED",
"HECATE WAREHOUSING PRIVATE LIMITED",
"HECKYL TECHNOLOGIES",
"HECL TECHNOLOGY PRIVATE LIMITED",
"HECO PANELLING SYSTEMS PRIVATE LIMITED",
"HECTAFINE ALUSYSTEMS INDIA LIMITED",
"HECTOR AND STREAK CONSULTING PRIVATE LIMITED",
"HECTOR ENTERPRISES PRIVATE LIMITED",
"HECTOR FASHIONS PVT LTD",
"HECTOR MANAGEMENT PRIVATE LIMITED",
"HECTOR PHARMACEUTICALS PRIVATE LIMITED",
"HECTRONIC INDIA RETAIL & PARKING AUTOMATION PRIVATE LIMITED",
"HED EXPERTS PRIVATE LIMITED",
"HEDA CHEMICALS PRIVATE LIMITED",
"HEDA INDUSTRIES PRIVATE LIMITED",
"HEDGE COMMODITIES LIMITED",
"HEDGE EQUITIES LIMITED",
"HEDGE FINANCE LIMITED",
"HEDGE MONEY PRIVATE LIMITED",
"HEDGEHOG LAB SOFTWARE PRIVATE LIMITED",
"HEDGEROW TECHNOLOGIES PRIVATE LIMITED",
"HEDONE DESIGNS LIMITED",
"HEEBEE COFFEE PRIVATE LIMITED",
"HEED LOGISTICS INDIA PRIVATE LIMITED",
"HEEHOON DESIGN GLOBE PRIVATE LIMITED",
"HEEL & BUCKLE LUXURY PRIVATE LIMITED",
"HEELCERA TILES PRIVATE LIMITED",
"HEELIUM SPORTS PRIVATE LIMITED",
"HEEMANKSHI BAKERS PRIVATE LIMITED",
"HEEMSOL ENERGY SYSTEM PRIVATE LIMITED",
"HEEMY DIGITAL PRINTING PRIVATE LIMITED",
"HEENA CARGO MOVERS PRIVATE LIMITED",
"HEENA ELECTRONICS PRIVATE LIMITED",
"HEENA ENGINEERING CO PRIVATE LIMITED",
"HEENA ENGINEERING CO. LIMITED",
"HEENA FOOD PRODUCTS PRIVATE LIMITED",
"HEENA HOLIDAYS PRIVATE LIMITED",
"HEENA MARKETING LIMITED",
"HEENA METAL PRIVATE LIMITED",
"HEENA PACK PET PRIVATE LIMITED",
"HEENA ROLLER FLOUR MILLS PRIVATE LIMITED",
"HEENA WATCH HOUSE",
"HEENA WIRE PRIVATE LIMITED",
"HEENAL OPERATING LEASE CO. PRIVATE LIMITED",
"HEENJIG EXPORTS PRIVATE LIMITED",
"HEER BUSINESS PROCESS MANAGEMENT PRIVATE LIMITED",
"HEER PHARMA PRIVATE LIMITED",
"HEERA AGRI FEEDS PRIVATE LIMITED",
"HEERA JEWELLERS GADARWARA PRIVATE LIMITED",
"HEERA JEWELS AND GEMS PRIVATE LIMITED",
"HEERA METALS PRIVATE LIMITED",
"HEERA MOTI STONE PRIVATE LIMITED",
"HEERA MOTI TEXTILES INDIA PRIVATE LIMITED",
"HEERA NUTRITECH PRIVATE LIMITED",
"HEERA PANNA COMMUNICATIONS PRIVATE LIMITED",
"HEERA SOFTWARE PRIVATE LIMITED",
"HEERA TRAVELS PRIVATE LIMITED",
"HEERACHAND GEMS PRIVATE LIMITED",
"HEERA-IND TRADING PRIVATE LIMITED",
"HEERALAL FOODS PRIVATE LIMITED",
"HEERALAL HOSPITAL PRIVATE LIMITED",
"HEERAWALA GOLD HUB PRIVATE LIMITED",
"HEERU CORROSION PROTECTION SERVICES PRIVATE LIMITED",
"HEET HEALTHCARE PRIVATE LIMITED",
"HEET STEEL INDIA PRIVATE LIMITED",
"HEETAL AEROSPACE TECHNOLOGIES PRIVATE LIMITED",
"HEETU CHEMICALS AND ALKALIES LIMITED",
"HEF- DURFERRIT INDIA PRIVATE LIMITED.",
"HEFT ENGINEERS PRIVATE LIMITED",
"HEG LIMITED",
"HEGDE & HEGDE PHARMACEUTICA LLP",
"HEGDE DYNAMICS PRIVATE LIMITED",
"HEGDE HEALTHCARE PRIVATE LIMITED",
"HEGDE HOTELS (INDIA) PVT LTD",
"HEGDE HOTELS AND RESORTS PRIVATE LIMITED",
"HEGDE PRECISION PRODUCTS PRIVATE LIMITED",
"HEGENSCHEIDT MFD INDIA PRIVATE LIMITED",
"HEI FILTER AIDS PRIVATE LIMITED",
"HEI POWER SYSTEM PRIVATE LIMITED",
"HEIDELBERG INDIA PRIVATE LIMITED",
"HEIDELBERG PROMINENT FLUID CONTROLS INDIA PRIVATE LIMITED",
"HEIDELBERGCEMENT INDIA LIMITED",
"HEIDELCO MEDICORE PRIVATE LIMITED",
"HEIDELSOFT TECHNOLOGIES PRIVATE LIMITED",
"HEIDRICK AND STRUGGLES INDIA PRIVATE LIMITED",
"HEIGHT 8 TECHNOLOGIES PRIVATE LIMITED",
"HEIGHT BUILDCON PRIVATE LIMITED",
"HEIGHT PAPER WINGS PRIVATE LIMITED",
"HEIGHTS COMMUNICATIONS [INDIA] PVT LTD",
"HEILGERS DEVELOPMENT & CONSTRUCTION CO. PVT. LTD.",
"HEILGERS PRIVATE LIMITED",
"HEILIGEN WORLDWIDE SERVICES PRIVATE LIMITED",
"HEILSA LIFE SCIENCES PRIVATE LIMITED",
"HEILWIG HEALTHCARE PRIVATE LIMITED",
"HEIMA GLOBAL LOGISTICS PRIVATE LIMITED",
"HEIMATEC INDIA PRIVATE LIMITED",
"HEIMDAL MINERALS PRIVATE LIMITED",
"HEIMRICH INFRASTRUCTURE AND INDUSTRIES PRIVATE LIMITED",
"HEIMTEX RETAIL PRIVATE LIMITED",
"HEIN LEHMANN INDIA PRIVATE LIMITED",
"HEIN+FRICKE INDIA TECHNOLOGY SERVICES PRIVATE LIMITED",
"HEINEN & HOPMAN ENGINEERING INDIA PRIVATE LIMITED",
"HEINGRID PHARMA PRIVATE LIMITED",
"HEINKEL ENGINEERING PRIVATE LIMITED",
"HEINRICH CORPORATION INDIA PRIVATE LIMITED",
"HEINZ INDIA PRIVATE LIMITED",
"HEINZ INDIA PRIVATE. LIMITED",
"HEINZMANN HYDROTECH PRIVATE LIMITED",
"HEIPLOEG SEAFOOD INDIA PRIVATE LIMITED",
"HEIRLOOM COLLECTIONS PRIVATE LIMITED",
"HEIRLOOM FINANCE PRIVATE LIMITED",
"HEIRLOOM REAL ESTATE PRIVATE LIMITED",
"HEJAZI FOODSTUFF PRIVATE LIMITED",
"HEKA SUPPORT SERVICES PRIVATE LIMITED",
"HELA SOFTWARE SOLUTIONS PRIVATE LIMITED",
"HELA SYSTEMS PRIVATE LIMITED",
"HELAR MARKETING AND CONSULTANTS PRIVATE LIMITED",
"HELAX HEALTHCARE PRIVATE LIMITED",
"HELENA EDTECH PRIVATE LIMITED",
"HELI ELECTRO SOLUTIONS PRIVATE LIMITED",
"HELIANTHUS SERVICE INDIA PRIVATE LIMITED",
"HELICAL AUTO TECHNOLOGY INDIA PUT LIMITED",
"HELICAL IT SOLUTIONS PRIVATE LIMITED",
"HELICON CONSTRUCTIONS PRIVATE LIMITED",
"HELICON FOODS PRIVATE LIMITED",
"HELICON IMPEX PRIVATE LIMITED",
"HELICON TRADING HOUSE PRIVATE LIMITED",
"HELIFLEX ENGINEERING AND SERVICES PRIVATE LIMITED",
"HELIGO CHARTERS PRIVATE LIMITED",
"HELIO AUTOMOTIVES PRIVATE LIMITED",
"HELIO ENGINEERING PRIVATE LIMITED",
"HELIOCENTRIX TECHNOLOGY PRIVATE LIMITED",
"HELIOCON AGROCHEMICALS LIMITED",
"HELIOFIX ENERGY PRIVATE LIMITED",
"HELION ADVISORS PRIVATE LIMITED",
"HELIOS ADVISORY PRIVATE LIMITED",
"HELIOS CONCREW PRIVATE LIMITED",
"HELIOS ESTATE PRIVATE LIMITED",
"HELIOS HOSPITALS",
"HELIOS HOSPITALS PRIVATE LIMITED",
"HELIOS HOTELWARES PRIVATE LIMITED",
"HELIOS INFRA VENTURES PRIVATE LIMITED",
"HELIOS INFRAPRO PRIVATE LIMITED",
"HELIOS INFRATECH PRIVATE LIMITED",
"HELIOS IOT SYSTEMS PRIVATE LIMITED",
"HELIOS LED LIGHTRONICS PRIVATE LIMITED",
"HELIOS LIFESTYLE PRIVATE LIMITED",
"HELIOS MEDIA PRIVATE LIMITED",
"HELIOS MERCANTILE LIMITED",
"HELIOS PACKAGING PRIVATE LIMITED",
"HELIOS PHARMACEUTICALS PRIVATE LIMITED",
"HELIOS PRECISION CONTROLS PRIVATE LIMITED",
"HELIOS QUAL-PRO OPC PRIVATE LIMITED",
"HELIOS SOLUTIONS",
"HELIOS STRATEGIC SYSTEMS LIMITED",
"HELIOS SYSCOM PRIVATE LIMITED",
"HELIOS TECHNOLOGIES PRIVATE LIMITED",
"HELIOSMEDIUM BAZAAR PRIVATE LIMITED",
"HELIOSNATURAL RENEWTECH PRIVATE LIMITED",
"HELIOUS CLEAN ENERGY PRIVATE LIMITED",
"HELIOUS SPECIALTY GASES PRIVATE LIMITED",
"HELIOZ GLOBAL SERVICES PRIVATE LIMITED",
"HELIUM CONSULTING PRIVATE LIMITED",
"HELIUM OVERSEAS PRIVATE LIMITED",
"HELIUM TRADERS PRIVATE LIMITED",
"HELIUMFOUR SOLAR PRIVATE LIMITED",
"HELIUS COMPUTECH INDIA PRIVATE LIMITED",
"HELIUS IMPEX (OPC) PRIVATE LIMITED",
"HELIWAL COLD STORAGE PVT LTD",
"HELIX BIOSCIENCES",
"HELIX CONSULTANTS PRIVATE LIMITED",
"HELIX DESIGN PRIVATE LIMITED",
"HELIX PURIFIERS PRIVATE LIMITED",
"HELIX SENSE TECHNOLOGIES PRIVATE LIMITED",
"HELIXAGON TECHNOLOGIES PRIVATE LIMITED",
"HELIXOTECH PRIVATE LIMITED",
"HELL ENERGY PRIVATE LIMITED",
"HELLA CHEMICAL MARKET PRIVATE LIMITED",
"HELLA INDIA AUTOMOTIVE PRIVATE LIMITED",
"HELLA INDIA LIGHTING LIMITED",
"HELLA INFRA MARKET PRIVATE LIMITED",
"HELLA INFRA MARKET RETAIL PRIVATE LIMITED",
"HELLA INFRATECH PRIVATE LIMITED",
"HELLER INDIA PRIVATE LIMITED",
"HELLERMANNTYTON PRIVATE LIMITED",
"HELLIOS SERVICES PRIVATE LIMITED",
"HELLMANN WORLDWIDE LOGISTICS INDIA PRIVATE LIMITED",
"HELLO AROMACHEM PRIVATE LIMITED",
"HELLO AROMATICS PRIVATE LIMITED",
"HELLO BABY FASHION PRIVATE LIMITED",
"HELLO BABY PRIVATE LIMITED",
"HELLO CURRY PRIVATE LIMITED",
"HELLO EXIM PRIVATE LIMITED",
"HELLO HEALTH SERVICES PRIVATE LIMITED",
"HELLO INDO FOOD PRODUCTS PRIVATE LIMITED",
"HELLO MOBILES PRIVATE LIMITED",
"HELLO MONEY INDIA PRIVATE LIMITED",
"HELLO POLYMER (INDIA) PRIVATE LIMITED",
"HELLO VERIFY INDIA PRIVATE LIMITED",
"HELLOHEALTH PHARMACY PRIVATE LIMITED",
"HELLOJI HOLIDAYS PRIVATE LIMITED",
"HELLOWORLD TECHNOLOGIES INDIA PRIVATE LIMITED",
"HELLY EXPORT IMPORT PRIVATE LIMITED",
"HELM ANALYTICS PRIVATE LIMITED",
"HELM EXPERIENTIAL PRIVATE LIMITED",
"HELM INDIA PRIVATE LIMITED",
"HELMA SOLUTIONS INDIA PRIVATE LIMITED",
"HELMAPPS SOLUTIONS PRIVATE LIMITED",
"HELMERICH AND PAYNE TECHNOLOGIES PRIVATE LIMITED",
"HELMET FASHION INDIA PRIVATE LIMITED",
"HELMS BIOTECHNOLOGY PRIVATE LIMITED",
"HELMSMAN (INDIA) QUALITY & TECHNOLOGY SERVICES PRIVATE LIMITED",
"HELP AGRA HOSPITAL",
"HELP BROS PRIVATE LIMITED",
"HELP FOR HELPLESS ONES FOUNDATION",
"HELP HOSPITALS PRIVATE LIMITED",
"HELP LINE INFRATECH PRIVATE LIMITED",
"HELP SERVICES PRIVATE LIMITED",
"HELPAGE FINLEASE LIMITED",
"HELPAGE INDIA",
"HELPAGE YOUTH FOUNDATION",
"HELPLAST BIOPLASTICS PRIVATE LIMITED",
"HELPLINE PHARMACY PRIVATE LIMITED",
"HELPLINE PUBLICATIONS PRIVATE LIMITED",
"HELPOST SOFTWARES PRIVATE LIMITED",
"HELPSHIFT TECHNOLOGIES PRIVATE LIMITED",
"HELSA - ICON INDIA PRIVATE LIMITED",
"HELUKABEL INDIA PRIVATE LIMITED",
"HELVETIC ENTERPRISE PRIVATE LIMITED",
"HELVETICA LIFESTYLE BOUTIQUE PRIVATE LIMITED",
"HELVOET RUBBER & PLASTIC TECHNOLOGIES INDIA PRIVATE LIMITED",
"HELYXON HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"HELZON PHARMACEUTICALS PVT LTD",
"HEM AUTOWINGS PRIVATE LIMITED",
"HEM CORPORATION PRIVATE LIMITED",
"HEM CREATIONS PRIVATE LIMITED",
"HEM DEBT CONSULTANTS PRIVATE LIMITED",
"HEM DEEP ASSOCIATES PRIVATE LIMITED",
"HEM FINANCIAL SERVICES PRIVATE LIMITED",
"HEM FINLEASE PRIVATE LIMITED",
"HEM FINLEASE PVT LTD",
"HEM FOOD PRIVATE LIMITED",
"HEM KANT ENTERPRISES PRIVATE LIMITED",
"HEM KNITWEARS PRIVATE LIMITED",
"HEM MOTOR DIVISION PRIVATE LIMITED",
"HEM PAINTS PRIVATE LIMITED",
"HEM RAJ BODH RAJ YARNS PRIVATE LIMITED",
"HEM RAJ SOHAN LAL",
"HEM SECURITIES LIMITED",
"HEM SHEELA MODEL SCHOOL",
"HEM UTILITIES PRIVATE LIMITED",
"HEMA ABODES PRIVATE LIMITED",
"HEMA CONNOISSEUR COLLECTIONS PRIVATE LIMITED",
"HEMA DRIVELINE AND HYDRAULICS PRIVATE LIMITED",
"HEMA DYECHEM PRIVATE LIMITED",
"HEMA DYEING AND PRINTING MILLS PRIVATE LIMITED",
"HEMA LABORATORIES PRIVATE LIMITED",
"HEMA MOTORS PRIVATE LIMITED",
"HEMA PAPER MACHINERY INDIA PRIVATE LIMITED",
"HEMA PHARMACEUTICALS PRIVATE LIMITED",
"HEMA SURGICALS PRIVATE LIMITED",
"HEMAADRI ELEX SYSTEMS PRIVATE LIMITED",
"HEMABH SOLUTIONS PRIVATE LIMITED",
"HEMADE HOSPITALITY PRIVATE LIMITED",
"HEMADRI CEMENTS LTD",
"HEMADRI COLD STORAGE PRIVATE LIMITED",
"HEMADRI HEALTH CARE PRIVATE LIMITED",
"HEMAIR SYSTEMS INDIA LIMITED",
"HEMAKI LAB-SERVICES PVT LTD",
"HEMAL EXIM PVT LTD",
"HEMALATA PUBLIC SCHOOL",
"HEMALI INVESTMENTS AND FINANCE PRIVATE LIMITED",
"HE-MAN AUTO ROBOPARK PRIVATE LIMITED",
"HEMANG DESIGN STUDIO PRIVATE LIMITED",
"HEMANG RESOURCES LIMITED",
"HEMANI CHEMICALS PRIVATE LIMITED",
"HEMANI CHEMIORGANIC PRIVATE LIMITED",
"HEMANI CROP CARE PRIVATE LIMITED",
"HEMANI INDUSTRIES LIMITED",
"HEMANI INTERMEDIATES PRIVATE LIMITED",
"HEMANI INTERNATIONAL PRIVATE LIMITED",
"HEMANJALI POLYMERS PRIVATE LIMITED",
"HEMANK SOAP AND CHEMICALS PRIVATE LIMITED",
"HEMANT & COMPANY ELECTRICAL CONTRACTORS AND ENGINEERS PRIVATE LIMITED",
"HEMANT AQUA SOLUTIONS PRIVATE LIMITED",
"HEMANT C PATEL",
"HEMANT FABRICS PRIVATE LIMITED",
"HEMANT FORGING PRIVATE LIMITED",
"HEMANT GOLD PALACE PRIVATE LIMITED",
"HEMANT INDUSTRIES",
"HEMANT ROADWAYS INDIA PRIVATE LIMITED",
"HEMANT SAHAI ASSOCIATES",
"HEMANT SHAH AND ASSOCIATES LLP",
"HEMANT SURGICAL INDUSTRIES LIMITED",
"HEMANT TOOLS PRIVATE LIMITED",
"HEMANT TRADING COMPANY PRIVATE LIMITED",
"HEMANT UJJWAL INFRA VISIONS & CONSTRUCTIONS PRIVATE LIMITED",
"HEMANTH COTTONS PRIVATE LIMITED",
"HEMANTH HOMES PRIVATE LIMITED",
"HEMANTH POULTRY FARMS PRIVATE LIMITED",
"HEMARUS THERAPEUTICS LIMITED",
"HEMA'S ENTERPRISES PRIVATE LIMITED",
"HEMASRI CONSTRUCTION PRIVATE LIMITED",
"HEMATITE INFOTECH PRIVATE LIMITED",
"HEMATO-ONCOLOGY CLINIC (AHMEDABAD) PRIVATE LIMITED",
"HEMATO-ONCOLOGY CLINIC AHMEDABAD PRIVATE LIMITED",
"HEMAVATHY POWER AND LIGHT PRIVATE LIMITED",
"HEMAVATHY SPUN CONCRETE PIPES PRIVATE LIMITED",
"HEMAVATI TRADERS PRIVATE LIMITED",
"HEMAVI MOTORS PRIVATE LIMITED",
"HEMAWAT PETROCOAL PRIVATE LIMITED",
"HEMAY INFRASTRUCTURE PRIVATE LIMITED",
"HEMCHAND YADAV UNIVERSITY",
"HEMCHANDA ENTERPRISES PRIVATE LIMITED",
"HEMCHANDRACHARYA NORTH GUJARAT UNIVERSITY",
"HEMCO CHEMIPOL PRIVATE LIMITED",
"HEMCO GARMENT PRIVATE LIMITED.",
"HEMCO GLOBAL PRIVATE LIMITED",
"HEM-DEEP ORGANICS PRIVATE LIMITED",
"HEMEE INTERNATIONAL PRIVATE LIMITED",
"HEMEN LIFE SCIENCES PRIVATE LIMITED",
"HEMENDRA SMRITI HEALTH CARE PRIVATE LIMITED",
"HEMETA ROLLING PRIVATE LIMITED",
"HEMETEK TECHNO INSTRUMENTS PRIVATE LIMITED",
"HEMEXDX PRIVATE LIMITED",
"HEMIS LUXURY JEWELS PRIVATE LIMITED",
"HEMISPHERE PROPERTIES INDIA LIMITED",
"HEMKUND ENERGY PRIVATE LIMITED",
"HEMKUNT AGRO CARE PRIVATE LIMITED",
"HEMKUNT IRON AND STEEL PVT LTD",
"HEMKUNT SECURITY SERVICES PRIVATE LIMITED",
"HEMKUNT SERVICE STATION PRIVATE LIMITED",
"HEMKUNT SPECIALITY CONES PRIVATE LIMITED",
"HEMLA EMBROIDERY MILLS PRIVATE LIMITED",
"HEMLATA TRADERS PRIVATE LIMITED",
"HEMLINES TEXPORT PRIVATE LIMITED",
"HEMLINES TEXTILE EXPORTS PRIVATE LIMITED",
"HEMLON SYNTHETICS PVT LTD",
"HEMMERSBACH INDIA PRIVATE LIMITED",
"HEMMINGER DATA MANAGEMENT SERVICES PRIVATE LIMITED",
"HEMMO PHARMACEUTICALS PRIVATE LIMITED",
"HEMNAV TECHNIQUES PRIVATE LIMITED",
"HEMNAV VENTURES PRIVATE LIMITED",
"HEMNIL METAL PROCESSORS PRIVATE LIMITED",
"HEMODIAZ LIFE SCIENCES PRIVATE LIMITED",
"HEMOGENOMICS PRIVATE LIMITED",
"HEMPEL PAINTS (INDIA) PRIVATE LIMITED",
"HEMPRA MULTIPRINTS PRIVATE LIMITED",
"HEMPRABHA TEA & ALLIEDS PRIVATE LIMITED",
"HEMPRONICS SYSTEMS PRIVATE LIMITED",
"HEMPSHIER STEEL PRIVATE LIMITED",
"HEMRAJ DEVKARANDAS METALS AND MINERALS PRIVATE LIMITED",
"HEMRAJ INDUSTRIES PRIVATE. LIMITED.",
"HEMRAJ INTERNATIONAL PRIVATE LIMITED",
"HEMRAJ PETROCHEM PRIVATE LIMITED",
"HEMRAJ RICE PRODUCTS PRIVATE LIMITED",
"HEMRATNA FASHION PRIVATE LIMITED",
"HEMSAGAR DEALERS PVT LTD",
"HEMSEN RUBBER PRIVATE LIMITED",
"HEMSON PRIVATE LIMITED",
"HEMSONS ENGINEERS",
"HEMSWORTH CONSULTING PRIVATE LIMITED",
"HEMTRIX AGRITECH PRIVATE LIMITED",
"HEMVIJAY HOLDINGS PRIVATE LIMITED",
"HEMVIR CONSTRUCTION LLP",
"HENA PROPERTIES PRIVATE LIMITED",
"HENCON SERVICES INDIA PRIVATE LIMITED",
"HENDRIK TECHNOLOGY PRIVATE LIMITED",
"H-ENERGY EAST COAST PRIVATE LIMITED",
"HENG XING MOULD PRIVATE LIMITED",
"HENGLI HYDRAULIC INDIA SYSTEM SOLUTIONS PRIVATE LIMITED",
"HENGST-LUMAN INDIA PRIVATE LIMITED",
"HENGXIN TECHNOLOGY (INDIA) PRIVATE LIMITED",
"HENGYU CLEANING PRODUCTS PRIVATE LIMITED",
"HENI DRUGS PVT LTD",
"HENKEL ADHESIVES TECHNOLOGIES INDIA PRIVATE LIMITED",
"HENKEL ANAND INDIA PRIVATE LIMITED",
"HENKELL & COMPANY IND PRIVATE LIMITED",
"HENKO COMMODITIES PVT.LTD.",
"HENKO LOGISTICS INDIA PRIVATE LIMITED",
"HENKRAFT INDIA PRIVATE LIMITED",
"HENLEY INDUSTRIES INDIA LIMITED",
"HENNA EXPORT CORPORATION NAGPUR",
"HENNA INDUSTRIES PVT. LTD.",
"HENNELL DIVINE COLLECTIONS PRIVATE LIMITED",
"HENNELL FINE COLLECTIONS PRIVATE LIMITED",
"HENRAAJH FEEDS INDIA PRIVATE LIMITED",
"HENRY AND FARAD PRIVATE LIMITED",
"HENRY HARVIN PRIVATE LIMITED",
"HENRY MARTYN INSTITUTE INTERNATIONAL CEN TRE FOR RESEARCH, INTERFAITH RELATIONS A ND RECONCILIATION",
"HENRY SCHEIN, INC.",
"HENSEL ELECTRIC INDIA PRIVATE LIMITED",
"HENSEL INDIA PRIVATE LIMITED",
"HENSEX SECURITIES PRIVATE LIMITED",
"HENSOLDT PRIVATE LIMITED",
"HENSON INFO SOLUTIONS PRIVATE LIMITED",
"HENTECH AGROVET PRIVATE LIMITED",
"HENX INTERNATIONAL TECHNOLOGIES PRIVATE LIMITED",
"HEPA PHARMA PRIVATE LIMITED",
"HEPATICA CROP CARE PRIVATE LIMITED",
"HEPATICA TECHNOLOGIES PRIVATE LIMITED",
"HEPHAESTUS REALITY AND LEASING PRIVATE LIMITED",
"HEPHZI ELEVATORS INTERNATIONAL CO. PRIVATE LIMITED",
"HEPO INDIA PRIVATE LIMITED",
"HEPTACARE POWER INDUSTRIES PRIVATE LIMITED",
"HEPTACHEM & PHARMA (INDIA) PRIVATE LIMITED",
"HEPTAGON TECHNOLOGIES PRIVATE LIMITED",
"HEPTALANDS PRIVATE LIMITED",
"HEPTARC TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"HEPTAVISION AUTOMATION INDIA PRIVATE LIMITED",
"HERA CHAND CHORDIA EYE HOSPITAL",
"HERA HOSPITALITY PRIVATE LIMITED",
"HERA IMPEX PRIVATE LIMITED",
"HERAA FOOD PRODUCTS PRIVATE LIMITED",
"HERACLES EQUIPMENTS LLP",
"HERACLES HEALTHCARE PRIVATE LIMITED",
"HERAEUS TECHNOLOGIES INDIA PRIVATE LIMITED",
"HERAIZEN TECHNOLOGIES PRIVATE LIMITED",
"HERAKLE ENTERPRISESS PRIVATE LIMITED",
"HERALD BEVERAGES PRIVATE LIMITED",
"HERALD ELECTRONICS PRIVATE LIMITED",
"HERALD FOOD & COMMODITIES PRIVATE LIMITED",
"HERALD GLOBAL VENTURES PRIVATE LIMITED",
"HERALD LOGIC PRIVATE LIMITED",
"HERALD MARINE PRODUCTS PRIVATE LIMITED",
"HERALD MARITIME SERVICES PRIVATE LIMITED",
"HERALD PUBLICATIONS PRIVATE LIMITED",
"HERALD SCHOLARLY PRIVATE LIMITED",
"HERALD TRAVELS PRIVATE LIMITED",
"HERALDS TRADING PRIVATE LIMITED",
"HERAMB PHARMACEUTICALS PRIVATE LIMITED",
"HERAMB THERMOPLASTICS PVT LTD",
"HERAMBA RENEWABLES LIMITED",
"HERANBA CROP CARE PRIVATE LIMITED",
"HERANBA INDUSTRIES LIMITED",
"HERB ARTIZAN PRIVATE LIMITED",
"HERB ELEMENTZ NATURECEUTICALS PRIVATE LIMITED",
"HERB TREE SERVICES PRIVATE LIMITED",
"HERBACEOUS RETAIL PRIVATE LIMITED",
"HERBAL COUNTY COTTAGES PRIVATE LIMITED",
"HERBAL DREAM AYURVEDA CREATIONS PRIVATE LIMITED",
"HERBAL GLOW DERMOTECH PRIVATE LIMITED",
"HERBAL HEALTH RESEARCH CONSORTIUM PRIVATE LIMITED",
"HERBAL ISOLATES PVT LTD",
"HERBAL SUPPLEMENTS PRIVATE LIMITED",
"HERBALCONCEPTS HEALTH CARE PRIVATE LIMITED.",
"HERBALIFE INERNATIONAL INDIA PRIVATE LIMITED",
"HERBALIFE INTERNATIONAL INDIA PRIVATE LIMITED",
"HERBALS APS PRIVATE LIMITED",
"HERBALYTE PRODUCTS PRIVATE LIMITED",
"HERBARIO COSMETICS (INDIA) PRIVATE LIMITED",
"HERBAYU WELLNESS INDIA PRIVATE LIMITED",
"HERBEDGE HEALTHCARE PRIVATE LIMITED",
"HERBERTPUR CHRISTIAN HOSPITAL",
"HERBERTSONS LIMITED",
"HERBEX EXPORTS PRIVATE LIMITED",
"HERBGENICS HEALTHCARE PRIVATE LIMITED",
"HERBLE PRINTS PRIVATE LIMITED",
"HERBOCARE NATURAL HOSPITAL AND RESEARCH INSTITUTE",
"HERBOCHEM INDUSTRIES PRIVATE LIMITED",
"HERBOLAB INDIA PRIVATE LIMITED",
"HERBS NUTRIPRODUCTS PRIVATE LIMITED",
"HERBY HOUSE PRIVATE LIMITED",
"HERCO TRANSFORMERS LIMITED",
"HERCULES AUTO SPARE PARTS PRIVATE LIMITED",
"HERCULES AUTOMOBILES INTERNATIONAL PRIVATE LIMITED",
"HERCULES AVIATION PRIVATE LIMITED",
"HERCULES AVIATION TRAINING SCHOOL PRIVATE LIMITED",
"HERCULES HEALTH CARES PRIVATE LIMITED",
"HERCULES HOIST LIMITED",
"HERCULES INFOTECH PRIVATE LIMITED",
"HERCULES INFRATECH PRIVATE LIMITED",
"HERCULES NUTRA PRIVATE LIMITED",
"HERCULES PIGMENTS PRIVATE LIMITED",
"HERCULES PLASTIC PRIVATE LIMITED",
"HERCULES SAFETY PRODUCTS PRIVATE LIMITED",
"HERCULES STRUCTURAL ENGINEERING PRIVATE LIMITED",
"HERCULES STRUCTURAL SYSTEMS PRIVATE LIMITED",
"HERCULES SUPER BAZAR PRIVATE LIMITED",
"HERD MEDICAL FOUNDATION PRIVATE LIMITED",
"HERE INDIA PRIVATE LIMITED",
"HERE SOLUTIONS INDIA PRIVATE LIMITED",
"HERITAGE AVIATION PRIVATE LIMITED",
"HERITAGE BEVERAGES PRIVATE LIMITED",
"HERITAGE BOARD LIMITED",
"HERITAGE BOUTIQUE LUXURY HOTELS PRIVATE LIMITED",
"HERITAGE COMPUTERS PRIVATE LIMITED",
"HERITAGE DISTILIARIES PRIVATE LIMITED",
"HERITAGE FINLEASE LIMITED",
"HERITAGE FOODS LIMITED",
"HERITAGE GRANITES PRIVATE LIMITED",
"HERITAGE HEALTH INSURANCE TPA PRIVATE LIMITED",
"HERITAGE HEALTHCARE HOSPITAL",
"HERITAGE HOMES INFRA PRIVATE LIMITED",
"HERITAGE INDIA EXPORTS PRIVATE LIMITED",
"HERITAGE INFRASPACE (INDIA) LIMITED",
"HERITAGE INFRASPACE INDIA PRIVATE LIMITED",
"HERITAGE INSTITUTE OF MEDICAL SCIENCE PRIVATE LIMITED",
"HERITAGE INSTITUTE OF MEDICAL SCIENCES",
"HERITAGE INSTITUTE OF TECHNOLOGY",
"HERITAGE INSURANCE BROKERS PRIVATE LIMITED",
"HERITAGE INTERNATIONAL JUNIOR COLLEGE",
"HERITAGE KHIRASARA PALACE PRIVATE LIMITED",
"HERITAGE LANDMARKS AUTOWORLD PRIVATE LIMITED",
"HERITAGE LIFESTYLES & DEVELOPERS PRIVATE LIMITED",
"HERITAGE MALABAR AYURVEDIC PHARMACY PRIVATE LIMITED",
"HERITAGE MARBLE PRIVATE LIMITED",
"HERITAGE MEX REALTECH PRIVATE LIMITED",
"HERITAGE MOTELS PRIVATE LIMITED",
"HERITAGE MOTORS MUMBAI PRIVATE LIMITED",
"HERITAGE NAMKEENS PRIVATE LIMITED",
"HERITAGE NORTH EAST PRIVATE LIMITED",
"HERITAGE NOVANDIE FOODS PRIVATE LIMITED",
"HERITAGE NUTRIVET LIMITED",
"HERITAGE ORGANICS PRIVATE LIMITED",
"HERITAGE PASSAGES PRIVATE LIMITED",
"HERITAGE PRIME FURNITURE PRIVATE LIMITED",
"HERITAGE PRINT SERVICES PRIVATE LIMITED",
"HERITAGE PROCESSORS PRIVATE LIMITED",
"HERITAGE PROMOTORS PRIVATE LIMITED",
"HERITAGE PUBLIC SCHOOL",
"HERITAGE REALTY PRIVATE LIMITED.",
"HERITAGE RESORTS PRIVATE LIMITED",
"HERITAGE RIVER JOURNEYS PRIVATE LIMITED",
"HERITAGE SEEDS PRIVATE LIMITED",
"HERITAGE VEHICLES PRIVATE LIMITED",
"HERITAGE WHEELS PRIVATE LIMITED",
"HERITAGE XPERIENTIAL LEARNING SCHOOL",
"HERITAL MARBLES PRIVATE LIMITED",
"HERJAVEC GROUP INDIA PRIVATE LIMITED",
"HERJEET MACHINES PRIVATE LIMITED",
"HERMAN INFRATECH PRIVATE LIMITED",
"HERMAN MILLER FURNITURE (INDIA) PRIVATE LIMITED",
"HERMAN PROPERTIES PRIVATE LIMITED",
"HERMANN AIR & SEAS PRIVATE LIMITED",
"HERMANOS INDUSTRIES PRIVATE LIMITED",
"HERMAS BIOTECH PRIVATE LIMITED",
"HERMES COMMERCE PRIVATE LIMITED",
"HERMES DISTILLERY PRIVATE LIMITED",
"HERMES ELECTRONICS AND TRADING PRIVATE LIMITED",
"HERMES FREIGHT PRIVATE LIMITED",
"HERMES HEALTHCARE PRIVATE LIMITED",
"HERMES I TICKETS PRIVATE LIMITED",
"HERMES INDIA RETAIL AND DISTRIBUTORS PRIVATE LIMITED",
"HERMES LABORATORIES PRIVATE LIMITED",
"HERMES LIFESCIENCE LLP",
"HERMES MARITIME SERVICES PRIVATE LIMITED",
"HERMES MEDIA PRIVATE LIMITED",
"HERMES SHIP MANAGEMENT PRIVATE LIMITED",
"HERMES TECHNOLOGIES PRIVATE LIMITED",
"HERMES TENSILE MEMBRANE STRUCTURES PRIVATE LIMITED",
"HERMES TRAVEL AND CARGO PRIVATE LIMITED",
"HERMINIO INDIA PRIVATE LIMITED",
"HERMITAGE FURNISHINGS PRIVATE LIMITED",
"HERO AGRO-PLAST PRIVATE LIMITED",
"HERO CORPORATE SERVICE PRIVATE LIMITED",
"HERO CYCLES LIMITED",
"HERO ECO MED PRIVATE LIMITED",
"HERO ECOTECH LIMITED",
"HERO E-CYCLES PRIVATE LIMITED",
"HERO ELECTRIC VEHICLES PRIVATE LIMITED",
"HERO ELECTRONIX PRIVATE LIMITED",
"HERO ENTERPRISES PVT LTD",
"HERO EXPORTS",
"HERO FINCORP LIMITED",
"HERO FOODS PRIVATE LIMITED",
"HERO FUTURE ENERGIES PRIVATE LIMITED",
"HERO HONDA MOTORS",
"HERO HOUSING FINANCE LIMITED",
"HERO INSURANCE BROKING INDIA PRIVATE LIMITED",
"HERO INVESTCORP PRIVATE LIMITED",
"HERO MANAGEMENT SERVICE LIMITED",
"HERO MINDMINE INSTITUTE PRIVATE LIMITED",
"HERO MOTOCORP LIMITED",
"HERO MOTORS LIMITED",
"HERO MULTI-PAP PRIVATE LIMITED",
"HERO PRODUCTS INDIA PRIVATE LIMITED",
"HERO REALTY PRIVATE LIMITED",
"HERO ROOFTOP ENERGY PRIVATE LIMITED",
"HERO SOLAR ENERGY PRIVATE. LIMITED.",
"HERO STEELS PRIVATE LIMITED",
"HERO TOURS & TRAVELS PRIVATE LIMITED",
"HERO VIRED LIMITED",
"HERO VIRED LTD",
"HERO WIND ENERGY PRIVATE LIMITED",
"HERO WIRETEX LIMITED",
"HERON HEALTH PRIVATE LIMITED",
"HERON INDIA PRIVATE LIMITED",
"HERONS LOGISTICS (INDIA) PRIVATE LIMITED",
"HEROS CONVENT HR SEC SCHOOL",
"HEROS FASHION PRIVATE LIMITED",
"HEROSTONE PRIVATE LIMITED",
"HERPORT LOGISTICS PRIVATE LIMITED",
"HERRENKNECHT INDIA PRIVATE LIMITED",
"HERRINGBONE & SUI PRIVATE LIMITED",
"HERRINGBONE PROJECTS PRIVATE LIMITED",
"HERRY CREATIONS PRIVATE LIMITED",
"HERSCHEL MOTORS PRIVATE LIMITED",
"HERSHEY INDIA PRIVATE LIMITED",
"HERSIMRAN FURNISHERS PRIVATE LIMITED",
"HERSTEL NUTRISCIENCE PRIVATE LIMITED",
"HERSTELLER BUILDTRADE PRIVATE LIMITED",
"HERTEL INDUSTRIES PRIVATE LIMITED",
"HERTZ CHEMICALS PRIVATE LIMITED",
"HERTZ CONTROLS (INDIA) PRIVATE LIMITED",
"HERTZ INSPECTION & SERVICES PRIVATE LIMITED",
"HERTZS INNOVATIVE SERVICES (I) PRIVATE LIMITED",
"HES ENGINEERS PVT LTD",
"HES INFRA PRIVATE LIMITED",
"HES WATER ENGINEERS (INDIA) PRIVATE LIMITED",
"HESA ENTERPRISES PRIVATE LIMITED",
"HESEL ENGINEERING PRIVATE LIMITED",
"HESH HERBAL PRIVATE LIMITED",
"HESOL INDIA PRIVATE LIMITED",
"HESOLT LUBRICANTS PRIVATE LIMITED",
"HESS CORPORATION",
"HESTABIT TECHNOLOGIES PRIVATE LIMITED",
"HESTECH INDUSTRIES PRIVATE LIMITED",
"HESTER BIOSCIENCES LIMITED",
"HESTER DIAGNOSTICS PRIVATE LIMITED",
"HESTER INFRA ENGINEERING PRIVATE LIMITED",
"HESTIA ELECTRONIC SECURITY SYSTEMS PRIVATE LIMITED",
"HESTIA HOSPITALITY PRIVATE LIMITED",
"HESTIN ENGINEERING PRIVATE LIMITED",
"HET CHINT HOSPITALITIES PRIVATE LIMITED",
"HET COTTON PRIVATE LIMITED",
"HET ELECTRIC SOLUTIONS PRIVATE LIMITED",
"HET FINANCE PRIVATE LIMITED",
"HETAL CONTAINERS PRIVATE LIMITED",
"HETAMSARIA PROJECTS PRIVATE LIMITED",
"HETANSHI PROPERTIES PRIVATE LIMITED",
"HETBAN SPECHEM LIMITED",
"HETERO BIOPHARMA LIMITED",
"HETERO DRUGS LIMITED",
"HETERO HEALTHCARE LIMITED",
"HETERO INFRASTRUCTURE SEZ LIMITED",
"HETERO INFRASTRUCTURE SEZ PRIVATE LIMITED",
"HETERO LABS LIMITED",
"HETERO MED SOLUTIONS LIMITED",
"HETERO WIND POWER (PENNAR) PRIVATE LIMITED",
"HETERO WIND POWER LIMITED",
"HETRO HELTHCARE",
"HETRO SHOES PRIVATE LIMITED",
"HETRONIC SYSTEMS INDIA PRIVATE LIMITED",
"HETSAM CLOTHING PRIVATE LIMITED",
"HETSHREE TRANSIT WORLD PRIVATE LIMITED",
"HETTICH COMPETENCE SERVICES PRIVATE LIMITED",
"HETTICH INDIA PRIVATE LIMITED",
"HETU CONSTRUCTION PVT LTD",
"HETVI LIFESCIENCES PRIVATE LIMITED",
"HETVI SILK MILLS PRIVATE LIMITED",
"HEUBACH COLORANTS INDIA LIMITED",
"HEUBACH COLOUR PRIVATE LIMITED",
"HEUBACH PIGMENTS PRIVATE LIMITED",
"HEUBACH TOYO COLOUR PRIVATE LIMITED",
"HEUFT INDIA PRIVATE LIMITED",
"HEUNGKUK INDIA PRIVATE LIMITED",
"HEUREUX SOFTWARE SOLUTIONS PRIVATE LIMITED",
"HEURISTIC CAPITAL SERVICES PRIVATE LIMITED",
"HEURISTICS INFORMATICS PRIVATE LIMITED",
"HEURISTIX DIGITAL TECHNOLOGIES PRIVATE LIMITED",
"HEURTEY PETROCHEM INDIA PRIVATE LIMITED",
"HEVEA AUTOMOTIVE INDIA PRIVATE LIMITED",
"HEVEA FURNITURE AND INTERIORS PRIVATE LIMITED",
"HEVEA RUBBER TECHNOLOGIES PRIVATE LIMITED",
"HEVEACRUMB RUBBER PRIVATE LIMITED",
"HEVINS ENGINEERING PRIVATE LIMITED",
"HEVO TECHNOLOGIES INDIA PRIVATE LIMITED",
"HEW PRECISION WORKS PRIVATE LIMITED",
"HEWA PRIVATE LIMITED",
"HEWLETT PACKARD ENTERPRISE GLOBALSOFT PRIVATE LIMITED",
"HEWLETT PACKARD ENTERPRISE INDIA PRIVATE LIMITED",
"HEWLETT PACKARD FINANCIAL SERVICES (INDIA) PRIVATE LTD",
"HEWLETT PACKARD INDIA SOFTWARE OPERATIONS PRIVATE LIMITED",
"HEX CABLE ACCESSORIES PRIVATE LIMITED",
"HEX WIRELESS PRIVATE LIMITED",
"HEXA CERAMIC PRIVATE LIMITED",
"HEXA COMMUNICATIONS PRIVATE LIMITED",
"HEXA ESTATES PRIVATE LIMITED",
"HEXA HEALTH CARE PRIVATE LIMITED",
"HEXA INTERNATIONAL PRIVATE LIMITED",
"HEXA SECURITIES AND FINANCE COMPANY LIMITED",
"HEXA STEEL & POWER PRIVATE LIMITED",
"HEXA TECHNOCRAFT INDIA PRIVATE LIMITED",
"HEXA WEBONY PRIVATE LIMITED",
"HEXABRAIN TECHNOLOGIES PRIVATE LIMITED",
"HEXACARE PHARMACEUTICALS PRIVATE LIMITED",
"HEXACELL PACKAGING PRIVATE LIMITED",
"HEXACOM TECHNOLOGIES PRIVATE LIMITED",
"HEXACORP TECHNICAL SERVICES PRIVATE LIMITED",
"HEXADOX PHARMACEUTICALS PRIVATE LIMITED",
"HEXAFIN CONSULTANCY PRIVATE LIMITED",
"HEXAGON BIO-PHARMA PRIVATE LIMITED",
"HEXAGON CAPABILITY CENTER INDIA PRIVATE LIMITED",
"HEXAGON CAPITAL ADVISORS PRIVATE LIMITED",
"HEXAGON DRIVES AND SYSTEMS PRIVATE LIMITED",
"HEXAGON EVENTS PRIVATE LIMITED",
"HEXAGON EXECUTIVE SEARCH PRIVATE LIMITED",
"HEXAGON GEOSYSTEMS INDIA PRIVATE LIMITED",
"HEXAGON GEOSYSTEMS SERVICES INDIA PRIVATE LIMITED",
"HEXAGON GLOBAL IT SERVICES PRIVATE LIMITED",
"HEXAGON GRAPHITE PRIVATE LIMITED",
"HEXAGON INDIA CORPORATION PRIVATE LIMITED",
"HEXAGON INGREDIENTS",
"HEXAGON MANUFACTURING INTELLIGENCE INDIA PRIVATE LIMITED",
"HEXAGON MARKETING PRIVATE LIMITED",
"HEXAGON METROLOGY INDIA PRIVATE LIMITED",
"HEXAGON NUTRITION (EXPORTS) PRIVATE LIMITED",
"HEXAGON NUTRITION EXPORTS PRIVATE LIMITED",
"HEXAGON NUTRITION INTERNATIONAL PRIVATE LIMITED",
"HEXAGON NUTRITION LIMITED",
"HEXAGON NUTRITION PRIVATE LIMITED",
"HEXAGON PRINT & PACK PRIVATE LIMITED",
"HEXAGON PROJECTS PRIVATE LIMITED",
"HEXAGON RESEARCH PRIVATE LIMITED",
"HEXAGON-MIDCO INDIA PRIVATE LIMITED",
"HEXAGRAM FINTECH PRIVATE LIMITED",
"HEXAGRAMM INFRASTRUCTURE PRIVATE LIMITED",
"HEXAMED TECHNOLOGIES INDIA PRIVATE LIMITED",
"HEXANET INFRA SOLUTIONS PRIVATE LIMITED",
"HEXARIDE TECHNOLOGIES OPC PRIVATE LIMITED",
"HEXATECH ESECURITY SOLUTIONS PRIVATE LIMITED",
"HEXATRON INDUSTRIES LIMITED",
"HEXAVIEW TECHNOLOGIES PRIVATE LIMITED",
"HEXAWARE TECHNOLOGIES LIMITED",
"HEXAXIS ADVISORS LIMITED",
"HEXCEL INVESTMENT SERVICES PRIVATE LIMITED",
"HEXES INDIA PRIVATE LIMITED",
"HEXIVE TECHNOLOGIES PRIVATE LIMITED",
"HEXLOGICALS TECHNOLOGIES PRIVATE LIMITED",
"HEXMESH TECHNOLOGIES PRIVATE LIMITED",
"HEXMOTO CONTROLS PRIVATE LIMITED",
"HEXOMED SYSTEMS PRIVATE LIMITED",
"HEXON LABORATORIES PRIVATE LIMITED",
"HEXONE INTERCHEM PVT LTD",
"HEXSTREAM SOLUTIONS PRIVATE LIMITED",
"HEXXA GEO SYSTEMS INTEGRATORS PRIVATE LIMITED",
"HEXYLIC POLYMERS PRIVATE LIMITED",
"HEY HOTELS AND RESTAURANT PRIVATE LIMITED",
"HEY NATH COLD STORAGE PRIVATE LIMITED",
"HEYER MEDICAL AG",
"HEYINZ INFRASTRUCTURE PRIVATE LIMITED",
"HEYLANDS EXPORTS PRIVATE LIMITED",
"HEYPEX PROTECTIVE COATINGS PRIVATE LIMITED",
"HEZAL ENTERPRISE PRIVATE LIMITED",
"HF FRESH RETAIL PRIVATE LIMITED",
"HF INDIA PRIVATE LIMITED",
"HF METALART PRIVATE LIMITED",
"HF UNIVERSAL PRIVATE LIMITED",
"HFC INDIA PRIVATE LIMITED",
"HFCL LIMITED",
"HFG ENTERTAINMENTS PRIVATE LIMITED",
"HFL CONSUMER PRODUCTS PRIVATE LIMITED",
"HFM INFRASTRUCTURES PRIVATE LIMITED",
"HFM LOGIWARE PRIVATE LIMITED",
"HFM SOLAR POWER PRIVATE LIMITED",
"HFN IT SERVICES PRIVATE LIMITED",
"HFTSOLUTION",
"HG ATOMS AND MOLECULES PRIVATE LIMITED",
"HG CREATORS PRIVATE LIMITED",
"HG FORCE 1 SECURITY SERVICES PRIVATE LIMITED",
"HG GRAPHICS PRIVATE LIMITED",
"HG METALS & ALLOYS PRIVATE LIMITED",
"HG SINGH LOGISTICS PRIVATE LIMITED",
"H-GARB INFORMATIX PRIVATE LIMITED",
"HGC TECHNOLOGIES INDIA PRIVATE LIMITED",
"HGE INTERNATIONAL PRIVATE LIMITED",
"HGI AUTOMOTIVES PRIVATE LIMITED",
"HGM COTTON YARN PRIVATE LIMITED",
"HGP CARS PRIVATE LIMITED",
"HGP COMMUNITY PRIVATE LIMITED",
"HGR PACKAGING SOLUTIONS PRIVATE LIMITED",
"HGS EXPORTS PRIVATE LIMITED",
"HGS INDIA LIMITED",
"HGS INDUSTRIES PRIVATE LIMITED",
"HH CUSTOM PRIVATE LIMITED",
"HH GLOBAL MARKETING SOLUTIONS PRIVATE LIMITED",
"HH INTERIOR & AUTO COMPONENTS PRIVATE LIMITED",
"HH IRON AND STEEL PRIVATE LIMITED",
"HH RAJDADI HOSPITAL",
"HH VENTURES PRIVATE LIMITED",
"HHA TANK TERMINAL PRIVATE LIMITED",
"HHI MARKETING PRIVATE LIMITED",
"HHJ BUILDTECH PRIVATE LIMITED",
"HHM EVENTS PRIVATE LIMITED",
"HHT PHARMA PRIVATE LIMITED",
"HHV CRYSTALS PRIVATE LIMITED",
"HHV PUMPS PRIVATE LIMITED",
"HHW CARE PRODUCTS (INDIA) PRIVATE LIMITED",
"HI - COMMANDS TECH INDIA LIMITED",
"HI - TECH BOARD PRIVATE LIMITED",
"HI - TECH LIFT MOVERS INDIA PRIVATE LIMITED",
"HI 2 BUY. COM PRIVATE LIMITED",
"HI 5 LMR PRIVATE LIMITED",
"HI BLUE INTERIORS PRIVATE LIMITED",
"HI BOND CEMENT INDIA PRIVATE LIMITED",
"HI CARE GLOVES PRIVATE LIMITED",
"HI CHOICE PROCESSORS PVT LTD",
"HI CLASS INSULATOR PRIVATE LIMITED",
"HI CURE HEALTHCARE PRIVATE LIMITED",
"HI DESTINATION MANAGEMENT PRIVATE LIMITED",
"HI FAB ENGINEERS PVT LTD",
"HI FAIRE APPARELS PRIVATE LIMITED",
"HI FASHIONS INDUSTRIES PRIVATE LIMITED",
"HI FIDELITY SOLUTIONS PRIVATE LIMITED",
"HI FLY FOOTWEARS LIMITED",
"HI FOCUS ELECTRONICS INDIA PRIVATE LIMITED",
"HI IN CONCEPTS PRIVATE LIMITED",
"HI LEAD INFOTECH PRIVATE LIMITED",
"HI LIFE IRON METALS INDIA PRIVATE LIMITED",
"HI LIFE PRODUCTS PRIVATE LIMITED",
"HI LINE PENS PRIVATE. LIMITED",
"HI LITE BUILDERS PRIVATE LIMITED",
"HI LITE CONSTRUCTIONS PRIVATE LIMITED",
"HI LITE PROJECTS PRIVATE LIMITED",
"HI PACK AND FILL MACHINES PRIVATE LIMITED",
"HI PACK BLOW CANS PRIVATE LIMITED",
"HI PHYSIX LABORATORY INDIA PRIVATE LIMITED",
"HI PLUS CREATIONS PRIVATE LIMITED",
"HI POINT PROJECT MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"HI POINT SERVICES INDIA PRIVATE LIMITED",
"HI PRIDE HEALTHCARE AMBULANCE PRIVATE LIMITED",
"HI PROFILE PACKING PRIVATE LIMITED",
"HI Q DESIGN AND DETAILING PRIVATE LIMITED",
"HI Q ELECTRONICS PRIVATE LIMITED",
"HI QFM SERVICES PRIVATE LIMITED",
"HI REL TECH PRIVATE LIMITED",
"HI RISE APARTMENT MAKERS PVT LTD",
"HI SECURE EXHIBITION SERVICES PRIVATE LIMITED",
"HI TECH AGRO EQUIPMENTS",
"HI TECH ARAI PRIVATE LIMITED",
"HI TECH ARTIFICIAL LIMBS PRIVATE LIMITED",
"HI TECH AUDIO & IMAGE LLP",
"HI TECH AUDIO SYSTEMS PRIVATE LIMITED",
"HI TECH BIOSCIENCES INDIA PRIVATE LIMITED",
"HI TECH BUTTERFLY VALVES INDIA PRIVATE LIMITED",
"HI TECH CHEMICALS LIMITED",
"HI TECH COMPUTERS SERVICES NASHIK PRIVATE LIMITED",
"HI TECH COTTEX PRIVATE LIMITED",
"HI TECH ELASTOMERS LIMITED",
"HI TECH ELEC AUTO PRIVATE LIMITED",
"HI TECH ELECTRO REPAIR PRIVATE LIMITED",
"HI TECH ENGINEERS",
"HI TECH ENTERPRISES",
"HI TECH FERROUS & NON FERROUS INDIA PRIVATE LIMITED",
"HI TECH FILM & BROADCAST ACADEMY PRIVATE LIMITED",
"HI TECH FLYASH (INDIA) PRIVATE LIMITED",
"HI TECH FORMULATIONS PRIVATE LIMITED",
"HI TECH INDUSTRIES LIMITED",
"HI TECH INFORMATICS PRIVATE LIMITED",
"HI TECH INKS PRIVATE LIMITED",
"HI TECH INSTITUTE OF TECHNOLOGY",
"HI TECH LAMINATION FILMS PRIVATE LIMITED",
"HI TECH MANUFACTURERS PVT LTD",
"HI TECH MEDICAL COLLEGE & HOSPITAL",
"HI TECH MEDICOS TRADE PRIVATED LIMITED",
"HI TECH MEDICS PRIVATE LIMITED",
"HI TECH NATURAL PRODUCTS INDIA LIMITED",
"HI TECH PHARMACEUTICALS PVT LTD",
"HI TECH PHARMACEVICALS",
"HI TECH PIPES LIMITED",
"HI TECH PIPES LTD",
"HI -TECH POLYPLAST AND IRRIGATION PRIVATE LIMITED",
"HI TECH POWERFIELD PRIVATE LIMITED",
"HI TECH PRECISION LLP",
"HI TECH RESISTORS PVT LTD",
"HI TECH THERMOFORMERS PRIVATE LIMITED",
"HI TECH TRANS TECHNOCRATES PRIVATE LIMITED",
"HI TECH TRANSPOWER PRIVATE LIMITED",
"HI- TECHNO CONTROL SYSTEM PRIVATE LIMITED",
"HI TEMP SOLUTIONS PRIVATE LIMITED",
"HI TONE HEARING PRIVATE LIMITED",
"HI TOURS (INDIA) PRIVATE LIMITED",
"HI TOURS INDIA PRIVATE LIMITED",
"HI TRANS SERVICES PRIVATE LIMITED",
"HI WALK TRAVELS PRIVATE LIMITED",
"HI3 TECHNOLOGIES PRIVATE LIMITED",
"HI-5 MULTIMEDIA SERVICES PRIVATE LIMITED",
"HI5 YOUTH FOUNDATION",
"HIA EXPORTS",
"HIACC ENGINEERING AND SERVICES PRIVATE LIMITED",
"HIACME AUTOMATIONS INDIA PRIVATE LIMITED",
"HIBERYL EXPORTS PRIVATE LIMITED",
"HIBEX INDIA PRIVATE LIMITED",
"HIBISCUS COMMUNICATIONS PRIVATE LIMITED",
"HIBISCUS DIGITAL MEDIA PRIVATE LIMITED",
"HIBISCUS PHARMACEUTICALS PRIVATE LIMITED",
"HIBISCUS TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"HI-BOLT INDUSTRIES PRIVATE LIMITED",
"HI-BOND INFRA PRIVATE LIMITED",
"HI-BRANDE ENTERPRISES PRIVATE LIMITED",
"HI-BRITE LIGHTING LIMITED",
"HIBROW HEALTHCARE PRIVATE LIMITED",
"HIBZA FOODS PRIVATE LIMITED",
"HIC ABF SPECIAL FOODS PRIVATE LIMITED",
"HIC IT SOLUTION AND SERVICES PRIVATE LIMITED",
"HICAL INFRA PRIVATE LIMITED",
"HICAL NSE ELECTRONICS PRIVATE LIMITED",
"HICAL TECHNOLOGIES PRIVATE LIMITED",
"HI-CAN INDUSTRIES PRIVATE LIMITED",
"HICARE SERVICES PRIVATE LIMITED",
"HICHIGIRI HOTEL PRIVATE LIMITED",
"HI-CHOICE EXPORTS PRIVATE LIMITED",
"HI-CHOICE PACK CRAFT PRIVATE LIMITED",
"HI-CHOICE TEXTILE PRIVATE LIMITED",
"HICKORY CREATIONS PRIVATE LIMITED",
"HICKS HEALTH CARE PRIVATE LIMITED",
"HICKS THERMOMETERS INDIA LIMITED",
"HICLASS AGRO PRODUCTS PRIVATE LIMITED",
"HICO MULTIFIN PRODUCTS PVT LTD",
"HICON ENGINEERING CO PRIVATE LTD",
"HI-CON TECHNO CAST PRIVATE LIMITED",
"HICONHERA BUILDTECH PRIVATE LIMITED",
"HICOTRONICS DEVICES PRIVATE LIMITED",
"HI-CRAZE FASHIONS PRIVATE LIMITED",
"HICRETE DECORATIVE SYSTEMS PRIVATE LIMITED",
"HICXICA FORMULATIONS OPC PRIVATE LIMITED",
"HID INDIA PRIVATE LIMITED",
"HIDADA COMPANY LIMITED",
"HIDAYATULLAH NATIONAL LAW UNIVERSITY",
"HIDDEN BRAINS INFOTECH PRIVATE LIMITED",
"HIDDEN DOOR TRAVEL LLP",
"HIDDENSMITH DECOR PRIVATE LIMITED",
"HIDECOR PRIVATE LIMITED",
"HIDEL POWER PRODUCTS PRIVATE LIMITED",
"HIDE-N-CHIC FURNITURE PRIVATE LIMITED",
"HIDESIGN INDIA PRIVATE LIMITED",
"HIDROGLOBAL INDIA PRIVATE LIMITED",
"HIEC TRADING COMPANY PRIVATE LIMITED",
"HIECOR SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"HI-ESTEEM AUTO KOMPONENTS PRIVATE LIMITED",
"HIETAFAN TECHNOLOGY PRIVATE LIMITED",
"HIFAB ALUMINIUM PRIVATE LIMITED",
"HIFERK TECHNOLOGIES PRIVATE LIMITED",
"HI-FI BIOTECH INDIA PRIVATE LIMITED",
"HIFI ELEVATOR INDIA PRIVATE LIMITED",
"HI-FI HOUSEKEEPING PRIVATE LIMITED",
"HI-FIELD AG-CHEM (INDIA) PRIVATE LIMITED",
"HIFIMAN ELECTRONICS INDIA PRIVATE LIMITED",
"HIFIN CAPITAL PRIVATE LIMITED",
"HIFINITE HEALTH INTERNATIONAL PRIVATE LIMITED",
"HIFINZY AGRO PRIVATE LIMITED",
"HI-FIT ELASTOMERS PRIVATE LIMITED",
"HI-FLEX HYDRAULICS PRIVATE LIMITED",
"HIFLEX PRINTO PACK PRIVATE LIMITED",
"HIFLO SOLDERS PRIVATE LIMITED",
"HIFUNI PUMPS PRIVATE LIMITED",
"HIFX IT AND MEDIA SERVICES PRIVATE LIMITED",
"HIFX LEARNING SERVICES PRIVATE LIMITED",
"HIGA DIGITAL PRIVATE LIMITED",
"HIGAIN FEEDS & FARMS PRIVATE LIMITED",
"HIGAIN ORGANIC PRIVATE LIMITED",
"HIGGINBOTHAMS PRIVATE LIMITED",
"HIGGINS INFRATECH PRIVATE LIMITED",
"HIGGS BOSON HEALTH PRIVATE LIMITED",
"HIGGS BOSON SYSTEMS PRIVATE LIMITED",
"HIGGS HEALTHCARE",
"HIGH ADVENTURE TOURS PRIVATE LIMITED",
"HIGH AIMS TRADECOM PRIVATE LIMITED",
"HIGH BREETD FASHIONS",
"HIGH CLASS PROJECTS LIMITED",
"HIGH CLASS SECURITY AND HOUSEKEEPING SERVICE PRIVATE LIMITED",
"HIGH CLEAN MAKE INDIA PRIVATE LIMITED",
"HIGH COMMISSION OF CANADA",
"HIGH COMMISSION OF MALAYSIA",
"HIGH COURT APPELLATE SIDE BOMBAY",
"HIGH COURT APPELLATE SIDE CALCUTTA",
"HIGH COURT BOMBAY",
"HIGH COURT CALCUTTA",
"HIGH COURT OF DELHI",
"HIGH COURT OF GUJARAT AHMEDABAD",
"HIGH COURT OF JUDICATURE AT ALLAHABAD",
"HIGH CREATION INTERIOR PROJECTS PRIVATE LIMITED",
"HIGH EDGE REAL ESTATE ADVISORY PRIVATE LIMITED",
"HIGH END INFRATECH PRIVATE LIMITED",
"HIGH END QUALITY CONSTRUCTIONS PRIVATE LIMITED",
"HIGH ENERGY BATTERIES INDIA LIMITED",
"HIGH ENERGY MATERIALS RESEARCH LAB",
"HIGH ENERGY MATERIALS RESEARCH LABORATORY",
"HIGH EXIMPETRO PRIVATE LIMITED",
"HIGH EXPLOSIVES FACTORY",
"HIGH FIELD DISTILLERS & BOTTLERS PRIVATE LIMITED",
"HIGH FLOW EQUIPMENTS PRIVATE LIMITED",
"HIGH FORCE HYDRAULICS PRIVATE LIMITED",
"HIGH GATES HOTEL PRIVATE LIMITED",
"HIGH GRADE INDUSTRIES (INDIA) PRIVATE LIMITED",
"HIGH GRADE INFRA PROJECTS PRIVATE LIMITED",
"HIGH GRADE QUALITY ENTERPRISES PRIVATE LIMITED",
"HIGH GROUND ENTERPRISE LIMITED",
"HIGH GROWTH CREDIT SERVICES LIMITED",
"HIGH GROWTH EXPORTS PVT LTD",
"HIGH HOMES INFRASTRUCTURE PRIVATE LIMITED",
"HIGH JUMP TRADERS PRIVATE LIMITED",
"HIGH LINK EXPORTS PVT LTD",
"HIGH LINK FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"HIGH NOON CONSULTING PRIVATE LIMITED",
"HIGH OCTANE WORLD WIDE COFFEE PRIVATE LIMITED",
"HIGH PARRA CONSTRUCTION PRIVATE LIMITED",
"HIGH PEAK FOODS PRIVATE LIMITED",
"HIGH PEAK SOFTWARE PRIVATE LIMITED",
"HIGH PERFORMANCE COMPOSITES AND COATINGS PRIVATE LIMITED",
"HIGH PERFORMANCE PLASTICS INDIA PRIVATE LIMITED",
"HIGH PERFORMANCE PRODUCTS INDUSTRIES PRIVATE LIMITED",
"HIGH PERFORMANCE TEXTILES PRIVATE LIMITED",
"HIGH PLACES INTERNATIONAL CONSULTING PRIVATE LIMITED",
"HIGH PLACES MANAGEMENT PRIVATE LIMITED",
"HIGH POINT PROPERTIES LIMITED",
"HIGH PROSPERITY INFRA PRIVATE LIMITED",
"HIGH PURE CAPITAL AGRO INDIA PRIVATE LIMITED",
"HIGH PURITY LABORATORY CHEMICALS PRIVATE LIMITED",
"HIGH QUALITY STEELS LTD",
"HIGH QUEEN DISTILLERS AND BOTTLERS PRIVATE LIMITED",
"HIGH RANGE COFFEE CURRING PRIVATE LIMITED",
"HIGH RANGE FOODS PRIVATE LTD",
"HIGH RANGE ORGANIC PRODUCER COMPANY LIMITED",
"HIGH RISE BUILDTECH PRIVATE LIMITED",
"HIGH RISE ENGINEERS PRIVATE LIMITED",
"HIGH RISE MEP SERVICES PRIVATE LIMITED",
"HIGH RISE REALTY PRIVATE LIMITED",
"HIGH SCHOOL KADHARE DHULE",
"HIGH SEAS LOGISTICS PRIVATE LIMITED",
"HIGH SEAS PROPERTIES PRIVATE LIMITED",
"HIGH SEAS WORLDWIDE PRIVATE LIMITED",
"HIGH SKY CONSTRUCTIONS & BUILDERS PRIVATE LIMITED",
"HIGH SPEED CARGO PRIVATE LIMITED",
"HIGH SPIRIT COMMERCIAL VENTURES PRIVATE LIMITED",
"HIGH SPIRIT SOFT BAGS PRIVATE LIMITED",
"HIGH SPIRIT TRADING VENTURES PRIVATE LIMITED",
"HIGH SPIRITS EXIM PRIVATE LIMITED",
"HIGH STREET ESSENTIALS PRIVATE LIMITED",
"HIGH STREET FASHIONS PRIVATE LIMITED",
"HIGH STREET LIGHTING PRIVATE LIMITED",
"HIGH STREET STORES PRIVATE LIMITED",
"HIGH TECH AGRICULUM PRIVATE LIMITED",
"HIGH TECH RECLAIM PRIVATE LIMITED",
"HIGH TECH SECURITY SERVICES",
"HIGH TENSILE FASTNUTS INDIA PRIVATE LIMITED",
"HIGH TENSILE PRODUCTS PRIVATE LIMITED",
"HIGH TENSION ERECTORS LIMITED",
"HIGH TIDE SHIP MANAGEMENT PRIVATE LIMITED",
"HIGH TOUCH FACILITY SERVICES PRIVATE LIMITED",
"HIGH VACUUM TECHNOLOGIES AND PRODUCTS PRIVATE LIMITED",
"HIGH WAY GARDEN DRIVE IN PVT LTD",
"HIGH YIELD FORTUNE PRIVATE LIMITED",
"HIGHBAR TECHNOCRAT LIMITED",
"HIGHBORN FLANGES & FITTINGS (INDIA) PRIVATE LIMITED",
"HIGHBORNE LAMINATES PRIVATE LIMITED",
"HIGHBROW CONSULTANTS PRIVATE LIMITED",
"HIGHBROW DILIGENCE SERVICES PRIVATE LIMITED",
"HIGHCARE MARINE FOODS EXPORTS PRIVATE LIMITED",
"HIGHCO ENGINEERS PRIVATE LIMITED",
"HIGHCO INDUSTRIES PRIVATE LIMITED",
"HIGHDREAM POLYMERS PRIVATE LIMITED",
"HIGHEND PROPERTIES PRIVATE LIMTIED",
"HIGHER EDUCATION DEPARTMENT OF GOVT RAJEEV LOCHAN COLLEGE",
"HIGHER EDUCATION FINANCING AGENCY",
"HIGHER EDUCATION GURU RAGHUVAR PRASAD BAUDH DEGREE COLLEGE KATAHULA PRAYAGRAJ",
"HIGHER HIGHS RETAIL PRIVATE LIMITED",
"HIGHER PITCH DIGITAL CONSULTING PRIVATE LIMITED",
"HIGHER TECHNOLOGY TRADING SYSTEMS PRIVATE LIMITED",
"HIGHFIELD BOTANICALS PRIVATE LIMITED",
"HIGHFLOW INDUSTRIES PRIVATE LIMITED",
"HIGHFOX PRIVATE LIMITED",
"HIGHGO INFO SOLUTIONS PRIVATE LIMITED",
"HIGHGRADE CONSULTANTS AND ENGINEERING PRIVATE LIMITED",
"HIGHGROUND ENERGY PRIVATE LIMITED",
"HIGHGROW FLORIS CHEMICALS PRIVATE LIMITED",
"HIGHGROWTH TRADECOM PRIVATE LIMITED",
"HIGHLAND CARE MULTI SPECIALITY HOSPITAL",
"HIGHLAND DE LA MER PRIVATE LIMITED",
"HIGHLAND EXIM PRIVATE LIMITED",
"HIGHLAND HOSPITAL RESEARCH & DIAGNOSTIC CENTRE",
"HIGHLAND LIQUORS PRIVATE LIMITED",
"HIGHLAND MEDICARE PRIVATE LIMITED",
"HIGHLAND SILVER SANDS PRIVATE LIMITED",
"HIGHLAND STAR HOTELS AND RESORTS PRIVATE LIMITED",
"HIGHLAND SUPER SPECIALITY HOSPITAL",
"HIGHLANDPARK MANALI PRIVATE LIMITED",
"HIGHLANDS INFO TECH PRIVATE LIMITED",
"HIGHLIFE CLOTHING PRIVATE LIMITED",
"HIGHLIFE ENCALVE CONSULTANTS PRIVATE LIMITED",
"HIGHLINE BUILDING PRODUCTS PRIVATE LIMITED",
"HIGHLINE EDUCARE INDIA PRIVATE LIMITED",
"HIGHLINE STUDIO PRODUCTIONS PRIVATE LIMITED",
"HIGHLINK INVESTMENT PRIVATE LIMITED",
"HIGHLITE FOOTWEARS PRIVATE LIMITED",
"HIGHLY ELECTRICAL APPLIANCES INDIA PRIVATE LIMITED",
"HIGHORBIT CAREERS PRIVATE LIMITED",
"HIGHORITY INDIA PRIVATE LIMITED",
"HIGHPOINTS TECHNOLOGIES INDIA PRIVATE LIMITED",
"HIGHPOWERV INFRASTRUCTURE LIMITED",
"HIGHPOWERV STANPRO SERVICES INDIA PRIVATE LIMITED",
"HIGHQ (INDIA) PRIVATE LIMITED",
"HIGHQ SOLUTIONS LIMITED",
"HIGHRANGE RUBBER AND COIR PRODUCTS PRIVATE LIMITED",
"HIGHRANK WAREHOUSING PRIVATE LIMITED",
"HIGHRICH ONLINE SHOPPE PRIVATE LIMITED",
"HIGHRISE INFRABIZ PRIVATE LIMITED",
"HIGHRISE INTERNATIONAL PRIVATE LIMITED",
"HIGHRISE OVERSEAS PRIVATE LIMITED",
"HIGHRISE ROLLER FLOUR MILLS PVT LTD",
"HIGHSKY FOREX PRIVATE LIMITED",
"HIGHSKY IT SOLUTIONS PRIVATE LIMITED",
"HIGHSKY TRAVELS PRIVATE LIMITED",
"HIGHSTREET ADVISORY SERVICES PRIVATE LIMITED",
"HIGHSTREET CRUISES AND ENTERTAINMENT PRIVATE LIMITED.",
"HIGHSTREET DEVELOPERS PRIVATE LIMITED",
"HIGHTECH ENERGY FEEDS INDIA PRIVATE LIMITED",
"HIGHTECH INFRAPROMOTERS PRIVATE LIMITED",
"HIGH-TECH TYRE RETREADERS PRIVATE LIMITED",
"HIGHTEK TOWNSHIP AND ESTATE DEVELOPERS PRIVATE LIMITED",
"HIGHTEMP AEROSPACE PRIVATE LIMITED",
"HIGHTEMP FURNACES LIMITED",
"HIGHTENSION ELECTRICAL EQUIPMENTS PRIVATE LIMITED",
"HIGHTOP TRADING PRIVATE LIMITED",
"HIGHVALLEY INSULATIONS PRIVATE LIMITED",
"HIGHVISION ENTERPRISES PRIVATE LIMITED",
"HIGH-VOLT ELECTRICALS PRIVATE LIMITED",
"HIGHVOLT POWER AND CONTROL SYSTEMS PRIVATE LIMITED",
"HIGHWAY 905 TECHNOLOGIES PRIVATE LIMITED",
"HIGHWAY CONCESSIONS ONE PRIVATE LIMITED",
"HIGHWAY ENGINEERING CONSULTANT",
"HIGHWAY INDUSTRIES LIMITED",
"HIGHWAY INFRASTRUCTURE LIMITED",
"HIGHWAY INFRATECH PRIVATE LIMITED",
"HIGHWAY KING HOTELS PRIVATE LIMITED",
"HIGHWAY ON WHEELS TRANSPORT PRIVATE LIMITED",
"HIGHWAY ROADLINES P LTD",
"HIGHWAY STAR REST AND RECREATION PRIVATE LIMITED",
"HIGHWAY TRADING PVT LTD",
"HIGHWAY TRANS SERVICES PRIVATE LIMITED",
"HIGHWAYMEN COLLECTIVE PRIVATE LIMITED",
"HIGLANCE LABORATORIES PRIVATE LIMITED",
"HI-GREEN CARBON LIMITED",
"HIGRID IMAGING SOLUTIONS PRIVATE LIMITED",
"HIGROVET NUTRITIONS PRIVATE LIMITED",
"HIH7 WEBTECH PRIVATE LIMITED",
"HII INSURANCE BROKING SERVICES PRIVATE LIMITED",
"HIIIH INNOVATIONS PRIVATE LIMITED",
"HIIMPACT CONSULTANTS PRIVATE LIMITED",
"HIJAZ BUILD TECH PRIVATE LIMITED",
"HIJAZ KURODA GLOVES COMPANY PRIVATE LIMITED",
"HIJAZ LEATHERS PRIVATE LIMITED",
"HIK PEK PVT LTD",
"HIKAL LIMITED",
"HIKARI HOTELS PRIVATE LIMITED",
"HIKARI VENTURES PRIVATE LIMITED",
"HIKE AUTOMATION PRIVATE LIMITED",
"HIKE SHOE PRIVATE LIMITED",
"HIKES INDUSTRIES PRIVATE LIMITED",
"HIKEZEE CONNECT INDIA PRIVATE LIMITED",
"HIKOKI POWER TOOLS INDIA PRIVATE LIMITED",
"HIL (INDIA) LIMITED",
"HIL LIMITED",
"HILAB EQUIPMENTS PRIVATE LIMITED",
"HILAND AGRO PRODUCTS PRIVATE LIMITED",
"HILAND PROJECTS LIMITED",
"HILARITY INN A UNIT OF SHAMA ANS HOTELS PRIVATE LIMITED",
"HILD DEFENCE AND AEROSPACE PRIVATE LIMITED",
"HILD ENERGY PRIVATE LIMITED",
"HILDA AUTOMATION PRIVATE LIMITED",
"HILDEN PACKAGING MACHINES PRIVATE LIMITED",
"HI-LEX DOOR INDIA PRIVATE LIMITED",
"HILGER U KERN MANUFACTURING PRIVATE LIMITED",
"HI-LIFE BUILDERS PRIVATE LIMITED",
"HI-LIFE MARKTECH PRIVATE LIMITED",
"HI-LIFE TOURS & TRAVEL PRIVATE LIMITED",
"HILIGHT LOGISTICS INDIA PRIVATE LIMITED",
"HILIKS TECHNOLOGIES LIMITED",
"HI-LINE AQUA PRIVATE LIMITED",
"HI-LINE SHIPPING SERVICES PRIVATE LIMITED",
"HILITE INDUSTRIES PRIVATE LIMITED",
"HILITE'S INDIA PRIVATE LIMITED",
"HILL & ASSOCIATES INDIA PRIVATE LIMITED",
"HILL & SMITH INFRASTRUCTURE PRODUCTS INDIA PRIVATE LIMITED",
"HILL AND ASSOCIATES (INDIA) PRIVATE LIMITED TRS FROM MUMBAI TO HR",
"HILL AND HERBS PRIVATE LIMITED",
"HILL COUNTY PROPERTIES LIMITED",
"HILL GRANGE PREP SCHOOL",
"HILL HEIGHT HOTELS PRIVATE LIMITED",
"HILL INDIA HYDRO ENGINEERING PRIVATE LIMITED",
"HILL INTERNATIONAL INC",
"HILL INTERNATIONAL PROJECT MGMT INDIA PRIVATE LIMITED",
"HILL PROPERTIES LIMITED",
"HILL SPRING INTERNATIONAL SCHOOL",
"HILL STONE CERAMIC PRIVATE LIMITED",
"HILL STONE DENTAL LABORATORY PRIVATE LIMITED",
"HILL TOP IMPEX PRIVATE LIMITED",
"HILL VALLEY RUBBERS PVT LTD",
"HILL VIEW HIRE PURCHASE PRIVATE LIMITED",
"HILL VIEW HOLIDAY INN PRIVATE LIMITED",
"HILL VIEW INFRABUILD LIMITED",
"HILL VIEW INFRASTRUCTURE PRIVATE LIMITED",
"HILL VIEW INVESTMENTS PVT LTD",
"HILL ZILL WINES PRIVATE LIMITED",
"HILLARY CLINTON NURSING SCHOOL",
"HILLCREST FOODS",
"HILLER DECANTERS INDIA PRIVATE LIMITED",
"HILLGREEN HERBALS PRIVATE LIMITED",
"HILLGREEN HIGH SCHOOL & JUNIOR COLLEGE",
"HILLGREEN PLANTATIONS PRIVATE LIMITED",
"HILLMAN GEARS PVT LTD",
"HILLMAN HOSIERY MILLS PRIVATE LIMITED",
"HILLOCK HOTELS PVT LTD",
"HILLOCK INFRASTRUCTURE (OPC) PRIVATE LIMITED",
"HILLPOINT BUILDING SOLUTIONS PRIVATE LIMITED",
"HILL-ROM INDIA PRIVATE LIMITED",
"HILLS CEMENT COMPANY LIMITED",
"HILLS HABBER ELECTRIC PRIVATE LIMITED",
"HILLS HIGH SCHOOL",
"HILLS N VALLEYS ORGANICS PRIVATE LIMITED",
"HILLS TRADE AGENCIES",
"HILLSIDE FARM DEVELOPERS PRIVATE LIMITED",
"HILLSON FOOTWEAR PRIVATE LIMITED",
"HILLSTONE GRANITES PRIVATE LIMITED",
"HILLTELL NETWORK INFRASTRUCTURE PRIVATE LIMITED",
"HILLTHEORY IT SOLUTIONS PRIVATE LIMITED",
"HILLTHRILL AGRO PROCESSOR PRIVATE LIMITED",
"HILLTON SCIENTIFIC LAB PRIVATE LIMITED",
"HILLTONE SOFTWARE AND GASES LIMITED",
"HILLTOP CERAMIC",
"HILLTOP CONSTRUCTIONS PRIVATE LIMITED",
"HILLTOP HIRISE PRIVATE LIMITED",
"HILLTOP REF ENGINEERS PRIVATE LIMITED",
"HILLTOP STONES PRIVATE LIMITED",
"HILLTOP TRADERS PRIVATE LIMITED",
"HILLVIEW AGENCIES PVT LTD",
"HILLWALK DESIGNS PRIVATE LIMITED",
"HILLWAYS CONSTRUCTION COMPANY PRIVATE LIMITED",
"HILLWOOD IMPEX PRIVATE LIMITED",
"HILLWOODS CAFE PRIVATE LIMITED",
"HILLWOODS SCHOOL",
"HILMAN CAPITAL FINANCE LIMITED",
"HILMAN TEX PRIVATE LIMITED",
"HILOTEX INTERNATIONAL PRIVATE LIMITED",
"HILSCHER INDIA PRIVATE LIMITED",
"HILSUN FOODS AND DRUGS PRIVATE LIMITED",
"HILSUN PHARMA PRIVATE LIMITED",
"HILTAKE ELECTRONICS PVT LTD",
"HILTEX INDUSTRIAL FABRICS PRIVATE LIMITED",
"HILTEX OVERSEAS",
"HILTI INDIA PRIVATE LIMITED",
"HILTI MANUFACTURING INDIA PRIVATE LIMITED",
"HILTI TECHNOLOGY SOLUTIONS INDIA PRIVATE LIMITED",
"HILTON AGRO FOODS PRIVATE LIMITED",
"HILTON BUILDERS AND TEXTILES PVT LTD",
"HILTON DEVELOPERS PRIVATE LIMITED",
"HILTON FORWARDERS PRIVATE LIMITED",
"HILTON HIGH INNOVATIVE LEARNING",
"HILTON HOLIDAYS AND RESORTS PRIVATE LIMITED",
"HILTON HOTEL MANAGEMENT SERVICES PRIVATE LIMITED",
"HILTON HOTELS MANAGEMENT INDIA PRIVATE LIMITED",
"HILTON INFRASTRUCTURE",
"HILTON LOGISTICS PRIVATE LIMITED",
"HILTON METAL FORGING LIMITED",
"HILTON POLYFLEX PRIVATE LIMITED",
"HILTON PRECISIONS LIMITED",
"HILTON TOBACCOS PRIVATE LIMITED",
"HILTON TRADECOMM PRIVATE LIMITED",
"HILTON'S SCHOOL",
"HILUX AUTOMOTIVE PRIVATE LIMITED",
"HILUXE GIFTS PRIVATE LIMITED",
"HIM AGRI FRESH PRIVATE LIMITED",
"HIM AUTO PRODUCTS PRIVATE LIMITED",
"HIM BIOLOGICS LIFECARE PRIVATE LIMITED",
"HIM CHEM LIMITED",
"HIM ENGINEERS INDIA PVT LTD",
"HIM FOODS AND COLD STORAGE PRIVATE LIMITED",
"HIM FRESH PRODUCE PRIVATE LIMITED",
"HIM INDUSTRIAL ENGINEERING PRIVATE LIMITED",
"HIM INFRATECH PRIVATE LIMITED",
"HIM LOGISTICS PRIVATE LIMITED",
"HIM MARKETING SERVICES PRIVATE LIMITED",
"HIM METAL PROCESSING PVT LTD",
"HIM SHIKHAR CONSTRUCTION PRIVATE LIMITED",
"HIM SURAJ ELECTRO FIBER PRIVATE LIMITED",
"HIM TEKNOFORGE LIMITED HTL",
"HIM URJA PRIVATE LIMITED",
"HIMA MATRIX PRIVATE LIMITED",
"HIMAAKARS TEXOFAB INDUSTRIES PRIVATE LIMITED",
"HI-MAC CASTINGS PRIVATE LIMITED",
"HIMACHAL ALUMINIUM AND CONDUCTORS",
"HIMACHAL C & F AGENCY PRIVATE LIMITED",
"HIMACHAL CEMENT PVT LTD",
"HIMACHAL CONSTRUCTION COMPANY PRIVATE LIMITED",
"HIMACHAL CONSULTANCY ORGANISATION LTD",
"HIMACHAL DASTAK MEDIA PRIVATE LIMITED",
"HIMACHAL ENERGY PRIVATE LIMITED",
"HIMACHAL ENERGY PRIVATE LIMITED HEPL",
"HIMACHAL FASTENERS PVT LTD",
"HIMACHAL FIBRES LIMITED",
"HIMACHAL FUTURISTIC COMMUNICATIONS LIMITED",
"HIMACHAL HEALTHCARE PRIVATE LIMITED",
"HIMACHAL HYDEL PROJECTS PRIVATE LIMITED",
"HIMACHAL INFRACON PRIVATE LIMITED",
"HIMACHAL INFRACON PRIVATE. LIMITED.",
"HIMACHAL INSTITUE OF DENTAL SCIENCES",
"HIMACHAL OXYGEN LTD",
"HIMACHAL POLYOLEFINS LIMITED",
"HIMACHAL PRADESH CRICKET ASSOCIATION",
"HIMACHAL PRADESH HORTICULTURAL PRODUCE MARKETING AND PROCESSING CORPORATION LIMITED",
"HIMACHAL PRADESH ROAD AND OTHER INFRASTRUCTURE DEVELOPMENT CORPN LTD",
"HIMACHAL PRADESH STATE ELECTRICITY BOARD LIMITED",
"HIMACHAL PRADESH STATE ELECTRONICS DEVP CORPN LTD",
"HIMACHAL ROAD TRANSPORT CORPORATION",
"HIMACHAL SHOTS & METALS PRIVATE LIMITED",
"HIMACHAL SORANG POWER PRIVATE LIMITED",
"HIMACHAL TEREPENE PRODUCTS PVT LTD",
"HIMACHAL TRADERS PRIVATE LIMITED",
"HIMACHAL WIRE INDUSTRIES PRIVATE LIMITED",
"HIMADRI CREDIT & FINANCE LTD",
"HIMADRI DEALCOM PRIVATE LIMITED",
"HIMADRI FOODS LIMITED",
"HIMADRI HYDRO POWER PROJECT PRIVATE LIMITED",
"HIMADRI INFRASTRUCTURE PRIVATE LIMITED",
"HIMADRI SPECIALITY CHEMICAL LIMITED",
"HIMADRI TRADE MART PRIVATE LIMITED",
"HIMAGIRI HOSPITALS PRIVATE LIMITED",
"HIMAGIRI SYSTEMS PRIVATE LIMITED",
"HIMAIRA GLOBAL PRIVATE LIMITED",
"HIMAJA CONSTRUCTIONS PRIVATE LIMITED",
"HI-MAK PRIVATE LIMITED",
"HIMAL SUPPLY INDIA PRIVATE LIMITED",
"HIMAL TRADE FACILITATORS PRIVATE LIMITED.",
"HIMALAY APPARELS PRIVATE LIMITED",
"HIMALAY PAPTECH PRIVATE LIMITED",
"HIMALAYA AGRO CHEMICALS PRIVATE LIMITED",
"HIMALAYA AGRO PUMPS PRIVATE LIMITED",
"HIMALAYA CABLES PRIVATE. LIMITED",
"HIMALAYA CONSTRUCTION CO.PVT.LTD.",
"HIMALAYA COTTON YARN LIMITED",
"HIMALAYA DRUG COMPANY PRIVATE LIMITED",
"HIMALAYA ELANZA PRIVATE LIMITED",
"HIMALAYA ENTERTAINMENT PRIVATE LIMITED",
"HIMALAYA EXTRUSION LIMITED",
"HIMALAYA FOOD INTERNATIONAL LIMITED",
"HIMALAYA GRANITES LIMITED",
"HIMALAYA GRAPHITES PRIVATE LIMITED",
"HIMALAYA HEAVY LIFTERS I PRIVATE LIMITED",
"HIMALAYA INFRA PROJECTS SUNSHINE",
"HIMALAYA INFRAESTATE PRIVATE LIMITED",
"HIMALAYA INFRAPROJECTS UNIT 2",
"HIMALAYA INTERNATIONAL SCHOOL",
"HIMALAYA INTERTRADE PRIVATE LIMITED",
"HIMALAYA KRAFT PRIVATE LIMITED",
"HIMALAYA MACHINERY PRIVATE LIMITED",
"HIMALAYA MEDITEK PRIVATE LIMITED",
"HIMALAYA MICRO NUTRIENTS PVT.LTD.",
"HIMALAYA OPTICALS PRIVATE LIMITED",
"HIMALAYA OXIDES PRIVATE LIMITED",
"HIMALAYA PACKAGING AND PRINTING PRIVATE LIMITED",
"HIMALAYA PHARMACEUTICALS LIMITED",
"HIMALAYA POLYTECH PRIVATE. LIMITED.",
"HIMALAYA POLYURETHANE PRIVATE LIMITED",
"HIMALAYA PROCESSORS PVT LTD",
"HIMALAYA PUBLISHING HOUSE PRIVATE LIMITED",
"HIMALAYA RASAYAN PVT.LTD.",
"HIMALAYA RESIDENCY PRIVATE LIMITED",
"HIMALAYA STEEL MILL SERVICES PRIVATE LIMITED",
"HIMALAYA TERPENES PRIVATE LIMITED",
"HIMALAYA TRANS - LOGISTICS PRIVATE LIMITED",
"HIMALAYA VISION CRAFTERS PRIVATE LIMITED",
"HIMALAYA WELLNESS COMPANY",
"HIMALAYAHEIGHT CEMENT PRIVATE LIMITED",
"HIMALAYAN AGRICULTURE AND CONSTRUCTIONS PRIVATE LIMITED",
"HIMALAYAN AGROFOODS PRIVATE LIMITED",
"HIMALAYAN ALES PRIVATE LIMITED",
"HIMALAYAN AUTO ERA ( INDIA ) PRIVATE LIMITED",
"HIMALAYAN BASKET PRIVATE LIMITED",
"HIMALAYAN BIO ORGANIC FOODS LIMITED",
"HIMALAYAN CREAMERY PRIVATE LIMITED",
"HIMALAYAN CREST POWER PRIVATE LIMITED",
"HIMALAYAN ENDEAVOUR PVT LTD",
"HIMALAYAN EQUIPMENT MANUFACTURING COMPANY PRIVATE LIMITED",
"HIMALAYAN FLORA AND AROMAS PRIVATE LIMITED",
"HIMALAYAN FLOUR MILL PRIVATE LIMITED",
"HIMALAYAN FOIL SOLUTIONS PRIVATE LIMITED",
"HIMALAYAN FOOD PARK PRIVATE LIMITED",
"HIMALAYAN FOREST RESEARCH INSTITUTE",
"HIMALAYAN FROZEN FOODS LIMITED",
"HIMALAYAN GARHWAL UNIVERSITY",
"HIMALAYAN GOLD BEVERAGES PRIVATE LIMITED",
"HIMALAYAN HELI SERVICES PRIVATE LIMITED",
"HIMALAYAN HORSE CARE PRODUCTS PRIVATE LIMITED",
"HIMALAYAN HOTELS PRIVATE LIMITED",
"HIMALAYAN INFRACORP PRIVATE LIMITED",
"HIMALAYAN INTERNATIONAL PRIVATE LIMITED",
"HIMALAYAN MARITIME SERVICES PRIVATE LIMITED",
"HIMALAYAN MOTORS PRIVATE LIMITED",
"HIMALAYAN ONYX PRIVATE LIMITED",
"HIMALAYAN PACKAGING INDUSTRIES LIMITED.",
"HIMALAYAN PLYWOOD PRIVATE LIMITED",
"HIMALAYAN POLYMER INDUSTRIES",
"HIMALAYAN POWER MACHINE MFG.CO",
"HIMALAYAN PRODUCTS AND INDUSTRIES CORPN PRIVATE LIMITED",
"HIMALAYAN RENEWABLE ENERGY PRIVATE LIMITED",
"HIMALAYAN ROAD CONSTRUCTION PRIVATE LIMITED",
"HIMALAYAN ROCKET STOVE PRIVATE LIMITED",
"HIMALAYAN ROLLING STEEL INDUSTRIES PRIVATE LIMITED",
"HIMALAYAN SOLAR PRIVATE LIMITED",
"HIMALAYAN SPRINGS",
"HIMALAYAN TEA & AGRO PRIVATE LIMITED",
"HIMALAYAN THEATRES PVT LTD",
"HIMALAYAN VILLAGE RESORT PRIVATE LIMITED",
"HIMALAYAVIEW INFRAZONE PRIVATE LIMITED",
"HIMALYA ADVENTURE TOURS PRIVATE LIMITED",
"HIMALYA OPTICAL CENTRE PRIVATE LIMITED",
"HIMALYAN BIOXTRACTS PRIVATE LIMITED",
"HIMALYAN COLLEGE",
"HIMALYAN EXPRESSWAY LIMITED",
"HIMALYAN PLASTICS PRIVATE LIMITED",
"HIMALYAPUTRA AVIATION LIMITED",
"HIMANEE FASHIONS PRIVATE LIMITED",
"HIMANGA MERCANTILES PVT. LTD.",
"HIMANGI FOODS PRIVATE LIMITED",
"HIMANGI PACKAGING PRIVATE LIMITED",
"HIMANI AGENCY PRIVATE LIMITED",
"HIMANI EDUCATION SOCIETY",
"HIMANI INFRACONSTRUCTION PRIVATE LIMITED",
"HIMANI SHIPPING SERVICES PRIVATE LIMITED",
"HIMANSHI ELECTRONICS PRIVATE LIMITED",
"HIMANSHU AGRO ROAD LINES PRIVATE LIMITED",
"HIMANSHU APPARELS",
"HIMANSHU ENGINEERING WORKS",
"HIMANSHU EXTRUSION PRIVATE LIMITED",
"HIMANSHU FEEDS PRIVATE LIMITED",
"HIMANSHU FLOUR MILLS LTD.",
"HIMANSHU FOODS PRIVATE LIMITED",
"HIMANSHU HOSPITAL AND CLINIC PRIVATE LIMITED",
"HIMANSHU METALS PRIVATE LIMITED",
"HIMANSHU PAPER PRIVATE LIMITED",
"HIMANSHU PHARMACEUTICALS PRIVATE LIMITED",
"HIMANSHU RESORTS PRIVATE LIMITED",
"HIMANSU IT SERVICES PRIVATE LIMITED",
"HIMASRI INFRA PRIVATE LIMITED",
"HIMATNAGAR DISTRICT JAIL",
"HIMATNAGAR HEALTHCARE PRIVATE LIMITED",
"HIMATSINGKA AGENCIES PRIVATE LIMITED",
"HIMATSINGKA CHEMICALS PVT. LTD.",
"HIMATSINGKA EXPORTS PRIVATE LIMITED",
"HIMATSINGKA SEIDE LIMITED",
"HIMATSINGKA WOVENS PRIVATE LIMITED",
"HIMAVASINI CARS PRIVATE LIMITED",
"HIMAVASINI MOTORS PRIVATE LIMITED",
"HIMAWARI GLOBAL LINKS PRIVATE LIMITED",
"HIMAX DEVLOPERS PRIVATE LIMITED",
"HIMAYA APPARELS PRIVATE LIMITED",
"HIMAYAM MATRIC HIGHER SECONDARY SCHOOL",
"HIM-BOARDS PVT LTD",
"HIMCON ENGINEERS (INDIA) PRIVATE LIMITED",
"HIMCON ESTATE & DEVELOPERS PRIVATE LIMITED",
"HIMECH EQUIPMENTS PRIVATE LIMITED",
"HIMEDIA LABORATORIES PRIVATE LIMITED",
"HIMENVIRO ENVIRONMENTAL ENGG CO PRIVATE LIMITED",
"HIMESH FOODS PRIVATE LIMITED",
"HIMGANGE GAS EQUIPMENTS PRIVATE LIMITED",
"HIMGHAR UDYOG PRIVATE LIMITED",
"HIMGIRI AUTO FINANCE PRIVATE LIMITED",
"HIMGIRI AUTO INDIA PRIVATE.LIMITED.",
"HIMGIRI AUTOMOBILES PRIVATE LIMITED",
"HIMGIRI BUILDCON & INDUSTRIES LIMITED",
"HIMGIRI CARS PRIVATE LIMITED",
"HIMGIRI CASTINGS PRIVATE LIMITED",
"HIMGIRI ENERGY VENTURES PRIVATE LIMITED",
"HIMGIRI ENTERPRISES PRIVATE LIMITED",
"HIMGIRI FRP COOLING TOWERS PRIVATE LIMITED",
"HIMGIRI GOODS PRIVATE LIMITED",
"HIMGIRI HIRE PURCHASE LIMITED",
"HIMGIRI ISPAT PRIVATE LIMITED",
"HIMGIRI LOGISTICS SERVICES PRIVATE LIMITED",
"HIMGIRI METALS PRIVATE LIMITED",
"HIMGIRI MOTORS PRIVATE LIMITED",
"HIMGIRI PACKS PRIVATE LIMITED",
"HIMGIRI SYNTHETICS PRIVATE LIMITED",
"HIMGIRI VIDYALAYA",
"HIMGIRI ZEE UNIVERSITY",
"HIMIGIRI RASOI",
"HIMIKA TRADELINK PRIVATE LIMITED",
"HIMIL UWAVE RESEARCHCO PRIVATE LIMITED",
"HIMILE MOLDS (INDIA) PRIVATE LIMITED",
"HIMJAL BEVERAGES PRIVATE LIMITED",
"HIMKER KNITS INDIA PRIVATE LIMITED",
"HIMLAND RESORTS PVT LTD",
"HIMNISH LIMITED",
"HIMRAG COIR PRODUCTS PRIVATE LIMITED",
"HIMRAG MARKETING PVT LTD",
"HIMS HEALTH CARE MANAGEMENT PRIVATE LIMITED",
"HIMSAN POLYMER PRIVATE LIMITED",
"HIMSANCHAY CREDIBLE NIDHI LIMITED",
"HIMSHAKTI PROJECTS PRIVATE LIMITED",
"HIMSHIKHA INFRASTRUCTURE PRIVATE LIMITED",
"HIMSKAF SYSTEMS PRIVATE LIMITED",
"HIMSON CHEMICAL INDUSTRIES PRIVATE LIMITED",
"HIMSON ENGINEERING PRIVATE LIMITED",
"HIMSON INDUSTRIAL CERAMIC PRIVATE LIMITED",
"HIMSON KNITTING INDUSTRIES PRIVATE LIMITED",
"HIMSON PETROSYNTHETICS LTD",
"HIMSON PRAKASH TECH PRIVATE LIMITED",
"HIMSON TEXTILE ENGINEERING INDUSTRIES PVT LTD",
"HIMSONS CAST PRIVATE LIMITED",
"HIMSONS PLASTICIZERS PRIVATE LIMITED",
"HIMTECH SALES PVT LTD",
"HIMTEJ INDIA PRIVATE LIMITED",
"HIMTEX TEXTILES PRIVATE LIMITED",
"HIMURA SPORTS PRIVATE LIMITED",
"HIMURVI FORESTRY PRIVATE LIMITED",
"HIMVATI FOODS PRIVATE LIMITED",
"HIN GREEN E-WASTE RECYCLING PRIVATE LIMITED",
"HINA COMMERCIAL PRIVATE LIMITED",
"HINA TRADING AND MANUFACTURING COMPANY PRIVATE LIMITED",
"HINCON FINANCE LTD.",
"HINCON HOLDINGS LIMITED",
"HIND AGRO EXPORTS INDIA PRIVATE LIMITED",
"HIND AIR SERVICES PRIVATE LIMITED",
"HIND ALUMINIUM INDUSTRIES LIMITED",
"HIND AUTOCRANKS PRIVATE LIMITED",
"HIND CARGO MOVERS PRIVATE LIMITED",
"HIND CARPETS PVT LTD",
"HIND CARRIERS PRIVATE LIMITED",
"HIND CERAMICS PVT. LTD",
"HIND CLEARING AND FORWARDING SERVICES PRIVATE LIMITED",
"HIND COMP PRIVATE LIMITED",
"HIND DEFENCE EQUIPMENT PRIVATE LIMITED",
"HIND DIGITAL PRIVATE LIMITED",
"HIND DISTRIBUTORS PRIVATE LIMITED",
"HIND ELASTOMERS PRIVATE LIMITED",
"HIND ELECTRO MECH PRIVATE LIMITED",
"HIND ELECTRONIKA INDIA PRIVATE LIMITED",
"HIND ELEVATORS PRIVATE LIMITED",
"HIND ENERGY & COAL BENEFICATION LIMITED",
"HIND ENERGY AND COAL BENEFICATION (INDIA) LIMITED",
"HIND FILTERS LIMITED",
"HIND FILTERS PRIVATE LIMITED",
"HIND FLUID POWER PRIVATE LIMITED",
"HIND FLYING SOLUTION PRIVATE LIMITED",
"HIND FREIGHT SERVICES PRIVATE LIMITED",
"HIND GRANITES PRIVATE LIMITED",
"HIND HIGH VACUUM COMPANY PRIVATE. LIMITED.",
"HIND HOSIERY MILLS PVT LTD",
"HIND HYDRAULICS AND ENGINEERS HIND FLUID POWER PRIVATE LIMITED",
"HIND ICE & COLD STORAGE PVT LTD",
"HIND INSTITUTE OF MEDICAL SCIENCES",
"HIND LBT INDIA PRIVATE LIMITED",
"HIND LOGISTICS & CARGO (INDIA) PRIVATE LIMITED",
"HIND MATCHES PRIVATE. LIMITED.",
"HIND MEDICAL SERVICES PRIVATE LIMITED",
"HIND METAL & ALLOYS PRIVATE LIMITED",
"HIND METAL SYNDICATE PRIVATE LIMITED",
"HIND METALS PAYROLL",
"HIND MULTI SERVICES PRIVATE LIMITED",
"HIND MUSAFIR AGENCY LIMITED",
"HIND OFFSHORE PRIVATE LIMITED",
"HIND PALACE PVT LTD",
"HIND PAPER BOX PRIVATE LIMITED",
"HIND POLYFABS PRIVATE LIMITED",
"HIND POLYTRADERS PRIVATE LIMITED",
"HIND PORT & HANDLING SERVICES PRIVATE LIMITED",
"HIND PROCESS PRIVATE LIMITED",
"HIND RECTIFIERS LIMITED",
"HIND RECYCLING PRIVATE LIMITED",
"HIND SEVA PARISHAD PUBLIC ENGLISH HIGH SCHOOL AND JR COLLEGE OF SCIENCE AND COMMERCE",
"HIND SPORTS PVT LTD",
"HIND SUTER SHELLAC PRIVATE LIMITED",
"HIND SYNTEX LIMITED",
"HIND TERMINALS PRIVATE LIMITED",
"HIND TOOL INDUSTRIES",
"HIND TOOLS",
"HIND UDYOG PRIVATE LIMITED",
"HIND UNITRADE PRIVATE LIMITED",
"HIND VEGOILS PRIVATE LIMITED",
"HINDAIR PRODUCTS PRIVATE LIMITED",
"HINDALCO INDUSTRIES LIMITED",
"HINDALCO-ALMEX AEROSPACE LIMITED",
"HINDAVI SOLUTION PRIVATE LIMITED",
"HINDBRO PRIVATE LIMITED",
"HINDCAM PRIVATE LIMITED",
"HINDCHEF PRIVATE LIMITED",
"HINDCON CHEMICALS LIMITED",
"HINDCON CHEMICALS PRIVATE LIMITED",
"HINDCON SOLUTIONS PRIVATE LIMITED",
"HINDERER AND MUEHLICH INDIA PRIVATE LIMITED",
"HINDI JR COLLEGE KALYAN",
"HINDIA ENGINEERS PRIVATE LIMITED",
"HINDIKO SOLUTION INDIA PRIVATE LIMITED",
"HINDITRON CORPORATE SYSTEMS PRIVATE LIMITED",
"HINDITRON SERVICES PRIVATE LIMITED",
"HINDKUSH CONSUMER CARE PRODUCTS PRIVATE LIMITED",
"HINDOCARE (INDIA) PRIVATE LIMITED",
"HINDON FILTERS PRIVATE LIMITED",
"HINDON FORGEPRIVATE LIMITED",
"HINDON INDIA PRIVATE LIMITED",
"HINDON MERCANTILE LIMITED",
"HINDON METAFORMS PRIVATE LIMITED",
"HINDOOSTAN MILLS LIMITED",
"HINDPRAKASH CASTOR DERIVATIVES PRIVATE LIMITED",
"HINDPRAKASH GLOBAL PRIVATE LIMITED",
"HINDPRAKASH INDUSTRIES LIMITED",
"HINDPRAKASH OVERSEAS PRIVATE LIMITED",
"HINDPRAKASH TRADELINK PRIVATE. LIMITED.",
"HINDTEK COMPOSITES PRIVATE LIMITED",
"HINDU COLLEGE",
"HINDU INTER COLLEGE ZAMANIA STATION",
"HINDU MISSION HOSPITAL",
"HINDU RAO HOSPITAL",
"HINDUJA ENERGY (INDIA) LIMITED",
"HINDUJA FINANCE LIMITED",
"HINDUJA FOUNDRIES LIMITED",
"HINDUJA GLOBAL SOLUTIONS LIMITED",
"HINDUJA GROUP LIMITED.",
"HINDUJA HEALTHCARE LIMITED",
"HINDUJA HOUSING FINANCE LIMITED",
"HINDUJA INTERNATIONAL",
"HINDUJA LEYLAND FINANCE LIMITED",
"HINDUJA NATIONAL POWER CORPORATION LIMITED",
"HINDUJA PROPERTIES LIMITED",
"HINDUJA REALTY VENTURES LIMITED",
"HINDUJA RENEWABLES ENERGY PRIVATE LIMITED",
"HINDUJA RENEWABLES ONE PRIVATE LIMITED",
"HINDUJA RENEWABLES PRIVATE LIMITED",
"HINDUJA RENEWABLES TWO PRIVATE LIMITED",
"HINDUJA ROOFTOP PRIVATE LIMITED",
"HINDUJA TECH LIMITED",
"HINDUMAL BALMUKUND INVESTMENT CO PRIVATE LIMITED",
"HINDUPUR SOLAR PARK PRIVATE LIMITED",
"HINDUPUR STEEL & ALLOYS PRIVATE LIMITED",
"HINDURAO HOSPITAL",
"HINDUS PHARMA PRIVATE LIMITED",
"HINDUSTAN ACADEMY COLLEGE",
"HINDUSTAN AEGIS LPG LIMITED HALPG",
"HINDUSTAN AERONAUTICS LIMITED",
"HINDUSTAN AEROSYSTEMS PRIVATE LIMITED",
"HINDUSTAN AGRI BUSINESS PRIVATE LIMITED",
"HINDUSTAN AGRO PRODUCTS LIMITED",
"HINDUSTAN AIRCON PRIVATE LIMITED",
"HINDUSTAN ALCOX PRIVATE LIMITED",
"HINDUSTAN ANTIBIOTICS LIMITED",
"HINDUSTAN ASSOCIATED ENGINEERS PVT LTD",
"HINDUSTAN ASSOCIATES PRIVATE LIMITED",
"HINDUSTAN AUTOHOUSE PRIVATE LIMITED",
"HINDUSTAN BEC TECH INDIA PRIVATE LIMITED",
"HINDUSTAN BIOSYNTH LIMITED",
"HINDUSTAN BUILDCON PRIVATE LIMITED",
"HINDUSTAN CABLES LTD",
"HINDUSTAN CANS PRIVATE LIMITED",
"HINDUSTAN CHEMICALS COMPANY",
"HINDUSTAN CLOSURES PRIVATE LIMITED",
"HINDUSTAN CLUB KOLKATA",
"HINDUSTAN COAL MOVERS PRIVATE LIMITED",
"HINDUSTAN COATINGS PRIVATE LIMITED",
"HINDUSTAN COCA COLA HOLDINGS PRIVATE LIMITED",
"HINDUSTAN COCA-COLA BEVERAGES PRIVATE LIMITED",
"HINDUSTAN COCA-COLA MARKETING COMPANY PRIVATE LIMITED",
"HINDUSTAN COILS LIMITED",
"HINDUSTAN COLAS PRIVATE LIMITED",
"HINDUSTAN COLLEGE",
"HINDUSTAN COMMERCIAL COMPANY LIMITED",
"HINDUSTAN COMPOSITES LIMITED",
"HINDUSTAN CONCRETE SOLUTION INDIA PRIVATE LIMITED",
"HINDUSTAN CONSTRUCTION COMPANY LIMITED",
"HINDUSTAN CONSTRUCTION CORPORATION",
"HINDUSTAN CONTROLS & EQUIPMENT PRIVATE LIMITED",
"HINDUSTAN COPPER LIMITED",
"HINDUSTAN CYCLES AND TUBES PRIVATE LIMITED",
"HINDUSTAN DEALERS LIMITED",
"HINDUSTAN DOCK YARD PRIVATE LIMITED",
"HINDUSTAN DYEING AND PRINTING MILLS PRIVATE LIMITED",
"HINDUSTAN ENGINEERING COLLEGE",
"HINDUSTAN ENGINEERING PRIVATE LIMITED",
"HINDUSTAN ENGINEERS PRIVATE. LIMITED.",
"HINDUSTAN ENTERPRISES PRIVATE LIMITED",
"HINDUSTAN ENVIRO LIFE PROTECTION SERVICES LIMITED",
"HINDUSTAN EPC CO PRIVATE LIMITED",
"HINDUSTAN EPC COMPANY LIMITED",
"HINDUSTAN EQUIPMENTS PRIVATE LIMITED",
"HINDUSTAN EXPORT & IMPORT CORPORATION PRIVATE LIMITED",
"HINDUSTAN FACILITIES PRIVATE LIMITED",
"HINDUSTAN FARMDIRECT INGREDIENTS PRIVATE LIMITED",
"HINDUSTAN FASTENERS PRIVATE LIMITED",
"HINDUSTAN FEEDS MANUFACTURING COMPANY SATARA",
"HINDUSTAN FERRO ALLOY INDUSTRIES PRIVATE LIMITED",
"HINDUSTAN FERRO ALLOYS PRIVATE LIMITED",
"HINDUSTAN FERTILIZER CORPORATION LIMITED",
"HINDUSTAN FIBRES LIMITED (TRANSFER FROM DELHI TO RAJASTHAN)",
"HINDUSTAN FIELD SERVICES PRIVATE LIMITED",
"HINDUSTAN FIRE PROTECTION PRIVATE LIMITED",
"HINDUSTAN FLEX LIMITED",
"HINDUSTAN FLOAT GLASS PRIVATE LIMITED",
"HINDUSTAN FLUORO CARBONS LTD.",
"HINDUSTAN FOODS LIMITED",
"HINDUSTAN FORGE PRIVATE LIMITED",
"HINDUSTAN GLASS WORKS LIMITED",
"HINDUSTAN GOLD INDUSTRIES PRIVATE LIMITED",
"HINDUSTAN GOODS CARRIERS PVT LTD",
"HINDUSTAN GUM AND CHEMICALS LIMITED",
"HINDUSTAN HARDY SPICER LIMITED",
"HINDUSTAN HATCHERIES PRIVATE LIMITED",
"HINDUSTAN HERBALS LIMITED",
"HINDUSTAN HOUSING COMPANY LIMITED",
"HINDUSTAN HYDRAULICS PRIVATE LIMITED",
"HINDUSTAN INFRALOG PRIVATE LIMITED",
"HINDUSTAN INFRAPOWER PRIVATE LIMITED",
"HINDUSTAN INOX LIMITED",
"HINDUSTAN INSTITUE OF TECHNOLOGY AND SCIENCE",
"HINDUSTAN INSTITUTE OF ENGINEERING TECHN",
"HINDUSTAN INSTITUTE OF MARITIME TRAINING",
"HINDUSTAN INSTITUTE OF TECHNOLOGY AND SCIENCE",
"HINDUSTAN INSURANCE BROKERS LIMITED",
"HINDUSTAN INTERNATIONAL SCHOOL",
"HINDUSTAN LABORATORIES LIMITED",
"HINDUSTAN LATEX FAMILY PLANNING PROMOTION TRUST (HLFPPT)",
"HINDUSTAN LIGHTINGS PRIVATE LIMITED",
"HINDUSTAN LIQUIDS PRIVATE LIMITED",
"HINDUSTAN LOGISTICS PRIVATE LIMITED",
"HINDUSTAN MARBLE PRIVATE LIMITED",
"HINDUSTAN MEDIA VENTURES LIMITED",
"HINDUSTAN MEDICINES PRIVATE LIMITED",
"HINDUSTAN MINERAL PRODUCTS COMPANY LIMITED",
"HINDUSTAN MINT AND AGRO PRODUCTS PRIVATE LIMITED",
"HINDUSTAN MONOMERS PRIVATE LIMITED",
"HINDUSTAN MOTOR FINANCE CORPORATION LIMITED",
"HINDUSTAN NUTRIN PRIVATE LIMITED",
"HINDUSTAN OIL EXPLORATION COMPANY LIMITED",
"HINDUSTAN OIL SEALS MFG COMPANY",
"HINDUSTAN ORGANIC CHEMICALS LIMITED",
"HINDUSTAN PENCILS PRIVATE LIMITED",
"HINDUSTAN PETROLEUM CORPORATION LIMITED",
"HINDUSTAN PHOSPHATES PRIVATE LIMITED",
"HINDUSTAN PIPES AND FITTINGS PRIVATE LIMITED",
"HINDUSTAN PLATINUM PRIVATE LIMITED",
"HINDUSTAN POLY FOAMS PRIVATE LIMITED",
"HINDUSTAN PORTFOLIO PRIVATE LTD",
"HINDUSTAN PORTS PRIVATE LIMITED",
"HINDUSTAN POWER PRODUCTS PRIVATE LIMITED",
"HINDUSTAN POWERPROJECTS PRIVATE LIMITED",
"HINDUSTAN PREFAB LIMITED",
"HINDUSTAN PRESSINGS PRIVATE LIMITED",
"HINDUSTAN PUMPS AND ELECTRICAL ENGINEERING PRIVATE LIMITED.",
"HINDUSTAN RADIATORS AND HEAT EXCHANGERS PRIVATE LIMITED",
"HINDUSTAN RASAYAN PRIVATE LIMITED",
"HINDUSTAN RICE EXPORTS PRIVATE LIMITED",
"HINDUSTAN RUBBERS INDUSTRIES PRIVATE LIMITED",
"HINDUSTAN SAFE PACK PRIVATE LIMITED",
"HINDUSTAN SALES PRIVATE LIMITED",
"HINDUSTAN SALTS LIMITED",
"HINDUSTAN SEEDS PRIVATE LIMITED",
"HINDUSTAN SHIPYARD COLLEGE",
"HINDUSTAN SHIPYARD LIMITED",
"HINDUSTAN SIGNAGESS PRIVATE LIMITED",
"HINDUSTAN SOFT EDUCATION LIMITED",
"HINDUSTAN SPIRITS LIMITED",
"HINDUSTAN STEELWORKS CONSTRUCTION LIMITED",
"HINDUSTAN STORAGE & DISTRIBUTION COMPANY LTD",
"HINDUSTAN SWITCH PRIVATE LIMITED",
"HINDUSTAN SYRINGES AND MEDICAL DEVICES LIMITED",
"HINDUSTAN TECHNOCAST PRIVATE LIMITED",
"HINDUSTAN TECHNOSOL PRIVATE LIMITED",
"HINDUSTAN THERAPEUTICS PRIVATE LIMITED",
"HINDUSTAN THERMAL-EPC COMPANY PRIVATE LIMITED",
"HINDUSTAN THOMPSON ADVERTISING LIMITED",
"HINDUSTAN THOMPSON ASSOCIATES PRIVATE LIMITED",
"HINDUSTAN TIN WORKS LIMITED",
"HINDUSTAN TOOLS AND ENGINEERING WORKS PVT LTD",
"HINDUSTAN TRADE OVERSEAS PRIVATE LIMITED",
"HINDUSTAN TRADECOM PRIVATE LIMITED",
"HINDUSTAN TRADETECH PRIVATE LIMITED",
"HINDUSTAN TRUST PRIVATE LIMITED",
"HINDUSTAN UNILEVER FOUNDATION",
"HINDUSTAN UNILEVER LIMITED",
"HINDUSTAN URVARAK & RASAYAN LIMITED",
"HINDUSTAN VIBROTECH PRIVATE LIMITED",
"HINDUSTAN WASTE TREATMENT PRIVATE LIMITED",
"HINDUSTAN WELLNESS PRIVATE LIMITED",
"HINDUSTAN WIRES LTD",
"HINDUSTAN ZINC LIMITED",
"HINDUSTAN ZIRCON",
"HINDUSTANI CONVENT CHURCH HIGH SCHOOL & JR COLLEGE",
"HINDUSTHAN ANIMAL CARE PRIVATE LIMITED",
"HINDUSTHAN CALCINED METALS PRIVATE LIMITED",
"HINDUSTHAN COLLEGE OF ARTS & SCIENCE",
"HINDUSTHAN COLLEGE OF ENGINEERING AND TECHNOLOGY",
"HINDUSTHAN CONSTRUCTION MACHINERIES & EQUIPMENTS PRIVATE LIMITED",
"HINDUSTHAN ELECTRIC CORPORATION PRIVATE LIMITED",
"HINDUSTHAN ENGINEERING & INDUSTRIES LIMITED",
"HINDUSTHAN HEAVY ELECTRICALS PRIVATE. LIMITED.",
"HINDUSTHAN HOSPITAL",
"HINDUSTHAN ICE & COLD STORAGE CO LTD",
"HINDUSTHAN INFRA AVENUES LIMITED",
"HINDUSTHAN INFRASTRUCTURE PROJECTS & ENGINEERING PRIVATE LIMITED",
"HINDUSTHAN LACE MFG CORPN PVT LTD",
"HINDUSTHAN LOHA LIMITED",
"HINDUSTHAN MALLEABLES & FORGINGS LIMITED",
"HINDUSTHAN MICROFINANCE PRIVATE LIMITED",
"HINDUSTHAN MISWACO LIMITED",
"HINDUSTHAN POLYTECHNIC COLLEGE",
"HINDUSTHAN SCHOOL OF ARCHITECTURE",
"HINDUSTHAN SPECIALITY CHEMICALS LIMITED",
"HINDUSTHAN TECHNOLOGIES PRIVATE LIMITED",
"HINDUSTHAN TRANSFORMERS (INDIA) PRIVATE LIMITED",
"HINDUSTHAN UDYOG LIMITED",
"HINDUSTHAN URBAN INFRASTRUCTURE LIMITED",
"HINDUSTHAN VIDYUT PRODUCTS LIMITED",
"HINDVA BUILDERS",
"HINDWARE HOME INNOVATION LIMITED",
"HINDWARE HOME RETAIL PRIVATE LIMITED",
"HINDWARE LIMITED",
"HINDYS LAB PRIVATE LIMITED",
"HINE HYDRAULICS INDIA PRIVATE LIMITED",
"HINES INDIA REAL ESTATE PRIVATE LIMITED",
"HINGANGHAT INFRASTRUCTURE PRIVATE LIMITED",
"HINGANGHAT INTEGRATED TEXTILE PARK PRIVATE LIMITED",
"HINGLAJ FOOD PRODUCTS PRIVATE LIMITED",
"HINGLAJMATA NAGARI SAH. PATSANSTHA MARYA",
"HINGNA KELZAR ROADWAYS PRIVATE LIMITED",
"HINGORANI AIR PRODUCTS PVT LTD",
"HINIMPEX PRIVATE LIMITED",
"HINJAWADI INFRADEVELOPMENT PRIVATE LIMITED",
"HINJEWADI TECHPARK PRIVATE LIMITED",
"HINO MOTORS SALES INDIA PRIVATE LIMITED",
"HINODE TECHNOLOGIES PRIVATE LIMITED",
"HINOTE SYSTEMS PRIVATE LIMITED",
"HINPA INCORPORATION",
"HINSHITSU MANUFACTURING PRIVATE LIMITED",
"HINSHITSU TECHNOLOGY PRIVATE LIMITED",
"HINSUI ENGINEERING PRIVATE LIMITED",
"HINTANNIA PLASTICS PVT LTD",
"HINTASTICA PRIVATE LIMITED",
"HI-NUC ENGINEERING PRIVATE LIMITED",
"HIOKI INDIA PRIVATE LIMITED",
"HIOX SOFTWARES PRIVATE LIMITED",
"HIP BAR P LIMITED",
"HIP TRAVELS PRIVATE LIMITED",
"HIPAAS INFOTECH PRIVATE LIMITED",
"HIPAC AUTO CYLINDERS PRIVATE LIMITED",
"HI-PACK FILMS INDIA PRIVATE LIMITED",
"HIPACK INDUSTRIES PRIVATE LIMITED",
"HIPAD TECHNOLOGY INDIA PRIVATE LIMITED",
"HIPAY FX SERVICES PRIVATE LIMITED",
"HIPEX FOREX PRIVATE LIMITED",
"HI-PICK PRODUCTS PRIVATE LIMITED",
"HIPOINT CONNECT PRIVATE LIMITED",
"HI-POWER FERTILIZERS & CHEMICALS PRIVATE LIMITED",
"HIPOWER SUPPORT CENTRE PRIVATE LIMITED",
"HIPOX TRADELINK PRIVATE LIMITED",
"HIPPO INNOVATIONS PRIVATE LIMITED",
"HIPPO LABS PRIVATE LIMITED",
"HIPPO SPECIAL STEELS PRIVATE LIMITED",
"HIPPOCAMPUS LEARNING CENTRES PRIVATE LIMITED",
"HIPPOCRAT BIOTECH PRIVATE LIMITED",
"HIPPOFLEX INTERNATIONAL PRIVATE LIMITED",
"HI-PRECISION ALLOYS PRIVATE LIMITED",
"HI-PRINT ELECTROMACK PRIVATE LIMITED",
"HIPRO CERAAMICS PRIVATE LIMITED",
"HIPRO TOOLS PRIVATE LIMITED",
"HIPSTERSG INDIA PRIVATE LIMITED",
"HI-Q ENTERPRISES PRIVATE LIMITED",
"HI-Q FOOD PRODUCTS PRIVATE LIMITED",
"HIQ POWER ASSOCIATES PRIVATE LIMITED",
"HI-QUALITY FOODS & BEVERAGES PRIVATE LIMITED",
"HIRA AUTOMATION PRIVATE LIMITED",
"HIRA AUTOMOBILES LIMITED HAL",
"HIRA COACH PRIVATE LIMITED",
"HIRA COAL MINES PRIVATE LIMITED",
"HIRA COMBINES PRIVATE LIMITED",
"HIRA ELECTRO SMELTERS PRIVATE LIMITED",
"HIRA FERRO ALLOYS LIMITED",
"HIRA INFRA-TEK LIMITED",
"HIRA INTERNATIONAL LIMITED",
"HIRA JEWELLERS PVT LTD",
"HIRA LALL AND SON (I) ANUPAM PRIVATE LIMITED",
"HIRA NAND GHANSHYAM DASS PRIVATE LIMITED",
"HIRA PACKAGING SOLUTIONS",
"HIRA PANNA COLLECTIONS PRIVATE LIMITED",
"HIRA PANNA JEWELLERS PRIVATE LIMITED",
"HIRA PHARMA DISTRIBUTORS PRIVATE LIMITED",
"HIRA POLYMERS PRIVATE LIMITED",
"HIRA POLYPRINTS PRIVATE LIMITED",
"HIRA POWER AND STEELS LIMITED",
"HIRA PRINT SOLUTIONS PRIVATE LIMITED",
"HIRA ROLLER AND FLOUR MILLS PRIVATE LIMITED",
"HIRA SINGH SOBTI AND ASSOCIATES PRIVATE LIMITED",
"HIRA STEELS LIMITED",
"HIRA SWEETS & CONFECTIONARY PRIVATE LIMITED",
"HIRA SWEETS MANUFACTURING PRIVATE LIMITED",
"HIRA SYNTEX PRIVATE LIMITED",
"HIRA TECH SOFTWARE SOLUTIONS INDIA PRIVATE LIMITED",
"HIRA TECHNOLOGIES PRIVATE LIMITED",
"HIRA TECHNOSOFT PRIVATE LIMITED",
"HIRA WALRAVEN INSTALLATIONS SYSTEMS PRIVATE LIMITED",
"HIRACO INDIA PRIVATE LIMITED",
"HIRACO RENEWABLE ENERGY PRIVATE. LIMITED.",
"HIRADHAN MOTORS PRIVATE LIMITED",
"HIRAI INSTITUTE OF NURSING EDUCATION GNM",
"HIRAJULI TEA COMPANY PRIVATE LIMITED",
"HIRAK LEASINGAND INVESTMENT PVT LTD",
"HIRAL CLASSIC PROPERTIES PRIVATE LIMITED",
"HIRAL FOODS PRIVATE LIMITED",
"HIRAL LABS LIMITED",
"HIRAL TEKTRONIX PRIVATE LIMITED",
"HIRALAL AGENCIES PRIVATE LIMITED",
"HIRALAL AGRO PRODUCTS PRIVATE LIMITED",
"HIRALAL DISHED-ENDS WORKS PRIVATE LIMITED",
"HIRALAL HEAVY ENGINEERING WORKS PRIVATE LIMITED",
"HIRALAL INDUSTRIAL TECHNOLOGIES PRIVATE LIMITED",
"HIRALAL MAJUMDER COLLEGE FOR WOMN",
"HIRALAL MAZUMDER MEMORIAL COLLEGE FOR WOMEN",
"HIRALAL MOTORS PRIVATE LIMITED",
"HIRAMAN DEVELOPERS PRIVATE LIMITED",
"HIRAMAN INFRASTRUCTURE PRIVATE LIMITED",
"HIRAMATI EXPORT PRIVATE LIMITED",
"HIRAMEKI SOLUTIONS INDIA PRIVATE LIMITED",
"HIRAMOTI TEX CHEM PVT LTD",
"HIRAN AGROCEUTICALS PRIVATE LIMITED",
"HIRANANDANI CONSTRUCTIONS PRIVATE LIMITED",
"HIRANANDANI DEVELOPERS",
"HIRANANDANI FINANCIAL SERVICES PRIVATE LIMITED",
"HIRANANDANI FOUNDATION SCHOOL INTERNATIONAL",
"HIRANANDANI HEALTHCARE PRIVATE LIMITED",
"HIRANANDANI PROPERTIES PRIVATE LIMITED",
"HIRANANDANI REALTORS PRIVATE LIMITED",
"HIRANANDANI UPSCALE SCHOOL",
"HIRANI VENTURES PRIVATE LIMITED",
"HIRANMAYEE ENTERPRISES",
"HIRANMAYEE RUBBER PRIVATE LIMITED",
"HIRANYA AGRI GENETIC SEEDS PRIVATE LIMITED",
"HIRANYA BUILDERS PRIVATE. LIMITED.",
"HIRANYA ENGINEERING PRIVATE LIMITED",
"HIRANYA INDIA JEWEL PRIVATE LIMITED",
"HIRANYA RAJ AGROCOM PRIVATE LIMITED",
"HIRANYA STOCKS AND SECURITIES PRIVATE LIMITED",
"HIRASONS GOLD AND GEMS PRIVATE LIMITED",
"HIRASONS INDUSTRIES PRIVATE LIMITED",
"HIRAVATI MARINE PRODUCTS PRIVATE LIMITED",
"HIRAWAT ELECTRICALS PRIVATE LIMITED",
"HIRAWAT'S FASHION PRIVATE LIMITED",
"HIRE A PRO CONSTRUCTION",
"HIRE IT PEOPLE PRIVATE LIMITED",
"HI-REACH CONSTRUCTION EQUIPMENTS PRIVATE LIMITED",
"HIREANDBUILD TECHNOLOGY SERVICES PRIVATE LIMITED",
"HIRECRAFT SOFTWARE PRIVATE LIMITED",
"HIREGENICS INDIA LLP",
"HIREGOUDAR AUTOMOBILES PRIVATE LIMITED",
"HIRE-IT TECHNOLOGIES PRIVATE LIMITED",
"HIREN ALUMINIUM LIMITED",
"HIREN BROTHERS INVESTMENT COMPANY PRIVATE LIMITED",
"HIREN HOLDINGS PRIVATE LIMITED",
"HIREN M DIWAN & CO",
"HIREN TEXTURISERS PRIVATE LIMITED",
"HIREPRO CONSULTING PRIVATE LIMITED",
"HIRERIGHT BACKGROUND SCREENING INDIA LLP",
"HIRESAFE VERIFICATION SERVICES INDIA PRIVATE LIMITED",
"HIREXA SOLUTIONS PRIVATE LIMITED",
"HIRFAL INTERIORS PRIVATE LIMITED",
"HIRING PARTNERS HR SOLUTIONS PRIVATE LIMITED",
"HIRINGHUT SOLUTIONS PRIVATE LIMITED",
"HIRISE FACILITY MANAGEMENT PRIVATE LIMITED",
"HIRISE HOSPITALITY PRIVATE LIMITED",
"HIRISE INFRACON LIMITED",
"HIRJI LOGIPACK PRIVATE LIMITED",
"HIRKANI MULTIVENTURES PRIVATE LIMITED",
"HIRLEKAR PRECISION",
"HIRO NISHA SYSTEMS PVT LTD",
"HI-ROCK CONSTRUCTION PRIVATE LIMITED",
"HIROHAMA INDIA PRIVATE LIMITED",
"HIROSE ELECTRIC INDIA PRIVATE LIMITED",
"HIROTEC INDIA PRIVATE LIMITED",
"HIROTEC MARK EXHAUST SYSTEMS PRIVATE LIMITED",
"HIRSCHVOGEL COMPONENTS INDIA PRIVATE LIMITED",
"HIRTHIK BUILDERS PRIVATE LIMITED",
"HIS AND HERS INDIA APPARELS PRIVATE LIMITED",
"HIS EYENESS OPHTHALMICS PRIVATE LIMITED",
"HIS GRACE MANAGEMENT PRIVATE LIMITED",
"HIS PUMPS & SYSTEMS PRIVATE LIMITED",
"HISAN MARKETING LIMITED",
"HISAR AUTO ENGINEERING PRIVATE LIMITED",
"HISAR EXIM PRIVATE LIMITED",
"HISAR LOGISTICS PRIVATE LIMITED",
"HISAR METAL INDUSTRIES LIMITED",
"HISAR MOTORS PRIVATE LIMITED",
"HISAR PAPER PRODUCTS PVT LTD",
"HISAR PROPERTIES PRIVATE LIMITED",
"HISAR SPINNING MILLS LIMITED",
"HISAR STEELS PRIVATE LIMITED",
"HISENSE GLOBAL TRADES PRIVATE LIMITED",
"HISENSE INDIA PRIVATE LIMITED",
"HISHIMO PHARMACEUTICALS PRIVATE LIMITED",
"HI-SHINE INKS PRIVATE LIMITED",
"HI-SKY PROMOTERS PRIVATE LIMITED",
"HISLOP COLLEGE",
"HISOA ELECTRONIC PRIVATE LIMITED",
"HISP INDIA INFO SYSTEMS PRIVATE LIMITED",
"HISPAN DEVELOPERS PRIVATE LIMITED",
"HISPAN ENGINEERS PRIVATE LIMITED",
"HISPANIC HORIZONS PRIVATE LIMITED",
"HI-SPEED DRILLING SOLUTIONS INDIA PRIVATE LIMITED",
"HI-SPEED LOGISTICS PRIVATE LIMITED",
"HI-SPEED MACHINING INDIA PRIVATE LIMITED",
"HISSAR PIPES PRIVATE LIMITED",
"HISSAR ROLLER FLOUR MILLS PRIVATE LIMITED",
"HISSAR UDYOG PRIVATE LIMITED",
"HISSARIA HYDROCOLLOIDS PRIVATE LIMITED",
"HISTOGENETICS (INDIA) PRIVATE LIMITED",
"HISTORIC RESORT HOTELS PRIVATE LIMITED",
"HI-STYLE INDIA PRIVATE LIMITED",
"HI-SUN FOREX AND ALLIED SERVICES PRIVATE LIMITED",
"HITA LIFE VENTURES PRIVATE LIMITED",
"HITA LIFE VENTURES PRIVATE. LIMITED.",
"HITACHI ASTEMO BRAKE SYSTEMS INDIA PRIVATE LIMITED",
"HITACHI ASTEMO CHENNAI PRIVATE LIMITED",
"HITACHI ASTEMO FIE PRIVATE LIMITED",
"HITACHI ASTEMO GURUGRAM POWERTRAIN SYSTEMS PRIVATE LIMITED",
"HITACHI ASTEMO HARYANA PRIVATE LIMITED",
"HITACHI ASTEMO INDIA PRIVATE LIMITED",
"HITACHI ASTEMO RAJASTHAN BRAKE SYSTEMS PRIVATE LIMITED",
"HITACHI AUTOMOTIVE SYSTEMS PUNE INDIA PRIVATE LIMITED",
"HITACHI DATA SYSTEMS INDIA PRIVATE LIMITED",
"HITACHI ENERGY INDIA LIMITED",
"HITACHI ENERGY TECHNOLOGY SERVICES PRIVATE LIMITED",
"HITACHI HI REL POWER ELECTRONICS PRIVATE LIMITED",
"HITACHI HIGH-TECH INDIA PRIVATE LIMITED",
"HITACHI HIGH-TECHNOLOGIES INDIA PRIVATE LIMITED",
"HITACHI INDIA PRIVATE LIMITED",
"HITACHI LIFT INDIA PRIVATE LIMITED",
"HITACHI MGRM NET LIMITED",
"HITACHI PAYMENT SERVICES PRIVATE LIMITED",
"HITACHI RAIL STS INDIA PRIVATE LIMITED",
"HITACHI SOLUTIONS INDIA PRIVATE LIMITED",
"HITACHI SYSTEMS INDIA PRIVATE LIMITED",
"HITACHI TERMINAL SOLUTIONS INDIA PRIVATE LIMITED",
"HITACHI VANTARA INDIA PRIVATE LIMITED",
"HITACHI DIGITAL SERVICES INDIA PRIVATE LIMITED",
"HITACHI ZOSEN INDIA PRIVATE LIMITED",
"HITAISHI CREATIVE ENTERPRISES PRIVATE LIMITED",
"HITAISHI HOSPITALS PRIVATE LIMITED",
"HITAISHI KK MANUFACTURING COMPANY PRIVATE LIMITED",
"HITAISHI KREATIV KRAFT UDYOG LTD",
"HITAISHI PUBLISHERS PRIVATE LIMITED",
"HITAM TRADING PRIVATE LIMITED",
"HITANSH FOOD PROCESSORS PRIVATE LIMITED",
"HITARG AGRITRADE COMMODITIES PRIVATE LIMITED",
"HITARTH ENTERPRISES PRIVATE LIMITED",
"HITASHI RUBBER PRIVATE LIMITED",
"HITASHI SERVICES PRIVATE LIMITED",
"HITASOFT TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"HITAWALA CONSTRUCTIONS PRIVATE LIMITED",
"HITC TRAVELS PRIVATE LIMITED",
"HITCHAN PROJECT PRIVATE LIMITED",
"HITCHCON CONSTRUCTION (INDIA)PVT LTD",
"HITCO CERAMICS (INDIA) PRIVATE LIMITED",
"HITCO ELECTRICALS PRIVATE LIMITED",
"HITCO INVESTMENTS PVT LTD",
"HITCOLUS FOOTWEAR PRIVATE LIMITED",
"HITEC CAARTONS INDIA PRIVATE LIMITED",
"HI-TEC DIE CAST PRIVATE LIMITED",
"HI-TEC MATFLOW PRIVATE LIMITED",
"HI-TEC METAL POWDERS PRIVATE LIMITED",
"HITEC PUMP INDUSTRIES PRIVATE LIMITED",
"HI-TEC ROCKFIBRE PRIVATE LIMITED",
"HI-TECH ACCURATE COMMUNICATION PRIVATE LIMITED",
"HITECH AGPRO PRIVATE LIMITED",
"HI-TECH AGRO FOOD PRIVATE LIMITED",
"HI-TECH ALUCAST PRIVATE LIMITED",
"HI-TECH APPARATUS PRIVATE LIMITED",
"HI-TECH ARCHITECTURAL (I) FABRICATORS PRIVATE LIMITED",
"HI-TECH BEARINGS PVT LTD",
"HI-TECH BELTS PRIVATE LIMITED",
"HITECH BIJLEE PRODUCTS PRIVATE LIMITED",
"HI-TECH BLOW MOULDERS PRIVATE LIMITED",
"HI-TECH BOILERS PRIVATE LIMITED",
"HI-TECH BUILDERS PRIVATE LIMITED",
"HI-TECH BUILDMART PRIVATE LIMITED",
"HITECH CELLPHONE PRIVATE LIMITED",
"HI-TECH CHEMICALS PRIVATE LIMITED",
"HI-TECH CHEMO EQUIP PRIVATE LIMITED",
"HITECH CIVIL ENGINEERS PRIVATE LIMITED",
"HI-TECH COMPANY SOFTWARE SOLUTIONS CHENNAI PRIVATE LIMITED",
"HITECH COMPETENT BUILDERS PRIVATE LIMITED",
"HITECH COMPRINT PRIVATE LIMITED",
"HITECH CONCRETE SOLUTIONS CHENNAI PRIVATE LIMITED",
"HITECH CONSTRUCTION AND DEVELOPERS PRIVATE LIMITED",
"HITECH CORPORATION LIMITED",
"HI-TECH DESIGNS PVT LTD",
"HI-TECH DIGITAL PLATES INDIA PRIVATE LIMITED",
"HI-TECH DIGITAL SOLUTIONS LLP",
"HITECH DIGITAL WORLD PRIVATE LIMITED",
"HITECH DYNAMIC CONTROLS PRIVATE LIMITED",
"HI-TECH EDIFICE PRIVATE LIMITED",
"HI-TECH ELECTRIFICATION ENGINEERS PRIVATE LIMITED",
"HITECH ELECTROCOMPONENTS PRIVATE LIMITED",
"HI-TECH ENGINEERING INDUSTRIES",
"HI-TECH ENGINEERING PRODUCTS PRIVATE LIMITED",
"HI-TECH ENGINEERS & BUILDERS PRIVATE LIMITED",
"HI-TECH ENGINEERS (GUJ) PVT LTD",
"HITECH ENGINEERS AND CONSULTANTS PRIVATE LIMITED",
"HITECH ENVIRO ENGINEERS & CONSULTANTS PRIVATE LIMITED",
"HITECH ERECTORS PRIVATE LIMITED",
"HI-TECH ESTATES AND PROMOTERS PRIVATE LIMITED",
"HITECH EXTRUSION LLP",
"HI-TECH FASTENERS INDIA PRIVATE LIMITED",
"HI-TECH FITFOOT AGENCIES PRIVATE LIMITED",
"HI-TECH FORGINGS (BANGALORE) PRIVATE LIMITED",
"HI-TECH FROZEN FACILITIES PRIVATE LIMITED",
"HITECH FURNISHINGS PRIVATE LIMITED",
"HI-TECH GLOBAL INFRASTRUTURE PRIVATE LIMITED",
"HI-TECH GLOBAL PRIVATE LIMITED",
"HITECH GUARDING PRIVATE LIMITED",
"HITECH HATCH FRESH PRIVATE LIMITED",
"HITECH HEALTH CARE PVT. TLD.",
"HITECH HUMAN CAPITAL PRIVATE LIMITED",
"HI-TECH HYDRAULIC ENGINEERS",
"HI-TECH IMAGE SOLUTIONS PRIVATE LIMITED",
"HI-TECH INDIA EQUIPMENTS PRIVATE LIMITED",
"HITECH INDUSTRIAL SUPPLIERS INDIA PRIVATE LIMITED",
"HI-TECH INFORMATION & MARKETING PVT LTD",
"HI-TECH INFRAPROJECTS (INDIA) PRIVATE LIMITED",
"HITECH INKJET PRIVATE LIMITED",
"HITECH INSULATORS PRIVATE LIMITED",
"HITECH INSURANCE BROKING SERVICES LIMITEDCAT",
"HI-TECH INVESTMENT CASTINGS LIMITED",
"HI-TECH INVESTMENT CASTINGS PRIVATE LIMITED",
"HITECH IRON FOUNDRY PRIVATE LIMITED",
"HITECH LIGHTS LIMITED",
"HITECH LITHO PRIVATE LIMITED",
"HITECH LOGISTICS LIMITED",
"HITECH MEDIASOLUTIONS PRIVATE LIMITED",
"HI-TECH MEDICARE DEVICES PRIVATE LIMITED",
"HITECH MEDICARE HOSPITAL",
"HI-TECH META CHEMICAL PRIVATE LIMITED",
"HITECH METAL CASTING PRIVATE LIMITED",
"HITECH MOTORS AND AUTOMOBILES PRIVATE LIMITED",
"HITECH MOULDS",
"HITECH MULTISPECIALITY HOSPITALS PRIVATE LIMITED",
"HITECH NETWORKS INDIA PRIVATE LIMITED",
"HITECH NON WOVEN PRIVATE LIMITED",
"HITECH NUTRISOL PRIVATE LIMITED",
"HITECH NUTRITIONS PRIVATE LIMITED",
"HI-TECH OFF SET PRIVATE LIMITED",
"HI-TECH OTTO BUSHINGS PRIVATE LIMITED",
"HITECH PESTCONTROL SERVICES PRIVATE LIMITED",
"HITECH PLASTOCHEM UDYOG PRIVATE LIMITED",
"HI-TECH PLYWOOD PRIVATE LIMITED",
"HI-TECH POLYPLAST NAGPUR PRIVATE LIMITED",
"HI-TECH POMO & AGRI PRODUCTION CONSULTANCY PRIVATE LIMITED",
"HI-TECH POWER AND STEEL LIMITED",
"HI-TECH POWER SYSTEMS",
"HITECH PRINT SYSTEMS LIMITED",
"HI-TECH PRINTING SERVICES PRIVATE LIMITED",
"HITECH PROAUDIO INDIA PRIVATE LIMITED",
"HITECH PRODUCTS PRIVATE LTD",
"HITECH PROJECTS PRIVATE LIMITED",
"HI-TECH RADIATORS PRIVATE LIMITED",
"HITECH RECRUITMENT AND TRAINING SERVICES PRIVATE LIMITED",
"HI-TECH REFRIGERATION SERVICES PRIVATE LIMITED",
"HITECH REFRIGRATION PRIVATE LIMITED",
"HITECH RENEWABLE ENERGY PRIVATE LIMITED",
"HI-TECH RESIDENCY PRIVATE LIMITED",
"HI-TECH RESOURCE MANAGEMENT LIMITED",
"HI-TECH ROBOTIC SYSTEMZ LIMITED",
"HI-TECH ROCK PRODUCTS & AGGREGATES LIMITED",
"HITECH ROLLING BALLS PRIVATE LIMITED",
"HITECH SAW LIMITED",
"HI-TECH SCAFFOLDING PRIVATE LIMITED",
"HITECH SECURITY SYSTEMS FIRE SAFETY SYSTEMS",
"HI-TECH SERVICES",
"HITECH SOLUTIONS PRIVATE LIMITED",
"HITECH SPECIALITIES SOLUTIONS LIMITED",
"HI-TECH SPECIALITY FABRICS (EXPORTS)PVT LTD",
"HITECH SPICES PRIVATE LIMITED",
"HI-TECH SURFACTANTS PRIVATE LIMITED",
"HITECH SURVEY TOOLS PRIVATE LIMITED",
"HI-TECH SWEET WATER TECHNOLOGIES PRIVATE LIMITED",
"HI-TECH SYSTEMS & SERVICES LTD.",
"HITECH TELEMART PRIVATE LIMITED",
"HI-TECH THERMAL INSULATIONS PRIVATE LIMITED",
"HI-TECH TRANSDUCERS AND DEVICES PRIVATE LIMITED",
"HITECH TRONICS",
"HITECH ULTRAVIOLET PRIVATE LIMITED",
"HI-TECH UNIVERSAL PRINTERS AND PUBLISHERS INDIA PRIVATE LIMITED",
"HITECH VISUAL CHANNEL PRIVATE LIMITED",
"HI-TECH WATER SOLUTIONS (INDIA) PRIVATE LIMITED",
"HITECH WEAR PRIVATE LIMITED",
"HITECHGREEN CITY PRIVATE LIMITED",
"HI-TECHNOCRATS PRIVATE LIMITED",
"HITECHWIRE MESH PRIVATE LIMITED",
"HITECO TOOL MANAGEMENT SERVICES INDIA PRIVATE LIMITED",
"HITEIN BUSHINGS PRIVATE LIMITED",
"HITEK BRASS PRODUCTS PRIVATE LIMITED",
"HITEK BUSINESS SYSTEMS PRIVATE LIMITED",
"HITEK FINE CHEMICALS PRIVATE LIMITED",
"HITEK STAVES PRIVATE LIMITED",
"HITEK VENTILATION SYSTEMS PRIVATE LIMITED",
"HITEMP FILTERS PRIVATE LIMITED",
"HITEMP POLYMERS PRIVATE LIMITED",
"HITEN AGRIPRO PRIVATE LIMITED",
"HITEN ALUMINIUM",
"HITEN FASTENERS PRIVATE LIMITED",
"HITEN FOREX PRIVATE LIMITED",
"HITEN MOTORS PRIVATE LIMITED",
"HITEN SETHI AND ASSOCIATE",
"HITEN SETHI ARCHITECTS PRIVATE LIMITED",
"HITEQ METACORP PRIVATE LIMITED",
"HITESH CHEMICALS AND DRUGS PRIVATE LIMITED",
"HITESH CHEMICALS PRIVATE LIMITED",
"HITESH DISTRIBUTORS PRIVATE LIMITED",
"HITESH DOMESTIC APPLIANCE PVT LTD",
"HITESH MECHANICALS PRIVATE LIMITED",
"HITESH PLASTICS PRIVATE LIMITED",
"HITESH STEEL SYNDICATE (INDIA) PRIVATE LIMITED",
"HITESH YARN AGENCY PRIVATE LIMITED",
"HITESHI INFOTECH PRIVATE LIMITED",
"HITESHI LEASING AND HOUSING PRIVATE LIMITED",
"HITEX HEALTHCARE PRIVATE LIMITED",
"HITH IMPEX PRIVATE LIMITED",
"HITHA DESIGN SCIENCE PRIVATE LIMITED",
"HITHA NET INDIA PRIVATE LIMITED",
"HITKAARI FOODS PRIVATE LIMITED",
"HITKARI AND SWARAJ ENTERPRISES PRIVATE LIMITED",
"HITKARI HITECH PRIVATE LIMITED",
"HITKARI MINES & MINERALS PRIVATE LIMITED",
"HITKARI MULTIFILTERS LIMITED",
"HITKARI MULTIFILTERS PRIVATE LIMITED",
"HITKARINI HIGHER SECONDARY SCHOOL DEVTAL GARHA JABALPUR",
"HITLITE APPLIANCES INDIA PRIVATE LIMITED",
"HITODI INFRASTRUCTURE PRIVATE LIMITED",
"HITRAC MANPOWER SERVICES PRIVATE LIMITED",
"HITRO LOGISTICS PRIVATE LIMITED",
"HITTCO TOOLS LIMITED",
"HITUMET CORPORATION PRIVATE LIMITED",
"HITWIN HEALTHCARE PRIVATE LIMITED",
"HITZE BOILERS PRIVATE LIMITED",
"HIVE COMMUNICATIONS INDIA PRIVATE LIMITED",
"HIVE CREATIONS PRIVATE LIMITED",
"HIVEC RHINO TECHNOLOGIES PRIVATE LIMITED",
"HIVELOOP CAPITAL PRIVATE LIMITED",
"HIVELOOP INTERNET PRIVATE LIMITED",
"HIVEMINDS INNOVATIVE MARKET SOLUTIONS PRIVATE LIMITED",
"HIVEPOWER ELECTRICALS PRIVATE LIMITED",
"HIVER AIRCON PRIVATE LIMITED",
"HIVESOLAR ENERGY PRIVATE LIMITED",
"HI-VIEW CONSTRUCTIONS PRIVATE LIMITED",
"HI-VISION INFRATECH AND DEVELOPER INDIA PRIVATE LIMITED",
"HIVOLTRANS ELECTRICALS PVT LTD",
"HIWAY AUTOMOBILES PRIVATE LIMITED",
"HIWAY LIGHTING SOLUTIONS PRIVATE LIMITED",
"HIXAL MANAGEMENT SERVICES PRIVATE LIMITED",
"HIYA DIGITAL PRIVATE LIMITED",
"HIYA HEALTHCARE PRIVATE LIMITED",
"HIYA INDIA BIOTECH PRIVATE LIMITED",
"HIYAMEE PRIVATE LIMITED",
"HIYANA WORLD LOGISTICS PRIVATE LIMITED",
"HIYOSHI INDIA ECOLOGICAL SERVICES PRIVATE LIMITED",
"HIZEN INTELLIGENCE SYSTEMS PRIVATE LIMITED",
"HJ FOODS PRIVATE LIMITED",
"HJ HOSPITALITY PRIVATE LIMITED",
"HJ KAKRECHA INFRACON PRIVATE LIMITED",
"HJ SUPPORT SERVICES PRIVATE LIMITED",
"HJASVANTRAI ENGINEERING PRIVATE LIMITED",
"HJK ELECTRONICS PRIVATE LIMITED",
"HJM FUELS PRIVATE LIMITED",
"HJORT KNUDSEN INDIA PRIVATE LIMITED",
"HJS EMISSIONTECHNOLOGY INDIA PRIVATE LIMITED",
"HK ARCHITECTURE INDIA PRIVATE LIMITED",
"HK AUTO WORLD PRIVATE LIMITED",
"HK CEMENT INDUSTRIES PRIVATE LIMITED",
"HK HUB DIAMOND LLP",
"HK INFRAVENTURES PRIVATE LIMITED",
"HK INFRAZONE PRIVATE LIMITED",
"HK ISPAT PRIVATE LIMITED",
"HK KRISHI MART PRIVATE LIMITED",
"HK LABELS INDIA PRIVATE LIMITED",
"HK MULTITRADE PRIVATE LIMITED",
"HK NULIFE HOSPITALS PRIVATE LIMITED",
"HK TEX FABS",
"HK TEXFAB PRIVATE LIMITED",
"HK TOLL ROAD PRIVATE LIMITED",
"HK WENTWORTH (INDIA) PRIVATE LIMITED",
"HK WENTWORTH INDIA PRIVATE LIMITED",
"HKB MARKETING SOLUTION PRIVATE LIMITED",
"HKBK COLLEGE OF ENGINEERING",
"HKD DISTRIBUTORS PRIVATE LIMITED",
"HKE ELECTRIC CONTRACTS PRIVATE LIMITED",
"HKE JACKETING AND METALS PRIVATE LIMITED",
"HKG MONEY TECH PRIVATE LIMITED",
"HKG PRINTERS & PACKAGERS PRIVATE LIMITED",
"HKGN ENTERPRISES",
"HKI ENTERPRISES PRIVATE LIMITED",
"HKM ENGINEERING PRIVATE LIMITED",
"HKN JEWELLERS PRIVATE LIMITED",
"HKRP INNOVATIONS LLP",
"HKS AUTOMOBILES PRIVATE LIMITED",
"HKS INDIA DESIGN CONSULTING PRIVATE LIMITED",
"HKS INTERNATIONAL SCHOOL HASSAN",
"HKSA LOGISTIX PRIVATE LIMITED",
"HKT CORPORATION PRIVATE LIMITED",
"HKT RETAIL VENTURES PRIVATE LIMITED",
"HKV AGGREGATES PRIVATE LIMITED",
"HKV AUXICHEM PRIVATE LIMITED",
"HKV PROJECTS INDIA PRIVATE LIMITED",
"HKVOLUME EXPORT PRIVATE LIMITED",
"HKX LOGISTICS INDIA PRIVATE LIMITED",
"HL COAL PRIVATE LIMITED",
"HL KLEMOVE INDIA PRIVATE LIMITED",
"HL MANDO ANAND INDIA PRIVATE LIMITED",
"HL PROMOTERS PRIVATE LIMITED",
"HLB MOTORS PRIVATE LIMITED",
"HLBL PRIVATE LIMITED",
"HLBP EXIM PRIVATE LIMITED",
"HLBS TECH PRIVATE. LIMITED.",
"HLE ENGINEERS PRIVATE LIMITED",
"HLE GLASCOAT LIMITED",
"HLF SERVICES LIMITED",
"HLG MEMORIAL HOSPITAL PRIVATE LIMITED",
"H-LINE SOFT INFORMATION TECHNOLOGY PRIVATE.",
"HLK INDUSTRIES PRIVATE LIMITED",
"HLK INFRASTRUCTURE PRIVATE LIMITED",
"HLL BIOTECH LIMITED",
"HLL INFRA TECH SERVICES LIMITED",
"HLL LIFECARE LIMITED",
"HLL SPECIALITY PROFILES PRIVATE LIMITED",
"HLPL GLOBAL LOGISTICS PRIVATE LIMITED",
"HLS ASIA LIMITED",
"HLS CONSTRUCTIONS PRIVATE LIMITED",
"HLS-SJM ADVISORS INDIA PRIVATE LIMITED",
"HLT RESIDENCY PRIVATE LIMITED",
"HLX INTERNATIONAL PRIVATE LIMITED",
"HM ALUMINIUM ALLOYS PRIVATE LIMITED",
"HM AND SONS DIAMOND MANUFACTURING PRIVATE LIMITED",
"HM AVIATION PRIVATE LIMITED",
"HM CLAUSE INDIA PRIVATE LIMITED",
"HM CLOTHING PRIVATE LIMITED",
"HM DEVELOPERS AND CONSTRUCTIONS PRIVATE LIMITED",
"HM DIGITAL INDIA PRIVATE LIMITED",
"HM GASES PRIVATE LIMITED",
"HM HOME FURNISHINGS PRIVATE LIMITED",
"HM MEGABRANDS PRIVATE LIMITED",
"HM MERCANTILES PRIVATE LIMITED",
"HM S INFOTECH PRIVATE LIMITED",
"HM WEB HOUSE PRIVATE LIMITED",
"HMA AGRO INDUSTRIES LIMITED",
"HMA AUTOMATION SYSTEMS INDIA PRIVATE LIMITED",
"HMA FOOD EXPORT PRIVATE LIMITED",
"HMA INDUSTRIES PRIVATE LIMITED",
"HMA LEATHER EXPORT PRIVATE LIMITED",
"HMA STARWARE PRIVATE LIMITED",
"HMACS TRADING PRIVATE LIMITED",
"HMAX MONEY EXCHANGE PRIVATE LIMITED",
"HMB COMMERCIAL PRIVATE LIMITED",
"HMB ISPAT PRIVATE LIMITED",
"HMB PROPERTIES PRIVATE LIMITED",
"HMC CONSULTANCY SERVICES PRIVATE LIMITED",
"HMC EXPORTS PRIVATE LIMITED",
"HMC MM AUTO LIMITED",
"HMD MOBILE INDIA PRIVATE LIMITED",
"HMDA ANCON LOGISTICS PARK PRIVATE LIMITED",
"HMDA TRUCK DOCK LOGISTICS PRIVATE LIMITED",
"HME BOILERS PRIVATE LIMITED",
"HMG GREEN INDIA PRIVATE LIMITED",
"HMG INDUSTRIES LIMITED",
"HMI INTERNATIONAL SCHOOL RICHHA BAREILLY UTTAR PRADESH",
"HMI METAL AND ALLOYS (INDIA) PRIVATE LIMITED",
"HML CONSULTING PRIVATE LIMITED",
"HMM ALUMINIUM PRIVATE LIMITED",
"HMM FARMS PRIVATE LIMITED",
"HMM INFRA LIMITED",
"HMM SHIPPING INDIA PRIVATE LIMITED",
"HMN TECHCONSULTANTS PRIVATE LIMITED",
"HMNR ENTERPRISES PRIVATE LIMITED",
"HMP BUILDERS PRIVATE LIMITED",
"HMP CONTRACTORS PRIVATE LIMITED",
"HMP HOTELS PRIVATE LIMITED",
"HMP INFRASTRUCTURE PRIVATE LIMITED",
"HMP LEGALEASE CORPORATE CONSULTANTS PRIVATE LIMITED",
"HMP MINERALS PRIVATE LIMITED",
"HMP WOOLLEN MILLS PRIVATE LIMITED",
"HMR STEELS PRIVATE LIMITED",
"HMS EDUCATION SOCIETY",
"HMS INFRA SOLUTIONS PRIVATE LIMITED",
"HMS INFRATECH PRIVATE LIMITED",
"HMS METAL PRIVATE LIMITED",
"HMS MINERALS AND ALLOYS PRIVATE LIMITED",
"HMS REAL ESTATE PRIVATE LIMITED",
"HMS RELATIONS MANAGEMENT PRIVATE LIMITED",
"HMSHOST HOSPITALITY SERVICES BHARATH PRIVATE LIMITED",
"HMSHOST SERVICES INDIA PRIVATE LIMITED",
"HMSU ROLLERS (INDIA) PRIVATE LIMITED",
"HMT",
"HMT MACHINE TOOLS LIMITED",
"HMT WATCHES LIMITED",
"HMTC ENGINEERING COMPANY (KOLKATA) PRIVATE LIMITED",
"HMTD ENGINEERING PRIVATE LIMITED",
"HMTD TEXTILES PRIVATE LIMITED",
"HMV ENGINEERING SERVICES PRIVATE LIMITED",
"HMY IMPEX PRIVATE LIMITED",
"HN CURE PHARMA PRIVATE LIMITED",
"HN INDIGOS PRIVATE LIMITED",
"HN IT SOLUTIONS PRIVATE LIMITED",
"HN PLASTICS PRIVATE LIMITED",
"HN RSEKURE INDIA PRIVATE LIMITED",
"HN SAFAL AVIATION PRIVATE LIMITED",
"HN SAFAL INFRA DEVELOPERS PRIVATE LIMITED",
"HN SAFAL INFRA SPACE PRIVATE LIMITED",
"HNA TELESYSTEMS INDIA PRIVATE LIMITED",
"HNAP INFRA PROJECTS PRIVATE LIMITED",
"HNB ENGINEERS PRIVATE LIMITED",
"HNC INDUSTRIES PRIVATE LIMITED",
"HNC MATTANNUR HOSPITAL PRIVATE LIMITED",
"HNC MOTION CONTROL PRIVATE LIMITED",
"HNCO ORGANICS PRIVATE LIMITED",
"HNG FLOAT GLASS LIMITED",
"HNG RETAIL PRIVATE LIMITED",
"HNHR EXECUTIVE SEARCH INDIA PRIVATE LIMITED",
"HNI AUTOTECH PRIVATE LIMITED",
"HNI IDEA VENTURES PRIVATE LIMITED",
"HNI OFFICE INDIA LIMITED",
"HNJ FOODS INTERNATIONAL PRIVATE LIMITED",
"HNJ STOCK BROKING PRIVATE LIMITED",
"HNL SYSTEMS PRIVATE LIMITED",
"HNM STUDIOS DESIGNNS PRIVATE LIMITED",
"HNND TRADING PRIVATE LIMITED",
"HNPE KNOWLEDGE PRIVATE LIMITED",
"HNR RETAIL PRIVATE LIMITED",
"HNR TECH PRIVATE LIMITED",
"HNS COACHES PRIVATE LIMITED",
"HNS CONTRACTORS DEVELOPERS INDIA PRIVATE LIMITED",
"HNS DETAILING SERVICES PRIVATE LIMITED",
"HNS TECHNOLOGIES PRIVATE LIMITED",
"HNS TECHNOLOGY SERVICES PRIVATE LIMITED",
"HNT ELECTRICALS PRIVATE LIMITED",
"HNT FOODS PRIVATE LIMITED",
"HNTI LIMITED",
"HNUPR MATRIC HIGHER SECONDARY SCHOOL",
"HNV CASTINGS PRIVATE LIMITED",
"HNYTECH SOLUTIONS PRIVATE LIMITED",
"HO DEPARTMENT OF HORTICULTURE",
"HOARD WELL FURNITURE PRIVATE LIMITED",
"HOB COSMETICS PRIVATE LIMITED",
"HOB NOB ELECTRONICS PRIVATE LIMITED",
"HOBBY TECH PRIVATE LIMITED",
"HOBVISION TECHNOLOGIES PRIVATE LIMITED",
"HOCAGE HOME DECOR PRIVATE LIMITED",
"HOCHADS PRIVATE LIMITED",
"HOCHIKI EUROPE UK LIMITED",
"HOCHSTE HEALTH CARE PRIVATE LIMITED",
"HOCKEY INDIA",
"HOCKEYCURVE GROWTH SOLUTIONS PRIVATE LIMITED",
"HOCON TECHNOLOGIES INDIA PRIVATE LIMITED",
"HOCS FIRE AND SECURITY SYSTEMS PRIVATE LIMITED",
"HODEK VIBRATION TECHNOLOGIES PRIVATE LIMITED",
"HODUSOFT PRIVATE LIMITED",
"HOE WELLNESS PRIVATE LIMITED",
"HOEC BARDAHL INDIA LIMITED",
"HOECHST LIFE CARE PRIVATE LIMITED",
"HOEGH AUTOLINERS (INDIA) PRIVATE LIMITED",
"HOERBIGER INDIA PVT LTD",
"HOESCH METALLURGIE INDIA PRIVATE LIMITED",
"HOF FURNITURE SYSTEM PRIVATE LIMITED",
"HOF PHARMACEUTICALS LIMITED",
"HOFFEN PLASTICS PRIVATE LIMITED",
"HOFFEN TRAVEL SERVICES PRIVATE LIMITED",
"HOFFENSOFT",
"HOFFENTECH SOLUTIONS LIMITED",
"HOFFMANN QUALITY TOOLS INDIA PRIVATE LIMITED",
"HOFFMEN FASHIONS PVT LTD",
"HOFINCONS INTERNATIONAL PRIVATE LIMITED",
"HOFMANN ENGINEERING AND MARKETING PRIVATE LIMITED",
"HOG ADDING LIFE TO YEAR HCG CANCER CENTER",
"HOGAN INDUSTRIES PRIVATE LIMITED",
"HOGER OFFSHORE AND MARINE PRIVATE LIMITED",
"HOGER SHOES PRIVATE LIMITED",
"HOGIST TECHNOLOGIES PRIVATE LIMITED",
"HOGO WORKS SOLUTIONS PRIVATE LIMITED",
"HOHENSTEIN INDIA PRIVATE LIMITED",
"HOHOCARE SERVICES PRIVATE LIMITED",
"HOICHOI TECHNOLOGIES PRIVATE LIMITED",
"HOIN MAL SONS ENTERPRISES PRIVATE. LIMITED.",
"HOISTO STRUCTURE AND EQUIPMENT PRIVATE LIMITED",
"HOJAI FOOD PRODUCTS PRIVATE LIMITED",
"HOJIWALA FABRICS PRIVATE LIMITED",
"HOJIWALA INFRASTRUCTURE LIMITED",
"HOK BEAUTY PRIVATE LIMITED",
"HOK DESIGN AND PLANNING SERVICES (INDIA) PRIVATE LIMITED",
"HOK RETAIL PRIVATE LIMITED",
"HOLACHEF HOSPITALITY PRIVATE LIMITED",
"HOLAM ORGANICS PRIVATE LIMITED",
"HOLAMED HEALTHCARE TECHNOLOGIES PRIVATE LIMITED",
"HOLANI BEARINGS PRIVATE LIMITED",
"HOLANI CONSULTANTS PRIVATE LIMITED",
"HOLCIM SERVICES SOUTH ASIA LIMITED",
"HOLD ON BUILDERS PRIVATE LIMITED",
"HOLDEN MEDICAL LABORATORIES PRIVATE. LIMITED",
"HOLDING BRICKS PRIVATE LIMITED",
"HOLDWELL COMPONENTS PRIVATE LIMITED",
"HOLIDAY BOOTS JOURNEYS PRIVATE LIMITED",
"HOLIDAY DEALS PRIVATE LIMITED",
"HOLIDAY DESIGNERS PRIVATE LIMITED",
"HOLIDAY HUB PRIVATE LIMITED",
"HOLIDAY INN GOA CANDOLIM",
"HOLIDAY INN MUMBAI INTERNATIONAL AIRPORT",
"HOLIDAY KART PRIVATE LIMITED",
"HOLIDAY POINT TOURISM PRIVATE LIMITED",
"HOLIDAY PROJECTS KERALA PRIVATE LIMITED",
"HOLIDAY UMBRELLA PRIVATE LIMITED",
"HOLIDAYPACK GLOBAL LLP",
"HOLIDAYS BOOKERS DMC INDIA PRIVATE LIMITED",
"HOLIDAYS BY SAHIBJI PRIVATE LIMITED",
"HOLIDAYS WORLD INDIA",
"HOLIDAYSANDYOU TRAVELS PRIVATE LIMITED",
"HOLIDAYZ MART PRIVATE LIMITED",
"HOLIDIFY TRAVELS PRIVATE LIMITED",
"HOLIFAX FACILITIES MANAGEMENT PRIVATE LIMITED",
"HOLISOL LOGISTICS PRIVATE LIMITED",
"HOLISOL TALENT SOLUTION PRIVATE LIMITED",
"HOLISTA TRANZWORLD PRIVATE LIMITED",
"HOLISTIC ADVISORY SERVICES PRIVATE LIMITED",
"HOLISTIC ENGINEERING PRIVATE LIMITED",
"HOLISTIC ENTERPRISES PRIVATE LIMITED",
"HOLISTIC HR &SECURITY PRIVATE LIMITED",
"HOLISTIC INFRA DEVELOPERS PRIVATE LIMITED",
"HOLISTIC MINDS PRIVATE LIMITED",
"HOLISTIC PEOPLE IT SERVICE PRIVATE LIMITED",
"HOLISTIC REMEDIES PRIVATE LIMITED",
"HOLISTIC TECHNOENGINEERS PRIVATE LIMITED",
"HOLISTIC TRAINING SOLUTIONS PRIVATE LIMITED",
"HOLISTICS URBAN INNOVATIONS PRIVATE LIMITED",
"HOLISTIK DIGITAL SOLUTIONS PRIVATE LIMITED",
"HOLISTIQUE BEAUTY PRODUCTS PRIVATE LIMITED",
"HOLITECH INDIA PRIVATE LIMITED",
"HOLKAR & SONS PRIVATE LIMITED",
"HOLKAR COLLEGE",
"HOLKOI SYSTEMS PRIVATE LIMITED",
"HOLKOI TECHNOLOGIES PRIVATE LIMITED",
"HOLLAND & SHERRY INDIA PRIVATE LIMITED",
"HOLLASONS TECHSOLUTIONS PRIVATE LIMITED",
"HOLLIS CROP SCIENCE PRIVATE LIMITED",
"HOLLIS VITRIFIED PRIVATE LIMITED",
"HOLLISTER MEDICAL INDIA PRIVATE LIMITED",
"HOLLTECK INDIA GUIDES PRIVATE LIMITED",
"HOLLY DRUGS PRIVATE LIMITED",
"HOLLY ENTERPRISES PRIVATE LIMITED",
"HOLLY GREEN E M HIGH SCHOOL",
"HOLLY HOCK RESORTS AND HOSPITALITY SERVICES PRIVATE LIMITED",
"HOLLYFIELD DEVCON PRIVATE LIMITED",
"HOLLYHOCK INFRASTRUCTURES PRIVATE LIMITED",
"HOLLYHOCKS REALTORS PRIVATE LIMITED",
"HOLLYSYS AUTOMATION INDIA PRIVATE LIMITED",
"HOLLYWOOD COLLECTION",
"HOLLYWOOD HOSPITALITY PRIVATE LIMITED",
"HOLLYWOOD OPTICIANS PRIVATE LIMITED",
"HOLMARC OPTO-MECHATRONICS LIMITED",
"HOLMARC OPTO-MECHATRONICS PRIVATE LIMITED",
"HOLO PUNDITS PRIVATE LIMITED",
"HOLOFLEX LIMITED",
"HOLOSAFE SECURITY LABELS PRIVATE LIMITED",
"HOLOSTIK INDIA LIMITED",
"HOLTEC CONSULTING PRIVATE LIMITED",
"HOLTECASIA PRIVATE LIMITED",
"HOLTZMAN SYSTEMS PRIVATE LIMITED",
"HOLVIN FOODS PRIVATE LIMITED",
"HOLY ANGEL MARINE SERVICES PRIVATE LIMITED",
"HOLY ANGELS ANGLO INDIAN HIGHER SECONDARY SCHOOL",
"HOLY ANGELS HIGH SCHOOL",
"HOLY BASIL CONSULTANCY PRIVATE LIMITED",
"HOLY CHILD INSTITUTE",
"HOLY CHILD SCHOOL",
"HOLY CHILD SENIOR SECONDARY SCHOOL",
"HOLY CITY TOUR COMPANY PRIVATE LIMITED",
"HOLY COW HOSPITALITY PRIVATE LIMITED",
"HOLY COW STUDIOS PRIVATE LIMITED",
"HOLY CROSS COLLEGE-TRICHY 620002",
"HOLY CROSS CONVENT ENGLISH HIGH SCHOOL AMRAVATI",
"HOLY CROSS CONVENT ENGLISH HIGH SCHOOL CAMP ROAD AMRAVATI",
"HOLY CROSS HOSPITAL PRIVATE LIMITED",
"HOLY CROSS MARATHI PRIMARY SCHOOL ACHALPUR",
"HOLY CROSS SCHOOL",
"HOLY EXPO PRIVATE LIMITED",
"HOLY FAITH ENGLISH SCHOOL",
"HOLY FAITH INTERNATIONAL P LIMITED.",
"HOLY FAMILY CONVENT SCHOOL",
"HOLY FAMILY HIGH SCHOOL",
"HOLY FAMILY HOSPITAL",
"HOLY FAMILY SCHOOL",
"HOLY GREEN ENERGY PRIVATE LIMITED",
"HOLY HEART PUBLIC SEN SEC SCHOOL",
"HOLY HEART SCHOOL",
"HOLY HEART SR SEC CONVENT SCHOOL",
"HOLY HEARTS EDUCATIONAL ACADEMY",
"HOLY INFANT JESUS MATRICULATION HIGHER SECONDARY SCHOOL",
"HOLY LAND MARKETING PRIVATE LIMITED",
"HOLY LIFESCIENCES PRIVATE LIMITED",
"HOLY MARY INSTITUTE OF TECHNOLOGY AND SCIENCE",
"HOLY MATHA COLLEGES",
"HOLY MOTHER ENGLISH SCHOOL",
"HOLY RIVER HOTEL PRIVATE LIMITED",
"HOLY SHRINE HOTELS PRIVATE LIMITED",
"HOLY SMOKE RESTAURANTS PRIVATE LIMITED",
"HOLY SOMETHING RESTURANT LLP",
"HOLY SPIRIT HOSPITAL",
"HOLY VISION PRIVATE LIMITED",
"HOLYCLOTHING PRIVATE LIMITED",
"HOLYCROSS ENGINEEING COLLEGE",
"HOLYGALA FUN PRIVATE LIMITED",
"HOLYGOLEE PHARMACY PRIVATE LIMITED",
"HOLYPROMISE MULTI SPECIALITY HOSPITAL PRIVATE LIMITED",
"HOLY-WOOD ACADEMY",
"HOLZCORD INDUSTRIES PRIVATE LIMITED",
"HOLZWERK INTERIOR PRIVATE LIMITED",
"HOM AUTOMATION PRIVATE LIMITED",
"HOM INDIA PRIVATE LIMITED",
"HOMAG INDIA PRIVATE LIMITED",
"HOMAG MACHINERY BANGALORE PRIVATE LIMITED",
"HOMAGE REALTOR PRIVATE LIMITED",
"HOMATICO SMART SOLUTIONS PRIVATE LIMITED",
"HOMBALE CONSTRUCTIONS AND ESTATES PRIVATE LIMITED",
"HOME & LAND PLANNERS LLP",
"HOME & SOUL INFRATECH PRIVATE LIMITED",
"HOME & SOUL MANAGEMENT SERVICES PRIVATE LIMITED",
"HOME & WE HANDICRAFTS PRIVATE LIMITED",
"HOME ASSOCIATES",
"HOME BAZAAR SERVICES PRIVATE LIMITED",
"HOME BUILD TECH INDIA PRIVATE LIMITED",
"HOME CABLE NETWORK PRIVATE LIMITED",
"HOME CITY LIFESTYLE PRIVATE LIMITED",
"HOME COMFORT INDIA PRIVATE LIMITED",
"HOME CREDIT INDIA FINANCE PRIVATE LIMITED",
"HOME DECOR",
"HOME DECOR ENTERPRISES",
"HOME DEPARTMENT",
"HOME DEPOT SOURCING INDIA PRIVATE LIMITED",
"HOME DESTINATIONS REALTY PRIVATE LIMITED",
"HOME DESTINO PRIVATE LIMITED",
"HOME EASY MAINTENANCE",
"HOME ELECTRIC (INDIA) PRIVATE LIMITED",
"HOME FIRST FINANCE COMPANY INDIA LIMITED",
"HOME FOR ADULT DEAF MUTE PERSONS",
"HOME FUNDRAISING INDIA PRIVATE LIMITED",
"HOME IDEA CURTAIN FABRICS",
"HOME IDEA UPHOLSTERY PRIVATE LIMITED",
"HOME INTERIOR PLUS PRIVATE LIMITED",
"HOME LIFE BUILDCON PRIVATE LIMITED",
"HOME LINKERS PRIVATE LIMITED",
"HOME MANAGEMENT AND CARE GIVERS SECTOR SKILL COUNCIL",
"HOME MEDIX (INDIA) PRIVATE LIMITED",
"HOME PLUS FINANCE PRIVATE LIMITED",
"HOME PRIDE ADHESIVE PRIVATE LIMITED",
"HOME RAYS PRIVATE LIMITED",
"HOME RESIDENCY INFRATECH PRIVATE LIMITED",
"HOME RISING CONSTRUCTION LLP",
"HOME SECURE PESTOBIRD SERVICES PRIVATE LIMITED",
"HOME SECURITY FACILITY SERVICES PRIVATE LIMITED",
"HOME SHOPPE PRIVATE LIMITED",
"HOME SIZZLER INDIA PRIVATE LIMITED",
"HOME STORES INDIA PRIVATE LIMITED",
"HOME STUDIO INDIA PRIVATE LIMITED",
"HOME STYLE FURNISHING PRIVATE LIMITED",
"HOME SYSTEMS PRIVATE LIMITED",
"HOME TELEVISION NETWORK PRIVATE LIMITED",
"HOME THEATER STORE INDIA PRIVATE LIMITED",
"HOME UP GOVT LKO",
"HOME ZONE RUBBER SOLUTIONS PRIVATE LIMITED",
"HOME ZONE STAINLESS PRIVATE LIMITED",
"HOMEBOTS AUTOMATION PRIVATE LIMITED",
"HOMEBRAIN IOT SERVICES PRIVATE LIMITED",
"HOMECREST CONSTRUCTIONS PRIVATE LIMITED",
"HOMEFLOORING & DECOR PRIVATE LIMITED",
"HOMEGENIE BUILDING PRODUCTS PRIVATE LIMITED",
"HOMEHEIGHT REAL ESTATE PRIVATE LIMITED (OPC)",
"HOMELAND AVENUES PRIVATE LIMITED",
"HOMELAND CONSTRUCTIONS PRIVATE LIMITED",
"HOMELAND RESORTS PRIVATE LIMITED.",
"HOMELAND SECURITECH PRIVATE LIMITED",
"HOMEMADE BAKERS INDIA LIMITED",
"HOMEMATE SMART PRIVATE LIMITED",
"HOMENURSE4U PRIVATE LIMITED",
"HOMEOCARE INTERNATIONAL LIMITED",
"HOMEOCARE INTERNATIONAL PRIVATE LIMITED",
"HOMEOPATHY INDIA PRIVATE LIMITED",
"HOMEPECKED E-MARKETPLACE SERVICES PRIVATE LIMITED",
"HOMERA TANNERS PRIVATE LIMITED",
"HOMERA TANNING INDUSTRIES PRIVATE LIMITED",
"HOMERS APPLIANCES INDIA PRIVATE LIMITED",
"HOMES UNLIMITED PRIVATE LIMITED",
"HOMESCAPE BUILDERS PRIVATE LIMITED",
"HOMESCONNECT STORES PRIVATE LIMITED",
"HOMESFY REALTY LIMITED",
"HOMESFY REALTY PRIVATE LIMITED",
"HOMESHREE HOUSING FINANCE LIMITED",
"HOMESPOON FOOD INDUSTRIES PRIVATE LIMITED",
"HOMESTAR SERVICES INDIA PRIVATE LIMITED",
"HOMESTEAD FARMS PRIVATE LIMITED",
"HOMESTEAD PROJECTS AND DEVELOPERS PRIVATE LIMITED",
"HOMESTONE INDUSTRIES PRIVATE LIMITED",
"HOMESTRAP FABRIC FURNISHING PRIVATE LIMITED",
"HOMESTYLE MERCHANDISE PRIVATE LIMITED",
"HOMETECH DIGITAL LIMITED",
"HOMETECH DIGITAL PRIVATE LIMITED",
"HOMETECH SERVICES PRIVATE LIMITED",
"HOMETECH SMARTVALUE PRIVATE LIMITED",
"HOMETOWN TRAVELS PRIVATE LIMITED",
"HOMETRAIL BUILDTECH PRIVATE LIMITED",
"HOMETRUST REALTY PRIVATE LIMITED",
"HOMEVEDA MEDIA LABS PRIVATE LIMITED",
"HOMEWARD RESIDENTIAL CORPORATION INDIA",
"HOMEWARD RESIDENTIAL CORPORATION INDIA PRIVATE LIMITED",
"HOMEWYPE FACILITY MANAGEMENT PRIVATE LIMITED",
"HOMEX BROTHERS PRIVATE LIMITED",
"HOMFEEL HUMANCARE PRODUCT PRIVATE LIMITED",
"HOMI MEHTA AND SONS PRIVATE LIMITED",
"HOMOEO WORLD",
"HOMOEOPATHY INDIA PRIVATE LIMITED",
"HOMOEOPATIC MEDICAL COLLEGE & HOSPITAL",
"HOMZNOW REALTY ADVISORS LIMITED",
"HON RATNAKARRAO GUTTE INTERNATIONAL SCHOOL",
"HON SHRI ANNASAHEB DANGE AYURVED MEDICAL COLLEGE POST GRADUATE & RESEARCH CENTRE ASHTA",
"HONASA CONSUMER LIMITED",
"HONASA CONSUMER PRIVATE LIMITED",
"HONASCO PLASTIC TECH PRIVATE LIMITED",
"HONAVAR ELECTRODES PRIVATE LIMITED",
"HONAWAR HOSPITALITY LLP",
"HONCHO PROPERTIES PRIVATE LIMITED",
"HONCHO TECH FOR GOOD FOUNDATION",
"HONDA ACCESS INDIA PRIVATE LIMITED",
"HONDA CARE CENTRE",
"HONDA CARS INDIA LIMITED",
"HONDA INDIA POWER PRODUCTS LIMITED",
"HONDA KAIHATSU INDIA HOSPITALITY PRIVATE LIMITED",
"HONDA LOGISTICS INDIA PRIVATE LIMITED",
"HONDA MOTOR INDIA PRIVATE LIMITED",
"HONDA MOTORCYCLE AND SCOOTER INDIA PVT LTD",
"HONDA R&D (INDIA) PRIVATE LIMITED",
"HONDA SIEL POWER PRODUCTS LIMITED",
"HONDA TRADING CORPORATION INDIA PRIVATE LIMITED",
"HONER PROPERTIES PRIVATE LIMITED",
"HONEST ALLOYS PRIVATE LIMITED",
"HONEST BIO VET PRIVATE LIMITED",
"HONEST CERAMIC PRIVATE LIMITED",
"HONEST ENTERPRISE",
"HONEST FREIGHT & FORWARDERS PRIVATE LIMITED",
"HONEST HOME HEALTHCARE LLP",
"HONEST INDUSTRIES PRIVATE LIMITED",
"HONEST INTERNATIONAL FOODS PRIVATE LIMITED",
"HONEST MARKETING PRIVATE LIMITED",
"HONEST RESTAURANT PRIVATE LIMITED",
"HONEST RESTAURANTS (INDIA) PRIVATE LIMITED",
"HONEST SHIPPING PRIVATE LIMITED",
"HONESTATTVA IT SOLUTIONS PRIVATE LIMITED",
"HONESTO FARMS PRIVATE LIMITED",
"HONESTY AUTOMATION PRIVATE LIMITED",
"HONESTY NET SOLUTIONS (INDIA) PRIVATE LIMITED",
"HONEY AGRO INDUSTRIES PRIVATE LIMITED",
"HONEY COMB CREATIVE SUPPORT",
"HONEY DH CONSTRUCTION PRIVATE LIMITED",
"HONEY JEWELLERY PRIVATE LIMITED",
"HONEY METALS & CHEMICALS PRIVATE LIMITED",
"HONEY MONEY ASSOCIATS PRIVATE LIMITED",
"HONEY SHIPBREAKING PRIVATE LIMITED",
"HONEY SPARK EROSION PRIVATE LIMITED",
"HONEY SWEETS PRIVATE LIMITED",
"HONEY TRADEX PRIVATE LIMITED",
"HONEY VANIJYA PVT LTD",
"HONEY WELL ESTATE PRIVATE LIMITED",
"HONEYBELL PHARMA PRIVATE LIMITED",
"HONEYCOMB ENGINEERING PRIVATE LIMITED",
"HONEYCOMB ESERVICES PRIVATE LIMITED",
"HONEYCOMB INDUSTRIES (OPC) PRIVATE LIMITED",
"HONEYCOMB LOGISTICS PRIVATE LIMITED",
"HONEYCOMB RELATIONSHIP MANAGEMENT SERVICES PRIVATE LIMITED",
"HONEYCOMB RETAIL INDIA PRIVATE LIMITED",
"HONEYCOMB SOFTWARES PRIVATE LIMITED",
"HONEYCOMB TELNET PRIVATE LIMITED",
"HONEYCOMB WEBWORLD PRIVATE LIMITED",
"HONEYCOOL BEVERAGES INTERNATIONAL PRIVATE LIMITED",
"HONEYEATER PROPERTIES AND INVESTMENT PRIVATE LIMITED",
"HONEYFLOWER ESTATES PRIVATE LIMITED",
"HONEYNBEAUTE (OPC) PRIVATE LIMITED",
"HONEYPACK F1 PRIVATE LIMITED",
"HONEYTECH CONTROLS (INDIA) PRIVATE LIMITED",
"HONEYVICK ENTERPRISES PRIVATE LIMITED",
"HONEYWELL AUTOMATION INDIA LIMITED",
"HONEYWELL ELECTRICAL DEVICES AND SYSTEMS INDIA LIMITED",
"HONEYWELL FINSERV PRIVATE LIMITED",
"HONEYWELL HOMETOWN SOLUTIONS INDIA FOUNDATION",
"HONEYWELL INTERNATIONAL INDIA",
"HONEYWELL IT SOLUTIONS PRIVATE LIMITED",
"HONEYWELL TECHNOLOGY SOLUTIONS LAB PRIVATE LIMITED",
"HONEYWELL TURBO TECH PRIVATE LIMITED",
"HONG GUANG DE TECHNOLOGY INDIA PRIVATE LIMITED",
"HONG ZHENG INDIA PRIVATE LIMITED",
"HONGKONG AND SHANGHAI BANKING CORPORATION",
"HONICEL INDIA PRIVATE LIMITED",
"HONNAKERE HOBLI HORTICULTURE FARMER PRODUCER COMPANY LIMITED",
"HONNASIRI ENERGY PRIVATE LIMITED",
"HONNASSIRI MOTORS INDIA PRIVATE LIMITED",
"HONNEX SOFTWARE SOLUTIONS PRIVATE LIMITED",
"HONOS PROTECTION SERVICES PRIVATE LIMITED",
"HONOUR LAB LIMITED",
"HONOUR LANE LOGISTICS (INDIA) PRIVATE LIMITED",
"HONOUR SECURESENSE SECURITY PRIVATE LIMITED",
"HONOURABLE PACKAGING PRIVATE LIMITED",
"HONSBERG SAWS INDIA PRIVATE LIMITED",
"HONZA RENT A CAR PRIVATE LIMITED",
"HOOBBO TECHNOLOGY SERVICES (OPC) PRIVATE LIMITED",
"HOOGHLY AGRO PRODUCTS PRIVATE LIMITED",
"HOOGHLY ALLOY & STEELS CO. PRIVATE LIMITED",
"HOOGHLY COCHIN SHIPYARD LIMITED",
"HOOGHLY ENGINEERING AND TECHNOLOGY COLLEGE",
"HOOGHLY EXTRUSIONS LIMITED",
"HOOGHLY HATCHERIES PRIVATE LIMITED",
"HOOGHLY INFRASTRUCTURE PRIVATE LIMITED",
"HOOGHLY JUTE MILLS ( VIZIANAGARAM ) PRIVATE LIMITED",
"HOOGHLY MILLS PROJECTS LIMITED",
"HOOGHLY MOTORS PRIVATE LIMITED",
"HOOGRAJULI(ASSAM)TEA CO LTD",
"HOOK CATCH SEAFOOD PRIVATE LIMITED",
"HOONAR TEKWURKS CONSULTING LLP",
"HOONAR TEKWURKS PRIVATE LIMITED",
"HOOP ENTERTAINMENT PRIVATE LIMITED",
"HOOP INNOVATION PRIVATE LIMITED",
"HOOPOE INFOEDGE PRIVATE LIMITED",
"HOOPS AND STRIPS PRIVATE LIMITED",
"HOOSAMI METAL INDUSTRIES PVT LTD",
"HOOVAR SERVICES PRIVATE LIMITED",
"HOOVER INFRACON PRIVATE LIMITED",
"HOOXO CHEMICALS PRIVATE LIMITED",
"HOP MOTORS PRIVATE LIMITED",
"HOPCO TRAVELS PRIVATE LIMITED",
"HOPE (INDIA) POLISHING WORKS PRIVATE LIMITED",
"HOPE ADVERTISING PRIVATE LIMITED",
"HOPE CERAMICS MACHINERY(I) PRIVATE LIMITED",
"HOPE CHILDRENS HOSPITAL.",
"HOPE CONSULTANTS LIMITED",
"HOPE FOR THE CHILDREN FOUNDATION",
"HOPE FOUNDATION AND RESEARCH CENTRE",
"HOPE HEALTH CARE PRIVATE LIMITED",
"HOPE MOBILES PRIVATE LIMITED",
"HOPE PRODUCTIONS PRIVATE LIMITED",
"HOPE SECURITY EQUIPMENTS PRIVATE LIMITED",
"HOPE TECHNOLOGIES PRIVATE LIMITED",
"HOPECON INFRA PROJECTS PRIVATE LIMITED",
"HOPEFIELD COMTEXTILE APPAREL INDIA PRIVATE LIMITED",
"HOPEFLOATS TECHNOLOGIES PRIVATE LIMITED",
"HOPEFUL TRADERS PRIVATE LIMITED",
"HOPES FLEET MOVERS PRIVATE LIMITED",
"HOPES HOSPITALITY SERVICES PRIVATE LIMITED",
"HOPETOWN GIRL SCHOOL",
"HOPEWELL CERAMICS PRIVATE LIMITED",
"HOPEWELL MANUFACTURING AND EXPORTS PRIVATE LIMITED",
"HOPEWELL PRODUCTS (INDIA) PRIVATE LIMITED",
"HOPEWELL TREXIM PVT. LTD.",
"HOPFIRST INFOCOMM PRIVATE LIMITED",
"HOPPECKE INDIA PRIVATE LIMITED",
"HOPS & BARRELS PRIVATE LIMITED",
"HOPSCOTCH HEALTH PRIVATE LIMITED",
"HOPSTOP PRIVATE LIMITED",
"HOPX ENTERTAINMENT PRIVATE LIMITED",
"HOQUE LOGISTICS PRIVATE LIMITED",
"HORA ART CENTRE PVT LTD",
"HORA MOTORS PVT LTD",
"HORA TRANSPORT COMPANY PVT LTD",
"HORAJI GEMS & JEWELS",
"HORIAKI INDIA PRIVATE LIMITED",
"HORIBA INDIA PRIVATE LIMITED",
"HORI-D CONSTRUCTIONS PRIVATE LIMITED",
"HORIDRILL SOLUTIONS INDIA PRIVATE LIMITED",
"HORIGINE CONSULTING PRIVATE LIMITED",
"HORISONS MOTORS",
"HORIZON AEROSPACE INDIA PRIVATE LIMITED",
"HORIZON AGRO SCIENCES PRIVATE LIMITED",
"HORIZON BIOCEUTICALS PVT LTD",
"HORIZON BIOLABS PRIVATE LIMITED",
"HORIZON CHUTES PRIVATE LIMITED",
"HORIZON CLEFORD PRIVATE LIMITED",
"HORIZON CONFERENCE MANAGEMENT PRIVATE LIMITED",
"HORIZON CONSULTING ENGINEERS PRIVATE LIMITED",
"HORIZON DATA SYSTEMS PRIVATE LIMITED",
"HORIZON DESTINATION MANAGEMENT COMPANY",
"HORIZON DWELLINGS PRIVATE LIMITED",
"HORIZON ELECTRICALS PRIVATE LIMITED",
"HORIZON ENTRADE PRIVATE LIMITED",
"HORIZON FABTECH INFRA PRIVATE LIMITED",
"HORIZON FINCAP SERVICES PRIVATE LIMITED",
"HORIZON FLORA INDIA LIMITED",
"HORIZON GLOBAL LIMITED",
"HORIZON GLOBAL SOURCING OPERATIONS & INNOVATION CENTER INDIA PRIVATE LIMITED",
"HORIZON HARDWARE AND GLASSES PRIVATE LIMITED",
"HORIZON HEALTHCARE SERVICES",
"HORIZON HGE ELECTRONICEQUIPMENT INDIA PRIVATE LIMITED",
"HORIZON INDUSTRIAL PARKS PRIVATE LIMITED",
"HORIZON INDUSTRIAL PRODUCTS PRIVATE LIMITED",
"HORIZON INFRADESIGNS PRIVATE LIMITED",
"HORIZON INTERNATIONAL ACADEMY",
"HORIZON MANAGEMENT PVT LTD",
"HORIZON MARKET RESEARCH PRIVATE LIMITED",
"HORIZON MEDITECH PRIVATE LIMITED",
"HORIZON METALTECH PRIVATE LIMITED",
"HORIZON MOTORS INDIA PRIVATE LIMITED",
"HORIZON PACKS PRIVATE LIMITED",
"HORIZON PERFORMANCE POLYURETHANE PRIVATE LIMITED",
"HORIZON POLYMER ENGINEERING PRIVATE LIMITED",
"HORIZON POLYMERS PRIVATE LIMITED",
"HORIZON PRIME HOSPITAL",
"HORIZON PROJECTS PRIVATE LIMITED",
"HORIZON PROMOTERS INDIA LIMITED",
"HORIZON RECYCLING PRIVATE LIMITED",
"HORIZON REFRACTORIES PRIVATE LIMITED",
"HORIZON SURVEY COMPANY INDIA PRIVATE LIMITED",
"HORIZON SYSTEMS & COMMUNICATION PRIVATE LIMITED",
"HORIZON TECHNO PROJECTS PRIVATE LIMITED",
"HORIZON TRANSLIFTERS PRIVATE LIMITED",
"HORIZONCORE INFOSOFT PRIVATE LIMITED",
"HORIZONS SALES PRIVATE LIMITED",
"HORIZONSTAR SHIPPING AGENCY PRIVATE LIMITED",
"HORIZONTAL INTEGRATION INDIA PRIVATE LIMITED",
"HORIZONTAL VENTURES PRIVATE LIMITED",
"HORIZONVIEW PROPERTIES PRIVATE LIMITED",
"HORIZZON INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"HORMIGON ENGINEERING AND INFRA PRIVATE LIMITED",
"HORN GLASS INDIA PRIVATE LIMITED",
"HORN OK PLEASE FINANCIAL SERVICES PRIVATE LIMITED",
"HORNBILL FX PRIVATE LIMITED",
"HORNBILL INFRASTRUCTURE SERVICES PRIVATE LIMITED",
"HORNBILL INTERNETWORKS PRIVATE LIMITED",
"HORNER ENGINEERING INDIA PRIVATE LIMITED",
"HORNERXPRESS INDIA PRIVATE LIMITED",
"HORNET DYNAMICS PRIVATE LIMITED",
"HORNET INFOTECH PRIVATE LIMITED",
"HORNIC COMMODITY DEALERS PRIVATE LIMITED",
"HORNIC INVESTMENT PRIVATE LIMITED",
"HOROLOGICAL COMPONENTS PVT LTD",
"HORSEPOWER DISTRIBUTION PRIVATE LIMITED",
"HORSES PRODUCTIONS PRIVATE LIMITED",
"HORSTER BIOTEK PRIVATE LIMITED",
"HORTBIO TECHNOLOGIES PRIVATE LIMITED",
"HORTICULTURE DEPARTMENT",
"HORUS SHIPPING AND TRADING PRIVATE LIMITED",
"HORVETECH PRIVATE LIMITED",
"HOSA SOLUTIONS PRIVATE LIMITED",
"HOSACHIGURU AGRI TECH PRIVATE LIMITED",
"HOSACHIGURU ENTERPRISES PRIVATE LIMITED",
"HOSCH EQUIPMENT (INDIA) LTD",
"HOSCO PRIVATE LIMITED",
"HOSCONS HEALTHCARE INDIA PRIVATE LIMITED",
"HOSEZONE ENGINEERS PRIVATE LIMITED",
"HOSHI AUTO PRIVATE LIMITED",
"HOSHI SECURITY INDIA PRIVATE LIMITED",
"HOSHI TOOLS PRIVATE LIMITED",
"HOSHIARPUR DOABA TRANSPORT COMPANY LIMITED",
"HOSHIYAR SINGH SURESH CHANDRA SAREES PRIVATE LIMITED",
"HOSHO CONSULTING PRIVATE LIMITED",
"HOSINDIA DISTRIBUTIONS PRIVATE LIMITED",
"HOSKOTE NEO HOMES LIMITED",
"HOSLAB ENGINEERING PRIVATE LIMITED",
"HOSLEY INDIA PRIVATE LIMITED",
"HOSMAC INDIA PRIVATE LIMITED",
"HOSMAT HOSPITAL",
"HOSOKAWA MICRON INDIA PRIVATE LIMITED",
"HOSPACCX HEALTHCARE BUSINESS CONSULTING PRIVATE LIMITED",
"HOSPEDIA MEDICARE PRIVATE LIMITED",
"HOSPET ISPAT PRIVATE LIMITED",
"HOSPET STEELS LIMITED",
"HOSPI LINE EQUIPMENTS PRIVATE LIMITED",
"HOSPI NEEDS MEDICAL SYSTEMS PRIVATE LIMITED",
"HOSPICAMED ASSOCIATES PRIVATE LIMITED",
"HOSPICARE LIFE SCIENCES PRIVATE LIMITED",
"HOSPIMAX HEALTHCARE PRIVATE LIMITED",
"HOSPIMEDICA INTERNATIONAL LIMITED",
"HOSPITAL FOR MENTAL HEALTH",
"HOSPITAL INFOTECH PRIVATE LIMITED",
"HOSPITAL INFRA SOLUTIONS PRIVATE LIMITED",
"HOSPITAL M C H AND PP CENTRE",
"HOSPITAL PROPERTY PRIVATE LIMITED",
"HOSPITAL SUPERINTENDENT K G HOSPITAL RAIGARH",
"HOSPITALIA EASTERN PRIVATE LIMITED",
"HOSPITALITY APPLIANCES PRIVATE LIMITED",
"HOSPITALITY CAD (OPC) PRIVATE LIMITED",
"HOSPITALITY CRM SOLUTIONS PRIVATE LIMITED",
"HOSPITALITY FIRST INDIA PRIVATE LIMITED",
"HOSPITALITY INITIATIVES INDIA PRIVATE LIMITED",
"HOSPITALITY LINK PRIVATE LIMITED",
"HOSPITY MART PRIVATE LIMITED",
"HOST ANALYTICS SOFTWARE PRIVATE LIMITED",
"HOST FINANCE AND INVESTMENTS PRIVATE LIMITED",
"HOST HOTELS & RESORTS, INC.",
"HOST INN PRIVATE LIMITED",
"HOST INTERNATIONAL PRIVATE LIMITED",
"HOSTDIME DATA CENTRE SERVICES PRIVATE LIMITED",
"HOSTECH PROJECT MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"HOSTIN SERVICES PRIVATE LIMITED",
"HOSTING CONCEPTS PRIVATE LIMITED",
"HOSTING WORLD PRIVATE LIMITED",
"HOSTPALACE WEB SOLUTION PRIVATE LIMITED",
"HOSTRA SYSTEMS PRIVATE LIMITED",
"HOSTROYALE TECHNOLOGIES PRIVATE LIMITED",
"HOSUR CERAMICS PRIVATE. LIMITED",
"HOSUR CNC APPLICATIONS PRIVATE LIMITED",
"HOSUR COIR FOAMS PRIVATE LIMITED",
"HOSUR DEVELOPMENT ENGINEERING CONSTRUCTIONS INDIA PRIVATE LIMITED",
"HOSUR FASTNERS AND ELECTRICALS PRIVATE LIMITED",
"HOSUR HOTELS PRIVATE LIMITED",
"HOSUR HYDRAULICS PRIVATE LIMITED",
"HOSUR MATTRESS INDUSTRIES INDIA PRIVATE LIMITED",
"HOSUR SMALL MICRO ENGINEERING COMPONENTS LIMITED",
"HOSUR SUPER SPECIALITY HOSPITALS PRIVATE LIMITED",
"HOSUR SURIYA PLASTICS PRIVATE LIMITED",
"HOSWIN INCINERATOR PRIVATE LIMITED",
"HOT & FRESH CANADIAN PIZZA PRIVATE LIMITED",
"HOT AIR PACKING PRIVATE LIMITED",
"HOT CAKES PRIVATE LIMITED",
"HOT CROSS BUNS FOODS INDIA PRIVATE LIMITED",
"HOT MOLD ENGINEERING INDIA PRIVATE LIMITED",
"HOTAGE OVERSEAS PRIVATE LIMITED",
"HOTBIT INFOSOFT LLP",
"HOTCODEL SOLUTIONS PRIVATE LIMITED",
"HOTCOURSES INDIA PRIVATE LIMITED",
"HOTCRETE INFRASTRUCTURE PRIVATE LIMITED",
"HOTEL AIRPORT KOHINOOR PVT LTD",
"HOTEL AJU PALACE PRIVATE LIMITED",
"HOTEL AMARJIT PVT LTD",
"HOTEL AMI RESIDENCY",
"HOTEL ANAND INTERNATIONAL PRIVATE LIMITED",
"HOTEL AND RESTAURANT ASSOCIATION (WESTERN INDIA)",
"HOTEL ANDAMAN SEA RESORT PRIVATE LIMITED",
"HOTEL ANNAMALAI INTERNATIONAL PRIVATE LIMITED",
"HOTEL ARAP PRIVATE LIMITED",
"HOTEL ARYAPRAVA PRIVATE LIMITED",
"HOTEL ASHWA PARK",
"HOTEL ASHWIN PRIVATE LIMITED",
"HOTEL ATLANTIC",
"HOTEL AVANTIKA PRIVATE LIMITED",
"HOTEL AVION PRIVATE LIMITED",
"HOTEL BABYLON CAPITAL PRIVATE LIMITED",
"HOTEL BABYLON INTERNATIONAL PRIVATE LIMITED",
"HOTEL BALAJI CENTRAL",
"HOTEL BALAJI CENTRAL PRIVATE LIMITED",
"HOTEL BALLERINA PVT LTD",
"HOTEL BALWAS PRIVATE LIMITED",
"HOTEL BANJARA LIMITED",
"HOTEL BELA CASA",
"HOTEL BMS PRIVATE LIMITED",
"HOTEL CENTER POINT",
"HOTEL CENTRAL POINT PRIVATE LIMITED",
"HOTEL CITY CENTAUR INTERNATIONAL PRIVATE LIMITED",
"HOTEL CLARK'S (VARANASI) LIMITED.",
"HOTEL COASTAL RESSIDENCY",
"HOTEL CONTESSA PRIVATE LIMITED",
"HOTEL CORPORATION OF INDIA LIMITED",
"HOTEL DAKSH RESIDENCY PRIVATE LIMITED",
"HOTEL DE GRAND MALABAR PRIVATE LIMITED",
"HOTEL DEKHO.COM PRIVATE LIMITED",
"HOTEL DESHMUKH WADA",
"HOTEL DREAMLAND PRIVATE LIMITED",
"HOTEL DURGADA SIRI PRIVATE LIMITED",
"HOTEL ENNORDEE INTERNATIONAL PRIVATE LIMITED",
"HOTEL EXCELSIOR LIMITED.",
"HOTEL FRIENDS REGENCY PRIVATE LIMITED",
"HOTEL GANESH MAHAAL (SALEM) PRIVATE LIMITED",
"HOTEL GANESH PRIVATE LIMITED",
"HOTEL GAUDAVAN PRIVATE LIMITED",
"HOTEL GOLDEN LEAF",
"HOTEL GOLDEN SWAN",
"HOTEL GOLKONDA",
"HOTEL GREEN PARK",
"HOTEL GURUDEVPRASAD PRIVATE LIMITED",
"HOTEL HARBOUR VIEW",
"HOTEL HARIMANGLA PRIVATE LIMITED",
"HOTEL HARSHIKHAR PRIVATE LIMITED",
"HOTEL HILLOCK PRIVATE LIMITED",
"HOTEL HILLTONE PRIVATE LIMITED",
"HOTEL HINDUSTAN INTERNATIONAL",
"HOTEL HOLIDAY RESORT PRIVATE LIMITED",
"HOTEL HUB",
"HOTEL HYATT HYDERABAD",
"HOTEL IMPERIAL",
"HOTEL INTERCITY INTERNATIONAL",
"HOTEL JAGAM PRIVATE LIMITED",
"HOTEL JAWAHAR INTERNATIONAL PVT LTD",
"HOTEL JAYAPUSHPAM PRIVATE LIMITED",
"HOTEL JN PRIVATE LIMITED",
"HOTEL JYOTDEEP PALACE PRIVATE LIMITED",
"HOTEL K. P. PARK INN PRIVATE LIMITED",
"HOTEL KADAMBARI REGENCY PRIVATE LIMITED",
"HOTEL KAMAL PRIVATE LIMITED",
"HOTEL LA PAZ GARDENS PRIVATE LIMITED",
"HOTEL LAKE VIEW PRIVATE LIMITED",
"HOTEL LAKSHMI NARAYANA PRIVATE LIMITED",
"HOTEL LAYA PRIVATE LIMITED",
"HOTEL LIBRARY CLUB PRIVATE LIMITED",
"HOTEL MAAS INN PRIVATE LIMITED",
"HOTEL MAHARAJA REGENCY",
"HOTEL MAHARANI PVT LTD",
"HOTEL MALAYORAM GATEWAY PRIVATE LIMITED",
"HOTEL MALLIGI PRIVATE LIMITED",
"HOTEL MARKAZ PRIVATE LIMITED",
"HOTEL MARUTHI PRIVATE LIMITED",
"HOTEL MAURYA PATNA",
"HOTEL MAYFAIR PRIVATE LIMITED",
"HOTEL METRO PALACE PRIVATE LIMITED",
"HOTEL MILAN PRIVATE LIMITED",
"HOTEL MIRAMAR COMFORT PVT LTD",
"HOTEL MM'S CHENNAI GATEWAY",
"HOTEL MONY LTD",
"HOTEL NAYANA PRIVATE LIMITED",
"HOTEL ORCHID",
"HOTEL PAGEONE",
"HOTEL PAL REGENCY PRIVATE LIMITED",
"HOTEL PALMLAKE (KANKARIA) PRIVATE LIMITED",
"HOTEL PANDIT PRIVATE LIMITED",
"HOTEL PARAS MAHAL PRIVATE LIMITED",
"HOTEL PARISUTHAM PRIVATE LIMITED",
"HOTEL PEARL DUNES PRIVATE LIMITED",
"HOTEL PERINGOTTUKARA PALACE PRIVATE LIMITED",
"HOTEL PERSIAN DARBAR PRIVATE LIMITED",
"HOTEL PLATINUM RESIDENCY",
"HOTEL POLO TOWERS PRIVATE LIMITED",
"HOTEL POONJA INTERNATIONAL PRIVATE LIMITED",
"HOTEL PREETHI INTERNATIONAL PRIVATE LIMITED",
"HOTEL PUSHPAMALA PRIVATE LIMITED",
"HOTEL QUEEN ROAD PRIVATE LIMITED",
"HOTEL RACHANA CONTINENTAL PVT LTD",
"HOTEL RADHA PRIVATE LIMITED",
"HOTEL RAH VILLAS & RESORTS PRIVATE LIMITED",
"HOTEL RAHMATH PRIVATE LIMITED",
"HOTEL RAJ HANS",
"HOTEL RAJ PARK PRIVATE LIMITED",
"HOTEL RAJ-RESIDENCY (HARDA) PRIVATE LIMITED",
"HOTEL RAJTILAK PVT LTD",
"HOTEL RANGOON RESORTS",
"HOTEL RANNI GATE PRIVATE LIMITED",
"HOTEL RED DIAMOND",
"HOTEL RESERVATION SERVICE ROBERT RAGGE G MBH",
"HOTEL RISHI CORNER (INDIA) PVT LTD",
"HOTEL ROYAL PARK PRIVATE LIMITED",
"HOTEL SAHIL PVT LTD",
"HOTEL SAI INTERNATIONAL PRIVATE LIMITED",
"HOTEL SAI KRIPA IMPERIAL",
"HOTEL SAMRAT",
"HOTEL SANDESH PRIVATE LIMITED",
"HOTEL SANGAMAM CHETTINAD AC RESTURANT",
"HOTEL SAVERA PRIVATE LIMITED",
"HOTEL SEA 'N' SAND PRIVATE LIMITED",
"HOTEL SEA VIEW PRIVATE LIMITED",
"HOTEL SEARS PVT LTD",
"HOTEL SHALIMAR DELUXE",
"HOTEL SHASHI PVT LTD",
"HOTEL SHERATON PRIVATE LIMITED",
"HOTEL SHILPIS INDIA PRIVATE LIMITED",
"HOTEL SHOPPEE INDIA PRIVATE LIMITED",
"HOTEL SHREE RAM EXCELLENCY",
"HOTEL SHREELEKHA REGENCY PRIVATE LIMITED",
"HOTEL SHRINGAR PVT LTD",
"HOTEL SIDDHARTHA PRIVATE LIMITED",
"HOTEL SIENA CENTRAL PRIVATE LIMITED",
"HOTEL SOFITEL PRIVATE LIMITED",
"HOTEL SOLARIS",
"HOTEL SONIA PRIVATE LIMITED",
"HOTEL SOUTHERN RESIDENCY",
"HOTEL SRINIVASA",
"HOTEL SRIVEEBA PRIVATE LIMITED",
"HOTEL SUBA PALACE PRIVATE LIMITED",
"HOTEL SUBA STAR PRIVATE LIMITED",
"HOTEL SUBASH PRIVATE LIMITED",
"HOTEL SUMMIT PRIVATE LIMITED",
"HOTEL SUN N SEA PRIVATE LIMITED",
"HOTEL SURBHI PALACE INDIA PRIVATE LIMITED",
"HOTEL SURYA PRIVATE LIMITED",
"HOTEL SWOSTI PRIVATE. LIMITED.",
"HOTEL TAJVIEW",
"HOTEL THREESTAR PRIVATE LIMITED",
"HOTEL TIPTOP INTERNATIONAL PRIVATE LIMITED",
"HOTEL TRANSIT PRIVATE LIMITED",
"HOTEL TUNGA REGENCY PRIVATE LIMITED",
"HOTEL UDAYANRAJE PALACE PRIVATE LIMITED",
"HOTEL VAIGAI PRIVATE LIMITED",
"HOTEL VEEYEMMAR INTERNATIONAL PRIVATE LIMITED",
"HOTEL VISHAL INTERNATIONAL",
"HOTEL WHITE DAMMAR INTERNATIONAL PRIVATE LIMITED",
"HOTEL& ALLIED TRADES PRIVATE LIMITED",
"HOTELHUB LLP",
"HOTELIVATE PRIVATE LIMITED",
"HOTELKEY INDIA PRIVATE LIMITED",
"HOTELOGIX INDIA PRIVATE LIMITED",
"HOTELS MART PRIVATE LIMITED",
"HOTEON TRADING PRIVATE LIMITED",
"HOTFOOT TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"HOTFUT SPORTS INFRASTRUCTURE PRIVATE LIMITED",
"HOTGEN BIOTECH INDIA PRIVATE LIMITED",
"HOTHAAT MARKETPLACE PRIVATE LIMITED",
"HOTLINE CAPITAL SERVICES PRIVATE LIMITED",
"HOTLOGICS INSURANCE MARKETING PRIVATE LIMITED",
"HOTMELT PACKAGING PRIVATE LIMITED",
"HOTPAD INDIA PRIVATE LIMITED",
"HOTSPOT INFODOT PRIVATE LIMITED",
"HOTSPOT RETAIL PRIVATE LIMITED",
"HOTSPOT SALES & SOLUTIONS PRIVATE LIMITED",
"HOTSTAR ELECTRICALS PRIVATE LIMITED",
"HOTSTUFF ADVERTISING PRIVATE LIMITED",
"HOTSTUFF EVENTS AND REPRO PRIVATE LIMITED",
"HOTTEX ENGINEERS PRIVATE LIMITED",
"HOTTRIX IT SERVICES PRIVATE LIMITED",
"HOTWAX SYSTEMS PRIVATE LIMITED",
"HOTWINE WINERY PRIVATE LIMITED",
"HOTZ INDUSTRIES LIMITED",
"HOUFU INFRATECH PRIVATE LIMITED",
"HOUFU MOTORS PRIVATE LIMITED",
"HOULIHAN LOKEY ADVISORY (INDIA) PRIVATE LIMITED",
"HOUR4U TECHNOLOGIES PRIVATE LIMITED",
"HOURGLASS DESIGN PRIVATE LIMITED",
"HOURGLASS ESSENTIALS PRIVATE LIMITED",
"HOURGLASS RESEARCH PRIVATE LIMITED",
"HOURS OVERSEAS PRIVATE LIMITED",
"HOUSE FULL INTERNATIONAL LIMITED",
"HOUSE MASTER FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"HOUSE MASTER GOVERNMENT TRIBAL BOYS HOSTEL NANDURBAR",
"HOUSE MASTER SERVICES PRIVATE LIMITED",
"HOUSE OF ANITA DONGRE LIMITED",
"HOUSE OF ANITA DONGRE PRIVATE LIMITED",
"HOUSE OF AWELLP COMPANY",
"HOUSE OF CARTONS (INDIA) PVT.LTD.",
"HOUSE OF CODE INDIA PRIVATE LIMITED",
"HOUSE OF DIAGNOSTICS HEALTHCARE PRIVATE LIMITED",
"HOUSE OF DIAGNOSTICS LLP",
"HOUSE OF FITNESS PRIVATE LIMITED",
"HOUSE OF HIRANANDANI GROUP",
"HOUSE OF JEWELS PRIVATE LIMITED",
"HOUSE OF MASABA LIFESTYLE PRIVATE LIMITED",
"HOUSE OF RAMAPURAM - FOODS PRIVATE LIMITED",
"HOUSE OF TYRES PRIVATE LIMITED",
"HOUSE OF VDJ PRIVATE LIMITED",
"HOUSE OF WANDERING SILK PRIVATE LIMITED",
"HOUSE OF WEARS PRIVATE LIMITED",
"HOUSE WARMING PRIVATE LIMITED",
"HOUSEBEE MEDIAHOUSE PRIVATE LIMITED",
"HOUSEEY SWAP TECH PRIVATE LIMITED",
"HOUSEHOLD PHARMACEUTICALS LIMITED",
"HOUSENEED DOORSTEP SERVICES PRIVATE LIMITED",
"HOUSEPITAL PRIVATE LIMITED",
"HOUSEWISE SERVICES PRIVATE LIMITED",
"HOUSIFY BUILDERS PRIVATE LIMITED",
"HOUSING AND URBAN DEVELOPMENT CORPORATION LIMITED",
"HOUSING AND URBAN DEVELOPMENT CORPORATION LIMITED HUDCO",
"HOUSING DEVELOPMENT FINANCE CORPORATION LIMITED",
"HOUSING.COM",
"HOUSR PROPTECH PRIVATE LIMITED",
"HOUSR SERVICES PRIVATE LIMITED",
"HOUSTAN INNOVATIONS LLP",
"HOUSTON EQUITY PRIVATE LIMITED",
"HOUSTON TECHNOLOGIES LIMITED",
"HOV SERVICES LIMITED",
"HOVIS FOODS INDIA PRIVATE LIMITED",
"HOWARD HOTELS LIMITED",
"HOWD INNOVATIONS PRIVATE LIMITED",
"HOWDEN AIR & GAS INDIA PRIVATE LIMITED",
"HOWDEN AIR AND GAS INDIA PRIVATE LIMITED",
"HOWDEN INSURANCE BROKERS INDIA PRIVATE. LIMITED.",
"HOWDEN SOLYVENT INDIA PRIVATE LIMITED",
"HOWDEN THOMASSEN COMPRESSORS INDIA PRIVATE LIMITED",
"HOWDY VENTURES PRIVATE LIMITED",
"HOWE ENGINEERING PROJECTS INDIA PRIVATE LIMITED",
"HOWE INDIA PRIVATE LIMITED",
"HOWE ROBINSON SHIPPING INDIA PRIVATE LIMITED",
"HOWELL ENERGY SYSTEMS PRIVATE LIMITED",
"HOWELL PROTECTION SYSTEMS INDIA PRIVATE LIMITED",
"HOWEWORK SPACES PRIVATE LIMITED",
"HOWLADER VENTURES PRIVATE LIMITED",
"HOWRAH BRIDGE FOOD PARK PRIVATE LIMITED",
"HOWRAH DISTRICT HOSPITAL",
"HOWRAH FLOUR MILLS LTD",
"HOWRAH GASES LIMITED.",
"HOWRAH IMPROVEMENT TRUST",
"HOWRAH ISPAT PVT LTD",
"HOWRAH MARKETING PRIVATE LIMITED",
"HOWRAH MOTOR ACCESSORIES AGENCY PVT LTD",
"HOWRAH MUNICIPAL CORPORATION",
"HOWRAH STEEL & METALCRAFTS PRIVATE LIMITED",
"HOYA LENS INDIA PRIVATE LIMITED",
"HOYA MEDICAL INDIA PRIVATE LIMITED",
"HOYSALA PROJECTS PRIVATE LIMITED",
"HOYSALA TOURS AND TRAVELS PRIVATE LIMITED",
"HP ADHESIVES LIMITED",
"HP COMPUTING AND PRINTING SYSTEMS INDIA PRIVATE LIMITED",
"HP COTTON TEXTILE MILLS LIMITED",
"HP ENTERPRISE GLOBAL SOFT PRIVATE LIMITED",
"HP FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"HP FINANCIAL SERVICES PRIVATE LIMITED",
"HP GOVT DENTAL COLLEGE HOSPITAL",
"HP HOUSING AND URBAN DEVELOPMENT AUTHORITY",
"HP INDIA SALES PRIVATE LIMITED",
"HP INSTITUTE OF PUBLIC ADMN",
"HP INTERNATIONAL LIMITED",
"HP NUTRITIONS PRIVATE LIMITED",
"HP PPS INDIA OPERATIONS PRIVATE LIMITED",
"HP PPS SERVICES INDIA PRIVATE LIMITED",
"HP TELECOM INDIA PRIVATE LIMITED",
"HP TRONIC PUNE PRIVATE LIMITED",
"HP VALVES & FITTINGS (PONDY) PRIVATE LIMITED",
"HPA AND SONS PRIVATE LIMITED",
"HPA TECHNOHUB (INDIA) PRIVATE LIMITED",
"HPA TRANSTRADE PRIVATE LIMITED",
"HPC INFOTECH PRIVATE LIMITED",
"HPC PACKAGING PRIVATE LIMITED",
"HPCL BIOFUELS LIMITED",
"HPCL LNG LIMITED",
"HPCL MITTAL ENERGY LIMITED",
"HPCL RAJASTHAN REFINERY LIMITED",
"HPCL-MITTAL FOUNDATION",
"HPCL-MITTAL PIPELINES LIMITED",
"HPDL WEAVING AND PRINTING PRIVATE LIMITED",
"HPE SMART CITY PROJECT",
"HPI FOREX PRIVATE LIMITED",
"HPKV METAL FINISHERS PRIVATE LIMITED",
"HPL ADDITIVES LIMITED",
"HPL DECOR PRIVATE LIMITED",
"HPL ELECTRIC & POWER LIMITED",
"HPL ELECTRIC AND POWER PRIVATE LIMITED",
"HPL GLOBAL SERVICES PRIVATE LIMITED",
"HPL GO PRIVATE LIMITED",
"HPL INDIA LIMITED",
"HPL LOGISTICS PRIVATE LIMITED",
"HPL MERCANTILE PRIVATE LIMITED",
"HPL SECURITIES PRIVATE LIMITED",
"HPL WAREHOUSING PRIVATE LIMITED",
"HPM CHEMICALS AND FERTILIZER LIMITED",
"HPM CONSTRUCTIONS PRIVATE LIMITED",
"HPMC SALES LIMITED",
"HPMG SHARES AND SECURITIES PRIVATE LIMITED",
"HPNL GRO PRIVATE LIMITED",
"HPOIL GAS PRIVATE LIMITED",
"HPR LOGISTICS PRIVATE LIMITED",
"HPR SYNERGY ENGINEERING PRIVATE LIMITED",
"HPRJ AGRI TRADERS PRIVATE LIMITED",
"HPRT INDIA PRIVATE LIMITED",
"HPS ENTERPRISES",
"HPS EXIM PRIVATE LIMITED",
"HPS LOYALTY VENTURES PRIVATE LIMITED",
"HPS WELLNESS PRIVATE LIMITED",
"HPV ELEVATE HVAC ENGINEERS PRIVATE LIMITED",
"HQ CHIEF ENGINEER JABALPUR ZONE",
"HQ MUMBAI SUB AREA",
"HQ RTG ZONE MP & CG JABALUR",
"HR ANEXI PRIVATE LIMITED",
"HR AUTOMOBILE PRIVATE LIMITED",
"HR BHATIA SERVICES PRIVATE LIMITED",
"HR CHAMBERS OUTSOURCING PRIVATE LIMITED",
"HR CLEARING & FORWARDING PRIVATE LIMITED",
"HR COMMERCIALS PRIVATE LIMITED",
"HR ELECTRONICS PRIVATE LIMITED",
"HR ENTERPRISE",
"HR FOOD PROCESSING PRIVATE LIMITED",
"HR INDUSTRY",
"HR INFRATEL INDIA PRIVATE LIMITED",
"HR INNOV FOR DIVISION OF RENESOLA INDIA PRIVATE LIMITED",
"HR INTEGRATED MEDIA PRIVATE LIMITED",
"HR INTER COLLEGE",
"HR KAVERI PRIVATE LIMITED",
"HR LOOPS LLP",
"HR MINERALS AND ALLOYS PRIVATE. LIMITED.",
"HR MUSIK LIMITED",
"HR NEETI PRIVATE LIMITED",
"HR NUTRITIOUS MEALS PRIVATE LIMITED",
"HR PATH INDIA PRIVATE LIMITED",
"HR POLYCOATS PRIVATE LIMITED",
"HR REMEDY INDIA",
"HR SERVICES INDIA PRIVATE LIMITED",
"HR SQUARE LLP",
"HR TALENT SOLUTIONS PRIVATE LIMITED",
"HRA PHARMA PRIVATE LIMITED",
"HRA SALES PRIVATE LIMITED.",
"HRC INFRA PRIVATE LIMITED",
"HRC STEELS PRIVATE LIMITED",
"HRC TECHNOLOGIES PRIVATE LIMITED",
"HRCS SERVICES PRIVATE LIMITED",
"HRD AUTOMATION ENGINEERS PRIVATE LIMITED",
"HRD BUILDERS PRIVATE LIMITED",
"HRD COMMERCIAL & INDUSTRIAL SECURITY FORCE PRIVATE LIMITED",
"HRD DIAMOND INSTITUTE PRIVATE LIMITED",
"HRDK BULLION & REFINERY PRIVATE LIMITED",
"HRG BUILDHOME DEVLOPERS PRIVATE LIMITED",
"HRG INFRASTRUCTURE PRIVATE LIMITED",
"HRG TRADING PRIVATE LIMITED",
"HRH CONSTRUCTIONS PRIVATE LIMITED",
"HRH NEXT SERVICES PRIVATE LIMITED",
"HRI HEALTHCARE PRIVATE LIMITED",
"HRIDAAN MOTORS LLP",
"HRIDAY AUTOMOBILES PRIVATE LIMITED",
"HRIDAY CARS PRIVATE LIMITED",
"HRIDAY STAINLESS PRIVATE LIMITED",
"HRIDAYAM SOFT SOLUTIONS PRIVATE LIMITED",
"HRIDHAAN ENGINEERING PRIVATE LIMITED",
"HRIDHAN CHEM PRIVATE LIMITED",
"HRIDOL CHEMICALS PRIVATE LIMITED",
"HRIDYA CARS PRIVATE LIMITED",
"HRIDYA HEART CARE PRIVATE LIMITED",
"HRIDYANSHU HEALTH CARE PRIVATE LIMITED",
"HRIMKAR CREATIONS PRIVATE LIMITED",
"HRIMTECH SOLUTIONS PRIVATE LIMITED",
"HRISHA CONSULTING PRIVATE LIMITED",
"HRISHABH LIFE SCIENCES",
"HRISHIKESA INFRATECH PRIVATE LIMITED",
"HRISHIKESH AMRUTALAYA PRIVATE LIMITED",
"HRISHIKESH ENGINEERING PRIVATE LIMITED",
"HRISHIKESH INDUSTRIAL FABRICS PRIVATE LIMITED",
"HRISHIKESH TECHNOLOGIES PRIVATE LIMITED",
"HRISHITA INVESTMENTS ADVISORY PRIVATE LIMITED",
"HRISHITA PRIVATE LIMITED",
"HRISON PHARMACHEM PRIVATE LIMITED",
"HRITIK CHEMICALS PRIVATE LIMITED",
"HRITNIK EXPORT PRIVATE LIMITED",
"HRIWA HOUSING PRIVATE LIMITED",
"HRJ STEELS PRIVATE LIMITED",
"HRJ TECHNOLOGY PRIVATE LIMITED",
"HRK CORPORATION PRIVATE LIMITED",
"HRK SONS CABLE SERVICES PRIVATE LIMITED",
"HRL FOODS PRIVATE LIMITED",
"HRM OVERSEAS",
"HRMM AGRO OVERSEAS PRIVATE LIMITED",
"HRMS CONSULTING",
"HRP INFRA PRIVATE LIMITED",
"HRPL PRIVATE LIMITED",
"HRPL RESTAURANTS PRIVATE LIMITED",
"HRS ALUGLAZE PRIVATE LIMITED",
"HRS FLOW INDIA PRIVATE LIMITED",
"HRS HOSPITALITY SOFTWARE PRIVATE LIMITED",
"HRS INDIA PRIVATE LIMITED",
"HRS INSIGHT FINANCIAL INTERMEDIARIES PRIVATE LIMITED",
"HRS PROCESS SYSTEMS LIMITED",
"HRTI PRIVATE LIMITED",
"HRTMS ONLINE PRIVATE LIMITED",
"HRTR ENTERPRISES PRIVATE LIMITED",
"HRUDAI AGRI PRIVATE LIMITED",
"HRUDAI AQUA FOODS PRIVATE LIMITED",
"HRUDAY INFRA AND RESOURCE SOLUTIONS PRIVATE LIMITED",
"HRUDAYA HEALTH CARE PRIVATE LIMITED",
"HRUDAYAM SUPER SPECIALITY HOSPITAL & RESEARCH CENTER",
"HRUTVIK CONSULTANCY SERVICES",
"HRV CERTPRO PRIVATE LIMITED",
"HRV CONGLOMERATE PRIVATE LIMITED",
"HRV GLOBAL LIFE SCIENCES PRIVATE LIMITED",
"HRV RESIDENCY PRIVATE LIMITED",
"HS AKASH AGRO INDIA PRIVATE. LIMITED.",
"HS ALLIANCE PRIVATE LIMITED",
"HS BUSINESS SERVICES PRIVATE LIMITED",
"HS CONSTRUCTION PRIVATE LIMITED",
"HS DENTAL INSTITUTE PRIVATE LIMITED",
"HS EDIBLE OILS PRIVATE LIMITED",
"HS FITNESS PRIVATE LIMITED",
"HS INFRACARE PROJECTS LLP",
"HS MARATHON CAPITAL PRIVATE LIMITED",
"HS SACHDEVA PROPERTIES AND BUILDERS PRIVATE LIMITED",
"HS STRUCTURES PRIVATE LIMITED",
"HS WEAVERS PRIVATE LIMITED",
"HS3D VISUALIZATION PRIVATE LIMITED",
"HSA APPAREL PRIVATE LIMITED",
"HSA CONSULTANCY PRIVATE LIMITED",
"HSA PHARMA PRIVATE LIMITED",
"HSA TRADERS PRIVATE LIMITED",
"HSA VENTURES PRIVATE LIMITED",
"HSAG CONSULTING PRIVATE LIMITED",
"HSAJL INDIA PRIVATE LIMITED",
"HSB AGRO INDUSTRIES LIMITED",
"HSB ENTERPRISES PRIVATE LIMITED",
"HSB ESTATES PRIVATE LIMITED",
"HSB INTERNATIONAL (INDIA) PRIVATE LIMITED",
"HSB SECURITIES & EQUITIES LIMITED",
"HSBC ASSET MANAGEMENT INDIA PRIVATE LIMITED",
"HSBC BANK",
"HSBC ELECTRONIC DATA PROCESSING INDIA PRIVATE LIMITED",
"HSBC INVESTDIRECT (INDIA) PRIVATE LIMITED",
"HSBC INVESTDIRECT FINANCIAL SERVICES INDIA LIMITED",
"HSBC INVESTDIRECT INDIA LIMITED",
"HSBC INVESTDIRECT SALES & MARKETING INDIA LIMITED",
"HSBC INVESTDIRECT SECURITIES INDIA PRIVATE LIMITED",
"HSBC PROFESSIONAL SERVICES",
"HSBC SECURITIES & CAPITAL MARKETS INDIA PRIVATE LIMITED",
"HSBC SOFTWARE DEVELOPMENT INDIA PRIVATE LIMITED",
"HSC INFRAPROJECTS PRIVATE LIMITED",
"HSCC INDIA LIMITED",
"HSCS MITHRA SERVICES INDIA PRIVATE LIMITED",
"HSD BATTERIES INDIA PRIVATE LIMITED",
"HSDL INNOVATIVE PRIVATE LIMITED",
"HSE ENGINEERS PRIVATE LIMITED",
"HSE INTEGRO PRIVATE LIMITED",
"HSE RISK MANAGEMENT SERVICES PRIVATE LIMITED",
"HSF FOOD PRO-TECH PRIVATE LIMITED",
"HSH TECHNOMOTIVE PRIVATE LIMITED",
"HSHS NUTRACEUTICALS LIMITED",
"HSI AUTOMOTIVES PRIVATE LIMITED",
"HSK FABRIC PRIVATE LIMITED",
"HSK INFRA PRIVATE LIMITED",
"HSK IT SOLUTIONS INDIA PRIVATE LIMITED",
"HSL AGRI SOLUTIONS LIMITED",
"HSM EDIFICE CONSTRUCTION SERVICES PRIVATE LIMITED",
"HSM FOODS INTERNATIONAL PRIVATE LIMITED",
"HSM GLOBAL LOGISTICS PRIVATE LIMITED",
"HSM HYDRO CONTROL PRIVATE LIMITED",
"HSM INDIA PRIVATE LIMITED",
"HSM MARINE SERVICES PRIVATE LIMITED",
"HSM PACKAGING PRIVATE LIMITED",
"HSM STEELS PRIVATE LIMITED",
"HSN HOTEL PRODUCTS PRIVATE LIMITED",
"HSN INTERIORS PRIVATE LIMITED",
"HSNA MARITIME EDUCATION AND RESEARCH PRIVATE LIMITED",
"HSO INDIA PRIVATE LIMITED",
"HSODHI VENTURES PRIVATE LIMITED",
"HSP OFFICE BASICS PRIVATE LIMITED",
"HSPS TEXTILE PRIVATE LIMITED",
"HSQUARE SPORTS PRIVATE LIMITED",
"HSR IT SOLUTIONS PRIVATE LIMITED",
"HSR LOGISTICS PRIVATE LIMITED",
"HSR VENTURES PRIVATE LIMITED",
"HSR WHOLESALE & RETAIL PRIVATE LIMITED",
"HSRC INFRA SERVICES LIMITED",
"HSS APPAREL PRIVATE LIMITED",
"HSS BIM SOLUTION PRIVATE LIMITED",
"HSS MAHUD MACHANDUR OFFICE OF HSS",
"HSS SECURE SERVICES PRIVATE LIMITED",
"HSS SOLUTIONS PRIVATE LIMITED",
"HSS SUBHASH CHANDRA BOSE HSS NIPANIYA GOYAL",
"HST STEELS PRIVATE LIMITED",
"HSV MEDIA PRIVATE LIMITED",
"HSV TRADERS PRIVATE LIMITED",
"HT COMPUTERS INDIA PRIVATE LIMITED",
"HT DIGITAL STREAMS LIMITED",
"HT FOODS PRIVATE LIMITED",
"HT HOTELS AND FINANCE PVT LTD",
"HT LEARNING CENTERS LIMITED",
"HT MEDIA LIMITED",
"HT MOBILE SOLUTIONS LIMITED",
"HT MUSIC AND ENTERTAINMENT COMPANY LIMITED",
"HT NOIDA (COMPANY) LIMITED",
"HT PROCESS CONTROLS PRIVATE LIMITED",
"HT TECHNOLOGIES PRIVATE LIMITED",
"HTA INSTRUMENTATION PRIVATE LIMITED",
"HTA MARKETING SERVICES PRIVATE LIMITED",
"HTA TEA AND AGRO PRIVATE LIMITED",
"HTB INFRA PRIVATE LIMITED",
"HTC FINANCE PVT LTD",
"HTC GLOBAL FINANCIAL SERVICES PRIVATE LIMITED",
"HTC GLOBAL SERVICES (INDIA) PRIVATE LIMITED",
"HTC HOLDINGS PRIVATE LIMITED",
"HTC INDIA PRIVATE LIMITED",
"HTC VALVES PRIVATE LIMITED",
"HTE ENGINEERS PRIVATE LIMITED",
"HTF MARKET INTELLIGENCE CONSULTING PRIVATE LIMITED",
"HTH TECHNOLABS PRIVATE LIMITED",
"HTI ENGINEERING PRIVATE LIMITED",
"HTIS TELECOM PRIVATE LIMITED",
"HTL AIRCON PRIVATE LIMITED",
"HTL CO. INDIA PRIVATE LIMITED",
"HTL FOOTWEAR PRIVATE LIMITED",
"HTL ISPAT PRIVATE LIMITED",
"HTL LIMITED",
"HTL METAL PRIVATE LIMITED",
"H-T-L PERMA INDIA PRIVATE LIMITED",
"HTM HYDRAULICS PRIVATE LIMITED",
"HTMT PRIVATE LIMITED",
"HTNS LOGISTICS INDIA PRIVATE LIMITED",
"H-TOWN TECHNOLOGIES INDIA PRIVATE LIMITED",
"HTP GLOBAL TECHNOLOGIES PRIVATE LIMITED",
"HTPL LOGISTICS PRIVATE LIMITED",
"HTR RUBBER INDIA PRIVATE LIMITED",
"HTS BIOPHARMA PRIVATE LIMITED",
"HTS HOT RUNNER SYSTEMS INDIA PRIVATE LIMITED",
"HTS INDIA LLP",
"HTS PETROCHEM PRIVATE LIMITED",
"HTS SECURITIES PRIVATE LIMITED",
"HTTPCART TECHNOLOGIES PRIVATE LIMITED",
"HTTPOOL DIGITAL PRIVATE LIMITED",
"HTV INTERNATIONAL PRIVATE LIMITED",
"HU SOFTWARE INDIA PRIVATE LIMITED",
"HUAFON INDIAN PRIVATE LIMITED",
"HUAHENG AUTOMATION PRIVATE LIMITED",
"HUAKE ENGINEERING INDIA PRIVATE LIMITED",
"HUALU TEXTILES PRIVATE LIMITED",
"HUAPTEC TELECOM INDIA PRIVATE LIMITED",
"HUAQI INTELLIGENT INDIA PRIVATE LIMITED",
"HUAREN LINEN INDIA PRIVATE LIMITED",
"HUARONG PLASTIC MACHINERY INDIA PRIVATE LIMITED",
"HUAWEI TECHNOLOGIES INDIA PRIVATE LIMITED",
"HUAWEI TELECOMMUNICATIONS INDIA CO. PRIVATE LIMITED",
"HUAYUAN TRADE PRIVATE LIMITED",
"HUB AND LINKS LOGISTICS INDIA PRIVATE LIMITED",
"HUB AND OAK ACCELERATOR PRIVATE LIMITED",
"HUB SPORTS EQUIPMENT PRIVATE LIMITED",
"HUB-AI TECHNOLOGIES PRIVATE LIMITED",
"HUBBELL INDIA ELECTRICAL PRODUCTS LLP",
"HUBBLAL INTER COLLEGE",
"HUBBLE CONNECTED INDIA PRIVATE LIMITED",
"HUBBLER PRIVATE LIMITED",
"HUBCO TECHNOLOGIES PRIVATE LIMITED",
"HUBENGAGE INDIA PRIVATE LIMITED",
"HUBER INDIA PRIVATE LIMITED",
"HUBER PROCESS CONTROL SYSTEMS INDIA PRIVATE LIMITED",
"HUBER SUHNER ELECTRONICS PRIVATE LIMITED",
"HUBERGROUP INDIA PRIVATE LIMITED",
"HUBERT BURDA MEDIA INDIA PRIVATE LIMITED",
"HUBERT EBNER INDIA PRIVATE LIMITED",
"HUBERT ENVIRO CARE SYSTEMS PRIVATE LIMITED",
"HUBERT HEALTHCARE PRIVATE LIMITED",
"HUBERT MONEY CHANGER PRIVATE LIMITED",
"HUBILO SOFTECH PRIVATE LIMITED",
"HUBINO TECHNOLOGIES PRIVATE LIMITED",
"HUBLI ASSISTED CONCEPTION CENTRE PRIVATE LIMITED",
"HUBLI ELECTRICITY SUPPLY COMPANY LIMITED",
"HUBLI SCAN CENTRE PRIVATE LIMITED",
"HUBLIT LIGHTING PRIVATE LIMITED",
"HUBLORE HEALTHCARE PRIVATE LIMITED",
"HUBMATRIX TECHNOLOGIES PRIVATE LIMITED",
"HUBNER INTERFACE SYSTEMS INDIA PRIVATE LIMITED",
"HUBRA PHARMACEUTICALS PRIVATE LIMITED",
"HUBRIS TECHNOLOGIES PRIVATE LIMITED",
"HUBSTREAM INDIA PRIVATE LIMITED",
"HUBTOWN BUS TERMINAL (ADAJAN) PRIVATE LIMITED",
"HUBTOWN BUS TERMINAL (AHMEDABAD) PRIVATE LIMITED",
"HUCON SOLUTIONS INDIA PRIVATE LIMITED",
"HUDA EQUIPMENTS PRIVATE LIMITED",
"HUDA FOODS PRIVATE LIMITED",
"HUDDERSFIELD TEXTILES PRIVATE LIMITED",
"HUDDL ENTERPRISE COMMUNICATION PRIVATE LIMITED",
"HUDDLE SOLUTIONS PRIVATE LIMITED",
"HUDEI METALS PRIVATE LIMITED",
"HUDL INDIA PRIVATE LIMITED",
"HUDLI AND SONS AUTO ENGINEERING PRIVATE LIMITED",
"HUDSON BAY IMMIGRATION SERVICES PRIVATE LIMITED",
"HUDSON DATA PRIVATE LIMITED",
"HUDSON FOODS PRIVATE LIMITED",
"HUDSON INSURANCE BROKERS PRIVATE LIMITED",
"HUDSON'S BAY SERVICES PRIVATE LIMITED",
"HUE CHEM TEXTILES PRIVATE LIMITED",
"HUE SERVICE PRIVATE LIMITED",
"HUECK DECENT ENGRAVING INDIA PRIVATE LIMITED",
"HUEGLI TECH ENGINEERING PRIVATE LIMITED",
"HUEGO SERVICES PRIVATE LIMITED",
"HUEMAN GRAPHICS PRIVATE LIMITED",
"HUEQ TECHNOLOGIES PRIVATE LIMITED",
"HUES ADVERTISING AND MARKETING PRIVATE LIMITED",
"HUES GRANITES PRIVATE LIMITED",
"HUETRAP CLOTHING PRIVATE LIMITED",
"HUEY TECH PRIVATE LIMITED",
"HUF INDIA PRIVATE LIMITED",
"HUFORT HEALTHCARE PRIVATE LIMITED",
"HUG FOODS PRIVATE LIMITED",
"HUGEL INFRA PRIVATE LIMITED",
"HUGEL TRADING SOLUTIONS INDIA PRIVATE LIMITED",
"HUGHES AND HUGHES CHEM LIMITED",
"HUGHES COMMUNICATIONS INDIA LIMITED",
"HUGHES NETWORK SYSTEMS INDIA LIMITED",
"HUGHES NETWORK SYSTEMS INDIA PRIVATE LIMITED",
"HUGHES SYSTIQUE PRIVATE LIMITED",
"HUGO PLAY PRIVATE LIMITED",
"HUGOPHARM TECHNOLOGIES PRIVATE LIMITED",
"HUHTAMAKI FOODSERVICE PACKAGING INDIA PRIVATE LIMITED",
"HUHTAMAKI INDIA LIMITED FORMERLY KNOWN AS HUHTAMAKI PPL LIMITED",
"HUI SONS MARKETING PRIVATE LIMITED",
"HUIFE TWOBROS PRIVATE LIMITED",
"HUIJIN ELECTRONIC INDIA PRIVATE LIMITED",
"HUIYU CONSTRUCTION AND DEVELOPMENT PRIVATE LIMITED",
"HUIZHONG AUTOMOBILE COMPONENTS INDIA PRIVATE LIMITED",
"HUKAM AUTOMOBILES PRIVATE LIMITED",
"HUKAM CHAND GUPTA FABRICS PRIVATE LIMITED",
"HUKMAWATI COLD STORAGE PRIVATE LIMITED",
"HUKUMATRAY INDUSTRIES PRIVATE LIMITED",
"HULA HOOP VFX PRIVATE LIMITED",
"HULA INFOTAINMENT STUDIOS PRIVATE LIMITED",
"HULAMANI BROTHERS PACKAGING PRIVATE LIMITED",
"HULASI METALS PRIVATE LIMITED",
"HULDIBARI INDUSTRIES & PLANTATION COMPANY LIMITED",
"HULE CONSTRUCTIONS PRIVATE LIMITED",
"HULIKKAL ELECTRO (INDIA) PRIVATE LIMITED",
"HULKAPPS PRIVATE LIMITED",
"HULKBOOSTERS NUTRITION PRIVATE LIMITED",
"HULKOTI HORTICULTURE FARMERS PRODUCER COMPANY LIMITED",
"HULKUL DEVELOPERS PRIVATE LIMITED",
"HULLADEK RECYCLING PRIVATE LIMITED",
"HULLUMANE PROPERTIES & POWER PRIVATE LIMITED",
"HULM ENTERTAINMENT PRIVATE LIMITED",
"HULSBERG ENTERPRISES PRIVATE LIMITED",
"HUM DEVELOPERS PRIVATE LIMITED",
"HUM FAUJI FINANCIAL SERVICES PRIVATE LIMITED",
"HUM INDIA FAB PRIVATE LIMITED",
"HUMA EXPORTS AND TECHNOCONSULTANTS PRIVATE LIMITED",
"HUMA SPECIALISED HOSPITAL",
"HUMA SPECIALISTS HOSPITAL & RESEARCH CENTRE PRIVATE LIMITED",
"HUMAN BIOLIFE INDIA PRIVATE LIMITED",
"HUMAN BIOLIFE PRIVATE LIMITED",
"HUMAN BIO-ORGANICS PRIVATE LIMITED",
"HUMAN CAPITAL FOR THIRD SECTOR",
"HUMAN CARE MEDICAL CHARITABLE TRUST",
"HUMAN DATA SYSTEMS PRIVATE LIMITED",
"HUMAN DYNAMIC INDIA PRIVATE LIMITED",
"HUMAN EDGE ADVISORY SERVICES PRIVATE LIMITED",
"HUMAN EMPOWER",
"HUMAN FACTORS INTERNATIONAL PRIVATE LIMITED",
"HUMAN FACTORS RESEARCH & DESIGN PRIVATE LIMITED",
"HUMAN LOGIC TECHNOLOGIES INDIA PRIVATE LIMITED",
"HUMAN POWER SERVICES PRIVATE LIMITED",
"HUMAN RACERS ADVISORY PRIVATE LIMITED",
"HUMAN RESOURCE SOCIETY",
"HUMAN VALUE DEVELOPERS PRIVATE LIMITED",
"HUMANA FINANCIAL SERVICES PRIVATE LIMITED",
"HUMANA FORMULATIONS PRIVATE LIMITED",
"HUMANA PEOPLE TO PEOPLE INDIA",
"HUMANBIOLOGICS PRODUCTS AND SERVICES (OPC) PRIVATE LIMITED",
"HUMANCARE WORLD WIDE PRIVATE LIMITED",
"HUMANCLOUD TECHNOLOGIES PRIVATE LIMITED",
"HUMANE BUSINESS INTELLIGENCE TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"HUMANE SOCIETY INTERNATIONAL INDIA",
"HUMANETICS INNOVATIVE SOLUTIONS INDIA PRIVATE LIMITED",
"HUMANI MEDIA CONSULTANCY",
"HUMANIQUE CONSULTING PRIVATE LIMITED",
"HUMANIT SOLUTIONS PRIVATE LIMITED",
"HUMANITICS DIMENSIONS SOFTWARE PRIVATE LIMITED",
"HUMANITY WELFARE COUNCIL",
"HUMANIX LIFESCIENCES PRIVATE LIMITED",
"HUMANLINKS TECHNOLOGIES PRIVATE LIMITED",
"HUMANS OF BOMBAY STORIES PRIVATE LIMITED",
"HUMANTECH SOLUTIONS INDIA PRIVATE LIMITED",
"HUMANWARE TECHNOLOGY PRIVATE LIMITED",
"HUMARA MEDIALABS PRIVATE LIMITED",
"HUMAYAN PROPERTIES LTD",
"HUMBING ETHICALS",
"HUMBLE COWS PRIVATE LIMITED",
"HUMBLE HEALTHCAARE LIMITED",
"HUMBLE HOSPITALITY (PUNJAB) PRIVATE LIMITED",
"HUMBLE MOBILE SOLUTIONS PRIVATE LIMITED",
"HUMBLE MUSIC PRIVATE LIMITED",
"HUMBLE PLASTICS PRIVATE LIMITED",
"HUMBOLDT WEDAG INDIA PRIVATE LIMITED",
"HUMI AIR SYSTEMS PRIVATE LIMITED",
"HUMINT GLOBAL TECHNOLOGIES PRIVATE LIMITED",
"HUMISEAL INDIA PRIVATE LIMITED",
"HUMMEL CONNECTOR SYSTEMS PRIVATE LIMITED",
"HUMMEL INDIA PRIVATE LIMITED",
"HUMMING BIRD DIGITAL PRIVATE LIMITED",
"HUMMING BIRD EDUCATION PRIVATE LIMITED",
"HUMMINGBIRD FOODS AND BEVERAGES PRIVATE LIMITED",
"HUMMINGBIRD WEB SOLUTIONS PRIVATE LIMITED",
"HUMMINGWAVE TECHNOLOGIES PRIVATE LIMITED",
"HUMONICS GLOBAL PRIVATE LIMITED",
"HUMOSERVE SOLUTIONS PRIVATE LIMITED",
"HUMSAA EXIM PRIVATE LIMITED",
"HUMSAFAR CONSUMER CARE PRIVATE LIMITED",
"HUMSAFAR TRADECOM PRIVATE LIMITED",
"HUNARSOURCE CONSULTING (OPC) PRIVATE LIMITED",
"HUNCH CIRCLE PRIVATE LIMITED",
"HUNDIA INFOSOLUTIONS PRIVATE LIMITED",
"HUNDRED MILLION AGRO PRIVATE LIMITED",
"HUNGAMA .COM PRIVATE LIMITED",
"HUNGAMA DIGITAL MEDIA ENTERTAINMENT PRIVATE LIMITED",
"HUNGAMA DIGITAL SERVICES",
"HUNGAMA GAME PLANET PRIVATE LIMITED",
"HUNGER INC HOSPITALITY PRIVATE LIMITED",
"HUNGER PANGS PRIVATE LIMITED",
"HUNGRY BAGS PRIVATE LIMITED",
"HUNGRY N THIRSTY FOODS PRIVATE LIMITED",
"HUNGRY WOLF KITCHEN PRIVATE LIMITED",
"HUNGRY WOLVES ENTERTAINMENT PRIVATE LIMITED",
"HUNJYOTI TEA & INDUSTRIES PRIVATE LIMITED",
"HUNKY DORY TRAVEL PRIVATE LIMITED",
"HUNNAR JEWELS LIMITED",
"HUNNAR SHAALA FOUNDATION FOR BUILDING TECHNOLOGY AND INNOVATIONS",
"HUNNARVI TECHNOLOGIES PRIVATE LIMITED",
"HUNNY MOTORS PRIVATE LIMITED",
"HUNS DIGITAL HOMES PRIVATE LIMITED",
"HUNSUR PLYWOOD WORKS PRIVATE LIMITED",
"HUNT AUTOMOTIVES PRIVATE LIMITED",
"HUNT CONSULTING SERVICES PRIVATE LIMITED",
"HUNT MOBILES PRIVATE LIMITED",
"HUNTER DOUGLAS INDIA PRIVATE LIMITED",
"HUNTER SECURITY FORCE PRIVATE LIMITED",
"HUNTER SECURITY PRIVATE LIMITED",
"HUNTIN ORGANICS PRIVATE LIMITED",
"HUNTINGCUBE RECRUITMENT SOLUTIONS PRIVATE LIMITED",
"HUNTINGTON INGALLS INDUSTRIES INC.",
"HUNTSMAN ADVANCED MATERIALS SOLUTIONS PRIVATE LIMITED",
"HUNYHUNY OVERSEAS PRIVATE LIMITED",
"HUOBAN PRIVATE LIMITED",
"HUPHEN ELECTROMECH PRIVATE LIMITED",
"HUPHEN FABRICATORS PRIVATE LIMITED",
"HUPLONGCHERRA TEA COMPANY LIMITED",
"HUPP TECHNOLOGIES PRIVATE LIMITED",
"HUQUO CONSULTING PRIVATE LIMITED",
"HURAIN INFOTECH LLP",
"HURCO INDIA PRIVATE LIMITED",
"HURITS CONSULTING PRIVATE LIMITED",
"HURIX SYSTEMS PRIVATE LIMITED",
"HURON EURASIA INDIA PRIVATE LIMITED",
"HURRAY HOLIDAYS PRIVATE LIMITED",
"HURRICANE SYSTEMS PRIVATE LIMITED",
"HURTADO HOME DECOR PRIVATE LIMITED",
"HUSAINI ENGINEERS PRIVATE LIMITED",
"HUSAINIA JUNIOR HIGH SCHOOL",
"HUSCO HYDRAULICS PRIVATE LIMITED",
"HUSH INDIA PRIVATE LIMITED",
"HUSH LIFESTYLE LLP",
"HUSIRAZ ENGINEERS PRIVATE LIMITED",
"HUSKY INJECTION MOLDING SYSTEMS INDIA PRIVATE LIMITED",
"HUSKY INJECTION MOLDING SYSTEMS PRIVATE LIMITED",
"HUSQVARNA INDIA PRODUCTS PRIVATE LIMITED",
"HUSSAIN SHETH AND SONS SHIPBREAKERS PRIVATE LIMITED",
"HUSSMANN SERVICES INDIA LLP",
"HUSTLE MEDIA HOUSE",
"HUSTON (INDIA) PVT LTD",
"HUSYS CONSULTING LIMITED",
"HUTAMA RAJGURU ARTS SCIENCE COMM COLL",
"HUTATMA DEORAO VIDYALAYA BHAYLA BEED",
"HUTATMA KISAN AHIR VIDYALAYA AND JUNIOR COLLEGE WALWA",
"HUTATMA RAJGURU SHIKSHAN PRASARAK MANDAL S LAW COLLEGE",
"HUTATMA SAHAKARI BANK LTD WALWA",
"HUTCH INDIA PRIVATE LIMITED",
"HUTCH STEEL PRIVATE LIMITED",
"HUTCHINGS HIGH SCHOOL & JUNIOR COLLEGE",
"HUTCHINGS SCHOOL TALEGAON",
"HUTCHINSON AND CO. INDIA PRIVATE LIMITED",
"HUTCHINSON INDUSTRIAL RUBBER PRODUCTS PRIVATE LIMITED",
"HUTHEESING DESIGN COMPANY PRIVATE LIMITED",
"HUTNI PROJEKT FM (INDIA) PRIVATE LIMITED",
"HUVEPHARMA SEA PUNE PRIVATE LIMITED",
"HUVIAIR TECHNOLOGIES PRIVATE LIMITED",
"HUWAG TELESERVICES PRIVATE LIMITED",
"HUWATS INDIA PRIVATE LIMITED",
"HUWEL LIFESCIENCES PRIVATE LIMITED",
"HUZAIFA URDU HIGH SCHOOL",
"HV CONNECTING INFRA INDIA PRIVATE LIMITED",
"HV RAJ SAREES PRIVATE LIMITED",
"HV VENTURES PROJECTS PRIVATE LIMITED",
"HVAC MARSONS POWER PRIVATE LIMITED",
"HVAC SPACE AIR PRIVATE LIMITED",
"HVANTAGE TECH SOLUTIONS PRIVATE LIMITED",
"HVAX TECHNOLOGIES LIMITED",
"HVAX TECHNOLOGIES PRIVATE LIMITED",
"HVC INTERNATIONAL PRIVATE LIMITED",
"HVD DISTRIBUTORS PRIVATE LIMITED",
"HVK HYDRAULICS PRIVATE LIMITED",
"HVK INTERNATIONAL PRIVATE LIMITED",
"HVK JEWELS PRIVATE LIMITED",
"HVK MACHINES PRIVATE LIMITED",
"HVK SYSTEMS & MARKETING PVT LTD",
"HVL ENGINEERS PRIVATE LIMITED",
"HVL PEST SERVICES PRIVATE LIMITED",
"HVM NETWORK PRIVATE LIMITED",
"HVN POWERCARE PRIVATE LIMITED",
"HVP MANDALS COLLEGE OF ENGINEERING AND TECHNOLOGY AMRAVATI",
"HVP REALTY PRIVATE LIMITED",
"HVR MARKETING INDIA PRIVATE LIMITED",
"HVR SOLAR PRIVATE LIMITED",
"HVS ANAROCK HOTEL ADVISORY SERVICES PRIVATE LIMITED",
"HVT TECHNOLOGIES PRIVATE LIMITED",
"HW WELLNESS SOLUTIONS PRIVATE LIMITED",
"HWACHEON MACHINE TOOL INDIA PRIVATE LIMITED",
"HWASEUNG IA AUTOMOTIVES PRIVATE LIMITED",
"HWASEUNG MATERIALS INDIA PRIVATE LIMITED",
"HWASHIN AUTOMOTIVE INDIA PRIVATE LIMITED",
"HWASHIN INDUSTRIES PRIVATE LIMITED",
"HWASUNG ENTERPRISES ANANTHAPUR PRIVATE LIMITED",
"HWASUNG ENTERPRISES INDIA PRIVATE LIMITED",
"HWATSI CHEMICAL PRIVATE LIMITED",
"HWELL24 BUSINESS SERVICES PRIVATE LIMITED",
"HWL ADVANCED TECHNOLOGIES PRIVATE LIMITED",
"HWM ENVIRO PRIVATE LIMITED",
"HWORKS MEDIA PRIVATE LIMITED",
"HX TECHNOLOGIES PRIVATE LIMITED",
"HY GRO CHEMICALS PHARMTEK PRIVATE LIMITED",
"HYACINTH HOTELS PRIVATE LIMITED",
"HYAGREEVA HOTEL AND RESORTS PRIVATE LIMITED",
"HYALINE ENVIRO ENGINEERS PRIVATE LIMITED",
"HYATT INDIA CONSULTANCY PRIVATE LIMITED",
"HYATT PLACE HYDERABADUNIT OF BGR MINNING & INFRA LIMITED",
"HYATT REGENCY AHMEDABAD",
"HYATT REGENCY JAIPUR MANSAROVAR",
"HYATT SERVICES INDIA PRIVATE LIMITED",
"HYATT TRAVELS PRIVATE LIMITED",
"HYBER PLASTIC AND RUBBER PRODUCTS (INDIA) PRIVATE LIMITED",
"HYBON ELEVATORS AND ESCALATORS PRIVATE LIMITED",
"HYBON ENGINEERING PRIVATE LIMITED",
"HYBRENT TECHNOLOGIES PRIVATE LIMITED",
"HYBRID & POP-UP EXPERIENCES INDIA PRIVATE LIMITED",
"HYBRID 360 ART TECH PRIVATE LIMITED",
"HYBRID ADTECH PRIVATE LIMITED",
"HYBRID B.I. POWER CABLES PRIVATE LIMITED",
"HYBRID CYBER SOLUTIONS PRIVATE LIMITED",
"HYBRID DESIGNS PRIVATE LIMITED",
"HYBRID EBI HATCHERIES PRIVATE LIMITED",
"HYBRID FINANCIAL SERVICES LIMITED",
"HYBRID FLEET MANAGEMENT PRIVATE LIMITED",
"HYBRID LOGISTICS PRIVATE LIMITED",
"HYBRID METALS PRIVATE LIMITED",
"HYBRID PRINT PRIVATE LIMITED",
"HYBRIDRICKSHAW ELECTRIC PRIVATE LIMITED",
"HYCAL AIRCON SERVICES PRIVATE LIMITED",
"HYCARE MEDI SERVICES PRIVATE LIMITED",
"HYCARE SUPER SPECIALITY HOSPITAL",
"HYCE ENGINEERS AND INFRA PRIVATE LIMITED",
"HYCHEM SAINOR CHEMICALS PRIVATE LIMITED",
"HYCHIC AGRO & AQUA INDUSTRIES PRIVATE LIMITED",
"HYCLONE LIFE SCIENCES SOLUTIONS INDIA PRIVATE LIMI",
"HYCLONE LIFE SCIENCES SOLUTIONS INDIA PRIVATE LIMITED",
"HYCOM ENGINEERING INDIA PRIVATE LIMITED",
"HYCONE PROJECTS PRIVATE LIMITED",
"HYCORR CONTAINERS PRIVATE LIMITED",
"HYD AUTOFORTE PRIVATE LIMITED",
"HYDAC INDIA PRIVATE LIMITED",
"HYDE ENGINEERING & CONSULTING INDIA PRIVATE LIMITED",
"HYDE PARK SOLUTIONS PRIVATE LIMITED",
"HYDEL CONSULTANTS PRIVATE LIMITED",
"HYDEL GENERATION DIVISION EXECUTIVE ENGINEER KHARA",
"HYDEN PACKAGING PVT LTD",
"HYDENSO STEEL AND ENGINEERING PRIVATE LIMITED",
"HYDERABAD AGRI GENETICS PRIVATE LIMITED",
"HYDERABAD AMMONIA AND CHEMICALS PVT LTD",
"HYDERABAD BOTTLING CO PRIVATE LIMITED",
"HYDERABAD BOTTLING COMPANY",
"HYDERABAD C & D WASTE PRIVATE LIMITED",
"HYDERABAD CABLE DIGITAL SERVICES PRIVATE LIMITED",
"HYDERABAD CASTINGS LIMITED",
"HYDERABAD CASTINGS PRIVATE LIMITED",
"HYDERABAD CHEFS PRIVATE LIMITED",
"HYDERABAD CHEMICAL PRODUCTS PRIVATE LIMITED",
"HYDERABAD COACH BUILDERS PRIVATE LIMITED",
"HYDERABAD COILS PRIVATE LIMITED",
"HYDERABAD CORPORATE SERVICES",
"HYDERABAD CRICKET ASSOCIATION",
"HYDERABAD CYLINDERS PRIVATE LIMITED",
"HYDERABAD DUTY FREE RETAIL LIMITED",
"HYDERABAD EDUCATIONAL ACADEMY",
"HYDERABAD EDUCATIONAL EARLY LEARNING PRIVATE LIMITED",
"HYDERABAD EDUCATIONAL INSTITUTIONS PRIVATE LIMITED",
"HYDERABAD ETHNICS PRIVATE LIMITED",
"HYDERABAD EVENTS INDUSTRY PRIVATE LIMITED",
"HYDERABAD EXPRESSWAYS LIMITED.",
"HYDERABAD FOREX LIMITED",
"HYDERABAD HEAVY ENGINEERING PRIVATE.LIMITED",
"HYDERABAD INFRATECH PRIVATE LIMITED",
"HYDERABAD INSTITUTE OF ELECTRICAL ENGINEERS",
"HYDERABAD INSTITUTE OF FASHION TECHNOLOG",
"HYDERABAD INSTITUTE OF NEURO SCIENCES PRIVATE LIMITED",
"HYDERABAD INSTITUTE OF ONCOLOGY PRIVATE LIMITED",
"HYDERABAD INSTITUTE OF TECHNOLOGY AND MANAGEMENT",
"HYDERABAD INSULATED WIRES PRIVATE LIMITED",
"HYDERABAD INTEGRATED MSW LIMITED",
"HYDERABAD INTERNATIONAL TRADE EXPOSITIONS LIMITED",
"HYDERABAD JABILLI PROPERTIES PRIVATE LIMITED",
"HYDERABAD LABORATORIES PRIVATE LIMITED",
"HYDERABAD MEDIA HOUSE PRIVATE LIMITED",
"HYDERABAD METROPOLITAN DEVELOPMENT AUTHORITY",
"HYDERABAD METROPOLITAN WATER SUPPLY & SEWERAGE BOARD",
"HYDERABAD MSW ENERGY SOLUTIONS PRIVATE LIMITED",
"HYDERABAD NURSING HOME PRIVATE LIMITED",
"HYDERABAD PAPER MILLS PRIVATE LIMITED",
"HYDERABAD PIGMENTS PRIVATE LIMITED",
"HYDERABAD POWER INSTALLATIONS PRIVATE. LIMITED.",
"HYDERABAD PRECISIONS MANUFACTURING CO PVT LTD",
"HYDERABAD RACE CLUB",
"HYDERABAD READYMIX AND APPLICATIONS PRIVATE LIMITED",
"HYDERABAD REPROGRAPHICS PRIVATE LIMITED",
"HYDERABAD SECURITES PRIVATE LIMITED",
"HYDERABAD SECURITY OFFSET PRINTERS PRIVATE LIMITED",
"HYDERABAD SKYSCRAPERS PRIVATE LIMITED",
"HYDERABAD TUBES & DUCTS PRIVATE LIMITED",
"HYDERABAD TULAMAN PRIVATE LIMITED",
"HYDERABAD-YADGIRI TOLLWAY PRIVATE LIMITED",
"HYDES SOFTWARE SOLUTIONS PRIVATE LIMITED",
"HYDMARK APPLICON PRIVATE LIMITED",
"HYDRA ACTIVE PHARMA SCIENCES PRIVATE LIMITED",
"HYDRA TRADING PRIVATE LIMITED",
"HYDRADERM HEALTHCARE (OPC) PRIVATE LIMITED",
"HYDRAGUARD INTERNATIONAL PRIVATE LIMITED",
"HYDRANAUTICS",
"HYDRAPURE TECHNOLOGIES PRIVATE LIMITED",
"HYDRASPECMA INDIA PRIVATE LIMITED",
"HYDRATECH INDUSTRIES INDIA PRIVATE LIMITED",
"HYDRAULIC ACTUATORS PRIVATE LIMITED",
"HYDRAULIC POWER SOLUTIONS PRIVATE LIMITED",
"HYDRAULIC TECHNOLOGIES PRIVATE LIMITED",
"HYDRAULICS INDIA SERVICES PRIVATE LIMITED",
"HYDRECO HYDRAULICS INDIA PRIVATE LIMITED",
"HYDRISE AGRITECH PRIVATE LIMITED",
"HYDRISE AGRO PRIVATE LIMITED",
"HYDRISE FOODS PRIVATE LIMITED",
"HYDRO AIRTECH ENGINEERS (MUMBAI) PRIVATE LIMITED",
"HYDRO BS INDIA PRIVATE LIMITED",
"HYDRO BUILDING SYSTEMS PRIVATE LIMITED",
"HYDRO CARE SYSTEMS (INDIA) PRIVATE LIMITED",
"HYDRO CHEMTECH PRIVATE LIMITED",
"HYDRO ELECTRIC AND LIFT IRRIGATION QUALITY CONTROL",
"HYDRO HYDRAULIC MARINE EQUIPMENT SERVICES PRIVATE LIMITED",
"HYDRO LINKS FLEXIBLES PRIVATE LIMITED",
"HYDRO MAGUS PRIVATE LIMITED",
"HYDRO PLUS INDUSTRIES PRIVATE LIMITED",
"HYDRO PNEUMATIC ENGINEERS HYD PRIVATE LIMITED",
"HYDRO PROKAV PUMPS INDIA PRIVATE LIMITED",
"HYDRO THERM UTILITIES PRIVATE LIMITED",
"HYDROAIR TECTONICS (SPD) PRIVATE LIMITED\n",
"HYDROBATHS RAMCO MARKETING PRIVATE LIMITED",
"HYDROCARBON PROJECT ENGINEERS LIMITED",
"HYDROCARBON SOLUTIONS INDIA PRIVATE LIMITED",
"HYDROCHEM ENGINEERS BOMBAY PRIVATE LIMITED",
"HYDROCHEM SPECIALITIES CHEMICALS PRIVATE LIMITED",
"HYDROCHEM SYSTEMS (INDIA) PRIVATE LIMITED",
"HYDRO-DESIGN MANAGEMENT CO PRIVATE LIMITED",
"HYDRODROPS AQUA SOLUTIONS PRIVATE LIMITED",
"HYDRODYNE TEIKOKU (INDIA) PRIVATE LIMITED",
"HYDROFILTSEP TECHNOLOGIES PRIVATE LIMITED",
"HYDRO-FLEX PIPING SYSTEMS PRIVATE LIMITED",
"HYDROFLO ENGINEERING SYSTEMS PRIVATE LIMITED",
"HYDROFLUX ENGINEERING PRIVATE LIMITED",
"HYDROGEN GENTECH PRIVATE LIMITED",
"HYDROGREENS AGRI SOLUTIONS PRIVATE LIMITED",
"HYDROKRIMP A C PVT LTD",
"HYDROLASER MACHINERY PRIVATE LIMITED",
"HYDROLIFT SERVICES PRIVATE LIMITED",
"HYDROLIGHT VENTURES PRIVATE LIMITED",
"HYDROLINE PRODUCTS PRIVATE LIMITED",
"HYDROMA INDIA PRIVATE LIMITED",
"HYDROMATERIALS PRIVATE LIMITED",
"HYDROMATIK",
"HYDROMECH AUTOMATION PRIVATE LTD",
"HYDROMECH INDUSTRIES PRIVATE LIMITED",
"HYDROMET (INDIA) LIMITED",
"HYDROMET TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"HYDROPACK INDIA PRIVATE LIMITED",
"HYDROPEDIA PRIVATE LIMITED",
"HYDROPNEU HYDRAULIK INDIA PRIVATE LIMITED",
"HYDROPNEUMATICS PRIVATE LIMITED",
"HYDROPURE SYSTEMS PRIVATE LIMITED",
"HYDROQUIP HYDRAULICS PRIVATE LIMITED",
"HYDROTEC ENGINEERS INDIA PRIVATE LIMITED",
"HYDROTECH ENTERPRISES PRIVATE LIMITED",
"HYDROTECH EQUIPMENTS PRIVATE LIMITED",
"HYDROTECH MARKETING PRIVATE LIMITED",
"HYDROTECH PARYAVARAN INDIA PRIVATE LIMITED",
"HYDROTHERM ENGINEERING PRIVATE LIMITED",
"HYDROTHERM FLUID CONTROLS PRIVATE LIMITED",
"HYDROTHERM MOTION CONTROLS PRIVATE LIMITED",
"HYDROVERVE TECHNOLOGIES INDIA PRIVATE LIMITED",
"HYDROVISION PUMPS PRIVATE LIMITED",
"HYDROXY WATER TECHNOLOGIES PRIVATE LIMITED",
"HYDUS TECHNOLOGIES INDIA PRIVATE LIMITED",
"HYE WOO INDIA PRIVATE LIMITED",
"HYENA INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"HYEOPSEONG ENGINEERING PRIVATE LIMITED",
"HYFLUX ENGINEERING INDIA PRIVATE LIMITED.",
"HYFLUX TECHNOLOGY INDIA PRIVATE LIMITED",
"HYFUN AGRILINK PRIVATE LIMITED",
"HYFUN FOOD SUPPLY CHAIN PRIVATE LIMITED",
"HYFUN FROZEN FOODS PRIVATE LIMITED",
"HY-FY TYRES PRIVATE LIMITED",
"HYGEIA FRUIT AND VEGETABLE PROCESSORS PRIVATE LIMITED",
"HYGEIA PHARMACEUTICALS MFG. PRIVATE LIMITED",
"HYGEN BEVERAGES PRIVATE LIMITED",
"HYGEN HEALTH PRIVATE LIMITED",
"HYGIA INSTITUTE OF PHARMACY",
"HYGIEA INFORMATICS PRIVATE LIMITED",
"HYGIENE (INDIA) PRIVATE LIMITED",
"HYGIENE BIGBITE PRIVATE LIMITED",
"HYGIENE CITY PRIVATE LIMITED",
"HYGIENE OIL & FOODS LIMITED",
"HYGIENE PLUS LIMITED",
"HYGIENE PLUS PRIVATE LIMITED",
"HYGIENE RICE MILLS PRIVATE LIMITED",
"HYGIENETECH INDIA PRIVATE LIMITED",
"HYGIENIC AIR SYSTEMS PRIVATE LIMITED",
"HYGIENIC RESEARCH INSTITUTE (INDIA) PRIVATE LIMITED",
"HYGIENIC RESEARCH INSTITUTE PRIVATE LIMITED",
"HYGIIA VENTURES PRIVATE LIMITED",
"HYGINE AIRTECH INDIA PRIVATE LIMITED",
"HYGLOW INDUSTRIES LIMITED",
"HYGNTEX PRIVATE LIMITED",
"HYGREE INDIA INDUSTRIES PRIVATE LIMITED",
"HYGREVAR ENTERPRISES PRIVATE LIMITED",
"HYIT KNOWLEDGE SYSTEMS PRIVATE LIMITED",
"HYKER FOOTCARE INDIA PRIVATE LIMITED",
"HYKON INDIA PRIVATE LIMITED",
"HYKON POWER ELECTRONICS PRIVATE LIMITED",
"HYKON SOLAR ENERGY PRIVATE LIMITED",
"HYKON TRANSCRIPTS PRIVATE LIMITED",
"HYLAM SECURITIES AND FINANCE PRIVATE LIMITED",
"HYLAND SOFTWARE SOLUTIONS INDIA LLP",
"HYLASCO BIO-TECHNOLOGY (INDIA) PRIVATE LIMITED",
"HYLEX HOME APPLIANCES INDIA PRIVATE LIMITED",
"HYLIFE ENTERTAINMENTS PRIVATE LIMITED",
"HYLINE AUTO PRIVATE LIMITED",
"HY-LINE ENGINEERING INDIA PRIVATE LIMITED",
"HY-LINE LAYERS PRIVATE LIMITED",
"HYLINE LOGISTICS PRIVATE LIMITED",
"HYLITE CABLES PRIVATE LIMITED",
"HYLITE ELECTROPLATERS PRIVATE LIMITED",
"HYLITE GALVANISERS PRIVATE LIMITED",
"HYLO CHALLENGER PRIVATE LIMITED",
"HYLOC HYDROTECHNIC PRIVATE LIMITED",
"HYM BROTHERS ANALYTICAL SOLUTIONS PRIVATE LIMITED",
"HYMA DEVELOPERS PRIVATE LIMITED",
"HYMA HOSPITALS PVT LTD",
"HYMA MILKLINE PRIVATE LIMITED",
"HY-MAC PACKAGING PRIVATE LIMITED",
"HYMARK AGRITECH PRIVATE LIMITED",
"HYMASATYA ENGINEERING PROJECTS PRIVATE LIMITED",
"HYMAX HEALTHCARE PRIVATE LIMITED",
"HYMECH ENGINEERS PRIVATE LIMITED",
"HYMN HOSPITAL PRIVATE LIMITED",
"HYNESS PRODUCTS PRIVATE LIMITED",
"HYNETIC ELECTRONICS PRIVATE LIMITED",
"HYNIVA CONSULTING SERVICES PRIVATE LIMITED",
"HYOJIN ENGINEERING INDIA PRIVATE LIMITED",
"HYOSEC SOLUTIONS PRIVATE LIMITED",
"HYOSEONG ELECTRIC INDIA PRIVATE LIMITED",
"HYOSUNG CORPORATION INDIA PRIVATE LIMITED",
"HYOSUNG INDIA PRIVATE LIMITED",
"HYOSUNG T & D INDIA PRIVATE LIMITED",
"HYPE INTEGRACOMM PRIVATE LIMITED",
"HYPER DRIVE INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"HYPER EDGE MOBILE FOOD SOLUTIONS PRIVATE LIMITED",
"HYPER FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"HYPER FILTERATION PRIVATE LIMITED",
"HYPER FOODS PRIVATE LIMITED",
"HYPER INTERNET PRIVATE LIMITED",
"HYPER QUALITY INDIA PRIVATE. LIMITED",
"HYPER REALITY STUDIO PRIVATE LIMITED",
"HYPER THREAD SOLUTIONS PRIVATE LIMITED",
"HYPERBARIC TECHNOLOGIES PRIVATE LIMITED",
"HYPERBEANS TECHNOLOGIES PRIVATE LIMITED",
"HYPERCITY RETAIL INDIA LIMITED",
"HYPERCONNECT TECHNOINFRA PRIVATE LIMITED",
"HYPERFACE TECHNOLOGIES PRIVATE LIMITED",
"HYPERFACTORY IT SERVICES INDIA PRIVATE LIMITED",
"HYPERFARMS PRIVATE LIMITED",
"HYPERION ACCOUNTING & ANALYTICS PRIVATE LIMITED",
"HYPERION MATERIALS & TECHNOLOGIES INDIA PRIVATE LIMITED",
"HYPERIONIT PRIVATE LIMITED",
"HYPERLINK BRAND SOLUTIONS PRIVATE LIMITED",
"HYPERLOCAL LOGISTICS PRIVATE LIMITED",
"HYPERLOOP SOLUTIONS PRIVATE LIMITED",
"HYPERNOVA INTERACTIVE TECHNOLOGY PRIVATE LIMITED",
"HYPERPORT LOGISTICS SOLUTION PRIVATE LIMITED",
"HYPERSCALE PRASTAV NETWORKS PRIVATE LIMITED",
"HYPERSOFT TECHNOLOGIES LIMITED",
"HYPERTHERM (INDIA) THERMAL CUTTING PRIVATE LIMITED",
"HYPERTHINK SYSTEMS PRIVATE LIMITED",
"HYPERTRON LOGISTICS INDIA PRIVATE LIMITED",
"HYPERVERGE TECHNOLOGIES PRIVATE LIMITED",
"HYPHEN GARMENTS PRIVATE LIMITED",
"HYPHEN LOGISTICS SOLUTIONS PRIVATE LIMITED",
"HYPHENMARK INDIA PRIVATE LIMITED",
"HYPKRT POWER PRIVATE LIMITED",
"HYPOTECH HYDRAULICS PRIVATE LIMITED",
"HY-POWER CLAMPS PRIVATE LIMITED",
"HY-POXY SYSTEMS INDIA PRIVATE LIMITED",
"HYPRATEK FLUID POWER PRIVATE LIMITED",
"HYPRKYTCHEN FOODTECH PRIVATE LIMITED",
"HYPRO AGRI FOODS PRIVATE LIMITED",
"HYPRO ENGINEERS PRIVATE LIMITED",
"HYQUIP SYSTEMS LIMITED",
"HYQUIP TECHNOLOGIES LIMITED",
"HYR GLOBAL SOURCE INDIA PRIVATE LIMITED",
"HYREFOX CONSULTANTS PRIVATE LIMITED",
"HYRETAIL TECHNOLOGIES PRIVATE LIMITED",
"HYRIN STAFFING PRIVATE LIMITED",
"HYS INDUSTRIES PRIVATE LIMITED",
"HYSON AUTO SALES PRIVATE LIMITED",
"HYSON EXPORTS PRIVATE LIMITED",
"HYSON MOTORS PRIVATE LIMITED",
"HYSON RESTAURANT PRIVATE LIMITED",
"HYSTER YALE LIFT TRUCKS INDIA PRIVATE LIMITED",
"HYSTONE MARBLES PVT. LTD",
"HYT ENGINEERING COMPANY PRIVATE LIMITED",
"HYTE INDIA PRIVATE LIMITED",
"HYTECH COMMUNICATIONS & BROADCAST PRIVATE. LIMITED",
"HY-TECH ENGINEERS LIMITED",
"HY-TECH ENGINEERS PRIVATE LIMITED",
"HY-TECH FLUID POWER PRIVATE LIMITED",
"HYTECH GEARS AND TRANSMISSION (INDIA) PRIVATE LIMITED",
"HYTECH PRINTING SOLUTIONS PRIVATE LIMITED",
"HYTECH PRIVATE LIMITED",
"HYTECH PROFESSIONALS INDIA PRIVATE LIMITED",
"HYTECH SEED INDIA PRIVATE LIMITED",
"HY-TECHTRONICS APPLIANCES PRIVATE LIMITED",
"HY-TEK MARBLES PRIVATE LIMITED",
"HYTEKIMP PRIVATE LIMITED",
"HYTONE MERCHANTS PVT LTD",
"HY-TUF STEELS PRIVATE LIMITED HTSPL",
"HYUN CHEM SOLUTIONS PRIVATE LIMITED",
"HYUNDAI ALUMINUM INDIA PRIVATE LIMITED",
"HYUNDAI AUTOEVER INDIA PRIVATE LIMITED",
"HYUNDAI CAPITAL INDIA PRIVATE LIMITED",
"HYUNDAI ELECTRONICS INDIA LIMITED",
"HYUNDAI ENGINEERING AND CONSTRUCTION COMPANY LIMITED",
"HYUNDAI ENGINEERING INDIA PRIVATE LIMITED",
"HYUNDAI ENGINEERING PLASTIC PRIVATE LIMITED",
"HYUNDAI LOGISTICS INDIA PRIVATE LIMITED",
"HYUNDAI MATERIALS INDIA PRIVATE LIMITED",
"HYUNDAI MOTOR INDIA ENGINEERING PRIVATE LIMITED",
"HYUNDAI MOTOR INDIA LIMITED",
"HYUNDAI POLYTECH INDIA PRIVATE LIMITED",
"HYUNDAI ROTEM COMPANY",
"HYUNDAI STEEL ANANTAPUR PRIVATE LIMITED",
"HYUNDAI STEEL INDIA PRIVATE LIMITED",
"HYUNDAI STEEL PIPE INDIA PRIVATE LIMITED",
"HYUNDAI TRANSYS INDIA PRIVATE LIMITED",
"HYUNDAI TRANSYS LEAR AUTOMOTIVE INDIA PRIVATE LIMITED",
"HYUNDAI WELDING COMPANY LIMITED",
"HYUNDAI WIA INDIA PRIVATE LIMITED",
"HYVE INDIA PRIVATE LIMITED",
"HZ JIUCE TECHNOLOGY AND COMMUNICATION PRIVATE LIMITED",
"I & A FINANCIAL SERVICES LLP",
"I & B AUTOMATION & CONTROLS PRIVATE LIMITED",
"I & B ENGINEERS PRIVATE LIMITED",
"I & I FINTECH SOLUTIONS PRIVATE LIMITED",
"I & V BIO INDIA PRIVATE LIMITED",
"I 2 I CONSULTANTS LLP",
"I ADMIN OUTSOURCING PRIVATE LIMITED",
"I AHMED AND CO (COLD STORAGE AND EXPORTS) PRIVATE LIMITED",
"I AND B SEEDS PRIVATE LIMITED",
"I AND F DISTRIBUTORS PRIVATE LIMITED",
"I AND S COMMUNIQUE PRIVATE LIMITED",
"I B CAPITAL PRIVATE LIMITED",
"I B L PUBLIC SCHOOL",
"I B MOTORS (GUJARAT) PRIVATE LIMITED",
"I B PHARMA PRIVATE LIMITED",
"I B S TEA PLANTATIONS PRIVATE LIMITED",
"I BASE SOFTWARE SOLUTIONS INDIA PRIVATE LIMITED",
"I C B I (INDIA) PRIVATE LIMITED",
"I C F SILVER JUBILEE MATRICULATION HIGHER SECONDARY SCHOOL",
"I C S FOODS PRIVATE LIMITED",
"I C S TECHNOLOGY SERVICES PRIVATE LIMITED",
"I C T C SADAR HOSPITAL KHUNTI",
"I CAN FINANCIAL PRIVATE LIMITED",
"I CARE LEARNING PRIVATE LIMITED",
"I CATCH COMMUNICATIONS INDIA LIMITED",
"I CHOICE RETAIL PRIVATE LIMITED",
"I CHOICE SUPERSTORES PRIVATE LIMITED",
"I CODE TECHNOLOGIES PRIVATE LIMITED",
"I CUBE AUTOMATION PRIVATE LIMITED",
"I CUBE NANOTEC INDIA PRIVATE LIMITED",
"I D TECH SOLUTIONS PRIVATE LIMITED",
"I D U B S HINDI HIGH SCHOOL",
"I DREAM NETWORKS PRIVATE LIMITED",
"I E C AIR TOOLS PRIVATE LIMITED",
"I E S ENGLISH SECONDARY SCHOOL",
"I E S MARATHI SECONDARY SCHOOL CHARKOP KANDIVALI",
"I ENGINEERING SOFTWARE PRIVATE LIMITED",
"I EXCEED TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"I F P PETRO PRODUCTS PRIVATE LIMITED",
"I FAB STEEL PRIVATE LIMITED",
"I FIT SPORTS PRIVATE LIMITED",
"I FOCUS SOLUTIONS INDIA PRIVATE LIMITED",
"I G AGRI VENTURES LIMITED",
"I G BUILDERS AND PROMOTORS PRIVATE LIMITED",
"I G FOOD AND SNACKS",
"I G HOMOEO REMEDIES PRIVATE LIMITED",
"I G PETROCHEMICALS LIMITED",
"I G PHARMA LIMITED",
"I G PRINTERS PRIVATE LIMITED",
"I G REGISTRATION",
"I HELP FOUNDATION GOA",
"I I INSPECTION & EXPORT PRIVATE LIMITED",
"I I T BOMBAY",
"I J TOOLS AND CASTINGS PRIVATE LIMITED",
"I K AGENCIES PVT LTD",
"I K GUJRAL PUNJAB TECHNICAL UNIVERSITY",
"I K MARINE AGENCIES PRIVATE LIMITED",
"I K SHARMA CONSTRUCTION PRIVATE LIMITED",
"I KAY HOLDING COMPANY PRIVATE LIMITED",
"I KNOWLEDGE SERVICES PRIVATE LIMITED",
"I LINK SOFTWARE PRIVATE LIMITED",
"I M C ADVERTISING PRIVATE LIMITED",
"I M D FOUNDATION",
"I M GEARS PRIVATE LIMITED",
"I M HEALTHCARE PRIVATE LIMITED",
"I M PRINT SOLUTIONS PRIVATE LIMITED",
"I M S I STAFFING PRIVATE LIMITED",
"I M S SHIP MANAGEMENT PRIVATE LIMITED",
"I M TRIM RESOURCES PRIVATE LIMITED",
"I MEDIA CORP LIMITED",
"I MONEY WALLET PRIVATE LIMITED",
"I NET SECURE LABS PRIVATE LIMITED",
"I ONE TECH LABS P LIMITED",
"I P INTEGRATED SERVICES PRIVATE LIMITED",
"I P JEWELLERS PRIVATE LIMITED",
"I P SPORTS COLLEGE OF EDUCATION RESEARCH & TECHNOLOGY",
"I P SUPPORT SERVICES INDIA PRIVATE LIMITED",
"I P TRADERS PRIVATE LIMITED",
"I P VERMA MEDIA MARKETING PVT LTD",
"I P VIJAYA MULTIPLEX PRIVATE LIMITED",
"I PACK INDIA PRIVATE LIMITED",
"I PERITUS SOLUTIONS AND SERVICES PRIVATE LIMITED",
"I PRIME SERVICES PRIVATE LIMITED",
"I PROCESS SERVICES INDIA PRIVATE LIMITED",
"I Q ENGINEERING INDIA PRIVATE LIMITED",
"I R ACCESSORIES PRIVATE LIMITED",
"I R LEATHER MANUFACTURERS PRIVATE LIMITED",
"I R REALTY",
"I R TECHNOLOGY SERVICES PRIVATE. LIMITED.",
"I R TUBES PVT LTD",
"I RIDE ENTERPRISES PRIVATE LIMITED",
"I S DYESTUFF INDUSTRIES LIMITED",
"I S MARKETING PRIVATE LIMITED",
"I S MOTORS PRIVATE. LIMITED.",
"I S SOFTWARE SOLUTIONS PRIVATE LIMITED",
"I SAT NETWORK ENGINEERS PRIVATE LIMITED",
"I SAY ORGANIC PRIVATE LIMITED",
"I SEE STAFFING SOLUTIONS PRIVATE LIMITED",
"I SERVICES INDIA PRIVATE LIMITED",
"IIRM GLOBAL SHARED SERVICES PRIVATE LIMITED",
"I SHILPINET SOLUTION PRIVATE LIMITED",
"I SKY BUILDING AUTOMATIONS PRIVATE LIMITED",
"I SOL ENTERPRISES PRIVATE LIMITED",
"I SOLUTION MICROSYSTEMS PRIVATE LIMITED",
"I SOURCE INFOSYSTEMS PRIVATE LIMITED",
"I SPACE FURNITURE SYSTEMS PRIVATE LIMITED",
"I SQUARE SOFT",
"I SQUARED INDIA ADVISORS PRIVATE LIMITED",
"I SQUARESOFT INNOVATIVE & UNWAVERING",
"I STRON CORPORATION PRIVATE LIMITED",
"I SYSTEMS TECHNOCRATS PRIVATE LIMITED",
"I T CONTRACTORS PRIVATE LIMITED",
"I T S COLLEGE MOHAN NAGAR GHAZIABAD",
"I T SOLUTIONS INDIA PRIVATE LIMITED",
"I T T LINES PRIVATE LIMITED",
"I TECH INDIA PRIVATE LIMITED",
"I THINK FITNESS PRIVATE LIMITED",
"I TRANSMASTER SOLUTIONS PRIVATE LIMITED",
"I V L MATRIC HIGHER SECONDARY SCHOOL",
"I VENTURES SECURITIES PRIVATE LIMITED",
"I VISTA DIGITAL SOLUTIONS PRIVATE LIMITED",
"I&A INTERNATIONAL PRIVATE LIMITED",
"I&PCL VACUUM CAST LIMITED",
"I. A. LEATHER INDIA PRIVATE. LIMITED.",
"I. C. CONSTRUCTION & SERVICES LIMITED",
"I. P. COMPLEX PRIVATE LIMITED",
"I. P. DEVELOPERS PRIVATE LIMITED",
"I.A. BHAI ENTERPRISES PRIVATE LIMITED",
"I.B. COMMUNICATIONS NETWORK PRIVATE LIMITED",
"I.B.PATEL BUILDERS PVT LTD",
"I.D.D.PRIVATE LIMITED",
"I.E. ELECTRICALS PRIVATE LIMITED",
"I.G. AMODWALA INTERNATIONAL PRIVATE LIMITED",
"I.G.INTERNATIONAL PRIVATE LIMITED",
"I.K.M. INDUSTRIES PRIVATE LIMITED",
"I.M. PATEL WARAKHWALA PRIVATE LIMITED",
"I.M.S.I STAFFING PRIVATE LIMITED",
"I.P ESTATES PRIVATE LIMITED",
"I.P. INFRAPOWER PRIVATE LIMITED",
"I.P.M.K.V.D. ROAD PRIVATE LIMITED",
"I.P.ROADLINES (INDIA) LIMITED",
"I.R. ENTERPRISERS PRIVATE LIMITED",
"I.R.V.S RESOURCES PRIVATE LIMITED",
"I.S.G ENTERPRISE S",
"I.V. ENTERPRISES PRIVATE LIMITED",
"I2 PRO SERVICES PRIVATE LIMITED",
"I2A TECHNOLOGIES PRIVATE LIMITED",
"I2CURE PRIVATE LIMITED",
"I2E CONSULTING PRIVATE LIMITED",
"I2I SOFTWARES PRIVATE LIMITED",
"I2I TELESOURCE PRIVATE LIMITED",
"I2IT PRIVATE LIMITED",
"I2K2 NETWORKS P LIMITED",
"I2N TECHNOLOGIES PRIVATE LIMITED",
"I2R CONSULTING PRIVATE LIMITED",
"I3 CONSULTING PRIVATE LIMITED",
"I3 INFOSYSTEM PRIVATE LIMITED",
"I3 MINDS LLP",
"I3 SECURITY PRIVATE LIMITED",
"I3 SOLUTIONS PRIVATE LIMITED",
"I3CLOGIC TECHNOLOGIES PRIVATE LIMITED",
"I-3PL INDIA PRIVATE LIMITED",
"I4 COMMUNICATION PRIVATE LIMITED",
"I4 GLOBAL INFORMATION TECHNOLOGIES LIMITED",
"I4 INFOTECH PRIVATE LIMITED",
"I4 KNOWLEDGE PROCESSING PRIVATE LIMITED",
"I4 VIDEO ANALYSIS PRIVATE LIMITED",
"I4S INFRA SECURITY SOLUTION PRIVATE LIMITED",
"I5 CONCEPTS PRIVATE LIMITED",
"I5 SYSTEMS PRIVATE LIMITED",
"I9 FREEWAYS PRIVATE LIMITED",
"IA ACCEL PRIVATE LIMITED",
"IA AUTOMOBILES INTERNATIONAL PRIVATE LIMITED",
"IA CONTAINER (INDIA) PRIVATE LIMITED",
"IA ENERGY",
"IA FLOW ELEMENTS PRIVATE LIMITED",
"IA HYDRO ENERGY PRIVATE LIMITED",
"IA INDIA ACCELERATOR PRIVATE LIMITED",
"IA MOTOR CORP PRIVATE LIMITED",
"IA MULTI VENTURES PRIVATE LIMITED",
"IA WEALTH PRIVATE LIMITED",
"IAB PHOTOS COIMBATORE PRIVATE LIMITED",
"IAC ELECTRICALS PVT LTD",
"IAC INTERNATIONAL AUTOMOTIVE INDIA PRIVATE LIMITED",
"IAC MINERALS PRIVATE LIMITED",
"IACG",
"IACUITY TELCO SOLUTIONS PRIVATE LIMITED",
"IADVANCE INFO PRIVATE LIMITED",
"IAE GLOBAL INDIA EDUNET PRIVATE LIMITED",
"IAEC CONSULTANTS PRIVATE LIMITED",
"IAG AUTOMATION PRIVATE LIMITED",
"IAI INDUSTRIES LIMITED",
"IAI IT SOLUTIONS PRIVATE LIMITED",
"IAIDC TECHNOLOGIES PRIVATE LIMITED",
"IAIR TECHNOLOGIES PRIVATE LIMITED",
"IAITO INFOTECH PRIVATE LIMITED",
"IAJ ENTERPRISES PRIVATE LIMITED",
"IAL INDIA LIMITED",
"IAL LOGISTICS INDIA LIMITED",
"IALITUS INFO SOLUTIONS PRIVATE LIMITED",
"IALPHA MOBILITY SOLUTIONS PRIVATE LIMITED",
"IAM CREATIVE COMMUNICATION PRIVATE LIMITED",
"IAMAX PRECISION INDIA PRIVATE LIMITED",
"IAMICO ANALYSIS PRIVATE LIMITED",
"IAMSEC VISION IT PRIVATE LIMITED",
"IAMSYS PRIVATE LIMITED",
"IAN ELECTRONICS INDIA PRIVATE LIMITED",
"IAN MACLEOD DISTILLERS INDIA PRIVATE LIMITED",
"IAN MARTIN CONSULTING PRIVATE LIMITED",
"IAN MARTIN VADODARA CONSULTING PRIVATE LIMITED",
"IAND INSURANCE BROKER PRIVATE LIMITED",
"IANS INDIA PRIVATE LIMITED",
"IANT EDUCOM PRIVATE LIMITED",
"IAP FARM SERVICES PRIVATE LIMITED",
"IAPL GROUP PRIVATE LIMITED",
"IAPL INDUSTREIS",
"IAPMO PLUMBING CODES AND STANDARDS INDIA PRIVATE LIMITED",
"IAPPSECURE SOLUTIONS PRIVATE LIMITED",
"IAPPSTRACK SOFTWARE PRIVATE LIMITED",
"IAR INSURANCE SURVEYORS AND LOSS ASSESSORS PRIVATE LIMITED",
"IARA HR SERVICES PRIVATE LIMITED",
"IAS STUDY CIRCLE",
"IASBABA OFFLINE PRIVATE LIMITED",
"IASIS HOSPITAL",
"IASO HEALTHCARE PRIVATE LIMITED",
"IASO PHARMACEUTICALS PRIVATE LIMITED",
"IASSIST HEALTH PRIVATE LIMITED",
"IASSURE INTERNATIONAL TECHNOLOGIES PRIVATE LIMITED",
"IASUOR ETS PRIVATE LIMITED",
"IASYS TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"IATOME ELECTRIC INDIA PRIVATE LIMITED",
"IATRIC INDUSTRIES PRIVATE LIMITED",
"IATROS PHARMACEUTICAL PVT LTD",
"I-ATTIRE PRIVATE LIMITED",
"IAURO SYSTEMS PRIVATE LIMITED",
"IAV INDIA PRIVATE LIMITED",
"IAV INFRASTRUCTURES PRIVATE LIMITED",
"IAV INTEGRAL SOLUTIONS PRIVATE LIMITED",
"IAVOCADO ECOMMERCE PRIVATE LIMITED",
"IAXIS TECHNOLOGY SERVICES PRIVATE LIMITED",
"IAXN TELECOM PRIVATE LIMITED",
"IB AUTOMATION ENGINEERING PROJECTS PRIVATE LIMITED",
"IB DISTRIBUTION SERV. LIMITED",
"IB HOSPITALITY PRIVATE LIMITED",
"IB INFOTECH ENTERPRISES LIMITED",
"IB LIGHTINGS PRIVATE LIMITED",
"IB RARALFINANCE PRIVATE LIMITED",
"IB RURAL FINANCE PRIVATE LIMITED",
"IB TURBO PRIVATE LIMITED",
"IB VOGT SOLAR INDIA PRIVATE LIMITED",
"IBA CRAFTS PRIVATE LIMITED",
"IBA MOLECULAR IMAGING (INDIA) PRIVATE LIMITED",
"IBA PARTICLE THERAPY INDIA PRIVATE LIMITED",
"IBA SYSTEMS INDIA PRIVATE LIMITED",
"IBAHN INDIA PRIVATE LIMITED",
"IBARGUS ENGINEERING SOLUTIONS PRIVATE LIMITED",
"IBASET INDIA SOFTWARE PRIVATE LIMITED",
"IBBAN INDUSTRIES PRIVATE LIMITED",
"IBC IMPEX PRIVATE LIMITED",
"IBC KNOWLEDGE PARK PRIVATE LIMITED",
"IBC SOLAR PROJECTS PRIVATE LIMITED",
"IBCC INDUSTRIES (INDIA) PRIVATE LIMITED",
"IBCC MANUFACTURING SOLUTIONS (INDIA) PRIVATE LIMITED",
"IBD INDIA PRIVATE LIMITED",
"IBD SPACE INFRASTRUCTURE PRIVATE LIMITED",
"I-BEE SOFTWARE SOULUTIONS PVT LTD",
"IBEN EDGE INDIA PRIVATE LIMITED",
"IBERIA PHARMACEUTICALS INDIA PRIVATE LIMITED",
"IBERIA SKINBRANDS INDIA PRIVATE LIMITED",
"IBERRY SOLUTIONS PRIVATE LIMITED",
"IBEX ENERGY PRIVATE LIMITED",
"IBEX ENGINEERING PRIVATE LIMITED",
"IBEX EXPEDITIONS PRIVATE LIMITED",
"IBEX FASHIONS PRIVATE LIMITED",
"IBEX INFRATEK PRIVATE LIMITED",
"IBEX PRODUCTS PRIVATE LIMITED",
"IBF ENGINEERING SERVICES PRIVATE LIMITED",
"IBH BEARINGS PRIVATE LIMITED",
"IBH PRINT AND BIND PRIVATE LIMITED",
"IBHA CONSTRUCTIONS PRIVATE LIMITED",
"IBHA SYSTEMS PRIVATE LIMITED",
"IBI ANALYTICAL SOLUTIONS PRIVATE LIMITED",
"IBI BIOSOLUTIONS PRIVATE LIMITED",
"IBI CHEMATUR ENGINEERING AND CONSULTANCY LIMITED",
"IBI CONSULTANCY INDIA PRIVATE LIMITED",
"IBI GROUP INDIA PRIVATE LIMITED",
"IBIBO GROUP PRIVATE LIMITED",
"IBIL SOLUTIONS PRIVATE LIMITED",
"IBIMEDIA TECHNOLOGIES PRIVATE LIMITED",
"IBINDER DIGITAL PRIVATE LIMITED",
"IBIOS PRIVATE LIMITED",
"IBIRDS SOFTWARE SERVICES PRIVATE LIMITED",
"IBIS",
"IBIS DESIGNS PRIVATE LIMITED",
"IBIS SMART MARBLE PRIVATE LIMITED",
"IBIS SYSTEMS AND SOLUTIONS PRIVATE LIMITED",
"IBIS TRAVELS PRIVATE LIMITED",
"IBITOL TECHNOLOGIES PRIVATE LIMITED",
"IBIZ CONSULTANCY SERVICES INDIA PRIVATE LIMITED",
"IBIZZA FASHION PRIVATE LIMITED",
"IBK ENGINEERS PRIVATE LIMITED",
"IBL FINANCE LIMITED",
"IBL FINANCE PRIVATE LIMITED",
"IBL HEALTHCARE LIMITED",
"IBLE SOFT PRIVATE LIMITED",
"IBLOCK TECHNOLOGIES PRIVATE LIMITED",
"IBLUE FMCG PRIVATE LIMITED",
"IBM GLOBAL FINANCING INDIA PRIVATE LIMITED",
"IBM INDIA PRIVATE LIMITED",
"IBM WORLD TRADE CORPN.",
"IBMK ENGINEERING EPC PRIVATE LIMITED",
"IBMZ CONSTRUCTIONS PRIVATE LIMITED",
"IBN ABDUL MAJID PRIVATE LIMITED",
"IBN INDIA PRIVATE LIMITED",
"IBN LOKMAT NEWS PRIVATE LIMITED",
"IBN TECHNOLOGIES LIMITED",
"IBODE TECHNOLOGIES PRIVATE LIMITED",
"IBOND INDUSTRIES PRIVATE LIMITED",
"IBOOKS INSTITUTE PRIVATE LIMITED",
"IBOSS FASTENERS PRIVATE LIMITED",
"IBOSS TECH SOLUTIONS PRIVATE LIMITED",
"IBOT CONTROL SYSTEMS INDIA PRIVATE LIMITED",
"IBOX INFOCOM PRIVATE LIMITED",
"IBOX STUDIOS PRIVATE LIMITED",
"IBRA ENERGY INDIA PRIVATE LIMITED",
"IBRAHIM COLLECTIONS",
"IBRAHIM INTERNATIONAL PRIVATE LIMITED",
"IBRAHIM SHARIEF",
"IBRAHIMI POULTRY PRODUCTS PRIVATE LIMITED",
"IBRAIN ENTERPRISES PRIVATE LIMITED",
"IBRIDGE ANALYSIS AND DEVELOPMENT PRIVATE LIMITED",
"IBRIDGE TECHSOFT PRIVATE LIMITED",
"IBROAD CONNECT PRIVATE LIMITED",
"IBROX REAL ESTATE DEVELOPMENT PRIVATE LIMITED",
"IBRUK CONSULTING PRIVATE LIMITED",
"IBS FINTECH INDIA PRIVATE LIMITED",
"IBS INFOWEB PRIVATE LIMITED",
"IBS SOFTWARE PRIVATE LIMITED",
"IBS SOFTWARE SERVICES PRIVATE LIMITED",
"IBSC INDIA WELLNESS LIMITED",
"IBT MEDIA PRIVATE LIMITED",
"IBTECH AUTOMATION INDIA PRIVATE LIMITED",
"IBTIONS INFOLOGIES PRIVATE LIMITED",
"IBTRACK SOLUTIONS PRIVATE LIMITED",
"IBU CONSULTING PRIVATE LIMITED",
"IBUILD INNOVATIONS INDIA LIMITED",
"IBULLS SALES LIMITED",
"IBUS NETWORK AND INFRASTRUCTURE PRIVATE LIMITED",
"IBUS VIRTUAL NETWORK SERVICES PRIVATE LIMITED",
"IBUSINESS SOFTWARE PRIVATE LIMITED",
"IBYTE INFOMATICS PRIVATE LIMITED",
"IBYTECODE TECHNOLOGIES PRIVATE LIMITED",
"IC ELECTRICALS COMPANY PRIVATE LIMITED",
"IC INDIA PRIVATE LIMITED",
"IC PRO SOLUTIONS PRIVATE LIMITED",
"ICA EDU SKILLS PRIVATE LIMITED",
"ICA PIDILITE PRIVATE LIMITED",
"ICABLE PRIVATE LIMITED",
"ICADVISORY SERVICES INDIA PRIVATE LIMITED",
"ICAI ACCOUNTING RESEARCH FOUNDATION",
"ICAI REGISTERED VALUERS ORGANISATION",
"ICALL SOFT PRIVATE LIMITED",
"ICALL SUPPORT SERVICES PRIVATE LIMITED",
"ICAM SOLUTION PRIVATE LIMITED",
"ICAN BPO PRIVATE LIMITED",
"ICANCERHELP INDIA PRIVATE LIMITED",
"ICAP IL INDIA PRIVATE LIMITED",
"ICAR CENTRAL INSTITUTE FOR RESEARCH ON COTTON TECHNOLOGY",
"ICAR CENTRAL PLANTATION CROPS RESEARCH INSTITUTE",
"ICAR CENTRAL RESEARCH INSTITUTE FOR JUTE AND ALLIED FIBRES",
"ICAR-CENTRAL AGROFORESTRY RESEARCH INSTITUTE, JHANSI",
"ICARD SOLUTIONS INDIA PRIVATE LIMITED",
"ICARE EYE HOSPITAL & POSTGRADUATE INSTITUTE",
"ICARE HEALTH PROJECTS AND RESEARCH PRIVATE LIMITED",
"ICARE LEARNING PRIVATE. LIMITED",
"ICARE RAD SERVICES PRIVATE LIMITED",
"ICAR-INDIAN INSTITUTE OF OILSEEDS RESEARCH",
"ICAR--NATIONAL BUREAU OF SOIL SURVEY AND LAND USE PLANNING",
"ICARUS DESIGN PRIVATE LIMITED",
"ICARUS HEALTH CARE PRIVATE LIMITED",
"ICARUSNOVA DISCOVERY PRIVATE LIMITED",
"ICASA TRADING COMPANY PRIVATE LIMITED",
"ICAT DESIGN & MEDIA COLLEGE",
"ICATT HEALTH SOLUTIONS PRIVATE LIMITED",
"ICBIO CLINICAL RESEARCH PRIVATE LIMITED",
"ICBS SYNERGY PRIVATE LIMITED",
"ICC CHEMTEC PRIVATE LIMITED",
"ICC INFRA PROJECT INDIA PRIVATE LIMITED",
"ICC INTERNATIONAL AGENCIES LIMITED",
"ICC MEDIA PRIVATE LIMITED",
"ICC PROJECTS PRIVATE LIMITED",
"ICC REALTY INDIA PRIVATE LIMITED",
"ICC WORLD WIDE PRIVATE LIMITED",
"ICCG INDIA PRIVATE LIMITED",
"ICCH GLOABL CONSULTING PRIVATE LIMITED",
"ICCHAMANI BUILDCON PRIVATE LIMITED",
"ICCHAPURAM TOLLWAY PRIVATE LIMITED",
"ICDS BHIWANDI",
"ICDS BRANCH VALSAD TALUKA PANCHAYAT",
"ICDS DEPT PROJECT KALWAN 2",
"ICDS LIMITED",
"ICDS SAKHA JILLA PANCHAYAT VADODARA",
"ICE (ASIA) PRIVATE LIMITED",
"ICE BOY MACHINES PRIVATE LIMITED",
"ICE CENTRE OF EXCELLENCE PRIVATE LIMITED",
"ICE DATA SERVICES INDIA PRIVATE LIMITED",
"ICE FIRE CLOTHING COMPANY PRIVATE LIMITED",
"ICE GATE EDUCATIONAL INSTITUTE PRIVATE LIMITED",
"ICE HOSPITALITY PRIVATE LIMITED",
"ICE JEWELLERY PRIVATE LIMITED",
"ICE MAKE REFRIGERATION LIMITED",
"ICE MT INDIA PRIVATE LIMITED",
"ICE STEEL 1 PRIVATE LIMITED",
"ICE TECHNOSOL PRIVATE LIMITED",
"ICE TOUCH RESORT PRIVATE LIMITED",
"ICE TRAVELS & TOUR PRIVATE LIMITED",
"ICE WEAR CREATION PRIVATE LIMITED",
"ICEBERG AQUA PRIVATE LIMITED",
"ICEBERG ENGINEERING SERVICES PRIVATE LIMITED",
"ICEBERG FOODS LIMITED",
"ICEBERG HEALTHCARE PRIVATE LIMITED",
"ICEBURG TECHNOCAST PRIVATE LIMITED",
"ICECOLD REFRIGERATION PRIVATE LIMITED",
"ICECUBE ENGINEERS PRIVATE LIMITED",
"ICED DESSERTS & FOOD PARLOURS INDIA PRIVATE LIMITED",
"ICEDREAM GLOBAL PRIVATE LIMITED",
"ICEGEN COMPUTING PRIVATE LIMITED",
"ICEIL SYSTEMS PRIVATE LIMITED",
"ICEKUBE MEDIA PRIVATE LIMITED",
"ICELAND ESTATES PRIVATE LIMITED",
"ICELERO TECHNOLOGIES PRIVATE LIMITED",
"ICEM ENGINEERING COMPANY PRIVATE LIMITED",
"ICENTRIS SOFTWARE DEVELOPMENT PRIVATE LIMITED",
"I-CERT GLOBAL LEARNING PRIVATE LIMITED",
"ICERTIS PRODUCTS INDIA PRIVATE LIMITED",
"ICERTIS SOLUTIONS PRIVATE LIMITED",
"ICESTASY PROJECTS PRIVATE LIMITED",
"ICETONAIR PRIVATE LIMITED",
"ICETRAIL LOGISTICS PRIVATE LIMITED",
"ICEWARP TECHNOLOGIES PRIVATE LIMITED",
"ICF CONSULTING INDIA PRIVATE LIMITED",
"ICF CONSULTING SERVICES INDIA PRIVATE LIMITED",
"ICF SHIPPING PRIVATE LIMITED",
"ICF SILVER JUBILEE MATRICULATION HR SEC SCHOOL",
"ICFAI FOUNDATION FOR HIGHER EDUCATION",
"ICFAI NATIONAL COLLEGE",
"ICFAI UNIVERSITY",
"ICFAIAIN FOUNDATION",
"ICG MEDICAL INDIA PRIVATE LIMITED",
"ICH PURE LIFESCIENCES PRIVATE LIMITED",
"ICHALKARANJI ENGINEERING CENTRE PVT LTD",
"ICHALKARANJI GARMENT CLUSTER LIMITED",
"ICHALKARANJI HIGH SCHOOL ICHALKARANJI",
"ICHALKARANJI MATHADI AND UNPROTECTED LABOUR BOARD ICHALKARANJI",
"ICHALKARANJI MUNICIPLE CORPORATION ICHALKARANJI",
"ICHALKARANJI TEXTILES PRIVATE LTD",
"ICHAMATI INVESTMENTS LTD",
"ICHAPORE GIRLS HIGH SCHOOL",
"ICHESS EXTRACT PRIVATE LIMITED",
"I-CHESS-CHEMICALS PRIVATE LIMITED",
"ICHI VENTURES PRIVATE LIMITED",
"ICHIBAAN AUTOMOBILES PRIVATE LIMITED",
"ICHIBAN CARGO PRIVATE LIMITED",
"ICHIBAN CROP SCIENCE LIMITED",
"ICHIBAN CROP SCIENCE LIMITED WEST BENGAL STAFF",
"ICHOR BIOLOGICS PRIVATE LIMITED",
"ICI HEALTHCARE PRIVATE LIMITED",
"ICICI BANK LIMITED",
"ICICI FOUNDATION FOR INCLUSIVE GROWTH",
"ICICI HOME FINANCE COMPANY LIMITED",
"ICICI INVESTMENT MANAGEMENT COMPANY LIMITED",
"ICICI LOMBARD GENERAL INSURANCE",
"ICICI LOMBARD GENERAL INSURANCE COMPANY LIMITED",
"ICICI MERCHANT SERVICES PRIVATE LIMITED",
"ICICI PRUDENTIAL ASSET MANAGEMENT COMPANY LIMITED",
"ICICI PRUDENTIAL LIFE INSURANCE",
"ICICI PRUDENTIAL LIFE INSURANCE COMPANY LIMITED",
"ICICI PRUDENTIAL PENSION FUNDS MANAGEMENT COMPANY LIMITED",
"ICICI PRUDENTIAL TRUST LIMITED",
"ICICI SECURITIES LIMITED",
"ICICI SECURITIES PRIMARY DEALERSHIP LIMITED",
"ICICI VENTURE FUNDS MANAGEMENT COMPANY LIMITED",
"ICIMS INDIA PRIVATE LIMITED",
"ICK HOSPITALITY PRIVATE LIMITED",
"ICL CONSTRUCTION CONSULTING PRIVATE LIMITED",
"ICL FERTILIZERS INDIA PRIVATE LIMITED",
"ICL FINANCIAL SERVICES LIMITED",
"ICL FINCORP LIMITED",
"ICL INTERNATIONAL LIMITED",
"ICL MANAGEMENT & TRADING INDIA PRIVATE LIMITED",
"ICL SECURITIES LIMITED",
"ICL SYSTEMS INDIA PRIVATE LIMITED",
"ICL TOURS & TRAVELS PRIVATE LIMITED",
"ICLEAN HOLLOW METAL SYSTEMS PRIVATE LIMITED",
"ICLICK ADVERTISING (OPC) PRIVATE LIMITED",
"ICLIMB SYSTEMS INDIA PRIVATE LIMITED",
"ICLOUD HOMES PRIVATE LIMITED",
"ICLOUD24X7 INDIA PRIVATE LIMITED",
"ICLOUDLOGIC INDIA PRIVATE LIMITED",
"ICM FINANCE PRIVATE LIMITED",
"ICM INSURANCE BROKERS PRIVATE LIMITED",
"ICM LOGISTICS PRIVATE LIMITED",
"ICM PLASTICS PRIVATE LIMITED",
"ICMAI MANAGEMENT ACCOUNTING RESEARCH FOUNDATION",
"ICMAI REGISTERED VALUERS ORGANISATION",
"ICMC CORPORATION LIMITED",
"ICMC PROJECTS PRIVATE LIMITED",
"ICMR NATIONAL INSTITUTE FOR RESEARCH IN REPRODUCTIVE AND CHILD HEALTH",
"ICMR NATIONAL INSTITUTE OF CHOLERA AND ENTERIC DISEASES",
"ICMR NATIONAL INSTITUTE OF IMMUNOHAEMATOLOGY",
"ICMR NATIONAL INSTITUTE OF RESEARCH IN TRIBAL HEALTH JABALPUR",
"ICMR- NATIONAL INSTITUTE OF VIROLOGY",
"ICMR-NATIONAL INSTITUTE OF MALARIA RESEARCH",
"ICNET SOFTWARE SOLUTIONS PRIVATE LIMITED",
"ICOACH ENTERPRISES PRIVATE LIMITED",
"ICOAL ENERGY PRIVATE LIMITED",
"ICODERZ SOLUTIONS PRIVATE LIMITED",
"ICODEX PUBLISHING SOLUTIONS PRIVATE LIMITED",
"ICOLD REFRIGERATION PRIVATE LIMITED",
"ICOM INFRA PRIVATE LIMITED",
"I-COM SYSTEMS PRIVATE LIMITED",
"ICOM TELESERVICES PRIVATE LIMITED",
"ICOMM TECHNOLOGIES PRIVATE LIMITED",
"ICOMM TELE LIMITED",
"ICOMPUTEX TECHNOLOGIES PRIVATE LIMITED",
"ICON ADCORP PRIVATE LIMITED",
"ICON ANALYTICAL EQUIPMENT PRIVATE LIMITED",
"ICON AUTOCRAFT PRIVATE LIMITED",
"ICON CADSOFT AND SURVEYORS (INDIA) PRIVATE LIMITED",
"ICON CARS PRIVATE LIMITED",
"ICON CERAMIC LIMITED",
"ICON CLINICAL RESEARCH INDIA PRIVATE LIMITED",
"ICON CONTROLS PRIVATE LIMITED",
"ICON DESIGN AUTOMATION PRIVATE LIMITED",
"ICON DRUGS PRIVATE LIMITED",
"ICON ENGINEERS PVT LTD",
"ICON FACILITATORS PRIVATE LIMITED",
"ICON HOMES PRIVATE LIMITED",
"ICON HOSPITAL",
"ICON HOSPITAL PRIVATE LIMITED",
"ICON HOSPITALITY PRIVATE LIMITED",
"ICON INFOLINE PRIVATE LIMITED",
"ICON INFOSYSTEMS PRIVATE LIMITED",
"ICON INFRA SHELTERS INDIA PRIVATE LIMITED",
"ICON LIFE SCIENCES",
"ICON MANUFACTURERS PRIVATE LIMITED",
"ICON MEDIA",
"ICON OFFICE INNOVATION PRIVATE LIMITED",
"ICON PAINTS PRIVATE LIMITED",
"ICON PAVERS INDIA PRIVATE LIMITED",
"ICON PETROLEUM CORPORATION LIMITED",
"ICON PLAST (INDIA) PRIVATE LIMITED",
"ICON POULTRY PRIVATE LIMITED",
"ICON POWER SOLUTIONS PRIVATE LIMITED",
"ICON PRINTS PRIVATE LIMITED",
"ICON PROJECTS PRIVATE LIMITED",
"ICON PROPERTIES",
"ICON SCHOOL OF EXCELLENCE",
"ICON SECURITY SERVICES PRIVATE LIMITED",
"ICON SHIPPING AND LOGISTICS PRIVATE LIMITED",
"ICON SLEEPER TRACK PRIVATE LIMITED",
"ICON SOLAR-EN POWER TECHNOLOGIES PRIVATE LIMITED",
"ICON STEEL AND ALLOYS PRIVATE LIMITED",
"ICON VALVES & ENGINEERING PRIVATE LIMITED",
"ICONCEPT SOFTWARE SERVICES PRIVATE LIMITED",
"ICONE HOMETEX PRIVATE LIMITED",
"ICONET PATIENT CARE PRIVATE LIMITED",
"ICONEX (INDIA) PRIVATE LIMITED",
"ICONEX EXHIBITIONS PRIVATE LIMITED",
"ICONFLUX TECHNOLOGIES PRIVATE LIMITED",
"ICONIC AUTOMOBILES",
"ICONIC BITUMINOUS PRIVATE LIMITED",
"ICONIC CASTINGS PRIVATE LIMITED",
"ICONIC FASHION RETAILING PRIVATE LIMITED",
"ICONIC MOTORS PRIVATE LIMITED",
"ICONIC POLYGEL PRIVATE LIMITED",
"ICONIC PRINT MEDIA PRIVATE LIMITED",
"ICONIC QUALITY PRIVATE LIMITED",
"ICONIC TECHNO SOLUTIONS PRIVATE LIMITED",
"ICONIC TRANS AGRO PRIVATE LIMITED",
"ICONICS ALUPLAST INDIA PRIVATE LIMITED",
"ICONINFRA ESTATE SERVICES PRIVATE LIMITED",
"ICONIQ SKILLS INDIA PRIVATE LIMITED",
"ICONIUM LEATHER WORKS PRIVATE LIMITED",
"ICONIX LIFESTYLE INDIA PRIVATE LIMITED",
"ICONKRISHI INSTITUTE OF MEDICAL SCIENCES PRIVATE LIMITED",
"ICONMA PROFESSIONAL SERVICES AND SOLUTIONS PRIVATE LIMITED",
"ICONNECT HR CONSULTANCY PRIVATE LIMITED",
"ICONNECT INFO SOLUTIONS PRIVATE LIMITED",
"I-CONNECT INFRATEL PRIVATE LIMITED",
"ICONS ENGINEERING SERVICES",
"ICONS FUTURETECH PRIVATE LIMITED",
"ICONS INFOCOM PRIVATE LIMITED",
"ICONS OUTDOOR PRIVATE LIMITED",
"ICONS PRINT MEDIA PRIVATE LIMITED",
"ICONSULTERA PRIVATE LIMITED",
"ICONVERGE SERVICES PRIVATE LIMITED",
"ICOOL TECHNOLOGY & COMMUNICATION PRIVATE LIMITED",
"ICORE LUMBERS PRIVATE LIMITED",
"ICORETS PRIVATE LIMITED",
"ICOVER INDIA INFORMATION AND SERVICES PRIVATE LIMITED",
"ICP FACILITY MANAGEMENT & SERVICES PRIVATE LIMITED",
"ICP INDIA PRIVATE LIMITED",
"ICP SOLUTIONS LIMITED",
"ICPA HEALTH PRODUCTS LIMITED",
"ICPS ENGINEERING PRIVATE LIMITED",
"ICR PAINTS (INDIA) PRIVATE LIMITED",
"ICRA ANALYTICS LIMITED",
"ICRA LIMITED",
"ICRA MANAGEMENT CONSULTING SERVICES LIMITED",
"SUJA ASSOCIATES PRIVATE LIMITED",
"ICREDERITY INFO SERVICES PRIVATE LIMITED",
"ICREDIZEN FINANCIAL TECHNOLOGIES PRIVATE LIMITED",
"ICREON COMMUNICATIONS PRIVATE LIMITED",
"ICRISAT",
"ICROTONE PRIVATE LIMITED",
"ICRUXSYSTEM PRIVATE LIMITED",
"ICS ASSURE SERVICES PRIVATE LIMITED",
"ICS FREIGHT SYSTEM PRIVATE LIMITED",
"ICS INDIA PRIVATE LIMITED",
"ICS MERCHANDISE PRIVATE LIMITED",
"ICS MOBILE PRIVATE LIMITED",
"ICS SYSTEM PRIVATE LIMITED",
"ICT ACADEMY OF TAMIL NADU",
"ICT HEALTH TECHNOLOGY SERVICES INDIA PRIVATE LIMITED",
"ICT INTERNATIONAL CARGO TRANSPORT INDIA PRIVATE LIMITED",
"ICT SERVICE MANAGEMENT SOLUTIONS INDIA PRIVATE LIMITED",
"ICT SERVICES MANAGEMENT SOLUTION",
"ICTECT TECHNOLOGY PRIVATE LIMITED",
"ICTI TECHNOLOGIES PRIVATE LIMITED",
"ICTL PRECOAT PANELS PRIVATE LIMITED",
"ICTRLBIZ CONSULTING PRIVATE LIMITED",
"ICTS TECKI INDIA PRIVATE LIMITED",
"ICTS WORK STATIONS INDIA PRIVATE LIMITED",
"ICU MEDICAL INDIA LLP",
"ICU SURGICARE INDIA PRIVATE LIMITED",
"ICUBE CONSULTING SERVICES INDIA PRIVATE LIMITED",
"I-CUBE SYSTEMS PRIVATE LIMITED",
"ICUBESWIRE TECHNOLOGIES PRIVATE LIMITED",
"ICUBIX INFOTECH LIMITED",
"ICUC CONSULTANTS PRIVATE LIMITED",
"ICWAI",
"ICWAI MANAGEMENT ACCOUNTING RESEARCH FOUNDATION",
"ICWARES SYSTEMS AND SOFTWARES (INDIA) PRIVATE LIMITED",
"ICX4 SOFTWARE SERVICES INDIA PRIVATE LIMITED",
"ICY SPICY FOODS PRIVATE LIMITED",
"ICYCLE SOLUTIONS PRIVATE LIMITED",
"ID CAR DRIVERS PRIVATE LIMITED",
"ID FRESH FOOD INDIA PRIVATE LIMITED",
"ID GOURMET INDIA PRIVATE LIMITED",
"ID INTERIORS AND DESIGN STUDIO PRIVATE LIMITED",
"ID MEDICAL INDIA LLP",
"ID OVERSEAS PRIVATE LIMITED",
"ID SMART CARDS CREATIONS PRIVATE LIMITED",
"ID SPORTS PRIVATE LIMITED",
"ID TECHNOLOGIES PRIVATE LIMITED",
"ID8 MEDIA SOLUTIONS PRIVATE LIMITED",
"IDA AUTOMATION PRIVATE LIMITED",
"IDA BUSINESS SOLUTIONS PRIVATE LIMITED",
"IDA ENGINEERING PRIVATE LIMITED",
"IDA SCUDDER SCHOOL",
"IDA TRADING FOUNDATION PRIVATE LIMITED",
"IDAA INFRASTRUCTURE PRIVATE LIMITED",
"IDAC SOLUTIONS PRIVATE LIMITED",
"IDAKA PRECISION TOOLS INDIA PRIVATE LIMITED",
"IDAKSHA TRAINING ACADEMY PRIVATE LIMITED",
"IDALIA PANACHE RETAIL PRIVATE LIMITED",
"IDAM INFRASTRUCTURE ADVISORY PRIVATE LIMITED",
"IDAT ESTATES PRIVATE LIMITED",
"IDATA TRANSCRIPTION SERVICES PRIVATE LIMITED",
"IDATALYTICS PRIVATE LIMITED",
"IDAVID AND COMPANY PRIVATE LIMITED",
"IDAX CONSULTING AND RESEARCH PRIVATE LIMITED",
"IDBI",
"IDBI ASSET MANAGEMENT LIMITED",
"IDBI BANK LIMITED",
"IDBI CAPITAL MARKET SERVICES LIMITED",
"IDBI INTECH LIMITED",
"IDBI TRUSTEESHIP SERVICES LIMITED",
"IDC CENTRE FOR CONSULTANCY AND RESEARCH PRIVATE LIMITED",
"IDC ENGINEERING INDIA PRIVATE LIMITED",
"IDC KITCHEN PRIVATE LIMITED",
"IDC SECURITIES LIMITED",
"IDC SYSTEMS PRIVATE LIMITED",
"IDC TECHNOLOGIES PRIVATE LIMITED",
"IDC TECHNOLOGIES SOLUTIONS INDIA PRIVATE LIMITED",
"IDCC GLOBAL CHEM PRIVATE LIMITED",
"IDCO",
"IDCUBE IDENTIFICATION SYSTEMS PRIVATE LIMITED",
"IDD RESEARCH SOLUTIONS PRIVATE LIMITED",
"IDDC ENGINEERS PRIVATE LIMITED",
"IDE PRO ENGINEERING ASIA PRIVATE LIMITED",
"IDE TECHNOLOGIES INDIA PRIVATE LIMITED",
"IDEA CELLULAR INFRASTRUCTURE SERVICES LIMITED",
"IDEA DEVICE TECHNOLOGIES PRIVATE LIMITED",
"IDEA ENTITY TECH SOLUTIONS PRIVATE LIMITED",
"IDEA ESTATES PRIVATE LIMITED",
"IDEA FASTENERS PRIVATE LIMITED",
"IDEA FOUNDATIONS LIMITED",
"IDEA HOLDING LIMITED",
"IDEA HOUZE PRIVATE LIMITED",
"IDEA INFINITY IT SOLUTION PRIVATE LIMITED",
"IDEA INTERNATIONAL HOUSING & CONTRUCTION PRIVATE LIMITED",
"IDEA INTERNATIONAL PRIVATE LIMITED",
"IDEA LAKE INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"IDEA MOBILE COMMERCE SERVICES LIMITED",
"IDEA SPICE DESIGN PRIVATE LIMITED",
"IDEA WEAVERS PRIVATE LIMITED",
"IDEABOX INFOTECH SOLUTIONS PRIVATE LIMITED",
"IDEABREW SOLUTIONS PRIVATE LIMITED",
"IDEABRIGHT INFOTECH PRIVATE LIMITED",
"IDEABYTES SOFTWARE INDIA PRIVATE LIMITED",
"IDEACLICKS INFOLABS PRIVATE LIMITED",
"IDEACOUNT EDUCATION PRIVATE LIMITED",
"IDEACRAFT EVENTURES PRIVATE LIMITED",
"IDEACRAFT IT SOLUTIONS PRIVATE LIMITED",
"IDEACTS INNOVATIONS PRIVATE LIMITED",
"IDEAFARM TECHNOLOGY PRIVATE LIMITED",
"IDEAFORGE TECHNOLOGY LIMITED",
"IDEAGAMI PRIVATE LIMITED",
"IDEAHELIX INDIA PRIVATE LIMITED",
"IDEAKARD INDIA PRIVATE LIMITED",
"IDEAL ACADEMY OF SCIENCE",
"IDEAL ADVISORY SERVICES PRIVATE LIMITED",
"IDEAL BAKING CORPORATION",
"IDEAL BEACH RESORT",
"IDEAL BEST FOODS INDIA PRIVATE LIMITED",
"IDEAL BOILER SPARES PRIVATE LIMITED",
"IDEAL BROADCASTING INDIA PRIVATE LIMITED",
"IDEAL BUILDTECH PVT LTD",
"IDEAL CARPET INDUSTRIES",
"IDEAL CHEMI PLAST PRIVATE LIMITED",
"IDEAL CHEMICALS (INDIA) PRIVATE LIMITED",
"IDEAL CLINIC AND HOSPITAL PRIVATE LIMITED",
"IDEAL COLLEGE OF ARTS AND SCIENCES",
"IDEAL COMPONENTS PRIVATE LIMITED",
"IDEAL CONVEYORS PRIVATE LIMITED",
"IDEAL CORPORATE SOLUTIONS PRIVATE LIMITED",
"IDEAL CREATIONS PRIVATE LIMITED",
"IDEAL CREATIONS PRIVATE. LIMITED.",
"IDEAL CURES PRIVATE LIMITED",
"IDEAL DATACOM NETWORK AND ELECTRICAL SOLUTIONS PRIVATE LIMITED",
"IDEAL DEALERS PVT LTD",
"IDEAL DEGREE COLLEGE FOR WOMEN",
"IDEAL DESIGN AND DISPLAY INDIA PRIVATE LIMITED",
"IDEAL DETONATORS PRIVATE LIMITED",
"IDEAL DISTRIBUTORS PRIVATE LIMITED",
"IDEAL DYE CHEM INDUSTRIES",
"IDEAL E-CASH SOLUTIONS PRIVATE LIMITED",
"IDEAL ENCLAVE FLAT OWNERS ASSOCIATION",
"IDEAL ENGLISH HIGH SCHOOL",
"IDEAL EXPERIENTIAL LEARNING PRIVATE LIMITED",
"IDEAL FASTENER INDIA PRIVATE LIMITED",
"IDEAL FINANCIAL SOLUTIONS PRIVATE LIMITED",
"IDEAL FISCAL SERVICES LTD",
"IDEAL FOODGRAIN INDIA PRIVATE LIMITED",
"IDEAL FOOTWEAR PRIVATE LIMITED",
"IDEAL FOREX COMPANY PRIVATE LIMITED",
"IDEAL FREIGHT FORWARDERS PRIVATE LIMITED",
"IDEAL GAS SPRINGS PRIVATE LIMITED",
"IDEAL GEOSERVICES PRIVATE LIMITED",
"IDEAL HANDLING PRIVATE LIMITED",
"IDEAL HI TECH ENGINEERING EQUIPMENT PRIVATE LIMITED",
"IDEAL HIGH SCHOOL",
"IDEAL HOSPITALITY PRIVATE LIMITED",
"IDEAL HOTELS AND INDUSTRIES LIMITED",
"IDEAL HR SOLUTION PRIVATE LIMITED",
"IDEAL ICE LIMITED",
"IDEAL IMPRESSION MARKET RESEARCH PRIVATE LIMITED",
"IDEAL IMPRESSIONS PRIVATE LIMITED",
"IDEAL INDUSTRIAL EXPLOSIVES LIMITED",
"IDEAL INDUSTRIAL SYNERGY SOLUTIONS PRIVATE LIMITED",
"IDEAL INDUSTRY",
"IDEAL INFRASTRUCTURE SOLUTIONS PRIVATE LIMITED",
"IDEAL INSURANCE BROKERS PRIVATE LIMITED",
"IDEAL INTERNATIONAL SCHOOL",
"IDEAL INVENT TECHNOLOGIES PRIVATE LIMITED",
"IDEAL IT TECHNO PRIVATE LIMITED",
"IDEAL JR COLLEGE",
"IDEAL LAMINATES PRIVATE LIMITED",
"IDEAL LIFE SCIENCES PRIVATE LIMITED",
"IDEAL LIGHTING SYSTEMS PRIVATE LIMITED",
"IDEAL LUGGAGE PRIVATE LIMITED",
"IDEAL MULTI-MEDIA NETWORK PRIVATE LIMITED",
"IDEAL MULTIPLEX PRIVATE LIMITED",
"IDEAL PLAY ABACUS INDIA PRIVATE LIMITED",
"IDEAL POLY TECNALOGIES PRIVATE LIMITED",
"IDEAL POLYMERS (INDIA) PRIVATE LIMITED",
"IDEAL PRECISION COMPONENTS PRIVATE LIMITED",
"IDEAL PROMOTERS PRIVATE LIMITED",
"IDEAL PUBLIC SCHOOL",
"IDEAL PUBLICITY PRIVATE LIMITED",
"IDEAL REAL ESTATES PRIVATE LIMITED",
"IDEAL REALTECH PRIVATE LIMITED",
"IDEAL REMEDIES PRIVATE LIMITED",
"IDEAL RIVERVIEW PROJECTS PRIVATE LIMITED",
"IDEAL ROAD BUILDERS PRIVATE LIMITED",
"IDEAL SEALTAPE PRIVATE LIMITED",
"IDEAL SECURITY SERVICES PRIVATE LIMITED",
"IDEAL SHEET METAL STAMPINGS AND PRESSINGS PRIVATE LIMITED",
"IDEAL SMITHLINE PHARMACEUTICALS PRIVATE LIMITED",
"IDEAL STEELS AND IRON ENTERPRISES PRIVATE LIMITED",
"IDEAL SURFACE CARGO PRIVATE LIMITED",
"IDEAL TECHLABS PRIVATE LIMITED",
"IDEAL TECHNOSOFT PRIVATE LIMITED",
"IDEAL THERMO-PLAST PRIVATE LIMITED",
"IDEAL TRADELINKS PRIVATE LIMITED",
"IDEAL TRADERS CREAM PARLOUR PRIVATE LIMITED",
"IDEAL TRIDON CLAMP (MUMBAI) COMPANY PRIVATE LIMITED",
"IDEAL UNIQUE REALTORS PVT LTD",
"IDEAL WORKFORCE STAFFING SOLUTIONS PRIVATE LIMITED",
"IDEAL WOVENPLAST PRIVATE LIMITED",
"IDEALABS TEEN BANDAR PRIVATE LIMITED",
"IDEALE SUTURES PRIVATE LIMITED",
"IDEALIFE HEALTHCARE LIMITED",
"IDEALPREPAID INDIA PRIVATE LIMITED",
"IDEALSITE TECHNOLOGIES(NT) PRIVATE LIMITED",
"IDEAMETRICS PRIVATE LIMITED",
"IDEAPOKE TECHNOLOGIES PRIVATE LIMITED",
"IDEARX SERVICES PRIVATE LIMITED",
"IDEAS 1ST INFORMATION SERVICES PRIVATE LIMITED",
"IDEAS AHEAD AV SOLUTIONS PRIVATE LIMITED",
"IDEAS AND INNOVATION SQUARED TECHNOLOGIES PRIVATE LIMITED",
"IDEAS DESIGN SOLUTIONS PRIVATE LIMITED",
"IDEAS ELECTRICALS & ENGINEERS PRIVATE LIMITED",
"IDEAS INCORPORATED PRIVATE LIMITED",
"IDEAS INFRATECH INDIA PRIVATE LIMITED",
"IDEAS TO IMPACTS INNOVATIONS PRIVATE LIMITED",
"IDEAS2IT TECHNOLOGY SERVICES PRIVATE LIMITED",
"IDEAS2TECH GLOBAL PRIVATE LIMITED",
"IDEASCAPE COMMUNICATIONS PRIVATE LIMITED",
"IDEASFACTORY VENTURES PRIVATE LIMITED",
"IDEASSION TECHNOLOGY SOLUTIONS LLP",
"IDEASTACK SOLUTIONS PRIVATE LIMITED",
"IDEASURGE SOLUTIONS PRIVATE LIMITED",
"IDEATION STUDIO PRIVATE LIMITED",
"IDEATOR ENGINEERING PRIVATE LIMITED",
"IDEATREE INDIA PRIVATE LIMITED",
"IDEAVATE SOLUTIONS PRIVATE LIMITED",
"IDEAX LABELS AND ACCESSORIES PRIVATE LIMITED",
"I-DEB ACCOUNTANCY PRIVATE LIMITED",
"IDEC CONTROLS INDIA PRIVATE LIMITED",
"I-DECOR INDIA PRIVATE LIMITED",
"IDEE CONCEPTS PRIVATE LIMITED",
"IDELIVER SOFTWARE SOLUTIONS PRIVATE LIMITED",
"IDEM HEALTH CARE PRIVATE LIMITED",
"IDEMIA IDENTITY & SECURITY INDIA PRIVATE LIMITED",
"IDEMIA SYSCOM INDIA PRIVATE LIMITED",
"IDEMITSU FINE COMPOSITES (INDIA) PRIVATE LIMITED",
"IDEMITSU LUBE INDIA PRIVATE LIMITED",
"IDEN GRAPHICS PVT.LTD",
"IDENTICAL BRAINS PRIVATE LIMITED",
"IDENTIFYPLUS DELIVERY SERVICES PRIVATE LIMITED",
"IDENTIS TECH SOLUTIONS PRIVATE LIMITED",
"IDENTITY WELLNESS CENTRE PRIVATE LIMITED",
"IDENTIV PRIVATE LIMITED",
"IDENTIXWEB LIMITED",
"IDEOLOGI SYSTEMS PRIVATE LIMITED",
"IDEOLOGY TOOLING AND PRESS COMPONENTS PRIVATE LIMITED",
"IDEOPE MEDIA PRIVATE LIMITED",
"IDEOSMITH INDUSTRIES PRIVATE LIMITED",
"IDEOSPHERE CONSULTING PRIVATE LIMITED",
"IDEOVATE RESEARCH PRIVATE LIMITED",
"IDERIZE STUDIO INDIA PRIVATE LIMITED",
"IDERIZE TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"IDESLABS PRIVATE LIMITED",
"IDEX EVENTS PRIVATE LIMITED",
"IDEX INDIA PRIVATE LIMITED",
"IDEX ONLINE (INDIA) PRIVATE LIMITED",
"IDEXCEL TECHNOLOGIES PRIVATE LIMITED",
"IDEXX LABORATORIES PRIVATE LIMITED",
"IDEYALABS TECH LLP",
"IDF FINANCIAL SERVICES PRIVATE LIMITED",
"IDFC ALTERNATIVES LIMITED",
"IDFC FINANCIAL HOLDING COMPANY LIMITED",
"IDFC FIRST BANK LIMITED",
"IDFC FIRST BHARAT LIMITED",
"IDFC FOUNDATION",
"IDFC INFRA DEBT FUND LIMITED",
"IDFL INDIA PRIVATE LIMITED",
"IDFS SERVICES PRIVATE LIMITED",
"IDG MEDIA PRIVATE LIMITED",
"IDHITRI GEOSERVICES PRIVATE LIMITED",
"IDHU FASHIONS PRIVATE LIMITED",
"IDHYAH FOODS INDIA PRIVATE LIMITED",
"IDHYAM CLINICAL LAB",
"IDI DESIGNS PRIVATE.LIMITED",
"IDI INFRA PRIVATE LIMITED",
"IDIADA AUTOMOTIVE TECHNOLOGY INDIA PRIVATE LIMITED",
"IDIBIM CONSULTANT PRIVATE LIMITED",
"IDIGIANS MEDIA PRIVATE LIMITED",
"IDIGISYS PRIVATE LIMITED",
"IDIGITAL ELECTRONICS PRIVATE LIMITED",
"IDIGITALISE CONSULTANCY PRIVATE LIMITED",
"IDIGITALPRENEUR PRIVATE LIMITED",
"IDIKA PROPERTIES PRIVATE LIMITED",
"IDIOM DESIGN AND CONSULTING LIMITED",
"IDIOSYNCRATIC INDUSTRIES PRIVATE LIMITED",
"IDIS SECURITATEM SOLUTIONES PRIVATE LIMITED",
"IDISHA INFO LABS PRIVATE LIMITED",
"IDIYA CREATORS PRIVATE LIMITED",
"IDKIT DCI TECHNOLOGIES PRIVATE LIMITED",
"IDLABELS AND SOLUTIONS PRIVATE LIMITED",
"IDLD LEARNING & DEVELOPMENT INDIA PRIVATE LIMITED",
"IDM SOLUTIONS PRIVATE LIMITED",
"IDMA LABORATORIES LIMITED",
"IDMA LABORATORIES LIMITED.",
"IDMC LIMITED",
"IDMISSION SOLUTIONS PRIVATE LIMITED",
"IDMWORKS IT SOLUTIONS GLOBAL PRIVATE LIMITED",
"IDN HOME PRIVATE LIMITED",
"IDN MOULD PRIVATE LIMITED",
"IDO GLOBAL INDIA PRIVATE LIMITED",
"IDOCZ.NET TECHNOLOGIES PRIVATE LIMITED",
"IDOL BIOTEC PRIVATE LIMITED",
"IDOL INFOTECH PRIVATE LIMITED",
"IDOL PLASTO PRIVATE LIMITED",
"IDOL POLYTECH PRIVATE LIMITED",
"IDOL WEARS PRIVATE LIMITED",
"IDOM INDIA PRIVATE LIMITED",
"IDONNEOUS MARKETING SERVICES PRIVATE LIMITED",
"IDOX INDIA PRIVATE LIMITED",
"IDP EDUCATION INDIA PRIVATE LIMITED",
"IDP EDUCATION INDIA SERVICES LLP",
"IDQ INNOVATION PRIVATE LIMITED",
"IDREAM ADVISORY SERVICES PRIVATE LIMITED",
"IDREAMS IMPEX PRIVATE LIMITED",
"IDRIVE SOFTWARE (INDIA) PRIVATE LIMITED",
"IDRREAM MOTION PICTURES INDIA PRIVATE LIMITED",
"IDRS LABS PRIVATE LIMITED",
"IDS ARGUS HEALTHCARE SERVICES PRIVATE LIMITED",
"IDS AUTOMATION PRIVATE LIMITED",
"IDS DENMED PRIVATE LIMITED",
"IDS E SOLUTIONS PRIVATE LIMITED",
"IDS FINANCIAL SERVICES PRIVATE LIMITED",
"IDS INFOTECH LIMITED",
"IDS LOGIC PRIVATE LIMITED",
"IDS NEXT BUSINESS SOLUTIONS PRIVATE LIMITED",
"IDS OMNI SOLUTIONS PRIVATE LIMITED",
"IDS RURAL ONLINE MARKETPLACE PRIVATE LIMITED",
"IDS TECHNOLOGIES INDIA PRIVATE LIMITED",
"IDSTEEL INDUSTRIES LIMITED",
"IDSURV TECHNOLOGIES PRIVATE LIMITED",
"IDT FASHION TRIMMINGS PRIVATE LIMITED",
"IDT GEMOLOGICAL LABORATORIES WORLDWIDE PRIVATE LIMITED",
"IDT LOGISTICS PRIVATE LIMITED",
"IDT SEMICONDUCTOR INDIA PRIVATE LIMITED",
"IDTN ENERGY (INDIA) PRIVATE LIMITED",
"IDUKKI DISTRICT TRADITIONAL CARDAMOM PRODUCER COMPANY LIMITED",
"IDUKKI RUBBERS P LTD",
"IDUPULAPADU COTTON MILLS PRIVATE LIMITED",
"IDX (INDIA) DISPLAY PRIVATE LIMITED",
"IDYLLIC CREATIONS PRIVATE LIMITED",
"IDYLLIC FACILITIES PRIVATE LIMITED",
"IDYLLIC RESORTS PRIVATE LIMITED",
"IDYLLIC SERVICES PRIVATE LIMITED",
"IDYLLIC SOFTWARE PRIVATE LIMITED",
"IDYNAMICS LIMITED",
"IDYNAMICS SOFTWARE PRIVATE LIMITED",
"IE AUTO INDUSTRIAL ENTERPRISE PRIVATE LIMITED",
"IE ONLINE MEDIA SERVICES PRIVATE LIMITED",
"IE TRUSTINDUSTRY PRIVATE LIMITED",
"IE3 INNOVATIONS PRIVATE LIMITED",
"IEC FABCHEM LIMITED",
"IEC MOTOR SERVICES PRIVATE LIMITED",
"IEC PROJECTS LIMITED",
"IECS CONSULTANCY LIMITED",
"IED COMMUNICATIONS LIMITED",
"IEE ENGINEERING ENTERPRISERS PVT LTD",
"IEE LIFTS PRIVATE LIMITED",
"IEE PROJECTS PRIVATE LIMITED",
"IEEC POWER ELECTRONICS PRIVATE LIMITED",
"IEIMPACT MEDICAL TRANSCRIPTION SERVICES PRIVATE LIMITED",
"IEIMPACT MICROSYSTEMS PRIVATE LIMITED",
"IEL LIMITED",
"IELEKTRON TECHNOLOGIES ENGINEERING PRIVATE LIMITED",
"IEMA RESEARCH & DEVELOPMENT PRIVATE LIMITED",
"IENERGIZER IT SERVICES PRIVATE LIMITED",
"IENERGY INNOVATIONS PRIVATE LIMITED",
"IENERGY NATURAL RESOURCES LIMITED",
"IENGINEERING POWER PRIVATE LIMITED",
"IENTITY PRIVATE LIMITED",
"IEP FUND ADVISORS PRIVATE LIMITED",
"IERS POWER KING PRIVATE LIMITED",
"IES MANAGEMENT COLLEGE AND RESEARCH CENTRE",
"IES MODERN ENGLISH SCHOOL",
"IES PADMAKAR DHAMDHERE ENGLISH MEDIUM PRIMARY",
"IES SECONDARY SCHOOL",
"IESOFT TECHNOLOGIES PRIVATE LIMITED",
"IES'S COLLEGE OF ARCHITECTURE",
"IES'S MANAGEMENT COLLEGE AND RESEARCH CENTRE",
"IET SERVICES INDIA PRIVATE LIMITED",
"IEW CRANES PRIVATE LIMITED",
"IEYZE CORPORATION PRIVATE LIMITED",
"IFA STEELS PRIVATE LIMITED",
"IFAA WIN MARINE EXPORT INDIA PRIVATE LIMITED",
"IFAN FINSERV PRIVATE LIMITED",
"IFAN GLOBAL INDIA PRIVATE LIMITED",
"IFAST FINANCIAL INDIA PRIVATE LIMITED",
"IFB AGRO INDUSTRIES LIMITED",
"IFB APPLIANCES LTD",
"IFB AUTOMOTIVE PRIVATE LIMITED",
"IFB GLOBAL LIMITED",
"IFB INDUSTRIES LTD",
"IFB SHIPPING (INDIA) PRIVATE LIMITED",
"IFCI FACTORS LIMITED",
"IFCI FINANCIAL SERVICES LIMITED",
"IFCI INFRASTRUCTURE DEVELOPMENT LIMITED",
"IFCI LIMITED.",
"IFCI VENTURE CAPITAL FUNDS LIMITED",
"IFCL LIMITED",
"IFE GLOBAL LOGISTICS (INDIA) PRIVATE LIMITED",
"IFEDORA SERVICES PRIVATE LIMITED",
"IFF OVERSEAS PRIVATE LIMITED",
"IFFCO EBAZAR LIMITED",
"IFFCO KISAN FINANCE LIMITED",
"IFFCO KISAN LOGISTICS LIMITED",
"IFFCO KISAN SEZ LIMITED",
"IFFCO KISAN SUVIDHA LIMITED",
"IFFCO TOKIO GENERAL INSURANCE COMPANY LIMITED",
"IFFCO-MC CROP SCIENCE PRIVATE LIMITED",
"IFFCO-TOKIO INSURANCE SERVICES LIMITED",
"IFFDC",
"IFFT MULTIETHNIC FASHION PRIVATE LIMITED",
"IFI TECHNOLOGY PRIVATE LIMITED",
"IFI TECHSOLUTIONS LIMITED",
"IFI TECHSOLUTIONS PRIVATE LIMITED",
"IFIELD ENERGY PRIVATE LIMITED",
"IFIN COMMODITIES LIMITED",
"IFIN CREDIT LIMITED",
"IFIN SECURITIES FINANCE LIMITED",
"IFINSOL GLOBAL PRIVATE LIMITED",
"IFINTALENT GLOBAL PRIVATE LIMITED",
"IFIRMS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"IFIXTECHGLOBAL PRIVATE LIMITED",
"IFIXTURE TECHNOLOGIES PRIVATE LIMITED",
"IFL AGRI PRODUCER COMPANY LIMITED",
"IFL ENTERPRISES LIMITED",
"IFL HOUSING FINANCE LIMITED",
"IFLAIR WEB TECHNOLOGIES PRIVATE LIMITED",
"IFLATE SOFTSYSTEMS INDIA PRIVATE LIMITED",
"I-FLOW IRRIGATION SYSTEMS PRIVATE LIMITED",
"IFLY VACATIONS PRIVATE LIMITED",
"IFM ELECTRONIC INDIA PRIVATE LIMITED",
"IFM ENGINEERING PRIVATE LIMITED",
"IFMA INDIA COMPANY",
"IFMC EDUCATIONAL INSTITUTIONS PRIVATE LIMITED",
"IFMR MEZZANINE FINANCE PRIVATE LIMITED",
"IFOCUS SYSTEC INDIA PRIVATE LIMITED",
"IFOOD WEB MEDIA TECHNOLOGY PRIVATE LIMITED",
"IFORE GREEN POWER PRIVATE LIMITED",
"I-FOREX (INDIA) PRIVATE LIMITED",
"IFOS AVIATION SERVICES PRIVATE LIMITED",
"IFOS FLIGHT SERVICES PRIVATE LIMITED",
"IFOUR TECHNOLAB PRIVATE LIMITED",
"I-FOUR TRANSFORMATION PRIVATE LIMITED",
"I-FOX WINDTECHNIK INDIA PRIVATE LIMITED",
"IFRA SOUTH ASIA PRIVATE LIMITED",
"IFTEX OIL AND CHEMICALS LIMITED",
"I-FUEL PRIVATE LIMITED",
"IFUSION NETLOGICS PRIVATE LIMITED",
"IFUTURE GLOBISTIC LIMITED",
"IFUTURE TECHNOLOGIES PRIVATE LIMITED",
"IFW TECHNO CREATIONS PRIVATE LIMITED",
"IG AATREYAS PRIVATE LIMITED",
"IG INFOTECH (INDIA) PRIVATE LIMITED",
"IG INTERNATIONAL PRIVATE LIMITED",
"IG SOLAR PRIVATE LIMITED",
"IG STEEL PRIVATE LIMITED",
"IG3 INFRA LIMITED",
"IGAKU NEEDLES PRIVATE LIMITED",
"IGAM AGENCIES PRIVATE LIMITED",
"IGARASHI MOTORS INDIA LIMITED",
"IGATE INFRASTRUCTURE MGMT SERVICES",
"IGATPURI NAGAR PARISHAD",
"IGAURI SOLUTIONS PRIVATE LIMITED",
"IGAWARA INDIA PRIVATE LIMITED",
"IGB POLYMERS PRIVATE LIMITED",
"IGD SERVICES PRIVATE LIMITED",
"IGDL INTERNATIONAL FZF",
"IGE INDIA LIMITED",
"IGE INDIA PRIVATE. LIMITED.",
"IGEAR HOLDINGS PRIVATE LIMITED",
"IGEAR TECH PRIVATE LIMITED",
"IGEFI SOFTWARE INDIA PRIVATE LIMITED",
"IGEN AGRI SOLUTIONS PRIVATE LIMITED",
"IGEN TECHNOLOGIES PRIVATE LIMITED",
"IGENE ENTERTAINMENT SERVICES PRIVATE LIMITED",
"IGENE LABSERVE PRIVATE LIMITED",
"IGENE MEDIA SOLUTION PRIVATE LIMITED",
"IGENE SCHOOL OF VFX TECHNOLOGY LLP",
"IGENETIC DIAGNOSTICS PRIVATE LIMITED",
"IGENOMIX INDIA PRIVATE LIMITED",
"IGESI HOSPITAL",
"IGFT PRIVATE LIMITED",
"IGH HOLDINGS PRIVATE LIMITED",
"IGI CORPORATION PRIVATE LIMITED",
"IGI INFORMATION TECHNOLOGY PRIVATE LIMITED",
"IGIENE CLEANING SERVICES PRIVATE LIMITED",
"IGK INTERIORS INDIA PRIVATE LIMITED",
"IGL FERTILIZERS PRIVATE LIMITED",
"IGL GEMSTONES PRIVATE LIMITED",
"IGL INDUSTRIES LIMITED",
"IGL INFRASTRUCTURE PRIVATE LIMITED",
"IGL SEEDS PRIVATE LIMITED",
"IGLOBAL IMPACT ITES PRIVATE LIMITED",
"IGLOBAL KPO SERVICES LLP",
"IGLOBE SOLUTIONS PRIVATE LIMITED",
"IGLOBLE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"I-GLOBUS CORPORATE CONSULTING PRIVATE LIMITED",
"IGLOO DAIRY SERVICES PRIVATE LIMITED",
"IGLULABS SOFTWARE PRIVATE LIMITED",
"IGM EXPORTS PRIVATE LIMITED",
"IGM ROBOTICSYSTEMS INDIA PRIVATE LIMITED",
"IGM SHIPPING PRIVATE LIMITED",
"IGMITE SOLUTIONS PRIVATE LIMITED",
"IGMOULD TECHNOLOGIES PRIVATE LIMITED",
"IGNACIO DEVELOPERS PRIVATE LIMITED",
"IGNATIUZ SOFTWARE PRIVATE LIMITED",
"IGNEXTO BIOTEX PRIVATE LIMITED",
"IGNIFY SOFTWARE PRIVATE LIMITED",
"IGNIGHTER ENGINEERING PRIVATE LIMITED",
"IGNIS AEROSPACE & DESIGN PRIVATE LIMITED",
"IGNIS INFRA-TECH SOLUTIONS PRIVATE LIMITED",
"IGNIS INTERNATIONAL INDUSTRIES PRIVATE LIMITED",
"IGNITARIUM TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"IGNITARY RESOURCES PRIVATE LIMITED",
"IGNITE INFRATECH PRIVATE LIMITED",
"IGNITE JUNIOR COLLEGE",
"IGNITE LIFE SCIENCE FOUNDATION",
"IGNITE SOLUTIONS INDIA PRIVATE LIMITED",
"IGNITEE DIGITAL SERVICES PRIVATE LIMITED",
"IGNITEWORLD PRIVATE LIMITED",
"IGNITHO TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"IGNITING MINDS AEROSPACE PRIVATE LIMITED",
"IGNITION AUTO PRIVATE LIMITED",
"IGNITION EDUTECH PRIVATE LIMITED",
"IGNITIUM SERVICES PRIVATE LIMITED",
"IGNITIV TECHNOLOGIES PRIVATE LIMITED",
"IGNIVA MARKETING PRIVATE LIMITED",
"IGNIVA SOLUTIONS PRIVATE LIMITED",
"IGNOU",
"IGNOU INDIRA GANDHI NATIONAL OPEN UNIVERSITY",
"IGNOVATE SOLUTIONS PRIVATE LIMITED",
"IGNUS FIRE SOLUTIONS PRIVATE LIMITED",
"IGO SOLUTIONS PRIVATE LIMITED",
"IGOLD TECHNOLOGIES PRIVATE LIMITED",
"IGONIC VENTURES LLP",
"IGP ENGINEERS PRIVATE LIMITED",
"I-GRANDEE SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"IGREENTEC ENGINEERING INDIA PRIVATE LIMITED",
"IGRID ENERGY SOLUTIONS PRIVATE LIMITED",
"IGRID INDIA PRIVATE LIMITED",
"IGROUP INFOTECH INDIA PRIVATE LIMITED",
"IGROW VIRTUAL IT SOLUTIONS PRIVATE LIMITED",
"IGRPHENIX ELECTRON PRIVATE LIMITED",
"IGRUN TECH PRO PRIVATE LIMITED",
"IGS APPARELS PRIVATE LIMITED",
"IGS INFRA PRIVATE LIMITED",
"IGS LOGISTICS PRIVATE LIMITED",
"IGSA SOLUTIONS PRIVATE LIMITED",
"IGT EXPORTS LTD",
"IGT INDIA PRIVATE LIMITED",
"IGT SOLUTIONS PRIVATE LIMITED",
"IGUID GLOBAL PRIVATE LIMITED",
"IGUS INDIA PRIVATE LIMITED",
"IGW INDIA TECHNOLOGIES PRIVATE LIMITED",
"IH&MS INTEGRATED SOLUTIONS INDIA PRIVATE LIMITED",
"IHBA TECHNO SOFT PRIVATE LIMITED",
"IHC INFRA BUILD PRIVATE LIMITED",
"IHC PARTS AND SERVICES (INDIA) PRIVATE LIMITED",
"IHCS TECHNOLOGIES INDIA PRIVATE LIMITED",
"IHD INDIA PRIVATE LIMITED",
"IHD INDUSTRIES PRIVATE LIMITED",
"IHD MARKETPLACE PRIVATE LIMITED",
"IHDP HOME INTERIORS EXPORT PARKS PRIVATE LIMITED",
"IHEART PROPERTIES PRIVATE LIMITED",
"IHF CLOTHING PRIVATE LIMITED",
"IHHR HOSPITALITY ANDHRA PRIVATE LIMITED",
"IHHR HOSPITALITY PRIVATE LIMITED",
"IHI CORPORATION",
"IHL LIFESCIENCES PRIVATE LIMITED",
"IHM AGRO FOODS PRIVATE LIMITED",
"IHM PIPES & STEELS PRIVATE LIMITED",
"IHM VALVES PRIVATE LIMITED",
"IHNC PRIVATE LIMITED",
"IHORIZONS INFORMATION SERVICES INDIA PRIVATE LIMITED",
"IHP ENTERPRISES PRIVATE LIMITED",
"IHP FINVEST LIMITED",
"IHPC POWER SOLUTIONS PRIVATE LIMITED",
"IHS GLOBAL PRIVATE LIMITED",
"IHSEDU AGROCHEM PRIVATE LIMITED",
"IHSEDUAGROCHEM PRIVATE LIMITED",
"IHT NETWORK LIMITED",
"IHUB EXPRESS PRIVATE LIMITED",
"I-HUB FOR ROBOTICS AND AUTONOMOUS SYSTEMS INNOVATION FOUNDATION",
"IHW MEDIA PRIVATE LIMITED",
"II KP ENTERPRISES",
"II5 TECHNOLOGIES PRIVATE LIMITED",
"IIAE EDUCATION SOCIETY",
"IIB CAREER INSTITUTE PRIVATE LIMITED",
"IIC CONTAINER LINE LIMITED",
"IIC LIMITED",
"IIC SERVICES INDIA PRIVATE LIMITED",
"IIC SOFTWARE SERVICES (INDIA) PRIVATE LIMITED",
"IIC TECHNOLOGIES PRIVATE LIMITED",
"IICE COMPUTER EDUCATION PRIVATE LIMITED",
"IIDL REALTORS PRIVATE LIMITED",
"IIFCL ASSET MANAGEMENT COMPANY LIMITED",
"IIFCL PROJECTS LIMITED",
"360 ONE DISTRIBUTION SERVICES LIMITED",
"IIFL FACILITIES SERVICES LIMITED",
"IIFL FINANCE LIMITED",
"IIFL HOLDINGS LIMITED",
"IIFL HOME FINANCE LIMITED",
"IIFL INSURANCE BROKERS LIMITED",
"IIFL MANAGEMENT SERVICES LIMITED",
"IIFL SAMASTA FINANCE LIMITED",
"IIFL WEALTH MANAGEMENT LIMITED",
"IIFL WEALTH PRIME LIMITED",
"IIGB ADVISORS PRIVATE LIMITED",
"IIGM PRIVATE LIMITED",
"IIGP VALVE TECHNOLOGY PRIVATE LIMITED",
"IIHM HOSPITALITY PRIVATE LIMITED",
"IIHMR UNIVERSITY JAIPUR",
"IIIEM EXIM TRAINING PRIVATE LIMITED",
"IIIEM GLOBAL TRAINING PRIVATE LIMITED",
"IIIOT INFOTECH PRIVATE LIMITED",
"IILM EDUCATION PRIVATE LIMITED",
"IILM FOUNDATION ACADEMY",
"IILM INSTITUTE FOR HIGHER EDUCATION",
"IILM UNIVERSITY",
"IIM AHMEDABAD",
"IIM AHMEDABAD ENDOWMENT MANAGEMENT FOUNDATION",
"IIM CALCUTTA",
"IIM INDORE",
"IIM KOZHIKODE",
"IIM LUCKNOW",
"IIMB INNOVATIONS",
"IIMCALCUTTA INNOVATION PARK",
"IIMI IMAGE MANAGEMENT PRIVATE LIMITED",
"IIMT AYURVEDIC MEDICAL COLLEGE AND HOSPITAL",
"IIMT COLLEGE OF ENGINEERING",
"IIMT COLLEGE OF PHARMACY",
"IIMT MEDIA PRIVATE LIMITED",
"IIMT UNIVERSITY MEERUT",
"IINDOWORLD MEDISERVE PRIVATE LIMITED",
"IINFOCOMM IT SERVICES PRIVATE LIMITED",
"IINTERCHANGE SYSTEMS PRIVATE LIMITED",
"IIOR INDIAN INSTITUTE OF OILSEEDS RESEARCH",
"IIPA CONSULTING PRIVATE LIMITED",
"IIPM",
"IIS FACILITY SERVICES INDIA PRIVATE LIMITED",
"IIS UNIVERSITY",
"IISHRAQ ELECTRONIC INTERNATIONAL PRIVATE LIMITED",
"IISKAM INFRA PRIVATE LIMITED",
"IIT ASHRAM",
"IIT BOMBAY ALUMNI ASSOCIATION",
"IIT BOMBAY DEVELOPMENT AND RELATIONS FOUNDATION",
"IIT DELHI",
"IIT DELHI ENDOWMENT MANAGEMENT FOUNDATION",
"IIT HYDERABAD",
"IIT IAN'S PACE EDUCATION PRIVATE LIMITED",
"IIT KANPUR",
"IIT KHARAGPUR",
"IIT MADRAS",
"IIT MADRAS RESEARCH PARK",
"IIT POWAI",
"IIT ROPAR",
"IITB MONASH RESEARCH ACADEMY",
"IITB-WUSTL RESEARCH AND EDUCATIONAL ACADEMY",
"IITI DRISHTI CPS FOUNDATION INDIAN INSTITUTE OF TECHNOLOGY INDORE",
"IITIAN'S PRASHIKSHAN KENDRA PRIVATE LIMITED",
"IITJOBS INC",
"IITL PROJECTS LIMITED",
"IITM INCUBATION CELL",
"IITM PRAVARTAK TECHNOLOGIES FOUNDATION",
"IJB HOTELS PRIVATE LIMITED",
"IJCP PUBLICATIONS LIMITED",
"IJEEVA SOFTWARE SOLUTIONS PRIVATE LIMITED",
"IJETZZ LOGISTICS PRIVATE LIMITED",
"IJLC INDIA PRIVATE LIMITED",
"IJM CONCRETE PRODUCTS PRIVATE LIMITED",
"IJM INDIA INFRASTRUCTURE LIMITED",
"IJM LINGAMANENI TOWNSHIP PRIVATE LIMITED",
"IJM MOTORS PRIVATE LIMITED",
"IJM PANJAB MOTORS PRIVATE LIMITED",
"IJM STEEL PRODUCTS PRIVATE LIMITED",
"IJOB DEPOT CONSULTANCY SERVICES PRIVATE LIMITED",
"IJPN TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"IJYA FASHIONS PRIVATE LIMITED",
"IK COMMUNICATION PRIVATE LIMITED",
"IK JEWELS (INDIA) LIMITED",
"IK KNIT FASHIONS PRIVATE LIMITED",
"IK POLYPACKS PRIVATE LIMITED",
"IKA INDIA PRIVATE LIMITED",
"IKAB SECURITIES AND INVESTMENT LIMITED",
"IKAMATE HR INDIA PRIVATE LIMITED",
"IKAN RELOCATION SERVICES INDIA PRIVATE LIMITED",
"I-KARE COMPOUNDS PRIVATE LIMITED",
"I-KARE POLYALLOYS PRIVATE LIMITED",
"IKARIA WELLNESS PRIVATE LIMITED",
"IKAROS SOLAR INDIA PRIVATE LIMITED",
"IKASHI FINTECH PRIVATE LIMITED",
"IKC TELECOM INFRASTRUCTURE PRIVATE LIMITED",
"IKCON DIGITAL IT SERVICES PRIVATE LIMITED",
"IKE ELECTRIC PRIVATE LIMITED",
"IKEA SERVICES INDIA PRIVATE LIMITED",
"IKEDA LIMITED",
"IKEDA PRIVATE LIMITED",
"IKEM PHARMA PRIVATE LIMITED",
"IKEN SOLUTIONS PRIVATE LIMITED",
"IKEVA VENTURE AND KNOWLEDGE ADVISORY SERVICES PRIVATE LIMITED",
"IKF FINANCE LIMITED",
"IKF HOME FINANCE LIMITED",
"IKF INFRATECH PRIVATE LIMITED",
"IKF SURAKSHA FINANCIAL SERVICES PRIVATE LIMITED",
"IKFM MANAGEMENT SERVICES PRIVATE LIMITED",
"IKG INDIA SERVICES PRIVATE LIMITED",
"IKIA METALS PRIVATE LIMITED",
"IKIGAI BUSINESS CONSULTING PRIVATE LIMITED",
"IKIGAI INFRATECH PRIVATE LIMITED",
"IKIKAI LIFESTYLE PRIVATE LIMITED",
"I-KINGDOM RETAIL PRIVATE LIMITED",
"IKIO LIGHTING LIMITED",
"IKIX 3D PRINTS PRIVATE LIMITED",
"IKM INVESTORS PRIVATE LIMITED",
"IKN CHASE CHECK SERVICES PRIVATE LIMITED",
"IKN ENGINEERING INDIA PRIVATE LIMITED",
"IKNOOR TECHNOLOGY PRIVATE LIMITED",
"IKNOWLEDGE FACTORY PRIVATE LIMITED",
"IKO HYBRID SEEDS PRIVATE LIMITED",
"IKOMET TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"IKON BARCODE SOLUTIONS PRIVATE LIMITED",
"IKON BOTTLES AND GLASS INDIA PRIVATE LIMITED",
"IKON COLLEGE OF FIRE ENGINEERING & SAFETY MANAGEMENT",
"IKON COPIER SERVICES PRIVATE LIMITED",
"IKON HERBAL PRODUCTS PRIVATE LIMITED",
"IKON INDIA PRIVATE LIMITED",
"IKON INNOVATIVE PRODUCTS PRIVATE LIMITED",
"IKON LABELS PRIVATE LIMITED",
"IKON LUBES (INDIA) PRIVATE LIMITED",
"IKON MOULDERS PRIVATE LIMITED",
"IKON MULTI SPECIALITY HOSPITAL PRIVATE LIMITED",
"IKON OUTSOURCING PRIVATE LIMITED",
"IKON PHARMACHEM PRIVATE LIMITED",
"IKON REMEDIES PRIVATE LIMITED",
"IKON RETAIL PRIVATE LIMITED",
"IKON RUBBER PRODUCTS PRIVATE LIMITED",
"IKON TECHNOLOGIES INDIA PRIVATE LIMITED",
"IKONIC INDUSTRIES INDIA PRIVATE LIMITED",
"IKONTEL SOLUTIONS PRIVATE LIMITED",
"IKOS DESIGNS PRIVATE LIMITED",
"IKOTECH INFOSOLUTIONS PRIVATE LIMITED",
"IKP KNOWLEDGE PARK",
"IKRAFT INTERIOR PROJECTS INDIA PRIVATE LIMITED",
"IKRAM RESTAURANT PRIVATE LIMITED",
"IKRIS PHARMA NETWORK PRIVATE LIMITED",
"IKRISH HEALTHCARE PRIVATE LIMITED",
"IKRUX SOLUTIONS OPC PRIVATE LIMITED",
"IKS FARMERS PRODUCER COMPANY LIMITED",
"IKSHA EYE CARE HOSPITALS LLP",
"IKSHAVAKU SOFTWARE VENTURES INDIA PRIVATE LIMITED",
"IKSHITA LOGISTICS PARK PRIVATE LIMITED",
"IKSULA SERVICES PLT LIMITED",
"IKTA AROMATICS LIMITED",
"IKURE TECHSOFT PRIVATE LIMITED",
"IKYAM SOLUTIONS PRIVATE LIMITED",
"IL JIN ELECTRONICS (INDIA) PRIVATE LIMITED",
"IL&FS CLUSTER DEVELOPMENT INITIATIVE LIMITED",
"IL&FS ENERGY DEVELOPMENT COMPANY LIMITED",
"IL&FS INFRA ASSET MANAGEMENT LIMITED",
"IL&FS MILESTONE REALTY ADVISORS PRIVATE LIMITED",
"IL&FS PARADIP REFINERY WATER LIMITED",
"IL&FS RAIL LIMITED",
"IL&FS SKILLS DEVELOPMENT CORPORATION LIMITED",
"IL&FS TAMIL NADU POWER COMPANY LIMITED",
"IL&FS TOWNSHIP & URBAN ASSETS LIMITED",
"IL&FS URBAN INFRASTRUCTURE MANAGERS LIMITED",
"IL&FS WATER LIMITED",
"IL&FS WIND ENERGY LIMITED",
"ILA BIOMARINE PRIVATE LIMITED",
"ILA COMMODITIES INDIA PRIVATE LIMITED",
"ILA INFOSOLUTIONS PRIVATE LIMITED",
"ILABKART TECHNOLOGIES PRIVATE LIMITED",
"ILABS HYDERABAD TECHNOLOGY CENTRE PRIVATE LIMITED",
"ILABS INFO TECHNOLOGY CENTER (GURGAON) PRIVATE LIMITED",
"ILABZ TECHNOLOGY LLP",
"ILAIYARAAJA MUSIC N MANAGEMENT PRIVATE LIMITED",
"ILANA ORGANICS PRIVATE LIMITED",
"ILAND MOTORS LIMITED",
"ILANO LED INDIA PRIVATE LIMITED",
"IDENTITYPLUS PRIVATE LIMITED",
"ILARIZA BIONATURALS PRIVATE LIMITED",
"ILC INDUSTRIES LIMITED",
"ILC SERVICES PRIVATE LIMITED",
"ILD MILLENNIUM PRIVATE LIMITED",
"ILE ILEARNINGENGINES INDIA PRIVATE LIMITED",
"ILEAD ANALYTICS TECHNOLOGY & CONSULTING PRIVATE LIMITED",
"ILEAD FOUNDATION",
"ILEAD POWER TECH & MANAGEMENT PRIVATE LIMITED",
"ILEADS AUXILIARY SERVICES PRIVATE LIMITED",
"I-LEAF BUILDPRO PRIVATE LIMITED",
"ILEAP ACADEMY PRIVATE LIMITED",
"ILED LIGHTING SYSTEMS PRIVATE LIMITED",
"ILENSYS TECHNOLOGIES PRIVATE LIMITED",
"ILEX DEVELOPERS & RESORTS LIMITED",
"ILEX PROPERTIES PRIVATE LIMITED",
"ILF CONSULTING ENGINEERS (INDIA) PRIVATE LIMITED",
"ILGAHNG AUTOMOTIVE INDIA PRIVATE LIMITED",
"ILGCROWN LEATHERS PRIVATE LIMITED",
"ILIFE IT SOLUTIONS PRIVATE LIMITED",
"ILIKA ESTATES PRIVATE LIMITED",
"ILINDRA WORK SPACE PRIVATE LIMITED",
"I-LINK INFOSOFT CONSULTANTS PRIVATE LIMITED",
"ILINK MULTITECH SOLUTIONS PRIVATE LIMITED",
"I-LINK RESEARCH SOLUTIONS INDIA PRIVATE LIMITED",
"ILINK SYSTEMS PRIVATE LIMITED",
"ILIOS BREWERIES PRIVATE LIMITED",
"ILIOS POWER PRIVATE LIMITED",
"ILIOS SYSTEMS PRIVATE LIMITED",
"ILIOSDIGITAL PRIVATE LIMITED",
"ILITE INDIA PRIVATE LIMITED",
"ILJIN AUTOMOTIVE PRIVATE LIMITED",
"ILJIN GLOBAL INDIA PRIVATE LIMITED",
"ILKKA HEALTHCARE PRIVATE LIMITED",
"ILLIES ENGINEERING (INDIA) PRIVATE LIMITED",
"ILLIG INDIA PRIVATE LIMITED",
"ILLINOIS INSTITUTE OF TECHNOLOGY INDIA PRIVATE LIMITED",
"ILLM UNIVERSITY",
"ILLUMINA INDIA BIOTECHNOLOGY PRIVATE LIMITED",
"ILLUMINATI BUILDING SOLUTIONS PRIVATE LIMITED",
"ILLUMINATI EDUCATION FORUM",
"ILLUMINATI HUMANISTA SOLUTIONS PRIVATE LIMITED",
"ILLUMINATI TRADING PRIVATE LIMITED",
"ILLUMINATION INDIA",
"ILLUMINE INDUSTRIES PRIVATE LIMITED",
"ILLUPPUR AGRICULTURE PRODUCER COMPANY LIMITED",
"ILLUSION DENTAL LABORATORY DIVISION OF LAXMI DENTAL EXPORT PVT LTD",
"ILLUSION REALITY STUDIOZ PRIVATE LIMITED",
"ILM INNOVATIVE SOLUTIONS PRIVATE LIMITED",
"ILM UX PRIVATE LIMITED",
"ILMS BUILDERS PRIVATE LIMITED",
"ILMS PROJECTS PRIVATE LIMITED",
"I-LOAN CREDIT PRIVATE LIMITED",
"ILOG SOLUTIONS INDIA PRIVATE LIMITED",
"ILOGIC NETWORK SOLUTION PRIVATE LIMITED",
"I-LOGICON CONTROL AUTOMATION PRIVATE LIMITED",
"ILOOPWORLD WEB PRIVATE LIMITED",
"ILOSUNG PRIVATE LIMITED",
"ILOVE DIAMONDS PRIVATE LIMITED",
"ILP SAFETY AND SECURITY SERVICES PRIVATE LIMITED",
"ILPEA PARAMOUNT LIMITED",
"ILS VENTURES PRIVATE LIMITED",
"ILSA SHIPPING & LOGISTICS PRIVATE LIMITED",
"ILSC INDIA PRIVATE LIMITED",
"ILSINTECH TRADING INDIA PRIVATE LIMITED",
"ILUMINAR ENGINEERING SERVICES PRIVATE LIMITED",
"ILUMINAR MEDIA LIMITED",
"ILUMINAR MERCHANDISING PRIVATE LIMITED",
"ILUX ELECTRICALS PRIVATE LIMITED",
"I-LUX TECHNICAL SERVICES PRIVATE LIMITED",
"ILV DISTRIPARK (MWC) PRIVATE LIMITED",
"ILV DISTRIPARK PRIVATE LIMITED",
"IM AMIS FORGINGS PRIVATE LIMITED",
"IM COST MANAGEMENT PRIVATE LIMITED",
"IM DIGITAL PRIVATE LIMITED",
"IM ENTERTAINMENT PRIVATE LIMITED",
"IM FASHION ACCESSORIES PRIVATE LIMITED",
"IM+ CAPITALS LIMITED",
"IM+ INVESTMENTS & CAPITAL PRIVATE LIMITED",
"IMA BOILERS PRIVATE LIMITED",
"IMA BULLION TRADING SERVICES LIMITED",
"IMA CLOTHING PRIVATE LIMITED",
"IMA INDIA PHARMA PROCESS",
"IMA PACKAGING TECHNOLOGY INDIA PRIVATE LIMITED",
"IMA PG INDIA PRIVATE LIMITED",
"IMAAN HOSPITALITY PRIVATE LIMITED",
"IMAANDAAR BUILDERS PRIVATE LIMITED",
"IMAANS SHOES PRIVATE LIMITED",
"IMAC ALLOY CASTING PRIVATE LIMITED",
"IMAC CABLES INDIA PRIVATE LIMITED",
"IMAC FACILITY PRIVATE LIMITED",
"IMAC INDIA COACH BUILDERS PRIVATE LIMITED",
"IMACBC DIAMOND EXPORTS PRIVATE LIMITED",
"IMAD TRAVEL PRIVATE LIMITED",
"IMAGA TRADE AND CRAFT PRIVATE LIMITED",
"IMAGE BRANDNEW INDIA PRIVATE LIMITED",
"IMAGE BRICKWORKS PRIVATE LIMITED",
"IMAGE CARGO MOVERS PRIVATE LIMITED",
"IMAGE COMPUTER SYSTEM PRIVATE LIMITED",
"IMAGE CORE LAB PRIVATE LIMITED",
"IMAGE CREATION SAREES PRIVATE LIMITED",
"IMAGE CREATIVE EDUCATION PRIVATE LIMITED",
"IMAGE CROP SCIENCES PRIVATE LIMITED",
"IMAGE DEALCOM PRIVATE LIMITED",
"IMAGE DEVICES INDIA PRIVATE LIMITED",
"IMAGE ENGINEERING & TECHNICAL INSTITUTE",
"IMAGE EQUITY (INDIA) PRIVATE LIMITED",
"IMAGE FURNISHERS PRIVATE LIMITED",
"IMAGE HEALTH CARE LIMITED",
"IMAGE INDIA SOLUTIONS PRIVATE LIMITED",
"IMAGE INFOSYSTEMS PRIVATE LIMITED",
"IMAGE INFOTAINMENT LIMITED",
"IMAGE LABELS PRIVATE LIMITED",
"IMAGE ONLINE PRIVATE LIMITED",
"IMAGE PUBLIC RELATIONS PRIVATE LIMITED",
"IMAGE REALTY LLP",
"IMAGE RX LENS PRIVATE LIMITED",
"IMAGE SOLUTIONS AND BRANDING PRIVATE LIMITED",
"IMAGE SPECIALITIES INDIA PRIVATE LIMITED",
"IMAGE STAR PRINT SOLUTIONS PRIVATE LIMITED",
"IMAGEBYTES PRIVATE LIMITED",
"IMAGE-ELECTRICAL ENTERPRISE PRIVATE LIMITED",
"IMAGEGRAFIX ENTERPRISES SOLUTIONS PRIVATE LIMITED",
"IMAGEGRAFIX SOFTWARE SOLUTIONS PRIVATE LIMITED",
"IMAGEKIT PRIVATE LIMITED",
"IMAGENE TECHNOLOGIES PRIVATE LIMITED",
"IMAGENOUS ENGINEERING PRIVATE LIMITED",
"IMAGEPROVISION TECHNOLOGY PRIVATE LIMITED",
"IMAGERY FASHIONS PRIVATE LIMITED",
"IMAGES ACCESS MULTIMEDIA PRIVATE LIMITED",
"IMAGES CONSUMER MEDIA PRIVATE LIMITED",
"IMAGES MULTIMEDIA PRIVATE LIMITED",
"IMAGES RETAIL INTELLIGENCE SERVICES PRIVATE LIMITED",
"IMAGETECH FURNITURE INDIA PRIVATE LIMITED",
"IMAGIC COMMUNICATIONS PVT LTD",
"IMAGICO INDIA PRIVATE LIMITED",
"IMAGIMAKE PLAY SOLUTIONS PRIVATE LIMITED",
"IMAGINARIUM INDIA PRIVATE LIMITED",
"IMAGINARIUM RAPID PRIVATE LIMITED",
"IMAGINARIUM SOLUTIONS (I) PRIVATE LIMITED",
"IMAGINATE SOFTWARE LABS PRIVATE LIMITED",
"IMAGINATION DESIGN AND COMMUNICATIONS INDIA PRIVATE LIMITED",
"IMAGINATION EDUTAINMENT INDIA PRIVATE LIMITED",
"IMAGINATION INFRATECH PRIVATE LIMITED",
"IMAGINATION INTERIOR DECORATORS LLP",
"IMAGINATION TECHNOLOGIES INDIA PRIVATE LIMITED",
"IMAGINATIONS SOFTECH SOLUTIONS PRIVATE LIMITED",
"IMAGINATIVE COLOURS PRIVATE LIMITED",
"IMAGINATIVE FLEXIPACKS LIMITED",
"IMAGINATIVE MINDS TRADERS PRIVATE LIMITED",
"IMAGINE FASHION APPARELS PRIVATE LIMITED",
"IMAGINE FIBRES PRIVATE LIMITED",
"IMAGINE IT PRIVATE LIMITED",
"IMAGINE MARKETING LIMITED",
"IMAGINE PANAJI SMART CITY DEVELOPMENT LIMITED",
"IMAGINE POWERTREE PRIVATE LIMITED",
"IMAGINE SERVICES 4 U PRIVATE LIMITED",
"IMAGINE SHOWBIZ LIMITED",
"IMAGINEARC INFRASTRUCTURE PRIVATE LIMITED",
"IMAGINEER TECHNOLOGIES PRIVATE LIMITED",
"IMAGINEERING SERVICE",
"IMAGING ENDPOINTS PRIVATE LIMITED",
"IMAGING PRODUCTS INDIA PRIVATE LIMITED",
"IMAGING WORLD DIAGNOSTIC CENTER",
"IMAGINNOVATE TECHSOLUTIONS INDIA PRIVATE LIMITED",
"IMAGINOUS PRIVATE LIMITED",
"IMAGIS ENGINEERING SOLUTIONS PRIVATE LIMITED",
"IMAGISMART SOLUTIONS PRIVATE LIMITED",
"IMAGO LEARNING SOLUTIONS PRIVATE LIMITED",
"IMAGO MEDIA COMPANY PRIVATE LIMITED.",
"IMAH POLY FAB PRIVATE LIMITED",
"IMAI FARMS PRIVATE LIMITED",
"IMARAT PLANNERS AND DEVELOPERS (INDIA) PRIVATE LIMITED",
"IMARC SERVICES PRIVATE LIMITED",
"I-MARINE INFRATECH (INDIA) PRIVATE LIMITED",
"IMARK INFOTECH PRIVATE LIMITED",
"IMARKETEER DIGITAL SERVICES LLP",
"IMARQUE SOLUTIONS PRIVATE LIMITED",
"I-MART TECHNOLOGIES PRIVATE LIMITED",
"IMARTI MEDIA PRIVATE LIMITED",
"IMASEN MANUFACTURING INDIA PRIVATE LIMITED",
"IMASIA CAD CAM SERVICES PRIVATE LIMITED",
"IMATE INFOTECH PRIVATE LIMITED",
"I-MATRIX IT SERVICES PRIVATE LIMITED",
"IMATRIX PROLEARN PRIVATE LIMITED",
"I-MAX COMMUNICATION PRIVATE LIMITED",
"IMAX DEVELOPERS PRIVATE LIMITED",
"IMAX GLOBAL VENTURES PRIVATE LIMITED",
"IMAX HEALTHCARE PRIVATE LIMITED",
"IMAX INFRASTRUCTURE PRIVATE LIMITED",
"IMAX MULTISPECIALITY HOSPITAL",
"IMAZZLE ADVERTISING PRIVATE LIMITED",
"IMBELLIRE BUSINESS SOLUTIONS PRIVATE LIMITED",
"IMC CHAMBER OF COMMERCE AND INDUSTRY",
"IMC INDIA SECURITIES PRIVATE LIMITED",
"IMC LIMITED",
"IMC PROJECTS INDIA LIMITED",
"IMCD INDIA PRIVATE LIMITED",
"IMCM PRIVATE LIMITED",
"IMCO ALLOYS PRIVATE LIMITED",
"IMCO DISTRIBUTORS PRIVATE LIMITED",
"IMCO OFFICE PRODUCTS INTERNATIONAL PRIVATE LIMITED",
"IMCOLA (EXPORTS) LIMITED",
"IMCOLA CRANE COMPANY PRIVATE LIMITED",
"IMCRINOX TECHNOLOGIES PRIVATE LIMITED",
"IMCS TECH PRIVATE LIMITED",
"IME INDIA PRIVATE LIMITED",
"IMEAM DESIGN PRIVATE LIMITED",
"IMEC SERVICES LIMITED",
"IMEC TOOLS INDIA PRIVATE LIMITED",
"IMECHE ENGINEERING SERVICES PRIVATE LIMITED",
"IMECO MACHINES PRIVATE LIMITED",
"IMECO OVERSEAS PRIVATE LIMITED",
"IMEDDOC SOFTWARE INDIA PRIVATE LIMITED",
"IMEDIC MEDICAL SOLUTIONS PRIVATE LIMITED",
"IMEDRIX SYSTEMS PRIVATE LIMITED",
"IMEDX INFORMATION SERVICES PRIVATE LIMITED",
"IMEG ENGINEERING INDIA PRIVATE LIMITED",
"IMELT EXTRUSIONS PRIVATE LIMITED",
"IMERGE BUSINESS SOLUTIONS PRIVATE LIMITED",
"IMERIT TECHNOLOGY SERVICES PRIVATE LIMITED",
"IMERYS CARBONATES INDIA LIMITED",
"IMERYS CERAMICS (INDIA) PRIVATE LIMITED",
"IMERYS MINERALS (INDIA) PRIVATE LIMITED",
"IMERYS NEWQUEST INDIA PRIVATE LIMITED",
"IMERYS PERFORMANCE AND FILTRATION MINERALS PRIVATE LIMITED",
"IMERYS VIZAG PRIVATE LIMITED",
"IMET TOOLING INDIA PRIVATE LIMITED",
"IMETRIX SOLUTION PRIVATE LIMITED",
"IMETRIX VISION TECHNOLOGY INDIA PRIVATE LIMITED",
"IMEX APPLIANCES LIMITED",
"IMEX ENGINEERING CO PRIVATE LIMITED",
"IMEXCO INTERNATIONAL PRIVATE LIMITED",
"IMEXSU ABRASIVE PRIVATE LIMITED",
"IMEXSU INDIA PRIVATE LIMITED",
"IMEZR INNOVATIONS PRIVATE LIMITED",
"IMF FOUNDRY EQUIPMENT INDIA PRIVATE LIMITED",
"IMFA ALLOYS FINLEASE LIMITED",
"IMFA EXIM PRIVATE LIMITED",
"IMG ADVISORY PRIVATE LIMITED",
"IMG GLOBAL INFOTECH PRIVATE LIMITED",
"IMG RELIANCE PRIVATE LIMITED",
"IMGENEX INDIA PRIVATE LIMITED",
"IMG-IN CONTROLS PRIVATE LIMITED",
"IMI ABRASIVES PVT LTD",
"IMI NORGREN HERION PRIVATE LIMITED",
"IMICL DIGHI MARITIME LIMITED",
"IMICRON WEB SERVICES PRIVATE LIMITED",
"IMIGO WORLD PRODUCTS PRIVATE LIMITED",
"IMIS PHARMACEUTICALS PVT LTD",
"IMKEMEX MARKETING PRIVATE LIMITED",
"IML CONTAINERS INDIA PRIVATE LIMITED",
"IMM GARMENTS PRIVATE LIMITED",
"IMMACULATE AGRO SPICES PRIVATE LIMITED",
"IMMACULATE BROADCASTING CONSORTIUM WORLD NEWS PRIVATE LIMITED",
"IMMACULATE CAM SERVICES PRIVATE LIMITED",
"IMMACULATE COMMUNICATIONS HOSUR PRIVATE LIMITED",
"IMMACULATE HEART OF MARY HIGH SCH",
"IMMACULATE STEELS PRIVATE LIMITED",
"IMMACULE LIFESCIENCES PRIVATE LIMITED",
"IMMANENT SOLUTIONS",
"IMMANUEL AVIATION AND CARGO SERVICES PRIVATE LIMITED",
"IMMANUEL CRUSHERS AND MINES PRIVATE LIMITED",
"IMMCO SOFTWARE SOLUTIONS PRIVATE LIMITED",
"IMMENSE AUTO PRIVATE LIMITED",
"IMMENSE CULTURE PRIVATE LIMITED",
"IMMENSE ENERGIES PRIVATE LIMITED",
"IMMENSE FOREX & TRAVELS PRIVATE LIMITED",
"IMMENSE POWER PRIVATE LIMITED",
"IMMENSE Q ENGGINEERING PRIVATE LIMITED",
"IMMENSE SOLUTIONS PRIVATE LIMITED",
"IMMENSO TECH PRIVATE LIMITED",
"IMMER COMMODITIES INDIA PRIVATE LIMITED",
"IMMERGRO TECHNOLOGIES PRIVATE LIMITED",
"IMMERSIVE INFOTECH PRIVATE LIMITED",
"IMMERSIVE RADICAL DIGIMEDIA LLP",
"IMMIDART TECHNOLOGIES LLP",
"IMMIGRATION ADVISORY SERVICES PRIVATE LIMITED",
"IMMIGRATION NEW ZEALAND",
"IMMIGRATION SECURITY SERVICES PRIVATE LIMITED",
"IMMIX NUTRITION PRIVATE LIMITED",
"IMMO INFORMATION TECHNOLOGY PRIVATE LIMITED",
"IMMORTAL BUILDWELL PRIVATE LIMITED",
"IMMORTAL CORPORATE SERVICES PRIVATE LIMITED",
"IMMORTAL TECHNOLOGIES PRIVATE LIMITED",
"IMMORTAL TYRES PRIVATE LIMITED",
"IMMPLY INDIA TECHNOLOGY PRIVATE LIMITED",
"IMMRSE EDUCATION PRIVATE LIMITED",
"IMMUCARE DIAGNOSTICS PRIVATE LIMITED",
"IMMUCOR INDIA PRIVATE LIMITED",
"IMMUNETIC LIFESCIENCES PRIVATE LIMITED",
"IMMUNIS INFO SERVICES PRIVATE LIMITED",
"IMMUNITY CONSTRUCTION PRIVATE LIMITED",
"IMMUNITY HEALTHCARE PRIVATE LIMITED",
"IMMUNITY INFRA INDIA LIMITED",
"IMMUNITY NETWORKS & TECHNOLOGIES PRIVATE LIMITED",
"IMMUNO DIAGNOSTICS PVT LTD",
"IMMUNO NATURAL OILS PRIVATE LIMITED",
"IMMUNOCONCEPT INDIA PRIVATE LIMITED",
"IMMUNOSHOP INDIA PRIVATE LIMITED",
"IMO AIRCONDITIONING SERVICES PRIVATE LIMITED",
"IMO CONTROL PRIVATE LIMITED",
"IMOBDEV TECHNOLOGIES PRIVATE LIMITED",
"IMOMENTOUS SOFTWARE PRIVATE LIMITED",
"IMONITOR SOLUTIONS INDIA PRIVATE LIMITED",
"IMOSYS ENGINEERING COMPANY PRIVATE LIMITED",
"IMP ENGINEERING AND POWER PRIVATE LIMITED",
"IMPA INFOTECH PRIVATE LIMITED",
"IMPACT ADS PRIVATE LIMITED",
"IMPACT ADVERTISING PRIVATE LIMITED",
"IMPACT AGENCIES PRIVATE LIMITED",
"IMPACT BIG DATA ANALYSIS PRIVATE LIMITED",
"IMPACT BIOCEUTICALS PRIVATE LIMITED",
"IMPACT COMMUNICATIONS PRIVATE LIMITED",
"IMPACT CONTAINERS PRIVATE LIMITED",
"IMPACT CORPORATE INVESTMENTS PRIVATE LIMITED",
"IMPACT DESIGN SOLUTIONS PRIVATE LIMITED",
"IMPACT ENTERPRISES PVT LTD",
"IMPACT FILMS PRIVATE LIMITED",
"IMPACT FIRE AND SAFETY APPLIANCES PRIVATE LIMITED",
"IMPACT FLOORS INDIA PRIVATE LIMITED",
"IMPACT FOUNDATION (INDIA)",
"IMPACT GRAPHIC SOLUTIONS PRIVATE LIMITED",
"IMPACT HEALTHCARE PRIVATE LIMITED",
"IMPACT INDIA POLYMERS PRIVATE LIMITED",
"IMPACT INFORMATION TECHNOLOGY LABS PRIVATE LIMITED",
"IMPACT INFOTECH PRIVATE LIMITED",
"IMPACT INFRA EQUIPMENT PRIVATE LIMITED",
"IMPACT INFRAHEIGHTS PRIVATE LIMITED",
"IMPACT IT SOLUTIONS PRIVATE LIMITED",
"IMPACT KERALA LIMITED",
"IMPACT LABS PRIVATE LIMITED",
"IMPACT LEASING PRIVATE LIMITED",
"IMPACT MERCHANDISING & SOURCING PRIVATE LIMITED",
"IMPACT METAL PARTS PVT LTD",
"IMPACT PLATERS PVT LTD",
"IMPACT PROJECTS PRIVATE LIMITED",
"IMPACT PROPERTIES PVT LTD",
"IMPACT PSD PRIVATE LIMITED",
"IMPACT RESEARCH AND MEASUREMENT PRIVATE LIMITED",
"IMPACT SARE MAGNUM TOWNSHIPS PRIVATE LIMITED",
"IMPACT SARE REALTY PRIVATE LIMITED",
"IMPACT SENIOR LIVING ESTATES PRIVATE LIMITED",
"IMPACT STANDARD BUSINESS REPORTING PRIVATE LIMITED",
"IMPACT SYSTEMS PRIVATE LIMITED",
"IMPACT TELEVISION PRIVATE LIMITED",
"IMPACTWARE TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"IMPALA PHONES PRIVATE LIMITED",
"IMPAQTIVE TECHNOLOGIES INDIA PRIVATE LIMITED",
"IMPARTUS INNOVATIONS PRIVATE LIMITED",
"IMPASTO COMMUNICATION PRIVATE LIMITED",
"IMPECCABLE FACILITY MANAGEMENT PRIVATE LIMITED",
"IMPEGNO SOFTWARE SOLUTIONS PRIVATE LIMITED",
"IMPEL EXPORTS PRIVATE LIMITED",
"IMPEL FORGE AND ALLIED INDUSTRIES LIMITED",
"IMPEL HOLDINGS PRIVATE LIMITED",
"IMPEL MARKETING (INDIA) PRIVATE LIMITED",
"IMPEL SERVICES PRIVATE LIMITED",
"IMPELCO TRANSFORMER PRIVATE LIMITED",
"IMPELPRO SCM SOLUTIONS PRIVATE LIMITED",
"IMPELSOFT TECHNOLOGIES PRIVATE LIMITED",
"IMPELSYS PRIVATE LIMITED",
"IMPENDI ANALYTICS INDIA PRIVATE LIMITED",
"IMPERARE ALLOYS PRIVATE LIMITED",
"IMPERARE IMPEX PRIVATE LIMITED",
"IMPERATIV HOSPITALITY PRIVATE LIMITED",
"IMPERATIVE BUSINESS VENTURES LIMITED",
"IMPERATIVE HOSPITALITY PRIVATE LIMITED",
"IMPERIA HEALTH PRIVATE LIMITED",
"IMPERIA INFRACON",
"IMPERIA INTERNATIONAL PRIVATE LIMITED",
"IMPERIA STRUCTURES LIMITED",
"IMPERIA WISHFIELD PRIVATE LIMITED",
"IMPERIAAL GRANIMARMO PRIVATE LIMITED",
"IMPERIAL 2WHEELERS PRIVATE LIMITED",
"IMPERIAL FOOD BIZ PRIVATE. LIMITED",
"IMPERIAL ACCESSORIES AND SPARES INDIA PRIVATE LIMITED",
"IMPERIAL AGRO PRIVATE LIMITED",
"IMPERIAL AUTO INDUSTRIES LIMITED",
"IMPERIAL AUTOMOBILES PRIVATE LIMITED",
"IMPERIAL AUTOWHEELS PRIVATE LIMITED",
"IMPERIAL BANK KENYA",
"IMPERIAL BIOTECH PRIVATE LIMITED",
"IMPERIAL BUILD TECH PRIVATE LIMITED",
"IMPERIAL BUILDREAL PRIVATE LIMITED",
"IMPERIAL CABLES PRIVATE LIMITED",
"IMPERIAL COLLEGE OF ENGINEERING AND RESEARCH",
"IMPERIAL CONSTRAFIN PRIVATE LIMITED",
"IMPERIAL DEGREE COLLEGE",
"IMPERIAL DEVELOPERS",
"IMPERIAL DISTILLERS AND VINTNERS PRIVATE LIMITED",
"IMPERIAL DYEING LIMITED",
"IMPERIAL ELECTRO CONTROLS PRIVATE LIMITED",
"IMPERIAL ENGINEERS AUTO PRIVATE LIMITED",
"IMPERIAL EXPORTS LIMITED",
"IMPERIAL FERNANDO BALLET COMPANY PRIVATE LIMITED",
"IMPERIAL FOREX PRIVATE LIMITED",
"IMPERIAL FRAGRANCES & FLAVOURS PRIVATE LIMITED",
"IMPERIAL FREIGHT FORWARDERS PVT LTD",
"IMPERIAL FUELS PRIVATE LIMITED",
"IMPERIAL GASES PRIVATE LIMITED",
"IMPERIAL GEMS LEAGUE INDIA PRIVATE LIMITED",
"IMPERIAL GRANITES PRIVATE LIMITED",
"IMPERIAL GREEN INFRA ESTATES PRIVATE LIMITED",
"IMPERIAL HEALTHCARE PRIVATE LIMITED",
"IMPERIAL HERITAGE SCHOOL",
"IMPERIAL HOLIDAY HOMES LIMITED",
"IMPERIAL HOSPITAL AND RESEARCH CENTRE LIMITED",
"IMPERIAL HOUSING VENTURES PRIVATE LIMITED",
"IMPERIAL INFRASTRUCTURE & DREDGING PRIVATE LIMITED",
"IMPERIAL INSTITUTE OF MANAGEMENT AND TECHNICAL STUDIES",
"IMPERIAL INTERNATIONAL PRIVATE LIMITED",
"IMPERIAL LIFE SCIENCES PRIVATE LIMITED",
"IMPERIAL LIFESTYLE PRIVATE LIMITED",
"IMPERIAL MARKETING SERVICES INDIA PRIVATE LIMITED",
"IMPERIAL MARKETING SERVICES INDIA PVT LTD",
"IMPERIAL MARTOR ENGINE TUBES PRIVATE LIMITED",
"IMPERIAL MEDCARE PRIVATE LIMITED",
"IMPERIAL MERCHANTS PRIVATE LIMITED",
"IMPERIAL OILFIELD CHEMICALS PRIVATE LIMITED",
"IMPERIAL ONLINE SERVICES PRIVATE LIMITED",
"IMPERIAL OVERSEAS PRIVATE LIMITED",
"IMPERIAL PHARMACHINES PRIVATE LIMITED",
"IMPERIAL PLATFORMS PRIVATE LIMITED",
"IMPERIAL PRIME CAPITAL PRIVATE LIMITED",
"IMPERIAL READYMADE GARMENTS FACTORY INDIA PRIVATE LIMITED",
"IMPERIAL REALTY & DEVELOPMENTS PRIVATE LIMITED",
"IMPERIAL SCHOOL OF BANKING & MANAGEMENT STUDIES",
"IMPERIAL SERVICED OFFICES AND PROPERTY MANAGEMENT PRIVATE LIMITED",
"IMPERIAL SHAH STORES",
"IMPERIAL SOLUTIONS PRIVATE LIMITED",
"IMPERIAL SPIRITS PRIVATE LIMITED",
"IMPERIAL STEEL PRIVATE LIMITED",
"IMPERIAL TOOLS PRIVATE LIMITED",
"IMPERIAL TRUCKING SERVICES INDIA PRIVATE LIMITED",
"IMPERIAL VEHICLES PRIVATE LIMITED",
"IMPERIAL WATERPROOFING INDUSTRIES PRIVATE LIMITED",
"IMPERIAL WHEELS PRIVATE LIMITED",
"IMPERIAL WORLDTRADE PRIVATE LIMITED",
"IMPERIALL TECHNOFORGE PRIVATE LIMITED",
"IMPERIO REALTIES PRIVATE LIMITED",
"IMPERIO VENTURES PRIVATE LIMITED",
"IMPERIOUS PHARMACEUTICAL PRIVATE LIMITED",
"IMPERIUM AGRO PRIVATE LIMITED",
"IMPERIUM CERAMIC PRIVATE LIMITED",
"IMPERIUM CNG SERVICES PRIVATE LIMITED",
"IMPERIUM DIGITAL NETWORK PRIVATE LIMITED",
"IMPERIUM ENGINEERING PRIVATE LIMITED",
"IMPERO IT SERVICES PRIVATE LIMITED",
"IMPERUS INTERIOR INDIA PRIVATE LIMITED",
"IMPERVA INDIA PRIVATE LIMITED",
"IMPETIS BIOSCIENCES LIMITED",
"IMPETUS ADCON PRIVATE LIMITED",
"IMPETUS ANALYTIC E-SOLUTIONS PRIVATE LIMITED",
"IMPETUS ARTHASUTRA PRIVATE LIMITED",
"IMPETUS CORPORATE PRIVATE LIMITED",
"IMPETUS ENGINEERS PROJECTS PRIVATE LIMITED",
"IMPETUS FIELD OPERATIONS PRIVATE LIMITED",
"IMPETUS IMPEX PVT LTD",
"IMPETUS INFRA PRIVATE LIMITED",
"IMPETUS INSURANCE BROKERS PRIVATE LIMITED",
"IMPETUS PACKAGING PRIVATE LIMITED",
"IMPETUS PROLIFIC PRIVATE LIMITED",
"IMPETUS RESEARCH PRIVATE LIMITED",
"IMPETUS TECHNOLOGIES INDIA PRIVATE LIMITED",
"IMPEX (INDIA) LIMITED",
"IMPEX CLEARING SERVICES PRIVATE LIMITED",
"IMPEX ENGINEERS PRIVATE LIMITED",
"IMPEX EXPRESS LOGISTICS PRIVATE LIMITED",
"IMPEX FERRO TECH LTD",
"IMPEX GLOBAL LOGISTICS PRIVATE LIMITED",
"IMPEX HEALTHCARE PRIVATE LIMITED",
"IMPEX METAL & FERRO ALLOYS LTD",
"IMPEX METAL PRIVATE LIMITED",
"IMPEX SERVICES INDIA PRIVATE LIMITED",
"IMPEXIFY SOLUTIONS PRIVATE LIMITED",
"IMPIGER TECHNOLOGIES PRIVATE LIMITED",
"IMPLANTAIRE TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"IMPLANTIUM INDIA PRIVATE LIMITED",
"IMPLANT'S BETTER SIGHT CENTRE PVT LTD",
"IMPLEMENTERS RETAIL INDIA PRIVATE LIMITED",
"IMPLENIA SMART NETWORK SERVICES PRIVATE LIMITED",
"IMPLEXIANS ECO SOLUTIONS PRIVATE LIMITED",
"IMPO FREIGHT PRIVATE LIMITED",
"IMPORIABOX MINERALS PRIVATE LIMITED",
"IMPORT EXPRESS INDIA PRIVATE LIMITED",
"IMPORTVIS PRIVATE LIMITED",
"IMPOS GLOBAL SERVICES PRIVATE LIMITED",
"IMPOSE INFRATECH PRIVATE LIMITED",
"IMPOTEL GLOBAL HEALTHCARE LLP",
"IMPOWER SOLUTIONS PRIVATE LIMITED",
"IMPRESA HOSPITALITY MANAGEMENT PRIVATE LIMITED",
"IMPRESARIO ENTERTAINMENT AND HOSPITALITY PRIVATE LIMITED",
"IMPRESS APPAREL MACHINES PRIVATE LIMITED",
"IMPRESS BOX MAKERS PRIVATE LIMITED",
"IMPRESS PRINTS PRIVATE LIMITED",
"IMPRESSICO BUSINESS SOLUTIONS PRIVATE LIMITED",
"IMPRESSION AUTO COMPONENTS PRIVATE LIMITED",
"IMPRESSION SECURITIES PRIVATE LIMITED",
"IMPRESSION SYSTEMS AND ENGINEERS PRIVATE LIMITED",
"IMPRESSION TOURISM SERVICES (INDIA) PRIVATE LIMITED",
"IMPRESSIONS PRINTING & PACKAGING LIMITED",
"IMPRESSIONS RFID PRIVATE LIMITED",
"IMPRESSIONS SERVICES PRIVATE LIMITED",
"IMPRESSIVE DATA SERVICES PRIVATE LIMITED",
"IMPRESSIVE EVENTS HUB PRIVATE LIMITED",
"IMPRESSIVE HEIGHTS FINSTOCK LIMITED",
"IMPRESSIVE HOSPITALITIES PRIVATE LIMITED",
"IMPRESSIVE MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"IMPRESSO GLASS SALES PRIVATE LIMITED",
"IMPRINT CONCEPTS PRIVATE LIMITED",
"IMPRINT CONSTRUCTIONS PRIVATE LIMITED",
"IMPRINT LED DISPLAYS PRIVATE LIMITED",
"IMPRINT TECH INDIA PRIVATE LIMITED",
"IMPRINT TRADING PRIVATE LIMITED",
"IMPRINT VINIMAY PRIVATE LIMITED",
"IMPRINTNEXT PRIVATE LIMITED",
"IMPROVE BUSINESS SOLUTIONS INDIA PRIVATE LIMITED",
"IMPROVE TRADERS PRIVATE LIMITED",
"IMPROVEMENT INTERACTIVE INDIA PRIVATE LIMITED",
"IMPROWISED TECHNOLOGIES PRIVATE LIMITED",
"IMPS EDUCATION TRUST",
"IMPULSE ADVERTISING PVT LTD",
"IMPULSE GREEN ENERGY PRIVATE LIMITED",
"IMPULSE INDIA PRIVATE LIMITED",
"IMPULSE INTERNATIONAL PRIVATE LIMITED",
"IMPULSE JUNIOR COLLEGE",
"IMPULSE LOGISTICS PRIVATE LIMITED",
"IMPULSE MICROELECTRONICS PRIVATE LIMITED",
"IMPULSE OVERSEAS PRIVATE LIMITED",
"IMPULSE PAPER INDUSTRIES PRIVATE LIMITED",
"IMPULSE PHARMA PRIVATE LIMITED",
"IMPULSE PLUS HOSPITAL PRIVATE LIMITED",
"IMPULSE TECHNOLOGIES AND BUSINESS SOLUTIONS PRIVATE LIMITED",
"IMPULSIONS LASER CONSULTING PRIVATE LIMITED",
"IMPULSIVE WEB PRIVATE LIMITED",
"IMR ELECTRICALS PRIVATE LIMITED",
"IMR INDIA PRIVATE LIMITED",
"IMR RESOURCES INDIA PRIVATE LIMITED",
"IMR SOFTWARE PRIVATE LIMITED",
"IMR STEEL PRIVATE LIMITED",
"IMRAN GLASS TRADING COMP PRIVATE LIMITED",
"IMRIEL TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"IMS ENGINEERING COLLEGE",
"IMS HEALTH INFORMATION SOLUTIONS INDIA PRIVATE LIMITED",
"IMS HEALTH TECHNOLOGY SOLUTIONS INDIA PRIVATE LIMITED",
"IMS IT SOLUTIONS PRIVATE LIMITED",
"IMS LEARNING RESOURCES PRIVATE LIMITED",
"IMS MACO SERVICES PVT LTD",
"IMS PROSCHOOL PRIVATE LIMITED",
"IMS SHIP MANAGEMENT",
"IMSE TECH-SERVICES PRIVATE LIMITED",
"IMSGROUP INDIA PRIVATE LIMITED",
"IMSI INDIA PRIVATE LIMITED",
"IMT CABLES PRIVATE LIMITED",
"IMT CENTRE FOR DISTANCE LEARNING PAYROLL",
"IMT TECHNOLOGIES PRIVATE LIMITED",
"IMT TEXKNITS PRIVATE LIMITED",
"IMTAC INDIA PRIVATE LIMITED",
"IMTF CANOO SOFTWARE PRIVATE LIMITED",
"IMTIARA CONSULTANTS PRIVATE LIMITED",
"IMTIBISH HEALTH CARE PRIVATE LIMITED",
"IMTP CONSULTANCY SERVICES CHENNAI PRIVATE LIMITED",
"IMT-THL INDIA PRIVATE LIMITED",
"IMUSICA ENTERTAINMENT PRIVATE LIMITED",
"IMV INDIA PRIVATE LIMITED",
"IMVERSION TECHNOLOGIES PRIVATE LIMITED",
"IMZ CORPORATE PRIVATE LIMITED",
"IMZ ENTERPRISES PRIVATE LIMITED",
"IN & OUT IMPRESSION PRIVATE LIMITED",
"IN 1947 INNOVATION DESIGN PRIVATE LIMITED",
"IN AND OUT ADVERTISING PRIVATE LIMITED",
"IN HOUZ RETAIL PRIVATE LIMITED",
"IN KNOW TECH PRIVATE LIMITED",
"IN MACHINERIES & EQUIPMENTS PRIVATE LIMITED",
"IN NO TECH TECHNOLOGIES PRIVATE LIMITED",
"IN POWER OIL INDUSTRIES PRIVATE LIMITED",
"IN SOLUTIONS GLOBAL LIMITED",
"IN SOLUTIONS GLOBAL PRIVATE LIMITED",
"IN TECHNOLOGIES PRIVATE LIMITED",
"IN TOUCH SOLUTIONS PRIVATE LIMITED",
"IN TRADING PRIVATE LIMITED",
"IN10 MEDIA PRIVATE LIMITED",
"IN2IT ENTERPRISE BUSINESS SERVICES PRIVATE LIMITED",
"IN2IT TECHNOLOGIES PRIVATE LIMTED",
"IN4 VELOCITY SYSTEMS PRIVATE LIMITED",
"IN4SOLUTION PRIVATE LIMITED",
"INA ELITE HOSPITALITY PRIVATE LIMITED",
"INA INDIA LIMITED",
"INA PHARMACEUTICALS PRIVATE LIMITED",
"INA TECHFM GLOBAL SOLUTION PRIVATE LIMITED",
"INAAVI CONSULTANCY PRIVATE LIMITED",
"INAAYA ENTERPRISES",
"INAAYA FOREX PRIVATE LIMITED",
"INABATA INDIA PRIVATE LIMITED",
"INAC BRASS PRIVATE LIMITED",
"INAC MICROTEK PRIVATE LIMITED",
"INAF PRIVATE LIMITED",
"INAGRIO FARMS SOLUTIONS PRIVATE LIMITED",
"INAGRO BIOSCIENCES PRIVATE LIMITED",
"INAHO DIGITAL SOLUTIONS PRIVATE LIMITED",
"INAIR HOLIDAYS PRIVATE LIMITED",
"INALCO METAL PRIVATE LIMITED",
"INAM IMPEX PRIVATE LIMITED",
"INAMDAR MULTISPECIALITY HOSPITAL",
"INAMDAR S HEART HOSPITAL",
"INANI COAL SERVICES PVT LTD",
"INANI INTERNATIONAL PRIVATE. LIMITED.",
"INANI MARBLES AND INDUSTRIES LTD",
"INANI MARBLES PVT LTD",
"INANI MARMO AND GRANITE P LTD",
"INANI METAL & ALLOYS PRIVATE LIMITED",
"INANI MINCHEM PRIVATE LIMITED",
"INANI SECURITIES LIMITED",
"INANI STONES PRIVATE LIMITED",
"INANI TEXTILES PRIVATE LIMITED",
"INAPEX PRIVATE LIMITED",
"INAPP INFORMATION TECHNOLOGIES INDIA PRIVATE LIMITED",
"INAPPAD ADVERTISING INDIA PRIVATE LIMITED",
"INARA TRAINING AND SKILL DEVELOPMENT ACADEMY",
"INARCO PRIVATE LIMITED",
"INATECH INDIA PRIVATE LIMITED",
"INATIVE NETWORKS PRIVATE LIMITED",
"INATIVE TELECOMMUNICATIONS PRIVATE LIMITED",
"INAVAN INDIA TECHNOLOGIES PRIVATE LIMITED",
"INAVIR PHARMATECH PRIVATE LIMITED",
"INAVIT INFRASTRUCTURE PRIVATE LIMITED",
"INAVIT SYSTEMS INDIA PRIVATE LIMITED",
"INB ENGINEERS PRIVATE LIMITED",
"INB FOOD PRODUCTS PRIVATE LIMITED",
"INB SERVICES PRIVATE LIMITED",
"INBEL ENTERPRISES PRIVATE LIMITED",
"INBIOGEN TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"IN-BIOT PRIVATE LIMITED",
"INBISCO INDIA PRIVATE LIMITED",
"INBISO ENGINEERING PRIVATE LIMITED",
"INBODY INDIA PRIVATE LIMITED",
"INBOIT SOLUTIONS PRIVATE LIMITED",
"INBORN ENGINEERING SOLUTIONS PVT LTD",
"INBOUND INFOCOM PRIVATE LIMITED",
"INBOUNDSYS WEB GALAXY PRIVATE LIMITED",
"INBOX PICTURES PRIVATE LIMITED",
"INBOXOPS SYSTEMS PRIVATE LIMITED",
"INBREW BEVERAGES PRIVATE LIMITED",
"INC 5 SHOES PRIVATE LIMITED",
"INCA HAMMOCK MANUFACTURING AND EXPORT PRIVATE LIMITED",
"INCA INFOTECH TECHNOLOGIES PRIVATE LIMITED",
"INCADEA INDIA PRIVATE LIMITED",
"INCAENDO TECHNOLOGIES PRIVATE. LIMITED",
"INCANDESCENT BUILDING SOLUTIONS PRIVATE LIMITED",
"INCANDESCENT TECHNOLOGIES PRIVATE LIMITED",
"INCANUS TECHNOLOGIES PRIVATE LIMITED",
"INCAP CONTRACT MANUFACTURING SERVICES PRIVATE LIMITED",
"INCAP LIMITED",
"INCAPSULATE INDIA PRIVATE LIMITED",
"INCAS INTERNATIONAL",
"INCEDO TECHNOLOGY SOLUTIONS LIMITED",
"INCENSE PARIVAAR PRIVATE LIMITED",
"INCENT TOURS PRIVATE LIMITED",
"INCENTIVE CONFERENCE AND EVENT MANAGEMENT PRIVATE LIMITED",
"INCENTIVE DESTINATIONS PRIVATE LIMITED",
"INCENTIVES SOFTWARE PRIVATE LIMITED",
"INCENTS CONSULTANTS PVT. LTD.",
"INCEPBIO PRIVATE LIMITED",
"INCEPTIVE CONSULTING PRIVATE LIMITED",
"INCEPTRA RETAIL INDIA PRIVATE LIMITED",
"INCEPTUM TECNICA SOLUTION PRIVATE LIMITED",
"INCESSANT TECHNOLOGIES PRIVATE LIMITED",
"INCH DIGITAL TECHNOLOGIES PRIVATE LIMITED",
"INCH ENERGY PRIVATE LIMITED",
"INCH ENVIRO TECHNOLOGIES PRIVATE LIMITED",
"INCH TRADE PRIVATE LIMITED",
"INCHCAPE SHIPPING SERVICES INDIA PRIVATE LIMITED",
"INCHCAPE SHIPPING SERVICES SSC PRIVATE LIMITED",
"INCHEM LABORATORIES PRIVATE LIMITED",
"INCHEON MOTORS PRIVATE LIMITED",
"INCHES HEALTHCARE PRIVATE LIMITED",
"INCHIN TRADING PRIVATE LIMITED",
"INCI CONSTRUCTION AND INTERIORS LIMITED",
"INCIPIO TECHNOLOGIES PRIVATE LIMITED",
"INCISE INFOTECH PRIVATE LIMITED",
"INCISIVE INFOTECH PRIVATE LIMITED",
"INCITE HOME CARE PRODUCTS PRIVATE LIMITED",
"INCKAH INFRASTRUCTURE TECHNOLOGIES PRIVATE LIMITED",
"INCLINE INFRA PROJECTS PRIVATE LIMITED",
"INCLINE REALTY PRIVATE LIMITED",
"INCLUSION FIRST CONSULTANCY PRIVATE LIMITED",
"INCLUSIVE SERVICES AND TECHNOLOGIES PRIVATE LIMITED",
"INCNUT DIGITAL PRIVATE LIMITED",
"INCNUT LIFESTYLE RETAIL PRIVATE LIMITED",
"INCO BUILDERS PRIVATE LIMITED",
"INCO COLOURS (INDIA) P LTDE",
"INCO MECHEL PVT LIMITED",
"INCOFIN INDIA INVESTMENT MANAGEMENT PRIVATE LIMITED",
"INCOHUB PAPERS PRIVATE LIMITED",
"INCOM KITS INDIA PRIVATE LIMITED",
"INCOM POWER PRIVATE LIMITED",
"INCOM SERVICES PRIVATE LIMITED",
"INCOME TAX APPELLATE TRIBUNAL",
"INCOME TAX DEPARTMENT",
"INCON AUTOMATION PRIVATE LIMITED",
"INCOPAC PARTS PRIVATE LIMITED",
"INCOR APPA PROJECTS PRIVATE LIMITED",
"INCOR CHENNAI PROJECTS TWO PRIVATE LIMITED",
"INCOR HOSPITALS PRIVATE LIMITED",
"INCOR HOSPITALS VIZAG PRIVATE LIMITED",
"INCOR INFRASTRUCTURE PRIVATE LIMITED",
"INCOR LAKE CITY PROJECTS PRIVATE LIMITED",
"INCOR PADMACHANDRA HOSPITALS PRIVATE LIMITED",
"INCORP ADVISORY SERVICES PRIVATE LIMITED",
"INCOSES ENGINEERING PRIVATE LIMITED",
"INCOTEC ENTERPRISES PRIVATE LIMITED",
"INCOTECH ENGINEERS PVT LTD",
"INCOZEN THERAPEUTICS PRIVATE LIMITED",
"INCREATIONS DESIGNS AND CONTRACTS PRIVATE LIMITED",
"INCRED ASSET MANAGEMENT PRIVATE LIMITED",
"INCRED CAPITAL FINANCIAL SERVICES PRIVATE LIMITED",
"INCRED CAPITAL WEALTH PORTFOLIO MANAGERS PRIVATE LIMITED",
"INCRED FINANCIAL SERVICES LIMITED",
"INCRED HOLDINGS LIMITED",
"INCRED PRIME FINANCE LIMITED",
"INCRED RESEARCH SERVICES PRIVATE LIMITED",
"INCRED WEALTH AND INVESTMENT SERVICES PRIVATE LIMITED",
"INCRED WEALTH PRIVATE LIMITED",
"INCREDIBLE ADVANCE TECHNOLOGIES PRIVATE LIMITED",
"INCREDIBLE AM PRIVATE LIMITED",
"INCREDIBLE BIZ SERVICES PRIVATE LIMITED",
"INCREDIBLE BUSINESS SOLUTIONS PRIVATE LIMITED",
"INCREDIBLE FACADE DEVELOPER PRIVATE LIMITED",
"INCREDIBLE HOUSING DEVELOPERS LIMITED",
"INCREDIBLE INDIA PROJECTS PRIVATE LIMITED",
"INCREDIBLE INDUSTRIES LIMITED",
"INCREDIBLE MANAGEMENT SERVICES PRIVATE LIMITED",
"INCREDIBLE TECHNOLOGIES PRIVATE LIMITED",
"INCREDIBLE VANIJYA PRIVATE LIMITED",
"INCREMENTORS WEB SOLUTIONS PRIVATE LIMITED",
"INCREMINDS PRIVATE LIMITED",
"INCREMINT CONSULTING PRIVATE LIMITED",
"INCRESCO TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"INCRESOL ENGINEERING SOLUTIONS PRIVATE LIMITED",
"INCRESOL SOFTWARE SERVICES PRIVATE LIMITED",
"INCRETIVE PRIVATE LIMITED",
"INCREV INDIA SOLUTIONS PRIVATE LIMITED",
"INCROLLERS PACKAGING PRIVATE LIMITED",
"INCROYABLE INDUSTRIES PRIVATE LIMITED",
"INCTURE TECHNOLOGIES PRIVATE LIMITED",
"INCUBATE ADVISORS INDIA PRIVATE LIMITED",
"INCUBATE SOFT TECH PRIVATE LIMITED",
"INCUBATION SYSTEMS PRIVATE LIMITED",
"INCUBE SOLUTIONS PRIVATE LIMITED",
"INCUBEX BUSINESS CONSULTING SERVICES PRIVATE LIMITED",
"INCUBIS CONSULTANTS INDIA PRIVATE LIMITED",
"INCUBIT GLOBAL BUSINESS SERVICES PRIVATE LIMITED",
"INCUBLER ADVISORS PRIVATE LIMITED",
"INCUITY PHARMA PRIVATE LIMITED",
"INCUS PHARMACEUTICALS PRIVATE LIMITED",
"INCUS QUIZ PRIVATE LIMITED",
"INCUSPAZE SOLUTIONS PRIVATE LIMITED",
"INCWERT ADVISORY PRIVATE LIMITED",
"INCY HEALTHCARE PRIVATE LIMITED",
"INCYGYS AUTOMATION PRIVATE LIMITED",
"INCYGYS GLOBAL CONSULTING PRIVATE LIMITED",
"IND AGIV COMMERCE LIMITED",
"IND AUST MARITIME PRIVATE LIMITED",
"IND AUTO MOTO TURNINGS PRIVATE LIMITED",
"IND CONTROLS PRIVATE LIMITED",
"IND ECO VENTURES LIMITED",
"IND FFT WORLDWIDE INDIA PRIVATE LIMITED",
"IND INFOTECH SERVICES",
"IND INNOVATIONS PRIVATE LIMITED",
"IND INST SOC WELFARE BUSS MNGT",
"IND MARVEL PROJECTS PRIVATE LIMITED",
"IND ORISON PRIVATE LIMITED",
"IND POWER LIMITED",
"IND SANITATION SOLUTIONS PRIVATE LIMITED",
"IND SPHINX PRECISION PRIVATE LIMITED",
"IND SWIFT LABORATORIES LIMITED",
"IND SWIFT LIMITED",
"IND SYNERGY LIMITED",
"INDAAI TECHNOLOGIES PRIVATE LIMITED",
"INDABIAN SMART VISION LLP",
"INDAC PARKING SYSTEMS PRIVATE LIMITED",
"INDACE CHEM INDIA PRIVATE LIMITED",
"INDACO JEANS PRIVATE LIMITED",
"INDAG RUBBER LIMITED",
"INDAGE DEVELOPMENT CONSTRUCTION PRIVATE LIMITED",
"INDAGRO FOODS PRIVATE LIMITED",
"INDAID ENGINEERS PRIVATE LIMITED",
"INDAIN INSTITUTE OF BANKING & FINANCE",
"INDAIRCON ENGINEERS PRIVATE LIMITED",
"INDAK INVESTCORP PRIVATE LIMITED",
"INDAKSH SOLUTIONS PRIVATE LIMITED",
"INDAMER AVIATION PRIVATE LIMITED",
"INDAMER MJETS AIRPORT SERVICES PRIVATE LIMITED",
"INDAMI INVESTMENTS PRIVATE LIMITED",
"INDANA ENGINEERING PRIVATE LIMITED",
"INDANA STEEL PRIVATE LIMITED",
"INDAPOINT TECHNOLOGIES PRIVATE LIMITED",
"INDAPP IT PRIVATE LIMITED",
"INDAPUR DAIRY AND MILK PRODUCTS LIMITED",
"INDARAYANI HOSPITAL AND CANCER INSTITUTE",
"INDARKA ENERGY PRIVATE LIMITED",
"INDARSEN SHAMLAL PRIVATE LIMITED",
"INDASI LIFESCIENCE PRIVATE LIMITED",
"INDATA VALUE SYSTEMS PRIVATE LIMITED",
"INDAUX INDIA PRIVATE LIMITED",
"INDAX ONLINE SERVICES PRIVATE LIMITED",
"INDBANK MERCHANT BANKING SERVICES LIMITED",
"INDBRO BIO-TECH PRIVATE LIMITED",
"INDBRO RESEARCH AND BREEEDING FARMS PRIVATE LIMITED",
"INDCAP ADVISORS PRIVATE LIMITED",
"INDCARB ACTIVATED CARBON PRIVATE LIMITED",
"INDCARE PHARMACEUTICALS PRIVATE LIMITED",
"INDCAS ENTERPRISES PRIVATE LIMITED",
"INDCHEMIE HEALTH SPECIALITIES PRIVATE LIMITED",
"INDCLAN MOBILITY PRIVATE LIMITED",
"INDCOAT SHOE COMPONENTS LIMITED",
"INDCOIL TRANSFORMERS PRIVATE LIMITED",
"INDCON BOILERS LIMITED",
"INDCON MANUFACTURING PRIVATE LIMITED",
"INDCON PROJECTS AND EQUIPMENT LIMITED",
"INDCON SALES LINK PVT LTD",
"INDCON STRUCTURALS PRIVATE LIMITED",
"INDCONNECT MARKETING PRIVATE LIMITED",
"INDDUSINC EXIM PRIVATE LIMITED",
"INDE DUTCH ENGINEERING & AEROSPACE SERVICES LIMITED",
"INDE EN VOGUE SOURCING PRIVATE LIMITED",
"INDE GLOBAL CONSULTING LLP",
"INDE HOSPITALITY PRIVATE LIMITED",
"INDE PAY NETWORKS PRIVATE LIMITED",
"INDE ROOH EXPORTS PRIVATE LIMITED",
"INDEA DESIGN SYSTEMS PRIVATE LIMITED",
"INDEAYOGA SPIRITUAL PRIVATE LIMITED",
"INDEBO INDIA PRIVATE LIMITED",
"INDEBO TRAVELS PRIVATE LIMITED",
"INDECA SPORTING GOODS PRIVATE LIMITED",
"INDECAB TECHNOLOGY SERVICES PRIVATE LIMITED",
"INDECO LEISURE HOTELS PRIVATE LIMITED",
"INDECOMM BUSINESS SERVICES (INDIA) PRIVATE LIMITED",
"INDECOR SLIDES (INDIA) PRIVATE LIMITED",
"INDEE SOFTWARE PRIVATE LIMITED",
"INDEED ADVISORY PRIVATE LIMITED",
"INDEED FINCAP PRIVATE LIMITED",
"INDEED INFRASTRUCTURE PRIVATE LIMITED",
"INDEEDCARE WELLNESS PRIVATE LIMITED",
"INDEEYA INFRASTRUCTURE PRIVATE LIMITED",
"INDEFT TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"INDEGENE LIMITED",
"INDEGENE PRIVATE LIMITED",
"INDEL AUTOMOTIVES KOCHI PRIVATE LIMITED",
"INDEL AUTOMOTIVES PRIVATE LIMITED",
"INDEL CORPORATION PRIVATE LIMITED",
"INDEL DISTRIBUTION COMPANY PRIVATE LIMITED",
"INDEL ENGINEERING PRIVATE LIMITED",
"INDEL INDUSTRIES PRIVATE LIMITED",
"INDEL MONEY LIMITED",
"INDEL MONEY PRIVATE LIMITED",
"INDELEC ELECTRICAL PRIVATE LIMITED",
"INDELEC S.A.",
"INDELECSA INDIA PRIVATE LIMITED",
"INDELIBLE ADVERTISING PRIVATE LIMITED",
"INDELOX GLOBAL DISTRIBUTION PRIVATE LIMITED",
"INDELOX SERVICES PRIVATE LIMITED",
"INDELSOL INDUSTRIAL ELECTRONICS SOLUTIONS I PRIVATE LIMITED",
"INDEMAND INFOTECH PRIVATE LIMITED",
"INDENA INDIA PRIVATE LIMITED",
"INDENIM FASHIONS PRIVATE LIMITED",
"INDENT ONLINE SUPPLIES PRIVATE LIMITED",
"INDENTA CHEMICALS (INDIA) PRIVATE LIMITED",
"INDEPENDENCE BREWING COMPANY PRIVATE LIMITED",
"INDEPENDENT BUSINESS MACHINES PRIVATE LIMITED",
"INDEPENDENT BUSINESS SOLUTIONS GULF DESIGN PRIVATE LIMITED",
"INDEPENDENT GLOBAL UTILITIES PRIVATE LIMITED",
"INDEPENDENT MINERAL RESOURCES PRIVATE LIMITED",
"INDEPENDENT NEWS SERVICE PRIVATE LIMITED",
"INDEPENDENT PURCHASING (IPC) PRIVATE LIMITED",
"INDEPESCA AQUACULTURE PRIVATE LIMITED",
"INDEPESCA OVERSEAS PRIVATE LIMITED",
"INDEPTH SOLUTIONS PRIVATE LIMITED",
"INDEQUIP LIMITED",
"INDER BHAN GIRLS INTER COLLEGE",
"INDER ENTERPRISES PRIVATE LIMITED",
"INDER FAB AND ENGINEERS PRIVATE LIMITED",
"INDER HARD COKE INDUSTRIES PRIVATE LIMITED",
"INDER HOTELS PRIVATE LIMITED",
"INDER JEWELLERY PRIVATE LIMITED",
"INDERA ENTERPRISES PRIVATE LIMITED",
"INDERA ETHNICS AND DESIGNS PRIVATE LIMITED",
"INDERA GARMENTS PRIVATE LIMITED",
"INDERA JEWELS PRIVATE LIMITED",
"INDERJEET BROS PROJECTS PRIVATE LIMITED",
"INDERJIT CARS PRIVATE LIMITED",
"INDERJIT JEWELLERS PRIVATE LIMITED",
"INDERJIT MEHTA CONSTRUCTION PRIVATE LIMITED",
"INDERLLAN AGROTECH PRIVATE LIMITED",
"INDERLOK HOTELS PRIVATE LIMITED",
"INDERMANI MINERALS INDIA PRIVATE. LIMITED.",
"INDERO METALS PRIVATE LIMITED",
"INDERPRASTHA ENGINEERING COLLEGE",
"INDERSONS MOTORS PRIVATE LTD",
"INDERVELLY FARMERS PRODUCER COMPANY LIMITED",
"INDES PROJECTS INDIA PRIVATE LIMITED",
"INDESES BUSINESS VENTURES PRIVATE LIMITED",
"INDESIGN CERAMICS LLP",
"INDESIGN OFFICE SOLUTIONS PRIVATE LIMITED",
"INDESSA GASES PRIVATE LIMITED",
"INDESYS EQUIPMENTS PRIVATE LIMITED",
"INDETICS NETWORK SOLUTIONS LLP",
"INDETRANS GLOBAL LOGISTICS PRIVATE LIMITED",
"INDEUS LIFE SCIENCES PRIVATE LIMITED",
"INDEUTSCH INDUSTRIES PRIVATE LIMITED",
"INDEUTSCH SYSTEMS PRIVATE LIMITED",
"INDEV CONSULTANCY PRIVATE LIMITED",
"INDEVELOP TECHNOLOGY PRIVATE LIMITED",
"INDEVIA ACCOUNTING PRIVATE LIMITED",
"INDEX ADVISORY PRIVATE LIMITED",
"INDEX AUTOMOTIVE SOLUTIONS PRIVATE LIMITED",
"INDEX BAGS PRIVATE LIMITED",
"INDEX CLOTHING COMPANY PRIVATE LIMITED",
"INDEX INFOTECH (INDIA) PRIVATE LIMITED",
"INDEX KNIT AND WEAVE PRIVATE LIMITED",
"INDEX LITHOGRAPHY INDIA PRIVATE LIMITED",
"INDEX LOGISTICS PRIVATE LIMITED",
"INDEX MEDIA PRIVATE LIMITED",
"INDEX MONEY LIMITED",
"INDEX PR PRIVATE LIMITED",
"INDEX SAFETY PRODUCTS PRIVATE LIMITED",
"INDEX SECURITIES & RESEARCH PRIVATE LIMITED",
"INDEX SYSTEM INDIA PRIVATE LIMITED",
"INDEXEL ENGINEERING PRIVATE LIMITED",
"INDEXER CORPORATE SERVICES PRIVATE LIMITED",
"INDEXING OPERATIONS PRIVATE LIMITED",
"INDEXNINE TECHNOLOGIES PRIVATE LIMITED",
"INDEXONE INDUSTRIES LIMITED",
"INDEXONE INFRACON AND LOGISTICS PRIVATE LIMITED",
"INDEXONE INTERNATIONAL PRIVATE LIMITED",
"IND-EXPO OLEOCHEMICALS PRIVATE LIMITED",
"INDEXPORT LEATHER EXPORT PRIVATE LIMITED",
"INDFRAG BIO SCIENCES PRIVATE LIMITED",
"INDGLOBAL DIGITAL PRIVATE LIMITED",
"INDGLOBE POWER BOOSTER PRIVATE LIMITED",
"INDHII CONSTRUCTIONS PRIVATE LIMITED",
"INDI DESIGN PRIVATE LIMITED",
"INDI INSIDE FASHION PRIVATE LIMITED",
"INDI PHARMA PRIVATE LIMITED",
"INDI TRESS PRIVATE LIMITED",
"INDIA AD BRIGADE",
"INDIA ADVANTAGE SECURITIES PRIVATE LIMITED",
"INDIA AGRO EXPORTS PRIVATE LIMITED",
"INDIA AHEAD NEWS PRIVATE LIMITED",
"INDIA ALTERNATIVES INVESTMENT ADVISORS PRIVATE LIMITED",
"INDIA ALUMINIUM & GLAZING PRIVATE LIMITED",
"INDIA ASYST PRIVATE LIMITED",
"INDIA ATLANTIC CHEMICALS TRADING PRIVATE LIMITED",
"INDIA BIO AND AGRO PACIFIC PRIVATE LIMITED",
"INDIA BIO-MEDICAL PRIVATE LIMITED",
"INDIA BISON",
"INDIA BITI PAYMENTS",
"INDIA BOOK DISTRIBUTORS BOMBAY LIMITED",
"INDIA BRAIDS PRIVATE LIMITED",
"INDIA BRIDLE WORKS PRIVATE LIMITED",
"INDIA BUILDERS CHENNAI LIMITED",
"INDIA CABS PRIVATE LIMITED",
"INDIA CAKES PRIVATE LIMITED",
"INDIA CAPITAL MARKETS PRIVATE LIMITED",
"INDIA CARBON LIMITED",
"INDIA CARRIERS PRIVATE LIMITED",
"INDIA CELLULAR & ELECTRONICS ASSOCIATION",
"INDIA CEMENTS INFRASTRUCTURES LIMITED",
"INDIA CEMENTS INVESTMENT SERVICES LIMITED",
"INDIA CHAPTER OF INTERNATIONAL ADVERTISING ASSOCIATION.",
"INDIA CIRCUITS PRIVATE LIMITED",
"INDIA CKP CONSULTANTS PRIVATE LIMITED",
"INDIA COKE AND POWER PRIVATE LIMITED",
"INDIA COMMERCIAL SERVICES",
"INDIA COMNET INTERNATIONAL PRIVATE LIMITED",
"INDIA CONNECTION IMPEX PRIVATE LIMITED",
"INDIA CONVENTION AND CULTURE CENTER PRIVATE LIMITED",
"INDIA CYBERLEARNING PRIVATE LIMITED",
"INDIA DAIRY FEEDS PRIVATE LIMITED",
"INDIA DAIRY PRODUCTS LIMITED",
"INDIA DATSEC SOLUTIONS PRIVATE LIMITED",
"INDIA DOCUMENT SOLUTIONS PRIVATE LIMITED",
"INDIA DRIVERS NETWORK SERVICES PRIVATE LIMITED",
"INDIA DYEING MILLS PRIVATE LIMITED",
"INDIA E HUB SERVICES PRIVATE LIMITED",
"INDIA ELECTRONICS & SEMICONDUCTOR ASSOCIATION",
"INDIA ENER-GEN PRIVATE LIMITED",
"INDIA EXOTICA TRAVELS PRIVATE LIMITED",
"INDIA EXPORT HOUSE PRIVATE LIMITED",
"INDIA EXPOSITION MART LIMITED",
"INDIA FACTORING AND FINANCE SOLUTIONS PRIVATE LIMITED",
"INDIA FASHIONS LIMITED",
"INDIA FASHIONS PRIVATE LIMITED",
"INDIA FAST FORWARD ADVISORY SERVICES PRIVATE LIMITED",
"INDIA FAST FORWARD SALES AND MARKETING PRIVATE LIMITED",
"INDIA FINANCE AND CONSTRUCTION COMPANY PRIVATE LIMITED",
"INDIA FIRE TECH PRIVATE LIMITED",
"INDIA FIRST LOGISTICS LIMITED",
"INDIA FITNESS PLAZA PRIVATE LIMITED",
"INDIA FLYSAFE AVIATION",
"INDIA FOR YOU HOLIDAYS PRIVATE LIMITED",
"INDIA FOREX ADVISORS PRIVATE LIMITED",
"INDIA FORGE & DROP STAMPINGS LIMITED",
"INDIA FORGINGS & ENGINEERING COMPANY PVT LTD",
"INDIA FORMS CENTRE PVT LTD",
"INDIA FOUNDATION FOR HUMANISTIC DEVELOPMENT",
"INDIA FROZEN FOODS",
"INDIA GARAGE",
"INDIA GAS SOLUTIONS PRIVATE LIMITED",
"INDIA GATEWAY TERMINAL PRIVATE LIMITED",
"INDIA GELATINE AND CHEMICALS LIMITED",
"INDIA GLAZES LTD.",
"INDIA GLYCOLS LIMITED",
"INDIA GOVERNMENT MINT",
"INDIA GRAPHIC SYSTEM PRIVATE LIMITED",
"INDIA GYPSUM LIMITED",
"INDIA HABITAT CENTER",
"INDIA HEALTH ACTION TRUST",
"INDIA HIV/AIDS ALLIANCE U/S 25",
"INDIA HOME HEALTH CARE PRIVATE LIMITED",
"INDIA HOME LOAN LIMITED",
"INDIA INDUSTRIAL ENTERPRISES PVT LTD",
"INDIA INFOLINE COMMODITIES LIMITED",
"INDIA INFOLINE FOUNDATION",
"INDIA INFOLINE INSURANCE SERVICES LIMITED",
"INDIA INFOLINE MEDIA AND RESEARCH SERVICES LIMITED",
"INDIA INFRADEBT LIMITED",
"INDIA INFRAHITECH PRIVATE LIMITED",
"INDIA INFRASTRUCTURE AND LOGISTICS PRIVATE LIMITED",
"INDIA INFRASTRUCTURE FINANCE COMPANY LIMITED",
"INDIA INFRASTRUCTURE PUBLISHING PRIVATE LIMITED",
"INDIA INGREDIENTS PRIVATE LIMITED",
"INDIA INNOVATION INCORPORATION PRIVATE LIMITED",
"INDIA INSTITUTE OF LEGAL STUDIES",
"INDIA INSULATION PRIVATE LIMITED",
"INDIA INSURE RISK MANAGEMENT AND INSURANCE BROKING SERVICES PRIVATE LIMITED",
"INDIA INTELLISYS TECHNOLOGY PRIVATE LIMITED",
"INDIA INTER NATIONAL EXPORTERS",
"INDIA INTERACTIVE TECHNOLOGIES LIMITED",
"INDIA INTERNATIONAL CENTRE",
"INDIA INTERNATIONAL CLEARING CORPORATIONIFSC LIMITED",
"INDIA INTERNATIONAL CONVENTION AND EXHIBITION CENTRE LIMITED",
"INDIA INTERNATIONAL EXCHANGE (IFSC) LIMITED",
"INDIA INTERNATIONAL GOLF AND TENNIS PRIVATE LIMITED",
"INDIA INTERNATIONAL HOUSE LIMITED",
"INDIA INTERNATIONAL INFRASTRUCTURE ENGINEERS LIMITED",
"INDIA INTERNATIONAL TRADE CENTRE",
"INDIA IRRIGATION LIMITED",
"INDIA JAPAN LIGHTING PRIVATE LIMITED",
"INDIA KAWASAKI MOTORS PRIVATE LIMITED",
"INDIA LAND AND PROPERTIES LIMITED",
"INDIA LAND AND SPACE INFRASTRUCTURE PRIVATE LIMITED",
"INDIA LAND HOTELS MUMBAI PRIVATE LIMITED",
"INDIA LAND INFRASTRUCTURE DEVELOPMENT PRIVATE LIMITED",
"INDIA LAND LOGIPARK PRIVATE LIMITED",
"INDIA LAND TECH PARK PRIVATE LIMITED",
"INDIA LIFE CONSULTANTS PRIVATE LIMITED",
"INDIA LUXCO RETAIL PRIVATE LIMITED",
"INDIA MACHINE MART PRIVATE LIMITED",
"INDIA MART INTERMESH LIMITED",
"INDIA MEDITECH PRIVATE LIMITED",
"INDIA MEDTRONIC PRIVATE LIMITED",
"INDIA METAL ONE STEEL PLATE PROCESSING PRIVATE LIMITED",
"INDIA METEOROLOGICAL DEPARTMEN",
"INDIA METEOROLOGICAL DEPTT",
"INDIA METPRO PRODUCTS PRIVATE LIMITED",
"INDIA METROLOGICAL DEPARTMENT",
"INDIA MORTGAGE GUARANTEE CORPORATION PRIVATE LIMITED",
"INDIA MOTOR KANPUR PRIVATE LIMITED",
"INDIA MOTOR PARTS & ACCESSORIES LIMITED",
"INDIA NAVIGATION COMPANY PRIVATE LIMITED",
"INDIA NEWS BROADCASTING PRIVATE LIMITED",
"INDIA NEWS RAJ PRIVATE LIMITED",
"INDIA NIPPON ELECTRICALS LIMITED",
"INDIA OCEAN MARITIME ENGINEERING COMPANY PRIVATE LIMITED",
"INDIA ONE BRAND SERVICES PRIVATE LIMITED",
"INDIA OPTEL LIMITED",
"INDIA PACKAGING PRODUCTS PRIVATE LIMITED",
"INDIA PESTICIDES LIMITED",
"INDIA PESTICIDES LIMITED.",
"INDIA PISTONS LIMITED",
"INDIA PORTS & LOGISTICS PRIVATE LIMITED",
"INDIA PORTS GLOBAL LIMITED",
"INDIA POST",
"INDIA POST PAYMENTS BANK LIMITED",
"INDIA POTTERIES LTD.",
"INDIA POWER CORPORATION LIMITED",
"INDIA PROPERTY ONLINE PRIVATE LIMITED",
"INDIA QUOTIENT ADVISERS LLP",
"INDIA RADIO VENTURES PRIVATE LIMITED",
"INDIA RATINGS AND RESEARCH PRIVATE LIMITED",
"INDIA REALTY PRIVATE LIMITED",
"INDIA RECYPA PRIVATE LIMITED",
"INDIA RECYPA PRIVATE LIMITED.",
"INDIA REISEBUERO PRIVATE LIMITED",
"INDIA RESOURCES TRUST",
"INDIA RESURGENCE ARC PRIVATE LIMITED",
"INDIA RESURGENCE ASSET MANAGEMENT BUSINESS PRIVATE LIMITED",
"INDIA RETAILS & HOSPITALITY PRIVATE LIMITED",
"INDIA SAFETY VAULTS PRIVATE LIMITED",
"INDIA SEAH PRECISION METAL PRIVATE LIMITED",
"INDIA SEED VENTURES PRIVATE LIMITED",
"INDIA SERVES PRIVATE LIMITED",
"INDIA SHELTER FINANCE CORPORATION LIMITED",
"INDIA SHOES EXPORTS PRIVATE LIMITED",
"INDIA SILICA MAGNESITE WORKS LTD.",
"INDIA SKILLS PRIVATE LIMITED",
"INDIA SOUTH HOTELS PRIVATE LIMITED",
"INDIA STEEL CONTINENTAL PRIVATE LIMITED",
"INDIA STEEL SUMMIT PRIVATE LIMITED",
"INDIA SWEET COMPANY PRIVATE LIMITED",
"INDIA TAX INFO PRIVATE LIMITED",
"INDIA TECHNOLOGY INVESTMENTS PRIVATE LIMITED",
"INDIA TERRY TOWELS PRIVATE LIMITED",
"INDIA TIN INDUSTRIES PRIVATE LIMITED",
"INDIA TODAY FASHIONS",
"INDIA TOOLING SOLUTION",
"INDIA TOOLS CRAFTS PRIVATE LIMITED",
"INDIA TOURISM DEVELOPMENT CORP LIMITED",
"INDIA TRADE LINK PRIVATE LIMITED",
"INDIA TRADE PROMOTION ORGANISATION",
"INDIA TRANSPORT & TRAVEL PVT LTD",
"INDIA TRIMMINGS PRIVATE LIMITED",
"INDIA TRUCK LOGISTICS INDIA PRIVATE LIMITED",
"INDIA TV INTERACTIVE MEDEA PRIVATE",
"INDIA UNIPER POWER SERVICES PRIVATE LIMITED",
"INDIA VALUE FUND ADVISORS PRIVATE LIMITED",
"INDIA VISION INSTITUTE",
"INDIA WIRE AND GENERAL MILLS PRIVATE LIMITED",
"INDIA WOODLINE LIMITED",
"INDIA X-ON ELECTRONICS PRIVATE LIMITED",
"INDIA YAMAHA MOTOR PRIVATE LIMITED",
"INDIA Y-NOT DESIGN AND MANUFACTURING PRIVATE LIMITED",
"INDIA1 PAYMENTS LIMITED",
"INDIABUILD DEVELOPERS PRIVATE LIMITED",
"INDIABUILD HOMES PRIVATE LIMITED",
"INDIABUILD INFRA PRIVATE LIMITED",
"INDIABUILD PREMISES PRIVATE LIMITED",
"INDIABUILD PROPERTY DEVELOPERS PRIVATE LIMITED",
"INDIABUILD REAL ESTATES PRIVATE LIMITED",
"INDIABUILD REALTY PRIVATE LIMITED",
"INDIABULLS ADVISORY SERVICES LIMITED",
"INDIABULLS ALTERNATE INVESTMENTS LIMITED",
"INDIABULLS ASSET MANAGEMENT COMPANY LIMITED",
"INDIABULLS ASSET RECONSTRUCTION COMPANY LIMITED",
"INDIABULLS COLLECTION AGENCY LIMITED",
"SAMMAAN FINSERVE LIMITED",
"INDIABULLS COMMERCIAL ESTATE LIMITED",
"INDIABULLS COMMERCIAL PROPERTIES LIMITED",
"INDIABULLS CONSTRUCTION MATERIALS LIMITED.",
"INDIABULLS CONSTRUCTIONS LIMITED",
"INDIABULLS DISTRIBUTION SERVICES LIMITED",
"INDIABULLS ENGINEERING LIMITED",
"INDIABULLS ESTATE LIMITED",
"SAMMAAN CAPITAL LIMITED",
"INDIABULLS INDUSTRIAL INFRASTRUCTURE LIMITED",
"INDIABULLS INFRAESTATE LIMITED",
"INDIABULLS INFRASTRUCTURE PRIVATE LIMITED",
"INDIABULLS INFRASTRUCTURE PROJECTS LIMITED",
"INDIABULLS INVESTMENT ADVISORS LIMITED",
"INDIABULLS INVESTMENT MANAGEMENT LIMITED",
"INDIABULLS LAND HOLDINGS LIMITED",
"INDIABULLS LIFE INSURANCE COMPANY LIMITED",
"INDIABULLS PHARMACEUTICALS LIMITED",
"INDIABULLS RURAL FINANCE PRIVATE LIMITED",
"INDIABULLS VENTURES LIMITED",
"INDIACAN EDUCATION PRIVATE LIMITED",
"INDIACAST MEDIA DISTRIBUTION PRIVATE LIMITED",
"INDIACHARTS SHARE TRADING PRIVATE LIMITED",
"INDIACOM LIMITED",
"INDIACRETE READY MIX PRIVATE LIMITED",
"INDIADOTCOM DIGITAL PRIVATE LIMITED",
"INDIAEMERGING INFRASTRUCTURE PRIVATE LIMITED",
"INDIAETAX COM PRIVATE LIMITED",
"INDIAFIN TECHNOLOGIES LIMITED",
"INDIAFIRST LIFE INSURANCE COMPANY LIMITED",
"INDIAGAMES LIMITED",
"INDIAGRO CONSORTIUM PRODUCER COMPANY LIMITED",
"INDIAHUB E-GOVERNANCE PRIVATE LIMITED",
"INDIAIDEAS COM LIMITED",
"INDIAL SHIPPING PRIVATE LIMITED",
"INDIAMART AUTO SERVICES PRIVATE LIMITED",
"INDIAMART INTERMESH LIMITED",
"INDIAMCO EXPORTS PRIVATE LIMITED",
"INDIAMCO INFRASTRUCTURE AND REAL ESTATE PRIVATE LIMITED",
"INDIAN ACADEMY EDUCATION TRUST",
"INDIAN ACADEMY OF COMPETETIVE EXAMS PRIVATE LIMITED",
"INDIAN ACRYLICS LIMITED",
"INDIAN ADDITIVES LIMITED",
"INDIAN AERO INFRASTRUCTURE PRIVATE LIMITED",
"INDIAN AEROSOLS PRIVATE LIMITED",
"INDIAN AEROSPACE AND ENGINEERING",
"INDIAN AGRIBUSINESS SYSTEMS LIMITED",
"INDIAN AGRIBUSINESS SYSTEMS PRIVATE LIMITED",
"INDIAN AGRICULTURAL RESEARCH INSTITUTE",
"INDIAN AGRICULTURE RESEARCH INSTITUTE",
"INDIAN AGRO-CHEM INDUSTRIES PRIVATE LIMITED",
"INDIAN AIR FORCE",
"INDIAN AIR GASES LIMITED",
"INDIAN ALE VENTURES PRIVATE LIMITED",
"INDIAN ALERT SECURITY SERVICES PRIVATE LIMITED",
"INDIAN APPLIANCES COMPANY PRIVATE LIMITED",
"INDIAN ARMED FORCES 51I DEP SUPPLY PLATOON",
"INDIAN ARMED FORCES CIVILIAN",
"INDIAN ARMOUR SYSTEMS PRIVATE LIMITED.",
"INDIAN ARMY",
"INDIAN ART PROJECTS PRIVATE LIMITED",
"INDIAN ASSOCIATES",
"INDIAN ASSOCIATION FOR SAVINGS AND CREDIT",
"INDIAN ASSOCIATION OF INVESTMENT PROFESSIONALS",
"INDIAN AUDIT ACCOUNTS DEPARTMENT",
"INDIAN AUDIT AND ACCOUNTS DEPARTMENT",
"INDIAN AUTOGAS COMPANY LIMITED",
"INDIAN AYURVEDIC HOSPITAL AND RESEARCH LIMITED",
"INDIAN BALL AND ROLLER PRIVATE LIMITED",
"INDIAN BANK",
"INDIAN BIOGAS ASSOCIATION",
"INDIAN BROADCASTING & DIGITAL FOUNDATION",
"INDIAN BUREAU OF MINES",
"INDIAN BURNS RESEARCH SOCIETY",
"INDIAN CANE POWER LIMITED",
"INDIAN CARGO EXPRESS PRIVATE LIMITED",
"INDIAN CASH AND CARRY PRIVATE LIMITED",
"INDIAN CENTRE FOR ACADEMIC RANKINGS & EXCELLENCE PRIVATE LIMITED",
"INDIAN CENTRE FOR RESEARCH AND DEVELOPENT OF COMMUNITY EDUCATION",
"INDIAN CHAIN PRIVATE LIMITED",
"INDIAN CHAMBER OF COMMERCE",
"INDIAN CHAMBER OF COMMERCE CALCUTTA",
"INDIAN CHEMICAL COUNCIL",
"INDIAN CHILLIES PRODUCTS COMPANY PRIVATE LIMITED",
"INDIAN CHILLIES TRADING COMPANY LIMITED",
"INDIAN CITY PROPERTIES LTD",
"INDIAN CLEARING CORPORATION LIMITED",
"INDIAN CLOTHING LEAGUE PRIVATE LIMITED",
"INDIAN COMMERCE & INDUSTRIES COMPANY PRIVATE LIMITED",
"INDIAN COMMODITY EXCHANGE LIMITED",
"INDIAN COMPRESSORS LIMITED",
"INDIAN CONCAST PRIVATE LIMITED",
"INDIAN CORE OILS PRIVATE LIMITED",
"INDIAN CORK MILLS PRIVATE LIMITED",
"INDIAN CORPORATE BUSINESS CENTRE LIMITED",
"INDIAN COUNCIL OF MEDICAL RESEARCH",
"INDIAN COUNCIL OF PHILOSOPHICAL RES",
"INDIAN COUNCIL OF WORLD AFFAIRS",
"INDIAN COUNCIL ON GLOBAL RELATIONS",
"INDIAN CROP CHEMICALS PRIVATE LIMITED",
"INDIAN CROP SCIENCE PRIVATE LIMITED",
"INDIAN DELCO PRIVATE LIMITED",
"INDIAN DENTAL ASSOCIATION",
"INDIAN DESIGNS EXPORTS PRIVATE LIMITED",
"INDIAN DIRECT EQUITY ADVISORS PRIVATE LIMITED",
"INDIAN DIRECT SELLING ASSOCIATION",
"INDIAN DRAPE PRIVATE LIMITED",
"INDIAN DRUG DISTRIBUTORS PRIVATE LIMITED",
"INDIAN DRUG HOUSE",
"INDIAN DRUG RESEARCH LABORATORY OF INDIA",
"INDIAN DYNAMITE CO PVT LTD",
"INDIAN EAGLE PRIVATE LIMITED",
"INDIAN EDUCATION SOCIETY",
"INDIAN ELECTRICAL AND ELECTRONICS MANUFACFTURERS ASSOCIATION",
"INDIAN EMULSIFIERS PRIVATE LIMITED",
"INDIAN ENERGY EXCHANGE LIMITED",
"INDIAN ENGINEERING CONSULTANTS INDIA PRIVATE LIMITED",
"INDIAN ENTREPRENEURS",
"INDIAN EXOTIC ICECREAM PRIVATE LIMITED",
"INDIAN EXPELLER WORKS PVT LTD",
"INDIAN EXPLOSIVES PRIVATE LIMITED",
"INDIAN EXPRESS COMMERCIAL VENTURES & PROJECTS LIMITED",
"INDIAN EXPRESS COMMERCIAL VENTURES & PROJECTS PRIVATE LIMITED",
"INDIAN EXPRESS NEWSPAPERS MUMBAI LIMITED",
"INDIAN EXTRUSIONS",
"INDIAN FARMERS FERTILISER COOPERATIVE LIMITED",
"INDIAN FEDERATION OF GREEN ENERGY",
"INDIAN FILES PRIVATE LIMITED",
"INDIAN FILM & T.V. PRODUCERS COUNCIL",
"INDIAN FINANCE GUARANTY LIMITED.",
"INDIAN FOODS PRIVATE LIMITED",
"INDIAN FOREST INDUSTRIES PVT LTD",
"INDIAN FOREST PRODUCTS PRIVATE LIMITED",
"INDIAN FORGING & STAMPING CO. PRIVATE LIMITED",
"INDIAN FREIGHTWAYS PRIVATE LIMITED",
"INDIAN FURNITURE PRODUCTS LIMITED",
"INDIAN GAS EXCHANGE LIMITED",
"INDIAN GEM & JEWELLERY CREATION PRIVATE LIMITED",
"INDIAN GENOMIX PRIVATE LIMITED",
"INDIAN GLASS & ELECTRICALS PRIVATE LIMITED",
"INDIAN GRASSLAND AND FODDER RESEARCH INSTITUTE JHANSI",
"INDIAN GREEN REVOLUTION PRIVATE LIMITED",
"INDIAN GREENHOUSES PRIVATE LIMITED",
"INDIAN GYMKHANA (MATUNGA) LIMITED",
"INDIAN HAIR INDUSTRIES PRIVATE LIMITED",
"INDIAN HEALTH ORGANISATION PRIVATE LIMITED",
"INDIAN HERBS SPECIALITIES PRIVATE LIMITED",
"INDIAN HERITAGE ARTS PRIVATE LIMITED",
"INDIAN HERPETOLOGICAL SOCIETY",
"INDIAN HIGHWAYS MANAGEMENT COMPANY LIMITED",
"INDIAN HOLIDAY PRIVATE LIMITED",
"INDIAN HOSPITALS CORPORATION LIMITED",
"INDIAN HOSPITEX PRIVATE LIMITED",
"INDIAN HUT PRIVATE LIMITED",
"INDIAN IMMUNOLOGICALS LIMITED",
"INDIAN INDUSTRIAL MACHINES PRIVATE LIMITED",
"INDIAN INDUSTRIAL SECURITY SERVICES PRIVATE LIMITED",
"INDIAN INFOSEC CONSORTIUM",
"INDIAN INFOTECH AND SOFTWARE LIMITED",
"INDIAN INFRASTRUCTURE AND PROJECT (INDIA) PRIVATE LIMITED",
"INDIAN INNST OF MNGT-CAL",
"INDIAN INOVATIX LIMITED",
"INDIAN INSTITIUTE OF TECHNOLOGY GANDHINAGAR",
"INDIAN INSTITUE OF SCIENCE EDUCATION AND RESEARCH",
"INDIAN INSTITUTE FOR HUMAN SETTLEMENTS",
"INDIAN INSTITUTE OF ADVANCED STUDY",
"INDIAN INSTITUTE OF ASTROPHYSICS",
"INDIAN INSTITUTE OF BANKING AND FIANANCE",
"INDIAN INSTITUTE OF ECOLOGY ENVIR",
"INDIAN INSTITUTE OF ENGINEERING SCIENCE AND TECHNOLOGY, SHIBPU",
"INDIAN INSTITUTE OF EXCELLENCE AND CONSULTANCY PRIVATE LIMITED",
"INDIAN INSTITUTE OF FINANCE",
"INDIAN INSTITUTE OF FOOD SCIENCE AND TECHNOLOGY",
"INDIAN INSTITUTE OF FOREIGN TRADE",
"INDIAN INSTITUTE OF FOREST MANAGEMENT",
"INDIAN INSTITUTE OF GEMS & JEWELLERY DELHI",
"INDIAN INSTITUTE OF GEMS AND JEWELLERY",
"INDIAN INSTITUTE OF GEOMAGNETISM",
"INDIAN INSTITUTE OF HARDWARE TECHNOLOGY LIMITED",
"INDIAN INSTITUTE OF HORTICULTURAL RESEARCH",
"INDIAN INSTITUTE OF INDUSTRY INTERACTION EDUCATION AND RESEARCH",
"INDIAN INSTITUTE OF INFORMATION TECHNOLO",
"INDIAN INSTITUTE OF INSOLVENCY PROFESSIONALS OF ICAI",
"INDIAN INSTITUTE OF INTEGRATIVE MEDICINE-TECHNOLOGY BUSINESS INCUBATOR (III",
"INDIAN INSTITUTE OF LEARNING AND DEVELOPMENT PRIVATE LIMITED",
"INDIAN INSTITUTE OF LIVER & DIGESTIVE SCIENCES",
"INDIAN INSTITUTE OF MANAGEMENT &COMMERCE",
"INDIAN INSTITUTE OF MANAGEMENT AHMEDABAD",
"INDIAN INSTITUTE OF MANAGEMENT BANGALORE",
"INDIAN INSTITUTE OF MANAGEMENT CALCUTTA",
"INDIAN INSTITUTE OF PETROLEUM AND ENERGY",
"INDIAN INSTITUTE OF PSYCHOLOGY AND RESEARCH",
"INDIAN INSTITUTE OF PUBLIC ADMINISTRATION",
"INDIAN INSTITUTE OF PUBLIC HEALTH",
"INDIAN INSTITUTE OF PULSES RESEACH",
"INDIAN INSTITUTE OF RICE RESEARCH",
"INDIAN INSTITUTE OF SCIANCE EDUCATION AND RESERCH PUNE",
"INDIAN INSTITUTE OF SCIENCE BANGALORE",
"INDIAN INSTITUTE OF SKILL DEVELOPMENT PRIVATE LIMITED",
"INDIAN INSTITUTE OF SOCIAL WELFARE AND BUSINESS MANAGEMENT",
"INDIAN INSTITUTE OF SOIL AND SCIENCE",
"INDIAN INSTITUTE OF TECCHNOLOGY INDORE",
"INDIAN INSTITUTE OF TECHNOLOGY ¬†ROORKEE",
"INDIAN INSTITUTE OF TECHNOLOGY BOMBAY",
"INDIAN INSTITUTE OF TECHNOLOGY GOA",
"INDIAN INSTITUTE OF TECHNOLOGY GUWAHATI",
"INDIAN INSTITUTE OF TECHNOLOGY JODHPUR",
"INDIAN INSTITUTE OF TECHNOLOGY KANPUR",
"INDIAN INSTITUTE OF TECHNOLOGY MADRAS",
"INDIAN INSTITUTE OF TECHNOLOGY ROORKEE",
"INDIAN INSTITUTE OF TECHNOLOGY TIRUPATI",
"INDIAN INSTITUTE OF TOURISM & TRAVEL MANAGEMENT",
"INDIAN INSTITUTE OF TROPICAL METROLOGY",
"INDIAN INSTITUTION OF ENGINEERS",
"INDIAN ION EXCHANGE & CHEMICALS LIMITED",
"INDIAN IRON & METALS PRIVATE LIMITED",
"INDIAN IRON AND STEEL SECTOR SKILL COUNCIL",
"INDIAN ISPAT WORKS PRIVATE LIMITED",
"INDIAN JEWELCAST PRIVATE LIMITED",
"INDIAN JUTE MILLS ASSOCIATION",
"INDIAN LEADERSHIP ACADEMY (OPC) PRIVATE LIMITED",
"INDIAN LEASING & TRADING PRIVATE LIMITED",
"INDIAN LEGENDS HOLIDAYS PRIVATE LIMITED",
"INDIAN MACHINE TOOL MANUFACTURERS ASSOCIATION",
"INDIAN MAGIC EYE PRIVATE LIMITED",
"INDIAN MARINE INDUSTRIES",
"INDIAN MARITIME UNIVERSITY",
"INDIAN MARITIME UNIVERSITY HEAD QUARTERS",
"INDIAN MARKET RESEARCH BUREAU PRIVATE LIMITED",
"INDIAN MATRIC HR SEC SCHOOL",
"INDIAN MEDIA ENTERTAINMENT AND NETWORK PRIVATE LIMITED",
"INDIAN MEDICAL ASSOCIATION",
"INDIAN MEDICINES PHARMACEUTICAL CORPORATION LIMITED",
"INDIAN MESH PRIVATE LIMITED",
"INDIAN METALLOY RECYCLERS PRIVATE LIMITED",
"INDIAN METALS & FERRO ALLOYS LIMITED",
"INDIAN METEOROLOGICAL DEPARTMENT",
"INDIAN MILITRY ACADEMY",
"INDIAN MINERALS AND GRANITE COMPANY",
"INDIAN MINES COMPANY PRIVATE LIMITED",
"INDIAN MOTION PICTURES PRODUCERS ASSOCIATION",
"INDIAN MRI DIAGNOSTIC & RESEARCH LIMITED",
"INDIAN NATIONAL CENTRE FOR OCEAN INFORMATION SERVICES",
"INDIAN NATIONAL PRESS (BOMBAY) PRIVATE LIMITED",
"INDIAN NATIONAL SHIPOWNERS ASSOCIATION",
"INDIAN NAVY",
"INDIAN NUTRITION PRIVATE LIMITED",
"INDIAN OFFICE AUTOMATION & TECHNOLOGIES PRIVATE LIMITED",
"INDIAN OIL CORPORATION LIMITED",
"INDIAN OILSEEDS AND PRODUCE EXPORT PROMOTION COUNCIL",
"INDIAN OPTICS PRIVATE LIMITED",
"INDIAN ORDNANCE FACTORIES",
"INDIAN ORGANIC FARMERS PRODUCER COMPANY LIMITED (UNDER PART IXA)",
"INDIAN OVERSEAS BANK",
"INDIAN OVERSEAS CORPORATION PRIVATE LIMITED",
"INDIAN OXIDES & CHEMICALS LIMITED",
"INDIAN PAC CONSULTING PRIVATE LIMITED",
"INDIAN PAPER MANUFACTURING ASSOCIATION",
"INDIAN PEDIATRIC NETWORK PRIVATE LIMITED",
"INDIAN PERFUMES PRIVATE LIMITED",
"INDIAN PEROXIDE LIMITED",
"INDIAN PHOSPHATE LIMITED",
"INDIAN PIPES PRIVATE LIMITED",
"INDIAN PLASTIC FOOTWEAR AND CLOTHING PRIVATE LIMITED",
"INDIAN PLATINUM PRIVATE LIMITED",
"INDIAN PNEUMATIC AND HYDRAULIC COMPANY PRIVATE LIMITED",
"INDIAN POLLUTION CONTROL ASSOCIATION",
"INDIAN PORT RAIL & ROPEWAY CORPORATION LIMITED",
"INDIAN PORTS ASSOCIATION",
"INDIAN POST",
"INDIAN POTASH LIMITED",
"INDIAN POULTRY EQUIPMENT MANUFACTURERS' ASSOCIATION",
"INDIAN PROCESSING AND GARMENT SERVICES PRIVATE LIMITED",
"INDIAN PRODUCTS PRIVATE LIMITED",
"INDIAN PROGRESSIVE PUBLISHING CO PVT LTD",
"INDIAN PUBLIC SCHOOL PRIVATE LIMITED",
"INDIAN PUBLIC SCHOOLS SOCIETY",
"INDIAN RAILWAY",
"INDIAN RAILWAY CATERING AND TOURISM",
"INDIAN RAILWAY CATERING AND TOURISM CORPORATION LIMITED",
"INDIAN RAILWAY FINANCE CORPORATION",
"INDIAN RAILWAY FINANCE CORPORATION LIMITED",
"INDIAN RAILWAY STATIONS DEVELOPMENT CORPORATION LIMITED",
"INDIAN RARE EARTHS LIMITED",
"INDIAN RED CROSS SOCIETY",
"INDIAN RENEWABLE ENERGY DEVELOPMENT AGENCY LIMITED.",
"INDIAN RESOURCES INFORMATION AND MANAGEMENT TECHNOLOGIES LIMITED",
"INDIAN RESOURCES INFORMATION AND MANAGEMENT TECHNOLOGIES PRIVATE LIMITED",
"INDIAN RETAIL SERVICES PRIVATE LIMITED",
"INDIAN ROAD SURVEY AND MANAGEMENT PRIVATE LIMITED",
"INDIAN ROADS CONGRESS",
"INDIAN ROADWAYS CORPN LIMITED",
"INDIAN ROTORCRAFT LIMITED",
"INDIAN RUBBER MANUFACTURERSE RESEARCH ASSOCIATION",
"INDIAN SCHOOL FINANCE COMPANY PRIVATE LIMITED",
"INDIAN SCHOOL OF BUSINESS",
"INDIAN SCHOOL OF BUSINESS MANAGEMENT AND ADMINISTRATION PRIVATE LIMITED",
"INDIAN SCHOOL OF HOSPITALITY",
"INDIAN SCHOOL OF MANAGEMENT AND ENTREPRENEURSHIP PRIVATE LIMITED",
"INDIAN SCHOOL OF MICROFINANCE FOR WOMEN",
"INDIAN SECURITIES PRIVATE LIMITED",
"INDIAN SECURITY ALLIED SERVICES",
"INDIAN SECURITY FORCE",
"INDIAN SECURITY SERVICE & FACILITY MANAGEMENT",
"INDIAN SENIOR SECONDARY SCHOOL",
"INDIAN SINGERS' AND MUSICIANS' RIGHTS ASSOCIATION",
"INDIAN SOCIAL EDUCATION SOCIETY",
"INDIAN SOCIAL EDUCATION SOCIETY PUNE",
"INDIAN SOCIETY OF CRITICAL CARE MEDICINE",
"INDIAN SOFTWARE PRODUCT INDUSTRY ROUND TABLE FOUNDATION",
"INDIAN SPACE RESEARCH ORGANIZATION",
"INDIAN SPECIAL CASTINGS PRIVATE LIMITED",
"INDIAN SPINAL INJURIES CENTRE",
"INDIAN STAINLESS STEEL DEVELOPMENT ASSOCIATION",
"INDIAN STATISTICAL INSTITUTE",
"INDIAN STAVES MANUFACTURING COMPANY PRIVATE LIMITED",
"INDIAN STEEL AND INFRASTRUCTURE PRIVATE LIMITED",
"INDIAN STEEL CORPORATION LIMITED",
"INDIAN STITCHERS",
"INDIAN STITCHES PRIVATE LIMITED",
"INDIAN STORES SUPPLYING COMPANY P LIMITED",
"INDIAN STRATEGIC PETROLEUM RESERVES LIMITED",
"INDIAN STRUCTURALS AND CONVEYORS PRIVATE LIMITED",
"INDIAN SUCROSE LIMITED",
"INDIAN SUGAR EXIM CORPORATION LIMITED.",
"INDIAN SURGICAL EQUIPMENT COMPANY PRIVATE LTD",
"INDIAN SYNTANS INVESTMENTS PRIVATE LIMITED",
"INDIAN SYNTHETIC RUBBER PRIVATE LIMITED",
"INDIAN TANKERS PRIVATE LIMITED",
"INDIAN TANNING INDUSTRIES PRIVATE LIMITED",
"INDIAN TECHNOCRAT LIMITED",
"INDIAN TECHNOFARM AGRIBUSINESS PRIVATE LIMITED",
"INDIAN TELEVISION DOT COM PRIVATE LIMITED",
"INDIAN TERRAIN FASHIONS LIMITED",
"INDIAN TEXT TO SPEECH PRIVATE LIMITED",
"INDIAN TIMBER PRODUCTS PRIVATE LIMITED",
"INDIAN TONNER & DEVELOPERS ITDL",
"INDIAN TOOL LIMITED",
"INDIAN TOURISM INFRASTRUCTURE LIMITED",
"INDIAN TRACTORS AND COMPONENTS LIMITED",
"INDIAN TRADE LINKS",
"INDIAN TRAILS SOURCING SERVICES PRIVATE LIMITED",
"INDIAN TRAINING INSTITUTE CHANDIG",
"INDIAN TRANSFORMERS AND ELECTRICALS PRIVATE LIMITED",
"INDIAN TRAVEL HOUSE PRIVATE LIMITED",
"INDIAN VACCINES CORPORATION LIMITED",
"INDIAN VALVE (CALCUTTA) PVT LTD",
"INDIAN VALVE PRIVATE LIMITED",
"INDIAN VANLINES PRIVATE LIMITED",
"INDIAN VENEER CO PVT LTD",
"INDIAN VETERINARY RESEARCH INSTITUTE",
"INDIAN WOMEN FASHIONS PRIVATE LIMITED",
"INDIAN WRITING INSTRUMENTS PRIVATE LIMITED",
"INDIAN YARN LIMITED",
"INDIANA ACIDS AND CHEMICALS PRIVATE LIMITED",
"INDIANA BUILD INFRASTRUCTURE PRIVATE LIMITED",
"INDIANA CONVEYORS PRIVATE LIMITED",
"INDIANA DRIVES & ENGINEERING PRIVATE LIMITED",
"INDIANA ENGINEERING WORKS BOMBAY PRIVATE LIMITED",
"INDIANA GARTINGS PRIVATE LIMITED",
"INDIANA GRATINGS PRIVATE LIMITED",
"INDIANA HOSPITAL AND HEART INSTITUTE LIMITED",
"INDIANA INTERNATIONAL CORPORATION FLOORING PRIVATE LIMITED",
"INDIANA POLYMERS PRIVATE LIMITED",
"INDIANA SUCRO-TECH PUNE PRIVATE LIMITED",
"INDIANAPOLI HOSPITALITY PRIVATE LIMITED",
"INDIANEERS MEDIA PRIVATE LIMITED",
"INDIANIA JEWELLERY COMPANY PRIVATE LIMITED",
"INDIANIC INFOTECH LIMITED",
"INDIANIVESH CAPITALS LIMITED",
"INDIANIVESH COMMODITIES PRIVATE LIMITED",
"INDIANIVESH LIMITED",
"INDIANIVESH SECURITIES LIMITED",
"INDIANNICA LEARNING PRIVATE LIMITED",
"INDIANO CHROME PRIVATE LIMITED",
"INDIANOIL - ADANI GAS PRIVATE LIMITED",
"INDIANOIL ADANI GAS PRIVATE LIMITED",
"INDIANOIL ADANI VENTURES LIMITED",
"INDIANOIL LNG PRIVATE LIMITED",
"INDIANOIL PETRONAS PRIVATE LIMITED",
"INDIANOIL SKYTANKING DELHI PRIVATE LIMIT ED",
"INDIANOIL SKYTANKING PRIVATE LIMITED",
"INDIANOIL TOTAL PRIVATE LIMITED",
"INDIAONEONLINE SYNERGIES LIMITED",
"INDIASIGN PRIVATE LIMITED",
"INDIASOFT TECHNOLOGIES PRIVATE LIMITED",
"INDIASPAN TRADE NETWORK PRIVATE LIMITED",
"INDIASYNDICATE COM PRIVATE LIMITED",
"INDIATECHSTORE",
"INDIATTITUDE MARKETING PRIVATE LIMITED",
"INDIAVIDUAL LEARNING PRIVATE LIMITED",
"INDIAVISION REALTY AND INFRASTRUCTURE PRIVATE LIMITED",
"INDIAWIN SPORTS PRIVATE LIMITED",
"INDIBNI PRIVATE LIMITED",
"INDIC EMS ELECTRONICS PRIVATE LIMITED",
"INDIC INSPIRATIONS INDIA PRIVATE LIMITED",
"INDIC MEDIA PRIVATE LIMITED",
"INDIC WISDOM PRIVATE LIMITED",
"INDICA CONVEYORS LIMITED",
"INDICA INDUSTRIES PRIVATE LIMITED",
"INDICA PUBLISHERS AND DISTRIBUTORS PRIVATE LIMITED",
"INDICA RESEARCH PRIVATE LIMITED",
"INDICA TRAVELS & TOURS PRIVATE LIMITED",
"INDICA TRAVELS AND TOURS PRIVATE LIMITED",
"INDICAL MEDSURG PRIVATE LIMITED",
"INDICARE HEALTH SOLUTIONS PRIVATE LIMITED",
"INDICATE EXIM PRIVATE LIMITED",
"INDICATION INSTRUMENTS LIMITED",
"INDICHEM SPECIALTY FERTILIZERS PRIVATE LIMITED",
"INDICO MOTORS PRIVATE LIMITED",
"INDICOLD PRIVATE LIMITED",
"INDICOMPS SOLUTIONS PRIVATE LIMITED",
"INDICON CONSTRUCTION PRIVATE LIMITED",
"INDICON ESTATES PVT LTD",
"INDICOOL INNOVATIONS PRIVATE LIMITED",
"INDICORE INFOCOMM PRIVATE LIMITED",
"INDICOSMIC CAPITAL LIMITED",
"INDICOSMIC CAPITAL PRIVATE LIMITED",
"INDICRAFT COMMUNICATIONS INDIA PRIVATE LIMITED",
"INDICSOFT TECHNOLOGIES PRIVATE LIMITED",
"INDICUS FOUNDATION",
"INDICUS SOFTWARE PRIVATE LIMITED",
"INDID CONSULTING PRIVATE LIMITED",
"INDIE DELIGHTS PRIVATE LIMITED",
"INDIEFOLIO NETWORK PRIVATE LIMITED",
"INDIEJEWEL FASHIONS PRIVATE LIMITED",
"INDIES GLOBAL FOODS PRIVATE LIMITED",
"INDIFABS OVERSEAS PRIVATE LIMITED",
"INDIFLAVOUR FOOD & BEVERAGE PRIVATE LIMITED",
"INDIFOSS ANALYTICAL PRIVATE LIMITED",
"INDIFRA LIMITED",
"INDIGATECH BUILDING SOLUTIONS INDIA PRIVATE LIMITED",
"INDIGENESIS CONSULTING PRIVATE LIMITED",
"INDIGENIUS HR AND STAFFING SERVICES PRIVATE LIMITED",
"INDIGENOUS CONTROL ELECTRICALS PRIVATE LIMITED",
"INDIGENOUS DIGITAL MEDIA PRIVATE LIMITED",
"INDIGENOUS VANIJYA PRIVATE LIMITED",
"INDIGEO CONSULTANTS PRIVATE LIMITED",
"INDIGINUS LEARNING PRIVATE LIMITED",
"INDIGO",
"INDIGO CATERING & SERVICES PRIVATE LIMITED",
"INDIGO COLLECTIONS PRIVATE LIMITED",
"INDIGO CONSULTANCY SERVICES PRIVATE LIMITED",
"INDIGO CONSULTING",
"INDIGO DENIM PRIVATE LIMITED",
"INDIGO FACILITY SERVICES PRIVATE LIMITED",
"INDIGO HEALTH CARE PRIVATE LIMITED",
"INDIGO HOSPITALITY PRIVATE LIMITED",
"INDIGO IMPEX PRIVATE LIMITED",
"INDIGO INFORMATION SYSTEMS PRIVATE LIMITED",
"INDIGO INFRAPROJECTS PRIVATE LIMITED",
"INDIGO JEWELLERY INDIA MFG. PRIVATE LIMITED",
"INDIGO MINING PRIVATE LIMITED",
"INDIGO MULTIFAB PRIVATE LIMITED",
"INDIGO MUSIC PRIVATE LIMITED",
"INDIGO PAINTS LIMITED",
"INDIGO PLAST INDIA PRIVATE LIMITED",
"INDIGO PRE ENGINEERED BUILDINGS PRIVATE LIMITED",
"INDIGO PRESS (INDIA) PRIVATE LIMITED",
"INDIGO PRINTS PRIVATE LIMITED",
"INDIGO PRINTS SMART PRIVATE LIMITED",
"INDIGO SEA WAYS PRIVATE LIMITED",
"INDIGO SEEDS PRIVATE LIMITED",
"INDIGO SYSTEMS AND TECHNOLOGY CONSULTING INDIA PRIVATE LIMITED",
"INDIGO TX SOFTWARE PRIVATE LIMITED",
"INDIGO WOMENS CENTER",
"INDIGOEDGE MANAGEMENT CONSULTANCY PRIVATE LIMITED",
"INDIGOLD AGRO INDUSTRIES PRIVATE LIMITED",
"INDIGOLEARN EDU TECH PRIVATE LIMITED",
"INDIGOTOWN DEVELOPERS PRIVATE LIMITED",
"INDIGRA EXPORTS PRIVATE LIMITED",
"INDIGRA INDUSTRIES PRIVATE LIMITED",
"INDIGREEN BIOFUEL PRIVATE LIMITED",
"INDIGRID 1 LIMITED",
"INDIGRID INVESTMENT MANAGERS LIMITED",
"INDIGRID LIMITED",
"INDIGRID SOLAR-I (AP) PRIVATE LIMITED",
"INDIGRID SOLAR-II (AP) PRIVATE LIMITED",
"INDIGRID TECHNOLOGY PRIVATE LIMITED",
"INDIGRO EXPORTS PRIVATE LIMITED",
"INDIHIRE HR CONSULTANTS PRIVATE LIMITED",
"INDIHOOD PRIVATE LIMITED",
"INDIKA FABRICS PRIVATE LIMITED",
"INDIKASA EXIM PRIVATE LIMITED",
"INDIMAX PRINT PRIVATE LIMITED",
"INDIMEDI SOLUTIONS PRIVATE LIMITED",
"INDIMET PRIVATE LIMITED",
"INDIMICA IMPEX PRIVATE LIMITED",
"INDINESE GLOBAL PRIVATE LIMITED",
"INDIO NETWORKS PRIVATE LIMITED",
"INDIOZ CONSULTANTS PRIVATE LIMITED",
"INDIP INDUSTRIAL PARKS (VIZAG) PRIVATE LIMITED",
"INDIPAISA PAYMENT SERVICES PRIVATE LIMITED",
"INDIPORT FOOTWEAR PRIVATE LIMITED",
"INDIPRO GREENDRIVE PRIVATE LIMITED",
"INDIRA BANQUETS PRIVATE LIMITED",
"INDIRA CONSTRUCTIONS PRIVATE LIMITED",
"INDIRA DAMPER INDUSTRIES",
"INDIRA EDUCATIONAL & CHARITABLE TRUST",
"INDIRA EXIM PRIVATE LIMITED",
"INDIRA FOOD PRIVATE LIMITED",
"INDIRA GANDHI ARTS-COMMERCE COLLEGE",
"INDIRA GANDHI BAL AVAM MAHILA CHIKITSALAYA GAS RAH",
"INDIRA GANDHI CO OPERATIVE HOSPITAL",
"INDIRA GANDHI COLLEGE/SCHOOL OF NURSING",
"INDIRA GANDHI ENGLISH HIGHSCHOOL BEED",
"INDIRA GANDHI GOVERNMENT MEDICAL COLLEGE",
"INDIRA GANDHI GOVT MEDICAL COLLEGE HOSPI",
"INDIRA GANDHI HOSPITAL",
"INDIRA GANDHI INSTI OF MEDICAL SCIE",
"INDIRA GANDHI INSTITUTE OF COOPERATIVE MANAGEMENT",
"INDIRA GANDHI JUNIOR AND HIGH COLLEGE",
"INDIRA GANDHI KRISHI VISHWAVIDYALAYA",
"INDIRA GANDHI NATIONAL OPEN UNIVERSITY",
"INDIRA GANDHI PRATHAMIK ASHRAM SHALA",
"INDIRA GANDHI VIDYA MANDIR",
"INDIRA GANDHI WOMENS COLLEGE",
"INDIRA GAS AND PETROLEUM PRIVATE LIMITED",
"INDIRA HEALTH AND LIFESTYLE PRIVATE LIMITED",
"INDIRA IN FIN LEASE LIMITED",
"INDIRA INDUSTRIES",
"INDIRA INFRATECH PRIVATE LIMITED",
"INDIRA INSTITUTE",
"INDIRA INSTITUTE OF PHARMACY",
"INDIRA IVF HOSPITAL PRIVATE LIMITED",
"INDIRA KALA SANGIT VISHWAVIDYALAYA KHAIRAGARH",
"INDIRA KRISHNA VIDYASHALA",
"INDIRA NATIONAL SCHOOL",
"INDIRA NATURALS PRIVATE LIMITED",
"INDIRA PAPER MILL PRIVATE LIMITED",
"INDIRA PRIMARY SCHOOL RENUKA NAGAR LATUR",
"INDIRA PRIYADARSHINI GOVT DEGREE COLLEGE FOR WOMEN",
"INDIRA RUBBER AND PLASTICS PRIVATE LIMITED",
"INDIRA SECURITIES PRIVATE LIMITED TRF.",
"INDIRA TELEVISION LIMITED",
"INDIRA TELUGU SCHOOL",
"INDIRABAI COLLEGE OF LIBRARY SCIENCE I",
"INDIRAKALA SANGIT VISHWA VIDYALAYA KHAIRAGARH",
"INDIRAPURAM PUBLIC SHCOOL INDRAPURAM GHAZIABAD",
"INDIS APPA TWO PROJECTS PRIVATE LIMITED",
"INDIS CENTRALPARK PROPERTIES PRIVATE LIMITED",
"INDISCH MOTORS PRIVATE LIMITED",
"INDISKA INDIA EXPORT SERVICES PRIVATE LIMITED",
"INDISMART GLOBAL LIMITED",
"INDISOL MARKETING PRIVATE LIMITED",
"INDISOLAR PRODUCTS PRIVATE LIMITED",
"INDISONS CORPORATION PRIVATE LIMITED",
"INDISPHERE CONSULTING LLP",
"INDISTOCK SECURITIES LIMITED",
"INDISUAN PHARMACEUTICALS PRIVATE LIMITED",
"INDITA BENTEL REALTY CONSULTANTS PRIVATE LIMITED",
"INDITAB ESOLUTIONS PRIVATE LIMITED",
"INDITECH ELECTROSYSTEMS PRIVATE LIMITED",
"INDITECH TECHNOLOGY SERVICES PRIVATE LIMITED",
"INDI-TECH VALVES PRIVATE LIMITED",
"INDITEX TRENT RETAIL INDIA PRIVATE LIMITED",
"INDITRADE BUSINESS CONSULTANTS LIMITED",
"INDITRADE CAPITAL LIMITED",
"INDITRADE DERIVATIVES AND COMMODITIES LIMITED",
"INDITRADE FINCORP LIMITED",
"INDITRADE INSURANCE BROKING PRIVATE LIMITED",
"INDITRADE MICROFINANCE LIMITED",
"INDITRADE SCALERATOR LIMITED",
"INDITRADE TECHNOLOGIES LIMITED",
"INDITRAVEL PRIVATE. LIMITED",
"INDITRON ENTERPRISES PRIVATE LIMITED",
"INDITRONICS PRIVATE LIMITED",
"INDIUM CAPITAL ADVISORS PRIVATE LIMITED",
"INDIUM DEVELOPMENTS PRIVATE LIMITED",
"INDIUM SOFTWARE (INDIA) PRIVATE LIMITED",
"INDIUM SOFTWARE INDIA PRIVATE LIMITED",
"INDIUM SOLDER PRIVATE LIMITED",
"INDIUM TECH SPIRE PRIVATE LIMITED",
"INDIVAR PROPERTIES PVT LTD",
"INDIVAR SOFTWARE SOLUTIONS PRIVATE LIMITED",
"INDIVATION EXPORTS PRIVATE LIMITED",
"INDIVILLE MERCHANDIZE PRIVATE LIMITED",
"INDIVINITY CLOTHING RETAIL PRIVATE LIMITED",
"INDIVIRTUS SOLUTIONS PRIVATE LIMITED",
"INDIWORK SOFTWARE SOLUTIONS PRIVATE LIMITED",
"INDIXITAL MEDIA PRIVATE LIMITED",
"INDIYUM FOODS PRIVATE LIMITED",
"INDJETS INDIA PRIVATE LIMITED",
"INDKAL TECHNOLOGIES PRIVATE LIMITED",
"INDLAND GRAINS & COMMODITIES PRIVATE LIMITED",
"INDLER CORPORATION PRIVATE LIMITED",
"INDMA STEEL PRIVATE LIMITED",
"INDMAC TRAVELS PRIVATE LIMITED",
"INDMACSOL PRIVATE LIMITED",
"INDMAN MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"INDMAN MEDIA SERVICES PRIVATE LIMITED",
"INDMARK FORMTECH PRIVATE LIMITED",
"INDMARK MARKETING LIMITED",
"INDMARK PAPERFORM PRIVATE LIMITED",
"INDMAX IT SERVICES PRIVATE LIMITED",
"INDMECH ENGINEERING SERVICES PRIVATE LIMITED",
"INDNA LIFESCIENCES PRIVATE LIMITED",
"INDO - GERMAN BRAKES PRIVATE LIMITED",
"INDO AEROSPACE SOLUTIONS PRIVATE LIMITED",
"INDO AFRICA GLOBAL LOGISTICS PRIVATE LIMITED",
"INDO AFRICAN STEEL VENTURES PRIVATE LIMITED",
"INDO AFRIQUE PAPER MILLS PRIVATE LIMITED",
"INDO ALLUMINIUM PRIVATE LIMITED",
"INDO AMERICAN CANCER INSTITUTE",
"INDO AMERICAN HYBRID SEEDS INDIA PRIVATE LIMITED",
"INDO AMERICAN JEWELLERY LIMITED",
"INDO AMERICAN SYNERGY LIMITED",
"INDO AMINES LIMITED",
"INDO ARABIAN SHIPPING LINES (INDIA) PRIVATE LIMITED",
"INDO ARYA CENTRAL TRANSPORT LIMITED",
"INDO ARYA LOGISTICS LIMITED",
"INDO ASIA HOTELS PRIVATE LIMITED",
"INDO ASIA LEISURE SERVICES PRIVATE LIMITED",
"INDO ASIA MACHINES PRIVATE LIMITED",
"INDO ASIAN BUILDCON PRIVATE LIMITED",
"INDO ASIAN FUSEGEAR LIMITED",
"INDO ASIATIC ENGINEERS PRIVATE LIMITED",
"INDO ASSAM TEA COMPANY PRIVATE LTD",
"INDO ASSIST CAPITAL ADVISOR PRIVATE LIMITED",
"INDO AUTOELECTRIC PRIVATE LIMITED",
"INDO AUTOMOTIVE BATTERIES PRIVATE LIMITED",
"INDO AUTOTECH LTD",
"INDO AVIA SERVICES LIMITED",
"INDO BAIJIN CHEMICALS PRIVATE LIMITED",
"INDO BAKELS PRIVATE LIMITED",
"INDO BEROLINA INDUSTRIES PRIVATE. LIMITED",
"INDO BIOCARE PRIVATE LIMITED",
"INDO BOGHER PLANT SCIENCE PRIVATE LIMITED",
"INDO BORAX & CHEMICALS LIMITED",
"INDO BRIGHT PETROLEUM PRIVATE LIMITED",
"INDO BRINE INDUSTRIES LIMITED",
"INDO BRITISH GARMENTS PVT LTD",
"INDO BRITISH GRAMMAR SCHOOL",
"INDO BUILT STORAGE SYSTEMS PRIVATE LIMITED",
"INDO CANADIAN CONSULTANCY SERVICES LIMITED",
"INDO CHAINS (RAIPUR) PRIVATE LIMITED",
"INDO CHEMICALS PVT LTD",
"INDO COLCHEM LIMITED",
"INDO COLCHEM PRIVATE LIMITED",
"INDO CONTAINERS PRIVATE LIMITED",
"INDO COPTERS PRIVATE LIMITED",
"INDO COSMO SYSTEMS PRIVATE LIMITED",
"INDO COTSPIN LIMITED",
"INDO COUNT INDUSTRIES LIMITED",
"INDO DAN LAMPSHADES PRIVATE LIMITED",
"INDO DIVINE SPIRITUAL SOLUTIONS PRIVATE LIMITED",
"INDO DUTCH CARPET MANUFACTURING PRIVATE LIMITED",
"INDO DUTCH HORTICULTURE TECHNOLOGIES PRIVATE LIMITED",
"INDO EAST CORPORATION PRIVATE LIMITED",
"INDO ENERGY INTERNATIONAL LIMITED",
"INDO ENTERPRISES PRIVATE LIMITED",
"INDO ENVIRO INTEGRATED SOLUTIONS PRIVATE LIMITED",
"INDO EURO INDCHEM LIMITED",
"INDO EUROPEAN AGRO PRIVATE LIMITED",
"INDO EUROPEAN BREWERIES LIMITED",
"INDO FARM EQUIPMENT LIMITED",
"INDO FLUID POWER PRIVATE LIMITED",
"INDO FORGING COMPONENTS PRIVATE LIMITED",
"INDO FRENCH HEALTH CARE PRIVATE LIMITED",
"INDO FRENCH LABORATORIES LIMITED",
"INDO FUJI ELECTRIC LIFTS PRIVATE LIMITED",
"INDO FUSION INTERIORS PRIVATE LIMITED",
"INDO GERMAN INTERNATIONAL",
"INDO GERMAN TOOL ROOM AHMEDABAD",
"INDO GERMAN TOOL ROOM JUNAGADH",
"INDO GERMAN TOOL ROOM, AHMEDABAD",
"INDO GLOBAL COMMERCIALS PRIVATE LIMITED",
"INDO GLOBAL ESUPPORT PRIVATE LIMITED",
"INDO GLOBAL HEALTH CARE PRIVATE LIMITED",
"INDO GLOBAL INFRA PROJECTS PRIVATE LIMITED",
"INDO GLOBAL INFRASTRUCTURES (RANJANGAON) SERVICES PRIVATE LIMITED",
"INDO GLOBAL PAPERS PRIVATE LIMITED",
"INDO GLOBAL SHARE BROKING PRIVATE LIMITED",
"INDO GULF AVIATION PRIVATE LIMITED",
"INDO GULF INDUSTRIES LIMITED",
"INDO GULF PEST CONTROL PRIVATE LIMITED",
"INDO HITECH APPLIANCES LIMITED",
"INDO HONGKONG INDUSTRIES PRIVATE LIMITED",
"INDO HYDRAULIC (BOMBAY) PVT LTD",
"INDO INDUSTRIES PRIVATE LIMITED",
"INDO INTERNATIONAL FERTILIZERS LIMITED",
"INDO JAPAN AIR SERVICES PRIVATE LIMITED",
"INDO JAPAN HOROLOGICALS PVT LTD",
"INDO JAPAN POLYMERS PRIVATE LIMITED",
"INDO JATALIA HOLDINGS LIMITED",
"INDO LAHIRI LIMITED",
"INDO MAG WIRES PRIVATE LIMITED",
"INDO METAFORGE PRIVATE LIMITED",
"INDO MIDDLE EASTERN ENTERPRISES PRIVATE LIMITED",
"INDO MIM LIMITED",
"INDO MONEY JEWELLERS & BULLION PRIVATE LIMITED",
"INDO MONEY SECURITIES PRIVATE LIMITED",
"INDO NACOP CHEMICALS LIMITED",
"INDO NATIONAL LIMITED",
"INDO NIPPON CHOSEKI PRIVATE LIMITED",
"INDO NIPPON FOODS PRIVATE LIMITED",
"INDO NISSIN FOODS PRIVATE LIMITED",
"INDO NONWOVEN PRIVATE LIMITED",
"INDO OFFICE SOLUTIONS PRIVATE LIMITED",
"INDO OILS AND CHEMICALS PVT LTD",
"INDO ORGANICS PRIVATE LIMITED",
"INDO OXYGEN PRIVATE LIMITED",
"INDO PACIFIC AVIATION PRIVATE LIMITED",
"INDO PACIFIC RESORTS PRIVATE LIMITED",
"INDO PACK LIMITED",
"INDO PHYTO CHEMICALS PRIVATE LIMITED",
"INDO PLAST UDYOG PRIVATE LIMITED",
"INDO PLASTECH PRIVATE LIMITED",
"INDO POWERSYS PRIVATE LIMITED",
"INDO PUMPS PRIVATE LIMITED",
"INDO QATAR PROJECTS PRIVATE LIMITED",
"INDO RAIL ENGINEERING SYSTEMS PRIVATE LIMITED",
"INDO RAMA SYNTHETICS (INDIA) LIMITED",
"INDO RIV CLINICAL PRIVATE LIMITED",
"INDO ROOFTEC (OPC) PRIVATE LIMITED",
"INDO RUBBER AND PLASTIC WORKS",
"INDO- RUSSIAN RIFLES PRIVATE LIMITED",
"INDO SAFE PHARMA PRIVATE LIMITED",
"INDO- SAKURA SOFTWARE PRIVATE LIMITED",
"INDO SAUDI SERVICES (CARGO) PRIVATE LIMITED",
"INDO SCIENTIFIC & SURGICALS PRIVATE LIMITED",
"INDO SCOTS GLOBAL SCHOOL",
"INDO SHELL CAST PRIVATE LIMITED",
"INDO SHELL MOULD LIMITED",
"INDO SHELL PRIVATE LIMITED",
"INDO SHINE MARMO PRIVATE LIMITED",
"INDO SIAM SAFETY PRODUCTS PRIVATE LIMITED",
"INDO SKINS GARMENTS PRIVATE LIMITED",
"INDO SLATE LIMITED",
"VEGOLA INDIA PRIVATE LIMITED",
"INDO SPECIALITY CHEMICALS PRIVATE LIMITED",
"INDO SPONGE POWER AND STEEL LIMITED",
"INDO SPUN LLP",
"INDO STAR INSULATION PRIVATE LIMITED",
"INDO STEEL IMPEX PRIVATE LIMITED",
"INDO SWISS ANTI-SHOCK LIMITED",
"INDO SWISS CHEMICALS LIMITED",
"INDO TECH TRANSFORMERS LIMITED",
"INDO TELEPORTS LIMITED",
"INDO TEXNOLOGY PRIVATE LIMITED",
"INDO TEXTILES & FIBRES LTD",
"INDO THAI DEVELOPERS PRIVATE LIMITED",
"INDO THAI SEEDS PRIVATE LIMITED",
"INDO THAI SYNTHETICS COMPANY LIMITED",
"INDO TOOLINGS PRIVATE LIMITED",
"INDO TYRES(CAL) PRIVATE LIMITED",
"INDO UNIQUE TRADING PRIVATE LIMITED",
"INDO US BIO TECH LIMITED",
"INDO VACUUM TECHNOLOGIES PRIVATE LIMITED",
"INDO WEBAL SURGICAL PRIVATE LIMITED",
"INDO WESTERN HYBRID SEEDS PRIVATE LIMITED",
"INDO WHEELS PRIVATE LIMITED",
"INDO WIRE INDUSTRIES PRIVATE LIMITED",
"INDO-AIR COMPRESSORS PRIVATE LIMITED",
"INDO-ALLIED PROTEIN FOODS PRIVATE LIMITED",
"INDO-AMERICAN CHAMBER OF COMMERCE",
"INDO-AMERICAN SUPERSPECIALITIES PRIVATE LIMITED",
"INDOASIA GLOBAL TECHNOLOGIES PRIVATE LIMITED",
"INDOBELL INSULATIONS LTD",
"INDO-BIO ACTIVE LABS PRIVATE LIMITED",
"INDOBLAST EXIM PRIVATE LIMITED",
"INDOBORAX INFRASTRUCTURE PRIVATE LIMITED",
"INDOCAN HONEY PRIVATE LIMITED",
"INDOCAYS PRIVATE LIMITED",
"INDOCEAN CONSTRUCTION DEVELOPMENT AND MANAGEMENT CO PVT LTD",
"INDOCEM (INDIA) PRIVATE LIMITED",
"INDOCEM COLOURS PRIVATE LIMITED",
"INDOCEN ELECTRONIC SYSTEMS PRIVATE LIMITED",
"INDOCHEM AGRI SCIENCE PRIVATE LIMITED",
"INDOCHEM AGROVET PRIVATE LIMITED",
"INDOCHEM OIL INDIA LIMITED",
"INDOCLONE LAB PRIVATE LIMITED",
"INDOCO REMEDIES LIMITED",
"INDOCOAR PHARMA PRIVATE LIMITED",
"INDOCON INFRASTRUCTURE PRIVATE LIMITED",
"INDOCON MICRO ENGINEERS LIMITED",
"INDOCOOL CHEMICALS PRIVATE LIMITED",
"INDOCOOL COMPOSITES PRIVATE LIMITED",
"INDOCOUNT SECURITIES LIMITED",
"INDOCREST TRANSPORTATION PRIVATE LIMITED",
"INDO-DANE TEXTILE INDUSTRIES PRIVATE LIMITED",
"INDO-DEUTSCH ELEKTRODEN PRIVATE LIMITED",
"INDOFIL INDUSTRIES LIMITED",
"INDOFIT SOLUTIONS PRIVATE LIMITED",
"INDOFLUXLITE PRIVATE LIMITED",
"INDOFOIL ALUMINIUM PRIVATE LIMITED",
"INDO-FRENCH CHAMBER OF COMMERCE AND INDUSTRY.",
"INDOGAS PRIVATE LIMITED",
"INDOGEM ENAMELS PVT LTD",
"INDO-GERMAN TOOL ROOM",
"INDO-GERMAN VACU TREAT PRIVATE LIMITED",
"INDO-GULF ASPHALT PRIVATE LIMITED",
"INDOGULF CROPSCIENCES LIMITED",
"INDO-GULF FOREX PRIVATE LIMITED",
"INDO-GULF INFRASTRUCTURE & INVESTMENTS PRIVATE LIMITED",
"INDO-GUM PRODUCTS PVT LTD",
"INDOHEALTH SOFTWARE SOLUTIONS PRIVATE LIMITED",
"INDOIN BIOLIFE PRIVATE LIMITED",
"INDO-ITALIAN FURNITURE COMPANY PRIVATE LIMITED",
"INDOJEWEL JEWELLERY PRIVATE LIMITED",
"INDOKEM LIMITED",
"INDOKO ENGINEERS PRIVATE LIMITED",
"INDO-KOREA SCIENCE AND TECHNOLOGY CENTER",
"INDOKOTE INDUSTRIES PRIVATE LIMITED",
"INDOLACCA SHELLAC INDUSTRIES PRIVATE LIMITED",
"INDOLANDS PHARMA PRIVATE LIMITED",
"INDOLINE INDUSTRIES PRIVATE LIMITED",
"INDOLITE DEVICES PRIVATE LIMITED",
"INDOLOG LOGISTICS PRIVATE LIMITED",
"INDOLUX ELECTRONICS PRIVATE LIMITED",
"INDOM TECHNOCHEM PRIVATE LIMITED",
"INDOMA INDUSTRIES PRIVATE LIMITED",
"INDOMA MARINE PRIVATE LIMITED",
"INDOMAS ELECTRICAL PRIVATE LIMITED",
"INDOMATRIX LOGISTICS PRIVATE LIMITED",
"INDOMAX",
"INDOMER COASTAL HYDRAULICS PRIVATE LIMITED",
"INDOMET STEEL INDUSTRIES PRIVATE LIMITED",
"INDOMIDAS ADVERTISING PRIVATE LIMITED",
"INDOMOBIL SALES AND SERVICES PRIVATE LIMITED",
"INDOMOUNT IMPEX PRIVATE LIMITED",
"INDONG TEA COMPANY LIMITED",
"INDOORIE FOOTCARE PRIVATE LIMITED",
"INDO-OVERSEAS CONSULTANTS PRIVATE LIMITED",
"INDO-PACIFIC SOLUTION PRIVATE LIMITED",
"INDOPET POLYMER PRIVATE LIMITED",
"INDOPLAST PRIVATE LIMITED",
"INDOPOL FOOD PROCESSING MACHINERY PRIVATE LIMITED",
"INDO-POLYGRAPH MACHINERY PRIVATE LIMITED",
"INDOPOWER LIGHTING PRIVATE LIMITED",
"INDORAILBUS TRAVEL PRIVATE LIMITED",
"INDORAMA ENTERTAINMENT PRIVATE LIMITED",
"INDORAMA HEALTH CARE PRIVATE LIMITED",
"INDORAMA INDIA PRIVATE LIMITED",
"INDORAMA INDUSTRIES LIMITED",
"INDORAMA VENTURES GLOBAL SHARED SERVICES PRIVATE LIMITED",
"INDORAMA VENTURES OXIDES ANKLESHWAR PRIVATE LIMITED",
"INDORAMA YARNS PRIVATE LIMITED",
"INDORE AGRO PRIVATE LIMITED",
"INDORE AROMATICS PVT LTD",
"INDORE BIOTECH INPUTS AND RESEARCH PRIVATE LIMITED",
"INDORE CAPS PRIVATE LIMITED",
"INDORE CHRISTIAN COLLEGE",
"INDORE CNC PRIVATE LIMITED",
"INDORE COLOUR ORANICS LIMITED",
"INDORE DEVELOPMENT AUTHORITY",
"INDORE DEWAS TOLLWAYS LIMITED",
"INDORE DRUMS AND BARRELS PVT LTD",
"INDORE EDUCATION AND SERVICE SOCIETY-INDORE",
"INDORE ENERGY SHIELD PRIVATE LIMITED",
"INDORE FOREX SERVICES PRIVATE LIMITED",
"INDORE GEL PRIVATE LIMITED",
"INDORE ICE & COLD STORAGE PRIVATE LIMITED",
"INDORE INSTITUTE OF SCIENCE AND TECHNOLO",
"INDORE LASIK LASER CENTRE PRIVATE LIMITED",
"INDORE MANAGEMENT INSTITUTE",
"INDORE MULTIFUNCTIONAL COMPLEX PRIVATE LIMITED",
"INDORE MUNICIPAL CORPORATION",
"INDORE PREMIER CO-OPERATIVE BANK",
"INDORE PROTEINS PRIVATE LIMITED",
"INDORE PUBLIC SCHOOL PRIVATE LIMITED",
"INDORE SMART CITY DEVELOPMENT LIMITED",
"INDORE STEEL AND IRON MILLS LIMITED",
"INDORE TOOLS PRIVATE LIMITED",
"INDORE TRAUMA CENTRE PRIVATE LIMITED",
"INDORE TREASURE ISLAND PRIVATE LIMITED",
"INDORIENT FINANCIAL SERVICES LIMITED",
"INDORIGIN ELECTRIC LIMITED",
"INDO-RUSSIAN HELICOPTERS LIMITED",
"INDO-SAUDI SERVICES TRAVEL PRIVATE LIMITED",
"INDO-SCULP AUTO-COMP PRIVATE LIMITED",
"INDOSING DISTRIBUTION PRIVATE LIMITED",
"INDOSPACE AS INDUSTRIAL PARK PRIVATE LIMITED",
"INDOSPACE BOMMASANDRA LOGISTICS PARK PRIVATE LIMITED",
"INDOSPACE CAPITAL ADVISORS PRIVATE LIMITED",
"INDOSPACE CHITTOOR II PRIVATE LIMITED",
"INDOSPACE CHITTOOR PRIVATE LIMITED",
"INDOSPACE FWS INDUSTRIAL PARK PRIVATE LIMITED",
"INDOSPACE FWS INDUSTRIAL PARK PRIVATE.LIMITED",
"INDOSPACE INDUSTRIAL PARK BADLI PRIVATE LIMITED",
"INDOSPACE INDUSTRIAL PARK ORAGADAM WALAJABAD PRIVATE LIMITED",
"INDOSPACE INDUSTRIAL PARK PANRUTI PRIVATE LIMITED",
"INDOSPACE INDUSTRIAL PARK PUNE PRIVATE LIMITED",
"INDOSPACE INDUSTRIAL PARKS PRIVATE LIMITED",
"INDOSPACE NELAMANGALA INDUSTRIAL PARK PRIVATE LIMITED",
"INDOSPACE PARK CHAKAN 1 PHASE 2A PRIVATE LIMITED",
"INDOSPACE PARK CHAKAN 1 PHASE 2B PRIVATE LIMITED",
"INDOSPACE PARK CHAKAN 1A PRIVATE LIMITED",
"INDOSPACE PARK CHAKAN 1B PRIVATE LIMITED",
"INDOSPACE PARK CHAKAN 1D PRIVATE LIMITED",
"INDOSPACE PARK SHAMSHABAD PRIVATE LIMITED",
"INDOSPACE ROHAN INDUSTRIAL PARK KHED PRIVATE LIMITED",
"INDOSPACE SKCL INDUSTRIAL PARK ORAGADAM PRIVATE LIMITED",
"INDOSPACE SKCL INDUSTRIAL PARK PRIVATE LIMITED",
"INDOSPACE SKLL COIMBATORE PRIVATE LIMITED",
"INDOSPACE WALAJABAD II PRIVATE LIMITED",
"INDOSPECTRUM PHARMACEUTICALS PRIVATE LIMITED",
"INDOSPEED SUPPLY CHAIN SOLUTION PRIVATE LIMITED",
"INDOSPIRIT BARS PRIVATE LIMITED",
"INDOSPIRIT BEVERAGES PRIVATE LIMITED",
"INDOSPIRIT DISTRIBUTION LIMITED",
"INDOSPIRIT MARKETING PRIVATE LIMITED",
"INDOSPIRIT PRIVATE LIMITED",
"INDOSTAR CAPITAL FINANCE LIMITED",
"NIWAS HOUSING FINANCE PRIVATE LIMITED",
"INDO-STRAITS PRIVATE LIMITED",
"INDOSUEZ COMMERCIAL BANKING",
"INDOSUEZ W I CARR SECURITIES INDIA PRIVATE LIMITED",
"INDOSURGICALS PRIVATE LIMITED",
"INDOSWE ENGINEERS PRIVATE LIMITED",
"INDOSWIFT CONSULTANCY SERVICES PRIVATE LIMITED",
"INDO-SWISS CENTRE OF EXCELLENCE",
"INDO-SWISS REMEDIES PRIVATE LIMITED",
"INDOTAG SOLUTIONS LIMITED",
"INDOTAN CHEMICALS LTD",
"INDO-TECH AUTO PARTS PRIVATE LIMITED",
"INDOTECH AUTOCOMP (I) PRIVATE LIMITED",
"INDOTECH DEVICES PVT LTD",
"INDOTECH ELEVATORS PRIVATE LIMITED",
"INDOTECH INDUSTRIES (I) PRIVATE LIMITED",
"INDOTECH INFRACON PRIVATE LIMITED",
"INDOTECH INTERNATIONAL PRIVATE LIMITED",
"INDO-TECH MAGNETICS PRIVATE LIMITED",
"INDOTECH SWITCHGEAR AND CONTROLS (DELHI) PRIVATE LIMITED",
"INDOTEQ OFFICE AUTOMATION SYSTEM",
"INDOTEX PAINTS PRIVATE LIMITED",
"INDOTHAI AMRITSAR PRIVATE LIMITED",
"INDO-TOOLS & DIES (INDIA) PRIVATE LIMITED",
"INDOTRANS SHIPPING PRIVATE LIMITED",
"INDO-UK HOSPITALS PRIVATE LIMITED",
"INDO-US AGRISEEDS LIMITED",
"INDOVANCE PRIVATE LIMITED",
"INDOVATION EXPORTS PRIVATE LIMITED",
"INDOVAX PRIVATE LIMITED",
"INDOVEDIC NUTRIENTS PRIVATE LIMITED",
"INDOVES INDUSTRIAL PRIVATE LIMITED",
"INDOVISION SECURITIES LIMITED",
"INDOVISION SERVICES PRIVATE LIMITED",
"INDOWAVE SERVICES PRIVATE LIMITED",
"INDOWEAVE TEXTILES PRIVATE LIMITED",
"INDO-WESTERN AGRO EXPORTS PRIVATE LIMITED",
"INDOWHITE MODATEX PRIVATE LIMITED",
"INDOWIND POWER PRIVATE LIMITED",
"INDOXPRESS LOGISTICS SOLUTIONS PRIVATE LIMITED",
"INDOYASH SPINTEX PRIVATE LIMITED",
"INDPRO ELECTRONIC SYSTEMS INDIA PRIVATE LIMITED",
"INDPRO ENGINEERING SYSTEMS PRIVATE LIMITED",
"INDPRO GLOBAL SOLUTIONS PRIVATE LIMITED",
"INDPROCESS INNOVATIONS PRIVATE LIMITED",
"INDR AGROTECH PRIVATE LIMITED",
"INDRA ACADEMY SR SEC SCHOOL",
"INDRA CONSTRUCTION CO.",
"INDRA EXIM PRIVATE LIMITED",
"INDRA HOTELS PRIVATE LIMITED",
"INDRA INDUSTRIES LIMITED",
"INDRA INFRA CREATIONS PRIVATE LIMITED",
"INDRA MARSHAL POWER PRIVATE LIMITED",
"INDRA NARAIN SINGH CONTRACTORS PVT. LTD.",
"INDRA POWERGEN PRIVATE LIMITED",
"INDRA PRASHTH COLLEGE FOR WOMEN",
"INDRA SECURITY AND ALLIED SERVICES PRIVATE LIMITED",
"INDRA SEEDS PRIVATE LIMITED",
"INDRA SINGH & SONS PVT LTD",
"INDRA SISTEMAS INDIA PRIVATE LIMITED",
"INDRA TELELINKS PRIVATE LIMITED",
"INDRA VISA FIDUCIARY SERVICES PRIVATE LIMITED",
"INDRADEV KISAN PRODUCER COMPANY LIMITED",
"INDRADHANUSH AGRO PRODUCER COMPANY LIMITED",
"INDRADHANUSH CHEMICALS PVT LTD",
"INDRADHANUSH DESIGNER JEWELLERY PRIVATE LIMITED",
"INDRADHANUSH GAS GRID LIMITED",
"INDRADHANUSH MASTERBATCHES PRIVATE LIMITED",
"INDRAJ AQUA PRIVATE LIMITED",
"INDRAJEET FOODS PRIVATE LIMITED",
"INDRAJEET INTER COLLEGE BELON BULANDSHAHR",
"INDRAJIT POWER PRIVATE LIMITED",
"INDRAJIT PROPERTIES PRIVATE LIMITED",
"INDRALOK TECHNOLOGY PRIVATE LIMITED",
"INDRAN LOGISTICS PARK PRIVATE LIMITED",
"INDRANAGARI CONCLAVE PRIVATE LIMITED",
"INDRANI AUTOMOTIVE & EGG",
"INDRANI STEELS PRIVATE LIMITED",
"INDRAPRASHTHA SECURITY SERVICES PRIVATE LIMITED",
"INDRAPRASTA ENGINE PARTS PRIVATE LIMITED",
"INDRAPRASTH ASHIYANA (INDIA) PRIVATE LIMITED",
"INDRAPRASTH FOODS LIMITED",
"INDRAPRASTHA (INDIA) PRIVATE LIMITED.",
"INDRAPRASTHA AUTOMOBILES PRIVATE LIMITED",
"INDRAPRASTHA BUILDERS PRIVATE LIMITED",
"INDRAPRASTHA CANCER SOCIETY & RESEARCH CENTRE",
"INDRAPRASTHA CORRIDOR ADVISORY SERVICES PRIVATE LIMITED",
"INDRAPRASTHA ENERGY & INFRASTRUCTURE",
"INDRAPRASTHA GAS LIMITED",
"INDRAPRASTHA ICE AND COLD STORAGE PRIVATE LIMITED",
"INDRAPRASTHA INSTITUTE OF MANAGEMENT AND TECHNOLOGY UMAHI KOTA SAHARANPUR",
"INDRAPRASTHA LOGISTICS LIMITED",
"INDRAPRASTHA LOGISTICS PRIVATE LIMITED",
"INDRAPRASTHA MEDICAL CORPORATION LIMITED",
"INDRAPRASTHA MOTORS PRIVATE LIMITED",
"INDRAPRASTHA PETRO-PRODUCTS PRIVATE LIMITED",
"INDRAPRASTHA POWER GENERATION COMPANY LIMITED",
"INDRAPRASTHA SOLES PRIVATE LIMITED",
"INDRAPRASTHA TRAVELS PRIVATE LIMITED",
"INDRAPUJA TEXTILE PRIVATE LIMITED",
"INDRAPURAM PUBLIC SCHOOL",
"INDRAPURI HIGH SCHOOL AMRAVATI",
"INDRAPURI LANDCON PRIVATE LIMITED",
"INDRARAJ ARTS COMMERCE AND SCIENCE COLLEGE",
"INDRARJUNA INFRASERVE PRIVATE LIMITED",
"INDRAS AGENCIES PRIVATE. LIMITED",
"INDRASHAKTI HUMAN RESOURCE SERVICES PRIVATE LIMITED",
"INDRASHIL UNIVERSITY",
"INDRASON PRECISION ENGINEERING PRIVATE LIMITED",
"INDRATARA AGRO INDUSTRIES PRIVATE LIMITED",
"INDRAVIJAYA ESTATES & DEVELOPERS PRIVATE LIMITED",
"INDRAWATI BUSINESS SERVICES PRIVATE LIMITED",
"INDRAYANI BIOTECH LIMITED",
"INDRAYANI FERROCAST PRIVATE LIMITED",
"INDRAYANI HUMAN RESOURCES LLP",
"INDRAYANI PRODUCTS MARKETING INDIA PRIVATE LIMITED",
"INDRAYANI SALES PRIVATE LIMITED",
"INDRAYANI SEEDS AND AGROTECH PRIVATE LIMITED",
"INDRESHWAR SUGAR MILLS LIMITED",
"INDREX PRIVATE LIMITED",
"INDRO SOLUTIONS PRIVATE LIMITED",
"INDRONES SOLUTIONS PRIVATE LIMITED",
"INDROX GLOBAL PRIVATE LIMITED",
"INDROYAL HOTELS PRIVATE LIMITED",
"INDRUX HEALTHCARE PRIVATE LIMITED",
"INDSAO CONSTRUCTION PRIVATE LIMITED",
"INDSAT CORPORATION",
"INDSEC SECURITIES AND FINANCE LTD",
"INDSIGHT GROWTH PARTNERS ADVISORS PRIVATE LIMITED",
"INDSIL ENERGY AND ELECTROCHEMICALS LIMITED",
"IND-SING DEVELOPERS PRIVATE LIMITED",
"INDSOFT SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"INDSOURCE INTERNATIONAL LLP",
"INDSOURCE PACKAGING PRIVATE LIMITED",
"INDSOYA LIMITED",
"INDSPAN SOLUTIONS PRIVATE LIMITED",
"INDSPRINT LOGISTICS PRIVATE LIMITED",
"INDSURE HEALTHCARE PRIVATE LIMITED",
"INDSYS HOLDINGS INDIA PRIVATE LIMITED",
"INDSYS INFOTECH SERVICES INDIA PRIVATE LIMITED",
"INDTAM ENGINEERING PRIVATE LIMITED",
"INDTECH APPARELS PVT LTD",
"INDTECH INSTRUMENTS PRIVATE LIMITED",
"INDTEX ENGINEERS LIMITED",
"INDTEX SOLUTIONS PRIVATE LIMITED",
"INDTRANS CONTAINER LINES PRIVATE LIMITED",
"INDU CORPORATION PRIVATE LIMITED (PART-IX)",
"INDU DATA FABRICX PRIVATE LIMITED",
"INDU DIE BLOCKS PRIVATE LIMITED",
"INDU DRUGS PRIVATE LIMITED",
"INDU EASTERN PROVINCE PROJECTS PRIVATE LIMITED",
"INDU ENGINEERING AND TEXTILES LIMITED",
"INDU EXIM PRIVATE LIMITED",
"INDU EXTRUSION & ALLOYS PRIVATE LIMITED",
"INDU HEALTH WELLNESS PRIVATE LIMITED",
"INDU INTERNATIONAL SCHOOL ERODE",
"INDU IONPURE INDIA PRIVATE LIMITED",
"INDU NISSAN OXO CHEMICAL INDUSTRIES LIMITED",
"INDU PLANT SERVICES PRIVATE LIMITED",
"INDU RAGHUKUL FOOD & CHEMICALS PRIVATE LIMITED",
"INDU SOLUTIONS PRIVATE LIMITED",
"INDU SYNTHETICS PRIVATE LIMITED",
"INDU THERMOFORMERS PRIVATE LIMITED",
"INDUBHAI PAREKH MEMORIAL HOSPITAL OF GRASIM JANA SEVA TRUST",
"INDUCARE PHARMA PRIVATE LIMITED",
"INDUCARE PHARMACEUTICALS AND RESEARCH FOUNDATION",
"INDUCO CREDIT INFORMATION AND ANALYSIS PRIVATE LIMITED",
"INDUCTION EQUIPMENTSINDIAPVT LTD",
"INDUCTION MELTING SOLUTIONS PRIVATE LIMITED",
"INDUCTION TREATMENT PRIVATE LIMITED",
"INDUCTIS INDIA PRIVATE LIMITED",
"INDUCTIVE QUOTIENT ANALYTICS INDIA PRIVATE LIMITED",
"INDUCTO TECH AUTOMATION PRIVATE LIMITED",
"INDUCTOTHERM (INDIA) PRIVATE LIMITED",
"INDUCTOTHERM GROUP PUNE PRIVATE LIMITED",
"INDUCTUS LIMITED",
"INDUGOMA RUBBER PRIVATE LIMITED",
"INDUJA ENGINEERING SERVICES PRIVATE LIMITED",
"INDUJA HOME SOLUTION PRIVATE LIMITED",
"INDUJAA MAHILA MILK PRODUCER COMPANY LIMITED",
"INDUJI TECHNOLOGIES PRIVATE LIMITED",
"INDUKERN OVERSEAS (INDIA) PRIVATE LIMITED",
"INDULGE VENTURES PRIVATE LIMITED",
"INDULGENCE RESTAURANTS PRIVATE LIMITED",
"INDUMATI H R FACILITIES PRIVATE LIMITED",
"INDUMOTI TEXFAB PRIVATE LIMITED",
"INDUPRAKASH MEDICAL AND HOSPITALITY PRIVATE LIMITED",
"INDUR LIFE SCIENCES PRIVATE LIMITED",
"INDURI FARM PRIVATE LIMITED",
"INDURO LIFESTYLE RESOURCES PRIVATE LIMITED",
"INDUS ACTION INITIATIVES",
"INDUS ADCOM PRIVATE LIMITED",
"INDUS ALLIANCE CLUB AND HOTELS PRIVATE LIMITED",
"INDUS APPSTORE PRIVATE LIMITED",
"INDUS ARC POWER PRIVATE LIMITED",
"INDUS AUTOMOTIVES PRIVATE LIMITED",
"INDUS BEST HOSPITALITY & REALTORS PRIVATE LIMITED",
"INDUS BEST MEGA FOOD PARK PRIVATE LIMITED",
"INDUS BIO GENETICS SEEDS PRIVATE LIMITED",
"INDUS BIOTECH LIMITED",
"INDUS BIOTECH PRIVATE LIMITED",
"INDUS BPO SERVICES PRIVATE LIMITED",
"INDUS BUSINESS SYSTEMS LIMITED",
"INDUS CAPITAL PRIVATE LIMITED",
"INDUS CASHEW PRIVATE LIMITED",
"INDUS CHEMIE EXPORTS PRIVATE LIMITED",
"INDUS CITY SCAPES CONSTRUCTIONS PRIVATE LIMITED",
"INDUS COFFEE PRIVATE LIMITED",
"INDUS COLONISERS PRIVATE LIMITED",
"INDUS CONCESSIONS INDIA PRIVATE LIMITED",
"INDUS CONSTRUCTION SERVICES PRIVATE LIMITED",
"INDUS CONSUMER PRODUCTS PRIVATE LIMITED",
"INDUS CONTAINER LIMITED",
"INDUS CONTROL AND AUTOMATION PRIVATE LIMITED",
"INDUS COSMECEUTICALS PRIVATE LIMITED",
"INDUS COVER SERVICES LLP",
"INDUS CROP CARE PRIVATE LIMITED",
"INDUS CULINARY TEAM PRIVATE LIMITED",
"INDUS DIGITECH PRIVATE LIMITED",
"INDUS EDUCATIONAL AND CHARITABLE TRUST",
"INDUS EDUTRAIN PRIVATE LIMITED",
"INDUS ELASTOMERE PRIVATE LIMITED",
"IND-US ELECTRONICS (INDIA) PRIVATE LIMITED",
"INDUS EMERGENCY VEHICLES PRIVATE LIMITED",
"INDUS ENGINEERS PRIVATE LIMITED",
"INDUS ENVIRONMENTAL SERVICES PRIVATE LIMITED",
"INDUS EQUITY ADVISORS PRIVATE LIMITED",
"INDUS EXIMTECH LIMITED",
"INDUS FASTENERS PRIVATE LIMITED",
"INDUS FINANCE LIMITED",
"INDUS FINE ARTS PRIVATE LIMITED",
"INDUS FIRE SAFETY PRIVATE LIMITED",
"INDUS FOOTPRINTS LIMITED",
"INDUS GARTEX PRIVATE LIMITED",
"INDUS GAS LIMITED",
"INDUS GENE EXPRESSIONS LIMITED",
"INDUS GIFTING PRIVATE LIMITED",
"INDUS HEALTH PLUS PRIVATE LIMITED",
"INDUS HEALTHCARE SERVICES PRIVATE LIMITED",
"INDUS HERBS PRIVATE LIMITED",
"INDUS HOMES PRIVATE LIMITED",
"INDUS HOSPITAL",
"INDUS INFOTECH PRIVATE LIMITED",
"INDUS INFRASERVICES PRIVATE LIMITED",
"INDUS INITIATIVES AND MANAGEMENT PRIVATE LIMITED",
"INDUS INSIGHTS AND ANALYTICAL SERVICES PRIVATE LIMITED",
"INDUS INSTRUMENTS IMPEX PRIVATE LIMITED",
"INDUS INSTRUMENTS PRIVATE LIMITED",
"INDUS INTELLIRISK & INTELLISENSE SERVICES PRIVATE LIMITED",
"INDUS INTERMODAL CARRIERS (BOMBAY) PVT LTD",
"INDUS INTERNATIONAL SCHOOL",
"INDUS INTERNATIONAL SCHOOL (PUNE) PRIVATE LIMITED",
"INDUS INTERNATIONAL SCHOOL PRIVATE LIMITED",
"INDUS INTERNTIONAL SCHOOL",
"INDUS INTEX PRIVATE LIMITED",
"INDUS INVESTMENTS PRIVATE LIMITED",
"INDUS IRON AND STEEL PRIVATE LIMITED",
"INDUS JAIPUR HOSPITAL",
"INDUS KUNDAN JEWELS PRIVATE LIMITED",
"INDUS LEISURE & AMUSEMENTS PRIVATE LIMITED",
"INDUS LIFE SCIENCES PRIVATE LIMITED",
"INDUS LIFECARE PHARMACEUTICALS PRIVATE LIMITED",
"INDUS MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"INDUS MANUFACTURING PRIVATE LIMITED",
"INDUS MARKETING",
"INDUS MEDICAL INSTRUMENTS PRIVATE LIMITED",
"INDUS MEDICARE PRIVATE LIMITED",
"INDUS MEGA FOOD PARK PRIVATE LIMITED",
"INDUS MOTOR COMPANY PRIVATE LIMITED",
"INDUS MOTORS LIGHT COMMERCIAL VEHICLES PRIVATE LIMITED",
"INDUS MULTIVENTURES LIMITED",
"INDUS NET TECHNOLOGIES LIMITED",
"INDUS NET TECHSHU DIGITAL PRIVATE LIMITED",
"INDUS NOVATEUR SOFTECH PRIVATE LIMITED",
"INDUS PETROCHEM LIMITED",
"INDUS PHARMA PRIVATE LIMITED",
"INDUS PLAST PRIVATE LIMITED",
"INDUS PORTFOLIO PRIVATE LIMITED",
"INDUS PROJECTS PRIVATE LIMITED",
"INDUS PROTECH SOLUTIONS LIMITED",
"INDUS PUBLIC SCHOOL",
"INDUS QUALITY FOUNDATION",
"INDUS RAWMETALS PRIVATE LIMITED",
"INDUS REFRIGERATION PRIVATE LIMITED",
"INDUS ROBOTICS & AUTOMATION RESEARCH PRIVATE LIMITED",
"INDUS SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"INDUS SOMA PRIVATE LIMITED",
"INDUS SOR URJA PRIVATE LIMITED",
"INDUS STRATEGY FINANCIAL ADVISORS PRIVATE LIMITED",
"INDUS SUPER SPECIALITY HEALTHCARE PRIVATE LIMITED",
"INDUS SYSTEMS AND SERVICES PRIVATE LIMITED",
"INDUS TANKS AND PIPES",
"INDUS TEQSITE PRIVATE LIMITED",
"INDUS TEXTILE MILLS PRIVATE LIMITED",
"INDUS TMT INDUSTRIES LIMITED",
"INDUS TOWERS LIMITED",
"INDUS TREE PRODUCER TRANSFORM PRIVATE LIMITED",
"INDUS TRUST",
"INDUS TUBES LIMITED",
"INDUS UDYOG & INFRASTRUCTURE PRIVATE LIMITED",
"INDUS UNIVERSITY",
"INDUS UTH HF MIXING SYSTEMS PRIVATE LIMITED",
"INDUS VALLEY AGRO SEEDS PRIVATE LIMITED",
"INDUS VALLEY AYURVEDIC CENTRE PRIVATE LIMITED",
"INDUS VALLEY BUILDCON LIMITED",
"INDUS VALLEY FERTILISERS PVT LTD",
"INDUS VALLEY PARTNERS INDIA PRIVATE LIMITED",
"INDUS VALLEY PROMOTERS LIMITED",
"INDUS VALLEY PROPERTIES PRIVATE LIMITED",
"INDUS VEGPRO PRIVATE LIMITED",
"INDUS WORLD SCHOOL",
"INDUS WORLD TRADE LIMITED",
"INDUSAGE ADVISORS LIMITED",
"INDUSAGE TECHAPP PRIVATE LIMITED",
"INDUSAJANTA PRIVATE LIMITED",
"INDUSASSIST PRIVATE LIMITED",
"INDUSCO CONSTRUCTIONS PRIVATE LIMITED",
"INDUSFACE PRIVATE LIMITED",
"INDUSFACE TELECOM PRIVATE LIMITED",
"INDUSGEEKS SOLUTIONS PRIVATE LIMITED",
"INDUSGLOBE FREIGHT LINES PRIVATE LIMITED",
"INDUSGLOBE MULTIVENTURES PRIVATE LIMITED",
"INDUSHERITAGE ARTS AND COLLECTIBLES PRIVATE LIMITED",
"INDUSHILL BUSINESS PRIVATE LIMITED",
"INDUSIND BANK",
"INDUSIND BANK LIMITED",
"INDUSIND FINANCIAL INCLUSION LIMITED",
"INDUSIND MARKETING AND FINANCIAL SERVICES PRIVATE LIMITED",
"INDU-SINO IMPEX PRIVATE LIMITED",
"INDUSION CONSULTING SERVICES PRIVATE LIMITED",
"INDUSLYNK TRAINING SERVICES PRIVATE LIMITED",
"INDUS-MARMARA AUTO COMPONENTS PRIVATE LIMITED.",
"INDUSNET TECHNOLOGIES PRIVATE LIMITED",
"INDUSPECT (INDIA) PRIVATE LIMITED",
"INDUSPRO AUTO ENGINEERS PRIVATE LIMITED",
"INDUSS FOOD PRODUCTS & EQUIPMENTS LIMITED",
"INDUSTECH ENGINEERING SERVICES PRIVATE LIMITED",
"INDUSTEEL INDIA",
"INDUSTILL FARMTECH PRIVATE LIMITED",
"INDUSTREE SKILLS TRANSFORM PRIVATE LIMITED",
"INDUSTRIAL & MINING TOOLS COMPANY PRIVATE LIMITED",
"INDUSTRIAL AIR SOLUTIONS LLP",
"INDUSTRIAL AND COMMERCIAL BANK OF CHINA LIMITED",
"INDUSTRIAL AND FLUID POWER CONSULTANTS",
"INDUSTRIAL AND PRUDENTIAL INVESTMENT COMPANY LIMITED",
"INDUSTRIAL ASSET TRANSACTION SERVICES PRIVATE LIMITED",
"INDUSTRIAL AUTOMATION",
"INDUSTRIAL BAG PACKAGING",
"INDUSTRIAL BANK OF KOREA",
"INDUSTRIAL CABLES (INDIA) LIMITED",
"INDUSTRIAL CARBONS PRIVATE LIMITED",
"INDUSTRIAL CHEMICALS AND MONOMERS LIMITED",
"INDUSTRIAL COMPRESSORS AND CRYOPUMPS PRIVATE LIMITED",
"INDUSTRIAL CONBUILD COMPANY PRIVATE LIMITED",
"INDUSTRIAL CONTROLS & DRIVES INDIA PRIVATE LIMITED",
"INDUSTRIAL CONTROLS AND APPLIANCES PRIVATE LIMITED",
"INDUSTRIAL CONVEYORS PRIVATE LIMITED",
"INDUSTRIAL COURT KOLHAPUR",
"INDUSTRIAL DEVELOPMENT AND INVESTMENT CO PVT LTD",
"INDUSTRIAL DEVELOPMENT SERVICES PRIVATE LIMITED",
"INDUSTRIAL DEVICES (INDIA) PRIVATE LIMITED",
"INDUSTRIAL ELECTRONICS & ALLIED PRODUCTS",
"INDUSTRIAL ENERGY LIMITED",
"INDUSTRIAL ENERGY SOLUTIONS",
"INDUSTRIAL ENGINEERS AND CONSULTANTS P L",
"INDUSTRIAL ENGINEERS DISTRIBUTORS PRIVATE LIMITED",
"INDUSTRIAL EQUIPMENT MANUFACTURIING COMPANY PRIVATE LIMITED",
"INDUSTRIAL EXIM PRIVATE LIMITED",
"INDUSTRIAL EXPLOSIVES PRIVATE LIMITED",
"INDUSTRIAL EXTENSION BUREAU",
"INDUSTRIAL FABRICATORS & ENGINEERS PRIVATE LIMITED",
"INDUSTRIAL FANS INDIA PRIVATE LIMITED",
"INDUSTRIAL FILTERS AND FABRICS PRIVATE LIMITED",
"INDUSTRIAL FISCAL SERVICES LIMITED",
"INDUSTRIAL FOAMS PRIVATE LIMITED",
"INDUSTRIAL FOOD MANAGEMENT PRIVATE LIMITED",
"INDUSTRIAL FORGE AND ENGINEERING COMPANY LIMITED",
"INDUSTRIAL FORGING INDUSTRIES PRIVATE LIMITED",
"INDUSTRIAL GENERAL PRODUCTS PVT LTD",
"INDUSTRIAL GUAR PRODUCTS PRIVATE LIMITED",
"INDUSTRIAL INFO RESEARCH INDIA PRIVATE LIMITED",
"INDUSTRIAL INFRASTRUCTURE SERVICES (INDIA)",
"INDUSTRIAL INSPECTION SERVICES PRIVATE LIMITED",
"INDUSTRIAL INVESTMENT TRUST LIMITED",
"INDUSTRIAL IT SOLUTION PRIVATE LIMITED",
"INDUSTRIAL JEWELS PRIVATE LIMITED",
"INDUSTRIAL KNOWLEDGE CENTRE PRIVATE LIMITED",
"INDUSTRIAL LAMINATES (INDIA) PRIVATE LIMITED",
"INDUSTRIAL MARINE AND OIL FIELD SERVICES I PRIVATE LIMITED",
"INDUSTRIAL METAL POWDERS (INDIA) PRIVATE LIMITED",
"INDUSTRIAL PERFORATION (INDIA) PVT LTD",
"INDUSTRIAL PIXEL MAGIC VISUAL EFFECTS AND ANIMATION STUDIO PRIVATE LIMITED",
"INDUSTRIAL PROCESSORS AND METALIZERS PRIVATE LIMITED",
"INDUSTRIAL PROMOTION AND INVESTMENT CORPORATION OF ODISHA LIMITED",
"INDUSTRIAL RADIOGRAPHIC SERVICES PRIVATE LIMITED",
"INDUSTRIAL REFRIGERATION PRIVATE LIMITED",
"INDUSTRIAL RUBBER PRODUCTS PRIVATE LIMITED",
"INDUSTRIAL SAFETY PRODUCTS PRIVATE LIMITED",
"INDUSTRIAL SECURITY & ALLIED SERVICES PRIVATE LIMITED",
"INDUSTRIAL SECURITY & INTELLIGENCE INDIA PRIVATE LIMITED",
"INDUSTRIAL SECURITY CONSULTANTS PRIVATE LIMITED",
"INDUSTRIAL SOLVENTS AND CHEMICALS PRIVATE LIMITED",
"INDUSTRIAL STAFFING SERVICES INDIA PRIVATE LIMITED",
"INDUSTRIAL SWITCHGEAR AND CONTROLS (BOMBAY) P LTD",
"INDUSTRIAL TECHNO MAN POWER SUPPLY & SERVICES PRIVATE LIMITED",
"INDUSTRIAL TOXICOLOGY RESEARCH CENTRE",
"INDUSTRIAL TRAINING INSTITUTE",
"INDUSTRIAL TRAINING INSTITUTE BILIMORA",
"INDUSTRIAL TRAINING INSTITUTE JALNA",
"INDUSTRIAL TRAINING INSTITUTE KARAD",
"INDUSTRIAL TRAINING INSTITUTE KHERALU",
"INDUSTRIAL TRAINING INSTITUTE MANDVI MUMBAI CITY",
"INDUSTRIAL TRAINING INSTITUTE NAGPUR GRAMIN",
"INDUSTRIAL TRAINING INSTITUTE PARDI",
"INDUSTRIAL TRAINING INSTITUTE THANE",
"INDUSTRIAL TRAINING INSTITUTE UNNAO",
"INDUSTRIAL TRAINING INSTITUTE VALSAD",
"INDUSTRIAL TRANING INSTIUTE UMARPADA",
"INDUSTRIAL TUBES MANUFACTURERS PRIVATE LIMITED",
"INDUSTRIAL X-RAYANDALLIED RADIOGRAPHERS(INDIA)PVT LTD",
"INDUSTRIANO PVT LTD",
"INDUSTRIAS DEL RECAMBIO INDIA PRIVATE LIMITED",
"INDUSTRIES ENERGY AND LABOUR DEPARTMENT",
"INDUSTRIES PRIVATE LIMITED",
"INDUSTRIES UP GOVT LKO",
"INDUSTRON NANOTECHNOLOGY PRIVATE LIMITED",
"INDUSTRY HOUSE LIMITED",
"INDUSTRYLANE SOLUTIONS PRIVATE LIMITED",
"INDUSUNO ONLINE PRIVATE LIMITED",
"INDUSVALLEY EMPIRES PRIVATE LIMITED",
"INDUSVALLEY TRADING PRIVATE LIMITED",
"INDUSVERITUS PRIVATE LIMITED",
"INDUSVIVA HEALTHSCIENCES PRIVATE LIMITED",
"INDUSWORLD VENTURES PRIVATE LIMITED",
"INDUTAI GAIKWAD PATIL AYURVEDIC COLLEGE AND RESEARCH CENTER",
"INDUTCH COMPOSITES TECHNOLOGY PRIVATE LIMITED",
"INDUTECH SOLUTIONS AND MANUFACTURE PRIVATE LIMITED",
"INDVENT FANS PVT LTD",
"INDVEST VENTURES PRIVATE LIMITED",
"IND-VIGO COAL PRIVATE LIMITED",
"INDVIZ SOLUTIONS PRIVATE LIMITED",
"INDWAY FURNITURE MANUFACTURING COMPANY PRIVATE LIMITED",
"INDWAY PRIME ENERGY PRIVATE LIMITED",
"INDWEL METALTREATER PRIVATE LIMITED",
"INDWELL CONSTRUCTIONS PRIVATE LIMITED",
"INDWELL EXPORTS PRIVATE LIMITED",
"INDWELL HOTELS PRIVATE LIMITED",
"INDWELL RETAIL PRIVATE LIMITED",
"INDX TECHNOLOGY INDIA PRIVATE LIMITED",
"INDXX CAPITAL MANAGEMENT PRIVATE LIMITED",
"INDXXING MANAGEMENT SERVICES PRIVATE LIMITED",
"INDYACAR TRAVEL SOLUTIONS PRIVATE LIMITED",
"INDYAGRO FOODS PRIVATE LIMITED",
"INDYATEX CLOTHING PRIVATE LIMITED",
"INDYCIUM TECH. LLP",
"INDYGREEN TECHNOLOGIES PRIVATE LIMITED",
"INE VALUE CREATORS AND CONSULTANT PRIVATE LIMITED",
"INEART CRYOGENICS AND ALLIED GASES PRIVATE LIMITED",
"INECOM TECHNOLOGY PRIVATE LIMITED",
"INECTA PRIVATE LIMITED",
"INEDA SYSTEMS PRIVATE LIMITED",
"INEDGE TECHNOLOGIES PRIVATE LIMITED",
"INEGA MODEL MANAGEMENT PRIVATE LIMITED",
"INEIGHT INDIA PRIVATE LIMITED",
"INEL GAS CONTROLS PRIVATE LIMITED",
"INEL POWER SYSTEM ENGINEERS PRIVATE LIMITED",
"INELGAS METERING SYSTEMS PRIVATE LIMITED",
"INEOS COMPOSITES INDIA LLP",
"INERG SOFTWARE INNOVATIONS PRIVATE LIMITED",
"INERGY INFRA PRIVATE LIMITED",
"INERTIA FOODS PRIVATE LIMITED",
"INERTIACART APPAREL PRIVATE LIMITED",
"INESA ENTERTAINMENT OPC PRIVATE LIMITED",
"INESH RADIATORS LIMITED",
"INESH REALTORS PRIVATE LIMITED",
"INESS GLOBAL SOLUTIONS PRIVATE LIMITED",
"INET FIBER INDIA PRIVATE LIMITED",
"INET FIBER PRIVATE LIMITED",
"INET FRAME TECHNOLOGIES PRIVATE LIMITED",
"INETEST TECHNOLOGIES INDIA PRIVATE LIMITED",
"INEVITABLE ELECTRONICS PRIVATE LIMITED",
"INEVITABLE INFOTECH PRIVATE LIMITED",
"INEVITABLE MARKETING LIMITED",
"INEX MEDICAMENTS PRIVATE LIMITED",
"INEXIOS PHARMACEUTICALS PRIVATE LIMITED",
"INEXO CAST METAL SOLUTIONS PRIVATE LIMITED",
"INEXT LOGISTICS & SUPPLY CHAIN PRIVATE LIMITED",
"INEXT SECURITIES AUTOMATION PRIVATE LIMITED",
"INEXTIS EVENTS PRIVATE LIMITED",
"INEXTRIX TECHNOLOGIES PRIVATE LIMITED",
"INEXTURE SOLUTIONS LLP",
"INEXUS BIOTECH PRIVATE LIMITED",
"INEZ ENGINEERING & FABRICATION PRIVATE LIMITED",
"INFA ENGINEERS PRIVATE LIMITED",
"INFAB INFRASTRUCTURE PRIVATE LIMITED",
"INFAC INDIA PRIVATE LIMITED",
"INFALLIBLE PHARMA PRIVATE LIMITED",
"INFANION SOFTWARE SOLUTIONS INDIA PRIVATE LIMITED",
"INFANT BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"INFANT ENGINEERS PRIVATE LIMITED",
"INFANT JESUS ACADEMY",
"INFANT JESUS COLLEGE OF PHYSIOTHERAPY",
"INFANT JESUS ENGINEERING WORKS PRIVATE LIMITED",
"INFANT JESUS HIGH SCHOOL",
"INFANT MARY SCHOOL KATIPALLA",
"INFANT PROPERTIES AND INVESTMENTS PRIVATE LIMITED",
"INFANT TRADING AND SERVICES PRIVATE LIMITED",
"INFANTJESUS PREPRIMARY SCHOOL",
"INFANTS TRAVELS PRIVATE LIMITED",
"INFEC SERVICES PRIVATE LIMITED",
"INFEEDO PRIVATE LIMITED",
"INFEEDO TECH PRIVATE LIMITED",
"INFER RADIOLOGICAL AND IMAGING SERVICES PRIVATE LIMITED",
"INFERENZ TECH PRIVATE LIMITED",
"INFERNO FIRE FIGHTING SYSTEMS PRIVATE LIMITED",
"INFERNO PACTEC INDIA PRIVATE LIMITED",
"INFERTILITY INSTITUTE AND RESEARCH CENTRE PRIVATE LIMITED",
"INFEXN LABORATORIES PRIVATE LIMITED",
"INFI TECHNOLOGIES PRIVATE LIMITED",
"INFIBEAM AVENUES LIMITED",
"INFICAD STRUCTURAL TECHNOLOGIES PRIVATE LIMITED",
"INFICARE SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"INFICHEM PHARMA PRIVATE LIMITED",
"INFICOLD INDIA PRIVATE LIMITED",
"INFIDIGIT CONSULTANTS PRIVATE LIMITED",
"INFIFLEX TECHNOLOGIES PRIVATE LIMITED",
"INFIGLOBAL ENGINEERING AND SERVICES PRIVATE LIMITED",
"INFIGO LIFESCIENCES PRIVATE LIMITED",
"INFIILOOM INDIA PRIVATE LIMITED",
"INFILIFE HEALTHCARE PRIVATE LIMITED",
"INFILON TECHNOLOGIES PRIVATE LIMITED",
"INFILTRA TECHNOLOGIES OPC PRIVATE LIMITED",
"INFIN SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"INFINA FINANCE PRIVATE LIMITED",
"INFINA INSURANCE BROKING PRIVATE LIMITED",
"INFINATOR PRIVATE LIMITED",
"INFINECS SYSTEMS PRIVATE LIMITED",
"INFINEON TECHNOLOGIES INDIA PRIVATE LIMITED",
"INFINEON TECHNOLOGIES SEMICONDUCTOR INDIA PRIVATE LIMITED",
"INFINERA COMMUNICATION INDIA PRIVATE LIMITED",
"INFINERA INDIA PRIVATE LIMITED",
"INFINES SECURITIES PRIVATE LIMITED",
"INFINEUM INDIA ADDITIVES PRIVATE LIMITED",
"INFINI DESIGNS PRIVATE LIMITED",
"INFINI INSTITUTE OF CONSTRUCTION PROJECT MANAGEMENT PRIVATE LIMITED",
"INFINI SYSTEMS PRIVATE LIMITED",
"INFINIA ENTERPRISES PRIVATE LIMITED",
"INFINIA LIFESTYLE PRIVATE LIMITED",
"INFINICHAINS LAB PRIVATE LIMITED",
"INFINIDAT IT INDIA PRIVATE LIMITED",
"INFINIIDEAS",
"INFINIMINDS PRIVATE LIMITED",
"INFINIOS BUSINESS SOLUTIONS INDIA PRIVATE LIMITED",
"INFINIRA SOFTWARE PRIVATE LIMITED",
"INFINIRE INNOVATIVE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"INFINIT ENERGY SOLUTIONS PRIVATE LIMITED",
"INFINITA BIOTECH PRIVATE LIMITED",
"INFINITAS DEVELOPMENTS (OPC) PRIVATE LIMITED",
"INFINITAS EPC PRIVATE LIMITED",
"INFINITAS TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"INFINITE ADHESIVE INDIA PRIVATE LIMITED",
"INFINITE ANALYTICS INDIA PRIVATE LIMITED",
"INFINITE AQUA PRIVATE LIMITED",
"INFINITE CERCLE PRIVATE LIMITED",
"INFINITE CIVIL SOLUTIONS PRIVATE LIMITED",
"INFINITE COMPUTER SOLUTIONS (INDIA) LIMITED",
"INFINITE COMPUTER SOLUTIONS INDIA LIMITED",
"INFINITE COMPUTING SYSTEMS PRIVATE LIMITED",
"INFINITE CREATIONS PRIVATE LIMITED",
"INFINITE ELECTROTECH PRIVATE LIMITED",
"INFINITE ENERGY PRIVATE LIMITED",
"INFINITE ENGINEERING SOLUTIONS PRIVATE LIMITED",
"INFINITE ENTERPRISES PRIVATE LIMITED",
"INFINITE FINANCIAL SERVICES PVT LTD",
"INFINITE FUSION WORKS PRIVATE LIMITED",
"INFINITE GLOBAL LOGISTICS PRIVATE LIMITED",
"INFINITE GLOBAL SPIRITS & BEVERAGE PRIVATE LIMITED",
"INFINITE HORIZONS SERVICES PRIVATE LIMITED",
"INFINITE INDIA INVESTMENT MANAGEMENT LIMITED",
"INFINITE INDUSTRIES PRIVATE LIMITED",
"INFINITE JOURNEYS PRIVATE LIMITED",
"INFINITE LEISURE PRIVATE LIMITED",
"INFINITE LINKED SOLUTIONS PRIVATE LIMITED",
"INFINITE LOOP CORPORATION PRIVATE LIMITED",
"INFINITE LUXURY BRANDS PRIVATE LIMITED",
"INFINITE MARCOM LLP",
"INFINITE ONLINE SHOPPING PRIVATE LIMITED",
"INFINITE PLASTOWARE PRIVATE LIMITED",
"INFINITE SIGNAGE AND FIXTURES INDIA PRIVATE LIMITED",
"INFINITE STAFFING SOLUTIONS PRIVATE LIMITED",
"INFINITE TECH SERVICES PRIVATE LIMITED",
"INFINITE TELECOM SOLUTIONS PRIVATE LIMITED",
"INFINITE TIRUPATI GLASS PRIVATE LIMITED",
"INFINITE TRADERS PRIVATE LIMITED",
"INFINITE TURFPARK PRIVATE LIMITED",
"INFINITE WATER SOLUTIONS PRIVATE LIMITED",
"INFINITE WIRES AND COMPONENTS PRIVATE LIMITED",
"INFINITEE INDIA NATURALS AND SYNTHETICS PRIVATE LIMITED",
"INFINITHEISM SPIRITUAL FOUNDATION PRIVATE LIMITED",
"INFINITI BUILDING SOLUTIONS PRIVATE LIMITED",
"INFINITI CERAMICA PRIVATE LIMITED",
"INFINITI DIGITECH PRIVATE LIMITED",
"INFINITI ENGINEERS PRIVATE LIMITED",
"INFINITI EQUITIES AND DERIVATIVES TRADING PRIVATELIMITED",
"INFINITI IMPEX PRIVATE LIMITED",
"INFINITI MODULES PRIVATE LIMITED",
"INFINITI POWER PRIVATE LIMITED",
"INFINITI RESEARCH MARKETING SOLUTIONS INDIA PRIVATE LIMITED",
"INFINITI RETAIL LIMITED",
"INFINITI SOFTWARE SOLUTIONS PRIVATE LIMITED",
"INFINITI TELEVISION & TELECOM PRIVATE LIMITED",
"INFINITRING TRADING PRIVATE LIMITED",
"INFINITTI DESIGN STUDIO PRIVATE LIMITED",
"INFINITUDE INTERNATIONAL PRIVATE LIMITED",
"INFINITUDE LOGISTICS PRIVATE LIMITED",
"INFINITUM GLOBAL SOFTWARE SOLUTIONS PRIVATE LIMITED",
"INFINITUM MANPOWER SERVICES PRIVATE LIMITED",
"INFINITUM VENTURES PRIVATE LIMITED",
"INFINITY ADVERTISING SERVICES PRIVATE LIMITED",
"INFINITY AIR & SEA LOGISTICS PRIVATE LIMITED",
"INFINITY APPARELS PRIVATE LIMITED",
"INFINITY ASSURANCE SOLUTIONS PRIVATE LIMITED",
"INFINITY AUTOLINKS PRIVATE LIMITED",
"INFINITY AUTOMATED SOLUTIONS PRIVATE LIMITED",
"INFINITY AUTOMATION SYSTEMS PRIVATE LIMITED",
"INFINITY BNKE INFOCITY PRIVATE LIMITED",
"INFINITY BPO SERVICES PRIVATE LIMITED",
"INFINITY CARE HOSPITAL",
"INFINITY CARS PRIVATE LIMITED",
"INFINITY COMMODITIES",
"INFINITY CONSULTANTS LIMITED",
"INFINITY CORPORATE SOLUTIONS PRIVATE LIMITED",
"INFINITY DATA TECHNOLOGIES PRIVATE LIMITED",
"INFINITY DEVCON PRIVATE LIMITED",
"INFINITY DEVELOPERS PRIVATE LIMITED",
"INFINITY DIGITAL SOLUTIONS PRIVATE LIMITED",
"INFINITY DRIVE PRIVATE LIMITED",
"INFINITY DUTY FREE SERVICES PRIVATE LIMITED",
"INFINITY EDIFICE PRIVATE LIMITED",
"INFINITY ENGINEERING SOLUTIONS PRIVATE LIMITED",
"INFINITY ESERVICES PRIVATE LIMITED.",
"INFINITY FABTECH PRIVATE LIMITED",
"INFINITY FINCORP SOLUTIONS PRIVATE LIMITED",
"INFINITY FINSERV PRIVATE LIMITED",
"INFINITY FORGE PRIVATE LIMITED",
"INFINITY FREIGHT SERVICES PRIVATE LIMITED",
"INFINITY GLOBAL SUPPLY CHAIN LIMITED",
"INFINITY GLOBALDELIVERY PRIVATE LIMITED",
"INFINITY HEALTH CARE PRIVATE LIMITED",
"INFINITY HEART INSTITUTE",
"INFINITY HR CONSULTAT PRIVATE LIMITED",
"INFINITY HVAC SPARES & TOOLS PRIVATE LIMITED",
"INFINITY INFOTECH PARKS LIMITED",
"INFINITY INFOWAY PRIVATE LIMITED",
"INFINITY INFRATECH",
"INFINITY INTERIORS PRIVATE LIMITED",
"INFINITY JEWELLERY PRIVATE LIMITED",
"INFINITY LABORATORIES PRIVATE LIMITED",
"INFINITY LABS LIMITED",
"INFINITY LINING PRIVATE LIMITED",
"INFINITY LOGISTICS & SUPPLY CHAIN PRIVATE LIMITED",
"INFINITY MANAEMENT AND ENGINEERING COLLEGE",
"INFINITY MANUFACTURING COMPANY PRIVATE LIMITED",
"INFINITY MARKETING SERVICES PRIVATE LIMITED",
"INFINITY MEASUREMENT SOLUTIONS PRIVATE LIMITED",
"INFINITY MEDICAL BILLING SOLUTIONS LLP",
"INFINITY MEDICARE PRIVATE LIMITED",
"INFINITY MEDIQUIP INDIA PRIVATE LIMITED",
"INFINITY MOTORS PRIVATE LIMITED",
"INFINITY NETWORKS PRIVATE LIMITED",
"INFINITY OPTIMAL SOLUTION PRIVATE LIMITED",
"INFINITY PANEL SWITCHGEAR PRIVATE LIMITED",
"INFINITY PAPER PACKS PRIVATE LIMITED",
"INFINITY PLYLAM PRIVATE LIMITED",
"INFINITY PMC PRIVATE LIMITED",
"INFINITY POLYRUB PRIVATE LIMITED",
"INFINITY POST PRIVATE LIMITED",
"INFINITY PUMPS AND SYSTEMS PRIVATE LIMITED",
"INFINITY SECURITY PAPERS LIMITED",
"INFINITY SHIPPING PRIVATE LIMITED",
"INFINITY SWITCH TECHNOLOGIES PRIVATE LIMITED",
"INFINITY VINCOM PRIVATE LIMITED",
"INFINITY.COM FINANCIAL SECURITIES LIMITED",
"INFINITYQUEST IT SERVICES PRIVATE LIMITED",
"INFINITYX TECH SYSTEMS PRIVATE LIMITED",
"INFINIUM COMMUNICATION PRIVATE LIMITED",
"INFINIUM HEALTHCARE PRIVATE LIMITED",
"INFINIUM INDIA LIMITED",
"INFINIUM MOTORS (GUJARAT) PRIVATE LIMITED",
"INFINIUM MOTORS PRIVATE LIMITED",
"INFINIUM PHARMACHEM LIMITED",
"INFINIUM PRECIOUS RESOURCES LIMITED",
"INFINIUM SOLUTIONZ PRIVATE LIMITED",
"INFINIUM TRADELINK PRIVATE LIMITED",
"INFINIVALUE PRIVATE LIMITED",
"INFINIXQ INDIA BUSINESS PROCESS MANAGEMENT PRIVATE LIMITED",
"INFINIZE CORPTECH PRIVATE LIMITED",
"INFINIZI CONSULTING PRIVATE LIMITED",
"INFINOVA INDIA PRIVATE LIMITED",
"INFINOVA TECHNOCAST PRIVATE LIMITED",
"INFINTRIX GLOBAL LIMITED",
"INFINTY HR CONSULTANT PRIVATE LIMITED",
"INFINX SERVICES PRIVATE LIMITED",
"INFION ADVANCED LASER SYSTEMS PRIVATE LIMITED",
"INFIONIC INDIA PRIVATE LIMITED",
"INFIOT NETWORKS PRIVATE LIMITED",
"INFIQUITY AUTO TECHNOLOGIES PRIVATE LIMITED",
"INFISWIFT TECHNOLOGIES PRIVATE LIMITED",
"INFITECH POWER TRANSMISSION PRIVATE LIMITED",
"INFITECH REALITY PRIVATE LIMITED",
"INFITHOUGHTS PRIVATE LIMITED",
"INFIVENTION TECHNOLOGIES PRIVATE LIMITED",
"INFIWAY PAYMENT SERVICES PRIVATE LIMITED",
"INFIXZON TECHNOLOGIES PRIVATE LIMITED",
"INFIZEN SOLUTIONS PRIVATE LIMITED",
"INFLAME APPLIANCES LIMITED",
"INFLATE PLAST",
"INFLIGHT AIRWAYS TRAINING PRIVATE LIMITED",
"INFLOW TECHNOLOGIES PRIVATE LIMITED",
"INFLUENCE ELECTRONICS PRIVATE LIMITED",
"INFLUENCE OUTSOURCING PRIVATE LIMITED",
"INFLUENCE TECHNOLABS PRIVATE LIMITED",
"INFLUENZONE TECHNOLOGIES PRIVATE LIMITED",
"INFLUIDITY SOLUTION PRIVATE LIMITED",
"INFLUX BIG DATA SOLUTIONS PRIVATE LIMITED",
"INFLUX HEALTHTECH LIMITED",
"INFLUX INDUSTRIAL AND LOGISTIC SERVICES PRIVATE LIMITED",
"INFLUX INTEGRATED SOLUTIONS PRIVATE LIMITED",
"INFLUX SALES PRIVATE LIMITED",
"INFO CARE DIGITAL SYSTEM PRIVATE LIMITED",
"INFO CAREER PRIVATE LIMITED",
"INFO CONNECT WEB TECHNOLOGIES INDIA PRIVATE LIMITED",
"INFO DATALOGY SOFTWARE PRIVATE. LIMITED.",
"INFO EDGE INDIA LIMITED",
"INFO FIBER SOLUTIONS PRIVATE LIMITED",
"INFO INSTITUTE OF ENGINEERING",
"INFO MAC IT SOLUTIONS PRIVATE LIMITED",
"INFO NETSYS COMMUNICATIONS PRIVATE LIMITED",
"INFO ORIGIN TECHNOLOGIES PRIVATE LIMITED",
"INFO PLUS TECHNOLOGIES PRIVATE LIMITED",
"INFO QUEST BACKGROUND CHECKS PRIVATE LIMITED",
"INFO SOFTDATA SERVICES PRIVATE LIMITED",
"INFO TALENT CONSULTING PRIVATE LIMITED",
"INFO TECH CORPORATION OF GOA LIMITED",
"INFO TEST IT SERVICES PRIVATE LIMITED",
"INFOANALYTICA CONSULTING PRIVATE LIMITED",
"INFOANE TECHNOLOGIES PRIVATE LIMITED",
"INFOAVANA TECHNOLOGIES PRIVATE LIMITED",
"INFOAXON TECHNOLOGIES INDIA PRIVATE LIMITED",
"INFOBAHN SOFTWORLD INDIA LLP",
"INFOBAHN TECHNICAL SOLUTIONS I PRIVATE LIMITED",
"INFOBASE SYSTEMS PRIVATE LIMITED",
"INFOBEANS CLOUDTECH LIMITED",
"INFOBEANS TECHNOLOGIES LIMITED",
"INFOBELL IT SOLUTIONS PRIVATE LIMITED",
"INFOBIP INDIA PRIVATE LIMITED",
"INFOBLOX TECHNICAL SUPPORT AND SOFTWARE DEVELOPMENT PRIVATE LIMITED",
"INFOBRIDGE INDIA PRIVATE LIMITED",
"INFOBRIDGE SOLUTIONS PRIVATE LIMITED",
"INFOCARE SOLUTIONS PRIVATE LIMITED",
"INFOCARE TECHNOLOGIES PRIVATE LIMITED",
"INFOCEPTS TECHNOLOGIES PRIVATE LIMITED",
"INFOCITY CLUBS AND RESORTS PRIVATE LIMITED",
"INFOCLAB SOLUTIONS PRIVATE LIMITED",
"INFOCLADE SOLUTION PRIVATE LIMITED",
"INFOCLOUD IT SERVICES PRIVATE LIMITED",
"INFOCOM BOOKS INDIA PRIVATE LIMITED",
"INFOCOM INDIA PRIVATE LIMITED",
"INFOCOM NETWORK PRIVATE LIMITED",
"INFOCON INTERNATIONAL LIMITED",
"INFOCON INTERNATIONAL PRIVATE LIMITED",
"INFOCON SYSTEMS (INDIA) PRIVATE LIMITED",
"INFOCORE ENGINEERING & IT SERVICES PRIVATE LIMITED",
"INFOCORPTECH SERVICES PRIVATE LIMITED",
"INFOCOST SOLUTION PRIVATE LIMITED",
"INFOCRATS WEB SOLUTIONS PRIVATE LIMITED",
"INFOCREATIONS TECHNOLOGIES PRIVATE LIMITED",
"INFOCRUNCH CAMPAIGNS PRIVATE LIMITED",
"INFOCUBE SOLUTION PRIVATE LIMITED",
"INFOCUS MEDIA SOLUTIONS INDIA PRIVATE LIMITED",
"INFOCUS TECHNOLOGIES PRIVATE LIMITED",
"INFOCYBER INDIA PRIVATE LIMITED",
"INFODART TECHNOLOGIES INDIA LIMITED",
"INFODEEP TECHNOLOGIES PRIVATE LIMITED",
"INFODESK INDIA PRIVATE LIMITED",
"INFODREAMZ TECHNOLOGIES (NAGPUR) PRIVATE LIMITED",
"INFO-DRIVE ANALYTICS PRIVATE LIMITED-MAHESH PATIL",
"INFODRIVE INDIA PRIVATE LIMITED",
"INFO-ELECTRONICS SYSTEMS INDIA PRIVATE LIMITED",
"INFOESEARCH INFORMATION TECHNOLOGY ENABLED SERVICES PRIVATE LIMITED",
"INFOEXCEL CONSULTING PRIVATE LIMITED",
"INFOFACE SOLUTIONS PRIVATE LIMITED",
"INFOGAIN INDIA PRIVATE LIMITED",
"INFOGAIN SOLUTIONS PRIVATE LIMITED",
"INFOGAIN SYSTEMS PRIVATE LIMITED",
"INFOGEM WEB SOLUTIONS PRIVATE LIMITED",
"INFOGEN LABS PRIVATE LIMITED",
"INFOGIRD INFORMATICS PRIVATE LIMITED",
"INFOGIX INDIA PRIVATE LIMITED",
"INFOGIX INTERNATIONAL PRIVATE LIMITED",
"INFOGRAINS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"INFOGRID PACIFIC SOFTWARE PRIVATE LIMITED",
"INFOICON TECHNOLOGIES PRIVATE LIMITED",
"INFOIT SOFTECH PRIVATE LIMITED",
"INFOKALL ENTERPRISE SOLUTIONS LIMITED",
"INFOKEYS INDIA PRIVATE LIMITED",
"INFOKRAFTS DATA CONSULTANCY SERVICES PRIVATE LIMITED",
"INFOLINK CONSULTANCY SERVICES PRIVATE LIMITED",
"INFOLINK HEALTH SERVICES PRIVATE LIMITED",
"INFOLKS PRIVATE LIMITED",
"INFOLLION RESEARCH SERVICES PRIVATE LIMITED",
"INFOLOB SOLUTIONS INDIA PRIVATE LIMITED",
"INFOLOG SOLUTIONS PRIVATE LIMITED",
"INFOLOGITECH INDIA PRIVATE LIMITED",
"INFOMAGNUS TECHNOLOGIES INDIA PRIVATE LIMITED",
"INFOMAP SOLUTIONS PRIVATE LIMITED",
"INFOMATICS SERVICES PRIVATE LIMITED",
"INFOMATICS SOFTWARE SOLUTIONS INDIA PRIVATE LIMITED",
"INFOMATIX MARKETING & SOLUTIONS PRIVATE LIMITED",
"INFOMAX MANAGEMENT SERVICES INDIA PRIVATE LIMITED",
"INFOMAZE ELITE PRIVATE LIMITED",
"INFOMEDIA INDIA LIMITED",
"INFOMEDIA PRESS LIMITED",
"INFOMERICA INDIA PRIVATE LIMITED",
"INFOMERICS ANALYTICS AND RESEARCH PRIVATE LIMITED",
"INFOMERICS VALUATION AND RATING PRIVATE LIMITED",
"INFOMETRY INDIA SOFTWARE PRIVATE LIMITED",
"INFOMILE TECHNOLOGIES LIMITED",
"INFONATIVE SOLUTIONS PRIVATE LIMITED",
"INFONEO TECHNOLOGIES PRIVATE LIMITED",
"INFONET COMM ENTERPRISES PRIVATE LIMITED",
"INFONEX TECHNOLOGIES",
"INFONOVIA MARKETING SERVICES PRIVATE LIMITED",
"INFONOVUM SOFTWARE AND CONSULTING PRIVATE LIMITED",
"INFONOVUM TECHNOLOGIES PRIVATE LIMITED",
"INFONOX SOFTWARE PRIVATE LIMITED",
"INFONPOWER SYSTEMS PRIVATE LIMITED",
"INFONYX INDIA PRIVATE LIMITED",
"INFOOBJECTS SOFTWARE INDIA PRIVATE LIMITED",
"INFOPERCEPT CONSULTING PRIVATE LIMITED",
"INFOPINE CONSULTANCY SERVICES PRIVATE LIMITED",
"INFOPOWER TECHNOLOGIES PRIVATE LIMITED",
"INFOPRO LEARNING PRIVATE LIMITED",
"INFOQORT TECHNOLOGIES PRIVATE LIMITED",
"INFOR INDIA PRIVATE LIMITED",
"INFORAISE TECHNOLOGIES PRIVATE LIMITED",
"INFORICA INDIA PRIVATE LIMITED",
"IN-FORK LOGISTICS SOLUTIONS PRIVATE LIMITED",
"INFORMA MARKETS INDIA PRIVATE LIMITED",
"INFORMA TECHNOLOGIES PRIVATE LIMITED",
"INFORMAGE REALTY PRIVATE LIMITED",
"INFORMAGE TECHNO SOLUTIONS PRIVATE LIMITED",
"INFORMAL INTERIORS PRIVATE LIMITED",
"INFORMATIC COMPUTECH PRIVATE LIMITED",
"INFORMATICA BUSINESS SOLUTIONS PRIVATE LIMITED",
"INFORMATICS IN CONTEXT INDIA PRIVATE LIMITED",
"INFORMATICS INDIA LIMITED",
"INFORMATICS PUBLISHING LIMITED",
"INFORMATION AND COMMUNICATION TECHNOLOGY ACADEMY OF KERALA",
"INFORMATION DYNAMICS INDIA PRIVATE LIMITED",
"INFORMATION EVOLUTION INDIA PRIVATE LIMITED",
"INFORMATION MOSAIC SOFTWARE PRIVATE LIMITED",
"INFORMATION PUBLIC RELATIONS DEPTT",
"INFORMATION QUOTIENT SOFTWARE SERVICES PRIVATE LIMITED",
"INFORMATION SECURITY MEDIA GROUP (INDIA) PRIVATE LIMITED",
"INFORMATION TECHNOLOGY MANAGEMENT INDIA",
"INFORMATION TECHNOLOGY PARK LIMITED",
"INFORMDS TECHNOLOGIES PRIVATE LIMITED",
"INFORMED TECHNOLOGIES INDIA LIMITED",
"INFOSAGE SYSTEMS INDIA PRIVATE LIMITED",
"INFOSEARCH BPO SERVICES PRIVATE LIMITED",
"INFOSEC VENTURES PRIVATE LIMITED",
"INFOSENSE PRIVATE LIMITED",
"INFOSENSE SERVICES",
"INFOSENSE TECHNOLOGIES PRIVATE LIMITED",
"INFOSHARE SOFT SOLUTIONS PRIVATE LIMITED",
"INFOSIGHT SOFTWARE & CONSULTING SERVICES PRIVATE LIMITED",
"INFOSION SOFTWARE PRIVATE LIMITED",
"INFOSMART SYSTEMS PRIVATE LIMITED",
"INFOSOFT COMPUTERS PRIVATE LIMITED",
"INFOSOFT DIGITAL DESIGN AND SERVICES PRIVATE LIMITED",
"INFOSOFT GLOBAL PRIVATE LIMITED",
"INFOSOFT PRINTNET PRIVATE LIMITED",
"INFOSOFT SYSTEMS",
"INFOSOFT TEKSOLUTIONS PRIVATE LIMITED",
"INFOSOLS ECONSULTANTS INDIA PRIVATE LIMITED",
"INFOSPECTRM INDIA PRIVATE LIMITED",
"APEXON INDIA PRIVATE LIMITED",
"INFOSTRIDE TECHNOLOGIES PRIVATE LIMITED",
"INFOSUN TECHNOLOGIES PRIVATE LIMITED",
"INFOSYS BPM LIMITED",
"INFOSYS LIMITED",
"INFOTAINMENT TELEVISION PRIVATE LIMITED",
"INFOTANKS MEDIA SERVICE PRIVATE LIMITED",
"INFOTECH EDUCATION SOCIETY",
"INFOTECH FINANCIALS PRIVATE LIMITED",
"INFOTECH GLOBAL INDIA LIMITED",
"INFOTECH HAL LIMITED",
"INFOTECHHUB PRIVATE LIMITED",
"INFOTEK SOFTWARE AND SYSTEMS PRIVATE LIMITED",
"INFOTEL ACCESS ENTERPRISES PRIVATE LIMITED",
"INFOTEL BUSINESS SOLUTIONS LIMITED",
"INFOTEL INFRASTRUCTURE PRIVATE LIMITED",
"INFOTEL SATCOM PRIVATE LIMITED",
"INFOTEL SERVICES AND SALES PRIVATE LIMITED",
"INFOTEL TECHNOLOGIES PRIVATE LIMITED",
"INFOTEL TELECOM INFRASTRUCTURE PRIVATE LIMITED",
"INFOTEL VENTURES PRIVATE LIMITED",
"INFOTON SYSTEMS & SERVICES PLIMITED",
"INFOTOUCH TECHNOLOGIES PRIVATE LIMITED",
"INFOTRACK SYSTEMS PRIVATE LIMITED",
"INFOTRACK TELEMATICS PRIVATE LIMITED",
"INFOTRANS ENGINEERS PRIVATE LIMITED",
"INFOTRELLIS INDIA PRIVATE LIMITED",
"INFOTRONICS COMMUNICATION PRIVATE LIMITED",
"INFOVIE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"INFOVIEW SYSTEMS INDIA PRIVATE LIMITED",
"INFOVIRGIN TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"INFOVISION LABS INDIA PRIVATE LIMITED",
"INFOVISION SOLUTIONS PRIVATE LIMITED",
"INFOVISION TECHNOLOGIES PRIVATE LIMITED",
"INFOVITY INDIA PRIVATE LIMITED",
"INFOWAY TECHNOSOFT SOLUTIONS PRIVATE LIMITED",
"INFOWAYZ GLOBAL SOLUTIONS PRIVATE LIMITED",
"INFOWEAVE ANALYTICS PRIVATE LIMITED",
"INFOWHIZ SOFTECH PRIVATE LIMITED",
"INFOWORKS DATA PRIVATE LIMITED",
"INFOWORLD CONSULTANCY PRIVATE LIMITED",
"INFOWORLD TECHNOLOGIES PRIVATE LIMITED",
"INFO-X SOFTWARE TECHNOLOGY PRIVATE LIMITED",
"INFOXEN TECHNOLOGIES INDIA PRIVATE LIMITED",
"INFOXERON TECHNOLOGIES PRIVATE LIMITED",
"INFOZEAL ESOLUTIONS PRIVATE LIMITED",
"INFOZECH SOFTWARE PRIVATE LIMITED",
"INFOZIANT IT SOLUTIONS PRIVATE LIMITED",
"INFOZIUM SOLUTIONS PRIVATE LIMITED",
"INFOZZLE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"INFRA 13 PRIVATE LIMITED",
"INFRA AKASHVISION TOWER PRIVATE LIMITED",
"INFRA BAZAAR PRIVATE LIMITED",
"INFRA COOL PRIVATE LIMITED",
"INFRA DEL PROJECTS PRIVATE LIMITED",
"INFRA ELEVATORS INDIA PRIVATE LIMITED",
"INFRA ENGINEERS INDIA PRIVATE LIMITED",
"INFRA EQUIP PRIVATE LIMITED",
"INFRA FINE FOODS PRIVATE LIMITED",
"INFRA INDIA CONSTRUCTION PRIVATE LIMITED",
"INFRA INSTRUMENTS PRIVATE LIMITED",
"INFRA PHARMACEUTICALS PRIVATE LIMITED",
"INFRA PRIME LOGISTIC TECHNOLOGIES PRIVATE LIMITED",
"INFRA STEEL CAST PVT LTD",
"INFRAA SSHINE PRIVATE LIMITED",
"INFRABEAT TECHNOLOGIES PRIVATE LIMITED",
"INFRACAP INDIA ADVISERS PRIVATE LIMITED",
"INFRACLOUD TECHNOLOGIES PRIVATE LIMITED",
"INFRACON",
"INFRACON ENGINEERING SERVICES INDIA PRIVATE LIMITED",
"INFRAEN INDIA PRIVATE LIMITED",
"INFRAHEALTH INDIA PRIVATE LIMITED",
"INFRAHEDGE SERVICES INDIA PRIVATE LIMITED",
"INFRAINCART INNOVATIONS PRIVATE LIMITED",
"INFRAIT TECHNOLOGIES PRIVATE LIMITED",
"INFRAKING CONSULTING ENGINEERS PRIVATE LIMITED",
"INFRAKNIT TECHNOLOGIES PRIVATE LIMITED",
"INFRALINE TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"INFRAMAN VENTURES LLP",
"INFRAMART REALTECH INDIA PRIVATE LIMITED",
"INFRAMAT ALLOYS PRIVATE LIMITED",
"INFRAMAT INDUSTRIES PRIVATE LIMITED",
"INFRAMATRIX CONSTRUCTION INDIA PRIVATE LIMITED",
"INFRAME MEDIA PRIVATE LIMITED",
"INFRAMECH POWER SOLUTIONS PRIVATE LIMITED",
"INFRAPLACES E-COMMERCE PRIVATE LIMITED",
"INFRAPLUS CONSULTING PRIVATE LIMITED",
"INFRAPRIME LOGISTICS TECHNOLOGIES PRIVATE LIMITED",
"INFRARED POWER IT SOLUTIONS PRIVATE LIMITED",
"INFRASCALE INDIA PRIVATE LIMITED",
"INFRASCAPE TECHNOLOGIES LIMITED",
"INFRASCHOOL SERVICES CHINTAMANI PRIVATE LIMITED",
"INFRASCHOOL SERVICES GURGAON PRIVATE LIMITED",
"INFRASCHOOL SERVICES KADIRI PRIVATE LIMITED",
"INFRASCHOOL SERVICES KORBA PRIVATE LIMITED",
"INFRASCHOOL SERVICES TUMKUR PRIVATE LIMITED",
"INFRASCOM SOLUTIONS PRIVATE LIMITED",
"INFRASKY SOLUTIONS PRIVATE LIMITED",
"INFRASOFT TECHNOLOGIES LIMITED",
"INFRASOUL TECHSERVE PRIVATE LIMITED",
"INFRASSIST TECHNOLOGIES PRIVATE LIMITED",
"INFRASTIL GLOBAL IMPEX PRIVATE LIMITED",
"INFRASTRUCTURE ADVISORS PRIVATE LIMITED",
"INFRASTRUCTURE DESIGN CONSULTANTS PRIVATE LIMITED",
"INFRASTRUCTURE DEVELOPMENT CONSULTANTS",
"INFRASTRUCTURE DEVELOPMENT CORPORATION KARNATAKA LIMITED",
"INFRASTRUCTURE ENGINEERING PROJECTS INDIA PRIVATE LIMITED",
"INFRASTRUCTURE LOGISTIC SYSTEMS LIMITED",
"INFRASTRUCTURE LOGISTICS PRIVATE LIMITED",
"INFRASUPPORT ENGINEERING CONSULTANTS PRIVATE LIMITED",
"INFRASUPPORT PROJECTS PRIVATE LIMITED",
"INFRASYS CONSULTING AND ADVISORY PRIVATE LIMITED",
"INFRASYSS TECHNO CONSULTANTS PRIVATE LIMITED",
"INFRAVOLT POWER PRIVATE LIMITED",
"INFRES METHODEX PRIVATE LIMITED",
"INFRONT ENTERPRISES PRIVATE LIMITED",
"INFROVATE CONSULTIND AND SOLUTIONS PRIVATE LIMITED",
"INFRRD PRIVATE LIMITED",
"INFRUIT EVENTS PRIVATE LIMITED",
"INFRUIT TRAVELS PRIVATE LIMITED",
"INFUGEN PHARMA PRIVATE LIMITED",
"INFURGO INTERIORS (OPC) PRIVATE LIMITED",
"INFUSE CONSULTING INDIA PRIVATE LIMITED",
"INFUSED SYSTEMS PRIVATE LIMITED",
"INFYMART RETAILS PRIVATE LIMITED",
"INFYNEX BUSINESS SERVICES PRIVATE LIMITED",
"INFYNIX DATA SERVICES PRIVATE LIMITED",
"INFYSEC SOLUTIONS PRIVATE LIMITED",
"INFYSHINE TECHNOLOGIES PRIVATE LIMITED",
"INFYSTRAT SOFTWARE SERVICES PRIVATE LIMITED",
"INFYTECH SOLUTIONS PRIVATE LIMITED",
"INFYZ SOLUTIONS PRIVATE LIMITED",
"ING SATCOM LIMITED",
"INGA ADVISORS PRIVATE LIMITED",
"INGA LABORATORIES PRIVATE LIMITED",
"INGA VENTURES PRIVATE LIMITED",
"INGAR ELECTRONICS PRIVATE LIMITED",
"INGARAN BIOTECH PRIVATE LIMITED",
"INGECO GEARS PRIVATE LIMITED",
"INGEM HOTELS AND RESTAURANTS PRIVATE LIMITED",
"INGEN TECHNOLOGIES PRIVATE LIMITED",
"INGENE ORGANICS PRIVATE LIMITED",
"INGENERO TECHNOLOGIES INDIA PRIVATE LIMITED",
"INGENIA POLYMERS INDIA PRIVATE LIMITED",
"INGENICO INTERNATIONAL INDIA PRIVATE LIMITED",
"INGENIO TECHNOLOGIES PRIVATE LIMITED",
"INGENIOCRATS PRIVATE LIMITED",
"INGENIOUS APPLIANCES & PACKAGING PRIVATE LIMITED",
"INGENIOUS BPO PRIVATE LIMITED",
"INGENIOUS CARBON PRIVATE LIMITED",
"INGENIOUS CONSTRUCTION EQUIPMENTS PRIVATE LIMITED",
"INGENIOUS CONSULTANTS SERVICES (POWER AND TRANSPORTATION)P. LTD",
"INGENIOUS CORPORATE SOLUTIONS PRIVATE LIMITED",
"INGENIOUS E-BRAIN SOLUTIONS PRIVATE LIMITED",
"INGENIOUS HR SOLUTIONS INDIA PRIVATE LIMITED",
"INGENIOUS INDUSTRIES PRIVATE LIMITED",
"INGENIOUS MANAGEMENT SERVICES",
"INGENIOUS MEDTECH PRIVATE LIMITED",
"INGENIOUS NETSOFT PRIVATE LIMITED",
"INGENIOUS PLASTICS PRIVATE LIMITED",
"INGENIOUS SAGGI SOLUTIONS PRIVATE LIMITED",
"INGENIOUS STUDIO PRIVATE LIMITED",
"INGENIUM INFRASTRUCTURE PRIVATE LIMITED",
"INGENIUM TELECOMMUNICATION PRIVATE LIMITED",
"INGENS TRADECOM PRIVATE LIMITED",
"INGENUITY AND INNOVATION GLOBAL AGROTECH PRIVATE LIMITED",
"INGENUITY AND INNOVATION GLOBAL EDUTECH PRIVATE LIMITED",
"INGENUITY AND INNOVATION GLOBAL INFRASTRUCTURE PRIVATE LIMITED",
"INGENUITY BIOSCIENCES PRIVATE LIMITED",
"INGENUITY GAMING PRIVATE LIMITED",
"INGENX TECHNOLOGY PRIVATE LIMITED",
"INGERSOLL - RAND TECHNOLOGIES AND SERVICES PRIVATE LIMITED",
"INGERSOLL-RAND INDIA LIMITED",
"INGERSOLL-RAND INTERNATIONAL INDIA PRIVATE LIMITED",
"INGETEAM INDIA PRIVATE LIMITED",
"INGETEAM POWER TECHNOLOGY INDIA PRIVATE LIMITED",
"INGEVITY INDIA PRIVATE LIMITED",
"INGEX LAB PRIVATE LIMITED",
"INGINIT TECHNOLOGY PRIVATE LIMITED",
"INGKA CENTRES INDIA PRIVATE LIMITED",
"INGKA SERVICES LLP",
"INGLENOOK HOME DECOR SOLUTIONS PRIVATE LIMITED",
"INGNIUS SYSTEMS PRIVATE LIMITED",
"INGO ELECTRIC PRIVATE LIMITED",
"INGOLD SOLUTIONS PRIVATE LIMITED",
"INGOLE TRADERS",
"INGRAHAM INTER COLLEGE",
"INGRAIN ARCHITECT",
"INGRAIN CONSULTING SERVICES PRIVATE LIMITED",
"INGRAIN SYSTEMS PRIVATE LIMITED",
"INGRAM MICRO INDIA PRIVATE LIMITED",
"INGRAM MICRO INDIA SSC PRIVATE LIMITED",
"INGRAVITY PETROCHEM PRIVATE LIMITED",
"INGREDION INCORPORATED",
"INGREDION INDIA PRIVATE LIMITED",
"INGRESS AUTOVENTURES (INDIA) PRIVATE LIMITED",
"IN-GROUP DEVELOPERS LLP",
"INGROW HOSPITALITY PRIVATE LIMITED",
"INGSOPHY CONSULTANTS PRIVATE LIMITED",
"INGUN INDIA PRIVATE LIMITED",
"INGURAN SORTING TECHNOLOGIES LLP",
"INGWENYA MINERAL TECH PRIVATE LIMITED",
"INH BROADCASTING PRIVATE LIMITED",
"INHABIT INDIA PRIVATE LIMITED",
"INHAWK IT SOLUTIONS PRIVATE LIMITED",
"INHERITX SOLUTIONS PRIVATE LIMITED",
"INHIBEO WATER SOLUTION AND TECHNOLOGIES PRIVATE LIMITED",
"INHOUSE HANDICRAFTS PRIVATE LIMITED",
"INHS ASVINI",
"INI CONSULTING PRIVATE LIMITED",
"INI CUSTOMER SERVICES PRIVATE LIMITED",
"INI DESIGN STUDIO PRIVATE LIMITED",
"INI FARMS PRIVATE LIMITED",
"INI INFRASTRUCTURE & ENGINEERING PRIVATE LIMITED",
"INICIAR FINANCIAL SERVICES PRIVATE LIMITED",
"INICUS TECH SOLUTIONS AND SERVICES PRIVATE LIMITED",
"INIGMA AIR PRIVATE LIMITED",
"INIQUUS IT SERVICES PRIVATE LIMITED",
"INIS MARKETING SERVICES PRIVATE LIMITED",
"INISHIA MEDIA PRIVATE LIMITED",
"INITECH SOFTWARE SOLUTIONS PRIVATE LIMITED",
"INITIATEFIRST INFORMATION SERVICES PRIVATE LIMITED",
"INITIATIVE DATA SYSYTEM PRIVATE LIMITED",
"INITIATIVE MEDIA (INDIA) PRIVATE LIMITED",
"INITIO EDUCATIONAL PLANNERS PRIVATE LIMITED",
"INITIUM PRODUCTIONS PRIVATE LIMITED",
"INITNINE CONSULTANTS (OPC) PRIVATE LIMITED",
"INITOR GLOBAL ACCOUNTEX PRIVATE LIMITED",
"INITUS HR CONSULTING PRIVATE LIMITED",
"INIXY POWER SOLUTION PRIVATE LIMITED",
"INIZ PLASTOMECH PRIVATE LIMITED",
"INIZIO BUSINESS SERVICES PRIVATE LIMITED",
"INJ MARKET INTELLIGENCE PRIVATE LIMITED",
"INJALA PRIVATE LIMITED",
"INJECT CARE PARENTERALS PRIVATE LIMITED",
"INJECTO POLYMERS PRIVATE LIMITED",
"INJECTOPLAST PRIVATE LIMITED",
"INJOTECH INDIA PRIVATE LIMITED",
"INK BLING DESIGNS PRIVATE LIMITED",
"INK GRAPH TECHNO PRIVATE LIMITED",
"INK IT SOLUTIONS AND CONSULTING PRIVATE LIMITED",
"INK SCIENCE PRIVATE LIMITED",
"INKA HOMEKARFTS PRIVATE LIMITED",
"INKAL VENTURES PRIVATE LIMITED",
"INKARP INSTRUMENTS PRIVATE LIMITED",
"INKARP TELECOM INDIA PRIVATE LIMITED",
"INKBIRD PACKAGING PRIVATE LIMITED",
"INKCRE MEDIA PRIVATE LIMITED",
"INKEL LIMITED",
"INKEL-EKK ROADS PRIVATE LIMITED",
"INKEL-KSIDC PROJECTS LIMITED",
"INKJET SOLUTIONS PRIVATE LIMITED.",
"INKOCEAN TECHNOLOGIES PRIVATE LIMITED",
"INKONIQ IT SOLUTIONS PRIVATE LIMITED",
"INKPOT PUBLICATIONS PRIVATE LIMITED",
"INKRITI SOLUTIONS PRIVATE LIMITED",
"INKSTREAM COLOUR PRIVATE LIMITED",
"INKSTUDIO INDIA PRIVATE LIMITED",
"INKWEST MANAGEMENT CONSULTANT INDIA PRIVATE LIMITED",
"INKWIRED TECHNOLOGIES PRIVATE LIMITED",
"INLAKS & BUDHRANI HOSPITAL",
"INLAND & COASTAL SHIPPING LIMITED",
"INLAND FINANCIAL SERVICES PRIVATE LIMITED",
"INLAND INDOORS",
"INLAND INFRASTRUCTURE DEVELOPERS PRIVATE LIMITED",
"INLAND MINES AND MINERALS PRIVATE LIMITED",
"INLAND POWER LIMITED",
"INLAND TEEVRA PRIVATE LIMITED",
"INLAND VIKASH LIMITED",
"INLAND WORLD LOGISTICS PRIVATE LIMITED",
"INLAY MARKETING PRIVATE LIMITED",
"INLEAD ELECTRONICS PRIVATE LIMITED",
"INLED TECHNOLOGIES LLP",
"INLIFE PHARMA PRIVATE LIMITED",
"INLINETECH NETWORK SOLUTIONS PRIVATE LIMITED",
"INLIST MANAGEMENT",
"INLITE FURNISHINGS PRIVATE LIMITED",
"INLOGIC TECHNOLOGIES PRIVATE LIMITED",
"INLOGSYS TECHNO PRIVATE LIMITED",
"INMAC COMPUTERS PRIVATE LIMITED",
"INMACO MARITIME COUNCIL",
"INMACS MANAGEMENT SERVICES LIMITED",
"INMAGE SYSTEMS PRIVATE LIMITED",
"INMAKE PANEL INDUSTRIES PRIVATE LIMITED",
"INMAR ENGINEERING SERVICES PRIVATE LIMITED",
"INMAR SHIPPING AND LOGISTICS PRIVATE LIMITED",
"INMAR TECHNOLOGIES PRIVATE LIMITED",
"INMARCO INDUSTRIES PRIVATE LIMITED",
"INMARK EXPORTS PRIVATE LIMITED",
"INMARSAT INDIA PRIVATE LIMITED",
"INMART COMMERCE PRIVATE LIMITED",
"INMASA TECHNAMIC SOLUTION PRIVATE LIMITED",
"INME LEARNING PRIVATE LIMITED",
"INMET TECHNOLOGY SOLUTION",
"INMILECABZ PRIVATE LIMITED",
"INMITO MEDITECH PRIVATE LIMITED",
"INMO FERTILIZERS & CHEMICALS PRIVATE LIMITED",
"INMOBI TECHNOLOGIES PRIVATE LIMITED",
"INMODE INDIA PRIVATE LIMITED",
"INMORPHIS SERVICES PRIVATE LIMITED",
"INN4SMART SOLUTIONS PRIVATE LIMITED",
"INNATE BIOTECH PRIVATE LIMITED",
"INNATE METRICS BUSINESS INSIGHTS LLP",
"INNAYA TEX PRIVATE LIMITED",
"INNCA STUDIO PRIVATE LIMITED",
"INNCON INFRASTRUCTURES PRIVATE LIMITED",
"INNCREWIN TECHNOLOGIES PRIVATE LIMITED",
"INNDEV ENGINEERS (INDIA) PRIVATE LIMITED",
"INNDUS INSTITUTIONAL MARKETING PRIVATE LIMITED",
"INNEATE HUB PRIVATE LIMITED",
"INNEFU LABS PRIVATE LIMITED",
"INNER CHALLENGES PRIVATE LIMITED",
"INNER CITY PROJECTS PRIVATE LIMITED",
"INNER ENGINEERING PRODUCTS & SYSTEMS PRIVATE LIMITED",
"INNER EXPORTS PRIVATE LIMITED",
"INNER EYE COMMUNICATIONS PRIVATE LIMITED",
"INNER MERCANTILE PRIVATE LIMITED",
"INNER URBAN INFRAESTATE PRIVATE LIMITED",
"INNER VOICE CONSULTANCY PRIVATE LIMITED",
"INNERGIZE SOLUTIONS PRIVATE LIMITED",
"INNERVE POWER SOLUTIONS PRIVATE LIMITED",
"IN-NET INDIA PRIVATE LIMITED",
"IN-NETINDIA PRIVATE LIMITED",
"INNGREEN NATURE'S HERB PRIVATE LIMITED",
"INNISFREE COSMETICS INDIA PRIVATE LIMITED",
"INNITI ALLIANCE PRIVATE LIMITED",
"INNIVE BUSINESS SOLUTIONS PRIVATE LIMITED",
"INNKEY INFOSYSTEMS PRIVATE LIMITED",
"INNLIFE DISTRIBUTORS INDIA PRIVATE LIMITED",
"INNO COLOR AND COMPOUNDS PVT LTD",
"INNO FAB (INDIA) PRIVATE LIMITED",
"INNO INSTRUMENT INDIA PRIVATE LIMITED",
"INNO STEELS PRIVATE LIMITED",
"INNO TRANSVENTIVE INDIA PRIVATE LIMITED",
"INNOACTIVE INTELLIGENCE LLP",
"INNOAGE-TECHNOLOGIES PRIVATE LIMITED",
"INNOAPPS TECHNOLOGIES PRIVATE LIMITED",
"INNOBEV SOLUTIONS PRIVATE LIMITED",
"INNOBIT SYSTEMS PRIVATE LIMITED",
"INNOBOT SYSTEMS PRIVATE LIMITED",
"INNOBOX SYSTEMS PRIVATE LIMITED",
"INNOCEAN WORLDWIDE COMMUNICATION PRIVATE LIMITED",
"INNOCENT HEARTS SCHOOL",
"INNOCENT MERCHANDISE PVT. LTD.",
"INNOCENT TRADERS LTD",
"INNOCENTER AGRITECH PRIVATE LIMITED",
"INNOCEPT EVENT STUDIO PRIVATE LIMITED",
"INNOCEPTS SOLUTIONS PRIVATE LIMITED",
"INNOCOAT SYSTEMS (INDIA) PRIVATE LIMITED",
"INNOCOM ELECTRONICS INDIA PRIVATE LIMITED",
"INNOCON ENGINEERING AND CONSTRUCTION PRIVATE LIMITED",
"INNOCOOL RUBBER PRIVATE LIMITED",
"INNOCORE SOLUTIONS PRIVATE LIMITED",
"INNOCORP LIMITED",
"INNOCTIVE TECHNOLOGIES PRIVATE LIMITED",
"INNOCULE MATERIALS AND ADDITIVES PRIVATE LIMITED",
"INNODATA INDIA PRIVATE. LIMITED",
"INNODEED SYSTEMS PRIVATE LIMITED",
"INNODEL TECHNOLOGIES PRIVATE LIMITED.",
"INNOERA SOFTWARE SOLUTIONS PRIVATE LIMITED",
"INNOESIS BUSINESS MANAGEMENT PRIVATE LIMITED",
"INNOFIED SOLUTION PRIVATE LIMITED",
"INNOFIN SOLUTIONS PRIVATE LIMITED",
"INNOFITT SYSTEM PRIVATE LIMITED",
"INNOFORGE PRIVATE LIMITED",
"INNOGROW TECHNOLOGIES LIMITED",
"INNOKAIZ INDIA LIMITED",
"INNOLIA ENERGY PRIVATE LIMITED",
"INNOLOGIX CONSULTING PRIVATE LIMITED",
"INNOMAC ENGINEERING INDUSTRIES PRIVATE LIMITED",
"INNOMASCH MEDIA PRIVATE LIMITED",
"INNOMAX IT SOLUTIONS PRIVATE LIMITED",
"INNOMEDIA TECHNOLOGIES PRIVATE. LIMITED",
"INNOMET ADVANCED MATERIALS LIMITED",
"INNOMICK TECHNOLOGY PRIVATE LIMITED",
"INNOMINDS SOFTWARE PRIVATE LIMITED",
"INNOMINDS SOFTWARE SEZ INDIA PRIVATE LIMITED",
"INNO-NU CHEM PRIVATE LIMITED",
"INNOPAC CROWNPACKAGING PRIVATE LIMITED",
"INNOPARK INDIA PRIVATE LIMITED",
"INNOPAY TECHNOLOGIES PRIVATE LIMITED",
"INNOPHARM HEALTHCARE PRIVATE LIMITED",
"INNOPLATS INFOTECH PRIVATE LIMITED",
"INNOPLEXUS CONSULTING SERVICES PRIVATE LIMITED",
"INNOPOLIS BIO INNOVATIONS PRIVATE LIMITED",
"INNOPPL IT SERVICES PRIVATE LIMITED",
"INNOPPL TECHNOLOGIES PRIVATE LIMITED",
"INNOPRO TRADE SOURCES (OPC) PRIVATE LIMITED",
"INNOPROP SPACES PRIVATE LIMITED",
"INNORAFT SOLUTIONS PRIVATE LIMITED",
"INNOREX PHARMACEUTICALS PRIVATE LIMITED",
"INNORIC SOLUTIONS PRIVATE LIMITED",
"INNOSERV SOLUTIONS PRIVATE LIMITED",
"INNOSERVE TECHSOL PRIVATE LIMITED",
"INNOSOLV CONSULTANCY SERVICES PRIVATE LIMITED",
"INNOSPACE AUTOMATION SERVICES PRIVATE LIMITED",
"INNOSPEC LIMITED",
"INNOSTAX SOFTWARE LABS PRIVATE LIMITED",
"INNOSTRIDE CONSULTING LLP",
"INNOSYN LIFE SCIENCES PRIVATE LIMITED",
"INNOTEC POWERSYS PRIVATE LIMITED",
"INNOTECH ADVANCE MACHINES PRIVATE LIMITED",
"INNOTECH DISTRIBUTORS PRIVATE LIMITED",
"INNOTECH ENGINEERING CONSULT PRIVATE LIMITED",
"INNOTECH HEALTHCARE PRIVATE LIMITED",
"INNOTECH INTERNATIONAL PRIVATE LIMITED",
"INNOTECH MACHINERY PRIVATE LIMITED",
"INNOTECH PACKAGING PRIVATE LIMITED",
"INNOTEK INDUSTRIES PRIVATE LIMITED",
"INNOTERRA BIOSCIENCE PRIVATE LIMITED",
"INNOTERRA PLATFORM PRIVATE LIMITED",
"INNOTEX (INDIA) PRIVATE LIMITED",
"INNOTHOUGHTS SYSTEMS PRIVATE LIMITED",
"INNOTION HOMES PRIVATE LIMITED",
"INNOTION INFRATECH PRIVATE LIMITED",
"INNOTRONICS TECHNOLOGIES PRIVATE LIMITED",
"INNOTRONIX LABS & TRADING PRIVATE LIMITED",
"INNOV ENGINEERING PRIVATE LIMITED",
"INNOV8 CAFFEINE WORKS PRIVATE LIMITED",
"INNOVA",
"INNOVA AGRI BIO PARK PRIVATE LIMITED",
"INNOVA AM TECH PRIVATE LIMITED",
"INNOVA CAPTAB",
"INNOVA CAPTAB LIMITED",
"INNOVA INTERNATIONAL PRIVATE LIMITED",
"INNOVA POLYPAK PRIVATE LIMITED",
"INNOVA PRINTING AND PACKAGING COMPANY PRIVATE LIMITED",
"INNOVA REMEDIES PRIVATE LIMITED",
"INNOVA RUBBERS PRIVATE LIMITED",
"INNOVA SOLUTIONS PRIVATE LIMITED",
"INNOVA SYSTEMS",
"INNOVA SYSTEMS INDIA PRIVATE LIMITED",
"INNOVA TECHNO PRODUCTS PRIVATE LIMITED",
"INNOVA TELECOM PRIVATE LIMITED",
"INNOVAC AIR SYSTEMS PRIVATE LIMITED",
"INNOVACCER ANALYTICS PRIVATE LIMITED",
"INNOVACION RETAIL PRIVATE LIMITED",
"INNOVACX TECH LABS PRIVATE LIMITED",
"INNOVAD MEDITECH PRIVATE LIMITED",
"INNOVAGE FINTECH PRIVATE LIMITED",
"INNOVAL DIGITAL SOLUTIONS PRIVATE LIMITED",
"INNOVALANCE LEARNING SYSTEMS PRIVATE LIMITED",
"INNOVALUS TECHNOLOGIES PRIVATE LIMITED",
"INNOVAN TECHNOLOGIES PRIVATE LIMITED",
"INNOVANA FITNESS LABS LIMITED",
"INNOVANA INFRASTRUCTURE LIMITED",
"INNOVANA TECHLABS LIMITED",
"INNOVANA THINKLABS LIMITED",
"INNOVANCE ELEVATORS SOLUTIONS PRIVATE LIMITED",
"INNOVANO TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"INNOVANT SERVICES PRIVATE LIMITED",
"INNOVAPATH IT SOLUTIONS PRIVATE LIMITED",
"INNOVAPOINT INFOTECH PRIVATE LIMITED",
"INNOVAPPTIVE GLOBAL SOLUTIONS PRIVATE LIMITED",
"INNOVAR CONSULTANCY PRIVATE LIMITED",
"INNOVARCH ARCHITECTS INDIA PRIVATE LIMITED",
"INNOVARE LABS PRIVATE LIMITED",
"INNOVARE MANAGEMENT INDIA PRIVATE LIMITED",
"INNOVARE RETAILS PRIVATE LIMITED",
"INNOVASSYNTH TECHNOLOGIES INDIA LIMITED",
"INNOVATE B2B PRIVATE LIMITED",
"INNOVATE DESIGNERS & BUILDERS PRIVATE LIMITED",
"INNOVATE OPERATIONS (INDIA) PRIVATE LIMITED",
"INNOVATE SEARCH PRIVATE LIMITED",
"INNOVATE SECURITIES PVT LTD",
"INNOVATE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"INNOVATECH ENVIRO SYSTEMS & SERVICES PRIVATE LIMITED",
"INNOVATECH SWITCHING POWER INDIA PRIVATE LIMITED",
"INNOVATED HOSPITALITY SERVICES (INDIA) PRIVATE LIMITED",
"INNOVATIA INDIA IT & KNOWLEDGE SOLUTIONS PRIVATE LIMITED",
"INNOVATIA INDIA KNOWLEDGE MANAGEMENT SERVICES PRIVATE LIMITED",
"INNOVATILY PRIVATE LIMITED",
"INNOVATION BEYOND IMAGINATION RESEARCH SOLUTIONS PRIVATE LIMITED",
"INNOVATION COATINGS PRIVATE LIMITED",
"INNOVATION DIAGNOSTIC LABS PRIVATE LIMITED",
"INNOVATION ENDEAVORS INDIA PRIVATE LIMITED",
"INNOVATION FILTER SYSTEMS PRIVATE LIMITED",
"INNOVATION GLASS (INDIA) PRIVATE LIMITED",
"INNOVATION HEALTHCARE DIAGNOSTICS PRIVATE LIMITED",
"INNOVATION HOUSE INDUSTRIES PRIVATE LIMITED",
"INNOVATION IMAGING TECHNOLOGIES PRIVATE LIMITED",
"INNOVATION INNOVA CNC PRIVATE LIMITED",
"INNOVATION MANPOWER SOLUTIONS",
"INNOVATION MEDITECH PRIVATE LIMITED",
"INNOVATION MODULAR SYSTEM PRIVATE LIMITED",
"INNOVATION SOLAR POWER PRIVATE LIMITED",
"INNOVATION TECHNOLOGY BY DESIGN PRIVATE LIMITED",
"INNOVATION TRAVELS PRIVATE LIMITED",
"INNOVATION TRIGGERS MGMT PRIVATE LIMITED",
"INNOVATION WATER TREATMENTS AND RECOVERY SERVICES PRIVATE LIMITED",
"INNOVATIONM MOBILE AND WEB TECHNOLOGIES PRIVATE LIMITED",
"INNOVATIONS GARMENT PRIVATE LIMITED",
"INNOVATIONS INDIA INN",
"INNOVATIONS MEDIRESEARCH PRIVATE LIMITED",
"INNOVATIV BIOSCIENCES PRIVATE LIMITED",
"INNOVATIVE 3D PRINTING SOLUTIONS LLP",
"INNOVATIVE ABSOLUTE SERVICE PRIVATE LIMITED",
"INNOVATIVE ADCOM PRIVATE LIMITED",
"INNOVATIVE ADVANCED MEDIA MANAGEMENT PRIVATE LIMITED",
"INNOVATIVE AND TECHNOLOGICAL LEARNING SERVICES PRIVATE LIMITED",
"INNOVATIVE ANTARES PRIVATE LIMITED",
"INNOVATIVE AQUA SYSTEMS PRIVATE LIMITED",
"INNOVATIVE AUTOCORP PRIVATE LIMITED",
"INNOVATIVE AUTOMATION PRIVATE LIMITED",
"INNOVATIVE AVIATION PRIVATE LIMITED",
"INNOVATIVE B2B LOGISTICS SOLUTIONS PRIVATE LIMITED",
"INNOVATIVE BATH INDIA PRIVATE LIMITED",
"INNOVATIVE BUILD CARE SOLUTIONS PRIVATE LIMITED",
"INNOVATIVE CHANGE COLLABORATIVE SERVICES PRIVATE LIMITED",
"INNOVATIVE CLAD SOLUTIONS PRIVATE LIMITED",
"INNOVATIVE CLEANING SYSTEMS PRIVATE LIMITED",
"INNOVATIVE CODES (I) PRIVATE LIMITED",
"INNOVATIVE COLLEGE OF PHARMACY",
"INNOVATIVE COMPONENTS PRIVATE LIMITED",
"INNOVATIVE CONCEPTS PRIVATE LIMITED",
"INNOVATIVE CONSTRUCTION CONTRACTORS AND ENGINEERS PRIVATE LIMITED",
"INNOVATIVE COOLING SOLUTIONS PRIVATE LIMITED",
"INNOVATIVE COVERAGE SOLUTIONS PRIVATE LIMITED",
"INNOVATIVE CRANE SOLUTIONS PRIVATE LIMITED",
"INNOVATIVE CUISINE PRIVATE LIMITED",
"INNOVATIVE DEALERS PVT LTD",
"INNOVATIVE DISTRIBUTIONS SERVICE PRIVATE LIMITED",
"INNOVATIVE EDUCATION NETWORK PRIVATE LIMITED",
"INNOVATIVE EMM CARE PRIVATE LIMITED",
"INNOVATIVE ENERPRO PRIVATE LIMITED",
"INNOVATIVE ENGINEERING PRODUCTS PRIVATE LIMITED",
"INNOVATIVE ENGINEERS INDIA PRIVATE LIMITED",
"INNOVATIVE ENTERPRISES PVT LIMITED.",
"INNOVATIVE ENVIRONMENTAL TECHNOLOGIES PRIVATE LIMITED",
"INNOVATIVE E-TECH PRIVATE LIMITED",
"INNOVATIVE EXPLICATION PRIVATE LIMITED",
"INNOVATIVE FACILITY SERVICES PRIVATE LIMITED",
"INNOVATIVE FACILITY SOLUTIONS PRIVATE LIMITED",
"INNOVATIVE FASTENERS AND AUTOCOMP PRIVATE LIMITED",
"INNOVATIVE FILM ACADEMY PRIVATE LIMITED (OPC)",
"INNOVATIVE FINANCE AND ACCOUNTING SERVICES INDIA PRIVATE LIMITED",
"INNOVATIVE FINANCIAL ADVISORS PRIVATE LIMITED",
"INNOVATIVE FLEXOTECH PRIVATE LIMITED",
"INNOVATIVE FOAM LIMITED",
"INNOVATIVE FOODS LIMITED",
"INNOVATIVE GENERALIST PRIVATE LIMITED",
"INNOVATIVE GLOBETEK PRIVATE LIMITED",
"INNOVATIVE GRAVURE PRIVATE LIMITED",
"INNOVATIVE GROUP CONFERENCE & EVENT SOLUTIONS PRIVATE LIMITED",
"INNOVATIVE HEALING SYSTEMS (INDIA) PRIVATE LIMITED",
"INNOVATIVE HOMES & DEVELOPERS PRIVATE LIMITED",
"INNOVATIVE HOUSING AND INFRASTRUCTURE PRIVATE LIMITED",
"INNOVATIVE IDEALS AND SERVICES INDIA LIMITED",
"INNOVATIVE INCENTIVES & REWARDS PRIVATE LIMITED",
"INNOVATIVE INDIA BUILDWELL COMPANY PRIVATE LIMITED",
"INNOVATIVE INDUSTRIES PRIVATE LIMITED",
"INNOVATIVE INFOCOM & IT PARKS PRIVATE LIMITED",
"INNOVATIVE INFORMATION TECHNOLOGY PVT LTD",
"INNOVATIVE INFRAPLUS INDIA LIMITED",
"INNOVATIVE INFRAPROJECTS PRIVATE LIMITED",
"INNOVATIVE INFRASTRUCTURE PRIVATE LIMITED",
"INNOVATIVE INSTRUMENT PVT LTD",
"INNOVATIVE INTERIORS PRIVATE LIMITED",
"INNOVATIVE INTERNATIONAL SCHOOL",
"INNOVATIVE LABEL SOLUTIONS PRIVATE LIMITED",
"INNOVATIVE LEARNING & LIVING NIRWANA HOSPITALITY SOLUTIONS PRIVATE LIMITED",
"INNOVATIVE LEATHER CREATIONS PRIVATE LIMITED",
"INNOVATIVE LIFE DISCOVERIES PRIVATE LIMITED",
"INNOVATIVE LIFESCIENCES PRIVATE LIMITED",
"INNOVATIVE LIGHTING DESIGNS LIMITED",
"INNOVATIVE LINEN COMPANY PRIVATE LIMITED",
"INNOVATIVE MEDIA & TRADE SOLUTIONS PRIVATE LIMITED",
"INNOVATIVE MEDICARE TECHNOLOGIES PRIVATE LIMITED",
"INNOVATIVE MICROFINANCE FOR POVERTY ALLEVIATION AND COMMUNITY TRANSFORMATION",
"INNOVATIVE MOTORS PRIVATE LIMITED",
"INNOVATIVE NON-DESTRUCTIVE TESTING SERVICES PRIVATE LIMITED",
"INNOVATIVE ORTHO-SURGICALS PRIVATE LIMITED",
"INNOVATIVE PACKTECH MACHINES PRIVATE LIMITED",
"INNOVATIVE PETROCHEMICAL ENGINEERING SERVICES PRIVATE LIMITED",
"INNOVATIVE PHARMA SOLUTIONS PRIVATE LIMITED",
"INNOVATIVE PHARMACY COLLEGE",
"INNOVATIVE PHARMATECH PRIVATE LIMITED",
"INNOVATIVE POLYCOATS PRIVATE LIMITED",
"INNOVATIVE POLYMERS PVT LTD",
"INNOVATIVE PREMIER LIGHTING PRIVATE LIMITED",
"INNOVATIVE PRE-PRESS AND PRINT PRIVATE LIMITED",
"INNOVATIVE PUBLIC SCHOOL & JR COLLEGE BORAWADE",
"INNOVATIVE REIT PRIVATE LIMITED",
"INNOVATIVE RESEARCH SERVICES (INDIA) PRIVATE LIMITED",
"INNOVATIVE RESINS PRIVATE LIMITED",
"INNOVATIVE RESTAURANT PRIVATE LIMITED",
"INNOVATIVE RETAIL CONCEPTS PRIVATE LIMITED",
"INNOVATIVE ROADZTECH PRIVATE LIMITED",
"INNOVATIVE SALARY SERVICES AND PAYROLL ADVISORY PRIVATE LIMITED",
"INNOVATIVE SOLUTIONS INDIA PRIVATE LIMITED",
"INNOVATIVE SOLUTIONS TO TAXING PROBLEMS",
"INNOVATIVE SPECIALITY INGREDIENTS PRIVATE LIMITED",
"INNOVATIVE SYSTEMS & ROBOTICS INDIA PRIVATE LIMITED",
"INNOVATIVE SYSTEMS AND SOLUTIONS PRIVATE LIMITED",
"INNOVATIVE TECH PACK LIMITED",
"INNOVATIVE TECHCENTRE PRIVATE LIMITED",
"INNOVATIVE TECHHUB PRIVATE LIMITED",
"INNOVATIVE TECHNO PARK PRIVATE LIMITED",
"INNOVATIVE TECHNOLOGIES",
"INNOVATIVE TECHNOMICS PRIVATE LIMITED",
"INNOVATIVE TELECOM AND SOFTWARES PRIVATE LIMITED",
"INNOVATIVE TEXTILES LIMITED",
"INNOVATIVE THERAPEUTICS PRIVATE LIMITED",
"INNOVATIVE THERMAL ENGINEERING PRIVATE LIMITED",
"INNOVATIVE TRADELINK SERVICES PRIVATE LIMITED",
"INNOVATIVE TRANSGENICS PRIVATE LIMITED",
"INNOVATIVE TYRES & TUBES LIMITED",
"INNOVATIVE TYRES TUBES LIMITED",
"INNOVATIVE VASTUNIRMAN PRIVATE LIMITED",
"INNOVATIVIEW INDIA PRIVATE LIMITED",
"INNOVATOR FAB-TEX PRIVATE LIMITED",
"INNOVATORS CONSULTANTS PRIVATE LIMITED",
"INNOVATORS CONTRACTING WORKS PRIVATE LIMITED",
"INNOVATORS ELECTRIC SOLUTIONS PRIVATE LIMITED",
"INNOVATORS FACADE SYSTEMS LIMITED",
"INNOVATORS FACADE SYSTEMS PRIVATE LIMITED",
"INNOVATURE SOFTWARE LABS PRIVATE LIMITED",
"INNOVATUS AUTOMATION PRIVATE LIMITED",
"INNOVATUS ENTERTAINMENT NETWORKS LIMITED",
"INNOVCARE LIFESCIENCES PRIVATE LIMITED",
"INNOVECTURE PRIVATE LIMITED",
"INNOVED K-12 TECHNOLOGIES PRIVATE LIMITED",
"INNOVEDA BIOLOGICAL SOLUTIONS PRIVATE LIMITED",
"INNOVEL ENERGY SERVICES PRIVATE LIMITED",
"INNOVEN CAPITAL INDIA PRIVATE LIMITED",
"INNOVEN INFRACON PRIVATE LIMITED",
"INNOVENT ENGINEERING SOLUTIONS PRIVATE LIMITED",
"INNOVENT PANEL WORKS PRIVATE LIMITED",
"INDIQUBE SPACES PRIVATE LIMITED",
"INNOVENTES TECHNOLOGIES INDIA PRIVATE LIMITED",
"INNOVENTINDIA ENGINEERS PRIVATE LIMITED",
"INNOVENTUS PRIVATE LIMITED",
"INNOVER DIGITAL PRIVATE LIMITED",
"INNOVERTS NETWORK PRIVATE LIMITED",
"INNOVERVE INVENTIONS PRIVATE LIMITED",
"INNOVES ANIMAL HEALTH PRIVATE LIMITED",
"INNOVEST ADVISORY SERVICES PRIVATE LIMITED",
"INNOVEST AGROTECH PRIVATE LIMITED",
"INNOVEST HOSPITALITY MANAGEMENT SERVICES PRIVATE LIMITED",
"INNOVETIVE CHEMPLAST PRIVATE LIMITED",
"INNOVEXIA LIFE SCIENCES PRIVATE LIMITED",
"INNOVIAR SOLUTIONS PRIVATE LIMITED",
"INNOVINC ASPIRE INFRATECH SOLUTIONS PRIVATE LIMITED",
"INNOVINC EXIM PRIVATE LIMITED",
"INNOVINC REELS INDIA PRIVATE LIMITED",
"INNOVIOR RESEARCH PRIVATE LIMITED",
"INNOVIOUS HEALTHCARE PRIVATE LIMITED",
"INNOVIS TELECOM SERVICES INDIA PRIVATE LIMITED",
"INNOVIS TELECOM SERVICES PRIVATE LIMITED",
"INNOVISION BUILDING SAFETY AND SECURITY PRIVATE LIMITED",
"INNOVISION IMAGING PRIVATE LIMITED",
"INNOVISION LIMITED",
"INNOVISION SYSTEMS AND DEVICES PRIVATE LIMITED",
"INNOVISTA FEEDING SOLUTIONS PRIVATE LIMITED",
"INNOVISTA SENSORS INDIA PRIVATE LIMITED",
"INNOVIUM INDIA PRIVATE LIMITED",
"INNOVIUS DIGITAL PRIVATE LIMITED",
"INNOVIX FACILITY MANAGEMENT PRIVATE LIMITED",
"INNOVIXA SERVICES PRIVATE LIMITED",
"INNOVIZIA TECHNOLOGIES PRIVATE LIMITED",
"INNOVME SOLUTIONS PRIVATE LIMITED",
"INNOVOLUTE VENTURES PRIVATE LIMITED",
"INNOVOTEK PRIVATE LIMITED",
"INNOVSOURCE FACILITIES PRIVATE LIMITED",
"INNOVSPACE BUSINESS SOLUTIONS PRIVATE LIMITED",
"INNOVTTE PRIVATE LIMITED",
"INNOVURA MULTITRADE PRIVATE LIMITED",
"INNOVUS EDUSERVICES PRIVATE LIMITED",
"INNOVZS EMPOWERMENT SERVICES PRIVATE LIMITED",
"INNOWATTS ENERGY PRIVATE LIMITED",
"INNOWAVE IT INFRASTRUCTURES LIMITED",
"INNOWAYS HEALTH CARE INDIA PRIVATE LIMITED",
"INNOWEAVE PACKAGING SOLUTIONS PRIVATE LIMITED",
"INNOWELL ENGINEERING INTERNATIONAL PRIVATE LIMITED",
"INNOWIRELESS INDIA SERVICES PRIVATE LIMITED",
"INNOWISE GLOBAL TECHNOLOGY PRIVATE LIMITED",
"INNOWISE WEALTH MANAGEMENT PRIVATE LIMITED",
"INNOWORKS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"INNOWYZE GLOBAL SOLUTIONS OPC PRIVATE LIMITED",
"INNOX IMPEX PRIVATE LIMITED",
"INNOX PRECISION (I) PRIVATE LIMITED",
"INNOX STRUCTURAL SYSTEM PRIVATE LIMITED",
"INNROAD SOFTWARE DEVELOPMENT SERVICES PRIVATE LIMITED",
"INNSIGHT INTERACTIVE PRIVATE LIMITED",
"INNTECH IT SERVICES INTERNATIONAL PRIVATE LIMITED",
"INNTECHKNOW PRIVATE LIMITED",
"INNTOT TECHNOLOGIES PRIVATE LIMITED",
"INNUVIS SOLUTIONS PRIVATE LIMITED",
"INNVECTRA INFO SOLUTIONS PRIVATE LIMITED",
"INNVECTRA SOFTECH PRIVATE LIMITED",
"INN-VENUE HOSPITALITY MANAGEMENT PRIVATE LIMITED",
"INNVOCEPT GLOBAL SOLUTIONS PRIVATE LIMITED",
"INNVOLUTION HEALTHCARE PRIVATE LIMITED",
"INO TOOLTRIX SOLUTIONS OPC PRIVATE LIMITED",
"INOAPPS INDIA PRIVATE LIMITED",
"INOBLE INFOWAY PRIVATE LIMITED",
"INODAY CONSULTANCY SERVICES PRIVATE LIMITED",
"INODAYA PRECEPTORS PRIVATE LIMITED",
"INODE TECHNOLOGIES PRIVATE LIMITED",
"INOFINIX PRIVATE LIMITED",
"INOFLEX PRIVATE LIMITED",
"INOGENT LABORATORIES PRIVATE LIMITED",
"INOGIC TECH (INDIA) PRIVATE LIMITED",
"INOK COTTONS PRIVATE LIMITED",
"I-NOK ENTERTAINMENT PRIVATE LIMITED",
"INOMY MEDIA PRIVATE LIMITED",
"INON TECHNOLOGIES PRIVATE LIMITED",
"INONE SMART TECHNOLOGY (INDIA) PRIVATE LIMITED",
"INOOGA BUSINESS CONSULTING PRIVATE LIMITED",
"INOOGA SOLUTIONS PRIVATE LIMITED",
"INOPEN TECHNOLOGIES PRIVATE LIMITED",
"INOPS IT SOLUTIONS PRIVATE LIMITED",
"INORA BIOTECH PRIVATE LIMITED",
"INORBIT MALLS INDIA PRIVATE LIMITED",
"INORBVICT HEALTHCARE INDIA PRIVATE LIMITED",
"INORYASOFT PRIVATE LIMITED",
"INOS TECHNOLOGIES PRIVATE LIMITED",
"INOSYSTEK SOLUTIONS PRIVATE LIMITED",
"INOTECH SUPPLIES PRIVATE LIMITED",
"INOVA CAST PVT LTD",
"INOVAANTAGE SYSTEMS PRIVATE LIMITED",
"INOVAARE CLOUDS SOLUTIONS PRIVATE LIMITED",
"INOVAARE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"INOVALON INDIA PRIVATE LIMITED",
"INOVAMAX TECHNOLOGY PRIVATE LIMITED",
"INOVANCE TECHNOLOGY PRIVATE LIMITED",
"INOVAR FLOORS INDIA PRIVATE LIMITED",
"INOVARK TECHNOLOGIES PRIVATE LIMITED",
"INOVATIQ POLY PRINTING PRIVATE LIMITED",
"INOVATIVA WASTE AID AND MANAGEMENT PRIVATE LIMITED",
"INOVATIVE TECHNOCAST PRIVATE LIMITED",
"INOVET METALPRINT PRIVATE LIMITED",
"INOVIC CREATIONS PRIVATE LIMITED",
"INOVIC POWER SOLUTIONS PRIVATE LIMITED",
"INOVITIVI IDEAAZ PRIVATE LIMITED",
"INOVOA HOTELS AND RESORTS LIMITED",
"INOVONZ ENGINEERING PRIVATE LIMITED",
"INOVORA INFOSOL PRIVATE LIMITED",
"INOWAYS DESIGN ZONE PRIVATE LIMITED",
"INOX AIR PRODUCTS PRIVATE LIMITED",
"INOX BIOSCIENCE PRIVATE LIMITED",
"INOX DECOR PRIVATE LIMITED",
"INOX ENTERPRISES",
"INOX EXIM PRIVATE LIMITED",
"INOX GREEN ENERGY SERVICES LIMITED",
"INOX INDIA LIMITED",
"INOX LEASING AND FINANCE LIMITED",
"INOX LEISURE LIMITED",
"INOX METAPRODUCTS PRIVATE LIMITED",
"INOX RENEWABLES JAISALMER LIMITED",
"INOX RENEWABLES LIMITED",
"INOX SHIPPING AGENCIES (INDIA) PRIVATE LIMITED",
"INOX SUBMERSIBLES (I) PRIVATE LIMITED",
"INOX WIND ENERGY LIMITED",
"INOX WIND INFRASTRUCTURE SERVICES LIMITED",
"INOX WORKS & CONSULTANT PRIVATE LIMITED",
"INOX WORLD INDUSTRIES PRIVATE LIMITED",
"INOXCOLORZ PRIVATE LIMITED",
"INOXCORP INDIA PRIVATE LIMITED",
"INOXPA INDIA PRIVATE LIMITED",
"INP TECHNOLOGIES PRIVATE LIMITED",
"INPACK FABRICATIONS PRIVATE LIMITED",
"INPACK INDUSTRIES PRIVATE LIMITED",
"INPACK MACHINERIES (INDIA) PRIVATE LIMITED",
"INPACK PLAST PRIVATE LIMITED",
"INPARCO INDIA PRIVATE LIMITED",
"INPHASE ENERGY PRIVATE LIMITED",
"INPHLOX WATER SYSTEMS PRIVATE LIMITED",
"INPIXON INDIA LIMITED",
"INPLAY GAMING PRIVATE LIMITED",
"INPODS INDIA PRIVATE LIMITED",
"INPROCORP INDIA PRIVATE LIMITED",
"INPUT TAG SOFTWARE SOLUTIONS PRIVATE LIMITED",
"INPUT ZERO TECHNOLOGIES PRIVATE LIMITED",
"INQILAB ENGINEERING PRIVATE LIMITED",
"INQNEST MARKETING SOLUTIONS PRIVATE LIMITED",
"INQOGNITO INSIGHTS PRIVATE LIMITED",
"INQUBE INNOVATIONS PRIVATE LIMITED",
"INQUEST ADVISORIES PRIVATE LIMITED",
"INQUEST TECHNOLOGIES SOFTWARE PRIVATE LIMITED",
"INQUILAB OFFSET PRINTERS LIMITED",
"INQUILABINQNOD",
"INQUISITOR MEDIA ANALYSIS & DATA RESEARCH PRIVATE LIMITED",
"INQUIZITY METANOIA (OPC) PRIVATE LIMITED",
"INRAIN CONSTRUCTION PRIVATE LIMITED",
"IN-RDVS ELECTRICAL CONSULTING PRIVATE LIMITED",
"INRECO ENTERTAINMENT PRIVATE LIMITED",
"INRHYTHM ENERGY PRIVATE LIMITED",
"INRHYTHM SOLUTIONS PRIVATE LIMITED",
"INROAD TECHNO CONSULTANTS PRIVATE LIMITED",
"INS DATA SERVICES PRIVATE LIMITED",
"INS HAMLA",
"INSA UNITED HEAVY INDUSTRIES PRIVATE LIMITED",
"INSAI CHEMPLAST PRIVATE LIMITED",
"INSANE TATTOOS NAILS AND ACADEMY",
"INSANELY GREAT RETAILS PRIVATE LIMITED",
"INSAP ENGINEERS PRIVATE LIMITED",
"INSAT EQUIPMENT (INDIA) PRIVATE LIMITED",
"INSCO STEELS PRIVATE LIMITED",
"INSCOL ACADEMY LIMITED",
"INSCOL HEALTHCARE PRIVATE LIMITED",
"INSCOL HOSPITAL",
"INSCON MEDICAL SOLUTIONS PRIVATE LIMITED",
"INSCRIBE BPO PRIVATE LIMITED",
"INSCRIBE GRAPHICS LIMITED",
"INSCRIPTS I PRIVATE LIMITED",
"INSEARCH MANAGEMENT PRIVATE LIMITED",
"INSECTICIDES INDIA LIMITED",
"INSEL RECTIFIERS (INDIA) PRIVATE LIMITED",
"INSELI PARK JAINS PROJECTS PRIVATE LIMITED",
"INSEMI TECHNOLOGY SERVICES PRIVATE LIMITED",
"INSEPTRA INDIA PRIVATE LIMITED",
"INSERVIA INNOVATIONS PRIVATE LIMITED",
"INSERVIA PROPACK PRIVATE LIMITED",
"INSHA COTTEX PRIVATE LIMITED",
"INSHA FOREX AND TRAVELS PRIVATE LIMITED",
"INSHAPE PRECISION COMPONENT PRIVATE LIMITED",
"INSHORTS INDIA ADVERTISING AND SERVICES PRIVATE LIMITED",
"INSHORTS MEDIALABS PRIVATE LIMITED",
"INSIDE CONCEPTS PRIVATE LIMITED",
"INSIDE SALES AND SERVICES PRIVATE LIMITED",
"INSIDRSTALENT INTELLIGENCE PRIVATE LIMITED",
"INSIFE INDIA PRIVATE LIMITED",
"INSIGHT ALPHA RESEARCH & SOLUTIONS PRIVATE LIMITED",
"INSIGHT BOOKS PRIVATE LIMITED",
"INSIGHT BRANDCOM PRIVATE LIMITED",
"INSIGHT BUSINESS MACHINES PRIVATE LIMITED",
"INSIGHT CARE POLYPLAST PRIVATE LIMITED",
"INSIGHT COLLABORATIVE LOGISTICS PRIVATE LIMITED",
"INSIGHT CUSTOMER CALL SOLUTIONS LIMITED",
"INSIGHT DEVELOPMENT CONSULTING GROUP PRIVATE LIMITED",
"INSIGHT ENTERPRISES",
"INSIGHT ENTERPRISES INC.",
"INSIGHT GRAPHICS PRIVATE LIMITED",
"INSIGHT MALL DEVELOPERS PRIVATE LIMITED",
"INSIGHT MEDIA CITY INDIA PRIVATE LIMITED",
"INSIGHT MEDICAL DIAGNOSTICS HYDERABAD PRIVATE LIMITED",
"INSIGHT MODULARS PRIVATE LIMITED",
"INSIGHT OUTREACH PRIVATE LIMITED",
"INSIGHT PLM CONSULTING PRIVATE LIMITED",
"INSIGHT PRINT COMMUNICATIONS PRIVATE LIMITED",
"INSIGHT RADIOLOGY PRIVATE LIMITED",
"INSIGHT RESULTS SOLUTIONS PRIVATE LIMITED",
"INSIGHT TRAVELS & TOURS PRIVATE LIMITED",
"INSIGHTRA MEDICAL PRIVATE LIMITED",
"INSIGHTS OPINION PRIVATE LIMITED",
"INSIGHTS STRATEGIC BUSINESS PRIVATE LIMITED",
"INSIGHTS SUCCESS MEDIA AND TECHNOLOGY PRIVATE LIMITED",
"INSIGHTSMART LEARNING PRIVATE LIMITED",
"INSIGHTSOFTWARE INTERNATIONAL PRIVATE LIMITED",
"INSIGN TECHNOLOGY PRIVATE LIMITED",
"INSIGNE CARPETS PRIVATE LIMITED",
"INSIGNIA CLINICAL SERVICES PRIVATE LIMITED",
"INSIGNIA COMMUNICATIONS PRIVATE LIMITED",
"INSIGNIA HOSPITALITY PRIVATE LIMITED",
"INSIGNIA LEARNING PRIVATE LIMITED",
"INSIGNIA MEDISCRIPTS AND INFRA SOLUTIONS PRIVATE LIMITED",
"INSIGNIA RETREATS & SPAS PRIVATE LIMITED",
"INSIGNIAN HOME PRIVATE LIMITED",
"INSIGNO QUIPMENT TECHNOLOGIES INDIA PRIVATE LIMITED",
"INSIST SEARCH AND SELECTION SERVICES PRIVATE LIMITED",
"INSITE DIGITAL PRIVATE LIMITED",
"INSITEL SERVICES PRIVATE LIMITED",
"INSITUFORM PIPELINE REHABILITATION PRIVATE LIMITED",
"INSITUTE OF LIVER AND BILLARY SCIENCES",
"INSIZA TECHNOLOGIES PRIVATE LIMITED",
"INSKI SKILL PRIVATE LIMITED",
"INSNAP TECHNOLOGIES PRIVATE LIMITED",
"INSOFE EDUCATION PRIVATE LIMITED",
"INSOFT AUTOMATION PRIVATE LIMITED",
"INSOFT.COM PRIVATE LIMITED",
"INSOL TECHNOHEIGHT PRIVATE LIMITED",
"INSOLARE ENERGY PRIVATE LIMITED",
"INSOLATION ENERGY LIMITED",
"INSOLATION GREEN ENERGY PRIVATE LIMITED",
"INSOLOX SPORTS & INFRATECH PRIVATE LIMITED",
"INSOLVENCY PROFESSIONAL AGENCY OF INSTITUTE OF COST ACCOUNTANTS OF INDIA",
"INSOMNIACS DIGITAL PRIVATE LIMITED",
"INSONLINE INDIA PRIVATE LIMITED",
"INSONTIS TECHNOLOGIES PRIVATE LIMITED",
"INSOPIRE EVENTS AND TOURS OPC PRIVATE LIMITED",
"INSOTEX INDIA LIMITED",
"INSPACE TECHNOLOGIES PRIVATE LIMITED",
"INSPACKT PACKAGING PRIVATE LIMITED",
"INSPAN INFOTECH PRIVATE LIMITED",
"INSPARC TECHNOLOGIES PRIVATE LIMITED",
"INSPECS METROLOGY INDIA PRIVATE LIMITED",
"INSPECTION AND QUALITY CONTROL PRIVATE LIMITED",
"INSPECTION SURVEY & SURVEILLANCE (INDIA) PVT LTD",
"INSPECTOR OF REGISTRATION",
"INSPECTORATE GRIFFITH INDIA PRIVATE LIMITED",
"INSPEED POWER PRIVATE LIMITED",
"INSPEERO TECHNOLOGIES LLP",
"INSPEN TECHNOLOGY PRIVATE LIMITED",
"INSPHERE SOLUTIONS PRIVATE LIMITED",
"INSPIRA BIO-PHARM PRIVATE LIMITED",
"INSPIRA BUILDERS LIMITED LIABILITY PARTN ERSHIP",
"INSPIRA ENTERPRISE INDIA LIMITED",
"INSPIRAGE SOFTWARE CONSULTING PRIVATE LIMITED",
"INSPIRATION CONSTRUCTION PRIVATE LIMITED",
"INSPIRATION MAN POWER CONSULTANCY PRIVATE LIMITED",
"INSPIRATIONAL DEVELOPMENT GROUP LIMITED",
"INSPIRE CLEAN ENERGY PRIVATE LIMITED",
"INSPIRE DESIGNS & BRANDING SERVICES PRIVATE LIMITED",
"INSPIRE DIAMOND JEWELS PRIVATE LIMITED",
"INSPIRE EXIM PRIVATE LIMITED",
"INSPIRE FILMS LIMITED",
"INSPIRE FILMS PRIVATE LIMITED",
"INSPIRE FORMULATIONS PRIVATE LIMITED",
"INSPIRE INDIA WEALTH PRIVATE LIMITED",
"INSPIRE INDUSTRIES PRIVATE LIMITED",
"INSPIRE INFOSOL PRIVATE LIMITED",
"INSPIRE INFOTECH PRIVATE LIMITED",
"INSPIRE INFRATECH PRIVATE LIMITED",
"INSPIRE I-TECH SERVICES PRIVATE LIMITED",
"INSPIRE NETWORK TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"INSPIRE ONE CONSULTANTS PRIVATE LIMITED",
"INSPIRE TELECOM PRIVATE LIMITED",
"INSPIRE YOUTH DEVELOPMENT PRIVATE LIMITED",
"INSPIRED CONSULTANCY SERVICES PRIVATE LIMITED",
"INSPIRED CONTROL SYSTEMS PRIVATE LIMITED",
"INSPIRED LEADERSHIP GURUKUL",
"INSPIRED LIFESTYLES PRIVATE LIMITED",
"INSPIRED TECHNOLOGIES PRIVATE LIMITED",
"INSPIREDGE IT SOLUTIONS PRIVATE LIMITED",
"INSPIRELABS SOLUTIONS PRIVATE LIMITED",
"INSPIREON ENTERPRISES PRIVATE LIMITED",
"INSPIRETECH REALTY PRIVATE LIMITED",
"INSPIREXT CONSULTING INDIA PRIVATE LIMITED",
"INSPIRIL TECH SOLUTIONS PRIVATE LIMITED",
"INSPIRING AGRO LIMITED",
"INSPIRING POTENTIAL AGENCY",
"INSPIRISYS SOLUTIONS LIMITED",
"INSPIRIT LEARNING PRIVATE LIMITED",
"INSPIRIT VISION LLP",
"INSPIRON ENGINEERING PRIVATE LIMITED",
"INSPIRON I T SERVICES PRIVATE LIMITED",
"INSPIRON INFO SOLUTIONS INDIA PRIVATE LIMITED",
"INSPIRONLABS SOFTWARE SYSTEMS PRIVATE LIMITED",
"INSPIRRIA CLOUDTECH PRIVATE LIMITED",
"INSPIRUSEDUMENTORS PRIVATE LIMITED",
"INSPLUS PRIVATE LIMITED",
"INSPOP TECHNOLOGIES PRIVATE LIMITED ADMIRAL GRP",
"INSPOP.COM LIMITED",
"INSPRA MACHINERY AND AUTOMATION PRIVATE LIMITED",
"INSPREMAC INDUSTRIES PRIVATE LIMITED",
"INSPROS ENGINEERS PVT LTD",
"INSSEMBLE TECHNOLOGIES PRIVATE LIMITED",
"INST OF CHILD HEALTH AND GOVT HOSPI",
"INST OF OBSTERICS GYNAECO GOVT HOSP",
"INST OF SCIENCE DR B N PURANDARE COLL",
"INSTA CAPITAL PRIVATE LIMITED",
"INSTA CHEMI PRIVATE LIMITED",
"INSTA CONCRETEX PRIVATE LIMITED",
"INSTA CONTROL PRIVATE LIMITED",
"INSTA FASHION",
"INSTA ICT SOLUTIONS PRIVATE LIMITED",
"INSTA MARK PRIVATE LIMITED",
"INSTA POWER CONTROL AND EQUIPMENTS PRIVATE LIMITED",
"INSTA PRINT PACK PRIVATE LIMITED",
"INSTA TOURISM PRIVATE LIMITED",
"INSTA UTILITY CONSULTANT PRIVATE LIMITED",
"INSTABASE INDIA PRIVATE LIMITED",
"INSTABIZ SOLUTIONS INDIA PRIVATE LIMITED",
"INSTACAD SOLUTIONS (INDIA) PRIVATE LIMITED",
"INSTADAY FOODS AND BEVERAGES PRIVATE LIMITED",
"INSTAFARM PRODUCTS PRIVATE LIMITED",
"INSTAFLOOR INFRA PRIVATE LIMITED",
"INSTAHOT FOODS PRIVATE LIMITED",
"INSTA-HUMANS MANAGEMENT PRIVATE LIMITED",
"INSTAKART SERVICES PRIVATE LIMITED",
"INSTALLCO WIFY TECHNOLOGY PRIVATE LIMITED",
"INSTAMECH CONSTRUCTIONS PRIVATE LIMITED",
"INSTAMENTOR EDUCATION PRIVATE LIMITED",
"INSTAMOD AIR PIPE PRIVATE LIMITED",
"INSTAMOJO TECHNOLOGIES PRIVATE LIMITED",
"INSTANT AUTOGAS EQUIPMENTS MFG. PRIVATE LIMITED",
"INSTANT CABLE NETWORK PRIVATE LIMITED",
"INSTANT DEVELOPERS PVT LTD",
"INSTANT FABRICATIONS PRIVATE LIMITED",
"INSTANT FINSERVE PRIVATE LIMITED",
"INSTANT GLOBAL PAYTECH PRIVATE LIMITED",
"INSTANT HOLDINGS LIMITED",
"INSTANT IMPEX PRIVATE LIMITED",
"INSTANT PROCUREMENT SERVICES PRIVATE LIMITED",
"INSTANT REMEDIES PRIVATE LIMITED",
"INSTANT SHIP AGENCIES PRIVATE LIMITED",
"INSTANT SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED",
"INSTANT SWIFT OVERSEAS PRIVATE LIMITED",
"INSTANT SYSTEMS",
"INSTANT TRADERS PRIVATE LIMITED",
"INSTANT TRANSPORT SOLUTION PRIVATE LIMITED",
"INSTANT VENTURES PRIVATE LIMITED",
"INSTANTALL EARTH MOVERS PRIVATE LIMITED",
"INSTANTEL HYDRAULIC SOLUTIONS PRIVATE LIMITED",
"INSTANTLY RESEARCH INDA PRIVATE. LIMITED",
"INSTANTPAY INDIA LIMITED",
"INSTAOFFICE BUSINESS SOLUTIONS PRIVATE LIMITED",
"INSTAPLAY SOLUTIONS PRIVATE LIMITED",
"INSTAPOWER LIMITED",
"INSTARAY HEALTHCARE PRIVATE LIMITED",
"INSTAREWARD PRIVATE LIMITED",
"INSTASERV INDIA PRIVATE LIMITED",
"INSTASINE POWER TECHNOLOGIES PRIVATE LIMITED",
"INSTASPACES REALTECH PRIVATE LIMITED",
"INSTASSURE INSURANCE SOLUTIONS LIMITED",
"INSTATRANS GLOBAL LOGISTICS PRIVATE LIMITED",
"INSTAVERITAS INDIA PRIVATE LIMITED",
"INSTAWORK SERVICES INDIA PRIVATE LIMITED",
"INSTELLARS GLOBAL CONSULTING PRIVATE LIMITED",
"INSTEM INDIA PRIVATE LIMITED",
"INSTILL TECHNOLOGIES PRIVATE LIMITED",
"INSTINCT INFRA & POWER LIMITED",
"INSTITUE OF AERONAUTICAL ENGINEERING",
"INSTITUTE FOR AUTOPARTS TECHNOLOGY",
"INSTITUTE FOR CONFLICT MANAGEMENT",
"INSTITUTE FOR DESIGN OF ELECTRICAL MEASURING INSTRUMENTS",
"INSTITUTE FOR DEVELOPMENT AND RESEARCH",
"INSTITUTE FOR DEVELOPMENT STUDIES ANDHR PRADESH",
"INSTITUTE FOR ENVIRONMENTAL MANAGEMENT ECO ENVIRO LAB",
"INSTITUTE FOR FINANCIAL MNGT AND RES",
"INSTITUTE FOR GLOBAL DEVELOPMENT",
"INSTITUTE FOR INNER STUDIES PUBLISHING FOUNDATION INDIA PRIVATE LIMITED",
"INSTITUTE FOR INTEGRATED RURAL DEVELOPMENT",
"INSTITUTE FOR PLASMA RESEARCH",
"INSTITUTE FOR POLICY RESEARCH STUDIES",
"INSTITUTE FOR TECHNOLOGY AND MANAGEMENT",
"INSTITUTE FOR THE BLIND CHANDIGARH ADMINISTRATION",
"INSTITUTE OF ACTUARIES OF INDIA",
"INSTITUTE OF ADVANCED MANAGEMENT & RESEARCH",
"INSTITUTE OF ADVANCED RESEARCH",
"INSTITUTE OF ADVANCED STUDY IN EDUCATION",
"INSTITUTE OF AERONAUTICAL ENGINEERING",
"INSTITUTE OF AYURVEDIC RESEARCH PRIVATE LIMITED",
"INSTITUTE OF AYUSH MEDICAL SCIENCES",
"INSTITUTE OF BANKING PERSONNEL SELECTION",
"INSTITUTE OF BIOINFORMATICS",
"INSTITUTE OF BUSINESS ADMN AND TRAINING",
"INSTITUTE OF BUSINESS MANAGEMENT AND RESEARCH",
"INSTITUTE OF CHEMICAL TECHNOLOGY",
"INSTITUTE OF CLINICAL RESEARCH PROFESSIONALS (INDIA)",
"INSTITUTE OF CO-OPERATIVE & CORPORATE MANAGEMENT RESEARCH & TRAINING",
"INSTITUTE OF CO-OPERATIVE AND CORPORATE MANAGEMENT RESEARCH AND TRAINING",
"INSTITUTE OF COOPERATIVE MANAGEMENT",
"INSTITUTE OF COST ACCOUNTANTS OF INDIA",
"INSTITUTE OF DESIGN",
"INSTITUTE OF EDUCATION & EXAMINATION MANAGEMENT PRIVATE LIMITED",
"INSTITUTE OF EDUCATION FOR WOMAN",
"INSTITUTE OF ELECTRICAL ENGINERING",
"INSTITUTE OF ENGINEERING & TECHNOLOGY",
"INSTITUTE OF ENTREPRENEURSHIP OF DEVELOPMENT U P",
"INSTITUTE OF FINANCE AND INTERNATIONAL MANAGEMENT",
"INSTITUTE OF FIRE ENGINEERING AND SAFETY MANAGEMENT",
"INSTITUTE OF FOREST PRODUCTIVITY",
"INSTITUTE OF GASTRO AND KIDNEY CARE PRIVATE LIMITED",
"INSTITUTE OF GEMONICS INTEGRATIVE",
"INSTITUTE OF GOOD MANUFACTURING PRACTICES INDIA PRIVATE LIMITED",
"INSTITUTE OF HEALTH MANAGEMENT",
"INSTITUTE OF HEALTH SCIENCES",
"INSTITUTE OF HOME ECONOMICS",
"INSTITUTE OF HOTEL MANAGEMENT CATERING TECHNOLOGY AND APPLIED NUTRITION",
"INSTITUTE OF HUMAN BEHAVIOUR AND ALLIED",
"INSTITUTE OF HUMAN BEHAVIOUR AND ALLIED SCIENCES",
"INSTITUTE OF HUMAN REPRODUCTION",
"INSTITUTE OF INSURANCE AND RISK MANAGEMENT",
"INSTITUTE OF INSURANCE FINANCIAL SCIENCE",
"INSTITUTE OF INTEGRATED MANAGEMENT & ENGINEERING",
"INSTITUTE OF INTIGRATED EDUCATION - BHUB",
"INSTITUTE OF KIDNEY DISEASE & RESEARCH CENTER AHMEDABAD",
"INSTITUTE OF KIDNEY DISEASES AND RESEARCH CENTER",
"INSTITUTE OF LABOUR MANAGEMENT",
"INSTITUTE OF LIVER & BILIARY SCIENCES",
"INSTITUTE OF LOCAL GOVERNMENT AND URBAN STUDIES",
"INSTITUTE OF MANAGEMENT & APPLICATION",
"INSTITUTE OF MANAGEMENT & TECHNICAL STUDIES EDUCATION PRIVATE LIMITED",
"INSTITUTE OF MANAGEMENT ACCOUNTANTS INDIA PRIVATE LIMITED",
"INSTITUTE OF MANAGEMENT EDUCATION & RESERACH",
"INSTITUTE OF MANAGEMENT STUDIES",
"INSTITUTE OF MANAGEMENT STUDIES AND INFORMATION TECHNOLOGY",
"INSTITUTE OF MANAGEMENT STUDIES GHAZIABAD",
"INSTITUTE OF MANAGEMENT TECHNOLOGY",
"INSTITUTE OF MARINE EDUCATION & RESEARCH",
"INSTITUTE OF MARKETING & MANAGEMENT",
"INSTITUTE OF MATHEMATICAL SCIENCES",
"INSTITUTE OF MEDICAL SCIENCES & SUM HOSPITAL",
"INSTITUTE OF MICROBIAL TECHNOLOGY",
"INSTITUTE OF MOLECULAR MEDICINE",
"INSTITUTE OF NEUROSCIENCES KOLKATA",
"INSTITUTE OF NUTRITION AND FITNESS SCIENCES PRIVATE LIMITED",
"INSTITUTE OF PHARMACY NANDURBAR",
"INSTITUTE OF PROFESSIONAL & TECHNICAL EDUCATION",
"INSTITUTE OF PSYCHATRY AND HUMAN BEHAVOU",
"INSTITUTE OF PUBLIC ENTERPRISE",
"INSTITUTE OF RURAL MANAGEMENT",
"INSTITUTE OF SENSORY INTEGRATION & RESEARCH CENTREIND",
"INSTITUTE OF SILICON SYSTEMS PRIVATE LIMITED",
"INSTITUTE OF TEACHING & RESEARCH IN AYURVEDA",
"INSTITUTE OF TECHNICAL EDUCATION & RESEARCH",
"INSTITUTE OF TECHNOLOGY MANAGEMENT",
"INSTITUTE OF TECHNOLOGY UNDER NIRMA UNIVERSITY",
"INSTITUTE OF TEXTILE TECHNOLOGY",
"INSTITUTE PROFESSIONAL STUDIES",
"INSTITUTE SCIENCE COLLEGE",
"INSTITUTION FOR CAPACITY BUILDING AND TECHNOLOGY ACADEMY",
"INSTITUTIONAL INVESTOR ADVISORY SERVICES INDIA LIMITED",
"INSTITUTIONAL SHAREHOLDER SERVICES INDIA PRIVATE LIMITED",
"INSTITUTO HISPANIA COMMUNICATIONS PRIVATE LIMITED",
"INSTO COSMETICS PRIVATE LIMITED",
"IN-STORE CONSULTING SERVICES PRIVATE LIMITED",
"INSTOREIN TECHNOLOGIES PRIVATE LIMITED",
"INSTORIED RESEARCH LABS PRIVATE LIMITED",
"INSTOVO SOLUTION PRIVATE LIMITED",
"INSTRANS ENGINEERING AND MANUFACTURING PRIVATE LIMITED",
"INSTRIVE SOFTLABS PRIVATE LIMITED",
"INSTROMEDIX (INDIA) PRIVATE LIMITED",
"INSTROMEDIX WASTE MANAGEMENT PRIVATE LIMITED",
"INSTRUCTOR IN CHARGE GLIDING CENTRE CIVIL AERODROME",
"INSTRUMECH ENGINEERS PRIVATE LIMITED",
"INSTRUMENT RESEARCH ASSOCIATES PRIVATE LIMITED",
"INSTRUMENTATION & CONTROL SOLUTIONS",
"INSTRUMENTATION AUTOMATION SURVEILLANCE & COMMUNICATION SECTOR SKILL COUNCIL",
"INSTRUMENTATION ENGINEERS PRIVATE LIMITED",
"INSTRUMENTATION LABORATORY INDIA PRIVATE LIMITED",
"INSTRUMENTATION LIMITED",
"INSTRUMENTS AND CHEMICALS PRIVATE LIMITED",
"INSTRUMENTS CARE CHENNAI PRIVATE LIMITED",
"INSTRUMENTS RESEARCH AND DEVELOPMENT ESTABLISHMENT",
"INSTRUPRO TECHNOLOGIES (OPC) PRIVATE LIMITED",
"INSTT OF ENG & TECH-DEVI AHILYA VISHWAVI",
"INSTT OF GENMOICS INTEGRATIVE BIOLOGY",
"INSTTITUE OF FIRE SERVICE WEST BENGAL FIRE & EMERGENCY SERVICE",
"IN-STYLE EMBROIDERIES PRIVATE LIMITED",
"INSTYLE EXPORTS PRIVATE LIMITED",
"INSTYLE SOLUTIONS PRIVATE LIMITED",
"INSUCON CABLES AND CONDUCTORS PRIVATE LIMITED",
"INSULATION AND ELECTRICAL PRODUCTS PRIVATE LIMITED",
"INSULATION PRODUCTS SYSTEMS PRIVATE LIMITED",
"INSULATIONS AND POLYMERS PRIVATE LIMITED",
"INSULATIONS INDIA ENGINEERING PRIVATE LIMITED",
"INSULINK PACKAGING SOLUTIONS PRIVATE LIMITED",
"INSULO FIBRE PRIVATE LIMITED",
"INSULON POLYMERS INDIA PRIVATE LIMITED",
"INSULREF TECHNOLOGIES PRIVATE LIMITED",
"INSULTEC INTERNATIONAL PRIVATE LIMITED",
"INSULWEL INSULATION INDIA PRIVATE LIMITED",
"INSURANCE INSTITUTE OF INDIA",
"INSURANCE MEDICAL OFFICER",
"INSURANCE MEDICAL OFFICER E S I S BAJERIYA BUTTIBORI NAGPUR",
"INSURANCE REGULATORY DEVELOP AUTHY",
"INSURE PRO2.0",
"INSUREKOT SPORTS PRIVATE LIMITED",
"INSURENCE MEDICAL OFFICER AB ROAD DEWAS",
"INSUREXCELLENCE ADVISORS PRIVATE LIMITED",
"INSUTECH INSURANCE BROKING SERVICES PRIVATE LIMITED",
"INSUTHERM PRIVATE LIMITED",
"INSYNC ANALYTICS INDIA PRIVATE LIMITED",
"INSYNC BUSINESS SOLUTIONS LIMITED",
"INSYNC INFOTECH PRIVATE LIMITED",
"INSYNC TECH - FIN SOLUTIONS LIMITED",
"INSYNERGY SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED",
"INSYS ELECTRICAL & CONTROLS LLP",
"INSYSTRON ELECTRONICS PRIVATE LIMITED",
"INT ADVISORY COUNCIL PRIVATE LIMITED",
"INT COLL SHRI DAU SARAY DHANAUTI MATHURA",
"INT FERTILITY CENTRE PRIVATE LIMITED",
"INT INFRASTRUCTURE PRIVATE LIMITED",
"INT INSTITUTE FOR POPULATION SCIENCE",
"INTACCT SOFTWARE PRIVATE LIMITED",
"INTACT AUTOMATION PRIVATE LIMITED",
"INTACT FIT PRIVATE LIMITED",
"INTACT GREEN SERVICES INDIA PRIVATE LIMITED",
"INTACT INFO INDIA PRIVATE LIMITED",
"INTACT INSURANCE BROKERS PRIVATE LIMITED",
"INTACT MARKET RESEARCH INDIA PRIVATE LIMITED",
"INTACT PACKAGING PRIVATE LIMITED",
"INTACT TRANSPORT PRIVATE LIMITED",
"INTACT VALVES",
"INTACT360 INDUSTRIES PRIVATE LIMITED",
"INTACTIT INFOSYSTEMS PRIVATE LIMITED",
"INTAG REMEDIES PRIVATE LIMITED",
"INTAGE INDIA PRIVATE LIMITED",
"INTAGLIO ZURIE PRIVATE LIMITED",
"INTAKE HOSPITAL PRIVATE LIMITED",
"INTALIA KNIT WEAR PRIVATE LIMITED",
"INTALIO PRIVATE LIMITED",
"INTAN EXIM PRIVATE LIMITED",
"INTANDEM SOLUTIONS PRIVATE LIMITED",
"INTANGLES LAB PRIVATE LIMITED",
"INTAP LABS PRIVATE LIMITED",
"INTAS PHARMACEUTICALS LIMITED",
"INTAT COURIER AND CARGO PRIVATE LIMITED",
"INTCERAMIC ENGINEERING PRIVATE LIMITED",
"INTEB ENERGY AND ENVIRONMENT SOLUTIONS PRIVATE LIMITED",
"INTEC EXPORT INDIA PRIVATE LIMITED",
"INTEC INFONET PRIVATE. LIMITED.",
"INTEC INFRA TECHNOLOGIES PRIVATE LIMITED",
"INTEC LOGISTICS PRIVATE LIMITED",
"INTEC SEALS PRIVATE LIMITED",
"INTEC TOOLS PRIVATE LIMITED",
"INTEC TRAINING AND EDUWARE COMPANY PRIVATE LTD",
"INTECA IT SOLUTIONS PRIVATE LIMITED",
"INTECCO TECHNICAL SERVICES PRIVATE LIMITED",
"INTECH ADDITIVE SOLUTIONS PRIVATE LIMITED",
"INTECH APPAREL PRIVATE LIMITED",
"INTECH AUTOMATION PRIVATE LIMITED",
"INTECH CREATIVE SERVICES PRIVATE LIMITED",
"INTECH DIGITAL TECHNOLOGY (INDIA) PRIVATE LIMITED",
"INTECH ENERGY SYSTEMS PRIVATE LIMITED",
"INTECH FIRE& SECURITY PRIVATE LIMITED",
"INTECH FORGE (INDIA) PRIVATE LIMITED",
"INTECH INDIA PRIVATE LIMITED",
"IN-TECH INDUSTRIES LIMITED",
"INTECH INFRASTRUCTURE PRIVATE LIMITED",
"INTECH INFRATEL PRIVATE LIMITED",
"INTECH INSURANCE SURVEYORS AND LOSS ASSESSORS PRIVATE LIMITED",
"INTECH ONLINE PRIVATE LIMITED",
"INTECH ORGANICS LIMITED",
"INTECH PHARMA PRIVATE LIMITED",
"INTECH POWER KOVAI PRIVATE LIMITED",
"INTECH RETREADERS PRIVATE LIMITED",
"INTECH SAFETY PRIVATE LIMITED",
"INTECH SURFACE COATING PRIVATE LIMITED",
"INTECH SYSTEMS CHENNAI PRIVATE LIMITED",
"INTECH SYSTEMS PVT LTD",
"INTECHAUTO SYSTEMS PRIVATE LIMITED",
"INTECHGRITY SOLUTIONS PRIVATE LIMITED",
"INTECONS SOFTWARE LAB PRIVATE LIMITED",
"INTECREW BUILDING AUTOMATION PRIVATE LIMITED",
"INTEGER INFRATECH PRIVATE LIMITED",
"INTEGER TELECOM SERVICES INDIA PRIVATE LIMITED",
"INTEGR8 FUELS INDIA PRIVATE LIMITED",
"INTEGRA AUTOMATION PRIVATE LIMITED",
"INTEGRA DATATECH PRIVATE LIMITED",
"INTEGRA ENGINEERING INDIA LIMITED",
"INTEGRA ESSENTIA LIMITED",
"INTEGRA HOSPITALITY AND FACILITY MANAGEMENT LIMITED",
"INTEGRA INTERNATIONAL PRIVATE LIMITED",
"INTEGRA LIFE SCIENCES PRIVATE LIMITED",
"INTEGRA MICRO SOFTWARE SERVICES PRIVATE LIMITED",
"INTEGRA MICRO SYSTEMS PRIVATE LIMITED",
"INTEGRA SECURITIES PRIVATE LIMITED",
"INTEGRA SOFTWARE SERVICES PRIVATE LIMITED",
"INTEGRA SOLUTIONS LLP",
"INTEGRA TECH INDIA PRIVATE LIMITED",
"INTEGRA TELECOMMUNICATION AND SOFTWARE LIMITED",
"INTEGRA UNISOURCE PRIVATE LIMITED",
"INTEGRAATE INNOVATIONS PRIVATE LIMITED",
"INTEGRACE PRIVATE LIMITED",
"INTEGRAL AD SCIENCE INDIA PRIVATE LIMITED",
"INTEGRAL ADVISORY SERVICES PRIVATE LIMITED",
"INTEGRAL ALPHA PRIVATE LIMITED",
"INTEGRAL AUTOMATION PRIVATE LIMITED",
"INTEGRAL BIOSCIENCES PRIVATE LIMITED",
"INTEGRAL COACH FACTORY",
"INTEGRAL COACH FACTORY SOUTHERN RAILWAY",
"INTEGRAL COMPONENT MANUFACTURERS PRIVATE LIMITED",
"INTEGRAL COMPUTER PRIVATE LIMITED",
"INTEGRAL DESIGNS INTERNATIONAL STUDIO PRIVATE LIMITED",
"INTEGRAL DEVELOPMENT ENGINEERS PVT LTD",
"INTEGRAL EDUCATION SOCIETY",
"INTEGRAL ESTATES & DEVELOPERS PRIVATE LIMITED",
"INTEGRAL INDIA SOFTWARE DEVELOPMENT CENTRE PRIVATE LIMITED",
"INTEGRAL INDUSTRIAL MARKETING PRIVATE LIMITED",
"INTEGRAL INDUSTRIES PRIVATE LIMITED",
"INTEGRAL INFOGEN TECHNOLOGIES PRIVATE LIMITED",
"INTEGRAL INFRASTRUCTURE & PROJECTS LIMITED",
"INTEGRAL LABELS PRIVATE LIMITED",
"INTEGRAL LOGISTICS SERVICES PRIVATE LIMITED",
"INTEGRAL POWER SOLUTIONS PRIVATE LIMITED",
"INTEGRAL PROCESS CONTROLS INDIA PRIVATE LIMITED",
"INTEGRAL PUBLICATIONS PRIVATE LIMITED",
"INTEGRAL SOLUTION",
"INTEGRAL SYSTEM AND COMPONENTS PRIVATE LIMITED",
"INTEGRAL TOOLS COMPANY INDIA PRIVATE LIMITED",
"INTEGRAL TRADING AND LOGISTICS INDIA PRIVATE LIMITED",
"INTEGRAL UNIVERSITY",
"INTEGRAL VYAPAR PRIVATE LIMITED",
"INTEGRAM FEEDS (OPC) PRIVATE LIMITED",
"INTEGRASS TECHNICAL SERVICES PRIVATE LIMITED",
"INTEGRATECH INDIA PRIVATE LIMITED",
"INTEGRATED ACTIVE MONITORING PRIVATE LIMITED",
"INTEGRATED ALLIED SERVICES PRIVATE LIMITED",
"INTEGRATED BATTERIES INDIA PRIVATE LIMITED",
"INTEGRATED BRAND.COMM. PRIVATE LIMITED",
"INTEGRATED BRANDCOM PRIVATE LIMITED",
"INTEGRATED BUSINESS ENVIRONMENT INDIA PRIVATE LIMITED",
"INTEGRATED BUSINESS PROCESSING PRIVATE LIMITED",
"INTEGRATED CADCAM SOLUTIONS PRIVATE LIMITED",
"INTEGRATED CARGO MOVERS PRIVATE LIMITED",
"INTEGRATED CASETECH CONSULTANTS PRIVATE LIMITED",
"INTEGRATED CHEMISOL PRIVATE LIMITED",
"INTEGRATED CHILD DEVELOPMENT SERVICES PANVADI VYARA DIST TAPI",
"INTEGRATED CLEANROOM TECHNOLOGIES PRIVATE LIMITED",
"INTEGRATED COAL MINING LTD",
"INTEGRATED COCO CARBON & AGRO PRODUCTS PRIVATE LIMITED",
"INTEGRATED CONSORTIUM PRIVATE LIMITED",
"INTEGRATED COOLTECH PRIVATE LIMITED",
"INTEGRATED DATA MANAGEMENT SERVICES PRIVATE LIMITED",
"INTEGRATED DATABASES INDIA LIMITED",
"INTEGRATED DECISIONS AND SYSTEMS INDIA PRIVATE LIMITED",
"INTEGRATED DEFENCE PRODUCTS PRIVATE LIMITED",
"INTEGRATED DIGITAL SOLUTIONS PRIVATE LIMITED",
"INTEGRATED DISTRICT HEALTH SOCIETY NEW DELHI DISTRICT",
"INTEGRATED DRIVE SYSTEMS PRIVATE LIMITED",
"INTEGRATED DYNAMIC SOLUTIONS INDIA PRIVATE LIMITED",
"INTEGRATED EDUTEAM SOLUTIONS PRIVATE LIMITED",
"INTEGRATED ELECTRIC CO PRIVATE LIMITED",
"INTEGRATED ENTERPRISES INDIA PRIVATE LIMITED",
"INTEGRATED ENVIRONMENTAL SOLUTIONS INDIA PRIVATE LIMITED",
"INTEGRATED EQUIPMENT INDIA PRIVATE LIMITED",
"INTEGRATED FERTILIZERS AND CHEMICALS CO. PVT. LTD.",
"INTEGRATED FINANCIAL MANAGEMENT SYSTEM",
"INTEGRATED FINANCIAL SERVICES LIMITED",
"INTEGRATED FINCAP PRIVATE LIMITED",
"INTEGRATED FIRE PROTECTION PVT LTD",
"INTEGRATED FLOWTECH PRIVATE LIMITED",
"INTEGRATED FOODS & CONSUMER PRODUCTS (INDIA) PRIVATE LIMITED",
"INTEGRATED GEO INFORMATICS SOLUTIONS PRIVATE LIMITED",
"INTEGRATED GEO INSTRUMENTS AND SERVICES PVT LTD",
"INTEGRATED GEOSPATIAL SOLUTIONS AND TECHNOLOGY PRIVATE LIMITED",
"INTEGRATED HEALTH GROUP PRIVATE LIMITED",
"INTEGRATED HEALTH VENTURES LLP",
"INTEGRATED HELICOPTER SERVICES PRIVATE LIMITED",
"INTEGRATED HOTELS PRIVATE LIMITED",
"INTEGRATED HYDROPONICS INDIA PRIVATE LIMITED",
"INTEGRATED INDUSTRIAL FINTECH CONSULTANTS PRIVATE LIMITED",
"INTEGRATED INDUSTRIES LIMITED",
"INTEGRATED INFINITE SOLUTIONS PRIVATE LIMITED",
"INTEGRATED INFORMATION SERVICES PRIVATE LIMITED",
"INTEGRATED INNOVATORS PRIVATE LIMITED",
"INTEGRATED INSURANCE BROKING SERVICES PRIVATE LIMITED",
"INTEGRATED INTELLIGENT SOLUTIONS & TECHNOLOGIES PRIVATE LIMITED",
"INTEGRATED LABORATORIES PRIVATE LIMITED",
"INTEGRATED LAMINATORS PRIVATE LIMITED",
"INTEGRATED LEARNING SOLUTION PRIVATE LIMITED",
"INTEGRATED LOGISTICS PRIVATE LIMITED",
"INTEGRATED MAINTENANCE SERVICES PRIVATE LIMITED",
"INTEGRATED MARKETING & SERVICES PRIVATE LIMITED",
"INTEGRATED MASTER SECURITIES PRIVATE LIMITED",
"INTEGRATED OIL AND GAS SERVICES PRIVATE LIMITED",
"INTEGRATED PERSONNEL SERVICES LIMITED",
"INTEGRATED PEST CONTROL PRIVATE LIMITED",
"INTEGRATED PEST MANAGEMENT SOLUTIONS (INDIA) PRIVATE LIMITED",
"INTEGRATED POWER SYSTEMS",
"INTEGRATED PROJECT LOGISTICS PRIVATE LIMITED",
"INTEGRATED PROJECT MANAGEMENT SERVICES",
"INTEGRATED PROJECT SERVICES INTERNATIONAL PRIVATE LIMITED",
"INTEGRATED PROPBUILD PRIVATE LIMITED",
"INTEGRATED PROPERTY & POWER DEVELOPERS PRIVATE LIMITED",
"INTEGRATED PROPERTY MANAGEMENT & SERVICE",
"INTEGRATED PUBLIC SAFETY SYSTEMS PRIVATE LIMITED",
"INTEGRATED QUALITY CERTIFICATION PRIVATE LIMITED",
"INTEGRATED REGISTRY MANAGEMENT SERVICES PRIVATE LIMITED",
"INTEGRATED REGISTRY SERVICES LIMITED",
"INTEGRATED RESORTS PRIVATE LIMITED",
"INTEGRATED RESOURCES STAFFING PRIVATE LIMITED",
"INTEGRATED RETAIL MANAGEMENT CONSULTING PRIVATE LIMITED",
"INTEGRATED RISK CONTROL APPLICATIONS PRIVATE LIMITED",
"INTEGRATED RISK INSURANCE BROKERS LIMITED",
"INTEGRATED ROADWAYS PRIVATE LIMITED",
"INTEGRATED SEALAND SERVICES PRIVATE LIMITED",
"INTEGRATED SERVICE POINT PRIVATE LIMITED",
"INTEGRATED SERVICES AND CONSULTANCY",
"INTEGRATED SIMULATION TECHNOLOGIES PRIVATE LIMITED",
"INTEGRATED SOFTWARE SOLUTIONS INDIA PRIVATE",
"INTEGRATED SOFTWARE SYSTEMS PRIVATE LIMITED",
"INTEGRATED STONE RESOURCES PRIVATE LIMITED",
"INTEGRATED SYSTEMS TECHNOLOGIES PRIVATE LIMITED",
"INTEGRATED TECH9LABS PRIVATE LIMITED",
"INTEGRATED TECHNICAL STAFFING AND SOLUTIONS PRIVATE LIMITED",
"INTEGRATED THERMOPLASTICS LIMITED",
"INTEGRATED TRANSPORT MOVERS PRIVATE LIMITED",
"INTEGRATED TRIBAL DEVELOPMENT PROJECT",
"INTEGRATED VALVES & FITTINGS PRIVATE LIMITED",
"INTEGRATED WEAVING INDIA PRIVATE LIMITED",
"INTEGRATED WEB SERVICES PRIVATE LIMITED",
"INTEGRATED WIPE INDUSTRIES INDIA PRIVATE LIMITED",
"INTEGRATED WIRELESS SOLUTIONS PRIVATE LIMITED",
"INTEGRATED WORKFORCE SOLUTIONS PRIVATE LIMITED",
"INTEGRATEDMOBI TECH PRIVATE LIMITED",
"INTEGRATING AUTOMOBILES PRIVATE LIMITED",
"INTEGRATION INFOTECH INDIA PRIVAT LIMITED",
"INTEGRATION WIZARDS SOLUTIONS PRIVATE LIMITED",
"INTEGRATIVE SOLUTIONS PRIVATE LIMITED",
"INTEGRATIVE SYSTEMS INDIA PRIVATE LIMITED",
"INTEGRATOR CONSULTANTS PRIVATE LIMITED",
"INTEGRE SOLUTIONS PRIVATE LIMITED",
"INTEGREAT PMC INDIA PRIVATE LIMITED",
"INTEGRELLA IT CONSULTING PRIVATE LIMITED",
"INTEGREON INDIA PRIVATE LIMITED",
"INTEGREON MANAGED SOLUTIONS INDIA PRIVATE LIMITED",
"INTEGRHYTHM INDIA PRIVATE LIMITED",
"INTEGRI MARINE AND OFFSHORE SERVICES PRIVATE LIMITED",
"INTEGRICHAIN PRIVATE LIMITED",
"INTEGRID DESIGN CONSULTANTS PRIVATE LIMITED",
"INTEGRIN HEALTHCARE PRIVATE LIMITED",
"INTEGRIN LIFESCIENCES PRIVATE LIMITED",
"INTEGRIS HEALTH PRIVATE LIMITED",
"INTEGRITAS GLOBAL SERVICES PRIVATE LIMITED",
"INTEGRITY CONSTRUCTION PRIVATE LIMITED",
"INTEGRITY ENGINEERING WORKS PRIVATE LIMITED",
"INTEGRITY FORMULATIONS PRIVATE LIMITED",
"INTEGRITY FOUNDATION",
"INTEGRITY HOLDINGS INDIA PRIVATE LIMITED",
"INTEGRITY IT SOLUTIONS PRIVATE LIMITED",
"INTEGRITY LOGISTIC SOLUTION INDIA PRIVATE LIMITED",
"INTEGRITY MINDS PRIVATE LIMITED",
"INTEGRITY SEA TRANS PRIVATE LIMITED",
"INTEGRITY SHIPS PRIVATE LIMITED",
"INTEGRITY SOFTWARES LLP",
"INTEGRITY VERIFICATION SERVICES PRIVATE LIMITED",
"INTEGRITY WINDOWS AND DOORS PRIVATE LIMITED",
"INTEGRO ENGINEERS PRIVATE LIMITED",
"INTEGRO PRODUCTS INDIA PRIVATE LIMITED",
"INTEGRON HUMAN CAPITAL SERVICES PRIVATE LIMITED",
"INTEGRON PHARMA PRIVATE LIMITED",
"INTEGROW ASSET MANAGEMENT PRIVATE LIMITED",
"INTEGRUM ENERGY INFRASTRUCTURE PRIVATE LIMITED",
"INTEGRUM LIFE SCIENCES PRIVATE LIMITED",
"INTEGRUM TECHNOLOGIES PRIVATE LIMITED",
"INTEGS CLOUD TECHNOLOGIES PRIVATE LIMITED",
"INTEK ENGINEERING PRIVATE LIMITED",
"INTEK ENGINEERS",
"INTEK MICRO SYSTEMS PRIVATE LIMITED",
"INTEK SECURITY SYSTEMS PRIVATE LIMITED",
"INTEK TAPES PRIVATE LIMITED",
"INTEL CORPORATION",
"INTEL LAND DEVELOPERS PRIVATE LIMITED",
"INTEL MOBILE COMMUNICATIONS INDIA PRIVATE LIMITED",
"INTEL TECHNOLOGY INDIA PRIVATE LIMITED",
"INTELEANTS VIRTUAL WORKFORCE PRIVATE LIMITED",
"INTELECORP SOFTWARE INDIA PRIVATE LIMITED",
"INTELECT ELEMECH COMPANY PRIVATE LIMITED",
"INTELECTRA AIRE PROJECTS PRIVATE LIMITED",
"INTELEGAIN TECHNOLOGIES PRIVATE LIMITED",
"INTELENERGI GLOBAL PRIVATE LIMITED",
"INTELENET BUSINESS SERVICES LIMITED",
"INTELENET GLOBAL SERVICES PRIVATE LIMITED",
"INTELEQ TECH PRIVATE LIMITED",
"INTELEX SYSTEMS PRIVATE LIMITED",
"INTELFOX INDIA LIMITED",
"INTELI PLATFORMS INFOTECH INDIA PRIVATE LIMITED",
"INTELICORP BUSINESS CONSULTANTS PRIVATE LIMITED",
"INTELIMENT SOFTWARE TECHNOLOGIES INDIA PRIVATE LIMITED",
"INTELIMINDS BPO SOLUTIONS PRIVATE LIMITED",
"INTELIWAVES TECHNOLOGIES PRIVATE LIMITED",
"INTELIZEST CONSULTING PRIVATE LIMITED",
"INTELIZIGN ENGINEERING SERVICES PRIVATE LIMITED",
"INTELIZIGN LIFECYCLE SERVICES PRIVATE LIMITED",
"INTELLECAP ADVISORY SERVICES PRIVATE LIMITED",
"INTELLECT APX PRIVATE LIMITED",
"INTELLECT AQUA PRIVATE LIMITED",
"INTELLECT BIZWARE SERVICES PRIVATE LIMITED",
"INTELLECT DESIGN ARENA LIMITED",
"INTELLECT INFORMATICS PRIVATE LIMITED",
"INTELLECT ISPAT PRIVATE LIMITED",
"INTELLECT LIFE SCIENCES PRIVATE LIMITED",
"INTELLECT MARKETING INDIA PRIVATE LIMITED",
"INTELLECT PAYMENTS LIMITED",
"INTELLECT PROJECTS PRIVATE LIMITED",
"INTELLECT SOFTWARE SOLUTIONS PRIVATE LIMITED",
"INTELLECT STOCK BROKING LIMITED",
"INTELLECT SUPPORT SERVICES PRIVATE LIMITED",
"INTELLECT WELLNESS CHEMIST PRIVATE LIMITED",
"INTELLECTFACES TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"INTELLECTICA SYSTEMS INDIA PRIVATE LIMITED",
"INTELLECTION SOFTWARE AND TECHNOLOGIES PRIVATE LIMITED",
"INTELLECTUAL BUILDING SYSTEMS PRIVATE LIMITED",
"INTELLECTUAL CORPORATE ADVISORS PRIVATE LIMITED",
"INTELLECTUAL I T SOLUTION PRIVATE LIMITED",
"INTELLECTUAL INFO SOLUTIONS PRIVATE LIMITED",
"INTELLECTUAL RESEARCH SERVICES PRIVATE LIMITED",
"INTELLECTYX DATA SCIENCE INDIA PRIVATE LIMITED",
"INTELLEXS INVESTMENTS SOLUTIONS PRIVATE LIMITED",
"INTELLI SEARCH SERVICES PRIVATE LIMITED",
"INTELLI VECTRA TECHNOLOGIES PRIVATE LIMITED",
"INTELLIAL SOLUTIONS PRIVATE LIMITED",
"INTELLIASIA SOFTWARE PRIVATE LIMITED",
"INTELLIATECH SOLUTIONS PRIVATE LIMITED",
"INTELLIBUZZ PRIVATE LIMITED",
"INTELLICARE SOLUTIONS PRIVATE LIMITED",
"INTELLICOMM SOLUTIONS AND ENTERPRISES PRIVATE LIMITED",
"INTELLICON PRIVATE LIMITED",
"INTELLICORECG PRIVATE LIMITED",
"INTELLICRATS INFOSOLUTIONS PRIVATE LIMITED",
"INTELLICREDENCE PRIVATE LIMITED",
"INTELLICUBE MARKET RESEARCH SOLUTIONS PRIVATE LIMITED",
"INTELLICUS TECHNOLOGIES PRIVATE LIMITED",
"INTELLIDATES CONSULTANTS PRIVATE LIMITED",
"INTELLIDECS PRIVATE LIMITED",
"INTELLIEST TECHNOLOGY PRIVATE LIMITED",
"INTELLIFY SOLUTIONS PRIVATE LIMITED",
"INTELLIFY WORLDWIDE PRIVATE LIMITED",
"INTELLIGAIA TECHNOLOGIES PRIVATE LIMITED",
"INTELLIGENCE CORPORATE SECURITY AND SERVICES PRIVATE LIMITED",
"INTELLIGENCE MANPOWER SERVICES PRIVATE LIMITED",
"INTELLIGENCE SECURITY OF INDIA",
"INTELLIGENCE SERVICE SOLUTIONS PRIVATE LIMITED",
"INTELLIGENCENODE CONSULTING PRIVATE LIMITED",
"INTELLIGENT AIR FILTERS INDIA PRIVATE LIMITED",
"INTELLIGENT AUTOCONTROL PRIVATE LIMITED",
"INTELLIGENT BUSINESS COMPUTER SYSTEMS (INDIA) PRIVATE LTD",
"INTELLIGENT COMMUNICATION SYSTEMS INDIA LIMITED",
"INTELLIGENT COMMUNITY MANAGEMENT PRIVATE LIMITED",
"INTELLIGENT CONSULTING ENGINEERS AND BUILDERS PRIVATE LIMITED",
"INTELLIGENT DATA COLLECTION PRIVATE LIMITED",
"INTELLIGENT DEVELOPMENT AND PROGRAMMING PRIVATE LIMITED",
"INTELLIGENT DIGITAL NETWORK PRIVATE LIMITED",
"INTELLIGENT INDUSTRIAL INTERNET SYSTEMS PRIVATE LIMITED",
"INTELLIGENT INFRASTRUCTURE LIMITED",
"INTELLIGENT IT HUB PRIVATE LIMITED",
"INTELLIGENT MACHINES LAB PRIVATE LIMITED",
"INTELLIGENT MATERIALS PRIVATE LIMITED",
"INTELLIGENT MICRO SYSTEM PRIVATE LIMITED",
"INTELLIGENT PROTECTION FORCE PRIVATE LIMITED",
"INTELLIGENT QUOTIENT SYSTEM PRIVATE LIMITED",
"INTELLIGENT RADIOLOGY SOLUTIONS PRIVATE LIMITED",
"INTELLIGENT RETAIL PRIVATE LIMITED",
"INTELLIGENT SOFTWARE SOLUTIONS PRIVATE LIMITED",
"INTELLIGENT STUDIOS PRIVATE LIMITED",
"INTELLIGENT TECHNOPRODUCTS (OPC) PRIVATE LIMITED",
"INTELLIGENTIA IT SYSTEMS PRIVATE LIMITED",
"INTELLIGENTTAG TECHNOLOGIES PRIVATE LIMITED",
"INTELLIGRAPHICS TECHNOLOGIES INDIA PRIVATE LIMITED",
"INTELLIHEALTH SOLUTIONS PRIVATE LIMITED",
"INTELLIKONNECT SOLUTIONS PRIVATE LIMITED",
"INTELLIMATION.AI SOFTWARE PRIVATE LIMITED",
"INTELLIMEDIA NETWORKS PRIVATE LIMITED",
"INTELLINET SYSTEMS PRIVATE LIMITED",
"INTELLINUM SOLUTIONS INDIA PRIVATE LIMITED",
"INTELLIO HEALTHCARE PRIVATE LIMITED",
"INTELLIOAK TECHNOLOGIES PRIVATE LIMITED",
"INTELLIOZ SOLUTIONS INDIA PRIVATE LIMITED",
"INTELLIPAAT SOFTWARE SOLUTIONS PRIVATE LIMITED",
"INTELLIPLANNER SOFTWARE SYSTEM INDIA PRIVATE LIMITED",
"INTELLIPREDIKT TECHNOLOGIES PRIVATE LIMITED",
"INTELLIPRO SOLUTIONS PRIVATE LIMITED",
"INTELLIQUITY CONSULTING SERVICES PRIVATE LIMITED",
"INTELLIRO INFRATECH PRIVATE LIMITED",
"INTELLIROSE SOFTWARE INDIA PRIVATE LIMITED",
"INTELLISENSE INFOTECH PRIVATE LIMITED",
"INTELLISERV TECHNOLOGIES PRIVATE LIMITED",
"INTELLISIGHT INDIA PRIVATE LIMITED",
"INTELLISIS RESOURCES PRIVATE LIMITED",
"INTELLISMART INFRASTRUCTURE PRIVATE LIMITED",
"INTELLISMITH CONSULTANCY PRIVATE LIMITED",
"INTELLISOL INTEGRATED SERVICES PRIVATE LIMITED",
"INTELLISOURCE TECHNOLOGIES PRIVATE LIMITED",
"INTELLISTALL PRIVATE LIMITED",
"INTELLISTRIDE TECHNOLOGIES PRIVATE LIMITED",
"INTELLISWIFT SOFTWARE (INDIA) PRIVATE LIMITED",
"INTELLITEACH OFFSHORE PRIVATE LIMITED",
"INTELLITECH ELECTRONIC SOLUTIONS LIMITED",
"INTELLITEST SOLUTIONS PRIVATE LIMITED",
"INTELLITEX AGROPRODUCTS PRIVATE LIMITED",
"INTELLITIDE TECHNOLOGIES INDIA PRIVATE LIMITED",
"INTELLIUS RECODE PRIVATE LIMITED",
"INTELLIVATE CAPITAL VENTURES LIMITED",
"INTELLIVISION ENGINEERING PRIVATE LIMITED",
"INTELLIVISION TECHNOLOGIES PRIVATE LIMITED",
"INTELLIWEIGH SYSTEMS PRIVATE LIMITED",
"INTELLIWORKZ BUSINESS SOLUTIONS PRIVATE LIMITED",
"INTELLO TECH AMC PRIVATE LIMITED",
"INTELLORE SYSTEMS PRIVATE LIMITED",
"INTELLOSOL SOFTWARES INDIA PRIVATE LIMITED",
"INTELLUM CORPORATE TECHNOLOGIES PRIVATE LIMITED",
"INTELLUS SOFTWARE INDIA PRIVATE LIMITED",
"INTELMAC MACHINE TOOLS PRIVATE LIMITED",
"INTELNET IT SOLUTIONS PRIVATE LIMITED",
"INTELOUS IO PRIVATE LIMITED",
"INTELSAT INFLIGHT INDIA LLP",
"INTELTEK AUTOMATION PRIVATE LIMITED",
"INTELUX ELECTRONICS PRIVATE LIMITED",
"INTENCE ENGINEERING PRIVATE LIMITED",
"INTENIM TECHNOLOGIES PRIVATE LIMITED",
"INTENSE FEEDS PRIVATE LIMITED",
"INTENSE IP SERVICES PRIVATE LIMITED",
"INTENSE LABELS SOLUTION PRIVATE LIMITED",
"INTENSE MEDICAL & DENTAL SYSTEM PRIVATE LIMITED",
"INTENSE TECHNOLOGIES LIMITED",
"INTENSE VALUE STREAM LOGISTICS PRIVATE LIMITED",
"INTENSIFY TECHNOLOGIES SOLUTION PRIVATE LIMITED",
"INTENSITY GLOBAL TECHNOLOGIES PRIVATE LIMITED",
"INTENSIVE CATLE DEVELOPMENT PROGRAM",
"INTENSIVE FINANCE PRIVATE LIMITED",
"INTENSIVE FISCAL SERVICES PRIVATE LIMITED",
"INTENSIVE SOFTSHARE PRIVATE LIMITED",
"INTENSIV-FILTER HIMENVIRO PRIVATE LIMITED",
"INTENT INFOTECH PRIVATE LIMITED",
"INTENTHEALTH TECHNOLOGIES PRIVATE LIMITED",
"INTENTIVE TECHNOLOGIES PRIVATE LIMITED",
"INTENTS MOBI PRIVATE LIMITED",
"INTENTWISE SERVICES INDIA PRIVATE LIMITED",
"INTEPAT IP SERVICES PRIVATE LIMITED",
"INTEQ BPO SERVICES PRIVATE LIMITED",
"INTEQ IT SERVICES INDIA PRIVATE LIMITED",
"INTEQ SOFTWARE LLP",
"INTEQ SOFTWARE PRIVATE LIMITED",
"INTEQUANT ADVISORS PRIVATE LIMITED",
"INTER - GLOBE MARINE AGENCIES PRIVATE LIMITED",
"INTER ADS EXHIBITIONS PRIVATE LIMITED",
"INTER AIRWINGS PRIVATE LIMITED",
"INTER ASIA MINERALS AND ENERGY (INDIA) PRIVATE LIMITED",
"INTER CERT PRIVATE LIMITED",
"INTER CITY CARRIERS PRIVATE LIMITED",
"INTER COLLEGE SERSA MATHURA",
"INTER COLLEGE UNNAO",
"INTER COMMERCE INDIA PVT LTD",
"INTER COMMERCE PVT LTD",
"INTER CONFERENCE AND EXHIBITIONS SERVICES PRIVATE LIMITED",
"INTER CONTINENTAL CONSTRUCTIONS (INDIA) LIMITED",
"INTER CONTINENTAL LOGISTICS PRIVATE LIMITED",
"INTER EVENT MANAGEMENT SERVICES PRIVATE LIMITED",
"INTER FILMS INDIA PRIVATE LIMITED",
"INTER FOTO INDIA PRIVATE LIMITED",
"INTER FREIGHT FORWARDERS PRIVATE LIMITED",
"INTER GLOBE FINANCE LTD",
"INTER GLOBE LOGISTICS AND CONSULTANTS PRIVATE LIMITED",
"INTER GLOBE MONEY EXCHANGE PRIVATE LIMITED",
"INTER GLOBE OVERSEAS LIMITED",
"INTER GOLD INDIA PRIVATE LIMITED",
"INTER INDIA ROADWAYS PRIVATE LIMITED",
"INTER KONTAKT ELEKTRIK PRIVATE LIMITED",
"INTER PROTECT MARINE PRIVATE LIMITED",
"INTER ROOFS ELECTRONIC SYSTEMS PRIVATE LIMITED",
"INTER SOLAR SYSTEMS PRIVATE LIMITED",
"INTER SOURCE EXPORTS PVT LTD",
"INTER SPACE DESIGNS PRIVATE LIMITED",
"INTER TOUCH METAL BUILDINGS PRIVATE LIMITED",
"INTER TRANS SERVICES INDIA PRIVATE LIMITED",
"INTER TRAVEL & T LINKS PRIVATE LIMITED",
"INTER UNIVERSITY CENTRE FOR ASTRONOMY",
"INTERA DATA MANAGEMENT SERVICES INDIA PRIVATE LIMITED",
"INTERACT AUTO PRIVATE LIMITED",
"INTERACT TEX LABELS PRIVATE LIMITED",
"INTERACTIVE AVENUES PRIVATE LIMITED",
"INTERACTIVE BEES PRIVATE LIMITED",
"INTERACTIVE BROKERS INDIA PRIVATE LIMITED",
"INTERACTIVE BROKERS SOFTWARE SERVICES (INDIA) PRIVATE LIMITED",
"INTERACTIVE COMMUNICATION SERVICES (INDIA) PRIVATE LIMITED",
"INTERACTIVE DATA SYSTEMS LIMITED",
"INTERACTIVE FINANCIAL AND TRADING SERVICES PRIVATE LIMITED",
"INTERACTIVE FINANCIAL SERVICES LIMITED",
"INTERACTIVE FORUM ON INDIAN ECONOMY",
"INTERACTIVE INFO-COM INDIA PRIVATE LIMITED",
"INTERACTIVE INTELLIGENCE INDIA PRIVATE LIMITED",
"INTERACTIVE MANPOWER SOLUTION PRIVATE LIMITED",
"INTERACTIVE MEDIA PRIVATE LIMITED",
"INTERACTIVE SECURITIES PRIVATE LIMITED",
"INTERACTIVE SOLUTIONS INDIA PRIVATE LIMITED",
"INTERACTIVE TELEVISION PRIVATE LIMITED",
"INTERACTIVETOUCHH TECHNOLOGY PRIVATE LIMITED",
"INTERADS ADVERTISING PRIVATE LIMITED",
"INTERAKT DIGITAL SOLUTION PRIVATE LIMITED",
"INTERALIA INDIA PRIVATE LIMITED",
"INTERARCH BUILDING PRODUCTS LIMITED",
"INTERARCH BUILDING PRODUCTS PRIVATE LIMITED",
"INTERART CREATORS PLUMBING SERVICES PRIVATE LIMITED",
"INTERASIA SHIPPING LINES INDIA PRIVATE LIMITED",
"INTERAZZO DECOR AND FURNISHING PRIVATE LIMITED",
"INTERBASE SERVICES PRIVATE LIMITED",
"INTERBIT SOLUTIONS PRIVATE LIMITED",
"INTERBIZ SOLUTIONS LLP",
"INTERBRAKE SYSTEMS PRIVATE LIMITED",
"INTERCAD SYSTEMS PRIVATE LIMITED",
"INTERCARE CLEANING AND HYGIENE SERVICES PRIVATE LIMITED",
"INTERCARE TECH PRIVATE LIMITED",
"INTERCAX TECHNOLOGIES PRIVATE LIMITED",
"INTERCHEM PRIVATE LIMITED",
"INTERCHEM PVT LTD",
"INTERCITY AGENCIES PRIVATE LIMITED",
"INTERCITY BUILDCON PRIVATE LIMITED",
"INTERCITY FINVEST PRIVATE LIMITED",
"INTER-CITY TRADERS PVT LTD",
"INTERCITY TRANSPORT COMPANY PRIVATE LIMITED",
"INTERCOM-SKICORP MANUFACTURING PRIVATE LIMITED",
"INTERCON IMPEX PRIVATE LIMITED",
"INTERCON INTERNATIONAL PRIVATE LIMITED",
"INTERCON REAL ESTATE DEVELOPERS PRIVATE LIMITED",
"INTERCONCEPTS FASHION SERVICES PRIVATE LIMITED",
"INTERCONT FREIGHT LINERS PRIVATE LIMITED",
"INTERCONTINENTAL CONSTRUCTION ENGINEERING CONSULTANCY LLP",
"INTERCONTINENTAL CONSULTANTS AND TECHNOCRATS PRIVATE LIMITED",
"INTERCONTINENTAL HOTELS GROUP INDIA PRIVATE LIMITED",
"INTERCONTINENTAL INFRASTRUCTURE LIMITED",
"INTERCONTINENTAL MARINE DRIVE-MUMBAI",
"INTERCORP BIOTECH LIMITED",
"INTERCRAFT TRADING PRIVATE LIMITED",
"INTERCUT ENTERTAINMENT PRIVATE LIMITED",
"INTERENERGO JVG ENGINEERING COMPANY PRIVATE LIMITED",
"INTEREST SECURITY SERVICES OPC PRIVATE LIMITED",
"INTEREX ARCH DESIGNS PRIVATE LIMITED",
"INTERFACE AUTOMATIONS PRIVATE LIMITED",
"INTERFACE BUSINESS SOLUTION PRIVATE LIMITED",
"INTERFACE COMMUSTAR PRIVATE LIMITED",
"INTERFACE COMPUTER SYSTEMS PRIVATE LIMITED.",
"INTERFACE CONNECTRONICS PRIVATE LIMITED",
"INTERFACE DESIGN ASSOCIATES PRIVATE LIMITED",
"INTERFACE DEVICES INDIA PRIVATE LIMITED",
"INTERFACE DIGITAL SOLUTIONS PRIVATE LIMITED",
"INTERFACE FINANCIAL SERVICES LTD",
"INTERFACE INFOSOFT SOLUTIONS PRIVATE LIMITED",
"INTERFACE MICROSYSTEM",
"INTERFACE MICROSYSTEMS",
"INTERFACE PHARMACEUTICALS PVT LTD",
"INTERFINET TECHNOLOGIES PVT LTD",
"INTERFLEX GRAVURE PRIVATE LIMITED",
"INTERFLITCH FURNITURE AND FIXTURES PRIVATE LIMITED",
"INTERFREIGHT LOGISTICS PRIVATE LIMITED",
"INTERFREIGHT SERVICES PRIVATE LIMITED",
"INTERGARDEN INDIA PRIVATE LIMITED",
"INTERGEN ENERGY LIMITED",
"INTERGEST SOUTH ASIA PRIVATE LIMITED",
"INTERGLOBAL LOGISOLUTIONS PRIVATE LIMITED",
"INTERGLOBE AIR TRANSPORT LIMITED",
"INTERGLOBE AVIATION LIMITED",
"INTERGLOBE EDUCATION SERVICES LIMITED",
"INTERGLOBE ENTERPRISES PRIVATE LIMITED",
"INTERGLOBE HOTELS PRIVATE LIMITED",
"INTERGLOBE REAL ESTATE VENTURES PRIVATE LIMITED",
"INTERGLOBE SPIRITZ INDIA PRIVATE LIMITED",
"INTERGLOBE TECHNOLOGIES PRIVATE LIMITED",
"INTERGLOBE TECHNOLOGY QUOTIENT PRIVATE LIMITED",
"INTERGOLD CREATIONS PRIVATE LIMITED",
"INTERGOLD INDIAPRIVATE LIMITED",
"INTERGRAPH SG&I INDIA PRIVATE LIMITED",
"INTERGRAPHIC SALES AND SERVICES PRIVATE LIMITED",
"INTERGROW BRANDS PRIVATE LIMITED",
"INTERGROW EXIM PRIVATE LIMITED",
"INTERGY CONSULTING (INDIA) PRIVATE LIMITED",
"INTERIA INFRASTRUCTURE PRIVATE LIMITED",
"INTERICS DESIGNS PRIVATE LIMITED",
"INTERICS INTERIOR MANAGEMENT PRIVATE LIMITED",
"INTERIM MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"INTERIO SOURCE INDIA PRIVATE LIMITED",
"INTERIOCRAFT PRIVATE LIMITED",
"INTERIONOMICS PRIVATE LIMITED",
"INTERIOPLEX PROJECTS PRIVATE LIMITED",
"INTERIOR FURNITURES & KITCHENS PRIVATE LIMITED",
"INTERIORS & MORE LIMITED",
"INTERIORS BLUE PRIVATE LIMITED",
"INTERIORS DESIGNERS DECORATORS PRIVATE LIMITED",
"INTERJAS LOGISTICS PRIVATE LIMITED",
"INTERJEWEL PRIVATE LIMITED",
"INTERJOIN MEDIA SERVICES PRIVATE LIMITED",
"INTERKARDIO PRIVATE LIMITED",
"INTERLACE INDIA PRIVATE LIMITED",
"INTERLINE TRAVEL PRIVATE LIMITED",
"INTERLINK CAPITAL ADVISORS PRIVATE LIMITED",
"INTERLINK COAL PVT LTD",
"INTERLINK FOODS PRIVATE LIMITED",
"INTERLINK INFORMATION SYSTEMS PVT LTD",
"INTERLINK REALTY PRIVATE LIMITED",
"INTERLINK SHIPPING & CLEARING PRIVATE LIMITED",
"INTERLINK VINIMAY PVT LTD",
"INTERLINKED DAWAMANDI PRIVATE LIMITED",
"INTERLINKS DISTRIBUTORS PRIVATE LIMITED",
"INTERLINKS OVERSEAS PRIVATE LIMITED",
"INTERLOG SERVICES PRIVATE LIMITED",
"INTERMARK ASSOCIATES PRIVATE LIMITED",
"INTERMARKET INDIA PRIVATE LIMITED",
"INTERMED HEALTHCARE PRIVATE LIMITED",
"INTERMED LABORATORIES PRIVATE LIMITED",
"INTERMED MUMBAI",
"INTERMEDIA CABLE COMMUNICATION PRIVATE LIMITED",
"INTERMEDIA PRINTS PRIVATE LIMITED",
"INTERMEDIATE COLLEGE KURSANDA",
"INTERMEDIATE COLLEGE PAHASU",
"INTERMEDICS DEVICES PRIVATE LIMITED",
"INTERMESH SHOPPING NETWORK PVT LTD",
"INTERMETAL ENGINEERS ( INDIA ) PRIVATE LIMITED",
"INTERMODAL LOGISTICS PRIVATE LIMITED",
"INTERMODAL SHIPPING AND CARGO PRIVATE LIMITED",
"INTERMOLDE FURNITURE PRIVATE LIMITED",
"INTERMOT HYDRAULIC MOTORS AND DRIVES INDIA PRIVATE LIMITED",
"INTERNACIA INDIA MARKETING PRIVATE LIMITED",
"INTERNATIONAL ADVANCED RESEARCH CENTRE FOR POWDER",
"INTERNATIONAL AEROSPACE MANUFACTURING PRIVATE LIMITED",
"INTERNATIONAL AGRICULTURAL PROCESSING PRIVATE LIMITED",
"INTERNATIONAL AIDS VACCINE INITIATIVE",
"INTERNATIONAL AIR TRANSPORT ASSOCIATION INDIA PRIVATE LIMITED",
"INTERNATIONAL AIRCRAFT SALES PRIVATE LIMITED",
"INTERNATIONAL AIRPORT HOTELS AND RESORTS PRIVATE LIMITED",
"INTERNATIONAL ASSET RECONSTRUCTION COMPANY PRIVATE LIMITED",
"INTERNATIONAL BAKERY PRODUCTS LIMITED",
"INTERNATIONAL BELTING LIMITED",
"INTERNATIONAL BEST FOOD",
"INTERNATIONAL BIOTECH PARK LIMITED",
"INTERNATIONAL BUSINESS ADVISORS LLP",
"INTERNATIONAL CANS PRIVATE LIMITED",
"INTERNATIONAL CARGO EXPRESS PRIVATE LIMITED",
"INTERNATIONAL CARGO TERMINAL PRIVATE LIMITED",
"INTERNATIONAL CARGO TERMINALS AND INFRASTRUCTURE PRIVATE LIMITED",
"INTERNATIONAL CARS AND MOTORS LIMITED",
"INTERNATIONAL CENTER FOR RESEARCH ON WOMEN",
"INTERNATIONAL CENTRE FOR GENETIC ENGINEERING AND BIOTECHNOLOGY",
"INTERNATIONAL CENTRE OF EXCELLENCE IN ENGINEERING AND MANAGEMENT",
"INTERNATIONAL CERTIFICATION SERVICES PRIVATE LIMITED CN",
"INTERNATIONAL CITY RUNNERS INDIA PRIVATE LIMITED",
"INTERNATIONAL CLEARING & SHIPPING AGENCY(INDIA) PRIVATE LIMITED",
"INTERNATIONAL COLLEGE FOR SECURITY STUDIES",
"INTERNATIONAL COLLEGE OF FINANCIAL PLANNING LIMITED",
"INTERNATIONAL COMBUSTION INDIA LIMITED",
"INTERNATIONAL COMMERCE LIMITED",
"INTERNATIONAL CONCAST PRIVATE LIMITED",
"INTERNATIONAL CONSTRUCTIONS LIMITED",
"INTERNATIONAL CONVEYORS LIMITED",
"INTERNATIONAL CORPORATE CONSULTANCY PRIVATE LIMITED",
"INTERNATIONAL CORPORATE SIGNS PRIVATE LIMITED",
"INTERNATIONAL CROPS RESEARCH INSTITUTE FOR THE SEMI-ARID TROPICS",
"INTERNATIONAL CUSTOMER LOYALTY PROGRAMMES PRIVATE LIMITED",
"INTERNATIONAL CYLINDERS PRIVATE LIMITED",
"INTERNATIONAL DELHI PUBLIC SCHOOL",
"INTERNATIONAL DESIGN AND ENGINEERING SOLUTIONS PRIVATE LIMITED",
"INTERNATIONAL DEVELOPMENT ENTERPRISES (INDIA)",
"INTERNATIONAL EARTHMOVERS",
"INTERNATIONAL ELECTRONICS & COMMUNICATION SYSTEMS PRIVATE LIMITED",
"INTERNATIONAL ESHA TECHNOLOGIES PRIVATE LIMITED",
"INTERNATIONAL FINANCE CORPORATION",
"INTERNATIONAL FINANCIAL SERVICES LTD",
"INTERNATIONAL FISCAL ASSOCIATION INDIA BRANCH",
"INTERNATIONAL FLAVOURS AND FRAGRANCES INDIA PRIVATE LIMITED",
"INTERNATIONAL FLAVOURS FRAGRANCES INDIA PRI LIMITED",
"INTERNATIONAL FORUM FOR ENVIRONMENT, SUSTAINABILITY & TECHNOLOGY",
"INTERNATIONAL FOUNDATION FOR RESEARCH AND EDUCATION",
"INTERNATIONAL FRESH FARM PRODUCTS INDIA LIMITED",
"INTERNATIONAL GEMMOLOGICAL INSTITUTE (INDIA) LIMITED",
"INTERNATIONAL GREEN SCAPES LIMITED",
"INTERNATIONAL HALLMARK & ASSAY PRIVATE LIMITED",
"INTERNATIONAL HEALTHCARE LIMITED",
"INTERNATIONAL HEALTHCARE MANAGEMENT SERVICES PRIVATE LIMITED",
"INTERNATIONAL HERBAL CORPORATION PRIVATE LIMITED",
"INTERNATIONAL HOMOEO RESEARCH PRIVATE LIMITED",
"INTERNATIONAL HOSPITAL LIMITED",
"INTERNATIONAL INDUSTRIAL GASES LTD",
"INTERNATIONAL INDUSTRIES (1942) PRIVATE LIMITED",
"INTERNATIONAL INFOCOM TECHNOLOGIES PRIVATE LIMITED",
"INTERNATIONAL INFRABUILD PRIVATE LIMITED",
"INTERNATIONAL INFRADEVELOPERS PRIVATE LIMITED",
"INTERNATIONAL INFRASTRUCTURE CONSULTANTS PRIVATE LIMITED",
"INTERNATIONAL INGREDIENTS & EXCIPIENTS PRIVATE LIMITED",
"INTERNATIONAL INITIATIVE FOR IMPACT EVALUATION (3IE)",
"INTERNATIONAL INSPECTION SERVICES PRIVATE LIMITED",
"INTERNATIONAL INSTITUE OF HOTEL MANAGEMENT",
"INTERNATIONAL INSTITUTE FOR ENERGY CONSERVATION-INDIA",
"INTERNATIONAL INSTITUTE FOR LEARNING INDIA PRIVATE LIMITED",
"INTERNATIONAL INSTITUTE FOR POPULATION SCIENCES",
"INTERNATIONAL INSTITUTE OF AVIATION PRIVATE LIMITED",
"INTERNATIONAL INSTITUTE OF BIOTECHNOLOGY AND TOXICOLOGY",
"INTERNATIONAL INSTITUTE OF BUSINESS MANAGEMENT",
"INTERNATIONAL INSTITUTE OF BUSINESS STUDIES",
"INTERNATIONAL INSTITUTE OF FINANCIAL MARKETS LIMITED.",
"INTERNATIONAL INSTITUTE OF GEMOLOGY",
"INTERNATIONAL INSTITUTE OF HOTEL MANAGEMENT",
"INTERNATIONAL INSTITUTE OF INFORMATION TECHNOLOGY",
"INTERNATIONAL INSTITUTE OF INFORMATION TECHNOLOGY BANGALORE",
"INTERNATIONAL INSTITUTE OF MANAGEMENT AND TECHNOLOGY STUDIES PRIVATE LIMITED",
"INTERNATIONAL INSTITUTE OF MANAGEMENT STUDIES IIMS PUNE",
"INTERNATIONAL INSTITUTE OF PROJECTS AND PROGRAM MANAGEMENT",
"INTERNATIONAL INSTITUTE OF SKILLS AND EXCELLENCE PRIATE LIMITED",
"INTERNATIONAL KNOWLEDGE PARK PRIVATE LIMITED",
"INTERNATIONAL LEGAL AND BUSINESS SERVICE S LLP",
"INTERNATIONAL LIVESTOCK RESEARCH INSTITUTE",
"INTERNATIONAL LOGISTICS IMPEX PRIVATE LIMITED",
"INTERNATIONAL LOHA BHANDAR PRIVATE LIMITED",
"INTERNATIONAL MANAGEMENT TECHNOLOGIES PRIVATE LIMITED",
"INTERNATIONAL MANPOWER RESOURCES PRIVATE LIMITED",
"INTERNATIONAL MARITIME INSTITUTE",
"INTERNATIONAL MARITIME INSTITUTE IMI",
"INTERNATIONAL MARKET ASSESSMENT (INDIA) PRIVATE LIMITED",
"INTERNATIONAL MEDICAL TECHNOLOGIES PRIVATE LIMITED",
"INTERNATIONAL MONEY MATTERS PRIVATE LIMITED",
"INTERNATIONAL OIL TRADING AND CONTRACTING PRIVATE LIMITED",
"INTERNATIONAL ONCOLOGY SERVICES PRIVATE LIMITED",
"INTERNATIONAL PACKAGING PRODUCTS PRIVATE LIMITED",
"INTERNATIONAL PILGRIMAGE REVOLUTION PRIVATE LIMITED",
"INTERNATIONAL PLACEWELL CONSULTANTS PRIVATE LIMITED",
"INTERNATIONAL PLANNED PARENTHOOD FEDERATION SOUTH ASIA REGION",
"INTERNATIONAL PLASTIC SOURCING PRIVATE LIMITED",
"INTERNATIONAL POWER CORPORATION PRIVATE LIMITED",
"INTERNATIONAL PRINT-O-PAC LIMITED",
"INTERNATIONAL PUBLIC SCHOOL",
"INTERNATIONAL PUBLIC SCHOOL PRIVATE LIMITED",
"INTERNATIONAL RACING GEARS PRIVATE LIMITED",
"INTERNATIONAL REAL ESTATE PARTNERS INDIA PRIVATE LIMITED",
"INTERNATIONAL REINSURANCE AND INSURANCE CONSULTANCY AND BROKING SERVICES PRIVATE LIMITED",
"INTERNATIONAL RICE RESEARCH INSTITUTE",
"INTERNATIONAL ROAD DYNAMICS SOUTH ASIA PRIVATE LIMITED",
"INTERNATIONAL SCHOOL OF BUSINESS & MEDIA",
"INTERNATIONAL SCHOOL OF CORPORATE ETIQUETTE & PROTOCOL PRIVATE LIMITED",
"INTERNATIONAL SCHOOL OF HYDERABAD",
"INTERNATIONAL SCHOOL OF SKILLS DEVELOPMENT",
"INTERNATIONAL SCHOOL SHAIKPET",
"INTERNATIONAL SEAPORT DREDGING PRIVATE LIMITED",
"INTERNATIONAL SEAPORTS (HALDIA) PRIVATE LIMITED",
"INTERNATIONAL SERVICES PVT LTD",
"INTERNATIONAL SHARED SUPPORT CENTRE PRIVATE LIMITED",
"INTERNATIONAL SHIPPERS AND TRADERS PRIVATE LIMITED",
"INTERNATIONAL SKILLS ACADEMY PRIVATE LIMITED",
"INTERNATIONAL SKILLS PRIVATE LIMITED",
"INTERNATIONAL SOCIETY FOR KRISHNA CONSCIOUSNESS",
"INTERNATIONAL SOLAR CORPORATION PRIVATE LIMITED",
"INTERNATIONAL SOS SERVICES INDIA PRIVATE LIMITED",
"INTERNATIONAL SPECIALTY PRODUCTS INDIA PRIVATE LIMITED",
"INTERNATIONAL SPIRITS AND WINES ASSOCIATION OF INDIA",
"INTERNATIONAL STEEL EXCHANGE PRIVATE LIMITED",
"INTERNATIONAL STONES INDIA PRIVATE LIMITED",
"INTERNATIONAL STUDENT RECRUITMENT AGENCY PRIVATE LIMITED",
"INTERNATIONAL SWITCHGEARS PRIVATE LIMITED",
"INTERNATIONAL TOBACOO COMPANY LIMITED",
"INTERNATIONAL TRACTORS LIMITED",
"INTERNATIONAL TRADE LINKS INSTRUMENTATION PRIVATE LIMITED",
"INTERNATIONAL TRADE LINKS PVT LTD",
"INTERNATIONAL TRAINING AND DEVELOPMENT PRIVATE LIMITED",
"INTERNATIONAL TRANSFORMERS PRIVATE LIMITED",
"INTERNATIONAL TRANSMISSION LIMITED",
"INTERNATIONAL TRAVEL HOUSE LIMITED",
"INTERNATIONAL TRIMMINGS AND LABELS INDIA PRIVATE LIMITED",
"INTERNATIONAL TUBULARS FZE",
"INTERNATIONAL TURNKEY SYSTEMS INDIA PRIVATE LIMITED",
"INTERNATIONAL UNION AGAINST TUBERCULOSIS AND LUNG DISEASE",
"INTERNATIONAL VALUE RETAIL PRIVATE LIMITED",
"INTERNATIONAL WASTE MANAGEMENT PRIVATE LIMITED",
"INTERNATIONAL YOUTH CLUB",
"INTERNET BUSINESS JAPAN COMPANY LIMITED",
"INTERNET CUSTOMER CONTACT INDIA PRIVATE LIMITED",
"INTERNET DATA SERVICES INDIA PRIVATE LIMITED",
"INTERNET EXCHANGENEXT.COM LIMITED",
"INTERNET GUARDS FORCE PRIVATE LIMITED",
"INTERNET MEDIA AND EVENTS PRIVATE LIMITED",
"INTERNET MERCHANDISE PRIVATE LIMITED",
"INTERNET PRODUCT CONSULTANTS LLP",
"INTERNET TESTING SYSTEMS INDIA PRIVATE LIMITED",
"INTERNET TEXTILES PRIVATE LIMITED",
"INTERNEX POLY PRIVATE LIMITED",
"INTERNORMEN FILTERS PRIVATE LIMITED",
"INTERO SOLUTIONS PRIVATE LIMITED",
"INTEROCEAN INSURANCE SURVEYORS AND LOSS ASSESSORS PRIVATE LIMITED",
"INTEROCEAN PROJECTS PVT LTD",
"INTEROCEAN SHIPPING INDIA PRIVATE LIMITED",
"INTEROCITY IMPEX PRIVATE LIMITED",
"INTERPACK MACHINES PRIVATE LIMITED",
"INTERPHASE ENGINEERS PRIVATE LIMITED",
"INTERPLASTICA PRIVATE LIMITED",
"ENNOVI MOBILITY SOLUTIONS INDIA PRIVATE LIMITED",
"INTERPLEX INDIA PVT LTD",
"INTERPLEX MAZZUCCHELLI PRIVATE LIMITED",
"INTERPORT GLOBAL LOGISTICS PRIVATE LIMITED",
"INTERPORT MULTIMODAL PRIVATE LIMITED",
"INTERPOWER INDUCTION PRIVATE LIMITED",
"INTERPRESS PUBLISHERS PRIVATE LTD",
"INTERPRO BULK PACKAGING PRIVATE LIMITED",
"INTERPRODUCTEC VIRTUAL LABS PRIVATE LIMITED",
"INTERPUBLICITY PRIVATE LIMITED",
"INTERPUMP HYDRAULICS INDIA PRIVATE LIMITED",
"INTERRA INFORMATION TECHNOLOGIES INDIA PRIVATE LIMITED",
"INTERRA INFOTECH INDIA PRIVATE LIMITED",
"INTERRA SYSTEMS INDIA PRIVATE LIMITED",
"INTERRAIL INDIA PRIVATE LIMITED",
"INTERROLL INDIA PRIVATE LIMITED",
"INTERSEA MARITIME LIMITED",
"INTERSIGHT HOLIDAYS PRIVATE LIMITED",
"INTERSIGHT TOURS AND TRAVELS PRIVATE LIMITED",
"INTERSIL (INDIA) PVT LIMITED",
"INTERSKALE DIGITAL MARKETING AND CONSULTING PRIVATE LIMITED",
"INTERSNACK CASHEW INDIA PRIVATE LIMITED",
"INTERSOFT DATA LABS & SOLUTIONS PRIVATE LIMITED",
"INTERSOL PROJECTS CHENNAI PRIVATE LIMITED",
"INTERSPACE COMMUNICATIONS PRIVATE LIMITED",
"INTERSPACE PROPERTIES PRIVATE LIMITED",
"INTERSPED LOGISTICS INDIA PRIVATE LIMITED",
"INTERSPENCE SOLUTIONS LLP",
"INTERSPERSE INDUSTRIES PRIVATE LIMITED",
"INTERSTATE LIQUID LOGISTICS LIMITED",
"INTERSTATE OIL CARRIER LTD",
"INTERSTELLAR SERVICES PRIVATE LIMITED",
"INTERSTELLAR TESTING CENTRE PRIVATE LIMITED",
"INTERTEC INSTRUMENTATION PRIVATE LIMITED",
"INTERTEC SOFTWARES PRIVATE LIMITED",
"INTER-TECH FITTINGS INDIA PRIVATE LIMITED",
"INTERTECH TECHNOENGINEERS LLP",
"INTERTECH TECHNOLOGIES PRIVATE LIMITED",
"INTERTEK INDIA PRIVATE LIMITED",
"INTERTERRA SERVICES PRIVATE LIMITED",
"INTERTEX PRIVATE LIMITED",
"INTERTIUM AUTOMOTIVE PRIVATE LIMITED",
"INTERTOLL INDIA CONSULTANT PRIVATE LIMITED",
"INTERTOUCH METAL BULLDINGS P LIMITED",
"INTERTRUST CORPORATE SERVICES INDIA PRIVATE LIMITED",
"INTERTRUST TECHNOLOGIES INDIA PRIVATE LIMITED",
"INTERTRUSTVITEOS CORPORATE AND FUND SERVICES PRIVATE LIMITED",
"INTER-UNIVERSITY CENTRE FOR ASTRONOMY AN",
"INTERVALVE POONAWALLA LIMITED",
"INTERVALZERO INDIA PRIVATE LIMITED",
"INTERVEIN LABORATORIES PRIVATE LIMITED",
"INTERVET INDIA PRIVATE LIMITED",
"INTERVIEW KICKSTART LLP",
"INTERVIEW STREET TECHNOLOGIES PRIVATE LIMITED",
"INTERVIEWBIT TECHNOLOGIES PRIVATE LIMITED",
"INTERWEAVE CONSULTING PRIVATE LIMITED",
"INTERWEAVE FASHIONS PRIVATE LIMITED",
"INTERWEAVE POLYTEX PRIVATE LIMITED",
"INTERWEIGHING PRIVATE LIMITED",
"INTERWELL STEELS PRIVATE LIMITED",
"INTERWINGS DECOR AND TRADERS PRIVATE LIMITED",
"INTERWOOD KITCHENS PRIVATE LIMITED",
"INTERWORLD CARGO CARE PRIVATE LIMITED",
"INTERWORLD DIGITAL CINEMA PRIVATE LIMITED",
"INTERWORLD FURNISHINGS (INDIA) PRIVATE LIMITED",
"INTERWRAP CORP PRIVATE LIMITED",
"INTESAS INDUSTRIES PRIVATE LIMITED",
"INTESOLS PRIVATE LIMITED",
"INTESOME SOLUTIONS PRIVATE LIMITED",
"INTEVA PRODUCTS INDIA AUTOMOTIVE PRIVATE LIMITED",
"INTEX FABRICS PRIVATE LIMITED",
"INTEX GEARS PRIVATE LIMITED",
"INTEX INFRAPROJECTS PRIVATE LIMITED",
"INTEX INTERNATIONAL TRADING & CLEARING PRIVATE LIMITED",
"INTEX INTERNET SOLUTIONS PRIVATE LIMITED",
"INTEX SOLUTIONS PRIVATE LIMITED",
"INTEX SPACE SOLUTIONS PRIVATE LIMITED",
"INTEXLOGISTICS INDIA PRIVATE LIMITED",
"INTEXSO BIOCHEM PRIVATE LIMITED",
"INTEZINE LIFESTYLES PRIVATE LIMITED",
"INTIE AUTOPARTS TRADING PRIVATE LIMITED",
"INTIGATE TECHNOLOGIES PRIVATE LIMITED",
"INTIGINIS PROMOTIONS PRIVATE LIMITED",
"INTIGREE BIOMED PRIVATE LIMITED",
"INTIM LAMINATES PRIVATE LIMITED",
"INTIMAR SERVICES PRIVATE LIMITED",
"INTIMATE FASHIONS INDIA PRIVATE LIMITED",
"INTIMATE FLEXI PACK PRIVATE LIMITED",
"INTIMATE JEWELS PRIVATE LIMITED",
"INTIMATE MULTY PLAST PRIVATE LIMITED",
"INTIME COMMOTRADE PRIVATE LIMITED",
"INTIME CONSULTANTS LLP",
"INTIME EQUITIES LIMITED",
"INTIME FIRE APPLIANCES PRIVATE LIMITED",
"INTIME FREIGHT & FORWARDERS PRIVATE LIMITED",
"IN-TIME GARMENTS PVT. LTD.",
"INTIME KNITS PRIVATE LIMITED",
"INTIME MULTI COMMODITY COMPANY LIMITED",
"INTIME PROPERTIES LIMITED",
"INTIME SERVICES (MUMBAI) PRIVATE LIMITED",
"INTIME VINCOM PRIVATE LIMITED",
"INTIMETEC VISIONSOFT PRIVATE LIMITED",
"INTIMI INDIA LIMITED",
"INTIQUAL TECHNOLOGIES LIMITED",
"INTIS AUCTIONS PRIVATE LIMITED",
"INTIVIA INFORMATICS INDIA PRIVATE LIMITED",
"INTL CROPS RES INST FOR SEMI-ARID TRO",
"INTL FCSTONE TECHNOLOGY SERVICES PRIVATE LIMITED",
"INTL INST FOR SPECIAL EDUCATION",
"INTL RISK CONSULTANTS INSURANCE BROKERS PRIVATE LIMITED",
"INTLUM TECHNOLOGY PRIVATE LIMITED",
"INTMPE CONSULTING PRIVATE LIMITED",
"INTO EDUCATION INDIA PRIVATE LIMITED",
"INTO WELLNESS PRIVATE LIMITED",
"INTOKU BUYING SERVICES PRIVATE LIMITED",
"INTOLCAST PVT LTD",
"INTONATION RESEARCH LABORATORIES PRIVATE LIMITED",
"INTONE NETWORKS (INDIA) PRIVATE LIMITED",
"INTONE NETWORKS INDIA PRIVATE LIMITED",
"INTORQ INDIA PRIVATE LIMITED",
"INTOUCH CONSTRUCTION AND INFRASTRUCTURE PRIVATE LIMITED",
"INTOUCH CONSUMER CARE SOLUTIONS PRIVATE LIMITED",
"INTOUCH LEATHER HOUSE INDIA PRIVATE LIMITED",
"INTOUCH MOBICARE PRIVATE LIMITED",
"INTOUCH SYSTEMS PRIVATE LIMITED",
"INTOVAS ENGINEERING PRIVATE LIMITED",
"INTOX PRIVATE LIMITED",
"INTOZI TECH PRIVATE LIMITED",
"INTRA GLOBUS BIOSYSTEMS PRIVATE LIMITED",
"INTRA INDUSTRIES PRIVATE LIMITED",
"INTRA OCULAR CARE PRIVATE LIMITED",
"INTRA TECH COMPUTERS PRIVATE LIMITED",
"INTRAC SYSTEMS PRIVATE LIMITED",
"INTRAC TYRES PRIVATE LIMITED",
"INTRACO IMPEX PRIVATE LIMITED",
"INTRADO EC INDIA PRIVATE LIMITED",
"INTRAEDGE TECHNOLOGIES PRIVATE LIMITED",
"INTRAGLOBE ONLINE TRADE LIMITED",
"INTRAGLOBE TRANSPORT SOLUTIONS PRIVATE LIMITED",
"INTRAGO ENTERPRISES INDIA PRIVATE LIMITED",
"INTRAHEALTH INTERNATIONAL INC",
"INTRALAIT ENGINEERING TECHNOLOGIES PRIVATE LIMITED",
"INTRALOG AUTOMATION PRIVATE LIMITED",
"INTRALOX (INDIA) PRIVATE LIMITED",
"INTRANS ELECTRO COMPONENTS PVT LTD",
"INTRANS LOGISTICS PRIVATE LIMITED",
"INTRAPAY PRODUCT SOLUTIONS PRIVATE LIMITED",
"INTRASOFT TECHNOLOGIES LIMITED",
"INTRASPATIAL SOFTECH PRIVATE LIMITED",
"INTRAXIS BUSINESS LIMITED",
"INTREDEN EXIM PRIVATE LIMITED",
"INTREND TEXTILES PRIVATE LIMITED",
"INTREPID MARKETING & COMMUNICATIONS PRIVATE LIMITED",
"INTREPID ONLINE RETAIL PRIVATE LIMITED",
"INTREPID RELIANT LIMITED",
"INTREPID TOURS INDIA PRIVATE LIMITED",
"INTREPID WORKS PRIVATE LIMITED",
"INTRICAST PRIVATE LIMITED",
"INTRICATE ENGINEERING PRIVATE LIMITED",
"INTRICS SOLUTIONS PRIVATE LIMITED",
"INTRION PHARMA",
"INTRISKELION LABS PRIVATE LIMITED",
"INTRIX INTEGRATED SERVICES PRIVATE LIMITED",
"INTRO REQUIRO PRIVATE LIMITED",
"INTRODUCTION TRADE SHOWS PRIVATE LIMITED",
"INTROHIVE TECHNOLOGIES INDIA PRIVATE LIMITED",
"INTROLLIGENT SOLUTIONS PRIVATE LIMITED",
"INTRON LIFE SCIENCES PRIVATE LIMITED",
"INTROUPE LLP",
"INTRUST GLOBAL ESERVICES PRIVATE LIMITED",
"INTSOL CONSULTANTS PRIVATE LIMITED",
"INTSYS TECHNOLOGIES PRIVATE LIMITED",
"INTUERI CONSULTING LLP",
"INTUGINE TECHNOLOGIES PRIVATE LIMITED",
"INTUINO BUSINESS CONSULTING INDIA PRIVATE LIMITED",
"INTUIT INDIA PRODUCT DEVELOPMENT CENTRE PRIVATE LIMITED",
"INTUIT INDIA TECHNOLOGY AND SERVICES LLP",
"INTUIT MICRO TECHNOLOGY PRIVATE LIMITED",
"INTUITECH TOOL COMPANY INDIA PRIVATE LIMITED",
"INTUITIVE COMMERCE PRIVATE LIMITED",
"INTUITIVE SURGICAL INDIA PRIVATE LIMITED",
"INTUITOR SOFTTECH SERVICES PRIVATE LIMITED",
"INTUZ SOLUTIONS PRIVATE LIMITED",
"INTVET PROUDCTS MANUFACTURING COMPANY PRIVATE LIMITED",
"INTYK SYSTEMS PRIVATE LIMITED",
"INUBE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"INULITE NUTRACEUTICALS PRIVATE LIMITED",
"INURTURE GALILEO INDIA PRIVATE LIMITED",
"INUUS INFRASTRUCTURE PRIVATE LIMITED",
"INUXU DIGITAL MEDIA TECHNOLOGIES PRIVATE LIMITED",
"INVA POWER SYSTEMS PRIVATE LIMITED",
"INVAATI MANAGEMENT CONSULTING LLP",
"INVAC CAST LIMITED",
"INVACO PRIVATE LIMITED",
"INVADER TECHNOLOGIES PRIVATE LIMITED",
"INVANOS WEB SOLUTIONS PRIVATE LIMITED",
"INVANSYS TECHNOLOGIES PRIVATE LIMITED",
"INVANTAGE BUSINESS SERVICES PRIVATE LIMITED",
"INVARIA TECH INDIA PRIVATE LIMITED",
"INVAS TECHNOLOGIES PRIVATE LIMITED",
"INVASCENT ADVISORY SERVICES INDIA PRIVATE LIMITED",
"INVASION PHARMACEUTICALS PRIVATE LIMITED",
"INVASIVE PROTECTIVE SECURITY GUARDS PRIVATE LIMITED",
"INVASYSTEMS DIGITAL INDIA PRIVATE LIMITED",
"INVASYSTEMS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"INVC WELLNESS PRIVATE LIMITED",
"INVECAS TECHNOLOGIES PRIVATE LIMITED",
"INVEL COMMERCIAL PVT. LTD.",
"INVEL TECHNOLOGIES PRIVATE LIMITED",
"INVEN PHARMACEUTICALS PRIVATE LIMITED",
"INVENDIS TECHNOLOGIES INDIA PRIVATE LIMITED",
"INVENGER TECHNOLOGIES PRIVATE LIMITED",
"INVENIO BUSINESS SOLUTIONS PRIVATE LIMITED",
"INVENIOLIFE TECHNOLOGY PRIVATE LIMITED",
"INVENIRE ENERGY PRIVATE LIMITED",
"INVENIRE PETRODYNE LIMITED",
"INVENSIS TECHNOLOGIES PRIVATE LIMITED",
"INVENSOFT TECHNOLOGIES PRIVATE LIMITED",
"INVENSYS DEVELOPMENT CENTRE INDIA LIMITED",
"INVENT ASSETS SECURITISATION AND RECONSTRUCTION PRIVATE LIMITED",
"INVENT CAST PRIVATE LIMITED",
"INVENT SOFTLABS (INDIA) PRIVATE LIMITED",
"INVENT SOFTLABS INDIA PRIVATE LIMITED",
"INVENT SOLUTIONS PRIVATE LIMITED",
"INVENT WELD AUTOMATION PRIVATE LIMITED",
"INVENTA CLEANTEC PRIVATE LIMITED",
"INVENTA DIGITAL TECHNOLOGIES PRIVATE LIMITED",
"INVENTA INTERNATIONAL LIMITED",
"INVENTA TECHNOLOGIES PRIVATE LIMITED",
"INVENTAA CHEMICALS LIMITED",
"INVENTAA INDUSTRIES PRIVATE LIMITED",
"INVENTAA LED LIGHTS PRIVATE LIMITED",
"INVENTAA MOULDINGS PRIVATE LIMITED",
"INVENTANT EDUCATION",
"INVENTCOLABS INFOTECH PRIVATE LIMITED",
"INVENTCORP TECHNOLOGIES LIMITED",
"INVENTE INNOVATION LABS PRIVATE LIMITED",
"INVENTEC SYSTEMS PRIVATE LIMITED",
"INVENTECH INFO SOLUTIONS PRIVATE LIMITED",
"INVENTEL CONSTRUCTIONS PRIVATE LIMITED",
"INVENTGRID INDIA PRIVATE LIMITED",
"INVENTIA HEALTHCARE LIMITED",
"INVENTIA HEALTHCARE PRIVATE LIMITED",
"INVENTIA TECHNOLOGY CONSULTANTS PRIVATE LIMITED",
"INVENTICO STUDIOS PRIVATE LIMITED",
"INVENTICON BUSINESS INTELLIGENCE PRIVATE LIMITED",
"INVENTINDIA INNOVATIONS PRIVATE LIMITED",
"INVENTION EVOLUTION COMPOSITION (INDIA) PRIVATE LIMITED",
"INVENTION LABS ENGINEERING PRODUCTS PRIVATE LIMITED",
"INVENTIS PROJECTS PRIVATE LIMITED",
"INVENTIS RETAIL INDIA PRIVATE LIMITED",
"INVENTIS TECHNOSYS PRIVATE LIMITED",
"INVENTIUS TECHNOLOGIES PRIVATE LIMITED",
"INVENTIV INTERNATIONAL PHARMA SERVICES PRIVATE LIMITED",
"INVENTIVA LABS PRIVATE LIMITED",
"INVENTIVE ALLOY CAST PRIVATE LIMITED",
"INVENTIVE ENGINEERING AND TECHNOLOGY PRIVATE LIMITED",
"INVENTIVE GLOBAL SOLUTIONS PRIVATE LIMITED",
"INVENTIVE INFRA & AUTOMATION ENGINEERING PRIVATE LIMITED",
"INVENTIVE INTELTECH PRIVATE LIMITED",
"INVENTIVE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"INVENTIVE SOLUTIONS PRIVATE LIMITED",
"INVENTIZ ENTERPRISES PRIVATE LIMITED",
"INVENTO LABS PRIVATE LIMITED",
"INVENTO MAKERSPACES PRIVATE LIMITED",
"INVENTORS EDUCATION PRIVATE LIMITED",
"INVENTORY PRO-AUDIO DISTRIBUTORS PRIVATE LIMITED",
"INVENTROM PRIVATE LIMITED",
"INVENTRONICS SSL INDIA PRIVATE LIMITED",
"INVENTUM ENGINEERING COMPANY PRIVATE LIMITED",
"INVENTUM MACHINE TOOLS PRIVATE LIMITED",
"INVENTUM TECHNOLOGIES PRIVATE LIMITED",
"INVENTURE COMMODITIES LIMITED",
"INVENTURE ENGINEERING INDIA PRIVATE LIMITED",
"INVENTURE SEJAL REALTORS PRIVATE LIMITED",
"INVENTURUS KNOWLEDGE SOLUTIONS LIMITED",
"INVENTURUS KNOWLEDGE SOLUTIONS PRIVATE LIMITED",
"INVENTURUS KNOWLEDGE SOLUTIONS PRIVATE. LIMITED",
"INVENTYS RESEARCH COMPANY PRIVATE LIMITED",
"INVENZO LABS INDIA PRIVATE LIMITED",
"INVER BRAS ELECTRICALS PRIVATE LIMITED",
"INVERIKA BIORESEARCH PRIVATE LIMITED",
"INVERSION MANAGEMENT SERVICES PRIVATE LIMITED",
"INVERT SUGAR INDIA LIMITED",
"INVERTED COMMAS ARTIST MANAGEMENT P LIMITED",
"INVERTEDI IT CONSULTANCY PRIVATE LIMITED",
"INVESCO (INDIA) PRIVATE LIMITED",
"INVESCO ASSET MANAGEMENT INDIA PRIVATE LIMITED",
"INVEST CARE PRIVATE LIMITED",
"INVEST GOLD AND GENERAL FINANCE PRIVATE LIMITED",
"INVEST IN REALITY LLP",
"INVEST INDIA",
"INVEST INDIA SECURITIES PRIVATE LIMITED",
"INVEST KARNATAKA FORUM",
"INVEST UP (INVESTMENT PROMOTION & FACILITATION AGENCY OF GOVT OF UTTAR PRADESH)",
"INVEST19 TECHNOLOGIES PRIVATE LIMITED",
"INVESTA FABRICATORS AND ENGINEERS PRIVATE LIMITED",
"INVESTACC INSURANCE BROKERS PRIVATE LIMITED",
"INVESTALLIGN SECURITIES PRIVATE LIMITED",
"INVESTCARE REALTY LLP",
"INVESTCORP INDIA ASSET MANAGERS PRIVATE LIMITED",
"INVESTEC CAPITAL SERVICES INDIA PRIVATE LIMITED",
"INVESTEC GLOBAL SERVICES (INDIA) PRIVATE LIMITED",
"INVESTERIA FINANCIAL SERVICES PRIVATE LIMITED",
"INVESTEURS CONSULTING PRIVATE LIMITED",
"INVESTIS DIGITAL INDIA PRIVATE LIMITED",
"INVESTMENT RESEARCH AND INFORMATION SERVICES LIMITED",
"INVESTMENTOR SECURITIES LIMITED",
"INVESTOR HOME SOLUTIONS PRIVATE LIMITED",
"INVESTOR SHOPPE CONSULTANCY PRIVATE LIMITED",
"INVESTORS CLINIC INFRATECH PRIVATE LIMITED",
"INVESTORS FINANCIAL EDUCATION ACADEMY",
"INVESTOXPERT ADVISORS PRIVATE LIMITED",
"INVESTPRO FINANCIAL SERVICES PRIVATE LIMITED",
"INVESTREKK GLOBAL RESEARCH PRIVATE LIMITED",
"INVESTSMART INDIA LIMITED",
"INVESTSMART STOCK BROKERS PRIVATE LIMITED",
"INVESTWELL AGENTS PVT LTD",
"INVESTWELL FINANCE AND LEASING PRIVATE LIMITED",
"INVETERATE SOLUTIONS PRIVATE LIMITED",
"INVEX HEALTH PRIVATE LIMITED",
"INVIBE IMPEX PRIVATE LIMITED",
"INVICARA INDIA PRIVATE LIMITED",
"INVICON HOMES PRIVATE LIMITED",
"INVICTA AGRITECH INDIA PRIVATE LIMITED",
"INVICTA DESIGN TECHNOLOGIES PRIVATE LIMITED",
"INVICTA DURASTEEL PRIVATE LIMITED",
"INVICTA MEDIA PRIVATE LIMITED",
"INVICTO SOFTWARE SOLUTIONS PRIVATE LIMITED",
"INVICTUS ARSV PRIVATE LIMITED",
"INVICTUS AUTOTEK PRIVATE LIMITED",
"INVICTUS FARMER PRODUCER COMPANY LIMITED",
"INVICTUS ONCOLOGY PRIVATE LIMITED",
"INVICTUS POLYPACK (INTERNATIONAL) PRIVATE LIMITED",
"INVICTUS POLYPACK PRIVATE LIMITED",
"INVICTUS PRIME PRIVATE LIMITED",
"INVICTUS T MEDIAWORKS PRIVATE LIMITED",
"INVIDA TRANS IT SOLUTIONS PRIVATE LIMITED",
"INVIDI TECHNOLOGIES INDIA PRIVATE LIMITED",
"INVIGO SOFTWARE PRIVATE LIMITED",
"INVIGO TEA PRIVATE LIMITED",
"INVIL CONSULTANTS AND TRADER PVT LTD",
"INVILOGIC SOFTWARE PRIVATE LIMITED",
"INVILOGUE SOLUTIONS PRIVATE LIMITED",
"INVIMATIC TECHNOLOGIES PRIVATE LIMITED",
"INVIN SOLUTIONS PRIVATE LIMITED",
"INVINCIBLE BUILDERS PRIVATE LIMITED",
"INVINCIBLE BUSINESS SOLUTIONS PRIVATE LIMITED",
"INVINCIBLE PROJECT LOGISTICS PRIVATE LIMITED",
"INVINCIBLE SOFTWARE SOLUTIONS INTEGRATED PRIVATE LIMITED",
"INVINCIBLE TECH SYSTEMS INDIA PRIVATE LIMITED",
"INVIS PRIVATE LIMITED",
"INVISALIGN INDIA LLP",
"INVISIA BPO SOLUTIONS PRIVATE LIMITED",
"INVISION AIR SERVICES PRIVATE LIMITED",
"INVISION COMMUNICATIONS AND RESEARCH PRIVATE LIMITED",
"INVISION MEDI SCIENCES PRIVATE LIMITED",
"INVISION PHARMA LIMITED",
"INVITRA TECHNOLOGIES PRIVATE LIMITED",
"INVITRO BABY PRIVATE LIMITED",
"INVITRO BIO SYSTEMS PRIVATE LIMITED",
"INVITRO INTERNATIONAL PRIVATE LIMITED",
"INVITRO RESEARCH SOLUTIONS PRIVATE LIMITED",
"INVITRO SPECIALITYLAB PRIVATE LIMITED",
"INVITROGEN BIOSERVICES INDIA PRIVATE LIMITED",
"INVITRON ADVANCED ANALYTICS PRIVATE LIMITED",
"INVIXIUM ACCESS PRIVATE LIMITED",
"INVIXO CHEMICALS PRIVATE LIMITED",
"INVIXO INTERIORS PRIVATE LIMITED",
"INVN-TREE INTELLECTUAL PROPERTY SERVICES PRIVATE LIMITED",
"INVO MEDICS PRIVATE LIMITED",
"INVO PACK PRIVATE LIMITED",
"INVOBUILD INFRATECH PRIVATE LIMITED",
"INVOKE INFRACARE PRIVATE LIMITED",
"INVOKE MEDICAL SYSTEM PRIVATE LIMITED",
"INVOLUTE ENGINEERING PRIVATE LIMITED",
"INVOLUTE INSTITUTE OF TECHNICAL TRAINING PRIVATE LIMITED",
"INVOLUTE POWERGEAR PRIVATE LIMITED",
"INVOR BUILDTECH PRIVATE LIMITED",
"INVOTEC AUTOMATION PRIVATE LIMITED",
"INVOXEL TECHNOLOGIES PRIVATE LIMITED",
"INVRECO PRIVATE LIMITED",
"INVT ELECTRIC INDIA PRIVATE LIMITED",
"INWAY TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"INWENTRA GLOBAL CONSULTANCY (INDIA) PRIVATE LIMITED",
"INWIZARDS SOFTWARE TECHNOLOGY PRIVATE LIMITED",
"INX MUSIC PRIVATE LIMITED",
"INXEE SYSTEMS PRIVATE LIMITED",
"INXITE-OUT PRIVATE LIMITED",
"INXPRESS INDIA PRIVATE LIMITED",
"INXS CONCRETE SOLUTIONS PRIVATE LIMITED",
"INXS CREATIONS PRIVATE LIMITED",
"INXUS EVENTS PRIVATE LIMITED",
"INXYS TECH SOLUTIONS PRIVATE LIMITED",
"INYANTRA TECHNOLOGIES PRIVATE LIMITED",
"INYT TECHNOLOGIES PRIVATE LIMITED",
"INYXA INFORMATION SYSTEMS PRIVATE LIMITED",
"INZ AXIS TECH SERVICES PRIVATE LIMITED",
"INZAANA ONLYNE TECHNOLOGIES PRIVATE LIMITED",
"INZANE LABS PRIVATE LIMITED",
"INZERON TRADING & CONTRACTING",
"INZEROTECH SOFTWARE PRIVATE LIMITED",
"INZEX TEXTILE PRIVATE LIMITED",
"INZI AUTO COMPONENTS AN PRIVATE LIMITED",
"INZI CONTROLS INDIA LIMITED",
"INZIN AUTOMOTIVE MARKETPLACE PRIVATE LIMITED",
"INZPERA HEALTHSCIENCES LIMITED",
"INZPIRA EDU SOLUTIONS PRIVATE LIMITED",
"IO ELECTRONIC INDIA PRIVATE LIMITED",
"I-O SIGN INTERNATIONAL PRIVATE LIMITED",
"IOANYT INNOVATIONS PRIVATE LIMITED",
"IOBOT TECHNOLOGIES INDIA PRIVATE LIMITED",
"IOCC SHIPPING PRIVATE LIMITED",
"IOCFO CONSULTING PRIVATE LIMITED",
"IOCOD INFOTECH PRIVATE LIMITED",
"IODINE INDIA PHARMACEUTICALS PRIVATE LIMITED",
"IOG SOLUTIONS PRIVATE LIMITED",
"IOL CHEMICALS AND PHARMACEUTICALS LIMITED",
"IOLITE CUBE INFRAMATERIAL LIMITED",
"IOLITE SOFTWARES PRIVATE LIMITED",
"IOLITE TECHNOLOGIES PRIVATE LIMITED",
"IOMARKET SOFTWARE SERVICES PRIVATE LIMITED",
"ION AQUA MEMBRANES PRIVATE LIMITED",
"ION ARC TECHNOLOGIES PRIVATE LIMITED",
"ION BIO MED-ICARE PRIVATE LIMITED",
"ION ELECTRICALS PRIVATE LIMITED",
"ION ENERGY INFRA PRIVATE LIMITED",
"ION EXCHANGE ENVIRO FARMS LIMITED",
"ION EXCHANGE INDIA LIMITED",
"ION EXCHANGE PROJECTS AND ENGINEERING LIMITED",
"ION EXCHANGE PURIFIED DRINKING WATER PRIVATE LIMITED",
"ION EXCHANGE WATERLEAU LIMITED",
"ION FOUNDATION",
"ION HEALTHCARE PRIVATE LIMITED",
"ION SCIENCE (INDIA) PRIVATE LIMITED",
"ION TRADING INDIA PRIVATE LIMITED",
"IONBOND COATINGS PRIVATE. LIMITED",
"IONE IT SOLUTIONS PRIVATE LIMITED",
"IONIC CHEMICALS PRIVATE LIMITED",
"IONIC ENGINEERING TECHNOLOGY PRIVATE LIMITED",
"IONICS AND POLYMERS PRIVATE LIMITED",
"IONICS POWER SOLUTIONS PRIVATE LIMITED",
"IONICX DIGITAL TECHNOLOGIES PRIVATE LIMITED",
"IONIDEA ENTERPRISE SOLUTIONS PRIVATE LIMITED",
"IONIDEA INFOTECH PRIVATE LIMITED",
"IONIDEA INTERACTIVE PRIVATE LIMITED",
"IONISATION FILTRATION INDUSTRIES PRIVATE LIMITED",
"IONIXX TECHNOLOGIES PRIVATE LIMITED",
"IONO INDIA PRIVATE LIMITED",
"IONOTRONICS TECHNOLOGIES PRIVATE LIMITED",
"IONPURE SYSTEMS AND SERVICES INDIA PRIVATE LIMITED",
"IONS FILTECH PRIVATE LIMITED",
"IONS HYDRO PRIVATE LIMITED",
"IONULE LIMITED",
"IONZ DIGITAL PRIVATE LIMITED",
"IOO LABS PRIVATE LIMITED",
"IOP MARKETING AND PROMOTION SERVICES PRIVATE LIMITED",
"IOPEX TECHNOLOGIES PRIVATE LIMITED",
"IOR TECHNOLOGY PRIVATE LIMITED",
"IORA ECOLOGICAL SOLUTIONS PRIVATE LIMITED",
"IORA HOTELS PRIVATE LIMITED",
"IORBIT DIGITAL TECHNOLOGIES PRIVATE LIMITED",
"IORTA TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"IOS COMMERCE PRIVATE LIMITED",
"IOS RELOCATIONS INTERNATIONAL",
"IOSIS REMEDIES PRIVATE LIMITED",
"IOSIS SPA AND WELLNESS PRIVATE LIMITED",
"IOSX TRADING PRIVATE LIMITED",
"IOSYS SOFTWARE INDIA PRIVATE LIMITED",
"IOT DESIGN & ENGINEERING LIMITED",
"IOT MONKS PRIVATE LIMITED",
"IOT SPORTING ASPIRATIONS PRIVATE LIMITED",
"IOT UTKAL ENERGY SERVICES LIMITED",
"IOTA ANALYTICS PRIVATE LIMITED",
"IOTA EXPORTS PRIVATE LIMITED",
"IOTA FLOW SYSTEMS PRIVATE LIMITED",
"IOTA HOTELS PRIVATE LIMITED",
"IOTA INFOTECH PRIVATE LIMITED",
"IOTA MTECH LIMITED",
"IOTAP TECHNOLOGY & SOLUTIONS PRIVATE LIMITED",
"IOTAS SOLUTIONS PRIVATE LIMITED",
"IOTASOL TECHNOLOGIES PRIVATE LIMITED",
"IOTFY SOLUTIONS PRIVATE LIMITED",
"IOTIUM SYSTEMS PRIVATE LIMITED",
"IOTLYNX TECHNOLOGIES PRIVATE LIMITED",
"IOTOMATION ECOTECH PRIVATE LIMITED",
"IOTREADY TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"IOTTIVE PRIVATE LIMITED",
"IOV REGISTERED VALUERS FOUNDATION",
"IP ACCESS INDIA PRIVATE LIMITED",
"IP CLEANING INDIA PRIVATE LIMITED",
"IP COLLEGE OF LAW",
"IP CORE SOLUTIONS INDIA PRIVATE LIMITED",
"IP HEIGHTS NETWORK SOLUTIONS PRIVATE LIMITED",
"IP INFUSION SOFTWARE INDIA PRIVATE LIMITED",
"IP INNOVATIVE PUBLICATION PRIVATE LIMITED",
"IP PHARMACEUTICALS INDIA PRIVATE LIMITED",
"IP RINGS LIMITED",
"IP SOFTCOM INDIA PRIVATE LIMITED",
"IP VENTURE ADVISORS PRIVATE LIMITED",
"IPA PRIVATE LIMITED",
"IPAC AUTOMATION PRIVATE LIMITED",
"IPAC PAPER BOARDS (INDIA) PRIVATE LIMITED",
"IPACESETTERS SOLUTIONS PRIVATE LIMITED",
"IPACK MANUFACTURERS PRIVATE LIMITED",
"IPAN REAL ESTATE PRIVATE LIMITED",
"IPANN MACHINERIES (INDIA) PRIVATE LIMITED",
"IPAS DEVELOPMENT FOUNDATION",
"IPASS INDIA PRIVATE LIMITED",
"IPATH SOLUTIONS",
"IPATH TECHNOLOGIES PRIVATE LIMITED",
"IPATHLABS MEDICAL SOLUTIONS PRIVATE LIMITED",
"IPAY TECH INDIA PRIVATE LIMITED",
"IPB CAPITAL ADVISORS LLP",
"IPC HEALTHCARE PRIVATE LIMITED",
"IPC INDUS POWER TECHNOLOGY PRIVATE LIMITED",
"IPC INFORMATION SYSTEMS INDIA PRIVATE LIMITED",
"IPC TECHNOLOGY CONSULTING PRIVATE LIMITED",
"IPCA LABORATORIES LIMITED",
"IP-COMMERCIAL PRIVATE LIMITED",
"IPCON INTERNATIONAL PVT LTD",
"IPCOS ENGINEERING SOLUTIONS PRIVATE LIMITED",
"IPCOS POE ENGINEERING SOLUTIONS PRIVATE LIMITED",
"IPCRESS FINANCE & SECURITIES PRIVATE LIMITED",
"IPDIGITAL TECHNOLOGIES PRIVATE LIMITED",
"IPDM SERVICES INDIA PRIVATE LIMITED",
"IPDNA COMMUNICATIONS AND SERVICES PRIVATE LIMITED",
"IPE GLOBAL LIMITED",
"IPEC ENGINEERING PRIVATE LIMITED",
"IPEC INDIA PRIVATE LIMITED",
"IPEC PROJECT SERVICES PRIVATE LIMITED",
"IPEM INTERNATIONAL SCHOOL PRAYAGRAJ",
"IPENGINE MANAGEMENT INDIA PRIVATE LIMITED",
"IPEOPLE BUSINESS SOLUTIONS PRIVATE LIMITED",
"IPERFORMANCE MEDIA PRIVATE LIMITED",
"IPETRONIK INDIA PRIVATE LIMITED",
"IPEX BEARINGS PRIVATE LIMITED",
"IPEXCEL SERVICES PRIVATE LIMITED",
"IPEXX GLOBAL INDIA PRIVATE LIMITED",
"IPF - VIKRAM INDIA LIMITED",
"IPF - VIKRAM INDIA PRIVATE LIMITED",
"IPF FACILITY MANAGEMENT INDIA PRIVATE LIMITED",
"IPF SECURITY SOLUTIONS PRIVATE LIMITED",
"IPG ADVERTISING AND BUSINESS SERVICES LL P",
"IPG ASIA PRIVATE LIMITED",
"IPG DXTRA INDIA PRIVATE LIMITED",
"IPG MOULDTECH INDIA PRIVATE LIMITED",
"IPG PHOTONICS INDIA PRIVATE LIMITED",
"IPGST INDIA PRIVATE LIMITED",
"IPHARRM PROCESS TECHNOLOGIES PRIVATE LIMITED",
"IPI INDIA PRIVATE LIMITED",
"IPITATA COMMOTRADE PVT LTD",
"IPL BIOLOGICALS LIMITED",
"IPL PRODUCTS",
"IPLACE INDIA PRIVATE LIMITED",
"IPLANET CLOUD SOLUTIONS PRIVATE LIMITED",
"IPLEX INDIA PRIVATE LIMITED",
"IPLON INDIA PRIVATE LIMITED",
"IPM BIO CONTROL LABS PRIVATE LIMITED",
"IPM COMMODITIES PRIVATE LIMITED",
"IPM ENGINEERING LIMITED",
"IPM ENTERPRISES PRIVATE LIMITED",
"IPM INDIA WHOLESALE TRADING PRIVATE LIMITED",
"IPM INFRATECH PRIVATE LIMITED",
"IPMOVERS IT PRIVATE LIMITED",
"IPOA MUMBAI PRIVATE LIMITED",
"IPOOLS INDIA PRIVATE LIMITED",
"IPOST COURIER NETWORK SERVICES PRIVATE LIMITED",
"IPOWER BATTERIES PRIVATE LIMITED",
"IPP CATALOG PUBLICATIONS PRIVATE LIMITED",
"IPPN CONSTRUCTION COMPANY PRIVATE LIMITED",
"IPPRO SERVICES INDIA PRIVATE LIMITED",
"IPR TECHNOLOGIES PRIVATE LIMITED",
"IPRA SECURITY SOLUTIONS PRIVATE LIMITED",
"IPRAGMATECH SOLUTIONS PRIVATE LIMITED",
"IPREALM TECHNOLOGIES PRIVATE LIMITED",
"IPRIMED EDUCATION SOLUTIONS PRIVATE LIMITED",
"IPRIMOFOCUS TECHNOLOGIES PRIVATE LIMITED",
"I-PROBONO (INDIA) LEGAL SERVICES",
"IPROCESS CLINICAL MARKETING PRIVATE LIMITED",
"IPROF LEARNING SOLUTIONS INDIA PRIVATE LIMITED",
"IPROGRAMMER SOLUTIONS PRIVATE LIMITED",
"IPROTECHS COMMERCIAL SOLUTIONS PRIVATE LIMITED",
"IPS ACADEMY",
"IPS AUTOMATION PRODUCTS PRIVATE LIMITED",
"IPS E SERVICES PRIVATE LIMITED",
"IPS MEHTALIA PRIVATE LIMITED",
"IPS VANTAGE TECH SERVICES PRIVATE LIMITED",
"IPSA BUSINESS INDIA PRIVATE LIMITED",
"IPSA LABS PRIVATE LIMITED",
"IPSA OVERSEAS PRIVATE LIMITED",
"IPSA SYSTEMS (INDIA) PRIVATE LIMITED",
"IPSA TEXCHEM PRIVATE LIMITED",
"IPSAA HOLDINGS PRIVATE LIMITED",
"IPSATOR ANALYTICS PRIVATE LIMITED",
"IPSCOM RETURNABLE PRIVATE LIMITED",
"IPSD PUBLICATIONS PRIVATE LIMITED",
"IPSEN TECHNOLOGIES PRIVATE LIMITED",
"IPSIT CONSULTANTS PRIVATE LIMITED",
"IPSIT ENTERPRISES PRIVATE LIMITED",
"IPSOFT GLOBAL SERVICES PRIVATE LIMITED",
"IPSOL HEALTHCARE PRIVATE LIMITED",
"IPSONS PHARMA EQUIPMENTS PRIVATE LIMITED",
"IPSOS RESEARCH PRIVATE LIMITED",
"IPSR SOLUTIONS LIMITED",
"IPSTAR (INDIA) PRIVATE LIMITED",
"IPSUM MEDICARE PRIVATE LIMITED",
"IPSUM PROADVISORS PRIVATE LIMITED",
"IQ BACK OFFICE INDIA PRIVATE LIMITED",
"IQ GENERAL SYSTEMS PRIVATE LIMITED",
"IQ INNOVATION HUB LLP",
"IQ PEST CONTROL PRIVATE LIMITED",
"IQ SUPPLY CHAIN SERVICES OPC PRIVATE LIMITED",
"IQ TECHLINE",
"IQBAL GARMENTS PRIVATE LIMITED",
"IQBAL IMPEX PRIVATE LIMITED",
"IQBAL TEA TRADER PRIVATE LIMITED",
"IQBALIA JUNIOR COLLEGE",
"IQBRI VERTICALS PRIVATE LIMITED",
"IQF FOODS PRIVATE LIMITED",
"IQGATEWAY PRIVATE LIMITED",
"IQGEN-X PHARMA PRIVATE LIMITED",
"IQHOM PRIVATE LIMITED",
"IQLANCE SOLUTIONS PRIVATE LIMITED",
"IQOO MOBILE INDIA PRIVATE LIMITED",
"IQOR INDIA SERVICES PRIVATE LIMITED",
"IQR ANALYTICS PRIVATE LIMITED",
"IQR CONSULTING PRIVATE LIMITED",
"IQRA AIRCON PRIVATE LIMITED",
"IQRA DISPLAYS PRIVATE LIMITED",
"IQRA INTERIORS PRIVATE LIMITED",
"IQRA PORTABLE SYSTEMS PRIVATE LIMITED",
"IQRA STEEL AND TUBES PRIVATE LIMITED",
"IQRUP DESIGNS FURNITURE PRIVATE LIMITED",
"IQRUP RITZ DESIGN PRIVATE LIMITED",
"IQS ENGINEERING SOLUTIONS PRIVATE LIMITED",
"IQS SYSTEMS AND ENGINEERS INDIA PRIVATE LIMITED",
"IQSR CERTIFICATION SERVICES PRIVATE LIMITED",
"IQTEK SOFTWARE LIMITED",
"IQTRON ENTERPRISES PRIVATE LIMITED",
"IQU POWER COMPANY PVT LIMITED",
"IQUADRA INFORMATION SERVICES PRIVATE LIMITED",
"IQUANTELA TECHNOLOGIES PRIVATE LIMITED",
"IQUANTI INDIA PRIVATE LIMITED",
"I-QUANTUM SOLUTIONS PRIVATE LIMITED",
"IQUASAR SOFTWARE SOLUTIONS PRIVATE LIMITED",
"IQUBX PRIVATE LIMITED",
"IQVIA ANALYTICS SERVICES PRIVATE LIMITED",
"IQVIA CONSULTING AND INFORMATION SERVICES INDIA PRIVATE LIMITED",
"IQVIA HEALTH TRANSFORMATION FOUNDATION",
"IQVIA RDS INDIA PRIVATE LIMITED",
"IQZ DESIGNS PRIVATE LIMITED",
"IQZ SYSTEMS PRIVATE LIMITED",
"IR ACCESSORIES PRIVATE LIMITED",
"IR CIVIL ENGINEERS & CONTRACTORS PRIVATE LIMITED",
"IR EXPORTS PRIVATE LIMITED",
"IR INNOVATE RESEARCH PRIVATE LIMITED",
"IR SOLUTIONS",
"IR VENTURES PRIVATE LIMITED",
"IRA BY ORCHID HOTELS",
"IRA EDUTECH PRIVATE LIMITED",
"IRA EXIM PRIVATE LIMITED",
"IRA GLOBAL SCHOOL",
"IRA INFRASTRUCTURE PPRIVATE LIMITED",
"IRA LIFECARE PRIVATE LIMITED",
"IRA POWER PRIVATE LIMITED",
"IRA PRATHMIK URDU SHALA NER DIST YAVATMAL",
"IRA RESORTS PRIVATE LIMITED",
"IRA STEEL CORPORATION PRIVATE LIMITED",
"IRA WEALTH",
"IRACHEM LIMITED",
"IRADIUM AUTOMOBILES PRIVATE LIMITED",
"IRAGE BROKING SERVICES LLP",
"IRAI ROOFING SHEET INDIA PRIVATE LIMITED",
"IRAJ CONTRACT MANUFACTURING PRIVATE LIMITED",
"IRAJ EVOLUTION DESIGN COMPANY PRIVATE LIMITED",
"IRAJE SOFTWARE CONSULTANTS PRIVATE LIMITED",
"IRAKI ENTERPRISE LIMITED",
"IRAM TECHNOLOGIES PRIVATE LIMITED",
"IRAMA GLOBAL SERVICES PRIVATE LIMITED",
"IRANI FOODS AND INVESTMENT COMPANY PRIVATE LIMITED",
"IRANNA STUDIO PRIVATE LIMITED",
"IRAVATI GOODS PRIVATE LIMITED",
"IRAVATI INDUSTRIES",
"IRAX TECH PRIVATE LIMITED",
"I-RAY IT SOLUTIONS PRIVATE LIMITED",
"IRAYNA IMPEX PRIVATE LIMITED",
"IRAYO TECHNOLOGIES PRIVATE LIMITED",
"IRAYS MEDTECH SOLUTIONS PRIVATE LIMITED",
"IRB AHMEDABAD VADODARA SUPER EXPRESS TOLLWAY PRIVATE LIMITED",
"IRB HAPUR MORADABAD TOLLWAY LIMITED",
"IRB HOLDING PRIVATE LIMITED",
"IRB INFRASTRUCTURE DEVELOPERS LIMITED",
"IRB INFRASTRUCTURE PRIVATE LIMITED",
"IRB JAIPUR DEOLI TOLLWAY PRIVATE LIMITED",
"IRB MP EXPRESSWAY PRIVATE LIMITED",
"IRB PATHANKOT AMRITSAR TOLL ROAD PRIVATE LIMITED",
"IRB SURAT-DAHISAR TOLLWAY PRIVATE LIMITED",
"IRB TALEGAON AMRAVATI TOLLWAY PRIVATE LIMITED",
"IRB TUMKUR CHITRADURGA TOLLWAY LIMITED",
"IRB WESTCOAST TOLLWAY LIMITED",
"IRC (INDIA) LIMITED",
"IRC COMMERCIAL PRIVATE LIMITED",
"IRC CONCRETEMIX INDIA PRIVATE LIMITED",
"IRC CREDIT MANAGEMENT SERVICES LIMITED",
"IRC ENGINEERING SERVICES INDIA PVT LTD",
"IRC INDIA LIMITED",
"IRC INFRA & REALTY PRIVATE LIMITED",
"IRC LOGISTICS LIMITED",
"IRC NATURAL RESOURCES PRIVATE LIMITED",
"IRC SUPPLY CHAIN SOLUTIONS LIMITED",
"IRCLASS SYSTEMS AND SOLUTIONS PRIVATE LIMITED",
"IRCON AKLOLI-SHIRSAD EXPRESSWAY LIMITED",
"IRCON DAVANAGERE HAVERI HIGHWAY LIMITED",
"IRCON GURGAON REWARI HIGHWAY LIMITED",
"IRCON INFRASTRUCTURE & SERVICES LIMITED",
"IRCON INTERNATIONAL LIMITED",
"IRCON LUDHIANA RUPNAGAR HIGHWAY LIMITED",
"IRCON PB TOLLWAY LIMITED",
"IRCON SHIVPURI GUNA TOLLWAY LIMITED",
"IRCON TRADING AND MANUFACTURING PRIVATE LIMITED",
"IRCON VADODARA KIM EXPRESSWAY LIMITED",
"IRCON-SOMA TOLLWAY PRIVATE LIMITED",
"IRD MECHANALYSIS LIMITED",
"IRDETO TECHNOLOGY INDIA PRIVATE LIMITED",
"IRE TEX PREMIER INDIA PRIVATE LIMITED",
"IREALITIES TECHNOLOGY PRIVATE LIMITED",
"IRECO CONSTRUCTIONS PRIVATE LIMITED",
"IREFR RECRUITMENT SOLUTIONS PRIVATE LIMITED",
"IREL ENGINEERS PRIVATE LIMITED",
"IREL IDCOL LIMITED",
"IREL INDIA LIMITED",
"IRELY SOFTSERVICES INDIA PRIVATE LIMITED",
"IRENE HELATH SERVICES PRIVATE LIMITED",
"IRENES COFFEE COMPANY PRIVATE LIMITED",
"IREO GRACE REALTECH PRIVATE LIMITED",
"IREO HOSPITALITY COMPANY PRIVATE LIMITED",
"IREO MANAGEMENT PRIVATE LIMITED",
"IREO RESIDENCES COMPANY PRIVATE LIMITED",
"IREP CREDIT CAPITAL PRIVATE LIMITED",
"IREP DHAN PRIVATE LIMITED",
"IRESCO ELECTRICALS PVT LTD",
"IRESEARCH SERVICES PRIVATE LIMITED",
"IRESLAB INFO TECH PRIVATE LIMITED",
"IRETEX PREMIER INDIA PRIVATE LIMITED",
"IREWARDS SOLUTIONS PRIVATE LIMITED",
"IRFAN AGRO FOODS PRIVATE LIMITED",
"IRFC FINANCE PRIVATE LIMITED",
"IRI MARITIME AND CORPORATE SERVICES PRIVATE LIMITED",
"IRIDES LIFE WELLNESS SOLUTIONS PRIVATE LIMITED",
"IRIDESCENT APPARELS PRIVATE LIMITED",
"IRIDIUM INFRASTRUCTURE PRIVATE LIMITED",
"IRIDIUM INTERACTIVE LIMITED",
"IRIDIUM ROLLS AND TRANSMISSIONS PRIVATE LIMITED",
"IRINA HOSPITALITY PRIVATE LIMITED",
"IRINGMARA TEA CO 1951 PVT LTD",
"IRIS AUTOMATION PRIVATE LIMITED",
"IRIS BUSINESS SERVICES LIMITED",
"IRIS CERAMICA PRIVATE LIMITED",
"IRIS CLOTHINGS PRIVATE LIMITED",
"IRIS COLOURS & POLYMERS PRIVATE LIMITED",
"IRIS COMPSOFT LLP",
"IRIS COMPUTERS LIMITED",
"IRIS CORPORATE SOLUTIONS PRIVATE LIMITED",
"IRIS COSMO-COLOUR PRIVATE LIMITED",
"IRIS ECOPOWER VENTURE PRIVATE LIMITED",
"IRIS GLOBAL SERVICES PRIVATE LIMITED",
"IRIS HEALTH SERVICES LIMITED",
"IRIS HEALTHCARE TECHNOLOGIES PRIVATE LIMITED",
"IRIS HOME EXPORTS PRIVATE LIMITED",
"IRIS HR SOLUTIONS PRIVATE LIMITED",
"IRIS HYBRID SEEDS PRIVATE LIMITED",
"IRIS IMPULSE INDIA PRIVATE LIMITED",
"IRIS INDIA HOUSEHOLD SOLUTIONS PRIVATE LIMITED",
"IRIS KNITWEAR",
"IRIS KPO RESOURCING (INDIA) PRIVATE LIMITED",
"IRIS LIFE SOLUTIONS PRIVATE LIMITED",
"IRIS MANAGEMENT SERVICES PRIVATE LIMITED",
"IRIS MEDICAL SOLUTIONS PRIVATE LIMITED",
"IRIS MERCHANTILE PRIVATE LIMITED",
"IRIS OVERSEAS PRIVATE LIMITED",
"IRIS PAPER MAGIC PRIVATE LIMITED",
"IRIS PARK LEISURES PRIVATE LIMITED",
"IRIS PHARMACHEM (INDIA) PRIVATE LIMITED",
"IRIS POLYMERS INDUSTRIES PRIVATE LIMITED",
"IRIS SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"IRIS SOURCING SERVICES PRIVATE LIMITED",
"IRIS SPECTRA PRIVATE LIMITED",
"IRIS STAFFING SOLUTIONS PRIVATE LIMITED",
"IRIS VACATIONS PRIVATE LIMITED",
"IRIS WAVES PRIVATE LIMITED",
"IRIS WORLD SCHOOL",
"IRIS WORLDWIDE INTEGRATED MARKETING PRIVATE LIMITED",
"IRISE INDIA PRIVATE LIMITED",
"IRISH CONNEXXION INDIA PRIVATE LIMITED",
"IRISH EXPERT LLP",
"IRISH INFRASTRUCTURE PRIVATE LIMITED",
"IRISH PUBLICATION PRIVATE LIMITED",
"IRIX TECHNOLOGIES PRIVATE LIMITED",
"IRLA CHEQUE(3674)",
"IRM ENERGY LIMITED",
"IRM ENTERPRISES PRIVATE LIMITED",
"IRM INFRAPROJECTS PRIVATE LIMITED",
"IRM INSURANCE BROKERS PRIVATE LIMITED",
"IRM OFFSHORE AND MARINE ENGINEERS PRIVATE LIMITED",
"IRM PRIVATE LIMITED",
"IROHA INVESTMENT MANAGEMENT PRIVATE LIMITED",
"IROKO INTERIORS PRIVATE LIMITED",
"IROMETAL ALLOYS INDIA PRIVATE LIMITED",
"IRON BUILD SYSTEMS PVT LTD",
"IRON FOUNDERS & FABRICATORS(INDIA) PVT LTD",
"IRON LOGIC DIGITAL LABS PRIVATE LIMITED",
"IRON MONK BEVERAGES PRIVATE LIMITED",
"IRON MOUNTAIN INDIA PRIVATE LIMITED",
"IRON MOUNTAIN SERVICES PRIVATE LIMITED",
"IRON SYSTEMS INDIA PRIVATE LIMITED",
"IRON TRIANGLE LIMITED",
"IRONHILL BREWERY LLP",
"IRONIDE MINERALS PRIVATE LIMITED",
"IRONJAW STUDIOS PRIVATE LIMITED",
"IRONJAW VENTURES PRIVATE LIMITED",
"IRONMAN SECURITY SERVICES PRIVATE LIMITED",
"IRONSOURCE INDIA PRIVATE LIMITED",
"IRONSTEPS ENGINEERING PRIVATE LIMITED",
"IRONWELD ENGINEERING PRIVATE LIMITED",
"IROSE IT SOLUTIONS PRIVATE LIMITED",
"IRP AGRI TECH PRIVATE LIMITED",
"IRP INFRA TECH PRIVATE LIMITED",
"IRREGULARS STUDIO PRIVATE LIMITED",
"IRRH SPECIALTY CHEMICALS INDIA LIMITED",
"IRRIGATION & FLOOD CONTROL",
"IRRIGATION & WATER RESOURCES DEPARTMENT",
"IRRIGATION DEPARTMENT",
"IRRIGATION DEPARTMENT GORAKHPUR",
"IRRIGATION DEPARTMENT NAGAR NIGAM AGRA",
"IRRIGATION DEPARTMENT SAHARANPUR",
"IRRIGATION DEPARTMENT UTTAR PRADESH",
"IRRIGATION INT COLL KALKATTI NARORA BULANDSHAHR",
"IRRIGATION MANAGEMENT TRAINING INSTITUTE",
"IRRIGATION PRODUCTS INTERNATIONAL PRIVATE LIMITED",
"IRRIGATION RESEARCH DIVISION PUNE",
"IRS LOGISTICS PRIVATE LIMITED",
"IRT DIGITAL ANALYTICS SOLUTIONS PRIVATE LIMITED",
"IRT SECURITAS INDIA PRIVATE LIMITED",
"IRTHO FABRICATORS PRIVATE LIMITED",
"IRULAPPA MILLS INDIA PRIVATE LIMITED",
"IRUNA INDIAN BRAKES PRIVATE LIMITED",
"IRUS ENGINEERING PRIVATE LIMITED",
"IRUS INTERNATIONAL PRIVATE LIMITED",
"IRUS SOFTWARE APPLICATIONS PRIVATE LIMITED",
"IRVINE DIGITAL MEDIA PRIVATE LIMITED",
"IRVINE INFOCOM PRIVATE LIMITED",
"IRVINE POLYMER PRIVATE LIMITED",
"IRVINE TECHNOLOGIES PVT LTD",
"IRX PHARMACEUTICALS PRIVATE LIMITED",
"IRYS ELECTRONICS ENGINEERING SERVICES PRIVATE LIMITED",
"IS EG HALAL INDIA PRIVATE LIMITED",
"IS INDIA MARINE TECHNICAL SERVICES PRIVATE LIMITED",
"ISA ADVANCE INSTRUMENTS INDIA PRIVATE LIMITED",
"ISA LOGISTICS PRIVATE LIMITED",
"ISAAC PROJECTS PRIVATE LIMITED",
"ISABELLA THOURN COLLEGE",
"ISAFETY SYSTEMS PRIVATE LIMITED",
"ISAGE ALLIANCE INDIA PRIVATE LIMITED",
"ISAGRO ASIA AGROCHEMICALS PRIVATE LIMITED",
"I-SAKSHAM EDUCATION AND LEARNING FOUNDATION",
"ISAKURA HEALTHCARE PRIVATE LIMITED",
"ISAM FASHIONS PRIVATE LIMITED",
"ISAN EXIM PLASTOTECH PRIVATE LIMITED",
"ISANA RETAIL PRIVATE LIMITED",
"ISANGO INDIA PRIVATE LIMITED",
"ISANI AND VIRANI HOTELS PRIVATE LIMITED",
"ISANI STEEL PRIVATE LIMITED",
"ISAP INDIA FOUNDATION",
"ISAR ENGINEERS PRIVATE LIMITED",
"ISARNAN STEEL AND MINERALS PRIVATE LIMITED",
"ISAS BEAUTY SCHOOL PRIVATE LIMITED",
"ISAYA CONSTRUCTIONS PRIVATE LIMITED",
"ISB INFRASTRUCTURE PRIVATE LIMITED",
"ISBIR MEWAR BULK BAG PRIVATE LIMITED",
"ISBR BUSINESS SCHOOL",
"ISBS INFINITY SOLUTIONS PRIVATE LIMITED",
"ISC ASSURANCE SERVICES PRIVATE LIMITED",
"ISC GLOBAL SOLUTIONS PRIVATE LIMITED",
"ISC MACHINES PRIVATE LIMITED",
"ISC PROCESSORS PRIVATE LIMITED",
"ISC PROJECTS PRIVATE LIMITED",
"ISC TEX-TECH PRIVATE LIMITED",
"ISCAPE DESIGNERS PRIVATE LIMITED",
"ISCAR INDIA PRIVATE LIMITED",
"ISCHOLAR KNOWLEDGE SERVICES PRIVATE LIMITED",
"ISCISTECH BUSINESS SOLUTIONS PRIVATE LIMITED",
"ISCON ARCADE PRIVATE LIMITED",
"ISCON AVIATION PRIVATE LIMITED",
"ISCON BALAJI FOODS PRIVATE LIMITED",
"ISCON CERAMIC PRIVATE LIMITED",
"ISCON CRAFT PAPER MILL PRIVATE LIMITED",
"ISCON GLOBAL PVT. LTD.",
"ISCON HOTELS PRIVATE LIMITED",
"ISCON LIFE SCIENCE",
"ISCON PROCON PRIVATE LIMITED",
"ISCON SURGICALS LIMITED",
"ISCREENING SERVICES PRIVATE LIMITED",
"ISCS TECHNOLOGIES PRIVATE LIMITED",
"ISD INDUSTRIES PRIVATE LIMITED",
"ISDEC INDIA PVT LTD",
"ISEARCH CONSULTING SERVICES PRIVATE LIMITED",
"ISEC SERVICES PRIVATE LIMITED",
"ISECURE IT PRIVATE LIMITED",
"ISECURE POWER TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"ISECURENET SOLUTIONS PRIVATE LIMITED",
"ISECURION TECHNOLOGY & CONSULTING PRIVATE LIMITED",
"ISENBERG INDIA PRIVATE LIMITED",
"ISENS BIOSENSORS INDIA PRIVATE LIMITED",
"ISERA BIOLOGICAL PRIVATE LIMITED",
"ISERVE SOLUTIONS & SERVICES PRIVATE LIMITED",
"I-SERVE SYSTEMS PRIVATE LIMITED",
"ISERVEU TECHNOLOGY PRIVATE LIMITED",
"ISERVICEGLOBE PRIVATE LIMITED",
"ISF INDUSTRIES PRIVATE LIMITED",
"ISF LIMITED",
"ISF MARITIME SERVICES PRIVATE LIMITED",
"ISF SEA FOODS PRIVATE LIMITED",
"ISF SECURITIES LIMITED",
"ISG COMPUSOLUTIONS INDIA PRIVATE LIMITED",
"ISG ESOLUTIONS PRIVATE LIMITED",
"ISG FUELS PRIVATE LIMITED",
"ISG HOSPITALITY SERVICES PRIVATE LIMITED",
"ISG NOVASOFT TECHNOLOGIES LIMITED",
"ISGEC HEAVY ENGINEERING LIMITED",
"ISGEC HITACHI ZOSEN LIMITED",
"ISGEC REDECAM ENVIRO SOLUTIONS PRIVATE LIMITED",
"ISGEC TITAN METAL FABRICATORS PRIVATE LIMITED",
"ISH AGRITECH PRIVATE LIMITED",
"ISH FOODS AND HOSPITALITY PRIVATE LIMITED",
"ISH INDIA SILK HOUSE PRIVATE LIMITED",
"ISH INFORMATION SYSTEMS PRIVATE LIMITED",
"ISH MEDICOS PRIVATE LIMITED",
"ISH TRAVEL & TOURS PRIVATE LIMITED",
"ISHA AGRO DEVELOPERS PRIVATE LIMITED",
"ISHA AGRO SCIENCES PRIVATE LIMITED",
"ISHA AND YASHO ENTERPRISES PRIVATE LIMITED",
"ISHA BUSINESS PRIVATE LIMITED",
"ISHA CRAFTS PRIVATE LIMITED",
"ISHA DIAGNOSTICS AND RESEARCH PRIVATE LIMITED",
"ISHA ELECTROVISION PRIVATE LIMITED",
"ISHA EYECARE PRIVATE LIMITED",
"ISHA FAB ENGINEERS PRIVATE LIMITED",
"ISHA FASHIONS PRIVATE LIMITED",
"ISHA GLOBAL PRIVATE LIMITED",
"ISHA HOMES INDIA PRIVATE LIMITED",
"ISHA INFRATECH PRIVATE LIMITED",
"ISHA INSTITUTE OF INNER SCIENCES",
"ISHA LIFE FITNESS SYSTEM PRIVATE LIMITED",
"ISHA LIFE PRIVATE LIMITED",
"ISHA NATURAL BEAUTY PRODUCTS & WELLNESS PRIVATE LIMITED",
"ISHA OUTREACH",
"ISHA PLAST IMPEX PRIVATE LIMITED",
"ISHA POWER PROJECTS PRIVATE LIMITED",
"ISHA PROJECTS PRIVATE LIMITED",
"ISHA PROPERTIES PRIVATE LIMITED TFR. FROM MUMBAITO DELHI",
"ISHA PROTECTIONAL SECURITY GUARD PRIVATE LIMITED",
"ISHA ROCKS PRIVATE LIMITED",
"ISHA SAREE HOUSE PRIVATE LIMITED",
"ISHA SECURITIES LIMITED",
"ISHA SNACKS PRIVATE LIMITED",
"ISHA STEEL PRIVATE LIMITED",
"ISHA STEEL TREATMENT PRIVATE LIMITED",
"ISHA TEXMACH INDIA PRIVATE LIMITED",
"ISHA TEXTILE PRIVATE LIMITED",
"ISHA TOURS AND TRAVELS",
"ISHAAN BIO PRIVATE LIMITED",
"ISHAAN CLUBS & HOTELS PRIVATE LIMITED",
"ISHAAN CLUBS AND HOSPITALITY PRIVATE LIMITED",
"ISHAAN CREATIONS AND EXPORTS PRIVATE LIMITED",
"ISHAAN MARKETING PRIVATE LIMITED",
"ISHAAN METALS PRIVATE LIMITED",
"ISHAAN PLASTICS PRIVATE LIMITED",
"ISHAAN SAREE PRIVATE LIMITED",
"ISHAANAV NUTRACEUTICALS PRIVATE LIMITED",
"ISHAANI CREATIONS INDIA PRIVATE LIMITED",
"ISHAKA INFRA DEVELOP PRIVATE LIMITED",
"ISHAN ANSHUM PRODUCTS PRIVATE LIMITED",
"ISHAN AUTOWORLD PRIVATE LIMITED",
"ISHAN CERAMICS PRIVATE LIMITED",
"ISHAN CHANDI AGRO INDUSTRIES PRIVATE LIMITED",
"ISHAN DIAMOND PRIVATE LIMITED",
"ISHAN DYES AND CHEMICALS LIMITED",
"ISHAN EQUIPMENTS PRIVATE LIMITED",
"ISHAN FINLEASE LIMITED",
"ISHAN HOSPITAL PRIVATE LIMITED",
"ISHAN INDUSTRIES PRIVATE LIMITED",
"ISHAN INFORMATION SERVICES PVT LTD",
"ISHAN INFOTECH LIMITED",
"ISHAN INFRAPROMOTERS PRIVATE LIMITED",
"ISHAN INTERNATIONAL",
"ISHAN INTERNATIONAL LIMITED",
"ISHAN NETSOL PRIVATE LIMITED",
"ISHAN PARYAVARAN PRIVATE LIMITED",
"ISHAN RESINS & PAINTS LIMITED",
"ISHAN SNACKS AND NAMKIN PRIVATE LIMITED",
"ISHAN SNAX PRIVATE LIMITED",
"ISHAN SPINNERS PRIVATE LIMITED",
"ISHAN TECHNICAL PLANT SERVICES PRIVATE LIMITED",
"ISHAN TOWNSHIP PRIVATE LIMITED",
"ISHANA AUTOMOBILES PRIVATE LIMITED",
"ISHANA EXIM PRIVATE LIMITED",
"ISHANA PROJECTS PRIVATE LIMITED",
"ISHANEE CHEMICALS PRIVATE LIMITED",
"ISHANI INFRATECH PRIVATE LIMITED",
"ISHANI PULSES PRIVATE LIMITED",
"ISHANI RICE MILLS PRIVATE LIMITED",
"ISHANIKA BUILDERS PRIVATE LIMITED",
"ISHANIKA HOTELS PRIVATE LIMITED",
"ISHANIKA SECURITIES PRIVATE LIMITED",
"ISHANVI INDUSTRIAL & LOGISTICS PARK PRIVATE LIMITED",
"ISHANYA BRAND SERVICES LIMITED",
"ISHANYA INDUSTRIES PRIVATE LIMITED",
"ISHAPASHYANTI COMMERCIAL ENTERPRISES PRIVATE LIMITED",
"ISHAR INFRATECH PRIVATE LIMITED",
"ISHARDASS TRADING COMPANY PVT LTD",
"ISHARDHAM PRIMARY SCHOOL JAMNAGAR",
"ISHATI BUILDER AND LAND DEVELOPER",
"ISHATVAM INDIA PVT LTD",
"ISHER MEGASTRUCTURES INDIA PRIVATE LIMITED",
"ISHETA REALTY PRIVATE LIMITED",
"ISHI ENTERPRISE",
"ISHICO INDIA PRIVATE LIMITED",
"ISHIDA INDIA PRIVATE LIMITED",
"ISHIJAS CHEMICALS PVT LTD",
"ISHIKA DEVELOPERS PRIVATE LIMITED",
"ISHIKA ELECTRONICS PRIVATE LIMITED",
"ISHIKA FERTILIZERS LIMITED",
"ISHIKA LIFESTYLES PRIVATE LIMITED",
"ISHIKA PACKAGING PRIVATE LIMITED",
"ISHIKA POLYFAB PRIVATE LIMITED",
"ISHIR OCTAVIAN TECHNOLOGIES PRIVATE LIMITED",
"ISHITA ACTIVE PHARMA INGREDIENTS PRIVATE LIMITED",
"ISHITA CONSULTANCY PRIVATE LIMITED",
"ISHITA CRAFT ESSENTIALS PRIVATE LIMITED",
"ISHITA DRUGS AND INDUSTRIES LIMITED",
"ISHITA FASHIONS PRIVATE LIMITED",
"ISHITA INFO SOLUTIONS PRIVATE LIMITED",
"ISHITA KNITFAB PRIVATE LIMITED",
"ISHIV INDIA SOLUTIONS PRIVATE LIMITED",
"ISHJAS PHARMA PRIVATE LIMITED",
"ISHKAR TOOLINGS PRIVATE LIMITED",
"ISHKRIPA PHARMACY PRIVATE LIMITED",
"ISHKRIPA REAL ESTATE PRIVATE LIMITED",
"ISHMAN INTERNATIONAL",
"ISHMEET FORGINGS PRIVATE LIMITED",
"ISHNA AUTOMOTIVE PRIVATE LIMITED",
"ISHOM PACKAGING PRIVATE LIMITED",
"ISHRAM IMPEX PRIVATE LIMITED",
"ISHRON INFRASTRUCTURE PRIVATE LIMITED",
"ISHTA CONSTRUCTIONS PRIVATE LIMITED",
"ISHTA INDUSTRIES PRIVATE LIMITED",
"ISHTA SIDDHI VINAYAKA PHARMA PRIVATE LIMITED",
"ISHTAKA BUILD METRIX PRIVATE LIMITED",
"ISHTAN ENTERPRISES INDIA PRIVATE LIMITED",
"ISHTAR MUSIC PRIVATE LIMITED",
"ISHTIKA HOMES PRIVATE LIMITED",
"ISHTTAA TECHCRAFT PRIVATE LIMITED",
"ISHU BUILDCON PRIVATE LIMITED",
"ISHUALOK HOSPITALITY PRIVATE LIMITED",
"ISHULL DMC PRIVATE LIMITED",
"ISHVAKOO IMPEX PRIVATE LIMITED",
"ISHVARYAM INFRASTRUCTURES PRIVATE LIMITED",
"ISHVED BIOTECH PRIVATE LIMITED",
"ISHVED CROP SCIENCE PRIVATE LIMITED",
"ISHVERLAL MADANLAL AND COMPANY PRIVATE LIMITED",
"ISHVI FOOD PRIVATE LIMITED",
"ISHWAM INFRASYSTEMS LIMITED",
"ISHWAR AUTOLINK PRIVATE LIMITED",
"ISHWAR CABLES PRIVATE LIMITED",
"ISHWAR CONSTRUCTIONS PRIVATE LIMITED",
"ISHWAR CORRUGATION & PACKAGING INDUSTRY PRIVATE LIMITED",
"ISHWAR DESHMUKH COLLEGE OF PHYSICAL EDU",
"ISHWAR FARMLINE EQUIPMENTS PRIVATE LIMITED",
"ISHWAR FORGE PRIVATE LIMITED",
"ISHWAR INFRAPROJECTS PRIVATE LIMITED",
"ISHWAR ISPAT INDUSTRIES PRIVATE LIMITED",
"ISHWAR OIL MILL",
"ISHWAR PACKAGING PRODUCTS PRIVATE LIMITED",
"ISHWAR PLASTOPACK PRIVATE LIMITED",
"ISHWAR RAJ BEVERAGES PRIVATE LIMITED",
"ISHWAR RESEARCH AND BREEDING FARMS PRIVATE LIMITED",
"ISHWAR RESORT HOTELS PRIVATE LIMITED",
"ISHWAR SINGH & ASSOCIATES CONSTRUCTION PRIVATE LIMITED",
"ISHWAR TEA COMPANY PRIVATE LIMITED",
"ISHWAR TECHNOCRATS PRIVATE LIMITED",
"ISHWAR TMT PRIVATE LIMITED",
"ISHWAR TRADITIONAL EXPORTS PRIVATE LIMITED",
"ISHWAR TRANSPORT SERVICES PRIVATE LIMITED",
"ISHWARA METALS PRIVATE LIMITED",
"ISHWARDASSONS LOGISTIC SOLUTION PRIVATE LIMITED",
"ISHWARI HEALTHCARE PRIVATE LIMITED",
"ISHWARLAL HARJIVANDAS JEWELLERS PRIVATE LIMITED",
"ISHWARSHAKTI HOLDING & TRADERS LIMITED",
"ISHWARTECH AUTO INDUSTRIES PRIVATE LIMITED",
"ISHWER REALTY AND TECHNOLOGIES PRIVATE. LIMITED.- PROJECT -PLOT C",
"ISILICA NETWORKS INDIA PRIVATE LIMITED",
"ISINOX STEELS LIMITED",
"ISINOX WIRES PRIVATE LIMITED",
"ISIT CONSULTANTS PRIVATE LIMITED",
"ISIT OFFICE SPACE SOLUTION PRIVATE LIMITED",
"ISK AUTO INDUSTRIES",
"ISK BIOSCIENCES INDIA PRIVATE LIMITED",
"ISKA PROPERTIES AND INVESTMENTS PVT LTD",
"ISKCON METALS",
"ISKCON STRIPS PRIVATE LIMITED",
"ISKO STRIP PRIVATE LIMITED",
"ISKPRO PRIVATE LIMITED",
"ISKRA ENERGIES PRIVATE LIMITED",
"ISKRAEMECO INDIA PRIVATE LIMITED",
"ISKRUPA MALL MANAGEMENT COMPANY PRIVATE LIMITED",
"ISL CONSULTING LIMITED",
"ISL ENGINEERING COLLEGE",
"ISL MINING PRIVATE LIMITED",
"ISL SOFTWARE INDIA PRIVATE LIMITED",
"ISL WIRELESS PRIVATE LIMITED",
"ISLAMIA GIRLS INTER COLLEGE",
"ISLAMIA GIRLS SENIOR SECONDARY SCHOOL",
"ISLAMIA HIGH SCHOOL",
"ISLAMIA HIGH SCHOOL MANDI GOBINDGARH PB UNDER PUNJAB WAKQ BOARD CHANDIGARH",
"ISLAMIA INTER COLLEGE SAHARANPUR",
"ISLAMIC BOOK SERVICE PRIVATE LIMITED",
"ISLAND AVIATION INDIA PRIVATE LIMITED",
"ISLAND AVIATION SERVICES LIMITED",
"ISLAND EAST WATCH & FASHIONS PRIVATE LIMITED",
"ISLAND HYDRAULICS (I) PRIVATE LIMITED",
"ISLAND PACIFIC RETAIL SYSTEMS PRIVATE LIMITED",
"ISLAND PEAK CLOUD INFOTECH PRIVATE LIMITED",
"ISLAND STAR MALL DEVELOPERS PRIVATE LIMITED",
"ISLAND STONE INDIA PRIVATE LIMITED",
"ISLAND VEER CHEMIE PVT LTD",
"ISLANDERS MARGIN FREE CANTEEN PRIVATE LIMITED",
"ISLE EXPORTS PRIVATE LIMITED",
"ISLEBERG TOUR AND TRAVELS PRIVATE LIMITED",
"ISLET COAST TRADING COMPANY PRIVATE LIMITED",
"ISM EDUTECH PRIVATE LIMITED",
"ISM INVESTMENTS PVT LTD",
"ISMAIL ENTERPRISES",
"ISMAIL GIRLS NATIONAL INTER COLLEGE",
"ISMART BUSINESS SOLUTIONS PRIVATE LIMITED",
"ISMARTU INDIA PRIVATE LIMITED",
"ISMT LIMITED",
"ISN ELECTRONICTENDER SERVICES PRIVATE LIMITED",
"ISN GLOBAL SOLUTIONS PRIVATE LIMITED",
"ISNIA TECHNOLOGIES (OPC) PRIVATE LIMITED",
"ISO FLEX SYSTEMS PRIVATE LIMITED",
"ISOAH DATA SECURITIES PRIVATE LIMITED",
"ISOBAR COMMERCE INDIA PRIVATE LIMITED",
"ISOBEL TRADEX PRIVATE LIMITED",
"ISOE PRINTPACK INDUSTRIES PRIVATE LIMITED",
"ISOFT TECHNOLOGIES PRIVATE LIMITED",
"ISOLA DI COCO HOLIDAYING PRIVATE LIMITED",
"ISOLATION HOSPITAL SMS - JAIPUR",
"ISOLLOYD ENGINEERING TECHNOLOGIES LIMITED",
"ISOLS GROUP PRIVATE LIMITED",
"ISOLUTIONS PRIVATE LIMITED",
"ISOLUTIONS TECHNOLOGIES PRIVATE LIMITED",
"ISOLUX INGENIERIA S.A.",
"ISOLVE TECHNOLOGIES PRIVATE LIMITED",
"ISOMAG INDIA PRIVATE LIMITED",
"ISOMETRIC DESIGN SERVICES PRIVATE LIMITED",
"ISON TECHNOLOGIES PRIVATE LIMITED",
"ISON XPERIENCES INDIA PRIVATE LIMITED",
"ISOQAR INDIA PRIVATE LIMITED",
"ISOSCELES SALES AND SERVICE PRIVATE LIMITED",
"ISOTECH INDIA PRIVATE LIMITED",
"ISOTECH TECHNOLOGY PRIVATE LIMITED",
"ISOTEX CORPORATION PRIVATE LIMITED",
"ISOTHERM PUF PANEL PRIVATE LIMITED",
"ISOTHERMAL TECHNOLOGY PRIVATE LIMITED",
"ISOTRACK INNOVATIVE INFRASTRUCTURE SOLUTIONS PRIVATE LIMITED",
"ISOURCE IT ENABLED",
"I-SOURCING TECHNOLOGIES PRIVATE LIMITED",
"ISOURSE TECHNOLOGIES PRIVATE LIMITED",
"ISOVOLTA INDIA PVT LTD",
"ISP GLOBAL CONSULTING PRIVATE LIMITED",
"ISPA ENGINEERING PRIVATE LIMITED",
"ISPA EXIM PRIVATE LIMITED",
"ISPA PHARMACEUTICALS PRIVATE LIMITED",
"ISPAAT UDYOG PVT LTD",
"ISPACE SOFTWARE SOLUTIONS INDIA PRIVATE LIMITED",
"ISPARK LEARNING SOLUTIONS PRIVATE LIMITED",
"ISPAT CARRIERS PRIVATE LIMITED",
"ISPAT DAMODAR PRIVATE LIMITED",
"ISPAT ENTERPRISES PRIVATE LIMITED",
"ISPAT EXPORTS PRIVATE LIMITED",
"ISPAT IMPEX PRIVATE LIMITED",
"ISPAT SANGRAH",
"ISPAT TRADERS PRIVATE LIMITED",
"ISPATIAL TECHNO SOLUTIONS PRIVATE LIMITED",
"ISPATIKA INTERNATIONAL LIMITED",
"ISPECK DIGITAL SOLUTIONS PRIVATE LIMITED",
"ISPEED FREIGHT (INDIA) PRIVATE LIMITED",
"ISPG TECHNOLOGIES INDIA PRIVATE LIMITED",
"ISPL MACHINE BUILDERS LIMITED",
"ISPRAVA DECOR PRIVATE LIMITED",
"ISPRAVA VESTA PRIVATE LIMITED",
"ISPROUT BUSINESS CENTRE PRIVATE LIMITED",
"ISPT INDIA PRIVATE LIMITED",
"ISQAA SOURCING PRIVATE LIMITED",
"ISQUARE SAFETY EQUIPMENTS PRIVATE LIMITED",
"ISR CONSTRUCTIONS PRIVATE LIMITED",
"ISR INFOMEDIA PRIVATE LIMITED",
"ISR SAMRUDDHI FOODS PRIVATE LIMITED",
"ISRA VISION INDIA PRIVATE LIMITED",
"ISRAEL AEROSPACE INDIA PRIVATE LIMITED",
"ISRAELITES SHOPPING NETWORK PRIVATE LIMITED",
"ISRANI TELECOM PRIVATE LIMITED",
"ISRI ADIENT AUTOMOTIVE SEATING LIMITED",
"ISRO DEPARTMENT OF SPACE",
"ISRSD INNOVATIONS PRIVATE LIMITED",
"ISS (INDIA) CONSULTANCY SERVICES PRIVATE LIMITED",
"ISS FACILITY SERVICES INDIA PRIVATE LIMITED",
"ISS HARDWARE PRIVATE LIMITED",
"ISS INTERNATIONAL LIMITED",
"ISS SDB SECURITY SERVICES PRIVATE LIMITED",
"ISS SHIPPING INDIA PRIVATE LIMITED",
"ISS SOFTTECH PRIVATE LIMITED",
"ISS SUPPORT SERVICES PRIVATE LIMITED",
"ISS TRADING PRIVATE LIMITED",
"ISSAC TECHNOLOGIES PRIVATE LIMITED",
"ISSGF INDIA PRIVATE LIMITED",
"ISSHAAN HEALTHCARE PRIVATE LIMITED",
"ISSHO TRADEX PRIVATE LIMITED",
"ISSIMO TECHNOLOGY PRIVATE LIMITED",
"ISSL MARKET SERVICES LIMITED",
"ISSL SETTLEMENT & TRANSACTION SERVICES LIMITED",
"ISSOJET BURNER PRIVATE LIMITED",
"ISSQUARED INDIA PRIVATE LIMITED",
"IST LIMITED",
"ISTAA FASHIONS PRIVATE LIMITED",
"ISTAA FINSERV PRIVATE LIMITED",
"ISTAR COLLEGE",
"I-STAY REAL ESTATE PRIVATE LIMITED",
"ISTEER TECHNOLOGIES PRIVATE LIMITED",
"ISTEM PRIVATE LIMITED",
"ISTHARA PARKS PRIVATE LIMITED",
"ISTHMUS INDUSTRIES PRIVATE LIMITED",
"ISTITUTO MARANGONI MUMBAI TRAINING CENTRE PRIVATE LIMITED",
"ISTITUTO MARANGONI S.R.L.",
"ISTORAGE INDIA PRIVATE LIMITED",
"ISTORE DIRECT TRADING PRIVATE LIMITED",
"ISTOS MEDICAL PRIVATE LIMITED",
"I-STRAT SOFTWARE PRIVATE LIMITED",
"ISTREAM TECHNOLOGIES PRIVATE LIMITED",
"ISTRI VASTRA PRIVATE LIMITED",
"I-STRON INDIA PRIVATE LIMITED",
"ISTTM BUSINESS SCHOOL PRIVATE LIMITED",
"ISTTM INDIA PRIVATE LIMITED",
"ISUMMATION TECHNOLOGIES PRIVATE LIMITED",
"ISUN SOLAR PRIVATE LIMITED",
"ISUN TECHNOLOGIES INDIA PRIVATE LIMITED",
"ISUNJET INDIA PRIVATE LIMITED",
"ISUPPORT FARMING PRIVATE LIMITED",
"ISUZU ENGINEERING BUSINESS CENTRE INDIA PRIVATE LIMITED",
"ISUZU LOGISTICS INDIA PRIVATE LIMITED",
"ISUZU MOTORS INDIA PRIVATE LIMITED",
"ISVARAH APPARELS PRIVATE LIMITED",
"ISWARIPUR MARJINA VIDYANIKETAN",
"ISWARYA HEALTH PRIVATE LIMITED",
"ISYA AESTHETICS PRIVATE LIMITED",
"ISYNERGY TECHSYS PRIVATE LIMITED",
"ISYS SOFTECH PRIVATE LIMITED",
"ISYS TECHWORKS INDIA PRIVATE LIMITED",
"IT ACTION GUJARAT PRIVATE LIMITED",
"IT AMERICA INDIA PRIVATE LIMITED",
"IT AND T ENTERTAINMENT SERVICES PRIVATE LIMITED",
"IT BUSINESS MANAGEMENT SOLUTIONS INDIA PRIVATE LIMITED",
"IT CONFIG INDIA PRIVATE LIMITED",
"IT CONVERGENCE CONSULTING SERVICES PRIVATE LIMITED",
"IT CONVERGENCE PROFESSIONAL SERVICES PRIVATE LIMITED",
"IT ENFRASERVICES PRIVATE LIMITED",
"IT E-PARK PRIVATE LIMITED",
"IT EXPRESSWAY LIMITED",
"IT FLEX SOLUTIONS INDIA PRIVATE LIMITED",
"IT GIANTS PRIVATE LIMITED",
"IT KEYSOURCE SOLUTIONS PRIVATE LIMITED",
"IT MINES TECHNOLOGY PRIVATE LIMITED",
"IT PATH SOLUTIONS PRIVATE LIMITED",
"IT PEOPLE CORPORATION INDIA PRIVATE LIMITED",
"IT RESONANCE PRIVATE LIMITED",
"IT SCIENT CONSULTING PRIVATE LIMITED",
"IT SERVE GLOBAL PRIVATE LIMITED",
"IT SHASTRA INDIA PRIVATE LIMITED",
"IT TEXTILE PRIVATE LIMITED",
"IT TRAILBLAZERS CONSULTING PRIVATE LIMITED",
"IT WEBTECH COMPUTERS",
"IT WORKS A DIV. OF ASHWINI AGENCIES PRIVATE LIMITED",
"IT2AUTOMATE.COM PRIVATE LIMITED",
"IT4T SOLUTIONS PRIVATE LIMITED",
"ITA LAKE CERAMIC PRIVATE LIMITED",
"ITAAKASH STRATEGIC SOFTWARE PRIVATE LIMITED",
"ITAAS INDIA PRIVATE LIMITED",
"ITACA CERAMIC PRIVATE LIMITED",
"ITACON GRANITO PRIVATE LIMITED",
"ITAJAI SHIPPING LINES PRIVATE LIMITED",
"ITAKEM FINECHEM PRIVATE LIMITED",
"ITAL BEAUTY NIPPERS INDIA PRIVATE LIMITED",
"ITAL PLASTIC COMPOUNDS PRIVATE LIMITED",
"ITAL SOLUTIONS PRIVATE LIMITED",
"ITALAB PRIVATE LIMITED",
"ITALENT APPLICATIONS PRIVATE LIMITED",
"ITALENT INDIA MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"ITALFERR S P A",
"ITALGRU INDIA PRIVATE LIMITED",
"ITALIA CERAMICS LIMITED",
"ITALIAN EDIBLES LIMITED",
"ITALIAN SOUND DESIGN (I) PRIVATE LIMITED",
"ITALIANO FABRICS PRIVATE LIMITED",
"ITALICA GRANITO PRIVATE LIMITED",
"ITALICA MOTORS PRIVATE LIMITED",
"ITALIEN JEWELLERY MANUFACTURING COMPANY LIMITED",
"ITALIK METALWARE PRIVATE LIMITED",
"ITALINDIA PACKPLUS PRIVATE LIMITED",
"ITALIX LIVING SPACES PRIVATE LIMITED",
"ITALTINTO EQUIPMENTS PRIVATE LIMITED",
"ITALUS VITRIFIED LLP",
"ITAM ADVISORY SERVICES PRIVATE LIMITED",
"ITARES SHOES PRIVATE LIMITED",
"ITARIUM TECHNOLOGIES INDIA PRIVATE LIMITED",
"ITARSI OILS & FLOURS LIMITED",
"ITBP PUBLIC SCHOOL",
"ITC ESSENTRA LIMITED",
"ITC INDIVISION LIMITED",
"ITC INFOTECH INDIA LIMITED",
"ITC INTEGRATED BUSINESS SERVICES LIMITED",
"ITC LIMITED",
"ITC SATELLITE SOLUTIONS INDIA PRIVATE LIMITED",
"ITCC DIGITAL PRIVATE LIMITED",
"ITCG SOLUTIONS PRIVATE LIMITED",
"ITCHAMPS SOFTWARE PRIVATE LIMITED",
"ITCO INDUSTRIES LIMITED",
"ITCONNECTUS TECH INDIA PRIVATE LIMITED",
"ITCONS E-SOLUTIONS LIMITED",
"ITCONS E-SOLUTIONS PRIVATE LIMITED",
"ITCOT CONSULTANCY AND SERVICES LIMITED",
"ITCRAFT TECHNOLOGIES PRIVATE LIMITED",
"ITCRATS INFO SOLUTIONS PRIVATE LIMITED",
"ITCUBE SOLUTIONS PRIVATE LIMITED",
"ITD CEMENTATION INDIA LIMITED",
"ITD TECHNOLOGIES AND MARKETING PRIVATE LIMITED",
"ITD-ITD CEM JV",
"ITDOSE INFOSYSTEMS PRIVATE LIMITED",
"ITE ENGINEERS PRIVATE LIMITED",
"ITEACH MOVEMENT",
"ITEANZ TECHNOLOGIES INDIA PRIVATE LIMITED",
"ITEC MEASURES PRIVATE LIMITED",
"ITECA INSTRUMENTS PRIVATE LIMITED",
"ITECH BUSINESS SOLUTIONS PRIVATE LIMITED",
"ITECH CONSULT RECRUITMENT PRIVATE LIMITED",
"ITECH INDIA PRIVATE LIMITED",
"ITECH IT SOLUTIONS PRIVATE LIMITED",
"I-TECH LANCE INFORMATION TECHNOLOGY PRIVATE LIMITED",
"ITECH MASS PRIVATE LIMITED",
"I-TECH MEDIA PRIVATE LIMITED",
"I-TECH MISSION PRIVATE LIMITED",
"I-TECH PLAST INDIA PRIVATE LIMITED",
"ITECH ROBOTICS & AUTOMATION PRIVATE LIMITED",
"ITECH SERIES PRIVATE LIMITED",
"ITECH SOFTWARE SOLUTION PRIVATE LIMITED",
"ITECH WORKSHOP PRIVATE LIMITED",
"ITECHCLOUD SOLUTION",
"ITECHIZEN GLOBAL PRIVATE LIMITED",
"ITECHLINE4U SERVICES & MARKETING SOLUTIONS PRIVATE LIMITED",
"ITECHNORIX SOLUTIONS PRIVATE LIMITED",
"ITECHNOTION PRIVATE LIMITED",
"ITECHNOWIZ SOLUTIONS PRIVATE LIMITED",
"ITECHVERSITY SOLUTIONS PRIVATE LIMITED",
"ITECKSYSCAD ENGINEERING PRIVATE LIMITED",
"ITECSYS TECHNOLOGIES PRIVATE LIMITED",
"I-TEK LOGICS PRIVATE LIMITED",
"ITEM SECURE PRIVATE LIMITED",
"ITEMA WEAVING INDIA PRIVATE LIMITED",
"ITEMPERANCE CONSULTING PRIVATE LIMITED",
"ITEN MEDIA PRIVATE LIMITED",
"ITEOS LLP",
"ITERATE INDIA PRIVATE LIMITED",
"ITERATION3 SOFTWARE LAB PRIVATE LIMITED",
"ITES HORIZON PRIVATE LIMITED",
"ITFAQ CEMENTS AND CONSTRUCTIONS PRIVATE LIMITED",
"ITFI INDUSTRIES PRIVATE LIMITED",
"ITFLUX TECHNOLOGIES PRIVATE LIMITED",
"ITFT CONSULTANCY PRIVATE LIMITED",
"ITG SOFTWARE ENGINEERING INDIA PRIVATE LIMITED",
"ITG TELEMATICS PRIVATE LIMITED",
"ITGALAX SOLUTIONS PRIVATE LIMITED",
"ITGEEKS TECNOLOGIES PRIVATE LIMITED",
"ITH ENGINEERING (INDIA) PRIVATE LIMITED",
"ITH TECHNOLOGIES PRIVATE LIMITED",
"ITHACA CLOTHING PRIVATE LIMITED",
"ITHAD MOTOR TRANSPORT INDIA PRIVATE LIMITED",
"ITHENA TECHNOLOGIES PRIVATE LIMITED",
"ITHIEL HEALTHCARE PRIVATE LIMITED",
"ITI ALTERNATE FUNDS MANAGEMENT LIMITED",
"ITI CAPITAL LIMITED",
"ITI COLLEGE",
"ITI COLLEGE BAH",
"ITI CREDIT LIMITED",
"ITI FINANCE LIMITED",
"ITI GILTS LIMITED",
"ITI GOLD LOANS LIMITED",
"ITI HOLDINGS AND INVESTMENT PRIVATE LIMITED",
"ITI LIMITED",
"ITI MATHURA",
"ITI SALUMBAR",
"ITI TECHNO AGRO PRIVATE LIMITED",
"ITIB MACHINERY INDIA PRIVATE LIMITED",
"ITIDATA CONSULTING INDIA PRIVATE LIMITED",
"ITIKRAT TRADING PRIVATE LIMITED",
"ITIO INNOVEX PRIVATE LIMITED",
"ITION SOLUTIONS LIMITED",
"ITISH BUSINESS SOLUTIONS PRIVATE LIMITED",
"ITISHUBHAM ORGANOFOODS PRIVATE LIMITED",
"ITJ RETAILS PRIVATE LIMITED",
"ITL HOLIDAYS PRIVATE LIMITED",
"ITL INDUSTRIES LIMITED",
"ITL LABS PRIVATE LIMITED",
"ITL PUBLIC SCHOOL",
"ITL TELETECH PRIVATE LIMITED",
"ITL TOURS AND TRAVELS PRIVATE LIMITED",
"ITM COLLEGE",
"ITM DOZCO (INDIA) PRIVATE LIMITED",
"ITM EDUTECH TRAINING PRIVATE LIMITED",
"ITM SAFETY PRIVATE LIMITED",
"ITM TRADING PRIVATE LIMITED",
"ITM UNIVERSITY GWALIOR",
"ITMANTRA TECHINTELLECT PRIVATE LIMITED",
"ITMS INDIA PRIVATE LIMITED",
"ITNATIVE INDIA SOLUTIONS LLP",
"ITNES STYLE STUDIO PRIVATE LIMITED",
"ITNET INFOCOM PRIVATE LIMITED",
"ITNL TOLL MANAGEMENT SERVICES LIMITED",
"ITO ELECTRONICS (INDIA) PRIVATE LIMITED",
"ITO HQ ADMIN O/O PRCCIT GUJARAT AHMEDABAD",
"ITO PRECISION TECHNOLOGIES PRIVATE LIMITED",
"ITOBUZ TECHNOLOGIES PRIVATE LIMITED",
"ITOCHU INDIA PRIVATE LIMITED",
"ITOCHU WORLDWIDE TECHNOLOGY PRIVATE LIMITED",
"ITOKRI ENTERPRISES PRIVATE LIMITED",
"ITON TECHNOLOGIES PRIVATE LIMITED",
"ITONE (INDIA) PRIVATE LIMITED",
"ITOP SOLUTIONS PRIVATE LIMITED",
"ITORIZIN TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"ITORIZON INDIA PRIVATE LIMITED",
"ITOSS SOLUTIONS (I) PRIVATE LIMITED",
"ITOUCH RETAIL SOLUTIONS PRIVATE LIMITED",
"ITOUCH TECHNOLOGIES PRIVATE LIMITED",
"ITP ELECTRONICS PRIVATE LIMITED",
"ITP EXTERNALS INDIA PRIVATE LIMITED",
"ITP SPECIAL ADDITIVES INDIA PRIVATE LIMITED",
"ITPC INDIA PRIVATE LIMITED",
"ITPG DEVELOPERS PRIVATE LIMITED",
"ITPL INFRASTRUCTURES PRIVATE LIMITED",
"ITPN CONSULTING INDIA PRIVATE LIMITED",
"ITPRENEURS TECHNOLOGY PRIVATE LIMITED",
"ITPROFOUND INDIA PRIVATE LIMITED",
"ITR INFRATECH PRIVATE LIMITED",
"ITRAVELS PRIVATE LIMITED",
"ITRC TECHNOLOGIES PRIVATE LIMITED",
"ITREE CONSULTING PRIVATE LIMITED",
"ITREE DYNAMICS SOLUTIONS PRIVATE LIMITED",
"ITREND (OPC) PRIVATE LIMITED",
"ITRH CLOTHINGS PRIVATE LIMITED",
"ITRIANGLE INFOTECH PRIVATE LIMITED",
"ITRIK EXTRACTIONS PRIVATE LIMITED",
"ITROPE TECHNOLOGIES PRIVATE LIMITED",
"ITROSYS TECHNOLOGIES PRIVATE LIMITED",
"ITS COATINGS PRIVATE LIMITED",
"ITS CORPORATION",
"ITS DATA-SOLUTIONS PRIVATE LIMITED",
"ITS ENGINEERING COLLEGE GREATER NOIDA",
"ITS FOR YOU PRIVATE LIMITED",
"ITS GLOBAL INSTANT TRAVEL SOLUTIONS",
"ITS INDIA PRIVATE LIMITED",
"ITS INFOSYSTEMS PRIVATE LIMITED",
"ITS MY NAME PRIVATE LIMITED",
"ITS PLANNERS AND ENGINEERS PRIVATE LIMITED",
"ITS TECHNOLOGY SOLUTION PRIVATE LIMITED",
"ITS TECNODUE INDIA PRIVATE LIMITED",
"ITS TRAVELS AND TOURS PRIVATE LIMITED",
"ITSA BRAND INNOVATIONS LIMITED",
"ITSACHECKMATE.COM SERVICES INDIA PRIVATE LIMITED",
"ITSC TECHNOGIES PRIVATE LINITED",
"ITSHASTRA (INDIA) PRIVATE LIMITED",
"ITSOFT TECHNOLOGIES PRIVATE LIMITED",
"ITSOLI INDIA PRIVATE LIMITED",
"ITSOURCE GLOBAL SERVICES PRIVATE LIMITED",
"ITSOURCE TECHNOLOGIES LIMITED",
"ITSPECTRUM SOLUTIONS PRIVATE LIMITED",
"ITSS INDIA PRIVATE LIMITED",
"ITSUMO BUSINESS ADVISORS LIMITED",
"ITSY BITSY PRIVATE LIMITED",
"ITSYS SOLUTIONS PRIVATE LIMITED",
"ITT CORPORATION INDIA PRIVATE LIMITED",
"ITT ENGINEERING INDIA PRIVATE LIMITED",
"ITTANTA TECHNOLOGIES PRIVATE LIMITED",
"ITTECHIES SERVICES PRIVATE LIMITED",
"ITTI PRIVATE LIMITED",
"ITTIAM SYSTEMS PRIVATE LIMITED",
"ITTISA DIGITAL MEDIA SERVICES PRIVATE LIMITED",
"ITTSTAR GLOBAL SERVICES PRIVATE LIMITED",
"ITU CHAUDHURI DESIGN PRIVATE LIMITED",
"ITURBO BUSINESS ASSOCIATES PRIVATE LIMITED",
"ITUS CAPITAL ADVISORS PRIVATE LIMITED",
"ITUS INSURANCE BROKERS PRIVATE LIMITED",
"ITV BROADCASTING PRIVATE LIMITED",
"ITVARA HOSPITALITY PRIVATE LIMITED",
"ITVIS INNOVATIONS PRIVATE LIMITED",
"ITW CONSULTING PRIVATE LIMITED",
"ITW INDIA PRIVATE LIMITED",
"ITW MEDIAWORX PRIVATE LIMITED",
"ITW TRAVEL AND LEISURE PRIVATE LIMITED",
"ITWINGS INFOSYSTEM PRIVATE LIMITED",
"ITWORKS INFOTECH PRIVATE LIMITED",
"ITX SERVICES INDIA PRIVATE LIMITED",
"ITX TRADING S.A.",
"ITXITPRO PRIVATE LIMITED",
"ITXM SOLUTIONS PRIVATE LIMITED",
"ITYADI INDIA PRIVATE LTD",
"ITYX INDIA PRIVATE LIMITED",
"ITZEL BATH (INDIA) PRIVATE LIMITED",
"ITZU INTERNATIONAL PRIVATE LIMITED",
"IU CONSULTING AND RESEARCH INDIA PRIVATE LIMITED",
"IUC AQUA PRIVATE LIMITED",
"IUMEDS INTERNET TECHNOLOGIES PRIVATE LIMITED",
"IUP JINDAL METALS & ALLOYS LIMITED",
"IUS EQUIPMENTS PRIVATE LIMITED",
"IUVENIS HEALTHCARE PRIVATE LIMITED",
"IV COMMUNICATIONS LIMITED",
"IV CONSULTANCY SERVICES PRIVATE LIMITED",
"IV COUNTY PRIVATE LIMITED",
"IV SQUARE STRUCTURE INDIA PRIVATE LIMITED",
"IVA BULK HANDLING EQUIPMENTS PRIVATE LIMITED",
"IVA MARKETING PRIVATE LIMITED",
"IVA TECHNOS PRIVATE LIMITED",
"IVA TEK PRIVATE LIMITED",
"IVA TELECON SOLUTIONS PRIVATE LIMITED",
"IVAAR HOSPITALITY PRIVATE LIMITED",
"IVALOREM RETAIL PRIVATE LIMITED",
"IVALUA INDIA PRIVATE LIMITED",
"IVALUE INFOSOLUTIONS PRIVATE LIMITED",
"IVALUE SYSTECH PRIVATE LIMITED",
"IVAN INFOTECH PRIVATE LIMITED",
"IVANA INTERNATIONAL ACADEMY PRIVATE LIMITED",
"IVANA STYLE ICON PRIVATE LIMITED",
"IVANGEL SALES & SERVICES PRIVATE LIMITED",
"IVANHOE CAMBRIDGE INDIA SERVICES PRIVATE LIMITED",
"IVANTI TECHNOLOGY INDIA PRIVATE LIMITED",
"IVAR CONSULTANTS PRIVATE LIMITED",
"IVAVSYS TECHNOLOGIES PRIVATE LIMITED",
"IVAX PAPER CHEMICALS LIMITED",
"IVAX PAPER CHEMICALS PRIVATE LIMITED",
"IVC BUILDCON PRIVATE LIMITED",
"IVC LOGISTICS LIMITED",
"IVC PUMPS PRIVATE LIMITED",
"IVD HEALTHCARE PRIVATE LIMITED",
"IVECO N V",
"IVEEEM TECHNOLOGIES PRIVATE LIMITED",
"I-VELOZITY INDIA PRIVATE LIMITED",
"IVES DRUGS ( INDIA) PVT.LTD.",
"IVG CONSULTANTS PRIVATE LIMITED",
"IVI VALVES PRIVATE LIMITED",
"IVIA BEAUTE PRIVATE LIMITED",
"IVIS INTERNATIONAL PRIVATE LIMITED",
"IVISION SOFTWARE PRIVATE LIMITED",
"IVISTAZ ECOM SERVICES PRIVATE LIMITED",
"IVITESSE TECHNOLOGIES PRIVATE LIMITED",
"IVK EXPORTS PRIVATE LIMITED",
"IVL DHUNSERI PETROCHEM INDUSTRIES PRIVATE LIMITED",
"IVL INDIA ENVIRONMENTAL R&D PRIVATE LIMITED",
"IVM INDIA FINANCE PRIVATE LIMITED",
"IVOCLAR VIVADENT MARKETING (INDIA) PRIVATE LIMITED",
"IVOICE NETWORKS PRIVATE LIMITED",
"IVOLVE HOLDINGS PRIVATE LIMITED",
"IVOOMI INNOVATION PRIVATE LIMITED",
"IVORA VENTURES PRIVATE LIMITED",
"IVORY DESIGNS PRIVATE LIMITED",
"IVORY DESTINATIONS PRIVATE LIMITED",
"IVORY HOSPITAL PRIVATE LIMITED",
"IVORY PROPERTIES AND HOTELS PRIVATE LIMITED",
"IVORY SOAP WORKS LIMITED",
"IVORYSENSE PRIVATE LIMITED",
"IVOYANT SYSTEMS PRIVATE LIMITED",
"IVP ENGINEERS PRIVATE LIMITED",
"IVP LIMITED",
"IVPS INFRA PRIVATE LIMITED",
"IVRCL CHANDRAPUR TOLLWAYS LIMITED",
"IVRCL INDORE GUJARAT TOLLWAYS LIMITED",
"IVRCL TLT PRIVATE LIMITED",
"IVRCL-CADAGUA HOGENAKKAL WATER TREATMENT COMPANY PRIVATE LIMITED",
"IVS CREATIONS PRIVATE LIMITED",
"IVS GLOBAL SERVICES PRIVATE LIMITED",
"IVSS EDUCATION (OPC) PRIVATE LIMITED",
"IVSSG PRIVATE LIMITED",
"IVTCE OPC PRIVATE LIMITED",
"IVTL INFOVIEW TECHNOLOGIES PRIVATE LIMITED",
"IVTREE IT SOLUTIONS PRIVATE LIMITED",
"IVY ASPIRE CONSULTING PRIVATE LIMITED",
"IVY BPO SERVICES PRIVATE LIMITED",
"IVY COMPTECH PRIVATE LIMITED",
"IVY ECOENERGY INDIA PRIVATE LIMITED",
"IVY ENTERTAINMENT PRIVATE LIMITED",
"IVY GLOBAL SHARED SERVICES PRIVATE LIMITED",
"IVY HEALTH AND LIFE SCIENCES PRIVATE LIMITED",
"IVY HEALTHCARE INFRASTRUCTURE PRIVATE LIMITED",
"IVY JEWELLERY PRIVATE LIMITED",
"IVY LEAGUE SCHOOLS PRIVATE LIMITED",
"IVY MOBILITY SOLUTIONS LIMITED",
"IVY OVERSEAS",
"IVY PRODUCT INTERMEDIARIES LIMITED",
"IVY PROTECH IT ASSOCIATES PRIVATE LIMITED",
"IVY SOFTWARE DEVELOPMENT SERVICES PRIVATE LIMITED",
"IVY TEXFAB PRIVATE LIMITED",
"IVY TOURS AND TRAVELS PRIVATE LIMITED",
"IVY WOMEN AND CHILDREN HOSPITALS PRIVATE LIMITED",
"IVY WORKS ADVISORS LLP",
"IVYCAP VENTURES ADVISORS PRIVATE LIMITED",
"IW SOFTWARE SOLUTIONS PRIVATE LIMITED",
"IWAI ELECTRONICS PVT LTD",
"IWANT TECHNOLOGIES PRIVATE LIMITED",
"IWARE SUPPLYCHAIN SERVICES PRIVATE LIMITED",
"IWATANI INDIA PRIVATE LIMITED",
"IWAVE SYSTEMS TECHNOLOGIES PRIVATE LIMITED",
"IWAY LOGISTICS SERVICES PRIVATE LIMITED",
"IWEEN SOFTWARE SOLUTIONS PRIVATE LIMITED",
"IWI CRYOGENIC VAPORIZATION SYSTEMS INDIA PRIVATE LIMITED",
"IWI STATIONERY PRIVATE LIMITED",
"I-WIN ADVISORY SERVICES LIMITED",
"IWIS MOBILITY SYSTEMS INDIA PRIVATE LIMITED",
"IWIZ ANDROID ROBO PRIVATE LIMITED",
"IWK INDIA PRIVATE LIMITED",
"IWL INDIA PRIVATE LIMITED",
"IWM PUBLISHING AND COMMUNICATION PRIVATE LIMITED",
"IWORK TECHNOLOGIES PRIVATE LIMITED",
"I-WORKZ AUTOMOTIVE PRIVATE LIMITED",
"IWORLD BUSINESS SOLUTIONS PRIVATE LIMITED",
"IWW LEISURE INDIA PRIVATE LIMITED",
"IWW LOGISTICS PRIVATE LIMITED",
"IX DESIGNS PRIVATE LIMITED",
"IXCEED INFOSOLUTIONS PRIVATE LIMITED",
"IXCFO SERVICES PRIVATE LIMITED",
"IXIA SOLUTIONS LLP",
"IXIA TECHNOLOGIES PRIVATE LIMITED",
"IXL INDIA SERVICES PRIVATE LIMITED",
"I-XL TECHNOLOGIES PRIVATE LIMITED",
"IXOOP TECHNOLOGIES PRIVATE LIMITED",
"IXORA CORPORATE SERVICES PRIVATE LIMITED",
"IXORA GLOBAL SERVICES PRIVATE LIMITED",
"IXORAA MEDIA PRIVATE LIMITED",
"IXORRA EXPORTS PRIVATE LIMITED",
"IXOXI CONSTRUCTION LLP",
"IY BEE PROJECTS PRIVATE LIMITED",
"IYALIA ENGINEERING SOLUTIONS INDIA PRIVATE LIMITED",
"IYAPPAN ENGINEERING INDUSTRIES PRIVATE LIMITED",
"IYCWORLD SOFTINFRASTRUCTURE PRIVATE LIMITED",
"IYER EDUCATIONAL INSTITUTIONS PRIVATE LIMITED",
"IYER HEALTH CARE",
"IYRA DEVELOPERS PRIVATE LIMITED",
"IYSERT ENERGY RESEARCH PRIVATE LIMITED",
"I-YUNO MEDIA R&D PRIVATE LIMITED",
"IZA MEDI TECHNOLOGIES PRIVATE LIMITED",
"IZAAP TECHNOLOGIES PRIVATE LIMITED",
"IZATECH LABS PRIVATE LIMITED",
"IZEE BUSINESS SCHOOL",
"IZEK HEALTHCARE PRIVATE LIMITED",
"IZEL INFRASTRUCTURE PRIVATE LIMITED",
"IZENBRIDGE CONSULTANCY PRIVATE LIMITED",
"IZHAR ALI CONSTRUCTION AND DESIGN PRIVATE LIMITED",
"IZINGA SOFTWARE PRIVATE LIMITED",
"IZMO LIMITED",
"IZNA FOREX & TRAVELS PRIVATE LIMITED",
"IZNG HEALTHCARE PRIVATE LIMITED",
"IZOE SOLUTIONS PRIVATE LIMITED",
"IZON TECHNOLOGIES PRIVATE LIMITED",
"IZRA SOLAR ENERGY PRIVATE LIMITED",
"IZS TECHOCRATS PRIVATE LIMITED",
"IZUSU SEEDS PRIVATE LIMITED",
"IZUZ CONSULTANCY PRIVATE LIMITED",
"I-ZYSK SOLUTIONS PRIVATE LIMITED",
"IZZOK ELECTRICALS PRIVATE LIMITED",
"IZZY METALS PRIVATE LIMITED",
"J & H ELECTRONICS PRIVATE LIMITED",
"J & H TEXTILES LLP",
"J & J CARE MULTITRADE PRIVATE LIMITED",
"J & J FRESH PRODUCTS PRIVATE LIMITED",
"J & J LEATHER ENTERPRISES LIMITED",
"J & K MINERAL DEVELOPMENT CORPORATION LIMITED.",
"J & K WIRE & STEEL INDUSTRIES PRIVATE LIMITED",
"J & M HOSPITALITY SERVICES PRIVATE LIMITED",
"J & M TECHNO SYSTEMS PRIVATE LIMITED",
"J & N NANDI TEA PROCESSING PRIVATE LIMITED",
"J & P SAND AND AGGREGATES INTERNATIONAL PRIVATE LIMITED",
"J & SONS CONSTRUCTION PRIVATE LIMITED",
"J & V RUGS PRIVATE LIMITED",
"J & Y GALLERY PRIVATE LIMITED",
"J . R. ROADLINES PRIVATE LIMITED",
"J A CREDIT CONSULTANTS PRIVATE LIMITED",
"J A ENGINEERING",
"J A K SOFTWARE PVT LTD",
"J A L C",
"J A MARKETING PRIVATE LIMITED",
"J A S INTER COLLEGE KHURJA NAGAR BULANDSHAHR",
"J A TEXTILES PRIVATE LIMITED",
"J A WOOLLENS PRIVATE LIMITED",
"J AND B ENGINEERING AND CONSTRUCTION COMPANY",
"J AND J AGROVET PRIVATE LIMITED",
"J AND K CARGO MOVERS PRIVATE LIMITED",
"J AND K HERITAGE HOTELS PRIVATE LIMITED",
"J AND K VEHICLEADES PRIVATE LIMITED",
"J AND P TECHNO SERVICES PRIVATE LIMITED",
"J AND S CONSTRUCTION",
"J AND S INVESTMENTS PRIVATE LIMITED",
"J AND S WIRELINKS PRIVATE LIMITED",
"J ARK LOGISTICS PRIVATE LIMITED",
"J ASHOK FABTEXS PRIVATE LIMITED",
"J B ADVANI AND COMPANY PRIVATE LIMITED",
"J B ALUMINIUM INDUSTRIES PRIVATE LIMITED",
"J B AND BROTHERS PRIVATE LIMITED",
"J B ANEJA ASSOCIATE",
"J B BODA AND CO PRIVATE LIMITED",
"J B BODA INSURANCE & REINSURANCE BROKERS PRIVATE LIMITED",
"J B BODA INSURANCE SURVEYORS & LOSS ASSESSORS PRIVATE LIMITED",
"J B C ENGINEERS PRIVATE LIMITED.",
"J B CHEMICALS AND PHARMACEUTICALS LIMITED",
"J B COMIDA PRIVATE LIMITED",
"J B DARUKA PAPERS LIMITED",
"J B DIAMONDS & KARP IMPEX VIDYA SANKUL",
"J B ECOTEX LIMITED",
"J B ENTERPRISE",
"J B EXPORTS PRIVATE LTD",
"J B GUPTA & SONS PRIVATE LIMITED",
"J B GUPTA ENTERPRISES PRIVATE LIMITED",
"J B HOME STORE PRIVATE LIMITED",
"J B JOSHI RESEARCH FOUNDATION",
"J B M R INDUSTRY PRIVATE LIMITED",
"J B M TEXTILES PRIVATE LIMITED",
"J B MARZBAN AND CO PVT LTD",
"J B METAL INDUSTRIES PRIVATE LIMITED",
"J B MOTORS PRIVATE LIMITED",
"J B POULTRIES PRIVATE LIMITED",
"J B PUBLISHING HOUSE PRIVATE LIMITED",
"J B R CHEMICALS PRIVATE LIMITED",
"J B REALTORS PRIVATE LIMITED",
"J B ROADLINES PRIVATE LIMITED",
"J B S ENTERPRISE",
"J B S SECURITIES PVT LTD",
"J B TRAVEL & TOURS (INDIA) PRIVATE LIMITED",
"J B TREDING CO",
"J BOSECK & CO PVT LTD",
"J C BUSINESS PRIVATE LIMITED",
"J C COLLEGE OF LAW",
"J C CONSTRUCTION PRIVATE LIMITED",
"J C FASTENERS LIMITED",
"J C GRAPICS PRIVATE LIMITED",
"J C I CHEMICALS INDIA PRIVATE LIMITED",
"J C INSULATION AND ENGINEERS PRIVATE LIMITED",
"J C INTERNATIONAL LIMITED",
"J C MERCHANDISING PRIVATE LIMITED",
"J C OVERSEAS LIMITED",
"J C PENNEY SERVICES INDIA PRIVATE LIMITED",
"J C STATIONERY PRIVATE LIMITED",
"J D B STEEL LLP",
"J D BIRLA INSTITUTE",
"J D CHAINS PRIVATE LIMITED",
"J D COLLEGE OF ENGINEERING & MANAGEMENT",
"J D CONTRACTS PRIVATE LIMITED",
"J D DIAGNOSTICS PVT LTD",
"J D FOOD PRODUCTS PRIVATE LIMITED",
"J D INFRASPACE PRIVATE LIMITED",
"J D IRON PRIVATE LIMITED",
"J D ISPAT PRIVATE LIMITED",
"J D JONES & CO PVT LTD",
"J D M METAL FINISHERS PRIVATE LIMITED",
"J D M UDYOG PRIVATE LIMITED",
"J D NIRMAN PRIVATE LIMITED",
"J D PRECISION PRIVATE LIMITED",
"J D PRINTERS PRIVATE LIMITED",
"J D S VENTURES INDIA LIMITED",
"J D SOFTECH PRIVATE LIMITED",
"J D SONS STEELS PRIVATE LIMITED",
"J D STATE PLANING COMM UP LKO",
"J D TYTLER SCHOOL",
"J DUNCAN HEALTHCARE PRIVATE LIMITED",
"J E SCHOOL JR COLLAGE MUKTAINAGAR DIST JALGAON",
"J F C LEASING PRIVATE LIMITED",
"J F COLLEGE OF SOCIAL WORK",
"J G A SHAH SHARE BROKERS PRIVATE LIMITED",
"J G ENGINEERS PVT LTD",
"J G ENTERPRISES PRIVATE LIMITED",
"J G FOUNDRY LIMITED",
"J G HOSIERY PRIVATE LIMITED",
"J G POWERCON PRIVATE LIMITED",
"J G S TEXFAB PRIVATE LIMITED",
"J G SERVICES",
"J G SPINNING MILLS PRIVATE LIMITED",
"J G SPONGE AND POWER PRIVATE LIMITED",
"J G TRADELINK PRIVATE LIMITED",
"J H JAISWAL",
"J H PARABIA (TRANSPORT) PRIVATE LIMITED",
"J H V SUGAR LIMITED",
"J H WOOD FIRMS PRIVATE LIMITED",
"J HOTELS PRIVATE LIMITED",
"J I GANDHI SILK MILLS PVT LTD",
"J INDUSTRIAL PRODUCTS (INDIA) PRIVATE LIMITED",
"J J ACADEMY",
"J J AUTO COMPONENTS (INDIA) PRIVATE LIMITED",
"J J AUTOMOTIVE PRIVATE LIMITED",
"J J COMMUNICATION PRIVATE LIMITED",
"J J ENGINEERING PVT LTD",
"J J EPC PRIVATE LIMITED",
"J J EXTRUSION PRIVATE LIMITED",
"J J FABTEX PRIVATE LIMITED",
"J J FOAMS PRIVATE LIMITED",
"J J GLASTRONICS PRIVATE LIMITED",
"J J HOSPITAL",
"J J IMPEX DELHI LIMITED",
"J J IMPEX DELHI PRIVATE LIMITED",
"J J INSTITUTE OF MEDICAL SCIENCES PRIVATE LIMITED",
"J J INTER COLLEGE SULTANPUR",
"J J J JEWELLERS PRIVATE LIMITED",
"J J LALL PRIVATE LIMITED",
"J J MEMORIAL DIAGNOSTICS & HOSPITALS PRIVATE LIMITED",
"J J MINETEX EXIM PRIVATE LIMITED",
"J J OIL INDUSTRIES PRIVATE LIMITED",
"J J PARIKH PHARMA PVT LTD",
"J J PLASTALLOY PRIVATE LIMITED",
"J J PRINTS PRIVATE LIMITED",
"J J PUMP PRIVATE LIMITED",
"J J RETAIL PRIVATE LIMITED",
"J J TRADELINKS PRIVATE LIMITED",
"J J V ENGINEERS PRIVATE LIMITED",
"J K AND SONS IMPEX PRIVATE LIMITED",
"J K AVTAR PRIVATE LIMITED",
"J K BUILDERS PRIVATE LIMITED",
"J K CABLES LIMITED",
"J K CEMENT LIMITED",
"J K CENTRALISED SERVICES PRIVATE LIMITED",
"J K CHANDRA EXPORTS PVT LTD",
"J K CLOTHING PRIVATE LIMITED",
"J K CONCRETE BUILDCON PRIVATE LIMITED",
"J K CONSULTANCY AND SERVICES PRIVATE LIMITED",
"J K ENGITECH PRIVATE LIMITED",
"J K EXIM PRIVATE LIMITED",
"J K FENNER (INDIA) LIMITED",
"J K FILLPACK ENGINEERS PRIVATE LIMITED",
"J K FINE PRINTS PRIVATE LIMITED",
"J K G BIO SCIENCE PRIVATE LIMITED",
"J K INDUSTRIES",
"J K INTERNATIONAL PRIVATE LIMITED",
"J K INVESTORS BOMBAY LIMITED",
"J K J & SONS ENDEAVOUR PRIVATE LIMITED",
"J K LEISURES PRIVATE LIMITED",
"J K LOAN SPMCHI HOSPITAL",
"J K M THERMO ENGINEERS TECHNOLOGY PRIVATE LIMITED",
"J K MACHINE TOOLS (GUJARAT) PRIVATE LIMITED",
"J K MALT PRODUCTS PRIVATE LIMITED",
"J K MOSUN & SONS JEWELLERS PRIVATE LIMITED",
"J K MULTISPECIALITY HOSPITAL KALYAN",
"J K P IMPEX (INDIA) PRIVATE LIMITED",
"J K PAINTS AND RESINS PRIVATE LIMITED",
"J K PAINTS PRIVATE LIMITED",
"J K PARAS POLYCOATS LIMITED",
"J K POLYPLAST PRIVATE LIMITED",
"J K PRINT PACKS",
"J K PROJECTS PRIVATE LIMITED",
"J K PROTOMAX PRIVATE LIMITED",
"J K PULSE MANUFACTURERS PRIVATE LIMITED",
"J K R MOTORS PRIVATE LIMITED",
"J K REAL ESTATE DEVELOPERS PRIVATE LIMITED",
"J K ROAD CONSTRUCTION COMPANY PRIVATE LIMITED",
"J K SALES",
"J K SOLUTIONS INC",
"J K SUBSEA ENGG PRIVATE LIMITED",
"J K SWITCHGEARS AND KABLE PRIVATE LIMITED",
"J K T FABRICS PRIVATE LIMITED",
"J K TEA ESTATES PRIVATE LIMITED",
"J K TECHNOLOGIES PRIVATE LIMITED",
"J K TECHNOSOFT LIMITED",
"J K TEXBOND PRIVATE LIMITED",
"J K TRADING COMPANY PRIVATE LIMITED",
"J K TRANSPORT & LOGISTICS PRIVATE LIMITED",
"J KAMDAR",
"J KORIN SPINNING PRIVATE LIMITED",
"J KUMAR CONSTRUCTION AND SERVICES PRIVATE LIMITED",
"J KUMAR INFRAPROJECTS LIMITED",
"J L AUTOPARTS PRIVATE LIMITED",
"J L HOTELS PRIVATE LIMITED",
"J L MORISON (INDIA) LIMITED",
"J L MORISON INDIA LIMITED",
"J L SHAH SECURITIES PRIVATE LIMITED",
"J M A FOOD PRODUCTS PRIVATE LIMITED",
"J M A STORES PRIVATE LIMITED",
"J M ASSETS MANAGEMENT PRIVATE LIMITED",
"J M BAXI HEAVY PRIVATE LIMITED",
"J M BAXI PORTS & LOGISTICS LIMITED",
"J M BAXI TECHNOLOGIES PRIVATE LIMITED",
"J M C WORKS PRIVATE LIMITED",
"J M D DESIGN DESK PRIVATE LIMITED",
"J M D HOSPITALITY PRIVATE LIMITED",
"J M D METAL PRIVATE PRIVATE LIMITED",
"J M ENTERPRISES PRIVATE LIMITED",
"J M ENVIROLAB PRIVATE LIMITED",
"J M ENVIRONET PRIVATE LIMITED",
"J M FINANCIAL AND INVESTMENT CONSULTANCY SERVICES PRIVATE LIMITED",
"J M GLOBAL EQUITIES PRIVATE LIMITED",
"J M HEALTHCARE PRIVATE LIMITED",
"J M INDUSTRIES",
"JM JAIN LLP",
"J M KOTHARI & SONS TRANSLOGISTICS PRIVATE LIMITED",
"J M LAND PROMOTERS PRIVATE LIMITED",
"J M LIFESTYLE INTERIOR PROJECTS PRIVATE LIMITED",
"J M MANPOWER & SECURITY PRIVATE LIMITED",
"J M MEHTA TRAVEL AND TOUR COMPANY PRIVATE LIMITED",
"J M MHATRE INFRA PRIVATE LIMITED",
"J M MILLS PRIVATE LIMITED",
"J M MOTORS PRIVATE LIMITED",
"J M PATEL ARTS COMMERCE & SCIENCE COLLAGE BHANDARA",
"J M S POLYMERS PRIVATE LIMITED",
"J M SPICES PRIVATE LIMITED",
"J M THAKKERS DEVELOPERS PVT LTD",
"J M W INDIA PRIVATE LIMITED",
"J MAHENDRAKANT JEWELLERS PRIVATE LIMITED",
"J MANDAL & CO",
"J MITRA AND CO PRIVATE LIMITED",
"J N ARORA AND COMPANY PRIVATE LIMITED",
"J N CREATIONS & LOGISTICS PRIVATE LIMITED",
"J N FREIGHT FORWARDERS PRIVATE LIMITED",
"J N J ELECTRONICS LIMITED",
"J N J MACHINES PRIVATE LIMITED",
"J N MARSHALL PRIVATE LIMITED",
"J N MISHRA HOSPITAL",
"J N PETIT INSTITUTE",
"J N PETIT TECHNICAL HIGH SCHOOL",
"J N ROBOTIC AUTOMATION PRIVATE LIMITED",
"J P AGROTECH PRIVATE LIMITED",
"J P AIR CORDITIONER",
"J P AVIATION SERVICES PRIVATE LIMITED",
"J P BROADLINE DISTRIBUTION COMPANY PRIVATE LIMITED",
"J P CABLES PRIVATE LIMITED",
"J P CLOTHINGS PRIVATE LIMITED",
"J P CONVENT SCHOOL",
"J P DYECHEM PRIVATE LIMITED",
"J P ENGINEERING WORKS",
"J P EXTRUSIONTECH PRIVATE LIMITED",
"J P G CONSTRUCTIONS PRIVATE LIMITED",
"J P JAIN SR SEC SCHOOL",
"J P KACHIWALA TEXTILES PRIVATE LIMITED",
"J P LABORATORIES PRIVATE LIMITED",
"J P M AUTOMOBILES LIMITED",
"J P MORGAN INDIA PRIVATE LIMITED",
"J P MORGAN SERVICES INDIA PRIVATE LIMITED",
"J P MUKHERJIAND ASSOCIATES PRIVATE LIMITED",
"J P N PHARMA PRIVATE LIMITED",
"J P O POLYCHEM PRIVATE LIMITED",
"J P P MILLS PRIVATE LIMITED",
"J P PETROCHEM PRIVATE LIMITED",
"J P POLYMERS PRIVATE LIMITED",
"J P PROCESSORS PRIVATE LIMITED",
"J P R INVESTMENTS AND TRADING PRIVATE LIMITED",
"J P R N AMAR INTER COLLEGE KANPUR",
"J P S EARTHMOVERS PRIVATE LIMITED",
"J P STEELS LTD",
"J P TOBACCO PRODUCTS PRIVATE LIMITED",
"J PAN TUBULAR COMPONENTS PRIVATE LIMITED",
"J R & M BANIK PVT LTD",
"J R AGRO INDUSTRIES PRIVATE LIMITED",
"J R BUSINESS AND RESORTS PRIVATE LIMITED",
"J R CONSULTANCY SERVICES PRIVATE LIMITED",
"J R CREATIONS ADVERTISERS PRIVATE LIMITED",
"J R D TELECOM PRIVATE LIMITED",
"J R EXPORTS PRIVATE LIMITED",
"J R FURNACE AND OVENS PRIVATE LIMITED",
"J R HOTELS PRIVATE LIMITED",
"J R J SEA FOODS INDIA PRIVATE LIMITED",
"J R K MFG PRIVATE LIMITED",
"J R POWER GEN PRIVATE LIMITED",
"J R REDDY LIONS HOSPITAL",
"J R RICE INDIA PRIVATE LIMITED",
"J R ROADLINES PRIVATE LIMITED",
"J R SHAH EXPORTS LIMITED",
"J R SQUARE TECHNOLOGIES PRIVATE LIMITED",
"J R SYNTHETIC PRIVATE LIMITED",
"J R URBAN INFRACON PRIVATE LIMITED",
"J RAJKUMAR TEXTILE PRIVATE LIMITED",
"J RAY MCDERMOTT ENGINEERING SERVICES PRIVATE LIMITED",
"J S ACADEMY",
"J S ALUMINIUM PRIVATE LIMITED",
"J S AUTO CAST FOUNDRY INDIA PRIVATE LIMITED",
"J S AYURVEDA MAHAVIDYALAYA AND P D PATEL AYURVEDA HOSPITAL",
"J S CORRU PACK PRIVATE LIMITED",
"J S DEVELOPMENT SOURCING ADVISORS PRIVATE LIMITED",
"J S ENGGPROJECTS PRIVATE LIMITED",
"J S ENVIRO SERVICES PRIVATE LIMITED",
"J S FASHIONS INTL PRIVATE. LIMITED",
"J S FOUR WHEEL MOTORS PRIVATE LIMITED",
"J S FURNISHINGS PRIVATE LIMITED",
"J S GROVER AUTOMOTIVES PRIVATE LIMITED",
"J S INFOSOFT PRIVATE LIMITED",
"J S J BUILDERS PRIVATE LIMITED",
"J S JAIN AGRO INDUSTRIES PRIVATE LIMITED",
"J S K FAB PRIVATE LIMITED",
"J S K HOTELS PRIVATE LIMITED",
"J S KHALSA STEELS PRIVATE LIMITED",
"J S MASALA COMPANY",
"J S OVERSEAS PVT LTD",
"J S P AUTOMOTIVE",
"J S PIGMENTS PRIVATE LIMITED",
"J S POLYPLAST PRIVATE LIMITED",
"J S R FABRICS PRIVATE LIMITED",
"J S SPINTEX PRIVATE LIMITED",
"J S WINTECH PRIVATE LIMITED",
"J S YARN TEX PRIVATE LIMITED",
"J SAGAR ASSOCIATES",
"J T INFOTECH PRIVATE LIMITED",
"J T MARINE SERVICES PRIVATE LIMITED",
"J T PACK PRIVATE LIMITED",
"J T S COLD STORAGE PRIVATE LIMITED",
"J TAO CREATIONS PRIVATE LIMITED",
"J TCHANRAI INDUSTRIES PRIVATE LIMITED",
"J TECHNOLOGIES INDIA LIMITED",
"J TEX INTERNATIONAL PRIVATE LIMITED",
"J THOMAS & CO PVT LTD",
"J V CAFE PRIVATE LIMITED",
"J V COMMODITY PRIVATE LIMITED",
"J V CONBUILD PRIVATE LIMITED",
"J V EQUITIES PRIVATE LIMITED",
"J V EXPORT",
"J V GOKAL AND COMPANY PRIVATE LIMITED",
"J V HOSPITAL",
"J V INDUSTRIES PRIVATE LIMITED",
"J V MODERN SCHOOL",
"J V R FINE CHEMIE PRIVATE LIMITED",
"J V S FOODS PRIVATE LIMITED",
"J V S H S VIDHYALAY",
"J V S LOGISTICS PRIVATE LIMITED",
"J V S PLASTICS PRIVATE LIMITED",
"J V S SECURITIES PVT LTD",
"J V SEAMLESS INDIA PRIVATE LIMITED",
"J V TAPES PRIVATE LIMITED",
"J V TEXPRO PRIVATE LIMITED",
"J Y KITCHENWARE PRIVATE LIMITED",
"J&A EDIBLE OILS PRIVATE LIMITED",
"J&F INDIA PRIVATE LIMITED",
"J&G TRANSFORMER PRIVATE LIMITED",
"J&J COLLEGE OF SCIENCE NADIAD",
"J&J GLOBAL SOURCING LLP",
"J&T GEM AND JEWELLRY PRIVATE LIMITED",
"J&V HUMAN RESOURCES SERVICES PRIVATE LIMITED",
"J&V INFRATECH PRIVATE LIMITED",
"J. ARIM FABRICS PRIVATE LIMITED",
"J. B. BROTHERS GARMENTS INDIA PRIVATE LIMITED",
"J. B. REMEDIES PRIVATE LIMITED",
"J. B. SYNTEX PRIVATE LIMITED",
"J. C. AND SONS PRIVATE LIMITED",
"J. C. ELECTRONICS PRIVATE LIMITED",
"J. C. PENNEY PURCHASING INDIA PRIVATE LIMITED",
"J. C. PENNEY SERVICES INDIA PRIVATE LIMITED",
"J. D. COMMERCIAL PRIVATE LIMITED",
"J. D. J. TRADERS PRIVATE LIMITED",
"J. I. POLYFAB PRIVATE LIMITED",
"J. J. GOLD REFINERY PRIVATE LIMITED",
"J. J. HOUSE PRIVATE. LIMITED.",
"J. J. INDUSTRIAL HOLDINGS PRIVATE LIMITED",
"J. J. IRON AND STEEL PRIVATE LIMITED",
"J. J. PATEL & CO. PRIVATE LIMITED",
"J. K. ENGICON PRIVATE LIMITED",
"J. K. JEWELS",
"J. K. READYMADE CENTRE PRIVATE LIMITED",
"J. K. SHAH EDUCATION PRIVATE LIMITED",
"J. K. SOLUTIONS PRIVATE LIMITED",
"J. K. TECH-MECH PRIVATE LIMITED",
"J. K. TECHNOPLAST PRIVATE LIMITED",
"J. K. YARN PRIVATE LIMITED",
"J. KUMAR DEVELOPERS LIMITED",
"J. M. B. METAL CRAFTS PRIVATE LIMITED",
"J. M. D. DIGITECH PRIVATE LIMITED",
"J. M. GOLD PRIVATE LIMITED",
"J. M. POWER TECHNOLOGIES PRIVATE LIMITED",
"J. N. TAYAL STEELS PRIVATE LIMITED",
"J. N. TRADERS",
"J. P. BISCUITS PRIVATE LIMITED",
"J. P. ENTERPRISES",
"J. P. LIFE SCIENCE PRIVATE LIMITED",
"J. P. MITTAL ISPAT PRIVATE LIMITED",
"J. P. PLASCHEM PRIVATE LIMITED",
"J. P. POULTRY EQUIPMENTS PRIVATE LIMITED",
"J. P. SWITCHGEAR DISTRIBUTORS PRIVATE LIMITED",
"J. R. C. GRID ENGINEERS PRIVATE LIMITED",
"J. R. COLLECTION PRIVATE LIMITED",
"J. R. JEWELLERS PRIVATE LIMITED",
"J. R. SHAH & CO",
"J. R. SOOD & CO. PRIVATE LIMITED",
"J. RAJAN STEELS PRIVATE LIMITED",
"J. S. AUTO PRIVATE LIMITED",
"J. S. B. AUTO PRIVATE LIMITED",
"J. S. BODYCARE PRIVATE LIMITED",
"J. S. ELASTIC PRIVATE LIMITED",
"J. S. ESTATES AND PROJECTS PRIVATE LIMITED",
"J. S. GAUTAM ENTERPRISES PRIVATE LIMITED",
"J. S. GROVER AUTOS PRIVATE LIMITED",
"J. S. PACKERS PRIVATE LIMITED",
"J. T. TRANSPORT PRIVATE LIMITED",
"J. TRONIX PRIVATE LIMITED",
"J. V. TRADELINK PRIVATE LIMITED",
"J.A. BUILDCON PRIVATE LIMITED",
"J.A. FINANCE LTD.",
"J.A. UNITED EXPORTS PRIVATE LIMITED",
"J.B ADVERTISING PRIVATE LIMITED",
"J.B FACILITY MANAGEMENT SERVICES",
"J.B. COTTON",
"J.B. DIGITRONICS PRIVATE LIMITED",
"J.B. FASHIONS LIMITED",
"J.B. MANUFACTURING & TRADING PRIVATE LIMITED",
"J.B. MARMO PRIVATE LIMITED",
"J.B. NUTS AND SPICES PRIVATE LIMITED",
"J.B. POWER CONSULTANTS PRIVATE LIMITED",
"J.B. SINGH PLYWOOD INDUSTRIES (I) PRIVATE LIMITED",
"J.B.A.CONCRETE SOLUTIONS PRIVATE LIMITED",
"J.B.CARRIERS AND MOVERS PRIVATE LIMITED",
"J.B.GUPTA HARDWARE COLLECTION PRIVATE LIMITED",
"J.B.MERCANTILE CARRIERS PRIVATE LIMITED",
"J.B.S. FOOD PRODUCTS PRIVATE LIMITED",
"J.B.SAWANT ENGINEERING PRIVATE LIMITED",
"J.C. FENASIA EXPORTS PRIVATE LIMITED",
"J.C. FLOWERS ASSET RECONSTRUCTION PRIVATE LIMITED",
"J.C. INFRA CORPORATION LIMITED",
"J.C. PRAKASH INFRASTRUCTURES PRIVATE LIMITED",
"J.C.ENTERPRISES PRIVATE LIMITED",
"J.C.GUPTA AND COMPANY INSURANCE SURVEYORS AND LOSS ASSESSORS PRIVATE LIMITED",
"J.C.IRON & STEELS PRIVATE LIMITED",
"J.C.ORNAMENTS PRIVATE LIMITED",
"J.C.P.M. INDUSTRIES PRIVATE LIMITED",
"J.C.R CNC AUTOMATION SYSTEMS PRIVATE LIMITED",
"J.D. AGRI GEARS LIMITED",
"J.D. ANEJA EDIBLES PRIVATE LIMITED",
"J.D. APPARELS PRIVATE LIMITED",
"J.D. AUTO ELECTRICALS PRIVATE LIMITED",
"J.D. HOISTS AND CRANES PRIVATE LIMITED",
"J.D. INDUSTRIES INDIA LIMITED",
"J.D. JADIA INFRASTRUCTURES PRIVATE LIMITED",
"J.D. METALS & ALLOYS PRIVATE LIMITED",
"J.D. TECHNOFAB PRIVATE LIMITED",
"J.D. VENTURES PRIVATE LIMITED",
"J.D.GOLD PRIVATE LIMITED",
"J.D.I ENTERPRISE PRIVATE LIMITED",
"J.D.S FOOD PRODUCTS PRIVATE LIMITED",
"J.G. HOLDINGS & INVESTMENTS PRIVATE LIMITED",
"J.G.DEVELOPMENT PVT LTD",
"J.G.IMPEX PRIVATE LIMITED",
"J.H DISPOSABLE AND PACKAGING PRIVATE LIMITED",
"J.H.S ISPAT (INDIA) PRIVATE LIMITED",
"J.H.V. STEELS LIMITED",
"J.J ALUMINIUM PRIVATE LIMITED",
"J.J MOULDS PRIVATE LIMITED",
"J.J SHAH PAPERS PRIVATE LIMITED",
"J.J. AUTOMOTIVE LIMITED",
"J.J. COATINGS",
"J.J. DEVSOFT PRIVATE LIMITED",
"J.J. NITRO PRODUCTS PRIVATE LIMITED",
"J.J. SPRING MANUFACTURING PVT. LTD.",
"J.J. TEA PRIVATE LIMITED",
"J.J. TUBES PRIVATE LIMITED",
"J.J. VYAPAAR PRIVATE LIMITED",
"J.J.ELECTROFAB (INDIA) PRIVATE LIMITED",
"J.J.FOODS PRIVATE LIMITED",
"J.J.HOUSE PRIVATE LIMITED",
"J.J.J. TRADERS",
"J.J.SAREES PRIVATE LIMITED",
"J.J.TOWELS PRIVATE LIMITED",
"J.K PRESTRESSING CO",
"J.K. CAR RENTAL SERVICES PRIVATE LIMITED",
"J.K. CERAMICS PRIVATE LIMITED",
"J.K. CREDIT AND FINANCE LIMITED.",
"J.K. ELECTRONICS AND APPLIANCES PRIVATE LIMITED",
"J.K. FABRICS BANGALORE PRIVATE LIMITED",
"J.K. INFCON PRIVATE LIMITED",
"J.K. JAIN BUILDTECH (INDIA) PRIVATE LIMITED",
"J.K. JEWELLERS PRIVATE LIMITED",
"J.K. POLYPET PRIVATE LIMITED",
"J.K. PUMPS PRIVATE LIMITED",
"J.K. SILKS PRIVATE LIMITED",
"J.K. SONS JUTE CO PRIVATE LIMITED",
"J.K. WEALTH PRIVATE LIMITED",
"J.K. WHEELS PRIVATE LIMITED",
"J.K.FABRICS PRIVATE LIMITED",
"J.K.FASHIONS PRIVATE LIMITED",
"J.K.FERRO ALLOYS PRIVATE LIMITED",
"J.K.FLOUR MILLS PRIVATE LIMITED",
"J.K.GEMS & JEWELLERY PRIVATE LIMITED",
"J.K.HELENE CURTIS LIMITED",
"J.K.J & SONS JEWELLERY HOUSE PRIVATE LIMITED",
"J.K.K MUNIRAJAHH MEDICAL RESEARCH FOUNDATION COLLEGE OF OCCUPATIONAL THERAPY",
"J.K.NON WOVEN BAGS PRIVATE LIMITED",
"J.K.P. MASTER BATCH PRIVATE LIMITED",
"J.K.PACKAGINGS PRIVATE LIMITED",
"J.K.SCAFFOLDING (INDIA) PRIVATE LIMITED",
"J.K.TEXCON INDUSTRIES PRIVATE LIMITED",
"J.K.TRADERS LIMITED",
"J.L. FOOD PRODUCTS PRIVATE LIMITED",
"J.L. JOLLY DIGITECH INDIA PRIVATE LIMITED",
"J.LOGICOM INDIA PRIVATE LIMITED",
"J.M. ISPAT PRIVATE LIMITED",
"J.M. PETROCHEMICALS PRIVATE LIMITED",
"J.M. SPARES & AUTO CENTRE PRIVATE LIMITED",
"J.M. STYLE & DESIGN PRIVATE LIMITED",
"J.M.AUTO DISTRIBUTORS PRIVATE LIMITED",
"J.M.CHEMICALS PRIVATE LIMITED",
"J.M.D H.R. MANAGEMENT PRIVATE LIMITED",
"J.M.D. CONTRACTS (INDIA) PRIVATE LIMITED",
"J.M.D. OVERSEAS PRIVATE LIMITED",
"J.M.SMITH INTERNATIONAL INDIA PRIVATE LIMITED",
"J.M.SPRINGS PRIVATE LIMITED",
"J.M.T PLASP PRIVATE LIMITED",
"J.M.T. ENTERPRISES PRIVATE LIMITED",
"J.MADHU ADVERTISING & MARKETING PRIVATE LIMITED",
"J.MAHESHKUMAR PETROCHEMICALS PRIVATE LIMITED",
"J.N. FOREST PRODUCTS PVT. LTD.",
"J.N. JEWELLERY HOUSE PRIVATE LIMITED",
"J.N.B. PHARMA PRIVATE LIMITED",
"JNB STEEL INDUSTRIES PRIVATE LIMITED",
"J.N.FOOTWEAR PRIVATE LIMITED",
"J.N.M. REALTY AND MARKETING LIMITED",
"J.N.N MATRIC HR SEC SCHOOL",
"J.P. DAIRY PRIVATE LIMITED",
"J.P. DEVELOPERS PRIVATE LIMITED",
"J.P. MORGAN CHASE & CO.",
"J.P. PAPER PRODUCTS PRIVATE LIMITED",
"J.P. SHARMA CONSULTANTS PRIVATE LIMITED",
"J.P. SILK MILLS PRIVATE LIMITED",
"J.P. TINS PRIVATE LIMITED",
"J.P. TRAFFIC AUTOMATION PRIVATE LIMITED",
"J.P.AGRAWAL & SONS COLD STORAGE PRIVATE LIMITED",
"J.P.DISTILLERIES PRIVATE LIMITED",
"J.P.ELECTRONIC DEVICES INDIA PRIVATE LIMITED",
"J.P.F.METACAST PRIVATE LIMITED",
"J.P.G. ENGINEERS PRIVATE LIMITED",
"J.P.J. EXIM PRIVATE LIMITED",
"J.P.JEWELLERS PRIVATE LIMITED",
"J.P.L.S. DAIRY PRIVATE LIMITED",
"J.P.M. HOSPITALITIES PRIVATE LIMITED",
"J.P.STONE CRUSHERS PRIVATE LIMITED",
"J.P.SWEETS PRIVATE LIMITED",
"J.PAPYRUS PACKAGING PRIVATE LIMITED",
"J.PEE ENGINEERS & PACKAGING PRIVATE LIMITED",
"J.R SPECIALITY CHEMICALS PRIVATE LIMITED",
"J.R. AGRO MILLS PRIVATE LIMITED",
"J.R. FABRICS PRIVATE LIMITED",
"J.R. ISPAT PRIVATE LIMITED",
"J.R. LADDHA FINANCIAL SERVICES PRIVATE.LIMITED.",
"J.R. METAL CHENNAI LIMITED",
"J.R.G. AUTOMOTIVE PRIVATE LIMITED",
"J.R.GOTECH ACCUMULATORS LIMITED",
"J.R.K. FABRICS PRIVATE LIMITED",
"J.R.L. ENGINEERING INFRATECH PRIVATE LIMITED",
"J.R.R. CONSTRUCTION PRIVATE LIMITED",
"J.R.S. ORYX PHARMACEUTICALS PVT LTD",
"J.R.TAPE PRODUCTS PRIVATE LIMITED",
"J.RODRIGUES COFFEE PRIVATE LIMITED",
"J.S GROVER CONSTRUCTIONS PRIVATE LIMITED",
"J.S JEWEL OM LLP",
"J.S. BASE COMPUTERS PRIVATE LIMITED",
"J.S. CONCRETE PRODUCTS PRIVATE LIMITED",
"J.S. GLOBAL FINANCE LIMITED",
"J.S. HELD INDIA PRIVATE LIMITED",
"J.S. INTERNATIONAL",
"J.S. MACHINE INDIA PRIVATE LIMITED",
"J.S. MARINE SERVICES PRIVATE LIMITED",
"J.S. OIL INDUSTRIES PRIVATE LIMITED",
"J.S. ONLINE SERVICES PRIVATE LIMITED (OPC)",
"J.S. SOLARTECH INDIA PRIVATE LIMITED",
"J.S. TRADEMART PRIVATE LIMITED",
"J.S.EXIM PRIVATE LIMITED",
"J.S.F. HOLDINGS PRIVATE LIMITED",
"J.S.LEADS TECHNOLOGIES PRIVATE LIMITED",
"J.S.P.HOSPITALS PRIVATE LIMITED",
"J.S.R. CONSTRUCTIONS PRIVATE LIMITED",
"J.S.R. RUBBER INDUSTRIES PVT LTD",
"J.T. FABRICS PRIVATE LIMITED",
"J.T.C. METALLON PRIVATE LIMITED",
"J.T.N. SERVICES PRIVATE LIMITED",
"J.TECH COMPUTERS PRIVATE LIMITED",
"J.U.B. AGRO FOODS PRIVATE LIMITED",
"J.UMASHANKAR AND COMPANY PVT. LTD.",
"J.V TRAVELS PRIVATE LIMITED",
"J.V. BRIGHT STEELS PRIVATE LIMITED",
"J.V. ENGINEERING AND CONVEYORS PRIVATE LIMITED",
"J.V. ESTATE INFRAPROJECTS PRIVATE LIMITED",
"J.V.M. PLASTCHEMS PRIVATE LIMITED",
"J.V.N. EXPORTS PRIVATE LIMITED",
"J.V.P MARINE PRODUCTS EXPORTS PRIVATE LIMITED",
"J.V.P.SUPER SPECIALITY HOSPITALS PRIVATE LIMITED",
"J.Y. BLOCK BEARING COMPANY (P) LTD",
"J2P EXECUTIVE HEADHUNTERS PRIVATE LIMITED",
"JA ARTS AND SCIENCE COLLEGE",
"JA ENGINEERING COLLEGE",
"JA ENTERTAINMENT PRIVATE LIMITED",
"JA FOODS CO PRIVATE LIMITED",
"JA FOOTBALL PRIVATE LIMITED",
"JA STERILE PRIVATE LIMITED",
"JA TRADERS PRIVATE LIMITED",
"JAABILLI CONSTRUCTIONS PRIVATE LIMITED",
"JAAC TECHNO SERVICES PRIVATE LIMITED",
"JAACM INFOTEL INFRASTRUCTRE INDIA PRIVATE LIMITED",
"JAAGATE SERVICES PRIVATE LIMITED",
"JAAGRUTHI HOUSING AND INFRA PRIVATE LIMITED",
"JAAGRUTHI INFO TECHNOLOGIES PRIVATE LIMITED",
"JAAGRUTHI LOGISTICS PRIVATE LIMITED",
"JAAGRUTHI POWER AND INFRA PRIVATE LIMITED",
"JAAHNAVEE LIFESCIENCES PRIVATE LIMITED",
"JAAI DEV HOSPITAL PRIVATE LIMITED",
"JAAIDEEP INDIA PRIVATE LIMITED",
"JAAJ OVERSEAS PRIVATE LIMITED",
"JAAJI SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"JAANDAR AGRO LIMITED",
"JAANDAR BUILDERS PRIVATE LIMITED",
"JAANI HOLDINGS PRIVATE LIMITED",
"JAANKI INFRA DEVELOPERS PRIVATE LIMITED",
"JAANVI SPINNERS PRIVATE LIMITED",
"JAAP CLOTHING PRIVATE LIMITED",
"JAAPS AUTOMOTIVE PRIVATE LIMITED",
"JAAPYAROSE INDUSTRIES PRIVATE LIMITED",
"JAARVIS TECHLABS PRIVATE LIMITED",
"JAARWIS TECHNOLOGIES PRIVATE LIMITED",
"JAAS AUTOMOTIVE INDIA PRIVATE LIMITED",
"JAASH UDYOG PRIVATE LIMITED",
"JAASHVI STORAGE SOLUTIONS PRIVATE LIMITED",
"JAASODHA AUTO PRIVATE LIMITED",
"JAAZ CORPORATION PRIVATE LIMITED",
"JAAZ TEXTILE SYSTEMS PRIVATE LIMITED",
"JABALPUR CITY TRANSPORT SERVICES LIMITED",
"JABALPUR ENGINEERING COLLEGE",
"JABALPUR ENTERPRISES PRIVATE LIMITED",
"JABALPUR ENTERTAINMENT COMPLEXES PRIVATE LIMITED",
"JABALPUR HOSPITAL & RESEARCH CENTRE PVT LTD.",
"JABALPUR HOSPITAL AND RESEARCH CENTRE",
"JABALPUR MOTORS LIMITED",
"JABALPUR MSW PRIVATE LIMITED",
"JABALPUR POLYTEX PRIVATE LIMITED",
"JABALPUR POWER & TECHNICAL PRIVATE LIMITED",
"JABALPUR SAHAKARI DUGDH SANGH MARYADIT",
"JABALPUR STEELS PRIVATE LIMITED",
"JABALPUR TRANSMISSION COMPANY LIMITED",
"JABAR SINGH KAUSHALYA DEVI HOSPITAL PRIVATE LIMITED",
"JABICO STEELS PRIVATE LIMITED",
"JABIL INDIA MANUFACTURING PRIVATE LIMITED",
"JABIT SOFT PRIVATE LIMITED",
"JABM ONESOURCE PRIVATE LIMITED",
"JABOX DEVICES PRIVATE LIMITED",
"JABRA CONNECT INDIA PRIVATE LIMITED",
"JABRO ADVERTISING & MARKETING PRIVATE LIMITED",
"JABS ASSOCIATES PRIVATE LIMITED",
"JABS INTERNATIONAL PRIVATE LIMITED",
"JABSONS FOODS PRIVATE LIMITED",
"JABU EXIM PRIVATE LIMITED",
"JAC AIR SERVICE PVT LTD",
"JAC RECRUITMENT INDIA PRIVATE LIMITED",
"JAC TRADEX PRIVATE LIMITED",
"JACARANDA PROPERTIES PRIVATE LIMITED",
"JACCO CABLES PRIVATE LIMITED",
"JACINTH ENGINEERING PRIVATE LIMITED",
"JACINTH FINVEST LIMITED",
"JACK IN THE BOX COMMUNICATIONS PRIVATE LIMITED",
"JACK SEWING MACHINE CO LIMITED",
"JACK SEWING MACHINE CO LTD",
"JACKBRO GLOBAL PRIVATE LIMITED",
"JACKLINE METROPOLITAN COMPANY PRIVATE LIMITED",
"JACKPOT DEALER PRIVATE LIMITED",
"JACKSON INVESTMENTS LTD",
"JACKSON LABORATORIES PRIVATE LIMITED",
"JACKSON PAPER PRODUCTS PRIVATE LIMITED",
"JACKSONS HOTELS PRIVATE LIMITED",
"JACOB AND RICHARD INTERNATIONAL PRIVATE LIMITED",
"JACOB BALLAS CAPITAL INDIA PRIVATE LIMITED",
"JACOB BALLAS INDIA PRIVATE LIMITED",
"JACOB ELECTRONICS PVT LTD",
"JACOB METALS AND ALLOYS P. LTD.",
"JACOBI CARBONS INDIA PRIVATE LIMITED",
"JACOBI MACHINERY PRIVATE LIMITED",
"JACOBI POWER INDIA PRIVATE LIMITED",
"JACOBS ENGINEERING GROUP INC.",
"JACOBS SOLUTIONS INDIA PRIVATE LIMITED",
"JACOMEX INDIA PRIVATE LIMITED",
"JACQUARD FABRICS (INDIA) PRIVATE LIMITED",
"JACQUARD HARNESS CORD PRIVATE LIMITED",
"JACSONS VENEERS AND PANELS PVT LTD",
"JACTRONIX TECHNOLOGY INDIA PRIVATE LIMITED",
"JAD SETU TECH PRIVATE LIMITED",
"JADABPUR TEA COMPANY LIMITED",
"JADAU JEWELLERS AND MANUFACTURERS PRIVATE LIMITED",
"JADAU POLKI JEWELLERY PRIVATE LIMITED",
"JADAV JEWELLERS PRIVATE LIMITED",
"JADAVPUR UNIVERSITY CALCUTTA",
"JADE BLUE LIFESTYLE INDIA LIMITED",
"JADE CONSUMER PRODUCTS INDIA PRIVATE LIMITED",
"JADE ESERVICES PRIVATE LIMITED",
"JADE ESTATES PRIVATE LIMITED",
"JADE GLOBAL SOFTWARE PRIVATE LIMITED",
"JADE GRANITES INDUSTRIES PRIVATE LIMITED",
"JADE LANDMARKS PRIVATE LIMITED",
"JADE LIFE SCIENCES PRIVATE LIMITED",
"JADE SECURITIES PRIVATE LIMITED",
"JADE STONE DEVELOPMENT AND HOLDING PRIVATE LTD",
"JADE TRADERS PRIVATE LIMITED",
"JADE UDYAM PRIVATE LIMITED",
"JADECORP INVENTEX PRIVATE LIMITED",
"JADEHOSPITAINMENT PRIVATE LIMITED",
"JADFOCUS SOLUTIONS LLP",
"JADHAO AGRO INDUSTRIES PVT.LTD.",
"JADHAO GEARS PRIVATE LIMITED",
"JADHAO LAYLAND PRIVATE LIMITED",
"JADHAO MOTORS PRIVATE LIMITED",
"JADHAV CONSTRUCTION & POWER COMPANY PRIVATE LIMITED",
"JADHAV INDUSTRIES PRIVATE LIMITED",
"JADLI FOODS (INDIA) PRIVATE LIMITED",
"JADOO INDIA PRIVATE LIMITED",
"JADOOZ MEDIA SOLUTION PRIVATE LIMITED",
"JADOUN ROADLINES PRIVATE LIMITED",
"JADUNANDAN SINGH ENGICONS PRIVATE LIMITED",
"JADWET TRADING COMPANY",
"JAE PHARMACY PRIVATE LIMITED",
"JAECO MOTORS PRIVATE LIMITED",
"JAECO REBUILDING SYSTEMS PRIVATE LIMITED",
"JAEGER PRODUCTS PRIVATE LIMITED",
"JAFFE FOOD INDUSTRIES PRIVATE LIMITED",
"JAFRA INSOLES INDIA PRIVATE LIMITED",
"JAG MARG PRIVATE LIMITED",
"JAG MINT PRIVATE LIMITED",
"JAG PRAVESH CHANDRA HOSPITAL",
"JAGABANDHU ENTERPRISERS PRIVATE LIMITED",
"JAGABANDHU INSTITUTION",
"JAGACHA HIGH SCHOOL",
"JAGADAMBA AUTO COMPONENTS LIMITED",
"JAGADAMBA ENGINEERING PRIVATE LIMITED",
"JAGADAMBA INFRASTRUCTURE PRIVATE LIMITED",
"JAGADAMBA KIDS WORLD PRIVATE LIMITED",
"JAGADAMBA SHELTER PRIVATE LIMITED",
"JAGADAMBA VAISHNO MOTORS PRIVATE LIMITED",
"JAGADDHATRI RICE MILL PRIVATE LIMITED",
"JAGADEESH IRON AND STEELS PRIVATE LIMITED",
"JAGADEESH MARINE EXPORTS",
"JAGADGURU BRICKS PRIVATE LIMITED",
"JAGADGURU NARENDRACHARYA MAHARAJ SANSTHAN",
"JAGADGURU RENUKACHARYA COLLEGE",
"JAGADGURU REVANSIDDHESHWAR PRASHALA",
"JAGADGURU SANT TUKARAM MAHARAJ SANTPITH",
"JAGADHATRI PLAST PRIVATE LIMITED",
"JAGADISH & ASSOCIATES IMPEX PVT. LTD.",
"JAGADISHWAR COLD STORAGE PRIVATE LIMITED",
"JAGADRAKSHA CHITFUNDS PRIVATE LIMITED",
"JAGAJAMPI AUTO PRIVATE LIMITED",
"JAGAJYOTI TIE-UP PVT LTD",
"JAGAN COLD WAREHOUSE PRIVATE LIMITED",
"JAGAN INDUSTRIES LIMITED",
"JAGAN INSTITUTE OF MANAGEMENT STUDIES",
"JAGAN JYOTI PRODUCT PRIVATE LIMITED",
"JAGAN LAMPS LIMITED",
"JAGAN PRASAD BUILDERS PRIVATE LIMITED",
"JAGANLITE INDIA PRIVATE LIMITED",
"JAGANNATH BANWARILAL TEXOFABS PRIVATE LIMITED",
"JAGANNATH CARRIER SERVICES PRIVATE LIMITED",
"JAGANNATH CHEMFOOD PRIVATE LIMITED",
"JAGANNATH CHEMICAL AND PHARMACEUTICAL WORKS PVT LTD",
"JAGANNATH CONSTRUCTION PRIVATE LIMITED",
"JAGANNATH CONVERTORS PRIVATE LIMITED",
"JAGANNATH CORPORATION PROJECTS PRIVATE LIMITED",
"JAGANNATH CRANEWAYS PRIVATE LIMITED",
"JAGANNATH EXTRUSION INDIA LIMITED",
"JAGANNATH GANGARAM PEDNEKAR JEWELLERS PRIVATE LIMITED",
"JAGANNATH GUPTA INSTITUE OF MEDICAL SCIENCE AND HOSPITAL",
"JAGANNATH HALOGEN PRIVATE LIMITED",
"JAGANNATH HEALTH CARE PRIVATE LIMITED",
"JAGANNATH HERBAL AND FOODS PRIVATE LIMITED",
"JAGANNATH JUTE PRODUCTS PRIVATE LIMITED",
"JAGANNATH KAWADAS SHAH ADARSH COLLEGE",
"JAGANNATH LIFE CARE PRIVATE LIMITED",
"JAGANNATH MULTI FOOD AND TOBACCO PRIVATE LIMITED",
"JAGANNATH PLACEMENT & SECURITY SERVICES PRIVATE LIMITED",
"JAGANNATH PLASTICS PRIVATE LIMITED",
"JAGANNATH PLASTIPACKS LIMITED",
"JAGANNATH POLYMERS LIMITED",
"JAGANNATH POLYMERS PVT LTD",
"JAGANNATH POLYPACKS LIMITED",
"JAGANNATH ROOFING TILES PRIVATE LIMITED",
"JAGANNATH SALT PRIVATE LIMITED",
"JAGANNATH STEEL PVT LTD",
"JAGANNATH TEXTILE COMPANY LIMITED",
"JAGANNATH TRAVELS AND TOUR PRIVATE LIMITED",
"JAGANNATHJI CITY BUS SERVICES PRIVATE LIMITED",
"JAGANNATHPUR ARABINDAPALLI B V",
"JAGARAN MICROFIN PRIVATE LIMITED",
"JAGARAN SEMILLAS PRIVATE LIMITED",
"JAGAT AGROTECH PRIVATE LIMITED",
"JAGAT EXIM PRIVATE LIMITED",
"JAGAT FOODS PVT LTD",
"JAGAT INDUSTRIES LIMITED",
"JAGAT JAGDAMBA FLOUR PRIVATE LIMITED",
"JAGAT JEET ENGINEERING INDUSTRIES PRIVATE LIMITED",
"JAGAT JYOTI RESORTS PRIVATE LIMITED",
"JAGAT MATA COLD STORAGE PVT LTD",
"JAGAT METALS PVT LTD",
"JAGAT PHARMA PROPREITORSHIP",
"JAGAT RF SOLUTIONS (INDIA) PRIVATE LIMITED",
"JAGAT TRADING ENTERPRISES LIMITED",
"JAGATBANDHU TEA ESTATE PVT LTD",
"JAGATDAL JUTE & INDUSTRIES LTD",
"JAGATGURU MAHADEV RICE MILL PRIVATE LIMITED",
"JAGATGURU PRINTING PRIVATE LIMITED",
"JAGATI MINING COMPANY PRIVATE LIMITED",
"JAGATI PUBLICATIONS LIMITED",
"JAGATJANANI SERVICES PRIVATE LIMITED",
"JAGATJIT ENGINEERING WORKS PVT LTD",
"JAGATJIT INDUSTRIES LIMITED",
"JAGATTARAN GOLDEN JUBILEE SCHOOL",
"JAGDALE INDUSTRIES PRIVATE LIMITED",
"JAGDALPUR MOTORS (COMMERCIAL) PRIVATE LIMITED",
"JAGDALPUR MOTORS PRIVATE LIMITED",
"JAGDAMBA AGRO FOOD PRIVATE LIMITED",
"JAGDAMBA AGROCARE PRIVATE LIMITED",
"JAGDAMBA APPARELS PRIVATE LIMITED",
"JAGDAMBA BHAWANI ENTERPRISES PRIVATE LIMITED",
"JAGDAMBA CHAINS PRIVATE LIMITED",
"JAGDAMBA COMMOSALES PRIVATE LIMITED",
"JAGDAMBA CONTRACTORS AND BUILDERS LIMITED",
"JAGDAMBA CRANES PRIVATE LIMITED",
"JAGDAMBA CUTLERY LIMITED",
"JAGDAMBA CUTLERY PRIVATE LIMITED",
"JAGDAMBA DWELLINGS PRIVATE LIMITED",
"JAGDAMBA ENGINEERS AND CONSULTANCY",
"JAGDAMBA ENTERPRISES PRIVATE LIMITED",
"JAGDAMBA FASHION PRIVATE LIMITED",
"JAGDAMBA FIBRES PRIVATE LIMITED",
"JAGDAMBA FLOATGLASS SALES PRIVATE LIMITED",
"JAGDAMBA FOILS PRIVATE LIMITED",
"JAGDAMBA ICE AND COLD STORAGE PVT LTD",
"JAGDAMBA INDUCTION PRIVATE LIMITED",
"JAGDAMBA INFRADEVELOPERS PRIVATE LIMITED",
"JAGDAMBA INFRASTRUCTURE PRIVATE LIMITED",
"JAGDAMBA INGO-TECH STEEL PRIVATE LIMITED",
"JAGDAMBA INTERNATIONAL HOUSEWARE PRIVATE LIMITED",
"JAGDAMBA INTERNATIONAL PRIVATE LIMITED",
"JAGDAMBA IRON FOUNDRY PVT LTD",
"JAGDAMBA ISPAT PRIVATE LIMITED",
"JAGDAMBA JEWELLERS PRIVATE LIMITED",
"JAGDAMBA MAHAVIDYALAYA ACHALPUR",
"JAGDAMBA MARCOM PRIVATE LIMITED",
"JAGDAMBA MOTORS (INDIA) PRIVATE LIMITED",
"JAGDAMBA OPTICS PRIVATE LIMITED",
"JAGDAMBA PADDY PROCESSING PVT LTD",
"JAGDAMBA PESTICIDES PRIVATE LIMITED",
"JAGDAMBA PETROLIUM (INDIA) PRIVATE LIMITED",
"JAGDAMBA PLYWOOD INDUSTRISES(KASHIPUR) PRIVATE LIMITED",
"JAGDAMBA POLYFABES PRIVATE LIMITED",
"JAGDAMBA POLYMERS PRIVATE LIMITED",
"JAGDAMBA POLYSTERS PRIVATE LIMITED",
"JAGDAMBA PRINTS PVT LTD",
"JAGDAMBA ROADLINES PRIVATE LIMITED",
"JAGDAMBA SALES PRIVATE LIMITED",
"JAGDAMBA SAREES PRIVATE LIMITED",
"JAGDAMBA SERVICE SOLUTIONS PRIVATE LIMITED",
"JAGDAMBA SPONGE PRIVATE LIMITED",
"JAGDAMBA STEEL & POWER-TECH LIMITED",
"JAGDAMBA STEEL INDUSTRIES PRIVATE LIMITED",
"JAGDAMBA STRUCTURALS (INDIA) PRIVATE LIMITED",
"JAGDAMBA TEXFAB PRIVATE LIMITED",
"JAGDAMBA TEXTILES PRIVATE LIMITED",
"JAGDAMBA TIMBERS PRIVATE LIMITED",
"JAGDAMBA TMT MILLS LIMITED",
"JAGDAMBA TOUGHENED GLASS PRIVATE LIMITED",
"JAGDAMBA TRAILERS PRIVATE LIMITED",
"JAGDAMBA TRANSPORT CARRIERS PRIVATE LIMITED",
"JAGDAMBA TRENDZ PRIVATE LIMITED",
"JAGDAMBA VALUE STEELS PRIVATE LIMITED",
"JAGDAMBA YARNS PRIVATE LIMITED",
"JAGDAMBAA AGRO MILL PRIVATE LIMITED",
"JAGDAMBAY COTSPIN LIMITED",
"JAGDAMBAY ENTERPRISES (INDIA) PRIVATE LIMITED",
"JAGDAMBAY FOREX PRIVATE LIMITED",
"JAGDAMBAY FURNACES PRIVATE LIMITED",
"JAGDAMBE COMMUNICATIONS PRIVATE LIMITED",
"JAGDAMBE VEGETABLE PRODUCTS PRIVATE LIMITED",
"JAGDAMBEY CAPITALS PRIVATE LIMITED",
"JAGDAMBHA INSTITUTE OF PHARMACY & RESEARCH KALAMB",
"JAGDATRI TRADELINKS PRIVATE LIMITED",
"JAGDEEP MACHINES (INDIA) PRIVATE LIMITED",
"JAGDEV ENGINEERING SOLUTIONS PRIVATE LIMITED",
"JAGDEV INFRASTRUCTURES PRIVATE LIMITED",
"JAGDHARTI CONSULATANTS PRIVATE LIMITED",
"JAGDHATRI BARTER PVT LTD",
"JAGDHATRI PAPERS PRIVATE LIMITED",
"JAGDHATRI TRADE PVT LTD",
"JAGDISH AGASHE FINANCING COMPANY PRIVATE LIMITED",
"JAGDISH AGRI EXPORT PRIVATE LIMITED",
"JAGDISH ALUMINIUM PRIVATE LIMITED",
"JAGDISH COMMODITIES INDIA PRIVATE LIMITED",
"JAGDISH CONSTRUCTION LIMITED",
"JAGDISH COTT FAB PRIVATE LIMITED",
"JAGDISH ELECTRONICS INDIA PRIVATE LIMITED",
"JAGDISH EXIM PRIVATE LIMITED",
"JAGDISH FARSHAN PRIVATE LIMITED",
"JAGDISH FOOD ZONE PRIVATE LIMITED",
"JAGDISH FOODS PVT. LTD.",
"JAGDISH FOUNDRIES PRIVATE LIMITED",
"JAGDISH HEALTHCARE PRIVATE LIMITED",
"JAGDISH INFRAHEIGHTS PRIVATE LIMITED",
"JAGDISH INTERNATIONAL PRIVATE LIMITED",
"JAGDISH ISPAT PRIVATE LIMITED",
"JAGDISH MEDICARE PRIVATE LIMITED",
"JAGDISH MOTOCORP PRIVATE LIMITED",
"JAGDISH NAMKEENS PRIVATE LIMITED",
"JAGDISH PIPES PRIVATE LIMITED",
"JAGDISH POLYESTER PRIVATE LIMITED",
"JAGDISH PRASAD AGARWAL",
"JAGDISH PRASAD SARRAF AND SONS PRIVATE LIMITED",
"JAGDISH PRECISION CAST PRIVATE LIMITED",
"JAGDISH RICE MILLS",
"JAGDISH SARAN",
"JAGDISH SONS ALLOYS PRIVATE LIMITED",
"JAGDISH TECHNO VENTURES PRIVATE LIMITED",
"JAGDISH TECHNOCAST PRIVATE LIMITED",
"JAGDISH TRACTORS PRIVATE LIMITED",
"JAGDISHPUR SK INSTITUTION HS",
"JAGDISHSREI AGROILS PRIVATE LIMITED",
"JAGDISHWAR ENTERPRISES (INDIA ) PRIVATE LIMITED",
"JAGDISHWAR LAL JEWELLERS PRIVATE LIMITED",
"JAGDUSHAH INTERNATIONAL PRIVATE LIMITED",
"JAGER-SMITH INDIA PRIVATE LIMITED",
"JAGGA FOOTWEAR PRIVATE LIMITED",
"JAGGA PRINTS PRIVATE LIMITED",
"JAGGA SPINNERS PRIVATE LIMITED",
"JAGGERY WIRES AND CABLES PRIVATE LIMITED",
"JAGGI BROTHERS OVERSEAS PVT LTD",
"JAGGI ENTERPRISES PRIVATE LIMITED",
"JAGGI HARDWARE PRIVATE LIMITED",
"JAGGI HOSPITALS AND HOTELS PRIVATE LIMITED",
"JAGGI MEDICAL INSTRUMENT COMPANY PRIVATE LIMITED",
"JAGGI MOTORS PRIVATE LIMITED",
"JAGGI SWEETS PRIVATE LIMITED",
"JAGGS INN BY HOCOTEL HOTELS & RESORT",
"JAGIT INDIA PRIVATE LIMITED",
"JAGJAN PRIVATE LIMITED",
"JAGJEET HOTELS & RESORTS PRIVATE LIMITED",
"JAGJEET MARKETING AND SERVICES PRIVATE LIMITED",
"JAGJIT AGENCIES INDIA PRIVATE LIMITED",
"JAGJIT ESTATES AND DEVELOPMENT COMPANY PVT LTD",
"JAGJIT PUBLISHING COMPANY PRIVATE LIMITED",
"JAGJIVANDAS ENGLISH SCHOOL MUKTAINAGAR",
"JAGLAXMI PLASTPACK PRIVATE LIMITED",
"JAGMAG ELECTRICAL AGENCIES PRIVATE LIMITED",
"JAGMAG IMPEX PRIVATE LIMITED",
"JAGMAG MARKETTING PRIVATE LIMITED",
"JAGMINI MICRO KNIT PRIVATE LIMITED",
"JAGMOHAN AUTOMOTIVES PRIVATE LIMITED",
"JAGMOHAN LAL GUPTA ESTATES PRIVATE LIMITED",
"JAGMOHAN MOTORS LIMITED",
"JAGMOHAN MOTORS PRIVATE LIMITED",
"JAGMOHAN PLA-MACH PRIVATE LIMITED",
"JAGOTA AND SONS PRIVATE LIMITED",
"JAGPIN BREWERIES LTD",
"JAGPREM VANIJYA PRIVATE LIMITED",
"JAGRAJ ENTERPRISES PRIVATE LIMITED",
"JAGRAMJI PLYWOODS PRIVATE LIMITED",
"JAGRAN COLLEGE OF ART SCIENCE AND COMMERCE",
"JAGRAN DEVELOPERS LIMITED",
"JAGRAN LAKECITY UNIVERSITY",
"JAGRAN MICRO MOTORS LIMITED",
"JAGRAN NEW MEDIA",
"JAGRAN PRAKASHAN LIMITED",
"JAGRAN PUBLIC SCHOOL",
"JAGRAN VYAPAAR PVT LTD",
"JAGRANI HOSPITAL PRIVATE LIMITED",
"JAGRAON CONCAST PRIVATE LIMITED",
"JAGRATAN FINVEST PRIVATE LIMITED",
"JAGRATI CIVIL CONSTRUCTIONS PRIVATE LIMITED",
"JAGRATI HOTELS PRIVATE LIMITED",
"JAGRATI INFRAMINES PRIVATE LIMITED",
"JAGRATI PAPER PRIVATE LIMITED",
"JAGRATI TRADE SERVICES PVT LTD",
"JAGRIT DISTRIBUTERS PRIVATE LIMITED",
"JAGRIT FASHIONS PRIVATE LIMITED",
"JAGRITI BUILDTECH PRIVATE LIMITED",
"JAGRITI COMPLEX PRIVATE LIMITED",
"JAGRITI ENTERPRISES",
"JAGRITI PLASTICS LIMITED",
"JAGRITI STEEL",
"JAGRITI STRIPS PRIVATE LIMITED",
"JAGRITI SUPPLIERS PRIVATE LIMITED",
"JAGRUT PHARMACEUTICALS PRIVATE LIMITED",
"JAGRUT PRINT-PACK PRIVATE LIMITED",
"JAGRUTESHWAR METALS PRIVATE LIMITED",
"JAGRUTHI CABS & SERVICES PRIVATE LIMITED",
"JAGRUTHI JR DEGREE PG COLLEGES",
"JAGRUTI ELECTRO CONTROLS PRIVATE LIMITED",
"JAGRUTI MADHYAMIK SHALA",
"JAGRUTI RUBBER ENTERPRISES PVT LTD",
"JAGRUTI STEELS PRIVATE LIMITED",
"JAGRUTI SUGAR & ALLIED INDUSTRIES LIMITED",
"JAGRUTI SYNTHETICS PRIVATE LIMITED",
"JAGRUTI TECHNICAL SERVICES PRIVATE LIMITED",
"JAGRUTI VIDYALAYA",
"JAGS GLOBAL EXPRESS PRIVATE LIMITED",
"JAGSAKTI MERCHANDISE PRIVATE LIMITED",
"JAGSHAKTI TEA & AGRO PRIVATE LIMITED",
"JAGSON AIRLINES",
"JAGSON CARRIERS PVT.LTD.",
"JAGSON COLORCHEM LIMITED",
"JAGSON CONSTRUCTIONS LIMITED",
"JAGSON INTERNATIONAL LIMITED",
"JAGSON MOTORS AND TRACTORS PRIVATE LIMITED",
"JAGSON PAL PHARMACEUTICALS LIMITED",
"JAGSONS FOOD AND PHARMACHEM PRIVATE LIMITED",
"JAGSONS READYMIX CONCRETE PRIVATE LIMITED",
"JAGSONS TRAVELS PRIVATE LIMITED",
"JAGSUMI PERSPECTIVES PRIVATE LIMITED",
"JAGSURYA SUPPLY CHAIN PRIVATE LIMITED",
"JAGTAP HORTICULTURE PRIVATE LIMITED",
"JAGTAP INFRAVENTURES INDIA PRIVATE LIMITED",
"JAGTAP MULTISPECIALITY HOSPITAL",
"JAGTARNI FINANCE AND INVESTMENTPRIVATE LIMITED",
"JAGTARNI TRADERS PRIVATE LIMITED",
"JAGTAT MINERALS PRIVATE LIMITED",
"JAGTIANI HOTELS AND PROPERTIES PRIVATE LIMITED",
"JAGUAR BUILDWELL PRIVATE LIMITED",
"JAGUAR INTERNATIONAL LIMITED",
"JAGUAR LAND ROVER INDIA LIMITED",
"JAGUAR LAND ROVER TECHNOLOGY AND BUSINESS SERVICES INDIA PRIVATE LIMITED",
"JAGUAR OVERSEAS LIMITED",
"JAGUAR PETROPACKS PRIVATE LIMITED",
"JAGUAR SECURITY & MANAGEMENT PRIVATE LIMITED",
"JAGUAR SECURITY SERVICES PRIVATE LIMITED",
"JAGUAR SERVICES PRIVATE LIMITED",
"JAGUAR SHIPPING AND LOGISTICS PRIVATE LIMITED",
"JAGUAR-MAX SECURITY SOLUTIONS PRIVATE LIMITED",
"JAGVAN TRADELINK PRIVATE LIMITED",
"JAGVI CONSULTANTS PRIVATE LIMITED",
"JAGVIJAY MOTORS (INDIA) PRIVATE LIMITED",
"JAGVIN INVESTMENTS PRIVATE LIMITED",
"JAHAAN STEELS LIMITED",
"JAHANPANAH CLOTHING PRIVATE LIMITED",
"JAHANVI APPARELS INDIA PRIVATE LIMITED",
"JAHANVI ISPAT PRIVATE LIMITED",
"JAHARVIR POLYMERS PRIVATE LIMITED",
"JAHNAVI CHEM PRODUCTS PRIVATE LIMITED",
"JAHNVI MAKWANA CONSTRUCTION PRIVATE LIMITED",
"JAHNVI MOTOR PRIVATE LIMITED",
"JAHOME REAL ESTATE SERVICES PRIVATE LIMITED",
"JAI AGRO INDUSTRIES LTD",
"JAI AMBAY FERTILISERS PRIVATE LIMITED",
"JAI AMBAY PLY PALACE PRIVATE LIMITED",
"JAI AMBE LOGISTICS PRIVATE LIMITED",
"JAI AMBE MAA TOYS PRIVATE LIMITED",
"JAI AMBE RUBBER PRODUCTS PRIVATE LIMITED",
"JAI AMBE SPARES PRIVATE LIMITED",
"JAI AMBE TRADEXIM PRIVATE LIMITED",
"JAI AMBE TRANSMOVERS PRIVATE LIMITED",
"JAI AMBEY CARGO MOVERS PRIVATE LIMITED",
"JAI AMBEY EMERGENCY SERVICES I PRIVATE LIMITED",
"JAI AMBEY METALS PRIVATE LIMITED",
"JAI AMBEY ROADLINES PRIVATE LIMITED",
"JAI AMBEY VASTRA BHANDAR PRIVATE LIMITED",
"JAI AMBEY WIRE EX-IM PRIVATE LIMITED",
"JAI AMBEY WIRE PRIVATE LIMITED",
"JAI ANAND PLAZA PRIVATE LIMITED",
"JAI ANAND TOUCH CENTER PRIVATE LIMITED",
"JAI AND ADITYA KELKAR EYE CARE AND LASER INSTITUTE PRIVATE LIMITED",
"JAI AND SONS PRIVATE LIMITED",
"JAI ARAVALI INDUSTRIAL PRODUCTS PRIVATE LIMITED.",
"JAI ARMAMENTS LIMITED",
"JAI AUTO PRIVATE LIMITED",
"JAI AUTO VEHICLES PRIVATE LIMITED",
"JAI BABA GLOBAL IMPEX PRIVATE LIMITED",
"JAI BABA SANYAD INFRA PRIVATE LIMITED",
"JAI BAJRANG GINNING AND PRESSING PRIVATE LIMITED",
"JAI BAJRANG POLYPACK PRIVATE LIMITED",
"JAI BAJRANGBALI ORES PRIVATE LIMITED",
"JAI BAJRANGI SHIP BREAKERS PRIVATE LIMITED",
"JAI BALAJEE PLYWOOD INDUSTRIES PRIVATE LIMITED",
"JAI BALAJEE SECURITY SERVICES PRIVATE LIMITED",
"JAI BALAJI BUSINESS SERVICES PRIVATE LIMITED",
"JAI BALAJI COIL & PLATES PRIVATE LIMITED",
"JAI BALAJI CONTROL GEARS PRIVATE. LIMITED.",
"JAI BALAJI EXTRACTIONS PRIVATE LIMITED",
"JAI BALAJI INDUSTRIES LIMITED",
"JAI BALAJI JEWELLERS PVT LTD",
"JAI BALAJI JYOTI STEELS LIMITED",
"JAI BALAJI LABEL PRIVATE LIMITED",
"JAI BALAJI MAHARAJ POLYMERS INDIA PRIVATE LIMITED",
"JAI BALAJI OXYGEN PRIVATE LIMTED",
"JAI BALAJI PLASTIPACK PRIVATE LIMITED",
"JAI BAMLESHWARI RICE SORTEX PRIVATE LIMITED",
"JAI BASUKINATH TRADERS PRIVATE LIMITED",
"JAI BEVERAGES PRIVATE LIMITED",
"JAI BHAGWAN REALTIES PRIVATE LIMITED",
"JAI BHARAT FURNACES PRIVATE LIMITED",
"JAI BHARAT GUM AND CHEMICALS LTD",
"JAI BHARAT INSTRUMENTS PRIVATE LIMITED",
"JAI BHARAT INTER COLLEGE",
"JAI BHARAT JUNIOR COLLEGE OF COMMERCE & SCIENCE",
"JAI BHARAT PLASTICS PRIVATE LIMITED",
"JAI BHARAT RESEARCH AND BREEDING FARM PRIVATE LIMITED",
"JAI BHARAT STEEL INDUSTRIES",
"JAI BHARAT TECHNICAL SERVICES PRIVATE LIMITED",
"JAI BHAVANI FURNISHING PRIVATE LIMITED",
"JAI BHAVANI JEWELLER PRIVATE LIMITED",
"JAI BHAVANI MATA ENGITECH PRIVATE LIMITED",
"JAI BHAVANI MATA STAMPINGS PRIVATE LIMITED",
"JAI BHAVANI SECURITY SERVICES (INDIA) PRIVATE LIMITED",
"JAI BHAVANI VIDYA MANDIR",
"JAI BHAVANI VIDYALAY SUGAON",
"JAI BHAWANI CONCAST PRIVATE LIMITED",
"JAI BHAWANI ESTATES PRIVATE LIMITED",
"JAI BHAWANI TRADING CO.",
"JAI BHIKSHU MARBLE PRIVATE LIMITED",
"JAI BHOLE STEEL TUBES PRIVATE LIMITED",
"JAI BHUVAN BUILDERS PRIVATE LIMITED",
"JAI BHUVAN MALLS PRIVATE LIMITED",
"JAI BHUVAN PROJECTS PRIVATE LIMITED",
"JAI BHUVANESWARI SHIPPING AND LOGISTICS PRIVATE LIMITED",
"JAI BIRAMI PRIVATE LIMITED",
"JAI BUILDCON PRIVATE LIMITED",
"JAI CARS PRIVATE LIMITED",
"JAI COMMERCIAL PVT LTD",
"JAI CORP LIMITED",
"JAI CREATIVE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"JAI DADA PANEL DECORATIVE PRIVATE LIMITED",
"JAI DAYAL PLYWOOD PRIVATE LIMITED",
"JAI DEV AGRO FOODS PRIVATE LIMITED",
"JAI DHARAMRAJ AUTO FAB PRIVATE LIMITED",
"JAI DRINKS PVT LTD",
"JAI DURGA CONTAINER MOVERS PRIVATE LIMITED",
"JAI DURGA IRON PRIVATE LIMITED",
"JAI DURGA KRAFT PAPERS PRIVATE LIMITED",
"JAI DURGA MULTI-TRADE PRIVATE LIMITED",
"JAI DURGA OIL EXTRACTION PRIVATE LIMITED",
"JAI DURGA PETROLPUMPS PRIVATE LIMITED",
"JAI DURGA PROJECTS PRIVATE LIMITED",
"JAI DURGA SECURITY FORCE & LABOUR SUPPLIER",
"JAI DURGA STEEL INDUSTRIES PRIVATE LIMITED",
"JAI DURGA TELECOM PRIVATE LIMITED",
"JAI DURGA TIMBER PRODUCTS PRIVATE LIMITED",
"JAI DURGA TRADERS PRIVATE LIMITED",
"JAI EARTH CLAY CHEMICALS PRIVATE LIMITED",
"JAI FAB PVT LTD",
"JAI FARM CHEMICALS PRIVATE LIMITED",
"JAI FASTENERS PRIVATE LIMITED",
"JAI GANESH AUTOCARE PRIVATE LIMITED",
"JAI GANESH AUTOCARS PRIVATE LIMITED",
"JAI GANESH AUTOCORP PRIVATE LIMITED",
"JAI GANESH AUTOLINK PRIVATE LIMITED",
"JAI GANESH ISPAT AND FERRO ALLOYS PRIVATE LIMITED",
"JAI GANESH TRADING CO",
"JAI GANESH VITRIFIED PRIVATE LIMITED",
"JAI GANGA ISPAT PRIVATE LIMITED",
"JAI GANGA SOLAR ENERGY PRIVATE. LIMITED.",
"JAI GEARS PRIVATE LIMITED",
"JAI GIRIRAJ RICE AND AGRO MILLS PRIVATE LIMITED",
"JAI GIRRAJJI MAHARAJ ICE & SHEETGRAH PRIVATE LIMITED",
"JAI GLASS (INDIA) PRIVATE LIMITED",
"JAI GOPAL INTERNATIONAL IMPEX PRIVATE LIMITED",
"JAI GOPAL RICE AND FLOUR MILLS PRIVATE LIMITED",
"JAI GURU RICE AND SOYA INDUSTRIES PRIVATE LIMITED",
"JAI GURUJI BIO SCIENCES PRIVATE LIMITED",
"JAI GURUJI PAPERS PRIVATE LIMITED",
"JAI HANDLOOM PRIVATE LIMITED",
"JAI HANUMAN AGENCIES",
"JAI HANUMAN CLOTH AGENCIES PRIVATE LIMITED",
"JAI HANUMAN CRANES PRIVATE LIMITED",
"JAI HANUMAN FASHION PRIVATE LIMITED",
"JAI HANUMAN FIBRES PRIVATE LIMITED",
"JAI HANUMAN PROPERTIES PRIVATE LIMITED",
"JAI HANUMAN RICE INDUSTRIES",
"JAI HANUMAN UDYOG LIMITED",
"JAI HARDWARES PRIVATE LIMITED",
"JAI HEALTHCARE PRIVATE LIMITED",
"JAI HIND AUTO TECH INDUSTRIES",
"JAI HIND EXPORTS PRIVATE LIMITED",
"JAI HIND FABRICATORS",
"JAI HIND HIGH SCHOOL PIMPRI PUNE",
"JAI HIND LOGISTICS PRIVATE LIMITED",
"JAI HIND OIL MILLS COMPANY PRIVATE LIMITED",
"JAI HIND OUTRIGHT PRIVATE LIMITED",
"JAI HIND PHARMA PRIVATE LIMITED",
"JAI HIND ROAD BUILDERS PRIVATE LIMITED",
"JAI HIND ROLLING MILLS INDIA PRIVATE LIMITED",
"JAI HIND SUGAR INDUSTRIES PRIVATE LIMITED",
"JAI HIND SUGAR PRIVATE LIMITED",
"JAI HIND WIRE ROD MILLS PRIVATE LIMITED",
"JAI HOSPITALS PRIVATE LIMITED",
"JAI INCENSE PRIVATE LIMITED",
"JAI INDUSTRIES",
"JAI INFRATECH PRIVATE LIMITED",
"JAI INGREDIENTS PRIVATE LIMITED",
"JAI INSTITUTE OF NURSING & RESEARCH GWALIOR",
"JAI INTERNATIONAL PRIVATE LIMITED",
"JAI JAGADHAMBIGA TEXTILE MILLS PRIVATE LIMITED",
"JAI JAGDAMBA DAIRY",
"JAI JAGDAMBA METALLOYS LIMITED",
"JAI JAGDAMBA SCRAP SUPPLIERS LIMITED",
"JAI JAGDISH SHIP BREAKERS PRIVATE LIMITED",
"JAI JAGGARNNATH ENTERPRISES PRIVATE LIMITED",
"JAI JAI DEALCOM PVT LTD",
"JAI JAI RAM SINGH INFRASTRUCTURE PRIVATE LIMITED",
"JAI JALARAM CERAMIC WORKS PRIVATE LIMITED",
"JAI JALARAM OVERSEAS PRIVATE LIMITED",
"JAI JALPESH FLOUR MILLS PRIVATE LIMITED",
"JAI JALPESH INTERNATIONAL PRIVATE LIMITED",
"JAI JAWALA STEELS PRIVATE LIMITED",
"JAI JAWAN JAI KISAN ENTERPRISES PRIVATE LIMITED",
"JAI JAWAN JAI KISAN HIGHSCHOOL KAWALGAON",
"JAI JHANHVI PLASTICS PRIVATE LIMITED",
"JAI JINENDRA COLD STORAGE PRIVATE LIMITED",
"JAI JINENDRA PRINTS PRIVATE LIMITED",
"JAI KAHNA RICE AND AGRO MILLS PRIVATE LIMITED",
"JAI KAR TECHNO PRIVATE LIMITED",
"JAI KARNI FABRICS PRIVATE LIMITED",
"JAI KARNI SUITINGS PRIVATE LIMITED",
"JAI KARTAR DIGITECH PRIVATE LIMITED",
"JAI KAUR ENTERPRISES PRIVATE LIMITED",
"JAI KAUSHAL INDUSTRIES PRIVATE LIMITED",
"JAI KELA DEVI PIGMENTS AND CHEMICALS PRIVATE LIMITED",
"JAI KISHAN ESTATES PRIVATE LIMITED",
"JAI KRISHAN INFRASTRUCTURES PRIVATE LIMITED",
"JAI KRISHAN LIQUORS PRIVATE LIMITED",
"JAI KRISHNA AGRIBIZ PRIVATE LIMITED",
"JAI KRISHNA ESTATES PRIVATE LIMITED",
"JAI KRISHNA HOTEL (INDIA) PRIVATE LIMITED",
"JAI KRISHNA JEWELLERS CO PRIVATE LIMITED",
"JAI KUMAR ARUN KUMAR PRIVATE LIMITED",
"JAI LAKSHMI AGRO CHEMICALS PRIVATE LIMITED",
"JAI LAKSHMI SOLVENTS PVT.LTD.",
"JAI LARA DRUGS PRIVATE LIMITED",
"JAI LAXMI CEMENT COMPANY PRIVATE LIMITED",
"JAI LAXMI FUELS PRIVATE LIMITED",
"JAI LOGISTICS SERVICES PRIVATE LIMITED",
"JAI MA FREIGHT AND FORWARDING PRIVATE LIMITED",
"JAI MA SATI NET PRIVATE LIMITED",
"JAI MAA AMBE INFRA PRIVATE LIMITED",
"JAI MAA CLOTH HOUSE",
"JAI MAA DURGA ELECTRONICS",
"JAI MAA HANDLOOM INDUSTRIES PRIVATE LIMITED",
"JAI MAA JAGDAMBA FLOUR PRIVATE LIMITED",
"JAI MAA KALI BULLION PRIVATE LIMITED",
"JAI MAA KALI UDYOG LTD",
"JAI MAA LOGISTICS PRIVATE LIMITED",
"JAI MAA PROCESSORS PRIVATE LIMITED",
"JAI MAA SHAKUMBHARI INDUSTRIES PRIVATE LIMITED",
"JAI MAA SHARDA AGRO AND RICE MILLS PRIVATE LIMITED",
"JAI MAA TEXTILE PRIVATE LIMITED",
"JAI MAA VAISHNO IMITATION JEWELLERS PRIVATE LIMITED",
"JAI MAA VINIMAY PRIVATE LIMITED",
"JAI MACHINE TOOLS PRIVATE LIMITED",
"JAI MAHAKAAL MINES AND MINERALS PRIVATE LIMITED",
"JAI MAHAL HOTELS PVT LTD",
"JAI MAHAVIR TEXTILE PRIVATE LIMITED",
"JAI MANAGER STATIONERRIES",
"JAI MANGAL INFRAPOWERS PRIVATE LIMITED",
"JAI MANGLA JR HIGH SCHOOL SAHARANPUR",
"JAI MANGLA MINERAL GRINDERS PRIVATE LIMITED",
"JAI MANGLA SPONGE IRON PRIVATE LIMITED",
"JAI MANGLA STEELS PRIVATE LIMITED",
"JAI MANGLAM STATIONERIES PRIVATE LIMITED",
"JAI MANSA MATA STONE CRUSHER PRIVATE LIMITED",
"JAI MATA ALLOYS PRIVATE LIMITED",
"JAI MATA BALA SUNDARI STEELS PRIVATE LIMITED",
"JAI MATA DE INFRA ELECTRIC PRIVATE LIMITED",
"JAI MATA DEE NATURE FRESH PRIVATE LIMITED",
"JAI MATA DI AGENCIES PRIVATE LIMITED",
"JAI MATA DI AGROPRODUCTS PRIVATE LIMITED",
"JAI MATA DI ART AND CREATION PRIVATE LIMITED",
"JAI MATA DI COMMERCIAL PRIVATE LIMITED",
"JAI MATA DI DYEING AND PRINTING MILLS PRIVATE LIMITED",
"JAI MATA DI ENTERTAINMENT PRIVATE LIMITED",
"JAI MATA DI FINANCIAL SOLUTIONS PRIVATE LIMITED",
"JAI MATA DI FOOD PROCESSING PRIVATE LIMITED",
"JAI MATA DI HOME CONSTRUCTIONS PRIVATE LIMITED",
"JAI MATA DI PACKERS PRIVATE LIMITED",
"JAI MATA DI PAPER MILLS PRIVATE LIMITED",
"JAI MATA DI ROAD CONSTRUCTION PRIVATE LIMITED",
"JAI MATA ENGINEERING LIMITED",
"JAI MATA FOUNDREX LIMITED",
"JAI MATA FURNISHING PRIVATE LIMITED",
"JAI MATA NARAYANI WOODPLY PRIVATE LIMITED",
"JAI MATA PLASTO PRIVATE LIMITED",
"JAI MATA TRADEPLACE PRIVATE LIMITED",
"JAI MATA VALUE INVESTMENT ADVISORY PRIVATE LIMITED",
"JAI MATADI FASHIONS PRIVATE LIMITED",
"JAI MATADI ISPAT LIMITED",
"JAI MATESHWARI STEELS PRIVATE LIMITED",
"JAI NARAIN RADHEY SHYAM AND COMPANY PRIVATE LIMITED",
"JAI NARAIN VYAS UNIVERSITY",
"JAI NARAIN VYAS UNIVERSITY - JODHPUR",
"JAI NSOHAM GARMENTS PRIVATE LIMITED",
"JAI PACKING SOLUTION PRIVATE LIMITED",
"JAI PADAM SHREE TRADEX PRIVATE LIMITED",
"JAI PAINTS & VARNISH PRIVATE LIMITED",
"JAI PARKASH HOSPITAL PRIVATE LIMITED",
"JAI PARKASH SOLVENT PVT LTD",
"JAI PARVATI FORGE LIMITED",
"JAI PAWANSUT POLYTEX PRIVATE LIMITED",
"JAI PLASTECH PRIVATE LIMITED",
"JAI POLYMERS CO PVT LTD",
"JAI POLYPAN PRIVATE LIMITED",
"JAI PRABHA IMPEX PRIVATE LIMITED",
"JAI PRABHUJI IRON & STEEL PRIVATE LIMITED",
"JAI RADHA MADHAV AUTOMOTIVES PRIVATE LIMITED",
"JAI RAJ ISPAT LIMITED",
"JAI RAJ PRINT PACK PRIVATE LIMITED",
"JAI RAJENDRA GOLD PALACE PRIVATE LIMITED",
"JAI RAJENDRA IMPEX PRIVATE LIMITED",
"JAI RAJENDRA JEWEL PALACE PRIVATE LIMITED",
"JAI RAM HOSPITALS AND RESEARCH CENTRE PRIVATE LIMITED",
"JAI RAVECHI CHEMICALS PRIVATE LIMITED",
"JAI REAL PRODUCTS PRIVATE LIMITED",
"JAI REALTECH PRIVATE LIMITED",
"JAI RUPANA DHAM ROADLINES PRIVATE LIMITED",
"JAI SAI COAL TRADERS PRIVATE LIMITED",
"JAI SAI CONSTRUCTION",
"JAI SAI FASHIONS LIMITED",
"JAI SAI FOOD AND BEVERAGES PRIVATE LIMITED",
"JAI SAI NATH ENGINEERING PRIVATE LIMITED",
"JAI SAI RAM MECH & TECH INDIA PRIVATE LIMITED",
"JAI SAI STAMPINGS PRIVATE LIMITED",
"JAI SAI-RAM HOSPITAL PRIVATE LIMITED",
"JAI SALASAR BALAJI INDUSTRIES PVT LTD",
"JAI SALASAR BALAJI METALS PRIVATE LIMITED",
"JAI SALASAR INDEX VENTURES PRIVATE LIMITED",
"JAI SHANKAR FOOD AND WOOD PRIVATE LIMITED",
"JAI SHANKAR RICE MILLS",
"JAI SHANKAR TEA CO PRIVATE LIMITED",
"JAI SHANKER SEEDS PRIVATE LIMITED",
"JAI SHANTI TYRES PRIVATE LIMITED",
"JAI SHIV FOOD PRODUCTS PRIVATE LIMITED",
"JAI SHIV PLYWOOD PRIVATE LIMITED",
"JAI SHIV SUITINGS PVT. LTD",
"JAI SHIV SYNCOTEX PRIVATE LIMITED",
"JAI SHIVHARI CONSTRUCTION PRIVATE LIMITED",
"JAI SHREE BALAJI INFRAREAL PRIVATE LIMITED",
"JAI SHREE GARMENTS",
"JAI SHREE HOLIDAYS AND TOURS P LIMITED",
"JAI SHREE PAY INDIA PRIVATE LIMITED",
"JAI SHREE SHYAM TEXTILES",
"JAI SHREE SHYAM TRADING PRIVATE LIMITED",
"JAI SHREE SWAMI SAMARTH ENGINEERING PRODUCTS PRIVATE LIMITED",
"JAI SHRI BALAJI INFRACON PRIVATE LIMITED",
"JAI SHRI MAHAVIR CHEM POLYMERS PRIVATE LIMITED",
"JAI SHRIKRISHNA ENTERPRISES DHULE",
"JAI SHRIMAN NARAYAN UDYOG PRIVATE LIMITED",
"JAI SIDHI ENTERPRISES PRIVATE LIMITED",
"JAI SINGH AND COMPANY",
"JAI SINGH COLLEGE BASANTSING INSTITUTE OF SCIENCE AND J T LALVANI COLLEGE OF COMMERCE",
"JAI SRI SHANMUGHA SPINNERS PRIVATE LIMITED",
"JAI SRI TRADEX PRIVATE LIMITED",
"JAI SRIRAM PADDY PROCESSING COMPANY PRIVATE LIMITED",
"JAI STEEL FACILITATION PRIVATE LIMITED",
"JAI SUDARSHAN AGROTECH PRIVATE LIMITED",
"JAI SUN TOURISM PRIVATE LIMITED",
"JAI SURGICALS LIMITED",
"JAI TARA CARRIERS PRIVATE LIMITED",
"JAI TEX UNIT PRIVATE LIMITED",
"JAI TRIPATI STEELS PRIVATE LIMITED",
"JAI TULSI PACKERS PRIVATE LIMITED",
"JAI TULSI SWITCHGEARS PRIVATE LIMITED",
"JAI VAIBHAVLAXMI COLD STORAGE PRIVATE LIMITED",
"JAI VAISHNOV SUITS",
"JAI VAKEEL FOUNDATION AND RESEARCH CENTRE",
"JAI VARDHMAN KHANIZ PRIVATE LIMITED",
"JAI VIJAY STEEL PVT LTD",
"JAI VIKAS STEEL CORPORATION PRIVATE LIMITED",
"JAI VINAYAK MAHADEV EXPORTS PRIVATE LIMITED",
"JAIAMBE FORGE ENGINEERS PRIVATE LIMITED",
"JAIAMBE ISPAT PRIVATE LIMITED",
"JAIAMBE MANUFACTURERS LIMITED",
"JAIAMBEY AUTOMOBILES PRIVATE LIMITED",
"JAIBABA MOTORS PRIVATE LIMITED",
"JAIBALAJEE DARSHAN POLYPAX PRIVATE LIMITED",
"JAIBALAJI BUSINESS CORPORATION PRIVATE LIMITED",
"JAIBALAJI FASHION PRIVATE LIMITED",
"JAIBHAGWATI TEXPRINT PRIVATE LIMITED",
"JAIBHARAT PADDY PROCESSING PRIVATE LIMITED",
"JAICHITTRA INFRASTRUCTURE PRIVATE LIMITED",
"JAICO ELECTRONICS PVT LTD",
"JAICO PRESS PRIVATE LIMITED",
"JAICO RUBBER PRIVATE LIMITED",
"JAIDA & SONS PRIVATE LIMITED",
"JAIDARSHAN INDOCRAFT PVT LTD",
"JAIDAYAL HITEX PRIVATE LIMITED",
"JAIDAYAL PACKAGING PRIVATE LIMITED",
"JAIDAYAL POLYMERS PRIVATE LIMITED",
"JAIDEEP ISPAT AND ALLOYS PRIVATE LIMITED",
"JAIDEEP METALLICS & ALLOYS PRIVATE LIMITED",
"JAIDEEP POWER SOLUTION PRIVATE LIMITED",
"JAIDEEP TRADING COMPANY",
"JAIDEV CASTALLOYS PRIVATE LIMITED",
"JAIDKA CONCAST LIMITED",
"JAIDKA POWER SYSTEMS PRIVATE LIMITED",
"JAIGAD POWERTRANSCO LIMITED",
"JAIGAJANAN CLASSIC SNACKS PRIVATE LIMITED",
"JAIGANAPATI FASHION HOUSE PRIVATE LIMITED",
"JAIGAON STEELS PRIVATE LIMITED",
"JAIGOPAL GARODIA MATRIC HR SEC SCHOOL",
"JAIGOPAL GARODIA RASHTROTTHANA VIDYA KENDRDA",
"JAIGOPAL GARODIA VIVEKANANDA VIDYALAYA",
"JAIGURU MOTORS PRIVATE LIMITED",
"JAIGURUDEV AGRO FOODS PRIVATE LIMITED",
"JAIHANUMAN COTTON GINNING MILLS PRIVATE LIMITED",
"JAIHIND AUTOMATION PRIVATE LIMITED",
"JAIHIND BUILDERS PRIVATE LIMITED",
"JAIHIND HATCHERIES PRIVATE LIMITED",
"JAIHIND INTERNATIONAL SCHOOL",
"JAIHIND MASS COMMUNICATION PRIVATE LIMITED",
"JAIHIND PROJECTS LIMITED",
"JAIHIND STEEL PRIVATE LIMITED",
"JAIHIND STRUCTURALS PRIVATE LIMITED",
"JAIHIND URBAN CO OPRATIVE BANK LTD",
"JAIJANAKI FABRICS PRIVATE LIMITED",
"JAIJWAN PRODUCER COMPANY LIMITED",
"JAIKA AUTOMOBILES AND FINANCE PVT LTD",
"JAIKA AUTOMOBILES PRIVATE LIMITED",
"JAIKA FINANCE PRIVATE LIMITED",
"JAIKA FOODS PRIVATE LIMITED",
"JAIKA HOSPITALITY VENTURES PRIVATE LIMITED",
"JAIKA INSURANCE BROKERAGE PRIVATE LIMITED",
"JAIKA MOTORS PRIVATE LIMITED",
"JAIKA VANIJYA PRIVATE LIMITED",
"JAIKA VEHICLE TRADE PRIVATE LIMITED",
"JAIKARA PRINTS PRIVATE LIMITED",
"JAIKASHI TRADING & FINANCE COMPANY PRIVATE LIMITED",
"JAIKISHANDASS MALL JUTE PRODUCTS PRIVATE LIMITED",
"JAIKON REFRIGERATION INDIA PRIVATE LIMITED",
"JAIKRISHNA COLD STORAGE PRIVATE LIMITED",
"JAIKRISHNA STEEL PRIVATE LIMITED",
"JAIKRISHNA TECHNOLOGY OPC PRIVATE LIMITED",
"JAIKRISHNAA AUTOSALES PRIVATE LIMITED",
"JAIKUMAR CONSTRUCTIONS LIMITED",
"JAIKUMAR CONSTRUCTIONS LLP",
"JAIKUMAR REAL ESTATES PRIVATE LIMITED",
"JAILAKSHMI AUTOMOTIVES PRIVATE LIMITED",
"JAILAKSHMI POLYMER PRIVATE LIMITED",
"JAILAXMI AUTO WORKS AND AGENCIES PRIVATE LIMITED",
"JAILAXMI CASTING AND ALLOYS PRIVATE LIMITED",
"JAILAXMI ENTERPRISES PRIVATE LIMITED",
"JAILAXMI NYLON PRIVATE LIMITED",
"JAILAXMI SPECIAL STEEL PRIVATE LIMITED",
"JAIMAA INDUSTRIAL COATINGS PRIVATE LIMITED",
"JAIMAAKALI CONSTRUCTION PRIVATE LIMITED",
"JAIMAL AUTOMOBILES PRIVATE LIMITED",
"JAIMAL TRADERS PRIVATE LIMITED",
"JAIMALA CONSTRUCTIONS PVT LTD",
"JAI-MALHAR FLOUR MILLS PRIVATE LIMITED",
"JAIMARUTHI TOOLS PRIVATE LIMITED",
"JAIMATA INFRACON PRIVATE LIMITED",
"JAIMATADI CASTINGS PRIVATE LIMITED",
"JAIMATADI COTSYN PRIVATE LIMITED",
"JAIMATADI INFRAPROMOTER PRIVATE LIMITED",
"JAIMATADI MACHINERY PRIVATE LIMITED",
"JAIMIN ENGINEERING PRIVATE LIMITED",
"JAIMIN TRAVELS LOGISTICS PRIVATE LIMITED",
"JAIN ABHUSHAN PRIVATE LIMITED",
"JAIN AGENCIES",
"JAIN AGRO MART PRIVATE LIMITED",
"JAIN ALUFOILS PRIVATE LIMITED",
"JAIN AMAR CLOTHING PRIVATE LIMITED",
"JAIN ART JEWELLERS PVT LTD",
"JAIN AUTO CARE PRIVATE LIMITED",
"JAIN AUTOCASTINGS PRIVATE LIMITED",
"JAIN AUTOFIN PRIVATE LIMITED",
"JAIN BAKERY PRIVATE LIMITED",
"JAIN BATTERIES GLOBAL PRIVATE LIMITED",
"JAIN BHARATI MRIGAVATI VIDYALAYA",
"JAIN BIJAY AND COMPANY PRIVATE LIMITED",
"JAIN BIOLOGICALS PRIVATE LIMITED",
"JAIN BROTHERS PRIVATE LIMITED",
"JAIN BROTHERS SANITATION PRIVATE LIMITED",
"JAIN BUILD MART PRIVATE LIMITED",
"JAIN BUILDCORP PRIVATE LIMITED",
"JAIN BUILDERS PVT LTD",
"JAIN BULK MOVERS PRIVATE LIMITED",
"JAIN CAPITAL MARKETS LIMITED",
"JAIN CARS & AUTO SALES PRIVATE LIMITED",
"JAIN CARS PRIVATE LIMITED",
"JAIN CARTON INDUSTRIES PRIVATE LIMITED",
"JAIN CASUALS WEAR PRIVATE LIMITED",
"JAIN CERAMIC COLOURS AND COATINGS PRIVATE LIMITED",
"JAIN CHEM PRIVATE LIMITED",
"JAIN CHEMICALS AND GASES PVT LTD",
"JAIN COAL SERVICES",
"JAIN COLLEGE HOSTEL",
"JAIN CONSTRUCTION",
"JAIN CORD INDUSTRIES PRIVATE LIMITED",
"JAIN CORRUGATORS PRIVATE LIMITED",
"JAIN COTTEX & AGRO INDUSTRIES PRIVATE LIMITED",
"JAIN CRANE SERVICES PRIVATE LIMITED",
"JAIN DAIRY PRODUCTS PRIVATE LIMITED",
"JAIN DIA MOUNTS PRIVATE LIMITED",
"JAIN DIAGNOSTIC PRIVATE LIMITED",
"JAIN DISTILLERY PRIVATE LIMITED",
"JAIN DOORS PRIVATE LIMITED",
"JAIN DREAM HOUSES PRIVATE LIMITED",
"JAIN ELECTRICALS PRIVATE LIMITED",
"JAIN ENGINEERS PRIVATE LIMITED",
"JAIN EX BEARINGS PVT LTD",
"JAIN EXPO CARVAN PVT LTD",
"JAIN EXPOSITIONS PRIVATE LIMITED",
"JAIN EYE HOSPITAL",
"JAIN FARM FRESH FOODS LIMITED",
"JAIN FARMS AND INDUSTRIES PRIVATE LIMITED",
"JAIN FERTILITY MOTHER CARE HOSPITAL",
"JAIN FLEXIPACK PRIVATE LIMITED",
"JAIN FOOT COMFORTS PRIVATE LIMITED",
"JAIN FOOTWEAR INDIA PRIVATE LIMITED",
"JAIN GLASS SOLUTION",
"JAIN GLAZERS PRIVATE LIMITED",
"JAIN GRANIMARMO PVT. LTD.",
"JAIN GROUP PROJECTS PRIVATE LIMITED",
"JAIN GROUP VENTURES PRIVATE LIMITED",
"JAIN GRUHA FOODS PRIVATE LIMITED",
"JAIN HAULERS PRIVATE LIMITED",
"JAIN HEART CARE HOSPITALS PVT LTD",
"JAIN HEIGHTS AND STRUCTURES PRIVATE LIMITED",
"JAIN HITEX CREATIONS PRIVATE LIMITED",
"JAIN HOLDINGS PVT LTD",
"JAIN HOSPITAL",
"JAIN HOUSING & CONSTRUCTIONS LIMITED",
"JAIN HYDRAULICS PRIVATE LIMITED",
"JAIN INDIA STEELCOORP PRIVATE LIMITED",
"JAIN INDUSTRIAL PRODUCTS",
"JAIN INDUSTRIES",
"JAIN INFOSYS PRIVATE LIMITED",
"JAIN INFOTECH PRIVATE LIMITED",
"JAIN INSTITUTE OF TECHNOLOGY",
"JAIN INTER COLLEGE KHEKRA",
"JAIN INTERNATIONAL",
"JAIN INTERNATIONAL SCHOOL",
"JAIN INTERNATIONAL TRADE ORGANISATION",
"JAIN IRON PRIVATE LIMITED",
"JAIN IRRIGATION SYSTEMS LIMITED",
"JAIN JARI ARTS PRIVATE LIMITED",
"JAIN JUBILANT CARS PRIVATE LIMITED",
"JAIN JYOTI JEWELLERS PRIVATE LIMITED",
"JAIN LABELS PRIVATE LIMITED",
"JAIN LABORATORY INSTRUMENTS PRIVATE LIMITED",
"JAIN MACHINERY PRIVATE LIMITED",
"JAIN MARBLE HOME PRIVATE LIMITED",
"JAIN MARKETING PRIVATE LIMITED",
"JAIN MARMO INDUSTRIES LIMITED",
"JAIN MFG. (INDIA) PRIVATE LIMITED",
"JAIN MINES & MINERALS (INDIA) PRIVATE LIMITED",
"JAIN MOTO-BIKE PRIVATE LIMITED",
"JAIN MOTOR FINMART PRIVATE LIMITED",
"JAIN NARROW FABRICS PRIVATE LIMITED",
"JAIN NATURAL PICKLES PRIVATE LIMITED",
"JAIN NEURO & IVF HOSPITALS PRIVATE LIMITED",
"JAIN OTR TYRE PRIVATE LIMITED",
"JAIN OVERSEAS",
"JAIN OVERSEAS SERVICES PRIVATE LIMITED",
"JAIN PACKAGING PRIVATE LIMITED",
"JAIN PACKWELL PVT LTD",
"JAIN PICTURE PUBLISHERS PRIVATE LIMITED",
"JAIN PIPE TRADERS PRIVATE LIMITED",
"JAIN POLYTECH PRIVATE LIMITED",
"JAIN PRECISION AND FORGINGS PRIVATE LIMITED",
"JAIN PRECISION FASTENERS PRIVATE LIMITED",
"JAIN PRIVY CLIENT PRIVATE LIMITED",
"JAIN PROMOTERS & BUILDERS PRIVATE LIMITED",
"JAIN PUBLIC SCHOOL",
"JAIN PUMPS PRIVATE LIMITED",
"JAIN REAL ESTATE PROMOTERS PRIVATE LIMITED",
"JAIN RECYCLING PRIVATE LIMITED",
"JAIN RICE MILLS PRIVATE LIMITED",
"JAIN RICELAND PRIVATE LIMITED",
"JAIN ROAD CARRIERS PRIVATE LIMITED",
"JAIN ROTODYNE PRIVATE LIMITED",
"JAIN RUBBERS PRIVATE LIMITED",
"JAIN SAFEWELD PRIVATE LIMITED",
"JAIN SAREE KENDRA PRIVATE LIMITED",
"JAIN SARVODAYA VIDHYA GYANPITH SAMITI JSVGS",
"JAIN SCIENTIFIC EQUIPMENTS PRIVATE LIMITED",
"JAIN SHIKANJI PRIVATE LIMITED",
"JAIN SONS FINLEASE LIMITED",
"JAIN SPICES AND AGRO PRODUCTS INDIA PRIVATE LIMITED",
"JAIN STEEL INDUSTRIES",
"JAIN STEEL SYNDICATE PRIVATE LIMITED",
"JAIN STONE INDUSTRIES PRIVATE LIMITED",
"JAIN SUITING PRIVATE LIMITED",
"JAIN SUPER BAZAR",
"JAIN SYNTEX PRIVATE LIMITED",
"JAIN TELEMEDIA SERVICES LIMITED",
"JAIN TEX NONWOVENS PRIVATE LIMITED.",
"JAIN TEXFAB PRIVATE LIMITED",
"JAIN TOOLS AND DIES PRIVATE LIMITED",
"JAIN TRACK FASTNER PRIVATE LIMITED",
"JAIN TRAILER SERVICES INDIA PRIVATE LIMITED",
"JAIN TRANSMISSION (I) PRIVATE LIMITED",
"JAIN TRANSMISSION INDIA PRIVATE LIMITED",
"JAIN UDHAY INTERNATIONAL PRIVATE LIMITED",
"JAIN UDYOG",
"JAIN UNIVERSITY",
"JAIN UNIVERSITY SCHOOL OF ENGINEERING & TECHNOLOGY",
"JAIN VANIJYA UDYOG LIMITED",
"JAIN VIDYAASHRAM SCHOOL",
"JAIN VIDYALAYA CBSE SCHOOL",
"JAIN VINIMAY PRIVATE LIMITED",
"JAIN WELDING ELECTRODES PRIVATE LIMITED",
"JAIN ZARI CREATIONS PRIVATE LIMITED",
"JAINA DIAMOND AND GOLD PRIVATE LIMITED",
"JAINA INDIA PRIVATE LIMITED",
"JAINA MARKETING & ASSOCIATES",
"JAINA SURGICALS PRIVATE LIMITED",
"JAINALCO INDUSTRIES LIMITED",
"JAINAM ALTERNATE ENERGY PRIVATE LIMITED",
"JAINAM AUTO LINKS PRIVATE LIMITED",
"JAINAM BROKING LIMITED",
"JAINAM CABLES (INDIA) PRIVATE LIMITED",
"JAINAM COMMODITIES PRIVATE LIMITED",
"JAINAM CONSTRUCTIONS PRIVATE LIMITED",
"JAINAM FAB PRIVATE LIMITED",
"JAINAM FERRO ALLOYS (I) LIMITED",
"JAINAM INDUSTRIES PRIVATE LIMITED",
"JAINAM INTERMEDIATES PRIVATE LIMITED",
"JAINAM INVAMED PRIVATE LIMITED",
"JAINAM MULTI PRODUCT INDIA PRIVATE LIMITED",
"JAINAM ORNAMENT PRIVATE LIMITED",
"JAINAM OVERSEAS PRIVATE LIMITED",
"JAINAM PAPAD AND FOOD PRIVATE LIMITED",
"JAINAM PHARMA INDIA PRIVATE LIMITED",
"JAINAM PROCON PRIVATE LIMITED",
"JAINAM SHARE CONSULTANTS PRIVATE LIMITED",
"JAINAM SILVER PRODUCTS PRIVATE LIMITED",
"JAINAM TECHNOLOGIES PRIVATE LIMITED",
"JAINAM TEXPARK PRIVATE LIMITED",
"JAINAM TRADING AND INVESTMENTS PRIVATE LIMITED",
"JAINANDANI COMMODITIES PRIVATE LIMITED",
"JAINARAIN FABTECH PRIVATE LIMITED",
"JAINARAIN MARKETING PRIVATE LIMITED",
"JAINARAYAN SARASWATI VIDYA MANDIR INTER COLLEGE BAREILLY",
"JAINARAYAN TRADERS PRIVATE LIMITED",
"JAINBROS INTERNATIONAL LIMITED",
"JAINCO AUTOMOBILES (J & K) PRIVATE LIMITED",
"JAINCO BEARINGS PRIVATE LIMITED.",
"JAINCO BUILDCON PRIVATE LIMITED",
"JAINCO CHEMICALS PRIVATE LIMITED",
"JAINCO CORPORATE ADVISORS PRIVATE LIMITED",
"JAINCO ENTERPRISES PRIVATE LIMITED",
"JAINCO FABRICS PRIVATE LIMITED",
"JAINCO FASHIONS PRIVATE LIMITED",
"JAINCO IRRIGATION PRIVATE LIMITED",
"JAINCO LIFESTYLE LIMITED",
"JAINCO PIPES PRIVATE LIMITED",
"JAINCO REFRACTORIES PRIVATE LIMITED",
"JAINCO REFRACTORY PRODUCTS PRIVATE LIMITED",
"JAINCO RUBBER INDUSTRIES LIMITED",
"JAINCO SYNTEX PVT LTD",
"JAINCO TANKS PRIVATE LIMITED",
"JAINCO TRANSMISSION LIMITED",
"JAINEE CHEM PRIVATE LIMITED",
"JAINEEX COMPUTERS PRIVATE LIMITED",
"JAINENDRA CONSTRUCTION PRIVATE LIMITED",
"JAINEX (FIRE AND SAFETY) SYSTEM PRIVATE LIMITED",
"JAINEX FOODS PRIVATE LIMITED",
"JAINEX IMPORTS AND EXPORTS PRIVATE LIMITED",
"JAINEX LIMITED",
"JAINEX PARIWAHAN PRIVATE LIMITED",
"JAINEX TEA COMPANY PRIVATE LIMITED",
"JAINFAM INDUSTRIES PRIVATE LIMITED",
"JAINFLEX CABLES PRIVATE LIMITED",
"JAINI TRADELINK PRIVATE LIMITED",
"JAINICO CHEMTECH PRIVATE LIMITED",
"JAINICO COATINGS PRIVATE LIMITED",
"JAINICO METACOAT INDUSTRIES INDIA PRIVATE LIMITED",
"JAINII TREXIM PRIVATE LIMITED",
"JAINIK POWER AND CABLES PRIVATE LIMITED",
"JAINIKA EXPORT IMPORT PRIVATE LIMITED",
"JAINISH ENTERTAINMENT PRIVATE LIMITED",
"JAINKUL MARKETING PRIVATE LIMITED",
"JAINOM PLASTICS INTERNATIONAL PRIVATE LIMITED",
"JAINPUR AGRO PRIVATE LIMITED",
"JAINSM MARTELL OVERSEAS PRIVATE LIMITED",
"JAINSON BIOTECH (INDIA) PRIVATE LIMITED",
"JAINSON CABLES INDIA PRIVATE LIMITED",
"JAINSON FOREX PRIVATE LIMITED",
"JAINSON LOCKS COMPANY PVT. LTD",
"JAINSON ORGANICS PVT LTD",
"JAINSON WOOLCOMBERS PRIVATE LIMITED",
"JAINSONS AVENUE PRIVATE LIMITED.",
"JAINSONS ENGINEERING PRIVATE LIMITED",
"JAINSONS HERBO LABS PRIVATE LIMITED",
"JAINSONS INDIA PRIVATE LIMITED",
"JAINSONS INDIA SECURITIES PVT LTD",
"JAINSONS LIGHTS PRIVATE LIMITED",
"JAINSONS NETWORK SYSTEM PRIVATE LIMITED",
"JAINTEK ELASTOMERS PRIVATE LIMITED",
"JAINTIA FERRO ALLOYS LIMITED",
"JAINTIA STAFFING SERVICES PRIVATE LIMITED",
"JAINUM FOOD & WASTE PROJECTS PRIVATE LIMITED",
"JAINYS CEREALS PRIVATE LIMITED",
"JAINYTIC PACKAGING PRIVATE LIMITED",
"JAIOM SAI BUILDWELL PRIVATE LIMITED",
"JAIPAN INDUSTRIES LIMITED",
"JAIPITAMBRA MOBILES PRIVATE LIMITED",
"JAIPRAKASH CONTRACTORS PRIVATE LIMITED",
"JAIPRAKASH HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED",
"JAIPRAKASH OVERSEAS FINANCE LIMITED",
"JAIPRAKASH POWER VENTURES LIMITED",
"JAIPUR BEARINGS LIMITED",
"JAIPUR BUILD DEVELOPERS PRIVATE LIMITED",
"JAIPUR CALGIRI EYE HOSPITAL",
"JAIPUR CARGO SERVICE PRIVATE LIMITED",
"JAIPUR CENTRAL ELECT. DIVISION",
"JAIPUR CENTRE DEVELOPERS PRIVATE LIMITED",
"JAIPUR CENTRE INFRAPROJECTS PRIVATE LIMITED",
"JAIPUR CERAMICS PRIVATE LIMITED",
"JAIPUR CLOTHING PRIVATE LIMITED",
"JAIPUR CODE",
"JAIPUR COLD STORAGE PVT. LTD.",
"JAIPUR COTTON ART WORKS PRIVATE LIMITED",
"JAIPUR CRAFTS PRIVATE LIMITED",
"JAIPUR DENTAL HOSPITAL POLYCLINIC",
"JAIPUR DESIGNS PRIVATE LIMITED",
"JAIPUR DEVELOPMENT AUTHORITY",
"JAIPUR DHOLPUR TRANSPORT CARRIER PRIVATE LIMITED",
"JAIPUR DIESELS PRIVATE LIMITED",
"JAIPUR EMERALD PRIVATE LIMITED",
"JAIPUR GOLDEN HOSPITAL",
"JAIPUR GOLDEN TRANSPORT CO PRIVATE LIMITED",
"JAIPUR GOUSAMVARDHAN SAMITI",
"JAIPUR IMPORTS PRIVATE LIMITED",
"JAIPUR INSTITUTE OF TECHNOLOGY",
"JAIPUR INTEGRATED TEXCRAFT PARK PRIVATE LIMITED",
"JAIPUR INTERNATIONAL AIRPORT LIMITED",
"JAIPUR INVESTMENT LIMITED",
"JAIPUR JEWELS GLOBAL LIMITED",
"JAIPUR MAHUA TOLLWAY PRIVATE LIMITED",
"JAIPUR MARBLE EMPORIUM PRIVATE LIMITED",
"JAIPUR MARRIOTT HOTEL",
"JAIPUR MEDINEEDS PRIVATE LIMITED",
"JAIPUR METRO RAIL CORPORATION LIMITED",
"JAIPUR MINERAL DEVELOPMENT SYNDICATE PVT LTD",
"JAIPUR NATIONAL UNIVERSITY",
"JAIPUR NUCLEAR & IMAGING CENTER PRIVATE LIMITED",
"JAIPUR PACKS PRIVATE LIMITED",
"JAIPUR PET PRIVATE LIMITED",
"JAIPUR PINK PANTHERS PRIVATE LIMITED",
"JAIPUR PLASTOPACK AGRO PRIVATE LIMITED",
"JAIPUR POLYMERS PRIVATE LIMITED",
"JAIPUR PRINTERS PRIVATE LIMITED",
"JAIPUR RATNA MANUFACTURING PRIVATE LIMITED",
"JAIPUR REALMART PRIVATE LIMITED",
"JAIPUR RUGS COMPANY PRIVATE LIMITED",
"JAIPUR SECURITIES PRIVATE LIMITED",
"JAIPUR SILVER JEWELS PRIVATE LIMITED",
"JAIPUR SMS HUB PRIVATE LIMITED",
"JAIPUR STEEL STRIPS PVT LTD",
"JAIPUR STEELTECH INDIA PRIVATE LIMITED",
"JAIPUR SUPREME PACKAGING PRIVATE LIMITED",
"JAIPUR TELECOM PRIVATE LIMITED",
"JAIPUR TEXFAB PRIVATE LIMITED",
"JAIPUR TEXPRINT PRIVATE LIMITED",
"JAIPUR TOOLS PRIVATE LIMITED",
"JAIPUR TUBE INDUSTRIES PRIVATE LIMITED",
"JAIPUR TUFFEN GLASS INDUSTRIES PRIVATE LIMITED",
"JAIPUR VIDYUT VITRAN NIGAM LIMITED",
"JAIPUR WATCH COMPANY PRIVATE LIMITED",
"JAIPUR ZILA DUGDH UTPADAK SAHAKARI SANGH LIMITED",
"JAIPURIA ADVANCE TECHNOLOGY PRIVATE LIMITED",
"JAIPURIA AGRO OILS PRIVATE LIMITED",
"JAIPURIA INSTITUTE OF MANAGEMENT",
"JAIPURIA LEO SOFTWARE AND SYSTEMS PRIVATE LIMITED",
"JAIPURIA SILK MILLS PRIVATE LIMITED",
"JAIPURIYA FAB PRIVATE LIMITED",
"JAIR NETWORK & SERVICES PRIVATE LIMITED",
"JAIRAJ ANCILLARIES PRIVATE LIMITED",
"JAIRAJ EARTHMOVERS AND CONSTRUCTION PRIVATE LIMITED",
"JAIRAM INTERNATIONAL PRIVATE LIMITED",
"JAIRAMDASS KHUSHIRAM IMPEX PVT LTD",
"JAIROLIA GEMS & JEWELLERY PRIVATE LIMITED",
"JAIRRAAJ FASHION PRIVATE LIMITED",
"JAIS JEWELLERY PRIVATE LIMITED",
"JAISAI INFRACREATOR INDIA PRIVATE LIMITED",
"JAISAL SILK MILLS PRIVATE LIMITED",
"JAISAR SPINTEX PRIVATE LIMITED",
"JAISARADHA MATRICULATION HIGHER SECONDARY SCHOOL",
"JAISARADHA METRICULATION HIGHER SECONDARY SCHOOL",
"JAISEE HOSPITAL PRIVATE LIMITED",
"JAI-SHEETLA COLD STORAGE PRIVATE LIMITED",
"JAISHIVA INFRA PROJECTS PRIVATE LIMITED",
"JAISHNAVI EMINENCE PRIVATE LIMITED",
"JAISHREE BUILDWELL INDIA PRIVATE LIMITED",
"JAISHREE GEMS & JEWELLERS PRIVATE LIMITED",
"JAISHREE GIRIRAJ ROADWAYS PRIVATE LIMITED",
"JAISHREE INDUSTRIES LIMITED",
"JAISHREE PAINTS & CHEMICALS PRIVATE LIMITED",
"JAISHREE REALTY PRIVATE LIMITED",
"JAISHREE SHYAM IMPEX PRIVATE LIMITED",
"JAISHREE STEELS PRIVATE LIMITED",
"JAISHREE SURGIDENT INDIA PRIVATE LIMITED",
"JAISHREE TRADING COMPANY PRIVATE LIMITED",
"JAISHREE VANIJYA PRIVATE LIMITED",
"JAISHREESHYAM PLYWOODS PRIVATE LIMITED",
"JAISIK BUSINESS LINKS PRIVATE LIMITED",
"JAISINAGAR SOYA SAMRIDHI PRODUCER COMPANY LIMITED",
"JAISINGH ALLOYS PRIVATE LIMITED",
"JAISINGH FINANCE PRIVATE LIMITED",
"JAISINGH INNOVATIONS LLP",
"JAISRI DESIGNS PRIVATE LIMITED",
"JAISUBA AGRO PRODUCTS PRIVATE LIMITED",
"JAISURYA STAFFING SERVICES PRIVATE LIMITED",
"JAISURYAS RETAIL VENTURES LIMITED",
"JAISURYAS RETAIL VENTURES PRIVATE LIMITED",
"JAISWAL AGRO CROPS PRIVATE LIMITED",
"JAISWAL AGRO INDUSTRIES PRIVATE LIMITED",
"JAISWAL ALLOYS PVT LTD",
"JAISWAL ART PRESS PRIVATE LIMITED",
"JAISWAL AUTOMOTIVE INDIA PRIVATE LIMITED",
"JAISWAL AUTOSALES PRIVATE LIMITED",
"JAISWAL CONSTRUCTION & PILETECH PRIVATE LIMITED",
"JAISWAL EQUIPMENTS AND HOLDINGS PRIVATE LIMITED",
"JAISWAL FOREX PRIVATE LIMITED",
"JAISWAL HOSPITALITY PRIVATE LIMITED",
"JAISWAL INFRATEL PRIVATE LIMITED",
"JAISWAL METALS PVT LTD",
"JAISWAL PHARMACEUTICALS PRIVATE LIMITED",
"JAISWAL SALES PRIVATE LIMITED",
"JAISWAL SPIRITS PRIVATE LIMITED",
"JAISWAL STEEL ENTERPRISES PRIVATE LIMITED",
"JAISWAL STEEL INDUSTRIES PRIVATE LIMITED",
"JAISWAL STEEL PROCESSING PRIVATE LIMITED",
"JAISWAL TILES PRIVATE LIMITED",
"JAISWALANDSONS INDUSTRIES PRIVATE LIMITED",
"JAITPUR AGRICULTURE PRIVATE LIMITED",
"JAITRA SOFTWARE SOLUTIONS PRIVATE LIMITED",
"JAIUDGAR INDUSTRIES INDIA PRIVATE LIMITED",
"JAIUDIT SUITINGS PRIVATE LIMITED",
"JAIUNISON SALES INDIA PRIVATE LIMITED",
"JAIVARDHAN POLYMERS INDUSTRIES PRIVATE LIMITED",
"JAIVARDHAN VYAPAAR PRIVATE LIMITED",
"JAIVEL ADVANCE TECHNOLOGIES PRIVATE LIMITED",
"JAIVEL AEROSPACE PRIVATE LIMITED",
"JAIVIC ELECTROMECH ENGINEERING PRIVATE LIMITED",
"JAIVIJAYA PAPER AND BOARDS PRIVATE LIMITED",
"JAIVIK FOOD & RESEARCH PRIVATE LIMITED",
"JAIVIK INTERNATIONAL PRIVATE LIMITED",
"JAIVIK KISAN UPAJ PRODUCER COMPANY LIMITED",
"JAIVIK SRI FARMERS PRODUCER COMPANY LIMITED",
"JAIWIK BIOTECH PRIVATE LIMITED",
"JAJ INTERNATIONAL INDIA LIMITED",
"JAJAL MEDICAL SERVICES PRIVATE LIMITED",
"JAJARAA FOODS AND INGREDIENTS PRIVATE LIMITED",
"JAJARAJ PHARMA",
"JAJATI DEVELOPERS AND INFRASTRUCTURE PRIVATE LIMITED",
"JAJODIA ESTATES PVT LTD",
"JAJODIA EXPORTS PRIVATE LIMITED",
"JAJODIA FINANCE LTD",
"JAJODIA IMPEX PRIVATE LIMITED",
"JAJODIA MEDICHEMS PRIVATE LIMITED",
"JAJOO ARCHITECTURAL GLASS PRIVATE LIMITED",
"JAJOO COMMERCIAL PRIVATE LIMITED",
"JAJOO ENGLISH MEDIUM SCHOOL",
"JAJOO EXIM PRIVATE LIMITED",
"JAJOO HYGIENE PRIVATE LIMITED",
"JAJOO RASHMI REFRACTORIES LIMITED",
"JAJOO RASHMI REFRACTORIES PRIVATE LIMITED",
"JAJOO SURGICALS PRIVATE LIMITED",
"JAJOT ENTERPRISES PRIVATE LIMITED",
"JAJU CHEMICALS PVT LTD",
"JAJU PHARMACEUTICALS PRIVATE LIMITED",
"JAJU SAREES PRIVATE LIMITED",
"JAK COMMUNICATIONS PRIVATE LIMITED",
"JAK GROUP",
"JAK MARITIME & LOGISTICS INDIA PRIVATE LIMITED",
"JAK PHARMALAB PRIVATE LIMITED",
"JAK PRINTERS PRIVATE LIMITED",
"JAK REALITY PROJECTS PRIVATE LIMITED",
"JAK RRC JABALPUR",
"JAKAN IMPEX PRIVATE LIMITED",
"JAKAP LACE PRIVATE LIMITED",
"JAKAP METIND PRIVATE LIMITED",
"JAKARI DEVELOPERS PRIVATE LIMITED",
"JAKES SNACKS AND FOODS PRIVATE LIMITED",
"JAKHAR AUTOMOBILES PRIVATE LIMITED",
"JAKHAR ESTATE AND INVESTMENTS PRIVATE LIMITED",
"JAKHARIA DISTRIBUTORS PRIVATE LIMITED",
"JAKHARIA FABRIC PRIVATE LIMITED",
"JAKHARIA SYNTHETICS PRIVATE LIMITED",
"JAKHAU SALT COMPANY PRIVATE LIMITED",
"JAKHETIA FINANCES PRIVATE LIMITED",
"JAKHOTIA PLASTICS PVT.LTD.",
"JAKHOTIA POLYCHEM PRIVATE LIMITED",
"JAKHOTIA POLYFIBRE PRIVATE LIMITED",
"JAKHOTIA POLYSACKS PRIVATE LIMITED",
"JAKHUBHAI LALJI DAL MILLS PRIVATE LIMITED",
"JAKKUR TECHNOPARKS PRIVATE LIMITED",
"JAKOB & PARTNERS INDIA PRIVATE LIMITED",
"JAKOB MULLER INDIAPRIVATE LIMITED",
"JAKRAYA SUGAR LIMITED",
"JAKS PLAST PRODUCTS PVT. LTD.",
"JAKSH CASTOR PRODUCTS PRIVATE LIMITED",
"JAKSH DIGITAL SERVICES PRIVATE LIMITED",
"JAKSHN MARKETING GROUP PRIVATE LIMITED",
"JAKSON ENGINEERS LIMITED",
"JAKSON GENERATORS PRIVATE LIMITED",
"JAKSON HOSPITALITY PRIVATE LIMITED",
"JAKSON LIMITED",
"JAKSON POWER PRIVATE LIMITED",
"JAKSON VENTURES PRIVATE LIMITED",
"JAL BHAGIRATHI FOUNDATION",
"JAL ENGINEERS PRIVATE LIMITED",
"JAL EXTRUSION PRIVATE LIMITED",
"JAL JYOTI INTERNATIONAL",
"JAL KAL VIBHAG AGRA",
"JAL KAL VIBHAG NAGAR NIGAM KANPUR",
"JAL KAL VIBHAG ZONE-1A NAGAR NIGAM PRAYAGRAJ",
"JAL PRAVAHIKA PVT LTD",
"JAL SANSTHAN AGRA",
"JAL SEVA CHARITABLE FONDATION",
"JAL SEVA CHARITABLE FOUNDATION",
"JAL SUPPLY CHAIN SOLUTIONS LLP.",
"JAL TECH PROJECTS PRIVATE LIMITED",
"JALA SHAKTI LIMITED",
"JALADHARA HYDRO SOLUTIONS PRIVATE LIMITED",
"JALADURGA SHIPPING PRIVATE LIMITED",
"JALAJ TRADING AND INVESTMENT CO PVT LTD",
"JALALABAD RICE EXPORTS PRIVATE LIMITED",
"JALAN AUTOLINK PRIVATE LIMITED",
"JALAN AUTOMOBILES PRIVATE LIMITED",
"JALAN BROS INDIA PRIVATE LIMITED",
"JALAN BROTHERS PRIVATE LIMITED",
"JALAN BUILDERS PRIVATE LIMITED",
"JALAN CARBONS & CHEMICALS PRIVATE LIMITED",
"JALAN CHEMICAL INDUSTRIES PVT LTD",
"JALAN COMPANY PRIVATE LIMITED",
"JALAN CON CAST LIMITED",
"JALAN CRYOGENICS PRIVATE LIMITED",
"JALAN EXPORTS PRIVATE LIMITED",
"JALAN FASHION PRIVATE LIMITED.",
"JALAN GOLD & SILVER PRIVATE LIMITED",
"JALAN INFOSYSTEM PRIVATE LIMITED",
"JALAN JEE POLY TEX LIMITED",
"JALAN JEWELLERS PVT LTD",
"JALAN JEWELS PRIVATE LIMITED",
"JALAN MARKETING PRIVATE LIMITED",
"JALAN PENS PRIVATE LIMITED",
"JALAN PROJECTS & MERCHANTS PRIVATE LIMITED",
"JALAN SILK MILLS PRIVATE LIMITED",
"JALAN TEXFAB PRIVATE LIMITED",
"JALAN TRANSOLUTIONS (INDIA) LIMITED",
"JALAN WIRES PRIVATE LIMITED",
"JALANDHAR ENGINEERING PRIVATE LIMITED",
"JALANDHAR FEED MILLS PVT LTD",
"JALANDHAR LEATHER INDIA PVT LTD",
"JALANI ENTERPRISES PRIVATE LIMITED",
"JALANNAGAR DEVELOPMENT PVT LTD",
"JALANNAGAR TEA ESTATE PVT LTD",
"JALARAM AGRIEXPORTS LIMITED",
"JALARAM BABA CHILDREN S NEST EDUCATION PRIVATE LIMITED",
"JALARAM CERAMICS LIMITED",
"JALARAM COTEX PVT LTD",
"JALARAM EXIM PRIVATE LIMITED",
"JALARAM HEALTHCARE PRIVATE LIMITED",
"JALARAM HOTELS PRIVATE LIMITED",
"JALARAM JUTE TRADERS PRIVATE LIMITED",
"JALARAM KRUPA MART PRIVATE LIMITED",
"JALARAM PAN PRODUCTS PRIVATE LIMITED",
"JALARAM POLYMERS P.LTD.",
"JALARAM PROJECTS PRIVATE LIMITED",
"JALARAM PULSES PRIVATE LIMITED",
"JALARAM SAW MILL",
"JALARAM STEEL FURNITURE PRIVATE LIMITED",
"JALARAM STEEL TRADERS PRIVATE LIMITED",
"JALARAM TRANSPORT",
"JALARAM VENEERS & FLOORS PRIVATE LIMITED",
"JALARAM YARNS PRIVATE LIMITED",
"JALARK SOLAR SOLUTIONS (OPC) PRIVATE LIMITED",
"JALAVAHINI MANAGEMENT SERVICES PRIVATE LIMITED",
"JALAVIHAR ENTERTAINMENT PRIVATE LIMITED",
"JALAYAN IT SOLUTIONS PRIVATE LIMITED",
"JALBHUMI NAMKEEN PRIVATE LIMITED",
"JALCO FINANCIAL SERVICES PRIVATE LIMITED",
"JALDACCA TEA PLANTATIONS PVT LTD",
"JALDAPARA INDUSTRIES PRIVATE LIMITED",
"JALDEEP ELECTRICALS PRIVATE LIMITED",
"JALDHAKA COLD STORAGE PRIVATE LIMITED",
"JALDHAR INVESTMENTS AND TRADING COMPANY PRIVATE LIMITED",
"JALDHARA AGRO PLAST PRIVATE LIMITED",
"JALDHARA DRIP IRRIGATION PRIVATE LIMITED",
"JALDHARA POLYTUBES PRIVATE LIMITED",
"JALDHARA SMALL TOOLS PVT LTD",
"JALDHARA TECHNOLOGIES PRIVATE LIMITED",
"JALDOOT MATERIALS HANDLING PRIVATE LIMITED",
"JALEEL AIRCON PROJECTS AND SERVICES PRIVATE LIMITED",
"JALFA INTERNATIONAL PRIVATE LIMITED",
"JALGAON GOLDEN TRANSPORT PVT.LTD.",
"JALGAON JEWELLERS PRIVATE LIMITED",
"JALGAON MUNICIPAL CORPORATION",
"JALGAON POLYMERS PRIVATE LIMITED",
"JALGAONKAR INDUSTRIES PRIVATE LIMITED",
"JALHANSA TOURS & TRAVELS PRIVATE LIMITED",
"JALINGA TEA CO (INDIA) PRIVATE LTD",
"JALIYAN PROTEINS PRIVATE LIMITED",
"JALJEEVAN ENGINEERING SERVICES PRIVATE LIMITED",
"JALKAL VIBHAG NAGAR NIGAM KANPUR",
"JALKAL VIBHAG NAGAR NIGAM LUCKNOW",
"JALKRANTI AQUACULTURE SERVICES PRIVATE LIMITED",
"JALKS PHARMACEUTICALS PRIVATE LIMITED",
"JALLAN CONCRETE PRIVATE LIMITED",
"JALLAN FURKATING TEA COMPANY PVT LTD",
"JALLAN GOLAGHAT TEA CO PVT LTD",
"JALLAN POLYPACK INDIA PVT LTD",
"JALNA BLOOD CENTER",
"JALNA CITY MAHANAGARPALIKA JALNA",
"JALNA CRITICAL CARE AND RESEARCH CENTRE PRIVATE LIMITED",
"JALNA GHANSAWANGI HIGHWAYS PRIVATE LIMITED",
"JALNA HOSPITAL PRIVATE LIMITED",
"JALNA IRRIGATION DIVISION",
"JALNA KRUSHI UTPANNA BAZAR SAMITI",
"JALNIDHI BITUMEN SPECIALITIES PRIVATE. LIMITED",
"JALORE JASWANTPURA BOT PROJECT PRIVATE LIMITED",
"JALORI KRAFTS AND TRADES PRIVATE LIMITED",
"JALPA DEVI ENGINEERING PRIVATE LIMITED",
"JALPA DEVI TOLLWAYS PRIVATE LIMITED",
"JALPAIGURI FOOD INDUSTRIES PRIVATE LIMITED",
"JALPAIGURI HINDI HIGH SCHOOL HS",
"JALPAIGURI MUNICIPALITY",
"JALPAIGURI TEA ESTATE PRIVATE LIMITED",
"JALPO TECHNOLOGIES PRIVATE LIMITED",
"JALPURTI PIPES PRIVATE LIMITED",
"JALRAJ AGRO EQUIPMENTS PRIVATE LIMITED",
"JALSA BANQUETS PRIVATE LIMITED",
"JALSA VENTURES PRIVATE LIMITED",
"JALSAGAR TEXTILE INDUSTRIES PRIVATE LIMITED",
"JALSHREE CORPORATION PRIVATE LIMITED",
"JALSUN DEVICES PRIVATE LIMITED",
"JALUKBARI HIGHER SECONDARY SCHOOL, OFFICE OF THE JALUKBARI HIGHER SECONDARY SCHOOL, JALUKBARI, GOVT OF ASSAM",
"JAL-VAYU ENVIRO SYSTEMS PRIVATE LIMITED",
"JAM FOUNDRY P LTD",
"JAM HEALTHCARE (INDIA) PRIVATE LIMITED",
"JAM HOTELS AND RESORTS PRIVATE LIMITED",
"JAM INFOSYSTEMS PRIVATE LIMITED",
"JAM JAM COLD STORAGE AND AGRO PRIVATE LIMITED",
"JAM KHAMBALIYA TRANSCO LIMITED",
"JAMABAI NARSEE SCHOOL",
"JAMAICA CAPITAL INVESTMENT AND FINANCE PRIVATE LIMITED",
"JAMAL AGRO INDUSTRIES PRIVATE LIMITED",
"JAMAL MOHAMED COLLEGE",
"JAMAL PROPERTIES PRIVATE LIMITED",
"JAMALI ENGLISH SCHOOL",
"JAMATHI'S TYRE AND SERVICES PRIVATE LIMITED",
"JAMBAI KNM TEXTILES PRIVATE LIMITED",
"JAMBHULKAR HOTEL AND RESORTS PRIVATE LIMITED",
"JAMBOPAY EXPRESS PRIVATE LIMITED",
"JAMBOTKAR MEDEQUIP PVT LTD",
"JAMBUWALA COMMODITIES PRIVATE LIMITED",
"JAMBUWALA PHARMACEUTICALS LIMITED",
"JAMCRACKER SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"JAMDAGNI KSHETRA FARMER PRODUCER COMPANY LIMITED",
"JAMDAR HOSPITAL PRIVATE LIMITED",
"JAMEA RAHMANIA",
"JAMECK SERVICES INDIA PRIVATE LIMITED",
"JAMECO AGENCIES PVT LTD",
"JAMES ELECTRICALS PRIVATE LIMITED",
"JAMES LONG CLINIC PRIVATE LIMITED",
"JAMES MACKINTOSH AND COMPANY PRIVATE LIMITED",
"JAMES RETAIL PRIVATE LIMITED",
"JAMES ROBINSON SPECIALITIES PRIVATE LIMITED",
"JAMES SMITH FOODS PRIVATE LIMITED",
"JAMES T KENT HOMOEO LAB PRIVATE LIMITED",
"JAMES WALKER INMARCO INDUSTRIES PRIVATE LIMITED",
"JAMES WARREN TEA LIMITED",
"JAMESBLAKE IT SOLUTIONS PRIVATE LIMITED",
"JAMEWAAR APPARELS PRIVATE LIMITED",
"JAMI HYDRAULICS PRIVATE LIMITED",
"JAMIA MILLIA ISLAMIA",
"JAMIA MILLIA UNIVERSITY",
"JAMIAH GIA ITI JAMBUSAR",
"JAMIE POWER PRIVATE LIMITED",
"JAMIND TECHNOLOGIES PRIVATE LIMITED",
"JAMINI BHUSAN RAY STATE AYURUVED",
"JAMIPOL LIMITED",
"JAMISH INVESTMENT PRIVATE LIMITED",
"JAMIYA AGRO FARMING PRIVATE LIMITED",
"JAMKASH BIKING PRIVATE LIMITED",
"JAMKASH TRUCKING PRIVATE LIMITED",
"JAMKASH VEHICLEADES (KASHMIR) PRIVATE LIMITED",
"JAMKASH VEHICLEADS PRIVATE LIMITED",
"JAMKO CONSULTANTS PRIVATE LIMITED",
"JAMMI PHARMACEUTICALS",
"JAMMU AND KASHMIR BANK",
"JAMMU AND KASHMIR DEVELOPMENT FINANCE CORPORATION LIMITED",
"JAMMU AUTO MART PRIVATE LIMITED",
"JAMMU AUTOWHEELS PRIVATE LIMITED",
"JAMMU CASTING PRIVATE LIMITED",
"JAMMU HEALTHCARE & DIAGNOSTICS PRIVATE LIMITED",
"JAMMU MOTORS PRIVATE LIMITED",
"JAMMU PIGMENTS LIMITED",
"JAMMULA ENTERPRISES PRIVATE LIMITED",
"JAMMY INFRA PRIVATE LIMITED",
"JAMMY LOGISTICS PRIVATE LIMITED",
"JAMNA AUTO INDUSTRIES LIMITED",
"JAMNA CONSTRUCTION PRIVATE LIMITED",
"JAMNA DASS AND SONS TRADERS PRIVATE LIMITED",
"JAMNA DASS NIKKAMAL JAIN SARAF PRIVATE. LIMITED.",
"JAMNA HERBAL RESEARCH LIMITED",
"JAMNA IRRIGATIONS PRIVATE LIMITED",
"JAMNA PHARMACUTICALS",
"JAMNA SYNTEX PRIVATE LIMITED",
"JAMNABAI GENERAL HOSPITAL",
"JAMNABAI HOSPITAL VADODARA",
"JAMNABAI NARSEE INTERNATIONAL SCHOOL",
"JAMNABAI NARSEE SCHOOL",
"JAMNADAS & COMPANY",
"JAMNADAS INDUSTRIES",
"JAMNADAS MORARJEE SECURITIES LIMITED",
"JAMNADAS VIRJI SHARES AND STOCK BROKERS PRIVATE LIMITED",
"JAMNADI KHORE FARMERS PRODUCER COMPANY LIMITED",
"JAMNAGAR CRITICAL CARE CENTRE PRIVATE LIMITED",
"JAMNAGAR GOLDEN CARRIERS (DELHI) PRIVATE LIMITED",
"JAMNAGAR JILLA SHIKSHAN SAMITI SANCHALIT PRIMARY SCHOOL",
"JAMNAGAR MUNICIPLE CORPORATION",
"JAMNAGAR TRANSPORT COMPANY PRIVATE LIMITED",
"JAMNAGAR UTILITIES & POWER PRIVATE LIMITED",
"JAMNAHARI PRIVATE LIMITED",
"JAMNALAL BAJAJ INSTITUTE OF MANAGEMENT S",
"JAMNALAL PAREKH FINANCE PRIVATE LIMITED",
"JAMNALAL SONS PRIVATE LIMITED",
"JAMNOTRI TRADERS PRIVATE LIMITED",
"JAMOCHA TECH PRIVATE LIMITED",
"JAMP INDIA PHARMACEUTICALS PRIVATE LIMITED",
"JAMPAN ELECTRICALS PRIVATE LIMITED",
"JAMPANA AGROTECH PRIVATE LIMITED",
"JAMPANA CONSTRUCTION PRIVATE LIMITED",
"JAMPESWAR AGRO UDYOG PRIVATE LIMITED",
"JAMPEX TRADING PRIVATE LIMITED",
"JAMPOT TECHNOLOGIES PRIVATE LIMITED",
"JAMS CASTINGS PRIVATE LIMITED",
"JAMS GRANITES PRIVATE LIMITED",
"JAMS TECHNOLOGIES PRIVATE LIMITED",
"JAMSAB COMPUTERS PRIVATE LIMITED",
"JAMSAS TRADELINKS PRIVATE LIMITED",
"JAMSHEDPUR AUTO COMPONENT PRIVATE LIMITED",
"JAMSHEDPUR CHLOROCHEM PRIVATE LIMITED",
"JAMSHEDPUR CONSTECH PRIVATE LIMITED",
"JAMSHEDPUR CONTINUOUS ANNEALING & PROCESSING COMPANY PRIVATE LIMITED",
"JAMSHEDPUR FOOTBALL AND SPORTING PRIVATE LIMITED",
"JAMSHEDPUR MINERAL WOOL MANOFACTURING COMPANY PRIVATE LIMITED",
"JAMSHEDPUR OXYGEN PRIVATE LIMITED",
"JAMSHEDPUR RESOURCES PRIVATE LIMITED",
"JAMSHEDPUR ROLLER FLOUR MILLS PVT LTD",
"JAMSHEDPUR TRANSPORT LIMITED",
"JAMSHRI REALTY LIMITED",
"JAMSON SECURITIES PRIVATE LIMITED",
"JAMTALA HIGH SCHOOL",
"JAMTECH TECHNOLOGIES PRIVATE LIMITED",
"JAMTRANS LOGISTICS PRIVATE LIMITED",
"JAMU AUTOMOBILES PVT LTD",
"JAMUNA BULLION PRIVATE LIMITED",
"JAMUNA CHRISTIAN COLLEGE",
"JAMUNA COMMERCIAL PRIVATE LIMITED",
"JAMUNA ENTERPRISES PVT LTD",
"JAMUNA GEM & JEWELLERS PRIVATE LIMITED",
"JAMUNA INFRAPROJECTS PRIVATE LIMITED",
"JAMUNA JEWELLERS PRIVATE LIMITED",
"JAMUNA JYOTI DEVELOPERS PRIVATE LIMITED",
"JAMUNA KHAND INTER COLLEGE TAPPAL",
"JAMUNA MAHANIRMAN PRIVATE LIMITED",
"JAMUNA MARKETING PRIVATE LIMITED",
"JAMUNA PLAST PRIVATE LIMITED",
"JAMUNA POULTRY FARM",
"JAMUNA REALTY PRIVATE LIMITED",
"JAMUNA TRANSPORT CORPORATION LTD",
"JAMUNAVIEW SILVER HOUSE PRIVATE LIMITED",
"JAMUNI POLYMERS PRIVATE LIMITED",
"JAMWAY LOGISTICS PRIVATE LIMITED",
"JAN AUSHADHI SANGH",
"JAN CHETNA MANCH BOKARO",
"JAN DE NUL DREDGING INDIA PRIVATE LIMITED",
"JAN GAN MAN ENGLISH SECONDARY SCHOOL",
"JAN PRIYA BUILDESTATE PRIVATE LIMITED",
"JAN SAHAS FOUNDATION",
"JAN SAMADHAN TECHNOLOGY & SERVICESPRIVATE LIMITED",
"JAN SHAKTI OIL PRODUCTS PRIVATE LIMITED",
"JAN SWASTHYA SAHYOG",
"JANA AGRO TECH PRIVATE LIMITED",
"JANA ANALYSIS",
"JANA ENGINEERS PRIVATE LIMITED",
"JANA JEEVA ESTATES PRIVATE LIMITED",
"JANA MED TECH PRIVATE LIMITED",
"JANA PAPERS PRIVATE LIMITED",
"JANA SMALL FINANCE BANK LIMITED",
"JANA URBAN FOUNDATION",
"JANA URBAN SERVICES FOR TRANSFORMATION PRIVATE LIMITED",
"JANA URBAN SPACE FOUNDATION (INDIA)",
"JANAADHAR INDIA PRIVATE LIMITED",
"JANACARE SOLUTIONS PRIVATE LIMITED",
"JANACHAITANYA HOUSING PRIVATE LIMITED",
"JANAHARSHA ESTATES N CONSTRUCTIONS PRIVATE LIMITED",
"JANAK BUILDCON PRIVATE LIMITED",
"JANAK CARGO MOVERS PVT LTD",
"JANAK DEHYDRATION PVT LTD",
"JANAK GARMENTEX (INDIA) PRIVATE LIMITED",
"JANAK HANDLOOMS PRIVATE LIMITED",
"JANAK MACHINES PRIVATE LIMITED",
"JANAK MERCHANT SECURITIES PRIVATE LIMITED",
"JANAK NANDINI BUILDWELL PRIVATE LIMITED",
"JANAK NANDINI INFRASTRUCTURES PRIVATE LIMITED",
"JANAK POSITIONING AND SURVEYING SYSTEMS PVT LTD",
"JANAK SONS KNITWEAR PRIVATE LIMITED",
"JANAKALYAN BLOOD BANK JALNA",
"JANAKALYAN FINANCIAL SERVICES PRIVATE LIMITED",
"JANAKALYAN SAHAKARI BANK",
"JANAKEE INDUSTRIAL PRODUCTS PRIVATE LIMITED",
"JANAKI APPLIANCES PRIVATE LIMITED",
"JANAKI COTTON MILLS LIMITED",
"JANAKI DEVI MADAN NURSING HOME PRIVATE LIMITED",
"JANAKI FEEDS PVT LTD",
"JANAKI RAM STEEL AND POWER PRIVATE LIMITED",
"JANAKI REFRACTORIES PRIVATE LIMITED",
"JANAKI STEEL PRIVATE LIMITED",
"JANAKIRAM MILLS LIMITED",
"JANAKIRAMA AQUA FARMS PRIVATE LIMITED",
"JANAKPUR TRADELINK PVT LTD",
"JANAKSONS FASHIONS PRIVATE LIMITED",
"JANAM CORPORATION PRIVATE LIMITED",
"JANAM DIAMONDS PRIVATE LIMITED",
"JANAM MULTIMEDIA LIMITED",
"JANAMBHUMI HOTELS & RESORTS (P) LTD",
"JANAMMA HOSPITAL",
"JANANAYAK ENTERPRISES PRIVATE LIMITED",
"JANAND ROADWAYS PRIVATE LIMITED",
"JANANI",
"JANANI AUTOMOBILES PRIVATE LIMITED",
"JANANI ENVIROTECH PRIVATE LIMITED",
"JANANI FOODTEK (I) PRIVATE LIMITED",
"JANANI INDUSTRIES PRIVATE LIMITED",
"JANANI INFRASTRUCTURE PRIVATE LIMITED",
"JANANI INTERNATIONAL PRIVATE LIMITED",
"JANANI MOULDINGS P LTD",
"JANANI PHARMACEUTICALS PRIVATE LIMITED",
"JANANI PROPERTY AND ESTATES PRIVATE LIMITED",
"JANANI PUBLIC SCHOOL",
"JANANI TOURS AND RESORTS PRIVATE. LIMITED.",
"JANANI WATER TECHNOLOGIES PRIVATE LIMITED",
"JANANII HOSPITAL PRIVATE LIMITED",
"JANAPRIYA COMMUNICATIONS LIMITED",
"JANAPRIYA PROJECTS",
"JANAPRIYO REAL ESTATE PRIVATE LIMITED",
"JANARDAN MINERAL EXIM PRIVATE LIMITED",
"JANARDAN NIRMAN PRIVATE LIMITED",
"JANARDAN WIND ENERGY PRIVATE LIMITED",
"JANARDHAN BEVERAGES PRIVATE LIMITED",
"JANAROGYAM GENERIC PRIVATE LIMITED",
"JANARTHA ADVERTISING PRIVATE LIMITED",
"JANASHA FINANCE PRIVATE LIMITED",
"JANASHAKTI REALCON PRIVATE LIMITED",
"JANATA AROGYA MANDAL INSTITUTE OF INDI",
"JANATA MACHINERY STORES PVT LTD",
"JANATA SAHAKARI BANK LIMITED",
"JANATA SHIKSHAN SANSTHA'S KISAN VEER MAHAVIDYALAYA WAI",
"JANATA VIDYA MANDIR KANISHTHA MAHAVIDYALAYA",
"JANATA VIDYALAYA AND ARTS JR COLLEGE MANGRUL",
"JANATA VIDYALAYA PAREGAON",
"JANATA VIDYALYA BAMBAVADE",
"JANATHA AUTOMOBILES PRIVATE LIMITED",
"JANATHA ENTERPRISES PRIVATE LIMITED",
"JANATHA FISH MEAL & OIL PRODUCTS",
"JANATHA HOSPITAL",
"JANATHA JEWELLERY PRIVATE LIMITED",
"JANATHA STEEL MILLS PRIVATE LIMITED",
"JANATICS INDIA PRIVATE LIMITED",
"JANATICS INDUSTRIAL AUTOMATION PRIVATE LIMITED",
"JANAV OVERSEAS PRIVATE LIMITED",
"JANAVI FACILITY MANAGEMENT PRIVATE LIMITED",
"JANAXA PHARMACEUTICALS PRIVATE LIMITED",
"JANAYUGAM PUBLICATIONS LTD",
"JANBAAZ CONSTRUCTION PRIVATE LIMITED",
"JANBASK CONSULTING PRIVATE LIMITED",
"JANBAZAR ALUMINIUM PRIVATE LIMITED",
"JANDIA ENGINEERING PRIVATE LIMITED",
"JANDIAL INFRA DEVELOPERS PRIVATE LIMITED",
"JANDJ DECHANE LABORATORIES PVT LTD",
"JANDV PHARMACY PRIVATE LIMITED",
"JANE AND JONES PVT LTD",
"JANE'S DEFENSE INDIA LLP",
"JANET'S RETAIL AND DISTRIBUTION PRIVATE LIMITED",
"JANGA MEDIA PRIVATE LIMITED",
"JANGAL MAHAL COLD STORAGE PRIVATE LIMITED",
"JANGEER MANUFACTURING INDUSTRIES PRIVATE LIMITED",
"JANGID BROTHERS PRIVATE LIMITED",
"JANGID BUILDERS PVT LTD",
"JANGID FREIGHT CARRIERS PRIVATE LIMITED",
"JANGID HOME PRIVATE LIMITED",
"JANGID INTERIOR DECOR PRIVATE LIMITED.",
"JANGID MARMO AND GRANITES PRIVATE LIMITED",
"JANGID MOTORS INDIA PRIVATE LIMITED",
"JANGID SOLAR ENERGY PRIVATE LIMITED",
"JANGIPARA RURAL HOSPITAL JANGIPARA HOOGHLY",
"JANGIPUR BENGAL MEGA FOOD PARK LIMITED",
"JANGIPUR JUTE MILLS PRIVATE LIMITED",
"JANGIR DRAFTS PRIVATE LIMITED",
"JANGLESHWAR ELECTRICALS PRIVATE LIMITED",
"JANGLOO'S CHANDAK CREATION PRIVATE LIMITED",
"JANGONE FOAM PRODUCTS INDIA PRIVATE LIMITED",
"JANGOO TECHNOLOGIES PRIVATE LIMITED",
"JANGRA CHEMICALS PRIVATE LIMITED",
"JANGRA STEEL PRIVATE LIMITED",
"JANHAVI PROMOTERS PRIVATE LIMITED",
"JANHIT KARI SEWA SAMITI",
"JANHVI INFRAVENTURES PRIVATE LIMITED",
"JANHVI NURSING HOME PRIVATE LIMITED",
"JANI METALS PRIVATE LIMITED",
"JANI SALES PRIVATE LIMITED",
"JANI SHIPPING AND LOGISTICS PRIVATE LIMITED",
"JANICO CHEMICALS PRIVATE LIMITED",
"JANISHA HOMES LIMITED",
"JANITOR DISTRIBUTORS PVT LTD",
"JANJAES PHARMACEUTICAL PRIVATE LIMITED",
"JANJAGRUTI VIDYALAYA SHEWGA TQ AMBAD",
"JANKALYAN MEDICAL PRIVATE LIMITED",
"JANKALYAN SHIKSHA VIKAS SEWA SAMITI",
"JANKI ASSOCIATES (INDIA) PRIVATE LIMITED",
"JANKI BALLABH CHEMICO PRIVATE LIMITED",
"JANKI COKES TRADERS PRIVATE LIMITED",
"JANKI CORP LIMITED",
"JANKI DEVI MEMORIAL COLLEGE",
"JANKI DIAMONDS PRIVATE LIMITED",
"JANKI FOREX PRIVATE LIMITED",
"JANKI GEMS PRIVATE LIMITED",
"JANKI IMAGE PRIVATE LIMITED",
"JANKI IMPEX PRIVATE LIMITED",
"JANKI JEWELLERS PRIVATE LIMITED",
"JANKI LEASING AND FINANCE PRIVATE LIMITED",
"JANKI MAHAL HOTELS PRIVATE LIMITED",
"JANKI MEDICAL",
"JANKI METAL STRIPS PRIVATE LIMITED",
"JANKI NANDAN SAREES PRIVATE LIMITED",
"JANKI NEWSPRINT PRIVATE LIMITED",
"JANKI PROJECTS PRIVATE LIMITED",
"JANKI RICE & SOLVENT INDUSTRIES PRIVATE LIMITED",
"JANKI SEEDS AND RESEARCH PRIVATE LIMITED",
"JANKI STAINLESS INDIA PRIVATE LIMITED",
"JANKI TARA IMPEX PRIVATE LIMITED",
"JANKI VIDHYALAYA",
"JANKILAL AND NANDLAL METAL PVT LTD",
"JANKIRAMAN ORGANIC FOOD PRIVATE LIMITED",
"JANMABHUMI DAILY",
"JANMAN INVESTMENTS PRIVATE LIMITED",
"JANMANGAL FINANCE PRIVATE LIMITED",
"JANMEJAY MARKETING PRIVATE LIMITED",
"JANN PROJECTS PRIVATE LIMITED",
"JANNAT BUSINESS ASSOCIATES PRIVATE LIMITED",
"JANNAT DEVELOPERS PRIVATE LIMITED",
"JANNAT FABRICS AND APPARELS PRIVATE LIMITED",
"JANNHAVI INVESTMENT PVT LTD",
"JANO MARITIME TRAINING SERVICES PRIVATE LIMITED",
"JANOSCHKA GRAPHIC SERVICES INDIA PRIVATE LIMITED",
"JANOSCHKA INDIA HOLDING PRIVATE LIMITED",
"JANPAD PANCHAYAT",
"JANPATH RESTAURENTS",
"JANPRAGATI ENGINEERING PRIVATE LIMITED",
"JANRISE ADVERTISING PRIVATE LIMITED",
"JANS BAMBOO PRODUCTS PRIVATE LIMITED",
"JANSA SOLAR SOLUTIONS PRIVATE LIMITED",
"JANSAHAYAK TRUST HIRMANI SCHOOL",
"JANSEN INDIA MEDTECH PRIVATE LIMITED",
"JANSEN INFRASTRUCTURE PRIVATE LIMITED",
"JANSEVA CARRIERS PRIVATE LIMITED",
"JANSEVA COOPERATIVE CREDIT SOCIETY LTD",
"JANSHAKTI TEXTILE MILLS LIMITED",
"JANSONS INDUSTRIES LIMITED",
"JANSONS MRI DIAGNOSTIC PRIVATE LIMITED",
"JANTA ADARSH INTER COLLEGE",
"JANTA ASSOCIATES AND CO. LIMITED",
"JANTA BAKERY",
"JANTA BREEDING FARM",
"JANTA DIAGNOSTIC CENTRE PRIVATE LIMITED",
"JANTA ELECTRICALS ENGINEERING PRIVATE LIMITED",
"JANTA FOOTWEAR PRIVATE LIMITED",
"JANTA HOSPITAL",
"JANTA INTER COLLEGE",
"JANTA JUNIOR HIGH SCHOOL",
"JANTA LAND PROMOTERS LIMITED",
"JANTA MADHYAMIK VIDYALAYA",
"JANTA PAINTS PRIVATE LIMITED",
"JANTA RICE MILL",
"JANTA STEEL PRIVATE LIMITED",
"JANTA SWEET HOME PRIVATE LIMITED",
"JANTA UCHUCHTAR MADHYAMIK VIDYALA",
"JANTA VIDYALAYA IC MAGORRA MATHURA",
"JANTA X RAY CLINIC PRIVATE LIMITED",
"JANTA X-RAY AND CLINICAL LAB PRIVATE LIMITED",
"JANUS AVIATION PRIVATE LIMITED",
"JANUS BIOTECH INDIA PRIVATE LIMITED",
"JANUS CONSOLIDATED FINANCE PRIVATE LIMITED",
"JANUS CORPORATION LIMITED",
"JANUS ENGINEERING PRIVATE LIMITED",
"JANUS GLOBAL TRADE PRIVATE LIMITED",
"JANUS INFRASTRUCTURE PROJECTS PRIVATE LIMITED",
"JANUS INTERNATIONAL PRIVATE LIMITED",
"JANUS INVESTMENTS PVT LTD",
"JANUS LIFE SCIENCES PRIVATE LIMITED",
"JANUS TEXFAB PRIVATE LIMITED",
"JANVANI PRAKASHAN PRIVATE LIMITED",
"JANVI CONSTRUCTIONS PRIVATE LIMITED",
"JANVI ENTERPRISES P. LTD.",
"JANVI GEMS",
"JANVI LGD PRIVATE LIMITED",
"JANVIK ENGINEERS AND TUBES PRIVATE LIMITED",
"JANYA BIOCARE PRIVATE LIMITED",
"JANYA EXTRUSIONS PRIVATE LIMITED",
"JANYU TECHNOLOGIES PRIVATE LIMITED",
"JANZIN CONTAINER LINES PRIVATE LIMITED",
"JAORA - NAYAGAON TOLL ROAD COMPANY PRIVATE LIMITED",
"JAORA FLOUR AND FOODS PVT LTD",
"JAORA GOLD AGRO PRIVATE LIMITED",
"JAORA GRAINS AND SPICES PRIVATE LIMITED",
"JAORA PRINCIPAL GIRLS H S SCHOOL JAORA",
"JAP 1 RANCHI",
"JAP AGENCIES PRIVATE LIMITED",
"JAP APPARELS PRIVATE LIMITED",
"JAP BUILDCON PRIVATE LIMITED",
"JAP ENGINEERING PRIVATE LIMITED",
"JAP INFO SYSTEMS PRIVATE LIMITED",
"JAP INFRACON PRIVATE LIMITED",
"JAP MODULAR FURNITURE CONCEPTS PRIVATE LIMITED",
"JAP OVERSEAS PRIVATE LIMITED",
"JAPAN AIR LINES CO.LIMITED",
"JAPAN CBM CORPORATION INDIA PRIVATE LIMITED",
"JAPAN INTERNATIONAL CONSULTANTS FOR TRAN SPORTATION COMPANY LTD",
"JAPAN INTERNATIONAL CONSULTANTS FOR TRANSPORTATION",
"JAPAN MARINE SPARES PRIVATE LIMITED",
"JAPAN METAL BUILDING SYSTEMS PRIVATE LIMITED",
"JAPAN STEEL WORKS INDIA PRIVATE LIMITED",
"JAPANESE EMBASSY",
"JAPANESE SCHOOL EDUCATIONAL TRUST OF CHENNAI",
"JAPANWALA JEWELLERS PRIVATE LIMITED",
"JAPCO PACKING PRIVATE LIMITED",
"JAPFA COMFEED INDIA PRIVATE LIMITED",
"JAPNIT ENTERPRISES PRIVATE LIMITED",
"JAPRO ENGINEERING PVT LTD",
"JAPS MULTIVENTURES PRIVATE LIMITED",
"JAPSIN JACOB WIRE DRAWING PRIVATE LIMITED",
"JAPSON ESTATES PRIVATE LIMITED",
"JAPTECH INDUSTRIES",
"JAQ-CAD TEXFAB (INDIA) PRIVATE LIMITED",
"JAQUAR AND COMPANY PRIVATE LIMITED",
"JAR LIGHTS PRIVATE LIMITED",
"JARAA GLOBAL ENGINEERING PRIVATE LIMITED",
"JARAIKELA LUMBERMAN INDIA PRIVATE. LIMITED.",
"JARANDESHWAR SUGAR MILLS PRIVATE LIMITED",
"JARDEN CORPORATION",
"JARDIN HOTELS",
"JARDINE HENDERSON LIMITED",
"JARDINE MATHESON LIMITED",
"JARE BUILDCON PRIVATE LIMITED",
"JARI KART PRIVATE LIMITED",
"JARI SAREE CENTRE INDIA PRIVATE LIMITED",
"JARIWALA AAROGYA PRIVATE LIMITED",
"JARIWALA ROBOTICS PRIVATE LIMITED",
"JARIWALA SALES PRIVATE LIMITED",
"JARO FINCAP PRIVATE LIMITED",
"JARO TOPPSCHOLARS PRIVATE LIMITED",
"JAROLI AGRO PRIVATE LIMITED",
"JAROSNIV EXPORTS PRIVATE LIMITED",
"JARSH INNOVATIONS PRIVATE LIMITED",
"JARUL HUMAN RESOURCES SERVICES PRIVATE LIMITED",
"JARUL INFRASTRUCTURE PRIVATE LIMITED",
"JARULSS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"JARULSS TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"JARUS TECHNOLOGIES INDIA PRIVATE LIMITED",
"JARVIS AUTOMATE PRIVATE LIMITED",
"JARVIS BUSINESS SOLUTIONS PRIVATE LIMITED",
"JARVIS EQUIPMENT PRIVATE LIMITED",
"JARVIS TECHNOLOGY AND STRATEGY CONSULTING PRIVATE LIMITED",
"JARVISDEN IT SOLUTIONS PRIVATE LIMITED",
"JAS ALUPLAST PRIVATE LIMITED",
"JAS CONTRACTOR PRIVATE LIMITED",
"JAS DELICACIES PRIVATE LIMITED",
"JAS EQUIPMENT & ENGINEERS PRIVATE LIMITED",
"JAS GLASSIX PRIVATE LIMITED",
"JAS GRANITE AGGREGATES PRIVATE LIMITED",
"JAS ONE SECURITIES PRIVATE LIMITED",
"JAS POLYCHEM PRIVATE LIMITED",
"JAS TELECOM PRIVATE LIMITED",
"JAS TOLL ROAD COMPANY LIMITED",
"JASAMRAT COTGIN PRIVATE LIMITED",
"JASAMRIT ESTATES PRIVATE LIMITED",
"JASANI",
"JASANI COTTON PRIVATE LIMITED",
"JASANI JEWELLERY",
"JASBIR SINGH AND SONS HOTELS PRIVATE LIMITED",
"JASCH FOAMS PRIVATE LIMITED",
"JASCH INDUSTRIES LIMITED",
"JASCH PLASTICS INDIA LIMITED",
"JASCH SHOES INDIA LIMITED",
"JASCO AGRO FARMS PRIVATE LIMITED",
"JASCO LABS PRIVATE LIMITED",
"JASCO MULTIPACKING PRIVATE LIMITED",
"JASCO PUMP PRIVATE LIMITED",
"JASCON ENERGY PRIVATE LIMITED",
"JASDAN ENERGY PRIVATE LIMITED",
"JASFO DESIGN PRIVATE LIMITED",
"JASGURA TRADERS PRIVATE LIMITED",
"JASH DIAJEWELS PRIVATE LIMITED",
"JASH ENGINEERING LIMITED",
"JASH ENGINEERING LTD",
"JASH FOODS INDIA PRIVATE LIMITED",
"JASH PRECISION TOOLS PRIVATE LIMITED",
"JASH STEEL PRIVATE LIMITED",
"JASH TEXFAB PRIVATE LIMITED",
"JASH VINIMAY PRIVATE LIMITED",
"JASHAN JEWELS PRIVATE LIMITED",
"JASHBHAI MAGANBHAI PATEL COLLEGE",
"JASHMAAN MINERALS PRIVATE LIMITED",
"JASHNANI CONSTRUCTIONS PRIVATE LIMITED",
"JASHODA BLEACHING",
"JASHODA ENGINEERING WORKS PVT LTD",
"JASIC TECHNOLOGY INDIA PRIVATE LIMITED",
"JASINOX VENTURES PRIVATE LIMITED",
"JASK EXPORTS PRIVATE LIMITED",
"JASK FOODS PRIVATE LIMITED",
"JASKARAN INFRASTRUCTURES PRIVATE LIMITED",
"JASKEIM INDUSTRIES PRIVATE LIMITED",
"JASKY EXPORTS PRIVATE LIMITED",
"JASLEEN BUILD PROJECTS PRIVATE LIMITED",
"JASLOK HOSPITAL",
"JASM EYE HOSPITALS PRIVATE LIMITED",
"JASMA SERVICES PRIVATE LIMITED",
"JASMAN CONSULTANTS PRIVATE LIMITED",
"JASMER PACK LIMITED",
"JASMIN INFINITETRADE PRIVATE LIMITED",
"JASMIN INFOTECH PRIVATE LIMITED",
"JASMINA CONSTRUCTIONS PRIVATE LIMITED",
"JASMINE APPARELS PRIVATE LIMITED",
"JASMINE BIO LABS PRIVATE LIMITED",
"JASMINE COMMERCIALS LTD",
"JASMINE COMMODITIES PRIVATE LIMITED",
"JASMINE CONCRETE EXPORTS PRIVATE LIMITED",
"JASMINE DESIGN PRIVATE LIMITED",
"JASMINE FAB PRIVATE LIMITED",
"JASMINE INDIA PVT LTD",
"JASMINE KNITTING INDUSTRIES PRIVATE LIMITED",
"JASMINE LIMITED",
"JASMINE NIRMAN PRIVATE LIMITED",
"JASMINE RICE MILL PRIVATE LIMITED",
"JASMINE ROSE SOFTWARE INNOVATION PRIVATE LIMITED",
"JASMINE SOURCING PRIVATE LIMITED",
"JASMINE STATIONERS PRIVATE LIMITED",
"JASMINE SUITS AND FABRICS PRIVATE LIMITED",
"JASMINE TOWELS PRIVATE LIMITED",
"JASMINE TRAVEL PRIVATE LIMITED",
"JASMINN HOSPITALITY SERVICES PRIVATE LIMITED",
"JASMINO POLYMERTECH PRIVATE LIMITED",
"JASMIRA ENGINEERS PVT LTD",
"JASNATH INFRASTUCTURE PRIVATE LIMITED",
"JASNETS INDUSTRIES PRIVATE LIMITED",
"JASO INDIA PRIVATE LIMITED",
"JASODA AGRO FOODS PRIVATE LIMITED",
"JASOL INVESTMENT& TRADING CO PVT LTD",
"JASPACK INDUSTRIES PRIVATE LIMITED",
"JASPAL ENTERPRISES",
"JASPAL INTERNATIONAL FASHIONS PRIVATE LIMITED",
"JASPAL KAUR PUBLIC SCHOOL",
"JASPAT INVESTMENTS AND CONSULTANCY PRIVATE LIMITED",
"JASPER ASSOCIATES PRIVATE LIMITED",
"JASPER AUTO SERVICES PRIVATE LIMITED",
"JASPER AUTOMOBILES PRIVATE LIMITED",
"JASPER COLIN RESEARCH PRIVATE LIMITED",
"JASPER INDUSTRIES PRIVATE LIMITED",
"JASPER REMEDIES PRIVATE LIMITED",
"JASPER SWITCHGEAR PRIVATE LIMITED.",
"JASPER TRIPS PRIVATE LIMITED",
"JASPREET STEELMET PRIVATE LIMITED",
"JASRA GRAPHICS PRIVATE LIMITED",
"JASRAJ INFRASTRUCTURE PRIVATE LIMITED",
"JASRAJ KALIANJI INFOSYSTEMS PRIVATE LIMITED",
"JASRAM MILK FOODS PRIVATE LIMITED",
"JASS ARTS & CRAFTS PRIVATE LIMITED",
"JASS GROUNDING SYSTEMS PRIVATE LIMITED",
"JASS JEWELARTS PRIVATE LIMITED",
"JASS ROLLER FLOUR MILLS PVT LTD",
"JASSCO STEEL PRIVATE LIMITED",
"JASSDAK FACILITIES PRIVATE LIMITED",
"JASSI BOUTIQUE",
"JASSMINE ENTERPRISES",
"JASSPACK SERVICES PVT LTD",
"JASTECH INFOSYSTEMS PRIVATE LIMITED",
"JASTECH SYSTEMS PRIVATE LIMITED",
"JASUBHAI BUSINESS SERVICES PRIVATE. LIMITED",
"JASUBHAI ENGINEERING PRIVATE LIMITED",
"JASUBHAI MEDIA PRIVATE LIMITED",
"JASUDBEN ML SECONDARY SCHOOL",
"JASUJA ENTERPRISES PRIVATE LIMITED",
"JASVIR ONLINE CAF√â",
"JASVIT CONSTRUCTIONS PRIVATE LIMITED",
"JASWALI AGROTECH PRIVATE LIMITED",
"JASWANI AUTOMOBILES PRIVATE LIMITED",
"JASWANT GARMENTS PRIVATE LIMITED",
"JASWANT INTERNATIONAL PRIVATE LIMITED",
"JASWANT MILLS INTER COLLEGE",
"JASWANT NAGAR COLD STORAGE PRIVATE LIMITED",
"JASWANT RAI SPECIALITY HOSPITAL",
"JASWANT RASAYAN PVT LTD",
"JASWANTSINGH OBEROI CONSTRUCTION PRIVATE LIMITED",
"JASWINDER MACHINE TOOLS PRIVATE LIMITED",
"JASYATRA TOURS AND TRAVELS PRIVATE LIMITED",
"JAT COLLEGE KAITHAL",
"JAT METAL PRESSING PRIVATE LIMITED",
"JAT REGIMENT CENTRE",
"JATAH WORX INDIA PRIVATE LIMITED",
"JATAN CONSTRUCTIONS PRIVATE LIMITED",
"JATAN GREENTECH PRIVATE LIMITED",
"JATAN KNITWEAR PRIVATE LIMITED",
"JATAN SECURITIES PRIVATE LIMITED",
"JATASYA INTERNATIONAL INSTITUTE FOR TALENT PRIVATE LIMITED",
"JATASYA PROMOTERS PRIVATE LIMITED",
"JATAYU TEXTILES & INDUSTRIES LIMITED",
"JATH WIND ENERGY PRIVATE LIMITED",
"JATHAR HOSPITAL PRIVATE LIMITED",
"JATHAR TEXTILES PRIVATE LIMITED",
"JATI ENGITECH PRIVATE LIMITED",
"JATIA CHEMICALS PRIVATE LIMITED",
"JATIA PROPRIETORY COMPANY LIMITED",
"JATILESHWAR RICE MILLS PRIVATE LIMITED",
"JATIN AGRO FOODS PRIVATE LIMITED",
"JATIN AND COMPANY",
"JATIN BUILDTECH PRIVATE LIMITED",
"JATIN COTTON MILLS PRIVATE LIMITED",
"JATIN FOREX TOUR AND TRAVELS PRIVATE LIMITED",
"JATIN MALIK COUTURE LLP",
"JATIN STONES",
"JATINDRA MOHAN TEA COMPANY PVT LTD",
"JATINGA AGRO-TECH PVT LTD",
"JATINGA TEA LTD",
"JATNI COLLEGE JATNI",
"JATO DYNAMICS INDIA PRIVATE LIMITED",
"JATO GARMENTS PRIVATE LIMITED",
"JATRANA MERCANTILE PRIVATE LIMITED",
"JATSON POWER PRIVATE LIMITED",
"JATTASHANKAR INDUSTRIES LIMITED",
"JATTI ENGINEERING INDIA PRIVATE LIMITED",
"JAU CHEMTECH PRIVATE LIMITED",
"JAUHARI PRINTERS PRIVATE LIMITED",
"JAUNTY LOGISTICS SOLUTIONS PRIVATE LIMITED",
"JAURA INFRATECH PRIVATE LIMITED",
"JAUSHNA STEELS INDIA PRIVATE LIMITED",
"JAVA OFFICE & HOSPITALITY",
"JAVA R AND D PRIVATE LIMITED",
"JAVA TRAVEL & HOSPITALITY PRIVATE LIMITED",
"JAVA WEALTH SOLUTION PRIVATE LIMITED",
"JAVAHARAT EXPORTS PRIVATE LIMITED",
"JAVALI AUTOMOBILES PRIVATE LIMITED",
"JAVERI FISCAL SERVICES LIMITED",
"JAVI FORWARD ENTERPRISES PRIVATE LIMITED",
"JAVI HOME PRIVATE LIMITED",
"JAVI INFRATECH PRIVATE LIMITED",
"JAVI SYSTEMS INDIA PRIVATE LIMITED",
"JAVIER MANAGEMENT SERVICE PRIVATE LIMITED",
"JAVIN CONSTRUCTION PRIVATE LIMITED",
"JAVIN IT SERVICES PRIVATE LIMITED",
"JAVIS METALS PRIVATE LIMITED",
"JAVIS TECHNOLOGIES PRIVATE LIMITED",
"JAVITRI DEVI SHEETGRAH PRIVATE LIMITED",
"JAVITRI TEST-TUBE BABY CENTRE PRIVATE LIMITED",
"JAWA PHARMACEUTICALS INDIA PRIVATE. LIMITED",
"JAWA PLASTECH PRIVATE LIMITED",
"JAWAD ALI SHAH IMAMBARA GIRLS POST GRADUATE COLLEGE GORAKHPUR",
"JAWADWALAS CONSTRUCTIONS PRIVATE LIMITED",
"JAWAHAR ARTS SCIENCE & COMMERCE COLLEGE ANADUR",
"JAWAHAR CUSTOM HOUSE NHAVA SHEVA",
"JAWAHAR HIGH SCHOOL",
"JAWAHAR HIGHER SEC VIDYA MANDIR SCHOOL NIRGUNDI BEED",
"JAWAHAR HIGHER SECONDARY SCHOOL SAHARANPUR",
"JAWAHAR INTER COLLEGE SHITALKUND AGRA",
"JAWAHAR LAL JAIN STEELS PRIVATE LIMITED",
"JAWAHAR LAL NEHRU CANCER HOSPITAL",
"JAWAHAR LAL NEHRU CANCER HOSPITAL AND RESEARCH CENTRE",
"JAWAHAR LAL NEHRU DISTRICT HOSPITAL",
"JAWAHAR LEATHER WORKS PRIVATE LIMITED",
"JAWAHAR NAVODAYA VIDYALAYA",
"JAWAHAR NAVODAYA VIDYALAYA C K DAM DIST DEWAS (MP)",
"JAWAHAR PRIMARY SCHOOL LATUR",
"JAWAHAR SPINNERS PRIVATE LIMITED",
"JAWAHAR TRADING COMPANY PVT LTD",
"JAWAHAR VIDHYALAYA INTER COLLEGE",
"JAWAHAR VIDYA BHAVAN",
"JAWAHARLAL INSTITUTE OF POSTGRADUATE MEDICAL EDUCATION AND RESEARCH",
"JAWAHARLAL INSTITUTE OF TECHNOLOGY AND MANAGEMENT",
"JAWAHARLAL NEHRU ARCHITECTURE AND FINE ARTS UNIVERSITY",
"JAWAHARLAL NEHRU CENTRE FOR ADVANCE SCIENTIFIC RESEARCH",
"JAWAHARLAL NEHRU ENGINEERING COLLEGE",
"JAWAHARLAL NEHRU INST OF DEVP BANKING",
"JAWAHARLAL NEHRU INSTITUTE OF ADVANCED STUDIES SCHOOL OF PLANNING AND ARCHITECTURE",
"JAWAHARLAL NEHRU KRISHI VISHWA VIDYALAYA JABALPUR",
"JAWAHARLAL NEHRU NATIONAL COLLEGE OF ENGINEERING",
"JAWAHARLAL NEHRU PORT AUTHORITY",
"JAWAHARLAL NEHRU PORT TRUST",
"JAWAHARLAL NEHRU SAHAKARI AGRICULTURE PRODUCE PROCESSING",
"JAWAHARLAL NEHRU TECHNOLOGICAL UNIVERSITY ANANTAPUR",
"JAWAHARLAL NEHRU TECHNOLOGICAL UNIVERSITY HYDERABAD",
"JAWAHARLAL NEHRU UNIVERSITY",
"JAWAHARLAL NEHRU VIDYALAYA NAGPUR",
"JAWAHARLAL VIDYALAYA",
"JAWAHARSONS ENTERPRISES PRIVATE LIMITED",
"JAWAHER INTER COLLEGE",
"JAWALA COKE PRIVATE LIMITED",
"JAWALA FASTENERS PRIVATE LIMITED",
"JAWALA HYDRO POWER PRIVATE LIMITED",
"JAWALA IMPEX PRIVATE LIMIED",
"JAWALA PARSHAD AND COMPANY PRIVATE LIMITED",
"JAWALA PARSHAD JWELLERS PRIVATE LIMITED",
"JAWALA TRADING PRIVATE LIMITED",
"JAWALA WAREHOUSE PRIVATE LIMITED",
"JAWAN FACILITY MANAGEMENT",
"JAWAN GUARDING SERVICES PRIVATE LIMITED",
"JAWANDAMAL DHANNAMAL",
"JAWANDSONS PRIVATE LIMITED",
"JAWED HABIB HAIR & BEAUTY SALON",
"JAWED HABIB HAIR AND BEAUTY LIMITED",
"JAWED HABIB HAIR AND BEAUTY STUDIO PRIVATE LIMITED",
"JAWLA ADVANCE TECHNOLOGY LLP",
"JAWLA ENGINEERING PRIVATE LIMITED",
"JAWS INFRASYSTEMS PRIVATE LIMITED",
"JAXRANE REMEDIES PRIVATE LIMITED",
"JAXX VITRIFIED PRIVATE LIMITED",
"JAY & B TECH PRIVATE LIMITED",
"JAY AAR GOLD PRIVATE LIMITED",
"JAY AAY ALLOYS PRIVATE LIMITED",
"JAY ACE TECHNOLOGIES LIMITED",
"JAY AIR COOLING PRIVATE LIMITED",
"JAY AIR SYSTEMS PRIVATE LIMITED",
"JAY AMAR AUTO",
"JAY AMBAY AGRO FOODS PRIVATE LIMITED",
"JAY AMBE CORPORATION",
"JAY AMBE INTEDRNATIONAL SCHOOL",
"JAY AMBE PIPES PRIVATE LIMITED",
"JAY AMBE SUPERMARKETS PRIVATE LIMITED",
"JAY AMBE TRANSPORT PRIVATE LIMITED",
"JAY AMBEY EMBROIDERY PRIVATE LIMITED",
"JAY AMBEY FILAMENT PRIVATE LIMITED",
"JAY AMBIKA SHIKSHAN PRASARAK MADAL'S K. BHIVSING FATTU PAWAR MADHYAMKI VIDYALAYA",
"JAY AND CO INDIA PRIVATE LIMITED",
"JAY BABA BAKRESWAR RICE MILL PRIVATE LIMITED",
"JAY BAJRANG COTTON INDUSTRIES",
"JAY BAJRANG MADHYAMIK VIDYALAY TAPOWAN ROAD AHEMDNAGAR",
"JAY BALAJI CONSTRUCTION",
"JAY BALAJI HARDWARE PRIVATE LIMITED",
"JAY BALAJI POLYTECH INDUSTRIES PRIVATE LIMITED",
"JAY BALAJI TRADERS",
"JAY BEE AUTO AGENCIES PRIVATE LIMITED",
"JAY BEE LAMINATIONS LIMITED",
"JAY BEE LAMINATIONS PRIVATE LIMITED",
"JAY BEE TEXKNITS PRIVATE LIMITED",
"JAY BHARAT COLLEGE OF PHARMACY",
"JAY BHARAT FOOD PROCESS PRIVATE LIMITED",
"JAY BHARAT HIGHSCHOOL KOLHAPUR",
"JAY BHARAT MARUTI LIMITED",
"JAY BHARAT METCAST PRIVATE LIMITED",
"JAY BHARAT SPICES PRIVATE LIMITED",
"JAY BHAVANI AGRIMACH PRIVATE LIMITED",
"JAY BHAVANI MINECHEM PRIVATE LIMITED",
"JAY BHAVANI VADAPAV PRIVATE LIMITED",
"JAY BHAWANI COAL FIELDS PRIVATE LIMITED",
"JAY BHAWANI SWEETS PRIVATE LIMITED",
"JAY BHOJAL TEXHUB PRIVATE LIMITED",
"JAY CEE CHEMISTS PRIVATE LIMITED",
"JAY CEE PUBLICATIONS PRIVATE LIMITED",
"JAY CEE PUNCHING SOLUTIONS PRIVATE LIMITED",
"JAY CHEMICAL INDUSTRIES LIMITED",
"JAY CHEMICAL INDUSTRIES PRIVATE LIMITED",
"JAY CHEMICALS",
"JAY COATINGS PRIVATE LIMITED",
"JAY CONSTRUCTION INDIA",
"JAY CONTAINER SERVICES CO PRIVATE LIMITED",
"JAY COPPER & ALLOYS PRIVATE LIMITED",
"JAY DEE BIO TECH LIMITED",
"JAY DEE FABRICS LIMITED",
"JAY DEE LEATHER PRIVATE LIMITED",
"JAY DEV CIVILCON INDIA PRIVATE LIMITED",
"JAY DHEEP TECHNO ENTERPRISESS PRIVATE LIMITED",
"JAY DIAM PRIVATE LIMITED",
"JAY DISTRIBUTORS PRIVATE LIMITED",
"JAY DURGA INDUSTRIAL SECURITY PRIVATE LIMITED",
"JAY DURGA MULTITECH PRIVATE LIMITED",
"JAY DWARKADHISH GINNING & OIL INDUSTRIES",
"JAY ELASTOMERS PRIVATE LIMITED",
"JAY ELL HEALTHCARE PRIVATE LIMITED",
"JAY EMM GASES PRIVATE LIMITED",
"JAY ENTERPRISE",
"JAY ENVIRONMENTAL INFRASTRUCTURE PRIVATE LIMITED",
"JAY EQUIPMENT AND SYSTEMS PRIVATE LIMITED",
"JAY ESS SADDLES PRIVATE LIMITED",
"JAY EXCAVATORS PRIVATE LIMITED",
"JAY FOODS AND COLD STORAGE PRIVATE LIMITED",
"JAY FORMULATIONS LIMITED",
"JAY GANESH AUTOMOBILES PRIVATE LIMITED",
"JAY GAURI PROJECTS (INDIA) PVT. LTD.",
"JAY GEE PLASTICS PRIVATE LIMITED",
"JAY GOPAL HOSIERY AND GARMENTS PRIVATE LIMITED",
"JAY GURU PARBOILED RICE MILL PRIVATE LIMITED",
"JAY GURUDEV POLYPACK PRIVATE LIMITED",
"JAY HANUMAN CHAWAL UDYOG PRIVATE LIMITED",
"JAY HIND COMMODITY PRIVATE LIMITED",
"JAY IBER PRIVATE LIMITED",
"JAY INDUSTRIAL CHEMICALS PRIVATE LIMITED",
"JAY INSTRUMENTS AND SYSTEMS PRIVATE LIMITED",
"JAY IRON AND STEELS INDUSTRIES LIMITED",
"JAY IRON AND STEELS LIMITED",
"JAY JAGANNATH INFRA-DEVELOPERS PRIVATE LIMITED",
"JAY JAGANNATH REROLLING & STEELS PRIVATE LIMITED",
"JAY JAGANNATH STEEL AND POWER LIMITED",
"JAY JAGDAMBA FORGINGS PRIVATE LIMITED",
"JAY JAGDAMBA LIMITED",
"JAY JAGDAMBA PROFILE PRIVATE LIMITED",
"JAY JALARAM HARDWARES PRIVATE LIMITED",
"JAY JALARAM QUARRY WORKS PRIVATE LIMITED",
"JAY JALARAM TECHNOLOGIES LIMITED",
"JAY JAY MILLS INDIA PRIVATE LIMITED",
"JAY JAYKAR ENTERPRISE",
"JAY JINENDRA REALATORS PRIVATE LIMITED",
"JAY JOTHI FOODS PRIVATE LIMITED",
"JAY KANHA FRESH DAIRY (OPC) PRIVATE LIMITED",
"JAY KAY COIR FOAM PRIVATE LIMITED",
"JAY KAY DEE HEALTHCARE PRIVATE LIMITED",
"JAY KAY HOSIERY MILLS PRIVATE LIMITED",
"JAY KAY LOAN HOSPITAL - JAIPUR",
"JAY KAY TRUST ( MAA VAISHNO DEVI DHAM)",
"JAY KAY WEARS PVT LTD",
"JAY KHODIYAR COTTON PRIVATE LIMITED",
"JAY KHODIYAR MANUFACTURE",
"JAY KHODIYAR TOUGHENED GLASS PRIVATE LIMITED",
"JAY KUMAR & CO SALES PRIVATE LIMITED",
"JAY LABEL TECH PRIVATE LIMITED",
"JAY LAXMI POLY PLAST",
"JAY LAXMI TEXPRINTS PRIVATE LIMITED",
"JAY LIGHTING PRIVATE LIMITED",
"JAY MAMRA PRIVATE LIMITED",
"JAY MARKET CREATORS PVT LTD",
"JAY MATA GLASS AGENCY PRIVATE LIMITED",
"JAY MELDI BUS SERVICE PRIVATE LIMITED",
"JAY METAL",
"JAY MOTORS",
"JAY 'N' JAY HOARDING COMPANY PRIVATE LIMITED",
"JAY NIKKI INDUSTRIES LIMITED",
"JAY OFFSET (GUJARAT) PRIVATE LIMITED",
"JAY OM PRIVATE LIMITED",
"JAY OVERSEAS PRIVATE LIMITED",
"JAY PARSHWA INFRASTRUCTURE PRIVATE LIMITED",
"JAY PARVATI COLD STORAGE",
"JAY PEE CHEMICALS PRIVATE LIMITED",
"JAY PEE STAINLESS PRIVATE LIMITED",
"JAY PESTICIDES PRIVATE LIMITED",
"JAY PRECISION PHARMACEUTICALS PRIVATE LIMITED",
"JAY PRECISION PRODUCTS (INDIA) PRIVATE LIMITED",
"JAY PRESTRESSED PRODUCTS LTD",
"JAY PROPERTIES PRIVATE LIMITED",
"JAY PUMPS PRIVATE LIMITED",
"JAY RAPID RUBBER PRIVATE LIMITED",
"JAY RENEWABLE ENERGY PRIVATE LIMITED",
"JAY ROAD CARRIERS PRIVATE LIMITED",
"JAY RUBCHEM PRIVATE LIMITED",
"JAY SANTOSHI TEX PRINTS PRIVATE LIMITED",
"JAY SHANKAR AGRO INPUTS PRIVATE LIMITED",
"JAY SHREE CEMENT PRIVATE LIMITED",
"JAY SHREE MACHINES PRIVATE LIMITED",
"JAY SHREE MAHAKAL TRADING COMPANY",
"JAY SHREE PADDY PROCESSORS PRIVATE LIMITED",
"JAY SHREE PULSES PRIVATE LIMITED",
"JAY SHREE RAM UNNATI DEVELOPERS AND INFRATECH PRIVATE LIMITED",
"JAY SHREE SHYAM SURGICAL COTTON PRIVATE LIMITED",
"JAY SHREE SOLVEX (INDIA) PRIVATE LIMITED",
"JAY SIDDHARTH EXPORTS PRIVATE LIMITED",
"JAY SONS APPLIANCES PVT LTD",
"JAY STORAGE SOLUTIONS PRIVATE LIMITED",
"JAY STREET INVESTMENT ADVISORS PRIVATE LIMITED",
"JAY SWITCHES INDIA PRIVATE LIMITED",
"JAY TANKS AND VESSELS PRIVATE LIMITED",
"JAY TEXFAB PRIVATE LIMITED",
"JAY THAKURJI MULTIMETALS PRIVATE LIMITED",
"JAY UMIYA INDUSTRIES",
"JAY USHIN LIMITED",
"JAY VEE TEXTILES PRIVATE LIMITED",
"JAY VIJAY PRINTS PVT LTD",
"JAY WATER LIMITED",
"JAY WATER MANAGEMENT PRIVATE LIMITED",
"JAY X-RAY AND IMAGING PRIVATE LIMITED",
"JAYA AROGYA HOSPITAL",
"JAYA BHARAT EQUIPMENTS PRIVATE LIMITED",
"JAYA BHUSHAN HOSPITALS PVT.LTD.",
"JAYA CHICKIES CO PVT LTD",
"JAYA COCONUT OIL PRIVATE LIMITED",
"JAYA ENGINEERING COLLEGE",
"JAYA GROUP OF INSTITUTIONS",
"JAYA HIND INDSTRIES LIMITED",
"JAYA HIND INDUSTRIES PRIVATE LIMITED",
"JAYA HIND MECHANICS LIMITED",
"JAYA HIND MONTUPET PRIVATE LIMITED",
"JAYA HOSPITAL",
"JAYA HOSPITALS",
"JAYA HOUSEHOLD PRODUCTS PRIVATE LIMITED",
"JAYA HUME PIPES PRIVATE LIMITED",
"JAYA INDUSTRIES PRIVATE LIMITED",
"JAYA INFRAPROJECTS PRIVATE LIMITED",
"JAYA INSTITUTE OF TECHNOLOGY",
"JAYA LAKSHMI AGENCIES PRIVATE LIMITED",
"JAYA LAXMI FREIGHT FORWARDERS PRIVATE LIMITED",
"JAYA LEASING AND FINANCE PRIVATE LIMITED",
"JAYA MAHABIR FOOD PRODUCTS AND RICE MILL PRIVATE LIMITED",
"JAYA MICROMINERALS PRIVATE LIMITED",
"JAYA NACHIAR TEXTILE MILLS PRIVATE LIMITED",
"JAYA NUTRITIONS PRIVATE LIMITED",
"JAYA PARAMESWARY CONSTRUCTIONS PRIVATE LIMITED",
"JAYA SEA FOODS PRIVATE LIMITED",
"JAYA SHREE TEXTILES",
"JAYA SURGICAL AND PHARMA PRIVATE LIMITED",
"JAYA VAIRAVAN BRICK PRIVATE LIMITED",
"JAYA VELU SPINNING MILLS PRIVATE LIMITED",
"JAYA VIN TRAVELS PRIVATE LIMITED",
"JAYAA SREE TEXTILES PRIVATE LIMITED",
"JAYAAM GALVANIZERS PRIVATE LIMITED",
"JAYAANSH INDIA PRIVATE LIMITED",
"JAYAAR INFRAVENTURES PRIVATE LIMITED",
"JAYABEN B KHOT ENG PRI PRIMARY SCHOOL",
"JAYABHARATH DEVELOPERS INDIA LIMITED",
"JAYABHARATHAM FURNITURE & APPLIANCES PRIVATE LIMITED",
"JAYABHERI AUTOMOTIVES PRIVATE LIMITED",
"JAYABHERI ENTERTAINMENTS PRIVATE LIMITED",
"JAYABHERI PROPERTIES & SERVICES PRIVATE LIMITED",
"JAYABHERI PROPERTIES PRIVATE LIMITED",
"JAYACHANDRA BEARINGS INDIA PRIVATE LIMITED",
"JAYACHANDRA TEXTILES PRIVATE LIMITED",
"JAYACHANDRAN ALLOYS PRIVATE LIMITED",
"JAYACHANDRAN INDUSTRIES PRIVATE LIMITED",
"JAYACHITRA HR SOLUTIONS PRIVATE LIMITED",
"JAYADARSINI HOUSING PRIVATE LIMITED",
"JAYADEV BIOFUELS PRIVATE LIMITED",
"JAYADEV MEMORIAL RASHTROTTHANA HOSPITAL AND RESEARCH CENTRE",
"JAYADI TECHMAC PRIVATE LIMITED",
"JAYADITYA INFRA BUILDERS PRIVATE LIMITED",
"JAYAJEYA AGRO FOOD PRODUCTS PRIVATE LIMITED",
"JAYAKANTH RUBBER PRODUCTS PRIVATE LIMITED",
"JAYAKAR AND PARTNERS",
"JAYAKRISHNA FLOUR MILLS PRIVATE. LIMITED",
"JAYAKRISHNA PESTICIDES PRIVATE LIMITED",
"JAYAKUMARI LOGISTICS PRIVATE LIMITED",
"JAYAKWADI IRRIGATION DIV",
"JAYAKWADI IRRIGATION DIV NATHNAGAR NORTH PAITHAN",
"JAYALAKSHMI AUTO ENTERPRISES PRIVATE LIMITED",
"JAYALAKSHMI AUTOMOTIVES PRIVATE LIMITED",
"JAYALAKSHMI BIKES PRIVATE LIMITED",
"JAYALAKSHMI EXPORTS & IMPORTS PRIVATE LIMITED",
"JAYALAKSHMI SEA FOODS PRIVATE LIMITED",
"JAYALAKSHMI SILKS PVT LTD",
"JAYALAKSHMI SPINTEX (INDIA) PRIVATE LIMITED",
"JAYALAKSHMI TEXTILES PRIVATE LIMITED",
"JAYALAKSHMI WEAVING MILL INDIA PRIVATE LIMITED",
"JAYALAXMI ENTERPRISES",
"JAYALAXMI POLY PACKS PRIVATE LIMITED",
"JAYALEELA CORPORATION PRIVATE LIMITED",
"JAYAM ACADEMY",
"JAYAM EDUCATIONAL HEALTH AND CHARITABLE TRUST",
"JAYAM FRUIT PRODUCTS PRIVATE LIMITED",
"JAYAM INFRATECH PRIVATE LIMITED",
"JAYAM PROJECTS PRIVATE LIMITED",
"JAYAM SAND & GRAVELS PRIVATE LIMITED",
"JAYAM SOLUTIONS PRIVATE LIMITED",
"JAYAM VIDHYALAYA MATRICULATION HIGHER SECONDARY SCHOOL",
"JAYAM VINIYOG & MERCANTILES PVT. LTD.",
"JAYAMAHAL COLLEGE",
"JAYAMATHA TECHNOLOGICAL CENTRE PRIVATE LIMITED",
"JAYAMAYFLOWER HOSPITALITY PRIVATE LIMITED",
"JAYAMUKHI INSTITUTE OF TECHNOLOGICAL SCIENCES",
"JAYAMURUGAN AGENCIES PRIVATE LIMITED",
"JAYAN AUTO PRIVATE LIMITED",
"JAYANAND ENGINEERING PRIVATE LIMITED",
"JAYANAND KHIRA AND COMPANY PVT LTD",
"JAYANATH AGRI FARMS PRIVATE LIMITED",
"JAYANITA EXPORTS PRIVATE LIMITED",
"JAYANITA EXPORTS PRIVATE LTD.",
"JAYANT CHEMICALS WORKS PVT LTD",
"JAYANT DAL MILLS PRIVATE LIMITED",
"JAYANT ENGINEERING AND MARKETING PVT LTD",
"JAYANT FINVEST LIMITED",
"JAYANT IMPEX PRIVATE LIMITED",
"JAYANT INFRATECH LIMITED",
"JAYANT INFRATECH PRIVATE LIMITED",
"JAYANT JAGGERY PRODUCTS PRIVATE LIMITED",
"JAYANT K FURNISHERS",
"JAYANT LOGISTICS PRIVATE LIMITED",
"JAYANT MARKETING PRIVATE LIMITED",
"JAYANT MINERALS PRIVATE LIMITED",
"JAYANT PACKAGING PRIVATE LIMITED",
"JAYANT ROLLERS PRIVATE LIMITED",
"JAYANT SHARE BROKING PRIVATE LIMITED",
"JAYANT SNACKS AND BEVERAGES PRIVATE LIMITED",
"JAYANT SPECIALITIES PRIVATE LIMITED",
"JAYANT VENTURES PRIVATE LIMITED",
"JAYANTA FANZEN LIGHTING INDUSTRIES PRIVATE LIMITED",
"JAYANTA LAMP INDUSTRIES PVT LTD",
"JAYANTH INDUSTRIES",
"JAYANTH LIFE SCIENCES PRIVATE LIMITED",
"JAYANTH PHARMACEUTICALS PRIVATE LIMITED",
"JAYANTI AGRILAND PRIVATE LIMITED",
"JAYANTI CONTRACTORS AND ENGINEERS LIMITED",
"JAYANTI FILMS (INDIA)PVT LTD",
"JAYANTI MOTORS PRIVATE LIMITED",
"JAYANTI PRASAD JEEVAN LAL JAIN JEWELLERS PRIVATE LIMITED",
"JAYANTI PRASAD JEEVAN LAL JAIN SARRAF PRIVATE LIMITED",
"JAYANTI REAL ESTATE DEVELOPERS PRIVATE LIMITED",
"JAYANTI TEA PRIVATE LIMITED",
"JAYANTILAL J GANDHI CHEMICALS PRIVATE LIMITED",
"JAYANTISUPER CONSTRUCTION PRIVATE LIMITED",
"JAYAPRIYA CHIT FUNDS PRIVATE LIMITED",
"JAYAPRIYA FOOD PRODUCTS PRIVATE LIMITED",
"JAYAPRIYA NIDHI LIMITED",
"JAYAPRIYA VIDYALAYA MATRIC HR SEC SCHOOL",
"JAYARAJ FORTUNE PACKAGING PRIVATE LIMITED",
"JAYARAJ INTERNATIONAL PRIVATE LIMITED",
"JAYARAJ TRUCKS & BUSES PRIVATE LIMITED",
"JAYARAM ENGINEERING WORKS",
"JAYARAM HOTELS PRIVATE LIMITED",
"JAYARANI MATRICULATION HIGHER SECONDARY SCHOOL",
"JAYARANI SPINNING MILLS LIMITED",
"JAYAS VENTURES PRIVATE LIMITED",
"JAYASAN INFOWARE PRIVATE LIMITED",
"JAYASHANKAR AGRICULTURAL UNIVERSITY",
"JAYASHI TIMBERKON PRIVATE LIMITED",
"JAYASHI WOODKON PRIVATE LIMITED",
"JAYASHRE MILLS PRIVATE LIMITED",
"JAYASHREE",
"JAYASHREE ASSOCIATES INDIA PRIVATE LIMITED",
"JAYASHREE ELECTRODEVICES PVT LTD",
"JAYASHREE ELECTRON PRIVATE LIMITED",
"JAYASHREE ENCODERS PRIVATE LIMITED",
"JAYASHREE GROCERY & DRY FRUITS PRIVATE LIMITED",
"JAYASHREE HOROLOGICALS PRIVATE LIMITED",
"JAYASHREE POLYMER EXPORTS PRIVATE LIMITED",
"JAYASHREE POLYMERS PRIVATE LIMITED",
"JAYASHREE TUBESTECH COMPONENT PRIVATE LIMITED",
"JAYASHREE WEAVES INDIA PRIVATE LIMITED",
"JAYASURIYA AERO PRIVATE LIMITED",
"JAYASWAL ENTERPRISES PRIVATE LIMITED",
"JAYASWAL NECO INDUSTRIES LIMITED",
"JAYASWAL NECO POWER PRIVATE LIMITED",
"JAYASWATHY CONSTRUCTIONS PRIVATE LIMITED",
"JAYATHI KRISHNA HEALTH CARE PRIVATE LIMITED",
"JAYATHIREES BUSINESS SOLUTIONS PRIVATE LIMITED",
"JAYATI AGRENUTRITION PRIVATE LIMITED",
"JAYATMA COTTON LIMITED",
"JAYATMA INDUSTRIES LIMITED",
"JAYATMA TECHNOLOGIES PRIVATE LIMITED",
"JAYAVARDHINI LAND DEVELOPERS PRIVATE LIMITED",
"JAYAVARMA TEXTILES PRIVATE LIMITED",
"JAYAWANT INSTITUTE OF MANAGEMENT STUDIES",
"JAYAWANTRAO SAWANT INSTITUTE OF MANAGEMENT AND REASERCH",
"JAYAWANTRAO SAWANT POLYTECHNIC",
"JAYBAJRANG AGRO PROCESSING PRIVATE LIMITED",
"JAYBALMIT BROTHERS (OPC) PRIVATE LIMITED",
"JAYBANAS METALS PRIVATE LIMITED",
"JAYBEE APPARELS PVT LTD",
"JAYBEE DRILLING PRIVATE LIMITED",
"JAYBEE INDUSTRIES",
"JAYBEEAR INVESTMENT AND FINANCE PRIVATE LIMITED",
"JAYBHARAT DYEING AND PRINTING PRIVATE LIMITED",
"JAYBHARAT ENERGY PRIVATE LIMITED",
"JAYBHARAT POWER PRIVATE LIMITED",
"JAYBHAVANI HIGHSCHOOL GAURGAON",
"JAYBHAWANI PRESS PRIVATE LIMITED",
"JAYCEE ADS PRIVATE LIMITED",
"JAYCEE AUTOFAB PRIVATE LIMITED",
"JAYCEE AUTOMOBILES PRIVATE LIMITED",
"JAYCEE BUILDCORP LLP",
"JAYCEE ENGINEERING PRIVATE LIMITED",
"JAYCEE EQUIPMENT PRIVATE LIMITED",
"JAYCEE HOUSING PRIVATE LIMITED",
"JAYCEE MOTORS PRIVATE LIMITED",
"JAYCEE RESOURCES PRIVATE LIMITED",
"JAYCEE STRIPS AND FASTNERS PRIVATE LIMITED",
"JAYCEE TECHNOLOGIES PRIVATE LIMITED",
"JAYCHEM ENTERPRISE PRIVATE LIMITED",
"JAYCO AGENCIES PRIVATE LIMITED",
"JAYCO DIAGOLD JEWELS PRIVATE LIMITED",
"JAYCO SAFETY PRODUCTS PRIVATE LIMITED",
"JAYDEE ELECTRONICS PRIVATE LIMITED",
"JAYDEE INTERNATIONAL PRIVATE LIMITED",
"JAYDEEP ASSOCIATES PRIVATE LIMITED",
"JAYDEEP CHEM FOOD PRIVATE LIMITED",
"JAYDEEP COTTON FIBRES PRIVATE LIMITED",
"JAYDEEP ELECTRIC INDIA PVT.LTD.",
"JAY-DEEP PROFILES PRIVATE LIMITED",
"JAYDEEP TOURS AND TRAVELS PRIVATE LIMITED",
"JAYDEEP TUBES PRIVATE LIMITED",
"JAYDEN AUTO WHEELS PRIVATE LIMITED",
"JAYDEN HEALTHCARE PRIVATE LIMITED",
"JAYDEN INTERNATIONAL TRADERS PRIVATE LIMITED",
"JAYDEV COLLEGE OF PHARMACEUTICALS SCIENC",
"JAYDEV REALTORS PRIVATE LIMITED",
"JAYDURGA DECOR PRIVATE LIMITED",
"JAYDURGA GINNING MILLS PRIVATE LIMITED",
"JAYELBEE FOOD PROCESSORS PRIVATE LIMITED",
"JAYEM AUTOMOTIVES PRIVATE LIMITED",
"JAYEM LOGISTICS PRIVATE LIMITED",
"JAYEM RECORDS AND DATA PRIVATE LIMITED",
"JAYEM SECURITIES PRIVATE LIMITED",
"JAYEM TRADE PRIVATE LIMITED",
"JAYEMS ENGINEERING COMPANY PRIVATE LIMITED",
"JAYEN ELECTROLINKS PRIVATE LIMITED",
"JAYER INDIA PVT LTD",
"JAYESH A DALAL PLANNING & ENGINEERING SERVICES PRIVATE LIMITED",
"JAYESH FOREX PRIVATE LIMITED",
"JAYESH INDUSTRIAL SUPPLIERS PRIVATE LIMITED",
"JAYESH INDUSTRIES LIMITED",
"JAYESH INFRASTRUCTURE & PROJECTS PRIVATE LIMITED",
"JAYESH INTERPRISES",
"JAYESH LOGISTICS PRIVATE LIMITED",
"JAYESH PULSE PRODUCTS PVT LTD",
"JAYESH STEEL PRIVATE LIMITED",
"JAYESH STEEL PROCESSORS PRIVATE LIMITED",
"JAYESH TEX FAB PRIVATE LIMITED",
"JAYESH TRADEX PRIVATE LIMITED",
"JAYESHJAGRUTI DEVELOPERS PRIVATE LIMITED",
"JAYESS PRIDE PRIVATE LIMITED",
"JAYESS ROADLINK PRIVATE LIMITED",
"JAYGANESH MACHINERY PRIVATE LIMITED",
"JAYGARMENTS INDIA PRIVATE LIMITED",
"JAYGEE HOSPITALITY SERVICES PRIVATE LIMITED",
"JAYGURU ENGINEERING WORKS PRIVATE LIMITED",
"JAYH BUILDTECH PRIVATE LIMITED",
"JAYHIDA MEDICARE PRIVATE LIMITED",
"JAYINE MULTITRADE PRIVATE LIMITED",
"JAYJAY TRENDZ PRIVATE LIMITED",
"JAYJEE PLASTIFILM PRIVATE LIMITED",
"JAYKA HOLDINGS AND INFRASTRUCTURE PRIVATE LIMITED",
"JAYKAL EXPORTS PRIVATE LIMITED",
"JAYKALP TRADE-LINK PRIVATE LIMITED",
"JAYKAMAL STOCKBROKERS PRIVATE LIMITED",
"JAYKAY ENTERPRISES LIMITED",
"JAYKAY FREIGHTERS PRIVATE LIMITED",
"JAYKAYPUR INFRASTRUCTURE & HOUSING LIMITED",
"JAY-KET SECURITIES AND FINANCE PRIVATE LIMITED",
"JAYKISAN CROP CARE (OPC) PRIVATE LIMITED",
"JAYKISHAN FIBRE PRIVATE LIMITED",
"JAYKO METALLIC ENGINEERING PRIVATE LIMITED",
"JAYKOND BIOSEEDS PRIVATE LIMITED",
"JAYLEE BIOTECH PRIVATE LIMITED",
"JAYLEELA IMPEX PRIVATE LIMITED",
"JAYLINK OVERSEAS PVT LTD",
"JAYMAA AMBEY BUILDING SOLUTIONS PRIVATE LIMITED",
"JAYMAA TRANSPORT MINING AND SUPPLIES PRIVATE LIMITED",
"JAYMALA INFRASTRUCTURE PRIVATE LIMITED",
"JAYMAN DEALER PVT LTD",
"JAYMAN TEXTILES PRIVATE LIMITED",
"JAYMANGAL PETROCHEM PRIVATE LIMITED",
"JAYMATAJI BATTERY PRIVATE LIMITED",
"JAYMCO POLYMERS PRIVATE LIMITED",
"JAYMEET REALTY PRIVATE LIMITED",
"JAYMIT SECURITY SYSTEMS PRIVATE LIMITED",
"JAYNA CLOSURES PRIVATE LIMITED",
"JAYNA PACKAGING PRIVATE LIMITED",
"JAYNA TRADERS PRIVATE LIMITED",
"JAYNAGAR INSTITUTION",
"JAYNI PROJECTS LIMITED",
"JAYNIX ENGINEER PRIVATE LIMITED",
"JAYNIX ENGINEERING PRIVATE LIMITED",
"JAYON IMPLANTS PRIVATE LIMITED",
"JAYON MEDICAL DEVICES PRIVATE LIMITED",
"JAYOSTUTE INDUSTRIES PRIVATE LIMITED",
"JAYPEE ALLOY & CASTINGS PRIVATE LIMITED",
"JAYPEE ALLOY & STEELS LTD.",
"JAYPEE BROTHERS MEDICAL PUBLISHERS PRIVATE LIMITED",
"JAYPEE CAPITAL SERVICES LIMITED",
"JAYPEE CEMENT CORPORATION LIMITED",
"JAYPEE CONTAINER LINE PRIVATE LIMITED",
"JAYPEE DEALER PVT LTD",
"JAYPEE ENGINEERING & HYDRAULIC EQUIPMENT COMPANY LIMITED",
"JAYPEE HEALTHCARE LIMITED",
"JAYPEE HOSPITAL",
"JAYPEE HOTELS",
"JAYPEE INDIA LIMITED",
"JAYPEE INFOMEDIA PRIVATE LIMITED",
"JAYPEE INFRA VENTURES PRIVATE LIMITED",
"JAYPEE INFRATECH LIMITED",
"JAYPEE INSTITUTE OF INFORMATION TECHNOLOGY",
"JAYPEE MERCHANDISE PRIVATE LIMITED",
"JAYPEE PHARMA CUSTOMISED IMPRINTS PRIVATE LIMITED",
"JAYPEE POWERGRID LIMITED",
"JAYPEE PROJECTS LIMITED",
"JAYPEE PUBLIC SCHOOL NOIDA",
"JAYPEECO INDIA PRIVATE LIMITED",
"JAYPORE E COMMERCE PRIVATE LIMITED",
"JAYPRAKRITI TOWNSHIPS PRIVATE LIMITED",
"JAYRAJ TEXTILE PARK PRIVATE LIMITED",
"JAYRAM INDUSTRIES (INDIA) PRIVATE LIMITED",
"JAYRAM SALES PRIVATE LIMITED",
"JAYRAM TEXTILES PRIVATE LIMITED",
"JAYRCON BUILDERS PRIVATE LIMITED",
"JAYSHAKTI SURGICALS PRIVATE LIMITED",
"JAYSHIV CHEMICALS PRIVATE LIMITED",
"JAYSHREE AROMATICS PRIVATE LIMITED",
"JAYSHREE AUTOMOBILES INDIA PRIVATE LIMITED",
"JAYSHREE AUTOTRADE PRIVATE LIMITED",
"JAYSHREE BUILDERS",
"JAYSHREE CARRIER PVT. LTD.",
"JAYSHREE CHEMICALS LIMITED",
"JAYSHREE FIBRE PRODUCTS LTD",
"JAYSHREE FINVEST LIMITED",
"JAYSHREE FLOUR AND FOOD PRIVATE LIMITED",
"JAYSHREE GRAIN PROCESSING PRIVATE LIMITED",
"JAYSHREE HARDWARES PRIVATE LIMITED",
"JAYSHREE INSTRUMENTS PRIVATE LIMITED",
"JAYSHREE KRIPA CEMENT PRIVATE LIMITED",
"JAYSHREE LOGISTICS PRIVATE LIMITED",
"JAYSHREE MACHINETOOLS PRIVATE LIMITED",
"JAYSHREE MARY HOSPITAL",
"JAYSHREE MOTORS PRIVATE LIMITED",
"JAYSHREE NIRMAN LTD",
"JAYSHREE PERIWAL GLOBAL SCHOOL",
"JAYSHREE PERIWAL HIGH SCHOOL",
"JAYSHREE PISTONS PRIVATE LIMITED",
"JAYSHREE PLYPOWER PRIVATE LIMITED",
"JAYSHREE SILK PROCESSING MILLS PVT LTD",
"JAYSHREE SWITCHGEARS PRIVATE LIMITED",
"JAYSHREE TEAK WOOD PRIVATE LIMITED",
"JAYSHREE TOOLS AND ASSEMBLIES PRIVATE LIMITED",
"JAYSHREE VYAPAR LIMITED",
"JAYSHRI DENIM MILLS PRIVATE LIMITED",
"JAYSHRI IMPEX",
"JAYSHRI PROPACK PRIVATE LIMITED",
"JAYSHRI WEAVETECH PRIVATE LIMITED",
"JAYSINGPUR ANGLO URDU HIGHSCOOL & JR COLLEGE JAYSINGPUR",
"JAYSINGPUR COLLEGE JAYSINGPUR",
"JAYSINGPUR MUNICIPAL CORPORATION",
"JAYSMITS FERTILIZERS PRIVATE LIMITED",
"JAYSONS AGRITECH PRIVATE LIMITED",
"JAYSONS AMMONIA AND CHEMICALS PRIVATE LIMITED",
"JAYSONS TRANSWAYS PRIVATE LIMITED",
"JAYSUKHLAL JAGJIVAN STOCK BROKING PRIVATE LIMITED",
"JAYSUN TECHNOCOATING PRIVATE LIMITED",
"JAYSWAL BUILDING PRODUCTS PRIVATE LIMITED",
"JAYSWAL INTERIORS PRIVATE LIMITED",
"JAYSYNTH DYESTUFF INDIA LIMITED",
"JAYSYNTH IMPEX LIMITED",
"JAYSYNTH IMPEX PRIVATE LIMITED",
"JAYTE INDUSTRIES PRIVATE LIMITED",
"JAYTEX DYES & INTERMEDIATES PRIVATE LIMITED",
"JAYTICK INTERMEDIATES PVT LTD",
"JAYV FOODS PRIVATE LIMITED",
"JAYVARUDI INFRACON PRIVATE LIMITED",
"JAYVEER ENTERPRISE PRIVATE LIMITED",
"JAYVIK FORESIGHT INNOVATIONS AND SOLUTIONS PRIVATE LIMITED",
"JAYWANT COLLEGE OF ENGINEERING AND POLYTECHNIC",
"JAYWANT NARHE TECHNICAL CAMPUS",
"JAYWANT SHIKSHAN PRASARAK MANDAL",
"JAYWANT SUGARS LIMITED",
"JAYWANTI TRADERS",
"JAYWIN PLASTECH PRIVATE LIMITED",
"JAYWIN REMEDIES PRIVATE LIMITED",
"JAZE NETWORKS PRIVATE LIMITED",
"JAZEERA TECHNOLOGIES PRIVATE LIMITED",
"JAZZ CINEMAS PRIVATE LIMITED",
"JAZZ MEDIA PRIVATE LIMITED",
"JAZZ TECHNICAL MANAGEMENT SERVICES OPC PRIVATE LIMITED",
"JAZZ TEXSTYLES",
"JAZZCON ENGINEERS PRIVATE LIMITED",
"JB AND SONS PRIVATE LIMITED",
"JB AUTOMOBILES PRIVATE LIMITED",
"JB AUTOMOTIVE PRIVATE LIMITED",
"JB DECORE PRIVATE LIMITED",
"JB ENTERPRISES PRIVATE LIMITED",
"JB EVEREST TECHNICAL SERVICES LLP",
"JB FABINFRA LIMITED",
"JB FOREX PRIVATE LIMITED",
"JB HEALTHCARE PRIVATE LIMITED",
"JB INSTITUTE OF ENGINEERING AND TECHNOLOGY",
"JB INTERTRADE CORP PRIVATE LIMITED",
"JB NAG WATER TECH PRIVATE LIMITED",
"JB OILS PRIVATE LIMITED",
"JB PLASTOCHEM PRIVATE LIMITED",
"JB POLYPACK PRIVATE LIMITED",
"JB ROLLING MILLS LIMITED",
"JB SECURITY SERVICES PRIVATE LIMITED",
"JB SKINCARE PRIVATE LIMITED",
"JB SOFT SYSTEM",
"JB TECHNOLOGIES PRIVATE LIMITED",
"JBA INFOSOLUTIONS PRIVATE LIMITED",
"JBB BUSINESS SOLUTIONS PRIVATE LIMITED",
"JBB INFRASTRUCTURES PRIVATE LIMITED",
"JBB MARKETING PRIVATE LIMITED",
"JBB PRODUCTS PRIVATE LIMITED",
"JBC AUTO TECH PRIVATE LIMITED",
"JBC ENTERPRISES PRIVATE LIMITED",
"JBC GARMENTS PRIVATE LIMITED",
"JBC HEALTHCARE & RESEARCH PRIVATE LIMITED",
"JBC MARINE SERVICES LLP",
"JBC PLYWOOD PRIVATE LIMITED",
"JBCG ADVISORY SERVICES PRIVATE LIMITED",
"JBCN INTERNATIONAL SCHOOL",
"JBD TRADING COMPANY PRIVATE LIMITED",
"JBEE TELECOMASSIST PRIVATE LIMITED",
"JBEL INDUSTRIES LIMITED",
"JBF INDUSTRIES LIMITED",
"JBFS ENGINEERING SYSTEMS PRIVATE LIMITED",
"JBG BIOFUELS PRIVATE LIMITED",
"JBG COLD STORAGE PRIVATE LIMITED",
"JBG ORGANISATION PRIVATE LIMITED",
"JBH SKILL CONSULTANTS PRIVATE LIMITED",
"JBI CONSTRUCTIONS PRIVATE LIMITED",
"JBIMEX PRIVATE LIMITED",
"JBJ COTTON INDIA PRIVATE LIMITED",
"JBJ INTERNATIONAL PRIVATE LIMITED",
"JBJ LAND PROMOTERS PRIVATE LIMITED",
"JBJ PERFUMES PRIVATE LIMITED",
"JBJ SECURITY SERVICES PRIVATE LIMITED",
"JBJ TECHNOLOGIES LIMITED",
"JBJM PARENTERALS PRIVATE LIMITED",
"JBK CONTROLS INDIA PRIVATE LIMITED",
"JBK INFOTECH PRIVATE LIMITED",
"JBL BUILDCON CO",
"JBL SAKS PRIVATE LIMITED",
"JBLD INTERNATIONAL PRIVATE LIMITED",
"JBM AUTO LIMITED",
"JBM AUTO SYSTEM PRIVATE LIMITED",
"JBM CADMIUM PRIVATE LIMITED",
"JBM ENERGY RESOURCES PRIVATE LIMITED",
"JBM ENTERPRISES",
"JBM ENVIRONMENT MANAGEMENT PRIVATE LIMITED",
"JBM EV TECHNOLOGIES PRIVATE LIMITED",
"JBM EXHAUST SYSTEMS PRIVATE LIMITED",
"JBM FREIGHT SOLUTION PRIVATE LIMITED",
"JBM GREEN ENERGY SYSTEMS PRIVATE LIMITED",
"JBM INDUSTRIES LIMITED",
"JBM KANEMITSU PULLEYS PRIVATE LIMITED",
"JBM MA AUTOMOTIVE PRIVATE LIMITED",
"JBM OGIHARA AUTOMOTIVE INDIA LIMITED",
"JBM OGIHARA DIE TECH PRIVATE LIMITED",
"JBM PRISPAC SOLUTION (INDIA) PRIVATE LIMITED",
"JBM RENEWABLES PRIVATE LIMITED",
"JBM SOLAR ENERGY MAHARASHTRA PRIVATE LIMITED",
"JBM SOLAR POWER MAHARASHTRA PRIVATE LIMITED",
"JBM SOLAR POWER PRIVATE LIMITED",
"JBMS FARMTODINE PRIVATE LIMITED",
"JBMS RETAILS PRIVATE LIMITED",
"JBN AUTOMOBILES PRIVATE LIMITED",
"JBN EXIM PRIVATE LIMITED",
"JBN SOLUTION PRIVATE LIMITED",
"JBN STEELS PRIVATE LIMITED",
"JBP INFRAPROJECTS PRIVATE LIMITED",
"JBR PROCESSORS PRIVATE LIMITED",
"JBRS STEELS AND PIPES LIMITED",
"JBS CARGO & LOGISTICS PRIVATE LIMITED",
"JBS CONSTRUCTIONS PVT LTD",
"JBS ENTERPRISES LIMITED",
"JBS ENTERPRISES PRIVATE LIMITED",
"JBS INTERMIX AND RUBBER PRODUCTS PRIVATE LIMITED",
"JBS MEDIITEC INDIA PRIVATE LIMITED",
"JBS SECURITY RESOURCE PRIVATE LIMITED",
"JBS STEELS PRIVATE LIMITED",
"JBSS ENGINEERS PRIVATE LIMITED",
"JBT FOAMS PRIVATE LIMITED",
"JBTO (INDIA) PVT. LTD.",
"JBW INDUSTRY PRIVATE LIMITED",
"JC AUTOMATION LLP",
"JC BIOTECH PRIVATE LIMITED",
"JC BROSWON UNITED PRIVATE LIMITED",
"JC CLOTHINGS PRIVATE LIMITED",
"JC ELETRONICA PRIVATE LIMITED",
"JC HOTFIX PRIVATE LIMITED",
"JC JEWELLERS (CHENNAI) PRIVATE LIMITED",
"JC LIFECARE PRIVATE LIMITED",
"JC ORTHOHEAL PRIVATE LIMITED",
"JC PRO ACADEMY",
"JC RESIDENCY PRIVATE LIMITED",
"JC RETAIL INDIA PRIVATE LIMITED",
"JC SILVER STAR FASHION PRIVATE LIMITED",
"JC TRAILER SERVICE PRIVATE LIMITED",
"JC TYBAX INTERNATIONAL PRIVATE LIMITED",
"JC VALVULAS INDIA PRIVATE LIMITED",
"JC VENTURES PRIVATE LIMITED",
"JCB CARD INTERNATIONAL SOUTHASIA PRIVATE LIMITED",
"JCB INDIA LIMITED",
"JCB LITERATURE FOUNDATION",
"JCB POWER PRODUCTS INDIA PRIVATE LIMITED",
"JCBL INDIA PRIVATE LIMITED",
"JCBL LIMITED",
"JCBL MARREL TIPPERS PRIVATE LIMITED",
"JCC COMMUNICATIONS PRIVATE LIMITED",
"JCC ENGINEERS PRIVATE LIMITED",
"JCC INDIA PRIVATE LIMITED",
"JCC INFRAPROJECTS PRIVATE LIMITED",
"JCC INFRASTRUCTURES PRIVATE LIMITED",
"JCC INFRATECH PRIVATE LIMITED",
"JCC TILES PRIVATE LIMITED",
"JCD AUTOMOTIVES SOLUTION PRIVATE LIMITED",
"JCDECAUX ADVERTISING INDIA PRIVATE LIMITED",
"JCE ENGINEERING AND MANAGEMENT SERVICES LIMITED",
"JCEE MANUFACTURING AND SERVICES PRIVATE LIMITED",
"JCENTRIX PRIVATE LIMITED",
"JCF CHIT FUNDS HYDERABAD PRIVATE LIMITED",
"JCK INFRA PROJECTS LIMITED",
"JCK INFRASTRUCTURE DEVELOPMENT LIMITED",
"JCL CEMENT PRIVATE LIMITED",
"JCL INFRA PRIVATE LIMITED",
"JCM DEVELOPERS PRIVATE LIMITED",
"JCM STAINLESS PRIVATE LIMITED",
"JCN GLOBAL EXIM PRIVATE LIMITED",
"JCO AGRO FRESH PRIVATE LIMITED",
"JCO GAS PIPE LIMITED",
"JCONNECT INFOTECH PRIVATE LIMITED",
"JCP ENTERPRISES PRIVATE LIMITED",
"JCP INTERNATIONAL PRIVATE LIMITED",
"JCR CINEMA PRIVATE LIMITED",
"JCR FASHION RETAIL PRIVATE LIMITED",
"JCS HEALTHCARE PRIVATE LIMITED",
"JCS IMPEX PVT LTD",
"JCSS CONSULTING PRIVATE LIMITED",
"JCT AUTOMATION PRIVATE LIMITED",
"JCT METAL",
"JCTSL TODI DEPOT",
"JCV LOGISTIC SOLUTIONS PRIVATE LIMITED",
"JCW IMPORIO PRIVATE LIMITED",
"JD BYTCO INSTITUTE OF MANAGEMENT STUDIE",
"JD CABLES PRIVATE LIMITED",
"JD CLOTHING INDIA PRIVATE LIMITED",
"JD COTTON PRIVATE LIMITED",
"JD COURIERS AND CARGO PRIVATE LIMITED",
"JD DIGITAL PRIVATE LIMITED",
"JD ENGINEERING COMPANY",
"JD INSTITUTE OF FASHION TECHNOLOGY",
"JD MERCANTILE PRIVATE LIMITED",
"JD MERCHANDISE PRIVATE LIMITED",
"JD MINING ENGINEERING PVT LTD",
"JD MUNTYAAL PRIVATE LIMITED",
"JD PANCHAYAT AND SOCIAL WELFARE BHOPAL",
"JD SPORTS FASHION INDIA LLP",
"JD TECHFAB PRIVATE LIMITED",
"JD WOMENS COLLEGE PATNA",
"JDA INFRA LIMITED",
"JDA TEXWORLD PRIVATE LIMITED",
"JDAGRO INDUSTRIES PRIVATE LIMITED",
"JDC HEALTHCARE & DIAGNOSTIC PRIVATE LIMITED",
"JDC INDIA LIMITED",
"JDC INFRATECH PRIVATE LIMITED",
"JDC TECHNOLOGY PRIVATE LIMITED",
"JDC TRADERS LIMITED",
"JDEPO ENTERPRISES PRIVATE LIMITED",
"JDFS EDUCATION PRIVATE LIMITED",
"JDH CAD JEWELLERY PRIVATE LIMITED",
"JDIA RETAIL PRIVATE LIMITED",
"JDIANM LIGHTING PRIVATE LIMITED",
"JDK ENGINEERING SOLUTIONS PRIVATE LIMITED",
"JDM BROADBAND SERVICES PRIVATE LIMITED",
"JDM CARGO PLANNERS PRIVATE LIMITED",
"JDM CREDIT SERVICES PRIVATE LIMITED",
"JDM ENGINEERING AND CONSTRUCTION PRIVATE LIMITED",
"JDM INFRATECH PRIVATE LIMITED",
"JDM OVERSEAS PRIVATE LIMITED",
"JDM SCIENTIFIC RESEARCH ORGANISATION PRIVATE LIMITED",
"JDM SOFTWARE PRIVATE LIMITED",
"JDM TECHNOLOGIES PRIVATE LIMITED",
"JDMVPS ARTS, SCIENCE AND COMMERCE COLLEGE, VARANGAON",
"JDN REALTY LLP",
"JDPALS INFO TECH PRIVATE LIMITED",
"JDR INSECTICIDES CONSULTING PRIVATE LIMITED",
"JDS CASTING PRIVATE LIMITED",
"JDS CREATIONS PRIVATE LIMITED",
"JDS DESIGN STUDIO PRIVATE LIMITED",
"JDS ENGINEERS PRIVATE LIMITED",
"JDS FLEETS UTILITIES INDIA LIMITED",
"JDS MEDICAL SYSTEMS INDIA PRIVATE LIMITED",
"JDS MOTION TECHNOLOGY PRIVATE LIMITED",
"JDS TRADE LINKS PVT.LTD.",
"JDS TRANSFORMERS INDUSTRIES PRIVATE LIMITED",
"JDSA PRIVATE LIMITED",
"JDV HEALTHCARE (INDIA) PRIVATE LIMITED",
"JDW EXPRESS LOGISTICS INDIA PRIVATE LIMITED",
"JE ENERGY VENTURES PRIVATE LIMITED",
"JE INNOVATIVE ENGINEERING PRIVATE LIMITED",
"JE MECHANICAL PRIVATE LIMITED",
"JE SHIPPING & LOGISTICS PRIVATE LIMITED",
"JEA DIGITAL INFOSYSTEMS LLP",
"JEAN MARTIN SYSTEMS INDIA PRIVATE LIMITED",
"JEAN MUELLER INDIA PRIVATE LIMITED",
"JEANS KNIT PRIVATE LIMITED",
"JEAVIO (INDIA) PRIVATE LIMITED",
"JEBLA CONSTRUCTION COMPANY PRIVATE LIMITED",
"JEBPO SERVICES LLP",
"JEBRUNA INTERNATIONAL PRIVATE LIMITED",
"JEC DISTRIBUTORS PRIVATE LIMITED",
"JECKSWELL MACHINERY PRIVATE LIMITED",
"JECO AGROVET PRIVATE LIMITED",
"JECO MALLEABLES PRIVATE LIMITED",
"JECO NUTRI CHEM PRIVATE LIMITED",
"JECON ENGINEERS PRIVATE LIMITED",
"JECRC UNIVERSITY",
"JED SOLAR PARKS PRIVATE LIMITED",
"JEDHRU INFORMATICS PRIVATE LIMITED",
"JEDI DIA. (INDIA) PRIVATE LIMITED",
"JEDI SOFTWARE ENGINEERING LLP",
"JEDIN EXPORTS PRIVATE LIMITED",
"JEDIV CARGO MANAGEMENT PRIVATE LIMITED",
"JEDUX PARENTERAL PRIVATE LIMITED",
"JEE PUMPS (GUJARAT) PRIVATE LIMITED",
"JEEBAN SURAKSHA HOSPITAL PRIVATE LIMITED",
"JEEBIKA BUSINESS PROMOTIONAL INITIATIVE PRIVATE LIMITED",
"JEECON FOODS PRIVATE LIMITED",
"JEEDIMETLA EFFLUENT TREATMENT LIMITED.",
"JEEKAY MEDICAL PRIVATE LIMITED",
"JEE-KAY POLYCHEM PRIVATE LIMITED",
"JEELO TYRES PRIVATE LIMITED",
"JEEN FOUNDATION",
"JEEN MATA PROMOTERS PRIVATE LIMITED",
"JEEN SOCIAL DEVELOPMENT FOUNDATION",
"JEEN TRADELINK PRIVATE LIMITED",
"JEENA & COMPANY",
"JEENA AND COMPANY PRIVATE LIMITED",
"JEENA SCRIPTECH ALPHA ADVISORS PRIVATE LIMITED",
"JEENA SIKHO LIFECARE LIMITED",
"JEENA SIKHO LIFECARE PRIVATE LIMITED",
"JEENALI TRADING AND COMMERCIAL SERVICES PRIVATE LIMITED",
"JEENEC SOLUTION PRIVATE LIMITED",
"JEENOMICS LABORATORY PRIVATE LIMITED",
"JEERNODHAR CONSERVATORS PRIVATE LIMITED",
"JEET (INDIA) PRIVATE LIMITED",
"JEET AND JEET GLASS AND CHEMICALS PVT LTD",
"JEET ASIA PRIVATE LIMITED",
"JEET BIRI MANUFACTURING CO. PRIVATE LIMITED",
"JEET EARTHMOVERS PRIVATE LIMITED",
"JEET ELECTRONICS AND ENGINEERING (INDIA) PVT LTD",
"JEET FABRIC AND MFG",
"JEET HOUSEKEEPING SERVICES PRIVATE LIMITED",
"JEET INFRA VENTURE PRIVATE LIMITED",
"JEET INSPECTION SERVICES (INDIA) PRIVATE LIMITED",
"JEET KRISHI SHEET GRAH PRIVATE LIMITED",
"JEET NIRMAN PRIVATE LIMITED",
"JEET PUMPS PRIVATE LIMITED",
"JEET STEEL INDUSTRIES PVT LTD",
"JEETAY INVESTMENTS PVT LTD",
"JEETMULL JAICHANDLALL PVT LTD",
"JEETSONS DISTILLERY & INDUSTRIES LIMITED",
"JEETSONS EXPORTS PRIVATE LIMITED",
"JEEV BRAMHA SEVA MEDICAL & RESEARCH INSTITUTE PRIVATE LIMITED",
"JEEV DIAGNOSTICS PRIVATE LIMITED",
"JEEV LIFEWORKS LLP",
"JEEVA TRADERS",
"JEEVAA TECHMAX PRIVATE LIMITED",
"JEEVAK HEART HOSPITAL AND REASERCH INSTITUTE PRIVATE LIMITED",
"JEEVAKA ENGINEERING SOLUTIONS PRIVATE LIMITED",
"JEEVAKA INDUSTRIES PRIVATE LIMITED",
"JEEVAKA LAMINATIONS PRIVATE LIMITED",
"JEEVALABS PRIVATE LIMITED",
"JEEVAM HEALTH PRIVATE LIMITED",
"JEEVAN AADHAR TRANSFORMATIVE AFTERCARE SERVICES PRIVATE LIMITED",
"JEEVAN AMBULANCE SERVICE PRIVATE LIMITED",
"JEEVAN AMRIT FOOD PRODUCTS PRIVATE LIMITED",
"JEEVAN AUTO MOTOR PRIVATE LIMITED",
"JEEVAN AUTOZONE PRIVATE LIMITED",
"JEEVAN BINDU IRRIGATION PRIVATE LIMITED",
"JEEVAN CHEMICALS PRIVATE LIMITED",
"JEEVAN ENTERPRISES",
"JEEVAN HEALTHCARE SERVICES PRIVATE LIMITED",
"JEEVAN JYOTI AGENCIES PRIVATE LIMITED",
"JEEVAN JYOTI AYURVEDIC MEDICAL COLLEGE & HOSPITAL",
"JEEVAN JYOTI GENERAL EYE HOSPITAL",
"JEEVAN JYOTI HEALTH CARE AND RESEARCH CENTRE PRIVATE LIMITED",
"JEEVAN JYOTI HEALTH SERVICES PRIVATE LIMITED",
"JEEVAN JYOTI HOSPITAL & RESEARCH CENTRE PRIVATE LIMITED",
"JEEVAN JYOTI HOSPITAL & TRAUMA CENTRE",
"JEEVAN JYOTI PUBLIC SCHOOL",
"JEEVAN JYOTI SENIOR SECONDARY PUBLIC SCHOOL",
"JEEVAN JYOTI SENIOR SECONDARY SCHOOL",
"JEEVAN JYOTI SHOPPING CENTRE PRIVATE LIMITED",
"JEEVAN MATA TEXTILES PRIVATE LIMITED",
"JEEVAN MEDISALES PRIVATE LIMITED",
"JEEVAN RAKSHA HEALTHCARE PRIVATE LIMITED",
"JEEVAN REKHA CRITICAL CARE & TRAUMA HOSPITAL",
"JEEVAN SANJEEVANI HERBS PRIVATE LIMITED",
"JEEVAN SCIENTIFIC TECHNOLOGY LIMITED",
"JEEVAN SHAKTI CHIT FUND PVT. LTD.",
"JEEVAN SHIPPING AND LOGISTICS PRIVATE LIMITED",
"JEEVAN SOLVENT EXTRACTS PRIVATE LIMITED",
"JEEVAN SUMYUKTHA HOSPITALS PRIVATE LIMITED",
"JEEVAN TELECASTING CORPORATION LIMITED",
"JEEVAN TELESERVICES PRIVATE LIMITED",
"JEEVAN UTTHAN FINANCIAL SERVICES PRIVATE LIMITED",
"JEEVAN VIKAS VIDYALAYA",
"JEEVANA SCHOOL",
"JEEVANADI ESTATES PRIVATE LIMITED",
"JEEVANDARSHI MARKETING PVT LTD",
"JEEVANDEEP EDUMEDIA PRIVATE LIMITED",
"JEEVANDEEP PRAKASHAN PRIVATE LIMITED",
"JEEVANDHARA CHAI PRIVATE LIMITED",
"JEEVANKIRAN",
"JEEVANLAKSHMI PACKAGING SOLUTIONS PRIVATE LIMITED",
"JEEVANMAHENDRA CHITS PRIVATE LIMITED",
"JEEVAN-REKHA MEDICAL CARE SERVICES LIMITED",
"JEEVANSH HOSPITAL",
"JEEVANSHREE INFRASTRUCTURES PRIVATE LIMITED",
"JEEVANTI HEALTHCARE PRIVATE LIMITED",
"JEEVASS CMI CENTRAL SCHOOL",
"JEEVES CONSUMER SERVICES PRIVATE LIMITED",
"JEEVES INFORMATION SYSTEMS PRIVATE LIMITED",
"JEEVIKA BIHAR RURAL LIVELIHOOD PROMOTION SOCIETY",
"JEEVIKA HOSPITALS PRIVATE LIMITED",
"JEEVIKA MINERALS PRIVATE LIMITED",
"JEEVISHA FOODS PRIVATE LIMITED",
"JEEVNAM ECO-FRIENDLY PRIVATE LIMITED",
"JEEVSHAKTI PRODUCTS PRIVATE LIMITED",
"JEEVTRONICS PRIVATE LIMITED",
"JEEWAN HOSPITAL AND NURSING HOME PRIVATE LIMITED",
"JEEWAN JYOTI PUBLIC SCHOOL",
"JEEWAN MALA HOSPITAL PRIVATE LIMITED",
"JEEWAN MEDICAL CENTRE PRIVATE LIMITED",
"JEEWAN MOTI KHERA HOSPITAL PRIVATE LIMITED",
"JEEWAN MOTORS PRIVATE LIMITED",
"JEEWAN SHEET GRAH PRIVATE LIMITED",
"JEEWANI FUELS PRIVATE LIMITED",
"JEF TECHNO SOLUTIONS PRIVATE LIMITED",
"JEFFERIES INDIA PRIVATE LIMITED",
"JEGA PRECISION DRIVES PRIVATE LIMITED",
"JEGAN RESEARCH ASSOCIATES PRIVATE LIMITED",
"JEGSER BUSINESS INDIA PRIVATE LIMITED",
"JEHAN NUMA PALACE HOTEL PRIVATE LIMITED",
"JEHANGIR CLINICAL DEVELOPEMENT CENTRE PRIVATE LIMITED",
"JEHANGIR HOSPITAL",
"JEHLUM ROADLINES PRIVATE LIMITED",
"JEHOVAH NISSI DESIGN BUILD PRIVATE LIMITED",
"JEHOVAH TRAVELS PRIVATE LIMITED",
"JEI GOWTHAM TEXTILE PRIVATE LIMITED",
"JEITSA TECHNOLOGIES PRIVATE LIMITED",
"JEIVIKASS HIGHER SECONDARY SCHOOL",
"JEIVIKASS NURSERY AND PRIMARY SCHOOL",
"JEJURI ICU & MULTISPECIALITY HOSPITAL",
"JEKAY INTERNATIONAL TRACK PVT. LTD.",
"JEKPL PRIVATE LIMITED",
"JEKSON HYDRAULIC PRIVATE LIMITED",
"JEKSON VISION PRIVATE LIMITED",
"JEKUMA TOOLS AND GAUGES PVT LTD",
"JELAM SECURITIES PRIVATE LIMITED",
"JELL PHARMACEUTICALS PRIVATE LIMITED",
"JELLYBEAN LAPTOP SPARES PRIVATE LIMITED",
"JELLYFISH DIGITAL INDIA PRIVATE LIMITED",
"JELLYFISH TECHNOLOGIES PRIVATE LIMITED",
"JEM ZIP CORPORATION PRIVATE LIMITED",
"JEMBY CHEM LIMITED",
"JEMCO ENGINEERING PRIVATE LIMITED",
"JEMINI ESTATES PRIVATE LIMITED",
"JEMINI VINCOM PRIVATE LIMITED",
"JEMKON PRIVATE LIMITED",
"JEMOND RUBBER PRIVATE LIMITED",
"JEMSTER HEALTHCARE PRIVATE LIMITED",
"JENA BROTHERS INFRASTRUCTURE PRIVATE LIMITED",
"JENA PLUMBING SYSTEM PRIVATE LIMITED",
"JENBURKT PHARMACEUTICALS LIMITED",
"JENCO COTFAB PRIVATE LIMITED",
"JENCO DEVELOPERS PRIVATE LIMITED",
"JENCY SOFTWARE",
"JENDAMARK INDIA PRIVATE LIMITED",
"JENESIS CONTROLS INDIA PRIVATE LIMITED",
"JENESYS TECHNOLOGIES PRIVATE LIMITED",
"JENFER BIOSCIENCES PRIVATE LIMITED",
"JENI CONSTRUCTION PRIVATE LIMITED",
"JENIL AQUA PRIVATE LIMITED",
"JENIL ENTERPRISE PRIVATE LIMITED",
"JENIL STEEL PRIVATE LIMITED",
"JENIOUS CLOTHING PRIVATE LIMITED",
"JENISH GLOBAL LOGISTICS PRIVATE LIMITED",
"JENISH INFRAWORK PRIVATE LIMITED",
"JENISHA JEWELS ARTS PRIVATE LIMITED",
"JENITH FLEXIBLE PRIVATE LIMITED",
"JENITH TECH-MEDIA PRIVATE LIMITED",
"JENITH TECHNOCAST PRIVATE LIMITED",
"JENKO BUSINESS PVT LTD",
"JENNEX GRANITE INDUSTRIES PRIVATE LIMITED",
"JENNEYS RESIDENCY PRIVATE LIMITED",
"JENNYS HOTEL PRIVATE LIMITED",
"JENO MARAN BUILDERS PRIVATE LIMITED",
"JENOME BIOPHAR PRIVATE LIMITED",
"JENOPTIK INDIA PRIVATE LIMITED",
"JEN-PHARMA PRODUCTS PRIVATE LIMITED",
"JENS ENVIRO TECHNOLOGIEN PRIVATE LIMITED",
"JENSEN KOBAIN SOLUTIONS PRIVATE LIMITED",
"JENSHRI (INDIA) PRIVATE LIMITED",
"JENSON & NICHOLSON PAINTS PRIVATE LIMITED",
"JENVEE INFRASTRUCTURE PRIVATE LIMITED",
"JEOL INDIA PRIVATE LIMITED",
"JEONGIN ENTERPRISE PRIVATE LIMITED",
"JEONGUN CHENNAI PRIVATE LIMITED",
"JEPEE CONSTRUCTION PRIVATE LIMITED",
"JEPIKA PAINTS PVT LTD",
"JEPPESEN INDIA PRIVATE LIMITED",
"JEPPIAAR ENGINEERING COLLEGE",
"JEPPIAAR FURNACE AND STEELS PRIVATE LIMITED",
"JEPPIAAR INSTITUTE OF TECHNOLOGY",
"JEPPIAAR SRR ENGINEERING COLLEGE",
"JERAI FITNESS LIMITED",
"JERAI FITNESS PRIVATE LIMITED",
"JERICHEM PRIVATE LIMITED",
"JERICHO DETERGENT PRIVATE LIMITED",
"JERICHO VENTURES PRIVATE LIMITED",
"JERMEL‚ÄôS ACADEMY",
"JERONONE TECHNOLOGIES PRIVATE LIMITED",
"JERRY NIDHI LIMITED",
"JERRY VARGGOSE INSTRIAL PRIVATE LIMITED",
"JERSEY ENGINEERING SOLUTIONS PRIVATE LIMITED",
"JERUSALEM COLLEGE OF ENGINEERING",
"JES & BEN GROUPO PRIVATE LIMITED",
"JES DEGREE COLLEGE FOR WOMEN",
"JES ELECTRONIC SYSTEMS PRIVATE LIMITED",
"JES GLOBAL FRESH PRIVATE LIMITED",
"JES INSTITUTE OF TECHNOLOGY MANAGEMENT & RESEARCH",
"JES PHARMACIA PRIVATE LIMITED",
"JES PUBLIC SCHOOL",
"JESAI HEALTHCARE INDIA PRIVATE LIMITED",
"JESAL PRODUCTS PRIVATE LIMITED",
"JESCO PROJECTS (INDIA) PRIVATE LIMITED",
"JESHRA INSTRUMENTS PRIVATE LIMITED",
"JESHTHA PROPERTIES PRIVATE LIMITED",
"JESKON SYSTEMS PRIVATE LIMITED",
"JESMAJO INDUSTRIAL FABRICATIONS KARNATAKA PRIVATE. LIMITED.",
"JESONS INDUSTRIES LIMITED",
"JESONS TECHNO POLYMERS LLP",
"JESONVIR INTERNATIONAL PRIVATE LIMITED",
"JESPA SHIPPING AGENCIES PRIVATE LIMITED",
"JESS IDEAS PRIVATE LIMITED",
"JESSA RAM HOSPITAL",
"JESSE PU AND DEGREE COLLEGE",
"JESSEENA MARINE SERVICES PRIVATE LIMITED",
"JESSICA FAB FASHION PRIVATE LIMITED",
"JESSUN TECHNO PRIVATE LIMITED",
"JESUIT TECHNOLOGIES PRIVATE LIMITED",
"JESUS AND MARY COLLEGE",
"JESUS AND MERY CONVENT SCHOOL",
"JESUS‚Äô SACRED HEART SCHOOL",
"JESWANTH AQUA FARMS PRIVATE LIMITED",
"JET AGE FINANCE PVT. LTD.",
"JET AGE SECURITIES PRIVATE LIMITED",
"JET AGE TOURS & TRAVEL",
"JET CARTRIDGE (INDIA) PRIVATE LIMITED",
"JET CONTENT BOUTIQUE PRIVATE LIMITED",
"JET ELECTRO-MECH ENGINEERING PVT LTD",
"JET EXPRESS (CARGO COURIER) PRIVATE LIMITED",
"JET FIBRE INDIA PRIVATE LIMITED",
"JET FLOW FOREX AND TRAVELS PRIVATE LIMITED",
"JET FREIGHT LOGISTICS LIMITED",
"JET FREIGHT LOGISTICS PRIVATE LIMITED",
"JET GRANITO PRIVATE LIMITED",
"JET INDIA",
"JET INFOTECH",
"JET INKS PRIVATE LIMITED",
"JET INSULATION PVT LTD",
"JET INTELLIGENCE SECURITY PRIVATE LIMITED",
"JET KNITWEARS PRIVATE. LIMITED.",
"JET LIFTS PRIVATE LIMITED",
"JET LOGISTIX (OPC) PRIVATE LIMITED",
"JET NETCOM BROADBAND PRIVATE LIMITED",
"JET PACK MACHINES PRIVATE LIMITED",
"JET PRIVILEGE PRIVATE LIMITED",
"JET ROAD LINES (INDIA) PRIVATE LIMITED",
"JET SKYESPORTS GAMING PRIVATE LIMITED",
"JET SPARKLE FACILITY MANAGEMENT PRIVATE LIMITED",
"JET TEC INFO-CONSUMABLES INDIA PRIVATE LIMITED",
"JET TECH PRIVATE LIMITED",
"JET TECHNO SERVICES PRIVATE LIMITED",
"JET VACUUM SYSTEMS PRIVATE LIMITED",
"JET(INDIA) PVT LTD",
"JET2 TRAVEL TECHNOLOGIES PRIVATE LIMITED",
"JETAA SEEDS PRIVATE LIMITED",
"JETAGE PACKAGING PRIVATE LIMITED",
"JETAIR PRIVATE LIMITED",
"JETAIR TOURS PRIVATE LIMITED",
"JETAVI ENGINEERING PRIVATE LIMITED",
"JETBLUE AIRWAYS CORPORATION",
"JETBRO PRIVATE LIMITED",
"JETCHASE TRAVELS PRIVATE LIMITED",
"JETCO ENGINEERS PVT LTD",
"JETCORD INDIA PRIVATE LIMITED",
"JETEX CARBURETTORS PRIVATE LIMITED",
"JETEX OCEAN AIR PVT LTD",
"JETEX PARCEL SYSTEMS PRIVATE LIMITED",
"JETFLEET PRIVATE LIMITED",
"JETHA PROPERTIES PRIVATE LIMITED",
"JETHA RAM DUDI MOTORS PRIVATE LIMITED",
"JETHABHAI & SONS FOODS & SNACKS PRIVATE LIMITED",
"JETHABHAI DOONGERSHI TRANSPORT PRIVATE LIMITED",
"JETHANAND HASSANAND TEXTILES PRIVATE LIMITED",
"JETHYL INDUSTRIES PRIVATE LIMITED",
"JETIBAI GRANDSONS SERVICES INDIA PRIVATE LIMITED",
"JETKING INFOTRAIN LIMITED",
"JETKING TECHNOLOGIES PRIVATE LIMITED",
"JETLINE COURIERS PRIVATE LIMITED",
"JETLINE INDUSTRIES PRIVATE LIMITED",
"JETMAX SOLUTIONS PRIVATE LIMITED",
"JETMOBILITY PRIVATE LIMITED",
"JETPACK MACHINES PRIVATE LIMITED",
"JETPUR SOMNATH TOLLWAYS PRIVATE LIMITED",
"JETROLL PRIVATE LIMITED",
"JETSAVE INDIA TOURS PRIVATE LIMITED",
"JETSERVE AVIATION PRIVATE LIMITED",
"JETSETGO AVIATION SERVICES PRIVATE LIMITED",
"JETSOR POWER SYSTEMS PRIVATE LIMITED",
"JETSPEED LOGISTICS PRIVATE LIMITED",
"JETSPRAY INNOVATIONS PRIVATE LIMITED",
"JETSTAR INNOVATIONS PVT LTD",
"JETSUP HOLIDAYS PRIVATE LIMITED",
"JETTI INFRA PROJECTS PRIVATE LIMITED",
"JETTRADE AND LOGISTIC (I) PRIVATE LIMITED",
"JETTY HOTELS PRIVATE LIMITED",
"JETTY VENTURES ADVISORS PRIVATE LIMITED",
"JETVENTURES INDIA PRIVATE LIMITED",
"JETWAY BROADBAND INDIA PRIVATE LIMITED",
"JETWAYS TRAVELS PRIVATE LIMITED",
"JETZ GLOBAL LOGISTICS PRIVATE LIMITED",
"JEUMONT ELECTRIC INDIA PRIVATE LIMITED",
"JEUNESSE GLOBAL INDIA PRIVATE LIMITED",
"JEVAN DREDGING LIMITED",
"JEVATLAL SHAH & SONS PRIVATE LIMITED",
"JEWEELKRAFT CREATIONS PRIVATE LIMITED",
"JEWEL ALLIANCE NETWORK PRIVATE LIMITED",
"JEWEL BUILDERS AND INFRAPROJECTS LIMITED",
"JEWEL CLASSIC HOTELS PRIVATE LIMITED",
"JEWEL CONSUMER CARE PRIVATE LIMITED",
"JEWEL ENGINEERING PRIVATE LIMITED",
"JEWEL FACTORY PRIVATE LIMITED",
"JEWEL GALLERY PRIVATE LIMITED",
"JEWEL IMPEX PRIVATE LIMITED",
"JEWEL INDIA PRIVATE LIMITED",
"JEWEL JYOTI ORNAMENTS PRIVATE LIMITED",
"JEWEL MERCHENT PRIVATE LIMITED",
"JEWEL METALLOCHEM LABORATORY PRIVATE LIMITED",
"JEWEL OCEAN GEMS PRIVATE LIMITED",
"JEWEL PACKAGING PVT LTD",
"JEWEL PAPERS PRIVATE LIMITED",
"JEWEL PLASTICS PVT LTD",
"JEWEL STATIONARY P LTD",
"JEWEL THRRONE AGROCORP PRIVATE LIMITED",
"JEWEL TRENDZ PRIVATE LIMITED",
"JEWELEX INDIA PRIVATE LIMITED",
"JEWELICK GLOBAL PRIVATE LIMITED",
"JEWELIMA DIAMONDS PRIVATE LIMITED",
"JEWELLERY GARDEN PRIVATE LIMITED",
"JEWELLERY HOUSE PRIVATE LIMITED",
"JEWELMARK INDIA PRIVATE LIMITED",
"JEWELMAZE PRIVATE LIMITED",
"JEWELMONDPRECIOUS PRIVATE LIMITED",
"JEWELPRO INDIA PRIVATE LIMITED",
"JEWELS STEELWARE PRIVATE LIMITED",
"JEWELSMART VENTURES PRIVATE LIMITED",
"JEWELSNEXT MEDIA PRIVATE LIMITED",
"JEWELUM INDIA PRIVATE LIMITED",
"JEY OIL & BITUMEN PRODUCTS INDIA PRIVATE LIMITED",
"JEYA BHARATH BENEFIT NIDHI LIMITED",
"JEYA ENGINEERING AND INFRASTRUCTURES PRIVATE LIMITED",
"JEYA INDUSTRIES AND ENGINEERINGS PRIVATE LIMITED",
"JEYAAR POLYMER PRIVATE LIMITED",
"JEYACHANDRAN INDUSTRIES PRIVATE LIMITED",
"JEYACHANDRAN LOGISTICS PRIVATE LIMITED",
"JEYAM METAL ROOF PRIVATE LIMITED",
"JEYAM METAL ROOFING PRIVATE LIMITED",
"JEYAM SCIENTIFIC COMPANY PRIVATE LIMITED",
"JEYAMALLI INDUSTRIES PRIVATE LIMITED",
"JEYAVISHNU CLOTHING PRIVATE LIMITED",
"JEYENKAY PETROGELS PRIVATE LIMITED",
"JEYES ENGINEERS AND CONTRACTORS PVT LTD",
"JEYPORE OVERSEAS PRIVATE LIMITED",
"JEYYAM GLOBAL FOODS LIMITED",
"JEYYAM GLOBAL FOODS PRIVATE LIMITED",
"JF GALLERY RETAIL INDIA PRIVATE LIMITED",
"JF PRODUCTION PRIVATE LIMITED",
"JFB INDUSTRIES PRIVATE LIMITED",
"JFB TECHNOLOGIES LIMITED",
"JFC FINANCE (INDIA) LIMITED",
"JFDMIL TECHNOLOGIES PRIVATE LIMITED",
"JFE ENGINEERING CORPORATION",
"JFE ENGINEERING INDIA PRIVATE LIMITED",
"JFE SHOJI STEEL INDIA PRIVATE LIMITED",
"JFE STEEL INDIA PRIVATE LIMITED",
"JFK INTERNATIONAL LIMITED",
"JFK TRANSPORTERS PRIVATE LIMITED",
"JFL LIFE SCIENCES LIMITED",
"JFROG INDIA PRIVATE LIMITED",
"JFT TRADING INDIA PRIVATE LIMITED",
"JG COLLEGE OF EDUCATION",
"JG INTERNATIONAL SCHOOL",
"JG VALVES & FITTINGS (I) PRIVATE LIMITED",
"JGANDHI TEX PRIVATE LIMITED",
"JGB AGROFRESH PRIVATE LIMITED",
"JGB SERVICES PRIVATE LIMITED",
"JGC CONSTRUCTION INTERNATIONAL PTE LTD",
"JGD ENGINEERING SOLUTION PRIVATE LIMITED",
"JGDTECH PRIVATE LIMITED",
"JGM INDUSTRIES PRIVATE LIMITED",
"JGN AGRO PRIVATE LIMITED",
"JGS GLASS INDUSTRIES",
"JGS HEALTHCARE PRIVATE LIMITED",
"JGT CONSTRUCTIONS PRIVATE LIMITED",
"JH CONTECH PRIVATE LIMITED",
"JH CORPORATION",
"JH DIGICOM WORLD PRIVATE LIMITED",
"JH PACKAGINGS PRIVATE LIMITED",
"JHA AGARSEN COLLEGE",
"JHA CONSTRUCTION PRIVATE LIMITED",
"JHA EDUCATIONAL SERVICES",
"JHA EXPORT PRIVATE LIMITED",
"JHA FINANCIAL SERVICES PRIVATE LIMITED",
"JHA FLOUR MILLS PRIVATE LIMITED",
"JHA P INFRASTRUCTURE PRIVATE LIMITED",
"JHA SCIENTIFIC RESEARCH PRIVATE LIMITED",
"JHABUA MOTOR TRANSPORT PRIVATE LIMITED",
"JHABUA POWER LIMITED",
"JHADESWAR ISPAT PRIVATE LIMITED",
"JHAISHNA TECHNOLOGIES PRIVATE LIMITED",
"JHAJHARIA INFRATECH PRIVATE LIMITED",
"JHAJHARIA NIRMAN LIMITED",
"JHAJJAR KT TRANSCO PRIVATE LIMITED",
"JHAJJAR POWER LIMITED.",
"JHAKAAS RETAIL PRIVATE LIMITED",
"JHALAK EXPRESS LOGISTICS PRIVATE LIMITED",
"JHALAK FINECHEM PRIVATE LIMITED",
"JHALAK IMPEX LIMITED",
"JHALANI FORGE PRIVATE LIMITED",
"JHALANI MARKETING SERVICES PRIVATE LIMITED",
"JHAMA SWEETS & FOODS PRIVATE LIMITED",
"JHAMAN DAS AGROTECH PRIVATE LIMITED",
"JHAMTANI REALTY PRIVATE LIMITED",
"JHANAVI HEIGHTS PRIVATE LIMITED",
"JHANGINIYA HYBRID SEEDS PRIVATE LIMITED",
"JHANJI TEXTILES PRIVATE LIMITED",
"JHANKAR AVIATION PRIVATE LIMITED",
"JHANSI CANCER CENTER AND MULTISPECIALITY HOSPITAL PRIVATE LIMITED",
"JHANSI CANTONMENT BOARD",
"JHANSI GRANITE STONE PRODUCTS PRIVATE LIMITED",
"JHANSI REROLERS PRIVATE LIMITED",
"JHANSILAKSHMI KALIDINDI ESTATES PRIVATE LIMITED",
"JHANSI-LALITPUR TOLLWAY PRIVATE LIMITED",
"JHANSI-VIGAKHET TOLLWAY PRIVATE LIMITED",
"JHANU LOGISTICS LIMITED",
"JHANVI AUTO MECH PRIVATE LIMITED",
"JHANVI RAJPAL AUTOMOTIVE PRIVATE LIMITED",
"JHANVI TRANSFORMERS PRIVATE LIMITED",
"JHANWAR INDUSTRIES",
"JHAPORDAH DUKE INSTITUTION",
"JHARAN DALLI AUTOMOBILES PRIVATE LIMITED",
"JHARANA INDUSTRIES PRIVATE LIMITED",
"JHARGRAM RAJ COLLEGE",
"JHARKHAND BENGAL FREIGHT CARRIER PRIVATE LIMITED",
"JHARKHAND BIJLI VITRAN NIGAM LIMITED",
"JHARKHAND CENTRAL RAILWAY LIMITED",
"JHARKHAND ELECTRIC COMPANY LIMITED",
"JHARKHAND ENGINEERING",
"JHARKHAND GRIND CHEM PRIVATE. LIMITED.",
"JHARKHAND INDUSTRIAL INFRASTRUCTURE DEVELOPMENT CORPORATION LIMITED",
"JHARKHAND INFRAPOWER LIMITED",
"JHARKHAND INFRASTRUCTURE IMPLEMENTATION CO LIMITED",
"JHARKHAND INTEGRATED POWER LIMITED",
"JHARKHAND ISPAT PRIVATE LIMITED",
"JHARKHAND NATIONAL MINERAL DEVELOPMENT CORPORATION LIMITED",
"JHARKHAND PLASTICS PRIVATE LIMITED",
"JHARKHAND POLICE HOUSING CORPORATION LIMITED",
"JHARKHAND ROAD PROJECTS IMPLEMENTATION COMPANY LIMITED",
"JHARKHAND RURAL HEALTH MISSION SOCIETY",
"JHARKHAND STATE BUILDING CONSTRUCTION CORPORATOIN LIMITED",
"JHARKHAND TECHNOLOGY PRIVATE LIMITED",
"JHARKHAND URJA SANCHARAN NIGAM LIMITED",
"JHARKHAND URJA VIKAS NIGAM LIMITED",
"JHARNESHWAR GLOBAL PRIVATE LIMITED",
"JHARSUGUDA INFRASTRUCTURE DEVELOPMENT CO. PRIVATE LIMITED",
"JHAVERI AUTO PRIVATE LIMITED",
"JHAVERI AUTOMOTIVE PRIVATE LIMITED",
"JHAVERI BROTHERS AND COMPANY PRIVATE LIMITED",
"JHAVERI CREDITS AND CAPITAL LIMITED",
"JHAVERI FLEXO INDIA PRIVATE LIMITED",
"JHAVERI IMMITATION JEWELLERY PRIVATE LIMITED",
"JHAVERI INDDUSTRIES",
"JHAVERI PACKAGING PRIVATE LIMITED",
"JHAVERI SECURITIES LIMITED",
"JHAVERI SPICES PRIVATE LIMITED",
"JHAVERI TRADING AND INVESTMENT PRIVATE LIMITED",
"JHAWAR ALUMAX PRIVATE LIMITED",
"JHAWAR COMMODITIES PRIVATE LIMITED",
"JHAWAR FELICITY PRIVATE LIMITED",
"JHAWAR TRADE AND INVESTMENTS PRIVATE LIMITED",
"JHEEL FABRICS",
"JHEELUM ACREAGE PRIVATE LIMITED",
"JHELUM JAVERRI PRIVATE LIMITED",
"JHELUM JEWELLERS PRIVATE LIMITED",
"JHELUM RESORTS PRIVATE LIMITED",
"JHIKRA HIGH SCHOOL",
"JHIL NANDI TEA PRIVATE LIMITED",
"JHILIK PROMOTERS & FINCON PVT LTD",
"JHILIMILI TEXTILE PRIVATE LIMITED",
"JHILMIL COMMODITIES PRIVATE LIMITED",
"JHILMIL FASHION PRIVATE LIMITED",
"JHILO VYAPAAR PVT.LTD.",
"JHJK EXPO PRIVATE LIMITED",
"JHKP TECHNOLOGIES PRIVATE LIMITED",
"JHL BEAUTY GYM AND SPA PRIVATE LIMITED",
"JHM INFRAHOMES PRIVATE LIMITED",
"JHM LOGISTICS PRIVATE LIMITED",
"JHM OVERSEAS PRIVATE LIMITED",
"JHM RICE MILLS PRIVATE LIMITED",
"JHONSON CHEMICALS PRIVATE LIMITED",
"JHOOM JHOOM MEDIA PRIVATE LIMITED",
"JHP EDUCATION FOUNDATION",
"JHP FINVEST PRIVATE LIMITED",
"JHP SECURITIES PRIVATE LIMITED",
"JHPIEGO CORPORATION",
"JHS CHEMI PHARMA PRIVATE LIMITED",
"JHS KOKILPATTI",
"JHS SVENDGAARD RETAIL VENTURES LIMITED",
"JHS SVENDGAARD RETAIL VENTURES PRIVATE LIMITED",
"JHS SVENGAARD LABORATORIES LIMITED",
"JHULELAL INSTITUTE OF TECHNOLOGY",
"JHULELAL MINE WORKS PRIVATE LIMITED",
"JHUNJHUNUWALA TEXTILES PRIVATE LIMITED",
"JHUNJHUNWALA CLOTH STORE PRIVATE LIMITED",
"JHUNJHUNWALA COTSPIN PRIVATE LIMITED",
"JHUNJHUNWALA EXPORT PRIVATE LIMITED",
"JHUNJHUNWALA OIL MILLS LIMITED",
"JHUNJHUNWALA POLYPLAST PRIVATE LIMITED",
"JHUNJHUNWALA SYNTHETIC LTD",
"JHUNJHUNWALA TEXYARN LIMITED",
"JHUNJHUNWALA TRADING PVT LTD",
"JHUNKAM LIGHTING SYSTEMS PRIVATE LIMITED",
"JHUNNILAL FOODS PRIVATE LIMITED",
"JHUNSONS CHEMICALS PRIVATE LIMITED",
"JHV CONSTRUCTION COMPANY PRIVATE LIMITED",
"JHV FINANCE AND LEASING LIMITED",
"JH-WELLTEC MACHINES (INDIA) PRIVATE LIMITED",
"JHY TECHSERVE PRIVATE LIMITED",
"JI FASHION INDIA PRIVATE. LIMITED",
"JI TECHNOVATION PRIVATE LIMITED",
"JIA AUTO SALES PRIVATE LIMITED",
"JIAN TECH PRIVATE LIMITED",
"JIANGYIN UNI-POL VACUUM CASTING INDIA PRIVATE LIMITED",
"JIBANTALA F P PRIMARY SCHOOL",
"JIBE DEVELOPMENT SERVICES PRIVATE LIMITED",
"JIBRA POWER SYSTEMS PRIVATE LIMITED",
"JIBU AND THOMAS PROJECTS PRIVATE LIMITED",
"JIBZ INDIA SYSTEMS PRIVATE LIMITED",
"JIC TRANSPORTATION INDIA PRIVATE LIMITED",
"JICE ACADEMY FOR EXCELLENCE PRIVATE LIMITED",
"JICS HOLDINGS PRIVATE LIMITED",
"JIDOKA TECHNOLOGIES PRIVATE LIMITED",
"JIE LIAN MOBILE INDIA PRIVATE LIMITED",
"JIECANG PRIVATE LIMITED",
"JIFFLE TECHNOLOGIES PRIVATE LIMITED",
"JIFFY EXPRESS PRIVATE LIMITED",
"JIFFY FOODS PRIVATE LIMITED",
"JIFFY INFOSOLUTIONS PRIVATE LIMITED",
"JIFFYBAG ECOM PRIVATE LIMITED",
"JIFFYSHIP CARGO TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"JIGAR CABLES LIMITED",
"JIGAR CARS PRIVATE LIMITED",
"JIGAR COMMODITIES & DERIVATIVES PRIVATE LIMITED",
"JIGAR FOUNDRY PRIVATE LIMITED",
"JIGAR MARKETING PRIVATE LIMITED",
"JIGAR POLY PLAST PRIVATE LIMITED",
"JIGAR POLYMERS LIMITED",
"JIGAR TRANSPORT CO.",
"JIGAR WOOD PRIVATE LIMITED",
"JIGEESHA TRADING PRIVATE LIMITED",
"JIGGIS FOOD SERVICES PRIVATE LIMITED",
"JIGISHA FIBRES PVT LTD",
"JIGISHA TEXOFAB PRIVATE LIMITED",
"JIGNECT TECHNOLOGIES",
"JIGNESH AGENCY PRIVATE LIMITED",
"JIGNESH CERAMICS PRIVATE LIMITED",
"JIGNESH RETAIL (INDIA) PRIVATE LIMITED",
"JIGNESH TEXTILES",
"JIGS CHEMICAL LIMITED",
"JIGS ENTERPRISE PRIVATE LIMITED",
"JIGSAN MERCANTILE PRIVATE LIMITED",
"JIGSAW EDU SOLUTIONS PRIVATE LIMITED",
"JIGSAW ENTERTAINMENT PRIVATE LIMITED",
"JIGSAW ERGO ARCHITECTS PRIVATE LIMITED",
"JIGSAW PICTURES PRIVATE LIMITED",
"JIGSON HOSPITALITY PRIVATE LIMITED",
"JIGYA SOFTWARE SERVICES PRIVATE LIMITED",
"JIGYASA INFRATECH (OPC) PRIVATE LIMITED",
"JIGYASA LIVELIHOOD PROMOTIONS MICRO FINANCE FOUNDATION",
"JIGYDI HOME CARE SERVICES PRIVATE LIMITED",
"JIJAI MASALE PRIVATE LIMITED",
"JIJAMATA KANYA MADHYAMIK VIDYALAYA BUDHGAON",
"JIJAMATA ROAD NIRMITI PRIVATE LIMITED",
"JIJAMATA SIKSHAN PRASARAK MANDAL SHRI LAXMANRAO JAHER PRATHMIK SCHOOL BEED",
"JIJAU COMMERCIAL CO OPERATIVE BANK",
"JIJAU INFRASTRUCTURE MU PROJECT PRIVATE LIMITED",
"JIJAU MU3 PROJECT PRIVATE LIMITED",
"JIJO INDIA PRIVATE LIMITED",
"JIJU GRAPHICS PRIVATE LIMITED",
"JIK INDUSTRIES LIMITED",
"JIKAKA PRIVATE LIMITED",
"JIL INFORMATION TECHNOLOGY LIMITED",
"JILA ANTARVYASAYI SAHKARI VIKASH SAMITI MARYADIT",
"JILA ANTYAVASAYI SAHKARI VIKAS SAMITI MARYADIT",
"JILA AYUSH ADHIKARI BHOPAL MADHYA PRADESH",
"JILA KRISHI RAKSHA ADHIKARI SAHARANPUR",
"JILA PANCHYAT RAJYA ADHIKARI KARYALAY",
"JILA SAHAKARI KENDRIYA BANK",
"JILA SAHAKARI KENDRIYA BANK MARYADIT DEWAS",
"JILA SAHAKARI KENDRIYA BANK MYDT KHANDWA",
"JILA SAHAKARI SANGH MARYADIT",
"JILA SAMAJ KALYAN ADHIKARI VARANASI",
"JILABA SOFTWARE SERVICES PRIVATE LIMITED",
"JILANI EARTH MOVERS PRIVATE LIMITED",
"JILESH POWER PRIVATE LIMITED",
"JILHA PARISHAD PRATHAMIK SHALA MOI",
"JILHA SHIKSHAN AND PRASHIKSHAN SANSTHA",
"JILL MILL NON-WOVEN PRIVATE LIMITED",
"JILLA UDHYOG KENDRA NAVSARI",
"JILLION BITES PRIVATE LIMITED",
"JILO EXPORTS PRIVATE LIMITED",
"JIMBH INDUSTRIES PRIVATE LIMITED",
"JIMBH INTERNATIONAL PRIVATE LIMITED",
"JIMBRIC CONSULTING (OPC) PRIVATE LIMITED",
"JIMCAP ELECTRONICS PRIVATE LIMITED",
"JIMMY SAREES PRIVATE LIMITED",
"JIMS ENGINEERING MANAGEMENT TECHNICAL CAMPUS",
"JIMS HOMOEOPATHIC MEDICAL COLLEGE AND HOSPITAL",
"JIMS HOSPITAL",
"JIN GRAPHIC PRIVATE LIMITED",
"JIN PLAST (INDIA) LIMITED",
"JIN SUNG ENGINEERING PRIVATE LIMITED",
"JIN TECH AUTOMOTIVE INDIA PRIVATE LIMITED",
"JINA SPECIAL STEEL WORKS PRIVATE LIMITED",
"JINAAM DRESS PRIVATE. LIMITED.",
"JINABAKUL FORGE PRIVATE LIMITED",
"JINAEHAT EXPORT PRIVATE LIMITED",
"JINAGOUDRA MACHINE TOOLS PRIVATE LIMITED",
"JINAL TRADING COMPANY PRIVATE LIMITED",
"JINAL TUBE PRIVATE LIMITED",
"JINAN CHEMICALS PRIVATE LIMITED",
"JINANAM EXPORTS PRIVATE LIMITED",
"JINAY PHARMACEUTICALS PRIVATE LIMITED",
"JIND AGRI SERVICES PRIVATE LIMITED",
"JIND GOHANA HIGHWAY PRIVATE LIMITED",
"JIND INDUSTRIAL AND MANUFACTURING WORKS PRIVATE LIMITED",
"JINDAGI LIVE CONSULTING PRIVATE LIMITED",
"JINDAL ADARSH VIDYALAYA SCHOOL",
"JINDAL ADVANCE MATERIALS PRIVATE LIMITED",
"JINDAL ALLIANCE POLYMER PRIVATE LIMITED",
"JINDAL ALUMINIUM LIMITED",
"JINDAL ART GLASS INNOVATIONS PRIVATE LIMITED",
"JINDAL ARYA IMPEX PRIVATE LIMITED",
"JINDAL AUTOMOTIVE PRIVATE LIMITED",
"JINDAL BARS PRIVATE LIMITED",
"JINDAL BASMATI (INDIA) LIMITED",
"JINDAL BIOTECH PRIVATE LIMITED",
"JINDAL BUILDMART LIMITED",
"JINDAL BUILDSYS LIMITED",
"JINDAL CAPITAL LIMITED",
"JINDAL CHEMTECH INDIA PRIVATE LIMITED",
"JINDAL COATINGS PRIVATE LIMITED",
"JINDAL COKE LIMITED",
"JINDAL COMBINES PVT LTD",
"JINDAL COMPOSITE TUBES PRIVATE LIMITED",
"JINDAL CONSULTANCY SERVICES PRIVATE LIMITED",
"JINDAL COTEX LIMITED",
"JINDAL COTSPIN PRIVATE LIMITED",
"JINDAL CREATIONS INC",
"JINDAL CREATIONS PRIVATE LIMITED",
"JINDAL CROP SCIENCES PRIVATE LIMITED",
"JINDAL DENIM INDIA PRIVATE LIMITED",
"JINDAL DENIMS INC",
"JINDAL DIAMONDS & GEMS PRIVATE LIMITED",
"JINDAL DOODH BHANDAR PRIVATE LIMITED",
"JINDAL DRILLING AND INDUSTRIES LIMITED",
"JINDAL DRUGS PRIVATE LIMITED",
"JINDAL DYECHEM INDUSTRIES PRIVATE LIMITED",
"JINDAL ELECTROCHEM ENGINEERS PRIVATE LIMITED",
"JINDAL ELECTRONICS PRIVATE LIMITED",
"JINDAL EPC SERVICES PRIVATE. LIMITED",
"JINDAL EXPORTS AND IMPORTS PRIVATE LIMITED.",
"JINDAL FAB TEX PRIVATE LIMITED",
"JINDAL FABRICS PRIVATE LIMITED",
"JINDAL FASTENERS PVT LTD",
"JINDAL FIBRES PRIVATE LIMITED",
"JINDAL FILAMENTS PRIVATE LIMITED",
"JINDAL FILMS INDIA LIMITED",
"JINDAL FITTINGS LIMITED",
"JINDAL FLOCKS PRIVATE LIMITED",
"JINDAL FORGING PRIVATE LIMITED",
"JINDAL FUTURES PRIVATE LIMITED",
"JINDAL GAS APPLIANCES PRIVATE LIMITED",
"JINDAL GENERAL SERVICES PRIVATE LIMITED",
"JINDAL GLOBAL FINANCE AND INVESTMENT LIMITED",
"JINDAL GREEN HOMES PRIVATE LIMITED",
"JINDAL HAND TEX PRIVATE LIMITED.",
"JINDAL HIRE PURCHASE PRIVATE LIMITED",
"JINDAL HITECH PRIVATE LIMITED",
"JINDAL HOLIDAYS PVT LTD",
"JINDAL HOME PRODUCTS PVT LTD",
"JINDAL HOTELS LIMITED",
"JINDAL INDIA LIMITED",
"JINDAL INDIA POWERTECH LIMITED",
"JINDAL INDIA THERMAL POWER LIMITED",
"JINDAL INDUSTRIES PRIVATE LIMITED",
"JINDAL INFOSOLUTIONS LIMITED",
"JINDAL INFRAPROJECTS PRIVATE LIMITED",
"JINDAL INFRASTRUCTURE AND UTILITIES LIMITED",
"JINDAL INFRASTRUCTURES PRIVATE LIMITED",
"JINDAL INTELLICOM LIMITED",
"JINDAL INTERNATIONAL PRIVATE LIMITED",
"JINDAL ITF LIMITED",
"JINDAL LIFECARE PRIVATE LIMITED",
"JINDAL LIFESTYLE LIMITED",
"JINDAL MARBLE PVT. LTD.",
"JINDAL MARMO IMPEX PRIVATE LIMITED",
"JINDAL MECHNO BRICKS PRIVATE LIMITED",
"JINDAL MECTEC INSULATION PRIVATE LIMITED",
"JINDAL MECTEC PRIVATE. LIMITED.",
"JINDAL MEDICAL AND SCIENTIFIC INSTRUMENTS COMPANY PRIVATE LIMITED",
"JINDAL MEDICINES PVT LTD",
"JINDAL MITTAL GRAHA NIRMAN PRIVATE LIMITED",
"JINDAL MULTITRADE PRIVATE LIMITED",
"JINDAL NATURECARE LIMITED",
"JINDAL NATURECURE INSTITUTE",
"JINDAL NICKEL AND ALLOYS LTD",
"JINDAL OFFSET INDIA PRIVATE LIMITED",
"JINDAL OILS INDUSTRIES PRIVATE LIMITED",
"JINDAL OVERSEAS CORPORATION",
"JINDAL PACKERS AND MOVERS PRIVATE LIMITED",
"JINDAL PADDY PROCESSORS PRIVATE LIMITED",
"JINDAL PADDY PRODUCTS PRIVATE LIMITED",
"JINDAL PANTHER CEMENT PRIVATE LIMITED",
"JINDAL PE-X TUBES PRIVATE LIMITED",
"JINDAL PHOTO LIMITED",
"JINDAL PIPES LIMITED",
"JINDAL PLASPACK ENTERPRISES PRIVATE LIMITED",
"JINDAL PLY (INDIA) PRIVATE LIMITED",
"JINDAL POLY FILMS LIMITED",
"JINDAL POLY INVESTMENT AND FINANCE COMPANY LIMITED",
"JINDAL POLY WEAVES PRIVATE LIMITED",
"JINDAL POLYBUTTONS PRIVATE LIMITED",
"JINDAL POLYTUBES PRIVATE LIMITED",
"JINDAL POLYWRAP PRIVATE LIMITED",
"JINDAL POWER LIMITED",
"JINDAL PREFAB PRIVATE LIMITED",
"JINDAL PREMIUM CONNECTIONS PRIVATE LIMITED",
"JINDAL PRIME FOODS PRIVATE LIMITED",
"JINDAL PROMOTERS PRIVATE LIMITED.",
"JINDAL QUALITY TUBULAR LIMITED",
"JINDAL RAIL INFRASTRUCTURE LIMITED",
"JINDAL RAYONS PRIVATE LIMITED",
"JINDAL REALTY LIMITED",
"JINDAL REFINERIES LIMITED",
"JINDAL RESOURCES PRIVATE LIMITED",
"JINDAL RETAIL INDIA PRIVATE LIMITED",
"JINDAL RICE & GENERAL MILLS",
"JINDAL ROADWAYS PRIVATE LIMITED",
"JINDAL ROLLING MILLS PRIVATE LIMITED",
"JINDAL SANITARYWARE PRIVATE LIMITED",
"JINDAL SANJEEVANI MULTISPECIALITY HOSPITAL",
"JINDAL SAREE CENTRE PRIVATE LIMITED",
"JINDAL SAW LIMITED",
"JINDAL SMI COATED PRODUCTS LIMITED",
"JINDAL SOFT ITALIA SEATING PRIVATE LIMITED",
"JINDAL SPECIALTY TEXTILES LIMITED",
"JINDAL SPICY FOODS TECH LTD",
"JINDAL SPINNING MILLS LIMITED",
"JINDAL STAINLESS CONSULTANCY SERVICES PRIVATE LIMITED",
"JINDAL STAINLESS CORPORATE MANAGEMENT SERVICES PRIVATE LIMITED",
"JINDAL STAINLESS HISAR LIMITED",
"JINDAL STAINLESS LIMITED",
"JINDAL STAINLESS STEELWAY LIMITED",
"JINDAL STEEL & ALLOYS LIMITED",
"JINDAL STEEL AND POWER LIMITED",
"JINDAL STEEL TUBES LIMITED",
"JINDAL STRIPS LIMITED",
"JINDAL SUPREME INDIA PRIVATE LIMITED",
"JINDAL SYNFUELS",
"JINDAL SYSTEMS PRIVATE LIMITED",
"JINDAL TAPES PRIVATE LIMITED",
"JINDAL TECHNOLOGIES AND MANAGEMENT SERVICES PRIVATE LIMITED",
"JINDAL TECHSERV PRIVATE LIMITED",
"JINDAL TEX TRADING PRIVATE LIMITED",
"JINDAL TEXOFAB LIMITED",
"JINDAL TRADING COMPANY PRIVATE LIMITED",
"JINDAL TUBULAR INDIA LIMITED",
"JINDAL UNITED STEEL LIMITED",
"JINDAL URBAN WASTE MANAGEMENT",
"JINDAL URBAN WASTE MANAGEMENT (AHMEDABAD) LIMITED",
"JINDAL URBAN WASTE MANAGEMENT (GUNTUR) LIMITED",
"JINDAL URBAN WASTE MANAGEMENT VISAKHAPATNAM LIMITED",
"JINDAL VALUE STEELS PRIVATE LIMITED",
"JINDAL VALVES PRIVATE LIMITED",
"JINDAL VEGETABLE PRODUCTS LIMITED",
"JINDAL VIDYUT PRODUCTS PRIVATE LIMITED",
"JINDAL WOOD PRODUCTS PRIVATE LIMITED",
"JINDAL WOOLLEN INDUSTRIES LIMITED",
"JINDAL WORLDWIDE LIMITED",
"JINDAL YARNS PRIVATE LIMITED",
"JINDALCO METAL PRIVATE LIMITED",
"JINDALS GRANITE PRIVATE LIMITED",
"JINDALSOCKS GLOBAL PRIVATE LIMITED",
"JINDALSONS INFRATEX PRIVATE LIMITED",
"JINDAT SILK MILLS PRIVATE LIMITED",
"JINDBA PROCESSORS PRIVATE LIMITED",
"JINDER AUTO PRIVATE LIMITED",
"JINDO CHEMICAL SOLUTIONS PRIVATE LIMITED",
"JINDUTT MINERALS PVT LTD",
"JINEN INDUSTRIES PRIVATE LIMITED",
"JINENDRA ENTERPRISE PRIVATE LIMITED",
"JINENDRA INFRACON PRIVATE LIMITED",
"JINENDRA ISPAT PRIVATE LIMITED",
"JINENDRA QUALIPHARM PRIVATE LIMITED",
"JINENDRAM TEXSPIN PRIVATE LIMITED",
"JINESH CHEMICALS PRIVATE LIMITED",
"JINESH FASHION PRIVATE LIMITED",
"JINESH MINERALS PRIVATE LIMITED",
"JINESHVAR SECURITIES PRIVATE LIMITED",
"JINESHWAR ENTERPRISES PVT LTD",
"JINESHWAR EXIM PRIVATE LIMITED",
"JINESHWAR FABRIC",
"JINESHWAR INFRA VENTURES PRIVATE LIMITED",
"JINESHWAR KNITTING PRIVATE LIMITED",
"JINESHWAR WRITING INSTRUMENTS LIMITED",
"JINFEI TRADING INDIA PRIVATE LIMITED",
"JINGLE BELLS PUBLIC SCHOOL",
"JINGLETOONS ANISKOOL PRIVATE LIMITED",
"JINHARSH INDUSTRIAL SOLUTIONS PRIVATE LIMITED",
"JINIGRAM CONSULTING SERVICES PRIVATE LIMITED",
"JINIL ENC INDIA PRIVATE LIMITED",
"JININIMI DESIGN STUDIO PRIVATE LIMITED",
"JINKORP INTERNATIONAL TRAVEL SERVICES",
"JINKOSOLAR TRADING PRIVATE LIMITED",
"JINKUSHAL ALLOYS AND COMMODITIES PRIVATE LIMITED",
"JINKUSHAL FERROMET PRIVATE LIMITED",
"JINKUSHAL INDUSTRIES PRIVATE LIMITED",
"JINOYAL INDUSTRIES PRIVATE LIMITED",
"JINRAJ ENGINEERING COMPANY PVT LTD.",
"JINRONG BANGALORE PRECISION MACHINERY PRIVATE LIMITED",
"JINSUNG SYSTEM INDIA PRIVATE LIMITED",
"JINTAN EXPORTS PRIVATE LIMITED",
"JINTECH AUTOMOTIVE INDIA P LIMITED",
"JINTECH SOLUTION LIMITED",
"JINTEX INDIA CO. PRIVATE LIMITED",
"JIN-X HEALTH CARE PRIVATE LIMITED",
"JINYOUNG SANDHAR MECHATRONICS PRIVATE LIMITED",
"JIO DIGITAL FIBRE PRIVATE LIMITED",
"JIO FINANCE LIMITED",
"JIO FINANCIAL SERVICES LIMITED",
"JIO HAPTIK TECHNOLOGIES¬† LIMITED",
"JIO INFRASTRUCTURE MANAGEMENT SERVICES LIMITED",
"JIO INSURANCE BROKING LIMITED",
"JIO LIMITED",
"JIO MEDIA LIMITED",
"JIO PAYMENTS BANK LIMITED",
"JIO PLATFORMS LIMITED",
"JIO STEEL INDIA",
"JIO THINGS LIMITED",
"JIOMEX AUTO (INDIA) PRIVATE LIMITED",
"JIPRA CONSTRUCTIONS PRIVATE LIMITED",
"JIPS PHARMACEUTICALS PRIVATE LIMITED",
"JIPS PLASTO INDUSTRIES PRIVATE LIMITED",
"JIPSAAN SOLUTION OPC PRIVATE LIMITED",
"JIPVI ECOMMERCE PRIVATE LIMITED",
"JIRAWALA PLASTECH PRIVATE LIMITED",
"JIRAWALA TEXTILES PRIVATE LIMITED",
"JIRAWALA TRAVELS PRIVATE LIMITED",
"JIREH INTERNATIONAL PRIVATE LIMITED",
"JIS BUSINESS SOLUTIONS PRIVATE LIMITED",
"JIS COLLEGE OF ENGINEERING",
"JIS INSTITUTE OF SKILL DEVELOPMENT",
"JIS SCHOOL OF POLYTECHNIC",
"JIS UNIVERSITY",
"JIS VACATIONS PRIVATE LIMITED",
"JISA SOFTECH PRIVATE LIMITED",
"JISHNU PHARMACEUTICALS PRIVATE LIMITED",
"JISHU INDIA ELECTRONICS PRIVATE LIMITED",
"JISK TRADERS",
"JISNU COMMUNICATIONS LIMITED",
"JISNU COMMUNICATIONS PRIVATE LIMITED",
"JIT GLOBAL FREIGHT SOLUTIONS PRIVATE LIMITED",
"JIT MULTILAYERS PRIVATE LIMITED",
"JITA MULTITRADERS PRIVATE LIMITED",
"JITAMITRA ELECTRO ENGINEERING PRIVATE LIMITED",
"JITEEN AUTOMOBILES PRIVATE LIMITED",
"JITEN AGRO LAND AND FARM PRIVATE LIMITED",
"JITEN FOODS AND FLAVOURS PRIVATE LIMITED",
"JITENDRA AUTOMOBILES PRIVATE LIMITED",
"JITENDRA ELECTRICALS & MULTITRADING PRIVATE LIMITED",
"JITENDRA IMPEX PRIVATE LIMITED",
"JITENDRA NEW EV TECH PRIVATE LIMITED",
"JITENDRA PASHU AAHAR PVT. LTD.",
"JITENDRA PHARMA PRIVATE LIMITED",
"JITENDRA SAW MILL & CO.PRIVATE LIMITED",
"JITENDRA SINGH DEVGAD KALADGI HIGHWAY PRIVATE LIMITED",
"JITENDRA SYNTHETICS PRIVATE LIMITED",
"JITENDRA WHEELS NASIK PRIVATE LIMITED",
"JITENDRASINGH INFRASTRUCTURE PRIVATE LIMITED",
"JITESH FAB PRIVATE LIMITED",
"JITF COMMODITY TRADEX LIMITED",
"JITF ESIPL CETP (SITARGANJ) LIMITED",
"JITF INFRALOGISTICS LIMITED",
"JITF SHIPYARDS LIMITED",
"JITF URBAN INFRASTRUCTURE",
"JITF URBAN INFRASTRUCTURE SERVICES LIMITED",
"JITIN CHAWLA'S CENTRE FOR CAREER DEVELOPMENT",
"JITM SKILLS PRIVATE LIMITED",
"JITMAL CHHAJED VIDYALAYA",
"JITO EDUCATIONAL AND MEDICAL TRUST",
"JITO INCUBATION AND INNOVATION FOUNDATION",
"JITO TRADE & BUSINESS CONNECT PRIVATE LIMITED",
"JITODIYA PRIMARY SCHOOL",
"JITSU MOTORS PRIVATE LIMITED",
"JIVA AGSERVICES PRIVATE LIMITED",
"JIVA AYURVEDIC PHARMACY LIMITED",
"JIVA DESIGNS PRIVATE. LIMITED",
"JIVA INTERNET SOLUTIONS PRIVATE LIMITED",
"JIVA SCIENCES PRIVATE LIMITED",
"JIVA TECH SURGICALS PRIVATE LIMITED",
"JIVAA MRI CENTRE PRIVATE LIMITED",
"JIVAA RETAILS INDIA PRIVATE LIMITED",
"JIVAASRI WELLNESS PRIVATE LIMITED",
"JIVABHUMI AGRI TECH PRIVATE LIMITED",
"JIVAGRO LIMITED",
"JIVAKA HEALTH CARE PRIVATE LIMITED",
"JIVALOGICS BIOTECH (INDIA) PRIVATE LIMITED",
"JIVAMRIT ORGANIC FARMER PRODUCER COMPANY LIMITED",
"JIVAN JYOT HIGHER SECONDARY SCHOOL",
"JIVAN JYOT HOSPITAL & ICU",
"JIVAN KALA MANDAL PARNERKAR MAHARAJ VIDYALAYA MANJARSUMBA BEED",
"JIVAN MILK & AGRO PROCESSING PRIVATE LIMITED",
"JIVAN SANSKAR VIDYALAYA",
"JIVAN VANIJYA PVT LTD",
"JIVANDEEP MULTISPECIALITY SURGICARE PRIVATE LIMITED",
"JIVANDEEP VIDYALAYA",
"JIVANDHARA COTTON INDUSTRIES",
"JIVANDHARA PHARMA PRIVATE LIMITED",
"JIVANJYOT MOTORS PRIVATE LIMITED",
"JIVANYOG TRUST",
"JIVATI ECOFRESH PRIVATE LIMITED",
"JIVDAYA CHARITABLE TRUST",
"JIVIKA AGENCIES PRIVATE LIMITED",
"JIVIKA FOOT CARE PRIVATE LIMITED",
"JIVITA HEALTHCARE PRIVATE LIMITED",
"JIVKAR SEEDS PRIVATE LIMITED",
"JIVKORBAI LALLUBHI HIGHER SECONDARY SCHOOL",
"JIVMON TECH SOLUTIONS PRIVATE LIMITED",
"JIVO WELLNESS PRIVATE LIMITED",
"JIVOX SOFTWARE INDIA PRIVATE LIMITED",
"JIVRAJ COMMERCE PRIVATE LIMITED",
"JIVRAJ INDUSTRIES LIMITED",
"JIVRAJ TEA INTERNATIONAL PRIVATE LIMITED",
"JIVRAJ TEA LIMITED",
"JIWADAYA HEALTHCARE PRIVATE LIMITED",
"JIWAJI UNIVERSITY GWALIOR",
"JIWAN AUTO PRIVATE LIMITED",
"JIWAN BOOKS INTERNATIONAL PVT LTD",
"JIWAN DASS & GRANDSONS PRIVATE LIMITED",
"JIWAN LAXMI CONSTRUCTION PRIVATE LIMITED",
"JIWAN LIME CHEMICALS PVT LTD",
"JIWAN METAFINS LIMITED",
"JIWAN PUBLISHING HOUSE PRIVATE LTD",
"JIWAN SAGAR PROMOTORS PVT. LTD.",
"JIWANDASS DESRAJ PRIVATE LIMITED",
"JIWANI CONSTRUMA PRIVATE LIMITED",
"JIWANJYOTI SALES PRIVATE LIMITED",
"JIWANJYOTI VINIMAY PRIVATE LIMITED",
"JIWANRAM SHEODUTTRAI INDUSTRIES LIMITED",
"JIWANRAM SHEODUTTRAI INDUSTRIES PRIVATE LIMITED",
"JIWANRAM SHEODUTTRAI PVT LTD",
"JIWANSAGAR TIMES PRIVATE LIMITED",
"JIWANSAGAR TOWERS PRIVATE LIMITED",
"JIWARAJKA INDUSTRIES PRIVATE LIMITED",
"JIWARAJKA TEXTILE INDUSTRIES",
"JIYA & JAY IMPEX PRIVATE LIMITED",
"JIYA EXIM PRIVATE LIMITED",
"JIYA LIQUORS PRIVATE LIMITED",
"JIYA STEEL PRIVATE LIMITED",
"JIYADIYA ENTERPRISES PRIVATE LIMITED",
"JIYAJEE SUITINGS PRIVATE LIMITED",
"JIYANJANI TECHNOLOGIES PRIVATE LIMITED",
"JIYO STAINLESS PRIVATE LIMITED",
"JIZHI MECHATRONIC INDIA PRIVATE LIMITED",
"JIZOSOFT PRIVATE LIMITED",
"JJ COATINGS PRIVATE LIMITED",
"JJ COLLEGE OF ENGINEERING AND TECHNOLOGY",
"JJ CONSULTANTS PRIVATE LIMITED",
"JJ ELECTROTECH PRIVATE LIMITED",
"JJ FINCAP PRIVATE LIMITED",
"JJ FINTAX SOLUTIONS PRIVATE LIMITED",
"JJ GROUP OF HOSPITALS",
"JJ MODULAR FURNITURES PRIVATE LIMITED",
"JJ PHARMACY COLLEGE",
"JJ PLUS HOSPITALS PRIVATE LIMITED",
"JJ PV SOLAR LIMITED",
"JJ PV SOLAR PRIVATE LIMITED",
"JJ RETAIL FIXTURES PRIVATE LIMITED",
"JJ STAFFING PRIVATE LIMITED",
"JJ STAMPINGS PRIVATE LIMITED",
"JJ ULTRA ELECTRO PRIVATE LIMITED",
"JJ WALLS FLOORS & MORE PRIVATE LIMITED",
"JJ WASTE SOLUTION PRIVATE LIMITED",
"JJC DIAMONDS (MUMBAI) PRIVATE LIMITED",
"JJC ENGINEERING PRIVATE LIMITED",
"JJCO PRESS METAL PRIVATE LIMITED",
"JJDJ CONSTRUCTIONS PRIVATE LIMITED",
"JJF CASTINGS LIMITED",
"JJG AERO PRIVATE LIMITED",
"JJG MACHINING PRIVATE LIMITED",
"JJIT FINTECH PRIVATE LIMITED",
"JJK HOTELS & RESORTS PRIVATE LIMITED",
"JJK MANAGEMENT AND FINANCIAL CONSULTANTS PRIVATE LIMITED",
"JJM CONSULTANTS AND DISTANCE LEARNING PRIVATE LIMITED",
"JJM MEDICAL COLLEGE",
"JJOSHI INFRA-PROJECTS PRIVATE LIMITED",
"JJR ENGINEERING AND CONSTRUCTIONS PRIVATE LIMITED",
"JJREALIS INDIA PRIVATE LIMITED",
"JJRS CONSTRUCTION PRIVATE LIMITED",
"JJRS PROJECTS",
"JJS ENGINEERS (INDIA) PRIVATE LIMITED",
"JJS INFOSOLUTION AND TECHNOLOGIES PRIVATE LIMITED",
"JJSS FARMHOUSE & DEVELOPERS PRIVATE LIMITED",
"JJUAN INDIA PRIVATE LIMITED",
"JJUST MUSIC LABEL PRIVATE LIMITED",
"JK AGRI GENETICS LIMITED",
"JK ASSOCIATES PRIVATE LIMITED",
"JK BK COLLEGE",
"JK BOTANICALS PRIVATE LIMITED",
"JK CHANNEL PRIVATE LIMITED",
"JK CIVIL CONSTRUCTIONS PRIVATE LIMITED",
"JK CORPORATE SOLUTIONS PRIVATE LIMITED",
"JK CROP SCIENCE PRIVATE LIMITED",
"JK DISTRIBUTORS PRIVATE LIMITED",
"JK ELECTRIC ENGINEERS PRIVATE LIMITED",
"JK FABTEX INDUSTRIES PRIVATE LIMITED",
"JK FILES & ENGINEERING LIMITED",
"JK FITWELL PRIVATE LIMITED",
"JK GARMENTS & READYMADES",
"JK GYPSUM PRIVATE LIMITED",
"JK INSURANCE BROKERS LIMITED",
"JK LAKSHMI CEMENT LIMITED",
"JK LAKSHMIPAT UNIVERSITY",
"JK LIFESTYLE PRIVATE LIMITED",
"JK MATTING HOUSE PRIVATE LIMITED",
"JK MEDICAL SYSTEMS PRIVATE LIMITED",
"JK MEDICITY HOSPITAL PRIVATE LIMITED",
"JK MINES EXPLORATION PRIVATE LIMITED",
"JK MULTIPURPOSE COLD STORAGE PRIVATE LIMITED",
"JK OFFSET GRAPHICS PRIVATE LIMITED",
"JK PAPER LIMITED",
"JK PETROENERGY PRIVATE LIMITED",
"JK PRESSTECH PRODUCTS PRIVATE LIMITED",
"JK RESTAURANT",
"JK RETAIL PRIVATE LIMITED",
"JK SEALS (INDIA) PRIVATE LIMITED",
"JK SECURITIES PRIVATE LIMITED",
"JK SOLAR PRIVATE LIMITED",
"JK SONS ENGINEERS PRIVATE. LIMITED.",
"JK SONS PRECIOUS METALS LIMITED",
"JK SPINNERS PRIVATE LIMITED",
"JK SUPPLIES & SOLUTIONS PRIVATE LIMITED",
"JK TALABOT LIMITED",
"JK TYRE & INDUSTRIES LIMITED",
"JK URBANSCAPES DEVELOPERS LIMITED",
"JKAGRO INDUSTRIES PRIVATE LIMITED",
"JKAV THERMOCOL AND PACKAGING PRIVATE LIMITED",
"JKB ENGINEERS",
"JKB EXIM PRIVATE LIMITED",
"JKB GAS PRIVATE LIMITED",
"JKB HOUSING PRIVATE LIMITED",
"JKB INFRASTRUCTURE PRIVATE LIMITED",
"JKB TVASTRA HANDICRAFTS PRIVATE LIMITED",
"JKC BUILDERS PRIVATE LIMITED",
"JKD ENGINEERS & INFRASTRUCTURE PRIVATE LIMITED",
"JKD FUTURE MART PRIVATE LIMITED",
"JKD PEARL INDIA DEVELOPERS PRIVATE LIMITED",
"JKEW METALEC LIMITED",
"JKEW TURN-TECH PRIVATE LIMITED",
"JKG CONSTRUCTION PRIVATE LIMITED",
"JKG EXIMCON PRIVATE LIMITED",
"JKG INFRATECH PRIVATE LIMITED",
"JKG ORGANICS PRIVATE LIMITED",
"JKG OVERSEAS PRIVATE LIMITED",
"JKG REALTECH PRIVATE LIMITED",
"JKI INFRASTRUCTURE PRIVATE LIMITED",
"JKIG AUTOMOTIVE INDIA PRIVATE LIMITED",
"JKITCO LIMITED",
"JKJ SONS EXPORT PRIVATE LIMITED",
"JKL INDIA SOLUTIONS PRIVATE LIMITED",
"JKM (INDORE) REALTY PRIVATE LIMITED",
"JKM ENGINEERING PRIVATE LIMITED",
"JKM ENGINEERS PRIVATE LIMITED",
"JKM ENTERPRISES PRIVATE LIMITED",
"JKM HUMAN RESOURCES PRIVATE LIMITED",
"JKM INFRASTRUCTURE PRIVATE LIMITED",
"JKM JEWELS & JEWELLERS PRIVATE LIMITED",
"JKM MAKFIN PVT LTD",
"JKM MOTORS PRIVATE LIMITED",
"JKM ORGANICS AND HERBS PRIVATE LIMITED",
"JKM OVERSEAS PRIVATE. LIMITED",
"JKM VENTURES PRIVATE LIMITED",
"JKMK FERRO ALLOYS PRIVATE LIMITED",
"JKN ENTERPRISES PRIVATE LIMITED",
"JKP AGRO FOODS PRIVATE LIMITED",
"JKP MICROMINERALS (INDIA) PRIVATE LIMITED",
"JKR BUILDERS PRIVATE LIMITED",
"JKR ENTERPRISE LIMITED",
"JKR HOSPITALITY SERVICES PRIVATE LIMITED",
"JKR REALTY PRIVATE LIMITED",
"JKR SONA MANDI JEWELLERS PRIVATE LIMITED",
"JKS AND SONS PRIVATE LIMITED",
"JKS ENGINEERING PRIVATE LIMITED",
"JKS INDIA HOLDINGS LIMITED",
"JKS INFRASTRUCTURE PRIVATE LIMITED",
"JKS INNOVATIVE CONSTRUCTION PRIVATE LIMITED",
"JKS JEWELS PRIVATE LIMITED",
"JKS MATCHES PRIVATE LIMITED",
"JKS PRECISION ENGINEERING PRIVATE LIMITED",
"JKSR INDUSTRIES INDIA PRIVATE LIMITED",
"JKT ENTERPRISES PRIVATE LIMITED",
"JKT LEARNING SOLUTIONS PRIVATE LIMITED",
"JKUMAR BUILDTECH PRIVATE LIMITED",
"JKV INFRACON (I) PRIVATE LIMITED",
"JKVB PROPERTIES PVT. LTD.",
"JKW CHEMICALS PRIVATE LIMITED",
"JL CHATURVEDI COLLEGE OF PHARMACY",
"JL DAGA MINES AND MINERALS PRIVATE LIMITED",
"JLA LOGISTICS AND MOTORS PRIVATE LIMITED",
"JLAC IT SOLUTIONS PRIVATE LIMITED",
"JLAL FOODS PRIVATE LIMITED",
"JLC ELECTROMET PRIVATE LIMITED",
"JLCITY PHARMA INDIA PRIVATE LIMITED",
"JLD BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"JLD ESTATES PRIVATE LIMITED",
"JLD HITECH INDUSTRIES PRIVATE LIMITED",
"JLK OVERSEAS PRIVATE LIMITED",
"JLKD HEALTHCARE PRIVATE LIMITED",
"JLLC NATIVITA",
"JLM CONFECTIONERY AND FOOD PRODUCT PRIVATE LIMITED",
"JLN GOVT COLLEGE",
"JLN HOSPITAL",
"JLNPHENIX ENERGY PRIVATE LIMITED",
"JLPL INFRASTRUCTURES PRIVATE LIMITED",
"JLPN MARKETING SERVICES PRIVATE LIMITED",
"JLT INDEPENDENT INSURANCE BROKERS PRIVATE LIMITED",
"JLT INDIA PRIVATE LIMITED",
"JLTM ENERGY INDIA PRIVATE LIMITED",
"JM ALUMINIUM LLP",
"JM ANNA IDLY CAFE PRIVATE LIMITED",
"JM BIO TECH PVT LTD",
"JM ENTRANCE AUTOMATION PRIVATE LIMITED",
"JM ENVIRO TECHNOLOGIES PRIVATE LIMITED",
"JM EXPRESS PRIVATE LIMITED",
"JM FINANCIAL",
"JM FINANCIAL ASSET MANAGEMENT LIMITED",
"JM FINANCIAL ASSET RECONSTRUCTION COMPANY PRIVATE LIMITED",
"JM FINANCIAL COMMTRADE LIMITED",
"JM FINANCIAL CREDIT SOLUTIONS LIMITED",
"JM FINANCIAL HOME LOANS LIMITED",
"JM FINANCIAL INSTITUTIONAL SECURITIES LIMITED",
"JM FINANCIAL PRODUCTS LIMITED",
"JM FINANCIAL PROPERTIES AND HOLDINGS LIMITED",
"JM FINANCIAL SERVICES LIMITED",
"JM FRICTECH INDIA PRIVATE LIMITED",
"JM GLOBAL COMMODITIES PRIVATE LIMITED",
"JM HOLDINGS PVT LTD",
"JM HOSIERY & COMPANY LIMITED",
"JM HOSIERY MILLS PRIVATE LIMITED",
"JM HOUSING LIMITED",
"JM HYDRAULIC SOLUTIONS PRIVATE LIMITED",
"JM INTEGRATED SOLUTIONS PRIVATE LIMITED",
"JM KNITWEAR AND GREEN ENERGY PRIVATE LIMITED",
"JM KNITWEAR PRIVATE LIMITED",
"JM TECH TALENT IT SERVICES PRIVATE LIMITED",
"JM ZHONGKAI CHEMICAL EQUIPMENT LLP",
"JMA IT SOLUTIONS PRIVATE LIMITED",
"JMA MARKETING LIMITED",
"JMAN DIGITAL SERVICES PRIVATE LIMITED",
"JMARK BROADCAST PRIVATE LIMITED",
"JMATEK INDIA PRIVATE LIMITED",
"JMB AQUA AGRO PRIVATE LIMITED",
"JMB EXIM AND GEMS PRIVATE LIMITED",
"JMB PHARMACEUTICALS PRIVATE LIMITED",
"JMB RICE MILL PRIVATE LIMITED",
"JMBC COTTFIBER PRIVATE LIMITED",
"JMC AUTOMOTIVE COMPONENTS PRIVATE LIMITED",
"JMC CONSTRUCTIONS PRIVATE LIMITED",
"JMC INFRATECH PRIVATE LIMITED",
"JMC METALS PRIVATE LIMITED",
"JMC PAPER TECH PRIVATE LIMITED",
"JMC PROJECTS INDIA LIMITED",
"JMCC INFRA PROJECTS PRIVATE LIMITED",
"JMD ABODE AND BANQUETS PRIVATE LIMITED",
"JMD AIR CARGO PRIVATE LIMITED",
"JMD ALL-CAR-MALL PRIVATE LIMITED",
"JMD ALLOYS LIMITED",
"JMD AUTO INDIA PRIVATE LIMITED",
"JMD AUTO INDUSTRIES AND TOOLS MANUFACTURERS PRIVATE LIMITED",
"JMD BULLION PRIVATE LIMITED",
"JMD CARGO PRIVATE LIMITED",
"JMD CLEARING & FORWARDING INDIA PRIVATE LIMITED",
"JMD CONSULTANTS PRIVATE LIMITED",
"JMD DIAGNOSTICS PRIVATE LIMITED",
"JMD DIGITAL ART XCHANGE PRIVATE LIMITED",
"JMD FOREIGN EXCHANGE PRIVATE LIMITED",
"JMD FOREX PRIVATE LIMITED",
"JMD HERITAGE LAWNS PRIVATE LIMITED",
"JMD INFOTECH PRIVATE LIMITED",
"JMD LIFECARE PRIVATE LIMITED",
"JMD LIMITED",
"JMD MARKETING PRIVATE LIMITED",
"JMD MAYA MARKETING PRIVATE LIMITED",
"JMD NUTS (INDIA) TRADING PRIVATE LIMITED",
"JMD PALACE AND RESORTS PRIVATE LIMITED",
"JMD PET PRODUCTS PRIVATE LIMITED",
"JMD PRECISION EQUIPMENTS PRIVATE LIMITED",
"JMD RAILTECH PRIVATE LIMITED",
"JMD SCIENTIFIC EQUIPMENTS PRIVATE LIMITED",
"JMD SERVICES PRIVATE LIMITED",
"JMD SOUNDS LTD",
"JMD SUPER INFRATECH PRIVATE LIMITED",
"JMD SUPPLYCHAIN SOLUTION PRIVATE LIMITED",
"JMD TEXFAB PRIVATE LIMITED",
"JMD VACATIONS PRIVATE LIMITED",
"JMD VENTURES LIMITED",
"JMDMS IRON ORE PRIVATE LIMITED",
"JMDVFM CARS INDIA PRIVATE LIMITED",
"JMF PERFORMANCE MATERIALS PRIVATE LIMITED",
"JMG CORPORATION LIMITED",
"JMG PROJECTS PRIVATE LIMITED",
"JMGI ABRASIVES INDIA PRIVATE LIMITED",
"JMJ CONTAINER SOLUTIONS",
"JMJ FINANCE LIMITED",
"JMJ FINTECH LIMITED",
"JMJ JEWELLERS PRIVATE LIMITED",
"JMJ LOGISTICS PRIVATE LIMITED",
"JMK AUTO PRIVATE LIMITED",
"JMK ENTERPRISES PRIVATE LIMITED",
"JMK FREIGHT SOLUTIONS PRIVATE LIMITED",
"JMK GEC REALTORS PRIVATE LIMITED",
"JMK HOLDINGS PRIVATE LIMITED",
"JMK INFOSOFT SOLUTIONS LIMITED",
"JMK JEWELS PRIVATE LIMITED",
"JMK MOTORS PRIVATE LIMITED",
"JMK MOTOWHEELS PRIVATE LIMITED",
"JMK SONI EXPORTS PRIVATE LIMITED",
"JMKC JEWELS PRIVATE LIMITED",
"JML CONSTRUCTION PRIVATE LIMITED",
"JML ENTERPRISES PRIVATE LIMITED",
"JML FINANCIAL SERVICES PRIVATE LIMITED",
"JMM FORMULATION PRIVATE LIMITED",
"JMM SPICES PRIVATE LIMITED",
"JMN INFOTECH PRIVATE LIMITED",
"JMN INVESTMENTS RESEARCH PRIVATE LIMITED",
"JMP ADVISORS PRIVATE LIMITED",
"JMP INDUSTRY PRIVATE LIMITED",
"JMP TEXTILES PRIVATE LIMITED",
"JMP TRADING AND PROPERTIES PRIVATE LIMITED",
"JMPROSPERIOS PRIVATE LIMITED",
"JMR DESIGNS PRIVATE LIMITED",
"JMR FREIGHT FORWARDER PRIVATE LIMITED",
"JMR INFOTECH INDIA PRIVATE LIMITED",
"JMR JEWELLERS PRIVATE LIMITED",
"JMR STEELS PRIVATE LIMITED",
"JMS BIOTECH PRIVATE LIMITED",
"JMS BUILDTECH PRIVATE LIMITED",
"JMS BUILDWELL REALTY PRIVATE LIMITED",
"JMS EXPRESS CLEARING FORWARDING PRIVATE LIMITED",
"JMS MARKETING SERVICES PVT LTD",
"JMS MEDICON PRIVATE LIMITED",
"JMS MEDIEQUIP HEALTHCARE PRIVATE LIMITED",
"JMS MINES & MINERALS PRIVATE LIMITED",
"JMS MINING PRIVATE LIMITED",
"JMS MODERN AIRWEAVES INDIA PRIVATE LIMITED",
"JMS UNIVERSAL TECHNOLOGIES PRIVATE LIMITED",
"JMSA PRIVATE LIMITED",
"JMT AUTO LIMITED",
"JMT CONSULTANTS DETAILING PRIVATE LIMITED",
"JMT VEHICLES PRIVATE LIMITED",
"JMU STAINLESS ALLOYS PRIVATE LIMITED",
"JMV AUTOMOBILES PRIVATE LIMITED",
"JMV FOOD PRODUCTS PRIVATE LIMITED",
"JMV ISPAT PRIVATE LIMITED",
"JMV LOGISTICS PRIVATE LIMITED",
"JMV LPS LIMITED",
"JMV MOTORS PRIVATE LIMITED",
"JMV PAPERS PRIVATE LIMITED",
"JMVD MULTITRADE PRIVATE LIMITED",
"JMW BRICKS AND PAVERS PRIVATE LIMITED",
"JN CHOWDHURY MANUFACTURING TEA PRIVATE LIMITED",
"JN FACILITIES PRIVATE LIMITED",
"JN MACHINERIES PRIVATE LIMITED",
"JN MARMOGRANI PRIVATE LIMITED",
"JNA ELECTRICAL PRIVATE LIMITED",
"JNANA BHARATHI PRAKASHANA LIMITED",
"JNANA GANGA ENGLISH MEDIUM SCHOOL",
"JNANA VIKASA PU COLLEGE",
"JNANADEEPA VIDYA SAMSTHE",
"JNANAJYOTHI PRE-UNIVERSITY COLLEGE",
"JNANAMANDAL PRIVATE LIMITED",
"JNANODAYA CENTRAL SCHOOL",
"JNB MARKETING INDIA PRIVATE LIMITED",
"JND AGRO PRIVATE LIMITED",
"JND EDU MANAGEMENT SERVICES PRIVATE LIMITED",
"JND EDU-REALTY PRIVATE LIMITED",
"JND TRADERS PRIVATE LIMITED",
"JNET TECHNOLOGIES PRIVATE LIMITED",
"JNEX FM (I) PRIVATE LIMITED",
"JNG FASHIONS PRIVATE LIMITED",
"JNG FOOTSTEP PRIVATE LIMITED",
"JNG PROPERTIES AND LEASING PRIVATE LTD",
"JNJ AQUA PRIVATE LIMITED",
"JNJ FINANCECOMPANY PRIVATE LIMITED",
"JNK INDIA LIMITED",
"JNK INDIA PRIVATE LIMITED",
"JNK LIFTERS PRIVATE LIMITED",
"JNM DEVELOPERS PRIVATE LIMITED",
"JNM FOREX PRIVATE LIMITED",
"JNP PRODUCTION AND SERVICES PRIVATE LIMITED",
"JNPT ANTWERP PORT TRAINING AND CONSULTANCY FOUNDATION",
"JNR ROADWAYS PRIVATE LIMITED",
"JNS & ASSOCIATES LLP",
"JNS COMMODITIES & SPECIALITIES PRIVATE LIMITED",
"JNS CREATIONS PRIVATE LIMITED",
"JNS ELECTROPLAST PRIVATE LIMITED",
"JNS INSTRUMENTS LIMITED",
"JNS SYSTECH PRIVATE LIMITED",
"JNT COSMETICS (OPC) PRIVATE LIMITED",
"JNTL CONSUMER HEALTH (INDIA) PRIVATE LIMITED",
"JNTU COLLEGE OF ENG",
"JNV INFRA PRIVATE LIMITED",
"JNV VIRA ENGINEERING PRIVATE LIMITED",
"JO JON ENGINEERING INDUSTRIES PVT LTD",
"JO PHARMA PRIVATE LIMITED",
"JOAMZIEL MARINE CRAFT PRIVATE LIMITED",
"JOANS INFRA VENTURE PRIVATE LIMITED",
"JOARDER RICE MILL PRIVATE LIMITED",
"JOB CLOUD",
"JOB COOKIES INDIA PRIVATE LIMITED",
"JOBBOSS AUTOMATION PRIVATE LIMITED",
"JOBBY ENGINEERS PRIVATE LIMITED",
"JOBBY INDUSTRIAL SERVICES PRIVATE LIMITED",
"JOBIAK SOFTWARE PRIVATE LIMITED",
"JOBIN CHEMICALS PRIVATE LIMITED",
"JOBINSIGHT RECRUITMENT PRIVATE LIMITED",
"JOBIS ENGINEERING PRIVATE LIMITED",
"JOBMOSIS TALENT SOLUTIONS PRIVATE LIMITED",
"JOBNER P G COLLEGE",
"JOBO METALS PRIVATE LIMITED",
"JOBSANDFRESHERS INDIA PRIVATE LIMITED",
"JOBSFORHER RESTART PORTAL PRIVATE LIMITED",
"JOBSLOTS CONSULTING INDIA PRIVATE LIMITED",
"JOBSMILL BUSINESS SOLUTIONS PRIVATE LIMITED",
"JOBULI TECHNOLOGIES PRIVATE LIMITED",
"JOBVITE INDIA PRIVATE LIMITED",
"JOBWORLD INDIA PRIVATE LIMITED",
"JOCATA FINANCIAL ADVISORY & TECHNOLOGY SERVICES PRIVATE LIMITED",
"JOCHALI IMPEX PRIVATE LIMITED",
"JOCIL LIMITED",
"JODAS EXPOIM PRIVATE LIMITED",
"JODEV HOSPITALITY PRIVATE LIMITED",
"JODHAMAL KAILASH CHAND JAIN JEWELLERS PRIVATE LIMITED",
"JODHANA HERITAGE RESORTS PRIVATE LIMITED",
"JODHANI PAPERS PRIVATE LIMITED",
"JODHPUR AGROFOODS PRIVATE LIMITED",
"JODHPUR CRAFTS PRIVATE LIMITED",
"JODHPUR DISCOMJODHPUR VIDHYUT VITRAN NIGAM LIMITED",
"JODHPUR HEALTHCARE PRIVATE LIMITED",
"JODHPUR INSTITUTE OF ENGINEERING & TECHNOLOGY",
"JODHPUR JAWAHARAT P. LTD.",
"JODHPUR METALS PVT LTD",
"JODHPUR MULTIFUNCTIONAL COMPLEX PRIVATE LIMITED",
"JODHPUR PALI EXPRESSWAY PRIVATE LIMITED",
"JODHPUR RBU INFRABUILD PRIVATE LIMITED",
"JODHPUR SAND STONE PRIVATE LIMITED",
"JODHPUR TEA AND INDUSTRIES PVT LTD",
"JODHPUR TRUCKS PRIVATE LIMITED",
"JODHPUR VIDYUT VITRAN NIGAM LIMITED",
"JODHPUR WIND FARMS PRIVATE LIMITED",
"JODHPUR WOODCRAFT PRIVATE LIMITED",
"JODS BLUE FORCE SECURITY & FACILITY SERVICES PRIVATE LIMITED",
"JOE AND DE ENGINEERS PRIVATE LIMITED",
"JOE SHU INTERNATIONAL LLP",
"JOECONS MARINE EXPORTS PRIVATE LIMITED",
"JOECONS SEAFOODS PRIVATE LIMITED",
"JOEL MULTI MEDIA PRIVATE LIMITED",
"JOFLO INDUSTRIES PRIVATE LIMITED",
"JOG HOSPITALITY PRIVATE LIMITED",
"JOG INFRASTRUCTURES PRIVATE LIMITED",
"JOG PLAST PRIVATE LIMITED",
"JOG WASTE TO ENERGY PRIVATE LIMITED",
"JOGBALA MOTORS PRIVATE LIMITED",
"JOGENSOMANY TEA INDUSTRIES PRIVATE LIMITED",
"JOGESHCHANDRA CHOUDHURY COLLEGE",
"JOGESHWARI MADHYAMIK & UCHH MADHYAMIK HIGH SCHOOL",
"JOGEWAR CONSTRUCTION COMPANY",
"JOGIJHORA TEA & AGRO PRIVATE LIMITED",
"JOGINDER COOLANT COMPANY PRIVATE LIMITED",
"JOGINDER HANDLOOM PRIVATE LIMITED.",
"JOGINDER PAL DODA",
"JOGINDRA CASTINGS PRIVATE LIMITED",
"JOGINDRA ENGINEERING WORKS PRIVATE LIMITED",
"JOGINDRA GASES AND CHEMICALS PVT LTD",
"JOGINDRA RICE AND GENERAL MILLS PVT LTD",
"JOGINPALLY B R ENGINEERING COLLEGE",
"JOGMAYA MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"JOGNIYA EXPLOSIVES PRIVATE LIMITED",
"JOGOMAYA DEVI COLLEGE",
"JOGUR APPAREL AND CLOTHING PRIVATE LIMITED",
"JOGURU TECHNOLOGIES PRIVATE LIMITED",
"JOGUSU INTERNATIONAL PVT LTD",
"JOHAL AIR TRAVEL SERVICES PRIVATE LIMITED",
"JOHAL CARRIERS PRIVATE LIMITED",
"JOHAL LOGISTICS PRIVATE LIMITED",
"JOHAR MOTORS PRIVATE LIMITED",
"JOHARI DIGITAL HEALTHCARE LIMITED",
"JOHARI STONEX INDUSTRIES PRIVATE LIMITED",
"JOHARS PRIVATE LIMITED",
"JOHN AND MANI INDIA PRIVATE LIMITED",
"JOHN BEAN TECHNOLOGIES INDIA PRIVATE LIMITED",
"JOHN BIOTECH PRIVATE LIMITED",
"JOHN BUSINESS SERVICES PRIVATE LIMITED",
"JOHN CANTLE SCIENTIFIC SERVICES PRIVATE LIMITED",
"JOHN COCKERILL GLOBAL BUSINESS SERVICES PRIVATE LIMITED",
"JOHN COCKERILL INDIA LIMITED",
"JOHN CRANE FLEXIBOX INDIA PRIVATE LIMITED",
"JOHN CRANE SEALING SYSTEMS INDIA PRIVATE LIMITED",
"JOHN DEERE FINANCIAL INDIA PRIVATE LIMITED",
"JOHN DEERE INDIA PRIVATE LIMITED",
"JOHN DISTILLERIES PRIVATE LIMITED",
"JOHN ENERGY LIMITED",
"JOHN FOWLER OCULAR LENSES PRIVATE LIMITED",
"JOHN GALT SOLUTIONS PRIVATE LIMITED",
"JOHN KEELLS FOODS INDIA PRIVATE LIMITED",
"JOHN LEWIS INDIA PRIVATE LIMITED",
"JOHN OAKEY AND MOHAN LIMITED",
"JOHN OIL AND GAS LTD",
"JOHN RICH FASHION FABRICS PRIVATE LIMITED",
"JOHN SAW MILL PRIVATE LIMITED",
"JOHN SNOW INDIA PRIVATE LIMITED",
"JOHN T HARDAKER (INDIA) PVT LTD",
"JOHN WILSON EDUCATION SOCIETY",
"JOHNASIA SHIPPING (I) PRIVATE LIMITED",
"JOHNBHAI SOFTCOM PRIVATE LIMITED",
"JOHNLEE PHARMACEUTICALS PRIVATE LIMITED",
"JOHNNY SOKO AND THE FLYING ROBOTS DESIGN PRIVATE LIMITED",
"JOHNS AUTOMOTIVES PRIVATE LIMITED",
"JOHNS ELECTRIC COMPANY PRIVATE LIMITED",
"JOHN'S GLOBAL OVERSEAS EDUCATIONAL CONSULTANCY",
"JOHNS HOPKINS INDIA PRIVATE LIMITED",
"JOHNSON & JOHNSON PRIVATE LIMITED",
"JOHNSON & JOHNSON SURGICAL VISION INDIA PRIVATE LIMITED",
"JOHNSON CONTROLS (INDIA) PRIVATE LIMITED",
"JOHNSON CONTROLS HITACHI AIR CONDITIONING INDIA LIMITED",
"JOHNSON CONTROLS MARINE & REFRIGERATION INDIA LIMITED",
"JOHNSON CONTROLS PTE LIMITED",
"JOHNSON CONTROLS SOFTWARE INDIA PRIVATE LIMITED",
"JOHNSON DYE WORKS PVT LTD",
"JOHNSON ELECTRIC PRIVATE LIMITED",
"JOHNSON GRAMMAR SCHOOL CBSE",
"JOHNSON LIFTS PRIVATE LIMITED",
"JOHNSON MATTHEY CHEMICALS INDIA PRIVATE LIMITED",
"JOHNSON MATTHEY INDIA PRIVATE LIMITED",
"JOHNSON MOTORS PRIVATE LIMITED",
"JOHNSON PAINTS PRIVATE LIMITED",
"JOHNSON PHARMACARE LIMITED",
"JOHNSON PUBLICATIONS PRIVATE LIMITED",
"JOHNSON SCREENS INDIA PRIVATE LIMITED",
"JOHNSON WATCH COMPANY PRIVATE LIMITED",
"JOHNSONCAB ELECTRICALS PRIVATE LIMITED",
"JOHNSONS OVERSEAS (INDIA) PRIVATE LIMITED",
"JOHOKU MANUFACTURING PRIVATE LIMITED",
"JOHRI GEMS AND JEWELLERS PRIVATE LIMITED",
"JOHRI MAL HARISH KUMAR PRIVATE LIMITED",
"JOHRI MAL SHIV LAL PRIVATE LIMITED",
"JOHRI SONS JEWELLERS PRIVATE LIMITED",
"JOIE DE VIVRE RESTAURANT PRIVATE LIMITED",
"JOIL INDIA PRIVATE LIMITED",
"JOIN COMMERCE PRIVATE LIMITED",
"JOIN FLORA PRIVATE LIMITED",
"JOIN LEADER CHEMTECH PRIVATE LIMITED",
"JOININ CAMPUS EDUCATION PRIVATE LIMITED",
"JOINMAY ELECTRONIC PRIVATE LIMITED - VIVO MOBILES",
"JOINMAY MUMBAI ELECTRONICS PRIVATE LIMITED",
"JOINT CIVIL COURT J M F C",
"JOINT COMMISIONER OF COMMERCIAL TAX",
"JOINT COMMISSIONER FOOD AND DRUGS ADMINISTRATION",
"JOINT CONTROLLER OF DEFENCE ACCOUNT AIRFORCE NAGPUR",
"JOINT DIRECTOR GOVERNMENT PRESS ALLAHABAD",
"JOINT DIRECTOR HEALTH SERVICES BHOPAL M P",
"JOINT DIRECTOR HEALTH SERVICES JABALPUR",
"JOINT DIRECTOR OF AGRICULTUREPLANT PROTECTION BHUBANESWAR",
"JOINT DIRECTOR OF ANIMAL HUSBANDRY UDAIPUR",
"JOINT DIRECTOR OF HEALTH GOVT OF ASSAM",
"JOINT DIRECTOR OF TREASURIES ACCOUNTS AND PENSION UJJAIN",
"JOINT DIRECTOR OF VETERINARY SERVICE RAIPUR",
"JOINT DIRECTOR OF VETERINARY SERVICES UJJAIN",
"JOINT DIRECTOR PANCHAYAT AND SOCIAL WELFARE GOVT SECTOR",
"JOINT DIRECTOR TREASURY AND ACCOUNTS INDORE",
"JOINT DIRECTOR URBAN ADMINISTRATION AND DEVELOPMENT DEPARTMENT GWALIOR",
"JOINT DIRECTOR VOCATIONAL EDUCATION AND TRAINING AURANGABAD",
"JOINT DISTRIC REGISTER CLASS ONE AMRAVATI",
"JOINT DISTRICT REGISTRAR",
"JOINT FORCE PHARMACHEM PRIVATE LIMITED",
"JOINT INVESTMENT PRIVATE LIMITED",
"JOINT REGISTRAR COOPERATIVE JABALPUR",
"JOINT RESIDENT COMMISSIONER",
"JOINTAK LABELS INDIA PRIVATE LIMITED",
"JOINTCARE PHARMACEUTICALS PRIVATE LIMITED",
"JOINTWORKS SOLUTIONS LLP",
"JOINWOOD REALITY PRIVATE LIMITED",
"JOISTER INFOMEDIA PRIVATE LIMITED",
"JOIST-O-MECH ENGINEERING PRIVATE LIMITED",
"JOJA SURGICAL PVT LTD",
"JOJO INTERNATIONAL PRIVATE LIMITED",
"JOKA CREEK PRIVATE LIMITED",
"JOLEN DERMA SCIENCE PRIVATE LIMITED",
"JOLEN MARKETING PVT LTD",
"JOLLY AGRI EXIM PRIVATE LIMITED",
"JOLLY BOARD LIMITED",
"JOLLY BOY NUTRITION PRIVATE LIMITED",
"JOLLY BROADBAND PRIVATE LIMITED",
"JOLLY CONTAINERS",
"JOLLY ENTERPRISE",
"JOLLY ENTERPRISES PRIVATE LIMITED",
"JOLLY EXPORTS PVT LTD",
"JOLLY FARM FRESH PRIVATE LIMITED",
"JOLLY HEALTH CARE PRIVATE LIMITED",
"JOLLY HOSPITAL",
"JOLLY MOTOR CORPORATION PRIVATE LIMITED",
"JOLLY MOTORS PRIVATE LIMITED",
"JOLLY OVERSEAS PRIVATE LIMITED",
"JOLLY SILKS PRIVATE LIMITED",
"JOLLY SPINNERS PRIVATE LIMITED",
"JOLLY SPINNING MILLS PRIVATE LIMITED",
"JOLLY STAPLE CRAFT PRIVATE LIMITED",
"JOLT TECHNOLOGIES P LIMITED",
"JOLTME ELECTROVISION (INDIA) PRIVATE LIMITED",
"JOLTTECH SOLUTIONS INDIA PRIVATE LIMITED",
"JOM ENTERPRISES PRIVATE LIMITED",
"JOMISO CONSULTING PRIVATE LIMITED",
"JONA SOFTECH PRIVATE LIMITED",
"JONAH SOLUTIONS (OPC) PRIVATE LIMITED",
"JONALI CONSTRUCTIONS PRIVATE LIMITED",
"JONAM ENGINEERING TECHNOLOGIES PRIVATE LIMITED",
"JONARIN PIGMENTS PRIVATE LIMITED",
"JONAS PETRO PRODUCTS PRIVATE LIMITED",
"JONAS WOODHEAD AND SONS INDIA LIMITED",
"JONEJA BRIGHT STEELS PRIVATE LIMITED",
"JONEJA HYDRAULICS PRIVATE LIMITED",
"JONEJA INFRAPROJECTS PRIVATE LIMITED",
"JONES DIGITECH PRIVATE LIMITED",
"JONES FOUNDATIONS PRIVATE LIMITED",
"JONES LANG LASALLE BUILDING OPERATIONS PRIVATE LIMITED",
"JONES LANG LASALLE PROPERTY CONSULTANTS INDIA PRIVATE LIMITED",
"JONJUA AIR PRIVATE LIMITED",
"JONJUA OVERSEAS LIMITED",
"JONKI TRAVELS LINK PRIVATE LIMITED",
"JONSON RUBBER INDUSTRIES LIMITED",
"JONY ENTERPRISES PRIVATE LIMITED",
"JONY ESTATES PRIVATE LIMITED",
"JOOHITHA POWER SYSTEMS PRIVATE LIMITED",
"JOORDAN PROJECTS AND TRADES PRIVATE LIMITED",
"JOOT FOODS PRIVATE LIMITED",
"JOP HOTELS LIMITED",
"JOP NETWORK PRIVATE LIMITED",
"JOPACK PRIVATE LIMITED",
"JOPASU INDIA PRIVATE LIMITED",
"JORABAT SHILLONG EXPRESSWAY LIMITED",
"JORARAM BUILDERS PRIVATE LIMITED",
"JORAS ONCOLOGY PRIVATE LIMITED",
"JORD INTERNATIONAL PRIVATE LIMITED",
"JORDAN CONSTRUCTION",
"JORDANN PHOSPHATE PRIVATE LIMITED",
"JORHAT BONDED WAREHOUSE PRIVATE LIMITED",
"JORIE HEALTH PRIVATE LIMITED",
"JORINI HOSPITALITY PRIVATE LIMITED",
"JORJY ENTERPRISES PVT LTD",
"JOS ALUKKAS",
"JOSAN AGRO PRIVATE LIMITED",
"JOSCH SYSTEMS PRIVATE LIMITED",
"JOSCO BULLION TRADERS PRIVATE LIMITED",
"JOSCO FOOTWEAR PRODUCTS PRIVATE LIMITED",
"JOSCO GOLD CORPORATION PRIVATE LIMITED",
"JOSCO JEWELLERS PRIVATE LIMITED",
"JOSE BROTHERS INDUSTRIES",
"JOSEPH AND CO PVT LTD",
"JOSEPH CARDIJN TECHNICAL SCHOOL",
"JOSEPH LESLIE DYNAMIKS MANUFACTURING PRIVATE LIMITED",
"JOSEPH RUBBERS (INDIA) PRIVATE LIMITED",
"JOSEPH'S MATRICULATION HR SEC SCHOOL",
"JOSH AUTOMATION INDIA PRIVATE LIMITED",
"JOSH SOFTWARE PRIVATE LIMITED",
"JOSH TALKS PRIVATE LIMITED",
"JOSH TECH SERVICES PRIVATE LIMITED",
"JOSHBRO COMMUNICATIONS PRIVATE LIMITED",
"JOSHI AGROCHEM PHARMA PRIVATE LIMITED",
"JOSHI AUTO SCANS PRIVATE LIMITED",
"JOSHI AUTO ZONE PRIVATE LIMITED",
"JOSHI AUTOLINKS PRIVATE LIMITED",
"JOSHI AUTOMOBILES PRIVATE LIMITED",
"JOSHI AUTOMOTIVES PRIVATE LIMITED",
"JOSHI AUTOZONE MOBILITY PRIVATE LIMITED",
"JOSHI BIZTECH SOLUTIONS LIMITED",
"JOSHI DRUGS PRIVATE LIMITED",
"JOSHI ENGINEERING AND SOFTWARE SOLUTIONS COMPANY PRIVATE LIMITED",
"JOSHI HOSPITAL PRIVATE LIMITED",
"JOSHI INTERMEDIATE PRIVATE LIMITED",
"JOSHI KONOIKE TRANSPORT AND INFRASTRUCTURE PRIVATE LIMITED",
"JOSHI MARBLES PRIVATE LIMITED",
"JOSHI OIL AND GAS PRIVATE LIMITED",
"JOSHI SALES",
"JOSHI TECHNOLOGIES INTERNATIONAL INC",
"JOSHI TRANSIT SOLUTIONS PRIVATE LIMITED",
"JOSHI VENTURES PRIVATE LIMITED",
"JOSHIJAMPALA ENGINEERING PRIVATE LIMITED",
"JOSHIKA PHARMA PRIVATE LIMITED",
"JOSHILA FOOTWEAR PRIVATE LIMITED",
"JOSHITHA INFRATECH PRIVATE LIMITED",
"JOSHODA OIL UDYOG PRIVATE LIMITED",
"JOSHRA HOSPITALITY PRIVATE LIMITED",
"JOSHY PYROTECHNICS PRIVATE LIMITED",
"JOSLER HYDROCARBONS INDIA PRIVATE LIMITED",
"JOSS DISTRIBUTORS PRIVATE LIMITED",
"JOSSAN GRAINS PRIVATE LIMITED",
"JOSSMIN VALVES AND AUTOMATIONS PRIVATE LIMITED",
"JOST INDIA AUTO COMPONENT PRIVATE LIMITED",
"JOSTARS ORGOTECH PRIVATE LIMITED",
"JOSTICK ADHESIVE PRIVATE LIMITED",
"JOSTICK POLYMERS PRIVATE LIMITED",
"JOSTS ENGINEERING COMAPNY LIMITED",
"JOTHI MALLEABLES PRIVATE LIMITED",
"JOTHI MICRO CAST PRIVATE LIMITED",
"JOTHI POLYMERS PRIVATE LIMITED",
"JOTHI SOFTWARE PRIVATE LIMITED",
"JOTIBA TECHNOLOGIES PRIVATE LIMITED",
"JOTINDRA INFRASTRUCTURE LIMITED",
"JOTINDRA STEEL AND TUBES LIMITED",
"JOTO ABRASIVES PRIVATE LIMITED",
"JOTOYSS ECOMMERCE INDIA PRIVATE LIMITED",
"JOTTERAI PRIVATE LIMITED",
"JOTUN INDIA PRIVATE LIMITED",
"JOTWIRE INDIA PRIVATE LIMITED",
"JOUBERT PLY PRIVATE LIMITED",
"JOULE CONSULTING PRIVATE LIMITED",
"JOULE TECH INDUSTRIAL SERVICES PRIVATE LIMITED",
"JOULESHEALTH ENTERPRISE PRIVATE LIMITED",
"JOULESTOWATTS BUSINESS SOLUTIONS PRIVATE LIMITED",
"SIX RED MARBLES INDIA PRIVATE LIMITED",
"JOVAKI AGRO FOOD INDIA PRIVATE LIMITED",
"JOVANTA CONSULTANTS PRIVATE LIMITED",
"JOVE ELECTRONICS PRIVATE LIMITED",
"JOVE ENGINEERS PRIVATE LIMITED",
"JOVE MULTISYSTEMS PRIVATE LIMITED",
"JOVE STEELS PRIVATE LIMITED",
"JOVE SYNTHOCHEM INDIA PRIVATE LIMITED",
"JOVEENS LOGISTICS AND SERVICES INDIA PRIVATE LIMITED",
"JOVEES HERBAL CARE INDIA LIMITED",
"JOVEN HEALTHCARE PRIVATE LIMITED",
"JOVEO TECHNOLOGIES PRIVATE LIMITED",
"JOVIAL FOODS PRIVATE LIMITED",
"JOVIAL INVESTMENT AND TRADING COMPANY PRIVATE LIMITED",
"JOVIKA NUTRITIONAL PRODUCTS PRIVATE LIMITED",
"JOWELA EXIM PRIVATE LIMITED",
"JOY AND SAYLA REALTORS",
"JOY BABA TARAKNATH RICE MILL PRIVATE LIMITED",
"JOY BEAUTY CARE PRIVATE LIMITED",
"JOY BHARAT COMMODEAL PRIVATE LIMITED",
"JOY BHARAT OIL MILLS PVT LTD",
"JOY BHAVYA PLY BOARD PVT LTD",
"JOY BIO FUEL PRIVATE LIMITED",
"JOY CONSTRUCTION",
"JOY D-ZIGN ENGINEERS PRIVATE LIMITED",
"JOY FOAM PRIVATE LIMITED",
"JOY FROZEN FOODS PRIVATE LIMITED",
"JOY GLOBAL INC.",
"JOY GLOBAL INDIA LIMITED",
"JOY GURU COLD STORAGE PRIVATE LIMITED.",
"JOY IMAGING PRIVATE LIMITED",
"JOY INFOTECH CONSULTING PRIVATE LIMITED",
"JOY JETS LIMITED",
"JOY KINGDOM SOFTWARE SERVICES LLP",
"JOY MA LAKSHMI COLD STORAGE PRIVATE LIMITED",
"JOY MAA RAKSHAKALI RICE MILL PRIVATE LIMITED",
"JOY MAA TARA POULTRY FARM PRIVATE LIMITED",
"JOY MARKETING COMPANY PRIVATE LIMITED",
"JOY NURSING HOME PRIVATE LIMITED",
"JOY PACK (INDIA) PRIVATE LIMITED",
"JOY PACKAGING PRIVATE LIMITED",
"JOY PETROCHEM PRIVATE LIMITED",
"JOY PLUS TECHNOLOGY PRIVATE LIMITED",
"JOY REAP METAL (INDIA) PRIVATE LIMITED",
"JOY SENIOR SECONDRY SCHOOL",
"JOY SHANKAR DUTTA & SONS FERTILISER PRIVATE LIMITED",
"JOY SHIPPING SERVICES PRIVATE LIMITED",
"JOY SOLAR PRIVATE LIMITED",
"JOY STEELS PRIVATE LIMITED",
"JOY TECHNO SERVICES PRIVATE LIMITED",
"JOY THOMAS ENGINEERING PRIVATE LIMITED",
"JOYALUKKAS INDIA LIMITED",
"JOYALUKKAS LIFESTYLE DEVELOPERS PRIVATE LIMITED",
"JOYAM ENGINEERS & CONSULTANTS PRIVATE LIMITED",
"JOYAMAZE INDIA PRIVATE LIMITED",
"JOYCE BUILDERS PRIVATE LIMITED",
"JOYCITY ENTERPRISES PRIVATE LIMITED",
"JOYFUL PLASTICS PRIVATE LIMITED",
"JOYGOAT EMPORIUM LLP",
"JOYGOPAL FOOD PRODUCTS PRIVATE LIMITED",
"JOYKEY MERCHANDISE PRIVATE LIMITED",
"JOYMAKALI COLD STORAGE PVT LTD",
"JOYMAX COLONIZERS AND DEVELOPERS PRIVATE LIMITED",
"JOYNEST PREMISES PRIVATE LIMITED",
"JOYO PLASTICS",
"JOYOUS AGRRIVISION PRODUCER COMPANY LIMITED",
"JOYOUS BLOCKS & PANELS PRIVATE LIMITED",
"JOYOUS HOUSING LIMITED",
"JOYOUS TRENDZ LIMITED",
"JOYRAMPUR BIDYA BHABAN",
"JOYRATH PROJECTS PRIVATE LIMITED",
"JOYRIDE GAMES PRIVATE LIMITED",
"JOYS ENTERPRISES PRIVATE LIMITED",
"JOYSHREE INDIA PVT LTD",
"JOYSON ANAND ABHISHEK SAFETY SYSTEMS PRIVATE LIMITED",
"JOYTSNA POULTRY PRIVATE LIMITED",
"JOYVILLE SHAPOORJI HOUSING PRIVATE LIMITED",
"JP AND JAI LOGISTICS PRIVATE LIMITED",
"JP AQUA PRIVATE LIMITED",
"JP CONSTRUCTIONS AND SERVICES PRIVATE LIMITED",
"JP ESSENTIALS EXPORTS INDIA PRIVATE LIMITED",
"JP EYE HOSPITAL",
"JP FLOUR MILLS PRIVATE LIMITED",
"JP HOLLANDWOVEN PRIVATE LIMITED",
"JP HOSPITAL BHOPAL",
"JP INFRA REALTY PRIVATE LIMITED",
"JP INFRA RESIDENCY PRIVATE LIMITED",
"JP INN PRIVATE LIMITED",
"JP INTERNATIONAL SCHOOL",
"JP ISCON LIMITED.",
"JP JAI LAND & BUILDING PROMOTERS PRIVATE LIMITED",
"JP MODATEX LLP",
"JP MORGAN CHASE BANK",
"JP MORGAN SERVICES",
"JP PETROPLAST PRIVATE LIMITED",
"JP PHARMA SOLUTIONS PRIVATE LIMITED",
"JP RESEARCH INDIA PRIVATE LIMITED",
"JP SMART SKILL FOUNDATION",
"JP SORTEX PRIVATE LIMITED",
"JP STEEL TUBES & PIPES PRIVATE LIMITED",
"JP STRUCTURES PRIVATE LIMITED",
"JP TOKYO INDIA PRIVATE LIMITED",
"JP TRACTORS PRIVATE LIMITED",
"JP UDYOG PRIVATE LIMITED",
"JPA SNACKS PRIVATE LIMITED",
"JPAC TECHNOLOGIES PRIVATE LIMITED",
"JPB CHEMICAL INDUSTRIES PRIVATE LIMITED",
"JPB TRADERS PRIVATE LIMITED",
"JPC BUILDERS PRIVATE LIMITED",
"JPC INFRA PRIVATE LIMITED",
"JPC INFRATECH PRIVATE LIMITED",
"JPD PRECISION FASTENERS PRIVATE LIMITED",
"JPEE REFINERIES PRIVATE LIMITED",
"JPENC PRIVATE LIMITED",
"JPEW ENGINEERING EXPORTS PRIVATE LIMITED",
"JPG BUILDERS PRIVATE LIMITED",
"JPG HARDWARES PRIVATE LIMITED",
"JPH INDUSTRIES PRIVATE LIMITED",
"JPH MATTRESS OPC PRIVATE LIMITED",
"JPI PRINTING MACHINERY PRIVATE LIMITED",
"JPJ INDUSTRIES PRIVATE LIMITED",
"JPJ OFFSHORES PRIVATE LIMITED",
"JPJN FINANCIAL SERVICES PRIVATE LIMITED",
"JPK METALLICS PRIVATE LIMITED",
"JPK SURGICAL EQUIPMENTS PRIVATE LIMITED",
"JPL INDUSTRIES LIMITED",
"JPL MANAGEMENT SERVICES PRIVATE LIMITED",
"JPLOFT SOLUTIONS PRIVATE LIMITED",
"JPM & DJM ENTERPRISES SERVICES PRIVATE LIMITED",
"JPM INDUSTRIES LIMITED",
"JPM TOOLS LIMITED",
"JPMA CONSTRUCTIONS PRIVATE LIMITED",
"JPMD AGROTECH PRIVATE LIMITED",
"JPMORGAN ASSET MANAGEMENT INDIA PRIVATE LIMITED",
"JPMOTOR PRIVATE LIMITED",
"JPNOVATIONS SOLUTIONS PRIVATE LIMITED",
"JPNR CORPORATE CONSULTANTS PRIVATE LIMITED",
"JPNS MEDDOCS PUBLISHERS PRIVATE LIMITED",
"JPR ASSOCIATES PVT LTD",
"JPR BALAJI INFRA PRIVATE LIMITED",
"JPR DIGITAL PRIVATE LIMITED",
"JPR LABS PRIVATE LIMITED",
"JPR NETWORK PRIVATE LIMITED",
"JPRI HOTELS PRIVATE LIMITED",
"J-PRINTEX POLYCOLLOIDS PRIVATE LIMITED",
"JPS ASSOCIATES PRIVATE LIMITED",
"JPS BUILDTECH PRIVATE LIMITED",
"JPS FASHIONS PRIVATE LIMITED",
"JPS METALS PRIVATE LIMITED",
"JPS MOTORS PRIVATE LIMITED",
"JPS PLASTICS PRIVATE LIMITED",
"JPS SCHOOL",
"JPS STEELS PRIVATE LIMITED",
"JPSC SOLUTIONS PRIVATE LIMITED",
"JPT FASHION PRIVATE LIMITED",
"JPT GLOBAL AUTOMOTIVE LLP",
"JPV INFRAPROJECTS (I) PRIVATE LIMITED",
"JPV REALTORS PRIVATE LIMITED",
"JPV SHIPS INDIA PRIVATE LIMITED",
"JPW ENGINEERING SERVICES PRIVATE LIMITED",
"JPW HOMEWARE CREATIONS PRIVATE LIMITED",
"JPW INFRATECH PRIVATE LIMITED",
"JQR FOOTWEAR (INDIA) PRIVATE LIMITED",
"JQR SPORTS (INDIA) PRIVATE LIMITED",
"JR COMMUNICATIONS & POWER CONTROLS PRIVATE LIMITED",
"JR FACILITIES & MANAGEMENT SERVICES PRIVATE LIMITED",
"JR FOREX SOLUTIONS PRIVATE LIMITED",
"JR FURNISHING PRIVATE LIMITED",
"JR HOUSING DEVELOPERS PRIVATE LIMITED",
"JR INFRA ENGINEERING PRIVATE LIMITED",
"JR JINDAL INFRAPROJECTS PRIVATE LIMITED",
"JR ONE LIFTS PRIVATE LIMITED",
"JR SALES AND SERVICES PRIVATE LIMITED",
"JR SEAMLESS PRIVATE LIMITED",
"JR SUPER SPECIALITY HOSPITALS PRIVATE LIMITED",
"JR TECHNOLOGIES",
"JR TECHNOLOGIES WEB PRIVATE LIMITED",
"JR TOLL ROAD PRIVATE LIMITED",
"JR WORLD SOFTTECH SYSTEMS PRIVATE LIMITED",
"JRA INFRASTRUCTURE LIMITED",
"JRAMP FOODS PRIVATE LIMITED",
"JRB BREEDERS PRIVATE LIMITED",
"JRB BUILDCON PRIVATE LIMITED",
"JRB FOODS PRIVATE LIMITED",
"JRB INFRASTRUCTURE PRIVATE LIMITED",
"JRB PACKERS PRIVATE LIMITED",
"JRB STRIPS PRIVATE LIMITED",
"JRC INTERIORS",
"JRC PRINTERS PRIVATE LIMITED",
"JRC TRANSCON PRIVATE LIMITED",
"JRCL INFRA PRIVATE LIMITED",
"JRCL STEEL PRIVATE LIMITED",
"JRD BUILDCON PRIVATE LIMITED",
"JRD DENIMS LIMITED",
"JRD ENGINEERING SOLUTIONS PRIVATE LIMITED",
"JRD EQUIPMENTS PRIVATE LIMITED",
"JRD FIBRE COMPOSITE PRIVATE LIMITED",
"JRD GEMS P LTD",
"JRD INFRATECH PRIVATE LIMITED",
"JRD INTERIORS INDIA PRIVATE LIMITED",
"JRD MY MY FASHIONS PRIVATE LIMITED",
"JRD PERFECT TOOLS PRIVATE LIMITED",
"JRD POLYMER PRIVATE LIMITED",
"JRD RUBBER AND PLASTIC TECHNOLOGY PRIVATE LIMITED",
"JRD STEELPAC PRIVATE LIMITED",
"JRD SYSTEMS PRIVATE LIMITED",
"JRD WHEEL N WAY PRIVATE LIMITED",
"JRE HOLDINGS INDIA PRIVATE LIMITED",
"JRE PRIVATE LIMITED",
"JRE TANK TERMINALS PRIVATE LIMITED",
"JREW ENGINEERING LIMITED",
"JRG AUTOMOTIVE (INDIA) PRIVATE LIMITED",
"JRG AUTOMOTIVE INDUSTRIES INDIA PRIVATE LIMITED",
"JRG DEVELOPERS PRIVATE LIMITED",
"JRG ENGINEERING POLYMERS PRIVATE LIMITED",
"JRG HEALTHCARE INDIA PRIVATE LIMITED",
"JRG HOSPITALITY PRIVATE LIMITED",
"JRH STEELS PRIVATE LIMITED",
"JRI TECHNOLOGIES PRIVATE LIMITED",
"JRJ FOODS PRIVATE LIMITED",
"JRJ INFRASTRUCTURE PRIVATE LIMITED",
"JRJ ORNAMENT PRIVATE LIMITED",
"JRK CONSULTING SERVICES PRIVATE LIMITED",
"JRK INDUSTRIES PRIVATE LIMITED",
"JRK INFOTECH PRIVATE LIMITED",
"JRK MARKETING PRIVATE LIMITED",
"JRK SOLAR PROJECTS PRIVATE LIMITED",
"JRK STOCK BROKING PRIVATE LIMITED",
"JRL CAPITAL PRIVATE LIMITED",
"JRL MEDICAL DEVICES PRIVATE LIMITED",
"JRL MINING PRIVATE LIMITED",
"JRM EXPORT PRIVATE LIMITED",
"JRM FOODS PRIVATE LIMITED",
"JRM SECURITIES AND FINANCE PRIVATE LIMITED",
"JRM SHARE AND STOCK BROKERS PRIVATE LIMITED",
"JRN CONTRACTS AND PHARMACEUTICAL PRIVATE LIMITED",
"JRN FOUNDRY PRIVATE LIMITED",
"JRP CEMENT PRIVATE LIMITED",
"JRP STEEL PRIVATE LIMITED",
"JRPL RICELAND LLP",
"JRR WASTE MANAGEMENT PRIVATE LIMITED",
"JRS CONBUILD PRIVATE LIMITED",
"JRS CREATIONS AND EVENT SOLUTIONS PRIVATE LIMITED",
"JRS FOOTWEAR PRIVATE LIMITED",
"JRS GLOBAL NETWORKS PRIVATE LIMITED",
"JRS HOSPITALS PRIVATE LIMITED",
"JRS INFRATECH PRIVATE LIMITED",
"JRS INTERNATIONAL SCHOOL",
"JRS INVESTMENTS PRIVATE LIMITED",
"JRS PHARMA & GUJARAT MICROWAX PRIVATE LIMITED",
"JRS RECYCLING SOLUTIONS PRIVATE LIMITED",
"JRS RENEW POWER PRIVATE LIMITED",
"JRS TUTORIALS",
"JRS VENTURES PRIVATE LIMITED",
"JRT ENTERPRISES PRIVATE LIMITED",
"JRVS ISPAT PRIVATE LIMITED",
"JRW TRANSFREIGHT PRIVATE LIMITED",
"JS ASSIGNMENTS PRIVATE LIMITED",
"JS ASSOCIATE DEVELOPMENT INDIA PRIVATE LIMITED",
"JS BITUMEN-TARFELT INDUSTRIES PRIVATE LIMITED",
"JS BOISSON INDIA PRIVATE LIMITED",
"JS BUILDING MATERIAL SUPPLIERS PRIVATE LIMITED",
"JS CLEANTECH PRIVATE LIMITED",
"JS FORGE PRIVATE LIMITED",
"JS GROUP OF SCHOOL",
"JS HOSPITAL",
"JS HOSPITALITY SERVICES PRIVATE LIMITED",
"JS INFOTECH PRIVATE LIMITED",
"JS INFRA PRIVATE LIMITED",
"JS INFRAHOMES PRIVATE LIMITED",
"JS INSTRUMENT SERVICE",
"JS JEWELS PRIVATE LIMITED",
"J'S LABORATORIES PRIVATE LIMITED",
"JS LOGITECH PRIVATE LIMITED",
"JS MOBILEON PRIVATE LIMITED",
"JS NEEDS24 RETAILMART PRIVATE LIMITED",
"JS PETRO TRADE PRIVATE LIMITED",
"JS RESIDENCY PRIVATE LIMITED",
"JS SPINTEX LIMITED",
"JS SYNERGIES PRIVATE LIMITED",
"JS WATER ENERGY LIFE COMPANY PRIVATE LIMITED",
"JSA HI-TECH ROOF INDIA PRIVATE LIMITED",
"JSA LUBES PRIVATE LIMITED",
"JSA ONLINE SUPPORT SERVICES PRIVATE LIMITED",
"JSA TECHNOLOGIES INDIA PRIVATE LIMITED",
"JSB ALUMINIUM PRIVATE LIMITED",
"JSB ENTRADE PRIVATE LIMITED JSB",
"JSB EVERGREEN SNACKS & SWEETS PRIVATE LIMITED",
"JSB EVERGREEN SWEETS & SNACKS PRIVATE LIMITED",
"JSB HEALTH AND FITNESS PRIVATE LIMITED",
"JSB METAL (OPC) PRIVATE LIMITED",
"JSB PLYWOOD INDUSTRIES PRIVATE LIMITED",
"JSB POLYMERS PRIVATE LIMITED",
"JSB RISKLESS SERVICES PRIVATE LIMITED",
"JSB STAFFING SOLUTIONS PRIVATE LIMITED",
"JSB STRUCT BUILD PRIVATE LIMITED",
"JSB VENTURES PRIVATE LIMITED",
"JSC IA VOZROZHDENIE INDIA PRIVATE LIMITED",
"JSC SEEDS PRIVATE LIMITED",
"JSC TECHNOCORP PRIVATE LIMITED",
"JSC VTB BANK",
"JSCO MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"JSD ACCESSORIES PRIVATE LIMITED",
"JSD CONINFRA PRIVATE LIMITED",
"JSD COURIER SERVICES PRIVATE LIMITED",
"JSD INDUSTRIES PRIVATE LIMITED",
"JSD INNOVATIONS PRIVATE LIMITED",
"JSD LOGISTICS PRIVATE LIMITED",
"JSD MEDICAL BUSINESS MANAGEMENT SERVICES PRIVATE LIMITED",
"JSD MICRO SYSTEMS PRIVATE LIMITED",
"JSE ENGINEERING PRIVATE LIMITED",
"JSE INFOTECH PRIVATE LIMITED",
"JSE INFRATECH PRIVATE LIMITED",
"JSEL SECURITIES LIMITED",
"JSERVICE INDIA PRIVATE LIMITED",
"JSG INNOTECH PRIVATE LIMITED",
"JSG PRINTS AND PACK PRIVATE LIMITED",
"JSG VENTURES PRIVATE LIMITED",
"JSHINE SOUK PRIVATE LIMITED",
"JSI INVESTMENTS PRIVATE LIMITED",
"JSI METALS LIMITED",
"JSI R & T FOUNDATION",
"JSI R&T INDIA FOUNDATION",
"JSIMPLE TECHNOSOFT PRIVATE LIMITED",
"JSIW INFRASTRUCTURE PRIVATE LIMITED",
"JSJ INFRAPROJECTS PRIVATE LIMITED",
"JSK COMMUNICATIONS PRIVATE LIMITED",
"JSK CORPORATION PRIVATE LIMITED",
"JSK DEVELOPERS PRIVATE LIMITED",
"JSK ELECTRICALS PRIVATE LIMITED",
"JSK ENGG. PRIVATE LIMITED",
"JSK INDUSTRIES PRIVATE LIMITED",
"JSK INFOSOLUTIONS PRIVATE LIMITED",
"JSK INFRASOLUTIONS PRIVATE LIMITED",
"JSK MULTI PRODUCTS PRIVATE LIMITED",
"JSK NET COMMERCE PRIVATE LIMITED",
"JSK SHIPPING AGENCIES PRIVATE LIMITED",
"JSK TECHNOLOGIES SOLUTIONS PRIVATE LIMITED",
"JSK WEB SERVICES PRIVATE LIMITED",
"JSL FLAVOURS PRIVATE LIMITED",
"JSL INDUSTRIES LIMITED",
"JSL IRON & STEEL PRIVATE LIMITED",
"JSL LIFESTYLE LIMITED",
"JSL LIMITED",
"JSL LOGISTICS LIMITED",
"JSM ADVISERS PRIVATE LIMITED",
"JSM CARGO PRIVATE LIMITED",
"JSM CORPORATION PRIVATE LIMITED",
"JSM ENERGY PRIVATE LIMITED",
"JSM HI TECH SIEVES PRIVATE LIMITED",
"JSM HIGH SCHOOL",
"JSM LOGISTICS PRIVATE LIMITED",
"JSM PAPER MILLS PRIVATE LIMITED",
"JSM PHARMA",
"JSM STEEL INDIA PRIVATE LIMITED",
"JSM SYNTHETICS PRIVATE LIMITED",
"JSM VEGOILS PRIVATE. LIMITED",
"JSMC FACILITY SERVICES PRIVATE LIMITED",
"JSN AGRI FOODS PRIVATE LIMITED",
"JSN AHMEDNAGAR AAROGYA PRIVATE LIMITED",
"JSN ENTERPRISE PRIVATE LIMITED",
"JSOFT SOLUTIONS",
"JSON POLYMER PRIVATE LIMITED",
"JSONS FOUNDRY PRIVATE LIMITED",
"JSONS SOLICITORS PRIVATE LIMITED",
"JSP 4WHEELER PRIVATE LIMITED",
"JSP AGRO PRIVATE LIMITED",
"JSP AUTOCORE PRIVATE LIMITED",
"JSP AUTOMOTIVE PRIVATE LIMITED",
"JSP CARS PRIVATE LIMITED",
"JSP CONSULTANCY SERVICES PRIVATE LIMITED",
"JSP ENTERPRISES PRIVATE LIMITED",
"JSP MOTORRAD HYD PRIVATE LIMITED",
"JSP PROJECTS PRIVATE LIMITED",
"JSP TRACOMM PRIVATE LIMITED",
"JSPM NARHE TECHNICAL CAMPUS",
"JSPM UNIVERSITY PUNE",
"JSPM S IMPERIAL ADHYAPAK VIDYALAYA",
"JSPS MARKETING SOLUTION PRIVATE LIMITED",
"JSQUAD LANGUAGE SERVICES OPC PRIVATE LIMITED",
"JSR AMENITIES PRIVATE LIMITED",
"JSR ASIA IMPORTS PRIVATE LIMITED",
"JSR CHEMICALS PRIVATE LIMITED",
"JSR DEVELOPERS PRIVATE LIMITED",
"JSR DISTRIBUTORS PRIVATE LIMITED",
"JSR ECR ROAD PROJECT PRIVATE LIMITED",
"JSR EDUWORKERS PRIVATE LIMITED",
"JSR FOILS INDIA PRIVATE LIMITED",
"JSR HOUSING AND DEVELOPERS PRIVATE LIMITED",
"JSR INDUSTRIES PRIVATE LIMITED",
"JSR INFRA CONSTRUCTIONS PRIVATE LIMITED",
"JSR INFRA DEVELOPERS PRIVATE LIMITED",
"JSR INTERNATIONAL (INDIA) PRIVATE LIMITED",
"JSR MARKETING PRIVATE LIMITED",
"JSR METRO UDYOG PRIVATE LIMITED",
"JSR MULBAGAL TOLLWAYS PRIVATE LIMITED",
"JSR NETSOL PRIVATE LIMITED",
"JSR OUTDOORS PRIVATE LIMITED",
"JSR PLASTO TOOLS PRIVATE LIMITED",
"JSR ROOFING & ENGIMETALS PRIVATE LIMITED",
"JSR SANSKRITI FOUNDATION",
"JSR SHIPPING SERVICES INDIA PRIVATE LIMITED",
"JSS ACADEMY OF TECHNICAL EDUCATION",
"JSS AUTO PARTS PRIVATE LIMITED",
"JSS BUILDCON PRIVATE LIMITED",
"JSS CARGO SERVICES PRIVATE LIMITED",
"JSS DIGITAL CONSULTING PRIVATE LIMITED",
"JSS FOODCRAFT PRIVATE LIMITED",
"JSS HIGH SCHOOL",
"JSS HOSPITAL",
"JSS MAHAVIDYAPEETHA",
"JSS MEDICAL RESEARCH ASIA PACIFIC PRIVATE LIMITED",
"JSS MEDICAL RESEARCH INDIA PRIVATE LIMITED",
"JSS PHARMACY COLLEGE",
"JSS POLYTECHNIC",
"JSS POWER PRIVATE LIMITED",
"JSS PRO SERVICES PRIVATE LIMITED",
"JSS PUBLIC SCHOOL",
"JSS STEELITALIA LIMITED",
"JSS SUPER SPECIALITY HOSPITALS",
"JSS VENTURES PRIVATE LIMITED",
"JSSCO ENTERPRISES & SERVICES PRIVATE LIMITED",
"JSSR TRANSPORT PRIVATE LIMITED",
"JST REALTY PRIVATE LIMITED",
"J-STAR SECURITY PRIVATE LIMITED",
"JSTC LOGISTICS PRIVATE LIMITED",
"JSTI TRANSFORMERS PRIVATE LIMITED",
"JSTREAMS SOLUTIONS PRIVATE LIMITED",
"JSUN CNC SOLUTIONS PRIVATE LIMITED",
"JSV CORPORATE FACILITY SOLUTION PRIVATE LIMITED",
"JSV INFRASTRUCTURE PRIVATE LIMITED",
"JSV INNOVATIONS PRIVATE LIMITED",
"JSV MOTORS AND CONSTRUCTIONS PRIVATE LIMITED",
"JSVM PLYWOOD INDUSTRIES LIMITED",
"JSW ADVAITH POWER PRIVATE LIMITED",
"JSW BENGAL STEEL LIMITED",
"JSW BENGALURU FOOTBALL CLUB PRIVATE LIMITED",
"JSW CEMENT LIMITED",
"JSW DHARAMTARPORT PRIVATE LIMITED",
"JSW ENERGY (KUTEHR) LIMITED",
"JSW ENERGY LIMITED",
"JSW FOUNDATION",
"JSW FUTURE ENERGY LIMITED",
"JSW GECKO MOTORS PRIVATE LIMITED",
"JSW GLOBAL BUSINESS SOLUTIONS LIMITED",
"JSW GREEN CEMENT PRIVATE LIMITED",
"JSW GREEN PRIVATE LIMITED",
"JSW HOLDINGS LIMITED",
"JSW HYDRO ENERGY LIMITED",
"JSW INDUSTRIAL GASES LIMITED",
"JSW INFRASTRUCTURE LIMITED",
"JSW INVESTMENTS PRIVATE LIMITED",
"JSW IP HOLDINGS PRIVATE LIMITED",
"JSW ISPAT SPECIAL PRODUCTS LIMITED",
"JSW JAIGARH PORT LIMITED",
"JSW JHARKHAND STEEL LIMITED",
"JSW MANGALORE CONTAINER TERMINAL PRIVATE LIMITED",
"JSW MI CHENNAI STEEL SERVICE CENTER PRIVATE LIMITED",
"JSW MI STEEL SERVICE CENTER PRIVATE LIMITED",
"JSW MINERALS TRADING PRIVATE LIMITED",
"JSW NEO ENERGY LIMITED",
"JSW ONE PLATFORMS LIMITED",
"JSW PAINTS PRIVATE LIMITED",
"JSW PARADIP TERMINAL PRIVATE LIMITED",
"JSW POWER TRADING COMPANY LIMITED",
"JSW PROJECTS LIMITED",
"JSW REALTY & INFRASTRUCTURE PRIVATE LIMITED",
"JSW REALTY PRIVATE LIMITED",
"JSW RENEW ENERGY LIMITED",
"JSW RENEW ENERGY TWO LIMITED",
"JSW RENEWABLE ENERGY (VIJAYANAGAR) LIMITED",
"JSW RETAIL AND DISTRIBUTION LIMITED",
"JSW SEVERFIELD STRUCTURES LIMITED",
"JSW SHIPPING & LOGISTICS PRIVATE LIMITED",
"JSW SPORTS PRIVATE LIMITED",
"JSW STEEL COATED PRODUCTS LIMITED",
"JSW STEEL LIMITED",
"JSW STRUCTURAL METAL DECKING LIMITED",
"JSW TECHNO PROJECTS MANAGEMENT LIMITED",
"JSW VALLABH TINPLATE PRIVATE LIMITED",
"JSW VIJAYANAGAR METALLICS LIMITED",
"JSY INFRA FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"JT DIRECTOR OF STEAM BOILERS NAGPUR",
"JT SPORTS PRIVATE LIMITED",
"JT STEEL TUBE PRIVATE LIMITED",
"JTAC AIR-CONDITIONING INDIA PRIVATE LIMITED",
"JTB INDIA PRIVATE LIMITED",
"JTB JUPITER EXPRESS SERVICES PRIVATE LIMITED",
"JTC FAB INDIA PRIVATE LIMITED",
"JTCTOOLING MANUFACTURING PRIVATE LIMITED",
"JTEKT BEARINGS INDIA PRIVATE LIMITED",
"JTEKT ELECTRONICS INDIA PRIVATE LIMITED",
"JTEKT FUJI KIKO AUTOMOTIVE INDIA LIMITED",
"JTEKT INDIA LIMITED",
"JTEKT MICROMATIC MACHINERY INDIA PRIVATE LIMITED",
"JTEKT SONA AUTOMOTIVE INDIA LIMITED",
"JTG E-BUSINESS SOFTWARE PRIVATE LIMITED",
"JTG INFOTECH SERVICES PRIVATE LIMITED",
"JTK ARIHANT APPLIANCES PRIVATE LIMITED",
"JTL INDUSTRIES LIMITED",
"JTL MANAGEMENT AND HR SERVICES PRIVATE LIMITED",
"JTPL PRIVATE LIMITED",
"JTPM ATSALI LIMITED",
"JTPM METAL TRADERS PRIVATE LIMITED",
"JTS TRAVELS PRIVATE LIMITED",
"JTSI TECHNOLOGIES INDIA PRIVATE LIMITED",
"JTS-MASTPRO PROJECTS PRIVATE LIMITED",
"JU AGRI SCIENCES PRIVATE LIMITED",
"JUAN SECURITIES PRIVATE LIMITED",
"JUANA TECHNOLOGIES PRIVATE LIMITED",
"JUARA IT SOLUTIONS PRIVATE LIMITED",
"JUBAILO CHEM PRIVATE LIMITED",
"JUBEE AND SARHA ENGINEERS PRIVATE LIMITED",
"JUBEERICH CONSULTANCY PRIVATE LIMITED",
"JUBEERICH STUDIES LLP",
"JUBEN RETAIL VENTURES PRIVATE LIMITED",
"JUBIANT BUSINESS SERVICES LIMITED",
"JUBILANT AGRI AND CONSUMER PRODUCTS LIMITED",
"JUBILANT AUTOWORKS PRIVATE LIMITED",
"JUBILANT AVENUE'S PRIVATE LIMITED",
"JUBILANT BHARTIA FOUNDATION",
"JUBILANT BIOSYS LIMITED",
"JUBILANT CAPITAL PRIVATE LIMITED",
"JUBILANT CHEMSYS LIMITED",
"JUBILANT CLINSYS LIMITED",
"JUBILANT CONSUMER PRIVATE LIMITED",
"JUBILANT ENPRO PRIVATE LIMITED",
"JUBILANT FOODWORKS LIMITED",
"JUBILANT GENERICS LIMITED",
"JUBILANT INDUSTRIES LIMITED",
"JUBILANT INFRASTRUCTURE LIMITED",
"JUBILANT MARKETING CO PVT LTD",
"JUBILANT MOTORS PRIVATE LIMITED",
"JUBILANT MOTORWORKS PRIVATE LIMITED",
"JUBILANT MOTORWORKS SOUTH PRIVATE LIMITED",
"JUBILANT OFFSHORE DRILLING PRIVATE LIMITED",
"JUBILANT OIL & GAS PRIVATE LIMITED",
"JUBILANT PERFORMANCE CARS PRIVATE LIMITED",
"JUBILANT PHARMA AND CHEMICAL LAB (OPC) PRIVATE LIMITED",
"JUBILANT PHARMOVA LIMITED",
"JUBILANT PIPING SOLUTIONS PRIVATE LIMITED",
"JUBILANT SECURITIES PRIVATE LIMITED",
"JUBILANT SHIP MANAGEMENT PRIVATE LIMITED",
"JUBILANT SOFTWARE SERVICES LIMITED",
"JUBILANT SPORTS CARS PRIVATE LIMITED",
"JUBILANT THERAPEUTICS INDIA LIMITED",
"JUBILEE AGRO FARMS PRIVATE LIMITED",
"JUBILEE BEVERAGES LIMITED",
"JUBILEE CARGO PRIVATE LIMITED",
"JUBILEE GRANITES INDIA PRIVATE LIMITED",
"JUBILEE HILLS LANDMARK PROJECTS PRIVATE LIMITED",
"JUBILEE INFRATECH PRIVATE LIMITED",
"JUBILEE MISSION HOSPITAL",
"JUBILEE PLOT & HOUSING PRIVATE LIMITED",
"JUBILEE PRODUCTIONS PRIVATE LIMITED",
"JUBILEE SEA TRADE PRIVATE LIMITED",
"JUBILIANT INSURANCE BROKING SERVICES PRIVATE LIMITED",
"JUBIN COLD STORAGE PRIVATE LIMITED",
"JUBIN FINANCE AND INVESTMENT LIMITED",
"JUBLEE STORES PRIVATE LIMITED",
"JUBLIANT HOSPITALITY SERVICES PRIVATE LIMITED",
"JUDE FOODS INDIA PRIVATE LIMITED",
"JUDEICO BPO SOLUTIONS PRIVATE LIMITED",
"JUDESON ENGINEERING SERVICES PRIVATE LIMITED",
"JUDGE INDIA SOLUTIONS PRIVATE LIMITED",
"JUDICAL LEGISLATURE U P GOVT",
"JUDICIAL DEPARTMENT",
"JUDICIAL MAGISTRATE FIRST CLASS KOLHAPUR",
"JUDICIOUS CONSULTANTS PRIVATE LIMITED",
"JUDICIOUS FINVEST PVT LTD",
"JUDSON HIGH SCHOOL",
"JUEGO STUDIO PRIVATE LIMITED",
"JUGAAD ADVERTISING PRIVATE LIMITED",
"JUGADOR TECHNOLOGY PRIVATE LIMITED",
"JUGAI INDUSTRIES PRIVATE LIMITED",
"JUGAI IRON AND STEEL PRIVATE LIMITED",
"JUGAL BAKERS PRIVATE LIMITED",
"JUGAL DEVI SARASWATI VIDYA MANDIR",
"JUGAL FREIGHT SYSTEM PRIVATE LIMITED",
"JUGAL KISHORE RICE MILL PVT LTD",
"JUGAL KISHORE VANASPATI PRODUCTS PRIVATE LIMITED",
"JUGAL TUBE PRIVATE LIMITED",
"JUGAPRO INDIA PRIVATE LIMITED",
"JUGGERNAUT BOOKS PRIVATE LIMITED",
"JUGGLER HAWK INDUSTRIES PRIVATE LIMITED",
"JUGH AGROTECH PRIVATE LIMITED",
"JUGHEAD EXPORTS PRIVATE LIMITED",
"JUGMUG REAL ESTATE PRIVATE LIMITED",
"JUGNU FOODS PRIVATE LIMITED",
"JUGNU HEAVY LOGISTICS PRIVATE LIMITED",
"JUGRAJ ORNAMENTS PRIVATE LIMITED",
"JUGRAJ TEJRAJ AGENCY PRIVATE LIMITED",
"JUGULAR SOCIAL MEDIA PRIVATE LIMITED",
"JUGUNOO SECURITY AND ALLIED SERVICES PRIVATE LIMITED",
"JUGVIJAY ENTERPRISES PRIVATE LIMITED",
"JUHF CERTIFICATION PRIVATE LIMITED",
"JUHI & JAI CONTRACTORS PRIVATE LIMITED",
"JUHI ALLOYS PRIVATE LIMITED",
"JUHI COMMERCIAL PVT.LTD.",
"JUHI ELECTRICALS PRIVATE LIMITED",
"JUHI FIBRES PRIVATE LIMITED",
"JUHI HABITAT PRIVATE LIMITED",
"JUHU BEACH RESORTS LIMITED",
"JUHU RESORTS & DEVELOPMENT PRIVATE LIMITED",
"JUICE HAIR MARKETING PRIVATE LIMITED",
"JUICY CHEMISTRY PRIVATE LIMITED",
"JUIZO ADVISORY PRIVATE LIMITED",
"JUJAMA SOLUTIONS PRIVATE LIMITED",
"JUJAN MARKFIN PRIVATE LIMITED",
"JUJHAR ADVERTISERS PRIVATE LIMITED",
"JUJHAR CONSTRUCTIONS AND TRAVELS PRIVATE LIMITED",
"JUJHAR PASSENGERS BUS SERVICE PRIVATE LIMITED",
"JUKASO PEST CONTROL PRIVATE LIMITED",
"JUKASO YARNS INDUSTRIES PVT LTD",
"JUKI INDIA PRIVATE LIMITED",
"JUKIN MEDIA (INDIA) PRIVATE LIMITED",
"JUKSHIO TECHNOLOGY INNOVATION PRIVATE LIMITED",
"JULIA COMPUTING INDIA PRIVATE LIMITED",
"JULIE INDIA MARKETING PRIVATE LIMITED",
"JULIEN AGRO INFRATECH LIMITED",
"JULIEN DAY SCHOOL",
"JULIET APPARELS PRIVATE LIMITED",
"JULIET APPEREL LIMITED",
"JULIET RUPESH GOMES",
"JULIUS BAER CAPITAL (INDIA) PRIVATE LIMITED",
"JULIUS BAER WEALTH ADVISORS INDIA PRIVATE LIMITED",
"JULIUS66 SOFTWARE INDIA PRIVATE LIMITED",
"JULLUNDUR MOTOR AGENCY (DELHI) LTD (TRS. CO.-DELHI TO HARANA)",
"JULPHAR BUILDERS & DEVELOPERS PRIVATE LIMITED",
"JULY SYSTEMS AND TECHNOLOGIES PRIVATE LIMITED",
"JUMAC MANUFACTURING PVT LTD",
"JUMADI HOSPITALITY PRIVATE LIMITED",
"JUMANI CHIT FUNDS PRIVATE LIMITED",
"JUMAX FOAM PRIVATE LIMITED",
"JUMBO BAG LIMITED",
"JUMBO COURIER COMPANY PRIVATE LIMITED",
"JUMBO ELECTRONICS CORPORATION PRIVATE LIMITED",
"JUMBO ENGINEERING PRIVATE LIMITED",
"JUMBO FINANCE LIMITED",
"JUMBO FINANCE LTD",
"JUMBO FINVEST INDIA LIMITED",
"JUMBO MINING PRIVATE LIMITED",
"JUMBO RESTAURANTS PRIVATE LIMITED",
"JUMBO RESTAURANTS PROJECTS PRIVATE LIMITED",
"JUMBO TOURISM CO. PRIVATE LIMITED",
"JUMBOKING FOODS PRIVATE LIMITED",
"JUMBOTAIL WHOLESALE PRIVATE LIMITED",
"JUMERA PROMOTERS AND DEVELOPERS PRIVATE LIMITED",
"JUMIO INDIA PRIVATE LIMITED",
"JUMO INDIA PRIVATE LIMITED",
"JUMP TRADING FINANCIAL INDIA PRIVATE LIMITED",
"JUMPBALL EDUVENTURES PRIVATE LIMITED",
"JUMPBALL VENTURES LLP",
"JUMPIN ADVENTURE SPORTS (INDIA) PRIVATE LIMITED",
"JUMPIN ADVENTURES PRIVATE LIMITED",
"JUMPS AUTO INDUSTRIES LIMITED",
"JUMPSTART INSURANCE CONSULTANTS PRIVATE LIMITED",
"JUMPUP INTELLIGENT SERVICES PRIVATE LIMITED",
"JUN ACADEMY PRIVATE LIMITED",
"JUN MEI XIN PRIVATE LIMITED",
"JUNA RENEWABLE ENERGY PRIVATE LIMITED",
"JUNAATI TECHNOLOGIES PRIVATE LIMITED",
"JUNAGADE HEALTHCARE PRIVATE LIMITED",
"JUNAGADH AGRICULTURAL UNIVERSITY",
"JUNAGADH AGRICULTURE UNIVERSITY",
"JUNAGADH DISTRICT PRISON GOVERNMENT OF GUJARAT",
"JUNAGADH JEWELLERY PRIVATE LIMITED",
"JUNAGADH MUNICIPAL CORPORATION",
"JUNAID ENTERPRISES",
"JUNAVANE TRAVELS PRIVATE LIMITED",
"JUNE ENTERPRISES PRIVATE LIMITED",
"JUNE GAMING PRIVATE LIMITED",
"JUNE RETAIL PRIVATE LIMITED",
"JUNEJA CONSTRUCTION PVT. LTD.",
"JUNEJA HOTELS PRIVATE LIMITED",
"JUNEJA METRL WORKS PVT LTD",
"JUNEJA PAPERS PVT LTD",
"JUNEJA PROJECT SERVICES PRIVATE LIMITED",
"JUNEJA SIZE AND COAL WASH PRIVATE LIMITED",
"JUNEJA TECHNO CONSULTANTS PRIVATE LIMITED",
"JUNEJA WIRES PRIVATE LIMITED",
"JUNGBU CHEMICAL INDIA PRIVATE LIMITED",
"JUNGBUSCH ALES INDIA PRIVATE LIMITED",
"JUNGDO ENGINEERING INDIA PRIVATE LIMITED",
"JUNGHEINRICH LIFT TRUCK INDIA PRIVATE LIMITED",
"JUNGLE LODGES AND RESORTS LIMITED",
"JUNGLE TRAVELS INDIA PRIVATE LIMITED",
"JUNGLE WORKS PRIVATE LIMITED",
"JUNGLEE GAMES INDIA PRIVATE LIMITED",
"JUNGLEE PICTURES LIMITED",
"JUNGLEHOMES HOLIDAYS PRIVATE LIMITED",
"JUNGLI JAUNTS PRIVATE LIMITED",
"JUNGPURA RIDERS PRIVATE LIMITED",
"JUNIOR DELHIPUBLIC SCHOOL LIMITED",
"JUNIOR SPORTS INDIA",
"JUNIPER CONSTRUCTIONS PRIVATE LIMITED",
"JUNIPER EQUITY INDIA PRIVATE LIMITED",
"JUNIPER GREEN ENERGY PRIVATE LIMITED",
"JUNIPER GREEN SIGMA PRIVATE LIMITED",
"JUNIPER HOTELS LIMITED",
"JUNIPER INVESTMENTS LIMITED",
"JUNIPER NETWORKS INDIA PRIVATE LIMITED",
"JUNIPER NETWORKS SOLUTION INDIA PRIVATE LIMITED",
"JUNISH COMPOSITES (INDIA) PRIVATE LIMITED",
"JUNIWAL DIAMOND PRIVATE LIMITED",
"JUNKAI TECHNOLOGY AND COMMUNICATION PRIVATE LIMITED",
"JUNKET FOODS PRIVATE LIMITED",
"JUNNA LIFE SCIENCES PRIVATE LIMITED",
"JUNNA SOLAR SYSTEMS LIMITED",
"JUNNER AGRO INDUSTRIES PRIVATE LIMITED",
"JUNO CONSULTANTS PRIVATE LIMITED",
"JUNO MONETA TECHNOLOGIES PRIVATE LIMITED",
"JUNO SOFTWARE SYSTEMS PRIVATE LIMITED",
"JUNOBO HOTELS PRIVATE LIMITED",
"JUNOMONETA FINSOL PRIVATE LIMITED",
"JUNOSYS NETWORKS PRIVATE LIMITED",
"JUNOTELE SOLUTIONS PRIVATE LIMITED",
"JUNQFOODS ONLINE SERVICES PRIVATE LIMITED",
"JUNTO HOME PRODUCTS PRIVATE LIMITED",
"JUNTRAN TECHNOLOGIES PRIVATE LIMITED",
"JUNWEI ELECTRONIC PRIVATE LIMITED",
"JUP E-COMM SERVICES INDIA PRIVATE LIMITED",
"JUP SOFT TECHNOLOGIES PRIVATE LIMITED",
"JUPALLY AVENUES PRIVATE LIMITED",
"JUPAX VANIJYA PVT LTD",
"JUPICOM TECHNOLOGIES PRIVATE LIMITED",
"JUPIN HEALTH CARE PRIVATE LIMITED",
"JUPION ELECTRIC PRIVATE LIMITED",
"JUPITER ADMINISTRATIVE AND SECURITY SERVICES PRIVATE LIMITED",
"JUPITER ALLOYS AND STEEL INDIA LIMITED",
"JUPITER ANALYTICS PRIVATE LIMITED",
"JUPITER AQUA LINES LIMITED",
"JUPITER AQUALIFE PRIVATE LIMITED",
"JUPITER BIOLABS PRIVATE LIMITED",
"JUPITER CAPITAL",
"JUPITER CARPETS & FLOORINGS PRIVATE LIMITED",
"JUPITER CHEMICALS PRIVATE LIMITED",
"JUPITER CHIT FUND PRIVATE LIMITED",
"JUPITER CLEARING & FORWARDING PRIVATE LIMITED",
"JUPITER CLOTHING COMPANY PRIVATE LIMITED",
"JUPITER COLLEGE OF ARTS AND MCVC COLLEGE",
"JUPITER COMMOSALE PRIVATE LIMITED",
"JUPITER COMTEX PRIVATE LIMITED",
"JUPITER CONCRETE BLOCKS AND ALLIED PRODUCTS PRIVATE LIMITED",
"JUPITER CORPORATE SERVICES LIMITED",
"JUPITER CULTURAL AND HERITAGE FOUNDATION",
"JUPITER DEALTRADE PRIVATE LIMITED",
"JUPITER DESIGN TECHNOLOGIES PRIVATE LIMITED",
"JUPITER DESTINATION MANAGEMENT COMPANY",
"JUPITER DYE CHEM PRIVATE LIMITED",
"JUPITER DYES PRIVATE LIMITED",
"JUPITER ENERGY TECHNOLOGIES PRIVATE LIMITED",
"JUPITER ESTATES PRIVATE LIMITED",
"JUPITER EXPRESS CARRIER PRIVATE LIMITED",
"JUPITER FOOD PRODUCTS (INDIA) PRIVATE LIMITED",
"JUPITER GASES PRIVATE LIMITED",
"JUPITER GOLDENSTATE LABELS INDIA PRIVATE LIMITED",
"JUPITER HOSPITAL PROJECTS PRIVATE LIMITED",
"JUPITER INTEGRATED SENSOR SYSTEMS PRIVATE LIMITED",
"JUPITER INTERNATIONAL INFRA PRIVATE LIMITED",
"JUPITER LAMINATORS PRIVATE LIMITED",
"JUPITER LEYS PRIVATE LIMITED",
"JUPITER LIFE LINE HOSPITALS LIMITED",
"JUPITER ORGANICS PRIVATE LIMITED",
"JUPITER ORISON PRIVATE LIMITED",
"JUPITER PAPER TRADING COMPANY PRIVATE LIMITED",
"JUPITER PHARMACEUTICALS LTD",
"JUPITER PHARMACY PUNE",
"JUPITER PRINT PACK INDIA PRIVATE LIMITED",
"JUPITER RECYCLING SYSTEMS PRIVATE LIMITED",
"JUPITER RESEARCH SERVICES PRIVATE LIMITED",
"JUPITER ROCK DRILLS PVT LTD",
"JUPITER ROLL FORMING PRIVATE LIMITED",
"JUPITER RUBBER PVT LTD",
"JUPITER SALES PRIVATE LIMITED",
"JUPITER SCAN AND IMAGING CENTRE PRIVATE LIMITED",
"JUPITER SEA & AIR SERVICES PRIVATE LIMITED",
"JUPITER TECHNOLOGIES PRIVATE LIMITED",
"JUPITER TRADE SOLUTION INDIA PRIVATE. LIMITED.",
"JUPITER WAGONS LIMITED",
"JUPITER WHEELS PRIVATE LIMITED",
"JUPITOR COLLGE OF PHYSICAL EDUCATION",
"JUPITOR POLYTEX (INDIA) PRIVATE LTD.",
"JUPIVEN PHARMACEUTICALS PRIVATE LIMITED",
"JUPLAY RETAIL PRIVATE LIMITED",
"JURCHEN TECHNOLOGY INDIA PRIVATE LIMITED",
"JURIMATRIX SERVICES INDIA PRIVATE LIMITED",
"JURIS METRICS CONSULTING PRIVATE LIMITED",
"JURISEARCH SERVICES BOMBAY PRIVATE LIMITED",
"JURONG CONSULTANTS INDIA PRIVATE LIMITED",
"JURONG ENGINEERING (INDIA) PRIVATE LIMITED",
"JUROX ENTERPRISES PRIVATE LIMITED",
"JURY INVESTMENT MALL PRIVATE LIMITED",
"JUS AMAZIN FOODS AND BEVERAGES PRIVATE LIMITED",
"JUS INFRATECH PRIVATE LIMITED",
"JUS' TRUFS CHOCOLATIERS COMPANY PRIVATE LIMITED",
"JUSCO EDUCATION MISSION FOUNDATION",
"JUSCORP ENTERPRISES PRIVATE LIMITED",
"JUSDA INDIA SUPPLY CHAIN MANAGEMENT PRIVATE LIMITED",
"JUSHI INDIA FIBERGLASS PRIVATE LIMITED",
"JUSICA AGRO FOODS PRIVATE LIMITED",
"JUSPAY TECHNOLOGIES PRIVATE LIMITED",
"JUST APPS PRIVATE LIMITED",
"JUST CLEAN FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"JUST CLEAN GLOBAL PRIVATE LIMITED",
"JUST CLICK KARO SERVICES PRIVATE LIMITED",
"JUST CONNECT ELECTRICALS PRIVATE LIMITED",
"JUST DIAL LIMITED",
"JUST DOGS SPALONS PRIVATE LIMITED",
"JUST ENERGY INDIA PRIVATE LIMITED",
"JUST ENGINEERING PRIVATE LIMITED",
"JUST HOLIDAYS PRIVATE LIMITED.",
"JUST IN AGRI FOODS PRIVATE LIMITED",
"JUST IN TIME TRADING PRIVATE LIMITED",
"JUST LADY RETAIL PRIVATE LIMITED",
"JUST LIFESTYLE PRIVATE LIMITED",
"JUST LUGGAGE",
"JUST ONE TECHNOLOGY",
"JUST PRECI COMPS PRIVATE LIMITED",
"JUST PROMINE PRIVATE LIMITED",
"JUST RIGHT LIFE LIMITED",
"JUST SECURE SECURITY PRIVATE LIMITED",
"JUST SHOPPING PRIVATE LIMITED",
"JUST SPRAY MARKETING PRIVATE LIMITED",
"JUST SPRAY PRODUCTS INDIA PRIVATE LIMITED",
"JUST TEXTILES LIMITED",
"JUST TRADE SECURITIES LIMITED",
"JUST UNIVERSAL PRIVATE LIMITED",
"JUST4KIDS SERVICES PRIVATE LIMITED",
"JUSTBOOKS SOLUTIONS PRIVATE LIMITED",
"JUSTCHALO TECHNOLOGIES PRIVATE LIMITED",
"JUSTDISPOSE RECYCLING PRIVATE LIMITED",
"JUSTDOGS UNLEASHED PRIVATE LIMITED",
"JUSTGROW TECHNOLOGIES PRIVATE LIMITED",
"JUSTICE BASHEER AHMED SAYEED COLLEGE FOR WOMEN",
"JUSTICE K S HEGDE CHARITABLE HOSPITAL",
"JUSTICKETS PRIVATE LIMITED",
"JUSTIFIED ADVERTISING SOFTWARE SERVICES INDIA DIGITAL PRIVATE LIMITED",
"JUSTIN ENGINEERING PRIVATE LIMITED",
"JUSTINTEGRATE IT PRIVATE LIMITED",
"JUSTJOBS NETWORK INDIA PRIVATE LIMITED",
"JUSTMED PHARMACY PRIVATE LIMITED",
"JUSTO GLOBAL INDIA PRIVATE LIMITED",
"JUSTO REALFINTECH PRIVATE LIMITED",
"JUSTPICK RETAILS PRIVATE LIMITED",
"JUSTRIGHT HOME APPLIANCES PRIVATE LIMITED",
"JUSTVEND PRIVATE LIMITED",
"JUSTVFX STUDIOS PRIVATE LIMITED",
"JUSTWORK TECHNOLOGIES PRIVATE LIMITED",
"JUSTWRAVEL PRIVATE LIMITED",
"JUTEX INDUSTRIES PRIVATE LIMITED",
"JUTIFY LIFESTYLE PRIVATE LIMITED",
"JUVALIA SALES PRIVATE LIMITED",
"JUVENCA ONLINE PRIVATE LIMITED",
"JUVENILE CREATIONS PRIVATE LIMITED",
"JUVENILE ENGINEERS PRIVATE LIMITED",
"JUVENILE INFRASTRUCTURE PRIVATE LIMITED",
"JUVENILE SOLUTIONS PRIVATE LIMITED",
"JUVENOR HEALTHCARE PRIVATE LIMITED",
"JUVENOR PHARMACEUTICALS",
"JUVENTUS ESTATE LIMITED",
"JUVIN SOFT PRIVATE LIMITED",
"JUWERIYAH NETWORKS PRIVATE LIMITED",
"JUWI INDIA RENEWABLE ENERGIES PRIVATE LIMITED",
"JV AGRO PRIVATE LIMITED",
"JV HOLDING PRIVATE LIMITED",
"JV HR MANAGEMENT PRIVATE LIMITED",
"JV RETAILS PRIVATE LIMITED",
"JV TRANSPORT SERVICE PRIVATE LIMITED",
"JV TRAVELS PRIVATE LIMITED",
"JVA CONSULTANCY PRIVATE LIMITED",
"JVB MEDICARE PRIVATE LIMITED",
"JVCHROM SOLUTIONS PRIVATE LIMITED",
"JVCKENWOOD MARKETING INDIA PRIVATE LIMITED",
"JVD HEALTH PRIVATE LIMITED",
"JVD METTLE INNOVATIONS PRIVATE LIMITED",
"JVG INDIA CONSTRUCTIONS PRIVATE LIMITED",
"JVG PRODUCTS PRIVATE LIMITED",
"JVJ PHARMACEUTICALS PRIVATE LIMITED",
"JVK STEEL PRIVATE LIMITED",
"JVL STEEL PRIVATE LIMITED",
"JVM DEGREE COLLEGE",
"JVM IMEX INTERNATIONAL PRIVATE LIMITED",
"JVM MARKETING PRIVATE LIMITED",
"JVM POLYPLAST PRIVATE LIMITED",
"J-VPD DIAGNOSTICS INDIA PRIVATE LIMITED",
"JVPD ONE PRIVATE LIMITED",
"JVR CROISSANCE INFRASTRUCTURE CO. PRIVATE LIMITED",
"JVR TECHNO PLAST PRIVATE LIMITED",
"JVS BUILDERS & INFRA PRIVATE LIMITED",
"JVS COMATSCO INDUSTRIES PRIVATE LIMITED",
"JVS ELECTRONICS PRIVATE LIMITED",
"JVS EXPORT",
"JVS EXTRACTS",
"JVS FAB PRIVATE LIMITED",
"JVS FLOW CONTROL PRIVATE LIMITED",
"JVS FOREX AND VISA SERVICES PRIVATE LIMITED",
"JVS INDUSTRIES PRIVATE LIMITED",
"JVS ISPAT PRIVATE LIMITED",
"JVS MECHBRICKS PRIVATE LIMITED",
"JVS PRINT MEDIA PRIVATE LIMITED",
"JVS STEEL AND ENERGY PRIVATE LIMITED",
"JVS TECHNOLOGIES PRIVATE LIMITED",
"JVTECH INDUSTRIES PRIVATE LIMITED",
"JW BRANDS PRIVATE LIMITED",
"JW HOSPITALITY PRIVATE LIMITED",
"JW MARRIOTT BENGALURU PRESTIGE GOLFSHIRE RESORT AND SPA",
"JW MARRIOTT HOTEL",
"JW MARRIOTT HOTEL NEW DELHI",
"JW SMART SOLUTIONS PRIVATE LIMITED",
"JWA TECHNOLOGY PRIVATE LIMITED",
"JWALA AUTOMOBILES PRIVATE LIMITED",
"JWALA CARBONICS PRIVATE LIMITED",
"JWALA DEVI SARASWATI VIDYA MANDIR INTTER COLLEGE",
"JWALA LOGISTIC PRIVATE LIMITED",
"JWALA TECHNO ENGINEERING PRIVATE LIMITED",
"JWALADEVI ENTERPRISES PRIVATE LIMITED",
"JWALAJI INDUSTRIES PRIVATE LIMITED",
"JWALAJI PADDY PROCESSING PRIVATE LIMITED",
"JWALAJI SALES PRIVATE LIMITED",
"JWALAMALA AGRO FOODS PRIVATE LIMITED",
"JWALAMUKHI LOGISTICS PRIVATE LIMITED",
"JWALAMUKHI MUDRANALAYA PRIVATE LIMITED",
"JWAY GLOBAL PRIVATE LIMITED",
"JWC LOGISTICS PARK PRIVATE LIMITED",
"JWIL INFRA LIMITED",
"JWL COLD STORE PRIVATE LIMITED",
"JWM AUTO PRIVATE LIMITED",
"JWM BHARAT UDYOG PRIVATE LIMITED",
"JWNGLARY AGRO & TEA PRODUCER COMPANY LIMITED",
"JWP DEVELOPERS PRIVATE LIMITED",
"JWR LOGISTICS PRIVATE LIMITED",
"JWT MINDSET ADVERTISING PRIVATE LIMITED",
"JY PHARMA PRIVATE LIMITED",
"JYA FINANCE AND INVESTMENT COMPANY LIMITED",
"JYA SECURITIES LIMITED",
"JYANGRA ADARSHA VIDYALAYA",
"JYKE PHARMACEUTICAL PRIVATE LIMITED",
"JYM DEVELOPERS PRIVATE LIMITED",
"JYOFLIKK MASS MEDIA & COMMUNICATION PRIVATE LIMITED",
"JYONA GREEN ENERGY PRIVATE LIMITED",
"JYONA INFRA PROJECTS PRIVATE LIMITED",
"JYONI CONSULTANCY PRIVATE LIMITED",
"JYOT EYE HOSPITAL PRIVATE LIMITED",
"JYOT INTERNATIONAL MARKETING LIMITED",
"JYOT OVERSEAS PRIVATE LIMITED",
"JYOT SEWING MACHINE PRIVATE LIMITED",
"JYOTE MOTORS (BALASORE) PRIVATE LIMITED",
"JYOTE MOTORS (BBSR) PRIVATE LIMITED",
"JYOTE MOTORS (BENGAL) PRIVATE LIMITED",
"JYOTE MOTORS PRIVATE LIMITED",
"JYOTE PREMIER PRIVATE LIMITED",
"JYOTECH ENGINEERING CO PRIVATE LIMITED",
"JYOTHI ENTERPRISES",
"JYOTHI GRANITE EXPORTS INDIA PRIVATE LIMITED",
"JYOTHI MARINE SERVICES PRIVATE LIMITED",
"JYOTHI MUTHYALA FOREX SERVICES LIMITED",
"JYOTHI NIVAS COLLEGE",
"JYOTHI SWARUPA COLD DIVISION PRIVATE LIMITED",
"JYOTHINIVAS COLLEGE GIRLS",
"JYOTHIRMAYE PROPERTIES PRIVATE LIMITED",
"JYOTHIS ASSOCIATES PRIVATE LIMITED",
"JYOTHIS COLLECTIONS",
"JYOTHISHKAR MARKETING SERVICES PRIVATE LIMITED",
"JYOTHISHMATHI INSTITUTE OF TECHNOLOGY AND SCIENCE",
"JYOTHY FABRICARE SERVICES LIMITED",
"JYOTHY INSTITUTE OF TECHNOLOGY",
"JYOTHY LABORATORIES LIMITED",
"JYOTHY LABS LIMITED",
"JYOTI (INDIA) METAL INDUSTRIES PRIVATE LIMITED",
"JYOTI AGRO FEEDS PRIVATE LIMITED",
"JYOTI ARCHITECTURAL PRODUCTS PRIVATE LIMITED",
"JYOTI AUDIO VISUAL PRIVATE LIMITED",
"JYOTI AUTOMOBILES PRIVATE LIMITED",
"JYOTI BIOTECH PRIVATE LIMITED",
"JYOTI BOOK DEPOT PRIVATE LIMITED",
"JYOTI CAPSULATIONS PRIVATE LIMITED",
"JYOTI CERAMIC INDUSTRIES PRIVATE LIMITED",
"JYOTI CNC AUTOMATION LIMITED",
"JYOTI COLOURS PRIVATE LIMITED",
"JYOTI COMMODITIES PRIVATE LIMITED",
"JYOTI COMMOTRADE PRIVATE LIMITED",
"JYOTI CONSTRUCTION",
"JYOTI CONSTRUCTION COMPANY NEW DELHI PRIVATE LIMITED",
"JYOTI COOLING TOWERS PRIVATE LIMITED",
"JYOTI COTSPIN PRIVATE LIMITED",
"JYOTI CREATORS PRIVATE LIMITED",
"JYOTI CREDIT & SAVINGS SWABLAMBI SAHAKARI SAMITI LTD",
"JYOTI DARSHNI JEWELLERS PRIVATE LIMITED",
"JYOTI DHAGA UDYOG PRIVATE LIMITED.",
"JYOTI DISPLAY PRIVATE LIMITED",
"JYOTI DYE CHEM PRIVATE LIMITED",
"JYOTI ELECTRICAL PRIVATE LIMITED",
"JYOTI ELECTRO SYSTEMS PRIVATE LIMITED",
"JYOTI ENGI-MECH PRIVATE LIMITED",
"JYOTI ENTERPRISES PRIVATE LIMITED",
"JYOTI EQUIPMENTS PRIVATE LIMITED",
"JYOTI FABPRINTS PRIVATE LIMITED",
"JYOTI FORGE & FABRICATION PRIVATE LIMITED",
"JYOTI GENERAL INDUSTRIES",
"JYOTI GLOBAL PLAST PRIVATE LIMITED",
"JYOTI HEALTHCARE PRIVATE LIMITED",
"JYOTI HEATSINKS PRIVATE LIMITED",
"JYOTI HOLDINGS PVT.LTD.",
"JYOTI HOMEMAKERS PRIVATE LIMITED",
"JYOTI HOSPITAL PRIVATE LIMITED",
"JYOTI HYDRO TECH PRIVATE LIMITED",
"JYOTI INDIA KITCHENSINK PRIVATE LIMITED",
"JYOTI INDUSTRIES FREIGHT CARRIER PRIVATE LIMITED",
"JYOTI INFOSOLUTION PRIVATE LIMITED",
"JYOTI INFRASTRUCTURE PRIVATE LIMITED",
"JYOTI INNOVISION PRIVATE LIMITED",
"JYOTI INOX PRIVATE LIMITED",
"JYOTI INTERNATIONAL FOODS PRIVATE LIMITED",
"JYOTI JEWELLERS (SALES) PRIVATE LIMITED",
"JYOTI KITCHEN INDUSTRIES PRIVATE LIMITED",
"JYOTI LAXMAN ROLLER FLOUR MILLS PVT LTD",
"JYOTI LIMITED",
"JYOTI LOGISTICS PRIVATE LIMITED",
"JYOTI METALLICS INDIA PRIVATE LIMITED",
"JYOTI MINERALS PRIVATE LIMITED",
"JYOTI MONEY EXCHANGE PRIVATE LIMITED",
"JYOTI MOTELS PRIVATE LIMITED",
"JYOTI MOULDERS PRIVATE LIMITED",
"JYOTI MULTI SPECIALITY HOSPITALS PRIVATE LIMITED",
"JYOTI NURSING HOME PRIVATE LIMITED",
"JYOTI PHARMACEUTICALS",
"JYOTI PLASTIC WORKS PRIVATE LIMITED",
"JYOTI POLYVINYL LIMITED",
"JYOTI PORTFOLIO PRIVATE LIMITED",
"JYOTI PRIME-FIN PVT LTD",
"JYOTI PRINT AND PRIVATE LIMITED",
"JYOTI PROCESS EQUIPMENTS PRIVATE LIMITED",
"JYOTI PROCESSORS PRIVATE LIMITED",
"JYOTI PROCESSORS PVT LTD",
"JYOTI RESINS AND ADHESIVES LTD",
"JYOTI ROCKS & EXPORTS PRIVATE LIMITED",
"JYOTI RUBBER UDYOG (INDIA) LIMITED",
"JYOTI RUBBERS PRIVATE LIMITED",
"JYOTI SAMPATTI PRIVATE LIMITED",
"JYOTI SOLAR SOLUTIONS PRIVATE LIMITED",
"JYOTI SOLUTIONSWORKS PRIVATE LIMITED",
"JYOTI STRIPS PRIVATE LIMITED",
"JYOTI SWITCHGEARS PRIVATE LIMITED",
"JYOTI TAR PRODUCTS PRIVATE LIMITED",
"JYOTI TECHNICAL SERVICES PRIVATE LIMITED",
"JYOTI THREADS (INDIA) PRIVATE LIMITED",
"JYOTI TRANSPET PRIVATE LIMITED",
"JYOTI TTURBO POWER SERVICES PRIVATE LIMITED",
"JYOTI VACUUM TECHNOLOGIES PRIVATE LIMITED",
"JYOTI VIDHYA MANDIR SCHOOL",
"JYOTI VIDHYA PITH SEN SEC SCHOOL",
"JYOTI VIDHYALAYA",
"JYOTI VINCOM PRIVATE LIMITED",
"JYOTI VINYL LIMITED",
"JYOTI VISHNU PHARMA PRIVATE LIMITED",
"JYOTI WATERPROOF WORKS PRIVATE LIMITED",
"JYOTIBA HOSPITAL",
"JYOTIBA PHULE EDUCATIONAL COLLEGE",
"JYOTIBEST PACKERS AND MOVERS PRIVATE LIMITED",
"JYOTICHAND BHAICHAND SARAF",
"JYOTIDARSHAN TRADERS PRIVATE LIMITED",
"JYOTIKA APPLIANCES PRIVATE LIMITED",
"JYOTIKA STRIPS PRIVATE LIMITED",
"JYOTIKIRAN ENERGY BHILWARA PRIVATE LIMITED",
"JYOTIKIRAN ENERGY CHENNAI PRIVATE LIMITED",
"JYOTIKIRAN ENERGY OKHLA PRIVATE LIMITED",
"JYOTINDRA INDUSTRIES PRIVATE LIMITED",
"JYOTIOM CHEMICALS RESEARCH CENTRE PRIVATE LIMITED",
"JYOTIPUNJ INTERNATIONAL PRIVATE LIMITED",
"JYOTIRADITYA POLYPACKS PRIVATE LIMITED",
"JYOTIRMAY HOUSING PRIVATE LIMITED",
"JYOTIRMAY JEWELS PRIVATE LIMITED",
"JYOTIRMAY MERCHANDISE PRIVATE LIMITED",
"JYOTIRMAYE TEXTILES PRIVATE LIMITED",
"JYOTIRMAYEE FOODS PRIVATE LIMITED",
"JYOTIRMAYEE LOGISTICS PRIVATE LIMITED",
"JYOTIRMOY AGRO PRIVATE LIMITED",
"JYOTISH BHOGILAL STOCK BROKERS PVT LTD",
"JYOTISHMAN MULTI-DISCIPLINARY HOSPITAL PRIVATE LIMITED",
"JYOTISHREE ENTERPRISES PRIVATE LIMITED",
"JYOTISUPER BUILDERS PRIVATE LIMITED",
"JYOTISUPER CONSTRUCTION AND HOUSING PRIVATE LIMITED",
"JYOTSANA GARMENTS PRIVATE LIMITED",
"JYOTSNA HOLDING PRIVATE LIMITED",
"JYOTSNA LAMPS CAPS PRIVATE LIMITED",
"JYOTSNA TECHNICAL AND MECHANICAL SERVICES PRIVATE LIMITED",
"JYOTSNAREDDY HOSPITAL PRIVATE LIMITED",
"JYPORE MANUFACTURING JEWELLERS PRIVATE LIMITED",
"JYT SUPPLY CHAIN (INDIA) PRIVATE LIMITED",
"JYTE LOGISTICS PRIVATE LIMITED",
"JYVA ENGINEERING PRIVATE LIMITED",
"JYY AUTOMATION TECHNOLOGIES PRIVATE LIMITED",
"JZ HOSPITALITY PRIVATE LIMITED",
"JZERO IT SOLUTIONS PRIVATE LIMITED",
"K & A GOLF PRIVATE LIMITED",
"K & B DEBT MANAGEMENT PRIVATE LIMITED",
"K & C INFRATECH PRIVATE LIMITED",
"K & J PROJECT PRIVATE LIMITED",
"K & K CONTECH ENGINEERING PRIVATE LIMITED",
"K & K IMPLEMENTS PRIVATE LIMITED",
"K & K TYRE EXPERTS PRIVATE LIMITED",
"K 3 DIGITAL MEDIA PRIVATE LIMITED",
"K A COMMODITIES PRIVATE LIMITED",
"K A ENGINEERS PRIVATE LIMITED",
"K A ENTERPRISES",
"K A EXPORTS PRIVATE LIMITED",
"K A I INTERNATIONAL PRIVATE LIMITED",
"K A INDUSTRIES",
"K A J CHEMICALS PRIVATE LIMITED",
"K A J INFRASTRUCTURE PRIVATE LIMITED",
"K A MALLE PHARMACEUTICALS LIMITED",
"K A R LEATHERS PRIVATE LIMITED",
"K A S TANNING COMPANY PRIVATE LIMITED",
"K A SANGHI ENTERPRISES PRIVATE LIMITED",
"K ANAND INDUSTRIES PRIVATE LIMITED",
"K AND D COMMUNICATION LIMITED",
"K AND K HOMEWARE PRIVATE LIMITED",
"K AND K SUPERSPECIALITY HOSPITAL",
"K AND S PACKAGING DYNAMICS PRIVATE LIMITED",
"K AND T AGRO MILLS PVT LTD",
"K B A AGROTECH PRIVATE LIMITED",
"K B A INFRASTRUCTURE PRIVATE LIMITED",
"K B AQUA PURE PRIVATE LIMITED",
"K B CHLORINATION PRIVATE LIMITED",
"K B CONTRACT PRIVATE LIMITED",
"K B DESIGNS PRIVATE LIMITED",
"K B ENGINEERING CO PVT LTD",
"K B ENTERPRISES PRIVATE LIMITED",
"K B FASHIONS PRIVATE LIMITED",
"K B INFRACON PRIVATE LIMITED",
"K B K PLASCON PRIVATE LIMITED",
"K B MEHTA CONSTRUCTION PRIVATE LIMITED",
"K B PRODUCTS PRIVATE LIMITED",
"K B SAHA & SONS INDUSTRIES PRIVATE LIMITED",
"K B SALES LTD",
"K B SHAH VINAY MANDIR VIRMAGAM",
"K B SPONGE IRON LIMITED",
"K B SWITCH GEAR PVT LTD",
"K B TEA PRODUCT PRIVATE LIMITED",
"K BANSAL AND SONS AGENCIES PRIVATE LIMITED",
"K BHUPAL ENGINEERS AND CONTRACTORS PRIVATE LIMITED",
"K BHURJEE MACHINERY PRIVATE LIMITED",
"K BIOLOGICALS PRIVATE LIMITED",
"K C AGARWAL MERCHANTS PRIVATE LIMITED",
"K C ASTIR AND CO PRIVATE LTD",
"K C C PRIMARY SCHOOL SANGLI",
"K C CITY CENTRE PRIVATE LIMITED",
"K C DAIRY PRODUCTS PRIVATE LIMITED",
"K C DAS PVT LTD",
"K C ENGINEERS LIMITED",
"K C ENTERPRISES",
"K C FERRO AND REROLLING MILLS PRIVATE LIMITED",
"K C G INFOTECH PRIVATE LIMITED",
"K C GARMENTS PRIVATE LIMITED",
"K C HOLDINGS PRIVATE LIMITED",
"K C HOTELS PRIVATE LIMITED",
"K C INDIA LIMITED",
"K C INTERNATIONAL LIMITED",
"K C J SONS PRIVATE LIMITED",
"K C KOPAR ENERGY SOLUTIONS PRIVATE LIMITED",
"K C PIPES PRIVATE LIMITED",
"K C POWER INFRA PRIVATE LIMITED",
"K C PRADHAN MINERAL PRIVATE LIMITED",
"K C ROLLER FLOUR MILLS PRIVATE LIMITED",
"K C S KASI NADAR COLLEGE OF ARTS AND SCIENCE",
"K C SANKARALINGA NADAR HIGHER SECONDARY SCHOOL",
"K C TEXTILES LIMITED",
"K CUBE EVENTS AND SPORTS ZONE",
"K D AMBANI RELIANCE FOUNDATION SCHOOL",
"K D AUTOCARE PRIVATE LIMITED",
"K D B PUBLIC SCHOOL",
"K D BHATIA DYEING AND PRINTING MILLS PRIVATE LIMITED",
"K D BUILDING SOLUTIONS PRIVATE LIMITED",
"K D C BONDED WARE HOUSE PVT LTD",
"K D COOL TECS PRIVATE LIMITED",
"K D FACILIITIES PRIVATE LIMITED",
"K D GAVIT MADHYAMIK VIDYALAYA DEVPUR",
"K D HYDRAULIC COMPONENTS PRIVATE LIMITED",
"K D INFRA",
"K D JAG HOLDINGS PVT LTD",
"K D JEWELS PRIVATE LIMITED",
"K D K COLLEGE OF ENGG",
"K D KOTHARI AND CO",
"K D LITE DEVELOPERS PRIVATE LIMITED",
"K D MEDICAL COLLEGE AND HOSPITAL",
"K D METALLOYS AND ENGINEERING PRIVATE LIMITED",
"K D P INFRASTRUCTURE PRIVATE LIMITED",
"K D PAWAR COLLEGE OF PHARMACY",
"K D R ENTERPRISES PRIVATE LIMITED",
"K D S WIND FARMS PRIVATE LIMITED",
"K D SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED",
"K DANIELS PROJECTS (INDIA) PRIVATE LIMITED",
"K DASS PHARMA DISTRIBUTORS PVT LTD",
"K E A CONSULTANTS PRIVATE LIMITED",
"K E AGRO PRODUCTS PRIVATE LIMITED",
"K E CARMEL SCHOOL AMTALA",
"K F BIOTECH PRIVATE LIMITED",
"K F PRINTS PRIVATE LIMITED",
"K FACTOR COMMUNICATIONS PRIVATE LIMITED",
"K FLEX",
"K FLEX INDIA PRIVATE LIMITED",
"K- FOR KATHIYAWAD RETAIL PRIVATE LIMITED",
"K G BUILDESTATE PRIVATE LIMITED",
"K G DENIM LIMITED",
"K G EMBROIDERY MILLS LIMITED",
"K G ENTERTAINMENT COMPANY PRIVATE LIMITED",
"K G HEALTHCARE PRIVATE LIMITED",
"K G KRISHNA FOOD PRODUCT PRIVATE LIMITED",
"K G LIFE SCIENCE PRIVATE LIMITED",
"K G MULTI SPECIALITY HOSPITAL AND RESEARCH CENTRE",
"K G N ELECTRICALS",
"K G N MOTORS PRIVATE LIMITED",
"K G PLAST MFG PRIVATE LIMITED",
"K G PRINT PACK PRIVATE LIMITED",
"K G PROJECTS AND EQUIPMEMT MARKETING COMPANY PRIVATE LIMITED",
"K G S SARVODAYA SCHOOL",
"K G TECH ASSOCIATE PRIVATE LIMITED",
"K H FACILITY SOLUTIONS INDIA PRIVATE LIMITED",
"K H I COLD STORAGE PRIVATE LIMITED",
"K H KEHMANI & SONS",
"K H T AGENCIES PRIVATE LIMITED",
"K I C METALIKS LIMITED",
"K I C RESOURCES LTD",
"K I GLASSWARE INDIA PRIVATE LIMITED",
"K I H E SOCIETY'S MAHARASHTRA COLLEGE OF ARTS SCIENCE AND COMMERCE",
"K I Z FOODS PRIVATE LIMITED",
"K J FASHIONS AND DESIGNERS PRIVATE LIMITED",
"K J GLASS INDUSTRIES PRIVATE LIMITED",
"K J INFRASTRUCTURE PROJECTS INDIA PRIVATE LIMITED",
"K J KHILNANI HIGH SCHOOL & JR COLLEGE",
"K J REALINFRA PRIVATE LIMITED",
"K J SHIPPING & LOGISTICS PRIVATE LIMITED",
"K J SOLAR SYSTEMS PRIVATE LIMITED",
"K J SOMAIYA AND SONS PRIVATE LIMITED",
"K J SOMAIYA COLLEGE OF NURSING",
"K J SOMAIYA MEDICAL COLLEGE",
"K J SOMIAYA HOSPITAL AND RESEARCH CENTER",
"K JAYANTILAL SECURITIES PRIVATE LIMITED",
"K K & COMPANY",
"K K AGRO FOODS & STORAGE PRIVATE LIMITED",
"K K APPARELS PRIVATE LIMITED",
"K K BEVERAGES PRIVATE LIMITED",
"K K BREWERIES PVT LTD",
"K K CABLES PRIVATE LIMITED",
"K K CAPITAL SERVICES LIMITED",
"K K CEMPROTECH PRIVATE LIMITED",
"K K CHEMPRO (INDIA) PRIVATE LIMITED",
"K K CORPORATION",
"K K COTTEX PRIVATE LIMITED",
"K K DUPLEX AND PAPER MILLS PRIVATE LIMITED",
"K K EATERIES PRIVATE LIMITED",
"K K EMBRO-TEX PRIVATE LIMITED",
"K K ENGINEERS AND PROMOTORS PRIVATE LIMITED",
"K K ENVIRO TECH PRIVATE LIMITED",
"K K FIBERS",
"K K FOREX PRIVATE LIMITED",
"K K GEO SYSTEM PRIVATE LIMITED",
"K K GUPTA CONSTRUCTIONS PRIVATE LIMITED",
"K K HEAVY MACHINERY & SERVICES PRIVATE LIMITED",
"K K HOLDING LLP",
"K K HOSIERY PRIVATE LIMITED",
"K K INFRAHOMES PRIVATE LIMITED",
"K K INFRAPROMOTERS PRIVATE LIMITED",
"K K INTENSIVE CARE HOSPITAL PRIVATE LIMITED",
"K K INTER COLLEGE",
"K K INTER LININGS MANUFACTURING CO PVT LTD",
"K K K EXPORTS PRIVATE LIMITED",
"K K K FABRIC PROCESSORS PRIVATE LIMITED",
"K K K HYDRO POWER LIMITED",
"K K KANSAL POLYVIN PRIVATE LIMITED",
"K K LOGISTICS & SERVICES LLP",
"K K MANHOLE AND GRATINGS COMPANY PRIVATE LIMITED",
"K K MEDICARE PRIVATE LIMITED",
"K K MODI INVESTMENT AND FINANCIAL SERVICES PRIVATE LIMITED",
"K K MOTORS",
"K K NAG PRIVATE LIMITED",
"K K P FABRICS PRIVATE LIMITED",
"K K P GARMENTS PRIVATE LIMITED",
"K K P HI TECH WEAVING INDIA PRIVATE LIMITED",
"K K P SPINNING MILLS PRIVATE LIMITED",
"K K P TEXTILES PRIVATE LIMITED",
"K K P WEAVING AND PROCESSING MILLS LIMITED",
"K K P WIND FARMS PRIVATE LIMITED",
"K K POLYCOLOR ASIA LIMITED",
"K K POULTRY PRIVATE LIMITED",
"K K R ENT HOSPITAL AND RESEARCH INSTITUTE PRIVATE LIMITED",
"K K R ENTERPRISES PRIVATE LIMITED",
"K K R INSTITUTE OF INFORMATION TECHNOLOGY",
"K K RECLAMATIONS PRIVATE LIMITED",
"K K RESOURCES PRIVATE LIMITED",
"K K ROLLER FLOUR MILLS PVT LTD",
"K K ROPEWAYS PRIVATE LIMITED",
"K K S DEVELOPERS INDIA PRIVATE LIMITED",
"K K S ENTERTAINMENT PRIVATE LIMITED",
"K K SALES PRIVATE LIMITED",
"K K SARRAF & SONS PRIVATE LIMITED",
"K K SHEETS PRIVATE LIMITED",
"K K SILK MILLS LIMITED",
"K K SOFTWARE PRIVATE LIMITED",
"K K SPINNERS PVT LTD",
"K K SPINTEX INDIA PRIVATE LIMITED",
"K K SPUN INDIA LIMITED",
"K K STOCK MANAGEMENT PRIVATE LIMITED",
"K K TALWAR FABRICS PRIVATE LTD",
"K K TECHNOCRATS PRIVATE LIMITED",
"K K VADIA AGRO PRIVATE LIMITED",
"K KALIDAS FASHIONS PRIVATE LIMITED",
"K KOSMIK TECHNOLOGIES PRIVATE LIMITED",
"K KYEMISTRY INDIA PRIVATE LIMITED",
"K L B INSTRUMENTS COMPANY PRIVATE LIMITED",
"K L B SECURITIES PVT LTD",
"K L DUTT & SONS (METAL REFORM) PRIVATE LIMITED",
"K L ENVITECH PRIVATE LIMITED",
"K L F NIRMAL INDUSTRIES PRIVATE LIMITED",
"K L G PUBLIC SCHOOL",
"K L GUPTA AND SONS PRIVATE LIMITED",
"K L ISPAT PRIVATE LIMITED",
"K L J POLYMERS AND CHEMICALS LIMITED",
"K L JAIN INTER COLLEGE",
"K L M ROYAL DUTCH AIRLINES",
"K L MEHTA DAYANAND COLLEGE FOR WOMEN FARIDABAD",
"K L MEMORIAL SR SEC SCHOOL",
"K L N ARTS AND SCIENCES COLLEGE",
"K L N ENGINEERING PRODUCTS PRIVATE LIMITED",
"K L PROJECTS PRIVATE LIMITED",
"K L R INDUSTRIES LIMITED",
"K L R TECHNOLOGIES PRIVATE LIMITED",
"K L RATHI STEELS LIMITED",
"K L STEELS PRIVATE LIMITED",
"K L. VEGETABLE OIL PRODUCTS PRIVATE LIMITED",
"K LALCHAND PRIVATE LIMITED",
"K LALL OVERSEAS",
"'K' LINE (INDIA) SHIPPING PRIVATE LIMITED",
"K LINE INDIA PRIVATE LIMITED",
"K LINE MARITIME ACADEMY INDIA",
"K LINE SHIP MANAGEMENT INDIA PRIVATE LIMITED",
"K LOG GLOBAL PRIVATE LIMITED",
"K M A RESORTS PRIVATE LIMITED",
"K M C ALUMINIUM PRIVATE LIMITED",
"K M C MAZDOORS CO OPERATIVE SOCIETY LTD",
"K M CABLES PRIVATE LIMITED",
"K M CHOKSI PRIVATE LIMITED",
"K M COTTON PRINT PRIVATE LIMITED",
"K M DASTUR REINSURANCE BROKERS PRIVATE LIMITED",
"K M ENEGRY SOLUTION PRIVATE LIMITED",
"K M ENERGY PRIVATE LIMITED",
"K M GALVANIZER (INDIA) PRIVATE LIMITED",
"K M GANDHI METALS PRIVATE LIMITED",
"K M GLOBAL CREDIT PRIVATE LIMITED",
"K M GLOBAL FINANCIAL SERVICES PRIVATE LIMITED",
"K M INFRATECH PRIVATE LIMITED",
"K M JAIN STOCK BROKERS PRIVATE LIMITED",
"K M JEWELLERS PRIVATE LIMITED",
"K M KNITWEAR PRIVATE LIMITED",
"K M KUNDNANI COLLEGE OF PHARMACY",
"K M OILS PRIVATE LIMITED",
"K M POLYESTER BUTTONS PRIVATE LIMITED",
"K M S ASSOCIATES",
"K M S MILL PRIVATE LIMITED",
"K M SEAT COMPANY PRIVATE LIMITED",
"K M SUGAR MILLS LIMITED",
"K M T S ENGINEERING PRIVATE LIMITED",
"K M TRANS LOGISTICS PRIVATE LIMITED",
"K M VYAPAR LIMITED",
"K MASS CONTROL PRIVATE LIMITED",
"K N AUTOMOBILES PRIVATE LIMITED",
"K N BAKERS PRIVATE LIMITED",
"K N CHAUDHURY & CO PVT LTD",
"K N GOYAL ICE AND COLD STORAGE PRIVATE LIMITED",
"K N IMPEX PRIVATE LIMITED",
"K N INDUSTRIAL ABRASIVES PRIVATE LIMITED",
"K N INTERNATIONAL LIMITED",
"K N K STAGE LIGHTS PRIVATE LIMITED",
"K N MOTORS PRIVATE LIMITED",
"K N R AUTOMOBILES PRIVATE LIMITED",
"K N RESOURCES PRIVATE LIMITED",
"K N S HAJEE SHAIK ABDUL KADER LABBAI SAHIB COMPANY PRIVATE LTD",
"K NANAVATTI AND COMPANY PRIVATE LIMITED",
"K NARESHKUMAR FABRICS PRIVATE LIMITED",
"K NET SOLUTIONS PRIVATE LIMITED",
"K NETWORKS INNOVATIVE SOLUTIONS PRIVATE LIMITED",
"K NIDHAN INFRAPROJECTS PRIVATE LIMITED",
"K NINE WRITING SYSTEMS PRIVATE LIMITED",
"K P AUTOMOBILES PRIVATE LIMITED",
"K P B HINDUJA COLLEGE OF COMMERCE",
"K P BADGUJAR CONSULTANTS PRIVATE LIMITED",
"K P BUILDCON PRIVATE LIMITED",
"K P C PUBLIC SCHOOL",
"K P CIVIL CONSTRUCTION PRIVATE LIMITED",
"K P COMMERCIAL PRIVATE LIMITED",
"K P COMMODITIES PRIVATE LIMITED",
"K P DIAMONDS PRIVATE LIMITED",
"K P ENERGY LIMITED",
"K P H DREAM CRICKET PRIVATE LIMITED",
"K P INTERMEDIATE COLLEGE",
"K P INTERNATIONAL PRIVATE LIMITED",
"K P L OIL MILLS PRIVATE LIMITED",
"K P L PLASTIC WORKS PRIVATE LIMITED",
"K P M AGRO FOOD PRODUCTS PRIVATE LIMITED",
"K P M EQUIPMENTS PRIVATE LIMITED",
"K P MANISH GLOBAL INGREDIENTS PRIVATE LIMITED",
"K P N TEXTILE MILLS PRIVATE LIMITED",
"K P R AGROCHEM LIMITED",
"K P R CROPSCIENCES PRIVATE LIMITED",
"K P R MILL LIMITED",
"K P R SUGAR MILL LIMITED",
"K P S A & ASSOCIATES",
"K P S OVERSEAS PRIVATE LIMITED",
"K P SANGHVI INTL PRIVATE LIMITED",
"K P SHAW BOTTLING PRIVATE LIMITED",
"K P SOLVEX PRIVATE LTD",
"K P TEXTILES COIMBATORE PRIVATE LIMITED",
"K P TOWERS PRIVATE LIMITED",
"K P TRANSPORTS PRIVATE LIMITED",
"K P VERMA JEWELLERS PRIVATE LIMITED",
"K P WOVEN PRIVATE LIMITED",
"K PARTH ENTERPRISES",
"K PATEL & CO PRIVATE LIMITED",
"K PATEL CHEMO-PHARMA PRIVATE LIMITED",
"K PATEL DYE-CHEM INDUSTRIES PRIVATE LIMITED",
"K PATEL METAL INDUSTRIES PRIVATE LIMITED",
"K PATEL PHYTO EXTRACTIONS PRIVATE LIMITED",
"K PYRAMID EQUIPMENTS PRIVATE LIMITED",
"K R AUTO COMPONENTS PRIVATE LIMITED",
"K R AUTOTECH PRIVATE LIMITED",
"K R B S JEWELERY PRIVATE LIMITED",
"K R BAKES PRIVATE LIMITED",
"K R CHAWLA CONSULTING PRIVATE LIMITED",
"K R CHOKSEY INVESTMENT MANAGERS PRIVATE LIMITED",
"K R CORPORATE CONSULTANTS PRIVATE LIMITED",
"K R CREATION PRIVATE LIMITED",
"K R FINANCIAL AND MANAGEMENT SERVICE PRIVATE LIMITED",
"K R FINMARK PRIVATE LIMITED",
"K R FOOTWEAR PRIVATE LIMITED",
"K R G CABLES PRIVATE LIMITED",
"K R GANDHI LOGISTICS PRIVATE LIMITED",
"K R HEALTH CARE PRIVATE LIMITED",
"K R INDUSTRIAL PROJECTS PVT LTD",
"K R INDUSTRIES",
"K R INFRASTRUCTURES LIMITED",
"K R J RETAIL PRIVATE LIMITED",
"K R LYNCH & COMPANY PVT LTD",
"K R MOTELS PRIVATE LIMITED",
"K R NET SOLUTIONS PRIVATE LIMITED",
"K R PLYWOOD WORKS PRIVATE LIMITED",
"K R PULP AND PAPERS LIMITED",
"K R R ENGINEERING PRIVATE LIMITED",
"K R REAL ESTATE PRIVATE LIMITED",
"K R REALCON PRIVATE LIMITED",
"K R SEA FOODS PRIVATE LIMITED",
"K R THERMO PACK PRIVATE LIMITED",
"K R TOOLS PRIVATE LIMITED",
"K R TRADERS PVT LTD",
"K R TRANS ENERGY PRIVATE LIMITED",
"K R V BUILDTECH PRIVATE LIMITED",
"K R V SPINNING MILLS PRIVATE LIMITED",
"K R WEAVING MILLS PRIVATE LIMITED",
"K R YARNS PRIVATE LIMITED",
"K RAHEJA",
"K RAHEJA CONSTRUCTION",
"K RAHEJA CORP INVESTMENT MANAGERS LLP",
"K RAHEJA CORP PRIVATE LIMITED",
"K RAHEJA CORPORATE SERVICES PRIVATE LIMITED",
"K RAHEJA HOMES PRIVATE LIMITED",
"K RAHEJA PRIVATE LIMITED",
"K RAHEJA REALTY PRIVATE LIMITED",
"K RAMABRAHMAM AND SONS PRIVATE LIMITED",
"K RAMACHANDRA RAO TRANSMISSION AND PROJECTS PRIVATE LIMITED PART IX",
"K RAMAKRISHNAN COLLEGE OF TECHNOLOGY",
"K RASIKLAL EXIM PRIVATE LIMITED",
"K S AGROTECH PRIVATE LIMITED",
"K S ANDW D ASSOCIATES PRIVATE LIMITED",
"K S APPARELS PRIVATE LIMITED",
"K S AUTO SERVICES PRIVATE LIMITED",
"K S BAKERS PRIVATE LIMITED",
"K S BISHT CONSTRUCTION PRIVATE LIMITED",
"K S ENTERPRISES PRIVATE LIMITED",
"K S GROUP OF INSTITUTIONS",
"K S HEGDE MEDICAL ACADEMY",
"K S INCTECH PRIVATE LIMITED",
"K S INFRACON PRIVATE LIMITED",
"K S K DIAGNOSTICS PRIVATE LIMITED",
"K S L RESOURCES PRIVATE LIMITED",
"K S M PUBLIC SCHOOL",
"K S METALS PVT LTD",
"K S MOTORS PRIVATE LTD",
"K S NUTRITIONS AND FOOD PRIVATE LIMITED",
"K S P S CFS PARK PRIVATE LIMITED",
"K S PLASTOCHEM INC",
"K S PROJECTS AND PROCESS ENGINEERS PRIVATE LIMITED",
"K S R ALANKAR HOTELS AND RESORTS PRIVATE LIMITED",
"K S R AUTO PRIVATE LIMITED",
"K S R COLLEGE OF ENGINEERING",
"K S R FREIGHT FORWARDERS PRIVATE LIMITED",
"K S R INFRAHOLDINGS PRIVATE LIMITED",
"K S R POLYTECHNIC COLLEGE",
"K S R TEXTILE MILLS PRIVATE LIMITED",
"K S REALTY CONSTRUCTIONS PRIVATE LIMITED",
"K S S REAL INFRA PRIVATE LIMITED",
"K S SPINNING MILLS PRIVATE LIMITED",
"K S SUBBIAH PILLAI AND COMPANY INDIA LIMITED",
"K S SYNTEX PRIVATE LIMITED",
"K S SYNTHETICS PRIVATE LIMITED.",
"K S TRADING",
"K S TRAVELS PRIVATE LIMITED",
"K S V HIGHER SECONDARY SCHOOL",
"K S VATASALA BAI BAPUSAHEB PATIL MA VIDYALAY TOP",
"K S WORLD WIDE EXPORTS PRIVATE LIMITED",
"K SERA SERA BOX OFFICE PRIVATE LIMITED",
"K SERA SERA CINEMA FACILITY MANAGEMENT PRIVATE LIMITED",
"K SERA SERA DIGITAL CINEMA PRIVATE LIMITED",
"K SERA SERA MINIPLEX LIMITED",
"K SESHAGIRI RAO & COMPANY",
"K SHARMA ELECTRICALS PRIVATE LIMITED",
"K SONS PROJECTS PRIVATE LIMITED",
"K SQUARE GLOBAL LOGISTICS PRIVATE LIMITED",
"K SQUARE GRANITE PRIVATE LIMITED",
"K SQUARE INDIA TECHNOLOGIES PRIVATE LIMITED",
"K SQUARE INFRATECH AND INTERIORS PRIVATE LIMITED",
"K SQUARE MOTORS PRIVATE LIMITED",
"K STAR SHIPPING AGENCY PRIVATE LIMITED",
"K STEAMSHIP AGENCIES PRIVATE LIMITED",
"K T B HOTELS PRIVATE LIMITED",
"K T C (INDIA) PRIVATE LIMITED",
"K T C EXPORT PRIVATE LIMITED",
"K T DESAI CLEARING & FORWARDING LLP",
"K T EXPORTS INDIA PRIVATE LIMITED",
"K T L SEEDS FARM PRIVATE LIMITED",
"K T M L PACK PRIVATE LIMITED",
"K T QUALITY CONTROL PRIVATE LIMITED",
"K T RESORT AND SPA PRIVATE LIMITED",
"K T SPINNING MILLS PRIVATE LIMITED",
"K T V HEALTH FOOD PRIVATE LIMITED",
"K T V OIL MILLS PRIVATE LIMITED",
"K TECH ENGINEER BUILDERS COMPANY PRIVATE LIMITED",
"K TRANS LOGISTICS SOLUTIONS PRIVATE LIMITED",
"K TREE COMPUTER SOLUTIONS INDIA PRIVATE LIMITED",
"K U N AUTO COMPANY PRIVATE LIMITED",
"K U SODALAMUTHU AND CO PRIVATE LIMITED",
"K V AROCHEM PRIVATE LIMITED",
"K V CARBONICS PVT LTD",
"K V CORDFABS PRIVATE LIMITED",
"K V DEVELOPMENT AND INVESTMENT CO PVT LTD",
"K V EDUCATION VENTURES PRIVATE LIMITED",
"K V ENTERPRISES PRIVATE LTD",
"K V INTER COLLEGE",
"K V JOSEPH AND SONS PRIVATE LIMITED",
"K V PHARMA DISTRIBUTORS PRIVATE LIMITED",
"K V PUBLIC SCHOOL",
"K V R KIDNEY & DIABETIC CENTRE",
"K W H ENGINEERING WORK",
"K WATCH PRIVATE LIMITED",
"K Y A APPAREL LLP",
"K Y C CARGO SERVICES PRIVATE LIMITED",
"K Y MOTORS PRIVATE LIMITED",
"K Y S SPONGE IRON PRIVATE LIMITED",
"K Z LEASING AND FINANCE LIMITED",
"K&A INDIA ENGINEERING CONSTRUCTIONS PRIVATE LIMITED",
"K&L COMMUNICATIONS INDIA PRIVATE LIMITED",
"K&M GARMENGUARDINI (INDIA) PRIVATE LIMITED",
"K&M TOYS INDIA PRIVATE LIMITED",
"K&R RAIL ENGINEERING LIMITED",
"K&S COLLECTION PRIVATE LIMITED",
"K&S PARTNERS",
"K. AJAY KUMAR REDDY",
"K AND R NURSING CENTER PRIVATE LIMITED",
"K. B. AROMATICS PRIVATE LIMITED",
"K. B. IMPEX",
"K. B. SYNCOTEX PRIVATE LIMITED",
"K. C CREATIONS PRIVATE LIMITED",
"K. C. AUTO MART PRIVATE LIMITED",
"K. C. S. KASI NADAR COLLEGE OF ARTS AND SCIENCE",
"K. C. SAREE CREATION PRIVATE LIMITED",
"K. CHANDRAKANT & CO. INTERNATIONAL PRIVATE LIMITED",
"K. D. COKES",
"K. D. GARMENTS PRIVATE LIMITED",
"K. D. RESOURCES PRIVATE LIMITED",
"K. D. ROLLER FLOUR MILLS PRIVATE LIMITED",
"K. D. SAREE EMPORIUM PRIVATE LIMITED",
"K. D. TELECOM PRIVATE LIMITED",
"K. DAMANI HOSPITALITY PRIVATE LIMITED",
"K. DINESH FURNISHING PRIVATE LIMITED",
"K. E. INFRASTRUCTURE PRIVATE LIMITED",
"K. G. GUPTA INFRASTRUCTURE PRIVATE LIMITED",
"K. G. SOFTECH PRIVATE LIMITED",
"K. GEERISH TEX-FAB PRIVATE LIMITED",
"K. H. PIPES PRIVATE LIMITED",
"K. H. TOYMAXX PRIVATE LIMITED",
"K. K. C NIRMAN INDIA LIMITED",
"K. K. CONSTRUCTION COMPANY",
"K. K. COTEX",
"K. K. ORGANOSYS AND POLYMERS PRIVATE LIMITED",
"K. K. TEX ENTERPRISES",
"K. L. JAIN TEXTILE PRIVATE LIMITED",
"K. LAKSHMANA ACHARI SON JEWELLERS PRIVATE LIMITED",
"K. M. AGRIPRODUCTS PRIVATE LIMITED",
"K. M. CARS PRIVATE LIMITED",
"K. M. COTEX PRIVATE LIMITED",
"K. M. FERROMETALS PRIVATE LIMITED",
"K. M. MUSIC CONSERVATORY PRIVATE LIMTIED",
"K. M. TEXTILES EXPORTS PRIVATE LIMITED",
"K. MAHESHKUMAR INDUSTRIES PRIVATE LIMITED",
"K. N. ENGINEERING WORKS PRIVATE LIMITED",
"K. NAVADIA CONSTRUCTION PRIVATE LIMITED",
"K. R. BAJAJ INDUSTRY PRIVATE LIMITED",
"K. R. BEVERAGES PRIVATE LIMITED",
"K. R. CONSTRUCTION",
"K. R. CROWNGANGA HOTELS PRIVATE LIMITED",
"K. RAJAGOPALAN & CO.",
"K S AUTOMOBILES PRIVATE LIMITED",
"K. S. FIBER",
"K. S. PIPE FITTINGS PRIVATE LIMITED",
"K. S. SUPER CHEM PRODUCTS PRIVATE LIMITED",
"K. SAMBHAV POWERTRONICS PRIVATE LIMITED",
"K. TECH (INDIA) LIMITED",
"K. TEX OVERSEAS PRIVATE LIMITED",
"K. U. YARN PRIVATE LIMITED",
"K. V. STRIPS PRIVATE LIMITED",
"K. V. TRAEXIM PRIVATE LIMITED",
"K.A.I.G.CONSTRUCTIONS PRIVATE LIMITED",
"K.A.PREVULCANISED LATEX PRIVATE LIMITED",
"K.A.R AGENCIES PRIVATE LIMITED",
"K.B. JAIN AND SONS DISTRIBUTORS PRIVATE LIMITED",
"K.B. PATEL PROCON PRIVATE LIMITED",
"K.B. POWER CARE PRIVATE LIMITED",
"K.B. ROPES PRIVATE LIMITED",
"K.B. TEXFAB PRIVATE LIMITED",
"K.B.G. TEXTILE MILLS (P) LTD",
"K.B.KAPUR AND COMPANY PRIVATE LIMITED",
"K.B.M. ENTERPRISES PRIVATE LIMITED",
"K.B.POLY INDUSTRIES PVT. LTD",
"K.C SAREE EMPORIUM PRIVATE LIMITED",
"K.C. DANG & CO MANUFACTURING PRIVATE LIMITED",
"K.C. DASS FASHION PRIVATE LIMITED",
"K.C. EDIBLE OILS PRIVATE LIMITED",
"K.C. EXIM PVT. LTD.",
"K.C. FIBERS LIMITED",
"K.C. SOLVENT EXTRACTIONS PRIVATE LIMITED",
"K.C. TIMBER TRADERS",
"K.C. TOOLROOM PRIVATE LIMITED",
"K.C.MEHTA CONSULTING PRIVATE LIMITED",
"K.C.PAPERS PRIVATE LIMITED",
"K.C.V.R INFRA PROJECTS PRIVATE LIMITED",
"K.D. KOHLI INSURANCE SURVEYORS AND LOSS ASSESSORS PRIVATE LIMITED",
"K.D. MOTORS ORG LLP",
"K.D. REALTIES PRIVATE LIMITED",
"K.D.JOSHI RUBBER INDUSTRIES PRIVATE LIMITED",
"K.D.LIQUOR & FERTILIZER PRIVATE LIMITED",
"K.D.S. CONSTRUCTION AND INTERIOR PRIVATE LIMITED",
"K.D.S. ENGINEERING PRIVATE LIMITED",
"K.D.SAREES PVT LTD",
"K.DAMANI SECURITIES PRIVATE LIMITED",
"K.DHANDAPANI & CO. ENGINEERS PRIVATE LIMITED",
"K.DULAREY JEWELLERS PRIVATE LIMITED",
"K.DURGE CONSTRUCTION PRIVATE LIMITED",
"K.ELECTRIC WORKS PRIVATE LIMITED",
"K.F. WATER COMPANY PRIVATE LIMITED",
"K.G. DATA FORMS PRIVATE LIMITED",
"K.G. FINVEST PRIVATE LIMITED",
"K.G. INDUSTRIES",
"K.G. ISPAT AND POWERS PRIVATE LIMITED",
"K.G. MIRROX PRIVATE LIMITED",
"K.G. RECREATIONAL AND TOURIST CENTRE PRIVATE LIMITED",
"K.G.M. AGRO INDIA PRIVATE LIMITED",
"K.H. DISTRIBUTORS PRIVATE LIMITED",
"K.H. FUELS PRIVATE LIMITED",
"K.H. RUBBER PRIVATE LIMITED",
"K.H.FOUNDATION",
"K.I. ELECTRONICS INDUSTRIES PRIVATE LIMITED",
"K.I.INDIA OPTICS PRIVATE LIMITED",
"K.J.E.P.C. PROJECTS PRIVATE LIMITED",
"K.K. AGRO TRADE VENTURES PRIVATE LIMITED",
"K.K. BUILDERS PRIVATE LIMITED",
"K.K. ELECTRO APPLIANCES PRIVATE LIMITED",
"K.K. EMULSIONS PRIVATE LIMITED",
"K.K. ENGINEERING PRIVATE LIMITED",
"K.K. HOLIDAY INNS PRIVATE LIMITED",
"K.K. LEISURES AND TOURISM INTERNATIONAL PRIVATE LIMTED",
"K.K. OVERSEAS PRIVATE LIMITED",
"K.K. POWER CONTROL WIRES PRIVATE LIMITED",
"K.K. SHEETGRAH PRIVATE LIMITED",
"K.K. TRADERS",
"K.K. VOICE SOLUTIONS PRIVATE LIMITED",
"K.K. WATERPROOFING PRIVATE LIMITED",
"K.K.G. MARKETING PRIVATE LIMITED",
"K.K.JEWELS PRIVATE LIMITED",
"K.K.METALS PRIVATE LIMITED",
"K.K.P. FINE LINEN PRIVATE LIMITED",
"K.K.PROTIENS PRIVATE LIMITED",
"K.K.RAO ENGINEERING WORKS PRIVATE LIMITED",
"K.K.RAO GREEN ENERGY PRIVATE LIMITED",
"K.K.RESORTS PRIVATE LIMITED",
"K.K.RETREAT PRIVATE LIMITED",
"K.K.S. LEAD PRIVATE LIMITED",
"K.K.TRADECOM PRIVATE LIMITED",
"K.KUMAR RAJA PROJECTS PRIVATE LIMITED",
"K.L. CHILL ROLLS PRIVATE LIMITED",
"K.L. CONCAST PRIVATE LIMITED",
"K.L. COTTON TEXTILES PRIVATE LIMITED",
"K.L. ENERGY AND COAL BENEFICATION PRIVATE LIMITED",
"K.L. REAL ESTATE PRIVATE LIMITED",
"K.L.E. BELGAUM IMAGING AND DIAGNOSTICS PRIVATE LIMITED",
"K.L.J. POLYMERS PRIVATE LIMITED",
"K.L.JUTE PRODUCTS PVT LTD",
"K.L.K. CEMENT PRIVATE LIMITED",
"K.L.MECHANICAL WORKS PRIVATE LIMITED",
"K.L.N.VIDYALAYA",
"K.L.S COTSPIN PRIVATE LIMITED",
"K.LALA EXOTIC STONES PRIVATE LIMITED",
"K.M. MERCANTILE PRIVATE LIMITED",
"K.M.ISPAT PRIVATE LIMITED",
"K.M.K PACKAGING INDUSTRIES PRIVATE LIMITED",
"K.M.WOOLLEN MILLS PRIVATE LIMITED",
"K.MAGANLAL IMPEX",
"K.MOHAN & COMPANY EXPORTD PRIVATE LIMITED",
"K.N. BIOSCIENCES (INDIA) PRIVATE LIMITED",
"K.N. CONSTRUCTIONS PRIVATE LIMITED",
"K.N. FOOD INDUSTRIES PRIVATE LIMITED",
"K.N. HOSPITAL PRIVATE LIMITED",
"K.N. MULTIPROJECTS AND INFRASTRUCTURE PRIVATE LIMITED",
"K.N.M. TEXTILES PRIVATE LIMITED",
"K.N.R. HOMES PRIVATE LIMITED",
"K.P. ARTS FASHION PRIVATE LIMITED",
"K.P. AUTOMOTIVES PRIVATE LIMITED",
"K.P. BANSAL AGRO PRIVATE LIMITED",
"K.P. COLD STORAGE PVT LTD",
"K.P. PACKAGING LIMITED",
"K.P. SAHA PVT LTD",
"K.P. STRUCTURAL & GALVANISING PRIVATE LIMITED",
"K.P. TEXTILES PRIVATE LIMITED",
"K.P. WOOLLEN MILLS PRIVATE LIMITED",
"K.P.A. ENGINEERING PRIVATE LIMITED",
"K.P.R AUTO AGENCY PRIVATE LIMITED",
"K.P.R. AGRO INDUSTRIES PRIVATE LIMITED",
"K.P.R. AGROS POULTRIES PRIVATE LIMITED",
"K.P.R. CARS PRIVATE LIMITED",
"K.P.R. DEVELOPERS LIMITED",
"K.P.R. MOTORS PRIVATE LIMITED",
"K.P.SINGH EDUCATION SERVICES PRIVATE LIMITED",
"K.R CASTINGS PVT LTD",
"K.R. & CO.",
"K.R. ENGINEERS & FABRICATORS PRIVATE LIMITED",
"K.R. EXPRESS PRIVATE LIMITED",
"K.R. FABRICS PRIVATE LIMITED",
"K.R. FOODS LTD",
"K.R. GASES PRIVATE LIMITED",
"K.R. MARINE SERVICES PRIVATE LIMITED",
"K.R. SHRILAXMI DEALS PVT. LTD.",
"K.R. STRUCTURES PRIVATE LIMITED",
"K.R.C. CONSTRUCTIONS PRIVATE LIMITED",
"K.R.C. INFRAPROJECTS PRIVATE LIMITED",
"K.R.K. POWER PRIVATE LIMITED",
"K.R.LYNCH HEALTHCARE PRIVATE LIMITED",
"K.R.M.HOME MAKERS PRIVATE LIMITED",
"K.R.P. INDUSTRIES LIMITED",
"K.R.S. ENGINEERING INDIA PRIVATE LIMITED",
"K.RAHEJA IT PARK (HYDERABAD) LIMITED",
"K.RAMAKRISHNAN CLEAN ENERGY PRIVATE LIMITED",
"K.S RICE-TEC MILLING EQUIPMENT PRIVATE LIMITED",
"K.S. COMMODITIES PRIVATE LIMITED",
"K.S. ELECTRONICS PRIVATE LIMITED",
"K.S. FLEXIPACK PRIVATE LIMITED",
"K.S. FOAM PRIVATE LIMITED",
"K.S. INFRA TRANSMISSION PRIVATE LIMITED",
"K.S. INFRA-CON POWER PROJECTS LIMITED",
"K.S. M. SPARES PRIVATE LIMITED",
"K.S. MARBLES PRIVATE LIMITED",
"K.S. OVERSEAS PRIVATE LIMITED",
"K.S. POLYTUBE PRIVATE LIMITED",
"K.S. SECURESOLUTIONS PRIVATE LIMITED",
"K.S. SURGICAL PRIVATE LIMITED",
"K.S. TECHNOGROUPS PRIVATE LIMITED",
"K.S. TECHNOSOFT PRIVATE LIMITED",
"K.S. TEXTILES PRIVATE LIMITED",
"K.S.AGRICULTURAL INDUSTRIES PRIVATE LIMITED",
"K.S.C.EDUCATION SOCIETYS NEW CAMBRIDGE ENGLISH SCHOOL",
"K.S.C.ENGINEERS PRIVATE LIMITED",
"K.S.CAPITAL SERVICES PRIVATE LIMITED",
"K.S.INSTRUMENTS PRIVATE LIMITED",
"K.S.J.METAL IMPEX PRIVATE LIMITED",
"K.S.K.FABRICATORS AND ERECTORS PRIVATE LIMITED",
"K.S.KIRAN EXPORTS PRIVATE LIMITED",
"K.S.M. ENTERPRISES PRIVATE LIMITED",
"K.S.R.GRANITES PRIVATE LIMITED",
"K.S.S. STONE CRUSHER COMPANY PRIVATE LIMITED",
"K.S.SELECTIONS PRIVATE LIMITED",
"K.S.T.ESTATE AND PROPERTIES PRIVATE LIMITED",
"K.T. FABRICS PRIVATE LIMITED",
"K.T. GRAY CLOTH PRIVATE LIMITED",
"K.T. INDIA INFRAPROJECTS PRIVATE LIMITED",
"K.T. PROJECTS PRIVATE LIMITED",
"K.T.FIBRES PRIVATE LIMITED",
"K.T.R. INFRASTRUCTURE PRIVATE LIMITED",
"K.T.S. AUTOMOTORS PRIVATE LIMITED",
"K.U.N.MOTORCYCLES PRIVATE LIMITED",
"K.UTTAMLAL (EXPORTS) PRIVATE LIMITED",
"K.V. METALS & ALLOYS PRIVATE LIMITED",
"K.V. MOHANA RAO & COMPANY PRIVATE LIMITED",
"K.V. NATURAL INGREDIENTS PRIVATE LIMITED",
"K.V. PENDHARKAR COLLEGE OF ARTS, SCIENCE AND COMMERCE",
"K.V. PROMOTERS PRIVATE LIMITED",
"K.V. SALES PRIVATE LIMITED",
"K.V. STEEL AND PIPES PRIVATE LIMITED",
"K.V.T HOMES AND ESTATES PRIVATE LIMITED",
"K.VENKATA RAJU ENGINEERS & CONTRACTORS PRIVATE LIMITED",
"K.W. ENGINEERING AND SIGNS PRIVATE LIMITED",
"K.W. STONE TECHNOLOGIES PVT LTD KW",
"K.Y. AGROTECH PRIVATE LIMITED",
"K.Y. FASTENERS PRIVATE LIMITED",
"K.Y.R. CRYSTAL PRIVATE LIMITED",
"K.Y.S.MANUFACTURORS & EXPORTERS PRIVATE LIMITED",
"K+S FERTILIZERS (INDIA) PRIVATE LIMITED",
"K1 FACILITY PRIVATE LIMITED",
"K1 SECURITY SERVICES PRIVATE LIMITED",
"K11 EDUCATION PRIVATE LIMITED",
"K11 FITNESS MANAGEMENT COMPANY PRIVATE LIMITED",
"K2 CRANES & COMPONENTS PRIVATE LIMITED",
"K2 ENGINEERS PRIVATE LIMITED",
"K2 INFRAGEN LIMITED",
"K2 LEARNING RESOURCES INDIA PRIVATE LIMITED",
"K2 METALS PRIVATE LIMITED",
"K2 RETAIL VENTURE PRIVATE LIMITED",
"K2 SCAFFOLD PRIVATE LIMITED",
"K2 TECHNOSOFT INDIA PRIVATE LIMITED",
"K21 TECHNOLOGIES PRIVATE LIMITED",
"K2B LEARNING PRIVATE LIMITED",
"K2B SECURE SOLUTION PRIVATE LIMITED",
"K2K CYLINDERS PRIVATE LIMITED",
"K2K EXPRESS INDIA PRIVATE LIMITED",
"K2K FINTECH SOLUTIONS PRIVATE LIMITED",
"K2K INFRASTRUCTURE INDIA PRIVATE LIMITED",
"K2K REAL ESTATE PRIVATE LIMITED",
"K2M IMPEX PRIVATE LIMITED",
"K2O CONSULTING PRIVATE LIMITED",
"K2Q CAPITAL LIMITED",
"K2V2 TECHNOLOGIES PRIVATE LIMITED",
"K3 MANAGEMENT AND EDU SERVICES PRIVATE LIMITED",
"K4 BANGALORE ANGEL NETWORK PRIVATE LIMITED",
"K4 IDEAS & INFRA PRIVATE LIMITED",
"K4 INFOTECH PRIVATE LIMITED",
"K5 BRAND SOLUTIONS PRIVATE LIMITED",
"K7 COMPUTING PRIVATE LIMITED",
"K7GROUP HOSPITALITY PRIVATE LIMITED",
"K8 SCHOOL PRIVATE LIMITED",
"K9 SECURE SOLUTIONS PRIVATE LIMITED",
"K95 FOODS PRIVATE LIMITED",
"KA HOSPITALITY PRIVATE LIMITED",
"KA XTRA-FUN INFLATABLES PRIVATE LIMITED",
"KAABA TRADING PRIVATE LIMITED",
"KAABIL FINANCE PRIVATE LIMITED",
"KAADOSH REAL ESTATES PRIVATE LIMITED",
"KAAFI ENTERPRISES PRIVATE LIMITED",
"KAAGAZ KALAM PRODUCTIONS PRIVATE LIMITED",
"KAAISER SERVICES PRIVATE LIMITED",
"KAAIZEEN MEDITECH PRIVATE LIMITED",
"KAAIZEN INFRATECH PRIVATE LIMITED",
"KAAJ BUSINESS ADVISORY PRIVATE LIMITED",
"KAAKATEEYA.COM INDIA PRIVATE LIMITED",
"KAAL FLEX PRIVATE LIMITED",
"KAALAANGI INFRASTRUCTURE PRIVATE LIMITED",
"KAALBI TECHNOLOGIES PRIVATE LIMITED",
"KAALKAA REAL ESTATES PRIVATE LIMITED",
"KAALMANNS PLASTICS PRIVATE LIMITED",
"KAAMA IMPEX PRIVATE LIMITED",
"KAAMADHENU ARTS AND SCIENCE COLLEGE",
"KAAMADHENU SPINNERS KS",
"KAAMAKAZI SOLUTION PRIVATE LIMITED",
"KAAMAKHYA CREATIONS PRIVATE LIMITED",
"KAAMAKYA MOTORS PRIVATE LIMITED",
"KAAMDHENU INFOTRADE PRIVATE LIMITED",
"KAAMDHENU MACHINE TOOLS PRIVATE LIMITED",
"KAAMDHENU PLY INDUSTRIES PRIVATE LIMITED",
"KAAMDHENU YARN PRIVATE LIMITED",
"KAAMNEY ELECTRONICS PRIVATE LIMITED",
"KAAMWORK TECHNOLOGIES PRIVATE LIMITED",
"KAANCHI JEWELS PRIVATE LIMITED",
"KAANDLA RUGS PRIVATE LIMITED",
"KAANE PACKAGING PRIVATE LIMITED",
"KAANISK JEWELS PRIVATE LIMITED",
"KAANUDA CREATION PRIVATE LIMITED",
"KAAPAA AGRO INDUSTRIES PRIVATE LIMITED",
"KAAPI MACHINES INDIA PRIVATE LIMITED",
"KAAPI SOLUTIONS INDIA OPC PRIVATE LIMITED",
"KAAPICAT BEVERAGES PRIVATE LIMITED",
"KAAPRO MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"KAAR AUTO PRIVATE LIMITED",
"KAAR INFOTECH PRIVATE LIMITED",
"KAAR TECHNOLOGIES INDIA PRIVATE LIMITED",
"KAARA DECOR PRIVATE LIMITED",
"KAARA HOSPITALITY AND LEISURE PRIVATE LIMITED",
"KAARA INFO SYSTEMS PRIVATE LIMITED",
"KAARYA CONSULTING SERVICES PRIVATE LIMITED",
"KAARYA ETHNIC CLOTHING INDIA PRIVATE LIMITED",
"KAARYA FACILITIES & SERVICES LIMITED.",
"KAARYA FACILITIES AND SERVICES PRIVATE LIMITED",
"KAASA HOMES",
"KAASHVI PRINTERS PRIVATE LIMITED",
"KAATYAAYINI STEELS PRIVATE LIMITED",
"KAAVERI VIDDHYA BHAVAN MATRIC HIGHER SECONDARY SCHOOL",
"KAAVIAN SYSTEMS PRIVATE LIMITED",
"KAAVIL BHAGAVATHY DISTRIBUTORS PRIVATE LIMITED",
"KAAVIYA CONSTRUCTIONS AND DEVELOPERS PRIVATE LIMITED",
"KAAY LABS PRIVATE LIMITED",
"KAAYA VIRTUALIZATION TECH PRIVATE LIMITED",
"KAAYAK TOOLS PRIVATE LIMITED",
"KAAZ ALUMINIUM PRIVATE LIMITED",
"KABA EXPRESS PRIVATE LIMITED",
"KABA MEDICAL CENTRE HEALTH CARE PRIVATE LIMITED",
"KABADI SHANKARSA & CO",
"KABBUR INDUSTRIES PRIVATE LIMITED",
"KABCO VENTURES PRIVATE LIMITED",
"KABEER COMPONENTS PRIVATE LIMITED",
"KABEER INFOTECH SYSTEMS INDIA PRIVATE LIMITED",
"KABEER REALITY PRIVATE LIMITED",
"KABEER TEXTILES PRIVATE LIMITED",
"KABEL BUILDCON SOLUTIONS PRIVATE LIMITED",
"KABEL TRADELINKS PRIVATE LIMITED",
"KABELSCHLEPP INDIA PRIVATE LIMITED",
"KABERA GLOBAL TECHNOLOGIES PRIVATE LIMITED",
"KABHA BUILDERS PRIVATE LTD",
"KABINI MINERALS PRIVATE LIMITED",
"KABIR ALKALIES AND CHEMICALS PRIVATE LIMITED",
"KABIR AUSHADHALYA PRIVATE LIMITED",
"KABIR BUILDCON PRIVATE LIMITED",
"KABIR COTTON COMPANY (INDIA) PRIVATE LIMITED",
"KABIR DIAMONDS PRIVATE LIMITED",
"KABIR FOODS PRIVATE LIMITED",
"KABIR HOSIERY WORKS PRIVATE LIMITED",
"KABIR IMPEX PRIVATE LIMITED",
"KABIR KHAN FILMS PRIVATE LIMITED",
"KABIR MINCHEM PRIVATE LIMITED",
"KABIR SHAHEB VIDHYALAYA MANDIR",
"KABIR TECHNOLOGIES PRIVATE LIMITED",
"KABIRDASS ALUMINIUM PRIVATE LIMITED",
"KABIRDASS MOTOR COMPANY LIMITED",
"KABLE FIRST INDIA PRIVATE LIMITED",
"KABNUR HIGHSCHOOL & JUNIOR COLLEGE KABNUR",
"KABOOS APPARELS PRIVATE LIMITED",
"KABOZZ SOFT TECH PRIVATE LIMITED",
"KABRA BUILDERS PRIVATE LIMITED",
"KABRA CARRIER SOLUTIONS PRIVATE LIMITED",
"KABRA COMMERCIAL LTD",
"KABRA EXPORTS PRIVATE LIMITED",
"KABRA EXTRUSION TECHNIK LTD",
"KABRA HARDWARE PRIVATE LIMITED",
"KABRA JEWELS PRIVATE LIMITED",
"KABRA SYNTEX PRIVATE LIMITED",
"KABRA TRADING COMPANY PRIVATE LIMITED",
"KABRA TRANSPORT PRIVATE LIMITED",
"KABRA YARNS PRIVATE LIMITED",
"KABS HEALTHCARE PRIVATE LIMITED",
"KABSONS GAS EQUIPMENT PRIVATE LIMITED",
"KABSONS INDUSTRIES LIMITED",
"KABU PROJECTS PRIVATE LIMITED",
"KAC ENGINEERS PRIVATE LIMITED",
"KAC PALM EXOTICA HOTELS PRIVATE LIMITED",
"KACH MOTORS PRIVATE LIMITED",
"KACHAKALI TEA & AGRO INDUSTRIES PRIVATE LIMITED",
"KACHANATHU MINERALS AND METALS PRIVATE LIMITED",
"KACHCHH HOSPITALITY PRIVATE LIMITED",
"KACHHUA SOLUTIONS PRIVATE LIMITED",
"KACHINS CLOTHING PRIVATE LIMITED",
"KACHINS TEXTILES LIMITED",
"KACHNAAR CRAFTS PRIVATE. LIMITED",
"KACHNAR POLYMERS PRIVATE LIMITED",
"KACIOUS SYSTEMS PRIVATE LIMITED",
"KAD DIGITECH PRIVATE LIMITED",
"KAD HOUSING PRIVATE LIMITED",
"KAD MODA",
"KADAAM CARDIOLOGY PRIVATE LIMITED",
"KADABA PRESS METAL AND PLASTIC MOULDS PRIVATE LIMITED",
"KADACHANAA SHIPPING N LOGISTICS PRIVATE LIMITED",
"KADAKIA PAPERS P LIMITED",
"KADAKIA PLASTICS AND CHEMICALS PVT LTD",
"KADALAI MITTAI PRIVATE LIMITED",
"KADALAIYUR MATCH COMPANY PRIVATE LIMITED",
"KADAM ADVERTISING AND MARKETING PRIVATE LIMITED",
"KADAM CHEMICALS PRIVATE LIMITED",
"KADAM DIGITAL TRANSPRINTS PRIVATE LIMITED.",
"KADAM DIGITAL TRANSPRINTS PVT LTD",
"KADAM MARKETING LIMITED",
"KADAM POLLUTION CONTROL PVT LTD",
"KADAM PRINTOCRAT PRIVATE LIMITED",
"KADAM REALTY PRIVATE LIMITED",
"KADAMBA AGRITECH PRIVATE LIMITED",
"KADAMBA TECHNOLOGIES PRIVATE LIMITED",
"KADAMBA TRANSPORT CORPN LIMITED",
"KADAMBARI AUTOPARTS PRIVATE LIMITED",
"KADAMBARI STEEL WIRE ROPE PRIVATE LIMITED",
"KADAMBARI TECHNOLOGIES PRIVATE LIMITED",
"KADAMBARI TEXTILES PVT LTD",
"KADAMBI PRABHU FAMILY SERVICES PRIVATE LIMITED",
"KADAMBINI SECURITIES PVT LTD",
"KADAMBRI HEALTHCARE PRIVATE LIMITED",
"KADAMBRI SAREE CENTRE PRIVATE LIMITED",
"KADAMTALA HIGH SCHOOL",
"KADANT INDIA PRIVATE LIMITED",
"KADANTHOTTU FINANCE PRIVATE LIMITED",
"KADAPATTI INFRA PRIVATE LIMITED",
"KADAT GLOBAL IMPEX PRIVATE LIMITED",
"KADDAM HEALTH CARE PRIVATE LIMITED",
"KADEL INSURANCE BROKERS PRIVATE LIMITED",
"KADEL LABS PRIVATE LIMITED",
"KADENCE INTERNATIONAL PRIVATE LIMITED",
"KADER EXPORTS PRIVATE LIMITED",
"KADHIR BROADCASTING PRIVATE LIMITED",
"KADI IMPEX PRIVATE LIMITED",
"KADI SARVA VISHWAVIDYALAYA",
"KADIAM PRODUCTS PRIVATE LIMITED",
"KADIAN BUILDERS & DEVELOPERS PRIVATE LIMITED",
"KADIAN PROJECTS PRIVATE LIMITED",
"KADILLAC CHEMICALS PVT LTD",
"KADIMI FOODS PRIVATE LIMITED",
"KADIMI INTERNATIONAL PRIVATE LIMITED",
"KADIMI SWEETS PRIVATE LIMITED",
"KADIMI TOOL MANUFACTURING COMPANY PRIVATE LIMITED",
"KADIYA CONSTRUCTION PRIVATE LIMITED",
"KADIYAM INDUSTRIES AND PROJECTS PRIVATE LIMITED",
"KADJI CARE AND REHABS PRIVATE LIMITED",
"KADKRAFT SYSTEMS PRIVATE LIMITED",
"KADMA TRADING CO. PRIVATE LIMITED",
"KADMAWALA DYEING AND PRINTING PRIVATE LIMITED",
"KADMAWALA INDUSTRIES PRIVATE LIMITED",
"KADMAWALA TEXTILE MILLS PRIVATE LIMITED",
"KADOR ENGINEERING SOLUTIONS PRIVATE LIMITED",
"KADRI CONSULTANTS PRIVATE LIMITED",
"KADTECH INFRAPROJECTS PRIVATE LIMITED",
"KADU NANDI TRAVELS PRIVATE LIMITED",
"KADUNA HOSPITALITY PRIVATE LIMITED",
"KADVA SAKARI SAKHAR KARKHANA",
"KADWA ENGLISH MEDIUM SCHOOL",
"KADWA SAHAKARI SAKHAR KARKHANA LTD",
"KAE CAPITAL MANAGEMENT PRIVATE LIMITED",
"KAE ENGINEERS PRIVATE LIMITED",
"KAENAT HITECH GLAZING SYSTEMS PRIVATE LIMITED",
"KAESER COMPRESSORS INDIA PRIVATE LIMITED",
"KAF VENTURES PTE.LIMITED",
"KAFA CLOTHING INDIA PRIVATE LIMITED",
"KAFEUCHA TEA COMPANY PRIVATE LIMITED",
"KAFF APPLIANCES (INDIA) PRIVATE LIMITED",
"KAFILA FORGE PRIVATE LIMITED",
"KAFISTA INDIA PRIVATE LIMITED",
"KAFQA VENTURES PRIVATE LIMITED",
"KAG BAGS PRIVATE LIMITED",
"KAG INDIA PRIVATE LIMITED",
"KAG INDUSTRIES",
"KAGA DEVICES INDIA PRIVATE LIMITED",
"KAGA ELECTRONICS INDIA PRIVATE LIMITED",
"KAGAJ DIGITAL PAPER PRIVATE LIMITED",
"KAGAL MULTISPECIALITY PRIVATE LIMITED",
"KAGALWALA PACKAGING PRIVATE LIMITED",
"KAGAMI INDIA PRIVATE LIMITED",
"KAGASHIN GLOBAL NETWORK PRIVATE LIMITED",
"KAGAZKAAR INDUSTRIES PRIVATE LIMITED",
"KAGAZNAGAR COTTON MILLS PRIVATE LIMITED",
"KAGEM MINING LIMITED",
"KAGOOL DATA PRIVATE LIMITED",
"KAGS ELECTROTECH PRIVATE LIMITED",
"KAGU SOLAR SOLUTIONS PRIVATE LIMITED",
"KAGUS CORPORATE PRIVATE LIMITED (OPC)",
"KAGVA ENGINEERING PRIVATE LIMITED",
"KAGZI HIRA JEWELS PRIVATE LIMITED",
"KAH PACKAGING PRIVATE LIMITED",
"KAHA TECHNOLOGIES PRIVATE LIMITED",
"KAHAAN LUBRICANT PRIVATE LIMITED",
"KAHAANMOTORS PRIVATE LIMITED",
"KAHAN CHAND AND SONS AGENGIES PVT LTD",
"KAHAN PACKAGING LIMITED",
"KAHANAJI ORNAMENTS PRIVATE LIMITED",
"KAHINI DEVELOPERS PRIVATE LIMITED",
"KAHM INDUSTRIES PRIVATE LIMITED",
"KAHNOV E-LEARNING PRIVATE LIMITED",
"KAHUMBO FOODS PRIVATE LIMITED",
"KAHUNA SYSTEMS PRIVATE LIMITED",
"KAI COMMERCIAL PRIVATE LIMITED",
"KAI KALYANRAO BALASAHEB INGALE POLYTECHNIC COLLEGE AKKALKOT",
"KAI MANUFACTURING INDIA PRIVATE LIMITED",
"KAI NARSINGRAO CHAVAN MADYAMIC VIDYALAYA NALEGAON",
"KAI OS TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"KAI P R PATIL UTKARSHA MADHYAMIK VIDYALAYA & JUNIOR COLLEGE",
"KAI SI MA NANDEDKAR MADHYAMIK ASHRAM SCHOOL ART & SCIENCE JR COLLEGE SURGAS",
"KAI SU G F PATIL JR COLLEGE SHAHADA",
"KAI WAREHOUSING PRIVATE LIMITED",
"KAIA TOURISM PRIVATE LIMITED",
"KAICO DEER ABRASIVE PRIVATE LIMITED",
"KAIEL HOTEL AND RESTAURANT PRIVATE LIMITED",
"KAIHATSU TECHNO CENTRE PRIVATE LIMITED",
"KAIK MANUFACTURING PRIVATE LIMITED",
"KAIKOBAD BYRAMJEE AND SONS (AGENCY) PRIVATE LIMITED",
"KAILA DEVI FOOD PRODUCTS PRIVATE LIMITED",
"KAILA DEVI HEALTH CARE SERVICES PRIVATE LIMITED",
"KAILA ENGINEERING WORKS",
"KAILADEVI EDIBLE PRODUCTS PRIVATE LIMITED",
"KAILADEVI ENGINEERING SOLUTIONS PRIVATE LIMITED",
"KAILADEVI ROLLER FLOUR MILLS PRIVATE LIMITED",
"KAILAS CERAMICS PRIVATE LIMITED",
"KAILAS RUBBER CO LTD",
"KAILAS TOOLINGS PRIVATE LIMITED",
"KAILASA ANALYTICS AND SERVICES PRIVATE LIMITED",
"KAILASA ENTERTAINMENT PRIVATE LIMITED",
"KAILASA SPECIALITY CUISINE PRIVATE LIMITED",
"KAILASA URJA PRIVATE LIMITED",
"KAILASH AGENCIES PRIVATE LIMITED",
"KAILASH AGRO PRIVATE LIMITED",
"KAILASH AYURVEDA PRIVATE LIMITED",
"KAILASH BUILDESTATE PRIVATE LIMITED",
"KAILASH BULK HANDLING PRIVATE LIMITED",
"KAILASH CASTINGS PRIVATE LIMITED",
"KAILASH CHAND & SONS JEWELLERS PRIVATE LIMITED",
"KAILASH CHAND MANOJ KUMAR SARAF PRIVATE LIMITED",
"KAILASH COAL AND COKE COMPANY LIMITED",
"KAILASH COLD STORAGE",
"KAILASH CONSTRUCTION COMPANY PRIVATE LIMITED",
"KAILASH DAIRY LIMITED",
"KAILASH DARSHAN DEVELOPERS (GUJARAT) PRIVATE LIMITED",
"KAILASH DARSHAN HOUSING DEVELOPEMENT (GUJARAT) PRIVATE LIMITED",
"KAILASH DEEPAK HOSPITAL",
"KAILASH ELECTRICALS",
"KAILASH FURNISHINGS PRIVATE LIMITED",
"KAILASH HEALTH SOLUTIONS PRIVATE LIMITED",
"KAILASH HEALTHCARE LIMITED",
"KAILASH HOSPITAL",
"KAILASH HOSPITALS LIMITED",
"KAILASH HOUSING LIMITED",
"KAILASH IMPEX LTD",
"KAILASH INFRABUILD PRIVATE LIMITED",
"KAILASH INFRATECH PRIVATE LIMITED",
"KAILASH INSTITUTE OF HEALTH AND MEDICAL SCIENCES COLLEGE OF NURSING",
"KAILASH INTERNATIONAL PRIVATE LIMITED",
"KAILASH LIFESCIENCES PRIVATE LIMITED",
"KAILASH MARBLE INDUSTRIES PRIVATE LIMITED",
"KAILASH MEDICAL SHOPS PRIVATE LIMITED",
"KAILASH MEDICOS PRIVATE LIMITED",
"KAILASH MEGA MALL PRIVATE LIMITED",
"KAILASH MOTORS",
"KAILASH NURSING HOME PRIVATE LIMITED",
"KAILASH PAPER CONVERSION PRIVATE LIMITED",
"KAILASH PARBAT CUISINES AND BANQUETS PRIVATE LIMITED",
"KAILASH PATI CEMENT LIMITED",
"KAILASH POLY INDUSTRIES PVT LTD",
"KAILASH PRASAD YADAV CONSTRUCTIONS PRIVATE LIMITED.",
"KAILASH SATYARTHI CHILDREN'S FOUNDATION",
"KAILASH SHIPPING SERVICES PRIVATE LIMITED",
"KAILASH STONE PRODUCTS PRIVATE LIMITED",
"KAILASH SUPER-SPECIALITY HOSPITAL PRIVATE LIMITED",
"KAILASH SURGICALS PRIVATE LIMITED",
"KAILASH TEXFAB SUIT PRIVATE LIMITED",
"KAILASH TRADING CORPORATION",
"KAILASH TRANSFORMERS PRIVATE LIMITED",
"KAILASH TRANSLINES PRIVATE LIMITED",
"KAILASH TRANSLOGISTICS PRIVATE LIMITED",
"KAILASH VAHN PRIVATE LIMITED",
"KAILASHGIRI CONSULTANTS PRIVATE LIMITED",
"KAILASHI METALS PRIVATE LIMITED",
"KAILASHI SUPER SPECIALITY HOSPITAL",
"KAILASHI SUPERSPECIALITY HOSPITAL & RESEARCH CENTER PRIVATE LIMITED",
"KAILASHI TAR PRIVATE LIMITED",
"KAILASHNATH AGRO PRIVATE LIMITED",
"KAILASHPATI POLYPLAST PRIVATE LIMITED",
"KAILASHPATI STEEL INDUSRIES PRIVATE LIMITED",
"KAILASHPATI VINIMAY PRIVATE LIMITED",
"KAILASHPURI BULIDTECH PRIVATE LIMITED",
"KAILASHSIDDHI PROMOTERS PRIVATE LIMITED",
"KAILBISH NATURAL RESOURCES PRIVATE LIMITED",
"KAILPAR SECURITIES PRIVATE LIMITED",
"KAILTECH TEST AND RESEARCH CENTRE PRIVATE LIMITED",
"KAIMUR DEVELOPERS PRIVATE LIMITED",
"KAIN SCRIBES PRIVATE LIMITED",
"KAINAAZ ASSOCIATES CARGO MOVERS PRIVATE LIMITED",
"KAINAT FOODS & SPICES PRIVATE LIMITED",
"KAINER TECHNOLOGIES LLP",
"KAINS INSTRUMENTS INDIA PRIVATE LIMITED",
"KAINSARA INFRAPROJECTS PRIVATE LIMITED",
"KAINYA AND ASSOCIATES PRIVATE LIMITED",
"KAINYA WIRES PRIVATE LIMITED",
"KAIPA VENTURES PRIVATE LIMITED",
"KAIPAI POUCHES PRIVATE LIMITED",
"KAIPAN PAN PRODUCTS PRIVATE LIMITED",
"KAIRA CAN COMPANY LIMITED",
"KAIRA DISTRIBUTION PRIVATE LIMITED",
"KAIRA DISTRICT CO-OPERATIVE MILK PRODUCERS UNION LTD",
"KAIRA FOODS PRIVATE LIMITED",
"KAIRA INTERNATIONAL CONCEPTS PRIVATE LIMITED",
"KAIRA POULTRY AND CATTLE FEEDS PRIVATE LIMITED",
"KAIRA SALON AND ACADEMY PRIVATE LIMITED",
"KAIRA SOLITAIRE DIAMOND JEWELLERS PRIVATE LIMITED",
"KAIRA TECHNOPLAST PRIVATE LIMITED",
"KAIRAA POLYPACK PRIVATE LIMITED",
"KAIRALI ARTS COLLEGE",
"KAIRALI AYURVEDIC CENTRE PRIVATE LIMITED",
"KAIRALI AYURVEDIC HEALTH RESORTS PRIVATE LIMITED",
"KAIRALI ENGINEERING PRIVATE LIMITED",
"KAIRALI EXPORTS",
"KAIRALI HERBAL CURES PRIVATE LIMITED",
"KAIRALI METAL INDUSTRIES PRIVATE LIMITED",
"KAIRALI NIKETHAN PRIMARY SCHOOL",
"KAIRALI STEELS AND ALLOYS PRIVATE LIMITED",
"KAIRALI STRUCTURAL FABRICATION PRIVATE LIMITED",
"KAIRAV CHEMOFARBE INDUSTRIES LIMITED",
"KAIRAV ELASTOMERS PRIVATE LIMITED",
"KAIRAVI AGENCIES PRIVATE LIMITED",
"KAIRAVIVIEW PRIVATE LIMITED",
"KAIREE SYSTEMS PRIVATE LIMITED",
"KAIRO5 MARCOM PRIVATE LIMITED",
"KAIROS ADVISORS LLP",
"KAIROS CONSULTANCY SERVICES PRIVATE LIMITED",
"KAIROS INTERNATIONAL SCHOOL",
"KAIROS METAL RECYCLER PRIVATE LIMITED",
"KAIROS POLYMERS PRIVATE LIMITED",
"KAIROS PROPERTIES PRIVATE LIMITED",
"KAIROS SECURITY HEALTH AND COMPOSITE SERVICES PRIVATE LIMITED",
"KAIROS TECHNOLOGIESP LIMITED",
"KAIRVAM ELECTRONICS INDIA PRIVATE LIMITED",
"KAISAR",
"KAISER CONSTRUCTIONS ENGINEERS AND CONTRACTORS",
"KAISER DRUGS PRIVATE LIMITED",
"KAISER INDUSTRIES LIMITED",
"KAISER INFRATECH PRIVATE LIMITED",
"KAISER POLY PLAST PRIVATE LIMITED",
"KAISERHAUS INFRASTRUCTURE PRIVATE LIMITED",
"KAISHA LIFESCIENCES PRIVATE LIMITED",
"KAISHA PACKAGING PRIVATE LIMITED",
"KAISHAHAAN ENTERPRISE PRIVATE LIMITED",
"KAISHAN MACHINERY (INDIA) PRIVATE LIMITED",
"KAISHAR INTERIORS PRIVATE LIMITED",
"KAISHIN METALEX STAINLESS STEEL PRIVATE LIMITED",
"KAISONS CONSTRUCTIONS PRIVATE LIMITED",
"KAISONS HOSPITALITY SERVICES PRIVATE LIMITED",
"KAITHAL SOLVENT (P) LTD.",
"KAITHAL TOLLWAY LIMITED",
"KAIVAL CHEMICALS PRIVATE LIMITED",
"KAIVAL REALITIES PRIVATE LIMITED",
"KAIVALE TECHNOLOGIES PRIVATE LIMITED",
"KAIVALYA ALLOYS PRIVATE LIMITED",
"KAIVALYA EDUCATION FOUNDATION",
"KAIYUAN WELDING & CUTTING AUTOMATION INDIA PRIVATE LIMITED",
"KAIZEN AGRO INFRABUILD LIMITED",
"KAIZEN ALEX PRIVATE LIMITED",
"KAIZEN AUTOCARS PRIVATE LIMITED",
"KAIZEN CAPITAL SERVICES PRIVATE LIMITED",
"KAIZEN CNC CENTRE PRIVATE LIMITED",
"KAIZEN COLD FORMED STEEL PRIVATE LIMITED",
"KAIZEN DAIRY FOODWORKS PRIVATE LIMITED",
"KAIZEN DRUGS PRIVATE LIMITED",
"KAIZEN EDUPLUS SOCIETY'S INSTITUTE OF EXCELLENCE IN MANAGEMENT SCIENCE",
"KAIZEN ENGINEERING (INDIA) PRIVATE LIMITED",
"KAIZEN ENTERPRISES PVT. LTD.",
"KAIZEN ENVIROTECH INDUSTRIES PRIVATE LIMITED",
"KAIZEN EXECUTIVE SEARCH PRIVATE LIMITED",
"KAIZEN GLOBAL SERVICES INDIA PRIVATE LIMITED",
"KAIZEN HI-TECH PRIVATE LIMITED",
"KAIZEN HOMES PRIVATE LIMITED",
"KAIZEN HOTELS & RESORTS LIMITED",
"KAIZEN INDUSTRIAL SERVICES",
"KAIZEN INFOSERVE PRIVATE LIMITED",
"KAIZEN INFOTECH SOLUTIONS PRIVATE LIMITED",
"KAIZEN IT SERVICES PVT LTD",
"KAIZEN LABORATORIES PRIVATE LIMITED",
"KAIZEN LEISURE & HOLIDAYS LIMITED",
"KAIZEN MANAGEMENT FINANCIAL ADVISORS PRIVATE LIMITED",
"KAIZEN METAL FORMING PRIVATE LIMITED",
"KAIZEN MOTOVENTURES PRIVATE LIMITED",
"KAIZEN MS HOSPITALITY INDIA PRIVATE LIMITED",
"KAIZEN ORGANICS PRIVATE LIMITED",
"KAIZEN PARTNERS PRIVATE LIMITED",
"KAIZEN PLASTOMOULD PRIVATE LIMITED",
"KAIZEN PRECISION PARTS PRIVATE LIMITED",
"KAIZEN RESEARCH LABS INDIA PRIVATE LIMITED",
"KAIZEN SHIPPING PRIVATE LIMITED",
"KAIZEN SPIN TECH PRIVATE LIMITED",
"KAIZEN SRA TECHNOLOGIES PRIVATE LIMITED",
"KAIZEN STEEL BUILDING SOLUTIONS PRIVATE LIMITED",
"KAIZEN SUPERSPECIALITY HOSPITAL",
"KAIZEN TOOL TECH PRIVATE LIMITED",
"KAIZEN TRADE FIN PRIVATE LIMITED",
"KAIZEN TRAINING SOLUTIONS PRIVATE LIMITED",
"KAIZENAT TECHNOLOGIES PRIVATE LIMITED",
"KAIZENCASA HARD GOODS PRIVATE LIMITED",
"KAIZENERS TECHNO PRIVATE LIMITED",
"KAIZER CONSTRUCTION COMPANY LTD",
"KAIZZEN PR SERVICES PRIVATE LIMITED",
"KAJ BUILDTRADE PRIVATE LIMITED",
"KAJ FINE JEWELLERY PRIVATE LIMITED",
"KAJAH ENTERPRISES PRIVATE LIMITED",
"KAJAH TEA COMPANY PRIVATE LIMITED",
"KAJAL CHEMICALS PRIVATE LIMITED",
"KAJAL FLOZEN TRENDZ LLP",
"KAJAL SYNTHETICS AND SILK MILLS LIMITED",
"KAJAL TEXTILE MILLS PRIVATE LIMITED",
"KAJARIA BATHWARE PRIVATE LIMITED",
"KAJARIA CERAMICS LIMITED",
"KAJARIA INFINITY PRIVATE LIMITED",
"KAJARIA INFRASTRUCTURE PRIVATE LIMITED",
"KAJARIA IRON & STEEL CO PRIVATE LIMITED",
"KAJARIA LOGISTICS PRIVATE LIMITED",
"KAJARIA PLYWOOD PRIVATE LIMITED",
"KAJARIA SANITARYWARE PRIVATE LIMITED",
"KAJARIA VISION PRIVATE LIMITED",
"KAJARIA VITRIFIED PRIVATE LIMITED",
"KAJAY CHEMIE PRIVATE LIMITED",
"KAJAY PHARMACHEM PRIVATE LIMITED",
"KAJAY REMEDIES PRIVATE LIMITED",
"KAJIMA INDIA PRIVATE LIMITED",
"KAJJAM TECHNOLOGIES PRIVATE LIMITED",
"KAJOL LEASING AND FINANCE PRIVATE LIMITED",
"KAJRI MINERALS PRIVATE LIMITED",
"KAKA ENGINEERING PRIVATE LIMITED",
"KAKA HALWAI FOODS PRIVATE LIMITED",
"KAKA HORAM SINGH COLLEGE OF LAW",
"KAKA INDUSTRIES LIMITED",
"KAKA INDUSTRIES PRIVATE LIMITED",
"KAKA OVERSEAS LIMITED",
"KAKA RAM HARI CHAND OIL MILLS PRIVATE LIMITED",
"KAKADE AUTO SPARES PRIVATE LIMITED",
"KAKADE STONE CRUSHER PRIVATE LIMITED",
"KAKADIYA HOSPITAL",
"KAKADONGA TEA ESTATES PVT LTD",
"KAKAJI AUTO & AGRO PRIVATE LIMITED",
"KAKA-KA DHABA PRIVATE LIMITED",
"KAKARANIA INNOVATIVE SYSTEMS PRIVATE LIMITED",
"KAKARAPARTI BHAVANARAYANA COLLEGE",
"KAKARIA EXIM (INDIA) LIMITED",
"KAKARIA HOUSING & INFRASTRUCTURE LIMITED",
"KAKARLA MOULDS AND DIES PRIVATE LIMITED",
"KAKATEEYA TRANSFORMERS PRIVATE LIMITED",
"KAKATI KARSHAK INDUSTRIES PRIVATE. LIMITED",
"KAKATIYA AUTOMOTIVES PRIVATE LIMITED",
"KAKATIYA CEMENT SUGAR AND INDUSTRIES LIMITED",
"KAKATIYA DEGREE COLLEGE",
"KAKATIYA ENERGY SYSTEMS PRIVATE LIMITED",
"KAKATIYA FABRICS PRIVATE LIMITED",
"KAKATIYA HOSPITAL",
"KAKATIYA INDUSTRIES PRIVATE LIMITED",
"KAKATIYA INSTITUTE OF TECHNOLOGY &SCIENCE",
"KAKATIYA LUBETECH PRIVATE LIMITED",
"KAKATIYA PIPES & INFRA PRIVATE LIMITED",
"KAKATIYA TEXTILES LTD",
"KAKATIYA UNIVERSITY",
"KAKATIYAN MEDICAL SERVICES PRIVATE LIMITED",
"KAKDA CONSTRUCTION & MANUFACTURERS PVT LTD",
"KAKDA SALES INDIA PRIVATE LIMITED",
"KAKINADA CONTAINER TERMINAL PRIVATE LIMITED",
"KAKINADA GATEWAY PORT LIMITED",
"KAKINADA INFRASTRUCTURE HOLDINGS PRIVATE LIMITED",
"KAKINADA INSTITUTE OF ENGINEERING & TECHNOLOGY",
"KAKINADA SEAPORTS LIMITED",
"KAKINADA SECURITY SERVICES PRIVATE LIMITED",
"KAKINADA SEZ LIMITED",
"KAKINADA SMART CITY CORPORATION LIMITED",
"KAKKAD JEWELLERS PRIVATE LIMITED",
"KAKKAR COMMERCIALS PRIVATE LIMITED",
"KAKKAR COMPLEX STEELS PRIVATE LIMITED",
"KAKKAR FOOTWEARS PRIVATE LIMITED",
"KAKKAR FORGE PVT LTD",
"KAKKAR IMPEX PRIVATE LIMITED",
"KAKKARS FAMILY ENTERTAINMENT PRIVATE LIMITED",
"KAKO TEA PRIVATE LIMITED",
"KAKODE ASSOCIATES CONSULTING PRIVATE LIMITED",
"KAKOPATHAR TEA COMPANY PRIVATE LIMITED",
"KAKRAN TECHNOLOGY PRIVATE LIMITED",
"KAKRANIA RETAILS PRIVATE LIMITED",
"KAKS AND BILLS PVT LTD",
"KAKUMANI EDUCATIONAL SOCIETY",
"KAKUMANU SEEDS",
"KAKUSHIN ENTERPRISE PRIVATE LIMITED",
"KAL AIRWAYS PRIVATE LIMITED",
"KAL ATM SOFTWARE INDIA PRIVATE LIMITED",
"KAL CABLES PRIVATE LIMITED",
"KAL COMM PRIVATE LIMITED",
"KAL ENERGY INDIA PRIVATE LIMITED",
"KAL MEDIA SERVICES PRIVATE LIMITED",
"KAL PUBLICATIONS PRIVATE LIMITED",
"KAL RADIO LIMITED",
"KALA AAKRUTI STORE",
"KALA ACADEMY",
"KALA AMB DISTILLERY & BREWERY PRIVATE LIMITED",
"KALA BIOTECH PRIVATE LIMITED",
"KALA COLOUR LAB PRIVATE LIMITED",
"KALA DARSHAN EXPORTS PRIVATE LIMITED",
"KALA EMPORIUM PRIVATE LIMITED",
"KALA GENSET PRIVATE LIMITED",
"KALA HOSPITALS PRIVATE LIMITED",
"KALA JYOTHI PROCESS PRIVATE LIMITED",
"KALA KAUMUDI PUBLICATIONS PVT LTD",
"KALA KUNJ SAREES PRIVATE LIMITED",
"KALA KUTIR PRIAVTE LIMITED",
"KALA SAGAR CHITRA MANDIR PVT LTD",
"KALA SALES PRIVATE LIMITED",
"KALA SANGAM SAREES PRIVATE LIMITED",
"KALA SEA FOODS PRIVATE LIMITED",
"KALA SPAN DEFENCE PRIVATE LIMITED",
"KALA TELECOM PRIVATE LIMITED",
"KALA VARISHTA MAHAVIDYALAYA",
"KALAARI CAPITAL ADVISORS PRIVATE LIMITED",
"KALABHAI KARSON PRIVATE LIMITED",
"KALABINDU ENTERPRISES PRIVATE LIMITED",
"KALABURAGI BIDAR & YADGIR CO OPERATIVE MILK PRODUCERS SOCIETIES UNION LTD",
"KALADHAR IMPEX AND TRADERS PRIVATE LIMITED",
"KALADI CONSULTING SERVICES LIMITED",
"KALADY RICE MILLERS CONSORTIUM PRIVATE LIMITED",
"KALAHANU BOTHRA AGENCIES PRIVATE LIMITED",
"KALAHANU BOTHRA ENTERPRISES PRIVATE LIMITED",
"KALAHANU BOTHRA EXIM PRIVATE LIMITED",
"KALAHANU BOTHRA INDUSTRIES PRIVATE LIMITED",
"KALAHANU BOTHRA TRADING PRIVATE LIMITED",
"KALAHANU MARKETING PRIVATE LIMITED",
"KALAHANU RETAIL VENTURE PRIVATE LIMITED",
"KALAHANU TRADING PRIVATE LIMITED",
"KALAHRIDHAAN TRENDZ LIMITED",
"KALAI POWER PRIVATE LIMITED",
"KALAIGNAR TV PRIVATE LIMITED",
"KALAIMAGAL HIGHER SECONDARY SCHOOL",
"KALAIMAGAL SCHOOL",
"KALAIVANI LOGISTICS PRIVATE LIMITED",
"KALAJYOTHI PROCESS PRIVATE LIMITED",
"KALAKRITI INFOTECH PRIVATE LIMITED",
"KALAKRUTI PROCESSORS PRIVATE LIMITED",
"KALAKRUTI REALTORS PRIVATE LIMITED",
"KALAKRUTI STEEL FURNITURE PRIVATE LIMITED",
"KALAKRUTII ASSOCIATES PRIVATE LIMITED",
"KALAM ACADEMY PRIVATE LIMITED",
"KALAMANDIR JEWELLERS LIMITED",
"KALAMBOLI IRON AND STEEL YARD PRIVATE LIMITED",
"KALAMKAAR MUSIC PRIVATE LIMITED",
"KALAMKAR MOTORS PRIVATE LIMITED",
"KALAMKAR MULTI SPLTY HOSPITAL RES INST",
"KALAMKARI LIFESTYLE TECH PRIVATE LIMITED",
"KALAMKRIYA LIMITED",
"KALANA ISPAT LIMITED",
"KALANABHA INFRATECH PRIVATE LIMITED",
"KALANDRI CAPITAL PRIVATE LIMITED",
"KALANEE IMPEX PRIVATE LIMITED",
"KALANGA ENGLISH MEDIUM SCHOOL",
"KALANI BROTHERS (INDORE) PRIVATE LIMITED",
"KALANI INDUSTRIES PRIVATE LIMITED",
"KALANI INFRASTRUCTURE PRIVATE LIMITED",
"KALANIDHI INTERNATIONAL PRIVATE LIMITED",
"KALANIDHI STUDIO PRIVATE LIMITED",
"KALANIKETHAN FASHIONS LIMITED",
"KALANIKETHAN FASHIONS PRIVATE LIMITED",
"KALANIKETHAN SILKS LIMITED",
"KALANIKETHAN SILKS PRIVATE LIMITED",
"KALANJALI CONSULTANCY SERVICES",
"KALANJIAM DEVELOPMENT FINANCIAL SERVICES",
"KALANJIYAM CONSULTANCY SERVICES LLP",
"KALANTRI BROTHERS PRIVATE LIMITED",
"KALANTRI ENGINEERING PRIVATE LIMITED",
"KALANYA FASHIONS PRIVATE LIMITED",
"KALAPARA KISHAN HIMGHAR PVT LTD",
"KALAPI ENGINEERING ASSOCIATES PRIVATE LIMITED",
"KALAPI TRACTOR SPARES PRIVATE LIMITED",
"KALAPURNA STEEL AND ENGG PRIVATE LIMITED",
"KALARI ACTION HERO FILMS PRIVATE LIMITED",
"KALARIA AUTOFORGE PRIVATE LIMITED",
"KALARIA FORGE PRIVATE LIMITED",
"KALARICKAL AGENCIES PVT LTD",
"KALAROOP LIFESTYLES & FABRICS PRIVATE LIMITED",
"KALASAKTHI AGRO PRIVATE LIMITED",
"KALASALINGAM ACADEMY OF RESERCH AND EDUCATION",
"KALASAM SACRED FOODS PRIVATE LIMITED",
"KALASANSKRUTI RETAIL PRIVATE LIMITED",
"KALASH CONTAINERS (INDIA) PRIVATE LIMITED",
"KALASH GLOBAL LOGISTICS PRIVATE LIMITED",
"KALASH GOLD AND ORNAMENTS PRIVATE LIMITED",
"KALASH HIGH SCHOOL HS",
"KALASH IMPEX PRIVATE LIMITED",
"KALASH INDIA FABTEX PRIVATE LIMITED",
"KALASH JEWELLERY PRIVATE LIMITED",
"KALASH REALCON PRIVATE LIMITED",
"KALASH SEEDS PRIVATE LIMITED",
"KALASH SHARES AND SECURITIES PRIVATE LIMITED",
"KALASH TRADE CHEM PRIVATE LIMITED",
"KALASHREE FABRICS PRIVATE LIMITED",
"KALATHIL BROTHERS CONSTRUCTION COMPANY PRIVATE LIMITED",
"KALATHIL RESORTS PRIVATE LIMITED",
"KALATI CONSTRUCTIONS PRIVATE LIMITED",
"KALATMAK SPATIAL SYSTEMS PRIVATE LIMITED",
"KALATRONICS SEMICONDUCTORS PRIVATE LIMITED",
"KALAVATI GAS DISTRIBUTORS",
"KALAWATI BUILDERS PRIVATE LIMITED",
"KALAWATI ENTERPRISES PRIVATE LIMITED",
"KALAWATI EXPORTS PRIVATE LIMITED",
"KALAWATI KAUSTUBH HOSPITAL PRIVATE LIMITED",
"KALAWATI SARAN CHILDREN HOSPITAL",
"KALAYAN DOMBIVALI MUNICIAPL TRANSPORT",
"KALBHAIRAV FOODS PRIVATE LIMITED",
"KALBRO FOREX PRIVATE LIMITED",
"KALBROS SOURCING PRIVATE LIMITED",
"KALBURGI CEMENT PRIVATE LIMITED",
"KALCHURI CONTRACTORS LIMITED.",
"KALCO ALU SYSTEMS PRIVATE LIMITED",
"KALCO PRODUCTS INDIA PRIVATE LIMITED",
"KALCO TRADING PVT LTD",
"KALE BRAYAN MANUFACTURING INDIA PRIVATE LIMITED",
"KALE DAL MILL PRIVATE LIMITED",
"KALE LOGISTICS SOLUTIONS PRIVATE LIMITED",
"KALE MANGESH FARMER PRODUCER COMPANY LIMITED",
"KALE PHARMA PRIVATE LIMITED",
"KALE RUBBER WORKS PRIVATE LIMITED",
"KALE' S GOODS CARRIERS PRIVATE LIMITED",
"KALEESUWARI REFINERY AND INDUSTRY PRIVATE LIMITED",
"KALEESUWARI REFINERY PRIVATE LIMITED",
"KALEIDO CHEMIE PRIVATE LIMITED",
"KALEIDO COMMUNICATIONS PRIVATE LIMITED",
"KALEIDOSCOPE PRINTING STUDIO PRIVATE LIMITED",
"KALEIDOSCOPE PRODUCTIONS & SERVICES LLP",
"KALEKE LIVETECH SERVICES PRIVATE. LIMITED.",
"KALELKAR SURGICALS PRIVATE LIMITED",
"KALESHAWARI POWER PRODUCT PRIVATE LIMITED",
"KALESHWARAM PIPES AND FITTINGS PRIVATE LIMITED",
"KALGOV LABS LIMITED",
"KALGUDI DIGITAL PRIVATE LIMITED",
"KALI (INDIA) PRIVATE LIMITED",
"KALI AERATED WATER WORKS PRIVATE LIMITED",
"KALI AGRO INDUSTRIES PRIVATE LIMITED",
"KALI CONSTRUCTIONS PRIVATE LIMITED",
"KALI DYECHEM PRIVATE LIMITED",
"KALI ISPAT PRIVATE LIMITED",
"KALI MAA FORGE & FITTING ENGINEERING PRIVATE LIMITED",
"KALI PIGMENTS PVT LTD",
"KALI PLAST PRIVATE LIMITED",
"KALI ROLLER FLOUR MILLS PRIVATE LIMITED",
"KALI TRANSPORT PRIVATE LIMITED",
"KALIA EXPORT PRIVATE LIMITED",
"KALIAPPA RENAL CENTER PRIVATE LIMITED",
"KALIBERR BIOSCIENCE PRIVATE LIMITED",
"KALIBERR LABS PRIVATE LIMITED",
"KALIBRANT TRADES PRIVATE LIMITED",
"KALIBRE GLOBAL KONNECTS PRIVATE LIMITED",
"KALICHARAN & ASSOCIATES PRIVATE LIMITED",
"KALICHARAN INTER COLLEGE LUCKNOW",
"KALIDAHA PASCHIM PRIMARY SCHOOL",
"KALIDASI MITRA VIDYALAYA",
"KALIEDO COATINGS PRIVATE LIMITED",
"KALIGHATA MISTHAN BHANDAR PRIVATE LIMITED",
"KALIGI RANGANATHAN MONTFORD MATRICULATION SCHOOL",
"KALIKA COLD STORAGE PRIVATE LIMITED",
"KALIKA EXTRUSIONS PRIVATE LIMITED",
"KALIKA GINNING AND PRESSING PRIVATE LIMITED",
"KALIKA HUT RESTAURANT PRIVATE LIMITED",
"KALIKA PRESS PVT LTD",
"KALIKA SALES PRIVATE LIMITED",
"KALIKA STEEL ALLOYS PRIVATE LIMITED",
"KALIKA SUPLIERS PRIVATE LIMITED",
"KALIKAAR DESIGN PRIVATE LIMITED",
"KALIKAPUR NURSING HOME PRIVATE LIMITED",
"KALIKOTAS DIGITAL SOLUTIONS PRIVATE LIMITED",
"KALIKUND DEVELOPERS",
"KALIM HOUSING PRIVATE LIMITED",
"KALIM INFRASTRUCTURE PRIVATE LIMITED",
"KALIMATA INVESTMENT CONSULTANCY PRIVATE LIMITED",
"KALIMATA ISPAT INDUSTRIES PVT LTD",
"KALIMATA VYAPAAR PRIVATE LIMITED",
"KALIMATI CARBON PRIVATE LIMITED",
"KALIMATI PRODUCTS PRIVATE LIMITED",
"KALIMATI STEEL PVT LTD",
"KALIMPONG PRODUCE COMPANY LIMITED",
"KALIM'S DEVELOPERS (INDIA) PVT LTD",
"KALINA CHEMICALS PRIVATE LIMITED",
"KALINA ENGINEERING PRIVATE LIMITED",
"KALINA ENTERPRISES PRIVATE LIMITED",
"KALINA FABTEX PRIVATE LIMITED",
"KALINAGAR TEA & AGRO CO. PRIVATE LIMITED",
"KALINDA SOLAR PRIVATE LIMITED",
"KALINDI AGRO BIOTECH LIMITED",
"KALINDI AGRO TRADE PRIVATE LIMITED",
"KALINDI CHEMICALS PRIVATE LIMITED",
"KALINDI COLD STORAGE PRIVATE LIMITED",
"KALINDI ENTERPRISE",
"KALINDI ISPAT PRIVATE LIMITED",
"KALING MAN POWER SOLUTIONS PRIVATE LIMIT",
"KALING MAN POWER SOLUTIONS PRIVATE LIMITED",
"KALINGA ADVISORY SERVICES PRIVATE LIMITED",
"KALINGA AERO & ALLIED SERVICES PRIVATE LIMITED",
"KALINGA AGRO AND PRECISION CASTING PRIVATE LIMITED",
"KALINGA ALLOYS AND ISPAT PRIVATE LIMITED",
"KALINGA ALLOYS PRIVATE LIMITED",
"KALINGA AUTOMOBILES PRIVATE LIMITED",
"KALINGA BAKERY PRIVATE LIMITED",
"KALINGA BREEDING FARMS PRIVATE LIMITED",
"KALINGA BUILDERS PRIVATE LIMITED",
"KALINGA CABLES & CONDUIT CO",
"KALINGA COMBINES PVT LTD",
"KALINGA COMMERCIAL CORPORATION LIMITED",
"KALINGA DISTRIBUTORS PRIVATE LIMITED",
"KALINGA ELECTRICALS PVT LTD",
"KALINGA GASES PRIVATE LIMITED",
"KALINGA GLOBAL SERVICES",
"KALINGA GOLD JEWELS PRIVATE LIMITED",
"KALINGA HOSPITAL LTD",
"KALINGA HOTELS PRIVATE LIMITED",
"KALINGA INSTITUTE",
"KALINGA INSTITUTE OF INDUSTRIAL TECHNOLOGY",
"KALINGA INSTITUTE OF SOCIAL SCIENCES",
"KALINGA INTERNATIONAL COAL TERMINAL PARADIP PRIVATE LIMITED",
"KALINGA INTERNATIONAL SCHOOL",
"KALINGA JUTE PRODUCTS P LIMITED.",
"KALINGA LOGISTIC PRIVATE LIMITED",
"KALINGA MEDIA & ENTERTAINMENT PRIVATE LIMITED",
"KALINGA METALICS LIMITED",
"KALINGA MINING CORPORATION PRIVATE LIMITED",
"KALINGA NIMMI INDUSTRIES PRIVATE LIMITED",
"KALINGA PACKERS PRIVATE LIMITED",
"KALINGA PAINTS AND CHEMICALS INDUSTRIES PRIVATE LIMITED",
"KALINGA PANELS PRIVATE LIMITED",
"KALINGA POLY COMPOUNDS PRIVATE LIMITED",
"KALINGA ULTRA CHEM PRIVATE LIMITED",
"KALINGA UNIVERSITY",
"KALINGA UTKAL BIDYUT PRIVATE LIMITED",
"KALINGA VIKING PRIVATE LIMITED",
"KALINGIA ILLUMINATION PRIVATE LIMITED",
"KALINI COLLEGE UNIVERSITY OF DELHI",
"KALINJAR TECHNOLOGIES PRIVATE LIMITED",
"KALINTIS HEALTHCARE PRIVATE LIMITED",
"KALIS SPARKLING WATER PRIVATE LIMITED",
"KALISTA JEWELS I PRIVATE LIMITED",
"KALITA ELECTRICALS PVT LTD",
"KALITA MERCANTILE PVT LTD",
"KALIYAGANJ AGRO TRADING PVT LTD",
"KALJANI COLD STORAGE PRIVATE LIMITED",
"KALKA INFRASTRUCTURE PRIVATE LIMITED",
"KALKA MARBLE PRIVATE LIMITED",
"KALKA RESTAURANTS LIMITED",
"KALKAJEE KRAFT PAPER PRIVATE LIMITED",
"KALKAJEE VANIJYA PRIVATE LIMITED",
"KALKAJI ENGINEERING COMPANY PRIVATE LIMITED",
"KALKAJI GLASSES PRIVATE LIMITED",
"KALKANI SYSTEMS PRIVATE LIMITED",
"KALKI COMMUNICATION TECHNOLOGIES PRIVATE LIMITED",
"KALKI FASHION",
"KALKI FLUID POWER PRIVATE LIMITED",
"KALKI HEALTHCARE PRIVATE LIMITED",
"KALKI LIGHTING LIMITED",
"KALKIN PROPBUILD PRIVATE LIMITED",
"KALKINE CONSULTANCY INDIA PRIVATE LIMITED",
"KALKINE SOLUTIONS PRIVATE LIMITED",
"KALKURA REFRIGERATION AND KITCHEN EQUIPMENTS PRIVATE LIMITED",
"KALKUT INFRASTUCTURE PRIVATE LIMITED",
"KALKUT MARKETING PRIVATE LIMITED",
"KALKUT VINIMAY PRIVATE LIMITED",
"KALLADA GENERAL FINANCE PRIVATE LIMITED",
"KALLADA REGENCY PRIVATE LIMITED",
"KALLADA SOFTWARE SERVICES PRIVATE LIMITED",
"KALLAGAM-MEENSURUTTI HIGHWAY PRIVATE LIMITED",
"KALLAKAL FOUNDARY CASTING PRODUCTS PRIVATE LIMITED",
"KALLAKUNTA HEALTHCARE SERVICES PRIVATE LIMITED",
"KALLAKURI FOODS PRIVATE LIMITED",
"KALLAM AGRO PRODUCTS AND OILS PRIVATE LIMITED",
"KALLAM BROTHERS COTTONS PRIVATE LIMITED",
"KALLAM HARANADHAREDDY INSTITUTE OF TECHNOLOGY",
"KALLAM TEXTILES LIMITED",
"KALLAM TRANSMISSION LIMITED",
"KALLANI AUTOCAST PRIVATE LIMITED",
"KALLATE REALTORS AND DEVELOPERS PRIVATE LIMITED",
"KALLATRA PARIVAR PRIVATE LIMITED",
"KALLATRA TECHNOLOGIES PRIVATE LIMITED",
"KALLELIL BUSINESS ENTERPRISES PRIVATE LIMITED",
"KALLEN MARBLE AND GRANITES PRIVATE LIMITED",
"KALLIDAI FOOD PRODUCTS PRIVATE LIMITED",
"KALLIDEO POLYTEX PRIVATE LIMITED",
"KALLIKADU COMMON EFFLUENT TREATMENT PLANT PRIVATE LIMITED",
"KALLIYATH DEVELOPERS PRIVATE LIMITED",
"KALLIYATH METALS AND ALLOYS PRIVATE LIMITED",
"KALLIYATH STEELS PVT LTD",
"KALLOLINI ALCOBEV PRIVATE LIMITED",
"KALLOOR ELECTRONICS AND LIGHTING PRIVATE LIMITED",
"KALLOS SOLUTIONS PRIVATE LIMITED",
"KALLU FOREX PRIVATE LIMITED",
"KALLUR CHITS AND FINANCE PVT LTD",
"KALLUVARAMBIL HOMES PRIVATE LIMITED",
"KALMANE TRADING PRIVATE LIMITED",
"KALMIA FOODS PRIVATE LIMITED",
"KALMIKHALI F P SCHOOL",
"KALMIL OVERSEAS PRIVATE LIMITED",
"KALNA AMBIKA POULTRY FARMS PRIVATE LIMITED",
"KALNA RICE MILLS PVT. LTD.",
"KALNIDHI MARKETING PRIVATE LIMITED",
"KALOL INSTITUTES & RESEARCH CENTER",
"KALOL STEEL & ALLOY PRIVATE LIMITED",
"KALOLWALA & ASSOCIATES PRIVATE LIMITED",
"KALON AGRO INDUSTRIES PRIVATE LIMITED",
"KALORY FOODS PRIVATE LIMITED",
"KALOS OIL REFINERY PRIVATE LIMITED",
"KALOSONA HIMGHAR UDYOG PRIVATE LIMITED",
"KALOTI ENGINEERING COMPANY PRIVATE LIMITED",
"KALOTI HOTELS AND RESORTS LIMITED",
"KALP CAPITAL CONSULTANCY SERVICES PRIVATE LIMITED",
"KALP CLOTHING PRIVATE LIMITED",
"KALP DIAMONDS",
"KALP FOOTWEAR INDUSTRIES PRIVATE LIMITED",
"KALP INFRASTRUCTURE PRIVATE LIMITED",
"KALP LIGHTING PRIVATE LIMITED",
"KALP MULTIPACK PRIVATE LIMITED",
"KALP TECHNOLOGIES PRIVATE LIMITED",
"KALP VARSHA TRADEX PRIVATE LIMITED",
"KALPA CHAR PRODUCTS PRIVATE LIMITED",
"KALPA ELECTRIKAL PRIVATE LIMITED",
"KALPA POWER PRIVATE LIMITED",
"KALPA SOFTTECH PRIVATE LIMITED",
"KALPAK CATERERS PRIVATE LIMITED",
"KALPAK MARKETING PRIVATE LIMITED",
"KALPAK STEELS PRIVATE LIMITED",
"KALPAK TOOLS AND ALLIED PRODUCTS PRIVATE LIMITED",
"KALPAKA CHEMICALS PRIVATE LIMITED",
"KALPAKA EXIM PRIVATE LIMITED",
"KALPAKA MOTORS",
"KALPAKA PACKAGING PRIVATE LIMITED",
"KALPAKA PLASTICS PVT LTD",
"KALPAKAARU PROJECTS PRIVATE LIMITED",
"KALPAKOSH SOFTWARE SOLUTIONS PRIVATE LIMITED",
"KALPALATA COLD STORAGE PRIVATE LIMITED",
"KALPAMRIT AYURVED PRIVATE LIMITED",
"KALPAMRIT MARKETING PRIVATE LIMITED",
"KALPANA AGENCIES PRIVATE LIMITED",
"KALPANA BIRI MANUFACTURING CO PRIVATE LIMITED",
"KALPANA CONSTECH PRIVATE LIMITED",
"KALPANA DWELLINGS PRIVATE LIMITED",
"KALPANA FORGINGS INDIA PRIVATE LIMITED",
"KALPANA FURNITURE PRODUCTS PRIVATE LIMITED",
"KALPANA GEARS PVT LTD.",
"KALPANA GLASS FIBRE PRIVATE LIMITED",
"KALPANA HARDWARE MANUFACTURING PRIVATE LIMITED",
"KALPANA HOSPITALITY PRIVATE LIMITED",
"KALPANA INFRASTRUCTURE DEVELOPMENT PRIVATE LIMITED",
"KALPANA MADHANI SERCURITIES PRIVATE LIMITED",
"KALPANA MEDICAL CENTRE PRIVATE LIMITED",
"KALPANA MINERALS PVT LTD",
"KALPANA NURSING HOME PRIVATE LIMITED",
"KALPANA OFFSET PRIVATE LIMITED",
"KALPANA POLYMERS PVT LTD",
"KALPANA STRUCT CON PRIVATE LIMITED",
"KALPANA TRADING CO",
"KALPANA TRAVELS PRIVATE LIMITED",
"KALPANA VALVES MANUFACTURING COMPANY PVT. LTD.",
"KALPANA WINES",
"KALPAR ENGINEERS PRIVATE LIMITED",
"KALPASHA THE IT SOLUTION",
"KALPASIRI FARMS AND FOODS PRIVATE LIMITED",
"KALPATARU AGRO FOREST ENTERPRISES PRIVATE LIMITED",
"KALPATARU CHEMICALS PRIVATE LIMITED",
"KALPATARU COTTON PROCESSORS PRIVATE LIMITED",
"KALPATARU EDIBLES PRIVATE LIMITED",
"KALPATARU ENGINEERING LTD",
"KALPATARU ENGINEERS AND CONTRACTORS PRIVATE LIMITED",
"KALPATARU FABTEX PRIVATE LIMITED",
"KALPATARU FORMULATIONS PRIVATE LIMITED",
"KALPATARU FOUNDATION",
"KALPATARU GARDENS PRIVATE LIMITED",
"KALPATARU GLOBAL ALLOYS PRIVATE LIMITED",
"KALPATARU HILLS RESIDENCY PRIVATE LIMITED",
"KALPATARU HOMES PRIVATE LIMITED",
"KALPATARU HOSPITAL",
"KALPATARU HOTELIERS PVT LTD",
"KALPATARU HOUSEFIN & TRADING PVT LTD",
"KALPATARU INFRACON PRIVATE LIMITED",
"KALPATARU LIMITED",
"KALPATARU MULTIPLIER LIMITED",
"KALPATARU NUTS PRIVATE LIMITED",
"KALPATARU PROJECTS INTERNATIONAL LIMITED",
"KALPATARU PROPERTIES PRIVATE LIMITED",
"KALPATARU PROPERTIES THANE PRIVATE LIMITED",
"KALPATARU PVT LTD",
"KALPATARU RETAIL VENTURES PRIVATE LIMITED",
"KALPATARUVU SPINNING MILLS PRIVATE LIMITED",
"KALPATECH ENGINEERS & INDUSTRIES LIMITED",
"KALPATHARU BREWERIES AND DISTILLERIES PRIVATE LIMITED",
"KALPATHARU ENTERPRISES PRIVATE LIMITED",
"KALPATHARU INFRASTRUCTURE DEVELOPMENT COMPANY PRIVATE LIMITED",
"KALPATHARU SOFTWARE LIMITED",
"KALPATRU ENTERPRISES PRIVATE LIMITED",
"KALPATRU PLASTICS PRIVATE LIMITED",
"KALPATRU POLYSTERS PRIVATE LIMITED",
"KALPATRU SYNTHETICS PRIVATE LIMITED",
"KALPATRU YARNS PRIVATE LIMITED",
"KALPAVRAKSHA AGROTECH PRIVATE LIMITED",
"KALPAVRIKSH HEALTHCARE PRIVATE LIMITED",
"KALPAVRIKSHA AGRISCIENCES PRIVATE LIMITED",
"KALPAVRIKSHA LOGITECH SERVICES PRIVATE LIMITED",
"KALPAVRUKSH SYSTEMS LIMITED",
"KALPAVRUKSH SYSTEMS PRIVATE LIMITED",
"KALPAVRUKSHA FINANCIAL ADVISORY SERVICES PRIVATE LIMITED",
"KALPAVRUKSHA HEALTHCARE SERVICES PRIVATE LIMITED",
"KALPA-VRUKSHA PLANTATIONS PVT LTD",
"KALPEN VENTURES PRIVATE LIMITED",
"KALPESH CABLE INDUSTRIES PRIVATE LIMITED",
"KALPESH CORPORATION",
"KALPESH ROADLINES LIMITED",
"KALPESH SYNTHETICS PRIVATE LIMITED",
"KALPESH TRADING AND INVESTMENT PVT LTD",
"KALPITA AGENCIES PRIVATE LIMITED",
"KALPITA TECHNOLOGIES PRIVATE LIMITED",
"KALPNA POLY FILMS PRIVATE LIMITED",
"KALPSAR LAM PRIVATE LIMITED",
"KALPSUTRA CHEMICALS PRIVATE LIMITED",
"KALPTARU CONSTRUCTION PRIVATE LIMITED",
"KALPTARU FINCAP LIMITED",
"KALPTARU HOSPITAL",
"KALPTARU INSURANCE BROKERS LIMITED",
"KALPTARU INVESTMENTS PRIVATE LIMITED",
"KALPTARU XPRESS CARGO PRIVATE LIMITED",
"KALPTREE FASHION AND LIFESTYLE PRIVATE LIMITED",
"KALPVISION CONSULTING AND TECHNOLOGIES PRIVATE LIMITED",
"KALPVRAKSH IMPEX PRIVATE LIMITED",
"KALPVRAKSHH PULSES FARMER PRODUCER COMPANY LIMITED",
"KALPVRIKSHA EDUCATION INSTITUTE PRIVATE LIMITED",
"KALPVRUX CONVERTING PRODUCTS PRIVATE LIMITED",
"KALRA ELECTROCOM PRIVATE LIMITED",
"KALRA HOSPITAL",
"KALRA HOSPITAL SRCNC PRIVATE LIMITED",
"KALRA IMPEX PRIVATE LIMITED",
"KALRA ISPAT PRIVATE LIMITED",
"KALRA MIND CARE",
"KALRA MOTORS PRIVATE LIMITED",
"KALRA PAPER INDUSTRIES PRIVATE LIMITED",
"KALRA STEEL UDYOG PRIVATE LIMITED",
"KALRA TEXTILE MILLS PRIVATE LIMITED",
"KALRASHUKLA CLASSES PRIVATE LIMITED",
"KALS BEVERAGES PRIVATE LIMITED",
"KALS BREWERIES PRIVATE LIMITED",
"KALS DISTILLERIES CARNATAKA PRIVATE LIMITED",
"KALS DISTILLERIES PRIVATE LIMITED",
"KALS TEX PRIVATE LIMITED",
"KALSAN ENGINEERING INDUSTRIES PRIVATE LIMITED",
"KALSEKAR HOSPITAL",
"KALSI AUTOMATIC DOOR SYSTEMS PRIVATE LIMITED",
"KALSI BUILDCON PRIVATE LIMITED",
"KALSI ELECTRONICS PRIVATE LIMITED",
"KALSIDDHI ANORECTAL",
"KALSON FABRIC PRIVATE LIMITED",
"KALSON PLAST PRIVATE LIMITED",
"KALSUBAI POWER PRIVATE LIMITED",
"KALTHIA ASHTI PACHOD PRIVATE LIMITED",
"KALTHIA BAGODARA TARAPUR HIGHWAY PRIVATE LIMITED",
"KALTHIA BHAVNAGAR HIGHWAY LIMITED",
"KALTHIA BHAVNAGAR PIPLI HIGHWAY PRIVATE LIMITED",
"KALTHIA ENGINEERING AND CONSTRUCTION LIMITED",
"KALTHIA INFRA PRIVATE LIMITED",
"KALTHIA INFRA PROJECTS PRIVATE LIMITED",
"KALTHIA INFRA-CON PRIVATE LIMITED",
"KALTHIA POWER INDIA PRIVATE LIMITED",
"KALTHIA PRIYHEER INFRASTRUCTURE PRIVATE LIMITED",
"KALTHIA UNA HIGHWAY LIMITED",
"KALUBAI ENTERPRISES PRIVATE LIMITED",
"KALURAM BASTIRAM MALI PRIVATE LIMITED",
"KALURAM FOOD PRODUCTS PRIVATE LIMITED",
"KALURAM MEMORIAL HOSPITALS PRIVATE LIMITED",
"KALURAM PRAKASHCHANDRA TEXO PRINT PRIVATE LIMITED",
"KALUWALA CONSTRUCTION PRIVATE LIMITED",
"KALVA MARKETING AND SERVICES LIMITED",
"KALVERT FOODS (INDIA) PRIVATE LIMITED",
"KALVIK BUILDERS PRIVATE LIMITED",
"KALVIN BIKES PRIVATE LIMITED",
"KALWA HINDI HIGH SCHOOL",
"KALWA SUPER MARKET PRIVATE LIMITED",
"KALYA CONSTRUCTIONS PRIVATE LIMITED",
"KALYA PROJECTS PRIVATE LIMITED",
"KALYADI ENGINEERING PRIVATE LIMITED",
"KALYAN ALLOYS PRIVATE LIMITED",
"KALYAN AQUA & MARINE EXPORTS INDIA PRIVATE LIMITED",
"KALYAN BHARTI TRUST",
"KALYAN BIO OIL PRIVATE LIMITED",
"KALYAN CAPITALS LIMITED",
"KALYAN CONFECTIONERY PVT LTD",
"KALYAN CONSULTANTS (MADRAS) PRIVATE LTD",
"KALYAN DOMBIVLI MUNICIPAL CORPORATION",
"KALYAN DOMBIVLI MUNICIPAL TRANSPORT",
"KALYAN EXIM GOLD JEWELLERY PRIVATE LIMITED",
"KALYAN FASHION INDIA PRIVATE LIMITED",
"KALYAN GLAZED TILES",
"KALYAN GRAND STAY PRIVATE LIMITED",
"KALYAN HOSPITALITY SERVICES PRIVATE LIMITED",
"KALYAN INFRATECH PRIVATE LIMITED",
"KALYAN ISPAT (INDIA) PVT LTD",
"KALYAN JEWELLERS INDIA LIMITED",
"KALYAN KAMAL SALES PAIVATE LIMITED",
"KALYAN KENDRA SILKS AND SAREES PRIVATE LIMITED",
"KALYAN KETI TOLL PRIVATE LIMITED",
"KALYAN KRIPA HERBALS PRIVATE LIMITED",
"KALYAN LOK NIRMAN PRIVATE LIMITED",
"KALYAN MARBLE AND GRANITE LIMITED",
"KALYAN METRO MULTISPECIALITY HOSPITAL PRIVATE LIMITED",
"KALYAN NAV NIRMAN LIMITED",
"KALYAN PG COLLEGE",
"KALYAN REFINERS AND OILS PRIVATE LIMITED",
"KALYAN ROLLER FLOUR MILLS PRIVATE LIMITED",
"KALYAN RURAL EMPOWERMENT DEVELOPEMENT INFOFINTECH FOUNDATION",
"KALYAN SILKS TRICHUR PRIVATE LIMITED",
"KALYAN STEEL PRODUCTS PRIVATE LIMITED",
"KALYAN TOLL HIGHWAYS PRIVATE LIMITED",
"KALYAN TOLL INFRASTRUCTURE LIMITED",
"KALYAN VYAPAAR PVT. LTD.",
"KALYANA KARNATAKA ROAD TRANSPORT CORPORATION",
"KALYANAMALAI PRIVATE LIMITED",
"KALYANBHAI MAYABHAI STOCK BROKERS PRIVATE LIMITED",
"KALYANESHWARI COKE PRIVATE LIMITED",
"KALYANESHWARI ISPAT UDYOG PRIVATE LIMITED",
"KALYANESWARI POLYFABS PRIVATE LIMITED",
"KALYANESWARI PROPERTIES PVT LTD",
"KALYANESWARI UDYOG PRIVATE LIMITED",
"KALYANI ADITYA MINERAL LIMITED",
"KALYANI ALLOY CASTINGS LTD",
"KALYANI ASSOCIATES",
"KALYANI AURA WORKSPACE PRIVATE LIMITED",
"KALYANI BUILDCON PRIVATE LIMITED",
"KALYANI CARTON PRIVATE LIMITED",
"KALYANI CAST TECH LIMITED",
"KALYANI CENTRE FOR PRECISION TECHNOLOGY LIMITED",
"KALYANI COMMERCIALS LIMITED",
"KALYANI COMMODITIES PVT.LTD.",
"KALYANI COMMUNICATIONS PRIVATE LIMITED",
"KALYANI CONSULTANTS PRIVATE LIMITED",
"KALYANI COVERING PRIVATE LIMITED",
"KALYANI EXPORTS AND INVESTMENTS PRIVATE LIMITED",
"KALYANI FIBRES LIMITED",
"KALYANI FINANCIAL SERVICES LIMITED",
"KALYANI FORGE LIMITED",
"KALYANI GLOBAL ENGINEERING PRIVATE LIMITED",
"KALYANI GOVT ENGG COLLEGE",
"KALYANI HAYES LEMMERZ LIMITED",
"KALYANI HOSPITAL",
"KALYANI HRUSHIKESH ENTERPRISES PRIVATE LIMITED",
"KALYANI INDIA PRIVATE LIMITED",
"KALYANI INDUSTRIES LIMITED",
"KALYANI INFORMIX PRIVATE LIMITED",
"KALYANI INFOTECH SOLUTIONS LIMITED",
"KALYANI INNERWEAR PRIVATE LIMITED",
"KALYANI INVESTMENT COMPANY LIMITED",
"KALYANI KNITFAB PRIVATE LIMITED",
"KALYANI LABORATORIES PRIVATE LIMITED",
"KALYANI MAXION WHEELS PRIVATE LIMITED",
"KALYANI MEDITIMES PRIVATE LIMITED",
"KALYANI MINE PRODUCTS PRIVATE LIMITED",
"KALYANI MOTORS PRIVATE LIMITED",
"KALYANI MOULD BASE PRIVATE LIMITED",
"KALYANI NAVYUG MEDIA PRIVATE LIMITED",
"KALYANI NON WOVEN FABRICS PRIVATE LIMITED",
"KALYANI OIL EXTRACTION PRIVATE LIMITED",
"KALYANI ORGANICS AND NURSERY PRIVATE LIMITED",
"KALYANI PANCHAYAT SAMITI",
"KALYANI POLYMERS PRIVATE LIMITED",
"KALYANI POWERTRAIN LIMITED",
"KALYANI PUBLISHERS",
"KALYANI PUMPS PRIVATE LIMITED",
"KALYANI RADIOTHERAPY SPECIALTY INDIA PRIVATE LIMITED",
"KALYANI RAFAEL ADVANCED SYSTEMS PRIVATE LIMITED",
"KALYANI SEED FARMS PRIVATE LIMITED",
"KALYANI SOLVEX PRIVATE LIMITED",
"KALYANI SPHEROCAST PRIVATE LIMITED",
"KALYANI STAMPINGS PRIVATE LIMITED",
"KALYANI STEELS LTD",
"KALYANI STRATEGIC MANAGEMENT SERVICES LIMITED",
"KALYANI STRATEGIC SYSTEMS LIMITED",
"KALYANI SYNTHETICS PRIVATE LIMITED",
"KALYANI TEA CO LTD",
"KALYANI TECH PARK PRIVATE LIMITED",
"KALYANI TECHNOFORGE LIMITED",
"KALYANI TIMBER PRIVATE LIMITED",
"KALYANI TRADELINKS PRIVATE LIMITED",
"KALYANI TRANSCO PRIVATE LIMITED",
"KALYANI TRANSMISSION TECHNOLOGIES PRIVATE LIMITED",
"KALYANI UNIVERSITY",
"KALYANI UNIVERSITY EXPERIMENTAL HIGH SCHOOL",
"KALYANI UNO'S AQUA FEEDS PRIVATE LIMITED",
"KALYANIRAM POLYPLAST PRIVATE LIMITED",
"KALYANIWALLA AND MISTRY LLP",
"KALYANLAKSHMI APPARELS PRIVATE LIMITED",
"KALYANPUR CEMENT",
"KALYANPUR HIGH SCHOOL",
"KALYCITO INFOTECH PRIVATE LIMITED",
"KALYPSO ADVENTURES PRIVATE LIMITED",
"KALYR RETAIL PRIVATE LIMITED",
"KALYX GLOBAL LOGISTICS PRIVATE LIMITED",
"KALYX INDIA HEALTH CARE PRIVATE LIMITED",
"KALYX INFOTECH PRIVATE LIMITED",
"KALYX WAREHOUSING PRIVATE LIMITED",
"KALZIP INDIA PRIVATE LIMITED",
"KALZOOM ADVISORS PRIVATE LIMITED",
"KAM AUTO ENGINEERING & VALIDATION PRIVATE LIMITED",
"KAM INFRASTRUCTURE PRIVATE LIMITED",
"KAM MARKETING PVT LTD",
"KAM RESOURCES PRIVATE LIMITED",
"KAMA AYURVEDA PRIVATE LIMITED",
"KAMA JEWELRY PRIVATE LIMITED",
"KAMA REALTY (DELHI) LIMITED",
"KAMAC ENGINEER'S PRIVATE LIMITED",
"KAMACHI CAR RENTAL PRIVATE LIMITED",
"KAMACHI SPONGE & POWER CORPORATION LIMITED",
"KAMACHI STEELS PRIVATE LIMITED",
"KAMACOM SYSTEMS PRIVATE LIMITED",
"KAMADGIRI CROP SCIENCE PRIVATE LIMITED",
"KAMADGIRI EXPORTS PRIVATE LIMITED",
"KAMADGIRI FABRICS",
"KAMADGIRI FASHION LIMITED",
"KAMADGIRI OILS PRIVATE LIMITED",
"KAMADGIRI STEEL PRIVATE LIMITED",
"KAMADGIRI VASTRALAYA PRIVATE LIMITED",
"KAMADHENU BEVERAGES PRIVATE LIMITED",
"KAMADHENU ELEVATORS PRIVATE LIMITED",
"KAMADHENU FEEDS PVT LTD",
"KAMADHENU FOOD PROCESSING INDUSTRIES",
"KAMADHENU RICE MILLS PRIVATE LIMITED",
"KAMADHENU TECHNOLOGY PRIVATE LIMITED",
"KAMADHENU TELE FILMS PRIVATE LIMITED",
"KAMAI ELEVATORS PRIVATE LIMITED",
"KAMAINDIA PRIVATE LIMITED",
"KAMAKHAYA VYAPAR PRIVATE LIMITED",
"KAMAKHYA INDIA LIMITED",
"KAMAKHYA INFRACON PRIVATE LIMITED",
"KAMAKHYA JEWELS PRIVATE LIMITED",
"KAMAKHYA KAY PAN FRAGRANCE INDUSTRIES PRIVATE LIMITED",
"KAMAKHYA MULTITRADE PRIVATE LIMITED",
"KAMAKHYA PAN PRODUCTS PRIVATE LIMITED",
"KAMAKHYA ROLLER FLOUR MILL PVT LIMITED",
"KAMAKHYA SOLUTION & SERVICES",
"KAMAKHYA TRANSPORT PRIVATE LIMITED",
"KAMAKHYAEXIMS MINERALS & PETROCHEMICALS INDIA PRIVATE LIMITED",
"KAMAKHYAKAMRUP INDUSTRIES PRIVATE LIMITED",
"KAMAKSHI CONSTRUCTIONS AND ENGINEERS PRIVATE LIMITED",
"KAMAKSHI COTTON INDUSTRIES GINNING AND PRESSING UNIT",
"KAMAKSHI DHAWAN INDUSTRIES PRIVATE LIMITED",
"KAMAKSHI HOSPITALS",
"KAMAKSHI KRAFTEX PRIVATE LIMITED",
"KAMAKSHI LAMIPACK PRIVATE LIMITED",
"KAMAKSHI OILS PRIVATE LIMITED",
"KAMAKSHI PAPERS PRIVATE LIMITED",
"KAMAKSHI PLASTICS PRIVATE LIMITED",
"KAMAKSHI SUEDPACK PRIVATE LIMITED",
"KAMAKSHI TRADEXIM (INDIA) PRIVATE LIMITED",
"KAMAKSHYA AGRO PRODUCTS PRIVATE LIMITED",
"KAMAL AGRO INDUSTRIES",
"KAMAL AND ASSOCIATES PVT LTD",
"KAMAL AUTO FINANCE LIMITED.",
"KAMAL AUTO INDUSTRIES COACH WORKS PRIVATE LIMITED",
"KAMAL AUTOCARE PRIVATE LIMITED",
"KAMAL AUTOFINANCE PRIVATE LIMITED",
"KAMAL AUTOMART PRIVATE LIMITED",
"KAMAL AUTOMATION SYSTEMS PRIVATE LIMITED",
"KAMAL AUTOMOTIVES PRIVATE LIMITED",
"KAMAL AUTOTECH PRIVATE LIMITED",
"KAMAL BEARINGS PRIVATE LIMITED",
"KAMAL BUILDTECH PRIVATE LIMITED",
"KAMAL BUS SERVICE PVT LTD",
"KAMAL CARLINE PRIVATE LIMITED",
"KAMAL CED SOLUTIONS LLP",
"KAMAL CHAND JAIN COLD STORAGE PRIVATE LIMITED",
"KAMAL CLEARING AND FORWARDING AGENCY PRIVATE LIMITED",
"KAMAL COGENT ENERGY PRIVATE LIMITED",
"KAMAL COMMERCIAL VEHICLES PRIVATE LIMITED",
"KAMAL CONPRO PRIVATE LIMITED",
"KAMAL COTSPIN PRIVATE LIMITED",
"KAMAL DESIGNS PRIVATE LIMITED",
"KAMAL DEVELOPERS PRIVATE LIMITED",
"KAMAL DISTRIBUTORS PRIVATE LIMITED",
"KAMAL ENCON INDUSTRIES LIMITED",
"KAMAL ENGINEERING INDUSTRIES PRIVATE LIMITED",
"KAMAL ENGINEERING SOLUTIONS LLP",
"KAMAL ENGINEERS AND CONTRACTORS PVT LTD",
"KAMAL ENVIROTECH PRIVATE LIMITED",
"KAMAL FABRICS PRIVATE LIMITED",
"KAMAL FINCAP PRIVATE LIMITED",
"KAMAL FOODS PRIVATE LIMITED",
"KAMAL FORGINGS PRIVATE LIMITED",
"KAMAL FUTURISTIC TECHNOLOGY PRIVATE LIMITED",
"KAMAL GEMS AND DIAMOND PRIVATE LIMITED",
"KAMAL GLASS SOLUTION PRIVATE LIMITED",
"KAMAL GOODS CARRIERS PRIVATE LIMITED",
"KAMAL HEALTHCARE PRODUCTS PRIVATE LIMITED",
"KAMAL HITECH ENGINEERS PRIVATE LIMITED",
"KAMAL IMAGING AND PATHOLOGY CENTRE PRIVATE LIMITED",
"KAMAL INFOCOMM PRIVATE LIMITED",
"KAMAL INFRABUILD PRIAVTE LIMITED",
"KAMAL INTERNATIONAL",
"KAMAL INTERNATIONAL DIVISION OF GAJHAM EXPORTS PRIVATE LIMITED",
"KAMAL INVESTMENTS LIMITED",
"KAMAL ISPAT PRIVATE LIMITED",
"KAMAL JEWELLERS",
"KAMAL KANTA RICE MILL PRIVATE LIMITED",
"KAMAL KAUSHAL INFRA SOLUTIONS PRIVATE LIMITED",
"KAMAL KISHORE FLOUR MILLS PRIVATE LIMITED",
"KAMAL KUMAR JALAN SECURITIES PRIVATE LIMITED",
"KAMAL MARINE & ENGINEERING WORKS PRIVATE LIMITED",
"KAMAL MARKETING PVT LTD",
"KAMAL MEDICO PRIVATE LIMITED",
"KAMAL METALS PVT LTD",
"KAMAL MODEL SR SEC SCHOOL",
"KAMAL MOOKERJEE & CO.(SHIPPING) PVT LTD",
"KAMAL MOTELS PRIVATE LIMITED",
"KAMAL MOTORS",
"KAMAL MULTITEXTILE OVERSEAS PRIVATE LIMITED",
"KAMAL NAYAN BAJAJ HOSPITAL",
"KAMAL NAYAN MARKETING ASSOCIATES PRIVATE LIMITED",
"KAMAL NETRALAYA PRIVATE LIMITED",
"KAMAL ORGANISERS PRIVATE LIMITED",
"KAMAL OSMAN JAMJOOM TECH SERVICES INDIA PRIVATE LIMITED",
"KAMAL PACKAGING PVT LTD",
"KAMAL PASSENGER VEHICLE PRIVATE LIMITED",
"KAMAL PIPES PRIVATE LIMITED",
"KAMAL POLYTECH PRIVATE LIMITED",
"KAMAL POULTRY AND FEEDS PVT LTD",
"KAMAL PROCESSORS PVT LTD",
"KAMAL RENU CREDIT & INVEST PRIVATE LIMITED",
"KAMAL RUBPLAST INDUSTRIES PRIVATE LIMITED",
"KAMAL SHAFT PRIVATE LIMITED",
"KAMAL SHIPPING SERVICES PRIVATE LIMITED",
"KAMAL SOLVENT EXTRACTIONS PRIVATE LIMITED",
"KAMAL SPONGE STEEL AND POWER LIMITED",
"KAMAL SUITINGS PRIVATE LIMITED",
"KAMAL SUPPLY CHAIN PRIVATE LIMITED",
"KAMAL TECHNOPLAST PRIVATE LIMITED",
"KAMAL TEWARI TEA WAREHOUSE PRIVATE LIMITED",
"KAMAL TEXFAB PRIVATE LIMITED",
"KAMAL TIMBERS INDIA PRIVATE LIMITED",
"KAMAL TOURS AND TRAVELS PRIVATE LIMITED",
"KAMAL TRADING CORPORATION.",
"KAMAL WATCH COMPANY PRIVATE LIMITED",
"KAMAL WATCH RETAIL PRIVATE LIMITED",
"KAMAL YOG MARBLES PRIVATE LIMITED",
"KAMALA AQUATIC PRIVATE LIMITED",
"KAMALA BOARD BOX PRIVATE. LIMITED.",
"KAMALA CONSUMER CARE PRIVATE LIMITED",
"KAMALA DEVI POLY PACKS PRIVATE LIMITED",
"KAMALA DYE STUFF PRIVATE LIMITED",
"KAMALA ELECTRONICS PVT LTD",
"KAMALA ENGINEERING (DIAMONDS) PRIVATE LIMITED",
"KAMALA FINCON PVT LTD",
"KAMALA GINNING AND OIL INDUSTRIES",
"KAMALA HEALTHCARE PRIVATE LIMITED",
"KAMALA HOSPITAL",
"KAMALA INSTIUTE OF TECHNOLOGY & SCIENCE",
"KAMALA INTERNATIONAL EXIM PRIVATE LIMITED",
"KAMALA LEISURE CENTER PRIVATE LIMITED",
"KAMALA NEHRU COLLEGE",
"KAMALA NEHRU POLYTECHNIC COLLEGE HOSTE",
"KAMALA NEHRU WOMENS COLLEGE - BBSR",
"KAMALA NIKETAN MONTESSORI SCHOOL",
"KAMALA NIRMAAN PRIVATE LIMITED",
"KAMALA PRESS PRIVATE LIMITED",
"KAMALA RAY HOSPITAL PRIVATE LIMITED",
"KAMALA SHIKSHA SADAN GOVT BOYS HIGH SCHOOL",
"KAMALA SPECIALITY HOSPITALS PRIVATE LIMITED",
"KAMALA SUGAR MILLS LIMITED",
"KAMALA TEA CO LTD",
"KAMALA VALVES & ENGINEERING PRIVATE LIMITED",
"KAMALABARI PRIVATE LIMITED",
"KAMALACHAL TUBES PRIVATE LIMITED",
"KAMALAKANTA COLD STORAGE PRIVATE LIMITED",
"KAMALAKANTA ENGINEERING & CONSTRUCTION COMPANY PRIVATE LIMITED",
"KAMALAKAR SAPLE ENGINEERING INDUSTRIES PRIVATE LIMITED",
"KAMALAKSHI MARKETING PRIVATE LIMITED",
"KAMALALAYA HIISOFT PRIVATE LIMITED",
"KAMALAM ADVISORY AND TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"KAMALAM HANDLOOMS PRIVATE LIMITED",
"KAMALASHA EXPORTS PRIVATE LIMITED",
"KAMALASHA INFRASTRUCTURE AND ENGINNERING PRIVATE LIMITED",
"KAMALASHI CONSTRUCTIONS AND ENGINEERS PRIVATE LIMITED",
"KAMALDEEP ENGINEERS PRIVATE LIMITED",
"KAMALDEEP ENTERPRISES PRIVATE LIMITED",
"KAMALDEEP ISPAT PRIVATE LIMITED",
"KAMALDEEP METALICS PRIVATE LIMITED",
"KAMALDEEP VANIJYA PRIVATE LIMITED",
"KAMALESH CONSTRUCTION PRIVATE LIMITED",
"KAMALJYOT INVESTMENTS LIMITED",
"KAMALNATH TRADECONS PRIVATE LIMITED",
"KAMALNAYAN INVESTMENT AND TRADING PVT LTD",
"KAMALNAYAN JAMNALAL BAJAJ FOUNDATION WARDHA",
"KAMALPURA CONSTRUCTION COMPANY PRIVATE LIMITED",
"KAMALRAJ ESTATE",
"KAMAL'S CAKE & CONFECTIONERY PRIVATE LIMITED",
"KAMAL'S ICE CREAM & INDUSTRIES PRIVATE LIMITED",
"KAMALSONS INTERNATIONAL LIMITED",
"KAMALUDYOG MFG & TRADE PRIVATE LIMITED",
"KAMALVEER SYSTEMS PRIVATE LIMITED",
"KAMANI AGENCIES PRIVATE LIMITED",
"KAMANI CHEMICALS PRIVATE LIMITED",
"KAMANI TUBES LIMITED",
"KAMANIA COMPUTER ACADEMY PRIVATE LIMITED",
"KAMANIA COMPUTER ACADEMY PVT LTD",
"KAMANWALA HOUSING CONSTRUCTION LIMITED",
"KAMAR INFRASTRUCTURE PRIVATE LIMITED",
"KAMARAJ COLLEGE OF ENGINEERING AND TECHNOLOGY",
"KAMARAJ CO-OPERATIVE CREDIT SOCIETY LTD",
"KAMARAJ INTERNATIONAL ACADEMY SENIOR SECONDARY SCHOOL",
"KAMARAJAR PORT LIMITED",
"KAMARHATI MUNICIPALITY",
"KAMARHATI STATE GENERAL HOSPITAL",
"KAMARHATTY POWER LIMITED",
"KAMARI TRADING PRIVATE LIMITED",
"KAMARPUKHURI TEA INDUSTRY PRIVATE LIMITED",
"KAMAT AUTOMOBILES PRIVATE LIMITED",
"KAMAT CONSTRUCTION AND RESORTS PRIVATE LIMITED",
"KAMAT CONSTRUCTION PRIVATE LIMITED",
"KAMAT EXPORTS PRIVATE LIMITED",
"KAMAT FOODS PRIVATE LIMITED",
"KAMAT HOSPITAL PRIVATE LIMITED",
"KAMAT HOTELS INDIA LTD",
"KAMAT HOTELS PRIVATE LIMITED",
"KAMAT YATRINIWAS PRIVATE LIMITED",
"KAMATAZ SOURCING AND CONSULTING PRIVATE LIMITED",
"KAMATH ELECTRICALS PRIVATE LIMITED",
"KAMATH TRANSFORMERS PRIVATE LIMITED",
"KAMATHAM COMMUNICATIONS PRIVATE LIMITED",
"KAMATHS NATURAL RETAIL PRIVATE LIMITED",
"KAMATHS SPECIALITY HOTELS PRIVATE LIMITED",
"KAMATS WORLDWIDE FOOD SERVICES PRIVATE LIMITED",
"KAM-AVIDA ENVIRO ENGINEERS PRIVATE LTD",
"KAMAX AUTOMOTIVE INDIA PRIVATE LIMITED",
"KAMAX INDIA SILK PRIVATE LIMITED",
"KAMAYANI AGENCIES PVT LTD.",
"KAMAYANI SCHOOL FOR MENTALLY HANDICAPPED",
"KAMAZ MOTORS LIMITED",
"KAMBALA HOSPITALITY PRIVATE LIMITED",
"KAMBAN HIGH SCHOOL DHARAVI",
"KAMBAR PRODUCTS AND SERVICES PRIVATE LIMITED",
"KAMBERT MACHINERY COMPANY PRIVATE LIMITED",
"KAMBILL SYSTEMS PRIVATE LIMITED",
"KAMBOJ INFRASTRUCTURE PRIVATE LIMITED",
"KAMBOJ POLYMERS PRIVATE LIMITED",
"KAMBRIJ HOSPITAL CARE PRIVATE LIMITED",
"KAMBS STRUCTURAL DETAILERS PRIVATE LIMITED",
"KAMBSON EXPRESS & LOGISTICS INDIA PRIVATE LIMITED",
"KAMBY FOODS PRIVATE LIMITED",
"KAMCO CHEW FOOD PRIVATE LIMITED",
"KAMDAR AND KAMDAR ASSOCIATES PRIVATE LIMITED",
"KAMDAR INFRASTRUCTURE PRIVATE LIMITED",
"KAMDAR NURSING HOME AND POLY CLINIC PRIVATE LIMITED",
"KAMDAR PLASTICS PRIVATE LIMITED",
"KAMDAR PRIVATE LIMITED",
"KAMDARS AGRO RESEARCH & DEVELOPMENT PRIVATE LIMITED",
"KAMDHENU AWAS PRIVATE LIMITED",
"KAMDHENU BIO FERTILIZER PRIVATE LIMITED",
"KAMDHENU CARS PRIVATE LIMITED",
"KAMDHENU CATERERS PRIVATE LIMITED",
"KAMDHENU CATTLE FEEDS PRIVATE LIMITED",
"KAMDHENU COTTON AND SPINNING MILLS PRIVATE LIMITED",
"KAMDHENU DEPARTMENTAL STORE PRIVATE LIMITED",
"KAMDHENU FOODS LIMITED",
"KAMDHENU LIMITED",
"KAMDHENU METALLIC INDUSTRIES LIMITED",
"KAMDHENU PAINT INDUSTRIES LIMITED",
"KAMDHENU PETROLEUM",
"KAMDHENU PICKLS AND SPICES INDUSTRIES PVT. LTD.",
"KAMDHENU POLYMERS PRIVATE LIMITED",
"KAMDHENU POLYTECH PRIVATE LIMITED",
"KAMDHENU PROCESSORS PRIVATE LIMITED",
"KAMDHENU REALITIES",
"KAMDHENU SWEETS & NAMKEEN",
"KAMDHENU TECH SERVICES PRIVATE LIMITED",
"KAMDHENU UDYOG PRIVATE LIMITED",
"KAMDHENU UNIVERSITY",
"KAMDHENU VANIJYA PRIVATE LIMITED",
"KAMDHENU VENTURES LIMITED",
"KAMDHENUS SWEETS PRIVATE LIMITED",
"KAMEDA INFOLOGICS PRIVATE LIMITED",
"KAMERO TECHNOSYS LIMITED",
"KAMESHWAR ALLOYS & STEELS PRIVATE LIMITED",
"KAMESHWAR INDUSTRIES",
"KAMESHWAR KNITTING PRIVATE LIMITED",
"KAMET INTERIORS PRIVATE LIMITED",
"KAMEYO SYSTEMS PRIVATE LIMITED",
"KAMFOOD PRODUCTS (INDIA) PRIVATE LIMITED",
"KAMGAR ENGINEERING WORKS I.PRIVATE. LIMITED",
"KAMGAR SAFETY INDIA PRIVATE LIMITED",
"KAMI COLOURCERA PRIVATE LIMITED",
"KAMI LABS PRIVATE LIMITED",
"KAMI MARINE & TRADE CENTRAL PRIVATE LIMITED",
"KAMICOZ INTERNATIONAL PRIVATE LIMITED",
"KAMINENI HEALTH CARE PRIVATE LIMITED",
"KAMINENI HEALTH SERVICES PRIVATE LIMITED",
"KAMINENI HOSPITALS PRIVATE LIMITED",
"KAMINENI LIFE SCIENCES PRIVATE LIMITED",
"KAMINENI ONCOLOGY CENTRE PRIVATE LIMITED",
"KAMINI FERROUS LIMITED",
"KAMINI METALLIKS PRIVATE LIMITED",
"KAMLA BHEL AND CO PVT LTD",
"KAMLA CONSTRUCTION",
"KAMLA DEVI RICE MILL PRIVATE LIMITED",
"KAMLA EYE AND MATERNITY HOME PRIVATE LIMITED",
"KAMLA EYE FOUNDATION PRIVATE LIMITED",
"KAMLA HOMES & LIFESTYLES PRIVATE LIMITED",
"KAMLA HOSPITAL",
"KAMLA KRISHNA FOREX PRIVATE LIMITED",
"KAMLA LIFESCIENCES LIMITED",
"KAMLA NEHRU COLLEGE KORBA",
"KAMLA NEHRU HIGHER SECONDARY SCHOOL BORI",
"KAMLA NEHRU HOSPITAL",
"KAMLA NEHRU MAHAVIDYALAYA",
"KAMLA NEHRU PUBLIC SCHOOL",
"KAMLA NUTRITION PROCESSING PRIVATE LIMITED[",
"KAMLA OLEO PRIVATE LIMITED",
"KAMLA ORGANICS PRIVATE LIMITED",
"KAMLA PACKAGING PRODUCTS PRIVATE LIMITED",
"KAMLA RAHEJA VIDYANIDHI INSTITUTE FOR ARCHITECTURE AND ENVIRONMENTAL STUDIES",
"KAMLA TESIO DIALS LIMITED",
"KAMLA TYPE MACHINES PRIVATE LIMITED",
"KAMLADEVI INFRASTRUCTURES PRIVATE LIMITED",
"KAMLADITYYA CONSTRUCTION PRIVATE LIMITED",
"KAMLAKAR EDUCATION TRUST‚ÄôS COSMOS HIGH SCHOOL",
"KAMLANG SAW AND VENEER MILLS PVT LTD",
"KAMLAPAT MEMORIAL HOSPITAL",
"KAMLAS MART PRIVATE LIMITED",
"KAMLASANA IMPEX PRIVATE LIMITED",
"KAMLASON TRADELINK PRIVATE LIMITED",
"KAMLAWATI DISPLAY PRIVATE LIMITED",
"KAMLAX POLYTEX PRIVATE LIMITED",
"KAMLESH ELECTRICAL INDUSTRIES PRIVATE LIMITED",
"KAMLESH FOODS PRIVATE LIMITED",
"KAMLESH JEWELLERS PRIVATE LIMITED",
"KAMLESH KUMAR SINGH ENGINEERS PRIVATE LIMITED",
"KAMLESH MOTO & SONS PRIVATE LIMITED",
"KAMLESH PLASTICS PRIVATE LIMITED",
"KAMLESH TEA ESTATE PRIVATE LIMITED",
"KAMLESH TRANSPORT PRIVATE LIMITED",
"KAMLESHKUMAR BALUBHAI LAD",
"KAMLESHWAR AND NISHAN CONSTRUCTION PRIVATE LIMITED",
"KAMNA MEDICAL CENTRE PRIVATE LIMITED",
"KAMNA TOBACCO PRIVATE LIMITED",
"KAMNATH INFRASTRUCTURE PRIVATE LIMITED",
"KAMNATH PRIVATE LIMITED",
"KAMOD COMMERCIAL AND FINANCE PVT. LTD",
"KAMP INFOTECH PRIVATE LIMITED",
"KAMP STAMPING PRIVATE LIMITED",
"KAMPARROW WOODTEK PRIVATE LIMITED",
"KAMPER CONCAST LIMITED",
"KAMPF MACHINERY INDIA PRIVATE LIMITED",
"KAMPFER AUTOMATION PRIVATE LIMITED",
"KAMPIBELL BATHWARE PRIVATE LIMITED",
"KAMPRA AUTO PRIVATE LIMITED",
"KAMPS HOLIDAYS",
"KAMPTEC INNOVATIVE TECHNOLOGIES PRIVATE LIMITED",
"KAMRA BUILDTECH PRIVATE LIMITED",
"KAMRA ECO FAB PRIVATE LIMITED",
"KAMRA INTERIO PRIVATE LIMITED",
"KAMRA METALS AND PROFILES PRIVATE LIMITED",
"KAMRAN LIVE STOCK AND REAL ESTATE PRIVATE LIMITED",
"KAMRAN POWER CONTROLS PRIVATE LIMITED",
"KAMREJ TALUKA PANCHAYAT",
"KAMRON HEALTHCARE PRIVATE LIMITED",
"KAMRON LABORATORIES",
"KAMROOP INFRABUILD PRIVATE LIMITED",
"KAMRUP CEMENT CENTRE PRIVATE LIMITED",
"KAMRUP ENTERPRISES LIMITED",
"KAMRUP MACHINERY STORES PRIVATE LIMITED",
"KAMRUP WAREHOUSING PRIVATE LIMITED",
"KAMRUPA THANDA GHAR PRIVATE LIMITED",
"KAMSA STEEL PRIVATE LIMITED",
"KAMSHET DAIRY INDUSTRIES PVT LTD",
"KAMSON HEALTH CARE PRIVATE LIMITED",
"KAMSONS CHEMICALS PRIVATE LIMITED",
"KAMSONS POLYMERS PRIVATE LIMITED",
"KAMSRI PRINTING AND PACKAGING PRIVATE LIMITED",
"KAMTANATH FOOD PRODUCT PRIVATE LIMITED",
"KAMTHI MOTORS LLP",
"KAMTRESS AUTOMATION SYSTEMS PRIVATE LIMITED",
"KAMTRON SYSTEMS PRIVATE LIMITED",
"KAMTRONICS TECHNOLOGY PRIVATE LIMITED",
"KAMUTHI RENEWABLE ENERGY LIMITED",
"KAMUTHI SOLAR POWER LIMITED",
"KAM-VIT CHEMICALS PRIVATE LIMITED",
"KAMYA ENGINEERS AND CONSULTANTS PRIVATE LIMITED",
"KAMYA HASTAKALA ARTS & CRAFTS PRIVATE LIMITED",
"KAMYA SHIPPING PRIVATE LIMITED",
"KAMYA TEXTILE MILLS PRIVATE LIMITED",
"KAN ALLOYS PRIVATE LIMITED",
"KAN AND KRISHME LIMITED LIABILITY PARTNE",
"KAN BIOSYS PRIVATE LIMITED",
"KAN CARBON PRIVATE LIMITED",
"KAN INDIA REALTORS PRIVATE LIMITED",
"KAN PHYTOCHEMICALS PRIVATE LIMITED",
"KAN TECH SOLUTIONS PRIVATE LIMITED",
"KAN VICTUAL PRIVATE LIMITED",
"KANA FAB MANUFACTURING PRIVATE LIMITED",
"KANA GENS",
"KANABAR FOAM PRIVATE LIMITED",
"KANACHUR INSTITUTE OF MEDICAL SCIENCE",
"KANACHUR ISLAMIC EDUCATION TRUST",
"KANAD CHEMICALS PRIVATE LIMITED",
"KANAD LABS PRIVATE LIMITED",
"KANAD LIFE SCIENCES PRIVATE LIMITED",
"KANADIA FYR FYTER PRIVATE LIMITED",
"KANADOO LLP",
"KANAECH INDIA PRIVATE LIMITED",
"KANAHAIYALAL BUILDCON PRIVATE LIMITED",
"KANAHIYA OVERSEAS PRIVATE LIMITED",
"KANAI TECHNOLOGY PARKS PRIVATE LIMITED",
"KANAIYA EXPORTS PRIVATE LIMITED",
"KANAK CATTLE FEEDS PRIVATE LIMITED",
"KANAK COTTON AGRO INDUSTRIES PRIVATE LIMITED",
"KANAK DISTRIBUTION INDIA PRIVATE LIMITED",
"KANAK DURGA AGRO PRODUCTS PRIVATE LIMITED",
"KANAK EXIM PRIVATE LIMITED",
"KANAK MARMO GRANI PRIVATE LIMITED",
"KANAK OVERSEAS PRIVATE LIMITED",
"KANAK PIPE INDUSTRIES PRIVATE LIMITED",
"KANAK PLYWOOD PRIVATE LIMITED",
"KANAK PROJECTS LTD",
"KANAK RASIK CONSUMER PRODUCTS PRIVATE LIMITED",
"KANAK RATNA WOVEN SACK PRIVATE LIMITED",
"KANAK RENEWABLES LIMITED",
"KANAK RESOURCES MANAGEMENT PRIVATE LIMITED",
"KANAK SILK MILLS PVT LTD",
"KANAK TRADE-LINK PRIVATE LIMITED",
"KANAK TRADERS LTD",
"KANAK TURNKEY PROJECTS PRIVATE LIMITED",
"KANAK VINIMAY PRIVATE LIMITED",
"KANAKA FOOD MANAGEMENT SERVICES PRIVATE LIMITED",
"KANAKA MAHALAKSHMI RICE INDUSTRIES",
"KANAKA MANAGEMENT SERVICES PRIVATE LIMITED",
"KANAKA POLYPACK PRIVATE LIMITED",
"KANAKA SOFTWARE CONSULTING PRIVATE LIMITED",
"KANAKADURGA AGRO OIL PRODUCTS PRIVATE LIMITED",
"KANAKADURGA CHIT FUNDS PRIVATE LIMITED",
"KANAKADURGA FINANCE LIMITED",
"KANAKADURGA FOODS PVT LTD",
"KANAKADURGA POULTRY FARM",
"KANAKADURGA TOWNSHIPS PRIVATE LIMITED",
"KANAKAVALLI RETAIL VENTURESS PRIVATE LIMITED",
"KANAKBIHARI CLOTHS PRIVATE LIMITED",
"KANAKDHAM AGRI FOODS PRIVATE LIMITED",
"KANAKDHAM FOODS PRIVATE LIMITED",
"KANAKDHARA MINING AND MINERALS PVT. LTD.",
"KANAKDHARA TRADERS PRIVATE LIMITED",
"KANAKDHARA WIRES PRIVATE LIMITED",
"KANAKESA THEVAR MEMORIAL HOSPITAL",
"KANAKGOLD INDUSTRIES PRIVATE LIMITED",
"KANAKIA FUTURE REALTY PRIVATE LIMITED",
"KANAKIA GRUHNIRMAN PRIVATE LIMITED",
"KANAKIA HOTELS & RESORTS PRIVATE LIMITED",
"KANAKIA RESIDENTIAL PRIVATE LIMITED",
"KANAKIA SPACES PRIVATE LIMITED",
"KANAKIA SPACES REALTY PRIVATE LIMITED",
"KANAKMARI FREE PRIMARY SCHOOL",
"KANAKNANDANI TRADERS PRIVATE LIMITED",
"KANAKRAJ JEWELLERS PRIVATE LIMITED",
"KANAKRATNA EXIM PRIVATE LIMITED",
"KANAKRATNA JEWELLERY PRIVATE LIMITED",
"KANAKSHREE FABRICS PRIVATE LIMITED",
"KANAL AUTOMOBILES PRIVATE LIMITED",
"KANAL AUTOMOTIVES PRIVATE LIMITED",
"KANALYSIS CONSULTANT PRIVATE LIMITED",
"KANAM LATEX INDUSTRIES PVT LTD",
"KANAN DEVAN HILLS PLANTATIONS COMPANY PRIVATE LIMITED",
"KANAN ELECTRICALS PRIVATE LIMITED",
"KANAN GRAPHICS PRIVATE LIMITED",
"KANAN INTERNATIONAL",
"KANAN INTERNATIONAL PRIVATE LIMITED",
"KANAN KNITWEAR",
"KANAN PLASTIC PRODUCTS PRIVATE LIMITED",
"KANAN POLY-CHEM PRIVATE LIMITED",
"KANAN SEEDS PRIVATE LIMITED",
"KANANI FLOTEX PRIVATE LIMITED",
"KANANI INDUSTRIES LIMITED",
"KANANI POLYFAB PRIVATE LIMITED",
"KANANI TEXTILES PRIVATE LIMITED",
"KANAN-KUNJ HOTELS AND RESORTS PRIVATE LIMITED",
"KANARA WOOD AND PLYWOOD INDUSTRIES LIMITED",
"KANARI NUTRITION PRIVATE LIMITED",
"KANARK ENTERPRISE PRIVATE LIMITED",
"KANASE AUTO WHEELS PRIVATE LIMITED",
"KANASE AUTO WORLD PRIVATE LIMITED",
"KANASSURE CONSULTANCY SERVICES PRIVATE LIMITED",
"KANASU COMPUTERS AND ACCESSORIES PRIVATE LIMITED",
"KANATE HOSPITALS PVT LTD",
"KANATH ENGINEERING PRIVATE LIMITED",
"KANAV AGRO INDUSTRIES PRIVATE LIMITED",
"KANAV CAPITAL ADVISORS PRIVATE LIMITED",
"KANAV ENTERPRISES PRIVATE LIMITED",
"KANAV HEALTHCARE PRIVATE LIMITED",
"KANAV MOTORS PRIVATE LIMITED",
"KANAV NUTRACARE PRIVATE LIMITED",
"KANAV RETAIL SOLUTIONS PRIVATE LIMITED",
"KANAW SEEDS PRIVATE LIMITED",
"KANAZAMUMA INDUSTRIES PRIVATE LIMITED",
"KANBAN INFOSYSTEM PRIVATE LIMITED",
"KANBE WATER TECH PRIVATE LIMITED",
"KANCARA RESOURCES PRIVATE LIMITED",
"KANCHAN ADDCHEM PRIVATE LIMITED",
"KANCHAN AGRO PRODUCTS PVT. LTD.",
"KANCHAN AUTO PRIVATE LIMITED",
"KANCHAN CERA COAT PRIVATE LIMITED",
"KANCHAN CLEARING AGENCY PRIVATE LIMITED",
"KANCHAN CREATIONS LIMITED",
"KANCHAN EXPORTS (INDIA) PRIVATE LIMITED",
"KANCHAN FASHION PRIVATE LIMITED",
"KANCHAN FILMS P LTD",
"KANCHAN GANGA SEED CO PRIVATE LIMITED",
"KANCHAN GOLDSIL METALS PRIVATE LIMITED",
"KANCHAN HYDRAULICS PRIVATE LIMITED",
"KANCHAN INDIA LIMITED",
"KANCHAN ISPAT (INDIA) PRIVATE LIMITED",
"KANCHAN JANGA INTEGRATED INFRASTRUCTURE DEVELOPMENT PRIVATE LIMITED",
"KANCHAN MARMO GRANI PRIVATE LIMITED",
"KANCHAN MEDICARE & RESEARCH CENTRE PRIVATE LIMITED",
"KANCHAN METALS PRIVATE LIMITED",
"KANCHAN METALS PVT LTD",
"KANCHAN OIL INDUSTRIES LIMITED",
"KANCHAN PHARMA PRIVATE LIMITED",
"KANCHAN PLASTICS PRIVATE LIMITED",
"KANCHAN POWER SYSTEM PRIVATE LIMITED",
"KANCHAN PRECISIONS PVT LTD",
"KANCHAN PRINTING PRESS PRIVATE LIMITED",
"KANCHAN PROJECTS PRIVATE LIMITED",
"KANCHAN RAIMALANI REALTY PRIVATE LIMITED",
"KANCHAN SYNTEX PRIVATE LIMITED",
"KANCHAN TELE INFRA-ENGINEERS PRIVATE LIMITED",
"KANCHAN VANIJYA PVT LTD",
"KANCHANA AUTOMOBILES PRIVATE LIMITED",
"KANCHANA MOTORS PRIVATE LIMITED",
"KANCHANI FARMER PRODUCER COMPANY LIMITED",
"KANCHANJANGA MEDIPHARMA PRIVATE LIMITED",
"KANCHANJANGA TEA & HORTICULTURE PRIVATE LIMITED",
"KANCHANJUNGA POWER COMPANY PRIVATE LIMITED",
"KANCHANJUNGHA RICE MILL PRIVATE LIMITED",
"KANCHANJYOTI TRANSPORTING AND SUPPLY PRIVATE LIMITED",
"KANCHANSOBHA DEBT RESOLUTION ADVISORS PRIVATE LIMITED",
"KANCHANSOBHA FINANCE PRIVATE LIMITED",
"KANCHARLA & GIRIDHARI HOMES PRIVATE LIMITED",
"KANCHAVA ENTERPRISE",
"KANCHEM PHARMACEUTICALS PRIVATE LIMITED",
"KANCHENJUNGA IMPEX PRIVATE LIMITED",
"KANCHENJUNGA SERVICES PRIVATE LIMITED",
"KANCHERLA MEDICAL SERVICES PRIVATE LIMITED",
"KANCHESHWAR SUGAR LIMITED",
"KANCHI KAMAKOTI CHILDS TRUST HOSPITAL",
"KANCHI KARPOORAM LIMITED",
"KANCHI MINING PROJECTS PRIVATE LIMITED",
"KANCHI PALLAVAN ENGINEERING COLLEGE",
"KANCHI RESORTS PRIVATE LIMITED",
"KANCHRAPARA COLLEGE",
"KANCHRAPARA COLLEGE KANCHRAPARA 24 PARGA",
"KANCO ENTERPRISES LIMITED",
"KANCO MARINE SERVICES PRIVATE LIMITED",
"KANCO TEA & INDUSTRIES LIMITED",
"KANCO VENTURES PRIVATE LIMITED",
"KANCOR INGREDIENTS LIMITED",
"KANDA AUTO PRIVATE LIMITED",
"KANDA EDIBLE OIL PRIVATE LIMITED",
"KANDAGIRI SPINNING MILLS LIMITED",
"KANDAKATLA ESTATES PRIVATE LIMITED",
"KANDALA DISTRIBUTORS",
"KANDAMKULATHI EXPORTS PRIVATE LIMITED",
"KANDAN ENERGY PRIVATE LIMITED",
"KANDAN MUTUAL BENEFIT SASWATHA NIDHI LIMITED",
"KANDAR AGRO FARMERS PRODUCER COMPANY LIMITED",
"KANDARP DIGI SMART BPO LIMITED",
"KANDARP MANAGEMENT SERVICES PRIVATE LIMITED",
"KANDARP TRADELINKS AND SERVICES (CHANDIGARH) PRIVATE LIMITED",
"KANDARP TRADELINKS AND SERVICES (DELHI) PRIVATE LIMITED",
"KANDARP TRADELINKS AND SERVICES PRIVATE LIMITED",
"KANDASWAMI KANDAR‚ÄôS COLLEGE",
"KANDASWAMY NAIDU COLLEGE",
"KANDELA INNOVATIONS PRIVATE LIMITED",
"KANDG PACKAGING PRIVATE LIMITED",
"KANDHAIAN FEEDS",
"KANDHAN INFRA PRIVATE LIMITED",
"KANDHAN KNITSS",
"KANDHAR COTSPIN PRIVATE LIMITED",
"KANDHARI AUTOMOBILES PRIVATE LIMITED",
"KANDHARI BEVERAGES PRIVATE LIMITED",
"KANDHARI HOTELS PRIVATE LIMITED",
"KANDHARI PHOTO ELECTRONICS PRIVATE LIMITED",
"KANDHARI TRAVELS PRIVATE LIMITED",
"KANDI ELECTRICAL SOLUTIONS PRIVATE LIMITED",
"KANDI ENGINEERING PRIVATE LIMTED",
"KANDIONERS SALES PRIVATE LIMITED",
"KANDISA EDUCATION SOCIETY",
"KANDISA ENGINEERING PRIVATE LIMITED",
"KANDISA TECHNOLOGIES PRIVATE LIMITED",
"KANDIVALI CABLE AND COMMUNICATION PRIVATE LIMITED",
"KANDLA AGRO & CHEMICALS PRIVATE LIMITED",
"KANDLA EXIM PRIVATE LIMITED",
"KANDLA INTERNATIONAL CONTAINER TERMINAL PRIVATE LIMITED",
"KANDLA ISPAT PRIVATE LIMITED",
"KANDLA MOTORS PRIVATE LIMITED",
"KANDLA PACKAGING PRIVATE LIMITED",
"KANDLA POLYPLAST (INDIA) PRIVATE LIMITED",
"KANDLA PROJECTS PRIVATE LIMITED",
"KANDLA SAGARMALA TRANSHIP PRIVATE LIMITED",
"KANDLA WAREHOUSE AND LOGISTICS PRIVATE LIMITED",
"KANDO ENTERPRISE PRIVATE LIMITED",
"KANDOI ESTATES PRIVATE LIMITED",
"KANDOI FABRICS PRIVATE. LIMITED",
"KANDOI INDUSTRIES INDIA PRIVATE LIMITED",
"KANDOI METAL POWDERS MANUFACTURING CO PVT LTD",
"KANDOI ROADLINES PRIVATE LIMITED",
"KANDOI TECHFAB PRIVATE LIMITED",
"KANDOR ACCOUNTING SERVICES OPC PRIVATE LIMITED",
"KANDORNA SIM SHALA NO 1",
"KANDPAL UDYOG PRIVATE LIMITED",
"KANDRU EYE WEAR PRIVATE LIMITED",
"KANDUI INDUSTRIES PRIVATE LIMITED",
"KANDUKURI INDUSTRIES PRIVATE LIMITED",
"KANDUKURI LIFESTYLE PRIVATE LIMITED",
"KANEFUSA INDIA PRIVATE LIMITED",
"KANEGRADE FLAVOURS & INGREDIENTS PRIVATE LIMITED",
"KANEHIRO YANTRA PRIVATE LIMITED",
"KANEKA INDIA PRIVATE LIMITED",
"KANEKAR CONSULTING ENGINEERS PRIVATE LIMITED",
"KANEMATSU INDIA PRIVATE LIMITED",
"KANEN LOGISTICS SERVICES PRIVATE LIMITED",
"KANERIA BUILDING SOLUTIONS PRIVATE LIMITED",
"KANERIA PLAST PRIVATE LIMITED",
"KANEX FIRE SOLUTIONS LIMITED",
"KANGARO INDIA PRIVATE LIMITED",
"KANGARO INDUSTRIES LIMITED",
"KANGARO METAPLAST PRIVATE LIMITED",
"KANGAROO BUILDCON PRIVATE LIMITED",
"KANGAROO CABS PRIVATE LIMITED",
"KANGAROO EXPORTS PRIVATE LIMITED",
"KANGAROO HYDRAULICS PRIVATE LIMITED",
"KANGAROO KIDS EDUCATION LIMITED",
"KANGAROO LEATHER PRIVATE LIMITED",
"KANGAROO LOGISTICS PRIVATE. LIMITED.",
"KANGAROO SHELTER PRIVATE LIMITED",
"KANGAROO STUDIES PRIVATE LIMITED",
"KANGARU POLYMERS PRIVATE LIMITED",
"KANGRA GLOBAL LOGISTICS PRIVATE LIMITED",
"KANGRA TALKIES PRIVATE LIMITED",
"KANHA CONFECTIONERS PRIVATE LIMITED",
"KANHA CONTRACTS PRIVATE LIMITED",
"KANHA DECALS PRIVATE LIMITED",
"KANHA DESIGNS PRIVATE LIMITED",
"KANHA DETERGENT PRIVATE LIMITED",
"KANHA ELECTRONICS",
"KANHA ENTERPRISES PRIVATE LIMITED",
"KANHA FLOUR MILLS PRIVATE LIMITED",
"KANHA FOAMS PRIVATE LIMITED",
"KANHA GRAIN PROCESS",
"KANHA HOTELS AND SPA PRIVATE LIMITED",
"KANHA INDUSTRIES LIMITED",
"KANHA MAKHAN PUBLIC SCHOOL",
"KANHA MARBLES PRIVATE LIMITED",
"KANHA MILK PRODUCTS PRIVATE LIMITED",
"KANHA MILK TESTING EQUIPMENTS PRIVATE LIMITED",
"KANHA MOTORS PRIVATE LIMITED",
"KANHA MULTI SPECIALITY HOSPITAL & RESEARCH CENTRE PRIVATE LIMITED",
"KANHA PRINTPACK PRIVATE LIMITED",
"KANHA PRODUCTS PRIVATE LIMITED",
"KANHA SHIPPING TRANSPORT AGENCY PRIVATE LIMITED",
"KANHA TESTING LABS PRIVATE LIMITED",
"KANHA TRADERS PRIVATE LIMITED",
"KANHA VANIJYA PVT LTD",
"KANHAA TYRES PRIVATE LIMITED",
"KANHAI FOODS LIMITED",
"KANHAI FOODS PRIVATE LIMITED",
"KANHAIYA AUTOCORP PRIVATE LIMITED",
"KANHAIYA BEVERAGES PRIVATE LIMITED",
"KANHAIYA CASTINGS PRIVATE LIMITED",
"KANHAIYA EXPRESS PRIVATE LIMITED",
"KANHAIYA HOTELS PRIVATE LIMITED",
"KANHAIYA JEE RICE MILL PRIVATE LIMITED",
"KANHAIYA LAL HANUMAN PRASAD TEXTILE PRIVATE LIMITED",
"KANHAIYA LAL TANDOOR PRIVATE LIMITED",
"KANHAIYA MERCHANDISE PRIVATE LIMITED",
"KANHAIYA NIRMAN P LTD",
"KANHAIYA PROCESSORS PRIVATE LIMITED",
"KANHAIYA REALTORS PRIVATE LIMITED",
"KANHAIYA RESIDENCY PRIVATE LIMITED",
"KANHAIYA SOLVEX PRIVATE LIMITED",
"KANHAIYA TEXTILE PRIVATE LIMITED",
"KANHAIYA TIMBER INDUSTRIES PRIVATE LIMITED",
"KANHAJI DISTRIBUTORS PRIVATE LIMITED",
"KANHAN PACKAGES PRIVATE LIMITED",
"KANHANGAD RUBBERS LIMITED",
"KANHASHYAM INFRA ESTATE PRIVATE LIMITED",
"KANHASOFT",
"KANHASOFT CUSTOM BUSINESS SOLUTIONS PROVIDER",
"KANHATECH SOLUTIONS LIMITED",
"KANHAV CREATION PRIVATE LIMITED",
"KANHAV INDUSTRIES PRIVATE LIMITED",
"KANHEYA YARNS PRIVATE LIMITED",
"KANHHA CABLES PRIVATE LIMITED",
"KANI DEPARTMENTAL STORES PRIVATE LIMITED",
"KANI SOLUTIONS INDIA PRIVATE LIMITED",
"KANICA METALS PRIVATE LIMITED",
"KANICHAI HOTELS PVT LTD",
"KANIKA BUILDCON PRIVATE LIMITED",
"KANIKA FURNITURE PRIVATE LIMITED",
"KANIKA IMPEX PRIVATE LIMITED",
"KANIKA INFRACON LLP",
"KANIKA INVESTMENT LIMITED TAMIL NADU",
"KANIKA ISPAT PRIVATE LIMITED",
"KANIKA SILVER PRIVATE LIMITED",
"KANIKA WORLDWIDE PRIVATE LIMITED",
"KANIMAM IMPEX PRIVATE LIMITED",
"KANIN COMMERCE PRIVATE LIMITED",
"KANIN INDIA",
"KANIN INDIA LIMITED",
"KANIN INDUSTRIES PRIVATE LIMITED",
"KANINI SOFTWARE SOLUTIONS INDIA PRIVATE LIMITED",
"KANISH MOTORS PRIVATE LIMITED",
"KANISHA PETROCHEM PRIVATE LIMITED",
"KANISHK ALUMINIUM INDIA PRIVATE LIMITED",
"KANISHK AUTOMATION PRIVATE LIMITED",
"KANISHK AUTOMOBILES PRIVATE LIMITED",
"KANISHK METAL RECYCLING PRIVATE LIMITED",
"KANISHK METALLOYS",
"KANISHK REALTY PRIVATE LIMITED",
"KANISHK STEEL INDUSTRIES LIMITED",
"KANISHKA CARBONS PRIVATE LIMITED",
"KANISHKA ENERGY CARE PRIVATE LIMITED",
"KANISHKA PRINTS PRIVATE LIMITED",
"KANISHKAA FURNISHING PRIVATE LIMITED",
"KANISHKADHURA RESOURCES PRIVATE LIMITED",
"KANISHQ AGENCIES PRIVATE LIMITED",
"KANIX INFOTECH PRIVATE LIMITED",
"KANIYEL PRIMARY SCHOOL",
"KANJ PRODUCTS PRIVATE LIMITED",
"KANJALOCHANA FINSERVE PRIVATE LIMITED",
"KANJAM CHEMICALS PRIVATE LIMITED",
"KANJI DEVJI OIL MILL PRIVATE LIMITED",
"KANJI FOREX PRIVATE LIMITED",
"KANJI SHAVJI PAREKH (CALCUTTA) PVT LTD",
"KANJIMULL LACHHMAN DASS JEWELLERS PRIVATE LIMITED",
"KANJIRAPPALLY AGRICULTURAL AND DAIRY PRODUCER COMPANY LIMITED",
"KANJWANI ACCOUNT CENTER",
"KANKAI PIPES & FITTINGS PRIVATE LIMITED",
"KANKALE CONSTRUCTIONS PRIVATE LIMITED",
"KANKALI ASSOCIATES PRIVATE LIMITED",
"KANKARIA AUTOMOBILES PRIVATE LIMITED",
"KANKARIYA IMPEX PVT LTD",
"KANKARIYA TEXTILE INDUSTRIES PRIVATE LIMITED",
"KANKATALA TEXTILES PRIVATE LIMITED",
"KANKEI RELATIONSHIP MARKETING SERVICES PRIVATE LIMITED",
"KANKER ROADWAYS PRIVATE LIMITED",
"KANKESH EXIMS PRIVATE LIMITED",
"KANKESHWARI SECURITIES PRIVATE LIMITED",
"KANKHU SAHNI CHITS PRIVATE LIMITED",
"KANKI MOTORS PRIVATE LIMITED",
"KANKNARRAH CO LTD",
"KANKNARRAH JUTE PRIVATE LIMITED",
"KANKRIYA ENTERPRISES PRIVATE LIMITED",
"KANKSHA MANUFACTURING LLP",
"KANKURGACHI LIQUOR MART PRIVATE LIMITED",
"KANKYO CLEANTECH (INDIA) PRIVATE LIMITED",
"KANLIFE INDIA PRIVATE LIMITED",
"KANMALAI TECHNOLOGIES PRIVATE LIMITED",
"KANMECH PRIVATE LIMITED",
"KANNA ENGINEERS AND DRAFTERS PRIVATE LIMITED",
"KANNADA KOOTA EDUCATION SOCIETY",
"KANNADA PRABHA PUBLICATIONS LIMITED",
"KANNAI STORAGE SOLUTIONS INDIA PRIVATE LIMITED",
"KANNAMMAL AGRO INDUSTRIES PRIVATE LIMITED",
"KANNAN BOREWELLS PRIVATE LIMITED",
"KANNAN ENTERPRISES BUILDERS AND CONTRACTORS",
"KANNAN FASHION PRIVATE LIMITED",
"KANNAN METALLURGICALS PRIVATE LIMITED",
"KANNANGAZATH FOODS PRIVATE LIMITED",
"KANNAPPAN ALLOY AND STEEL COMPANY PRIVATE LIMITED",
"KANNAPPAN IRON AND STEEL COMPANY PRIVATE LIMITED",
"KANNAPPAN SAAI RECYCLERS PRIVATE LIMITED",
"KANNATTU FINANCE NIDHI LIMITED",
"KANNELITE HOTELS PRIVATE LIMITED",
"KANNIKKATT TECHNOCRAFT PRIVATE LIMITED",
"KANNIMAR TRANSPORTS PRIVATE LIMITED",
"KANNIYAKUMARI PORT LIMITED",
"KANNU KI CHAI PRIVATE LIMITED",
"KANNU TEX PRIVATE LIMITED",
"KANNUR INTERNATIONAL AIRPORT LIMITED",
"KANNUR LULU GOLD LIMITED",
"KANODA ENERGY SYSTEMS PRIVATE LIMITED",
"KANODIA CEMENT LIMITED",
"KANODIA COLD STORAGE PRIVATE LIMITED",
"KANODIA FABRICS PRIVATE LIMITED",
"KANODIA FINANCE PVT.LTD.",
"KANODIA GLOBAL PRIVATE LIMITED",
"KANODIA HOSPITAL",
"KANODIA INFRATECH LIMITED",
"KANODIA INTERCONTINENETAL PRIVATE LIMITED",
"KANODIA INTERNATIONAL PRIVATE LIMITED",
"KANODIA INVESTMENT ADVISORY PRIVATE LIMITED",
"KANODIA INVESTMENTS PRIVATE LIMITED",
"KANODIA PACKAGING PRIVATE LIMITED",
"KANODIA SALT COMPANY PRIVATE LIMITED",
"KANODIA SILK MILLS PRIVATE LIMITED",
"KANODIA SPANDAN HOSPITAL PRIVATE LIMITED",
"KANODIA STEEL ALLOYS PRIVATE LIMITED",
"KANODIA STOCK BROKING PVT.LTD.",
"KANODIA SYNTEX PRIVATE LIMITED",
"KANODIA TECHNOPLAST LIMITED",
"KANODIA TRADERS PRIVATE LIMITED",
"KANODIA WORLD PRIVATE LIMITED",
"KANOE SOFTWARES LIMITED",
"KANOHAR ELECTRICALS LIMITED",
"KANOHAR LAL MAHILA MAHAVIDYALAY",
"KANOI ESTATES PVT LTD",
"KANOI PLANTATIONS PVT LTD",
"KANOI STEELS PRIVATE LIMITED",
"KANOI TEA PVT LTD",
"KANOKA VILLAGE RESORT PRIVATE LIMITED",
"KANOO SHIPPING INDIA PRIVATE LIMITED",
"KANOOS BUSINESS INDIA PRIVATE LIMITED",
"KANOPY TECHNO SOLUTIONS PRIVATE LIMITED",
"KANORIA CHEMBOND PRIVATE LIMITED",
"KANORIA CHEMICALS & INDUSTRIES LTD",
"KANORIA SECURITIES & FINANCIAL SERVICES LIMITED",
"KANORIA SUGAR AND GENERAL MANUFACTURING COMPANY LIMITED",
"KANOTA CAMP PRIVATE LIMITED",
"KANOTA HOUSE VYAPAR MANADAL",
"KANOTA RESORTS PRIVATE LIMITED",
"KANOUJIA CITY REAL ESTATE PRIVATE LIMITED",
"KANPEKI WORKFORCE PRIVATE LIMITED",
"KANPUR AGRA TRANSPORT PRIVATE LIMITED",
"KANPUR COIR PRODUCTS PRIVATE LIMITED",
"KANPUR COOLING SERVICES PRIVATE LIMITED",
"KANPUR DEVELOPMENT AUTHORITY KANPUR",
"KANPUR EDIBLES PRIVATE LIMITED",
"KANPUR ELECTRICITY SUPPLY COMPANY LIMITED",
"KANPUR FERTILIZERS & CHEMICALS LIMITED",
"KANPUR FLOWERCYCLING PRIVATE LIMITED",
"KANPUR INSTITUTE OF TECHNOLOGY",
"KANPUR LOGISTICS PARK PRIVATE LIMITED",
"KANPUR MEDICAL CENTRE PRIVATE LIMITED",
"KANPUR MINERAL AND CHEMICAL ENTERPRISE PRIVATE LIMITED",
"KANPUR ORGANICS PRIVATE LIMITED",
"KANPUR PACKAGERS PRIVATE LIMITED",
"KANPUR PLASTIPACK LIMITED",
"KANPUR POLYPLAST PRIVATE LIMITED",
"KANPUR RIVER MANAGEMENT PRIVATE LIMITED",
"KANPUR SCALECARE PRIVATE LIMITED",
"KANPUR SCANS PRIVATE LIMITED",
"KANPUR SHIFTERS PRIVATE LIMITED",
"KANPUR TEXEL PRIVATE LIMITED",
"KANPUR TRAUMA AND ORTHO CENTRE PRIVATE LIMITED",
"KANPUR WOVEN SALES PRIVATE LIMITED",
"KANRAD HOUSEWARE PRIVATE LIMITED",
"KANRAD TECHNOLOGIES INDIA PRIVATE LIMITED",
"KANSAI NEROLAC PAINTS LIMITED",
"KANSAL CHEM PACK PRIVATE LIMITED",
"KANSAL COLOUR ROOFINGS INDIA PRIVATE LIMITED",
"KANSAL ENGINEERING",
"KANSAL ESTATE PRIVATE LIMITED",
"KANSAL FINCAP LIMITED",
"KANSAL IMPEX PRIVATE LIMITED",
"KANSAL INDUSTRIES",
"KANSAL INFRAPLANNER PRIVATE LIMITED",
"KANSAL MECHANICAL INDUSTRIES PRIVATE LIMITED",
"KANSAL MEDICAL SYSTEMS PRIVATE LIMITED",
"KANSAL METAL PRIVATE LIMITED",
"KANSAL OVERSEAS",
"KANSAL PETROCHEM PRIVATE LIMITED",
"KANSAL PUMPS PRIVATE LIMITED",
"KANSAL SONS STEELS LIMITED",
"KANSAL STEEL SCRAPS PRIVATE LIMITED",
"KANSARA BEARINGS LIMITED",
"KANSARA ENGINEERS PRIVATE LIMITED",
"KANSARA FORGE AND WIRES PRIVATE LIMITED",
"KANSARA MODLER LTD.",
"KANSARA POPATLAL TIBHOVANDAS METAL PRIVATE LIMITED",
"KANSAS MANUFACTURING PRIVATE LIMITED",
"KANSAS OVERSEAS CAREERS PRIVATE LIMITED",
"KANSERA HOTELS PRIVATE LIMITED",
"KANSHAL GROCER PRIVATE LIMITED",
"KANSHI RAM FOODS PRIVATE LIMITED",
"KANSHI RAM PAWAN KUMAR MARKETING PRIVATE LIMITED",
"KANSI TECHNOVATION PRIVATE LIMITED",
"KANSIL ALLOYS PRIVATE LIMITED",
"KANSO INDIA PRIVATE LIMITED",
"KANSOFT SOLUTIONS PRIVATE LIMITED",
"KANSONS FOODS PRIVATE LIMITED",
"KANSONS INDUSTRIES LIMITED",
"KANSONS OVERSEAS LIMITED",
"KANSRA EXPORTS PRIVATE LIMITED",
"KANSTAR RAIL PRIVATE LIMITED",
"KANSTER MOVERS PRIVATE LIMITED",
"KANSUEE INDUSTRIES PRIVATE LIMITED",
"KANT & CO LTD",
"KANT CYLINDERS PRIVATE LIMITED",
"KANT DRUGS PRIVATE LIMITED",
"KANT FASTENERS PRIVATE LIMITED",
"KANT MULTISPECIALITY HOSPITAL PRIVATE LIMITED",
"KANTA CHLORIDES PRIVATE LIMITED",
"KANTA ELECTRICALS INDIA LIMITED",
"KANTA ENTERPRISES PRIVATE LIMITED",
"KANTA FABRICS PVT. LTD.",
"KANTA FLEX INDIA PRIVATE LIMITED",
"KANTA POLYTEX (INDIA) PRIVATE LIMITED",
"KANTA RUBBER PRIVATE LIMITED",
"KANTAI NETRALAYA",
"KANTAMARI CHURAMONI HIGH SCHOOL HS",
"KANTAR",
"KANTAR GDC INDIA PRIVATE LIMITED",
"KANTAWALA ENGINEERS PRIVATE LIMITED",
"KANTE BUSINESS AND CONSULTANCY SERVICES PRIVATE LIMITED",
"KANTER STEEL (INDIA) PRIVATE LIMITED",
"KANTHA HEALTHCARE PRIVATE LIMITED",
"KANTHALBERIA HARIHAR HIGH SCHOOL",
"KANTHI PRECISIONS PRIVATE LIMITED",
"KAN-THT INDIA PRIVATE LIMITED",
"KANTHWAL SERVICES",
"KANTI BEVERAGES PRIVATE LIMITED",
"KANTI BROTHERS OILS PRIVATE LIMITED (PART IX)",
"KANTI BUILDERS PRIVATE LIMITED",
"KANTI CHIRAN CORPORATION PRIVATE LIMITED",
"KANTI FASHION FABS (INDIA) PRIVATE LIMITED",
"KANTI FLOOR FURNISHERS",
"KANTI INFRABUILD PRIVATE LIMITED",
"KANTI KAPOOR SARASWATI BALIKA VIDYA MANDIR BAREILLY",
"KANTI KAPUR PVT LTD",
"KANTI SHANTI INFRATECH PRIVATE LIMITED",
"KANTI THERMO EQUIP PRIVATE LIMITED",
"KANTIBHAI & SONS JEWELS PRIVATE LIMITED",
"KANTILAL MANILAL AND COMPANY PRIVATE LIMITED",
"KANTIPUDI AUTOMOBILES PRIVATE LIMITED",
"KANTIPUDI ENGINEERING COMPANY PRIVATE LIMITED",
"KANTIPUDI MOTORS INDIA LLP",
"KANTISHIVA ROLLER FLOUR MILL PRIVATE LIMITED",
"KANU KITCHEN KULTURE PRIVATE LIMITED",
"KANU MHARA FERROALLOYS PVT LTD",
"KANUNGA EXTRUSION PRIVATE LIMITED",
"KANUNGO ASSOCIATES PRIVATE LIMITED",
"KANUNGO FERROMET PRIVATE LIMITED",
"KANUNGO TEXTILES PRIVATE LIMITED",
"KANUPAT HIMGHAR PRIVATE LIMITED",
"KANUPRIYA TECHNOLOGY PRIVATE LIMITED",
"KANURA IRRIGATION SYSTEMS PRIVATE LIMITED",
"KANUSRII DESIGNS PRIVATE LIMITED",
"KANVA DIAGNOSTIC SERVICES PRIVATE LIMITED",
"KANVA FASHIONS LIMITED",
"KANVA PLASTICS PRIVATE LIMITED",
"KANVAR CONCOS DISTRIBUTION PRIVATE LIMITED",
"KANVAS CONSULTANCY SERVICES PRIVATE LIMITED",
"KANWAL DUROPARTS PVT LTD",
"KANWAL FOODS AND SPICES PRIVATE LIMITED",
"KANWAL PLASTIC HOUSE PRIVATE LIMITED",
"KANWAR ENTERPRISES P LIMITED",
"KANWAR INDIA PRIVATE LIMITED",
"KANWAR KRISHEN ASSOCIATES PRIVATE LIMITED",
"KANWAR SAIN BABU LAL TIMBERS PRIVATE LIMITED",
"KANWAR SONS INFRAARTS PRIVATE LIMITED",
"KANWARJI CONSTRUCTION CO",
"KANWHIZZ INFRA CORP0RATION INDIA LIMITED",
"KANYA HOMES PRIVATE LIMITED",
"KANYA MADHYAMIC VID KOREGAON",
"KANYA MOTORS PRIVATE LIMITED",
"KANYA PATHSHALA INTER COLLAGE",
"KANYA VIDYA MANDIR ABDULLAT",
"KANYA VIDYA MANDIR UCHGAON",
"KANYA VIDYALAYA ASTAN",
"KANYAKA PARAMESHWARI ENGINEERING LTD",
"KANYAKA PARAMESHWARI ENGINEERING PRIVATE LTD",
"KANYAKA PARAMESWARI OILS PRIVATE LIMITED",
"KANYAKUBJ NURSING COLLEGE",
"KANYAKUMARI POLYMERS PVT LTD",
"KANYAKUMARI SOFTECH PRIVATE LIMITED",
"KANYAKUMARI-ETTURAVATTAM TOLLWAY PRIVATE LIMITED",
"KANYSHQ SPECIALTIES (INDIA) PRIVATE LIMITED",
"KANZEN INSTITUTE ASIA PACIFIC PRIVATE LIMITED",
"KAOLIN INDIA PRIVATE LIMITED",
"KAOLIN TECHNIQUES PRIVATE LIMITED",
"KAP AUTOMOBILES PRIVATE LIMITED",
"KAP CALL CENTER PRIVATE LIMITED",
"KAP COMPUTER SOLUTIONS PRIVATE LIMITED",
"KAP CONES PRIVATE LIMITED",
"KAP GLOBAL FORWARDERS PRIVATE LIMITED",
"KAP INDIA PROJECTS AND CONSTRUCTIONS PRIVATE LIMITED",
"KAP PRESSTECH PRIVATE LIMITED",
"KAP SCAN AND DIAGNOSTIC CENTRE PVT LTD",
"KAP SILVER LEGION PRIVATE LIMITED",
"KAP SURGI-TRADE PRIVATE LIMITED",
"KAP VISWANATHAN MEDICAL COLL",
"KAPA IMPEX PRIVATE LIMITED",
"KAPA IT SERVICES PRIVATE LIMITED",
"KAPAAS HOME FURNISHING PRIVATE LIMITED",
"KAPACHI CLOTHING PRIVATE LIMITED",
"KAPADIA HEALTH CLUB PVT LTD",
"KAPADIA ICON PRIVATE LIMITED",
"KAPADIA MONEY CHANGERS PRIVATE LIMITED",
"KAPADIA REALTORS PVT. LTD",
"KAPADIA TRAVELS PRIVATE LIMITED",
"KAPAHI CONTRACTS PRIVATE LIMITED",
"KAPALESWAR PROJECTS PRIVATE LIMITED",
"KAPALIN INSURANCE BROKING PRIVATE LIMITED",
"KAPARDI ALCOBEV PRIVATE LIMITED",
"KAPAS TECHNO FABS PRIVATE LIMITED",
"KAPASI CHUNILAL DEEPCHAND VIVIDHLAKSHI VIDHYALAYA CHUDA",
"KAPBROS ENGINEERING INDUSTRIES LIMITED",
"KAPCI COATINGS INDIA PRIVATE LIMITED",
"KAPCO BANQUETS AND CATERING PRIVATE LIMITED",
"KAPCO ELECTRIC PRIVATE LIMITED",
"KAPCO INTERNATIONAL LIMITED",
"KAPCO MARKETING PRIVATE LIMITED",
"KAPCON PROJECTS PRIVATE LIMITED",
"KAPDATA INDIA (OPC) PRIVATE LIMITED",
"KAPEDOME ENTERPRISES LIMITED",
"KAPEESH FILAMENT PRIVATE LIMITED",
"KAPEESH MINESTONES PRIVATE LIMITED",
"KAPEESHWAR CHEMICALS PRIVATE LIMITED",
"KAPEESHWAR SUGARS & CHEMICALS LIMITED",
"KAPHAJA MODULAR FURNITURES PRIVATE LIMITED",
"KAPHS GLASS AND METAL PRODUCTS PRIVATE LIMITED",
"KAPI INTERNATIONAL PRIVATE LIMITED",
"KAPICO AUTO 1 INDIA PRIVATE LIMITED",
"KAPICO INDIA PRIVATE LIMITED",
"KAPICO KERALA RESORTS PRIVATE LIMITED",
"KAPIKA INDIA ENTERPRISES PRIVATE LIMITED",
"KAPIL AGRO FARM INDIA PRIVATE LIMITED",
"KAPIL ANAND AGRO PRIVATE LIMITED",
"KAPIL BUSINESS CENTER PRIVATE LIMITED",
"KAPIL CABLES PRIVATE LIMITED",
"KAPIL CHITS HYDERABAD PRIVATE LIMITED",
"KAPIL CHITS KAKATIYA PRIVATE LIMITED",
"KAPIL CHITS KOSTA PRIVATE LIMITED",
"KAPIL CHITS TELANGANA PRIVATE LIMITED",
"KAPIL CONSULTANCY SERVICES PRIVATE LIMITED",
"KAPIL COREPACKS PRIVATE LIMITED",
"KAPIL ENTERPRISES PRIVATE LIMITED",
"KAPIL EXPO-TRADES PRIVATE LIMITED",
"KAPIL EYE HOSPITAL PRIVATE LIMITED",
"KAPIL GEMS PRIVATE LIMITED",
"KAPIL GROUP MARKETING SERVICES PRIVATE LIMITED",
"KAPIL HEALTH CLUB PRIVATE LIMITED",
"KAPIL IT SOLUTIONS PRIVATE LIMITED",
"KAPIL MEDIAS PRIVATE LIMITED",
"KAPIL METAL PROCESSING INDUSTRIES PRIVATE LIMITED",
"KAPIL MINING RESOURCES PRIVATE LIMITED",
"KAPIL MOHAN AND ASSOCIATES HYDRO POWER PRIVATE LIMITED",
"KAPIL MOTORS PRIVATE LIMITED",
"KAPIL PROPERTY MANAGEMENT PRIVATE LIMITED",
"KAPIL PROTEINS PRIVATE LIMITED",
"KAPIL PULSES PRIVATE LIMITED",
"KAPIL SOLVEX PRIVATE LIMITED",
"KAPIL SPIRITS PRIVATE LIMITED",
"KAPILA AGROVET PRIVATE LIMITED",
"KAPILA ANIMAL HEALTHCARE PRIVATE LIMITED",
"KAPILA BREEDERS AND HATCHERIES PRIVATE LIMITED",
"KAPILA COLOURS PRIVATE LIMITED",
"KAPILA ELECTRONICS PRIVATE LIMITED",
"KAPILA KRISHI UDYOG LIMITED",
"KAPILA MANJUSHREE APPARELS PRIVATE LIMITED",
"KAPILA METALS PRIVATE LIMITED",
"KAPILANSH DHATU UDYOG PRIVATE LIMITED",
"KAPILASH INFRASOL PROJECT PRIVATE LIMITED",
"KAPILESWAR ENTERPRISES PRIVATE LIMITED",
"KAPILESWARA MINING AND MINERALS PRIVATE LIMITED",
"KAPILS SALON INDIA PRIVATE LIMITED",
"KAPILVSTU INFRACON PRIVATE LIMITED",
"KAPIRAJ CREATION PRIVATE LIMITED",
"KAPIS REALTY DEVELOPERS PRIVATE LIMITED",
"KAPISH APPARELS PRIVATE LIMITED",
"KAPISH GOLDS PRIVATE LIMITED",
"KAPISH INFOLINKS PRIVATE LIMITED",
"KAPISH INFRATECH PRIVATE LIMITED",
"KAPISH LEATHER PRIVATE LIMITED",
"KAPISHWAR ALLOYS PRIVATE LIMITED",
"KAPKO INTERNATIONAL PRIVATE LIMITED",
"KAPKOL EXPORTS PRIVATE LIMITED",
"KAPLAN COLLEGES PRIVATE LIMITED",
"KAPLAN INDIA PRIVATE LIMITED",
"KAPLINKS ENGINEERING PRIVATE LIMITED",
"KAPMEAD TRADING PRIVATE LIMITED",
"KAPNOX FOREX PRIVATE LIMITED",
"KAPO FOOTWEARS PRIVATE LIMITED",
"KAPOOR & SONS VESTURE PRIVATE LIMITED",
"KAPOOR ABHUSHAN PALACE PRIVATE LIMITED",
"KAPOOR AGENCIES PRIVATE LIMITED",
"KAPOOR CELLULOSE UTILITY PRIVATE LIMITED",
"KAPOOR CHANDRA STONE PRODUCTS PRIVATE LIMITED",
"KAPOOR COTSYN INDIA",
"KAPOOR DIESELS GARAGE PRIVATE LIMITED",
"KAPOOR -E-ILLUMINATIONS PRIVATE LIMITED",
"KAPOOR FINE DIAMONDS PRIVATE LIMITED",
"KAPOOR FLEXIBLE PACKAGING PRIVATE LIMITED",
"KAPOOR FLOUR MILLS PRIVATE LIMITED",
"KAPOOR FREIGHT CARRIERS PRIVATE LIMITED",
"KAPOOR GLASS INDIA PRIVATE LIMITED",
"KAPOOR HOSPITAL",
"KAPOOR IMAGING PRIVATE LIMITED",
"KAPOOR INDUSTRIES LIMITED",
"KAPOOR KITCHEN PRIVATE LIMITED",
"KAPOOR LAMP SHADES (KM) PRIVATE LIMITED",
"KAPOOR PRINT PACK PRIVATE LIMITED",
"KAPOOR REGENCY INN PRIVATE LIMITED",
"KAPOOR SILK AND SAREES PRIVATE LIMITED",
"KAPOOR SONS",
"KAPOOR TIMBER SUPPLIER PRIVATE LIMITED",
"KAPOOR WATCH COMPANY PRIVATE LIMITED",
"KAPOOR WOOLTEX PRIVATE LIMITED",
"KAPOTEX INDUSTRIES PRIVATE LIMITED",
"KAPP NILES INDIA TECHNOLOGIES PRIVATE LIMITED",
"KAPPA CHAKKA KANDHARI FOODS PRIVATE LIMITED",
"KAPPA COFFEE PRIVATE LIMITED",
"KAPPA ENGINEERING PRIVATE LIMITED",
"KAPPA INTERNET SERVICES PRIVATE LIMITED",
"KAPPAHL FAR EAST LIMITED",
"KAPRI CORE SOLUTION PRIVATE LIMITED",
"KAPRIKA CONFECTIONARY PRIVATE LIMITED",
"KAPS FOODS INDIA PRIVATE LIMITED",
"KAPS HYGIENE SOLUTIONS PRIVATE LIMITED",
"KAPS MEDINEEDS PRIVATE LIMITED",
"KAPS MERCANTILE PRIVATE LIMITED",
"KAPS MOTORS PRIVATE LIMITED",
"KAPS THREE LIFE SCIENCES PRIVATE LIMITED",
"KAPS THREE NUTRA PRIVATE LIMITED",
"KAPS VEHICLE & SPARES (INDIA) PRIVATE LIMITED",
"KAPSA WELLNESS PRIVATE LIMITED",
"KAPSE CONSULTING ENGINEERS PRIVATE LIMITED",
"KAPSE PATIL KRUSHI PRODUCER COMPANY LIMITED",
"KAPSI ELECTRICAL POWER PRODUCTS PRIVATE LIMITED",
"KAPSICA MEDIA PRIVATE LIMITED",
"KAPSIME VENTURES PRIVATE LIMITED",
"KAPSIN PHARMA PRIVATE LIMITED",
"KAPSIT RICE MILL PVT LTD",
"KAPSO BUSINESS SERVICES PRIVATE LIMITED",
"KAPSON EXIM PRIVATE LIMITED",
"KAPSON PLASTICS PRIVATE LTD",
"KAPSONS AGENCIES PRIVATE LIMITED",
"KAPSONS FASHION PRIVATE LIMITED",
"KAPSONS INDUSTRIES PRIVATE LIMITED",
"KAPSONS INTERNATIONAL PRIVATE LIMITED",
"KAPSONS LOGISTICS PRIVATE LIMITED",
"KAPSONS RETAIL PRIVATE LIMITED",
"KAPSONS SOLUTIONS PRIVATE LIMITED",
"KAPSONS WORLDWIDE",
"KAPSTON SERVICES LIMITED",
"KAPSTONE CONSTRUCTIONS PRIVATE LIMITED",
"KAPSTONE INDUSTRIES PRIVATE LIMITED",
"KAPSUN RESOURCES CORPORATION",
"KAPTAN POLYPLAST PRIVATE LIMITED",
"KAPTIM PRIVATE LIMITED",
"KAPTON ALLOYS PRIVATE LIMITED",
"KAPTRONICS PRIVATE LIMITED",
"KAPTUNE MEDIA INDIA PRIVATE LIMITED",
"KAPTURA TECHNOLOGIES PRIVATE LIMITED",
"KAPU GEMS LLP",
"KAPUR AGRANI MILK AND AGRO PROCESSING PRIVATE LIMITED",
"KAPUR GRAPHICS PRIVATE LIMITED",
"KAPUR SONS STEELS PVT LTD",
"KAPURTHALA HI TECH TRANSBELT PRIVATE LIMITED",
"KAPYNAG PHARMA PRIVATE LIMITED",
"KAR CLINIC & HOSPITAL PRIVATE LIMITED",
"KAR CONSTRUCTION PVT LTD",
"KAR JEWELLERY HOUSE PRIVATE LIMITED",
"KAR MOBILES LIMITED",
"KAR VISION PRIVATE LIMITED",
"KARA CONSEIL PRIVATE LIMITED",
"KARA EXPRESS PRIVATE LIMITED",
"KARA HARDWARE PRIVATE LIMITED",
"KARA4KIDS",
"KARABI ART COMMUNITY PRIVATE LIMITED",
"KARACHI BAKERY PEARL PRIVATE LIMITED",
"KARACUS ENERGY PRIVATE LIMITED",
"KARAD AGRO FARMER PRODUCER COMPANY LIMITED",
"KARAD AND PATIL PHARMACEUTICALS PRIVATE LIMITED",
"KARAD MULTI SPECIALITY HOSPITAL & RESEARCH CENTRE PRIVATE LIMITED",
"KARAD NAGARPARISHAD",
"KARAD POWER INDIA PRIVATE LIMITED",
"KARADANI ENGINEERING PRIVATE LIMITED",
"KARADI PATH EDUCATION COMPANY PRIVATE LIMITED",
"KARADI TALES COMPANY PRIVATE LIMITED",
"KARAIKAL PORT PRIVATE LIMITED",
"KARAIKUDI MAGANLAL MEHTA CORPORATION LIMITED",
"KARAIKUDI MEDICAL CENTRE AND HOSPITAL LIMITED",
"KARAKUN SOFTWARE PRIVATE LIMITED",
"KARALI POLYSACK PRIVATE LIMITED",
"KARALKAR CHANDRASHEKHAR 9O21O PRIVATE LIMITED",
"KARAM CARGO LOGISTIC PRIVATE LIMITED",
"KARAM CHAND THAPAR & BROS COAL SALES LIMITED",
"KARAM CHAND THAPAR AND BROS (JAMMU AND KASHMIR) PRIVATE LIMITED",
"KARAM FOOD GRAINS PRIVATE LIMITED",
"KARAM FOODPACK PRIVATE LIMITED",
"KARAM GROUP",
"KARAM HOLDING PRIVATE LIMITED",
"KARAM INDUSTRIES PRIVATE LIMITED",
"KARAM MULTIPACK PRIVATE LIMITED",
"KARAM PACKAGING PRIVATE LIMITED",
"KARAM SAFETY PRIVATE LIMITED",
"KARAMAT HUSAIN MULSIM GIRLS PG COLLEGE",
"KARAMAT TANNING INDUSTRIES",
"KARAMCHAND REALTECH PRIVATE LIMITED",
"KARAMHANS FOODS PRIVATE LIMITED",
"KARAMJEET SINGH AND COMPANY LIMITED",
"KARAMJYOTI SALES PVT.LTD.",
"KARAMRAJ FRUIT AND VEGETABLES PRODUCER COMPANY LIMITED",
"KARAMSAD PRAMUKH SWAMI MEDICAL COLLEGE",
"KARAMSAR ELECTRONICS PRIVATE LIMITED",
"KARAMSAR TECHNOLOGY PRIVATE LIMITED",
"KARAMTARA ENGINEERING PRIVATE LIMITED",
"KARAMVEER ELECTRONICS LIMITED",
"KARAMVEER POWER PRODUCTS PRIVATE LIMITED",
"KARAMVEER TRANSPORT COMPANY PRIVATE LIMITED",
"KARAMVIR BHAURAO PATIL VIDYAMANDIR AND JUNOR COLLEGE",
"KARAN AGRI GENETICS PRIVATE LIMITED",
"KARAN ASHOK CARS PRIVATE LIMITED",
"KARAN AUTOMOBILES PRIVATE LIMITED",
"KARAN AUTOMOTIVES PRIVATE LIMITED",
"KARAN BOTTLING COMPANY PRIVATE LIMITED",
"KARAN CAB SERVICES PRIVATE LIMITED",
"KARAN DEVELOPMENT SERVICES PRIVATE LIMITED",
"KARAN DISTILLERIES PRIVATE LIMITED",
"KARAN FAABTEX PRIVATE LIMITED",
"KARAN HEALTHCARE PRIVATE LIMITED",
"KARAN HOLDINGS PRIVATE LIMITED",
"KARAN INTERMEDIATES PRIVATE LIMITED",
"KARAN KOTHARI AABHUSHAN PRIVATE LIMITED",
"KARAN KOTHARI JEWELLERS PRIVATE LIMITED",
"KARAN LETEX LIMITED",
"KARAN LIFESTYLE PRIVATE LIMITED",
"KARAN MAINTENANCE SERVICES PRIVATE LIMITED",
"KARAN MARKING SYSTEMS PRIVATE LIMITED",
"KARAN MERCHANT PRIVATE LIMITED",
"KARAN MOIN KLOTHING PRIVATE LIMITED",
"KARAN MONOMER'S PRIVATE LIMITED",
"KARAN MOTORS PRIVATE LIMITED",
"KARAN MULTITRADELINKS PRIVATE LIMITED",
"KARAN POLYMERS PRIVATE LIMITED",
"KARAN PROPERTY DEVELOPMENTS PRIVATE LIMITED",
"KARAN RAGHAV EXPORTS PRIVATE LIMITED",
"KARAN SALES PRIVATE LIMITED",
"KARAN SOLUTIONS PRIVATE LIMITED",
"KARAN SUGARS PRIVATE LIMITED",
"KARAN TECHNO CAST PRIVATE LIMITED",
"KARAN TECHNO FAB PRIVATE LIMITED",
"KARAN TIE UP PRIVATE LIMITED",
"KARAN TRADING (INDIA) PRIVATE LIMITED",
"KARAN VALVES PRIVATE LIMITED",
"KARAN VANIJYA PRIVATE LIMITED",
"KARANASHOK AUTO PRIVATE LIMITED",
"KARANASHOK VAHAN PRIVATE LIMITED",
"KARANASHOK VEHICLES INDIA PRIVATE LIMITED",
"KARANDIKAR LABORATORIES PRIVATE LIMITED",
"KARANDIKARS ORGOCHEM PRIVATE LIMITED",
"KARANI HOTELS PRIVATE LIMITED",
"KARANI PROJECTS PRIVATE LIMITED",
"KARANJA INDUSTRIES PRIVATE LIMITED",
"KARANJA INFRASTRUCTURE PRIVATE LIMITED",
"KARANJAWALA ASSOCIATES (ENGINEERS) PRIVATE LIMITED",
"KARANJI FARMA AGRO PRODUCER COMPANY LIMITED",
"KARANJI INFOTECH PRIVATE LIMITED",
"KARAN-TEJ PARAMOUNT PROPERTIES PRIVATE LIMITED",
"KARANWAL LIME CHEM (I) PRIVATE LIMITED",
"KARANYA HEART CARE PRIVATE LIMITED",
"KARAPUR AGRO PRIVATE LIMITED",
"KARARA IMPEX PRIVATE LIMITED",
"KARATAGI REFINERIES PRIVATE LIMITED",
"KARAULI HEALTH CARE SERVICES PRIVATE LIMITED",
"KARAVALI COLOUR CARTONS LIMITED.",
"KARAVALI FREEZERS & EXPORTERS",
"KARAVALI OCEAN PRODUCTS PRIVATE LIMITED",
"KARAYALA ZILADHIKARI TEHSIL SADAR LUCKNOW",
"KARAYALAY JILHA PARISHAD NAGPUR",
"KARBI TRADE AND INDUSTRIES LIMITED",
"KARBIT TOOLING INDIA PRIVATE LIMITED",
"KARBONSTEEL ENGINEERING PRIVATE LIMITED",
"KARBOSH ENGINEERS PRIVATE LIMITED",
"KARCE ENTERPRISES (INDIA) PRIVATE LIMITED",
"KARCHER CLEANING SYSTEMS PRIVATE LIMITED",
"KARDA CONSTRUCTIONS LIMITED",
"KARDAM CONSTRUCTIONS PRIVATE LIMITED",
"KARDEX FACILITIES SERVICES PRIVATE LIMITED",
"KARDEX INDIA PRIVATE LIMITED",
"KARDI DRYERS PRIVATE LIMITED",
"KARDI TRADING PRIVATE LIMITED",
"KARDO DESIGN PRIVATE LIMITED",
"KARE ELECTRONICS AND DEVELOPMENT PRIVATE LIMITED",
"KARE ENTERPRISE PRIVATE LIMITED",
"KARE GLOBAL LIMITED",
"KARE HOTELS PRIVATE LIMITED",
"KARE INDIA INSURANCE BROKERS PRIVATE LIMITED",
"KARE PARTNERS GROUP INDIA PRIVATE LIMITED",
"KARE PERIPHERALS PRIVATE LIMITED",
"KARE POWER RESOURCES PRIVATE LIMITED",
"KARE SMARTECH PRIVATE LIMITED",
"KARECARD SOLUTIONS PRIVATE LIMITED",
"KAREENA FASHIONS PRIVATE LIMITED",
"KAREENA SHARES AND STOCKS PRIVATE LIMITED",
"KAREER KRAFTERS INDIA PRIVATE LIMITED",
"KAREFREE HYGIENE & HEALTH PRODUTS PRIVATE LIMITED",
"KAREGAON BHAG SUGARCANE TRANSPORT CO PVT LTD",
"KAREGAR EARTHMOVERS PRIVATE LIMITED",
"KARELI SUGAR MILL PRIVATE LIMITED",
"KARELIDES TRADERS PRIVATE LIMITED",
"KAREN PHARMA PRIVATE LIMITED",
"KARENN INTERNATIONAL PRIVATE LIMITED",
"KARENNAVAR BUILDMAT PRIVATE LIMITED",
"KARES ENGINEERING PROJECTS PRIVATE LIMITED",
"KAREXPERT TECHNOLOGIES PRIVATE LIMITED",
"KARGAINDIA ROADWAYS PRIVATE LIMITED",
"KARGO KING EXPRESS PRIVATE LIMITED",
"KARGO LEAGUE LOGISTICS PRIVATE LIMITED",
"KARGOKART PRIVATE LIMITED",
"KARGO-LEAGUE LOGISTICS PRIVATE LIMITED",
"KARGROW LOGISTICS PRIVATE LIMITED",
"KARGWAL CONSTRUCTIONS PRIVATE LIMITED",
"KARGWAL ENTERPRISES PRIVATE LIMITED",
"KARGWAL KM JOINT VENTURE",
"KARHA DEVELOPERS & MINERS PRIVATE LIMITED",
"KARI NIRBHAU NIRVAIR LIMITED",
"KARIA SATI AGRO INDUSTRIES PRIVATE LIMITED",
"KARIBETTU PRIVATE LIMITED",
"KARIDA REAL ESTATES PRIVATE LIMITED",
"KARIGAR NIRYAT PRIVATE LIMITED",
"KARIGARI DESIGN PRIVATE LIMITED",
"KARIKA INDIA PRIVATE LIMITED",
"KARIKALI AMMAN SPINNING MILLS PRIVATE LIMITED",
"KARILADHAM AGRO PRODUCER COMPANY LIMITED",
"KARIM HOTELS PRIVATE LTD",
"KARIMGANJ BIOFUELS PRIVATE LIMITED",
"KARIMIA AGROTECH PRIVATE LIMITED",
"KARIMNAGAR MILK PRODUCER COMPANY LIMITED",
"KARINA FINCAP LIMITED",
"KARINI VENTURES PRIVATE LIMITED",
"KARISHMA BARTER PRIVATE LIMITED",
"KARISHMA COMPUTERS PRIVATE LIMITED",
"KARISHMA FINISHERS PRIVATE LIMITED",
"KARISHMA INSTRUMENTS PVT LTD",
"KARISHMA LASER & COSMETIC PRIVATE LIMITED",
"KARISHMA MARINE SOLUTIONS PRIVATE LIMITED",
"KARISHMA METAL INDUSTRIES PRIVATE LIMITED",
"KARISHMA POLYMERS PRIVATE LTD",
"KARISHMA PRINTS PRIVATE LIMITED",
"KARISHMA RESEARCH AND HYBRID SEEDS (INDIA) PRIVATE LIMITED",
"KARISHMA SOFTWARE PRIVATE LIMITED",
"KARISHMA VINTRADE PRIVATE LIMITED",
"KARISHMAA CLOTHING COMPANY (P) LTD",
"KARISMAA FOUNDATIONS PRIVATE LIMITED",
"KARISON AUTO PARTS PRIVATE LIMITED",
"KARISON PROFILES PRIVATE LIMITED",
"KARIWAL TEXTILES PRIVATE LIMITED",
"KARIWALA BROTHERS AQUASTRUCTURE PRIVATE LIMITED",
"KARIWALA HOME STYLES & FASHIONS PRIVATE LIMITED",
"KARIWALA INDUSTRIES LIMITED",
"KARIWALA MARKETING PRIVATE LIMITED",
"KARIWALA SYNTHETIC PRIVATE LIMITED",
"KARIX MOBILE PRIVATE LIMITED",
"KARKADA JAYALAKSHMI HOTELS AND RESORTS PRIVATE LIMITED",
"KARKALA INVESTMENTS PRIVATE LIMITED",
"KARL DUNGS PRIVATE LIMITED",
"KARL MAYER INDIA PRIVATE LIMITED",
"KARL MAYER TEXTILE MACHINERY INDIA PRIVATE LIMITED",
"KARL STORZ ENDOSCOPY INDIA PRIVATE LIMITED",
"KARLE HOMES PRIVATE LIMITED",
"KARLE INFRA PRIVATE LIMITED",
"KARLE PROPERTIES",
"KARLE TECH PARK PRIVATE LIMITED",
"KARLO AUTOMOBILES PRIVATE LIMITED",
"KARLO TRANSPORT PRIVATE LIMITED",
"KARLOS LIFESTYLE PRIVATE LIMITED",
"KARM INDO GLOBAL BUILDTECH PRIVATE LIMITED",
"KARM PROJECTS PRIVATE LIMITED",
"KARMA CAPITAL ADVISORS PRIVATE LIMITED",
"KARMA CARGO MOVERS PRIVATE LIMITED",
"KARMA ECOTECH LIMITED",
"KARMA EDUCATION PRIVATE LIMITED",
"KARMA ENERGY LIMITED",
"KARMA HEALTH CARE LIMITED",
"KARMA HOLDINGS PRIVATE LIMITED",
"KARMA LAKELANDS PRIVATE LIMITED",
"KARMA MANAGEMENT GLOBAL CONSULTING SOLUTIONS PRIVATE LIMITED",
"KARMA MODEL SERVICES PRIVATE LIMITED",
"KARMA PRIMARY HEALTHCARE SERVICES PRIVATE LIMITED",
"KARMA PROCESSORS PRIVATE LTD",
"KARMA RE ROLLERS PRIVATE LIMITED",
"KARMA REHACARE PRODUCTS PRIVATE LIMITED",
"KARMA REMEDIES PRIVATE LIMITED",
"KARMA ROYAL PALMS",
"KARMA SECURITY SOLUTIONS PRIVATE LIMITED",
"KARMA TECHNO SOLUTIONS PRIVATE LIMITED",
"KARMA TEX-PRINTS PRIVATE LIMITED",
"KARMA UDYOG",
"KARMAA S R CONSULTANTS PRIVATE LIMITED",
"KARMAGURU R & D PRIVATE LIMITED",
"KARMAH RMC INFRA PRIVATE LIMITED",
"KARMAJA EXPORTS PRIVATE LIMITED",
"KARMANYA EDUCATION FOUNDATION",
"KARMANYE TRADERS PRIVATE LIMITED",
"KARMATECH MEDIA WORKS PRIVATE LIMITED",
"KARMATEX APPARELS PRIVATE LIMITED",
"KARMAVEER BHAURAO PATIL COLLEGE",
"KARMAVEER BHAURAO PATIL VIDHYALAY",
"KARMAVEER BHAUSAHEB HIRAY HIGH SCHOOL",
"KARMAVEER DADASAHEB KANNAMWAR COLLEGE OF",
"KARMAVEER HIRE ARTS SCIENCE COMMERCE AND EDUCATION COLLEGE",
"KARMAVEER VIDYALAY BU",
"KARMAYOGI HOLDINGS PRIVATE LIMITED",
"KARMEN INTERNATIONAL PRIVATE LIMITED",
"KARMIC CONNECTION SECURITAS PRIVATE LIMITED",
"KARMIC DESIGN PRIVATE LIMITED",
"KARMIC FASHIONS PVT LTD",
"KARMIC MEDITRADERS PRIVATE LIMITED",
"KARMICK SOLUTIONS PRIVATE LIMITED",
"KARMINDER HP CENTRE",
"KARMVEER BHAURAO PATIL KANISHTHA VIDYALAYA",
"KARMYOG HEATTREATMENT PRIVATE LIMITED",
"KARMYOGI HOTELS AND BUILDCON PRIVATE LIMITED",
"KARMYOGI MART LIMITED",
"KARMYOGI SOLUTIONS PRIVATE LIMITED",
"KARN CARBON COMPANY PRIVATE LIMITED",
"KARN LAMINATORS PRIVATE LIMITED.",
"KARNA APPARELS PRIVATE LIMITED",
"KARNA INTERNATIONAL",
"KARNA PAINTS PRIVATE LIMITED",
"KARNAK EXIM PRIVATE LIMITED",
"KARNAL FEEDS PRIVATE LIMITED",
"KARNAL MILK FOOD LIMITED",
"KARNAL MOTORS PRIVATE LIMITED",
"KARNALA NAGARI SAHAKARI BANK LIMITED",
"KARNANI INDUSTRIES LIMITED",
"KARNANI LABORATORIES LIMITED",
"KARNANI MINERALS PRIVATE LIMITED",
"KARNANI PHARAMACEUTICALS PRIVATE LIMITED",
"KARNANI SOLVEX PRIVATE LIMITED",
"KARNATAKA AGENCIES",
"KARNATAKA AGRO CHEMICALS PRIVATE LIMITED",
"KARNATAKA AGRO INDUSTRIES CORPN LIMITED",
"KARNATAKA ANTIBIOTICS N PHARMACEUTI",
"KARNATAKA AUTOMATS PRIVATE LIMITED",
"KARNATAKA BANK LIMITED",
"KARNATAKA CASHEW DEVELOPMENT CORPORATION LIMITED",
"KARNATAKA CHEMICAL INDUSTRIES",
"KARNATAKA CLASSIC EDUCATION PRIVATE LIMITED",
"KARNATAKA CLOSURES PRIVATE LIMITED",
"KARNATAKA CNC TECH PRIVATE LIMITED",
"KARNATAKA COLLEGE OF PHARMACY",
"KARNATAKA COMPOST DEVELOPMENT CORPORATION LIMITED",
"KARNATAKA CONVEYORS AND SYSTEMS PRIVATE LIMITED",
"KARNATAKA CO-OPERATIVE MILK PRODUCERS FEDERATION LIMITED",
"KARNATAKA CO-OPERATIVE OILSEEDS GROWERS FEDERATION LIMITED",
"KARNATAKA FISHERIES DEVELOPMENT CORPORATION LIMITED",
"KARNATAKA FOOD AND CIVIL SUPPLIES CORPORATION LIMITED",
"KARNATAKA FREIGHT CARRIERS PRIVATE LIMITED",
"KARNATAKA FREIGHT MOVERS PRIVATE LIMITED",
"KARNATAKA GRAMIN BANK",
"KARNATAKA HOUSING BOARD",
"KARNATAKA HYBRID MICRO DEVICES LIMITED",
"KARNATAKA INDUSTRIAL GASES PRIVATE LIMITED",
"KARNATAKA KLEENING KORPORATION",
"KARNATAKA LEASING AND COMMERCIAL CORPORATION LIMITED",
"KARNATAKA NEERAVARI NIGAM LIMITED",
"KARNATAKA NEWS PUBLICATIONS PRIVATE LIMITED",
"KARNATAKA NUTRACEUTICALS INDIA LIMITED",
"KARNATAKA PIPES AND TUBES PRIVATE LIMITED",
"KARNATAKA PLASTOO INDUSTRIES PRIVATE LIMITED",
"KARNATAKA POWER CORPORATION LIMITED",
"KARNATAKA POWER TRANSMISSION CORPORATION LIMITED",
"KARNATAKA PUBLIC LANDS CORPORATION LIMITED",
"KARNATAKA RENEWABLE ENERGY DEVELOPMENT LIMITED",
"KARNATAKA ROAD DEVELOPMENT CORPORATION LIMITED",
"KARNATAKA RURAL INFRASTRUCTURE DEVELOPMENT LIMITED",
"KARNATAKA SILK INDUSTRIES CORPORATION LIMITED",
"KARNATAKA SOAPS AND DETERGENTS LIMITED",
"KARNATAKA SOLAR POWER DEVELOPMENT CORPORATION LIMITED",
"KARNATAKA SOUTHERN DIOCESE",
"KARNATAKA STATE AGRICULTURAL PRODUCE PROCESSING AND EXPORT CORPORATION LIMITED",
"KARNATAKA STATE AGRO-CORN PRODUCTS LIMITED",
"KARNATAKA STATE BEVERAGES CORPORATION LIMITED",
"KARNATAKA STATE CO-OPERATIVE MARKETING FEDERATION LIMITED",
"KARNATAKA STATE COOPERATIVE MARKETING FEDERATION LTD",
"KARNATAKA STATE ELECTRONIC DEVELOPMENT CORPORATION LIMITED",
"KARNATAKA STATE FINANCIAL CORPORATION",
"KARNATAKA STATE HANDICRAFTS DEVELOPMENT CORPORATION LTD",
"KARNATAKA STATE INDUSTRIAL AND INFRASTRUCTURE DEVELOPMENT CORPORATION LIMITED",
"KARNATAKA STATE MANGO DEVELOPMENT AND MARKETING CORPORATION LIMITED",
"KARNATAKA STATE MINERALS CORPORATION LIMITED",
"KARNATAKA STATE POLICE HOUSING AND INFRASTRUCTURE DEVELOPMENT CORPORATION LIMITED",
"KARNATAKA STATE PULSES ABHIVRIDHI MANDALI LIMITED",
"KARNATAKA STATE REMOTE SENSING APPLICATIONS CENTRE KSRSAC",
"KARNATAKA STATE ROAD TRANSPORT CORPORATION",
"KARNATAKA STATE SEED AND ORGANIC CERTIFICATION AGENCY",
"KARNATAKA STATE SEEDS CORPORATION LIMITED",
"KARNATAKA STATE SOUHARDA FEDERAL COOPERATIVE LTD",
"KARNATAKA STATE TEXTILE INFRASTRUCTURE DEVELOPMENT CORPORATION LIMITED.",
"KARNATAKA TEST HOUSE PRIVATE LIMITED",
"KARNATAKA TEXSPARES AND STEEL PROFILES PRIVATE LIMITED",
"KARNATAKA TOURISM INFRASTRUCTURE LIMITED",
"KARNATAKA TRADE PROMOTION ORGANISATION",
"KARNATAKA TURNED COMPONENTS PRIVATE LIMITED",
"KARNATAKA UNIVERSITY DHARWAD",
"KARNATAKA URBAN INFRASTRUCTURE DEVELOPMENT AND FINANCE CORP",
"KARNATAKA VIDYUTH KARKHANE LIMITED",
"KARNATAKA VIJAYNAGAR STEEL LIMITED",
"KARNATAKA VIKAS GRAMEENA BANK",
"KARNATAKA WILDLIFE RESORTS PRIVATE LIMITED",
"KARNATION INDIA FOREX SERVICES PRIVATE LIMITED",
"KARNAVATI AVIATION PRIVATE LIMITED",
"KARNAVATI BIKES PRIVATE LIMITED",
"KARNAVATI CAR AIRCONDITIONERS PRIVATE LIMITED",
"KARNAVATI CLUB LIMITED",
"KARNAVATI COMMERCIAL PRIVATE LIMITED",
"KARNAVATI DISTRIBUTORS LIMITED",
"KARNAVATI ENGINEERING LIMITED",
"KARNAVATI ENTERPRISE",
"KARNAVATI FINANCE LIMITED",
"KARNAVATI HOSPITAL PVT LTD",
"KARNAVATI INFRASTRUCTURE PRIVATE LIMITED",
"KARNAVATI POLYBLENDS PRIVATE LIMITED",
"KARNAVATI POLYESTER PRIVATE LIMITED",
"KARNAVATI SEEDS PRIVATE LIMITED",
"KARNAVATI UNIVERSITY",
"KARNAVATI WHEELS PRIVATE LIMITED",
"KARNAWAT MARBLES AND GRANITES PRIVATE LIMITED",
"KARNAWATI BUILDERS PRIVATE LIMITED",
"KARNAWATI TRADELINK PRIVATE LIMITED",
"KARNE HOSPITALS PRIVATE LIMITED",
"KARNEET ENTERPRISES(INDIA)PRIVATE LIMITED",
"KARNEX SOFTWARE SOLUTIONS OPC PRIVATE LIMITED",
"KARNI COMMUNICATION PRIVATE LIMITED",
"KARNI CONSTRUCTION",
"KARNI DESIGN & CONSTRUCTION PRIVATE LIMITED",
"KARNI EARTH RESOURCES PRIVATE LIMITED",
"KARNI ENGINEERS PRIVATE LIMITED",
"KARNI ENTERPRISES PRIVATE LIMITED",
"KARNI FREIGHT CARRIERS",
"KARNI PACKAGING PRIVATE LIMITED",
"KARNI PROCESSORS PRIVATE. LIMITED.",
"KARNI ROADWAYS PRIVATE LIMITED",
"KARNI STEELS PRIVATE LIMITED",
"KARNI SYNTEX PVT. LTD.",
"KARNI TEXTILE MILLS PRIVATE LIMITED",
"KARNI THERMO-PLAST PRIVATE LIMITED",
"KARNI VENTURE PRIVATE LIMITED",
"KARNIKA CREATION PRIVATE LIMITED",
"KARNIKA FUELS & COMMODITIES PRIVATE LIMITED",
"KARNIKA GARMENTS PRIVATE LIMITED",
"KARNIKA INTERNATIONAL PRIVATE LIMITED",
"KARNIKA TEXTILE PRIVATE LIMITED",
"KARNIMATA COLD STORAGE LIMITED",
"KARNIS HARDWARE INDIA PRIVATE LIMITED",
"KARNISH MOTORS PRIVATE LIMITED",
"KARNIVAL INTERNET TECHNOLOGIES PRIVATE LIMITED",
"KARO CHEM PRIVATE LIMITED",
"KARO SAMBHAV PRIVATE LIMITED",
"KARODA MULTI SOLUTION PRIVATE LIMITED",
"KARODA ONLINE TRADERS PRIVATE LIMITED",
"KAROL BAGH NETWORK PRIVATE LIMITED",
"KAROL BROTHERS AGRIFRESH PRIVATE LIMITED",
"KAROL LUBRICANTS INDIA LIMITED",
"KAROLIA LIGHTING PRIVATE LIMITED",
"KAROM CORPORATION PRIVATE LIMITED",
"KAROMA PLAST PRIVATE LIMITED",
"KAROMI TECHNOLOGY PRIVATE LIMITED",
"KARON HOTELS PRIVATE LIMITED",
"KARONA CHEMICALS PRIVATE LIMITED",
"KAROOYA TECHNOLOGIES PRIVATE LIMITED",
"KAROTHUKUDY CONSTRUCTIONS PRIVATE LIMITED",
"KAROTHUKUZHI HOSPITAL PRIVATE LIMITED",
"KAROW MINES AND MINERALS PRIVATE LIMITED",
"KARP DIAMONDS PRIVATE LIMITED",
"KARP IMPEX LIMITED",
"KARPAGA ASSESSMENT APP MATRIX SERVICES PRIVATE LIMITED",
"KARPAGA VINAYAGA & COMPANY",
"KARPAGA VINAYAGA COLLEGE OF ENGINEERING AND TECHNOLOGY",
"KARPAGA VINAYAGA INSTITUTE OF MEDICAL SCIENCES AND RESEARCH CENTRE",
"KARPAGA VINAYAGA MATRICULATION HIGHER SECONDARY SCHOOL",
"KARPAGAM ACADEMY OF HIGHER EDUCATION",
"KARPAGAM AGRO FOODS PRIVATE LIMITED",
"KARPAGAM COLLEGE OF ENGINEERING",
"KARPAGAM COLLEGE OF PHARMACY",
"KARPAGAM FACULTY OF MEDICAL SCIENCES AND RESEARCH",
"KARPAGAM HIRE PURCHASE AND FINANCE PRIVATE LIMITED",
"KARPAGAM INSTITUTE OF TECHNOLOGY",
"KARPAGAM TEXTILES PRIVATE LIMITED",
"KARPAGAM THEATRES PRIVATE LIMITED",
"KARPAGAM WEAVES PRIVATE LIMITED",
"KARPARA PROJECT ENGINEERING PRIVATE LIMITED",
"KARPASA APPARELS INDIA PRIVATE LIMITED",
"KARPASA SUPERMARTS PRIVATE LIMITED",
"KARPI INDIA PRIVATE LIMITED",
"KARPITA VIRTUAL REALITY STUDIO PRIVATE LIMITED",
"KARPO REAL ESTATE PRIVATE LIMITED",
"KARPUR CONSTRUCTTIONS PRIVATE LIMITED",
"KARRAT CHEMICALS (INDIA) PRIVATE LIMITED",
"KARRAT MULTIGASES & CHEMICALS PRIVATE LIMITED",
"KARRDIAS TECHNO SERVICES PRIVATE LIMITED",
"KARRIA FOOD & SNACKS PRIVATE LIMITED",
"KARRIBEAN OVERSEAS PRIVATE LIMITED",
"KARRIERS FINANCE PRIVATE LIMITED",
"KARRM INFRASTRUCTURE PRIVATE LIMITED",
"KARS FOODS INDIA PRIVATE LIMITED",
"KAR'S TECHNO PLAST PRIVATE LIMITED",
"KARSAN DEVELOPERS PRIVATE LIMITED",
"KARSHAK CROP SCIENCES PRIVATE LIMITED",
"KARSHAK PRINT SOLUTIONS PRIVATE. LIMITED.",
"KARSHEV DIAMONDS PRIVATE LIMITED",
"KARSHIVNIK INTERNATIONAL PRIVATE LIMITED",
"KARSHNI AGENCIES",
"KARSHNI EXTRUSION PRIVATE LIMITED",
"KARSHNI PACKS PRIVATE LIMITED",
"KARSTADT A G",
"KARSTEN SEA AND AIR PRIVATE LIMITED",
"KARSUNINDIA SOLUTIONS PRIVATE LIMITED",
"KARSY HEALTH CARE PRIVATE LIMITED",
"KARTAL PROJECTS PRIVATE LIMITED",
"KARTAR AGRO ENGINEERS PRIVATE LIMITED",
"KARTAR AGRO INDUSTRIES PRIVATE LIMITED",
"KARTAR AUTO LOGISTICS PRIVATE LIMITED",
"KARTAR BROTHERS PRIVATE LIMITED",
"KARTAR CARRIERS PRIVATE LIMITED",
"KARTAR CRUMBS PRIVATE LIMITED",
"KARTAR FEEDS PRIVATE LIMITED",
"KARTAR INFOTECH PRIVATE LIMITED",
"KARTAR ROLLER FLOUR MILLS PVT LTD",
"KARTAR RUBBERS PRIVATE LIMITED",
"KARTAR SONS PRINTERS PRIVATE LIMITED",
"KARTAR TRACTORS PRIVATE LIMITED",
"KARTAR TYRES & TUBES PRIVATE LIMITED",
"KARTAR VALVES PRIVATE LIMITED",
"KARTARZ ALLOYS PRIVATE LIMITED",
"KARTARZ HOTEL ESTATES PVT LTD",
"KARTAVYA AGRITECH PRIVATE LIMITED",
"KARTAVYA CONSULTANTS PRIVATE LIMITED",
"KARTAVYA FASHION PRIVATE LIMITED",
"KARTAVYA HEALTHEON PRIVATE LIMITED",
"KARTAVYA REALCON PRIVATE LIMITED",
"KARTBIN ONLINE SERVICES PRIVATE LIMITED",
"KARTEEK FERROMET PRIVATE LIMITED",
"KARTEKYA WINES",
"KARTHAVYA TECHNOLOGIES PRIVATE LIMITED",
"KARTHI HOMEPRODUCTS PRIVATE LIMITED",
"KARTHIGAI TEXTILE MILLS",
"KARTHIGEYA MOULDS & DIES PRIVATE LIMITED",
"KARTHIGEYA PLASTICS AND TECHNOLOGIES PRIVATE LIMITED",
"KARTHIK BUSINESS MACHINES PRIVATE LIMITED",
"KARTHIK DOORS & WINDOWS PRIVATE LIMITED",
"KARTHIK ENTERPRISES PRIVATE LIMITED",
"KARTHIK INDUCTIONS LIMITED",
"KARTHIK NETRALAYA INSTITUTE OF OPHTHALMOLOGY PRIVATE LIMITED",
"KARTHIK ROLLER FLOUR MILLS PRIVATE LIMITED",
"KARTHIK ROOFINGS",
"KARTHIKA HOTEL CONCERNS PRIVATE LIMITED",
"KARTHIKA MODERN RICE MILL",
"KARTHIKAI TEXTILE MILLS PRIVATE LIMITED",
"KARTHIKAJYOTHI AGRO PRIVATE LIMITED",
"KARTHIKEYA ANCILLARIES PRIVATE LIMITED",
"KARTHIKEYA CONSTRUCTIONS",
"KARTHIKEYA PAPER MILLS PRIVATE LIMITED",
"KARTICK CHANDRA AGRO PRODUCTS PRIVATE LIMITED",
"KARTIK CLOTHING AND FABRICS PRIVATE LIMITED",
"KARTIK CONSTRUCTION COMPANY",
"KARTIK DRUG DISTRIBUTORS",
"KARTIK DYEING AND PRINTING MILLS PRIVATE LIMITED",
"KARTIK ELECTRONICS",
"KARTIK ENTERPRISES PRIVATE LIMITED",
"KARTIK FASHIONS PRIVATE LIMITED",
"KARTIK FOREX DEALERS PRIVATE LIMITED",
"KARTIK INDOTECH PRIVATE LIMITED",
"KARTIK INFRATOWN PRIVATE LIMITED",
"KARTIK OVERSEAS PRIVATE LIMITED",
"KARTIK PAPER MARKETING PRIVATE LIMITED",
"KARTIK SAREES PRIVATE LIMITED",
"KARTIK SOLUTIONS PRIVATE LIMITED",
"KARTIK SOURCING PRIVATE LIMITED",
"KARTIK THREADS PRIVATE LIMITED",
"KARTIKAY COAL WASHERIES PRIVATE LIMITED",
"KARTIKAY EXPLORATION AND MINING SERVICES PRIVATE LIMITED",
"KARTIKAY INNOVISION PRIVATE LIMITED",
"KARTIKAY PROJECTS PRIVATE LIMITED",
"KARTIKAY TRANSMISSION PRODUCT PRIVATE LIMITED",
"KARTIKAYAN CIVILIZATION PRIVATE LIMITED",
"KARTIKAYE PROPMART PRIVATE LIMITED",
"KARTIKEY DEVELOPERS PRIVATE LIMITED",
"KARTIKEY JEWELLERS PRIVATE LIMITED",
"KARTIKEY MARMO PRIVATE LIMITED",
"KARTIKEYA AUTOMOBILES PRIVATE LIMITED",
"KARTIKEYA ENERTECH PRIVATE LIMITED",
"KARTIKEYA INDUSTRIES PRIVATE LIMITED",
"KARTIKEYA PAPER DISTRIBUTOR PRIVATE.LIMITED",
"KARTIKEYA PROPERTIES PRIVATE LIMITED",
"KARTIKEYA SECURITY AND HOUSEKEEPING SERVICES PRIVATE LIMITED",
"KARTIKEYA SEEDS PRIVATE LIMITED",
"KARTIKEYA SHELTERS PRIVATE LIMITED",
"KARTIKEYA SYNTHETICS PRIVATE LIMITED",
"KARTIKEYAS MANGANESE AND IRON ORES PRIVATE LIMITED",
"KARTIKEYGANESH FOODS PRIVATE LIMITED",
"KARTINA ENTERTAINMENT AND SPORTS PRIVATE LIMITED",
"KARTYA CONSTRUCTIONS PRIVATE LIMITED",
"KARUKRIT ADVERTISING PVT LTD",
"KARUMURI SUPER SPECIALITY HOSPITALS PRIVATE LIMITED",
"KARUNA BULLION PRIVATE LIMITED",
"KARUNA DISTRIBUTORS PRIVATE LIMITED",
"KARUNA ENGINEERS PRIVATE LIMITED",
"KARUNA FINANCIAL SERVICES PVT LTD",
"KARUNA GREENTECH PRIVTAE LIMITED",
"KARUNA HOSPITAL",
"KARUNA MANAGEMENT SERVICES LIMITED",
"KARUNA MOTORS (GULBARGA) PRIVATE LIMITED",
"KARUNA NIKETAN HIGH SCHOOL BALASINOR",
"KARUNA VENTURES PRIVATE LIMITED",
"KARUNADU COMMUNICATIONS PRIVATE LIMITED",
"KARUNADU ONCOLOGY HAEMATOLOGY ASSOCIATES PRIVATE LIMITED",
"KARUNADU SERVICES PRIVATE LIMITED",
"KARUNAKARAN WHEELS INDIA PRIVATE LIMITED",
"KARUNAMOYEE COMMOSALE PRIVATE LIMITED",
"KARUNANAND HYDRO PNEUMATIC CONTROLS PRIVATE LIMITED",
"KARUNANIDHAN AGRO TECH PRIVATE LIMITED",
"KARUNANIDHAN ENTERPRISES PRIVATE LIMITED",
"KARUNASAGAR VIDHYALAY",
"KARUNASHRAYA MEDICAL AND RESEARCH CENTRE PRIVATE LIMITED",
"KARUNYA AQUA FARMS PRIVATE LIMITED",
"KARUNYA INSTITUTE OF TECHNOLOGY- 641114",
"KARUNYA KURIES PRIVATE LIMITED",
"KARUPPASWAMY BUILDERS PRIVATE LIMITED",
"KARUR COTTON MILLS PRIVATE LIMITED",
"KARUR FINANCE PRIVATE LIMITED",
"KARUR GOLD FINANCE",
"KARUR SREE RAMA TRADING PRIVATE LIMITED",
"KARUR SRI RAMA WIND ENERGY PRIVATE LIMITED",
"KARUR TEXTILE PARK PRIVATE LIMITED",
"KARUR TRANSMISSION LIMITED",
"KARUR VYSYA BANK",
"KARUR WIND ENERGY PRIVATE LIMITED",
"KARUVANTHALA HOTELS AND RESORTS PRIVATE LIMITED",
"KARUYAKI SOLUTIONS PRIVATE LIMITED",
"KARVANSARAI INVESTMENTS PRIVATE LIMITED",
"KARVAT COVERMORE ASSIST PRIVATE LIMITED",
"KARVE INFRA SOLUTIONS PRIVATE LIMITED",
"KARVEER TEXTILES PRIVATE LIMITED",
"KARVEN INFRASTRUCTURE PRIVATE LIMITED",
"KARVI DRUGS PRIVATE LIMITED",
"KARVI WORLD TRAVELS PRIVATE LIMITED",
"KARVIN POWER SYSTEMS PRIVATE LIMITED",
"KARVY ANALYTICS LIMITED",
"KARVY CAPITAL LIMITED",
"KARVY COMPUTERSHARE PRIVATE LIMITED",
"KARVY COMTRADE LIMITED",
"KARVY DATA MANAGEMENT SERVICES LIMITED",
"KARVY FINANCIAL SERVICES LIMITED",
"KARVY FORDE SEARCH PRIVATE LIMITED",
"KARVY FOREX AND CURRENCIES PRIVATE LIMITED",
"KARVY GLOBAL SERVICES LIMITED",
"KARVY INFOTECH PRIVATE LIMITED",
"KARVY INSURANCE REPOSITORY LIMITED",
"KARVY INVESTOR SERVICES LIMITED",
"KARVY NEXT LIMITED",
"KARVY RENEWABLE ENERGY PROJECTS LIMITED",
"KARVY TECHNOLOGIES PRIVATE LIMITED",
"KARVY THERAPEUTICS PRIVATE LIMITED",
"KARWA COMMERCIAL PRIVATE LIMITED",
"KARWA CONSOLIDATED MARKETING LIMITED",
"KARWA SECURITIES LIMITED",
"KARWA SPINNERS PRIVATE LIMITED",
"KARWA VANIJYA PRIVATE LIMITED",
"KARWA YARN PRIVATE LIMITED",
"KARYA INDUSTRIES PRIVATE LIMITED",
"KARYA TECHNOLOGIES INDIA PRIVATE LIMITED",
"KARYALAI UP NIDESHAK VIDYUT SURAKSHA BLY",
"KARYALAY AATIRIKT SAHAYAK VIKAS AAYUKT JANPAD PANCHAYAT GOGAWA",
"KARYALAY ADHISHASHI ABHIYANTA",
"KARYALAY ANUVIBHAGIYA ADHIKARI LOK NIRMAN VIBHAG UPSAMBHAG MAHIDPUR",
"KARYALAY DISTRICT COMMANDENT S D E R F JILA UJJAIN",
"KARYALAY JANPAD PANCHAYA RATLAM",
"KARYALAY JANPAD PANCHAYAT ALOTE",
"KARYALAY JANPAD PANCHAYAT BAJNA DIST RATLAM",
"KARYALAY JANPAD PANCHAYAT DIST SEHORE [MP]",
"KARYALAY JANPAD PANCHAYAT FANDA BHOPAL",
"KARYALAY JANPAD PANCHAYAT MAHIDPUR M P",
"KARYALAY JANPAD PANCHAYAT MAJHOLI JILA JABALPUR",
"KARYALAY JANPAD PANCHAYAT SAILANA DIST RATLAM",
"KARYALAY JILA PANCHAYAT RAISEN",
"KARYALAY JILA UDYAN ADHIKARI LUCKNOW",
"KARYALAY KARYAPALAN YANTRI TAWA NAHAR SAMBHAG SEONI MALWA",
"KARYALAY KRASHI UPAJ MANDI SAMITI KHACHROUD DIST UJJAIN",
"KARYALAY KRASHI UPAJ MANDI SAMITI MAHIDPUR DIST UJJAIN",
"KARYALAY KRISHI UPAJ MANDI SAMITI",
"KARYALAY KRISHI UPAJ MANDI SAMITI BADNAWAR DIST DHAR",
"KARYALAY MAHAPRABANDHAK MP GRAMIN SADAK VIKAS PRADHIKARAN PIU-1 UJJAIN",
"KARYALAY MUKHYA CHIKITSHA AVAM AADHIKARI",
"KARYALAY NAGAR PALIKA PARISAD SARANGARH",
"KARYALAY NAGAR PALIKA PARISHAD NAGDA DIST UJJAIN",
"KARYALAY NAGAR PALIKA PARISHAD SEHORE",
"KARYALAY NAGAR PARISHAD ALOT DIST RATLAM",
"KARYALAY NAGAR PARISHAD MAKDONE",
"KARYALAY NAGAR PARISHAD PATAN JILA JABALPUR",
"KARYALAY NAGAR PARISHAD SARANGARH",
"KARYALAY NAGAR PARISHAD SOKATCH JILA DEWAS MP",
"KARYALAY PRACHARYA GOVERNMENT POLYTECHNIC MAHAVIDHYALAY JAORA",
"KARYALAY PRATHMIK KRISHI SAKH SAHKARI SANSTHA MARYADIT BHENSODA",
"KARYALAY RAHMANIA INTER COLLEGE MAUDAHA HAMIRPUR",
"KARYALAY SAHAYAK MAHANIRICHHAK NIBANDHAN PRAYAGRAJ",
"KARYALAY SAMBHAGYA KHADYA NIYANTRAK PRAYAGRAJ",
"KARYALAY SANYUKT SANCHALAK AVAN ADHIKSHAK HAMIDIA CHIKITSALAY BHOPAL",
"KARYALAY VAN SANRAKSHAK LUPTPRAY PARIYOJNA UTTAR PRADESH LUCKNOW",
"KARYALAYA ADHISHASI ABHIYANTA MIRZAPUR NAHAR PRAKHAND",
"KARYALAYA DISTRICT COMMANDED",
"KARYALAYA JANPAD PANCHAYAT DEWAS",
"KARYALAYA JANPAD PANCHAYAT KHALWA",
"KARYALAYA JANPAD PANCHAYAT PANDHANA",
"KARYALAYA JILA ANTYAWASAYI SAHKARI VIKAS SAMITI MARYADIT",
"KARYALAYA NAGAR PALIKA PARISHAD HAMIRPUR UTTAR PRADESH",
"KARYALAYA NAGAR PANCHAYAT RAJPUR DISTRICT BALRAMPUR",
"KARYALAYA NAGAR PARISHAD UMRED",
"KARYALAYA PRACHARYA BHAGIRATH JI SILAWAT SHASHKIYA MAHAVIDHYALAYA DEPLAPUR JILA INDORE",
"KARYALAYA SANYUKT GANNA AYUKT BAREILLY",
"KARYALAYA ZILADHIKARI SANGRAH ANUBHAG LKO",
"KARYALIYE SAHKARI GANNA VIKAS SAMITI LIMITED",
"KARYAN AGRO FLAVOURS (INDIA) PRIVATE LIMITED",
"KARYASIDDHI ENVIRONMENTAL ENGINEERING COMPANY PRIVATE LIMITED",
"KARYAVATTOM SPORTS FACILITIES LIMITED",
"KARYON HEALTHYCO FOREVER LLP",
"KARYOTICA BIOLOGICALS PRIVATE LIMITED",
"KARZA TECHNOLOGIES PRIVATE LIMITED",
"KAS AUTO POLYMERS INDIA PRIVATE LIMITED",
"KAS CAREWEARS PRIVATE LIMITED",
"KAS DIRECT SOURCING PRIVATE LIMITED",
"KAS INDUSTRIES INDIA PRIVATE LIMITED",
"KAS MED PRIVATE LIMITED",
"KAS POWER SOLUTIONS PRIVATE LIMITED",
"KAS SERVICES INDIA PRIVATE LIMITED",
"KASA ANLAGEN INDIA PRIVATE LIMITED",
"KASA CEREMICS PRIVATE LIMITED",
"KASA CHEMICALS PRIVATE LIMITED",
"KASA DEVELOPMENT PVT LTD",
"KASA LIGHTS & ELECTRONICS PRIVATE LIMITED",
"KASA TECHNOLOGIES LIMITED",
"KASA VENTURES PRIVATE LIMITED",
"KASAI INDIA CHENNAI PRIVATE LIMITED",
"KASANA BUILDERS PRIVATE LIMITED",
"KASANA FOODS PRIVATE LIMITED",
"KASANA LOGISTICS PRIVATE LIMITED",
"KASAT AGRO INDUSTRIES PRIVATE LIMITED",
"KASAT SECURITIES PRIVATE LIMITED",
"KASATEX HOME FURNISHING PRIVATE LIMITED",
"KASAULI CLUB LIMITED",
"KASAULI CONSTRUCTIONS PRIVATE LIMITED",
"KASBA PARIDHAN PRIVATE LIMITED",
"KASBE TADVALE AGRO PRODUCER COMPANY LIMITED",
"KASCAP GLASS PRIVATE LIMITED",
"KASCHURA DESIGN CENTRE PRIVATE LIMITED",
"KASCO INDUSTRIES PRIVATE LIMITED",
"KASERA ELECTRICALS PRIVATE LIMITED",
"KASERA HEAT EXCHANGER PRIVATE LIMITED",
"KASERA IRON & STEEL PRIVATE LIMITED",
"KASETTI TECHNOLOGIES PRIVATE LIMITED",
"KASH FOODS PRIVATE LIMITED",
"KASH INDUSTRIES PRIVATE LIMITED",
"KASH IT SOLUTIONS LIMITED",
"KASH LOGISTICS PRIVATE LIMITED",
"KASH MEDICARE PRIVATE LIMITED",
"KASH MULTI TRADE PRIVATE LIMITED",
"KASH VENTURE TRAVELS PRIVATE LIMITED",
"KASHA KAKES PRIVATE LIMITED",
"KASHCHEM AGENCIES PRIVATE LIMITED",
"KASHEC ENGINEERS PRIVATE LIMITED",
"KASHEDI PARSHURAM HIGHWAYS PRIVATE LIMITED",
"KASHI CAPITAL PRIVATE LIMITED",
"KASHI GREEN INFRATECH PRIVATE LIMITED",
"KASHI IMPEX PRIVATE LIMITED",
"KASHI JEET MARKETING PRIVATE LIMITED",
"KASHI KANCHAN PRIVATE LIMITED",
"KASHI MAHADEVA DEVELOPERS PRIVATE LIMITED",
"KASHI METALFAB PRIVATE LIMITED",
"KASHI NATH ENGINEERING PRIVATE LIMITED",
"KASHI PLASTIC UDYOG PRIVATE LIMITED",
"KASHI POLY PACK PRIVATE LIMITED",
"KASHI SECURITY AND CONSULTING SERVICES PRIVATE LIMITED",
"KASHI VISHWANATH STEELS PRIVATE LIMITED",
"KASHI VISHWANATH TEXTILE MILL PRIVATE LIMITED",
"KASHI WELFAB PRIVATE LIMITED",
"KASHIBAI UKHAJI KOLHE VIDYALAYA JALGAON",
"KASHIBEN CHILDREN HOSPITAL",
"KASHIKA HOTEL INDUSTRIES PRIVATE LIMITED",
"KASHIMIRA CERAMICS PRIVATE LIMITED",
"KASHIMOKSHA SPIRITUAL PRIVATE LIMITED",
"KASHIMPUR HIGH SCHOOL",
"KASHINATH AGRO INDUSTRIES PRIVATE LIMITED",
"KASHINATH ENTERPRISES PRIVATE LIMITED",
"KASHINATH GOLD TRADE PRIVATE LIMITED",
"KASHINATH RICE MILL PRIVATE LIMITED",
"KASHIPUR AGRO INDUSTRIES PRIVATE LIMITED",
"KASHIPUR HOLDINGS LIMITED",
"KASHIPUR INFRASTRUCTURE AND FREIGHT TERMINAL PRIVATE LIMITED",
"KASHIPUR RICE MILLS PRIVATE LIMITED",
"KASHIPUR SITARGANJ HIGHWAYS PRIVATE LIMITED",
"KASHIRAJ SUPPLY PVT LTD",
"KASHISH DEVELOPERS LIMITED",
"KASHISH FOREX WORLD PRIVATE LIMITED",
"KASHISH GARMENTS PRIVATE LIMITED",
"KASHISH GLOBAL WORK SERVICES PRIVATE LIMITED",
"KASHISH METALLICS PRIVATE LIMITED",
"KASHISH OPTICS LIMITED",
"KASHISH PLASTICS PRIVATE LIMITED",
"KASHISH TECHNO PACK PRIVATE LIMITED",
"KASHISH TEX PRIVATE LIMITED",
"KASHISWARI PATHSHALA",
"KASHIV BIOSCIENCES PRIVATE LIMITED",
"KASHIVISHWANATH PIPES PRIVATE LIMITED",
"KASHLIWAL AGENCIES PRIVATE LIMITED",
"KASHLIWAL AUTO PRIVATE LIMITED",
"KASHLIWAL ENTERPRISES PRIVATE LIMITED",
"KASHMEEN COMMODITIES PRIVATE LIMITED",
"KASHMIERA APPARELS PRIVATE LIMITED",
"KASHMIK FORMULATION PRIVATE LIMITED",
"KASHMIR AUTOMOBILE PRIVATE LIMITED",
"KASHMIR HYGIENICS PRIVATE LIMITED",
"KASHMIR LOOM COMPANY PRIVATE LIMITED.",
"KASHMIR PREMIUM APPLES PRIVATE LIMITED",
"KASHMIR SURGICAL INDIA PRIVATE LIMITED",
"KASHMIR VALLEY MOTOR PRIVATE LIMITED",
"KASHMIR WALNUT OVERSEAS PRIVATE LIMITED",
"KASHMIR WEAVERS PRIVATE LIMITED",
"KASHMIRA EXPORTS PRIVATE LIMITED",
"KASHMIRA INVESTMENT AND LEASING PRIVATE LIMITED",
"KASHMIRA TRADER",
"KASHMIRI LAL CONSTRUCTIONS PRIVATE LIMITED",
"KASHMIRI LAL TARUN KHANNA PVT LTD",
"KASHTA MADHYAMIK VIDYALAY",
"KASHTAMANDUP DEVELOPERS PRIVATE LIMITED",
"KASHVI DESIGNS PRIVATE LIMITED",
"KASHVI INTERNATIONAL PRIVATE LIMITED",
"KASHVI JEWELS PRIVATE LIMITED",
"KASHVI POWER & STEEL PRIVATE LIMITED",
"KASHVIN SEEDS PRIVATE LIMITED",
"KASHYAP CONSTRUCTION",
"KASHYAP GEO TECHNICAL ENGINEERS PRIVATE LIMITED",
"KASHYAP GREEN HOMES PRIVATE LIMITED",
"KASHYAP INFRAPROJECTS PRIVATE LIMITED",
"KASHYAP INFRATECH PRIVATE LIMITED",
"KASHYAP PACKAGING PRIVATE LIMITED",
"KASHYAP SHIPPING PVT LTD",
"KASHYAPI INFRASTRUCTURE PRIVATE LIMITED",
"KASHYP TECHNOENGICON INDIA PRIVATE LIMITED",
"KASI SALES & SERVICES PRIVATE LIMITED",
"KASIM TEXTILE MILLS PRIVATE LIMITED",
"KASIPALAYAM COMMON EFFLUENT TREATMENT PLANT PRIVATE LIMITED",
"KASIREDDY NARAYANREDDY COLLEGE OF ENGINEERING & RESEARCH",
"KASIVISWANATHAN MEDICAL AGENCIES PRIVATE LIMITED",
"KASLIWAL AUTOMOBILES PRIVATE LIMITED",
"KASLIWAL AUTOMOTIVES PRIVATE LIMITED",
"KASLIWAL ENERGY PRIVATE LIMITED",
"KASLIWAL GEM PALACE PRIVATE LIMITED",
"KASLIWAL PIPES PRIVATE LIMITED",
"KASLIWAL PROJECTS PRIVATE LIMITED",
"KASLIWAL SANITARY PRIVATE LIMITED",
"KASLIWAL TRUCKING PRIVATE LIMITED",
"KASOJAN TEA CO PVT LTD",
"KASPEN IT SOLUTIONS PRIVATE LIMITED",
"KASPLO INTERNET PRIVATE LIMITED",
"KASPON TECHWORKS PRIVATE LIMITED",
"KASPRS BUILD MATE PRIVATE LIMITED",
"KASS TRAVELS PRIVATE LIMITED",
"KASSEL EXPORTS PRIVATE LIMITED",
"KASSIMS FOOD CHAIN PRIVATE LIMITED",
"KASSTECH AEROSPACE PRIVATE LIMITED",
"KASTECH SOFTWARE SOLUTIONS INDIA PRIVATE LIMITED",
"KASTH UDYOG PRIVATE LIMITED",
"KASTHURI HOSPITAL",
"KASTHURI MEDIAS PRIVATE LIMITED",
"KASTHURI SUPER STORE PRIVATE LIMITED",
"KASTINO MACHINES & TECHNOLOGIES PRIVATE LIMITED",
"KASTNER TRADING PRIVATE LIMITED",
"KASTUGY DENIMS PRIVATE LIMITED",
"KASTUR BHAI LALBHAI MUSEUM (INDIA) PRIVATE LIMITED",
"KASTURA MEDICOS LIMITED",
"KASTURBA GANDHI BALIKA VIDYALAYA SCHOOL",
"KASTURBA GANDHI HOS FOR WOMEN CHILD",
"KASTURBA HOSPITAL",
"KASTURBA KANYA VIDYALAYA ANAND",
"KASTURBA MEDICAL COLLEGE",
"KASTURCHAND FERTILISERS PRIVATE LIMITED",
"KASTURI & SONS LIMITED",
"KASTURI AGENTS PVT LTD",
"KASTURI AQUA LIFE PRODUCTS PRIVATE LIMITED",
"KASTURI AUTOMATION PRIVATE LIMITED",
"KASTURI FARM PRIVATE LIMITED",
"KASTURI FOUNDRY PRIVATE LIMITED",
"KASTURI HOUSING PRIVATE LIMITED",
"KASTURI INFRACON PRIVATE LIMITED",
"KASTURI INTERNATIONAL PRIVATE LIMITED",
"KASTURI JEWELLERS PRIVATE LIMITED",
"KASTURI K12 SERVICES PRIVATE LIMITED",
"KASTURI MEDICAL CENTRE PRIVATE LIMITED",
"KASTURI METAL COMPOSITE PRIVATE LIMITED",
"KASTURI MULTI SOLUTIONS PRIVATE LIMITED",
"KASTURI MULTI SPECIALITY MEDICARE PRIVATE LIMITED",
"KASTURI PRESTRESS PRIVATE LIMITED",
"KASTURI RAM AGRO PRODUCT LIMITED",
"KASTURI RAM INTERNATIONAL SCHOOL",
"KASTURI RAM SCIENCE AND TECHNOLOGICAL PARK LIMITED",
"KASTURI STEEL ALLOYS PRIVATE LIMITED",
"KASTURI TRADING COMPANY PVT LTD",
"KASTURIBA GANDHI COLLEGE",
"KASTURI-POORNACHANDRA DEVELOPERS PRIVATE LIMITED",
"KASU ELECTRICALS PRIVATE LIMITED",
"KASUKA CONSULTING PRIVATE LIMITED",
"KASV LOGISTIC PRIVATE LIMITED",
"KASWA FINLEASE PRIVATE LIMITED",
"KASWA IMPEX PRIVATE LIMITED",
"KASYAP DEVELOPERS PRIVATE LIMITED",
"KASYAP SWEETNERS LIMITED",
"KASYAP SWEETNERS PRIVATE LIMITED",
"KAT CONTROLS PRIVATE LIMITED",
"KATAKAM INFRA PROJECTS (INDIA) PRIVATE LIMITED",
"KATALINE INFRA-PRODUCTS PRIVATE LIMITED",
"KATALIST VIEWSPAPER PRIVATE LIMITED",
"KATALYST ADVISORS PRIVATE LIMITED",
"KATALYST BUSINESS SOLUTIONS PRIVATE LIMITED",
"KATALYST ENTERTAINMENT PRIVATE LIMITED",
"KATALYST SOFTWARE SERVICES LIMITED",
"KATALYST SOFTWARE SERVICES PRIVATE LIMITED",
"KATAMA BIOMED PRIVATE LIMITED",
"KATANAMECH SOLUTIONS PRIVATE LIMITED",
"KATARA DENTAL PVT LTD",
"KATARA ESTATES PRIVATE LIMITED",
"KATARA STONE CRUSHER PRIVATE LIMITED",
"KATARE SPINNING MILLS LIMITED",
"KATARIA AUTOMOBILES PRIVATE LIMITED",
"KATARIA AUTOZONE PRIVATE LIMITED",
"KATARIA BUILTECK PRIVATE LIMITED",
"KATARIA CARRIERS",
"KATARIA CONSTRUCTIONS PRIVATE LIMITED",
"KATARIA DHULCHAND PANNALAL JEWELLERS PRIVATE LIMITED",
"KATARIA ECOTECH PRIVATE LIMITED",
"KATARIA EYE& ENT HOSPITAL PRIVATE LIMITED",
"KATARIA FABS INTERNATIONAL PRIVATE LIMITED",
"KATARIA FOODS PRIVATE LIMITED",
"KATARIA GOLD JEWELLERY PRIVATE LIMITED",
"KATARIA HOME FURNISHING PRIVATE LIMITED",
"KATARIA INDIA ENTERPRISES PRIVATE LIMITED",
"KATARIA INDUSTRIAL PARK PRIVATE LIMITED",
"KATARIA INDUSTRIES LIMITED",
"KATARIA INDUSTRIES PRIVATE LIMITED",
"KATARIA INFRASTRUCTURE PRIVATE LIMITED",
"KATARIA INSURANCE BROKERS PRIVATE LIMITED",
"KATARIA IRRIGATION PRIVATE LIMITED",
"KATARIA JEWELLERS PRIVATE LIMITED",
"KATARIA MOTORS PRIVATE LIMITED",
"KATARIA PACKAGING PRIVATE LIMITED",
"KATARIA PIPES PRIVATE LIMITED",
"KATARIA PLASTICS PRIVATE LIMITED",
"KATARIA SNACK PELLETS PRIVATE LIMITED",
"KATARIA WIRES PRIVATE LIMITED",
"KATARIYA AGRO PRIVATE LIMITED",
"KATARIYA ASSOCIATES PRIVATE LIMITED",
"KATARIYA INFRA PROJECT PRIVATE LIMITED",
"KATARIYA POLYMERS PRIVATE LIMITED",
"KATARIYAA COILS PRIVATE LIMITED",
"KATASHI INTERNATIONAL PRIVATE LIMITED",
"KATDARE FOOD PRODUCTS PRIVATE LIMITED",
"KATE FOOD INDUSTRIES PRIVATE LIMITED",
"KATE MOTORS PRIVATE LIMITED",
"KATEEL ENGINEERING INDUSTRY PRIVATE LIMITED",
"KATEEL FOOD & BEVERAGES PRIVATE LIMITED",
"KATEELESHWARI DEVELOPERS PRIVATE LIMITED",
"KATERRA INDIA PRIVATE LIMITED",
"KATERRA TECHNOLOGIES PRIVATE LIMITED",
"KATERRA TECHNOLOGY SERVICES LLP",
"KATEX DYEING AND PRINTING MILLS PRIVATE LIMITED",
"KATEX EXIM LIMITED",
"KATEX EXIM PRIVATE LIMITED",
"KATGORA SRI KRISHNA KRISHAK HIMGHAR PRIVATE LIMITED",
"KATHA O KAHINI (BOOK SELLERS) PVT LTD",
"KATHED MOTORS PRIVATE LIMITED",
"KATHERI INDUSTRIAL PRIVATE LIMITED",
"KATHGODOWN LUXE INDIA PRIVATE LIMITED",
"KATHIR COLLEGE OF ENFINEERING",
"KATHIR MEMORIAL HOSPITAL PRIVATE LIMITED",
"KATHIR MOTORS PRIVATE LIMITED",
"KATHLEHO ELEVATORS INDIA PRIVATE LIMITED",
"KATHO INTERIOR PRODUCTS PRIVATE LIMITED",
"KATHRANI EXPORTS (INDIA) PRIVATE LIMITED",
"KATHREIN INDIA PRIVATE LIMITED",
"KATHURIA MEDICAL AGENCIES PRIVATE LIMITED",
"KATHURIA ROLL MILL PRIVATE LIMITED",
"KATHURIA STEELS PRIVATE LIMITED",
"KATHURIA TECHMECH PRIVATE LIMITED",
"KATHYA TECH PRIVATE LIMITED",
"KATHYAYANI MEDCARE SERVICES PRIVATE LIMITED",
"KATIA EDUCATION INSTITUTE",
"KATIAL SPORTS & CHEMICALS PRIVATE LIMITED",
"KATIC INFRASTRUCTURES PRIVATE LIMITED",
"KATIHAR FLOUR MILLS PVT LTD",
"KATIKANENI HOTELS AND RESORTS PRIVATE LIMITED",
"KATIRA BUILDTRANS PRIVATE LIMITED",
"KATIRA CONSTRUCTION LIMITED",
"KATIRA HOTELS PRIVATE LIMITED",
"KATIYAR COLD STORAGE PRIVATE LIMITED",
"KATLAX ENTERPRISES PRIVATE LIMITED",
"KATLEGO FOODS INDIA PRIVATE LIMITED",
"KATLEGO FURNISHINGS INDIA PRIVATE LIMITED",
"KATM TECHNOLOGIES PRIVATE LIMITED",
"KATNI BAUXITE PRIVATE LIMITED",
"KATNI HOSPITAL PRIVATE LIMITED",
"KATNI MINERALS PVT LTD",
"KATNI MSW MANAGEMENT PRIVATE LIMITED",
"KATNI REALTY PRIVATE LIMITED",
"KATOOSH INTERIORS PRIVATE LIMITED",
"KATOUR GLOBAL PRIVATE LIMITED",
"KATRA PHYTOCHEM INDIA PRIVATE LIMITED",
"KATRAGADDA ENGINEERING SERVICES PRIVATE LIMITED",
"KATRIYA INSTITUTE OF EXCELLENCE IN HOTEL MANAGEMENT",
"KATROLIA EXIM PRIVATE LIMITED",
"KATS HOLDINGS PRIVATE LIMITED",
"KAT'S ORGANICS PVT LTD",
"KATSTECH PRIVATE LIMITED",
"KATSU COFFEE PRIVATE LIMITED",
"KATSUSHIRO MATEX INDIA PRIVATE LIMITED",
"KATTA HOSPITAL ORTHOPAEDIC CENTRE",
"KATTAMURI JEWELLERS PRIVATE LIMITED",
"KATTERRA DESIGN PRIVATE LIMITED",
"KATTILAMMA DISTRIBUTORS",
"KATTI-MA EXPORTS PRIVATE LIMITED",
"KATTI-MA LLP",
"KATTYA SEEDS PRIVATE LIMITED",
"KATWA CEMENTS PRIVATE LIMITED",
"KATYAAYANI SALES & SERVICES PRIVATE LIMITED",
"KATYAINI PRODUCTS PRIVATE LIMITED",
"KATYAL INFRASTRUCTURE PRIVATE LIMITED",
"KATYAL METAL AGENCIES PRIVATE LIMITED",
"KATYAL TRADERS PRIVATE LIMITED",
"KATYAL TRADEX PRIVATE LIMITED",
"KATYANI ABRASIVES & PAINTS PRIVATE LIMITED",
"KATYANI BEVERAGES & AGRO PRODUCTS PRIVATE LIMITED",
"KATYANI ENERGY SOLUTION PRIVATE LIMITED",
"KATYANI FRESH FRUITS PRIVATE LIMITED",
"KATYANI FUELS",
"KATYANI PLASTIC UDYOG PRIVATE LIMITED",
"KATYAYAN BUILDERS & CONTRACTORS PRIVATE LIMITED",
"KATYAYAN HR SOLUTIONS PRIVATE LIMITED",
"KATYAYAN MERCANTILE AND TRADING PRIVATE LIMITED",
"KATYAYAN SECURITY SERVICES PRIVATE LIMITED",
"KATYAYANI CREATIONS (INDIA) PRIVATE LIMITED",
"KATYAYANI HEALTHCARE PRIVATE LIMITED",
"KATYAYANI TELECOM SERVICES PRIVATE LIMITED",
"KATYAYANI TRADEZONE PRIVATE LIMITED",
"KATYAYINI PAPER MILLS PRIVATE LIMITED",
"KATYAYINI TISSUES PRIVATE LIMITED",
"KATYAYNI CONTRACTORS PRIVATE LIMITED",
"KATYAYNI NATURAL RESOURCES LIMITED",
"KATZION TECHNOLOGY SOLUTIONS LLP",
"KATZUNG PHARMACEUTICALS PRIVATE LIMITED",
"KAULGUD CONSTRUCTIONS PRIVATE LIMITED",
"KAUMARAM SUSHILA INTERNATIONAL RESIDENTIAL SCHOOL",
"KAUNANYA MINERALS & METALS PRIVATE LIMITED",
"KAUNTEYA OVERSEAS PRIVATE LIMITED",
"KAUNTIA CASTINGS LTD",
"KAUNTIA MOTOR WORKS PVT LTD",
"KAUNYA LOGISTICS PRIVATE LIMITED",
"KAUP INDIA MATERIAL HANDLING PRIVATE LIMITED",
"KAUR & SINGH PROJECTS & CONSTRUCTIONS PRIVATE LIMITED",
"KAUR SAIN SPINNING MILLS",
"KAURTURE DESIGNS PRIVATE LIMITED",
"KAUSALYA PRIME ISPAT PRIVATE LIMITED",
"KAUSALYA SHELTERS PRIVATE LIMITED",
"KAUSALYAM FINANCIAL SERVICES PRIVATE LIMITED",
"KAUSHAL AGROILS PRIVATE LIMITED",
"KAUSHAL AROMATIC CHEMICALS PRIVATE LIMITED",
"KAUSHAL ARTS PRIVATE LIMITED",
"KAUSHAL ENGINEERING LIMITED",
"KAUSHAL FERRO METALS PRIVATE LIMITED",
"KAUSHAL HEALTHCARE PRIVATE LIMITED",
"KAUSHAL INTERIORS PRIVATE LIMITED",
"KAUSHAL KANCHAN CONSTRUCTION PVT LTD",
"KAUSHAL KISAN BIO PLANTTEC PRIVATE LIMITED",
"KAUSHAL KUSHAL PARCEL SERVICES PRIVATE LIMITED",
"KAUSHAL PHARMACEUTICALS PRIVATE LIMITED",
"KAUSHAL POLYMERS PRIVATE LIMITED",
"KAUSHAL POWER & STEEL PRIVATE LIMITED",
"KAUSHAL SOLAR EQUIPMENTS PVT LTD",
"KAUSHAL VIDYABHAVAN",
"KAUSHALAM DIGITAL PRIVATE LIMITED",
"KAUSHALGRAM RURAL SERVICES PRIVATE LIMITED",
"KAUSHALI INTERNATIONAL",
"KAUSHALPATI INFRA EQUIPMENTS PRIVATE LIMITED",
"KAUSHALYA AQUA MARINE PRODUCT EXPORTS PRIVATE LIMITED",
"KAUSHALYA BUILDCON PRIVATE LIMITED",
"KAUSHALYA ESTATE PRIVATE LIMITED",
"KAUSHALYA INFRASTRUCTURE DEVELOPMENT CORPORATION LTD",
"KAUSHALYA LOGISTICS LIMITED",
"KAUSHALYA NIRMAN PRIVATE LIMITED",
"KAUSHALYA ROLLER FLOUR MILLS PRIVATE LIMITED",
"KAUSHALYA TOWNSHIP PRIVATE LIMITED",
"KAUSHEYAM NATURAL TEXTILES PRIVATE LIMITED",
"KAUSHICO MACHINE TOOLS PRIVATE LIMITED",
"KAUSHIK FLOUR MILLS PRIVATE LIMITED",
"KAUSHIK HOSIERY PRIVATE LIMITED",
"KAUSHIK INTERNATIONAL POLYBLENDS PRIVATE LIMITED",
"KAUSHIK MOTORS PRIVATE LIMITED",
"KAUSHIK REALTECHS LIMITED",
"KAUSHIK ROADWAYS PRIVATE LIMITED",
"KAUSHIK ROLLFORMERS PRIVATE LIMITED",
"KAUSHIK UDYOG PRIVATE LIMITED",
"KAUSHIK WEAVETEX PRIVATE LIMITED",
"KAUSHIKEE JANTA ADARSH EDUCATION FOUNDATION",
"KAUSHIKEE MAHILA MILK PRODUCER COMPANY LIMITED",
"KAUSHIKI SHOES PRIVATE LIMITED",
"KAUSHLYA MEDICAL AND RESEARCH CENTRE PRIVATE LIMITED",
"KAUSHNIK BUILDCAST PRIVATE LIMITED",
"KAUSIKH THERAPEUTICS PRIVATE LIMITED",
"KAUSTHUBHA PROJECT PRIVATE LIMITED",
"KAUSTUBH CONSTRUCTION PRIVATE LIMITED",
"KAUSTUBH ENGINEERING FAB & ERECTORS",
"KAUSTUBH INDUSTRIES PRIVATE LIMITED",
"KAUSTUBH PATH LAB",
"KAUSTUBH ROOFING INDUSTRIES PRIVATE LIMITED",
"KAUSTUBHA MEDIAWORKS PRIVATE LIMITED",
"KAUSTUBHA SCIENTIFIC RESEARCH LABORATORY PRIVATE LIMITED",
"KAUT CONCEPTS MANAGEMENT PRIVATE LIMITED",
"KAUTAGE FURNISHINGS PRIVATE LIMITED",
"KAUTELCO PRIVATE LIMITED",
"KAUTEX PLASTIC TECHNOLOGY GUJARAT PRIVATE LIMITED",
"KAUTILYA ACADEMY",
"KAUTILYA ACADEMY PRIVATE LIMITED",
"KAUTILYA FINANCE INVESTMENT ADVISORS LLP",
"KAUTILYA GOVT. SARVODAYA BAL VIDYALAYA",
"KAUTILYA INDUSTRIES PRIVATE LIMITED UNIT II",
"KAUTILYA INFRATECH PRIVATE LIMITED",
"KAUTILYA MULTI CREATION PRIVATE LIMITED",
"KAUTILYA TRADERS PVT.LTD.",
"KAUTUKI AGRO PRODUCTS PRIVATE LIMITED",
"KAUVERY HOSPITAL MEDICAL SERVICES PRIVATE LIMITED",
"KAUVERY HOSPITALS (BENGALURU) PRIVATE LIMITED",
"KAUZER TECHNOLOGIES & SYSTEMS (PRIVATE) LIMITED",
"KAUZI FOOD & BEVERAGE SERVICES PRIVATE LIMITED",
"KAV ENGINEERING AND MARKETING PRIVATE LIMITED",
"KAVA FASHIONS PRIVATE LIMITED",
"KAVACH 9 PHARMA & RESEARCH PRIVATE LIMITED",
"KAVACH GLOBAL KONNECTS PRIVATE LIMITED",
"KAVAL POWER PRIVATE LIMITED",
"KAVALIFE PRIVATE LIMITED",
"KAVANAR LATEX LIMITED",
"KAVANA'S VENTURES PRIVATE LIMITED",
"KAVAS AGRO PRIVATE LIMITED",
"KAVASSU INTERNATIONAL PRIVATE LIMITED",
"KAVASSU NUTRITION & ORGANIC DAIRY PRIVATE LIMITED",
"KAVAYAH IT SOLUTIONS PRIVATE LIMITED",
"KAVEDIA JEWELLERS PRIVATE LIMITED",
"KAVEEN INFRA SOLUTIONS PRIVATE LIMITED",
"KAVEESHA ENGINEERING",
"KAVEESHA ENGINEERS INDIA PRIVATE LIMITED",
"KAVEL ENTERPRISE PRIVATE LIMITED",
"KAVEL INDUSTRIES PRIVATE LIMITED",
"KAVENE PRO BUSINESS PRIVATE LIMITED",
"KAVERI AGRO INDUSTRIES PRIVATE LIMITED",
"KAVERI ALLOY CASTINGS PRIVATE LIMITED",
"KAVERI AUTOMOBILES PRIVATE LIMITED",
"KAVERI COLLECTIONS PRIVATE LIMITED",
"KAVERI COTEX PRIVATE LIMITED",
"KAVERI DEALER PRIVATE LIMITED",
"KAVERI DIVYA HOTELS PRIVATE LIMITED",
"KAVERI ENERGY PRIVATE LIMITED",
"KAVERI FASHIONS PVT LTD",
"KAVERI GINNING INDUSTRIES PRIVATE LIMITED",
"KAVERI GINNING MILLS PRIVATE LIMITED",
"KAVERI GRAMINA BANK",
"KAVERI IMPEX PVT LTD",
"KAVERI INFRAPROJECTS PRIVATE LIMITED",
"KAVERI INFRASTRUCTURE PRIVATE LIMITED",
"KAVERI JEWELERS PRIVATE LIMITED",
"KAVERI MARKETTOKRATS PRIVATE LIMITED",
"KAVERI MEDI HOUSE PRIVATE LIMITED",
"KAVERI MEDITRADE PRIVATE LIMITED",
"KAVERI MERCANTILE LIMITED",
"KAVERI METALLISING AND COATING INDUSTRIES PRIVATE LIMITED",
"KAVERI MICROTECK PRIVATE LIMITED",
"KAVERI MINECHEM PRIVATE LIMITED",
"KAVERI PIPES",
"KAVERI PIPING SYSTEMS PRIVATE LIMITED",
"KAVERI PLASTO CONTAINERS PRIVATE LIMITED",
"KAVERI POLY INFRA MATERIAL SUPPLIERS",
"KAVERI PRINT PROCESS PRIVATE LIMITED",
"KAVERI PRINTERS PRIVATE LIMITED",
"KAVERI PUMPS PRIVATE LIMITED",
"KAVERI RENEWABLE ENERGY PRIVATE LIMITED",
"KAVERI RETREATS AND RESORTS LIMITED",
"KAVERI S BIO PROTEINS PRIVATE LIMITED",
"KAVERI SAREES PRIVATE LIMITED",
"KAVERI SEED COMPANY LIMITED",
"KAVERI SEED COMPANY LTD.",
"KAVERI SELECTIONS PRIVATE LIMITED",
"KAVERI SILK MILLS PRIVATE LIMITED",
"KAVERI SUPER MARKET PRIVATE LIMITED",
"KAVERI TECHNOBUILD PRIVATE LIMITED",
"KAVERI TUBES",
"KAVERI ULTRA POLYMERS PRIVATE LIMITED",
"KAVERI YARNS AND FABRICS LIMITED",
"KAVERY HOSPITAL HOSUR PRIVATE LIMITED",
"KAVI COMMERCIAL COMPANY LIMITED",
"KAVI CONTAINER PRIVATE LIMITED",
"KAVI ENTRADE PVT LTD",
"KAVI EPC PRIVATE LIMITED",
"KAVI FOODS PRIVATE LIMITED",
"KAVI POULTRIE",
"KAVIA ENGINEERING PRIVATE LIMITED",
"KAVIK ENTERPRISES PRIVATE LIMITED",
"KAVIL ROCK PRODUCTS INDIA PRIVATE LIMITED",
"KAVIN CARBONS PRIVATE LIMITED",
"KAVIN ENGINEERING AND SERVICES PRIVATE LIMITED",
"KAVIN MOTORS PRIVATE LIMITED",
"KAVINGANGA WEAVING MILLS PRIVATE LIMITED",
"KAVINTAN ENTERPRISES PRIVATE LIMITED",
"KAVIRAJ SECURITIES PRIVATE LIMITED",
"KAVIS FASHIONS PRIVATE LIMITED",
"KAVISH AUTOMOBILES PRIVATE LIMITED",
"KAVISH CRAFTS INDIA PRIVATE LIMITED",
"KAVISH FINSERV PRIVATE LIMITED",
"KAVISHA MOTORS PRIVATE LIMITED",
"KAVISHA PROCON PRIVATE LIMITED",
"KAVIT GREEN ENERGY PRIVATE LIMITED",
"KAVITA AGENCIES PRIVATE LIMITED",
"KAVITA ARNEJA HOTEL PRIVATE LIMITED",
"KAVITA AUXILIARIES PRIVATE LIMITED",
"KAVITA DIPAK JOGI",
"KAVITA DREAMHOMES PRIVATE LIMITED",
"KAVITA EXIM PRIVATE LIMITED",
"KAVITA FACILITY MANAGEMENT PRIVATE LIMITED",
"KAVITA LABELS INDIA PRIVATE LIMITED",
"KAVITA SOLAR ENERGY PRIVATE LIMITED",
"KAVITA WOMEN WEAR PRIVATE LIMITED",
"KAVITHAA SAND INDIA PRIVATE LIMITED",
"KAVITHALAYA PRODUCTIONS PRIVATE LIMITED",
"KAVITSU ROBOTRONIX PRIVATE LIMITED",
"KAVITSU TRANSMISSIONS PRIVATE LIMITED",
"KAVIVA LIFE SCIENCES LLP",
"KAVIYAN SCIENCE PACK PRIVATE LIMITED",
"KAVNIYA TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"KAVONE TECHNOLOGY PRIVATE LIMITED",
"KAVS TECHNOCRAFT PRIVATE LIMITED",
"KAVSET EXPORTS PRIVATE LIMITED",
"KAVUNGAL AGRO TECH PRIVATE LIMITED",
"KAVURI HILLS DEVELOPERS PRIVATE LIMITED",
"KAVV FOODS PRIVATE LIMITED",
"KAVVERI TELECOM PRODUCTS LIMITED",
"KAVYA ALLOY PRIVATE LIMITED",
"KAVYA BUILD-CON PRIVATE LIMITED",
"KAVYA DIAMONDS PRIVATE LIMITED",
"KAVYA DYEING AND PRINTING MILLS PRIVATE LIMITED",
"KAVYA FOOTWEAR PRIVATE LIMITED",
"KAVYA FOREX PRIVATE LIMITED",
"KAVYA JEWELS PRIVATE LIMITED",
"KAVYA PROJECTS PRIVATE LIMITED",
"KAVYA SKILLS PRIVATE LIMITED",
"KAVYA SOFTECH PRIVATE LIMITED",
"KAVYA TOUR AND TRAVELS (OPC) PRIVATE LIMITED",
"KAVYAA BUILDCON INDIA PRIVATE LIMITED",
"KAVYAM ENERGY PRIVATE LIMITED",
"KAVYANIDHI COMMODITIES PRIVATE LIMITED",
"KAVYANJALI ENGINEERING SOLUTIONS LLP",
"KAVYASREE MULTI SPECIALITY HOSPITALS PRIVATE LIMITED",
"KAVYATRI PAPER AND BOARD PRIVATE LIMITED",
"KAWA ENGINEERING WORKS PRIVATE LIMITED",
"KAWA PRESS SYSTEMS PRIVATE LIMITED",
"KAWAKEN STERLING SURFACTANTS PRIVATE LIMITED",
"KAWAL MOTORS PRIVATE LIMITED",
"KAWASAKI MANUFACTURING INDIA PRIVATE LIMITED",
"KAWASAKI ROBOTICS INDIA PRIVATE LIMITED",
"KAWASAKI SOLAR WAREHOUSING PRIVATE LIMITED",
"KAWASAKI-MK INDUSTRIES INDIA PRIVATE LIMITED",
"KAWATRA AGRO OILS PRIVATE LIMITED",
"KAWATRA PAPERS PRIVATE LIMITED",
"KAWATRA TENT & CATERERS PRIVATE LIMITED",
"KAWWALITY PAINTS AND COATINGS PRIVATE LIMITED",
"KAY AND SID CORPORATE PRIVATE LIMITED",
"KAY ART PRINTERS PRIVATE LIMITED",
"KAY AUTOMATICS PRIVATE LIMITED",
"KAY BEE AGRO FARMS PRIVATE LIMITED",
"KAY BEE BATTERIES PRIVATE LIMITED",
"KAY BEE BIO-ORGANICS PRIVATE LIMITED",
"KAY BEE FOUNDRY SERVICES PRIVATE LIMITED",
"KAY BEE INDUSTRIAL HOUSE PVT LTD",
"KAY BEE METALIKS PRIVATE LIMITED",
"KAY BEE POLYMERS PRIVATE LIMITED",
"KAY BOUVET ENGINEERING LTD",
"KAY CEE ENERGY & INFRA LIMITED",
"KAY CEE GENERATORS PRIVATE LIMITED",
"KAY CEE HOSIERY PRIVATE LIMITED",
"KAY CEE WOOLLEN MILLS PRIVATE LIMITED",
"KAY CHANDRA IRON ENGINEERING WORKS PRIVATE LIMITED",
"KAY DEE AUDIOVISIONS PRIVATE LIMITED",
"KAY DEE COLD STORAGE PVT LTD",
"KAY DEE COMMUNICATIONS PRIVATE LIMITED",
"KAY DEE ENGINEERS PRIVATE LIMITED",
"KAY DEE TOOLING SOLUTIONS PRIVATE LIMITED",
"KAY ELL DEE METALIKS PRIVATE LIMITED",
"KAY EM KAY IMPEX PRIVATE LIMITED",
"KAY EM KAY INTERNATIONAL PRIVATE LIMITED",
"KAY ESS ENERGY & INFRASTRUCTURE PRIVATE LIMITED",
"KAY FLAVOURS PRIVATE LIMITED",
"KAY FLURO ELECTRONICS PRIVATE LIMITED",
"KAY GEE SPINNERS PRIVATE LIMITED",
"KAY GENE CROP SCIENCE PRIVATE LIMITED",
"KAY HI-TECH ENGINEERS PRIVATE LIMITED",
"KAY INDUSTRIAL GASES PRIVATE LIMITED",
"KAY INNS PVT LTD",
"KAY INTERNATIONAL PRIVATE LIMITED",
"KAY IRON WORKS (YAMUNANAGAR) PRIVATE LIMITED",
"KAY JAIN WEARS PVT LTD",
"KAY JAY CHILL ROLLS PVT LTD",
"KAY JAY FORGINGS PRIVATE LIMITED",
"KAY JEE ESS AUTOMOBILES PRIVATE LIMITED",
"KAY KAY AGRO PROCESS PRIVATE LIMITED",
"KAY KAY AIR EXPRESS PRIVATE LIMITED",
"KAY KAY ART PRIVATE LIMITED",
"KAY KAY FACILITIES & ENGINEERING SERVICES PRIVATE LIMITED",
"KAY KAY FLUID SEALS PRIVATE LIMITED",
"KAY KAY INFRA VENTURE PRIVATE LIMITED",
"KAY KAY NETS PVT LTD",
"KAY KAY OVERSEAS CORPORATION",
"KAY KAY SOFTECH PRIVATE LIMITED",
"KAY KRISHNA TEXFAB PRIVATE LIMITED",
"KAY MARKETING SERVICES LIMITED",
"KAY NITROXYGEN PRIVATE LIMITED",
"KAY PEE CARGO MOVERS PRIVATE LIMITED",
"KAY PEE DIES INDIA PRIVATE LIMITED",
"KAY PEE EFF TOOLTECH PRIVATE LIMITED",
"KAY PEE EQUIPMENTS PVT LTD",
"KAY PEE KHAINI PRIVATE LIMITED",
"KAY PEE STEEL UDYOG PRIVATE LIMITED",
"KAY PLAST PRODUCT PRIVATE LIMITED",
"KAY POWER AND PAPER LIMITED",
"KAY SONS (INDIA) PRIVATE LIMITED",
"KAY SONS OILS PRIVATE LIMITED",
"KAY SWITCHGEARS INDIA PRIVATE LIMITED",
"KAY TEE EXPORTS PRIVATE LIMITED",
"KAY TEE TOOLING TECHNOLOGIES PRIVATE LIMITED",
"KAY TEX FASHIONS PRIVATE LIMITED",
"KAY TRADING AND HOLDINGS PRIVATE LTD.",
"KAY VEE POLYMERS PRIVATE LIMITED",
"KAY VENTURES PRIVATE LIMITED",
"KAY VYBIN CORPORATION",
"KAYA CLEARING AND FORWARDING PRIVATE LIMITED",
"KAYA KALP HERBALS PRIVATE LIMITED",
"KAYA KALPA MEDICAL SERVICES PRIVATE LIMITED",
"KAYA LIMITED",
"KAYA PRODUCTS PRIVATE LIMITED",
"KAYAAN MARKETING & DISTRIBUTION PRIVATE LIMITED",
"KAYAAN PRINTS PRIVATE LIMITED",
"KAYAAR EXPORTS PRIVATE LIMITED",
"KAYAKALP CARS PRIVATE LIMITED",
"KAYAKO HELPDESK PRIVATE LIMITED",
"KAYAKO SUPPORT SYSTEMS PRIVATE LIMITED",
"KAYAMA STEEL PRIVATE LIMITED",
"KAYAN AGRO INDUSTRIES & CO PRIVATE LIMITED",
"KAYATHRI CONSULTANTS PRIVATE LIMITED",
"KAYAVLON IMPEX PRIVATE LIMITED",
"KAYBEE INDENTS PRIVATE LIMITED",
"KAYBEE INDUSTRIAL ALLOYS (P) LTD.",
"KAYBEE PVT LTD",
"KAYCEE FASHION PRIVATE LIMITED",
"KAYCEE FINSTOCK PRIVATE LIMITED",
"KAYCEE INDUSTRIAL CHEMICALS PRIVATE LIMITED",
"KAYCEE INDUSTRIES LIMITED",
"KAYCEE POLYMERS PRIVATE LIMITED",
"KAY-COL PVT LTD",
"KAYCOMM SERVICES PRIVATE.LIMITED.",
"KAYDEE ADVERTISING PRIVATE LIMITED",
"KAYDEN INFRA ENGINEERING PRIVATE LIMITED",
"KAYDEN INVESTMENTS PRIVATE LIMITED",
"KAYDEN MINES AND MINERALS PRIVATE LIMITED",
"KAYDENT LOGISTICS PRIVATE LIMITED",
"KAYEE PROJECT EQUIPMENTS PVT LTD",
"KAYEES LUBE PVT LTD",
"KAYEL MEDICHEM PRIVATE LIMITED",
"KAYEL SYNTEX LIMITED",
"KAYEM EXIM PRIVATE LIMITED",
"KAYEM FOOD INDUSTRIES PRIVATE LIMITED",
"KAYEM SYNTHETICS PVT LTD",
"KAYEMPEE FOODS PRIVATE LIMITED",
"KAYERA TECHNOLOGIES PRIVATE LIMITED",
"KAYESS BRIGHT BARS PRIVATE LIMITED",
"KAYESS FLOUR MILLS PRIVATE LIMITED",
"KAYESS SQUARE CONSULTING PRIVATE LIMITED",
"KAYGAON PAPER MILLS PRIVATE LIMITED",
"KAYGEE CONMIX PRIVATE LIMITED",
"KAYGEE FOAM PVT LTD",
"KAYGEE INVESTMENTS PRIVATE LIMITED",
"KAYGEE KNIT WEAR WORKS PRIVATE LIMITED",
"KAYGEE LABORATORIES PRIVATE LIMITED",
"KAYGEE PROCESSORS PRIVATE LIMITED",
"KAYJI REAL ESTATE PRIVATE LIMITED.",
"KAYKAY CYANO CHEMICALS PRIVATE LIMITED",
"KAYKAY SCAFFOLDING PRIVATE LIMITED",
"KAYMON FOODS PRIVATE LIMITED",
"KAYNEE EXPRESS FREIGHT PRIVATE LIMITED",
"KAYNES HOTELS PRIVATE LIMITED",
"KAYNES INTERNATIONAL DESIGN & MANUFACTURING PRIVATE LIMITED",
"KAYNES TECHNOLOGY INDIA LIMITED",
"KAYNET COMMODITIES PRIVATE LIMITED",
"KAYO BUSINESS SYSTEMS PRIVATE LIMITED",
"KAYOMA TRADING PRIVATE LIMITED",
"KAYONE MANAGEMENT ADVISORY SERVICES PRIVATE LIMITED",
"KAYPEE COMPUTER SERVICES PRIVATE LIMITED",
"KAYPEE ELECTRONICS AND ASSOCIATES PRIVATE LIMITED",
"KAYPEE HOSPITALITY PRIVATE LIMITED",
"KAYPEE MACHINES PRIVATE LIMITED",
"KAYPEE MECHANICAL INDIA PRIVATE LIMITED",
"KAYPEE POLYFAB PRIVATE LIMITED",
"KAYPEE REALITY MANAGEMENT SERVICES PRIVATE LIMITED",
"KAYRA HOLIDAY MAPS PRIVATE LIMITED",
"KAYRA INNOPHARM PRIVATE LIMITED",
"KAYRAAH FASHION PRIVATE LIMITED",
"KAYRPEE VANIJYA PRIVATE LIMITED",
"KAYS BISCUITS PRIVATE LIMITED",
"KAYS HARBOR TECHNOLOGIES PRIVATE LIMITED",
"KAYS JEWELS PRIVATE LIMITED",
"KAYS LOVELY SWEETS PRIVATE LIMITED",
"KAYSON POLYLAM PRIVATE LIMITED",
"KAYSONS AGENCIES PRIVATE LIMITED",
"KAYSONS AUTOMOTIVE PVT LTD",
"KAYSONS INFRASTRUCTURE PRIVATE LIMITED",
"KAYSONS PIGMENTS PRIVATE LIMITED",
"KAYSONS TECHNO EQUIPMENTS PVT LTD",
"KAYSONS VENTURES PRIVATE LIMITED",
"KAYSTAR INDUSTRIAL CONTROLS PRIVATE LIMITED",
"KAYTEX FABRICS PRIVATE LIMITED",
"KAYTX INDUSTRIES PRIVATE LIMITED",
"KAYVEE AERO PHARM PVT LTD",
"KAYYAR AGGREGATES PRIVATE LIMITED",
"KAYZER FLEXIBLES PRIVATE LIMITED",
"KAZA INDUSTRIAL CORPORATION",
"KAZE ENERGY LIMITED",
"KAZEN BARCODE PRIVATE LIMITED",
"KAZHANI FARMERS PRODUCER COMPANY LIMITED",
"KAZIAN SCHOOL OF MANAGEMENT LLP",
"KAZIRANGA GALVANIZERS PRIVATE LIMITED",
"KAZIRANGA UDYOG PVT LTD",
"KAZJIN TRADING PRIVATE LIMITED",
"KAZMA TECHNOLOGY PRIVATE LIMITED",
"KAZMUNAI INDIA PRIVATE LIMITED",
"KAZO FASHION PRIVATE LIMITED",
"KAZOO MERCANTILE PRIVATE LIMITED",
"KAZSTROY ENGINEERING INDIA PRIVATE LIMITED",
"KB & SONS CHEMICAL PRIVATE LIMITED",
"KB AUTOSYS INDIA PRIVATE LIMITED",
"KB AUTOTECH INDIA PRIVATE LIMITED",
"KB BUILDWORTH PRIVATE LIMITED",
"KB CAPITAL MARKETS PVT LTD",
"KB EDUCATIONAL SERVICES PRIVATE LIMITED",
"KB GLASS SOLUTIONS PRIVATE LIMITED",
"KB INFOTECH",
"KB INFRA SPACE PRIVATE LIMITED",
"KB ISPAT PRIVATE LIMITED",
"KB LIVERPOOL FOODS INDIA PRIVATE LIMITED",
"KB LUBES PRIVATE LIMITED",
"KB MOBILINK PRIVATE LIMITED",
"KB POLYCHEM INDIA PRIVATE LIMITED",
"KB RAVAL COLLEGE OF PHARMACY",
"KB REALHOMES PRIVATE LIMITED",
"KBACE TECHNOLOGIES PRIVATE LIMITED",
"KBB BAZAR PRIVATE LIMITED",
"KBB FOOD PRODUCTS PRIVATE LIMITED",
"KBB NUTS PRIVATE LIMITED",
"KBC & COMPANY PRIVATE LIMITED",
"KBC BANK NV",
"KBC COMPUTECH PRIVATE LIMITED",
"KBC INFRASTRUCTURES PRIVATE LIMITED",
"KBC MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"KBC NANO PUBLICATION PRIVATE LIMITED",
"KBC STEEL PRIVATE LIMITED",
"KBEERA HYDRAULIC ENGINEERS PRIVATE LIMITED",
"KBG CONSULTANTS PRIVATE LIMITED",
"KBG LIFE INFRA PRIVATE LIMITED",
"KBG SERVICES PRIVATE LIMITED",
"KBGB AGRITECH PRIVATE LIMITED",
"KBI FIRE AND SECURITY PRIVATE LIMITED",
"K-BIT BRAVE SOURCING PRIVATE LIMITED",
"KBJ AUTO PRIVATE LIMITED",
"KBJ PLASTO INDIA PRIVATE LIMITED",
"KBK BIOTECH PRIVATE LIMITED",
"KBK CHEM-ENGINEERING PRIVATE LIMITED",
"KBL MERCANTILE PRIVATE LIMITED",
"KBL PACKAGING PRIVATE LIMITED",
"KBL SERVICES LIMITED",
"KBL TEXTILES PRIVATE LIMITED",
"KBM EXTRUSIONS MACHINES PRIVATE LIMITED",
"KBM FOODS PRIVATE LIMITED",
"KBM INFRABUILD PRIVATE LIMITED",
"KBM INFRASTRUCTURE PRIVATE LIMITED",
"K-BOND POLYMERS PRIVATE LIMITED",
"KBP COMMODITY INDIA PRIVATE LIMITED",
"KBPL INFRASTRUCTURE PRIVATE LIMITED",
"KBR INC.",
"KBR INFRATECH LIMITED",
"KBR MANUFACTURING PRIVATE LIMITED",
"KBR TRADING PRIVATE LIMITED",
"KBR TRANSPORT PRIVATE LIMITED",
"KBR VENTURES PRIVATE LIMITED",
"KBRIDGE CONSULTING SERVICES PRIVATE LIMITED",
"KBROS ARISTO PRIVATE LIMITED",
"KBS CERTIFICATION SERVICES LIMITED",
"KBS CERTIFICATION SERVICES PRIVATE LIMITED",
"KBS CORPORATES PRIVATE LIMITED",
"KBS CREATIONS",
"KBS CREATIONS PRIVATE LIMITED",
"KBS DIAMONDS",
"KBS EGG FARMS",
"KBS FILTERS PRIVATE LIMITED",
"KBS INDUSTRIES PRIVATE LIMITED",
"KBS JEWELS PRIVATE LIMITED",
"KBS MOTORS PRIVATE LIMITED",
"KBS PROPERTIES PRIVATE LIMITED",
"KBS TECHNOLOGIES PRIVATE LIMITED",
"KBSA STAFFING SOLUTIONS PRIVATE LIMITED",
"KBSH PRIVATE LIMITED",
"KBSS ENTERTAINMENT PRIVATE LIMITED",
"KBT SOINS PRIVATE LIMITED",
"KBV INDUSTRIES INDIA PRIVATE LIMITED",
"KBWIPER SYSTEMS INDIA PRIVATE LIMITED",
"KC COLLAGE OF MANAGEMENT STUDIES",
"KC COTTRELL ENGINEERING SERVICES PRIVATE LIMITED",
"KC COTTRELL INDIA PRIVATE LIMITED",
"KC CREATIVE WORKS PRIVATE LIMITED",
"KC FASHIONPACK PRIVATE LIMITED",
"KC GREEN REVOLUTION PRIVATE LIMITED",
"KC GUPTA TRADERS PRIVATE LIMITED",
"KC HIGH",
"KC JEWELLERY MFG. LLP",
"KC MAHINDRA EDUCATION TRUST",
"KC MARITIME INDIA LIMITED",
"KC MEMORIAL EYE HOSPITAL",
"KC OVERSEAS EDUCATION PRIVATE LIMITED",
"KC OVERSEAS PRIVATE LIMITED",
"KCALTECH SYSTEM INDIA LLP",
"KCARE STRUCTURAL SOLUTIONS PRIVATE LIMITED",
"KCAT ENZYMATIC PRIVATE LIMITED",
"KCB HOLDINGS PRIVATE LIMITED",
"KCB TRADING AND TRANSPORTING PRIVATE LIMITED",
"KCBN INFRA PROJECTS PRIVATE LIMITED",
"KCC BUILDCON PRIVATE LIMITED",
"KCC DAK PACKAGE I EXPRESSWAY PRIVATE LIMITED",
"KCC DEVCON PRIVATE LIMITED",
"KCC DHANGAON BOREGAON EXPRESSWAY PRIVATE LIMITED",
"KCC INFRACON PRIVATE LIMITED",
"KCC KATRA EXPRESSWAY PRIVATE LIMITED",
"KCC LATERI EXPRESSWAY PRIVATE LIMITED",
"KCC PAINT INDIA PRIVATE LIMITED",
"KCC ROADS CONSTRUCTION PRIVATE LIMITED",
"KCC SOFTWARE LIMITED",
"KCC STEELREELS PRIVATE LIMITED",
"KCC TALGAON KALMATH HIGHWAYS PRIVATE LIMITED",
"KCCB CIVIL CONSTRUCTIONS PRIVATE LIMITED",
"KCCL ZIPALL INDIA PRIVATE LIMITED",
"KCCO INDIA PRIVATE LIMITED",
"KCCP LIMITED",
"KCD INDUSTRIES INDIA LIMITED",
"KCEE PROPERTIES PRIVATE LIMITED",
"KCG COLLEGE OF TECHNOLOGY",
"KCG OIL & FOOD PRIVATE LIMITED",
"KCG TRAVELS & FOREX PRIVATE LIMITED",
"KCGS ENTERPRISES PRIVATE LIMITED",
"KCH INDIA PRIVATE LIMITED",
"KCI BEARINGS INDIA PRIVATE LIMITED",
"KCI MEDICAL INDIA PRIVATE LIMITED",
"KCJ APPARELS PRIVATE LIMITED",
"KCJ INTERNATIONAL PRIVATE LIMITED",
"KCJ MARKETING PRIVATE LIMITED",
"KCK AGRO PRODUCTS PRIVATE LIMITED",
"KCK DENTAL PRIVATE LIMITED",
"KCK INDUSTRIES LIMITED",
"KCL INFRA PROJECTS LIMITED",
"KCL LIMITED",
"KCL SOLUTIONS PRIVATE LIMITED",
"KCM APPLIANCES PRIVATE LIMITED",
"KCM CONSULTING PRIVATE LIMITED",
"KCM SUPPLY CHAIN SOLUTION PRIVATE LIMITED",
"KCM TECHNOLOGIES PRIVATE LIMITED",
"KCM TRANSWAY PRIVATE LIMITED",
"KCN LIFE PRIVATE LIMITED",
"KCO FOIL PRIVATE LIMITED",
"KCP EXPORTS PRIVATE LIMITED",
"KCP GAUGING TECHNOLOGY PRIVATE LIMITED",
"KCP INFRA LIMITED",
"KCPL INTRADE PRIVATE LIMITED",
"KCPSUGAR AND INDUSTRIES CORPORATION LIMITED",
"KCS AUTOMOBILES PRIVATE LIMITED",
"KCS DISTRIBUTORS PRIVATE LIMITED",
"KCS FABRICS PRIVATE LIMITED",
"KCS FINANCIAL SERVICES LIMITED",
"KCS MOTORS PRIVATE LIMITED",
"KCS QUALITY INSPECTION PRIVATE LIMITED",
"KCT FINANCIAL & MANAGEMENT SERVICES PRIVATE LIMITED",
"KCT MANAGEMENT SERVICES PRIVATE LIMITED",
"KCT TRADING PRIVATE LIMITED",
"KCTR VARSHA AUTOMOTIVE PRIVATE LIMITED",
"KCUBE CONSULTANCY SERVICES PRIVATE LIMITED",
"KD ASSOCIATES PRIVATE LIMITED",
"KD CAMPUS PRIVATE LIMITED",
"KD EXPRESS COURIER&LOGISTICS",
"KD GOLD AND DIAMONDS PRIVATE LIMITED",
"KD INDUSTRIES PRIVATE LIMITED",
"KD INFOSYSTEMS PRIVATE LIMITED",
"KD IRON AND STEEL",
"KD MOTOCORP INDIA PRIVATE LIMITED",
"KD PRACTICE CONSULTING PRIVATE LIMITED",
"KD QUALITY CODING AND CONSULTING",
"KD SALES EXCEL PRIVATE LIMITED",
"KD SHIPPING INDIA PRIVATE LIMITED",
"KD SUPPLY CHAIN SOLUTIONS",
"KDA ISPAT PRIVATE LIMITED",
"KDAC CHEM PRIVATE LIMITED",
"KDANS SURGICAL PVT LTD",
"KDATASCIENCE SOLUTIONS PRIVATE LIMITED",
"KDDI INDIA PRIVATE LIMITED",
"KDDL LIMITED",
"KDG FOODS PRIVATE LIMITED",
"KDG PROJECTS PRIVATE LIMITED",
"KDH FOODS (OPC) PRIVATE LIMITED",
"KDH TEXTILE PRIVATE LIMITED",
"KDI PLASTOTECH PRIVATE LIMITED",
"KDI POWER PRIVATE LIMITED",
"KDJP STEELS PRIVATE LIMITED",
"KDK DIAMONDS PRIVATE LIMITED",
"KDK INFRA PRIVATE LIMITED",
"KDK SOFTWARES INDIA PRIVATE LIMITED",
"KDKR INDUSTRIES PRIVATE LIMITED",
"KDM BUSINESS NETWORK LIMITED",
"KDM CHEMICLAS AND RESEARCH PRIVATE LIMITED",
"KDM CLOTHING CO.",
"KDM DOTSOFT DEVELOPERS PRIVATE LIMITED",
"KDM ENGINEERS (INDIA) PRIVATE LIMITED",
"KDM ENGINEERS AND CONSULTANTS PRIVATE LIMITED",
"KDM FOODS PRIVATE LIMITED",
"KDM MEDIA PRIVATE LIMITED",
"KDM SEEDS & INFRASTRUCTURE PRIVATE LIMITED",
"KDM TELECOM SOLUTIONS PRIVATE LIMITED",
"KDMP COMMUNICATION PRIVATE LIMITED",
"KDMV EXPORTS PRIVATE LIMITED",
"KDN INFRASTRUCTURE PRIVATE LIMITED",
"KDN INFRATECH PRIVATE LIMITED",
"KDN LOGISTICS PRIVATE LIMITED",
"KDN TOOLS PVT LTD",
"KDP ELEVATORS PRIVATE LIMITED",
"KDP MICRO POINT PVT. LTD.",
"KDPL DIAGNOSTICS (AMRITSAR) PRIVATE LIMITED",
"KDPL DIAGNOSTICS (BATHINDA) PRIVATE LIMITED",
"KDPL DIAGNOSTICS (JALANDHAR) PRIVATE LIMITED",
"KDPL DIAGNOSTICS (LUDHIANA) PRIVATE LIMITED",
"KDPL DIAGNOSTICS (PATIALA) PRIVATE LIMITED",
"KDPL DIAGNOSTICS (SAS NAGAR) PRIVATE LIMITED",
"KDPS LIFESTYLE PRIVATE LIMITED",
"KDR BRIGHT STEELS PRIVATE LIMITED",
"KDR FORGINGS PRIVATE LIMITED",
"KDR INFRASTRUCTURE PRIVATE LIMITED",
"KDR SERVICES PRIVATE LIMITED",
"KDS AGRO EXPORTS PRIVATE LIMITED",
"KDS BHAVANI PACKAGING PRIVATE LIMITED",
"KDS HEALTH CARE PRIVATE LIMITED",
"KDS INFRAWAYS PRIVATE LIMITED",
"KDS INTERNATIONAL PRIVATE LIMITED",
"KDS LOGISTICS PRIVATE LIMITED",
"KDS PETROCHEM PRIVATE LIMITED",
"KDS SERVICES PRIVATE LIMITED",
"KDS WINDOW SOLUTIONS PRIVATE LIMITED",
"KDT INFRASTRUCTURE PRIVATE LIMITED",
"KDU ENTERPRISES PRIVATE LIMITED",
"KE DISTRIBUTORS PRIVATE LIMITED",
"KE ENGINEERS PRIVATE LIMITED",
"KE HEALTHCARE PRIVATE LIMITED",
"KE TECHNICAL TEXTILES PRIVATE LIMITED",
"KEAA INTERNATIONAL PRIVATE LIMITED",
"KEABIS TECH PRIVATE LIMITED",
"KEAHI PANACHE TEXTILE PRIVATE LIMITED",
"KEAN CONSTRUCTION LLP",
"KEANSA SOLUTIONS LLP",
"KEASIS TECHNOLOGY PRIVATE LIMITED",
"KEAUM ORGANICS PRIVATE LIMITED",
"KEAVY GLOBAL LOGISTIC PRIVATE LIMITED",
"KEB HANA BANK",
"KEBA INDIA PRIVATE LIMITED",
"KEBAB BROTHERS F & B PRIVATE LIMITED",
"KEBEE PHARMACEMIE PRIVATE LIMITED",
"HITACHI AUTOMATION INDIA PRIVATE LIMITED",
"KEC BEARINGS PRIVATE LIMITED",
"KEC INTERNATIONAL LIMITED",
"KEC SPUR INFRASTRUCTURE PRIVATE LIMITED",
"KECH BOARDS PVT LTD",
"KECIOUS MICROTECH PRIVATE LIMITED",
"KEDA CERAMIC PRIVATE LIMITED",
"KEDA INDUSTRIAL (INDIA) LIMITED",
"KEDAAR AUTO ASSOCIATES PRIVATE LIMITED",
"KEDAAR METALIKS PRIVATE LIMITED",
"KEDAARA CAPITAL ADVISORS LLP",
"KEDAR AGROS PRIVATE LIMITED",
"KEDAR CEREALS PRIVATE LIMITED",
"KEDAR COTSPIN PRIVATE LIMITED",
"KEDAR HOSPITAL",
"KEDAR JANANI CHEMPLAST PRIVATE LIMITED",
"KEDAR METALS PRIVATE LIMITED",
"KEDAR NATH & SONS INDIA PRIVATE LIMITED",
"KEDAR NATH ROLLER FLOUR MILLS PRIVATE LIMITED",
"KEDAR SECURITY SERVICES PRIVATE LIMITED",
"KEDAR SEEDS TRADERS PRIVATE LIMITED",
"KEDARA PLASTICS PRIVATE LIMITED",
"KEDARESHWAR INFRASRUCTURE DEVELOPERS PRIVATE LIMITED",
"KEDARNATH ADARSHA VIDYAPITH",
"KEDARNATH COTTONS PRIVATE LIMITED",
"KEDARNATH EDUCATIONS PRIVATE LIMITED",
"KEDARNATH INDUSTRIES LIMITED",
"KEDARNATH MINING PRIVATE LIMITED",
"KEDARNATH MULTIGRAINS PRIVATE LIMITED",
"KEDARNATH PACKING INDUSTRIES",
"KEDARNATH RAMGOPAL PVT LTD",
"KEDARNATH TREXIM PRIVATE LIMITED",
"KEDARNATH VIDYA PRASARINI'S",
"KEDGE SYSTEMS PRIVATE LIMITED",
"KEDIA AGENCIES PVT LTD",
"KEDIA BUILDERS AND COLONIZERS PRIVATE LIMITED",
"KEDIA CAPITAL SERVICES PRIVATE LIMITED",
"KEDIA CARBON PRIVATE LIMITED",
"KEDIA CLOTHING PRIVATE LIMITED",
"KEDIA DHANDHARIA & CO",
"KEDIA EXPORTS PRIVATE LIMITED",
"KEDIA FINANCIAL SERVICES PRIVATE LIMITED",
"KEDIA GUAR GUM PRIVATE LIMITED",
"KEDIA INTERNET PRIVATE LIMITED",
"KEDIA LIFESPACE DEVELOPERS PRIVATE LIMITED",
"KEDIA LOGISTIC PRIVATE LIMITED",
"KEDIA LUMBERS",
"KEDIA ORGANIC CHEMICALS PRIVATE LIMITED",
"KEDIA OVERSEAS LIMITED",
"KEDIA OVERSEAS PRIVATE LIMITED",
"KEDIA PAPER INDUSTRIES PRIVATE LIMITED",
"KEDIA PIPES PRIVATE LIMITED",
"KEDIA PLASTICS PRIVATE LIMITED",
"KEDIA PULSES PRIVATE LIMITED",
"KEDIA RICE MILL PVT LTD ,",
"KEDIA SECURITIES PVT LTD",
"KEDIA SHARES AND STOCKS BROKERS LIMITED",
"KEDIA SILK MILLS PRIVATE LIMITED",
"KEDIA SOLVENT OIL INDUSTRIES PRIVATE LIMITED",
"KEDIA STOCK & COMMODITIES RESEARCH PRIVATE LIMITED",
"KEDIA TEXFAB AND INDUSTRIES PRIVATE LIMITED",
"KEDIA TRADE & AGENCIES PRIVATE LIMITED",
"KEDIA TRADING PVT LTD",
"KEDIA TRANS LIFTERS PRIVATE LIMITED",
"KEDIA TRENDZ LIMITED",
"KEDIA TUBES PRIVATE LIMITED",
"KEDIA YARNS PRIVATE LIMITED",
"KEDMAN SKILLING PRIVATE LIMITED",
"KEDRA STYLES PRIVATE LIMITED",
"KEDSATI IRON & STEEL PRIVATE LIMITED",
"KEDUVENTURES SMART SERVICES PRIVATE LIMITED",
"KEE DIAGNOSTICS PRIVATE LIMITED",
"KEE PHARMA LIMITED",
"KEE PROJECTS LIMITED",
"KEEAN INDUSTRIES PRIVATE LIMITED",
"KEEC I PRIVATE LIMITED",
"KEECHERY ENGINEERING CO",
"KEECO LLC",
"KEEDA MEDIA PRIVATE LIMITED",
"KEEL LOGISTICS PRIVATE LIMITED",
"KEEMAYA BUILD PRIVATE LIMITED",
"KEEMAYA PRODUCTIONS PRIVATE LIMITED",
"KEEMTEE FINANCIAL SERVICES LIMITED",
"KEEN AND ABLE COMPUTERS PRIVATE LIMITED",
"KEEN PUBLICITY PRIVATE LIMITED",
"KEENARA FILAMENTS PRIVATE LIMITED",
"KEENHEADS TECHNOLOGIES PRIVATE LIMITED",
"KEEO LIFE PRIVATE LIMITED",
"KEEP WHITE ENTERPRISES PRIVATE LIMITED",
"KEEP WHITE TRADING PRIVATE LIMITED",
"KEEPER LANDWEY PRIVATE LIMITED",
"KEEPHUMAN MANAGEMENT PRIVATE LIMITED",
"KEEPSAFE TRADERS PVT LTD",
"KEEPSAKE AUTOMATION LLP",
"KEEPTRUCKIN INDIA PRIVATE LIMITED",
"KEEPWORKS TECHNOLOGIES PRIVATE LIMITED",
"KEER HOTELS PRIVATE LIMITED",
"KEERAN MULTIBUSINESS PRIVATE LIMITED",
"KEEROS FOODS PRIVATE LIMITED",
"KEERTAN CONSULTANTS PRIVATE LIMITED",
"KEERTHI AGRO MILLS PRIVATE LIMITED",
"KEERTHI BIZPLUS4U SERVICES PRIVATE LIMITED",
"KEERTHI ESTATES PRIVATE LIMITED",
"KEERTHI PETROCHEM PRIVATE LIMITED",
"KEERTHI POULTRIES & FOODS PRIVATE LIMITED",
"KEERTHI SRINIVASA SOLUTIONS PRIVATE LIMITED",
"KEERTHI TECHNOCRAFT PRIVATE LIMITED",
"KEERTHY MEDICAL STORES PRIVATE LIMITED",
"KEERTI CARGO SERVICES PRIVATE LIMITED",
"KEERTI INSTITUE INDIA PRIVATE LIMITED",
"KEERTI KNOWLEDGE AND SKILLS LIMITED",
"KEERTI SOFTWARE AND HARDWARE INFOTECH PRIVATE LIMITED",
"KEERTI VIDYALAYA",
"KEERTIKA ACADEMY PRIVATE LIMITED",
"KEETRONICS (INDIA) PRIVATE LIMITED",
"KEEVA AGRO INDIA PRIVATE LIMITED",
"KEFCO EXIM PRIVATE LIMITED",
"KEFI HOLDINGS PRIVATE LIMITED",
"KEFI HOME HEALTH CARE PRIVATE LIMITED",
"KEFI TECH SOLUTIONS PRIVATE LIMITED",
"KEGGFARMS PRIVATE LIMITED",
"KEHEM LAND AND PROPERTIES PRIVATE LIMITED",
"KEHEMS CONSULTANTS PVT. LTD.",
"KEHEMS ENGINEERING PRIVATE LIMITED",
"KEHEMS TECHNOLOGIES PRIVATE LIMITED",
"KEHR SURGICAL PRIVATE LIMITED",
"KEI INDUSTRIES LIMITED",
"KEI RAJAMAHENDRI RESORTS PRIVATE LIMITED",
"KEIL TOOLS PRIVATE LIMITED",
"KEIMED PRIVATE LIMITED",
"KEINEN TECHNE SOLUTIONS PRIVATE LIMITED",
"KEIRESTU SMART PRO PRIVATE LIMITED",
"KEI-RSOS PETROLEUM AND ENERGY PRIVATE LIMITED",
"KEISH HOSPITALITY PRIVATE LIMITED",
"KEISHA ENTERPRISES PRIVATE LIMITED",
"KEISHDALE PRIVATE LIMITED",
"KEITA PHARMA PRIVATE LIMITED",
"KEITH CERAMIC INDIA PRIVATE LIMITED",
"KEITH ELECTRONICS PRIVATE LIMITED",
"KEITH TELECOM SYSTEMS PRIVATE LIMITED",
"KEITH WALKING FLOOR INDIA PRIVATE LIMITED",
"KEIVY ENTERPRISES PRIVATE LIMITED",
"KEJ MINERALS PRIVATE LIMITED",
"KEJAJI SUSHIKSHIT BEROJGAR SAHKARI SANSTHA LIMITED",
"KEJE THERMOWELD EQUIPMENTS PRIVATE LIMITED",
"KEJRIWAL BEE CARE INDIA PRIVATE LIMITED",
"KEJRIWAL FASHIONS PRIVATE LIMITED",
"KEJRIWAL INDUSTRIES PRIVATE LIMITED",
"KEJRIWAL INTEGRATED TEXTILE PARK PRIVATE LIMITED",
"KEJRIWAL MACHINERIES PVT LTD",
"KEJRIWAL METALLISATION LIMITED",
"KEJRIWAL MIINIING PRIVATE LIMITED",
"KEJRIWAL PLYWOODS PRIVATE LIMITED",
"KEJRIWAL REAL-INFRA PROJECTS PRIVATE LIMITED",
"KEJRIWAL SUGAR AGENCIES PRIVATE LIMITED",
"KEKA TECHNOLOGIES PRIVATE LIMITED",
"KEKULE LIFE SCIENCES LIMITED",
"KEKULE PHARMA LIMITED",
"KEL ENGINEERS PRIVATE LIMITED",
"KEL SEA LINE PRIVATE LIMITED",
"KELACHANDRA PIPE FITTINGS",
"KELAWALA WEAVES PRIVATE LIMITED",
"KELBA AGRO ENGINEERS PRIVATE LIMITED",
"KELCO AGENCIES PRIVATE LIMITED",
"KELD ELLENTOFT IND PRIVATE LIMITED",
"KELEGENT METAPLAST INDIA PRIVATE LIMITED",
"KELEON ENERGY PRIVATE LIMITED",
"KELI HOTELS PRIVATE LIMITED",
"KELIN INDIA PRIVATE LIMITED",
"KELKAR AUTO PARTS PRIVATE LIMITED",
"KELKAR EDUCATION TRUSTS'S SCIENTIFIC RESEARCH CENTRE",
"KELKAR MEDICOS PRIVATE LIMITED",
"KELLEN ENTERPRISES PRIVATE LIMITED",
"KELLER GROUND ENGINEERING INDIA PRIVATE LIMITED",
"KELLEY MATERIAL HANDLING EQUIPMENT INDIA PRIVATE LIMITED",
"KELLNER ELECTRICALS PRIVATE LIMITED",
"KELLOGG & ANDELSON MANAGEMENT SERVICES PRIVATE LIMITED",
"KELLOGG BROWN & ROOT ENGINEERING & CONSTRUCTION INDIA PRIVATE LIMITED",
"KELLOGG COMPANY",
"KELLOGG INDIA PRIVATE LIMITED",
"KELLTON DBYDX SOFTWARE PRIVATE LIMITED",
"KELLTON SECURITIES PRIVATE LIMITED",
"KELLTON TECH SOLUTIONS LIMITED",
"KELLY OUTSOURCING AND CONSULTING GROUP INDIA PRIVATE LIMITED",
"KELOID INDIA PRIVATE LIMITED",
"KELSA MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"KELSATEK SOLUTIONS PRIVATE LIMITED",
"KELTECH ENERGIES LIMITED",
"KELTECH INFRASTRUCTURE LIMITED",
"KELTON TECH GGN",
"KELTRON COMPONENT COMPLEX LIMITED",
"KELVIN AIR CONDITIONING AND VENTILATION SYSTEMS PRIVATE LIMITED",
"KELVIN AQUA ENGINEERS PRIVATE LIMITED",
"KELVIN ENERGY SOLUTIONS",
"KELVIN JUTE LIMITED",
"KELVIN NATURAL MINT PRIVATE LIMITED",
"KELVIN PLASTIC PRIVATE LIMITED",
"KELVIN SILK MILLS PRIVATE LIMITED",
"KELVIN SYSTEMS PRIVATE LIMITED",
"KELVIN WATER TECHNOLOGIES PRIVATE LIMITED",
"KELVINSTAR FOOD CONTROLS PRIVATE LIMITED",
"KELVION INDIA PRIVATE LIMITED",
"KELVIRON TECHNOLOGIES PRIVATE LIMITED",
"KELWE PAN UTPADAK VIKRETA COMPANY PRIVATE LIMITED",
"KELWIN SALES PRIVATE LIMITED",
"KEM FINISHES PRIVATE LIMITED",
"KEM HOSPITAL",
"KEM LIGHT SPECHEM LABS PRIVATE LIMITED",
"KEM PHAR PVT LTD",
"KEM TRON TECHNOLOGIES PRIVATE LIMITED",
"KEMA LOGISTICS & MANUFACTURERS PRIVATE LIMITED",
"KEMACH EQUIPMENTS PRIVATE LIMITED",
"KEMAN COMPOSITE INDIA PRIVATE LIMITED",
"KEMAN OPTICAL INDIA PRIVATE LIMITED",
"KEMAR PORT AUTOMATION PRIVATE LIMITED",
"KEMCO CORPORATION",
"KEMCO ELEVATORS PRIVATE LIMITED",
"KEMCO TECHNOLOGIES INDIA PRIVATE LIMITED",
"KEME PRIVATE LIMITED",
"KEMECOS INDIA PVT LTD",
"KEMET ELECTRONICS MARKETING S PRIVATE LIMITED",
"KEMEX INTERNATIONAL PRIVATE LIMITED",
"KEMEXEL ECOMMERCE PRIVATE LIMITED",
"KEMFIN SERVICES PRIVATE LIMITED",
"KEMFLW WATER TREATMENT PRIVATE LIMITED",
"KEMFORD HEALTHCARE PRIVATE LIMITED",
"KEMGIA TRADERS PRIVATE LIMITED",
"KEMI CHEMS PRIVATE LIMITED",
"KEMIA APARTMENTS LIMITED",
"KEMIA TAU SRL",
"KEMICIDES CROP PROTECTION PRIVATE LIMITED",
"KEMIN INDUSTRIES SOUTH ASIA PRIVATE LIMITED",
"KEMINTERPHARM SPECHEM RESOURCES PRIVATE LIMITED",
"KEMISTAR CORPORATION LIMITED",
"KEMIT CHEMICALS PVT LTD",
"KEMIX CHEMICALS AND COATING PRIVATE LIMITED",
"KEMO HOLDINGS PRIVATE LIMITED",
"KEMP AND COMPANY LIMITED",
"KEMP TECHNOLOGIES INDIA PRIVATE LIMITED",
"KEMPEGOWDA BUILD MART",
"KEMPEGOWDA INSTITUTE OF MANAGEMENT STUDIES AND RESEARCH",
"KEMPEGOWDA INSTITUTE OF MEDICAL SCIENCES",
"KEMPEGOWDA INTERNATIONAL AIRPORT FOUNDATION",
"KEMPPI INDIA PRIVATE LIMITED",
"KEMPSZ TRADING PRIVATE LIMITED",
"KEMRIJE PAPER INDUSTRIES PRIVATE LIMITED",
"KEMRON WOOD PLAST PRIVATE LIMITED",
"KEMS AUTO COMPONENTS LIMITED",
"KEMS FORGINGS LIMITED",
"KEMS SECURITIES LIMITED",
"KEMS SERVICES PRIVATE LIMITED",
"KEMS SHAKTI PRECISION CASTINGS PRIVATE LIMITED",
"KEMSYS TECHNOLOGIES PRIVATE LIMITED",
"KEMTANI PROJECTS PRIVATE LIMITED",
"KEMTEC INDIA PHOTOGRAPHIC CO.PRIVATE LIMITED.",
"KEMTECH INTERNATIONAL PRIVATE LTD",
"KEMTECH SOLUTIONS PRIVATE LIMITED",
"KEMTEX PETROCHEMICALS LIMITED",
"KEMTREE ENTERPRISES PRIVATE LIMITED",
"KEMWELL BIOPHARMA PRIVATE LIMITED",
"KEMWELL INFRASTRUCTURE PRIVATE LIMITED",
"KEMWELL PRIVATE LIMITED",
"KEN AGRITECH PRIVATE LIMITED",
"KEN BIOLINKS PRIVATE LIMITED",
"KEN CHEMICALS PRIVATE LIMITED",
"KEN CONSULTING",
"KEN FINANCIAL SERVICES LIMITED",
"KEN GLOBAL DESIGNS PRIVATE LIMITED",
"KEN GLOBAL DRINKS PRIVATE LIMITED",
"KEN LIFESTYLES PRIVATE LIMITED.",
"KEN PRIVATE LIMITED",
"KEN RESEARCH PRIVATE LIMITED",
"KENA ALLOYS PRIVATE LIMITED",
"KENA BIOSCIENCE (OPC) PRIVATE LIMITED",
"KENA MARKETING PRIVATE LIMITED",
"KENABRAZ TRADING COMPANY PRIVATE LIMITED",
"KENAI TECHNOLOGIES PRIVATE LIMITED",
"KENAM EXIM PRIVATE LIMITED",
"KENBROOK AUTOMATION PRIVATE LIMITED",
"KENCES CONSTRUCTIONS PRIVATE LIMITED",
"KENCES CONTAINER TERMINAL LIMITED",
"KENCORP MARKETING PRIVATE LIMITED",
"KENDA FARBEN INDIA PRIVATE LIMITED",
"KENDALL HEALTHCARE PRIVATE LIMITED",
"KENDALL WORLD CLASS PRIVATE LIMITED",
"KENDEIL INDFARAD ELECTRONICS PRIVATE LIMITED",
"KENDLE INDIA PRIVATE LIMITED",
"KENDO SALES PRIVATE LIMITED",
"KENDON SOFTWARE PRIVATE LIMITED",
"KENDRA BUSINESS TECHNOLOGIES PRIVATE LIMITED",
"KENDRA VIDHYALAYA SCHOOLS",
"KENDRASHALA HALDI TAL KAGAL DIST KOLHAPUR",
"KENDRIYA BHANDAR",
"KENDRIYA SAJJA EVM BHANDAR SANGTHAN PRAPTI PRATHAM LUCKNOW",
"KENDRIYA VIDYALAYA",
"KENDRIYA VIDYALAYA BANGALORE",
"KENDRIYA VIDYALAYA HYDERABAD",
"KENDRIYA VIDYALAYA SANGATHAN",
"KENERGIE INDUSTRIES PRIVATE LIMITED",
"KENEXA TECHNOLOGIES PRIVATE LIMITED",
"KENGERI PACKERS PRIVATE LIMITED",
"KENHEAL HEALTHCARE PRIVATE LIMITED",
"KENI INDUSTRIES PRIVATE LIMITED",
"KENI OFFICE SEATING SYSTEM PRIVATE LIMITED",
"KENIA EYE HOSPITAL PRIVATE LIMITED",
"KENIL MOTORZ PRIVATE LIMITED",
"KENLA SYSTEMS PRIVATE LIMITED",
"KENMARK TECH SOLUTIONS",
"KENMORE SHOES PRIVATE LIMITED",
"KENMORE VIKAS INDIA PRIVATE LIMITED",
"KENN PHARMACEUTICALS PRIVATE LIMITED",
"KENNAMETAL INDIA LIMITED",
"KENNAMETAL SHARED SERVICES PRIVATE LIMITED",
"KENNECT SOLUTIONS PRIVATE LIMITED",
"KENNEDY EDUCATIONAL INSTITUTIONS PRIVATE LIMITED",
"KENNEDY GLOBAL SCHOOLS EDUCATIONAL SOCIETY",
"KENNEDY HIGH THE GLOBAL SCHOOL",
"KENNEDY RESIDENTIAL SCHOOLS PRIVATE LIMITED",
"KENNEDYS KOGNITIVE COMPUTING PRIVATE LIMITED",
"KENNEN AUTOMATION SOLUTIONS PRIVATE LIMITED",
"KENNIGTON INDUSTRIES PRIVATE LIMITED",
"KENNOVATION SOFTWARE SERVICES PRIVATE LIMITED",
"KENNY FOODS PRIVATE LIMITED",
"KENNY PHARMA PRIVATE LIMITED",
"KENNY'S TRENDZ PRIVATE LIMITED",
"KENOOR ORGANICS PRIVATE LIMITED",
"KENORITA COLLECTIONS PRIVATE LIMITED",
"KENOX AGRO INDUSTRIES PRIVATE LIMITED",
"KENPACK PHARMA PRIVATE LIMITED",
"KENRIK INDUSTRIES LIMITED",
"KENRISE MEDIA PRIVATE LIMITED",
"KENSCIO DIGITAL MARKETING PRIVATE LIMITED",
"KENSHA BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"KENSHINE GLOBAL LOGISTICS PRIVATE LIMITED",
"KENSHINE LOGISTICS PRIVATE LIMITED",
"KENSHINE SHIPPING PRIVATE LIMITED",
"KENSHOP GLOBAL",
"KENSINGTON HOSPITAL",
"KENSIUM SOLUTIONS PRIVATE LIMTED",
"KENSO AGRO PRIVATE LIMITED",
"KENSOFT INFOTECH LIMITED",
"KENSOLE FASHIONS PRIVATE LIMITED",
"KENSPIRE ADVISORS PRIVATE LIMITED",
"KENSRI SCHOOL",
"KENSRI SCHOOL & COLLEGE",
"KENSTEL COMMUNICATIONS PRIVATE LIMITED",
"KENSTEL NETWORKS LIMITED",
"KENSTONE CAPITAL DEBT CONSULTING PRIVATE LIMITED",
"KENSURE HEALTHCARE PRIVATE LIMITED",
"KENT CONSTRUCTIONS PRIVATE LIMITED",
"KENT ENGINEERING INDIA PRIVATE LIMITED",
"KENT INDUSTRIES",
"KENT INTELLIGENT TRANSPORTATION SYSTEMS INDIA PRIVATE LIMITED",
"KENT INTERNATIONAL PRIVATE LIMITED",
"KENT MALLEABLES PVT LTD",
"KENT RO SYSTEMS LIMITED",
"KENT VALLEY INTERNATIONAL SCHOOL",
"KENT VALVE PRIVATE LIMITED",
"KENTCO RESOURCES PRIVATE LIMITED",
"KENTEE OILS PRIVATE LIMITED",
"KENTER CABLES INDIA PRIVATE LIMITED",
"KENTRECK LABORATORIES PRIVATE LIMITED",
"KENTREE CONSULTANTS PRIVATE LIMITED",
"KENTROPY TECHNOLOGIES PRIVATE LIMITED",
"KENVI JEWELS LIMITED",
"KENWOOD DECOR PRIVATE LIMITED",
"KENXINDA ELECTRONICS PRIVATE LIMITED",
"KENYT TECHNOLOGIES PRIVATE LIMITED",
"KENZO ENGINEERING PRIVATE LIMITED",
"KENZO INTERNATIONAL",
"KENZO NUTRICO PRIVATE LIMITED",
"KEOLIS HYDERABAD MASS RAPID TRANSIT SYSTEM PRIVATE LIMITED",
"KEON REALTY PRIVATE LIMITED",
"KEONA INTERIORS PRIVATE LIMITED",
"KEONA TEXTILES",
"KEONJHAR INFRASTRUCTURE DEVELOPMENT COMPANY LIMITED",
"KEP ENGINEERING SERVICES PRIVATE LIMITED",
"KEP PRIVATE LIMITED",
"KEP TECHNOLOGIES PRIVATE LIMITED",
"KEPCO ALLOYS PRIVATE LIMITED",
"KEPCO METALS PRIVATE LIMITED",
"KEPCO PLANT SERVICE &ENGINEERING CO LIMITED",
"KEPLER CANNON INTERNATIONAL PRIVATE LIMITED",
"KEPLER CAST PRIVATE LIMITED",
"KEPLER CONSULTING LLP",
"KEPLER HEALTHCARE PRIVATE LIMITED",
"KEPLER VET MISSION PRIVATE LIMITED",
"KEPPEL OFFSHORE & MARINE ENGINEERING SERVICES MUMBAI PRIVATE LIMITED",
"KEPPEL PURAVANKARA DEVELOPMENT PRIVATE LIMITED",
"KEPRI COMPUTERS PRIVATE LIMITED",
"KEPRO TECHNOLOGIES PRIVATE LIMITED",
"KEPSURE SOLUTIONS PRIVATE LIMITED",
"KER INDIA TOURS PRIVATE LIMITED",
"KERA FRESH PRODUCER COMPANY LIMITED",
"KERAKOLL INDIA PRIVATE LIMITED",
"KERALA AGRICULTURAL UNIVERSITY",
"KERALA ALCOHOLIC PRODUCTS PRIVATE LIMITED",
"KERALA AYURVEDA LIMITED",
"KERALA BALERS PRIVATE LTD",
"KERALA CARS PRIVATE LIMITED",
"KERALA CO OPERATIVE MILK MARKETING FEDERATION",
"KERALA COMMUNICATORS CABLE LIMITED.",
"KERALA DISTRICT CO-OP BANK",
"KERALA ELECTRICAL AND ALLIED ENGG. CO. LIMITED",
"KERALA ENVIRO INFRASTRUCTURE LIMITED",
"KERALA FASHION JEWELLERY",
"KERALA FEEDS LIMITED",
"KERALA FINANCIAL CORPORATION",
"KERALA FIRST HEALTH SERVICES PRIVATE LIMITED",
"KERALA GRAMIN BANK",
"KERALA HEALTH CARE PRIVATE LIMITED.",
"KERALA IRON FABRICATORS CONSORTIUM LIMITED",
"KERALA KAUMUDI PRIVATE LIMITED",
"KERALA LATEX PRIVATE LIMITED",
"KERALA MANUFACTURES JEWELLERY PRIVATE LIMITED",
"KERALA MEDICAL SERVICES CORPORATION LIMITED",
"KERALA MINERALS METALS LIMITED",
"KERALA NUT FOOD COMPANY",
"KERALA ROADWAYS PRIVATE LIMITED",
"KERALA SR. SECONDARY SCHOOL",
"KERALA STATE BEVERAGES MANUFACTURING AND MARKETING CORPORATION LTD",
"KERALA STATE CIVIL SUPPLIES CORPN LIMITED",
"KERALA STATE COIR CORPORATION LIMITED",
"KERALA STATE DRUGS AND PHARMACEUTICALS LTD",
"KERALA STATE ELECTRICITY BOARD LIMITED",
"KERALA STATE ELECTRONICS DEVELOPMENT CORPORATION LIMITED",
"KERALA STATE FINANCIAL ENTERPRISES LTD",
"KERALA STATE INDUSTRIAL DEVELOPMENT CORPN LTD",
"KERALA STATE MINERAL DEVELOPMENT CORPORATION LIMITED",
"KERALA STATE POWER AND INFRASTRUCTURE FINANCE CORPORATION LIMITED",
"KERALA STATE ROAD TRANSPORT CORPORATION",
"KERALA STATE WOMEN'S DEVELOPMENT CORPORATION LIMITED",
"KERALA TOURISM DEVELOPMENT CORPORATION LIMITED",
"KERALA TRAVELS INTER SERVE LIMITED",
"KERALA TUBES LIMITED",
"KERALA VARMAR COLLEGE",
"KERALA VISION BROAD BAND LIMITED",
"KERALA VISION LIMITED",
"KERALAWATERWAYS AND INFRASTRUCTURES LIMITED",
"KERALEEYA ARYAVAIDYA OUSHADASALA PRIVATE LIMITED",
"KERAM OIL MILLS PRIVATE LIMITED",
"KERAMISCHER OFENBAU INDIA PRIVATE LIMITED",
"KERAMOS TILE AND STONE PRIVATE LIMITED",
"KERAPURA PRODUCTS PRIVATE LIMITED",
"KERAZA SERVICES PRIVATE LIMITED",
"KERG INTERNATIONAL EXPORT PRIVATE LIMITED",
"KERING EYEWEAR INDIA PRIVATE LIMITED",
"KERKAR MEDIA PRIVATE LIMITED",
"KERN ENTERPRISES PRIVATE LIMITED",
"KERN LOGISTICS PRIVATE LIMITED",
"KERNCARGO PRIVATE LIMITED",
"KERNEL SOLUTIONS PRIVATE LIMITED",
"KERNELAPPS PRIVATE LIMITED",
"KERNEOS INDIA ALUMINATE PRIVATE LIMITED",
"KERNEX MICROSYSTEMS INDIALIMITED",
"KERN-LIEBERS INDIA PRIVATE LIMITED",
"KERNSHELL TECHNOLOGIES PRIVATE LIMITED",
"KEROMIYONS ENTERPRISES INDIA PRIVATE LIMITED",
"KERON LIFESCIENCES PRIVATE LIMITED",
"KERONE ENGINEERING SOLUTIONS LIMITED",
"KEROSS RESEARCH AND DEVELOPMENT CENTER PRIVATE LIMITED",
"KERRIMO INTERNATIONAL PRIVATE LIMITED",
"KERRY INDEV LOGISTICS PRIVATE LIMITED",
"KERRY INGREDIENTS INDIA PRIVATE LIMITED",
"KERSEYMERE INDIA PRIVATE LIMITED",
"KERU SIKSHAN SANSTHAN JODHPUR",
"KERUDI HEALTHCARE PRIVATE LIMITED",
"KERYX RETAIL SOLUTIONS PRIVATE LIMITED",
"KES PROJECTS PRIVATE LIMITED",
"KES SHROFF COLLEGE OF ARTS & COMMERCE",
"KESA PAPERS PRIVATE LIMITED",
"KESAL CHEMICALS AND PIGMENTS (INDIA) PVT.LTD.",
"KESAR ALLOYS AND METALS PRIVATE LIMITED",
"KESAR AUTOMOBILES PRIVATE LIMITED",
"KESAR BUILDCON PRIVATE LIMITED",
"KESAR CRAFT PACKAGING PRIVATE LIMITED",
"KESAR EARTH SOLUTION",
"KESAR ENTERPRISES LIMITED",
"KESAR FAB PRIVATE LIMITED",
"KESAR FOREX PRIVATE LIMITED",
"KESAR GATEWAY PRIVATE LIMITED",
"KESAR GIFT MART PRIVATE LIMITED",
"KESAR HOSPITAL",
"KESAR IMPEX",
"KESAR IMPEX FLOOR CONCEPTS PRIVATE LIMITED",
"KESAR INDIA LIMITED",
"KESAR INTERLINK PRIVATE LIMITED",
"KESAR ISPAT LIMITED",
"KESAR MARBLE AND GRANITE LIMITED",
"KESAR MOTELS P.LIMITED.",
"KESAR MULTIMODAL LOGISTICS LIMITED",
"KESAR PETROPRODUCTS LIMITED",
"KESAR PHARMA PRIVATE LIMITED",
"KESAR SINGH FOOD MART PRIVATE LIMITED",
"KESAR TERMINALS & INFRASTRUCTURE LIMITED",
"KESAR TEXTILE PARK INDIA PRIVATE LIMITED",
"KESAR TRUCKS PRIVATE LIMITED",
"KESARA SYNTEX PVT. LTD.",
"KESARI ADS PRIVATE LIMITED",
"KESARI AUTOMOTIVES PRIVATE LIMITED",
"KESARI BANI MEDIA PRIVATE LIMITED",
"KESARI CONNECT PRIVATE LIMITED",
"KESARI EXPORT PRIVATE LIMITED",
"KESARI FIBRES PRIVATE LIMITED",
"KESARI GEMS PRIVATE LIMITED",
"KESARI NANDAN SAREES PRIVATE LIMITED",
"KESARI ROLLER FLOUR MILLS PRIVATE LIMITED",
"KESARI TOURS PRIVATE LIMITED",
"KESARI WORLD TRAVE COMPANY",
"KESARIA NANDAN FRUITS AND NUTS PRIVATE LIMITED",
"KESARIA RUBBER INDUSTRIES PRIVATE LIMITED",
"KESARIA TEA CO LIMITED",
"KESARIYA FARM PRIVATE LIMITED",
"KESARS AND KESARS PRIVATE LIMITED",
"KESARS KRISHANDARSHAN PRIVATE LIMITED",
"KESARWANI MARKETING PRIVATE LIMITED",
"KESAV CERAMICS PVT LTD",
"KESAV PACKAGING PRIVATE LIMITED.",
"KESAVA JEWELS PRIVATE LIMITED",
"KESAVATSAPUR TEA COMPANY PRIVATE LIMITED",
"KESBO PRIVATE LIMITED",
"KESDEE SYSTEMS INDIA PRIVATE LIMITED",
"KESELEC SCHREDER PRIVATE LIMITED",
"KESH KNITWEAR PRIVATE.LIMITED.",
"KESHA SALES PRIVATE LIMITED",
"KESHAL PLASTI CHEM PRIVATE LIMITED",
"KESHAR BHAWANI INFRA PROJECT PRIVATE LIMITED",
"KESHAR EMULSION PRIVATE LIMITED",
"KESHAR INFRASTRUCTURES",
"KESHAR MILK & MILK PRODUCTS PRODUCER COMPANY LIMITED",
"KESHARDEEP TUBE MANUFACTURING COMPANY PVT LTD",
"KESHARI CREATION PRIVATE LIMITED",
"KESHARI ESTATES PVT LTD",
"KESHARI INDUSTRIES PRIVATE LIMITED",
"KESHARI MERCANTILES PRIVATE LIMITED",
"KESHARI NATURAL STONES PRIVATE LIMITED",
"KESHARI SINGH CHAUDHARY HOSPITALS PRIVATE LIMITED",
"KESHARI SYNTHETICS PRIVATE LIMITED",
"KESHARI TEXTILES PVT LTD",
"KESHARINANDAN KNIT FABRICS PRIVATE LIMITED",
"KESHARINANDAN PRAKALPA PRIVATE LIMITED",
"KESHARIYA ENTERPRISES PRIVATE LIMITED",
"KESHARIYAJI SALT WORKS PRIVATE LIMITED",
"KESHARWANI MOTORS PRIVATE LIMITED",
"KESHAV AGRO THE SEED COMPANY",
"KESHAV ALUMINIUM PRIVATE LIMITED",
"KESHAV BIKE WORLD PRIVATE LIMITED",
"KESHAV BUILDPROP PRIVATE LIMITED",
"KESHAV COLD STORAGE PRIVATE LIMITED",
"KESHAV COMPUTER PRIVATE LIMITED",
"KESHAV CONTRACTOR PRIVATE LIMITED",
"KESHAV COTTON INDUSTRIES",
"KESHAV DIAMOND",
"KESHAV ELECTRICALS PVT LTD",
"KESHAV ESTATTES PRIVATE LIMITED",
"KESHAV FISCAL SERVICES PVT.LTD.",
"KESHAV GENERATORS PRIVATE LIMITED",
"KESHAV GRANIMARMO PRIVATE LIMITED",
"KESHAV HICHEM PRIVATE LIMITED",
"KESHAV HOLIDAY RESORT PRIVATE LIMITED",
"KESHAV HOSPITAL HOSHANGABAD",
"KESHAV HOSPITAL PRIVATE LIMITED",
"KESHAV INDUSTRIES PRIVATE LIMITED",
"KESHAV INFORMATION TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"KESHAV JEWELLERS (INDIA) PRIVATE LIMITED",
"KESHAV KHANAK SEEDS PRIVATE LIMITED",
"KESHAV KRUPA CONSTRUCTION PRIVATE LIMITED",
"KESHAV LOGISTICS SOLUTION PRIVATE LIMITED",
"KESHAV MADHAV INFRADEVELOPERS PRIVATE LIMITED",
"KESHAV MADHAV PACKAGING PRIVATE LIMITED",
"KESHAV MEMORIAL ENGINEERING COLLEGE",
"KESHAV MEMORIAL JR COLLEGE",
"KESHAV METALICS PRIVATE LIMITED",
"KESHAV MILK PRODUCTS PRIVATE LIMITED",
"KESHAV MOTORS PRIVATE LIMITED",
"KESHAV MULTIPACK (INDIA) PRIVATE LIMITED",
"KESHAV POWER LIMITED",
"KESHAV PUBLICATION PRIVATE LIMITED",
"KESHAV RESIN COATS PRIVATE LIMITED",
"KESHAV ROCKS PRIVATE LIMITED",
"KESHAV SANITARYWARETILES PRIVATE LIMITED",
"KESHAV SOUND AND EQUIPMENTS PRIVATE LIMITED",
"KESHAV SPINNING MILLS LIMITED",
"KESHAV TOWERS PRIVATE LIMITED",
"KESHAV UDYOG PRIVATE LIMITED",
"KESHAVA JUTE MILLS PRIVATE LIMITED",
"KESHAVA MEDI DEVICES PRIVATE LIMITED",
"KESHAVA ORGANICS PVT LTD",
"KESHAVA PLANTATIONS PRIVATE LIMITED",
"KESHAVA PRABHA MICROFIN PRIVATE LIMITED",
"KESHAVA REDDY E M SCHOOL",
"KESHAVA'S HOSPITALITY PRIVATE LIMITED",
"KESHAVDEEP IRON TRADERS PRIVATE LIMITED",
"KESHAVJI CHHAGANLAL JEWELLERS PRIVATE LIMITED",
"KESHAVKRIPA EDIBLE OILS PRIVATE LIMITED",
"KESHAVLAL KALYANJI & CO. PRIVATE LIMITED",
"KESHAVLAL V. BODANI EDUCATION FOUNDATION",
"KESHAYONA PROCON LIMITED",
"KESHMA CREATIONS PVT LTD",
"KESHO FOOD AND BEAVERAGE PRIVATE LIMITED",
"KESHO PACKAGING PRIVATE LIMITED",
"KESHOB REAL ESTATE PRIVATE LIMITED",
"KESHORAM MANUFACTURING PRIVATE LIMITED",
"KESHOTE CARRIERS PRIVATE LIMITED",
"KESHRANAND COTEX PRIVATE LIMITED",
"KESHRANAND GINNING AND PRESSING FACTORY PRIVATE LIMITED",
"KESHREE METALURGIES PRIVATE LIMITED",
"KESHRI EXPORT",
"KESHRI FOOD AND PACKING PRIVATE LIMITED",
"KESHRI ORGANISERS PRIVATE LIMITED",
"KESHRUP SYSTEMS PRIVATE LIMITED",
"KESHVI DEVELOPERS PRIVATE LIMITED",
"KESHVIN AUTOMOTORS PRIVATE LIMITED",
"KESHWANI EXIM PRIVATE LIMITED",
"KESINENI CARGO CARRIERS PRIVATE LIMITED",
"KESM INDIA LLP",
"KESORAM INDUSTRIES LIMITED",
"KESORAM TEXTILE MILLS LIMITED",
"KESRI ALLOYS PRIVATE LIMITED",
"KESRI CLOTH PRIVATE LIMITED",
"KESRI METAL LIMITED",
"KESRI NANDAN BALAJI SECURITY AGENCY PRIVATE LIMITED",
"KESRI OIL PRIVATE LIMITED",
"KESRI STEELS LIMITED",
"KESRIA PIPES PRIVATE LIMITED",
"KESRIHIND SECURITY PRIVATE LIMITED",
"KESSEBOEHMER FURNITURE FITTINGS INDIA PRIVATE LIMITED",
"KESSEBOEHMER INTERIOR SOLUTIONS INDIA PRIVATE LIMITED",
"KESSELS ENGINEERING WORKS PRIVATE LIMITED",
"KESSI FABRICS PRIVATE LIMITED",
"ARGANO SOFTWARE PRIVATE LIMITED",
"KESTO INFRASTRUCTURE PRIVATE LIMITED",
"KESTONE INTEGRATED MARKETING SERVICES PRIVATE LIMITED",
"KESTREL AVIATION PRIVATE LIMITED",
"KESULA TEXTILES PRIVATE LIMITED",
"KETAKI ENGINEERING P LIMITED",
"KETAKI ENTERPRISES PRIVATE LIMITED",
"KETAN BUTTONS PRIVATE LIMITED",
"KETAN CONSTRUCTION LIMITED",
"KETAN ENGINEERING SERVICES PRIVATE LIMITED",
"KETAN ENTERPRISES PRIVATE LIMITED",
"KETAN FOOD PRODUCTS PRIVATE LIMITED",
"KETAN GAS SERVICES PRIVATE LIMITED",
"KETAN INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"KETAN MOTORS LIMITED",
"KETAN PLASTIC INDUSTRIES PRIVATE LIMITED",
"KETAN RIBBONS PRIVATE LIMITED",
"KETANEYA FOOD & BEVERAGES PRIVATE LIMITED",
"KETCHUM SAMPARK PRIVATE LIMITED",
"KETCO SWITCHHGEAR PRIVATE LIMITED",
"KETEKI MOBILE TRADING PRIVATE LIMITED",
"KETHAMS HOSPITALS PRIVATE LIMITED",
"KETHOS TILES PRIVATE LIMITED",
"KETHRI INTERNATIONAL PRIVATE LIMITED",
"KETI CONSTRUCTIONS LIMITED",
"KETI HIGHWAY DEVELOPERS PRIVATE LIMITED",
"KETI INFRASTRUCTURE PRIVATE LIMITED",
"KETI SANGAM INFRASTRUCTURE INDIA LIMITED",
"KETIMPORTA IMPEX PRIVATE LIMITED",
"KETKI ENTERPRISES",
"KETKI FOOD AND BEVERAGES PRIVATE LIMITED",
"KETKI MEDICOS PRIVATE LIMITED",
"KETKI RESEARCH INSTITUTE OF MEDICAL SCIENCES LTD",
"KETKI SECURITIES PRIVATE LIMITED",
"KETKO APPLIANCES PRIVATE LIMITED",
"KETKO SAN PRIVATE LIMITED",
"KETO MOTORS PRIVATE LIMITED",
"KETOMAC MOTERS PRIVATE LIMITED",
"KETRON INDUSTRIES",
"KETSOL PRIVATE LIMITED",
"KETTELA TEA COMPANY PRIVATE LIMITED",
"KETTLE COMMUNICATIONS PRIVATE LIMITED",
"KETTLES TALENT NETWORKS PRIVATE LIMITED",
"KETTO FOUNDATION",
"KETTO ONLINE VENTURES PRIVATE LIMITED",
"KETTRO GOURMET GIFTS PRIVATE LIMITED",
"KETTY APPARELS INDIA PRIVATE LIMITED",
"KETUL CHEM PRIVATE LIMITED",
"KETUL ENTERPRISES PRIVATE LIMITED",
"KEVA AROMATICS PRIVATE LIMITED",
"KEVA AYURVEDA HEALTH CARE PRIVATE LIMITED",
"KEVA CONSTRUCTIONS PRIVATE LIMITED",
"KEVA FLAVOURS PRIVATE LIMITED",
"KEVA FRAGRANCES PRIVATE LIMITED",
"KEVADIYA CONSTRUCTION PRIVATE LIMITED",
"KEVADIYA INFRAPROJECTS PRIVATE LIMITED",
"KEVAL EXPORTS PRIVATE LIMITED",
"KEVAL INFOCOM PRIVATE LIMITED",
"KEVAL SHIV MARKETING VENTURE LLP",
"KEVALAM BUILDERS PRIVATE LIMITED",
"KEVAY STONES PRIVATE LIMITED",
"KEVENTER AGRO LTD",
"KEVENTER CAPITAL LIMITED",
"KEVENTER GLOBAL PRIVATE LIMITED",
"KEVENTER PROJECTS LIMITED",
"KEVENTER VENTURES LIMITED",
"KEVI CHEM COLOUR PRIVATE LIMITED",
"KEVIN CERAMIC PRIVATE LIMITED",
"KEVIN DIAMONDS PRIVATE LIMITED",
"KEVIN DYES & CHEMICALS PRIVATE LIMITED",
"KEVIN ELECTRICALS PRIVATE LIMITED",
"KEVIN ENTERPRISES PRIVATE LIMITED",
"KEVIN PACKERS PRIVATE LIMITED",
"KEVIN PROCESS TECHNOLOGIES PRIVATE LIMITED",
"KEVIN PUBLICATION PRIVATE LIMITED",
"KEVIN STEELS PRIVATE LIMITED",
"KEVIN TECHNOLOGIES PRIVATE LIMITED",
"KEVINJO PHARMACEUTICALS PRIVATE LIMITED",
"KEVIT HISOFT SOLUTION PRIVATE LIMITED",
"KEVIT TECHNOLOGIES PRIVATE LIMITED",
"KEVNIT DIGITAL SOLUTIONS PRIVATE LIMITED",
"KEVY'S GENERICS PRIVATE LIMITED",
"KEVY'S ORGANICS PRIVATE LIMITED",
"KEW CONSTRUCTIONS PVT. LTD.",
"KEWAL CARGO CARRIERS PVT LTD",
"KEWAL ENGINEERING PRIVATE LIMITED",
"KEWAL KIRAN CLOTHING LIMITED",
"KEWAL KIRAN FINANCE PRIVATE LIMITED",
"KEWAL KIRAN REALTORS AND INFRASTRUCTURES PRIVATE LIMITED",
"KEWALNATH TRADELINK PRIVATE LIMITED",
"KEWALRAM TEXTILES PRIVATE LIMITED",
"KEWALRAMANI HATCHERIES PRIVATE LIMITED",
"KEWAT CREATION PRIVATE LIMITED",
"KEWATIA FOODS PRIVATE LIMITED",
"KEWAUNEE LABWAY INDIA PRIVATE LIMITED",
"KEWIN CHEMICALS PRIVATE LIMITED",
"KEWLANI AGRO INDUSTRIES PRIVATE LIMITED",
"KEXVEG INDIA PRIVATE LIMITED",
"KEY ACCOUNT MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"KEY APPLICATION DEVELOPMENT INDIA PRIVATE LIMITED",
"KEY CARRIER MANAGEMENT SERVICE PRIVATE LIMITED",
"KEY COMPUTERS",
"KEY CORP LIMITED",
"KEY DISRUPTORS PRIVATE LIMITED",
"KEY FINCORP SERVICES PRIVATE LIMITED",
"KEY HUMAN RESOURCES PRIVATE LIMITED",
"KEY INDIA GRAPHICS PRIVATE LIMITED",
"KEY- MAN MARBLES PRIVATE LIMITED",
"KEY MOTOR VENTURES PRIVATE LIMITED",
"KEY OPERATION & ELECTROCOMPONENTS PRIVATE LIMITED",
"KEY PERFORMANCE MANAGEMENT LEARNINGS & MANPOWER SOLUTIONS PRIVATE LIMITED",
"KEY PRODUCTS PRIVATE LIMITED",
"KEY RECRUITMENT SOLUTIONS PRIVATE LIMITED",
"KEY SOFTWARE SERVICES PRIVATE LIMITED",
"KEY STONE DEVELOPERS PRIVATE LIMITED",
"KEY STONE ENTERPRISE",
"KEY STONES CLOUD TECH PRIVATE LIMITED",
"KEY TEXTILE ACCESSORIES PRIVATE LIMITED",
"KEY VEE MONOTEX PRIVATE LIMITED",
"KEY WEST INDUSTRIES PRIVATE LIMITED",
"KEYA ANAND SOLUTIONS PRIVATE LIMITED",
"KEYA APPARELS PRIVATE LIMITED",
"KEYA DIGITRONICS PRIVATE LIMITED",
"KEYA FOODS INTERNATIONAL PRIVATE LIMITED",
"KEYA FUSION TECHNOLOGY PRIVATE LIMITED",
"KEYA SETH AYURVEDIC SOLUTION PRIVATE LIMITED",
"KEYA SETH COMMUNICATION (INDIA) PRIVATE LIMITED",
"KEYAL EMPIRE DESIGNS PRIVATE LIMITED",
"KEYANA ESTATE LLP",
"KEYARAM DEVELOPERS & HOTELS PRIVATE LIMITED",
"KEYCHRON INDIA PRIVATE LIMITED",
"KEYCOAT INDIA PRIVATE LIMITED",
"KEYENCE INDIA PRIVATE LIMITED",
"KEYFALCON SOLUTIONS PRIVATE LIMITED",
"KEYGENES SOLUTIONS PRIVATE LIMITED",
"KEYLINE CROP SCIENCE PRIVATE LIMITED",
"KEYLINE MARITIME SERVICES PRIVATE LIMITED",
"KEYLINE SOLUTIONS PRIVATE LIMITED",
"KEYMAN REALTORS PRIVATE LIMITED",
"KEYMAX FOOD PRODUCTS INDIA PRIVATE LIMITED",
"KEYMEN LOANS DISTRIBUTION LIMITED",
"KEYMOUSE IT SERVICES PRIVATE LIMITED",
"KEYNOTE CAPITALS LIMITED",
"KEYNOTE FINANCIAL SERVICES LIMITED",
"KEYNOTE MARKETING PRIVATE LIMITED",
"KEYPOINT TECHNOLOGIES INDIA PRIVATE LIMITED",
"KEYSIGHT TECHNOLOGIES INDIA PRIVATE LIMITED",
"KEYSIGHT TECHNOLOGIES INTERNATIONAL INDIA PRIVATE LIMITED",
"KEYSOL CAPITAL ADVISORS PRIVATE LIMITED",
"KEYSTONE AUTOMATION SOLUTIONS PRIVATE LIMITED",
"KEYSTONE BUILDING SOLUTIONS (OPC) PRIVATE LIMITED",
"KEYSTONE BUSINESS SOLUTIONS PRIVATE LIMITED",
"KEYSTONE HEALTHCARE TECHNOLOGIES PRIVATE LIMITED",
"KEYSTONE INFRA PRIVATE. LIMITED.",
"KEYSTONE INFRASTRUCTURE PRIVATE LIMITED",
"KEYSTONE LIFESPACES PRIVATE LIMITED",
"KEYSTONE PROMOTERS PRIVATE LIMITED",
"KEYSTONE REALTORS LIMITED",
"KEYSTONE REALTORS PRIVATE LIMITED",
"KEYSTONE SCHOOL OF ENGINEERING",
"KEYSTONE SYSTECH PRIVATE LIMITED",
"KEYSTONE UNIVERSE OF EDUCATION",
"KEYSTONE WEAVES PRIVATE LIMITED",
"KEYSTRIDE LABS PRIVATE LIMITED",
"KEYSTROKE PRO INDIA PRIVATE LIMITED",
"KEY-TECH ENGINEERING INDIA PRIVATE LIMITED",
"KEYTON EXPORTS PRIVATE LIMITED",
"KEYTONE CORPORATE SOLUTIONS PRIVATE LIMITED",
"KEYUR ANIMAL HEALTHCARE PRIVATE LIMITED",
"KEYUR ENTERPRISES PRIVATE LIMITED",
"KEYUR GILTS PRIVATE LIMITED",
"KEYUR ISPAT LIMITED",
"KEYUR PHARMACHEM INDIA PRIVATE LIMITED",
"KEYVALUE SOFTWARE SYSTEMS PRIVATE LIMITED",
"KEYWEALTH ADVISOR PRIVATE LIMITED",
"KEYWEST REALTY PRIVATE LIMITED",
"KEYWORD INDIA NETWORK PRIVATE LIMITED",
"KEZZLER HINDUSTAN PRIVATE LIMITED",
"KF BIOPLANTS PRIVATE LIMITED",
"KF INSTRUMENTS INDIA PRIVATE LIMITED",
"KF VALVES INDIA PRIVATE LIMITED",
"K-FAM MICRO PRODUCTS PRIVATE LIMITED",
"KFC LOGISTICS AND EXPORTS PRIVATE LIMITED",
"KFC SHOEMAKER PRIVATE LIMITED",
"KFCH RESTAURANTS PRIVATE LIMITED",
"KFIN NIDHI LIMITED",
"KFIN TECHNOLOGIES PRIVATE LIMITED",
"K-FINS PUMPS PRIVATE LIMITED",
"KFM AGRO PRIVATE LIMITED",
"KFS BIOTECH PRIVATE LIMITED",
"KFS FASHIONS PRIVATE LIMITED",
"KFW BANKENGRUPPE",
"KG & SONS PRIVATE LIMITED",
"KG ASHTECH PRIVATE LIMITED",
"KG BRIGHT ENTERPRISES INDIA PRIVATE LIMITED",
"KG EXPORTS",
"KG FOUNDATIONS PRIVATE LIMITED",
"KG FUNCTIONAL BEVERAGES PRIVATE LIMITED",
"KG GK JEWELLERS PRIVATE LIMITED",
"KG HOSPITAL",
"KG INFORMATION SYSTEMS PRIVATE LIMITED",
"KG INFOSYSTEM PRIVATE LIMITED",
"KG IRON & STEEL CASTINGS PRIVATE LIMITED",
"KG MULTISPECIALITY HOSPITAL &REASEARCH CENTER",
"KG REDDY COLLEGE OF ENGINEERING AND TECHNOLOGY",
"KG TECHNOLOGIES INDIA PRIVATE LIMITED",
"KGA ELITE CONTINENTAL HOTELS PRIVATE LIMITED",
"KGA SECURITIES (INDIA) LIMITED",
"KGA TEX KNIT (INDIA) (P) LTD",
"KGAMIGOS IMPEX PRIVATE LIMITED",
"KGBIND MANUFACTURING AND MANAGEMENT SERVICES PRIVATE LIMITED",
"KGC ENGINEERING PROJECTS PRIVATE LIMITED",
"KGC HOSPITALITY PRIVATE LIMITED",
"KGC LOGISTICS PRIVATE LIMITED",
"KGCENTERPRISES",
"KGEYES RESIDENCY PRIVATE LIMITED",
"KGG SERVICES LLP",
"KGI CLOTHING PRIVATE LIMITED",
"KGI MERCANTILE PRIVATE LIMITED",
"KGIRDHARLAL INTERNATIONAL PRIVATE LIMITED",
"KGISL INFRASTRUCTURES PRIVATE LIMITED",
"KGISL TRUST",
"KGJ SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"KGK ARTISTIC STONES LLP",
"KGK CREATIONS INDIA PRIVATE LIMITED",
"KGK CREATIONS MFG PRIVATE LIMITED",
"KGK CREATIONS PRIVATE LIMITED",
"KGK CREATIONS PROCESSING PRIVATE LIMITED",
"KGK DIA PROCESSING PRIVATE LIMITED",
"KGK DIAMONDS I PRIVATE LIMITED",
"KGK ENGINEERS PRIVATE LIMITED",
"KGK ENTICE INDIA PRIVATE LIMITED",
"KGK GEMS PRIVATE LIMITED",
"KGK HOMES PRIVATE LIMITED",
"KGK INDUSTRIES PRIVATE LIMITED",
"KGK INNOVATIVE PRIVATE LIMITED",
"KGK JET INDIA PRIVATE LIMITED",
"KGK JEWELLERY MANUFACTURING PRIVATE LIMITED",
"KGK REALTY (INDIA) LIMITED",
"KGK REALTY (INDIA) PRIVATE LIMITED",
"KGK TRADELINKS PRIVATE LIMITED",
"KGKOR STEEL INDIA PRIVATE LIMITED",
"KGL IMPEX PRIVATE LIMITED",
"KGL NETWORK PRIVATE LIMITED",
"KGM COTSPIN TEX PRIVATE LIMITED",
"KGM FERTILIZERS & AGROTECH PRIVATE LIMITED",
"KGM IMMIGRATION & EDUCATIONAL CONSULTANTS PRIVATE LIMITED",
"KGM LIME INDUSTRIES PRIVATE LIMITED",
"KGM TECHNOLOGY PRIVATE LIMITED",
"KGM UNIVERSAL PRIVATE LIMITED",
"KGMS BROKING AND RESEARCH PRIVATE LIMITED",
"KGMT MULTISPECIALITY HOSPITAL",
"KGN COMTRADE PRIVATE LIMITED",
"KGN GENERAL TRADING CO. LIMITED",
"KGN MOVERS PRIVATE LIMITED",
"KGN PHARMACEUTICALS PRIVATE LIMITED",
"KGN POLYMERS PRIVATE LIMITED",
"KGN PRESTRESS PRIVATE LIMITED",
"KGN VENTURES PRIVATE LIMITED",
"KGOC GLOBAL LLP",
"KGP AUTO LIMITED",
"KGP TECH SOLUTIONS LLP",
"KGPCO INDIA PRIVATE LIMITED",
"KGPS MECHANICAL PRIVATE LIMITED",
"KGR CONSULTANCY OPC PRIVATE LIMITED",
"KGR ENTERPRISES",
"KGR GREENS INFRATECH PRIVATE LIMITED",
"KGR IMPORT & EXPORT PRIVATE LIMITED",
"KGR POLYMERS PRIVATE LIMITED",
"KGR SPINNING MILLS PRIVATE LIMITED",
"KGS ADVANCED MR AND CT SCAN PRIVATE LIMITED",
"KGS AND CBM'S INDIA PRIVATE LIMITED",
"KGS ENGINEERING LIMITED",
"KGS LOGISTICS PRIVATE LIMITED",
"KGS PRINTEK PVT LIMITED",
"KGS SOURCING INDIA PRIVATE LIMITED",
"KGSK ALLIANCE PRIVATE LIMITED",
"KGVK AGRO LIMITED",
"KGVV SCHOOL",
"KGY GLASS INDUSTRIES PRIVATE LIMITED",
"KH AGENCIES",
"KH CONTRACTS PRIVATE LIMITED",
"KH ENGINEERING AND BUSINESS CONSULTANCY",
"K H EXPORTS INDIA PRIVATE LIMITED",
"KH LEATHER INDUSTRIES PRIVATE LIMITED",
"KHA CREATION PRIVATE LIMITED",
"KHABAR COMMUNICATION PRIVATE LIMITED",
"KHABRI INC",
"KHACHROD NAGAR PALIKA",
"KHADEER ENTERPRISES",
"KHADERSHAH CONSTRUCTION PRIVATE LIMITED",
"KHADERSHAH INFRATECH PRIVATE LIMITED",
"KHADI & VILLAGE INDUSTRIES COMMISSION",
"KHADI AND VILLAGE INDUSTRIES COMMISSION",
"KHADIM INDIA LIMITED",
"KHADKESHWARA BREEDERS PRIVATE LIMITED",
"KHAGARIA PURNEA HIGHWAY PROJECT LIMITED",
"KHAGRAGACHI WEST PRIMARY SCHOOL",
"KHAIRABAD EYE HOSPITAL",
"KHAIRATI TRADING COMPANY",
"KHAITAN & CO LLP",
"KHAITAN BEVERAGES PRIVATE LIMITED",
"KHAITAN CEMENT PVT. LTD.",
"KHAITAN CHEMICALS AND FERTILIZERS LIMITED",
"KHAITAN COMMERCIAL SERVICES PRIVATE LIMITED",
"KHAITAN CONSULTANTS LIMITED",
"KHAITAN EDUSERVE PRIVATE LIMITED",
"KHAITAN ELECTRONICS",
"KHAITAN HOTELS P LTD",
"KHAITAN INDIA LIMITED",
"KHAITAN IRON FOUNDRY PRIVATE LIMITED",
"KHAITAN LOGISTICS PRIVATE LIMITED",
"KHAITAN MERCANTILE LTD",
"KHAITAN PAPER & PACKAGING PVT LTD",
"KHAITAN PHOSPHATE AND PESTICIDES PRIVATE LIMITED",
"KHAITAN PUBLIC SCHOOL",
"KHAITAN RICE MILL PRIVATE LIMITED",
"KHAITAN SYNTHETICS PVT LTD",
"KHAITAN TRANSPORT CO PVT LTD",
"KHAITAN WINDING WIRE PRIVATE LIMITED",
"KHAITAN WORLD SCHOOL",
"KHAITAR INDUSTRIES PRIVATE LIMITED",
"KHAJA BANDANAWAZ UNIVERSITY",
"KHAJAGI PRATHAMIK VIDYAMANDIR SHANIMANDAL",
"KHAJANCHI AND GANDHI STOCKBROKING PRIVATE LIMITED",
"KHAJANCHIS PROPERTY PVT LTD",
"KHAJIT CHEM PRIVATE LIMITED",
"KHAJRANA GANESH PROPERTIES PRIVATE LIMITED",
"KHAJURAHO BUILDERS AND CONSTRUCTION PRIVATE LIMITED",
"KHAJURAHO INFRASTRUCTURE PRIVATE LIMITED",
"KHAJURAHO MOTORS PRIVATE LIMITED",
"KHAJURAHO STONES (INDIA) PRIVATE LIMITED",
"KHAJURGAON HOTELS & RESORTS LIMITED",
"KHAKHI BABA COLONISERS AND DEVELOPERS PRIVATE LIMITED",
"KHAKHIJALIYA MADHYAMIK SHALA",
"KHAKHU POULTRY PRIVATE LIMITED",
"KHALATKAR CONSTRUCTION",
"KHALATKAR CONSTRUCTION INFRA PRIVATE LIMITED",
"KHALGHAT MANAWAR TOLL PRIVATE LIMITED",
"KHALGHAT SENDHWA TOLLWAYS PRIVATE LIMITED",
"KHALGHAT SENDHWA TOLLWAYS PRIVATE. LIMITED.",
"KHALILABAD FLOUR MILLS PRIVATE LIMITED",
"KHALSA AUTOMOVERS PRIVATE LIMITED",
"KHALSA COLLEGE AMRITSAR",
"KHALSA COTSPIN PRIVATE LIMITED",
"KHALSA ENGLISH HIGH SCHOOL",
"KHALSA EXPORTS PRIVATE LIMITED",
"KHALSA NUTRITIOUS INDIA PRIVATE LIMITED",
"KHALSAE-VEHICLES PRIVATE LIMITED",
"KHAMANWALA FOOD PRODUCTS PRIVATE LIMITED",
"KHAMBATTA SECURITIES LIMITED",
"KHAMBETE KOTHARI CANS AND ALLIED PRODUCTS PRIVATE LIMITED",
"KHAMESRA BROTHERS PRIVATE LIMITED",
"KHAMKAR CONSTRUCTIONS PRIVATE LIMITED",
"KHAMMAM GRANITE PRIVATE LIMITED",
"KHAMMAM MILKLINE PRIVATE LIMITED",
"KHAN ACADEMY INDIA",
"KHAN SAHEB FOODS PRIVATE LIMITED",
"KHAN STEEL CENTRE PRIVATE LIMITED",
"KHANA KHAZANA INDIA PRIVATE LIMITED",
"KHANAK AGENCY PRIVATE LIMITED",
"KHANAL FOODS PRIVATE LIMITED",
"KHANAL INDUSTRIES PRIVATE LIMITED",
"KHAND SHIKSHA ADHIKARI DEPALPUR",
"KHAND VIKAS ADHIKARI FATEHPUR 84 UNNAO",
"KHANDAGIRI PULP PRIVATE LIMITED",
"KHANDAKA HOSPITAL",
"KHANDALA NAGARPANCHYAYAT KHANDALA",
"KHANDAY INFRASTRUCTURE PRIVATE LIMITED",
"KHANDAY PROJECTS PRIVATE LIMITED",
"KHANDE SHITOLE BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"KHANDELA CHEMICALS PRIVATE LIMITED",
"KHANDELA INDUSTRIES PRIVATE LIMITED",
"KHANDELA MINERALS PRIVATE LIMITED",
"KHANDELIA OIL AND GENERAL MILLS PRIVATE LIMITED",
"KHANDELIA UDYOG PRIVATE LIMITED",
"KHANDELWAL AGENCIES PRIVATE LIMITED",
"KHANDELWAL ASSOCIATES",
"KHANDELWAL AUTOCORP PRIVATE LIMITED",
"KHANDELWAL AUTOMOBILES (BETUL) PRIVATE LIMITED",
"KHANDELWAL AUTOMOTIVE PRIVATE LIMITED",
"KHANDELWAL AUTOWHEELS PRIVATE LIMITED",
"KHANDELWAL AYURVED BHAWAN PRIVATE LIMITED",
"KHANDELWAL BUSAR INDUSTRIES PRIVATE LIMITED",
"KHANDELWAL CHAIN PRIVATE LIMITED",
"KHANDELWAL EDIBLE OILS PRIVATE LIMITED",
"KHANDELWAL ESTATES PRIVATE LIMITED",
"KHANDELWAL FIBRES PRIVATE LIMITED",
"KHANDELWAL FINANCE PVT LTD",
"KHANDELWAL FREIGHT CARRIER PRIVATE LIMITED",
"KHANDELWAL FURNITURE MART PRIVATE LIMITED",
"KHANDELWAL GARTEX PRIVATE LIMITED",
"KHANDELWAL GROUP PRIVATE LIMITED",
"KHANDELWAL HANDLOOM FACTORY PRIVATE LIMITED",
"KHANDELWAL HI-PRO PROTEIN FEED PRIVATE LIMITED",
"KHANDELWAL IMPEX PRIVATE LIMITED",
"KHANDELWAL INDUSTRIES PRIVATE LIMITED",
"KHANDELWAL INFRASTRUCTURE PRIVATE LIMITED",
"KHANDELWAL INSULATIONS PRIVATE. LIMITED.",
"KHANDELWAL IRRIGATION PVT. LTD",
"KHANDELWAL JEWELLERS (AKOLA) PRIVATE LIMITED",
"KHANDELWAL JUTEX PRIVATE LIMITED",
"KHANDELWAL LABORATORIES PRIVATE LIMITED",
"KHANDELWAL LOGISTICS PRIVATE LIMITED",
"KHANDELWAL LOHA PRIVATE LIMITED",
"KHANDELWAL MACHINING PRIVATE LIMITED",
"KHANDELWAL MOLASSES BULK CARRIER PRIVATE LIMITED",
"KHANDELWAL MOTORS PRIVATE LIMITED",
"KHANDELWAL NAMKEENS AND SNACKS PRIVATE LIMITED",
"KHANDELWAL ODD-SAHRES PVT LTD",
"KHANDELWAL PACKAGING INDUSTRIES PRIVATE LIMITED",
"KHANDELWAL PESTICIDES PRIVATE LIMITED",
"KHANDELWAL PHARMA & COSMETIC EQUIPMENTS",
"KHANDELWAL SANITATIONS PVT LTD",
"KHANDELWAL SAW MILLS PRIVATE LIMITED",
"KHANDELWAL SECURITIES PRIVATE LIMITED",
"KHANDELWAL SPOT BULLION TRADING INDIA PRIVATE LIMITED",
"KHANDELWAL SURTI PRIVATE LIMITED",
"KHANDELWAL VEHICLES PRIVATE LIMITED",
"KHANDELWAL WIRES & ELECTRICALS PRIVATE LIMITED",
"KHANDESH ROLLER FLOUR MILLS PRIVATE LIMITED",
"KHANDIGE ORGANIC HEALTH PRODUCTS PRIVATE LIMITED",
"KHANDKE WIND ENERGY PRIVATE LIMITED",
"KHANDOBA DISTILLERIES PRIVATE LIMITED",
"KHANDUJA COLD STORAGE LIMITED",
"KHANDUJA SALES PRIVATE LIMITED",
"KHANDURI CONTRACTORS PRIVATE LIMITED",
"KHANDWA AGROH PATHWAYS PRIVATE LIMITED",
"KHANDWA NAGAR NIGAM",
"KHANDWALA COMMERCIAL PRIVATE LIMITED",
"KHANDWALA FINSTOCK PVT LTD",
"KHANDWALA SECURITIES LIMITED",
"KHANIJ BIDESH INDIA LIMITED",
"KHANNA AND KHANNA LIMITED",
"KHANNA AND SAWANT INTERIORS PRIVATE LIMITED",
"KHANNA AUTO SALES PRIVATE LIMITED",
"KHANNA AUTOMART PRIVATE LIMITED",
"KHANNA CAR PLAZA PRIVATE LIMITED",
"KHANNA DESIGNERS & CONSULTANTS PRIVATE LIMITED",
"KHANNA DIAGNOSTICS PRIVATE LIMITED",
"KHANNA EXPORTS PVT LTD",
"KHANNA FEED LIMITED",
"KHANNA FINCAP PRIVATE LIMITED",
"KHANNA FOREX PRIVATE LIMITED",
"KHANNA GEMS PRIVATE LIMITED",
"KHANNA HOLIDAYS PRIVATE LIMITED",
"KHANNA HOTELS PRIVATE LIMITED MUMBAI",
"KHANNA INDUSTRIAL PIPES PRIVATE LIMITED",
"KHANNA JEWELLERS PRIVATE LIMITED",
"KHANNA METALS PRIVATE LIMITED",
"KHANNA MULTISPECIALITY HOSPITALS PRIVATE LIMITED",
"KHANNA PAPER MILLS LIMITED",
"KHANNA POLYRIB PRIVATE LIMITED",
"KHANNA POLYWEAVE PRIVATE LIMITED",
"KHANNA PROPERTIES & INFRASTRUCTURES PRIVATE LIMITED",
"KHANNA RAYON INDUSTRIES PRIVATE LIMITED",
"KHANNA SILK MILLS PRIVATE LIMITED",
"KHANNA SPORTS INDUSTRIES PRIVATE LIMITED",
"KHANNA TECHNOCRATS PRIVATE LIMITED",
"KHANNA YARNS AND TEXTILES PRIVATE LIMITED",
"KHANNA'S VIVEK CHEMICALS PRIVATE LIMITED",
"KHANNBA ENTERPRISES PRIVATE LIMITED",
"KHANPUR COLD STORAGE PVT LTD",
"KHANSE WEBMEDIA PRIVATE LIMITED",
"KHANUJA PATRA AND ASSOCIATES",
"KHANVILKAR PLASTICISER PRIVATE LIMITED",
"KHAPTISON ENGINEERING PRIVATE LIMITED",
"KHAR EDUCATION SOCIETY",
"KHARAGPUR FLOUR MILLS PRIVATE LIMITED",
"KHARAGPUR METAL REFORMING INDUSTRIES PVT LTD",
"KHARAUDI BAGHWANI PRODUCER COMPANY LIMITED",
"KHARAUJHA BUILDERS PRIVATE LIMITED",
"KHARAUJHA ENGINEERING LLP",
"KHARAVELA ENTERPRISE PRIVATE LIMITED",
"KHARE AGRO MECH INDUSTRIES PRIVATE LIMITED",
"KHARE AND TARKUNDE INFRASTRUCTURE PRIVATE LIMITED",
"KHARE ENGINEERING AND TOOLS PVT LTD",
"KHARGHAR MEDICITY HOSPITAL",
"KHARGHAR VIKHROLI TRANSMISSION LIMITED",
"KHARGONE TRANSMISSION LIMITED",
"KHARI HYDRO POWER PROJECT PRIVATE LIMITED",
"KHARKAI BUILDING SYSTEMS PRIVATE LIMITED",
"KHAS EXPORTS PRIVATE LIMITED",
"KHASI ALLOYS PRIVATE LIMITED",
"KHATANA STONES PRIVATE LIMITED",
"KHATAU MAKANJI SPINNING AND WEAVING COMPANY LIMITED",
"KHATAV HOSPITALS PRIVATE LIMITED",
"KHATAV MAN TALUKA AGRO PROCESSING PRIVATE LIMITED",
"KHATENDRA MARKETING PVT LTD",
"KHATI SOLUTIONS PRIVATE LIMITED",
"KHATIB & ALAMI ENGINEERING CONSULTANTS PRIVATE LIMITED",
"KHATIBENG PRIVATE LIMITED",
"KHATKHATA WEAVERS FOUNDATION",
"KHATOON ZUBEDA YASEEN URDU HIGH SCHOOL",
"KHATOR TECHNICAL TEXTILES PRIVATE LIMITED",
"KHATORE PHARMACEUTICALS PVT LTD",
"KHATRI CASTINGS PRIVATE LIMITED",
"KHATRI DYEING PRIVATE LIMITED",
"KHATRI HEALTHCARE PRIVATE LIMITED",
"KHATRI INDUSTRIES PRIVATE LIMITED",
"KHATRI INTERNATIONAL LIMITED",
"KHATRI INVESTMENTS PRIVATE LIMITED",
"KHATRI PAINTS ( INDIA) LIMITED",
"KHATTAR EDIBLES PRIVATE LIMITED",
"KHATTAR EXPORTS PRIVATE LIMITED",
"KHATTAR MARINE SERVICES PRIVATE LIMITED",
"KHATTU CONSTRUCTIONS AND DEVELOPERS PRIVATE LIMITED",
"KHATTU SHYAM UDYOG PRIVATE LIMITED",
"KHATU NARESH OILS PRIVATE LIMITED",
"KHATU SHYAM GLOBAL APPLIANCES PRIVATE LIMITED",
"KHATU SHYAM HOTELS PRIVATE LIMITED",
"KHATU SHYAM INFRA PROJECTS PRIVATE LIMITED",
"KHATU SHYAM IRON & STEEL PRIVATE LIMITED",
"KHATU SHYAM ISPAT PRIVATE LIMITED.",
"KHATU SHYAM JI TOLLWAYS PRIVATE LIMITED",
"KHATUCO EXPORT (INDIA) PRIVATE LIMITED",
"KHATUNARESH ENTERPRISES PRIVATE LIMITED",
"KHATUSHYAM CORRUGATED BOXES PRIVATE LIMITED",
"KHATUSHYAM DYEING AND PRINTING MILLS PRIVATE LIMITED",
"KHATUSHYAM NATURAL RESOURCES PRIVATE LIMITED",
"KHATUSHYAM PAPER INDUSTRIES PRIVATE LIMITED",
"KHATWANI MOTORS PRIVATE LIMITED",
"KHATWANI SALES & SERVICES PRIVATE LIMITED",
"KHAVDA MULTICOM PRIVATE LIMITED",
"KHAVDA-BHUJ TRANSMISSION LIMITED",
"KHAYA SOLAR PROJECTS PRIVATE LIMITED",
"KHAYATI STEEL INDUSTRIES PRIVATE LIMITED",
"KHAYERBARI TEA CO LTD",
"KHAZANA AGROTECH PRIVATE LIMITED",
"KHAZANA JEWELLERY",
"KHAZANA LIFESTYLE PRIVATE LIMITED",
"KHAZANA TRADELINKS PRIVATE LIMITED",
"KHAZANAH INDIA ADVISORS PRIVATE LIMITED",
"KHAZANCHI JEWELLERS LIMITED",
"KHAZANCHI SILVERS PRIVATE LIMITED",
"KHAZIR KRAFT PRIVATE LIMITED",
"KHC ENGINEERING PRIVATE LIMITED",
"KHC EXIM PRIVATE LIMITED",
"KHC HEALTHCARE INDIA PRIVATE LIMITED",
"KHD VALVES AUTOMATION PRIVATE LIMITED",
"KHED ECONOMIC INFRASTRUCTURE PRIVATE LIMITED",
"KHED SINNAR EXPRESSWAY LIMITED",
"KHED TALUKA EDUCATION SOCIETY S RAJGURUNAGAR KHED",
"KHEDA DISTRICT EDUCATION COMMITTEE MANAGED PRIMARY SCHOOL TEACHER",
"KHEDA HI-TECH SOLAR ENERGY PRIVATE LIMITED",
"KHEDARIA ISPAT LIMITED",
"KHEDDA INSULATION SYSTEMS PRIVATE LIMITED",
"KHEDUT AGRO ENGINEERING PRIVATE LIMITED",
"KHEDUT COTEX PRIVATE LIMITED",
"KHEDUT FEEDS AND FOODS PRIVATE LIMITED",
"KHEDUT IRRIGATION (INDIA) PRIVATE LIMITED",
"KHEDUT SOLVEXP PRIVATE LIMITED",
"KHEE LOGISTICS INDIA PRIVATE LIMITED",
"KHEM CHAND PAWAN KUMAR SARRAF PRIVATE LIMITED",
"KHEMANI DISTILLERIES PRIVATE LIMITED",
"KHEMANI DISTRIBUTORS & MARKETING LIMITED",
"KHEMANI METAL INDUSTIES PVT LTD",
"KHEMANI TEA CO PVT LTD",
"KHEMCHAND SONS PRIVATE LIMITED",
"KHEMI TUBES PRIVATE LIMITED",
"KHEMJI TRAILER PRIVATE LIMITED",
"KHEMJI WIRE AND WIRE PRIVATE LIMITED",
"KHEMKA ADHESIVE TAPE PRIVATE LIMITED",
"KHEMKA AVIATION PRIVATE LIMITED",
"KHEMKA EXIM SOLUTIONS PVT LTD",
"KHEMKA FLOUR MILLS PRIVATE LIMITED",
"KHEMKA MINERALS PRIVATE LIMITED",
"KHEMKA MOTORS PRIVATE LIMITED",
"KHEMKA POLY TEX PRIVATE LIMITED",
"KHEMKA REFRACTORIES PRIVATE LIMITED",
"KHEMKA SPLINE GAUGES PRIVATE LIMITED",
"KHEMKA WOODCRAFT PRIVATE LIMITED",
"KHEMRAJ KATARA SATELLITE HOSPITAL",
"KHERA FOODS AND BEVERAGES PRIVATE LIMITED",
"KHERA INSTRUMENTS PRIVATE LIMITED",
"KHERA PHARMA PRIVATE LIMITED",
"KHERA PIPES PRIVATE LIMITED",
"KHERA PLASTICHEM LIMITED",
"KHERANI PAPER MILLS PRIVATE LIMITED",
"KHERATI LALL SONS PRIVATE LIMITED",
"KHETAN ALLOYS PRIVATE LIMITED",
"KHETAN BUILDCON PRIVATE LIMITED",
"KHETAN BUSINESS CORPORATION PVT LTD",
"KHETAN CONTAINERS PRIVATE LIMITED",
"KHETAN CORPORATE SOLUTIONS PRIVATE LIMITED.",
"KHETAN EXIM PRIVATE LIMITED",
"KHETAN FASHION PRIVATE LIMITED",
"KHETAN HOSPITAL",
"KHETAN MEDIA CREATION PRIVATE LIMITED",
"KHETAN MERCHANDISE PRIVATE LIMITED",
"KHETAN METALLIC OXIDES PRIVATE LIMITED",
"KHETAN PACK FINE PRIVATE LIMITED",
"KHETAN PLASTOPACK PRIVATE LIMITED",
"KHETAN POLYTEX PRIVATE LIMITED",
"KHETAN SYNTHETICS PRIVATE LIMITED",
"KHETAN TILES PRIVATE LIMITED",
"KHETAN TRADELINK PRIVATE LIMITED",
"KHETAN TWIST-NET PRIVATE LIMITED",
"KHETAN VINIYOG PRIVATE LIMITED",
"KHETAN WELPACK PVT LTD",
"KHETANI MOTORS AND TRACTORS PRIVATE LIMITED",
"KHETARPAL HOSPITAL",
"KHETAWAT FINANCIAL RESOURCES PRIVATE LIMITED",
"KHETAWAT MERCANTILES PRIVATE LIMITED",
"KHETHWORKS PRIVATE LIMITED",
"KHETRIYE KARYALAY MADHMIK SHIKSHA PRISHAD",
"KHETTIGRO EQUIPMENT PRIVATE LIMITED",
"KHETWANI DESIGNS PRIVATE LIMITED",
"KHFM HOSPITALITY & FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"KHG HEALTH SERVICES PRIVATE LIMITED",
"KHICHA PHOSCHEM LTD",
"KHIDDERPORE COLLEGE",
"KHILARI INFRASTRUCTURE PRIVATE LIMITED",
"KHILARI LIFESCIENCES PRIVATE LIMITED",
"KHIMANI WATCH COMPANY PRIVATE LIMITED",
"KHIMESARA SILK MILLS PRIVATE LIMITED",
"KHIMJI POONJA FRIEGHT FORWORDERS PRIVATE LIMITED",
"KHIMJI RAMDAS INDIA PRIVATE LIMITED",
"KHIMJI VISRAM AND SONS GUJARAT PRIVATE LIMITED",
"KHIMJI-K.D.& SONS PRIVATE LIMITED",
"KHIMSAR FORT PVT LTD",
"KHIRA STEEL WORKS PRIVATE LIMITED",
"KHIRKEE CHEMICALS PRIVATE LIMITED",
"KHIVRAJ MOTORS PRIVATE LIMITED",
"KHIVRAJ PEARL",
"KHIVRAJ TECH PARK PRIVATE LIMITED",
"KHIVRAJ VAHAN PRIVATE LIMITED",
"KHIWASARA FINANCE & LEASING LIMITED",
"KHK ALLOYS PRIVATE LIMITED",
"KHK PRESSINGS AND FORGING PRIVATE LIMITED",
"KHM DRIVE SYSTEMS PRIVATE LIMITED",
"KHM HOSPITAL",
"KHN INTERIORS INDIA PRIVATE LIMITED",
"KHODAL CORPORATION PRIVATE LIMITED",
"KHODAL DIAMONDS PRIVATE LIMITED",
"KHODAL EXPORTS PRIVATE LIMITED",
"KHODAL TWISTING AND WEAVING PRIVATE LIMITED",
"KHODAMBARI UNION P B HS SCHOOL HS",
"KHODAY INDUSTRIES (HYDERABAD) PRIVATE LIMITED",
"KHODAY INDUSTRIES PRIVATE LIMITED",
"KHODAYS BREWERIES LIMITED",
"KHODIYAR AGRI-FLOUR MILLS PRIVATE LIMITED",
"KHODIYAR AUTO PARTS (GUJ) PRIVATE LIMITED",
"KHODIYAR AUTOMOTIVE PRIVATE LIMITED",
"KHODIYAR CERAMICS (INDIA) PRIVATE LIMITED",
"KHODIYAR CONSULTANTS PRIVATE LIMITED",
"KHODIYAR DEVELOPERS & INFRASTRUCTURE PRIVATE LIMITED",
"KHODIYAR ENGINEERING",
"KHODIYAR ESOLUTIONS LLP",
"KHODIYAR INDUSTRIES",
"KHODIYAR MARKETING PRIVATE LIMITED",
"KHODIYAR PROPERTIES PRIVATE LIMITED",
"KHODIYAR SAREES PRIVATE LIMITED",
"KHODIYAR STAIRS PRIVATE LIMITED",
"KHODIYAR U B VIDHYALAYA MOBHA",
"KHOJ INFORMATION TECHNOLOGY PRIVATE LIMITED",
"KHOJ RESEARCH SOLUTIONS PRIVATE LIMITED",
"KHOJA HOTELS AND RESORTS PRIVATE LIMITED",
"KHOKAN AUTO DISTRIBUTORS PRIVATE LIMITED",
"KHOKAN MOTORS WORKS PRIVATE LIMITED",
"KHOKHANI CERAMIC PRIVATE LIMITED",
"KHOKHAR ELECTRICALS PRIVATE LIMITED",
"KHOKHAR INFRASTRUCTURE PRIVATE LIMITED",
"KHOKHARIYA ALLUMINIUM PRIVATE LIMITED",
"KHOMANE AGRO FOOD INDUSTRIES PRIVATE LIMITED",
"KHOOBSURAT APPARELS PRIVATE LIMITED",
"KHOPE AGENCIES PRIVATE LIMITED",
"KHORAKIWALA HOLDINGS AND INVESTMENTS PRIVATE LIMITED",
"KHOROS INDIA R & D PRIVATE LIMITED",
"KHOSE CONSULTANCY SERVICES PRIVATE LIMITED",
"KHOSHAL PLASTO PACK INDIA PRIVATE LIMITED",
"KHOSLA AGRO OVERSEAS",
"KHOSLA AUTO PRODUCTS PRIVATE LIMITED",
"KHOSLA ELECTRONICS PRIVATE LIMITED",
"KHOSLA ENGINEERING PRIVATE LIMITED",
"KHOSLA GRAINS PRIVATE LIMITED",
"KHOSLA INVESTMENT PRIVATE LIMITED",
"KHOSLA LABS PRIVATE LIMITED",
"KHOSLA MACHINES PRIVATE LIMITED",
"KHOSLA PLASTICS PVT LTD",
"KHOSLA PROFIL PRIVATE LIMITED",
"KHOSLA RICELAND PRIVATE LIMITED",
"KHOSLA RUBBERS PRIVATE LIMITED",
"KHOSLA TRAVELS PRIVATE LIMITED",
"KHOSYA ROAD LINES PRIVATE LIMITED",
"KHP RESOURCES PRIVATE LIMITED",
"KHP STEELWORKS PRIVATE LIMITED",
"KHR HOSPITALITY INDIA LIMITED",
"KHR INFRASTRUCTURES PRIVATE LIMITED",
"KHS IMPEX PRIVATE LIMITED",
"KHS MACHINERY PRIVATE LIMITED",
"KHUB RAM FOODS PRIVATE LIMITED",
"KHUBCHANDANI HEALTHCARE PRIVATE LIMITED",
"KHUDIRAM BOSE CENTRAL COLLEGE",
"KHUDIRAM COLD STORAGE PRIVATE LIMITED",
"KHUKRI ENTERPRISES PRIVATE LIMITED",
"KHULLAR APPARELS PRIVATE LIMITED",
"KHULLAR EVENT SERVICES PRIVATE LIMITED",
"KHUMBU INFORMATION SYSTEMS PRIVATE LIMITED",
"KHURANA AUTOMOTIVE PRIVATE LIMITED",
"KHURANA CARBIDES PRIVATE LIMITED",
"KHURANA CLOTHINGS PRIVATE LIMITED",
"KHURANA DIAMOND VILLA PRIVATE LIMITED",
"KHURANA ENGINEERING WORKS PRIVATE LIMITED",
"KHURANA EXPORTS - KANPUR",
"KHURANA FURNISHINGS PRIVATE LIMITED",
"KHURANA GASES PVT LTD",
"KHURANA JEWELLERS & SONS PRIVATE LIMITED",
"KHURANA OLEO CHEMICALS",
"KHURANA POLYMERS PRIVATE LIMITED",
"KHURANA PUBLISHING HOUSE PRIVATE LIMITED",
"KHURANA ROLLING MILLS PRIVATE LIMITED",
"KHURANA STEELS PRIVATE LIMITED",
"KHURANA TEXTILE MILLS PRIVATE LIMITED",
"KHURANABEK FOODS PRIVATE LIMITED",
"KHURINJI HOMES PRIVATE LIMITED",
"KHURJA CERAMIC PRIVATE LIMITED",
"KHURRAM CARPETS PRIVATE LIMITED",
"KHUS ONLINE SOLUTIONS PRIVATE LIMITED",
"KHUSABOO BEARING PRIVATE LIMITED",
"KHUSH HOUSING FINANCE PRIVATE LIMITED",
"KHUSHAL INFRATECH PRIVATE LIMITED",
"KHUSHAL SETHI HOUSING SOLUTIONS PRIVATE LIMITED",
"KHUSHALANI STORES PRIVATE LIMITED",
"KHUSHALI JEWELLS PRIVATE LIMITED",
"KHUSHAR TRADERS",
"KHUSHARAV BUILDERS PRIVATE LIMITED",
"KHUSHBOO CAPITAL FINANCE LIMITED",
"KHUSHBOO COOL PRODUCTS PRIVATE LIMITED",
"KHUSHBOO DIAMOND PRIVATE LIMITED",
"KHUSHBOO ENGRAVURES PRIVATE LIMITED",
"KHUSHBOO EXPORTS PRIVATE LIMITED",
"KHUSHBOO FEED MILLS PRIVATE LIMITED",
"KHUSHBOO FERTILISERS PRIVATE LIMITED",
"KHUSHBOO FOODS PRIVATE LIMITED",
"KHUSHBOO INDIA PRIVATE LIMITED",
"KHUSHBOO ISPAT PRIVATE LIMITED",
"KHUSHBOO MARBLES PVT LTD",
"KHUSHBOO PLYWOODS PRIVATE LIMITED",
"KHUSHBOO SCIENTIFIC PRIVATE LIMITED",
"KHUSHBOO TEXPRINT PRIVATE LIMITED",
"KHUSHBU AUTO FINANCE LIMITED",
"KHUSHBU AUTO PVT. LTD.",
"KHUSHBU DYE-CHEM PRIVATE LIMITED",
"KHUSHBU INDUSTRIES PRIVATE LIMITED",
"KHUSHBU POLYPRINTS PRIVATE LIMITED",
"KHUSHBU REALTIES PRIVATE LIMITED",
"KHUSHBU SERVICES PRIVATE LIMITED",
"KHUSHI ADVERTISING IDEAS PRIVATE LIMITED",
"KHUSHI ALLOYS LIMITED",
"KHUSHI BABY ASSOCIATION",
"KHUSHI BIOTECH PRIVATE LIMITED",
"KHUSHI BUILDERS & DEVELOPER PRIVATE LIMITED",
"KHUSHI BUILDING MATERIAL SUPPLIERS PRIVATE LIMITED",
"KHUSHI CLEANTECH PRIVATE LIMITED",
"KHUSHI COMMUNICATIONS PRIVATE LIMITED",
"KHUSHI COTSPIN PRIVATE LIMITED",
"KHUSHI CREATION PRIVATE LIMITED",
"KHUSHI DYECHEM PRIVATE LIMITED",
"KHUSHI ENTERPRISES - VAPI",
"KHUSHI FABRICS PRIVATE LIMITED",
"KHUSHI HOSPITAL",
"KHUSHI HOSPITAL A UNIT OF KHUSHI MEDICARE PRIVATE LIMITED",
"KHUSHI INFRASTRUCTURE PRIVATE LIMITED",
"KHUSHI LOGISPACE PRIVATE LIMITED",
"KHUSHI MULTIPACK SOLUTIONS LLP",
"KHUSHI REALCON PRIVATE LIMITED",
"KHUSHI SANSAAR DEVELOPERS PRIVATE LIMITED",
"KHUSHI TEXTILES PRIVATE LIMITED",
"KHUSHIL ENTERPRISE (OPC) PRIVATE LIMITED",
"KHUSHIRAM AGENCIES PRIVATE LIMITED",
"KHUSHKHERA STEELS PRIVATE LIMITED",
"KHUSHMEET OVERSEAS PRIVATE LIMITED",
"KHUSHNUMA TEXTURE & COATINGS PRIVATE LIMITED",
"KHUSHVEER LIFE SCIENCES PRIVATE LIMITED",
"KHVAFAR PROPERTY DEVELOPERS PRIVATE LIMITED",
"KHVATEC INDIA PRIVATE LIMITED",
"KHWAAHISH DIAMONDS PRIVATE LIMITED",
"KHWAB RESORTS PRIVATE LIMITED",
"KHWAHISH TECHNOLOGIES PRIVATE LIMITED",
"KHWAJA BABA COLD STORAGE PRIVATE LIMITED",
"KHWAJA BANDANAWAZ HASINA URDU GIRLS HIGHSCHOOL AUSA",
"KHWAJA EXPORTS PRIVATE LIMITED",
"KHY ELECTRONIC INDIA PRIVATE LIMITED",
"KHYATEE ELECTRONICS PRIVATE LIMITED",
"KHYATEH CONSULTING PRIVATE LIMITED",
"KHYATI ADVISORY SERVICES LIMITED",
"KHYATI CHEMICALS PRIVATE LIMITED",
"KHYATI HEALTHCARE PRIVATE LIMITED",
"KHYATI INDUSTRIES PRIVATE LIMITED",
"KHYATI ISPAT PRIVATE LIMITED",
"KHYATI MOTORS PRIVATE LIMITED",
"KHYATI NILUM ASSOCIATES PRIVATE LTD.",
"KHYATI PET INDUSTRIES PRIVATE LIMITED",
"KHYATI REALITIES LIMITED",
"KHYATI RIDES PRIVATE LIMITED",
"KHYATI SHIPPING SERVICES PRIVATE LIMITED",
"KHYATI WORLD EDUCARE PRIVATE LIMITED",
"KHYATISHIELD VENTURES PRIVATE LIMITED",
"KHYBER RESTAURANT PRIVATE LIMITED",
"KHYBER TRANSPORT PRIVATE LIMITED",
"KI AND NI HOSPITALITY PRIVATE LIMITED",
"KI MOBILITY SOLUTIONS PRIVATE LIMITED",
"KI OILFIELD CHEMICALS PRIVATE LIMITED",
"KI TRANSPOWER PRIVATE LIMITED",
"KIA CONTAINER LINES PRIVATE LIMITED",
"KIA INDIA PRIVATE LIMITED",
"KIA INTELLIGENT NETWORK GLOBAL HR SERVICES PRIVATE LIMITED",
"KIA MEDICO PRIVATE LIMITED",
"KIA TRANS MODEL PRIVATE LIMITED",
"KIAAN ENGINEERING PRIVATE LIMITED",
"KIAAN SOLUTIONS PRIVATE LIMITED",
"KIAAYO ENTERPRISES PRIVATE LIMITED",
"KIADO MULTIVENTURES PRIVATE LIMITED",
"KIAH ENERGIES PRIVATE LIMITED",
"KIAH LIFE STYLE PRIVATE LIMITED",
"KIAM INTL PRIVATE LIMITED",
"KIAN FALCON MANUFACTURING LLP",
"KIANNA EXIM PRIVATE LIMITED",
"KIANOTEC INDUSTRIES LIMITED",
"KIANSH INTERNATIONAL TECHNOLOGIES PRIVATE LIMITED",
"KIARA AUTOMOBILES PRIVATE LIMITED",
"KIARA JEWELLERY PRIVATE LIMITED",
"KIARA LIFESPACES PRIVATE LIMITED",
"KIARA MICROCREDIT PRIVATE LIMITED",
"KIARA MILLS PRIVATE LIMITED",
"KIARA MULTI-COMMODITIES PRIVATE LIMITED",
"KIARA PACKAGING INDUSTRIES PRIVATE LIMITED",
"KIARA REALTORS PRIVATE LIMITED",
"KIARA SLIDES (INDIA) PRIVATE LIMITED",
"KIARA TRAVELS AND TOURS PRIVATE LIMITED",
"KIASA INTERNATIONAL PRIVATE LIMITED",
"KIASK IMPEX PRIVATE LIMITED",
"KIBBCOM INDIA PRIVATE LIMITED",
"KIBS HOSIERY MILLS PRIVATE LIMITED",
"KIC FOOD PRODUCTS PRIVATE LIMITED",
"KIC UNIVASSIST INDIA PRIVATE LIMITED",
"KICH ARCHITECTURAL PRODUCTS PRIVATE LIMITED",
"KICH HARDWARE PRODUCTS PRIVATE LIMITED",
"KICHHA SUGAR COMPANY LIMITED",
"KICKASS ADVENTURES PRIVATE LIMITED¬†¬†¬†¬†¬†¬†¬†¬†¬†¬†¬†¬†¬†¬† ¬†¬†¬†¬†¬†¬†¬†¬†¬†¬†¬†¬†¬†¬†",
"KICKDRUM TECHNOLOGIES INDIA PRIVATE LIMITED",
"KICONEQUIP PRIVATE LIMITED",
"KICONS LIMITED",
"KICX EDUCATION GATEWAY PRIVATE LIMITED",
"KID APTIVITY TECHNOLOGIES PRIVATE LIMITED",
"KID 'N'KIDS GARMENTS PRIVATE LIMITED",
"KIDA RETAIL PRIVATE LIMITED",
"KIDDA MAL EXPORTS PRIVATE LIMITED",
"KIDDOS STATIONERY PRIVATE LIMITED",
"KIDDY PLAST LIMITED",
"KIDEES INFO PARK PETH",
"KIDER (INDIA) PRIVATE LIMITED",
"KIDIM INDIA PRIVATE LIMITED",
"KIDIN INDUSTRIES PRIVATE LIMITED",
"KIDITUP NS PRIVATE LIMITED",
"KIDNEY ASSOCIATES PRIVATE LIMITED",
"KIDNEY CARE FLUIDS PRIVATE LIMITED",
"KIDNEY CARE LAB PRIVATE LIMITED",
"KIDNEY CENTRE HOSPITAL",
"KIDNEY HOSPITAL",
"KIDNEY HOSPITAL AND LIFELINE MEDICAL INSTITUTIONS",
"KIDO ENTERPRISES PRIVATE LIMITED",
"KIDOMATE RETAIL INDIA PRIVATE LIMITED",
"KIDS CLINIC INDIA LIMITED",
"KIDS CLINIC INDIA PRIVATE LIMITED",
"KIDS CLUB MATRICULATION HIGHER SECONDARY SCHOOL",
"KIDS CORNER JHS ANTAULI",
"KIDS DELHI PUBLIC SCHOOL",
"KIDS GURUKUL INTERNATIONAL SCHOOL",
"KIDS INTERNATIONAL PRIVATE LIMITED",
"KIDS2DAY INTERNATIONAL PUBLISHERS PRIVATE LIMITED",
"KIDSS TALK PRIVATE LIMITED",
"KIDSSTOPPRESS MEDIA PRIVATE LIMITED",
"KIDSTOUCH LEARN AND GROW PRIVATE LIMITED",
"KIDSWEAR FABRICATORS PRIVATE LIMITED",
"KIDUJA INDIA LIMITED",
"KIDVENTO EDUCATION AND RESEARCH PRIVATE LIMITED",
"KIDWAI MEMORIAL GIRLS INTER COLLEGE",
"KIDWAI MEMORIAL INSTITUTE OF ONCOLOGY",
"KIDYS FOOD PRODUCTS PRIVATE LIMITED",
"KIDZ DRIVE IN PRIVATE LIMITED",
"KIDZEE PRE-SCHOOL & DAY CARE",
"KIDZLET PLAY STRUCTURES PRIVATE LIMITED",
"KIE ENGINEERING PRIVATE LIMITED",
"KIE SQUARE CONSULTING PRIVATE LIMITED",
"KIEARRA TILES PRIVATE LIMITED",
"KIERA CONSTRUCTION & DEVELOPERS PRIVATE LIMITED",
"KIET GROUP OF INSTITUTIONS",
"KIET TECHNOLOGIES PRIVATE LIMITED",
"KIFS HOUSING FINANCE LIMITED",
"KIFS MOTORS PRIVATE LIMITED",
"KIFS TRADE CAPITAL PRIVATE LIMITED",
"KIG KRAFT TECH CONTAINERS PRIVATE LIMITED",
"KIGG SYSTEMS INDIA PRIVATE LIMITED",
"KIGOTEK AUTOMOTRIZ PRIVATE LIMITED",
"KIHAMA SPORTS PRIVATE LIMITED",
"KIIT HOSPITALITY PRIVATE LIMITED",
"KIIT TECHNOLOGY BUSINESS INCUBATOR",
"KIIT UNIVERSITY",
"KIIT WORLD SCHOOL",
"KIJALK INFRASTRUCTURE PRIVATE LIMITED",
"KIJEKA ENGINEERS PRIVATE LIMITED",
"KIK PLASTICS PRIVATE LIMITED",
"KIKAI SERVICES PRIVATE LIMITED",
"KIKAI TECHNOLOGIES PRIVATE LIMITED",
"KIKAN INTERNATIONAL PRIVATE LIMITED",
"KIKANI ENTERPRISES PRIVATE LIMITED",
"KIKANI EXPORTS PRIVATE LIMITED",
"KIKANI GLOBAL ACADEMY",
"KIKANI INTERNATIONAL PRIVATE LIMITED",
"KIKAR LODGE NATURE RESORT PRIVATE LIMITED",
"KIKKOMAN INDIA PRIVATE LIMITED",
"KIKO COSMETICS RETAIL PRIVATE LIMITED",
"KIKUWA INDIA PRIVATE LIMITED",
"KILA MARKETING PRIVATE LIMITED",
"KILAI BUILDERS PRIVATE LIMITED",
"KILARU NATURALS PRIVATE LIMITED",
"KILBAN FOODS INDIA PRIVATE LTD",
"KILBIL CHILDREN HOSPITAL",
"KILBURN ENGINEERING LTD",
"KILBURN MANAGEMENT SERVICES PVT.LTD.",
"KILBURN OFFICE AUTOMATION LIMITED",
"KILHOR METALS PRIVATE LIMITED",
"KILITCH DRUGS INDIA LIMITED.",
"KILITCH HEALTHCARE INDIA LIMITED",
"KILKOTAGIRI AND THIRUMBADI PLANTATIONS LIMITED",
"KILLICK AGENCIES AND MARKETING LIMITED",
"KILLICK GUARD SPECIALITY PRODUCTS LIMITED",
"KILLICK INFOTECH LIMITED",
"KILLICK SHIPPING SERVICES LIMITED",
"KILLIMANJARO COMMODITIES (INDIA) PRIVATE LIMITED",
"KILOFARMS PRIVATE LIMITED",
"KILOL FABRICS PRIVATE LIMITED",
"KILPAUK MEDICAL COLLEGE",
"KILPAUK MEDICAL HOSPITAL",
"KIM CHEMICALS LIMITED",
"KIM COOLS PROJECTS INDIA PRIVATE LIMITED",
"KIM ENG SECURITIES INDIA PRIVATE LIMITED",
"KIM FUTURE VISION SERVICES LIMITED",
"KIM INDIA EXIM PRIVATE LIMITED",
"KIM KRAFTS PRIVATE LIMITED",
"KIM LABORATORIES PRIVATE LIMITED",
"KIMAAN EXPORTS PRIVATE LIMITED",
"KIMATRAM AND SONS PRIVATE LIMITED",
"KIMATSU INDIA PRIVATE LIMITED",
"KIMAYA AUTOMATION PRIVATE LIMITED",
"KIMAYA ENGINEERING PRIVATE LIMITED",
"KIMAYA IMPEX PRIVATE LIMITED",
"KIMAYA MEDICAL SOLUTIONS PRIVATE LIMITED",
"AVERNA TEST (INDIA) PRIVATE LIMITED",
"KIMBERLEY APPAREL PRIVATE LIMITED",
"KIMBERLEY ENGINEERS P LTD",
"KIMBERLITE CHEMICALS (INDIA) PRIVATE LIMITED",
"KIMBERLY BUILDHOME PRIVATE LIMITED",
"KIMBERLY-CLARK HYGIENE PRODUCTS PRIVATE LIMITED",
"KIMBERLY-CLARK INDIA PRIVATE LIMITED",
"KIMIA BIOSCIENCES LIMITED",
"KIMIA BIOSCIENCES PRIVATE LIMITED",
"KIMIRICA HUNTER INTERNATIONAL LLP",
"KIMITSU STEEL PRIVATE LIMITED",
"KIMIYA ENGINEERS PRIVATE LIMITED",
"KIMMANE GOLF VILLAGE PRIVATE LIMITED",
"KIMO CLOTHING DESIGN CONCEPT PRIVATE LIMITED",
"KIMO ELECTRONIC PRIVATE LIMITED",
"KIMO ENTERPRISES PRIVATE LIMITED",
"KIMORA FASHION PRIVATE LIMITED",
"KIMPEX FLOW PRIVATE LIMITED",
"KIMPLAS PIPING SYSTEMS PRIVATE LIMITED",
"KIMS AL SHIFA HEALTHCARE PRIVATE LIMITED",
"KIMS BELLEROSE INSTITUTE OF MEDICAL SCIENCES PRIVATE LIMITED",
"KIMS HEALTH CARE MANAGEMENT LIMITED",
"KIMS HOSPITAL AND RESEARCH CENTER",
"KIMS HOSPITAL ENTERPRISES PRIVATE LIMITED",
"KIMS HOSPITAL KURNOOL PRIVATE LIMITED",
"KIMS HOSPITALS",
"KIMS ICON HOSPITAL",
"KIMS IMPEX PRIVATE LIMITED",
"KIMS KINGSWAY HOSPITALS",
"KIMS KOLLAM MULTI SPECIALITY HOSPITAL INDIA PRIVATE LIMITED",
"KIMS SUNSHINE HOSPITAL",
"KIMS SUPER SPECIALITY HOSPITAL PRIVATE LIMITED",
"KIMURO SOLUTIONS (OPC) PRIVATE LIMITED",
"KIMYA BIOTECH PRIVATE LIMITED",
"KIN LINES AND LOGISTICS PRIVATE LIMITED",
"KIN RAILWAY EQUIPMENT PRIVATE LIMITED",
"KINA ENGINEERS & CONTRACTORS PRIVATE LIMITED",
"KINAEGIS GLOBAL ENGINEERS PRIVATE LIMITED",
"KINAL GLOBAL CARE PRIVATE LIMITED",
"KINALUR VOX FOOTWEAR PRIVATE LIMITED",
"KINAPSE INDIA SCIENTIFIC SERVICES PRIVATE LIMITED",
"KINARA AGENCIES PRIVATE LIMITED",
"KINARA AI PRIVATE LIMITED",
"KINARA CAPITAL PRIVATE LIMITED",
"KINARA GROUP OF HOTELS PRIVATE LIMITED",
"KINARA POWER SYSTEMS AND PROJECTS PRIVATE LIMITED",
"KINASA PRIVATE LIMITED",
"KINATTUKARAYIL VENTURES PRIVATE LIMITED",
"KINAXIS INDIA PRIVATE LIMITED",
"KINC MINERAL TECHNOLOGIES PRIVATE LIMITED",
"KINCSEM HOSPITALITY PRIVATE LIMITED",
"KIND SPECIAL STEELS (INDIA) PRIVATE LIMITED",
"KINDCARE DRUGS PRIVATE LIMITED",
"KINDER MORGAN INC.",
"KINDER WOMENS HOSPITAL AND FERTILITY CENTRE PRIVATE LIMITED",
"KINDLE ENGINEERING AND CONSTRUCTION PRIVATE LIMITED",
"KINDLEBIT SOLUTIONS PRIVATE LIMITED",
"KINDORAMA HEALTHCARE PRIVATE LIMITED",
"KINDRED HEALTHCARE INC.",
"KINECO KAMAN COMPOSITES- INDIA PRIVATE LIMITED",
"KINECO LIMITED",
"KINEDEX HEALTHCARE PRIVATE LIMITED",
"KINEGIC PHARMACEUTICALS PRIVATE LIMITED",
"KINELECTRO LINES INDIA PRIVATE LIMITED",
"KINEMACH ENGINEERING AND MACHINES PRIVATE LIMITED",
"KINEMATIC FOODTECH PRIVATE LIMITED",
"KINEMATICS MACHINES PRIVATE LIMITED",
"KINERK DIRECT MARKETING SOLUTIONS PRIVATE LIMITED",
"KINESCO POWER AND UTILITIES PRIVATE LIMITED",
"KINESIS PHARMACEUTICALS PRIVATE LIMITED",
"KINESSO INDIA PRIVATE LIMITED",
"KINETIC ADVERTISING INDIA PRIVATE LIMITED",
"KINETIC COMMUNICATIONS LIMITED",
"KINETIC ELECTRIC MOTOR COMPANY PRIVATE LIMITED",
"KINETIC ELECTRICALS PVT LTD",
"KINETIC ENGINEERING LTD",
"KINETIC FORGE PRIVATE LIMITED",
"KINETIC GREEN ENERGY AND POWER SOLUTIONS LIMITED",
"KINETIC HYUNDAI ELEVATOR AND MOVEMENT TECHNOLOGIES LIMITED",
"KINETIC INDUSTRIES PRIVATE LIMITED",
"KINETIC MARKETING & SERVICES LIMITED",
"KINETIC MEDICAMENTS INDIA PRIVATE LIMITED",
"KINETIC PROCESS TECHNOLOGY INDIA PRIVATE LIMITED",
"KINETIC ROLLS PRIVATE LIMITED",
"KINETICS MARINE CONTAINER SERVICES PRIVATE LIMITED",
"KINETIGRA MEDIAS & PRODUCTIONS PRIVATE LIMITED",
"KINETIQTV SOFTWARE SERVICES PRIVATE LIMITED",
"KINETIX TRADING SOLUTION INDIA P LIMITED",
"KINEXIN CONVENTION MANAGEMENT PRIVATE LIMITED",
"KINFRA EXPORT PROMOTION INDUSTRIAL PARKS LTD",
"KINFRA INTERNATIONAL APPAREL PARKS LIMITED",
"KING BAKERS PRIVATE LIMITED",
"KING CANYON SEZ PRIVATE LIMITED",
"KING CHAINS PRIVATE LIMITED",
"KING COMMERCIAL PRIVATE LIMITED",
"KING DIGITAL PRIVATE LIMITED",
"KING EDWARD MEMORIAL HOSPITAL",
"KING EXIM PRIVATE LIMITED",
"KING FACILITY SERVICES PRIVATE LIMITED",
"KING FISH PRODUCTS PRIVATE LIMITED",
"KING FREIGHT MARITIME PRIVATE LIMITED",
"KING GEORGE HOSPITAL",
"KING GEORGE'S MEDICAL UNVERSITY",
"KING JEWELLERS PRIVATE LIMITED",
"KING LIFESTYLE VACATION PRIVATE LIMITED",
"KING METALS & ALLOYS LIMITED",
"KING OF CARDS INDIA PRIVATE LIMITED",
"KING PARK RESORTS PRIVATE LIMITED",
"KING PERSONNEL CONSULTANCY PRIVATE LIMITED",
"KING POLYPLAST PRIVATE LIMITED",
"KING POWER TOOLS & SPARES PRIVATE LIMITED",
"KING REFINERIES PRIVATE LIMITED",
"KING REMEDIES PRIVATE LIMITED",
"KING RICE MILLS PRIVATE LIMITED",
"KING ROSE SERVICES PRIVATE LIMITED",
"KING SEAL COMPONENTS PRIVATE LIMITED",
"KING SECURITY GUARDS SERVICES PRIVATE LIMITED",
"KING SHINE EXPORTS PRIVATE LIMITED",
"KING SHIPPING SERVICES PRIVATE LIMITED",
"KING STAR FREIGHT PRIVATE LIMITED",
"KING TUBE INDIA PRIVATE LIMITED",
"KING YARNS PRIVATE LIMITED",
"KING`S IDEAL SCHOOL",
"KINGAR SIGNS PRIVATE LIMITED",
"KINGBIRD REALTY PRIVATE LIMITED",
"KINGCRAFT RESTAURANTS PRIVATE LIMITED",
"KINGDAO AGROCHEM (INDIA) PRIVATE LIMITED",
"KINGDOM ESTATES PRIVATE LIMITED",
"KINGER AGRICO PRIVATE LIMITED",
"KINGER PLAST (INDIA) PRIVATE LIMITED",
"KINGER TRADE LINK PRIVATE LIMITED",
"KINGFA SCIENCE & TECHNOLOGY INDIA LIMITED",
"KINGFISH CONSULTANTS PRIVATE LIMITED",
"KINGFISHER PRODUCTS PRIVATE LIMITED",
"KINGKAVERY GASES PRIVATE LIMITED",
"KINGLAB INSTRUMENTS PRIVATE LIMITED",
"KINGLIFE INFRA PRIVATE LIMITED",
"KINGLIKE RETAIL VENTURES PRIVATE LIMITED",
"KINGLY CLOTHING PRIVATE LIMITED",
"KINGMAKER DEVELOPERS PRIVATE LIMITED",
"KINGMAKER INDUSTRIES PRIVATE LIMITED",
"KINGMAN MARINE PRIVATE LIMITED",
"KINGS AND KNIGHTS HERITAGE HOTELS PRIVATE LIMITED",
"KINGS BROADBAND PRIVATE LIMITED",
"KINGS CLIFF HOTELS PRIVATE LIMITED",
"KING'S COLLEGE INDIA",
"KINGS CONVENTION CENTRE PRIVATE LIMITED",
"KINGS DEHYDRATED FOODS PRIVATE. LIMITED.",
"KINGS DISTRIBUTORS PRIVATE LIMITED",
"KINGS EMPIRE HEIGHTS PRIVATE LIMITED",
"KINGS ENGINEERING COLLEGE",
"KINGS ESSENTIALCO LIMITED",
"KINGS EXPOMEDIA LIMITED",
"KINGS GLOBAL BIOTECH LIMITED",
"KINGS HOLIDAY & RESORTS PVT LTD",
"KINGS IMPEX PRIVATE. LIMITED.",
"KINGS IMPEX PVT LTD",
"KINGS INFOMATICA SOLUTIONS PRIVATE LIMITED",
"KINGS INFRA VENTURES LIMITED",
"KINGS INTERNATIONAL LIMITED",
"KINGS INTERNATIONAL MEDICAL ACADEMY PRIVATE LIMITED",
"KINGS LUMBER PRIVATE LIMITED",
"KING'S MOTORS PRIVATE LIMITED",
"KINGS OCEAN MARINE SERVICES PRIVATE LIMITED",
"KINGS PREMIUM MARKETING PRIVATE LIMITED",
"KINGS TOWNSHIP PRIVATE LIMITED",
"KINGSDELL HOSPITALITY AND SERVICES PRIVATE LIMITED",
"KINGSIGNAL TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"KINGSLEY GATE PARTNERS PRIVATE LIMITED",
"KINGSLEY INDUSTRIES LIMITED",
"KINGSLY INSTRUMENTATION AND COMMUNICATION PVT LTD",
"KINGSMARQUE PACKAGING PRIVATE LIMITED",
"KINGSMEN FAIRTECH INTERIORS PRIVATE LIMITED",
"KINGSPAN JINDAL PRIVATE LIMITED",
"KINGSRADIO EXIM PRIVATE LIMITED",
"KINGSTAY REAL ESTATE PRIVATE LIMITED",
"KINGSTON AQUA INDUSTRIES PRIVATE LIMITED.",
"KINGSTON AUTO BODY WORKS PRIVATE LIMITED",
"KINGSTON IMPERIAL INSTITUTE DEHRADUN",
"KINGSTON JEWELLERY PRIVATE LIMITED",
"KINGSTON MULTI PRODUCTS INDIA PRIVATE LIMITED",
"KINGSTON OILFIELD SERVICES PVT. LTD",
"KINGSTON PROPERTY SERVICES PRIVATE LIMITED",
"KINGSTON TECHNOLOGY FAR EAST CORP.",
"KINGSTON VENTURES INDIA PRIVATE LIMITED",
"KINGSTON VINCOM PRIVATE LIMITED",
"KINGSUN BUILDTECH PRIVATE LIMITED",
"KINGSWAY HEALTHCARE PRIVATE LIMITED",
"KINGSWAY INSTITUTE OF HEALTH SCIENCES PRIVATE LIMITED",
"KINGSWOOD SUPPLIERS PRIVATE. LIMITED.",
"KINGTECH BIO CHEM PRIVATE LIMITED",
"KINI HIGHSCHOOL",
"KINITOUS LLP",
"KINJAL BUSINESS SOLUTIONS PRIVATE LIMITED",
"KINJAL CHEMICALS PRIVATE LIMITED",
"KINJAL CIVILCON LLP",
"KINJAL CONSTRUCTION",
"KINJAL CONSTRUCTION CO.",
"KINJAL COTTON PRIVATE LIMITED",
"KINJAL ELECTRICALS PVT LTD",
"KINJAL GEMS PRIVATE LIMITED",
"KINJAL ORGANICS PRIVATE LIMITED",
"KINJAL SHRI TRADE (INDORE) PRIVATE LIMITED",
"KINJIN FOOD PRIVATE LIMITED",
"KINLONG HARDWARE INDIA PRIVATE LIMITED",
"KINNECT MEDIA PRIVATE LIMITED",
"KINNOVATE VENTURES PRIVATE LIMITED",
"KINNY GARMENTS PRIVATE LIMITED",
"KINOBEO SOFTWARE PRIVATE LIMITED",
"KINOL LUBES PRIVATE LIMITED",
"KINOMERA BIOSCIENCES PRIVATE LIMITED",
"KINS CARE & RESEARCH FOUNDATION PRIVATE LIMITED",
"KINSAP MEDISCIENCES PRIVATE LIMITED",
"KINSEY KNITT INTERNATIONAL",
"KINSFOLK TECHNOLOGY PRIVATE LIMITED",
"KINSHIP BIZ PRIVATE LIMITED",
"KIN-SHIP SERVICES INDIA PRIVATE LIMITED",
"KINSHUK CONTROLS PRIVATE LIMITED",
"KINSHUK OVERSEAS PRIVATE LIMITED",
"KINSMAK OFFSHORE PRIVATE LIMITED",
"KINTEC GLOBAL LIMITED",
"KINTECH GLOBAL SERVICES PRIVATE LIMITED",
"KINTECH SYNERGY PRIVATE LIMITED",
"KINTECHNO INFORMATICS PRIVATE LIMITED",
"KINTETSU WORLD EXPRESS INDIA PRIVATE LIMITED",
"KINTSUGI INNOVATION LABS PRIVATE LIMITED",
"KINU BABA GEMS INDIA PRIVATE LIMITED",
"KINU BABA JEWELLERY ( INDIA) PRIVATE LIMITED",
"KINZA DEVELOPERS AND TRADERS PRIVATE LIMITED",
"KINZA GRANITES AND MARBLES PRIVATE LIMITED",
"KINZIN ASSIST PRIVATE LIMITED",
"KIOCL LIMITED",
"KION INDIA PRIVATE LIMITED",
"KIOSENCE HEALTH CARE PRIVATE LIMITED",
"KIOSK PROPERTIES PRIVATE LIMITED",
"KIOT FOODS PRIVATE LIMITED",
"KIOT INNOVATIONS PRIVATE LIMITED",
"KIOZEN TECHNOLOGIES PRIVATE LIMITED",
"KIP CHEMICALS PRIVATE LIMITED",
"KIPC INDIA PRIVATE LIMITED",
"KIPI.BI INDIA PRIVATE LIMITED",
"KIPLING & COMPANY ENTERPRISES PRIVATE LIMITED",
"KIPO CHEM INDIA (OPC) PRIVATE LIMITED",
"KIPPIS MEDIA PRIVATE LIMITED",
"KIPPS CONFECTIONERS PRIVATE LIMITED",
"KIPPS SALES PRIVATE LIMITED",
"KIPRA ELECTRICALS PRIVATE LIMITED",
"KIPRO TECHNOLOGIES PRIVATE LIMITED",
"KIPSC AR-AV ELECTRONICS PRIVATE LIMITED",
"KIRA EQUIPMENTS PRIVATE LIMITED",
"KIRA9 EDUMEDIA PRIVATE LIMITED",
"KIRAN AGENCIES PRIVATE LIMITED",
"KIRAN AUTO COMPONENTS",
"KIRAN AUTO WHEELS PRIVATE LIMITED",
"KIRAN AUTOMOBILES PRIVATE LIMITED",
"KIRAN AUTOMOTIVE PRIVATE LIMITED",
"KIRAN BUSINESS FORMS PRINT PRIVATE LIMITED",
"KIRAN CABLES PRIVATE LIMITED",
"KIRAN CARE AND CURE PRIVATE LIMITED",
"KIRAN CARGO PRIVATE LIMITED",
"KIRAN CONSTRUCTION AND INFRASTRUCTURE PRIVATE LIMITED",
"KIRAN CONSULTANTS PRIVATE LIMITED",
"KIRAN CREDITS PRIVATE LIMITED",
"KIRAN DATA FORMS PVT LTD",
"KIRAN DESIGNERS PRIVATE LIMITED",
"KIRAN DRUG HOUSE PRIVATE LIMITED",
"KIRAN ELASTOMERS PRIVATE LIMITED",
"KIRAN ELECTRIC COMPANY (RAJKOT) PVT LTD",
"KIRAN EXIMTRADE PRIVATE LIMITED",
"KIRAN FASHION",
"KIRAN FASHIONS PRIVATE LIMITED",
"KIRAN FINE JEWELLERS PRIVATE LIMITED",
"KIRAN FLOORINGS PRIVATE LIMITED",
"KIRAN FOREIGN TRADE PRIVATE LIMITED",
"KIRAN GEMS PRIVATE LIMITED",
"KIRAN GLOBAL GEOCEMENTS LIMITED",
"KIRAN INDUSTRIES PRIVATE LIMITED",
"KIRAN INFERTILITY CENTRE (BENGALURU) PRIVATE LIMITED",
"KIRAN INFERTILITY CENTRE (GURGAON) PRIVATE LIMITED",
"KIRAN INFRA ENGINEERS LIMITED",
"KIRAN INFRA ISPAT LIMITED",
"KIRAN INSTITUTE OF CAREER EXCELLENCE PRIVATE LIMITED",
"KIRAN IRON AND STEEL PRIVATE LIMITED",
"KIRAN LIFE SCIENCES PRIVATE LIMITED",
"KIRAN MACHINE TOOLS PRIVATE LIMITED",
"KIRAN MARBLES PRIVATE LIMITED",
"KIRAN MOTOCORP PRIVATE LIMITED",
"KIRAN MOTORS LIMITED",
"KIRAN MULTI SUPER SPECIALTY HOSPITAL AND RESEARCH CENTER",
"KIRAN NADAR MUSEUM OF ART",
"KIRAN ORNAMENT (I) PRIVATE LIMITED",
"KIRAN PHONES PRIVATE LIMITED",
"KIRAN POLYFAB PRIVATE LIMITED",
"KIRAN POULTRY AND BREEDING FARM PRIVATE LIMITED",
"KIRAN POWER RECTIFICATION SERVICES PRIVATE LIMITED",
"KIRAN PRINT PACK LIMITED",
"KIRAN PROBUILD PRIVATE LIMITED",
"KIRAN PROTECTION SERVICES PRIVATE LIMITED",
"KIRAN RENEWABLES PRIVATE LIMITED",
"KIRAN RETAIL PRIVATE LIMITED",
"KIRAN ROADWAYS PRIVATE LIMITED",
"KIRAN SOLAR ONE PRIVATE LIMITED",
"KIRAN SURYAPRAKASH INDIA PRIVATE LIMITED",
"KIRAN TECHNOLOGY PRIVATE LIMITED",
"KIRAN TEXPRO PRIVATE LIMITED",
"KIRAN TRANSPORT PVT. LTD.",
"KIRAN VEHICLE AGENCY PRIVATE LIMITED",
"KIRAN VYAPAR LIMITED",
"KIRANA KING RETAIL NETWORK PRIVATE LIMITED",
"KIRANMANI INVESTMENT AND FINANCE PRIVATE LIMITED (PART IX)",
"KIRANMAYE SUPER SPECIALITY HOSPITAL",
"KIRANOTICS INDIA PRIVATE LIMITED",
"KIRANSHREE HOTELS PRIVATE LIMITED",
"KIRANUM PRIVATE LIMITED",
"KIRANYA JEWELS PRIVATE LIMITED",
"KIRAT PLASTICS PRIVATE LIMITED",
"KIRATPUR INDUSTRIES PRIVATE LIMITED",
"KIRATPUR NER CHOWK EXPRESSWAY LIMITED",
"KIRBY BUILDING SYSTEMS & STRUCTURES INDIA PRIVATE LIMITED",
"KIRBY BUILDING SYSTEMS INDIA PRIVATE LIMITED",
"KIRDAK AUTOCOM PRIVATE LIMITED",
"KIREETI SOFT TECHNOLOGIES LIMITED",
"KIRI AND COMPANY LOGISTICS PRIVATE LIMITED",
"KIRI INDUSTRIES LIMITED",
"KIRIN TECHNOLOGY PRIVATE LIMITED",
"KIRISH WEAVINGS PRIVATE LIMITED",
"KIRISHANTHINI CONSTRUCTIONS PRIVATE LIMITED",
"KIRLOSKAR BATTERIES PRIVATE LIMITED",
"KIRLOSKAR BROTHERS LIMITED",
"KIRLOSKAR CHILLERS PRIVATE LIMITED",
"KIRLOSKAR CORROCOAT PRIVATE LIMITED",
"KIRLOSKAR EBARA PUMPS LIMITED",
"KIRLOSKAR ELECTRIC COMPANY LIMITED",
"KIRLOSKAR FERROUS INDUSTRIES LIMITED",
"KIRLOSKAR INDUSTRIES LIMITED",
"KIRLOSKAR INSTITUTE OF ADVANCED MANAGEMENT STUDIES",
"KIRLOSKAR MANAGEMENT SERVICES PRIVATE LIMITED",
"KIRLOSKAR OIL ENGINES LIMITED",
"KIRLOSKAR PNEUMATIC COMPANY LIMITED",
"KIRLOSKAR PROPRIETARY LIMITED",
"KIRLOSKAR SOLAR TECHNOLOGIES PRIVATE LIMITED",
"KIRLOSKAR SYSTEMS LIMITED",
"KIRLOSKAR SYSTEMS PRIVATE LIMITED",
"KIRLOSKAR TECHNOLOGIES PRIVATE LIMITED",
"KIRLOSKAR TOYOTA TEXTILE MACHINERY PRIVA TE LIMITED",
"KIRO REFRIGERANTS PRIVATE LIMITED",
"KIRON HYDRAULIC NEEDS PRIVATE LIMITED",
"KIRON SERVEPRENEURS PRIVATE LIMITED",
"KIRORI MAL PREM CHAND PRIVATE LIMITED",
"KIRORIMAL KASHIRAM MARKETING AND AGENCIES PRIVATE LIMITED",
"KIRORIMAL SEWA RAM PRIVATE LIMITED",
"KIROS HOSPITALITY SOLUTIONS PRIVATE LIMITED",
"KIROS TEXTILES PRIVATE LIMITED",
"KIRPA KALYAN ENTERPRISES PRIVATE LIMITED",
"KIRPA RAM DAIRY PRIVATE LIMITED",
"KIRPAL POLYMERS PRIVATE LIMITED",
"KIRPALANEY & ASSOCIATES (ENGINEERS) PRIVATE LIMITED",
"KIRPALANEY & ASSOCIATES ENGINEERS PRIVATE LIMITED",
"KIRPEKAR ENGINEERINGS PRIVATE LIMITED",
"KIRTAN MARKETING PVT LTD",
"KIRTANE & PANDIT LLP",
"KIRTANI FREIGHT CARRIER PRIVATE LIMITED",
"KIRTANLAL INTERNATIONAL DMCC",
"KIRTANLAL STEEL PRIVATE LIMITED",
"KIR-TEX PVT LTD",
"KIRTI AGROMILL PRIVATE LIMITED",
"KIRTI AGROTECH LIMITED",
"KIRTI AGROVET LIMITED",
"KIRTI BEARINGS PRIVATE LIMITED",
"KIRTI CONSTECH PRIVATE LIMITED",
"KIRTI COTTEX PRIVATE LIMITED",
"KIRTI DAL MILLS LIMITED",
"KIRTI DEVELOPERS AND CONSTRUCTIONS LIMITED",
"KIRTI ENTERPRISES PRIVATE LIMITED",
"KIRTI FILTRATION AND AUTOMATION PRIVATE LIMITED",
"KIRTI FOODS LIMITED",
"KIRTI FOODS PVT LTD",
"KIRTI GEMS PRIVATE LIMITED",
"KIRTI GOLD LIMITED",
"KIRTI HEALTHCARE PRIVATE LIMITED",
"KIRTI INFRASTRUCTURES LIMITED",
"KIRTI INVESTMENTS LIMITED",
"KIRTI M DOONGURSEE COLLEGE DADAR",
"KIRTI MASALA PROCESS PRIVATE LIMITED",
"KIRTI PLASTIC INDUSTRIES PRIVATE LIMITED",
"KIRTI POLYPACK PRIVATE LIMITED",
"KIRTI PRESSINGS PRIVATE LIMITED",
"KIRTI R SHAH SHARES AND STOCK BROKERS PRIVATE LIMITED",
"KIRTI SPARDHA PARIKSHA AND SPOKEN ENGLISH CLASES",
"KIRTI STAMPINGS PRIVATE LIMITED",
"KIRTI STRUCTURAL CONSULTANTS PRIVATE LIMITED",
"KIRTI TEXTILES PRIVATE LIMITED",
"KIRTI TRADING CORPORATION PRIVATE LIMITED",
"KIRTIKUNJ AUTOMOBILES PRIVATE LIMITED",
"KIRTIKUNJ JEWELLERS PRIVATE LIMITED",
"KIRTILAL KALIDAS JEWELLERS PRIVATE LIMITED",
"KIRTILAL M. SHAH",
"KIRTIMAAN CONSTRUCTIONS PRIVATE LIMITED",
"KIRTIMAN AGROGENETICS LIMITED",
"KIRTIMAN TECHNOLOGIES PRIVATE LIMITED",
"KIRTIPRADA FASHIONS PRIVATE LIMITED",
"KIRTIRAJ FOOD MACHINES PRIVATE LIMITED",
"KIRTIRAJ SNACKS PRIVATE LIMITED",
"KIRTIVARDHAN FINVEST SERVICES LIMITED",
"KIRUSA SOFTWARE PRIVATE LIMITED",
"KIRUTHIGESWAR INDUSTRIES PRIVATE LIMITED",
"KIRVSY HEALTHCARE PRIVATE LIMITED",
"KIRVSY PHARMACEUTICALS PRIVATE LIMITED",
"KIS MANAGEMENT PRIVATE LIMITED",
"KISAAN DIE TECH PRIVATE LIMITED",
"KISAAN PRIME ESTATE PRIVATE LIMITED",
"KISAAN STEELS PRIVATE LIMITED",
"KISAANGO AGROSOL PRIVATE LIMITED",
"KISAANSATHI E-SEVA PRIVATE LIMITED",
"KISALAYA HERBALS LIMITED",
"KISALAYA PUBLICATIONS PRIVATE LIMITED",
"KISAN AGRO AND POULTRY FARMS PRIVATE LIMITED",
"KISAN AGRO PIPES AND FITTINGS PRIVATE LIMITED",
"KISAN AGRONET INDUSTRIES",
"KISAN AUTOMOBILES",
"KISAN DNET INDIA PRIVATE LIMITED",
"KISAN EXCEL PRIVATE LIMITED",
"KISAN FILTERS PRIVATE LIMITED",
"KISAN FODDER MILLS PRIVATE LIMITED",
"KISAN FORUM PRIVATE LIMITED",
"KISAN GAGAN TRADERS",
"KISAN GINNING AND PRESSING",
"KISAN INTER COLLEGE",
"KISAN IRRIGATIONS AND INFRASTRUCTURE LIMITED",
"KISAN KIRTI AGRO PRIVATE LIMITED",
"KISAN MADHYAMIK VIDYALAYA LONI GROUP",
"KISAN MINERAL PRIVATE LIMITED",
"KISAN OLEOCHEM AND DERIVATIVES PRIVATE LIMITED",
"KISAN ORGANICS PRIVATE LIMITED",
"KISAN PG COLLEGE HAPUR",
"KISAN PHOSPHATES PRIVATE LIMITED",
"KISAN PIPES AND PROFILES PVT LTD",
"KISAN PRESERVATIONS PRIVATE LIMITED",
"KISAN PROJECTS PRIVATE LIMITED",
"KISAN PROTEINS PRIVATE LIMITED",
"KISAN PURV MADHYAMIK¬†VIDYALAYA¬†KARTHALA IGLAS",
"KISAN SEWA SAHAKARI SAMITI LIMITED",
"KISAN SHAKTI KRUSHI UDYOG PRIVATE LIMITED",
"KISAN TRACTORS PRIVATE LIMITED.",
"KISAN VIDHYA MANDIR INTER COLLEGE",
"KISAN VIDYALAYA MOHIDE",
"KISAN VIDYALAYA SHINDHKHEDA",
"KISANKONNECT FARMER PRODUCER COMPANY LIMITED",
"KISANKONNECT SAFE FOOD PRIVATE LIMITED",
"KISANKRAFT LIMITED",
"KISANMITRA COLD STORAGE PRIVATE LIMITED",
"KISANMITRA WAREHOUSING PRIVATE LIMITED",
"KISANSANJEEVANI KRUSHI UDYOG PRIVATE LIMITED",
"KISANSHAKTI FERTILIZERS AND PESTICIDES PRIVATE LIMITED",
"KISANTECH AUTO ENGINEERS PRIVATE LIMITED",
"KISCO CASTINGS (INDIA) LIMITED",
"KISCO CASTINGS PRIVATE LIMITED",
"KISCO INDIA PRIVATE LIMITED",
"KISCO TRADING INDIA PRIVATE LIMITED",
"KISETSU SAISON FINANCE (INDIA) PRIVATE LIMITED",
"KISH ENGINEERING P LTD.",
"KISH EXPORTS PRIVATE LIMITED",
"KISH HANDICRAFTS PRIVATE LIMITED",
"KISHA PRIVATE LIMITED",
"KISHA TELELINKS PRIVATE LIMITED",
"KISHAN AGRO PRODUCT",
"KISHAN AUTOPARTS PRIVATE LIMITED",
"KISHAN ENTERPRISES PRIVATE LIMITED",
"KISHAN FORGE PRIVATE LIMITED",
"KISHAN INFRASTRUCTURE PRIVATE LIMITED",
"KISHAN INTER COLLEGE",
"KISHAN KANIHYA FABRIC PRIVATE LIMITED",
"KISHAN LAL JEWELLERS AND SONS PRIVATE LIMITED",
"KISHAN LAL JEWELS PRIVATE LIMITED",
"KISHAN LAL SARAF JEWELS PRIVATE LIMITED",
"KISHAN MARINE SERVICES LLP",
"KISHAN METAL INDUSTRIES PRIVATE LIMITED",
"KISHAN MOHAN LOGISTICS PRIVATE LIMITED",
"KISHAN PRASAD ANDCOMPANY LIMITED",
"KISHAN REFRACTORIES PRIVATE LIMITED",
"KISHAN SINGH HOSPITAL LIMITED",
"KISHANGARH BEAWAR NH-8 TOLLWAY PRIVATE LIMITED",
"KISHANGARH CONSTRUCTIONS PVT. LTD",
"KISHANGARH GULABPURA TOLLWAY LIMITED",
"KISHANGARH HI TECH TEXTILE PARK LIMITED",
"KISHANGARH SPUNTEX PRIVATE LIMITED",
"KISHANGARH STONEX PRIVATE LIMITED",
"KISHANKALA TEXPRINT PRIVATE LIMITED",
"KISHANLAL MAYARAM FOOD INDUSTRIES PRIVATE LIMITED",
"KISHANLAL RUKMANIDEVI TEA PRIVATE LIMITED",
"KISHANMAL FOODS PRIVATE LIMITED",
"KISHANZEN (OPC) PRIVATE LIMITED",
"KISHCO ENTERPRISES PRIVATE LIMITED",
"KISHCO LIMITED",
"KISHCO PRIVATE LIMITED",
"KISHENS ACCOUNTING SOLUTIONS PRIVATE LIMITED",
"KISHINCHAND CHELLARAM (INDIA) PRIVATE LIMITED",
"KISHINCHAND CHELLARAM COLLEGE",
"KISHIV MOTORS PRIVATE LIMITED",
"KISHLAY FOODS PRIVATE LIMITED",
"KISHLEY CABLES AND STEELS LIMITED",
"KISHNA EXPORTS INTERNATIONAL",
"KISHOR ENCARE GLOBAL PRIVATE LIMITED",
"KISHOR PROJECTS PRIVATE LIMITED",
"KISHOR PUMPS PRIVATE LIMITED",
"KISHOR SORTEX AND RICE MILL PRIVATE LIMITED",
"KISHOR SPRINGS PRIVATE LIMITED",
"KISHOR STEEL PRIVATE LIMITED",
"KISHOR TRANSPORT SERVICES PRIVATE LIMITED",
"KISHORCHANDRA KALYANJI AGRI LLP",
"KISHORE ADVENTIS PRIVATE LIMITED",
"KISHORE AMPOULES PVT LTD",
"KISHORE AUTOMOBILES PRIVATE LIMITED",
"KISHORE BAGAI TRANSPORT PVT LTD",
"KISHORE BANDHU PRIVATE LIMITED",
"KISHORE DIE-O-FORM PVT LTD",
"KISHORE FABRICS PVT LTD",
"KISHORE INDUSTRIES PRIVATE LIMITED",
"KISHORE INFRASTRUCTURES PRIVATE LIMITED",
"KISHORE LABELS PRIVATE LIMITED",
"KISHORE MARKETING(INDIA) PRIVATE LIMITED",
"KISHORE PHARMA PRODUCTS PVT LTD",
"KISHORE PRASAD BIJAY PRASAD BEVERAGES PRIVATE LIMITED",
"KISHORE SAREES PRIVATE LIMITED",
"KISHORE VADILAL PVT LTD",
"KISHOREMAN ENGINEERING PRIVATE LIMITED",
"KISHORI LAL MARKETING PRIVATE LIMITED",
"KISHORI MERCANTILES PRIVATE LIMITED",
"KISHORI METAL INDUSTRIES PRIVATE LIMITED",
"KISHORI NURSING HOME PRIVATE LIMITED",
"KISHORI RAMAN INT COLL MATHURA",
"KISHORI SAREES PRIVATE LIMITED",
"KISHORIJI EXIM PRIVATE LIMITED",
"KISHORILAL CONSTRUCTIONS PRIVATE LIMITED",
"KISHORILAL SHYAM SUNDER PRIVATE LIMITED",
"KISHU TRADECOM PRIVATE LIMITED",
"KISHU TRADEX PRIVATE LIMITED",
"KISKU CONSTRUCTION PRIVATE LIMITED",
"KISLAY VEGGIFARM PRIVATE LIMITED",
"KISM TEXTILE PRIVATE LIMITED",
"KISMAT MACHINES INDIA PRIVATE LIMITED",
"KISMAT TEXTILE MILLS PRIVATE LIMITED",
"KISMAT TRADEPLACE PRIVATE LIMITED",
"KISSAN AGRI MALL PRIVATE LIMITED",
"KISSAN AGRO FOODS PRIVATE LIMITED",
"KISSAN AGRO FOODS STORAGE PRIVATE LIMITED",
"KISSAN AGRO PRODUCTS PRIVATE LIMITED",
"KISSAN AGROVET PRIVATE LIMITED",
"KISSAN CROP CARE & MULTI SERVICES PRIVATE LIMITED",
"KISSAN ENERGY INDIA PRIVATE LIMITED",
"KISSAN FATS LIMITED",
"KISSAN HATCHERIES PRIVATE LIMITED",
"KISSAN INDUSTRIES",
"KISSAN POULTRY (INDIA) PRIVATE LIMITED",
"KISSAN RICE MILL",
"KISSAN RICE MILLS",
"KISSAN SOLVEX PRIVATE LIMITED",
"KISSAN ZINC INDIA PVT LTD",
"KISSANDHAN AGRI FINANCIAL SERVICES PRIVATE LIMITED",
"KISSANPRO AGRO TECHNOLOGY PRIVATE LIMITED",
"KISSUI METALIKS & STEELS PRIVATE LIMITED",
"KISTLER INSTRUMENTS INDIA PRIVATE LIMITED",
"KISWOK INDUSTRIES PRIVATE LIMITED",
"KIT COLLEGE OF ENGINEERING",
"KIT MARKETING PRIVATE LIMITED",
"KIT MART PRIVATE LIMITED",
"KIT SOLUTIONS PRIVATE LIMITED",
"KIT TRADERS PVT.LTD.",
"KITADI TORGAON HIGHWAY PRIVATE LIMITED",
"KITAGAWA INDIA PRIVATE LIMITED",
"KITARA CAPITAL PRIVATE LIMITED",
"KITARO TRADING PRIVATE LIMITED",
"KITCH MART HOME SOLUTIONS PRIVATE LIMITED",
"KITCHEN AIDS DISTRIBUTORS PRIVATE LIMITED",
"KITCHEN FRAGRANCES INDIA LLP",
"KITCHEN HOUSE SOLUTIONS PRIVATE LIMITED",
"KITCHEN KREW 91 PRIVATE LIMITED",
"KITCHEN STRAINERS AND TOOLS (INDIA) PRIVATE LIMITED",
"KITCHEN XPRESS OVERSEAS LIMITED",
"KITCHNRAMA FOOD SERVICE EQUIPMENT PRIVATE LIMITED",
"KITCO LIMITED",
"KITE INFOCOM VISION PRIVATE LIMITED",
"KITE KNOWLEDGE SERVICES INDIA PRIVATE LIMITED",
"KITEC INDUSTRIES (INDIA) PRIVATE LIMITED",
"KITES ENGINEERING SOLUTIONS PRIVATE LIMITED",
"KITES HOME DECOR PRIVATE LIMITED",
"KITEX CHILDRENSWEAR LIMITED",
"KITEX GARMENTS LIMITED",
"KITEX LIMITED",
"KITGOTT INGREDIENTS PRIVATE LIMITED",
"KITHANIA STEELS PRIVATE LIMITED",
"KITPAY PRIVATE LIMITED",
"KITTEN ENTERPRISES PRIVATE LIMITED",
"KITTY INDUSTRIES PRIVATE LIMITED",
"KITTY MARBLE PRIVATE LIMITED",
"KITTY6 SOURCING PRIVATE LIMITED",
"KIVA CAPITAL PRIVATE LIMITED",
"KIVASH ENGINEERING PVT LTD",
"KIVI HEALTHCARE PRIVATE LIMITED",
"KIVI LABS LIMITED",
"KIVIPIX PHOTOLAB PRIVATE LIMITED",
"BREGO BUSINESS PRIVATE LIMITED",
"KIWAKO AUTOMATION PRIVATE LIMITED",
"KIWI ALLOYS LIMITED",
"KIWI COMMODITIES PRIVATE LIMITED",
"KIWI COTTSPIN MILL PRIVATE LIMITED",
"KIWI ENTERPRISES PRIVATE LIMITED",
"KIWI FOODS INDIA PRIVATE LIMITED",
"KIWI INDIA PRIVATE LIMITED",
"KIWI KISAN WINDOW PRIVATE LIMITED",
"KIWI METAL CAST PRIVATE LIMITED",
"KIWI TECHNOLOGIES INDIA PRIVATE LIMITED",
"KIWIQA SERVICES PRIVATE LIMITED",
"KIWIS AND BROWNIES IT SOLUTIONS INDIA PRIVATE LIMITED",
"KIWIS ECO LABORATORIES PRIVATE LIMITED",
"KIWLA PRIVATE LIMITED",
"KIX HOSPITALITY PRIVATE LIMITED",
"KIXTIX MEDIA PRIVATE LIMITED",
"KIYA AGRO INDUSTRIES PRIVATE LIMITED",
"KIYAAN IT SOLUTIONS PRIVATE LIMITED",
"KIYAN LOGISTICS (OPC) PRIVATE LIMITED",
"KIYOSHI ENTERTAINMENT PRIVATE LIMITED",
"KIYOSHI INDIA AUTOMOTIVE PARTS AND FILTERS PRIVATE LIMITED",
"KIZHAKKETHIL STEELS PRIVATE LIMITED",
"KJ FOUNDATION",
"KJ ISPAT LIMITED",
"KJ LABORATORIES (OPC) PRIVATE LIMITED",
"KJ PANDYA COLLEGE OF PHYSIOTHERAPY",
"KJ QUARRIES PRIVATE LIMITED",
"KJ SOMAIYA ARTS COMMERCE COLLEGE",
"KJ SOMAIYA INSTITUTE OF DHARMA STUDIES",
"KJ SOMAIYA INSTITUTE OF MANAGEMENT STUD",
"KJ SOMAIYA PRIVATE INDUSTRIAL TRAINING INSTITUTE",
"KJ SONS JEWELLERS PRIVATE LIMITED",
"KJ SYSTEMS INDIA PRIVATE LIMITED",
"KJD EXIM PRIVATE LIMITED",
"KJELLBERG CUTTING AND WELDING INDIA PRIVATE LIMITED",
"KJI RESOURCES INDIA PRIVATE LIMITED",
"KJK INFRATECH PRIVATE LIMITED",
"KJK MEISTER HONEN PRIVATE LIMITED",
"KJMC CAPITAL MARKET SERVICES LIMITED",
"KJMC CORPORATE ADVISORS (INDIA) LIMITED",
"KJMC FINANCIAL SERVICES LIMITED",
"KJR POLY FILMS PRIVATE LIMITED",
"KJS CEMENT I LIMITED",
"KJS CONCRETE PRIVATE LIMITED",
"KJ'S FEATHER TOUCH JEWELLERY PRIVATE LIMITED",
"KJS INDIA PRIVATE LIMITED",
"KJS INVESTMENTS AND FINANCIAL SERVICES PRIVATE LIMITED",
"KJS PELLETS & POWER PRIVATE LIMITED",
"KJS SOLUTIONS (OPC) PRIVATE LIMITED",
"KJS TECHNOLOGIES INDIA PRIVATE LIMITED",
"KJSL COAL AND POWER PRIVATE LIMITED",
"KJSW SOLUTIONS AND DEVELOPERS PRIVATE LIMITED",
"KK COLLEGE OF PHARMACY",
"KK DHANUKA ESTATES PRIVATE LIMITED",
"KK FINECOT PRIVATE LIMITED",
"KK HOUSEHOLD PRIVATE LIMITED",
"KK INDIA PETROLEUM SPECIALITIES PRIVATE LIMITED",
"KK KOMPOUNDING TECH GIANT LIMITED",
"KK LIGHTING INDIA PRIVATE LIMITED",
"KK MOHINDRA FASTENINGS PRIVATE LIMITED",
"KK POWER CONSTRUCTION",
"KK PRECAST CONCRETE PRIVATE LIMITED",
"KK SHAH JARODWALA MANINAGA SCI COLG",
"KK SOFTWARE ASSOCIATES (GLOBAL) PRIVATE LIMITED",
"KK TECH ECO PRODUCTS PRIVATE LIMITED",
"KK TELECOM SERVICES",
"KK WAGH ENGINEERING COLLEGE",
"KK WAGH VIDYABHAVAN AND JUNIOR COLLEGE BHAUSAHEBNAGAR",
"KK WIND SOLUTIONS INDIA PRIVATE LIMITED",
"KK WORLD VISA CONSULTANTS PRIVATE LIMITED",
"KKA BUILDTECH PRIVATE LIMITED",
"KKALAMKARI CREATIONS PRIVATE LIMITED",
"KKALPANA INDUSTRIES INDIA LIMITED",
"KKASTURI MEDICARE PRIVATE LIMITED",
"KKB ENGINEERING & CONSTRUCTIONS PRIVATE LIMITED",
"KKB MADURA INDUSTRIES INDIA PRIVATE LIMITED",
"KKB PROJECTS PRIVATE LIMITED",
"KKC HOMOEOPATHIC MEDICAL COLLEGE AND HOSPITAL",
"KKCH MEDIWORLD PRIVATE LIMITED",
"KKDREAM AUTOCORP SOLUTION PRIVATE LIMITED",
"KKE WASH SYSTEMS",
"KKEC PRIVATE LIMITED",
"KKFM INDIA PRIVATE LIMITED",
"KK-FRP AND KONCRETE PRODUCTS PRIVATE LIMITED",
"KKG INDUSTRIES",
"KKG INDUSTRIES SIDCUL HARIDWAR",
"KKIPOWER DRIVES PRIVATE LIMITED",
"KKIRAN P3 INTERNATIONAL PRIVATE LIMITED",
"KKK TEXTILES PRIVATE LIMITED",
"KKL AUTOMOBILES PRIVATE LIMITED",
"KKM ENGINEERING SOLUTIONS PRIVATE LIMITED",
"KKM OVERSEAS PRIVATE LIMITED",
"KKNT FIRST MAIN PRIVATE LIMITED",
"KKOTECHA AGRO INDUSTRIES PRIVATE LIMITED",
"KKP PETCHEM PRIVATE LIMITED",
"KKR & KSR INSTITUTE OF TECHNOLOGY & SCIENCES",
"KKR AND KSR INSTITUTE OF TECHNOLOGY AND SCIENCES",
"KKR BUILDCON PRIVATE LIMITED",
"KKR CAPSTONE INDIA OPERATIONS ADVISORY PRIVATE LIMITED",
"KKR DRUGS & INTERMEDIATES PRIVATE LIMITED",
"KKR ENTERTAINMENT PRIVATE LIMITED",
"KKR INDIA ADVISORS PRIVATE LIMITED",
"KKR INDIA ASSET FINANCE PRIVATE LIMITED",
"KKR INDIA FINANCIAL SERVICES PRIVATE LIMITED",
"KKRC INFRASTRUCTURE PRIVATE LIMITED",
"KKRISHNA VAAHAN PRIVATE LIMITED",
"KKROY HEALTHCARE PRIVATE LIMITED",
"KKR'S GOWTHAM EDUCATIONAL INSTITUTIONS",
"KKRTC BIDAR",
"KKS GYPSUM INDIA PRIVATE LIMITED",
"KKSEC FINANCE SERVICES PRIVATE LIMITED",
"KKSV BUSINESS SERVICES PRIVATE LIMITED",
"KKT FOODS (INDIA) PRIVATE LIMITED",
"KKTS TELECOM PRIVATE LIMITED",
"KKUSUM INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"KKV TEA AND COFFEE PRIVATE LIMITED",
"KL ABDUL SATHAR IMPEX PRIVATE LIMITED",
"KL HI-TECH SECURE PRINT LIMITED",
"KL INFRABUILD PRIVATE LIMITED",
"KL REALBUILD PRIVATE LIMITED",
"KL RESOURCES PVT LTD",
"KL UNIVERSITY",
"KLA CONST TECHNOLOGIES PRIVATE LIMITED",
"KLA FOODS (INDIA) LIMITED",
"KLA INDIA PUBLIC LIMITED",
"KLAD ON DESIGN PRIVATE LIMITED",
"KLAKSHYA MARKETING PRIVATE LIMITED",
"KLAP EDUTAINMENT PRIVATE LIMITED",
"KLAR CARE SERVICES PRIVATE LIMITED",
"KLARA VENTURES PRIVATE LIMITED",
"KLARHEIT VALUERS AND ENGINEERING SERVICES PRIVATE LIMITED",
"KLARITY TECHNOCONSULT PRIVATE LIMITED",
"KLARKE FACILITY MANAGEMENT PRIVATE LIMITED",
"KLAS PRODUCTS PRIVATE LIMITED .",
"KLASS MOLD PRIVATE LIMITED",
"BOROSIL SCIENTIFIC LIMITED",
"KLASS VELVETS PRIVATE LIMITED",
"KLASSCORP SOLUTIONS PRIVATE LIMITED",
"KLASSIC BUSINESS ADVISORY PRIVATE LIMITED",
"KLASSIC CORROPACK PRIVATE LIMITED",
"KLASSIC KLAROL FILTERS PRIVATE LIMITED",
"KLASSIC PACKAGING PRIVATE LIMITED",
"KLASSIC WHEELS LIMITED",
"KLASSIFY TECHNOLOGY PRIVATE LIMITED",
"KLASSIK ENTERPRISES PRIVATE LIMITED",
"KLASSIK LAMITEX PRIVATE LIMITED",
"KLASSIK VINYL PRODUCTS LLP",
"KLA-TENCOR SOFTWARE INDIA PRIVATE LIMITED",
"KLAUS ELECTRICALS PRIVATE LIMITED",
"KLAUS IT SOLUTIONS PRIVATE LIMITED",
"KLAUS MULTIPARKING SYSTEMS PRIVATE LIMITED",
"KLAUS UNION ENGINEERING INDIA PRIVATE LIMITED",
"KLAUS UNION INDIA PRIVATE LIMITED",
"KLAUS WAREN FIXTURES PRIVATE LIMITED",
"KLAXON TRADING PRIVATE LIMITED",
"KLAY FINVEST PRIVATE LIMITED",
"KLAY SECURTIES PRIVATE LIMITED",
"KLB COMMODITIES PRIVATE LIMITED",
"KLB KOMAKI PRIVATE LIMITED",
"KLC LIQUORS PRIVATE LIMITED",
"KLC OVERSEAS",
"KLE COLLEGE",
"KLE ENGLISH MEDIUM SCHOOL",
"KLE GA COMP PU COLLEGE BELGAUM",
"KLE HOSPITAL",
"KLE VISHWANATH KATTI INSTITUTE OF DENTAL SCIENCES & HOSPITAL",
"KLEAN ENVIRONMENTAL CONSULTANTS PRIVATE LIMITED",
"KLEAN LABORATORIES AND RESEARCH PRIVATE LIMITED",
"KLEANFAB GV TEX PRIVATE LIMITED",
"KLEANSITE HOSPITALITY SERVICES PRIVATE LIMITED",
"KLEEMA CHEMICALS PVT LTD",
"KLEENAGE PRODUCTS (INDIA) PRIVATE LIMITED",
"KLEENAIR SYSTEMS P LIMITED",
"KLEENCO ON DEMAND SERVICES PRIVATE LIMITED",
"KLEENOIL FILTRATION INDIA PRIVATE LIMITED",
"KLEENTECH FACILITY MANAGEMENT PRIVATE LIMITED",
"KLEENTECH NETWORK PRIVATE LIMITED",
"KLEENWELL INDIA PRIVATE LIMITED",
"KLEIBER INTERIORS PRIVATE LIMITED",
"KLEIBERIT ADHESIVES INDIA PRIVATE LIMITED",
"KLEIN & NOBEL MEDICAL TECHNOLOGIES PRIVATE LIMITED",
"KLEMPZ CREATIVE SOLUTIONS PRIVATE LIMITED",
"KLENE PAKS LIMITED",
"KLENTY INDIA PRIVATE LIMITED",
"KLENZAIDS CONTAMINATION CONTROLS PRIVATE LIMITED",
"KLENZALL FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"KLEOS COMMUNICATIONS PRIVATE LIMITED",
"KLES SN COLLEGE",
"KLEVU INDIA PRIVATE LIMITED",
"KLEWARD CONSULTING PRIVATE LIMITED",
"KLG CAPITAL SERVICES LIMITED",
"KLI FREIGHT SOLUTIONS PRIVATE LIMITED",
"KLI SPORTS PRIVATE LIMITED",
"KLICK2BUY VENTURES PRIVATE LIMITED",
"KLICKH PRIVATE LIMITED",
"KLIENTO TECHNOLOGIES PRIVATE LIMITED",
"KLIEO GALLERIA OPC PRIVATE LIMITED",
"KLIFF COMPUTER SERVICES PRIVATE LIMITED",
"KLIFF INDUSTRIAL SERVICES PRIVATE LIMITED",
"KLIM ART PRIVATE LIMITED",
"KLIMA TECHNOLOGIES PRIVATE LIMITED",
"KLIMAANLAGE ENGINEERING SERVICES PRIVATE LIMITED",
"KLIMAANLAGE SOLUTIONS PRIVATE LIMITED",
"KLIMAPHARM TECHNOLOGIES PRIVATE LIMITED",
"KLIMAS INDIA PRIVATE LIMITED",
"KLIN WELD WIRES PRIVATE LIMITED",
"KLINGELNBERG INDIA PRIVATE LIMITED",
"KLINGSPOR INDIA PRIVATE LIMITED",
"K-LINK HEALTHCARE INDIA PRIVATE LIMITED",
"K-LINQ HOSMED (OPC) PRIVATE LIMITED",
"KLIO-TECH PRIVATE LIMITED",
"KLIPCO PRIVATE LIMITED",
"K-LITE INDUSTRIES PRIVATE LIMITED",
"KLITZZ IMPEX PRIVATE LIMITED",
"KLIXON ENGINEERS PRIVATE LIMITED",
"KLJ CAPITAL SERVICES PRIVATE LIMITED",
"KLJ DEVELOPERS PRIVATE LIMITED",
"KLJ ORGANIC LIMITED",
"KLJ PARAFLEX INDIA LIMITED",
"KLJ PETROPLAST LIMITED",
"KLJ PLASTICIZERS LIMITED",
"KLK URJA PRIVATE LIMITED",
"KLK VENTURES PRIVATE LIMITED",
"KLM AXIVA FINVEST LIMITED",
"KLM ELECTRONICS PRIVATE LIMITED",
"KLM FINCORP LIMITED",
"KLM FLEXI PACK PRIVATE LIMITED",
"KLM HOTEL AND RESORTS PRIVATE LIMITED",
"KLM INFRA",
"KLM LABORATORIES PRIVATE LIMITED",
"KLM ROYAL DUTCH AIRLINES",
"KLMM HOSPITAL PRIVATE LIMITED",
"KLN AUTOMOBILES PRIVATE LIMITED",
"KLN ENGINEERING PRIVATE LIMITED",
"KLN MOTOR AGENCIES PRIVATE LIMITED",
"KLO INDIA BATHROOM PRIVATE LIMITED",
"KLOC TECHNOLOGIES PRIVATE LIMITED",
"KLODEN TECHNOLOGIES PRIVATE LIMITED",
"KLOECKNER DESMA MACHINERY PRIVATE LIMITED",
"KLOHRCHEM INDUSTRY PRIVATE LIMITED",
"KLOK SYSTEMS INDIA PRIVATE LIMITED",
"K-LON TEKNO POLYMERS PRIVATE LIMITED",
"KLONEC AUTOMATION SYSTEMS PRIVATE LIMITED",
"KLOROFIL S K M PRIVATE LIMITED",
"KLOUD CONNECT TECH PRIVATE LIMITED",
"KLOUD DATA LABS PRIVATE LIMITED",
"KLOUD WIFI PRIVATE LIMITED",
"KLOUDGIN SAAS INDIA PRIVATE LIMITED",
"KLOUDQ TECHNOLOGIES LIMITED",
"KLOUDRAC SOFTWARES PRIVATE LIMITED",
"KLOUDSERVE SOFTWARE PRIVATE LIMITED",
"KLOUDYNET TECHNOLOGIES SDN. BHD",
"KLOUTIX LOGISTICS PRIVATE LIMITED",
"KLOUTIX SOLUTIONS PRIVATE LIMITED",
"KLOVE STUDIO SHOES AND ACCESSORIES PRIVATE LIMITED",
"KLOVER TEL PRIVATE LIMITED",
"KLOVES CUISINES PRIVATE LIMITED",
"KLOVES SOFTWARE PRIVATE LIMITED",
"KLOW COMPUTERS AND COMMUNICATIONS PRIVATE LIMITED",
"KLP PROJECTS PRIVATE LIMITED",
"KLP SECURITIES PRIVATE LIMITED",
"KLPN DIGITECH PRIVATE LIMITED",
"KLPTA BUSINESS SOLUTIONS PRIVATE LIMITED",
"KLR AGRO PRIVATE LIMITED",
"KLR COLLEGE OF ENGINEERING & TECHNOLOGY",
"KLR DIGITECH PRIVATE LIMITED",
"KLR FACILITY MANAGEMENT PRIVATE LIMITED",
"KLR PRODUCTS LIMITED",
"KLRL PHARMA PRIVATE LIMITED",
"KLS GOGTE INSTITUTE OF TECHNOLOGY",
"KLS MARTIN INDIA PRIVATE LIMITED",
"KLS WELLNESS",
"KLSR INFRATECH LIMITED",
"KLT AUTOMOTIVE AND TUBULAR PRODUCTS LIMITED",
"KLUB FINANCE PRIVATE LIMITED",
"KLUBER LUBRICATION INDIA PRIVATE LIMITED",
"KLUDIRAK INDIA PRIVATE LIMITED",
"KLUG AVALON MECHATRONICS PRIVATE LIMITED",
"KLUG INFRASTRUCTURE PRIVATE LIMITED",
"KLUG PUMPS PRIVATE LIMITED",
"KLV COLONISERS PRIVATE LIMITED",
"KLYSTRON ELECTRONICS PVT.LTD.",
"KM & CO",
"KM AGRO TECH PRIVATE LIMITED",
"KM AIRCON PRIVATE LIMITED",
"KM CHARAN INFRA PRIVATE LIMITED",
"KM FASTENERS PRIVATE LIMITED",
"KM FINANCIAL CONSULTANTS PVT LTD",
"KM FOOD INFRASTRUCTURE PRIVATE LIMITED",
"KM HOSPITALS",
"KM NU HOSPITAL",
"KM PAPERS",
"KM POWER PRIVATE LIMITED",
"KM SECURITY & PAYROLL MANAGEMENT PRIVATE LIMITED",
"KM SHAH DENTAL COLLEGE HOSPITAL",
"KMA ELECTRICALS PRIVATE LIMITED",
"KMA PHARMA PRIVATE LIMITED",
"KMB EXTRUSION PRIVATE LIMITED",
"KMB PAPERS PRIVATE LIMITED",
"KMB SERVICES PRIVATE LIMITED",
"KMB SOFTWARE SOLUTIONS PRIVATE LIMITED",
"KMC CONSTRUCTIONS LIMITED",
"KMC COOL CHAIN INDIA PRIVATE LIMITED",
"KMC ELECTRONICS PRIVATE LIMITED",
"KMC ENTERPRISES PRIVATE LIMITED",
"KMC GLASS AND ALUMINIUM PRIVATE LIMITED",
"KMC HOSPITAL & RESEARCH CENTRE",
"KMC HOUSING PRIVATE LIMITED",
"KMC INFRASTRUCTURE PRIVATE LIMITED",
"KMC INFRATECH LIMITED",
"KMC OILTOOLS INDIA PRIVATE LIMITED",
"KMC TEX FAB PRIVATE LIMITED",
"KMD TRANSWORLD (INDIA) PRIVATE LIMITED",
"KMEA ENGINEERING COLLEGE",
"KMEW OFFSHORE PRIVATE LIMITED",
"KMF AUTOMOTIVE PRIVATE LIMITED",
"KMF BUILDERS AND DEVELOPERS LIMITED",
"KMF INFOTECH (OPC) PRIVATE LIMITED",
"KMG AGRO FOODS PRIVATE LIMITED",
"KMG CERAMICS INDIA PRIVATE LIMITED",
"KMG ENTERPRISES",
"KMG INFOTECH LIMITED",
"KMG INFOTECH LIMITED.",
"KMG INTERNATIONAL LIMITED",
"KMG IT SERVICES PRIVATE LIMITED",
"KMG MILK FOOD LIMITED",
"KMG ROLLING PRIVATE LIMITED",
"KMG STAR INTERNATIONAL PRIVATE LIMITED",
"KMG TRADING AND SERVICES PRIVATE LIMITED",
"KMG WIRES PRIVATE LIMITED",
"KMGS ROAD SIGNS PRIVATE LIMITED",
"KMI BUSINESS TECHNOLOGIES PRIVATE LIMITED",
"KMK EVENT MANAGEMENT LIMITED",
"KMK PHARMA CONSULTING PRIVATE LIMITED",
"KMK VENTURES PRIVATE LIMITED",
"KML MOULDING A UNIT OF KRISHNA MARUTI LTD",
"KMM COLLEGE OF EDUCATION",
"KMM INSTITUTE OF TECHNOLOGY AND SCIENCES",
"KMM SOFTECHNOLOGIES PRIVATE LIMITED",
"KMN AGRI-BUSINESS SOLUTIONS PRIVATE LIMITED",
"KMN HEALTHCARE PRIVATE LIMITED",
"KMP INDUSTRRIAL PRIVATE LIMITED",
"KMP INFRATECH PRIVATE LIMITED",
"KMP MOTOR PARTS PRIVATE LIMITED",
"KMP TECHNOLOGIES PRIVATE LIMITED",
"KMPAISA PAYMENTS PRIVATE LIMITED",
"KMPHITECH LLP",
"KMPL INFRASTRUCTURES PRIVATE LIMITED",
"KMR EDUCATIONAL SOCIETY",
"KMR ESTATES AND BUILDERS PVT LTD",
"KMR JUNIOR COLLEGE",
"KMR POLYMERS PRIVATE LIMITED",
"KMR REALPROP PRIVATE LIMITED",
"KMR SEEDS PRIVATE LIMITED",
"KMR STEEL PRIVATE LIMITED",
"KMS COACH BUILDERS PRIVATE LIMITED",
"KMS CONFECTIONERIES PRIVATE LIMITED",
"KMS HEALTH CENTER PRIVATE LIMITED",
"KMS LOGISTICS & SHIPPING PRIVATE LIMITED",
"KMS MARITIME INDIA PRIVATE LIMITED",
"KMS MEDISURGI LIMITED",
"KMS MOTHER CHILD HOSPITAL",
"KMS PLASTWORLD PRIVATE LIMITED",
"KMS SOLAR PRIVATE LIMITED",
"KMS THERMAL ENGINEERING PRIVATE LIMITED",
"KMSA TRADING PRIVATE LIMITED",
"KMT VOYAGES PRIVATE LIMITED",
"KMTC EXIM PRIVATE LIMITED",
"KMTC INDIA PRIVATE LIMITED",
"KMTSU HI-TECH (INDIA) PRIVATE LIMITED",
"KMUNOTAG PRIVATE LIMITED",
"KMV PROJECTS LIMITED",
"KMV SPACES LLP",
"KMWA PU COLLEGE",
"KN AGRI RESOURCES LIMITED",
"KN ANAND CONSTRUCTIONS PRIVATE LIMITED",
"KN BIJAPURA SOLAR ENERGY PRIVATE LIMITED",
"KN CREATIONS PRIVATE LIMITED",
"KN FARM EQUIPMENT PRIVATE LIMITED",
"KN HIGHWAYS DEVELOPMENT PRIVATE LIMITED",
"KN INDI VIJAYAPURA SOLAR ENERGY PRIVATE LIMITED",
"KN M MANAGEMENT ADVISORY SERVIES PRIVATE LIMITED",
"KN MADHUSOODANAN CONTRACTORS PRIVATE LIMITED",
"KN MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"KN MUDDEBIHAL SOLAR ENERGY PRIVATE LIMITED",
"KN SAVOURY PRODUCTS PRIVATE LIMITED",
"KN SINDAGI SOLAR ENERGY PRIVATE LIMITED",
"KN SYN TEX PRIVATE LIMITED",
"KNA MARKETING INDIA PRIVATE LIMITED",
"KNA SHARE BROKERS PRIVATE LIMITED",
"KNAB FINANCE ADVISORS PRIVATE LIMITED",
"KNACK GLOBAL PRIVATE LIMITED",
"KNACK HEALTH CARE PRIVATE LIMITED.",
"KNACK PACKAGING PRIVATE LIMITED",
"KNACK POLYMERS",
"KNACK SYSTEMS AND SERVICES PRIVATE LIMITED",
"KNACKFORGE SOFT SOLUTIONS PRIVATE LIMITED",
"KNAM FOODS PRIVATE LIMITED",
"KNAM MARKETING PRIVATE LIMITED",
"KNANDI REFINERY PRIVATE LIMITED",
"KNAUF AMF INDIA PRIVATE LIMITED.",
"KNAUF CEILING SOLUTIONS INDIA PRIVATE LIMITED",
"KNAUF INDIA PRIVATE LIMITED",
"KNB TECHSERVE PRIVATE LIMITED",
"KNC FACILITY MANAGEMENT PRIVATE LIMITED",
"KNCHAN INFRASTRUCTURES LIMITED",
"KND BUSINESS VENTURES PRIVATE LIMITED",
"KND ENGINEERS AND CONSULTANTS (INDIA) PRIVATE LIMITED",
"KND INFRASTRUCTURE PRIVATE LIMITED",
"KND RUBBER MOULDING & FABRICATING PRIVATE LIMITED",
"KNDR CONSTRUCTIONS PRIVATE LIMITED",
"KNEO AUTOMATION PRIVATE LIMITED",
"KNESCOPIC ELECTRONICS PRIVATE LIMITED",
"KNEST MANUFACTURERS LLP",
"K--NET PRIVATE LIMITED",
"KNEWMORROW ENTERPRISE PRIVATE LIMITED",
"KNEXIR CONSULTANTS PRIVATE LIMITED",
"KNEXUS SOFTWARE DEVELOPMENT CENTRE PRIVATE LIMITED",
"KNF PUMPS+SYSTEMS (INDIA) PRIVATE LIMITED",
"KNG AGRO FOOD PRIVATE LIMITED",
"KNGD MART PRIVATE LIMITED",
"KNIDS GREEN PRIVATE LIMITED",
"KNIGHT DETECTIVE AND SECURITY SERVICES PRIVATE LIMITED",
"KNIGHT FINTECH PRIVATE LIMITED",
"KNIGHT FRANK PROPERTY SERVICES PRIVATE LIMITED",
"KNIGHT FRANK INDIA PRIVATE LIMITED",
"KNIGHT HOOD CORPORATE SERVICES PRIVATE LIMITED",
"KNIGHT LEARNING SOLUTIONS PRIVATE LIMITED",
"KNIGHT PHARMACEUTICALS PRIVATE LIMITED",
"KNIGHT RANGER SECURITY SERVICES PRIVATE LIMITED",
"KNIGHT WATCH SECURITY PRIVATE LIMITED",
"KNIGHTFIELD ENGINES PRIVATE LIMITED",
"KNIGHTLION PROTECTION PRIVATE LIMITED",
"KNIGHTS TRANSCO PRIVATE LIMITED",
"KNILA IT SOLUTIONS INDIA PRIVATE LIMITED",
"K-NINE SPARES PRIVATE LIMITED",
"KNISS LABORATORIES PRIVATE LIMITED",
"KNIT CITY GRAPHICS PRIVATE LIMITED",
"KNIT FOULDS PRIVATE LIMITED",
"KNIT GALLERY INDIA PRIVATE LIMITED",
"KNIT INDIA APPAREL PRIVATE LIMITED",
"KNIT INFRASTRUCTURE PRIVATE LIMITED",
"KNITCON SOLUTIONS PRIVATE LIMITED",
"KNITCRAFT APPARELS INTERNATIONAL PRIVATE LIMITED",
"KNIT-FAB TECHNICS P LIMITED",
"KNITRIGHT FABS (INDIA) PRIVATE LIMITED",
"KNITSBURG PRIVATE LIMITED",
"KNITSEW INTERNATIONAL PRIVATE LIMITED",
"KNITVEL NEEDLES PRIVATE LIMITED",
"KNITWELL APPARELS PRIVATE LIMITED",
"KNITWELL INDIA PRIVATE LIMITED",
"KNJ LOGISTICS PRIVATE LIMITED",
"KNK ASSOCIATES PRIVATE LIMITED",
"KNK INVESTMENTS PRIVATE LIMITED",
"KNK KARTS PRIVATE LIMITED",
"KNK POWER PRIVATE LIMITED",
"KNK PROJECTS PRIVATE LIMITED",
"KNK TECHNOLOGIES PRIVATE LIMITED",
"KNL AXLES PRIVATE LIMITED",
"KNL DRIVELINE PARTS PRIVATE LIMITED",
"KNL MK GEARS PRIVATE LIMITED",
"KNM CHEMICALS PRIVATE LIMITED",
"KNM PHARMA PRIVATE LIMITED",
"KNM SPARES PRIVATE LIMITED",
"KNM TRANS & FORM PRIVATE LIMITED",
"KNMR ENGINEERS PRIVATE LIMITED",
"KNN INTERNATIONAL PRIVATE LIMITED",
"KNND ASSOCIATES PRIVATE LIMITED",
"KNOC DOOR SERVICES HR INDIA PRIVATE LIMITED",
"KNOC DOOR SERVICES PRIVATE LIMITED",
"KNOCK OUT SECURITY PRIVATE LIMITED",
"KNOCK WORLD PHARMA",
"KNOCKOUT FITNESS PRIVATE LIMITED",
"KNOCTOWL TECHNOLOGIES PRIVATE LIMITED",
"KNOLL HEALTHCARE PRIVATE LIMITED",
"KNOLL PHARMACEUTICALS LIMITED",
"KNOLSKAPE SOLUTIONS PRIVATE LIMITED",
"K-NOMICS TECHNO SOLUTIONS PRIVATE LIMITED",
"KNOP MERCANTILE PRIVATE LIMITED",
"KNOPFF SOLUTIONS PRIVATE LIMITED",
"KNOREX INDIA PRIVATE LIMITED",
"KNORISH FRAMEWORKS PRIVATE LIMITED",
"KNORR BREMSE INDIA PRIVATE LIMITED TFR CO FROM DELHI TO HARYANA",
"KNORR BREMSE SYSTEMS FOR COMMERCIAL VEHICLES INDIA PRIVATE LIMITED",
"KNORR-BREMSE TECHNOLOGY CENTER INDIA PRIVATE LIMITED",
"KNORR-BRESMSE INDIA PRIVATE LIMITED",
"KNOSTICS INFODEL PRIVATE LIMITED",
"KNOT SOLUTIONS PRIVATE LIMITED",
"KNOTT VORTEX PRIVATE LIMITED",
"KNOVEA PHARMACEUTICAL PRIVATE LIMITED",
"KNOVEDAD PRIVATE LIMITED",
"KNOVOS INDIA PRIVATE LIMITED",
"KNOW ALL EDGE NETWORKS PRIVATE LIMITED",
"KNOW YOUR MEDS INDIA PRIVATE LIMITED",
"KNOWCHEM LABORATORIES PRIVATE LIMITED",
"KNOWCRAFT ANALYTICS PRIVATE LIMITED",
"KNOWCROSS SOLUTIONS PRIVATE LIMITED",
"KNOWELL CONSULTANCY PRIVATE LIMITED",
"KNOWELL ENTERPRISES PRIVATE LIMITED",
"KNOWELL INTERNATIONAL PRIVATE LIMITED",
"KNOWERX EDUCATION INDIA PRIVATE LIMITED",
"KNOWHOW TECHNOLOGIES PRIVATE LIMITED",
"KNOWLARITY COMMUNICATIONS INDIA PRIVATE LIMITED",
"KNOWLARITY COMMUNICATIONS PRIVATE LIMITED",
"KNOWLEDGE ACADEMY SCHOOL",
"KNOWLEDGE ADVENTURE INDIA PRIVATE LIMITED",
"KNOWLEDGE BOX ACADEMY",
"KNOWLEDGE CAPITAL SERVICES PRIVATE LIMITED",
"KNOWLEDGE CENTRE FOR SUCCESS EDUCATE PRIVATE LIMITED",
"KNOWLEDGE CITY EDUCATION PRIVATE LIMITED",
"KNOWLEDGE EDUCATION TRUST",
"KNOWLEDGE EXCEL PRIVATE LIMITED",
"KNOWLEDGE FLEX TECHNOLOGIES PRIVATE LIMITED",
"KNOWLEDGE FOODS PRIVATE LIMITED",
"KNOWLEDGE FOUNDRY BUSINESS SOLUTIONS PRIVATE LIMITED",
"KNOWLEDGE INFRA PORTS PRIVATE LIMITED",
"KNOWLEDGE INFRASTRUCTURE SYSTEMS PRIVATE LIMITED",
"KNOWLEDGE INSTITUTE OF TECHNOLOGY",
"KNOWLEDGE INTEGRATION SERVICES I P L",
"KNOWLEDGE LENS PRIVATE LIMITED",
"KNOWLEDGE LINKS PRIVATE LIMITED",
"KNOWLEDGE MANAGEMENT AND RESEARCH ORGANISATION",
"KNOWLEDGE MARINE & ENGINEERING WORKS LIMITED",
"KNOWLEDGE MATRIX INDIA PRIVATE LIMITED",
"KNOWLEDGE PARTNER TECHNOLOGIES PRIVATE LIMITED",
"KNOWLEDGE PODIUM SYSTEMS PRIVATE LIMITED",
"KNOWLEDGE RIDGE PRIVATE LIMITED",
"KNOWLEDGE SPARK CONSULTANCY PRIVATE LIMITED",
"KNOWLEDGE SPLICE SERVICES PRIVATE LIMITED",
"KNOWLEDGE SQUARE PARKS & INCUBATORS PRIVATE LIMITED",
"KNOWLEDGE TREE INFRASTRUCTURE LIMITED",
"KNOWLEDGE TREE LEARNING RESOURCES PRIVATE LIMITED",
"KNOWLEDGE WOODS CONSULTING PRIVATE LIMITED",
"KNOWLEDGE WOODS EDUCATION TRAINING CONSULTING",
"KNOWLEDGE-DIVINE INFORMATION TECHNOLOGY PRIVATE LIMITED",
"KNOWLEDGEHOUSE LIMITED",
"KNOWLEDGEHUT SOLUTIONS PRIVATE LIMITED",
"KNOWLEDGEQ INTERACTIVE CONSULTANCY SERVICES PRIVATE LIMITED",
"KNOWLEDGEWORKS INNOVATIVE LINGUISTIC SOLUTIONS PRIVATE LIMITED",
"KNOWLENS SOLUTIONS PRIVATE LIMITED",
"KNOWLVERS CONSULTING PRIVATE LIMITED",
"KNOWN TEXTILES PRIVATE LIMITED",
"KNOWNSENSE STUDIOS LLP",
"KNOWN-YOU SEED (INDIA) PRIVATE LIMITED",
"KNOWTABLE ONLINE SERVICES PRIVATE LIMITED",
"KNOWTEQ CONCEPTS PRIVATE LIMITED",
"KNOWX INNOVATIONS PRIVATE LIMITED",
"KNOWZIES TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"KNOX IMPEX PRIVATE LIMITED",
"KNOX RETAIL",
"KNP ARISES GREEN ENERGY PRIVATE LIMITED",
"KNR CONSTRUCTION LIMITED",
"KNR CONSTRUCTIONS LIMITED",
"KNR CONTRACTORS PRIVATE LIMITED",
"KNR ENGINEERS INDIA PRIVATE LIMITED",
"KNR INFRA DEVELOPERS PRIVATE LIMITED",
"KNR MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"KNR MUZAFFARPUR - BARAUNI TOLLWAY PRIVATE LIMITED",
"KNR PALANI INFRA PRIVATE LIMITED",
"KNR SHANKARAMPET PROJECTS PRIVATE LIMITED",
"KNR SOMWARPET INFRAPROJECT PRIVATE LIMITED",
"KNR SRIRANGAM INFRA PRIVATE LIMITED",
"KNR TIRUMALA INFRA PRIVATE LIMITED",
"KNR WALAYAR TOLLWAYS PRIVATE LIMITED",
"KNRC HOLDINGS AND INVESTMENTS PRIVATE LIMITED",
"KNS ARCHITECTS PRIVATE LIMITED",
"KNS ENGINEERING WORKS PRIVATE LIMITED",
"KNS INFRACON PRIVATE LIMITED",
"KNS MEMORIAL HOSPITAL PRIVATE LIMITED",
"KNS OVERSEAS PRIVATE LIMITED",
"KNS PROJECTS PRIVATE LIMITED",
"KNS TRADING PVT LTD",
"KNS VINAYAK AUTO PRIVATE LIMITED",
"KNS VINAYAK COMMERCIALS PRIVATE LIMITED",
"KNS VINAYAK MINING AND INFRA PRIVATE LIMITED",
"KNSD ENTERPRISES PRIVATE LIMITED",
"KNT CREATIONS INDIA PRIVATE LIMITED",
"KNTX TRADING SOLUTIONS INDIA PRIVATE LIMITED",
"KNV EXIM PRIVATE LIMITED",
"KNVM MEDICARE PRIVATE LIMITED",
"KNVUPS INFRA PRIVATE LIMITED",
"KNW APPARELS PRIVATE LIMITED",
"KNY PROJECTS PRIVATE LIMITED",
"KNYA ENTERPRISE PRIVATE LIMITED",
"KO CON INDIA PRIVATE LIMITED",
"KO INDUSTRIES PRIVATE LIMITED",
"KO KO TOKE (INDIA) PRIVATE LIMITED",
"KOALA SUPER-PREMIUM PRIVATE LIMITED",
"KOB MEDICAL TEXTILES PRIVATE LIMITED",
"KOBASHI MACHINE TOOLS PRIVATE LIMITED",
"KOBE SUSPENSION COMPANY PRIVATE LIMITED",
"KOBELCO COMPRESSORS INDIA PRIVATE LIMITED",
"KOBELCO CONSTRUCTION EQUIPMENT INDIA PRIVATE LIMITED",
"KOBELCO INDUSTRIAL MACHINERY INDIA PRIVATE LIMITED",
"KOBELCO LOGISTICS INDIA PRIVATE LIMITED",
"KOBELCO PLATE PROCESSING INDIA PRIVATE LIMITED",
"KOBELCO TRADING INDIA PRIVATE LIMITED",
"KOBIAN ECS INDIA PRIVATE LIMITED",
"KOBLE TRADE PRIVATE LIMITED",
"KOBLENZ UTTURKAR FITTINGS PRIVATE LIMITED",
"KOBLERR ENTERPRISES PRIVATE LIMITED",
"KOBLERR FOOT WEAR & ACCESSORIES PRIVATE LIMITED",
"KOBOLD INSTRUMENTS PRIVATE LIMITED",
"KOBUS LOGISTICS PRIVATE LIMITED",
"KOC SOUND SYSTEM INDIA PRIVATE LIMITED",
"KOCH BUSINESS SOLUTIONS INDIA PRIVATE LIMITED",
"KOCH ENGINEERED SOLUTIONS INDIA PRIVATE LIMITED¬†",
"KOCH KUNDA AGRO FARMING PRIVATE LIMITED",
"KOCHAR CONSULTANTS PRIVATE LIMITED",
"KOCHAR ENTERPRISES PRIVATE LIMITED",
"KOCHAR HOMES PRIVATE LIMITED",
"KOCHAR INFOTECH LIMITED",
"KOCHAR INFRASTRUCTURE PRIVATE LIMITED",
"KOCHAR PROPERTIES PRIVATE LIMITED",
"KOCHAR RICE EXIM PRIVATE LIMITED",
"KOCHAR WOLLEN MILLS PRIVATE LIMITED",
"KOCHAS POWER PRIVATE LIMITED",
"KOCHASOFT INDIA PRIVATE LIMITED",
"KOCHHAR & CO",
"KOCHHAR ASSOCIATES PRIVATE LIMITED",
"KOCHHAR GLASS INDIA PRIVATE LIMITED",
"KOCHI AROOR TOLLWAYS PRIVATE LIMITED",
"KOCHI CRICKET PRIVATE LIMITED",
"KOCHI HOLDINGS PRIVATE LIMITED",
"KOCHI METRO RAIL LIMITED",
"KOCHI SALEM PIPELINE PRIVATE LIMITED",
"KOCHI WATER METRO LIMITED",
"KOCHIN INLAB EQUIPMENTS INDIA PRIVATE LIMITED",
"KOCKPIT ANALYTICS PRIVATE LIMITED",
"KODACHADRI CHITS PRIVATE LIMITED",
"KODAD KHAMMAM ROAD PRIVATE LIMITED",
"KODAGU HYDEL PROJECTS PRIVATE LIMITED",
"KODAGU RETAILS PRIVATE LIMITED",
"KODAI AUTOMOBILES LTD",
"KODAI DAIRY PRODUCTS PRIVATE LIMITED",
"KODAI INVESTMENT & TRADING COMPANY PRIVATE LIMITED",
"KODAIKANAL INTERNATIONAL SCHOOL",
"KODAK INDIA PRIVATE LIMITED",
"KODAMA INFO INNOVATIONS PRIVATE LIMITED",
"KODAN SOLUTIONS PRIVATE LIMITED",
"KODANDARAM ROLLER FLOUR MILLS PRIVATE LIMITED",
"KODANGAL SOLAR PARKS PRIVATE LIMITED",
"KODARMA CHEMICAL PRIVATE LIMITED",
"KODCO ENERGY INDIA PRIVATE LIMITED",
"KODE CORP TECHNOLOGY SOLUTIONS PRIVATE. LIMITED.",
"KODECORP TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"KODEGEAR TECHNOLOGIES PRIVATE LIMITED",
"KODEL UNIQUOTERS PRIVATE LIMITED",
"KODERMA TRANSMISSION LIMITED",
"KODEX GLOBAL CONSTRUCTION CHEMICALS PRIVATE LIMITED",
"KODEX KITCHEN INDUSTRIES PRIVATE LIMITED",
"KODEYOGA INDIA PRIVATE LIMITED",
"KODHAI IMAGING SOLUTIONS PRIVATE LIMITED",
"KODI SHIPPING AGENCIES PRIVATE LIMITED",
"KODIAK CONTAINER LINES PRIVATE LIMITED",
"KODIAK NETWORKS INDIA PRIVATE LIMITED",
"KODIBAIL IMPORT - EXPORT PRIVATE LIMITED",
"KODION SOFTWARES PRIVATE LIMITED",
"KODIXODEL PRIVATE LIMITED",
"KODIYA ENTERPRISES PRIVATE LIMITED",
"KODIYALAM FLORICULTURE PRIVATE LIMITED",
"KODNEST TECHNOLOGIES PRIVATE LIMITED",
"KODUNGALLUR MEDICARE P LTD",
"KODUVALLY INSTITUTE OF MEDICAL SCIENCES PRIVATE LIMITED",
"KODVAV PRA SHALA TALUKO MANAVADAR",
"KODY RUBE-TECH PRIVATE LIMITED",
"KODY TECHNOLAB LIMITED",
"KOEDGE TECHNOLOGIES (OPC) PRIVATE LIMITED",
"KOEL COLOURS PVT LTD",
"KOELEMAN INDIA PRIVATE LIMITED",
"KOELLE DESIGNS PRIVATE LIMITED",
"KOELNMESSE YA TRADEFAIR PRIVATE LIMITED",
"KOENIG & BAUER BANKNOTE SOLUTIONS (IN) PRIVATE LIMITED",
"KOENIG SOLUTIONS PRIVATE LIMITED",
"KOERBER PHARMA PRIVATE LIMITED",
"KOERTING ENGINEERING PRIVATE LIMITED",
"KOFAX INDIA PRIVATE LIMITED",
"KOFFEETECH SOFTWARE PRIVATE LIMITED",
"KOFFER PACKAGING PRIVATE LIMITED",
"KOFLUENCE TECH PRIVATE LIMITED",
"KOGANTI METALS AND ALLOYS PRIVATE LIMITED",
"KOGANTI STEELS PVT LTD",
"KOGENTIX TECHNOLOGIES PRIVATE LIMITED",
"KOGNITIV INDIA PRIVATE LIMITED",
"KOGNOZ RESEARCH & CONSULTING PRIVATE LIMITED",
"KOGTA FINANCIAL (INDIA) LTD",
"KOGTA GLOBAL PRIVATE LIMITED",
"KOGTA IMPORT EXPORT PRIVATE LIMITED",
"KOGTA INTERNATIONAL PRIVATE LIMITED",
"KOHAN CONSUMER CARE PRIVATE LIMITED",
"KOHBEE TECHNOLOGIES PRIVATE LIMITED",
"KOHELIKA KOHLI ARCHITECTS & DESIGNERS PRIVATE LIMITED",
"KOHENOOR ASLI LUNGIWALA PRIVATE LIMITED",
"KOHIMA-MARIANI TRANSMISSION LIMITED",
"KOHIMARAN APPLE FARMS PRIVATE LIMITED",
"KOHINOOR ACCESSORIES PRIVATE LIMITED",
"KOHINOOR ALLOYS PRIVATE LIMITED",
"KOHINOOR ARTS COMMERCE AND SCIENCE COLLEGE",
"KOHINOOR AUTOMOTORS PRIVATE LIMITED",
"KOHINOOR BUILDHOME PRIVATE LIMITED",
"KOHINOOR COLLEGE",
"KOHINOOR COLOURS PVT LTD",
"KOHINOOR COMMOTRADE PRIVATE LIMITED",
"KOHINOOR COTTONTEX PRIVATE LIMITED",
"KOHINOOR CREATIONS PRIVATE LIMITED",
"KOHINOOR CTNL INFRASTRUCTURE COMPANY PRIVATE LIMITED",
"KOHINOOR CYCLES PRIVATE LIMITED",
"KOHINOOR DURON PAINTS PRIVATE LIMITED",
"KOHINOOR EDUCATION TRUST",
"KOHINOOR EDUCATIONAL SERVICES PRIVATE LIMITED",
"KOHINOOR ELASTICS PVT LTD",
"KOHINOOR ELITE HOTELS PRIVATE LIMITED",
"KOHINOOR ENTERPRISES PRIVATE LIMITED",
"KOHINOOR FASHION PRIVATE LIMITED",
"KOHINOOR FEEDS & FATS LIMITED",
"KOHINOOR FEEDS AND FATS PRIVATE LIMITED",
"KOHINOOR FLOORS PRIVATE LIMITED",
"KOHINOOR GEMS PRIVATE LIMITED",
"KOHINOOR GRAIN PROCESSING PRIVATE LIMITED",
"KOHINOOR GRANI MARMO INTERNATIONAL PRIVATE LIMITED",
"KOHINOOR GRANITE EXCLUSIVE INDIA PRIVATE LIMITED",
"KOHINOOR HATCHERIES PRIVATE LIMITED",
"KOHINOOR HOSPITALS PRIVATE LIMITED",
"KOHINOOR INTERNATIONAL PRIVATE LIMITED",
"KOHINOOR INTERNATIONAL SCHOOL",
"KOHINOOR LABELS PRIVATE LIMITED",
"KOHINOOR METALS PRIVATE LIMITED",
"KOHINOOR METFOAM PRIVATE LIMITED",
"KOHINOOR PLANET CONSTRUCTIONS PRIVATE LIMITED",
"KOHINOOR PRINTERS",
"KOHINOOR PRINTERS BANGALORE PRIVATE LIMITED",
"KOHINOOR REFINED FLOUR MILLS PRIVATE LIMITED",
"KOHINOOR REFRACTORIES PRIVATE LIMITED",
"KOHINOOR RIBBON FACTORY PRIVATE LIMITED",
"KOHINOOR ROPES PRIVATE LIMITED",
"KOHINOOR SEED FIELDS INDIA PRIVATE LIMITED",
"KOHINOOR TARPAULIN PRIVATE LIMITED",
"KOHINOOR TELEVIDEO PRIVATE LIMITED",
"KOHINOOR TEXTILES PROCESSING HOUSE PRIVATE LIMITED",
"KOHINOOR TOBACCO PRODUCTS PVT LTD",
"KOHINOOR TYRES PRIVATE LIMITED",
"KOHINOOR WOOLLENS PVT LTD",
"KOHLER INDIA CORPORATION PRIVATE LIMITED",
"KOHLER POWER INDIA PRIVATE LIMITED",
"KOHLEX INDIA DESIGN CENTER PRIVATE LIMITED",
"KOHLI AND SONS BEVERAGES PRIVATE LIMITED",
"KOHLI AUTOCOMP PRIVATE LIMITED",
"KOHLI AUTOMOBILES PRIVATE LIMITED",
"KOHLI BUILDERS AND DEVELOPERS PRIVATE LTD",
"KOHLI CABLES PRIVATE LIMITED",
"KOHLI EXPORT PACKAGING INDIA PRIVATE LIMITED",
"KOHLI GRAPHIC SYSTEMS PVT LTD",
"KOHLI INDUSTRIES",
"KOHLI IRON AND STEELS PRIVATE LIMITED",
"KOHLI LEATHER EXPORTS PRIVATE LIMITED",
"KOHLI ONE HOUSING & DEVELOPMENT PRIVATE LIMITED",
"KOHLI REALTECH PRIVATE LIMITED",
"KOHLI REALTORS PRIVATE LIMITED",
"KOHLI SALES AND SERVICES PRIVATE LIMITED",
"KOHLI SPORTS PRIVATE LIMITED",
"KOHLI STEEL FURNITURE PRIVATE LIMITED",
"KOHLI TYRES PRIVATE LIMITED",
"KOHLICO FOODS AND BEVERAGES PRIVATE LIMITED",
"KOIKE CUTTING & WELDING INDIA PRIVATE LIMITED",
"KOIL HARDWARE PRIVATE LIMITED",
"KOIN LOGISTICS INDIA PRIVATE LIMITED",
"KOINDO TRADING PRIVATE LIMITED",
"KOINEARTH INDIA PRIVATE LIMITED",
"KOINONE POLYTECH INDIA PRIVATE LIMITED",
"KOINONIA COFFEE PRIVATE LIMITED",
"KOINS INDIA MAINTENANCE SOLUTIONS SERVICES PRIVATE LIMITED",
"KOITO INDUSTRIES PRIVATE LIMITED",
"KOJAGORI AGRO INDUSTRIES PRIVATE LIMITED",
"KOJAK KNITS PRIVATE LIMITED",
"KOKA TECHNOLOGY PRIVATE LIMITED",
"KOKAL INTERIOR CONTRACTS PRIVATE LIMITED",
"KOKAN MITRA MANDAL MEDICAL TRUST",
"KOKAN SYNTHETICS & CHEMICALS PRIVATE LIMITED",
"KOKANA ASIA INGREDIENTS PRIVATE LIMITED",
"KOKANE AUTOLINES PRIVATE LIMITED",
"KOKANRATNA HOLIDAY RESORTS LIMITED",
"KOKBAN AUTOMATION PRIVATE LIMITED",
"KOKILA HENNA AND HERBALS PRIVATE LIMITED",
"KOKILA INFRATECH PRIVATE LIMITED",
"KOKILA MINING PRIVATE LIMITED",
"KOKILAA TEXTILE INDIA PRIVATE LIMITED",
"KOKILABEN DHIRUBHAI AMBANI HOSPITAL",
"KOKILABEN DHIRUBHAI AMBANI NURSING COLLEGE",
"KOKO NETWORKS PRIVATE LIMITED",
"KOKO SPICES PRIVATE LIMITED",
"KOKOCO INNOVATIVE BEVERAGES PRIVATE LIMITED",
"KOKOKU INTECH INDIA PRIVATE LIMITED",
"KOKUYO CAMLIN LIMITED",
"KOKUYO RIDDHI PAPER PRODUCTS PRIVATE LIMITED",
"KOLA PERUMAL CHETT VAISHNAV SENIOR SECONDARY SCHOOL",
"KOLA PHARMA PRIVATE LIMITED",
"KOLA SARASWATHI VAISHNAV SENOIR SECONDARY SCHOOL",
"KOLAAHALAM HOUSING PROJECTS PRIVATE LIMITED",
"KOLAGATLA INFRA PROJECTS PRIVATE LIMITED",
"KOLAGHAT RESORT PVT LTD",
"KOLAGHAT THERMAL POWER STATION",
"KOLAR MILL STORES PRIVATE LIMITED",
"KOLAR PAPER MILLS LIMITED",
"KOLASARASWATHI VAISHNAV SENIOR SECONDARY SCHOOL",
"KOLASI AGROTECH PRIVATE LIMITED",
"KOLAY PROPERTIES PVT LTD",
"KOLAZ BIOTECH PRIVATE LIMITED",
"KOLAZ INFOTAINMENT",
"KOLBEN COMPRESSOR SPARES (INDIA ) PRIVATE LIMITED",
"KOLBEN HYDRAULICS LIMITED.",
"KOLDEN AIR CONDITIONING PVT LTD",
"KOLDKING LOGISTICS PRIVATE LIMITED",
"KOLESHVARI INFRATECH PRIVATE LIMITED",
"KOLESHWARI INFRACONS PRIVATE LIMITED",
"KOLEY CONVERTING MACHINERY PVT. LTD.",
"KOLEY MULTIPURPOSE HIMGHAR PRIVATE LIMITED",
"KOLF HOUSEWARE INDIA PRIVATE LIMITED",
"KOLHAN MINES AND MINERALS PRIVATE LIMITED",
"KOLHAN UNIVERSITY CHAIBASA",
"KOLHAPUR AUTO WORKS PRIVATE LIMITED",
"KOLHAPUR CANCER CENTRE PRIVATE LIMITED",
"KOLHAPUR DISTRICT CENTRAL COOPERATIVE BANK LTD",
"KOLHAPUR FOUNDRY AND EGINEERING CLUSTER",
"KOLHAPUR HIGHSCHOOL KOLHAPUR",
"KOLHAPUR IRRIGATION DIVISION KOLHAPUR",
"KOLHAPUR JILLHA KENDRAPRAMUKH PADVIDHAR SHIKSHAK SEVAKANCHI SAHKARI PATH SANSTHA",
"KOLHAPUR MUNICIPAL CORPORATION",
"KOLHAPUR MUNICIPAL TRANSPORT UNDERTAKING KOLHAPUR",
"KOLHAPUR OXYGEN AND ACETYLENE PRIVATE LIMITED",
"KOLHAPUR SUGAR MILLS LIMITED",
"KOLHAPUR ZILLA SAH DUDH UTPADAK SANGH LTD",
"KOLHAPUR ZILLA SAHAKARI DUDH UTPADAK SANGH LIMITED",
"KOLIS FOODS PRIVATE LIMITED",
"KOLIYOT SPECIALITY CHEMICALS PRIVATE LIMITED",
"KOLKATA AAYAT NIRYAT PRIVATE LIMITED",
"KOLKATA ASSAM ROADLINES PRIVATE LIMITED",
"KOLKATA AUTO AGENCIES PRIVATE LIMITED",
"KOLKATA BAGS PRIVATE LIMITED",
"KOLKATA BENEPOLE ROADLINES PRIVATE LIMITED",
"KOLKATA CALL TAXI PRIVATE LIMITED",
"KOLKATA CARBAZAAR PRIVATE LIMITED",
"KOLKATA EYE CARE HOSPITAL PRIVATE LIMITED",
"KOLKATA HOTELS LIMITED",
"KOLKATA M A BUSINESS CENTRE PRIVATE LIMITED",
"KOLKATA MARINE PRODUCTS PRIVATE LIMITED",
"KOLKATA METRO NETWORKS LIMITED",
"KOLKATA METRO RAIL CORPORATION LIMITED",
"KOLKATA METROPOLITAN DEVELOPMENT AUTHORITY",
"KOLKATA MUNICIPAL CORPORATION",
"KOLKATA PORT TRUST",
"KOLKATA RESPONSE GROUP PRIVATE LIMITED",
"KOLKATA SOUTH HEALTH ELECTRICAL DIVISION P W DTD",
"KOLKATA TELECOM SUPPORT & SERVICE PRIVATE LIMITED",
"KOLKATA TOURS & TRAVELS (I) PRIVATE LIMITED",
"KOLKATA WEST INTERNATIONAL CITY PRIVATE LIMITED",
"KOLKATTA HOTELS LIMITED",
"KOLLA DEVELOPERS AND BUILDERS PRIVATE LIMITED",
"KOLLAM INTERNET CABLE DISTRIBUTION PRIVATE LIMITED",
"KOLLAMKULAM RUBBERS PVT LTD",
"KOLLAND DEVELOPERS PRIVATE LIMITED",
"KOLLAR SPICES TRADING PRIVATE LIMITED",
"KOLLARA ENTERPRISES PRIVATE LIMITED",
"KOLLEGAL SCANNING & DIAGNOSTIC CENTRE PRIVATE LIMITED",
"KOLLENGODE AGRO MILLS PRIVATE LIMITED",
"KOLLENGODE HERITAGE HOTELS AND TOURISM PRIVATE LIMITED",
"KOLLI GRAPHICS PRIVATE LIMITED",
"KOLLIPARA APPARAO COTTON MILLS PVT LTD",
"KOLLUR GURUNATH CONSTRUCTION INFRA PRIVATE LIMITED",
"KOLLURI IMPEX PRIVATE LIMITED",
"KOLMEKS (GUJARAT) MANUFACTURING PRIVATE LIMITED",
"KOLMET HOSPITAL",
"KOLOGNE INTERNATIONAL PRIVATE LIMITED",
"KOLON GLOTECH INDIA PRIVATE LIMITED",
"KOLON PLASTICS INDIA PRIVATE LIMITED",
"KOLONIZER REAL BUSINESS SOLUTIONS PRIVATE LIMITED",
"KOLONY TEA ESTATE PRIVATE LIMITED",
"KOLOR BIO - GENETICS PRIVATE LIMITED",
"KOLORJET CHEMICALS PRIVATE LIMITED",
"KOLORKAARI STUDIOS PRIVATE LIMITED",
"KOLORROL TECHNOLOGIES PRIVATE LIMITED",
"KOLORS HEALTH CARE INDIA PRIVATE LIMITED",
"KOLORS HEALTHCARE LLP",
"KOLORS INDIA PRIVATE LIMITED",
"KOLORTEK PAINTS PRIVATE LIMITED",
"KOLOT MEDIA AND ENTERTAINMENT PRIVATE LIMITED",
"KOLOUR KONCEPTS INTERNATIONAL",
"KOLOUR SPINTEK LIMITED",
"KOLPING CONVENT HIGHER SECONDARY SCHOOL",
"KOLS AND PEERS ANALYTICS",
"KOLT OILFIELD SERVICES PRIVATE LIMITED",
"KOLTE PATIL DEVELOPERS LIMITED",
"KOLTE PATIL INTEGRATED TOWNSHIPS LIMITED",
"KOLTE WAREHOUSING PRIVATE LIMITED",
"KOLTE-PATIL PROPERTIES PRIVATE LIMITED",
"KOLTE PATIL REAL ESTATE PRIVATE LIMITED",
"KOLVAN SOLUTIONS PRIVATE LIMITED",
"KOLVIN MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"KOMAF FINANCIAL SERVICES PRIVATE LIMITED",
"KOMAL AGROTECH PRIVATE LIMITED",
"KOMAL ALLURE PRIVATE LIMITED",
"KOMAL APPARELS PRIVATE LIMITED",
"KOMAL ATOMIZER PVT LTD",
"KOMAL BUILDCON PRIVATE LIMITED",
"KOMAL CARGO SERVICES PRIVATE LIMITED",
"KOMAL COTTEX INDIA PRIVATE LIMITED",
"KOMAL ENGINEERS & CONSULTANTS PRIVATE LIMITED",
"KOMAL ENTERPRISES",
"KOMAL EXIM PRIVATE LIMITED",
"KOMAL FABRICS PRIVATE LIMITED",
"KOMAL HEALTH CARE PRIVATE LIMITED",
"KOMAL INDUSTRIES PRIVATE LIMITED",
"KOMAL INFOTECH PRIVATE LIMITED",
"KOMAL LEOLITE PRIVATE LIMITED",
"KOMAL LIFESTYLE PRIVATE LIMITED",
"KOMAL MANUFACTURING CHEMISTS PRIVATE LIMITED",
"KOMAL OIL PRIVATE LIMITED",
"KOMAL SALES AND CARE PRIVATE LIMITED",
"KOMAL SYSTEMS PRIVATE LIMITED",
"KOMAL TANKERS PRIVATE LIMITED",
"KOMAL TEXART PRIVATE LIMITED",
"KOMAL TEXFAB PRIVATE LIMITED",
"KOMAL WORLDWIDE PRIVATE LIMITED",
"KOMALA VILAS BOARDING AND STORES PVT LTD",
"KOMALAY INVESTRADE PRIVATE LIMITED",
"KOMALI FERTILITY CENTRE LLP",
"KOMALIKA FARMER PRODUCER COMPANY LIMITED",
"KOMALRAJ TRANSPORT PRIVATE LIMITED",
"KOMARINA FOOD PRODUCTS PRIVATE LIMITED",
"KOMARLA FEEDS AND FOODS PRIVATE LIMITED",
"KOMARLA HATCHERIES KH",
"KOMATSU INDIA PRIVATE LIMITED",
"KOMAX AUTOMATION INDIA PRIVATE LIMITED",
"KOMDHARA PRY SCHOOL",
"KOMEA FUTURE EDU CONSULTING PRIVATE LIMITED",
"KOMHAR INFOTECH PRIVATE LIMITED",
"KOM-MED LABROTORIES PRIVATE LIMITED",
"KOMMLABS DEZIGN PRIVATE LIMITED",
"KOMMONERS CLUB & HOSPITALITY PRIVATE LIMITED",
"KOMMUNE ARTS PRIVATE LIMITED",
"KOMMUNE BRAND COMMUNICATIONS PRIVATE LIMITED",
"KOMMURI PRATAP REDDY INSTITUTE OF TECHNOLOGY",
"KOMOLINE AEROSPACE LIMITED",
"KOMOREBI TECH SOLUTIONS PRIVATE LIMITED",
"KOMORI INDIA PRIVATE LIMITED",
"KOMOS AUTOMOTIVE INDIA PRIVATE LIMITED",
"KOMPANION RESEARCH PRIVATE LIMITED",
"KOMPASS HEALTHCARE SERVICES PRIVATE LIMITED",
"KOMPASS OVERSEAS PRIVATE LIMITED",
"KOMPLETE SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED",
"KOMPLETT ELECTRICAL SOLUTIONS PRIVATE LIMITED",
"KOMPRESS INDIA PRIVATE LIMITED",
"KOMPRISE INDIA PRIVATE LIMITED",
"KOMTECH PLASTIC TECHNOLOGIES INDIA PRIVATE LIMITED",
"KOMTER EQUIPMENTS PRIVATE LIMITED",
"KOMYO ENGINEERING PRIVATE LIMITED",
"KONACC DIAGNOSTICS PRIVATE LIMITED",
"KONAR ENGINEERING SERVICES PRIVATE LIMITED",
"KONAR ORGANICS LIMITED",
"KONARK ADVISERS PRIVATE LIMITED",
"KONARK AGROTECH PRIVATE LIMITED",
"KONARK CONSTRUCTION AND ENGINEERS LIMITED",
"KONARK DARSHAN CONSTRUCTIONS PRIVATE LIMITED",
"KONARK EARTHMOVERS PRIVATE LIMITED",
"KONARK ENTERPRISES PRIVATE LIMITED",
"KONARK ENVIRO PROJECT PRIVATE LIMITED",
"KONARK FIXTURES LIMITED",
"KONARK FROZEN FOODS PRIVATE LIMITED",
"KONARK GUJARAT PV PRIVATE LIMITED",
"KONARK INDUSTRIA PRIVATE LIMITED",
"KONARK INVACARE PRIVATE LIMITED",
"KONARK IP DOSSIERS PRIVATE LIMITED",
"KONARK LIFE SPACES",
"KONARK METAL AND WIRE CONDUCTORS PRIVATE LIMITED",
"KONARK METAL PRODUCTS PRIVATE LIMITED",
"KONARK NIRMAN PRIVATE LIMITED",
"KONARK OVERSEAS PRIVATE LIMITED",
"KONARK PETRO PRODUCTS (INDIA) PRIVATE LIMITED",
"KONARK PLAZA CONSTRUCTIONS PRIVATE LIMITED",
"KONARK POLYTUBES PRIVATE LIMITED",
"KONARK PROJECTS LIMITED",
"KONARK RESEARCH FOUNDATION",
"KONARK STEEL INDUSTRIES PVT LTD",
"KONARK STRUCTURAL ENGINEERS PRIVATE LIMITED",
"KONARK SYNTHETIC LIMITED",
"KONARK TAR PRODUCTS P LTD",
"KONARK UDYOG PRIVATE LIMITED",
"KONART STEEL BUILDINGS PRIVATE LIMITED",
"KONASTH INFRASTRUCTURE PRIVATE LIMITED.",
"KONASTH SOLUTIONS PRIVATE LIMITED",
"KONASTH TRAVELS PRIVATE LIMITED",
"KONATHALA COLD STORAGE PRIVATE LIMITED",
"KONCEIVE DEVELOPMENT CENTER PRIVATE LIMITED",
"KONCEPO SCIENTECH INTERNATIONAL PRIVATE LIMITED",
"KONCEPT AUTOMOBILES PRIVATE LIMITED",
"KONCEPT CARS INDIA PRIVATE LIMITED",
"KONCEPT CLOUD PRIVATE LIMITED",
"KONCEPT POLYPRO PRIVATE LIMITED",
"KONCEPT PROSTHETIC PRIVATE LIMITED",
"KONCEPT RETAIL SERVICES PRIVATE LIMITED",
"KONCEPT STEEL PRIVATE LIMITED",
"KONCEPT WELLNESS INTEGRATED THERAPY PRIVATE LIMITED",
"KONCEPTWISE DIGITAL MEDIA PRIVATE LIMITED",
"KONCHERIL TRADES AND EXPORTS PRIVATE LIMITED",
"KONCORDE CONTRACTORS PRIVATE LIMITED",
"KONCRETTA TILES INDIA PRIVATE LIMITED",
"KONCRIVA GROUP PRIVATE LIMITED",
"KONDA LABORATORIES PRIVATE LIMITED",
"KONDAAS AUTOMATION PRIVATE LIMITED",
"KONDAPALLI CONVEYORS AND ENGINEERS PRIVATE LIMITED",
"KONDAPALLY FORGINGS PRIVATE LIMITED",
"KONDAPUR TOWERS PRIVATE LIMITED",
"KONDE PRODUCTS & SERVICES PRIVATE LIMITED",
"KONDLI BAZAR PRIVATE LIMITED",
"KONDODY AUTOCRAFT (INDIA) PRIVATE LIMITED",
"KONDODY HOTELS AND RESORTS INDIA PRIVATE LIMITED",
"KONDODY PREFAB CONCRETES PRIVATE LIMITED",
"KONDRA INDIA PRIVATE LIMITED",
"KONDUSKAR AUTO CENTRE PRIVATE LIMITED",
"KONDUSKAR TRAVELS PRIVATE LIMITED",
"KONE ELEVATOR INDIA PRIVATE LIMITED",
"KONECRANES AND DEMAG PRIVATE LIMITED",
"KONEKT MARKETING SYSTEMS PRIVATE LIMITED",
"KONEL CORPORATION PRIVATE LIMITED",
"KONEM PRIVATE LIMITED",
"KONERU CONSTRUCTIONS PRIVATE LIMITED",
"KONERU LAKSHMAIAH COLLEGE OF ENGINEERING",
"KONERU LAKSHMAIAH EDUCATION FOUNDATION",
"KONET JEWELS PRIVATE LIMITED",
"KONEXIONS BACK OFFICE SERVICES PRIVATE LIMITED",
"KONFIDENCE RETAILS PRIVATE LIMITED",
"KONGHU VELALAR POLYTECHNIC COLLEGE",
"KONGOVI PRIVATE LIMITED",
"KONGSBERG AUTOMOTIVE DRIVELINE SYSTEMS INDIA PRIVATE LIMITED",
"KONGSBERG AUTOMOTIVE I PRIVATE LIMITED",
"KONGSBERG DIGITAL SOFTWARE AND SERVICES PRIVATE LIMITED",
"KONGSBERG MARITIME CM INDIA PRIVATE LIMITED",
"KONGSBERG MARITIME INDIA PRIVATE LIMITED",
"KONGSBERG NORCONTROL SURVEILLANCE PRIVATE LIMITED",
"KONGU ENGINEERING COLLEGE",
"KONGU KALVI NILAYAM MATRICULATION HIGHER SECONDARY SCHOOL",
"KONGU MATCH INDUSTRIES PRIVATE LIMITED",
"KONGUNAD HOSPITALS PRIVATE LIMITED",
"KONGUNADU AIR PRODUCT PRIVATE LIMITED",
"KONGUNADU ARTS AND SCIENCE COLLEGE",
"KONGUNADU COLLEGE OF ENGINEERING & TECHNOLOGY",
"KONICA MINOLTA BUSINESS SOLUTIONS INDIA PRIVATE LIMITED",
"KONICA MINOLTA HEALTHCARE INDIA PRIVATE LIMITED",
"KONICA MINOLTA MARKETING SERVICES INDIA PRIVATE LIMITED",
"KONIKA ELASTICS PRIVATE LIMITED",
"KONIKA INTIMA PRIVATE LIMITED",
"KONIKA JEWELLERY PRIVATE LIMITED",
"KONIKA TAPES PRIVATE LIMITED",
"KONIS PHARMACEUTICALS PRIVATE LIMITED",
"KONITA INDUSTRIES PRIVATE LIMITED",
"KONIVA TOURS AND TRAVELS PRIVATE LIMITED",
"KONKAN AGGREGATES PRIVATE LIMITED",
"KONKAN AGRO MARINE INDUSTRIES PRIVATE LIMITED",
"KONKAN BARGE BUILDERS PRIVATE LIMITED",
"KONKAN BAZAR COMPANY PRIVATE LIMITED",
"KONKAN BHAVAN",
"KONKAN GYANPEETH",
"KONKAN INJECTO PLAST PRIVATE LIMITED",
"KONKAN LNG LIMITED",
"KONKAN PAPER PRODUCTS PRIVATE LIMITED",
"KONKAN RAILWAY CORPORATION LIMITED",
"KONKAN ROADWAYS PVT LTD",
"KONKAN SPECIALITY POLY PRODUCTS PRIVATE. LIMITED.",
"KONKAN STORAGE SYSTEMS (KARWAR) PRIVATE LIMITED",
"KONKAN STORAGE SYSTEMS KOCHI PRIVATE LIMITED",
"KONKAN TECHNICAL PRIVATE LIMITED",
"KONKAN TOOLS PRIVATE LIMITED",
"KONKAN WIRES PRIVATE LIMITED",
"KONKANBHOOMI FRESH FRUITS PRIVATE LIMITED",
"KONKORE PACKAGING PRIVATE LIMITED",
"KONMENT BUILD LIMITED",
"KONNARK POLYMER PRIVATE LIMITED",
"KONNDOR INDUSTRIES LIMITED",
"KONNECT 9",
"KONNECT CONSULTANCY SERVICES PRIVATE LIMITED",
"KONNECT DIAGNOSTICS (BN REDDY NAGAR) PRIVATE LIMITED",
"KONNECT DIAGNOSTICS (JAGTIAL) PRIVATE LIMITED",
"KONNECT DIAGNOSTICS (SURYAPET) PRIVATE LIMITED",
"KONNECT IMAGING AND DIAGNOSTICS PRIVATE LIMITED",
"KONNECT INFRATECH PRIVATE LIMITED",
"KONNECT PATHLABS PRIVATE LIMITED",
"KONNECTION INDIA DOT COM PRIVATE LIMITED",
"KONNET SOLUTIONS PRIVATE LIMITED",
"KONNI HIRE PURCHASING AND LEASING COMPANY PRIVATE LIMITED",
"KONNICHIWA POLY PRIVATE LIMITED",
"KONPAKRI AGRO INDUSTRIES PVT LTD",
"KONRAD WORLDWIDE INDIA PRIVATE LIMITED .",
"KONSILI TECHNOLOGIES PRIVATE LIMITED",
"KONSTANT INFOSOLUTIONS PRIVATE LIMITED",
"KONSTELEC ENGINEERS LIMITED",
"KONSTELEC ENGINEERS PRIVATE LIMITED",
"KONSTRUCTWELL INDIA VENTURE PRIVATE LIMITED",
"KONSULTERA SOLUTIONS PRIVATE LIMITED",
"KONSULTING ITSM PRIVATE LIMITED",
"KONSULTOO SOFTWARE CONSULTING PRIVATE LIMITED",
"KONSYL PHARMACEUTICALS PRIVATE LIMITED",
"KONTACT CONSORTIUM INDIA PRIVATE LIMITED",
"KONTACT PETRO-CHEM PRIVATE LIMITED",
"KONTERA VENTURES PRIVATE LIMITED",
"KONTEST CHEMICALS LIMITED",
"KONTINENTAL CROSSLINK PRIVATE LIMITED",
"KONTOOR BRANDS INDIA PRIVATE LIMITED",
"KONTOR SPACE LIMITED",
"KONUDA IMPEX PRIVATE LIMITED",
"KONVERGE AI PRIVATE LIMITED",
"KONVERGE TECHNOLOGIES PRIVATE LIMITED",
"KONVERTOR PACKAGING SOLUTIONS PRIVATE LIMITED",
"KONVIO RO SYSTEMS PRIVATE LIMITED",
"KONVIS SOLUTIONS PRIVATE LIMITED",
"KONY INDIA PRIVATE LIMITED",
"KONY IT SERVICES PRIVATE LIMITED",
"KONY MARKETING SERVICES PRIVATE LIMITED",
"KONZEPT ENERGY SERVICES INDIA PRIVATE LIMITED",
"KONZEPT PRE SCHOOL",
"KONZERT TECHNOLOGIES PRIVATE LIMITED",
"KONZERT TOOLINGS PRIVATE LIMITED",
"KOO KOO TV ENTERTAINMENT PRIVATE LIMITED",
"KOOBOX TECH PRIVATE LIMITED",
"KOOCHIE PLAY SYSTEMS PRIVATE LIMITED",
"KOOH SPORTS PRIVATE LIMITED",
"KOOKABURRA EDUCATION PRIVATE LIMITED",
"KOOKABURRA SPORT INDIA PRIVATE LIMITED",
"KOOKIE JAR FOODS PRIVATE LIMITED",
"KOOKMIN BANK",
"KOOKMIN SECURITIES PRIVATE LIMITED",
"KOOL CUT TECHNOLOGIES PRIVATE LIMITED",
"KOOL DROP COOLING TOWERS PRIVATE LIMITED",
"KOOL EX COLD CHAIN LIMITED",
"KOOL HOME BUILDERS PRIVATE LIMITED",
"KOOL INDIA REFRIGERANTS PRIVATE LIMITED",
"KOOL KIDZ PRODUCTS LIMITED",
"KOOL KRAFT ENGINEERS PRIVATE LIMITED",
"KOOL MARKETING INDIA PRIVATE LIMITED",
"KOOL N COMFORT PRIVATE LIMITED",
"KOOL SOLUTIONS INDIA PRIVATE LIMITED",
"KOOL TECH ENTERPRISES",
"KOOLAIR SYSTEMS PRIVATE LIMITED",
"KOOMBER TEA COMPANY PRIVATE LIMITED",
"KOORUS EMBROIDERIES PRIVATE LIMITED",
"KOOSHAL FERTILIZERS PRIVATE LIMITED",
"KOOVS MARKETING CONSULTING PRIVATE LIMITED",
"KOP AGRO TECH LIMITED",
"KOP ENTERPRISES PRIVATE LIMITED",
"KOP MACHINERY PRIVATE LIMITED",
"KOPAL COMPUTERS PRIVATE LIMITED",
"KOPAL HIGHER SECONDARY SCHOOL",
"KOPAL INSTITUTE OF SCIENCE & TECHNOLOGY",
"KOPAL PAPERS PRIVATE LIMITED",
"KOPELL GROUNDING SYSTEMS PRIVATE LIMITED",
"KOPEN TRADING PRIVATE LIMITED",
"KOPERTEK METALS PRIVATE LIMITED",
"KOPI FRESCO PRIVATE LIMITED",
"KOPMELT EXTRUSIONS PRIVATE LIMITED",
"KOPPAL GREEN POWER LIMITED",
"KOPPAL LOGISTICS PRIVATE LIMITED",
"KOPPAL SOLAR POWER PROJECTS PRIVATE LIMITED",
"KOPPAL-NARENDRA TRANSMISSION LIMITED",
"KOPPER PLANT ELECTRIC INDIA PRIVATE LIMITED",
"KOPPERN MACO SERVICES PRIVATE LIMITED",
"KOPPERT BIOLOGICAL SYSTEMS INDIA PRIVATE LIMITED",
"KOPRAN LAB LIMITED",
"KOPRAN LIMITED",
"KOPRAN RESEARCH LABORATORIES LIMITED",
"KOPS INTERNATIONAL LIMITED",
"KOPS OUTSOURCING SOLUTIONS PRIVATE LIMITED",
"KOPS TECHNOLOGY PRIVATE LIMITED",
"KOPYBRIGHT INDIA LIMITED",
"KOPYBRIGHT INDIA PRIVATE LIMITED",
"KORA CAFE PRIVATE LIMITED",
"KORA PACK PRIVATE LIMITED",
"KORA SHOES PRIVATE LIMITED",
"KORALS ENGINEERING SOLUTIONS PRIVATE LIMITED",
"KORAMANGALA PROPERTIES LIMITED",
"KORAMBAYIL HOSPITAL AND DIAGNOSTIC CENTRE PVT LTD",
"KORANGANI TEA COMPANY PRIVATE LIMITED",
"KORANNE CONSULTANTS PRIVATE LIMITED",
"KORBA METAL & CONDUCTORS PVT LTD",
"KORCOMPTENZ CONSULTANCY PRIVATE LIMITED",
"KORDE ELECTRICALS AND ELECTRONICS PRIVATE LIMITED",
"KORDIA HVAC SYSTEMS PRIVATE LIMITED",
"KORE DIGITAL LIMITED",
"KORE MINING AND CRUSHING PRIVATE LIMITED",
"KORE SECURITY SERVICES PRIVATE LIMITED",
"KORE TRADECOM PRIVATE LIMITED",
"KORE.AI SOFTWARE INDIA PRIVATE LIMITED",
"KORE1 MANPOWER SOLUTION PRIVATE LIMITED",
"KOREA ELECTRIC POWER CORPORATION",
"KOREA FUEL-TECH INDIA PRIVATE LIMITED",
"KOREA TRADE-INVESTMENT PROMOTION AGENCY",
"KOREAN AIRLINES CO LIMITED",
"KOREBI GOURMET PRIVATE LIMITED",
"KORECENT SOLUTIONS PRIVATE LIMITED",
"KORED INFRATECH PRIVATE LIMITED",
"KOREIOT SOLUTIONS PRIVATE LIMITED",
"KORERO CREATIVE HOUSE PRIVATE LIMITED",
"KORES (INDIA) LIMITED",
"KORFEZBANK",
"KORI FACILITY PRIVATE LIMITED",
"KORI MERCANTILE PRIVATE LIMITED",
"KORIYA INFRA PRIVATE LIMITED",
"KORLOY INDIA TOOLING PRIVATE LIMITED",
"KORN /FERRY INTERNATIONAL PRIVATE LIMITED",
"KORNICH EXPORTS PRIVATE LIMITED",
"KORON PROJECTS LIMITED",
"KOROVA MILK PRODUCT PRIVATE LIMITED",
"KORP RESOURCES PVT LTD",
"KORPOLE HEALTHCARE PRIVATE LIMITED",
"KORPORATE BIZMAX LIMITED",
"KORPORATE FACILITY MANAGEMENT PRIVATE LIMITED",
"KORROCOAT POLYMERS PRIVATE LIMITED",
"KORTAS INDUSTRIES PRIVATE LIMITED",
"KORTEN PHARMACEUTICALS PRIVATE LIMITED",
"KORU UX DESIGN LLP",
"KORUS DESIGN & SKILL FORUM",
"KORUS ENGINEERING SOLUTIONS PRIVATE LIMITED",
"KORUTECH INDIA PRIVATE LIMITED.",
"KORVIE AGRO PRIVATE LIMITED",
"KOS LO SOLUTIONS PRIVATE LIMITED",
"KOSAMATTAM FINANCE LIMITED",
"KOSAMATTAM VENTURES PRIVATE LIMITED",
"KOSAMBA GLASS DECO PRIVATE LIMITED",
"KOSAN CRISPLANT INDIA PRIVATE LIMITED",
"KOSAN INDUSTRIES PRIVATE LIMITED",
"KOSAN SFPL PROJECTS INDIA PRIVATE LIMITED",
"KOSANA CONSULTANTS AND DIGITAL SERVICES PRIVATE LIMITED",
"KOSAVI INDUSTRIES PRIVATE LIMITED",
"KOSBROS MACHINE TOOLS PRIVATE LIMITED",
"KOSCA DEP INDIA PRIVATE LIMITED",
"KOSCA DISTRIBUTION LLP",
"KOSE CORPORATION INDIA PRIVATE LIMITED",
"KOSEI MINDA ALUMINUM COMPANY PRIVATE LIMITED",
"KOSEI MINDA MOULD PRIVATE LIMITED",
"KOSEL INDUSTRIES INDIA LIMITED",
"KOSHA CHEMTECH PRIVATE LIMITED",
"KOSHA FINE JEWELS PRIVATE LIMITED",
"KOSHAL CERAMICS PRIVATE LIMITED",
"KOSHAL POLY PACK",
"KOSHALA AUTOMOBILES PRIVATE LIMITED",
"KOSHALA ENTERPRISES PRIVATE LIMITED",
"KOSHAMBH MULTITRED PRIVATE LIMITED",
"KOSHBIO PRIVATE LIMITED",
"KOSHER CLIMATE INDIA PRIVATE LIMITED",
"KOSHER CONSTRUCTION PRIVATE LIMITED",
"KOSHER ORGANICS PRIVATE LIMITED",
"KOSHER TISSUE PRODUCTS PRIVATE LIMITED",
"KOSHI AGRO BIOTECH PRIVATE LIMITED",
"KOSHIKA PLYWOOD PRIVATE LIMITED",
"KOSHINO FASHIONS PRIVATE LIMITED",
"KOSHISH IMPEX PRIVATE LIMITED",
"KOSHISH MARKETING SOLUTIONS PRIVATE LIMITED",
"KOSHYMA ENGINEERING PRIVATE LIMITED",
"KOSI AUTOMOBILES PRIVATE LIMITED",
"KOSI BRIDGE INFRASTRUCTURE COMPANY LIMITED.",
"KOSMETICS LANE PRIVATE LIMITED",
"KOSMETIKA (DELHI) PVT LTD",
"KOSMIC FILM ENTERTAINMENT COMPANY PRIVATE LIMITED",
"KOSMIC HITECH MOTORS PRIVATE LIMITED",
"KOSMO ONE BUSINESS PARK LIMITED",
"KOSMO ONE BUSINESS PARK PRIVATE LIMITED",
"KOSMO PLASTIC EXPORTS PRIVATE LIMITED",
"KOSMO VEHICLES PRIVATE LIMITED",
"KOSMOCHEM PRIVATE LIMITED",
"KOSMODERMA HEALTHCARE PRIVATE LIMITED",
"KOSMOS INDIA EVENTS PRIVATE LIMITED",
"KOSMOSYS SOLUTIONS PRIVATE LIMITED",
"KOSO INDIA PRIVATE LIMITED",
"KOSOL ENERGIE PRIVATE LIMITED",
"KOSONS INDUSTRIES",
"KOSSHER INFRA SERVICES PRIVATE LIMITED",
"KOST LOGISTICS CONSULTANTS FREIGHT INDIA PRIVATE LIMITED",
"KOSTAL INDIA PRIVATE LIMITED",
"KOSTAL PHARMA LABS PRIVATE LIMITED",
"KOSTWEIN INDIA COMPANY PRIVATE LIMITED",
"KOSURI BALAJI AGRO FOODS PRIVATE LIMITED",
"KOSUT BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"KOTA AGROPROTIENS PRIVATE LIMITED",
"KOTA AUTOMOBILES PRIVATE LIMITED",
"KOTA CAREER POINT SR SEC SCHOOL",
"KOTA EARTHMOVERS AND HYDRAULICS PRIVATE LIMITED",
"KOTA ELECTRICITY DISTRIBUTION LIMITED",
"KOTA HEART INSTITUTE & R.C",
"KOTA HEART INSTITUTE PRIVATE LIMITED",
"KOTA INDUSTRIAL PRODUCTS PRIVATE LIMITED",
"KOTA JEWELLERS PRIVATE LIMITED",
"KOTA METCHEM PRIVATE LIMITED",
"KOTA MIXCRETE PRIVATE LIMITED",
"KOTA OXYGEN PRIVATE LIMITED",
"KOTA SAMPANNA AGRO PRODUCER COMPANY LIMITED",
"KOTA TAPES (INDIA) PRIVATE LIMITED",
"KOTA TRUCKS PRIVATE LIMITED",
"KOTAH WALAS EXPORTS PVT LTD",
"KOTAK AGRO PROCESSING PRIVATE LIMITED",
"KOTAK COMMODITY SERVICES PRIVATE LIMITED",
"KOTAK EDUCATION FOUNDATION",
"KOTAK GINNING AND PRESSING INDUSTRIES PRIVATE LIMITED",
"KOTAK GLOBAL LOGISTICS PRIVATE LIMITED",
"KOTAK INFRASTRUCTURE DEBT FUND LIMITED",
"KOTAK ALTERNATE ASSET MANAGERS LIMITED",
"KOTAK LIFE SCIENCES",
"KOTAK MAHINDRA ASSET MANAGEMENT COMPANY",
"KOTAK MAHINDRA BANK LIMITED",
"KOTAK MAHINDRA CAPITAL COMPANY LIMITED",
"ZURICH KOTAK GENERAL INSURANCE COMPANY (INDIA) LIMITED",
"KOTAK MAHINDRA INVESTMENTS LIMITED",
"KOTAK MAHINDRA LIFE INSURANCE COMPANY LIMITED",
"KOTAK MAHINDRA PENSION FUND LIMITED",
"KOTAK MAHINDRA PRIME LIMITED",
"KOTAK MAHINDRA TRUSTEE COMPANY LIMITED",
"KOTAK MAHINDRA TRUSTEESHIP SERVICES LIMITED",
"KOTAK OVERSEAS PRIVATE LIMITED",
"KOTAK PETRO-CHEM PRIVATE LIMITED",
"KOTAK SECURITIES LIMITED",
"KOTAK URJA PRIVATE LIMITED",
"KOTARKI CONSTRUCTIONS PRIVATE LIMITED",
"KOTAWALA CREATIONS PRIVATE LIMITED",
"KOTBAGI HOSPITAL",
"KOTEC AUTOMOTIVE SERVICES INDIA PRIVATE LIMITED",
"KOTECHA CLEARING AND FORWARDING PRIVATE LIMITED",
"KOTECHA STEEL FORGE AND CAST INDUSTRIES PRIVATE LIMITED",
"KOTEMODA LIFESTYLE PRIVATE LIMITED",
"KOTESHWAR CHEMFOOD INDUSTRIES PRIVATE LIMITED",
"KOTESHWAR FABRIC MILL PRIVATE LIMITED",
"KOTESHWAR MARKETING PRIVATE LIMITED",
"KOTHAMANGALAM AGGREGATES PRIVATE LIMITED",
"KOTHARE VISION PRIVATE LIMITED",
"KOTHARI & SONS JEWELS INDIA PRIVATE LIMITED",
"KOTHARI AGRITECH PRIVATE LIMITED",
"KOTHARI ART JEWEL PRIVATE LIMITED",
"KOTHARI ASSOCIATES PVT LTD",
"KOTHARI AUTO LINK PRIVATE LIMITED",
"KOTHARI BROTHERS TECH PRIVATE LIMITED",
"KOTHARI CARS PRIVATE LIMITED",
"KOTHARI COMMERCIAL CONCERN PRIVATE LIMITED",
"KOTHARI CORPORATION",
"KOTHARI COTEX PRIVATE LIMITED",
"KOTHARI COTSYN PRIVATE LIMITED",
"KOTHARI CREDIT (INDIA) LIMITED",
"KOTHARI DIAGNOSTICS PRIVATE LIMITED",
"KOTHARI DIAMOND INDUSTRIES PRIVATE LIMITED",
"KOTHARI ELECTRIC SERVICES PRIVATE LIMITED",
"KOTHARI ENTERPRISES PVT LTD",
"KOTHARI ETEKNOLOGIC PRIVATE LIMITED",
"KOTHARI EXIM (INDIA) PRIVATE LIMITED",
"KOTHARI FABTEX PRIVATE LIMITED",
"KOTHARI FERMENTATION AND BIOCHEM LIMITED",
"KOTHARI FERRO METALIKS PRIVATE LIMITED",
"KOTHARI FILAMENTS PRIVATE LIMITED",
"KOTHARI FNALEX LIMITED",
"KOTHARI HOSIERY FACTORY PVT LTD",
"KOTHARI INDUSTRIAL CORPORATION LIMITED",
"KOTHARI INFOTECH PRIVATE LIMITED",
"KOTHARI INTERNATIONAL SCHOOL",
"KOTHARI INVESTMENT & INDUSTRIES PVT LTD",
"KOTHARI M LAND DEVELOPERS PRIVATE LIMITED",
"KOTHARI MADRAS INTERNATIONAL LTD.",
"KOTHARI MEDICAL & SURGICALS",
"KOTHARI MEDICAL CENTRE",
"KOTHARI MEDICAL HOSPITAL",
"KOTHARI MERCANTILES PVT LTD",
"KOTHARI METAL RESOURSES PVT LTD",
"KOTHARI METAL WORKS PRIVATE LIMITED",
"KOTHARI METALS LIMITED",
"KOTHARI METSOL PRIVATE LIMITED",
"KOTHARI PETROCHEMICALS LIMITED",
"KOTHARI PHARMA TECHNOLOGIES PRIVATE LIMITED",
"KOTHARI PHYTOCHEMICALS & INDUSTRIES LIMITED",
"KOTHARI PHYTOCHEMICALS & INDUSTRIES LTD",
"KOTHARI POLYESTER PRIVATE LIMITED",
"KOTHARI POWER SOLUTIONS PRIVATE LIMITED",
"KOTHARI PROCESSORS PRIVATE LIMITED",
"KOTHARI PRODUCTS LIMITED",
"KOTHARI PROJECTS PRIVATE LIMITED",
"KOTHARI RAYONS PRIVATE LIMITED",
"KOTHARI RETAIL PRIVATE LIMITED",
"KOTHARI SAFE DEPOSITS LIMITED",
"KOTHARI SPORTS AND APPARELS PRIVATE LIMITED",
"KOTHARI SUGARS AND CHEMICALS LIMITED",
"KOTHARI SYNTEX PRIVATE LIMITED",
"KOTHARI TEXPRINT PRIVATE LIMITED",
"KOTHARI TEXTILES PRIVATE LIMITED",
"KOTHARI TIMBERS PRIVATE LIMITED",
"KOTHARI TUBES PVT LTD",
"KOTHARI UNIFORMS PRIVATE LIMITED",
"KOTHARI WOOLLENS PVT.LTD.",
"KOTHARI WORLD FINANCE LIMITED",
"KOTHARISHAH TEXTURISERS PRIVATE LIMITED",
"KOTHAVALSA INFRAVENTURES PRIVATE LIMITED",
"KOTHI STEEL LIMITED",
"KOTHIWAL HEALTHCARE PRIVATE LIMITED",
"KOTHUR LOGISTICS PARK PRIVATE LIMITED",
"KOTI PLASTIC PROCESSING MACHINERY PRIVATE LIMITED",
"KOTI RESORTS LIMITED",
"KOTI WOMENS COLLEGE",
"KOTIA TRANSFORMERS PRIVATE LIMITED",
"KOTIBHASKAR INFRASTRUCTURES & DEVELOPERS PRIVATE LIMITED",
"KOTILINGESWARA AGRI PRODUCTS PRIVATE LIMITED",
"KOTIRATAN NIKETAN PRIVATE LIMITED",
"KOTKAR ENERGY DYNAMICS P LIMITED",
"KOTLA HYDRO POWER PRIVATE LIMITED",
"KOTLA RENEWABLES PRIVATE LIMITED",
"KOTLEE CREATION PRIVATE LIMITED",
"KOTLEE TEXTILE INDUSTRIES PRIVATE LIMITED",
"KOTS FOOD AND PACKAGING PRIVATE LIMITED",
"KOTS HOUSING PRIVATE LIMITED",
"KOTSON IT SOLUTIONS PRIVATE LIMITED",
"KOTSON PROJECTS PRIVATE LIMITED",
"KOTSONS PRIVATE LIMITED",
"KOTT SOFTWARE PRIVATE LIMITED",
"KOTTA ENTERPRISES PRIVATE LIMITED",
"KOTTACKAL AGRO FOODS",
"KOTTAI BENEFIT FUND NIDHI LIMITED",
"KOTTAKKAL GOLD PRIVATE LIMITED",
"KOTTARAM AGENCIES AND DISTRIBUTORS (INDIA) PRIVATE LIMITED",
"KOTTARAM CLOTHING INDIA PRIVATE LIMITED",
"KOTTARAM HOTELS PRIVATE LIMITED",
"KOTTAYAM CABLE CHANNEL DISTRIBUTORS PRIVATE LIMITED",
"KOTTAYAM DISTRICT CO-OP BANK",
"KOTTAYAM FOREX SERVICES PRIVATE LIMITED",
"KOTTEX INDUSTRIES PRIVATE LIMITED",
"KOTTIYOOR METALS PRIVATE LIMITED",
"KOTTONWORLD EXPORT IMPORT (INDIA) PVT LTD",
"KOTTUKULAM ENGINEER PRIVATE LIMITED",
"KOTTY LIFESTYLE PRIVATE LIMITED",
"KOTWALA ENTERPRISE PRIVATE LIMITED",
"KOTWA-MUZAFFARPUR TOLLWAY PRIVATE LIMITED",
"KOTWAN POLYMERS PRIVATE LIMITED",
"KOTYARK INDUSTRIES LIMITED",
"KOU CHAN KNOWLEDGE CONVERGENCE",
"KOU-CHAN TECHNOLOGIES PRIVATE LIMITED",
"KOUNDANYA REALTORS PRIVATE LIMITED",
"KOUNDINYA MARKETING PRIVATE LIMITED",
"KOUPER LUBRICANTS PRIVATE LIMITED",
"KOUSAR GLASS PRIVATE LIMITED",
"KOUSHALYA INDUSTRIES PRIVATE LIMITED",
"KOUSHIC PRESSURE VESSELS PRIVATE LIMITED",
"KOUSHIKA ENTERPRISES PRIVATE LIMITED",
"KOUSTHUBA SPINNERS PRIVATE LIMITED",
"KOUSTUV INSTITUTE OF SELF DOMAIN KISD",
"KOUTILYA SUPER MARKETS PRIVATE LIMITED",
"KOUZINA FOOD TECH PRIVATE LIMITED",
"KOUZINA HOSPITALITY PRIVATE LIMITED",
"KOVA FASTENERS PRIVATE LIMITED",
"KOVAI BUILDERS AND PROPERTY DEVELOPERS PRIVATE LIMITED",
"KOVAI ELITE FURNITURE PRIVATE LIMITED",
"KOVAI ENGINEERING WORKS PRIVATE LIMITED",
"KOVAI HEART FOUNDATION PRIVATE LIMITED",
"KOVAI HILLS EDINFRA PRIVATE LIMITED",
"KOVAI KALAIMAGAL ART SCI COLL -641049",
"KOVAI LIFESTYLE PRIVATE LIMITED",
"KOVAI MARUTHI PAPERS AND BOARDS PRIVATE LIMITED",
"KOVAI MEDIA PRIVATE LIMITED",
"KOVAI MEDICAL CENTER AND HOSPITAL LIMITED",
"KOVAI PURANI FINANCE PRIVATE LIMITED",
"KOVAI RACKS INDIA PRIVATE LIMITED",
"KOVAI SILVER PRIVATE LIMITED",
"KOVAI SYSTEMS INDIA PRIVATE LIMITED",
"KOVAI VIDYASHRAM",
"KOVAION CONSULTING INDIA PRIVATE LIMITED",
"KOVAIR SOFTWARE PRIVATE LIMITED",
"KOVAISAMBANDAM YARN MILLS PRIVATE LIMITED",
"KOVALAM INVESTMENT AND TRADING COMPANY LIMITED",
"KOVAN TECHNOLOGY LABS INDIA PRIVATE LIMITED",
"KOVAX ABRASIVES SOUTH ASIA PRIVATE LIMITED",
"KOVEL ENGINEERING PRIVATE LIMITED",
"KOVERHOOP TECHNOLOGIES INDIA PRIVATE LIMITED",
"KOVID GROUP ANALYTICS INDIA PRIVATE LIMITED",
"KOVILAKAM CRUSHERS PRIVATE LIMITED",
"KOVILAKAM HOTELS PRIVATE LIMITED",
"KOVILAKAM RESIDENCY PRIVATE LIMITED",
"KOVILPATTI LAKSHMI ROLLER FLOUR MILLS LIMITED",
"KOVVUR MANDAL FARMERS PRODUCER COMPANY LIMITED",
"KOWA INDIA PRIVATE LIMITED",
"KOWENTUSH MEDLABS PRIVATE LIMITED",
"KOWEY CONVEYING TECHNOLOGY ENGINEERING PRIVATE LIMITED",
"KOWLEY POLYMERS P LTD",
"KOX HOSIERY PRIVATE LIMITED",
"KOX MED & LABS PRIVATE LIMITED",
"KOYA AND COMPANY CONSTRUCTION LIMITED",
"KOYA COLD STORAGE PRIVATE LIMITED",
"KOYAMA PRECISION WORKS INDIA PRIVATE LIMITED",
"KOYAS FASTENERS PRIVATE LIMITED",
"KOYAS PERFUMERY AND PHARMA PRIVATE LIMITED",
"KOYASON BUILDING MATERIALS PRIVATE LIMITED",
"KOYKA ELECTRONICS PRIVATE LIMITED",
"KOYNA DESIGN DIVISION PUNE",
"KOYNA ENERGY PRIVATE LIMITED",
"KOYNA ENGINEERS PVT LTD",
"KOYNA PROJECT PUNE",
"KOYO BEARINGS INDIA PRIVATE LIMITED",
"KOYO ELECTRONICS INDIA PRIVATE LIMITED",
"KOYO FASHIONS PRIVATE LIMITED",
"KOYO SMS INDIA PRIVATE LIMITED",
"KOYTUR FISH FARMING PRIVATE LIMITED",
"KOZENT TEC PRIVATE LIMITED",
"KOZHIKODE CABLE COMMUNICATORS LIMITED",
"KOZHIKODE RUBBERS PRIVATE LIMITED",
"KOZON INDIA SOLUTIONS (OPC) PRIVATE LIMITED",
"KOZZBY CONSTRUCTIONS PRIVATE LIMITED",
"KOZZBY TECHTEX PRIVATE LIMITED",
"KP ABRASIVES PRIVATE LIMITED",
"KP CAPITAL ADVISORS PRIVATE LIMITED",
"KP CORPORATE SOLUTIONS LIMITED",
"KP DIGITAL PRIVATE LIMITED",
"KP GEMS PRIVATE LIMITED",
"KP GREEN ENGINEERING LIMITED",
"KP HEALTHCARE PRIVATE LIMITED",
"KP INSTITUTE OF MEDICAL SCIENCES",
"KP LOGISTICS PRIVATE LIMITED",
"KP METALS PRIVATE LIMITED",
"KP PAN PRODUCTS PRIVATE LIMITED",
"KP POLYOLEFIN SACKS PRIVATE LIMITED",
"KP PRIME ASSETS PRIVATE LIMITED",
"KP RELIABLE TECHNIQUE INDIA PRIVATE LIMITED",
"KP SANGHVI & SONS LLP",
"KP SANGHVI JEWELS PRIVATE LIMITED",
"KP SHAH ENTERPRISE PRIVATE LIMITED",
"KP TECH MACHINE (INDIA) PRIVATE LIMITED",
"KP TECH NONWOVEN INDIA PRIVATE LIMITED",
"KP TECHNOBUILD PRIVATE LIMITED",
"KP WATER TREATMENT PRIVATE LIMITED",
"KPA GLOBAL PRIVATE LIMITED",
"K-PACK SYSTEMS PRIVATE LIMITED",
"KPADITYACO PRIVATE LIMITED",
"KPALLY SALES PRIVATE LIMITED",
"KPAR LED PRIVATE LIMITED",
"KPC BUILDERS PRIVATE LIMITED",
"KPC CREATIONS PRIVATE LIMITED",
"KPC FLEXI TUBES PRIVATE LIMITED",
"KPC GAS POWER CORPORATION LIMITED",
"KPC MEDICAL COLLEGE & HOSPITAL",
"KPC MULTISPECIALITY HOSPITAL PRIVATE LIMITED",
"KPC OLD GOLD PURCHASE STORE PRIVATE LIMITED",
"KPC PROJECTS LIMITED",
"KPCORP CONSULTANTS PRIVATE LIMITED",
"KPD IMPEX PRIVATE LIMITED",
"KPDK BUILDTECH PRIVATE LIMITED",
"KPDN INFO TECH PRIVATE LIMITED",
"KPE PRIVATE LIMITED",
"KPF ENGINEERS PRIVATE LIMITED",
"KPF LIFESCIENCES PRIVATE LIMITED",
"KPF PRIVATE LIMITED",
"KPG COTTSPINN INDIA PRIVATE LIMITED",
"KPG FOODS LIMITED",
"KPG SOLUTIONS PRIVATE LIMITED",
"KPGS WEB PRIVATE LIMITED",
"KPH CIVIL WORKS PRIVATE LIMITED",
"KPH COSMOS PRIVATE.LIMITED.",
"KPH FABRICS PRIVATE LIMITED",
"KPI GREEN ENERGY LIMITED",
"KPI PARTNERS INDIA PRIVATE LIMITED.",
"KPIG ENERGIA PRIVATE LIMITED",
"KPISOFT TECHNOLOGIES PRIVATE LIMITED",
"KPIT TECHNOLOGIES LIMITED",
"KPI-TECH SERVICES PRIVATE LIMITED",
"KPJ CONSTRUCTIONS PRIVATE LIMITED",
"KPJ INFRACOM PRIVATE LIMITED",
"KPK FASERV INDIA PRIVATE LIMITED",
"KPK GOLDEN IMPEX PRIVATE LIMITED",
"KPL EQUIPMENTS PRIVATE LIMITED",
"KPL EXPORTS PRIVATE LIMITED",
"KPL INTERNATIONAL LIMITED",
"KPL TECH SOLUTION PRIVATE LIMITED",
"KPLUS INFOTECH PRIVATE LIMITED",
"KPM DESIGN SERVICES PRIVATE LIMITED",
"KPM DEVELOPERS PRIVATE LIMITED",
"KPM INFRASTRUCTURE PRIVATE LIMITED",
"KPM PROCESSING MILL PRIVATE LIMITED",
"KPMC TECHNOLOGY LIMITED",
"KPMD SOFTWARE SOLUTIONS PRIVATE LIMITED",
"KPMG ADVISORY SERVICES PRIVATE LIMITED",
"KPMG ASSURANCE AND CONSULTING SERVICES LLP",
"KPMG GLOBAL DELIVERY CENTER PRIVATE LIMITED",
"KPMG GLOBAL SERVICES MANAGEMENT PRIVATE LIMITED",
"KPMG GLOBAL SERVICES PRIVATE LIMITED",
"KPMG INDIA",
"KPMG INDIA SERVICES LLP",
"KPMG RESOURCE CENTRE PRIVATE LIMITED",
"KPN FARM FRESH PRIVATE LIMITED",
"KPN LABELS PRIVATE LIMITED",
"KPNR INFRA PROJECTS PRIVATE LIMITED",
"KPOINT TECHNOLOGIES PRIVATE LIMITED",
"KPONG APPARELS PRIVATE LIMITED",
"KPR FINANCE PRIVATE LIMITED",
"KPR INDUSTRIES INDIA LIMITED",
"KPR INSTITUTE OF ENGINEERING AND TECHNOLOGY",
"KPR LIFE SCIENCES AND RESEARCH PRIVATE LIMITED",
"KPR SUGAR AND APPARELS LIMITED",
"KPR TECHNO SOFTWARE SOLUTIONS PRIVATE LIMITED",
"KPR TRADECOM PRIVATE LIMITED",
"K-PRA FOODS PRIVATE LIMITED",
"KPRBSK REALTORS PRIVATE LIMITED",
"KPRV MANAGEMENT SERVICES PRIVATE LIMITED",
"KPS ALUMINIUM AND GLASS PRIVATE LIMITED",
"KPS FORGE (INDIA) PRIVATE LIMITED",
"KPS GUARDING SYSTEMS PRIVATE LIMITED",
"KPS INDIA PRIVATE LIMITED",
"KPS PRODUCTS PRIVATE LIMITED",
"KPS STRUCTURE MAKERS PRIVATE LIMITED",
"KPS TRONICS INDIA PRIVATE LIMITED",
"KPSH ENTERPRISES LLP",
"KPSL ITECHPATH PRIVATE LIMITED",
"KPSN CONSULTING LLP",
"KPSS BUILDERS PVT LTD",
"KPT INDUSTRIES LIMITED",
"KPT PIPING SYSTEM PRIVATE LIMITED",
"KPT STAINLESS STEEL PRIVATE LIMITED",
"KPTCL",
"KPTOOLS PRIVATE LIMITED",
"KPV POWERCON ENGINEERING SERVICES PRIVATE LIMITED",
"KPW FINSERV PRIVATE LIMITED",
"KPX CHEMICAL INDIA PRIVATE LIMITED",
"KR BEDMUTHA TECHNO ASSOCIATES PRIVATE LIMITED",
"KR INN PRIVATE LIMITED",
"KR LIFESCIENCES PRIVATE LIMITED",
"KR LOGISTIC & CONSTRUCTION PRIVATE LIMITED",
"KR MANGALAM UNIVERSITY",
"KR MOTORS KOLHAPUR PRIVATE LIMITED",
"KR MROADS INDIA PRIVATE LIMITED",
"KR NETWORK CLOUD TECHNOLOGIES PRIVATE LIMITED",
"KR PHARMA CAPS PRIVATE LIMITED",
"KR POLYMERS PRIVATE LIMITED",
"KR POWER INFRA (INDIA) PRIVATE LIMITED",
"KR SCHOOL OF NURSING",
"KR TOURIST SERVICES PRIVATE LIMITED",
"KRA INFRASTRUCTURE DEVELOPERS PRIVATE LIMITED",
"KRAB MEDIA AND MARKETING PRIVATE LIMITED",
"KRADLE STORE PRIVATE LIMITED",
"KRAFF SOFTWARE PRIVATE LIMITED",
"KRAFT ACCESSORIES PRIVATE LIMITED",
"KRAFT AUTO PRIVATE LIMITED",
"KRAFT BOX CONTAINERS INDIA PRIVATE LIMITED",
"KRAFT BOX PVT LTD",
"KRAFT BPO SOLUTIONS PRIVATE LIMITED",
"KRAFT CONVERTERS (INDIA) PRIVATE LIMITED",
"KRAFT OUTDOOR MEDIA PRIVATE LIMITED",
"KRAFT PACK EXPORTS INDIA PRIVATE LIMITED",
"KRAFT POWERCON INDIA LIMITED",
"KRAFT PRINT N PACK PRIVATE LIMITED",
"KRAFT SALES AND SERVICES INDIA LIMITED",
"KRAFTCONS PRIVATE LIMITED",
"KRAFTDECOR SERVICES PRIVATE LIMITED",
"KRAFTEX TRADING PRIVATE LIMITED",
"KRAFTING NETWORKS",
"KRAFTINN HOME DECOR INDIA PRIVATE LIMITED",
"KRAFTLAND CONSULTS PRIVATE LIMITED",
"KRAFTMAID SERVICES INDIA PRIVATE LIMITED",
"KRAFTON INDIA PRIVATE LIMITED",
"KRAFTPIXEL DIGITAL SOLUTIONS PRIVATE LIMITED",
"KRAFTPOWERCON POWER PRODUCTS PRIVATE LIMITED",
"KRAFTPRO MARKETING PRIVATE LIMITED",
"KRAFTS PRINTOGRAPHICS PRIVATE LIMITED",
"KRAFTSMAN TOOLING PRIVATE LIMITED",
"KRAFTWARES (INDIA) PRIVATE LIMITED",
"KRAFTWOOD DECOR PRIVATE LIMITED",
"KRAFTWORK SOLAR PRIVATE LIMITED",
"KRAIBURG TPE PRIVATE LIMITED",
"KRAM INFRACON PRIVATE LIMITED",
"KRAMA ENTERPRISES PRIVATE LIMITED",
"KRAMER ELECTRONICS INDIA PRIVATE LIMITED",
"KRAMMER BIOSCIENCE INDIA PRIVATE LIMITED",
"KRAMOFIRE MANUFACTURER AND TRADER PRIVATE LIMITED",
"KRAMP UK LTD",
"KRAMSKI STAMPING AND MOLDING INDIA PRIVATE LIMITED",
"KRAN CONSULTING PRIVATE LIMITED",
"KRAN RADER PRIVATE LIMITED",
"KRANE OPERATION AND MAINTENANCE TECHNOLOGY SERVICES PRIVATE LIMITED",
"KRANNICH SOLAR PRIVATE LIMITED",
"KRANO BLOCK PVT LTD",
"KRANS PROJECTS PRIVATE LIMITED",
"KRANTHI JR DEGREE COLLEGES",
"KRANTI COTTON AND OIL INDUSTRIES",
"KRANTI INDUSTRIES LIMITED",
"KRANTI INFRA POWER PRIVATE LIMITED",
"KRANTI JYOTI FOODS PRIVATE LIMITED",
"KRANTI MERCANTILE LIMITED",
"KRANTI METALLURGY PVT LTD",
"KRANTI METALS PRIVATE LIMITED",
"KRANTI NURSING SCHOOL",
"KRANTI POLYTECH PRIVATE LIMITED",
"KRANTI ROAD TRANSPORT PVT LTD",
"KRANTI SOAPS PVT LTD",
"KRANTI WINES PVT LTD",
"KRANTIAGRANI DR G D BAPU LAD SAHAKARI SAKHAR KARKHANA LTD KUNDAL",
"KRANTIJYOTI AGRO PRODUCER COMPANY LIMITED",
"KRANTIVEER CONSTRUCTION INDIA PRIVATE LIMITED",
"KRANTIVEER LAHUJI WASTAD SELVE EKTA PRATISHTHAN",
"KRAS PHARMACEUTICALS PRIVATE LIMITED",
"KRASHIKA DISTRIBUTORS KHANDWA",
"KRASHMI ENTERPRISES PRIVATE LIMITED",
"KRASKA ZONE TRAINING PRIVATE LIMITED",
"KRASNY DEFENCE TECHNOLOGIES LIMITED",
"KRASOMA BIOCHEM PRIVATE LIMITED",
"KRATEE SHOPPING SOLUTION PRIVATE LIMITED",
"KRATIKA WORKFORCE SECURITY SERVICES PRIVATE LIMITED",
"KRATIKAL TECH PRIVATE LIMITED",
"KRATIN SOFTWARE SOLUTIONS PRIVATE LIMITED",
"KRATM ASSOCIATES PRIVATE LIMITED",
"KRATOS CAPITAL ADVISORS PRIVATE LIMITED",
"KRATOS FOODS PRIVATE LIMITED",
"KRATOS IMPEX LIMITED",
"KRATUS SOLAR SOLUTIONS PRIVATE LIMITED",
"KRAUSE BIAGOSCH INDIA PRIVATE LIMITED",
"KRAUTER HEALTHCARE LIMITED",
"KRAVOUR FOODS PRIVATE LIMITED",
"KRAWLER INFORMATION SYSTEMS PRIVATE LIMITED",
"KRAYONS INTERIOR SYSTEMS PRIVATE LIMITED",
"KRAZY MANTRA HR SOLUTIONS PRIVATE LIMITED",
"KRAZY MANTRA IT PRIVATE LIMITED",
"KRAZYBEE SERVICES PRIVATE LIMITED",
"KRAZYFOX TECHNOLOGY PRIVATE LIMITED",
"KRAZYKIDS FOOD PRIVATE LIMITED",
"KRAZYTECH BUSINESS SOLUTIONS PRIVATE LIMITED",
"KRB FOOTWEAR PRIVATE LIMITED",
"KRB IMPEX (OPC) PRIVATE LIMITED",
"KRB INNOVATIONS",
"KRBL FOODS LIMITED",
"KRBL INFRASTRUCTURE LIMITED",
"KRBL LIMITED",
"KRC INFRASTRUCTURE AND PROJECTS PRIVATE LIMITED",
"KRCHOKSEY FINANCIAL SERVICES PRIVATE LIMITED",
"KRCHOKSEY SHARES AND SECURITIES PRIVATE LIMTED",
"KRD EXPORTS PRIVATE LIMITED",
"KRDB ENTERPRISES PRIVATE LIMITED",
"KRDS SOFTWARE DEVELOPMENT PRIVATE LIMITED",
"KREA EKNOWLEDGE PRIVATE LIMITED",
"KREA FOODS AND BEVERAGES PRIVATE LIMITED",
"KREA UNIVERSITY",
"KREARA SOLUTIONS PRIVATE LIMITED",
"KREATA GLOBAL DIGITAL MEDIA SERVICES PRIVATE LIMITED",
"KREATE ENERGYI PRIVATE LIMITED",
"KREATE GREEN ENERGY PRIVATE LIMITED",
"KREATION HANDICRAFTS",
"KREATION HANDICRATS",
"KREATIV ENGINEERING SOLUTION",
"KREATIV TOOLING SOLUTIONS PRIVATE LIMITED",
"KREATIVE INDEX INTERIOR DESIGNS PRIVATE LIMITED",
"KREATIVE ORGANICS PRIVATE LIMITED",
"KREATIVE RAINBOWBLISS LOGISTICS PRIVATE LIMITED",
"KREATIVE TECHNOMATION PRIVATE LIMITED",
"KREATIVEAD VISION PRIVATE LIMITED",
"KREATIVSARG TECHNOLOGY SOLUTIONS LLP",
"KREAYOTOO SOLUTIONS PRIVATE LIMITED",
"KREBS & RIEDEL ABRASIVES INDIA PRIVATE LIMITED",
"KREBS BIOCHEMICALS AND INDUSTRIES LIMITED",
"KREBS INTERNATIONAL LIMITED",
"KREBZ HEALTHCARE PRIVATE LIMITED",
"KREDENCE BUSINESS ADVISORY PRIVATE LIMITED",
"KREDENCE MULTI TRADING LIMITED",
"KREDENCE PERFORMANCE MATERIALS (INDIA) PRIVATE LIMITED",
"KREDENT CAPITAL PRIVATE LIMITED",
"KREDENT HOLDINGS PRIVATE LIMITED",
"KREDENT INFOEDGE PRIVATE LIMITED",
"KREDENT TRADING LLP",
"KREDERE WEALTH PARTNER PRIVATE LIMITED",
"KREDIFY FINTECH SOLUTIONS PRIVATE LIMITED",
"KREDITSTACK FINANCIAL SERVICES PRIVATE LIMITED",
"KREE-DOH MANAGEMENT PRIVATE LIMITED",
"KREEM FOODS PRIVATE LIMITED",
"KREEMA BAKERS PRIVATE LIMITED",
"KREEPA OVERSEAS PRIVATE LIMITED",
"KREESHNA EXIM ENTERPRISE PRIVATE LIMITED",
"KREETI TECHNOLOGIES PRIVATE LIMITED",
"KREMEDINE HEALTH PRIVATE LIMITED",
"KREMER MERCANTILE PVT LTD",
"KREMOINT PHARMA PRIVATE LIMITED",
"KREON FINNANCIAL SERVICES LIMITED",
"KREON INFRA PRIVATE LIMITED",
"KRESCENT SOFT-SKILLS PRIVATE LIMITED",
"KRESH FASHIONS PRIVATE LIMITED",
"KRESHA STEEL PRIVATE LIMITED",
"KRESKO PROJECTS PRIVATE LIMITED",
"KREST FACILITATORS PRIVATE LIMITED",
"KREST SOLUTIONS PRIVATE LIMITED",
"KRESTON BNB ADVISORS PRIVATE LIMITED",
"KRETECH SOLUTIONS PRIVATE LIMITED",
"KREW INSTRUMENTS PRIVATE LIMITED",
"KREYA INFRATECH PRIVATE LIMITED",
"KRF COSMETICS PRIVATE LIMITED",
"KRF LIMITED",
"KRG COMPUTER PRIVATE LIMITED",
"KRG MARKETING PRIVATE LIMITED",
"KRG POLYCHEM PRIVATE LIMITED",
"KRG TECHNOLOGIES INDIA PRIVATE LIMITED",
"KRH MANUFACTURING AND MANAGEMENT PRIVATE LIMITED",
"KRIA HEALTHCARE PRIVATE LIMITED",
"KRIA INFOTECH PRIVATE LIMITED",
"KRIA MARKETING MEDIA SOLUTIONS PRIVATE LIMITED",
"KRIAAR MEDENT PRIVATE LIMITED",
"KRIAGRO FARMERS PRODUCER COMPANY LIMITED",
"KRIAN MEDIA LIMITED",
"KRIANSH APPARELS WORLD PRIVATE LIMITED",
"KRIANSH TRADELINKS PRIVATE LIMITED",
"KRIARZ VOIXSAI SOLUTIONS PRIVATE LIMITED",
"KRIBEL VENTURES PRIVATE LIMITED",
"KRIBHCO",
"KRIBHCO FERTILIZERS LIMITED",
"KRICON I.T. SOLUTIONS PRIVATE LIMITED",
"KRIDAY OVERSEAS PRIVATE LIMITED",
"KRIDAY REALTY PRIVATE LIMITED",
"KRIDHA LAMINATES PRIVATE LIMITED",
"KRIDHA PROJECT PRIVATE LIMITED",
"KRIDHABHASIN AGENCY PRIVATE LIMITED",
"KRIDHAN INFRA SOLUTIONS LIMITED",
"KRIDHAN INFRATECH PRIVATE LIMITED",
"KRIDHAN PETROCHEMICALS PRIVATE LIMITED",
"KRIFOUR INDUSTRIES PRIVATE LIMITED",
"KRIFY SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"KRIHAAN TEXCHEM PRIVATE LIMITED",
"KRIHANT CORPORATION PRIVATE LIMITED",
"KRIIS PORTFOLIO PRIVATE LIMITED",
"KRIJMA ENGINEERS PRIVATE LIMITED",
"KRIKAMIT ENGINEERING PRIVATE LIMITED",
"KRIMA SIL PVT LTD",
"KRIMAKA PACKING SYSTEMS PRIVATE LIMITED",
"KRIMANSHI TECHNOLOGIES PRIVATE LIMITED",
"KRIMEESHA STEELS PRIVATE LIMITED",
"KRIMS HOSPITAL",
"KRIMSON APPARELS PRIVATE LIMITED",
"KRINI FURNITURE PRIVATE LIMITED",
"KRINI INFRATECH PRIVATE LIMITED",
"KRINOTEK PRIVATE LIMITED",
"KRION CONSULTING PRIVATE LIMITED",
"KRION INDUSTRIES PRIVATE LIMITED",
"KRIOS BUILDING MATERIALS PRIVATE LIMITED",
"KRIOS INFO SOLUTIONS PRIVATE LIMITED",
"KRIPA ANAND RISHI CELLULAR PRIVATE LIMITED",
"KRIPA AUTOMATION INDIA PRIVATE LIMITED",
"KRIPA BUILDCON PRIVATE LIMITED",
"KRIPA ELECTRONICS INDIA PRIVATE LIMITED",
"KRIPA FASHIONS PVT LTD",
"KRIPA INFRAHEIGHTS PRIVATE LIMITED",
"KRIPA SHIDDHI BUILDCON (INDIA) PRIVATE LIMITED",
"KRIPAL TEXTILES MILLS PRIVATE LIMITED",
"KRIPALANI & SONS JEWELLERS PRIVATE LIMITED",
"KRIPALU AGENCIES PRIVATE LIMITED",
"KRIPALU COMMERCIAL PRIVATE LIMITED",
"KRIPALU CREATIONS PRIVATE LIMITED",
"KRIPALU MARBLES AND GRANITES PRIVATE LIMITED",
"KRIPARTI PLAYING11 PRIVATE LIMITED",
"KRIPASHREE JEWELS PRIVATE LIMITED",
"KRIPLON SYNTHETICS PVT LTD",
"KRIPTON CERAMIC PRIVATE LIMITED",
"KRIPTON GRANITO PRIVATE LIMITED",
"KRIPTON POWDER PAINTS PRIVATE LIMITED",
"KRIPYA SOLUTIONS PRIVATE LIMITED",
"KRIPYA TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"KRIS (SG) INFOTECH INDIA PRIVATE LIMITED",
"KRIS AERO SERVICES PRIVATE LIMITED",
"KRIS AUTOMATED PACKAGING SYSTEMS PRIVATE LIMITED",
"KRIS FLEXIPACKS PRIVATE LIMITED",
"KRISAM AUTOMATION",
"KRISANI BIO SCIENCES PRIVATE LIMITED",
"KRISBA HEALTHCARE PRIVATE LIMITED",
"KRISCON REALTORS PRIVATE LIMITED",
"KRISCORE FINANCIAL ADVISORS PRIVATE LIMITED",
"KRISEMI DESIGN TECHNOLOGIES PRIVATE LIMITED",
"KRISH AGRO FARMS PRIVATE LIMITED",
"KRISH AIR CONDITIONING PRIVATE LIMITED",
"KRISH AUTO PRIVATE LIMITED",
"KRISH AUTOMOTIVE SALES AND SERVICES PRIVATE LIMITED",
"KRISH AUTOMOTORS PRIVATE LIMITED",
"KRISH BIOTECH RESEARCH PRIVATE LIMITED",
"KRISH CARE REMEDYS PRIVATE LIMITED",
"KRISH CARRIERS PRIVATE LIMITED",
"KRISH CARS PRIVATE LIMITED",
"KRISH CEREALS PRIVATE LIMITED",
"KRISH CHEMICALS PRIVATE LIMITED",
"KRISH COMERCIO PRIVATE LIMITED",
"KRISH DEVELOPERS PRIVATE LIMITED",
"KRISH ELECTRO TECHNOLOGIES PRIVATE LIMITED",
"KRISH FABRICS INDIA PRIVATE LIMITED",
"KRISH FASHION ACCESSORIES PRIVATE LIMITED",
"KRISH FASHIONS BRANDS PRIVATE LIMITED",
"KRISH FERRO INDUSTRIES PRIVATE LIMITED",
"KRISH FRAGRANCE PRIVATE LIMITED",
"KRISH INDUSTRIES PRIVATE LIMITED",
"KRISH INFRASTRUCTURE PRIVATE LIMITED",
"KRISH INFRATEL PRIVATE LIMITED",
"KRISH INTRATRADE PRIVATE LIMITED",
"KRISH IRON AND STEELS PRIVATE LIMITED",
"KRISH IT SOLUTIONS PRIVATE LIMITED",
"KRISH KRIPA PRODUCER COMPANY LIMITED",
"KRISH OVERSEAS PRIVATE LIMITED",
"KRISH SOFTWARE SERVICES INDIA PRIVATE LIMITED",
"KRISH TECHNOLABS PRIVATE LIMITED",
"KRISH TRADECORP PRIVATE LIMITED",
"KRISHA ANGEL PRIVATE LIMITED",
"KRISHA DISTRIBUTION PRIVATE LIMITED",
"KRISHA INFRASOL PRIVATE LIMITED",
"KRISHA TRANS POWER (INDIA) PRIVATE LIMITED",
"KRISHAA AUTO PRIVATE LIMITED",
"KRISHAANGI AGRO FOODS PRIVATE LIMITED",
"KRISHABH NIRMAN PRIVATE LIMITED",
"KRISHAGNI SOLUTIONS PRIVATE LIMITED",
"KRISHAK BHARATI COOPERATIVE LIMITED",
"KRISHAK SEVITA ONLINE SOLUTIONS PRIVATE LIMITED",
"KRISHAK SUPPORT PRIVATE LIMITED",
"KRISHAN CHAND MEDICOS PRIVATE LIMITED",
"KRISHAN GOPAL FOODS PRIVATE LIMITED",
"KRISHAN KIRPA COMPUTER INDUSTRIES PRIVATE LIMITED",
"KRISHAN KUMAR & COMPANY",
"KRISHAN KUMAR DISTRIBUTORS PRIVATE LIMITED",
"KRISHAN MULTIMETALS & ALLOYS PRIVATE LIMITED",
"KRISHANA CLEARING AND FORWARDING AGENCY",
"KRISHANA INFRACREATIONS PRIVATE LIMITED",
"KRISHANA METALLURGICAL PRIVATE LIMITED",
"KRISHANA PHOSCHEM LIMITED",
"KRISHANGI CONSTRUCTION PRIVATE LIMITED",
"KRISHAV LOGISTICS PRIVATE LIMITED",
"KRISHAV TEX CREATION PRIVATE LIMITED",
"KRISHAWEB TECHNOLOGIES PRIVATE LIMITED",
"KRISHAY CASTINGS LIMITED",
"KRISHCA STRAPPING SOLUTIONS LIMITED",
"KRISHCO ENGINEERS PRIVATE LIMITED",
"KRISHCO MEDICAL PRODUCTS PRIVATE LIMITED",
"KRISHE SAPPHIRE MANAGEMENT COMPANY PRIVATE LIMITED",
"KRISHI BAZAR PRIVATE LIMITED",
"KRISHI BIO PRODUCTS AND RESEARCH PRIVATE LIMITED",
"KRISHI CARE & MANAGEMENT SERVICES PRIVATE LIMITED",
"KRISHI COLD STORAGE (UP) PRIVATE LIMITED",
"KRISHI CONSTRUCTIONS PRIVATE LIMITED",
"KRISHI DISCS & KNIVES (I) PRIVATE LIMITED",
"KRISHI ENGITECH PRIVATE LIMITED",
"KRISHI GEOPACK PRIVATE LIMITED",
"KRISHI INFRATECH",
"KRISHI INTER COLLEGE BAREILLY",
"KRISHI KALPA FOUNDATION",
"KRISHI NUTRITION COMPANY PRIVATE LIMITED",
"KRISHI POLYMERS PRIVATE LIMITED",
"KRISHI POWER SOLAR SYSTEMS PRIVATE LIMITED",
"KRISHI RASAYAN EXPORTS PRIVATE LIMITED",
"KRISHI RASAYAN PRIVATE LIMITED.",
"KRISHI SAHYOG EXPORTS PRIVATE LIMITED",
"KRISHI UPAJ MANDI SAMITI",
"KRISHI VIGYAN KENDRA GUJARAT VIDYAPEETH DETHALI",
"KRISHI VIGYAN KENDRA GWALIOR",
"KRISHI VIGYAN KENDRA KOLHAPUR",
"KRISHIACHARYA TECHNOLOGIES PRIVATE LIMITED",
"KRISHICROP PRIVATE LIMITED",
"KRISHIDHAAN BIOCARE PRIVATE LIMITED",
"KRISHIINET INFOCOM PRIVATE LIMITED",
"KRISHIK INFRASTRUCTURE DEVELOPERS PRIVATE LIMITED",
"KRISHIKA FARMS PRIVATE LIMITED",
"KRISHIKAN KRISHIKAN PRIVATE LIMITED",
"KRISHIL CAPITAL HOLDINGS PRIVATE LIMITED",
"KRISHITA MARKETING PRIVATE LIMITED",
"KRISHITA TEXTILES PRIVATE LIMITED",
"KRISHITEK INDUSTRIES PRIVATE LIMITED",
"KRISHIV AUTO AGENCIES PRIVATE LIMITED",
"KRISHIV FOOD SERVICES PRIVATE LIMITED",
"KRISHIV ISPAT PRIVATE LIMITED",
"KRISHIV MOTORS PRIVATE LIMITED",
"KRISHIV SUPPLIERS PRIVATE LIMITED",
"KRISHIV TEA PRIVATE LIMITED",
"KRISHJAY ENERGY PRIVATE LIMITED",
"KRISHKAN INVESTMENT PRIVATE LIMITED",
"KRISHKO LOGISTICS INDIA PRIVATE LIMITED",
"KRISHKON STRUCTURALS PVT LTD",
"KRISHLEX POLYMERS PRIVATE LIMITED",
"KRISHLOCK SOLUTIONS PRIVATE LIMITED",
"KRISHMA EXPORTS (INDIA) LTD.",
"KRISHMA GLOVES PRIVATE LIMITED",
"KRISHNA & PRASAD CORPORATION PRIVATE LIMITED",
"KRISHNA AGENCIES PRIVATE LIMITED",
"KRISHNA AIR CARGO AND LOGISTICS PRIVATE LIMITED",
"KRISHNA AL-CAST PRIVATE LIMITED",
"KRISHNA ALEX PRIVATE LIMITED",
"KRISHNA ALKALI BOMBAY PRIVATE LIMITED",
"KRISHNA ALUMINIUM PRIVATE LIMITED",
"KRISHNA AND SAURASTRI ASSOCIATES LLP",
"KRISHNA ANTIOXIDANTS PRIVATE LIMITED",
"KRISHNA ART SILK CLOTHS PRIVATE LIMITED",
"KRISHNA ASSET RECONSTRUCTION PRIVATE LIMITED",
"KRISHNA AUTO RIDERS PRIVATE LIMITED",
"KRISHNA AUTOMOBILES",
"KRISHNA AYU TEXTILES PRIVATE LIMITED",
"KRISHNA BALRAM EXPORTS PRIVATE LIMITED",
"KRISHNA BATH EFFECTS PRIVATE LIMITED",
"KRISHNA BEADS INDUSTRIES LLP",
"KRISHNA BELTS PRIVATE LIMITED",
"KRISHNA BHAGYA JALA NIGAM LIMITED",
"KRISHNA BHIMA SAMRUDDHI LOCAL AREA BANK LIMITED",
"KRISHNA BHOG RICE INDUSTRIES PRIVATE LIMITED",
"KRISHNA BIHARI RAMAN SARRAF JEWELS PRIVATE LIMITED",
"KRISHNA BIKES PRIVATE LIMITED",
"KRISHNA BUILDCON PRIVATE LIMITED",
"KRISHNA BUILDER",
"KRISHNA BUILDESTATES PRIVATE LIMITED",
"KRISHNA BUILDSPACE PRIVATE LIMITED",
"KRISHNA BUILDTECH LIMITED",
"KRISHNA BULK MOVERS PRIVATE LIMITED",
"KRISHNA BUS SERVICES PRIVATE LIMITED",
"KRISHNA BUSINESS DEVELOPMENT PRIVATE LIMITED",
"KRISHNA CAPBOX PRIVATE LIMITED",
"KRISHNA CARGO MOVERS PRIVATE LIMITED",
"KRISHNA CHANDRA DUTTA (COOKME) PVT LTD",
"KRISHNA CHANDRA DUTTA(SPICE) PVT LTD",
"KRISHNA CHANDRA PATRA KCP",
"KRISHNA CHANDRAPURHIGH SCHOOL",
"KRISHNA CHEMFOOD PRIVATE LIMITED",
"KRISHNA CLEANING & SECURITY SERVICES PRIVATE LIMITED",
"KRISHNA COATED FABRICS PVT.LTD.",
"KRISHNA CODDLE RESIDENCY PRIVATE LIMITED",
"KRISHNA COIL CUTTERS PRIVATE LIMITED",
"KRISHNA COKE (INDIA) PRIVATE LIMITED",
"KRISHNA COKE PRIVATE LIMITED",
"KRISHNA COMPUTECH INTERNATIONAL PRIVATE LIMITED",
"KRISHNA CONCAST PRIVATE LIMITED",
"KRISHNA CONCHEM PRODUCTS PRIVATE LIMITED",
"KRISHNA CONSTRO-PROJECTS PRIVATE LIMITED",
"KRISHNA CONSTRUCTION COMPANY PRIVATE LIMITED",
"KRISHNA CONSTRUCTIONS (CHENNAI) PRIVATE LIMITED",
"KRISHNA CONSTRUCTIONS COMPANY",
"KRISHNA COOK-WARES PRIVATE LIMITED",
"KRISHNA COPPER PRIVATE LIMITED",
"KRISHNA CORPINDIA PRIVATE LIMITED",
"KRISHNA CORPORATION",
"KRISHNA CORRUGATORS PRIVATE LIMITED",
"KRISHNA COTFAB PRIVATE LIMITED",
"KRISHNA COTTEX INDUSTRIES",
"KRISHNA COTWEAVING PRIVATE LIMITED",
"KRISHNA CREATIVE CARDS PRIVATE LIMITED",
"KRISHNA DARSHAN ENVIRO CARE AND INFRA PROJECT PVT. LTD",
"KRISHNA DEFENCE AND ALLIED INDUSTRIES LIMITED",
"KRISHNA DEHYDRATION PRIVATE LIMITED",
"KRISHNA DEVELOPERS PRIVATE LIMITED",
"KRISHNA DI KULFI PRIVATE LIMITED",
"KRISHNA DIAGNOSTICS PRIVATE LIMITED",
"KRISHNA DRESSES PRIVATE LIMITED",
"KRISHNA DYEING AND PRINTING MILLS PRIVATE LIMITED",
"KRISHNA E CAMPUS PRIVATE LIMITED",
"KRISHNA EDIBLE PRODUCTS PRIVATE LIMITED",
"KRISHNA EMPORIUM PVT LTD",
"KRISHNA ENGG COLLEGE",
"KRISHNA ENGIMECH PRIVATE LIMITED",
"KRISHNA ENGINEERING CO PRIVATE LIMITED",
"KRISHNA ENZYTECH PRIVATE LIMITED",
"KRISHNA ESTATE DEVELOPERS PRIVATE LIMITED",
"KRISHNA EYE CENTRE PRIVATE LIMITED",
"KRISHNA FABRICATION PRIVATE. LIMITED",
"KRISHNA FANCYFAB PRIVATE LIMITED",
"KRISHNA FASHION",
"KRISHNA FILAMENT PRIVATE LIMITED",
"KRISHNA FIRE SYSTEMS PRIVATE LIMITED",
"KRISHNA FLOUR MILLS (BANGALORE) PRIVATE LIMITED",
"KRISHNA GEMS",
"KRISHNA GENERAL HOSPITAL STREE CLINIC",
"KRISHNA GLOBAL SERVICES PRIVATE LIMITED",
"KRISHNA GLOBAL TRANSENERGY LIMITED",
"KRISHNA GODAVARI AQUATECH PRIVATE LIMITED",
"KRISHNA GODAVARI COASTAL ENERGY PRIVATE LIMITED",
"KRISHNA GRAIN SYSTEMS PRIVATE LIMITED",
"KRISHNA GRAVURE PRIVATE LIMITED",
"KRISHNA GREENTECH PRIVATE LIMITED",
"KRISHNA GRUPO ANTOLIN PRIVATE LIMITED",
"KRISHNA HALFTONE PRIVATE LIMITED",
"KRISHNA HANGUK TECHNOLOGIES PRIVATE LIMITED",
"KRISHNA HOSPITAL",
"KRISHNA HYDROCARBONS PRIVATE LIMITED",
"KRISHNA IMAGING AND DIAGNOSTICS PRIVATE LIMITED",
"KRISHNA INDUSTRIAL SERVICES SUPER PRIVATE LIMITED",
"KRISHNA INFOSOLUTIONS PRIVATE LIMITED",
"KRISHNA INFRASTEEL PRIVATE LIMITED",
"KRISHNA INNOVATIVE SOFTWARE PRIVATE LIMITED",
"KRISHNA INSTITUTE OF ENGINEERING AND TECHNOLOGY",
"KRISHNA INSTITUTE OF MEDICAL SCIENCES DEEMED TO BE UNIVERSITY KARAD",
"KRISHNA INSTITUTE OF MEDICAL SCIENCES LIMITED",
"KRISHNA INSTITUTE OF TECHNOLOGY",
"KRISHNA INSULATIONS & ENGINEERS PRIVATE LIMITED",
"KRISHNA INTERNATIONAL",
"KRISHNA INTERNATIONAL ENGLISH SCHOOL",
"KRISHNA INTERNATIONAL HOTELS (CHENNAI) PRIVATE LIMITED",
"KRISHNA INTERTEX PRIVATE LIMITED",
"KRISHNA IRON STRIPS AND TUBES PVT LTD",
"KRISHNA ISHIZAKI AUTO LIMITED",
"KRISHNA IVF CLINIC PRIVATE LIMITED",
"KRISHNA JCB",
"KRISHNA JEWELS",
"KRISHNA JYOTI PVT LTD",
"KRISHNA KANHAIYA METALS PRIVATE LIMITED",
"KRISHNA KANHAIYA MILK PROCESSING PRIVATE LIMITED",
"KRISHNA KRISHNA DESIGN AND MANUFACTURING PRIVATE LIMITED",
"KRISHNA KRISHNA JEWELLERS AND INVESTMENTS PRIVATE LIMITED",
"KRISHNA KRISHNA JEWELLERS PRIVATE LIMITED",
"KRISHNA KRISHNA LEGACY PRIVATE LIMITED",
"KRISHNA KRISHNA TELEMART PRIVATE LIMITED",
"KRISHNA KUMAR SINGH",
"KRISHNA KUNJ DEVELOPERS PRIVATE LIMITED",
"KRISHNA KUNJ SAREES PRIVATE LIMITED",
"KRISHNA LA WINDZ INDIA PRIVATE LIMITED",
"KRISHNA LABELS PRIVATE LIMITED",
"KRISHNA LABELS PVT LTD",
"KRISHNA LAMICOAT PRIVATE LIMITED",
"KRISHNA LANDI RENZO INDIA PRIVATE LIMITED",
"KRISHNA LIFECARE PRIVATE LIMITED",
"KRISHNA LUMBERS PRIVATE LIMITED",
"KRISHNA MACHINERY MANUFACTURERS PVT LTD",
"KRISHNA MARUTI LIMITED",
"KRISHNA MEDICAL CENTRE PRIVATE LIMITED",
"KRISHNA MEDICO AND GENERAL STORES¬†¬†",
"KRISHNA META LURGICAL LABORITIES PRIVATE LIMITED",
"KRISHNA METACRAFT PVT LTD",
"KRISHNA METAFAB PRIVATE LIMITED",
"KRISHNA METAL AND ALLIED PRODUCTS (INDIA) PRIVATE LIMITED",
"KRISHNA METAL INDUSTRIES PVT LTD",
"KRISHNA METALLURGICAL LABORATORIES PRIVATE LIMITED",
"KRISHNA MOBILITY PRIVATE LIMITED",
"KRISHNA MOHAN FOODS PRIVATE LIMITED",
"KRISHNA MONEY BASE NIDHI LIMITED",
"KRISHNA MOVERS & MINERAL PRIVATE LIMITED",
"KRISHNA MRI & CT SCAN CENTER LLP",
"KRISHNA MULTI INDUSTRIES PVT LTD",
"KRISHNA MULTIFARIOUS PRIVATE LIMITED",
"KRISHNA MULTIFOILS PRIVATE LIMITED",
"KRISHNA MULTISPECIALITY HOSPITAL",
"KRISHNA MULTISPECIALITY HOSPITAL AND TRAUMA CARE",
"KRISHNA MULTISTRUCTURE ENGINEERING PRIVATE LIMITED",
"KRISHNA MURARI MEMORIAL HOSPITAL & RESEARCH CENTRE PRIVATE LIMITED",
"KRISHNA MURARI ORGANOSYS PRIVATE LIMITED",
"KRISHNA MURARI TEA INDUSTRIES PVT LTD",
"KRISHNA NATURAL FIBRE PRIVATE LIMITED",
"KRISHNA NETRALAYA PRIVATE LIMITED",
"KRISHNA NM GRANITE PRIVATE LIMITED",
"KRISHNA OILS AND CHEMICALS PRIVATE LIMITED",
"KRISHNA ORNAMENTS PRIVATE LIMITED",
"KRISHNA PACKTECH PRIVATE LIMITED",
"KRISHNA PADDY AND FOOD PRODUCTS PRIVATE LIMITED",
"KRISHNA PALACE RESIDENCY PRIVATE LIMITED",
"KRISHNA PARK INFRACON PRIVATE LIMITED",
"KRISHNA PECTINS PVT LTD",
"KRISHNA PENS PRIVATE LIMITED",
"KRISHNA PENSTONE AUTOMOTIVE PRIVATE LIMITED",
"KRISHNA PETRO CHEM PRIVATE LIMITED",
"KRISHNA PETROTECH & OILS PRIVATE LIMITED",
"KRISHNA PLY & HARDWARES PRIVATE LIMITED",
"KRISHNA PLYWOOD PRODUCTS PRIVATE LIMITED",
"KRISHNA POLY PACKS PVT LTD",
"KRISHNA POLYMACH PRIVATE LIMITED",
"KRISHNA POLYMER PRIVATE LIMITED",
"KRISHNA POLYPIPES PRIVATE LIMITED",
"KRISHNA POLYPLAST (INDIA) PRIVATE LIMITED",
"KRISHNA POLYPRO INDUSTRIES PRIVATE LIMITED",
"KRISHNA POULTRY TEX MILL INDIA PRIVATE LIMITED",
"KRISHNA POWER CONSTRUCTION PVT LTD",
"KRISHNA PRABHAS AGRO OILS PRIVATE LIMITED",
"KRISHNA PRINTS PRIVATE LIMITED",
"KRISHNA PRIYA ESTATES PRIVATE LIMITED",
"KRISHNA PROCESSORS & INDUSTRIES PRIVATE LIMITED.",
"KRISHNA PROMOTIONS PRIVATE LIMITED",
"KRISHNA PROPERTIES & DEVELOPERS PRIVATE LIMITED",
"KRISHNA PUBLIC SCHOOL",
"KRISHNA PULSES AND CEREALS",
"KRISHNA QUINETTE SEATS PRIVATE LIMITED",
"KRISHNA RAVI TEXTILE PROCESSORS PRIVATE LIMITED",
"KRISHNA REFRIGERATION AND INFRASTRUCTURE PRIVATE LIMITED",
"KRISHNA RESIDENCY PRIVATE LIMITED",
"KRISHNA RESINS AND PIGMENTS PRIVATE LIMITED",
"KRISHNA RICE MILLS PVT LTD",
"KRISHNA SAGAR HOSPITALITY SERVICES PRIVATE LIMITED.",
"KRISHNA SAHAKARI BANK LTD",
"KRISHNA SAHIL CONSTRUCTIONS PRIVATE LIMITED",
"KRISHNA SCHOOL KARAD",
"KRISHNA SECURITY & LABOUR SUPPLIER SERVICES PRIVATE LIMITED",
"KRISHNA SHAREBROKING SERVICES PRIVATE LIMITED",
"KRISHNA SHEET METAL COMPONENTS PRIVATE LIMITED",
"KRISHNA SHEET PROCESSORS PRIVATE LIMITED",
"KRISHNA SHIPPING AND LOGISTICS PRIVATE LIMITED",
"KRISHNA SHYAM EARTHMOOVERS PRIVATE LIMITED",
"KRISHNA SNACKS PRIVATE LIMITED",
"KRISHNA SOLAR FARMS PRIVATE LIMITED",
"KRISHNA SOLVECHEM LIMITED",
"KRISHNA SPACECON PRIVATE LIMITED",
"KRISHNA SPECIALITY CHEMICALS PRIVATE LIMITED",
"KRISHNA SPICES PVT LTD",
"KRISHNA SPRINGSINDIA PVT LTD",
"KRISHNA STAR MOULDING PRIVATE LIMITED",
"KRISHNA STONE INDUSTRIES PRIVATE LIMITED",
"KRISHNA SURGICAL HEALTHCARE PRIVATE LIMITED",
"KRISHNA SURGICAL SOLUTIONS PRIVATE LIMITED",
"KRISHNA SWAROOP HOSPITAL PRIVATE LIMITED",
"KRISHNA TECHNO CHEM PRIVATE LIMITED",
"KRISHNA TECHNOCONSULTANTS PRIVATE LIMITED",
"KRISHNA TECHNOLOGIST PRIVATE LIMITED",
"KRISHNA TEJA FOOD PRODUCTS",
"KRISHNA TELENET PRIVATE LIMITED",
"KRISHNA TERRY TEX PRIVATE LIMITED",
"KRISHNA TISSUES PRIVATE LIMITED",
"KRISHNA TRADE & COMMERCE PVT. LTD.",
"KRISHNA TRADLINKS PRIVATE LIMITED",
"KRISHNA TRANSFORMER COMPONENTS PRIVATE LIMITED",
"KRISHNA TRANSNATIONAL MARBLES PRIVATE LIMITED",
"KRISHNA TRENDZ PRIVATE LIMITED",
"KRISHNA TUBE INDUSTRIES PRIVATE LIMITED",
"KRISHNA TUFF PRIVATE LIMITED",
"KRISHNA VALLEY AGROTECH LLP",
"KRISHNA VALLEY POWER PRIVATE LIMITED",
"KRISHNA VANIJYA PRIVATE LIMITED",
"KRISHNA VASUDEVA FOODS AND DERIVATIVES PRIVATE LIMITED",
"KRISHNA VEHICLES PRIVATE LIMITED",
"KRISHNA VELVET",
"KRISHNA VENTURES LIMITED",
"KRISHNA VENTURES REALTY PRIVATE LIMITED",
"KRISHNA VIDYUT AND INFRA PRIVATE LIMITED",
"KRISHNA VISHWA VIDHYAPEET",
"KRISHNA VISHWA VIDYAPEETH DEEMED TO BE UNIVERSITY",
"KRISHNA WALL AND GLAZE TILES PRIVATE LIMITED",
"KRISHNA WAX PRIVATE LIMITED",
"KRISHNA WHEELS PRIVATE LIMITED",
"KRISHNA WINDFARMS DEVELOPERS PRIVATE LIMITED",
"KRISHNA WIRE PRODUCTS PVT LTD",
"KRISHNA WOOD AND METAL PRODUCTS PRIVATE LIMITED",
"KRISHNA WOOD WORKS",
"KRISHNA WOVEN SACKS PRIVATE LIMITED",
"KRISHNA YPB ELECTRO-CHEMICALS PRIVATE LIMITED",
"KRISHNAA INCENSE PRIVATE LIMITED",
"KRISHNAAG BUSINESS ENTERPRISES PRIVATE LIMITED",
"KRISHNAAV ENGINEERING LIMITED",
"KRISHNABEHARI TEA CO LTD",
"KRISHNABHAKTA GRIHA NIRMAN PRIVATE LIMITED",
"KRISHNA-CREATIVE DEVELOPERS PRIVATE LIMITED",
"KRISHNAGIRI IMPEX PRIVATE LIMITED",
"KRISHNAGIRI THOPUR TOLL ROAD PRIVATE LIMITED",
"KRISHNAGIRI WALAJAHPET TOLLWAY PRIVATE LIMITED",
"KRISHNAIAH MOTORS PRIVATE LIMITED",
"KRISHNAIAH PROJECTS PRIVATE LIMITED",
"KRISHNAKALI TEA ESTATE PRIVATE LIMITED",
"KRISHNAKANHA RESIDENCY PRIVATE LIMITED",
"KRISHNAKANTH INFRA PROJECTS PRIVATE LIMITED",
"KRISHNAKISHORE AGROTECH PRIVATE LIMITED",
"KRISHNAKRIPA TUBES PRIVATE LIMITED",
"KRISHNALAXMI MULTI TRADE PRIVATE LIMITED",
"KRISHNAM DIAMOND AND JEWELLERS PRIVATE LIMITED",
"KRISHNAM RESOURCES PRIVATE LIMITED",
"KRISHNAM STEEL INDIA PRIVATE LIMITED",
"KRISHNAM TWISTING AND WEAVING PRIVATE LIMITED",
"KRISHNAMAL RAMASUBBAIYER CBSE SCHOOL",
"KRISHNAMAYA TRADERS PRIVATE LIMITED",
"KRISHNAMMAL TRUST",
"KRISHNA-MOHAN OVERSEAS (INDORE) PRIVATE LIMITED",
"KRISHNAMUKUT WALA PRIVATE LIMITED",
"KRISHNAMURTI FOUNDATION INDIA UNIT: RBS RAJGHAT FORT, VARANASI",
"KRISHNANCHAL PULP & PAPERS PRIVATE LIMITED",
"KRISHNAPADAM IT SOLUTION PRIVATE LIMITED",
"KRISHNAPATNAM CONSTRUCTIONS PRIVATE LIMITED",
"KRISHNAPATNAM RAILWAY COMPANY LIMITED",
"KRISHNAPATNAM SECURITY SERVICES PRIVATE LIMITED",
"KRISHNAPING ALLOYS LIMITED",
"KRISHNAPING MINERALS PRIVATE LIMITED",
"KRISHNAPOULTRY FARM INDIA PRIVATE LIMITED",
"KRISHNAPRIYA CREDIT MANAGEMENT SERVICES PRIVATE LIMITED",
"KRISHNAPRIYA PROPERTIES PRIVATE LIMITED",
"KRISHNARAJ BUILDCON PRIVATE LIMITED",
"KRISHNARAJ DIAMOND PRIVATE LIMITED",
"KRISHNARAJ FERTICHEM PRIVATE LIMITED",
"KRISHNARAJ JEWELS PRIVATE LIMITED",
"KRISHNARAJ RUBBERS PRIVATE LIMITED",
"KRISHNARAJ SHIPPING COMPANY LIMITED",
"KRISHNARAJ SPINNING MILLS PRIVATE LIMITED",
"KRISHNARPAN INVESTMENTS PRIVATE LIMITED",
"KRISHNASAA FABS PRIVATE LIMITED",
"KRISHNASAMY COLLEGE OF ENGINEERING AND TECHNOLOGY",
"KRISHNASANJEEV ENTERPRISES PRIVATE LIMITED",
"KRISHNASASI HEALTH CARE PRIVATE LIMITED",
"KRISHNASHREE FOODS PRIVATE LIMITED",
"KRISHNASREE PROJECTS PRIVATE LIMITED",
"KRISHNAVENI CARBON PRODUCTS PRIVATE LIMITED",
"KRISHNAVENI CONSTRUCTIONS PRIVATE LIMITED",
"KRISHNAVENI FILM EXHIBITORS PRIVATE LIMITED",
"KRISHNAVENI HIGH SCHOOL",
"KRISHNAVENI METAL CASTINGS PRIVATE LIMITED",
"KRISHNAVENI PVT ITI",
"KRISHNAYAN PROMOTERS PRIVATE LIMITED",
"KRISHNAYASH YARN PRIVATE LIMITED",
"KRISHNEEL EXPORTS PRIVATE LIMITED",
"KRISHPAR TECHNOLOGIES PRIVATE LIMITED",
"KRISHTECH MACHINES PRIVATE LIMITED",
"KRISHTEE TECHNOLOGY INDIA PRIVATE LIMITED",
"KRISHU FEEDS PRIVATE LIMITED",
"KRISHU MOTOR CRAFT PVT LTD",
"KRISHVAN OLEO CHEMICALS PRIVATE LIMITED",
"KRISHVI GEMS PRIVATE LIMITED",
"KRISHVI PROJECTS PRIVATE LIMITED",
"KRISHVI SECURITIES PRIVATE LIMITED",
"KRISIA HOLIDAYS & TRAVELS PRIVATE LIMITED",
"KRISLON CREATIONS PRIVATE LIMITED",
"KRISLON FASHIONS PRIVATE LIMITED",
"KRISLUR CASTOMECH PRIVATE LIMITED",
"KRISON INFRATECH PRIVATE LIMITED",
"KRISORIGINALS PRIVATE LIMITED",
"KRISS DRILLING PRIVATE LIMITED",
"KRISSHIDHAAN AGRO PRIVATE LIMITED",
"KRISSNIDHI INDUSTRIES PRIVATE LIMITED",
"KRISSOL (INDIA) PRIVATE LIMITED",
"KRISTA SOFTWARE PRIVATE LIMITED",
"KRISTAL SPIRITS INDIA PRIVATE LIMITED",
"KRISTEEL PRECISION LLP",
"KRISTEEL SHINWA INDUSTRIES LIMITED",
"KRISTINA ENTERPRISES",
"KRISTINO FASHIONS PRIVATE LIMITED",
"KRISTINO NX PRIVATE LIMITED",
"KRISTL SEIBT INDIA PRIVATE LIMITED",
"KRISTORR VACUUM EQUIPMENTS PRIVATE LIMITED",
"KRISTRON CONTROLS & SYSTEMS PRIVATE LIMITED",
"KRISTU JAYANTI COLLEGE AUTONOMOUS",
"KRISULA GLOBEXIM PRIVATE LIMITED",
"KRIT PRODUCER COMPANY LIMITED",
"KRITA ENGINEERING PRIVATE LIMITED",
"KRITAKA GOODS PRIVATE LIMITED",
"KRITARC DESIGNING ENVIRONMENT PRIVATE LIMITED",
"KRITARTH ADVERTISING PRIVATE LIMITED",
"KRITASHREE ENGINEERS PRIVATE LIMITED",
"KRITESH CONSTRUCTION PRIVATE LIMITED",
"KRITHA CONVERTORS PRIVATE LIMITED",
"KRITHIK SPORTS PRIVATE LIMITED",
"KRITHISHA ENTERPRISES",
"KRITHIYAA INTEGRATED BUSINESS SERVICES PRIVATE LIMITED",
"KRITI CONS LIMITED",
"KRITI CREATIONS PRIVATE LIMITED",
"KRITI GLOBAL PRODUCTS PRIVATE LIMITED",
"KRITI IMPEX PRIVATE LIMITED",
"KRITI INDUSTRIES INDIALIMITED",
"KRITI NUTRIENTS LIMITED",
"KRITI PRINTERS AND PUBLISHERS PRIVATE LIMITED",
"KRITI SCANNING CENTRE PRIVATE LIMITED",
"KRITI SPINNERS PRIVATE LIMITED",
"KRITI STEEL ROLLING MILLS PRIVATE LIMITED",
"KRITI TOOLS PRIVATE LIMITED",
"KRITIKA APARTMENTS PRIVATE LIMITED",
"KRITIKA DESIGNER STUDIO PRIVATE LIMITED",
"KRITIKA REMEDIES PRIVATE LIMITED",
"KRITIKA RICE MILL PRIVATE LIMITED",
"KRITIKA WIRES PRIVATE. LIMITED.",
"KRITIKAL SOLUTIONS PRIVATE LIMITED",
"KRITILABS TECHNOLOGIES PRIVATE LIMITED",
"KRITIM PRIVATE LIMITED",
"KRITIVAAS FREIGHT MOVERS PRIVATE LIMITED",
"KRITON WELD EQUIPMENTS PRIVATE LIMITED",
"KRITTER SOFTWARE TECHNOLOGY PRIVATE LIMITED",
"KRITUNGA RESTAURANT PRIVATE LIMITED",
"KRITVA TECHNOLOGIES PRIVATE LIMITED",
"KRITVIK VENTURES PRIVATE LIMITED",
"KRIVAM CONSULTANT PRIVATE LIMITED",
"KRIVELLI JEWELS PRIVATE LIMITED",
"KRIVI EXIM PRIVATE LIMITED",
"KRIVI METALEX PRIVATE LIMITED",
"KRIVI-TEX PRIVATE LIMITED",
"KRIYA COMMUNICATIONS PRIVATE LIMITED",
"KRIYA DESIGN TECHNOLOGIES PRIVATE LIMITED",
"KRIYA FORMULATIONS PRIVATE LIMITED",
"KRIYA GEMS PRIVATE LIMITED",
"KRIYA INFRASTRUCTURE PRIVATE LIMITED",
"KRIYA NEXTWEALTH PRIVATE LIMITED",
"KRIYANSH INDUSTRIES PRIVATE LIMITED",
"KRIYAS UNIPRO PRIVATE LIMITED",
"KRIYATEC IT SYSTEMS PRIVATE LIMITED",
"KRIYATEK DELIVERY SERVICES PRIVATE LIMITED",
"KRIZALGLOBAL INGREDIENTS PRIVATE LIMITED",
"KRIZTLE BATH & WELLNESS PRIVATE LIMITED",
"KRK CASTINGS (HYD) PRIVATE LIMITED",
"KRK INFRAPROJECTS (INDIA) PRIVATE LIMITED",
"KRL INFRATECH (INDIA) LIMITED",
"KRL TRANSPORT PRIVATE LIMITED",
"KRM 3PL INDIA PRIVATE LIMITED",
"KRM AYURVEDA PRIVATE LIMITED",
"KRM EXPORTS PRIVATE LIMITED",
"KRM PUBLIC SCHOOL",
"KRM TYRES KRM",
"KRMA BUSINESS SOLUTION PRIVATE LIMITED",
"KRMG CONTRACTORS PRIVATE LIMITED",
"KRMM EASYBITES PRIVATE LIMITED",
"KRN ALLOYS PRIVATE LIMITED",
"KRN EDUCATION PRIVATE LIMITED",
"KRN HEAT EXCHANGER AND REFRIGERATION LIMITED",
"KRNCOILS PRIVATE LIMITED",
"KROFTA ENGINEERING LIMITED",
"KROFTA PAPERS PRIVATE LIMITED",
"KROGER",
"KROHNE MARSHALL PRIVATE LIMITED",
"KROLL ASSOCIATES INDIA PRIVATE LIMITED",
"KROLL GLOBAL SOLUTIONS LLP",
"KROM INFRADEVELOPMENTS PRIVATE LIMITED",
"KROMA DIGITAL SERVICES PRIVATE LIMITED",
"KROMA PAINTS PRIVATE LIMITED",
"KROMAKAY IMAGE SALONS PRIVATE LIMITED",
"KROMATIC KONCEPT",
"KROMATIKS AND INSULANTS PRIVATE LIMITED",
"KROME DISPENSE PRIVATE LIMITED",
"KROMO TECHNOLOGIES PRIVATE LIMITED",
"KROMPH RUBBER PRIVATE LIMITED",
"KROMTEK SYSTEMS INDIA PRIVATE LIMITED",
"KRONA LIQUATEC LIMITED",
"KRONE FINSTOCK PRIVATE LIMITED",
"KRONE TECH ENGINEERING PRIVATE LIMITED",
"KRONES INDIA PRIVATE LIMITED",
"KRONOKARE COSMETICS PRIVATE LIMITED",
"KRONOS LOGISTICS INDIA PRIVATE LIMITED",
"KRONOS METALCRAFT PRIVATE LIMITED",
"KRONOS PACKAGING PRIVATE LIMITED",
"KRONOS SOLUTIONS INDIA PRIVATE LIMITED",
"KRONOS SYSTEMS INDIA PRIVATE LIMITED",
"KRONOX LAB SCIENCES LIMITED",
"KROOT MEMORIAL SCHOOL",
"KROPEX AUTO PRIVATE LIMITED",
"KROPEX INDIA LIMITED",
"KROPEX INDIA PRIVATE LIMITED",
"KROPIVNIK CABLEWAYS PVT LTD",
"KROSLINK POLYMERS PVT LTD",
"KROSS INNOVATIONS PRIVATE LIMITED",
"KROSS KOMICS INDIA PRIVATE LIMITED",
"KROSS LIMITED",
"KROSS MANUFACTURERS INDIA PRIVATE LIMITED",
"KROSSARK INSPIRE CONSULTING LLP",
"KROSSLINK INFRASTRUCTURE LIMITED",
"KROSYL PHARMACEUTICALS PRIVATE LIMITED",
"KROVINYS OCEAN PECIFIC INDIA PRIVATE LIMITED",
"KROWD R&D INDIA PRIVATE LIMITED",
"KROWN AGROFOODS PRIVATE LIMITED",
"KROWN BAKERS (INDIA) PRIVATE LIMITED",
"KROWN INFRASTRUCTURE EQUIPMENTS LIMITED",
"KROX CAPITAL SERVICES PRIVATE LIMITED",
"KROYWEN SERVICES PRIVATE LIMITED",
"KRP ENGINEERING PRIVATE LIMITED",
"KRP MEDIA PRIVATE LIMITED",
"KRPC LISHEN BATTERY INDIA PRIVATE LIMITED",
"KRPS MOBITECH PRIVATE LIMITED",
"KRR INSTITUTE OF INFORMATION TECHNOLOGY",
"KRR VIGNAN JR DEGREE PG COLLEGE",
"KRRG TEXTILES PRIVATE LIMITED",
"KRRISH ACQUA PRIVATE LIMITED",
"KRRISH AUTOWHEELS PRIVATE LIMITED",
"KRRISH MOTORS PRIVATE LIMITED",
"KRRISH SHALIMAR PROJECTS PRIVATE LIMITED",
"KRRISHAADHYA FOODS PRIVATE LIMITED",
"KRRISHAY BIOFUELS PRIVATE LIMITED",
"KRS BUILDINFRA PRIVATE LIMITED",
"KRS ERECTORS PRIVATE LIMITED",
"KRS GOLD AND DIAMOND JEWELLERY PRIVATE LIMITED",
"KRS GROUP",
"KRS HOME DEVELOPERS PRIVATE LIMITED",
"KRS MEGAFOODS PRIVATE LIMITED",
"KRS MULTI LUB PRIVATE LIMITED",
"KRS MULTIPRO PRIVATE LIMITED",
"KRS MULTISPECIALITY HOSPITAL PRIVATE LIMITED",
"KRS PHARMACEUTICALS PRIVATE LIMITED",
"KRS POLYFAB",
"KRS RECYCLING TECHNOLOGIES PRIVATE LIMITED",
"KRSALA JEWELS PRIVATE LIMITED",
"KRSHNA MEDIA AND ASSOCIATES PRIVATE LIMITED",
"KRSKA CAPITAL PRIVATE LIMITED",
"KRSM GLOBAL CORPORATE SERVICES PRIVATE LIMITED",
"KRSNA DIAGNOSTICS (MUMBAI) PRIVATE LIMITED",
"KRSNA ENGIMECH PRIVATE LIMITED",
"KRSNA PACKAGING PRIVATE LIMITED",
"KRSNA STRUCTURES PRIVATE LIMITED",
"KRSNA TRANSMISSION HARDWARE MANUFACTURING PRIVATE LIMITED",
"KRSNAA DIAGNOSTICS LIMITED",
"KRSTAL IMPEX PRIVATE LIMITED",
"KRSV INNOVATIVE AUTO SOLUTIONS PRIVATE LIMITED",
"KRSV INTER COLLEGE NAGLA",
"KRT FOODS PRIVATE LIMITED",
"KRTYA SPORTS & EVENTS PRIVATE LIMITED",
"KRUEGER INTERNATIONAL FURNITURE SYSTEMS PRIVATE LIMITED",
"KRUGER CHEMICALS LIMITED",
"KRUGER M AND E INDUSTRIES INDIA PRIVATE LIMITED",
"KRUGER METAFORM INDIA PRIVATE LIMITED",
"KRUGER VENTILATION INDUSTRIES INDIA PRIVATE LIMITED",
"KRUGER VENTILATION INDUSTRIES NORTH INDIA PRIVATE LIMITED",
"KRUM ALLOYS INDUSTRIES PRIVATE LIMITED",
"KRUNAL GEMS & JEWELLERY PRIVATE LIMITED",
"KRUNAL INDUSTRIES PRIVATE LIMITED",
"KRUNAL ISPAT PRIVATE LIMITED",
"KRUNAL MOTORS PRIVATE LIMITED",
"KRUNAL TRADING AND INVESTMENT PVT LTD",
"KRUNG THAI BANK",
"KRUNG THAI BANK PUBLIC COMPANY LIMITED",
"KRUNISH ENGINEERS AND FABRICATORS PRIVATE LIMITED",
"KRUPA CHATON MANUFACTURING COMPANY PRIVATE LIMITED",
"KRUPA CONTAINERS PRIVATE LIMITED",
"KRUPA LAND LIMITED",
"KRUPA POLYMERS PRIVATE. LIMITED.",
"KRUPA TECH PRIVATE LIMITED",
"KRUPALI FASHIONS PRIVATE LIMITED",
"KRUPALU METALS PRIVATE LIMITED",
"KRUPALU PROTEINS PRIVATE LIMITED",
"KRUPALU RICE INDUSTRIES PRIVATE LIMITED",
"KRUPAMAYI HEALTH CARE PRIVATE LIMITED",
"KRUPANIDHI EDUCATIONAL TRUST",
"KRUPAY TRADEPIPES PRIVATE LIMITED",
"KRUPP INDUSTRIES INDIA LIMITED",
"KRUPP J B M PRIVATE LIMITED",
"KRUSHA PREMIUM INDUSTRIES PRIVATE LIMITED",
"KRUSHAK AGRO & INFRASTRUCTURE PRIVATE LIMITED",
"KRUSHAK MITRA AGRO SERVICES PRIVATE LIMITED",
"KRUSHANA SEEDS PRIVATE LIMITED",
"KRUSHI AMRUT MILK PRIVATE LIMITED",
"KRUSHI BAZAR UTPANNA SAMITI JALNA",
"KRUSHI CHEM AGRO PRIVATE LIMITED",
"KRUSHI FOODS AND SPICES PRIVATE LIMITED",
"KRUSHI INFRAPROJECTS INDIA PRIVATE LIMITED",
"KRUSHI INFRAS INDIA PRIVATE LIMITED",
"KRUSHI NITYANAND PRIVATE LIMITED",
"KRUSHI UTPANNA BAJAR SAMITI KADA UP BAZAR SAMITI KADA ASHTI BEED",
"KRUSHI UTPANNA BAZAR SAMITI PUNE",
"KRUSHI VEG SEEDS (I) PRIVATE LIMITED",
"KRUSHIDEEP AGRICULTURAL PRODUCER COMPANY LIMITED",
"KRUSHIDHAN PRODUCER COMPANY LIMITED",
"KRUSHINAGAR MADHYAMIK VIDYALAYA DHULE",
"KRUSHINATH GREEN ENERGY LIMITED",
"KRUSHIPLUS FARMER PRODUCER COMPANY LIMITED",
"KRUSHIRAJ SUGAR LIMITED",
"KRUSHIRAJA FARMERS PRODUCER COMPANY LIMITED",
"KRUSHISAGAR FARM CULTIVATORS PRODUCER COMPANY LIMITED",
"KRUSHISAHYOG FARMERS PRODUCER COMPANY LIMITED",
"KRUSHISEVA BIO-ORGANIC FERTILIZER INDIA PRIVATE LIMITED",
"KRUSHITEK PRIVATE LIMITED",
"KRUSHIVAIBHAV AGRO FARMERS PRODUCER COMPANY LIMITED",
"KRUSHIVEDH AGRO AND FISH FARMERS PRODUCER COMPANY LIMITED",
"KRUSHNA CASUAL WEARS PRIVATE LIMITED",
"KRUSHNA CONTRACTING PRIVATE LIMITED",
"KRUSHNA DARSHAN INFRA",
"KRUSHNA FERTILIZERS AND CHEMICALS PRIVATE LIMITED",
"KRUSHNA INDUSTRIES",
"KRUSHNAI MEDITEXT PRIVATE LIMITED",
"KRUSHNAKARTIKI PAPERCORE PRIVATE LIMITED",
"KRUSHNAM AGRI PRIVATE LIMITED",
"KRUSHNAM INFRA PRIVATE LIMITED",
"KRUSHNARAJ BIO FUEL PRIVATE LIMITED",
"KRUSHNAVEER APPLIANCES PRIVATE LIMITED",
"KRUSHONNATI SHETKARI PRODUCER COMPANY LIMITED",
"KRUSH-TAR INDUSTRIES PRIVATE LIMITED",
"KRUTAM TECHNOSOLUTIONS PRIVATE LIMITED",
"KRUTI ENGINEERS LIMITED",
"KRUTI FOODS PRIVATE LIMITED",
"KRUTI HUMAN RESOURCES PRIVATE LIMITED",
"KRUTI POWER PROJECTS PRIVATE LIMITED",
"KRUTI PROMOTIONS & EVENTS PRIVATE LIMITED",
"KRUTIKA AGRO PRODUCE PRIVATE LIMITED",
"KRUTIKA SEEDS PRIVATE LIMITED",
"KRUTTIKA TEXPORT PRIVATE LIMITED",
"KRUX PHARMA PRIVATE LIMITED",
"KRV GREEN PRIVATE LIMITED",
"KRYDEL CHEM PRIVATE LIMITED",
"KRYFS FABRICATIONS PRIVATE LIMITED",
"KRYFS POWER COMPONENTS LIMITED",
"KRYFS TRANSFORMERS PRIVATE LIMITED",
"KRYOLAN COSMETICS INDIA PRIVATE LIMITED",
"KRYOVESS PRIVATE LIMITED",
"KRYPC TECHNOLOGIES PRIVATE LIMITED",
"KRYPT INDIA PRIVATE LIMITED",
"KRYPTOAGILE SOLUTIONS PRIVATE LIMITED",
"KRYPTON BIOMEDICALS PRIVATE LIMITED",
"KRYPTON DATAMATICS LTD",
"KRYPTON FASHIONS PRIVATE LIMITED",
"KRYPTON HEALTHCARE",
"KRYPTON INDIA SOLUTIONS PRIVATE LIMITED",
"KRYPTON INDUSTRIES LTD",
"KRYPTON INFOTECH AND LEASING PRIVATE LIMITED",
"KRYPTON POLYMERS PRIVATE LIMITED",
"KRYPTON POWER CONTROLS (INDIA) PRIVATE LIMITED",
"KRYPTON STAINLESS PRIVATE LIMITED",
"KRYPTOS CONSULTING SERVICES PRIVATE LIMITED",
"KRYPTOS NETWORKS PRIVATE LIMITED",
"KRYPTOS TECHNOLOGIES PRIVATE LIMITED",
"KRYSALIS CONSULTANCY SERVICES PRIVATE LIMITED",
"KRYSH RETAIL PRIVATE LIMITED",
"KRYSHNAJAY DEVELOPERS PRIVATE LIMITED",
"KRYSTA CROP SOLUTIONS PRIVATE LIMITED",
"KRYSTAL ALLIED SERVICES PRIVATE LIMITED",
"KRYSTAL AVIATION SERVICES PRIVATE LIMITED",
"KRYSTAL FIBROTECH PROJECTS PRIVATE LIMITED",
"KRYSTAL FINE CHEMICALS PRIVATE LIMITED",
"KRYSTAL GLOBAL ENGINEERING LIMITED",
"KRYSTAL GOURMET PRIVATE.LIMITED",
"KRYSTAL INTEGRATED SERVICES LIMITED",
"KRYSTAL INTEGRATED SERVICES PRIVATE LIMITED",
"KRYSTAL STEEL MANUFACTURING PRIVATE LIMITED",
"KRYSTALS CABLES INDIA PRIVATE LIMITED",
"KRYSTALVISION IMAGE SYSTEMS PRIVATE LIMITED",
"KRYSTTAL MOTORS PRIVATE LIMITED",
"KRYTECH TECHNOLOGIST PRIVATE LIMITED",
"KRYTHIUM SOLUTIONS PRIVATE LIMITED",
"KRYTON BUILDMAT COMPANY PRIVATE LIMITED",
"KRYZEN BIOTECH PRIVATE LIMITED",
"KRZ TRADEX PRIVATE LIMITED",
"KS AMINE CHEMICALS INDIA PRIVATE LIMITED",
"KS ARCIS OUTSOURCING PRIVATE LIMITED",
"KS DISTRIBUTION AND SALES PRIVATE LIMITED",
"KS DISTRIBUTORS PRIVATE LIMITED",
"KS ENTERPRISES",
"KS FOODS AND BEVERAGES PRIVATE LIMITED",
"KS HEGDE HOSPITAL",
"KS INFRATECH PRIVATE LIMITED",
"KS METALS & MINING INDUSTRIES PRIVATE LIMITED",
"KS MULTIFACILITY SERVICES PRIVATE LIMITED",
"KS PRECISION COMPONENTS PRIVATE LIMITED",
"KS PROPMART PRIVATE LIMITED",
"KS RUCHI LIFESTYLE PRIVATE LIMITED",
"KS SHREEYA INFRASTRUCTURE PRIVATE LIMITED",
"KS SMART SOLUTIONS PRIVATE LIMITED",
"KS WIND & RENEWABLES INDIA PRIVATE LIMITED",
"KSA EDUCATIONAL SERVICES PRIVATE LIMITED",
"KSA METAFAB INDUSTRY PRIVATE LIMITED",
"KSA POWERINFRA PRIVATE. LIMITED.",
"KSA SHARES AND SECURITIES PRIVATE LIMITED",
"KSATHEESAN REALTORS PRIVATE LIMITED",
"KSB AND SMART SOLUTIONS PRIVATE LIMITED",
"KSB BUILDERS AND SUPPLIES",
"KSB LIMITED",
"KSB MIL CONTROLS LIMITED",
"KSB TECH PRIVATE LIMITED",
"KSB TRAIN CARGO CARRIERS PRIVATE LIMITED",
"KSBIOMED HEALTHCARE PRIVATE LIMITED",
"KSBL COMMODITY BROKERS PRIVATE LIMITED",
"KSBPS TECHNOLOGY PRIVATE LIMITED",
"KSC FORGE PRIVATE LIMITED",
"KSC KRISHNA STEEL PRIVATE LIMITED",
"KSC METALLURGY PRIVATE LIMITED",
"KSCS INFRA PRIVATE LIMITED",
"KSD EQUIPMENTS PRIVATE LIMITED",
"KSD TECHNOLOGIES PRIVATE LIMITED",
"KSDM AGRO INDUSTRIES PRIVATE LIMITED",
"KSE ELECTRICALS PVT LTD",
"KSE LIMITED",
"KSERVE BPO PRIVATE LIMITED",
"KSF 9 CORPORATE SERVICES PRIVATE LIMITED",
"KSFES",
"KSG ARTS SCIENCE COLLEGE",
"KSG TECHNOLOGIES PRIVATE LIMITED",
"KSH AGRO FOODS BANGALORE PRIVATE LIMITED",
"KSH AUTOMOTIVE PRIVATE LIMITED",
"KSH DISTRIPARKS PRIVATE LIMITED",
"KSH INTERNATIONAL PRIVATE LIMITED",
"KSH LOGISTICS PRIVATE LIMITED",
"KSH PROJECTMANAGEMENT SERVICES PRIVATE LIMITED",
"KSH PROJECTS PRIVATE LIMITED",
"KSHAMA BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"KSHAMA SURGICAL PRIVATE LIMITED",
"KSHAMATA INNOVATION FOUNDATION",
"KSHAMATA SOCIO TECH PRIVATE LIMITED",
"KSHATRIYA VIDHYASALA ENGLISH MEDIUM SCHOOL",
"KSHEER SAGAR DEVELOPERS PVT LTD",
"KSHEER SAGAR PRIVATE LIMITED",
"KSHEM KALYANI INDUSTRIES",
"KSHETHRA INDUSTRIES PRIVATE LIMITED",
"KSHETRA CONSULTANCY SERVICES PRIVATE LIMITED",
"KSHETRA INFRACON PRIVATE LIMITED",
"KSHETRIYA AYURVEDIC & UNANI ADHIKARI OFFICE",
"KSHIPAN ESTATES AND ENTERPRISE PRIVATE LIMITED",
"KSHIPRA & COMPANY PVT LTD",
"KSHIPRA BIOTECH PRIVATE LIMITED",
"KSHIPRA DRUGS PRIVATE LIMITED",
"KSHIPRA INNOVATIVE SOLUTIONS PRIVATE LIMITED",
"KSHIPRA RESTAURANTS PRIVATE LIMITED",
"KSHITIJ COLONISERS PRIVATE LIMITED",
"KSHITIJ INFRAPROJECTS PRIVATE LIMITED",
"KSHITIJ INTERIORS PRIVATE LIMITED",
"KSHITIJ KITCHENCARE PRIVATE LIMITED",
"KSHITIJ KUMAR CHOUDHARY",
"KSHITIJ MARINE SERVICES PRIVATE LIMITED",
"KSHITIJ POLYLINE LIMITED",
"KSHITIJ PORTFOLIO PRIVATE LIMITED",
"KSHITIJ TRADING PRIVATE LIMITED",
"KSHITIJA INFRASTRUCTURE PRIVATE LIMITED",
"KSHITIRAJ REALTY PRIVATE LIMITED",
"KSHITIZ SOLAR ENERGY PRIVATE LIMITED",
"KSHREEN TEXTILES PRIVATE LIMITED",
"KSHUMAT ENERGY PRIVATE LIMITED",
"KSI MEDICARE PRIVATE LIMITED",
"KSITIH INFRACON PRIVATE LIMITED",
"KSJ DYNAMIC SECURITY PRIVATE LIMITED",
"KSJ RECRUITMENT PRIVATE LIMITED",
"KSJ RECYCLERS PRIVATE LIMITED",
"KSJ TECHNO SERVICES PRIVATE LIMITED",
"KSJN CHEMICALS PRIVATE LIMITED",
"KSK ENERGY RESOURCES PRIVATE LIMITED",
"KSK ENGINEERING INDUSTRIES PRIVATE LIMITED",
"KSK PACKAGING SOLUTIONS PRIVATE LIMITED",
"KSK STONE CRUSHER PRIVATE LIMITED",
"KSK SURYA PHOTOVOLTAIC VENTURE LIMITED",
"KSK WIND ENERGY PRIVATE LIMITED",
"KSKT AGROMART PRIVATE LIMITED",
"KSL CARGO PRIVATE LIMITED",
"KSL CLEANTECH LIMITED",
"KSL DEVELOPERS PRIVATE LIMITED",
"KSL DIGITAL VENTURES LIMITED",
"KSL HOLDINGS PRIVATE LIMITED",
"KSL MEDIA LIMITED",
"KSM COMMODITIES PRIVATE LIMITED",
"KSM CONSTRUCTION PRIVATE LIMITED",
"KSM MARINE LOGISTICS PRIVATE LIMITED",
"KSM METALLURGICALS LIMITED",
"KSM NIKETAN PRIVATE LIMITED",
"KSMAHADEV CONSTECH PRIVATE LIMITED",
"KSMZ PROPERTIES PRIVATE LIMITED",
"KSN AUTOMOBILES PRIVATE LIMITED",
"KSN HEALTHCARE PRIVATE LIMITED",
"KSN IMPEX PRIVATE LIMITED",
"KSN PRASAD ENGINEERING AND PRESTRESSED PRODUCTS PVT LTD",
"KSN TOURS PRIVATE LIMITED",
"KSNR IMMEGRATION SERVICES PRIVATE LIMITED",
"KSOLVES INDIA LIMITED",
"KSP CORPORATION PRIVATE LIMITED",
"KSP ELECTRO ENGINEERING (INDIA) PRIVATE LIMITED",
"KSP FIBRE PRODUCTS PRIVATE LIMITED",
"KSP HYDRO ENGINEERS PRIVATE LIMITED",
"KSP INC",
"KSP INDIA PRIVATE LIMITED",
"KSP METAL FORGE PRIVATE LIMITED",
"KSPG AUTOMOTIVE INDIA PRIVATE LIMITED",
"KSPK AGRI PRIVATE LIMITED",
"KSPN FINCON PRIVATE LIMITED",
"KSPOTFI SYSTEMS INDIA PRIVATE LIMITED",
"KSQUARE ENERGY PRIVATE LIMITED",
"KSQUARE EXIM PRIVATE LIMITED",
"KSQUARE METALS TRADING PRIVATE LIMITED",
"KSR CAPITAL SERVICES LTD",
"KSR COTTON AGENCIES",
"KSR DEVELOPERS PRIVATE LIMITED",
"KSR EYECARE PRIVATE LIMITED",
"KSR HANDLOOMS PRIVATE LIMITED",
"KSR HOLIDAYS LLP",
"KSR MARINE SERVICES PRIVATE LIMITED",
"KSR MOTORS PRIVATE LIMITED",
"KSR PROPERTIES PRIVATE LIMITED",
"KSR RENEWABLES PRIVATE LIMITED",
"KSR ROOFINGS & INFRASTRUCTURE PRIVATE LIMITED",
"KSR TEXTILES INDIA PRIVATE LIMITED",
"KSRS EXPORTS PRIVATE LIMITED",
"KSS ABHISHEK SAFETY SYSTEMS PRIVATE LIMITED",
"KSS AUTO PRIVATE LIMITED",
"KSS ELECTRODES PRIVATE LIMITED",
"KSS HOSPITALS PRIVATE LIMITED",
"KSS PROGRESSIVE CAPITAL PRIVATE LIMITED",
"KSS SHIPPING SERVICES PRIVATE LIMITED",
"KSSR PLYBOARD PVT LTD",
"KST ISPAT PRIVATE LIMITED",
"KST PHARMACEUTICALS PRIVATE LIMITED",
"KSTRATA IT SOLUTIONS PRIVATE LIMITED",
"KSU AVIATION PRIVATE LIMITED",
"KSV COTTON MILLS PRIVATE LIMITED",
"KSV ELECTRICALS PRIVATE LIMITED",
"KSV OILS & SEEDS PRIVATE LIMITED",
"KSW INDIA PRIVATE LIMITED",
"KSY PROJECTS PRIVATE LIMITED",
"KT TELEMATIC SOLUTIONS PRIVATE LIMITED",
"KT WELDING TECHNOLOGIES PRIVATE LIMITED",
"KTA POWERS PRIVATE LIMITED",
"KTB VENTURES HOLDING PRIVATE LIMITED",
"KTBHAI LCD PRIVATE LIMITED",
"KTBL PRIVATE LIMITED",
"KTC AGRO BHARAT PRIVATE LIMITED",
"KTC AUTOMOTIVE COMPANY",
"KTC ENTERPRISES PRIVATE LIMITED",
"KTC PUMPS PRIVATE LIMITED",
"KTC TRANSLOGISTICS INDIA PRIVATE LIMITED",
"KTE JUFENG SOLDER MANUFACTURING PRIVATE LIMITED",
"K-TECH ENGINEERS (INDIA) PRIVATE LIMITED",
"KTECH POLYMERS PRIVATE LIMITED",
"K-TEK RESOURCING",
"KTEX NONWOVENS PRIVATE LIMITED",
"KTF FASHION PRIVATE LIMITED",
"KTG HOTELS & RESORTS PRIVATE LIMITED",
"KTG SOFTWARE PRIVATE LIMITED",
"KTGY INDIA PRIVATE LIMITED",
"KTHAN PLYWOODS PRIVATE LIMITED",
"KTK GROUP CO LTD",
"KTK MACHINES (INDIA) PRIVATE LIMITED",
"KTL AUTOMOBILE PRIVATE LIMITED",
"KTL INDUSTRIES LIMITED",
"KTL LOGISTICS & SERVICES PRIVATE LIMITED",
"KTL MINERALS PRIVATE LIMITED",
"KTL PRIVATE LIMITED",
"KTL TEXTILE MACHINES PRIVATE LIMITED",
"KTM IMPEX PRIVATE LIMITED",
"KTM PLYWOOD PRIVATE LIMITED",
"KTM TECHNO MOULDS PRIVATE LIMITED",
"KTMS PROPERTIES PRIVATE LIMITED",
"KTM-SPORTMOTORCYCLE INDIA PRIVATE LIMITED",
"KTN DESIGNERS PRIVATE LIMITED",
"KTN FASHIONS PRIVATE LIMITED",
"KTN RESTAURANTS PRIVATE LIMITED",
"KTPL INSTRUMENTS PRIVATE LIMITED",
"KTR COUPLINGS INDIA PRIVATE LIMITED",
"KTRIAN SOLUTIONS PRIVATE LIMITED",
"KT'S CONSTRUCTION PRIVATE LIMITED",
"KT'S DESI WORLD PRIVATE LIMITED",
"KTST ENGINEERS PRIVATE LIMITED",
"KTV INFRASTRUCTURE PRIVATE LIMITED",
"KTWO HEALTHCARE PRIVATE LIMITED",
"KTWO TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"KU INDUSTRIES PRIVATE LIMITED",
"KU KOO CH KU POULTRY FARM PRIVATE LIMITED",
"KU S G PATEL VIDYALAY VIHAN",
"KUANTUM PAPERS LIMITED",
"KUANTUM TECHNOLOGIES PRIVATE LIMITED",
"KUB QUALITY SERVICES PRIVATE LIMITED",
"KUBE AUTOTECH PRIVATE LIMITED",
"KUBER AGRICOM (INDIA) PRIVATE LIMITED",
"KUBER CASTING PRIVATE LIMITED",
"KUBER COTSPIN PRIVATE LIMITED",
"KUBER CREATIONS PRIVATE LIMITED",
"KUBER ENTERPRISES",
"KUBER FINSTOCK PRIVATE LIMITED",
"KUBER FOODS",
"KUBER FOUNDRY PVT LTD",
"KUBER GLOBALS LIMITED (TRF)",
"KUBER GRAINS & SPICES PRIVATE LIMITED",
"KUBER GUESTLINE HOTELS & RESORTS PRIVATE LIMITED",
"KUBER HEALTHFOOD AND ALLIED SERVICES PRIVATE LIMITED",
"KUBER HOSPITALITY PRIVATE LIMITED",
"KUBER IMPEX LIMITED",
"KUBER ISPAT & DEVELOPERS PRIVATE LIMITED",
"KUBER KANAK MICROFINANCE ASSOCIATION",
"KUBER MART INDUSTRIES PRIVATE LIMITED",
"KUBER METPACK PRIVATE LIMITED",
"KUBER MULTI SPECIALITY HOSPITALS PRIVATE LIMITED",
"KUBER PACKAGING INDUSTRIES PRIVATE LIMITED",
"KUBER PIPES PRIVATE LIMITED",
"KUBER PLASTICS PRIVATE LIMITED",
"KUBER POLYCHEM PRIVATE LIMITED",
"KUBER POLYFAB PRIVATE LIMITED",
"KUBER PRODUCTS",
"KUBER RICE INDIA PRIVATE LIMITED",
"KUBER SOLUTIONS AND INFRASTRUCTURE PRIVATE LIMITED",
"KUBER STAR PRIVATE LIMITED",
"KUBER STEEL INDUSTRIES PRIVATE LIMITED",
"KUBER TEXLEN PRIVATE LIMITED",
"KUBER TRADING PRIVATE LIMITED",
"KUBER TRAVELS PRIVATE LIMITED",
"KUBER TREXIM PVT LTD",
"KUBER TUBES & FITTINGS PRIVATE LIMITED",
"KUBERA CORPORATES PRIVATE LIMITED",
"KUBERA FANTASY PRIVATE LIMITED",
"KUBERA RICE MILLS PRIVATE LIMITED",
"KUBERA SOLUTIONS PRIVATE LIMITED",
"KUBERA UNIVERSAL (OPC) PRIVATE LIMITED",
"KUBERAKSHI ADVISORY SERVICES PRIVATE LIMITED",
"KUBERAY REALTY INDIA PRIVATE LIMITED",
"KUBERBOX LIFESTYLE PRIVATE LIMITED",
"KUBERKAMNA MARBLES PRIVATE LIMITED",
"KUBERRE HIGH PERFORMANCE COMPUTING PRIVATE LIMITED",
"KUBERTARA MANUFACTURERS PRIVATE LIMITED",
"KUBIK INDIA PRIVATE LIMITED",
"KUBO CHEMICALS PVT LTD",
"KUBO COMBUSTION EFFICIENCY CHEMICALS PRIVATE LIMITED",
"KUBOS CONSULTANCY SERVICES PRIVATE LIMITED",
"KUBOTA AGRICULTURAL MACHINERY INDIA PRIVATE LIMITED",
"KUBOTA CORPORATION",
"KUBS IMPEX PRIVATE LIMITED",
"KUCHENA COAL TRANSPORT PRIVATE LIMITED",
"KUCHHAL ALLOYS PRIVATE LIMITED",
"KUDALE ENGINEERING PRIVATE LIMITED",
"KUDALE TALWELKAR CONSULTING AND SOFTWARE SERVICES PRIVATE LIMITED",
"KUDANTHAI MOTORS PRIVATE LIMITED",
"KUDGI TRANSMISSION LIMITED",
"KUDILAL GOVINDRAM SEKSARIA SARVODAYA SCHOOL",
"KUDOS FASHIONS PRIVATE LIMITED",
"KUDOS FINANCE AND INVESTMENTS PRIVATE LIMITED",
"KUDOS INTERNATIONAL TRAVEL & TOURS P L",
"KUDOS KNOWLEDGE SERVICES PRIVATE LIMITED",
"KUDOS LABORATORIES INDIA LIMITED",
"KUDOS TEXTILES PRIVATE LIMITED",
"KUDOSINTECH SOFTWARE PRIVATE LIMITED",
"KUDRA CONSTRUCTION LIMITED",
"KUDRAT HOLDINGS PVT LTD",
"KUDRAT HOTEL PRIVATE LIMITED",
"KUDRAT IMPEX PRIVATE LIMITED",
"KUDROLI BUILDERS AND INFRASTRUCTURES PRIVATE LIMITED",
"KUDROLI CONSTRUCTIONS COMPANY PRIVATE LIMITED",
"KUDU INDUSTRIES LIMITED",
"KUDU KNIT PROCESS PRIVATE LIMITED",
"KUDUMA FASTENERS PRIVATE LIMITED",
"KUDZU BUSINESS CONSULTANCY PRIVATE LIMITED",
"KUDZUINFOTECH PRIVATE LIMITED",
"KUEBLER AUTOMATION INDIA PRIVATE LIMITED",
"KUEHNE + NAGEL PRIVATE LIMITED",
"KUEMEN LABORATORIES PRIVATE LIMITED",
"KUFNER TEXTILES INDIA PRIVATE LIMITED",
"KUFRI BUILDCON PRIVATE LIMITED",
"KUFRI FUN CAMPUS PRIVATE LIMITED",
"KUFRI HOTELS PVT LTD",
"KUFRI ICE AND COLD STORAGE PRIVATE LIMITED",
"KUHELI DEALCOM PVT LTD",
"KUHU INDUSTRIES PRIVATE LIMITED",
"KUI PUMPS PRIVATE LIMITED",
"KUJJAL HOTELS PRIVATE LIMITED",
"KUJUDU AGRO PRIVATE LIMITED",
"KUK BO HOTELS & RESORTS INDIA PRIVATE LIMITED",
"KUKA INDIA PRIVATE LIMITED",
"KUKA SYSTEMS INDIA PRIVATE LIMITED",
"KUKADI PROJECT CIRCLE PUNE",
"KUKADIA VENTURES PRIVATE LIMITED",
"KUKDO CHEMICAL INDIA PRIVATE LIMITED",
"KUKDONG COOLANT INDIA PRIVATE LIMITED",
"KUKJE BUSINESS SOLUTION PRIVATE LIMITED",
"KUKKE HYDRO PROJECTS PRIVATE LIMITED",
"KUKKU CAPITAL PRIVATE LIMITED",
"KU-KOO-CH-KU POULTRY FARM",
"KUKREJA AUTO COMPONENTS PRIVATE LIMITED",
"KUKREJA BUILDERS PRIVATE LIMITED",
"KUKREJA HOSPITAL AND HEART CENTRE PRIVATE LIMITED",
"KUKREJA MARKETING PRIVATE LIMITED",
"KUKREJA METAL FAB PRIVATE LIMITED",
"KUKRETI STEEL PRIVATE LIMITED",
"KUKRU WIND POWER PRIVATE LIMITED",
"KUKSONS ELECTRONICES PRIVATE LIMITED",
"KUKSONS TELESYS PRIVATE LIMITED",
"KUKU FASHION PRIVATE LIMITED",
"KUKUN INDIA PRIVATE LIMITED",
"KUKURJAN TEA PROCESSING PRIVATE LIMITED",
"KULACHI HANSRAJ MODEL SCHOOL",
"KULAR HOSPITALS PRIVATE LIMITED",
"KULDATTA CHEMICALS PRIVATE LIMITED",
"KULDEEP COZY CABZ PRIVATE LIMITED",
"KULDEEP IMPEX PRIVATE LIMITED",
"KULDEEP LABELS PRIVATE LIMITED",
"KULDEEP METAL PRIVATE LIMITED",
"KULDEEP MOTORS LUCKNOW PRIVATE LIMITED",
"KULDEEP MOTORS PRIVATE LIMITED",
"KULDEEP POULTARY PRIVATE LIMITED",
"KULDEEP SINGH MEMORIAL PUBLIC SCHOOL",
"KULDEEP SINGH SUKHVINDER SINGH & OTHERS",
"KULDEVI COTTON INDUSTRIES",
"KULDEVI TRANSPORT COMPANY PRIVATE LIMITED",
"KULDIP ENGINEERING INDUSTIRES LIMITED",
"KULDIP ENTERPRISES INDIA LIMITED",
"KULDIP OSWAL COTSPIN PRIVATE LIMITED",
"KULDIP OSWAL GARMENTS PRIVATE LIMITED",
"KULDIP OSWAL HOSIERY MILLS PRIVATE LIMITED",
"KULDIP SINGH SONS PRIVATE LIMITED",
"KULDIP SONS JEWELLERS PRIVATE LIMITED",
"KULIN IMPEX PRIVATE LIMITED",
"KULINKUMAR HOLIDAYS PRIVATE LIMITED",
"KULIZA TECHNOLOGIES PRIVATE LIMITED",
"KULJA INDUSTRIES LIMITED",
"KULKARNI CONSTRUCTIONS PVT LTD",
"KULKARNI ORGANICS PRIVATE LIMITED",
"KULKARNI PRECITECH PRIVATE LIMITED",
"KULKARNI PUMPS PRIVATE LIMITED",
"KULKARNI SALES PRIVATE LIMITED",
"KULKARNI TRANSPOWER PRIVATE LIMITED",
"KULLOLLI INSTITUTE OF HEALTH SERVICES PRIVATE LIMITED",
"KULODAY PLASTOMERS PRIVATE LIMITED",
"KULODAY TECHNOPACK PRIVATE LIMITED",
"KULOSINI JR HIGH SCHOOL",
"KULPAK STEEL & FORGINGS PRIVATE LIMITED",
"KULSI PRODUCTS PRIVATE LIMITED",
"KULSWAMI FOOD INDUSTRIES PRIVATE LIMITED",
"KULSWAMINI ENTERPRISES",
"KULSWAMINI LOGISTICS AND ASSEMBLY SERVICES PRIVATE LIMITED",
"KULT COSMETICS PRIVATE LIMITED",
"KULTHIAA JEWEL PRIVATE LIMITED",
"KULTURE FOREVER PRIVATE LIMITED",
"KULTURE SHOP PRIVATE LIMITED",
"KULWAL IRON AND STEEL PRIVATE LIMITED",
"KUMADA CARS PRIVATE LIMITED",
"KUMAGAI GUMI COMPANY LIMITED",
"KUMAGAI INDIA PRIVATE LIMITED",
"KUMAIS ENTERPRISES PRIVATE LIMITED",
"KUMAON ENTERTAINMENT AND HOSPITALITIES PRIVATE LIMITED",
"KUMAON EXPORTS PRIVATE LIMITED",
"KUMAON GEORESOURCE PRIVATE LIMITED",
"KUMAON ISPAAT PRIVATE LIMITED",
"KUMAON RADIOS & ELECTRONICS PRIVATE LIMITED",
"KUMAR & SARRAF HEALTHCARE PRIVATE LIMITED",
"KUMAR ADHESIVE PVT LTD",
"KUMAR AEROSOLS PRIVATE LIMITED",
"KUMAR AGRO PRODUCTS PRIVATE LIMITED",
"KUMAR AGRO TECH PRIVATE LIMITED",
"KUMAR AGROMILLS PRIVATE LIMITED",
"KUMAR AND BROTHERS INFRASTRUCTURES PRIVATE LIMITED",
"KUMAR AND COMPANY AVENUES PRIVATE LIMITED",
"KUMAR ARCH TECH PRIVATE LIMITED",
"KUMAR ASHUTOSH INSTITUTION",
"KUMAR AUDYOGIK VIKAS PRIVATE LIMITED",
"KUMAR AUTO PARTS PVT LTD",
"KUMAR AUTOCAST LIMITED",
"KUMAR AUTOWHEELS PRIVATE LIMITED",
"KUMAR BIKES PRIVATE LIMITED",
"KUMAR BIOSEEDS AND AGRO PRODUCTS PRIVATE LIMITED",
"KUMAR BROTHERS CHEMISTS PRIVATE LIMITED",
"KUMAR BROTHERS PHARMA PRIVATE LIMITED",
"KUMAR BUILDERS CONSORTIUM PRIVATE LIMITED",
"KUMAR BUILDERS PROJECT PUNE PRIVATE LIMITED",
"KUMAR CARGO SOLUTION",
"KUMAR CIVIL INFRA CONSORTIUM INDIA PRIVATE LIMITED",
"KUMAR COMMODITIES PVT LTD",
"KUMAR COMMODITY AND FOOD MANAGEMENT PRIVATE LIMITED",
"KUMAR CONSTRUCTION",
"KUMAR CONSTRUCTION AND PROPERTIES PRIVATE LIMITED",
"KUMAR CONTAINERS PRIVATE LIMITED",
"KUMAR COTTON MILLS PRIVATE LIMITED",
"KUMAR CREATIONS PRIVATE LIMITED",
"KUMAR DAIRY PRIVATE LIMITED",
"KUMAR DHUBI STEELS PRIVATE LIMITED",
"KUMAR DISTRIBUTORS PRIVATE LIMITED",
"KUMAR DRINKS",
"KUMAR ELASTOMECH PRIVATE LIMITED",
"KUMAR ELECTROFIELD PRIVATE LIMITED",
"KUMAR EMPORIUM PRIVATE LIMITED",
"KUMAR ENDECON PRIVATE LIMITED",
"KUMAR ENGINEERING INDIA PRIVATE LIMITED",
"KUMAR EQUIPMENT (INDIA) PRIVATE LIMITED",
"KUMAR FABTEX PRIVATE LIMITED",
"KUMAR FEEDS AND BIOTECH PRIVATE LIMITED",
"KUMAR FERROCAST (INDIA) PRIVATE LIMITED",
"KUMAR GALLERY PRIVATE LTD",
"KUMAR GOYAL MANAGEMENT CONSULTANCY PRIVATE LIMITED",
"KUMAR HEIGHTS PRIVATE LIMITED",
"KUMAR HOSPITALS PRIVATE LIMITED",
"KUMAR INDIA ENGITECH PRIVATE LIMITED",
"KUMAR INDUSTRIES",
"KUMAR INFRACOM PRIVATE LIMITED",
"KUMAR INFRATECH AND CONSTRUCTIONS PRIVATE LIMITED",
"KUMAR INFRATRADE ENTERPRISES PRIVATE LIMITED",
"KUMAR INN PRIVATE LIMITED",
"KUMAR KERING DEVELOPERS LLP",
"KUMAR LABEL HOUSE PRIVATE LIMITED",
"KUMAR MACHINES PRIVATE LIMITED",
"KUMAR MANASH CONSTRUCTION PRIVATE LIMITED",
"KUMAR MESS PRIVATE LIMITED",
"KUMAR METAL INDUSTRIES PRIVATE LIMITED",
"KUMAR METALS PRIVATE LIMITED",
"KUMAR MILK PRODUCTS PRIVATE LIMITED",
"KUMAR MOTOR CORPORATION PRIVATE LIMITED",
"KUMAR ORGANIC PRODUCTS LIMITED",
"KUMAR OUTSOURCING SERVICES INDIA PRIVATE LIMITED",
"KUMAR PAINTS (INDIA) PRIVATE LIMITED",
"KUMAR PIYUSH CONSTRUCTION PRIVATE LIMITED",
"KUMAR PLAZA RESORTS PVT.LTD.",
"KUMAR PRECISION STAMPINGS PRIVATE LIMITED",
"KUMAR PRINTERS PVT LTD",
"KUMAR PRINTING SOLUTIONS PRIVATE LIMITED.",
"KUMAR PROPERTIES AND HOUSING DEVELOPMENT PRIVATE LIMITED",
"KUMAR PROPERTIES AND PROMOTERS PRIVATE LIMITED",
"KUMAR PROPERTIES AND REAL ESTATE PRIVATE LIMITED",
"KUMAR PROPERTIES PRIVATE LIMITED",
"KUMAR RESORTS AND AMUSEMENT PRIVATE LIMITED",
"KUMAR RESTAURANTS AND HOTELIERS PVT LTD",
"KUMAR RICE MILL PRIVATE LIMITED",
"KUMAR ROTOFLEX PRIVATE LIMITED",
"KUMAR SAREE GHAR PRIVATE LIMITED",
"KUMAR SHALA",
"KUMAR SNACKS PRODUCTS PRIVATE LIMITED",
"KUMAR SPICES PRIVATE LIMITED",
"KUMAR SPINTEX PRIVATE LIMITED",
"KUMAR STEEL INDIA",
"KUMAR STEELWAYS PRIVATE LIMITED",
"KUMAR STYRENE PACKAGING PRIVATE LIMITED",
"KUMAR SURGICAL AND LAPAROSCOPIC CLINIC",
"KUMAR TELECOM PRIVATE LIMITED",
"KUMAR URBAN DEVELOPMENT PRIVATE LIMITED",
"KUMAR VIDYA MANDIR HAROLI HAROLI",
"KUMAR VINYLS PRIVATE LIMITED",
"KUMAR WAREHOUSING PRIVATE LIMITED",
"KUMARAGIRI ELECTRONICS LIMITED",
"KUMARAGIRI SPINNERSS PRIVATE LIMITED",
"KUMARAGURU COLLEGE OF TECHNOLOGY-641006",
"KUMARAKOM CUISINE PRIVATE LIMITED",
"KUMARAN AAGRO FOODS",
"KUMARAN ENGINEERING BHOPAL PRIVATE LIMITED",
"KUMARAN FILAMENTS PRIVATE LIMITED",
"KUMARAN FISH NETS PRIVATE LIMITED",
"KUMARAN HOSPITAL",
"KUMARAN HOSPITALS PRIVATE LIMITED",
"KUMARAN INDUSTRIES PRIVATE LIMITED",
"KUMARAN POULTRY FARM",
"KUMARAN SYSTEMS PRIVATE LIMITED",
"KUMARAPALAYAM TOLLWAYS LIMITED",
"KUMARDEEP APPARELS PRIVATE LIMITED",
"KUMARI MONIKABEN RASHMIKANT GARDI VIDHYALAYA",
"KUMARI S G PATEL VIDHYALAY",
"KUMARPUR AGRO POULTRIES LIMITED",
"KUMARS FORGE & VALVES PRIVATE LIMITED",
"KUMAR'S METALLURGICAL CORPORATION LTD",
"KUMAUN GRAMEEN UDYOG",
"KUMAUN MOULDINGS PRIVATE LIMITED",
"KUMAWAT INFRASTRUCTURE PRIVATE LIMITED",
"KUMBAKONAM MUTUAL BENEFIT FUND NIDHI LIMITED",
"KUMBHALGARH JUNGLE RETREAT PRIVATE LIMITED",
"KUMBHALGARH YATRI NIWAS PRIVATE LIMITED",
"KUMBHALKAR COLLEGE OF SOCIAL WORK",
"KUMBHAT ADVISORS PRIVATE LIMITED",
"KUMBHESHWAR ENTERPRISES",
"KUMERGODE ESTATES LIMITED",
"KUMHWA ENTERPRISES PRIVATE LIMITED",
"KUMI INDIA INDUSTRIES PRIVATE LIMITED",
"KUMI LABS PRIVATE LIMITED",
"KUMJAI FARMS LIMITED",
"KUMKANG KIND INDIA PRIVATE LIMITED",
"KUMKUM BUILDCON PRIVATE LIMITED",
"KUMKUM ELECTRIC INDIA PRIVATE LIMITED",
"KUMKUM JEWELS PRIVATE LIMITED",
"KUMKUM MINES & MINERALS PRIVATE LIMITED",
"KUMON INDIA EDUCATION PRIVATE LIMITED",
"KUMOWIZ TECHNOLOGIES PRIVATE LIMITED",
"KUMRA SALES PRIVATE LIMITED",
"KUMUD EXIM AND TRADERS PRIVATE LIMITED",
"KUMUD FOODS AND BEVERAGE PRIVATE LIMITED",
"KUMUD METAL FOUNDRY PRIVATE LIMITED",
"KUMUD MOHABEY MEMORIAL HOSPITAL",
"KUMUD OVERSEAS PRIVATE LIMITED",
"KUMUDA CREATIVE ENGINEERS PRIVATE LIMITED",
"KUMUDHA STEEL TRADING PRIVATE LIMITED",
"KUMUDINI ENGINEERING PRIVATE LIMITED",
"KUMUDVATI VISION PRIVATE LIMITED",
"KUN AEROSPACE PRIVATE LIMITED",
"KUN CAPITAL AUTOMOTIVE PRIVATE LIMITED",
"KUN CAPITAL MOTORS PRIVATE LIMITED",
"KUN CAR ENTERPRISES PRIVATE LIMITED",
"KUN COMMERCIAL VEHICLES PRIVATE LIMITED",
"KUN DEVELOPMENT FOUNDATION",
"KUN MOTOR COMPANY PRIVATE LIMITED",
"KUN MOTOR ENTERPRISES PRIVATE LIMITED",
"KUN MOTOREN",
"KUN MOTOREN PRIVATE LIMITED",
"KUN UNITED CAR TRAX PRIVATE LIMITED",
"KUN UNITED MOTORS PRIVATE LIMITED",
"KUNA IMPEX PRIVATE LIMITED",
"KUNAFA FOODS & BEVERAGES PRIVATE LIMITED",
"KUNAIC RETAIL LLP",
"KUNAL AUTO INDUSTRIES PRIVATE LIMITED",
"KUNAL AUTOMOBILES PRIVATE LIMITED",
"KUNAL AUTOTECH PRIVATE LIMITED",
"KUNAL BOTTLE TRADING CO.PRIVATE LIMITED",
"KUNAL BSBK JOINT VENTURE PRIVATE LIMITED",
"KUNAL CALCIUM LTD",
"KUNAL CLOTHING PRIVATE LIMITED",
"KUNAL CONCHEM PRIVATE LIMITED",
"KUNAL CONSULTANCY PRIVATE LIMITED",
"KUNAL CORPORATION PRIVATE LIMITED",
"KUNAL CRITICAL CARE AND RESEARCH CENTRE PRIVATE LIMITED",
"KUNAL ENTERPRISE PRIVATE LIMITED",
"KUNAL EXIM PVT LTD",
"KUNAL FABRICATORS & ENGG WORKS",
"KUNAL FASHIONS PRIVATE LIMITED",
"KUNAL FOOD PRODUCTS PRIVATE LIMITED",
"KUNAL FOUNDERS AND ENGINEERS PRIVATE LIMITED",
"KUNAL GREEN EARTH PRODUCTS PRIVATE LIMITED",
"KUNAL HOPITAL",
"KUNAL HOUSEWARES PRIVATE LIMITED",
"KUNAL INFRAPROJECT PRIVATE LIMITED",
"KUNAL INTERNATIONAL",
"KUNAL LOHACHEM PRIVATE LIMITED",
"KUNAL MANPOWER SERVICES PRIVATE LIMITED",
"KUNAL MARKETING PVT LTD",
"KUNAL MICRONS PRIVATE LIMITED",
"KUNAL NESTBUILD PRIVATE LIMITED",
"KUNAL OCEAN AGENCY PVT LTD",
"KUNAL OVERSEAS PRIVATE LIMITED",
"KUNAL PHARMA DISTRIBUTORS PRIVATE LIMITED",
"KUNAL PLASTICS PRIVATE LIMITED",
"KUNAL PNEUMATICS PRIVATE LIMITED",
"KUNAL PRINTING & PACKAGING PRIVATE LIMITED",
"KUNAL REMEDIES PRIVATE LIMITED",
"KUNAL SERVICES PRIVATE LIMITED",
"KUNAL SHIPPING AND LOGISTICS PRIVATE LIMITED",
"KUNAL SPACES PRIVATE LIMITED",
"KUNAL STAMPINGS PRIVATE LIMITED",
"KUNAL STRUCTURE INDIA PRIVATE LIMITED",
"KUNAL VAASTU KENDRA PRIVATE LIMITED",
"KUNALRAWALVIBE PRIVATE LIMITED",
"KUNAMNENI TECHNOLOGIES PRIVATE LIMITED",
"KUNARK HITECH MACHINING AND SALES PRIVATE LIMITED",
"KUNASH INSTRUMENTS PRIVATE LIMITED",
"KUNCHALS STORES PRIVATE LIMITED",
"KUN-CHEM PRETREATMENTS PVT LTD",
"KUNDA EXPRESS PRIVATE LIMITED",
"KUNDAL JEWELLERS (INDIA) PRIVATE LIMITED",
"KUNDALI JEWELS INDIA PRIVATE LIMITED",
"KUNDALIA POLYMERS PRIVATE LIMITED",
"KUNDALIN JEWELS PRIVATE LIMITED",
"KUNDALINI YOGA EDUCATIONAL FOUNDATION 3HO",
"KUNDAN CABLES (INDIA) PRIVATE LIMITED",
"KUNDAN CARE PRODUCTS LIMITED",
"KUNDAN CARS PRIVATE LIMITED",
"KUNDAN CASTINGS PRIVATE LIMITED",
"KUNDAN COMPONENTS PRIVATE LIMITED",
"KUNDAN CRAFT PRIVATE LIMITED",
"KUNDAN CREATION",
"KUNDAN CUTLERY PRIVATE LIMITED",
"KUNDAN DEVELOPERS PRIVATE LIMITED",
"KUNDAN DISTRIBUTORS PRIVATE LIMITED",
"KUNDAN EDIFICE LIMITED",
"KUNDAN ELECTRICAL COMPONENTS PRIVATE LIMITED",
"KUNDAN ELECTROPOWER PRIVATE LIMITED",
"KUNDAN ENGINEERS PVT LTD",
"KUNDAN FABRICS PRIVATE LIMITED",
"KUNDAN FURNISHING PRIVATE LIMITED",
"KUNDAN GREEN VALLEY SCHOOL",
"KUNDAN INDUSTRIAL PRODUCTS AND SERVICES",
"KUNDAN JEWELLERS PRIVATE LIMITED",
"KUNDAN LAL IRON & STEEL PRIVATE LIMITED.",
"KUNDAN LEATHERS PRIVATE LIMITED",
"KUNDAN MAL ROOP CHAND JEWELLERS PRIVATE LIMITED",
"KUNDAN METALS PRIVATE LIMITED",
"KUNDAN PESTICHEM PVT LTD",
"KUNDAN PRECISION COMPONENTS PRIVATE LIMITED",
"KUNDAN REFINERY PRIVATE LIMITED",
"KUNDAN RICE MILLS LIMITED",
"KUNDAN SOLAR (ASTONFIELD) PRIVATE LIMITED",
"KUNDAN SWITCH GEARS PRIVATE LIMITED",
"KUNDAN TEXFAB PRIVATE LIMITED",
"KUNDANA TECHNO TEX PRIVATE LIMITED",
"KUNDESHWAR VIDYALAY",
"KUNDLI MANESAR EXPRESSWAY LIMITED",
"KUNDLI METALS PRIVATE LIMITED",
"KUNDLIK AUTOMATION PRIVATE LIMITED",
"KUNDRA FOREX PRIVATE LIMITED",
"KUNDU COLD STORAGE PRIVATE LIMITED",
"KUNDU INFRACOM PRIVATE LIMITED",
"KUNDUBAPI SALES PRIVATE LIMITED",
"KUNDUR CONSTRUCTIONS PRIVATE LIMITED",
"KUNDU'S KITCHEN EQUIPMENT PRIVATE LIMITED",
"KUNG INJU AGRO PVT LTD",
"KUNHAR PERIPHERALS PRIVATE LIMITED",
"KUNIL ILMU ACADEMY",
"KUNJ AGRO PROUDCTS PVT LTD",
"KUNJ ALLOYS PRIVATE LIMITED",
"KUNJ AUTO PARTS MFG PVT LTD",
"KUNJ BEHARI AUTOMOTIVE PRIVATE LIMITED",
"KUNJ BEHARI LAL CHARITABLE TRUST",
"KUNJ BEHARI SHAW AGENCIES PRIVATE LIMITED",
"KUNJ BIHARI BULLIONS & JEWELLERS PRIVATE LIMITED",
"KUNJ BIHARI FOOD PROCESSORS PRIVATE LIMITED",
"KUNJ BIHARI GOLD LEAF INDUSTRIES PRIVATE LIMITED",
"KUNJ BIHARI LAL RADHEY SHYAM METALS PRIVATE LIMITED",
"KUNJ BIHARI PULSES PRIVATE LIMITED",
"KUNJ BIHARI STEEL PRIVATE LIMITED",
"KUNJ COLD-WARE SOLUTIONS PRIVATE LIMITED",
"KUNJ FORGINGS PRIVATE LIMITED",
"KUNJ LUB MARKETING PRIVATE LIMITED",
"KUNJ PHARMA PRIVATE LIMITED",
"KUNJ ROLLER FLOUR MILLS PRIVATE LIMITED",
"KUNJ SERVICES PRIVATE LIMITED",
"KUNJAIVAL HEALTHCARE CENTER PRIVATE LIMITED",
"KUNJAL SYNERGIES PRIVATE LIMITED",
"KUNJAN PLANNERS PRIVATE LIMITED",
"KUNJAN SILICATE PRIVATE LIMITED",
"KUNJBIHARI RICE MILL PRIVATE LIMITED",
"KUNJITA IMPEX PRIVATE LIMITED",
"KUNKEL WAGNER INDIA PVT LTD",
"KUNKR CRYSTAL PRIVATE LIMITED",
"KUNNATH CHEMICALS PVT LTD",
"KUNNATH PAPER MILLS PVT LTD",
"KUNNATHAN CHIP BOARDS PRIVATE LIMITED",
"KUNNATHAN POLYMERS PRIVATE LIMITED",
"KUNNEL ENGINEERS & CONTRACTORS P LIMITED",
"KUNSHAN Q TECH MICROELECTRONICS INDIA PRIVATE LIMITED",
"KUNSKAPSSKOLAN EDUVENTURES PRIVATE LIMITED",
"KUNSKAPSSKOLAN SCHOOL",
"KUNSONS PIPES PRIVATE LIMITED",
"KUNSTOCOM INDIA LIMITED",
"KUNSTOPLAST(INDIA) LIMITED",
"KUNSTSTOFFE INDUSTRIES LIMITED",
"KUNTAL EDUCATIONAL SERVICES PRIVATE. LIMITED.",
"KUNTAL GRANITES PRIVATE LIMITED",
"KUNTAL ICE AND COLD STORAGE PRIVATE LIMITED",
"KUNTE & DRABU CONSULTANTS PRIVATE LIMITED",
"KUNTESHWAR APPLIANCES PVT LTD",
"KUNTHU CONSULTANTS PRIVATE LIMITED (OPC)",
"KUNTHUSAGAR MULTITRADE PRIVATE LIMITED",
"KUNTUNATH MERCHANTS PRIVATE LIMITED",
"KUNTURKAR SUGAR & AGRO PRIVATE LIMITED",
"KUNVARJI COMMODITIES BROKERS PRIVATE LIMITED",
"KUNVARJI COMTRADE RETAIL PRIVATE LIMITED",
"KUNVARJI FINCORP PRIVATE LIMITED",
"KUNVARJI FINSTOCK PRIVATE LIMITED",
"KUNVARJI INFRA-PROPERTIES PRIVATE LIMITED",
"KUNVARJI REALTY ADVISORS",
"KUNVARJI WAREHOUSING AND LOGISTICS PRIVATE LIMITED",
"KUNWAR DEVENDRA SINGH COLD STORAGE AND ICE FACTORY PRIVATE LIMITED",
"KUNWAR HARIBANSH SINGH COLLAGE OF PHARMACY MAHRUPUR JAUNPUR",
"KUNWAR RUKUM SINGH VEDIC INTER COLLEGE",
"KUNWAR SAAB FASHION PRIVATE LIMITED",
"KUNWARIBARI TEA ESTATES PVT LTD",
"KUNWARJI FOODS PRIVATE LIMITED",
"KUNWARS EDUCATIONAL FOUNDATION",
"KUNWARS WELLNESS FOUNDATION",
"KUNZITE CROP SCIENCE PRIVATE LIMITED",
"KUNZOM INFRACON PROJECTS PRIVATE LIMITED",
"KUONI GLOBAL TRAVEL SERVICES (INDIA) PRIVATE LIMITED",
"KUOTIENT REALTY PRIVATE LIMITED",
"KUPARAMJI JEWELLERY PRIVATE LIMITED",
"KUPPLE PRIVATE LIMITED",
"KUPPU EXPORTS PRIVATE LIMITED",
"KUPS FOODS & BEVERAGES PRIVATE LIMITED",
"KUPSA COATINGS PRIVATE LIMITED",
"KURA HOMES PRIVATE LIMITED",
"KURALOANE FAB TECH PRIVATE LIMITED",
"KURARAY INDIA PRIVATE LIMITED",
"KURAULI COLD STORAGE PRIVATE LIMITED",
"KURAUNI MINERALS PRIVATE LIMITED",
"KUREASIA PHARMA PRIVATE LIMITED",
"KURELE CHEMICAL INDUSTRIES PRIVATE LIMITED",
"KURELE PACKAGING PRIVATE LIMITED",
"KURIAMAL REAL ESTATES PRIVATE LIMITED",
"KURIAN ABRAHAM PRIVATE LIMITED",
"KURIANS VISION CARE PRIVATE LIMITED",
"KURIEKAL PROJECTS AND CONTRACTORS PRIVATE LIMITED",
"KURINCHI MATRIC HR SEC SCHOOL",
"KURINJEE PRONATURAL FOODS PRIVATE LIMITED",
"KURINJI COLLEGE OF ARTS AND SCIENCE",
"KURINJI MATRICULATION HIGHER SECONDARY SCHOOL",
"KURINJI SPINNING MILLS PRIVATE LIMITED",
"KURINJI SUPER SPECIALITIES HOSPITAL PRIVATE LIMITED",
"KURIOS FINVEST LLP",
"KURIYA BROTHERS TEXTILE PRIVATE LIMITED",
"KURJ PROJECTS PRIVATE LIMITED",
"KURJI HOLY FAMILY HOSPITAL",
"KURLA GLASS PRIVATE LIMITED",
"KURLON ENTERPRISE LIMITED",
"KURLON LIMITED",
"KURLON RETAIL LIMITED",
"KURMA TRADING PRIVATE LIMITED",
"KURMANCHAL CONSTRUCTION PRIVATE LIMITED",
"KURMI ENERGY PRIVATE LIMITED",
"KURMI NON CONVENTIONAL ENERGY PRIVATE LIMITED",
"KURMITAR IRON ORE MINING PRIVATE LIMITED",
"KURMUR FOODS PVT.LTD.",
"KURNOOL CYLINDERS PRIVATE LIMITED",
"KURNOOL HOSPITAL ENTERPRISES LIMITED",
"KURNOOL INSTITUTE OF ONCOLOGY PRIVATE LIMITED",
"KURNOOL SEEDS PRIVATE LIMITED",
"KURO DESIGN STUDIO PRIVATE LIMITED",
"KURSELA PRODUCT PRIVATE LIMITED",
"KURSEONG CARRIERS PRIVATE LIMITED",
"KURSEONG COMPUTER SALES PRIVATE LIMITED",
"KURTOSYS SYSTEMS INDIA PRIVATE LIMITED",
"KURUKSHETRA AGRI TECH PRIVATE LIMITED",
"KURUKSHETRA FOODS PRIVATE LIMITED",
"KURUKSHETRA INSTITUTE OF PROFESSIONAL",
"KURUKSHETRA TECHNO PLAST PRIVATE LIMITED",
"KURUKSHETRA UNIVERSITY KURUKSHETRA",
"KURUMA TRAVELS PRIVATE LIMITED",
"KURUPIN VENTURES PRIVATE LIMITED",
"KURUVANSHI FARMER PRODUCER COMPANY LIMITED",
"KURUVITHADAM AGENCIES PVT LTD",
"KURVE CONSTRUCTION PRIVATE LIMITED",
"KURZ INDIA PRIVATE LIMITED",
"KUSA CHEMICALS PRIVATE LIMITED",
"KUSABA ENGINEERS PRIVATE LIMITED",
"KUSAGRA PROJECTS PRIVATE LIMITED",
"KUSALAVA FINANCE LIMITED",
"KUSALAVA INTERNATIONAL LIMITED",
"KUSALAVA MOTORS PRIVATE LIMITED",
"KUSAM ELECTRICAL INDUSTRIES LTD",
"KUSAM-MECO IMPORT EXPORT PRIVATE LIMITED",
"KUSAUTO INDIA PRIVATE LIMITED",
"KUSH GLOBAL SERVICES PRIVATE LIMITED",
"KUSH INFOSYSTEMS PRIVATE LIMITED",
"KUSH PLASTICS PRIVATE LIMITED",
"KUSH PROTEINS PRIVATE LIMITED",
"KUSH SYNTHETICS PRIVATE LIMITED",
"KUSH TRADING & COMMERCE PVT LTD",
"KUSHAAGRA EXPORTS PRIVATE LIMITED",
"KUSHAGR INFRA-DEVELOPERS PRIVATE LIMITED",
"KUSHAGRA ENTERPRISES PRIVATE LIMITED",
"KUSHAGRAMATI ANALYTICS PRIVATE LIMITED",
"KUSHAL AGRO PROCESSING PRIVATE LIMITED",
"KUSHAL BHARAT REALCON PRIVATE. LIMITED.",
"KUSHAL CHAND PRIVATE LIMITED",
"KUSHAL DEEP AUTOMOBILES (INDIA) PRIVATE LIMITED",
"KUSHAL FABRICS PRIVATE LIMITED",
"KUSHAL FERRO ALLOYS PRIVATE LIMITED",
"KUSHAL FOODS PRIVATE LIMITED",
"KUSHAL INDUSTRIES LIMITED",
"KUSHAL INFO SERVICES PRIVATE LIMITED",
"KUSHAL KARYASHALA PRIVATE LIMITED",
"KUSHAL LANDMARKS PRIVATE LIMITED",
"KUSHAL METAL AND STEEL INDUSTRIES PRIVATE LIMITED",
"KUSHAL MOTORS AND ELECTICALS PRIVATE LIMITED",
"KUSHAL PLASTO PRIVATE LIMITED",
"KUSHAL POLYSACKS PRIVATE LIMITED",
"KUSHAL SALES AND AGENCIES PRIVATE LIMITED",
"KUSHAL SURAKSHA AND ALLIED SERVICES PRIVATE LIMITED",
"KUSHAL TECHNICAL SERVICES PRIVATE LIMITED",
"KUSHAL TIMBER PRIVATE LIMITED",
"KUSHAL TRADELINK LIMITED.",
"KUSHALBAGH MARBLES PRIVATE LIMITED",
"KUSHALBHARAT REALCON PRIVATE LIMITED",
"KUSHALRAJ LAND DEVELOPERS PRIVATE LIMITED",
"KUSHAL'S RETAIL PRIVATE LIMITED",
"KUSHALTA BAKES PRIVATE LIMITED",
"KUSHANG SECURITY & HOUSE-KEEPING SERVICES PRIVATE LIMITED",
"KUSHBOO PLASTICS PRIVATE LIMITED",
"KUSHIKA INDUSTRIES PRIVATE LIMITED",
"KUSHMITHA FOUNDATIONS PRIVATE LIMITED",
"KUSHTAGI SOLAR POWER PRIVATE LIMITED",
"KUSHUM EXPRESS SERVICES PRIVATE LIMITED",
"KUSHWAH PRODUCTS PRIVATE LIMITED",
"KUSHWAHA AGRICULTURE PRIVATE LIMITED",
"KUSHWAHA AGRITECH PRIVATE LIMITED",
"KUSHWAHA ENGINEERING CONSTRUCTION PRIVATE LIMITED",
"KUSHWAHA HOMES PRIVATE LIMITED",
"KUSMASULI MULTIPURPOSE COLD STORAGE PRIVATE LIMITED",
"KUSMO CHEMICALS PRIVATE LIMITED",
"KUSPACK INDIA PRIVATE LIMITED",
"KUSSUM BUSINESS SOLUTIONS PRIVATE LIMITED",
"KUSTERS CALICO MACHINERY PRIVATE LIMITED",
"KUSTERS ENGINEERING INDIA PRIVATE LIMITED",
"KUSUM AGRO ENDEAVOR PRIVATE LIMITED",
"KUSUM ALLOYS LIMITED",
"KUSUM AUTOMATION SENSORS PRIVATE LIMITED",
"KUSUM CABLES & WIRES PRIVATE LIMITED",
"KUSUM COLD STORAGE PRIVATE LIMITED",
"KUSUM DEVCON (INDORE) PRIVATE LIMITED",
"KUSUM DEVI SUNDERLAL DUGAR JAIN DENTAL COLLEGE & HOSPITAL",
"KUSUM DHIRAJLAL HOSPITAL",
"KUSUM ELECTRICAL ENGINEERS PRIVATE LIMITED",
"KUSUM ENGINEERS & DEVELOPERS PRIVATE LIMITED",
"KUSUM ENGITECH PRIVATE LIMITED",
"KUSUM ENTERPRISES PRIVATE LTD",
"KUSUM FERRO PRIVATE LIMITED",
"KUSUM FOREX AND TRAVELS PRIVATE LIMITED",
"KUSUM GOEL DR SANTOSH SARASWATI VIDYA MANDIR",
"KUSUM HEALTHCARE PRIVATE LIMITED",
"KUSUM INDUSTRIAL GASES LTD",
"KUSUM INDUSTRIES PRIVATE LIMITED",
"KUSUM INFRA ESTATE PRIVATE LIMITED",
"KUSUM INTERNATIONAL",
"KUSUM INTERNATIONAL ACADEMY",
"KUSUM MANAGEMENT SERVICES PVT LTD",
"KUSUM METALS PRIVATE LIMITED",
"KUSUM PLASTICS PRIVATE LIMITED",
"KUSUM SALT AND MINERALS PRIVATE LIMITED",
"KUSUM SILICONES PRIVATE LIMITED",
"KUSUM SILK MILLS PVT LTD",
"KUSUM SMELTERS PRIVATE LIMITED",
"KUSUM TIME AGENCIES PRIVATE LIMITED",
"KUSUM TRADEX PRIVATE LIMITED",
"KUSUM YARN TRADING COMPANY PRIVATE LIMITED",
"KUSUMAKAR GUPTA & SONS PRIVATE LIMITED",
"KUSUMGAR PRIVATE LIMITED",
"KUSUMGAR HEALTHCARE PRIVATE LIMITED",
"KUSUMOTO CHEMICALS (INDIA) PRIVATE LIMITED",
"KUSUMSELLERS",
"KUTCH AGROTECH PRIVATE LIMITED",
"KUTCH CARRIER PRIVATE LIMITED",
"KUTCH CHEMICAL INDUSTRIES LIMITED",
"KUTCH COPPER LIMITED",
"KUTCH CROP SERVICES PRIVATE LIMITED",
"KUTCH DISTRICT EDUCATION COMMITEE MANAGED PRIMARY SCHOOL TEACHER",
"KUTCH DISTRICT EDUCATION COMMITTEE MANAGED PRIMARY SCHOOL TEACHER",
"KUTCH ENERGIES PRIVATE LIMITED",
"KUTCH FISH PRODUCER COMPANY LIMITED",
"KUTCH GASES PRIVATE LIMITED",
"KUTCH PETROCHEM PRIVATE LIMITED",
"KUTCH RAILWAY COMPANY LIMITED",
"KUTCH SHIPPING AGENCY PVT LTD",
"KUTCH WINDFARM DEVELOPMENT PRIVATE LIMITED",
"KUTCHI KING HOSPITALITY PRIVATE LIMITED",
"KUTCHINA HOME MAKERS PRIVATE LIMITED",
"KUTE SONS DAIRYS LIMITED",
"KUTIR COMMERCIAL PRIVATE LIMITED",
"KUTIR HOUSING DEVELOPERS & CONSULTANTS PRIVATE LIMITED",
"KUTIR POST GRADUATE COLLEGE CHAKKEY JAUNPUR",
"KUTON INDUSTRIES INFRATECH PRIVATE LIMITED",
"KUTTANADU VIKASANA SAMITHY",
"KUTTI SPINNERS PRIVATE LIMITED",
"KUTTUKARAN CARS PRIVATE LIMITED",
"KUTTUKARAN GREEN PRIVATE LIMITED",
"KUTTUKARAN INSTITUTE FOR HRD",
"KUTTUVA SILICATES PRIVATE LIMITED",
"KUTUHAL SCIENCE ACTIVITIES PRIVATE LIMITED",
"KUTUMBH CARE PRIVATE LIMITED",
"KUTUMBH HRCARE PRIVATE LIMITED",
"KUTUNG DESIGN LABS PRIVATE LIMITED",
"KUTWAL FOODS PRIVATE LIMITED",
"KUUBERA MOTION CONTROLS PRIVATE LIMITED",
"KUURAKU INDIA PRIVATE LIMITED",
"KUVALA CORPORATION PRIVATE LIMITED",
"KUVAM FASHIONS PRIVATE LIMITED",
"KUVAM TECHNOLOGIES PRIVATE LIMITED",
"KUVARBA VIDYALAYA",
"KUVARIKA VIDHYALAY AGHAR",
"KUVAWALA CORE DRILL EQPT PRIVATE LIMITED",
"KUWAIT AIRWAYS COMPANY",
"KUWAR TIKAMCHAND JWELLERS PRIVATE LIMITED",
"KUWER INDUSTRIES LIMITED",
"KUWY TECHNOLOGY SERVICE PRIVATE LIMITED",
"KUYA TECHNOLOGIES PRIVATE LIMITED",
"KUZA TECHNOLOGIES PRIVATE LIMITED",
"KUZALIN SERVICES PRIVATE LIMITED",
"KV CAREER CONSULTANTS PRIVATE LIMITED",
"KV COMPUTER HOME PRIVATE LIMITED",
"KV FIRE CHEMICALS INDIA PRIVATE LIMITED",
"KV HUMAN RESOURCES SERVICES PRIVATE LIMITED",
"KV KARGIL DEVELOPER PRIVATE LIMITED",
"KV KONSTECH EQUIPMENT PRIVATE LIMITED",
"KV MARKETING SOLUTIONS PRIVATE LIMITED",
"KV SALES & MARKETING PRIVATE LIMITED",
"KV SHINE HOSPITALS PRIVATE LIMITED",
"KV TECHNO SOLUTIONS PRIVATE LIMITED",
"KVA PROCESS TRANSFORMERS PRIVATE LIMITED",
"KVAR TECHNOLOGIES PRIVATE LIMITED",
"KVB ASTA LIFE SCIENCES PRIVATE LIMITED",
"KVB E-TECHNOLOGIES PRIVATE LIMITED",
"KVB INTERNATIONAL ENERGY SERVICES PRIVATE LIMITED",
"KVB PROCESSORS PRIVATE LIMITED",
"KVB STAFFING SOLUTIONS PRIVATE LIMITED",
"KVC CONSULTANTS LIMITED",
"KVC SUPER SPECIALITY HOSPITAL",
"KVD PLASTO POLYMERS PRIVATE LIMITED",
"KVG ENTERPRISES PRIVATE LIMITED",
"KVG HIGH TECH AUTO COMPONENTS PRIVATE LIMITED",
"KVG PROJECTS PRIVATE LIMITED",
"KVG PROPERTIES PRIVATE LIMITED",
"KVG REALTECH PRIVATE LIMITED",
"KVG TOWNSHIPS PRIVATE LIMITED",
"KVGGN SYNERGY PRIVATE LIMITED",
"KVH MEDIA GROUP INDIA PRIVATE LIMITED",
"KVIK INFOTEL PRIVATE LIMITED",
"KVJ BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"KVK PROSET PRIVATE LIMITED",
"KVM AIR CARGO PRIVATE LIMITED",
"KVM ENGINEERS PRIVATE LIMITED",
"KVM EXPORTS PRIVATE LIMITED",
"KVM INDUSTRIES PRIVATE LIMITED",
"KVM ORGANIC PRODUCTS PRIVATE. LIMITED.",
"KVM STEELS PRIVATE. LIMITED.",
"KVN IMPEX PRIVATE LIMITED",
"KVN POLYTECH PRIVATE LIMITED",
"KVP BUSINESS SOLUTIONS PRIVATE LIMITED",
"KVP ELECTRICALS PRIVATE LIMITED",
"KVP TRADERS PRIVATE LIMITED",
"KVQA CERTIFICATION SERVICES PRIVATE LIMITED",
"KVR AQUA CLARE PRIVATE LIMITED",
"KVR AUTO MALL PRIVATE LIMITED",
"KVR AUTOCARS PRIVATE LIMITED",
"KVR AUTOMOBILES PRIVATE LIMITED",
"KVR AUTOMOTIVE PRIVATE LIMITED",
"KVR BASELINE RESOURCES PRIVATE LIMITED",
"KVR BEST PROPERTY MANAGEMENT PRIVATE LIMITED",
"KVR DREAM VEHICLES PRIVATE LIMITED",
"KVR HOSPITAL",
"KVR HOSPITAL PRIVATE LIMITED",
"KVR INDUSTRIAL PARK PRIVATE LIMITED",
"KVR INFOSYS PRIVATE LIMITED",
"KVR MINERALS PRIVATE LIMITED",
"KVR MOTOR CARS PRIVATE LIMITED",
"KVR OFFSHORE PRIVATE LIMITED",
"KVR PRESTIGE CARS PRIVATE LIMITED",
"KVR PRIME CONSTRUCTIONS PRIVATE LIMITED",
"KVR PRINT PACK PRIVATE LIMITED",
"KVR PROJECTS PRIVATE LIMITED",
"KVR WAREHOUSING & LOGISTICS (INDIA) PRIVATE LIMITED",
"KVS CASTINGS PRIVATE LIMITED",
"KVS FEEDS AND FARMS PRIVATE LIMITED",
"KVS HOSPITAL ARIYALUR PRIVATE LIMITED",
"KVS INFRA PROJECTS INDIA PRIVATE LIMITED",
"KVSBRITE LOGISTICS PRIVATE LIMITED",
"KVT HEART FOUNDATION AND DIAGNOSTICS PRIVATE LIMITED",
"KVTS AUTOMOTIVE PRIVATE LIMITED",
"KVVSN INFRA (INDIA) PRIVATE LIMITED",
"KW CONFERENCES PRIVATE LIMITED",
"KW HOMES PRIVATE LIMITED",
"KW POLYPACK INDIA PRIVATE LIMITED",
"KW SECURITY AND SERVICES PRIVATE LIMITED",
"KWA ANALYTICS PRIVATE LIMITED",
"KWAKIDS LEARNING PRIVATE LIMITED",
"KWALICHEM PRIVATE LIMITED",
"KWALIN SURGICARE PRIVATE LIMITED",
"KWALITEX HEALTHCARE PRIVATE LIMITED",
"KWALITY AGRO-VET INDUSTRIES PRIVATE LIMITED",
"KWALITY AIR-TECH ENGINEERING PRIVATE LIMITED",
"KWALITY ALUTRADE PRIVATE LIMITED",
"KWALITY ANIMAL FEEDS PRIVATE. LIMITED.",
"KWALITY APPARELS PRIVATE LIMITED",
"KWALITY CHEMICAL INDUSTRIES PRIVATE LIMITED",
"KWALITY COIL PRODUCTS PRIVATE LIMITED",
"KWALITY COMFORTS PRIVATE LIMITED",
"KWALITY COMPONENTS PRIVATE LIMITED",
"KWALITY CONFECTIONERS AND BAKERS (INDIA) PRIVATE LIMITED",
"KWALITY CONVEYING SYSTEMS PRIVATE LIMITED",
"KWALITY CYCLES PRIVATE LIMITED",
"KWALITY DEALS PRIVATE LIMITED",
"KWALITY DIARIES PRIVATE LIMITED",
"KWALITY DIE-CASTING PRIVATE LIMITED",
"KWALITY ELECTRODES PVT LTD",
"KWALITY ERGO PRIVATE LIMITED",
"KWALITY EXPOLINK INDIA PRIVATE LIMITED",
"KWALITY FABCON PRIVATE LIMITED",
"KWALITY FEEDS LIMITED",
"KWALITY GAS BOTTLERS PRIVATE LIMITED",
"KWALITY HOSPITALITY SERVICES PRIVATE LIMITED",
"KWALITY INDUSTRIES (BHOPAL) LIMITED",
"KWALITY INFRAHOMES PRIVATE LIMITED",
"KWALITY MACHINES & NATURAL GAS EQUIPMENT PRIVATE LIMITED",
"KWALITY MART PRIVATE LIMITED",
"KWALITY METALSTEEL INDIA PRIVATE LIMITED",
"KWALITY MILK FOODS LIMITED",
"KWALITY MOBIKES PRIVATE LIMITED",
"KWALITY NUTRIENTS PRIVATE LIMITED",
"KWALITY PHARMACEUTICALS LIMITED",
"KWALITY POLYTHREADS PRIVATE LIMITED",
"KWALITY PROCESS EQUIPMENTS PRIVATE LIMITED",
"KWALITY SPINNING MILLS PRIVATE LIMITED",
"KWALITY STEELAGE PRIVATE LIMITED",
"KWALITY TECHMECH PRIVATE LIMITED",
"KWALITY THREADS PRIVATE LIMITED",
"KWALITY UNICORN FAB PRIVATE LIMITED",
"KWALITY WALLCOATINGS PRIVATE LIMITED",
"KWALITY ZIPPERS PRIVATE LIMITED",
"KWALITYTECH IT SERVICES PRIVATE LIMITED",
"KWAN (SOUTH) CELEBRITY SERVICES PRIVATE LIMITED",
"KWAN ENVIRONMENTAL SOLUTIONS INDIA PRIVATE LIMITED",
"KWANG JIN INDIA AUTOSYSTEMS PRIVATE LIMITED",
"KWANGSUNG BRAKE INDIA PRIVATE LIMITED",
"KWANGSUNG SANDHAR AUTOMOTIVE SYSTEMS PRIVATE LIMITED",
"KWANTA SOFTWARE SOLUTIONS PRIVATE LIMITED",
"KWANTIFY SOLUTIONS PRIVATE LIMITED",
"KWANTUM CHEMICALS AND POLYMERS PRIVATE LIMITED",
"KWENG ALLOYS PRIVATE LIMITED",
"KWH TECH SERVICES PRIVATE LIMITED",
"KWICK LIVING INDIA PRIVATE LIMITED",
"KWICK SOFT SOLUTIONS PRIVATE LIMITED",
"KWIK FASTENING SOLUTIONS PRIVATE LIMITED",
"KWIK FLITE SUPPORT PRIVATE LIMITED",
"KWIK PATCH PRIVATE LIMITED",
"KWIK PRINTS PRIVATE LIMITED",
"KWIKTEAM SUPPORT SERVICES PRIVATE LIMITED",
"KWIKZO TELECOMM PRIVATE LIMITED",
"KWK RESISTORS INDIA PRIVATE LIMITED",
"KWON ENTERPRISE PRIVATE LIMITED",
"KWONG YIK BANK",
"KWORKTECH INNOVATIVE INTERIORS PRIVATE LIMITED",
"KWS EVAPORATORS PRIVATE LIMITED",
"KWW ELECTRICALS & ELECTRONICS PRIVATE LIMITED",
"KY LASER WORKS PRIVATE LIMITED",
"KYADA INTERNATIONAL",
"KYAL AGENCIES PRIVATE LIMITED",
"KYAL DEVELOPERS PVT LTD",
"KYAN RESORTS AND CLUBS PRIVATE LIMITED",
"KYANG TEA SEED CO LTD",
"KYANITE SOLAR PRIVATE LIMITED",
"KYANSH CONSTRUCTION PRIVATE LIMITED",
"KYATHI CLIMATE MODIFICATION CONSULTANTS LLP",
"KYB MOTORCYCLE SUSPENSION INDIA PRIVATE LIMITED",
"KYB-CONMAT PRIVATE LIMITED",
"KYD EXPORTS PRIVATE LIMITED",
"KYI SOFT SOLUTIONS PRIVATE LIMITED",
"KYKCORP INDIA PRIVATE LIMITED",
"KYLAN ENTERPRISES PRIVATE LIMITED",
"KYMSAP AGENCIES PRIVATE LIMITED",
"KYNA IMPEX PRIVATE LIMITED",
"KYNA INDUSTRIES PRIVATE LIMITED",
"KYNATECH SYSTEMS PRIVATE LIMITED",
"KYNDAL INDIA PRIVATE LIMITED",
"KYNDRYL SOLUTIONS PRIVATE LIMITED",
"KYNETEC DATA SERVICES PRIVATE LIMITED",
"KYNTOX BIOTECH INDIA PRIVATE LIMITED",
"KYOBASHI PREMIER FREEZE DRY PRIVATE LIMITED",
"KYOCERA ASIA PACIFIC INDIA PRIVATE LIMITED",
"KYOCERA AVX COMPONENTS NEW DELHI PRIVATE LIMITED",
"KYOCERA DOCUMENT SOLUTIONS INDIA PRIVATE LIMITED",
"KYOCERA PRECISION TOOLS INDIA PRIVATE LIMITED",
"KYODO YUSHI INDIA PRIVATE LIMITED",
"KYOKUTO TRADING INDIA PRIVATE LIMITED",
"KYOKUTOH WELD INDIA PRIVATE LIMITED",
"KYOORIUS COMMUNICATIONS PRIVATE LIMITED",
"KYOORIUS DIGITAL PRIVATE LIMITED",
"KYORITSU ELECTRIC INDIA PRIVATE LIMITED",
"KYOSAN INDIA PRIVATE LIMITED",
"KYOTO AUTOMATION PRIVATE LIMITED",
"KYOTO MERCHANDISE PVT LTD",
"KYOWA NATESAN SYNCHRO TECHNOLOGIES PRIVATE LIMITED",
"KYPIPE ENGINEERING PRIVATE LIMITED",
"KYRA INFOTECH PRIVATE LIMITED",
"KYRA PHOTON TECH PRIVATE LIMITED",
"KYRAA CERAMIC PRIVATE LIMITED",
"KYRIAD HOTEL CHINCHWAD",
"KYROS ENGINE SOLUTIONS PRIVATE LIMITED",
"KYROS SOFT-TECH LIMITED",
"KYS PROCESSORS PRIVATE LIMITED",
"KYSSA INDIA ORGANIC AND NATURAL PRIVATE LIMITED",
"KYTE ENERGY PRIVATE LIMITED",
"KYTHUB TECHNOLOGIES PRIVATE LIMITED",
"KYUNG CHANG CASTER INDIA PRIVATE LIMITED",
"KYUNGJOO HOTEL PRIVATE LIMITED",
"KYUNGSHIN INDUSTRIAL MOTHERSON LIMITED",
"KYVALYA ENTERPRISES PRIVATE LIMITED",
"KYVALYA LOGISTICS (INDIA) PRIVATE LIMITED",
"KYYBA ENGINEERING PRIVATE LIMITED",
"KYYBA INDIA PRIVATE LIMITED",
"KYZAF OVERSEAS PRIVATE LIMITED",
"KYZEN BRANDS PRIVATE LIMITED",
"KYZER SOFTWARE INDIA PRIVATE LIMITED",
"L & G STEEL AND COMMODITIES PRIVATE LIMITED",
"L & L PRODUCTS SHROFF PRIVATE LIMITED",
"L & Q TECHNOLOGIES PRIVATE LIMITED",
"L & S EQUIPMENT PVT LTD",
"L & T AVIATION SERVICES PRIVATE LIMITED",
"L & T GULF PRIVATE LIMITED",
"L & T SARGENT & LUNDY LIMITED",
"L & T SEAWOODS PRIVATE LIMITED",
"L & T TECHNOLOGY SERVICES LIMITED",
"L & T TRANSPORTATION INFRASTRUCTURE LIMITED",
"L & W CONSTRUCTION PRIVATE LIMITED",
"L 3 COMMUNICATIONS INDIA PRIVATE LIMITED",
"L A TECHNOLOGIES PRIVATE LIMITED",
"L AFFAIRE DESIGNS PRIVATE LIMITED",
"L AND C MEDIA PRIVATE LIMITED",
"L AND G INSURANCE BROKERS LIMITED",
"L AND S DESIGN CONCEPTS PRIVATE LIMITED",
"L AND S ELECTRONICS PRIVATE LIMITED",
"L AND S HYDRO ENGINEERS PRIVATE LIMITED",
"L AND T REALTY LIMITED",
"L AND T SOUTH CITY PROJECTS LIMITED",
"L AND T THALES TECHNOLOGY SERVICES PRIVATE LIMITED",
"L AND T VRINDAVAN PROPERTIES LIMITED",
"L B CONSULTANTS PRIVATE LIMITED",
"L B L ELECTRIC PRIVATE LIMITED",
"L B S I C J ROAD HATHRAS",
"L C C INFOTECH LIMITED",
"L C MANEK POLYCLINIC & NURSING HOME",
"L C OSWAL HOSIERY PRIVATE LIMITED",
"L C PACKERS PRIVATE LIMITED",
"L CUBE INNOVATIVE SOLUTIONS PRIVATE LIMITED",
"L D GOYAL STEELS PRIVATE LIMITED",
"L D K SHARES AND SECURITIES PRIVATE LIMITED",
"L D O ARDHAPUR",
"L D RANGWALA PRIVATE LIMITED",
"L D SOLVEX PRIVATE LIMITED",
"L D SUITINGSPVT LTD",
"L E K CONSULTING INDIA PRIVATE LIMITED",
"L E PROJECTS PRIVATE LIMITED",
"L F C SECURITIES PRIVATE LIMITED",
"L F C TEXCOAT PRIVATE LIMITED",
"L FAST BRANDS PRIVATE LIMITED",
"L G AND DOCTOR ASSOCIATES PRIVATE LIMITED",
"L G BALAKRISHNAN & BROS LIMITED",
"L G ELECTRONICS INDIA PRIVATE LIMITED",
"L G K AUTOMOTIVE PRIVATE LIMITED",
"L G TRADING ENGINEERS PVT LTD",
"L H SCIENCE COLLEGE",
"L H SUGER FACTORIES LIMITED",
"L I AND FUNG INDIA PRIVATE LIMITED",
"L J COLLEGE OF COMP UTER APPLICATION",
"L J KNOWLEDGE FOUNDATION",
"L J TRADING PRIVATE LIMITED",
"L JAVERCHAND JEWELLERS PRIVATE LIMITED",
"L JAYANTHA VISHNU SIVA",
"L K GOLD PALACE PRIVATE LIMITED",
"L K HOSPITAL & TRAUMA CENTER",
"L K INFRASTRUCTURE PRIVATE LIMITED",
"L K NAKASHE CONSULTANTS PRIVATE LIMITED",
"L M BAKERS PRIVATE LIMITED",
"L M J SERVICES LIMITED",
"L M POWER SYSTEMS PRIVATE LIMITED",
"L M STAR AUTOTRADE PRIVATE LIMITED",
"L M TRADING COMPANY PVT LTD",
"L M UCAL ENGINEERING PRIVATE LIMITED",
"L MADANLAL ALUMINIUM LTD",
"L N ENTERPRISES PRIVATE LIMITED",
"L N L AUTO INDUSTRIES PRIVATE LIMITED",
"L N MALVIYA INFRA PROJECTS PRIVATE LIMITED",
"L N MEMORIAL HOSPITAL AND RESEARCH CENTRE",
"L N METALLICS LIMITED",
"L N TECH ENVIRO SERVICES PRIVATE LIMITED",
"L P CARTRIDGE PRIVATE LIMITED",
"L P DIAGNOSTIC PRIVATE LIMITED",
"L P DISTRIBUTORS PRIVATE LIMITED",
"L P JAGDALE GURUJI VIDYALAYA",
"L P NAVAL AND ENGINEERING LIMITED",
"L P SAVANI ACADEMY",
"L P SAVANI VIDHYABHAVAN",
"L R ACTIVE PRIVATE LIMITED",
"L R AUTOMOBILES",
"L R FABRICATIONS PRIVATE LIMITED",
"L R FABRICS PRIVATE LIMITED",
"L R FOODS PRIVATE LIMITED",
"L R INFRASTRUCTURE PRIVATE LIMITED",
"L R N MOTORS PRIVATE LIMITED",
"L R PATEL & CO",
"L R RICE MILLS PVT LTD",
"L R SEA FOODS PRIVATE LIMITED",
"L R VALIA ARTS AND P R MEHTA COMMERCE COLLEGE",
"L S AUXI CHEM PRIVATE LIMITED",
"L S ELECTROMART PRIVATE LIMITED",
"L S KHAN LOGISTICS PRIVATE LIMITED",
"L S POWER CONTROL PRIVATE LIMITED",
"L S R SPECIALITY OILS PRIVATE LIMITED",
"L S TALENT TRANSFORMATION MANPOWER PRIVATE LIMITED",
"L S TEXTILES AND EXPORTS PRIVATE LIMITED",
"L T COLLEGE OF NURSING",
"L T ELEVATOR PRIVATE LIMITED",
"L T FASHIONS PRIVATE LIMITED",
"L T OVERSEAS PRIVATE LIMITED",
"L T TECHNO SOLUTIONS PRIVATE LIMITED",
"L V LOGISTICS PRIVATE LIMITED",
"L V P FOODS PRIVATE LIMITED",
"L V PRASAD COLLEGE OF MEDIA STUDIES",
"L V TOURS AND TRAVELS PRIVATE LIMITED",
"L VAIBHAV CASTINGS PRIVATE LIMITED",
"L W S KNITWEAR LTD",
"L& T INTERSTATE ROAD CORRIDOR LIMITED",
"L&E INDIA PRIVATE LIMITED",
"L&J FOODS IMPEX PRIVATE LIMITED",
"L&K BIOMED INDIA PRIVATE LIMITED",
"L&K SERVICES PRIVATE LIMITED",
"L&L PRODUCTS INDIA PRIVATE LIMITED",
"L&L SECURITY SERVICES PRIVATE LIMITED",
"L&N INFRACON PRIVATE LIMITED",
"L&T MHI POWER TURBINE GENERATORS PRIVATE LIMITED",
"L&T AHMEDABAD - MALIYA TOLLWAY LIMITED",
"L&T BPP TOLLWAY LIMITED",
"L&T CAPITAL COMPANY LIMITED",
"L&T CAPITAL MARKETS LIMITED",
"L&T CONSTRUCTION",
"L&T CONSTRUCTION EQUIPMENT LIMITED",
"L&T CUTTING TOOLS LIMITED",
"L&T DECCAN TOLLWAYS LIMITED",
"L&T DEVIHALLI HASSAN TOLLWAY LIMITED",
"L&T ENERGY HYDROCARBON ENGINEERING LIMITED",
"L&T FINANCIAL CONSULTANTS LIMITED",
"L&T GEOSTRUCTURE",
"L&T GEOSTRUCTURE PRIVATE LIMITED",
"L&T HIMACHAL HYDROPOWER LIMITED",
"L&T HOUSING FINANCE LIMITED",
"L&T HOWDEN PRIVATE LIMITED",
"L&T INFRA CREDIT LIMITED",
"L&T INFRA INVESTMENT PARTNERS ADVISORY PRIVATE LIMITED",
"L&T INFRASTRUCTURE DEVELOPMENT PROJECTS LIMITED",
"L&T INFRASTRUCTURE ENGINEERING LIMITED",
"L&T INFRASTRUCTURE FINANCE COMPANY LIMITED",
"L&T INVESTMENT MANAGEMENT LIMITED",
"L&T KOBELCO MACHINERY PRIVATE LIMITED",
"L&T KRISHNAGIRI WALAJAHPET TOLLWAY LIMITED",
"L&T MBDA MISSILE SYSTEMS LIMITED",
"L&T METRO RAIL HYDERABAD LIMITED",
"L&T MHI POWER BOILERS PRIVATE LIMITED",
"L&T PANIPAT ELEVATED CORRIDOR LIMITED",
"L&T POWER DEVELOPMENT LIMITED",
"L&T RAJKOT - VADINAR TOLLWAY LIMITED",
"L&T SAMAKHIALI GANDHIDHAM TOLLWAY LIMITED",
"L&T SAMBALPUR - ROURKELA TOLLWAY LIMITED",
"L&T SHIPBUILDING LIMITED",
"L&T TECHNOLOGY SERVICES LIMITED",
"L&T VADODARA BHARUCH TOLLWAY LIMITED",
"L&T VALVES LIMITED",
"L&T-STEC JV",
"L&W BUILDING SOLUTIONS PRIVATE LIMITED",
"L. B. ENGINEERING PRIVATE LIMITED",
"L. C. FOODS LIMITED",
"L. C. RAHEJA FOREX PRIVATE LIMITED",
"L. GOPAL JEWELLERS PRIVATE LIMITED",
"L. H. PATIL CONSTRUCTIONS PRIVATE LIMITED",
"L. K. TRADERS PRIVATE LIMITED",
"L. M. AGROFRESH PRIVATE LIMITED",
"L. MADANLAL STEELS",
"L. N. INFRASTRUCTURE & CONSTRUCTIONS PRIVATE LIMITED",
"L. R. D FOODS PRIVATE LIMITED",
"L.A. & CO. AUTOMOBILES PRIVATE LIMITED",
"L.A. HOTELS & RETREATS PRIVATE LIMITED",
"L.A. INFRAVENTURES PRIVATE LIMITED",
"L.B. DASS ICE & COLD STORAGE PRIVATE LIMITED",
"L.B. POLYMERS PRIVATE LIMITED",
"L.C. ENTERPRISES PRIVATE LIMITED",
"L.C.R. INVESTMENTS PRIVATE LIMITED",
"L.D. CHEMICALS PRIVATE LIMITED",
"L.D. POWER TRANSFORMERS PRIVATE LIMITED",
"L.D.C. HOLDINGS PRIVATE LIMITED",
"L.D.GOLD LAB PRIVATE LIMITED",
"L.G COKE PRIVATE LIMITED",
"L.G. EXTRUSIONS PRIVATE LIMITED",
"L.G.B. AUTO PRODUCTS PRIVATE LIMITED",
"L.H. EXPORTS PRIVATE LIMITED",
"L.J. INTERNATIONAL LIMITED",
"L.K.MEHTA POLYMERS LIMITED",
"L.K.S.GOLDHOUSE PRIVATE LIMITED",
"L.K.SONS ALLOY PRIVATE LIMITED",
"L.KASHI NATH SETH GEMS & JEWELS PRIVATE LIMITED",
"L.KISHAN CHAND FABRICS PRIVATE LIMITED",
"L.L. LOGISTICS PRIVATE LIMITED",
"L.M. ENGINEERING MACHINERY CO. PRIVATE LIMITED",
"L.M. FOODS",
"L.N.S MULTISPECIALITY HOSPITAL PRIVATE LIMITED",
"L.N.S TECHNOLOGY PRIVATE LIMITED",
"L.P. RAI DEVELOPERS PRIVATE LIMITED",
"L.P.S. CONSTRUCTION PRIVATE LIMITED",
"L.R AGRO PRODUCT PRIVATE LIMITED",
"L.R FINVEST PRIVATE LIMITED",
"L.R.FERRO ALLOYS PVT LTD.",
"L.R.N.AUTO AGENCIES PRIVATE LIMITED",
"L.S. MILLS LIMITED",
"L.S. SPINNING MILLS PRIVATE LIMITED",
"L-1 COACHING PRIVATE LIMITED",
"L-1 IDENTITY SOLUTIONS OPERATING COMPANY PRIVATE LIMITED",
"L1 SUPPLY NETWORKS PRIVATE LIMITED",
"L2 SOFTWARE DEVELOPMENT INDIA PRIVATE LIMITED",
"L29 EXPANSION SOLUTIONS PRIVATE LIMITED",
"L2MTECH INDIA PRIVATE LIMITED",
"L4 SUPPORT SERVICES PRIVATE LIMITED",
"L7 HITECH PRIVATE LIMITED",
"L7H LIFE RESOURCES PRIVATE LIMITED",
"LA ARCHPLAN PVT LTD",
"LA BONNE WINERIES PRIVATE LIMITED",
"LA CARTE RETAILERS PRIVATE LIMITED",
"LA CASA DE JOAILLIER PRIVATE LIMITED",
"LA CASA INDIA R&D PRIVATE LIMITED",
"LA CERA MALL PRIVATE LIMITED",
"LA CERAMICA BATH SOLUTIONS PRIVATE LIMITED",
"LA CHANDRA PHARMALAB PRIVATE LIMITED",
"LA CHATELAINE JUNIOR COLLEGE",
"LA CHEMICO PVT LTD",
"LA CLASSE TRANSLATION PRIVATE LIMITED",
"LA COSTA ENTERPRISES PRIVATE LIMITED",
"LA DYLUNIO EMPRESA (OPC) PRIVATE LIMITED",
"LA ESTILOSO PRIVATE LIMITED",
"LA FREIGHTLIFT PRIVATE LIMITED",
"LA GAJJAR MACHINERIES PRIVATE LIMITED",
"LA GRANDE PRIVATE LTD",
"LA GRANDE SOLITAIRE PRIVATE LIMITED",
"LA HOSPIN HOTELS AND RESORTS PRIVATE LIMITED",
"LA INDUSTRIES PRIVATE LIMITED",
"LA KABABIYAA PRIVATE LIMITED",
"LA KOUTURE APPARELS PRIVATE LIMITED",
"LA LAGOS SANTE HOSPITALITY PRIVATE LIMITED",
"LA MA NILRAJ ENGINEERING PRIVATE LIMITED",
"LA MARTINIERE COLLEGE LUCKNOW",
"LA MCLEAN INDIA LIMITED",
"LA MCLEAN INDIA PRIVATE LIMITED",
"LA MER MARITIME PRIVATE LIMITED",
"LA MODA CLOTHING EXPORTS PRIVATE LIMITED",
"LA OPALA R G LIMITED",
"LA PIEL BIOTECH PRIVATE LIMITED",
"LA PLASTPACKS PRIVATE LIMITED",
"LA POINTE TELECOM SOLUTIONS PRIVATE LIMITED",
"LA PRISTINE BIOCEUTICALS PRIVATE LIMITED",
"LA PROSPERITE FOREX PRIVATE LIMITED",
"LA RELIANT ALUMINIUM PRIVATE LIMITED",
"LA RENON HEALTHCARE PRIVATE LIMITED",
"LA REVERIE HERBAL CARE PRIVATE LIMITED",
"LA ROCHE HOTEL & RESORTS",
"LA SAGESSE ACADEMY",
"LA SCENTEUR FRAGRANCE TECHNOLOGIES PRIVATE LIMITED",
"LA SHIVE EXIM PRIVATE LIMITED",
"LA SKINNOVITA PRIVATE LIMITED",
"LA SOLITAIRE JEWELS PRIVATE LIMITED",
"LA SOROGEEKA INTERIORS INDIA PRIVATE LIMITED",
"LA SOVEREIGN BICYCLES PRIVATE LIMITED",
"LA SUPER RETAIL PRIVATE LIMITED",
"LA TIM METAL & INDUSTRIES LIMITED",
"LA TRENDZ FABRICA PRIVATE LIMITED",
"LA VANCE INTERNATIONAL PRIVATE LIMITED",
"LA VILLA CAFE PRIVATE LIMITED",
"LA VILLA HOTEL PRIVATE LIMITED",
"LA VIVANTA HOTEL PRIVATE LIMITED",
"LAABDHI OUTSOURCE INDIA SERVICES PRIVATE LIMITED",
"LAADKI TRADING AND INVESTMENTS LIMITED",
"LAADO TEXTILE PRIVATE LIMITED",
"LAADRO GC PRIVATE LIMITED",
"LAAJ CREATION",
"LAALSA BUSINESS INSIGHTS PRIVATE LIMITED",
"LAANGUR INFRATECH PRIVATE LIMITED",
"LAANGZA WATERS PRIVATE LIMITED",
"LAAP CONSTRUCTION PRIVATE LIMITED",
"LAASMA POWER PRIVATE LIMITED",
"LAAY CONTROLS PRIVATE LIMITED",
"LAB AND LIFE INSTRUMENTS PRIVATE LIMITED",
"LAB CHEMICALS PRIVATE LIMITED",
"LAB DEVICES (INDIA) PRIVATE LIMITED",
"LAB INFRATECH PRIVATE LIMITED",
"LAB MEDICA SYSTEMS PRIVATE LIMITED",
"LAB OF THINGS PRIVATE LIMITED",
"LAB REALTY PRIVATE LIMITED",
"LAB SULPHONATE PRIVATE LIMITED",
"LAB TO MARKET INNOVATIONS PRIVATE LIMITED",
"LABANA DEVELOPERS LLP",
"LABANHRAD VIDYAPITH",
"LABASIA BIO-MEDICALS PRIVATE LIMITED",
"LABAT ASIA PRIVATE LIMITED",
"LABBAIK INTERNATIONAL",
"LABBAIK MEDICAL CENTRE PRIVATE LIMITED",
"LABBDHI PAPER TUBES PRIVATE LIMITED",
"LAB-CARE DIAGNOSTICS (INDIA) PRIVATE LIMITED",
"LABCON SCIENTIFIC INSTRUMENTS P LTD",
"LABCON TECHNOLOGY VENTURES PRIVATE LIMITED",
"LABCORP DIAGNOSTICS PRIVATE LIMITED",
"LABCORP ENDPOINT INDIA PRIVATE LIMITED",
"LABCURE DIAGNOSTIC PRIVATE LIMITED",
"LABCURE SOLUTIONS PRIVATE LIMITED",
"LABDHI INTERNATIONAL PRIVATE. LIMITED.",
"LABDHI JEWELLERS PRIVATE LIMITED",
"LABDHI MANUFACTURING LLP",
"LABDHI SYNTEX PRIVATE LIMITED",
"LABDI FOREX PRIVATE LIMITED",
"LABEL CORP PRIVATE LIMITED",
"LABEL KINGDOM PRINTERS PRIVATE LIMITED",
"LABELLE BODY CARE PRIVATE LIMITED",
"LABGENIUS DIAGNOSTICS PRIVATE LIMITED",
"LAB-GROWN DIAMOND AND JEWELLERY PROMOTION COUNCIL",
"LABGUARD INDIA PRIVATE LIMITED",
"LABH CAPITAL SERVICES LIMITED",
"LABH IMPEX",
"LABH INFRASTRUCTURE PRIVATE LIMITED",
"LABH INTERNATIONAL PRIVATE LIMITED",
"LABH PROJECTS PRIVATE LIMITED",
"LABH SECURITIES ADVISORY PRIVATE LIMITED",
"LABH VENTURES INDIA PRIVATE LIMITED",
"LABHANSHI MULTITRADE PRIVATE LIMITED",
"LABHDAYAK MADHYAMIK VIDYALAYA SHAHADA",
"LABHDHAN MARINE PRODUCTS PRIVATE LIMITED",
"LABHESH FINSTOCK PRIVATE LIMITED",
"LABHI GENERAL TRADING COMPANY PRIVATE LIMITED",
"LABHI OVERSEAS PRIVATE LIMITED",
"LABHLAXMI MULTITRADE PRIVATE LIMITED",
"LABIFIX INNOVATIONS PRIVATE LIMITED",
"LABINDIA ANALYTICAL INSTRUMENTS PRIVATE LIMITED",
"LABINDIA HEALTHCARE PRIVATE LIMITED",
"LABINDIA INSTRUMENTS PRIVATE LIMITED",
"LABINDUSS LIMITED",
"LABINFORMATICS SOLUTIONS INDIA PRIVATE LIMITED",
"LABIQUIP SOLUTIONS PRIVATE LIMITED",
"LABLINE EQUIPMENTS PRIVATE LIMITED",
"LABMAN SCIENTIFIC INSTRUMENTS PRIVATE LIMITED",
"LABMATE (ASIA) PRIVATE LIMITED",
"LABNATION INDIA PRIVATE LIMITED",
"LABOFAB INDIA PRIVATE LIMITED",
"LABONEL FINE BAKING (INDIA) PRIVATE LIMITED",
"LABONI COLLECTION PRIVATE LIMITED",
"LABONI IMPEX PRIVATE LIMITED",
"LABORATE PHARMACEUTICALS INDIA LIMITED",
"LABORATOIRES GRIFFON PRIVATE LIMITED",
"LABORT FINE-CHEM PRIVATE LIMITED",
"LABOSPORT INDIA PRIVATE LIMITED",
"LABOTECH MICROSCOPES INDIA PRIVATE LIMITED",
"LABOTEK PLASTICS AUXILIARIES INDIA PRIVATE LIMITED",
"LABOTRON INSTRUMENTS PRIVATE LIMITED",
"LABOUR COURT",
"LABOUR COURT AMRAVATI",
"LABOUR DEPARTMENT",
"LABOURNET MANAGED SERVICES PRIVATE LIMITED",
"LABOURNET SERVICES INDIA PRIVATE LIMITED",
"LABOWORLD PRIVATE LIMITED",
"LABQUARTZ SILICA PRIVATE LIMITED",
"LABQUIP INDIA PRIVATE LIMITED",
"LABRARY CLOTHING LIMITED",
"LABRON HEALTHCARE PRIVATE LIMITED",
"LABROO CLOTHING (OPC) PRIVATE LIMITED",
"LABSAKHA DIAGNOSTICS PRIVATE LIMITED",
"LABSOLUTIONS INSTRUMENTS AND CONSULTANCY PRIVATE LIMITED",
"LABSTAR MULTIPLAST PRIVATE LIMITED",
"LABTECH ELECTRONICS PRIVATE LIMITED",
"LABTECH HEALTH CARE INDIA PRIVATE LIMITED",
"LABTECH MEDICO PRIVATE LIMITED",
"LABTOP INSTRUMENTS PRIVATE LIMITED",
"LABULTIMA PROCESS TECHNOLOGIES PRIVATE LIMITED",
"LABURNUM CAPITAL ADVISORS PRIVATE LIMITED",
"LABURNUM CHEMICALS PRIVATE LIMITED",
"LABVANTAGE SOLUTIONS PRIVATE LIMITED",
"LABWALA HEALTHCARE MARKETING",
"LABWARE LIMITED",
"LABWAY TRUSITED WAY OF DIAGNOSTICS SERVICES",
"LABYRINTH CINEMATIC SOLUTIONS PRIVATE LIMITED",
"LABYRINTH LOGISTICS PRIVATE LIMITED",
"LACAMEO INTERNATIONAL PRIVATE LIMITED",
"LACE VORTEX PRIVATE LIMITED",
"LA'CERA TILES PRIVATE LIMITED",
"LACEUP RETAILS PRIVATE LIMITED",
"LACEWOOD CONSULTING PRIVATE LIMITED",
"LACEY TRADING COMPANY PRIVATE LIMITED",
"LACGENE TECHNOLOGIES PRIVATE LIMITED",
"LACHMAN DAS BHATIA HINGWALA PRIVATE LIMITED",
"LACHMANDAS ARK TRADING CORPORATION PRIVATE LIMITED",
"LACTITOL INDIA PRIVATE LIMITED",
"LACTONOVA NUTRIPHARM PRIVATE LIMITED",
"LACTOSE INDIA LIMITED",
"LADAM HOMES PRIVATE LIMITED",
"LADCO GALVANIZERS PRIVATE LIMITED",
"LADDA INFRATECH PRIVATE LIMITED",
"LADDER AUTOMATION SOLUTIONS PRIVATE LIMITED.",
"LADDER MEDIA PRIVATE LIMITED",
"LADDERUP CORPORATE ADVISORY PRIVATE LIMITED",
"LADDERUP FINANCE LIMITED",
"LADDERUP WEALTH MANAGEMENT PRIVATE LIMITED",
"LADDHA ADVISORS PRIVATE LIMITED",
"LADDHA AGRO PLAST INDUSTRIES PRIVATE LIMITED",
"LADDHA CONSTRUCTION COMPANY PRIVATE LIMITED",
"LADDHA HOSPITAL PRIVATE LIMITED",
"LADERA TECHNOLOGY PRIVATE LIMITED",
"LADHA OVERSEAS PRIVATE LIMITED",
"LADHURAM TOSHNIWAL AND SONS ELECTRICALS PRIVATE LIMITED",
"LADI STEEL INDUSTRIES PVT LTD",
"LADIWALA JEWELS PRIVATE LIMITED",
"LADLA GOLD PRIVATE LIMITED",
"LADLEE FABRICS PRIVATE LIMITED",
"LADO CERAMIC PRIVATE LIMITED",
"LADPILATTUS TECH PARK PRIVATE LIMITED",
"LADPURA KISAN AGRO PRODUCER COMPANY LIMITED",
"LADURAM PROMOTERS PRIVATE LIMITED",
"LADWA SAFETY SOLUTIONS PRIVATE LIMITED",
"LADY AMRITBAI DAGA COLLEGE FOR WOMENS OF ARTS COMMERCE AND SCIENCE",
"LADY AMRUTA BAI DAGA COLLEGE FOR WOMEN",
"LADY ANDAL SCHOOL",
"LADY BAMFORD FOUNDATION",
"LADY BRABOURNE COLLEGE",
"LADY FLORENCE PUBLIC SCHOOL",
"LADY HARDINGE MEDICAL COLLEGE",
"LADY LRD PUBLIC SCHOOL",
"LADY PILLAR HOSPITAL",
"LADY RATANBAI & SIR MATHURADAS VISSANJI ACADEMY",
"LADY SHRI RAM COLLEGE FOR WOMEN",
"LADY WILLINGTON INSTITUTE OF ADVANCE STU",
"LADYBIRD WEB SOLUTION PRIVATE LIMITED",
"LA-ELIXIR AASHIYAN ESTATE DEVELOPERS PRIVATE LIMITED",
"LAEMPE FOUNDRY TECHNOLOGY PRIVATE LIMITED",
"LAERDAL BANGALORE LLP",
"LAERDAL MEDICAL INDIA PRIVATE LIMITED",
"LAFARGE UMIAM MINING PRIVATE LIMITED",
"LAFFALE DISTRIBUTION PRIVATE LIMITED",
"LAFFANS (INDIA) PRIVATE LIMITED",
"LAFFANS GRANITO PRIVATE LIMITED",
"LA-FIN FINANCIAL SERVICES PRIVATE LIMITED",
"LAFINY TECHNOLOGIES PRIVATE LIMITED",
"LAFIT LIGHTING PRIVATE LIMITED",
"LAFORD AGROTECH LIMITED",
"LAFT TRAVEL PRIVATE LIMITED",
"LAG JEANS PRIVATE LIMITED",
"LAGAN ENGINEERING COMPANY LIMITED",
"LAGGAR INDUSTRIES LIMITED",
"LAGHMANI TRADING PRIVATE LIMITED",
"LAGHU DAL NAHAR KHAND KANPUR",
"LAGNA SHRINGAR DESIGN PRIVATE LIMITED",
"LAGNAM SPINTEX LIMITED",
"LAGNISREE EXIM PVT LTD",
"LAGOM FOOD LABS PRIVATE LIMITED",
"LAGOM LABS PRIVATE LIMITED",
"LAGOM RETAIL PRIVATE LIMITED",
"LAGOON MOTOR PRIVATE LIMITED",
"LAGREENS INDIA PRIVATE LIMITED",
"LAGSAMA INTER COLLEGE",
"LAGSAMA KANYA INTER COLLEGE GONDA",
"LAGU BANDHU MOTIWALE PRIVATE LIMITED",
"LAGUN HOLIDAYS INDIA PRIVATE LIMITED",
"LAGUNA FARMS PRIVATE LIMITED",
"LAHAG SPIRITS PRIVATE LIMITED",
"LAHAM EXPORTS INDIA PRIVATE LIMITED",
"LAHANTI HOMES & INFRASTRUCTURE PRIVATE LIMITED",
"LAHANTI LASTMILE SERVICES PRIVATE LIMITED",
"LAHARI ENTERPRISES INDIA PRIVATE LIMITED",
"LAHARI INFRASTRUCTURE PRIVATE LIMITED",
"LAHARI LAMINATES PVT LTD",
"LAHARIYA OIL INDUSTRIES PRIVATE LIMITED",
"LAHEJJAT GLOBAL BEVERAGES PRIVATE LIMITED",
"LAHIRI EPHARMA INDIA (OPC) PRIVATE LIMITED",
"LAHLIWALA STEELS PRIVATE LIMITED",
"LAHMEYER INTERNATIONAL INDIA PRIVATE LIMITED",
"LAHOOTI PRINTECH PRIVATE LIMITED",
"LAHOTI COMPUTERS PVT LTD",
"LAHOTI ENTERPRISES PVT. LTD.",
"LAHOTI FOOD PRODUCTS PRIVATE LIMITED",
"LAHOTI HOLDINGS LIMITED",
"LAHOTI LIFECARE PRIVATE LIMITED",
"LAHOTI MEDI CARE PVT LTD",
"LAHOTI MOTORS PRIVATE LIMITED",
"LAHOTI TEXTILES PRIVATE LIMITED",
"LAHOTY BROTHERS PRIVATE LIMITED",
"LAHOTY BUILDCON LIMITED",
"LAHS GREEN INDIA PRIVATE LIMITED",
"LAHS GREEN INDIA PVT LTD",
"LAIBA DEVELOPER AND CONSTRUCTIONS PRIVATE LIMITED",
"LAIKA DYING & PRINTING",
"LAILA HOTELS AND RESORTS PRIVATE LIMITED",
"LAILA IMPEX PRIVATE LIMITED",
"LAILA NUTRACEUTICALS",
"LAILESH SURGICAL EQUIPMENTS (OPC) PRIVATE LIMITED",
"LAILESH TECHNOLOGIES PRIVATE LIMITED",
"LAIMA INDUSTRIES PRIVATE LIMITED",
"LAIS FOREX PRIVATE LIMITED",
"LAIS LEATHER INDUSTRIES PVT LTD",
"LAITKOR INFOSOLUTIONS PRIVATE LIMITED",
"LAITMATUS SOFTWARE PRIVATE LIMITED",
"LAIZER TREND PRIVATE LIMITED",
"LAJ COLOR LEAF PRIVATE LIMITED",
"LAJ EXPORTS LIMITED",
"LAJ LIFESTYLE PRIVATE LIMITED",
"LAJ NUTS PRIVATE LIMITED",
"LAJAWAAB SHOES PRIVATE LIMITED",
"LAJJA POLYFAB PRIVATE LIMITED",
"LAJJA RAM COLD STORAGE PRIVATE LIMITED",
"LAJJAT AGRO PRODUCTS PRIVATE LIMITED",
"LAJJIAWATI JAIN MEMORIAL NURSING INSTITUTE",
"LAJPAT AGRO PVT LTD",
"LAJPAT RAI COLLEGE",
"LAJPAT RAI INTER COLLEGE",
"LAKADAWALA DEVELOPERS PRIVATE LIMITED",
"LAKADIA BANASKANTHA TRANSCO LIMITED",
"LAKASHIKA COUTURE PRIVATE LIMITED",
"LAKDA DAL AND OIL MILLS PRIVATE LIMITED",
"LAKE CHEMICALS PRIVATE LIMITED",
"LAKE CITY DRY FRUITS PRIVATE LIMITED",
"LAKE CITY SUPER SPECIALITY HEALTH CARE PRIVATE LIMITED",
"LAKE MEADOWS HOTELS & RESORTS PRIVATE LIMITED",
"LAKE MONTFORT SCHOOL",
"LAKE SHORE INDIA ADVISORY PRIVATE LIMITED",
"LAKE SHORE INDIA MANAGEMENT PRIVATE LIMITED",
"LAKE WATER SOFTWARE PRIVATE LIMITED",
"LAKE WINE STORES PRIVATE LIMITED",
"LAKEBA IT SOLUTIONS PRIVATE LIMITED",
"LAKECITY HOSPITAL",
"LAKECITY INSTITUTE OF SURGICAL SCIENCES PRIVATE LIMITED",
"LAKEDGE TECHNOLOGIES PRIVATE LIMITED",
"LAKEE ESHOPPING INDIA PRIVATE LIMITED",
"LAKEFOREST WINES PRIVATE LIMITED",
"LAKEHOUSE PROJECTS PRIVATE LIMITED",
"LAKELAND GLOVES AND SAFETY APPAREL PRIVATE LIMITED",
"LAKEND HOTELS AND MOTELS PRIVATE LIMITED",
"LAKENT BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"LAKEPOINT BUILDERS PRIVATE LIMITED",
"LAKESHORE HOSPITAL AND RESEARCH CENTER LIMITED",
"LAKESIDE HOTELS PRIVATE LIMITED",
"LAKESIDE MEDICAL CENTRE PRIVATE LIMITED",
"LAKESIDE SOFTWARE INDIA PRIVATE LIMITED",
"LAKEVIEW AGENCIES PVT LTD",
"LAKEVIEW CLUBS LIMITED",
"LAKEWATER ADVISORS PRIVATE LIMITED",
"LAKEWOOD MALLS PRIVATE LIMITED",
"LAKH BRANDING PRIVATE LIMITED",
"LAKHA REAL ESTATE PRIVATE LIMITED",
"LAKHAMSHI P SHAH TEXTILES PRIVATE LIMITED",
"LAKHANI & DESAI DEVELOPERS",
"LAKHANI BUILDERS PRIVATE LIMITED",
"LAKHANI ENTERPRISES",
"LAKHANI FILAMENTS PRIVATE LIMITED",
"LAKHANI FOOTWEAR PRIVATE LIMITED",
"LAKHANI INFINITY FOOTCARE PRIVATE LIMITED",
"LAKHANI INFRA PROJECTS LLP",
"LAKHANI JORDAN ENGINEERS AND ARCHITECTS PRIVATE LIMITED",
"LAKHANI RUBBER PRODUCTS PRIVATE LIMITED",
"LAKHANI SHOES AND APPARELS PRIVATE LIMITED",
"LAKHANI STEEL CORPORATION",
"LAKHANI SYNTHETICS PVT LTD",
"LAKHANI. ARMAAN. SHOES. PRIVATE. LIMITED.",
"LAKHANLAL KANTILAL BROKERS PRIVATE LIMITED",
"LAKHANPAL AUTO PRIVATE LIMITED",
"LAKHANPAL ENTERPRISES PRIVATE LIMITED",
"LAKHANPAL INFRASTRUCTURE PRIVATE LIMITED",
"LAKHARI RESOURCES PRIVATE LIMITED",
"LAKHDATAR FOODS PRIVATE LIMITED",
"LAKHDATAR TECHNOLOGY PRIVATE LIMITED",
"LAKHI CREATION PRIVATE LIMITED",
"LAKHI GEMS IMPEX PVT LTD",
"LAKHINA DYE-CHEM PRIVATE LIMITED",
"LAKHMI CHAND TEJOO MAL PRIVATE LIMITED",
"LAKHMICHAND KESHARICHAND GOTHI JEWELLERS PRIVATE LIMITED",
"LAKHO AGRICULTURAL AND FOOD PRODUCTS PRIVATE LIMITED",
"LAKHOTIA (INDIA) PRIVATE LIMITED",
"LAKHOTIA AGRO SORTEX PRIVATE LIMITED",
"LAKHOTIA BELTINGS PRIVATE LIMITED",
"LAKHOTIA CONVEYORS PRIVATE LIMITED",
"LAKHOTIA DIAGNOSTIC SERVICE PRIVATE LIMITED",
"LAKHOTIA INFRA PROJECTS PRIVATE LIMITED",
"LAKHOTIA INFRASTRUCTURE PRIVATE LIMITED",
"LAKHOTIA INTERNATIONAL PVT LTD.",
"LAKHOTIA METALIZERS PRIVATE LIMITED",
"LAKHOTIA MULTI BUSINESS PRIVATE LIMITED",
"LAKHOTIA OVERSEAS PRIVATE LIMITED",
"LAKHOTIA POLYESTERS (INDIA) LIMITED",
"LAKHOTIA TEXPRO PRIVATE LIMITED",
"LAKHOTIA TRANSPORT CO. PRIVATE LIMITED",
"LAKHOTIYA TRADERS PRIVATE LIMITED",
"LAKHPAT TRADING AND INDUSTRYS PRIVATE LIMITED",
"LAKHPATRAJ FASHION PRIVATE LIMITED",
"LAKHU TELESERVICES PRIVATE LIMITED",
"LAKIREDDY BALI REDDY COLLEGE OF ENGINEERING",
"LAKKA TRANSGLOBAL INDIA PRIVATE LIMITED",
"LAKKAVARAM SILAGE FODDER PRIVATE LIMITED",
"LAKKSHAY TOUR AND TRAVELS PRIVATE LIMITED",
"LAKKSHMI DURGA RICE INDUSTRIES",
"LAKME HOSIERY PRIVATE LIMITED",
"LAKME LEVER PRIVATE LIMITED",
"LAKOZY MOTORS PRIVATE LIMITED",
"LAKSH AUTOMOBILES PRIVATE LIMITED",
"LAKSH FINE CHEM PRIVATE LIMITED",
"LAKSH FIRE AND SAFETY ENGINEERS OPCPRIVATE LIMITED",
"LAKSH FIRE AND SAFETY ENGINEERS PRIVATE LIMITED",
"LAKSH HUMAN RESOURCES INDIA PRIVATE LIMITED",
"LAKSH IT SOLUTIONS & SECURITY SYSTEMS PRIVATE LIMITED",
"LAKSH SEMICONDUCTORS PRIVATE LIMITED",
"LAKSH TRANSVENTURE PRIVATE LIMITED",
"LAKSH VENTURE PRIVATE LIMITED",
"LAKSHADWEEP DEVELOPMENT CORPORATION LIMITED",
"LAKSHAM AUTOMOBILES PRIVATE LIMITED",
"LAKSHAM TELECOM SERVICES PRIVATE LIMITED",
"LAKSHANA CONSULTANTS AND HOTELIERS PRIVATE LIMITED",
"LAKSHANYA VENTURES PRIVATE LIMITED",
"LAKSHARA TOYS PRIVATE LIMITED",
"LAKSHAY CARGO MOVERS",
"LAKSHAY INTERNATIONAL PRIVATE LIMITED",
"LAKSHAYA ENTERTAINMENTS PRIVATE LIMITED",
"LAKSHDEEP INVESTMENTS AND FINANCE PRIVATE LIMITED",
"LAKSHDHAM HIGH SCHOOL",
"LAKSHGRIH CONTRACT PRIVATE LIMITED",
"LAKSHIN METALS PRIVATE LIMITED",
"LAKSHITA FASHIONS PRIVATE LIMITED",
"LAKSHITA STRUCTURAL SOLUTIONS PRIVATE LIMITED",
"LAKSHITH CONSULTING PRIVATE LIMITED",
"LAKSHMAN AND CO.",
"LAKSHMAN ISPAT PRIVATE LIMITED",
"LAKSHMANVEER STEEL PRIVATE LIMITED",
"LAKSHMI AARUSH HEALTHCARE PRIVATE LIMITED",
"LAKSHMI AGRO INDUSTRIES",
"LAKSHMI AIRCONS MEP INDIA PRIVATE LIMITED",
"LAKSHMI AUTOMOTIVES INDIA PRIVATE LIMITED",
"LAKSHMI BALAJI ENGINEERING PRIVATE LIMITED",
"LAKSHMI BALAJI OILS PRIVATE LIMITED",
"LAKSHMI BHOG AGRO PRIVATE LIMITED",
"LAKSHMI BUSINESS SERVICES & INSURANCE MARKETING PRIVATE LIMITED",
"LAKSHMI CAR ZONE PRIVATE. LIMITED.",
"LAKSHMI CARD CLOTHING MANUFACTURING COMPANY PRIVATE LIMITED",
"LAKSHMI CARGO COMPANY LIMITED",
"LAKSHMI CERAMICS AND REFRACTORIES INDIA PRIVATE LIMITED",
"LAKSHMI CHEMI PRODUCTS PRIVATE LIMITED",
"LAKSHMI COMPONENTS PRIVATE LIMITED",
"LAKSHMI CONSULTANTS PRIVATE LIMITED",
"LAKSHMI COTS AGENCIES AND SERVICES PRIVATE LIMITED",
"LAKSHMI CRYOGENICS PRIVATE LIMITED",
"LAKSHMI DHATU UDYOG PVT LTD",
"LAKSHMI DURGA DRUGS AND INTERMEDIATES PRIVATE LIMITED",
"LAKSHMI ELECTRICAL CONTROL SYSTEMS LIMITED",
"LAKSHMI ELECTRICAL DRIVES LIMITED",
"LAKSHMI ELECTRICAL DRIVES PRIVATE LIMITED",
"LAKSHMI ENERGY AND ENVIRONMENT DESIGNS PRIVATE LIMITED",
"LAKSHMI ENGINEERING ENTERPRISES",
"LAKSHMI ENGINEERS ARCHITECTS & DESIGNERS INDIA PRIVATE LIMITED",
"LAKSHMI ENTERPRISES",
"LAKSHMI FACTORY TOOLS PRIVATE LIMITED",
"LAKSHMI FARMACHEM PRIVATE LIMITED",
"LAKSHMI FINANCE",
"LAKSHMI FINANCE AND INDUSTRIAL CORPORATION LTD",
"LAKSHMI FINE YARNS COIMBATORE PRIVATE LIMITED",
"LAKSHMI FLOAT GLASS LIMITED",
"LAKSHMI FLOUR MILLS.",
"LAKSHMI FOODS PRIVATE LIMITED",
"LAKSHMI FOUNDRY WORKS PVT LTD",
"LAKSHMI GANAPATHI GINNERS PRIVATE LIMITED",
"LAKSHMI GANAPATHI JUTE MILLS PRIVATE LIMITED",
"LAKSHMI GANAPATHY INFRASTRUCTURE PRIVATE LIMITED",
"LAKSHMI GANESH AGRO FERTILIZERS PRIVATE LIMITED",
"LAKSHMI GARDEN SCHOOL",
"LAKSHMI GOLD KHAZAANAA PRIVATE LIMITED",
"LAKSHMI HOSPITAL",
"LAKSHMI HYDRO PRODUCTS PRIVATE LIMITED",
"LAKSHMI INFRA BUILOCON PRIVATE LIMITED",
"LAKSHMI INFRASTRUCTURE & DEVELOPERS INDIA PRIVATE LIMITED",
"LAKSHMI INFRATECH INDIA PRIVATE LIMITED",
"LAKSHMI LIFE SCIENCES PRIVATE LIMITED",
"LAKSHMI MACHINE WORKS LIMITED",
"LAKSHMI MAGNET WIRES PRIVATE LIMITED",
"LAKSHMI MATA RICE MILL PRIVATE LIMITED",
"LAKSHMI MATRIC HR SEC SCHOOL",
"LAKSHMI METALEXCHANGES PRIVATE LIMITED",
"LAKSHMI METALS AND ALLOYS PRIVATE LIMITED",
"LAKSHMI MOTORCYCLES & ALLIED PRIVATE LIMITED",
"LAKSHMI MULTISPECIALITIES & LIFE CARE PRIVATE LIMITED",
"LAKSHMI NARAIN COLLEGE OF TECHNOLOGY",
"LAKSHMI NARAIN DIAMOND (INDIA) PRIVATE LIMITED",
"LAKSHMI NARASIMHA SEEDS PRIVATE LIMITED",
"LAKSHMI NARASIMHA TEXTILES PRIVATE LIMITED",
"LAKSHMI NARAYAN RICE & FOOD PRODUCTS PRIVATE LIMITED",
"LAKSHMI NARAYAN SEN & SONS PVT LTD",
"LAKSHMI NIRMAL HOLIDAY HOME PRIVATE LIMITED",
"LAKSHMI ORGANICS PRIVATE LIMITED",
"LAKSHMI PETRO PRIVATE LIMITED",
"LAKSHMI PLYWOODS PVT LTD",
"LAKSHMI POULTRIES PRIVATE LIMITED",
"LAKSHMI PRAKASH AGRO SOLUTIONS PRIVATE LIMITED",
"LAKSHMI PRECISION PLASTICS PRIVATE LIMITED",
"LAKSHMI PRECISION TECHNOLOGIES LIMITED",
"LAKSHMI PRESSINGS PRIVATE LIMITED",
"LAKSHMI PRESTRESS CONCRETE WORKS PVT LTD",
"LAKSHMI PRINTOGRAPHICS PRIVATE LIMITED",
"LAKSHMI PRIYA PROPERTIES PRIVATE LIMITED",
"LAKSHMI REAL HOUSING PRIVATE LIMITED",
"LAKSHMI RING TRAVELLERS (COIMBATORE) PRIVATE LIMITED",
"LAKSHMI RING TRAVELLERS COIMBATORE LIMITED",
"LAKSHMI SAAI AGRI COLD STORAGE PRIVATE LIMITED",
"LAKSHMI SAI DELINTERS",
"LAKSHMI SANDHYA HEALTHCARE PRIVATE LIMITED",
"LAKSHMI SARADA HATCHERIES PRIVATE LIMITED",
"LAKSHMI SARAS CHEMTECH PRIVATE LIMITED",
"LAKSHMI SARASWATHI COTTON MILLS PRIVATE LIMITED",
"LAKSHMI SHREE INVESTMENT AND SECURITIES LTD",
"LAKSHMI SHREE INVESTMENT AND SECURITIES PVT LTD",
"LAKSHMI SHRIMP PRODUCTS PRIVATE LIMITED",
"LAKSHMI SOLVEX PRIVATE LIMITED",
"LAKSHMI SOUNDARYA CONSTRUCTIONS PRIVATE LIMITED",
"LAKSHMI SRINIVASA FLOUR MILLS PRIVATE LIMITED",
"LAKSHMI SUNDARAVADANAN HOSPITAL PRIVATE LIMITED",
"LAKSHMI SUTHAA FUTURISTIC AUTOMOTIVES PRIVATE LIMITED",
"LAKSHMI SYNCOTS PRIVATE LIMITED",
"LAKSHMI SYNDICATE PRIVATE LIMITED",
"LAKSHMI TECHNOLOGY AND ENGINEERING INDUSTRIES LIMITED",
"LAKSHMI TRADESOFT PRIVATE LIMITED",
"LAKSHMI TRAVELS & FOREX PRIVATE LIMITED",
"LAKSHMI TRIMURTI DECOR PRIVATE LIMITED",
"LAKSHMI UTILITY FINANCE PRIVATE LIMITED",
"LAKSHMI VACUUM HEAT TREATERS PRIVATE LIMITED",
"LAKSHMI VACUUM SERVICES PRIVATE LIMITED",
"LAKSHMI VACUUM TECHNOLOGIES PRIVATE LIMITED",
"LAKSHMI VELVETTE INDIA PRIVATE LIMITED",
"LAKSHMI VENKAT FARMS LIMITED",
"LAKSHMI VENKATA SAI RICE INDUSTRIES",
"LAKSHMI VIDYA SANGHAM",
"LAKSHMI VILAS BANK",
"LAKSHMI VINAYAKA TRADERS",
"LAKSHMI WHEAT PRODUCTS PRIVATE LIMITED",
"LAKSHMIBAI COLLEGE",
"LAKSHMIBAI NATIONAL INSTITUTE OF PHYSICAL EDUCATION GWALIOR",
"LAKSHMIDURGA TEXTILES PRIVATE LIMITED",
"LAKSHMIGRAHA ENTERPRISES PRIVATE LIMITED",
"LAKSHMIJI SUGAR MILLS COMPANY LIMITED",
"LAKSHMIMAHIMA METALLOYS PRIVATE LIMITED",
"LAKSHMIPATI INDUSTRIES PRIVATE LIMITED",
"LAKSHMIPRIYA STEELS PRIVATE LIMITED",
"LAKSHMISARASWATHI CHEMICALS AND ORGANICS PRIVATE LIMITED",
"LAKSHMISHREE CAPITAL SERVICES PRIVATE LIMITED",
"LAKSHMISHREE COMMODITIES PRIVATE LIMITED",
"LAKSHMIVEL MILLS PRIVATE LIMITED",
"LAKSHMIWADI MINES AND MINERALS PRIVATE LIMITED",
"LAKSHMIWAN POLYMERS PRIVATE LIMITED",
"LAKSHMIYAM HOMES INDIA PRIVATE LIMITED",
"LAKSHY MANAGEMENT CONSULTANT PRIVATE LIMITED",
"LAKSHYA AQUACULTURE PRIVATE LIMITED",
"LAKSHYA CAPITAL VENTURES PRIVATE LIMITED",
"LAKSHYA COAL AND TRANSPORTING PRIVATE LIMITED",
"LAKSHYA COMPLETE SOLUTIONS PRIVATE LIMITED",
"LAKSHYA DIGITAL PRIVATE LIMITED",
"LAKSHYA EDUCATIONAL SERVICES (INDIA) PRIVATE LIMITED",
"LAKSHYA ELECTRICALS PRIVATE LIMITED",
"LAKSHYA ELECTRONET PRIVATE LIMITED",
"LAKSHYA ENTERPRISES PRIVATE LIMITED",
"LAKSHYA FLEXI TUBES & PROFILE PRIVATE LIMITED",
"LAKSHYA HEALTH FOOD PRIVATE LIMITED",
"LAKSHYA HOTELS AND RESORTS PRIVATE LIMITED",
"LAKSHYA INTERNET PRIVATE LIMITED",
"LAKSHYA JEWAR JEWELLERY HOUSE PRIVATE LIMITED",
"LAKSHYA LIFECARE PRODUCTS PRIVATE LIMITED",
"LAKSHYA MOTORS PRIVATE LIMITED",
"LAKSHYA PACKAGING PRIVATE LIMITED",
"LAKSHYA PHARMA PRIVATE LIMITED",
"LAKSHYA POWERTECH PRIVATE LIMITED",
"LAKSHYA SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"LAKSHYA TECH INDIA PRIVATE LIMITED",
"LAKSHYA TECHNOCRATS INDIA PRIVATE LIMITED",
"LAKSHYA TECHNOINFRA PRIVATE LIMITED",
"LAKSHYA TECHNOLOGY PRIVATE LIMITED",
"LAKSHYA TECHSOLUTIONS LIMITED",
"LAKSHYA VINIYOG PRIVATE LIMITED",
"LAKSHYAA EDUCATIONAL INSTITUTIONS",
"LAKSHYAIM PAPER PRODUCTS PRIVATE LIMITED",
"LAKSHYAS AGRI SOLUTIONS PRIVATE LIMITED",
"LAKSHYE STEELS PRIVATE LIMITED",
"LAKSON TECHNOLOGY PRIVATE LIMITED",
"LAKSTECH IT SOLUTIONS PRIVATE LIMITED",
"LAKVIN DEVELOPERS PRIVATE LIMITED",
"LAL BABA SEAMLESS TUBES PRIVATE LIMITED",
"LAL BAHADUR SHASHTRI HOSPITAL",
"LAL BAHADUR SHASTRI COLLAGE OF ARTS SCIENCE AND COMMERCE SATARA",
"LAL BAHADUR SHASTRI ENGLISH SCHOOL BASMATH",
"LAL BAHADUR SHASTRI INTER COLLEGE BAREILLY",
"LAL BAHADUR SHASTRI NATIONAL ACADEMY OF ADMINISTRATION",
"LAL BAHADUR SHASTRI PG COLLEGE JAIPUR",
"LAL BAHADUR SHASTRI URDU HIGH SCHOOL",
"LAL BHADUR SHASTRI URDU PRIMARY SCHOOL",
"LAL CHINTA RICE MILLS PRIVATE LIMITED",
"LAL FERRO ALLOYS COMPANY PRIVATE LIMITED",
"LAL GEBI INFRA PRIVATE LIMITED",
"LAL INTERNATIONAL PRIVATE LIMITED",
"LAL METAL FORGE PRIVATE LIMITED",
"LAL OIL AND GENERAL MILLS PRIVATE LIMITED",
"LAL STEELS PRIVATE LIMITED",
"LAL SWEETS PRIVATE LIMITED",
"LAL TYRES PRIVATE LIMITED",
"LALA AGRO TROPIC PRIVATE LIMITED",
"LALA AMBA PRASAD SMARAK CHIKITSALAYA",
"LALA CHHOTELAL RADHESHYAM NAVYUVAK INTER COLLEGE BADAUN BAREILLY",
"LALA JAGAT NARAIN DAV MODEL SCHOOL",
"LALA JUGAL KISHORE SAREES PRIVATE LIMITED",
"LALA KAILASHPAT SINGHANIA PUBLIC SCHOOL",
"LALA LAJPAT RAI HOSPITAL HALLETT HOSPITAL",
"LALA LAJPAT RAI INSTITUTE OF MANAGEMENT",
"LALA LAJPAT RAI MEMORIAL MEDICAL COLLEGE",
"LALA LAJPATRAI COLLEGE OF LAW",
"LALA LAJPATRAI INSTITUTE OF MANAGEMENT",
"LALA MADHORAM BHAGWAN DAS CHARITABLE SOCIETY",
"LALA PIPES PRIVATE LIMITED",
"LALA PURSHOTTAM DAS JEWELLERS PRIVATE LIMITED",
"LALA SHIVNATH RAI SUMERCHAND CONFECTIONER PRIVATE LIMITED",
"LALAHS INDIAN SPICES AND FOOD PRIVATE LIMITED",
"LALAJI FLATSWALE PRIVATE LIMITED",
"LALAJI MEMORIAL OMEGA INTERNATIONAL SCHOOL",
"LALAJI'S KITCHEN PRIVATE LIMITED",
"LALAMOVE INDIA PRIVATE LIMITED",
"LALANI AND COMPANY PVT LTD",
"LALANI INFO TECH LIMITED",
"LALANI INNOVATIONS PRIVATE LIMITED",
"LALANI SUITINGS PRIVATE. LIMITED.",
"LALBABA INDUSTRIAL CORPORATION PRIVATE LIMITED",
"LALBABA PROJECTS PRIVATE LIMITED",
"LALBAHADUR SHASTRI SR COLLEGE PARTUR",
"LALBHAI BROKERS PRIVATE LIMITED",
"LALBHAI DALPATBHAI INSTITUTE OF INDOLOGY",
"LALBHAI INDUSTRIES PRIVATE LIMITED",
"LALCHAND GULABCHAND TRADINGS PVT LTD",
"LALCHAND JEWELLERS PRIVATE LIMITED",
"LALCHAND MANGALDAS SONI GEMS AND JEWELLERS PRIVATE LIMITED",
"LALCHAND SOBHRAJ SONS JEWELLERS PRIVATE LIMITED",
"LALCHND BUILDER PRIVATE LIMITED",
"LALCHND GEM & JEWELLER PRIVATE LIMITED",
"LALCHND RESORT PRIVATE LIMITED",
"LALCO PHARMA PRIVATE LIMITED",
"LALCO RESIDENCY LLP",
"LALDIGHI MEDICAL CENTRE PRIVATE LIMITED",
"LALGANGA BUILDERS PRIVATE LIMITED",
"LALGANJ POWER PRIVATE LIMITED",
"LALI SHEETALAY PRIVATE LIMITED",
"LALIT CHANDRA BHARALI COLLEGE",
"LALIT ELECTROTECH PVT. LTD",
"LALIT GREAT EASTERN KOLKATA HOTEL LIMITED",
"LALIT HANS PROTIEN PRIVATE LIMITED",
"LALIT HARI RAJKIYE AYURVAD MAHAVIDHYALA EVAM CHIKITSALYA",
"LALIT IMPEX PVT LTD",
"LALIT KALA AKADEMI",
"LALIT KUMAR AMIT KUMAR AGRO PRIVATE LIMITED",
"LALIT MOHAN SPICES PRIVATE LIMITED",
"LALIT PIPES & PIPES PRIVATE LIMITED",
"LALIT POLYPLAST PRIVATE LIMITED",
"LALIT VIDYA NIKETAN",
"LALITA ELECTRICALS PRIVATE LIMITED",
"LALITA FOAMEX PRIVATE LIMITED",
"LALITA INFRAPROJECTS PRIVATE LIMITED",
"LALITA LOGASTICES AND AGENCIES PRIVATE L",
"LALITA MEMORIAL HOSPITAL PRIVATE LIMITED",
"LALITA PROJECTS PRIVATE LIMITED",
"LALITA RICE MILL PRIVATE LIMITED",
"LALITA STEEL INDUSTRIES PVT LTD",
"LALITH CORRUGATING PRIVATE LIMITED",
"LALITH REALTORS PRIVATE LIMITED",
"LALITHA CHEM INDUSTRIES PRIVATE LIMITED",
"LALITHA DEGREE PG COLLEGE",
"LALITHA ENGINEERING PVT LTD",
"LALITHA ENGINEERING WORKS",
"LALITHA HEALTHCARE PRIVATE LIMITED",
"LALITHA MEDICARE PRIVATE LIMITED",
"LALITHA PVS INSTITUTE OF MEDICAL SCIENCES PRIVATE LIMITED",
"LALITHA SUPER SPECIALITIES HOSPITAL PRIVATE LIMITED",
"LALITHAA JEWELLERY MART LIMITED",
"LALITHAA JEWELLERY MART PRIVATE LIMITED",
"LALITMOHAN RICE MILL PVT LTD",
"LALITOM FOOD PRODUCTS PRIVATE LIMITED",
"LALITPUR POWER GENERATION COMPANY LIMITED",
"LALJEE FOOD PRODUCTS PRIVATE LIMITED",
"LALJEE TRADELINKS PRIVATE LIMITED",
"LALJI AROMATICS PRIVATE LIMITED",
"LALJI GEMS AND JEWELLERS PRIVATE LIMITED",
"LALJI JEWELLERS PRIVATE LIMITED",
"LALJI LAKHAMSHI AND SONS (AGRO) PRIVATE LIMITED",
"LALJI ORNAMENT HOUSE PRIVATE LIMITED",
"LALJI OVERSEAS PRIVATE LIMITED",
"LALJI SARRAF PRIVATE LIMITED",
"LALJIBHAI JEWELLERS PRIVATE LIMITED",
"LALKAR SECURITIES PRIVATE LIMITED",
"LALKUAN STONE CRUSHERS INDIA PRIVATE LIMITED",
"LALL MINERALS PRIVATE LIMITED",
"LALL STEELS PRIVATE LIMITED",
"LALLACHERRA TEA CO PVT LTD",
"LALLEMAND INDIA PRIVATE LIMITED",
"LALLI OVERSEAS PRIVATE LIMITED",
"LALLOOJI AND SONS PRIVATE LIMITED",
"LALLUBHAI AMICHAND LIMITED",
"LALLY AUTOMOBILES (INDIA) PRIVATE LIMITED",
"LALLY AUTOMOBILES PRIVATE LIMITED",
"LALLY MOTORS INDIA PRIVATE LIMITED",
"LALLY MOTORS PRIVATE LIMITED",
"LALLY MOTORS SERVICES PRIVATE LIMITED",
"LALMAN FASHIONS PRIVATE LIMITED",
"LALOO JI DERAWALA PRIVATE LIMITED",
"LALPUR WIND ENERGY PRIVATE LIMITED",
"LAL'S EXPORTERS (INDIA) PRIVATE LIMITED",
"LALS SOFTWARE SERVICES PRIVATE LIMITED",
"LALSON ELECTRO TECH PRIVATE LIMITED",
"LALSONS INKS PRIVATE LIMITED",
"LALSTREETAGRI TECH AND SOFTWARE SERVICES PRIVATE LIMITED",
"LALU'S AUDIO VISUAL CENTRE PRIVATE LIMITED",
"LALWANI BOMBAY SAREE COLLECTION PRIVATE LIMITED",
"LALWANI FERRO ALLOYS LIMITED",
"LALWANI FURNISHING PRIVATE LIMITED",
"LALWANI INDUSTRIES LIMITED",
"LALWANI METALLICS PRIVATE LIMITED",
"LALZ AUTOMOBILES PRIVATE LIMITED",
"LAM RESEARCH INDIA PRIVATE LIMITED",
"LAMA ENGINEERS AND CONTRACTORS PRIVATE LIMITED",
"LAMA RICE PRIVATE LIMITED",
"LAMAK SYNTEX PVT LTD",
"LAMANE INFRASTRUCTURE PRIVATE LIMITED",
"LAMAR HEALTHCARRE PRIVATE LIMITED",
"LAMAR LINAN ENTERPRISES PRIVATE LIMITED",
"LAMAR NATURAL PRODUCT PRIVATE LIMITED",
"LAMB CERAMICS PRIVATE LIMITED",
"LAMBA & JUNEJA CRANES PRIVATE LIMITED",
"LAMBA AUTOMOTIVE PRIVATE LIMITED",
"LAMBA BRICKS PRIVATE LIMITED",
"LAMBA BROS PRIVATE LTD.",
"LAMBA ENTERPRISES PRIVATE LIMITED",
"LAMBA EXPORTS PRIVATE LIMITED",
"LAMBA INTERNATIONAL PRIVATE LIMITED",
"LAMBA MOTORS PRIVATE LIMITED",
"LAMBA STEEL AND ALLOYS PRIVATE LTD",
"LAMBA TECHNO FLOORING SOLUTIONS PRIVATE LIMITED",
"LAMBA TIMBER WORKS PRIVATE LIMITED",
"LAMBAY INFRA LLP",
"LAMBDA INFRATECH LIMITED",
"LAMBDA TECHNOLOGIES LIMITED LIABILITY PARTNERSHIP",
"LAMBDA THERAPEUTIC RESEARCH LIMITED",
"LAMBDATEST INDIA PRIVATE LIMITED",
"LAMBDAZEN INDIA PRIVATE LIMITED",
"LAMBERT LIGHTING PRODUCT PRIVATE LIMITED",
"LAMBERT SECURITY MANAGEMENT PRIVATE LIMITED",
"LAMBERTI HYDROCOLLOIDS PRIVATE. LIMITED",
"LAMBODAR FERRO ALLOYS LTD",
"LAMBODAR INVESTMENTS AND TRADING COMPANY LIMITED",
"LAMBODAR MOULDERS PRIVATE LIMITED",
"LAMBODAR STOCKS PRIVATE LIMITED",
"LAMBODAR SUPPLIERS PRIVATE LIMITED",
"LAMBODAR VINTRADE PRIVATE LIMITED",
"LAMBODHARA TEXTILES LIMITED",
"LAMBODRA INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"LAMBORSHI INDUSTRIES LIMITED",
"LAMBROS ANALYTICS PRIVATE LIMITED",
"LAMBTON KUNSTWERK MACHINERY INDIA PRIVATE LIMITED",
"LAMCO INDUSTRIES UNIT-II PRIVATE LIMITED",
"LAMCO TRANSFORMERS PRIVATE LIMITED",
"LAMCON FINANCE AND MANAGEMENT SERVICES PRIVATE LIMITED",
"LAMDA COMPONENTS PRIVATE LIMITED",
"LA-MED PRIVATE LIMITED",
"LAMET PHARMA PRIVATE LIMITED",
"LAMHAS SATELLITE SERVICES LIMITED",
"L'AMICALE CLUB & RESORT PRIVATE LIMITED",
"LAMICO NANPURIA SOLUTIONS PRIVATE LIMITED",
"LAMIFABS & PAPERS PRIVATE LIMITED",
"LAMIFLEX PACKTECH INDIA PRIVATE LIMITED",
"LAMILUX INDIA PRIVATE LIMITED",
"LAMINA FOUNDRIES LIMITED",
"LAMINA LEASING ANDFINANCE LIMITED",
"LAMINA RESEARCH CENTER PRIVATE LIMITED",
"LAMINA SUSPENSION PRODUCTS LIMITED",
"LAMINEX",
"LAMIT INDUSTRIES PRIVATE LIMITED",
"LAMIT ROOFTECH (INDIA) PRIVATE LIMITED",
"LA-MODE FASHIONS PRIVATE LIMITED",
"L'AMOUR FASHIONS PRIVATE LIMITED",
"L'AMOUR VOYAGES PRIVATE LIMITED",
"LAMPADAIRE ENGINEERING & INFRASTRUCTURE PRIVATE LIMITED",
"LAMPEX ELECTRONICS",
"LAMPO COMPUTERS PRIVATE LIMITED",
"LAMSY SOFTEK PRIVATE LIMITED",
"LAMTECH SOLUTIONS LLP",
"LAMTUF LIMITED",
"LAN FINANCE PRIVATE LIMITED",
"LAN MARK SHOPS INDIA LIMITED",
"LAN MARK SHOPS INDIA PRIVATE LIMITED",
"LAN SPIN TEX PRIVATE LIMITED",
"LANARSY INFRA LIMITED",
"LANASOL ENERGY SOLUTIONS PRIVATE LIMITED",
"LANASOL ENTERTAINMENT PRIVATE LIMITED",
"LANCAN INDUSTRIES PRIVATE LIMITED",
"LANCE ENERGY SOLUTIONS PRIVATE LIMITED",
"LANCER CONTAINER LINES LIMITED",
"LANCER FAB TECH PRIVATE LIMITED",
"LANCER FOOTWEAR INDIA PRIVATE LIMITED",
"LANCER LASER TECH LIMITED",
"LANCER LOGISTICS PRIVATE LIMITED",
"LANCER REINFORCEMENTS PRIVATE LIMITED",
"LANCER SECURITAS SERVICES PRIVATE LIMITED",
"LANCER SHIELD FORCE PRIVATE LIMITED",
"LANCER SPICES PRIVATE LIMITED",
"LANCER TOOLS PRIVATE LIMITED",
"LANCER TRAVELS PRIVATE LIMITED",
"LANCERS ARMY SCHOOL",
"LANCERS IMPEX PRIVATE LI MITED",
"LANCERS INTERNATIONAL SCHOOL",
"LANCERS NETWORK LIMITED",
"LANCESOFT INDIA PRIVATE LIMITED",
"LANCET SOFTWARE INDIA PRIVATE LIMITED",
"LANCEWOOD INFRA PRIVATE LIMITED",
"LANCIFY CONNECT PRIVATE LIMITED",
"LANCO AGRO FOODS INDIA PRIVATE LIMITED",
"LANCO ANPARA POWER LIMITED",
"LANCO HOSKOTE HIGHWAY LIMITED",
"LANCO KANPUR HIGHWAYS LIMITED",
"LANCO SOLAR (GUJARAT) PRIVATE LIMITED",
"LANCO TEESTA HYDRO POWER LIMITED",
"LANCOR HOLDINGS LIMITED",
"LAND & TOOL INFRASTRUCTURE PRIVATE LIMITED",
"LAND ACQUISITION DEPT",
"LAND AIR TRAVELS P LIMITED",
"LAND AND MARITIME SERVICES PRIVATE LIMITED",
"LAND FARM AGRO TECH EXIM PRIVATE LIMITED",
"LAND KART BUILDERS PRIVATE LIMITED",
"LAND MARK TILES PRIVATE LIMITED",
"LAND RECORD DEPARTMENT",
"LAND SCIENCE BUILDWELL LLP",
"LAND TRADES BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"LANDANGEN SOFTWARE PRIVATE LIMITED",
"LANDASIA INFRASTRUCTURE LIMITED",
"LANDBASE INDIA LIMITED",
"LANDCAPITAL ESTATES PRIVATE LIMITED",
"LANDCHESTER AVIATION PRIVATE LIMITED",
"LANDE PATIL TRANSPORT PRIVATE LIMITED",
"LANDESA CONSULTING PRIVATE LIMITED",
"LANDESBANK BADEN - WURTTEMBERG",
"LANDGRACE CERAMIC PRIVATE LIMITED",
"LANDIS GYR LIMITED",
"LANDLINE IMPORTS & EXPORTS PRIVATE LIMITED",
"LANDLORD LANDMARK PRIVATE LIMITED",
"LANDLORD PROPERTIES PRIVATE LIMITED",
"LANDMARC LEISURE CORPORATION LIMITED",
"LANDMARK ABASAN PRIVATE LIMITED",
"LANDMARK AGRI EXPORTS PRIVATE LIMITED",
"LANDMARK AQUATEC PRIVATE LIMITED",
"LANDMARK AUTOMOBILES LIMITED",
"LANDMARK BOOKS PRIVATE LIMITED",
"LANDMARK BUILDWELL PRIVATE LIMITED",
"LANDMARK CAPITAL ADVISORS PRIVATE LIMITED",
"LANDMARK CAPITAL MARKETS PRIVATE LIMITED",
"LANDMARK CARS EAST PRIVATE LIMITED",
"LANDMARK CARS LIMITED",
"LANDMARK CARS PRIVATE LIMITED",
"LANDMARK CFS PRIVATE LIMITED",
"LANDMARK COMMERCIAL PRIVATE LIMITED",
"LANDMARK COMMERCIAL VEHICLES PRIVATE LIMITED",
"LANDMARK COMMERCIAL VEHICLES PRIVATE LIMITED HCV",
"LANDMARK CONCEPTS PRIVATE LIMITED",
"LANDMARK DIGITAL RETAIL PRIVATE LIMITED",
"LANDMARK ELECTRICAL PRIVATE LIMITED",
"LANDMARK GLOBFIN LIMITED",
"LANDMARK GROUP",
"LANDMARK HEALTH TECHNOLOGIES PRIVATE LIMITED",
"LANDMARK HOMEBUILD (INDIA) PRIVATE LIMITED",
"LANDMARK HOSPITALS",
"LANDMARK HUMAN RESOURCES SERVICES PRIVATE LIMITED",
"LANDMARK IMMIGRATION CONSULTANTS PRIVATE LIMITED",
"LANDMARK INFONET PRIVATE LIMITED",
"LANDMARK INFRALOGISTICS PRIVATE LIMITED",
"LANDMARK INSURANCE BROKERS PRIVATE LIMITED",
"LANDMARK IT SOLUTIONS PRIVATE LIMITED",
"LANDMARK LAND HOLDINGS PRIVATE LIMITED",
"LANDMARK LEISURES & HOTELS PRIVATE LIMITED",
"LANDMARK LIFESTYLE CARS PRIVATE LIMITED",
"LANDMARK MATERIAL TESTING AND RESEARCH LABORATORY PRIVATE LIMITED",
"LANDMARK NEST PRIVATE LIMITED",
"LANDMARK OFFICE SYSTEMS PRIVATE LIMITED",
"LANDMARK ONLINE INDIA PRIVATE LIMITED",
"LANDMARK PACKS PRIVATE LIMITED",
"LANDMARK PREMISES PRIVATE LIMITED",
"LANDMARK PRODEVELOPERS PRIVATE LIMITED",
"LANDMARK REAL ESTATE DEVELOPERS LIMITED",
"LANDMARK ROYAL ENGINEERING (INDIA) PRIVATE LIMITED",
"LANDMARK SIGNBOARDS PRIVATE LIMITED",
"LANDMARK SIZING",
"LANDMARK SYSTEMS AND SOLUTIONS PRIVATE LIMITED",
"LANDMARK VENEERS PRIVATE LIMITED",
"LANDMARK WORLDWIDE BREAKTHROUGH TECHNOLOGIES PRIVATE LIMITED",
"LANDSCAPE OUTSOURCE MARKETING PRIVATE LIMITED",
"LANDSCAPE REALITY",
"LANDSEA IMPEX LIMITED",
"LANDSKY ALLIED INDUSTRIES PRIVATE LIMITED",
"LANDSKY ENGINEERS PRIVATE LIMITED",
"LANDSMILL AGRO PRIVATE LIMITED",
"LANDT WELFARE COMPANY LIMITED",
"LANDTECH AEPC PRIVATE LIMITED",
"LANDWIRT INDIA PRIVATE LIMITED",
"LANEXIS PRIVATE LIMITED",
"LANFEST PRIVATE LIMITED",
"LANFORD CERAMIC PRIVATE LIMITED",
"LANGAR BIDI COMPANY POONA",
"LANGERS INTERNATIONAL PRIVATE LIMITED",
"LANGFORD CONSTRUCTIONS PRIVATE LIMITED",
"LANGHAM CAPITAL INDIA PRIVATE LIMITED",
"LANGLAI TEA AND INDUSTRIES LTD",
"LANGOO ENGINEERING SOLUTIONS PRIVATE LIMITED",
"LANGOOR MARKETING TRANSFORMATION PRIVATE LIMITED",
"LANGRO INDIA PRIVATE LIMITED",
"LANGUAGE ART CULTURE DEPTT",
"LANIK CERAMIC FOAM FILTERS INDIA PRIVATE LIMITED",
"LANIKA SOLUTIONS PRIVATE LIMITED",
"LANKA RSK INFRASTRUCTURE PRIVATE LIMITED",
"LANKASHI TEA & SEED ESTATES PVT LTD",
"LANKESWARI MOTORS PRIVATE LIMITED",
"LANNET INFOTECH LLP",
"LANS ENTERPRISES PRIVATE LIMITED",
"LANSDOWN MEDICALS PVT LTD",
"LANSH ENGINEERIING PRIVATE LIMITED",
"LANSHANG INDUSTRIAL PRIVATE LIMITED",
"LANSISO INNOVATION TECHNOLOGIES PRIVATE LIMITED",
"LANSON CARS PRIVATE LIMITED",
"LANSON MOTORS PRIVATE LIMITED",
"LANSON Q CARS PRIVATE LIMITED",
"LANSUM PROPERTIES LLP",
"LANTECH SYSTEMS INDIA PRIVATE LTD",
"LANTERN OF ART PRIVATE LIMITED",
"LANTERN PHARMACEUTICALS PRIVATE LIMITED",
"LANTIQ COMMUNICATIONS INDIA PRIVATE LIMITED",
"LANTR MARKETING PRIVATE LIMITED",
"LANTRASOFT PRIVATE LIMITED",
"LANTRO TECHNOLOGY PRIVATE LIMITED",
"LANTRONIX INDIA PRIVATE LIMITED",
"LANUS LAB PRIVATE LIMITED",
"LANVS GREEK INDIA PRIVATE LIMITED",
"LANWARE INFOTECH (INDIA) PRIVATE LIMITED",
"LANXESS INDIA PRIVATE LIMITED",
"LANXESS PERFORMANCE MATERIALS (INDIA) PRIVATE LIMITED",
"LANXESS SOLUTIONS INDIA PRIVATE LIMITED",
"LANXIN ENGINEERING PRIVATE LIMITED",
"LANXIN INFRATECH PRIVATE LIMITED",
"LANYA CHEM INDUSTRIES PRIVATE LIMITED",
"LANYA CHEMICAL (INDIA) PRIVATE LIMITED",
"LANZA APPARELS PRIVATE LIMITED",
"LANZATECH PRIVATE LIMITED",
"LANZEINTEGRA TECHNOLOGIES PRIVATE LIMITED",
"LAO JAN TEA CO PVT LTD",
"LAO-MORE BISCUITS PVT LTD",
"LAP AND DADO ENTERPRISES PRIVATE LIMITED",
"LAPAN HEALTHCARE PRIVATE LIMITED",
"LAPCOM PERIPHERALS PRIVATE LIMITED",
"LA-PHARMA(GUJARAT) PRIVATE LIMITED",
"LAPIS INDIA CAPITAL ADVISORS PRIVATE LIMITED",
"LAPIZ DIGITAL SERVICES",
"LAPKING BUSINESS PRIVATE LIMITED",
"LAPL AUTOMOTIVE PRIVATE LIMITED",
"LAPLAND ENTERPRISES PRIVATE LIMITED",
"LAPLIFE ELECTRONICS PRIVATE LIMITED",
"LAPMASTER WOLTERS INDIA PRIVATE LIMITED",
"LAPP INDIA PRIVATE LIMITED",
"LAPSYS INFOTECH PRIVATE LIMITED",
"LAPTECH SOLUTIONS PRIVATE LIMITED",
"LAPTOPIA INFOTECH PRIVATE LIMITED",
"LAPTRON TECHNOLOGY PRIVATE LIMITED",
"LAPYRAMID HOSPITALITIES PRIVATE LIMITED",
"LAQSH JOB SKILLS ACADEMY PRIVATE LIMITED",
"LAQSHYA DIGITAL MEDIA PRIVATE LIMITED",
"LAQSHYA EVENT IP PRIVATE LIMITED",
"LAQSHYA HYDERABAD AIRPORT MEDIA PRIVATE LIMITED",
"LAQSHYA LIVE EXPERIENCES PRIVATE LIMITED",
"LAQSHYA MEDIA LIMITED",
"LARA EXIMP PRIVATE LIMITED",
"LARAKSHA IMPACT FINANCE ENTERPRISE PRIVATE LIMITED",
"LARAON ENGINEERS AND CONSULTANTS PRIVATE LIMITED",
"LARCO INDIA PRIVATE LIMITED",
"LARES AGRI BIOTECH PRIVATE LIMITED",
"LARES GLOBAL LIMITED",
"LARES SOFTECH PRIVATE LIMITED",
"LARGE LOGIC PRIVATE LIMITED",
"LARICA ESTATES LIMITED",
"LARICA LED PRODUCTS PRIVATE LIMITED",
"LARION LIFE SCIENCES PRIVATE LIMITED",
"LARISA AGRO PRIVATE LIMITED",
"LARISA ENTERPRISES PRIVATE LIMITED",
"LARIYA ART PALACE PRIVATE LIMITED",
"LARIYA RESORT PRIVATE LIMITED",
"LARK ENGINEERING COMPANY INDIA PRIVATE LIMITED",
"LARK LABORATORIES INDIA LIMITED",
"LARK LOGISTICS PRIVATE LIMITED",
"LARK PACKS PRIVATE LIMITED",
"LARK PROJECTS PRIVATE LIMITED",
"LAROM ORGANICS PRIVATE LIMITED",
"LARS ENVIRO PRIVATE LIMITED",
"LARS SECURITIES PVT LTD",
"LARSEN AND TOUBRO LIMITED",
"LARSON PHARMA PRIVATE LIMITED",
"LARSRN INFRASTRUCTURE PRIVATE LIMITED",
"LAS ENGINEERS AND CONSULTANTS PRIVATE LIMITED",
"LAS VEGAS SANDS CORP.",
"LASA CONSULTANCY PRIVATE LIMITED",
"LASA ENGINEERS PRIVATE LIMITED",
"LASA KNIT INDIA PRIVATE LIMITED",
"LASA SUPERGENERICS LIMITED",
"LA-SANI INFRA PRIVATE LIMITED",
"LASARA HOTELS PRIVATE LIMITED",
"LASCO MEDICARE PRIVATE LIMITED",
"LASCO SHIPPING COMPANY PRIVATE LIMITED",
"LASENOR CHARBHUJA FOODS PRIVATE. LIMITED.",
"LASER AUTOMATION PRIVATE LIMITED",
"LASER BEAM SOFTWARE PRIVATE LIMITED",
"LASER COTE PVT LTD",
"LASER CUT (I) TECHNOLOGY PRIVATE LIMITED",
"LASER FABRICS PRIVATE LIMITED",
"LASER FIBERS PRIVATE LIMITED",
"LASER HOLOGRAMS PVT LTD",
"LASER LAB (INDIA) PRIVATE LIMITED",
"LASER POWER & INFRA PRIVATE LIMITED",
"LASER SCIENCE & TECHNOLOGY CENTRE",
"LASER SHAVING INDIA PRIVATE LIMITED",
"LASER SHAVING PRODUCTS PRIVATE LIMITED",
"LASER SOFT INFOSYSTEMS LIMITED",
"LASER SOS (INDIA) PRIVATE LIMITED",
"LASER SPECIALITY CHEMICALS PRIVATE LIMITED",
"LASER SPECTRA SERVICES INDIA PRIVATE LIMITED",
"LASER SYSTMS PRIVATE LIMITED",
"LASER TECHNOLOGIES PRIVATE LIMITED",
"LASER TELESYSTEMS PRIVATE LIMITED",
"LASERASIA TECHNOLOGIES PRIVATE LIMITED",
"LASERSEC TECHNOLOGIES PRIVATE LIMITED",
"LASH TECHNOLOGIES PRIVATE LIMITED",
"LASHKARI DEVELOPERS PVT. LTD",
"LASHKARIA HOUSING & INFRASTRUCTURE PRIVATE LIMITED",
"LASNARO KISAN BAZAAR PRIVATE LIMITED",
"LASONS INDIA PRIVATE LIMITED",
"LASSO AND MARQUEE DESIGN SOLUTIONS PRIVATE LIMITED",
"LASSOL PRIVATE LIMITED",
"LAST 3 FEET MARKETING SOLUTIONS PRIVATE LIMITED",
"LAST DECIMAL PRIVATE LIMITED",
"LAST DROP HOSPITALITY PRIVATE LIMITED",
"LAST INCH APPAREL PRIVATE LIMITED",
"LAST MILE COMMUNICATIONS PRIVATE LIMITED",
"LAST MILE ENTERPRISES LIMITED",
"LAST MILE INFRAPROJECTS PRIVATE LIMITED",
"LAST MILE XPRESS PRIVATE LIMITED",
"LAST PEAK DATA PRIVATE LIMITED",
"LAST WORD CONSULTING PRIVATE LIMITED",
"LAST9 PRIVATE LIMITED",
"LASTAKI ADVISORS PRIVATE LIMITED",
"LASTANGATA SOURCING INDIA PRIVATE LIMITED",
"LASTERRA EXIM INDIA PRIVATE LIMITED",
"LASTMILE SOLUTIONS INDIA PRIVATE LIMITED",
"LASTMILE TRANSTECH PRIVATE LIMITED",
"LASTRA NIRAJ PRIVATE LIMITED",
"LASVIN FINVEST PVT LTD",
"LASYS TECHNOLOGIES PRIVATE LIMITED",
"LATA COLD STORAGE PRIVATE LIMITED",
"LATA FIBRES PRIVATE LIMITED",
"LATA FOOD PRODUCTS PRIVATE LIMITED",
"LATA HOSPITALS",
"LATA INFRA MANUFACTURING PRIVATE LIMITED",
"LATA MANGESHKAR HOSPITAL",
"LATA SHEETALAYA PRIVATE LIMITED",
"LATA TOOLINGS PRIVATE LIMITED",
"LATAMBARCEM BREWERS PRIVATE LIMITED",
"LATASHA IMPEX PRIVATE LIMITED",
"LATE ABASO S S PATIL MADHYAMIK VIDYALAYA LONDHAVE TAL AMALNER",
"LATE B G CHAYYA SUB DISTRICT HOSPITAL AMBERNATH",
"LATE BANDOJI KHANDOJI CHAVAN JR COLLEGE",
"LATE CHHAGANLAL MULJIBHAI KADHI KALA MAHAVIDYALAYA ACHALPUR CAMP",
"LATE DATTATRAYA PUSADKAR ARTS COLLEGE",
"LATE GURUDAYAISING RATHOD SECONDARY JAI BALAJI HIGHER SECONDARY ASHRAM SCHOOL",
"LATE LALASHETH BIHANI VIDYA MANDIR PRASHALA RAHURI",
"LATE MANIK'S PODAR LEARN SCHOOL WADHONA",
"LATE MANOHARRAO KAMDI COLLEGE",
"LATE N B CHHABADA INST OF ENGG AND TEC",
"LATE N P W COLLEGE EKODI",
"LATE PANDURANG RAGHUNATH PATIL VIDYALAYA & JUNIOR COLLEGE",
"LATE PRAKASHBHAU UMATHE VIDYALAYA",
"LATE PROF V Y GHASKADBI ARTS SCIENCE AND HSC VOCATIONAL JR COLLEGE DHULE",
"LATE R G DESHMUKH COLLEGE OF AGRICULTURE TIWASA",
"LATE SHRI VISHNU WAMAN THAKUR CHARITABLE TRUST",
"LATECOERE INDIA PRIVATE LIMITED",
"LATENT RENEWABLE ENERGIES PRIVATE LIMITED",
"LATENT VIEW ANALYTICS LIMITED",
"LATENT VIEW ANALYTICS PRIVATE LIMITED",
"LATERAL EMSOFT PRIVATE LIMITED",
"LATERAL MGT. SERVICES LIMITED",
"LATERAL PRAXIS INDIA PRIVATE LIMITED",
"LATERAL VIEW TECHNOLOGIES PRIVATE LIMITED",
"LATEST MARBLES PRIVATE LIMITED",
"LATESTLY MEDIA PRIVATE LIMITED",
"LATEX CHEMICALS PRIVATE LIMITED",
"LATEX HOUSE",
"LATH INDUSTRIES PRIVATE LIMITED",
"LATH SACHIDANANDA AGRO PRIVATE LIMITED",
"LATHANAND MOTORS PRIVATE LIMITED",
"LATHIA INDUSTRIAL ROLLER PRIVATE LIMITED",
"LATHIA INDUSTRIAL SUPPLIES CO PVT LTD",
"LATHIA RUBBER MANUFACFACTURING CO PRIVATE LIMITED",
"LATIF GANI AND SONS PRIVATE LIMITED",
"LATIGRES VITRIFIED PRIVATE LIMITED",
"LATIK AUTO COMPONTS PRIVATE LIMITED",
"LATIKA DEALCOMM PRIVATE LIMITED",
"LATIKA SEA FOOD PRIVATE LIMITED",
"LA-TIM LIFE STYLE AND RESORTS LIMITED",
"LATIN LABS PRIVATE LIMITED",
"LATIN MANHARLAL INSURANCE BROKING PRIVATE LIMITED",
"LATIN MANHARLAL SECURITIES PRIVATE LIMITED",
"LATIN RASAYANI PVT.LTD.",
"LATITUDE TECHNOLABS PRIVATE LIMITED",
"LATIVE LIFE SCIENCE PRIVATE LIMITED",
"LATIWALA ENTERPRISES PRIVATE LIMITED",
"LATIYAL HANDICRAFTS PRIVATE LIMITED",
"LATLON TECHNOLOGIES PRIVATE LIMITED",
"LAT-LONG ENGINEERING PRIVATE LIMITED",
"LATTA INNOVATIONS PRIVATE LIMITED",
"LATTEYS INDUSTRIES LIMITED",
"LATTICE PROJEX PRIVATE LIMITED",
"LATTICE SEMICONDUCTOR (INDIA) PRIVATE LIMITED",
"LATTICE TECHNOLOGIES PRIVATE LIMITED",
"LATTICE ZINCARE PRIVATE LIMITED",
"LATTICEBRIDGE INFOTECH PRIVATE LIMITED",
"LATUR CITY MUNICIPAL CORPORATION LATUR",
"LATUR COLLEGE OF PHARMACY",
"LATUR DISTRICT CENTRAL CO-OP BANK LTD",
"LATUR FERTILITY CENTER PRIVATE LIMITED",
"LATUR HEALTHCARE PRIVATE LIMITED",
"LATUR INDUSTRIES INDIA PRIVATE LIMITED",
"LATUR MEDICHEM PRIVATE LIMITED",
"LATUR RENEWABLE PRIVATE LIMITED",
"LATUR SOLVENT EXTRACTIONS PRIVATE LIMITED",
"LATUR SUPERSPECIALITY HOSPITAL PRIVATE LIMITED",
"LATUR URBAN CO OP BANK LTD",
"LATYAN INFRASTRUCTURE PRIVATE LIMITED",
"LAUAK CIM AEROSPACE PRIVATE LIMITED",
"LAUDCO MEDIA PRIVATE LIMITED",
"LAUGHING COLOURS ENTERTAINMENT PRIVATE LIMITED",
"LAUGHING DOTS ENTERTAINMENT PRIVATE LIMITED",
"LAULAGUN BEARINGS INDIA PRIVATE LIMITED",
"LAULS PRIVATE LIMITED",
"LAUNCH IT CONSULTING INDIA PRIVATE LIMITED",
"LAUNCHERS WORLD SOFTWARE INDIA PRIVATE LIMITED",
"LAUNCHNODE TECHNOLOGIES PRIVATE LIMITED",
"LAUNCHNOTE INDIA PRIVATE LIMITED",
"LAUNCHPAD FINTECH PRIVATE LIMITED",
"LAUNCHSHIP IT & MEDIA SERVICES PRIVATE LIMITED",
"LAUNCHSHIP TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"LAUNCHTRAX PRIVATE LIMITED",
"LAUNDRETTES GROUP PRIVATE LIMITED",
"LAUNDREXX FABRIC CARE INDIA PRIVATE LIMITED",
"LAUNDRY LABS INDIA PRIVATE LIMITED",
"LAUNDRYHEAP INDIA PRIVATE LIMITED",
"LAUREATE BUILDWELL PRIVATE LIMITED",
"LAUREL COMMUNICATION & SECURITY SOLUTIONS PRIVATE LIMITED",
"LAUREL HIGH SCHOOL",
"LAUREL HITECH SEALS PRIVATE LIMITED",
"LAUREL INFRASTRUCTURE PRIVATE LIMITED",
"LAUREL SECURITIES PVT. LTD.",
"LAUREL WIRES LIMITED",
"LAURELS SCHOOL AND MANAGEMENT INSTITUTIONS PRIVATE LIMITED",
"LAUREN INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"LAURENT AND BENON MANAGEMENT CONSULTANTS LIMITED",
"LAURES PHARMACEUTICALS PRIVATE LIMITED",
"LAURUS BIO PRIVATE LIMITED",
"LAURUS BUSINESS SOLUTIONS LLP",
"LAURUS EDUTECH PRIVATE LIMITED",
"LAURUS GREEN POWER PRIVATE LIMITED",
"LAURUS INDUSTRIES PRIVATE LIMITED",
"LAURUS INFOSYSTEMS INDIA PRIVATE LIMITED",
"LAURUS INFRA PROJECTS PRIVATE LIMITED",
"LAURUS LABS LIMITED",
"LAURUS SYNTHESIS PRIVATE LIMITED",
"LAURUS TECHNOCAST PRIVATE LIMITED",
"LAVA CAST PRIVATE LIMITED",
"LAVA FORGE PRIVATE LIMITED",
"LAVA INTERNATIONAL LIMITED",
"LAVANA LIFESTYLE SOLUTIONS PRIVATE LIMITED",
"LAVANSH SOLUTION PRIVATE LIMITED",
"LAVANYA BANQUETS PRIVATE LIMITED",
"LAVANYA CONSTRUCTION PRIVATE LIMITED",
"LAVANYA FASHIONS PRIVATE LIMITED",
"LAVANYA FINVEST PRIVATE LIMITED",
"LAVANYA FITNESS PRIVATE LIMITED",
"LAVANYA JEWELS LIMITED",
"LAVANYA MEDICARE SOLUTIONS PRIVATE LIMITED",
"LAVANYA OLYFINS PRIVATE LIMITED",
"LAVANYA PUREFOOD PRIVATE LIMITED",
"LAVAS FOUNDRIES PRIVATE LIMITED",
"LAVAYA INFRACON PRIVATE LIMITED",
"LAVEENA HOSIERY PVT LTD",
"LAVEENA PROPERTIES PRIVATE LIMITED",
"LAVELLE NETWORKS PRIVATE LIMITED",
"LAVEN LABORATORIES",
"LAVENDER BUILDCON PRIVATE LIMITED",
"LAVENDER LOTUS MULTISPECIALITY HOSPITAL PRIVATE LIMITED",
"LAVENIR CONSULTANCY PRIVATE LIMITED",
"LAVERO INFRA SERVICES PRIVATE LIMITED",
"LAVESH FINANCE . LTD",
"LAVI PRODUCTS & SALES PRIVATE LIMITED",
"LAVIK ESTATES LIMITED",
"LAVIK LOGISTICS PRIVATE LIMITED",
"LAVIM DEVELOPERS PRIVATE LIMITED",
"LAVIN AGRO PRODUCTS PRIVATE LIMITED",
"LAVINA CREATIONS PRIVATE LIMITED",
"LAVINA PHARMACEUTICALS PRIVATE LIMITED",
"LAVINCITA LIFE SCIENCES PRIVATE LIMITED",
"LAVINIA LIFE SCIENCES PRIVATE LIMITED",
"LAVINSTAR LOGISTICS PRIVATE LIMITED",
"LAVIOSA INDIA PRIVATE LIMITED",
"LAVIS SIGNATURE PANEL PRIVATE LIMITED",
"LAVISH BUILDCON PRIVATE LIMITED",
"LAVISH BUILDMART PRIVATE LIMITED",
"LAVISH EXIM",
"LAVISH GRANITO PRIVATE LIMITED",
"LAVISH INTERLININGS PRIVATE LIMITED",
"LAVISH MANPOWER SERVICES PRIVATE LIMITED",
"LAVISH MOTORS PRIVATE LIMITED",
"LAVISH POLYFAB PRIVATE LIMITED",
"LAVISH THE FOODIE LOUNGE PRIVATE LIMITED",
"LAVISHLINE FURNITURES PRIVATE LIMITED",
"LAVISTA IDEAL PHARMACY PRIVATE LIMITED",
"LAVITANO INDIA PRIVATE LIMITED",
"LAVITRA VANIJYA PRIVATE LIMITED",
"LAVITSEE CONSTRUCTIONS PRIVATE LIMITED",
"LAVLIN SALT TRADERS",
"LAVNOR INDIA PRIVATE LIMITED",
"LAVTI ASSOCIATES PRIVATE LIMITED",
"LAVU EDUCATIONAL SOCIETY",
"LAVUE PHARMACEUTICALS PRIVATE LIMITED",
"LAVUPOS TECHNOLOGIES INDIA PRIVATE LIMITED",
"LAVYUK CONSULTANCY SERVICES PRIVATE LIMITED",
"LAW & KENNETH SAATCHI & SAATCHI PRIVATE LIMITED",
"LAW AND LEGISLATIVE AFFAIS DEPARTMENT",
"LAW CRUX ADVISORS PRIVATE LIMITED",
"LAW DEPARTMENT HIGH COURT OF CHHATTISGARH",
"LAW PROTECTORS IPR CONSULTANT LLP",
"LAWA BRIGHT BARS PRIVATE LIMITED",
"LAWA FASTENERS PRIVATE LIMITED",
"LAWAND MARKETING & CONSULTANCY PRIVATE LIMITED",
"LAWANDE REAL ESTATES PRIVATE LIMITED",
"LAWAT JEWELLERS PRIVATE LIMITED",
"LAWATHERM FURNACE PRIVATE LIMITED",
"LAWERENCE DYES AND PETROCHEMICALS PRIVATE LIMITED",
"LAWKESH TIWARI ARCHITECTS PVT LTD",
"LAWRBIT LEXTECH INDIA PRIVATE LIMITED",
"LAWRENCE AGRO STORAGE PRIVATE LIMITED",
"LAWRENCE AND MAYO (INDIA) PRIVATE LIMITED",
"LAWRENCE CLOTHING PRIVATE LIMITED",
"LAWRENCE HIGH SCHOOL",
"LAWRENCE MERCHANTS PVT LTD",
"LAWRENCE PUBLIC SCHOOL",
"LAWRENCE SAW MILL & COMPANY",
"LAWRENCEDALE AGRO PROCESSING INDIA PRIVATE LIMITED",
"LAWRESHWAR FOOTCARE PRIVATE LIMITED",
"LAWSON LUCY INDIA PRIVATE LIMITED",
"LAWSON TRAVELS AND TOURS INDIA PRIVATE LIMITED",
"LAW-SPADES SERVICES PRIVATE LIMITED",
"LAWZ MEDIA PRIVATE LIMITED",
"LAX BLUE METALS PRIVATE LIMITED",
"LAXACHEM ORGANICS PRIVATE LIMITED",
"LAXAM COMMTRADE PRIVATE LIMITED",
"LAXCON STEELS LIMITED",
"LAXIFS LIFESCIENCES PRIVATE LIMITED",
"LAXJEET RENEWABLE ENERGY PRIVATE LIMITED",
"LAXMAN ENERGY PRODUCTS LIMITED",
"LAXMAN INDUSTRIES LIMITED",
"LAXMAN KADVA & SONS PRIVATE LIMITED",
"LAXMAN PROCON PRIVATE LIMITED",
"LAXMAN ROLLER FLOUR MILLS PVT LTD",
"LAXMAN TIMBERS PRIVATE LIMITED",
"LAXMANBHAI CONSTRUCTIONS INDIA PRIVATE. LIMITED.",
"LAXME SAAI STEEL PRIVATE LIMITED",
"LAXMEE CHEMFAB PRIVATE LIMITED",
"LAXMI AGNI COMPONENTS AND FORGINGS PRIVATE LIMITED",
"LAXMI AGRO INDIA PRIVATE LIMITED",
"LAXMI AGRO INDUSTRIAL CONSULTANTS & EXPORTERS LIMITED",
"LAXMI AGRO INDUSTRIES PRIVATE LIMITED",
"LAXMI AGRO TRADELINKS PRIVATE LIMITED",
"LAXMI AIR CONTROL LIMITED",
"LAXMI AUTO ENGINEERS PRIVATE LIMITED",
"LAXMI AUTO INDUSTRIES PVT LTD",
"LAXMI AUTOMOBILES",
"LAXMI AVIATION SERVICES PRIVATE LIMITED",
"LAXMI BALAJI AUTOMOTIVE PRODUCTS PRIVATE LIMITED",
"LAXMI BALAJI INDUSTRIES",
"LAXMI BARTAN INDUSTRIES PRIVATE LIMITED",
"LAXMI BARTER PRIVATE LIMITED",
"LAXMI BEADS MFG CO PRIVATE LIMITED",
"LAXMI BEARINGS (GUJARAT) PRIVATE LIMITED",
"LAXMI BEAUTY PRODUCT PRIVATE LIMITED",
"LAXMI BHOG PRIVATE LIMITED",
"LAXMI BLOCKS BUILDING PRIVATE LIMITED",
"LAXMI BOARD AND PAPER MILLS PRIVATE LIMITED",
"LAXMI BRIGHT STEEL BARS PRIVATE LIMITED",
"LAXMI CABS PRIVATE LIMITED",
"LAXMI CAKEZONE PRIVATE LIMITED",
"LAXMI CAR CARRIERS PRIVATE LIMITED",
"LAXMI CARGO MOVERS PRIVATE LIMITED",
"LAXMI CHEMICALS PRIVATE LIMITED",
"LAXMI CIVIL ENGINEERING INFRASTRUCTURE PRIVATE LIMITED",
"LAXMI CIVIL ENGINNERING SERVICES PRIVATE LIMITED",
"LAXMI CLOTHING PRIVATE LIMITED",
"LAXMI COMPLEX PRIVATE LIMITED",
"LAXMI CONSTRUCTION COMPANY",
"LAXMI COTSPIN LIMITED",
"LAXMI COTTON INDUSTRIES",
"LAXMI DATTA MANDAP INDUSTRIES PRIVATE LIMITED",
"LAXMI DENTAL EXPORT PRIVATE LIMITED",
"LAXMI DIA GOLD PRIVATE LIMITED",
"LAXMI DIA JEWEL PRIVATE LIMITED",
"LAXMI DIAMOND PRIVATE LIMITED",
"LAXMI DIGITAL PRINTS AND SOLUTIONS PRIVATE LIMITED",
"LAXMI DRUCKEN KOMPONENTS PRIVATE LIMITED",
"LAXMI DWELLERS PRIVATE LIMITED",
"LAXMI ELECTROMECH PRIVATE LIMITED",
"LAXMI EN-FAB PRIVATE LIMITED",
"LAXMI ENGINEERING PVT LTD",
"LAXMI ENGITECH PRIVATE LIMITED",
"LAXMI ESSENTIAL OIL OLEORESINS AND FRAGRANCE PRIVATE LIMITED",
"LAXMI EYE INSTITUTE",
"LAXMI FASTNERS LIMITED",
"LAXMI FILM LABORATORIES AND STUDIOS PRIVATE LIMITED",
"LAXMI FIRE & MACHINERY PRIVATE LIMITED",
"LAXMI FOILS PRIVATE LIMITED",
"LAXMI FOODS AND STORAGES PRIVATE LIMITED",
"LAXMI FREIGHT CARRIERS PRIVATE LIMITED",
"LAXMI GENCHEM SCIENCES PRIVATE LIMITED",
"LAXMI GOLDORNA HOUSE LIMITED",
"LAXMI GOLDPALACE PRIVATE LIMITED",
"LAXMI GOUR STONEX PRIVATE LIMITED",
"LAXMI HARI PRINTS PRIVATE LIMITED",
"LAXMI HIGHCON PRIVATE LIMITED",
"LAXMI HOME DEVELOPERS PRIVATE LIMITED",
"LAXMI HYDRAULICS PRIVATE LIMITED",
"LAXMI ICE-CREAM PRIVATE LIMITED.",
"LAXMI INDIA FINANCE LIMITED",
"LAXMI INDUSTRIES",
"LAXMI INFOBAHN PRIVATE LIMITED",
"LAXMI INFRA & FACILITIES MANAGEMENT CO. PRIVATE LIMITED",
"LAXMI INFRA DEVELOPERS LIMITED",
"LAXMI INFRA VISION PRIVATE LIMITED",
"LAXMI INFRASOLUTIONS PRIVATE LIMITED",
"LAXMI INFRAZONE PRIVATE LIMITED",
"LAXMI IRON & STEEL INDUSTRIES (NAGPUR) PRIVATE LIMITED",
"LAXMI JEWEL CRAFTS PRIVATE LIMITED",
"LAXMI JEWELLERY",
"LAXMI JEWELLERY EXPORT PRIVATE LIMITED",
"LAXMI KRIPA ISPAT PRIVATE LIMITED",
"LAXMI KRUPA ABRASIVESS PRIVATE LIMITED",
"LAXMI LIFTERS PRIVATE LIMITED",
"LAXMI LUBE PRIVATE LIMITED",
"LAXMI LUMBER INDUSTRIES PRIVATE LIMITED",
"LAXMI LUMBERS INDIA PRIVATE LIMITED",
"LAXMI MATA MILK AND MILK PRODUCTS PRIVATE LIMITED",
"LAXMI MECHANICAL WORKSHOP PRIVATE LIMITED",
"LAXMI MEMORIAL EDUCATION TRUST",
"LAXMI METAL & MACHINES PRIVATE LIMITED",
"LAXMI METAL PRESSING WORKS PRIVATE LIMITED",
"LAXMI METAL PRODUCTS PRIVATE LIMITED",
"LAXMI MICRONIZER PRIVATE LIMITED",
"LAXMI MOTORS",
"LAXMI MOULDS INDUSTRIES PRIVATE LIMITED",
"LAXMI MUKUND ENTERPRISES PRIVATE LIMITED",
"LAXMI NARAIN METALLIC PRIVATE LIMITED",
"LAXMI NARAIN OM PRAKASH JEWELS LIMITED",
"LAXMI NARAYAN AIR TRAVELS PRIVATE LIMITED",
"LAXMI NARAYAN BASTRALAYA PRIVATE LIMITED",
"LAXMI NARAYAN CHEMITECH PRIVATE LIMITED",
"LAXMI NARAYAN GUMS PRIVATE LIMITED",
"LAXMI NARAYAN HOSPITAL",
"LAXMI NARAYAN INFRAMIN PRIVATE LIMITED",
"LAXMI NARAYAN INSTITUTE OF NURSING VADODARA",
"LAXMI NARAYAN INSTITUTE OF TECHNOLOGY",
"LAXMI NARAYAN MEGA MART PRIVATE LIMITED",
"LAXMI NARAYAN RICE MILLS PVT LTD",
"LAXMI NIWAS MITTAL INSTITUTE OF INFORMATION TECHNOLOGY",
"LAXMI OIL COMPANY PVT. LTD.",
"LAXMI ORGANIC INDUSTRIES LIMITED",
"LAXMI PARIVAHAN PRIVATE LIMITED",
"LAXMI PHARMA PACK",
"LAXMI PHARMACEUTICALS PRIVATE LIMITED",
"LAXMI PLASTOPACK INDIA PRIVATE LIMITED",
"LAXMI POLYCHEM INDIA LIMITED",
"LAXMI POLYTEX PRIVATE LIMITED",
"LAXMI PRAKASHAN BOOKS PRIVATE LIMITED",
"LAXMI PROTEIN PRODUCTS PRIVATE LIMITED",
"LAXMI PUBLICATIONS PRIVATE LIMITED",
"LAXMI PUMPS PRIVATE LIMITED",
"LAXMI PYRAMID SECURITY FORCE PRIVATE LIMITED",
"LAXMI REDDY MIX PRIVATE LIMITED",
"LAXMI REMOTE (INDIA) PRIVATE LIMITED",
"LAXMI RIKSHAW BODY PRIVATE LIMITED",
"LAXMI ROLLING AND STRIPS PRIVATE LIMITED",
"LAXMI RUBBER PRODUCTS PRIVATE LIMITED",
"LAXMI SAFE DEPOSIT VAULT PRIVATE LIMITED",
"LAXMI SAGAR ENGINEERS PRIVATE LIMITED",
"LAXMI SAI BREEDING FARMS PRIVATE LIMITED",
"LAXMI SALES AND ALLOYS PRIVATE LIMITED",
"LAXMI SALES AND SERVICE PRIVATE LIMITED",
"LAXMI SALES INDIA PRIVATE LIMITED",
"LAXMI SAREES PRIVATE LIMITED",
"LAXMI SEAMLESS TUBES PRIVATE LIMITED",
"LAXMI SECURITY GUJARAT PRIVATE LIMITED",
"LAXMI SHUTTLELESS LOOMS PRIVATE LIMITED",
"LAXMI SMELTING AND REFINING CO PVT LTD",
"LAXMI SNACKS PRIVATE LIMITED",
"LAXMI SOLAR POWER SYSTEMS PRIVATE LIMITED",
"LAXMI STAINALLOYS PRIVATE LIMITED",
"LAXMI SUPER MEGAMART PRIVATE LIMITED",
"LAXMI SYNERGY INFRA & FM SERVICES PRIVATE LIMITED",
"LAXMI SYNTEX PRIVATE LIMITED",
"LAXMI TEA PROCESSORS CO PVT LTD",
"LAXMI TECHNICAL TEXTILE PRIVATE LIMITED",
"LAXMI TECHNO SERVICES",
"LAXMI TOOLS",
"LAXMI TRANSMISSION",
"LAXMI TRANSMISSIONS PRIVATE LIMITED",
"LAXMI UDYOG OIL FIELD EQUIPMENTS PRIVATE LIMITED",
"LAXMI VALLABHA COLD STORAGE PRIVATE LIMITED",
"LAXMI VENTURES (INDIA) LIMITED",
"LAXMI VIDYAPEETH",
"LAXMI VISHAL FABRICS PRIVATE LIMITED",
"LAXMI VISHNU SILK MILLS",
"LAXMI VISION SERVICES LLP",
"LAXMI WEAVING PRIVATE LIMITED",
"LAXMIBAI BHAURAO PATIL MADHYAMIK VIDYALAYA AHMEDNAGAR",
"LAXMICHAND CHHEDA CONSULTANCY PRIVATE LIMITED",
"LAXMICHAND DAYABHAI (EXPORT) COMPANY PRIVATE LIMITED",
"LAXMICHAND GOLWALA COLLEGE OF COMMERCE",
"LAXMICORP FARMER PRODUCER COMPANY LIMITED",
"LAXMIDATTA MANDAP PRIVATE LIMITED",
"LAXMIDEEP INDUSTRIES PRIVATE LIMITED",
"LAXMIGANPATI MOTORS PRIVATE LIMITED",
"LAXMIHARI TEXTILE PRIVATE LIMITED",
"LAXMII FOREX LIMITED",
"LAXMIJANARDAN AGRO PRODUCTS PRIVATE LIMITED",
"LAXMIJYOT TECHNO PRIVATE LIMITED",
"LAXMIJYOTHI ECO-TOURISM AND JUNGLE RESORTS PRIVATE LIMITED",
"LAXMIKRIPA BUILDCON PRIVATE LIMITED",
"LAXMIKRIPA STEELS AND POWER PRIVATE LIMITED",
"LAXMIMANAK FINANCE PRIVATE LIMITED",
"LAXMINAND LOGISTICS PRIVATE LIMITED",
"LAXMINARAIAN SUNDERLAL MERCANTILE PRIVATE LIMITED",
"LAXMINARAIN INFRABUILD PRIVATE LIMITED",
"LAXMINARAYAN AGENCY",
"LAXMINARAYAN AGRO FOODS PRIVATE LIMITED",
"LAXMINARAYAN COLLEGE OF TECH & SCIENCES",
"LAXMINARAYAN FABTEX (I) PRIVATE LIMITED",
"LAXMINARAYAN FIBER PRIVATE LIMITED",
"LAXMINARAYAN INSTITUTE OF TECHNOLOGY",
"LAXMINARAYAN PADDY PROCESSING PRIVATE LIMITED",
"LAXMINARAYAN SPINNERS (I) PRIVATE LIMITED",
"LAXMINARAYAN TRADEX PRIVATE LIMITED",
"LAXMINARAYAN VYAPAAR PRIVATE LIMITED",
"LAXMINATH INFRASTRUCTURE PRIVATE LIMITED",
"LAXMINATH INVESTMENT AND MANAGEMENT CONSULTANTS PVT LTD",
"LAXMINATHJEE SILK MILLS PRIVATE LIMITED",
"LAXMIPATI MOTORS PRIVATE LIMITED",
"LAXMIPRAKASH GARMENTS PRIVATE LIMITED",
"LAXMIPUTRA INFRATECH PRIVATE LIMITED",
"LAXMIRA MEDICARE PRIVATE LIMITED",
"LAXMIRAJ DISTRIBUTORS PRIVATE LIMITED",
"LAXMIRAMUNA INVESTMENTS PRIVATE LIMITED",
"LAXMIROOP PRIVATE LIMITED",
"LAXMISOPAN AGRICULTURE PRODUCE MARKETING COMPANY LIMITED",
"LAXMISREE RICEMILL PRIVATE LIMITED",
"LAXMIVINAYAK VENTURES PRIVATE LIMITED",
"LAXO MEDICARE PRIVATE LIMITED",
"LAXON DRUGS PRIVATE LIMITED",
"LAXSHMI SERVICES AND CONSULTANCY PRIVATE LIMITED",
"LAXSONS (INDIA) PRIVATE LIMITED",
"LAXTER PHARMACEUTICALS PRIVATE LIMITED",
"LAXXMI KRISHI VIKAS PRODUCER COMPANY LIMITED",
"LAXYA PRODUCTIONS PRIVATE LIMITED",
"LAXYO ENERGY LIMITED",
"LAXYO SOLUTION SOFT PRIVATE LIMITED",
"LAYA HEALTHCARE PRIVATE LIMITED",
"LAYA MILK PRODUCTS PRIVATE LIMITED",
"LAYA TECH PRIVATE LIMITED",
"LAYAM FLEXI SOLUTIONS PRIVATE LIMITED",
"LAYAM MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"LAYAM TALENT ACADEMY FOUNDATION",
"LAYANA FINANCE AND LEASING LIMITED",
"LAYANA TOURS PRIVATE LIMITED",
"LAYAP HGNIS APPARELS PRIVATE LIMITED",
"LAYAWAY DEPOT INDIA PRIVATE LIMITED",
"LAYBOND CONSTRUCTIONS PRIVATE LIMITED LAYB",
"LAYER INFORMATICS PRIVATE LIMITED",
"LAYER5 INDIA CONSULTING PRIVATE LIMITED",
"LAYERBITE FOODS PRIVATE LIMITED",
"LAYHER SCAFFOLDING SYSTEMS PRIVATE LIMITED",
"LAYING INFRASTRUCTURE PRIVATE LIMITED",
"LAYLOCK ENGINEERS PRIVATE LIMITED",
"LAYMAN MARKETING AND RESEARCH PRIVATE LIMITED",
"LAYMEN AGRO VENTURES PRIVATE LIMITED",
"LAYON INTERNATIONAL PRIVATE LIMITED",
"LAYOTS TECHNOLOGIES PRIVATE LIMITED",
"LAZAKAT FOODS PRIVATE LIMITED",
"LAZARO ADVERTISING PRIVATE LIMITED",
"LAZARUS BUSINESS PARK PRIVATE LIMITED",
"LAZER FOOTWEAR PRIVATE LIMITED",
"LAZER INDIA PRIVATE LIMITED",
"LAZER INSTRUMENTATION PRIVATE LIMITED",
"LAZER KEN IT SERVICES INDIA PRIVATE LIMITED",
"LAZIZ CATERERS PRIVATE LIMITED",
"LAZOR DETERGENTS PRIVATE LIMITED",
"LAZULINE BIOTECH PRIVATE LIMITED",
"LAZYCOCKTAILS BEVERAGES PRIVATE LIMITED",
"LAZYPAY PRIVATE LIMITED",
"LAZZARO HR SOLUTIONS PRIVATE LIMITED",
"LAZZLE SINK PRIVATE LIMITED",
"LB COTTON INDUSTRIES LLP",
"LB MEDI-SERVICES PRIVATE LIMITED",
"LB SPECIALITIES PRIVATE LIMITED",
"LBD FASHION PRIVATE LIMITED",
"LBF PUBLICATIONS PRIVATE LIMITED",
"LBH AVIATION PRIVATE LIMITED",
"LBH LOGISTICS PRIVATE LIMITED",
"LBI EXPORT PRIVATE LIMITED",
"LBM INFOTECH PRIVATE LIMITED",
"LBM MINERALS PRIVATE LIMITED",
"LBMS PRIVATE LIMITED",
"LBN TECH SOLUTIONS PRIVATE LIMITED",
"LBR FOUNDATION INDIA",
"LBR LEISURE AND HOSPITALITY SERVICES PRIVATE LIMITED",
"LBS CONSULTANTS PRIVATE LIMITED",
"LBS JEWELLERS PRIVATE LIMITED",
"LBS MANPOWER SERVICES PRIVATE LIMITED",
"LBS TOOLS PRIVATE LIMITED",
"LBT ELECTRONICS PRIVATE LIMITED",
"LBT PLASTICS & HARDWARE PRIVATE LIMITED",
"LBTEX PRIVATE LIMITED",
"LBZ SONS PRIVATE LIMITED",
"LC AUTOMATION PRIVATE LIMITED",
"LC CAPITAL INDIA PRIVATE LIMITED",
"LC INFRA PROJECTS PRIVATE LIMITED",
"LCATTERTON MUMBAI ADVISORY SERVICES PRIVATE LIMITED",
"LCC MILL PRIVATE LIMITED",
"LCC PROJECTS PRIVATE LIMITED",
"LCC READYMIX CONCRETE PRIVATE LIMITED",
"LCD PLASTO FILM PRIVATE LIMITED",
"LCDF IMPEX PRIVATE LIMITED",
"LCG ALUMINIUM INDUSTRIES PRIVATE LIMITED",
"LCG EXIMCHEM PRIVATE LIMITED",
"LCG INDUSTRIES LIMITED",
"LCG INDUSTRIES PRIVATE LIMITED",
"LCGC BIOANALYTIC SOLUTIONS LLP",
"LCGC CHROM CONSUMABLES LLP",
"LCGC LIFESCIENCES LLP",
"LCGC TRUCAL AND SERVICES LLP",
"LCIT GROUP OF INSTITUTION",
"LCIT SCHOOL OF PHARMACY",
"LCL LOGISTIX INDIA PRIVATE LIMITED",
"LCM LOGISTICS PRIVATE LIMITED",
"LCM PROJECTS PRIVATE LIMITED",
"LCN PRIVATE LIMITED",
"LCODE TECHNOLOGIES PRIVATE LIMITED",
"LCP BUILDING PRODUCTS PRIVATE LIMITED",
"LCS CONTROLS PRIVATE LIMITED",
"LCS SERVICES INDIA PRIVATE LIMITED",
"LCTM OVERSEAS PRIVATE LIMITED",
"LD IMPEX PRIVATE LIMITED",
"LD MANUFACTURING PRIVATE LIMITED",
"LDD BIOSCIENCE PRIVATE LIMITED",
"LDGARG FOREX PRIVATE LIMITED",
"LDK LAMI PRINT PRIVATE LIMITED",
"LDM AGRO FOODS PRIVATE LIMITED",
"LDM AGROTECH PRIVATE LIMITED",
"LDR ERETAIL LIMITED",
"LDR MODULAR FURNITURE PRIVATE LIMITED",
"LDRA TECHNOLOGY PRIVATE LIMITED",
"LDRP INSTITUTE OF TECHNOLOGY AND RESEARCH",
"LDS ENGINEERS PRIVATE LIMITED",
"LDS GUARDING SOLUTIONS PRIVATE LIMITED",
"LDS INFOTECH PRIVATE LIMITED",
"LDS LOGISTICS AND AGENCIES PRIVATE LIMITED",
"LDS RUBBER TECH (CHENNAI) PRIVATE LIMITED",
"LDSM TRADERS PRIVATE LIMITED",
"LDSQUARE TECHNOLOGIES INDIA PRIVATE LIMITED",
"LE - VANZA PHARMA PRIVATE LIMITED",
"LE BAIN JEANS PRIVATE LIMITED",
"LE BEAUTY CARE PRIVATE LIMITED",
"LE CARRIERS PRIVATE LIMITED",
"LE CHAMP (SOUTH EAST ASIA) PTE LTD",
"LE CREUSET INDIA TRADING PRIVATE LIMITED",
"LE DIMORA INDIA PRIVATE LIMITED",
"LE ELECTRONICS PRIVATE LIMITED",
"LE FABCO PRIVATE LIMITED",
"LE FRAIS FOODS (INDIA) PRIVATE LIMITED",
"LE FRIC DERMA PRIVATE LIMITED",
"LE GALA EVENTS PRIVATE LIMITED",
"LE GATEAU FOODS INDIA PRIVATE LIMITED",
"LE GRAND ENGINEERING PRIVATE LIMITED",
"LE GRANDE RESIDENCY PRIVATE LIMITED",
"LE GRIFFE OFFSET PRIVATE LIMITED",
"LE HUMAN RESOURCES SERVICES PRIVATE LIMITED",
"LE LAVOIR LIMITED",
"LE LEXUZ PROPERTIES PRIVATE LIMITED",
"LE MAK EXPORTS PRIVATE LIMITED",
"LE MANTUS PHARMACEUTICALS PRIVATE LIMITED",
"LE MARBLE GALLERY PRIVATE LIMITED",
"LE MEI PLASTIC MANUFACTURING PRIVATE LIMITED",
"LE MEILLEUR GLOBAL TRADE PRIVATE LIMITED",
"LE MERIDIEN NAGPUR",
"LE MERITE EXPORTS LIMITED",
"LE MERITE FASHIONS PRIVATE LIMITED",
"LE MILL PRIVATE LIMITED",
"LE MOUNT GARMENTS PRIVATE LIMITED",
"LE PARAGUAS CONSULTANTS PRIVATE LIMITED",
"LE PASSAGE TO INDIA TOURS AND TRAVELS PRIVATE LIMITED",
"LE PENSIONS STAYS AND ENTERPRISES PRIVATE LIMITED",
"LE ROYAL CONSTRUCTIONS PRIVATE LIMITED",
"LE SUTRA HOSPITALITY PRIVATE LIMITED",
"LE TRAVELWORLD PRIVATE LIMITED",
"LE TRAVENUES TECHNOLOGY LIMITED",
"LE TRENDS PRIVATE LIMITED",
"LE VISION TELECOM PRIVATE LIMITED",
"LEA ASSOCIATES SOUTH ASIA PRIVATE LIMITED",
"LEAAP INTERNATIONAL PRIVATE LIMITED",
"LEAD ACID BATTERY COMPANY PVT. LTD.",
"LEAD ADS PRIVATE LIMITED",
"LEAD CONSTRUCTION AND EQUIPMENTS PRIVATE LIMITED",
"LEAD CONSULTANCY AND ENGINEERING SERVICES INDIA PRIVATE LIMITED",
"LEAD CROP SCIENCE PRIVATE LIMITED",
"LEAD EDGE PAPERS PRIVATE LIMITED",
"LEAD HR SERVICES PRIVATE LIMITED",
"LEAD INFRASTRUCTURE AND HOSPITALITY PRIVATE LIMITED",
"LEAD INSTRUEMENTS PRIVATE LIMITED",
"LEAD MEDICAL SYSTEMS PRIVATE LIMITED",
"LEAD RECLAIM AND RUBBER PRODUCTS LIMITED",
"LEAD SCHOOL",
"LEAD STREET PRIVATE LIMITED",
"LEADAIR SYSTEMS PRIVATE LIMITED",
"LEADBXD TECHNOLOGIES PRIVATE LIMITED",
"LEADCAP KNOWLEDGE SOLUTIONS PRIVATE LIMITED",
"LEADCO STAFFING SOLUTIONS PRIVATE LIMITED",
"LEADE LIQUOR MANUFACTURING PRIVATE LIMITED",
"LEADEC INDIA PRIVATE LIMITED",
"LEADEDGE INFRATECH PRIVATE LIMITED",
"LEADEDGE TRAINING AND CONSULTING PRIVATE LIMITED",
"LEADER BIOMEDICAL AND SURGICALS INDIA PRIVATE LIMITED",
"LEADER DOCUMENT PROCESSING PRIVATE LIMITED",
"LEADER HIGH PRESSURE FITTINGS INDIA PRIVATE LIMITED",
"LEADER IT PRIVATE LIMITED",
"LEADER MEDICAL SYSTEMS PRIVATE LIMITED",
"LEADER STAR SECURITY LIMITED",
"LEADER VALVES LIMITED",
"LEADERCROP PRIVATE LIMITED",
"LEADERMA INDIA PRIVATE LIMITED",
"LEADERMIND PRIVATE LIMITED",
"LEADERS GATE HOUSING PRIVATE LIMITED",
"LEADERS HEALTHCARE LIMITED",
"LEADERS LEARNING HOUSE PRIVATE LIMITED",
"LEADERSEDGE CONSULTING PRIVATE LIMITED",
"LEADERSHIP CONSULTING PRIVATE LIMITED",
"LEADERSHIP R US INDIA PRIVATE LIMITED",
"LEADERSHIP TRIBE PRIVATE LIMITED",
"LEADGE BUSINESS SERVICES PRIVATE LIMITED",
"LEADIC DESIGN PRIVATE LIMITED",
"LEADICS CONSULTING INDIA PRIVATE LIMITED",
"LEADING EDGE - TRAVEL MANAGEMENT PRIVATE LIMITED",
"LEADING EDGE ADVERTISING INDIA PRIVATE LIMITED",
"LEADING EDGE COMMUNICATION PRIVATE LIMITED",
"LEADING EDGE DISTRIBUTORS PRIVATE LIMITED",
"LEADING EDGE INFO SOLUTIONS PRIVATE LIMITED",
"LEADING EDGE SYSTEMS PRIVATE LIMITED",
"LEADING ESTATES LIMITED",
"LEADING FRONTIER PRIVATE LIMITED",
"LEADING HEALTH CARE LOGISTICS PRIVATE LIMITED",
"LEADING HEALTH TECHNOLOGIES PRIVATE LIMITED",
"LEADING LEASING FINANCE AND INVESTMENT COMPANY LIMITED",
"LEADING METALS PRIVATE LIMITED",
"LEADING NETWORK SYSTEMS PRIVATE LIMITED",
"LEADING TORCH (INDIA) PRIVATE LIMITED",
"LEADINGTRONIC HUB (OPC) PRIVATE LIMITED",
"LEADIT INDIA PRIVATE LIMITED",
"LEADKING AIR SERVICES PRIVATE LIMITED",
"LEADKING CONSOLIDATORS PRIVATE LIMITED",
"LEADLINE SYSTEMS PRIVATE LIMITED",
"LEADMARK WHOLESALE PRIVATE LIMITED",
"LEADMAX TECHNOLOGIES PRIVATE LIMITED",
"LEADNPLA INDIA PRIVATE LIMITED",
"LEADPRO CONSULTANCY PRIVATE LIMITED",
"LEADS CLINICAL RESEARCH AND BIO SERVICES PRIVATE LIMITED",
"LEADS INSURANCE BROKERS PRIVATE LIMITED",
"LEADS INTERACTIVE SOLUTIONS PRIVATE LIMITED",
"LEADS OVERSEAS PRIVATE LIMITED",
"LEADS PHARMA PRIVATE LIMITED",
"LEADSCONNECT SERVICES PRIVATE LIMITED",
"LEADSOC TECHNOLOGIES PRIVATE LIMITED",
"LEADSTART PUBLISHING PRIVATE LIMITED",
"LEADSTONE ENERGY LTD.",
"LEADTECH SOLUTIONS PRIVATE LIMITED",
"LEADWELL INSURANCE BROKERS PRIVATE LIMITED",
"LEADWINNER CORP PRIVATE LIMITED",
"LEAF AND NUTS PRIVATE LIMITED",
"LEAF DESIGN PRIVATE LIMITED",
"LEAF IMPEX PRIVATE LIMITED",
"LEAF STUDIOS PRIVATE LIMITED",
"LEAFBERRY ADS PRIVATE LIMITED",
"LEAFINITI BIOENERGY PRIVATE LIMITED",
"LEAFLET TECHNOLOGIES PRIVATE LIMITED",
"LEAFYO FARM VENTURES PRIVATE LIMITED",
"LEAGUE FOODS PRIVATE LIMITED",
"LEAGUE SPACES LLP",
"LEAKLESS GASKET INDIA PRIVATE LIMITED",
"LEAK-PROOF CAST (INDIA) PRIVATE LIMITED",
"LEAK-PROOF ENGINEERING INDIA PRIVATE LIMITED",
"LEAK-PROOF PUMPS (INDIA) PRIVATE LIMITED",
"LEAMAK HEALTHCARE LIMITED",
"LEAN AUTOMATION EQUIPMENTS PRIVATE LIMITED",
"LEAN FOODS PRIVATE LIMITED",
"LEAN PEOPLE CONSULTING SERVICES PRIVATE LIMITED",
"LEAN PORT SOFTWARE PRIVATE LIMITED",
"LEAN TRANSITION SOLUTIONS PRIVATE LIMITED",
"LEANAPPS SOFTWARE PRIVATE LIMITED",
"LEANBOX LOGISTICS SOLUTIONS PRIVATE LIMITED",
"LEANFAB LASER ENGINEERING PRIVATE LIMITED",
"LEANPITCH TECHNOLOGIES PRIVATE LIMITED",
"LEANSOFT SOLUTIONS PRIVATE LIMITED",
"LEANSWIFT SOLUTIONS INDIA PRIVATE LIMITED",
"LEANWAY ENERGY PRIVATE LIMITED",
"LEANWORX TECHNOLOGIES PRIVATE LIMITED",
"LEAP AGRI LOGISTICS (GUWAHATI) PRIVATE LIMITED",
"LEAP DIGIPRINT PRIVATE LIMITED",
"LEAP ECOTEC SOLUTIONS PRIVATE LIMITED",
"LEAP EDTECH LEARNING PRIVATE LIMITED",
"LEAP GREEN ENERGY PRIVATE LIMITED",
"LEAP INDIA FOOD & LOGISTICS PRIVATE LIMITED",
"LEAP INDIA PRIVATE LIMITED",
"LEAP INFO SYSTEMS PRIVATE LIMITED",
"LEAP INFRAASYS PRIVATE LIMITED",
"LEAPEDGE NETWORKS PRIVATE LIMITED",
"LEAPEX LOGISTICS PRIVATE LIMITED",
"LEAPFOUR MEDIA PRIVATE LIMITED",
"LEAPFROG ENGINEERING SERVICES PRIVATE LIMITED",
"LEAPFROGLABS SOFTWARE PRIVATE LIMITED",
"LEAPINDIA BRANDHUB SERVICES PRIVATE LIMITED",
"LEAPING FROG CONSULTING PRIVATE LIMITED",
"LEAPING FROG SOLUTIONS PRIVATE LIMITED",
"LEAPMILE LOGISTICS PRIVATE LIMITED",
"LEAPS & BOUNDS PRIVATE LIMITED",
"LEAPS N LAPS LOGISTICS PRIVATE LIMITED",
"LEAPSWITCH NETWORKS PRIVATE LIMITED",
"LEAPTHOUGHT TECHNOLOGY SERVICES PRIVATE LIMITED",
"LEAPUS TECHNOLOGIES PRIVATE LIMITED",
"LEAPWORK INDIA PRIVATE LIMITED",
"LEAR AUTOMOTIVE INDIA PRIVATE LIMITED",
"LEAR CORPORATION",
"LEAR INDIA ENGINEERING LLP",
"LEAR INSULATION ENGINEERING PRIVATE LIMITED",
"LEAR LAUF DESIGN AND ENGINEERS PRIVATE LIMITED",
"LEARN N GROW PUBLICATIONS PRIVATE LIMITED",
"LEARN TRAIN & LEVER PRIVATE LIMITED",
"LEARNAPP TECHNOLOGIES PRIVATE LIMITED",
"LEARNBRIDGE TECHNOLOGIES PRIVATE LIMITED",
"LEARNENGG PRIVATE LIMITED",
"LEARNERS TECHNOLOGY LLP",
"LEARNEX ACADEMY PRIVATE LIMITED",
"LEARNFLUENCE EDUCATION PRIVATE LIMITED",
"LEARNFLY EDTECH PRIVATE LIMITED",
"LEARNGRAM TECHNOLOGY INDIA PRIVATE LIMITED",
"LEARNING CANDID INDIA PRIVATE LIMITED",
"LEARNING CLOSET PRIVATE LIMITED",
"LEARNING CREW PRIVATE LIMITED",
"LEARNING CURVE EDUTECH SOLUTIONS PRIVATE LIMITED",
"LEARNING INFORMATION SYSTEMS INDIA PRIVATE LIMITED",
"LEARNING INTEGRATION FOR EDUCATION PRIVATE LIMITED",
"LEARNING LEADERSHIP FOUNDATION",
"LEARNING LINKS FOUNDATION",
"LEARNING LINKS PUBLISHING HOUSE PRIVATE LIMITED",
"LEARNING MATE SOLUTIONS PRIVATE LIMITED",
"LEARNING MATTERS PRIVATE LIMITED",
"LEARNING OWL PRIVATE LIMITED",
"LEARNING PATHS SCHOOL",
"LEARNING ROUTES PRIVATE LIMITED",
"LEARNING SPIRAL PVT LTD",
"LEARNING STAR PRIVATE LIMITED",
"LEARNING STORE ACADEMY PRIVATE LIMITED",
"LEARNING TOOLS PRIVATE LIMITED",
"LEARNIPHI TECHNOLOGY PRIVATE LIMITED",
"LEARNKART TECHNOLOGY PRIVATE LIMITED",
"LEARNON TECHNOLOGY SOLUTIONS LLP",
"LEARNQUEST INDIA PRIVATE LIMITED",
"LEARNSHIP TECHNOLOGIES PRIVATE LIMITED",
"LEARNTURE VENTURES PRIVATE LIMITED",
"LEARN-VEL PRIVATE LIMITED",
"LEASE PLAN INDIA PRIVATE LIMITED",
"LEASEACCELERATOR INDIA PRIVATE LIMITED",
"LEASEFORCEE STAFFING INDIA PRIVATE LIMITED",
"LEASING IQ (INDIA) PRIVATE LIMITED",
"LEATHER & LACE COLLECTIONS LLP",
"LEATHER AUXILLIARIES MARKETING COMPANY PVT. LTD",
"LEATHER CEATRA (OPC) PRIVATE LIMITED",
"LEATHER CRAFTS INDIA PRIVATE LIMITED",
"LEATHER INDUSTRIES CORPORATION OF MARATHWADA LIMITED",
"LEATHER LINKERS FOOTWEAR PRIVATE LIMITED",
"LEATHER ONLINE PRIVATE LIMITED",
"LEATHER SECTOR SKILL COUNCIL",
"LEATHER SOURCES PRIVATE LIMITED",
"LEATHER TECH",
"LEATHERCRAFT LIFESTYLE PRIVATE LIMITED",
"LEATHERMAN FASHION PRIVATE LIMITED",
"LEATHERRELATION INDIA PRIVATE LIMITED",
"LEATHERSMITH HOUSE OF FASHION PRIVATE LIMITED",
"LEAVOCHEM LABS PRIVATE LIMITED",
"LEAYAN GLOBAL PRIVATE LIMITED",
"LEBARA MEDIA SERVICES PRIVATE LIMITED",
"LEBEN LABORATORIES PRIVATE LIMITED",
"LEBEN LIFE SCIENCES PRIVATE LIMITED",
"LEBENTEC MEDICAL SYSTEMS PRIVATE LIMITED",
"LEBNITZE REAL ESTATES PRIVATE LIMITED",
"LEBO SCRAP PRIVATE LIMITED",
"LEBONG INVESTMENTS PRIVATE LIMITED",
"LEBRACS RUBBER LININGS PVT.LTD",
"LECAN SOLUTIONS PRIVATE LIMITED",
"LECBNS INVESTMENTS AND TRADING COMPANY PRIVATE LIMITED",
"LECHLER INDIA PRIVATE LIMITED",
"LECICHEM AGROTECH INDUSTRIES PRIVATE LIMITED",
"LECILITE INGREDIENTS PRIVATE LIMITED",
"LECO INSTRUMENTSINDIA PRIVATE LIMITED",
"LECOANET HEMANT INDIA PRIVATE LIMITED",
"LECON ENERGETICS PRIVATE LIMITED",
"LE-CON SEALS PRIVATE LIMITED",
"LECORB INDIA PRIVATE LIMITED",
"LECTRA TECHNOLOGIES INDIA PRIVATE LIMITED",
"LECTRIX EV PRIVATE LIMITED",
"LED LINEAR INDIA PRIVATE LIMITED",
"LEDCHIP INDUS PRIVATE LIMITED",
"LEDER AND VOGUE PRIVATE LIMITED",
"LEDERLE PHARMA LIMITED",
"LEDGER SERVICES PRIVATE LIMITED",
"LEDO TEA CO LTD .",
"LEDONIX TECHNOLOGIES PRIVATE LIMITED",
"LEDURE LIGHTNING LIMITED",
"LEDUS LIGHTING PRIVATE LIMITED",
"LEDVANCE PRIVATE LIMITED",
"LEE & NEE SOFTWARES (EXPORTS) LTD",
"LEE AND MUIRHEAD PRIVATE LIMITED",
"LEE BUILDERS PRIVATE LIMITED",
"LEE HEALTH DOMAIN INDIA PRIVATE LIMITED",
"LEE HYDRAULICS AND FASTENERS PRIVATE LIMITED",
"LEE PHARMA LIMITED",
"LEE SPRING COMPANY INDIA PRIVATE LIMITED",
"LEEBEX METALS PRIVATE LIMITED",
"LEEBO METALS PRIVATE LIMITED",
"LEEBOY INDIA CONSTRUCTION EQUIPMENT PRIVATE LIMITED",
"LEECHANTS GLOBAL INDIA PRIVATE LIMITED",
"LEECHEM BIOTECH PRIVATE LIMITED",
"LEECOS MANUFACTURING TECHNOLOGY INDIA PRIVATE LIMITED",
"LEECOT APPARELS PRIVATE LIMITED",
"LEEDS DEVELOPERS AND BUILDCON PRIVATE LIMITED",
"LEEDS LIFE SCIENCES PRIVATE LIMITED",
"LEEDS SKILL TRAINING CENTRE PRIVATE LIMITED",
"LEEDS SPORTS PRIVATE LIMITED",
"LEEDSKEM (INDIA) LIMITED",
"LEEFONG EXIM PRIVATE LIMITED",
"LEEFORD HEALTHCARE LIMITED",
"LEEFORD MEDICARE LIMITED",
"LEEGRAND S LIFESTYLE PRIVATE LIMITED",
"LEEHANSH EXIM PRIVATE LIMITED",
"LEEISHA DESIGNS PRIVATE LIMITED",
"LEEJO LIGHTING ELECTRONICS PRIVATE LIMITED",
"LEELA AUTOCOMP AND STAMPINGS PRIVATE LIMITED",
"LEELA BATI DEBI PROJECTS ENTERPRISE PVT LTD",
"LEELA DIAMONDS PRIVATE LIMITED",
"LEELA ELECTRICPOWER SERVICES PRIVATE LIMITED",
"LEELA FOODS PRIVATE LIMITED",
"LEELA GLOBAL PRIVATE LIMITED",
"LEELA GREENSHIP RECYCLING PRIVATE LIMITED",
"LEELA HOSPITAL",
"LEELA KRISHNA AGRI & AQUA EXPORTS PRIVATE LIMITED",
"LEELA KRISHNA AUTOMOBILES PRIVATE LIMITED",
"LEELA KRISHNA DAIRY PRIVATE LIMITED",
"LEELA LACE HOLDINGS PRIVATE LIMITED",
"LEELA LOGISTICS PRIVATE LIMITED",
"LEELA MERCANTILE PRIVATE LIMITED",
"LEELA NEWS NETWORK PVT LTD",
"LEELA POLYPLAST INDIA PRIVATE LIMITED",
"LEELA RESIDENCIES PRIVATE LIMITED",
"LEELA SEPERATORS PRIVATE LIMITED",
"LEELA SHIP RECYCLING PRIVATE LIMITED",
"LEELA SUSTAINABLE SHIP RECYCLING PRIVATE LIMITED",
"LEELA TAXI SERVICE PRIVATE LIMITED",
"LEELA TRADE-LINK PRIVATE LIMITED",
"LEELA TUBES PRIVATE LIMITED",
"LEELABIHARI FINANCE PRIVATE LIMITED",
"LEELADHARA PROJECTS PRIVATE LIMITED",
"LEELAMAYEE FOODS PVT LTD",
"LEELAMAYEE WINES PRIVATE LIMITED",
"LEELAMAYI AUTOMOBILES PRIVATE LIMITED",
"LEELAP CLOTHING PRIVATE LIMITED",
"LEELAVATI CLASSIC MOTORS PRIVATE LIMITED",
"LEELMAX POWER SOLUTION PRIVATE LIMITED",
"LEELOTTAM INDUSTRIES PRIVATE LIMITED",
"LEEMA EXPORTS PRIVATE LIMITED",
"LEEMA MOBILES INDIA PRIVATE LIMITED",
"LEEMIK LOGISTICS PRIVATE LIMITED",
"LEEN INTERNATIONAL FABRICS PRIVATE LIMITED",
"LEENA AI INDIA PRIVATE LIMITED",
"LEENA AUTOMOTIVE INDIA PRIVATE LIMITED",
"LEENA ELECTRO MECHANICAL PRIVATE LIMITED",
"LEENA HOSPITALITY SERVICES PRIVATE LIMITED",
"LEENA ORGANICS PRIVATE LIMITED",
"LEENA POWER TECH ENGINEERS PRIVATE LIMITED",
"LEENOVA KITCHEN EQUIPMENTS PRIVATE LIMITED",
"LEENTICING GLOBAL LLP",
"LEENUS INFRA PRIVATE LIMITED",
"LEEO VALVES INDIA PRIVATE LIMITED",
"LEEP EDRIVE PRIVATE LIMITED",
"LEER CHEM INDIA PRIVATE LIMITED",
"LEET EPM PRIVATE LIMITED",
"LEETHA PACK PVT LTD",
"LEETHA PRESS AND PROCESS PRIVATE LIMITED",
"LEETU EDUCATION SERVICES PRIVATE LIMITED",
"LEEWAY SOFT-TECH PRIVATE LIMITED",
"LEEWAY TECHNOSOLUTION PRIVATE LIMITED",
"LEEWAYHERTZ TECHNOLOGIES PRIVATE LIMITED",
"LEEWO CONTRACTS PRIAVATE LIMITED",
"LEEWON PRECISION PRIVATE LIMITED",
"LEEZA EXIM PRIVATE LIMITED",
"LEEZA LIFESTYLE PRIVATE LIMITED",
"LEFT RIGHT MIND PRIVATE LIMITED",
"LEFTSHIFT TECHNOLOGIES PRIVATE LIMITED",
"LEG GODT INDIA PRIVATE LIMITED",
"LEGACY COMMODITIES PRIVATE LIMITED",
"LEGACY CONSULTANCY PRIVATE LIMITED",
"LEGACY FOODS PRIVATE LIMITED",
"LEGACY IMPEX PRIVATE LIMITED",
"LEGACY MED PRIVATE LIMITED",
"LEGACY SHIP MANAGEMENT PRIVATE LIMITED",
"LEGAL ENTITY GARRET MOTION TECH I PL",
"LEGAL INFOSOLUTIONS PRIVATE LIMITED",
"LEGAL METROLOGY",
"LEGAL O2 PRIVATE LIMITED",
"LEGAL RAASTA TECHNOLOGIES PRIVATE LIMITED",
"LEGAL TALENT MANAGEMENT PRIVATE LIMITED",
"LEGALCRAFT SOLUTIONS PRIVATE LIMITED",
"LEGALEASE SOLUTIONS INDIA PRIVATE LIMITED",
"LEGALFORCE RAPC PRIVATE LIMITED",
"LEGALJINI CORPORATE SERVICES PRIVATE LIMITED",
"LEGALMONK ADVISORS PRIVATE LIMITED",
"LEGALPAY TECHNOLOGY PRIVATE LIMITED",
"LEGALPUNDITS INTERNATIONAL SERVICES PRIVATE LIMITED",
"LEGALWIZIN PRIVATE LIMITED",
"LEGALXGEN SOFTWARE SOLUTION PRIVATE LIMITED",
"LEGASIS CONSULTANCY SERVICES PRIVATE LIMITED",
"LEGASIS PRIVATE LIMITED",
"LEGENCY REMEDIES PRIVATE LIMITED",
"LEGEND ARTISTS PRIVATE LIMITED",
"LEGEND CARS PRIVATE LIMITED",
"LEGEND CERAMIC PRIVATE LIMITED",
"LEGEND CREATIONS PRIVATE LIMITED",
"LEGEND DISTILLERIES PVT LTD",
"LEGEND POLYFOAMS PRIVATE LIMITED",
"LEGEND PUBLIC SCHOOL",
"LEGEND REMEDIES PRIVATE LIMITED",
"LEGEND TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"LEGEND TRAVELS INDIA PRIVATE LIMITED",
"LEGEND TRAVELS PRIVATE LIMITED",
"LEGEND XPRESS INDIA PRIVATE LIMITED",
"LEGENDARY DISTRIBUTORS PRIVATE LIMITED",
"LEGENDRY MOTORS PRIVATE LIMITED",
"LEGENDRY NIRMAN PRIVATE LIMITED",
"LEGERO INTERNATIONAL INDIA PRIVATE LIMITED",
"LEGERO LIGHTING INDIA PRIVATE LIMITED",
"LEGGETT & PLATT AUTOMOTIVE INDIA PRIVATE LIMITED",
"LEGGETT AND PLATT AUTOMOTIVE INDIA PRIVATE LIMITED",
"LEGION MINERALS PRIVATE LIMITED",
"LEGISLATIVE AND PARLIAMENTARY DEPARTMENT",
"LEGISTIFY SERVICES PRIVATE LIMITED",
"LEGITIMATE HEALTH SOLUTION PRIVATE LIMITED",
"LEGNO DOORS AND INTERIORS PRIVATE LIMITED",
"LEGOR LOGISTICS PRIVATE LIMITED",
"LEGRIS HOLDING INDIA PRIVATE LIMITED",
"LEGRIS INDIA PRIVATE LIMITED",
"LEGRO INDIA PRIVATE LIMITED",
"LEGRO OVERSEAS PRIVATE LIMITED",
"LEGUME AGRI INDIA PRIVATE LIMITED",
"LEH COLD STORAGE PRIVATE LIMITED",
"LEHAL EXPORTS PRIVATE LIMITED",
"LEHANAA ENTERPRISES PRIVATE LIMITED",
"LEHAR ADVERTISING PRIVATE LIMITED",
"LEHAR FOOTWEARS LIMITED",
"LEHAR WEBSTORE PRIVATE LIMITED",
"LEHARI ENGINEERING AND CONSTRUCTIONS PRIVATE LIMITED",
"LEHARTECHNOLOGIES. COM PRIVATE LIMITED",
"LEHMAN BROTHERS SECURITIES PRIVATE LIMITED",
"LEHNN SPORTS INFRA PRIVATE LIMITED",
"LEHREN NETWORKS PRIVATE LIMITED",
"LEHRI SOLUTIONS PRIVATE LIMITED",
"LEHRY INDUSTRIES PRIVATE LIMITED",
"LEHRY INSTRUMENTATION AND VALVES PRIVATE LIMITED",
"LEHSUNWALA AGRO PRODUCTS PRIVATE LIMITED",
"LEHUI FINNAH INDIA ENGINEERING & EQUIPMENT PRIVATE LIMITED",
"LEI INDIA PRIVATE LIMITED",
"LEI REGISTER INDIA PRIVATE LIMITED",
"LEICHT LED PRIVATE LIMITED",
"LEIGHTON INDIA CONTRACTORS PRIVATE LIMITED",
"LEINER SHOES PRIVATE LIMITED",
"LEINTZ CONTROLS PRIVATE LIMITED",
"LEISSTUNG MOTORRAAD PRIVATE LIMITED",
"LEISTEN SYSTEMS AND INFRASTRUCTURE PRIVATE LIMITED",
"LEISTEN SYSTEMS AND INFRASTRUCTURE PRIVATE LIMITED (OPC)",
"LEISTER TECHNOLOGIES INDIA PRIVATE LIMITED",
"LEISTRITZ INDIA PRIVATE LIMITED",
"LEISTUNG ENGINEERING PRIVATE LIMITED",
"LEISURE AND LIFESTYLE INFORMATION SERVICES PRIVATE LIMITED",
"LEISURE CARGO INDIA PRIVATE LIMITED",
"LEISURE ENTERTAINMENT PRIVATE LIMITED",
"LEISURE HOTELS LIMITED",
"LEISURE LUGGAGE PRIVATE LIMITED",
"LEISURE N LUXURY HOTELS AND RESORTS PRIVATE LIMITED",
"LEISURE PROMOTION PRIVATE LIMITED",
"LEISURE RESTOBAR PRIVATE LIMITED",
"LEISUREFLIES TRAVELS PRIVATE LIMITED",
"LEISUREZONE CAFE PRIVATE LIMITED",
"LEITNER INDIA PRIVATE LIMITED",
"LEITZ TOOLING SYSTEMS INDIA PRIVATE LIMITED",
"LEIXIR RESOURCES PRIVATE LIMITED",
"LEJONET TECHNOLOGIES PRIVATE LIMITED",
"LEKCON INFRASTRUCTURE PRIVATE LIMITED",
"LEKH BUILDTECH PRIVATE LIMITED",
"LEKH RAJ AUTOPLAZA PRIVATE LIMITED",
"LEKH RAJ ENTERPRISES PRIVATE LIMITED",
"LEKHA MACHINE TOOLS PRIVATE LIMITED",
"LEKHA PRODUCTIONS PRIVATE LIMITED",
"LEKHA STAMPING INDIA PRIVATE LIMITED",
"LEKHA WIRELESS SOLUTIONS PRIVATE LIMITED",
"LEKHNI PUBLISHERS PRIVATE LIMITED",
"LEKHRAJ CORP PRIVATE LIMITED",
"LEKHUS COLLECTIONS PRIVATE LIMITED",
"LEKHYA MOTORS PRIVATE LIMITED",
"LEKSA LIGHTING TECHNOLOGIES PRIVATE LIMITED",
"LEL INTERNATIONAL PRIVATE LIMITED",
"LEL PROPERTIES (INDIA) LIMITED",
"LELAFE IT SOLUTIONS PRIVATE LIMITED",
"LELE AND ASSOCIATES CONSULTANTS AND ENGINEERS PRIVATE LIMITED",
"LELE HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED",
"LELESYS INFOTECH PRIVATE LIMITED",
"LEM INFRASTRUCTURE PRIVATE LIMITED",
"LEMA LABS TECHNOLOGIES PRIVATE LIMITED",
"LEMFORD BIOTECH PRIVATE LIMITED",
"LEMINOS LABORATORIES PRIVATE LIMITED",
"LEMIS INDIA PRIVATE LIMITED",
"LEMKEN INDIA AGRO EQUIPMENT PRIVATE LIMITED",
"LEMMA TECHNOLOGIES (I) PRIVATE LIMITED",
"LEMMENS SHARDLOW INDIA PRIVATE LIMITED",
"LEMMINKAINEN CONSTRUCTION INDIA PRIVATE LIMITED",
"LEMON CHILLI VEG GOURMET FOODS LLP",
"LEMON CONSTRUCTIONS PRIVATE LIMITED",
"LEMON DESIGN PRIVATE LIMITED",
"LEMON GRASS HOTELS PRIVATE LIMITED",
"LEMON HOME APPLIANCES PRIVATE LIMITED",
"LEMON PEAK MARKETING SERVICES PRIVATE LIMITED",
"LEMON SALES & DISTRIBUTION PRIVATE LIMITED",
"LEMON SEEDS HOSPITALITY PRIVATE LIMITED",
"LEMON TECHNOLOGIES PRIVATE LIMITED",
"LEMON TECHNOMIST PRIVATE LIMITED",
"LEMON TREE EXHIBITIONS PRIVATE LIMITED",
"LEMON TREE HOTEL COMPANY PRIVATE LIMITED",
"LEMON TREE HOTELS LIMITED",
"LEMONCHILLII FARMS PRIVATE LIMITED",
"LEMONGRASS INVESTMENT CONSULTANTS PRIVATE LIMITED",
"LEMONGRASS PRODUCT DEVELOPMENT INDIA PRIVATE LIMITED",
"LEMONMINT TOURS PRIVATE LIMITED",
"LEMOR INTERIO PRIVATE LIMITED",
"LEMOSYS INFOTECH PRIVATE LIMITED",
"LEMUIR SECURE LOGISTICS PRIVATE LIMITED",
"LENAX PHARMACEUTICALS PRIVATE LIMITED",
"LEND A HAND INDIA",
"LEND LEASE COMPANY (INDIA) LIMITED",
"LENDCIERGE ESTATE PRIVATE LIMITED",
"LENDI INSTITUTE OF ENGINEERING AND TECHNOLOGY",
"LENDINGKART FINANCE LIMITED",
"LENDINGKART GROUP",
"LENDINGTREE RESEARCH SERVICES LLP",
"LENDITT INNOVATIONS & TECHNOLOGIES PRIVATE LIMITED",
"LENEXIS FOODWORKS PRIVATE LIMITED",
"LENGRAI TEA LTD",
"LENIENT CONSULTANTS PRIVATE LTD",
"LENIMEN BIOTECH PRIVATE LIMITED",
"LENINGARH SIKSHA NIKETAN HIGH SCHOOL",
"LENKRAD TRANSLATIONS PRIVATE LIMITED",
"LENNOX ESTATES PRIVATE LIMITED",
"LENNOX INDIA TECHNOLOGY CENTRE PRIVATE LIMITED",
"LENORA GLOVE PRIVATE LIMITED",
"LENORA IT SOLUTIONS PRIVATE LIMITED",
"LENORA SOFT TECHNOLOGIES PRIVATE LIMITED",
"LENOVO GLOBAL TECHNOLOGY INDIA P LIMITED",
"LENOVO INDIA PRIVATE LIMITED",
"LENOX INDIA PRIVATE LIMITED",
"LENS AND GRAPHIC (INDIA) PRIVATE LIMITED",
"LENS MAKERS ENTERPRISES",
"LENSEL OPTICS PRIVATE LIMITED",
"LENSKART SOLUTIONS PRIVATE LIMITED",
"LENSTECH OPTICALS PRIVATE LIMITED",
"LENTERA TECHNOLOGIES PRIVATE LIMITED",
"LENTILLE OPTICS PRIVATE LIMITED",
"LENTILS BAZAAR PRIVATE LIMITED",
"LENTO INDUSTRIES PRIVATE LIMITED",
"LENTUS SPECIALTY CHEMICALS PRIVATE LIMITED",
"LENUS LIFE CARE PRIVATE LIMITED",
"LENUS MEDICARE & RESEARCH PRIVATE LIMITED",
"LENZE MECHATRONICS PRIVATE LIMITED",
"LENZING FIBERS INDIA PRIVATE LIMITED",
"LEO ADVISORY SERVICES PRIVATE LIMITED",
"LEO AIR & POWER SOLUTION PRIVATE LIMITED.",
"LEO BHUMI PRIVATE LIMITED.",
"LEO BIO-CARE PRIVATE LIMITED",
"LEO CARLO FABRICS PRIVATE LIMITED",
"LEO CHEMO PLAST PRIVATE LIMITED",
"LEO CIRCUIT BOARDS P LIMITED",
"LEO COATS (INDIA) PRIVATE LIMITED",
"LEO CORPORATE CONSULTANTS (INDORE)PVT LTD",
"LEO DA VINCI EXPORTS LIMITED",
"LEO DESIGNS AND PACKAGING PRIVATE LIMITED",
"LEO DIGITAL COMMUNICATIONS PRIVATE LIMITED",
"LEO DRYFRUITS & SPICES TRADING LIMITED",
"LEO EARTHMOVERS PVT LTD",
"LEO EDIBLES AND FATS LIMITED",
"LEO ENVIROTECH PRIVATE LIMITED",
"LEO FACILITATORS PRIVATE LIMITED",
"LEO FINANCIAL SERVICES LIMITED",
"LEO FORMULATIONS PRIVATE LIMITED",
"LEO GLOBAL COMMODITIES PRIVATE LIMITED",
"LEO GLOBAL LOGISTICS INDIA PRIVATE LIMITED",
"LEO HOUSING PRIVATE LIMITED",
"LEO ISPAT LIMITED",
"LEO KRISHTEK PRIVATE LIMITED",
"LEO LAMINATES PRIVATE LIMITED",
"LEO LIFE SCIENCES PRIVATE LIMITED",
"LEO LUBRICANTS PRIVATE LIMITED",
"LEO MARINE INSPECTIONS PRIVATE LIMITED",
"LEO MATRICULATION HIGHER SECONDARY SCHOOL",
"LEO METAL CRAFT PRIVATE LIMITED",
"LEO METAL PRIVATE LIMITED",
"LEO METAL WORK PRIVATE LIMITED",
"LEO METRO CARDIAC CENTRE PRIVATE LIMITED",
"LEO N BABES CLOTHING COMPANY PRIVATE LIMITED",
"LEO NATURAL FLORALS PRIVATE LIMITED",
"LEO NUTRISCIENCE LLP",
"LEO PHARMA DISTRIBUTORS PRIVATE LIMITED",
"LEO PORTFOLIOS PRIVATE LIMITED",
"LEO PRECISION PRIVATE LIMITED",
"LEO PRIME COMP PRIVATE LIMITED",
"LEO PROMOTERS & DEVELOPERS PRIVATE LIMITED",
"LEO REALTORS",
"LEO SCHACHTER DIAMONDS INDIA PRIVATE LIMITED",
"LEO SIGN COMPOSITE (SD) PRIVATE LIMITED",
"LEO STEEL PROCESSORS PRIVATE LIMITED",
"LEO SURFACE COATINGS PRIVATE LIMITED",
"LEO TECHNOSOFT PRIVATE LIMITED",
"LEO TILES PRIVATE LIMITED",
"LEO TRANSPORTS PRIVATE LIMITED",
"LEO WETBLUE LEATHER PRIVATE LIMITED",
"LEOCH BATTERIES INDIA PRIVATE LIMITED",
"LEOCH SUPER POWER INDIA PRIVATE LIMITED",
"LEOCORP INTERNATIONAL PRIVATE LIMITED",
"LEOFAB PROJECTS PRIVATE LIMITED",
"LEOFLO PIPES PRIVATE LIMITED",
"LEOFORCE INDIA PRIVATE LIMITED",
"LEOGARD PHARMACEUTICALS PRIVATE LIMITED",
"LEOGEN ENERGY PRIVATE LIMITED",
"LEOGENIC HEALTHCARE PRIVATE LIMITED",
"LEOKRAFT TECHNOLOGIES PRIVATE LIMITED",
"LEOLINE COMMODITIES PRIVATE LIMITED",
"LEOMI INSTRUMENTS PRIVATE LIMITED",
"LEON COMMUNICATION TECHNOLOGIES PRIVATE LIMITED",
"LEON CROP SCIENCES PRIVATE LIMITED",
"LEON FERTILIZER PRIVATE LIMITED",
"LEON FOOD PRODUCTS PRIVATE LIMITED",
"LEON INSPECTION & TESTING INDIA PRIVATE LIMITED",
"LEON LABELS PRIVATE LIMITED",
"LEON REALTORS PRIVATE LIMITED",
"LEON STEELS PRIVATE LIMITED",
"LEON TECHNOLOGIES INTEGRATIONS PRIVATE LIMITED",
"LEONARD CHESHIRE DISABILITY",
"LEONARD EXPORTS",
"LEONARD FINANCE PRIVATE LIMITED",
"LEONARD HEALTH SERVICES PRIVATE LIMITED",
"LEONARD HOLDINGS AND TRADING PVT LTD",
"LEONARD MINERALS AND EXIM PRIVATE LIMITED",
"LEONARD TRAVELS PVT LTD",
"LEONARDO AEROSPACE DEFENSE & SECURITY INDIA PRIVATE LIMITED",
"LEONARDO ENGINEERING PRIVATE LIMITED",
"LEONARDO LEATHERS PRIVATE LIMITED",
"LEONAS IT SOLUTIONS PRIVATE LIMITED",
"LEONEX SYSTEMS PRIVATE LIMITED",
"LEONI CABLE SOLUTIONS INDIA PRIVATE LIMITED",
"LEONI WIRING SYSTEMS PUNE PRIVATE LIMITED",
"LEONIS ELECTRONICS PRIVATE LIMITED",
"LEONIS GAMMA HEALTHCARE PRIVATE LIMITED",
"LEONNE HILL PROPERTY DEVELOPMENTS PRIVATE LIMITED",
"LEONS INTEGRATIONS PRIVATE LIMITED",
"LEOPARD EQUIPMENTS AND ENGINEERS PRIVATE LIMITED",
"LEOPARD INVESTMENTS PVT LTD",
"LEOPARD REALTORS PRIVATE LIMITED",
"LEOPARD VITRIFIED PRIVATE LIMITED",
"LEORA EXIM PRIVATE LIMITED",
"LEORA JEWELLERY",
"LEORA LOGISTICS PRIVATE LIMITED",
"LEORAIN BATH PRODUCTS PRIVATE LIMITED",
"LEOSCO INDIA APPAREL PRIVATE LIMITED",
"LEOSTAR LOGISTICS PRIVATE LIMITED",
"LEOTRONIC SCALES PRIVATE LIMITED",
"LEOZ FURNITURE PRIVATE LIMITED",
"LEP EXPORTS PRIVATE LIMITED",
"LEPAKSHI TUBES PRIVATE LIMITED",
"LEPARO ELECTRICALS PRIVATE LIMITED",
"LEPHONE TECHNOLOGY PRIVATE LIMITED",
"LEPIDE SOFTWARE PRIVATE LIMITED",
"LEPIUS LIFE SCIENCES PRIVATE LIMITED",
"LEPL VENTURES PRIVATE LIMITED",
"LEPRO HERBALS PRIVATE LIMITED",
"LEPROSY HOSPITAL",
"LEPTON PROJECTS PRIVATE LIMITED",
"LEPTON TECHNOLOGIES PRIVATE LIMITED",
"LEPUCARE INDIA VASCULAR SOLUTIONS PRIVATE LIMITED",
"LERA CONSULTING STRUCTURAL ENGINEERS INDIA PRIVATE LIMITED",
"LERA TECHNOLOGIES PRIVATE LIMITED",
"LERCH BATES PRIVATE LIMITED",
"LERICA INTERNATIONAL PRIVATE LIMITED",
"LERICON INFORMATICS PRIVATE LIMITED",
"LERIDA PROPERTIES PRIVATE LIMITED",
"LEROC MEDIA SERVICES PRIVATE LIMITED",
"LEROI PHARMACEUTICALS PRIVATE LIMITED",
"LES CONCIERGES SERVICES PRIVATE LIMITED",
"LES REINS LIFESCIENCES PRIVATE LIMITED",
"LES TRANSFORMATIONS LEARNING PRIVATE LIMITED",
"LESANTO LABORATORIES PRIVATE LIMITED",
"LESCHACO INDIA PRIVATE LIMITED",
"LESHA AGENCIES",
"LESHA INDUSTRIES LIMITED",
"LE-SHARK GLOBAL LLP",
"LESICS ENGINEERS PRIVATE LIMITED",
"LESOKART INDUSTRIES PRIVATE LIMITED",
"LESS PRICE RETAIL PRIVATE LIMITED",
"LESSARD ARCHITECTURE AND LAND PLANNING PRIVATE LIMITED",
"LESSO BUILDTECH PRIVATE LIMITED",
"LESTECH ENGINEERING INDIA PRIVATE LIMITED",
"LESTED KNITFAB PRIVATE LIMITED",
"LESTER INFOSERVICES PRIVATE LIMITED",
"LETIC VITRIFIED PRIVATE LIMITED",
"LETMEDOIT TECHNOLOGIES PRIVATE LIMITED",
"LETRA GRAPHIX PRIVATE LIMITED",
"LETREACH TECHNOLOGIES PRIVATE LIMITED",
"LETS CONNECT COWORKING SPACE PRIVATE LIMITED",
"LETS CORP INDIA PRIVATE LIMITED",
"LETS ENKINDLE SOFTSERV PRIVATE LIMITED",
"LETS NURTURE INFOTECH PRIVATE LIMITED",
"LETS SHINE PRIVATE LIMITED",
"LETS TRAVEL PRIVATE LIMITED",
"LETS YATRA & EVENTS PRIVATE LIMITED",
"LETSDRESSUP FASHION PRIVATE LIMITED",
"LETSENDORSE DEVELOPMENT PRIVATE LIMITED",
"LETSMOBILITY SOFTWARE SOLUTIONS PRIVATE LIMITED",
"LETSMOVE SERVICES PRIVATE LIMITED",
"LETSSHAVE PRIVATE LIMITED",
"LETSTRAK TECH PRIVATE LIMITED",
"LETSVENTURE TECHNOLOGIES PRIVATE LIMITE",
"LETTERSHOP INDIA PRIVATE LIMITED",
"LETZ CONNET TECH PRIVATE LIMITED",
"LETZPAY SOLUTION PRIVATE LIMITED",
"LEUCINE MEDTECH PRIVATE LIMITED",
"LEUCON TECHNOLOGY PRIVATE LIMITED",
"L'EUROPA APPARELS PRIVATE LIMITED",
"LEUZE ELECTRONIC PRIVATE LIMITED",
"LEVANA INFRA PRIVATE LIMITED",
"LEVANT IMPORTERS PRIVATE LIMITED",
"LEVANT SOLAR PRIVATE LIMITED",
"LEVANTARE TECHNOLOGY PRIVATE LIMITED",
"LEVANTINA NATURAL STONE INDIA PRIVATE LIMITED",
"LEVARE CONSULTANTS PRIVATE LIMITED",
"LEVASSA OVERSEAS PRIVATE LIMITED",
"LEVCON INSTRUMENTS PVT LTD",
"LEVEETECH ECOMMERCE SERVICES PRIVATE LIMITED",
"LEVEL 9 BIZ PRIVATE LIMITED",
"LEVEL A COMMODITY SERVICES PRIVATE LIMITED",
"LEVEL INNOVATIONS PRIVATE LIMITED",
"LEVEL SHOES PRIVATE LIMITED",
"LEVEL UP SPORTS PRIVATE LIMITED",
"LEVELNEXT IDEAS PRIVATE LIMITED",
"LEVELUP HOSPITALITY PRIVATE LIMITED",
"LEVERAGE CAPITAL PRIVATE LIMITED",
"LEVERAGE INFRASTRUCTURES PRIVATE LIMITED",
"LEVERAGE REALTORS PRIVATE LIMITED",
"LEVERAGE SCIENCE AND TECHNOLOGIES LIMITED",
"LEVERGENT TECHNOLOGIES INDIA PRIVATE LIMITED",
"LEVI STRAUSS INDIA PRIVATE LIMITED",
"LEVIAT INDIA PRIVATE LIMITED",
"LEVIATHAN SYSTEMS PRIVATE LIMITED",
"LEVIDIA INFRA PRIVATE LIMITED",
"LEVIGATO EXIM PRIVATE LIMITED",
"LEVIGO ENGINEERING INDIA PRIVATE LIMITED",
"LEVIKAS ENTERPRISES PRIVATE LIMITED",
"LEVIM BIOTECH LLP",
"LEVIN FINTECH PRIVATE LIMITED",
"LEVINZA CERAMIC PRIVATE LIMITED",
"LEVITEK PLM SOLUTIONS PRIVATE LIMITED",
"LEVO BEAUTY PRIVATE LIMITED",
"LEVO RETAILS PRIVATE LIMITED",
"LEVRAM LIFESCIENCES PRIVATE LIMITED",
"LEVRARA CONSULTING INDIA PRIVATE LIMITED",
"LEVROSEDUTECH BOOKS PRIVATE LIMITED",
"LEVTECH CONSULTING SERVICES INDIA PRIVATE LIMITED",
"LEVVAN ENGINEERING & AUTOMATION PRIVATE LIMITED",
"LEWA PUMPS INDIA PRIVATE LIMITED",
"LEWEK ALTAIR SHIPPING PRIVATE LIMITED",
"LEWENS LABS PRIVATE LIMITED",
"LEWIS AND HICKEY INDIA PRIVATE LIMITED",
"LEX CONNECT CONSULTING PRIVATE LIMITED",
"LEX INTERNATIONAL PRIVATE LIMITED",
"LEX LAND SECURITIES PRIVATE LIMITED",
"LEX NIMBLE SOLUTIONS LIMITED",
"LEX ORBIS CONSULTING PRIVATE LIMITED",
"LEX SPORTEL VISION PRIVATE LIMITED",
"LEX TECHNOAID INTERNATIONAL PRIVATE LIMITED",
"LEXAGENT SERVICES PRIVATE LIMITED",
"LEXCLOUD SOFTWARE PRIVATE LIMITED",
"LEXCRU WATER INDUSTRIES PRIVATE LIMITED",
"LEXCRU WATER TECH PRIVATE LIMITED",
"LEXI PRIVATE LIMITED",
"LEXICAL HEALTH CARE PRIVATE LIMITED",
"LEXICARE PHARMA PRIVATE LIMITED",
"LEXICON BROADCASTING LLP",
"LEXICON CERAMIC PRIVATE LIMITED",
"LEXICON COMMERCIAL ENTERPRISES LIMITED",
"LEXICON COMPUTERS PRIVATE LIMITED",
"LEXICON FREIGHT INTERNATIONAL PRIVATE LIMITED",
"LEXICON GLOBAL SCHOOL",
"LEXICON LEARNING PRIVATE LIMITED",
"LEXICON MANAGEMENT INSTITUTE OF LEADERSHIP & EXCELLENCE",
"LEXICON NETWORKS INDIA PRIVATE LIMITED",
"LEXICON OVERSEAS PRIVATE LIMITED",
"LEXICON VANIJYA PRIVATE LIMITED",
"LEXICON WORLDWIDE LIMITED",
"LEXICONN CONTENT SERVICES PRIVATE LIMITED",
"LEXINE TECHNOCHEM PRIVATE LIMITED",
"LEXINGTON SOFT PRIVATE LIMITED",
"LEXINNOVA TECHNOLOGIES PRIVATE LIMITED",
"LEXIS TOOLING SYSTEMS PRIVATE LIMITED",
"LEXLA ENERGY INDIA PRIVATE LIMITED",
"LEXMARK CORPORATE SERVICES PRIVATE LIMITED",
"LEXMARK INTERNATIONAL INDIA PRIVATE LIMITED TRF.",
"LEXMARK PHARMACEUTICALS PRIVATE LIMITED",
"LEXMARK RADIATORS PRIVATE LIMITED",
"LEXPLOSION SOLUTIONS PRIVATE LIMITED",
"LEXPORTEX (INDIA) PVT LTD",
"LEXRAYS MANAGEMENT CONSULTING PRIVATE LIMITED",
"LEXTURE INDIA PRIVATE LIMITED",
"LEXUS CONSULTANTS PRIVATE LIMITED",
"LEXUS EXPORTS PRIVATE LIMITED",
"LEXUS FUTURE PRIVATE LIMITED",
"LEXUS GRANITO INDIA PRIVATE LIMITED",
"LEXUS HYCON PRIVATE LIMITED",
"LEXUS INFRATECH LLP",
"LEXUS MACHINES PRIVATE LIMITED",
"LEXUS MOTORS LIMITED",
"LEXUS WATER TECH INDIA PRIVATE LIMITED",
"LEYBOLD INDIA PRIVATE LIMITED",
"LEYTA GENUINE PRIVATE LIMITED",
"LEYTON FRESH PRIVATE LIMITED",
"LEYTON INVESTMENT SERVICES PRIVATE LIMITED",
"LEZEND TECHNOLOGIES PRIVATE LIMITED",
"LEZINI METALS PRIVATE LIMITED",
"LEZORA VITRIFIED PRIVATE LIMITED",
"LF HOSPITAL",
"LF LOGISTICS (INDIA) PRIVATE LIMITED",
"LFC AUTO PRIVATE LIMITED",
"LFG HARDWARE PRIVATE LIMITED",
"LFS BROKING PRIVATE LIMITED",
"LFS HEALTH CARE PRIVATE LIMITED",
"LG CHEMICAL INDIA PRIVATE LIMITED",
"LG CNS INDIA PRIVATE LIMITED",
"LG ELECTRONICS INDIA PRIVATE LIMITED",
"LG FARM PRODUCTS PRIVATE LIMITED",
"LG LIFE SCIENCES INDIA PRIVATE LIMITED",
"LG MULTISPECIALITY MEDICAL CENTRE",
"LG PATSONS ENGINEERING PRIVATE LIMITED",
"LG PETROCHEMICALS PRIVATE LIMITED",
"LG POLYMERS INDIA PRIVATE LIMITED",
"LG SOFT INDIA PRIVATE LIMITED",
"LG SPORTS PRIVATE LIMITED",
"LGB FORGE LIMITED",
"LGC ENGINEERING",
"LGC PETROCHEMICAL INDIA PRIVATE LIMITED",
"LGF VITRIFIED PRIVATE LIMITED",
"LGM ENERGY INDIA PRIVATE LIMITED",
"LGM ENGINEERING INDIA PRIVATE LIMITED",
"LGN NUTS PRIVATE LIMITED",
"LGPL PAPER INDUSTRIES PRIVATE LIMITED",
"LGT BUSINESS CONNEXTIONS PRIVATE LIMITED",
"LGT WEALTH INDIA PRIVATE LIMITED",
"LGW INDUSTRIES LIMITED",
"LH COMMODITIES PRIVATE LIMITED",
"LH GLOBAL HUB SERVICES PRIVATE LIMITED",
"LH INDUSTRIES PRIVATE LIMITED",
"LHB TRADING PRIVATE LIMITED",
"LHC ASSET AND PROJECT MANAGERS PRIVATE LIMITED",
"LHC SHARED SERVICES PRIVATE LIMITED",
"LHDINDIA PRIVATE LIMITED",
"LHDM & DR PREM HOSPITAL LIMITED",
"LHHS HEALTHCARE PRIVATE LIMITED",
"LHK INFOTECH PRIVATE LIMITED",
"LHOIST INDIA PRIVATE LIMITED",
"LHP INTERNATIONAL PRIVATE LIMITED",
"LHSS - MRP SILICONE HOSES PRIVATE LIMITED",
"LI INDUSTRIAL PARKS PRIVATE LIMITED",
"LI MED LABS PRIVATE LIMITED",
"LIA GEORSON PRIVATE LIMITED",
"LIA LIFE SCIENCES PRIVATE LIMITED",
"LIAISON OFFICER ASSAM RIFLES",
"LIALIN HEALTHCARE PRIVATE LIMITED",
"LIANCHUANG ELECTRONIC INDIA PRIVATE LIMITED",
"LIANMING TECHNOLOGY INDIA PRIVATE LIMITED",
"LIASES FORAS REAL ESTATE RATING & RESEARCH PRIVATE LIMITED",
"LIBAKO PACKAGING PRIVATE LIMITED",
"LIBAS CONSUMER PRODUCTS LIMITED",
"LIBAS DESIGNS LIMITED",
"LIBATION CRAFTS PRIVATE LIMITED",
"LIBERAL ADVISORY SERVICES PRIVATE LIMITED",
"LIBERAL VINCOM PRIVATE LIMITED",
"LIBERALTY CONSTRUCTIONS PRIVATE LIMITED",
"LIBERATION COACHES PRIVATE LIMITED",
"LIBERIN TECHNOLOGIES PRIVATE LIMITED",
"LIBERIUM GLOBAL RESOURCES PRIVATE LIMITED",
"LIBERTY ASSOCIATES PRIVATE LIMITED",
"LIBERTY CAREER ACADEMY AHMEDABAD",
"LIBERTY DATA ANALYTICS PRIVATE LIMITED",
"LIBERTY EMBRO EXIM PRIVATE LIMITED",
"LIBERTY ENERGY PRIVATE LIMITED",
"LIBERTY ENGINEERING EQUIPMENTS (INDIA) PRIVATE LIMITED",
"LIBERTY EXPORTS PRIVATE LIMITED",
"LIBERTY FITNESS AND HEALTH SOLUTIONS PRIVATE LIMITED",
"LIBERTY GENERAL INSURANCE LIMITED",
"LIBERTY HIGH SCANS PRIVATE LIMITED",
"LIBERTY HIGHRISE PRIVATE LIMITED",
"LIBERTY HOSPITAL",
"LIBERTY INTERNATIONAL LIMITED",
"LIBERTY INVESTMENTS PRIVATE LIMITED",
"LIBERTY MANUFACTURERS AND MARKETORS PVT. LTD.",
"LIBERTY MATCH COMPANY PRIVATE LIMITED",
"LIBERTY MED SUPPLIES PRIVATE LIMITED",
"LIBERTY METAL & MACHINES PRIVATE LIMITED",
"LIBERTY MUTUAL HOLDING COMPANY INC.",
"LIBERTY NATURAL WEAVES PRIVATE LIMITED",
"LIBERTY OIL MILLS LIMITED",
"LIBERTY SHIPPING AGENCIES PRIVATE LIMITED",
"LIBERTY SHOES LIMITED",
"LIBERTY STEEL INDIA LIMITED",
"LIBERTY STEEL PROCESSORS PVT LTD",
"LIBERTY STEEL SERVICES INDIA PRIVATE LIMITED",
"LIBERTY VALVES PRIVATE LIMITED",
"LIBERTY WAREHOUSING COMPANY PVT LTD",
"LIBERTY WIRELESS TECHNOLOGIES PRIVATE LIMITED",
"LIBIN ERECTORS PRIVATE LIMITED",
"LIBORD ADVISORS PRIVATE LIMITED",
"LIBORD FINANCE LIMITED",
"LIBRA ALKALISCHEMIE PRIVATE LIMITED",
"LIBRA APPLIANCES PVT LTD",
"LIBRA AUTO AND GENERAL FINANCE LIMITED",
"LIBRA AUTO CAR COMPANY LIMITED",
"LIBRA AUTOMOBILES LIMITED",
"LIBRA AUTOSALES PRIVATE LIMITED",
"LIBRA BIOSCIENCE PRIVATE LIMITED",
"LIBRA BIOTECH PRIVATE LIMITED",
"LIBRA BUSINESS PRIVATE LIMITED",
"LIBRA CABLE NETWORK LIMITED",
"LIBRA CONSUMABLES PRIVATE LIMITED",
"LIBRA DETECTIVE AND SECURITY SERVICES",
"LIBRA DRUGS (INDIA) PVT LTD",
"LIBRA EXPORTERS LIMITED",
"LIBRA FABRICS PRIVATE LIMITED",
"LIBRA GASES PRIVATE LIMITED",
"LIBRA HOTELS PRIVATE LIMITED",
"LIBRA INFRA PROJECTS PRIVATE LIMITED",
"LIBRA INTERCITY SERVICES PRIVATE LIMITED",
"LIBRA INTERNATIONAL LIMITED",
"LIBRA INTERNATIONAL SHIPPING PRIVATE LIMITED",
"LIBRA MOTOR SALES PRIVATE LIMITED",
"LIBRA NATURAL RESOURCES PRIVATE LIMITED",
"LIBRA PAINTS PRIVATE LIMITED",
"LIBRA PROCESS TECHNOLOGIES PRIVATE LIMITED",
"LIBRA SYNTHETIC PRIVATE LIMITED",
"LIBRA TECHCON LIMITED",
"LIBRAA OFFSHORE PRIVATE LIMITED",
"LIBRAA SHIP MANAGEMENT PRIVATE LIMITED",
"LIBRAL TRADERS PRIVATE LIMITED",
"LIBRAMED PHARMACEUTICALS PRIVATE LIMITED",
"LIBRARIAN CLASS 2 DISTRICT LIBRARY OFFICER",
"LIBRATHERM INSTRUMENTS PRIVATE LIMITED",
"LIBRE WIRELESS TECHNOLOGIES INDIA PRIVATE LIMITED",
"LIBRO FOOTWEAR PRIVATE LIMITED",
"LIBSYS IT SERVICES PRIVATE LIMITED",
"LIBSYS LIMITED",
"LIC",
"LIC HOUSING FINANCE LIMITED",
"LIC MUTUAL FUND ASSET MANAGEMENT COMPANY LIMITED",
"LIC PENSION FUND LIMITED",
"LICHEE CONSTRUCTION PRIVATE LIMITED",
"LICHEN BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"LICHENS ENVIRONMENT PRIVATE LIMITED",
"LICHFL ASSET MANAGEMENT COMPANY LIMITED",
"LICHFL CARE HOMES LIMITED",
"LICHFL FINANCIAL SERVICES LIMITED",
"LICORNE HOSPITALITY PRIVATE LIMITED",
"LIDCO PROJECTS (INDIA) PRIVATE LIMITED",
"LIDO COMMERCIAL CO LIMITED",
"LIDO COMMERCIAL CO LTD",
"LIDO MALLS MANAGEMENT PRIVATE LIMITED",
"LIEBE INFOSOFT TECHNOLOGY PRIVATE LIMITED",
"LIEBHERR CMCTEC INDIA PRIVATE LIMITED",
"LIEBHERR INDIA PRIVATE LIMITED",
"LIEBHERR MACHINE TOOLS INDIA PRIVATE LIMITED",
"LIEBIGS AGRO CHEM PRIVATE LIMITED",
"LIEK PHARMA PRIVATE LIMITED",
"LIFARS INDIA PRIVATE LIMITED",
"LIFE - CARE EQUIPMENTS PRIVATE LIMITED",
"LIFE AID SURGICAL",
"LIFE BOND MACHINES PRIVATE LIMITED",
"LIFE CARE",
"LIFE CARE BIO-MEDICAL PRIVATE LIMITED",
"LIFE CARE DIAGNOSTIC",
"LIFE CARE HERITAGE FORMULATIONS PRIVATE LIMITED",
"LIFE CARE HOSPITAL",
"LIFE CARE HOSPITAL LIMITED",
"LIFE CARE LOGISTIC PRIVATE LIMITED",
"LIFE CARE MEDICAL COMPLEX PRIVATE LIMITED",
"LIFE CARE MEDICAL SYSTEMS ENTERPRISES PRIVATE LIMITED",
"LIFE CARE PHARMACEUTICALS PRIVATE LIMITED",
"LIFE CARE SCAN & RESEARCH CENTRE",
"LIFE CARE WARE HOUSING PRIVATE LIMITED",
"LIFE CELL INTERNATIONAL PRIVATE TD",
"LIFE CIRCLE HEALTH SERVICES PRIVATE LIMITED",
"LIFE CONSTRUCTIONS PRIVATE LIMITED",
"LIFE CRAFT MAINTENANCE PRIVATE LIMITED",
"LIFE ESSENTIALS PERSONAL CARE PRIVATE LIMITED",
"LIFE EXPRESS HEALTHCARE PRIVATE LIMITED",
"LIFE FITNESS INDIA PRIVATE LIMITED",
"LIFE FORCE MOLECULES PRIVATE LIMITED",
"LIFE GEAR SAFETECH PRIVATE LIMITED",
"LIFE GUARD DISTRIBUTORS PRIVATE LIMITED",
"LIFE HEALTH FOODS INDIA PRIVATE LIMITED",
"LIFE INFRA ENGINEERS PRIVATE LIMITED",
"LIFE INSU CORPORATION- GOVT RAJ",
"LIFE INSURANCE CORP INDIA S",
"LIFE INSURANCE CORPORATION OF INDIA",
"LIFE LAYING FARM PRIVATE LIMITED",
"LIFE LEARNING SOLUTIONS PRIVATE LIMITED",
"LIFE LINE BIOTECH LIMITED",
"LIFE LINE BIZ PRIVATE LIMITED",
"LIFE LINE FEEDS INDIA PRIVATE LIMITED",
"LIFE LINE IMPEX INDIA PRIVATE LIMITED",
"LIFE LINE MEDISOL PRIVATE LIMITED",
"LIFE LINE PHARMA",
"LIFE LINE REMEDIES (INDIA) PRIVATE LIMITED",
"LIFE LINE SUPER-SPECIALITY HOSPITAL PRIVATE LIMITED",
"LIFE LINE SURGICAL ORTHO AND MEDICAL CENTRE PRIVATE LIMITED",
"LIFE LINE SURGICHEM (INDIA) PRIVATE LIMITED",
"LIFE LINK ECO-TECHNOLOGIES PRIVATE LIMITED",
"LIFE MEDICARE AND BIOTECH PRIVATE LIMITED",
"LIFE MEDICITY HOSPITAL",
"LIFE OF RILEY PRIVATE LIMITED",
"LIFE PHARMACEUTICALS PVT LTD",
"LIFE PILLAR FOODS PRIVATE LIMITED",
"LIFE PLUS HEALTHCARE PRIVATE LIMITED",
"LIFE POSITIVE PRIVATE LIMITED",
"LIFE SAFETY ENGINEERS PRIVATE LIMITED",
"LIFE SAVE FOUNDATION",
"LIFE SCIENCE CONSULTING PRIVATE LIMITED",
"LIFE SHINE MEDICAL SERVICES PRIVATE LIMITED",
"LIFE SLIMMING AND COSMETIC PRIVATE LIMITED",
"LIFE SOURCE (INDIA) TECHNOLOGY PRIVATE LIMITED",
"LIFE SPACES REALTY PRIVATE LIMITED",
"LIFE STYLE FOUNDATION PRIVATE LIMITED",
"LIFE STYLE INTERNATIONAL PRIVATE LIMITED",
"LIFE STYLE PROPERTIES PRIVATE LIMITED",
"LIFE TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"LIFE VISION CONSTRUCTION PRIVATE LIMITED",
"LIFE WATER PRIVATE LIMITED",
"LIFEBRIDGE SENIOR CARE PRIVATE LIMITED",
"LIFEBYTES INDIA PRIVATE LIMITED",
"LIFECARE CHARITABLE HOSPITAL",
"LIFECARE DIAGNOSTIC AND RESEARCH CENTRE PRIVATE LIMITED",
"LIFECARE EXIM INDIA PRIVATE LIMITED",
"LIFECARE FORMULATION PRIVATE LIMITED",
"LIFECARE FORMULATIONS PRIVATE LIMITED",
"LIFECARE INNOVATIONS PRIVATE LIMITED",
"LIFECARE MULTISPECIALITY HOSPITAL",
"LIFECARE NEURO PRODUCTS LIMITED",
"LIFECARE PHARMA PRIVATE LIMITED",
"LIFECELL INTERNATIONAL PRIVATE LIMITED",
"LIFECHEM LABORATORIES PRIVATE LIMITED",
"LIFECOM PHARMACEUTICALS INDIA PRIVATE LIMITED",
"LIFECRAFT HEALTHCARE PRIVATE LIMITED",
"LIFECURE PRODUCTS PRIVATE LIMITED",
"LIFECYCLE INFOTECH PRIVATE LIMITED",
"LIFEFIRST CONCEPTS AND TECHNOLOGIES PRIVATE LIMITED",
"LIFEFIRST ESSENTIALS PRIVATE LIMITED",
"LIFEFORD HEALTHCARE PRIVATE LIMITED",
"LIFEGRACE PHARMACEUTICALS PRIVATE LIMITED",
"LIFEGUARD MEDICAL SYSTEMS PRIVATE LIMITED",
"LIFEISCOOL MEDIA PRIVATE LIMITED",
"LIFEJET CARDIAC AMBULANCE SERVICE",
"LIFELINE FOODS AND AGRO PRODUCTS PRIVATE LIMITED",
"LIFELINE HOSPITAL",
"LIFELINE MARKETING PVT LTD",
"LIFELINE MEDICAL DEVICES PRIVATE LIMITED",
"LIFELINE MEDICARE HOSPITAL",
"LIFELINE MINDCARE SOLUTIONS INDIA PRIVATE LIMITED",
"LIFELINE MULTISPECIALITY HOSPITAL",
"LIFELINE MULTI-VENTURES PRIVATE LIMITED",
"LIFELINE PHARMACEUTICAL PRIVATE LIMITED",
"LIFELINE SPRING WATERS (INDIA) PRIVATE LIMITED",
"LIFELINE SUPERSPECIALITY HOSPITAL",
"LIFELINE SYSTECH SOLUTIONS PRIVATE LIMITED",
"LIFELINE TECHNOLOGIES",
"LIFELINX SURGIMED PRIVATE LIMITED",
"LIFELLINE MEDICARE HOSPITALS PRIVATE LIMITED",
"LIFELONG CLUB HOLIDAYS PRIVATE LIMITED",
"LIFELONG INDIA PRIVATE LIMITED",
"LIFELONG MEDITECH PRIVATE LIMITED",
"LIFELONG ONLINE RETAIL PRIVATE LIMITED",
"LIFELONG REAL ESTATE PRIVATE LIMITED",
"LIFEMAP BUILDERS PRIVATE LIMITED",
"LIFEMATE INDIA PRIVATE LIMITED",
"LIFENITY HEALTH LIMITED",
"LIFEON LABS PRIVATE LIMITED",
"LIFEPOINT MULTISPECIALITY HOSPITAL PRIVATE LIMITED",
"LIFEPURE LABS PRIVATE LIMITED",
"LIFEQUBES SHELTERS PRIVATE LIMITED",
"LIFERAY INDIA PRIVATE LIMITED",
"LIFESCAN MEDICAL DEVICES INDIA PRIVATE LIMITED",
"LIFESCAPES PROJECTS LLP",
"LIFESCIENCE INTELLIPEDIA PRIVATE LIMITED",
"LIFESCIENCE LABORATORIES PRIVATE LIMITED",
"LIFESCIENCE MECHANICS INDIA P LIMITED",
"LIFESHIELD FORMULATIONS PRIVATE LIMITED",
"LIFESHIELD SECURITY PRIVATE LIMITED",
"LIFESIGHT TECHNOLOGIES PRIVATE LIMITED",
"LIFESIGN HEALTHCARE PRIVATE LIMITED",
"LIFESIGNALS INDIA PRIVATE LIMITED",
"LIFESIZE INDIA PRIVATE LIMITED",
"LIFESOL MEDICAL INDIA PRIVATE LIMITED",
"LIFESPAN PRIVATE LIMITED",
"LIFESPRING HEALTHPLUS INDIA PRIVATE LIMITED",
"LIFESPRING HOSPITALS PRIVATE LIMITED",
"LIFESQUARE PHARMA PRIVATE LIMITED",
"LIFESTAR PHARMA PRIVATE LIMITED",
"LIFESTRAW INDIA PRIVATE LIMITED",
"LIFESTREAM PRIVATE LIMITED",
"LIFESTYLE & MEDIA HOLDINGS LIMITED",
"LIFESTYLE AUTOMOBILES PRIVATE LIMITED",
"LIFESTYLE BUILDCON PRIVATE LIMITED",
"LIFESTYLE FOODS PRIVATE LIMITED",
"LIFESTYLE HOLDING LIMITED",
"LIFESTYLE INTERIOR LLP",
"LIFESTYLE INTERIORS PRIVATE LIMITED",
"LIFESTYLE JEWELS PRIVATE LIMITED",
"LIFESTYLE MOBILES PRIVATE LIMITED",
"LIFESTYLE SUPERTECH PRIVATE LIMITED",
"LIFESTYLE TECHNOLOGIES PRIVATE LIMITED",
"LIFESURE CONSULTANCY PRIVATE LIMITED",
"LIFESURGE TRADING PRIVATE LIMITED",
"LIFETECH SCIENTIFIC INDIA PRIVATE LIMITED",
"LIFETIME WELLNESS RX INTERNATIONAL LIMITED",
"LIFETREE AGRO FOODS PRIVATE LIMITED",
"LIFETRUST HEALTHCARE PRIVATE LIMITED",
"LIFEVISION MEDICARE PRIVATE LIMITED",
"LIFEWALL GREENTECH PRIVATE LIMITED",
"LIFEWAY PRODUCTS PRIVATE LIMITED",
"LIFEWAY PUBLISHING INDIA PRIVATE LIMITED",
"LIFEWAYS INFRAESTATE PRIVATE LIMITED",
"LIFEWELL DIAGNOSTICS PRIVATE LIMITED",
"LIFEWORKS WELLBEING SOLUTIONS (INDIA) LLP",
"LIFEWORTH DIAGNOSTIC CENTRE PVT LTD",
"LIFEX FIRE FIGHTING INDUSTRIES PRIVATE LIMITED",
"LIFEZEN HEALTHCARE PRIVATE LIMITED",
"LIFT & SHIFT INDIA PRIVATE LIMITED",
"LIFT AND LASH PRIVATE LIMITED",
"LIFT AND TECH ENGINEERING AND INFRASTRUCTURE PRIVATE LIMITED",
"LIFT CONTROLS PRIVATE LIMITED",
"LIFT LIFE BIOTECH PRIVATE LIMITED",
"LIFT LINK TECHNOLOGIES PRIVATE LIMITED",
"LIFT MART PRIVATE LIMITED",
"LIFTBYTE AUTOMATION PRIVATE LIMITED",
"LIFTEC E&C INDIA PRIVATE LIMITED",
"LIFTECH CRANES AND COMPONENTS PRIVATE LIMITED",
"LIFTECH INDIA PRIVATE LIMITED",
"LIFTECH INDUSTRIES (INDIA) PRIVATE LIMITED",
"LIFTECH SOLUTIONS INDIA PRIVATE LIMITED",
"LIFTLAB ANALYTICS PRIVATE LIMITED",
"LIFTMAK UDYOG PRIVATE LIMITED",
"LIFTOFF SOFTWARE INDIA PRIVATE LIMITED",
"LIFT-XPERTS INDIA PRIVATE LIMITED",
"LIGABUE BIGI SUPPORT INDIA PRIVATE LIMITED",
"LIGARE AVIATION ENGINEERING PRIVATE LIMITED",
"LIGARE AVIATION LIMITED",
"LIGASURE HEALTHCARE PRIVATE LIMITED",
"LIGENT MACHINES PRIVATE LIMITED",
"LIGERO INDUSTRIES PRIVATE LIMITED",
"LIGERO SYSTEMS PRIVATE LIMITED",
"LIGHT AHEAD TECH SERVICES PRIVATE LIMITED",
"LIGHT AND SHADE ELECTRICALS PRIVATE LIMITED",
"LIGHT AND YOU PRIVATE LIMITED",
"LIGHT AXXIS PRIVATE LIMITED",
"LIGHT BULB COMMUNICATION PRIVATE LIMITED",
"LIGHT BULB MOTION PICTURES PRIVATE LIMITED",
"LIGHT CRAFT & SOUND PRIVATE LIMITED",
"LIGHT EMPORIUM PRIVATE LIMITED",
"LIGHT GUIDE OPTICS PRIVATE LIMITED",
"LIGHT INFORMATION SYSTEMS PRIVATE LIMITED",
"LIGHT INSIDE PRIVATE LIMITED",
"LIGHT LEATHERS PRIVATE LIMITED",
"LIGHT LIFT INDIA PRIVATE LIMITED",
"LIGHT MECHANICS PRIVATE LIMITED",
"LIGHT MICROFINANCE PRIVATE LIMITED",
"LIGHT N LIGHT INDIA PRIVATE LIMITED",
"LIGHT PHARMA PRIVATE LIMITED",
"LIGHT RAY ADVISORS LLP",
"LIGHT ROOFINGS LIMITED",
"LIGHTALIVE SOLUTIONS PRIVATE LIMITED",
"LIGHTBEAM PROJECTS PRIVATE LIMITED",
"LIGHTBERRY INNOVATIVE IDEAS PRIVATE LIMITED",
"LIGHTBOOK RETAIL PRIVATE LIMITED",
"LIGHTBOX INDIA ADVISORS PRIVATE LIMITED",
"LIGHTFIRE SOLUTIONS PRIVATE LIMITED",
"LIGHTFLAME HOME APPLIANCES PRIVATE LIMITED",
"LIGHTHOUSE ADVISORS (INDIA) PRIVATE LIMITED",
"LIGHTHOUSE COMMUNITIES FOUNDATION",
"LIGHTHOUSE INFO SYSTEMS PRIVATE LIMITED",
"LIGHTHOUSE LEARNING PRIVATE LIMITED",
"LIGHTHOUSE MALL MANAGEMENT COMPANY PRIVATE LIMITED",
"LIGHTHOUSE TECHNOLOGIES PRIVATE LIMITED",
"LIGHTING RESOURCES INDIA PRIVATE LIMITED",
"LIGHTING SOLUTION MEDIA EQUIPMENT RENTAL PRIVATE LIMITED",
"LIGHTING SYSTEMS AND SOLUTIONS INDIA PRIVATE LIMITED",
"LIGHTING TECHNOLOGIES INDIA PRIVATE LIMITED",
"LIGHTINGALE TECHNOLOGIES PRIVATE LIMITED",
"LIGHTMETRICS TECHNOLOGIES PRIVATE LIMITED",
"LIGHTNER POWER CONTROLS PRIVATE LIMITED",
"LIGHTNINGBIRD TECHNOLOGIES PRIVATE LIMITED",
"LIGHTNINGCHART SOLUTIONS PRIVATE LIMITED",
"LIGHTNINGLOGISTICS PRIVATE LIMITED",
"LIGHTONS ENGINEERING PRIVATE LIMITED",
"LIGHTOO TECHNOLOGIES PRIVATE LIMITED",
"LIGHTPRO TECHNOLOGIES PRIVATE LIMITED",
"LIGHTRIGHT PRIVATE LIMITED",
"LIGHTROCK CORPORATE SERVICES PRIVATE LIMITED",
"LIGHTROCK INVESTMENT ADVISORS PRIVATE LIMITED",
"LIGHTSTONE DEVELOPERS INDIA PRIVATE LIMITED",
"LIGHTSTORM DATA CENTERS PRIVATE LIMITED",
"LIGHTSTORM TELECOM VENTURES PRIVATE LIMITED",
"LIGHTWARE VISUAL ENGINEERING INDIA PRIVATE LIMITED",
"LIGMAN LIGHTING INDIA PRIVATE LIMTED",
"LIGMS INDIA PRIVATE LIMITED",
"LIGNUM PRO INDUSTRIES PRIVATE LIMITED",
"LIGO INTERTRADE PRIVATE LIMITED",
"LIGO TRADING PRIVATE LIMITED",
"LIGUER PACKAGING SOLUTIONS PRIVATE LIMITED",
"LIHA LIFE SCIENCES PRIVATE LIMITED",
"LIKEON TRADING INTERNATIONAL PRIVATE LIMITED",
"LIKEWISH VINIMAY PVT LTD",
"LIKEWIZE INDIA SHARED SERVICES LLP",
"LIKHAMI HOLDINGS LIMITED",
"LIKHITA ENERGY SYSTEMS PRIVATE LIMITED",
"LIKHITHA DIAGNOSTICS",
"LIKHITHA INFRASTRUCTURE LIMITED",
"LIKIN GEMS PRIVATE LIMITED",
"LIKITH AGRO FOODS PRIVATE LIMITED",
"LIKIZO SERVICES PRIVATE LIMITED",
"LIKO-S INDIA PRIVATE LIMITED",
"LIKU-TECH ENVIRONMENTAL SOLUTIONS INDIA PRIVATE LIMITED",
"LILA AGROTECH PRIVATE LIMITED",
"LILA FURNISHINGS PRIVATE LIMITED",
"LILA GAMES PRIVATE LIMITED",
"LILA POLYMERS PRIVATE LIMITED",
"LILA POONAWALA FOUNDATION",
"LILAC CLOUD INDIA PRIVATE LIMITED",
"LILAC FACILITY MANAGEMENT PRIVATE LIMITED",
"LILAC INSIGHTS PRIVATE LIMITED",
"LILADHAR PASOO FORWARDERS PRIVATE LIMITED",
"LILANAND MAGNESITES PRIVATE LIMITED",
"LILANAND TRADERS PRIVATE LIMITED",
"LILANAND TRADING CO. PVT LTD",
"LILARAM AND SONS (KATNI) PRIVATE LIMITED",
"LILARAM FOREX AND TRAVELS PRIVATE LIMITED",
"LILASONS ALCO BEV PRIVATE LIMITED",
"LILASONS INDUSTRIES LIMITED",
"LILASONS STEEL TUBES LIMITED",
"LILAVATI HOSPITAL",
"LILAVATI HOSPITAL AND RESEARCH CENTRE",
"LILAWATI VIDHYA MANDIR SR SEC SCHOOL",
"LILIUM ARCADE PRIVATE LIMITED",
"LILIUM COSMETICS PRIVATE LIMITED",
"LILIUM INTERNATIONAL PRIVATE LIMITED",
"LILKIS RESOURCES PRIVATE LIMITED",
"LILLOAH FLOUR MILLS PVT LTD",
"LILLY FASHIONS PRIVATE LIMITED",
"LILLY MARITIME PRIVATE LIMITED",
"LILLY WHITE LAUNDRY PRIVATE LIMITED",
"LILLY WHITES GARMENTS PRIVATE LIMITED",
"LILUAH T R G R KHEMKA HIGH SCHOOL",
"LILY ASSOCIATES PRIVATE LIIMITED",
"LILY COMMERCIAL PRIVATE LIMITED",
"LILY CONSTRUCTIONS PRIVATE LIMITED",
"LILY COOLERS PRIVATE LIMITED",
"LILY EDUCATION SOCIETY",
"LILY HOTELS PRIVATE LIMITED",
"LILY INDIA PRIVATE LIMITED",
"LILY INFRABUILD PRIVATE LIMITED",
"LILY PACKAGINGS PRIVATE LIMITED",
"LILY PACKERS PRIVATE LIMITED",
"LILY VINTRADE PRIVATE LIMITED",
"LILY WORLDWIDE PRIVATE LIMITED",
"LILYAN PHARMACEUTICALS PRIVATE LIMITED",
"LIMA ENGINEERING PRIVATE LIMITED",
"LIMAX ADVERTISING PRIVATE LIMITED",
"LIMBANI STEEL PRIVATE LIMITED",
"LIMBANI WIRES PRIVATE LIMITED",
"LIMBHORE ENGINEERING CONTRACTORS PRIVATE LIMITED",
"LIMBODI GARI BUILDCON PRIVATE LIMITED",
"LIMBUGURI TEA ESTATE PRIVATE LIMITED",
"LIMCO GLOBAL SERVICES PRIVATE LIMITED",
"LIMCO SALES CORPORATION",
"LIME CHEMICALS LIMITED",
"LIME INTERNET PRIVATE LIMITED",
"LIME LIGHT SALES PRIVATE LIMITED",
"LIME LITE ADVERTISING PRIVATE LIMITED",
"LIMEGA POWER INDIA PRIVATE LIMITED",
"LIMELIGHT COMMERCIAL PRIVATE LIMITED",
"LIMELIGHT DEALERS PVT LTD",
"LIMELIGHT LAB GROWN DIAMONDS LIMITED",
"LIMELIGHT MOTION PICTURES PRIVATE LIMITED",
"LIMELITE TRADECOM PRIVATE LIMITED",
"LIMENAPH CHEMICAL PRIVATE LIMITED",
"LIMEPROPCARE SOLUTIONS PRIVATE LIMITED",
"LIMERICK TECHNOLOGIES PRIVATE LIMITED",
"LIMITLESS CONTRACTING PRIVATE LIMITED",
"LIMITLESS INSURANCE BROKING SERVICES PRIVATE LIMITED",
"LIMITLESS STUDIO PRIVATE LIMITED",
"LIMITORQUE INDIA LIMITED",
"LIMOLINER INDIA PRIVATE LIMITED",
"LIMONICS DISTRIBUTION PRIVATE LIMITED",
"LIMRA FIRE & SECURITY PRIVATE LIMITED",
"LIMRA FOODS PRIVATE LIMITED",
"LIMRA GRAPHICS (INDIA) PRIVATE LIMITED",
"LIMRA METAL HUB PRIVATE LIMITED",
"LIMRA METALS PRIVATE LIMITED",
"LIMRA PAPER MILLS PRIVATE LIMITED",
"LIMRA SERVICES",
"LIMRA STEELS PRIVATE LIMITED",
"LIMRA TECHNOSYS PRIVATE LIMITED",
"LIMRAS ENTERPRISES PRIVATE LIMITED",
"LIMS HOSPITAL",
"LIMSON ENGINEERING PRIVATE LIMITED",
"LIMTEX AGRI UDYOG LIMITED",
"LIMTON ELECTRO OPTICS PVT LTD",
"LIMTON PVT LTD",
"LIN SCAN ADVANCED PIPELINE AND TANK SERVICES PRIVATE LIMITED",
"LINA ASHAR FOUNDATION",
"LINA MEDICAL INDIA PRIVATE LIMITED",
"LINAMAR INDIA PRIVATE LIMITED",
"LINBA TECHNO SERVICES PRIVATE LIMITED",
"LINC DIGITAL SYSTEMS PRIVATE LIMITED",
"LINC LIMITED",
"LINC RETAIL LIMITED",
"LINCE SOFT SOLUTIONS PRIVATE LIMITED",
"LINCHI SALES PRIVATE LIMITED",
"LINCHPIN ANALYTICS PRIVATE LIMITED",
"LINCO SCIENTIFIC INSTRUMENT AND CHEMICALS PVT LTD",
"LINCODE LABS INDIA PRIVATE LIMITED",
"LINCOLN DEVELOPERS PRIVATE LIMITED",
"LINCOLN EDUCATION PRIVATE LIMITED",
"LINCOLN ELECTRIC COMPANY (INDIA) PRIVATE LIMITED",
"LINCOLN ENGINEERING PRIVATE LIMITED",
"LINCOLN HELIOS INDIA LIMITED",
"LINCOLN INTERNATIONAL ADVISORS",
"LINCOLN NATIONAL CORPORATION",
"LINCOLN PHARMACEUTICALS LIMITED",
"LINCON POLYMERS PRIVATE LIMITED",
"LINDE ENGINEERING INDIA PRIVATE LIMITED",
"LINDE GLOBAL SUPPORT SERVICES PRIVATE LIMITED",
"LINDE INDIA LIMITED",
"LINDE SOUTH ASIA SERVICES PRIVATE LIMITED",
"LINDEN FOODS PRIVATE LIMITED",
"LINDEN TEXTILES PVT LTD",
"LINDER STRAPPING INDIA PRIVATE LIMITED",
"LINDEX INDIA PRIVATE LIMITED",
"LINDNER INDIA CONSTRUCTION PRIVATE LIMITED",
"LINDSAY INTERNATIONAL PRIVATE.LIMITED",
"LINDSAY TRADING CO PVT LTD",
"LINDSTROM SERVICES INDIA PRIVATE LIMITED",
"LINE & WAVE INDUSTRIES PRIVATE LIMITED",
"LINE COMMUNICATIONS PRIVATE LIMITED",
"LINE LEVEL PLUMB PRIVATE LIMITED",
"LINE O MATIC GRAPHIC INDUSTRIES",
"LINE PACKAGING INDIA PRIVATE LIMITED",
"LINEA FASHIONS INDIA PRIVATE LIMITED",
"LINEAGE HEALTHCARE LIMITED",
"LINEAGE POWER PRIVATE LIMITED",
"LINEAGE SALES PRIVATE LIMITED",
"LINEAL SERVICES PRIVATE LIMITED",
"LINEAR AND DIGITAL SYSTEMS PRIVATE LIMITED",
"LINEAR COMMERCIAL PVT.LTD.",
"LINEAR DESIGN",
"LINEAR EXPORTS PRIVATE LIMITED",
"LINEAR SYSTEMS (INDIA) PRIVATE LIMITED",
"LINEARLOOP PRIVATE LIMITED",
"LINEARMICRO SURGICAL INDIA PRIVATE LIMITED",
"LINEHAUL EXPRESS INDIA PRIVATE LIMITED",
"LINEN AND BEYOND PRIVATE LIMITED",
"LINEN ART PRIVATE LIMITED",
"LINEN ART PVT LTD¬†",
"LINEN CRAFT PRIVATE LIMITED",
"LINEN DESIGN COMPANY PRIVATE LIMITED",
"LINENCARE SOLUTIONS PRIVATE LIMITED",
"LINEPRO CONTROLS PRIVATE LIMITED",
"LINESIGHT CONSULTING PRIVATE LIMITED",
"LINETEK ENTERPRISES PRIVATE LIMITED",
"LINEUP DISTRIBUTIONS PRIVATE LIMITED",
"LINEVAN RETAIL AND TRADING PRIVATE LIMITED",
"LINEZONE CONSTRUCTION PRIVATE LIMITED",
"LINFOX LOGISTICS INDIA PRIVATE LIMITED",
"LING LIANG HIGH SCHOOL",
"LINGA AGRI TRADING AND MACHINERY PRIVATE LIMITED",
"LINGA BASIC ELEMENTS SOLUTIONS PRIVATE LIMITED",
"LINGAMANENI ESTATES & PROJECTS PRIVATE LIMITED",
"LINGARAJ BISCUITS PRIVATE LIMITED",
"LINGARAJ FLOUR MILLS PVT LTD",
"LINGARAJ GRANITIES PRIVATE LIMITED",
"LINGARAJ PIPES PRIVATE LIMITED",
"LINGARAJ STONE PRIVATE LIMITED",
"LINGAYAS INSTITUTE OF MANAGEMENT AND TECHNOLOGY",
"LINGDAO MOBILES INDIA PRIVATE LIMITED",
"LINGEL WINDOWS AND DOORS TECFHNOLOGIES PRIVATE LIMITED",
"LINGO IMPEX PRIVATE LIMITED",
"LINGRAJ CONSULTANTS PVT LTD",
"LINGRAJ FOOD PRODUCTS PRIVATE LIMITED",
"LINGRAJ STEEL AND POWER PRIVATE LIMITED",
"LINGRAJ SUPPLIERS PRIVATE LIMITED",
"LINGS FOODS PRIVATE LIMITED",
"LINGUAL CONSULTANCY SERVICES PRIVATE LIMITED",
"LINGUAL MATRIX SERVICES PRIVATE LIMITED",
"LINGUANEXT TECHNOLOGIES PRIVATE LIMITED",
"LINIT EXPORTS PRIVATE LIMITED",
"LINIT TECHNOLOGIES PRIVATE LIMITED",
"LINK - K INSURANCE BROKER COMPANY PRIVATE LIMITED",
"LINK ADMINISTRATION SERVICES PRIVATE LIMITED",
"LINK AUTOTECH PRIVATE LIMITED",
"LINK CLOTHING (INDIA ) PRIVATE LIMITED",
"LINK COMPOSITES PRIVATE LIMITED",
"LINK CONTINENT FOOD PRIVATE LIMITED",
"LINK ENTERPRISES",
"LINK IN REPS PRIVATE LIMITED",
"LINK INFORMATION TECHNOLOGY PRIVATE LIMITED",
"LINK INTIME INDIA PRIVATE LIMITED",
"LINK LOCKS PRIVATE LIMITED",
"LINK LOGISTICS MANAGEMENT PRIVATE LIMITED",
"LINK MOBILITY INDIA LLP",
"LINK MONEY CHANGERS PRIVATE LIMITED",
"LINK MULTI SHOPPERS PRIVATE LIMITED",
"LINK PHARMACHEM LIMITED",
"LINK POLYMER & CHEMTECH PRIVATE LIMITED",
"LINK ROADLINES PVT LTD",
"LINK SPHERE BEAUTY AND WELLNESS LLP",
"LINK SURGICAL PVT LTD",
"LINK TELECOM PRIVATE LIMITED",
"LINK UP TEXTILES PRIVATE LIMITED",
"LINK UTSAV HSRP PRIVATE LIMITED",
"LINK VUE SYSTEM PRIVATE LIMITED",
"LINK WELL TELESYSTEMS PRIVATE LIMITED",
"LINKAGE IT PRIVATE LIMITED",
"LINKAGE SECURITIES PRIVATE LIMITED",
"LINKAPPAREL EXPORTS PRIVATE LIMITED",
"LINKCEED CORPORATE SERVICES PRIVATE LIMITED",
"LINKCON ENGINEERING PRIVATE LIMITED",
"LINKDIGI SPACES PRIVATE LIMITED",
"LINKEDDOTS ENGINEERING SOLUTIONS PRIVATE LIMITED",
"LINKEDGE MARKETING SERVICES PRIVATE LIMITED",
"LINKEDIN LOGISTICS PARTNERS PRIVATE LIMITED",
"LINKEDIN TECHNOLOGY INFORMATION PRIVATE LIMITED",
"LINKEDTEAMS INDIA SOFTWARE PRIVATE LIMITED",
"LINKER SHELTER PRIVATE LIMITED",
"LINKERS INDIA LOGISTICS PRIVATE LIMITED",
"LINKEXPRESS LOGISTICS PRIVATE LIMITED",
"LINKFIELDS INNOVATIONS PRIVATE LIMITED",
"LINKINDIA LOGISTICS PRIVATE LIMITED",
"LINKING MINDS CONSULTING PRIVATE LIMITED",
"LINKITES INFOTECH PRIVATE LIMITED",
"LINKJET PACKAGING SOLUTIONS PRIVATE LIMITED",
"LINKMARINE LOGISTIC SERVICES PRIVATE LIMITED",
"LINKNET SOLUTIONS PRIVATE LIMITED",
"LINKPOINT RETAILS PRIVATE LIMITED",
"LINKS FIELD NETWORKS INDIA PRIVATE LIMITED",
"LINKS FORWARDERS PVT LTD",
"LINKS4ENGG INDIA PRIVATE LIMITED",
"LINKSMART TECHNOLOGIES PRIVATE LIMITED",
"LINKSOFT TECHNOLOGY SOLUTIONS LLP",
"LINKSTAR COMMODITIES PRIVATE LIMITED",
"LINKSTAR INFOSYS PRIVATE LIMITED",
"LINKSTREET LEARNING PRIVATE LIMITED",
"LINKSTURE TECHNOLOGIES PRIVATE LIMITED",
"LINKSYS COMMUNICATION PRIVATE LIMITED",
"LINKTAG GLOBAL SERVICES PRIVATE LIMITED",
"LINKTECH ENGINEERING PRIVATE LIMITED",
"LINKVIEW REALTY PRIVATE LIMITED",
"LINKWAVE TECHNOLOGIES PRIVATE LIMITED",
"LINKWELL TELESYSTEMS PRIVATE LIMITED",
"LINKWISE TIE-UP PRIVATE LIMITED",
"LINNHOFF INDIA PRIVATE LIMITED",
"LINODE HOSTING INDIA PRIVATE LIMITED",
"LINOY TECHNOLOGIES PRIVATE LIMITED",
"LINTAS CREATIVE EXECUTIONS PRIVATE LIMITED",
"LINTAS INDIA PRIVATE LIMITED",
"LINTAS PACKAGING PVT LTD",
"LINTEC INDIA PRIVATE LIMITED",
"LINTECH INFRASTRUCTURE PRIVATE LIMITED",
"LINTEUM EXIM PRIVATE LIMITED",
"LINTEX LINENS PRIVATE LIMITED",
"LINTL CLOTHING PRIVATE LIMITED",
"LINTON SOLUTION PRIVATE LIMITED",
"LINUX ADMINSTRATOR QUESS CORP PRIVATE LIMITED",
"LINUX LABORATORIES PRIVATE LIMITED",
"LINUX LEARNING CENTRE PRIVATE LIMITED",
"LINUX LIFE SCIENCES PRIVATE LIMITED",
"LINUX TILES PRIVATE LIMITED",
"LINUX WORLD INFORMATICS PRIVATE LIMITED",
"LINUXPECT PRIVATE LIMITED",
"LINVATEC INDIA PRIVATE LIMITED",
"LINXENS INDIA PRIVATE LIMITED",
"LINXON INDIA ENGINEERING PRIVATE LIMITED",
"LINXON INDIA PRIVATE LIMITED",
"LIO DISCOVERY SERVICES INDIA PRIVATE LIMITED",
"LIOHA ELECTRICS PRIVATE LIMITED",
"LIOLI CERAMICA PRIVATE LIMITED",
"LIOLINE PACKERS AND MOVERS PRIVATE LIMITED",
"LION AGRI FAB PRIVATE LIMITED",
"LION BRIDGE",
"LION DATES IMPEX PRIVATE LIMITED",
"LION ENGINEERING CONSULTANTS PRIVATE LIMITED",
"LION FABRICS PRIVATE LIMITED",
"LION FOODS PRIVATE LIMITED",
"LION HEART SECURE SOLUTIONS PRIVATE LIMITED",
"LION HEARTS SECURITY SERVICES PRIVATE LIMITED",
"LION INDIA LIMITED",
"LION INFRADEVELOPERS LLP",
"LION INSULATION PRIVATE LIMITED",
"LION MANPOWER SOLUTIONS PRIVATE LIMITED",
"LION MERCANTILE PRIVATE LIMITED",
"LION PACKAGING PVT LTD",
"LION PENCILS LIMITED",
"LION PICTURE & FRAMES (INDIA) LIMITED",
"LION RUBBER INDUSTRIES PRIVATE LIMITED",
"LION SERVICES LIMITED.",
"LION STEEL PRIVATE LIMITED",
"LION TAPES PRIVATE LIMITED",
"LION VIDYA MANDIR SEC SCHOOL",
"LIONBRIDGE TECHNOLOGIES LLP",
"LIONEL INDIA LIMITED",
"LIONEL RESOURCES PRIVATE LIMITED",
"LIONESS KARNAVATI M H HINDI HIGHER",
"LIONEX LOGISTICS PRIVATE LIMITED",
"LIONFORCE TECHNOLOGIES PRIVATE LIMITED",
"LIONIA LED INDIA PRIVATE LIMITED",
"LIONMOBILTAT POWER PRIVATE LIMITED",
"LIONS CALCUTTA GREATER VIDYA MANDIR",
"LIONS CANCER DETECTION CENTRE TRUST",
"LIONS CLUB",
"LIONS CLUB OF HYDERABAD SADHURAM EYE HOSPITAL",
"LIONS CLUBS INTERNATIONAL",
"LIONS ENGLISH SCHOOL",
"LIONS INDIA ENTERPRISES PRIVATE LIMITED",
"LIONS INDUSTRIAL SECURITY AND MANAGEMENT SERVICES PRIVATE LIMITED",
"LIONS JUHU NANDLAL JALAN MAHILA MAHAVIDYALAYA",
"LIONS MATRIC HIGHER SECONDARY SCHOOL",
"LIONS NETRA CHIKITSALAYA",
"LIONS PREMIUM SUITINGS PRIVATE LIMITED",
"LIONS VIDYA MANDIR SECONDARY SCHOOL",
"LIONS WORKFORCE SOLUTIONS INDIA PRIVATE LIMITED",
"LIONSEC & MAC ESCORTS PRIVATE LIMITED",
"LIONSGATE BREWERIES PRIVATE LIMITED",
"LIONTREE HR CONSULTANTS PRIVATE LIMITED",
"LIOTECH INDUSTRIES PRIVATE LIMITED",
"LIP FASTENERS",
"LIPAP SYSTEMS PRIVATE LIMITED",
"LIPI BOILERS PRIVATE LIMITED",
"LIPI DATA SYSTEMS LIMITED",
"LIPI EXPORTS PRIVATE LIMITED",
"LIPI INTERNATIONAL PRIVATE LIMITED",
"LIPI MARKETING PRIVATE LIMITED",
"LIPIKA GRAPHCHEM PRIVATE LIMITED",
"LIPIN EXPORTS PRIVATE LIMITED",
"LIPOMIC HEALTHCARE PRIVATE LIMITED",
"LIPPERT COMPONENTS INDIA PRIVATE LIMITED",
"LIPPI SYSTEMS LIMITED",
"LIPPON PHARMA PRIVATE LIMITED",
"LIPROTECH (OPC) PRIVATE LIMITED",
"LIPSON MACHINE TOOLS PRIVATE LIMITED",
"LIPUL CONSTRUCTIONS PRIVATE LIMITED",
"LIQUECHEM INDUSTRIES PRIVATE LIMITED",
"LIQUEE SEALS PRIVATE LIMITED",
"LIQUI FINANCE SOLUTIONS PRIVATE LIMITED",
"LIQUID GOLD CARRIERS PVT LTD",
"LIQUID HOLDINGS PRIVATE LIMITED",
"LIQUID LUCK BREWERIES PRIVATE LIMITED",
"LIQUID PAPER FINSERVE PRIVATE LIMITED",
"LIQUID PAYMENTS INDIA PRIVATE LIMITED",
"LIQUID SPACE ARCHITECTURE & DESIGN PRIVATE LIMITED",
"LIQUIDHUB ANALYTICS PRIVATE LIMITED",
"LIQUIDHUB INDIA PRIVATE LIMITED",
"LIQUIFIED GAS TRANSPORT (BOMBAY) PRIVATE LIMITED",
"LIQUIGAS POWER PRIVATE LIMITED",
"LIQUINOX GASES PRIVATE LIMITED",
"LIQUIPACK SYSTEMS PRIVATE LIMITED",
"LIQUORDOM EXPORTS PRIVATE LIMITED",
"LIQUORS INDIA LIMITED",
"LIQVD DIGITAL INDIA PRIVATE LIMITED",
"LIQVID ELEARNING SERVICES PRIVATE LIMITED",
"LIQVID ENGLISH EDGE PRIVATE LIMITED",
"LIQVIGAS INDIA LIMITED",
"LIRA CONSTRUCTIONS PRIVATE LIMITED",
"LIRADOLF INFORMATION TECHNOLOGIES AND ENGINEERING SERVICES PRIVATE LIMITED",
"LIRCO COMPOSITES PRIVATE LIMITED",
"LIRCTEK TECHNOLOGIES PRIVATE LIMITED",
"LIRICON TRADING PRIVATE LIMITED",
"LIRIK INFOTECH PRIVATE LIMITED",
"LIRIN LOGISTICS PRIVATE LIMITED",
"LIRISHA IMAGE EDITING AGENCY (OPC) PRIVATE LIMITED",
"LIRISOFT INDIA PRIVATE LIMITED",
"LIS (INDIA) CONSTRUCTION COMPANY P LTD",
"LISA AMPOULES & VIALS PRIVATE LIMITED",
"LISA FINVEST PVT LTD",
"LISA ROLLER FLOUR MILLS PVT LTD",
"LISALINE LIFESCIENCE TECHNOLOGIES PRIVATE LIMITED",
"LISAM SYSTEMS INDIA PRIVATE LIMITED",
"LISAMED TECHNOLOGIES PRIVATE LIMITED",
"LISCO SYSTEMS PRIVATE LIMITED",
"LISEGA INDIA PRIVATE LIMITED",
"LISHA ENGINEERS PRIVATE LIMITED",
"LISHBOS TECHNOLOGIES PRIVATE LIMITED",
"LISIE HOSPITAL",
"LISIEUX CMI PUBLIC SCHOOL",
"LISIEUX MATRICULATION HIGHER SECONDARY SCHOOL",
"LISO COIR TEX PRIVATE LIMITED",
"LISRAJ OVERSEAS PRIVATE LIMITED",
"LISSOM CABLES INDIA PRIVATE LIMITED",
"LISSY RUBBERS PRIVATE LIMITED",
"LIST INDIA PRIVATE LIMITED",
"LIST SOFTWARE PRIVATE LIMITED",
"LISTENLIGHTS PRIVATE LIMITED",
"LISTENUP INDIA HEARING SOLUTIONS PRIVATE LIMITED",
"LISTER MOESSNER INDIA PRIVATE LIMITED",
"LISTER PETTER INDIA PRIVATE. LIMITED",
"LISTER TECHNOLOGIES FOUNDATIONS",
"LISTER VENTURES PRIVATE LIMITED",
"LISTING OF SHRREEYAM MORANI RISE PRIVATE LIMITED",
"LIT (INDIA) PRIVATE LIMITED",
"LIT NAGPUR UNIVERSITY",
"LIT TECH ELECTRO PLAST PRIVATE LIMITED",
"LITASKI ELECTRICALS PRIVATE LIMITED",
"LITCHICA PRODUCTS PRIVATE LIMITED",
"LITCHITREE SKILLS AND SOLUTIONS PRIVATE LIMITED",
"LITE BITE FOODS TRES PRIVATE LIMITED",
"LITE BITE TRAVEL FOODS PRIVATE LIMITED",
"LITE CONTAINERS PRIVATE LIMITED",
"LITE JUNCTION PRIVATE LIMITED",
"LITE TECHNOLOGY CO PRIVATE LIMITED",
"LITECON INDUSTRIES PRIVATE LIMITED",
"LITEL INFRA-RED SYSTEMS PRIVATE LIMITED",
"LITENS AUTOMOTIVE INDIA PRIVATE LIMITED",
"LITE-ON POWER ELECTRONIC INDIA PRIVATE LIMITED",
"LITE-ON-MOBILE INDIA PRIVATE LIMITED",
"LITEPLUS PACKAGING PRIVATE LIMITED",
"LITERA TECHNOLOGIES PRIVATE LIMITED",
"LITERACY INDIA",
"LITEWEL MATCH INDUSTRIES PRIVATE LIMITED",
"LITEX PHARMACEUTICALS PRIVATE LIMITED",
"LITHASA TECHNOLOGIES PRIVATE LIMITED",
"LITHIUM URBAN TECHNOLOGIES PRIVATE LIMITED",
"LITHOP PHARMA",
"LITHOS HEALTHCARE PRIVATE LIMITED",
"LITMUS BRANDING PRIVATE LIMITED",
"LITMUS MARINE INNOVATION PRIVATE LIMITED",
"LITMUS MEROFORM EVENTS AND EXHIBITIONS PRIVATE LIMITED",
"LITMUS ORGANICS PRIVATE LIMITED",
"LITMUS SOLUTIONS PRIVATE LIMITED",
"LITMUS WORLD MARKETING TECHNOLOGIES PRIVATE LIMITED",
"LITMUS7 SYSTEMS CONSULTING PRIVATE LIMITED",
"LITOLIER FARMS PRIVATE LIMITED",
"LITOMATIC TECH PRIVATE LIMITED",
"LITRA MOTORS PRIVATE LIMITED",
"LITRATIM MICRO SPECIALITIES PVT LTD",
"LITSUN ENERGY SOLUTIONS LLP",
"LITTLE ANGELS KG",
"LITTLE ANGELS MEDICAL SERVICES PRIVATE LIMITED",
"LITTLE ANGELS NURSEY & PRIMARY SCHOOL",
"LITTLE ANGELS SCHOOL",
"LITTLE ARYANS PRE K",
"LITTLE BLOSSOM APPARELS PRIVATE LIMITED",
"LITTLE BUDS SCHOOL",
"LITTLE CARROTS INDIA PRIVATE LIMITED",
"LITTLE FAIRY PUBLIC SCHOOL",
"LITTLE FINGERS INDIA PRIVATE LIMITED",
"LITTLE FLOWER HIGH SCHOOL THANE",
"LITTLE FLOWER HIGHER SECONDARY SCHOOL",
"LITTLE FLOWER HOSPITAL PRIVATE LIMITED",
"LITTLE FLOWER JR COLLEGE",
"LITTLE FLOWER NEONATAL AND PEDIATRIC CRITICAL CARE CENTER PRIVATE LIMITED",
"LITTLE FLOWER PREPARATORY SCHOOL",
"LITTLE FLOWER SCHOOL",
"LITTLE FLOWER SCHOOL GITA VATIKA GORAKHPUR",
"LITTLE GENIUS TOYS PRIVATE LIMITED",
"LITTLE HEARTS VENTURE PRIVATE LIMITED",
"LITTLE INDIA PRIVATE LIMITED",
"LITTLE ITALY EXPRESS FOODS PRIVATE LIMITED",
"LITTLE KINGDOM NURSERY SCHOOL",
"LITTLE LACY (INDIA) PRIVATE LIMITED",
"LITTLE LAMB FILMS PRIVATE LIMITED",
"LITTLE LEARNERS PUBLICATION (INDIA) PRIVATE LIMITED",
"LITTLE LIGHTS SCHOOL",
"LITTLE LOVESHE LLP",
"LITTLE MILLENNIUM EDUCATION PRIVATE LIMITED",
"LITTLE NAP DESIGNS PRIVATE LIMITED",
"LITTLE OXFORD MATRIC HIGHER SECONDARY SCHOOL",
"LITTLE PARADISE BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"LITTLE RED ZOMBIES STUDIOS PRIVATE LIMITED",
"LITTLE RIDES INDIA PRIVATE LIMITED",
"LITTLE SCHOLARZ PRIVATE LIMITED",
"LITTLE STAR ENGLISH HIGH SCHOOL",
"LITTLE STAR ENGLISH PRIMARY SCHOOL",
"LITTLE STAR ENGLISH SCHOOL WADALA TQ JAFRABAD DIST JALNA",
"LITTLE STAR FOODS PRIVATE LIMITED",
"LITTLE STEPS SCHOOL",
"LITTLEBEE BABY CARE PRODUCTS PRIVATE LIMITED",
"LITTLEMOPPET FOODS (OPC) PRIVATE LIMITED",
"LITTLES AGRIVET PRIVATE LIMITED",
"LITTLE'S GARMENTS PRIVATE LIMITED",
"LITTLESTAR DEALMARK PRIVATE LIMITED",
"LITTLESTAR PROJECTS PRIVATE LIMITED",
"LITTLESTAR VANIJYA PRIVATE LIMITED",
"LITURA ELECTRICAL TECHNOLOGIES PRIVATE LIMITED",
"LITWEL INDIA LIMITED",
"LIUGONG INDIA PRIVATE LIMITED",
"LIV LONG NUTRACEUTICALS LIMITED",
"LIVANOVA INDIA PRIVATE LIMITED",
"LIVANTO CERAMIC PRIVATE LIMITED",
"LIVARES TECHNOLOGIES PRIVATE LIMITED",
"LIVBLENDS AND SFG HOSPITALITY PRIVATE LIMITED",
"LIVE CONNECTIONS PLACEMENTS PRIVATE LIMITED",
"LIVE CONNECTIONS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"LIVE DATA VISUALISATION PRIVATE LIMITED",
"LIVE DEFTSOFT INFORMATICS PRIVATE LIMITED",
"LIVE INDIATOUR PRIVATE LIMITED",
"LIVE MEDIA AND PUBLISHERS PRIVATE LIMITED",
"LIVE NATURAL FOODS PRIVATE LIMITED",
"LIVE OAK RESORTS PRIVATE LIMITED",
"LIVE ORGANIC",
"LIVE SPORTS365 PRIVATE LIMITED",
"LIVE WIRES ADVERTISING PRIVATE LIMITED",
"LIVEALTH BIOPHARMA PRIVATE LIMITED",
"LIVEBIRD TECHNOLOGIES PRIVATE LIMITED",
"LIVEC STAFFING SERVICES PRIVATE LIMITED",
"LIVECHEK PRIVATE LIMITED",
"LIVECITY CERAMIC PRIVATE LIMITED",
"LIVEDIGITAL MARKETING SOLUTIONS PRIVATE LIMITED",
"LIVEFIBRE CONNECT PRIVATE LIMITED",
"LIVEKEEPING TECHNOLOGIES PRIVATE LIMITED",
"LIVEKETO PRIVATE LIMITED",
"LIVELIHOOD SYSTEM",
"LIVELIKE SPORTS TECHNOLOGIES INDIA PRIVATE LIMITED",
"LIVENUTRIFIT HEALTHTECH PRIVATE LIMITED",
"LIVEON BIOLABS PRIVATE LIMITED",
"LIVEON TECHNOLABS PRIVATE LIMITED",
"LIVEPIXEL TECHNOLOGIES LLP",
"LIVEPOOLS PRIVATE LIMITED",
"LIVERAMP INDIA PRIVATE LIMITED",
"LIVERBIRD INTERNATIONAL PRIVATE LIMITED",
"LIVERLEAF TRADING PRIVATE LIMITED",
"LIVESHAALA EDUCATION PRIVATE LIMITED",
"LIVESMART LIFESCIENCES PRIVATE LIMITED",
"LIVESPACE INTERIORS PRIVATE LIMITED",
"LIVESTOCK SOLUTIONS PRIVATE LIMITED",
"LIVESTONE CERAMIC PRIVATE LIMITED",
"LIVESTREAM INFRA TECHNOLOGIES PRIVATE LIMITED",
"LIVESTRONG HEALTH & FITNESS PRIVATE LIMITED",
"LIVEVOX SOLUTIONS PRIVATE LIMITED",
"LIVEWEAVER INDIA PRIVATE LIMITED",
"LIVEWELL PROJECTS INDIA LIMITED",
"LIVEXPERT TECHNOLOGIES PRIVATE LIMITED",
"LIVFAST BATTERIES PRIVATE LIMITED",
"LIVFIN INDIA PRIVATE LIMITED",
"LIVFUTURE AUTOMATION & SECURITY PRIVATE LIMITED",
"LIVGREEN CLEANTECH PRIVATE LIMITED",
"LIVGUARD BATTERIES PRIVATE LIMITED",
"LIVGUARD DRIVETRAIN PRIVATE LIMITED",
"LIVGUARD ENERGY TECHNOLOGIES PRIVATE LIMITED",
"LIVHOUSING E-SERVICES PRIVATE LIMITED",
"LIVIA INDIA LIMITED",
"LIVIA POLYMER PRODUCTS PRIVATE LIMITED",
"LIVIA SPACES (INDIA) PRIVATE LIMITED",
"LIVIDUS PHARMACEUTICALS PRIVATE LIMITED",
"LIVIK STEEL IMPEX PRIVATE LIMITED",
"LIVIN PRODUCTS PRIVATE LIMITED",
"LIVIN SOURCES INDIA PRIVATE LIMITED",
"LIVINDIA INFRA PRIVATE LIMITED",
"LIVING AUDIO PRIVATE LIMITED",
"LIVING AVENUE FURNITURE AND INTERIORS INDIA PRIVATE LIMITED",
"LIVING CENTURY TEXTILES PRIVATE LIMITED",
"LIVING COMMERCE SPACE PRIVATE LIMITED",
"LIVING CONSUMER PRODUCTS PRIVATE LIMITED",
"LIVING CREATIONS PRIVATE LIMITED",
"LIVING DESIGN PRIVATE LIMITED",
"LIVING FOODS INDIA PRIVATE LIMITED",
"LIVING HEALTHY 24 HEALTHCARE PRIVATE LIMITED",
"LIVING LIFESTYLE PRIVATE LIMITED",
"LIVING LIQUIDZ SPIRITS AND SPORTS BAR PRIVATE LIMITED",
"LIVING MEDIA INDIA LIMITED",
"LIVING SEEDS TECHNOLOGY",
"LIVING WATEREFINE TECHNOLOGIES PRIVATE LIMITED",
"LIVINGFOODCO PRIVATE LIMITED",
"LIVINGPOINT SALES PRIVATE LIMITED",
"LIVINGROOM LIFESTYLES PRIVATE LIMITED",
"LIVINGSTON INTERNATIONAL INDIA PRIVATE LIMITED",
"LIVINGSTONE HEALTH CARE SERVICES PRIVATELIMITED",
"LIVINGSTONES",
"LIVINGSTONES JEWELLERY PRIVATE LIMITED",
"LIVINGUARD TECHNOLOGIES PRIVATE LIMITED",
"LIVINGWARE HOME FASHION PRIVATE LIMITED",
"LIVINIA FOODS INDIA PRIVATE LIMITED",
"LIVINT TECHNOLOGIES PRIVATE LIMITED",
"LIVIYA INTERNATIONAL PRIVATE LIMITED",
"LIVLIFE HOSPITALS PRIVATE LIMITED",
"LIVLONG INSURANCE BROKERS LIMITED",
"LIVLONG PROTECTION & WELLNESS SOLUTIONS LIMITED",
"LIVNEST TECHNOLOGIES PRIVATE LIMITED",
"LIVNSENSE TECHNOLOGIES PRIVATE LIMITED",
"LIVO PRODUCTS INDIA PRIVATE LIMITED",
"LIVON INDUSTRIES PRIVATE LIMITED",
"LIVON PAINTS PRIVATE LIMITED",
"LIVONTA GLOBAL PRIVATE LIMITED",
"LIVPURE PRIVATE LIMITED",
"LIVPURE SMART HOMES PRIVATE LIMITED",
"LIVQUIK TECHNOLOGY (INDIA) PRIVATE LIMITED",
"LIVSCIENCE TECHNOLOGIES PRIVATE LIMITED",
"LIVSOL INNOVATIONS PRIVATE LIMITED",
"LIWAYWAY FOODS INDIA PRIVATE LIMITED",
"LIXEL STATIONERIES PRIVATE LIMITED",
"LIXIL INDIA PRIVATE LIMITED",
"LIXIL INDIA SANITARYWARE PRIVATE LIMITED",
"LIXIL WINDOW SYSTEMS PRIVATE LIMITED",
"LIYA INFRATECH PRIVATE LIMITED",
"LIYAANA AD WORLD",
"LIYAKAT ALI HEDAR ALI TRADING COMPANY PRIVATE LIMITED",
"LIYANA LOGISTICS PRIVATE LIMITED",
"LIYANS COMMERCE PRIVATE LIMITED",
"LIZ CLAIBORNE INTERNATINAL LIMITED",
"LIZA CLOTHING AND APPARELS PRIVATE LIMITED",
"LIZER CYLINDERS LIMITED",
"LIZMONTAGENS INDIA PRIVATE LIMITED",
"LJ FILMS PRIVATE LIMITED",
"LJ INSTITUTE OF ENGINEERING AND TECHNOLOGY",
"LJP PRIVATE LIMITED",
"LJTANNA ENTERPRISES PRIVATE LIMITED",
"LJ-VICTORIA PROPERTIES PRIVATE LIMITED",
"LK AUTOCOMPONENTS PRIVATE LIMITED",
"LK OVERSEAS PRIVATE LIMITED",
"LK PROJECTS PRIVATE LIMITED",
"LK TEXTILES PRIVATE LIMITED",
"LKART LOGI TECH SOLUTIONS PRIVATE LIMITED",
"LKB ENGINEERING PRIVATE LIMITED",
"LKB SOLUTIONS PRIVATE LIMITED",
"LKC COATINGS PRIVATE LIMITED",
"LKC INDUSTRIES AND INFRA PRIVATE LIMITED",
"LKC LOGISTICS PRIVATE LIMITED",
"LKC MOULDING SOLUTIONS PRIVATE LIMITED",
"LKESULAL INTERNATIONAL PRIVATE LIMITED",
"LKG FOREX LIMITED",
"LKG INFOSOLUTIONS PRIVATE LIMITED",
"LKLS PRIVATE LIMITED",
"LKN FOREX PRIVATE LIMITED",
"LKN LIFE STYYLE INDIA PRIVATE LIMITED",
"LKO CEMENT PRIVATE LIMITED",
"LKOASSOCIATES PRIVATE LIMITED",
"LKP FINANCE LIMITED",
"LKP SECURITIES LIMITED",
"LKQ INDIA PRIVATE LIMITED",
"LKS HOME MAKING SOLUTION PRIVATE LIMITED",
"LKS IMPEX PRIVATE LIMITED",
"LLAMA LOGISOL PRIVATE LIMITED",
"LLAMADAS INFO SOLUTIONS PRIVATE LIMITED",
"L-LIGHT INNOTECH PRIVATE LIMITED",
"LLM APPLIANCES PRIVATE LIMITED",
"LLOYD HEALTHCARE PRIVATE LIMITED",
"LLOYD INSULATIONS (INDIA) LIMITED",
"LLOYD LABORATORIES PRIVATE LIMITED",
"LLOYD LAW COLLEGE",
"LLOYD SHOES INDIA PRIVATE LIMITED",
"LLOYDS BUSINESS VENTURES PRIVATE LIMITED",
"LLOYDS ENGINEERING CORPORATION PRIVATE LIMITED",
"LLOYDS ENGINEERING WORKS LIMITED",
"LLOYDS LOGISTICS PRIVATE LIMITED",
"LLOYDS LUXURIES LIMITED",
"LLOYDS MEDICAL SOLUTIONS PRIVATE LIMITED",
"LLOYDS METALS AND ENERGY LIMITED",
"LLOYDS OFFSHORE GLOBAL SERVICES PRIVATE LIMITED",
"LRQA LIMITED",
"LLT FASHIONS PRIVATE LIMITED",
"LM AUTOCARS PRIVATE LIMITED",
"LM AUTOMOTIVE INDIA PRIVATE LIMITED",
"LM CARS PRIVATE LIIMITED",
"LM COTEX PRIVATE LIMITED",
"LM ENERGY AND SOFTWARE PRIVATE LIMITED",
"LM INDUSTRIAL SOLUTIONS PRIVATE LIMITED",
"LM LIFESTYLE INDIA PRIVATE LIMITED",
"LM MANUFACTURING INDIA PRIVATE LIMITED",
"LM POWER AND INDUSTRIAL SOLUTIONS PRIVATE LIMITED",
"LM WIND POWER BLADES INDIA PRIVATE LIMITED",
"LM WIND POWER TECHNOLOGIES INDIA PRIVATE LIMITED",
"LMC AUTOMOTIVE COMPANY PRIVATE LIMITED",
"LMC CONSULTANTS PRIVATE LIMITED",
"LMC ENTERPRISES PRIVATE LIMITED",
"LMC FORCE PRIVATE LIMITED",
"LMC GLOBAL PRIVATE LIMITED",
"LMC MOTOR COMPANY PRIVATE LIMITED",
"LMCS INFRA HOLDINGS PRIVATE LIMITED",
"LMCS MARITIME PRIVATE LIMITED",
"LMD CONTROL AND AUTOMATION PRIVATE LIMITED",
"LMD HITECH INDIA PRIVATE LIMITED",
"LMG CONSULTING SERVICES INDIA PRIVATE LIMITED",
"LMI (INDIA) PRIVATE LIMITED",
"LMI TRUST",
"LMMFS MAI MANGESHKAR HOSPITAL",
"LMR HOSPITALS PRIVATE LIMITED",
"LMR OILS PRIVATE LIMITED",
"LMS SOLUTIONS INDIA PRIVATE LIMITED",
"LMT INDIA PRIVATE LIMITED",
"LMT TOOLS INDIA PRIVATE LIMITED",
"LMTEC INDIA CONSULTING SERVICES PRIVATE LIMITED",
"LMV FINANCIALSERVICES PRIVATE LIMITED",
"LMV INSURANCE BROKING SERVICES PRIVATE LIMITED",
"LMV IT SOLUTIONS PRIVATE LIMITED",
"LMVAN MOPPES DIAMOND TOOLS INDIA PRIVATE LIMITED",
"LN AGRO PRODUCTS PRIVATE LIMITED",
"LN DIGITAL PRIVATE LIMITED",
"LN GOENKA AGRO FOODS PRIVATE LIMITED",
"LN GUPTA COLLEGE OF SCIENCE",
"LN INFRAPROJECTS PRIVATE LIMITED",
"LN OUTSOURCES PRIVATE LIMITED",
"LN PETROCHEM PRIVATE LIMITED",
"LN SYSTEMS PRIVATE LIMITED",
"LN TOOLS PRIVATE LIMITED",
"LN WEBWORKS PRIVATE LIMITED",
"LN WELINGKAR INSTITUTE OF MANAGEMENT DE",
"LNA INFRAPROJECTS PRIVATE LIMITED",
"LNAR ASSOCIATES PRIVATE LIMITED",
"LNB CONSTRUCTIONS PRIVATE LIMITED",
"LNB PAPER PACKAGING PRIVATE LIMITED",
"LNB RENEWABLE ENERGY LIMITED",
"LNB RENEWABLE ENERGY PRIVATE LIMITED",
"LNB SOLAR ENERGY PRIVATE LIMITED",
"LNCT EDUCATION FOUNDATION",
"LNCT MEDICAL COLLEGE & SEWAKUNJ HOSPITAL INDORE",
"LNCT UNIVERSITY",
"LNG ACCESSORIES PRIVATE LIMITED",
"LNG AGRICOM PRIVATE LIMITED",
"LNG FOUNDATION",
"LNJ INSTITUTE OF SKILLS & TECHNOLOGY PRIVATE LIMITED",
"LNJ POLYMERS PRIVATE LIMITED",
"LNJ POWER VENTURES LIMITED",
"LNJ REALTY PRIVATE LIMITED",
"LNJ SKILLS & ROZGAR PRIVATE LIMITED",
"LNM AUTO INDUSTRIES PRIVATE LIMITED",
"LNM ENTERPRISES PRIVATE LIMITED",
"LNM TECHNOLOGIES PRIVATE LIMITED",
"LNPR ENTERPRISES INDIA PRIVATE LIMITED",
"LNRD AGROCOM PRIVATE LIMITED",
"LNS AGRIWORLD PRIVATE LIMITED",
"LNS PLY BOARDS PRIVATE LIMITED",
"LNSK GREENHOUSE AGRO PRODUCTS LLP",
"LNT TRAVELS PRIVATE LIMITED",
"LNV DIGITAL SYSTEMS PRIVATE LIMITED",
"LNV TECHNOLOGY PRIVATE LIMITED",
"LNW INDIA SOLUTIONS PRIVATE LIMITED",
"LO&BEHOLD STORAGE SOLUTIONS PRIVATE LIMITED",
"LOAD CONTROLS INDIA PRIVATE LIMITED",
"LOAD STAR OVERSEAS PRIVATE LIMITED",
"LOADSTAR EQUIPMENT PRIVATE LTD",
"LOAN DARBAR FINANCIAL SERVICES PRIVATE LIMITED",
"LOANQUBES FINANCIAL SERVICES PRIVATE LIMITED",
"LOANTAP CREDIT PRODUCTS PRIVATE LIMITED",
"LOANTAP FINANCIAL TECHNOLOGIES PRIVATE LIMITED",
"LOANZEN FINANCE PRIVATE LIMITED",
"LOBA CHEMIE PRIVATE LIMITED",
"LOBAN MEDITECH PRIVATE LIMITED",
"LOBHCHAND MANGILAL CHADDARWALA PRIVATE LIMITED",
"LOBO BUSINESS CONSULTANTS PRIVATE LIMITED",
"LOBO STAFFING SOLUTIONS PRIVATE LIMITED",
"LOBOTUS TECHNOLOGY PRIVATE LIMITED",
"LOC INFORMATIC PRIVATE LIMITED",
"LOCAL AUDIT DEPARTMENT",
"LOCAL AUDIT FUND DEPARTMENT",
"LOCALCIRCLES INDIA PRIVATE LIMITED",
"LOCANIX PRIVATE LIMITED",
"LOCATION 2 LOCATIONS INTL PRIVATE LIMITED",
"LOCATION GURU SOLUTIONS PRIVATE LIMITED",
"LOCCIONI INDIA PRIVATE LIMITED",
"L'OCCITANE INDIA PRIVATE LIMITED",
"LOCERO CERAMIC PRIVATE LIMITED",
"LOCGFX PRIVATE LIMITED",
"LOCHAN TEA LIMITED",
"LOCHANA TRADING AND SERVICES PRIVATE LIMITED",
"LOCK AND KEY FASTNERS PRIVATE LIMITED",
"LOCK MASTER INDIA PRIVATE LIMITED",
"LOCKGATE SHIPPING PRIVATE LIMITED",
"LOCKHEED MARTIN CORPORATION",
"LOCKSMITHS INDUSTRIES PRIVATE LIMITED",
"LOCKSTEP NETWORK INDIA PRIVATE LIMITED",
"LOCKSWORTH INFRASTRUCTURE LIMITED",
"LOCKTITE INDIA PRIVATE LIMITED",
"LOCKWELL INDUSTRIES",
"LOCO DESIGN PRIVATE LIMITED",
"LOCOBUZZ SOLUTIONS PRIVATE LIMITED",
"LOCODEL SOLUTIONS PRIVATE LIMITED",
"LOCOFEAST PRIVATE LIMITED",
"LOCONAV INDIA PRIVATE LIMITED",
"LOCUS FIRE & SECURITY INDIA PRIVATE LIMITED",
"LOCUS HEALTHCARE PRIVATE LIMITED",
"LOCUS INDIA FINANCIAL ADVISORS PRIVATE LIMITED",
"LOCUS IT SERVICES PRIVATE LIMITED",
"LOCUS MACHINE TOOLS PRIVATE LIMITED",
"LOCUZ ENTERPRISE SOLUTIONS LIMITED",
"LODESTAR CONTAINER LINES PRIVATE LIMITED",
"LODESTAR INNOVATIONS PRIVATE LIMITED",
"LODESTAR MARITIME PRIVATE LIMITED",
"LODESTAR PRECIOUS JEWELS PRIVATE LIMITED",
"LODESTONE SOFTWARE SERVICES PRIVATE LIMITED",
"LODHA & COMPANY PRIVATE. LIMITED",
"LODHA BUILDCON PRIVATE. LIMITED.",
"LODHA CAPITAL MARKETS LTD",
"LODHA GROUP - LODHA PRANIK LANDMARK DEVELOPERS PRIVATE. LIMITED.",
"LODHA GROUP - SURYAKRUPA FARMS AND CONSTRUCTION PRIVATE. LIMITED.",
"LODHA HEALTHY CONSTRUCTION AND DEVELOPERS PRIVATE. LIMITED.",
"LODHA JEWELLERY EXPORTS INDIA PRIVATE LIMITED",
"LODHA SIT PRIVATE LIMITED",
"LODHA SUPREMUS",
"LODHA VENTURES HOLDINGS PRIVATE LIMITED",
"LODHA WORLD SCHOOL",
"LODHI AIR TOUR AND TRAVELS PRIVATE LIMITED",
"LODHI CALCIUM PRODUCTS PVT LTD",
"LODHI PROPERTY COMPANY LIMITED",
"LODHI RAJPOOT ICE AND COLD STORAGE PRIVATE LIMITED",
"LODZ DENIM PRIVATE LIMITED",
"LOESCHE ENERGY SYSTEMS INDIA PRIVATE LIMITED",
"LOESCHE INDIA PRIVATE LIMITED",
"LOESER ARM INDIA PRIVATE LIMITED",
"LOFT FURNITURE DESIGN PRIVATE LIMITED",
"LOFTEN INDIA PRIVATE LIMITED",
"LOFTIL AUTOMATION PVT LTD",
"LOFTY ADVERTISEMENT PRIVATE LIMITED",
"LOFTY LABORATORIES PRIVATE LIMITED",
"LOFTY TECHNOLOGIES PRIVATE LIMITED",
"LOFTY TRIP PRIVATE LIMITED",
"LOG 9 MATERIALS SCIENTIFIC PRIVATE LIMITED",
"LOG 9 MOBILITY PRIVATE LIMITED",
"LOG ON LOGISTICS INDIA PRIVATE LIMITED",
"LOG WOOD IMPORTS AND EXPORTS PRIVATE LIMITED",
"LOGAN ADVISORS PRIVATE LIMITED",
"LOGAN MINERALS PRIVATE LIMITED",
"LOGARHYTHM CONSULTANCY PRIVATE LIMITED",
"LOGART CERAMIC PRIVATE LIMITED",
"LOGASS INDUSTRIES PRIVATE LIMITED",
"LOGASSADIVINE PRIVATE LIMITED",
"LOGELITE PRIVATE LIMITED",
"LOGENIX LOGISTICS INDIA PRIVATE LIMITED",
"LOGENIX SERVICES PRIVATE LIMITED",
"LOG-FREIGHT MUMBAI PRIVATE LIMITED",
"LOGGERHEADS COMMUNICATIONS PRIVATE LIMITED",
"LOGGERS INDIA PRIVATE LIMITED",
"LOGHORN INDUSTRIES PRIVATE LIMITED",
"LOGIC ERP SALES PRIVATE LIMITED",
"LOGIC ERP SOLUTIONS PRIVATE LIMITED",
"LOGIC FACTOR INDIA PRIVATE LIMITED",
"LOGIC FRUIT TECHNOLOGIES PRIVATE LIMITED",
"LOGIC HEART PRIVATE LIMITED",
"LOGIC INFORMATION SYSTEMS (INDIA) PRIVATE LIMITED",
"LOGIC LABS INFOTRONICS LIMITED",
"LOGIC MINING & CONSTRUCTIONS PRIVATE LIMITED",
"LOGIC SOFTWARE SOLUTIONS PRIVATE LIMITED",
"LOGIC SYSTECH PRIVATE LIMITED",
"LOGICA ENGINEERING & MANUFACTURING INDIA PRIVATE LIMITED",
"LOGICA SYSTEMS & PERIPHERALS PRIVATE LIMITED",
"LOGICAD SOLUTIONS PRIVATE LIMITED",
"LOGICAL AGRI BUSINESS INDIA PRIVATE LIMITED",
"LOGICAL DNA IT SOLUTION PRIVATE LIMITED",
"LOGICAL SOLUTIONS LIMITED",
"LOGICAL STEPS INTERACTIVE SOLUTIONS PRIVATE LIMITED",
"LOGICAL WINGS INFOWEB PRIVATE LIMITED",
"LOGICANGLE PRIVATE LIMITED",
"LOGICAPT INFORMATICS PRIVATE LIMITED",
"LOGICARE HEALTH SOLUTIONS PRIVATE LIMITED",
"LOGICASH SOLUTIONS PRIVATE LIMITED",
"LOGICBOX INDIA PRIVATE LIMITED",
"LOGICGO INFOTECH LLP",
"LOGICHIVE SOLUTIONS PRIVATE LIMITED",
"LOGICIEL SOLUTIONS PRIVATE LIMITED",
"LOGICLADDER TECHNOLOGIES PRIVATE LIMITED",
"LOGICLOOP VENTURES LLP",
"LOGICMATTER INDIA PRIVATE LIMITED",
"LOGICMO SYSTEMS PRIVATE LIMITED",
"LOGICMONITOR INDIA LLP",
"LOGICNEXT SOFTWARES & SERVICES PRIVATE LIMITED",
"LOGICON ALTERNATE FUELS PRIVATE LIMITED",
"LOGICON ENGINEERS PRIVATE LIMITED",
"LOGICON FACILITY MANAGEMENT PRIVATE LIMITED",
"LOGICON SERVICES LLP",
"LOGICON TECHNOSOLUTIONS PRIVATE LIMITED",
"LOGICOY SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"LOGICPLANET IT SERVICES INDIA PRIVATE LIMITED",
"LOGICRAIN TECHNOLOGIES PRIVATE LIMITED",
"LOGICRAYS TECHNOLOGIES PRIVATE LIMITED",
"LOGICS POWERAMR PRIVATE LIMITED",
"LOGICSERVE DIGITAL PRIVATE LIMITED",
"LOGICSOFT E-SOLUTIONS PRIVATE LIMITED",
"LOGICSOFT INDIA PRIVATE LIMITED",
"LOGICSOFT INTERNATIONAL PRIVATE LIMITED",
"LOGICSPICE CONSULTANCY PRIVATE LIMITED",
"LOGICSQUARE TECHNOLOGIES PRIVATE LIMITED",
"LOGICTECH SOLAR AND AUTOMATION PRIVATE LIMITED",
"LOGICTREE INVESTMENT ADVISERS PRIVATE LIMITED",
"LOGICTREE IT SOLUTIONS PRIVATE LIMITED",
"LOGICVALLEY TECHNOLOGIES PRIVATE LIMITED",
"LOGIDOTS TECHNOLOGIES PRIVATE LIMITED",
"LOGIFY CARGO SERVICES PRIVATE LIMITED",
"LOGIKA SYSTEMS INDIA PRIVATE LIMITED",
"LOGIKOOF TECHNOLOGIES PRIVATE LIMITED",
"LOGIKVIEW ANALYTICS PRIVATE LIMITED",
"LOGILINK INDIA PRIVATE LIMITED",
"LOGILITY SOLUTIONS PRIVATE LIMITED",
"LOGIMATIX CONSULTANTS PRIVATE LIMITED",
"LOGIMED PHARMA PRIVATE LIMITED",
"LOGIMETRIX TECHSOLUTIONS PRIVATE LIMITED",
"LOGIN INFOTECH PRIVATE LIMITED",
"LOGIN INFOWAY INDIA PRIVATE LIMITED",
"LOGINEXT SOLUTIONS PRIVATE LIMITED",
"LOGINN HOSPITALITY LIMITED",
"LOGINOMIC TECH SOLUTIONS PRIVATE LIMITED",
"LOGINSOFT PRIVATE LIMITED",
"LOGIOLOGY SOLUTIONS PRIVATE LIMITED",
"LOGIQ EMBEDDED SYSTEMS INDIA PRIVATE LIMITED",
"LOGIQ HEALTHCARE SERVICES PRIVATE LIMITED",
"LOGIQ LABS PRIVATE LIMITED",
"LOGIQAI SOFTWARE INDIA PRIVATE LIMITED",
"LOGIQUAD SOLUTIONS PRIVATE LIMITED",
"LOGIS TECH INDIA PRIVATE LIMITED",
"LOGISALL INDIA PRIVATE LIMITED",
"LOGISOFT IT SERVICES PRIVATE LIMITED",
"LOGISOFTWARE INDIA PRIVATE LIMITED",
"LOGISPRINT SOLUTIONS PRIVATE LIMITED",
"LOGISTIC ENTERPRISES PRIVATE LIMITED",
"LOGISTIC INFOTECH PRIVATE LIMITED",
"LOGISTIC INTEGRATORS (I) PRIVATE LIMITED",
"LOGISTIC LINKAGE INDIA PRIVATE LIMITED",
"LOGISTIC MARITIME SERVICES LLP",
"LOGISTIC TRANSPORT OF INDIA PRIVATE LIMITED",
"LOGISTICS COMPANION INDIA PRIVATE LIMITED",
"LOGISTICS EXPEDITORS INDIA PRIVATE LIMITED",
"LOGISTICS PARK (INDIA) PRIVATE LIMITED",
"LOGISTICS PLUS INDIA PRIVATE LIMITED",
"LOGISTICSNOW PRIVATE LIMITED",
"LOGISTIMO INDIA PRIVATE LIMITED",
"LOGISTIXIAN TECHNOLOGIES PRIVATE LIMITED",
"LOGITECH ENGINEERING & DESIGNS INDIA PRIVATE LIMITED",
"LOGITECH MANAGEMENT CONSULTANCY PRIVATE LIMITED",
"LOGITECH TRADING PRIVATE LIMITED",
"LOGITEL NETWORKS PRIVATE LIMITED",
"LOGITRADE BPO SOLUTIONS PRIVATE LIMITED",
"LOGITRAIL SUPPLY CHAIN PRIVATE LIMITED",
"LOGITRANS TECHNOLOGY PRIVATE LIMITED",
"LOGITRUST CUSTOMS SERVICES PRIVATE LIMITED",
"LOGITRUST EXPRESS PRIVATE LIMITED",
"LOGITRUST VOYAGES PRIVATE LIMITED",
"LOGIVIA LOGISTICS SOLUTIONS PRIVATE LIMITED",
"LOGIWARE INDIA PRIVATE LIMITED",
"LOGIWIZ LOGISTICS INDIA PRIVATE LIMITED",
"LOGIX BUILT UPTECH",
"LOGIX DISTRIBUTORS PRIVATE LIMITED",
"LOGIX FOX PRIVATE LIMITED",
"LOGIX HEIGHTS PRIVATE LIMITED",
"LOGIX INFOSOFT PRIVATE LIMITED.",
"LOGIX ITS INDIA LLP",
"LOGIX NET SOLUTIONS PRIVATE LIMITED",
"LOGIX SOFT-TEL PRIVATE LIMITED",
"LOGIXAL CLOUD SOLUTIONS LLP",
"LOGIXAL SOLUTIONS PRIVATE LIMITED",
"LOGIXGRID TECHNOLOGIES PRIVATE LIMITED",
"LOGIXHEALTH SOLUTIONS PRIVATE LIMITED",
"LOGIXKART PRIVATE LIMITED",
"LOGLABS VENTURES PRIVATE LIMITED",
"LOGLINE PRODUCTION PRIVATE LIMITED",
"LOGMEIN INDIA PRIVATE LIMITED",
"LOGO FASHION TEXTILES PRIVATE LIMITED",
"LOGOMAN ENERGY PRIVATE LIMITED",
"LOGON INDIA INFRASTRUCTURE PRIVATE LIMITED",
"LOGON SOFTWARE INDIA PRIVATE LIMITED",
"LOGOS FOODS PRIVATE LIMITED",
"LOGOS LOGISTICS PRIVATE LIMITED",
"LOGOSOUK MERCES PRIVATE LIMITED",
"LOGOTECH CLOTHING PRIVATE LIMITED",
"LOGSKIM SOLUTIONS PRIVATE LIMITED",
"LOGSTAR ERP INDIA PRIVATE LIMITED",
"LOGTECH INFOWAY PRIVATE LIMITED",
"LOGTECH LOGISTICS AND SYSTEMS PRIVATE LIMITED",
"LOGUS ADVISORY SERVICES PRIVATE LIMITED",
"LOGUS BUSINESS SYSTEMS INDIA PRIVATE LIMITED",
"LOGUS REALTY PRIVATE LIMITED",
"LOGVITE SOLUTIONS PRIVATE LIMITED",
"LOGWELL FORGE LIMITED",
"LOGWELL LOGISTICS AND AVIATION SERVICES (OPC) PRIVATE LIMITED",
"LOGWIN AIR & OCEAN INDIA PRIVATE LIMITED",
"LOGWOOD VINIMAY PRIVATE LIMITED",
"LOHA LIVE JUNCTION PRIVATE LIMITED",
"LOHA NANDED WARANGA HIGHWAYS PRIVATE LIMITED",
"LOHAAR ENGINEERING AND CONSTRUCTION PRIVATE LIMITED",
"LOHAGARH RESORTS PRIVATE LIMITED",
"LOHAGIRI INDUSTRIALS PRIVATE LIMITED",
"LOHAJA BUSINESS PRIVATE LIMITED",
"LOHAKA INDUSTRIES PRIVATE LIMITED",
"LOHANA STEEL PRIVATE LIMITED",
"LOHANAS TOURS PRIVATE LIMITED",
"LOHARDAGA RICE MILL PRIVATE LIMITED",
"LOHARU INFRASTRUCTURES PRIVATE LIMITED",
"LOHARUKA INFRASTRUCTURE PRIVATE LIMITED",
"LOHCHAB AUTOCAR PRIVATE LIMITED",
"LOHCHAB MOTOR COMPANY PRIVATE LIMITED",
"LOHCHABKRISHNA MOTORS PRIVATE LIMITED",
"LOHIA ALLOYS LIMITED",
"LOHIA ASSOCIATES PVT LTD",
"LOHIA AUTO INDUSTRIES",
"LOHIA BRASS PRIVATE LIMITED",
"LOHIA CONSTRUCTIONS PVT LTD",
"LOHIA DEVELOPERS INDIA PRIVATE LIMITED",
"LOHIA FILAMENT MACHINES LIMITED",
"LOHIA FOODS PRIVATE LIMITED",
"LOHIA GLOBAL SOLUTIONS PRIVATE LIMITED",
"LOHIA HOLDINGS PVT. LTD.",
"LOHIA INDUSTRIES (TEXTILES) PVT. LTD.",
"LOHIA IRONS PRIVATE LIMITED",
"LOHIA JUTE PRESS PVT LTD",
"LOHIA MECHATRONIK PRIVATE LIMITED",
"LOHIA MINE CHEM PRIVATE LIMITED",
"LOHIA NETWORKS PRIVATE LIMITED",
"LOHIA PAPER AND BOARD PRIVATE LIMITED",
"LOHIA SECURITIES LIMITED",
"LOHIA WAREHOUSE PRIVATE LIMITED",
"LOHIND STEELS PRIVATE LIMITED",
"LOHIT TEA PVT LTD",
"LOHITHA LIFESCIENCES PRIVATE LIMITED",
"LOHIYA AGROTECH INDIA PRIVATE LIMITED",
"LOHIYA BANQUETS PRIVATE LIMITED",
"LOHIYA DEVELOPERS",
"LOHIYA EDIBLE OILS PRIVATE LIMITED",
"LOHIYA INDUSTRIES",
"LOHMANN ADHESIVE TAPES INDIA PRIVATE LIMITED",
"LOHMOD TECH. PRIVATE LIMITED",
"LOHPATH RAIL TECHNOLOGIES PRIVATE LIMITED",
"LOHPOHIA TEA COMPANY PRIVATE LIMITED",
"LOHR INDIA AUTOMOTIVE PRIVATE LIMITED",
"LOHSHREE ENGINEERS PRIVATE LIMITED",
"LOHUM CLEANTECH PRIVATE LIMITED",
"LOIS CARON PRIVATE LIMITED",
"LOIWAL COMMERCIAL PVT.LTD.",
"LOK ADVISORY SERVICES PRIVATE LIMITED",
"LOK AUSHADHI PRIVATE LIMITED",
"LOK BHARTI EDUCATION SOCIETY",
"LOK BHARTI SKILLING SOLUTIONS PRIVATE LIMITED",
"LOK CHEMICALS PRIVATE LIMITED",
"LOK ENTERPRISES",
"LOK JAGRUTI KRISH-E PRODUCER COMPANY LIMITED",
"LOK MANAGEMENT SERVICES PRIVATE LIMITED",
"LOK NAYAK HOSPITAL",
"LOK NIRMAN VIBHAG GVT",
"LOK PRIYA BUILDWELL LLP",
"LOK PRIYA BUILDWELL PRIVATE LIMITED",
"LOK PRIYA NURSING HOME LIMITED",
"LOK SABHA SECRETARIAT",
"LOK SEWAK LEASINGAND INVESTMENT PRIVATE LIMITED",
"LOK SUVIDHA FINANCE LIMITED",
"LOK UNNATI KRISH-E FARMER PRODUCER COMPANY LIMITED",
"LOKA BIOSCIENCES PRIVATE LIMITED",
"LOKA PROPERTIES PVT LTD",
"LOKADITYA CONSTRUCTIONS PRIVATE LIMITED",
"LOKALFERI ECOMMERCE PRIVATE LIMITED",
"LOKAMANYA HOSPITAL",
"LOKAPUJYA TRADING PRIVATE LIMITED",
"LOKAVANI SOUTHERN PRINTERS PRIVATE LIMITED",
"LOKDHUN TELEMEDIA PRIVATE LIMITED",
"LOKE NATH CHATTERJEE & SONS (PRECISION TOOLS) PVT LTD",
"LCPL ENERGY SOLUTIONS PRIVATE LIMITED",
"LOKENATH GRAPHICS PRIVATE LIMITED",
"LOKENATH PATTERNS AND CASTINGS PVT LTD",
"LOKESH",
"LOKESH ADVISORY PRIVATE LIMITED",
"LOKESH BUILDERS PRIVATE LIMITED",
"LOKESH CARRIER PRIVATE LIMITED",
"LOKESH ELECTRICALS PRIVATE LIMITED",
"LOKESH ENGINEERING PRIVATE LIMITED",
"LOKESH FOOD PRIVATE LIMITED",
"LOKESH FOUNDRIES PVT LTD",
"LOKESH INDUSTRIAL SERVICES PRIVATE LIMITED",
"LOKESH INFRAPROJECT PRIVATE LIMITED",
"LOKESH KUMAR SARAAF & SONS PRIVATE LIMITED",
"LOKESH LOGISTICS PRIVATE LIMITED",
"LOKESH MACHINES LIMITED GPM",
"LOKESH OIL MILLS PVT.LTD.",
"LOKESH POWER INFRA PRIVATE LIMITED",
"LOKHANDE'S HEALTH CARE PRIVATE LIMITED",
"LOKHANDWALA CONSTRUCTION INDUSTRIES PRIVATE LIMITED",
"LOKHANDWALA FOUNDATIONS",
"LOKHANDWALA INFRASTRUCTURE PRIVATE LIMITED",
"LOKHANDWALA WATCHES PRIVATE LIMITED",
"LOKHITH HEALTHCARE PRIVATE LIMITED",
"LOKI SECURITY SYSTEMS AND CONSULTANCY PRIVATE LIMITED",
"LOKJIWAN P S BELA NAGPUR",
"LOKKALYAN MICROCARE FOUNDATION",
"LOKKURR FINVESTT PRIVATE LIMITED",
"LOKMANGAL BIO-TECH PRIVATE LIMITED",
"LOKMANGAL DEVELOPERS LIMITED",
"LOKMANGAL ENGLISH MEDIUM SCHOOL & JUNIOR COLLEGE WADALA SOLAPUR",
"LOKMANGAL PRODUCTS LIMITED",
"LOKMANGAL TEXTILES PRIVATE LIMITED",
"LOKMANYA CON M P S GANDHI NAGAR NAGPUR",
"LOKMANYA HEART INSTITUTE PRIVATE LIMITED",
"LOKMANYA HOSPITAL CHINCHWAD",
"LOKMANYA HOSPITALS PRIVATE LIMITED",
"LOKMANYA MULTIPURPOSE CO-OP SOCIETY LTD",
"LOKMANYA MULTIPURPOSE COOPERATIVE SOCIETY LIMITED",
"LOKMANYA TILAK INSTITUTE OF MANAGEMENT S",
"LOKMANYA TILAK JANKALYAN SHIKSHAN SANSTHA'S",
"LOKMANYA TILAK JANTA INTER COLLEGE",
"LOKMANYA TILAK MAHAVIDYALAY WADWANI",
"LOKMANYA TILAK MUNCIPAL GEN HOSPITAL AND MEDICAL COLLEGE",
"LOKMAT MEDIA PRIVATE LIMITED",
"LOKMUDRA POLY CLINIC",
"LOKNATH COMMOSALES PRIVATE LIMITED",
"LOKNATH DTP CENTRE",
"LOKNATH PRASAD GUPTA INDUSTRIES PRIVATE LIMITED",
"LOKNATH TEA PROCESSING PRIVATE LIMITED",
"LOKNETE BABURAO PATIL AGRO INDUSTRIES LIMITED",
"LOKNETE DATTAJI PATIL SAHKARI BANK LIMITED",
"LOKOZO TECHNOLOGY PRIVATE LIMITED",
"LOKPRIYA HOSPITAL",
"LOKPRIYA SECONDARY SCHOOL",
"LOKRANJAN BREWERIES PRIVATE LIMITED",
"LOKSEVA COLLEGE OF PHARMACY",
"LOKSEVA EDUCATION SOCIETY'S ARTS AND SCIENCE COLLEGE",
"LOKSEVA HIGH SCHOOL SOLAPUR",
"LOKTAK DOWNSTREAM HYDROELECTRIC CORPORATION LIMITED",
"LOKUMAL KISHINCHAND EXPORTS PRIVATE LIMITED",
"LOKUS DESIGN PRIVATE LIMITED",
"LOKWANI SALES PRIVATE LIMITED",
"LOLARK POLYTEX PRIVATE LIMITED",
"LOLI POLI DRESSES PRIVATE LIMITED",
"LOLIYA PRIMARY SCHOOL",
"LOM LOGISTICS INDIA PRIVATE LIMITED",
"LOM SUPPLY CHAIN INDIA PRIVATE LIMITED",
"LOMA CO-DEVELOPERS 1 PRIVATE LIMITED",
"LOMA CO-DEVELOPERS 2 PRIVATE LIMITED",
"LOMA IT PARK DEVELOPERS PRIVATE LIMITED",
"LOMAC REMEDIES PRIVATE LIMITED",
"LOMASH SLURRY TECH PRIVATE LIMITED",
"LOMASSI FASHION INDUSTRIES PRIVATE LIMITED",
"LOMBARD REALTY PRIVATE LIMITED",
"LOMBARDI ENGINEERING INDIA PRIVATE LIMITED",
"LOMI ENTERPRISE PRIVATE LIMITED",
"LOMIRAA ENTERPRISE PRIVATE LIMITED",
"LOMISCO EXPORTS PRIVATE LIMITED",
"LONA INDUSTRIES LIMITED",
"LONAR AGRO PRODUCER COMPANY LIMITED",
"LONAR TECHNOLOGIES PRIVATE LIMITED",
"LONAVALA NAGARPARISHAD",
"LONAWALA EDU TRUST S ARTS COMM COLL",
"LONDE JEWELLERS PRIVATE LIMITED",
"LONDON HOUSE DRYCLEANERS INDIA PRIVATE LIMITED",
"LONDON OFFSHORE CONSULTANTS INDIA PRIVATE LIMITED",
"LONDON STAR DIAMOND COMPANY INDIA PRIVATE LIMITED",
"LONDON UNITED MEDIMPEX PRIVATE LIMITED",
"LONDON WINES AND STORES PRIVATE LIMITED",
"LONE STAR HOLDINGS PVT LTD",
"LONE STAR HOSPITALITY PRIVATE LIMITED",
"LONELY PLANET INDIA PRIVATE LIMITED",
"LONESTAR INDUSTRIES",
"LONESTAR TECHNOLOGY PRIVATE LIMITED",
"LONG ISLAND TRADING COMPANY PRIVATE LIMITED",
"LONG LIFE ELECTRONICS PRIVATE LIMITED",
"LONG RANGE COMMERCIAL PVT LTD",
"LONG TAIL PROCUREMENT SOLUTIONS PRIVATE LIMITED",
"LONG TERM CREDIT BANK OF JAPAN",
"LONGBOW GAMES PRIVATE LIMITED",
"LONGBOW LEGAL SERVICES PRIVATE LIMITED",
"LONGBOW TECHNOLOGIES PRIVATE LIMITED",
"LONGITUDE 74 STUDIO PRIVATE LIMITED",
"LONGITUDE EXPORTS PRIVATE LIMITED",
"LONGKING ENGINEERING INDIA PRIVATE LIMITED",
"LONGLASST GLASSES PRIVATE LIMITED",
"LONGLAST PIPES INDIA PVT LTD",
"LONGOWAL SPINNING MILLS PRIVATE LIMITED",
"LONGOWALIA YARNS LIMITED",
"LONGSHINE GLOBAL AGENCIES PRIVATE LIMITED",
"LONGSHINE GLOBAL ENTERPRISES PRIVATE LIMITED",
"LONGSHORE INDUSTRIES PRIVATE LIMITED",
"LONGTOP TECHNOLOGY INDIA PRIVATE LIMITED",
"LONGULF TRADING INDIA PRIVATE LIMITED",
"LONGVIEW AVIATION INDIA PRIVATE LIMITED",
"LONGVIEW HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"LONGVIEW RESOURCES (INDIA) PRIVATE LIMITED",
"LONGVIEW TEA CO LTD",
"LONGWELL INVESTMENT PRIVATE LIMITED",
"LONSDALE LIFE SCIENCES PRIVATE LIMITED",
"LONSEN KIRI CHEMICAL INDUSTRIES LIMITED",
"LOOK UNISEX & SALON",
"LOOKAD (INDIA) PRIVATE LIMITED",
"LOOKMAN ELECTROPLAST INDUSTRIES LIMITED",
"LOOKS APPARELS PRIVATE LIMITED",
"LOOKS HEALTH SERVICES LIMITED",
"LOOKS SALON PRIVATE LIMITED",
"LOOKS21 LIFESTYLE SERVICES PRIVATE LIMITED",
"LOOKWELL LIFESPACE PRIVATE LIMITED",
"LOOKWELL SALONS PRIVATE LIMITED",
"LOOM AND KNOTS",
"LOOM CRAFTS FURNITURE (INDIA) PRIVATE LIMITED",
"LOOM CRAFTS SHADE SYSTEMS PRIVATE LIMITED",
"LOOM DRAPE INDIA PRIVATE LIMITED",
"LOOM SOLAR PRIVATE LIMITED",
"LOOMANTHA ENTER PRISES PRIVATE LIMITED",
"LOOMS GUILD PRIVATE LIMITED",
"LOOMS N ART PRIVATE LIMITED",
"LOONKER CREATIVE SOLUTIONS (OPC) PRIVATE LIMITED",
"LOONYCORN QUANT MEDIA PRIVATE LIMITED",
"LOOP TECHNO SYSTEMS PRIVATE LIMITED",
"LOOPBELL TECH PRIVATE LIMITED",
"LOOPCODE TECHNOLAB",
"LOOPINTECHIES SERVICES (INDIA) PRIVATE LIMITED",
"LOOQUS MEDIA PRIVATE LIMITED",
"LOPAN ENGINEERING PRIVATE LIMITED",
"LOPAN METAL TREATMENT PRIVATE LIMITED",
"LOPAREX INDIA PRIVATE LIMITED",
"LORA MATTRESS PRIVATE LIMITED",
"LORA PCTECHS PRIVATE LIMITED",
"LORBAX INDIA PRIVATE LIMITED",
"LORCH WELDING PRODUCTS PRIVATE LIMITED",
"LORD & TAYLOR INDIA PRIVATE LIMITED",
"LORD BALAJI WAREHOUSING PRIVATE LIMITED",
"LORD BUDDHA FOOD PRODUCTS PRIVATE LIMITED",
"LORD BUDHA EDUCATIONAL SOCIETY",
"LORD FINCAP LIMITED",
"LORD INDIA PRIVATE LIMITED",
"LORD INDUSTRIALS PRIVATE LIMITED",
"LORD KRISHNA ARCADE PRIVATE LIMITED",
"LORD KRISHNA BANK LIMITED",
"LORD KRISHNA CONTAINER LEASING PRIVATE LIMITED",
"LORD KRISHNA FINANCIAL SERVICES LIMITED",
"LORD KRISHNA PUBLIC SCHOOL",
"LORD KRISHNA TRADERS PRIVATE LIMITED",
"LORD MAHAVEER INDUSTRIES PRIVATE LIMITED",
"LORD OF GADGETS PRIVATE LIMITED",
"LORD PASHUPATI SEEDS PRIVATE LIMITED",
"LORD S HOMOEPATHIC LABORATORY PRIVATE LIMITED",
"LORD SECURATOR SERVICES PRIVATE LIMITED",
"LORD SHIVA CONSTRUCTION CO PRIVATE LIMITED",
"LORD SHIVA TEX EXPORTS PRIVATE LIMITED",
"LORD SHYAMA REALBUILD PRIVATE LIMITED",
"LORD STYLE PRIVATE LIMITED",
"LORD V FACILITIES PRIVATE LIMITED",
"LORD VARUN CORPORATE SERVICES LIMITED",
"LORD VISHNU CONSTRUCTIONS PRIVATE LIMITED",
"LORD VISHWAKARMA HEAT EXCHANGERS PRIVATE LIMITED",
"LORD WHEELS PRIVATE LIMITED",
"LORDCULTURAL RESOURCES PRIVATE LIMITED",
"LORDS AUTOMATIVE PRIVATE LIMITED",
"LORDS CHEMICALS LTD",
"LORDS CHLORO ALKALI LIMITED",
"LORDS DISTILLERY LIMITED",
"LORDS EDUCATION AND HEALTH SOCIETY",
"LORDS FREIGHT INDIA PRIVATE LIMITED",
"LORDS HOSPITAL",
"LORD'S HOSPITALS PRIVATE LIMITED",
"LORDS HOTELS PRIVATE LIMITED",
"LORDS INDIA ENTERTAINMENT PRIVATE LIMITED",
"LORDS INFRACON PRIVATE LIMITED",
"LORDS INN HOTELS AND DEVELOPERS PRIVATE LIMITED",
"LORDS INSTITUTE OF ENGINEERING & TECHNOLOGY",
"LORDS INTERIOR PRIVATE LIMITED",
"LORDS INTERNATIONAL SCHOOL",
"LORDS ISHWAR HOTELS LIMITED",
"LORD S MARK INDUSTRIES LIMITED",
"LORD'S MARK INDUSTRIES PRIVATE LIMITED",
"LORDS TRAVELS PRIVATE.LIMITED",
"LORDS UNIVERSITY",
"LORDS VARAM HOTELS PRIVATE LIMITED",
"LORDSON BRIGHT BARS & WIRES PRIVATE LIMITED",
"LORE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"LOREAL INDIA PRIVATE. LIMITED",
"LOREM TILES PRIVATE LIMITED",
"LOREN BEAUTIFIERS PVT LTD",
"LORENZINI APPARELS LIMITED",
"LORETO CONVENT ENTALLY",
"LORETO DAY SCHOOL DHARMATALA",
"LORETO DAY SCHOOL SEALDAH",
"LORETO HOUSE",
"LORETO HOUSE COLLEGE",
"LORETO PHARMACEUTICALS PRIVATE LIMITED",
"LORHAN IT SERVICES PRIVATE LIMITED",
"LORINA CONSULTANTS PRIVATE LIMITED",
"LORMAN GREENTECH PRIVATE LIMITED",
"LORMAN KITCHEN EQUIPMENTS PRIVATE LIMITED",
"LOROM INDIA CORPORATION PRIVATE LIMITED",
"LORRAINE FINANCE PRIVATE LIMITED",
"LORRAM MEDICAL SYSTEMS PRIVATE LIMITED",
"LORVEN BIOLOGICS PRIVATE LIMITED",
"LORVEN FLEX AND SACK INDIA PRIVATE LIMITED",
"LORVEN HYDRAULIC PRIVATE LIMITED",
"LORVEN INSURANCE BROKING SERVICES PRIVATE LIMITED",
"LORVEN INTERNATIONAL LIMITED",
"LORVEN METAL PRODUCTS PRIVATE LIMITED",
"LORVEN TECHNOLOGIES PRIVATE LIMITED",
"LORVENSAI INDUSTRIES PRIVATE LIMITED",
"LOSMA INDIA PRIVATE LIMITED",
"LOST BOY MEDIA PRODUCTIONS PRIVATE LIMITED",
"LOSUNG AUTOMATION PRIVATE LIMITED",
"LOSUNG AUTOMOTIVE PRIVATE LIMITED",
"LOSUNG E-SERVICES PRIVATE LIMITED",
"LOT MOBILES PRIVATE LIMITED",
"LOTEY HEAVY MACHINES PRIVATE LIMITED",
"LOTMOR BRANDS PRIVATE LIMITED",
"LOTS SHIPPING LIMITED",
"LOTSATRAVEL HOLIDAYS LLP",
"LOTTE CHEMICAL INDIA PRIVATE LIMITED",
"LOTTE CHEMICAL THAILAND CO. LTD",
"LOTTE INDIA CORPORATION LIMITED",
"LOTUS ABRASIVE TECH (INDIA) PRIVATE LIMITED",
"LOTUS AGRO INDUSTRIES PRIVATE LIMITED",
"LOTUS AIR TECH ENGINEERING PRIVATE LIMITED",
"LOTUS AIRTECH PRIVATE LIMITED",
"LOTUS AIRWAYS PRIVATE LIMITED",
"LOTUS ATTIRES (INDIA) PRIVATE LIMITED",
"LOTUS AUTO PRIVATE LIMITED",
"LOTUS AVIATION TECHNOLOGY PRIVATE LIMITED",
"LOTUS BEAUTY CARE PRODUCTS PRIVATE LIMITED",
"LOTUS BIOMEDICALS PRIVATE LIMITED",
"LOTUS BLUE INFRA PROJECTS PRIVATE LIMITED",
"LOTUS CAPITAL FINANCIAL SERVICES LIMITED",
"LOTUS CARDIAC CARE PRIVATE LIMITED",
"LOTUS CLEAN POWER VENTURE PRIVATE LIMITED",
"LOTUS CONTRACTORS AND DEVELOPERS PRIVATE LIMITED",
"LOTUS CORPORATE PARK MAINTAINANCE ACCOUNT",
"LOTUS CYCLES PRIVATE LIMITED",
"LOTUS DAIRY PRODUCTS PRIVATE LIMITED",
"LOTUS DESTINATIONS PRIVATE LIMITED",
"LOTUS DEVELOPERS",
"LOTUS ENERGY SYSTEMS PRIVATE LIMITED",
"LOTUS EXHIBITORS PRIVATE LIMITED",
"LOTUS EXIM PRIVATE LIMITED",
"LOTUS EXPORTS PRIVATE LIMITED",
"LOTUS FABCOT PRIVATE LIMITED",
"LOTUS FARMS",
"LOTUS FERTILIZERS PRIVATE LIMITED",
"LOTUS FOOTWEAR ENTERPRISES LIMITED",
"LOTUS GEOSOLUTIONS PRIVATE LIMITED",
"LOTUS GLOBAL EQUITIES PRIVATE LIMITED",
"LOTUS GLOBAL PRIVATE LIMITED",
"LOTUS GRANGES INDIA LIMITED",
"LOTUS GREENS CONSTRUCTIONS PRIVATE LIMITED",
"LOTUS GRIH NIRMAN PRIVATE LIMITED",
"LOTUS HERBALS PRIVATE LIMITED",
"LOTUS HOMETEXTILES LIMITED",
"LOTUS HOSPITALS FOR WOMEN & CHILDREN",
"LOTUS INFRACONSTRUCTION PRIVATE LIMITED",
"LOTUS INFRAESTATES PRIVATE LIMITED",
"LOTUS INFRAREALTY LIMITED",
"LOTUS INN PRIVATE LIMITED",
"LOTUS INSTITUTE OF MANAGEMENT",
"LOTUS INSTRUMENTS SOLUTIONS PRIVATE LIMITED",
"LOTUS INTEGRATED LOGISTICS PRIVATE LIMITED",
"LOTUS INTERNATIONAL FREIGHT EXPRESS PRIVATE LIMITED",
"LOTUS INTERTRADE PRIVATE LIMITED",
"LOTUS KALEEN PRIVATE LIMITED",
"LOTUS KNITS PRIVATE LIMITED",
"LOTUS KNOWLWEALTH PRIVATE LIMITED",
"LOTUS LABS PRIVATE LIMITED",
"LOTUS LANDMARKS (INDIA) PRIVATE LIMITED",
"LOTUS LIGHTING TECHNIK INDIA PRIVATE LIMITED",
"LOTUS LOGISTICS AND DEVELOPERS PRIVATE LIMITED",
"LOTUS MAINTENANCE SERVICES PRIVATE LIMITED",
"LOTUS MANPOWER CONSULTANTS SERVICES PRIVATE LIMITED",
"LOTUS MARINE SERVICES PRIVATE LIMITED",
"LOTUS MATRICULATION SCHOOL",
"LOTUS MECHANICAL PRIVATE LIMITED",
"LOTUS MEGA MALLS PRIVATE LIMITED",
"LOTUS MICROWAVE TECHNOLOGIES PRIVATE LIMITED",
"LOTUS MULTISUPERSPECIALITY HOSPITAL PRIVATE LIMITED",
"LOTUS ORNAMENTS PRIVATE LIMITED",
"LOTUS OVERSEAS EDUCATION & IMMIGRATION SERVICES",
"LOTUS POLYTECH PVT LTD",
"LOTUS POND HOTEL PRIVATE LIMITED",
"LOTUS POULTRIES PRIVATE LIMITED",
"LOTUS POWERGEAR PRIVATE LIMITED",
"LOTUS PRINTERS PRIVATE LIMITED",
"LOTUS PROPERTIES LIMITED",
"LOTUS PUBLICATIONS PRIVATE LIMITED",
"LOTUS REALTECH PRIVATE LIMITED",
"LOTUS RENEWABLE POWER PRIVATE LIMITED",
"LOTUS ROOFINGS LIMITED",
"LOTUS ROOFINGS PRIVATE LIMITED",
"LOTUS SHIELDERS INDIA PRIVATE LIMITED",
"LOTUS SPACES PRIVATE LIMITED",
"LOTUS STOCK MARKETS PRIVATE LIMITED",
"LOTUS TAPES (INDIA) PRIVATE LIMITED",
"LOTUS TEA PACKERS PRIVATE LIMITED",
"LOTUS TECHNICALS PRIVATE LIMITED",
"LOTUS TECHSOL PRIVATE LIMITED",
"LOTUS TELE INFRA PRIVATE LIMITED",
"LOTUS TEX CREATIONS PRIVATE LIMITED",
"LOTUS TRADING AND SECURITIES PRIVATE LIMITED",
"LOTUS TRAEXIM PRIVATE LIMITED",
"LOTUS TRANS TRAVEL PRIVATE LIMITED",
"LOTUS TRANSFORMS PRIVATE LIMITED",
"LOTUS TRAVEL SERVICES PRIVATE LIMITED",
"LOTUS TREE PRIVATE LIMITED",
"LOTUS TRENDS PRIVATE LIMITED",
"LOTUS URBAN SPACES PRIVATE LIMITED",
"LOTUS VALLEY INTERNATIONAL SCHOOL",
"LOTUS VALLEY TECHNOLOGIES PRIVATE LIMITED",
"LOTUS VALLEYI EDUCATION SOCIETY",
"LOTUS VENEERS PRIVATE LIMITED",
"LOTUS WEARS PRIVATE LIMITED",
"LOTUS WIRELESS TECHNOLOGIES PRIVATE LIMITED",
"LOTUS WOODTECH PRIVATE LIMITED",
"LOTUS-AERO ENTERPRISES PRIVATE LIMITED",
"LOTUSBLOSSOM INFRA PRIVATE LIMITED",
"LOTUSDEW WEALTH AND INVESTMENT ADVISORS PRIVATE LIMITED",
"LOTUSINDIA INTERCONTINENTAL PRIVATE LIMITED",
"LOTUSJET INTERNATIONAL LOGISTICS PRIVATE LIMITED",
"LOTUSMINT WEALTH PRIVATE LIMITED",
"LOTUSPAY SOLUTIONS PRIVATE LIMITED",
"LOTVUE INDIA LLP",
"LOTZ & HOMEZ PROPERTIES PRIVATE LIMITED",
"LOUDCELL TECHNOLOGIES PRIVATE LIMITED",
"LOUDCLOUD SYSTEMS PRIVATE LIMITED",
"LOUHAJA STEEL PRIVATE LIMITED",
"LOUIS BERGER CONSULTING PRIVATE LIMITED",
"LOUIS BERGER S A S",
"LOUIS DREYFUS COMMODITIES SERVICES INDIA PRIVATE LIMITED",
"LOUIS DREYFUS COMPANY INDIA PRIVATE LIMITED",
"LOUIS EXPORTS PRIVATE LIMITED",
"LOUIS LOGISTICS PRIVATE LIMITED",
"LOUIS VUITTION INDIA RETAIL P LIMITED",
"LOUISIANA INVESTMENT & FINANCE PRIVATE LIMITED",
"LOUNGE HOSPITALITY LLP",
"LOURDES COLLEGE OF NURSING KAKKANADU",
"LOURDES HOSPITAL",
"LOURDES MATRIC HR SEC SCHOOL",
"LOURDES TEXTILES PRIVATE LIMITED",
"LOURDU ENGLISH HIGHER PRIMARY SCHOOL",
"LOURENCO MARINE PRIVATE LIMITED",
"LOUTE WAREHOUSING UNIT PRIVATE LIMITED",
"LOUVERLINE BLINDS PRIVATE LIMITED",
"LOVA IMPEX PRIVATE LIMITED",
"LOVAANI IMPEX PRIVATE LIMITED",
"LOVABLE LINGERIE LIMITED",
"LOVATO CERAMIC PRIVATE LIMITED",
"LOVE AND HOPE ENGLISH SCHOOL",
"LOVE FARMS INDIA PRIVATE LIMITED",
"LOVE FROM INDIA APPARELS & HOSPITALITY PRIVATE LIMITED",
"LOVE KUSH FOODS PRIVATE LIMITED",
"LOVE SHOPPERS LIMITED",
"LOVEE SHUBH HOSPITAL PRIVATE LIMITED",
"LOVEEY TRADING INDIA PRIVATE LIMITED",
"LOVEFOODLOVELIFE HEALTH SERVICES PRIVATE LIMITED",
"LOVEFOOLS HOSPITALITY PRIVATE LIMITED",
"LOVEINSTORE TECHNOLOGIES PRIVATE LIMITED",
"LOVELOCK & LEWES",
"LOVELY AUTO SHINE",
"LOVELY COIR FOAMS PRIVATE LIMITED",
"LOVELY FABRICS AND PROCESSORS PRIVATE LIMITED",
"LOVELY FORMS AND STATIONERY PRIVATE LIMITED",
"LOVELY HOTELS PRIVATE LIMITED",
"LOVELY IMPRESSION INDIA PRIVATE LIMITED",
"LOVELY INDUSTRIES PRIVATE LIMITED",
"LOVELY INTERNATIONAL TRUST",
"LOVELY OFFSET PRINTERS PRIVATE LIMITED",
"LOVELY PROFESSIONAL UNIVERSITY",
"LOVELY PROMOTERS AND BUILDERS PVT LTD",
"LOVELY PUBLIC ENGLISH SCHOOL",
"LOVELY PUBLIC SCHOOL",
"LOVELY PUBLIC SR SEC SCHOOL",
"LOVELY RANI CONSTRUCTIONS PRIVATE LIMITED",
"LOVELY ROADLINES PRIVATE LIMITED",
"LOVELY ROSE PUBLIC SECONDARY SCHOOL",
"LOVELY SECURITIES PRIVATE LIMITED",
"LOVELYMARBLE HOUSE PRIVATE LIMITED",
"LOVEN LABS PRIVATE LIMITED",
"LOVES CLOUD PRIVATE LIMITED",
"LOVE'S GOLD JEWELLERY PRIVATE LIMITED",
"LOVETOBAG ACCESSORIES PRIVATE LIMITED",
"LOVI REAL ESTATE LLP",
"LOVINCARE COSMETICS PRIVATE LIMITED",
"LOW & BONAR INDIA PRIVATE LIMITED",
"LOW HEAT METAL BONDS PRIVATE LIMITED",
"LOW LOSS PRODUCTS PRIVATE LIMITED",
"LOWA LOGISTICS PRIVATE LIMITED",
"LOWE'S INDIA PRIVATE LIMITED",
"LOWES TCI TISSUE CULTURE (INDIA) PRIVATE LIMITED",
"LOXIM INDUSTRIES LIMITED",
"LOYA PRE ENGINEERED BUILDINGS PRIVATE LIMITED",
"LOYAL ADS PRIVATE LIMITED",
"LOYAL EQUIPMENTS LIMITED",
"LOYAL HOSPITALITY PRIVATE LIMITED",
"LOYAL INFOSERVICES PRIVATE LIMITED",
"LOYAL INSURANCE BROKERS LIMITED",
"LOYAL MERCHANT PRIVATE LIMITED",
"LOYAL POLYPACK PRIVATE LIMITED",
"LOYAL SCAFFOLDING PRIVATE LIMITED",
"LOYAL SKILLS PRIVATE LIMITED",
"LOYAL STEEL AND METAL PRIVATE LIMITED",
"LOYAL TEXTILE MILLS LIMITED",
"LOYAL TOURS AND TRAVELS PRIVATE LIMITED",
"LOYAL VENTURES PRIVATE LIMITED",
"LOYALA HOMES PRIVATE LIMITED",
"LOYALIE IT-SOLUTIONS PRIVATE LIMITED",
"LOYALINDIA POWER SERVICES PRIVATE LIMITED",
"LOYALTECH MANAGEMENT SERVICES PRIVATE LIMITED",
"LOYALTY AUTOMATION PRIVATE LIMITED",
"LOYALTY COMMUNICATION PRIVATE LIMITED",
"LOYALTY JUGGERNAUT INDIA PRIVATE LIMITED",
"LOYALTY SOLUTIONS & RESEARCH PRIVATE LIMITED",
"LOYLI ENGINEERING PRIVATE LIMITED",
"LOYLOGIC TECHNOLOGIES PRIVATE LIMITED",
"LOYLTY REWARDZ MANAGEMENT PRIVATE LIMITED",
"LOYOLA ACADEMY DEGREE AND PG COLLEGE",
"LOYOLA COLLEGE",
"LOYOLA HIGH SCHOOL AND JUNIOR COLLEGE",
"LOYOLA INCLUSIVE INNOVATION IMPACT CENTRE",
"LOYOLA INSTITUTE OF BUSINESS ADMINISTRAT",
"LOYOLA ITI",
"LOYOLA MATRICULATIONN HIGHER SECONDARY SCHOOL",
"LOYREX SOLUTIONS PRIVATE LIMITED",
"LOZANO PACKAGING PRIVATE LIMITED",
"LOZEN PHARMA PRIVATE LIMITED",
"LP GAS TRANSPORT AND BOTTLEING COMPANY PRIVATE LIMITED",
"LP INDIA LOGISTICS PRIVATE LIMITED",
"LP LOGISCIENCE LLP",
"LP LOGISTICS PLUS CHEMICAL SCM PRIVATE LIMITED",
"LP SAREES PRIVATE LIMITED",
"LP SAVANI ACADEMY",
"LP VILAS",
"LPC ADVISORS PRIVATE LIMITED",
"LPC SECURITIES PRIVATE LIMITED",
"LPDEAL ECOMMERCE PRIVATE LIMITED",
"LPF AUTO PRIVATE LIMITED",
"LPGR CONSTRUCTIONS INDIA PRIVATE LIMITED",
"LPH APPAREL INDIA PRIVATE LIMITED",
"LPH PHARMA PRIVATE LIMITED",
"LPHC PRIVATE LIMITED",
"LPM ENGINEERING PRIVATE LIMITED",
"LPO LEGAL ADVANTAGE PRIVATE LIMITED",
"LPR EXPORTS (ENGINE COMPONENTS) PRIVATE LIMITED",
"LPS BOSSARD PRIVATE LIMITED",
"LPS INDUSTRIAL SUPPLIES PRIVATE LIMITED",
"LQ LEADERSHIP DEVELOPMENT INDIA PRIVATE LIMITED",
"LR ENERGY PRIVATE LIMITED",
"LR ENGINEERING PRIVATE LIMITED",
"LR INFRAHOMES (INDIA) PRIVATE LIMITED",
"LR SPORTS MANAGEMENT PRIVATE LIMITED",
"LRA LOGISTICS PRIVATE LIMITED",
"LRAR INFRA PRIVATE LIMITED",
"LRC BUILDERS PRIVATE LIMITED",
"LRC SPECIALITY CHEMICALS PRIVATE LIMITED",
"LRDMC TRAVEL INDIA PRIVATE LIMITED",
"LRG STEEL CONCEPT PRIVATE LIMITED",
"LRG TECHNOLOGIES LIMITED",
"L-RHAKS STEEL SAND PRIVATE LIMITED",
"LRK GEOTECH PRIVATE LIMITED",
"LRL MOTORS PRIVATE LIMITED",
"LRM SPICES PRIVATE LIMITED",
"LRN TECHNOLOGY AND CONTENT SOLUTIONS INDIA PRIVATE LIMITED",
"LRP CAPTIVATORS PRIVATE LIMITED",
"LRP MOTORS PRIVATE LIMITED",
"LRS SERVICES PRIVATE LIMITED",
"LRSD SECURITIES PRIVATE LIMITED",
"LRVI ENGINEERING SOLUTIONS PRIVATE LIMITED",
"LS AUTOMOTIVE INDIA PRIVATE LIMITED",
"LS CABLE INDIA PRIVATE LIMITED",
"LS CONTRACTORS PRIVATE LIMITED",
"LS INTERIOR PRIVATE LIMITED",
"LS LOGISTICS PRIVATE LIMITED",
"LS METATECH PRIVATE LIMITED",
"LS RICE EXPORTS PRIVATE LIMITED",
"LS SPECTRUM SOLUTIONS PRIVATE LIMITED",
"LSA SOFTWARE PRIVATE LIMITED",
"LSC AUTOWHEELS PRIVATE LIMITED",
"LSC INFRATECH LIMITED",
"LSC MARKETING INDIA PRIVATE LIMITED",
"LSC MINES AND MINERALS PRIVATE LIMITED",
"LSC SECURITIES LIMITED",
"LSC STEELS PRIVATE LIMITED",
"LSD COMMUNICATIONS PRIVATE LIMITED",
"LSD LIFESTYLES PRIVATE LIMITED",
"LSD REALCON PRIVATE LIMITED",
"LSG INDIA PRIVATE LIMITED",
"LSG SKY CHEFS INDIA PRIVATE LIMITED",
"LSI COMPONENTS PRIVATE LIMITED",
"LSI CORPORATE SERVICES PRIVATE LIMITED",
"LSI FINANCIAL SERVICES PRIVATE LIMITED",
"LSI INDIA RESEARCH & DEVELOPMENT PRIVATE LIMITED",
"LSI RESOLUTION PRIVATE LIMITED",
"LSK PROJECTS PRIVATE LIMITED",
"LSKB ALUMINIUM FOILS PRIVATE LIMITED",
"LSL LOGISTICS NETWORK (OPC) PRIVATE LIMITED",
"LSL TOOLS PRIVATE LIMITED",
"LSN MINERALS PRIVATE LIMITED",
"LSN SOFTWARE SERVICES PRIVATE LIMITED",
"LSP INDUSTRIES PRIVATE LIMITED",
"LSQUARE ECO-PRODUCTS PRIVATE LIMITED",
"LSR ENGINEERING PRIVATE LIMITED",
"LSR FAB PRIVATE LIMITED",
"LSR FORGE PRIVATE LIMITED",
"LSR INFRACON PRIVATE LIMITED",
"LSR ISPAT PRIVATE LIMITED",
"LSR MEDICAL PRIVATE LIMITED",
"LSR TUDOR INFRA LLP",
"LSSC INDIA PRIVATE LIMITED",
"LSV PUBLIC SCHOOL",
"LT APPAREL PRIVATE LIMITED",
"LT ATUL KATARYA MEMORIAL SCHOOL",
"LT BUILDWELL PRIVATE LIMITED",
"LT COL 15-MP BATTALION NCC GWALIOR",
"LT DIGITAL PRIVATE LIMITED",
"LT ENERGY SOLUTIONS PRIVATE LIMITED",
"LT FOODS LIMITED",
"LT NAHAR SINGH INTER COLLEGE",
"LT SAGAR COASTAL TRANSPORT PRIVATE LIMITED",
"LT SUPERCOM INDIA PRIVATE LIMITED",
"LTA SCHOOL OF BEAUTY PRIVATE LIMITED",
"LTA TOURS PRIVATE LIMITED",
"LTC AGRI FOODS PRIVATE LIMITED",
"LTC COMMERCIAL CO PRIVATE LIMITED",
"LTC INFRASTRUCTURE PRIVATE LIMITED",
"LTC LOGISTICS PRIVATE LIMITED",
"LTC TRANSLINKS PRIVATE LIMITED",
"LTC TRAVEL PRIVATE LIMITED",
"LTDC SERVICES (OPC) PRIVATE LIMITED",
"LTECH STRUCTURE PROJECT PRIVATE LIMITED",
"LTELFORD CONSULTING ENGINEERS PRIVATE LIMITED",
"LTG CONSTRUCTIONS PRIVATE LIMITED",
"LTG INFRASTRUCTURE LIMITED",
"LTG INFRASTRUCTURE PRIVATE LIMITED",
"LTG MYSORE GREENS EXPORTS PRIVATE LIMITED",
"LTG PROJECTS PRIVATE LIMITED",
"LTGL AGRO INDUSTRIES PRIVATE LIMITED",
"LTI IMAGING PRIVATE LIMITED",
"LTIDPL INDVIT SERVICES LIMITED",
"LTIMINDTREE LIMITED",
"LTK INDUSTRIES PRIVATE LIMITED",
"LTK SOFT PRIVATE LIMITED",
"LTS CONSULTANTS PRIVATE LIMITED",
"LTS LUMBERS PRIVATE LIMITED",
"LTZCLUB FASHION PRIVATE LIMITED",
"LUB DUB MEDICAL TECHNOLOGIES PRIVATE LIMITED",
"LUBCON LUBRICATION INDIA PRIVATE LIMITED",
"LUBE AIR FILTERS PRIVATE LIMITED",
"LUBE DISTRIBUTING COMPANY PRIVATE LIMITED",
"LUBE ENGINEERS PRIVATE LIMITED",
"LUBEIT ENGINEERING SOLUTIONS PRIVATE LIMITED",
"LUBEMAN ENGINEERS PRIVATE LIMITED",
"LUBERR PRIVATE LIMITED",
"LUBES ENERGY PRIVATE LIMITED",
"LUBESOL INDIA PRIVATE LIMITED",
"LUBESOLUTIONS PRIVATE LIMITED",
"LUBEWATT INDIA PRIVATE LIMITED",
"LUBGRAF SYNOILS PVT LTD",
"LUBI ELECTRONICS",
"LUBI GEL LIMITED",
"LUBI INDUSTRIES LLP",
"LUBOCHEM SPECIALITY PRIVATE LIMITED",
"LUBOIL FILTRATION SYSTEMS PRIVATE LIMITED",
"LUBRALL INDUSTRIES PRIVATE LIMITED",
"LUBRICARE PVT LTD",
"LUBRICATING CENTRE PRIVATE LIMITED",
"LUBRICHEM ENGINEERS PRIVATE LIMITED",
"LUBRIKOTE SPECIALITIES PRIVATE LIMITED",
"LUBRILOG INDIA PRIVATE LIMITED",
"LUBRIMETAL INDIA PRIVATE LIMITED",
"LUBRINA RECYCLING PRIVATE LIMITED",
"LUBRITA INDIA PRIVATE LIMITED",
"LUBRIZOL ADVANCED MATERIALS INDIA PRIVATE LIMITED",
"LUBRIZOL INDIA PRIVATE LIMITED",
"LUBRO AIR ENGINEERS PRIVATE LIMITED",
"LUBROGLIDE OILLESS BEARINGS PRIVATE LIMITED",
"LUBROS ENTERPRISES PRIVATE LIMITED",
"LUBSA MULTILUB SYSTEMS PRIVATE LIMITED",
"LUBZONE INDIA PRIVATE LIMITED",
"LUCARE PHARMA PRIVATE LIMITED",
"LUCAS INDIAN SERVICE LIMITED",
"LUCAS TVS LIMITED",
"LUCASO CERAMIC PRIVATE LIMITED",
"LUCE & LITCH ELECTRIC PRIVATE LIMITED",
"LUCENT (I) ENERGY CONVERSION PRIVATE LIMITED",
"LUCENT BIOTECH LIMITED",
"LUCENT DRUGS PRIVATE LIMITED",
"LUCENT ENERGY COMPANY PRIVATE LIMITED",
"LUCENT GREEN PRIVATE LIMITED",
"LUCENT MARCONS PRIVATE LIMITED",
"LUCENT POLYSYSTEMS (INDIA) PRIVATE LIMITED",
"LUCENT TRANSPORT PRIVATE LIMITED",
"LUCENTS TECHNOLOGIES INDIA PRIVATE LIMITED",
"LUCERE LIGHTING SOLUTION PRIVATE LIMITED",
"LUCEVIDA PHARMACEUTICALS PRIVATE LIMITED",
"LUCID COLLOIDS LIMITED",
"LUCID DESIGN (INDIA) PRIVATE LIMITED",
"LUCID HEALTHCARE PRIVATE LIMITED",
"LUCID IMAGING PRIVATE LIMITED",
"LUCID IT SOLUTIONS PRIVATE LIMITED",
"LUCID LABORATORIES PRIVATE LIMITED",
"LUCID LABS PRIVATE LIMITED",
"LUCID LINES PRODUCTIONS PRIVATE LIMITED",
"LUCID MEDICAL DIAGNOSTICS PRIVATE LIMITED",
"LUCID SOFTWARE LIMITED",
"LUCID TECHNOLOGIES AND SOLUTIONS PRIVATE LIMITED",
"LUCIDA TECHNOLOGIES PRIVATE LIMITED",
"LUCIEN SYSTEMS PRIVATE LIMITED",
"LUCIFER CONSTRUCTIONS PRIVATE LIMITED",
"LUCINI & LUCINI COMMUNICATIONS ASIA PACIFIC PRIVATE LIMITED",
"LUCIUS INDIA TILES PRIVATE LIMITED",
"LUCKNOW CHAIN HOUSE PRIVATE LIMITED",
"LUCKNOW CHRISTIAN DEGREE COLLEGE",
"LUCKNOW COLONISERS PRIVATE LIMITED",
"LUCKNOW DEVELOPMENT AUTHORITY",
"LUCKNOW ELECTRICAL PRIVATE LIMITED",
"LUCKNOW FINANCE COMPANY LIMITED",
"LUCKNOW HEALTH CARE SERVICES PRIVATE LIMITED",
"LUCKNOW HEALTHCITY & TRAUMA CENTRE PHARMACY PRIVATE LIMITED",
"LUCKNOW HEALTHCITY TRAUMA CENTRE AND SUPERSPECIALITY HOSPITAL PRIVATE LIMITED",
"LUCKNOW INTERNATIONAL AIRPORT LIMITED",
"LUCKNOW MALL DEVELOPERS PRIVATE LIMITED",
"LUCKNOW MEDICAL AGENCIES",
"LUCKNOW ORGANICS PRIVATE LIMITED",
"LUCKNOW PLASTICS PRIVATE LIMITED",
"THE LUCKNOW PUBLIC COLLEGIATE",
"LUCKNOW PUBLIC INTER COLLEGE LUCKNOW",
"LUCKNOW PUBLIC SCHOOL",
"LUCKNOW PVC PIPE PRIVATE LIMITED",
"LUCKNOW ROYAL INFRADEVELOPERS PRIVATE LIMITED",
"LUCKNOW SMART CITY LIMITED",
"LUCKNOW SOLAR POWER DEVELOPMENT CORPORATION LIMITED",
"LUCKNOWHEIGHTS INFRAZONE PRIVATE LIMITED",
"LUCKNOWHM GREENCITY PRIVATE LIMITED",
"LUCKNOWMETRO HEALTHCARE PRIVATE LIMITED",
"LUCKNOW-RAEBARELI TOLLWAY PRIVATE LIMITED",
"LUCKSHMI YARN IMPEX PRIVATE LIMITED",
"LUCKY COKE INDUSTRIES PRIVATE LIMITED",
"LUCKY COKE MANUFACTURERS PRIVATE LIMITED",
"LUCKY DIGITAL TECHNNICAL CONSULTANTS PRIVATE LIMITED",
"LUCKY EDUCATION SOCIETY",
"LUCKY ENGINEERING AND FABRICATIONS PRIVATE LIMITED",
"LUCKY ENTERPRISE¬†",
"LUCKY FRAMES & GYPSUM PRIVATE LIMITED",
"LUCKY HOLDINGS PVT LTD",
"LUCKY HOSPITALITY PRIVATE LIMITED",
"LUCKY INDUSTRIES (INDIA) PRIVATE LIMITED.",
"LUCKY LEATHERS PRIVATE LIMITED",
"LUCKY LOGISTICS PRIVATE LIMITED (PART IX)",
"LUCKY MACHINE TOOLS PRIVATE LIMITED",
"LUCKY MACHINES PRIVATE LIMITED",
"LUCKY MARINE SHIPPING & LOGISTICS PRIVATE LIMITED",
"LUCKY MERCANTILE PRIVATE LIMITED",
"LUCKY MINERALS PRIVATE LIMITED",
"LUCKY MONEY CHANGER PRIVATE LIMITED",
"LUCKY MYCROFINE APPLIANCES PRIVATE. LIMITED",
"LUCKY NUGGET GAMING PRIVATE LIMITED",
"LUCKY PHARMACEUTICALS PRIVATE LIMITED",
"LUCKY PLAST LIMITED",
"LUCKY PLY & LAMINATES",
"LUCKY PRIME FINANCIAL CONSULTANTS PRIVATE LIMITED",
"LUCKY PRINTS AND PACK PRIVATE LIMITED",
"LUCKY RETAIL STORES PRIVATE LIMITED",
"LUCKY SALES PROMOTION PVT LTD",
"LUCKY SEEDS PRIVATE LIMITED",
"LUCKY SILK STORE PRIVATE LIMITED",
"LUCKY STAR COMPUTERS INDIA PRIVATE LIMITED",
"LUCKY STAR ESTATEINDIAPRIVATE LIMITED",
"LUCKY STEEL FALSE CEILING SYSTEMS PRIVATE LIMITED",
"LUCKY STEEL INDUSTRIES SHIP BREAKING DIVISION",
"LUCKY STOCK BROKING PRIVATE LIMITED",
"LUCKY TEX SPINNERS LIMITED",
"LUCKY TEX-FAB PRIVATE LIMITED",
"LUCKY TRADING CO",
"LUCKY WEALTH CONSTRUCTION PRIVATE LIMITED",
"LUCKY WEALTHCONSTRUCTION PRIVATE LIMITED",
"LUCKY WEAVESS INDIA PRIVATE LIMITED",
"LUCKYS BAKERY PRIVATE LIMITED",
"LUCKYSTAR AUTOMOBILES PRIVATE LIMITED",
"LUCKYSTAR FOODS INDIA PRIVATE LIMITED",
"LUCKYSTAR PROPERTY HOLDING PRIVATE LIMITED",
"LUCKY-TECH MEMBRANES PRIVATE LIMITED",
"LUCKYYARN TEX INDIA PRIVATE LIMITED\n",
"LUCKYZONE AUTO PRIVATE LIMITED",
"LUCRATIVE ADVERTISING PRIVATE LIMITED",
"LUCRATIVE COMMERCIAL PRIVATE LTD",
"LUCRATIVE GLOBAL LOGISTICS LIMITED",
"LUCRATIVE IMPEX PRIVATE LIMITED",
"LUCRATIVE TRADING LLP",
"LUCRO PLASTECYCLE PRIVATE LIMITED",
"LUCROR TRADING & INDUSTRIES PRIVATE LIMITED",
"LUCROSE PHARMA PRIVATE LIMITED",
"LUCY ELECTRIC INDIA PRIVATE LIMITED",
"LUCY ELECTRIC MANUFACTURING AND TECHNOLOGIES INDIA PRIVATE LIMITED",
"LUCZOTIQ PRIVATE LIMITED",
"LUDHANI ESTATES PVT LTD",
"LUDHIANA BEVERAGES PRIVATE LIMITED",
"LUDHIANA BUILDERS",
"LUDHIANA CAPITAL SERVICES PRIVATE LIMITED",
"LUDHIANA CONSTRUCTIONS PVT LTD",
"LUDHIANA ENTERPRISES LIMITED",
"LUDHIANA FEED MILLS PRIVATE LIMITED",
"LUDHIANA FLOUR AND GENERAL MILLS PVT LTD",
"LUDHIANA GROUP OF COLLEGES",
"LUDHIANA HAND TOOLS (R&D) PRIVATE LIMITED",
"LUDHIANA HATCHERIES PRIVATE LIMITED",
"LUDHIANA KNIT-TECH PRIVATE LIMITED",
"LUDHIANA MEDIWAYS HOSPITAL",
"LUDHIANA MEDIWAYS PRIVATE LIMITED",
"LUDHIANA OIL EXPELLER AND PARTS MANUFACTURERS ASSOCIATION",
"LUDHIANA SCRIPS PRIVATE LIMITED",
"LUDHIANA STEEL ROLLING MILLS LIMITED",
"LUDHIANA TRANSPORT COMPANY PRIVATE LIMITED",
"LUDHIANA-SANGRUR INFRA ROAD PRIVATE LIMITED",
"LUDLOW JUTE & SPECIALITIES LIMITED",
"LUEZOID TECHNOLOGIES PRIVATE LIMITED",
"LUFT CAPITALS PRIVATE LIMITED",
"LUFT HOLIDAYS PRIVATE LIMITED",
"LUFTEK ENGINEERING PRIVATE LIMITED",
"LUFTHANSA GERMAN AIRLINES",
"LUFTHANSA TECHNIK SERVICES INDIA PRIVATE LIMITED",
"LUGUS PROJECTS PRIVATE LIMITED",
"LUHARI PAPERS TRADEX PRIVATE LIMITED",
"LUHARIWALA FINANCE AND INVESTMENT PRIVATE LTD",
"LUHARUKA COMMOTRADE PRIVATE LIMITED",
"LUHARUKA EXPORTS PRIVATE LIMITED",
"LUHARUKA INVESTMENT AND CONSULTANTS PRIVATE LIMITED",
"LUHARUKA MEDIA & INFRA LIMITED",
"LUHARUKA SALES & SERVICES PRIVATE LIMITED",
"LUHIT TEA COMPANY PVT LTD",
"LUIT COAL PRODUCTS PRIVATE LIMITED",
"LUJO TRENDS PRIVATE LIMITED",
"LUK BRICKS PRIVATE LIMITED",
"LUK INDIA LIMITED",
"LUK INFRASTRUCTURE PRIVATE LIMITED",
"LUK PLASTCON LIMITED",
"LUKE COUTINHO HOLISTIC HEALING SYSTEMS PRIVATE LIMITED",
"LUKE ELECTRONIC DEVICES PRIVATE LIMITED",
"LUKE SECURITIES PRIVATE LIMITED",
"LUKER ELECTRIC TECHNOLOGIES PRIVATE LIMITED",
"LUKKO SAFETY IMPEX PRIVATE LIMITED",
"LUKMAN FRUITS PRIVATE LIMITED",
"LUKOIL BENELUX B.V.",
"LULU CONVENTION AND EXHIBITION CENTER PRIVATE LIMITED",
"LULU CYBER PARK PRIVATE LIMITED",
"LULU FLIGHT KITCHEN PRIVATE LIMITED",
"LULU FOREX PRIVATE LIMITED",
"LULU HOSPITALITY PRIVATE LIMITED",
"LULU HYPERMARKET PRIVATE LIMITED",
"LULU INTERNATIONAL SHOPPING MALL PRIVATE LIMITED",
"LULU IT INFRABUILD PRIVATE LIMITED",
"LULU TECH PARK PRIVATE LIMITED",
"LULULEMON INDIA (SERVICES) PRIVATE LIMITED",
"LUMA OPTICS PRIVATE LIMITED",
"LUMALA INDUSTRIES PRIVATE LIMITED",
"LUMAN AUTOMOTIVE SYSTEMS PRIVATE LIMITED",
"LUMAN INDUSTRIES LIMITED",
"LUMASONIC TECH RENTAL PRIVATE LIMITED",
"LUMATEX INDIA PRIVATE LIMITED",
"LUMAX AUTO TECHNOLOGIES LIMITED",
"LUMAX AUTOMOTIVE CARE LIMITED",
"LUMAX AUTOMOTIVE COMPONENTS SYSTEMS",
"LUMAX CORNAGLIA AUTO TECHNOLOGIES PRIVATE LIMITED",
"LUMAX ELECTRONICS PRIVATE LIMITED",
"LUMAX FINANCE PRIVATE LIMITED",
"LUMAX GILL-AUSTEM AUTO TECHNOLOGIES PRIVATE LIMITED",
"LUMAX INDUSTRIES LIMITED",
"LUMAX ITURAN TELEMATICS PRIVATE LIMITED",
"LUMAX MANAGEMENT SERVICES PRIVATE LIMITED",
"LUMAX MANNOH ALLIED TECHNOLOGIES LIMITED",
"LUMAX TOURS & TRAVELS LIMITED",
"LUMAX YOKOWO TECHNOLOGIES PRIVATE LIMITED",
"LUMBER AND YARN INDIA PRIVATE LIMITED",
"LUMBINI AUTO PRIVATE LIMITED",
"LUMBINI BEVERAGES PRIVATE LIMITED",
"LUMBINI DEALCOM PVT.LTD.",
"LUMBUS SECURITY & MANPOWER PRIVATE LIMITED",
"LUMDING PLYWOOD PASTING PVT LTD",
"LUME SOLAR ENERGY PRIVATE LIMITED",
"LUMEC ENERGY PRIVATE LIMITED",
"LUMEDX HEALTHCARE TECHNOLOGIES INDIA PRIVATE LIMITED",
"LUMEN CERAMIC PRIVATE LIMITED",
"LUMEN ENGINEERING PRIVATE LIMITED",
"LUMEN IT INDIA PRIVATE LIMITED",
"LUMEN PHARMACHEM PRIVATE LIMITED",
"LUMEN STARTECH PRIVATE LIMITED",
"LUMEN TELE-SYSTEMS PVT LTD",
"LUMEN TRAVELS PRIVATE LIMITED",
"LUMEN21 INFOSERV PRIVATE LIMITED",
"LUMENIS INDIA PRIVATE LIMITED",
"LUMENS AIRCON PRIVATE LIMITED",
"LUMENS TECHNOLOGIES PRIVATE LIMITED",
"LUMENX ELECTRICAL PRIVATE LIMITED",
"LUMERA SOFTWARE SOLUTIONS PRIVATE LIMITED",
"LUMERIS INDIA PRIVATE LIMITED",
"LUMESSE INDIA PRIVATE LIMITED",
"LUMETIQ INDUSTRIES PRIVATE LIMITED",
"LUMEX DIAMOND SERVICES PRIVATE LIMITED",
"LUMEX TOWN PLANNERS PRIVATE LIMITED",
"LUMICOM VISUAL SOLUTIONS PRIVATE LIMITED",
"LUMIERE BUSINESS SOLUTIONS PRIVATE LIMITED",
"LUMIERE COOLANTS LIMITED",
"LUMIERE COOLANTS PRIVATE LIMITED",
"LUMIERE LIFE SCIENCES PRIVATE LIMITED",
"LUMIERE SECURITY SERVICES PRIVATE LIMITED",
"LUMIERE TECHNOLOGIES PRIVATE LIMITED",
"LUMILEDS INDIA PRIVATE LIMITED",
"LUMINA DATAMATICS LIMITED",
"LUMINARY LIFESTYLE PRIVATE LIMITED",
"LUMINARY PROFESSIONAL SERVICES PRIVATE LIMITED",
"LUMINASIC PRIVATE LIMITED",
"LUMINAZ SAFETY GLASS PRIVATE LIMITED",
"LUMINEX TECHNOSYS PRIVATE LIMITED",
"LUMINIQUE INFRA PRIVATE LIMITED",
"LUMINO GLOZ SOLUTIONS PRIVATE LIMITED",
"LUMINO INDUSTRIES LIMITED",
"LUMINO POWER INFRASTRUCTURE PRIVATE LIMITED",
"LUMINOR FASHION PRIVATE LIMITED",
"LUMINOUS EXPRESS CARGO PRIVATE LIMITED",
"LUMINOUS INFOWAYS PRIVATE LIMITED",
"LUMINOUS MOBILE ACCESSORIES PRIVATE LIMITED",
"LUMINOUS POWER TECHNOLOGIES PRIVATE LIMITED",
"LUMINOUS TECHNOCAST PRIVATE LIMITED",
"LUMINUX ENERGY PRIVATE LIMITED",
"LUMIPLAN INTELLIGENT TRANSPORT SYSTEMS INDIA PRIVATE LIMITED",
"LUMIRISE PRIVATE LIMITED",
"LUMIS BIOTECH PRIVATE LIMITED",
"LUMIS CONSULTING PARTNERS INDIA PRIVATE LIMITED",
"LUMISENSE OPTOELECTRONICS PRIVATE LIMITED",
"LUMIUM INNOVATIONS PRIVATE LIMITED",
"LUMIXTRA LIGHTING PRIVATE LIMITED",
"LUMMUS TECHNOLOGY HEAT TRANSFER B V",
"LUMOS BUILDING AUTOMATION PRIVATE LIMITED",
"LUMOS INFRA PRIVATE LIMITED",
"LUMOS LEARNING INDIA PRIVATE LIMITED",
"LUMPI-BERNDORF DRAHT-UND SEILWERK PRIVATE LIMITED",
"LUNA ABRASIVI INDIA PRIVATE LIMITED",
"LUNA INDIA PRIVATE LIMITED",
"LUNA PLASTIC WORKS PVT. LTD.",
"LUNA SIL PRIVATE LIMITED",
"LUNA TECHNOLOGIES PRIVATE LIMITED",
"LUNA TYRES PVT LTD",
"LUNAR ASTRO VEDIC ACADEMY (OPC) PRIVATE LIMITED",
"LUNAR CHEMICALS PRIVATE LIMITED",
"LUNAR COMMERCIALS PVT LTD",
"LUNAR ELECTRICALS PRIVATE LIMITED",
"LUNAR ENTERPRISE PRIVATE LIMITED",
"LUNAR EXPORTS PRIVATE LIMITED",
"LUNAR MOTORS PRIVATE LIMITED",
"LUNAR RUBBERS PVT LTD",
"LUNARMECH MACHINENFABRIK LIMITED",
"LUNARMECH TECHNOLOGIES PRIVATE LIMITED",
"LUNAWAT GEMS",
"LUND AND BLOCKLEY PVT LTD",
"LUNDBECK INDIA PRIVATE LIMITED",
"LUNG CARE INDIA PRIVATE LIMITED",
"LUNGMAR REMOTE CAMP PRIVATE LIMITED",
"LUNI EXPORT TRADING PRIVATE LIMITED",
"LUNIA EXIM PRIVATE LIMITED",
"LUNIA MARKETING PRIVATE LIMITED",
"LUNKAD ALUMINIUM LIMITED",
"LUNKER AGENCIES PRIVATE LIMITED",
"LUOVA TECHNOLOGIES PRIVATE LIMITED",
"LUPIN BUILDCAP PRIVATE LIMITED",
"LUPIN DIAGNOSTICS LIMITED",
"LUPIN FORGING PRIVATE LIMITED",
"LUPIN GASES PVT. LTD.",
"LUPIN INVESTMENTS PRIVATE LIMITED",
"LUPIN LIMITED",
"LUPIN VENTURES PRIVATE LIMITED",
"LUPITAS PHARMACEUTICALS PRIVATE LIMITED",
"LURE NAILS AND SPA SOLUTIONS PRIVATE LIMITED",
"LURGI INDIA INTERNATIONAL SERVICES PRIVATE LIMITED",
"LURK ESTATE PRIVATE LIMITED",
"LUSH ESTATES PVT LTD",
"LUSH FINANCE AND INVESTMENTS PRIVATE LIMITED",
"LUSNT TECHNOLOGIES PRIVATE LIMITED",
"LUSTER AUTOMOTIVE PRIVATE LIMITED",
"LUSTER GOLD PALACE INDIA PRIVATE LIMITED",
"LUSTER SPECIALITY PAPERS PRIVATE LIMITED",
"LUSTER TYRES PRIVATE LIMITED",
"LUSTRE PHARMACEUTICALS PRIVATE LIMITED",
"LUSTRE PRESS PRIVATE LIMITED",
"LUTECH RESOURCES INDIA PRIVATE LIMITED",
"LUTF FOODS PRIVATE LIMITED",
"LUTHERAN HIGH SCHOOL",
"LUTHRA CHEM TEX INDUSTRIES LIMITED",
"LUTHRA GROUP LLP",
"LUTHRA HANDLOOM INDUSTRIES PRIVATE LIMITED",
"LUTHRA HOSPITALS PRIVATE LIMITED",
"LUTHRA MOTORS PRIVATE LIMITED",
"LUTHRA PRECISION INSTRUMENTS PRIVATE LIMITED",
"LUTHRA TEXTILES LTD",
"LUTHRIA INCENSE AND ESTATES PRIVATE LIMITED",
"LUTIM PHARMA PRIVATE LIMITED",
"LUTON CERAMIC PRIVATE LIMITED",
"LUTRON GL SALES AND SERVICES PRIVATE LIM ITED",
"LUTRON GL SALES AND SERVICES PRIVATE LIMITED",
"LUV JEWELLERY PRIVATE LIMITED",
"LUV KUSH BUILDCON PRIVATE LIMITED",
"LUV KUSH PROJECTS LIMITED",
"LUV MULTI TRADE (INDIA) PRIVATE LIMITED",
"LUV REAL ESTATE PRIVATE LIMITED",
"LUVAC BUSINESS PRIVATE LIMITED",
"LUVISH GREEN ACRES PRIVATE LIMITED",
"LUVKESH TEXTILE INDUSTRIES PRIVATE LIMITED",
"LUVKKUSH SILK MILLS PRIVATE LIMITED",
"LUVYA MEDICARE PRIVATE LIMITED",
"LUVYANSH ENTERPRISE",
"LUWA INDIA PRIVATE LIMITED",
"LUX FLAVOURS.",
"LUX INDUSTRIES LIMITED",
"LUXABODE HOTELS PRIVATE LIMITED",
"LUXAYOR FASHION INDIA PRIVATE LIMITED",
"LUXCERA GLOBAL PRIVATE LIMITED",
"LUXE OPERA HOTELS AND RESORTS PRIVATE LIMITED",
"LUXE RETAIL COMPANY PRIVATE LIMITED",
"LUXEBUILT HOMES PRIVATE LIMITED",
"LUXEPOLIS RETAIL SERVICES PRIVATE LIMITED",
"LUXERATI RETAIL PRIVATE LIMITED",
"LUXEVA INDIA PRIVATE LIMITED",
"LUXLIGHTING TECHNOLOGY PRIVATE LIMITED",
"LUXMI ASSOCIATES PRIVATE LIMITED",
"LUXMI CASTINGS INDIA",
"LUXMI CLORO CHEM PRIVATE LIMITED",
"LUXMI DIES & MOULDS PRIVATE LIMITED",
"LUXMI MEDICHEM PRIVATE LIMITED",
"LUXMI NARAIN PIPES PRIVATE LIMITED",
"LUXMI PREMIUM GRAINS INDIA PRIVATE LIMITED",
"LUXMI RICE MILL",
"LUXMI RICE MILLS",
"LUXMI SPINNING MILLS PVT LTD",
"LUXMI SWITCHGEARS PRIVATE LIMITED",
"LUXMI TEA CO PRIVATE LIMITED",
"LUXMI TOWNSHIP & HOLDINGS LIMITED",
"LUXMI TRADING & POWERPROJECT PRIVATE LIMITED",
"LUXOFT INDIA LLP",
"LUXON MOTORS PRIVATE LIMITED",
"LUXOR IMPEX PRIVATE LIMITED",
"LUXOR INTERNATIONAL PRIVATE LIMITED",
"LUXOR LOGISTICS PRIVATE LIMITED",
"LUXOR NANO TECHNOLOGY PRIVATE LIMITED",
"LUXOR WRITING INSTRUMENTS PRIVATE LIMITED",
"LUXOTTICA INDIA EYEWEAR PRIVATE LIMITED",
"LUXOX FURNITURE PRIVATE LIMITED",
"LUXRA ENTERPRISES PRIVATE LIMITED",
"LUXRA SOLAR INDIA PRIVATE LIMITED",
"LUXSH SOLUTIONS PRIVATE LIMITED",
"LUXSOLI ENERGY PRIVATE LIMITED",
"LUXSUM ENTERPRISES (OPC) PRIVATE LIMITED",
"LUXTURE SURFACE COATINGS PRIVATE LIMITED",
"LUXUR CABLES PRIVATE LIMITED",
"LUXURY DIAMOND PRIVATE LIMITED",
"LUXURY FACILITIES MAINTENANCE SERVICES PRIVATE LIMITED",
"LUXURY GOODS RETAIL PRIVATE LIMITED",
"LUXURY HOUSING PRIVATE LIMITED",
"LUXURY JEWELRY (INDIA) PRIVATE LIMITED",
"LUXURY LIFESTYLE TRADING INDIA PRIVATE LIMITED",
"LUXURY LINK INDIA PRIVATE LIMITED",
"LUXURY ONLINE RETAIL INDIA PRIVATE LIMITED",
"LUXURY PRODUCTS TRENDSETTER PRIVATE LIMITED",
"LUXURY RIDE INDIA PRIVATE LIMITED",
"LUXURY SAND KERALA PRIVATE LIMITED",
"LUXURY TIME PRIVATE LIMITED",
"LUXURY WATCH WORKS PRIVATE LIMITED",
"LUXURYCO TECH SERVICES PRIVATE LIMITED",
"LUXUS FACADE SOLUTIONS PRIVATE LIMITED",
"LUXUS INDIA PRIVATE LIMITED",
"LUXUS RETAIL PRIVATE LIMITED",
"LUXXERA LIFESTYLE INDIA PRIVATE LIMITED (OPC)",
"LUXZI PRIVATE LIMITED",
"LUZO INDIA EXIM PRIVATE LIMITED",
"LV ENTERPRISES PRIVATE LIMITED",
"LV PRASAD EYE INSTITUTE",
"LVD-STRIPPIT INDIA PRIVATE LIMITED",
"LVG FACILITIES INDIA PRIVATE LIMITED",
"LVJ INVESTMENTS PRIVATE LIMITED",
"LVJ MOTORS PRIVATE LIMITED",
"LVJ PROJECTS PRIVATE LIMITED",
"LVJ TRADING PRIVATE LIMITED",
"LVK PROPERTIES PRIVATE LIMITED",
"LVMH WATCH AND JEWELLERY INDIA PRIVATE LIMITED",
"LVR CONSUMER PRIVATE LIMITED",
"LVR DISTILLERIES AND BREWERIES PRIVATE LIMITED",
"LVS EARTHMOVERS PRIVATE LIMITED",
"LVS POWER LIMITED",
"LW SHIPPING PRIVATE LIMITED",
"LW STRATEGY CONSULTING PRIVATE LIMITED",
"LWP HEALTH DIAGNOSTICS SERVICES PRIVATE LIMITED",
"LX FINANCIAL SERVICES PRIVATE LIMITED",
"LX HAUSYS INDIA PRIVATE LIMITED",
"LX INFRASTRUCTURE LIMITED",
"LX INTERNATIONAL INDIA PRIVATE LIMITED",
"LX MARKETING PRIVATE LIMITED",
"LX PANTOS INDIA PRIVATE LIMITED",
"LX PANTOS SOLUTIONS INDIA PRIVATE LIMITED",
"LXIR MEDILABS PRIVATE LIMITED",
"LXL IDEAS PRIVATE LIMITED",
"LYALLPUR EMPORIUM PRIVATE LIMITED",
"LYALLPUR UNIFORMS PRIVATE LIMITED",
"LYBLEY INDIA PRIVATE LIMITED",
"LYBRATE INDIA PRIVATE LIMITED",
"LYCA DIGITAL PRIVATE LIMITED",
"LYCA FLY PRIVATE LIMITED",
"LYCA PRODUCTIONS PRIVATE LIMITED",
"LYCA TELECOM PRIVATE LIMITED",
"LYCAST TECHNOLOGY PRIVATE LIMITED",
"LYCATEL BPO PRIVATE LIMITED",
"LYCEE FRANCAIS INTERNATIONAL DE DELHI",
"LYCEUM DEVELOPMENT CENTER PRIVATE LIMITED",
"LYCLIA AGROFRESH PRIVATE LIMITED",
"LYCOS CERAMIC PRIVATE LIMITED",
"LYCOS INDIA LIMITED",
"LYEARN SOFTWARE DEVELOPMENT INDIA PRIVATE LIMITED",
"LYFBOAT TECHNOLOGIES PRIVATE LIMITED",
"LYK IT TRADERS PRIVATE LIMITED",
"LYKA EXPORTS LIMITED",
"LYKA GENERICS LIMITED",
"LYKA HEALTHCARE LIMITED",
"LYKA LABS LIMITED",
"LYKA PACKAGING PRIVATE LIMITED",
"LYKIS LIMITED",
"LYKIS MARKETING PRIVATE LIMITED",
"LYMPRO CHEM PRIVATE LIMITED",
"LYNCBIZ INDIA PRIVATE LIMITED",
"LYNCIS TECHNOLOGIES INDIA PRIVATE LIMITED",
"LYNKIT SOLUTIONS PRIVATE LIMITED",
"LYNKS LOGISTICS LIMITED",
"LYNN PUMPS PRIVATE LIMITED",
"LYNTEX POLYMERS PRIVATE LIMITED",
"LYNX COMMUNICATION SYSTEMS PRIVATE LIMITED",
"LYNX COMPUTERS PVT LTD",
"LYNX DESIGNERS AND CREATORS PRIVATE LIMITED",
"LYNX MANAGEMENT SERVICES PRIVATE LIMITED",
"LYNX PACKAGING (INDIA) PRIVATE LIMITED",
"LYNX SECURITY AND DETECTIVE SERVICES PRIVATE LIMITED",
"LYNX SECURITY SERVICES PRIVATE LIMITED",
"LYNX SYNERGY AND SOLUTIONS PRIVATE LIMITED",
"LYNX TOOLS & COMPONENTS PRIVATE LIMITED",
"LYON GOODS PRIVATE LIMITED",
"LYON INVESTMENT AND INDUSTRIES PRIVATE LIMITED",
"LYONS ENGINEERING PRIVATE LIMITED",
"LYOPHILIZATION SYSTEMS INDIA PRIVATE LIMITED",
"LYOR LIFE PLATFORM SERVICES PRIVATE LIMITED",
"LYPSA GEMS & JEWELLERY LIMITED",
"LYRA INFOSYSTEMS PRIVATE LIMITED",
"LYRA LABORATORIES PRIVATE LIMITED",
"LYRA NETWORK PRIVATE LIMITED",
"LYREBIRD ELECTRO INDIA PRIVATE LIMITED",
"LYRICS DECOR PRIVATE LIMITED",
"LYRUS FITNESS",
"LYRUS LIFE SCIENCES PRIVATE LIMITED",
"LYSAGHT TAPERLINE POLES PRIVATE LIMITED",
"LYTAGE ELECTRIC PRIVATE LIMITED",
"LYV BRANDS PRIVATE LIMITED",
"LYXEL LABS PRIVATE LIMITED",
"LZWL MOTORS INDIA PRIVATE LIMITED",
"M & B ENGINEERING LIMITED",
"M & B FOOTWEAR PRIVATE LIMITED",
"M & N RETAIL PRIVATE LIMITED",
"M & P CLEARING & FORWARDING AGENCIES PRIVATE LIMITED",
"M & S BOTTLING COMPANY",
"M A ARCHITECTS PRIVATE LIMITED",
"M A INFRA POWER PRIVATE LIMITED",
"M A K MATRICULATION HIGHER SECONDARY SCHOOL",
"M A OIL PACKAGING & HANDLING PRIVATE LIMITED",
"M A PODAR HOSPITAL",
"M A R ANGLO URDU SEC SCH JALGAON",
"M A S D PUBLIC SEN SEC SCHOOL",
"M A SIDDHIKI ENTERPRISES",
"M A TEXTILES PRIVATE LIMITED",
"M ACER AUTOMOTIVE SYSTEMS PRIVATE LIMITED",
"M AGARWAL STOCK BROKERS PRIVATE LIMITED",
"M AHUJA PROJECT (INDIA) PRIVATE LIMITED",
"M AND A ASSOCIATES PRIVATE LIMITED",
"M AND C AVIATION INDIA PRIVATE LIMITED",
"M AND C PROPERTY DEVELOPMENT PRIVATE LIMITED",
"M AND COMPANY ENGINEERS AND CONTRACTORS PRIVATE LIMITED",
"M AND K BUILDING SYSTEMS PRIVATE LIMITED",
"M AND M ENGINEERS GUJARAT PRIVATE LIMITED",
"M AND M FESTIVAL SHOPPING CENTRE PRIVATE LIMITED",
"M AND R FURNISHING PRIVATE LIMITED",
"M AND V MARKETING AND SALES PRIVATE LIMITED",
"M AND W ASSOCIATES PRIVATE LIMITED",
"M B AND K PHARMA PRIVATE LIMITED",
"M B AND SONS FABRICS PRIVATE LIMITED",
"M B ASHTEKAR JEWELLERS PRIVATE LIMITED",
"M B AUTOWHEELS PRIVATE LIMITED",
"M B BODA RE-INSURANCE BROKERS PRIVATE LIMITED",
"M B CASTING PRIVATE LIMITED",
"M B D HOTELS PRIVATE LIMITED",
"M B ENGINEERING INDUSTRIES PRIVATE LIMITED",
"M B ENTERPRISES PRIVATE LIMITED",
"M B EXPORTS LIMITED",
"M B FLOUR MILL INDUSTRIES PRIVATE LIMITED",
"M B GRAMMAR HIGH SCHOOL",
"M B H PUMPS (GUJARAT) PRIVATE LIMITED",
"M B I POWDER COATINGS PRIVATE LIMITED",
"M B IMPEX SERVICES PRIVATE LIMITED",
"M B INFRAPROJECTS PRIVATE LIMITED",
"M B ISPAT CORPORATION LIMITED",
"M B JEWELLERS AND SONS PRIVATE LIMITED",
"M B M INDIA PRIVATE LIMITED",
"M B PIMPALGAONKAR JEWELLERS PRIVATE LIMITED",
"M B PLYWOOD INDUSTRIES PVT LTD",
"M B PROCESSORS PRIVATE LIMITED",
"M B RUBBER PRIVATE LIMITED",
"M B SUGARS AND PHARMACEUTICALS PRIVATE LIMITED",
"M B TEA & ALLIED PRODUCTS PRIVATE LIMITED",
"M B TEXFAB PRIVATE LIMITED",
"M B TUBES PVT LTD",
"M BHATTACHARYYA & CO PVT LTD",
"M C DAVAR HOLDINGS PRIVATE LIMITED",
"M C GOPICHAND INTER COLLEGE",
"M C KEJRIWAL VIDYAPEETH",
"M C M CHENNAI INFRASTRUCTURE PRIVATE LIMITED",
"M C MEDICAL SERVICES PRIVATE LIMITED",
"M C MOWJEE & COMPANY PVT LTD",
"M C O HOSPITAL AIDS PRIVATE LIMITED",
"M C P MOTORS (INDIA) PRIVATE LIMITED",
"M C P ROSE SUPERMARKET PRIVATE LIMITED",
"M C S M",
"M C SALES PRIVATE LIMITED",
"M C TB CONTROL SOCIETY CHH SAMBHAJINAGAR",
"M C TUBES PVT LTD",
"M CHEM INDIA PRIVATE LIMITED",
"M CHRISTAIN COLLEGE",
"M CHUNIBHAI PATEL & CO",
"M CRISTAIN COLLEGE",
"M CRITICAL INFRASTRUCTURE CONSULTING PRIVATE LIMITED",
"M CUBE PROFILES PRIVATE LIMITED",
"M D AUTO COMPONENTS PRIVATE LIMITED",
"M D COMPUTERS PRIVATE LIMITED",
"M D ENTERPRISES",
"M D GLOBUS REALTY PRIVATE LIMITED",
"M D GRAPHICS PRIVATE LIMITED",
"M D M M CONSULTANTS PRIVATE LIMITED",
"M D OVERSEAS PRIVATE LIMITED",
"M D PRINTING AND PACKAGING PRIVATE LIMITED",
"M D SHUKLA SHARE AND SECURITIES PRIVATE LIMITED",
"M DEAN CHEMICALS PRIVATE LIMITED",
"M DINSHAW & RANJIT HOTELS PRIVATE LIMITED",
"M E C INTERNATIONAL PRIVATE LIMITED",
"M E DECOR PRIVATE LIMITED",
"M E ENERGY PRIVATE LIMITED",
"M E HYDRAULICS PRIVATE LIMITED",
"M F ENTERTAINMENT & AMUSEMENT PRIVATE LIMITED",
"M F RINGS AND BEARING RACES LIMITED",
"M F RINGS AND BEARING RACES PRIVATE LIMITED",
"M F S CONSULTANCY PRIVATE LIMITED",
"M F T ROADLINES PRIVATE LIMITED",
"M FAR HOLDINGS PRIVATE LIMITED",
"M FUEL KART PRIVATE LIMITED",
"M G APPARELS PRIVATE LIMITED",
"M G AUTOMOTIVES PRIVATE LIMITED",
"M G BROTHERS PRIVATE LIMITED",
"M G CHARITABLE TRUST",
"M G CHOPRA TEXTILES PVT LTD",
"M G COMPUTERS PRIVATE LIMITED.",
"M G CONTRACTORS PRIVATE LIMITED",
"M G ELECTRONICS LIMITED",
"M G F DEVELOPMENTS LIMITED",
"M G F MOTORS LIMITED",
"M G FOOTWEAR INDIA PRIVATE LIMITED",
"M G G S INT COLL VIJAY GARH ALIGARH",
"M G GLOBAL LIMITED",
"M G M INTER COLLEGE",
"M G M SPRINGS PRIVATE LIMITED",
"M G M STONE CRUSHERS PRIVATE LIMITED",
"M G POLY COAT PRIVATE LIMITED",
"M G R ADARSH SCHOOL",
"M G R AUTOMOBILES PRIVATE LIMITED",
"M G R FRUITS PRIVATE LIMITED",
"M G REALINFRA PRIVATE LIMITED",
"M G S INDIA PRIVATE LIMITED",
"M G S INT COLL SONKH MATHURA",
"M G T MOTORS PRIVATE LIMITED",
"M G TOOLS PRIVATE LIMITED",
"M GANDHI VIDYALAYA",
"M GANESH",
"M GULAB SINGH AND SONS PRIVATE LIMITED",
"M GURU CONTROLS PVT LTD",
"M H K EXPORTS PRIVATE LIMITED",
"M H MEDICUS PRIVATE LIMITED",
"M H METALIC PRODUCTS INDIA PRIVATE LIMITED",
"M H PACKAGING PRIVATE LIMITED",
"M H S MEDICARE INDIA PRIVATE LIMITED",
"M H SABOO SIDDIK TECH HIGH SCHOOL & JR COLLEGE",
"M H SHINDE MAHAVIDYALAYA TISANGI",
"M H SHINDE MAHAVIDYALAYA TISANGI GAGANBAWDA",
"M H VALVES PVT LTD",
"M HOSSAIN TEACHERS TRAINING INSTITUTE",
"M I A CONSTRUCTION PRIVATE LIMITED",
"M I BUILDERS PRIVATE LIMITED",
"M I FOOTWEAR COMPONENTS PRIVATE LIMITED",
"M I M E R MEDICAL COLLEGE",
"M I MISSION HOSPITAL",
"M I OVERSEAS LTD",
"M I PHARMA PRIVATE LIMITED",
"M I S T DEGREE COLLEGE",
"M I T R A AGRO EQUIPMENTS PRIVATE LIMITED",
"M I/W S Z P SUB DIVISION NILANGA",
"M J ALLOYS PVT LTD",
"M J BIOPHARM PRIVATE LIMITED",
"M J CASTING LIMITED",
"M J GOLD PRIVATE LIMITED",
"M J HEALTHCARE PRIVATE LIMITED",
"M J M ART'S COMMERCE & SCIENCE COLLEGE KARANJALI",
"M J P ENTERPRISES PRIVATE LIMITED",
"M J PATEL SHARE AND STOCK BROKERS LIMITED",
"M J PLASTEK",
"M J PRINTPACKAGING PRIVATE LIMITED",
"M J PROPERTY MAINTENANCE SERVICES PRIVATE LIMITED",
"M J S MANDAL S INSTITUTE OF MANAGEMENT",
"M J TEXTILES (SURAT) PRIVATE LIMITED",
"M J WAREHOUSING PRIVATE LIMITED",
"M K AGROTECH PRIVATE LIMITED",
"M K AIRCON SYSTEMS PRIVATE LIMITED",
"M K AND SONS ENGINEERING PRIVATE LIMITED",
"M K B SALES AND MARKETING PRIVATE LIMITED",
"M K C AGRO FRESH LIMITED",
"M K COLOURTECH PRIVATE LIMITED",
"M K CYCLES PVT LTD",
"M K DISTRIBUTORS PVT LTD",
"M K ENGINEERS AND CONTROLS PRIVATE LIMITED",
"M K ES INSTITUTE OF MANAGEMENT STUDIES & RESEARCH",
"M K EXIM INDIA LIMITED",
"M K FASHION HUB PRIVATE LIMITED",
"M K FINTEX PRIVATE LIMITED",
"M K GASTECH PRIVATE LIMITED",
"M K HI TECH SOLUTIONS PRIVATE LIMITED",
"M K INFO SYSTEMS PRIVATE LIMITED",
"M K INFOSYSTEMS PRIVATE LIMITED",
"M K INTERNATIONAL REALTY PRIVATE LIMITED",
"M K IRON PRIVATE LIMITED",
"M K JAIN BUILDERS PVT LTD",
"M K JOKAI AGRI PLANTATIONS PRIVATE LIMITED",
"M K K METAL SECTIONS PRIVATE LIMITED",
"M K LUMBERS PRIVATE LIMITED",
"M K M TECHNOLOGIES PRIVATE LIMITED",
"M K MOBILES PRIVATE LIMITED",
"M K N BRICKS AND BLUE METALS PRIVATE LIMITED",
"M K N COMMODITY BROKERS PRIVATE LIMITED",
"M K NADKARNI HIGH SCHOOL",
"M K PETRO PRODUCTS INDIA PRIVATE LIMITED",
"M K PRECISION METAL PARTS PRIVATE LIMITED",
"M K PRINTPACK PRIVATE LIMITED",
"M K PROTEINS LIMITED",
"M K ROY & BROS PROJECTS LIMITED",
"M K SAHOO & ASSOCIATES",
"M K SHINDE VIDYALAYA",
"M K SHIPPING AND ALLIED INDUSTRIES PRIVATE LIMITED",
"M K SILICONE PRODUCTS PRIVATE LIMITED",
"M K SONS FINE JEWELS PRIVATE LIMITED",
"M K SPUNTEX PRIVATE LIMITED",
"M K SRINIVASAN SYSTEMS PRIVATE LIMITED",
"M K TEA PVT LTD",
"M K U LIMITED",
"M K U PRIVATE LIMITED",
"M K VELVETS PRIVATE LIMITED",
"M KUMARASAMY COLLEGE OF ENGINEERING",
"M L AGGARWAL HOSIERY PRIVATE LIMITED",
"M L AGROFOODS PRIVATE LIMITED",
"M L B PRODUCTS PRIVATE LIMITED",
"M L IMAGE PERFECT CONCEPTS PRIVATE LIMITED",
"M L JUBLEE INSTITUTION",
"M L K EXPORTS PRIVATE LIMITED",
"M L M FACILITY SERVICES",
"M L MANSUKHANI AND CO PVT LTD",
"M L P ADVANCE HEALTH CARE SYSTEMS PRIVATE LIMITED",
"M L R FOODS PROCESSING PRIVATE LIMITED",
"M L S MARKETING PRIVATE LIMITED",
"M L SHARMA AND CO (CONSTRUCTION) PRIVATE LIMITED",
"M L SPINNERS PRIVATE LIMITED",
"M L TRADERS PRIVATE LIMITED",
"M L YARN (INDIA) PRIVATE LIMITED",
"M LAKHAMSI INDUSTRIES LIMITED",
"M- LITE SOLAR",
"M LIVE EVENTS AND PROMOTIONS PRIVATE LIMITED",
"M M AGENCIES AND ENGINEERING",
"M M AROCHEM PRIVATE LIMITED",
"M M CASTINGS PRIVATE LIMITED",
"M M CREATIONS",
"M M DEVELOPERS SHRAMJIVI",
"M M DIAGNOSTICS PRIVATE LIMITED",
"M M DOTCOM GRAPHICS PRIVATE LIMITED",
"M M EMPORIUM PRIVATE LIMITED",
"M M ENGINEERS PRIVATE LIMITED",
"M M ENTERPRISES",
"M M ENVIRO PROJECTS PRIVATE LIMITED",
"M M EYETECH PRIVATE LIMITED",
"M M FISHERIES PRIVATE LIMITED",
"M M HEALTHCARE LIMITED",
"M M I SOFTWARES PRIVATE LIMITED",
"M M INDUSTRIAL CONTROLS PRIVATE LIMITED",
"M M K COLLEGE OF COMMERCE & ECONOMICS",
"M M MEMORIAL PUBLIC SR SEC SCHOOL",
"M M METACRAFT PRIVATE LIMITED",
"M M MITHAIWALA PRIVATE LIMITED",
"M M N PRE PROFESSIONAL EDUCATION NILANGA",
"M M NAGALINGAM REFINERIES PRIVATE LIMITED",
"M M PLASTOWARE INDIA PRIVATE LIMITED",
"M M POLYMERS PRIVATE LIMITED",
"M M POONJIAJI SPICES LIMITED",
"M M PRASAD CONSTRUCTION PRIVATE LIMITED",
"M M PRINTERS A DIVISION OF MODI MOTORS PVT LTD",
"M M PROJECT CONSULTANTS PRIVATE LIMITED",
"M M RABHANI H S KAMPTEE",
"M M RUBBER COMPANY LIMITED",
"M M S STEEL PRIVATE LIMITED",
"M M SHERRY HSS SHAHZADI MANDI AGRA",
"M M SONS TRAVELS PRIVATE LIMITED",
"M M STEEL PRIVATE LIMITED",
"M M T DISTRIBUTORS PRIVATE LIMITED",
"M M TRADERS PRIVATE LIMITED",
"M M VORA AUTOMOBILES PRIVATE LIMITED",
"M MONKS DIGITAL MEDIA PRIVATE LIMITED",
"M MOSER DESIGN ASSOCIATES INDIA PRIVATE LIMITED",
"M N AUTO PRODUCTS PRIVATE LIMITED",
"M N DASTUR & COMPANY P LTD",
"M N P PRATHMIK SHALA RAMNAGAR",
"M N POLYTEX PRIVATE LIMITED",
"M N STEEL CRAFTS PVT LTD",
"M N SURFACTANTS PRIVATE LIMITED",
"M N W COLLEGE",
"M N WORLD ENTERPRISE PRIVATE LIMITED",
"M NELLAIYAH ROLLING MILL PRIVATE LIMITED",
"M P AGARWALA PRIVATE LIMITED",
"M P AUDYOGIK KENDRAVIKAS NIGAM LIMITED",
"M P B METALS PRIVATE LIMITED",
"M P BIRLA FOUNDATION H S SCHOOL",
"M P BLOWERS PRIVATE LIMITED",
"M P CONVERTERS PVT LTD",
"M P COUNCIL OF SCIENCE & TECHNOLOGY",
"M P DYE CHEM INDUSTRIES PRIVATE LIMITED",
"M P E B",
"M P ENGINEERING CONSTRUCTIONS INDIA PRIVATE LIMITED",
"M P FAB PRIVATE LIMITED",
"M P HOUSING AND INFRASTRUCTURE DEVELOPMENT BOARD",
"M P INFRAESTATE PRIVATE LIMITED",
"M P INTEGRATED ROOFING PRIVATE LIMITED",
"M P M INTER COLLEGE",
"M P PATEL KANYA VIDYALAYA",
"M P POWER MANAGEMENT COMPANY LIMITED",
"M P PUBLIC SCHOOL",
"M P RAJYA SAHAKARI BANK MARYADIT",
"M P S DISTRIBUTORS PRIVATE LIMITED",
"M P S STEELS PRIVATE LIMITED",
"M P SANGHVI INVESTMENS PVT LTD",
"M P SECRETARIATE",
"M P VIDHAN SABHA",
"M P WAREHOSING AND LOGISTICS CORPORATION UJJAIN",
"M P WAREHOUSING AND LOGISTICS CORPORATION",
"M P WIRES & CONDUCTORS PVT LTD",
"M P WOOD AND MILL PRIVATE LIMITED",
"M PALLONJI AND COMPANY PRIVATE LIMITED",
"M PALLONJI SHIPPING PVT LTD",
"M PANELS RESEARCH SERVICES PRIVATE LIMITED",
"M PLUS PARKING SERVICES PRIVATE LIMITED",
"M POWER ENERGY INDIA PRIVATE LIMITED",
"M POWER INDIA PRIVATE LIMITED",
"M POWER MICRO FINANCE PRIVATE LIMITED",
"M PRATAPRAY PRINTS PVT LTD",
"M QUE TRANSPORT PRIVATE LIMITED",
"M R AGRAULIC EXPERTS",
"M R BUSINESS PRIVATE LIMITED",
"M R CLEAN SERVICES PRIVATE LIMITED",
"M R CREATION PRIVATE LIMITED",
"M R D EXPORTS PRIVATE LIMITED",
"M R DAIRY PRODUCTS PRIVATE LIMITED",
"M R DECOR PRIVATE LIMITED",
"M R DIES",
"M R ELECTRONICS PRIVATE LIMITED",
"M R EMPORIUM PVT LTD",
"M R FINLEASE LIMITED",
"M R G CONSULTANTS PRIVATE LIMITED",
"M R GUPTA AND COMPANY PRIVATE LIMITED",
"M R HOSPITALS",
"M R HY-TEK EQUIPMENTS PRIVATE LIMITED",
"M R INDUSTRIES",
"M R INFRAESTATE PRIVATE LIMITED",
"M R K R CONSTRUCTIONS AND INDUSTRIES PRIVATE LIMITED",
"M R L POSNET PRIVATE LIMITED",
"M R M AUTOS PVT LTD",
"M R M COLLEGE OF PHARMACY",
"M R M PROCOM PRIVATE LIMITED",
"M R M RAMAIYA ENTERPRICES PRIVATE LIMITED",
"M R OVERSEAS PRIVATE LIMITED",
"M R PRO TECH PRIVATE LIMITED",
"M R REAL FOOD PRIVATE LIMITED",
"M R REALTY PRIVATE LIMITED",
"M R SHIPPING PRIVATE LIMITED",
"M R STEEL CORPORATION",
"M R SYNTHETICS PRIVATE LIMITED",
"M R T FARM PRIVATE LIMITED",
"M R T SIGNALS LIMITED",
"M R T STUDIOS PRIVATE LIMITED",
"M R TEA PLANTATION PVT LTD",
"M R TELECARE PRIVATE LIMITED",
"M R TEX PRIVATE LIMITED",
"M R UTILITY PRODUCTS PRIVATE LIMITED",
"M R WARERKAR AND ASSOCIATES PRIVATE LIMITED",
"M R.TECHNOFIN CONSULTANTS PRIVATE LIMITED",
"M RAJKRISHNA TRADING PRIVATE LIMITED",
"M S AHUJA AGRO FOODS PRIVATE LIMITED",
"M S AUTOMOBILE PRIVATE LIMITED",
"M S BIDWE ENGINEERING COLLEGE",
"M S CABROL INDIA PRIVATE LIMITED",
"M S CARHIRERS (INDIA) PRIVATE LIMITED",
"M S CHARAN BUILDERS PRIVATE LIMITED",
"M S COMPSERVE PRIVATE LIMITED",
"M S DUA CARS & MOTORS (INDIA) PRIVATE LIMITED",
"M S ELECTROVISION PRIVATE LIMITED",
"M S ENGINEERS INDIA PRIVATE LIMITED",
"M S ENTERPRISES",
"M S FISHNETS INDUSTRIES",
"M S G EXIM PRIVATE LIMITED",
"M S GRANIMARMO PRIVATE LIMITED",
"M S GUPTA HARDWARE PRIVATE LIMITED",
"M S INDUSTRIAL COMPONENTS PRIVATE LIMITED",
"M S INDUSTRIES & FORGINGS PVT LTD",
"M S INFRAENGINEERS PRIVATE LIMITED",
"M S JAIN VIDYALAYA",
"M S KAWAR INTERNATIONAL SCHOOL",
"M S LAND PROMOTERS PRIVATE LIMITED",
"M S LUVISH CONSTRUCTION PRIVATE LIMITED",
"M S LUVISH IT PIONEERS PRIVATE LIMITED",
"M S LUVISH MART PRIVATE LIMITED",
"M S LUVISH MEGA SOLUTIONS PRIVATE LIMITED",
"M S MEDIA AND PUBLICATIONS PRIVATE LIMITED",
"M S METALS AND STEELS PRIVATE LIMITED",
"M S NAMIEX CHEMICAL PVT L T D",
"M S NANDI STEELS",
"M S P MANDAL DEOGIRI COLLEGE",
"M S PROTIENS PRIVATE LIMITED",
"M S R COSMOS IT LLP",
"M S R GARMENTS PRIVATE LIMITED",
"M S R IRON AND STEEL INDUSTRIES INDIA PRIVATE LIMITED",
"M S R IT SERVICES PRIVATE LIMITED",
"M S R T C RTN DIV OFFICE",
"M S R VALVES AND PIPES PRIVATE LIMITED",
"M S RAMAIAH DEVELOPERS AND BUILDERS PRIVATE LIMITED",
"M S REALTY GROUP",
"M S SHOPS PRIVATE LIMITED",
"M S SUITS AND DUPATTA PRIVATE LIMITED",
"M S SWAMINATHAN RESEARCH FOUNDATION",
"M S TALAULICAR AND SONS PRIVATE LIMITED",
"M S TOOLS AND MANUFACTURING CO P LIMITED",
"M S V HOTELS PRIVATE LIMITED",
"M S VIGILANT SECURITY PLACEMENT DETECTIVE SERVICES PRIVATE LIMITED",
"M S WELLNESS N SOLUTIONS (INDIA) PRIVATE LIMITED",
"M S WINES PRIVATE LIMITED",
"M SEA PHARMACEUTICALS PRIVATE LIMITED",
"M SHAH TUBES AND EMGINEERS PVT LTD",
"M SHASHIKANT EXPORTS LIMITED",
"M SHESHMAL TEXTILES (INDIA) PRIVATE LIMITED",
"M SQUARE AUTOMOBILE PRIVATE LIMITED",
"M SQUARE FINANCIAL CONSULTANTS AND AUTO PRIVATE LIMITED",
"M SQUARE METAL PROCESSORS PRIVATE LIMITED",
"M SQUARED SOFTWARE AND SERVICES PRIVATE LIMITED",
"M SURESH COMPANY PRIVATE LIMITED",
"M T C LOGISTICS PRIVATE LIMITED",
"M T D EXIM PRIVATE LIMITED",
"M TECH DEVELOPERS PRIVATE LIMITED",
"M U JEWELLERS PRIVATE LIMITED",
"M U S MARKETING PRIVATE LIMITED",
"M V AGRO ENGINEERS PRIVATE LIMITED",
"M V AGROTECH PRIVATE LIMITED",
"M V AND M P RAMANI ARTS COLLEGE AND R K KHETANI COMMERCE COLLEGE",
"M V BUILDCON PRIVATE LIMITED",
"M V FOOD INDUSTRIES LIMITED",
"M V HOSPITAL FOR DIABETES PRIVATE LIMITED",
"M V INFOTECH SYSTEMS PRIVATE LIMITED",
"M V J FOODS INDIA PRIVATE LIMITED",
"M V K CHEMICALS PRIVATE LIMITED",
"M V K INNOVATIONS PRIVATE LIMITED",
"M V M METAL AND ALLOYS PRIVATE LIMITED",
"M V MOTORS PRIVATE LIMITED",
"M V P S TRADING PRIVATE LIMITED",
"M V PLAST PRIVATE LIMITED",
"M V PROJECTS INDIA PRIVATE LIMITED",
"M V R INFRASTRUCTURE AND TOLLWAYS LIMITED",
"M V RECYCLERS INDIA PRIVATE LIMITED",
"M V SALES (INDIA) PRIVATE LIMITED",
"M V SHIPTRADE PRIVATE LIMITED",
"M V SHOE CARE PRIVATE LIMITED",
"M V WAGHADKAR AND SONS JEWELLERS PRIVATE LIMITED",
"M X SYSTEMS INTERNATIONAL PRIVATE LIMITED",
"M Y C INFRA PRIVATE LIMITED",
"M Y ENTERPRISES INDIA PRIVATE LIMITED",
"M Y HOSPITAL INDORE",
"M Y PAPER MERCHANTS PRIVATE LIMITED",
"M Y POULTRY FARMS PRIVATE LIMITED",
"M Y TRANSPORT COMPANY PRIVATE LIMITED",
"M&C SAATCHI COMMUNICATIONS PRIVATE LIMITED",
"M&C SAATCHI MOBILE INDIA LLP",
"M&CO. ADVISORS AND CONSULTANTS PRIVATE LIMITED",
"M&D POWERTEC ENGINEERS PRIVATE LIMITED",
"M&G GLOBAL SERVICES PRIVATE LIMITED",
"M&G IMPEX I PRIVATE LIMITED",
"M&I MATERIALS INDIA PRIVATE LIMITED",
"M&M ABHILASHA FABRICS PRIVATE LIMITED",
"M&M LOGICORP PRIVATE LIMITED",
"M&M MACHINE CRAFT PRIVATE LIMITED",
"M&N INFRA CONSTRUCTION PRIVATE LIMITED",
"M&N MOTORS PRIVATE LIMITED",
"M&S CONTAINER LINES PRIVATE LIMITED",
"M&S SOFTWARE INDIA PRIVATE LIMITED",
"M&W FASHION PRIVATE LIMITED",
"M. B. BEVERAGES (INDIA) LIMITED",
"M. B. GARMENTS (INDIA) PRIVATE LIMITED",
"M. B. MOTORS PRIVATE LIMITED",
"M. B. MULTI SERVICES PRIVATE LIMITED",
"M. B. TOOLS PRIVATE LIMITED",
"M. B. VENTURES PRIVATE LIMITED",
"M. BAFNA TECHNOVATIONS PRIVATE LIMITED",
"M. BHANDARI CHEM. PRIVATE LIMITED",
"M. C. TOOLS PRIVATE LIMITED",
"M. D. AUTOMATION & CONTROLS PRIVATE LIMITED",
"M. D. FRESH VEG PRIVATE LIMITED",
"M. D. HOMOEO LAB PRIVATE LIMITED",
"M. D. HYGIENE PRIVATE LIMITED",
"M. D. ORNAMENTS PRIVATE LIMITED",
"M. D. SARAF SECURITIES PRIVATE LIMITED",
"M. E. INFRA PROJECTS PRIVATE LMITED",
"M. F. FARMLANDS PRIVATE LIMITED",
"M. G. BAID SECURITIES PRIVATE LIMITED",
"M. G. BAKERS PRIVATE LIMITED",
"M. H. BOHRA ENTERPRISES PRIVATE LIMITED",
"M. H. FOODS",
"M. H. INTERNATIONAL PRIVATE LIMITED",
"M. H. WINDOWS DECOR PRIVATE LIMITED",
"M. HIMMATLAL & COMPANY PRIVATE LIMITED",
"M. J. INDUSTRIES",
"M. J. N ABHUSHAN PRIVATE LIMITED",
"M. J. SOFTWARE SOLUTIONS PRIVATE LIMITED",
"M. K. COOLING SYSTEMS PRIVATE LIMITED",
"M. K. COTEX",
"M. K. FOODCHEM PRIVATE LIMITED",
"M. K. INDIA INFRAESTATE PRIVATE LIMITED",
"M. K. INDUSTRIES PRIVATE LIMITED",
"M. K. INFRADEVELOPERS PRIVATE LIMITED",
"M. K. MORSE COMPANY INDIA PRIVATE LIMITED",
"M. K. S. ELECTRICAL AND INTERIORS PRIVATE LIMITED",
"M. K. STONE",
"M. K. WIRE ROPES PRIVATE LIMITED",
"M. L. AGRITECH LIMITED",
"M. L. CHOPRA SHIPPING PRIVATE LIMITED",
"M. L. DALMIYA & CO. LIMITED",
"M. L. DAMANI SECURITIES PRIVATE LIMITED",
"M. L. ENTERPRISES",
"M. L. G. BUSINESS PRIVATE LIMITED",
"M. L. IRON PRIVATE LIMITED",
"M. L. LABADE ENGINEER & CONTRACTOR PRIVATE LIMITED",
"M. L. OIL & PROTEIN PRIVATE LIMITED",
"M. M. BHARWADA SURGICALS PRIVATE LIMITED",
"M. M. CERAMICS & FERRO ALLOYS",
"M. M. FISH SEED CULTIVATION PRIVATE LIMITED",
"M. M. INDUSTRIES",
"M. M. LENO INDUSTRIES PRIVATE LIMITED",
"M. M. YARNS PRIVATE LIMITED",
"M. N. FOREX INDIA PRIVATE LIMITED",
"M. P. BEER PRODUCTS LIMITED",
"M. P. BOARD AND PAPER MILLS PRIVATE LIMITED",
"M. P. ELECTRONICS APPLIANCES PRIVATE LIMITED",
"M. P. GOEL HARDWARE PRIVATE LIMITED",
"M. P. METALWELD PRIVATE LIMITED",
"M. PALLONJI LOGISTICS PRIVATE LIMITED",
"M. PRASAD AND CO LIMITED",
"M. R. GOEL & SONS PRIVATE LIMITED",
"M. R. GRANITE & MINERALS PRIVATE LIMITED",
"M. R. IMPORTING COMPANY PRIVATE LIMITED",
"M. R. INFRA DEVELOPERS PRIVATE LIMITED",
"M. R. MITTALS INFRATECH PRIVATE LIMITED",
"M. R. PAYAL PRIVATE LIMITED",
"M. R. PIPES PRIVATE LIMITED",
"M. R. SHAH LOGISTICS PRIVATE LIMITED",
"M. S. A. STEEL & ALLOYS PRIVATE LIMITED",
"M. S. CONSTROTECH PRIVATE LIMITED",
"M. S. INFRA TRANSMISSION PRIVATE LIMITED",
"M. S. INSTITUTE OF EDUCATION PVT. LTD.",
"M. S. LUVISH DATACARE PRIVATE LIMITED",
"M. S. LUVISH INFO SYSTEMS PRIVATE LIMITED",
"M. S. LUVISH IT FOCUS PRIVATE LIMITED",
"M. S. PRESSCO WORKS PRIVATE LIMITED",
"M. S. SHELTERS & INFRASTRUCTURES PRIVATE LIMITED",
"M. S. TREXIM & MFGS PRIVATE LIMITED",
"M. SALT PRIVATE LIMITED",
"M. SHYAMLAL FASHIONS PRIVATE LIMITED",
"M. TARUN DIAMONDS PRIVATE LIMITED",
"M. TECH INFORMATICS LIMITED",
"M. V. S. JEWELLERS PRIVATE LIMITED",
"M. V. VINIMPEX PVT. LTD.",
"M.A. BOARD PRODUCTS PRIVATE LIMITED",
"M.A. BUILDTECH PRIVATE LIMITED",
"M.A. INDUSTRIES",
"M.A. POWER TECHNOLOGIES PRIVATE LIMITED",
"M.A. WOOD PRODUCTS PRIVATE LIMITED",
"M.A.FINANCIAL SERVICES PVT LTD",
"M.A.G RENEWABLE ENERGY PRIVATE LIMITED",
"M.A.I.PRIMARY SCHOOL KHOLVAD",
"M.A.K HOTELS & RESORTS PRIVATE LIMITED",
"M.A.K PROJECTS PRIVATE LIMITED",
"M.A.S. HOSPITAL PRIVATE LIMITED",
"M.ARUNACHALAM PROJECTS AND INFRASTRUCTURE COMPANY PRIVATE LIMITED",
"M.B. AGRIBIZ PRIVATE LIMITED",
"M.B. EDUCATIONAL CONCEPTS PRIVATE LIMITED",
"M.B. FINMART PRIVATE LIMITED",
"M.B. GARTEX PRIVATE LIMITED",
"M.B. INDUSTRIES PRIVATE LIMITED",
"M.B. METAYARN PRIVATE LIMITED",
"M.B. ORNAMENTS PRIVATE LIMITED",
"M.B. PANESAR & SONS PRIVATE LIMITED",
"M.B. SAREES PRIVATE LIMITED",
"M.B. SMELTERS PVT LTD",
"M.B.A CONSULTING INDIA PRIVATE LIMITED",
"M.B.APPARELS PRIVATE LIMITED",
"M.B.C. CAR RENTAL PRIVATE LIMITED",
"M.B.C. INFRATECH PRIVATE LIMITED",
"M.B.FERTI & AUTO SALES PRIVATE LIMITED",
"M.B.M.R REAL ESTATE PRIVATE LIMITED",
"M.B.ORGANICS PRIVATE LIMITED",
"M.B.S. BOOKS PRIVATE LIMITED",
"M.B.S. INDIA INFRADEVELOPERS PRIVATE LIMITED",
"M.C. BHARDWAJ & SONS PACKAGING PRIVATE LIMITED",
"M.C. FOODS PRIVATE LIMITED",
"M.C. ROLLER FLOUR MILLS PRIVATE LIMITED",
"M.C.I.(BANGALORE) CHITS LIMITED",
"M.CT.M CHIDAMBARAM CHETTYAR INTERNATIONAL SCHOOL",
"M.D. AGRO FOODS",
"M.D. EQUIPMENTS PRIVATE LIMITED",
"M.D. FROZEN FOOD EXPORTS",
"M.D. MOHTA RAKHI PRIVATE LIMITED",
"M.D. MOTORS PRIVATE LIMITED",
"M.D. TRADELINKS PRIVATE LIMITED",
"M.D.C DESIGNER PRIVATE LIMITED",
"M.D.J.TEXCO FAB PRIVATE LIMITED",
"M.D.PROJECTS PRIVATE LIMITED",
"M.D.SUITINGS PRIVATE LIMITED",
"M.D.TEA INDUSTRIES PRIVATE LIMITED",
"M.E.TEXTILES PRIVATE LIMITED",
"M.EDISON & COMPANY PRIVATE LIMITED",
"M.F. CONSTRUCTION PRIVATE LIMITED",
"M.F.H.S. AGRO PRIVATE LIMITED",
"M.F.H.S. MILLS PRIVATE LIMITED",
"M.G METALLOY PRIVATE LIMITED",
"M.G. INFRAESTATES PRIVATE LIMITED",
"M.G. MOULD SYSTEMS PRIVATE LIMITED",
"M.G. SPINTEX PRIVATE LIMITED",
"M.G.BAKERS PRIVATE LIMITED",
"M.G.BROTHERS AUTOMOBILES PRIVATE LIMITED",
"M.G.BROTHERS INDUSTRIES PRIVATE LIMITED",
"M.G.CONSTRUCTIONS PRIVATE LIMITED",
"M.G.D. ELECTRONICS PRIVATE LIMITED",
"M.G.F. GROWTH RESEARCH AND INVESMART LIMITED",
"M.G.K PRINTING WORK PRIVATE LIMITED",
"M.G.R.G. AUTOMOBILES PRIVATE LIMITED",
"M.H. TOOLING SOLUTIONS PRIVATE LIMITED",
"M.H.CONSTRUCTION CO. PRIVATE LIMITED",
"M I ALLOYS PRIVATE LIMITED",
"M.J. FOOTWEAR PRIVATE LIMITED",
"M.J. INFRAVENTURES PRIVATE LIMITED",
"M.J. OSWAL KNIT PRIVATE LIMITED",
"M.J. STEELS PRIVATE LIMITED",
"M.J.COATERS PRIVATE LIMITED",
"M.K FOOD LION PRIVATE LIMITED",
"M.K. ADVISORY & ENGINEERING SERVICES PRIVATE LIMITED",
"M.K. AGGARWAL FABRICS PRIVATE LIMITED",
"M.K. AGGARWAL HOSIERY P LIMITED",
"M.K. AIR PRODUCTS PRIVATE LIMITED",
"M.K. FABRICS PRIVATE LIMITED",
"M.K. HEGDE CONSTRUCTIONS PRIVATE LIMITED",
"M.K. PACKAGING PRIVATE LIMITED",
"M.K. SALWAR KAMEEZ PRIVATE LIMITED",
"M.K. STORES",
"M.K. SYNTHETICS PRIVATE LIMITED",
"M.K.B.POWER CONSTRUCTION PRIVATE LIMITED",
"M.K.ENGIMECH PRIVATE LIMITED",
"M.K.ENGINEERING",
"M.K.GOLD PAINTS PRIVATE LIMITED",
"M.K.J. MANUFACTURING PVT LTD",
"M.K.M. RUBBER PVT LTD",
"M.K.PEACOCK MINERAL WATER PRIVATE LIMITED",
"M.K.POWERTECH PRIVATE LIMITED",
"M.K.R. TRADERS PRIVATE LIMITED",
"M.K.S.ENGINEERING COMPANY PVT LTD",
"M.K.S.K. BUSINESS LIMITED",
"M.KAY ASSOCIATES PRIVATE LIMITED",
"M.L. EXPORTS PRIVATE LIMITED",
"M.L. FOODS PRIVATE LIMITED",
"M.L. HOSPITALITY SERVICES PRIVATE LIMITED",
"M.L. ROY & CO. SANITATIONS PRIVATE LIMITED",
"M.L. TRADINGS PRIVATE LIMITED",
"M.L. WOOLLENS PRIVATE LIMITED",
"M.L.EXPORTS",
"M.L.S ENTERPRISES PRIVATE LIMITED",
"M.L.SINGHI AND ASSOCIATES PRIVATE LIMITED",
"M.M SHAWL ENGINEERS & CONTRACTORS PRIVATE LIMITED",
"M.M. BROTHERS PRIVATE LIMITED",
"M.M. CREATIONS PRIVATE LIMITED",
"M.M. FASTFOOD PRIVATE LIMITED",
"M.M. GULATI AND COMPANY PRIVATE LIMITED",
"M.M. HOUSING PRIVATE LIMITED",
"M.M. METALS PRIVATE LIMITED",
"M.M. REMEDIES PRIVATE LIMITED",
"M.M.C. TECHNOLOGIES PRIVATE LIMITED",
"M.M.FINE GRINDERS PRIVATE LIMITED",
"M.M.G.HOLDINGS PRIVATE LIMITED",
"M.M.HYDRO PNEUMATICS PRIVATE LIMITED",
"M.M.N. MANICKAVEL COIR PRODUCTS PRIVATE LIMITED",
"M.M.P AGRO PRODUCTS PRIVATE LIMITED",
"M.M.POLYVINYLS PRIVATE LIMITED",
"M.M.R.T. INSTRUMENTATION PRIVATE LIMITED",
"M.M.ROLLER FLOUR MILLS PRIVATE LIMITED",
"M.M.S.STEEL & POWER PRIVATE LIMITED",
"M.M.TEXTILES PRIVATE LIMITED",
"M.N. PERFECT TOOLS PRIVATE LIMITED",
"M.N. RUBBER PRIVATE LIMITED",
"M.N.C.JAY BHAVANI PRASHALA SECONDARY SCHOOL, SOLAPUR",
"M.N.CHEMICALS LIMITED",
"M.N.EYE HOSPITAL PRIVATE LIMITED",
"M.N.M. TOOLS PRIVATE LIMITED",
"M.N.POLYESTER (INDIA) PRIVATE LIMITED",
"M.N.R. AUTOMOTIVE PRIVATE LIMITED",
"M.N.S. PRINTERS PRIVATE LIMITED",
"M.N.S.METAL & PROFILES PRIVATE LIMITED",
"M.N.STOCK & SHARE SERVICES PRIVATE LIMITED",
"M.O.HASAN KUTHOOS MARICAR PRIVATE LIMITED",
"M.P AND SONS",
"M.P BOTTLES",
"M.P NEEDZ 'N' SOLUTIONZ PRIVATE LIMITED",
"M.P. AGRO NUTRI FOODS LIMITED",
"M.P. AGROTONICS LIMITED",
"M.P. AMBULANCE SERVICES PRIVATE LIMITED",
"M.P. BAGARIA VINIMAY PRIVATE LIMITED",
"M.P. EDIBLE OIL & FOODS PRIVATE LIMITED",
"M.P. ELECTRONICS & HOME APPLIANCES",
"M.P. GODARA LOGISTICS PRIVATE LIMITED",
"M.P. GOYAL INDUSTRIES LIMITED",
"M.P. MICA ENTERPRISES PRIVATE LIMITED",
"M.P. MINING & ENERGY LIMITED",
"M.P. SAINIK COAL MINING PRIVATE LIMITED",
"M.P. TERRACE PRIVATE LIMITED",
"M.P. WIRE INDUSTRIES INDIA PRIVATE LIMITED",
"M.P. WIRE PRODUCTS PRIVATE LIMITED",
"M.P.AGARWAL AND CO.PRIVATE LIMITED",
"M.P.AGRO INDUSTRIES LIMITED",
"M.P.BISCUITS PRIVATE LIMITED",
"M.P.C. PHARMA PRIVATE LIMITED",
"M.P.CARBON PRIVATE LIMITED",
"M.P.K. STEEL INDIA PRIVATE LIMITED",
"M.P.N.CONSTRUCTIONS PRIVATE LIMITED",
"M.P.TYRES PRIVATE LIMITED",
"M.P.VENEERS PRIVATE LIMITED",
"M.PODDAR & CO.PRIVATE LIMITED",
"M.R FERRO PRIVATE LIMITED",
"M.R GENERIC FOODS PRIVATE LIMITED",
"M.R. AGRO OVERSEAS PRIVATE LIMITED",
"M.R. DISTRIBUTORS PRIVATE LIMITED",
"M.R. ENGG. WORKS PRIVATE LIMITED",
"M.R. FABRICS (RANCHI) PVT LTD",
"M.R. GOEL STEEL COMPANY PRIVATE LIMITED",
"M.R. HI-TECH ENGINEERS PRIVATE LIMITED",
"M.R. HOLIDAY MYSTIQUE PRIVATE LIMITED",
"M.R. HOSIERY PRIVATE LIMITED",
"M.R. MANOKAMNA PVT LTD",
"M.R. MEDIA SERVICES PRIVATE LIMITED",
"M.R. OIL MILLS PRIVATE LIMITED",
"M.R. PROVIEW REALTECH P LIMITED",
"M.R. SEEDS PRIVATE LIMITED",
"M.R. SPECIALITY CHEMICALS PRIVATE LIMITED",
"M.R. TOURS & TRADERS PRIVATE LIMITED",
"M.R.A.ENTERPRISES PRIVATE LIMITED",
"M.R.COLD STORAGE PRIVATE LIMITED",
"M.R.ENGINEERS PRIVATE LIMITED",
"M.R.GOLD PRIVATE LIMITED",
"M.R.M. ENTERPRISES PRIVATE. LIMITED",
"M.R.ORGANISATION LIMITED",
"M.R.P PRECISONS PRIVATE LIMITED",
"M.R.R. ELECTRICALS AND CONTRACTORS PRIVATE LIMITED",
"M.R.R. HOUSING PRIVATE LIMITED",
"M.R.S. LEATHER EXPORTS PRIVATE LIMITED",
"M.R.U. SEWAK RAM CONSTRUCTIONS PRIVATE LIMITED",
"M.RAMADEVI ENTERPRISES PRIVATE LIMITED",
"M.RAMSINGH AGRO FOODS PRIVATE LIMITED",
"M.RAUF ENTERPRISES PRIVATE LIMITED",
"M.S GRAPHICS PVT. LTD.",
"M.S LIFE DRUG HOUSE PRIVATE LIMITED",
"M.S MENTHOL PRIVATE LIMITED",
"M.S MUSICIAN'S MALL PRIVATE LIMITED",
"M.S PLASTICS POLYMERS POLYWEAVERS PRIVATE LIMITED",
"M.S TRADE",
"M.S TRANSFORMERS INDIA PRIVATE LIMITED",
"M.S. COLD STORAGE",
"M.S. ELASTIC & TAPES PRIVATE LIMITED",
"M.S. E-SOLUTIONS PRIVATE LIMITED",
"M.S. KHURANA ENGINEERING LIMITED",
"M.S. KUMAR ELECTRICALS PRIVATE LIMITED",
"M.S. LUVISH INFOWAY PROJECTS PRIVATE LIMITED",
"M.S. LUVISH IT SERVICES PRIVATE LIMITED",
"M.S. LUVISH PROJECTS PRIVATE LIMITED",
"M.S. MARBLES PRIVATE LIMITED",
"M.S. PLASTOMOULD PVT. LTD.",
"M.S. RICE INDUSTRIES PRIVATE LIMITED",
"M.S. ROADLINES INDIA PRIVATE LIMITED",
"M.S. SHEETS & TUBE CO. PRIVATE LIMITED",
"M.S. SYNTHETICS PRIVATE LIMITED",
"M.S.FITTINGS MANUFACTURING COMPANY PVT.LTD.",
"M.S.INTROPOWER PRIVATE LIMITED",
"M.S.J. CHEMICALS WORLDWIDE LIMITED",
"M.S.LUVISH INFOTECH PROJECTS PRIVATE LIMITED",
"M.S.R. PROJECTS AND MINERALS PRIVATE LIMITED",
"M.S.RAMAYYA CONSTRUCTIONS PRIVATE LIMITED",
"M.SASHI BADALIA & SONS PRIVATE LIMITED",
"M.SHERIF & SONS PRIVATE LIMITED",
"M.SURESH JEWELLERY PRIVATE LIMITED",
"M.T. PATIL BUILDERS AND CONTRACTORS PRIVATE LIMITED",
"M.T.M. SHIP MANAGEMENT INDIA PRIVATE LIMITED",
"M.TECH SOLUTIONS INDIA PRIVATE LIMITED",
"M.V. LOGISTICS PRIVATE LIMITED",
"M.V. MUTHIAH GOVERNMENT ARTS COLLEGE FOR WOMEN",
"M.V. RACK INDUSTRIES PRIVATE LIMITED",
"M.V.D. AUTO COMPONENTS PRIVATE LIMITED",
"M.V.D. INFRADEVELOPERS PRIVATE LIMITED",
"M.V.K. AGRO FOOD PRODUCT LIMITED",
"M.V.POLYPLAST PRIVATE LIMITED",
"M.V.S INDUSTRIES PRIVATE LIMITED",
"M.VISVESVARAYA INDUSTRIAL RESEARCH AND DEVELOPMENT CENTRE",
"M/S A¬† S ENTERPRIES",
"M/S AAKAR ARCHITECTS",
"ANANTA HOTEL & RESORTS",
"M/S AURUM THE GLOBAL SCHOOL",
"M/S BARNALA SREEE EMPORIO",
"M/S BHARAT YADAV SECURITY AGENCY",
"M/S BM ENGINEERING",
"M/S CHAITYA",
"M/S CHITTARANJAN SWAIN",
"M/S DANIEL ENTERPRISES",
"M/S DAROGA PRADHAN",
"M/S ELEMECH ENGINEERING",
"M/S ESSCO INTERNATIONAL",
"M/S EVERBAKE BAKERS PRIVATE LIMITED",
"M/S EVEREST PRINTERS",
"M/S GO-STYLE ATTIRE PRIVATE LIMITED",
"M/S HEMS CORPORATION",
"M/S HINDUSTAN POWER SOLUTIONS",
"M/S INDUSTRIAL ENGINEERING SYNDICATE",
"M/S INTEC CORPORATION",
"M/S IVS INDUSTRIES",
"M/S J. K. STAR",
"M/S JSR STEEL ENTERPRISES",
"M/S K P CLEENING ASSOCIATES",
"M/S K. R. SOLVENT",
"M/S KALOKHE RMC",
"M/S KARTAR SINGH CONST. CO.",
"M/S KUMAR RESTAURANTS",
"M/S KUNAL CONSTRUCTION",
"M/S KUNAL ENTERPRISES",
"M/S M.P. AGARWALLA",
"M/S MIRA ENTERPRISE",
"M/S MONGA MOTORS",
"M/S N. D. GUPTA AND SONS",
"M/S N.R. ENTERPRISES",
"M/S NARAIN ENTERPRISES",
"M/S NATIONAL CONSTRUCTION",
"NEPTUNE CONTAINER LINE & LOGISTICS PRIVATE LIMITED",
"M/S OFFCOM SYSTEMS PRIVATE LIMITED",
"M/S PAL ENTERPRISES",
"M/S PASUPATI FEEDS",
"M/S PERFECT CONSTRUCTION",
"MS PRADEEP B KUNDU",
"M/S PUSHPA AK PRINTER",
"M/S R K & COMPANY",
"M/S RADHA KRISHNA INDUSTRIES",
"M/S RADHE RADHE FIBERS",
"M/S RAJCHANRA AGENCIES",
"M/S RAJINDER & CO.",
"M/S RAM FABRICATOR AND ENGINEERING WORKS WARDHA",
"M/S RAM SONS",
"M/S RAWAT TRADERS",
"M/S RVK",
"M/S SANJAY AGRAWAL",
"M/S SHERRY CLOTHING & DESIGNS PRIVATE. LIMITED.",
"M/S SHIVANYA AUTO INDUSTRY",
"M/S SHREE BOITECH",
"M/S SHREYANS POLYSACK",
"M/S SHRI RAM TEMPO CARRIER",
"M/S SHRI SAI INDIA ENGINEERING COMPANY",
"M/S SHRISHANTI ENGINEERS",
"M/S SR ELECTRICALS",
"M/S SRI GANESH MEDICAL STORE",
"M/S STAR CONSTRUCTION",
"M/S SURESH KUMAR AND BROTHERS",
"M/S SWAROOP FUEL STATION",
"M/S TECKNOCRAT",
"M/S TIRTHAN ENTERPRISE",
"M/S V.K. ENTERPRISES CHANDRAPUR",
"M/S VENKATESWER ENGG WORKS",
"M/S VINAYAK CORPORATION",
"M/S VIVEK HOSTING CO",
"M/S WEIGH-TECH ENTERPRISES",
"M/S YASHASMINI PARIDA",
"M/S ZAC EXPORTS",
"M/S. IITL-NIMBUS THE EXPRESS PARK VIEW",
"M/S. JASMINE ART PRINTERS PRIVATE. LIMITED",
"M/S. MOKAM GLOBAL TECHNOLOGIES EDUCATION HUB",
"M/S. QUANTEON SOLUTIONS",
"M/S. RAJ CONSTRUCTION CO",
"M/S. S.N. MOHANTY",
"M/S. SHANTILAL B. PATEL",
"M/S. SREE LAXMI CONSTRUCTIONS",
"M/S. VIABLE ASSOCIATES",
"M+L SHOES AND ACCESSORIES PRIVATE LIMITED",
"M0DERN COLL OF ARTS SCIE COMM-411007",
"M1 MARKETING SERVICES PRIVATE LIMITED",
"M11 INSURANCE AGENTS PRIVATE LIMITED",
"M2C SOLUTION AND SERVICES PRIVATE LIMITED",
"M2GO ELECTRIC VEHICLE PRIVATE LIMITED",
"M2K ADVISORS PRIVATE LIMITED",
"M2K DEVELOPERS PRIVATE LIMITED",
"M2K ENTERTAINMENT PRIVATE LIMITED",
"M2K INFRASTRUCTURE PRIVATE LIMITED",
"M2M CYBERNETICS PRIVATE LIMITED",
"M2M FERRIES PRIVATE LIMITED",
"M2M RESOURCE MANAGEMENT PRIVATE LIMITED",
"M2NXT SOLUTIONS PRIVATE LIMITED",
"M2P SOLUTIONS PRIVATE LIMITED",
"M3 BUSINESS SERVICES PRIVATE LIMITED",
"M3 HEALTHCARE PRIVATE LIMITED",
"M3 INFRA PROJECTS INDIA PRIVATE LIMITED",
"M3 INFRASTRUCTURE PRIVATE LIMITED",
"M3 INVESTMENT PRIVATE LIMITED",
"M3 SERVICES PRIVATE LIMITED",
"M3 SIGN PRIVATE LIMITED",
"M3A PETROCHEM PRIVATE LIMITED",
"M3BI INDIA PRIVATE LIMITED",
"M3M FOUNDATION",
"M3M INDIA HOLDINGS PRIVATE LIMITED",
"M4 CONSTRUCTION PRIVATE LIMITED",
"M4 PROJECTS & INFRASTRUCTURE PRIVATE LIMITED",
"M4 SOLUTIONS PRIVATE LIMITED",
"M56 STUDIOS TECHNOLOGIES INDIA PRIVATE LIMITED",
"M9 BUILDCON PRIVATE LIMITED",
"MA AMBE AGRO FOOD PROCESSING PVT. LTD.",
"MA ANANDAMOYEE POULTRY PRIVATE LIMITED",
"MA BHABATARINI AGRO PRODUCTS PRIVATE LIMITED",
"MA BHAGWATI SUGAR MILL LIMITED",
"MA BIPADTARINI RICE MILL PRIVATE LIMITED",
"MA CHANDI REALCON PRIVATE LIMITED",
"MA CHHINMASTIKA COKE INDUSTRIES PRIVATE LIMITED",
"MA CHIDAMBRAM NURSING COLLEGE",
"MA CONSULTING SERVICES PRIVATE LIMITED",
"MA DHANLAXMI FISHERIES PRIVATE LIMITED",
"MA DURGA DEVCON PRIVATE LIMITED",
"MA EXTRUSION INDIA PRIVATE LIMITED",
"MA FACILITY MANAGEMENT AND SERVICES PRIVATE LIMITED",
"MA FOI STRATEGIC CONSULTANTS PRIVATE LIMITED",
"MA FRUITS INTERNATIONAL PRIVATE LIMITED",
"MA GAYETRI PRINTING & PACKAGING PRIVATE LIMITED",
"MA IT SOLUTIONS PRIVATE LIMITED",
"MA KALI AGENCIES PRIVATE LIMITED",
"MA KALYANESHWARI HOLDINGS PRIVATE LIMITED",
"MA KALYANESHWARI STEELS PRIVATE LIMITED",
"MA KANSHIRAM SAYUNKT CHIKITSHALAYA TRAMA CENTER",
"MA LAKSHMIANNA AGRO PRODUCTS PRIVATE LIMITED",
"MA LAXMI ENAMELS PRIVATE LIMITED",
"MA MACHNA CROP PRODUCER COMPANY LIMITED",
"MA MALAICHANDI COMMERCIAL PRIVATE LIMITED",
"MA MANSA ENTERPRISES PRIVATE LIMITED",
"MA MULTI-INFRA DEVELOPMENT PRIVATE LIMITED",
"MA OM PARIVAHAN PRIVATE LIMITED",
"MA PORTABLE CABINS INDIA PRIVATE LIMITED",
"MA SARADA COLD STORAGE PVT LTD",
"MA SARSINSA STEELS PRIVATE LIMITED",
"MA SHAKAMBARI CHEMICALS PRIVATE LIMITED",
"MA SHANTI AGRO FOODS PRIVATE LIMITED.",
"MA SURESHDADA PATIL VIDYALAY JAMADI TAL KANNAD",
"MA UMIA ICE AND COLD STORAGE PVT LTD",
"MAA ABHYA RICE MILL PRIVATE LIMITED",
"MAA AHILYA INFRACON PRIVATE LIMITED",
"MAA AIR TICKET CENTRE PRIVATE LIMITED",
"MAA ALLOYS PRIVATE LIMITED",
"MAA ALLUMINIUM (INDIA) PRIVATE LIMITED",
"MAA ALU PANEL INDIA PRIVATE LIMITED",
"MAA AMBA INFRA DEVELOPERS PRIVATE LIMITED",
"MAA AMBA INFRASTRUCTURE PVT LTD",
"MAA AMBA TOWERS LIMITED",
"MAA AMBAY VINCOM PRIVATE LIMITED",
"MAA AMBE STEEL",
"MAA AMBE WAREHOUSING PVT LTD",
"MAA AMBEY RETAIL PRIVATE LIMITED",
"MAA AMBEY RICE AND GENERAL MILLS PRIVATE LIMITED",
"MAA AMBEY TRADING COMPANY PRIVATE LIMITED",
"MAA AMBIKA AGROTECH PRIVATE LIMITED",
"MAA AMBIKA MINERALS PRIVATE LIMITED",
"MAA AMI SALES PRIVATE LIMITED",
"MAA ANANDMAYI KANYA VIDHYALAYA RAJKOT",
"MAA ANJANI RAMSIYA RICE MILL P LIMITED.",
"MAA ANNAPURNA AGRITECH PRIVATE LIMITED",
"MAA ANNAPURNA AGRO PRODUCTS",
"MAA ANNAPURNA JUTE & CARPETS INDUSTRIES PRIVATE LIMITED",
"MAA ANNAPURNA TRANSPORT AGENCY PRIVATE LIMITED",
"MAA ASHAPURA SERVICES PRIVATE LIMITED",
"MAA ASHISH TEXTILES INDUSTRIES PRIVATE LIMITED",
"MAA AUTOCORP INDIA LLP",
"MAA BAGHEI CONSTRUCTIONS PRIVATE LIMITED",
"MAA BAJRESHWARI DEVI SHOPPING MALL PRIVATE LIMITED",
"MAA BALA SUNDARI PACKAGING PRIVATE LIMITED",
"MAA BAMESWARI COLD STORAGE PRIVATE LIMITED",
"MAA BANADEVI POULTRY PRIVATE LIMITED",
"MAA BHADRA KALI COKE INDUSTRIES (P) LTD",
"MAA BHADRAKALI SHEETGRAH PRIVATE LIMITED",
"MAA BHADRAKALI TEXTILES PRIVATE LIMITED",
"MAA BHAGABATI PIPES PRIVATE LIMITED",
"MAA BHAGAWATI RE-ROLLING MILLS PRIVATE LIMITED",
"MAA BHAGWATI PAINTS & HARDWARE PRIVATE LIMITED",
"MAA BHAGWATI RICE MILL",
"MAA BHAGWATI TEXCON PRIVATE LIMITED",
"MAA BHAWANI CONSTRUCTION & MINING PRIVATE LIMITED",
"MAA BHAWANI ENTERPRISES PRIVATE LIMITED",
"MAA BHAWANI INFRASTRUCTRE PRIVATE LIMITED",
"MAA BHAWANI POWER AND ISPAT PRIVATE LIMITED",
"MAA BIDDESWARI AGRO PRODUCTS PRIVATE LIMITED",
"MAA BIJASANI PETROCHEM PRIVATE LIMITED",
"MAA BUDHI IMPEX PRIVATE LIMITED",
"MAA BUSINESS SOLUTIONS PRIVATE LIMITED",
"MAA CEMENT COMPANY PRIVATE LIMITED",
"MAA CHAKRESHWARI SHEETGRAH PRIVATE LIMITED",
"MAA CHAMUNDA ALLOYS PRIVATE LIMITED",
"MAA CHAMUNDA DEVI SHEETGRAH PRIVATE LIMITED",
"MAA CHEMFOOD PRIVATE LIMITED",
"MAA CHHIN MASTIKA IMPEX PVT LTD",
"MAA CHHINNMASTIKA CEMENT AND ISPAT PRIVATE LIMITED",
"MAA CHINNAMASTA CERAMICS PRIVATE LIMITED",
"MAA CONSULTANTS PRIVATE LIMITED",
"MAA CREATIONS PRIVATE LIMITED",
"MAA DAYALU FERTILIZERS AND CHEMICALS PRIVATE LIMITED",
"MAA DAYALU TRANSPORT & WAREHOUSE PRIVATE LIMITED",
"MAA DHANESHWARI HP CENTRE",
"MAA DURGA ELECTRICAL PAINT HARDWARE AND SANITARY STORE",
"MAA DURGA ENTERPRISE",
"MAA DURGA FILING STATION",
"MAA DURGA GROCERY STORE PRIVATE LIMITED",
"MAA DURGA PROPERTIES PRIVATE LIMITED",
"MAA FARMS",
"MAA FOUNDRY PRIVATE LIMITED",
"MAA GANGA BHAGAT GOPAL MAYA EDUCATIONAL TRUST",
"MAA GAURI TIMBERS PRIVATE LIMITED",
"MAA GAYATRI AGENCIES PVT LTD",
"MAA GAYATRI COKE INDUSTRIES PRIVATE LIMITED",
"MAA GAYATRI FASHIONS PRIVATE LIMITED",
"MAA GAYATRI MEDICAL CENTER",
"MAA GAYATRI STEEL PRIVATE LIMITED",
"MAA GENERAL HOSPITAL TALEJA",
"MAA GIRIJA ISPAT PRIVATE LIMITED",
"MAA GROUP HOLDINGS PRIVATE LIMITED",
"MAA HARSIDDHI INFRA DEVELOPERS PRIVATE LIMITED",
"MAA HOSPITALS PRIVATE LIMITED",
"MAA INDUSTRIAL CHEMICALS & ENGINEERS PRIVATE LIMITED",
"MAA INFRATECH PRIVATE LIMITED",
"MAA JAGDAMBEY MASALA INDUSTRIES PRIVATE LIMITED",
"MAA JAGDHATRI MOVERS PRIVATE LIMITED.",
"MAA JANKI TOOFAN AGRO INDUSTRIES PRIVATE LIMITED",
"MAA JAY CHANDI MULTIPURPOSE COLD STORAGE PRIVATE LIMITED",
"MAA JHANDEWALAN STEEL PRIVATE LIMITED",
"MAA JHARBONI HIMGHAR PRIVATE LIMITED",
"MAA JOHARA RICE MILL PRIVATE LIMITED",
"MAA JOYTARA RICE MILL PRIVATE LIMITED",
"MAA KAILADEVI JI FOODTECH INDIA PRIVATE LIMITED",
"MAA KALI ALLOYS UDYOG PRIVATE. LIMITED.",
"MAA KALI ASSOCIATES PRIVATE LIMITED",
"MAA KALI BUILDERS PRIVATE LIMITED",
"MAA KALI COKE PLANT LTD",
"MAA KALI FRUIT PROCESSING PRIVATE LIMITED",
"MAA KALI GOLD JEWELLERY PRIVATE LIMITED",
"MAA KALI PROJECTS PRIVATE LIMITED",
"MAA KALI VINIMAY PRIVATE LIMITED",
"MAA KALIKA BHANDAR",
"MAA KAMAKHYA COKE INDUSTRIES",
"MAA KAMAKHYA MULTIPURPOSE HIMGHAR PRIVATE LIMITED",
"MAA KAMAKHYA POULTRY PRODUCTS PRIVATE LIMITED",
"MAA KAMDHENU BIO ENERGY PRIVATE LIMITED",
"MAA KAMDHENU FASHIONS PRIVATE LIMITED",
"MAA KARNI ANTIQUE PRIVATE LIMITED",
"MAA KARNI EARTHMOVER PRIVATE LIMITED",
"MAA KARNI INFRATECH PRIVATE LIMITED",
"MAA KARNI MARBLES PRIVATE LIMITED",
"MAA KAUSHALYA COMMERCIAL PRIVATE LIMITED",
"MAA KELA TRANSFORMER PRIVATE LIMITED",
"MAA KRIPA INDUSTRIAL PARK PRIVATE LIMITED",
"MAA KUDARGARHI MINERALS AND REFRACTORIES PRIVATE LIMITED",
"MAA KUDARGARHI STEELS PRIVATE LIMITED",
"MAA LALITA ENTERTAINMENT AND DEVELOPERS PRIVATE LIMITED",
"MAA LAXMI AGRO PRIVATE LIMITED",
"MAA LAXMI BOX HUB (OPC) PRIVATE LIMITED",
"MAA LAXMI ENTERPRISE",
"MAA LAXMI FOOD PRIVATE LIMITED",
"MAA LUXMI DEVI AGRO PRIVATE LIMITED",
"MAA MADHOEI RICE MILL PRIVATE LIMITED",
"MAA MAHAKALI FOODS PRIVATE LIMITED",
"MAA MAHALAXMI GRAMIN UDYOG PRIVATE LIMITED",
"MAA MAHAMAYA ALLOYS PRIVATE LIMITED",
"MAA MAHAMAYA INDUSTRIES LIMITED",
"MAA MAHAMAYA MINERALS AND MINING PRIVATE LIMITED",
"MAA MANASA MODERN RICE MILLS PRIVATE LIMITED",
"MAA MANGALCHANDI BRICK FIELD PRIVATE LIMITED",
"MAA MANGLA FLOUR MILLS PRIVATE LIMITED",
"MAA MANGLA ISPAT PRIVATE LIMITED",
"MAA MANI INDUSTRIES PRIVATE LIMITED",
"MAA MANI IRION & STEEL CO",
"MAA MANOKAMNA AGRO PRIVATE LIMITED",
"MAA MATESHWARI GARMENT PRIVATE LIMITED",
"MAA MAYNAMATA WAREHOUSING PRIVATE LIMITED",
"MAA MINAKSHI GRANITE PRIVATE LIMITED",
"MAA MUNDESHWARI AGRO MILLS PRIVATE LIMITED",
"MAA MUNDESHWARI AUTOMOTIVES PRIVATE LIMITED",
"MAA MUNDESHWARI MOTORS PRIVATE LIMITED",
"MAA NACHINDA SEA FOODS PRIVATE LIMITED",
"MAA NARAYANI AGRO MILL PRIVATE LIMITED",
"MAA NARMADA AGROTECH AND INFRASTRUCTURES LIMITED",
"MAA OM BUSINESS ENTERPRISES PRIVATE LIMITED",
"MAA OM EXIM PRIVATE LIMITED",
"MAA PADMAWATI AGRO FOODS PRIVATE LIMITED",
"MAA PADMAWATI STEELS PRIVATE LIMITED",
"MAA PAHARI MERCANTILES PVT.LTD.",
"MAA PANEL INDIA PRIVATE LIMITED",
"MAA PARVATI SHEETGRAH PRIVATE LIMITED.",
"MAA PARWATI BUILDCON PRIVATE LIMITED",
"MAA PEETAMBRA SUGAR AND POWER LIMITED",
"MAA PET PRIVATE LIMITED",
"MAA PITAAMBARA PRINTING AND PACKAGING PRIVATE LIMITED",
"MAA PITAMBARA COAL CARRIERS PRIVATE LIMITED",
"MAA PITAMBRA BUILDHEIGHTS PRIVATE LIMITED",
"MAA POLYPACKS INDUSTRIES (IND) PRIVATE LIMITED",
"MAA RAJ RAJESHWARI ICE AND COLD STORAGE PRIVATE LIMITED",
"MAA RAM PYARI ORTHO HOSPITAL RESEARCH CENTRE PRIVATE LIMITED",
"MAA RAMACHANDI INFRA PRIVATE LIMITED",
"MAA RANI SATI ALLOYS & STEEL PRIVATE LIMITED",
"MAA RATANGARH DEVELOPERS PRIVATE LIMITED",
"MAA RATANTI FOREX & TRAVELS PRIVATE LIMITED",
"MAA RATANTI KALIMATA COLD STORAGE PRIVATE LIMITED",
"MAA RESHMIDEVI ICE AND COLD STORAGE PRIVATE LIMITED",
"MAA RETAIL PRIVATE LIMITED",
"MAA SAMLESWARI FOOD PRODUCTS PRIVATE LIMITED",
"MAA SAMLESWARI INDUSTRIES PRIVATE LIMITED",
"MAA SANTOSHI ALLOYS PRIVATE LIMITED",
"MAA SARASWATI EDUCATIONAL TRUST",
"MAA SARASWATI ORNAMENTS & JEWELLERS PRIVATE LIMITED",
"MAA SARASWATI PUBLIC SENIOR SECONDARY SCHOOL",
"MAA SARASWATI STEEL RE-ROLLING MILLS PRIVATE. LIMITED.",
"MAA SARDA RAIL NIRMAN PRIVATE LIMITED",
"MAA SATYAVATI MOTORS PRIVATE LIMITED",
"MAA SHAKAMBARI STEEL LIMITED",
"MAA SHAKAMBHARI GLOBAL FOODS PRIVATE LIMITED",
"MAA SHAKTI EXIM PRIVATE LIMITED",
"MAA SHAKTI HOSPITALS PRIVATE LIMITED",
"MAA SHAKUMBARI SPONGE PRIVATE LIMITED",
"MAA SHAKUNTALA INFRASTRUCTURE PRIVATE LIMITED",
"MAA SHANTI INFRA DEVELOPERS PRIVATE LIMITED",
"MAA SHANTI PACKAGING PRIVATE LIMITED",
"MAA SHANTIMOYEE RICE MILL PRIVATE. LIMITED.",
"MAA SHARDA CHILDCARE PRIVATE LIMITED",
"MAA SHARDA DEVI MANDIR PRABANDH SAMITI, MAIHAR(M.P)",
"MAA SHARDA ENDEAVOR PRIVATE LIMITED",
"MAA SHARDA STONE CRUSHER PRIVATE LIMITED",
"MAA SHARDAA INFRASTUCTURE DEVELOPERS PRIVATE LIMITED",
"MAA SHEETALA CHAUKIYA TEXTILE PRIVATE LIMITED",
"MAA SHEETALA DEVI MICRO FINANCE PRIVATE LIMITED",
"MAA SHEETLA AUTOWHEELS PRIVATE LIMITED",
"MAA SHEETLA DISTRIBUTORS PRIVATE LIMITED",
"MAA SHEETLA INDUSTRIES PRIVATE LIMITED",
"MAA SHEETLA PACKAGING LIMITED",
"MAA SHEETLA RETAILERS PRIVATE LIMITED",
"MAA SHEETLA UDYOG PRIVATE LIMITED",
"MAA SHERAWALI INFRACON PRIVATE LIMITED",
"MAA SHITALA AGRO PRIVATE LIMITED",
"MAA SHITLA TRADING COMPANY PRIVATE LIMITED",
"MAA SHOOLINI LOGISTICS PRIVATE LIMITED",
"MAA SHUBHAYAI FOODS PRIVATE LIMITED",
"MAA SHYAMA MEDITECH PRIVATE LIMITED",
"MAA SHYAMA MOTORS PRIVATE LIMITED",
"MAA SRI TEX PRIVATE LIMITED",
"MAA STAR POWER CONTROL PRIVATE LIMITED",
"MAA SUBHALA COLD STORAGE PRIVATE LIMITED",
"MAA SUNDHA FASHION",
"MAA TARA EXIM PRIVATE LIMITED",
"MAA TARA INFRASTRUCTURE AND BUILDERS PRIVATE LIMITED",
"MAA TARA RICE MILL",
"MAA TARANI LOGISTICS LIMITED",
"MAA TARIN! EXSERVICEMAN RESETTLEMENT COOPERATIVE SOCIETY",
"MAA TARINI CARRIER PRIVATE LIMITED",
"MAA TARINI HOSPITAL PRIVATE LIMITED",
"MAA TARINI ISPAT PRIVATE LIMITED",
"MAA TELDIHA AGRO PRIVATE LIMITED",
"MAA USHA URJA LIMITED",
"MAA UTTAR BAHINI AGRO INDUSTRIES PRIVATE LIMITED",
"MAA UTTAR BAHINI RICE MILL PRIVATE LIMITED",
"MAA VAISHNAV DEVI TELECOM PRIVATE LIMITED",
"MAA VAISHNAV INFRACONTRACT (INDIA) PRIVATE LIMITED",
"MAA VAISHNAVEE STONEX INDIA PRIVATE LIMITED",
"MAA VAISHNAVI AUTOMOTIVE PRIVATE LIMITED",
"MAA VAISHNAVI ENGICON PRIVATE LIMITED",
"MAA VAISHNO COTSPIN LIMITED",
"MAA VAISHNO DEVI REFRIGERATION PRIVATE LIMITED",
"MAA VAISHNO EDIBLES PRIVATE LIMITED",
"MAA VAISHNO FRUIT PRESERVATION PRIVATE LIMITED",
"MAA VAISHNO FUELS PRIVATE LIMITED",
"MAA VAISHNO ICE AND COLD STORAGE PRIVATE LIMITED",
"MAA VAISHNO ISPAT INDUSTRIES PRIVATE LIMITED",
"MAA VAISHNO MERCHANDISERS PRIVATE LIMITED",
"MAA VAISHNO NET - TECH PRIVATE LIMITED",
"MAA VAISHNO PREETI PLAST PRIVATE LIMITED",
"MAA VAN BHAIRVEE INDUSTRIES PRIVATE LIMITED",
"MAA VAN DEVI SECURITY & INFRASTRUCTURE PRIVATE LIMITED",
"MAA VANKAL REFINERIES PRIVATE LIMITED",
"MAA VESHNO CONSUMER PRODUCTS PRIVATE LIMITED",
"MAA VESHNO FOOD PRODUCTS PRIVATE LIMITED",
"MAA VINDHYABASINI STEEL TRADERS PRIVATE LIMITED",
"MAA VINDHYAVASINI SHEETGARH AVAM ICE FACTORY PRIVATE LIMITED",
"MAA YOUSHODA EQUIPMENTS PRIVATE LIMITED",
"MAAAN MEDICOSE PRIVATE LIMITED",
"MAAC INTERNATIONAL FACILITY MANAGEMENT PRIVATE LIMITED",
"MAAC SCAFFOLDING PRIVATE LIMITED",
"MAACRICH FOODS PRIVATE LIMITED",
"MAAD MINES AND MINERALS PRIVATE LIMITED",
"MAADHAV AUTOMOTIVE FASTNERS PRIVATE LIMITED.",
"MAADURGA STEEL INDUSTRIES PRIVATE LIMITED",
"MAAFRESH AGRO FOODS PRIVATE LIMITED",
"MAAGANGA TRADING PRIVATE LIMITED",
"MAAGH ADVERTISING AND MARKETING SERVICES LIMITED",
"MAAGRITA EXPORTS LIMITED",
"MAAHI COMPUTERS AND PERIPHERALS PRIVATE LIMITED",
"MAAHI ENTERPRISE",
"MAAHI MILK PRODUCER COMPANY LIMITED",
"MAAHIMA FASHIONS PRIVATE LIMITED",
"MAAHIR SPICES PRIVATE LIMITED",
"MAAHIRON TECHNOLOGIES PRIVATE LIMITED",
"MA-AI WORLD ELECTRICALS 7 ELCETRONIC PRIVATE LIMITED",
"MAAJI TEX-TRADE PRIVATE LIMITED",
"MAAK IMPEX PRIVATE LIMITED",
"MAAKAILA FOUNDRIES PRIVATE LIMITED",
"MAAKALI DEALS PRIVATE LIMITED",
"MAA-KRIPA CREATIONS PRIVATE LIMITED",
"MAAKRIPA TRENDZ PRIVATE LIMITED",
"MAAKRISHNA METALS PRIVATE LIMITED",
"MAAKRUPA SCIENTIFIC INDUSTRIES PRIVATE LIMITED",
"MAAKS CREAM HOLDINGS PRIVATE LIMITED",
"MAALANA FOODS PRIVATE LIMITED",
"MAALAV MAHILA MILK PRODUCER COMPANY LIMITED",
"MAALIK INTERNATIONAL PRIVATE LIMITED",
"MAALU FERRO ALLOYS PRIVATE LIMITED",
"MAAMANGALA CONSTRUCTIONS PRIVATE LIMITED",
"MAAMANGALA ROAD TRANSPORTS PRIVATE LIMITED",
"MAAMI FOODS PRIVATE LIMITED",
"MAAMUNDESHWARI AGRO OILS PRIVATE LIMITED",
"MAAN ALUMINIUM LIMITED",
"MAAN CONCAST PRIVATE LIMITED",
"MAAN ENGINEERS PRIVATE LIMITED",
"MAAN EVENTS & ENTERTAINMENTS PRIVATE LIMITED",
"MAAN HOSPITALITY PRIVATE LIMITED",
"MAAN INFRASTRUCTURE PRIVATE LIMITED",
"MAAN MARBLES INDIA PRIVATE LIMITED",
"MAAN OIL MILLS PRIVATE LIMITED",
"MAAN PHARMACEUTICALS LTD",
"MAAN POLYPACKS PRIVATE LIMITED",
"MAAN RESTAURANT PRIVATE LIMITED",
"MAAN STEEL & POWER LIMITED",
"MAAN TRADING PRIVATE LIMITED",
"MAANAV MANDIR HERBALS PRIVATE LIMITED",
"MAANAV MOTORS PRIVATE LIMITED",
"MAANAVEEYA DEVELOPMENT & FINANCE PRIVATE LIMITED",
"MAANI CARE SYSTEM INDIA PRIVATE LIMITED",
"MAANIKA EXIM PRIVATE LIMITED",
"MAANINI VASTRA SAMSKRITHI INDIA PRIVATE LIMITED",
"MAANJALI COTEX PRIVATE LIMITED",
"MAANK HOTEL PRIVATE LIMITED",
"MAAN-PRATAP MOBILITIES PRIVATE LIMITED",
"MAANSAROVAR AUTOMOBILE PRIVATE LIMITED",
"MAANSAROVAR CERAMICS PRIVATE LIMITED",
"MAANSAROVAR MOTORS PRIVATE LIMITED",
"MAANTALAI CONSTRUCTION COMPANY PRIVATE LIMITED",
"MAANTIC TECHNOLOGIES PRIVATE LIMITED",
"MAANYA MOTORCYCLES PRIVATE LIMITED",
"MAANYA QUICKSOURCE PRIVATE LIMITED",
"MAANYAM ENTERPRISE SOLUTIONS PRIVATE LIMITED",
"MAAP ENGINEERING PRIVATE LIMITED",
"MAAPARVATI MILK PRIVATE LIMITED",
"MAARC LABS PRIVATE LIMITED",
"MAAREWA SUGARS PRIVATE LIMITED",
"MAARG TECHNOLOGIES RVI-NDT PRIVATE LIMITED",
"MAARGA SYSTEMS PRIVATE LIMITED",
"MAARK CIVIL ENGINEERING SERVICES PRIVATE LIMITED",
"MAARK PREMIUM AGRO PRODUCTS PRIVATE LIMITED",
"MAARKAL CONTAINER FREIGHT STATION PRIVATE LIMITED",
"MAARQ GENX INDIA PRIVATE LIMITED",
"MAARQ SPACES PRIVATE LIMITED",
"MAARS SUPER SPECIALITY HEALTHCARE PRIVATE LIMITED",
"MAARU BROTHERS MULTI TRADE SOLUTIONS PRIVATE LIMITED",
"MAARUT TECHNOLOGIES PRIVATE LIMITED",
"MAARUTH CONSULTANTS PRIVATE LIMITED",
"MAARUTI COACH BUILDERS PRIVATE LIMITED",
"MAAS INFRA AND LOGISTICS LIMITED",
"MAAS SHARES & STOCK BROKERS PRIVATE LIMITED",
"MAASAGRA GRANITO PRIVATE LIMITED",
"MAASARALA AGRITECH PRIVATE LIMITED",
"MAASATYA MERCHANTS PRIVATE LIMITED",
"MAA-SHAKAMBHRI DAL MILLS PVT LTD",
"MAASHEETLA INDUSTRIES PRIVATE LIMITED",
"MAASHEETLA VENTURES LIMITED",
"MAASHITLA SECURITIES PRIVATE LIMITED",
"MAASHRI AKSHARA DEVI PRIVATE LIMITED",
"MAASHRI PITAMBARA REALCON PRIVATE LIMITED",
"MAASIDDHIDATRI CATTLE FEED PRIVATE LIMITED",
"MAASILVER HUB INDIA PRIVATE LIMITED",
"MAASIS INTER FASHION PRIVATE LIMITED",
"MAASS FLANGE INDIA PRIVATE LIMITED",
"MAA-SUSWANI JEWELLERS PRIVATE LIMITED",
"MAATANGI JEWELS PRIVATE LIMITED",
"MAATANGI TEXTILES PRIVATE LIMITED",
"MAATAPESHWARI MEDIA & PUBLICATION PRIVATE LIMITED",
"MAATRIBHUMI INFRATECH PRIVATE LIMITED",
"MAATRUM TECHNOLOGIES AND LEGAL VENTURES PRIVATE LIMITED",
"MAAU BRANDS PRIVATE LIMITED",
"MAAULI CREATIONS PRIVATE LIMITED",
"MAAULI PROPAC PRIVATE LIMITED",
"MAAVADI SOFT TECH VENTURES (INDIA) PRIVATE LIMITED",
"MAAVADU MESS PRIVATE LIMITED",
"MAAVAISHNONANDINI FOOD PRODUCTS PRIVATE LIMITED",
"MAAVIYA ENGINEERING CONSULTANTS PRIVATE LIMITED",
"MAAX HOSPITAL",
"MAAXMUS LIFE SCIENCES PRIVATE LIMITED",
"MAAYA TYRES PRIVATE LIMITED",
"MAAZE UNDERWRITING SOLUTIONS PRIVATE LIMITED",
"MAB AVIATION PRIVATE LIMITED",
"MAB PROJECTS ENGINEERING PRIVATE LIMITED",
"MABEL APPAREL PRIVATE LIMITED",
"MABEL ENGINEERING PRIVATE LIMITED",
"MABEL ENGINEERS PRIVATE LIMITED",
"MABELLE INNOVATIONS PRIVATE LIMITED",
"MABEN NIDHI LIMITED",
"MABEN NIDHI LIMITED.",
"MABI ALLUPLAST PRIVATE LIMITED",
"MABON TECHNOLOGIES PRIVATE LIMITED",
"MABOOD INTERNATIONAL PRIVATE LIMITED",
"MABU SEAL PRIVATE LIMITED",
"MAC ANCILLARY SERVICES PRIVATE LIMITED",
"MAC BIO SCIENCES PRIVATE LIMITED",
"MAC CHARLES INDIA LIMITED",
"MAC COATINGS PRIVATE LIMITED",
"MAC DECOR LIMITED",
"MAC FINANCIAL AND MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"MAC FOREX & HOLIDAYS PRIVATE LIMITED",
"MAC HEALTH CARE (INDIA) PRIVATE LIMITED",
"MAC HOTELS LIMITED",
"MAC INDUSTRIAL SECURITY AND FACILITY SERVICES PRIVATE LIMITED",
"MAC INDUSTRIES",
"MAC LIFESTYLE PRODUCTS LIMITED",
"MAC MASTER TOOLS PRIVATE LIMITED",
"MAC MEDILIFE PRIVATE LIMITED",
"MAC PERSONAL CARE PRIVATE LIMITED",
"MAC STEELAGE PIPE AND TUBE PRIVATE LIMITED",
"MAC TECH INTERNATIONAL PRIVATE LIMITED",
"MAC TECHNOCAST PRIVATE LIMITED",
"MAC VEHICLES PRIVATE LIMITED",
"MAC WELL PHARMACEUTICALS PRIVATE LIMITED",
"MACADAM GRANITES PRIVATE LIMITED",
"MACADAM MANAGEMENT SERVICES PRIVATE LIMITED",
"MACADUM MAKERS INFRASTRUCTURE PRIVATE LIMITED",
"MACAPPSTUDIO PRIVATE LIMITED",
"MACARAV INFRASTRUCTURES INDIA PRIVATE LIMITED",
"MACARIO TECHNOLOGIES PRIVATE LIMITED",
"MACART EQUIPMENTS PRIVATE LIMITED",
"MACAWBER BEEKAY PRIVATE LIMITED",
"MACAWBER ENGINEERING SYSTEMS INDIA PRIVATE LIMITED",
"MACBEE PRIVATE LIMITED",
"MACBROUT ENGINEERING PRIVATE LIMITED",
"MACC OCEANIC INDIA PRIVATE LIMITED",
"MACCAFERRI ENVIRONMENTAL SOLUTIONS PRIVATE LIMITED",
"MACCAFERRI INFRASTRUCTURE PRIVATE LIMITED",
"MACCARE DRUGS PRIVATE LIMITED",
"MACCARE SOLUTIONS INDIA PRIVATE LIMITED",
"MACCARON INDIA PRIVATE LIMITED",
"MAC-CHEM PRODUCTS INDIA PRIVATE LIMITED",
"MACCLITE INDUSTRIES PRIVATE LIMITED",
"MACDONALD HUMFREY (AUTOMATION) INDIA PRIVATE LIMITED",
"MACE PHARMA PRIVATE LIMITED",
"MACE PROJECT AND COST MANAGEMENT PRIVATE LIMITED",
"MACEA EXPORT (INDIA) PRIVATE LIMITED",
"MACEDON VINIMAY PVT.LTD.",
"MACER INDUSTRIES PRIVATE LIMITED",
"MACFIL GLOBAL PRIVATE LIMITED",
"MACFLOW ENGINEERING PRIVATE LIMITED",
"MACFOS PRIVATE LIMITED",
"MACGREGOR MARINE INDIA PRIVATE LIMITED",
"MACH - 1 MACHINERY AND ENGINEERING PRIVATE LIMITED",
"MACH AERO COMPONENTS PRIVATE LIMITED",
"MACH CLEARING SOLUTIONS INDIA PRIVATE LIMITED",
"MACH CONFERENCE & EVENTS PRIVATE LIMITED",
"MACH CONFERENCES AND EVENTS PRIVATE LIMITED.",
"MACH MIND TECHNOLOGIES PRIVATE LIMITED",
"MACH TRADE WINGS PRIVATE LIMITED",
"MACHA CONSUMER PRODUCTS PRIVATE LIMITED",
"MACHADO AND SONS AGENTS AND STEVEDORES PRIVATE LIMITED",
"MACHADO SONS PRIVATE LIMITED",
"MACHANI INFRA DEVELOPMENT CORPORATION PRIVATE LIMITED",
"MACHBIZZ MARKETERS PRIVATE LIMITED",
"MACHE PRIVATE LIMITED",
"MACHENZZO INDIA PRIVATE LIMITED",
"MACHHALANDAPUR SIMLON AGRO PRIVATE LIMITED",
"MACHHAR INDUSTRIES LIMITED",
"MACHHAR PACKAGING SERVICES PRIVATE LIMITED",
"MACHHAR POLYMER PRIVATE LIMITED",
"MACHILIPATNAM COMMUNICATIONS PRIVATE LIMITED",
"MACHINE HOUSE INDIA PRIVATE LIMITED",
"MACHINE SUPPLIERS SYNDICATE PVT LTD",
"ARMOURED VEHICLES NIGAM LIMITED",
"MACHINE TOOLS INDIA LIMITED",
"MACHINERY MARKETING ASSOCIATES PRIVATE LIMITED",
"MACHINETRON AUTOMATION PRIVATE LIMITED",
"MACHINFABRIK INDUSTRIES PRIVATE LIMITED",
"MACHINFINITY PRIVATE LIMITED",
"MACHINO AGRICULTURE IMPLEMENTS PRIVATE LIMITED",
"MACHINO AUTO COMP TOOLING PRIVATE LIMITED",
"MACHINO INTERNATIONAL PRIVATE LIMITED",
"MACHINO PLASTICS BECHARAJI LIMITED",
"MACHINO PLASTICS LIMITED",
"MACHINO POLYMERS LIMITED",
"MACHINO TECHNO SALES LIMITED",
"MACHINT SOLUTIONS PRIVATE LIMITED",
"MACHINTEL MEDIA PRIVATE LIMITED",
"MACHINTEL SYSTEMS PRIVATE LIMITED",
"MACHINTORG INDIA PRIVATE LTD",
"MACHIS EVENTS PRIVATE LIMITED",
"MACHO ENGINEERING INDUSTRIES",
"MACHRE REFRIGERATION PRODUCTS PRIVATE LIMITED",
"MACHSAN ENGINEERS PRIVATE LIMITED",
"MACHT CONSULTANTS PRIVATE LIMITED",
"MACHT TECHNOLOGIES PRIVATE LIMITED",
"MACHTIG SOLUTIONS PRIVATE LIMITED",
"MACHTRANS SHIP MANAGEMENT PRIVATE LIMITED",
"MACHTRONIX INDIA PRIVATE LIMITED",
"MACHWAN COMMUNICATION & RESEARCH PRIVATE LIMITED",
"MACHWARES IT SOLUTIONS PRIVATE LIMITED",
"MACHWEL ENGINEERING SERVICES PRIVATE LIMITED",
"MACHWELD TRANSMISSIONS PRIVATE LIMITED",
"MACI DEVELOPERS PRIVATE LIMITED",
"MACI RESEARCH PRIVATE LIMITED",
"MACIN REMEDIES INDIA LIMITED",
"MACITA F&B PRIVATE LIMITED",
"MACK AURAA HEALTHCARE PRIVATE LIMITED",
"MACK BROWN PHARMACEUTICALS PVT LTD",
"MACK COLLECTIONS PVT LTD",
"MACK PHARMATECH PRIVATE LIMITED",
"MACK SOFT TECH PRIVATE LIMITED",
"MACK SPRINGS PRIVATE LIMITED",
"MACK STAR MARKETING PRIVATE LIMITED",
"MACK TELECOM SERVICES PRIVATE LIMITED",
"MACK TRADING COMPANY LIMITED",
"MACK VALVES INDIA PRIVATE LIMITED",
"MACKAY MARINE PRIVATE LIMITED",
"MACKEIL ISPAT & FORGING LIMITED",
"MACKENZIE ENGINEERING PRIVATE LIMITED",
"MACKERAL OIL TOOLS PRIVATE LIMITED",
"MACKERTICH CONSULTANCY SERVICES PVT LTD",
"MACKINON ENTERPRISES PRIVATE LIMITED",
"MACKINTOSH BURN LIMITED",
"MACKLY CLOTHING PRIVATE LIMITED",
"MACKLY LIFE SCIENCE PRICATE LIMITED",
"MACKS SURFACE TREATMENTS PRIVATE LIMITED",
"MACLAN PHARMACEUTICALS PRIVATE LIMITED",
"MACLAREEN CONSULTING INDIA PRIVATE LIMITED",
"MACLEAN POWER (INDIA) PRIVATE LIMITED",
"MACLEC TECHNICAL PROJECT LABORATORY PRIVATE LIMITED",
"MACLEODS PHARMACEUTICALS LIMITED",
"MACLEON PHARMACEUTICALS PRIVATE LIMITED",
"MAC-LINE INDIA PRIVATE LIMITED",
"MACLOWIN LIFESCIENCE PRIVATE LIMITED",
"MACMERISE CELFIE DESIGN PRIVATE LIMITED",
"MACMET ENGINEERING LIMITED",
"MACMET INDIA LIMITED",
"MACMET INDIA PRIVATE LIMITED",
"MACMILLAN DEVELOPERS PRIVATE LIMITED",
"MACMILLAN EDUCATION INDIA PRIVATE LIMITED",
"MACMILLON PHARMACEUTICALS LIMITED",
"MACMILLON PHARMACEUTICALS PRIVATE LIMITED",
"MACMIXU COATING AND CHEMICALS PRIVATE LIMITED",
"MACNEILL ENGINEERING LTD",
"MAC-NELS CONTAINER LINES PRIVATE LIMITED",
"MACNICA CYTECH PTE LTD",
"MACNOR LIFESCIENCES PRIVATE LIMITED",
"MACO CORPORATION INDIA PRIVATE LIMITED",
"MACO INFOTECH LIMITED",
"MACO PRIVATE LIMITED",
"MACOBS TECHNOLOGIES LIMITED",
"MACOLINE SHIPPING PRIVATE LIMITED",
"MACOM TECHNOLOGY SOLUTIONS BANGALORE PRIVATE LIMITED",
"MACON ENVIRO TECHNOLOGIES PRIVATE LIMITED",
"MACONS EQUIPMENTS PRIVATE LIMITED",
"MACPAC INDUSTRIES PRIVATE LIMITED",
"MACPI TRADING INDIA PRIVATE LIMITED",
"MACPOLE INDIA PRIVATE LIMITED",
"MACPOWER CNC MACHINES LIMITED",
"MACPOWER SWITCHGEAR PRIVATE LIMITED",
"MACPRO BUSINESS SERVICES INDIA PRIVATE LIMITED",
"MACPRO TECHNOLOGIES PRIVATE LIMITED",
"MACQUARIE CAPITAL SECURITIES (INDIA) PRIVATE LIMITED",
"MACQUARIE GLOBAL SERVICES PRIVATE LIMITED",
"MACQUARIE GROUP MANAGEMENT (INDIA) PRIVATE LIMITED",
"MACQUARIE INFRASTRUCTURE AND REAL ASSETS (INDIA) PRIVATE LIMITED",
"MACRAME DESIGNS PRIVATE LIMITED",
"MACREW TECHNOLOGIES PRIVATE LIMITED",
"MACRICH IT SOLUTIONS PRIVATE LIMITED",
"MACRO AUTOMATION SOLUTIONS INDIA PRIVATE LIMITED",
"MACRO BARS AND WIRES (INDIA) PVT LTD",
"MACRO COSMIC ENGINEERS PRIVATE LIMITED",
"MACRO DEALCOMM PRIVATE LIMITED",
"MACRO ELECTRO TECH PRIVATE LIMITED",
"MACRO FURNACES PRIVATE LIMITED",
"MACRO HEALTH LABS PRIVATE LIMITED",
"MACRO INFOTECH PRIVATE LIMITED",
"MACRO INFRABUILD PRIVATE LIMITED",
"MACRO INTERNATIONAL LIMITED",
"MACRO LABS PRIVATE LIMITED",
"MACRO LOGISTICS & EXIM PRIVATE LIMITED",
"MACRO MEDIA DIGITAL IMAGING PRIVATE LIMITED",
"MACRO METALS PRIVATE LIMITED",
"MACRO MOULDS & PLASTICS PRIVATE LIMITED",
"MACRO NIRMAN PRIVATE LIMITED",
"MACRO POLYMERS PRIVATE LIMITED",
"MACRO PRECISION COMPONENTS",
"MACRO SCIENTIFIC WORKS PRIVATE LIMITED",
"MACRO TECH EQUIPMENT PRIVATE LIMITED",
"MACRO TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"MACROFIL INVESTMENTS LIMITED",
"MACROLINK SOLUTIONS SERVICES PRIVATE LIMITED",
"MACRON EXPRESS SERVICES PRIVATE LIMITED",
"MACRON LOGI SERVICES PRIVATE LIMITED",
"MACRONEL INDIA PRIVATE LIMITED",
"MACRONIMOUS WEB SOLUTIONS PRIVATE LIMITED",
"MACRONIX INTEGRATIVE SOLUTIONS (OPC) PRIVATE LIMITED",
"MACRONOVA APPARELS PRIVATE LIMITED",
"MACROPACT EXIM PRIVATE LIMITED",
"MACROPLAST PRIVATE LIMITED",
"MACROSENSE CONSTRUCTION PRIVATE LIMITED",
"MACROSERVE INFOTECH PRIVATE LIMITED",
"MACROSIVE COMPUTER SOLUTIONS PRIVATE LIMITED",
"MACROSOFT IT SOLUTIONS INDIA PRIVATE LIMITED",
"MACROSPARK ENGINEERING PRIVATE LIMITED",
"MACROTECH DEVELOPERS LIMITED",
"MACROTECH POLYCHEM PRIVATE LIMITED",
"MACROVISION TEA & ALLIED PRIVATE LIMITED",
"MACROVISION TELENET PRIVATE LIMITED",
"MACS AGHARKAR RESEARCH INSTITUTE",
"MACS FABRICATORS PVT LTD",
"MACSAM CLOTHING PRIVATE LIMITED",
"MACSOFT ELECTRONIC CONTROLS INDIA PRIVATE LIMITED",
"MACSON COLOR CHEM PRIVATE LIMITED",
"MACSONS SHIPPING AGENCIES PRIVATE LIMITED",
"MACSTAR MACHINE TOOLS PRIVATE LIMITED",
"MAC-STEEL PVT LTD",
"MACSUN CONSTRUCTION PRIVATE LTD",
"MACSUR PHARMAA (INDIA) PRIVATE LIMITED",
"MACT ENGINEERS PRIVATE LIMITED",
"MACTEC REALTORS & DEVELOPERS PRIVATE LIMITED",
"MACTECH ENGINEERING",
"MACTEL INFOTECH PRIVATE LIMITED",
"MACTILE INDIA PRIVATE LIMITED",
"MACTION CONSULTING PRIVATE LIMITED",
"MACTOWN INFRA PRIVATE LIMITED",
"MACUREX SENSORS PRIVATE LIMITED",
"MACVALLY PHARMA PRIVATE LIMITED",
"MACVISION KRISHNA EDUCATION TRUST",
"MACWALA DOT COM PRIVATE LIMITED",
"MACWEL INFOSYSTEMS PRIVATE LIMITED",
"MACWEL METALS PRIVATE LIMITED",
"MACWELL AUTO ENGINEERING PRIVATE LIMITED",
"MACWIN LOGISTICS PRIVATE LIMITED",
"MAD (INDIA) PRIVATE LIMITED",
"MAD ABOUT WHEELS PRIVATE LIMITED",
"MAD ENTERTAINMENT LIMITED",
"MAD STUDIOS PRIVATE LIMITED",
"MAD WORKS INDIA ADVERTISING PRIVATE LIMITED",
"MADAAN EGG PRIVATE LIMITED",
"MADAAN HOSIERY PRIVATE LIMITED",
"MADAAN JACQUARD FACTORY PRIVATE LIMITED",
"MADADNISH PASHUPALAN NIYAMAK",
"MADAM AGRO FOOD INDUSTRIES PRIVATE LIMITED",
"MADAN CHEMICALS PRIVATE LIMITED",
"MADAN GOPAL BOARD HOUSE PRIVATE LIMITED",
"MADAN JEWELLERS PRIVATE LIMITED",
"MADAN LAL & SONS FRUITS PRIVATE LIMITED",
"MADAN LAL BAJAJ CONSTRUCTION PRIVATE LIMITED",
"MADAN LAL BANSAL AND COMPANY CONTRACTORS PVT LTD",
"MADAN LAL PURUSHOTTAM DAS FOODS PRIVATE LIMITED",
"MADAN MADHAV FERTILIZERS AND CHEMICALS PRIVATE LIMITED",
"MADAN MARKETINGS PRIVATE LIMITED",
"MADAN MOHAN GRADINGS PRIVATE LIMITED",
"MADAN MOHAN MALAVIYA UNIVERSITY OF TECHNOLOGY",
"MADAN MOHAN MALVIYA INTER COLLEGE ALIGARH",
"MADAN MOHAN MISHRA ENTERPRISES PRIVATE LIMITED",
"MADAN MOTORS AUTO WHEELS PRIVATE LIMITED",
"MADAN SAREE EMPORIUM",
"MADAN TRANSMISSIONS PRIVATE LIMITED",
"MADAN UDYOG PRIVATE LIMITED",
"MADANAHATTI LOGISTICS AND INDUSTRIAL PARKS PRIVATE LIMITED",
"MADANAPALLE INSTITUTE OF TECHNOLOGY & SCIENCE",
"MADANAPALLE RETAIL PRIVATE LIMITED",
"MADANIMUS TECHNOLOGIES PRIVATE LIMITED",
"MADANJI MEGHRAJ JEWELLERS PRIVATE LIMITED",
"MADANLAL LTD",
"MADANMOHAN PROPERTIES PRIVATE LIMITED",
"MADANMOHAN REALCON PRIVATE LIMITED",
"MADANMOHAN RICE MILL PRIVATE LIMITED",
"MADANMOHAN VINODKUMAR DISTRIBUTORS PRIVATE LIMITED",
"MADANPUR SOUTH COAL COMPANY LIMITED",
"MADARSA ALIYA JAMA MASJID",
"MADARSA ANSAR JUNIOR HIGH SCHOOL NISWAN",
"MADARSA ARABIA ASHRAFUL ULOOM BASTI",
"MADARSA ARABIA MISBAHUL ULLOM",
"MADARSA KHANAN JAN ARABIC SCHOOL",
"MADAV BUILDCON PRIVATE LIMITED",
"MADBOW VENTURES LIMITED",
"MADBULL TECHNOLOGIES PRIVATE LIMITED",
"MADCAP ADVENTURE XPERIENCES PRIVATE LIMITED",
"MADDER FINANCIAL CONSULTANTS PRIVATE LIMITED",
"MADDI LAKSHMAIAH AND COMPANY PRIVATE LIMITED",
"MADDOCK FILMS PRIVATE LIMITED",
"MADDOX PEOPLECARE PRIVATE LIMITED",
"MADDOX SOLUTIONS PRIVATE LIMITED",
"MADDUX PRODUCTS PRIVATE LIMITED",
"MADE EASY EDUCATION PRIVATE LIMITED",
"MADE EASY PUBLICATIONS PRIVATE LIMITED",
"MADE EASY SCHOOL",
"MADEENA COLD STORAGE PRIVATE LIMITED",
"MADEENASTAR TRADING COMPANY PRIVATE LIMITED",
"MADEIRA INDIA PRIVATE LIMITED",
"MADELEINE PRE UNIVERSITY COLLEGE MULKY",
"MADESH HUMAN RESOURCES PRIVATE LIMITED",
"MADESWARA ESTATES TEA FACTORY PRIVATE LIMITED",
"MADGETS INDIA PRIVATE LIMITED",
"MADGUL PARKS PVT LTD",
"MADHA COLLEGE OF NURSING",
"MADHA ENGINERING COLLEGE",
"MADHA INSTITUTE OF ENGINEERING AND TECHNOLOGY",
"MADHA MEDICAL COLLEGE AND RESEARCH INSTITUTE",
"MADHABGANJ KARUNAMOYEE HIMGHAR PRIVATE LIMITED",
"MADHABI ENGINEERING WORKS PRIVATE LIMITED",
"MADHABI GOLD HOUSE PRIVATE LIMITED",
"MADHAMPATTY THANGAVELU HOSPITALITY PRIVATE LIMITED",
"MADHANI INFRAPROJECTS PRIVATE LIMITED",
"MADHAV (AARON SINDH ROAD) PRIVATE LIMITED",
"MADHAV (PHOOLSAGAR NIWAS SHAHPURA CORRIDOR) HIGHWAYS PRIVATE LIMITED",
"MADHAV (SEHORA SILODI CORRIDOR) HIGHWAYS PRIVATE LIMITED",
"MADHAV AGRO FOODS PRIVATE LIMITED",
"MADHAV ALLOYS PRIVATE LIMITED",
"MADHAV AND RAGHAV INFRAMECH PRIVATE LIMITED",
"MADHAV ASSOCIATE",
"MADHAV AUTOLINK PRIVATE LIMITED",
"MADHAV AUTOMOBILES PRIVATE LIMITED",
"MADHAV AUTOWINGS PRIVATE LIMITED",
"MADHAV BISCUITS PRIVATE LIMITED",
"MADHAV BUILDTECH PRIVATE LIMITED",
"MADHAV CAPACITORS PVT LTD",
"MADHAV CHEM-TECH PRIVATE LIMITED",
"MADHAV CONSTRUCTIONS",
"MADHAV CORPORATION PRIVATE LIMITED",
"MADHAV COTEX PVT.LTD.",
"MADHAV COTTON PRIVATE LIMITED",
"MADHAV DIAMOND",
"MADHAV EQUIPMENTS AND ENGINEERS PRIVATE LIMITED",
"MADHAV EXIM PRIVATE LIMITED",
"MADHAV EXPOSITION PRIVATE LIMITED",
"MADHAV FARMTECH CORPORATION PRIVATE LIMITED",
"MADHAV FIBRES PVT LTD",
"MADHAV GOVIND FOOD PRODUCTS PRIVATE LIMITED",
"MADHAV INDUSTRIAL GASES PVT LTD",
"MADHAV INFRA PROJECTS LIMITED",
"MADHAV INFRACON (BK CORRIDOR) PRIVATE LIMITED",
"MADHAV INFRACON (GHANSORE MANDLA CORRIDOR) PRIVATE LIMITED",
"MADHAV INSTITUTE OF TECHNOLOGY & SCIENCE GWALIOR (M P) INDIA GWALIOR",
"MADHAV INSURANCE BROKERS PRIVATE LIMITED",
"MADHAV KRG LIMITED",
"MADHAV KRG RE CYCLERS PRIVATE LIMITED",
"MADHAV KRG TRADE LINK PRIVATE LIMITED",
"MADHAV LIFE STYLE PRIVATE LIMITED",
"MADHAV LIMAYE CONSULTING LIMITED LIABILITY PARTNERSHIP",
"MADHAV MARBLES AND GRANITES LIMITED",
"MADHAV MARINE PRODUCTS PRIVATE LIMITED",
"MADHAV MEDIA PRIVATE LIMITED",
"MADHAV MINERALS & CHEMICALS PRIVATE LIMITED",
"MADHAV MUKUND PROMOTERS PRIVATE LIMITED",
"MADHAV NIRMAN PRIVATE LIMITED",
"MADHAV OIL INDUSTRIES",
"MADHAV PE FOAM PRIVATE LIMITED",
"MADHAV PIPES & TUBES PRIVATE LIMITED",
"MADHAV PRINTO GRAPHICS PRIVATE LIMITED",
"MADHAV PUFOAM PRIVATE LIMITED",
"MADHAV RAGHAV FOODS PRIVATE LIMITED",
"MADHAV RENEWABLES PRIVATE LIMITED",
"MADHAV SALES PRIVATE LIMITED",
"MADHAV SHEETGRAH PRIVATE LIMITED",
"MADHAV SOLAR (KARNATAKA) PRIVATE LIMITED",
"MADHAV SOLAR (VADODARA ROOFTOP) PRIVATE LIMITED",
"MADHAV SOLAR PRIVATE LIMITED",
"MADHAV STELCO PRIVATE LIMITED",
"MADHAV STOCK VISION PRIVATE LIMITED",
"MADHAV STORES",
"MADHAV TEX SPIN PRIVATE LIMITED",
"MADHAV TRADING CORPORATION LIMITED",
"MADHAV UDYOG PRIVATE LIMITED",
"MADHAV VASISTHA HYDRO POWER PRIVATE LIMITED",
"MADHAV VENTURES PRIVATE LIMITED",
"MADHAV VIDHYA SANKUL",
"MADHAVA HYTECH INFRASTRUCTURES (INDIA) PRIVATE LIMITED",
"MADHAVAN POLYPLAST PRIVATE LIMITED",
"MADHAVAN TRADERS",
"MADHAVEY INFRA PROJECT PRIVATE LIMITED",
"MADHAVI DESAI CONSULTING PRIVATE LIMITED",
"MADHAVI EDIBLE BRAN OILS (RAICHUR) PRIVATE LIMITED",
"MADHAVI EDIBLE BRAN OILS PRIVATE LIMITED",
"MADHAVI JEWELLERS PRIVATE LIMITED",
"MADHAVI MICRO MINERALS PRIVATE LIMITED",
"MADHAVI REAL ESTATES PRIVATE LIMITED",
"MADHAVI STONES PRIVATE LIMITED",
"MADHAVKRISHNA TEXTILE MILLS PRIVATE LIMITED",
"MADHAVLAL JANKILAL TRADING PRIVATE LIMITED",
"MADHAVNAGAR STEEL & ALLOYS PRIVATE LIMITED",
"MADHAVSHRI EXPORTS PRIVATE LIMITED",
"MADHDA BUSINESS SOLUTIONS PRIVATE LIMITED",
"MADHEES TECHNO CONSULTING PRIVATE LIMITED",
"MADHEPURA ELECTRIC LOCOMOTIVE PRIVATE LIMITED",
"MADHESHIYA INFRASTRUCTURES PRIVATE LIMITED",
"MADHIKA AUTO PRIVATE LIMITED",
"MADHO AROMATICS & SPICES PRIVATE LIMITED",
"MADHOK HOSIERY FACTORY",
"MADHOOR BUILDWELL PRIVATE LIMITED",
"MADHOOS BIOCARE PRIVATE LIMITED",
"MADHOUSE MOBILE INDIA PRIVATE LIMITED",
"MADHRANI CHEMICALS PRIVATE LIMITED",
"MADHU CHANDRA TECHNO-CHEM COMPLEX PVT LTD",
"MADHU CHAWLA DESIGN PRIVATE LIMITED",
"MADHU CORPORATE PARK LIMITED",
"MADHU CORPORATE SERVICES PRIVATE LIMITED",
"MADHU EDUCATIONAL ACADEMY",
"MADHU FERTILIZERS LIMITED",
"MADHU FINANCE AND ESTATE PRIVATE LIMITED",
"MADHU FRAGRANCES PRIVATE LIMITED",
"MADHU GLASSTEX PRIVATE LIMITED",
"MADHU HOLDINGS PRIVATE LIMITED",
"MADHU HYDRO PRODUCTS PRIVATE LIMITED",
"MADHU HYDROCOLLOIDS PRIVATE LIMITED",
"MADHU INDIA DECO LIMITED",
"MADHU INDUSTRIES PRIVATE LIMITED",
"MADHU INFOTECH INDIA PRIVATE LIMITED",
"MADHU INFRACON PRIVATE LIMITED",
"MADHU JAS PROMOTIONS PRIVATE LIMITED",
"MADHU JAYANTI INTERNATIONAL PRIVATE LIMITED",
"MADHU JEWELLERS PRIVATE LIMITED",
"MADHU MACHINES & SYSTEMS PRIVATE LIMITED",
"MADHU MALTI ENTERPRISES PRIVATE LIMITED",
"MADHU MATTOR PVT LTD",
"MADHU MERCHANDISE PRIVATE LIMITED",
"MADHU ONLINE SERVICES PRIVATE LIMITED",
"MADHU PLASTICS PRIVATE LIMITED",
"MADHU POLYTECH PRIVATE LIMITED",
"MADHU SILICA PRIVATE LIMITED",
"MADHU SKIN CLINIC",
"MADHU SUBTRONIC COMPONENTS PRIVATE LIMITED",
"MADHU SULZCON PRIVATE LIMITED",
"MADHU TECHNO DEVICES PRIVATE LIMITED",
"MADHU TEX INDUSTRIES LIMITED",
"MADHU VILAS HOTEL PRIVATE LIMITED",
"MADHU VINIYOG PRIVATE LIMITED",
"MADHUADIT HEALTHCARE PRIVATE LIMITED",
"MADHUANAND CONSTRUCTION PRIVATE LIMITED",
"MADHUBAN AGRISTORAGE PRIVATE LIMITED",
"MADHUBAN GOLD PRIVATE LIMITED",
"MADHUBAN INN PRIVATE LIMITED",
"MADHUBAN MOTORS PRIVATE LIMITED",
"MADHUBAN TRADE-STEELS PRIVATE LIMITED",
"MADHUBANI AGRO PRIVATE LIMITED",
"MADHUBANI INVESTMENTS PRIVATE LIMITED",
"MADHUBANI MAKHANA PRIVATE LIMITED",
"MADHUBANI TRADING COMPANY PRIVATE LIMITED",
"MADHUBARI TEA & AGRO INDUSTRY PRIVATE LIMITED",
"MADHUBATI PAPERS PRIVATE LIMITED",
"MADHUBENI HOME APPLIANCES PRIVATE LIMITED",
"MADHUCON HEIGHTS PRIVATE LIMITED",
"MADHUCON MEGA MALL PRIVATE LIMITED",
"MADHUCON PROJECTS LIMITED",
"MADHUKAMAL INFRASTRUCTURE PRIVATE LIMITED",
"MADHUKAMAL TEA INDUSTRY PRIVATE LIMITED",
"MADHUKAMINI FABRICS PRIVATE LIMITED",
"MADHUKARS RAINBOW CHILDRENS HOSPITALS",
"MADHUKER FLOUR MILL PRIVATE LIMITED",
"MADHUKHAR FOUNDATION PRIVATE LIMITED",
"MADHUKRISHNA ENGINEERS PRIVATE LIMITED",
"MADHULI EXIM PRIVATE LIMITED",
"MADHULIKA ESTATE ENTERPRISE PRIVATE LIMITED",
"MADHULIKA FOODS PRIVATE LIMITED",
"MADHULOKA LIQUOR BOUTIQUE PRIVATE LIMITED",
"MADHUMALATI CONSTRUCTIONS PRIVATE LIMITED",
"MADHUMALTI DISTRIBUTORS PVT. LTD.",
"MADHUMILAN INDUSTRIES LIMITED",
"MADHUMITA CONSTRUCTION PVT LTD",
"MADHUMITA DAIRY PRODUCTS PRIVATE LIMITED",
"MADHUMITHRA DEVELOPERS PRIVATE LIMITED",
"MADHUNANDAN TEXTILES PRIVATE LIMITED",
"MADHUNIL ENGINEERING SERVICES PRIVATE LIMITED",
"MADHUPRIYA FASHIONS PRIVATE LIMITED",
"MADHUPUR TEA ESTATE PVT LTD",
"MADHUPUR WASTE MANAGEMENT PRIVATE LIMITED",
"MADHUR COLD STORAGE PRIVATE LIMITED",
"MADHUR ENGINEERS PRIVATE LIMITED",
"MADHUR IRON & STEEL (INDIA) PRIVATE LIMITED",
"MADHUR KNIT CRAFTS PRIVATE LIMITED",
"MADHUR MARBLES PRIVATE LIMITED",
"MADHUR MILAN FOOD PRODUCTS PRIVATE LIMITED",
"MADHUR NEWS INDIA PRIVATE LIMITED",
"MADHUR PARCEL SERVICES PRIVATE LIMITED",
"MADHUR PHARMA AND RESEARCH LABORATORIES PRIVATE LIMITED",
"MADHUR PLASTIC PRIVATE LIMITED",
"MADHUR SALES PRIVATE LIMITED",
"MADHUR SECURITIES PVT LTD",
"MADHUR TRADERS INFRA PRIVATE LIMITED",
"MADHUR VEGOILS PRIVATE LIMITED",
"MADHURA AGENCY PRIVATE LIMITED",
"MADHURA DIE CAST PRIVATE LIMITED",
"MADHURA ENGINEERING SERVICES PRIVATE LIMITED",
"MADHURA FRAGRANCES PRIVATE LIMITED",
"MADHURA INGOTS AND STEEL COMPANY PRIVATE LIMITED",
"MADHURA POWER TECHNOLOGIES PRIVATE LIMITED",
"MADHURAJ ENGINEERS PRIVATE LIMITED",
"MADHURAJ HOSPITAL PRIVATE LIMITED",
"MADHURAJ IMPEX PRIVATE LIMITED",
"MADHURAJ INDUSTRIAL GASES PRIVATE LIMITED",
"MADHURAJ MARKETING & TECHNOLOGIES PRIVATE LIMITED",
"MADHURAJ RESTAURANT",
"MADHURAM APPARELS PRIVATE LIMITED",
"MADHURAM FABRICS PRIVATE LIMITED",
"MADHURAM INDUSTRIES PRIVATE LIMITED",
"MADHURAM METAL (INDIA) PRIVATE LIMITED",
"MADHURAM PAPER PRIVATE LIMITED",
"MADHURAM PULSES PRIVATE LIMITED",
"MADHURAM SPORTS CAFE PRIVATE LIMITED",
"MADHURAM SYNTHETICS PRIVATE LIMITED",
"MADHURAM TRADERS PRIVATE LIMITED",
"MADHURE INFRA ENGINEERING PRIVATE LIMITED",
"MADHURGOPAL SYNTHETICS PRIVATE LIMITED",
"MADHURI ADVISORY AND ASSETS PRIVATE LIMITED",
"MADHURI ELECTRONICS PVT LTD",
"MADHURI EXPORTS PVT. LTD.",
"MADHURI REFINERS PRIVATE LIMITED",
"MADHURI RUIA S INTEGYM",
"MADHURIMA INTERNATIONAL PRIVATE LIMITED",
"MADHUS GARAGE EQUIPMENTS PRIVATE LIMITED",
"MADHUSANCHAY CONSTRUCTION & DEVELOPERS PRIVATE LIMITED",
"MADHUSHREE AGRO INDUSTRIES (INDIA) PRIVATE LIMITED",
"MADHUSHREE CONSTRUCTIONS PVT LTD",
"MADHUSHREE ENGINEERING SERVICES",
"MADHUSHREE ENTERPRISES PRIVATE LIMITED",
"MADHUSIRI GEOINFORMATICS & SURVEY PRIVATE LIMITED",
"MADHUSMITA DEVELOPERS PRIVATE LIMITED",
"MADHUSMITA INFRASTRUCTURE PRIVATE LIMITED",
"MADHUSON OVERSEAS PRIVATE LIMITED",
"MADHUSUDAN AGRAWAL PROJECT PRIVATE LIMITED",
"MADHUSUDAN AGRI PROCESSING AND COLD STORAGE PRIVATE LIMITED",
"MADHUSUDAN AUTO PRIVATE LIMITED",
"MADHUSUDAN AUTO-BIZ PRIVATE LIMITED",
"MADHUSUDAN BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"MADHUSUDAN DURGESH POLYMERS PRIVATE LIMITED",
"MADHUSUDAN ENTERPRISES PRIVATE LIMITED",
"MADHUSUDAN EXPOFAB PRIVATE LIMITED",
"MADHUSUDAN FERROMETS PRIVATE LIMITED",
"MADHUSUDAN GARAI",
"MADHUSUDAN GOVT ITI",
"MADHUSUDAN HOUSING AND INFRASTRUCTURE PRIVATE LIMITED",
"MADHUSUDAN LOGISTICS PRIVATE LIMITED",
"MADHUSUDAN MARBLES PRIVATE LIMITED",
"MADHUSUDAN MINERALS PVT LTD",
"MADHUSUDAN MOTORS PRIVATE LIMITED",
"MADHUSUDAN ORGANICS PRIVATE LIMITED",
"MADHUSUDAN PRINTS PVT LTD",
"MADHUSUDAN PROPERTIES PRIVATE LIMITED",
"MADHUSUDAN SILK PRIVATE LIMITED",
"MADHUSUDAN SPECIAL SECTIONS PRIVATE LIMITED",
"MADHUSUDAN TEXTURISERS PRIVATE LIMITED",
"MADHUSUDAN VEHICLES PRIVATE LIMITED",
"MADHUSUDANA HEALTHCARE SERVICES PRIVATE LIMITED",
"MADHUSUDHAN ENCLAVE PRIVATE LIMITED",
"MADHUTING TEA PRIVATE LIMITED",
"MADHUVAN COTTON PRIVATE LIMITED",
"MADHUVAN GEMS AND JEWELS PRIVATE LIMITED",
"MADHUVAN INSURANCE BROKING SERVICES PRIVATE LIMITED",
"MADHUVAN IRON PRIVATE LIMITED",
"MADHUVAN PRASAD INFRA PRIVATE LIMITED",
"MADHUVAN PROPERTIES PVT LTD",
"MADHUVAN SECURITIES PVT LTD",
"MADHUVAN SILICA PRIVATE LIMITED",
"MADHUVAN SPACE MANAGEMENT PRIVATE LIMITED",
"MADHUVANTHI CONSOLIDATED CONSTRUCTIONS PRIVATE LIMITED",
"MADHVA ENTERPRISES (INDIA) PRIVATE LIMITED",
"MADHVA TEXTILE PROCESSORS PRIVATE LIMITED",
"MADHVADI PETROCHEMICALS PRIVATE LIMITED",
"MADHVI DAIRY PRIVATE LIMITED",
"MADHYA BHARAT AGRO PRODUCTS LIMITED",
"MADHYA BHARAT CONSORTIUM OF FARMERS PRODUCER COMPANY LIMITED",
"MADHYA BHARAT ENERGY CORPORATION LT",
"MADHYA BHARAT INFRASTRUCTURES PRIVATE LIMITED",
"MADHYA BHARAT PHOSPHATE PRIVATE LIMITED",
"MADHYA BHARAT POWER CORPORATION LIMITED",
"MADHYA GUJARAT VIJ COMPANY LIMITED",
"MADHYA PRADESH AGRO FOOD INDUSTRIES LIMITED",
"MADHYA PRADESH BHOJ OPEN UNIVERSITY",
"MADHYA PRADESH CRICKET ASSOCIATION",
"MADHYA PRADESH FINANCIAL CORPORATION INDORE",
"MADHYA PRADESH GARMIN SADAK VIKAS PRADIKARAN PARIYOJNA KRIYANVAN",
"MADHYA PRADESH GRAMIN BANK",
"MADHYA PRADESH HOUSING AND INFRASTRUCTURE BOARD",
"MADHYA PRADESH INDUSTRIAL DEVELOPMENT CORPORATION LTD",
"MADHYA PRADESH JAL NIGAM MARYADIT",
"MADHYA PRADESH JAYPEE MINERALS LIMITED",
"MADHYA PRADESH MADHYA KSHETRA VIDYUT VITARAN COMPANY LIMITED",
"MADHYA PRADESH METRO RAIL CORPORATION LIMITED",
"MADHYA PRADESH PASCHIM KSHETRA VIDYUT VITARAN COMPANY LIMITED",
"MADHYA PRADESH POLLUTION CONTROL BOARD",
"MADHYA PRADESH POORV KSHETRA VIDYUT VITARAN COMPANY LIMITED",
"MADHYA PRADESH POORV KSHETRA VIDYUT VITRAN COMPANY LTD",
"MADHYA PRADESH POWER GENERATING COMPANY LIMITED",
"MADHYA PRADESH POWER TRANSMISSION COMPANY LIMITED",
"MADHYA PRADESH RAJYA BEEJ EVAM FARM VIKAS NIGAM",
"MADHYA PRADESH RAJYA KRISHI VIPARAN BOARD TAKNIKI SAMBHAG JABALPUR",
"MADHYA PRADESH ROAD DEVELOPMENT CORPORATION LIMITED",
"MADHYA PRADESH SANSKRUTI PARISHAD",
"MADHYA PRADESH STATE ELECTRICITY BOARD",
"MADHYA PRADESH STATE SEED CERTIFICATION AGENCY",
"MADHYA PRADESH STATE TOURISM DEVELOPMENT CORPORATION LTD",
"MADHYA PRADESH TODAY MEDIA LIMITED",
"MADHYA PRADESH TRANSFORMERS PVT LTD",
"MADHYA PRADESH URJA VIKAS NIGAM LTD",
"MADHYA PRADESH WASTE MANAGEMENT PRIVATE LIMITED",
"MADHYA PRADESH WOMEN POULTRY PRODUCERS COMPANY PRIVATE LIMITED",
"MADHYA PRADESH WOOLEN MILLS PRIVATE LIMITED",
"MADHYACHAL PROFESSIONAL UNIVERSITY BHOPAL",
"MADHYACHAL STEELS PVT LTD",
"MADHYADESH PUBLICATIONS PRIVATE LIMITED",
"MADHYAM BUILDTECH PRIVATE LIMITED",
"MADHYAM ESTATE LINKERS PRIVATE LIMITED",
"MADHYAM MARKETING SOLUTIONS PRIVATE LIMITED",
"MADHYAM PRINTERS AND PUBLISHERS PRIVATE LIMITED",
"MADHYAMAM BROADCASTING LIMITED",
"MADHYAMGRAM B.ED COLLEGE",
"MADHYAMGRAM RAJLAKSHMI BALIKA VIDYAMANDIR",
"MADHYAMIC SHIKSHA ALIGARH",
"MADHYAMIC VIDYALAY AMLAD",
"MADHYAMIK ASHRAM SCHOOL KHADKED",
"MADHYAMIK ASHRAM SHALA KOHNALI SOLAPUR",
"MADHYAMIK ASHRAM SHALA VAROLA MAJALGAON BEED",
"MADHYAMIK ASHRAMSHALA THALVADA",
"MADHYAMIK KANYA VIDYALAYA NANDGAO PETH",
"MADHYAMIK SHALA MOTHIJUI",
"MADHYAMIK VIDYALAY PIMPALKHED",
"MADHYAMIK VIDYALAY SHELAVE",
"MADHYAMIK VIDYALAYA AMLAD",
"MADHYAMIK VIDYALAYA BHONGARA",
"MADHYAMIK VIDYALAYA BUDHAWAL",
"MADHYAMIK VIDYALAYA KANHOLI",
"MADHYAMIK VIDYALAYA NAGTHANE TQ PALUS",
"MADHYAMIK VIDYALAYA WADAVALI",
"MADHYAMIK VIDYLE DUDHALE",
"MADHYANCHAL LEASING PRIVATE LIMITED",
"MADHYANCHAL PROFESSIONAL UNIVERSITY",
"MADHYANCHAL VIDYUT VITRAN NIGAM LIMITED",
"MADHYAPRADESH CUPROMETALS PRIVATE LIMITED",
"MADHYAVART PACKAGING PVT LTD",
"MADHYMIC VIDYLAYA NIGADI",
"MADHYMIK SHIKSHAK",
"MADIBA CONSULTING INDIA PRIVATE LIMITED",
"MADIKERI CONSTRUCTION PRIVATE LIMITED",
"MADINA BROTHERS PRIVATE LIMITED",
"MADINA JR COLLEGE",
"MADINA RICE MILL PRIVATE LIMITED",
"MADINA TEXPLANET PRIVATE LIMITED",
"MADINATUL ULOOM HIGHER SECONDARY SCHOOL NANDED",
"MADISH STYLE BAR PRIVATE LIMITED",
"MADISON CHEMICALS AND INFRAPROJECTS PRIVATE LIMITED",
"MADISON CLOTHING PRIVATE LIMITED",
"MADISON COMMUNICATIONS PRIVATE LIMITED",
"MADISON NEUROCITY PRIVATE LIMITED",
"MADISON RETAIL PARADIGM PRIVATE LIMITED",
"MADISON SPECIALIST COMMUNICATION SERVICES PRIVATE LIMITED",
"MADKAR CONSTRUCTIONS PRIVATE LIMITED",
"MADKARTER TECHNOLOGIES PRIVATE LIMITED",
"MADNANI ENGINEERINGS WORKS",
"MADNANI MEDICARE PRIVATE LIMITED",
"MADNCRAZY MEDIANOMICS PRIVATE LIMITED",
"MADNI HIGH SCHOOL",
"MADONA CREATIONS PVT LTD",
"MADONIS VYAPAR PVT.LTD.",
"MADONNA SALON PRIVATE LIMITED",
"MADONNA SCHOOL",
"MADOORIE TEA ESTATE PVT LTD",
"MADOVERFISH INDIA PRIVATE LIMITED",
"MADOX TECHNOLOGIES PRIVATE LIMITED",
"MADPACKERS HOSTELS PRIVATE LIMITED",
"MADRAS ACCOUNTANCY PRIVATE LIMITED",
"MADRAS AIR-CONDITIONERS PRIVATE LIMITED",
"MADRAS APPALAM EXPORTS PRIVATE LIMITED",
"MADRAS ASSET RECOVERY COMPANY PRIVATE LIMITED",
"MADRAS AUTO SERVICE",
"MADRAS BOAT CLUB",
"MADRAS CABLE INDUSTRIES PRIVATE LIMITED",
"MADRAS CARBONS PRIVATE LIMITED",
"MADRAS CHRISTIAN COLLEGE",
"MADRAS CHRISTIAN COLLEGE HIGHER SECONDARY SCHOOL",
"MADRAS COLD FORMING PRIVATE LIMITED",
"MADRAS CRICKET CLUB",
"MADRAS CROCODILE BANK TRUST",
"MADRAS DIABETES RESEARCH FOUNDATION",
"MADRAS ENGINEERING INDUSTRIES PRIVATE LIMITED",
"MADRAS ENT RESEARCH HOSPITAL",
"MADRAS FERTILIZERS LIMITED",
"MADRAS FLUORINE PRIVATE LIMITED",
"MADRAS HARDTOOLS AGENCIES PRIVATE LIMITED",
"MADRAS HARDTOOLS PRIVATE LIMITED",
"MADRAS HYDRAULIC HOSE PRIVATE LIMITED",
"MADRAS INST OF HOTEL MANAGEMENT AND CATE",
"MADRAS INSTITUTE OF DEVELOPMENT STUDIES",
"MADRAS MEDICAL COLLEGE",
"MADRAS NETWORKING PRIVATE LIMITED",
"MADRAS RACE CLUB",
"MADRAS RADIATORS AND PRESSINGS LIMITED",
"MADRAS SECURITY PRINTERS PRIVATE LIMITED",
"MADRAS SECURITY SERVICES PRIVATE LIMITED",
"MADRAS SWITCH GEARS PRIVATE LIMITED",
"MADRAS TRAVELS AND TOURS PRIVATE LIMITED",
"MADRAS UNITY HOSPITALS PRIVATE LIMITED",
"MADRAS UNIVERSITY",
"MADRAS VETERINARY COLLEGE",
"MADRASA AHYAUSSUNNAH BAJARDIHA",
"MADRASA ARABIA SALARIA",
"MADRASA ISLAMIA ARABIA",
"MADRASI CHAKKARI BEEDI FACTORY PRIVATE LIMITED",
"MADRECHA SOLUTIONS PRIVATE LIMITED",
"MADS CREATIONS PRIVATE LIMITED",
"MADSAN AGENCIES PVT.LTD.",
"MADSTITCHES APPARELS PRIVATE LIMITED",
"MADURA COATS PRIVATE LIMITED",
"MADURA COLLEGE BOARD",
"MADURA FASHION & LIFESTYLE",
"MADURA FASHION AND LIFESTYLE",
"MADURA INDUSTRIAL TEXTILES LIMITED",
"MADURA MERCERISERS INDIA PRIVATE LIMITED",
"MADURA ORTHOSURGE PRIVATE LIMITED",
"MADURA SOUTH INDIA CORPORATION PRIVATE LIMITED",
"MADURA STEEL INDUSTRIES PRIVATE LIMITED",
"MADURA TRAVEL SERVICE PRIVATE LIMITED",
"MADURAI ACME ENTERPRISES PRIVATE LIMITED",
"MADURAI BENCH OF MADRAS HIGH COURT",
"MADURAI BUSINESS SERVICES PRIVATE LIMITED",
"MADURAI DISTRICT CENTRAL COOPERATIVE BANK LTD",
"MADURAI DISTRICT CO -OPERATIVE MILK PRODUCERS UNION LIMITED",
"MADURAI HINDU PERMANENT NIDHI LIMITED",
"MADURAI INTEGRATED TEXTILE PARK PRIVATE LIMITED",
"MADURAI KAMARJ UNIVERSITY",
"MADURAI KUMAR MESS PRIVATE LIMITED",
"MADURAI MULTIFUNCTIONAL COMPLEX PRIVATE LIMITED",
"MADURAI POWER CORPORATION PRIVATE LIMITED",
"MADURAI RENEWABLE ENERGY PRIVATE LIMITED",
"MADURAI SAI ENGINEERING COMPANY PRIVATE LIMITED",
"MADURAI SRI JEWELLERS PRIVATE LIMITED",
"MADURAI SRI KAMATCHI PLASTIC PRIVATE LIMITED",
"MADURAI TRANS CARRIER LIMITED",
"MADURAI-KANYAKUMARI TOLLWAY PRIVATE LIMITED",
"MADURAI-TUTICORIN EXPRESSWAYS LIMITED",
"MADYAMIC VA UCHHA MADYAMIC VIDHYA CHACHADGAON",
"MADYAMIK KANYA VIDYALAYA NANDGAON PETH",
"MADYAMIK VIDYALAYA SHINDE MALA SANGLI",
"MADYOASIS MEDICAL SERVICES PRIVATE LIMITED",
"MAECENAS WELLNESS PRIVATE LIMITED",
"MAEDA CORPORATION INDIA PRIVATE LIMITED",
"MAEER MIT S VISHWASHANTI GURUKUL",
"MAEERS MIMER MEDICAL COLLEGE & BHAUSAHEB SARDESAI TALEGAON RURAL HOSPITAL",
"MAEERS MIT ARTS COMMERCE & SCIENCE COLLEGE ALANDI",
"MAEERS MIT GROUP OF INSTITUTIONS PUNE INDIA",
"MAEER'S VISHWASHANTI GURUKUL SCHOOL",
"MAERSK FLEET MANAGEMENT AND TECHNOLOGY INDIA PRIVATE LIMITED",
"MAERSK GLOBAL SERVICE CENTRES INDIA PRIVATE LIMITED",
"MAERSK GSC",
"MAERSK LINE INDIA PRIVATE LIMITED",
"MAERSK TRAINING INDIA PRIVATE LIMITED",
"MAERSK TRAINING SERVICES INDIA PRIVATE LIMITED",
"MAESTRO BUILDWELL PRIVATE LIMITED",
"MAESTRO CATERING SERVICES PRIVATE LIMITED",
"MAESTRO ENGINEERING PRIVATE LIMITED",
"MAESTRO HEALTHCARE LIMITED",
"MAESTRO INTERIOR SOLUTION (I) PVT. LTD.",
"MAESTRO LOGISTICS PRIVATE LIMITED",
"MAESTRO STEEL DETAILING PRIVATE LIMITED",
"MAESTRO TECHNOLOGY SERVICES PRIVATE LIMITED",
"MAESTRO TOUR AND TRAVELS INDIA PRIVATE LIMITED",
"MAESTRO TRADEX PRIVATE LIMITED",
"MAESTROAK CHEM INDIA PRIVATE LIMITED",
"MAESTROBL INFRASTRUCTURE PRIVATE LIMITED",
"MAESTROD TECHNOLOGIES PVT LTD",
"MAESTROFITS ENGINEERING PRIVATE LIMITED",
"MAESTROS ELECTRONICS & TELECOMMUNICATIONS SYSTEMS LIMITED",
"MAESTROTECH SYSTEMS PRIVATE LIMITED",
"MAESTROTEK INNOVATIONS PRIVATE LIMITED",
"MAEZ ONE RETAIL AND FOOD PRIVATE LIMITED",
"MAF CLOTHING PRIVATE LIMITED",
"MAFATLAL FOOD PRODUCTS LIMITED",
"MAFATLAL IMPEX PRIVATE LIMITED",
"MAFFICK INSTRUMENTS PRIVATE LIMITED",
"MAFIA TRENDS LIMITED",
"MAFLOW INDIA PRIVATE LIMITED",
"MAFTECK ENGINEERING SOLUTIONS PRIVATE LIMITED",
"MAG FINSERV COMPANY LIMITED",
"MAG HARD INSULATIONS AND ENGINEERS PRIVATE LIMITED",
"MAG IMPEX PVT. LTD.",
"MAG INDIA INDUSTRIAL AUTOMATION SYSTEMS PRIVATE LIMITED",
"MAG INFRASOLUTIONS PRIVATE LIMITED",
"MAG PHARMA PRIVATE LIMITED",
"MAG PRODUCTS (INDIA) PRIVATE LIMITED",
"MAG REALBUILD PRIVATE LIMITED",
"MAG SOLVICS PRIVATE LIMITED",
"MAG STEEL INDUSTRIES PRIVATE LIMITED",
"MAG STUNNING LOGISTICS (OPC) PRIVATE LIMITED",
"MAG TECH PROCESS EQUIPMENTS PRIVATE LIMITED",
"MAG TEE PVT LTD",
"MAG5 INNOVATIONS PRIVATE LIMITED",
"MAGADH CANCER INSTITUTE AND RESEARCH CENTRE PRIVATE LIMITED",
"MAGADH INDUSTRIES PRIVATE LIMITED",
"MAGADH INFRA VENTURES PRIVATE LIMITED",
"MAGADH IRON PRIVATE LIMITED",
"MAGADH LOGISTICS PRIVATE LIMITED",
"MAGADH POWER INFRA PRIVATE LIMITED",
"MAGADH PRECISION EQUIPMENT LIMITED",
"MAGADH SUGAR & ENERGY LIMITED",
"MAGADH UTILITY SERVICES PRIVATE LIMITED",
"MAGAL ENGG TECH PRIVATE LIMITED",
"MAGAL ENGINEERING CO INDIA PRIVATE LIMITED",
"MAGAL SECURITY SYSTEMS (INDIA) LIMITED",
"MAGALIR MICRO CAPITAL PRIVATE LIMITED",
"MAGAM EXPORTS PRIVATE LIMITED",
"MAGANI JETHAJI TEXOFINE PRIVATE LIMITED",
"MAGANJI TRADING CO",
"MAGANLAL CHIKKI PRODUCTS PRIVATE LIMITED",
"MAGANLAL MEHTA & CO DIAMOND AND GOLD JEWELLERY PRIVATE LIMITED",
"MAGANTI ELECTRO-MECHANICAL PROJECTS PRIVATE LIMITED",
"MAGANTI IT SOLUTIONS PRIVATE LIMITED",
"MAGARASA PHARMACY COLLEGE",
"MAGARHAT ANGLO ORIENTAL INSTITUTION",
"MAGARPATTA CITY DEVELOPMENT COMPANY PRIVATE LIMITED",
"MAGARPATTA CLUBS AND RESORTS PRIVATE LIMITED",
"MAGARPATTA COLLEGE OF HOSPITALITY",
"MAGARPATTA RETAIL PRIVATE LIMITED",
"MAGARPATTA TOWNSHIP DEVELOPMENT AND CONSTRUCTION COMPANY LIMITED",
"MAGASIN DISTRIBUTORS PRIVATE LIMITED",
"MAGASSIANS VOIP PRIVATE LIMITED",
"MAGBRO HEALTH CARE PRIVATE LIMITED",
"MAGCON INFRATECH PRIVATE LIMITED",
"MAGCONS CONSULTING ENGINEERS PRIVATE LIMITED",
"MAGCORE LAMINATION (INDIA) PRIVATE LIMITED",
"MAGDALE PHARMA PRIVATE LIMITED",
"MAGDIEL ENGINEERING PRIVATE LIMITED",
"MAGDU ECOMMERCE PRIVATE LIMITED",
"MAGE INFOTECH PRIVATE LIMITED",
"MAGEBA BRIDGE PRODUCTS PRIVATE LIMITED",
"MAGEDELIGHT SOLUTIONS PRIVATE LIMITED",
"MAGELLAN AEROSPACE TUMKUR PRIVATE LIMITED",
"MAGELLAN EXPRESS LOGISTICS PRIVATE LIMITED",
"MAGELLAN TRAVEL SERVICES LIMITED",
"MAGELLANIC CLOUD LIMITED",
"MAGENATON ELECTRONICS PRIVATE LIMITED",
"MAGENTA DISTRIBUTORS PRIVATE LIMITED.",
"MAGENTA LIFECARE LIMITED",
"MAGENTO TILES PRIVATE LIMITED",
"MAGESPIDER INFOWEB",
"MAGESWARI ENTERPRISES PRIVATE LIMITED",
"MAGGENOME TECHNOLOGIES PRIVATE LIMITED",
"MAGGI COLD STORAGE PRIVATE LIMITED",
"MAGGU MULTIVENTURES PRIVATE LIMITED",
"MAGHAN PACKERS PVT LTD",
"MAGHAN PAPER MILLS PVT LTD",
"MAGIC AUTO PRIVATE LIMITED",
"MAGIC BEANSTALK INSTITUTIONS PRIVATE LIMITED",
"MAGIC BLADES PRIVATE LIMITED",
"MAGIC BRICKS REALTY SERVICES LIMITED",
"MAGIC BUS INDIA FOUNDATION",
"MAGIC CLOTHING PRIVATE LIMITED",
"MAGIC CONSULTANTS PRIVATE LIMITED",
"MAGIC DIL HEALTH FOR ALL PRIVATE LIMITED",
"MAGIC ECO PRIVATE LIMITED",
"MAGIC ECOMMERCE PRIVATE LIMITED",
"MAGIC EYE DEVELOPERS PRIVATE LIMITED",
"MAGIC FASTENERS PRIVATE LIMITED",
"MAGIC FOODS INDIA PRIVATE LIMITED",
"MAGIC FOREX PRIVATE LIMITED",
"MAGIC GENIE SMARTECH SOLUTIONS LIMITED",
"MAGIC GOLD JEWELLERY PRIVATE LIMITED",
"MAGIC HOME APPLIANCES PRIVATE LIMITED",
"MAGIC I.T. SOLUTION PRIVATE LIMITED",
"MAGIC INDIA HITECH PROJECTS PRIVATE LIMITED",
"MAGIC INOX PRIVATE LIMITED",
"MAGIC INTERNATIONAL PRIVATE LIMITED",
"MAGIC KONNECTIONS SOLUTION PRIVATE LIMITED",
"MAGIC KRAFT PRIVATE LIMITED",
"MAGIC MELTS (OPC) PRIVATE LIMITED",
"MAGIC MIKE ENTERPRISES PRIVATE LIMITED",
"MAGIC MOMENTS MOTION PICTURES PRIVATE LIMITED",
"MAGIC MOTORS",
"MAGIC MOVEMENTS PRIVATE LIMITED",
"MAGIC PE SERVICES PRIVATE LIMITED",
"MAGIC PICTURES AND ENTERTAINMENTS PRIVATE LIMITED",
"MAGIC RETAIL VENTURES PRIVATE LIMITED",
"MAGIC SOFTWARE ENTERPRISES INDIA PRIVATE LIMITED",
"MAGIC SOFTWARE PRIVATE LIMITED",
"MAGIC SPECIAL PURPOSE MACHINERIES PRIVATE LIMITED",
"MAGIC TOURS & HOLIDAYS PRIVATE LIMITED",
"MAGIC WIRES PRIVATE LIMITED",
"MAGIC9 MEDIA & ANALYTICS PRIVATE LIMITED",
"MAGICA FACILITY MANAGEMENT SERVICES (I) PRIVATE LIMITED",
"MAGICA SPORTS VENTURES PRIVATE LIMITED",
"MAGICAL FEED SOLUTIONS PRIVATE LIMITED",
"MAGICAL JOURNEYS PRIVATE LIMITED",
"MAGICBALL HOSPITALITY PRIVATE LIMITED",
"MAGICBOX RETAIL PRIVATE LIMITED",
"MAGICBRICKS REALTY SERVICES LIMITED",
"MAGICCIRCLE COMMUNICATIONS PRIVATE LIMITED",
"MAGICFORCE STAFFING SOLUTIONS PRIVATE LIMITED",
"MAGICGOLD DIAMONDS PRIVATE LIMITED",
"MAGICK WOODS EXPORTS PRIVATE LIMITED",
"MAGICLOGISYS GLOBAL PRIVATE LIMITED",
"MAGICON INPEX PRIVATE LIMITED",
"MAGICPILLS HEALTHCARE PRIVATE LIMITED",
"MAGICRETE BUILDING SOLUTIONS PRIVATE LIMITED",
"MAGICROT INDUSTRIAL SERVICES PRIVATE LIMITED",
"MAGICVILLA BUILDWELL PRIVATE LIMITED",
"MAGICWEB RETAIL PRIVATE LIMITED",
"MAGIHZHCHI ENTERPRISES PRIVATE LIMITED",
"MAGIK EYE TECH PRIVATE LIMITED",
"MAGIKLE PHARMA PRIVATE LIMITED",
"MAGINE PHARMACEUTICALS PRIVATE LIMITED",
"MAGIQUE HOSPITALITY PRIVATE LIMITED",
"MAGIRSHA INDUSTRIES PRIVATE LIMITED",
"MAGIVA TECHNOLOGIES PRIVATE LIMITED",
"MAGIXENGAGE PRIVATE LIMITED",
"MAGKA IMAGING AND TECHNOLOGY COMPANY PRIVATE LIMITED",
"MAGLARE TECHNOLOGIES PRIVATE LIMITED",
"MAGLEC HANDLING EQUIPMENTS PRIVATE LIMITED",
"MAGMA ALLIANZ LABORATORIES LIMITED",
"MAGMA CARE PRIVATE LIMITED",
"MAGMA ENGINEERING ASIA-PACIFIC PTE LIMITED",
"MAGMA ENGINEERING INDIA PRIVATE LIMITED",
"MAGMA FOODS PRIVATE LIMITED",
"MAGMA HDI GENERAL INSURANCE COMPANY LIMITED",
"MAGMA HOUSING FINANCE A PUBLIC COMPANY WITH UNLIMITED LIABILITY",
"MAGMA INDUSTRIES LIMITED",
"MAGMA ITL FINANCE LIMITED",
"MAGMA LIFESCIENCES PRIVATE LIMITED",
"MAGMA MACHINING PRIVATE LIMITED",
"MAGMA VENTURES PRIVATE LIMITED",
"MAGMAR LOGISTICS PRIVATE LIMITED",
"MAGNA AUTOMATIONS LIMITED",
"MAGNA AUTOMOTIVE INDIA PRIVATE LIMITED",
"MAGNA CABLE MANUFACTURING PRIVATE LIMITED",
"MAGNA CHEMICALS MANUFACTURERS PRIVATE LIMITED",
"MAGNA COLOURS INDIA PRIVATE LIMITED",
"MAGNA ELECTRO CASTINGS LIMITED",
"MAGNA ENGINEERING PRODUCTS PVT LTD",
"MAGNA FERROCHEM PRIVATE LIMITED",
"MAGNA INFOTECH A DIVISION OF QUESS CORP LIMITED",
"MAGNA PROJECTS PRIVATE LIMITED",
"MAGNA RICO POWERTRAIN PRIVATE LIMITED",
"MAGNA SERVICES INDIA PRIVATE. LIMITED",
"MAGNA TECHNOLOGIES",
"MAGNA WAREHOUSING & DISTRIBUTION PRIVATE LIMITED",
"MAGNA WAVES PRIVATE LIMITED",
"MAGNA WIRES PVT LTD",
"MAGNAA MODULES & SYSTEMS PRIVATE LIMITED",
"MAGNACODE HEALTHCARE AND RESEARCH PRIVATE LIMITED",
"MAGNACON ELECTRICALS INDIA LTD",
"MAGNACORE CLUTCHES AND BRAKES PRIVATE LIMITED",
"MAGNAM NETLINK PRIVATE LIMITED",
"MAGNAMIOUS SYSTEMS PRIVATE LIMITED",
"MAGNANIMOUS VENTURES PRIVATE LIMITED",
"MAGNAQUEST TECHNOLOGIES LIMITED",
"MAGNARC ELECTRODES & WIRES PRIVATE LIMITED",
"MAGNARC ELECTRODES PVT LTD",
"MAGNAS TECHNOLOGIES INDIA PRIVATE LIMITED",
"MAGNASIA AGRO INDUSTRIES PRIVATE LIMITED",
"MAGNASOFT CONSULTING INDIA PRIVATE LIMITED",
"MAGNASYS MATERIAL HANDLING AND STORAGE SYSTEMS PRIVATE LIMITED",
"MAGNATECH SMARTGRID SOLUTIONS PRIVATE LIMITED",
"MAGNATEK CARDS AND GIFTS PRIVATE LIMITED",
"MAGNATESAGE TECHNOLOGIES PRIVATE LIMITED",
"MAGNATHERM ALLOYS PRIVATE LIMITED",
"MAGNEQ INFRA PRIVATE LIMITED",
"MAGNEQ SYSTEMS PRIVATE LIMITED",
"MAGNEQ TRANSMISSION PRIVATE LIMITED",
"MAGNESSA ENTERPRISES PRIVATE LIMITED",
"MAGNET ALLOYS PRIVATE LIMITED",
"MAGNET BRAINS LEARNING FOUNDATION",
"MAGNET BRAINS SOFTWARE TECHNOLOGY PRIVATE LIMITED",
"MAGNET BUILDTECH PRIVATE LIMITED",
"MAGNET FACTORING SERVICES PRIVATE LIMITED",
"MAGNET HEALTHCARE AND DIAGNOSTICS PRIVATE LIMITED",
"MAGNET LABS PRIVATE LIMITED",
"MAGNET LOGISTIC PARK PRIVATE LIMITED",
"MAGNET TECHNOLOGIES PRIVATE LIMITED",
"MAGNET TELELINKS PRIVATE LIMITED",
"MARELLI POWERTRAIN INDIA PRIVATE LIMITED",
"MAGNETI MARELLI TALBROS CHASSIS SYSTEMS PRIVATE LIMITED",
"MAGNETIC FAAC INDIA PRIVATE LIMITED",
"MAGNETIC INFOTECH PRIVATE LIMITED",
"MAGNETIC LOGISTICS PRIVATE LIMITED",
"MAGNETIC MARKETING PRIVATE LIMITED",
"MAGNETIC SOLUTIONS PRIVATE LIMITED",
"MAGNETICCAP INDIA PRIVATE LIMITED",
"MAGNETO (INDIA) PRIVATE LIMITED",
"MAGNETO CLEANTECH PRIVATE LIMITED",
"MAGNETO DYNAMICS PRIVATE LIMITED",
"MAGNETO IT SOLUTIONS PRIVATE LIMITED",
"MAGNEWIN ENERGY PRIVATE LIMITED",
"MAGNI TECH SPECIALITY CABLES PRIVATE LIMITED",
"MAGNIC TECHNOLOGIES PRIVATE LIMITED",
"MAGNIFICENT FOODPARK PROJECTS LIMITED",
"MAGNIFICENT HOMES PRIVATE LIMITED",
"MAGNIFICENT MEDIA VISION PRIVATE. LIMITED.",
"MAGNIFICENT MERCANTILE PRIVATE LIMITED",
"MAGNIFICENT POWER PRIVATE LIMITED",
"MAGNIFICENT TLC SOLUTIONS PRIVATE LIMITED",
"MAGNIFICIENT MERCHANDISE AND ADVISORY SERVICES PRIVATE LIMITED",
"MAGNIFIQUE DECOR PRIVATE LIMITED",
"MAGNIFIQUE INFRASOLUTIONS PRIVATE LIMITED",
"MAGNIFIQUE LUXE LLP",
"MAGNIFY INDUSTRIES PRIVATE LIMITED",
"MAGNIFYING SOLUTIONS PRIVATE LIMITED",
"MAGNIGEEKS TECHNOLOGIES PRIVATE LIMITED",
"MAGNIT GLOBAL INDIA PRIVATE LIMITED",
"MAGNITUDE SHIPPING & LOGISTICS PRIVATE LIMITED",
"MAGNO INFRA PRIVATE LIMITED",
"MAGNOLIA ADVISORS PRIVATE LIMITED",
"MAGNOLIA HOSPITALITY PRIVATE LIMITED",
"MAGNOLIA HOTELS AND RESORTS PRIVATE LIMITED",
"MAGNOLIA INFRASTRUCTURE DEVELOPMENT LIMITED",
"MAGNOLIA LIMITED",
"MAGNOLIA MARTINIQUE CLOTHING PRIVATE LIMITED",
"MAGNOLID TECH PRIVATE LIMITED",
"MAGNON INTERACTIVE PRIVATE LIMITED",
"MAGNON SOLUTIONS PRIVATE LIMITED",
"MAGNOT CONSULTANCY SERVICES PRIVATE LIMITED",
"MAGNUM AVIATION PRIVATE LIMITED",
"MAGNUM BUILDWELL PRIVATE LIMITED",
"MAGNUM CARGO PRIVATE LIMITED",
"MAGNUM CASUALS INTERNATIONAL PRIVATE LIMITED",
"MAGNUM CERAMICS PRIVATE LIMITED",
"MAGNUM CHEMI-GRAN PRIVATE LIMITED",
"MAGNUM CLOTHING PRIVATE LIMITED",
"MAGNUM COMPUTERS",
"MAGNUM CONCRETES PRIVATE LIMITED",
"MAGNUM CYLINDERS PRIVATE LIMITED",
"MAGNUM DESTINATION MANAGEMENT PRIVATE LIMITED",
"MAGNUM DISTRIBUTORS PRIVATE LIMITED",
"MAGNUM ENGINEERS INDIA PRIVATE LIMITED",
"MAGNUM ENTERPRISES PVT LTD",
"MAGNUM ENVIRONMENT MANAGEMENT PRIVATE LIMITED",
"MAGNUM EQUITY BROKING LIMITED",
"MAGNUM EQUITY SERVICES LIMITED",
"MAGNUM ESTATES LIMITED",
"MAGNUM FIBRES PRIVATE LIMITED",
"MAGNUM FOOTWEAR PRIVATE LIMITED",
"MAGNUM FORGE AND MACHINE WORKS PVT LTD",
"MAGNUM GLASS CONCEPTS",
"MAGNUM HEALTH AND SAFETY PRIVATE LIMITED",
"MAGNUM HEIGHTS PRIVATE LIMITED",
"MAGNUM HOME MAKERS PRIVATE LIMITED",
"MAGNUM HOUSEKEEPING SERVICES PRIVATE LIMITED",
"MAGNUM IMAGING & DIAGNOSTICS PRIVATE LIMITED",
"MAGNUM INDUSTRIES",
"MAGNUM INTEGRATED SERVICES PRIVATE LIMITED",
"MAGNUM INTERNATIONAL TRADING COMPANY PRIVATE LIMITED",
"MAGNUM LOGISTICS PRIVATE LIMITED",
"MAGNUM LUBRICANTS INDIA PRIVATE LIMITED",
"MAGNUM MACHINE & TOOLS PRIVATE LIMITED",
"MAGNUM MACHINE TECHNOLOGIES LIMITED",
"MAGNUM MAINTENANCE SERVICES PRIVATE LIMITED",
"MAGNUM MANAGEMENT AND SERVICES PRIVATE LIMITED",
"MAGNUM MARBLE LIMITED",
"MAGNUM MI STEEL PRIVATE LIMITED",
"MAGNUM NETWORKS SUPPORT PRIVATE LIMITED",
"MAGNUM OPUS IT CONSULTING PRIVATE LIMITED",
"MAGNUM PETROCHEM PRIVATE LIMITED",
"MAGNUM PHARMA AND DIAGNOSTIC SERVICES PRIVATE LIMITED",
"MAGNUM PIGMENTS & POLYMERS PRIVATE LIMITED",
"MAGNUM POLYMERS PRIVATE LIMITED",
"MAGNUM POLYSURE PRIVATE LIMITED",
"MAGNUM POWER GENERATION LIMITED",
"MAGNUM PROMOTERS PRIVATE LIMITED",
"MAGNUM RESOURCES PRIVATE LIMITED",
"MAGNUM SADOSHIMA ISPAT PRIVATE LIMITED",
"MAGNUM SEA FOODS LIMITED",
"MAGNUM SEMICONDUCTORS LLP",
"MAGNUM SILK MILLS PRIVATE LIMITED",
"MAGNUM SPINNING MILLSS INDIA PRIVATE LIMITED",
"MAGNUM SPORTS PRIVATE LIMITED",
"MAGNUM STRIPS & TUBES PRIVATE LIMITED",
"MAGNUM SUGARS AND ALLIED PRODUCTS PRIVATE LIMITED",
"MAGNUM SUPER DISTRIBUTORS INDIA PRIVATE LIMITED",
"MAGNUM TELESYSTEM PRIVATE LIMITED",
"MAGNUM TEXFABB PRIVATE LIMITED",
"MAGNUM TOURS AND TRAVELS PRIVATE LIMITED",
"MAGNUM TRADECOM PRIVATE LIMITED",
"MAGNUM TRADERS",
"MAGNUM VENTURES LIMITED",
"MAGNUM VINIMAY PVT LTD",
"MAGNUM WINDOW STYLES PRIVATE LIMITED",
"MAGNUMTUFF INDIA PRIVATE LIMITED",
"MAGNUS BIOTECH PRIVATE LIMITED",
"MAGNUS BUILDCON PROJECTS PRIVATE LIMITED",
"MAGNUS CADEAUX INDIA PRIVATE LIMITED",
"MAGNUS COMPOSITES SYNERGIES PRIVATE LIMITED",
"MAGNUS ECO CONCEPTS PRIVATE LIMITED",
"MAGNUS EDESIGN SYSTEMS PRIVATE LIMITED",
"MAGNUS FACILITIES AND MAINTENANCE PRIVATE LIMITED",
"MAGNUS HEALTH CARE & RESEARCH CENTRE PRIVATE LIMITED",
"MAGNUS IMPEX PRIVATE LIMITED",
"MAGNUS INDIA CONSULTING SERVICES PRIVATE LIMITED",
"MAGNUS INFRATECH PRIVATE LIMITED",
"MAGNUS IT SOLUTIONS PRIVATE LIMITED",
"MAGNUS LUBRICANTS PRIVATE LIMITED",
"MAGNUS MEDICARE PRIVATE LIMITED",
"MAGNUS OPTO SYSTEMS INDIA PRIVATE LIMITED",
"MAGNUS PLAST",
"MAGNUS PLYWOOD PRIVATE LIMITED",
"MAGNUS POWER PRIVATE LIMITED",
"MAGNUS PROPERTIES PRIVATE LIMITED",
"MAGNUS STEELS PRIVATE LIMITED",
"MAGNUS WELLNESS PRIVATE LIMITED",
"MAGNUSTEK INFO SOLUTIONS PRIVATE LIMITED",
"MAGO PRINPRO PRIVATE LIMITED",
"MAGO THERMAL LIMITED",
"MAGO THERMAL PRIVATE LIMITED",
"MAGOD FUSION TECHNOLOGIES PRIVATE LIMITED",
"MAGOD LASER MACHINING PRIVATE LIMITED",
"MAGOT ENGINEERING CONSULTANTS PRIVATE LIMITED",
"MAGOTRA SUPER MARKET PRIVATE LIMITED",
"MAGOTTEAUX INDUSTRIES PRIVATE LIMITED",
"MAGPET POLYMERS PRIVATE LIMITED",
"MAGPIE GLOBAL LIMITED",
"MAGPIE HYDEL CONSTRUCTION OPERATION INDUSTRIES PRIVATE LIMITED",
"MAGPIE IMPEX PRIVATE LIMITED",
"MAGPPIE LIVING PRIVATE LIMITED",
"MAGPRO SECURITIES PRIVATE LIMITED",
"MAGRAA FASHIONS PRIVATE LIMITED",
"MAGRAJ KANTILAL FAB PRIVATE LIMITED",
"MAGRAM CHEMICALS PRIVATE LIMITED",
"MAGRATH PROPERTIES PRIVATE LIMITED",
"MAGRAY ASSOCIATES PRIVATE LIMITED",
"MAGS ANTICORROSIVE COATINGS PRIVATE LIMITED",
"MAGS FINVEST PRIVATE LIMITED",
"MAGSOL TECHNOLOGIES PRIVATE LIMITED",
"MAGSON RETAIL AND DISTRIBUTION LIMITED",
"MAGSONS EXPORT",
"MAGTECH INFRASTRUCTURE PRIVATE LIMITED",
"MAGTECH MOBILE SPARES PRIVATE LIMITED",
"MAGTECH SECURITY SYSTEMS PRIVATE LIMITED",
"MAGTEL POWER SYSTEMS PRIVATE LIMITED",
"MAGTORQ ENGINEERING SOLUTIONS PRIVATE LIMITED",
"MAGTORQ PRIVATE LIMITED",
"MAGTRONIC DEVICES PVT LTD",
"MAGUS CONSORTIUM ORCHID AVENUE PRIVATE LIMITED",
"MAGUS CREATIONS PRIVATE LIMITED",
"MAGUS DESIGNS LLP",
"MAGUS INFRA TECH PRIVATE LIMITED",
"MAGUS SALES AND SERVICES PRIVATE LIMITED",
"MAGUS TRAVEL SOLUTIONS PRIVATE LIMITED",
"MAGWEN VALVES PRIVATE LIMITED",
"MAGZTER DIGITAL PRIVATE LIMITED",
"MAH IMPORTS PRIVATE LIMITED",
"MAH JEEVAN PRADHIKARA WATER MANEGMENT",
"MAHA ACTIVE ENGINEERS INDIA PRIVATE LIMITED",
"MAHA AGRICULTURAL PRODUCTS PRIVATE LIMITED",
"MAHA AGRO INDUSTRIES PRIVATE LIMITED",
"MAHA BAZAR INDIA PRIVATE LIMITED",
"MAHA BODHI VIDYALAYA VENKATAPURAM",
"MAHA DURGA CHARITABLE TRUST",
"MAHA ELECTRONICS PRIVATE LIMITED",
"MAHA FARMERS PRODUCER COMPANY LIMITED",
"MAHA GANESH FASHIONS PRIVATE LIMITED",
"MAHA GAURI STRIPS PRIVATE LIMITED",
"MAHA GUJARAT SEEDS PRIVATE LIMITED",
"MAHA HYDRAULICS PRIVATE LIMITED",
"MAHA INDIA AUTOMOTIVE TESTING EQUIPMENT PRIVATE LIMITED",
"MAHA KAALI YARNS PRIVATE LIMITED",
"MAHA KALI DISTRIBUTORS PRIVATE LIMITED",
"MAHA LAKSHMI PAR BOILED INDUSTRIES POCHARAM PRIVATE LIMITED",
"MAHA LAKSHMI YARNS PRIVATE LIMITED",
"MAHA LAXMI BRIGHT BARS PRIVATE LIMITED",
"MAHA LAXMI SAWS PRIVATE LIMITED",
"MAHA MAYA GENERAL FINANCE COMPANY LTD",
"MAHA METFIELD PRIVATE LIMITED",
"MAHA MINERAL MINING & BENEFICIATION PRIVATE LIMITED",
"MAHA MUMBAI METRO M3 OPERATION CORPORATION LIMITED",
"MAHA PADMAVATI TEXTILE SERVICES PRIVATE LIMITED",
"MAHA RASHTRA APEX CORPORATION LIMITED",
"MAHA SEER HOTELS AND RESORTS PRIVATE LIMITED",
"MAHA SHIV SHAKTI STEEL ROLLING MILLS PRIVATE LIMITED",
"MAHA SHIVAN TEX",
"MAHA SPINCOT PRIVATE LIMITED",
"MAHA SPORTS DESIGN APPARELS PRIVATE LIMITED",
"MAHA TECHNOPLAST PRIVATE LIMITED",
"MAHA TRIPURASUNDARI INDUSTRIES PRIVATE LIMITED",
"MAHA VIDYA VIHAR PRIVATE LIMITED",
"MAHA X-RAY EQUIPMENTS PRIVATE LIMITED",
"MAHAA CAUVERY EXPORT",
"MAHAA INDUSTRIES PRIVATE LIMITED",
"MAHAAJAY SPINNERS INDIA PRIVATE LIMITED",
"MAHAAMERU SPINNING MILLS PRIVATE LIMITED",
"MAHAAN FOODS LIMITED",
"MAHAAN MILK FOODS LIMITED",
"MAHAARANA INDUSTRIES PRIVATE LIMITED",
"MAHABAHU BUILD INDIA PRIVATE LIMITED",
"MAHABAL APPARELS PRIVATE LIMITED",
"MAHABAL AUTO ANCILLARIES PRIVATE LIMITED",
"MAHABAL ENVIRO ENGINEERS PRIVATE LIMITED",
"MAHABAL MALL PRIVATE LIMITED",
"MAHABAL METALS PRIVATE LIMITED",
"MAHABALA MERCHANTS PRIVATE LIMITED",
"MAHABALA TECHNOLOGIES PRIVATE LIMITED",
"MAHABALESHWARA PROMOTERS AND BUILDERS PRIVATE LIMITED",
"MAHABALI BUILDCON PRIVATE LIMITED",
"MAHABALI MODERN RICE MILL PRIVATE LIMITED",
"MAHABALI STONES PRIVATE LIMITED",
"MAHABELL INDUSTRIES INDIA PRIVATE LIMITED",
"MAHABHADRA CONSTRUCTIONS LIMITED",
"MAHABHAGWANI DEVI ENTERPRISES PRIVATE LIMITED",
"MAHABHUJA ESTATES PRIVATE LIMITED",
"MAHABIR ABHUSHAN BHANDAR PRIVATE LIMITED",
"MAHABIR BAJRANG AGRO CHEMICAL PRIVATE LIMITED",
"MAHABIR BOREWELL & EQUIPMENTS",
"MAHABIR COLD STORAGE PRIVATE LIMITED",
"MAHABIR DANWAR JEWELLERS PRIVATE LIMITED",
"MAHABIR DESIGN AND CONSTRUCTION PRIVATE LIMITED",
"MAHABIR EDIBLE PRODUCTS PRIVATE LIMITED",
"MAHABIR EXPORT AND IMPORT COMPANY LIMITED",
"MAHABIR FINE ARTS PRIVATE LIMITED",
"MAHABIR HIRISE PRIVATE LIMITED",
"MAHABIR INDUSTRIES & ALLIED WORKS PRIVATE LIMITED",
"MAHABIR JUTE INDUSTRIES PRIVATE LIMITED",
"MAHABIR MULTI TECH PRIVATE LIMITED",
"MAHABIR NIRMAN PRIVATE LIMITED",
"MAHABIR PETRO PRODUCTS PVT.LTD.",
"MAHABIR POLYFABS PRIVATE LIMITED",
"MAHABIR PROTEINEX LIMITED",
"MAHABIR SEQUINS PRIVATE LIMITED",
"MAHABIR STEEL ENTERPRISE PRIVATE LIMITED",
"MAHABIR TRADE-COM PRIVATE LIMITED",
"MAHABIR VANIJYA PVT LTD",
"MAHABIR VENNTURES PRIVATE LIMITED",
"MAHABLESHWAR ENG WORKS",
"MAHABUBNAGAR ENERGY PROJECTS PRIVATE LIMITED",
"MAHABUBNAGAR SOLAR PARKS PRIVATE LIMITED",
"MAHABULL INFRA ENGINEERS PRIVATE LIMITED",
"MAHACHAKRA INDUSTRIES PRIVATE LIMITED",
"MAHACOL TREXIM PVT LTD",
"MAHACOT TEXTILES PRIVATE LIMITED",
"MAHADEO JUTE & INDUSTRIES LIMITED",
"MAHADEO NIRMAN PVT LTD",
"MAHADEOBARI TEA CO PVT LTD",
"MAHADEOLAL HARIRAM PVT LTD",
"MAHADEV BUILDING SYSTEMS PRIVATE LIMITED",
"MAHADEV COLD CHAIN PRIVATE LIMITED",
"MAHADEV CONSTRUCTION PVT LTD",
"MAHADEV COTSYN PRIVATE LIMITED",
"MAHADEV CRAFT PAPERS PRIVATE LIMITED",
"MAHADEV DAL MILLS PVT.LTD",
"MAHADEV ENCLAVE PRIVATE LIMITED",
"MAHADEV ENTERPRISE",
"MAHADEV ENTERPRISES PRIVATE LIMITED",
"MAHADEV FERRO CAST PRIVATE LIMITED",
"MAHADEV FIBRES PRIVATE LIMITED",
"MAHADEV FOREX PRIVATE LIMITED",
"MAHADEV FORGE PRIVATE LIMITED",
"MAHADEV GARMENTS PRIVATE LIMITED",
"MAHADEV GINNING PRESSING CO.",
"MAHADEV GRIHA NIRMAN PRIVATE LIMITED",
"MAHADEV GROCERY TRADE PRIVATE LIMITED",
"MAHADEV HERITAGE HOTELS PRIVATE LIMITED",
"MAHADEV HOLIDAY INN PRIVATE LIMITED",
"MAHADEV HOSPITALITY PRIVATE LIMITED",
"MAHADEV INDUSTRIES",
"MAHADEV IRON & STEEL PRIVATE LIMITED",
"MAHADEV KANCHAN COLLEGE OF PHARMACEUTICAL EDUCATION AND RESEARCH",
"MAHADEV KRISHAN AGRO PRIVATE LIMITED",
"MAHADEV MANTRA PRIVATE LIMITED",
"MAHADEV MARMO PRIVATE LIMITED",
"MAHADEV MELTING PRIVATE LIMITED",
"MAHADEV METALIKS PRIVATE LIMITED",
"MAHADEV MOTORS PRIVATE LIMITED",
"MAHADEV PACKAGINGS PRIVATE LIMITED",
"MAHADEV PETROCHEM PRIVATE LIMITED",
"MAHADEV PRE UNIVERSITY COLLEGE",
"MAHADEV PRESTRESSED PRODUCTS PRIVATE LIMITED",
"MAHADEV PRINT & PACKAGING",
"MAHADEV PROFILES PRIVATE LIMITED",
"MAHADEV PULSES PRIVATE LIMITED",
"MAHADEV RETAIL PRIVATE LIMITED",
"MAHADEV SALES CORPORATION",
"MAHADEV SAUR URJA PROJECTS PRIVATE LIMITED",
"MAHADEV SHASTRI VIDHYALAYA OLPAD",
"MAHADEV SHIP BREAKERS PRIVATE LIMITED",
"MAHADEV SITHARAM COTTON MILLS INDIA PRIVATE LIMITED",
"MAHADEV SOLVENT PRIVATE LIMITED",
"MAHADEV SUPER SPECIALITY HOSPITAL",
"MAHADEV TEXTILES PRIVATE LIMITED",
"MAHADEVA CARS PRIVATE LIMITED",
"MAHADEVA DALL INDUSTRIES PRIVATE LIMITED",
"MAHADEVA STEEL MILLS PRIVATE LIMITED",
"MAHADEVAN LOGISTICS PRIVATE LIMITED",
"MAHADEVI BIRLA WORLD ACADEMY",
"MAHADEVI INDUSTRIES PRIVATE LIMITED",
"MAHADEVI METALS PRIVATE LIMITED",
"MAHADEVRAO WANDRE INSTITUTE OF TECHNOLOGY",
"MAHADHAN AGRITECH LIMITED",
"MAHADHAN FARM TECHNOLOGIES PRIVATE LIMITED",
"MAHADHAN PHOSPHATE PRIVATE LIMITED",
"MAHADHAN SEEDS PRIVATE LIMITED",
"MAHADHYUTA AUTOMOTIVE PRIVATE LIMITED",
"MAHADYUTA LOGISTICS PRIVATE LIMITED",
"MAHAFEED SPECIALITY FERTILIZERS (INDIA) PRIVATE LIMITED",
"MAHAFPO FEDERATION",
"MAHAGANAPATI FINCORP PRIVATE LIMITED",
"MAHAGANAPATI FOOD AND AGRO PRODUCTS PRIVATE LIMITED",
"MAHAGANAPATI TRADERS PVT LTD",
"MAHAGANPATI COTTON AND OIL MILL PRIVATE LIMITED",
"MAHAGAURI HOUSING PROJECTS PRIVATE LIMITED",
"MAHAGAURI STEEL PRIVATE LIMITED",
"MAHAGENCO RENEWABLE ENERGY LIMITED",
"MAHAGOURI ALUMINIUM PRIVATE LIMITED",
"MAHAGOURI ELECTRICAL PRIVATE LIMITED",
"MAHAGRAM PAYMENTS PRIVATE LIMITED",
"MAHAGUJ COLLIERIES LIMITED",
"MAHAGUN HOTELS PRIVATE LIMITED",
"MAHAGUN INDIA PRIVATE LIMITED",
"MAHAGUN PROPERTY MANAGEMENT PRIVATE LIMITED",
"MAHAGUN REAL ESTATE PRIVATE LIMITED",
"MAHAGURU BOOKS PRIVATE LIMITED",
"MAHAHVEER ENGLISH MEDIUM SCHOOL",
"MAHAJAN & AIBARA CHARTERED ACCOUNTANTS LLP",
"MAHAJAN AMRIT PRIVATE LIMITED",
"MAHAJAN FABRICS PRIVATE LIMITED",
"MAHAJAN FOODS PRIVATE LIMITED",
"MAHAJAN HOSPITAL",
"MAHAJAN IMAGING PRIVATE LIMITED",
"MAHAJAN INDUSTRIES PRIVATE LIMITED",
"MAHAJAN INTERNATIONAL PRIVATE LIMITED",
"MAHAJAN IRON WORKS PRIVATE LIMITED",
"MAHAJAN MALLEABLES PRIVATE LIMITED",
"MAHAJAN MULTINATIONAL PRIVATE LIMITED",
"MAHAJAN NUTRI FOODS PRIVATE LIMITED",
"MAHAJAN OVERSEAS PRIVATE LIMITED",
"MAHAJAN PRODUCTS PRIVATE LIMITED",
"MAHAJAN REALTECH PRIVATE LIMITED",
"MAHAJAN STEELS AND WIRES PRIVATE LIMITED",
"MAHAJAN TEXTILES FINISHERS PRIVATE LIMITED",
"MAHAJAN WIRES PVT LTD",
"MAHAJANCONVEYOR PRIVATE LIMITED",
"MAHAJEET BENTOSIL PRIVATE LIMITED",
"MAHAK BUILDHOME PRIVATE LIMITED",
"MAHAK COMMERCIAL PVT.LTD.",
"MAHAK CREATEX PRIVATE LIMITED",
"MAHAK DIAM PRIVATE LIMITED",
"MAHAK INDUSTRIES PRIVATE LIMITED",
"MAHAK JEWELS PRIVATE LIMITED",
"MAHAK PHARMA PRIVATE LIMITED",
"MAHAK PLASTIC INDUSTRIES",
"MAHAK SYNTHETICS MILLS PRIVATE LIMITED",
"MAHAKAAL JEWELS PRIVATE LIMITED",
"MAHAKAL AGRO FOODS PRIVATE LIMITED",
"MAHAKAL COAL TRANSPORT PRIVATE LIMITED",
"MAHAKAL DEVCON PRIVATE LIMITED",
"MAHAKAL INSTITUTE OF TECHNOLOGY",
"MAHAKAL ISPAT PRIVATE LIMITED",
"MAHAKAL REAL ESTATE DEVELOPERS PRIVATE LIMITED",
"MAHAKAL ROLLER FLOUR MILLS PRIVATE LIMITED",
"MAHAKAL STEEL AND POWER PRIVATE LIMITED",
"MAHAKALESHWAR CONSTRUCTION",
"MAHAKALESHWAR INFRATECH PRIVATE LIMITED",
"MAHAKALESHWAR MINES & METALS PRIVATE LIMITED",
"MAHAKALESHWAR MINES AND MINERALS PRIVATE LIMITED",
"MAHAKALESHWAR OILS PRIVATE LIMITED",
"MAHAKALI AGRO INDUSTRIES PRIVATE LIMITED",
"MAHAKALI CAPITAL INVESTMENTS SERVICES PRIVATE LIMITED",
"MAHAKALI CEMENT WORKES PVT LTD",
"MAHAKALI CHANDRAPUR POLYTEX PRIVATE LIMITED",
"MAHAKALI COLD STORAGE PVT LTD",
"MAHAKALI DEVELOPERS AND RESORTS PRIVATE LIMITED",
"MAHAKALI ENTERPRISES",
"MAHAKALI FOODS PRIVATE LIMITED",
"MAHAKALI FUEL PRIVATE LIMITED",
"MAHAKALI INFRASTRUCTURE AND PROPERTIES PRIVATE LIMITED",
"MAHAKALI ISPAT PRIVATE LIMITED",
"MAHAKALI MARKETING PRIVATE LIMITED",
"MAHAKALI METAL AND ALLOYS PRIVATE LIMITED",
"MAHAKALI MILK PROCESSORS PRIVATE LIMITED",
"MAHAKALI MOTORS PRIVATE LIMITED",
"MAHAKALI PLASTI-WEAVE PRIVATE LIMITED",
"MAHAKALI RICE MILLS PRIVATE LIMITED",
"MAHAKALI UDYOG PRIVATE LIMITED",
"MAHAKALI VINYL FILM PRIVATE LIMITED",
"MAHAKASH TREXIM PRIVATE LIMITED",
"MAHAKASHA INDIA PROTIEN PROVIDERS PRIVATE LIMITED",
"MAHAKAUSHAL AGRICROP INDIA PRIVATE LIMITED",
"MAHAKAUSHAL SUGAR AND POWER INDUSTRIES LIMITED",
"MAHAKAVI SOOR SMARAK INTER COLLEGE",
"MAHAKAYA SPACEBUILD PRIVATE LIMITED",
"MAHAKAYAYA NAMAH JEWELLERS PRIVATE LIMITED",
"MAHAKETU PROMOTERS AND DEVELOPERS PRIVATE LIMITED",
"MAHAKOSHAL HOSPITAL PRIVATE LIMITED",
"MAHAKOSHAL REFRACTORIES PRIVATE LIMITED",
"MAHAKRUSHI FARMERS PRODUCER COMPANY LIMITED",
"MAHALAKHMI YARNS PRIVATE LIMITED",
"MAHALAKSHMI ALLOYS AND METALS PRIVATE LIMITED",
"MAHALAKSHMI BRIGHT STEEL INDUSTRIES PRIVATE LIMITED",
"MAHALAKSHMI CO - OPERATIVE BANK LTD",
"MAHALAKSHMI COLD STORAGE PVT. LTD",
"MAHALAKSHMI COLLEGE OF ARTS SCIENCE",
"MAHALAKSHMI ENERGY PRIVATE LIMITED",
"MAHALAKSHMI GLASS WORKS PRIVATE LIMITED",
"MAHALAKSHMI INFRAPROJECTS LIMITED",
"MAHALAKSHMI INFRAPROJECTS PRIVATE LIMITED",
"MAHALAKSHMI IRON & STEELS PRIVATE LIMITED",
"MAHALAKSHMI LABORATORIES PRIVATE LIMITED",
"MAHALAKSHMI LOGISTICS PRIVATE LIMITED",
"MAHALAKSHMI MEDICAL SCIENCES AND HEALTH CARE PRIVATE LIMITED",
"MAHALAKSHMI MOTORCYCLES (INDIA) PRIVATE LIMITED",
"MAHALAKSHMI OILS PVT. LTD.",
"MAHALAKSHMI PLASTICS ENGINEERING PRIVATE LIMITED",
"MAHALAKSHMI RICE MILLS PVT. LTD.",
"MAHALAKSHMI ROLLER FLOUR MILLS PVT LTD",
"MAHALAKSHMI SPINTEX PRIVATE LIMITED",
"MAHALAKSHMI TEXTILES TRADERS PRIVATE LIMITED",
"MAHALAKSHMI TOOLS AND MACHINERY PRIVATE LIMITED",
"MAHALAKSHMIDEVI FLAVOURS PRIVATE LIMITED",
"MAHALASA ACOUSTIC PRIVATE LIMITED",
"MAHALASA CONSTRUCTIONS PRIVATE LIMITED",
"MAHALASA SILVER SHOPPY PRIVATE LIMITED",
"MAHALAXMI AGRO INDUSTRIES",
"MAHALAXMI AGRO OIL MILLS PRIVATE LIMITED",
"MAHALAXMI AND COMPANY",
"MAHALAXMI AUTO CARE PRIVATE LIMITED",
"MAHALAXMI AUTOFIN PRIVATE LIMITED",
"MAHALAXMI AUTOMOTIVES PRIVATE LIMITED",
"MAHALAXMI AUTOMOTIVES VEHICLES PRIVATE LIMITED",
"MAHALAXMI AUTOMOTIVES WHEELS PRIVATE LIMITED",
"MAHALAXMI BROKERAGE (INDIA) PRIVATE LIMITED",
"MAHALAXMI BUILDHOME LIMITED",
"MAHALAXMI BUILDWELL (INDIA) PRIVATE LIMITED",
"MAHALAXMI BUILDWELL ENTERPRISES PRIVATE LIMITED",
"MAHALAXMI BUS TRANSPORT PRIVATE LIMITED",
"MAHALAXMI CALCHEM PRIVATE LIMITED",
"MAHALAXMI CASTLES AND VILLAS PRIVATE LIMITED",
"MAHALAXMI CHEM CARBONATE PRIVATE LIMITED",
"MAHALAXMI CHEMICAL AGENCIES PRIVATE LIMITED",
"MAHALAXMI COAL PRIVATE LIMITED",
"MAHALAXMI COLD STORAGE & WAREHOUSING PRIVATE LIMITED",
"MAHALAXMI COMMERCIAL SERVICES PRIVATE LIMITED",
"MAHALAXMI CONCAST PRIVATE LIMITED",
"MAHALAXMI CONTINENTAL LIMITED",
"MAHALAXMI COPPER PRODUCTS LIMITED",
"MAHALAXMI CRAFTS AND TISSUES PRIVATE LIMITED",
"MAHALAXMI DHATU UDHYOG PRIVATE LIMITED",
"MAHALAXMI DRAPE PRIVATE LIMITED",
"MAHALAXMI ELECTRODES PRIVATE LIMITED",
"MAHALAXMI ELECTROMECH PRIVATE LIMITED",
"MAHALAXMI ENGINEERING COMPANY PRIVATE LIMITED",
"MAHALAXMI ENGITECH PRIVATE LIMITED",
"MAHALAXMI EXPORTS PRIVATE LIMITED",
"MAHALAXMI FERRO CAST PRIVATE LIMITED",
"MAHALAXMI FIBERS PRIVATE LIMITED",
"MAHALAXMI FILLING STATION PRIVATE LIMITED",
"MAHALAXMI FOREX PRIVATE LIMITED",
"MAHALAXMI FURNISHING PRIVATE LIMITED",
"MAHALAXMI GAJAK BHANDAR PRIVATE LIMITED",
"MAHALAXMI GOLD AND DIAMOND MERCHANTS",
"MAHALAXMI GOLD PRIVATE LIMITED",
"MAHALAXMI HEALTH CARE PRIVATE LIMITED",
"MAHALAXMI HIGH TENSION INSULATORS PRIVATE LIMITED",
"MAHALAXMI HRUDAYALAY PRIVATE LIMITED",
"MAHALAXMI INDIA PRIVATE LIMITED",
"MAHALAXMI INFRACON",
"MAHALAXMI INFRA-CON PRIVATE LIMITED",
"MAHALAXMI INFRACONTRACT LIMITED",
"MAHALAXMI INFRACONTRACT PRIVATE LIMITED",
"MAHALAXMI INVESTMENT AND TRADING PRIVATE LIMITED",
"MAHALAXMI JEWELLERS (INDIA) PRIVATE LIMITED",
"MAHALAXMI JEWELWORLD PRIVATE LIMITED",
"MAHALAXMI JWELLERS PRIVATE LIMITED",
"MAHALAXMI LABELS PRIVATE LIMITED",
"MAHALAXMI LUMBERS PRIVATE LIMITED",
"MAHALAXMI MALT PRODUCTS PRIVATE LIMITED",
"MAHALAXMI MERCHANDISERS PRIVATE LIMITED",
"MAHALAXMI METAL WORKS AND ALLOYS PRIVATE LIMITED",
"MAHALAXMI METALLOYS (INDIA) PRIVATE LIMITED",
"MAHALAXMI MILLENNIUM AGENCIES PRIVATE LIMITED",
"MAHALAXMI MINCHEM PRIVATE LIMITED",
"MAHALAXMI MOULDS PRIVATE LIMITED",
"MAHALAXMI P C PATEL CONSORTIUM PRIVATE LIMITED",
"MAHALAXMI PIPES PRIVATE LIMITED",
"MAHALAXMI PLYWOOD P.LTD.",
"MAHALAXMI POLYCARE PRIVATE LIMITED",
"MAHALAXMI POLYMERS",
"MAHALAXMI POLYPACK PRIVATE LIMITED",
"MAHALAXMI POPLINE MILLS PRIVATE LIMITED",
"MAHALAXMI RUBTECH LTD",
"MAHALAXMI SANITARY EMPORIUM PRIVATE LIMITED",
"MAHALAXMI SANSTHAN AYURVEDA PRIVATE LIMITED",
"MAHALAXMI SEAMLESS LIMITED",
"MAHALAXMI SHIPPING PRIVATE LIMITED",
"MAHALAXMI SILICATES PRIVATE LIMITED",
"MAHALAXMI SPINNING & WEAVING MILLS PRIVATE LIMITED",
"MAHALAXMI STEEL AND POWER LIMITED",
"MAHALAXMI STOREHOUSES PRIVATE LIMITED",
"MAHALAXMI TECHNOCAST PRIVATE LIMITED",
"MAHALAXMI TEXCHEM PRIVATE LIMITED",
"MAHALAXMI TEX-CLOTHING PRIVATE LIMITED",
"MAHALAXMI UNIEXIM PRIVATE LIMITED",
"MAHALAXMI UTENSIL PRIVATE LIMITED",
"MAHALAXMI VALVES PRIVATE LIMITED",
"MAHALAXMI VIDYUT PRIVATE LIMITED",
"MAHALAXMI WIRES PRIVATE LIMITED",
"MAHALAXMI WORLDWIDE LOGISTICS PRIVATE LIMITED",
"MAHALAXMIASPHALT PRIVATE LIMITED",
"MAHALAYA TEXTILE PRIVATE LIMITED",
"MAHALE SUVARN NIDHI LIMITED",
"MAHALINGA SHETTY AND CO LIMITED",
"MAHALINGAM INFRASTRUCTURE PRIVATE LIMITED",
"MAHALINGAM POLYPACKS PRIVATE LIMITED",
"MAHALSA COMPUTERS PRIVATE LIMITED",
"MAHALUNGE LAND DEVELOPERS PRIVATE LIMITED",
"MAHALUNGE TOWNSHIP DEVELOPERS LLP",
"MAHALUXMI BRICK MOULDING AND FABRICATING INDUSTRIES PRIVATE LIMITED",
"MAHALUXMI BUILDTECH CONSORTIUM PRIVATE LIMITED",
"MAHALUXMI BUILDTECH LIMITED",
"MAHALUXMI INFRAHOME PRIVATE LIMITED",
"MAHALUXMI IRON TRADING COMPANY PRIVATE LIMITED",
"MAHALUXMI PAPER INDUSTRIES PVT LTD",
"MAHALUXMI PROCESSING HOUSE PRIVATE LIMITED",
"MAHALUXMI TRADING HOUSE PRIVATE LIMITED",
"MAHALWALA INTERNATIONAL GROUP OF COMPNIES",
"MAHAMANAV ISPAT PRIVATE LIMITED",
"MAHAMANI PROPERTIES PRIVATE LIMITED",
"MAHAMANTRA FABRICS PRIVATE LIMITED",
"MAHAMARG INFRA CONSULTANTS PRIVATE LIMITED",
"MAHAMARUTI LOGISTICS PRIVATE LIMITED",
"MAHAMAYA AGRO-INDUSTRIES PVT.LTD.",
"MAHAMAYA AUTOCARS PRIVATE LIMITED",
"MAHAMAYA CASTING PRIVATE LIMITED",
"MAHAMAYA CONSTRUCTIONS PRIVATE LIMITED",
"MAHAMAYA FABRIC TREND PRIVATE LIMITED",
"MAHAMAYA FINANCE PRIVATE LIMITED",
"MAHAMAYA FOODS & GRAINS PRIVATE LIMITED",
"MAHAMAYA FOREX PRIVATE LIMITED",
"MAHAMAYA HOMELINKERS PRIVATE LIMITED",
"MAHAMAYA HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED",
"MAHAMAYA INDUSTRIES",
"MAHAMAYA INFRASTRUCTURE PRIVATE LIMITED",
"MAHAMAYA LIFESCIENCES PRIVATE LIMITED",
"MAHAMAYA POLYMERS PRIVATE LIMITED",
"MAHAMAYA RENTALS PRIVATE LIMITED",
"MAHAMAYA SPACES PRIVATE LIMITED",
"MAHAMAYA SPONGE IRON PRIVATE LIMITED",
"MAHAMAYA STEEL INDUSTRIES LIMITED",
"MAHAMAYA STONES PRIVATE LIMITED",
"MAHAMAYA TIE-UP PRIVATE LIMITED",
"MAHAMAYA TOURS AND TRAVELS PRIVATE LIMITED",
"MAHAMEGA GOAT FARMING(OPC) PRIVATE LIMITED",
"MAHAMIA TRADERS",
"MAHAMUDRA AGRO TRADERS PRIVATE LIMITED",
"MAHAN ENERGEN LIMITED",
"MAHAN INDUSTRIES LIMITED",
"MAHAN PLASTICS PRIVATE LIMITED",
"MAHAN ROLLER FLOUR MILLS PRIVATE LIMITED",
"MAHANADI BASIN POWER LIMITED",
"MAHANADI COAL RAILWAY LIMITED",
"MAHANADI COALFIELDS LIMITED",
"MAHANADI INVESTMENTS AND PROPERTIES PRIVATE LIMITED",
"MAHANADI METALS AND CHEMICALS PRIVATE LIMITED",
"MAHANADI STEEL AND IRON PRIVATE LIMITED",
"MAHANAGAR CONSTRUCTIONS PRIVATE LIMITED",
"MAHANAGAR GAS LIMITED",
"MAHANAGAR MEDIA NETWORK PRIVATE LIMITED",
"MAHANAGAR MULTI MEDIA PRIVATE LIMITED",
"MAHANAJ INTERNATIONAL PRIVATE LIMITED",
"MAHANAM IMPEX PVT LTD",
"MAHANANDA INDUSTRIES PVT LTD",
"MAHANANDA SECURITIES LTD",
"MAHANANDA SPA AND RESORTS PRIVATE LIMITED",
"MAHANKALESWARA AGRI TECH PRIVATE LIMITED",
"MAHANSARIA & SONS PVT. LTD.",
"MAHANSARIA FEEDS PRIVATE LIMITED",
"MAHANSARIA TYRES PRIVATE LIMITED",
"MAHANT OVERSEAS",
"MAHANT RAMESHWAR DAS INTER COLLEGE JHANSI",
"MAHANT VANIJYA PVT. LTD.",
"MAHANTI TRADERS PRIVATE LIMITED",
"MAHAONLINE LIMITED",
"MAHAPACK INDUSTRIES PRIVATE LIMITED",
"MAHAPEEK FERTILIZERS INDIA PRIVATE LIMITED",
"MAHAPHANT FIBRE CEMENT SOUTH ASIA P LIMITED",
"MAHAPRABANDHAK JILA UDHYOG KENDRA",
"MAHAPRABHU HIMGHAR PRIVATE LIMITED",
"MAHAPRABHU RESOURCES PRIVATE LIMITED",
"MAHAPRAGYA ENTERPRISES PRIVATE LIMITED",
"MAHAPUJA LIMITED",
"MAHAR WEDDING CENTRE",
"MAHARA PUSHYA AGRI PRODUCTS PRIVATE LIMITED",
"MAHARAI GIRLS COLLEGE",
"MAHARAJ AUDIO VISUAL SERVICE PRIVATE LIMITED",
"MAHARAJ BAG CLUB LIMITED",
"MAHARAJ JI AGRO PRODUCTS PRIVATE LIMITED",
"MAHARAJ PARADISE",
"MAHARAJ SOAPS INDUSTRY PRIVATE LIMITED",
"MAHARAJA",
"MAHARAJA & SPEEDEX INDIA PRIVATE LIMITED",
"MAHARAJA AGENCIES PRIVATE. LIMITED",
"MAHARAJA AGRASEN GIRLS INT COLL MATHURA",
"MAHARAJA AGRASEN HELATH CARE CENTER",
"MAHARAJA AGRASEN HIMALAYAN GARHWAL UNIVERSITY",
"MAHARAJA AGRASEN HOSPITAL",
"MAHARAJA AGRASEN INSTITUTE OF MANAGEMENT STUDIES",
"MAHARAJA AGRASEN INSTITUTE OF TECHNOLOGY",
"MAHARAJA AGRASEN MODEL SCHOOL",
"MAHARAJA AGRASEN TECHNICAL EDUCATION SOCIETY",
"MAHARAJA AGRASEN VIDYALAYA",
"MAHARAJA AGROFOODS PRIVATE LIMITED",
"MAHARAJA AUTOMOBILES INDIA PRIVATE LIMITED",
"MAHARAJA AVIATION PRIVATE LIMITED",
"MAHARAJA BAKERS PRIVATE LIMITED",
"MAHARAJA BIJLI PASI RAJKIYA MAHAVIDYALAYA LUCKNOW",
"MAHARAJA BUILDERS PVT LTD",
"MAHARAJA CARRIERS PRIVATE LIMITED",
"MAHARAJA CATERING SERVICE P LTD",
"MAHARAJA DEHYDRATION PRIVATE LIMITED",
"MAHARAJA D'SIGNERS & GARMENTS (INDIA) PRIVATE LIMITED",
"MAHARAJA DYEING PRIVATE LIMITED",
"MAHARAJA EDIFICE PRIVATE LIMITED",
"MAHARAJA EXHAUST PRODUCTS PRIVATE LIMITED",
"MAHARAJA EXIM TRADE PRIVATE LIMITED",
"MAHARAJA FABRICS PRIVATE LIMITED",
"MAHARAJA FERRO ALLOYS PRIVATE LIMITED",
"MAHARAJA GRAINS PRIVATE LIMITED",
"MAHARAJA GRANITO PRIVATE LIMITED",
"MAHARAJA HERITAGE RESORTS LIMITED",
"MAHARAJA INDIA VINTRADE PRIVATE LIMITED",
"MAHARAJA INSTRUMENTATION PRIVATE LIMITED",
"MAHARAJA ISPAT PVT LTD",
"MAHARAJA KRISHNAKUMARSINHJI BHAVNAGAR UNIVERSITY BHAVNAGAR",
"MAHARAJA MANINDRA CHANDRA COLLEGE",
"MAHARAJA MARBLES PRIVATE LIMITED",
"MAHARAJA MEDICAL CENTRE PVT LTD",
"MAHARAJA MINERALS PVT LTD",
"MAHARAJA OIL PRODUCTS PRIVATE LIMITED",
"MAHARAJA PALANISAMY GARMENTS",
"MAHARAJA PHARMACY COLLEGE",
"MAHARAJA RESOURCES PRIVATE LIMITED",
"MAHARAJA ROLLER FLOUR MILLS JALNA PRIVATE LIMITED",
"MAHARAJA SAWAI BHAWANI SINGH SCHOOL",
"MAHARAJA SAWAI MAN SINGH VIDYALAYA",
"MAHARAJA SHREE AGRASEN JEE AAPNO GHAR PRIVATE LIMITED",
"MAHARAJA SHREE UMAID MILLS LIMITED",
"MAHARAJA SIRISH CH COLLEGE",
"MAHARAJA SRISCHANDRA COLLEGE",
"MAHARAJA SURAJMAL INSTITUTE OF TECHNOLOGY",
"MAHARAJA TEXO FAB PRIVATE LIMITED",
"MAHARAJA TILES PRIVATE LIMITED",
"MAHARAJA ULTRABUILD PRIVATE LIMITED",
"MAHARAJA WHITELINE DEVELOPERS PRIVATE LIMITED",
"MAHARAJA YESHWANT RAO HOSPITAL",
"MAHARAJAH‚ÄôS INSTITUTE OF MEDICAL SCIENCES",
"MAHARAJAS COLLEGE",
"MAHARAJAS INSTITUTE OF MEDICAL SCIENCE VIZIANAGARAM",
"MAHARAJAS TECHNICAL INSTITUTE",
"MAHARAJI COLLEGE OF PHYSIOTHERAPY",
"MAHARANA BHUPAL GOVT HOSPITAL UDAIPUR",
"MAHARANA JEWELLERS PRIVATE LIMITED",
"MAHARANA JIVAJIRAO SHINDE MAHAVIDYALAY SHRIGONDA",
"MAHARANA PRATAP DISTRICT HOSPITAL BAREILLY",
"MAHARANA PRATAP EDUCATION CENTRE",
"MAHARANA PRATAP ENGINEERING COLLEGE",
"MAHARANA PRATAP NATIONAL INSTITUTE OF NURSING EDUCATION AND RESEARCH",
"MAHARANA PRATAP POLYTECHNIC GORAKHPUR",
"MAHARANA PRATAP PRIMARY SCHOOL",
"MAHARANA PRATAP UNIVERCITY OF AGRICULTURE AND TECHNOLOGY UDAIPUR",
"MAHARANEE TEA COMPANY PRIVATE LIMITED",
"MAHARANI AUTOTECH PRIVATE LIMITED",
"MAHARANI COLLEGE OF COMMERCE",
"MAHARANI FOREX PRIVATE LIMITED",
"MAHARANI GAYATRI DEVI GIRLS SCHOOL",
"MAHARANI GEMS PRIVATE LIMITED",
"MAHARANI INDUSTRIAL EQUIPMENTS PRIVATE LIMITED",
"MAHARANI INNOVATIVE PAINTS PRIVATE LIMITED",
"MAHARANI JEWELS INTERNATIONAL PRIVATE LIMITED",
"MAHARANI KASHISARI COLLEGE",
"MAHARANI LAXMI AMMANNI WOMENS COLLEGE",
"MAHARANI LAXMIBAI MEDICAL COLLEGE JHANSI",
"MAHARANI MEDI-CARE PRIVATE LIMITED",
"MAHARANI PAINTS PRIVATE LIMITED",
"MAHARANI SHANTA DEVI HOSPITAL",
"MAHARANI SILK MILLS PRIVATE LIMITED",
"MAHARANI TARABAI MADHYAMIK VIDYALAYA WADWANI",
"MAHARANI ZAIKA FOODS PRIVATE LIMITED",
"MAHARASHTRA ADHAYAN MANDIR HIGH SCHOOL",
"MAHARASHTRA ADHYAYAN MANDIR HIGH SCHOOL NAGPUR",
"MAHARASHTRA ADMINISTRATIVE TRIBUNAL",
"MAHARASHTRA AIRPORT DEVELOPMENT COMPANY LIMITED",
"MAHARASHTRA ALDEHYDES AND CHEMICALS LIMITED",
"MAHARASHTRA ALUMINIUM AND ALLOYS PRIVATE LIMITED",
"MAHARASHTRA APEX ASSET MANAGEMENT COMPANY LIMITED",
"MAHARASHTRA BAMBOO DEVELOPMENT BOARD",
"MAHARASHTRA BORDER CHECK POST NETWORK LIMITED",
"MAHARASHTRA BUILDING MATERIALS AND AGRO PRODUCTS (PUNE) PRIVATE LIMITED",
"MAHARASHTRA CAPITAL SOLUTIONS PRIVATE LIMITED",
"MAHARASHTRA CARBON PVT LTD",
"MAHARASHTRA CENTRE FOR ENTREPRENEURSHIP",
"MAHARASHTRA COLLEGE OF ARTS SCIENCES AND COMMERCE",
"MAHARASHTRA COLLEGE OF NURSING",
"MAHARASHTRA COLLEGE OF PHARMACY",
"MAHARASHTRA CORPORATION LIMITED",
"MAHARASHTRA EARTH MOVING PRIVATE LIMITED",
"MAHARASHTRA EASTERN GRID POWER TRANSMISSION COMPANY LIMITED",
"MAHARASHTRA EDUCATION SOCIETY",
"MAHARASHTRA ELECTRO-MECHANICAL WORKS PRIVATE LIMITED",
"MAHARASHTRA ENVIRO POWER LIMITED",
"MAHARASHTRA ESTERS AND KETONES PRIVATE LIMITED",
"MAHARASHTRA EX SERVICEMEN CORPORATION LIMITED",
"MAHARASHTRA FASTNERS PRIVATE LIMITED",
"MAHARASHTRA FEEDS PRIVATE LIMITED",
"MAHARASHTRA FILM STAGE AND CULTURAL DEVELOPMENT CORPORATION LIMITED",
"MAHARASHTRA GEOSPATIC DATA CENTER",
"MAHARASHTRA GRAMIN BANK",
"MAHARASHTRA HOUSING AND AREA DEVELOPMENT AUTHORITY",
"MAHARASHTRA HOUSING DEVELOPMENT CORPORATION LIMITED",
"MAHARASHTRA HYBRID SEEDS COMPANY LIMITED",
"MAHARASHTRA IMPEX LIMITED",
"MAHARASHTRA INDUSTRIAL DEVELOPMENT CORPORATION",
"MAHARASHTRA INSTITUTE OF DENTAL SCIENCE AND RESEARCH LATUR INDIA",
"MAHARASHTRA INSTITUTE OF MENTAL HEALTH",
"MAHARASHTRA INSTITUTE OF TECHNOLOGY",
"MAHARASHTRA JEEVAN PRADHIKARAN CIRCLE,AMRAVATI",
"MAHARASHTRA KNOWLEDGE CORPORATION LIMITED",
"MAHARASHTRA LABOUR WELFARE BOARD",
"MAHARASHTRA MAHAVIDYALAYA NILANGA",
"MAHARASHTRA MARITIME BOARD",
"MAHARASHTRA MEDIA SERVICES AND PUBLIC RELATIONS PRIVATE LIMITED",
"MAHARASHTRA MEDICAL TOURISM SERVICES LIMITED",
"MAHARASHTRA METAL INDUSTRIES PRIVATE LIMITED",
"MAHARASHTRA METAL WORKS PRIVATE LIMITED",
"MAHARASHTRA METRO RAIL CORPORATION LIMITED",
"MAHARASHTRA MINERALS CORPORATION LIMITED",
"MAHARASHTRA MITRA MANDAL SECONDARY SCHOOL",
"MAHARASHTRA NAGARI SAHAKARI BANK LTD",
"MAHARASHTRA NATIONAL LAW UNIVERSITY MUMBAI",
"MAHARASHTRA NATURAL GAS LIMITED",
"MAHARASHTRA OIL EXTRACTIONS PRIVATE LIMITED",
"MAHARASHTRA PESTICIDE LIMITED",
"MAHARASHTRA PETRO CHEMICALS CORPORATION LIMITED",
"MAHARASHTRA POLLUTION CENTRAL BOARD",
"MAHARASHTRA POLLUTION CONTROL BOARD",
"MAHARASHTRA POULTRY PRIVATE LIMITED",
"MAHARASHTRA PROTECTION AND INVESTAGATION FORCE PRIVATE LIMITED",
"MAHARASHTRA PUBLIC SERVICE COMMISSION",
"MAHARASHTRA PUNJAB ROAD CARRIER PRIVATE LIMITED",
"MAHARASHTRA RAIL INFRASTRUCTURE DEVELOPMENT CORPORATION LIMITED",
"MAHARASHTRA RAJYA SAHAKARI DUDH MAHASANGH MARYADIT",
"MAHARASHTRA RAJYA VIDYUT MANDAL KARMACHARI SAHAKARI PAT SANSTHA MARYADIT",
"MAHARASHTRA REMOTE SENSING APPLICATION CENTRE",
"MAHARASHTRA RESINS PRIVATE LIMITED",
"MAHARASHTRA REVANGAON WINDFARM DEVELOPMENT PRIVATE. LIMITED.",
"MAHARASHTRA ROLLER FLOUR MILLS PRIVATE LIMITED",
"MAHARASHTRA SAFE CHEMISTS AND DISTRIBUTORS ALLIANCE LIMITED",
"MAHARASHTRA SCHOOL & COLLEGE OF NURSING MIDC LATUR",
"MAHARASHTRA SCOOTERS LIMITED",
"MAHARASHTRA SEAMLESS LIMITED",
"MAHARASHTRA SOAP WORKS P LTD",
"MAHARASHTRA SOLVENT EXTRACTION PRIVATE LIMITED",
"MAHARASHTRA STATE AIDS CONTROL SOCIETY",
"MAHARASHTRA STATE BOARD OF SECONDARY AND HIGHER SECONDARY EDUCATION",
"MAHARASHTRA STATE BUREAU TEXTBOOK PRODUCTION AND CURRICULUM RESEARCH",
"MAHARASHTRA STATE ELECTRICITY BOARD URBAN DIVISION-2 AURANGABAD",
"MAHARASHTRA STATE ELECTRICITY DISTRIBUTION COMPANY LIMITED",
"MAHARASHTRA STATE ELECTRICITY TRANSMISSION COMPANY LIMITED",
"MAHARASHTRA STATE ELECTRICTTY DISTRIBUTION COMPANY LTD",
"MAHARASHTRA STATE FACULTY DEVELOPMENT ACADEMY",
"MAHARASHTRA STATE HANDICAPED FINANCE & DEVELOPMENT CORP LIMITED",
"MAHARASHTRA STATE POLICE HOUSING & WELFARE COPORATION LIMITED",
"MAHARASHTRA STATE POWER GENERATION COMPANY LIMITED",
"MAHARASHTRA STATE POWERLOOMS CORPORATION LIMITED",
"MAHARASHTRA STATE ROAD DEVELOPMENT CORPORATION LIMITED",
"MAHARASHTRA STATE ROAD TRANSPORT CORPORATION",
"MAHARASHTRA STATE RURAL LIVELIHOOD MISSION",
"MAHARASHTRA STATE RURAL LIVELIHOODS MISSION",
"MAHARASHTRA STATE SECURITY CORPORATION",
"MAHARASHTRA STATE SEEDS CORPORATION LIMITED",
"MAHARASHTRA STATE WAREHOUSING CORPORATION",
"MAHARASHTRA TECHNICAL EDUCATION SOCIETY",
"MAHARASHTRA TOURISM DEVELOPMENT COR L",
"MAHARASHTRA TRANSMISSION COMMUNICATION INFRASTRUCTURE LIMITED",
"MAHARASHTRA UNIVERSITY OF HEALTH SCIENCES NASHIK",
"MAHARASHTRA URBAN INFRASTRUCTURE DEVELOPMENT COMPANY LIMITED",
"MAHARASHTRA VALLEY VIEW PRIVATE LIMITED",
"MAHARASHTRA VIDHYUT NIGAM PRIVATE LIMITED",
"MAHARASHTRA VIJ KAMGAR MAHASANGH SAHAKARI PATSANSTHA MARYADIT",
"MAHARASHTRA¬†LEGISLATURE SECRETARIAT",
"MAHARASHTRIAN HEALTHCARE PHENO PRIVATE LIMITED",
"MAHARASTRA FREIGHT CARRIERS PRIVATE LIMITED",
"MAHARASTRA MAGNET WIRES PRIVATE LIMITED",
"MAHARASTRA STATE BOARD OF SECONDARY AND HIGHER SECONDARY EDUCATION",
"MAHARATRIKA INFRA INDIA PRIVATE LIMITED",
"MAHARISHI DAYANAND ADARSH VIDYALAYA",
"MAHARISHI INFORMATION TECHNOLOGY PRIVATE LIMITED",
"MAHARISHI INTERNATIONAL RESIDENTIAL SCHOOL",
"MAHARISHI MARKANDESHWAR UNIVERSITY",
"MAHARISHI SANDIPANI RASHTRIYA VED VIDYA PRATISHTHAN",
"MAHARISHI TECHNOLOGY CORPORATION PRIVATE LIMITED",
"MAHARISHI VALMIKI HOSPITAL",
"MAHARISHI VIDYA MANDIR SENIOR SECONDARY SCHOOL",
"MAHARISHI WOMENS COLLEGE",
"MAHARSHEE GEOMEMBRANE (INDIA) PRIVATE LIMITED",
"MAHARSHI ALLOYS AND STEELS",
"MAHARSHI BADRI PHARMACEUTICALS PRIVATE LIMITED",
"MAHARSHI BALMIKI VIDYALAY HIGHER SECONDARY SCHOOL",
"MAHARSHI BARIUM SALTS PRIVATE LIMITED",
"MAHARSHI COMMERCE LIMITED",
"MAHARSHI ENTERPRISE",
"MAHARSHI G J CHITAMBAR VIDYA MANDIR AHMEDNAGAR",
"MAHARSHI HOSPITAL PRIVATE LIMITED",
"MAHARSHI INDUSTRIES PRIVATE LIMITED",
"MAHARSHI KARVE STREE SHIKSHAN SAMSTHA‚ÄôS",
"MAHARSHI LABELS PRIVATE LIMITED",
"MAHARSHI PANINI SANSKRIT AVAM VAIDIK VISHWAVIDYALAYA UJJAIN",
"MAHARSHI PATANJALI VIDYA MANDIR",
"MAHARSHI PHARMA CHEM PRIVATE LIMITED",
"MAHARSHI RICE MILLS PRIVATE LIMITED",
"MAHARSHI SANTSEVI MOTORS PRIVATE LIMITED",
"MAHARSHI WOMENS DEGREE COLLEGE",
"MAHARUDRA AGROCOM PRIVATE LIMITED",
"MAHARUDRA TRADERS & CONSTRUCTIONS PRIVATE LIMITED",
"MAHASACH INDIA PRIVATE LIMITED",
"MAHASAGAR TRAVELS LIMITED",
"MAHASAI ALUMINIUM PROFILES PRIVATE LIMITED",
"MAHASAKTHI BIO ENERCON PRIVATE LIMITED",
"MAHASAKTHI EDUCATIONAL TRUST",
"MAHASEMAM TRUST",
"MAHASETHU INFRA PROJECTS PRIVATE. LIMITED.",
"MAHASHAKTI COLD STORAGE PVT LTD",
"MAHASHAKTI ENERGY LIMITED.",
"MAHASHAKTI ENTERPRISES PRIVATE LIMITED",
"MAHASHAKTI FOODS PRIVATE LIMITED",
"MAHASHAKTI INFRAPROJECT PRIVATE LIMITED",
"MAHASHAKTI INFRASTRUCTURE PRIVATE LIMITED",
"MAHASHAKTI MACHINES PRIVATE LIMITED",
"MAHASHAKTI PLASTO PRIVATE LIMITED",
"MAHASHAKTI RASAYAN PVT LTD",
"MAHASHAKTI STEELS PRIVATE LIMITED",
"MAHASHE JEWELLERS PRIVATE LIMITED",
"MAHASHE RESORTS PRIVATE LIMITED",
"MAHASHIAN DI HATTI PRIVATE LIMITED",
"MAHASHIV PROMOTERS PRIVATE LIMITED",
"MAHASHIV TEXTILE ENGINEERING PRIVATE LIMITED",
"MAHASHWETA HOSPITAL PRIVATE LIMITED",
"MAHASWAAN PHARMA PRIVATE LIMITED",
"MAHASWAMI SOFTWARE PRIVATE LIMITED",
"MAHATAM PHULE HIGH SCHOOL",
"MAHATAMA GANDHI NATIONAL RURAL EMPLOYMENT MGNREGA",
"MAHATAMA GANDHI STATE INSTITUTE OF RURAL DEVELOPMENT JABALPUR",
"MAHATEJA RICE MILLS PRIVATE LIMITED",
"MAHATEJAS FINANCE PRIVATE LIMITED",
"MAHATEM EYE BANK",
"MAHATHA PETROLEUM PRIVATE LIMITED",
"MAHATHI INFOTECH PRIVATE LIMITED",
"MAHATHI INFRA DEVELOPERS INDIA PRIVATE LIMITED",
"MAHATHI INFRA SERVICES PRIVATE LIMITED",
"MAHATHI IT SOLUTIONS PRIVATE LIMITED",
"MAHATHI SOFTWARE PRIVATE LIMITED",
"MAHATHMA GANDHI DENT COLL PG INST",
"MAHATI HYDRO POWER PROJECTS PRIVATE LIMITED",
"MAHATI HYDRO POWER VIDHARBHA PRIVATE LIMITED",
"MAHATI INDUSTRIES PRIVATE LIMITED",
"MAHATI PACKWELL PRIVATE LIMITED",
"MAHATMA BASWESHWAR MADHYAMIK VIDYALAY RUI",
"MAHATMA DUDHADHARI I C NAGLA VISHNU",
"MAHATMA EDUCATION SOCIETY",
"MAHATMA FULE PRATHMIK SHALA GEORAI BEED",
"MAHATMA FULE VIDYALAYA BMAJALGAON BEED",
"MAHATMA GANDHI ADMIN TRAINING INSTITUTE",
"MAHATMA GANDHI ANTARRASHTRIYA HINDI VISHWAVIDYALAYA WARDHA",
"MAHATMA GANDHI C S H S NGP",
"MAHATMA GANDHI CANCER HOSPITAL II",
"MAHATMA GANDHI GOVERNMENT SCHOOL SIKANDARA",
"MAHATMA GANDHI HOSPITAL",
"MAHATMA GANDHI INSTITUTE",
"MAHATMA GANDHI INSTITUTE OF MEDICAL SCIENCES SEVAGRAM",
"MAHATMA GANDHI INTER COLLEGE GORAKHPUR",
"MAHATMA GANDHI KASHI VIDYAPITH",
"MAHATMA GANDHI MEDICAL COLLEGE & RESEARCH INSTITUTE",
"MAHATMA GANDHI MEMORIAL COLLEGE",
"MAHATMA GANDHI MEMORIAL MEDICAL COLLEGE",
"MAHATMA GANDHI MISSION KRISHI VIGYAN KENDRA",
"MAHATMA GANDHI MISSION'S COLLEGE OF ENGINEERING AND TECHNOLOGY",
"MAHATMA GANDHI POST GRADUATE COLLEGE GORAKHPUR",
"MAHATMA GANDHI PRATHAMIK VIDYAMANDIR LATUR",
"MAHATMA GANDHI STATE INSTITUTE OF RURAL DEVELOPMENT",
"MAHATMA GANDHI UNIVERSITY",
"MAHATMA GANDHI UNIVERSITY OF MEDICAL SCIENCES & TECHNOLOGY",
"MAHATMA GANDHI VIDYALAYA WA KANISHTA MAHAVIDYALAY AASHTE",
"MAHATMA JYOTIBA PHULE CANTOMENT BOARD SR SEC SCHOOL",
"MAHATMA JYOTIBA PHULE MADHYAMIK VIDYALAY MAJALGAON",
"MAHATMA JYOTIBA PHULE RESEARCH AND TRAINING INSTITUTE",
"MAHATMA JYOTIBA PHULE ROHILKHAND UNIVERSITY BAREILLY",
"MAHATMA JYOTIBA PHULE TELANGANA BACKWARD CLASSES WELFARE RESIDENTIAL EDUCATIONAL INSTITUTIONS SOCIETY",
"MAHATMA MONTESSORI MATRIC HIGHER SECONDARY SCHOOL",
"MAHATMA MONTESSORI SCHOOL",
"MAHATMA PHULE BACKWARD CLASS DEVELOPMENT CORPORATION LTD",
"MAHATMA PHULE EDUCATION SOCIETY",
"MAHATMA PHULE RENEWABLE ENERGY AND INFRASTRUCTURE TECHNOLOGY LIMITED",
"MAHATMA PHULE SECONDARY AND HIGHER SECONDARY HIGHSCHOOL BORRANJANI JALNA",
"MAHATMA PUBLIC SCHOOL",
"MAHATMAGANDHI MISSION INSTITUTE OF MAN",
"MAHATME DYE-CHEM PVT LTD",
"MAHATME HEALTH AND HAPPINESS HOSPITAL",
"MAHATO MULTICOMS CONSTRUCTION PRIVATE LIMITED",
"MAHATTA MULTIMEDIA PRIVATE LIMITED",
"MAHATTA TOWERS PRIVATE LIMITED",
"MAHATVA INFRACON PRIVATE LIMITED",
"MAHAVAS PRECISION CONTROLS PRIVATE LIMITED",
"MAHAVAT TRADERS PRIVATE LIMITED",
"MAHAVATAR BABAJI TADEKAM FOUNDATION",
"MAHAVEER AQUA PRIVATE LIMITED",
"MAHAVEER AUTODEAL PRIVATE LIMITED",
"MAHAVEER BULLION PRIVATE LIMITED",
"MAHAVEER COLLEGE OF PHARMACY",
"MAHAVEER COTTON PRIVATE LIMITED",
"MAHAVEER COTTS STRINGS LIMITED",
"MAHAVEER DISPOTECH PRIVATE LIMITED",
"MAHAVEER ELECTRO-MECH PRIVATE LIMITED",
"MAHAVEER ENGICONS PRIVATE LIMITED",
"MAHAVEER ENGLISH MEDIUM SCHOOL & JR COLLEGE",
"MAHAVEER FABROCAST PVT LTD",
"MAHAVEER FINANCE INDIA LIMITED",
"MAHAVEER INFOWAY LIMITED",
"MAHAVEER INFRAENGINEERING PRIVATE LIMITED",
"MAHAVEER INSTITUTE OF MEDICAL SCIENCES",
"MAHAVEER INSTITUTE OF SCIENCE&TECHNOLOGY",
"MAHAVEER JAIPURIA RAJASTHAN HOSPITAL",
"MAHAVEER MEDICARE",
"MAHAVEER MEDI-SALES PRIVATE LIMITED",
"MAHAVEER METAL COMPANY",
"MAHAVEER NURSING HOME AND RESERCH CENTER LIMITED",
"MAHAVEER NUTRIEX PRIVATE LIMITED",
"MAHAVEER PADDY PROCESSORS PRIVATE LIMITED",
"MAHAVEER PAPER MILL PRIVATE LIMITED",
"MAHAVEER PARBOILED RICE INDUSTRIES PRIVATE LIMITED",
"MAHAVEER PLASTOPET PRIVATE LIMITED",
"MAHAVEER POLYTEX PRIVATE LIMITED",
"MAHAVEER PUBLIC SCHOOL",
"MAHAVEER RAJASTHANI INTERNATIONAL SCHOOL",
"MAHAVEER SODIUMS PRIVATE LIMITED",
"MAHAVEER STAR TRADING PRIVATE LIMITED",
"MAHAVEER SURFACTANTS PRIVATE LIMITED",
"MAHAVEER TEXSPARES PRIVATE LIMITED",
"MAHAVEER TRANSCARRIERS PRIVATE LIMITED",
"MAHAVEER TRANSPORT COMPANY",
"MAHAVEERA BUILD-TECH PRIVATE LIMITED",
"MAHAVEERA CARRIERS PRIVATE LIMITED",
"MAHAVEERA COAL SALES PRIVATE LIMITED",
"MAHAVEERA CREDIT CO OPERATIVE SOCIETY LTD",
"MAHAVEERA TRANSPORT PRIVATE LIMITED",
"MAHAVEERAYA DEV-BUILD INDIA PRIVATE LIMITED",
"MAHAVEERS SAREE PRIVATE LIMITED",
"MAHAVIR (THALTEJ) COMPLEX PRIVATE LIMITED",
"MAHAVIR AGRO INDUSTRIES",
"MAHAVIR ALUMINIUM PRIVATE LIMITED",
"MAHAVIR ARYAN INDUSTRIES PRIVATE LIMITED",
"MAHAVIR ASHOK ENTERPRISES PRIVATE LIMITED",
"MAHAVIR AUTO DIAGNOSTICS PRIVATE LIMITED",
"MAHAVIR BEVERAGES PRIVATE LIMITED",
"MAHAVIR BUILDERS",
"MAHAVIR BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"MAHAVIR CANCER INSTITUTE & RESEARCH CENTRE",
"MAHAVIR CASHEW AND FOODS PRIVATE LIMITED",
"MAHAVIR CASTINGS PRIVATE LIMITED",
"MAHAVIR CERA IMPEX PRIVATE LIMITED",
"MAHAVIR CIVIL ENGINEERING AND SERVICES PRIVATE LIMITED",
"MAHAVIR COAL CORPORATION PRIVATE LIMITED",
"MAHAVIR COAL RESOURCES PRIVATE LIMITED",
"MAHAVIR COAL TRADERS PRIVATE LIMITED",
"MAHAVIR COAL WASHERIES PRIVATE LIMITED",
"MAHAVIR COCONUT AND AGRO PRODUCTS PRIVATE LIMITED",
"MAHAVIR COMMERCIAL AUTOINDIA PRIVATE LIMITED",
"MAHAVIR COMMERCIAL COMPANY PRIVATE LIMITED",
"MAHAVIR COMMERCIAL PRIVATE LIMITED",
"MAHAVIR COMPUTECH PRIVATE LIMITED",
"MAHAVIR CONCAST LIMITED",
"MAHAVIR CONSTRUCTION CO.",
"MAHAVIR COTTON PRIVATE LIMITED",
"MAHAVIR CREATIVE PRIVATE LIMITED",
"MAHAVIR DAL MILLS PRIVATE LIMITED",
"MAHAVIR DECCAN AUTO PRIVATE LIMITED",
"MAHAVIR DEN ENTERTAINMENT PRIVATE LIMITED",
"MAHAVIR DESIGN SYSTEM PRIVATE LIMITED",
"MAHAVIR DIE CASTER PRIVATE LIMITED",
"MAHAVIR DWELLERS PRIVATE LIMITED",
"MAHAVIR DYEING AND PRINTING MILLS PRIVATE LIMITED",
"MAHAVIR ECO PROJECTS PRIVATE LIMITED",
"MAHAVIR EDUCATIONAL SOCIETY",
"MAHAVIR ENERGY AND COAL BENEFICATION LIMITED",
"MAHAVIR ENGIMACH PRIVATE LIMITED",
"MAHAVIR ENTERPRISES PRIVATE LIMITED",
"MAHAVIR EXTRACTION PVT LTD",
"MAHAVIR FASHION PRIVATE LIMITED",
"MAHAVIR FASTNERS PRIVATE LIMITED",
"MAHAVIR FILAMENT PRIVATE LIMITED",
"MAHAVIR FINANCE PRIVATE LIMITED",
"MAHAVIR FINCON PVT.LTD",
"MAHAVIR GHAR SANSAR PRIVATE LIMITED",
"MAHAVIR GLOBAL COAL LIMITED",
"MAHAVIR GLOBAL VANTAGE PRIVATE LIMITED",
"MAHAVIR HALL MARKING CENTRE PRIVATE LIMITED",
"MAHAVIR HANUMAN DEVELOPERS PRIVATE LIMITED",
"MAHAVIR HEALTHCARE INSTITUTIONS DAHOD PRIVATE LIMITED",
"MAHAVIR HYDRAULICS PRIVATE LIMITED",
"MAHAVIR HYDRO PROJECTS PRIVATE LIMITED",
"MAHAVIR INDUCTO-MELT PRIVATE LIMITED",
"MAHAVIR INFRACON PRIVATE LIMITED",
"MAHAVIR INFRA-DEVELOPERS PRIVATE LIMITED",
"MAHAVIR INFRASPACE PRIVATE LIMITED",
"MAHAVIR INTERFACE PRIVATE LIMITED",
"MAHAVIR INTERNATIONAL PRIVATE LIMITED",
"MAHAVIR JAIPURIA RAJASTHAN HOSPITAL",
"MAHAVIR LABORATORIES PRIVATE LIMITED",
"MAHAVIR LOGISTICS PRIVATE LIMITED",
"MAHAVIR MAHAVIDYALAYA KOLHAPUR",
"MAHAVIR MANUFACTURING PRIVATE LIMITED",
"MAHAVIR MINERALS LIMITED",
"MAHAVIR MOTORCORP PRIVATE LIMITED",
"MAHAVIR MOULDS INDIA PRIVATE LIMITED",
"MAHAVIR MUKHWAS PRIVATE LIMITED",
"MAHAVIR MULTIPACK",
"MAHAVIR NAMKEENS PRIVATE LIMITED",
"MAHAVIR NETTING PRIVATE LIMITED",
"MAHAVIR PAINTS AND ADHESIVES PRIVATE LIMITED",
"MAHAVIR PLUS PRIVATE LIMITED",
"MAHAVIR POLYFILMS PRIVATE LIMITED",
"MAHAVIR POLYMERS PRIVATE LIMITED",
"MAHAVIR POLYPLAST PRIVATE LIMITED",
"MAHAVIR PUMPS MANUFACTURING PVT. LTD.",
"MAHAVIR RANG BHANDAR PRIVATE LIMITED",
"MAHAVIR REALSPACE PRIVATE LIMITED",
"MAHAVIR REFRATECH (GUJARAT) PRIVATE LIMITED",
"MAHAVIR RETAIL PRIVATE LIMITED",
"MAHAVIR RICE MILLS",
"MAHAVIR ROADWAYS PRIVATE LIMITED",
"MAHAVIR ROLLER FLOUR MILLS PRIVATE LIMITED",
"MAHAVIR SEAMLESS TUBE PRIVATE LIMITED",
"MAHAVIR SHEETGRAH PRIVATE LIMITED",
"MAHAVIR SILK MILLS PVT LTD",
"MAHAVIR SPINFAB PRIVATE LIMITED",
"MAHAVIR SPINNING MILLS LIMITED",
"MAHAVIR SUBMERSIBLES PRIVATE LIMITED",
"MAHAVIR SYNTHESIS PRIVATE LIMITED",
"MAHAVIR SYSPOWER PRIVATE LIMITED",
"MAHAVIR T & G PRIVATE LIMITED",
"MAHAVIR TEX PRINTS PRIVATE LIMITED",
"MAHAVIR TEX-SYN PRIVATE LIMITED",
"MAHAVIR THERMOEQUIP P LIMITED",
"MAHAVIR TRADERS",
"MAHAVIR TRANSMISSION LIMITED",
"MAHAVIR VINIYOG LTD",
"MAHAVIR XPERT TECHNOPLAST PRIVATE LIMITED",
"MAHAVIRA AGRICARE PRIVATE LIMITED",
"MAHAVIRA BUILDCON PRIVATE LIMITED",
"MAHAVIRA COLLECTIONS PRIVATE LIMITED",
"MAHAVIRA ELECTRICALS PVT. LTD.",
"MAHAVIRA OVERSEAS PRIVATE LIMITED",
"MAHAVIRA TENTS (INDIA) PRIVATE LIMITED",
"MAHAVIR'S OIL SEEDS & AGRI PRODUCTS PRIVATE LIMITED",
"MAHAVISHNU SPINNING MILLS PRIVATE LIMITED",
"MAHAWAR IRON STORES PVT LTD",
"MAHAWAR MARKETINGS PRIVATE LIMITED",
"MAHBROS INTERTRADE PRIVATE LIMITED",
"MAHDI BAGH COMPUTERS PRIVATE LIMITED",
"MAHDI SCHOOL",
"MAHEK AGRITECH (INDIA) PRIVATE LIMITED",
"MAHEK AGRO MINERAL PRIVATE LIMITED",
"MAHEK CARGO CARRIERS PRIVATE LIMITED",
"MAHEK ENTERPRISE",
"MAHEK HOUSEWARE PRIVATE LIMITED",
"MAHEK MARCHANDISE PRIVATE LIMITED",
"MAHELAV KANYA SHALA",
"MAHELKA MOTORS PRIVATE LIMITED",
"MAHELWALA FABRICS PRIVATE LIMITED",
"MAHEM IMPEX PRIVATE LIMITED",
"MAHEN DISTRIBUTION LIMITED",
"MAHENDRA AGRIGENETICS PRIVATE LIMITED",
"MAHENDRA ARTO LIMITED LIABILITY PARTNERS HIP",
"MAHENDRA BRIGHT STEEL PRIVATE LIMITED",
"MAHENDRA BROTHERS EXPORTS PRIVATE LIMITED",
"MAHENDRA COTTON MILLS PRIVATE LIMITED",
"MAHENDRA DISHED ENDS PRIVATE LIMITED",
"MAHENDRA EDUCATIONAL PRIVATE LIMITED",
"MAHENDRA ELECTRICALS PRIVATE LIMITED",
"MAHENDRA ENGINEERING COLLEGE",
"MAHENDRA ENGINEERING LIMITED",
"MAHENDRA GEMS AND JEWELLERS INDIA PRIVATE LIMITED",
"MAHENDRA GOLD PRIVATE LIMITED",
"MAHENDRA HOMES PRIVATE LIMITED",
"MAHENDRA INFRA HEIGHTS PRIVATE LIMITED",
"MAHENDRA INSTITUTE OF TECHNOLOGY",
"MAHENDRA INTERNATIONAL SCHOOL",
"MAHENDRA JEWELLERS PRIVATE LIMITED",
"MAHENDRA KRISHI FARMS PRIVATE LIMITED",
"MAHENDRA LABS PRIVATE LIMITED",
"MAHENDRA LOGISTICS INDIA PRIVATE LIMITED",
"MAHENDRA MANISH AUTOMOBILES PRIVATE LIMITED",
"MAHENDRA MITHAIWALA PRIVATE LIMITED",
"MAHENDRA NEXT WEALTH IT INDIA PRIVATE LIMITED",
"MAHENDRA PATEL BUILDERS PVT LTD",
"MAHENDRA POWER PRIVATE LIMITED",
"MAHENDRA PRESSING WORKS PRIVATE LIMITED",
"MAHENDRA PUBLICATION PRIVATE LIMITED",
"MAHENDRA PUMPS PRIVATE LIMITED",
"MAHENDRA REALTORS & INFRASTRUCTURE PRIVATE LIMITED",
"MAHENDRA RICE INDUSTRY",
"MAHENDRA ROADLINES PRIVATE LIMITED",
"MAHENDRA SKILLS TRAINING & DEVELOPMENT PRIVATE LIMITED",
"MAHENDRA SLIVERS AND LOOMS PRIVATE LIMITED",
"MAHENDRA SPONGE AND POWER LIMITED",
"MAHENDRA STEEL TRADERS PRIVATE LIMITED",
"MAHENDRA STRIPS PRIVATE LIMITED",
"MAHENDRA TOOLS AND MACHINES(INDIA)PRIVATE LIMITED",
"MAHENDRA TRANSFORMERS PRIVATE LIMITED",
"MAHENDRA TRANSPORT AGENCY PRIVATE LIMITED",
"MAHENDRARAJ CONSULTANTS PRIVATE LIMITED",
"MAHENJU TEXTILES PRIVATE LIMITED",
"MAHER SOFT TECHNOLOGIES PRIVATE LIMITED",
"MAHESANA DISTRICT EDUCATION COMMITTEE MANAGED PRIMARY SCHOOL",
"MAHESANA DISTRICT EDUCATION COMMITTEE MANAGED PRIMARY SCHOOL TEACHER",
"MAHESANA JILLA PANCHAYAT KARMCHARI",
"MAHESANA JILLA SHIKSHAN SAMITI SANCHALIT",
"MAHESH ASSOCIATES",
"MAHESH AUTOMOTIVE AGENCIES PVT LTD",
"MAHESH BARCODE SOLUTIONS PRIVATE LIMITED",
"MAHESH CHAND JAIN AND SONS SARRAF PRIVATE LIMITED",
"MAHESH COAL SALES PRIVATE LIMITED",
"MAHESH COTSPIN PRIVATE LIMITED",
"MAHESH DISTRIBUTORS PRIVATE LIMITED",
"MAHESH DYEING AND PRINTING MILLS PRIVATE LIMITED",
"MAHESH EDIBLE AGRO OIL INDUSTRIES PRIVATE LIMITED",
"MAHESH EDIBLE OIL CORPORATION PRIVATE LIMITED",
"MAHESH EDIBLE OIL INDUSTRIES LIMITED",
"MAHESH EDIBLE OIL MANUFACTURES PRIVATE LIMITED",
"MAHESH EDIBLE OIL MARKETING LIMITED",
"MAHESH EDIBLE OILS PRODUCTS PRIVATE LIMITED",
"MAHESH ELECTRO INDUSTRIES PRIVATE LIMITED",
"MAHESH ENTERPRISES AND INFRA INDIA PRIVATE LIMITED",
"MAHESH EXTRUSIONS PRIVATE LIMITED",
"MAHESH FABRINOX PRIVATE LIMITED",
"MAHESH FATS AND OILS PRIVATE LIMITED",
"MAHESH FOODS PRIVATE LIMITED",
"MAHESH GINNING PRIVATE LIMITED",
"MAHESH HARDWARE & PIPES PRIVATE LIMITED",
"MAHESH HIGH SCHOOL",
"MAHESH HOSIERY FACTORY PRIVATE LTD",
"MAHESH HOSPITAL",
"MAHESH INDUSTRIAL FACILITIES PRIVATE LIMITED",
"MAHESH INFRACON PRIVATE LIMITED",
"MAHESH INFRASTRUCTURES PRIVATE LIMITED",
"MAHESH INTERIORS PRIVATE LIMITED",
"MAHESH KRUSHI UDYOG PRIVATE LIMITED",
"MAHESH MARMO PRIVATE LIMITED",
"MAHESH MEGA MART PRIVATE LIMITED",
"MAHESH METALLOYS PRIVATE LIMITED",
"MAHESH MOTORS PRIVATE LIMITED",
"MAHESH NAMKEEN PRIVATE LIMITED",
"MAHESH PACKAGING PVT LTD",
"MAHESH PARAMESWARI BALIKA VIDYALAYA",
"MAHESH POLYMERS PRIVATE LIMITED",
"MAHESH PREFAB PRIVATE LIMITED",
"MAHESH RAJ CHEMICALS PRIVATE LIMITED",
"MAHESH RICE MILL",
"MAHESH SAHAKARI BANK LIMITED",
"MAHESH SILK MILLS PRIVATE LIMITED",
"MAHESH SMRUTI MULTISPECILITY HOSPITAL",
"MAHESH SNACKS PRIVATE LIMITED",
"MAHESH SPINTEX PRIVATE LIMITED",
"MAHESH STAINLESS STEELS PRIVATE LIMITED",
"MAHESH SUNNY ENTERPRISES PRIVATE LIMITED",
"MAHESH SUPPLIERS (INDIA) PRIVATE LIMITED",
"MAHESH SURGICAL & PHARMACEUTICAL",
"MAHESH TEA PROCESSORS AND PACKERS LIMITED",
"MAHESH TEXTILE PROCESSORS PRIVATE LIMITED",
"MAHESH TRADING CO",
"MAHESH TRANSLINE PRIVATE LIMITED",
"MAHESH TWISTO TECH PRIVATE LIMITED",
"MAHESH VALUE PRODUCTS PRIVATE LIMITED",
"MAHESH VEGOILS PRIVATE LIMITED",
"MAHESH WIRE-WELD INDUSTRIES PRIVATE LIMITED",
"MAHESH WOOD PRODUCTS PRIVATE LIMITED",
"MAHESHA INFRAVALLEY PRIVATE LIMITED",
"MAHESHKUMAR SPINNING MILLS PRIVATE LIMITED",
"MAHESHRAJKA PHARMACEUTICALS PRIVATE LIMITED",
"MAHESHTALA MUNICIPALITY",
"MAHESHVAR ISPAT PRIVATE LIMITED",
"MAHESHWAR DISTRIBUTORS PRIVATE LIMITED",
"MAHESHWAR FLOORING INDUSTRIES LIMITED",
"MAHESHWAR NAGAR PARISHAD",
"MAHESHWAR PACKAGING INDIA PRIVATE LIMITED",
"MAHESHWAR ROLLING MILLS PRIVATE LIMITED",
"MAHESHWARA COTTON INDUSTRIES",
"MAHESHWARA MEDICAL COLLEGE",
"MAHESHWARAM TRANSMISSION LIMITED",
"MAHESHWARI (THALTEJ) COMPLEX PRIVATE LIMITED",
"MAHESHWARI ADHESIVES PRIVATE LIMITED",
"MAHESHWARI AGROFOOD PRIVATE LIMITED",
"MAHESHWARI APPLIANCES PRIVATE LIMITED",
"MAHESHWARI APPLIANCES PVT LTD",
"MAHESHWARI AYURVED PRIVATE LIMITED",
"MAHESHWARI BIOCHEMICAL PRIVATE LIMITED",
"MAHESHWARI BLEND INDUSTRIES PRIVATE LIMITED",
"MAHESHWARI BOARD MILLS PRIVATE LIMITED",
"MAHESHWARI BRAZINGS PRIVATE LIMITED",
"MAHESHWARI BROTHERS PRIVATE LIMITED",
"MAHESHWARI CABLE AND CONDUCTOR PRIVATE LIMITED",
"MAHESHWARI CAPS PRIVATE LIMITED",
"MAHESHWARI CEMENT DISTRIBUTORS PVT LTD",
"MAHESHWARI COAL BENEFICATION AND INFRASTRUCTURE PRIVATE LIMITED",
"MAHESHWARI COMPUTERS PVT. LTD.",
"MAHESHWARI CONSTROSOLUTION PRIVATE LIMITED",
"MAHESHWARI CONTRACTORS PRIVATE LIMITED",
"MAHESHWARI COTS",
"MAHESHWARI CREATIONS PRIVATE LIMITED",
"MAHESHWARI DATAMATICS PVT LTD.",
"MAHESHWARI ELECTEICAL MERS PRIVATE LIMITED",
"MAHESHWARI ELECTRICAL MANUFACTURERS PRIVATE LIMITED",
"MAHESHWARI ELECTRICALS PRIVATE LIMITED",
"MAHESHWARI ELECTRONICS AND CABLE T.V.PRIVATE LIMITED",
"MAHESHWARI ELECTROS PVT LTD",
"MAHESHWARI ENTERPRISE",
"MAHESHWARI EQUITY BROKERS PRIVATE LIMITED",
"MAHESHWARI EQUITY SERVICES PRIVATE LIMITED",
"MAHESHWARI EXTRUSIONS PRIVATE LIMITED",
"MAHESHWARI FOODS AND HOSPITALITY PRIVATE LIMITED",
"MAHESHWARI FUELCHEM PRIVATE LIMITED",
"MAHESHWARI GEMS AND JEWELS (INDIA) PRIVATE LIMITED",
"MAHESHWARI GLOBAL INDUSTRIES PRIVATE LIMITED",
"MAHESHWARI HANDLING AGENCY PRIVATE LIMITED",
"MAHESHWARI INFRATECH PRIVATE LIMITED",
"MAHESHWARI INVESTORS PRIVATE LIMITED",
"MAHESHWARI LOGISTICS LIMITED",
"MAHESHWARI MARBLES PRIVATE LIMITED",
"MAHESHWARI MARMO PRIVATE LIMITED",
"MAHESHWARI MEGA VENTURES LIMITED",
"MAHESHWARI MINING PRIVATE LIMITED",
"MAHESHWARI OFFSET PRINTERS PRIVATE LIMITED",
"MAHESHWARI OXYGEN PRIVATE LIMITED",
"MAHESHWARI PACK TECH PRIVATE LIMITED",
"MAHESHWARI PAPAD UDYOG PRIVATE LIMITED",
"MAHESHWARI PAPER INDUSTRIES PRIVATE LIMITED",
"MAHESHWARI PHARMACEUTICALS (INDIA) LIMITED",
"MAHESHWARI PLYWOODS",
"MAHESHWARI PUBLIC SCHOOL",
"MAHESHWARI REALTORS AND DEVELOPERS PRIVATE LIMITED",
"MAHESHWARI RESOURCES PRIVATE LIMITED",
"MAHESHWARI ROAD CARRIERS PVT LTD",
"MAHESHWARI ROSIN AND TURPENTINE PVT LTD",
"MAHESHWARI SHARE AND STOCK-BROKERS PRIVATE LIMITED",
"MAHESHWARI SILKFAB PRIVATE LIMITED",
"MAHESHWARI SILVER ALLOYS PRIVATE LIMITED",
"MAHESHWARI STONES AND MINERALS PVT LTD",
"MAHESHWARI SUGARCANDY PRIVATE LIMITED",
"MAHESHWARI SYNTHETICS PVT LIMITED",
"MAHESHWARI TEA COMPANY PRIVATE LIMITED",
"MAHESHWARI TECHNOCAST LIMITED",
"MAHESHWARI TILES PRIVATE LIMITED",
"MAHESHWARI TRADELINK PRIVATE LIMITED",
"MAHESHWARI TRANSPORT AGENCY PRIVATE LIMITED",
"MAHESHWARI WIRES PRIVATE LIMITED",
"MAHESHWARI WOODS PRIVATE LIMITED",
"MAHESHWARI WOOLLEN MILLS PRIVATE LIMITED",
"MAHESTALA AGRO FOODS PRIVATE LIMITED",
"MAHESVARI POWER CONTROL PRIVATE LIMITED",
"MAHESWARI FABRICS PRIVATE LIMITED",
"MAHESWARI GRANULES PRIVATE LIMITED",
"MAHESWARI MINING AND ENERGY PRIVATE LIMITED",
"MAHESWARI OIL INDUSTRIES PRIVATE LIMITED",
"MAHESWARI ROLLER FLOUR MILLS PRIVATE LIMITED",
"MAHHAGURU NAVGRAH PRIVATE LIMITED",
"MAHI AGRI IMPEX PRIVATE LIMITED",
"MAHI BUILDHOME PRIVATE LIMITED",
"MAHI DRUGS PRIVATE LIMITED",
"MAHI DRYMIX PRODUCTS PRIVATE LIMITED",
"MAHI ENTERPRISES",
"MAHI FITNESS AND WELLNESS PRIVATE LIMITED",
"MAHI GRANITES PRIVATE LIMITED",
"MAHI IMPEX PRIVATE LIMITED",
"MAHI INTERNATIONAL SCHOOL",
"MAHI JEWELS PRIVATE LIMITED",
"MAHI ORGANIC PROTEINS PRIVATE LIMITED",
"MAHI WEAVES PRIVATE LIMITED",
"MAHICKRA CHEMICALS LIMITED",
"MAHIDHARA CHEMICALS PRIVATE LIMITED",
"MAHIDHARA PROJECTS PRIVATE LIMITED",
"MAHIKA HEALTHCARE PRIVATE LIMITED",
"MAHIKA PACKAGING INDIA LIMITED",
"MAHILA ABHIVRUDDDI SOCIETY",
"MAHILA CO-OPERATIVE BANK LIMITED",
"MAHILA EVAM BAL VIKAS JABALPUR",
"MAHILA KHADYA SANSADHAN PRIVATE LIMITED",
"MAHILA KUTIR KENDRA PRIVATE LIMITED",
"MAHILA MAHA VIDYALAYA KIDWAI NAGAR",
"MAHILA MONEY PRIVATE LIMITED",
"MAHILA SEVA SAMAJA SENIOR SECONDARY SCHOOL",
"MAHILA VIDYALAYA JUNIOR HIGH SCHOOL",
"MAHILA WOMENS COLLEGE",
"MAHIM POLYPRINTS PRIVATE LIMITED",
"MAHIMA COLD STORAGE PRIVATE LIMITED",
"MAHIMA COTEX PRIVATE LIMITED",
"MAHIMA ENGINEERING SYSTEMS PRIVATE LIMITED",
"MAHIMA EXIM PRIVATE LIMITED",
"MAHIMA FIBRES PRIVATE LIMITED",
"MAHIMA GRANITE PRIVATE LIMITED",
"MAHIMA INFRASTRUCTURES PRIVATE LIMITED",
"MAHIMA LIFESCIECES PRIVATE LIMITED",
"MAHIMA MERCHANDIZING PRIVATE LIMITED",
"MAHIMA MOTORS PRIVATE LIMITED",
"MAHIMA PRINTS PRIVATE LIMITED",
"MAHIMA REAL ESTATE PRIVATE LIMITED",
"MAHIMA SALES PRIVATE LIMITED",
"MAHIMA STOCKS PRIVATE LIMITED",
"MAHIMA SYNTEX PRIVATE LIMITED",
"MAHIMA TECHNOLOGY PRIVATE LIMITED",
"MAHIMA TEX TECH PRIVATE LIMITED",
"MAHIMTURA CONSULTANTS PRIVATE LIMITED",
"MAHINDER ATTACHI HOUSE PRIVATE LIMITED",
"MAHINDRA AEROSPACE PRIVATE LIMITED",
"MAHINDRA AEROSTRUCTURES PRIVATE LIMITED",
"MAHINDRA AGRI SOLUTIONS LIMITED",
"MAHINDRA AND MAHINDRA CONTECH LIMITED",
"MAHINDRA AND MAHINDRA FINANCIAL SERVICES LIMITED",
"MAHINDRA AND MAHINDRA LIMITED",
"MAHINDRA AUTO STEEL PRIVATE LIMITED",
"MAHINDRA AUTOMOBILE DISTRIBUTOR PRIVATE LIMITED",
"MAHINDRA BEBANCO DEVELOPERS LIMITED",
"MAHINDRA CIE AUTOMOTIVE",
"MAHINDRA CONSTRUCTION COMPANY LIMITED",
"MAHINDRA CONSULTING ENGINEERS LIMITED",
"MAHINDRA DEFENCE NAVAL SYSTEMS PRIVATE LIMITED",
"MAHINDRA DEFENCE SYSTEMS LIMITED",
"MAHINDRA ECOLE CENTRALE",
"MAHINDRA EDUCATION SOCIETY MAHINDRA ACADEMY",
"MAHINDRA EDUCATIONAL INSTITUTIONS",
"MAHINDRA ENGINEERING AND CHEMICAL PRODUCTS LIMITED",
"MAHINDRA EPC IRRIGATION LIMITED",
"MAHINDRA EPC SERVICES PRIVATE. LIMITED",
"MAHINDRA FINACE LIMITED",
"MAHINDRA FIRST CHOICE SERVICES LIMITED",
"MAHINDRA FIRST CHOICE WHEELS LIMITED",
"MAHINDRA GREENYARD PRIVATE LIMITED",
"MAHINDRA HAPPINEST DEVELOPERS LIMITED",
"MAHINDRA HEAVY ENGINES PRIVATE LIMITED",
"MAHINDRA HOLDINGS LIMITED",
"MAHINDRA HOLIDAYS & RESORTS INDIA LIMITED",
"MAHINDRA HOLIDAYS AND RESORTS LIMITED",
"MAHINDRA HOMES PRIVATE LIMITED",
"MAHINDRA HZPC PRIVATE LIMITED",
"MAHINDRA INDUSTRIAL PARK CHENNAI LIMITED",
"MAHINDRA INDUSTRIAL PARK PRIVATE LIMITED",
"MAHINDRA INFRASTRUCTURE DEVELOPERS LIMITED",
"MAHINDRA INSURANCE BROKERS LIMITED",
"MAHINDRA INTEGRATED BUSINESS SOLUTIONS PRIVATE LIMITED",
"MAHINDRA INTERNATIONAL SCHOOL ACADEMY",
"MAHINDRA INTERNET COMMERCE PRIVATE LIMITED",
"MAHINDRA INTERTRADE LIMITED",
"MAHINDRA LIFESPACE DEVELOPERS LIMITED",
"MAHINDRA LOGISTICS",
"MAHINDRA LOGISTICS LIMITED",
"MAHINDRA MANULIFE INVESTMENT MANAGEMENT PRIVATE LIMITED",
"MAHINDRA MARINE PRIVATE LIMITED",
"MAHINDRA MSTC RECYCLING PRIVATE LIMITED",
"MAHINDRA NAMASTE PRIVATE LIMITED",
"MAHINDRA RETAIL PRIVATE LIMITED",
"MAHINDRA RISE",
"MAHINDRA RURAL HOUSING FINANCE LIMITED",
"MAHINDRA SANYO SPECIAL STEEL PRIVATE LIMITED",
"MAHINDRA SATYAM",
"MAHINDRA SONA LIMITED",
"MAHINDRA STEEL SERVICE CENTRE LIMITED",
"MAHINDRA STILLER AUTO TRUCKS LTD",
"MAHINDRA SUMMIT AGRISCIENCE LIMITED",
"MAHINDRA SUSTAINABLE ENERGY PRIVATE LIMITED",
"MAHINDRA TELEPHONICS INTEGRATED SYSTEMS LIMITED",
"MAHINDRA TEQO PRIVATE LIMITED",
"MAHINDRA TOP GREENHOUSES PRIVATE LIMITED",
"MAHINDRA TRUCKS & BUSES LIMITED",
"MAHINDRA TSUBAKI CONVEYOR SYSTEMS PRIVATE LIMITED",
"MAHINDRA TWO WHEELERS LIMITED",
"MAHINDRA UNITED WORLD COLLEGE OF WORLD",
"MAHINDRA UNIVERSITY MUI",
"MAHINDRA VEHICLE MANUFACTURERS LIMITED",
"MAHINDRA WASTE TO ENERGY SOLUTIONS LIMITED",
"MAHINDRA WATER UTILITIES LIMITED",
"MAHINDRA WORLD CITY (JAIPUR) LIMITED",
"MAHINDRA WORLD CITY DEVELOPERS LIMITED",
"MAHINDRA WORLD CITY JAIPUR LIMITED",
"MAHINDRU HOSPITAL PRIVATE LIMITED",
"MAHIPAL AUTO INDUSTRIES PRIVATE LIMITED",
"MAHIPAL CERAMICS PVT LTD",
"MAHIPAL HOSPITALS",
"MAHIPATI AGRO PRIVATE LIMITED",
"MAHISAN PRIVATE LIMITED",
"MAHISHI TRUST'S YOGA & NATUROPATHY HOSPITAL DHARWAD",
"MAHISHMATI PLASTICS PRIVATE LIMITED",
"MAHITECHS",
"MAHKAM POORVIAUM IMPEX TRADING PRIVATE LIMITED",
"MAHLE ANAND FILTER SYSTEMS PRIVATE LIMITED",
"MAHLE ANAND THERMAL SYSTEMS PRIVATE LIMITED",
"MAHLE ELECTRIC DRIVES INDIA PRIVATE LIMITED",
"MAHLE ENGINE COMPONENTS INDIA PRIVATE LIMITED",
"MAHLE ENGINEERING SERVICES INDIA PRIVATE LIMITED",
"MAHLE FILTER SYSTEMS INDIA PRIVATE LIMITED",
"MAHLE HOLDING INDIA PRIVATE LIMITED",
"MAHMOOD ASSOCIATES PRIVATE LIMITED",
"MAHNA LEATHERS PRIVATE LIMITED",
"MAHODARA ESTATES PRIVATE LIMITED",
"MAHODAYA HYBRID SEEDS PRIVATE LIMITED",
"MAHODAYA INDUSTRIES PRIVATE LIMITED",
"MAHOGANI VISHWA AGRO LIMITED",
"MAHOTI FARMS PRIVATE LIMITED",
"MAHOTSAV CREATION PRIVATE LIMITED",
"MAHR METROLOGY INDIA PRIVATE LIMITED",
"MAHRATTA CHAMBER OF COMMERCE INDUSTRIES AND AGRICULTURE",
"MAHRISHI ALLOYS PRIVATE LIMITED",
"MAHRISHI MELTCHEMS PRIVATE LIMITED",
"MAHROOK SEA FOODS PRIVATE LIMITED",
"MAHRSHEE LABORATORIES PRIVATE LIMITED",
"MAHRSHEE ORGANICS PRIVATE LIMITED",
"MAHSEER PRODUCT PRIVATE LIMITED",
"MAHTO FRUITS PRIVATE LIMITED",
"MAHUA BHARATPUR EXPRESSWAYS LIMITED",
"MAHUDI SYNTHETICS PRIVATE LIMITED",
"MAHURKAR INFRASTRUCTURE DEVELOPMENT PRIVATE LIMITED",
"MAHUWALATRADING COMPANY PVT.LTD.",
"MAHYCO MONSANTO BIOTECH (INDIA) PRIVATE LIMITED",
"MAHYCO PRIVATE LIMITED",
"MAI BAAP PROCESSORS PRIVATE LIMITED",
"MAI INDOLINK CONSULTING PRIVATE LIMITED",
"MAI MANGESHKAR HOSPITAL",
"MAI TECH PRIVATE LIMITED",
"MAIA INTELLIGENCE PRIVATE LIMITED",
"MAIA LIFE-STYLE PRIVATE LIMITED",
"MAICO VENTILATION PRIVATE LIMITED",
"MAIDEE AGRO AND INFRASTRUCTURE PRIVATE LIMITED",
"MAIDEN DISTRIBUTORS LIMITED",
"MAIDEN DROP EDU FOUNDATION",
"MAIDEN FORGINGS LIMITED",
"MAIDEN MARKETING INDIA PRIVATE LIMITED",
"MAIDEN PAPER TUBES PRIVATE LIMITED",
"MAIDEN PHARMACEUTICALS LIMITED",
"MAIDEN TRADEFIN PRIVATE LIMITED",
"MAIESTA MOTORS PRIVATE LIMITED",
"MAIGNO INFRA & DEVELOPERS PRIVATE LIMITED",
"MAIGNO INFRA PRIVATE LIMITED",
"MAIHAR ALLOYS PRIVATE LIMITED",
"MAIHAR HOTELS & RESORT PRIVATE LIMITED",
"MAIHAR MOTORS PRIVATE LIMITED",
"MAIHAR ROCK CRUSHERS PRIVATE LIMITED",
"MAIHAR WHEELS PRIVATE LIMITED",
"MAIHER SECURITY SERVICE INDIA PRIVATE LIMITED",
"MAIKA METALS PRIVATE LIMITED",
"MAIKAL BREWERIES PRIVATE LIMITED",
"MAIKAL KANYA INTERNATIONAL PRIVATE LIMITED",
"MAIKAL WOMEN LAYER PRODUCER COMPANY LIMITED",
"MAIL ORDER SOLUTIONS INDIA PRIVATE LIMITED",
"MAIL TODAY NEWSPAPERS PRIVATE LIMITED",
"MAILAM ENGINEERING COLLEGE",
"MAILAM INDIA LIMITED",
"MAILAM INDIA PRIVATE LIMITED",
"MAILAM PLASTIC",
"MAILAM SUBRAMANIYA SWAMY FOUNDATION",
"MAILAM UPKING ENGINEERING LIMITED",
"MAILBOX FASHIONS PRIVATE LIMITED",
"MAILE STONE INDUSTRIES PRIVATE LIMITED",
"MAILHEM ENVIRONMENT PRIVATE LIMITED",
"MAILIKA INFRA PROJECTS PRIVATE LIMITED",
"MAILINI BUILDWELL CONSTRUCTION PRIVATE LIMITED",
"MAILIT MAILROOM MANAGEMENT SERVICES PRIVATE LIMITED",
"MAILLEFER EXTRUSION INDIA PRIVATE LIMITED",
"MAIN DATA GROUP (INDIA) PRIVATE LIMITED",
"MAIN HARDWARE INDIA PRIVATE LIMITED",
"MAIN LAND FINANCE PRIVATE LIMITED",
"MAINA INTERNATIONAL LIMITED",
"MAINA SALES & MARKETING",
"MAINAGE FACILITY MANAGEMENT PRIVATE LIMITED",
"MAINAK ENGINEERING PVT LTD",
"MAINATREXIM PVT. LTD.",
"MAINAWAT PACKAGE INDUSTRY PVT LTD",
"MAIND FLOW CONTROLS PRIVATE LIMITED",
"MAIND INVESTMENTS PRIVATE LIMITED",
"MAINEE STEEL WORKS PRIVATE LIMITED",
"MAINETTI INDIA PRIVATE LIMITED",
"MAINFRAME COMPUTERS PVT LTD",
"MAINI AUTO AGENCIES PRIVATE LIMITED",
"MAINI CONSTRUCTION EQUIPMENTS PVT. LTD.",
"MAINI GROUP OF EDUCATIONAL SOCIETY",
"MAINI INDUSTRIES PRIVATE LIMITED",
"MAINI MATERIALS MOVEMENT PRIVATE LIMITED",
"MAINI PLASTICS AND COMPOSITES PRIVATE LIMITED",
"MAINI PRECISION PRODUCTS LIMITED",
"MAINLAND ENGINEERING PRIVATE LIMITED",
"MAINLAND HEAVY PARTS PRIVATE LIMITED",
"MAINLAND INFRACORE PRIVATE LIMITED",
"MAINLINE ACADEMY",
"MAINLINE SERVICES PRIVATE LIMITED",
"MAINSTAY DEVELOPMENT CONSULTANTS PRIVATE LIMITED",
"MAINSTAY TELESERVICES PRIVATE. LIMITED",
"MAINSTREAM PRODUCTION PRIVATE LIMITED",
"MAINTEC TECHNOLOGIES PRIVATE LIMITED",
"MAIORA IT SERVICES AND CONSULTING PRIVATE LIMITED",
"MAIP TRANS PRIVATE LIMITED",
"MAIPAKPI MATERNITY AND CHILD HOSPITAL PRIVATE LIMITED",
"MAIPARADO MCE PRIVATE LIMITED",
"MAIPOO INNOVATIONS PRIVATE LIMITED",
"MAIR SECURITIES PRIVATE LIMITED",
"MAIRA FITNESS PRIVATE LIMITED",
"MAIRA LIFESTYLE PRIVATE LIMITED",
"MAIRA NETWORKS PRIVATE LIMITED",
"MAIRAJ PROPERTIES PRIVATE LIMITED",
"MAIS INDIA MEDICALDEVICES PRIVATE LIMITED",
"MAIS OVERSEAS PRIVATE LIMITED",
"MAISHA LIFESTYLE PRODUCTS PRIVATE LIMITED",
"MAISON DE LUXE SERVICES PRIVATE LIMITED",
"MAISON DES ARTS PRIVATE LIMITED",
"MAISON STAYS PRIVATE LIMITED",
"MAISTERING INDIA PRIVATE LIMITED",
"MAISUR PROJECTS PRIVATE LIMITED",
"MAIT INDIA FOUNDATION EQUIPMENT PRIVATE LIMITED",
"MAITHAN ALLOYS LTD",
"MAITHAN CERAMIC LTD",
"MAITHAN COAL CO PVT LTD",
"MAITHAN STEEL & POWER PRIVATE. LIMITED.",
"MAITHAN TRADE-COM PRIVATE LIMITED",
"MAITHILI ADITYA CONSTRUCTIONS (INDIA ) PRIVATE LIMITED",
"MAITHILI ADITYA MINERALS PRIVATE LIMITED",
"MAITHILI KALPVRUKSH PRIVATE LIMITED",
"MAITHILI LIFE SCIENCES PRIVATE LIMITED",
"MAITHILI SHIPPING & LOGISTICS PRIVATE LIMITED",
"MAITHON POWER LIMITED",
"MAITHRI AQUATECH PRIVATE LIMITED",
"MAITHRI DRUGS PRIVATE LIMITED",
"MAITHRI LABORATORIES PRIVATE LIMITED",
"MAITHRY VIDYANIKETHAN",
"MAITI GOLD WORKS PRIVATE LIMITED",
"MAITO KALI AGRO PRODUCTS PRIVATE LIMITED",
"MAITRA BUILDTECH PRIVATE LIMITED",
"MAITRA COMMODITIES PRIVATE LIMITED",
"MAITREYA CAPITAL AND BUSINESS SERVICES PRIVATE LIMITED",
"MAITREYA ELECTRICALS PVT.LTD.",
"MAITREYA MEDICARE LIMITED",
"MAITREYEE I.T. SERVICES PRIVATE LIMITED",
"MAITREYI COLLEGE",
"MAITREYI DEGREE COLLEGE",
"MAITREYI HOSPITAL PVT LTD",
"MAITRI ADVERTISING WORKS PRIVATE LIMITED",
"MAITRI BODH PARIVAAR PRIVATE LIMITED",
"MAITRI CAST PRIVATE LIMITED",
"MAITRI DENTAL COLLEGE",
"MAITRI DIAGNOSTICS PRIVATE LIMITED",
"MAITRI EDUCATIONAL SOCIETY",
"MAITRI ENVIRONMENT SOLUTIONS PRIVATE LIMITED",
"MAITRI INFORMATION SYSTEMS PRIVATE LIMITED",
"MAITRI INTERIOR PROJECTS PRIVATE LIMITED",
"MAITRI METALS PRIVATE LIMITED",
"MAITRI SOLUTIONS LIMITED",
"MAITRI TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"MAITRIK FASHION PRIVATE LIMITED",
"MAITY FOREX PRIVATE LIMITED",
"MAITY POULTRIES PRIVATE LIMITED",
"MAIVA PHARMA PRIVATE LIMITED",
"MAIWIR ENGINEERING PRIVATE LIMITED",
"MAIYAS RESTAURANTS PRIVATE LIMITED",
"MAIZ HOSPITALITY PRIVATE LIMITED",
"MAJATI JEWELLERS PRIVATE LIMITED",
"MAJEE IRON & MINERALS PRIVATE LIMITED",
"MAJENTA HOLDINGS PRIVATE LIMITED",
"MAJERAUT KHIRODAMOYEE PRY SCHOOL",
"MAJESCO SOFTWARE AND SOLUTIONS INDIA PRIVATE LIMITED",
"MAJESTIC AUTO LIMITED",
"MAJESTIC BASMATI RICE PRIVATE LTD",
"MAJESTIC BUILTWELL PRIVATE LIMITED",
"MAJESTIC CAFE PRIVATE LIMITED",
"MAJESTIC CLOTHING INDIA PRIVATE LIMITED",
"MAJESTIC COMMODITIES PRIVATE LIMITED",
"MAJESTIC CONSTRUCTIONS AND DEVELOPERS PRIVATE LIMITED",
"MAJESTIC EMPOWERMENT FORUM",
"MAJESTIC EXPORTS",
"MAJESTIC GRANITES PRIVATE LIMITED",
"MAJESTIC GRAPHICS AND MACHINERY INDIA PRIVATE LIMITED",
"MAJESTIC HANDICRAFTS PRIVATE LIMITED",
"MAJESTIC HOSPITALITIES PRIVATE LIMITED",
"MAJESTIC IT SERVICES LIMITED",
"MAJESTIC MANOR PRIVATE LIMITED",
"MAJESTIC MARITIME PRIVATE LIMITED",
"MAJESTIC PEOPLE INFOTECH PRIVATE LIMITED",
"MAJESTIC PROPERTIES PRIVATE LIMITED",
"MAJESTIC PROPERTY DEVELOPERS PRIVATE LIMITED",
"MAJESTIC REALBUILD PRIVATE LIMITED",
"MAJESTIQUE LANDMARKS PRIVATE LIMITED",
"MAJESTRO CIVIL TECH PRIVATE LIMITED",
"MAJESTY CORPORATE SOLUTIONS PRIVATE LIMITED",
"MAJETHIA PAPERS PRIVATE LIMITED",
"MAJHA INVESTMENT PRIVATE LIMITED",
"MAJID AL FUTTAIM HYPERMARKETS PRIVATE LIMITED",
"MAJIME EXIM PRIVATE LIMITED",
"MAJISHAA CRAFTS AND ARTS PRIVATE LIMITED",
"MAJIX COMPUTING PRIVATE LIMITED",
"MAJOR AO 1 MP COMPO TECH REGIMENT NCC BHOPAL",
"MAJOR APPLIANCES INDIA PRIVATE LIMITED",
"MAJOR CONSTRUCTION EQUIPMENTS COMPANY PRIVATE LIMITED",
"MAJOR FOOTWEARS PRIVATE LIMITED",
"MAJOR INFRATECH PRIVATE LIMITED",
"MAJOR KALSHI CLASSES PRIVATE LIMITED",
"MAJOR LIFE STYLE PRIVATE LIMITED",
"MAJOR SECURITY & INTELLIGENCE SERVICES PRIVATE LIMITED",
"MAJOR SINGH & BROS. PRIVATE LIMITED",
"MAJOR SURESH BHATNAGAR H.R SEC SCHOOL",
"MAJOR TEXTILES PRIVATE LIMITED",
"MAJOREL INDIA PRIVATE LIMITED",
"MAJORHUB OLEO CHEMICALS PRIVATE LIMITED",
"MAJRA PAINTS PRIVATE LIMITED",
"MAJULAH INFOTECH PRIVATE LIMITED",
"MAJUMDER AGRO INDUSTRIES PRIVATE LIMITED",
"MAJUMDER MILLENNIUM NURSING HOME& RELIABLE DIAGNOSTIC CENTRE PVT LTD",
"MAK AGENCIES AND DISTRIBUTORS PRIVATE LIMITED",
"MAK AIRWAYS PRIVATE LIMITED",
"MAK BUILDCON (INDORE) PRIVATE LIMITED",
"MAK CLEAN AIR SYSTEMS PRIVATE LIMITED",
"MAK CONSTRUCTIONS",
"MAK CONTROLS AND SYSTEMS PRIVATE LIMITED",
"MAK ENVIROTECH & SOLUTIONS (INDIA) PRIVATE LIMITED",
"MAK FLEXIBLE PACKAGING PRIVATE LIMITED",
"MAK FOODS INDUSTRIES INDIA PRIVATE LIMITED",
"MAK GLOBAL LEATHER EXPORTS PRIVATE LIMITED",
"MAK HOSPITALS PRIVATE LIMITED",
"MAK INDIA LIMITED",
"MAK INFRA PRIVATE LIMITED",
"MAK INFRAREALTY PRIVATE LIMITED",
"MAK INFRAZONE PRIVATE LIMITED",
"MAK INTEGRATED ELECTRICAL CONTRACTORS PRIVATE LIMITED",
"MAK LOGISTICS PRIVATE LIMITED",
"MAK MOBILITY PRIVATE LIMITED",
"MAK MOTORS PRIVATE LIMITED",
"MAK PARAMOUNT INFRAVENTURES PRIVATE LIMITED",
"MAK POWER AND CONTROL PRIVATE LIMITED",
"MAK REMOVAL & STORAGE INDIA PRIVATE LIMITED",
"MAK RUBBER INDIA LIMITED",
"MAK VEE WATER EQUIPMENTS PRIVATE LIMITED",
"MAK VENTURES INDIA PRIVATE LIMITED",
"MAKAAN COM PRIVATE LIMITED",
"MAKALI ENGINEERING WORKS PVT LTD",
"MAKAM AGRO CHEM PRIVATE LIMITED",
"MAKAMASHI ENTERPRISES PRIVATE LIMITED",
"MAKAMS INDUSTRIES PRIVATE LIMITED",
"MAKANI CREATIVES PRIVATE LIMITED",
"MAKARAJYOTHI CHITS PRIVATE LIMITED",
"MAKARNA EXIM PRIVATE LIMITED",
"MAKARPURA HOSPITAL PRIVATE LIMITED",
"MAKASHIR DIAGNOSTIC MEDICAL LAB PRIVATE LIMITED",
"MAKCUR LABORATORIES LIMITED",
"MAKE EASY FINANCE LIMITED",
"MAKE EVENT & CATERERS",
"MAKE HOME REALTY AND CONSTRUCTION PRIVATE LIMITED",
"MAKE MARK MFG PRIVATE LIMITED",
"MAKE MY TRAVEL (INDIA) PRIVATE LIMITED",
"MAKE POSITIVE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"MAKE UP STUDIO TRAINING CENTER PRIVATE LIMITED",
"MAKE WAVES SEA RESORT PRIVATE LIMITED",
"MAKEBOT ROBOTIC SOLUTIONS PRIVATE LIMITED",
"MAKEDIAN SOFTECH SOLUTIONS PRIVATE LIMITED",
"MAKEEN ENERGY INDIA PRIVATE LIMITED",
"MAKEMYTRIP (INDIA) PRIVATE LIMITED",
"MAKEOVER DECOR PRIVATE LIMITED",
"MAKEOVER PAINTS PRIVATE LIMITED",
"MAKER LANDCON PRIVATE LIMITED",
"MAKERINME TECHNOLOGIES PRIVATE LIMITED",
"MAKER'S ASYLUM INNOVATION PRIVATE LIMITED",
"MAKERS CASTING PRIVATE LIMITED",
"MAKERS LABORATORIES LTD",
"MAKERS OF MILKSHAKES PRIVATE LIMITED",
"MAKERS PHARMA PRIVATE LIMITED",
"MAKERS POLYFILMS PRIVATE LIMITED",
"MAKERSTRIVE ENGINEERING PRIVATE LIMITED",
"MAKEUR HOME INFRA PRIVATE LIMITED",
"MAKEVALE ACRYLICS PRIVATE LIMITED",
"MAKEWELL DEVELOPERS PRIVATE LIMITED",
"MAKEWELL FLOWWRAP SYSTEM PRIVATE LIMITED",
"MAKEWELL INDUCTO CAST PRIVATE LIMITED",
"MAKEWELL MANAGEMENT SERVICES PRIVATE LIMITED",
"MAKEX PROJECTS PRIVATE LIMITED",
"MAKEYOU TRAVEL PRIVATE LIMITED",
"MAKHAN BHOG FOOD PRODUCTS PVT LTD",
"MAKHAN CHOR PORTFOLIOS PRIVATE LIMITED",
"MAKHANA FARMS PRIVATE LIMITED",
"MAKHANA FOODGRAINS PRIVATE LIMITED",
"MAKHANAWALA NATURAFOODS PRIVATE LIMITED",
"MAKHANLAL CHATURVEDI NATIONAL UNIVERSITY OF JOURNALISM & COMMUNICATION",
"MAKHARIA CHEMICALS PRIVATE LIMITED",
"MAKHARIA ELECTRICALS PRIVATE LIMITED",
"MAKHARIA MACHINERIES PRIVATE LIMITED",
"MAKHAYO FOODS PRIVATE LIMITED",
"MAKHIJA COLD STORAGE PRIVATE LIMITED",
"MAKHIJA COTTON FAB PRIVATE LIMITED",
"MAKHIJA DEVELOPERS PRIVATE LIMITED",
"MAKHIJA INTERNATIONAL PRIVATE LIMITED",
"MAKHOUSE INFRATECH PRIVATE LIMITED",
"MAKIN DEVELOPERS PRIVATE LIMITED",
"MAKIN HEALTH CARE PRIVATE LIMITED",
"MAKIN LABORATORIES PRIVATE LIMITED",
"MAKIN MEMORIES PRIVATE LIMITED",
"MAKING YOU LIVE PRIVATE LIMITED",
"MAKINO AUTO INDUSTRIES PRIVATE LIMITED",
"MAKINO AUTOMOTIVE",
"MAKINO INDIA PRIVATE LIMITED",
"MAKITA POWER TOOLS INDIA PRIVATE LIMITED",
"MAKKAJAI EDU TECH PRIVATE LIMITED",
"MAKKAL THOLAI THODARPU KUZHUMAM LIMITED",
"MAKKAR AUTOMOBILES PRIVATE LIMITED",
"MAKKAR MEDICAL CENTRE PRIVATE LIMITED",
"MAKKAR MULTI SPECIALITY HOSPITAL",
"MAKKAR SONS TELECOM PRIVATE LIMITED",
"MAKKAR STEELS PRIVATE LIMITED",
"MAKKAR TEXTILE",
"MAKKER FABS PRIVATE LIMITED",
"MAKKPRESS TECHNOLOGIES PRIVATE LIMITED",
"MAKO IT LAB PRIVATE LIMITED",
"MAKONIS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"MAKPOWER TRANS SYSTEMS PRIVATE LIMITED",
"MAKRAMPUR RICE MILL PRIVATE LIMITED.",
"MAKROCARE CLINICAL RESEARCH LIMITED",
"MAKS AUTOMATION PRIVATE LIMITED",
"MAKS AUTOMOTIVE PRIVATE LIMITED",
"MAKS ENERGY SOLUTIONS INDIA LIMITED",
"MAKS HOSPITAL PRIVATE LIMITED",
"MAKS MOTORS PRIVATE LIMITED",
"MAKS PROFESSIONALS PRIVATE LIMITED",
"MAKS TECHNOLOGIES",
"MAKS TELEWORLD PRIVATE LIMITED",
"MAKSAD BUILDCON PRIVATE LIMITED",
"MAKSAT CORAL PRIVATE LIMITED",
"MAKSAT TECHNOLOGIES PRIVATE LIMITED",
"MAKSE SERVICES PRIVATE LIMITED",
"MAKSENS PAPER PRODUCTS PRIVATE LIMITED",
"MAKSHI INFOTECH PRIVATE LIMITED",
"MAKSIM LEGAL PROSERVE PRIVATE LIMITED",
"MAKSON ENGINEEERING EXPORTS PRIVATE LIMITED",
"MAKSON HEALTH CARE PRIVATE LIMITED",
"MAKSON INDIA HOSPITALITY PRIVATE LIMITED",
"MAKSON MACHINERY PRIVATE LIMITED",
"MAKSON MACHINES PVT LTD",
"MAKSON PHARMACEUTICALS (INDIA) PRIVATE LIMITED",
"MAKSON SHEET METAL FABRICATION PRIVATE LIMITED",
"MAKSONS FINE CHEM PRIVATE LIMITED",
"MAKSTEEL WIRE HEALDS PVT LTD",
"MAKSUD ALAM LEAF MECHANICAL",
"MAKSUN BIOTECH PRIVATE LIMITED",
"MAKTECH AUTO PRIVATE LIMITED",
"MAKTEK STEEL SOLUTIONN PRIVATE LIMITED",
"MAKUDA HEALTH CARE'S PRIVATE LIMITED",
"MAKUNIVERSAL INFRATECH INDIA PRIVATE LIMITED",
"MAKUTA DEVELOPERS AND INFRASTRUCTURES PRIVATE LIMITED",
"MAKUTA EFFECTS PRIVATE LIMITED",
"MAKVIN AUTOMATION PRIVATE LIMITED",
"MAKVOLT POWER PRIVATE LIMITED",
"MAKWANA ASSOCIATE",
"MAKWANA STEEL ART",
"MAKWELL ORGANICS PRIVATE LIMITED",
"MAKYSH PETROCHEM PRIVATE LIMITED",
"MAKZEST CONTROLS PRIVATE LIMITED",
"MAL METALLIKS PRIVATE LIMITED",
"MALA ENGICON PRIVATE LIMITED",
"MALA KUMAR ENGINEERS PRIVATE LIMITED",
"MALA PLAST INDIA PRIVATE LIMITED",
"MALA SHAKUNTALEYA TRANS PRIVATE LIMITED",
"MALABAR BUILDERS INDIA PRIVATE LIMITED",
"MALABAR BUSINESS CENTRE PRIVATE LIMITED",
"MALABAR CARS PRIVATE LIMITED",
"MALABAR CEMENTS LTD",
"MALABAR COAST MARINE SERVICES PRIVATE LTD",
"MALABAR COCHIN ARCADE PRIVATE LIMITED",
"MALABAR COLLECTIONS PRIVATE LIMITED",
"MALABAR COMMERCIAL PLAZA PRIVATE LIMITED",
"MALABAR CREATIONS PRIVATE LIMITED",
"MALABAR CRYSTALS AND DIAMONDS PRIVATE LIMITED",
"MALABAR DAZZLE INDIA PRIVATE LIMITED",
"MALABAR DEVELOPERS PRIVATE LIMITED",
"MALABAR DIAMOND GALLERY PRIVATE LIMITED",
"MALABAR EQUIPMENTS AND GENERAL TRADERS PRIVATE LIMITED",
"MALABAR EXTRUSIONS PRIVATE LIMITED",
"MALABAR FABRICATORS AND CONTRACTORS PRIVATE LIMITED",
"MALABAR FASHIONJEWELLERS PRIVATE LIMITED",
"MALABAR GOLD JEWELS TIRUR PRIVATE LIMITED",
"MALABAR GOLD LIMITED",
"MALABAR GOLD PALACE PRIVATE LIMITED",
"MALABAR GOLD PRIVATE LIMITED",
"MALABAR GOLD SUPER MARKET KANNUR PRIVATE LIMITED",
"MALABAR HIGHVIEW BUILDERS PRIVATE LIMITED",
"MALABAR HILL CLUB LIMITED",
"MALABAR HOSPITALITY SERVICES PRIVATE LIMITED",
"MALABAR HOSPITALS PVT LTD",
"MALABAR INSTITUTE OF MEDICAL SCIENCES",
"MALABAR INTERNATIONAL GOLD DESIGNS PRIVATE LIMITED",
"MALABAR JEWELS AND GEMS PRIVATE LIMITED",
"MALABAR JEWELS FORT PRIVATE LIMITED",
"MALABAR KODUNGALLUR SONA BAZAR P LIMITED",
"MALABAR LATEX P LTD",
"MALABAR MANGALORE ARCADE PRIVATE LIMITED",
"MALABAR MOUNTAIN INFRA DEVELOPERS PRIVATE LIMITED",
"MALABAR MULTI SPECIALITY CENTRE PRIVATE LIMITED",
"MALABAR ORNAMENTS PRIVATE LIMITED",
"MALABAR OXYGEN COMPANY PRIVATE LIMITED",
"MALABAR PLEASURES INDIA PRIVATE LIMITED",
"MALABAR PLUS CONSTRUCTIONS PRIVATE LIMITED",
"MALABAR PRECIOUS JEWELS INDIA PRIVATE LIMITED",
"MALABAR READYMIX CONCRETE PRIVATE LIMITED",
"MALABAR REGIONAL CO-OPERATIVE MILK PRODUCERS' UNION LTD",
"MALABAR RETNA MAHAL PRIVATE LIMITED",
"MALABAR ROCK PRIVATE LIMITED",
"MALABAR ROYAL DESIGNS HYDERABAD PRIVATE LIMITED",
"MALABAR RUBY PRIVATE LIMITED",
"MALABAR WATCHES PRIVATE LIMITED",
"MALABARNATURAL FOODS PRIVATE LIMITED",
"MALABOU TESTING & SERVICES INDIA PRIVATE LIMITED",
"MALADE CHEMICALS PRIVATE LIMITED",
"MALAI MURASU TV PRIVATE LIMITED",
"MALAIYA AGRO ENGINEERING PVT LTD",
"MALAK APPARELS PRIVATE LIMITED",
"MALAK TRADING PRIVATE LIMITED",
"MALAMPUZHA CEMENT AND CHEMICALS",
"MALANA POWER COMPANY LIMITED",
"MALANADU AMMONIA PRIVATE LIMITED",
"MALANGIA ARTS PRIVATE LIMITED",
"MALANI DAIRY PRIVATE LIMITED",
"MALANI FOODS PRIVATE LIMITED",
"MALANI MARBLES PRIVATE LIMITED",
"MALANKARA MULTI-STATE CO-OPERATIVE CREDIT SOCIETY LTD",
"MALAPPURAM HOTELS AND RESORTS PRIVATE LIMITED",
"MALAPRABHA FERTILIZERS PRIVATE LIMITED",
"MALAR FERTILITY AND RESEARCH CENTRE",
"MALAR HOSPITAL",
"MALAR PLASTICS PRIVATE LIMITED",
"MALAR PUBLICATIONS LIMITED",
"MALAR SILKS PRIVATE LIMITED",
"MALAR SOLVENT EXTRACTION PRIVATE LIMITED",
"MALARA SHIPPING PRIVATE LIMITED",
"MALASHIKA PRIMARY SCHOOL",
"MALATHY CONSTRUCTION PRIVATE LIMITED",
"MALATI AUTOCAST PRIVATE LIMITED",
"MALATI FOUNDERS PRIVATE LIMITED",
"MALAV SEEDS PVT LTD",
"MALAVIKA HOTELS PRIVATE LIMITED",
"MALAVIYA NATIONAL INSTITUTE OF TECHNOLOGY JAIPUR",
"MALAXMI HIGHWAY PRIVATE LIMITED",
"MALAXMI INFRA VENTURES INDIA PRIVATE LIMITED",
"MALAXMI POLYMERS PRIVATE LIMITED",
"MALAXMI PROPERTY VENTURES PRIVATE LIMITED",
"MALAY EXPORTS PRIVATE LIMITED",
"MALAY INFOTECH PRIVATE LIMITED",
"MALAYA TRADE IMPEX PRIVATE LIMITED",
"MALAYAGIRI FOODS AND BEVERAGES PRIVATE LIMITED",
"MALAYAJ SOLUTIONS PRIVATE LIMITED",
"MALAYAKAM AGGREGATES AND SANDS PRIVATE LIMITED",
"MALAYALA MANAROMA COMPANY LIMITED",
"MALAYALAM COMMUNICATIONS LIMITED",
"MALAYALAM HIRE PURCHASE AND LEASING PVT LTD",
"MALAYALAM INDUSTRIES LIMITED",
"MALAYALAM MOTORS PRIVATE LIMITED",
"MALAYALAM VEHICLES INDIA PRIVATE LIMITED",
"MALAYAPPA GARMENTS KG DENIM LIMITED",
"MALAYIL BUILDERS PRIVATE LIMITED",
"MALAYITHA IMPEX PRIVATE LIMITED",
"MALAYSIA AIRLINES BERHAD",
"MALBEL TECHNOLOGIES PRIVATE LIMITED",
"MALBROS INTERNATIONAL PRIVATE LIMITED",
"MALBROS PLASTICS INDIA PVT LTD",
"MALCA AMIT JK LOGISTICS PRIVATE LIMITED",
"MALCHAND & CO. FABRIC PRIVATE LIMITED",
"MALCHAND DINDAYAL SALTS PRIVATE LIMITED",
"MALCHAND TRADE RESOURCES PRIVATE LIMITED",
"MALDA FOOTWARES PRIVATE LIMITED",
"MALDA PROJECTS PRIVATE LIMITED",
"MALDAR SHIPYARD PRIVATE LIMITED",
"MALDEEP CATALYSTS PRIVATE LIMITED",
"MALEBENNUR FOODS PRIVATE LIMITED",
"MALEGAON MANMAD KOPARGAON INFRASTRUCTURE AND TOLL ROAD PRIVATE LIMITED",
"MALEGAON POWER SUPPLY LIMITED",
"MALEMA SENSORS INDIA PRIVATE LIMITED",
"MALENADU NUTS AND SPICES PRODUCER COMPANY LIMITED",
"MALENADU PLANTERS COFFEE CURING WORKS PRIVATE LIMITED",
"MALERKOTLA STEEL AND ALLOYS PVT LTD",
"MALERKOTLA STEEL ROLLING MILLS PVT LTD",
"MALFONIC NETWORK COMMUNICATION PRIVATE LIMITED",
"MALGANGA MAULI ENTERPRISES PRIVATE LIMITED",
"MALGANGA MILK AND AGRO PRODUCTS PRIVATE LIMITED",
"MALGRE SAFETY SOLUTIONS PRIVATE LIMITED",
"MALGUDI FOODS PRIVATE LIMITED",
"MALGUNDE BUILDCON PRIVATE LIMITED",
"MALHAN ENTERPRISES PRIVATE LIMITED",
"MALHAR AGENCY AND TRADING PRIVATE LIMITED",
"MALHAR AQUA SYSTEMS PRIVATE.LIMITED",
"MALHAR BHANDAR GRIH PRIVATE LIMITED",
"MALHAR FASHIONS (INDIA) PRIVATE LIMITED",
"MALHAR FOOD MACHINES (INDIA) PRIVATE LIMITED",
"MALHAR IMPERIAL PRIVATE LIMITED",
"MALHAR REALTORS PRIVATE LIMITED",
"MALHAR WIRES PRIVATE LIMITED",
"MALHOTRA BATTERIES PRIVATE LIMITED",
"MALHOTRA BOOK DEPOT",
"MALHOTRA BROTHERS (EXHIBITORS) PRIVATE LIMITED",
"MALHOTRA CABLES PRIVATE LIMITED",
"MALHOTRA CONSTRUCTIONS P LIMITED",
"MALHOTRA DIAMOND & GOLD PRIVATE LIMITED",
"MALHOTRA ELECTRONICS PRIVATE LIMITED",
"MALHOTRA INFRASTRUCTURE PRIVATE LIMITED",
"MALHOTRA JEWELS PRIVATE LIMITED",
"MALHOTRA LAND DEVELOPERS AND COLONISERS PRIVATE LIMITED",
"MALHOTRA LEATHER EXPORTS PRIVATE LIMITED",
"MALHOTRA LUBRICANTS PRIVATE LIMITED",
"MALHOTRA MARKETING PRIVATE LIMITED",
"MALHOTRA MEDICAL LABORATORIES PRIVATE LIMITED",
"MALHOTRA RICE INDUSTRIES PRIVATE LIMITED",
"MALHOTRA RUBBERS LIMITED",
"MALHOTRA SPINNERS PRIVATE LIMITED",
"MALHOTRA TOURS AND TRAVELS PRIVATE LIMITED",
"MALI TRACTORS PRIVATE LIMITED",
"MALI VENTURES PRIVATE LIMITED",
"MALIBHITA TEA COMPANY PRIVATE LIMITED",
"MALIBU ESTATE PRIVATE LIMITED",
"MALIBU TECH PRIVATE LIMITED",
"MALIBU WORLDCOM PRIVATE LIMITED",
"MALIDESARC PRIVATE LIMITED",
"MALIHABAD MANGO FARMER PRODUCER COMPANY LIMITED",
"MALIK & SONS TRADING PRIVATE LIMITED",
"MALIK AGENCIES PRIVATE LIMITED",
"MALIK AIRCON PRIVATE LIMITED",
"MALIK AUTO ZONE PRIVATE LIMITED",
"MALIK AUTOMOTIVES PRIVATE LIMITED",
"MALIK AUTOWORKS PRIVATE LIMITED",
"MALIK BUILDERS PRIVATE LIMITED",
"MALIK CARS PRIVATE LIMITED",
"MALIK CYCLE PARTS INDUSTRIES PRIVATE LIMITED",
"MALIK EXIM PRIVATE LIMITED",
"MALIK FEEDS INDIA PRIVATE LIMITED",
"MALIK FORGINGS PRIVATE LIMITED",
"MALIK JEWELLERS PRIVATE LIMITED",
"MALIK LIFESCIENCES PRIVATE LIMITED",
"MALIK MOTORS PRIVATE LIMITED",
"MALIK NEEDLS AND ALLIED INDUSTRIES PRIVATE LIMITED",
"MALIK POLYCHEM PRIVATE LIMITED",
"MALIK PROPERTIES LIMITED",
"MALIK PROTECTION SERVICES",
"MALIK RADIX HEALTHCARE PRIVATE LIMITED",
"MALIK RESIDENCY PRIVATE LIMITED",
"MALIK SEASONING AND SPICES PRIVATE LIMITED",
"MALIK TRADING AND INVESTMENT PRIVATE LIMITED",
"MALIK TRADING COMPANY",
"MALIK TRANSPORT PRIVATE LIMITED",
"MALIKA OVERSEAS PRIVATE LIMITED",
"MALIKA'S KANTHA COLLECTION & TRADING PVT. LTD.",
"MALIKS EXPORT PRIVATE LIMITED",
"MALIN ONE APPLIED TECHNOLOGIES PRIVATE LIMITED",
"MALINDO HOLIDAYS PRIVATE LIMITED",
"MALINENI LAKSHMAIAH WOMENS ENGINEERING COLLEGE",
"MALINI CONSTRUCTIONS PRIVATE LIMITED",
"MALINI KISHOR SANGHVI COLLEGE",
"MALIWAL ENGINEERS AND PROJECTS PRIVATE LIMITED",
"MALIWAL METALS PRIVATE LIMITED",
"MALIYAKKAL ROLLER FLOUR MILLS PRIVATE LIMITED",
"MALJ LINES PRIVATE LIMITED",
"MALKANI METALS PRIVATE LIMITED",
"MALKANS TRAINING INSTITUTE PRIVATE LIMITED",
"MALKE ESTATES PRIVATE LIMITED",
"MALKE MECHTECH PRIVATE LIMITED",
"MALKE PRIVATE LIMITED",
"MALKERA HOTELS AND RESORTS PRIVATE LIMITED",
"MALKHAN SINGH DISTRICT HOSPITAL",
"MALKHARE BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"MALKHARE SILVER CONCRETE PRIVATE LIMITED",
"MALKHED REAL ESTATE PRIVATE LIMITED",
"MALKISH JEWELS PRIVATE LIMITED",
"MALKIT AGROTECH PRIVATE LIMITED",
"MALKOH MARKETING PRIVATE LIMITED",
"MALL COMMERCIAL PVT LTD",
"MALL HOTEL LIMITED",
"MALL OF JOY PRIVATE LIMITED",
"MALLA REDDY COLLEGE OF ENGINEERING",
"MALLA REDDY COLLEGE OF ENGINEERING & TECHNOLOGY",
"MALLA REDDY INSTITUTE OF MEDICAL SCIENCES",
"MALLA REDDY INSTITUTE OF TECHNOLOGY & SCIENCE",
"MALLA REDDY MEDICAL COLLEGE FOR WOMEN",
"MALLA REDDY NARAYANA MULTISPECIALITY HOSPITAL",
"MALLA REDDY UNIVERSITY",
"MALLADI DRUGS AND PHARMACEUTICALS LIMITED",
"MALLADI SPECIALITIES LIMITED",
"MALLAIAH AND SONS EDIBLE OILS PRIVATE LIMITED",
"MALLAK OIL CHEM PRIVATE LIMITED",
"MALLAK SPECIALTIES PRIVATE LIMITED",
"MALLANI HOTELS,MOTELS AND RESTAURANTS PVT. LTD",
"MALLAREDDY HOSPITAL",
"MALLAREDDY NARAYANA MULTISPECIALTY HOSPITAL",
"MALLCOM INDIA LIMITED",
"MALLCOM SAFETY PRIVATE LIMITED",
"MALLCOM VSFT GLOVES PRIVATE LIMITED",
"MALLEKAN DAIRY AND AGRO PRIVATE LIMITED",
"MALLEMAALA ENTERTAINMENTS PRIVATE LIMITED",
"MALLEMKONDA REALITIES PRIVATE LIMITED",
"MALLES AUTOMATED AND ROBOTIC SYSTEMS PRIVATE LIMITED",
"MALLES CONSTRUCTIONS PRIVATE LIMITED",
"MALLESHWARAM WOMEN ASSO FIRST GRADE COLL",
"MALLETI PROJECTS OPC PRIVATE LIMITED",
"MALLHAR REALTORS PRIVATE LIMITED",
"MALLI POLYMERS PRIVATE LIMITED",
"MALLICK FOOD PRODUCTS PVT LTD",
"MALLICK HEEMGHAR PRIVATE LIMITED",
"MALLICK INFRA CONSTRUCTION PRIVATE LIMITED",
"MALLIGE MEDICAL CENTRE PRIVATE LIMITED",
"MALLIK ENGINEERING INDIA PRIVATE LIMITED",
"MALLIK MULTITECHNOLOGIES PRIVATE LIMITED",
"MALLIKA ALLOY CAST PRIVATE LIMITED",
"MALLIKA PROPERTIES PRIVATE LIMITED",
"MALLIKARJUN HEALTH CARE AND RESEARCH CENTRE",
"MALLIKARJUN TRANSPORTS INDIA PRIVATE LIMITED",
"MALLIKARJUNA HOSPITALITY PRIVATE LIMITED",
"MALLIKARJUNA PARBOILED BINNY RICE MILL",
"MALLINA LIFE SCIENCES PRIVATE LIMITED",
"MALLINATH COMFORTS PRIVATE LIMITED",
"MALLINATH SHARES AND STOCK PRIVATE LIMITED",
"MALLISHWARA COLD STROAGE PRIVATE LIMITED",
"MALLOC SOLUTIONS PRIVATE LIMITED",
"MALLOW TECHNOLOGIES PRIVATE LIMITED",
"MALLREDDY MEDICAL COLLEGE FOR WOMEN",
"MALLUR FLORA AND HOSPITALITY PRIVATE LIMITED",
"MALLYA ADITI INTERNATIONAL SCHOOL",
"MALLYA HOSPITAL",
"MALLYA STEEL INDUSTRIES PRIVATE LIMITED",
"MALLYA'S GENERAL FOUNDRIES PRIVATE LIMITED",
"MALMO EXPORTS PRIVATE LIMITED",
"MALMO STEELS PRIVATE LIMITED",
"MALNAD ALLOY CASTINGS PRIVATE LIMITED",
"MALNAD ELECTRICALS PRIVATE LIMITED",
"MALNAD HOMES PRIVATE LIMITED",
"MALNAD HOSPITAL AND INSTITUTE OF ONCOLOGY PRIVATE LIMITED",
"MALNAD INFOTECH PRIVATE LIMITED",
"MALNAD PRIME MACHINING TECHNOLOGIES PRIVATE LIMITED",
"MALNADY TEA ESTATES PVT LTD",
"MALODIA BUSINESS COACHING PRIVATE LIMITED",
"MALODIYA POLYTEX PRIVATE LIMITED",
"MALOMATIA INDIA TECHNOLOGY SERVICES PRIVATE LIMITED",
"MALOO CONSTRUCTIONS (INDIA) PRIVATE LIMITED",
"MALOO INVESTWISE PRIVATE LIMITED",
"MALOO MARBLES PRIVATE LIMITED",
"MALOOK CHAND FOODS PRIVATE LIMITED",
"MALOOK CHAND TEXTILE MILL LIMITED",
"MALOOK PHARMACEUTICALS PRIVATE LIMITED",
"MALORY ESTATE PRIVATE LIMITED",
"MALPANI AGROVET PRIVATE LIMITED",
"MALPANI ALLOY AND EXTRUSIONS PRIVATE",
"MALPANI AND ASSOCIATES PRIVATE LIMITED",
"MALPANI ANTENNA ELECTRONICS PRIVATE LIMITED",
"MALPANI ENTERPRISES PRIVATE LIMITED",
"MALPANI GRUH NIRMAN PRIVATE LIMITED",
"MALPANI INFERTILITY CLINIC PRIVATE LIMITED",
"MALPANI PIPES AND FITTINGS PRIVATE LIMITED",
"MALPANI PRODUCTS PRIVATE LIMITED",
"MALPANI TEA COMPANY PVT LTD",
"MALPANI VENEERS PRIVATE LIMITED",
"MALPE MANIPAL BUILDERS PRIVATE LIMITED",
"MALPEFRESH MARINE EXPORT PRIVATE LIMITED",
"MALSONS POLYMERS LIMITED",
"MALSTERS AND BLENDERS (INDIA) PRIVATE LIMITED",
"MALT SPIRITS INDIA PRIVATE LIMITED",
"MALTA CREATIONS PRIVATE LIMITED",
"MALTANB CONSTRUCTION ENGINEERS PRIVATE LIMITED",
"MALTEX MALSTERS LTD",
"MALTI ENTERPRISES",
"MALTI POLY FABRIC PRIVATE LIMITED",
"MALTI WORLD WIDE CONSULTANCY SERVICES",
"MALTOWN ELECTRICS PRIVATE LIMITED",
"MALU ELECTRODES PRIVATE LIMITED",
"MALU GLOBAL CONSUMER PRODUCTS PRIVATE LIMITED",
"MALU PAPER MILLS LIMITED",
"MALU RICE MILLS PRIVATE LIMITED",
"MALU SLEEPERS (MAHARASHTRA) PRIVATE LIMITED",
"MALU SLEEPERS PRIVATE LIMITED",
"MALUR BANGARPET HIGHWAYS LIMITED",
"MALUR LOGISTICS AND INDUSTRIAL PARKS PRIVATE LIMITED",
"MALUR TUBES PRIVATE LIMITED",
"MALVE CHEMICALS (INDIA) PRIVATE LIMITED",
"MALVIKA JEWELS PRIVATE LIMITED",
"MALVIN IT SYSTEMS INDIA PRIVATE LIMITED",
"MALVINA DEVELOPERS PRIVATE LIMITED",
"MALVIYA CHEMICALSANDPHARMACEUTICALS PVT LTD",
"MALVIYA INSTITUTE OF TECNOLOGY",
"MALVIYA NAGAR WATER SERVICES PRIVATE LIMITED",
"MALWA AGRO FOODS PRIVATE LIMITED",
"MALWA AUTO TECH PRIVATE LIMITED",
"MALWA AUTOMOBILES PRIVATE LIMITED",
"MALWA AUTOMOTIVES PRIVATE LIMITED",
"MALWA AUTOSALES PRIVATE LIMITED",
"MALWA BUILDWELL PRIVATE LIMITED",
"MALWA CARZONE PRIVATE LIMITED",
"MALWA CERAMICS PRIVATE LIMITED",
"MALWA COLD STORAGE PVT LTD",
"MALWA CONCRETE UDYOG PRIVATE LIMITED",
"MALWA DYE CHEM PRIVATE LIMITED",
"MALWA HOSPITALITY PRIVATE LIMITED",
"MALWA IMAGES PRIVATE LIMITED",
"MALWA INFRACON PRIVATE LIMITED",
"MALWA ISPAT PRIVATE LIMITED",
"MALWA MOTORS (P) LTD",
"MALWA MOTORS SALES PRIVATE. LIMITED",
"MALWA OVERSEAS LIMITED",
"MALWA OXYGEN & INDUSTRIAL GASES PRIVATE LIMITED",
"MALWA PAPER AND BOARD MILLS PRIVATE LIMITED",
"MALWA POWDERS PRIVATE LIMITED",
"MALWA POWER PRIVATE LIMITED",
"MALWA REALITIES PRIVATE LIMITED",
"MALWA RESORTS & HOTELS INDIA PRIVATE LIMITED",
"MALWA SOLAR POWER GENERATION PRIVATE LIMITED",
"MALWA STRIPS PRIVATE LIMITED",
"MALWA TRANSLAMINATION (INDIA) PVT LTD.,",
"MALWA VEHICLES PVT LTD",
"MALWA WIRES PVT LTD",
"MALWANCHAL UNIVERSITY",
"MALWAWALA ENGINEERING SERVICES PRIVATE LIMITED",
"MALWI SHIP BREAKING CO",
"MALYO ENTERPRISES PRIVATE LIMITED",
"MAM COLLEGE OF ENGINEERING",
"MAM COLLEGE OF PHARMACY",
"MAM INTERIORS PRIVATE LIMITED",
"MAM MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"MAMA GOA RESORT",
"MAMA HOME PRIVATE LIMITED",
"MAMA MEA PIZZA RESTAURANT",
"MAMA MIA FOODS PRIVATE LIMITED",
"MAMADAPUR SOLAR PRIVATE LIMITED",
"MAMAL CAPACITORS P LTD",
"MAMASHRI CARGO AND LOGISTICS PRIVATE LIMITED",
"MAMATA ACADEMY OF MEDICAL SCIENCES",
"MAMATA ENTERPRISE",
"MAMATA GENERAL AND SUPER SPECIALITY HOSPITAL",
"MAMATA MACHINERY PRIVATE LIMITED",
"MAMATA MILK AND MILK PRODUCTS PRIVATE LIMITED",
"MAMATHA ACADEMY OF MEDICAL SCIENCE AND HOSPITALS",
"MAMATHA EDUCATIONAL AND TECHNICAL SOCIETY",
"MAMATHA INFRA PRIVATE LIMITED",
"MAMATHA MEDICARE PRIVATE LIMITED",
"MAMATHA PACKAGING PRIVATE LIMITED",
"MAMB WOOLLENS PRIVATE LIMITED",
"MAMC INDUSTRIES LIMITED",
"MAMEREJ CONSTRUCTION PRIVATE LIMITED",
"MAMIDIPUDI NAGARJUNA AREA HOSPITAL MALAKPET",
"MAMIGO TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"MAMLATDAR DOLVAN",
"MAMLATDAR MUNDRA",
"MAMLATDAR OFFICE NADIAD",
"MAMLATDAR OFFICE PATDI",
"MAMLATDAR OFFICE THANGADH",
"MAMLATDAR OFFICE UMARPADA",
"MAMLATDAR OFFICE UPLETA",
"MAMLESHWAR AGRO FUEL PRIVATE LIMITED",
"MAMMIES HEALTHCARE PRODUCTS PRIVATE LIMITED",
"MAMMOET (INDIA) PRIVATE LIMITED",
"MAMMON BUILDCON PRIVATE LIMITED",
"MAMMON CONCAST PRIVATE LIMITED",
"MAMMUT BUILDING SYSTEMS INDIA PRIVATE LIMITED",
"MAMPARAMBIL RUBBER INDUSTRIES P LTD",
"MAMRAJ RETAIL LIMITED",
"MAMSAI ELECTRICALS PRIVATE LIMITED",
"MAMSYS CONSULTANCY SERVICES PRIVATE LIMITED",
"MAMTA ALUMINIUM PRIVATE LIMITED",
"MAMTA COMMERCIAL CO PRIVATE LIMITED",
"MAMTA CRAFT PRIVATE LIMITED",
"MAMTA ELECTROCASTING PRIVATE LIMITED",
"MAMTA ENGINEERING PRIVATE LIMITED",
"MAMTA FABRICS PRIVATE LIMITED",
"MAMTA GENERAL STORES",
"MAMTA GLOBAL PRIVATE LIMITED",
"MAMTA HEALTHCARE PRIVATE LIMITED",
"MAMTA HOUSING FINANCE COMPANY PRIVATE LIMITED",
"MAMTA HYGIENE PRODUCTS PRIVATE LIMITED",
"MAMTA INTERMEDIATE LTD",
"MAMTA LIGHTS INDIA PRIVATE LIMITED",
"MAMTA MAISHION MUIQUE PRIVATE LIMITED",
"MAMTA MARBLES PVT LTD",
"MAMTA MODERN SENIOR SECONDARY SCHOOL",
"MAMTA NURSING HOME PRIVATE LIMITED",
"MAMTA RAYONS PRIVATE LIMITED",
"MAMTA REFRACTORIES AND CERAMICS PRIVATE LIMITED",
"MAMTA SAGO AND STARCH PRIVATE LIMITED",
"MAMTA SEEDS",
"MAMTA SPINNERS PVT LTD",
"MAMTA STRUCTURES PRIVATE LIMITED",
"MAMTA SUPERSPECIALITY HOSPITAL",
"MAMTA TEXDYES PRIVATE LIMITED",
"MAMTA TRANSFORMERS PVT LTD",
"MAMTALAXMI SAREES PRIVATE LIMITED",
"MAMTHA JEWELLERS PRIVATE LIMITED",
"MAMUDPUR COLD STORAGE PRIVATE LIMITED",
"MAN CARE LABORATORIES PRIVATE LIMITED",
"MAN CLEARING AND FORWARDING PRIVATE LIMITED",
"MAN COTT PRIVATE LIMITED",
"MAN ELEVATORS COMPANY PRIVATE LIMITED",
"MAN ENERGY SOLUTIONS INDIA PRIVATE LIMITED",
"MAN ENTERPRISE",
"MAN FINANCE PRIVATE LIMITED",
"MAN FOODS PRIVATE LIMITED",
"MAN GLOBAL LIMITED",
"MAN INDUSTRIES INDIA LIMITED",
"MAN INFRACONSTRUCTION LIMITED",
"MAN LOGISTICS INDIA PRIVATE LIMITED",
"MAN MADE TEXTILES RESEARCH INSTITUTE",
"MAN MANDIR ALUMINIUM PRIVATE LIMITED",
"MAN MOHAN SALES AND SERVICES PVT LTD",
"MAN POWER GROUP SERVICE INDIA PRIVATE LIMITED",
"MAN PROJECTS LIMITED",
"MAN REALTORS AND HOLDINGS PRIVATE LIMITED",
"MAN SINGH AND SONS PRIVATE LTD",
"MAN TECHNOLOGIES PRIVATE LIMITED",
"MAN TRUCKS INDIA PRIVATE LIMITED",
"MAN UNITED MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"MAN VASTUCON LLP",
"MANA AYURVEDAM PRIVATE LIMITED (OPC)",
"MANA EFFLUENT TREATMENT PLANT LIMITED",
"MANA MA REAL ESTATE DEVELOPERS PRIVATE LIMITED",
"MANA PHARMA PRIVATE LIMITED",
"MANA PROJECTS PRIVATE LIMITED",
"MANA VENTURES PRIVATE LIMITED",
"MANAAR EXPORTS PRIVATE LIMITED",
"MANABARRIE TEA CO LIMITED",
"MANABS SOURCING SOLUTIONS PRIVATE LIMITED",
"MANACLE TECHNOLOGIES PRIVATE LIMITED",
"MANACLES INDUSTRIES PRIVATE LIMITED",
"MANACTIVE PACKAGING PRIVATE LIMITED",
"MANAD GREEN PRODUCTS PRIVATE LIMITED",
"MANAFULI DEVELOPERS PRIVATE LIMITED",
"MANAGALAM AGRO INDUSTRIES PRIVATE LIMITED",
"MANAGE AIR PRODUCTS(INDIA) PRIVATE LIMITED",
"MANAGE CHEMICALS PRIVATE LIMITED",
"MANAGE STAR PROPERTY & FACILITY MANAGEMENT SERVICE",
"MANAGE STAR PROPERTY & FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"MANAGED CONNECT IT SERVICES INDIA PRIVATE LIMITED",
"MANAGED TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"MANAGEMENT & ENTREPRENEURSHIP AND PROFESSIONAL SKILLS COUNCIL",
"MANAGEMENT AND GOVERNANCE CONSULTING PRIVATE LIMITED",
"MANAGEMENT DEVELOPMENT INSTITUTE",
"GHX INDIA PRIVATE LIMITED",
"MANAGEMENT MULTI TRADING PRIVATE LIMITED",
"MANAGESERVE TECHNOLOGIES INDIA PRIVATE LIMITED",
"MANAJ INFRACONSTRUCTION LIMITED",
"MANAJ TOLLWAY PRIVATE LIMITED",
"MANAK CITRUS PRODUCTS PRIVATE LIMITED",
"MANAK INFRATECH PRIVATE LIMITED",
"MANAK JEWELLERS PRIVATE LIMITED",
"MANAK SANGEMERMER PRIVATE LIMITED",
"MANAK SHAH FABRICS PRIVATE LIMITED",
"MANAK SHEETAL LLP",
"MANAK TEXTILE PRIVATE LIMITED",
"MANAKA AGROTECH PRIVATE LIMITED",
"MANAKAMNA COMPOSITES PRIVATE LIMITED",
"MANAKAMNA FLOUR MILLS PRIVATE LIMITED",
"MANAKAMNA FOOD PROCESSING PRIVATE LIMITED",
"MANAKAMNA TEA INDUSTRIES PRIVATE LIMITED",
"MANAKIN RESORTS PRIVATE LIMITED",
"MANAKKADU MASALA",
"MANAKKULAN PROMOTERS PRIVATE LIMITED",
"MANAKSHYA ASSOCIATES PRIVATE LIMITED",
"MANAKSHYA PULSES PRIVATE LIMITED",
"MANAKSIA ALUMINIUM COMPANY LIMITED",
"MANAKSIA COATED METALS & INDUSTRIES LIMITED",
"MANAKSIA STEELS LIMITED",
"MANAKTALA CHEMICALS PVT LTD",
"MANAKULA VINAYAGAR ENGINEERING COLLEGE",
"MANAKULA VINAYAGAR POLYTECHNIC COLLEGE",
"MANAKULA VINAYAGAR TECHNOLOGIES PRIVATE LIMITED",
"MANAKULAR MOTORS",
"MANALI BEAUTY CARE PRIVATE LIMITED",
"MANALI CREDIT AND SECURITIES LIMITED",
"MANALI DIGI COMMERCE PRIVATE LIMITED",
"MANALI ENTERPRISES",
"MANALI GUM INDUSTRIES PRIVATE LIMITED",
"MANALI JEWELS PRIVATE LIMITED",
"MANALI LUBRICANTS PRIVATE LIMITED",
"MANALI PETROCHEMICALS LIMITED",
"MANALI REFRIGERATION PRIVATE LIMITED",
"MANALI ROLLER FLOUR MILLS PRIVATE LIMITED",
"MANALI TRADING AND HOLDINGS PVT LTD",
"MANALTHEERAM AYURVEDIC HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED",
"MANAM BUILDERS CHENNAI PRIVATE LIMITED",
"MANAM INFOTECH PRIVATE LIMITED",
"MANAMA SUPER MARKET",
"MANAN APPARELS LIMITED",
"MANAN APPARELS PRIVATE LIMITED",
"MANAN BUSINESS CENTRE PRIVATE LIMITED",
"MANAN COTSYN PRIVATE LIMITED",
"MANAN CREATION",
"MANAN INSTITUTE FOR FERTILITY MANAGEMENT AND TEST TUBE BABY CENTER PRIVATE LIMITED",
"MANAN ISPAT AND ALLOYS PRIVATE LIMITED",
"MANAN OVERSEAS PRIVATE LIMITED",
"MANAN POLYMERS PRIVATE LIMITED",
"MANAN PRODUCTS INDIA PRIVATE LIMITED",
"MANAN TEXTECH GLOBAL PRIVATE LIMITED",
"MANAN TRADING COMPANY PRIVATE LIMITED",
"MANAN TRANSLOGISTIC PRIVATE LIMITED",
"MANAN WATER-TECH PRIVATE LIMITED",
"MANAN WELLNESS PRIVATE LIMITED",
"MANANSH INFOTECH PRIVATE LIMITED",
"MANAPPURAM AGRO FARMS LIMITED",
"MANAPPURAM ASSET FINANCE LIMITED",
"MANAPPURAM CHITS KARNATAKA PRIVATE LIMITED",
"MANAPPURAM CHITS( INDIA )LIMITED",
"MANAPPURAM COMPTECH AND CONSULTANTS LIMITED",
"MANAPPURAM CONSTRUCTION AND PROPERTIES LIMITED",
"MANAPPURAM FINANCE LIMITED",
"MANAPPURAM HOME FINANCE LIMITED",
"MANAPPURAM INSURANCE BROKERS LIMITED",
"MANAPPURAM INSURANCE BROKERS PRIVATE LIMITED",
"MANAPPURAM JEWELLERS LIMITED",
"MANAR DEVELOPERS PRIVATE LIMITED",
"MANAR TOOLS PRIVATE LIMITED",
"MANARA HEALTHCARE PRIVATE LIMITED",
"MANAS AGRO INDUSTRIES & INFRASTRUCTURE LIMITED",
"MANAS AUTOMOTIVE SYSTEMES LIMITED",
"MANAS FABRICS PRIVATE LIMITED",
"MANAS FOOTWEARS PRIVATE LIMITED",
"MANAS GEO TECH INDIA PRIVATE LIMITED",
"MANAS HOSPITALITY PRIVATE LIMITED",
"MANAS INDIA PROJECTS PRIVATE LIMITED",
"MANAS INNOVATIONS PRIVATE LIMITED",
"MANAS INSURANCE BROKERS PRIVATE LIMITED",
"MANAS LABS PRIVATE LIMITED",
"MANAS LIFESTYLE PROPERTIES PRIVATE LIMITED",
"MANAS MANTRA OUTSOURCING PRIVATE LIMITED",
"MANAS MERCHANDISE PRIVATE LIMITED",
"MANAS MICROSYSTEMS PRIVATE LIMITED",
"MANAS PAINTS & CHEMICALS PRIVATE LIMITED",
"MANAS PAPER PRODUCTS PRIVATE LIMITED",
"MANAS PROPERTIES LIMITED",
"MANAS STEELS PRIVATE LIMITED",
"MANAS SUPPLY CHAIN PRIVATE LIMITED",
"MANASA ESTATES & HOSPITALITY PRIVATE LIMITED",
"MANASA QUALITY ENTERPRISES LIMITED",
"MANASA TRADING PRIVATE LIMITED",
"MANASAVI AGRO FARM & RESEARCH PRIVATE LIMITED",
"MANASH LIFE STYLE PRIVATE LIMITED",
"MANASH LIFESTYLE PRIVATE LIMITED",
"MANASHA LOGISTICS CONSULTANCY SERVICES PRIVATE LIMITED",
"MANASHI CRAFT PVT LTD",
"MANASHI INTERIORS PRIVATE LIMITED",
"MANASHI MEDI EQUIPMENTS PRIVATE LIMITED",
"MANASHVI SECURITIES LIMITED",
"MANASI MEMORIAL HOSPITAL",
"MANASI PRESSINGS PRIVATE LIMITED",
"MANASI TECHNOFORGE PRIVATE LIMITED",
"MANASLU PROPERTIES PRIVATE LIMITED",
"MANASVI COMMUNICATIONS PRIVATE LIMITED",
"MANASVI PROJECT PRIVATE LIMITED",
"MANASWI CIVIBUILD INDIA PRIVATE LIMITED",
"MANASWINI FOODS PRIVATE LIMITED",
"MANASWINI HEALTHCARE SERVICES PRIVATE LIMITED",
"MANATEC ELECTRONICS PRIVATE LIMITED",
"MANAV AGRIFOODS PRIVATE LIMITED",
"MANAV ALLOYS PRIVATE LIMITED",
"MANAV BIO CHEM IMPEX PRIVATE LIMITED",
"MANAV BUILDERS PRIVATE LIMITED",
"MANAV CRYOGENIC GASES PRIVATE LIMITED",
"MANAV ENERGY AND STEEL PRIVATE LIMITED",
"MANAV ENERGY PRIVATE LIMITED",
"MANAV FOOTCARE PRIVATE LIMITED",
"MANAV FOREX PRIVATE LIMITED",
"MANAV GASES PRIVATE LIMITED",
"MANAV IMPORTS PRIVATE LIMITED",
"MANAV INFRA PROJECTS LIMITED",
"MANAV INFRASTRUCTURE PRIVATE LIMITED",
"MANAV INVESTMENT AND TRADING COMPANY LTD",
"MANAV JAGRUTI HIGH SCHOOL",
"MANAV KALYAN CREDIT COOPERATIVE SOCIETY LIMITED",
"MANAV MANGAL SCHOOL",
"MANAV MARKETING PRIVATE LIMITED",
"MANAV NESVI INFRASTRUCTURE PRIVATE LIMITED",
"MANAV NESVI TRENDZ PRIVATE LIMITED",
"MANAV NEURO-PSYCHIATRIC HOSPITALS PRIVATE LIMITED",
"MANAV PACKAGING INDUSTRIES PVT LTD",
"MANAV PACKAGING PRIVATE LIMITED",
"MANAV PROCESSORS PRIVATE LIMITED",
"MANAV RACHNA GLOBAL SCHOOL",
"MANAV RACHNA INTERNATIONAL INSTITUTE OF RESEARCH AND STUDIES",
"MANAV RACHNA INTERNATIONAL SCHOOL",
"MANAV RACHNA INTERNATIONAL UNIVERSITY",
"MANAV RACHNA VIDYANTARIKSHA PRIVATE LIMITED",
"MANAV RAKSHAK HOSPITALS PRIVATE LIMITED",
"MANAV RUBBER MACHINERY PRIVATE LIMITED",
"MANAV SEVARTH TRUST",
"MANAV SNACKS PRIVATE LIMITED",
"MANAV VIKAS SANSTHA",
"MANAV VIKAS SEVA SANGH",
"MANAV VIKAS VIDYALAY",
"MANAVTA HOLDINGS LIMITED",
"MANAVTA HOSPITALS PRIVATE LIMITED",
"MANAWAR KUKSHI TOLLWAYS PRIVATE LIMITED",
"MANAYLUX ENGINEERS PRIVATE LIMITED",
"MANBA FINANCE LIMITED",
"MANBHAV ENTERPRISE INDIA PRIVATE LIMITED",
"MANBHAWANI INVESTMENT LIMITED",
"MANBHUM CONSTRUCTION COMPANY PRIVATE LIMITED",
"MANBHUM ISPAT PRIVATE LIMITED",
"MANBIK GRAPHICS PVT LTD",
"MANBRO PHARMA PRIVATE LIMITED",
"MANBRO POLYMERS LIMITED",
"MANBRO SUPERMARKET PVT.LTD.",
"MANCARE HEALTH PRIVATE LIMITED",
"MANCARE LABORATORIES PRIVATE. LIMITED.",
"MANCARE PHARMACEUTICALS PRIVATE LIMITED",
"MANCARE REMEDIES PRIVATE LIMITED",
"MANCER CONSULTING SERVICES PRIVATE LIMITED.",
"MANCH TECHNOLOGIES PRIVATE LIMITED",
"MANCHAL AGRO AND POULTRY FARMS PRIVATE LIMITED",
"MANCHANDA AND MANCHANDA BUILDERS PRIVATE LIMITED",
"MANCHANDA BUILDCON PRIVATE LIMITED",
"MANCHANDA HERBAL PRODUCTS PRIVATE LIMITED",
"MANCHANDA INTERIORS PRIVATE LIMITED",
"MANCHANDA INTERNATIONAL LIMITED",
"MANCHANDA MEDICOS",
"MANCHANDA TECHNOCAST PRIVATE LIMITED",
"MANCHERIAL CEMENT COMPANY PRIVATE LIMITED",
"MANCHERIAL REPALLEWADA ROAD PRIVATE LIMITED",
"MANCHESTER FREIGHT SYSTEMS PRIVATE LIMITED",
"MANCHESTER INTERNATIONAL SCHOOL",
"MANCHESTER TEXTILE PRIVATE LIMITED",
"MANCHU TOUGHEND GLASS PRIVATE LIMITED",
"MANCHUKONDA AGROTECH PRIVATE LIMITED",
"MANCHUKONDA PRAKASHAM INDUSTRIES INDIA PRIVATE LIMITED",
"MANCO RECRUITERS INTERNATIONAL INDIA LIMITED",
"MANCOO BOX FACTORY PRIVATE LIMITED",
"MANDA MOTORS PRIVATE LIMITED",
"MANDA PROJECTS PRIVATE LIMITED",
"MANDA VIPRA INFRA PRIVATE LIMITED",
"MANDADI CONSTRUCTIONS PRIVATE LIMITED",
"MANDAKINEE BUILD AND INVESTMENT PRIVATE LIMITED",
"MANDAKINI ACCOMODATION PRIVATE LIMITED",
"MANDAKINI HEAVEN HUTS PRIVATE LIMITED",
"MANDAKINI RESEARCH FARMS PRIVATE LIMITED",
"MANDAKINI RESORTS PRIVATE LIMITED",
"MANDAKINI SAREE HOUSE PRIVATE LIMITED",
"MANDAL AGROVETS PRIVATE LIMITED",
"MANDAL CHICKEN CENTRE PRIVATE LIMITED",
"MANDAL EDIBLE PRODUCTS PRIVATE LIMITED",
"MANDAL INDUSTRIES PRIVATE LIMITED",
"MANDAL INFRASTRUCTURE PRIVATE LIMITED",
"MANDAL PARISHAD DEVELOPMENT OFFICE",
"MANDAL SEA ESTA PRIVATE LIMITED",
"MANDALA ADVISORY INDIA PRIVATE LIMITED",
"MANDALA CONSTRUCTIONS PRIVATE LIMITED",
"MANDALA EXIM PRIVATE LIMITED",
"MANDALA WELLNESS PRIVATE LIMITED",
"MANDALI GAMES PRIVATE LIMITED",
"MANDALI PACKAGING PRIVATE LIMITED",
"MANDALIA OVERSEAS CORPORATION",
"MANDALPARA GIRLS HIGH SCHOOL",
"MANDAP INTERNATIONAL PVT LTD",
"MANDAPETA DIGITAL ENTERTAINMENT PRIVATE LIMITED",
"MANDAR CLEARANCE AND FORWARDERS PRIVATE LIMITED",
"MANDAR HEALTH AND HYGIENE PRIVATE LIMITED",
"MANDAR ORGANICS PRIVATE LIMITED",
"MANDAR RICE MILLS PRIVATE LIMITED",
"MANDAR STEEL & INFRA LIMITED",
"MANDAR TRANSMISSION LIMITED",
"MANDARIN INTERNATIONAL PRIVATE LIMITED",
"MANDARK TECHNOLOGIES PRIVATE LIMITED",
"MANDAVA HOLDINGS PRIVATE LIMITED",
"MANDAVA INSTITUTE OF ENGINEERING & TECHNOLOGY",
"MANDAVYA AGROCHEM PRIVATE LIMITED",
"MANDAWEWALA CONSULTANTS PRIVATE LIMITED",
"MANDEEP GRANI MARMO PRIVATE LIMITED",
"MANDEEP INDUSTRIES",
"MANDEEP MARBLES AND STONES PRIVATE LIMITED",
"MANDEK FOUNDATION",
"MANDELASHRI INDUSTRIES PRIVATE LIMITED",
"MANDESHI FOODS PRIVATE LIMITED",
"MANDEV SURGIPHARMA PRIVATE LIMITED",
"MANDEV TUBES PRIVATE LIMITED",
"MANDEVI BUILDING MANAGEMENT SERVICES",
"MANDHAN MOTORS PRIVATE LIMITED",
"MANDHANA HARDWARE PRIVATE LIMITED",
"MANDHANA INDUSTRIES PRIVATE LIMITED",
"MANDHANA PLASTICS PRIVATE LIMITED",
"MANDHANA POLYMERS PRIVATE LIMITED",
"MANDHARDEVI ENTERPRISES PRIVATE LIMITED",
"MANDHOLIWAL INDUSTRIES PRIVATE LIMITED",
"MANDI GOBINDGARH STEELS PVT LTD",
"MANDIA POLYMERS PRIVATE LIMITED",
"MANDIAL AGRO PRIVATE LIMITED",
"MANDIANT CYBERSECURITY PRIVATE LIMITED",
"MANDKE AND MANDKE INFRASTRUCTURE PRIVATE LIMITED",
"MANDKE FOUNDATION",
"MANDKE HOSPITAL SUPPORT SERVICES LIMITED",
"MANDLA BUSINESS (INDIA) PRIVATE LIMITED",
"MANDO SOFTTECH INDIA PRIVATE LIMITED",
"MANDOM CORPORATION (INDIA) PRIVATE LIMITED",
"MANDONA HYUNDAI A UNIT OF BIMALA AUTOMOBILE PRIVATE LIMITED",
"MANDORE CLINIC PRIVATE LIMITED",
"MANDORE PHARMA PRIVATE LIMITED",
"MANDORE SUPERMARKET PRIVATE LIMITED",
"MANDORI TRADERS PRIVATE LIMITED",
"MANDOTHARI APPARELS PRIVATE LIMITED",
"MANDOVI CASTING PRIVATE LIMITED",
"MANDOVI DISTILLERIES & BREWERIES PRIVATE LIMITED",
"MANDOVI DRYDOCKS",
"MANDOVI MINERALS PRIVATE LIMITED",
"MANDOVI MOTORS PRIVATE LIMITED",
"MANDOWARA NATURAL STONES PRIVATE LIMITED",
"MANDR CONSULTANTS CORPORATION",
"MANDRAIL SEEDS PRIVATE LIMITED",
"MANDS CONSULTING PRIVATE LIMITED",
"MANDSAUR FARMER PRODUCER COMPANY LIMITED",
"MANDVI NAGARPALIKA",
"MANDVIWALA QUTUB & ASSOCIATES",
"MANDY TECHNOLOGIES PRIVATE LIMITED",
"MANDYA DIAGNOSTIC CENTRE PRIVATE LIMITED",
"MANDYA ORGANIC FOODS PRIVATE LIMITED",
"MANE INDIA PRIVATE LIMITED",
"MANE KANCOR INGREDIENTS PRIVATE LIMITED",
"MANECKJI COOPER EDUCATION TRUST SCHOOL",
"MANEESH CHEMICALS PVT LTD",
"MANEESH PHARMACEUTICALS LIMITED",
"MANEESH PIPES PRIVATE LIMITED",
"MANEESH UDYOG HEAT EXCHANGERS PRIVATE LIMITED",
"MANEESHA FINLEASE LIMITED",
"MANEK ACTIVE CLAY PRIVATE LIMITED",
"MANEK CONSULTING",
"MANEK FLURO-POLYMERS PRIVATE LIMITED",
"MANEK METAL (INDIA) PRIVATE LIMITED",
"MANEK METALCRAFT",
"MANEK OVERSEAS PRIVATE LIMITED",
"MANEK SALT WORKS PRIVATE LIMITED",
"MANEKTECH SOLUTIONS PRIVATE LIMITED",
"MANEPALLY JEWELLERS PRIVATE LIMITED",
"MANERS EVENTS AND PROMOTIONS PRIVATE LIMITED",
"MANES INTERNATIONAL SCHOOL (CBSE)",
"MANESAR STEEL PROCESSING INDIA PRIVATE LIMITED",
"MANETAIN STORE PRIVATE LIMITED",
"MANEXPIMP SURGICARE INDIA PRIVATE LIMITED",
"MANFORD ALLIANZ PRIVATE LIMITED",
"MANFRAME COMPUTERS PRIVATE LIMITED",
"MANFRED INFOTECH PRIVATE LIMITED",
"MANFRIDAY INTEGRATED SERVICES PRIVATE LIMITED",
"MANFRIDAY LIFESCIENCES PRIVATE LIMITED",
"MANGAL & MANGAL",
"MANGAL AGENCIES PRIVATE LIMITED",
"MANGAL ALLOY CASTING PRIVATE LIMITED",
"MANGAL ANAND HEALTH CARE LTD",
"MANGAL BUILDCON PRIVATE LIMITED",
"MANGAL BULLION PRIVATE LIMITED",
"MANGAL CHAND TUBES PRIVATE LIMITED",
"MANGAL COMMERCIAL PRIVATE LIMITED",
"MANGAL COMPUSOLUTION LIMITED",
"MANGAL COTTON MILLS PRIVATE LIMITED",
"MANGAL CREATION PVT LTD",
"MANGAL CREDIT AND FINCORP LIMITED",
"MANGAL DEEP COLD STORAGE PRIVATE LIMITED",
"MANGAL DEEP FABRICS PRIVATE LIMITED",
"MANGAL DEEP REAL ESTATE",
"MANGAL ELECTRICAL INDUSTRIES PRIVATE LIMITED",
"MANGAL ENERGY AND POWER PRIVATE LIMITED",
"MANGAL ENTERTAINMENT PRIVATE LIMITED",
"MANGAL FOREX AND TRAVELS PRIVATE LIMITED",
"MANGAL GEETA FASHIONS PRIVATE LIMITED",
"MANGAL GOLD PALACE PRIVATE LIMITED",
"MANGAL INDUSTRIES LIMITED",
"MANGAL INFRAESTATES PRIVATE LIMITED",
"MANGAL IRON PRIVATE LIMITED",
"MANGAL KESHAV CAPITAL LIMITED",
"MANGAL KESHAV FINANCIAL SERVICES LLP",
"MANGAL KESHAV SECURITIES LIMITED",
"MANGAL MACHINES PRIVATE LIMITED",
"MANGAL MEDICAL AGENCIES PRIVATE LIMITED",
"MANGAL MEDI-CENTRE",
"MANGAL METALS PRIVATE LIMITED",
"MANGAL MOORTI DEVELOPERS PRIVATE LIMITED",
"MANGAL MOTORS PRIVATE LIMITED",
"MANGAL MURTI FABRICS PRIVATE LIMITED",
"MANGAL MURTI SEEDS PRIVATE LIMITED",
"MANGAL PAPERS PRIVATE LIMITED",
"MANGAL PETRO INFRA PRIVATE LIMITED",
"MANGAL PLYLAM PRIVATE LIMITED",
"MANGAL POLYSACKS PRIVATE LIMITED",
"MANGAL ROYAL JEWELS PRIVATE LIMITED",
"MANGAL RUBBER PRODUCTS PVT LTD",
"MANGAL SAI TRADEWINGS PRIVATE LIMITED",
"MANGAL SHREE CREATION PRIVATE LIMITED",
"MANGAL SHREE POLYPLAST PRIVATE LIMITED",
"MANGAL SINGH BROTHERS PRIVATE LIMITED",
"MANGAL SPONGE AND STEEL PRIVATE LIMITED",
"MANGAL STORES PRIVATE LIMITED",
"MANGAL STRIPS (BOMBAY) PRIVATE LIMITED",
"MANGAL SURAKSHA PRIVATE LIMITED",
"MANGAL TEXTILE MILLS INDIA PRIVATE LIMITED",
"MANGAL TIRTH ESTATE LIMITED",
"MANGAL TRADING COMPANY",
"MANGALA ASSOCIATES PRIVATE LIMITED",
"MANGALA BHOOMI ASSOCIATES PRIVATE LIMITED",
"MANGALA COLLEGE OF PARAMEDICAL SCIENCES",
"MANGALA ISPAT (JAIPUR) LIMITED",
"MANGALA ISPAT LIMITED",
"MANGALA LOGISTIC PRIVATE LIMITED.",
"MANGALA MARINE EXIM INDIA PRIVATE LIMITED",
"MANGALA PRODUCT PRIVATE LIMITED",
"MANGALA RESOURCE MANAGEMENT PRIVATE LIMITED",
"MANGALA SHREE BUILDCON PRIVATE LIMITED",
"MANGALALAXMI INDUSTRIES PRIVATE LIMITED",
"MANGALAM ADHESIVES PRIVATE LIMITED",
"MANGALAM ADVISORY SERVICES PRIVATE LIMITED",
"MANGALAM ALLOYS LIMITED",
"MANGALAM ALLOYS LIMITED.",
"MANGALAM AUTOMOTIVES PRIVATE LIMITED",
"MANGALAM BRANDS PRIVATE LIMITED",
"MANGALAM CEMENT LIMITED",
"MANGALAM COILS PRIVATE LIMITED",
"MANGALAM DEALCOM PRIVATE LIMITED",
"MANGALAM DECORS INDIA PRIVATE LIMITED",
"MANGALAM DESIGNER PRIVATE LIMITED",
"MANGALAM DRUGS AND ORGANICS LIMITED",
"MANGALAM DURA JET TECHNOLOGIES PRIVATE LIMITED",
"MANGALAM DYECHEM PRIVATE LIMITED",
"MANGALAM ECS ENVIRONMENT PRIVATE LIMITED",
"MANGALAM EDU GATE",
"MANGALAM ENTERPRISES",
"MANGALAM EQUITY MANAGEMENT PVT LTD",
"MANGALAM ESTATES PRIVATE LIMITED",
"MANGALAM ETHNIC WEAR PRIVATE LIMITED",
"MANGALAM EXPORTBIZ PRIVATE LIMITED",
"MANGALAM FASHIONS LIMITED",
"MANGALAM FEEDS & FOODS PRIVATE LIMITED",
"MANGALAM FOODS PRIVATE LIMITED",
"MANGALAM FUELS PRIVATE LIMITED",
"MANGALAM GENERAL WORKS PRIVATE LIMITED",
"MANGALAM GLOBAL ENTERPRISE LIMITED",
"MANGALAM INDUSTRIAL FINANCE LTD",
"MANGALAM INDUSTRIES PRIVATE LIMITED",
"MANGALAM INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"MANGALAM INTERMEDIATES UNIT-2",
"MANGALAM JEEVAL CONSTRUCTION PRIVATE LIMITED",
"MANGALAM LUBRICANTS PRIVATE LIMITED",
"MANGALAM MARKETING",
"MANGALAM METALS & ORES LIMITED",
"MANGALAM MINERALS & CHEMICALS PVT LTD",
"MANGALAM MULTI BUSINESSES PRIVATE LIMITED",
"MANGALAM NUTRITIONS PRIVATE LIMITED",
"MANGALAM OIL MILLS PRIVATE LIMITED",
"MANGALAM ORGANICS LIMITED",
"MANGALAM PHOSPHATES LIMITED",
"MANGALAM PIPES PRIVATE LIMITED",
"MANGALAM PLASTIC COMPONENTS PRIVATE LIMITED",
"MANGALAM PRINTS PRIVATE LIMITED",
"MANGALAM PUBLICATIONS INDIAPRIVATE.LIMITED",
"MANGALAM RICE MILL PRIVATE LIMITED",
"MANGALAM SEEDS LIMITED",
"MANGALAM STEELCAST PRIVATE LIMITED",
"MANGALAM TEA PRODUCTS PVT LTD",
"MANGALAM TOURS AND TRAVELS",
"MANGALAM TYRES PRIVATE LIMITED",
"MANGALAM VENTURES LIMITED",
"MANGALAM VIDHYAMANDIR",
"MANGALAM WEAVETECH PRIVATE LIMITED",
"MANGALAM WEB MEDIA PRIVATE LIMITED",
"MANGALAM WOOD INDUSTRIES PVT LTD",
"MANGALAM WORLDWIDE LIMITED",
"MANGALATHU ENTERPRISES",
"MANGALAYATAN UNIVERSITY",
"MANGALCHAND ALLOYS AND REFINERIES PRIVATE LIMITED",
"MANGALDAS INFRATECH PRIVATE LIMITED",
"MANGALDAS MEHTA AND COMPANY LIMITED",
"MANGALDAS VENICHAND",
"MANGALDEEP COTTON INDUSTRIES",
"MANGALDEEP FASHIONS PRIVATE LIMITED",
"MANGALDEEP RICE MILL PRIVATE LIMITED",
"MANGALDEEP SUPERSTRUCTURES PRIVATE LIMITED",
"MANGALDEV AGRITECH PRIVATE LIMITED",
"MANGALDHAM TEX FAB PRIVATE LIMITED",
"MANGALI INDUSTRIES LIMITED",
"MANGALIK SALES & MARKETING PRIVATE LIMITED",
"MANGALMANI JEWELLERS LIMITED",
"MANGALMAY FOUNDATION TRUST",
"MANGALMOYEE MAA CHANDI MULTIPURPOSE COLD STORAGE PRIVATE LIMITED",
"MANGALMURTI ADVISORY SERVICES PRIVATE LIMITED",
"MANGALMURTI BIO-CHEM PRIVATE LIMITED",
"MANGALMURTI CONCHEM PRIVATE LIMITED",
"MANGALMURTI DEVELOPERS PRIVATE LIMITED",
"MANGALMURTI JEWELS INDIA PRIVATE LIMITED",
"MANGALMURTI MARUTI NANDAN TRADING PRIVATE LIMITED",
"MANGALMURTI POLYMERS PRIVATE LIMITED",
"MANGALMURTY MANAGEMENT CONSULTANCY PRIVATE LIMITED",
"MANGALNATH REALITY PRIVATE LIMITED",
"MANGALODAYAM PHARMACEUTICALS PRIVATE LIMITED",
"MANGALORE CHEMICALS AND FERTILISERS LIMITED",
"MANGALORE COAL TERMINAL PRIVATE LIMITED",
"MANGALORE CO-OPERATIVE TOWN BANK LTD",
"MANGALORE ELECTRICITY SUPPLY COMPANY LIMITED",
"MANGALORE ENERGIES PRIVATE LIMITED",
"MANGALORE GANESH BEEDI WORKS",
"MANGALORE HEALTHCARE PRIVATE LIMITED",
"MANGALORE HEART SCAN AND CT ANGIO CENTRE PRIVATE LIMITED",
"MANGALORE INFOTECH SOLUTIONS PRIVATE LIMITED",
"MANGALORE INSTITUTE OF ONCOLOGY PRIVATE LIMITED",
"MANGALORE INSTITUTE OF TECHNOLOGY AND ENGINEERING",
"MANGALORE INTERNET CITY PRIVATE LIMITED",
"MANGALORE LIQUID IMPEX PRIVATE LIMITED",
"MANGALORE MARINE COLLEGE & TECHNOLOGY",
"MANGALORE MINERALS PRIVATE LIMITED",
"MANGALORE PAPER MILLS PRIVATE LIMITED",
"MANGALORE PU COLLEGE",
"MANGALORE REFINERY AND PETROCHEMICALS LIMITED",
"MANGALORE RUBBERS PRIVATE LIMITED",
"MANGALORE SEA PRODUCTS",
"MANGALORE SECURITY SERVICES PRIVATE LIMITED",
"MANGALORE SEZ LIMITED",
"MANGALORE STP LIMITED",
"MANGALORE TILES LIMITED",
"MANGALORE TRAWL BOAT FISHERMANS PRIMARY CO OPERATIVE SOCIETY LIMITED",
"MANGALORE UNIVERSITY",
"MANGALPUR CEMENT PRIVATE LIMITED",
"MANGALRASHI PROMOTERS PRIVATE LIMITED",
"MANGALURU INTERNATIONAL AIRPORT LIMITED",
"MANGALURU SMART CITY LIMITED",
"MANGALWEDHA SOLAPUR HIGHWAYS PRIVATE LIMITED",
"MANGALY INDUSTRIES PRIVATE LIMITED",
"MANGALYA BUILDTECH PRIVATE LIMITED",
"MANGALYA ENTERPRISE PRIVATE LIMITED",
"MANGAT RAM DAL MILLS PRIVATE LIMITED",
"MANGATRAI PEARLS & JEWELLERS PRIVATE LIMITED",
"MANGATRAM CLEARING AND FORWARDING AGENT PRIVATE LIMITED",
"MANGATTIL MOTORS PRIVATE LIMITED",
"MANGATTIL TRADE LINKS PRIVATE LIMITED",
"MANGE RAM EDUCATIONAL & CHARITABLE TRUST",
"MANGESH VIDYA MANDIR",
"MANGILAL AGARWAL",
"MANGILAL BADRIPRASAD TRADING PRIVATE LIMITED",
"MANGILAL DUDHWALE MILK PRODUCTS PRIVATE LIMITED",
"MANGILAL NIRBAN MEDICAL SERVICES PRIVATE LIMITED",
"MANGILALL ESTATES PVT LTD",
"MANGLA AMIT BUILDERS PRIVATE LIMITED",
"MANGLA APPARELS INDIA PRIVATE LIMITED",
"MANGLA BATTERY PRIVATE LIMITED",
"MANGLA ENGINEERING LIMITED",
"MANGLA ENTERPRISES PRIVATE LIMITED",
"MANGLA HOISTS PRIVATE LIMITED",
"MANGLA INDUSTRIES PRIVATE LIMITED",
"MANGLA LPG CARRIER PRIVATE LIMITED",
"MANGLA METAL PRIVATE LIMITED",
"MANGLA OIL CARRIER PRIVATE LIMITED",
"MANGLA PIPES PRIVATE LIMITED",
"MANGLA PLYWOOD PRIVATE LIMITED",
"MANGLA REDIMIX PRIVATE LIMITED",
"MANGLA SEEDS PRIVATE LIMITED",
"MANGLA SONS",
"MANGLA STEEL UDHYOG PRIVATE LIMITED",
"MANGLA TRADERS PRIVATE LIMITED",
"MANGLA UDYOGA PRIVATE LIMITED",
"MANGLAGORI DEALERS PRIVATE LIMITED",
"MANGLAM AGRO PRIVATE LIMITED",
"MANGLAM AGROTECH PRIVATE LIMITED",
"MANGLAM ALLOYS & ISPAT PRIVATE LIMITED",
"MANGLAM APPARELS PRIVATE LIMITED",
"MANGLAM ARTS",
"MANGLAM ARTS PRIVATE LIMITED",
"MANGLAM BIOTECH PRIVATE LIMITED",
"MANGLAM BUILD-DEVELOPERS LIMITED",
"MANGLAM CERAMIC PRIVATE LIMITED",
"MANGLAM CHEMICALS PRIVATE LIMITED",
"MANGLAM CONTAINERS PRIVATE LIMITED",
"MANGLAM CORPORATION INDIA PRIVATE LIMITED",
"MANGLAM EXPRESS CARGO PRIVATE LIMITED",
"MANGLAM FAB PROCESSORS PRIVATE LIMITED",
"MANGLAM HOSPITAL",
"MANGLAM IMAGING PRIVATE LIMITED",
"MANGLAM MEDIKITS PRIVATE LIMITED",
"MANGLAM MILK INDIA PRIVATE LIMITED",
"MANGLAM MOTOBIKE PRIVATE LIMITED",
"MANGLAM PAPER PRIVATE LIMITED",
"MANGLAM PLANNERS AND CONSTRUCTION PRIVATE LIMITED",
"MANGLAM RICINUS PRIVATE LIMITED",
"MANGLAM TECHNO AIR EQUIPMENTS PRIVATE LIMITED.",
"MANGLAM TOURS & TRAVELS PRIVATE LIMITED",
"MANGLAM TRADEIMPEX (INDIA) PRIVATE LIMITED",
"MANGLAM WIRES PRIVATE LIMITED",
"MANGLAM YARN AGENCIES",
"MANGLAMG APPARELS PRIVATE LIMITED",
"MANGLAMPLUS MEDICITY HOSPITAL",
"MANGLANI INVESTMENTS PRIVATE LIMITED",
"MANGLIK PRESS PRIVATE LIMITED",
"MANGLOOR HIGHWAYS PRIVATE LIMITED",
"MANGO HOLIDAYS INDIA PRIVATE LIMITED",
"MANGO HOTELS PRIVATE LIMITED",
"MANGO MASS MEDIA PRIVATE LIMITED",
"MANGO MOTORS PRIVATE LIMITED",
"MANGO SCIENCES INDIA LLP",
"MANGO SEMICONDUCTORS INDIA PRIVATE LIMITED",
"MANGO STATIONERY PRIVATE LIMITED",
"MANGO TELECOMMUNICATION PRIVATE LIMITED",
"MANGOAPPS INDIA PRIVATE LIMITED",
"MANGOE LANE VENTURES PRIVATE LIMITED",
"MANGOES INDUSTRIES PRIVATE LIMITED",
"MANGOPEOPLE MEDIA NETWORK PRIVATE LIMITED",
"MANGOSORANGE SERVICES PRIVATE LIMITED",
"MANGOSPRING TECHNOLOGY SERVICES PRIVATE LIMITED",
"MANGOWOOD HOME DECOR PRIVATE LIMITED",
"MANGRUL KAMBE SCHEDULE CASTE SEED PRODUCER COMPANY LIMITED",
"MANGSIDESH INVESTMENTS PRIVATE LIMITED",
"MANGTURAM SARALIA FOODS PRIVATE LIMITED",
"MANGU MAL PACKAGING PRIVATE LIMITED",
"MANGUKIYA BROTHERS PROJECT PRIVATE LIMITED",
"MANGURAM SPICES PRIVATE LIMITED",
"MANHAR POLYMERS PRIVATE LIMITED",
"MANHARLAL AND COMPANY PRIVATE LIMITED",
"MANHARSH ENGINEERS PRIVATE LIMITED",
"MANHATTAN ASSOCIATES INDIA DEVELOPMENT CENTRE PRIVATE LIMITED ISC",
"MANHATTAN COMMUNICATIONS INDIA PRIVATE LIMITED",
"MANHATTAN HOSPITAL PRIVATE LIMITED",
"MANHATTAN HOSPITALITY PRIVATE LIMITED",
"MANHATTAN INDUSTRIAL PROMOTERS PRIVATE LIMITED",
"MANHATTAN INFRA SERVICES PRIVATE LIMITED",
"MANHATTAN TECH VENTURES PRIVATE LIMITED",
"MANI ALLOYS (INDIA) PRIVATE LIMITED",
"MANI BHUSAN DUTTA STEEL PRIVATE LIMITED",
"MANI EXPORT PRIVATE LIMITED",
"MANI EXPORTS",
"MANI HEART CARE PRIVATE LIMITED",
"MANI INDIA TECHNOLOGIES PRIVATE LIMITED",
"MANI JEWEL",
"MANI KANCHAN JEWELLERS PVT LTD",
"MANI KARN OWNERS ASSOCIATION",
"MANI MAHESH ISPAT PRIVATE LIMITED",
"MANI MEDICAL INDIA PRIVATE LIMITED",
"MANI MORE SYNTHETICS PRIVATE LIMITED",
"MANI MORE TEXTILES PRIVATE LIMITED",
"MANI NAGGAPPA MOTORS MADURAI PRIVATE LIMITED",
"MANI PACKAGING PVT LTD",
"MANI POWER DISTRIBUTION SYSTEMS PRIVATE LIMITED",
"MANI RAM EXPORTS PVT LTD",
"MANI RAM TUBES PRIVATE LIMITED",
"MANI SHANKAR STEEL PRIVATE LIMITED",
"MANI SQUARE LIMITED",
"MANIAM HARDWARE & STEELS PRIVATE LIMITED",
"MANIAM PROPERTIES PVT LTD",
"MANIAR DEVELOPERS PRIVATE LIMITED",
"MANIAR ELECTRICALS PRIVATE LIMITED",
"MANIAR ENGINEERS PVT LTD",
"MANIAR VEHICLES PRIVATE LIMITED",
"MANIBEN NANAVATI WOMEN'S COLLEGE",
"MANIBHADRA CERAMICS PRIVATE LIMITED",
"MANIBHADRA ELECTRICALS PRIVATE LIMITED",
"MANIBHADRA ENTERPRISES PRIVATE LIMITED",
"MANIBHADRA FERROMET PRIVATE LIMITED",
"MANIBHADRA JEWELLERS PRIVATE LIMITED",
"MANIBHADRA LIFESPACE PRIVATE LIMITED",
"MANIBHADRA MACHINE TOOLS PRIVATE LIMITED",
"MANIBHADRA SILK MILLS PRIVATE LIMITED",
"MANIBHAVNAM HOME FINANCE INDIA PRIVATE LIMITED",
"MANICKAVEL EDIBLE OILS PRIVATE LIMITED",
"MANICKBAG AUTOMOBILES PRIVATE LIMITED",
"MANICKPUR URBAN CO OP CREDIT SOC LTD",
"MANICO RESOURCES PRIVATE LIMITED",
"MANIDHARA REALTY",
"MANIDHARI ENTERPRISES PRIVATE LIMITED",
"MANIDHARI FOILS PRIVATE LIMITED",
"MANIDHARI REALTORS PRIVATE LIMITED",
"MANIDHARI SILK MILLS PRIVATE LIMITED",
"MANIDHARI TRANSPORT PRIVATE LIMITED",
"MANIDWEEP JEWELLERS",
"MANIFAB WEAVES PRIVATE LIMITED",
"MANIFICENT SOLUTIONS & SERVICES PRIVATE LIMITED",
"MANIFOLD AGRICROPS PRIVATE LIMITED",
"MANIFOLD E-CONNECT LIMITED",
"MANIFOLD IMPEX PRIVATE LIMITED",
"MANIFOLD WRAP SOLUTIONS PRIVATE LIMITED",
"MANIHAMSA POWER PROJECTS PRIVATE LTD",
"MANIHAR GEMS CREATION PRIVATE LIMITED",
"MANIHEM ENERFRA PRIVATE LIMITED",
"MANII WAY CITY DEVELOPERS PRIVATE LIMITED",
"MANIK CHAND AND SONS (JEWELLERS) PRIVATE LIMITED",
"MANIK CHAND AND SONS J PVT LTD",
"MANIK CHAND JEWELLERS & SONS PRIVATE LIMITED",
"MANIK CHAND JEWELLERS PRIVATE LIMITED",
"MANIK CHAND JEWELS (INDIA) PRIVATE LIMITED",
"MANIK CHAND NAND KISHORE JEWELLERS PRIVATE LIMITED",
"MANIK COMMERCIAL PVT LTD",
"MANIK COSPACK PRIVATE LIMITED",
"MANIK HARDWARE PRIVATE LIMITED",
"MANIK INFRATECH PRIVATE LIMITED",
"MANIK IT & INFRASTRUCTURE SERVICES PRIVATE LIMITED",
"MANIK MACHINERY MANUFACTURERS PRIVATE LIMITED",
"MANIK PRINTPACK INDIA PRIVATE LIMITED",
"MANIK STEEL RE ROLLING P LTD",
"MANIKA PLASTECH PRIVATE LIMITED",
"MANIKAM RADIATORS PRIVATE LIMITED",
"MANIKANDAN TEXTILES",
"MANIKANTA CONSTRUCTIONS",
"MANIKANTA GREEN HOMES PRIVATE LIMITED",
"MANIKAR STEEL PRIVATE LIMITED",
"MANIKARAN ANALYTICS LIMITED",
"MANIKARAN CREDIT AND LEASING COMPANY PRIVATE LIMITED",
"MANIKARAN DEALTRADE PRIVATE LIMITED",
"MANIKARAN HYDRO PRIVATE LIMITED",
"MANIKARAN INTERNATIONAL PRIVATE LIMITED",
"MANIKARAN POWER LIMITED",
"MANIKARAN ROLLER FLOUR MILLS PRIVATE LIMITED",
"MANIKARAN UTILITY SERVICES COMPANY LIMITED",
"MANIKARNIKA FILMS PRIVATE LIMITED",
"MANIKJI METACHEM PRIVATE LIMITED",
"MANIKRAJ CONSTRUCTION PRIVATE LIMITED",
"MANIK'S DREAMLAND PRIVATE LIMITED",
"MANIKS SYSTEMS PRIVATE LIMITED",
"MANIKSTU AGRO PRIVATE LIMITED",
"MANIKYA AGROTECH PRIVATE LIMITED",
"MANIKYA CREATIONS PRIVATE LIMTED",
"MANIKYAM AGRO PROCESSORS PRIVATE LIMITED",
"MANILA PHARMA PRIVATE LIMITED",
"MANILAL & SONS",
"MANILAL MANEKJI PRIVATE LIMITED",
"MANILAL PATEL CLEARING FORWARDING PRIVATE LIMITED",
"MANILAL PATEL FREIGHT SERVICES PRIVATE LIMITED",
"MANILAM INDUSTRIES PRIVATE LIMITED",
"MANIMAHESH HYDEL POWER PROJECTS COOPERATIVE SOCIETY",
"MANIMAHESH MOTOR WORKS PRIVATE LIMITED",
"MANIMALAYAR RUBBERS PVT LTD",
"MANIMUDRA VINCOM PVT LTD",
"MANINDRA METAL SUPPLIERS PRIVATE LIMITED",
"MANIOCA FOOD PRODUCTS PRIVATE LIMITED",
"MANIPAL ACADEMY OF HIGHER EDUCATION",
"MANIPAL ADVERTISING SERVICES PRIVATE LIMITED",
"MANIPAL AGTECH PRIVATE LIMITED",
"MANIPAL BANGLORE HOSPITAL",
"MANIPAL BREWING AND HOSPITALITY PRIVATE LIMITED",
"MANIPAL BUSINESS SOLUTIONS PRIVATE LIMITED",
"MANIPAL DIGITAL NETWORK LIMITED",
"MANIPAL DIGITAL SYSTEMS PRIVATE LIMITED",
"MANIPAL DOT NET PRIVATE LIMITED",
"MANIPAL EDUCATION AND MEDICAL GROUP INDIA PRIVATE LIMITED",
"MANIPAL ENERGY & INFRATECH LIMITED",
"MANIPAL GLOBAL EDUCATION SERVICES PRIVATE LIMITED",
"MANIPAL GOA CANCER HOSPITAL",
"MANIPAL GOA HOSPITAL",
"MANIPAL HEALTH ENTERPRISES PRIVATE LIMITED",
"MANIPAL HEALTH SYSTEMS PRIVATE LIMITED",
"MANIPAL HEALTHCARE PRIVATE LIMITED",
"MANIPAL HOME FINANCE LIMITED",
"MANIPAL HOSPITALS",
"MANIPAL HOSPITALS DWARKA PRIVATE LIMITED",
"MANIPAL HOSPITALS JAIPUR PRIVATE LIMITED",
"MANIPAL HOSPITALS PRIVATE LIMITED",
"MANIPAL HOUSING FINANCE SYNDICATE LIMITED",
"MANIPAL INDUSTRIES LIMITED",
"MANIPAL INTEGRATED SERVICES PRIVATE LIMITED",
"MANIPAL MEDIA NETWORK LIMITED",
"MANIPAL PACKAGING INDUSTRIES (INDIA) PRIVATE LIMITED",
"MANIPAL PLASTO PRIVATE LIMITED",
"MANIPAL PRAKASHAN LIMITED",
"MANIPAL PRESS LIMITED",
"MANIPAL RESORTS COMPANY PRIVATE LIMITED",
"MANIPAL SCHOOL",
"MANIPAL TECHNOLOGIES LIMITED",
"MANIPAL THOMAS GREG PRESS PRIVATE LIMITED",
"MANIPAL UNIVERSITY",
"JKPL UTILITY PACKAGING SOLUTIONS PRIVATE LIMITED",
"MANIPALCIGNA HEALTH INSURANCE COMPANY LIMITED",
"MANIRA ENERGY PRIVATE LIMITED",
"MANIRA INTERIORS PRIVATE LIMITED",
"MANIRAM ORGANICS PRIVATE LIMITED",
"MANIRAM STEEL PRIVATE LIMITED",
"MANIRANJAN DIESEL SALES AND SERVICE PRIVATE LIMITED",
"MANIRAT MOTORS PRIVATE LIMITED",
"MANIRATNA FOREX PRIVATE LIMITED",
"MANIRATNA INDUSTRIES PRIVATE LIMITED",
"MANIRATNA ORNAMENTS (INDIA) PRIVATE LIMITED",
"MANIRATNA STAINLESS PRIVATE LIMITED",
"MANIRATNA STEELS PRIVATE LIMITED",
"MANIRATNAM GEMS PRIVATE LIMITED",
"MANIS BAKING SOLUTIONS PRIVATE LIMITED",
"MANI'S FACILITY MANAGEMENT PRIVATE LIMITED",
"MANIS FOUNDRIES PRIVATE LIMITED",
"MANI'S RANISATI FINVEST LIMITED",
"MANISA DYEING AND PRINTING WORKS PRIVATE LIMITED",
"MANISAGAR BIO SCIENCES PRIVATE LIMITED",
"MANISH AGENCIES RETAILS PRIVATE LIMITED",
"MANISH AGRO-TECH LIMITED",
"MANISH ALUMINIUM PRIVATE LIMITED",
"MANISH BOOK DISTRIBUTORS PRIVATE LIMITED",
"MANISH BUILDWELL PRIVATE LIMITED",
"MANISH BUSINESS PRIVATE LIMITED",
"MANISH CHEMI NOVA PRIVATE LIMITED",
"MANISH CO PVT LTD",
"MANISH DESIGNER PRIVATE LIMITED",
"MANISH DYEING AND PRINTING MILLS PRIVATE LIMITED",
"MANISH ENGICORP PRIVATE LIMITED",
"MANISH FASHIONWORLD PRIVATE LIMITED",
"MANISH GOLD AND DIAMOND PRIVATE LIMITED",
"MANISH HEALTHCARE PVT. LTD.",
"MANISH IMPEX PRIVATE LIMITED",
"MANISH JEWELLERS PRIVATE LIMITED",
"MANISH KUMAR MANOJ KUMAR SAREES PRIVATE LIMITED",
"MANISH MACHINERY PRIVATE LIMITED",
"MANISH MANGLA FLAVOURS PRIVATE LIMITED",
"MANISH MATHUR VAISH",
"MANISH METAL PROCESSING & ENGINEERING COMPANY PRIVATE LIMITED",
"MANISH PACKAGING PRIVATE LIMITED",
"MANISH PRESSING COMPONENTS",
"MANISH REALITIES PRIVATE LIMITED",
"MANISH RESINS & POLYMERS PRIVATE LIMITED",
"MANISH SILK FAB PVT LTD",
"MANISH SURFACTANTS LIMITED",
"MANISH SYNTHETICS PVT LTD",
"MANISH TECHNOCRATE PRIVATE LIMITED",
"MANISH TRADING COMPANY",
"MANISH VINYLS PRIVATE LIMITED",
"MANISHA AGRO INDUSTRIES PRIVATE LIMITED",
"MANISHA ANALYTICAL LABORATORIES PRIVATE LIMITED",
"MANISHA COMPOSITEK PRIVATE LIMITED",
"MANISHA CONSTRUCTION",
"MANISHA CONSTRUCTIONS PRIVATE LIMITED",
"MANISHA ELECTRICALS AND ENGINEERS PRIVATE LIMITED",
"MANISHA ELITE REALTY PRIVATE LIMITED",
"MANISHA ENGINEERS PRIVATE LIMITED",
"MANISHA EXIM PRIVATE LIMITED",
"MANISHA INFRACON PROJECTS PRIVATE LIMITED",
"MANISHA INFRASTRUCTURE PRIVATE LIMITED",
"MANISHA INTERNATIONAL PRIVATE LIMITED",
"MANISHA LIFESPACES CONSULTING PRIVATE LIMITED",
"MANISHA OVERSEAS PRIVATE LIMITED",
"MANISHA PACKAGING",
"MANISHA PEB & EQUIPMENTS PRIVATE LIMITED",
"MANISHA PHARMO PLAST PRIVATE LIMITED",
"MANISHA PROJECTS PRIVATE LIMITED",
"MANISHA SPINNING MILLS PRIVATE LIMITED",
"MANISHA TEXTILES PRIVATE LIMITED",
"MANISHA WIRES PRIVATE LIMITED",
"MANISHANKAR MINERALS PRIVATE LIMITED",
"MANISHANKAR OILS PRIVATE LIMITED",
"MANISHANKER TRADING PRIVATE LIMITED",
"MANISHRENI FERROALLOYS PRIVATE LIMITED",
"MANISHRI REFRACTORIES AND CERAMICS PRIVATE LIMITED",
"MANISONS MARKETING PRIVATE LIMITED",
"MANISSHA PACKAGING PRIVATE LIMITED",
"MANIT APPARELS PRIVATE LIMITED",
"MANITEJA RICE MILLS PRIVATE LIMITED",
"MANITOU SOUTH ASIA",
"MANITOU SOUTH ASIA PRIVATE LIMITED",
"MANITOWOC INDIA PRIVATE LIMITED",
"MANIVAL EXIM PRIVATE LIMITED",
"MANIVEERA STRUCTURE PRIVATE LIMITED",
"MANIYA CONSULTANCY SERVICES PRIVATE LIMITED",
"MANIYANK PACKAGING PRIVATE LIMITED",
"MANIYAR AGRO MILLS PRIVATE LIMITED",
"MANIYAR COMMERCIAL SERVICES PRIVATE LIMITED",
"MANIYAR REFINERY PRIVATE LIMITED",
"MANIYAR SYNTHETICS PRIVATE LIMITED",
"MANJAL GRANITES AND STONES PRIVATE LIMITED",
"MANJALY VENTURES INDIA PRIVATE LIMITED",
"MANJARA KRUSHI PRODUCER COMPANY LIMITED",
"MANJARA SHETKARI SAHAKARI SAKHAR KARKHANA LTD",
"MANJARI AGRO INDUSTRIES PRIVATE LIMITED",
"MANJARI FOUNDATION",
"MANJARI RURAL LIVELIHOOD SERVICES PRIVATE LIMITED",
"MANJEERA CONSTRUCTIONS LIMITED",
"MANJEERA ESTATES PRIVATE LIMITED",
"MANJEERA HOSPITALITY RAJAHMUNDRY PRIVATE LIMITED",
"MANJEET COTTON PRIVATE LIMITED",
"MANJEET ELECTRONICS PRIVATE LIMITED",
"MANJEET FIBERS PRIVATE LIMITED",
"MANJEET GLOBAL PRIVATE LIMITED",
"MANJEET LOGISTICS PRIVATE LIMITED",
"MANJHU AUTOMOBILES PRIVATE LIMITED",
"MANJIL HOTELS PVT LTD",
"MANJILAS FOOD AND BEVERAGES PRIVATE LIMITED",
"MANJILAS FOOD TECH PRIVATE LIMITED",
"MANJIRA FINANCE PRIVATE LIMITED",
"MANJIRA MACHINE BUILDERS PRIVATE LIMITED",
"MANJOLLY CREATION PRIVATE LIMITED",
"MANJRI DEVELOPERS PRIVATE LIMITED",
"MANJRI DYEING AND PRINTING WORKS PRIVATE LIMITED",
"MANJRI HORSE BREEDERS' FARM PRIVATE LIMITED",
"MANJU CHEMICALS PRIVATE LIMITED",
"MANJU CONCRETE FABRICATORS AND DEVELOPERS PRIVATE LIMITED",
"MANJU DYEING AND PRINTING MILLS PRIVATE LIMITED",
"MANJU EXIM PRIVATE LIMITED",
"MANJU FOUNDATIONS PRIVATE LIMITED",
"MANJU INTERTEX PRIVATE LIMITED",
"MANJU LAKSHMI ASSOCIATES PRIVATE LIMITED",
"MANJU MANUFACTURERS PRIVATE LIMITED",
"MANJU MOTORS PRIVATE LIMITED",
"MANJU SATYA PRAKASH INFRATECH PRIVATE LIMITED",
"MANJU SHREE SYNTEX PRIVATE LIMITED",
"MANJU SURGIKRAFT PRIVATE LIMITED",
"MANJUL PUBLISHING HOUSE PRIVATE LIMITED",
"MANJULA ENTERPRISES PRIVATE LIMITED",
"MANJULA HOTELS PVT LTD",
"MANJUNATH AUTOMOBILES PRIVATE LIMITED",
"MANJUNATH TYRESOLES TREADS PRIVATE LIMITED",
"MANJUSHA HEALTHCARE PRIVATE LIMITED",
"MANJUSHA RASAYAN PRIVATE LIMITED",
"MANJUSHA VENTURES PRIVATE LIMITED",
"MANJUSHREE AGRICULTURE PROJECTS PRIVATE LIMITED",
"MANJUSHREE FINTUBE PRIVATE LIMITED",
"MANJUSHREE HEAT TECH PRIVATE LIMITED",
"MANJUSHREE HOTELS AND RESORTS PRIVATE LIMITED",
"MANJUSHREE INNOVATIONS PRIVATE LIMITED",
"MANJUSHREE NURSING HOME PRIVATE LIMITED",
"MANJUSHREE PLANTATIONS LIMITED",
"MANJUSHREE PLASTICS PVT LTD",
"MANJUSHREE POLYMERS PVT LTD,",
"MANJUSHREE PROPERTIES PRIVATE LIMITED",
"MANJUSHREE STRECH-FILM PRIVATE LIMITED",
"MANJUSHREE TECHNOPACK LIMITED",
"MANJUSHREE UNITED CAPITAL PRIVATE LIMITED",
"MANKAD AND ASSOCIATES INSURANCE BROKING PRIVATE LIMITED",
"MANKAM BUSINESS ASSOCIATES PRIVATE LIMITED",
"MANKAMAL ENTERPRISE PRIVATE LIMITED",
"MANKAMESHWAR STEELS PRIVATE LIMITED",
"MANKAMESHWAR STEELS UNIT-II PRIVATE LIMITED",
"MANKAPUR SEEDS CO. PRIVATE LIMITED",
"MANKARA SOFTWARE SERVICES PRIVATE LIMITED",
"MANKARI FOREX PRIVATE LIMITED",
"MANKASIA STEEL PRIVATE LIMITED",
"MANKASTU IMPEX PRIVATE LIMITED",
"MANKHA ELECTROTECH PRIVATE LIMITED",
"MANKIEWICZ INDIA PRIVATE LIMITED",
"MANKIND LIFE SCIENCES PRIVATE LIMITED",
"MANKIND PHARMA LIMITED",
"MANKIND PRIME LABS PRIVATE LIMITED",
"MANKIRAN ELECTRONICS PRIVATE LIMITED",
"MANKO NATURAL FLAVOURS AND EXTRACTS PRIVATE LIMITED",
"MANKOO INDIA PVT LTD",
"MANKU AGRO TECH PRIVATE LIMITED",
"MANLAKSH ENTERPRISES PRIVATE LIMITED",
"MANLEO FOODS PRIVATE LIMITED",
"MANLIFE TRADING PRIVATE LIMITED",
"MANLIFT INDIA PRIVATE LIMITED",
"MANLOG LOGISTICS (SOUTH INDIA) PRIVATE LIMITED",
"MANLON ENGINEERS PRIVATE LIMITED",
"MANLOVA DEALCOM PRIVATE LIMITED",
"MANLY SILICON STEEL PRIVATE LIMITED",
"MANMACHINE CAR CARE PRIVATE LIMITED",
"MANMACHINE MANAGEMENT PRIVATE LIMITED",
"MANMACHINE SOLUTIONS PRIVATE LIMITED",
"MANMACHINE WORKS PRIVATE LIMITED",
"MANMAN MANUFACTURING COMPANY PRIVATE LIMITED",
"MANMANDIR JEWELS & DIAMONDS PRIVATE LIMITED",
"MANMANDIR MILK & AGRO PRODUCTS PRIVATE LIMITED",
"MAN-MANDIR SHELTER PRIVATE LIMITED",
"MANMANTRA INFRACON LLP",
"MANMARK APPARELS PRIVATE LIMITED",
"MANMATH RESOURCES PRIVATE LIMITED",
"MANMATHA NATH KUNDU & SONS",
"MANMEET ALLOYS PRIVATE LIMITED",
"MANMEET ISPAT PRIVATE LIMITED",
"MANMET ENGINEERING PRODUCTS PRIVATE LIMITED",
"MANMOHAK FASHION PRIVATE LIMITED",
"MANMOHAN BESAN MILL PRIVATE LIMITED",
"MANMOHAN COMMERCIALS LIMITED",
"MANMOHAN EXPORTS PRIVATE LIMITED",
"MANMOHAN GINNING INDUSTRIES.",
"MANMOHAN ISPAT PRIVATE LIMITED",
"MANMOHAN MINERAL INDUSTRIES PRIVATE LIMITED",
"MANMOHAN MINERALS & CHEMICALS PRIVATE LIMITED",
"MANMOHAN SHARMA & ASSCOCIATES",
"MANMOHAN SINGH MARKETING (INDIA) PRIVATE LIMITED",
"MANMOHAN SINGH WADHWA CONSTRUCTIONS PRIVATE LIMITED",
"MANMOHINI ACADEMIC INSTITUTION",
"MANMOHINI HEALTH CARE PRIVATE LIMITED",
"MANMOHINI TEXTILE PRIVATE LIMITED",
"MANN AND HUMMEL FILTER PRIVATE LIMITED",
"MANN CONSULTANCY PRIVATE LIMITED",
"MANN FEEDS PRIVATE LIMITED",
"MANN FOREX AND AIR TICKETING PRIVATE LIMITED",
"MANN MEDICITI WELLNESS CENTRE PRIVATE LIMITED",
"MANN ORNA PRIVATE LIMITED",
"MANN RESIDENCY PRIVATE LIMITED",
"MANN TOURIST TRANSPORT SERVICE PRIVATE LIMITED",
"MANNA FOODS PRIVATE LIMITED",
"MANNA SHIPPING AND LOGISTICS PRIVATE LIMITED",
"MANNALAL RAJENDRA PRASAD IMPEX PRIVATE LIMITED",
"MANNAN FOAM INDUSTRIES PRIVATE LIMITED",
"MANNAR CRAFT PRIVATE LIMITED",
"MANNARA TECHNOLOGIES PRIVATE LIMITED",
"MANNARA TRADING PRIVATE LIMITED",
"MANNARIAH & SONS PRIVATE LIMITED",
"MANNARKKAD GOLD PRIVATE LIMITED",
"MANNARKKAD HOTELS PRIVATE LIMITED",
"MANNARKKAD STEELS PRIVATE LIMITED",
"MANNAT EMBROIDERY PRIVATE LIMITED",
"MANNAT GROUP OF HOTELS PRIVATE LIMITED",
"MANNAT INDUSTRIES",
"MANNAT LEISURE PRIVATE LIMITED",
"MANNAT STEEL PRIVATE LIMITED",
"MANNCO LOGISTIX PRIVATE LIMITED",
"MANNCOTTA HOLDINGS PVT LTD",
"MANNE PROJECTS PRIVATE LIMITED",
"MANNEQUIN PHARMACEUTICALS PRIVATE LIMITED",
"MANNI LAL MAHADEO PRASAD PRIVATE LIMITED",
"MANNIL TRADECOMM PRIVATE LIMITED",
"MANNING RECRUITMENT SOLUTIONS INDIA PRIVATE LIMITED",
"MANNIX INSTRUMENTS PRIVATE LIMITED",
"MANNK FOODS (INDIA) PRIVATE LIMITED",
"MANNLOWE INFORMATION SERVICES PRIVATE LIMITED",
"MANNOHAR LAL HIRA LAL PRIVATE LIMITED",
"MANN'S FROZEN FOODS PRIVATE LIMITED",
"MANNYA TECHNO SOLUTIONS OPC PRIVATE LIMITED",
"MANO INFOWAYS PRIVATE LIMITED",
"MANO PROJECT CONSULTANTS PRIVATE LIMITED",
"MANOCHA POLYMERS LIMITED",
"MANOCHA TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"MANOEUVRE EDUCATION PRIVATE LIMITED",
"MANOGYAM E-COMMERCE PRIVATE LIMITED",
"MANOHAR AQUA FARMS PRIVATE LIMITED",
"MANOHAR AUTO PRIVATE LIMITED",
"MANOHAR BHUSHAN INTER COLLEGE BAREILLY",
"MANOHAR BOOK DEPOT PRIVATE LIMITED",
"MANOHAR CANISTERS PVT LTD",
"MANOHAR CAPITAL MARKETS LIMITED",
"MANOHAR COLD STORAGE AND GENERAL MILLS LIMITED",
"MANOHAR ELECTRODES PRIVATE LIMITED",
"MANOHAR FABRICS P LTD",
"MANOHAR FILAMENTS PRIVATE LIMITED",
"MANOHAR FOOTWEARS PRIVATE LIMITED",
"MANOHAR INFRASTRUCTURE AND CONSTRUCTIONS PRIVATE LIMITED",
"MANOHAR LAL SARRAF AND SONS JEWELLERS PRIVATE LIMITED",
"MANOHAR MANAK ALLOYS PRIVATE LIMITED",
"MANOHAR MERCHANDISE PRIVATE LIMITED",
"MANOHAR PACKAGINGS PRIVATE LIMITED",
"MANOHAR RETAIL INDIA PRIVATE LIMITED",
"MANOHAR SARDA FOODS PRIVATE LIMITED",
"MANOHAR SILK AND SAREES PRIVATE LIMITED",
"MANOHARLAL SANTRAM HIRING PRIVATE LIMITED",
"MANOHARLAL SANTRAM TRANSPORT PRIVATE LIMITED.",
"MANOJ AGRO PRIVATE LIMITED",
"MANOJ BABUJI EXPORTS INDIA PRIVATE LIMITED",
"MANOJ BROTHERS PRIVATE LIMITED",
"MANOJ CERAMIC LIMITED",
"MANOJ DESIGNS PRIVATE LIMITED",
"MANOJ DYEING PRIVATE LIMITED",
"MANOJ FABCRAFT INDIA PRIVATE LIMITED",
"MANOJ FINANCIAL SERVICES PRIVATE LIMITED",
"MANOJ FINVEST PRIVATE LIMITED",
"MANOJ FIRE EQUIPMENTS PRIVATE LIMITED",
"MANOJ FOREX AND ORNAMENTS PRIVATE LIMITED",
"MANOJ INFRACON PRIVATE LIMITED",
"MANOJ INFRAWORK PRIVATE LIMITED",
"MANOJ JEWELLERS LIMITED",
"MANOJ KUMAR RICE MILLS PRIVATE LIMITED",
"MANOJ KUMAR SINGH CONSTRUCTION PRIVARE LIMITED",
"MANOJ LUMBERS PRIVATE LIMITED",
"MANOJ MANGLA AND MANISH MANGLA WARE HOUSE",
"MANOJ MEDISALES PRIVATE LIMITED",
"MANOJ MOTORS PRIVATE LIMITED",
"MANOJ MULTI FOODS PRIVATE LIMITED",
"MANOJ ORNAMENTS PRIVATE LIMITED",
"MANOJ PRINTS PRIVATE LIMITED",
"MANOJ STONE INFRA PRIVATE LIMITED",
"MANOJ TRADING CO.",
"MANOJ VAIBHAV GEMS 'N' JEWELLERS LIMITED",
"MANOJ VAIBHAV GEMS N JEWELLERS PRIVATE LIMITED",
"MANOJ VAIBHAV JEWELLERS PRIVATE LIMITED",
"MANOJKRISHNA ENGINEERING WORKS PRIVATE LIMITED",
"MANOKAMANA AGROTECH PRIVATE LIMITED",
"MANOKAMNA METALS PRIVATE LIMITED",
"MANOKESH INDUSTRIES PRIVATE LIMITED",
"MANOKRISHNA INTERNATIONAL PRIVATE LIMITED",
"MANOMAV ENGINEERS PRIVATE LIMITED",
"MANOMAY HEALTHCARE PRIVATE LIMITED",
"MANOMAY PAPER PACKAGING PRIVATE LIMITED",
"MANOMAY PHARMACEUTICALS PRIVATE LIMITED",
"MANOMAY TEX INDIA LIMITED",
"MANOMAY TEX INDIA PRIVATE LIMITED",
"MANOMETER (INDIA) PRIVATE LIMITED",
"MANONE HOSPITALITY PRIVATE LIMITED",
"MANONE INDIA PRIVATE LIMITED",
"MANONMANI VILASAM PRESS PRIVATE LIMITED",
"MANOPRE TELECOM INDIA PRIVATE LIMITED",
"MANOR & MEWS PRIVATE LIMITED",
"MANOR ENTERPRISES PRIVATE LIMITED",
"MANOR FINLEASE PRIVATE LIMITED",
"MANOR HOTELS PRIVATE LIMITED",
"MANOR HOUSE DEVELOPMENTS PRIVATE LIMITED",
"MANOR INFORMATION AND MANAGEMENT SERVICES PRIVATE LIMITED",
"MANOR VYAPAAR PVT LTD",
"MANORAMA HOSPITEX PRIVATE LIMITED",
"MANORAMA INDUSTRIES LIMITED",
"MANORAMA INFOSOLUTIONS PRIVATE LIMITED",
"MANORAMA MEDICARE PRIVATE LIMITED",
"MANORAMA MEMORIAL ENGLISH MEDIUM SCHOOL",
"MANORAMA OXYGEN PRIVATE LIMITED",
"MANORAMA ROPES INDIA PRIVATE LIMITED",
"MANORAMA WEB SOLUTIONS PRIVATE LIMITED",
"MANORANJAN GRAH LIMITED",
"MANORATH DEVELOPERS PRIVATE LIMITED",
"MANORATH LOGISTICS PRIVATE LIMITED",
"MANORATH SERVICES PVT LTD",
"MANORIA HEART CARE CENTRE PRIVATE LIMITED",
"MANORIT ENGINEERING CONSULTANCY & SUPPLY PRIVATE LIMITED",
"MANPASAND AGRO FOOD PRIVATE LIMITED",
"MANPASAND GYMKHANA PRIVATE LIMITED",
"MANPHOOL EXPORTS LTD",
"MANPHUL TRADING AND FINANCE COMPANY PRIVATE LIMITED",
"MANPOWER INFRA PROJECTS PRIVATE LIMITED",
"MANPOWER RESOURCES INDIA PRIVATE LIMITED",
"MANPOWER SECURITY SERVICES PRIVATE LIMITED",
"MANPOWERGROUP SERVICES INDIA PRIVATE LIMITED",
"MANPRO EQUIPMENTS PRIVATE LIMITED",
"MANQUE GLOBAL SERVICES PRIVATE LIMITED",
"MANRAJ AUTOMOBILES PRIVATE LIMITED",
"MANRAJ JEWELLERS PRIVATE LIMITED",
"MANRAJ MOTORS PRIVATE LIMITED",
"MANRAS TECHNOLOGIES PRIVATE LIMITED",
"MANRATAN RETAILS PRIVATE LIMITED",
"MANREK SERVICES",
"MANRO FINANCE & TRADERS PVT LTD",
"MANROLAND GOSS WEB SYSTEMS (INDIA) PRIVATE LIMITED",
"MANROLAND INDIA PRIVATE LIMITED",
"MANRULAN ENGINEERING AND INNOVATIONS PRIVATE LIMITED",
"MANSA ELECTRICALS PRIVATE LIMITED",
"MANSA FOODS PRIVATE LIMITED",
"MANSA INDUSTRIES PRIVATE LIMITED",
"MANSA INFOTECH PRIVATE LIMITED",
"MANSA MATA FINANCE PRIVATE LIMITED",
"MANSA PACKERS PVT LTD",
"MANSA PRINT AND PUBLISHERS LIMITED",
"MANSA RAM AGRO FOODS PRIVATE LIMITED",
"MANSA RAM MAHAJAN FURNISHINGS PRIVATE LIMITED",
"MANSA SALON PRIVATE LIMITED",
"MANSA STEELS PVT LTD",
"MANSA VINCOM PVT.LTD.",
"MANSAROVAR AGRO SACKS PRIVATE LIMITED",
"MANSAROVAR FABRICS PRIVATE LIMITED",
"MANSAROVAR FERROUS PRIVATE LIMITED",
"MANSAROVAR FOODIES PRIVATE LIMITED",
"MANSAROVAR FORGINGS PRIVATE LIMITED",
"MANSAROVAR HATCHERIES PRIVATE LIMITED",
"MANSAROVAR HOSPITAL",
"MANSAROVAR LOGISTICS PVT LTD",
"MANSAROVAR MEDICAL CENTRE PRIVATE LIMITED",
"MANSAROVAR NIRMAN PRIVATE LIMITED",
"MANSAROVAR OUTDOORS PRIVATE LIMITED",
"MANSAROVAR ROLLER FLOUR MILLS PRIVATE LIMITED",
"MANSAROVAR TEA PRIVATE LIMITED",
"MANSAROVER FURNISHINGS PRIVATE LIMITED",
"MANSAROVER HEALTHCARE PRIVATE LIMITED",
"MANSAROVER INFRABUILD PRIVATE LIMITED",
"MANSAROWAR ISPAT (INDIA) PRIVATE LIMITED",
"MANSCHAFT IT PRIVATE LIMITED",
"MANSETA INDUSTRIES PRIVATE LIMITED",
"MANSFIELD CABLES COMPANY LIMITED",
"MANSH ENGINEERS PVT LTD",
"MANSHA AGENCIES PRIVATE LIMITED",
"MANSHA AUTO SERVICES PRIVATE LIMITED",
"MANSHA BUILDCON PVT LTD",
"MANSHA JEWELLERY PRIVATE LIMITED",
"MANSHA JUTE PRIVATE LIMITED",
"MANSHA PLASTIC PRIVATE LIMITED",
"MANSHA VACUUM EQUIPMENTS PRIVATE LIMITED",
"MANSHA VACUUM TECHNOLOGIES PRIVATE LIMITED",
"MANSHAA COTFAB PRIVATE LIMITED",
"MANSHAPURN KARNI MATA ROPEWAY PRIVATE LIMITED",
"MANSHAPURNA CHAINS PRIVATE LIMITED",
"MANSHI ENTERPRISE",
"MANSHU COMTEL PRIVATE LIMITED",
"MANSHYA ENVIRO-BIOTECH PRIVATE LIMITED",
"MANSHYA FERTILIZERS PRIVATE LIMITED",
"MANSHYA MARKETING PRIVATE LIMITED",
"MANSI AUTOCARE PRIVATE LIMITED",
"MANSI CATTELFEED PRIVATE LIMITED",
"MANSI FINANCE (CHENNAI) LIMITED",
"MANSI FOOTWEAR PVT.LTD",
"MANSI FOUNDATION PRIVATE LIMITED",
"MANSI GANGA BUILDERS & ENGINEERS PRIVATE LIMITED",
"MANSI INFRACON PRIVATE LIMITED",
"MANSI INTERIORS PRIVATE LIMITED",
"MANSI MANUFACTURER AND SERVICES PRIVATE LIMITED",
"MANSI PAPER PRODUCTS PVT LTD",
"MANSI POLYMERS PVT LTD",
"MANSI PRINTS PRIVATE LIMITED",
"MANSI SHARE AND STOCK ADVISORS PRIVATE LIMITED",
"MANSIK CHIKITSALAYA VARANASI",
"MANSINGH HOTELS AND RESORTS LIMITED",
"MANSION CABLE NETWORK PRIVATE LIMITED",
"MANSON PACKAGING PRIVATE LIMITED",
"MANSONS INTERNATIONAL PRIVATE LIMITED",
"MANSOON SEEDS PRIVATE LIMITED",
"MANSOON TRADING COMPANY LIMITED",
"MANSOORI WELDARC (INDIA) PRIVATE LIMITED",
"MANSOR FOODS INDIA PRIVATE LIMITED",
"MANSOUL COMMERCIAL PVT.LTD.",
"MANSU CHEMICAL INDUSTRIES PRIVATE LIMITED",
"MANSUKH ADVISORY PVT LTD",
"MANSUKH COMMODITY FUTURES PRIVATE LIMITED",
"MANSUKH DISTRIBUTORS PRIVATE LIMITED",
"MANSUKH FINANCIAL PRIVATE LIMITED",
"MANSUKH FINVEST LIMITED",
"MANSUKH IFSC BROKING PRIVATE LIMITED",
"MANSUKH SECURITIES AND FINANCE LIMITED",
"MANSUKH SECURITIES AND FINANCE LIMITED FARIDABAD",
"MANSUKH STOCK BROKERS LIMITED",
"MANSUKHBHAI INDUSTRIES LIMITED",
"MANSUN CONSULTANCY PRIVATE LIMITED",
"MANSUR HABIBULLAH MEMORIAL SCHOOL",
"MANSYCOM CONSULTANTS PRIVATE LIMITED",
"MANTARAM SERVICE PRIVATE LIMITED",
"MANTARAY DIGICOM PRIVATE LIMITED",
"MANTARO NETWORK PRIVATE LIMITED",
"MANTAVYA NEWS PRIVATE LIMITED",
"MANTAVYA SEEDS PRIVATE LIMITED",
"MANTEC CONSULTANTS PRIVATE LIMITED",
"MANTEC INDIA SECURICOR PRIVATE LIMITED",
"MANTECH AUTOMATION PRIVATE LIMITED",
"MANTECH INTELLISYS PRIVATE LIMITED",
"MANTECH LIFE SCIENCES PRIVATE LIMITED",
"MANTENA INFRASOL PRIVATE LIMITED",
"MANTENA INFRATECH PRIVATE LIMITED",
"MANTH GREEN PRIVATE LIMITED",
"MANTHAK BUSINESS SOLUTIONS PRIVATE LIMITED",
"MANTHAN BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"MANTHAN INTERNATIONAL SCHOOL",
"MANTHAN MILK PRODUCTS PRIVATE LIMITED",
"MANTHAN REALTY VENTURES PRIVATE LIMITED",
"MANTHARAGIRI TEXTILES",
"MANTIS TECHNOLOGIES PRIVATE LIMITED",
"MANTISSA INFOTECH PRIVATE LIMITED",
"MANTLE SOLUTIONS PRIVATE LIMITED",
"MANTOOR INFRASTRUCTUTRE PRIVATE LIMITED",
"MANTORA OIL PRODUCTS PRIVATE LIMITED",
"MANTORA PUBLIC SCHOOL",
"MANTRA",
"MANTRA EVENTS AND PROMOTIONS PRIVATE LIMITED",
"MANTRA EXPORTS PRIVATE LIMITED",
"MANTRA INDUSTRIES LIMITED",
"MANTRA IT SYSTEMS PRIVATE LIMITED",
"MANTRA KINGDOM PRIVATE LIMITED",
"MANTRA LABS PRIVATE LIMITED",
"MANTRA LIFESTYLE HOMES PRIVATE LIMITED",
"MANTRA MINERALS PRIVATE LIMITED",
"MANTRA ONE ASSOCIATES PRIVATE LIMITED",
"MANTRA PROPERTIES AND DEVELOPERS PRIVATE LIMITED",
"MANTRA RESORTS PRIVATE LIMITED",
"MANTRA SEA AND AIR LOGISTICS PRIVATE LIMITED",
"MANTRA SOCIAL SERVICES",
"MANTRA SOFTECH INDIA PRIVATE LIMITED",
"MANTRA TECHNOLOGIES PRIVATE LIMITED",
"MANTRA VASTU PRIVATE LIMITED",
"MANTRALAYA",
"MANTRAM INDUSTRIES PRIVATE LIMITED",
"MANTRAM TECHNOFAB PRIVATE LIMITED",
"MANTRAWORK PRIVATE LIMITED",
"MANTRI AUTO COMPONENTS PRIVATE LIMITED",
"MANTRI DEVELOPERS PRIVATE LIMITED",
"MANTRI FOODS AND FOREX PRIVATE LIMITED",
"MANTRI GARDENVIEW HOMES P. LIMITED",
"MANTRI HEALTHCARE PRIVATE LIMITED",
"MANTRI INFRASTRUCTURE PRIVATE LIMITED",
"MANTRI LEASING AND FINANCE PVT LTD",
"MANTRI MARKETING PRIVATE LIMITED",
"MANTRI METALLICS PRIVATE LIMITED",
"MANTRI TEA COMPANY PRIVATE LIMITED",
"MANTRI TRADING PRIVATE LIMITED",
"MANTRI WAREHOUSING AND PACKAGING PRIVATE LIMITED",
"MANTTRA SOURCING SERVICES PRIVATE LIMITED",
"MANTURAM INFRASTRUCTURE PRIVATE LIMITED",
"MANU & COMPANY",
"MANU BHATIA WEALTH ADVISORS PRIVATE LIMITED",
"MANU ELECTRICALS PRIVATE LIMITED",
"MANU FASHIONS PRIVATE LIMITED",
"MANU FOOD PRODUCTS PRIVATE LIMITED",
"MANU HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED",
"MANU HOSPITALITY INDIA PRIVATE LIMITED",
"MANU IMPEX PRIVATE LIMITED",
"MANU LAW CLASSES PRIVATE LIMITED",
"MANU MAHARANI HOTELS LIMITED",
"MANU MANDIR JUNIOR HIGH SCHOOL GURUKUL KANGRI HARI",
"MANU MECHANICAL WORKS PRIVATE LIMITED",
"MANU PRAKASHAN PRIVATE LIMITED",
"MANU STOCK BROKING PRIVATE LIMITED",
"MANU TILING COMPANY PRIVATE LIMITED",
"MANU TRADERS PRIVATE LIMITED",
"MANU TREADS PRIVATE LIMITED",
"MANU UTENSILS PRIVATE LIMITED",
"MANU VYAPAR PRIVATE LIMITED",
"MANU YANTRALAYA PRIVATE LIMITED",
"MANUBHAI & SHAH LLP",
"MANUBHAI AND SONS INVESTMENTS COMPANY PRIVATE LIMITED",
"MANUBHAI BHAGWANDAS JEWELLERS PVT LTD",
"MANUBHAI GEMS PRIVATE LIMITED",
"MANUBHAI MANGALDAS SECURITIES PRIVATE LIMITED",
"MANUBHAI PATEL DENTAL COLLEGE",
"MANUBHAI VITHALDAS EXPORTS PRIVATE LIMITED",
"MANUBHAI ZAVERI ORNAMENTS PRIVATE LIMITED",
"MANUCHO MACHINES PRIVATE LIMITED",
"MANUEL PHARMACEUTICALS PRIVATE LIMITED",
"MANUFACTURING SYSTEM INSIGHTS INDIA PRIVATE LIMITED",
"MANUGRAPH INDIA LIMITED",
"MANUH GLOBAL TECHNOLOGIES PRIVATE LIMITED",
"MANUH SOLUTIONS INDIA PRIVATE LIMITED",
"MANUKRAFT TECHNOLOGY PRIVATE LIMITED",
"MANUPATRA INFORMATION SOLUTIONS PRIVATE LIMITED",
"MANURAJ CELLULAR SERVICES PRIVATE LIMITED",
"MANURAJ TOOLING TECHNOLOGIES PRIVATE LIMITED",
"MANUREVA DIGITAL SOLUTIONS INDIA PRIVATE LIMITED",
"MANUSH DISTRIBUTORS LTD.",
"MANUSHYA NIRMAN EDUCATION PRIVATE LIMITED",
"MANVANTRA AQUA ECOCARBON PRIVATE LIMITED",
"MANVAR RESORT AND CAMP PRIVATE LIMITED",
"MANVENDRA ICE AND COLD STORAGE PRIVATE LIMITED",
"MANVET ANIMAL HEALTH PRIVATE LIMITED",
"MANVI ELEVATORS PRIVATE LIMTED",
"MANVI INFOTECH PRIVATE LIMITED",
"MANVI NONFERROUS VARIETIES PRIVATE LIMITED",
"MANVI PLAST INDIA PRIVATE LIMITED",
"MANVI TEXTILE AIR ENGINEERS PRIVATE LIMITED",
"MANVICK SAI MARINE EXPORTS PRIVATE LIMITED",
"MANVIK HYBRID SEEDS PRIVATE LIMITED",
"MANVISH ETECH PRIVATE LIMITED",
"MANWANI MACHINES PRIVATE LIMITED",
"MANWARD HEALTHCARE PRODUCTS PRIVATE LIMITED",
"MANYA EDUCATION PRIVATE LIMITED",
"MANYA INFRABUILDWELL PRIVATE LIMITED",
"MANYA JEWELLERS PRIVATE LIMITED",
"MANYAH ENERGY PRIVATE LIMITED",
"MANYAM ESTATES",
"MANYATA AGRO INDUSTRIES PRIVATE LIMITED",
"MANYATA ENERGY PRIVATE LIMITED",
"MANYATA PROMOTERS PRIVATE LIMITED",
"MANYAVAR CREATIONS PRIVATE LIMITED",
"MANYOG SECURITIES LIMITED",
"MANYOG SECURITIES PRIVATE LIMITED",
"MANYU LOGISTICS PRIVATE LIMITED",
"MANZA RETAIL PRIVATE LIMITED",
"MANZIL MOTORS PRIVATE LIMITED",
"MANZOOR SHARIQ HOTELS & RESORTS PRIVATE LIMITED",
"MAOSAJI MOTOCORP PRIVATE LIMITED",
"MAP AUTO LIMITED",
"MAP CHEM PRIVATE LIMITED",
"MAP ENERGY",
"MAP FOREX EXIM PRIVATE LIMITED",
"MAP INFRA ENGINEERS INDIA PRIVATE LIMITED",
"MAP SYSTEM (INDIA) PRIVATE LIMITED",
"MAP TECHNOLAB PRIVATE LIMITED",
"MAPA MANAGEMENT SERVICES PRIVATE LIMITED",
"MAPAEX CONSUMER HEALTHCARE PRIVATE LIMITED",
"MAPAEX TRADELINK PRIVATE LIMITED",
"MAPAGE INFRASTRUCTURE PRIVATE LIMITED",
"MAPAL INDIA PRIVATE LIMITED",
"MAPATHINK PRIVATE LIMITED",
"MAPDYNAMICS PRIVATE LIMITED",
"MAPE ADVISORY GROUP PRIVATE LIMITED",
"MAPED INDIA STATIONERY PRODUCTS PRIVATE LIMITED",
"MAPEL MOULDS AND DIES INDIA PRIVATE LIMITED",
"MAPEX PUMPS INDIA PRIVATE LIMITED",
"MAPHAR CONSTRUCTIONS PRIVATE LIMITED",
"MAPIMS HOSPITAL",
"MAPIN PUBLISHING PRIVATE LIMITED",
"MAPKART FOREX PRIVATE LIMITED",
"MAPKHAN HIGH SCHOOL",
"MAPLE ACCESSORIES PRIVATE LIMITED",
"MAPLE AUTO MOTION PRIVATE LIMITED",
"MAPLE BEAR EDUCATION PRIVATE LIMITED",
"MAPLE BIOTECH PVT LTD",
"MAPLE CAPITAL ADVISORS PRIVATE LIMITED",
"MAPLE CITY DEVELOPERS",
"MAPLE COMPUTER AND COMMUNICATION PRIVATE LIMITED",
"MAPLE CROSS REMEDIES PRIVATE LIMITED",
"MAPLE CYBERTECH INFORMATICS PRIVATE LIMITED",
"MAPLE DIGITAL TECHNOLOGY INTERNATIONAL PRIVATE LIMITED",
"MAPLE ENGG-DESIGN SERVICES INDIA PRIVATE LIMITED",
"MAPLE EXPORTS PRIVATE LIMITED",
"MAPLE FOREX PRIVATE LIMITED",
"MAPLE HEALTH CARE PRIVATE LIMITED",
"MAPLE HEIGHTS PRIVATE LIMITED",
"MAPLE HIGHWAY PROJECT MANAGEMENT PRIVATE LIMITED",
"MAPLE HILLS ACADEMY SECONDARY SCHOOL",
"MAPLE HOTELS AND RESORTS PRIVATE LIMITED",
"MAPLE LEAF EDUCONNECT PRIVATE LIMITED",
"MAPLE LEAF INTELLIGENT SOLUTIONS PRIVATE LIMITED",
"MAPLE LEAF PROJECTS PRIVATE LIMITED",
"MAPLE MARITIME PRIVATE LIMITED",
"MAPLE MOTORS",
"MAPLE MOULDINGS PRIVATE LIMITED",
"MAPLE ODC MOVERS PRIVATE LIMITED",
"MAPLE ORGTECH INDIA LIMITED",
"MAPLE OVERSEAS PRIVATE LIMITED",
"MAPLE OVERSEAS TRADE PRIVATE LIMITED",
"MAPLE PANELS PRIVATE LIMITED",
"MAPLE PC & PERIPHERALS PRIVATE LIMITED",
"MAPLE PETS INTERNATIONAL PRIVATE LIMITED",
"MAPLE PRESS PRIVATE LIMITED",
"MAPLE RENEWABLE POWER PRIVATE LIMITED",
"MAPLE SECURITY SOLUTIONS PRIVATE LIMITED",
"MAPLE SOFTWARE PRIVATE LIMITED",
"MAPLE STAFFING SOLUTIONS PRIVATE LIMITED",
"MAPLE TEXSOURCE PRIVATE LIMITED",
"MAPLELABS SOLUTIONS PRIVATE LIMITED",
"MAPLELEAF EPICUREA PRIVATE LIMITED",
"MAPLETREE FARMS PRIVATE LIMITED",
"MAPLETREE INDIA MANAGEMENT SERVICES PRIVATE LIMITED",
"MAPLETREE PROPERTY PRIVATE LIMITED",
"MAPLETUNE FURNITURES PRIVATE LIMITED",
"MAPMED IMAGING INDIA PRIVATE LIMITED",
"MAPMYGENOME INDIA LIMITED",
"MAPOL BUSINESS SOLUTIONS PRIVATE LIMITED",
"MAPOSER INDIA PRIVATE LIMITED",
"MAPP DRILLING AND EXPLORATION PRIVATE LIMITED",
"MAPPD SYSTEMS PRIVATE LIMITED",
"MAPPING DIGIWORLD PRIVATE LIMITED",
"MAPPLE ENERGY PRIVATE LIMITED",
"MAPPLE PUMPS PRIVATE LIMITED",
"MAPPLE STAINLESS PROCESSING PRIVATE LIMITED",
"MAPPLEHILL CREDITS HOLDINGS AND LEASING LIMITED",
"MAPPS IT SERVICES PRIVATE LIMITED",
"MAPPS TRADE CONCEPTS PRIVATE LIMITED",
"MAPRA LABORATORIES PRIVATE LIMITED",
"MAPRICOT FOODS PRIVATE LIMITED",
"MAPRO FOODS PRIVATE LIMITED",
"MAPRO GASES LIMITED",
"MAPRO VENTURES LIMITED",
"MAPS GLOBAL CIVILTECH PRIVATE LIMITED",
"MAPS GRANITO PRIVATE LIMITED",
"MAPS INDUSTRIES INDIA PRIVATE LIMITED",
"MAPS LABORATORIES PRIVATE LIMITED",
"MAPSA TAPES PVT LTD",
"MAPSGLOBAL CONSTRUCTIONS PRIVATE LIMITED",
"MAPSHORE TRAVEL PRIVATE LIMITED",
"MAPSKO AUTO INDIA PRIVATE LIMITED",
"MAPSKO BUILDERS PRIVATE LIMITED",
"MAPSONS INDIA PRIVATE LIMITED",
"MAPSTED TECHNOLOGIES INDIA PRIVATE LIMITED",
"MAPSURF TRAVELS PRIVATE LIMITED",
"MAPTEC SURVEY CONSULTANCY PRIVATE LIMITED",
"MAPTECH PACKAGING PRODUCTS PRIVATE LIMITED",
"MAPTECH SOLUTIONS PRIVATE LIMITED",
"MAPUP INDIA PRIVATE LIMITED",
"MAPUSA MUNICIPAL COUNCIL",
"MAQ INDIA PRIVATE LIMITED",
"MAQ SOFTWARE HYDERABAD PRIVATE LIMITED",
"MAQSAAD BAKERY FOOD PRODUCTS PRIVATE LIMITED",
"MAR BASELIOS COLLEGE OF ENGG AND TECH",
"MAR GREGORIOS COLLEGE OF ARTS AND SCIENCE",
"MAR GREGORIOUS COLLEGE",
"MAR GREGORIOUS MEMORIAL SENIOR SECONDARY SCHOOL",
"MAR SLEEVA MEDICITY PALAI",
"MAR WAR CAP ADVISORS PRIVATE LIMITED",
"MARA STUDIOS PRIVATE LIMITED",
"MARACANA SDC PRIVATE LIMITED",
"MARAEKAT INFOTECH LIMITED",
"MARAGATHAMMBAL INDUSTRIAL AND LOGISTICS PARK PRIVATE LIMITED",
"MARAHAR POWER CONTROLS PRIVATE LIMITED",
"MARAL OVERSEAS LIMITED",
"MARAM INFRAPROJECTS PRIVATE LIMITED",
"MARAM POLYMERS LIMITED",
"MARAMA BEVERAGES PRIVATE LIMITED",
"MARAMON HOTEL AND RESORT PRIVATE LIMITED",
"MARANGI PRIVATE LIMITED",
"MARANGONI SOUTH ASIA PRIVATE LIMITED",
"MARANON AGRO PRIVATE LIMITED",
"MARARI MARKETING LIMITED",
"MARASA HOSPITALITY PRIVATE LIMITED",
"MARATH ENTERPRISES AND CRUSHERS PRIVATE LIMITED",
"MARATHA EDUCATION SOCIETY'S INSTITUTE OF MANAGEMENT STUDIES & INFORMATION TECHNOLOGY",
"MARATHA FORCE PRIVATE LIMITED",
"MARATHA MANDIR",
"MARATHA MANDIR GLOBAL SCHOOL",
"MARATHE INFOTECH PRIVATE LIMITED",
"MARATHI CHAPMAN SCHOOL",
"MARATHI MULANCHI SHALA SANJAY GANDHI NAGAR MIRAJ",
"MARATHON BUILDERS PRIVATE LIMITED",
"MARATHON ELECTRIC INDIA PRIVATE LIMITED",
"MARATHON ELECTRIC MOTORS INDIA LIMITED",
"MARATHON ENER-GEN LLP",
"MARATHON FINLEASE LIMITED",
"MARATHON INDIA LIMITED",
"MARATHON INTERIORS PRIVATE LIMITED",
"MARATHON NEXTGEN REALTY LIMITED",
"MARATHON OIL CORPORATION",
"MARATHON PETROLEUM",
"MARATHON REALTY PRIVATE LIMITED",
"MARATHON SKYSHIP SERVICES PRIVATE LIMITED",
"MARATHON TRENDS ADVISORY PRIVATE LIMITED",
"MARATHWADA ACCELERATOR FOR GROWTH AND INCUBATION COUNCIL",
"MARATHWADA AGRO PROCESS FARMER PRODUCER COMPANY LIMITED",
"MARATHWADA AUTO CLUSTER",
"MARATHWADA AUTO COMPO PRIVATE LIMITED",
"MARATHWADA CERAMIC COMPLEX LIMITED",
"MARATHWADA CHEMICAL INDUSTRIES PRIVATE LIMITED",
"MARATHWADA COLD STORAGE PRIVATE LIMITED",
"MARATHWADA INSTITUTE OF TECHNOLOGY",
"MARATHWADA MEDICAL & RESEARCH INSTITUTE",
"MARATHWADA MITRAMANDALS INSTITUTE OF MA",
"MARATHWADA PACKAGING PRIVATE LIMITED",
"MARATHWADA SANSKRUTIK MANDAL'S COLLEGE OF PHYSICAL EDUCATION",
"MARATT HOSPITALITY PRIVATE LIMITED",
"MARATT PRIVATE LIMITED",
"MARAX TECHNOLOGIES PRIVATE LIMITED",
"MARAYUR POLYFORMS PRIVATE LIMITED",
"MARBANIANG PROJECTS PRIVATE LIMITED",
"MARBELLA STONES INDIA PRIVATE LIMITED",
"MARBEX CERAMIC PRIVATE LIMITED",
"MARBLE ARCH SCHOOL",
"MARBLE BOX SOLUTIONS LLP",
"MARBLE CENTRE INTERNATIONAL PRIVATE LIMITED",
"MARBLE CITY INDIA LIMITED",
"MARBLE HOUSE (INDIA) PVT. LTD.",
"MARBLE POINT (INDIA) PRIVATE LIMITED",
"MARBLE POINT (KOLKATA) PRIVATE LIMITED",
"MARBLECITY HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED",
"MARBLEVALLEY FOODS AND BEVERAGES PRIVATE LIMITED",
"MARBOCERA INTERNATIONAL PRIVATE LIMITED",
"MARBONIZE MICRONS PRIVATE LIMITED",
"MARC ELECTRO INFRA PRIVATE LIMITED",
"MARC ENTERPRISES PVT LTD",
"MARC HOSPITAL",
"MARC INFOTECH PRIVATE LIMITED",
"MARC LABORATORIES LIMITED",
"MARC SALON & BEAUTY EQUIPMENTS PRIVATE LIMITED",
"MARC SANITATION PRIVATE LIMITED",
"MARC SURFACE COATINGS PRIVATE LIMITED",
"MARC TECHNOCRATS PRIVATE LIMITED",
"MARCA COROMA BATHTECH PRIVATE LIMITED",
"MARCE CEMENT WORKS LIMITED",
"MARCEL PIPING PROJECTS SUPPLY PRIVATE LIMITED",
"MARCELLUS INVESTMENT MANAGERS PRIVATE LIMITED",
"MARCFOUR HOSPITALITY SERVICES PRIVATE LIMITED",
"MARCH WORK PRIVATE LIMITED",
"MARCHAK MANUFACTURING PRIVATE LIMITED",
"MARCHE RETAIL PRIVATE LIMITED",
"MARCHE RICCHE FASHION PRIVATE LIMITED",
"MARCHESINI GROUP INDIA PRIVATE LIMITED",
"MARCHING ANTS ADVERTISING PRIVATE LIMITED",
"MARCHINO LEATHERS PRIVATE LIMITED",
"MARCK & CARE ENGINEERS INDIA",
"MARCK AND CARE ENGINEERS LIMITED",
"MARCK DWELLERS",
"MARCK FINCON PRIVATE LIMITED",
"MARCK INDUSTRIES",
"MARCK SECURITIES PRIVATE LIMITED",
"MARCKSWIN LIFESCIENCE",
"MARCO BLOWERS (INDIA) PVT LTD",
"MARCO BUILDING SERVICES PRIVATE LIMITED",
"MARCO CABLES & CONDUCTORS LIMITED",
"MARCO CABLES PRIVATE LIMITED",
"MARCO EXPRESS PRIVATE LIMITED",
"MARCO INFRASTRUCTURE HOLDINGS PRIVATE LIMITED",
"MARCO POLO TESSITURA PRIVATE LIMITED",
"MARCO POLO TRAVELS & TOURS PRIVATE LIMITED",
"MARCO POWER SOLUTIONS PRIVATE LIMITED",
"MARCO SECURE SOLUTIONS PRIVATE LIMITED",
"MARCOFRANCESCO SHOES (INDIA) PRIVATE LIMITED",
"MARCOM INFRA PRIVATE LIMITED",
"MARCOMM ENTERPRISES",
"MARCON SIGNAGE PRIVATE LIMITED",
"MARCONS SHIPPING (KONKAN) PRIVATE LIMITED",
"MARCOPOLO PRODUCTS PVT LTD",
"MARCOS SECURITY FORCE INDIA PRIVATE LIMITED",
"MARCOWAGON RETAIL PRIVATE LIMITED",
"MARCPOLO FASHIONS PRIVATE LIMITED",
"MARCS ENGINEERING PRIVATE LIMITED",
"MARCURA INDIA SERVICES PRIVATE LIMITED",
"MARCURAS WATER TREATMENT (INDIA) PRIVATE LIMITED",
"MARCUS HI-TECH ENGINEERING PRIVATE LIMITED",
"MARCUS OIL & CHEMICALS PRIVATE. LIMITED",
"MARCUS PROJECTS PRIVATE LIMITED",
"MARDA BANG INDUSTRIES PRIVATE LIMITED",
"MARDA COLLECTIONS PRIVATE LIMITED",
"MARDA COMMERCIAL & HOLDINGS LTD",
"MARDA ENTERPRISES PVT. LTD.",
"MARDA ESTATES PRIVATE LIMITED",
"MARDA INDUSTRIES PRIVATE LIMITED",
"MARDA UNIVERSAL PRIVATE LIMITED",
"MARDI GRAS RESTAURANTS PRIVATE LIMITED",
"MARDI GRAS SPRITS",
"MARE FOOD PRODUCTS INDIA PRIVATE LIMITED",
"MAREANA SOFTWARE INDIA PRIVATE LIMITED",
"MAREL INDIA PRIVATE LIMITED",
"MARELLI INDIA PRIVATE LIMITED",
"MARELLI MOTHERSON AUTO SUSPENSION PARTS PRIVATE LIMITED",
"MARELLI MOTHERSON AUTOMOTIVE LIGHTING INDIA PRIVATE LIMITED",
"MARELLI SKH EXHAUST SYSTEMS PRIVATE LIMITED",
"MARELLI UM ELECTRONIC SYSTEMS PRIVATE LIMITED",
"MAREN SOLUTIONS PRIVATE LIMITED",
"MARENGO ASIA HOSPITALS FARIDABAD",
"MARENGO CIMS HOSPITAL",
"MARENGO QRG HOSPITAL",
"MAREX MEDIA PRIVATE LIMITED",
"MARFANI STEEL PRIVATE LIMITED",
"MARFATIA COMMODITIES PRIVATE LIMITED",
"MARFATIA STOCK BROKING PRIVATE .LIMITED",
"MARFIL TILES LLP",
"MARFLIX PICTURES PRIVATE LIMITED",
"MARG BUSINESS TRANSFORMATION PRIVATE LIMITED",
"MARG CHINMAYA VIDYALAYA",
"MARG DARSHAN INFRASTRUCTURE PRIVATE LIMITED",
"MARG ERP LIMITED",
"MARG FINTECH PRIVATE LIMITED",
"MARG HOSPITALITY PRIVATE LIMITED",
"MARG INFOTECH PRIVATE LIMITED",
"MARG PROPERTIES LIMITED",
"MARG STEEL PRIVATE LIMITED",
"MARG TECHNO-PROJECTS LIMITED",
"MARG TRADING LIMITED",
"MARGADARSI CHIT FUND PRIVATE LIMITED",
"MARGADARSI CHITS (KARNATAKA) PRIVATE LIMITED",
"MARGADARSI COMPUTERS",
"MARGADARSI MARKETING PRIVATE LIMITED",
"MARGAO MUNICIAL COUNCIL",
"MARGARET SIDNEY HOSPITAL",
"MARGARITE WOODTECHS PRIVATE LIMITED",
"MARGDARSHAK CONSULTANTS PRIVATE LIMITED",
"MARGEN IMPEX PRIVATE LIMITED",
"MARGH DISTRIBUTORS PRIVATE LIMITED",
"MARGHAT WAALE BABA JI PRIVATE LIMITED",
"MARGIN'SVIEW CONSULTANCY PRIVATE LIMITED",
"MARGO BIOCONTROLS PRIVATE LIMITED",
"MARGO ENGINEERS PVT LTD",
"MARGO PLYWOOD PRIVATE LIMITED.",
"MARGOM CORPORATE ADVISORY SERVICES PRIVATE LIMITED",
"MARGOSA BIOGROW (INDIA) PRIVATE LIMITED",
"MARGSOFT TECHNOLOGIES PRIVATE LIMITED",
"MARHABA FROZEN FOODS",
"MARHABA MEDICAL SERVICES PRIVATE LIMITED",
"MARIA AQUACON PRIVATE LIMITED",
"MARIA COLLEGE NURSING",
"MARIA INTERNATIONAL",
"MARIA PUBLISHERS PRIVATE LIMITED",
"MARIA RUG INTERNATIONAL",
"MARIAM ELECTRONIC SERVICES PRIVATE LIMITED",
"MARIAM RETAIL PRIVATE LIMITED",
"MARIAMPUR HOSPITAL",
"MARIAN EDUCATIONAL INITIATIVES PRIVATE LIMITED",
"MARIAN ENGINEERING COLLEGE",
"MARIAN MATRICULATION HIGHER SECONDARY SCHOOL",
"MARIAN PROJECTS PRIVATE LIMITED",
"MARIANA EXPRESS LINES PRIVATE LIMITED",
"MARIAPPS MARINE SOLUTIONS INDIA PRIVATE LIMITED",
"MARIAPPS MARINE SOLUTIONS PRIVATE LIMITED",
"MARIAS PUBLIC SCHOOL",
"MARICA AGRONOMICS PRIVATE LIMITED",
"MARICA FOODS PRIVATE LIMITED",
"MARICO INNOVATION FOUNDATION",
"MARICO LIMITED",
"MARICON (I) PRIVATE LIMITED",
"MARIDI BIO INDUSTRIES PRIVATE LIMITED",
"MARIDI ECO INDUSTRIES (ANDHRA) PRIVATE LIMITED",
"MARIE GOLD REALTORS PRIVATE LIMITED",
"MARIE PRODUCTS PRIVATE LIMITED",
"MARIEGOLD INDUSTRIES PVT LTD",
"MARIENTAL INDIA PRIVATE LIMITED",
"MARIGOLD APPAREL INDUSTRIES PRIVATE LIMITED",
"MARIGOLD BIOEXTRACTS PRIVATE LIMITED",
"MARIGOLD BUILDCONS PRIVATE LIMITED",
"MARIGOLD CONSTRUCTIONS",
"MARIGOLD DIES & TOOLS PRIVATE LIMITED",
"MARIGOLD EXPORTS (IND) PRIVATE LIMITED",
"MARIGOLD FABRICS PRIVATE LIMITED",
"MARIGOLD FACILITY SERVICES PRIVATE LIMITED",
"MARIGOLD HEIGHTS PRIVATE LIMITED",
"MARIGOLD HOSPITAL",
"MARIGOLD HOTELS PRIVATE LIMITED",
"MARIGOLD LOGISTICS PRIVATE LIMITED",
"MARIGOLD PAINTS PRIVATE LIMITED",
"MARIGOLD PARK CAPITAL ADVISERS PRIVATE LIMITED",
"MARIJAY RESORTS PRIVATE LIMITED",
"MARIK MEDIA AND COMMUNICATIONS PRIVATE LIMITED",
"MARIKAJU PRIVATE LIMITED",
"MARIKAR AUTOMOBILES AND SERVICES PRIVATE LIMITED",
"MARIKAR ENGINEERS PRIVATE LIMITED",
"MARIKAR MOTORS LIMITED",
"MARIKKO FOCHEM (INDIA) PRIVATE LIMITED",
"MARIKO PLUS PRIVATE LIMITED",
"MARIKO TARINI PRIVATE LIMITED",
"MARILL SECURITY MANAGEMENT SERVICES PRIVATE LIMITED",
"MARIM IMPEX INDIA PRIVATE LIMITED",
"MARIN AUTOMATION PRIVATE LIMITED",
"MARINA MEDICAL CENTRE PRIVATE LIMITED",
"MARINA MOTORS INDIA PRIVATE LIMITED",
"MARINA PUBLICATIONS PRIVATE LIMITED",
"MARINA RESORTS PRIVATE LIMITED",
"MARINATING FILMS PRIVATE LIMITED",
"MARINE BLUE TECHNOLOGY PRIVATE LIMITED",
"MARINE CHARIOT PRIVATE LIMITED",
"MARINE CONSULTANTS AND ENGINEERS PRIVATE LIMITED",
"MARINE CONSULTANTS AND SURVEYORS PRIVATE LIMITED",
"MARINE CONTAINER SERVICES (INDIA) PRIVATE LIMITED",
"MARINE CONTAINER SERVICES INDIA PRIVATE LIMITED",
"MARINE DRIVE HOSPITALITY & REALTY PRIVATE LIMITED",
"MARINE ELECTRICALS INDIA LIMITED",
"MARINE ENGINEERING AND RESEARCH INSTITUTE MESS",
"MARINE EXPERT PROTECTION & ALLIED SERVICES PRIVATE LIMITED",
"MARINE FRONTIERS PRIVATE LIMITED",
"MARINE INFRASTRUCTURE DEVELOPER PRIVATE LIMITED",
"MARINE INFRASTRUCTURE GOA PRIVATE LIMITED",
"MARINE LINES AQUACULTURE PRIVATE LIMITED",
"MARINE MECHANICS PRIVATE LIMITED",
"MARINE MEDICARE PRIVATE LIMITED",
"MARINE NAVAIDS AND SOLAR AUTO PRIVATE LIMITED",
"MARINE SECURITY PRIVATE LIMITED",
"MARINE SOLUTION SHIP MANAGEMENT PRIVATE LIMITED",
"MARINE SOLUTIONS DISTRIBUTION AND SERVICES PRIVATE LIMITED",
"MARINE SPACE CRAFT PRIVATE LIMITED",
"MARINECRAFT ENGINEERS PVT LTD",
"MARINELINES SHIP BREAKERS PRIVATE LIMITED",
"MARINESCAPE INDIA PRIVATE LIMITED",
"MARINETEK INDIA SERVICES PRIVATE LIMITED",
"MARINETRANS INDIA LIMITED",
"MARINETRANS INDIA PRIVATE LIMITED",
"MARINI INDIA PRIVATE LIMITED",
"MARINO AGRI TEK PRIVATE LIMITED",
"MARINO BISCUITS & FOOD PRODUCTS PRIVATE LIMITED",
"MARINO CABLES INDIA PRIVATE LIMITED",
"MARINO FOOD PRODUCTS PRIVATE LIMITED",
"MARINO INDUSTRIES PRIVATE LIMITED",
"MARINOTRANS LOGISTICS PRIVATE LIMITED",
"MARINTEK DESIGN & ENGINEERING PRIVATE LIMITED",
"MARIO ENGINEERING INDIA PRIVATE LIMITED",
"MARION BIOTECH PRIVATE LIMITED",
"MARION PHARMA INDIA PRIVATE LIMITED",
"MARIOTTE HYDRAULICS PRIVATE LIMITED",
"MARIP AUTOMOTIVE PRIVATE LIMITED",
"MARIPOSA AGRI VENTURES AND HOSPITALITIES PRIVATE LIMITED",
"MARIS AGRO-PRODUCTS PRIVATE LIMITED",
"MARIS ASSOCIATES PRIVATE LIMITED",
"MARIS HOTELS AND THEATRES PRIVATE LIMITED",
"MARIS POWER SUPPLY COMPANY PRIVATE LIMITED",
"MARIS SPINNERS LIMITED",
"MARISHA TRADING COMPANY PRIVATE LIMITED",
"MARITEC TANKER MANAGEMENT PRIVATE LIMITED",
"MARITECH TRADELINK PRIVATE LIMITED",
"MARITIME ASSOCIATES INDIA PRIVATE LIMITED",
"MARITIME BOARD",
"MARITIME ENERGY HELI AIR SERVICES P LIMITED",
"MARITIME INFRA PROJECTS PRIVATE LIMITED",
"MARITIME MONTERING NORINCO INDIA PRIVATE LIMITED",
"MARITIME SHIP BROKERS (INDIA) PRIVATE LIMITED",
"MARITRONICS INDIA PRIVATE LIMITED",
"MARIUM LEASING AND INVESTMENT PVT LTD",
"MARIVIL FINANCE LIMITED",
"MARIWALA HEALTH FOUNDATION",
"MARIYA HEALTHCARE PRIVATE LIMITED",
"MARIYA ROTO PACKS PRIVATE LIMITED",
"MARIYA SHIP BREAKING PRIVATE LIMITED",
"MARIYAH OVERSEAS PRIVATE LIMITED",
"MARIYAM ENTERPRISES AND TRADERS PRIVATE LIMITED",
"MARIYANO TECHNOLOGIES PRIVATE LIMITED",
"MARIYAPPA FIRST GRADE COLLEGE",
"MARIYAPPANAPALYA SRI GURU EDUCATION SOCIETY",
"MARIYEM GRANITES PRIVATE LIMITED",
"MARJAN MOTORS PRIVATE LIMITED",
"MARJING COMMERCE PRIVATE LIMITED",
"MARK & MERRY INDIA PRIVATE LIMITED",
"MARK (INDIA) COSMED PRIVATE LIMITED",
"MARK ACOUSTIC ENCLOSURE PRIVATE LIMITED",
"MARK AD",
"MARK AGENCIES PRIVATE LIMITED",
"MARK AGRI GENETICS PRIVATE LIMITED",
"MARK ALLOYS PRIVATE LIMITED",
"MARK AND ORION VENTURES PRIVATE LIMITED",
"MARK AND SPACE TELESYSTEMS PRIVATE LIMITED",
"MARK BULLION COMMODITIES PRIVATE LIMITED",
"MARK COM SOLUTIONS PRIVATE LIMITED",
"MARK COMMERCIAL PRIVATE LIMITED",
"MARK CONMIX PRIVATE LIMITED",
"MARK DESIGN SOLUTIONS PRIVATE LIMITED",
"MARK ENCLAVE PRIVATE LIMITED",
"MARK ENERGY SOLUTIONS PRIVATE LIMITED",
"MARK EXHAUST SYSTEMS LIMITED",
"MARK EXHIBITS AND DISPLAYS PRIVATE LIMITED",
"MARK FOREX HUB INDIA PRIVATE LIMITED",
"MARK GLAZE TILES PRIVATE LIMITED",
"MARK HYDROLUB PRIVATE LIMITED",
"MARK INFRACITY DEVELOPERS PRIVATE LIMITED",
"MARK INFRASTRUCTURE PRIVATE LIMITED",
"MARK IT SOLUTIONS PRIVATE LIMITED",
"MARK JOINT VENTURE IMPEX PRIVATE LIMITED",
"MARK LIGHTING SOLUTIONS PRIVATE LIMITED",
"MARK LUBES PRIVATE LIMITED",
"MARK MAKERS CONSULTANCY SERVICES PRIVATE LIMITED",
"MARK MALL PRIVATE LIMITED",
"MARK ORTHO CARE PRIVATE LIMITED",
"MARK OUTSOURCING",
"MARK OUTSOURCING WORKMEN TEAM PROCESS PRIVATE LIMITED",
"MARK PETRO PRODUCTS PRIVATE LIMITED",
"MARK PROCESSING AND FREEZING COMPANY PRIVATE LIMITED",
"MARK PROCON PRIVATE LIMITED",
"MARK ROYAL CORPORATION INDIA PRIVATE LIMITED",
"MARK SALON & SPA PRIVATE LIMITED",
"MARK SPECIALITY (INDIA) PRIVATE LIMITED",
"MARK STEELS LIMITED",
"MARK TECH POLYMERS PRIVATE LIMITED",
"MARK TECHPRO AND CONSULATANTS PRIVATE LIMITED",
"MARKANDESHWAR ENGINEERING PRIVATE LIMITED",
"MARKANDESHWAR FARMERS PRODUCER COMPANY LIMITED",
"MARKANDESHWAR FOODS & ALLIED PRODUCTS LIMITED",
"MARKANDYA TRADELINKS PRIVATE LIMITED",
"MARKARIAN INTERNATIONAL PRIVATE LIMITED",
"MARKAZ ARABI COLLEGE",
"MARKDATA POWER AND ENERGY LIMITED",
"MARKDRAFT PRIVATE LIMITED",
"MARKEL SERVICES INDIA PRIVATE LIMITED",
"MARKELYTICS SOLUTIONS INDIA PRIVATE LIMITED",
"MARKEM - IMAJE INDIA PRIVATE LIMITED",
"MARKEM IMAJE INDIA PRIVATE LIMITED",
"MARKEM IMAJE SOFTWARE DEVELOPMENT CENTRE PRIVATE LIMITED",
"MARKEN LIMITED",
"MARKET ALIGNED SKILLS FOUNDATION",
"MARKET AND MARKETS RESEARCH PRIVATE LIMITED",
"MARKET CITY RESOURCES PRIVATE LIMITED",
"MARKET COMMITTEE ABOHAR",
"MARKET CREATORS LTD",
"MARKET EYES CONSULTANCY PRIVATE LIMITED",
"MARKET HUB STOCK BROKING PRIVATE LIMITED",
"MARKET MEN",
"MARKET MIRROR RESEARCH SOLUTION",
"MARKET NINETY NINE PRIVATE LIMITED",
"MARKET PULSE TECHNOLOGIES PRIVATE LIMITED",
"MARKET SIMPLIFIED INDIA LIMITED",
"MARKET VISTAS CONSUMER INSIGHT PRIVATE LIMITED",
"MARKET XCEL DATA MATRIX PRIVATE LIMITED",
"MARKETBOATS CONSULTING PRIVATE LIMITED",
"MARKETELS HOSPITALITY PRIVATE LIMITED",
"MARKETFOX INDIA PRIVATE LIMITED",
"MARKETGATE CONSULTING PRIVATE LIMITED",
"MARKETING COMMUNICATION & ADVERTISING LIMITED",
"MARKETING KING ONLINE PRIVATE LIMITED",
"MARKETING NETWORK (INDIA) PRIVATE LIMITED",
"MARKETING REX",
"MARKETING SOLUTIONS AND SERVICES PRIVATE LIMITED",
"MARKETING SPACE PRIVATE LIMITED",
"MARKETLEGOS PRIVATE LIMITED",
"MARKETOPPER SECURITIES PRIVATE LIMITED",
"MARKETPLACE IT SOLUTIONS PRIVATE LIMITED",
"MARKETS AND MARKETS RESEARCH PRIVATE LIMITED",
"MARKETSANDMARKETS RESEARCH PRIVATE LIMITED",
"MARKETSOF1 ANALYTICAL MARKETING SERVICES PRIVATE LIMITED",
"MARKETWAVE AGENCIES PRIVATE LIMITED",
"MARKETWICK PRIVATE LIMITED",
"MARKETWISE SERVICES PRIVATE LIMITED",
"MARKETWOLF SECURITIES PRIVATE LIMITED",
"MARKETXPANDER SERVICES PRIVATE LIMITED",
"MARKETYSERS GLOBAL CONSULTING LLP",
"MARKEVOLVE PRIVATE LIMITED",
"MARKEX BRANDING SOLUTIONS PRIVATE LIMITED",
"MARKFED CATTLEFEED & ALLIED INDUSTRIES",
"MARKIMPEX ELECTRONICS PRIVATE LIMITED",
"MARKISH EXIM AND SERVICES PRIVATE LIMITED",
"MARKIT INDIA SERVICES PRIVATE LIMITED",
"MARKIV SEEDS PRIVATE LIMITED",
"MARKK-LAMB INTERNATIONAL LIMITED",
"MARKLINE INDUSTRIES PRIVATE LIMITED",
"MARKLINES INDIA PRIVATE LIMITED",
"MARKLON TEX IN PRIVATE LIMITED",
"MARKO AGRO HOUSING AND FINANCE PRIVATE LIMITED",
"MARKO STEAMJET PRIVATE LIMITED",
"MARKOLINE INFRA PRIVATE LIMITED",
"MARKOLINES PAVEMENT TECHNOLOGIES LIMITED",
"MARKON ELECTRONICS CORPORATION PRIVATE LIMITED",
"MARKOR TECHNOLOGY PRIVATE LIMITED",
"MARKOWATE TECHNOLOGIES PRIVATE LIMITED",
"MARKPULIKKOTTIL RESORTS AND PROPERTIES PRIVATE LIMITED",
"MARKS ACADEMIC & HOSPITALITY PRIVATE LIMITED",
"MARKS AND SPENCER INDIA PRIVATE LIMITED",
"MARKS AND SPENCER RELIANCE INDIA PRIVATE LIMITED",
"MARKS ENGINEERING WORKS",
"MARKS MARINE RADIO PRIVATE LIMITED",
"MARKS MARKETING PRIVATE LIMITED",
"MARK'S SHIPPING PRIVATE LIMITED",
"MARKS TOURS AND TRAVELS PRIVATE LIMITED",
"MARKSANS PHARMA LIMITED",
"MARKSMEN AUTOMOBILES PRIVATE LIMITED",
"MARKSMEN FACILITIES PRIVATE LIMITED",
"MARKSMEN MARINE PRODUCTS PRIVATE LIMITED",
"MARKSPACE MEDIA",
"MARKSS INFOTECH LIMITED",
"MARKSUPER STORE PRIVATE LIMITED",
"MARKUP DESIGNS PRIVATE LIMITED",
"MARKWEL EQUIPMENTS PRIVATE LIMITED",
"MARKWELL PHARMACEUTICALS PRIVATE LIMITED",
"MARKWELL SPINNING PRIVATE LIMITED",
"MARKWIN LOGISTICS (INDIA) PRIVATE LIMITED",
"MARLABS INNOVATIONS PRIVATE LIMITED",
"MARLABS SOFTWARE PRIVATE LIMITED",
"MARLECHA INDUSTRIES PRIVATE LIMITED",
"MARLECHA INTERIORS PRIVATE LIMITED",
"MARLECHA JEWELLERS AND FOREX PRIVATE LIMITED",
"MARLECHA'S SCIENTIFIC & CHEMICALS PRIVATE LIMITED",
"MARLENSOFT PRIVATE LIMITED",
"MARLEX PRODUCTS LIMITED",
"MARLIN GLOBAL ENERGY PRIVATE LIMITED",
"MARLIN INFRASTRUCTURES PRIVATE LIMITED",
"MARLIN LOGISTICS PRIVATE LIMITED",
"MARLIN PLATE SYSTEM",
"MARLIN POOLS & SPA PRIVATE LIMITED",
"MARLIN TRAVEL PRIVATE LIMITED",
"MARLO TECHNOLOGIES PRIVATE LIMITED",
"MARLOW NAVIGATION INDIA PRIVATE LIMITED",
"MARMALADE DIGITAL PRIVATE LIMITED",
"MARMAN ENGINEERING AND SHIPBUILDING PRIVATE LIMITED",
"MARMO HOME PRIVATE LIMITED",
"MARMO STONE PRIVATE LIMITED",
"MARMON FOOD & BEVERAGE TECHNOLOGIES INDIA PRIVATE LIMITED",
"MARMORE MENA INTELLIGENCE PRIVATE LIMITED",
"MARNAVI SHIPPING MANAGEMENT PRIVATE LIMITED",
"MARNITE SHOPPE PRIVATE LIMITED",
"MARNITE STEEL PRIVATE LIMITED",
"MAROL EDUCATION ACADEMY PRIMARY SCHOOL",
"MAROL PRAGATIK PRIMARY SCHOOL",
"MAROLI METERS PRIVATE LIMITED",
"MAROLI NH ROAD PRIVATE LIMITED",
"MAROLIX TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"MAROO CARPETS PRIVATE LIMITED",
"MAROO MACHINERIES PRIVATE LIMITED",
"MAROO STEELS PRIVATE LIMITED",
"MAROON OVERSEAS PRIVATE LIMITED",
"MAROPOST INDIA PRIVATE LIMITED",
"MAROTHI CEMENT PRIVATE LIMITED",
"MAROTIA STEEL & ALLOYS PRIVATE LIMITED",
"MAROTIA STEEL ENGINEERING PRIVATE LIMITED",
"MAROTIA STEEL TRADERS PRIVATE LIMITED",
"MAROTRAO MUDE HEMANTRAO JAKATE HIGH SCHOOL",
"MARPOL PRIVATE LIMITED",
"MARPOSS INDIA PRIVATE LIMITED",
"MARPS MARKETING PRIVATE LIMITED",
"MARQT RETAIL PRIVATE LIMITED",
"MARQTAGS PRIVATE LIMITED",
"MARQUARDT INDIA PRIVATE LIMITED",
"MARQUE ARTISANS PRIVATE LIMITED",
"MARQUE AUTOS PRIVATE LIMITED",
"MARQUE BUILDERS & DEVELOPERS PRIVATE LIMITED",
"MARQUE MARKETING SERVICES PRIVATE LIMITED",
"MARQUEE AGRIVENTURES PRIVATE LIMITED",
"MARQUEESEMI INDIA PRIVATE LIMITED",
"MARQUIS HOTELS LIMITED",
"MARQUIS TECHNOLOGIES PRIVATE LIMITED",
"MARRI EDUCATIONAL SOCIETY",
"MARRI LAXMAN REDDY INSTITUTE OF TECHNOLOGY AND MANAGEMENT",
"MARRI PROJECTS PRIVATE LIMITED",
"MARRI RETAIL PRIVATE LIMITED",
"MARRIOTT FACILITY MANAGEMENT PRIVATE LIMITED",
"MARRIOTT GRAND VACATIONS PRIVATE LIMITED",
"MARRIOTT HOSPITALITY SERVICES PRIVATE LIMITED",
"MARRIOTT HOTELS INDIA PRIVATE LIMITED TRF.",
"MARRIOTT REALTORS PRIVATE LIMITED",
"MARRS INTELLECTUAL SERVICES PRIVATE LIMITED",
"MARRS PUMPS SERVICES PRIVATE LIMITED",
"MARRT CON INDIA PRIVATE LIMITED",
"MARS (INDIA) ANTENNAS & RF SYSTEMS PRIVATE LIMITED",
"MARS ART AND CRAFT PRIVATE LIMITED",
"MARS ASSET RESOLUTION AND SECURITY SERVICES PRIVATE LIMITED",
"MARS ASSOCIATES PRIVATE LIMITED",
"MARS AUTO PRIVATE LIMITED",
"MARS BEARINGS COMPANY PVT LTD",
"MARS BIOANALYTICAL PRIVATE LIMITED",
"MARS CAPITAL PRIVATE LIMITED",
"MARS CAR CARE SERVICES PRIVATE LIMITED",
"MARS CARGO PRIVATE LIMITED",
"MARS CATERING SERVICES PRIVATE LIMITED",
"MARS CHEMIE PRIVATE LIMITED",
"MARS COMMODITIES PRIVATE LIMITED",
"MARS COSMETICS PRIVATE LIMITED",
"MARS DETECTIVE AGENCY PRIVATE LIMITED",
"MARS DEVELOPERS AND BUILDTECH INDIA PRIVATE LIMITED",
"MARS DIA JEWELS LLP",
"MARS DIAGNOSTICS PRIVATE LIMITED",
"MARS EDPAL INSTRUMENTS PRIVATE LIMITED.",
"MARS ENDEAVOUR PRIVATE LIMITED",
"MARS ENGINEERING AND CONSTRUCTION PRIVATE LIMITED",
"MARS ENTERPRISES & HOSPITALITY PRIVATE LIMITED",
"MARS ENTERPRISES PRIVATE LIMITED",
"MARS ENVIRO RESEARCH & ENGINEERING SERVICES PRIVATE LIMITED",
"MARS ENVIROTECH LIMITED",
"MARS EXIM PRIVATE LIMITED",
"MARS FINCOM PRIVATE LIMITED",
"MARS FRAGRANCE PRIVATE LIMITED",
"MARS GLASS SOLUTIONS PRIVATE LIMITED",
"MARS HEALTHCARE PRIVATE LIMITED",
"MARS HIGHWAYS PRIVATE LIMITED",
"MARS HOSPITALITY & RETAIL PRIVATE LIMITED",
"MARS HOTELS AND RESORTS PRIVATE LIMITED",
"MARS HOUSEWARE INDUSTRIES PRIVATE LIMITED",
"MARS INDIA AUTOMOBILE PRIVATE LIMITED",
"MARS INFRA ENGINEERING PRIVATE LIMITED",
"MARS INTERNATIONAL INDIA PRIVATE LIMITED",
"MARS IT TECHNICAL AND CONSULTING SERVICES PRIVATE LIMITED",
"MARS JEWELZ PRIVATE LIMITED",
"MARS KINETEK ELEVATORS INDIA PRIVATE LIMITED",
"MARS LIFESTYLE PRIVATE LIMITED",
"MARS MEDICAL DEVICES LIMITED",
"MARS MERCANTILES PRIVATE LIMITED",
"MARS MOTOCARE PRIVATE LIMITED",
"MARS MOUNTAIN SECURITY SERVICES PRIVATE LIMITED",
"MARS MOVERS PRIVATE LIMITED",
"MARS PACKAGING INDUSTRIES",
"MARS PEST MANAGEMENT SYSTEMS (INDIA) PRIVATE LIMITED",
"MARS PETROCHEM PRIVATE LIMITED",
"MARS PHARMA PRIVATE LIMITED",
"MARS PLANNING AND ENGINEERING SERVICES INTERNATIONAL PRIVATE LIMITED",
"MARS PLANNING AND ENGINEERING SERVICES PRIVATE LIMITED",
"MARS PRINTECH PRIVATE LIMITED",
"MARS RAIL-FIT ENGINEERS PRIVATE LIMITED",
"MARS SYNERGIES PRIVATE LIMITED",
"MARS TEA (INDIA) PRIVATE LIMITED",
"MARS TELECOM SYSTEMS PRIVATE LIMITED",
"MARS THERAPEUTICS PRIVATE LIMITED",
"MARS TRANS EXPRESS PRIVATE LIMITED",
"MARSAP SERVICES PRIVATE LIMITED",
"MARS-CARE INDIA PRIVATE LIMITED",
"MARSH AUTOMATION PRIVATE LIMITED",
"MARSH INDIA INSURANCE BROKERS PRIVATE LIMITED",
"MARSH MACLEAN INSURANCE SERVICES LIMITED",
"MARSH MCLENNAN GLOBAL SERVICES INDIA PRIVATE LIMITED",
"MARSH STAMPING PRIVATE LIMITED",
"MARSHA ORGANICS PRIVATE LIMITED",
"MARSHA PHARMA PRIVATE LIMITED",
"MARSHAH INDUSTRIAL ELECTRONICS COMPANY PRIVATE LIMITED",
"MARSHAL AVIATION SERVICES PRIVATE LIMITED",
"MARSHAL ELECTRICALS PRIVATE LIMITED",
"MARSHAL HMB PRIVATE LIMITED",
"MARSHAL INFRADEVELOPERS INDIA PRIVATE LIMITED",
"MARSHAL PLYWOODS PVT. LTD.",
"MARSHAL PROPERTIES PRIVATE LIMITED",
"MARSHAL QUARRIES AND GRANITES PRIVATE LIMITED",
"MARSHAL SHIP MANAGEMENT PRIVATE LIMITED",
"MARSHAL SPECIALITY PRODUCTS PRIVATE LIMITED",
"MARSHAL TEXTILES PRIVATE LIMITED",
"MARSHALL AUTO CAST PRIVATE LIMITED",
"MARSHALL AUTO PRODUCTS PRIVATE LIMITED",
"MARSHALL CASTINGS LIMITED",
"MARSHALL CORPORATION LIMITED",
"MARSHALL FOUNDRY AND ENGG PRIVATE LIMITED",
"MARSHALL FOUNDRY WORKS PRIVATE LIMITED",
"MARSHALL FOWLER ENGINEERS INDIA PRIVATE LIMITED",
"MARSHALL INTEGRATED SERVICES PRIVATE LIMITED",
"MARSHALL MACHINES LIMITED",
"MARSHALL PRODUCE BROKERS COMPANY PRIVATE LIMITED",
"MARSHALL SONS AND CO INDIA LTD",
"MARSHALL TECHNOCAST PRIVATE LIMITED",
"MARSHALL WIRE PRIVATE LIMITED",
"MARSHALLS ENTERPRISE INDIA PRIVATE LIMITED",
"MARSHIL EXPORTS AND IMPORTS LLP",
"MARSILLI INDIA PRIVATE LIMITED",
"MARSIN TECHNOLOGY LLP",
"MARSMAN INDIA CRANES PRIVATE LIMITED",
"MARSMAN INDIA LIMITED",
"MARSONS ENERGY PRIVATE LIMITED",
"MARSONS LIMITED",
"MARSORBIT ENTERTAINMENT PRIVATE LIMITED",
"MARSULEX ENVIRONMENTAL TECHNOLOGIES INDIA PRIVATE LIMITED",
"MARSWAY ENGINEERING CONSULTANCY AND CONSTRUCTION SERVICES PRIVATE LIMITED",
"MARSWELL FOODS PRIVATE LIMITED",
"MART GLOBAL MANAGEMENT SOLUTIONS LLP",
"MARTAND EXPORTS PVT.LTD,",
"MARTAND FOODS AND DEHYDRATES PRIVATE LIMITED",
"MARTCO EXPORT PRIVATE LIMITED",
"MARTECH INFO SYSTEMS PRIVATE LIMITED",
"MAR-TECH INSURANCE SURVEYORS AND LOSS ASSESSORS PRIVATE LIMITED",
"MARTHALA HOSPITALS PVT LTD",
"MARTHOMA H S SCHOOL CBSE",
"MARTI INDIA PRIVATE LIMITED",
"MARTIAL BUILDCON PRIVATE LIMITED",
"MARTIAL GUARDING SERVICES PRIVATE LIMITED",
"MARTIAL MOTORS PRIVATE LIMITED",
"MARTIN & HARRIS PRIVATE LIMITED",
"MARTIN AND HARRIS LABORATORIES LIMITED",
"MARTIN BUILDERS PRIVATE LIMITED",
"MARTIN BURN CONSTRUCTIONS LIMITED",
"MARTIN BURN LTD",
"MARTIN ENGINEERING COMPANY INDIA PRIVATE LIMITED",
"MARTIN FARMS PRIVATE LIMITED",
"MARTIN HAPPY HOME PRIVATE LIMITED",
"MARTIN HI-TECH CONSTRUCTION PRIVATE LIMITED",
"MARTIN SPINNING MILLS AND AGENCIES PRIVATE LIMITED",
"MARTINET ENGINEERS PRIVATE LIMITED",
"MARTINET FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"MARTINEZ LEAL INDIA PRIVATE LIMITED",
"MARTINS IMPEX PVT. LTD.",
"MARTOPEARL ALLOYS PRIVATE LIMITED",
"MARTRADE INDIA SHIPPING AND LOGISTICS PRIVATE LIMITED",
"MARTRAM FOODS INDIA PRIVATE LIMITED",
"MARTRIKZ PRIVATE LIMITED",
"MARU ENTERPRISES PRIVATE LIMITED",
"MARU FIBRE TECH PRIVATE LIMITED",
"MARU ONE BRAND TEXTILES PRIVATE LIMITED",
"MARU SHIRTINGS PRIVATE LIMITED",
"MARU TRANSMISSION SERVICE COMPANY LIMITED",
"MARUBENI CORPORATION,",
"MARUBENI INDIA PRIVATE LIMITED",
"MARUBENI ITOCHU STEEL INDIA PRIVATE LIMITED",
"MARUCHAN AJINOMOTO INDIA PRIVATE LIMITED",
"MARUDESH CONSTRUCTIONS PRIVATE LIMITED",
"MARUDHAM TELEVISION PRIVATE LIMITED",
"MARUDHAMALAI INDUSTRIAL & LOGISTICS PARKS PRIVATE LIMITED",
"MARUDHAMALAI SRI DHANDAPANI SPINNINGMILLS",
"MARUDHAR ALUM AND CHEMICALS PRIVATE LIMITED",
"MARUDHAR ASSAM ROADLINES PRIVATE LIMITED",
"MARUDHAR CALCIUM PRIVATE LIMITED",
"MARUDHAR CERAMICS PRIVATE LIMITED",
"MARUDHAR CINEVENTURES PRIVATE LIMITED",
"MARUDHAR CLOTHING PRIVATE LIMITED",
"MARUDHAR ENTERPRISES PRIVATE LIMITED",
"MARUDHAR FOODS PRIVATE LIMITED",
"MARUDHAR HOSPITAL",
"MARUDHAR HOSPITAL AND RESEARCH PRIVATE LIMITED",
"MARUDHAR HOTELS PVT LTD",
"MARUDHAR INDUSTRIES LIMITED",
"MARUDHAR ISPAT PRIVATE LIMITED",
"MARUDHAR LIFE STYLE PRIVATE LIMITED",
"MARUDHAR MISHRI MOTORS LLP",
"MARUDHAR MOTORS PRIVATE LIMITED",
"MARUDHAR POLYCOT (INDIA) PRIVATE LIMITED.",
"MARUDHAR POLYSACKS PRIVATE LIMITED",
"MARUDHAR PROJECTS PRIVATE LIMITED",
"MARUDHAR REALTIES COMPANY PRIVATE LIMITED",
"MARUDHAR ROCKS INTERNATIONAL PRIVATE LIMITED",
"MARUDHAR SPG MILLS PRIVATE LIMITED",
"MARUDHAR STONES INTERNATIONAL PRIVATE LIMITED",
"MARUDHAR TANCHEM PRIVATE LIMITED",
"MARUDHAR TECHNOLOGY PRIVATE LIMITED",
"MARUDHAR VANIJYA PRIVATE LIMITED",
"MARUDHAR WIRES PRIVATE LIMITED",
"MARUDHARA AGRI INFRA PRIVATE LIMITED",
"MARUDHARA AUTOMOBILES PRIVATE LIMITED",
"MARUDHARA POLYPACK PRIVATE LIMITED",
"MARUDHARKESARI STONES PRIVATE LIMITED",
"MARUDUPANDIYAR COLLEGE",
"MARUICHI KUMA STEEL TUBE PRIVATE LIMITED",
"MARULENE TEXFAB PRIVATE LIMITED",
"MARUNA EXPORTS PVT LTD",
"MARUPRIDE SOLAR INFRASTRUCTURE PRIVATE LIMITED",
"MARUSH OVERSEAS PRIVATE LIMITED",
"MARUSHIKA TECHNOLOGY ADVISORS PRIVATE LIMITED",
"MARUT DRONETECH PRIVATE LIMITED",
"MARUT ENERGY EQUIPMENTS PRIVATE LIMITED",
"MARUT NANDAN PARYATAN LIMITED",
"MARUT NANDAN TEXTILES LTD",
"MARUT TECHNO TOOLS PRIVATE LIMITED",
"MARUTEE DESIGN AND ENGINEERING PRIVATE LIMITED",
"MARUTHAM MATRIC HIGHER SECONDARY SCHOOL",
"MARUTHAM PHARMACY PRIVATE LIMITED",
"MARUTHAM PIPES & FITTINGS PRIVATE LIMITED",
"MARUTHAM TEXTILES PRIVATE LIMITED",
"MARUTHI AQUA TECHNOLOGIES PRIVATE LIMITED",
"MARUTHI CONSTRUCTIONS",
"MARUTHI CORPORATION LIMITED",
"MARUTHI ELECTRODES PRIVATE LIMITED",
"MARUTHI ENGINEERING WORKS",
"MARUTHI FASHION STORES PRIVATE LIMITED",
"MARUTHI GARMENTS PRIVATE LIMITED",
"MARUTHI MANJUNATHA LOGISTICS PRIVATE LIMITED",
"MARUTHI MECHANICAL AND ELECTRICALS PRIVATE LIMITED",
"MARUTHI MICROCOMPONENTS PRIVATE LIMITED",
"MARUTHI MOULDERS PRIVATE LIMITED",
"MARUTHI OFFICE EQUIPMENT PRIVATE LIMITED",
"MARUTHI PLASTICS & PACKAGING CHENNAI PRIVATE",
"MARUTHI PLASTICS UDYOG PRIVATE LIMITED",
"MARUTHI POLYMERS (INDIA) PRIVATE LIMITED",
"MARUTHI QUALITY MANAGEMENT SERVICES PRIVATE LIMITED",
"MARUTHI TRADERS",
"MARUTHI VENKATASAI FOODS PRIVATE LIMITED",
"MARUTHI VIDYALAYA",
"MARUTHISAN PRIVATE LIMITED",
"MARUTI AIR COURIERS AND CARGO PRIVATE LIMITED",
"MARUTI ALLUMINIUM PRIVATE LIMITED",
"MARUTI ARCHITECTURAL PRODUCTS PRIVATE LIMITED",
"MARUTI AUTO EQUIPMENT INDIA PRIVATE LIMITED",
"MARUTI AUTO SPARES PARTS PRIVATE LIMITED",
"MARUTI BLOW TECH PRIVATE LIMITED",
"MARUTI BOARDS PRIVATE LIMITED",
"MARUTI CARGO AND CHEMICALS PVT LTD",
"MARUTI CLEAN COAL AND POWER LIMITED",
"MARUTI CLOTHING PRIVATE LIMITED",
"MARUTI COAL AND CARGO PRIVATE LIMITED",
"MARUTI COMFORTS & INN PRIVATE LIMITED",
"MARUTI CONSTRUCTION PRIVATE LIMITED",
"MARUTI COTEX LIMITED",
"MARUTI COTTEX LTD",
"MARUTI DECOR PROJECTS PRIVATE LIMITED",
"MARUTI DIATECH PRIVATE LIMITED",
"MARUTI DOOR AND PLY ( GUJARAT ) PRIVATE LIMITED",
"MARUTI DWELLERS PRIVATE LIMITED",
"MARUTI ECO PRODUCTS PRIVATE LIMITED",
"MARUTI ELECTRO PROCELAIN PVT LTD",
"MARUTI ELEVATORS PRIVATE LIMITED",
"MARUTI ENGINEERING",
"MARUTI ENT HOSPITAL",
"MARUTI ENTERPRISE",
"MARUTI ESTATE (INDIA) PRIVATE LIMITED",
"MARUTI EXPORT",
"MARUTI FABRICS",
"MARUTI FABRICS PVT. LTD",
"MARUTI FASHIONS PRIVATE LIMITED",
"MARUTI FERROUS PRIVATE LIMITED",
"MARUTI FERTOCHEM PRIVATE LIMITED",
"MARUTI FIBRES PVT. LTD",
"MARUTI FINANCE PVT LTD",
"MARUTI FLEX PRIVATE LIMITED",
"MARUTI FREIGHT MOVERS LIMITED",
"MARUTI FUTURISTIC PHARMA PRIVATE LIMITED",
"MARUTI GINNING AND PRESSING INDUSTRIES",
"MARUTI GLAZE TILES PRIVATE LIMITED",
"MARUTI GLOBAL PRIVATE LIMITED",
"MARUTI GRANITES AND MARBLES PRIVATE LIMITED",
"MARUTI HARDWARE PRODUCTS PRIVATE LIMITED",
"MARUTI HEALTHCARE PRIVATE LIMITED",
"MARUTI HYDRAULICS PRIVATE LIMITED",
"MARUTI INFRACREATION PRIVATE LIMITED",
"MARUTI INFRASTRUCTURE LIMITED",
"MARUTI INFRAVENTURES INDIA PRIVATE LIMITED",
"MARUTI INOX INDIA PRIVATE LIMITED",
"MARUTI INSURANCE BROKING PRIVATE LIMITED",
"MARUTI INTERIOR PRODUCTS LIMITED",
"MARUTI ISPAT AND PIPES PRIVATE LIMITED",
"MARUTI LIFT AND SAFE TECHNIQUE PRIVATE LIMITED",
"MARUTI MACHINES PRIVATE LIMITED",
"MARUTI MECH-TECH PRIVATE LIMITED",
"MARUTI MEDITECH PRIVATE LIMITED",
"MARUTI MILLS PRIVATE LIMITED",
"MARUTI MOTOR TRANSPORT COMPANY PRIVATE LIMITED",
"MARUTI MULTICHEM PRIVATE LIMITED",
"MARUTI NANDAN IMPEX PRIVATE LIMITED",
"MARUTI NANDAN MILLING SOLUTION PRIVATE LIMITED",
"MARUTI NANDAN OILS PRIVATE LIMITED",
"MARUTI NANDAN PLASTIC PRIVATE LIMITED",
"MARUTI NON-WOVEN FABRIC PRIVATE LIMITED",
"MARUTI NOUVEAUKNITS PRIVATE LIMITED",
"MARUTI OIL AND FATS PRIVATE LIMITED",
"MARUTI PACKAGERS PRIVATE LIMITED",
"MARUTI PANCHAL CYLINDERS PRIVATE LIMITED",
"MARUTI PAPERS PRIVATE LIMITED",
"MARUTI PESTICIDES PRIVATE LIMITED",
"MARUTI PET & PREFORM PRIVATE LIMITED",
"MARUTI PHARMACHEM PRIVATE LIMITED",
"MARUTI PULSES PRIVATE LIMITED",
"MARUTI RICH VENTURES PRIVATE LIMITED",
"MARUTI RMC PRIVATE LIMITED",
"MARUTI ROPES INDIA PRIVATE LIMITED",
"MARUTI RUB-PLAST PRIVATE LIMITED",
"MARUTI SALT FARM PRIVATE LIMITED",
"MARUTI SANITARY PRODUCTS (INDIA) PRIVATE LIMITED",
"MARUTI SPINCOT INDIA PRIVATE LIMITED",
"MARUTI SPINTEX PRIVATE LIMITED",
"MARUTI STEEL SRIJAN PRIVATE LIMITED",
"MARUTI SUZUKI CENTRE FOR EXCELLENCE",
"MARUTI SUZUKI INDIA LIMITED",
"MARUTI SUZUKI TOYOTSU INDIA PRIVATE LIMITED",
"MARUTI SYNTHCOT PRIVATE LIMITED",
"MARUTI TEA AND INDUSTRIES PVT. LTD.",
"MARUTI TECHLABS PRIVATE LIMITED",
"MARUTI TECHNO RUBBER PVT LTD",
"MARUTI TECHNOFAB INDUSTRIES PRIVATE LIMITED",
"MARUTI TEMPERED PROCESS PRIVATE LIMITED",
"MARUTI TEXPROCESS INDIA PRIVATE LIMITED",
"MARUTI TRADING PRIVATE LIMITED",
"MARUTI WEIGHTECH PRIVATE LIMITED",
"MARUTI WIRETECH PRIVATE LIMITED",
"MARUTII QUALITY PRODUCTS PRIVATE LIMITED",
"MARUTINANDAN ELECTRIC WORKS PRIVATE LIMITED",
"MARUTINANDAN HANDICRAFTS PRIVATE LIMITED",
"MARUTINANDAN OILS PRIVATE LIMITED",
"MARUTINANDAN STRUCTURES PRIVATE LIMITED",
"MARUTINANDAN TEX-PRINT PRIVATE LIMITED",
"MARUTISUT CONTRACTORS PRIVATE LIMITED",
"MARUT-SHAKTI ENERGY INDIA LIMITED",
"MARUWA ELECTRONIC INDIA PRIVATE LIMITED",
"MARV CONSULTING PRIVATE LIMITED",
"MARV FURNITURE MIND PRIVATE LIMITED",
"MARVAL ENGINEERING PRIVATE LIMITED",
"MARVAR INDIA PRIVATE LIMITED",
"MARVEL ASSOCIATES",
"MARVEL BIKES PRIVATE LIMITED",
"MARVEL BUILDWELL PRIVATE LIMITED",
"MARVEL BUSINESS SOLUTIONS PRIVATE LIMITED",
"MARVEL BUYING HOUSE PRIVATE LIMITED",
"MARVEL CERAMICS INDIA PRIVATE LIMITED",
"MARVEL CERAMICS PRIVATE LIMITED",
"MARVEL DECOR LIMITED",
"MARVEL DRUGS PVT LTD",
"MARVEL DYERS AND PROCESSORS PRIVATE LIMITED",
"MARVEL ELECTRIC EQUIPMENTS PRIVATE LIMITED",
"MARVEL GEOSPATIAL SOLUTIONS PRIVATE LIMITED",
"MARVEL GLASS PRIVATE LIMITED",
"MARVEL GRANITES PRIVATE LIMITED",
"MARVEL HOSPITALITY SERVICES PRIVATE LIMITED",
"MARVEL HOUSING PRIVATE LIMITED",
"MARVEL INDENTING PRIVATE LIMITED",
"MARVEL INDUSTRIES & SERVICES PRIVATE LIMITED",
"MARVEL INFOCOMM PRIVATE LIMITED",
"MARVEL INFRATECH PRIVATE LIMITED",
"MARVEL ISPAT PRIVATE LIMITED",
"MARVEL MACHINE TOOLS PRIVATE LIMITED",
"MARVEL MACHINES PRIVATE LIMITED",
"MARVEL MEDILINKS PRIVATE LIMITED",
"MARVEL METALS PRIVATE LIMITED",
"MARVEL PAPERS PRIVATE LIMITED",
"MARVEL PRINT HEAT TRANSFER PRIVATE LIMITED",
"MARVEL PROPERTIES PRIVATE LIMITED",
"MARVEL RESIDENCY PRIVATE LIMITED",
"MARVEL SOLREN PRIVATE LIMITED",
"MARVEL SOURCING PRIVATE LIMITED",
"MARVEL TEA ESTATE INDIA LIMITED",
"MARVEL TECHNOLOGY & TOOLS PRIVATE LIMITED",
"MARVEL TOOLS AND ACCESSORIES PRIVATE LIMITED",
"MARVEL TOUCH ALUMINIUM PRIVATE LIMITED",
"MARVEL TOURS PRIVATE LIMITED",
"MARVEL TRIP LIMITED",
"MARVEL VINYLS LIMITED",
"MARVEL VINYLS LIMITED.",
"MARVELING MARKETING PRIVATE LIMITED",
"MARVELL CONSTRUCTIONS AND TECHNIQUES PRIVATE LIMITED",
"MARVELL INDIA PRIVATE LIMITED",
"MARVELL NUTEX PRIVATE LIMITED",
"MARVELLA CORPORATION",
"MARVELLE SKIN CARE PRIVATE LIMITED",
"MARVELLON PHARMACEUTICALS PRIVATE LIMITED",
"MARVELLOUS EXPORTS PRIVATE LIMITED",
"MARVELLOUS INTRA PVT.LTD.",
"MARVELLOUS STEEL PRIVATE LIMITED",
"MARVELORE MINING AND ALLIED INDUSTRIES PRIVATE LIMITED",
"MARVELOUS BUILDINFRA PRIVATE LIMITED",
"MARVELOUS ENGINEERS PRIVATE LIMITED",
"MARVELOUS INFRAESTATE PRIVATE LIMITED",
"MARVELOUS MACHINIST PRIVATE LIMITED",
"MARVELOUS METALS PVT LTD",
"MARVELOUS PROPERTY AND SERVICES PRIVATE LIMITED",
"MARVELOUS VIMERCATI FOUNDRY PRIVATE LIMITED",
"MARVEST AQUA PROTEIN PRIVATE LIMITED",
"MARVEX PIPE TECH PRIVATE LIMITED",
"MARVEX POLYTECH PRIVATE LIMITED",
"MARVI AUTOCOMP PRIVATE LIMITED",
"MARVILLA HOLIDAYS PRIVATE LIMITED",
"MARVIN LIFESTYLE INDIA PRIVATE LIMITED",
"MARVIS INNOVATIONS PRIVATE LIMITED",
"MARVOTECH BUILDER PRIVATE LIMITED",
"MARVY OUTSOURCING PRIVATE LIMITED",
"MARWA IMPEX PRIVATE LIMITED",
"MARWADI CHANDARANA INTERMEDIARIES BROKERS PRIVATE LIMITED",
"MARWADI CHARITABLE FOUNDATION",
"MARWADI COMMODITY BROKER PRIVATE LIMITED",
"MARWADI EDUCATION FOUNDATION GROUP OF INSTITUTIONS",
"MARWADI FINLEASE PRIVATE LIMITED",
"MARWADI HINDI VIDYALAYA HIGH SCHOOL & PRIMARY SCHOOL",
"MARWADI INVESTMENT PRIVATE LIMITED",
"MARWADI METALS AND MINERALS PRIVATE LIMITED",
"MARWADI SHARES AND FINANCE LIMITED",
"MARWADI UNIVERSITY",
"MARWAH HOSPITALS PRIVATE LIMITED",
"MARWAH IRON INDUSTRIES PRIVATE LIMITED",
"MARWAH STEELS PRIVATE LIMITED",
"MARWAN REALITY AND CONSTRUCTIONS PRIVATE LIMITED",
"MARWAR CEMENT LIMITED",
"MARWAR CONSULTANCY PRIVATE LIMITED",
"MARWAR INTER COLLEGE",
"MARWAR JEWELS PRIVATE LIMITED",
"MARWAR METALS PRIVATE LIMITED",
"MARWAR TRUCKING PRIVATE LIMITED",
"MARWARI MEDIA CORPORATIONPRIVATE LIMITED",
"MARWARI RELIEF SOCIETY",
"MARWELL ENNCON TECH PRIVATE LIMITED",
"MARXELEC ENERGY PRIVATE LIMITED",
"MARY DEVELOPERS PVT LTD",
"MARY KAY COSMETICS PRIVATE LIMITED",
"MARYA FROZEN AGRO FOOD PRODUCTS PRIVATE LIMITED",
"MARYA FROZEN AGRO FOODS PRIVATE LIMITED",
"MARYADARAMANNA PATNAM FARMERS PRODUCER COMPANY LIMITED",
"MARYAN APPAREL PRIVATE LIMITED",
"MARYLAND CONSTRUCTION COMPANY PRIVATE LIMITED",
"MARYLAND RESORTS LTD",
"MARYMATHA AGRO FOODS PRIVATE LIMITED",
"MARYMATHA CONSTRUCTION COMPANY",
"MARYMATHA INFRASTRUCTURE PRIVATE LIMITED",
"MARYSADAN PROJECTS PRIVATE LIMITED",
"MARYUS HEALTHCARE PRIVATE LIMITED",
"MARZ SYSTEMS (INDIA) PRIVATE LIMITED",
"MARZOLI TEXTILE MACHINERY MANUFACTURERS PRIVATE LIMITED",
"MAS ADDITIVES PRIVATE LIMITED",
"MAS ALLUMINIUM PRIVATE LIMITED",
"MAS AUTO SYSTEMS PRIVATE LIMITED",
"MAS CALLNET INDIA PRIVATE LIMITED",
"MAS CONSTRUCTION PVT LTD",
"MAS CONSTRUCTIONS",
"MAS ENTERPRISES LIMITED",
"MAS EQUIPMENTS PRIVATE LIMITED",
"MAS FINANCIAL SERVICES LIMITED",
"MAS FREIGHT FORWARDERS PRIVATE LIMITED",
"MAS INDUSTRIES PRIVATE LIMITED",
"MAS LOGISTICS PRIVATE LIMITED",
"MAS MARINE SERVICES INDIA PRIVATE LIMITED",
"MAS OFFICE SYSTEMS PRIVATE LIMITED",
"MAS PACK LIMITED",
"MAS ROLLPRO TECHNOLOGIES PRIVATE LIMITED",
"MAS RURAL HOUSING & MORTGAGE FINANCE LIMITED",
"MAS SEALING SYSTEMS PRIVATE LIMITED",
"MAS SERVICES LTD",
"MAS SHIPPING AGENCIES PRIVATE LIMITED",
"MAS SOLAR SYSTEMS PRIVATE LIMITED",
"MAS SUENO OPTIKA PRIVATE LIMITED",
"MAS SYSTECH PRIVATE LIMITED",
"MAS TECHNOLOGY SYSTEM PRIVATE LIMITED",
"MASALA AUTHENTIC INDIAN CUISINE",
"MASALA KING EXPORTS TRADING PRIVATE LIMITED",
"MASAMB ELECTRONICS SYSTEMS PRIVATE LIMITED",
"MASAND AGRITECH PRIVATE LIMITED",
"MASAND AGRO EQUIPMENTS PVT LTD",
"MASANI POLYMERS PRIVATE LIMITED",
"MASANY CONSTRUCTION EQUIPMENT PRIVATE LIMITED",
"MASARA IMPEX PRIVATE LIMITED",
"MASAS CONSULTANTS INTERNATIONAL PRIVATE LIMITED",
"MASATYA TECHNOLOGIES PRIVATE LIMITED",
"MASAYA PHARMACEUTICALS PRIVATE LIMITED",
"MASC COLLEGE HAUNSBHVI",
"MASCHIO GASPARDO INDIA PRIVATE LIMITED",
"MASCHMEIJER AROMATICS (INDIA) PRIVATE LIMITED",
"MASCO CORPORATION",
"MASCO HOME PRODUCTS PRIVATE LIMITED",
"MASCOM ELECTRONICS PRIVATE LIMITED",
"MASCOM STEEL (INDIA) PRIVATE LIMITED",
"MASCON COMPUTER SERVICES PVT LTD",
"MASCON FINANCIAL SERVICES PRIVATE LIMITED",
"MASCON MULTI SERVICES AND CONSULTANTS PRIVATE LIMITED",
"MASCONS ENGINEERING & CONTRACTING COMPANY PRIVATE LIMITED",
"MASCOR PRECISIONS PRIVATE LIMITED",
"MASCOT AIRCONDITIONING AND ENGINEERING PRIVATE LIMITED",
"MASCOT ALLOYS PRIVATE LIMITED",
"MASCOT AUTOMOTIVE INDIA PRIVATE LIMITED",
"MASCOT BUSINESS SOLUTIONS PRIVATE LIMITED",
"MASCOT CAPITAL AND MARKETING PRIVATE LIMITED",
"MASCOT CNC TOOLS & EQUIPMENTS PRIVATE LIMITED",
"MASCOT DYNAMICS PRIVATE LIMITED",
"MASCOT EDUCATION PRIVATE LIMITED",
"MASCOT ELECTROMECH PRIVATE LIMITED",
"MASCOT ELECTROTEK PRIVATE LIMITED",
"MASCOT ENGINEERING COMPANY",
"MASCOT FASHIONS PRIVATE LIMITED",
"MASCOT FLOWTECH PRIVATE LIMITED",
"MASCOT FORGE PVT LTD",
"MASCOT FROZEN FOODS PRIVATE LIMITED",
"MASCOT GARMENTS PRIVATE LIMITED",
"MASCOT HEALTH SERIES PRIVATE LIMITED",
"MASCOT INFRACON PRIVATE LIMITED",
"MASCOT INFRASTRUCTURE (I) PRIVATE LIMITED",
"MASCOT INTERNATIONAL PRIVATE LIMITED",
"MASCOT MOBILITY INDIA PRIVATE LIMITED",
"MASCOT MOTORS PRIVATE LIMITED",
"MASCOT OUTSOURCING SERVICES PRIVATE LIMITED",
"MASCOT PETROCHEM PRIVATE LIMITED",
"MASCOT PROJECTS PRIVATE LIMITED",
"MASCOT PROPERTIES PRIVATE LIMITED",
"MASCOT PUMP LIMITED",
"MASCOT RECYCLING PRIVATE LIMITED",
"MASCOT SPEED INDIA PRIVATE LIMITED",
"MASCOT SPINCONTROL INDIA PRIVATE LIMITED",
"MASCOT SYSTEMS PRIVATE LIMITED",
"MASCOT VALVES PRIVATE LIMITED",
"MASEN PRODUCTION PRIVATE LIMITED",
"MASER ELECTRONICS PRIVATE LIMITED",
"MASER GAS (CHENNAI) PRIVATE LIMITED",
"MASER INDIA PRIVATE LIMITED",
"MASH AGRO FOODS LIMITED.",
"MASH AUDIO VISUALS PRIVATE LIMITED",
"MASH ENERGY INDIA PRIVATE LIMITED",
"MASH INTERNATIONAL PRIVATE LIMITED",
"MASH SPIRITS PRIVATE LIMITED",
"MASH VIRTUAL PRIVATE LIMITED",
"MASHAKTI FOOD PRODUCTS LIMITED",
"MASHAL HOTELS PVT LTD",
"MASHAL SPORTS PRIVATE LIMITED",
"MASHI EXPORTS INDIA PRIVATE LIMITED",
"MASHIBA ELEVATORS INDIA PRIVATE LIMITED",
"MASHIV SHAKTI CONSTRUCTIONS PRIVATE LIMITED",
"MASHIVA FOODS PRIVATE LIMITED",
"MASHIVA TECHNOLOGIES PRIVATE LIMITED",
"MASHOBRA RESORTS LIMITED",
"MASHREQ BANK PSC",
"MASHREQ GLOBAL SERVICES PRIVATE LIMITED",
"MASIBUS AUTOMATION AND INSTRUMENTATION PRIVATE. LIMITED",
"MASIHA MEDICA PVT LTD",
"MASILA ARIYA KITCHEN EQUIPMENTS PRIVATE LIMITED",
"MASIMO MEDICAL TECHNOLOGIES INDIA PRIVATE LIMITED",
"MASIN PROJECTS PRIVATE LIMITED",
"MASINA ALLOYS PRIVATE LIMITED",
"MASINA HOSPITAL",
"MASINA HOSPITAL TRUST",
"MASINENI HOTELS PRIVATE LIMITED",
"MASITIA CAPITAL SERVICES PRIVATE LIMITED",
"MASK BUSINESS CONSULTANCY PRIVATE LIMITED",
"MASK ENTERPRISE LLP",
"MASK EXPORTS PRIVATE LTD",
"MASK FASTENERS PRIVATE LIMITED",
"MASK IMPEX PRIVATE LIMITED",
"MASK LOGISTICS PRIVATE LIMITED",
"MASK POLYMERS INSULATORS PRIVATE LIMITED",
"MASK POLYMERS PRIVATE LIMITED",
"MASK SEALS PRIVATE LIMITED",
"MASKAP FASHION WEAR EXPORTS PRIVATE LIMITED",
"MASKARA ENTERPRISES PRIVATE LIMITED",
"MASKARA FINVEST PRIVATE LIMITED",
"MASKARA VINIMAY PVT LTD",
"MASKATI CHARITABLE HOSPITAL",
"MASKATI INVESTMENT PRIVATE LIMITED",
"MASKATI SHIPPING AND LOGISTICS PRIVATE LIMITED",
"MASKON LIFE SCIENCES PRIVATE LIMITED",
"MASKS LIFE SCIENCES PRIVATE LIMITED",
"MASL CONTROL CABLES PRIVATE LIMITED",
"MASLANDAPUR BHUDEV SMRITI BALIKA VIDYALAYA",
"MASO AUTOMOTIVES PRIVATE LIMITED",
"MASO TECHNOLOGIES PRIVATE LIMITED",
"MASON ESTATE (INDIA) PRIVATE LIMITED",
"MASON MINERALS PRIVATE LIMITED",
"MASON STEEL TRADERS PRIVATE LIMITED",
"MASONIC PUBLIC SCHOOL",
"MASOOM AGRO FOOD PRIVATE LIMITED",
"MASOOM EDUCATION",
"MASP FOODS PRIVATE LIMITED",
"MASPAR INDUSTRIES PRIVATE LIMITED",
"MASPERO INDIA PRIVATE LIMITED",
"MASPOLI VENTURES PRIVATE LIMITED",
"MASQ SYNDICATE PRIVATE LIMITED",
"MASQATI DAIRY PRODUCTS LIMITED",
"MASQATI FOOD LIMITED",
"MASROS ENGINEERS PRIVATE LIMITED",
"MASS AWASH PRIVATE LIMITED",
"MASS CINE PRODUCTIONS PRIVATE LIMITED",
"MASS CROP SCIENCE PRIVATE LIMITED",
"MASS DYECHEM PRIVATE LIMITED",
"MASS EDUCATIONGOVT OF ORISSA",
"MASS EXPRESS CARGO PRIVATE LIMITED",
"MASS HEIGHTS PRIVATE LIMITED",
"MASS INFONET PRIVATE LIMITED",
"MASS INTERNATIONAL EXPORTS PRIVATE LIMITED",
"MASS MANAGEMENT SERVICES PRIVATE LIMITED",
"MASS N-ERGY PRIVATE LIMITED",
"MASS PACKAGINGS PRIVATE LIMITED",
"MASS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"MASS TECH CONTROLS PRIVATE LIMITED",
"MASS TECHNOMECH PRIVATE LIMITED",
"MASS TELECASTING PRIVATE LIMITED",
"MASS WEIGH SYSTEMS PRIVATE LIMITED",
"MASS WEIGHING AND BAGGING PRIVATE LIMITED",
"MASS WHEELS PRIVATE LIMITED",
"MASS WIRE AND STEELS PRIVATE LIMITED",
"MASSA IZOLYATOR MEHRU PRIVATE LIMITED",
"MASSANA INDIA PRIVATE LIMITED",
"MASSCO MEDIA PRIVATE LIMITED",
"MASSCODE LIFESCIENCE PRIVATE LIMITED",
"MASSEY INVESTMENTS PRIVATE LIMITED",
"MASSEYS ENTERPRISES PRIVATE LIMITED",
"MASSILLY INDIA PACKAGING PVT LTD",
"MASSIMO DUTTI INDIA PRIVATE LIMITED",
"MASSIMO ENTERPRISE",
"MASSIVE RESTAURANTS PRIVATE LIMITED",
"MASSMED PRIVATE LIMITED",
"MASSMUTUAL GLOBAL BUSINESS SERVICES INDIA LLP",
"MASSON HEALTHCARE PRIVATE LIMITED",
"MASSPRO PRINTERS INDIA PRIVATE LIMITED",
"MASSS GLASS INDIA PRIVATE LIMITED",
"MASSSKILL DEVELOPMENT PRIVATE LIMITED",
"MASSTRANS TECHNOLOGIIES PRIVATE LIMITED",
"MAST INDIA TRADING SERVICES PRIVATE LIMITED",
"MAST INNOVATIVE PRODUCTS PRIVATE LIMITED",
"MAST MOBILE MEDIA PRIVATE LIMITED",
"MASTA BEARING HOUSING PRIVATE LIMITED",
"MASTEC QUADGEN WIRELESS LLP",
"MASTECH DIGITAL PRIVATE LIMITED",
"MASTEK ENTERPRISE SOLUTIONS PRIVATE LIMITED",
"MASTEK LIMITED",
"MASTEL IMAGING AND RESEARCH CENTRE PRIVATE LIMITED",
"MASTEL MEDICAL SYSTEMS PRIVATE LIMITED",
"MASTER ART PRIVATE LIMITED",
"MASTER AUTOMECH PRIVATE LIMITED",
"MASTER AUTOMOTIVE COMPONENTS PRIVATE LIMITED",
"MASTER BLENDERS PRIVATE LIMITED",
"MASTER BUILDERS SOLUTIONS INDIA PRIVATE LIMITED",
"MASTER CABLES & NETWORK PRIVATE LIMITED",
"MASTER CAPITAL SERVICES LIMITED",
"MASTER CHAIN PRIVATE LIMITED",
"MASTER CLEAN SOLUTIONS SERVICES PRIVATE LIMITED",
"MASTER COMPONENTS LIMITED",
"MASTER COMPUTER SERVICES PRIVATE LIMITED",
"MASTER CONSTRUCTION COMPANY",
"MASTER CONSULTANCY SERVICES PRIVATE LIMITED",
"MASTER CRAFTMAN INDIA PVT LTD",
"MASTER DINANATH MANGESKAR SOMTHANA",
"MASTER ESTATES PRIVATE LIMITED",
"MASTER FAB INDUSTRIES",
"MASTER FIRE AND SAFETY PRIVATE LIMITED",
"MASTER FIRE FIGHTERS PRIVATE LIMITED",
"MASTER FLOORS INDIA PRIVATE LIMITED",
"MASTER FLUID SOLUTIONS (INDIA) PRIVATE LIMITED",
"MASTER FOILS (INDIA) LIMITED",
"MASTER FOOD PRODUCTS PVT LTD",
"MASTER FORGE INDIA PRIVATE LIMITED",
"MASTER FRUIT COMPANY PRIVATE LIMITED",
"MASTER GASKETS PRIVATE LIMITED",
"MASTER GOLD PRIVATE LIMITED",
"MASTER HANDLERS PRIVATE LIMITED",
"MASTER HEAT TREATERS PRIVATE LIMITED",
"MASTER INFRASTRUCTURE AND REAL ESTATE DEVELOPERS LIMITED",
"MASTER INFRASTRUCTURE PRIVATE LIMITED",
"MASTER INSURANCE BROKERS LIMITED",
"MASTER INTEGRATORS PRIVATE LIMITED",
"MASTER LEVI SERVICES (INDIA) PRIVATE LIMITED",
"MASTER LINQUE AUTOMATION INDIA PRIVATE LIMITED",
"MASTER LUBE ENGINEERS PRIVATE LIMITED",
"MASTER MARINE SERVICES PRIVATE LIMITED",
"MASTER MIND COMMERCIAL PVT LTD",
"MASTER MINDS",
"MASTER MOULDS PRIVATE LIMITED",
"MASTER MYLIFE EQ EDUCATIONPRIVATE LIMITED",
"MASTER NIDAVELLIR AEROMED PRIVATE LIMITED",
"MASTER POLISHERS PRIVATE LIMITED",
"MASTER PORTFOLIO SERVICES LIMITED",
"MASTER PROMOTERS PRIVATE LIMITED",
"MASTER PROPERTIES PRIVATE LIMITED",
"MASTER SHARE AND STOCK BROKERS PRIVATE LIMITED",
"MASTER SOFTWARE SOLUTION HITECH PRIVATE LIMITED",
"MASTER STAFFING SOLUTIONS PRIVATE LIMITED",
"MASTER STROKE INTERIORS PRIVATE LIMITED",
"MASTER TOUR ORGANISERS PRIVATE LIMITED",
"MASTER TROUSERS PRIVATE LIMITED",
"MASTER VENTURES PRIVATE LIMITED",
"MASTERBLEND INDUSTRIES PRIVATE LIMITED",
"MASTERBRAIN AGRO INDUSTRY PRIVATE LIMITED",
"MASTERCAM INDIA PRIVATE LIMITED",
"MASTERCAMPUS PRIVATE LIMITED",
"MASTERCARD INDIA SERVICES PRIVATE LIMITED",
"MASTERCARD MOBILE TRANSACTIONS SOLUTIONS PRIVATE LIMITED",
"MASTERCARD MONEY TRANSFER SERVICES INDIA PRIVATE LIMITED",
"MASTERCARD TECHNOLOGY PRIVATE LIMITED",
"MASTERCARD XBS TECHNOLOGIES PRIVATE LIMITED",
"MASTERCERT LLP",
"MASTERCHOW FOODS PRIVATE LIMITED",
"MASTERCOM TECHNOLOGY SERVICES INDIA PRIVATE LIMITED",
"MASTERCRAFT SEAFOOD EXPORTS PRIVATE LIMITED",
"MASTERCUT PICTURES PRIVATE LIMITED",
"MASTERFLEXO CABLES PRIVATE LIMITED",
"MASTERGENIE SERVICES PRIVATE LIMITED",
"MASTERGUARD PROECTIVE SERVICES PRIVATE LIMITED",
"MASTERJEE IIT ACADEMY",
"MASTERJI GARMENTS",
"MASTERKEY CAPITAL INVESTMENTS PRIVATE LIMITED",
"MASTERKEY HOLDINGS PRIVATE LIMITED",
"MASTERLINE LUBRICANTS PRIVATE LIMITED",
"MASTERLINE TECHNOLOGIES PRIVATE LIMITED",
"MASTERLINE TELEBIZ LIMITED",
"MASTERLINE TELEBIZ PRIVATE LIMITED",
"MASTERMIND (INDIA) PVT LTD",
"MASTERMIND ENGINEERING PRODUCTS PRIVATE LIMITED",
"MASTERMIND MONEY SOLUTIONS PRIVATE LIMITED",
"MASTERMIND PUBLICATIONS (INDIA) PRIVATE LIMITED",
"MASTERMIND REALTY AND VENTURES PRIVATE LIMITED",
"MASTERMIND TRAINING AND CONSULTANCY SERVICES PRIVATE LIMITED",
"MASTERMINDZ BRANDCOM LLP",
"MASTERPIECE INDIA PRIVATE LIMITED",
"MASTERPLAN ARCHITECTURAL SERVICES PRIVATE LIMITED",
"MASTERPLAST INDIA PRIVATE LIMITED",
"MASTERPREP EDUCATION LIMITED",
"MASTERPRO FACILITY SERVICES PRIVATE LIMITED",
"MASTERS ALUMINIUM INDIA PRIVATE LIMITED",
"MASTERS DEVELOPEMENT MANAGEMENT INDIA PRIVATE LIMITED",
"MASTERS FMS PRIVATE LIMITED",
"MASTERS HOMEOPATHY PRIVATE LIMITED",
"MASTERS INDIA IT SOLUTIONS PRIVATE LIMITED",
"MASTERS INDIA PRIVATE LIMITED",
"MASTERS LOGISTICS SOLUTIONS INDIA PRIVATE LIMITED",
"MASTERS MANAGEMENT CONSULTANTS INDIA PRIVATE LIMITED",
"MASTERS TECHNOLOGY BUSINEZ PRIVATE LIMITED",
"MASTERS UNION SCHOOL OF BUSINESS",
"MASTERSOFT ERP SOLUTIONS PRIVATE LIMITED",
"MASTERSTROKE MEDIA PRIVATE LIMITED",
"MASTERSTROKE TECHNOSERVICES OPC PRIVATE LIMITED",
"MASTERWINGS MACHINES PRIVATE LIMITED",
"MASTHEAD TECHNOLOGIES PRIVATE LIMITED",
"MAST-JAEGERMEISTER SERVICES (INDIA) PRIVATE LIMITED",
"MASTKIN FOODS PRIVATE LIMITED",
"MASTRO METALS PRIVATE LIMITED",
"MASTRO STORE PRIVATE LIMITED",
"MASTUR LAL PRIVATE LIMITED",
"MASTURLAL CORDS AND ROPES PRIVATE LIMITED",
"MASTURLAL FABRICHEM PRIVATE LIMITED",
"MASU BRAKE PADS PRIVATE LIMITED",
"MASU BRAKES PRIVATE LIMITED",
"MASUBA INSTRUMENTS PVT LTD",
"MASUM TRADE-LINK PRIVATE LIMITED",
"MASUNDA NEW BARRACKPORE BOYS HIGH SCHOOL",
"MASUVIC INDSUP PRIVATE LIMITED",
"MASWER AUTOMOTIVE INDIA PRIVATE LIMITED",
"MASYC PROJECTS PRIVATE LIMITED",
"MASYCODA SOLUTIONS PRIVATE LIMITED",
"MAT BRAKES INDIA PRIVATE LIMITED",
"MAT INDIA TECHNOLOGIES PRIVATE LIMITED",
"MAT INTERNATIONAL PRIVATE LIMITED",
"MAT MARINE SERVICES PRIVATE LIMITED",
"MAT SHIPPING AND SERVICES",
"MAT WHITE GUM INDUSTRIES PRIVATE LIMITED",
"MATA ALLOYS PRIVATE LIMITED",
"MATA CHANAN DEVI HOSPITAL",
"MATA CHUNRI PALACE PRIVATE LIMITED",
"MATA CONSTRUCTION AND BUILDERS PRIVATE LIMITED",
"MATA DADHIMATI METALS & MINERALS PRIVATE LIMITED",
"MATA GUJARI PUBLIC SENIOR SECONDARY SCHOOL",
"MATA JANKI CONCRETE PRIVATE LIMITED",
"MATA LAXMI NURSING HOME AND INVESTIGATION CENTRE P LTD",
"MATA ROAD CARRIER PRIVATE LIMITED",
"MATA ROOP RANI MAGGO HOSPITAL PRIVATE LIMITED",
"MATA SAHIB KAUR KHALSA GIRLS COLLEGE OF EDUCATION",
"MATA SECURITIES INDIA PRIVATE LIMITED",
"MATA TRANSPORT PRIVATE LIMITED",
"MATA VAISHNO PACKING PRIVATE LIMITED",
"MATA VAISHNOU METAL AND STEEL PRIVATE LIMITED",
"MATAJI IMPEX KESARWALA PRIVATE LIMITED",
"MATAJI PIPE AND FITTINGS PRIVATE LIMITED",
"MATAJI VANIJYA PRIVATE LIMTIED",
"MATALIA STOCK BROKING PRIVATE LIMITED",
"MATAMANSAJI NAMKEEN PRIVATE LIMITED",
"MATANE - JEWELS PRIVATE LIMITED",
"MATANGI INDUSTRIES LLP",
"MATANGI MOTOR MAX PRIVATE LIMITED",
"MATANGI POLYMERS AND PRODUCTS PRIVATE LIMITED",
"MATANGI RUBBER PRIVATE LIMITED",
"MATAOSHRI VIDYAMANDIR",
"MATARANI COMMOTRADE PRIVATE LIMITED",
"MATARANI RESOURCES PRIVATE LIMITED",
"MATASHREE MERCANTILE PVT LTD",
"MATAWAN BUSINESS PRIVATE LIMITED",
"MATCEL TRADING PRIVATE LIMITED",
"MATCH DIGISOL PRIVATE LIMITED",
"MATCH GRAPHICS PRIVATE LIMITED",
"MATCHBOX PICTURES PRIVATE LIMITED",
"MATCHBOX SHOTS LLP",
"MATCHES GOA PVT LTD",
"MATCHING PANTS PRIVATE LIMITED",
"MATCHLESS HOSPITALITY SERVICES PRIVATE LIMITED",
"MATCHLESS RESTAURANT PRIVATE LIMITED",
"MATCHLOG SOLUTIONS PRIVATE LIMITED",
"MATCHPOINT SOLUTIONS PRIVATE LIMITED",
"MATCHWELL DECOR PRIVATE LIMITED",
"MATCHWELL DIE CASTERS PRIVATE LIMITED",
"MATCHWELL ENGINEERING PRIVATE LIMITED",
"MATCHWELL ENGINEERING PVT LTD",
"MATCO CARPETS AND ACCESSORIES PRIVATE LIMITED",
"MATE CONSULTANTS PVT LTD",
"MATE INDIA PRIVATE LIMITED",
"MATE MARKETING AND IMPEX PRIVATE LIMITED",
"MATEBIZ PRIVATE LIMITED",
"MATECH EQUIPMENT PRIVATE LIMITED",
"MATEL MOTION AND ENERGY SOLUTIONS PRIVATE LIMITED",
"MATELABS INNOVATIONS PRIVATE LIMITED",
"MATELLA FABRICATOR & BIO PRODUCTS PRIVATE LIMITED",
"MATELLIO INDIA PRIVATE LIMITED",
"MATEO TRADING PRIVATE LIMITED",
"MATERIA ENGINEERING PRIVATE LIMITED",
"MATERIA MEDITECH PRIVATE LIMITED",
"MATERIAL CONVEYING ENGINEERS PRIVATE LIMITED",
"MATERIAL INSPECTION LABORATORY",
"MATERIAL MOVELL INDIA PVT LTD",
"MATERIAL RECYCLING ASSOCIATION OF INDIA",
"MATERIALS MAINTENANCE MANAGEMENT SERVICES PRIVATE LIMITED",
"MATESHWARI BUS OPERATIONS PRIVATE LIMITED",
"MATESHWARI COMCON PRIVATE LIMITED",
"MATESHWARI FOOD STUFF PRIVATE LIMITED",
"MATESHWARI HEALTHCARE PRIVATE LIMITED",
"MATESHWARI PAPER MILL PRIVATE LIMITED",
"MATESHWARI TEMPLE CONSTRUCTION PRIVATE LIMITED",
"MATESHWARI TEXTILES PRIVATE LIMITED",
"MATESWARI MINERALS",
"MATEX NET PRIVATE LIMITED",
"MATGLOBER CAREERS PRIVATE LIMITED",
"MATGROW RENEWABLES PRIVATE LIMITED",
"MATH BROS ENGINEERS PRIVATE LIMITED",
"MATH CREATIONS PRIVATE LIMITED",
"MATH MATICS WEALTH MANAGEMENT SERVICES OPC PRIVATE LIMITED",
"MATHA & CO",
"MATHA COLLEGE OF TECHNOLOGY",
"MATHA EDUCATION SOCIETY",
"MATHA EXPORT PRIVATE. LIMITED",
"MATHA MEDICAL CENTRE PRIVATE LIMITED",
"MATHA PROPERTIES (INDIA) PRIVATE LIMITED",
"MATHA STEELS PRIVATE LIMITED",
"MATHABHANGA DETERGENTS & CHEMICALS PRIVATE LIMITED",
"MATHADI AND UNPROTECTED LABOUR BOARD NAGPUR",
"MATHADI AND UNPROTECTED LABOUR BOARD NASHIK",
"MATHADI HOSPITAL TRUST",
"MATHANI PAPER MILLS PRIVATE LIMITED",
"MATHENSON RECORDS MANAGEMENT PRIVATE LIMITED",
"MATHESON BOSANQUET ENTERPRISES PRIVATE L IMITED",
"MATHETICS ENGICON PRIVATE LIMITED",
"MATHEUS IT SOLUTION OPC PRIVATE LIMITED",
"MATHFLUX BUSINESS SOLUTIONS PRIVATE LIMITED",
"MATHI EDUCATIONAL AND CHARITABLE TRUST",
"MATHI INTEGRATED HEALTH CENTRE PRIVATE LIMITED",
"MATHI NURSERY AND PRIMARY SCHOOL MATHI SCHOOL OF EXCELLENCE",
"MATHIAS ALUMINIUM SYSTEMS PRIVATE LIMITED",
"MATHIAS CONSTRUCTION PRIVATE LIMITED",
"MATHIIT LEARNING PRIVATE LIMITED",
"MATHIYAN CONSTRUCTION PRIVATE LIMITED",
"MATHOSHREE ENTERPRISES PRIVATE LIMITED",
"MATHOSHRI SOU SARASVATI BABURAO CHAKOTE PRIMARY SCHOOL SOLAPUR",
"MATHRA DASS GRAND SONS PRIVATE LIMITED",
"MATHRAN SECURITIES PRIVATE LTD.",
"MATHRU BUILDMET ENGINEERS PRIVATE LIMITED",
"MATHRUKA PRACHARANALAYAM LTD",
"MATHRUSRI LOGISTICS PRIVATE LIMITED",
"MATHSONS RE-INSURANCE BROKERS PRIVATE LIMITED",
"MATHUR BROTHERS PRIVATE LIMITED",
"MATHUR CORR TECH PRIVATE LIMITED",
"MATHUR HOSPITALITY PRIVATE LIMITED",
"MATHUR INFRASOLUTIONS PRIVATE LIMITED",
"MATHURA DAIRY PRIVATE LIMITED",
"MATHURA FIBRES AND COTTON INDUSTRIES",
"MATHURA POLYPACK PRIVATE LIMITED",
"MATHURA STONE CRUSHERS PRIVATE LIMITED",
"MATHURA WASTEWATER MANAGEMENT PRIVATE LIMITED",
"MATHURAM SWASTHA EVAM SHIKSHAN SANSTHAN",
"MATHURE METAL WORKS PRIVATE LIMITED",
"MATHWORKS INDIA PRIVATE LIMITED",
"MATI BIRI FACTORY PVT LTD",
"MATI MATE AGROMART PRIVATE LIMITED",
"MATIAS HEALTHCARE PRIVATE LIMITED",
"MATILAL AND GAURI FOOD & STORAGE PRIVATE LIMITED",
"MATILDA CLOUD PRIVATE LIMITED",
"MATIMAND NIWASI VIDYALAY GEORAI BEED",
"MATIN ASSESSMENT PRIVATE LIMITED",
"MATIS MULTI SPECIALITY HOSPITAL",
"MATISH HEALTHCARE PRIVATE LIMITED",
"MATISH PACKAGING PRIVATE LIMITED",
"MATIX FERTILISERS AND CHEMICALS LIMITED",
"MATLEK LIVES PRIVATE LIMITED",
"MATLOGIX TECHNOLOGIES PRIVATE LIMITED",
"MATOD INDUSTRIES PRIVATE LIMITED",
"MATOSHREE COTTON PRIVATE LIMITED",
"MATOSHREE HEALTH CARE PRIVATE LIMITED",
"MATOSHREE KAMALBAI VISPUTE ENGLISH MEDIUM SCHOOL",
"MATOSHREE TRAVELS PRIVATE LIMITED",
"MATOSHREE VIDYAMANDIR",
"MATOSHRI AASARABAI POLYTECHNIC",
"MATOSHRI HIRAI DESHMUKH SECONDARY AND HIGHER SECONDARY SCHOOL SHEDGEWADI",
"MATOSHRI LAXMI SUGAR CO-GENERATION INDUSTRIES LIMITED",
"MATOSHRI LAXMIBAI MHETRE COLLEGE OF EDUCATION",
"MATOSHRI TECH PRIVATE LIMITED",
"MATPROP TECHNICAL SERVICES PRIVATE LIMITED",
"MATRA AHAR PRIVATE LIMITED",
"MATRA KRIPA FASHION INDUSTRIES PRIVATE LIMITED",
"MATRA REALTY AND DEVELOPERS LIMITED",
"MATRI DAIRY PRIVATE LIMITED",
"MATRI MANDIR HIMGHAR PRIVATE LIMITED",
"MATRI MANDIR MULTIPURPOSE COLD CHAIN LIMITED",
"MATRI MANDIR RICE MILLS PRIVATE LIMITED",
"MATRI SHREE POWERTRONICS PRIVATE LIMITED",
"MATRIBHUMI NATURE FARMS AND LANDS PRIVATE LIMITED",
"MATRIC AUTO SOLUTIONS PRIVATE LIMITED",
"MATRIKA HOSPITAL PRIVATE LIMITED",
"MATRIMONY COM LIMITED",
"MATRIMONY.COM",
"MATRIOT SOLUTIONS PRIVATE LIMITED",
"MATRISWA CONSTRUCTION PRIVATE LIMITED",
"MATRISWA INFRA PRIVATE LIMITED",
"MATRITAW BHAWANI SERVICES PRIVATE LIMITED",
"MATRIX",
"MATRIX 3D INFOCOM PRIVATE LIMITED",
"MATRIX AGRO PRIVATE LIMITED",
"MATRIX AGRO SOLUTIONS PRIVATE LIMITED",
"MATRIX BHARAT PTE. LIMITED",
"MATRIX BIOMEDICS PRIVATE LIMITED",
"MATRIX BOILERS PRIVATE LIMITED",
"MATRIX BUSINESS MACHINES PRIVATE LIMITED",
"MATRIX BUSINESS SERVICES INDIA PRIVATE LIMITED",
"MATRIX CELLULAR (INTERNATIONAL) SERVICES PRIVATE LIMITED",
"MATRIX CELLULAR INTERNATIONAL SERVICES LIMITED",
"MATRIX CERAMIC",
"MATRIX CHEMTECH PRIVATE LIMITED",
"MATRIX CLOTHING PRIVATE LIMITED",
"MATRIX COMPONENTS",
"MATRIX COMSEC PRIVATE LIMITED",
"MATRIX CONTAINERS AND CARTONS PRIVATE LIMITED",
"MATRIX CREDIT RISK CONTROLS PRIVATE LIMITED",
"MATRIX CUTTING TOOLS PRIVATE LIMITED",
"MATRIX DEVELOPERS PRIVATE LIMITED",
"MATRIX DISTRIBUTION HOUSE PRIVATE LIMITED",
"MATRIX DISTRIBUTOR PRIVATE LIMITED",
"MATRIX DISTRIBUTORS PVT LTD",
"MATRIX EDUCARE PRIVATE LIMITED",
"MATRIX ENCLAVES PROJECTS DEVELOPMENTS PRIVATE LIMITED",
"MATRIX ENTERPRISES",
"MATRIX EQUIPMENTS & TECHNO SERVICES PRIVATE LIMITED",
"MATRIX EQUITRADE PRIVATE LIMITED",
"MATRIX FACILITY SERVICES INDIA PVT LTD",
"MATRIX FAST TOOLS TECHNOLOGIES PRIVATE LIMITED",
"MATRIX FINANCERS LIMITED",
"MATRIX FREIGHT SYSTEMS PRIVATE LIMITED",
"MATRIX GAS AND RENEWABLES LIMITED",
"MATRIX GRATING PRIVATE LIMITED",
"MATRIX GREEN ENERGY PRIVATE LIMITED",
"MATRIX GUARDTECH PRIVATE LIMITED",
"MATRIX HOUSEWARES PRIVATE LIMITED.",
"MATRIX HR SOLUTIONS PRIVATE LIMITED",
"MATRIX IMAGING SOLUTIONS INDIA PRIVATE LIMITED",
"MATRIX INDIA ASSET ADVISORS PRIVATE LIMITED",
"MATRIX INDIA ENTERTAINMENT CONSULTANS PRIVATE LIMITED",
"MATRIX INFO SYSTEMS PRIVATE LIMITED",
"MATRIX INSPECTION & ENGINEERING SERVICES PRIVATE LIMITED",
"MATRIX INTEGRATED PRODUCTS LLP",
"MATRIX INTERTECH PRIVATE LIMITED",
"MATRIX INVESTMENTS PRIVATE LIMITED",
"MATRIX LIFE SCIENCE PRIVATE LIMITED",
"MATRIX LIFESCIENCES PRIVATE LIMITED",
"MATRIX MEDIA SOLUTIONS PRIVATE LIMITED",
"MATRIX MEDICALS PRIVATE LIMITED",
"MATRIX MEDICARE PRIVATE LIMITED",
"MATRIX METERS PRIVATE LIMITED",
"MATRIX MINING SOLUTIONS PRIVATE LIMITED",
"MATRIX MOON PRIVATE LIMITED",
"MATRIX PARTNERS INDIA ADVISORS LLP",
"MATRIX PHARMA-CHEM (INDIA) PRIVATE LIMITED",
"MATRIX PHARMA-CHEM INDIA PRIVATE LIMITED",
"MATRIX PLUS PRIVATE LIMITED",
"MATRIX PMC CONSORTIUM PRIVATE LIMITED",
"MATRIX POLYTECH PRIVATE LIMITED .",
"MATRIX POWER (WIND) PRIVATE LIMITED",
"MATRIX PRIVATE LIMITED",
"MATRIX PUBLICITIES AND MEDIA INDIA PRIVATE LIMITED",
"MATRIX REALTECH PRIVATE LIMITED",
"MATRIX RECON PRIVATE LIMITED",
"MATRIX ROBOTICS PRIVATE LIMITED",
"MATRIX ROLLER MILL PRIVATE LIMITED",
"MATRIX SEAFOODS INDIA LIMITED",
"MATRIX SECURITY AND SURVEILLANCE PRIVATE LIMITED",
"MATRIX SPORTS MARKETING PRIVATE LIMITED",
"MATRIX STAMPI LIMITED",
"MATRIX STONETECH AND SERVICES PRIVATE LIMITED",
"MATRIX SUPER SPECIALITY HOSPITALS LLP",
"MATRIX SYNERGIES PRIVATE LIMITED",
"MATRIX TECHNICAL SERVICES PRIVATE LIMITED",
"MATRIX THERAPEUTICS PRIVATE LIMITED.",
"MATRIX TOOLS AND COMPONENTS PRIVATE LIMITED",
"MATRIX TOOLS AND METAPLAST PRIVATE LIMITED",
"MATRIX TUBE AND FITTINGS PRIVATE LIMITED",
"MATRIX WAREHOUSING PRIVATE LIMITED",
"MATRIX WEIGHING SYSTEMS PRIVATE LIMITED",
"MATRIX WIND ENERGY PRIVATE LIMITED",
"RESMED TECHNOLOGY INDIA PRIVATE LIMITED",
"MATRIXONE BRANDS PRIVATE LIMITED",
"MATRIXX COMPONENTS (INDIA) PRIVATE LIMITED",
"MATRO INFRAVENTURE PRIVATE LIMITED",
"MATRONIX OPTOTECHNIK PRIVATE LIMITED",
"MATRU SHRI M P SHAH MADHYAMIK SHALA",
"MATRU VIDYALAYA",
"MATRUBHOOMI EDUCATION SOCIETY HIGH SCOOL",
"MATRUBHUMI LANDMARK PRIVATE LIMITED",
"MATRUBHUMI ORGANIC PRODUCER COMPANY LIMITED",
"MATRUSEVA SANGH SOCIAL WORK WOMENS COLLE",
"MATRUSRI D A V PUBLIC SCHOOL",
"MATRUTIRTH SINDKHEDRAJA INFRA PRIVATE LIMITED",
"MATS INDIA PRIVATE LIMITED",
"MATS PHARMA PRIVATE LIMITED",
"MATS UNIVERSITY",
"MATSON SURGICALS PRIVATE LIMITED",
"MATSONS ELECTRO COATS PRIVATE LIMITED",
"MATSPIN INDIA PRIVATE LIMITED",
"MATSU ENTERPRISES PRIVATE LIMITED",
"MATSUI TECHNOLOGIES INDIA LIMITED",
"MATSYA AUTOMOBILES LIMITED",
"MATSYA GREEN ENVIRO PRIVATE LIMITED",
"MATSYA PRECISION PRIVATE LIMITED",
"MATSYA SHIPPING & PORTS PRIVATE LIMITED",
"MATSYA TRAVEL SERVICES PRIVATE LIMITED",
"MATSYACARE PRIVATE LIMITED",
"MATSYODARI INVESTMENT & HOLDINGS PRIVATE LIMITED",
"MATSYODARI SHIKSHAN SANSTHAS ART COLLAGE TIRTHPURI",
"MATSYODARI STEEL AND ALLOY PRIVATE LIMITED",
"MATSYODARI VIDYALAYA GHUNGARDE HADGAON",
"MATT TELECOM PRIVATE LIMITED",
"MATTA PLASTICS PRIVATE LIMITED",
"MATTA PLASTOCHEM PRIVATE LIMITED",
"MATTATHIL MOTORS PRIVATE LIMITED",
"MATTE MULTITRADE LIMITED",
"MATTEL TOYS INDIA LIMITED",
"MATTEO HEALTHCARE PRIVATE LIMITED",
"MATTERHORN CHEM PHARMA PRIVATE LIMITED",
"MATTEX JEWELS PRIVATE LIMITED",
"MATTHEWS INDUSTRIAL EQUIPMENTS TRADING PRIVATE LIMITED",
"MATTS CORNER INDIA PRIVATE LIMITED",
"BILL GOSLING INDIA PRIVATE LIMITED",
"MATTU GARMENTS PRIVATE LIMITED",
"MATU INTERNATIONAL PRIVATE LIMITED",
"MATULYA PROCESSORS PRIVATE LIMITED",
"MATURAM NAKIPURIA SONS ENTERPRISE PRIVATE LIMITED",
"MATURI VENKATA SUBBARAO ENGINEERING COLLEGE",
"MATUSHI TRADE LINKERS PRIVATE LIMITED",
"MATUSHREE ANCILLARY SERVICES PRIVATE LIMITED",
"MATUSHREE GOMATI HOSPITAL",
"MATUSHREE REAL ESTATE DEVELOPERS PRIVATE LIMITED",
"MATUSHRI JAMNABAI BHAGWANDAS KANYA VIDYALAYA",
"MATUSHRI L G DHOLAKIYA SCHOOL RAJKOT",
"MATXIN LABS PRIVATE LIMITED",
"MATY FOODCHAIN & KITCHEN PRIVATE LIMITED",
"MATZ PUMPS PRIVATE LIMITED",
"MAUI JIM SUN OPTICS INDIA PRIVATE LIMITED",
"MAUJ MOBILE PRIVATE LIMITED",
"MAUKTIK RETAIL PRIVATE LIMITED",
"MAULANA ABDUR RAZZAQUE ANGLO URDU HIGH SCHOOL JALGAON",
"MAULANA AZAD COLLEGE",
"MAULANA AZAD COLLEGE OF ARTS, SCIENCE AND COMMERCE",
"MAULANA AZAD INTER COLLEGE BAREILLY",
"MAULANA AZAD INTER COLLEGE S GANJ",
"MAULANA AZAD MEDICAL COLLEGE",
"MAULANA AZAD NATIONAL INSTITUTE OF TECHNOLOGY",
"MAULANA AZAD NATIONAL URDU UNIVERSITY",
"MAULANA AZAD POLYTECHNIC SOLAPUR",
"MAULANA AZAD PRIMARY SCHOOL",
"MAULANA AZAD URDU GIRLS HIGH SCHOOL",
"MAULANA AZAD URDU HIGH SCHOOL BADNAPUR",
"MAULANA ENGINEERING PRIVATE LIMITED",
"MAULANA HASRAT MOHANI MEMORIAL GIRLS HIGH SCHOOL",
"MAULANA S A URDU HI RANJANI JALNA",
"MAULI AUTOTECH PRIVATE LIMITED",
"MAULI CAST TECH PRIVATE LIMITED",
"MAULI ELECTRONICS AND APPLIANCES DEALERS PRIVATE LIMITED",
"MAULI ENTERPRISES",
"MAULI FOODS & AGRI PROCESSING PRIVATE LIMITED",
"MAULI FRESH AGRO INDUSTRIES PRIVATE LIMITED",
"MAULI HOSPITAL AND RESEARCH CENTER SATARA",
"MAULI ICE PRIVATE LIMITED",
"MAULI INDUSTRIES PRIVATE LIMITED",
"MAULI INFRASTRUCTURAL PROJECT PRIVATE LIMITED",
"MAULI METAL INDUSTRIES PRIVATE LIMITED",
"MAULI ORGANIC PRIVATE LIMITED",
"MAULI PRIVATE LIMITED",
"MAULI PROPERTIES PRIVATE LIMITED",
"MAULI SAI DEVELOPERS PRIVATE LIMITED",
"MAULI SECURITY FORCE SERVICES PRIVATE LIMITED",
"MAULIAGE LASER PRIVATE LIMITED",
"MAULIFAB PRIVATE LIMITED",
"MAULIK BUSINESS SERVICES PRIVATE LIMITED",
"MAULIK LEATHER CRAFTS PVT LTD",
"MAULIKEM PRODUCTS PRIVATE LIMITED",
"MAULIN DISTILLERS PRIVATE LIMITED",
"MAUNA DHWANI FOUNDATION",
"MAUNI INTERNATION SCHOOL",
"MAUNI MOON MULTI-TECHNOLOGIES PRIVATE LIMITED",
"MAUN-SAT FERRO ALLOYS PRIVATE LIMITED",
"MAURANIPUR LOGISTICS PRIVATE LIMITED",
"MAURITIUS HIGH COMMISSION",
"MAURIYA HOTELS (MADRAS) PRIVATE LIMITED",
"MAURVI EVENTS AND BRAND SOLUTION PRIVATE LIMITED",
"MAURYA AGRO ENTERPRISES PRIVATE LIMITED",
"MAURYA ENVIRO PROJECT PRIVATE LIMITED",
"MAURYA FOODS PRIVATE LIMITED",
"MAURYA HEIGHTS BUILDCON PRIVATE LIMITED",
"MAURYA INFOTEK PRIVATE LIMITED",
"MAURYA LIFE CARE PRIVATE LIMITED",
"MAURYA METAL PRIVATE LIMITED",
"MAURYA MOTORS PRIVATELIMITED",
"MAURYA PRINTERS PRIVATE LIMITED",
"MAURYA REALCON PRIVATE LIMITED",
"MAURYA SPINNING MILLS PRIVATE LIMITED",
"MAURYA TRANSCARGO PRIVATE LIMITED",
"MAURYA X-RAY & ULTRASOUND PRIVATE LIMITED",
"MAURYAA ALLOYS PRIVATE LIMITED",
"MAURYAGRAND REAL HOMES PRIVATE LIMITED",
"MAURYAN CAPITAL MANAGEMENT PRIVATE LIMITED",
"MAUSAM AGRO PRIVATE LIMITED",
"MAUTIK IMPEX PRIVATE LIMITED",
"MAUVE ENTERPRISES PRIVATE LIMITED",
"MAUZ FASHIONS PRIVATE LIMITED",
"MAV BUILDCON PRIVATE LIMITED",
"MAV VIDYASHRAM SEMBAKKAM SCHOOL",
"MAVA GEMS PRIVATE LIMITED",
"MAVAL HEALTHCARE PRIVATE LIMITED",
"MAVANI SYNTHETIC LUBRICANTS PRIVATE LIMITED",
"MAVCOMM CONSULTING PRIVATE LIMITED",
"MAVEE FOODS",
"MAVEN AUTOMATION SOLUTIONS PRIVATE LIMITED",
"MAVEN CLUSTER SOFTWARE PRIVATE LIMITED",
"MAVEN INFOSOFT PRIVATE LIMITED",
"MAVEN INFRA & CONSULTANTS PRIVATE LIMITED",
"MAVEN INFRASTRUCTURE PROJECTS PRIVATE LIMITED",
"MAVEN IT SOLUTIONS INDIA PRIVATE LIMITED",
"MAVEN MARINE INTERNATIONAL LIMITED",
"MAVEN MARKETING PRIVATE LIMITED",
"MAVEN PROJECT MANAGEMENT PRIVATE LIMITED",
"MAVEN RUBBER PRODUCTS PRIVATE LIMITED",
"MAVEN SILICON SOFTECH PRIVATE LIMITED",
"MAVEN SOLAR PRIVATE LIMITED",
"MAVEN SYSTEMS PRIVATE LIMITED",
"MAVEN TECHNOSOFT PRIVATE LIMITED",
"MAVEN TOOLS AND TECHNOLOGIES PRIVATE LIMITED",
"MAVEN TRADERS PRIVATE LIMITED",
"MAVEN WAVE PARTNERS (INDIA) PRIVATE LIMITED",
"MAVEN WAVE PARTNERS INDIA PRIVATE LIMITED",
"MAVEN WORKFORCE PRIVATE LIMITED",
"MAVENBERG INNOVATIONS (INDIA) PRIVATE LIMITED",
"MAVENCODES TECHNOLOGIES LLP",
"MAVENHASTEN CONSULTING PRIVATE LIMITED",
"MAVENICK CONSULTING PRIVATE LIMITED",
"MAVENIR INDIA INFORMATION TECHNOLOGY PRIVATE LIMITED",
"MAVENIR SYSTEMS PRIVATE LIMITED",
"MAVENMAGNET RESEARCH PRIVATE LIMITED",
"MAVENS I SOFTECH SOLUTIONS PRIVATE LIMITED",
"MAVENSOFT SYSTEMS PRIVATE LIMITED",
"MAVENTECH INNOVATIONS PRIVATE LIMITED",
"MAVENTECH LABS PRIVATE LIMITED",
"MAVENTIC INNOVATIVE SOLUTIONS PRIVATE LIMITED",
"MAVERIC SYSTEMS LIMITED",
"MAVERICK AIRPORT SERVICES PRIVATE LIMITED",
"MAVERICK COMMUNICATIONS PRIVATE LIMITED",
"MAVERICK DEVELOPERS AND COLONISERS PRIVATE LIMITED",
"MAVERICK DIGITAL SERVICES PRIVATE LIMITED",
"MAVERICK DYNAMICS PRIVATE LIMITED",
"MAVERICK FINANCIAL SERVICES PRIVATE LIMITED",
"MAVERICK FITNESS STUDIOS PRIVATE LIMITED",
"MAVERICK HOLDINGS & INVESTMENTS PRIVATE LIMITED",
"MAVERICK INNOVATIONS PRIVATE LIMITED",
"MAVERICK MOTORS",
"MAVERICK POWER SOLUTIONS PRIVATE LIMITED",
"MAVERICK PROPERTIES PRIVATE LIMITED",
"MAVERICK QUALITY ADVISORY SERVICES PRIVATE LIMITED",
"MAVERICK REAL ESTATE PRIVATE LIMITED",
"MAVERICK SHARE BROKERS PRIVATE LIMITED",
"MAVERICK SOLUTION & CONSULTANCY PRIVATE LIMITED",
"MAVERICK TURF TECHNOLOGIES PRIVATE LIMITED",
"MAVERICKS SOLAR ENERGY SOLUTIONS PRIVATE LIMITED",
"MAVERICKS WEB SERVICES INDIA PRIVATE LIMITED",
"MAVERIK FACILITY MANAGEMENT PRIVATE LIMITED",
"MAVERIX PLATFORMS PRIVATE LIMITED",
"MAVI BUILDTECH PRIVATE LIMITED",
"MAVI HOLDING PTE LTD",
"MAVI HOSPITAL PRIVATE LIMITED",
"MAVIA HOMES PRIVATE LIMITED",
"MAVIN SWITCHGEARS AND CONTROL PRIVATE LIMITED",
"MAVIN TECH SOLUTIONS PRIVATE LIMITED",
"MAVINLOGISTICS AND RESOURCES PRIVATE LIMITED",
"MAVINZ CONSULTANCY PRIVATE LIMITED",
"MAVIS COMMUNICATION SERVICES PRIVATE LIMITED",
"MAVIS SATCOM LIMITED",
"MAVM ANGELS NETWORK PRIVATE LIMITED",
"MAVRY CONSULTANTS",
"MAVUCA CAPITAL ADVISORS PRIVATE LIMITED",
"MAVUKKARAI HOTELS PRIVATE LIMITED",
"MAVYATHO VENTURES PRIVATE LIMITED",
"MAWAI INFOTECH LIMITED",
"MAWANA FOOD PRIVATE LIMITED",
"MAWANA PRIVATE INDUSTRIAL TRAINING INSTITUTE",
"MAWANA SUGARS LIMITED",
"MAWANDIA CLOTHING PRIVATE LIMITED",
"MAWMLUH CHERRA CEMENTS LIMITED",
"MAWSIM GOLD PRIVATE LIMITED",
"MAX AEROSPACE AND AVIATION PRIVATE LIMITED",
"MAX AGRI-GENETICS PRIVATE LIMITED",
"MAX AIR PRIVATE LIMITED",
"MAX ALUMINIUM PRIVATE LIMITED",
"MAX AND NAD CARE PRIVATE LIMITED",
"MAX APPARELS PRIVATE LIMITED",
"MAX AQUA LIMITED",
"MAX ASIA PTE LIMITED",
"MAX ASSET SERVICES LIMITED",
"MAX AUTO CABLES PRIVATE LIMITED",
"MAX CAR FINISHES PRIVATE LIMITED",
"MAX CERAMICS PRIVATE LIMITED",
"MAX CHEM PHARMACEUTICALS PRIVATE LIMITED",
"MAX COOL SOLUTIONS PRIVATE LIMITED",
"MAX CRYO ENGINEERING PRIVATE LIMITED",
"MAX DETECTIVE AND GUARDING SERVICES PRIVATE LIMITED",
"MAX DIAGNOSTIC PRIVATE LIMITED",
"MAX DIGI INFOTECH PRIVATE LIMITED",
"MAX DISTRIBUTORS PRIVATE LIMITED",
"MAX ENGINEERING & MARKETING PRIVATE LIMITED",
"MAX ENGINEERING AND AUTOMATION PRIVATE LIMITED",
"MAX EXTRUSIONS PRIVATE LIMITED",
"MAX FAITH ENGINEERS PRIVATE LIMITED",
"MAX FAUCETS PRIVATE LIMITED",
"MAX FINANCIAL SERVICES LIMITED",
"MAX GRANITO PRIVATE LIMITED",
"MAX HAIR CLINIC PRIVATE LIMITED",
"MAX HEALTH CARE",
"MAX HEALTH HOSPITAL",
"MAX HEALTHCARE INSTITUTE LIMITED",
"MAX HEALTHCARE INSTITUTE PRIVATE LIMITED",
"MAX HEIGHTS INFRASTUCTURE LIMITED",
"MAX HOSPITAL",
"MAX HOSPITALS AND ALLIED SERVICES LIMITED",
"MAX HYPERMARKET INDIA PRIVATE LIMITED",
"MAX INDIA LIMITED",
"MAX INDO PRIVATE LIMITED",
"MAX INFRA INDIA LIMITED",
"MAX INFRA VENTURES PRIVATE LIMITED",
"MAX INTERNATIONAL FOOTCARE PRIVATE LIMITED",
"AXIS MAX LIFE INSURANCE LIMITED",
"MAX MAHARASHTRA MEDIA SOLUTIONS LLP",
"MAX MOTORS PRIVATE LIMITED",
"MAX MOULDS PRIVATE LIMITED",
"MAX MRO SERVICES PRIVATE LIMITED",
"MAX MULLER HIGH SCHOOL",
"MAX NATURAL GASES PRIVATE LIMITED",
"MAX NEEMAN MEDICAL INTERNATIONAL LIMITED",
"MAX NONWOVEN PRIVATE LIMITED",
"MAX OFFICE PRODUCTS (I) PRIVATE LIMITED",
"MAX ONE DISTRIBUTION AND SERVICES LIMITED",
"MAX TRANSTECH LIMITED",
"MAX PEST CONTROL SERVICES",
"MAX POPULAR FLEXI - CABLES PRIVATE LIMITED",
"MAX PRECISION BEARINGS PRIVATE LIMITED",
"MAX PROPERTIES PRIVATE LIMITED",
"MAX PROTECTION SERVICES PRIVATE LIMITED",
"MAX PUBLICITY AND COMMUNICATION PRIVATE LIMITED",
"MAX PURE WATER SYSTEM PRIVATE LIMITED",
"MAX ROADLINE PRIVATE LIMITED",
"MAX ROOFING SYSTEMS PRIVATE LIMITED",
"MAX SHIPPING AND FORWARDING PRIVATE LIMITED",
"MAX SKILL FIRST LIMITED",
"MAX SPARE LIMITED",
"MAX SPECIALITY FILMS LIMITED",
"MAX SPECIALITY PRODUCTS",
"MAX STANDARD STORES PRIVATE LIMITED",
"MAX SUPREME TEXTILES PRIVATE LIMITED",
"MAX SYSTEMS PRIVATE LIMITED",
"MAX TECH EQUIPMENTS & CONSULTANTS PRIVATE LIMITED",
"MAX TOWERS PRIVATE LIMITED",
"MAX VALUE PLUS CAPITAL PRIVATE LIMITED",
"MAX VALVES AND REGULATORS PRIVATE LIMITED",
"MAX VENDING PRIVATE LIMITED",
"MAX VENTURES INVESTMENT HOLDINGS PRIVATE LIMITED",
"MAX VENTURES PRIVATE LIMITED",
"MAX VETS HOSPITALS PRIVATE LIMITED",
"MAX VISION PEST FUMI-TECH INDIA PRIVATE LIMITED",
"MAX WIN SMART LIFE INDIA PRIVATE LIMITED",
"MAXAM INDIA PRIVATE LIMITED",
"MAXAMTECH DIGITAL VENTURES PRIVATE LIMITED",
"MAXAMUS PHARMA PRIVATE LIMITED",
"MAXAR TECHNOLOGIES INDIA PRIVATE LIMITED",
"MAXBALAJI HOSPITAL",
"MAXBIEN PHARMA PRIVATE LIMITED",
"MAXBLIS CONSTRUCTION PRIVATE LIMITED",
"MAXBROS VENTURES INDIA LIMITED",
"MAXBYTE TECHNOLOGIES PRIVATE LIMITED",
"MAXCAB INDUSTRIES PRIVATE LIMITED",
"MAXCARE CHILDREN HOSPITAL (BHOPAL) PRIVATE LIMITED",
"MAXCARE HOSPITAL",
"MAXCARE PACKERS & MOVERS PRIVATE LIMITED",
"MAXCARGO FORWARDING PRIVATE LIMITED",
"MAXCELL SYSTEMS PRIVATE LIMITED",
"MAXCESS INDIA AUTOMATION PRIVATE LIMITED",
"MAXCOMM INDIA PRIVATE LIMITED",
"MAXCON TOWN PLANNING & DEVELOPMENT PRIVATE LIMITED",
"MAXCURE NUTRAVEDICS LIMITED",
"MAXDERMCARE SKIN AND LASER PRIVATE LIMITED",
"MAX-DIGI INFOTECH PRIVATE LIMITED",
"MAXEEMA BIO-TECH PRIVATE LIMITED",
"MAXEFF ENGINEERING P LTD",
"MAXELL H.R. PRIVATE LIMITED",
"MAXELL HEAT EXCHANGERS PRIVATE LIMITED",
"MAXELL PHARMA PRIVATE LIMITED",
"MAXEMO CAPITAL SERVICES PRIVATE LIMITED",
"MAXENER WELLNESS LIMITED",
"MAXENERGY EQUIPMENTS PRIVATE LIMITED",
"MAXERGY TECHSERVE PRIVATE LIMITED",
"MAXEYE TECHNOLOGIES PRIVATE LIMITED",
"MAXFIT ENTERPRISES PRIVATE LIMITED",
"MAXFIT EQUIPMENT SOLUTIONS PRIVATE LIMITED",
"MAXFLOW CONTROLS (INDIA) PRIVATE LIMITED",
"MAXFLOW FANS MANUFACTURING PRIVATE LIMITED",
"MAXFLOW TECHNOLOGY & SOLUTIONS PRIVATE LIMITED",
"MAXFORT HOSPITALS PRIVATE LIMITED",
"MAXFORT SCHOOL",
"MAXFORT SUPERSPECIALITY HOSPITAL",
"MAX-GEARS PRIVATE LIMITED",
"MAXGRID SECURICOR (INDIA) PRIVATE LIMITED",
"MAXGROW BIOTECH PRIVATE LIMITED",
"MAXGROW DEVELOPMENT FOUNDATION",
"MAXGROW FINTRADE PRIVATE LIMITED",
"MAXGROWTH INFRASTRUCTURE PRIVATE LIMITED",
"MAXHEAL LABORATORIES PRIVATE LIMITED",
"MAXHEAL PHARMACEUTICALS INDIA LIMITED",
"MAXHEAL REMEDIES PRIVATE LIMITED",
"MAXHEAP TECHNOLOGIES PRIVATE LIMITED",
"MAXHEIGHTS AWAS PRIVATE LIMITED",
"MAXIBIO OLEOS PRIVATE LIMITED",
"MAXICARE OVERSEAS ASSOCIATES PRIVATE LIMITED",
"MAXICCORR SOLUTIONS PRIVATE LIMITED",
"MAXICON PHARMACEUTICALS PRIVATE LIMITED",
"MAXICON SHIPPING AGENCIES DIVISION OFSSLL",
"MAXIFY DIGITAL LABS PRIVATE LIMITED",
"MAXILIFE HOSPITAL PRIVATE LIMITED",
"MAXIM CROP SCIENCES PRIVATE LIMITED",
"MAXIM ELEVATORS AND CRANES PRIVATE LIMITED",
"MAXIM FINANCE PVT LTD",
"MAXIM GLOBAL RESOURCES PRIVATE LIMITED",
"MAXIM INDIA INTEGRATED CIRCUIT DESIGN PRIVATE LIMITED",
"MAXIM INFRASTRUCTURE AND REAL ESTATE (SHILLONG) PRIVATE LIMITED",
"MAXIM INTEGRATED PRODUCTS INDIA SALES PRIVATE LIMITED",
"MAXIM MECHATRONICS LIMITED",
"MAXIM PERIPHERALS PRIVATE LIMITED",
"MAXIM PHARMACEUTICALS PRIVATE LIMITED",
"MAXIM PRECISION TECHNOLOGIES PRIVATE LIMITED",
"MAXIM PROMOTERS PRIVATE LIMITED",
"MAXIM SMT TECHNOLOGIES PRIVATE LIMITED",
"MAXIM TREXION PRIVATE LIMITED",
"MAXIM TUBES COMPANY PRIVATE LIMITED",
"MAXIMA ACCORD TRADING PRIVATE LIMITED",
"MAXIMA AUTOMATION SOLUTIONS PRIVATE LIMITED",
"MAXIMA BOILERS PVT LTD",
"MAXIMA GLASS PRIVATE LIMITED",
"MAXIMA IT CONSULTING INDIA PRIVATE LIMITED",
"MAXIMA SOLUTIONS",
"MAXIMAL FINANCE AND INVESTMENTS LIMITED",
"MAXIMATOR INDIA PRIVATE LIMITED",
"MAXIMAX WAREHOUSING SOLUTIONS PRIVATE LIMITED",
"MAXIMISER MARKETING OPC PRIVATE LIMITED",
"MAXIMIST FOR EDIFICATION AND SOFTWARE SOLUTIONS PRIVATE LIMITED",
"MAXIMIZE MARKET RESEARCH PRIVATE LIMITED",
"MAXIMIZER E-SERVICES PRIVATE LIMITED",
"MAXIML LABS PRIVATE LIMITED",
"MAXIMO CERAMIC",
"MAXIMON PHARMA PRIVATE LIMITED",
"MAXIMUM FACILITY SERVICES PRIVATE LIMITED",
"MAXIMUM GRAPHIC ARTS",
"MAXIMUM OUTFITS PRIVATE LIMITED",
"MAXIMUM S.S PRIVATE LIMITED",
"MAXIMUM SPACES PRIVATE LIMITED",
"MAXIMUS ARC LIMITED",
"MAXIMUS BREWERIES & DISTILLERIES PRIVATE LIMITED",
"MAXIMUS ELECTRIC PRIVATE LIMITED",
"MAXIMUS ENVIROTECH PRIVATE LIMITED",
"MAXIMUS GLOBAL TRADE LINKS PRIVATE LIMITED",
"MAXIMUS HOTEL CATERING SERVICES PRIVATE LIMITED",
"MAXIMUS HUMAN RESOURCES PRIVATE LIMITED",
"MAXIMUS INFOWARE INDIA PRIVATE LIMITED",
"MAXIMUS INTERNATIONAL LIMITED",
"MAXIMUS MICE AND MEDIA SOLUTIONS PRIVATE LIMITED",
"MAXIMUS MOTORCYCLE AND SCOOTER PRIVATE LIMITED",
"MAXIMUS SECURITIES LIMITED",
"MAXIMUS SOLUTIONS PRIVATE LIMITED",
"MAXIMUS STORAGE SOLUTIONS PRIVATE LIMITED",
"MAXINE ELECTRICAL ENGINEERING PRIVATE LIMITED",
"MAXINOV SOLUTIONS PRIVATE LIMITED",
"MAX-ION ENGINEERS PRIVATE LIMITED",
"MAXION WHEELS ALUMINUM INDIA PRIVATE LIMITED",
"MAXIPLE ADVISORS PRIVATE LIMITED",
"MAXIS HEALTHCARE (I) PRIVATE LIMITED",
"MAXIS MOTION CONTROLS PRIVATE LIMITED",
"MAXIS MOTORS PRIVATE. LIMITED",
"MAXIT MEDIA PRIVATE LIMITED",
"MAXITECH ENGINEERING PRIVATE LIMITED",
"MAXITHERM BOILERS PRIVATE LIMITED",
"MAXIVISION EYE HOSPITALS PRIVATE LIMITED",
"MAXKART FOOD RETAILS PRIVATE LIMITED",
"MAXLIFE HEALTH ENTERPRISES PRIVATE LIMITED",
"MAXLIFE INSURANCE CO.LIMITED.",
"MAXLINE FACILITIES",
"MAXLINEAR TECHNOLOGIES PRIVATE LIMITED",
"MAXLITE AAC BLOCKS (INDIA) PRIVATE LIMITED",
"MAXLIVE PHARMACEUTICALS PRIVATE LIMITED",
"MAXMECH EQUIPMENTS PRIVATE LIMITED",
"MAXMED LIFE SCIENCES PRIVATE LIMITED",
"MAXMILE TRANS PRIVATE LIMITED",
"MAXMOVE LOGISTICS PRIVATE LIMITED",
"MAXNET TECHNOLOGIES PRIVATE LIMITED",
"MAXOFFICE SERVICES PRIVATE LIMITED",
"MAXOIND TECH SOLUTIONS PRIVATE LIMITED",
"MAXOL LUBRICANT (INDIA) PRIVATE LIMITED",
"MAXON BIOTECH PRIVATE LIMITED",
"MAXON DOORS PRIVATE LIMITED",
"MAXON ENERGY SERVICES PRIVATE LIMITED",
"MAXON HEALTHCARE INDIA PRIVATE LIMITED",
"MAXON PRECISION MOTOR INDIA PRIVATE LIMITED",
"MAXONIC INDIA PRIVATE LIMITED",
"MAXOP ENGINEERING COMPANY PRIVATE LIMITED",
"MAXOP SYNERGIES PRIVATE LIMITED",
"MAXPOSURE LIMITED",
"MAXPOSURE MEDIA GROUP INDIA PRIVATE LIMITED",
"MAXPOWER INFOSYSTEMS",
"MAXPRECI MACHINES PRIVATE LIMITED",
"MAXPRIDE (INDIA) RUBBER PRIVATE LIMITED",
"MAXPRO ENGINEERS PRIVATE LIMITED",
"MAXRAD SOFTWARE INDIA PRIVATE LIMITED",
"MAXROOF CORPORATION PRIVATE LIMITED",
"MAXSAS FACILITY MANAGEMENT PRIVATE LIMITED",
"MAXSHINE DIGITAL SOLUTIONS PRIVATE LIMITED",
"MAXSO PETROCARBAN PRIVATE LIMITED",
"MAXSOINDIA INDUSTRIAL SOLUTION PRIVATE LIMITED",
"MAXSTAR APPLIANCE LIMITED",
"MAXSUM CONSULTANTS PRIVATE LIMITED",
"MAXSUN POLYSHRINK PRIVATE LIMITED",
"MAXTAR BIO-GENICS PRIVATE LIMITED",
"MAXTEC GREEN EXPORT PRIVATE LIMITED",
"MAXTEL",
"MAXTHERM (INDIA) PRIVATE LIMITED",
"MAXTHERM BOILERS PRIVATE LIMITED",
"MAXTHERM ENTERPRISES PRIVATE LIMITED",
"MAXTON ENGINEERING PRIVATE LIMITED",
"MAXTON TECHNOLOGY PRIVATE LIMITED",
"MAXTORK MANUFACTURERS PRIVATE LIMITED",
"MAXTRA GLOBAL PRIVATE LIMITED",
"MAXTRACT ENGINEERS PRIVATE LIMITED",
"MAXUM WRITING INSTRUMENTS PRIVATE LIMITED",
"MAXUNO LAUNDRY PRIVATE LIMITED",
"MAXVAL IP SERVICES PRIVATE LIMITED",
"MAXVAL IP VENTURES INDIA PRIVATE LIMITED",
"MAXVAL TECHNOLOGIES PRIVATE LIMITED",
"MAXVALUE CREATIONS PRIVATE LIMITED",
"MAXVALUE CREDITS AND INVESTMENTS LIMITED",
"MAXVALUE NIDHI LIMITED",
"MAXVEGA NETWORKS PRIVATE LIMITED",
"MAXVEL REALTECH PRIVATE LIMITED",
"MAXVITA FOODS (INDIA) PRIVATE LIMITED",
"MAXVOLT ENERGY INDUSTRIES PRIVATE LIMITED",
"MAXVY TECHNOLOGIES PRIVATE LIMITED",
"MAXWARE TECHNOLOGIES PRIVATE LIMITED",
"MAXWATT TURBO SYSTEMS PRIVATE LIMITED",
"MAXWEALTH CAPITAL SERVICES PRIVATE LIMITED",
"MAXWEL AIRCON INDIA PRIVATE LIMITED",
"MAXWEL METALS (INDIA) PRIVATE LIMITED",
"MAXWELL ADDITIVES PRIVATE LIMITED",
"MAXWELL AND STUART PROJECT MANAGEMENT PRIVATE LIMITED",
"MAXWELL AUTO COMPONENTS PRIVATE LIMITED",
"MAXWELL AUTOMATION & SYSTEMS PRIVATE LIMITED",
"MAXWELL CAPITAL MANAGEMENT PRIVATE LIMITED",
"MAXWELL COMMUNICATION PRIVATE LIMITED",
"MAXWELL COMPANY PRIVATE LIMITED",
"MAXWELL CONSUMER LINKS PRIVATE LIMITED",
"MAXWELL DIESELS & ELECTRICALS PRIVATE LIMITED",
"MAXWELL ENERGY SYSTEMS PRIVATE LIMITED",
"MAXWELL ENTERTAINMENT PRIVATE LIMITED",
"MAXWELL EQUIPMENT & FORGINGS PVT LTD",
"MAXWELL INFRASTRUCTURE PRIVATE LIMITED",
"MAXWELL LIFE SCIENCE PRIVATE LIMITED",
"MAXWELL LOGISTICS PRIVATE LIMITED",
"MAXWELL MERCHANTS PRIVATE LIMITED",
"MAXWELL PROJECTS PRIVATE LIMITED",
"MAXWELL SOLAR AND WIND ENERGY PRIVATE LIMITED",
"MAXWELL SUPER MULTISPECIALITY HOSPITAL PRIVATE LIMITED",
"MAXWELL TOURS TRAVELS PRIVATE LIMITED",
"MAXWILL ELECTRONICS PRIVATE LIMITED",
"MAXWIN CHEMTECH PRIVATE LIMITED",
"MAXWOOD FURNITURE PRIVATE LIMITED",
"MAXWOOD INDUSTRIES PRIVATE LIMITED",
"MAXWORTH ELECTRONICS SYSTEMS PRIVATE LIMITED",
"MAXWORTH INTERNATIONAL PRIVATE LIMITED",
"MAXWORTH PLYWOOD PRIVATE. LIMITED.",
"MAXX BEVERAGES AND ENERGY LIMITED",
"MAXX FARMACIA INDIA LLP",
"MAXX FITNESS MANAGEMENT PRIVATE LIMITED",
"MAXX FORTUNE LINES PRIVATE LIMITED",
"MAXX HOSPITALITIES & CATERING SERVICES PRIVATE LIMITED",
"MAXX IMPEX PRIVATE LIMITED",
"MAXX SPORTZ AND FITNESS PRIVATE LIMITED",
"MAXX TTC PRIVATE LIMITED",
"MAXXCAB WIRES & CABLES PRIVATE LIMITED",
"MAXXGRO AGROLOGY PRIVATE LIMITED",
"MAXXIS RUBBER INDIA PRIVATE LIMITED",
"MAXXMANN COMMUNICATIONS PRIVATE LIMITED",
"MAXXMANN SYSTEMS LIMITED",
"MAXXON IMPEX & CREDIT PVT LTD",
"MAX-XPRESS LOGISTICS PRIVATE LIMITED",
"MAXXTECH PRIVATE LIMITED",
"MAXXTON INDIA TECHNOLOGIES PRIVATE LIMITED",
"MAXXVALUE HOTELS AND HOSPITALITY PRIVATE LIMITED",
"MAXZIMAA PHARMACEUTICALS PRIVATE LIMITED",
"MAXZONE CLOTHING PRIVATE LIMITED",
"MAY & BAKER PHARMA CEUTICALS",
"MAY DESIGNS STUDIO PRIVATE LIMITED",
"MAY FLOWER SOFTWARE PRIVATE LIMITED",
"MAY PROJECTS INDIA PRIVATE LIMITED",
"MAY SOFTECH PRIVATE LIMITED",
"MAY STEELS PVT LTD",
"MAYA APPLIANCES PRIVATE LIMITED",
"MAYA BUILDCON PRIVATE LIMITED",
"MAYA CONSTRUCTION COMPANY PRIVATE LIMITED",
"MAYA DEVI EDUCATIONAL FOUNDATION",
"MAYA ENTERTAINMENT STUDIOS PRIVATE LIMITED",
"MAYA EXIM PRIVATE LIMITED",
"MAYA EXPORTS CORPORATION",
"MAYA FAN AIR ENGINEERING PRIVATE LIMITED",
"MAYA FASHIONS PRIVATE LIMITED",
"MAYA GLOBAL PRIVATE LIMITED",
"MAYA GLOBAL SERVICES PRIVATE LIMITED",
"MAYA HEIGHTS BUILDERS PRIVATE LIMITED",
"MAYA HOSPITAL AND RESEARCH INSTITUDE",
"MAYA HYBRID SEEDS COMPANY PRIVATE LIMITED",
"MAYA INNS PRIVATE LIMITED",
"MAYA ISPAT PRIVATE LIMITED",
"MAYA JUKTA TEA ESTATE PVT LTD",
"MAYA MANDAP DECORATION PRIVATE LIMITED",
"MAYA MANU MOTORS PRIVATE LIMITED",
"MAYA MOTORCYCLES PRIVATE LIMITED",
"MAYA MOVIES PRIVATE LIMITED",
"MAYA NURSING HOME PRIVATE LIMITED",
"MAYA NUTRIFOODS PRIVATE LIMITED",
"MAYA OIL MILLS PRIVATE LIMITED",
"MAYA SHEETALAYA PRIVATE LIMITED",
"MAYA SONA HOSIERY MILLS PRIVATE LIMITED",
"MAYA STEEL PVT LTD",
"MAYA SYNTHETICS PRIVATE LIMITED",
"MAYA UDYOG PRIVATE LIMITED",
"MAYAAR FABRICS PRIVATE LIMITED",
"MAYABANDAR DOORS LIMITED",
"MAYADEVI POLYCOT LIMITED",
"MAYAJAAL ENTERTAINMENT PRIVATE LIMITED",
"MAYAN ENGINEERS PRIVATE LIMITED",
"MAYANAGRI WORLD ONE PRIVATE LIMITED",
"MAYANK AIRCON PRIVATE LIMITED",
"MAYANK ARC AND ELECTRODES PRIVATE LIMITED",
"MAYANK CATTLE FOOD LIMITED",
"MAYANK DISTRIBUTORS PRIVATE LIMITED",
"MAYANK EARTH MOVERS PRIVATE LIMITED",
"MAYANK ELECTRICALS PRIVATE LIMITED",
"MAYANK FABMAC PVT. LTD.",
"MAYANK GARMIMPEX PRIVATE LIMITED",
"MAYANK GLOBAL FINANCE LIMITED",
"MAYANK HOTELS LIMITED",
"MAYANK INFRATECH PRIVATE LIMITED",
"MAYANK PROCESSORS PRIVATE LIMITED",
"MAYANK RAW-MINT PRIVATE LIMITED",
"MAYANK SECURITIES PRIVATE LIMITED",
"MAYANK SHARMA ENTERPRISES PRIVATE LIMITED",
"MAYANK TRADE AND AGENCY PVT LTD",
"MAYANK VIDUT UDYOG PRIVATE LIMITED",
"MAYANKS IT SOLUTIONS PRIVATE LIMITED",
"MAYANKS WELFARE SOCIETY",
"MAYANKSHREE AUTOMOBILES PRIVATE LIMITED",
"MAYANKSHREE MOTORS PRIVATE LIMITED",
"MAYANSH RESOURCES PRIVATE LIMITED",
"MAYAPURI CONSTRUCTIONS PRIVATE LIMITED",
"MAYAR HEALTH RESORTS LIMITED",
"MAYAR INDIA LIMITED",
"MAYAR INFRASTRUCTURE DEVELOPMENT PRIVATE LIMITED",
"MAYASHEEL RETAIL INDIA LIMITED",
"MAYATECH SOLUTIONS PRIVATE LIMITED",
"MAYBACH INDUSTRIES PRIVATE LIMITED",
"MAYBOLE TECHNOLOGIES PRIVATE LIMITED",
"MAYBRIGHT VENTURES PRIVATE LIMITED",
"MAYCO FREIGHT AND TRAVELS PRIVATE LIMITED",
"MAYDHYAMIK VIDYALAYA VILHOLI",
"MAYEKAR BROADBAND PRIVATE LIMITED",
"MAYEKAWA INDIA PRIVATE LIMITED",
"MAYER DAN AGRO PRODUCT PRIVATE LIMITED",
"MAYFAIR AIRTRAVEL SERVICES PRIVATE LIMITED",
"MAYFAIR BIOTECH PRIVATE LIMITED",
"MAYFAIR COLORTECH PRIVATE LIMITED",
"MAYFAIR CONSULTANCY SERVICES INDIA PRIVATE LIMITED",
"MAYFAIR FABRICS LIMITED",
"MAYFAIR FASHIONS PRIVATE LIMITED",
"MAYFAIR HOTELS & RESORTS LIMITED",
"MAYFAIR HOUSING PRIVATE LIMITED",
"MAYFAIR MACHINEKRAFT PRIVATE LIMITED",
"MAYFAIR POLYMERS PVT LTD",
"MAYFAIR RENEWABLE ENERGY (I) PRIVATE LIMITED",
"MAYFAIR RESORTS (INDIA) LIMITED",
"MAYFAIR SECURITIES PVT LTD",
"MAYFAIR SPACES LIMITED",
"MAYFLOWER ENTERPRISES PRIVATE LIMITED",
"MAYFLOWER EXPORTS PRIVATE LIMITED",
"MAYFLOWER HOSPITALS PRIVATE LIMITED",
"MAYFLOWER HOTELS AND RESORTS LLP",
"MAYFLOWER HOTELS PVT LTD",
"MAYFLOWER LANGUAGE SERVICES PRIVATE LIMITED",
"MAYFLOWER MANAGEMENT SERVICES PRIVATE LIMITED",
"MAYFLOWER SOFTWARE PRIVATE LIMITED",
"MAYFOAM PRIVATE LIMITED",
"MAYGRISS HEALTHCARE PRIVATE LIMITED",
"MAYITHARA HOME DECOR PRIVATE LIMITED",
"MAYKA RETAIL PRIVATE LIMITED",
"MAYMILL AGRO PRIVATE LIMITED",
"MAYMILL BUTTONS PRIVATE LIMITED",
"MAYNAGURI AGRO TEA PRIVATE LIMITED",
"MAYO COLLEGE",
"MAYOM HOSPITAL",
"MAYON INFRA PROJECT PRIVATE LIMITED",
"MAYOOR CHOPASNI SCHOOL JODHPUR",
"MAYOOR SCHOOL JAIPUR",
"MAYOR SPORTS PRIVATE LIMITED",
"MAYORA INDIA PRIVATE LIMITED",
"MAYORAL MODA INFANTIL INDIA PRIVATE LIMITED",
"MAYPRI HEALTHCARE PRIVATE LIMITED",
"MAYRA ALUMINIUM FORMWORK PRIVATE LIMITED",
"MAYRUSH ENGINEERING CONSULTANTS PRIVATE LIMITED",
"MAYS COMMERCIAL PRIVATE LIMITED",
"MAYS FOODS PRIVATE LIMITED",
"MAYSQUARE LIFESTYLE PRIVATE LIMITED",
"MAYTAG UDYOG PRIVATE LIMITED",
"MAYUKA HOLDINGS PRIVATE LIMITED",
"MAYUKA INVESTMENT LIMITED",
"MAYUKH BUSINESS PRIVATE LIMITED",
"MAYUKH DEALTRADE LIMITED",
"MAYUR (CASTING & HOUSING) PVT LTD",
"MAYUR ALANKAR PRIVATE LIMITED",
"MAYUR ALUMINIUM INDUSTRIES PRIVATE LIMITED",
"MAYUR AUTO PRIVATE LIMITED",
"MAYUR C.CONTRACTOR LOGISTICS PRIVATE LIMITED",
"MAYUR CHAI COMPANY PRIVATE LIMITED",
"MAYUR CHAINS PRIVATE LIMITED",
"MAYUR CHEM DISTRIBUTORS PRIVATE LIMITED",
"MAYUR CHEMICAL INDUSTRIES PVT LTD",
"MAYUR COLDSTORAGE PRIVATE LIMITED",
"MAYUR CORRUGATERS PRIVATE LIMITED",
"MAYUR CORUPACK PRIVATE LIMITED",
"MAYUR DYECHEM INTERMEDIATES LIMITED",
"MAYUR ELECTRO CERAMICS PVT LTD",
"MAYUR ELECTROMECK PRIVATE LIMITED",
"MAYUR ENGINEERS PRIVATE LIMITED",
"MAYUR EXTRUSION PRIVATE LIMITED",
"MAYUR FABRICS PVT LTD",
"MAYUR FLOORINGS LIMITED",
"MAYUR FURNITURE",
"MAYUR GINNING AND PRESSING PVT LTD",
"MAYUR GLASS INDUSTRIES LIMITED",
"MAYUR GLOBAL VENTURES PRIVATE LIMITED",
"MAYUR GOLD PRIVATE LIMITED",
"MAYUR INDUSTRIES PRIVATE LIMITED",
"MAYUR INFRASTRUCTURE PRIVATE LIMITED",
"MAYUR INORGANICS. LIMITED",
"MAYUR LEATHER PRODUCTS LIMITED",
"MAYUR MEDICAL AGENCY PRIVATE LIMITED",
"MAYUR MICRO TECHNIQUES INDIA PRIVATE LIMITED",
"MAYUR PHARMA DISTRIBUTORS PRIVATE LIMITED",
"MAYUR POLY FILMS PRIVATE LIMITED",
"MAYUR POLYDYEING PRIVATE LIMITED",
"MAYUR PROMOTERS PRIVATE LIMITED",
"MAYUR PROPMART PRIVATE LIMITED",
"MAYUR REEDS AND HEALDS PRIVATE LIMITED",
"MAYUR RICE MILLS PRIVATE LIMITED",
"MAYUR SAI INDUSTRIES PRIVATE LIMITED",
"MAYUR SEEDS AND AGRITECH",
"MAYUR STAINLESS PRIVATE LIMITED",
"MAYUR STONEX PRIVATE LIMITED",
"MAYUR TEA PRIVATE LIMITED",
"MAYUR TECHNOSOFT PRIVATE LIMITED",
"MAYUR TELECOM PRIVATE LIMITED",
"MAYUR TRAVELS RAJASTHAN PRIVATE LIMITED",
"MAYUR UNIQUOTERS LIMITED",
"MAYUR VISION PRIVATE LIMITED",
"MAYUR WOVENS PRIVATE LIMITED",
"MAYUR YARN & THREAD PRIVATE LIMITED",
"MAYURA ASSOCIATES",
"MAYURA AUTOMATION & ROBOTIC SYSTEMS PRIVATE LIMITED",
"MAYURA CAPS AND CONTAINERS PRIVATE LIMITED",
"MAYURA HOTELS PRIVATE LIMITED",
"MAYURA KRISHNA ANJALI CORPORATION PRIVATE LIMITED",
"MAYURA PACKAGING PRIVATE LIMITED",
"MAYURA SARIA PRIVATE LIMITED",
"MAYURA STEELS PRIVATE LIMITED",
"MAYURAKSHI COLD STORAGE PRIVATE LIMITED",
"MAYURANK FOOD PRODUCTS PRIVATE LIMITED",
"MAYURBHANJ METALS LTD",
"MAYURES GRANI MARMO PRIVATE LIMITED",
"MAYURESH CONSTRUCTIONS OPC PRIVATE LIMITED",
"MAYURESH JEWELS INTERNATIONAL PRIVATE LIMITED",
"MAYURESH MARKETING PRIVATE LIMITED",
"MAYURESH PROTENZ PRIVATE LIMITED",
"MAYURESH REAL ESTATE AND MANAGEMENT PRIVATE LIMITED",
"MAYURESH REALTY PRIVATE LIMITED",
"MAYURESH TRADE CENTRE UNITS PURCHASERS PRIVATE LIMITED",
"MAYURESH VENTURES PRIVATE LIMITED",
"MAYURESHWAR AGRI-HORTI PRODUCER COMPANY LIMITED",
"MAYURESHWAR INFRA SUPPLIES PRIVATE LIMITED",
"MAYURESHWAR LOGISTICS PRIVATE LIMITED",
"MAYURI BROILER BREEDING FARMS PVT LTD",
"MAYURI ELECTRONICS PRIVATE LIMITED",
"MAYURI HERBALCARE PRIVATE LIMITED",
"MAYURI INFRASTRUCTURES PRIVATE LIMITED",
"MAYUSH IT SERVICES PRIVATE LIMITED",
"MAYVI INTERNATIONAL PRIVATE LIMITED",
"MAZA DEVELOPERS PRIVATE LIMITED",
"MAZAF INTERNATIONAL AGENCIES PRIVATE LIMITED",
"MAZAGON DOCK SHIPBUILDERS LIMITED",
"MAZARS ADVISORY LLP",
"CLA INDUS VALUE CONSULTING PRIVATE LIMITED",
"MAZBAT TEA ESTATE LTD",
"MAZBOOT INFRASTRUCTURE PRIVATE LIMITED",
"MAZCO TRADING PRIVATE LIMITED",
"MAZDA COLOURS LIMITED",
"MAZDA CONSTRUCTION COMPANY PRIVATE LIMITED",
"MAZDA CONSULTANCY SERVICES PRIVATE LIMITED",
"MAZDA HI-TECH ELECTRICALS PRIVATE LIMITED",
"MAZDA IMAGING PRIVATE LIMITED",
"MAZDA INFOTECH SYSTEMS PRIVATE LIMITED",
"MAZDA LIMITED",
"MAZE EVENTS AND EXHIBIT SOLUTIONS PRIVATE LIMITED",
"MAZE NET SOLUTION PRIVATE LIMITED",
"MAZEIX HOSPITALITY PRIVATE LIMITED",
"MAZEL ELECTRIC (INDIA) LIMITED",
"MAZEL INFRATECH PRIVATE LIMITED",
"MAZENTA RETAIL PRIVATE LIMITED",
"MAZEWEB TECHNOLOGIES PRIVATE LIMITED",
"MAZI SHALA BHOSALEWADI KADAMWADI",
"MAZIDUN HIGH SCHOOL",
"MAZIK TECH SOLUTIONS PRIVATE LIMITED",
"MAZIQ FARM TECHNOLOGIES PRIVATE LIMITED",
"MAZSON BUILDERS AND DEVELOPERS PRIVATE LIMITED.",
"MAZUNA TECHNOBRIDGE PRIVATE LIMITED",
"MAZZETTI INDIA ENGINEERING PRIVATE LIMITED",
"MB BPO SERVICES PRIVATE LIMITED",
"MB CRUSHER INDIA PRIVATE LIMITED",
"MB DAGA PACKAGING PRIVATE LIMITED",
"MB DIAMONDS LLP",
"MB EXIM PRIVATE LIMITED",
"MB FUND ADMINISTRATORS PRIVATE LIMITED",
"MB INFORMATICS PRIVATE LIMITED",
"MB INFRABUILD PRIVATE LIMITED",
"MB INTERIOR PRIVATE LIMITED",
"MB LOGISTICS & CONSTRUCTION PRIVATE LIMITED",
"MB MAGNETS PVT.LTD.",
"MB MEDICAL TECHNOLOGIES PRIVATE LIMITED",
"MB METALLIC BELLOWS PRIVATE LIMITED",
"MB PATEL SCIENCE COLLEGE",
"MB POWER MADHYA PRADESH LIMITED",
"MB PROJECTS AND LOGISTICS INDIA PRIVATE LIMITED",
"MB SPONGE & POWER LIMITED",
"MB TRANSPORT PRIVATE LIMITED",
"MB WHEELERS LTD",
"MBA CHAI WALA PRIVATE LIMITED",
"MBA DEVELOPERS PRIVATE LIMITED",
"MBA PHARMACEUTICALS PRIVATE LIMITED",
"MBA STEELS PRIVATE LIMITED",
"MBATREK PRIVATE LIMITED",
"MBB LABS PRIVATE LIMITED",
"MBBSDIRECT CONSULTANCY PRIVATE LIMITED",
"MBC CORPORATE ADVISORS PRIVATE LIMITED",
"MBC INFRA SPACE PRIVATE LIMITED",
"MBC LEGAL ADVISORS PRIVATE LIMITED",
"MBD ALCHEMIE PRIVATE LIMITED",
"MBD ENTERPRISES PRIVATE LIMITED",
"MBD PRINTOGRAPHICS PRIVATE LIMITED",
"MBDA INDIA PRIVATE LIMITED",
"MBE COAL AND MINERAL TECHNOLOGY INDIA PRIVATE LIMITED",
"MBEE PAPER PRINTS PRIVATE LIMITED",
"MBF DIGITAL PRODUCTION SERVICES PRIVATE LIMITED",
"MBG COMMODITIES PRIVATE LIMITED",
"MBG SALES PRIVATE LIMITED",
"MBGREENS HOTELS PRIVATE LIMITED",
"MBH POWER PRIVATE LIMITED",
"MBI METALLOYS PRIVATE LIMITED",
"MBIB SOLUTIONS PRIVATE LIMITED",
"MBIT COMPUTRAINING PRIVATE LIMITED",
"MBIT WIRELESS PRIVATE LIMITED",
"MBIZSOL (OPC) PRIVATE LIMITED",
"MBIZTECH CONSULTING PRIVATE LIMITED",
"MBJ TRADERS PRIVATE LIMITED",
"MBK CASTINGS PRIVATE LIMITED",
"MBK INFINITY SERVICE PRIVATE LIMITED",
"MBK LOGISTIX PRIVATE LIMITED",
"MBK OVERSEAS TRADECON PRIVATE LIMITED",
"MBKS AGRO FOODS PRIVATE LIMITED",
"MBL (MP) TOLL ROAD COMPANY LIMITED",
"MBL AND COMPANY LIMITED",
"MBL IMPEX PRIVATE LIMITED",
"MBL INFRASTRUCTURE LIMITED",
"MBLAZON SOLUTIONS PRIVATE LIMITED",
"MBM COMMODITY PRIVATE LIMITED",
"MBM ENGINEERING INFOTECH LIMITED",
"MBM INFOSERV PRIVATE LIMITED",
"MBM NEWTECH PRIVATE LIMITED",
"MBM TEXTILES PRIVATE LIMITED",
"MBM TRADE-LINK PRIVATE LIMITED",
"MBM TUBES PRIVATE LIMITED",
"MBMG DIAMONDS PRIVATE LIMITED",
"MBP BEARINGS PVT LTD",
"MBP GARMENTS PRIVATE LIMITED",
"MBP TECHNOLOGIES PRIVATE LIMITED",
"MBPG COLLEGE GOVT COLLEGE",
"MBPL DIGITAL LEARNING SOLUTIONS PRIVATE LIMITED",
"MBR AUTOMATION PRIVATE LIMITED",
"MBR EXIMS PRIVATE LIMITED",
"MBR FLEXIBLES LIMITED",
"MBR HOMES PRIVATE LIMITED",
"MBR SOLAR ENERGIES PRIVATE LIMITED",
"MBRS FOOD PRIVATE LIMITED",
"MBRS HOTEL PRIVATE LIMITED",
"MBS ALUMINIUM INDUSTRIES PRIVATE LIMITED",
"MBS BEVERAGE PRIVATE LIMITED",
"MBS GYMKHANA LIMITED",
"MBS INDIA PRIVATE LIMITED",
"MBS LIFESCIENCE PRIVATE LIMITED",
"MBS SCHOOL",
"MBS TEXTILES PRIVATE LIMITED",
"MBS TRADERS PRIVATE LIMITED",
"MBS WIND ENERGY PRIVATE LIMITED",
"MBS WIND INFRA PRIVATE LIMITED",
"MBSV REALTORS PRIVATE LIMITED",
"MBT INFRASTRUCTURES PRIVATE LIMITED",
"MBTC INTRAFURNISH PRIVATE LIMITED",
"MBWORLD EXIM PRIVATE LIMITED",
"MC BAUCHEMIE INDIA PVT LTD",
"MC COY DRUGS PRIVATE LIMITED",
"MC JAIN INFOSERVICES PRIVATE LIMITED",
"MC LOGISTICS INDIA PRIVATE LIMITED",
"MC MACHINERY SYSTEMS INDIA PRIVATE LIMITED",
"MC METALS PRIVATE LIMITED",
"MC MILLAN MARKETING PRIVATE LIMITED",
"MC PACKAGING PRIVATE LIMITED",
"MC SPARR TEST SYSTEMS AND CHEMICALS PRIVATE LIMITED",
"MC4 RESOURCE PRIVATE LIMITED",
"MCA CONSULTING SERVICES PRIVATE LIMITED",
"MCAFEE INDIA SALES PRIVATE LIMITED",
"MCAFEE SOFTWARE INDIA PRIVATE LIMITED",
"MCANVAS ADVERTISING PRIVATE LIMITED",
"MCAP WEALTH PRIVATE LIMITED",
"MCARBON TECH INNOVATION PRIVATE LIMITED",
"MCB MARINE PRODUCTS PRIVATE LIMITED",
"MCBERRY FASHIONS PRIVATE LIMITED",
"MCBULLS INDIA PRIVATE LIMITED",
"MCBW INFRA PRIVATE LIMITED",
"MCC ALCAST PRIVATE LIMITED",
"MCC CAMPUS MATRICULATION HIGHER SECONDARY SCHOOL",
"MCC CONTAINER LINES PRIVATE LIMITED",
"MCC DIGITAL INNOVATIONS PRIVATE LIMITED",
"MCC GLOBAL SALES LLP",
"MCC POWER PROJECTS PRIVATE LIMITED",
"MCC PUBLIC SCHOOL",
"MCC RESOURCES PVT. LTD.",
"MCCAIN FOODS INDIA PRIVATE LIMITED",
"MCCANDLESS MANAGEMENT PRIVATE LIMITED",
"MCCANN ERICKSON INDIA PRIVATE LIMITED",
"MCCI INTERCONNECT SOLUTIONS PRIVATE LIMITED",
"MCCLARY BIOTECH PRIVATE LIMITED",
"MCCMAHADEO CONSTRUCTIONS PRIVATE LIMITED",
"MCCORMICK FOODS INDIA PRIVATE LIMITED",
"MCCORMICK SUPPORT SERVICES PRIVATE LIMITED",
"MCCOY ARCHITECTURAL SYSTEMS PRIVATE LIMITED",
"MCCOY DIGITAL PRIVATE LIMITED",
"MCCOY GLOBAL LINKS PRIVATE LIMITED",
"MCCOY INFRASTRUCTURE PRIVATE LIMITED",
"MCCOY INVESTMENT PRIVATE LIMITED",
"MCCOY PAL'S INFRASTRUCTURE LIMITED",
"MCCOY PERFORMANCE SILICONES PRIVATE LIMITED",
"MCCOY PHARMA PRIVATE LIMITED",
"MCCOY SILICONES LIMITED",
"SOUDAL INDIA PRIVATE LIMITED",
"MCCREADE SOFTWARE ASIA PRIVATE LIMITED",
"MCCS INFRA PRIVATE LIMITED",
"MCD BUILT ENVIRONMENT RESEARCH LABORATORY PRIVATE LIMITED",
"MCD CERACON PRIVATE LIMITED",
"MCDAAV SYSTEMS PRIVATE LIMITED",
"MCDERMOTT ENGINEERING SERVICES PRIVATE LIMITED",
"MCDONALD PELZ GLOBAL COMMODITIES INDIA PRIVATE LIMITED",
"MCDONALD'S INDIA PRIVATE LIMITED",
"MCDS GOLBAL SOLUTIONS (I) PRIVATE LIMITED",
"MCE CONSULTING ENGINEERS PRIVATE LIMITED",
"MCE SOCIETYS ENGLISH MEDIUM SCHOOL",
"MCELROY SALES AND SERVICE INDIA PRIVATE LIMITED",
"MCF FINLEASE PRIVATE LIMITED",
"MCF FOODS INDIA PRIVATE LIMITED",
"MCFADYEN CONSULTING SOFTWARE INDIA PRIVATE LIMITED",
"MCGEOCH MARINE ELECTRICALS PRIVATE LIMITED",
"MCGI PRIVATE LIMITED",
"MCGILL ENGINEERING INDIA PRIVATE LIMITED",
"MCGILL FOODS PRIVATE LIMITED",
"MCGN INFRA PRIVATE LIMITED",
"MCGRAW HILL EDUCATION INDIA PRIVATE LIMITED",
"MCGRAW HILL FINANCIAL INC.",
"MCHEMIST GLOBAL PRIVATE LIMITED",
"MCI GETS INDIA PRIVATE LIMITED",
"MCI MANAGEMENT INDIA PRIVATE LIMITED",
"MCI WORLD INDIA PRIVATE LIMITED",
"MCJ ENERGY ENGINEERS PRIVATE LIMITED",
"MCJ MULTIPACK PRIVATE LIMITED",
"MCK INFOLINK ONLINE LIMITED",
"MCK KUTTY ENGINEERING PROJECTS PRIVATE LIMITED",
"MCK KUTTY ENGINEERS PRIVATE LIMITED",
"MCKESSON",
"MCKINNON INDIA PRIVATE LIMITED",
"MCKINSEY & COMPANY INDIA LLP",
"MCKINSEY AND CO INC",
"MCKINSEY GLOBAL CAPABILITIES & SERVICES PRIVATE LIMITED",
"MCKINSEY GLOBAL SERVICES INDIA PRIVATE LIMITED",
"MCKINSEY KNOWLEDGE CENTRE INDIA PRIVATE LIMITED",
"MCKIOL BUSINESS SOLUTIONS PRIVATE LIMITED",
"MCKV INSTITUTE OF ENGINEERING",
"MCL BUILDERS PRIVATE LIMITED",
"MCLANE LOGISTICS PRIVATE LIMITED",
"MCLANSYS SOLUTIONS PRIVATE LIMITED",
"MCLARENS INSURANCE SURVEYORS AND LOSS ASSESSORS INDIA PRIVATE LIMITED",
"MCLAYERS MERCANTILE PVT LTD",
"MCLEAD ENTERPRISES",
"MCLEOD & CO LTD",
"MCLEOD RUSSEL INDIA LIMITED",
"MCLUBE ASIA PRIVATE LIMITED",
"MCM CONSTRUCTIONS INDIA PRIVATE LIMITED",
"MCM FLEXI CLADDING INDIA PRIVATE LIMITED",
"MCM TELECOM EQUIPMENT PRIVATE LIMITED",
"MCMETRO FOUNDATION",
"MCML PROJECTS PRIVATE LIMITED",
"MCN FARM FRESH PRIVATE LIMITED",
"MCN INFRASTRUCTURE PRIVATE LIMITED",
"MCN INTERNATIONAL (INDIA) PRIVATE LIMITED",
"MCN SOLUTIONS PRIVATE LIMITED",
"MCNALLY BHARAT ENGG CO LIMITED",
"MCNALLY BHARAT EQUIPMENTS LIMITED",
"MCNEIL AND ARGUS PHARMACEUTICALS LIMITED",
"MCNROE CONSUMER PRODUCTS PRIVATE LIMITED",
"MCNS POLYURETHANES INDIA PRIVATE LIMITED",
"MCO FEED PRIVATE LIMITED",
"MCO HATCHERIES PRIVATE LIMITED",
"MCON RASAYAN INDIA LIMITED",
"MCON RASAYAN PRIVATE LIMITED",
"M-CORE INDUSTRIES PRIVATE LIMITED",
"MCP PROPERTIES PRIVATE LIMITED",
"MCPHAR INTERNATIONAL PRIVATE LIMITED",
"MCPI PRIVATE LIMITED",
"MCPP INDIA PVT LTD",
"MCQDB PRIVATE LIMITED",
"MCQUILLING SHIPPING SERVICES INDIA PRIVATE LIMITED",
"MCR ENTERPRISES PRIVATE LIMITED",
"MCR TEXTILES PRIVATE LIMITED",
"MCRAM & SAH PRIVATE LIMITED",
"MCRC EXPORTS PRIVATE LIMITED",
"MCRENNETT FOODS PRIVATE LIMITED",
"M-CRIL LIMITED",
"MCS AUTO PRIVATE LIMITED",
"MCS COMMUNICATIONS PRIVATE LIMITED",
"MCS DIAGNOSTIC AND HOSPITAL PRIVATE LIMITED",
"MCS ELECTRICALS PRIVATE LTD",
"MCS FASTENERS (INDIA) LIMITED",
"MCS INDIA LIMITED",
"MCS LOGISTICS INTERNATIONAL PRIVATE LIMITED",
"MCS RESOURCES PRIVATE LIMITED",
"MCS SHARE TRANSFER AGENT LIMITED",
"MCS SOLUTIONS PRIVATE LIMITED",
"MCS TRADING COMPANY PRIVATE LIMITED",
"MCSRETAIL PRIVATE LIMITED",
"MCT BRATTBERG INDIA PRIVATE LIMITED",
"MCT CARDS & TECHNOLOGY PRIVATE LIMITED",
"MCT INDIA INFOTECH PRIVATE LIMITED",
"MCT IT SOLUTIONS PRIVATE LIMITED",
"MCTC EXIM PRIVATE LIMITED.",
"MCTEC INDIA PRIVATE LIMITED",
"MCUBE ADVISORS PRIVATE LIMITED",
"MCUBE INVESTMENTS SOFTWARE PRIVATE LIMITED",
"M-CUBE PROJECTS PRIVATE LIMITED",
"MCUBE TECHNOLIGES PRIVATE LIMITED",
"MCV MOTOCORP PRIVATE LIMITED",
"MCVU VENTURES PRIVATE LIMITED",
"MCW HEALTHCARE PRIVATE LIMITED",
"MCW INFOTECH PRIVATE LIMITED",
"MCWANE INDIA PRIVATE LIMITED",
"MCWAY MANAGEMENTS LIMITED",
"MD AIR & OCEAN FREIGHT INDIA PRIVATE LIMITED",
"MD BRASSWARE PRIVATE LIMITED",
"MD CONSULTANCY SOLUTIONS PRIVATE LIMITED",
"MD GARMENTS PRIVATE LIMITED",
"MD HATCHERIES",
"MD MANAGE INDIA PRIVATE LIMITED",
"MD MOVERS",
"MD PLASTECH PRIVATE LIMITED",
"MD PRODUCT DEVELOPMENT PRIVATE LIMITED",
"MD RETAIL INDIA PRIVATE LIMITED",
"MD SYNERGY INDIA PRIVATE LIMITED.",
"MD Y PASHA",
"MD. QUIYAMUDDIN KHAN ENGINEERS PRIVATE LIMITED",
"MD.YASIN CONSTRUCTION PRIVATE LIMITED",
"MDA AGROCOT PRIVATE LIMITED",
"MDA FOOTWEAR PRIVATE LIMITED",
"MDA FOUNDATION",
"MDA MINERAL DHATU (AP) PRIVATE LIMITED",
"MDA SUPERGRITS PRIVATE LIMITED",
"MDAAC INTERNATIONAL PRIVATE LIMITED",
"MDB CHEMICALS INDIA PRIVATE.LIMITED",
"MDB PROJECTS PRIVATE LIMITED",
"MDB SOFTWARE TECHNOLOGY PRIVATE LIMITED",
"MDB STEEL PRIVATE LIMITED",
"MDB TOURS AND FOREX PRIVATE LIMITED",
"MDC HEALTHCARE PRIVATE LIMITED",
"MDC IMPEX PRIVATE LIMITED",
"MDC PHARMACEUTICALS PRIVATE LIMITED",
"MDCWL LIMITED",
"MDD CATERES PRIVATE LIMITED",
"MDD ENGINEERING PRIVATE LIMITED",
"MDD MEDICAL SYSTEMS INDIA PRIVATE LIMITED",
"MDDA-RAMKY ISBUS TERMINAL LIMITED",
"MDEVERYWHERE INDIA PRIVATE LIMITED",
"MDFC FINANCIERS PRIVATE LIMITED",
"MDG ASSOCIATES PRIVATE LIMITED",
"MDG CONSULTANTS PRIVATE LIMITED",
"MDG IMPEX PRIVATE LIMITED",
"MDH MOTORS PRIVATE LIMITED",
"MDH WHEELS PRIVATE LIMITED",
"MDI LABORATORIES INDIA PRIVATE LIMITED",
"MDI NETWORX PRIVATE LIMITED",
"MDINDIA HEALTH INSURANCE TPA PRIVATE LIMITED",
"MDINDIA HEALTHCARE NETWORX PRIVATE LIMITED",
"MDK CHEMTEX PRIVATE LIMITED",
"MDL ENERGY SERVICES PRIVATE LIMITED",
"MDLR TOURS & TRAVEL PRIVATE LIMITED",
"MDM BUILDCONS PRIVATE LIMITED",
"MDM HOSPITAL",
"MDM TELEVENTURES PRIVATE LIMITED",
"MDMA MARKETING PRIVATE LIMITED",
"MDN EDIFY EDUCATION PRIVATE LIMITED",
"MDP FOOD AND BEVERAGES PRIVATE LIMITED",
"MDP INFRA (INDIA) PRIVATE LIMITED",
"MDR LOGISTICS PRIVATE LIMITED",
"MDRC SCANS & HEALTH CARE PRIVATE LIMITED",
"MDRIFT TECHNOLOGIES PRIVATE LIMITED",
"MDS AIR PRODUCTS PRIVATE LIMITED",
"MDS BIO-ANALYTICS PRIVATE LIMITED",
"MDS COATINGS (INDIA) PRIVATE LIMITED",
"MDS CONSTRUCTION AND DEVELOPERS PRIVATE LIMITED",
"MDS DIGITAL MEDIA PRIVATE LIMITED",
"MDS PACIFIC INDIA PRIVATE LIMITED",
"MDS PHOTOGRAPHY",
"MDSI OVERSEAS PRIVATE LIMITED",
"MDSS CONSTRUCTION PRIVATE LIMITED",
"MDV RESOURCES PRIVATE LIMITED",
"MDVR PROJECTS PRIVATE LIMITED",
"MDY HOSPITAL & RESEARCH CENTRE PRIVATE LIMITED",
"ME & MUMMY HOSPITAL PRIVATE LIMITED",
"M-E ENGINEERS DESIGN PRIVATE LIMITED",
"ME HIN",
"ME HIN TECH EDGE SOLUTIONS",
"ME INDIAN CONFERENCES PRIVATE LIMITED",
"ME N MOMS PRIVATE LIMITED",
"ME POLYMERS PRIVATE LIMITED",
"MEAD JOHNSON NUTRITIONINDIAPRIVATE LIMITED",
"MEADOW PROJECTS PRIVATE LIMITED",
"MEADOW RURAL ENTERPRISES PRIVATE LIMITED",
"MEADOW VALE OVERSEAS PRIVATE LIMITED",
"MEADOWLARK HEALTHCARE PRIVATE LIMITED",
"MEADOWS HOLIDAYS AND RESORTS PRIVATE LIMITED",
"MEADOWS WELLNESS INDIA PRIVATE LIMITED",
"MEADWESTVACO CORPORATION",
"MEAL FOODS INDUSTRIES PRIVATE LIMITED",
"MEALCO AGRO PRIVATE LIMITED",
"MEALITE FOODS PRIVATE LIMITED",
"MEALSMAN HOSPITALITY SERVICES PRIVATE LIMITED",
"MEALSMITH FOOD CONCEPTS PRIVATE LIMITED",
"MEALSZONE CAFE PRIVATE LIMITED",
"MEAN WELL INDIA ELECTRONICS PRIVATE LIMITED",
"MEASI ACADEMY OF ARCHITECTURE",
"MEASI COLLEGE OF EDUCATION",
"MEASI INSTITUTE OF INFORMATION TECHNOLOGY",
"MEASURE INDIA CORPORATION PRIVATE LIMITED",
"MEASURECON INSTRUMENTS PRIVATE LIMITED",
"MEASURED CONSULTECH SERVICES PRIVATE LIMITED",
"MEASUREWEL TECHNOVISION PRIVATE LIMITED",
"MEAT AND SPICE PRIVATE LIMITED",
"MEATEK FOOD MACHINERIES INDIA PRIVATE LIMITED",
"MEATTLES PRIVATE LIMITED",
"MEB PHARMA PRIVATE LIMITED",
"MEBA INDIA PRIVATE LIMITED",
"MEBELKART TECHNOLOGIES PRIVATE LIMITED",
"MEBESTO AUTO PRIVATE LIMITED",
"MEBHAV INVESTMENT PVT LTD",
"MEBITA PHARMACEUTICAL PRIVATE LIMITED",
"MEC BEARINGS PRIVATE LIMITED",
"MEC ELEC INDUSTRIAL SERVICES PRIVATE LIMITED",
"MEC GROWTHS TEX MACH PRIVATE LIMITED",
"MEC PUBLIC SCHOOL",
"MEC SHOT BLASTING EQUIPMENTS PVT.LTD.",
"MEC SUPPORT SERVICES PRIVATE LIMITED",
"MEC TECHNICAL ENGINEERS PRIVATE LIMITED",
"MEC TUBES PVT LTD",
"MECAB CABLES PRIVATE LIMITED",
"MECADEZ CORE TECHNOLOGIES PRIVATE LIMITED",
"MECAMIDI HPP INDIA PRIVATE LIMITED",
"MECATRIX FURNITURE AND DESIGN SOLUTIONS PRIVATE LIMITED",
"MECATRON ENTERPRISES PRIVATE LIMITED",
"MECC ALTE INDIA PRIVATE LIMITED",
"MECCA HEALTHCARE PRIVATE LIMITED",
"MECCANICA PLAST PRIVATE LIMITED",
"MECCANOTECNICA INDIA PRIVATE LIMITED",
"MECEKA GRAPHITE PRIVATE LIMITED",
"MECGALE AUTOMATION PRIVATE LIMITED",
"MECGALE PNEUMATICS PRIVATE LIMITED",
"MECH ENGINEERS",
"MECH ENGINEERS AND ERECTORS PRIVATE LIMITED",
"MECH FORGE ENGINEERING PRIVATE LIMITED",
"MECH INDUSTRIES PVT LTD",
"MECH TECHNIK INDIA PVT LTD",
"MECH WELL INDUSTRIES LIMITED",
"MECH WORLD ECO PRIVATE LIMITED",
"MECHADEMY ENGINEERING SOLUTIONS PRIVATE LIMITED",
"MECHANICA VALVES PRIVATE LIMITED",
"MECHANICAL ASSEMBLY SYSTEMS INDIA PVT LTD",
"MECHANICAL DIVISION LUCKNOW PWD",
"MECHANICAL ELECTRONICS COMPUTING CONCEPTS INDIA PRIVATE LIMITED",
"MECHANICAL PACKING INDUSTRIES PRIVATE LIMITED",
"MECHANO MAINTENANCE SERVICES PRIVATE LIMITED",
"MECHARTES RESEARCHERS PRIVATE LIMITED",
"MECHATECH BUSINESS CENTER PRIVATE LIMITED",
"MECHATECH INFO SYSTEMS PRIVATE LIMITED",
"MECHATRONICS CONTROL EQUIPMENTS INDIA PRIVATE LIMITED",
"MECHATRONICS SYSTEMS PRIVATE LIMITED",
"MECHATRONIK TECHNOLOGIES PRIVATE LIMITED",
"MECHAZONIX INDUSTRIES PRIVATE LIMITED",
"MECHCI CADD ENGINEERING PRIVATE LIMITED",
"MECHCI ENGG-PROJECTS PRIVATE LIMITED",
"MECHCON INDUSTRIAL SOLUTIONS PRIVATE LIMITED",
"MECHE PVT LTD",
"MECHELEK MEP PROJECTS PRIVATE LIMITED",
"MECHELONIC ENGINEERS PRIVATE LIMITED",
"MECHELONIC WELDERS PRIVATE LIMITED",
"MECHEM PRIVATE LIMITED",
"MECHEMCO RESINS PRIVATE LIMITED",
"MECHERI SMART CAPITAL PRIVATE LIMITED",
"MECHFAB COATINGS PRIVATE LIMITED",
"MECHFAB ENGINEERING INDUSTRIES PVT LTD",
"MECHFAB PROJECTS PRIVATE LIMITED",
"MECHFAST ENGINEERING PRIVATE LIMITED",
"MECHFIELD TECHNOLOGIES PRIVATE LIMITED",
"MECHINENI PROJECTS PRIVATE LIMITED",
"MECHIST ENGINEERING PRIVATE LIMITED",
"MECHKNOW INDIA PRIVATE LIMITED",
"MECHKRAFT ENGINEERING PRIVATE LIMITED",
"MECHLIN SOFTWARE TECHNOLOGY PRIVATE LIMITED",
"MECHLION INDIA PRIVATE LIMITED",
"MECHMAARK FILTECH INDIA PRIVATE LIMITED",
"MECHMANN ENGINEERING PRIVATE LIMITED",
"MECHMATRIX COMPONENTS INDIA PRIVATE LIMITED",
"MECHMEN MOTORS PRIVATE LIMITED",
"MECHNO SALES AGENCIES PVT LTD",
"MECHNOX PRIVATE LIMITED",
"MECHO LIGHT COMPONENTS (CHENGAI) PRIVATE LIMITED",
"MECHPARTS INDIA PRIVATE LIMITED",
"MECHPLUS SOLUTIONS PRIVATE LIMITED",
"MECHSEAL VALVE PRIVATE LIMITED",
"MECHSHOT ENGINEERS PRIVATE LIMITED",
"MECHSOFT DIGITAL TECHNOLOGIES PRIVATE LIMITED",
"MECHTA INDUSTRIES PRIVATE LIMITED",
"MECHTECH INDUSTRIES",
"MECHTECH INDUSTRIES PRIVATE LIMITED",
"MECHTOOL VISTA PRIVATE LIMITED",
"MECHVAC FABRICATORS I PRIVATE LIMITED",
"MECHVISION CONSTRUCTIONS PRIVATE LIMITED",
"MECHWAT TECHNOLOGIES PRIVATE LIMITED",
"MECH-WELL FITTINGS PVT LTD",
"MECHWELL TOOLS AND GAUGES PRIVATE LIMITED",
"MECHZEAL INTERPHASING PRIVATE LIMITED",
"MECK PHARMACEUTICALS AND CHMEICALS PRIVATE L",
"MECKAMALIL POLYMERS PRIVATE LIMITED",
"MECKINS ENGINEERING PVT LTD",
"MECKLAI FINANCIAL SERVICES PRIVATE LIMITED",
"MECKMILLS PRIVATE LIMITED",
"MECO INSTRUMENTS PRIVATE LIMITED",
"MECO METERS PRIVATE LIMITED",
"MECO TECHNOLOGIES PRIVATE LIMITED",
"MECO TOUGHENED GLASS PRIVATE LIMITED",
"MECON LIMITED",
"MECORD SYSTEMS AND SERVICES PRIVATE LIMITED",
"MECORDS INDIA PRIVATE LIMITED",
"MECO-TRONICS PRIVATE LIMITED",
"MECPOWER INFRASTRUCTURE PRIVATE LIMITED",
"MECPOWER SOLUTIONS LIMITED",
"MECPRO HEAVY ENGINEERING LIMITED",
"MECS INDIA PRIVATE LIMITED",
"MECTECH KNITFABS PRIVATE LIMITED",
"MECTECH PROCESS ENGINEERS PRIVATE LIMITED",
"MECTECH PROJECTS PRIVATE LIMITED",
"MECTRON DENTAL INDIA PRIVATE LIMITED",
"MECTUS SYSTEMS INDIA PRIVATE LIMITED",
"MECVEL TECHNOLOGIES PRIVATE LIMITED",
"MECWEL CONSTRUCTIONS PRIVATE LIMITED",
"MECWELL PHARMA MACHINERY PRIVATE LIMITED",
"MECWIN TECHNOLOGIES INDIA PRIVATE LIMITED",
"MECWISE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"MED CARE 365 MEDICAL SERVICES PRIVATE LIMITED",
"MED DOC MEDICARE PRIVATE LIMITED",
"MED FRESHE PRIVATE LIMITED",
"MED MANOR ORGANICS PRIVATE LIMITED",
"MED QUEST DIAGNOSTICS PRIVATE LIMITED",
"MED SUPDT RURAL HOSPITAL NILANGA",
"MED WASTE SOLUTIONS PRIVATE LIMITED",
"MEDABYSS RCM HEALTHCARE SERVICES PRIVATE LIMITED",
"MEDACE BUSINESS SOLUTIONS PRIVATE LIMITED",
"MEDAK SOLAR PROJECTS PRIVATE LIMITED",
"MEDALL HEALTHCARE PRIVATE LIMITED",
"MEDALL SCANS AND LABS RANCHI PRIVATE LIMITED",
"MEDALL SPARK DIAGNOSTICS NASHIK PRIVATE LIMITED",
"MEDALLIN SPORTS PRIVATE LIMITED",
"MEDALLION JEWELLERS PRIVATE LIMITED",
"MEDALLION MARINE PRIVATE LIMITED",
"MEDALLION SYNERGIES PRIVATE LIMITED",
"MEDANA INFRAHEIGHT PRIVATE LIMITED",
"MEDANTA HOLDINGS PRIVATE LIMITED",
"MEDANTA HOSPITAL",
"MEDANTA THE MEDICITY",
"MEDANTA¬†INSTITUTE¬†OF EDUCATION AND¬†RESEARCH",
"MEDAPATI MOTORS PRIVATE LIMITED",
"MEDARMI BIOPHAR PRIVATE LIMITED",
"MEDAS CONSULTANCY SERVICES PRIVATE LIMITED",
"MEDAS ENGGDESIGN PRIVATE LIMITED",
"MEDAS IMPEX PRIVATE LIMITED",
"MEDAVIN HEALTHTECH PRIVATE LIMITED",
"MEDBION HEALTHCARE PRIVATE LIMITED",
"MEDBPRO SOLUTIONS PRIVATE LIMITED",
"MEDBROS PRIVATE LIMITED",
"MEDCALIFORNIA SCIENTIFIC PRIVATE LIMITED",
"MEDCARE MANAGEMENT SERVICES PRIVATE LIMITED",
"MEDCASH HEALTHTECH PRIVATE LIMITED",
"MEDCIS PATHLABS INDIA PRIVATE LIMITED",
"MEDCITY INTERNATIONAL ACADEMY PRIVATE LIMITED",
"MEDCLOUD SOFTWARE SOLUTIONS (I) PRIVATE LIMITED",
"MEDCON PROJECTS PRIVATE LIMITED",
"MEDCONVERGE HEALTHCARE SERVICES PRIVATE LIMITED",
"MEDCORP PHARMACY PRIVATE LIMITED",
"MEDCURE INSTITUTE OF MEDICAL SCIENCES PRIVATE LIMITED",
"MEDCURE ORGANICS PRIVATE LIMITED",
"MEDDEY TECHNOLOGIES PRIVATE LIMITED",
"MEDDIFF TECHNOLOGIES PRIVATE LIMITED",
"MEDDO SAFEHAWK PRIVATE LIMITED",
"MEDE HEALTHCARE INDUSTRIES PRIVATE LIMITED",
"MEDEC MEDICARE LIMITED",
"MEDECINS SANS FRONTIERES INDIA",
"MEDEKOM VENTURES PRIVATE LIMITED",
"MED-EL INDIA PRIVATE LIMITED",
"MEDENET ANALYTICS INDIA PRIVATE LIMITED",
"MEDEOR HOSPITAL LIMITED",
"MEDEOR PHARMA PVT LTD",
"MEDEQUIP HEALTHCARE SOLUTIONS LLP",
"MEDERAL PHARMACEUTICALS PRIVATE LIMITED",
"MEDEVIS RUBPLAST INDIA PRIVATE LIMITED",
"MEDEXPERT BUSINESS CONSULTANTS PRIVATE LIMITED",
"MEDEXPERT SOFTWARE SOLUTIONS PRIVATE LIMITED",
"MEDFAST HEALTH SOLUTION PRIVATE LIMITED",
"MEDFIN INDIA PRIVATE LIMITED",
"MEDFLO HEALTH CARE PRIVATE LIMITED",
"MEDFLY HEALTHCARE PRIVATE LIMITED",
"MEDFORD HEALTHCARE PRIVATE LIMITED",
"MEDFORD PHARMACEUTICALS LLP",
"MEDGEL PRIVATE LIMITED",
"MEDGEN DRUGS AND LABORATORIES PRIVATE LIMITED",
"MEDGENIX PHARMA INDIA PRIVATE LIMITED",
"MEDGENOME LABS LIMITED",
"MEDGENSYS LABORATORIES PRIVATE LIMITED",
"MEDHA BOGIES PRIVATE LIMITED",
"MEDHA DYECHEM PRIVATE LIMITED",
"MEDHA ENERGY PRIVATE LIMITED",
"MEDHA FASHIONS PRIVATE LIMITED",
"MEDHA GANSER FUEL SYSTEMS PRIVATE LIMITED",
"MEDHA HOSTING (OPC) PRIVATE LIMITED",
"MEDHA RAILWAY EQUIPMENTS PRIVATE LIMITED",
"MEDHA RUBICON WATER TECHNOLOGIES PRIVATE LIMITED",
"MEDHA SERVO DRIVES PVT LTD",
"MEDHA TEXTILE AND EXPORTS PRIVATE LIMITED",
"MEDHA TRACTION EQUIPMENT PRIVATE LIMITED",
"MEDHAJ TECHNO CONCEPT PRIVATE LIMITED",
"MEDHAJITES SOLUTIONS PRIVATE LIMITED",
"MEDHANSH HOSIPITAL",
"MEDHANSH HOSPITAL BAREILLY",
"MEDHAS CONSULTANTS PRIVATE LIMITED",
"MEDHATIYA CONSTRUCTION COMPANY PVT LTD",
"MEDHAVI FOUNDATION",
"MEDHAVI PRESTRESSED PIPES PRIVATE LIMITED",
"MEDHAVI PROFESSIONAL SERVICES PRIVATE LIMITED",
"MEDHINI AGRITECH PRIVATE LIMITED",
"MEDI ANALYTIKA INDIA PRIVATE LIMITED",
"MEDI ASSIST INSURANCE TPA PRIVATE LIMITED",
"MEDI BIOTEK (INDIA) PRIVATE LIMITED",
"MEDI CARRIER PVT LTD",
"MEDI CHEM PHARMA REMEDIES PRIVATE LIMITED",
"MEDI CLUE RESEARCH & DIAGNOSTIC PRIVATE LIMITED",
"MEDI COMMERCE PRIVATE LIMITED",
"MEDI CONSULTANTS PRIVATE LIMITED",
"MEDI CURE HOSPITAL",
"MEDI FOCUS INDIA PRIVATE LIMITED",
"MEDI PHARM EQUIPMENTS PVT LTD",
"MEDI PLUS (INDIA) LIMITED",
"MEDI RASAYAN PRIVATE LIMITED",
"MEDI SALES AGENCIES",
"MEDI SIDDH PHARMA PRIVATE LIMITED",
"MEDI SUPDT HOSPI FOR MENTAL HEALTH",
"MEDI TRANSCARE PRIVATE LIMITED",
"MEDI WINGS BIO SCIENCE PRIVATE LIMITED",
"MEDI WORLD FERTILITY PRIVATE LIMITED",
"MEDI XPERT INDIA LIMITED",
"MEDIA 360 CONCEPT INDIA PRIVATE LIMITED",
"MEDIA 360 DEGREE SERVICES INDIA PRIVATE LIMITED",
"MEDIA BACKOFFICE INDIA PRIVATE LIMITED",
"MEDIA CAGE INDIA PRIVATE LIMITED",
"MEDIA CIRCLE PRIVATE LIMITED",
"MEDIA ENTERPRISES",
"MEDIA EVENTS AND ADVERTISING (INDIA) PRIVATE LIMITED",
"MEDIA GATE PRIVATE LIMITED",
"MEDIA IMPEX PRIVATE LIMITED",
"MEDIA INTERNATIONAL PRIVATE LIMITED",
"MEDIA IQ DIGITAL INDIA PRIVATE LIMITED",
"MEDIA MAGIC TECHNOLOGIES PRIVATE LIMITED",
"MEDIA MANOEUVRE (INDIA) PRIVATE LIMITED",
"MEDIA MATRIX WORLDWIDE LIMITED",
"MEDIA NET SOFTWARE SERVICES (INDIA) PRIVATE LIMITED",
"MEDIA NETWORK BROADCASTING PRIVATE LIMITED",
"MEDIA NETWORK I PRIVATE LIMITED",
"MEDIA NUCLEUS INDIA PRIVATE LIMITED",
"MEDIA ONE SOLUTIONS",
"MEDIA PRO ENTERPRISE INDIA PRIVATE LIMITED",
"MEDIA RESEARCH USERS COUNCIL INDIA",
"MEDIA SHOUTER",
"MEDIA SPACE COMMUNICATION & MARKETING PRIVATE LIMITED",
"MEDIA STAR PRIVATE LIMITED",
"MEDIA SUPPLEMENTS PRIVATE LIMITED",
"MEDIA SYSTEMS INDIA SOFT SOLUTIONS PRIVATE LIMITED",
"MEDIA TEAM SOLUTIONS (INDIA) PRIVATE LIMITED",
"MEDIA TRANSASIA INDIA PRIVATE LIMITED",
"MEDIA WIDE LABS PRIVATE LIMITED",
"MEDIA WORLD VENTURES LIMITED",
"MEDIA WORLDWIDE LIMITED",
"MEDIA24X7 ADVERTISING PRIVATE LIMITED",
"MEDIA3 INTERNATIONAL PRIVATE LIMITED",
"MEDIAAGILITY INDIA PRIVATE LIMITED",
"MEDI-ACCESS SOLUTIONS PRIVATE LIMITED",
"MEDIACOM COMMUNICATIONS PRIVATE LIMITED",
"MEDIADONUTS INDIA PRIVATE LIMITED",
"MEDIADRONE PRIVATE LIMITED",
"MEDIADTING PRIVATE LIMITED",
"MEDIAEDGE CIA INDIA PRIVATE LIMITED",
"MEDIAGIST DIGITAL PRIVATE LIMITED",
"MEDIAGURU CONSULTANTS PRIVATE LIMITED",
"MEDIAHOUSE MARKETING AND ADVERTISING PRIVATE LIMITED",
"MEDIAID HEALTH CARE PRIVATE LIMITED",
"MEDIAID MEDICAL ANCILLARY SERVICES",
"MEDIAIR HEALTHCARE PRODUCTS PRIVATE LIMITED",
"MEDIAKIND INDIA PRIVATE LIMITED",
"MEDIALAB 3D SOLUTIONS PRIVATE LIMITED",
"MEDIALOGIC SOLUTIONS PRIVATE LIMITED",
"MEDIAMAN INFOTECH PRIVATE LIMITED",
"MEDIAMANDI INTERNATIONAL PRIVATE LIMITED",
"MEDIAMATE ADVERTISING INDIA PRIVATE LIMITED",
"MEDIAMEDIC COMMUNICATIONS PRIVATE LIMITED",
"MEDIAN RESEARCH AND CONSULTING PRIVATE LIMITED",
"MEDIANEXT INFOPROCESSORS PRIVATE LIMITED",
"MEDIANT COMMUNICATIONS PRIVATE LIMITED",
"MEDIAOCEAN ASIA PRIVATE LIMITED",
"MEDIAONE GLOBAL ENTERTAINMENT LIMITED",
"MEDIAPOLE TECHNOLOGIES PRIVATE LIMITED",
"MEDIARKA LIFESCIENCES PRIVATE LIMITED",
"MEDIART HEALTHCARE PRIVATE LIMITED",
"MEDIART LIFE SCIENCE PRIVATE LIMITED",
"MEDIARUN DIGITAL PRIVATE LIMITED",
"MEDIASHA SERVICES PRIVATE LIMITED",
"MEDIASMART ATELIER PRIVATE LIMITED",
"MEDIATALK COMMUNICATIONS PRIVATE LIMITED",
"MEDIATE HEALTHCARE PRIVATE LIMITED",
"MEDIATECH CONSULTING PRIVATE LIMITED",
"MEDIATECH INTERNATIONAL PRIVATE LIMITED",
"MEDIATEK BANGALORE PRIVATE LIMITED",
"MEDIATEK INDIA TECHNOLOGY PRIVATE LIMITED",
"MEDIATEXT PRIVATE LIMITED",
"MEDIATORS AND AJANTHA SECURITIES PRIVATE LIMITED",
"MEDIATRONIX PRIVATE LIMITED",
"MEDIAWARE INFOTECH PRIVATE LIMITED",
"MEDIAWARE SYSTEMS INDIA PRIVATE LIMITED",
"MEDIAXPEDIA TECHNOLOGIES PRIVATE LIMITED",
"MEDIAZO DIGITAL LAB PRIVATE LIMITED",
"MEDI-BED (INDIA) PRIVATE LIMITED",
"MEDIBEST PHARMA PRIVATE LIMITED",
"MEDIBIOS LABORATORIES LIMITED",
"MEDIBLESS HOSPITAL PRIVATE LIMITED",
"MEDIBLESS PHARMA PRIVATE LIMITED",
"MEDIBOX DIGITAL SOLUTIONS PRIVATE LIMITED",
"MEDIBOX PHARMA PRIVATE LIMITED",
"MEDIBRUK PHARMA PRIVATE LIMITED",
"MEDIC BIOLOGICALS AND PHARMACEUTICALS PRIVATE LIMITED",
"MEDIC GURU HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"MEDIC MINDS PRIVATE LIMITED",
"MEDICA HOSPITALS PRIVATE LIMITED",
"MEDICA TS HOSPITAL PRIVATE LIMITED",
"MEDICAD HEALTHCARE PRIVATE LIMITED",
"MEDICAID LABS LLP",
"MEDICAL AND VISUAL TECHNOLOGIES PRIVATE LIMITED",
"MEDICAL BACK-OFFICE SOLUTIONS INDIA PRIVATE LIMITED",
"MEDICAL BILLING WHOLESALERS ACROLOGIC BUSINESS SOLUTIONS PVT. LTD",
"MEDICAL BIONIC PRIVATE LIMITED",
"MEDICAL COLLEGE",
"MEDICAL COLLEGE & HOSPITAL KOLKATA",
"MEDICAL COLLEGE HOSPITAL",
"MEDICAL COLLEGE HOSPITAL & RESEARCH CENTRE ADGAON",
"MEDICAL COLLEGE VADODARA",
"MEDICAL DEFENCE CONSULTANCY INDIA PRIVATE LIMITED",
"MEDICAL EDUCATION",
"MEDICAL EDUCATION TRUST ASSO. SURAT OF SEVENTH DAY ADVENTIST",
"MEDICAL EDUCATIONAL TRUST ASSOCIATION SURAT OF SEVENTH-DAY ADVENTIST",
"MEDICAL ELEBORATE CONCEPT PRIVATE LIMITED",
"MEDICAL ELECTRONIC SYSTEMS (INDIA) PRIVATE LIMITED",
"MEDICAL ENGINEERS (INDIA) LTD.",
"MEDICAL EQUIPMENT AND INSTRUMENT SERVICE",
"MEDICAL HEALTH & FAMILY WELFARE DEPARTMENT",
"MEDICAL INFORMATICS AND SOFTWARE SOLUTIONS PRIVATE LIMITED",
"MEDICAL INNOVATION PRIVATE LIMITED",
"MEDICAL MISSION HOSPITAL",
"MEDICAL OFFICER CL LI RESEARCH CUM TRAINING CENTRE",
"MEDICAL OFFICER COMMUNITY HEALTH CENTRE BARAPADA BHADRAK",
"MEDICAL OFFICER COMMUNITY HEALTH CENTRE MANGALPUR",
"MEDICAL OFFICER COTTAGE HOSPITAL TALODA DIST NANDURBAR",
"MEDICAL OFFICER IC SUPERVISORY URBAN LEPROSY UNIT IV MUMBAI",
"MEDICAL OFFICER INCHARGE ESIS DISPENSERY SANGLI",
"MEDICAL OFFICER PRIMARY HEALTH CENTER BIDHANIMA",
"MEDICAL OFFICER RURAL HOSPITAL VADGAON MAVA",
"MEDICAL POINT I LIMITED",
"MEDICAL RESEARCH FOUNDATION",
"MEDICAL SATHI PRIVATE LIMITED",
"MEDICAL SENSORS INDIA PRIVATE LIMITED",
"MEDICAL SOLUTIONS INDIA PRIVATE LIMITED",
"MEDICAL SUPERINDENT ESIS HOSPITAL AURANGABAD",
"MEDICAL SUPERINDENT ESIS HOSPITAL THANE",
"MEDICAL SUPERINTENDENT CLASS 1 RURAL HOSPITAL KHANDBARA TAL NANVAPUR",
"MEDICAL SUPERINTENDENT ESIS HOSPITAL KANDIVALI",
"MEDICAL SUPERINTENDENT ESIS HOSPITAL SOLAPUR",
"MEDICAL SUPERINTENDENT GENERAL HOSPITAL MALVANI MALAD SUB",
"MEDICAL SUPERINTENDENT RURAL HOSPITAL ALANDI",
"MEDICAL SUPERINTENDENT RURAL HOSPITAL",
"MEDICAL SUPERINTENDENT SERVICES HOSPITAL KOLHAPUR",
"MEDICAL SUPERINTENDENT SUB DISTRICT HOSPITAL ARVI",
"MEDICAL SUPERINTENDS COTTAGE HOSPITAL DARWHA DIST YAVATMAL",
"MEDICAL SUPERITENDENT RURAL HOSPITAL",
"MEDICAL SUPERITENDENT RURAL HOSPITAL WAI",
"MEDICAL SUPRINTENDENT CIVIL HOSPITA",
"MEDICAL TECHNOLOGY ASSOCIATION OF INDIA",
"MEDICAL TRUST HOSPITAL",
"MEDICALGORITHMICS INDIA PRIVATE LIMITED",
"MEDICALMINE INDIA PRIVATE LIMITED",
"MEDICALOCEAN SERVICES PRIVATE LIMITED",
"MEDICAMEN BIOTECH LIMITED",
"MEDICAMEN ORGANICS LIMITED.",
"MEDICANA PRIVATE LIMITED",
"MEDICAP HEALTHCARE LIMITED",
"MEDICAPS UNIVERSITY",
"MEDI-CAPS UNIVERSITY",
"MEDICARE AGENCIES PRIVATE LIMITED",
"MEDICARE DIAGNOSTICS PVT LTD",
"MEDICARE ENVIRONMENTAL MANAGEMENT PRIVATE LIMITED",
"MEDICARE HOSPITALS",
"MEDICARE HYGIENE LIMITED",
"MEDICARE REMEDIES PRIVATE LIMITED",
"MEDICARE T P A SERVICES I PRIVATE LIMITED",
"MEDICAREPLUS HEALTHCARE PRIVATE LIMITED",
"MEDICATE INTERNATIONAL PRIVATE LIMITED",
"MEDICEF PHARMA",
"MEDICEPT DENTAL INDIA PRIVATE LIMITED",
"MEDI-CHECK HEALTH SERVICES PRIVATE LIMITED",
"MEDICINE BOX CHEMIST PRIVATE LIMITED",
"MEDICINE DISTRIBUTORS PRIVATE LIMITED",
"MEDICITA PHARMA PRIVATE LIMITED",
"MEDICITI HEALTH CARE SERVICES PRIVATE LIMITED",
"MEDICITY HOSPITAL",
"MEDICITY MEDICHEM PRIVATE LIMITED",
"MEDICLEAR PRIVATE LIMITED",
"MEDICLONE BIOTECH PRIVATE LIMITED",
"MEDICLOVE BIOTECH PRIVATE LIMITED",
"MEDICLUE IMAGING PRIVATE LIMITED",
"MEDICLUE SURGICAL AND DISPOSABLE PRIVATE LIMITED",
"MEDICO ELECTRODES INTERNATIONAL LIMITED",
"MEDICO INTERCONTINENTAL LIMITED",
"MEDICO MULTISPECIALITY HOSPITAL PRIVATE LIMITED",
"MEDICO REMEDIES PRIVATE. LIMITED.",
"MEDICOETHIC HEALTHCARE PRIVATE LIMITED",
"MEDICOM INTERNATIONAL EYETECH PRIVATE LIMITED",
"MEDICOM SUPERDRUGS PHARMACY PRIVATE LIMITED",
"MEDICON LEATHER PRIVATE LIMITED",
"MEDICON SURGICAL TECHNOLOGIES PRIVATE LIMITED",
"MEDICONECTAR PHARMACY PRIVATE LIMITED",
"MEDICONZ INTERNATIONAL PRIVATE LIMITED",
"MEDICORES HOMOEOPATHIC LABORATORY PRIVATE LIMITED",
"MEDICOS DIOGNOSTIC AND MEDICAL RESEARCH INDIA PRIVATE LIMITED",
"MEDICOTRANS PRIVATE LIMITED",
"MEDICOVER HEALTHCARE PRIVATE LIMITED",
"MEDICOVER HOSPITAL",
"MEDICOVER TECH INDIA PRIVATE LIMITED",
"MEDICOX LIFESCIENCE PRIVATE LIMITED",
"MEDICRIT BIOTECH PRIVATE LIMITED",
"MEDICRON LIFE SCIENCES PRIVATE LIMITED",
"MEDICROSS LABORATORIES PRIVATE LIMITED",
"MEDICROSS PHARMA-CHEM LIMITED",
"MEDICURE MULTISPECIALITY HOSPITAL AND CARDIAC CENTERS",
"MEDICVISOR PRIVATE LIMITED",
"MEDICYTE PHARMACEUTICAL PRIVATE LIMITED",
"MEDIDENT INDIA PRIVATE LIMITED",
"MEDIEARTH LIFECARE PRIVATE LIMITED",
"MEDIEN DIGITAL NET WORKS PRIVATE LIMITED",
"MEDIENTE FILMS INTERNATIONAL PRIVATE LIMITED",
"MEDIERA HOSPITALS AND RESEARCH INSTITUTE PRIVATE LIMITED",
"MEDIESSENCE LIFEGLUE PRIVATE LIMITED",
"MEDIEVAL MEDICAL INDIA PRIVATE LIMITED",
"MEDI-EX DEVICES PRIVATE LIMITED",
"MEDIEX HEALTHCARE PRIVATE LIMITED",
"MEDIEZ PHARMA PRIVATE LIMITED",
"MEDIFLORENCE MEDICAMENTS LIMITED",
"MEDIFORCE HEALTHCARE PRIVATE LIMITED",
"MEDIFORCE RESEARCH PRIVATE LIMITED",
"MEDIGENCE NETWORK PRIVATE LIMITED",
"MEDIGENE HEALTH CARE PRIVATE LIMITED",
"MEDIGENMED CARE PRIVATE LIMITED",
"MEDIGINIC HEALTH SOLUTIONS PRIVATE LIMITED",
"MEDIGRAND PHARMACEUTICALS PRIVATE LIMITED",
"MEDIGRAPH PHARMACEUTICALS PRIVATE LIMITED",
"MEDIGROWTH HOSPITAL PRIVATE LIMITED",
"MEDIHAUXE HEALTHCARE PRIVATE LIMITED",
"MEDIHAUXE INTERNATIONAL PRIVATE LIMITED",
"MEDIHAUXE PHARMA PRIVATE LIMITED",
"MEDIHEALTH LIFESCIENCES ( INDIA ) PRIVATE LIMITED",
"MEDIHELP HEALTHCARE PRIVATE LIMITED",
"MEDIHOME CARE-SOLUTIONS PRIVATE LIMITED",
"MEDIHOPE HOSPITALS AND RESEARCH CENTRE PRIVATE LIMITED",
"MEDIHOUSE PHARMACY PRIVATE LIMITED",
"MEDIHUB ENTERPRISES PRIVATE LIMITED",
"MEDIINFOTEC PRIVATE LIMITED",
"MEDIIT HEALTH SOLUTIONS INDIA PRIVATE LIMITED",
"MEDIJOURN SOLUTIONS PRIVATE LIMITED",
"MEDIKART HEALTHCARE SYSTEMS PRIVATE LIMITED",
"MEDIKIGAI INDIA PRIVATE LIMITED",
"MEDIKLIN HEALTHCARE LIMITED",
"MEDIKON INDIA",
"MEDIKONDA CONSTRUCTIONS PRIVATE LIMITED",
"MEDILAB SPECIALITY LABORATORIES (INDIA) PRIVATE LIMITED",
"MEDILAND DIAGNOSTIC CENTRE PRIVATE LIMITED",
"MEDILENTE PHARMA PRIVATE LIMITED",
"MEDILENZ INNOVATIONS PRIVATE LIMITED",
"MEDILIEF BIOSCIENCES PRIVATE LIMITED",
"MEDILIFE HEALTH SCIENCES PRIVATE LIMITED",
"MEDILIFE IMPEX PRIVATE LIMITED",
"MEDILIGHT PRIVATE LIMITED",
"MEDILINE HEALTH MANAGEMENT AND RESEARCH CENTRE PRIVATE LIMITED",
"MEDILINK ENTERPRISES PRIVATE LIMITED",
"MEDILINK HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED",
"MEDILLOYD MEDICAMENT PRIVATE LIMITED",
"MEDIMAA DIAGNOSTICS PRIVATE LIMITED",
"MEDIMANAGE INSURANCE BROKING PRIVATE LIMITED",
"MEDIMAP HEALTHCARE PRIVATE LIMITED",
"MEDIMART MEDICAL SYSTEMS PRIVATE LIMITED",
"MEDIMATTER HEALTH MANAGEMENT PRIVATE LIMITED",
"MEDINA FROZEN FOOD EXPORTS PRIVATE LIMITED",
"MEDINAIN PRIVATE LIMITED",
"MEDINDIA HOSPITALS",
"MEDINETCORP SOLUTIONS PRIVATE LIMITED",
"MEDINEX LABORATORIES PRIVATE LIMITED",
"MEDINFRA INDIA PRIVATE LIMITED",
"MEDINI PUMPS PVT LTD",
"MEDINNBELLE HERBALCARE PRIVATE LIMITED",
"MEDINOK HEALTHCARE PRIVATE LIMITED",
"MEDINOMICS HEALTH CARE PRIVATE LIMITED",
"MEDINOVA DIAGNOSTIC SERVICES LIMITED",
"MEDINYX SOFTWARE SOLUTIONS PRIVATE LIMITED",
"MEDINZA BIOTECH",
"MEDIOLOGY SOFTWARE PRIVATE LIMITED",
"MEDION BIOTECH PRIVATE LIMITED",
"MEDION HEALTHCARE PRIVATE LIMITED",
"MEDIOS LABORATORIES PRIVATE LIMITED",
"MEDIP HEALTHTECH PRIVATE LIMITED",
"MEDIPAAMS INDIA PRIVATE LIMITED",
"MEDIPACK INNOVATIONS PRIVATE LIMITED",
"MEDIPARK HEALTHCARE PRIVATE LIMITED",
"MEDIPFLEGE PRIVATE LIMITED",
"MEDIPLAST PACKAGING NAGPUR PRIVATE LIMITED",
"MEDIPLUS HOSPITAL & RESEARCH CENTER PRIVATE LIMITED",
"MEDIPOINT HOSPITALS PRIVATE LIMITED",
"MEDIPROBE CONSULTANCY SERVICES PRIVATE LIMITED",
"MEDIQUIP SALES PRIVATE LIMITED",
"MEDIRENT SERVICES PRIVATE LIMITED",
"MEDIRIGG TECH PRIVATE LIMITED",
"MEDIRIZE PHARMACEUTICALS PRIVATE LIMITED",
"MEDISAGE E-LEARNING PRIVATE LIMITED",
"MEDISALES (INDIA) PRIVATE LIMITED",
"MEDISAM BIOMEDICAL SYSTEMS PRIVATE LIMITED",
"MEDISAP PHARMA PRIVATE LIMITED",
"MEDISCAN DIAGNOSTIC AND HEALTH CARE PRIVATE LIMITED",
"MEDISCAN SYSTEMS",
"MEDISCIENT DEVICES (OPC) PRIVATE LIMITED",
"MEDISCOPE GLOBAL SERVICES PRIVATE LIMITED",
"MEDISCRIBE INDIA PRIVATE LIMITED",
"MEDISCRIBES INFOTECH INDIALLP",
"MEDISEARCH LABORATORIES (BOMBAY) PRIVATE LIMITED",
"MEDISEARCH SYSTEMS PRIVATE LIMITED",
"MEDISHOPI PHARMACY PRIVATE LIMITED",
"MEDISHRI HEALTHCARE PRIVATE LIMITED",
"MEDISIGNS TRANSTECH PRIVATE LIMITED",
"MEDISOL LIFESCIENCE PRIVATE LIMITED",
"MEDISON HOSPITAL PRIVATE LIMITED",
"MEDISONIC EQUIPMENTS PRIVATE LIMITED",
"MEDISPAN LIMITED",
"MEDISPEC INDIA LIMITED",
"MEDISPHERE BIOTECH INDIA PRIVATE LIMITED",
"MEDISPHERE LIFE SCIENCES PRIVATE LIMITED",
"MEDISPRAY LABORATORIES PRIVATE LIMITED",
"MEDI-SQUARE HOSPITAL",
"MEDI-SQUARE HOSPITAL PRIVATE LIMITED",
"MEDISQUIRE GLOBAL EDUCATION RESOURCES PRIVATE LIMITED",
"MEDISTAR HOSPITAL PRIVATE LIMITED",
"MEDISTER INFECTION CONTROL SYSTEMS PRIVATE LIMITED",
"MEDISTICS GLOBAL PRIVATE LIMITED",
"MEDISUN LIFESCIENCE PRIVATE LIMITED",
"MEDISUN MEDICAL SOLUTIONS PRIVATE LIMITED",
"MEDISURE HEALTHCARE SERVICES",
"MEDISURGE HEALTH CARE PRIVATE LIMITED",
"MEDISURGE TECHNOLOGIES PRIVATE LIMITED",
"MEDISYNC HEALTH MANAGEMENT SERVICES PRIVATE LIMITED",
"MEDISYNTH CHEMICALS PVT LTD",
"MEDISYNTH NATURALS PRIVATE LIMITED",
"MEDISYS BIOTECH PRIVATE LIMITED",
"MEDISYS EDUTECH PRIVATE LIMITED",
"MEDIT SYSTEMS PRIVATE LIMITED",
"MEDITAB SOFTWARE INDIA PRIVATE LIMITED",
"MEDITAB SPECIALITIES LIMITED",
"MEDITAB SPECIALITIES PRIVATE LIMITED",
"MEDITATION PROPERTIES PRIVATE LIMITED",
"MEDITEC LAB PRIVATE LIMITED",
"MEDITECH DEVICES PRIVATE LIMITED",
"MEDITECH ENGINEERS PRIVATE LIMITED",
"MEDITECH HOSPITAL",
"MEDITECH OVERSEAS PRIVATE LIMITED",
"MEDITECH TECHNOLOGIES INDIA PRIVATE LIMITED",
"MEDITEK DIAGNOSTIC CENTER PRIVATE LIMITED",
"MEDITEK ENTERPRISES",
"MEDITEK LIFE SCIENCES PRIVATE LIMITED",
"MEDITEX PHARMA PVT LTD",
"MEDITOUCH HEALTHCARE PRIVATE LIMITED",
"MEDITRANS PERFORMANCE PRIVATE LIMITED",
"MEDITRINA HOSPITALS PRIVATE LIMITED",
"MEDITRINA INSTITUTE OF MEDICAL SCIENCES",
"MEDITRINA INSTITUTE OF MEDICAL SCIENCES PRIVATE LIMITED",
"MEDITRUE HEALTHCARE PRIVATE LIMITED",
"MEDITRUST DIAGNOSTIC AND IMAGING CENTRE PRIVATE LIMITED",
"MEDITUNE HEALTHCARE PRIVATE LIMITED",
"MEDIVAC SURGICAL PRIVATE LIMITED",
"MEDIVAL SUPERINTEDENT ESI HOSPITAL",
"MEDIVALLEY AMTZ INCBATION COUNCIL",
"MEDIVEL BIOTECH PRIVATE LIMITED",
"MEDIVENTIONS INDIA PRIVATE LIMITED",
"MEDIVERSAL HEALTHCARE PRIVATE LIMITED",
"MEDIVERVE LABORATORIES PRIVATE LIMITED",
"MEDIVIEW MR SCAN PRIVATE LIMITED",
"MEDIVIEW NURSING HOME PVT LTD",
"MEDIVISION INFOMEDIA PRIVATE LIMITED",
"MEDIVISION MULTY SPECIALITY HOSPITAL",
"MEDIVISION SCAN AND DIAGNOSTIC RESEARCH CENTRE PVT LTD",
"MEDIVISTA LIFESCIENCES PRIVATE LIMITED",
"MEDIVIZ PHARMA SERVICES PRIVATE LIMITED",
"MEDIVUE TECHNOLOGIES PRIVATE LIMITED",
"MEDIWEST LIFE CARE PRIVATE LIMITED",
"MEDIWIZ MEDICAL SERVICES PRIVATE LIMITED",
"MEDIWORLD PHARMA PRIVATE LIMITED",
"MEDIWORM PRIVATE LIMITED",
"MEDIX DIAGNOSTICS AND MRI CENTRE PRIVATE LIMITED",
"MEDIX MEDICAL SERVICES INDIA PRIVATE LIMITED",
"MEDIX MEDICAL SYSTEMS PRIVATE LIMITED",
"MEDIYORK PHARMA PRIVATE LIMITED",
"MEDIZANT LIFECARE PRIVATE LIMITED",
"MEDIZEN LABS PRIVATE LIMITED",
"MEDIZEST PHARMACEUTICALS PRIVATE LIMITED",
"MEDIZONE HOSPITALS PRIVATE LIMITED",
"MEDKART PHARMACY PRIVATE LIMITED",
"MEDLAB RESEARCH PRIVATE LIMITED",
"MEDLAR PHARMACHEM PRIVATE LIMITED",
"MEDLAY HEALTHCARE PRIVATE LIMITED",
"MEDLEY INDIA INFOSOLUTION PRIVATE LIMITED",
"MEDLEY PHARMACEUTICALS LIMITED",
"MEDLEYMED HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"MEDLIFE FORMULATIONS PRIVATE LIMITED",
"MEDLIFE INTERNATIONAL PRIVATE LIMITED",
"MEDLIFE PROPERTIES PRIVATE LIMITED",
"MEDLINE DIAGNOSTICS PRIVATE LIMITED",
"MEDLINE HEALTHCARE INDUSTRIES PRIVATE LIMITED",
"MEDLINE INDUSTRIES INDIA PRIVATE LIMITED",
"MED-LINK COMPUTER SCIENCES (INDIA) PRIVATE LIMITED",
"MEDLIS HEALTHCARE PRIVATE LIMITED",
"MEDMALL PHARMACY PRIVATE LIMITED",
"MEDMATE PHARMA PRIVATE LIMITED",
"MEDMEME INFORMATICS PRIVATE LIMITED",
"MEDMIDAS HEALTHCARE PRIVATE LIMITED",
"MEDMONX ENTERPRISES PRIVATE LIMITED",
"MEDNAUTIX OUTSOURCING PRIVATE LIMITED",
"MEDNEO MEDICAL COMMUNICATIONS PRIVATE LIMITED",
"MEDNEXT BIOTECH LIMITED",
"MEDNIK PHARMACEUTICALS LLP",
"MEDNOW PRIVATE LIMITED",
"MEDO SPECIA LABORATORIES PRIVATE LIMITED",
"MEDOCT LABS PRIVATE LIMITED",
"MEDOK LIFESCIENCES PRIVATE LIMITED",
"MEDOLWAY LIFE SCIENCES PRIVATE LIMITED",
"MEDONGO HEALTH PRIVATE LIMITED",
"MEDONICA HEALTHCARE PRIVATE LIMITED",
"MEDOOK INTERNATIONAL PRIVATE LIMITED",
"MEDOPHARM PRIVATE LIMITED",
"MEDOPLUS SERVICES PRIVATE LIMITED",
"MEDOPS TECHNOLOGY PRIVATE LIMITED",
"MEDORGANICS INDIA PRIVATE LIMITED",
"MEDORNA HEALTH SYSTEMS PRIVATE LIMITED",
"MEDORS RENEWABLE ENERGY PRIVATE LIMITED",
"MEDOX BIOTECH INDIA PRIVATE LIMITED",
"MEDOZ PHARMACEUTICALS PRIVATE LIMITED",
"MEDPACE CLINICAL RESEARCH INDIA PRIVATE LIMITED",
"MEDPAL PLUS HEALTH CARE SOLUTIONS PRIVATE LIMITED",
"MEDPHY TECHNOLOGIES PRIVATE LIMITED",
"MEDPIPER TECHNOLOGIES PRIVATE LIMITED",
"MEDPLEXUS INDIA PRIVATE LIMITED",
"MEDPLUS APEX HOSPITAL AHMEDNAGAR",
"MEDPLUS HEALTH SERVICES LIMITED",
"MEDPRIME TECHNOLOGIES PRIVATE LIMITED",
"MEDPRIO LIFE SCIENCES PRIVATE LIMITED",
"MEDPRO AGENCIES PRIVATE LIMITED",
"MED-PRO HEALTH CARE SERVICES PRIVATE LIMITED",
"MEDPRO MARKETING PRIVATE LIMITED",
"MEDPULSE DEVICES PRIVATE LIMITED",
"MEDREICH LIFE CARE LIMITED",
"MEDREICH LIMITED",
"MEDREV HEALTHCARE PRIVATE LIMITED",
"MEDREXCARE PHARMA PRIVATE LIMITED",
"MEDRHANS PHARMACEUTICALS PRIVATE LIMITED",
"MEDRIX LABS PRIVATE LIMITED",
"MEDRO MEDICAL SYSTEMS PRIVATE LIMITED",
"MEDRONA BILLING SERVICES PRIVATE LIMITED",
"MEDROUTE PHARMACEUTICALS PRIVATE LIMITED",
"MEDRYTE HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"MEDS AND SCANS INTERVENTIONS PRIVATE LIMITED",
"MEDS LIFE CARE",
"MEDSAFE PHARMACEUTICALS PRIVATE LIMITED",
"MEDSAVE HEALTH INSURANCE TPA LIMITED",
"MEDSEA HEALTHCARE PRIVATE LIMITED",
"MEDSEZE PRIVATE LIMITED",
"MEDSHORE HEALTH CARE PRIVATE LIMITED",
"MEDSIGN BIOTECH PRIVATE LIMITED",
"MEDSMART LOGISTICS PRIVATE LIMITED",
"MEDSOFT INDIA PRIVATE LIMITED",
"MEDSOL INDIA OVERSEAS PRIVATE LIMITED",
"MEDSOURCE HEALTHCARE PRIVATE LIMITED",
"MEDSOURCE OZONE BIOMEDICALS PRIVATE LIMITED",
"MEDSPHERE INDIA PRIVATE LIMITED",
"MEDSTAR CLINICS PRIVATE LIMITED",
"MEDSTAR HOSPITAL PRIVATE LIMITED",
"MEDSTAR SPECIALITY HOSPITAL",
"MEDSTOCKS PRIVATE LIMITED",
"MEDSTORE ASCLEPIUS PRIVATE LIMITED",
"MEDSTRATUS PRIVATE LIMITED",
"MEDSYNAPTIC PRIVATE LIMITED",
"MEDTABS PHARMA PRIVATE LIMITED",
"MEDTECH LIFE PRIVATE LIMITED",
"MEDTECH REMEDIES PRIVATE LIMITED",
"MEDTEEM INDIA PRIVATE LIMITED",
"MEDTEK.NET INDIA PRIVATE LIMITED",
"MEDTEL HEALTHCARE PRIVATE LIMITED",
"MEDTELERAD HEALTHCARE PRIVATE LIMITED",
"MEDTITANS MANAGEMENT SERVICES PRIVATE LIMITED",
"MEDTRAIL TECHNOLOGIES PRIVATE LIMITED",
"MEDTRIX HEALTHCARE COMMUNICATION SERVICES PRIVATE LIMITED",
"MEDTRONIC ENGINEERING AND INNOVATION CENTER PRIVATE LIMITED",
"MEDTRONIC INC.",
"MEDULANCE HEALTHCARE PRIVATE LIMITED",
"MEDULLA COMMUNICATIONS PRIVATE LIMITED",
"MEDULLA RECRUITMENT SERVICES PRIVATE LIMITED",
"MEDULLA SOFT TECHNOLOGIES PRIVATE LIMITED",
"MEDUSA BEVERAGES PRIVATE LIMITED",
"MEDUSA SERVICES PRIVATE LIMITED",
"MEDUSIND SOLUTIONS INDIA PRIVATE LIMITED",
"MEDVANCE HEALTH PRIVATE LIMITED",
"MEDVANTAGE INSURANCE TPA PRIVATE LIMITED",
"MEDVARSITY ONLINE LIMITED",
"MEDVERVE HEALTHCARE PRIVATE LIMITED",
"MEDVERVE IMPACT VENTURES PRIVATE LIMITED",
"MED-VET BIOLINKS PRIVATE LIMITED",
"MEDVIEW MEDICAL SERVICES PRIVATE LIMITED",
"MEDVIK PHARMACEUTICALS PRIVATE LIMITED",
"MEDVISION SOLUTIONS PRIVATE LIMITED",
"MEDVOICE TRANSCRIPT SOLUTIONS PRIVATE LIMITED",
"MEDWAY HOSPITALS",
"MEDWAY TECHNOLOGIES PRIVATE LIMITED",
"MEDWELL PACIFIC PRIVATE LIMITED",
"MEDWELL VENTURES PRIVATE LIMITED",
"MEDWHIZ EDUCARE PRIVATE LIMITED",
"MEDWISE OVERSEAS PRIVATE LIMITED",
"MEDWIZ HEALTH CARE COMMUNICATIONS PRIVATE LIMITED",
"MEDWRITE INDIA SOFTWARE SOLUTIONS PRIVATE LIMITED",
"MEDYBIZ PHARMA PRIVATE LIMITED",
"MEDYBIZ PRIVATE LIMITED",
"MEDYHEALTH TECHNOLOGIES PRIVATE LIMITED",
"MEDYK LIFESCIENCE PRIVATE LIMITED",
"MEDYSKY PRIVATE LIMITED",
"MEEAMI TECHNOLOGIES PRIVATE LIMITED",
"MEECON ENGINEERS PRIVATE LIMITED",
"MEEDAAS PROTEK PRIVATE LIMITED",
"MEEKA MACHINERY PRIVATE LIMITED",
"MEEKSTAR STEEL AND INFRA PRIVATE LIMITED",
"MEEL HOTELS PRIVATE LIMITED",
"MEELANZI BUYING CUM EXPORT HOUSE PRIVATE LIMITED",
"MEEM AGRO FOODS PRIVATE LIMITED",
"MEEMAIN CAPITAL ADVISORS PRIVATE LIMITED",
"MEENA ADVERTISERS",
"MEENA BAZAAR",
"MEENA BAZAR DEPARTMENT STORES PRIVATE LIMITED",
"MEENA CAST PRIVATE LIMITED",
"MEENA CIRCUITS PRIVATE LIMITED",
"MEENA COSMETIC PRODUCTS PRIVATE LIMITED",
"MEENA CREATIONS PRIVATE LIMITED",
"MEENA ELASTOMERS PRIVATE LIMITED",
"MEENA HOSPITAL",
"MEENA MEDICAL DISTRIBUTORS PRIVATE LIMITED",
"MEENA METAL IMPEX PRIVATE LIMITED",
"MEENA MINERALS PRIVATE LIMITED",
"MEENA PRINTS PRIVATE LIMITED",
"MEENA RESOURCES PRIVATE LIMITED",
"MEENAAKSHI MOLECULES PRIVATE LIMITED",
"MEENAAR GLOBAL CONSULTANTS LLP",
"MEENACHI MEDICAL COLLEGE",
"MEENACHIL HOTELS AND RESORTS PRIVATE LIMITED",
"MEENACHIL RUBBER WOOD LIMITED",
"MEENAKSHEE FABRICS (INDIA) PRIVATE LIMITED",
"MEENAKSHI ACADEMY OF HIGHER EDUCATION AND RESEARCH",
"MEENAKSHI AGRO AND FLOUR MILL PRIVATE LIMITED",
"MEENAKSHI ALLOYS PVT LTD",
"MEENAKSHI AMMAL COLLEGE",
"MEENAKSHI AMMAL DENTAL COLLEGE AND HOSPITAL",
"MEENAKSHI AUTO ZONE PRIVATE LIMITED",
"MEENAKSHI BEAUTY AND ACADEMY PRIVATE LIMITED",
"MEENAKSHI BRIGHT STEEL BARS PRIVATE LIMITED",
"MEENAKSHI CEMENT-N-STEEL (BANGLURU) PRIVATE LIMITED",
"MEENAKSHI CREATIONS PRIVATE LIMITED",
"MEENAKSHI DAIRY AND AGRO FARM PRIVATE LIMITED",
"MEENAKSHI DEVELOPERS (BANGALORE) PRIVATE LIMITED",
"MEENAKSHI EMBROIDERY YARN",
"MEENAKSHI ENERGY AND INFRASTRUCTURE HOLDINGS PRIVATE LIMITED",
"MEENAKSHI FERRO INGOTS PRIVATE LIMITED",
"MEENAKSHI FINVEST LIMITED",
"MEENAKSHI HATCHERIES PRIVATE LIMITED",
"MEENAKSHI HOSPITAL",
"MEENAKSHI INDIA LIMITED",
"MEENAKSHI INDUSTRIES PRIVATE LIMITED",
"MEENAKSHI INFRASTRUCTURES PRIVATE LIMITED",
"MEENAKSHI IRON AND STEEL SUPPLIERS (BANGALORE) PRIVATE LIMITED",
"MEENAKSHI MATERNITY & WOMEN CARE CENTRE",
"MEENAKSHI MEDICAL DISTRIBUTORS PRIVATE LIMITED",
"MEENAKSHI MERCANTILES LTD",
"MEENAKSHI METALLICS PRIVATE LIMITED",
"MEENAKSHI MISSION HOSPITAL & RESEARCH CENTRE",
"MEENAKSHI MOLDINGS PRIVATE LIMITED",
"MEENAKSHI MULTISPECIALITY HOSPITAL",
"MEENAKSHI NARAYANAN INVESTMENTS PRIVATE LIMITED",
"MEENAKSHI ODISHA POWER PRIVATE LIMITED",
"MEENAKSHI PAPER MILLS P LIMITED",
"MEENAKSHI POLYMERS PRIVATE LIMITED",
"MEENAKSHI POWER PRIVATE LIMITED",
"MEENAKSHI RE-ROLLERS PRIVATE LIMITED",
"MEENAKSHI SILK MILLS PRIVATE LIMITED",
"MEENAKSHI SMELTER AND ROLLERS PRIVATE LIMITED",
"MEENAKSHI SPEECH & HEARING CLINICS PRIVATE LIMITED",
"MEENAKSHI STEEL INDUSTRIES LIMITED",
"MEENAKSHI STRIPS PRIVATE LIMITED",
"MEENAKSHI SUNDARAM MICA MINES PRIVATE LIMITED",
"MEENAKSHI TEXTILES LTD",
"MEENAKSHI THERMEXO PRIVATE LIMITED",
"MEENAKSHI UDYOG (INDIA) PRIVATE LIMITED",
"MEENAM AQUA NEEDS",
"MEENAM CONSTRUCTIONS PRIVATE LIMITED",
"MEENAM HOSPITAL",
"MEENAMBAKKAM REALTY PRIVATE LIMITED",
"MEENAR INDUSTRIES LIMITED",
"MEENAR POLYDYED YARNS LIMITED",
"MEENASHI STEELS PRIVATE LIMITED",
"MEENAXI BUILDING SOLUTIONS PRIVATE LIMITED",
"MEENAXI FABRICS PRIVATE LIMITED",
"MEENAXY PHARMA PRIVATE LIMITED",
"MEENESH CONTRACTORS AND DEVELOPERS PRIVATE LIMITED",
"MEENESH IRRIGATION INDIA PRIVATE LIMITED",
"MEENU AGENCIES PRIVATE LIMITED",
"MEENU BHADORIYA SECURITY SOLUTION PRIVATE LIMITED",
"MEENU CREATION LLP",
"MEENU DRESSES PRIVATE LIMITED",
"MEENU PAPER MILLS PRIVATE LIMITED",
"MEENU PRINTS PRIVATE LIMITED",
"MEENU VYAPAAR PRIVATE LIMITED",
"MEERA AMENITIES PRIVATE LIMITED",
"MEERA AND CEIKO PUMPS PVT LTD",
"MEERA AND COMPANY LIMITED",
"MEERA BIKES PRIVATE LIMITED",
"MEERA CEMENT PRIVATE LIMITED",
"MEERA COTTON AND SYNTHETIC MILLS PRIVATE LIMITED",
"MEERA ENVIROTECH PRIVATE LIMITED",
"MEERA FIBRETEK PRIVATE LIMITED",
"MEERA GEMS PRIVATE LIMITED",
"MEERA GOPI JEWELS PRIVATE LIMITED",
"MEERA GRANITES PRIVATE LIMITED",
"MEERA HERBS PRIVATE LIMITED",
"MEERA HOSPITAL",
"MEERA INDUSTRIES LIMITED",
"MEERA JEWEL HOUSE",
"MEERA JEWELS PRIVATE LIMITED",
"MEERA LASER SOLUTIONS PRIVATE LIMITED",
"MEERA MANOURS & FERTILIZERS PRIVATE LIMITED.",
"MEERA MARBLES PVT. LTD.",
"MEERA MEDICAL AGENCIES",
"MEERA POLY CONTAINERS (INDIA) PRIVATE LIMITED",
"MEERA POLYMERS PRIVATE LIMITED",
"MEERA PROJECTS PRIVATE LIMITED",
"MEERA RESCUE SERVICES PRIVATE LIMITED",
"MEERA SAMUH CORPORATE SERVICES PRIVATE LIMITED",
"MEERA SAMUH HOSPITALITY SERVICES PRIVATE LIMITED",
"MEERA SHANTIVANAM PRIVATE LIMITED",
"MEERA STONES PRIVATE LIMITED",
"MEERA TEXTILES PRIVATE LIMITED",
"MEERAAM ACIDS PRIVATE LIMITED",
"MEERABAI INSTITUTE OF TECHNOLOGY",
"MEERABO GLOBAL FOUNDATION",
"MEERAJ KNITWEARS PRIVATE LIMITED",
"MEERAKUNJ POLYMERS PRIVATE LIMITED",
"MEERAN MINERALS PRIVATE LIMITED",
"MEERASA SKILLED TEAM PRIVATE LIMITED",
"MEERASOL ELECTRICALS PRIVATE LIMITED",
"MEEREEN TEXTILE PRIVATE LIMITED",
"MEERES MASTER SYSTEMS PRIVATE LIMITED",
"MEERO TECHNOLOGIES PRIVATE LIMITED",
"MEERUT AUTOMOBILES PRIVATE LIMITED",
"MEERUT COLLEGE",
"MEERUT CRITICAL CARE HOSPITAL",
"MEERUT DEVELOPMENT AUTHORITY",
"MEERUT INSTITUTE OF ENGINEERING AND TECHNOLOGY",
"MEERUT MEDICARE CENTRE PRIVATE LIMITED",
"MEERUT POLYPACK PRIVATE LIMITED",
"MEERUT PTFE PRODUCTS PRIVATE LIMITED",
"MEERUT PUBLIC SCHOOL",
"MEERUT ROAD CARRIERS PRIVATE LIMITED",
"MEERUT ROLLER FLOUR MILLS PRIVATE LIMITED",
"MEERUT SCAN CENTRE PRIVATE LIMITED",
"MEERUT SPORT TEX PRIVATE LIMITED",
"MEERUT SPUN PIPES PRIVATE LIMITED",
"MEERUT SUGARS PRIVATE LIMITED",
"MEESAN LOGISTICS PRIVATE LIMITED",
"MEESHA FABRICS PRIVATE LIMITED",
"MEET ASSOCIATES PRIVATE LIMITED",
"MEET CONSTRUCTION PRIVATE LIMITED",
"MEET CONTROL PANEL PRIVATE LIMITED",
"MEET DIAMONDS PRIVATE LIMITED",
"MEET ELECTRONICS JUNCTION LIMITED",
"MEET FABRICS PRIVATE LIMITED",
"MEET MARKETING (INDIA) PRIVATE LIMITED",
"MEET POLY PLAST PVT. LTD.",
"MEET PRECISION ENGINEERING WORKS (I) PRIVATE LIMITED",
"MEET PRIVATE LIMITED",
"MEET SANGHVI PRIVATE LIMITED",
"MEET SYNTHETICS PRIVATE LIMITED",
"MEETA ACCESSORIES PRIVATE LIMITED",
"MEETA AGRICORN PRIVATE LIMITED",
"MEETA SCREWS PRIVATE LIMITED",
"MEETANSH ENTERPRISES PRIVATE LIMITED",
"MEETEI CONSTRUCTION PRIVATE LIMITED",
"MEETHALE LOGISTICS PRIVATE LIMITED",
"MEETHI FOODS PRIVATE LIMITED",
"MEETRA SYNTHETICS PRIVATE LIMITED",
"MEETS FOREX PRIVATE LIMITED",
"MEETUS TECHNOLOGY PRIVATE LIMITED",
"MEEVER INDIA PRIVATE LIMITED",
"MEEVIN AGROMACH PRIVATE LIMITED",
"MEFCO ENGINEERS PRIVATE LIMITED",
"MEFCOM CAPITAL MARKETS LIMITED",
"MEFCOM SECURITIES LIMITED",
"MEFRO ORGANIC LIMITED",
"MEFS ENGINEERING PRIVATE LIMITED",
"MEGA ADVERTISING & MARKETING PRIVATE LIMITED",
"MEGA AUDIO INTERNATIONAL PRIVATE LIMITED",
"MEGA AUTOBAHN PRIVATE LIMITED",
"MEGA AUTOMOBILES PVT LTD",
"MEGA CABS LIMITED",
"MEGA CABS PRIVATE LIMITED",
"MEGA CALIBRE ENTERPRISES PRIVATE LIMITED",
"MEGA COLLECTIONS PRIVATE LIMITED",
"MEGA COMPU WORLD PRIVATE LIMITED",
"MEGA CONSTRUCTION LLP",
"MEGA CORPORATION LIMITED",
"MEGA CRANES INDIA PRIVATE LIMITED",
"MEGA DESIGNS PRIVATE LIMITED",
"MEGA DOORS & PLY PRIVATE LIMITED",
"MEGA ELECTRICALS PRIVATE LIMITED",
"MEGA ENERGY PRIVATE LIMITED",
"MEGA ENERGY SOLUTIONS PRIVATE LIMITED",
"MEGA ENGINEERING PRIVATE LIMITED",
"MEGA EPC PROJECTS PRIVATE LIMITED",
"MEGA FIBRE PRIVATE LIMITED",
"MEGA FINE PHARMA PRIVATE LIMITED",
"MEGA FLEX PLASTICS LIMITED",
"MEGA FORMWORKS INDIA PRIVATE LIMITED",
"MEGA FREIGHT MOVERS LIMITED",
"MEGA FUSION INDIA PRIVATE LIMITED",
"MEGA GRAIN TRADING COMPANY PRIVATE LIMITED",
"MEGA HEAT CAST PRIVATE LIMITED",
"MEGA HERTZ NETWORK SOLUTIONS PRIVATE LIMITED",
"MEGA INFOSOLUTIONS PRIVATE LIMITED",
"MEGA INFOTECH PRIVATE LIMITED",
"MEGA INFRA AND TRADING CO PRIVATE LIMITED",
"MEGA INFRA SERVICES PRIVATE LIMITED",
"MEGA INFRACITY PRIVATE LIMITED",
"MEGA INFRASTRUCTURE DEVELOPERS PRIVATE LIMITED",
"MEGA INNOVATIVE CROPS PRIVATE LIMITED",
"MEGA INTERNATIONAL PVT LTD",
"MEGA JEWELS PRIVATE LIMITED",
"MEGA KNITTERS PRIVATE LIMITED",
"MEGA LIFESCIENCES PRIVATE LIMITED",
"MEGA LINK CHAINS INDIA PRIVATE LIMITED",
"MEGA MALL MANAGEMENT SERVICES PRIVATE LIMITED",
"MEGA MATRIX PRIVATE LIMITED",
"MEGA MILLENNIUM SERVICES PRIVATE LIMITED",
"MEGA MINND BOOKS (INDIA) PRIVATE LIMITED",
"MEGA MOTORS PRIVATE LIMITED",
"MEGA MOVERS LOGISTICS PRIVATE LIMITED",
"MEGA NETWORKS PRIVATE LIMITED",
"MEGA NIRMAN & INDUSTRIES LIMITED",
"MEGA PACK AND CARRY PRIVATE LIMITED",
"MEGA PANEL PRIVATE LIMITED",
"MEGA PIPES PRIVATE LIMITED",
"MEGA PRINTOGRAPHICS PRIVATE LIMITED",
"MEGA PRODUCT PROCESSORS PRIVATE LIMITED",
"MEGA RADIOLOGY SERVICES PRIVATE LIMITED",
"MEGA RICE MILL PRIVATE LIMITED",
"MEGA RUBBER TECHNOLOGIES PRIVATE LIMITED",
"MEGA SAFE GUARD SERVICES PRIVATE LIMITED",
"MEGA SOURCE TECHNOLOGY INDIA PRIVATE LIMITED",
"MEGA STEELS PRIVATE LIMITED",
"MEGA SUPER REAL ESTATE DEVELOPERS (INDIA) PRIVATE LIMITED",
"MEGA SURYAURJA PRIVATE LIMITED",
"MEGA TECH POLYMERS PRIVATE LIMITED",
"MEGA TECHNOBIZ CONSULTANTS PRIVATE LIMITED",
"MEGA TELEMATICS PRIVATE LIMITED",
"MEGA TRENDS ADVERTISING LIMITED",
"MEGA VENTURE DEVELOPERS PRIVATE LIMITED",
"MEGA VITRIFIED TILES PRIVATE LIMITED",
"MEGA WATER PROOFING (INDIA) PRIVATE LIMITED",
"MEGAA MODA PRIVATE LIMITED",
"MEGAA SUPER GOOD FILMS PRIVATE LIMITED",
"MEGABOUND INDIA PRIVATE LIMITED",
"MEGABUCKS TRADERS PVT LTD",
"MEGABYTE SOLUTIONS PRIVATE LIMITED",
"MEGACHEM SPECIALTY CHEMICALS I PRIVATE LIMITED",
"MEGACHIP INSTRUMENTATION PRIVATE LIMITED",
"MEGACITY APARTMENTS PRIVATE LIMITED",
"MEGACITY FLOUR MILLS PRIVATE LIMITED",
"MEGACORP PROPERTY DEVELOPERS PRIVATE LIMITED",
"MEGACOSM COGNITIONS PRIVATE LIMITED",
"MEGACRAFT ENTERPRISES PRIVATE LIMITED",
"MEGADIMENSION INFRA PRIVATE LIMITED",
"MEGAEXPRESS FREIGHT SERVICES PRIVATE LIMITED",
"MEGAFIBRE INDIA PRIVATE LIMITED",
"MEGAFINE SPECIALITY CHEMICALS PRIVATE LIMITED",
"MEGAFOODS",
"MEGAGLOBAL MART PRIVATE LIMITED",
"MEGAHERTZ INFOTECH PRIVATE LIMITED",
"MEGAHERTZ INTERNET NETWORK PRIVATE LIMITED",
"MEGAKAP INSULATIONS PRIVATE LIMITED",
"MEGALIFT MATERIAL HANDLING PRIVATE LIMITED",
"MEGALO FOOD AND SERVICES PRIVATE LIMITED",
"MEGALO WORLDWIDE LOGISTICS PRIVATE LIMITED",
"MEGAM SYSTEMS LLP",
"MEGAMARVEL INFRA PRIVATE LIMITED",
"MEGAMAX SERVICES PRIVATE LIMITED",
"MEGAMET ENGINEERS PRIVATE LIMITED",
"MEGAMET STEELS PRIVATE LIMITED",
"MEGAMETRO ENGINEERING PRIVATE LIMITED",
"MEGAMIC ELECTRONICS PRIVATE LIMITED",
"MEGAMILES BEARING CUPS PRIVATE LIMITED",
"MEGAMIND CONSULTANTS PRIVATE LIMITED",
"MEGAMORPH MARKETING PRIVATE LIMITED",
"MEGAN ENTERPRISES PRIVATE LIMITED",
"MEGAN HEALTHCARE",
"MEGANEXUS INDIA PRIVATE LIMITED",
"MEGANTH INFORMATIX PRIVATE LIMITED",
"MEGAPACIFIC VENTURES PRIVATE LIMITED",
"MEGAPET CONTAINERS PRIVATE LIMITED",
"MEGAPLAST INDIA PRIVATE LIMITED",
"MEGAPOWER SOLUTIONS PRIVATE LIMITED",
"MEGARUB INDUSTRIES",
"MEGAS ARCHITECTURAL SERVICES PRIVATE LIMITED",
"MEGASAVE TRADING PRIVATE LIMITED",
"MEGASEA SHIPPING & LOGISTICS PRIVATE LIMITED",
"MEGASHOTS INTERNET PRIVATE LIMITED",
"MEGASOFT INFORMATION SYSTEMS PRIVATE LIMITED",
"MEGASOFT LIMITED",
"MEGASOFT SOLUTIONS INDIA PRIVATE LIMITED",
"MEGASOLIS RENEWABLES PRIVATE LIMITED",
"MEGASOURCE SERVICES PRIVATE LIMITED",
"MEGASPEED TECHNOLOGY PRIVATE LIMITED",
"MEGASTAR COOLERS PRIVATE LIMITED",
"MEGASTAR DOORS AND WINDOWS PRIVATE LIMITED",
"MEGASTAR FOODS LIMITED",
"MEGASTAR LED LIMITED",
"MEGASTAR PRODUCTS PRIVATE LIMITED",
"MEGASTONE LOGIPARKS PRIVATE LIMITED",
"MEGASYS BIOTEK PRIVATE LIMITED",
"MEGASYS INDIA PRIVATE LIMITED",
"MEGATAJ AGROVET PVT LTD",
"MEGATECH BUILDING PRODUCTS PRIVATE LIMITED",
"MEGATECH COMPONENTS PRIVATE LIMITED",
"MEGATECH CONSTRUCTION AND ENGINEERING PRIVATE LIMITED",
"MEGATECH CONTROL PRIVATE LIMITED",
"MEGATECH ENGINEERING AND SERVICES PRIVATE LIMITED",
"MEGATECH INDUSTRIES INDIA PRIVATE LIMITED",
"MEGATECH INTERNATIONAL PRIVATE LIMITED",
"MEGATECH PRODUCTS PRIVATE LIMITED",
"MEGATECHS COLD FORGINGS PRIVATE LIMITED",
"MEGATHERM ELECTRONICS PVT LTD",
"MEGATHERM INDUCTION LIMITED",
"MEGATRON CERAMIC PRIVATE LIMITED",
"MEGATRON IT SERVICES PRIVATE LIMITED",
"MEGATRON LOGISTICS PRIVATE LIMITED",
"MEGATRON SOLUTIONS PRIVATE LIMITED",
"MEGAVERSE TECHNOLOGIES PRIVATE LIMITED",
"MEGAVISION TECHNOLOGIES PRIVATE LIMITED",
"MEGAVOICE INDIA PRIVATE LIMITED",
"MEGAWARE TECHNOLOGIES PRIVATE LIMITED",
"MEGAWIDE CONSTRUCTION DMCC",
"MEGAWIDE INFRASTRUCTURE INDIA PRIVATE LIMITED",
"MEGAWIN SWITCHGEAR PRIVATE LIMITED",
"MEGAWORK DESIGN & ENGINEERING PRIVATE LIMITED",
"MEGAWORLD TECHNOLOGIES PRIVATE LIMITED",
"MEGBUILD DEVELOPERS PRIVATE LIMITED",
"MEGCO HOSPITALITY PRIVATE LIMITED",
"MEGDAP INNOVATION LABS PRIVATE LIMITED",
"MEGE MOBILE SHELTERS PRIVATE LIMITED",
"MEGGER INDIA PRIVATE LIMITED",
"MEGGHA FITTING AND PIPING INDIA PRIVATE LIMITED",
"MEGGHA TECHNOLOGIES PRIVATE LIMITED",
"MEGGITT INDIA PRIVATE LIMITED",
"MEGH 9 TECHNOLOGIES PRIVATE LIMITED",
"MEGH COMPUTING PRIVATE LIMITED",
"MEGH ENTERPRISES",
"MEGH MALLHAR MOTEL PRIVATE LIMITED",
"MEGH MEDITECH PRIVATE LIMITED",
"MEGH OVERSEAS PRIVATE LIMITED",
"MEGH PROMOTERS PRIVATE LIMITED",
"MEGH STEELS PRIVATE LIMITED",
"MEGH TECHNOLOGIES INDIA PRIVATE LIMITED",
"MEGH VARSHA ESTATE DEVELOPERS PRIVATE LIMITED",
"MEGHA AGRI FOOD PRODUCTS PRIVATE LIMITED",
"MEGHA AGROTECH PRIVATE LIMITED",
"MEGHA ASSAM PVT LTD",
"MEGHA AUTOMATIONS PRIVATE LIMITED",
"MEGHA BOTTLING",
"MEGHA COMPUSOFT PRIVATE LIMITED",
"MEGHA COMPUTERS",
"MEGHA ENGG & CONSTRUCTIONS PRIVATE LIMITED",
"MEGHA ENGINEERING & INFRASTRUCTURES LIMITED",
"MEGHA FIBRE GLASS INDUSTRIES LIMITED",
"MEGHA FINE FAB PRIVATE LIMITED",
"MEGHA FINLOAN PRIVATE LIMITED",
"MEGHA FORWARDERS PRIVATE LIMITED",
"MEGHA FRUIT PROCESSING PRIVATE LIMITED",
"MEGHA FUTURES PRIVATE LIMITED",
"MEGHA GOLD PRIVATE LIMITED",
"MEGHA HEALTHCARE PRIVATE LIMITED",
"MEGHA HOLDINGS PRIVATE LTD",
"MEGHA INFRASTRUCTURE PROJECTS PRIVATE LIMITED",
"MEGHA KITCHEN AND HOME APPLIANCES PRIVATE LIMITED",
"MEGHA MARKETING",
"MEGHA POLYFOAMS PRIVATE LIMITED",
"MEGHA PROPERTY DEVELOPERS LIMITED",
"MEGHA PUNCH FORMS PRIVATE LIMITED",
"MEGHA SERVICES PRIVATE LIMITED",
"MEGHA SPINNERS PVT LTD",
"MEGHA STAR AGRO - HORTITECH PRIVATE LIMITED",
"MEGHA TEA COMPANY PRIVATE LIMITED",
"MEGHA TECHNICAL & ENGINEERS PRIVATE LIMITED",
"MEGHA TRADECOM PRIVATE LIMITED",
"MEGHA UNIVERSAL SERVICES PRIVATE LIMITED",
"MEGHA VINCOM PRIVATE LIMITED",
"MEGHAAARIKA INTERNATIONAL",
"MEGHALAI STEELS PRIVATE LIMITED",
"MEGHALAYA AUTO AGENCIES PVT LTD",
"MEGHALAYA BITCHEM PRIVATE LIMITED",
"MEGHALAYA CAST & ALLOYS PRIVATE LIMITED",
"MEGHALAYA ENERGY CORPORATION LIMITED",
"MEGHALAYA GOVERNMENT CONSTRUCTION CORPORATION LTD",
"MEGHALAYA HOTELS PRIVATE LIMITED",
"MEGHALAYA LUBRICANTS PRIVATE LIMITED",
"MEGHALAYA MINERALS & MINES LIMITED",
"MEGHALAYA OXYGEN PRIVATE LIMITED",
"MEGHALAYA POWER DISTRIBUTION CORPORATION LIMITED",
"MEGHALAYA POWER LIMITED",
"MEGHALAYA POWER TRANSMISSION CORPORATION LIMITED",
"MEGHALAYA STATE ELECTRICITY BOARD",
"MEGHALAYA STEELS PRIVATE LIMITED",
"MEGHALAYA TRAVELS PRIVATE LIMITED.",
"MEGHAMALA ENTERPRISES PRIVATE LIMITED",
"MEGHANA FOODS PRIVATE LIMITED",
"MEGHANA HOUSE KEEPING CONSULTANCY SERVICES",
"MEGHAVATH COMPANY PRIVATE LIMITED",
"MEGHAVI AWAS PRIVATE LIMITED",
"MEGHAVI WELLNESS PRIVATE LIMITED",
"MEGHBELA CABLE & BROAD BAND SERVICES PVT LTD",
"MEGHDHAN TEXTILES PRIVATE LIMITED",
"MEGHDIPA LOGISTICS PRIVATE LIMITED",
"MEGHDOOT BUSINESS PRIVATE LIMITED",
"MEGHDOOT COMMODITIES PRIVATE LIMITED",
"MEGHDOOT EXPORT IMPORT PRIVATE LIMITED",
"MEGHDOOT GINNING AND PRESSING INDUSTRIES PRIVATE LIMITED",
"MEGHDOOT LAMINART PRIVATE LIMITED",
"MEGHDOOT LOGISTICS & INFRA PRIVATE LIMITED",
"MEGHDOOT MARKETING PRIVATE LIMITED",
"MEGHDOOT MULTI LINK PRIVATE LIMITED",
"MEGHDOOT OIL MILLS PRIVATE LIMITED",
"MEGHDOOT PACKAGING(UTTRANCHAL)",
"MEGHDOOT PISTONS PRIVATE LIMITED",
"MEGHDOOT REFRIGERATION INDUSTRIES PVT LTD",
"MEGHDOOT RESORTS PRIVATE LIMITED",
"MEGHDOOT TEXTILES PRIVATE LIMITED",
"MEGHDOOT VANIJYA PRIVATE LIMITED",
"MEGHDOOT VILLAGE PRODUCT PRIVATE LIMITED",
"MEGHDUT METAL TUBE INDUSTRIES PVT LTD",
"MEGHDUTAM TRAVELS PRIVATE LIMITED",
"MEGHE GROUP OF SCHOOL",
"MEGHHA FLOWERS PRIVATE LIMITED",
"MEGHMALA ROY EDUCATION CENTRE",
"MEGHMALHAR CONSULTING PRIVATE LIMITED",
"MEGHMALLAR ESTATES AND SERVICES PVT LTD",
"MEGHMANI DYES AND INTERMEDIATES LIMITED",
"MEGHMANI DYES AND INTERMEDIATES LLP",
"MEGHMANI FINECHEM LIMITED",
"MEGHMANI INDUSTRIES LIMITED",
"MEGHMANI LIFESCIENCES LIMITED",
"MEGHMANI LLP",
"MEGHMANI NOVOTECH PRIVATE LIMITED",
"MEGHMANI ORGANICS LIMITED",
"MEGHMANI PIGMENTS",
"MEGHMAYUR REALITY PRIVATE LIMITED",
"MEGHNA JEWELLERS PRIVATE LIMITED",
"MEGHNA RASAYAN PRIVATE LIMITED",
"MEGHNAD SAHA INSTITUTE OF TECHNOLOGY",
"MEGHNAGAR ORGANICS PRIVATE LIMITED",
"MEGHNAGAR PETROCHEMICALS PRIVATE LIMITED",
"MEGHNISH INFRASTRUCTURE PRIVATE LIMITED",
"MEGHRAJ FOOD PROCESSING INDIA PRIVATE LIMITED",
"MEGHRAJ HEALTHCARE PRIVATE LIMITED",
"MEGHRAJ IMPEX PRIVATE LIMITED",
"MEGHRAJ LOGISALES PRIVATE LIMITED",
"MEGHRAJ MARKETING PRIVATE LIMITED",
"MEGHRAJ PROPERTIES PRIVATE LIMITED",
"MEGHRAM ACCESSORIES SOLUTIONS PRIVATE LIMITED",
"MEGHUBA FABRICS PRIVATE LIMITED",
"MEGI CONTROL SYSTEMS PRIVATE LIMITED",
"MEGLYN TECHNOLOGIES PRIVATE LIMITED",
"MEGMA HEALTHCARE PRIVATE LIMITED",
"MEGMA RFID AND LABELS PRIVATE LIMITED",
"MEGMEET ELECTRICAL INDIA PRIVATE LIMITED",
"MEGMENTO PHARMACEUTICALS PRIVATE LIMITED",
"MEGNA FOREX AND TRAVELS PRIVATE LIMITED",
"MEGNA INFOTECH",
"MEGNA POULTRY PRIVATE LIMITED",
"MEGNEIL TECH PRIVATE LIMITED",
"MEGNITY TECHNOLOGIES PRIVATE LIMITED",
"MEGNUM PAPER MILL PRIVATE LIMITED",
"MEGO TECHNOLOGIES PRIVATE LIMITED",
"MEGOTIA CONSTRUCTION PRIVATE LIMITED",
"MEGRI SOFT LIMITED",
"MEGRON TECH PRIVATE LIMITED",
"MEGSAC INFRA PRIVATE LIMITED",
"MEGSAN DIAGNOSTICS PRIVATE LIMITED",
"MEGSOFT BUSINESS SOLUTIONS PRIVATE LIMITED",
"MEGTEC SYSTEMS INDIA PRIVATE LIMITED",
"MEGTIX TECHNOLOGIES PRIVATE LIMITED",
"MEGTRI ADHESIVES PRIVATE LIMITED",
"MEH INDIA OVERSEAS PRIVATE LIMITED",
"MEHADIA ENTERPRISES PRIVATE LIMITED",
"MEHAI TECHNOLOGY LIMITED",
"MEHAK E PUNJAB HOTEL & RESTAURANT PRIVATE LIMITED",
"MEHAK E PUNJAB RETREAT PRIVATE LIMITED",
"MEHAK FACILITY SERVICES PRIVATE LIMITED",
"MEHAK FINPRO (INDIA) PRIVATE LIMITED",
"MEHAK FOODS LIMITED",
"MEHAK INFRACON PRIVATE LIMITED",
"MEHAK INFRASTRUCTURE PRIVATE LIMITED",
"MEHAK INFRATECH PRIVATE LIMITED",
"MEHALA CARONA TEXTILES PRIVATE LIMITED",
"MEHALA MACHINES INDIA LIMITED",
"MEHALI PAPERS PRIVATE LIMITED",
"MEHAMIA SHOE PACKAGING PRIVATE LIMITED",
"MEHAR & MUKAND TOOLS PRIVATE LIMITED",
"MEHAR AUTOMOBILES PRIVATE LIMITED",
"MEHAR GLOBAL SPIRIT PRIVATE LIMITED",
"MEHAR METALS (INDIA) PRIVATE LIMITED",
"MEHAR SOLAR TECHNOLOGY PRIVATE LIMITED",
"MEHAR STEELS PRIVATE LIMITED",
"MEHAR TABLEWARE PRIVATE LIMITED",
"MEHAR TRAVELS PRIVATE LIMITED",
"MEHAR VOYAGES PRIVATE LIMITED",
"MEHAR WING SERVICES PRIVATE LIMITED",
"MEHARSONS ELECTRONICS PVT LTD",
"MEHBOOB PRESERVATIONS PRIVATE LIMITED",
"MEHBOOB PRODUCTION PRIVATE LIMITED",
"MEHBOOB SONS SELECTIONS PRIVATE LIMITED",
"MEHEK FORGING INDUSTRIES PRIVATE LIMITED",
"MEHEK MERCANTILE PRIVATE LIMITED",
"MEHENDIYA CONSTRUCTION PRIVATE LIMITED",
"MEHER ADVANCED MATERIALS PRIVATE. LIMITED.",
"MEHER CONTAINER TERMINALS PRIVATE LIMITED",
"MEHER DISTILLERIES PRIVATE LIMITED",
"MEHER DISTRIBUTORS PRIVATE LIMITED",
"MEHER FASHIONS PRIVATE LIMITED",
"MEHER FOUNDATIONS AND CIVIL ENGINEERS PRIVATE LIMITED",
"MEHER MANGOLDT INDUCTORS PRIVATE LIMITED",
"MEHER OIL INDUSTRIES PRIVATE LIMITED",
"MEHER PETROCHEM PRIVATE LIMITED",
"MEHER TECHNO CONSULTANTS PVT.LTD.",
"MEHER TRAILERS PRIVATE LIMITED",
"MEHERAA DAIRY FOODS AND PRODUCTS PRIVATE LIMITED",
"MEHERAFRIN INVESTMENTS PRIVATE LIMITED",
"MEHI METALLS & ALLOYS PRIVATE LIMITED",
"MEHIDPURWALA FURNISHERS PRIVATE LIMITED",
"ME-HIN CONSULTANTS & ADVISORE",
"ME-HIN METICULOUS & HIGHLY INTEGRATED FOCUSED SOURCING SOLUTIONS",
"MEHITH CREATION PRIVATE LIMITED",
"MEHJAL ADHESIVE TAPES PRIVATE LIMITED",
"MEHK CHEMICALS PRIVATE LIMITED",
"MEHMOOD CONSTRUCTION PRIVATE LIMITED",
"MEHO HCP AIR SYSTEMS PRIVATE LIMITED",
"MEHR GLOBAL FOODS AND BEVERAGES PRIVATE LIMITED",
"MEHR IMAGE PRIVATE LIMITED",
"MEHRA EYETECH PRIVATE LIMITED",
"MEHRA JEWEL PALACE PRIVATE LIMITED",
"MEHRA METAL COMPONENTS PRIVATE LIMITED",
"MEHRA POLYTEX PRIVATE LIMITED",
"MEHRA WAX PRODUCTS PRIVATE LIMITED",
"MEHRAB AUTO SALES PRIVATE LIMITED",
"MEHRAB MOTORS PRIVATE LIMITED",
"MEHRAE DI HATTI PRIVATE LTD",
"MEHRAJ TEXTILES PRIVATE LIMITED",
"MEHRASONS COATINGS PRIVATE LIMITED",
"MEHRATEX INDIA PRIVATE LIMITED",
"MEHRAULI REALTY AND CONSULTANTS LIMITED",
"MEHRIYAS LOGISTICS PRIVATE LIMITED",
"MEHROTRA BIOTECH PRIVATE LIMITED",
"MEHROTRA BUILDCON PRIVATE LIMITED",
"MEHROTRA CONSULTANTS PRIVATE LIMITED",
"MEHROTRA CONSUMER PRODUCTS PRIVATE LIMITED",
"MEHROTRA IMPEX PRIVATE LIMITED",
"MEHRU ELECTRICAL AND MECHANICAL ENGINEERS PRIVATE LIMITED",
"MEHRUN FOREX & TRAVELS PRIVATE LIMITED",
"MEHSANA DAIRY AND FOOD PRODUCTS LIMITED",
"MEHSANA DISTRICT COOPERATIVE MILK PRODUCERS' UNION LIMITED",
"MEHSANA MUNICIPALITY",
"MEHTA & MEHTA LEGAL AND ADVISORY SERVICES PRIVATE LIMITED",
"MEHTA & PADAMSEY INSURANCE SURVEYORS & LOSS ASSESSORS PRIVATE LIMITED",
"MEHTA ALLOYS LIMITED",
"MEHTA AND ASSOCIATES LLP",
"MEHTA AND PAZOL CONSULTING SERVICES PRIVATE LIMITED",
"MEHTA AUTOMOBILES PVT LTD",
"MEHTA AUTOMOTIVE PRIVATE LIMITED",
"MEHTA BREEDINGS PRIVATE LIMITED",
"MEHTA BROTHERS FRIEGHT FORWARDERS PRIVATE LIMITED",
"MEHTA BROTHERS GEMS PRIVATE LIMITED",
"MEHTA CAD CAM SYSTEMS PRIVATE LIMITED",
"MEHTA CLOTHING PRIVATE LIMITED",
"MEHTA E - STORES PRIVATE LIMITED",
"MEHTA ENGINEERS LIMITED",
"MEHTA ENGINEERS PRIVATE LIMITED",
"MEHTA ENTERPRISES PRIVATE LIMITED",
"MEHTA EQUITIES LIMITED",
"MEHTA EXCEL PRIVATE LIMITED",
"MEHTA EXPORT CORPORATION",
"MEHTA EYE CLINIC PRIVATE LIMITED",
"MEHTA FABRICS PRIVATE LIMITED",
"MEHTA FINANCIAL SERVICES PRIVATE LIMITED",
"MEHTA FLEX LLP",
"MEHTA FLEX PRIVATE LIMITED",
"MEHTA FREEZING HOUSE PRIVATE LIMITED",
"MEHTA GARMENTS PRIVATE LIMITED",
"MEHTA GEMS & JEWELLERY PRIVATE LIMITED",
"MEHTA GOLD",
"MEHTA HERBALS PVT LTD",
"MEHTA HITECH INDUSTRIES LIMITED",
"MEHTA ICE FACTORY PRIVATE LIMITED",
"MEHTA INFOCOM PRIVATE LIMITED",
"MEHTA INSULATORS PVT LTD",
"MEHTA JEWELLERY",
"MEHTA LOHISPAT PRIVATE LIMITED",
"MEHTA MEDICARE PVT.LTD.",
"MEHTA MULTISPECIALITY HOSPITALS INDIA PRIVATE LIMITED",
"MEHTA ORNAMENTS PRIVATE LIMITED",
"MEHTA PACKAGINGS PRIVATE LIMITED",
"MEHTA PETRO PRODUCTS PRIVATE LIMITED",
"MEHTA PETRO REFINERIES LIMITED",
"MEHTA PHARMACEUTICAL INDUSTRIES",
"MEHTA PHARMACEUTICALS PRIVATE LIMITED",
"MEHTA POLYPROPYLENE INDUS PVT LTD",
"MEHTA POLYTEX LIMITED",
"MEHTA POWER PRIVATE LIMITED",
"MEHTA PRINT ARTS PRIVATE LIMITED",
"MEHTA PRIVATE LIMITED",
"MEHTA PULSES LIMITED",
"MEHTA REAL ASSETS BANGALORE PRIVATE LIMITED",
"MEHTA RETAIL PRIVATE LIMITED",
"MEHTA SERVICES (INDIA) PRIVATE LIMITED",
"MEHTA SOLITAIRES PRIVATE LIMITED",
"MEHTA STAR HOTELS PRIVATE LIMITED",
"MEHTA STONE EXPORT HOUSE",
"MEHTA TEA PRIVATE LIMITED",
"MEHTA TEXMILLS (INDIA) PRIVATE LIMITED",
"MEHTA TIMES PRIVATE LIMITED",
"MEHTA TRANS LOGISTICS PRIVATE LIMITED",
"MEHTA TUBES LIMITED",
"MEHTA UNANI PHARMACY AND CO PVT LTD",
"MEHTA VAKIL AND COMPANY PRIVATE LIMITED",
"MEHTA WEALTH LIMITED",
"MEHTA WHEELS PRIVATE LIMITED",
"MEHTA'S SILK PRIVATE LIMITED",
"MEHTEX ENGINEERING PRIVATE LIMITED",
"MEHUL COLOURS AND MASTERBATCHES PRIVATE LIMITED",
"MEHUL CONSTRUCTION COMPANY PVT LTD",
"MEHUL ELECTRO INSULATING INDUSTRY",
"MEHUL ENTERTAINMENTS PRIVATE LIMITED",
"MEHUL FINANCE AND INVESTMENTS PRIVATE LIMITED",
"MEHUL IMPEX LIMITED",
"MEHUL ORGANICS PRIVATE LIMITED",
"MEHUL REALTORS PRIVATE LIMITED",
"MEI POWER PRIVATE LIMITED",
"MEIBAN ENGINEERING TECHNOLOGIES PRIVATE LIMITED",
"MEIDEN INDIA PRIVATE LIMITED",
"MEIDEN T&D (INDIA) LIMITED",
"MEIJI INDIA PRIVATE LIMITED",
"MEIKO CLEAN SOLUTIONS INDIA PRIVATE LIMITED",
"MEIKO LOGISTICS INDIA PRIVATE LIMITED",
"MEIL ADVANCED TECHNOLOGIES PRIVATE LIMITED",
"MEIL BHUBANESWAR BULK WATER PROJECT PRIVATE LIMITED",
"MEIL CHENGALA ROADWAYS PRIVATE LIMITED",
"MEIL FOUNDATION",
"MEIL HOLDINGS LIMITED",
"MEIL NEELESHWARAM ROADWAYS PRIVATE LIMITED",
"MEIL RENIGUNTA ROADWAYS PRIVATE LIMITED",
"MEIL VIJAYAWADA BYPASS ROADWAYS PRIVATE LIMITED",
"MEINE KUCHE INDIA PRIVATE LIMITED",
"MEINHARDT EPCM INDIA PRIVATE LIMITED",
"MEINHARDT INDIA PRIVATE LIMITED 100% FOR. SUB.CO.",
"MEINHARDT SINGAPORE PTE LIMITED",
"MEINIGAR TECHNOLOGIES PRIVATE LIMITED",
"MEIOSIS CHEMICALS PRIVATE LIMITED",
"MEIPPORUL AGRONOMICKS PRIVATE LIMITED",
"MEIR COMMODITIES INDIA PRIVATE LIMITED",
"MEISEI LOGISTIC INDIA PRIVATE LIMITED",
"MEISSA TECHNOLOGIES PRIVATE LIMITED",
"MEISTERVERSE PRIVATE LIMITED",
"MEISTERWURST INDIA PRIVATE LIMITED",
"MEJA URJA NIGAM PRIVATE LIMITED",
"MEK AIZAR PRIVATE LIMITED",
"MEK PERIPHERALS INDIA PRIVATE LIMITED",
"MEK STRUCTURAL ENGINEERING PRIVATE LIMITED",
"MEKA FURNISHINGS PRIVATE LIMITED",
"MEKA GRAVURE SOLUTIONS PRIVATE LIMITED",
"MEKA HOSPITALITY PRIVATE LIMITED",
"MEKALA METAL WORKS PRIVATE LIMITED",
"MEKALSUTA MOTORS PRIVATE LIMITED",
"MEKALSUTA SUGARS PRIVATE LIMITED",
"MEKANO ENGINEERING PRIVATE LIMITED",
"MEKASA PRODUCTS PRIVATE LIMITED",
"MEKASHI TOYS PRIVATE LIMITED",
"MEKASTER FINLEASE LIMITED",
"MEKERAN ENERGY & INFRA PRIVATE LIMITED",
"MEKFY ICOMMERCE PRIVATE LIMITED",
"MEKHOS TECHNOLOGY SERVICES PRIVATE LIMITED",
"MEKI POLYMERS PRIVATE LIMITED",
"MEKING BUILDTEC (INDIA) PRIVATE LIMITED",
"MEKINS INDUSTRIES PRIVATE LIMITED",
"MEKKVELL",
"MEKN TOOL INDIA PRIVATE LIMITED",
"MEKO AUTO PRIVATE LIMITED",
"MEKONG ENGINEERING & INFRASTRUCTURES PRIVATE LIMITED",
"MEKONG PHARMACEUTICALS PRIVATE LIMITED",
"MEKONG SILK MILLS PRIVATE LIMITED",
"MEKTRON MANUFACTURING INDIA PRIVATE LIMITED",
"MEKUMEE INTERNATIONAL PRIVATE LIMITED",
"MEL FLOORINGS PRIVATE LIMITED",
"MEL PROPERTIES PRIVATE LIMITED",
"MEL SYSTEMS AND SERVICES LIMITED",
"MEL TRAINING & ASSESSMENTS LIMITED",
"MEL WINDMILLS PRIVATE LIMITED",
"MELA ARTISANS (INDIA) PRIVATE LIMITED",
"MELAANGE STUDIO PRIVATE LIMITED",
"MELAMIAKI INFRACON PRIVATE LIMITED",
"MELANGE ASIA GLOBAL PRIVATE LIMITED",
"MELANGE DEVELOPERS PRIVATE LIMITED",
"MELANGE INTERIORS PRIVATE LIMITED",
"MELANGE SUITINGS PRIVATE LIMITED",
"MELBARR ITES PRIVATE LIMITED",
"MELBOURNE INSTITUTE OF TECHNOLOGY",
"MELBROW ENGINEERING WORKS PVT LTD",
"MELCAN FOOD VENTURES PRIVATE LIMITED",
"MELCO ENGRAVING INDIA PRIVATE LIMITED",
"MELCO INDIA PRIVATE LIMITED",
"MELCO TECHNOLOGIES INDIA PRIVATE LIMITED",
"MELCON CONTROLS PRIVATE LIMITED",
"MELCON TRANSFORMERS AND ELECTRICALS PRIVATE LIMITED",
"MELCON VIZAG PRIVATE. LIMITED.",
"MELGHAT COLD CHAIN PRIVATE LIMITED",
"MELGIRI POWER INFRAA PRIVATE LIMITED",
"MELI MAL WALAITI RAM TRADERS PRIVATE LIMITED",
"MELI MELO DESIGN PRIVATE LIMITED",
"MELIMU EDUTECH PRIVATE LIMITED",
"MELIORA ASSET RECONSTRUCTION COMPANY LIMITED",
"MELIORATE COMMODEAL PRIVATE LIMITED",
"MELIORATE ENGINEERS PRIVATE LIMITED",
"MELIORATE HEALTH OPC PRIVATE LIMITED",
"MELIORATE TRIDENT JV PRIVATE LIMITED",
"MELISSA TOURS AND TRAVELS PRIVATE LIMITED",
"MELIUS KNOWLEDGE AND TECHNOLOGY PRIVATE LIMITED",
"MELIUS TRADERS PRIVATE LIMITED",
"MELKER FINANCE AND LEASING PRIVATE LIMITED",
"MELKER PREMIUM LLP",
"MELKER TTI BIOFUELS LIMITED",
"MELLCON ENGINEERS PRIVATE LIMITED",
"MELLORA INFRASTRUCTURE PRIVATE LIMITED",
"MELLOW INFO SYSTEMS PRIVATE LIMITED",
"MELLULI TECHNOLOGIES PRIVATE LIMITED",
"MELMARUVATHUR ADHIPARASAKTHI INSTITUTE OF MEDICAL SCIENCES AND RESEARCH",
"MELMONT CONSTRUCTION PRIVATE LIMITED",
"MELOANIMATE EDUTECH PRIVATE LIMITED",
"MELOCARE WELLNESS PRIVATE LIMITED",
"MELODY ENTERPRISES PRIVATE LIMITED",
"MELODY HEALTHCARE PRIVATE LIMITED",
"MELODY POLYPLAST PRIVATE LIMITED",
"MELODY TOWN PLANNERS PRIVATE LIMITED",
"MELOG SPECIALITY CHEMICALS PRIVATE LIMITED",
"MELON TELECOM INDIA PRIVATE LIMITED",
"MELON VENTURES PRIVATE LIMITED",
"MELOT TECHNOLOGIES PRIVATE LIMITED",
"MELRONIA HOSPITALITY PRIVATE LIMITED",
"MELROSE CREATIONS PRIVATE LIMITED",
"MELROSE DO-IT-YOURSELF (OPC) PRIVATE LIMITED",
"MELROSE HEALTHCARE PRIVATE LIMITED",
"MELSTAR MANUFACTURING SYSTEMS PRIVATE LIMITED",
"MELT 'N' MELLOW FOODS PRIVATE LIMITED",
"MELTBOOK CONVERGENCE PRIVATE LIMITED",
"MELTECH CRANES PRIVATE LIMITED",
"MELTEK INFOSYSTEMS PRIVATE LIMITED",
"MELTIC HEALTHCARE PRIVATE LIMITED",
"MELTING POT CONCEPTS PRIVATE LIMITED",
"MELTING POT FOOD PRODUCTS PRIVATE LIMITED",
"MELT-O-THERM FURNACES PRIVATE LIMITED",
"MELTROLL ENGINEERING PRIVATE LIMITED",
"MELTRONICS SYSTEMTECH PRIVATE LIMITED",
"MELTWATER SOFTWARE PRIVATE LIMITED",
"MELUHA EDUCATIONAL SOCIETY",
"MELUHA TECHNOLOGIES PRIVATE LIMITED",
"MELUX CONTROL GEARS PRIVATE LIMITED",
"MELVAULT SOFTWARE SOLUTIONS PRIVATE LIMITED",
"MELYNA SEEDS PRIVATE LIMITED",
"MELZER CHEMICALS PRIVATE LIMITED",
"MEM ENGINEERING PRIVATE LIMITED",
"MEMBER SECRETARY ODISHA STATE LEGAL SERVICES AUTHORITY CUTTACK ODISHA",
"MEMBRANE ENGINEERING PRIVATE LIMITED",
"MEMBRANE FILTERS (INDIA) PRIVATE LIMITED",
"MEMBRANE FILTRATION SYSTEMS PRIVATE LIMITED",
"MEMBRANE GROUP INDIA PRIVATE LIMITED",
"MEMBRANE SYSTEM SPECIALISTS INDIA PRIVATE LIMITED",
"MEMCO ASSOCIATES I PRIVATE LIMITED",
"MEMCO ENGINEERING P LIMITED",
"MEMCO ENGINEERING PRIVATE LIMITED",
"MEMESYS CULTURAL LAB PRIVATE LIMITED",
"MEMG INTERNATIONAL INDIA PRIVATE LIMITED",
"MEMMERT INDIA LABORATORY EQUIPMENT PRIVATE LIMITED",
"MEMON HEALTH CARE PRIVATE LIMITED",
"MEMORABLE INDIA JOURNEYS PRIVATE LIMITED",
"MEMORY ELECTRONICS PRIVATE LIMITED",
"MEMORY GRAPHICS PRIVATE LIMITED",
"MEMORY REPRO SYSTEMS PRIVATE LIMITED",
"MEMORYAI INDIA PRIVATE LIMITED",
"MEMPHIS PRINTING AND PUBLISHING PRIVATE LIMITED",
"MEMPHIS VISION CARE PRIVATE LIMITED",
"MEMTECH FILTRATION INDUSTRIES PRIVATE LIMITED",
"MEN AT WORK ENGINEERS (I) PRIVATE LIMITED",
"MEN AT WORK STAGECRAFT MANAGEMENT PRIVATE LIMITED",
"MEN ROCKS PRIVATE LIMITED",
"MENA MANI INDUSTRIES LIMITED",
"MENAAL MOTEL AND RESORTS PRIVATE LIMITED",
"MENACHERY CHEMICALS PRIVATE LIMITED",
"MENACHERY HOTELS AND RESORTS PRIVATE LIMITED",
"MENAGA STEELS PRIVATE LIMITED",
"MENAKA ELECTRICALS PRIVATE LIMITED",
"MENAKA MILLS PRIVATE LIMITED",
"MENAMED PHARMA PRIVATE LIMITED",
"MENAR AUTO COMPONENTS PVT LTD",
"MENARINI PHARMA CEUTICAL LIMITED",
"MENCEE PHARMA PRIVATE LIMITED",
"MENDAS DIAMONDS PRIVATE LIMITED",
"MENDCURE LIFE SCIENCES PRIVATE LIMITED",
"MENDEL PHARMA PRIVATE LIMITED",
"MENDINE LIFECARE PRODUCTS PRIVATE LIMITED",
"MENDINE PHARMACEUTICALS PRIVATE LIMITED",
"MENDIRATTA BUSINESS SOLUTIONS PRIVATE LIMITED",
"MENDIRATTA HOSPITALITY AND FOODS PRIVATE LIMITED",
"MENDONSA INVESTMENTS PRIVATE LIMITED",
"MENDU ENTERPRISE PRIVATE LIMITED",
"MENETA AUTOMOTIVE COMPONENTS PRIVATE LIMITED",
"MENEZES FISHNET INDUSTRY PRIVATE LIMITED",
"MENEZES KAMCO FOODS PRIVATE LIMITED",
"MENEZES PHARMACEUTICALS LIMITED",
"MENKA TEXTILES INDUSTRIES PRIVATE LIMITED",
"MENKO ONLINE TRADING INDIA PRIVATE LIMITED",
"MENKOL INDUSTRIES PRIVATE LIMITED",
"MENLO REALTY LLP",
"MENLO TECHNOLOGIES INDIA PRIVATE LIMITED",
"MENLO WORLDWIDE FORWARDING INDIA PRIVATE LIMITED",
"MENLYN TRANSPORT PRIVATE LIMITED",
"MENMENTOR FACILITIES PRIVATE LIMITED",
"MENNEKES ELECTRIC INDIA PRIVATE LIMITED",
"MENOIR SEATING SYSTEM PRIVATE LIMITED",
"MENOKA JEWELLERY PRIVATE LIMITED",
"MENOKA TEA ESTATE PVT LTD",
"MENON AND MENON LIMITED",
"MENON BEARINGS LIMITED",
"MENON PISTON RINGS PRIVATE LIMITED",
"MENON PISTONS LIMITED",
"MENON RENEWABLE RESOURCES (INDIA) PRIVATE LIMITED",
"MENON TECHNICAL SERVICES PRIVATE LIMITED",
"MENON UNITED PRIVATE LIMITED",
"MENORAH REALTIES PRIVATE LIMITED",
"MENRIK BIOMERGE PRIVATE LIMITED",
"MENSA FOODS PRIVATE LIMITED",
"MENSA FUTURA LIFE SCIENCES PRIVATE LIMITED",
"MENSA MEDICARE INDIA PRIVATE LIMITED",
"MENSCHEN CONSULTING PRIVATE LIMITED",
"MENSCHEN SOCIALBOOTH PRIVATE LIMITED",
"MENSCHLICH HEALTHCARE PRIVATE LIMITED",
"MENSE ELECTRICALS PRIVATE LIMITED",
"MENSK MANAGEMENT SERVICES LIMITED",
"MENSON(INDIA) PRIVATE LIMITED",
"MENSTAR SERVICES PRIVATE LIMITED",
"MENT FIELD (INDIA) PRIVATE LIMITED",
"MENTATION TECHNOLOGIES PRIVATE LIMITED",
"MENTCO MANUFACTURING PRIVATE LIMITED",
"MENTESO TECHNOLOGIES PRIVATE LIMITED",
"MENTHA AND ALLIED PRODUCTS PRIVATE LIMITED",
"MENTIS SOFTWARE SOLUTIONS INDIA PRIVATE LIMITED",
"MENTISSOFT SOLUTIONS PRIVATE LIMITED",
"MENTO VINIMAY PVT.LTD.",
"MENTOR CAPITAL LIMITED",
"MENTOR CAPITAL SERVICES PRIVATE LIMITED",
"MENTOR FINANCIAL SERVICES PRIVATE LIMITED",
"MENTOR FINMART PRIVATE LIMITED",
"MENTOR FUNDS DISTRIBUTORS PRIVATE LIMITED",
"MENTOR HOME LOANS INDIA LIMITED",
"MENTOR INFOCOMM INDIA PRIVATE LIMITED",
"MENTOR INFOTECH PRIVATE LIMITED",
"MENTOR KNOWLEDGE MANAGEMENT PRIVATE LIMITED",
"MENTOR MANAGEMENT AND FINANCIAL ADVISORS PRIVATE LIMITED",
"MENTOR MINDS SOLUTIONS & SERVICES PRIVATE LIMITED",
"MENTOR NEST ANIMATION PRIVATE LIMITED",
"MENTOR PRINTING AND LOGISTICS PRIVATE LIMITED",
"MENTOR SECURERS PRIVATE LIMITED",
"MENTOR WATER EXPERT PRIVATE LIMITED",
"MENTORED COUNSELLING PRIVATE LIMITED",
"MENTORIA PRIVATE LIMITED",
"MENTORIS PROFESSIONAL SERVICES PRIVATE LIMITED",
"MENTORME FOUNDATION",
"MENTORS ETHICARE PRIVATE LIMITED",
"MENZ HEALTH INTERNATIONAL PRIVATE LIMITED",
"MENZEL ENGINEERING INDIA PRIVATE LIMITED",
"MENZEL VISION & ROBOTICS PRIVATE LIMITED",
"MENZIES AVIATION BOBBA BANGALORE PRIVATE LIMITED",
"MENZIES AVIATION INDIA PRIVATE LIMITED",
"MEO INTERNATIONAL LOGISTICS INDIA PRIVATE LIMITED",
"MEONE HEALTHCARE PRIVATE LIMITED",
"MEOTIDA PRIVATE LIMITED",
"MEP INDIA PRIVATE LIMITED",
"MEP INFRASTRUCTURE DEVELOPERS LIMITED",
"MEP INFRASTRUCTURE PRIVATE LIMITED",
"MEP SYSTEM SOLUTIONS PRIVATE LIMITED",
"MEPCO INDUSTRIES LIMITED",
"MEPCON PROJECTS PRIVATE LIMITED",
"MEPGEN SOLAR PRIVATE LIMITED",
"MEPL MAINTENANCE PRIVATE LIMITED",
"MEPLA-UTTURKAR FITTINGS PRIVATE LIMITED",
"MEPPADI PLANTATIONS PRIVATE LIMITED",
"MEPPAYIL VENTURES PRIVATE LIMITED",
"MEPRO PHARMACEUTICALS PRIVATE LIMITED",
"MEPRO TECHNOLOGY (INDIA) CO PRIVATE LIMITED",
"MEPROMAX LIFE SCIENCES PRIVATE LIMITED",
"MEPS PACKAGING AND WARES PRIVATE LIMITED",
"MEPSERVE INDIA PRIVATE LIMITED",
"MEPSTRA ENGINEERING & CONSULTANCY PRIVATE LIMITED",
"MEPSTRA POWER SOLUTIONS & CONTROLS PRIVATE LIMITED",
"MERA BABA REAL ESTATE PRIVATE LIMITED",
"MERA BABA REALITY ASSOCIATES PRIVATE LIMITED",
"MERA BATHROOM PRIVATE LIMITED",
"MERA GAO MICRO GRID POWER PRIVATE LIMITED",
"MERA INTERNATIONAL INDIA PRIVATE LIMITED",
"MERA JOB INDIA PRIVATE LIMITED",
"MERA TRAVELS PRIVATE LIMITED",
"MERAGO SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"MERAIR TRAVEL AND TOURS PRIVATE LIMITED",
"MERAJ COMMERCIAL PRIVATE LIMITED",
"MERAK HOZE PRIVATE LIMITED",
"MERAKI COMMUNICATIONS PRIVATE LIMITED",
"MERAKI ENGINEERS",
"MERAKI HEALTH",
"MERAKI IDEALABS PRIVATE LIMITED",
"MERAKI LAMINATES INDUSTRIES PRIVATE LIMITED",
"MERAKI PROJECTS INDIA PRIVATE LIMITED",
"MERAKI REALTY SOLUTIONS PRIVATE LIMITED",
"MERAKI SHIPPING INDIA PRIVATE LIMITED",
"MERAKI SPORT & ENTERTAINMENT PRIVATE LIMITED",
"MERAKIE EXPERIENTIAL SOLUTIONS PRIVATE LIMITED",
"MERAKISAN PRIVATE LIMITED",
"MERAMEX PRIVATE LIMITED",
"MERAPATH EDUCATION LIMITED",
"MERAQEE PRIVATE LIMITED",
"MERAQUI VENTURES PRIVATE LIMITED",
"MERASHA SHAPERS PRIVATE LIMITED",
"MERASTOCK INDIA PRIVATE LIMITED",
"MERC ENGINEERING SERVICES PRIVATE LIMITED",
"MERC INFRA INDIA PRIVATE LIMITED",
"MERC LOGISTICS INDIA PRIVATE LIMITED",
"MERC LOGIX PRIVATE LIMITED",
"MERC MOTORS AND SERVICES PRIVATE LIMITED",
"MERCADOS ENERGY MARKETS INDIA PRIVATE LIMITED",
"MERCANTILE AND INDUSTRIAL DEVELOPMENT CO LIMITED",
"MERCANTILE CAPITALS AND FINANCIAL SERVICES PRIVATE LIMITED",
"MERCANTILE CORPS NE PVT LTD",
"MERCANTILE MARKETING INDIA PRIVATE LIMITED",
"MERCANTILE VENTURES LIMITED",
"MERCANUS MERCANTILE PRIVATE LIMITED",
"REMIGES TECHNOLOGIES PRIVATE LIMITED",
"MERCEDES BENZ RESEARCH AND DEVELOPMENT INDIA PRIVATE LIMITED",
"MERCEDES-BENZ FINANCIAL SERVICES INDIA PRIVATE LIMITED",
"MERCEDES-BENZ INDIA PRIVATE LIMITED",
"MERCER CONSULTING (INDIA) PRIVATE LIMITED",
"MERCER CONSULTING INDIA PRIVATE LIMITED",
"MERCER WEALTH (INDIA) PRIVATE LIMITED",
"MERCHANT DEHYDRATES PRIVATE LIMITED",
"MERCHANT ENGINEERING COLLEGE",
"MERCHANT ENGINEERING PRIVATE LIMITED",
"MERCHANT EXIMP TRADE PRIVATE LIMITED",
"MERCHANT EXPRESS LOGISTICS PRIVATE LIMITED",
"MERCHANT FINVEST PRIVATE LIMITED",
"MERCHANT FOODS AND HOSPITALITY PRIVATE LIMITED",
"MERCHANT RECORDS PRIVATE LIMITED",
"MERCHANT SCIENCE COLLEGE",
"MERCHANT SHIPPING SERVICES PRIVATE LIMITED",
"MERCHANT VENTURES PRIVATE LIMITED",
"MERCHANTAS INFRAHEIGHTS PRIVATE LIMITED",
"MERCHANTS' CHAMBER OF COMMERCE & INDUSTRY",
"MERCHSERVE GLOBAL PRIVATE LIMITED",
"MERCK LIFE SCIENCE PRIVATE LIMITED",
"MERCK LIMITED",
"MERCK PERFORMANCE MATERIALS PRIVATE LIMITED",
"MERCK SPECIALITIES PRIVATE LIMITED",
"MERCO ENGINEERS PRIVATE LIMITED",
"MERCOM COMMUNICATIONS INDIA PRIVATE LIMITED",
"MERCUR REMEDIES PRIVATE LIMITED",
"MERCURE HOTEL SAK BUILD TECH PRIVATE LIMITED",
"MERCURE METALS AND ALLOYS PRIVATE LIMITED",
"MERCURE PHARMACEUTICALS (OPC) PRIVATE LIMITED",
"MERCURI GOLDMANN INDIA PRIVATE LIMITED",
"MERCURI TALENT MANAGEMENT PRIVATE LIMITED",
"MERCURIUS ADVISORY SERVICES PRIVATE LIMITED",
"MERCURIUS CORPORATE ADVISORY SERVICES PRIVATE LIMITED",
"MERCURIUS INFO TECH INDIA PRIVATE LIMITED",
"MERCURIUS TRAVEL PRIVATE LIMITED",
"MERCURY (INTERNATIONAL) P.LTD.",
"MERCURY BUILD MART PRIVATE LIMITED",
"MERCURY CAPITAL ADVISORS INDIA PRIVATE LIMITED",
"MERCURY COMMUNICATION DESIGN PRIVATE LIMITED",
"MERCURY COTTEX PRIVATE LIMITED",
"MERCURY DESIGNS AND SOLUTIONS PRIVATE LIMITED",
"MERCURY ENSEMBLES AND TEXTILES PRIVATE LIMITED",
"MERCURY EV-TECH LIMITED",
"MERCURY FABRICS PRIVATE LIMITED",
"MERCURY FITTINGS PRIVATE LIMITED",
"MERCURY FLUID POWER PRIVATE LIMITED",
"MERCURY GLOBAL PRIVATE LIMITED",
"MERCURY HEALTHCARE PRIVATE LIMITED",
"MERCURY HOSPITAL PRIVATE LIMITED",
"MERCURY INDUSTRIES LIMITED",
"MERCURY INSURANCE BROKERS PRIVATE LIMITED",
"MERCURY LABORATORIES LIMITED",
"MERCURY LAMPS PRIVATE LIMITED",
"MERCURY MANAGEMENT AND TECHNICAL SERVICES PRIVATE LIMITED",
"MERCURY MARINE INDUSTRIES PRIVATE LIMITED",
"MERCURY PHARMACHEM INDUSTRIES PVT LTD",
"MERCURY PNEUMATIC SYSTEMS PRIVATE LIMITED",
"MERCURY PNEUMATICS PRIVATE LIMITED",
"MERCURY PRECISION PRODUCTS PRIVATE LIMITED",
"MERCURY SECURITY SERVICES PRIVATE LIMITED",
"MERCURY TRAVELS LIMITED",
"MERCY MEMORIAL SCHOOL",
"MERDICA PRIVATE LIMITED",
"MERE AGRO PRIVATE LIMITED",
"MEREDDY MOTORS PRIVATE LIMITED",
"MEREDITH INDIA SERVICES PRIVATE LIMITED",
"MERF INSTITUTE OF SPEECH AND HEARING PRIVATE LIMITED",
"MERFANTZ RETAIL PRIVATE LIMITED",
"MERGANZER PHARMA PRIVATE LIMITED",
"MERGE SYSTEMS PRIVATE LIMITED",
"MERGEN CORPORATES PRIVATE LIMITED",
"MERGERMARKET INDIA PRIVATE LIMITED",
"MERHAKI FOODS AND NUTRITION PRIVATE LIMITED",
"MERI PUNJI IMF PRIVATE LIMITED",
"MERICA AGRO PRODUCTS PRIVATE LIMITED",
"MERICAN CONSULTANTS PRIVATE LIMITED",
"MERICANA PHARMACEUTICALS PRIVATE LIMITED",
"MERICO AGRO INDUSTRIES PRIVATE LIMITED",
"MERICO FILAMENT LIMITED",
"MERICO HOTELS & RESORTS PRIVATE LIMITED",
"MERICO TEA ESTATE LIMITED",
"MERIDEAN OVERSEAS EDUCATION CONSULTANTS PRIVATE LIMITED",
"MERIDIAN BUILDPRO PRIVATE LIMITED",
"MERIDIAN CARGO LINES PRIVATE LIMITED",
"MERIDIAN CHEMICALS PVT LTD",
"MERIDIAN CITY PROJECT PRIVATE LIMITED",
"MERIDIAN CLOTHING COMPANY PRIVATE LIMITED",
"MERIDIAN COMPU SERVICES PVT LTD",
"MERIDIAN CONSTRUCTION PRIVATE LIMITED",
"MERIDIAN EDUCATIONAL SOCIETY",
"MERIDIAN ENTERPRISES PRIVATE LIMITED",
"MERIDIAN FREIGHT FORWARDERS PRIVATE LIMITED",
"MERIDIAN GLOBAL SHIPPING AND LOGISTICS PRIVATE LIMITED",
"MERIDIAN GLOBAL VENTURES PRIVATE LIMITED",
"MERIDIAN INFOTECH LIMITED",
"MERIDIAN IT INDIA PRIVATE LIMITED",
"MERIDIAN MEDICAL RESEARCH AND HOSPITAL LIMITED",
"MERIDIAN MEDICARE LIMITED",
"MERIDIAN MOBILE PRIVATE LIMITED",
"MERIDIAN NURSING HOME AND HOSPITAL PRIVATE LIMITED",
"MERIDIAN PHARMACARE PRIVATE LIMITED",
"MERIDIAN POLYMERS PRIVATE LIMITED",
"MERIDIAN SCHOOL",
"MERIDIAN SEA AIR SERVICES PRIVATE LIMITED",
"MERIDIAN SECURITIES PVT LTD",
"MERIDIAN SOFT INFO SYSTEMS PRIVATE LIMITED",
"MERIDIAN SOLUTIONS PRIVATE LIMITED",
"MERIDIAN SQUADS PRIVATE LIMITED",
"MERIDIAN TRANZ SOLUTIONS PRIVATE LIMITED",
"MERIDIEN TRADEPLACE PRIVATE LIMITED",
"MERIDION OVERSEAS PRIVATE LIMITED",
"MERIDIUM SERVICES AND LABS PRIVATE LIMITED",
"MERIDIUM TECHNOLOGIES PRIVATE LIMITED",
"MERIDYN HEALTHCARE PRIVATE LIMITED",
"MERIEUX NUTRISCIENCES BANGALORE PRIVATE LIMITED",
"MERIEUX NUTRISCIENCES INDIA PRIVATE LIMITED",
"MERIL DIAGNOSTICS PRIVATE LIMITED",
"MERIL ENDO SURGERY PRIVATE LIMITED",
"MERIL HEALTHCARE PRIVATE LIMITED",
"MERIL LIFE SCIENCES INDIA PRIVATE LIMITED",
"MERIL LIFE SCIENCES PRIVATE LIMITED",
"MERILAND ESTATES PRIVATE LIMITED",
"MERIND AUTOMOTIVE PRIVATE LIMITED",
"MERIND LIMITED",
"MERINGUE HOTELS PRIVATE LIMITED",
"MERINO CONSULTING SERVICES LIMITED",
"MERINO INDUSTRIES LIMITED",
"MERINO PANEL PRODUCTS LIMITED",
"MERINO PROPERTIES PRIVATE LIMITED",
"MERINO SERVICES LIMITED",
"MERINO SHELTERS PRIVATE LIMITED",
"MERINT DEVELOPERS PRIVATE LIMITED",
"MERION CARE PRIVATE LIMITED",
"MERISIS ADVISORS PRIVATE LIMITED",
"MERIT ARMS INDIA PRIVATE LIMITED",
"MERIT BMH ENGINEERING PRIVATE LIMITED",
"MERIT CREDIT CORPORATION LIMITED",
"MERIT DATA AND TECHNOLOGY PRIVATE LIMITED",
"MERIT FIRE AND POWER PIPING SYSTEM PRIVATE LIMITED",
"MERIT HOSPITALITY SERVICES PRIVATE LIMITED",
"MERIT HOUSING SOLUTIONS INDIA PRIVATE LIMITED",
"MERIT MEDICAL SYSTEMS INDIA PRIVATE LIMITED",
"MERIT MEDICARE PRIVATE LIMITED",
"MERIT ORGANICS LIMITED",
"MERIT POLYCHEM PVT. LTD.",
"MERIT POLYMERS PRIVATE LIMITED",
"MERIT POLYTECHNIC COLLEGE",
"MERIT RETAIL PRIVATE LIMITED",
"MERIT SOFTWARE SERVICES PRIVATE LIMITED",
"MERIT TECHNOLOGIES (INDIA) LIMITED",
"MERITAS HOTELS PRIVATE LIMITED",
"MERITECH SOFTWARE PRIVATE LIMITED",
"MERITON INFOTECH PVT LTD",
"MERITOR COMMERCIAL VEHICLE SYSTEMS INDIA PRIVATE LIMITED",
"MERITOR CVS INDIA PRIVATE LIMITED",
"MERITOR PHARMACEUTICAL PRIVATE LIMITED",
"MERITORIOUS LEISURE PRIVATE LIMITED",
"MERITPLUS BPO PRIVATE LIMITED",
"MERITRA HOMES PRIVATE LIMITED",
"MERITS CAPITAL MARKET SERVICES PRIVATE LIMITED",
"MERITTRAC SERVICES PRIVATE LIMITED",
"MERITUS INTELYTICS PRIVATE LIMITED",
"MERIX LABORATORIES PRIVATE LIMITED",
"MERIYA PETROLEUM PRODUCTS PRIVATE LIMITED",
"MERKLE INSPIRE PRIVATE LIMITED",
"MERKUR GAMING INDIA PRIVATE LIMITED",
"MERLIN ACROPOLIS PROJECTS PRIVATE LIMITED",
"MERLIN AERONAUTICS MANUFACTURING PRIVATE LIMITED",
"MERLIN BRANDS PRIVATE LIMITED",
"MERLIN COMMERCIAL PRIVATE LIMITED",
"MERLIN COMMOSALES PRIVATE LIMITED",
"MERLIN CREATIONS PRIVATE LIMITED",
"MERLIN DENTIFRICES PRIVATE LIMITED",
"MERLIN ENCLAVES PVT LTD",
"MERLIN EXIM PVT LTD",
"MERLIN HOLDINGS PVT. LTD.",
"MERLIN LEISURES LIMITED",
"MERLIN MARKETING PVT LTD",
"MERLIN PHARMA PRIVATE LIMITED",
"MERLIN PROJECTS LIMITED",
"MERLIN RECREATION PRIVATE LIMITED",
"MERLIN RESORTS AND HOTELS PRIVATE LIMITED",
"MERLIN RESOURCES PVT LTD",
"MERLINHAWK AEROSPACE PRIVATE LIMITED",
"MERLION IMPEX PRIVATE LIMITED",
"MERLION SALES PRIVATE LIMITED",
"MERLION TOOLS PRIVATE LIMITED",
"MERLIZ LOGISTICS PRIVATE LIMITED",
"MERLLYONS KARGO PRIVATE LIMITED",
"MERLOAM REALTY PRIVATE LIMITED",
"MERLON INFRA PROJECTS PRIVATE LIMITED",
"MERLYN HYDROCARBONS PRIVATE LIMITED",
"MERLYN MIND INDIA PRIVATE LIMITED",
"MERMAID TECHNOLOGIES PRIVATE",
"MERO ASIA PACIFIC ENGINEERING PRIVATE LIMITED",
"MERO ASIA PACIFIC P LIMITED",
"MEROFORM INDIA PRIVATE LIMITED",
"MERON SCIENTIFIC PRIVATE LIMITED",
"MEROO TEXTILE INDUSTRIES PRIVATE LIMITED",
"MEROXIO IT SOLUTIONS PRIVATE LIMITED",
"MERRELL ROAD SOLUTIONS PRIVATE LIMITED",
"MERRIANT FASHIONTECH PRIVATE LIMITED",
"MERRICK INDUSTRIES PRIVATE LIMITED",
"MERRICTRO PRODUCTS PRIVATE LIMITED",
"MERRIDIAN FABRICS & ACCESSORIES PRIVATE LIMITED",
"MERRIL PHARMA PRIVATE LIMITED",
"MERRITO POLYMERS (INDIA) PRIVATE LIMITED",
"MERRITRONIX PRIVATE LIMITED",
"MERRITRONIX PVT LTD.",
"MERRITT INNOVATIVE SOLUTIONS INDIA PRIVATE LIMITED",
"MERRITT LOGISTICS PRIVATE LIMITED",
"MERRY ANGELS ENGLISH MEDIUM SCHOOL AKHADE",
"MERRY IMPEX PRIVATE LIMITED",
"MERRY TIME CREAM FOODS PRIVATE LIMITED",
"MERRYGO TRAVELS PRIVATE LIMITED",
"MERRYGOLD AGROPROCESS PRIVATE LIMITED",
"MERRYGOLD ASIAYANA CONSTRUCTIONS PRIVATE LIMITED",
"MERSACO CHEMICALS PRIVATE LIMITED",
"MERSEL FOODS PRIVATE LIMITED",
"MERSEN INDIA PRIVATE LIMITED",
"MERTON EXPORTS AND IMPORTS PRIVATE LIMITED",
"MERTZ ESTATES LIMITED",
"MERU AUTOMOBILES PRIVATE LIMITED",
"MERU CHEM PRIVATE LIMITED",
"MERU DIAMONDS (INDIA) PRIVATE LIMITED",
"MERU INDUSTRIES",
"MERU INFRASTRUCTURE PRIVATE LIMITED",
"MERU INTERNATIONAL SCHOOL",
"MERU MOBILITY TECH PRIVATE LIMITED¬†",
"MERULANDS INSURANCE SERVICES PRIVATE LIMITED",
"MERUPAM TRADELINK PRIVATE LIMITED",
"MERWANJEE SECURITIES LIMITED",
"MERWANS CONFECTIONERS PRIVATE LIMITED",
"MERX HEALTHCARE COMMUNICATIONS PRIVATE LIMITED",
"MERYFUR TRADELINKS PRIVATE LIMITED",
"MERYKH TECHNOLOGIES PRIVATE LIMITED",
"MERZ BIOCEUTICALS PRIVATE LIMITED",
"MES COLLEGE BANGALORE",
"MES COLLEGE OF ARTS SCIENCE AND COMMERC",
"MES COLLEGE OF ENGINEERING KUTTIPPURAM",
"MES SOU VIMALABAI GARWARE HIGHSCHOOL",
"MESANARULA INFRA PROJECTS PRIVATE LIMITED",
"MESBOR PRIVATE LIMITED",
"MESCAB INDIA PRIVATE LIMITED",
"MESCO CRESCENT ENGLISH HIGH SCHOOL",
"MESDAN INDIA PRIVATE LIMITED",
"MESE FASHIONS PRIVATE LIMITED",
"MESH STOCK BROKERS PRIVATE LIMITED",
"MESHA ENGINEERING INDUSTRY PRIVATE LIMITED",
"MESHA PHARMA PRIVATE LIMITED",
"MESHAYU CONSULTANTS PRIVATE LIMITED",
"MESIK HEALTHCARE PRIVATE LIMITED",
"MESINDUS VENTURES LIMITED",
"MESLOVA SYSTEMS PRIVATE LIMITED",
"MESMER PHARMACEUTICALS",
"MESMOR STUDIO PRIVATE LIMITED",
"MESO CARBON INDIA PRIVATE LIMITED",
"MESO PRIVATE LIMITED",
"MESON VALVES INDIA LIMITED",
"MESON VALVES INDIA PRIVATE LIMITED",
"MESPACK INDIA PRIVATE LIMITED",
"MESPC INFRA PROJECTS PRIVATE LIMITED",
"MESSAGE CORPORATE PRIVATE LIMITED",
"MESSE DUESSELDORF INDIA PRIVATE LIMITED",
"MESSE FRANKFURT TRADE FAIRS INDIA PRIVATE LIMITED",
"MESSE MUENCHEN INDIA PRIVATE LIMITED",
"MESSER CUTTING SYSTEMS INDIA PRIVATE LIMITED",
"MESSIANIC CLOTHING PRIVATE LIMITED",
"MESSINA BEEJ PRIVATE LIMITED",
"MESSRS DSK LEGAL",
"MESSUNG SYSTEMS PRIVATE LIMITED",
"MESTECH SERVICES PRIVATE LIMITED",
"MESTON INSTITUTE OF EDUCATION",
"MESTRA PHARMA PRIVATE LIMITED",
"MESTRU TRADING PRIVATE LIMITED",
"MESUKA TECH PRIVATE LIMITED",
"MESURA NIRMAL GAS CONTROLS PRIVATE LIMITED",
"MET BHUJBAL KNOWLEDGE CITY",
"MET HEAT ENGINEERS PRIVATE LIMITED",
"MET INDIA ALLOYS PRIVATE LIMITED",
"MET ROLLA IRON AND STRIPS COMPANY LIMITED",
"MET ROLLA STEELS PRIVATE LIMITED",
"MET TECHNOLOGIES PRIVATE LIMITED",
"META ARCH PRIVATE LIMITED",
"META BUSINESS SOLUTIONS PRIVATE LIMITED",
"META CORE INDIA PRIVATE LIMITED",
"META FORCE PRIVATE LIMITED",
"META INDUSTRIES.",
"META INFOTECH PRIVATE LIMITED",
"META OPTION SOFTWARE PRIVATE LIMITED",
"META SOFT TECH SYSTEMS PRIVATE LIMITED",
"META TUBEX PVT LTD",
"METABOLISTICS LABORATORIES PRIVATE LIMITED",
"METACHEM MANUFACTURING COMPANY PRIVATE LIMITED",
"META-CHEM PAINTS AND ADHESIVES PRIVATE LIMITED",
"METACUBE BUSINESS VENTURES PRIVATE LIMITED",
"METACUBE SOFTWARE PRIVATE LIMITED",
"METACUBE SOLUTIONS PRIVATE LIMITED",
"METADESIGN INDIA PRIVATE LIMITED",
"METADESIGN SOLUTIONS PRIVATE. LIMITED.",
"METADESIGNS CONSULTANTS PRIVATE LIMITED",
"METADIMENSIONS IT SOLUTIONS PRIVATE LIMITED",
"METADIZ ENGINEERING (INDIA) PRIVATE LIMITED",
"METAFAB INDUSTRIES PRIVATE LIMITED",
"METAFERRO TRADING PRIVATE LIMITED",
"METAFIC",
"METAFIN CLEANTECH FINANCE PRIVATE LIMITED",
"METAFLEX DOORS INDIA PRIVATE LIMITED",
"METAFLUX COMPANY PVT. LTD.",
"METAFOLD ENGINEERING PRIVATE LIMITED",
"METAFORGE ENGINEERING INDIA PRIVATE LIMITED",
"METAFRIQUE TRADING PRIVATE LIMITED",
"METAGE DESIGNING SOLUTIONS (OPC) PRIVATE LIMITED",
"METAGRREL TUBES PRIVATE LIMITED",
"METAHELIX LIFE SCIENCES LIMITED",
"META-I TECHNOLOGIES PRIVATE LIMITED",
"MET-AIR TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"METAJEWEL KRAFTS (INDIA) PRIVATE LIMITED",
"METAL & PLASTIC PRIVATE LIMITED",
"METAL & SCRAP TRADERS PRIVATE LIMITED",
"METAL AIDS COATINGS LIMITED",
"METAL ALLOYS CORPORATION",
"METAL AND STEEL FACTORY ISHAPORE",
"METAL ARTS CREATION PRIVATE LIMITED",
"METAL CANS AND CLOSURES PRIVATE LIMITED",
"METAL CAP INDUSTRIES PRIVATE LIMITED",
"METAL CARE ALLOYS LIMITED",
"METAL COATINGS INDIA LIMITED",
"METAL COMMUNICATIONS PRIVATE LIMITED",
"METAL CRAFT ENGINEERING PRIVATE LIMITED",
"METAL CRAFT INDUSTRIES PRIVATE LIMITED",
"METAL CRAFTS CONSTRUCTORS PRIVATE LIMITED",
"METAL DYNE AUTO PARTS PRIVATE LIMITED",
"METAL ENGINEERING & TREATMENT COMPANY PRIVATE LIMITED",
"METAL FACADE SYSTEMS PRIVATE LIMITED",
"METAL FITTINGS PVT LTD",
"METAL FLOW LUBRICANTS & SOLUTIONS PRIVATE LIMITED",
"METAL FORGINGS PVT LTD",
"METAL FORMS PRIVATE LIMITED",
"METAL IMPACTS PRIVATE LIMITED",
"METAL IMPREGNATIONS INDIA PRIVATE LIMITED",
"METAL INDIA PRODUCTS PRIVATE LIMITED",
"METAL ONE CORPORATION INDIA PRIVATE LIMITED",
"METAL ORE",
"METAL PLANTS (INDIA) PRIVATE LIMITED",
"METAL POWER ANALYTICAL INDIA PRIVATE LIMITED",
"METAL S & METAL ELECTRIC PRIVATE LIMITED",
"METAL SCOPE INDIA PRIVATE LIMITED",
"METAL SEAM COMPANY PRIVATE LIMITED",
"METAL SHINE INDUSTRIES PRIVATE LIMITED",
"METAL STORAGE SYSTEMS PRIVATE LIMITED",
"METAL TECH PAINTS & CHEMICALS PRIVATE LIMITED",
"METAL TECH PRIVATE LIMITED",
"METAL TRADERS INDIA PRIVATE. LIMITED.",
"METAL WORK PNEUMATIC INDIA PRIVATE LIMITED",
"METALABS SERVICES LLP",
"METALACE PRIVATE LIMITED",
"METALARCH PORTA CABINS PRIVATE LIMITED",
"METALASTIK MANUFACTURING CO PRIVATE LIMITED",
"METALCAST AND ALLOYS PRIVATE LIMITED",
"METALCLOTH PRODUCTS PRIVATE LIMITED",
"METALDRAFTING ENGINEERING SERVICES PRIVATE LIMITED",
"METALET INTERNATIONAL PRIVATE LIMITED",
"METALEX COMMODITIES PRIVATE LIMITED",
"METALEX CRYOGENICS LIMITED",
"METALEX STEEL STRIPS PRIVATE LIMITED",
"METALFAB HIGHTECH PRIVATE LIMITED",
"METALFAB HIGHTECH PRIVATE. LIMITED.",
"METALGUARD PRIVATE LIMITED",
"METALHOME PRIVATE LIMITED",
"METALIC IMPRESSIONS INDIA PRIVATE LIMITED",
"METALIC TECHNOFORGE PRIVATE LIMITED",
"METALICA FURNITURE PRIVATE LIMITED",
"METALIK FUEL PRIVATE LIMITED",
"METALINK METALS PRIVATE LIMITED",
"METALIS INDIA PRIVATE. LIMITED",
"METALIS LIFESCIENCES PRIVATE LIMITED",
"METALITE FOOD PROCESSING PRIVATE LIMITED",
"METALITE INDIA PRIVATE LIMITED",
"METALKARMA ENGINEERING TECHNOLOGIES PRIVATE LIMITED",
"METALKING VENTURES PRIVATE LIMITED",
"METALKRAFT ENGINEERING PRIVATE LIMITED",
"METALKRAFT FORMING INDUSTRIES PRIVATE LIMITED",
"METALKRAFT WINDOW ACCESSORIES PRIVATE LIMITED",
"METALL STRUCTURES PRIVATE LIMITED",
"METALLIC BELLOWS INDIA PRIVATE LIMITED",
"METALLICA TUBEMILL PRIVATE LIMITED",
"METALLICS MINECHEM PRIVATE LIMITED",
"METALLICZ ENTERTAINMENT PRIVATE LIMITED",
"METALLICZ MEDIA PRIVATE LIMITED",
"METALLIDE CHEMICAL INDUSTRIES INDIA PRIVATE LIMITED",
"METALLION TRADESWIFT PRIVATE LIMITED",
"METALLIZING EQUIPMENT COMPANY PRIVATE LIMITED",
"METALLO & ENGINEERING EQUIPMENTS PRIVATE LIMITED",
"METALLOYS RECYCLING LIMITED",
"METALLURGICAL ENGINEERING AND EQUIPMENTS LIMITED",
"METALLURGICAL ENGINEERING AND EQUIPMENTS PRIVATE LIMITED",
"METALLURGICAL PRODUCTS INDIA PRIVATE LIMITED",
"METALLURGICAL SERVICES PRIVATE LIMITED",
"METALMAN AUTO PRIVATE LIMITED",
"METALMAN MICRO TURNERS",
"METALMAN MICROTUNERS",
"METALMECCANICA FRACASSO INDIA PRIVATE LIMITED",
"METALO PRODUCTS PVT LTD",
"METALOCK MACO ENGINEERING INDIA PRIVATE LIMITED",
"METALOFT INDUSTRIES PRIVATE LIMITED",
"METALOMED INDIA PRIVATE LIMITED",
"METALS UNITED ALLOYS AND FUSION PRODUCTS LIMITED",
"METALSA INDIA PRIVATE LIMITED",
"METALSALES MANUFACTURING COMPANY PRIVATE LIMITED",
"METALSCRAP RECYCLING MUMBAI PRIVATE LIMITED",
"METALSHAPE INDUSTRIES PRIVATE LIMITED",
"METALSMITH INDIA PRIVATE LIMITED",
"METALTEC PRODUCTS PRIVATE LIMITED",
"METALTECH CNC PRIVATE LIMITED",
"METALTECH DESIGN PRIVATE LIMITED",
"METALTECH DESIGN PRIVATE LIMITED.",
"METALTECH MOTORBODIES PRIVATE LIMITED",
"METALTECH MOTORS PRIVATE LIMITED",
"METALTRIM ELECTRIC INDIA PRIVATE LIMITED",
"METALUBE PRIVATE LIMITED",
"METALWORK INDUSTRIES LIMITED",
"METAMATIX SOLUTIONS PRIVATE LIMITED",
"METAMECH ENGINEERS PRIVATE LIMITED",
"METAMECH INDUSTRIES PRIVATE LIMITED",
"METAMINDS SOFTWARE SOLUTIONS LIMITED",
"METAMINDS TECHNOLOGIES PRIVATE LIMITED",
"METAMORF INTERIORS & DESIGNERS PRIVATE LIMITED",
"METAMORPH IT SYSTEMS PRIVATE LIMITED",
"METAMORPHICK SOLUTIONS PRIVATE LIMITED",
"METAMORPHOSIS ENGITECH INDIA PRIVATE LIMITED",
"METAMORPHOSYS TECHNOLOGIES PRIVATE LIMITED",
"METAMOULD PRIVATE LIMITED",
"METANOIA SOFTWARE SOLUTIONS PRIVATE LIMITED",
"METAOPTION SOFTWARE PRIVATE LIMITED",
"METAPHOR INFRASTRUCTURE PRIVATE LIMITED",
"METAPLORE SOLUTIONS PRIVATE LIMITED",
"METAPOINT TECHNOLOGIES PRIVATE LIMITED",
"METAPOW ENGINEERS PRIVATE LIMITED",
"METAPURE SUPPLEMENT PRIVATE LIMITED",
"METAROCK JEWELS PRIVATE LIMITED",
"METAROCK PRIVATE LIMITED",
"METAROLLS ISPAT PRIVATE LIMITED",
"METARVRSE IMMERSIVE TECHNOLOGIES PRIVATELIMITED",
"METAS ADVENTIST COLLEGE OF MANAGEMENT",
"METAS ADVENTIST HOSPITAL",
"METAS ADVENTIST SCHOOL",
"METAS SECURITY AND FIRE SERVICES PRIVATE LIMITED",
"METASIS EQUIPMENTS PRIVATE LIMITED",
"METASKIL PRIVATE LIMITED",
"METASOFT SOLUTIONS PRIVATE LIMITED",
"METASPONGE PRIVATE LIMITED",
"METASTAR INFRA PRIVATE LIMITED",
"METASTEEL PREFAB PRIVATE LIMITED",
"METASTRIP ENTERPRISE PRIVATE LIMITED",
"METASTRUCT INFRATECH INDIA PRIVATE LIMITED",
"METASWAR INDUSTRIES PRIVATE LIMITED",
"METASYS SOFTWARE PRIVATE LIMITED",
"METASYSTEMS INDIA (BANGALORE) PRIVATE LIMITED",
"METATECH AIRSYSTEMS INDIA PRIVATE LIMITED",
"METATECH CCR PRIVATE LIMITED",
"METATECH MEDICAL PRIVATE LIMITED",
"METATECH THERMAL SPRAY PRIVATE LIMITED",
"METATHERM FURNACE PRIVATE LIMITED",
"METAVAL ENGINEERING PRIVATE LIMITED",
"METAWALA PLASTIC PRIVATE LIMITED",
"METAWARES (INDIA) PRIVATE LIMITED",
"METAWING TECHNOLOGIES PRIVATE LIMITED",
"METAWOOD DISPLAY SYSTEMS",
"METBRASS PLASSIM INDIA PRIVATE LIMITED",
"METBUILD INFRA PRIVATE LIMITED",
"METCALFE & HODGKINSON INSURANCE SURVEYORS AND LOSS ASSESSORS PRIVATE LIMITED",
"METCAN PACKS PRIVATE LIMITED",
"METCAP TUBES PRIVATE LIMITED",
"METCO ENTERPRISES PRIVATE LIMITED",
"METCO MARKETING INDIA PRIVATE LIMITED",
"METCO ROOF PRIVATE LIMITED",
"METCO SPORTS INFRA PRIVATE LIMITED",
"METCO SPORTS PRIVATE LIMITED",
"METCON BUILDTECH PRIVATE LIMITED",
"METCON COATINGS AND CHEMICALS INDIA PRIVATE LIMITED",
"METCON INDIA REALTY AND INFRASTRUCTURE PRIVATE LIMITED",
"METCON WATER SYSTEMS PRIVATE LIMITED",
"METCOP GYPSUM INDIA PRIVATE LIMITED",
"METCRAFT ENGINEERING",
"METCROSSCHEM GLOBAL PRIVATE LIMITED",
"METCUT TOOLINGS PRIVATE LIMITED.",
"METEC CONSTRUCTION TECHNOLOGY PRIVATE LIMITED",
"METEC DESIGN AND CONSTRUCTION ENGINEERS INDIA PRIVATE LIMITED",
"METEC ELECTRONICS PRIVATE LIMITED",
"METECNO INDIA PRIVATE LIMITED",
"METEL MELT ENGNEERING CO",
"METEONIC INNOVATION PRIVATE LIMITED",
"METEOR FILMS PRIVATE LIMITED",
"METEOR PRIVATE LIMITED",
"METEORIC BIOPHARMACEUTICALS PRIVATE LIMITED",
"METEORIC LOGISTICS PRIVATE LIMITED",
"METEOXPERTS SOLUTIONS PRIVATE LIMITED",
"METEROLOGY DATA PRIVATE LIMITED",
"METERS AND INSTRUMENT PVT LTD",
"METESH KESHAV GLOBAL PRIVATE LIMITED",
"METEX GLOBAL GIFTS INDIA PRIVATE LIMITED",
"METEXIM SOURCING PRIVATE LIMITED",
"METFAB VENTURES PRIVATE LIMITED",
"METFARB PROJECTS PRIVATE LIMITED",
"METFLOW CAST PRIVATE LIMITED",
"METGLOBE SERVICES PRIVATE LIMITED",
"METGUD HOSPITAL",
"METHIBAI DEVRAJ GUNDECHA FOUNDATIONS",
"METHOD AND MADNESS TECHNOLOGY PRIVATE LIMITED",
"METHODE ELECTRONICS INDIA PRIVATE LIMITED",
"METHODEX SYSTEMS PRIVATE LIMITED",
"METHODHUB SOFTWARE PRIVATE LIMITED",
"METHODIST CHURCH OF INDIA",
"METHODIST EDUCATION INSTITUTION CHURCH C",
"METHODIST GIRLS SCHOOL",
"METHODIST HIGH SCHOOL",
"METHODIST SCHOOL",
"METHODS (INDIA) PRIVATE LIMITED",
"METHODS APPAREL CONSULTANCY INDIA PRIVATE LIMITED",
"METHODS AUTOMOTIVE PRIVATE LIMITED",
"METHRA INDUSTRIES INDIA PRIVATE LIMITED",
"METI M2M INDIA PRIVATE LIMITED",
"METIARY KARUNAMOYEE FP SCHOOL",
"METICULOUS MARKET RESEARCH PRIVATE LIMITED",
"METICULOUS PHARMACETICALS PRIVATE LIMITED",
"METIER ADVISORY SERVICES PRIVATE LIMITED",
"METIER LIFESTYLE PRODUCTS PRIVATE LIMITED",
"METIETA ADVERTISING PRIVATE LIMITED",
"METINA PHARMCONSULTING PRIVATE LIMITED",
"METIS FAMILY OFFICE SERVICES PRIVATE LIMITED",
"METIS LEARNING SOLUTIONS PRIVATE LIMITED",
"METIS MARKETING SERVICES PRIVATE LIMITED",
"METISTECH FABRICATORS PRIVATE LIMITED",
"METITO POLLUTION CONTROL INDIA PRIVATE LIMITED",
"METIZSOFT SOLUTIONS PRIVATE LIMITED",
"METLAX INTERNATIONAL PRIVATE LIMITED",
"METLIFE GLOBAL OPERATIONS SUPPORT CENTER PRIVATE LIMITED",
"METLIN CONTAINERS PRIVATE LIMITED",
"METLIN PROJECTS PRIVATE LIMITED",
"METLLOY TRADING SERVICES PRIVATE LIMITED",
"METLOK PRECOAT SERVICES PRIVATE LIMITED",
"METLOK PRIVATE LIMITED",
"METLONICS INDUSTRIES PRIVATE LIMITED",
"METLORD ALLOYS PRIVATE LIMITED",
"METMILL FOOTWEAR PRIVATE LIMITED",
"METMIN COMMTRADE PRIVATE LIMITED",
"METMIN FINANCE AND HOLDINGS PRIVATE LIMITED",
"METMIN INVESTMENT AND TRADING PRIVATE LIMITED",
"METMOX SOFTWARE SOLUTIONS INDIA PRIVATE LIMITED",
"METOMATIC INDUSTRIES PRIVATE LIMITED",
"METONE ELECTRONICS PRIVATE LIMITED",
"METORES ISPAT PRIVATE LIMITED",
"METOWELD ELECTRO (INDIA) PRIVATE LIMITED",
"METOXO ECO PRIVATE LIMITED",
"METPINCS ENGINEERING & CONTRACTS PRIVATE LIMITED",
"METPRO INDUSTRIES (INDIA) PRIVATE LIMITED",
"METPROTECT TECHNOLOGIES PRIVATE LIMITED",
"METRAVI INSTRUMENTS PRIVATE LIMITED",
"METRE INFRATECH PRIVATE LIMITED",
"METREC RECYCLING PRIVATE LIMITED",
"METRECON INDUSTRIES PRIVATE LIMITED",
"METRENDS LEATHERS PRIVATE LIMITED",
"METREX SCIENTIFIC INSTRUMENTS PRIVATE LIMITED",
"METRI SPIRITS PRIVATE LIMITED",
"METRIC CONSULTANCY LIMITED",
"METRIC INFRASTRUCTURE PRIVATE LIMITED",
"METRIC OFFICER CONTROLLER WEIGHT MEASURE BHOPAL MADHYA PRADESH",
"METRICBEES PRIVATE LIMITED",
"METRICS4 ANALYTICS PRIVATE LIMITED",
"METRICSTREAM INFOTECH (INDIA) PRIVATE LIMITED",
"METRICWAYS ROTOGRAVURE PRINTERS PRIVATE LIMITED",
"METRIKA MODULER SOLUTIONS PRIVATE LIMITED",
"METRIKS GLOBAL SCHOOL",
"METRIKUS SOFTWARE INDIA PRIVATE LIMITED",
"METRIQE SOLUTIONS PRIVATE LIMITED",
"METRIT CHEMICALS PRIVATE LIMITED",
"METRITE LUBES & SPECIALITIES PRIVATE LIMITED",
"METRIX AUTOCOMP PRIVATE LIMITED",
"METRIX AUTOMATIONS INDIA PRIVATE LIMITED",
"METRIXIT SOLUTIONS PRIVATE LIMITED",
"METRIXLAB INDIA RESEARCH SOLUTIONS LLP",
"METRIXLAB RESEARCH INDIA LLP",
"METRO & METRO",
"METRO ARTS PRIVATE LIMITED",
"METRO BIOSOL PRIVATE LIMITED",
"METRO BOOKS PRIVATE LIMITED",
"METRO BRANDS LIMITED",
"METRO BRIGHT BAR (INDIA) PRIVATE LIMITED",
"METRO BUILDERS ORISSA PRIVATE LIMITED",
"METRO BUILDTECH PRIVATE LIMITED",
"METRO CARD AND PRINTS PRIVATE LIMITED",
"METRO CASH AND CARRY INDIA PRIVATE LIMITED",
"METRO CAST NETWORK INDIA PRIVATE LIMITED",
"METRO CHEF PRIVATE LIMITED",
"METRO CITY TILES PRIVATE LIMITED",
"METRO CITY VANIJYA PVT LTD",
"METRO COLOUR INDUSTRIES PRIVATE LIMITED",
"METRO COOL JOINT SERVICES PRIVATE LIMITED",
"METRO DAIRY LIMITED",
"METRO DECORATIVE PRIVATE LIMITED",
"METRO DIGITAL NETWORKS (HYDERABAD) PRIVATE LIMITED",
"METRO DWELLERS PRIVATE LIMITED",
"METRO ECO GREEN RESORTS LIMITED",
"METRO EXPORTERS PRIVATE LIMITED",
"METRO FACILITY MANAGEMENT PRIVATE LIMITED",
"METRO FEEDS PRIVATE LIMITED",
"METRO FOODS PVT LTD",
"METRO FROZEN FOLKKS FOODS PRIVATE LIMITED",
"METRO FURNITURE PRIVATE LIMITED",
"METRO GARDEN ESTATE PRIVATE LIMITED",
"METRO GASKETS PRIVATE LIMITED",
"METRO GIFTS PVT LTD",
"METRO GLOBAL SOLUTION CENTER PRIVATE LIMITED",
"METRO GROUP PTE LTD",
"METRO HARD COKE INDUSTRIES PRIVATE LIMITED",
"METRO HEART INSTITUTE WITH MULTISPECIALTY",
"METRO HOLDINGS AND SECURITIES PRIVATE LIMITED",
"METRO HOSPITAL AND CANCER RESEARCH CENTRE",
"METRO HOTEL AND KHAZIR TRAVELS PRIVATE LIMITED",
"METRO HYPERPOINT PRIVATE LIMITED",
"METRO INDIA LIMITED",
"METRO INFOSOLUTIONS PRIVATE LIMITED",
"METRO INFRASTRUCTURE DEVELOPMENT LIMITED",
"METRO INFRASYS PRIVATE LIMITED",
"METRO INSTITUTES OF MEDICAL SCIENCES PRIVATE LIMITED",
"METRO INVESTMENTS PRIVATE LIMITED",
"METRO IRRIGATION PRIVATE LIMITED",
"METRO ISPAT PRIVATE LIMITED",
"METRO LIFE HEALTHCARE PRIVATE LIMITED",
"METRO LIFESTYLES INDIA PRIVATE LIMITED",
"METRO LUBES PRIVATE LIMITED",
"METRO MALTBRU PRIVATE LIMITED",
"METRO MARBLES PVT. LTD.",
"METRO MAS HOSPITAL PRIVATE LIMITED",
"METRO MATERIAL HANDLING EQUIPMENTS PRIVATE LIMITED",
"METRO MEDICAL SERVICES LIMITED",
"METRO MERCANTILE PRIVATE LIMITED",
"METRO METALIKS LIMITED",
"METRO MILK PRODUCTS LIMITED",
"METRO MOBILES PRIVATE LIMITED",
"METRO MOBILINK PRIVATE LIMITED",
"METRO MONEYCHANGER PRIVATE LIMITED",
"METRO MOTORS PRIVATE LIMITED",
"METRO MULTISPECIALITY HOSPITALS PRIVATE LIMITED",
"METRO NETCOM SERVICES PRIVATE LIMITED",
"METRO ORTEM LIMITED",
"METRO PHARMACEUTICALS PRIVATE LIMITED",
"METRO PLYWOOD PRIVATE LIMITED",
"METRO POLYFILMS PRIVATE LIMITED",
"METRO POLYMERS PRIVATE LIMITED",
"METRO POLYPACK LLP",
"METRO PRADHAN INFRASOLUTIONS PRIVATE LIMITED",
"METRO PRINTS PRIVATE LIMITED",
"METRO PROFESSIONAL SERVICES PRIVATE LIMITED",
"METRO PROMOTERS PRIVATE LIMITED",
"METRO RAIL KOLKATA",
"METRO RAILWAY KOLKATA",
"METRO RETAIL PRIVATE.LIMITED",
"METRO RMC SUPPLIES PRIVATE LIMITED",
"METRO SAFETY INDIA PRIVATE LIMITED",
"METRO SERVISOL PRIVATE LIMITED",
"METRO SKY CONSTRUCTION PRIVATE LIMITED",
"METRO SOLUTIONS PRIVATE LIMITED",
"METRO SPARE PART (INDIA) PRIVATE LIMITED",
"METRO SPECIALITY HOSPITALS PRIVATE LIMITED",
"METRO STONE CRUSHER PRIVATE LIMITED",
"METRO SULZ PVT. LTD",
"METRO SWIFT PRIVATE LIMITED (OPC)",
"METRO TELECOM AND BROADBAND PRIVATE LIMITED",
"METRO TELELINK SERVICES PRIVATE LIMITED",
"METRO TELWORKS PRIVATE LIMITED",
"METRO TRANSIT PRIVATE LIMITED",
"METRO TUNNELING CHENNAI",
"METRO TYRES LIMITED",
"METROAD AND PRINT PACK PRIVATE LIMITED",
"METROARK PRIVATE LIMITED",
"METROBIT NETWORKS PRIVATE LIMITED",
"METROBUILD PROJECTS PRIVATE LIMITED",
"METROCHEM API PRIVATE LIMITED",
"METROCITY FINANCE PRIVATE LIMITED",
"METROCITY LANDMARKS PRIVATE LIMITED",
"METRODECOR PRIVATE LIMITED",
"METROFLEX INDUSTRIES LIMITED",
"METROGLOBAL LIMITED",
"METROHM INDIA PRIVATE LIMITED",
"METROID ENGINEERS PRIVATE LIMITED",
"METROLAB AUTOMATION PRIVATE LIMITED",
"METROLAB ENGINEERING PRIVATE LIMITED",
"METROLABS SERVICES PRIVATE LIMITED",
"METROLINE PROMOTERS PRIVATE LIMITED",
"METROLINE TOWNSHIPS PRIVATE LIMITED",
"METROLINK OUTSOURCING SERVICES PRIVATE LIMITED",
"METROLITE HEAVY INDUSTRIES PRIVATE LIMITED",
"METROLITE ROOFING PRIVATE LIMITED",
"METROMED INTERNATIONAL CARDIAC CENTRE PRIVATE LIMITED",
"METRONATION CHENNAI TELEVISION PRIVATE LIMITED",
"METRONIC ENGINEERING PRIVATE LIMITED",
"METRONLABS SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"METROOF STRUCTURES PRIVATE LIMITED",
"METROPOL INDIA PRIVATE LIMITED",
"METROPOLE TILES PRIVATE LIMITED",
"METROPOLE VINIMAY PRIVATE LIMITED",
"METROPOLI FASHIONS PVT LTD",
"METROPOLIS HEALTHCARE LIMITED",
"METROPOLIS LOGISTICS PRIVATE LIMITED",
"METROPOLIS MEDIA PRIVATE LIMITED",
"METROPOLIS PROPERTIES PRIVATE LIMITED",
"METROPOLITAN BUILDMART PRIVATE LIMITED",
"METROPOLITAN CLEARING CORPORATION OF INDIA LIMITED",
"METROPOLITAN EQUIPMENTS AND CONSULTANTS",
"METROPOLITAN EXIMCHEM PRIVATE LIMITED",
"METROPOLITAN INFRABUILD DEVELOPMENT AND SERVICES PRIVATE LIMITED",
"METROPOLITAN INSTITUTION MAIN",
"METROPOLITAN LIFESPACE REAL ESTATE DEVELOPERS PRIVATE LIMITED",
"METROPOLITAN LOGISTICS PRIVATE LIMITED",
"METROPOLITAN MEDIA COMPANY LIMITED",
"METROPOLITAN STOCK EXCHANGE OF INDIA LIMITED",
"METROPOLITAN TRANSPORT CORPORATION CHENNAI LIMITED",
"METROROADWAYS PRIVATE LIMITED",
"METROSHINE SECURITY FORCE PRIVATE LIMITED",
"METROUNITED HEALTHCARE",
"METROVISION HOSPITAL PRIVATE LIMITED",
"METROWORLD TILES PRIVATE LIMITED",
"METROZ DETECTIVES SERVICES PRIVATE LIMITED",
"METRRO WASTE HANDLING PRIVATE LIMITED",
"METSAR TECHNOLOGIES PRIVATE LIMITED",
"METSIL EXPORTS PVT. LTD.",
"METSMITH INNOVATIONS PRIVATE LIMITED",
"METSMITH TECHNO PRIVATE LIMITED",
"METSO OUTOTEC INDIA PRIVATE LIMITED",
"METSONS INDUSTRIES PRIVATE LIMITED",
"METSTAR INDUSTRIES PRIVATE LIMITED",
"METSTON TECHNOLOGIES PRIVATE LIMITED",
"METSURFIN PRIVATE LIMITED",
"METTA LIFE SCIENCES PRIVATE LIMITED",
"METTANOX INFRATECK PRIVATE LIMITED",
"METTA'S PHARMACEUTICALS PRIVATE LIMITED",
"METTLE NETWORKS PRIVATE LIMITED",
"METTLE POLYMERS AND ARTIFACTS LIMITED",
"METTLER TOLEDO INDIA PRIVATE LIMITED",
"METTLESOME SHIPPING & LOGISTIC SERVICES PRIVATE LIMITED",
"METTO SUPER MARKET PRIVATE LIMITED",
"METTUPAKKAM FOUNDATIONS PRIVATE LIMITED",
"METTUR S.P.R. BLUE METAL & CONSTRUCTION PRIVATE LIMITED",
"METTWA ELECTRICALS & APPLIANCES P LIMITED",
"METYIS INDIA PRIVATE LIMITED",
"METZER OPTICAL INSTRUMENT PRIVATE LIMITED",
"MEUSBURGER INDIA PRIVATE LIMITED",
"MEV INFRA POWER PROJECTS PRIVATE LIMITED",
"MEVA FORM WORK SYSTEMS PRIVATE LIMITED",
"MEVADA ENGINEERING WORKS PRIVATE LIMITED",
"MEVIR SOLUTIONS PRIVATE LIMITED",
"MEVISH PHARMA MACHINERIES (INDIA) PRIVATE LIMITED",
"MEVU E-COMMERCE PRIVATE LIMITED",
"MEW ELECTRICALS LIMITED",
"MEWA MISHRI ENTERPRISES PRIVATE LIMITED",
"MEWAD POLYMERS PRIVATE LIMITED",
"MEWAR CHEM-TECH PRIVATE LIMITED",
"MEWAR DIGITAL SOLUTIONS PRIVATE LIMITED",
"MEWAR EDUCATION PRIVATE LIMITED",
"MEWAR FOODS PVT.LTD.",
"MEWAR FURNITURE PRIVATE LIMITED",
"MEWAR HI TECH ENGINEERING LIMITED",
"MEWAR HI-TECH ENGINEERING LIMITED",
"MEWAR HOSPITAL PRIVATE LIMITED",
"MEWAR MICRONS PRIVATE LIMITED",
"MEWAR POLYTEX LIMITED",
"MEWARA MACADAM PRIVATE LIMITED",
"MEWARA SALES INDIA PRIVATE LIMITED",
"MEWAT TRANSPORT PRIVATE LIMITED",
"MEWS HIGHER SECONDARY SCHOOL",
"MEX EXHIBITIONS PRIVATE LIMITED",
"MEX STORAGE SYSTEMS PRIVATE LIMITED",
"MEXATO PHARMACEUTICALS PRIVATE LIMITED",
"MEXCEL ENGINEERING INDIA PRIVATE LIMITED",
"MEXICAN AGRO CHEMICAL LIMITED",
"MEXICAN FERTILIZER & CHEMICALS PRIVATE LIMITED",
"MEXIM ADHESIVE TAPES PRIVATE LIMITED",
"MEXMON FINANCIALS PRIVATE LIMITED",
"MEXMON INNOVATION PRIVATE LIMITED",
"MEXMYCORP PRIVATE LIMITED",
"MEXO POLYFAB PRIVATE LIMITED",
"MEXPRESS CARGO PRIVATE LIMITED",
"MEXPRESS SERVICES PRIVATE LIMITED",
"MEXTECH TECHNOLOGIES INDIA PRIVATE LIMITED",
"MEXUM TEXINK PRIVATE LIMITED",
"MEXUS CORPORATION PRIVATE LIMITED",
"MEXUS EDUCATION PRIVATE LIMITED",
"MEYER HOUSEWARES INDIA PRIVATE LIMITED",
"MEYER ORGANICS PRIVATE LIMITED",
"MEYER SEALS INDIA PRIVATE LIMITED",
"MEYO GENERAL HOSPITAL NAGPUR",
"MEYOU SERVICES PRIVATE LIMITED",
"MEYVNSYSTEMS PRIVATE LIMITED",
"MEZDOO ENGINEERING AND CONSTRUCTION PRIVATE LIMITED",
"MEZENGAH TEA PRODUCER COMPANY LIMITED",
"MEZHUKKATTIL TRADERS AND AGENCIES PRIVATE LIMITED",
"MEZOCLIQ TECHNOLOGY INDIA PRIVATE LIMITED",
"MEZON PHARMACEUTICALS PRIVATE LIMITED",
"MEZORA PRODUCTIONS PRIVATE LIMITED",
"MEZUX TOUCH PRIVATE LIMITED",
"MEZZANINE INFRATECH PRIVATE LIMITED",
"MEZZEQUITY SOFTWARE SERVICES LIMITED",
"MEZZO CLOTHINGS PRIVATE LIMITED",
"MF PROCESS & SOLUTIONS PRIVATE LIMITED",
"MF UTILITIES INDIA PRIVATE LIMITED",
"MFA CAPITAL PRIVATE LIMITED",
"MFA WEALTH PRIVATE LIMITED",
"MFAR CONSTRUCTIONS PRIVATE LIMITED",
"MFAR DEVELOPERS PRIVATE LIMITED",
"MFAR ENTERPRISES PRIVATE LIMITED",
"MFAR HOTELS & RESORTS PRIVATE LIMITED",
"MFB GEOTECH PRIVATE LIMITED",
"MFC AUTO PARTS PRIVATE LIMITED",
"MFC ERAM",
"MFC TRANSPORT PRIVATE LIMITED",
"MFE FORMWORK TECHNOLOGY INDIA PRIVATE LIMITED",
"MFG OVERSEAS PRIVATE LIMITED",
"MFIFLEX TECHNOLOGIES PRIVATE LIMITED",
"MFINS SERVICES PRIVATE LIMITED",
"M-FIVE SECURITY PRIVATE LIMITED",
"MFL INDIA LIMITED",
"MFMW HOME SOLUTIONS PRIVATE LIMITED",
"MFORMATION SOFTWARE TECHNOLOGIES INDIA PRIVATE LIMITED",
"MFORMILLET FOODS PRIVATE LIMITED",
"MFOUR ADVISORY PRIVATE LIMITED",
"M-FOUR ESTATES PRIVATE LIMITED",
"MFPL TEX PRIVATE LIMITED",
"MFR ELECTRONIC COMPONENTS PRIVATE LIMITED",
"MFS ETHNIC LIMITED",
"MFS FORMWORK SYSTEMS PRIVATE LIMITED",
"MFS WHOLESALE PRIVATE LIMITED",
"MFX INFOTECH PRIVATE LIMITED",
"MG ACRYPLAST INDUSTRIES PRIVATE LIMITED",
"MG AUTOMOTIVES (BUS & COACH) PRIVATE LIMITED",
"MG AUTOSALES PRIVATE LIMITED",
"MG BUILDCARE INFRATECH PRIVATE LIMITED",
"MG CABINETS PRIVATE LIMITED",
"MG CARS PRIVATE LIMITED",
"MG CONSULTING PRIVATE LIMITED",
"MG COTTON COMPANY PRIVATE LIMITED",
"MG INDUSTRIES PRIVATE LIMITED",
"MG LOGISTICS PRIVATE LIMITED",
"MG MARKETSOFT INDIA PRIVATE LIMITED",
"MG MOBILES INDIA PRIVATE LIMITED",
"MG MOTOR INDIA PRIVATE LIMITED",
"MG PET PRIVATE LIMITED",
"MG PROCESSORS PRIVATE LIMITED",
"MG RESIDENCY PRIVATE LIMITED",
"MG RETAILS PRIVATE LIMITED",
"MG SEATING SYSTEMS PRIVATE LIMITED",
"MG TECHNOPOS IT SERVICES LLP",
"MG TOYS WORLD PRIVATE LIMITED",
"MG TRADE SERVICES INDIA PRIVATE LIMITED",
"MG VIDYA MANDIR K B H LAW COLLEGE",
"MG WELL SOLUTIONS PROJECT INTERNATIONAL PRIVATE LIMITED",
"MG WORLDWIDE PRIVATE LIMITED",
"MGA ENGG. & INFRA PRIVATE LIMITED",
"MGA LIFESTYLE PRIVATE LIMITED",
"MGAGE INDIA PRIVATE LIMITED",
"MGB BUSINESS ADVISORS PRIVATE LIMITED",
"MGB HOSPITALITY PRIVATE LIMITED",
"MGB MOBILES ANANTAPUR",
"MGB MOTOR AND AUTO AGENCIES PRIVATE LIMITED",
"MGB RESOURCES PRIVATE LIMITED",
"MGC IMPEX PRIVATE LIMITED",
"MGC PROJECT I D ALIGARH",
"MGCI INSTITUTE INDORE",
"MGD GIRLS SCHOOL",
"MGD HOLDINGS PRIVATE LIMITED",
"MGD KIDS GARMENT PRIVATE LIMITED",
"MGE FARMS PRODUCER COMPANY LIMITED",
"MGE GOLD & DIAMOND PRIVATE LIMITED",
"MGE GRAPHIC SYSTEMS INDIA PRIVATE LIMITED",
"MGEES HOLITEL HOTELS PRIVATE LIMITED",
"MGF AUTOMOBILES LIMITED",
"MGF AUTOMOBILES PRIVATE LIMITED",
"MGF ESTATES MANAGEMENT PRIVATE LIMITED",
"MGF MALL MANAGEMENT",
"MGG INFRA PROJECTS PRIVATE LIMITED",
"MGG TRADING PRIVATE LIMITED",
"MGH HEALTH CARE",
"MGH LOGISTICS PRIVATE LIMITED",
"MGHANSHYAM TEXFAB PRIVATE LIMITED",
"MGI CAPITAL (INDIA) PRIVATE LIMITED",
"MGI COUTIER ENGINEERING PRIVATE LIMITED",
"MGI INDIA PRIVATE LTD",
"MGI INFRA PRIVATE LIMITED",
"MGINNE PRIVATE LIMITED",
"MGIT MAHATHMA GANDHI INSTITUTE",
"MGK FOOD & NATURALS PRIVATE LIMITED",
"MGK FORGING PRIVATE LIMITED",
"MGK HYDRAULICS ENGINEERS PRIVATE LIMITED",
"MGL CARRY PACK PRIVATE LIMITED",
"MGL MARKETING SOLUTIONS PRIVATE LIMITED",
"MGLL MACHINERY (INDIA) PRIVATE LIMITED",
"MGLR PRIVATE LIMITED",
"MGM AGRI-TECH AND RESEARCH INSTITUTE PRIVATE LIMITED",
"MGM ALLIED HEALTH SCIENCES INSTITUTE (MAHSI)",
"MGM COLLEGE",
"MGM DENTAL COLLEGE & HOSPITAL",
"MGM EDIBLE OILS PRIVATE LIMITED",
"MGM ENTERTAINMENTS PRIVATE LIMITED",
"MGM FORGINGS PRIVATE LIMITED",
"MGM GLOBAL AIR PRIVATE LIMITED",
"MGM GREEN ENERGY LIMITED",
"MGM HEALTHCARE PRIVATE LIMITED",
"MGM HOSPITAL",
"MGM HOSPITAL & RESEARCH CENTRE PRIVATE LIMITED",
"MGM INSTITUTE OF BIOSCIENCES AND TECHNOLOGY",
"MGM INSTITUTE OF HOTEL MANAGEMENT",
"MGM INTERNATIONAL SCHOOL",
"MGM MECH PRIVATE LIMITED",
"MGM MEDICAL STORE",
"MGM MINERALS LIMITED",
"MGM NEW BOMBAY HOSPITAL",
"MGM PRINT TECH PRIVATE LIMITED",
"MGM RESORTS INTERNATIONAL",
"MGM SALES PRIVATE LIMITED",
"MGM SENIOR SECONDARY SCHOOL",
"MGM STEELS",
"MGM VARVEL POWER TRANSMISSION PRIVATE LIMITED",
"MGMOBILES INDIA PRIVATE LIMITED",
"MGMS POLYTECHNIC",
"MGMT TOOLS & HARDWARE PRIVATE LIMITED",
"MGN AGRO PROPERTIES PRIVATE LIMITED",
"MGN MEDISAFE PRIVATE LIMITED",
"MGN PUBLIC SCHOOL",
"MGNETO RESOURCE MANAGEMENT PRIVATE LIMITED",
"MGNIKA PRIVATE LIMITED",
"MGO INDIA PRIVATE LIMITED",
"MGP BUILDERS & DEVELOPERS PRIVATE LIMITED",
"MGR AGRO PRODUCTS PRIVATE LIMITED",
"MGR FABRICATORS PRIVATE LIMITED",
"MGR GOVT FILM AND TELEVISION INSTITUTE",
"MGR OVERSEAS PRIVATE LIMITED",
"MGR POLYCOATS INDIA PRIVATE LIMITED",
"MGRID TECHNOLOGIES PRIVATE LIMITED",
"MGRM INFOTECH SOLUTIONS PRIVATE LIMITED",
"MGRM MEDICARE PRIVATE LIMITED",
"MGRM NET LIMITED",
"MGROW TECHNO SYSTEMS PRIVATE LIMITED",
"MGRS AUTOMOTIVES PRIVATE LIMITED",
"MGRV ENTERPRISES PRIVATE LIMITED",
"MGS AUTO FAB PRIVATE LIMITED",
"MGS FAB EQUIPMENTS PRIVATE LIMITED",
"MGS FARMING PRIVATE LIMITED",
"MGS GRAPES PRIVATE LIMITED",
"MGS HOSPITALITIES PRIVATE LIMITED",
"MGS INFOTECH RESEARCH AND SOLUTIONS PRIVATE LIMITED",
"MGS INFRABUILD PRIVATE LIMITED",
"MGS PERSONNEL VISION PRIVATE LIMITED",
"MGS POWER INSTRUMENT PRIVATE LIMITED",
"MGSA REALTY PRIVATE LIMITED",
"MGSHAHANI AND CO DELHI PRIVATE LIMITED",
"MGSR BUILDCON PRIVATE LIMITED",
"MGV EXPORTS PRIVATE LIMITED",
"MGV FOOD DESIGN COMPANY PRIVATE LIMITED",
"MGV INFRA PRIVATE LIMITED",
"MGVA PRIVATE LIMITED",
"MGX COM EXPRESS PRIVATE LIMITED",
"MGYA INFRASTRUCTURE PRIVATE LIMITED",
"MH CONTAINERS PRIVATE LIMITED",
"MH ECOLIFE EMOBILITY PRIVATE LIMITED",
"MH INFRAPROJECTS LIMITED",
"MH ONE TV NETWORK PRIVATE LIMITED",
"MH PARBHANI POWER PRIVATE LIMITED",
"MH TECHNIQUE SOLAIRE INDIA PRIVATE LIMITED",
"MH VENTURES PRIVATE LIMITED",
"MH XORBIAN TECH PRIVATE LIMITED",
"MHAISKAR INFRASTRUCTURE PRIVATE LIMITED",
"M-HANCE INDIA PRIVATE LIMITED",
"MHASKE HOTELS PRIVATE LIMITED",
"MHASKE LOGISTICS PRIVATE LIMITED",
"MHASPL SERVICES PRIVATE LIMITED",
"MHASWADKAR AUTOLINES PRIVATE LIMITED",
"MHATRE ELECTRONICS PRIVATE LIMITED",
"MHATRE INFRA PROJECTS PRIVATE LIMITED",
"MHD POWER PRIVATE LIMITED",
"MHE RENTALS INDIA PRIVATE LIMITED",
"MHE SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED",
"MHEALTH VENTURES INDIA PRIVATE LIMITED",
"MHETRE FOODS PRIVATE LIMITED",
"MHETRE PACKAGING PRIVATE LIMITED",
"MHF SCHOOL OF NURSING",
"MHFA INDIA PRIVATE LIMITED",
"MHI ENGINEERING AND INDUSTRIAL PROJECTS INDIA PRIVATE LIMITED",
"MHITRAA ENGINEERING EQUIPMENTS PRIVATE LIMITED",
"MHL HEALTHCARE LIMITED",
"MHL INFOTECH AND LEASING PRIVATE LIMITED",
"MHM HOLDINGS PRIVATE LIMITED",
"MHN FOODS PRIVATE LIMITED",
"MHOW AGROH PATHWAYS PRIVATE LIMITED",
"MHPL INDIA PRIVATE LIMITED",
"MHTRADELINK SERVICES PRIVATE LIMITED",
"MHWIRTH INDIA PRIVATE LIMITED",
"MI CNC-TECHNOLOGIES PRIVATE LIMITED",
"MI DESIGNERS PRIVATE LIMITED",
"MI ELECTRICAL STEEL PROCESSING INDIA PRIVATE LIMITED",
"M-I ENTERPRISES (INDIA) PRIVATE LIMITED",
"MI GROUP PRIVATE LIMITED",
"MI INDUSTRIES INDIA PRIVATE LIMITED",
"MI LIFESTYLE MARKETING GLOBAL PRIVATE LIMITED",
"MI MYSOLAR24 PRIVATE LIMITED",
"MI SOLAR (INDIA) PRIVATE LIMITED",
"MI STEEL PROCESSING INDIA PRIVATE LIMITED",
"MI STOCK BROKING PRIVATE LIMITED",
"MI TORICA INDIA PRIVATE LIMITED",
"MI TRADERS AND SERVICES PRIVATE LIMITED",
"MI2C SECURITY AND FACILITIES PRIVATE LIMITED",
"MIA COMMUNICATIONS PRIVATE LIMITED",
"MIA DASTKAAR ZARIWALE PRIVATE LIMITED",
"MIA PLASTICISERS AND ALLIED PRODUCTS PRIVATE LIMITED",
"MIAC ANALYTICAL SERVICES PRIVATE LIMITED",
"MIAGRI BIOCHEM PRIVATE LIMITED",
"MIALO TECHNOLOGIES PRIVATE LIMITED",
"MIALTUS INSURANCE BROKING PRIVATE LIMITED",
"MIAMO INDUSTRIES PRIVATE LIMITED",
"MIANTIC AV DISTRIBUTION PRIVATE LIMITED",
"MIATELA ETAIL PRIVATE LIMITED",
"MIB ENGINEERING AND CONSULTANTS PRIVATE LIMITED",
"MIBA DRIVETEC INDIA PRIVATE LIMITED",
"MIBA ENGINEERING CENTER INDIA PRIVATE LIMITED",
"MIBHASHI ELECTRIC PRIVATE LIMITED",
"MIC ELECTRONICS LIMITED",
"MICA",
"MICA HOUSE LIMITED",
"MICALS PHARMA PRIVATE LIMITED",
"MICAN ENGINEERS PRIVATE LIMITED",
"MICANITE INSULATING PRIVATE LIMITED",
"MICAR SHARING TECHNOLOGIES PRIVATE LIMITED",
"MICAS ORGANICS LIMITED",
"MICASA EDUCATION PRIVATE LIMITED",
"MICE KART PRIVATE LIMITED",
"MICECAFE JOURNEY PRIVATE LIMITED",
"MICHAEL ARAM INDIA PRIVATE LIMITED",
"MICHAEL BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"MICHAEL EXPORT AND IMPORT PRIVATE LIMITED",
"MICHAEL HIGH SCHOOL",
"MICHAEL PAGE INTERNATIONAL RECRUITMENT PRIVATE LIMITED",
"MICHEL BAU GMBH & CO. KG",
"MICHELIN INDIA PRIVATE LIMITED",
"MICHELIN INDIA TECHNOLOGY CENTER LLP",
"MICHELIN INDIA TECHNOLOGY CENTER PRIVATE LIMITED",
"MICHELL BEARINGS INDIA PRIVATE LIMITED",
"MICHELMAN PRIVATE LIMITED",
"MICHEN ENGINEERING SOLUTION PRIVATE LIMITED",
"MICHEZO SPORTS INFRASTRUCTURE PRIVATE LIMITED",
"MICHIGAN ENGINEERS PRIVATE LIMITED",
"MICHIGAN STONES PRIVATE LIMITED",
"MICHIGANTAP HOSPITALITY PRIVATE LIMITED",
"MICKEYFONE TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"MICKY METALS LIMITED",
"MICL BUILDERS LLP",
"MICM NET SOLUTIONS PRIVATE LIMITED",
"MICNELF MICRONUTRIENTS PRIVATE LIMITED",
"MICO GLASS INDUSTRIES PRIVATE LIMITED",
"MICO PETROCHEM PRIVATE LIMITED",
"MICO PLAST INDUSTRIES PRIVATE LIMITED",
"MICOLOGY SOLUTIONS INDIA PRIVATE LIMITED",
"MICOLUBE INDIA LIMITED",
"MICON AUTOMATION SYSTEMS PRIVATE LIMITED",
"MICON ENGINEERS HUBLI PRIVATE LIMITED",
"MICON VALVES INDIA PRIVATE LIMITED",
"MICPRO ENGINEERING PRIVATE LIMITED",
"MICRA SOFT PRIVATE LIMITED",
"MICRO ACADEMY INDIA PRIVATE LIMITED",
"MICRO ACCESS PRIVATE LIMITED",
"MICRO AGE INSTRUMENTS PRIVATE LIMITED",
"MICRO AUTOMOTIVE COMPONENTS PRIVATE LIMITED",
"MICRO BELTS AND TYRES PRIVATE LIMITED",
"MICRO CAPITALS PRIVATE LIMITED",
"MICRO CARE COMPUTERS PRIVATE LIMITED",
"MICRO CARE ENT HOSPITAL & RESEARCH INSTITUTE",
"MICRO CARE MEDICAL SYSTEMS PRIVATE LIMITED",
"MICRO CHEMPRINT PVT.LTD.",
"MICRO CLINICAL LABORATORY & DIAGNOSTIC CENTRE PRIVATE LIMITED",
"MICRO CNC TECHNOLOGIS PRIVATE LIMITED",
"MICRO COM SOLUTIONS PRIVATE LIMITED",
"MICRO COMMERCIAL PRIVATE LIMITED",
"MICRO CONCEPT TOOLS",
"MICRO DEVICES PRIVATE LIMITED",
"MICRO ENERGY CREDITS CORPORATION PRIVATE LIMITED",
"MICRO ENTERPRISES PRIVATE LIMITED",
"MICRO FLAT DATUMS PRIVATE LIMITED",
"MICRO FLOW DEVICES INDIA PRIVATE LIMITED",
"MICRO FOCUS INDIA PRIVATE LIMITED",
"MICRO FOCUS SOFTWARE INDIA PRIVATE LIMITED",
"MICRO FOCUS SOFTWARE SOLUTIONS INDIA PRIVATE LIMIT",
"MICRO FOCUS SOFTWARE SOLUTIONS INDIA PRIVATE LIMITED",
"MICRO FOOTWEARS PRIVATE LIMITED",
"MICRO FX PRIVATE LIMITED",
"MICRO HARD IT SOLUTIONS PRIVATE LIMITED",
"MICRO HYDROCHEM PRIVATE LIMITED",
"MICRO HYDROTECHNIC PRIVATE LIMITED",
"MICRO INDUSTRIAL CORPORATION",
"MICRO INFOSOLUTIONS PRIVATE LIMITED",
"MICRO INFRASTRUCTURE INDIA PRIVATE LIMITED",
"MICRO INFRATECH PRIVATE LIMITED",
"MICRO INSTRUMENTS LIMITED",
"MICRO INSTRUMENTS PRIVATE LIMITED",
"MICRO INSURANCE SERVICES PRIVATE LIMITED",
"MICRO INTERLININGS PRIVATE LIMITED",
"MICRO ION-COATING PRIVATE LIMITED",
"MICRO JEWELS AND DIAMONDS PRIVATE LIMITED",
"MICRO LABELS PRIVATE LIMITED",
"MICRO LABS LIMITED",
"MICRO LIFE SCIENCES PRIVATE LIMITED",
"MICRO LINK INFONET PRIVATE LIMITED",
"MICRO LOGISTICS INDIA PRIVATE LIMITED",
"MICRO MARBLES PRIVATE LIMITED",
"MICRO MARBLEX (INDIA) PRIVATE LIMITED",
"MICRO MEASURES METROLOGY PRIVATE LIMITED",
"MICRO MED CHARTS MANUFACTURING COMPANY PRIVATE LIMITED",
"MICRO MELT PRIVATE. LIMITED",
"MICRO MESH INDIA PRIVATE LIMITED",
"MICRO METALS",
"MICRO MOLECULES PRIVATE LIMITED",
"MICRO MOTION INDIA PRIVATE LIMITED",
"MICRO MULTICOM PRIVATE LIMITED",
"MICRO NETWORK (INDIA) PRIVATE LIMITED",
"MICRO ORGANICS PHARMACEUTICALS INDIA PRIVATE LIMITED",
"MICRO PIXEL PRIVATE LIMITED",
"MICRO PLASTICS PRIVATE LIMITED",
"MICRO PLUS NETWORKING SOLUCTIONS PRIVATE LIMITED",
"MICRO PNEUMATICS PRIVATE LIMITED",
"MICRO POLYFAB PRIVATE LIMITED",
"MICRO POLYIONICS PRIVATE LIMITED",
"MICRO PRECISION CALIBRATION INDIA PRIVATE LIMITED",
"MICRO PRECISION PRODUCTS PRIVATE LIMITED",
"MICRO PRECISION PRODUCTS PVT LTD",
"MICRO PRETEMP INSTRUMENTS PRIVATE LIMITED",
"MICRO PRINT & PACK PRIVATE LIMITED",
"MICRO PROTECT ENGIEQUIPMENTS PRIVATE LIMITED",
"MICRO RESINS PRIVATE LIMITED",
"MICRO SCREW MANUFACTURING COMPANY PRIVATE LIMITED",
"MICRO SMALL AND MEDIUM ENTERPRISES DEPARTMENT",
"MICRO SPARK SOFTWERE SOLUTIONS PRIVATE LIMITED",
"MICRO SUPREME AUTO INDUSTRIES (INDIA) PRIVATE LIMITED",
"MICRO TECH CNC PRIVATE LIMITED",
"MICRO TECHNOCAM EQUIPMENTS PRIVATE LIMITED",
"MICRO THERAPEUTIC RESEARCH LABS PRIVATE LIMITED",
"MICRO TIN PRINTERS PRIVATE LIMITED",
"MICRO TOOLING SYSTEMS INDIA PRIVATE LIMITED",
"MICRO TOOLS (INDIA PRIVATE LIMITED",
"MICRO TRANSMISSIONS PRIVATE LIMITED",
"MICRO TRAVELS SERVICES PRIVATE LIMITED",
"MICRO UNITS DEVELOPMENT & REFINANCE AGENCY LIMITED",
"MICRO VILLAGE COMMUNICATIONS PRIVATE LIMITED",
"MICRO WEAVES PRIVATE LIMITED",
"MICRO WOOD PRIVATE LIMITED",
"MICROALGAE SOLUTIONS INDIA PRIVATE LIMITED",
"MICROART SYSTEMS (INDIA) PRIVATE LIMITED",
"MICROART SYSTEMS INDIA PRIVATE LIMITED",
"MICRO-AZURE COMPUTERS PRIVATE LIMITED",
"MICROBAN INDIA PRIVATE LIMITED",
"MICROBAX INDIA LIMITED",
"MICROBI AGROTECH PRIVATE LIMITED",
"MICROBIOLOGICAL LABORATORY",
"MICROBION LIFESCIENCE PRIVATE LIMITED",
"MICROCAB INDUSTRIES & LOGISTICS PRIVATE LIMITED",
"MICROCARE COMPUTERS PRIVATE LIMITED HYDERABAD",
"MICROCHEM SILLIKER PRIVATE LIMITED",
"MICROCHIP INFOTECH SYSTEMS PRIVATE LIMITED",
"MICROCHIP TECHNOLOGY INDIA PRIVATE LIMITED",
"MICROCOM DATA CENTRE PRIVATE LIMITED",
"MICROCOM SOLUTION PRIVATE LIMITED",
"MICROCOMMERCE BUSINESS INNOVATIONS PRIVATE LIMITED",
"MICROCON I2I PRIVATE LIMITED",
"MICROCOOL SYSTEMS PRIVATE LIMITED",
"MICROCOUNTS INFO SYSTEM PRIVATE LIMITED",
"MICROCRAFT K.K.",
"MICROCREDIT INITIATIVE OF GRAMEEN",
"MICRODATA COMPUTER SERVICES PVT LTD",
"MICRO-EPSILON INDIA PRIVATE LIMITED",
"MICROFACE ENGINEERS (MADRAS) PRIVATE LIMITED",
"MICROFIBER CORP PRIVATE LIMITED",
"MICROFILAMENT YARN PRIVATE LIMITED",
"MICROFILT FILTER MEDIA PRIVATE LIMITED",
"MICROFILT INDIA PRIVATE LIMITED",
"MICROFINANCE INSTITUTIONS NETWORK",
"MICROFINE BUSHINGS PRIVATE LIMITED",
"MICROFINISH PUMPS PRIVATE LIMITED",
"MICROFINISH VALVES PRIVATE LIMITED",
"MICROFIT INDUSTRIES PRIVATE LIMITED",
"MICROFLOW SURGICAALS INDIA PRIVATE LIMITED",
"MICROGEN HYGIENE PRIVATE LIMITED",
"MICROGENE DIAGNOSTIC SYSTEMS PRIVATE LIMITED",
"MICROGENESIS CADSOFT PRIVATE LIMITED",
"MICROGENESIS LEARNING PRIVATE LIMITED",
"MICROGENESIS TECHSOFT PRIVATE LIMITED",
"MICROGO LLP",
"MICROGREEN TECHNOLOGIES PRIVATE LIMITED",
"MICROHARD SERVICES PRIVATE LIMITED",
"MICROID BIOMETRICS PRIVATE LIMITED",
"MICROL REMEDIES",
"MICROLAND LIMITED",
"MICROLENT SYSTEMS PRIVATE LIMITED",
"MICROLINE INDIA PRIVATE LIMITED",
"MICROLINK MARKETING PRIVATE LIMITED",
"MICROLINK SOLUTIONS PRIVATE LIMITED",
"MICROLISE TELEMATICS PRIVATE LIMITED",
"MICROLL ENGINEERS PRIVATE LIMITED",
"MICROLOG SYSTEMS AND TECHNOLOGY PRIVATE LIMITED",
"MICROLOGIC INTEGRATED SYSTEMS PRIVATE LIMITED",
"MICROLOGIX EMBEDDED CONTROLS PRIVATE LIMITED",
"MICROLYN HEALTHCARE PRIVATE LIMITED",
"MICROMAC INDUSTRIES PRIVATE LIMITED",
"MICROMAP ELECTRONIC SYSTEMS PRIVATE LIMITED",
"MICROMASTER LABORATORIES PRIVATE LIMITED",
"MICROMATE PERIPHERALS AND COMPUTERS (PUNE) PRIVATE LIMITED",
"MICROMATIC GRINDING TECHNOLOGIES LIMITED",
"MICROMATIC GRINDING TECHNOLOGIES PRIVATE LIMITED",
"MICROMATIC MACHINE TOOLS PRIVATE LTD",
"MICROMATIC MACHINE TOOLS PRIVATE.LIMITED",
"MICROMATIC MANUFACTURING SYSTEMS PRIVATE LIMITED",
"MICROMATICS RESEARCH PRIVATE LIMITED",
"MICROMATION PVT LTD",
"MICROMAX INFORMATICS LIMITED",
"MICROMAX INSTRUMENTS PRIVATE LIMITED",
"MICROMAX TECHNOLOGIES PRIVATE LIMITED.",
"MICROMEG ENTERPRISES PRIVATE LIMITED",
"MICROMEN SOFTWARE SOLUTIONS PRIVATE LIMITED",
"MICROMILL TECHNOLOGIES LLP",
"MICROMOLE IONICS PRIVATE LIMITED",
"MICRON ALUMINA PRIVATE LIMITED",
"MICRON CALCITE PRIVATE LIMITED",
"MICRON CNC MACHINES PRIVATE LIMITED",
"MICRON COATING PRIVATE LIMITED",
"MICRON CONCEPT PRIVATE LIMITED",
"MICRON ELECTRICALS",
"MICRON EMS TECH PRIVATE LIMITED",
"MICRON ENGINEERS AND DEVELOPERS BANGALORE PRIVATE LIMITED",
"MICRON ENTERPRISES PRIVATE LIMITED",
"MICRON HVAC PRIVATE LIMITED",
"MICRON INDUSTRIES PRIVATE LIMITED",
"MICRON PLASTICS PRIVATE LIMITED",
"MICRON PRECION SCREWS LIMITED",
"MICRON PRECISION SCREWS PRIVATE LIMITED",
"MICRON SPECMA (INDIA) PRIVATE LIMITED",
"MICRON SYSTEMS AND CONTROLS PRIVATE LIMITED",
"MICRON TECHNOLOGY OPERATIONS INDIA LLP",
"MICRONEL GLOBAL ENGINEERS PRIVATE LIMITED",
"MICRONET INFOCOM & LOGISTICS PRIVATE LIMITED",
"MICRONIC ANALYTICAL DEVICES PRIVATE LIMITED",
"MICRONIC INFOTECH SERVICES PRIVATE LIMITED",
"MICRONIX INFOSOLUTIONS LIMITED",
"MICRONOVA HELIOS NETWORKING SOLUTIONS PRIVATE LIMITED",
"MICRONOVA IMPEX PRIVATE LIMITED",
"MICRONOVA INFOTEX PRIVATE LIMITED",
"MICRONOVA NETWORK SOLUTIONS PRIVATE LIMITED",
"MICRONOVA TELESYSTEMS PRIVATE LIMITED",
"MICRONOX INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"MICRONTECH ENGINEERS PRIVATE LIMITED",
"MICROOBJECTS PRIVATE LIMITED",
"MICROORBIT CONSULTING SERVICES INC",
"MICROPACK LIMITED",
"MICROPACK VENTURES PRIVATE LIMITED",
"MICROPARK LOGISTICS PRIVATE LIMITED",
"MICROPLAST POLYTEX INDUSTRIES PRIVATE LIMITED",
"MICROPNEUMATIC ENGINEERING & CONSTRUCTION PRIVATE LIMITED",
"MICROPOINT COMPUTERS PRIVATE LIMITED",
"MICROPOLIS LIFESCIENCES PRIVATE LIMITED",
"MICROPOLO OVERSEAS PRIVATE LIMITED",
"MICROPORE FILTRATION SOLUTIONS PRIVATE LIMITED",
"MICROPORT SCIENTIFIC INDIA PRIVATE LIMITED",
"MICROPRO SOFTWARE SOLUTIONS LIMITED",
"MICROPRO SOFTWARE SOLUTIONS PRIVATE LIMITED",
"MICROPURE PARENTERALS PRIVATE LIMITED",
"MICROPYRAMID INFORMATICS PRIVATE LIMITED",
"MICRORIVVATE METAL PRIVATE LIMITED",
"MICROSCAN COMMUNICATIONS PRIVATE LIMITED",
"MICROSCAN INFOCOMMTECH PRIVATE LIMITED",
"MICROSCAN ORANGE BROADBAND PRIVATE LIMITED",
"MICROSEMI COMMUNICATIONS INDIA PRIVATE LIMITED",
"MICROSEMI INDIA PRIVATE LIMITED",
"MICROSEMI STORAGE SOLUTIONS INDIA PRIVATE LIMITED",
"MICROSENSE NETWORKS PRIVATE LIMITED",
"MICROSENSE PRIVATE LIMITED",
"MICROSENSE WIRELESS PRIVATE LIMITED",
"MICROSENZE DYNAMICS PRIVATE LIMITED",
"MICROSET INDIA PRIVATE LIMITED",
"MICROSHARE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"MICROSOFT",
"MICROSOFT CORPORATION INDIA PRIVATE LIMITED",
"MICROSOFT GLOBAL SERVICES CENTER INDIA PRIVATE. LIMITED",
"MICROSOFT INDIA R&D PRIVATE LIMITED",
"MICROSOFT RESEARCH LAB INDIA PRIVATE LIMITED",
"MICROSPARK SOFTWARE SOLUTIONS PRIVATE LIMITED",
"MICROSTEP MONITORING INFORMATION SYSTEMS INDIA PRIVATE LIMITED",
"MICROSTITCH FASHIONS PRIVATE LIMITED",
"MICROSTRATEGY INDIA PRIVATE LIMITED",
"MICROSUN BIO PLANTS (INDIA) PRIVATE LIMITED",
"MICROSUN INFOCARE PRIVATE LIMITED",
"MICROTALK COMMUNICATIONS PRIVATE LIMITED",
"MICROTALK INDIA PRIVATE LIMITED",
"MICROTECH BOILERS PRIVATE LIMITED",
"MICROTECH DIGISYSTEMS PRIVATE LIMITED",
"MICROTECH INDUCTIONS (INDIA) PRIVATE LIMITED",
"MICROTECH INFOSERVE PRIVATE LIMITED",
"MICROTECH ROLLERS PVT LTD",
"MICROTECH SEAMLESS TUBE PRIVATE LIMITED",
"MICROTECH SPLINE GAUGES PRIVATE LIMITED",
"MICROTECH SUPPORT 247 PRIVATE LIMITED",
"MICROTECH THERMAL SYSTEMS PRIVATE LIMITED",
"MICROTEK FORGINGS PRIVATE LIMITED",
"MICROTEK GRINDING MACHINES PRIVATE LIMITED",
"MICROTEK INFOSOFT LIMITED",
"MICROTEK INFRASTRUCTURES PRIVATE LIMITED",
"MICROTEK INTERNATIONAL PRIVATE LIMITED",
"MICROTEK LEASING & FINANCE PRIVATE LIMITED",
"MICROTEK NEW TECHNOLOGIES PRIVATE LIMITED",
"MICROTEL NETLINKS PRIVATE LIMITED",
"MICROTEX CLOTHING PRIVATE LIMITED",
"MICROTEX ENERGY PRIVATE LIMITED",
"MICROTHERM INDIA PRIVATE LIMITED",
"MICROTRANS INFRATECH LIMITED",
"MICROTROL STERILISATION SERVICES PRIVATE.LIMITED",
"MICROTURNERS",
"MICROVERSE AUTOMATION PVT LTD",
"MICROVIEWS INFOSYSTEMS PRIVATE LIMITED",
"MICROVISION ENGINEERING PRIVATE LIMITED",
"MICROVISION ENVIRO EQUIPMENTS PRIVATE LIMITED",
"MICROWARE CARDS SOLUTIONS PRIVATE LIMITED",
"MICROWARE COMPUTING & CONSULTING PRIVATE LIMITED",
"MICROWARE MULTIMEDIA PRIVATE LIMITED",
"MICROWATT ENERGY SYSTEMS PRIVATE LIMITED",
"MICROWEB ENTERPRISES PRIVATE LIMITED",
"MICROWEBIES SOFTWARE SERVICES",
"MICROWIN LABS PRIVATE LIMITED",
"MICROWORLD INFOSOL PRIVATE LIMITED",
"MICROWORLD INFOTECH PRIVATE LIMITED",
"MICROWORLD SOFTWARE SERVICES PRIVATE LIMITED",
"MICROZANT TECHNOLOGIES PRIVATE LIMITED",
"MICROZONE TECHNOLOGIES PRIVATE LIMITED",
"MICRRO COTSPINN INDIA PRIVATE LIMITED",
"MID INDIA CIVIL ERECTORS PRIVATE LIMITED",
"MID INDIA CONSTRUCTION PRIVATE LIMITED",
"MID INDIA CREATIONS",
"MID VALLEY HEALTH CARE SERVICES PRIVATE LIMITED",
"MIDA & COMPANY PRIVATE LIMITED",
"MIDAAS TELESOFT PRIVATE LIMITED",
"MIDAPPLE FOODS PRIVATE LIMITED",
"MIDAS AGROFOODS PRIVATE LIMITED",
"MIDAS AIRCON SOLUTIONS PRIVATE LIMITED",
"MIDAS ALTERNATIVE INVESTMENT MANAGER PRIVATE LIMITED",
"MIDAS AUTOSOFT ENGINEERS PRIVATE LIMITED",
"MIDAS BUSINESS MACHINES PRIVATE LIMITED",
"MIDAS BUTYL PRODUCTS INDIA PRIVATE LIMITED",
"MIDAS CARE PHARMACEUTICALS PVT LTD",
"MIDAS DEALS PRIVATE LIMITED",
"MIDAS DIAMONDS PRIVATE LIMITED",
"MIDAS DIGITAL SERVICES PRIVATE LIMITED",
"MIDAS ELECTRICALS PRIVATE LIMITED",
"MIDAS ELECTRONICS PRIVATE LIMITED",
"MIDAS FERTCHEM IMPEX PRIVATE LIMITED",
"MIDAS FINSERVE PRIVATE LIMITED",
"MIDAS FOOD OVERSEAS PRIVATE LIMITED",
"MIDAS FOODS INDIA PRIVATE LIMITED",
"MIDAS GARMENTS ACCESSORIES PRIVATE LIMITED",
"MIDAS GLOBAL MARITIME PRIVATE LIMITED",
"MIDAS GOLDEN DISTILLERIES PRIVATE LIMITED",
"MIDAS HEALTHCARE LIMITED",
"MIDAS HYGIENE INDUSTRIES PRIVATE LIMITED",
"MIDAS IMPEX PRIVATE LIMITED",
"MIDAS INFRATECH PRIVATE LIMITED",
"MIDAS IT SERVICES INDIA PRIVATE LIMITED",
"MIDAS JEWELS PVT LTD",
"MIDAS KNITS PRIVATE LIMITED",
"MIDAS MANPOWER OUTSOURCING PRIVATE LIMITED",
"MIDAS MARKETING SERVICES PRIVATE LIMITED",
"MIDAS MEDIA NETWORK PRIVATE LIMITED",
"MIDAS METCONS PRIVATE LIMITED",
"MIDAS MICROTECH ENGINEERING PRIVATE LIMITED",
"MIDAS MOULDERS PRIVATE LIMITED",
"MIDAS MULTISPECIALITY HOSPITAL PRIVATE LIMITED",
"MIDAS NATURALS PRIVATE LIMITED",
"MIDAS POLYPACK PRIVATE LIMITED",
"MIDAS PRE CURED TREADS PVT LTD",
"MIDAS PROJECTS PRIVATE LIMITED",
"MIDAS RESEARCH AND DEVELOPMENT CENTRE INDIA PRIVATE LIMITED",
"MIDAS RESOURCES OVERSEAS PRIVATE LIMITED",
"MIDAS RETREADS INDIA PRIVATE LIMITED",
"MIDAS RUBBER PRIVATE LIMITED",
"MIDAS SAFETY PRIVATE LIMITED",
"MIDAS SALES PRIVATE LIMITED",
"MIDAS SIGNATURE JEWELLERY PRIVATE LIMITED",
"MIDAS SKB INFRASTRUCTURE PRIVATE LIMITED",
"MIDAS TANKERS PRIVATE LIMITED",
"MIDAS TECHNIQUE PRIVATE LIMITED",
"MIDAS TOUCH ENTERPRISES PRIVATE LIMITED",
"MIDAS TOUCH HEALTH CARE PRIVATE LIMITED",
"MIDAS TOUCH INTERNATIONAL PRIVATE LIMITED",
"MIDAS TOUCH METALLOYS PRIVATE LIMITED",
"MIDAS TREADS (INDIA) PRIVATE LIMITED",
"MIDAS VENTURES PRIVATE LIMITED",
"MIDAS YARN PROCESSORS PRIVATE LIMITED",
"MIDASMEDITECH PRIVATE LIMITED",
"MIDASTECH ORBIT PRIVATE LIMITED",
"MIDASTECH VENTURES PRIVATE LIMITED",
"MIDASTOUCH DYES AND INTERMEDIARIES LIMITED",
"MIDAURA CONSTRUCTION PRIVATE LIMITED",
"MIDAXIS CONSTRUCTIONS PRIVATE LIMITED",
"MIDDAS CROPSAFE LIMITED",
"MIDDAS TOUCH DESIGN PRIVATE LIMITED",
"MIDDAY INFOMEDIA LIMITED",
"MIDDAZO ENTERPRISES PRIVATE LIMITED",
"MIDDHA GLOBAL PRIVATE LIMITED",
"MIDDHA LOGISTIC SERVICES PRIVATE LIMITED",
"MIDDLE EARTH CONSULTANTS PRIVATE LIMITED",
"MIDDLE EAST LUBRICANTS INDIA PRIVATE LIMITED",
"MIDDLE MIST PHARMACEUTICALS PRIVATE LIMITED",
"MIDDLE PATH TRADING PRIVATE LIMITED",
"MIDDLEBY CELFROST INNOVATIONS PRIVATE LIMITED",
"MIDDLEBY INDIA ENGINEERING PRIVATE LIMITED",
"MIDDLEMILE PRO LLP",
"MIDDLESEX EDUCATION PRIVATE LIMITED",
"MIDDSHINE TECHNOLOGIS PRIVATE LIMITED",
"MIDEA HOME APPLIANCES (INDIA) PRIVATE LIMITED",
"MIDEA INDIA PRIVATE LIMITED",
"MIDESK SERVICES PRIVATE LIMITED",
"MIDEX GLOBAL PRIVATE LIMITED",
"MIDEX VASHI MARKETING PRIVATE LIMITED",
"MIDGULF SERVICES INDIA PRIVATE LIMITED",
"MIDHIL STRIPS PRIVATE LIMITED",
"MIDITAS INDIA PRIVATE LIMITED",
"MIDLAND AGRO PVT. LTD.",
"MIDLAND APPLIANCES PRIVATE LIMITED",
"MIDLAND CONCRETE PRIVATE LIMITED",
"MIDLAND CREDIT MANAGEMENT INDIA PRIVATE LIMITED",
"MIDLAND MICROFIN LIMITED",
"MIDMAC DEVELOPERS PRIVATE LIMITED",
"MIDMAC INFRASTRUCTURE PRIVATE LIMITED",
"MIDMARK INDIA PRIVATE LIMITED",
"MIDNAPORE DIAGNOSTICS PRIVATE LIMITED",
"MIDNAPORE HATCHERIES PVT LTD",
"MIDNAPORE POULTRY & AGRO FARM PRIVATE LIMITED",
"MIDNAPUR PLASTIC INDUSTRY PRIVATE LIMITED",
"MIDNAPUR SHIVAM HATCHERY AND BREEDING FARM PRIVATE LIMITED",
"MIDNIGHT AGENCIES PVT LTD",
"MIDREX TECHNOLOGIES INDIA PRIVATE LIMITED",
"MIDRIB HEALTH CARE PRIVATE LIMITED",
"MIDRIFF INFO SOLUTION PRIVATE LIMITED",
"MIDWAY APPARELS INDIA PRIVATE LIMITED",
"MIDWEST GOLD LIMITED",
"MIDWEST GRANITE PRIVATE LIMITED",
"MIDWEST HOLDINGS & PROPERTIES PVT LTD",
"MIEBACH CONSULTING INDIA PRIVATE LIMITED",
"MIECO BOARDS PRIVATE LIMITED",
"MIECO PUMPS AND GENERATORS PRIVATE LIMITED",
"MIELE INDIA PRIVATE LIMITED",
"MIES TURNKEY PROJECTS SOLUTIONS PRIVATE LIMITED",
"MIESTILO LIFESTYLE PRIVATE LIMITED",
"MIET PUBLIC SCHOOL",
"MIETERIOR PRIVATE LIMITED",
"MIEUPRO SYSTEMS PRIVATE LIMITED",
"MIEUX ADVISORS PRIVATE LIMITED",
"MIEUX INFRACON LIMITED",
"MIEUX TECHNOLOGIES PRIVATE LIMITED",
"MIEVIC LIFESTYLE PRIVATE LIMITED",
"MIFAMED MEDICAL PRIVATE LIMITED",
"MI-FI NETWORKS PRIVATE LIMITED",
"MIFY SOLUTIONS PRIVATE LIMITED",
"MIG FINCON PVT LTD",
"MIGATRONIC INDIA PRIVATE LIMITED",
"MIGHTY AUTO WHEELS PRIVATE LIMITED",
"MIGHTY AVENGERS SOLAR PRIVATE LIMITED",
"MIGHTY CONSTRUCTIONS PRIVATE LIMITED",
"MIGHTYHIVE INDIA PRIVATE LIMITED",
"MIGHTYWARNER INFOSERVE OPC PRIVATE LIMITED",
"MIGLANIS AND ASSOCIATES PRIVATE LIMITED",
"MIGRANI ENVIROTECH ENGINEERS PVT LTD",
"MIGROS INDIA PRIVATE LIMITED",
"MIH INTERNET INDIA PRIVATE LIMITED",
"MIHAMA INDIA PRIVATE LIMITED",
"MIHAN INDIA LIMITED",
"MIHEER LOGITECH PRIVATE LIMITED",
"MIHIJAM VANASPATI LIMITED",
"MIHIKA INDUSTRIES LTD.",
"MIHIKITA ENTERPRISES LIMITED",
"MIHIR AND CO AGENCY",
"MIHIR ENGINEERS PRIVATE LIMITED",
"MIHIR INFINITE SERVICES PRIVATE LIMITED",
"MIHIR MACHINE TOOLS (GUJARAT) PRIVATE LIMITED",
"MIHIR SYNTHETICS PRIVATE LIMITED",
"MIHIRLAL KHAN INSTITUTION",
"MIHIT SOLAR POWER PRIVATE LIMITED",
"MIHUP COMMUNICATIONS PRIVATE LIMITED",
"MII EXPORTS PRIVATE LIMITED",
"MII MOBILE APP PRIVATE LIMITED",
"MIICRON WIRES AND POLYMERS PRIVATE LIMITED",
"MIIHIR CHEMOSOL PRIVATE LIMITED",
"MIIO ENERGY PRIVATE LIMITED",
"MIJAS CONSULTANTS PRIVATE LIMITED",
"MIJO AUTO GAS PVT. LTD.",
"MIJU PRECISION INDIA PRIVATE LIMITED",
"MIKA ENGINEERING INDIA PRIVATE LIMITED",
"MIKADO EDUCATION FOUNDATION",
"MIKADO REALTORS PRIVATE LIMITED",
"MIKADO TRADING PRIVATE LIMITED",
"MIKALA SILVER EXPORT PRIVATE LIMITED",
"MIKAP ENGINEERING SERVICES PRIVATE LIMITED",
"MIKAS STAINLESS STEELS INDIA PRIVATE LIMITED",
"MIKAYA BRANDS PRIVATE LIMITED",
"MIKE SIERRA HEALTHCARE PRIVATE LIMITED",
"MIKELEGAL SERVICES PRIVATE LIMITED",
"MIKER FINANCIAL CONSULTANTS PRIVATE LIMITED",
"MIKHAEL CAPITALIZE PRIVATE LIMITED",
"MIKHAEL FOODS LIMITED",
"MIKHAIL EXIM PRIVATE LIMITED",
"MIKI EXPORTS INTERNATIONAL",
"MIKI MAIZE MILLING PRIVATE LIMITED",
"MIKI PULLEY (INDIA) PRIVATE LIMITED",
"MIKI WIRE WORKS PRIVATE LIMITED",
"MIKIMOTO EXPORTS PRIVATE LIMITED",
"MIKLENS BIO PRIVATE LIMITED",
"MIKRO FLO FILTERS PRIVATE LIMITED",
"MIKRO INNOTECH INDIA PRIVATE LIMITED",
"MIKROFINE TOOLINGS PRIVATE LIMITED",
"MIKRON TOOLS PRIVATE LIMITED",
"MIKRONIX GAUGES PRIVATE LIMITED",
"MIKROSEN CONTROL DEVICES PRIVATE LIMITED",
"MIKROTEK MACHINES LIMITED",
"MIKROZ INFOSECURITY PRIVATE LIMITED",
"MIKSAR FOODS PRIVATE LIMITED",
"MIKU TRADERS",
"MIKUNI INDIA PRIVATE LIMITED",
"MIL INDIA LIMITED",
"MIL INDIA PRIVATE LIMITED",
"MIL INDUSTRIES LIMITED",
"MIL LABORATORIES PRIVATE LIMITED",
"MIL OVERSEAS EXPORT PRIVATE LIMITED",
"MIL POWER CONVERTER TECHNOLOGIES INDIA PRIVATE LIMITED",
"MIL STEEL AND POWER PRIVATE LIMITED",
"MIL TRADING PRIVATE LIMITED",
"MIL VEHICLES & TECHNOLOGIES PRIVATE LIMITED",
"MILA STAR RETAIL PRIVATE LIMITED",
"MILAAP SOCIAL VENTURES INDIA PRIVATE LIMITED",
"MILAAYA EMBROIDERY PRIVATE LIMITED",
"MILACRON INDIA PRIVATE LIMITED",
"MILAGE COMMERCIAL PRIVATE LIMITED",
"MILAGRES COLLEGE",
"MILAGRO CERAMICA PRIVATE LIMITED",
"MILAGRO LIFE SCIENCES PRIVATE LIMITED",
"MILAGROW BUSINESS & KNOWLEDGE SOLUTIONS PRIVATE LIMITED",
"MILAGROW NUTS PRIVATE LIMITED",
"MILAHA - QATAR SPIRIT",
"MILAHA SHIP MANAGEMENT INDIA PRIVATE LIMITED",
"MILAM SALES ENTERPRISES PRIVATE LIMITED",
"MILAN AGRO TECH COMPANY PRIVATE LIMITED",
"MILAN BUSINESS ASSOCIATES PRIVATE LIMITED",
"MILAN CATERERS PRIVATE LIMITED",
"MILAN COSMETICS PRIVATE LIMITED",
"MILAN DAIRY FOODS PRIVATE LIMITED",
"MILAN DECOR PRIVATE LIMITED",
"MILAN FOREX INDIA PRIVATE LIMITED",
"MILAN GINNING PRESSING PRIVATE LIMITED",
"MILAN HUMAN RESOURCES PRIVATE LIMITED",
"MILAN INFRASTRUCTURES AND DEVELOPERS PRIVATE LIMITED",
"MILAN INTERBUILT PRIVATE LIMITED",
"MILAN JEWELLERS",
"MILAN LABORATORIES INDIA PRIVATE LIMITED",
"MILAN PLAST PVT LTD",
"MILAN ROAD BUILDTECH LLP",
"MILAN SUPARI COMPANY PRIVATE LIMITED",
"MILAN TRADELINK PRIVATE LIMITED",
"MILAN TRANSPORT COMPANY PRIVATE LIMITED",
"MILAND HOSPITALITY PRIVATE LIMITED",
"MILANDO FASHIONS LIMITED",
"MILANN HOSPITAL",
"MILANO BATHROOM FITTINGS PRIVATE LIMITED",
"MILANO ICE CREAM PRIVATE LIMITED",
"MILANO IMPEX PRIVATE LIMITED",
"MILANYA FOOTPRINTS PRIVATE LIMITED",
"MILAP ESTATE PRIVATE LIMITED",
"MILAP LOGISTICS PRIVATE LIMITED",
"MILAP MACHINES (I) PRIVATE LIMITED",
"MILAP POLYMERS PRIVATE LIMITED",
"MILAP TRADELINK PRIVATE LIMITED",
"MILAZE AUTOTECH PRIVATE LIMITED",
"MILBAN MOULDS PVT LTD",
"MILCENT APPLIANCES PRIVATE LIMITED",
"MIL-COTS SYSTEMS INDIA PRIVATE LIMITED",
"MILDA BUILDWELL PRIVATE LIMITED",
"MILE DEEP WORKS PRIVATE LIMITED",
"MILE RUN INDIA PRIVATE LIMITED",
"MILEAGE ACTIVE WEAR PRIVATE LIMITED",
"MILEAGE ADVERTISING SERVICES PVT LTD",
"MILEAGE COMMUNICATIONS INDIA PRIVATE LIMITED.",
"MILEAGE LOGISTICS PRIVATE LIMITED",
"MILEAGE PROPERTIES PRIVATE LIMITED",
"MILECON ENGINEERING PRIVATE LIMITED",
"MILENIUM TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"MILES EDUCATION PRIVATE LIMITED",
"MILES VOYAGES AND HOLIDAYS PRIVATE LIMITED",
"MILESH MARINE EXPORTS PRIVATE LIMITED",
"MILESTONE ALUMINIUM COMPANY PRIVATE LIMITED",
"MILESTONE BOOKS PRIVATE LIMITED",
"MILESTONE BRANDCOM PRIVATE LIMITED",
"MILESTONE BUILDCON PRIVATE LIMITED",
"MILESTONE CAPITAL ADVISORS LIMITED",
"MILESTONE CAPITAL ADVISORS PRIVATE LIMITED",
"MILESTONE CEMENT PRODUCTS PRIVATE LIMITED",
"MILESTONE DWELLERS PRIVATE LIMITED",
"MILESTONE EARTHCON PRIVATE LIMITED",
"MILESTONE ELECTRONICS PRIVATE LIMITED",
"MILESTONE ENGINEERING PRIVATE LIMITED",
"MILESTONE EVENTMANAGEMENT LIMITED",
"MILESTONE EXIMP PRIVATE LIMITED",
"MILESTONE FINANCIAL ADVISORY PRIVATE LIMITED",
"MILESTONE FINVEST LIMITED",
"MILESTONE GEARS PRIVATE LIMITED",
"MILESTONE GLOBAL LIMITED.",
"MILESTONE GROUP INTERIOR SOLUTIONS PRIVATE LIMITED",
"MILESTONE HOLDINGS & INFRASTRUCTURE PRIVATE LIMITED",
"MILESTONE HOME DECOR PRIVATE LIMITED",
"MILESTONE INTEGRATED SERVICES PRIVATE LIMITED",
"MILESTONE INTERNET MARKETING PVT. LTD",
"MILESTONE LOGISTICS PRIVATE LIMITED",
"MILESTONE MEGA CITY PRIVATE LIMITED",
"MILESTONE MERCANDISE PRIVATE LIMITED",
"MILESTONE PLASTICS PRIVATE LIMITED",
"MILESTONE PLM SOLUTIONS PRIVATE LIMITED",
"MILESTONE PLOTDEVELOPERS PRIVATE LIMITED",
"MILESTONE PRAKRITI PRIVATE LIMITED",
"MILESTONE PRESERVATIVES PRIVATE LIMITED",
"MILESTONE PROESTATE INDIA PRIVATE LIMITED",
"MILESTONE REALCON LIMITED",
"MILESTONE RIVER VENTURE ADVISORY PRIVATE LIMITED",
"MILESTONE SOLUTIONS PRIVATE LIMITED",
"MILESTONE SPACE",
"MILESTONE SYSTEMS INDIA PRIVATE LIMITED",
"MILESTONE TECHNOCONSULTING PRIVATE LIMITED",
"MILESTONE TECHNOLOGIES PRIVATE LIMITED",
"MILESTONE TRADELINKS PRIVATE LIMITED",
"MILESTONE TRUSTEESHIP SERVICES PRIVATE LIMITED",
"MILESTONE TUBES PRIVATE LIMITED",
"MILESTONE UTILITY SERVICES PRIVATE LIMITED",
"MILESTONE WORLDWIDE FREIGHT SOLUTIONS PRIVATE LIMITED",
"MILESTONE X-PROTECT INDIA PRIVATE LIMITED",
"MILESTONES SWITCHGEARS PRIVATE LIMITED",
"MILESTONES TO MEMORIES PRIVATE LIMITED",
"MILESWEB INTERNET SERVICES PRIVATE LIMITED",
"MILGARD SERVICES INDIA PRIVATE LIMITED",
"MILHARD SALES PRIVATE LIMITED",
"MILI CONSULTANTS AND INVESTMENT PVT LTD",
"MILI MAINTENANCE AND CARE PRIVATE LIMITED",
"MILI STEELS PRIVATE LIMITED",
"MILIND COLLEGE OF ARTS",
"MILIND ELECTRICALS PVT LTD",
"MILIND MADHANI SECURITIES PRIVATE LIMITED",
"MILIND MADHYAMIK V UCHHA MADHYAMIK VIDYALAY",
"MILIND POLYCHEM PRIVATE LIMITED",
"MILIND UDAY PRIMARY SCHOOL",
"MILITARY COLLEGE OF ELECTRONICS AND MECHANICAL ENGINEERING SECUNDERABAD",
"MILITARY COLLEGE OF TELECOMMUNICATION ENGINEERING",
"MILITARY DENTAL CENTRE",
"MILITARY ENGINEER SERVICES",
"MILITARY HOSPITAL AGRA CANTT",
"MILITARY HOSPITAL AHMEDABAD",
"MILITARY HOSPITAL AHMEDNAGAR",
"MILITARY HOSPITAL ALWAR",
"MILITARY HOSPITAL BHOPAL",
"MILITARY HOSPITAL DEHRADUN",
"MILITARY HOSPITAL GOLCONDA",
"MILITARY HOSPITAL JALANDHAR",
"MILITARY HOSPITAL KAMPTEE",
"MILITARY HOSPITAL MHOW",
"MILITARY HOSPITAL PULGOAN CAMP",
"MILITARY HOSPITAL ROORKEE",
"MILK INFOTECH PRIVATE LIMITED",
"MILK MANTRA DAIRY PRIVATE LIMITED",
"MILKAM FOODS PRIVATE LIMITED",
"MILKIN EDIT FURNITURE PRIVATE LIMITED",
"MILKLANE DAIRY SERVICES PRIVATE LIMITED",
"MILKLEY FOOD & BEVERAGES INDIA PRIVATE LIMITED",
"MILKY FASHION CLOTHES PRIVATE LIMITED",
"MILKY INVESTMENT AND TRADING COMPANY",
"MILKY MILK PROCESSORS (INDIA) PRIVATE LIMITED",
"MILKY MIST DAIRY FOOD PRIVATE LIMITED",
"MILKY PURE FOODS PRIVATE LIMITED",
"MILKY WAY RESORTS PRIVATE LIMITED",
"MILKYFARM NUTRITION PRIVATE LIMITED",
"MILKYPLUS FOODS PRIVATE LIMITED",
"MILKYWAY PACKAGING PRIVATE LIMITED",
"MILL GEARS PRIVATE LIMITED",
"MILLANIUM TECHNOLOGIES PVT LTD",
"MILLARD TREXIM INDIA PRIVATE LIMITED",
"MILLAT NURSING HOME",
"MILLBONT PHARMACEUTICAL PRIVATE LIMITED",
"MILLBORN SWITCHGEARS PRIVATE LIMITED",
"MILLENIA GLOBAL PRIVATE LIMITED",
"MILLENIAL FOODS PRIVATE LIMITED",
"MILLENIUM AMUSEMENT PARK PRIVATE LIMITED",
"MILLENIUM BEST FOODS PRIVATE LIMITED",
"MILLENIUM BUILDHOME PRIVATE LIMITED",
"MILLENIUM CEMENT COMPANY PRIVATE LIMITED",
"MILLENIUM EXIM PRIVATE LIMITED",
"MILLENIUM FOREX PRIVATE LIMITED",
"MILLENIUM GRANITES AND MARBLES PRIVATE LIMITED",
"MILLENIUM INFRATECH PRIVATE LIMITED",
"MILLENIUM LEISURE HOSPITALITY SERVICES PRIVATE LIMITED",
"MILLENIUM MARBLES PRIVATE LIMITED",
"MILLENIUM MARINE & LOGISTICS SEVICES PRIVATE LIMITED",
"MILLENIUM PACKAGING SOLUTIONS LIMITED",
"MILLENIUM PAPER PRODUCTS",
"MILLENIUM PLASTIPACK PRIVATE LIMITED",
"MILLENIUM REAL INFRA PRIVATE LIMITED",
"MILLENIUM ROAD CONSTRUCTION PRIVATE LIMI TED",
"MILLENIUM STEEL INDIA PRIVATE LIMITED",
"MILLENIUM SYNERGY (GUJRAT) PRIVATE LIMITED",
"MILLENIUM SYNERGY PRIVATE LIMITED",
"MILLENNIA CERAMICA PRIVATE LIMITED",
"MILLENNIA DEVELOPERS PRIVATE LIMITED",
"MILLENNIA HI-TECH SYSTEMS PRIVATE LIMITED",
"MILLENNIA LOOMS PRIVATE LIMITED",
"MILLENNIA MEDIA NETWORK PRIVATE LIMITED",
"MILLENNIA REALTORS PRIVATE LIMITED",
"MILLENNIA TRANSPORT CORPORATION PRIVATE LIMITED",
"MILLENNIA VENTURES AND PROJECTS INDIA PRIVATE LIMITED",
"MILLENNIAL HOSPITALITY VENTURES PRIVATE LIMITED",
"MILLENNIAL LIVING PRIVATE LIMITED",
"MILLENNIAL SOURCING PRIVATE LIMITED",
"MILLENNIUM AERO DYNAMICS PRIVATE LIMITED",
"MILLENNIUM AUTOMATION PRIVATE LIMITED",
"MILLENNIUM BABYCARES PRIVATE LIMITED",
"MILLENNIUM BOARDS PRIVATE LIMITED",
"MILLENNIUM BOOK SOURCE PRIVATE LIMITED",
"MILLENNIUM CERA TILES PRIVATE LIMITED",
"MILLENNIUM CITY EXPRESSWAYS PRIVATE LIMITED",
"MILLENNIUM CONSTRUCTION PRIVATE LIMITED",
"MILLENNIUM CONSULTING INDIA PRIVATE LIMITED",
"MILLENNIUM EDUCATION MANAGEMENT PRIVATE LIMITED",
"MILLENNIUM ENGINEERS AND CONTRACTORS PRIVATE LIMITED",
"MILLENNIUM FINANCE LIMITED",
"MILLENNIUM FORGING PRIVATE LIMITED",
"MILLENNIUM FREIGHT FORWARDERS PRIVATE LIMITED",
"MILLENNIUM GLOBAL SERVICES PRIVATE LIMITED",
"MILLENNIUM GOLD PRIVATE LIMITED",
"MILLENNIUM GRANITO INDIA PRIVATE LIMITED",
"MILLENNIUM HERBAL CARE LIMITED",
"MILLENNIUM HYPERMARKET PRIVATE LIMITED",
"MILLENNIUM IMPEX PRIVATE LIMITED",
"MILLENNIUM INFRA CONSTRUCTIONS PRIVATE LIMITED",
"MILLENNIUM INFRAENGINEERS PRIVATE LIMITED",
"MILLENNIUM INSTRUMENTS LIMITED",
"MILLENNIUM JEWELLERY PRIVATE LIMITED",
"MILLENNIUM LANDMARKS PRIVATE LIMITED",
"MILLENNIUM LIFE STYLE PRIVATE LIMITED",
"MILLENNIUM LOGITRANS INDIA PRIVATE LIMITED",
"MILLENNIUM MARMO AND GRANITES PRIVATE LIMITED",
"MILLENNIUM MEDISOLUTIONS PRIVATE LIMITED",
"MILLENNIUM METALLOYS PRIVATE LIMITED",
"MILLENNIUM MULTI TRADE PRIVATE LIMITED",
"MILLENNIUM NATIONAL SCHOOL",
"MILLENNIUM POOLS PRIVATE LIMITED",
"MILLENNIUM POOLS PVT. LTD.",
"MILLENNIUM PRECISION AUTO INDIA PRIVATE LIMITED",
"MILLENNIUM PROPERTIES PRIVATE LIMITED",
"MILLENNIUM RED DOT PRIVATE LIMITED",
"MILLENNIUM RUBBER TECHNOLOGIES PRIVATE LIMITED",
"MILLENNIUM SEMI CONDUCTORS",
"MILLENNIUM SEMICONDUCTORS INDIA PRIVATE LIMITED",
"MILLENNIUM SILICON SERVICES INDIA PRIVATE LIMITED",
"MILLENNIUM SOFTWARE PRODUCTIONS INDIA PRIVATE LIMITED",
"MILLENNIUM SOFTWARE SOLUTIONS PRIVATE LIMITED",
"MILLENNIUM SPECIAL LAB PRIVATE LIMITED",
"MILLENNIUM STARCH INDIA PRIVATE LIMITED",
"MILLENNIUM STOCK BROKING PRIVATE LIMITED",
"MILLENNIUM SUPPLIERS PVT LTD",
"MILLENNIUM TECHNOLOGY PRIVATE LIMITED",
"MILLENNIUM TECHNOSOFT LIMITED",
"MILLENNIUM TECHNOSOFT PRIVATE LIMITED",
"MILLENNIUM TECHNOTOOLS PRIVATE LIMITED",
"MILLENNIUM TELECOM LIMITED",
"MILLENNIUM WRITING PRODUCTS PRIVATE LIMITED",
"MILLENNIUMPARK HOLDINGS PRIVATE LIMITED",
"MILLER GROUNDBREAKING INDIA PRIVATE LIMITED",
"MILLERMAN ORGANIC PRIVATE LIMITED",
"MILLET EXPRESS FOODS PRIVATE LIMITED",
"MILLI AL AMIN COLLEGE",
"MILLI AL-AMEER COLLEGE",
"MILLI TRUST",
"MILLIA TRADING PVT LTD",
"MILLICON CONSULTANT ENGINEERS PRIVATE LIMITED",
"MILLIKEN CHEMICAL AND TEXTILE (INDIA) CO PRIVATE LIMITED",
"MILLIMAN INDIA PRIVATE LIMITED",
"MILLINIUM TOWNSHIP PRIVATE LIMITED",
"MILLION CERAMIC",
"MILLION MINDS INFOTECH PRIVATE LIMITED",
"MILLION PAPIER PRIVATE LIMITED",
"MILLION SPARKS FOUNDATION",
"MILLION SWITCH GEARS PRIVATE LIMITED",
"MILLION TALENTS INDIA PRIVATE LIMITED",
"MILLION-AIR JETS PRIVATE LIMITED",
"MILLIONAIRE DEVELOPERS",
"MILLIONAIRE FASHION PRIVATE LIMITED",
"MILLIONAIRE HEALTH PRIVATE LIMITED",
"MILLIONS KART PRIVATE LIMITED",
"MILLITREK TECHNOLOGIES PRIVATE LIMITED",
"MILLMAN (INDIA) PRIVATE LIMITED",
"MILLS STORE COMPANY (DELHI) PRIVATE LIMITED",
"MILLTEC MACHINERY PRIVATE LIMITED",
"MILLWARD BROWN MARKET RESEARCH SERVICES INDIA PRIVATE LIMITED",
"MILLWRIGHT ENGINEERING PRIVATE LIMITED",
"MILMAN THIN FILM SYSTEMS PRIVATE LIMITED",
"MILON AGROVET PRIVATE LIMITED",
"MILONI CONSULTANTS PRIVATE LIMITED",
"MILONI ENTERPRISE LIMITED",
"MILORE INFRAPROJECTS PRIVATE LIMITED",
"MILROC GOOD EARTH DEVELOPERS",
"MILSHA AGRO EXPORTS PRIVATE LIMITED",
"MILSPEED INDIA PRIVATE LIMITED",
"MILSTAR RF & MICROWAVE SYSTEMS PRIVATE LIMITED",
"MILTON CHEMICALS PVT LTD",
"MILTON CYCLE INDUSTRIES LIMITED",
"MILTON ELEVATOR PRIVATE LIMITED",
"MILTON EXPORTS PVT LTD",
"MILTON GENERIC PRIVATE LIMITED",
"MILTON INDUSTRIES LIMITED",
"MILTON LIFECARE PRIVATE LIMITED",
"MILTON MEDICARE PRIVATE LIMITED",
"MILTON PRODUCTS INDIA PRIVATE LIMITED",
"MILTONROY INDIA PRIVATE LIMITED",
"MILTSAAR ENTERTAINMENTS PRIVATE LIMITED",
"MILVIK TECHNOLOGY SERVICES INDIA PRIVATE LIMITED",
"MILVIRTAN EXPORTS PRIVATE LIMITED",
"MILWAUKEE ELECTRONICS INDIA PRIVATE LIMITED",
"MIM ADVISORS PRIVATE LIMITED",
"MIM PETRO WORLD PRIVATE LIMITED",
"MIMA TRADERS PVT LTD",
"MIMAKI INDIA PRIVATE LIMITED",
"MIMANI AGRO PRODUCTS PRIVATE LIMITED",
"MIMANI WIRES PRIVATE LIMITED",
"MIMANSA INDUSTRIES PRIVATE LIMITED",
"MIMANSA RISK CONSULTING (OPC) PRIVATE LIMITED",
"MIMANSA SOFTWARE SYSTEMS PVT LTD",
"MIMAXX ELECTRONICS PRIVATE LIMITED",
"MIMEC ELECTRONICS PRIVATE LIMITED",
"MIMER MEDICAL COLLEGE TALEGAON",
"MIMEX INDIA PRIVATE LIMITED",
"MIMHANS PRIVATE LIMITED",
"MIMICS EAST TECHNOLOGIES PRIVATE LIMITED",
"MIMKART FASHION PRIVATE LIMITED",
"MIMOSA HOSPITALITY PRIVATE LIMITED",
"MIMOTO TECHNOLOGIES PRIVATE LIMITED",
"MIMOZA ENTERPRISES FINANCE PRIVATE LIMITED",
"MIMS BUILDERS PRIVATE LIMITED",
"MIMS INFRASTRUCTURE AND PROPERTIES PRIVATE LIMITED",
"MIMSR MEDICAL COLLEGE LATUR",
"MIMSYS TECHNOLOGIES PRIVATE LIMITED",
"MIN MEC CONSULTANCY PRIVATE LIMITED",
"MIN OF FINANCE",
"MIN OF HANDICRAPPED FIN DEVELOPMENT C",
"MIN OF RAILWAY",
"MIN OF RURAL DEVELOPMENT",
"MIN TOY PRIVATE LIMITED",
"MINA INSTITUTE OF ENGINEERING AND TECHNOLOGY FOR WOMEN",
"MINA SAREE PRIVATE LIMITED",
"MINAEAN HABITAT INDIA PRIVATE LIMITED",
"MINAGOLD JEWELS PRIVATE LIMITED",
"MINAKSHI COTTON PRIVATE LIMITED",
"MINAKSHI FASHIONS PVT LTD",
"MINAKSHI SOLVEX LLP",
"MINAL AAC INDUSTRIES AND CONTRACTORS PRIVATE LIMITED",
"MINAL FINANCES PRIVATE LIMITED",
"MINAL INDUSTRIES LIMITED",
"MINAL INFOJEWELS LIMITED",
"MINAL PUBLICATION AND PRODUCTION PRIVATE LIMITED",
"MINAL WAREHOUSING PRIVATE LIMITED",
"MINAMI METALS PRIVATE LIMITED",
"MINAQUA INTERNATIONAL PRIVATE LIMITED",
"MINAR AGRO PRIVATE LIMITED",
"MINAR ALLOYS AND FORGINGS PRIVATE LIMITED",
"MINAR BUILDERS PRIVATE LIMITED",
"MINAR CASTINGS PRIVATE LIMITED",
"MINAR FLOORINGS AND SANITARIES PRIVATE LIMITED",
"MINAR GOLD PRIVATE LIMITED",
"MINAR ISPAT PRIVATE LIMITED",
"MINAR PREFAB PVT LTD",
"MINAR RECLAIMATION PRIVATE LIMITED",
"MINAR RENEWABLE ENERGY PROJECTS PRIVATE LIMITED",
"MINAR TRAVELS INDIA PRIVATE LIMITED",
"MINAR URDU HIGH SCHOOL PATEL NAGAR LATUR",
"MINAR YARNS PRIVATE LIMITED",
"MINARCH OVERSEAS PRIVATE LIMITED",
"MINARTECH DEVELOPERS PRIVATE LIMITED",
"MINATI PROCON PRIVATE LIMITED",
"MINAWALA GEMS AND JEWELS PRIVATE LIMITED",
"MINAXI MULTI-PRODUCT (INDIA) PRIVATE LIMITED",
"MINAXI TEXTILES LIMITED",
"MINAZ INTER TRADE PRIVATE LIMITED",
"MINC BILLBOX PVT LTD",
"MINCA CALCINATION PRIVATE LIMITED",
"MINCHEM IMPEX INDIA PVT LTD",
"MINCO INDIA FLOW ELEMENTS PRIVATE LIMITED",
"MINCO INDIA PVT LTD",
"MINCO MALVERN PROCESS EQUIPMENT PRIVATE LIMITED",
"MINCO TECH (INDIA) PRIVATE LIMITED",
"MINCORE RESOURCES PRIVATE LIMITED",
"MINCORP RESOURCES PRIVATE LIMITED",
"MIND & MATTER MARKETING SOLUTIONS PRIVATE LIMITED",
"MIND DESIGN MARKETING AND COMMUNICATION PRIVATE LIMITED",
"MIND EDUTAINMENT PRIVATE LIMITED",
"MIND ENGINEERING DESIGN INDIA PRIVATE LIMITED",
"MIND INFO SERVICES PRIVATE LIMITED",
"MIND INVENTORY",
"MIND ITSYS PRIVATE LIMITED",
"MIND KRAFT IT SOLUTIONS PRIVATE LIMITED",
"MIND LEADERS LEARNING INDIA PRIVATE LIMITED",
"MIND LEASE SERVICES PRIVATE LIMITED",
"MIND LOGIC SYSTEMS PRIVATE LIMITED",
"MIND MAKERS COMMUNICATIONS PRIVATE LIMITED",
"MIND MATRIX IT SERVICES PRIVATE LIMITED",
"MIND MENTOR",
"MIND MERCHANT GLOBAL PRIVATE LIMITED",
"MIND PLUS HEALTHCARE PRIVATE LIMITED",
"MIND POWER FINANCIAL CONSULTANTS PRIVATE LIMITED",
"MIND Q SYSTEMS PRIVATE LIMITED",
"MIND ROOTS PRIVATE LIMITED",
"MIND SEARCH CONSULTANTS PRIVATE LIMITED",
"MIND SHAPER TECHNOLOGIES PRIVATE LIMITED",
"MIND SHELL INFOTECH PRIVATE LIMITED",
"MIND SPACE ESTATES PRIVATE LIMITED",
"MIND SPACE REALTY PRIVATE LIMITED",
"MIND TECHNOLOGIES PRIVATE LIMITED",
"MIND TREE EDUVATION PRIVATE LIMITED",
"MINDA AUTO COMPONENTS LIMITED",
"MINDA AUTOELEKTRIK LIMITED",
"MINDA AUTOMOTIVE SOLUTIONS LIMITED",
"MINDA CAPITAL PRIVATE LIMITED",
"MINDA CORPORATION LIMITED",
"MINDA DISTRIBUTION AND SERVICES LIMITED",
"MINDA I CONNECT PRIVATE LIMITED",
"MINDA INSTRUMENTS LIMITED",
"MINDA INVESTMENTS LIMITED",
"MINDA KOSEI ALUMINUM WHEEL PRIVATE LIMITED",
"MINDA KYORAKU LIMITED",
"MINDA MANAGEMENT SERVICES LIMITED",
"MINDA NABTESCO AUTOMOTIVE PRIVATE LIMITED",
"MINDA NEXGEN TECH LIMITED",
"MINDA NEXGENTECH LIMITED",
"MINDA ONKYO INDIA PRIVATE LIMITED",
"MINDA PROJECTS LIMITED",
"MINDA SILCA ENGINEERING PRIVATE LIMITED",
"MINDA STORAGE BATTERIES PRIVATE LIMITED",
"MINDA TG RUBBER PRIVATE LIMITED",
"MINDA VAST ACCESS SYSTEMS PRIVATE LIMITED",
"MINDA WESTPORT TECHNOLOGIES LIMITED",
"MINDAGE REALTY PRIVATE LIMITED",
"MIND-A-MEND CONSULTANCY PRIVATE LIMITED",
"MINDARIKA PRIVATE LIMITED",
"MINDARRAY SYSTEMS PRIVATE LIMITED",
"MINDBLAZE SOLUTIONS PRIVATE LIMITED",
"MINDBODY SOFTWARE PRIVATE LIMITED",
"MINDBOWSER INFOSOLUTIONS PRIVATE LIMITED",
"MINDBOX ANALYTICS PRIVATE LIMITED",
"MINDBRIDGE BUSINESS SOLUTIONS PRIVATE LIMITED",
"MINDCHAMPION LEARNING SYSTEM",
"MINDCOM CONSULTING SERVICES PRIVATE LIMITED",
"MINDCOMP PROPERTIES PRIVATE LIMITED",
"MINDCOMP REGENCY PARK PRIVATE LIMITED",
"MINDCOMP TECH PARK PRIVATE LIMITED",
"MINDCRAFT SOFTWARE PRIVATE LIMITED",
"MINDCREST INDIA PRIVATE. LIMITED",
"MINDCREW TECHNOLOGIES PRIVATE LIMITED",
"MINDCURV TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"MINDDEFFT TECHNOLOGIES PRIVATE LIMITED",
"MINDEDGE SOLUTIONS PRIVATE LIMITED",
"MINDEED TECHNOLOGIES AND SERVICES PRIVATE LIMITED",
"MINDERA INDIA PRIVATE LIMITED",
"MINDFIELD RESEARCH SERVICES PRIVATE LIMITED",
"MINDFIELDS CONSULTING PRIVATE LIMITED",
"MINDFIN SER PRIVATE LIMITED",
"MINDFIRE SOLUTIONS",
"MINDFORCE RESEARCH AND HIRING SOLUTIONS PRIVATE LIMITED",
"MINDFUL COOK PRIVATE LIMITED",
"MINDGATE SOLUTIONS PRIVATE LIMITED",
"MINDGENIX PRIVATE LIMITED",
"MINDGRAPH TECHNOLOGIES PRIVATE LIMITED",
"MINDGRID TECHNOLOGIES PRIVATE LIMITED",
"MINDIII SYSTEMS PRIVATE LIMITED",
"MINDLABS SYSTEMS PRIVATE LIMITED",
"MINDLESS PANDORA TECH SOLUTIONS PRIVATE LIMITED",
"MINDLINKS SOLUTION INDIA PRIVATE LIMITED",
"MINDMAP ADVANCE RESEARCH PRIVATE LIMITED",
"MINDMAP LEARNING LLP",
"MINDMILIEU (OPC) PRIVATE LIMITED",
"MINDMILL SOFTWARE LIMITED",
"MINDNERVES TECHNOLOGY SERVICES PRIVATE LIMITED",
"MINDPATH TECH PRIVATE LIMITED",
"MINDPOOL MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"MINDPOOL TECHNOLOGIES LIMITED",
"MINDPOOL TECHNOLOGIES PRIVATE LIMITED",
"MINDPOWER FINSOURCE SERVICES PRIVATE LIMITED",
"MINDPRO INFORMATION SYSTEMS PRIVATE LIMITED",
"MINDPRO TECHNOLOGIES PRIVATE LIMITED",
"MINDQUAD SOLUTIONS PRIVATE LIMITED",
"MINDRAY MEDICAL INDIA PRIVATE LIMITED",
"MINDRILL SYSTEMS & SOLUTIONS PRIVATE LIMITED",
"MINDROPS SOLUTIONS PRIVATE LIMITED",
"MINDS ARTIFICIAL INTELLIGENCE TECHNOLOGIES PRIVATE LIMITED",
"MINDS CREATIVE SOLUTIONS PRIVATE LIMITED",
"MINDSARRAY NETWORK PRIVATE LIMITED",
"MINDSARRAY TECHNOLOGIES PRIVATE LIMITED",
"MINDSET EXPERIENCE INDIA PRIVATE LIMITED",
"MINDSET SECURITIES PRIVATE LIMITED",
"MINDSHAFT MEDIA PRIVATE LIMITED",
"MINDSHARE UNITED FOUNDATION",
"MINDSHIFT INTERACTIVE PRIVATE LIMITED",
"MINDSIGHT CLINIC",
"MINDSPACE BUSINESS PARKS PRIVATE LIMITED",
"MINDSPACE CONSULTANCY SERVICES PRIVATE LIMITED",
"MINDSPACE OUTSOURCING SERVICES PRIVATE LIMITED",
"MINDSPACE SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"MINDSPAN BRANDCOM PRIVATE LIMITED",
"MINDSPEED TECHNOLOGIES INDIA PRIVATE LIMITED",
"MINDSPHERE CONSULTING PRIVATE LIMITED",
"MINDSPRIGHT REAL ESTATE PRIVATE LIMITED",
"MINDSPRIGHT SOLUTIONS PRIVATE LIMITED",
"MINDSPRINGS (INDIA) PRIVATE LIMITED",
"MINDSPRINT DIGITAL INDIA PRIVATE LIMITED",
"MINDSQUARE TECHNOLOGIES INDIA PRIVATE LIMITED",
"MINDSTEC DISTRIBUTION PRIVATE LIMITED",
"MINDSTIX SOFTWARE LABS PRIVATE LIMITED",
"MINDSTORM DIGITAL MARKETING PRIVATE LIMITED",
"MINDSTUDIO PRIVATE LIMITED",
"MINDTECH COMPUSOFT PRIVATE LIMITED",
"MINDTECH SOLUTIONS PRIVATE LIMITED",
"MINDTECK INDIA LIMITED",
"MINDTICKLE INTERACTIVE MEDIA PRIVATE LIMITED",
"MINDTREE LIMITED",
"MINDWARE OUTSOURCING PRIVATE LIMITED",
"MINDWAVE HEALTHCARE PRIVATE LIMITED",
"MINDWAVE SYSTEMS PRIVATE LIMITED",
"MINDWORKS GLOBAL MEDIA SERVICES PRIVATE LIMITED",
"MINDWORKS TALENT MANAGEMENT PRIVATE LIMITED",
"MINDWORX SOFTWARE SERVICES PRIVATE LIMITED",
"MINDZ N MINDS PRIVATE LIMITED",
"MINDZCLOUD TECHNOLOGIES PRIVATE LIMITED",
"MINDZVUE TECHNOLOGIES PRIVATE LIMITED",
"MINE AID PRODUCTS PRIVATE LIMITED",
"MINE ENERGY PRIVATE LIMITED",
"MINE LINE PRIVATE LIMITED",
"MINEBEA INTEC INDIA PRIVATE LIMITED",
"MINEBRAT PRIVATE LIMITED",
"MINECODES TECHNOLOGY PRIVATE LIMITED",
"MINECRAFT MINERALS PRIVATE LIMITED",
"MINEMECH ENGINEERING PRIVATE LIMITED",
"MINEPRO MINERALS PRIVATE LIMITED",
"MINERA STEEL & POWER PRIVATE LIMITED",
"MINERAL ENTERPRISES LIMITED",
"MINERAL ENTERPRISES PRIVATE LIMITED",
"MINERAL EXPLORATION AND CONSULTANCY LIMITED",
"MINERAL FASHIONS PRIVATE LIMITED",
"MINERAL OIL COMPANY PRIVATE LIMITED",
"MINERAL PROCESS EQUIPMENT PRIVATE LIMITED",
"MINERALIA IMPEX PRIVATE LIMITED",
"MINERALS & MINERALS LIMITED",
"MINERALS LAB SERVICES PRIVATE LIMITED",
"MINERALS MANAGEMENT SERVICES (INDIA) PRIVATE LIMITED",
"MINERALS TECHNOLOGIES INDIA PRIVATE LIMITED",
"MINERALX FLOWTECH PRIVATE LIMITED",
"MINERIA ALLOYS PRIVATE LIMITED",
"MINERVA AUTO MOTORS PRIVATE LIMITED",
"MINERVA AUTOMOBILES PRIVATE LIMITED",
"MINERVA BIOGENIX PRIVATE LIMITED",
"MINERVA CAPITAL PRIVATE LIMITED",
"MINERVA DIESEL ENGINES PRIVATE LIMITED",
"MINERVA FLAVOURS AND FRAGRANCES PRIVATE LIMITED",
"MINERVA INDIA ADVISORS PRIVATE LIMITED",
"MINERVA MEDICAL TREATMENT PRIVATE LIMITED",
"MINERVA MERCHANDISING COMPANY PRIVATE LIMITED",
"MINERVA PADDY PROCESSING PVT LTD",
"MINERVA POULTRY PRIVATE LIMITED",
"MINERVA PUBLIC SCHOOL",
"MINERVA TECHNOLOGY SOLUTIONS LIMITED",
"MINESCAPE AND KADAR ORES PRIVATE LIMITED",
"MINESCAPE MINERALS PRIVATE LIMITED",
"MINESOURCE INDIA PRIVATE LIMITED",
"MINESTONE EXPORTS PRIVATE LIMITED",
"MINETRACK PRIVATE LIMITED",
"MINEX INFRACON PRIVATE LIMITED",
"MINEX LOGISTICS PRIVATE LIMITED",
"MINEX METALLURGICAL COMPANY LIMITED",
"MINFY TECHNOLOGIES PRIVATE LIMITED",
"MINGHAO ELECTRONICS INDIA PRIVATE LIMITED",
"MINGO FOODS INDIA PRIVATE LIMITED",
"MINHA IMPORTS AND EXPORTS PRIVATE LIMITED",
"MINHAJ FOREX PRIVATE LIMITED",
"MINI BUILDERS PVT.LTD.",
"MINI CONSTRUCTION",
"MINI DIAMONDS (INDIA) LIMITED",
"MINI ELECTRONIC INDUSTRIES PVT LTD",
"MINI IRON & ALLOYS PRIVATE LIMITED",
"MINI IRON AND STEEL PRIVATE LIMITED",
"MINI MACHINE TOOLS INDIA PRIVATE LIMITED",
"MINI MAGIC CREATION PRIVATE LIMITED",
"MINI MELTS ICE CREAM INDIA PRIVATE LIMITED",
"MINI METERS MANUFACTURING COMPNAY PRIVATE LIMITED",
"MINI METRO EV LLP",
"MINI PUNJAB CATERING INDIA PRIVATE LIMITED",
"MINI SECRETARIAT PUNJAB",
"MINI SIGNS & DISPLAYS PRIVATE LIMITED",
"MINI WEAR EXPORT PRIVATE LIMITED",
"MINICRAFT ENTERPRISE PVT LTD",
"MINIFAB ENTERPRISES PRIVATE LIMITED",
"MINIKIN AGRO INDIA PRIVATE LIMITED",
"MINIL LABORATORIES PRIVATE LIMITED",
"MINILEC INDIA PRIVATE LIMITED",
"MINILEC PROTECTIVE RELAY PVT LTD",
"MINIMAC SYSTEMS PRIVATE LIMITED",
"MINIMALIST SOLUTIONS PRIVATE LIMITED",
"MINIMAX ADS PRIVATE LIMITED",
"MINIMAX ENGINEERS PRIVATE LIMITED",
"MINIMAX FINVEST PRIVATE LIMITED",
"MINIMAX METALS AND PLYWOOD PRIVATE LIMITED",
"MINIMAX PUMPS PRIVATE LIMITED",
"MINIMILL TECHNOLOGIES SERVICES INTERNATIONAL PRIVATE LIMITED",
"MINIMUM SHARES & SECURITIES PRIVATE LIMITED",
"MINING ASSOCIATES PRIVATE LIMITED",
"MINING EQUIPMENT AGENCIES PRIVATE LIMITED",
"MINING MATERIALL HANDLING EQUIPMENT PVT LTD",
"MINIO PRIVATE LIMITED",
"MINIONLABS INDIA PRIVATE LIMITED",
"MINIONS VENTURES PRIVATE LIMITED",
"MINISHA EXIM PRIVATE LIMITED",
"MINISO LIFE STYLE PRIVATE LIMITED",
"MINISTAR ENGINEERING PRIVATE LIMITED",
"MINISTER RAINWEAR PRIVATE LIMITED",
"MINISTER STAFF ESTABLISHMENT",
"MINISTER WHITE CLOTHING (A UNIT OF OTTO CLOTHING PVT LTD)",
"MINISTRY OF AGRICULTURE",
"MINISTRY OF AGRICULTURE & FARMERS WELFARE",
"MINISTRY OF ATOMIC ENERGY",
"MINISTRY OF CHEMICAL FERTILISERS",
"MINISTRY OF CIVIL AVIATION",
"MINISTRY OF COAL",
"MINISTRY OF COMMERCE",
"MINISTRY OF COMMUNICATION AND INFORMATION TECHNOLOGY",
"MINISTRY OF CORPORATE AFFAIRS",
"MINISTRY OF CULTURE",
"MINISTRY OF DEFENCE",
"MINISTRY OF DISINVESTMENT",
"MINISTRY OF EARTH SCIENCES",
"MINISTRY OF EDUCATION",
"MINISTRY OF ELECTRONICS",
"MINISTRY OF ENVIRONMENT AND FORESTS",
"MINISTRY OF EXTERNAL AFFAIRS",
"MINISTRY OF FINANCE CENTRAL GOVT",
"MINISTRY OF FINANCE INCOME TAX DEPARTMENT",
"MINISTRY OF HEALTH AND FAMILY WELFARE",
"MINISTRY OF HOME AFFAIRS",
"MINISTRY OF HOUSING AND URBAN AFFAIRS",
"MINISTRY OF HUMAN RESOURCE DEVELOPM",
"MINISTRY OF I B",
"MINISTRY OF INDUSTRY",
"MINISTRY OF INFORMATION AND BROADCASTING",
"MINISTRY OF INFORMATION BROADCAST",
"MINISTRY OF JAL SHAKTI DEPARTMENT OF WATER RESOURCES",
"MINISTRY OF LAW AND JUSTICE",
"MINISTRY OF MINES",
"MINISTRY OF MINORITY AFFAIRS",
"MINISTRY OF MSME",
"MINISTRY OF OCEAN DEVELOPMENT",
"MINISTRY OF PANCHAYATI RAJ",
"MINISTRY OF PARLIAMENTARY AFFAIRS",
"MINISTRY OF PERSONNEL PUBLIC GRIEF",
"MINISTRY OF PETROLEUM NATURAL GAS",
"MINISTRY OF PLANNING",
"MINISTRY OF POWER",
"MINISTRY OF RAILWAYS",
"MINISTRY OF RAILWAYS GOV OF INDIA RAIL BHAWAN",
"MINISTRY OF SCIENCE TECHNOLOGY",
"MINISTRY OF SHIPPING",
"MINISTRY OF SMALL SCALE INDUSTRY AND AGR",
"MINISTRY OF SPACE",
"MINISTRY OF STATISTICS AND PI NATIONAL STATISCAL OFFICE FIELD OPERATION DIVISION",
"MINISTRY OF SURFACE TRANSPORT",
"MINISTRY OF TEXTILES",
"MINISTRY OF TOURISM",
"MINISTRY OF WATER RESOURCES",
"MINISTRY OF WOMEN & CHILD DEVELOPMENT",
"MINISTRY OFG PROGRAMME IMPLEMENTATI",
"MINIT ENGINEERS INDIA PRIVATE LIMITED",
"MINIT OVERSEAS PRIVATE LIMITED",
"MINITECHS AEROTOOLS PRIVATE LIMITED",
"MINITEK SYSTEMS INDIA PRIVATE LIMITED",
"MINIVEL SERVICES LLP",
"MINIX HOLDINGS PRIVATE LIMITED",
"MINJAR CLOUD SOLUTIONS PRIVATE LIMITED",
"MINJUR PANCHAYAT UNION ELEMENTARY",
"MINK HAIR & BEAUTY SALON PRIVATE LIMITED",
"MINKSUN AGRO PRIVATE LIMITED",
"MINMAT FERRO ALLOYS PRIVATE LIMITED",
"MINMET COMTRADE PRIVATE LIMITED",
"MINMET REFRACTORY SOLUTIONS PRIVATE LIMITED",
"MINOCHA ENTERPRISES PRIVATE LIMITED",
"MINOCHA METALS PRIVATE LIMITED",
"MINOGENIX PHARMA PRIVATE LIMITED",
"MINOL ACIDS AND CHEMICALS PVT LTD",
"MINOO CONTAINERS PRIVATE LIMITED",
"MINOP INNOVATIVE TECHNOLOGIES PVT LTD",
"MINOR HOTELS PRIVATE LIMITED",
"MINOR IRRIGATION DEPARTMENT",
"MINORI LABS PRIVATE LIMITED",
"MINORITY WELLFARE DIRECTORATE",
"MINOSHA INDIA LIMITED",
"MINOSHIMA INDIA PRIVATE LIMITED",
"MINOVA LIFE SCIENCES PRIVATE LIMITED",
"MINOVA RUNAYA PRIVATE LIMITED",
"MINOX METAL PRIVATE LIMITED",
"MINPRA INFRASTRUCTURES INDUSTRIES LIMITED",
"MINS TECHNOLOGIES PRIVATE LIMITED",
"MINSAN CHEMTEK INDIA PRIVATE LIMITED",
"MINSHA CHILDREN HOSPITAL",
"MINSOL LIMITED",
"MINSTER CONSULTING INDIA PRIVATE LIMITED",
"MINSTRY OF NON CONVENTIONAL ENERGY",
"MINSUB VENTURES PRIVATE LIMITED",
"MINSUN INFRAA PRROJECTS PRIVATE LIMITED",
"M-INSURE SERVICES PRIVATE LIMITED",
"MINT COMMODITY PRIVATE LIMITED",
"MINT DEVELOPERS PRIVATE LIMITED",
"MINT ENVIRON PRIVATE LIMITED",
"MINT FASHION PRIVATE LIMITED",
"MINT FOREX AND TRAVELS PRIVATE LIMITED",
"MINT INTEGRATED HEALTHCARE PRIVATE LIMITED",
"MINT INVESTMENTS LTD",
"MINT LIFE SCIENCES PRIVATE LIMITED",
"MINT LOGISTICS PRIVATE LIMITED",
"MINT LOGIX SOLUTIONS PRIVATE LIMITED",
"MINT PHARMACEUTICALS PRIVATE LIMITED",
"MINT PROPERTIES PRIVATE LIMITED",
"MINT RPO SERVICES PRIVATE LIMITED",
"MINT STEER INDIA FINANCIAL CONSULTANCY PRIVATE LIMITED",
"MINT STONE AND TILES PRIVATE LIMITED",
"MINTA CRUZ LANGUAGE ACADEMY LLP",
"MINTAGE STEELS LIMITED",
"MINTAP TECHNO SERVICES LLP",
"MINTECH GLOBAL PRIVATE LIMITED",
"MINTEL (CONSULTING) INDIA PRIVATE LIMITED",
"MINTER CSTECH PRIVATE LIMITED",
"MINTERGRAPH SYSTEMS PRIVATE LIMITED",
"MINTHOMEZ RETAIL INDIA PRIVATE LIMITED",
"MINTIFI FINSERVE PRIVATE LIMITED",
"MINTIFI PRIVATE LIMITED",
"MINTIN MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"MINTLOGIX SOLUTIONS PRIVATE LIMITED",
"MINTOAK INNOVATIONS PRIVATE LIMITED",
"MINTREE PREMIER LIFESTYLE & BEAUTY PRIVATE LIMITED",
"MINTU TEXTILE MILLS PVT LTD",
"MINTWALK FINTECH SERVICES PRIVATE LIMITED",
"MINU MARKETING PRIVATE LIMITED",
"MINUS30 PRIVATE LIMITED",
"MINUSCULE TECHNOLOGIES PRIVATE LIMITED",
"MINUTUS COMPUTING PRIVATE LIMITED",
"MINYSU RETAIL PRIVATE LIMITED",
"MIO DESIGN PRIVATE LIMITED",
"MIOT HOSPITAL",
"MIOT HOSPITALS PRIVATE LIMITED",
"MIOTA RESEARCH PRIVATE LIMITED",
"MIPA INFOTECH SOLUTIONS PRIVATE LIMITED",
"MIPADH ENGINEERS LIMITED",
"MIPL GCL INFRACONTRACT PRIVATE LIMITED",
"MIPL SOLUTIONS PRIVATE LIMITED",
"MIPOX ABRASIVES INDIA PRIVATE LIMITED",
"MIPS WEB SERVICES PRIVATE LIMITED",
"MIQ DIGITAL COMMERCIAL PRIVATE LIMITED",
"MIQ DIGITAL INDIA PRIVATE LIMITED",
"MIR CO BUILDERS PRIVATE LIMITED",
"MIR EDUTECH PRIVATE LIMITED",
"MIR HOLISTICS PRIVATE LIMITED",
"MIR REALTORS PRIVATE LIMITED",
"MIRA BHAYANDAR MUNCIPAL CORPORATION",
"MIRA CYCLES PVT LIMITED",
"MIRA ENERGY RESOURCES PRIVATE LIMITED",
"MIRA EXIM LIMITED",
"MIRA FINSTOCK PRIVATE LIMITED",
"MIRA GALAXY CARE AND CURE PRIVATE LIMITED",
"MIRA INDIA MANAGEMENT SERVICES PRIVATE LIMITED",
"MIRA INFORM PRIVATE LIMITED",
"MIRA KNITTING WORKS PVT LTD",
"MIRA LEATHER CONSULTANTS PVT LTD",
"MIRA LIFECARE PRIVATE LIMITED",
"MIRA MAHAL PREMISES MANAGEMENT PRIVATE LIMITED",
"MIRAAACLE THREAD MANUFACTURING PRIVATE LIMITED",
"MIRAACULOUS ABSEILING AND MANAGEMENT SOLUTIONS (OPC) PRIVATE LIMITED",
"MIRABEL ENTERTAINMENT PRIVATE LIMITED",
"MIRABEL TECHNOLOGIES INDIA PRIVATE LIMITED",
"MIRABELLE AGRO MANUFACTURING PRIVATE LIMITED",
"MIRABELLE COSMETICS PRIVATE LIMITED",
"MIRABILE VENTURES PRIVATE LIMITED",
"MIRABLE PRIVATE LIMITED",
"MIRACLE CABLES (INDIA ) PRIVATE LIMITED",
"MIRACLE CARS INDIA PRIVATE LIMITED",
"MIRACLE COATINGS PRIVATE LIMITED",
"MIRACLE CONTAINER PRIVATE LIMITED",
"MIRACLE CORO PLAST PRIVATE LIMITED",
"MIRACLE CORPORATE SOLUTIONS PRIVATE LIMITED",
"MIRACLE DEVCON PRIVATE LIMITED",
"MIRACLE DEVELOPERS & PROMOTERS PRIVATE LIMITED",
"MIRACLE DINE SERVICES PRIVATE LIMITED",
"MIRACLE ELECTRICAL SOLUTIONS INDIA PRIVATE LIMITED",
"MIRACLE ELECTRONIC DEVICES PRIVATE LIMITED",
"MIRACLE FERROCAST PRIVATE LIMITED",
"MIRACLE FOILS PRIVATE LIMITED",
"MIRACLE FOUNDATION INDIA",
"MIRACLE GRANITO PRIVATE LIMITED",
"MIRACLE HR SOLUTIONS PRIVATE LIMITED",
"MIRACLE INFRASTRUCTURE PRIVATE LIMITED",
"MIRACLE LIFESTYLE LIMITED",
"MIRACLE MEDICARE PRIVATE LIMITED",
"MIRACLE MOTORS I PRIVATE LIMITED",
"MIRACLE ORGANICS PRIVATE LIMITED",
"MIRACLE POOLS PRIVATE LIMITED",
"MIRACLE PRINT PACK PRIVATE LIMITED",
"MIRACLE RECLAIM RUBBER COIMBATORE PRIVATE LIMITED",
"MIRACLE SHIPPING DELHI PRIVATE LIMITED",
"MIRACLE SOFTWARE SYSTEMS (INDIA) PRIVATE LIMITED",
"MIRACLE STONES PRIVATE LIMITED",
"MIRACLE STONEX PRIVATE LIMITED",
"MIRACLE STUDIOS PRIVATE LIMITED",
"MIRACLE TECH DISTRIBUTORS PRIVATE LIMITED",
"MIRACLE TECH SECURITY PRIVATE LIMITED",
"MIRACLE TECHNOLOGIES",
"MIRACLE VENTURES PRIVATE LIMITED",
"MIRACLEAN TOOLS PRIVATE LIMITED",
"MIRACLEHEALTH SYSTEMS PRIVATE LIMITED",
"MIRACLES ACADEMY OF ARTS & MEDIA PRIVATE LIMITED",
"MIRACLES HOSPITAL",
"MIRACLEVISION INFOSOLUTIONS PRIVATE LIMITED",
"MIRACLON INDIA PRIVATE LIMITED",
"MIRACLUS ORTHOTECH PRIVATE LIMITED",
"MIRACOLO DRINKS PRIVATE LIMITED",
"MIRACULOUS HOSPITALITY PRIVATE LIMITED",
"MIRAE ASSET CAPITAL MARKETS INDIA PRIVATE LIMITED",
"MIRAE ASSET FINANCIAL SERVICES (INDIA) PRIVATE LIMITED",
"MIRAE ASSET FOUNDATION",
"MIRAE ASSET INVESTMENT MANAGERS INDIA PRIVATE LIMITED",
"MIRAE ASSET TRUSTEE COMPANY PRIVATE LIMITED",
"MIRAE ASSET VENTURE INVESTMENTS (INDIA) PRIVATE LIMITED",
"MIRAE CONSTRUCTION INDIA PRIVATE LIMITED",
"MIRAFRA SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"MIRAGE CLOTHING COMPANY PRIVATE LIMITED",
"MIRAGE HOTEL MUMBAI",
"MIRAGE HOTELS PRIVATE LIMITED",
"MIRAGE JEWELLERY PRIVATE LIMITED",
"MIRAGE MARBLE PRIVATE LIMITED",
"MIRAGE NETWORK PVT LTD",
"MIRAGE TOUGHENED GLASSES PRIVATE LIMITED",
"MIRAGGIO LIFESTYLES PRIVATE LIMITED",
"MIRAH DEKOR PRIVATE LIMITED",
"MIRAH HOSPITALITY & GOURMET SOLUTIONS PRIVATE LIMITED",
"MIRAH REALTORS PRIVATE LIMITED",
"MIRAI APPARRELS PRIVATE LIMITED",
"MIRAI BHAVISHY PRIVATE LIMITED",
"MIRAIGIRLS PRIVATE LIMITED",
"MIRAJ BUSINESS DEVELOPMENT PRIVATE LIMITED",
"MIRAJ CREATIONS PRIVATE LIMITED",
"MIRAJ DEVELOPERS LIMITED",
"MIRAJ DRYMIX PRIVATE LIMITED",
"MIRAJ ELECTRICAL AND MECHANICAL COMPANY PRIVATE LIMITED",
"MIRAJ ENTERTAINMENT LIMITED",
"MIRAJ HOTELS PRIVATE LIMITED",
"MIRAJ IMAGING CENTRE PRIVATE LIMITED",
"MIRAJ ENGINEERING SERVICES PRIVATE LIMITED",
"MIRAJ METALS",
"MIRAJ MIRACLE PRIVATE LIMITED",
"MIRAJ MULTI COLOUR PRIVATE LIMITED",
"MIRAJ MULTISERVICES PRIVATE LIMITED",
"MIRAJ PIPES AND FITTINGS PRIVATE LIMITED",
"MIRAJ PRODUCTS PRIVATE LIMITED",
"MIRAJ REALCON PRIVATE LIMITED",
"MIRAJ RETAILS PRIVATE LIMITED",
"MIRAJ STEELS PRIVATE LIMITED",
"MIRAKI TECHNOLOGIES PRIVATE LIMITED",
"MIRAKLE 5 AUTOMOBILES PRIVATE LIMITED",
"MIRAKLE COURIERS PRIVATE LIMITED",
"MIRAL HEALTH CARE PRIVATE LIMITED",
"MIRAMAC PROPERTIES PRIVATE LIMITED",
"MIRAMAR RESORTS PRIVATE LIMITED.",
"MIRAMBICA AGRO INDUSTRIES",
"MIRAN SOLUTIONS PRIVATE LIMITED",
"MIRANDA FEW TOOLS PRIVATE LIMITED",
"MIRANDA TOOLS",
"MIRAPRO INDIA PRIVATE LIMITED",
"MIRARBINDO ENGINEERING PRIVATE LIMITED",
"MIRAS PROPERTIES PRIVATE LIMITED",
"MIRAS SECURITY & FACILITIES SERVICES PRIVATE LIMITED",
"MIRASH INDUSTRIES PRIVATE LIMITED",
"MIRAT EXIM PRIVATE LIMITED",
"MIRAZ INSECTICIDES PRIVATE LIMITED",
"MIRAZ PAPTECH INDIA PRIVATE LIMITED",
"MIRAZ SECURITAS PRIVATE LIMITED",
"MIRC ELECTRONICS LIMITED",
"MIRC MEDIA AUDIENCE MEASUREMENT PRIVATE LIMITED",
"MIRCHI ADLABS PRIVATE LIMITED",
"MIRCHI E-COMMERCE PRIVATE LIMITED",
"MIRCHI WILD WINGS PRIVATE LIMITED",
"MIRCO DYNAMICS PRIVATE LIMITED",
"MIRCOM FIRE & COMMUNICATIONS (INDIA) PRIVATE LIMITED",
"MIRDEEP TRADING PRIVATE LIMITED",
"MIREEN INDUSTRIES PRIVATE LIMITED",
"MIREK THERMOFORMERS PRIVATE LIMITED",
"MIREYA FOODS PRIVATE LIMITED",
"MIRHA EXPORTS PRIVATE LIMITED",
"MIRHAE ENGINEERING INDIA PRIVATE LIMITED",
"MIRHATI BALIKA VIDYALAYA",
"MIRI INFOTECH PRIVATE LIMITED",
"MIRIMAL ISPAT PRIVATE LIMITED",
"MIRKA INDIA PRIVATE LIMITED",
"MIRKANA ENGINEERING PRIVATE LIMITED",
"MIRKETA SOFTWARE PRIVATE LIMITED",
"MIRKUTE & PATIL DEVELOPERS PRIVATE LIMITED",
"MIRKUTE TRANSPORTS PRIVATE LIMITED",
"MIRLESS METAL COMPONENTS PRIVATE LIMITED",
"MIRON ENGINEERING AND CASTINGS PRIVATE LIMITED",
"MIRONDA MINMETALS PRIVATE LIMITED",
"MIRRA ADITI ADVISORY PRIVATE LIMITED",
"MIRRA HEALTH CARE SERVICES INDIA PRIVATE LIMITED",
"MIRRANT AUTOMATION PRIVATE LIMITED",
"MIRRAS COFFEE INDIA PRIVATE LIMITED",
"MIRRAW ONLINE SERVICES PRIVATE LIMITED",
"MIRRI AGRO PRIVATE LIMITED",
"MIRRIAD ADVERTISING PRIVATE LIMITED",
"MIRRIKH INFRATECH PRIVATE LIMITED",
"MIRRORTECH PRIVATE LIMITED",
"MIRTO TECHNOLOGY PRIVATE LIMITED",
"MIRUM DIGITAL PRIVATE LIMITED",
"MIRUS GLOBAL CONSULTANTS PRIVATE LIMITED",
"MIRUS INFRASTRUCTURE PRIVATE LIMITED",
"MIRV INFRA PRIVATE LIMITED",
"MIRYALGUDA RICE INDUSTRIES PVT LTD",
"MIRZA INTERNATIONAL LIMITED",
"MIRZAPUR ELECTRICAL INDUSTRIES LTD.",
"MIRZAPUR GHAZIPUR STPS PRIVATE LIMITED",
"MIRZAPUR HIGH SCHOOL",
"MIRZAPUR POWER PRIVATE LIMITED",
"MIS ENGINEERING SOLUTIONS PRIVATE LIMITED",
"MIS HEALTHCARE PRIVATE LIMITED",
"MIS OUTSOURCING PRIVATE LIMITED",
"MIS SUPPORT CENTER PRIVATE LIMITED",
"MIS TEXFAB PRIVATE LIMITED",
"MISA FINECHEM PRIVATE LIMITED",
"MISATU WELDEQUIP PVT LTD",
"MISBA HOLIDAYS PRIVATE LIMITED",
"MISBAH FARMS PRIVATE LIMITED",
"MISBAH TRADELINK PRIVATE LIMITED",
"MISCHIEF CLOTHING PRIVATE LIMITED",
"MISCOT SYSTEMS PRIVATE LIMITED",
"MISFIRE APPARELS PRIVATE LIMITED",
"MISGO SALES PRIVATE LIMITED",
"MISH DESIGNS LIMITED",
"MISH MASH BIO LAB PRIVATE LIMITED",
"MISHA BIOTECH PRIVATE LIMITED",
"MISHA INFOTECH PRIVATE LIMITED",
"MISHANK DIAGEM PRIVATE LIMITED",
"MISHANT TRADING CO",
"MISHKA EXIM LIMITED",
"MISHKAT AGRO INDUSTRIES PRIVATE LIMITED",
"MISHKAT FOOD INDUSTRIES PRIVATE LIMITED",
"MISHKON RESEARCH LABS LIMITED",
"MISHRA & SONS REALCON PRIVATE LIMITED",
"MISHRA AND COMPANY SANITARY PRIVATE LIMITED",
"MISHRA DHATU NIGAM LIMITED",
"MISHRA HYDROPOWER (INDIA) PRIVATE LIMITED",
"MISHRA INFRACON PRIVATE LIMITED",
"MISHRA LIME MINERALS AND PAINTS PRIVATE LIMITED",
"MISHRA POLYCLINIC & RESEARCH CENTRE PVT LTD",
"MISHRA POLYPACKS PRIVATE LIMITED",
"MISHRA PRESERVERS PRIVATE LIMITED",
"MISHRA UDYOG PRIVATE LIMITED",
"MISHRA URO-ONCOLOGY SERVICES PRIVATE LIMITED",
"MISHRAMBU BEVERAGES PRIVATE LIMITED",
"MISHRI DEVI EYE HOSPITAL PRIVATE LIMITED",
"MISHRI HOSPITAL",
"MISHRI MEDIPOINT PRIVATE LIMITED",
"MISHRI SAW COLD STORAGE PVT LTD",
"MISHRI SAW WAREHOUSING PRIVATE LIMITED",
"MISHRIBAI AGRO TECH PRIVATE LIMITED",
"MISHRIBAI MOHANLAL MEDICAL CENTRE PRIVATE LIMITED",
"MISHRILAL ASSOCIATES PRIVATE LIMITED",
"MISHRY HOLDINGS LIMITED",
"MISHTANN FOODS LIMITED",
"MISHTANN SHOPPEE INDIA PRIVATE LIMITED",
"MISHTEL SERVICES PRIVATE LIMITED",
"MISHTHEE TEXTILES PRIVATE LIMITED",
"MISHTHI INDUSTRIES PRIVATE LIMITED",
"MISHTI FARMER PRODUCER COMPANY LIMITED",
"MISHTI MULTIMEDIA PRIVATE LIMITED",
"MISHTI RAJ FOODS PRIVATE LIMITED",
"MISK APPARELS PRIVATE LIMITED",
"MISKIN FOODS PRIVATE LIMITED",
"MISO HEALTHCARE PRIVATE LIMITED",
"MISPL SYSTEMS PRIVATE LIMITED",
"MISPRAS FURNISHINGS PRIVATE LIMITED",
"MISQUITA ENGINEERING LIMITED",
"MISRA ASSOCIATES DEVELOPMENT CONSULTANTS PVT LTD",
"MISRA AUTOMATICS PRIVATE LIMITED",
"MISRA BOILERS PRIVATE LIMITED",
"MISRA BRICK FIELDS PVT LTD",
"MISRA INFRAVENTURES PRIVATE LIMITED",
"MISRI AUTO SERVICES PRIVATE LIMITED",
"MISRILALL MINES PRIVATE LIMITED",
"MISRIMAL NAVAJEE MUNOTH JAIN ENGINEERING COLLEGE",
"MISS ART GARMENTS PRIVATE LIMITED",
"MISS UNIVERSE GARMENTS PRIVATE LIMITED",
"MISSA MORE CLOTHING PRIVATE LIMITED",
"MISSHYA LIFE SCIENCE PRIVATE LIMITED",
"MISSION ACADEMY",
"MISSION CURE PHARMA PRIVATE LIMITED",
"MISSION DEAL RETAIL INDIA PRIVATE LIMITED",
"MISSION ENERGY FOUNDATION",
"MISSION MEDIA PVT. LTD.",
"MISSION NEPHRO-URO CARE PRIVATE LIMITED",
"MISSION PHARMACEUTICALS LIMITED.",
"MISSION RESEARCH LABORATORIES INDIA PRIVATE LIMITED",
"MISSION SYSTEMS INDIA PRIVATE LIMITED",
"MISSION TRADING PRIVATE LIMITED",
"MISSION XCELLENCE CREATIVE SOLUTIONS PRIVATE LIMITED",
"MISSIONPHARMA LOGISTICS INDIA PRIVATE LIMITED",
"MISSIVE FACILITY SERVICES PRIVATE LIMITED",
"MISSVALENTINE INNERWEAR PRIVATE LIMITED",
"MIST IT SERVICES PRIVATE LIMITED",
"MIST KNOWLEDGE PARK PRIVATE LIMITED",
"MIST MINDS TECHNOLOGIES PRIVATE LIMITED",
"MIST RESSONANCE ENGINEERING PRIVATE LIMITED",
"MIST SEPARATORS INDIA PRIVATE LIMITED",
"MIST VFX STUDIO PRIVATE LIMITED",
"MISTAIR HEALTH AND HYGIENE PRIVATE LIMITED",
"MISTAIR REALTYS PRIVATE LIMITED",
"MISTER POLICY INSURANCE MARKETING PRIVATE LIMITED",
"MISTER VEG FOODS PRIVATE LIMITED",
"MISTIC INFOSOLUTIONS PRIVATE LIMITED",
"MISTRAL IMPEX PRIVATE LIMITED",
"MISTRAL SOLUTIONS PRIVATE LIMITED",
"MISTRAL TECHNOLOGIES PRIVATE LIMITED",
"MISTRY AUTO ENGINEERING PRIVATE LIMITED",
"MISTRY ENGINEERING WORKS PRIVATE LIMITED",
"MISTWOOD FARMS PRIVATE LIMITED",
"MISTY PURE TECHNOLOGY PRIVATE LIMITED",
"MISUMI INDIA PRIVATE LIMITED",
"MISUN PURE LIGHTS PRIVATE LIMITED",
"MISYS TRADE AND RISK MANAGEMENT INDIA PRIVATE LIMITED",
"MIT ACADEMY OF ENGINEERING",
"MIT ARTS DESIGN AND TECHNOLOGY UNIVERSITY",
"MIT COLLEGE OF AGRICULTURE AND TECHNOLOGY",
"MIT COLLEGE OF COMPUTER SCIENCE & I.T",
"MIT GRAFIK PRIVATE LIMITED",
"MIT INFOCOM (INDIA) PRIVATE LIMITED",
"MIT IRON AND STEEL PRIVATE LIMITED",
"MIT SCHOOL OF DISTANCE EDUCATION",
"MIT SCHOOL OF ENGINEERING",
"MIT SCHOOL OF FINE ARTS AND APPLIED ARTS",
"MIT SHAIV ENGINEERS PRIVATE LIMITED",
"MITA ENGINEERS AND FABRICATORS PRIVATE LIMITED",
"MITA FASTENERS PVT LTD",
"MITA LOCKS PVT LTD",
"MITA SUPPLIERS PRIVATE LIMITED",
"MITA TEXTILES PRIVATE LIMITED",
"MITALI ALLOYS PRIVATE LIMITED",
"MITALI METERS PVT. LTD.",
"MITALI TRANSFORMER AND SWITCHGEAR PRIVATE LIMITED",
"MITARSH ENERGY PRIVATE LIMITED",
"MITASH CORPORATION",
"MITASO APPLIANCES LIMITED",
"MITASO COMTEL LIMITED",
"MITASU DEVELOPERS PRIVATE LIMITED",
"MITC ROLLING MILLS PRIVATE LIMITED",
"MITCHELL GROUP USA PRIVATE LIMITED",
"MITCHELL MARTIN (INDIA) PRIVATE LIMITED",
"MITCHI PROPERTIES AND INVESTMENTS (DELHI) PVT LTD",
"MITCO WIRES PRIVATE LIMITED",
"MITCON CONSULTANCY & ENGINEERING SERVICES LIMITED",
"MITCON CREDENTIA TRUSTEESHIP SERVICES LIMITED",
"MITCON ENVIROTECH LIMITED",
"MITCON FORUM FOR SOCIAL DEVELOPMENT",
"MITCON SOLAR ALLIANCE LIMITED",
"MITCON SUN POWER LIMITED",
"MITCSCO FINANCIAL SERVICES PRIVATE LIMITED",
"MITECH BUS DOOR SYSTEMS PRIVATE LIMITED",
"MITECK SYSTEMS PRIVATE LIMITED",
"MITEL CLOUD COMMUNICATIONS PRIVATE LIMITED",
"MITEL COMMUNICATIONS PRIVATE LIMITED",
"MITER & MITER ENGINEERS PRIVATE LIMITED",
"MITERA HOSPITALS PRIVATE LIMITED",
"MITERA IMPEX PRIVATE LIMITED",
"MITESH AUTO ANCILLARY PRIVATE LIMITED",
"MITESH CONSTRUCTION PRIVATE LIMITED",
"MITESH FAB TEX PRIVATE LIMITED",
"MITESH FOOD PRODUCTS PRIVATE LIMITED",
"MITHAAS SWEETS & RESTAURANT PRIVATE LIMITED",
"MITHAL INDUSTRIES PRIVATE LIMITED",
"MITHALS INTERNATIONAL MOVERS PRIVATE LIMITED",
"MITHALS INTERNATIONAL RELOCATIONS PRIVATE LIMITED",
"MITHAS FOODS PRIVATE LIMITED",
"MITHI GOVINDRAM PUBLIC SCHOOL",
"MITHI OVERSEAS PRIVATE LIMITED",
"MITHIBAI COLLEGE OF ARTS CHAUHAN INSTITUTE OF SCIENCE AND AMRUTBEN JIVANLAL COLLEGE OF COMMERCE AND ECONOMICS",
"MITHIBORWALA GLOBAL VENTURES PRIVATE LIMITED",
"MITHILA CONSUMER GOODS PRIVATE LIMITED",
"MITHILA DUGDH UTPADAK SAHKARI SANGH LTD",
"MITHILA E ZONES PRIVATE LIMITED",
"MITHILA MARINE AGENCY PRIVATE LIMITED",
"MITHILA MOTORS PRIVATE LIMITED",
"MITHILA NATURALS PRIVATE LIMITED",
"MITHILA PAINTS PRIVATE LIMITED",
"MITHILA PROPERTIES PUBLICATION & CONTRACT ENTERPRISES PRIVATE LIMITED",
"MITHILA QUALITY PRODUCTS PRIVATE LIMITED",
"MITHILA RASAYAN PRIVATE LIMITED",
"MITHILA TRADING PRIVATE LIMITED",
"MITHILESH HEALTHCARE",
"MITHLA INFRABUILD PRIVATE LIMITED",
"MITHLA INFRACITY PRIVATE LIMITED",
"MITHLESH INFRASTRUCTURE & BUILDCON PRIVATE LIMITED",
"MITHRA AUTO AGENCIES PRIVATE LIMITED",
"MITHRA INCREST PRIVATE LIMITED",
"MITHRA KYOKUTO SPECIAL PURPOSE VEHICLE COMPANY PRIVATE LIMITED",
"MITHRA SCANS PRIVATE LIMITED",
"MITHRAA CARGO SOLUTIONS PRIVATE LIMITED",
"MITHRAN STRUCTURES PRIVATE LIMITED",
"MITHRAS TRANSLOGIC PRIVATE LIMITED",
"MITHRIL TELECOMMUNICATIONS PRIVATE LIMITED",
"MITHROS CHEMICALS PRIVATE LIMITED",
"MITHSAGAR ELECTRONICSS SYSTEMS PRIVATE LIMITED",
"MITHUN SECURITIES PRIVATE LIMITED",
"MITHVASSAA VENTURES PRIVATE LIMITED",
"MITI ELECTRONICS PRIVATE LIMITED",
"MITI SPHERE SOLUTIONS PRIVATE LIMITED",
"MITIE DESIGNERS AND PLANNERS PRIVATE LIMITED",
"MITIL POLYMER PRIVATE LIMITED",
"MITIS BIOMEDICS LIMITED",
"MITKAT ADVISORY SERVICES PRIVATE LIMITED",
"MITKORD STEEL PRIVATE LIMITED",
"MIT-MOL CONVEYORS PRIVATE LIMITED",
"MITOCH PHARMA PRIVATE LIMITED",
"MITOOL EQUIPMENTS PRIVATE LIMITED",
"MITORA MACHINEX PRIVATE LIMITED",
"MITOSIS TECHNOLOGIES PRIVATE LIMITED",
"MITPAL ENTERPRISES PRIVATE LIMITED",
"MITR HEALTHCARE PRIVATE LIMITED",
"MITR LEARNING MEDIA PRIVATE LIMITED",
"MITR SEWA PRIVATE LIMITED",
"MITRA & GHOSH PUBLISHERS PVT LTD",
"MITRA AGRO ENTERPRISES LIMITED",
"MITRA BENEFIT NIDHI LIMITED",
"MITRA COMMERCIAL PRIVATE LIMITED",
"MITRA EARTHMOVERS PRIVATE LIMITED",
"MITRA INDUSTRIESPRIVATE LIMITED",
"MITRA PRECISE FORGE PRIVATE LIMITED",
"MITRA PRECISION FASTNERS PVT LIMITED",
"MITRA S K COAL INSPECTION PRIVATE LIMITED",
"MITRA S K PVT LTD",
"MITRA SPINNING MILLS PRIVATE LIMITED",
"MITRA TECHNOLOGY FOUNDATION",
"MITRA TRADERS",
"MITRA TRAVELS",
"MITRANAND FINANCIAL SERVICES PRIVATE LIMITED",
"MITRAS BIKES PRIVATE LIMITED",
"MITRAS TECHNOCRAFTS PRIVATE LIMITED",
"MITRASHMI EXPRESS SERVICES PRIVATE LIMITED",
"MITRATA INCLUSIVE FINANCIAL SERVICES PRIVATE LIMITED",
"MITRATECH INDIA LLP",
"MITRAYA FARMERS PRODUCER COMPANY LIMITED",
"MITRAZ FINANCIAL SERVICES PRIVATE LIMITED",
"MITRISK CONSULTING LLP",
"MITRON CAPITAL LIMITED",
"MITRU FOODS PRIVATE LIMITED",
"MIT'S FACILITY SOLUTIONS PRIVATE LIMITED",
"MITS GLOBAL CONSULTING PRIVATE LIMITED",
"MITS HEALTHCARE PRIVATE LIMITED",
"MITS LIFE SCIENCES PRIVATE LIMITED",
"MITS NUTRACEUTICALS PRIVATE LIMITED",
"MITSAUS TECHNOLOGIES PRIVATE LIMITED",
"MITSOGO TECHNOLOGIES PRIVATE LIMITED",
"MITSU CHEM PLAST LIMITED",
"MITSU ENERGY PRIVATE LIMITED",
"MITSUBA INDIA PRIVATE LIMITED",
"MITSUBISHI CHEMICAL INDIA PRIVATE LIMITED",
"MITSUBISHI CORPORATION INDIA PRIVATE LIMITED",
"MITSUBISHI ELECTRIC AUTOMOTIVE INDIA PRIVATE LIMITED",
"MITSUBISHI ELECTRIC INDIA PRIVATE LIMITED",
"MITSUBISHI ELEVATOR INDIA PRIVATE LIMITED",
"MITSUBISHI HEAVY INDUSTRIES",
"MITSUBISHI HEAVY INDUSTRIES INDIA PRIVATE LIMITED",
"MITSUBISHI HEAVY INDUSTRIES VST DIESEL ENGINES PRIVATE LIMITED",
"MITSUBISHI POWER INDIA PRIVATE LIMITED",
"MITSUBOSHI BELTING-INDIA PRIVATE LIMITED",
"MITSUI & COMPANY LIMITED",
"MITSUI AND CO INDIA PRIVATE LIMITED",
"MITSUI CHEMICALS INDIA PRIVATE LIMITED",
"MITSUI KINZOKU COMPONENTS INDIA PRIVATE LIMITED",
"MITSUI O S K LINES INDIA PRIVATE LIMITED",
"MITSUI OIL FIELD PRIVATE LIMITED",
"MITSUI PRIME ADVANCED COMPOSITES INDIA PRIVATE LIMITED",
"MITSUI SUMITOMO INSURANCE CO.LIMITED",
"MITSUMI AGRISCIENCE PRIVATE LIMITED",
"MITSUMI HOUSING PRIVATE LIMITED",
"MITSUN ENGINEERING PRIVATE LIMITED",
"MITSUN STEELS PRIVATE LIMITED",
"MITSUTOR SHIPPING AGENCY PVT.LTD.",
"MITT AGRO PRIVATE LIMITED",
"MITTA PROPERTIES PRIVATE LIMITED",
"MITTAL & MITTAL TUBULAR PRIVATE LIMITED",
"MITTAL AGRAWAL & ASSOCIATES",
"MITTAL AGRO PRIVATE LIMITED",
"MITTAL ALLOY CASTING CO",
"MITTAL ANALYTICS PRIVATE LIMITED",
"MITTAL AND MEHROTRA ASSOCIATES PRIVATE LIMITED",
"MITTAL AND MITTAL COLORS (INDIA) PRIVATE LIMITED",
"MITTAL APPLIANCES LIMITED",
"MITTAL BATTERIES PRIVATE LIMITED",
"MITTAL BIOTECH LIMITED",
"MITTAL BLOWERS INDIA PRIVATE LIMITED",
"MITTAL BOILERS PRIVATE LIMITED",
"MITTAL BROTHERS PRIVATE LIMITED",
"MITTAL BUILDHOME PRIVATE LIMITED",
"MITTAL CHEMPLAST PRIVATE LIMITED",
"MITTAL CLOTHING PRIVATE LIMITED",
"MITTAL COIN PRIVATE LIMITED",
"MITTAL COLD STORAGE PVT LTD",
"MITTAL COMMERCE CLASSES PRIVATE LIMITED",
"MITTAL CONCRETE PRIVATE LIMITED",
"MITTAL CONSTRUCTION UNIT",
"MITTAL COT FIBERS",
"MITTAL COTEX INDIA PRIVATE LIMITED",
"MITTAL CREATIONS PRIVATE LIMITED",
"MITTAL DEWELLERS PRIVATE LIMITED",
"MITTAL DIAGNOSTICS AND RESEARCH CENTRE PRIVATE LIMITED",
"MITTAL DISTRIBUTORS INDIA",
"MITTAL DOOR DEVICES INDIA PRIVATE LIMITED",
"MITTAL DYEING PRIVATE LIMITED",
"MITTAL ENGINEERING WELDSAFE PRIVATE LIMITED",
"MITTAL ENGINEERING WORKS",
"MITTAL FABRICS PRIVATE LIMITED",
"MITTAL FILAMENTS PRIVATE LIMITED",
"MITTAL FILES AND TOOLS PRIVATE LIMITED",
"MITTAL FINVEST AND CONSULTANCY PRIVATE LIMITED",
"MITTAL FORGINGS AND COMPONENTS PRIVATE LIMITED",
"MITTAL GLOBAL COT. INDUSTRIES",
"MITTAL GRANITES PVT LTD",
"MITTAL GROUP",
"MITTAL HARDWARES PRIVATE LIMITED",
"MITTAL HEALTH CARE",
"MITTAL HOSPITALS LIMITED",
"MITTAL INFOCOM PRIVATE LIMITED",
"MITTAL INFRASTRUCTURE PRIVATE LIMITED",
"MITTAL INFRAVENTURES PRIVATE LIMITED",
"MITTAL KNIT WEAR PRIVATE LIMITED",
"MITTAL LACE COMPANY PRIVATE LIMITED",
"MITTAL LIFE STYLE LIMITED",
"MITTAL LOGISTICS PRIVATE LIMITED",
"MITTAL MACHINES PRIVATE LIMITED",
"MITTAL MARBLES AND TILES PRIVATE LIMITED",
"MITTAL MEDICARE AND HOSPITAL PRIVATE LIMITED",
"MITTAL MEDICOS PRIVATE LIMITED",
"MITTAL METAL INDUSTRIES",
"MITTAL METALLOYS PRIVATE LIMITED",
"MITTAL N K BUSINESS PRIVATE LIMITED",
"MITTAL OCEAN TRADE PRIVATE LIMITED",
"MITTAL OIL MILLS PRIVATE LIMITED",
"MITTAL PAPER PRIVATE LIMITED",
"MITTAL PHARMA PRIVATE LIMITED",
"MITTAL PIGMENTS PRIVATE LIMITED",
"MITTAL POLYFILS PRIVATE LIMITED",
"MITTAL POLYMERS PRIVATE LIMITED",
"MITTAL POLYWEAVE PRIVATE LIMITED",
"MITTAL PORTFOLIOS PRIVATE LIMITED",
"MITTAL PRECISION AUTO COMPS PRIVATE LIMITED",
"MITTAL PRECISION HITECH STEELS PRIVATE LIMITED",
"MITTAL PRECISION TECHNOLOGIES PRIVATE LIMITED",
"MITTAL PUNCH AND PACKS PRIVATE LIMITED",
"MITTAL RICE & GENERAL MILLS",
"MITTAL ROADLINKS PRIVATE LIMITED",
"MITTAL ROADWAYS PRIVATE LIMITED",
"MITTAL RUBBER PRIVATE LIMITED",
"MITTAL S GALLERY",
"MITTAL SANITARY & PIPES PRIVATE LIMITED",
"MITTAL SECTIONS LIMITED",
"MITTAL SEEDS AND CHEMICALS PRIVATE LIMITED",
"MITTAL SERVICES INDIA PRIVATE LIMITED",
"MITTAL SIDDHI INFRA PRIVATE LIMITED",
"MITTAL SILK MILLS PRIVATE LIMITED",
"MITTAL SONS CONSTRUCTIONS PRIVATE LIMITED",
"MITTAL SOYA INDUSTRIES LIMITED",
"MITTAL SOYA PROTEIN PRIVATE LIMITED",
"MITTAL TECHNOPACK PRIVATE LIMITED",
"MITTAL TEXO FAB PVT LTD",
"MITTAL TRACTORS PRIVATE LIMITED",
"MITTAL TRADELINK PRIVATE LIMITED",
"MITTAL TRADEX PRIVATE LIMITED",
"MITTAL UDYOG INDORE PRIVATE LIMITED",
"MITTAL UNIVERSAL CONSTRUCTIONS LLP",
"MITTAL VESSELS PRIVATE LIMITED",
"MITTAL WAREHOUSING AND CARGO SERVICE PRIVATE LIMITED",
"MITTAL WEAVES PRIVATE LIMITED",
"MITTALIUM STEELS PRIVATE LIMITED",
"MITTALPRIYAL EXIM PRIVATE LIMITED",
"MITTALS GREEN ENERGY PRIVATE LIMITED",
"MITTAL'S INTERNATIONAL SCHOOL OF INNOVATIVE STUDIES AND RESEARCH",
"MITTALTECH STEEL AND CEMENT PRIVATE LIMITED",
"MITTAPALLI AGRO PRODUCTS PRIVATE LIMITED",
"MITTAPALLI AUDINARAYANA ENTERPRISES PRIVATE LIMITED",
"MITTAPALLI RAMA RAO AND SONS TOBACCOS PRIVATE LIMITED",
"MITTAPALLI SPINNERS LIMITED.",
"MITTAPALLI SPINNERS PRIVATE LIMITED",
"MITTASO PROJECTS PRIVATE LIMITED",
"MITTER FASTENERS",
"MITTER SYSTEMS PRIVATE LIMITED",
"MITTHAN LAL MARKETING LIMITED",
"MITTICOOL PRIVATE LIMITED",
"MITTRA SALES PRIVATE LIMITED",
"MITTSURE TECHNOLOGIES LLP",
"MITUJ MARKETING PRIVATE LIMITED",
"MITUL ENTERPRISES PRIVATE LIMITED",
"MITUL INDIA PRIVATE LIMITED",
"MITUL PAPERS PRIVATE LIMITED",
"MITUL TRADELINK PRIVATE LIMITED",
"MITUSHEE AUTO PRODUCTS PRIVATE LIMITED",
"MITUSHI ELECTRONIC COMPONENTS PRIVATE LIMITED",
"MITUTOYO SOUTH ASIA PRIVATE. LIMITED",
"MITVA FABRICS PRIVATE LIMITED",
"MITVA SAFETY ENGINEERS PRIVATE LIMITED",
"MITYA INFRATECH PRIVATE LIMITED",
"MITYUNG INFOTECH PRIVATE LIMITED",
"MITZVAH ENGG (INDIA) PRIVATE LIMITED",
"MIV INVESTMENT SERVICES PRIVATE LIMITED",
"MIV LOGISTICS PRIVATE LIMITED",
"MIV THERAPEUTICS INDIA PRIVATE LIMITED",
"MIVAAN CHEMTEX PRIVATE LIMITED",
"MIVEN AUTOMATION TECHNOLOGIES PRIVATE LIMITED",
"MIVEN MACHINE TOOLS LIMITED",
"MIVEN MAYFRAN CONVEYORS PRIVATE LIMITED",
"MIVIN ENGG. TECHNOLOGIES PRIVATE LIMITED",
"MIWAY TEACHING AIDS PRIVATE LIMITED",
"MIWON SPECIALTY CHEMICAL INDIA PRIVATE LIMITED",
"MIX FUSION LOGISTICS PRIVATE LIMITED",
"MIX INDIA BULK HANDLING PRIVATE LIMITED",
"MIXTRAP SOLUTION PRIVATE LIMITED",
"MIXX TECHNOLOGIES PRIVATE LIMITED",
"MIXXON PETROCHEMICALS PRIVATE LIMITED",
"MIYAKAWA DRIVES AND CONTROLS PRIVATE LIMITED",
"MIYAMA ELECTRIC INDIA PRIVATE LIMITED",
"MIYAMOTO DESIGN AND ENGINEERING CONSULTANTS PRIVATE LIMITED",
"MIYAMOTO GLOBAL EXPERTS INDIA PRIVATE LIMITED",
"MIYOTA UV PRINT & PACK PRIVATE LIMITED",
"MIZA INNOVATIONS PRIVATE LIMITED",
"MIZAC SCAFFOLDING SYSTEMS PRIVATE LIMITED",
"MIZAN CASHEW PROCESSING PRIVATE LIMITED",
"MIZE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"MIZORAM ISPAT INDUSTRIES",
"MIZPAH DIABRASIVES PRIVATE LIMITED",
"MIZPAH PUBLISHING SERVICES PRIVATE LIMITED",
"MIZUHO BANK LIMITED",
"MIZUHO GLOBAL SERVICES INDIA PRIVATE LIMITED",
"MIZUHO SECURITIES INDIA PRIVATE LIMITED",
"MIZUKI POWER PRODUCTS PRIVATE LIMITED",
"MIZUKY TOOLS INDIA PRIVATE LIMITED",
"MIZZEN MARINE PRIVATE LIMITED",
"MJ CARBUN8 TECHNOLOGY PRIVATE LIMITED",
"MJ CHEMICAL INDUSTRIES PRIVATE LIMITED",
"MJ COIR PRODUCTS PRIVATE LIMITED",
"MJ COLLEGE OF ENG AND TECH",
"MJ CORP PRIVATE LIMITED",
"MJ DISTRIBUTORS PRIVATE LIMITED",
"MJ FOREX PRIVATE LIMITED",
"MJ FRANCHISEE INDIA PRIVATE LIMITED",
"MJ GLOBAL PRIVATE LIMITED",
"MJ GRAIN PRODUCTS PRIVATE LIMITED",
"MJ HERBAL EXTRACTS PRIVATE LIMITED",
"MJ INFRASTRUCTURE & BUILDERS INDIA PRIVATE LIMITED",
"MJ LAB PRIVATE LIMITED",
"MJ LOGISTICS SERVICES LIMITED",
"MJ SHAH GROUP",
"MJ TELECOMMUNICATION SERVICES PRIVATE LIMITED",
"MJA PHARMATECH PRIVATE LIMITED",
"MJAIN IMPEX PRIVATE LIMITED",
"MJB HOTELS & RESTAURANTS PRIVATE LIMITED",
"MJB TECHNOLOGIES LLP",
"MJE PROJECTS SOLUTIONS PRIVATE LIMITED",
"MJG JEWELLERS PRIVATE LIMITED",
"MJG SURAKSHA PRIVATE LIMITED",
"MJIC CONSULTANCY PRIVATE LIMITED",
"MJJ STEEL PRIVATE LIMITED",
"MJR BUILDERS PRIVATE LIMITED",
"MJR POLYMERS PRIVATE LIMITED",
"MJR SILVER PRIVATE LIMITED",
"MJS BIDKARO SERVICES PRIVATE LIMITED",
"MJS LATEX PRIVATE LIMITED",
"MJS STEEL INFRA PRIVATE LIMITED",
"MJSJ COAL LIMITED",
"MJUNCTION SERVICES LIMITED",
"MJVS FASHION SERVICES PRIVATE LIMITED",
"MK DIES & TOOLINGS PRIVATE LIMITED",
"MK ENGINEERING",
"MK ENGINEERING & CONSTRUCTION",
"MK FAB AND FURN PRIVATE LIMITED",
"MK HARSHRAJ INTERNATIONAL SERVICES PRIVATE LIMITED",
"MK INFRA HOLDINGS PRIVATE LIMITED",
"MK ISTORES PRIVATE LIMITED",
"MK LIDE AUTOCLUTCH INDUSTRIES PRIVATE LIMITED",
"MK MULTIVISION SOFTWARE PRIVATE LIMITED",
"MK PLAST PRIVATE LIMITED",
"MK PLASTIC INDUSTRIES",
"MK POWER PROJECTS PRIVATE LIMITED",
"MK PROFINLEASE PRIVATE LIMITED",
"MK PURELINE FARMS PVT LTD",
"MK RETAIL SOLUTIONS PRIVATE LIMITED",
"MK SUPER SPECIALITY HOSPITAL PRIVATE LIMITED",
"MK TEKNOLOGY1 PRIVATE LIMITED",
"MK TRON AUTOPARTS PRIVATE LIMITED",
"MK UNISOFT INDIA PRIVATE LIMITED",
"MKA ENGINEERS AND EXPORTERS PRIVATE LIMITED",
"MKA INFRACON PRIVATE LIMITED",
"MKAD INFRASTRUCTURE & EXPORTS PRIVATE LIMITED",
"MKART INFOTECH PRIVATE LIMITED",
"MKAS HEALTH CARE SERVICES PRIVATE LIMITED",
"MKAY INFRATECH PRIVATE LIMITED",
"MKB (ASIA) PRIVATE LIMITED",
"MKB DESIGNER STUDIO PRIVATE LIMITED",
"MKC INDUSTRIES PRIVATE LIMITED",
"MKC INFRASTRUCTURE LIMITED",
"MKD AUTOSHELL PRIVATE LIMITED",
"MKD CHEM PRIVATE LIMITED",
"MKDM STUDIO PRIVATE LIMITED",
"MKF LOGISTICS PRIVATE LIMITED",
"MKG COMPUTERS PRIVATE LIMITED",
"MKG CONSULTANTS PRIVATE LIMITED",
"MKG ENGINEERING SERVICES PRIVATE LIMITED",
"MKG STEEL & POWER SOLUTIONS PRIVATE LIMITED",
"MKGK READYMADES PRIVATE LIMITED",
"MKJ TRADEX LIMITED",
"MKL STEEL INDIA PRIVATE LIMITED",
"MKLM B L AMLANI COLLEGE",
"MKM AIR TRAVELS PRIVATE LIMITED",
"MKM CREATIONS PRIVATE LIMITED",
"MKM MEDISTAR PRIVATE LIMITED",
"MKM PHARMA PRIVATE LIMITED",
"MKM PUBLISHERS PRIVATE LIMITED",
"MKM STUDIOS PRIVATE LIMITED",
"MKM SYNTEX PRIVATE LIMITED",
"MKP ENGINEERS INDIA PRIVATE LIMITED",
"MKP POLYMERS PRIVATE LIMITED",
"MKS AUTO ELECTRIC COMPONENTS PRIVATE LIMITED",
"MKS CONSTRO VENTURE PRIVATE LIMITED",
"MKS EXPORT LIMITED",
"MKS FLEXITUFF LIMITED",
"MKS GLOBAL LOGISTICS INDIA PRIVATE LIMITED",
"MKS PHARMA LIMITED",
"MKS VISION PRIVATE LIMITED",
"MKSAP PACKERS AND TRADERS PRIVATE LIMITED",
"MKSSS S SCHOOL OF MEDIA ACTIVITY RESEARCH AND TECHNOLOGY",
"MKSSS'S VISION ENGLISH MEDIUM SCHOOL",
"MKT INSURANCE BROKERS PRIVATE LIMITED",
"MKV ASHA PRIVATE LIMITED",
"MKV ENTERPRISES PRIVATE LIMITED",
"MKV FACILITIES SERVICES PRIVATE LIMITED",
"MKW HOSPITAL",
"MKY GEMS PRIVATE LIMITED",
"ML AGRO PRODUCTS LIMITED",
"ML BILLING INDIA PRIVATE LIMITED",
"ML BOOKS INTERNATIONAL PRIVATE LIMITED",
"ML INTER COLLEGE",
"ML KUSHWAHA ICE AND COLD STORAGE PRIVATE LIMITED",
"ML MODI & SONS INDIA PRIVATE LIMITED",
"ML OUTSOURCING SERVICES PRIVATE LIMITED",
"ML SPRINGS INDIA PRIVATE LIMITED",
"MLAI DIGITAL PRIVATE LIMITED",
"MLB ADVISORY SERVICES LIMITED",
"MLB CAPITAL PRIVATE LIMITED",
"MLB SALES PRIVATE LIMITED",
"MLC INDUSTRIES PRIVATE LIMITED",
"MLC JEWELS PRIVATE LIMITED",
"MLD COMMERCIAL PRIVATE LIMITED",
"MLD FOREX PRIVATE LIMITED",
"MLG POLYPLAST PRIVATE LIMITED",
"MLI LOGISTICS INDIA PRIVATE LIMITED",
"M-LIGA SPORTS EXCELLENCE PRIVATE LIMITED",
"MLINOTS TECHNOLOGIES PRIVATE LIMITED",
"MLIT-18 TECHNOLOGY PRIVATE LIMITED",
"MLJ GRANITES PRIVATE LIMITED",
"MLJ INDUSTRIES LIMITED",
"MLJP CHEMICALS PRIVATE LIMITED",
"MLK AUTOS PRIVATE LIMITED",
"MLK FASHIONS PRIVATE LIMITED",
"MLK SECURITIES PRIVATE LIMITED",
"MLL EXPRESS SERVICES PRIVATE LIMITED",
"MLM (INDIA) LIMITED",
"MLMP ROLLER FLOUR MILL PRIVATE LIMITED",
"MLOGICA COMPUTECH INDIA PRIVATE LIMITED",
"MLP COAL INTERNATIONAL PRIVATE LIMITED",
"MLP FOOD PRODUCTS PRIVATE LIMITED",
"MLR AUTO LIMITED",
"MLR INDUSTRIES PRIVATE LIMITED",
"MLR INSTITUTE OF TECHNOLOGY",
"MLR MOTORS PRIVATE LIMITED",
"MLS COMPONENT SOLUTIONS PRIVATE LIMITED",
"MLS INSPECTION PRIVATE LIMITED",
"MLS NUTS PRIVATE LIMITED",
"MLT LABORATORIES PRIVATE LIMITED",
"MLT TRADERS PRIVATE LIMITED",
"MLTC ENERGY INDIA PRIVATE LIMITED",
"MLTI PRIVATE LIMITED",
"MLU METALIKS PRIVATE LIMITED",
"MLU OVERSEAS PRIVATE LIMITED",
"MM ACTIV SCI-TECH COMMUNICATIONS PRIVATE LIMITED",
"MM AGRICHEM PRIVATE LIMITED",
"MM AGRO FOOD PRIVATE LIMITED",
"MM AGRO SEEDS PRIVATE LIMITED",
"MM AQUA TECHNOLOGIES LIMITED",
"MM AUTO INDUSTRIES LIMITED",
"MM CARBON PRODUCTS PRIVATE LIMITED",
"MM CARGO GEAR AND MARINE SERVICES PRIVATE LIMITED",
"MM CARGO SERVICES PRIVATE LIMITED",
"MM ENGINEERING",
"MM ENGINEERING INDUSTRIES PRIVATE LIMITED",
"MM E-TECH DESIGNS PRIVATE LIMITED",
"MM FORGINGS LIMITED",
"MM INDIA MEDICAL SERVICES PRIVATE LIMITED",
"MM PET MANUFACTURERS PRIVATE LIMITED",
"MM PROMOTIVE SOLUTIONS",
"MM SHARDA RARE EARTHS PRIVATE LIMITED",
"MM STYLES PRIVATE LIMITED",
"MM SYSTEMS AND EQUIPMENTS PRIVATE LIMITED",
"MM TV LIMITED",
"MM VINIYOG PRIVATE LIMITED",
"MM9 INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"MMA DESIGN PRIVATE LIMITED",
"MMAN INFRA PROJECTS & ENGINEERING PRIVATE LIMITED",
"MMB FOOD TRADERS PRIVATE LIMITED",
"MMB IMPEX PRIVATE LIMITED",
"MMC DOORTECH SERVICES PRIVATE LIMITED",
"MMC ELECTRIC COMPANY PRIVATE LIMITED",
"MMC HARDMETAL INDIA PRIVATE LIMITED",
"MMC HEALTHCARE LIMITED",
"MMC INFOTECH SERVICES PRIVATE LIMITED",
"MMC LOGISTIC PRIVATE LIMITED",
"MMC PHARMACEUTICALS LIMITED",
"MMC PROJECTS (INDIA) PRIVATE LIMITED",
"MMD DMAIC PROFILE SOLUTIONS PRIVATE LIMITED",
"MMD ENTERTAINMENTS PRIVATE LIMITED",
"MMD HEAVY MACHINERY (INDIA) PRIVATE LIMITED",
"MME INFRACON PRIVATE LIMITED",
"MMF HOSPITALS ASSOCIATION",
"MMF INDUCTION PRIVATE LIMITED",
"MMF INFOTECH TECHNOLOGIES PRIVATE LIMITED",
"MMF RATNA MEM0RIAL HOSPITAL",
"MMF SYSTEMS INDIA PRIVATE LIMITED",
"MMG HOSPITAL",
"MMG INDIA PRIVATE LIMITED",
"MMG MANDAS CONSTRUCTION PRIVATE LIMITED",
"MMG RE ROLLING MILLS PRIVATE LIMITED",
"MMG STEELS PRIVATE LIMITED",
"MMGT TELEVENTURES PRIVATE LIMITED",
"MMI ONLINE LIMITED",
"MMI RESEARCH SERVICES PRIVATE LIMITED",
"MMIMAGINE TECHNOLOGIES PRIVATE LIMITED",
"MMIS TECHNOLOGY SERVICES INDIA PRIVATE LIMITED",
"MMJ POLYPACK PRIVATE LIMITED",
"MMJC ADVISORY PRIVATE LIMITED",
"MMJS CONSULTING PRIVATE LIMITED",
"MMK ENTERPRISES PRIVATE LIMITED",
"MMK INFRA BUILDTECH PRIVATE LIMITED",
"MMK TOLL ROAD PRIVATE LIMITED",
"MMKR HEALTHCARE PRIVATE LIMITED",
"MMKTEA GLOBAL PRIVATE LIMITED",
"MMLUNGI PRIVATE LIMITED",
"MMM SOLUTIONS PRIVATE LIMITED",
"MMMT DIGITAL CRAFTAGE AND DESIGN PRIVATE LIMITED",
"MMP INDUSTRIES LIMITED",
"MMP INTERNATIONAL PRIVATE LIMITED",
"MMP MOBI WALLET PAYMENT SYSTEMS LIMITED",
"MMP SHAH WOMEN'S COLLEGE OF ARTS & COMMERCE",
"MMP SOFTWARE DEVELOPMENT PRIVATE LIMITED",
"MMP STRUCTURAL ENGINEERS PRIVATE LIMITED",
"MMP-FILTRATION PRIVATE LIMITED",
"MMR CONSTRUCTION COMPANY PRIVATE LIMITED",
"MMR INFRASTRUCTURE DEVELOPERS PRIVATE LIMITED",
"MMR RESEARCH WORLDWIDE (INDIA) PRIVATE LIMITED",
"MMRFIC TECHNOLOGY PRIVATE LIMITED",
"MMS & UD INTERNATIONAL PRIVATE LIMITED",
"MMS COMP PU COLLEGE BELGAUM",
"MMS HEALTHCARE TECHNOLOGIES PRIVATE LIMITED",
"MMS INFRATECH PRIVATE LIMITED",
"MMS MARITIME INDIA PRIVATE LIMITED",
"MMS SHIP MANAGEMENT (INDIA ) PRIVATE LIMITED",
"MMS STORES PRIVATE LIMITED",
"MMSH CLINICAL RESEARCH PRIVATE LIMITED",
"MMT FOREX AND TRAVELS PRIVATE LIMITED",
"MMT IRON & STEEL TRADING PRIVATE LIMITED",
"MMT POLYPACKS PRIVATE LIMITED",
"MMTC - PAMP INDIA PRIVATE LIMITED",
"MMTC LIMITED",
"MMTC PAMP INDIA PRIVATE LIMITED",
"MMU METALIKS UDYOG PRIVATE LIMITED",
"MMV FASHIONS PRIVATE LIMITED",
"MMV PRODUCTION PRIVATE LIMITED",
"MMX FOODS PRIVATE LIMITED",
"MMYL PACKAGING PRIVATE LIMITED",
"MMYRAJ INDUSTRIES PRIVATE LIMITED",
"MN AGRO INDUSTRIES",
"MN AUTOMOBILE PRIVATE LIMITED",
"MN BIOTECH PVT LTD",
"MN DEVSKANDHA ENTERPRISES PRIVATE LIMITED",
"MN ENFORCEMENT SERVICE PRIVATE LIMITED",
"MN FINSERVE PRIVATE LIMITED",
"MN GLOBEX PRIVATE LIMITED",
"MN LIFE CARE PRODUCTS PRIVATE LIMITED",
"MN MULTI SOLUTIONS PRIVATE LIMITED",
"MN MUNOTH JAIN POLY TECHNIC COLLEGE",
"MN ORTHOPAEDIC HOSPITAL",
"MN POLYPACK PRIVATE LIMITED",
"MN PRINTING SOLUTIONS PRIVATE LIMITED",
"MN SOLUTIONS",
"MN VENTURES PRIVATE LIMITED",
"MNB BAJRANG STEEL PRIVATE LIMITED",
"MNB LOGISTICS PRIVATE LIMITED",
"MNC AUTOMATION PRIVATE LIMITED",
"MNC ELECTRICALS PRIVATE LIMITED",
"MNC ENTERPRISES PRIVATE LIMITED",
"MNCAS INDIA PRIVATE LIMITED",
"MNCL SOFTECH PRIVATE LIMITED",
"MNEC CONSULTANTS PRIVATE LIMITED",
"MNET PARTNER TECHNOLOGY SERVICES (INDIA) PRIVATE LIMITED",
"MNF ELECTRONICS SOLUTION PRIVATE LIMITED",
"MNF METALS & FORMING PRIVATE LIMITED",
"MNG FREIGHT SERVICES PRIVATE LIMITED",
"MNG OVERSEAS PRIVATE LIMITED",
"MNG SHIPPING PRIVATE LIMITED",
"MNH CARE HOSPITAL",
"MNH SHAKTI LIMITED",
"MNINE CONSULTING PRIVATE LIMITED",
"MNJ INSTITUTE OF ONCOLOGY AND REGIONAL C",
"MNJ INSTITUTE OF ONCOLOGY AND REGIONAL CANCER CENTRE",
"MNL AGRO FOODS PRIVATE LIMITED",
"MNM BUILDERS PRIVATE LIMITED",
"MNM COMPOSITES PRIVATE LIMITED",
"MNM FITNESS CENTER PRIVATE LIMITED",
"MNM GLOBAL SERVICES PRIVATE LIMITED",
"MNM JAIN ENGINEERING COLLEGE",
"MNM JEWELS PRIVATE LIMITED",
"MNM STOCK BROKING PRIVATE LIMITED",
"MNP GIRLS MARATHI CAMP SCHOOL",
"MNP INTERCONNECTION TELECOM SOLUTIONS INDIA PRIVATE LIMITED",
"MNP ISPAT PRIVATE LIMITED",
"MNP MEDITECH PRIVATE LIMITED",
"MNP METALIKS PRIVATE LIMITED",
"MNP MOBILITY PRIVATE LIMITED",
"MNR BROADBAND SERVICES PRIVATE LIMITED",
"MNR COLLEGE OF ENGINEERING & TECHNOLOGY",
"MNR COLLEGE OF PHARMACY",
"MNR COTTONS PRIVATE LIMITED",
"MNR EDUCATIONAL COUNCIL",
"MNR EDUCATIONAL TRUST",
"MNR INFRASTRUCTURE PRIVATE LIMITED",
"MNR MECHANICALS PRIVATE LIMITED",
"MNR SOLUTIONS PRIVATE LIMITED",
"MNS AUTOMATION INDIA PRIVATE LIMITED",
"MNS CREDIT MANAGEMENT GROUP PRIVATE LIMITED",
"MNS FOODS LIMITED",
"MNS MOTORS PRIVATE LIMITED",
"MNSK COLLEGE OF ENGINEERING",
"MNSR TRADING PRIVATE LIMITED",
"MNT INFO VISION PRIVATE LIMITED",
"MNTEX SYNTHETICS PRIVATE LIMITED",
"MNV CASTING PRIVATE LIMITED",
"MNV FASHION PRIVATE LIMITED",
"MNV INDUSTRIES LIMITED",
"MO ALTERNATE INVESTMENT ADVISORS PRIVATE LIMITED",
"MO DESIGNS PRIVATE LIMITED",
"MO DIESEL (INDIA) PRIVATE LIMITED",
"MOA ENGINEERING PRIVATE LIMITED",
"MOA ENTERPRISES PRIVATE LIMITED",
"MOAISUS GLOBAL SOLUTIONS",
"MOAPPZ TECHNOLOGIES PRIVATE LIMITED",
"MOB FOUNTAIN MEDIA PRIVATE LIMITED",
"MOBA MOBILE AUTOMATION INDIA PRIVATE LIMITED",
"MOBACK TECHNOLOGIES INDIA PRIVATE LIMITED",
"MOBASE ELECTRONICS INDIA PRIVATE LIMITED",
"MOBASE INDIA PRIVATE LIMITED",
"MOBATIME INDIA PRIVATE LIMITED",
"MOBATREE MANUFACTURERS PRIVATE LIMITED",
"MOBAVENUE MEDIA PRIVATE LIMITED",
"MOBAX NETWORKS PRIVATE LIMITED",
"MOBCAST INNOVATIONS PRIVATE LIMITED",
"MOBCLIXS TECHNOLOGIES PRIVATE LIMITED",
"MOBCODER TECHNOLOGIES PRIVATE LIMITED",
"MOBE QUALITY FIBRES PRIVATE LIMITED",
"MOBEL INDIA PRIVATE LIMITED",
"MOBELCHEM SPECIALTY PRIVATE LIMITED",
"MOBI OCEAN TECHNOLOGIES PRIVATE LIMITED",
"MOBIAPT SERVICES PRIVATE LIMITED",
"MOBICAFE RETAIL PRIVATE LIMITED",
"MOBICULE TECHNOLOGIES PRIVATE LIMITED",
"MOBIFUSION TECHNOLOGIES PRIVATE LIMITED",
"MOBIGESTURE SOFTWARE PRIVATE LIMITED",
"MOBIGIC TECHNOLOGIES PRIVATE LIMITED",
"MOBIGNOSIS TECHNOLOGY PRIVATE LIMITED",
"MOBIGOSSIP INFOTECH PRIVATE LIMITED",
"MOBIKODE SOFTWARE PRIVATE LIMITED",
"MOBIL80 SOLUTIONS AND SERVICES PRIVATE LIMITED",
"MOBILART MOBILITY SOLUTIONS PRIVATE LIMITED",
"MOBILE ASPECTS INDIA PRIVATE LIMITED",
"MOBILE CLIMATE CONTROL THERMAL SYSTEMS INDIA PRIVA",
"MOBILE COMMUNICATIONS INDIA PRIVATE LIMITED",
"MOBILE DEFENDERS PRIVATE LIMITED",
"MOBILE HOSPITAL DESIGNERS AND DEVELOPERS INDIA PRIVATE LIMITED",
"MOBILE INTERNET INDIA PRIVATE LIMITED",
"MOBILE MEDIA PRIVATE LIMITED",
"MOBILE PROGRAMMING INDIA PRIVATE LIMITED",
"MOBILE SHOP",
"MOBILE TECHSOL PRIVATE LIMITED",
"MOBILE TELECARE SERVICES PRIVATE LIMITED",
"MOBILE TUTOR PRIVATE LIMITED",
"MOBILE2WIN INDIA PRIVATE LIMITED",
"MOBILECOMM TECHNOLOGIES INDIA PRIVATE LIMITED",
"MOBILEFIRST APPLICATIONS PRIVATE LIMITED",
"MOBILEMOTION TECHNOLOGIES PRIVATE LIMITED",
"MOBILENXT TELESERVICES PRIVATE LIMITED",
"MOBILEPE E-COMMERCE PRIVATE LIMITED",
"MOBILETECH ONLINE SERVICES PRIVATE LIMITED",
"MOBILEUM INDIA PRIVATE LIMITED",
"MOBILEUM TECHNOLOGIES PRIVATE LIMITED",
"MOBILEWARE TECHNOLOGIES PRIVATE LIMITED",
"MOBILISTIC INNOVATIVE BUSINESS SOLUTIONS PRIVATE LIMITED",
"MOBILITY FOR YOU PRIVATE LIMITED",
"MOBILITY MOTORS PRIVATE LIMITED",
"MOBILITY SOLUTIONS LIMITED",
"MOBILIZAR TECHNOLOGIES PRIVATE LIMITED",
"MOBILLOR TECHNOLOGIES PRIVATE LIMITED",
"MOBILOITTE TECHNOLOGIES INDIA PRIVATE LIMITED",
"MOBILOUS SOFTECH PRIVATE LIMITED",
"MOBILOX INNOVATIONS PRIVATE LIMITED",
"MOBILUTION IT SYSTEMS PRIVATE LIMITED",
"MOBILY INFOTECH INDIA PRIVATE LIMITED",
"MOBIMART INDIA PRIVATE LIMITED",
"MOBINEERS INFO SYSTEMS PRIVATE LIMITED",
"MOBINET IT SOLUTION PRIVATE LIMITED",
"MOBIO SOLUTIONS PRIVATE LIMITED",
"MOBIOTICS IT SOLUTION PRIVATE LIMITED",
"MOBIPRO INNOVATION PRIVATE LIMITED",
"MOBIQUITY SOFTECH PRIVATE LIMITED",
"MOBIS INDIA LIMITED",
"MOBIS INDIA MODULE PRIVATE LIMITED",
"MOBISAFAR SERVICES PRIVATE. LIMITED",
"MOBISHAALA EDUTECH PRIVATE LIMITED",
"MOBISHASTRA TECHNOLOGIES PRIVATE LIMITED",
"MOBISIGN SERVICES PRIVATE LIMITED",
"MOBISMART CARD TECHNOLOGY PRIVATE LIMITED",
"MOBISOC TECHNOLOGY PRIVATE LIMITED",
"MOBISOFT INFOTECH PRIVATE LIMITED",
"MOBISOFT TELESOLUTIONS PRIVATE LIMITED",
"MOBISPRINT CONSULTING PRIVATE LIMITED",
"MOBISWIPE TECHNOLOGIES PRIVATE LIMITED",
"MOBISY TECHNOLOGIES PRIVATE LIMITED",
"MOBITECH CREATIONS PRIVATE LIMITED",
"MOBITECH TRADING PRIVATE LIMITED",
"MOBITECH WIRELESS SOLUTION PRIVATE LIMITED",
"MOBITRASH RECYCLE VENTURES PRIVATE LIMITED",
"MOBITUNE PLANET (OPC) PRIVATE LIMITED",
"MOBIURJA INNOVATIONS PRIVATE LIMITED",
"MOBIUS KNOWLEDGE SERVICES PRIVATE LIMITED",
"MOBIUS PROTECTION INDUSTRIES LLP",
"MOBIUS SOLUTIONS PRIVATE LIMITED",
"MOBIUS365 DATA SERVICES PRIVATE LIMITED",
"MOBIUSO TECHNOLOGIES INDIA PRIVATE LIMITED",
"MOBIVEIL TECHNOLOGIES INDIA PRIVATE LIMITED",
"MOBIVERSA PRIVATE LIMITED",
"MOBIWEB TECHNOLOGIES SERVICES PRIVATE LIMITED",
"MOBIZ INFOTECH PRIVATE LIMITED",
"MOBIZENT SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"MOBLIGENT MEDIA PRIVATE LIMITED",
"MOBME WIRELESS SOLUTIONS LIMITED",
"MOBOCOR TRADING PRIVATE LIMITED",
"MOBOFIX DIGITAL PRIVATE LIMITED",
"MOBOGAGE PRIVATE LIMITED",
"MOBOLUTION INDIA PRIVATE LIMITED",
"MOBONAIR WIRELESS PRIVATE LIMITED",
"MOBPAIR TECHNOLOGIES PRIVATE LIMITED",
"MOBSS WINDSHIELD PRIVATE LIMITED",
"MOC DIES AND MOULDS",
"MOC SHIPYARDS PRIVATE LIMITED",
"MOCHIKO SHOES PRIVATE LIMITED",
"MOD AUTOMOBILES PRIVATE LIMITED",
"MOD CERAMIC INDUSTRIES LIMITED",
"MOD E TECH ENGINEERING PRIVATE LIMITED",
"MOD FASHIONS AND SECURITIES PRIVATE LIMITED",
"MOD FORGE PRIVATE LIMITED",
"MOD FURN SYSTEMS INDIA PRIVATE LIMITED",
"MOD HIKE PRIVATE LIMITED",
"MOD INTERIORS PRIVATE LIMITED",
"MOD KITCHEN EQUIPMENT PRIVATE LIMITED",
"MOD MEDICARE SYSTEMS PRIVATE LIMITED",
"MOD SCAFF PRIVATE LIMITED",
"MODA HARDWARE INDIA PRIVATE LIMITED",
"MODADOME ONLINE PRIVATE LIMITED",
"MODAGE BUILDING POTENTIALS PVT LTD",
"MODAK ANALYTICS LLP",
"MODAK ANALYTICS SOFTWARE PRIVATE LIMITED",
"MODAK INTERNATIONAL PRIVATE LIMITED",
"MODAK RUBBER AND TEXTILE INDUSTRIES PRIVATE LIMITED",
"MODALIFE COMMERCE PRIVATE LIMITED",
"MODANI SECURITIES PRIVATE LIMITED",
"MODART INTERNATIONAL",
"MODASA PHARMACEUTICALS PRIVATE LIMITED",
"MODATECH E-COMMERCE PRIVATE LIMITED",
"MODCON INDUSTRIES PRIVATE LIMITED",
"MODE FINSERVER PRIVATE LIMITED",
"MODEL AUTO WIZARD PRIVATE LIMITED",
"MODEL BUSINESS SERVICES PRIVATE LIMITED",
"MODEL CO-OP BANK LIMITED",
"MODEL DAIRY PRIVATE LIMITED",
"MODEL ECONOMIC TOWNSHIP LIMITED",
"MODEL ENTERPRISES PRIVATE LIMITED",
"MODEL EXIMS",
"MODEL FUELS PVT. LTD.",
"MODEL HIGH SCHOOL NANDPUR",
"MODEL HIGHER SECONDARY SCHOOL",
"MODEL INFRA CORPORATION PRIVATE LIMITED",
"MODEL INSTITUTE OF EDUCATION AND RESEARCH",
"MODEL LOGISTICS PRIVATE LIMITED",
"MODEL MEDI DIAGNOSTIC CENTRE PRIVATE LIMITED",
"MODEL MEDIA SOLUTIONS INDIA PRIVATE LIMITED",
"MODEL N INDIA SOFTWARE PRIVATE LIMITED",
"MODEL PRINTING PRESS (INDIA) PRIVATE LIMITED",
"MODEL SCHOOL DEDIYAPADA",
"MODEL SCHOOL ROHTAK",
"MODELAMA EXPORTS PRIVATE LIMITED",
"MODELCAM ENGINEERING PRIVATE LIMITED OPC",
"MODELCAM TECHNOLOGIES PRIVATE LIMITED",
"MODELLA WOOLLENS LIMITED",
"MODELLO VENTURES LLP",
"MODELLTECHNIK RAPID PROTOTYPING INDIA PRIVATE LIMITED",
"MODELS CONSTRUCTION PRIVATE LIMITED",
"MODELS LEISURE VENTURE",
"MODELYTICS INDIA PRIVATE LIMITED",
"MODENA WAFTAGE FREIGHT CARRIERS PRIVATE LIMITED",
"MODENIK LIFESTYLE PRIVATE LIMITED",
"MODEPRO INDIA PRIVATE LIMITED",
"MODER SOLUTIONS INDIA PRIVATE LIMITED",
"MODERA FREIGHT SERVICES PRIVATE LIMITED",
"MODERATE LEASING AND CAPITAL SERVICES LTD",
"MODERATE MACHINES PRIVATE LIMITED",
"MODERE INDIA PRIVATE LIMITED",
"MODERN 3P MART PRIVATE LIMITED",
"MODERN ACADEMY",
"MODERN ACRYLICS PRIVATE LIMITED",
"MODERN AGE METAL PROCESSORS PRIVATE LIMITED",
"MODERN AGRO MOTORS AND TRACTORS PRIVATE LIMITED",
"MODERN AGRO-TECH INDUSTRIES",
"MODERN AMUSEMENT AND THEATRE PRIVATE LIMITED",
"MODERN ARCH INFRASTRUCTURE PRIVATE LIMITED",
"MODERN AUTOCARS PRIVATE LIMITED",
"MODERN AUTOMOBILES GUJARAT PVT LTD",
"MODERN AUTOMOTIVES LIMITED",
"MODERN BANQUETS & RESORTS PRIVATE LIMITED",
"MODERN BP PUBLIC SCHOOL",
"MODERN BUSINESS EQUIPMENTS AND SERVICES PRIVATE. LIMITED",
"MODERN BUSINESS EQUIPMENTS AND SERVICES PVT. LTD.",
"MODERN BUSINESS SOLUTIONS",
"MODERN CARGO SERVICES PRIVATE LIMITED",
"MODERN CHEMICALS",
"MODERN COLLEGE",
"MODERN COLLEGE OF ARTS SCIENCE COMMER",
"MODERN COLLEGE OF PHYSIOTHERAPY",
"MODERN COMMUNICATION AND BROADCAST SYSTEMS PRIVATE LIMITED",
"MODERN CONSTRUCTION CO",
"MODERN COTTON YARN SPINNERS LIMITED",
"MODERN CREATION PRIVATE LIMITED",
"MODERN CREDIT PRIVATE LIMITED",
"MODERN CROP SCIENCE PRIVATE LIMITED",
"MODERN DAIRIES LIMITED",
"MODERN DAIRYFARMS LIMITED",
"MODERN DELHI PUBLIC SCHOOL",
"MODERN DENIM LIMITED",
"MODERN DERIVATIVES AND COMMODITIES PRIVATE LIMITED",
"MODERN DESIGNER JEWELLERY BOUTIQUE PRIVATE LIMITED",
"MODERN DIAGNOSTIC & RESEARCH CENTRE PRIVATE LIMITED",
"MODERN DOORDEVICES PRIVATE LIMITED",
"MODERN DUDH UTPADAK UDHYOG PRIVATE LIMITED",
"MODERN DYEING PRIVATE LIMITED",
"MODERN EDUCATION SOCIETY'S COLLEGES EMPLOYEES CO OP CREDIT SOCIETY LIMITED",
"MODERN ELECTROFAB PRIVATE LIMITED",
"MODERN EMERGENCY SERVICES JV PRIVATE LIMITED",
"MODERN ENERGY RENTAL PRIVATE LIMITED",
"MODERN ENGINEERS INFRATECH PRIVATE LIMITED",
"MODERN ENTERPRISES PRIVATE LIMITED",
"MODERN EQUIPMENTS & SALES PRIVATE LIMITED",
"MODERN EYE HOSPITAL & RESEARCH CENTRE",
"MODERN FABRICS PRIVATE LIMITED",
"MODERN FACILITIES MANAGEMENT PRIVATE LIMITED",
"MODERN FAMILY DOCTOR PRIVATE LIMITED",
"MODERN FIBOTEX INDIA LTD",
"MODERN FINCON PRIVATE LIMITED",
"MODERN FOOD AND BEVERAGES PRIVATE LIMITED",
"MODERN FOOD ENTERPRISES PRIVATE LIMITED",
"MODERN FOOD PVT. LTD.",
"MODERN FREIGHT SERVICES PRIVATE LIMITED",
"MODERN GEM AND DESIGNER PRIVATE LIMITED",
"MODERN GRIT PRIVATE LIMITED",
"MODERN GROUP OF INSTITUTIONS",
"MODERN GROWTH TECHNOLOGIES PRIVATE LIMITED",
"MODERN GUINEA HOUSE PVT LTD",
"MODERN HIGH SCHOOL (ENGLISH MEDIUM)",
"MODERN HIGH SCHOOL FOR GIRLS",
"MODERN HIRING SERVICE",
"MODERN HI-RISE PRIVATE LIMITED",
"MODERN HITECH PRODUCTS PRIVATE LIMITED",
"MODERN HOLDINGS PRIVATE LIMITED",
"MODERN HOMOEO DISTRIBUTORS PVT LTD",
"MODERN HVAC SOLUTIONS PRIVATE LIMITED",
"MODERN INDIA CON CAST LTD",
"MODERN INDIA CREATIVE PRIVATE LIMITED",
"MODERN INDIA LIMITED",
"MODERN INDIA STEEL ROLLING MILLS PRIVATE LIMITED",
"MODERN INDUSTRIAL EQUIPMENTS PRIVATE LIMITED",
"MODERN INDUSTRIAL GASES PRIVATE LIMITED",
"MODERN INDUSTRIES",
"MODERN INFO TECHNOLOGY PRIVATE LIMITED",
"MODERN INFORMATICS PRIVATE LIMITED",
"MODERN INNS PRIVATE LIMITED",
"MODERN INSECTICIDES LIMITED",
"MODERN INSTITUTE OF PHARMACEUTICAL SCIENCES",
"MODERN INSULATORS LIMITED",
"MODERN INTERNATIONAL PRIVATE LIMITED",
"MODERN IRON COMPANY PRIVATE LIMITED",
"MODERN ISPAT PRIVATE LIMITED",
"MODERN JEWELS PRIVATE LIMITED",
"MODERN LAMINATORS LIMITED",
"MODERN LAMINATORS PRIVATE LIMITED",
"MODERN LAW HOUSE PRIVATE LIMITED",
"MODERN LIVING HOSPITALITY PRIVATE LIMITED",
"MODERN LIVING SOLUTIONS PRIVATE LIMITED",
"MODERN MART PRIVATE LIMITED",
"MODERN MARWAR PRIVATE LIMITED",
"MODERN MASTI PRIVATE LIMITED",
"MODERN MATCHES PRIVATE LIMITED",
"MODERN METAALICS PRIVATE LIMITED",
"MODERN METAL INDIA PRIVATE LIMITED",
"MODERN MOBITECH PRIVATE LIMITED",
"MODERN MOLD PLAST PRIVATE LIMITED",
"MODERN MONTESSORI INTERNATIONAL (INDIA) PRIVATE LIMITED",
"MODERN MULTISPECIALTY HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED",
"MODERN MYTH TRADEX PRIVATE LIMITED",
"MODERN NEST BUILT PRIVATE LIMITED",
"MODERN ORNAMENTS PRIVATE LIMITED",
"MODERN PACKAGING PRIVATE LIMITED",
"MODERN PANELS PRIVATE LIMITED",
"MODERN PAPER MART PRIVATE LIMITED",
"MODERN PEB PRIVATE LIMITED",
"MODERN PESTICIDES SUPPLY PRIVATE LIMITED",
"MODERN POLYTEX LIMITED",
"MODERN PREFAB SYSTEMS PRIVATE LIMITED",
"MODERN PROCESS PRINTERS PRIVATE LIMITED",
"MODERN PROPACK PRIVATE LIMITED",
"MODERN PROTECTION INDIA PRIVATE LIMITED",
"MODERN PUBLIC SCHOOL",
"MODERN PUBLISHERS",
"MODERN RADIO HOUSE INDIA PRIVATE LIMITED",
"MODERN RAILTECH EQUIPMENT MANUFACTURES PRIVATE LIMITED",
"MODERN ROAD MAKERS P LTD",
"MODERN ROADWAYS PRIVATE LIMITED",
"MODERN ROCK & CLAY PRIVATE LIMITED",
"MODERN ROLLS & ENGINEERING PRIVATE LIMITED",
"MODERN SAFETY GLASS PRIVATE LIMITED",
"MODERN SCHOOL",
"MODERN SCIENCE APPARATUS PRIVATE LIMITED",
"MODERN SHARES AND STOCKBROKERS LIMITED",
"MODERN SHIKSHAN PRASARAK MANDAL",
"MODERN SNACKS PRIVATE LIMITED",
"MODERN SOFTWARE SYSTEMS PRIVATE LIMITED",
"MODERN SPRAYERS PRIVATE LIMITED",
"MODERN SR SEC SCHOOL",
"MODERN STAGE SERVICES PRIVATE LIMITED",
"MODERN STEEL LIMITED",
"MODERN STONE CRUSHERS PRIVATE LIMITED",
"MODERN TECHNO PROJECTS PRIVATE LIMITED",
"MODERN TESTING SERVICES (INDIA) PRIVATE LIMITED",
"MODERN THREADS INDIA LIMITED",
"MODERN TRACTOR SPARES PRIVATE LIMITED",
"MODERN TRADING CO.(DELHI) PRIVATE LIMITED",
"MODERN TRANSFORMERS PRIVATE LIMITED",
"MODERN TRANSMISSION PRIVATE LIMITED",
"MODERN VEER RAYS SECURITY FORCE INDIA PRIVATE LIMITED",
"MODERN VENTAS PRIVATE LIMITED",
"MODERN WATER ENGINEERING PRIVATE LIMITED",
"MODERN WHITENERS PRIVATE LIMITED",
"MODERN WILMAR REFINERY PRIVATE LIMITED",
"MODERN WOOD WORKS",
"MODERNA JYOTI PRODUCTS PRIVATE LIMITED",
"MODERNE TEXTILE SOLUTIONS PRIVATE LIMITED",
"MODERNIZE CHIP SOLUTIONS PRIVATE LIMITED",
"MODERNIZING TRENDS PRIVATE LIMITED",
"MODERNVILLA CONSTRUCTION INDIA PRIVATE LIMITED",
"MODEST INFRA LIMITED",
"MODEST INFRASTRUCTURE PRIVATE LIMITED",
"MODEST MARITIME SERVICES PRIVATE LIMITED",
"MODESTO CROP PROTECTION PRIVATE LIMITED",
"MODESTY CARGO SERVICES PRIVATE LIMITED",
"MODEX HARDWARE PRIVATE LIMITED",
"MODEX TRADING PRIVATE LIMITED",
"MODEZ TECH INGENIOUS PRIVATE LIMITED",
"MODFLEX INDIA LIMITED",
"MODHERA CHEMICALS PRIVATE LIMITED",
"MODI & MODI REALTY HYDERABAD PRIVATE LIMITED",
"MODI AGRITRADE AND FOODS PRIVATE LIMITED",
"MODI AQUA-FILL PRIVATE LIMITED",
"MODI BROTHERS PRIVATE LIMITED",
"MODI BUILDERS & INFRASTRUCTURES PRIVATE LIMITED",
"MODI BUILDERS AND REALTORS PRIVATE LIMITED",
"MODI BUILDESTATE INDIA PRIVATE LIMITED",
"MODI BUILD-WELL LIMITED",
"MODI CAKES AND CONFECTIONARY PRIVATE LIMITED",
"MODI CAR AGENCIES PRIVATE LIMITED",
"MODI CHEMICALS PRIVATE LIMITED",
"MODI CHEMPLAST MATERIALS PRIVATE LIMITED",
"MODI CLINICAL LABORATORY PRIVATE LIMITED",
"MODI COAL PRIVATE LIMITED",
"MODI CON-CAST PRIVATE LIMITED",
"MODI CONTRACTS LIMITED",
"MODI DISTRIBUTORS PRIVATE LIMITED",
"MODI DYEING AND PROOFING WORKS PRIVATE LIMITED",
"MODI FABRICS PRIVATE LIMITED",
"MODI FANS PRIVATE LIMITED",
"MODI FITNESS PRIVATE LIMITED",
"MODI FOODS PVT LTD",
"MODI GLAZING AND CLADDING PRIVATE LIMITED",
"MODI GRANEXPO PRIVATE LIMITED",
"MODI GRANI MARMO PRIVATE LIMITED",
"MODI GRANITES PRIVATE LIMITED",
"MODI HEALTHCARE PLACEMENT INDIA PRIVATE LIMITED",
"MODI HITECH INDIA LIMITED",
"MODI HOUSING PRIVATE LIMITED",
"MODI ILLVA INDIA PRIVATE LIMITED",
"MODI INDIA PRIVATE LIMITED",
"MODI INDUSTRIES LIMITED",
"MODI INFOSOL PRIVATE LIMITED",
"MODI INFRASTONE PRIVATE LIMITED",
"MODI INNOVATIONS PRIVATE LIMITED",
"MODI MATTRESSES PRIVATE LIMITED",
"MODI MEASUREMENT SYSTEMS PRIVATE LIMITED",
"MODI METAL AND ALLIED INDUSTRIES PRIVATE LIMITED",
"MODI MOTORS AGENCIES PRIVATE LIMITED",
"MODI MUNDIPHARMA PRIVATE LIMITED",
"MODI NATURALS LIMITED",
"MODI OIL & PACKAGERS PRIVATE LIMITED",
"MODI ORGANISORS PRIVATE LIMITED",
"MODI PIPES PRIVATE LIMITED",
"MODI POLYFAB PRIVATE LIMITED",
"MODI PRIMARY SCHOOL ENGLISH MEDIUM",
"MODI PROJECTS LTD.",
"MODI PROPAC PRIVATE LIMITED",
"MODI PROPERTIES PRIVATE LIMITED",
"MODI PROTECTARP PRIVATE LIMITED",
"MODI RANGLAL AND SONS PRIVATE LIMITED",
"MODI REMEDIES PRIVATE LIMITED",
"MODI SALTS PRIVATE LIMITED",
"MODI SCHIFFLI EMBROIDERY MILLS PRIVATE LIMITED",
"MODI SHELTERS PRIVATE LIMITED",
"MODI SILK MILLS PRIVATE LIMITED",
"MODI SPECIAL PURPOSE MACHINES PRIVATE LIMITED",
"MODI SPRINKLERS PRIVATE LIMITED",
"MODI STRATFORD ENTERPRISE MANAGEMENT PRIVATE LIMITED",
"MODI SURGICO HEALTHCARE PRIVATE LIMITED",
"MODI TEA & INDUSTRIES PVT LTD",
"MODI WOODSPACE PRIVATE LIMITED",
"MODIANT SOLUTIONS",
"MODICARE LIMITED",
"MODICON PRIVATE LIMITED",
"MODIEN PROJECTS PRIVATE LIMITED",
"MODIFI INVESTMENT SERVICES PRIVATE LIMITED",
"MODIFI SERVICES PRIVATE LIMITED",
"MODIGOLD BEVERAGES PRIVATE LIMITED",
"MODIGOLD PIPES PRIVATE LIMITED",
"MODILINE TRAVEL SERVICE PRIVATE LIMITED",
"MODIMAHALAXMI SIZING PRIVATE LIMITED",
"MODI-MUNDIPHARMA BEAUTY PRODUCTS PRIVATELIMITED",
"MODI-MUNDIPHARMA HEALTHCARE PRIVATE LIMITED",
"MODINAGAR ROLLS PRIVATE LIMITED",
"MODINAGAR TEA CO PVT LTD",
"MODINDIA EXIM PRIVATE LIMITED",
"MODINE THERMAL SYSTEMS PRIVATE LIMITED",
"MODIPLAST EXIM PRIVATE LIMITED",
"MODIRA DISTILLERS & BOTTLERS PRIVATE LIMITED",
"MODIREALTY DEVELOPERS PRIVATE LIMITED",
"MODI-SENATOR (INDIA) PRIVATE LIMITED",
"MODISH KNITWEARS PRIVATE LIMITED",
"MODISH STUDIO PRIVATE LIMITED",
"MODISH TRACTORAURKISAN PRIVATE LIMITED",
"MODISH TRADEX PRIVATE LIMITED",
"MODISON COPPER PRIVATE LIMITED",
"MODISON METALS LIMITED",
"MODISONS ENTERPRISES (INDIA) PRIVATE LIMITED",
"MODISPACES REAL-ESTATE PRIVATE LIMITED",
"MODLE GOVT MULTI HIGH SEC SCHOOL",
"MODLON POLYMERS (INDIA) PRIVATE LIMITED",
"MODRIBA HYGIENE SOLUTIONS LIMITED",
"MODRIG TECHSOLUTIONS PRIVATE LIMITED",
"MODSAL FROZEN FOODS PRIVATE LIMITED",
"MODSONIC INSTRUMENTS MANUFACTURING COMPANY PRIVATE LIMITED",
"MODTECH MACHINES PRIVATE LIMITED",
"MODTECH MATERIAL HANDLING PROJECTS PRIVATE LIMITED",
"MODTECH TRADECOM PRIVATE LIMITED",
"MODTEX TEXTURISERS PRIVATE LIMITED",
"MODULA AUTOMATED WAREHOUSES INDIA PRIVATE LIMITED",
"MODULAR AUTO LIMITED",
"MODULAR COLD ROOMS PRIVATE LIMITED",
"MODULAR CONCEPTS INDIA PRIVATE LIMITED",
"MODULAR ELECTRONICS PRIVATE LIMITED",
"MODULAR INFOTECH PRIVATE LIMITED",
"MODULAR INFRATECH PRIVATE LIMITED",
"MODULAR KITCHEN-AIDE PRIVATE LIMITED",
"MODULAR LIGHTING (INDIA) PRIVATE LIMITED",
"MODULAR RACK SYSTEMS PRIVATE LIMITED",
"MODULAR TANKS PRIVATE LIMITED",
"MODULE INNOVATIONS PRIVATE LIMITED",
"MODULE MD HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"MODULE ONE INDIA LIMITED",
"MODULUS ALTERNATIVES INVESTMENT MANAGERS LIMITED",
"MODULUS COSMETICS",
"MODULUS COSMETICS PRIVATE LIMITED",
"MODULUS RESEARCH AND ANALYSIS PRIVATE LIMITED",
"MODUS INFORMATION SYSTEMS PRIVATE LIMITED",
"MODUTEC READY PANELS PRIVATE LIMITED",
"MODUTECH BUILDING SYSTEMS PRIVATE LIMITED",
"MODVAK CABLES INDIA PRIVATE LIMITED",
"MODVAK ENGINEERING INDIA PRIVATE LIMITED",
"MODWAY SUITING PRIVATE LIMITED",
"MODWAYS BUILDCON PRIVATE LIMITED",
"MODWAYS OBJET D ART PRIVATE LIMITED",
"MODWEAVE INTERNATIONAL PRIVATE LIMITED",
"MODWEL MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"MODWIN NETWORKS PRIVATE LIMITED",
"MODY AUTO (INDIA) PRIVATE LIMITED",
"MODY AUTO CORP PRIVATE LIMITED",
"MODY CHEMI PHARMA LIMITED",
"MODY CHEMI PHARMA PRIVATE LIMITED",
"MODY INVESTMENT & MFG COMPANY PVT LTD",
"MODY PUMPS INDIA PRIVATE LIMITED",
"MODY RESINS PRIVATE LIMITED",
"MODY UNIVERSITY OF SCIENCE AND TECHNOLOGY",
"MOEBIUS TRADE PRIVATE LIMITED",
"MOEL INFRASTRUCTURE PRIVATE LIMITED",
"MOELIS & COMPANY INDIA PRIVATE LIMITED",
"MOENGAGE INDIA PRIVATE LIMITED",
"MOENUS TEXTILE PRIVATE LIMITED",
"MOERHEIM PLANTS AND FLOWERS PRIVATE LIMITED",
"MOE'S ART PRIVATE LIMITED",
"MOET HENNESSY INDIA PRIVATE LIMITED",
"MOFILM TECHNOLOGIES INDIA PRIVATE LIMITED",
"MOFIRST SOLUTIONS PRIVATE LIMITED",
"MOFLEX SUSPENSIONS LLP",
"MOFLEX SUSPENSIONS PRIVATELIMITED",
"MOFTWARE INFOTECH PRIVATE LIMITED",
"MOG TECHNOLOGIES PRIVATE LIMITED",
"MOGA FOODS PRIVATE LIMITED",
"MOGA MEDICITY PRIVATE LIMITED",
"MOGAE CONSULTANTS PRIVATE LIMITED",
"MOGAE DIGITAL PRIVATE LIMITED",
"MOGAE MEDIA PRIVATE LIMITED",
"MOGHA JEWELLERY PRIVATE LIMITED",
"MOGLI LABS (INDIA) PRIVATE LIMITED",
"MOGLI RESORTS PRIVATE LIMITED",
"MOGORA COSMIC PRIVATE LIMITED",
"MOGRA ENGINEERING PRIVATE LIMITED",
"MOGRA MERCHANTS PVT LTD",
"MOGU ENGINEERS PRIVATE LIMITED",
"MOGUIRE VIRAGO PRIVATE LIMITED",
"MOGUL EXIM TRADING PRIVATE LIMITED",
"MOGUL FINANCE PRIVATE LIMITED",
"MOGULKATA TEA COMPANY PRIVATE LIMITED",
"MOHA PACKAGING (INDIA) PRIVATE LIMITED",
"MOHAK MEDICAL AND RESEARCH CENTRE PRIVATE LIMITED",
"MOHAK REAL ESTATE PRIVATE LIMITED",
"MOHAK STONE CRAFT PRIVATE LIMITED",
"MOHAK WOOLLENS PRIVATE LIMITED",
"MOHALI AUTOMOBILES PRIVATE LIMITED",
"MOHALI PETROCHEM LTD",
"MOHAM INFOSOLUTIONS PRIVATE LIMITED",
"MOHAMAD IDRIS BROS PRIVATE LIMITED",
"MOHAMAD IDRIS BROS SONS FABRIC PRIVATE LIMITED",
"MOHAMAD ISRAIL COLD STORAGES PRIVATE LIMITED",
"MOHAMAD SATHAK COLLEGE OF ARTS",
"MOHAMED ABOOBACKER CHANK LUNGI PRIVATE LIMITED",
"MOHAMED SATHAK A J ACADEMY OF ARCHITECTURE",
"MOHAMED SATHAK COLLEGE OF ARTS AND SCIENCE",
"MOHAMMAD ALI JOHAR URDU HIGH SCHOOL JALNA",
"MOHAMMAD RAFI ANWARI TRADING PRIVATE LIMITED",
"MOHAMMADI EDU AND SOCI URDU HIGHSCHOOL DEOPUR DHULE",
"MOHAMMADIYA EDUCATIONAL SOCIETY",
"MOHAMMADIYA URDU BOYS HIGH SCHOOL AND JR COLLEGE DHULE",
"MOHAMMED ENTERPRISES PRIVATE LIMITED",
"MOHAMMED KHAN JEWELLERS PRIVATE LIMITED",
"MOHAMMED YASIN MOHAMMED YAMIN PERFUMERS PRIVATE LIMITED",
"MOHAMMEDAN SPORTING CLUB PRIVATE LIMITED",
"MOHAMMEDI ENGINEERING COMPANY PRIVATE LIMITED",
"MOHAN APPARELS PRIVATE LIMITED",
"MOHAN AROMATICS PRIVATE LIMITED",
"MOHAN AUTO INDUSTRIES PRIVATE LIMITED",
"MOHAN AUTOMOTIVES PRIVATE LIMITED",
"MOHAN BABU UNIVERSITY",
"MOHAN BHOG LLP",
"MOHAN BHOG SAMUDYAM PRIVATE LIMITED",
"MOHAN BOARDS PRIVATE LIMITED",
"MOHAN BREEDING FARM",
"MOHAN BROTHERS (DRINKS) PRIVATE LIMITED",
"MOHAN BROTHERS DRINKS PRIVATE LIMITED",
"MOHAN CHARITABLE EDUCATIONAL TRUST",
"MOHAN CLOTHING COMPANY PRIVATE LIMITED",
"MOHAN COLD STORAGE PVT LTD",
"MOHAN COMMUNICATIONS PVT LTD",
"MOHAN CURE 360 (OPC) PRIVATE LIMITED",
"MOHAN DAI OSWAL CANCER TREATMENT & RESEARCH FOUNDATION",
"MOHAN DISTRIBUTORS PRIVATE LIMITED",
"MOHAN ELASTICS PRIVATE LIMITED",
"MOHAN ELECTROCASTING PRIVATE LIMITED",
"MOHAN ENERGY CORPORATION PRIVATE. LIMITED.",
"MOHAN ENGINEERING STEEL FABRICATION PRIVATE LIMITED",
"MOHAN ENTERPRISES",
"MOHAN ENVIRO ENGINEERING PRIVATE LIMITED",
"MOHAN EXIM INDIA PRIVATE LIMITED",
"MOHAN EXPORTS PVT. LTD.",
"MOHAN FABTEX LIMITED.",
"MOHAN FOOTCARE PRIVATE LIMITED",
"MOHAN FOURWHEEL PRIVATE LIMITED",
"MOHAN FURNITURE MART PRIVATE LIMITED",
"MOHAN GOLDWATER BREWERIES LIMITED",
"MOHAN GRANITES PRIVATE LIMITED",
"MOHAN HEALTH CENTRE PRIVATE LIMITED",
"MOHAN IMPRESSIONS PVT LTD",
"MOHAN INDUSTRY",
"MOHAN INDUSTRY PRIVATE LIMITED",
"MOHAN INFRADEVELOPERS PRIVATE LIMITED",
"MOHAN INTERNATIONAL BUILDERS",
"MOHAN INVESTMENTS AND PROPERTIES PRIVATE LTD",
"MOHAN IRON AND STEEL (INDIA) PRIVATE LIMITED",
"MOHAN JUTE LTD",
"MOHAN KUMAR EASTERN HOSPITAL",
"MOHAN LABORATORIES PVT LTD",
"MOHAN LAL DAYAL VINAY MANDIR SCHOOL",
"MOHAN LAL GAUTAM RAJKIYA MAHILA HEALTH DEPARTMENT ALIGARH",
"MOHAN MARKETING PRIVATE LIMITED",
"MOHAN MEAKIN LIMITED",
"MOHAN MECHEM PROJECTS PRIVATE LIMITED",
"MOHAN MERCHANDISE PRIVATE LIMITED",
"MOHAN MILKFOODS PRIVATE LIMITED",
"MOHAN MILKLINE PRIVATE LIMITED",
"MOHAN MINES PRIVATE LTD.",
"MOHAN MISHRA MULTITRADE PRIVATE LIMITED",
"MOHAN MOHAN & CO PRIVATE LIMITED",
"MOHAN MOTOR SERVICES PRIVATE LIMITED",
"MOHAN MOTOR SUPER BIKES PRIVATE LIMITED",
"MOHAN MUTHA EXPORTS PRIVATE LIMITED",
"MOHAN MUTHA INFRASTRUCTURES PRIVATE LIMITED",
"MOHAN MUTHA TRANSLOGISTICS PRIVATE LIMITED",
"MOHAN NUTRIENTS PRIVATE LIMITED",
"MOHAN OVERSEAS PRIVATE LIMITED",
"MOHAN POLYFAB PVT LTD",
"MOHAN POWER INFRASTRUCTURE PRIVATE LIMITED",
"MOHAN PRITILATA MEDICAL & RESEARCH CENTRE PRIVATE LIMITED",
"MOHAN PROJECTCONTRACTORS PRIVATE LIMITED",
"MOHAN RAM TRADING PRIVATE LIMITED",
"MOHAN RAO AND COMPANY",
"MOHAN ROCKY SPRING WATER BREWERIES LIMITED",
"MOHAN SATHE CONSULTANCY PRIVATE LIMITED",
"MOHAN SEEDS PVT. LTD.",
"MOHAN SHARMA AND COMPANY PRIVATE LIMITED",
"MOHAN SHEETALAYA PRIVATE LIMITED",
"MOHAN SPARES PARTS PRIVATE LIMITED",
"MOHAN SPINTEX INDIA LIMITED",
"MOHAN STORES PRIVATE LIMITED",
"MOHAN SUPER ALLOYS PRIVATE LIMITED",
"MOHAN TEXTILE PRIVATE LIMITED",
"MOHAN THREAD MILLS PRIVATE LIMITED",
"MOHAN THREE WHEELERS PRIVATE LIMITED",
"MOHAN TRACTORS PRIVATE LIMITED",
"MOHAN TRADERS PRIVATE LIMITED",
"MOHAN UDYOG PRIVATE LIMITED",
"MOHAN VEHICLES PRIVATE LIMITED",
"MOHAN YARNS PRIVATE LIMITED",
"MOHAN ZUPACK LIMITED",
"MOHANA COMMERCIAL PRIVATE LIMITED",
"MOHANAMMA TECHNOLOGY PRIVATE LIMITED",
"MOHANBATI PRIMARY SCHOOL",
"MOHANI MARKETING PVT. LTD.",
"MOHANI TEA LEAVES PRIVATE LIMITED",
"MOHANI TRADING COMPANY PVT LTD",
"MOHANISH ENGINEERING PRIVATE LIMITED",
"MOHANKHEDA JEWELS PRIVATE LIMITED",
"MOHANKUMAR CONSTRUCTIONS PRIVATE LIMITED",
"MOHANLAL BRIGHT BAR PRIVATE LIMITED",
"MOHANLAL HARGOVINDDAS BIDI UDYOG PVT.LTD.",
"MOHANLAL JEWELLERS CHENNAI PRIVATE LIMITED",
"MOHANLAL JEWELLERS PRIVATE LIMITED",
"MOHANLAL KISHAN CHAND AND COMPANY PRIVATE LIMITED",
"MOHANLAL MADHAWJEE JEWELLERS PRIVATE LIMITED",
"MOHANLAL MATHRANI CONSTRUCTION PRIVATE. LIMITED.",
"MOHANLAL PUKHRAJ TEXTILES PRIVATE LIMITED",
"MOHANLAL SHANKARLAL AGRO FOODS PRIVATE LIMITED",
"MOHANRAO PATANGRAO PATIL MAHAVIDYALAYA BORGAON",
"MOHANSON FERRITES PRIVATE LIMITED",
"MOHANTY ENTERPRISES",
"MOHAPATRA BROTHERS VENTURES PRIVATE LIMITED",
"MOHAR CREATIONS LLP",
"MOHAR DIAMONDS PRIVATE LIMITED",
"MOHARIR AUTOTRADE PRIVATE LIMITED",
"MOHARIR MOTORS AND SERVICES PRIVATE LIMITED",
"MOHASHAKTI FORGING PRIVATE LIMITED",
"MOHATA COAL COMPANY PVT. LTD.",
"MOHATA ENTERPRISES PRIVATE LIMITED",
"MOHATA TEXTILE MILLS PRIVATE LIMITED",
"MOHAWK INDUSTRIES INC.",
"MOHD AHSON INFRA PRIVATE LIMITED",
"MOHEEMA LIMITED",
"MOHIB SHOE ENTERPRISES PRIVATE LIMITED",
"MOHIB SHOES PRIVATE LIMITED",
"MOHIJULI TEA CO PVT LTD",
"MOHINA PROPERTIES PVT LTD",
"MOHINDER ELECTRODES PRIVATE LIMITED",
"MOHINDER GARMENTS PRIVATE LIMITED",
"MOHINDER KAUR KNITTING PRIVATE LIMITED",
"MOHINDER SINGH JEWELLERS PRIVATE LIMITED",
"MOHINDRA COACH FACTORY PRIVATE LIMITED",
"MOHINDRA COACHES (INDIA) PRIVATE LIMITED",
"MOHINDRA DIE CASTING PRIVATE LIMITED",
"MOHINDRA FASTENERS LIMITED",
"MOHINDRA FINVEST PRIVATE LIMITED",
"MOHINDRA JACQUARDS PRIVATE LIMITED",
"MOHINDRA TUBES LIMITED",
"MOHINDRA UDYOG PRIVATE LIMITED",
"MOHINGARI MURALI PRIVATE LIMITED",
"MOHINI AGENCY INDUSTRIAL FRAGRANCES (INDIA) PRIVATE LIMITED",
"MOHINI AGRO PRIVATE LIMITED",
"MOHINI AUXICHEM PVT LTD",
"MOHINI BUILDWELL PRIVATE LIMITED",
"MOHINI CORPORATION PRIVATE LIMITED",
"MOHINI EDUMAX PRIVATE LIMITED",
"MOHINI ELECTRICALS LIMITED",
"MOHINI FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"MOHINI FASHION PRIVATE LIMITED",
"MOHINI FINE FOODS PRIVATE LIMITED",
"MOHINI FOOD PRODUCTS PRIVATE LIMITED",
"MOHINI HEALTH & HYGIENE LIMITED",
"MOHINI HYGIENE CARE PRODUCTS PRIVATE LIMITED",
"MOHINI INFRA PRIVATE LIMITED",
"MOHINI KITCHENWARE PRIVATE LIMITED",
"MOHINI MARKETING PRIVATE LIMITED",
"MOHINI ORGANICS PRIVATE LIMITED",
"MOHINI PLYWOOD PRODUCTS PRIVATE LIMITED",
"MOHINI PRINTS (MADRAS) PRIVATE LIMITED",
"MOHINI TRANSFORMERS PRIVATE. LIMITED.",
"MOHINI WINERIES LIMITED",
"MOHINTARA HOSPITAL",
"MOHI'S INFRASTRUCTURE PRIVATE LIMITED",
"MOHIT ANNA CONSTRUCTION PRIVATE LIMITED",
"MOHIT BAGS MANUFACTURING PRIVATE LIMITED",
"MOHIT BAKERS PRIVATE LIMITED",
"MOHIT CARRIERS PVT LTD",
"MOHIT CHEME ALLOY PVT LTD",
"MOHIT DIAMONDS PRIVATE LIMITED",
"MOHIT DYESTUFFS PRIVATE LIMITED",
"MOHIT EDUCOMP PRIVATE LIMITED",
"MOHIT ENGINEERS PRIVATE LIMITED",
"MOHIT ENVIRO INFRA PRIVATE LIMITED",
"MOHIT EXPORTS PVT.LTD.",
"MOHIT FASHIONS PRIVATE LIMITED",
"MOHIT FMCG PRODUCTS COMPANY PRIVATE LIMITED",
"MOHIT FURNACE PRIVATE LIMITED",
"MOHIT GAMBIR EDUCATION PRIVATE LIMITED",
"MOHIT GLOBAL SERVICES PRIVATE LIMITED",
"MOHIT INDUSTRIES LIMITED",
"MOHIT INFRABUILD PRIVATE LIMITED",
"MOHIT INTERNATIONAL PRIVATE LIMITED",
"MOHIT IRON AND STEEL PRIVATE LIMITED",
"MOHIT ISPAT PRIVATE LIMITED",
"MOHIT MEDICAL CORNER PRIVATE LIMITED",
"MOHIT MINERALS LIMITED",
"MOHIT ORGANIC RESOURCES PRIVATE LIMITED",
"MOHIT OVERSEAS LIMITED",
"MOHIT PAPER MILLS LIMITED",
"MOHIT PETROCHEMICALS PRIVATE LIMITED",
"MOHIT POLYTECH PRIVATE LIMITED",
"MOHIT PUBLICATIONS PRIVATE LIMITED",
"MOHIT ROADLINES PRIVATE LIMITED",
"MOHIT RUBBER FOAM INDIA PRIVATE LIMITED",
"MOHIT STEEL INDUSTRIES PRIVATE LIMITED",
"MOHIT TISSUES PRIVATE LIMITED",
"MOHIT VENTURES PRIVATE LIMITED",
"MOHIT WOOD PRODUCTS PRIVATE LIMITED",
"MOHITCORP POLYTEX PRIVATE LIMITED",
"MOHITE AND SHAW PISTONS (INDIA) PRIVATE LIMITED",
"MOHITE CORPORATION PRIVATE LIMITED",
"MOHITE INDUSTRIES LIMITED",
"MOHITE INFRAPROJECTS PRIVATE LIMITED",
"MOHITRAJ DISTRIBUTORS PRIVATE LIMITED",
"MOHITS LIVE STOCK FARM TECHNOLOGIES PRIVATE LIMITED",
"MOHLER MACHINE WORKS PRIVATE LIMITED",
"MOHNOT STAINLESS STEEL INDUSTRIES PRIVATE LIMITED",
"MOHOGNEY AGROTECH PRIVATE LIMITED",
"MOHONANANDA RICE MILL PVT. LTD.",
"MOHOR FLOWTECH INDIA PRIVATE LIMITED",
"MOHOR LAL SINHA PVT LTD",
"MOHRA INFRATECH PRIVATE LIMITED",
"MOHRISH PHARMACEUTICALS PRIVATE LIMITED",
"MOHSIN & SONS RADIATORS PRIVATE LIMITED",
"MOHSIN ENTERPRISES PRIVATE LIMITED",
"MOHTA BRIGHT STEELS PRIVATE LIMITED",
"MOHTA CAPITAL PVT LTD",
"MOHTA CEMENT PVT LTD",
"MOHTA COLLEGE OF SCIENCE",
"MOHTA MICRO MINERALS PRIVATE LIMITED",
"MOHTA ORGANISATION PVT LTD",
"MOHTA PLASTICS PRIVATE LIMITED",
"MOHVOGUE APPARELS PRIVATE LIMITED",
"MOHYAL FOODS PRIVATE LIMITED",
"MOI COMMODITIES INDIA PRIVATE LIMITED",
"MOI HEALTH CARE PRIVATE LIMITED",
"MOIC URBAN MALERIA UNIT",
"MOIDUS MEDI CARE PVT LTD",
"MOIL LIMITED",
"MOIN DYECHEM PRIVATE LIMITED",
"MOIRA INSTITUTE OF DESIGN PRIVATE LIMITED",
"MOIRAI COTTON PULP PRIVATE LIMITED",
"MOISSANITE APPARELS PRIVATE LIMITED",
"MOISSANITE DESIGNS PRIVATE LIMITED",
"MOISTOP ENTERPRISES PRIVATE LIMITED",
"MOJ RUBBER PRIVATE LIMITED",
"MOJIKA REAL ESTATE AND DEVELOPERS PRIVATE LIMITED",
"MOJJ ENGINEERING SYSTEMS LIMITED",
"MOJO ADVERTISING PRIVATE LIMITED",
"MOJO MARKETS PRIVATE LIMITED",
"MOJO NETWORKS PRIVATE LIMITED",
"MOJO RYDER PRIVATE LIMITED",
"MOJOSTAR BRAND MANAGEMENT& MERCHANDISING SOLUTIONS PRIVATE LIMITED",
"MOKA BUSINESS PRIVATE LIMITED",
"MOKA RETAIL PRIVATE LIMITED",
"MOKALBARI KANOI TEA ESTATE PRIVATE LIMITED",
"MOKAMA - MUNGER HIGHWAY LIMITED",
"MOKASH FOUNDATION DE-ADDICTION & REHABILATION CENTURE NASHIK",
"MOKIA GREEN ENERGY PRIVATE LIMITED",
"MOKIA POWER PRIVATE LIMITED",
"MOKKSH MACHINES PRIVATE LIMITED",
"MOKOBARA LIFESTYLE PRIVATE LIMITED",
"MOKSA TECHNOLOGIES INDIA PRIVATE LIMITED",
"MOKSH ADVERTISING & EVENTS MANAGEMENTS PRIVATE LIMITED",
"MOKSH CORP",
"MOKSH JUNGLE RETREAT PRIVATE LIMITED",
"MOKSH ORNAMENTS LIMITED",
"MOKSH PRECISION ENGINEERING PRIVATE LIMITED",
"MOKSH PROMOTIONS LIMITED",
"MOKSH TRAVELS INDIA PRIVATE LIMITED",
"MOKSHA BIOSURGICALS PRIVATE LIMITED",
"MOKSHA DESIGNS PRIVATE LIMITED",
"MOKSHA FOODS AND BEVERAGES PRIVATE LIMITED",
"MOKSHA LIFECARE PRIVATE LIMITED",
"MOKSHA SOFTLABS PRIVATE LIMITED",
"MOKSHA THERMOPLASTICS PVT LTD",
"MOKSHA WELLNESS PRIVATE LIMITED",
"MOKSHAA MOTORBIKE COMPANY PRIVATE LIMITED",
"MOKSHAMULTIVERSE PRIVATE LIMITED",
"MOKSHART PRINT PRODUCTION PRIVATE LIMITED",
"MOKSHI INDUSTRIES PRIVATE LIMITED",
"MOKSHY WAFERS AND CONFECTIONERS PRIVATE LIMITED",
"MOKUL INFRASTRUCTURE PRIVATE LIMITED",
"MOKVIS ENGINEERING PRIVATE LIMITED",
"MOL INFORMATION PROCESSING SERVICES INDIA PRIVATE LIMITED",
"MOL INFORMATION TECHNOLOGY INDIA PRIVATE LIMITED",
"MOL LOGISTICS INDIA PRIVATE LIMITED",
"MOL MARITIME INDIA PRIVATE LIMITED",
"MOL NIPPON INDIA SHIP MANAGEMENT PRIVATE LIMITED",
"MOL SHIPPING (INDIA) PRIVATE LIMITED",
"MOL SHIPPING INDIA PRIVATE LIMITED",
"MOL SYNERGY MARINE (INDIA) PRIVATE LIMITED",
"MOL TOYOFUJI AUTOMOTIVE LOGISTICS (INDIA) PRIVATE LIMITED",
"MOLAGAVALLI RENEWABLE PRIVATE LIMITED",
"MOLB INDIA PRIVATE LIMITED",
"MOLBIO DIAGNOSTICS PRIVATE LIMITED",
"MOLCLONE LABS PRIVATE LIMITED",
"MOLD TEK PACKAGING LIMITED",
"MOLD TEK TECHNOLOGIES LIMITED",
"MOLD2SPECS PLASTIC PRIVATE LIMITED",
"MOLDEX COMPOSITES PRIVATE LIMITED",
"MOLDRITE INNOVATIONS PRIVATE LIMITED",
"MOLECULAR CARE LABS PRIVATE LIMITED",
"MOLECULAR CONNECTIONS PRIVATE LIMITED",
"MOLECULAR CONNECTIONS RESEARCH PRIVATE LIMITED",
"MOLECULAR QUEST HEALTHCARE PRIVATE LIMITED",
"MOLECULAR SCIENTIFIC CORE HEALTHCARE PRIVATE LIMITED",
"MOLECULES ANALYTICAL LAB SOLUTIONS PRIVATE LIMITED",
"MOLECULES CONCHEM PRIVATE LIMITED",
"MOLEMEDD PLUS PRIVATE LIMITED",
"MOLETHU PROJECT MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"MOLEX INDIA BUSINESS SERVICES PRIVATE LIMITED",
"MOLEX INDIA PRIVATE LIMITED",
"MOLIKULE TECHNOLOGIES PRIVATE LIMITED",
"MOLINA HEALTHCARE, INC.",
"MOLINARI RAIL TECHNOLOGY INDIA PRIVATE LIMITED",
"MOLINE FACILITY SERVICES PRIVATE LIMITED",
"MOLISATI VINIMAY PRIVATE LIMITED",
"MOLKEM CHEMICALS PRIVATE LIMITED",
"MOLLA KRISHI BHANDER",
"MOLLIMAX FIRE PROTECTION INDUSTRIES PRIVATE LIMITED",
"MOLLYS CLOTHING PRIVATE LIMITED",
"MOLNLYCKE HEALTH CARE INDIA PRIVATE LIMITED",
"MOLOCO DAIRY PRODUCTS PRIVATE LIMITED",
"MOLSHREE TRADE INVEST PRIVATE LIMITED",
"MOLSIEVE DESIGNS LIMITED",
"MOLSON COORS COBRA INDIA PRIVATE LIMITED",
"MOLSYS PRIVATE LIMITED",
"MOLTECH SOLUTIONS PRIVATE LIMITED",
"MOLTENI INDIA PRIVATE LIMITED",
"MOLTERA CERAMIC PRIVATE LIMITED",
"MOLTUS RESEARCH LABORATORIES PRIVATE LIMITED",
"MOLVIZADAH SONS INDIA PRIVATE LIMITED",
"MOLYTRON SYNTHETICS PRIVATE LIMITED",
"MOM SOON FERTILITY PRIVATE LIMITED",
"MOM‚ÄôS PRIDE SCHOOL",
"MOMAGIC TECHNOLOGIES PRIVATE LIMITED",
"MOMAI FOODS PRIVATE LIMITED",
"MOMAJA LIFE SCIENCES INDIA PRIVATE LIMITED",
"MOMARK SERVICES PRIVATE. LIMITED",
"MOMAY SALT WORKS PRIVATE LIMITED",
"MOMCOM INDIA DIGITAL MEDIA PRIVATE LIMITED",
"MOMENTA LEARNING SOLUTIONS PRIVATE LIMITED",
"MOMENTA RESOURCING INDIA PRIVATE LIMITED",
"MOMENTIVE PERFORMANCE MATERIALS INDIA P LIMITED",
"MOMENTOUS CLINICAL RESEARCH PRIVATE LIMITED",
"MOMENTS EVENTS AND ENTERTAINMENT PRIVATE LIMITED",
"MOMENTSNAP INDIA PRIVATE LIMITED",
"MOMENTUM BUSINESS SOLUTIONS PRIVATE LIMITED",
"MOMENTUM COMMUNICATIONS INDIA PRIVATE LIMITED",
"MOMENTUM CONTROLS SOFTWARE AND SERVICES PRIVATE LIMITED",
"MOMENTUM INDIA PRIVATE LIMITED",
"MOMENTUM METROPOLITAN SERVICES PRIVATE LIMITED",
"MOMENTUM TECHNOLOGIES INC PRIVATE LIMITED",
"MOMENTUM TECHSYS PRIVATE LIMITED",
"MOMENTUS DIGITAL MEDIA PRIVATE LIMITED",
"MOMENTZ CLUB & RESORTS PRIVATE LIMITED",
"MOMIN JUNIOR HIGH SCHOOL CHANDPUR",
"MOMJUNCTION PRIVATE LIMITED",
"MOMNEXT PHARMA PRIVATE LIMITED",
"MOMOE TECHNOLOGIES PRIVATE LIMITED",
"MOM'S BELIEF",
"MOMS OUTDOOR MEDIA SOLUTIONS PRIVATE LIMITED",
"MOMS PET APPARELS PRIVATE LIMITED",
"MONA DRIVE INDIA PRIVATE LIMITED",
"MONA FITNESS CENTRE PRIVATE LIMITED",
"MONA GENERATOR SERVICES PRIVATE LIMITED",
"MONA INFRASTRUCTURE PRIVATE LIMITED",
"MONA LAKSHMI HOMES PRIVATE LIMITED",
"MONA MOTORS PRIVATE LIMITED",
"MONA RASAYAN INDUSTRIES PRIVATE LIMITED",
"MONA TOURS AND TRAVELS PRIVATE LIMITED",
"MONA TRENDS PRIVATE LIMITED",
"MONAA HOTELS PRIVATE LIMITED",
"MONAARC CORPORATION PRIVATE LIMITED",
"MONAD CONSTRUCTION PRIVATE LIMITED",
"MONADPLUS TECHLABS PRIVATE LIMITED",
"MONAL CHAINS LIMITED",
"MONAL CONSTRUCTIONS PRIVATE LIMITED",
"MONAL LAMINATE PRIVATE LIMITED",
"MONALISA BOTTLING INDUSTRIES PVT LTD",
"MONALISA ELECTRONIC DESIGN CENTRE PRIVATE LIMITED",
"MONALISA MANPOWER MANAGEMENT LLP",
"MONALISA STORES PRIVATE LIMITED",
"MONALISA SYNTHETICS PRIVATE LIMITED",
"MONAMI HOSPITALITY PRIVATE LIMITED",
"MONAMIT TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"MONARAYS MARINE SERVICES PRIVATE LIMITED",
"MONARCH AUTOMOTIVE PRIVATE LIMITED",
"MONARCH AUTOSQUARE PRIVATE LIMITED",
"MONARCH BATH PRIVATE LIMITED",
"MONARCH BUILDTECH LIMITED",
"MONARCH CARS PRIVATE LIMITED",
"MONARCH COATING PRIVATE LIMITED",
"MONARCH COMPUSYS PRIVATE LIMITED",
"MONARCH COMTRADE PRIVATE LIMITED",
"MONARCH DYESTUFFS INDUSTRIES AND EXPORTS LIMITED",
"MONARCH ELEC-TECH PRIVATE LIMITED",
"MONARCH ENTERPRISE PRIVATE LIMITED",
"MONARCH ERGO PRIVATE LIMITED",
"MONARCH GRAPHICS INDIA PRIVATE LIMITED",
"MONARCH HATCHERIES PRIVATE LIMITED",
"MONARCH INDIA INFRACON PRIVATE LIMITED",
"MONARCH INDUSTRIAL PRODUCTS INDIA PRIVATE LIMITED",
"MONARCH INFO TECH SERVICES PRIVATE LIMITED",
"MONARCH INFOTECH SERVICES PRIVATE LIMITED",
"MONARCH INFRAPARKS PRIVATE LIMITED",
"MONARCH INNOVATION PRIVATE LIMITED",
"MONARCH INTERNATIONAL SCHOOL",
"MONARCH IT SOLUTIONS PRIVATE LIMITED",
"MONARCH NETWORKPRIVATE LIMITED",
"MONARCH NETWORTH CAPITAL LIMITED",
"MONARCH NETWORTH COMTRADE LIMITED",
"MONARCH NETWORTH FINSERVE PRIVATE LIMITED",
"MONARCH NETWORTH INVESTMENT ADVISORS PRIVATE LIMITED",
"MONARCH PHARMA LINES HYDERABAD PRIVATE LIMITED",
"MONARCH PLASTICS PVT LTD",
"MONARCH POLY PLAST PRIVATE LIMITED",
"MONARCH SELF ADHESIVE TAPES AND FOAMS INDIA PRIVATE LIMITED",
"MONARCH SHELTER PVT LTD",
"MONARCH SURVEYORS AND ENGINEERING CONSULTANTS LIMITED",
"MONARCH SURVEYORS AND ENGINEERING CONSULTANTS PRIVATE LIMITED",
"MONARCH TECHNO ENGINEERING SOLUTIONS PRIVATE LIMITED",
"MONARCH TECHNOLOGIES PUNE PRIVATE LIMITED",
"MONARIS CLINIC INDIA PRIVATE LIMITED",
"MONARO Z SECURITE PRIVATE LIMITED",
"MONART INFRA PRIVATE LIMITED",
"MONASH AIRCON PRIVATE LIMITED",
"MONASH BIOTECH PRIVATE LIMITED",
"MONATRIX OVERSEAS INDIA PRIVATE LIMITED",
"MONCHER FASHIONS PRIVATE LIMITED",
"MONDAL COLD STORAGE",
"MONDAL CONSTRUCTION COMPANY LIMITED",
"MONDAL DEVELOPERS PRIVATE LIMITED",
"MONDAL DISTRIBUTION PRIVATE LIMITED",
"MONDAL FOOD PRODUCTS PRIVATE LIMITED",
"MONDAL PRECISION PRIVATE LIMITED",
"MONDAY FASHIONS PRIVATE LIMITED",
"MONDAY MORNING PRIVATE LIMITED",
"MONDE LIFESTYLE PRIVATE LIMITED",
"MONDEE TECH PRIVATE LIMITED",
"MONDELEZ INDIA FOODS PRIVATE LIMITED",
"MONDESSO PACKAGING PRIVATE LIMITED",
"MONDIAL GENNEXT SOLUTIONS PRIVATE LIMITED",
"MONDIAL IT CONSULTANTS PRIVATE LIMITED",
"MONDIAL KOMMUNICATIONS PRIVATE LIMITED",
"MONDO FOODS LLP",
"MONDOTTICA INDIA PRIVATE LIMITED",
"MONDRAGON ASSEMBLY INDIA PRIVATE LIMITED",
"MONDY INDIA PRIVATE LIMITED",
"MONEDA FOREX AND TRAVELS PRIVATE LIMITED",
"MONEE SPOKES PRIVATE LIMITED",
"MONEETO PLASTI FAB PRIVATE LIMITED",
"MONET MARKETING (INDIA) PRIVATE LIMITED",
"MONET SECURITIES PVT. LTD.",
"MONETA RESOURCE AND CONSULTING PRIVATE LIMITED",
"MONETAGO INDIA PRIVATE LIMITED",
"MONETONIC FINANCIAL SERVICES PRIVATE LIMITED",
"MONETTA SOFTWARE SOLUTIONS PRIVATE LIMITED",
"MONEY CARE SECURITIES AND FINANCIAL SERVICES PRIVATE LIMITED",
"MONEY FUTURE FOREX PRIVATE LIMITED",
"MONEY HONEY FINANCIAL SERVICES PRIVATE LIMITED",
"MONEY LOGIX SECURITIES PRIVATE LIMITED",
"MONEY MAGNUM NEST PRIVATE LIMITED",
"MONEY MANAGERS (INDIA) PRIVATE LIMITED",
"MONEY MASTERS LEASING AND FINANCE LIMITED",
"MONEY MULTLIPLIER WEALTH SOLUTIONS PRIVATE LIMITED",
"MONEY POLYMERS PRIVATE LIMITED",
"MONEY SHINE INFOCOM PRIVATE LIMITED",
"MONEY SPELL PRIVATE LIMITED",
"MONEY TREE ENTERTAINMENT LIMITED",
"MONEY2ME FINANCE PRIVATE LIMITED",
"MONEYBEE INVESTMENT ADVISORS PRIVATE LIMITED",
"MONEYBEE REALTY PRIVATE LIMITED",
"MONEYBEE SECURITIES PRIVATE LIMITED",
"MONEYBOAT FOREX PRIVATE LIMITED",
"MONEYBOLISM FINANCIAL SERVICES PRIVATE LIMITED",
"MONEYBOXX CAPITAL PRIVATE LIMITED",
"MONEYBOXX FINANCE LIMITED",
"MONEYCREW FINTEC PRIVATE LIMITED",
"MONEYDAM INDIA PRIVATE LIMITED",
"MONEYEDGE IMF PRIVATE LIMITED",
"MONEYFROG FINANCIAL SERVICES PRIVATE LIMITED",
"MONEYFY GLOBAL PRIVATE LIMITED",
"MONEYGAIN FINANCIAL SERVICES PRIVATE LIMITED",
"MONEYGRAM INDIA PRIVATE LIMITED",
"MONEYLICIOUS CAPITAL & ADVISORY SERVICES PRIVATE LIMITED",
"MONEYLIFE ADVISORY SERVICES PRIVATE LIMITED",
"MONEYMART CONSULTANTS PRIVATE LIMITED",
"MONEYMART SECURITIES PRIVATE LIMITED",
"MONEYMAX FINGROW PRIVATE LIMITED",
"MONEYMITHRA SERVICES PRIVATE LIMITED",
"MONEYMITRA IT SOLUTIONS PRIVATE LIMITED",
"MONEYMUTTATH NIDHI LIMITED",
"MONEYPACKERS INDIA PRIVATE LIMITED",
"MONEYPALM INVESTMENT SOLUTIONS PRIVATE LIMITED",
"MONEYPALM WEALTH PRIVATE LIMITED",
"MONEYPLANT ESTATES PRIVATE LIMITED",
"MONEYPLUS CAPITAL AND FINANCE PRIVATE LIMITED",
"MONEYPLUS FINANCIAL SERVICES PRIVATE LIMITED",
"MONEYWISE FINANCIAL SERVICES PRIVATE LIMITED",
"MONEYWISE FINVEST LIMITED",
"MONEYWORX CONSULTING PRIVATE LIMITED",
"MONFORT AI HR SEC SCHOOL",
"MONGA BROTHERS LIMITED",
"MONGA CONTINENTAL PRIVATE LIMITED",
"MONGA IMPEX PVT LTD",
"MONGA IRON AND STEEL PRIVATE LIMITED",
"MONGA REALTORS PRIVATE LIMITED",
"MONGA STRAYFIELD PRIVATE LIMITED",
"MONGA SWEETS PRIVATE LIMITED",
"MONGA TRADEX PRIVATE LIMITED",
"MONGA TYRES PRIVATE LIMITED",
"MONGIA STEEL LIMITED",
"MONGIA VENTURES PRIVATE LIMITED",
"MONGINIS FOODS PRIVATE LIMITED",
"MONGODB SOFTWARE INDIA PRIVATE LIMITED",
"MONI DESIGNER WEAR PRIVATE LIMITED",
"MONIBA ANAND ELECTRICALS PVT LTD",
"MONICA CARDS PRIVATE LIMITED",
"MONICA CONSTROTECH PRIVATE LIMITED",
"MONICA ENTERPRISES PRIVATE LIMITED",
"MONICA GALAXY PVT LTD",
"MONICA GARMENTS",
"MONICA GRAPHICS",
"MONICA MIRACLE ELECTRONICS (INDIA) LIMITED",
"MONICA STEELS PRIVATE LIMITED",
"MONICACOT MILLS PRIVATE LIMITED",
"MONICHEM ADHESIVES PRIVATE LIMITED",
"MONICHEM HEALTH CARE PRIVATE LIMITED",
"MONIER ROOFING PRIVATE LIMITED",
"MONIKA BUILDERS AND DEVELOPERS",
"MONIKA COLLECTION PRIVATE LIMITED",
"MONIKA INFRASTRUCTURE PRIVATE LIMITED",
"MONIKA SAREES PRIVATE LIMITED",
"MONILEK HOSPITAL & RESEARCH CENTRE",
"MONIN INDIA PRIVATE LIMITED",
"MONIQUE PHARMACEUTICALS PRIVATE LIMITED",
"MONISH FINANCIAL SERVICES PRIVATE LIMITED",
"MONISH INVESTMENTS PRIVATE LIMITED",
"MONISHA CORP PRIVATE LIMITED",
"MONIT TRADING PRIVATE LIMITED",
"MONITRON SECURITY PRIVATE LIMITED",
"MONITRON SUPPORT SERVICES PRIVATE LIMITED",
"MONJIN INTERVIEWS PRIVATE LIMITED",
"MONK & MEI PRIVATE LIMITED",
"MONK AKARSHALA PRIVATE LIMITED",
"MONK AUTOMATION PRIVATE LIMITED",
"MONK BHAVAN PRIVATE LIMITED",
"MONK ENGINEERS PRIVATE LIMITED",
"MONK REALTY SOLUTIONS PRIVATE LIMITED",
"MONKEY WRENCH COMMUNICATIONS PRIVATE LIMITED",
"MONNAIE INTERIOR DESIGNERS PRIVATE LIMITED",
"MONNET DANIELS COAL WASHERIES LIMITED",
"MONNET DAV PUBLIC SCHOOL",
"MONNET INTERNATIONAL LIMITED",
"MONO ORION FOODS INDIA PRIVATE LIMITED",
"MONO PACKAGING PRIVATE LIMITED",
"MONO STEEL INDIA LIMITED",
"MONOCEPT CONSULTING PRIVATE LIMITED",
"MONOCHEM GRAPHICS PRIVATE LIMITED",
"MONOCOAT ASIA PRIVATE LIMITED",
"MONOCRAFT PRIVATE LIMITED",
"MONOGRAM TEXTILE PROCESSORS PVT LTD",
"MONOLINE LASER AND ROBOTICS MACHINERY PRIVATE LIMITED",
"MONOLITH TECHNOLOGIES PRIVATE LIMITED",
"MONOLITHISCH INDIA PRIVATE LIMITED",
"MONOLOM INDIA PHARMA PRIVATE LIMITED",
"MONOMARK ENGINEERING (INDIA) PRIVATE LIMITED",
"MONOMER CHEMICAL INDUSTRIES LIMITED",
"MONOPOL CHEMICALS PRIVATE LIMITED",
"MONOPOL COLORS INDIA PRIVATE LIMITED",
"MONOPOLE SYSTEMS LLP",
"MONOPOLY CARRIERS AND CARGO PRIVATE LIMITED",
"MONOPOLY EXPRESS CARGO MUMBAI PRIVATE LIMITED",
"MONOPOLY INNOVATIONS LIMITED",
"MONOPOLY INNOVATIONS PRIVATE LIMITED",
"MONORAMA DAIRY & FOODS PRIVATE LIMITED",
"MONORAMA ULTRASCAN PRIVATE LIMITED",
"MONOTECH INFRA SERVICES PRIVATE LIMITED",
"MONOTECH SYSTEMS LIMITED",
"MONOTYPE SOLUTIONS INDIA PRIVATE LIMITED",
"MONOZYGOTIC SOLUTIONS PRIVATE LIMITED",
"MONROVIA AGRO FOODS PRIVATE LIMITED",
"MONSA FOODS PRIVATE LIMITED",
"MONSANTO COMPANY",
"BAYER SCIENCE AND INNOVATION PRIVATE LIMITED",
"MONSHER FIRE PROTECTION SYSTEMS PRIVATE LIMITED",
"MONSO INFRATEC PRIVATE LIMITED",
"MONSOON",
"MONSOON AGRO BIO PRIVATE LIMITED",
"MONSOON AGROCHEMICALS PRIVATE LIMITED",
"MONSOON BOUNTY FOODS MANUFACTURING PRIVATE LIMITED",
"MONSOON CREDITTECH PRIVATE LIMITED",
"MONSOON FABRICS PRIVATE LIMITED",
"MONSOON IMPEX PRIVATE LIMITED",
"MONSOON POLYMERS PRIVATE LIMITED",
"MONSTABOLIC NUTRITION PRIVATE LIMITED",
"MONSTER ENERGY INDIA PRIVATE LIMITED",
"MONSTER WHOLESALE PRIVATE LIMITED",
"MONSUN FOODS PRIVATE LIMITED",
"MONT BLANC PROPERTIES PRIVATE LIMITED",
"MONTAGE ENTERPRISES PRIVATE LIMITED",
"MONTAGE GLOBAL PRIVATE LIMITED",
"MONTAGE IMPEX PRIVATE LIMITED",
"MONTAGE LABORATORIES PRIVATE LIMITED",
"MONTAN HYDRAULIK (INDIA) PRIVATE LIMITED",
"MONTANA CONFECTIONERS PRIVATE LIMITED",
"MONTANA REMEDIES PRIVATE LIMITED",
"MONTANA SHIPPING AND CHARTERING PRIVATE LIMITED",
"MONTANA TILES PRIVATE LIMITED",
"MONTANARI LIFTS COMPONENTS PRIVATE LIMITED",
"MONTANE SHIPPING PRIVATE LIMITED",
"MONTAPLAST INDIA PRIVATE LIMITED",
"MONTARA INDIA PRIVATE LIMITED",
"MONTARY WIRE PRODUCTS PRIVATE LIMITED",
"MONTBLANC INDIA RETAIL PRIVATE LIMITED",
"MONTBLEU TECHNOLOGIES PRIVATE LIMITED",
"MONTE BIANCO DIAMOND TOOLS PRIVATE LIMITED",
"MONTE CARLO CONSTRUCTION",
"MONTE CARLO FASHIONS LIMITED",
"MONTE CARLO IMPEX PRIVATE LIMITED",
"MONTE PACK PRIVATE LIMITED",
"MONTECARLO AMRAVATI CHIKHLI HIGHWAY PRIVATE LIMITED",
"MONTECARLO BARJORA MINING PRIVATE LIMITED",
"MONTECARLO HUBLI HAVERI HIGHWAY PRIVATE LIMITED",
"MONTECARLO LIMITED",
"MONTECARLO MUNGER MIRZACHAUKI 1 HIGHWAY PRIVATE LIMITED",
"MONTECARLO MUNGER MIRZACHAUKI 3 HIGHWAY PRIVATE LIMITED",
"MONTECARLO SINGHARA BINJHABAHAL HIGHWAY PRIVATE LIMITED",
"MONTECARLO SINNAR SHIRDI HIGHWAY PRIVATE LIMITED",
"MONTECARLO VADODARA MUMBAI EXPRESSWAY PRIVATE LIMITED",
"MONTECINO TRADING PRIVATE LIMITED",
"MONTEDISON S.P.A.,",
"MONTEFERRO INDIA GUIDE RAILS AND ELEVATOR PARTS PRIVATE LIMITED",
"MONTEK SYSTEMS PRIVATE LIMITED",
"MONTEK TECH SERVICES PRIVATE LIMITED",
"MONTER SHIPPING & LOGISTICS INDIA PRIVATE LIMITED",
"MONTERIA RESORT PRIVATE LIMITED",
"MONTESSORI INDUS EM SCHOOL",
"MONTESSORI OLYMPUS SCHOOL",
"MONTEX FAMILY STORE PRIVATE LIMITED",
"MONTEX GLASS FIBRE INDUSTRIES PRIVATE LIMITED",
"MONTEXO AGRITECH SOLUTIONS PRIVATE LIMITED",
"MONTFORT INTER COLLEGE",
"MONTFORT MATRIC HIGHER SECONDARY SCHOOL",
"MONTFORT MATRIC HR SEC SCHOOL",
"MONTFORT MATRICULATION HIGHER SECONDARY SCHOOL",
"MONTFORT SCHOOL NAGPUR",
"MONTFORT SCHOOL ROORKEE",
"MONTFORT SEN SEC SCHOOL",
"MONTGOMERY FINANCE COMPANY PRIVATE LIMITED",
"MONTRAN CORPORATION INDIA PRIVATE LIMITED",
"MONTRIDGE SCHOOL",
"MONTRONICS ELECTRONICS PRIVATE LIMITED",
"MONTU MOTORS LIMITED",
"MONTU SHALLU KNITWEARS",
"MONTY FOREX PRIVATE LIMITED",
"MONTY TELECOM DEVELOPMENT PRIVATE LIMITED",
"MONTYCLOUD TECHNOLOGY SERVICES LLP",
"MONU MEMORIAL INSTITUTION",
"MONUMENTS ADVERTISERS PRIVATE LIMITED",
"MONVI LABORATORIES PRIVATE LIMITED",
"MONY PRINTS PRIVATE LIMITED",
"MONZADV PRIVATE LIMITED",
"MOOCHIKUNNANS HOTEL PRIVATE LIMITED",
"MOOD FOODS INDIA PRIVATE LIMITED",
"MOOD OF WOOD INDIA PRIVATE LIMITED",
"MOODY INTERNATIONAL CERTIFICATION INDIA LIMITED",
"MOODY INTERNATIONAL INDIA PRIVATE LIMITED",
"MOODY'S ANALYTICS INDIA PRIVATE LIMITED",
"MOODY'S INVESTMENT COMPANY INDIA PRIVATE LIMITED",
"MOODYS INVESTOR SERVICE",
"MOODYS SHARED SERVICES INDIA PRIVATE LIMITED",
"MOOFWD TECHNOLOGIES INDIA PRIVATE LIMITED",
"MOOG ADVANCE SYSTEMS PRIVATE LIMITED",
"MOOG CONTROLS (INDIA) PRIVATE LIMITED",
"MOOG CONTROLS INDIA PRIVATE LIMITED",
"MOOG INDIA TECHNOLOGY CENTER PRIVATE LIMITED",
"MOOG MOTION CONTROLS PRIVATE LIMITED",
"MOOGA TECH SOLUTIONS (INDIA) PRIVATE LIMITED",
"MOOGAMBIKAI COLLEGE OF PHYSIOTHERAPHY",
"MOOIJ INDIA TECHNOLOGIES PRIVATE LIMITED",
"MOOJIGAE ENTERPRISES PRIVATE LIMITED",
"MOOKERJEE ESTATES PVT LTD",
"MOOL CHAND EDIBLES PRIVATE LIMITED",
"MOOL CHAND SHYAMLAL ROLLER FLOUR MILLS PRIVATE LIMITED",
"MOOLAKARA WAYANAD SPICES PRIVATE LIMITED",
"MOOLANS ENTERPRISES PRIVATE LIMITED",
"MOOLANS INTERNATIONAL EXIM PRIVATE LIMITED",
"MOOLCHAND ASHOKKUMAR TEXFAB PRIVATE LIMITED",
"MOOLCHAND MILL PRIVATE LIMITED",
"MOOLCHAND MOTILAL SYNTEX PRIVATE LIMITED",
"MOOLJI JAITHA COLLEGE JALGAON",
"MOOLRAJ KANYA INTER COLLEGE",
"MOOLYA SOFTWARE TESTING PRIVATE LIMITED",
"MOOMARK PRIVATE LIMITED",
"MOON BERRY SERVICES PRIVATE LIMITED",
"MOON BEVERAGES LIMITED",
"MOON BUILDESTATES PRIVATE LIMITED",
"MOON CLEARING AND FORWARDERS PRIVATE LIMITED",
"MOON DIAMONDS",
"MOON EDUCATION PRIVATE LIMITED",
"MOON ENGINEERING WORKS PVT LTD",
"MOON FLIGHT SUPPORT PRIVATE LIMITED",
"MOON HERBAL LABORATORIES PRIVATE LIMITED",
"MOON HOSPITALS PRIVATE LIMITED",
"MOON INFRAZONE PRIVATE LIMITED",
"MOON LIGHT CATERERS PRIVATE LIMITED",
"MOON LIGHT METAL INDUSTRIES PVT LTD",
"MOON MATERNITY CARE INDIA PRIVATE LIMITED",
"MOON POWER ELECTRICALS PRIVATE LIMITED",
"MOON SEZ & MANAGEMENT CONSULTANTS LLP",
"MOON SEZ CONSULTANTS PRIVATE LIMITED",
"MOON STAR SECURITIES TRADING AND FINANCE COMPANY PRIVATE LIMITED",
"MOON STEELS AND GENERAL INDUSTRIES PRIVATE LIMITED",
"MOON STITCHES PRIVATE LIMITED",
"MOON SYNDICAT",
"MOON TECHNOLABS PRIVATE LIMITED",
"MOON URECAST PRIVATE LIMITED",
"MOONA CONSULTING INDIA PRIVATE LIMITED",
"MOONAIR SALES AND SERVICES PRIVATE LIMITED",
"MOONBEAM ADVISORY PRIVATE LIMITED",
"MOONBOOT OIL PRIVATE LIMITED",
"MOONCHILD MEDIA PRIVATE LIMITED",
"MOONCITY ADVISORS PRIVATE LIMITED",
"MOONDROP CHEMINEERS PRIVATE LIMITED",
"MOONDROPS INTERNATIONAL HOLIDAYS PRIVATE LIMITED",
"MOONDUST AGRO PROJECTS PRIVATE LIMITED",
"MOONDUST PAPER PRIVATE LIMITED",
"MOONET PAPERS PRIVATE LIMITED",
"MOONFROG LABS PRIVATE LIMITED",
"MOONGIPA CAPITAL FINANCE LIMITED",
"MOONGIPA INDUSTRIES LIMITED",
"MOONGIPA LOGISTICS PRIVATE LIMITED",
"MOONGIPA ROADWAYS PRIVATE LIMITED",
"MOONGIPA SYNTHETICS PRIVATE LIMITED",
"MOONGIPA TRANSPORT PRIVATE LIMITED",
"MOONGLADE SHIPPING AND LOGISTICS PRIVATE LIMITED",
"MOONHEIGHT SHIPTRANS LLP",
"MOONHOUSE PROJECTS LIMITED",
"MOONLAM PRIVATE LIMITED",
"MOONLIGHT AUTO PRIVATE LIMITED",
"MOONLIGHT AUTOMAT PRIVATE LIMITED",
"MOONLIGHT BUILDCON PRIVATE LIMITED",
"MOONLIGHT BUILDTECH PRIVATE LIMITED",
"MOONLIGHT CONSTRUCTION PVT.LTD.",
"MOONLIGHT CONTINENTAL PRIVATE LIMITED",
"MOONLIGHT DIE CASTING INDUSTRIES PRIVATE LIMITED",
"MOONLIGHT TOOLS PRIVATE LIMITED",
"MOONLIKE CONSTRUCTION PRIVATE LIMITED",
"MOONLIKE VINIMAY PRIVATE LIMITED",
"MOONLINE EXPRESS CARGO PRIVATE LIMITED",
"MOONLITE TECHNOCHEM PRIVATE. LIMITED.",
"MOONPRENEUR INDIA PRIVATE LIMITED",
"MOONRAFT INNOVATION LABS PRIVATE LIMITED",
"MOONREEF INNOVATIONS LLP",
"MOONROCK HOSPITALITY PRIVATE LIMITED",
"MOONS' INTELLIGENT MOTION SYSTEM INDIA PRIVATE LIMITED",
"MOONSHINE ESERVICES PRIVATE LIMITED",
"MOONSHINE HOSPITALITY PRIVATE LIMITED",
"MOONSHINE INFORMATION SERVICES PRIVATE LIMITED",
"MOONSHINE INFRACON PRIVATE LIMITED",
"MOONSHINE MEDIA PRIVATE LIMITED",
"MOONSHINE TECHNOLOGY PRIVATE LIMITED",
"MOONSHOT FOODWORKS PRIVATE LIMITED",
"MOONSTAR ENTERPRISES PRIVATE LIMITED",
"MOONSTAR LIFECARE PRIVATE LIMITED",
"MOONSTAR LINES PRIVATE LIMITED",
"MOONSTONE REALCON PRIVATE LIMITED",
"MOONWALK INFRAPROJECTS PRIVATE LIMITED",
"MOOOFARM PRIVATE LIMITED",
"MOOPENS ENERGY SOLUTIONS PRIVATE LIMITED",
"MOOPLE ANIMATION PRIVATE LIMITED",
"MOORJANI HOSPITALITY PRIVATE LIMITED",
"MOORTHY OFFSET PRINTERS PRIVATE LIMITED",
"MOOSA HAJI PATRAWALA PVT LTD",
"MOOSAJEE JEEVAJEE ENTERPRISE PRIVATE LIMITED",
"MOOSPRING DAIRY FARM PRIVATE LIMITED",
"MOOVAL DISTRIBUTORS PRIVATE LIMITED",
"MOOZOO FASHIONS PRIVATE LIMITED",
"MOP VAISHNAV COLLEGE FOR WOMEN",
"MOPA DISTRIBUTORS PRIVATE LIMITED",
"MOPASA INTERNATIONAL PRIVATE LIMITED",
"MOPATI LOGISTICS PRIVATE LIMITED",
"MOPE INVESTMENT ADVISORS PRIVATE LIMITED",
"MOPED HOUSE PRIVATE LIMITED",
"MOPP FOODS PRIVATE LIMITED",
"MOPSHOP DISTRIBUTION PRIVATE LIMITED",
"MOPTRA INFOTECH PRIVATE LIMITED",
"MOR ALLOYS PRIVATE LIMITED",
"MOR BAGH HOSPITALITY PRIVATE LIMITED",
"MOR BIO ENERGY PRIVATE LIMITED",
"MOR GOLD JEWELLERS PRIVATE LIMITED",
"MOR MUKAT MARKETING PRIVATE LIMITED",
"MOR TECHFAB PRIVATE LIMITED",
"MOR TRANSFORMERS AND CABLES PRIVATE LIMITED",
"MORA SALES (INDIA) PVT. LTD.",
"MORACEAE PHARMACEUTICALS PRIVATE LIMITED",
"MORADABAD BAREILLY EXPRESSWAY LIMITED",
"MORADABAD CORRUGATION CENTRE PRIVATE LIMITED",
"MORADABAD INTERNET SERVICES PRIVATE LIMITED",
"MORADABAD SMART CITY LIMITED",
"MORAE SERVICES INDIA PRIVATE LIMITED",
"MORAI INFRASTRUCTURE PRIVATE LIMITED",
"MORAINE HEALTH CARE PRIVATE LIMITED",
"MORAJ INFRATECH PRIVATE LIMITED",
"MORAL CERAMIC PRIVATE LIMITED",
"MORAL DEVELOPMENT PUBLIC SCHOOL",
"MORAL FIBER PRIVATE LIMITED",
"MORAL NUTRACEUTICALS PRIVATE LIMITED",
"MORAL PHARMACEUTICALS PRIVATE LIMITED",
"MORALISTIC ADVISORY PRIVATE LIMITED",
"MORARJEE TEXTILES LIMITED",
"MORARJI UMARSHI CLEARING AND FORWARDING PRIVATE LIMITED",
"MORARKA FINANCE LIMITED",
"MORARKA ORGANIC FOODS LIMITED",
"MORAS CHEMICALS INDIA PRIVATE LIMITED",
"MORAYA COLLECTION",
"MORAYA FEEDS PRIVATE LIMITED",
"MORAYA GLOBAL LIMITED",
"MORAYA PACKAGING INDIA PRIVATE LIMITED",
"MORAYA WOODPACK INDIA PRIVATE LIMITED",
"MORBIDO MERCHANDISE PRIVATE LIMITED",
"MORBIDO VINYL PRIVATE LIMITED",
"MORBIWALAS ENTERPRISE PRIVATE LIMITED",
"MORCEL BIOTECH PRIVATE LIMITED",
"MORCHEM PRIVATE LIMITED",
"MORCHHADI TEXTILE PRIVATE LIMITED",
"MORDE FOODS PRIVATE LIMITED",
"MORDOR INTELLIGENCE LLP",
"MORDOR INTELLIGENCE PRIVATE LIMITED",
"MORE 4 LESS ADVISORY SERVICES PRIVATE LIMITED",
"MORE BITES N FOODS PRIVATE LIMITED",
"MORE EVENTS PRIVATE LIMITED",
"MORE MARKETING PRIVATE LIMITED",
"MORE RETAIL PRIVATE LIMITED",
"MORE THAN BUILDERS PRIVATE LIMITED",
"MORE THAN SOLUTIONS PRIVATE LIMITED",
"MORECARE PHARMATEC PRIVATE LIMITED",
"MOREFUN COMMUNICATION PRIVATE LIMITED",
"MOREIND AUTOMATION PRIVATE LIMITED",
"MOREISH FOODS LIMITED",
"MOREL IMAGETONE SOLUTIONS PRIVATE LIMITED",
"MORELIFE LONDON PRIVATE LIMITED",
"MOREMAKES INDUSTRIES PRIVATE LIMITED",
"MORENA MOTORS PRIVATE LIMITED",
"MORENA TECHNOLOGIES PRIVATE LIMITED",
"MOREPAN HOTEL",
"MOREPEN LABORATORIES LIMITED",
"MOREPLUS MERCHANTS PRIVATE LIMITED",
"MORES FABRICS PRIVATE LIMITED",
"MORESCHI ASIA DOORS PRIVATE LIMITED",
"MORESCO HM&LUB INDIA PRIVATE LIMITED",
"MORESCO SOFTWARE SERVICES PRIVATE LIMITED",
"MORESECURE PACK SEALS PRIVATE LIMITED",
"MORESHWAR AGRO FEEDS PRIVATE LIMITED",
"MORESHWAR TRADING COMPANY PRIVATE LIMITED",
"MORESHWARA GLOBAL LOGISTICS PRIVATE LIMITED",
"MORETASKS BUSINESS SOLUTION PRIVATE LIMITED",
"MORETECH SOLUTIONS PRIVATE LIMITED",
"MOREWELL TUBES PRIVATE LIMITED",
"MOREX COMPOSITES PRIVATE LIMITED",
"MOREX INDUSTRIES PRIVATE LIMITED",
"MOREYEAHS IT TECHNOLOGIES PRIVATE LIMITED",
"MORF INDIA PRIVATE LIMITED",
"MORF WON DESIGN STUDIO PRIVATE LIMITED",
"MORGAIN CROP BIOSCIENCE PRIVATE LIMITED",
"MORGAN BEVERAGES PRIVATE LIMITED",
"MORGAN CREDITS PRIVATE LIMITED",
"MORGAN FINANCIAL SERVICES PVT LTD",
"MORGAN LIFESCIENCES PRIVATE LIMITED",
"MORGAN MCKINLEY SERVICES PRIVATE LIMITED",
"MORGAN MILK & DAIRY INDUSTRIES PRIVATE LIMITED",
"MORGAN PROPACK LIMITED",
"MORGAN SECURITIES AND CREDITS PRIVATE LIMITED",
"MORGAN STANLEY",
"MORGAN STANLEY ADVANTAGE SERVICES PRIVATE LIMITED",
"MORGAN STANLEY INDIA FINANCIAL SERVICES PRIVATE LIMITED",
"MORGAN STANLEY INDIA PRIMARY DEALER PRIVATE LIMITED",
"MORGAN STANLEY INDIA SECURITIES PRIVATE LIMITED",
"MORGAN STANLEY INVESTMENT MANAGEMENT PRIVATE LIMITED",
"MORGAN STANLEY SOLUTIONS INDIA PRIVATE LIMITED",
"MORGAN TOWERS PRIVATE LIMITED",
"MORGAN VENTURES LIMITED",
"MORGANITE CRUCIBLE INDIA LIMITED",
"MORI SEIKI INDIA PRIVATE LIMITED",
"MORI SPINNING PRIVATE LIMITED",
"MORIAH GRANITES PRIVATE LIMITED",
"MORIANI PLASTICS PRIVATE LIMITED",
"MORIAS INFRASTRUCTURE PRIVATE LIMITED",
"MORIKS SHIPPING AND TRADING PRIVATE LIMITED",
"MORIMURA BROTHERS TRADING INDIA PRIVATE LIMITED",
"MORINDA RICE AND GEN. MILLS",
"MORINE TECH INDIA PRIVATE LIMITED",
"MORINGA FRONTIERS PRIVATE LIMITED",
"MORINGO ORGANICS PRIVATE LIMITED",
"MORIROKU CHEMICALS INDIA PRIVATE LIMITED",
"MORIROKU TECHNOLOGY INDIA PRIVATE LIMITED",
"MORIS ACCESSORIES PRIVATE LIMITED",
"MORISIKO AUTO TECH PRIVATE LIMITED",
"MORISSON TRADERS & DEVELOPMENTS PVT LTD",
"MORJAR WINDFARM DEVELOPMENT PRIVATE LIMITED",
"MORLATIS ENGINEERING AND CONSTRUCTION PRIVATE LIMITED",
"MORMUGAO PORT TRUST",
"MORMUKUT EXIM PRIVATE LIMITED",
"MORNEE FASHIONS PRIVATE LIMITED",
"MORNI SAREES PRIVATE LIMITED",
"MORNING COMMOSALE PRIVATE LIMITED",
"MORNING GLORY INFRA LIMITED",
"MORNING GLORY VINIMAY PRIVATE LIMITED",
"MORNING STAAR APPARELS",
"MORNING STAR COLLEGE",
"MORNING STAR SCHOOL RATLAM",
"MORNING STAR SHIPPING AND TRADING PRIVATE LIMITED",
"MORNING STORES NKM PRIVATE LIMITED.",
"MORNINGSIDE HEALTHCARE INDIA PRIVATE LIMITED",
"MORNINGSTAR INDIA PRIVATE LIMITED",
"MOROLI HOSPITAL PRIVATE LIMITED",
"MORPAWALA REALCON PRIVATE LIMITED",
"MORPH",
"MORPH DIGITAL SOLUTIONS PRIVATE LIMITED",
"MORPH INTERIO PRIVATE LIMITED",
"MORPHEDO TECHNOLOGIES PRIVATE LIMITED",
"MORPHEME REMEDIES PRIVATE LIMITED",
"MORPHEUS LIFE SCIENCES PRIVATE LIMITED",
"MORPHEUS SECURITY PRIVATE LIMITED",
"MORPHEUS SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED",
"MORPHEUS VFX STUDIOS PRIVATE LIMITED",
"MORPHIC METAL CONCEPTS PRIVATE LIMITED",
"MORPHING INOVATIONS PRIVATE LIMITED",
"MORPHING INOVATIONSOPC PRIVATE LIMITED",
"MORPHISEC INFORMATION SECURITY 2014 INDI A LLP",
"MORPHLE LABS PRIVATE LIMITED",
"MORPHOGENESIS ENGINEERING CONSULTANTS PRIVATE LIMITED",
"MORPHOGENESIS REALTY PRIVATE LIMITED",
"MORRIES ENERGY LIMITED",
"MORRIKO PURE FOODS PRIVATE LIMITED",
"MORRILL AND GREENWOOD DEVELOPERS PRIVATE LIMITED",
"MORRIS STREET ADVISORS PRIVATE LIMITED",
"MORRISONS LIFECARE PRIVATE LIMITED",
"MORSEF PHARMACEUTICALS PRIVATE LIMITED",
"MORSEL ENGGTECH PRIVATE LIMITED",
"MORSEL RESEARCH AND DEVELOPMENT PRIVATE LIMITED",
"MORTEK MACHINERY PRIVATE LIMITED",
"MORTISE FURNITURES PRIVATE LIMITED",
"MORTON FOODS LIMITED",
"MORULAA HEALTHTECH PRIVATE LIMITED",
"MORVEL LABORATORIES PRIVATE LIMITED",
"MORVI AUTOWHEELS PRIVATE LIMITED",
"MORVIN INDIA HEALTH CARE PRIVATE LIMITED",
"MORWAL FABRICS PRIVATE LIMITED",
"MORWAN CONSTRUCTIONS PRIVATE LIMITED",
"MORWELL PHARMACIA PRIVATE LIMITED",
"MORYA ASSOCIATES",
"MORYA CARS PRIVATE LIMITED",
"MORYA CASTOR PRIVATE LIMITED",
"MORYA FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"MORYA HOSPITAL PRIVATE LIMITED",
"MORYA INFRACONSTRUCT PRIVATE LIMITED",
"MORYA LABELS PRIVATE LIMITED",
"MORYA MULTI SPECIALITY HOSPITAL",
"MORYA SOLUTIONS & FACILITIES PRIVATE LIMITED",
"MORYA STEEL PRIVATE LIMITED",
"MORYA SYNTEX PRIVATE LIMITED",
"MORYAAS DIGITAL PRIVATE LIMITED",
"MORZARIA REAL TECH PRIVATE LIMITED",
"MOS IMMIGRATION PRIVATE LIMITED",
"MOS LOGI TECHNOLOGIES PRIVATE LIMITED",
"MOS UTILITY LIMITED",
"MOS UTILITY PRIVATE LIMITED",
"MOSAA FOUNDATION FOR AGRICULTURE SCIENCE TRAINING EDUCATION AND RESEARCH",
"MOSAD IT SOLUTIONS PRIVATE LIMITED",
"MOSAIC CAPITAL SERVICES PRIVATE LIMITED",
"MOSAIC ENGINEERING PRIVATE LIMITED",
"MOSAIC ENTERPRISES LIMITED",
"MOSAIC GLOBAL PRIVATE LIMITED",
"MOSAIC HOUSEWARE PRIVATE LIMITED",
"MOSAIC INDIA PRIVATE LIMITED",
"MOSAIC INFRA CONCEPTS (INDIA) PRIVATE LIMITED",
"MOSAIC ITES SERVICES PRIVATE LIMITED",
"MOSAIC LEISURES PRIVATE LIMITED",
"MOSAIC MEDIA VENTURES PRIVATE LIMITED",
"MOSAIC WELLNESS PRIVATE LIMITED",
"MOSAIC WORKSKILLS PRIVATE LIMITED",
"MOSAIK ANALYTICS SOLUTIONS PRIVATE LIMITED",
"MOSARAM BHAGWANDAS ENTERPRISES PRIVATE LIMITED",
"MOSARAM CONSUMER PRODUCTS PRIVATE LIMITED",
"MOSARAM ENTERPRISES LIMITED",
"MOSARAM MOTORS PRIVATE LIMITED",
"MOSARAM TECH PRIVATE LIMITED",
"MOSARAM TELECOM PRIVATE LIMITED",
"MOSAVI ENTERPRISES PRIVATE LIMITED",
"MOSAY INTERNATIONAL PRIVATE LIMITED",
"MOSCHIP TECHNOLOGIES LIMITED",
"MOSCO INTERNATIONAL COMMODITIES PRIVATE LIMITED",
"MOSCO PRINTS INDIA PRIVATE LIMITED",
"MOSCOT EXPORTS PRIVATE LIMITED",
"MOSDORFER INDIA PRIVATE LIMITED",
"MOSERP TECHNOLOGIES INDIA PRIVATE LIMITED",
"MOSES INDUSTRIES PRIVATE LIMITED",
"MOSFET HEALTHCARE PRIVATE LIMITED",
"MOSH VARAYA INFRASTRUCTURE LIMITED",
"MOSHES FINE FOODS PRIVATE LIMITED",
"MOSHINE ELECTRONICS PRIVATE LIMITED",
"MOSHPIT TECHNOLOGIES PRIVATE LIMITED",
"MOSIAC LAND DEVELOPERS PRIVATE LIMITED",
"MOSIL LUBRICANTS PRIVATE LIMITED",
"MOSMETRO INDIA PRIVATE LIMITED",
"MOSONS EXTRACTIONS PRIVATE LIMITED",
"MOSRIMAA INFRA PRIVATE LIMITED",
"MOSS HOSPITALITY PRIVATE LIMITED",
"MOSS REALTORS PRIVATE LIMITED",
"MOSUS INFRASTRUCTURES PRIVATE LIMITED",
"MOSYS INDIA PRIVATE LIMITED",
"MOT JUSTE COMMUNICATION SERVICES PRIVATE LIMITED",
"MOTA AUTOMOTIVE PRIVATE LIMITED",
"MOTA BHAI VASTRALYA PRIVATE LIMITED",
"MOTA FOODS AND STORES PRIVATE LIMITED",
"MOTA TRADING PRIVATE LIMITED",
"MOTAN-COLORTRONIC PLASTICS MACHINERY INDIA PRIVATE LIMITED",
"MOTCAB FINANCE PRIVATE LIMITED",
"MOTEL DAMJI'S (GUJRAT) PRIVATE LIMITED",
"MOTEL NAGPAL REGENCY PRIVATE LIMITED",
"MOTEX PETROCHEM PRIVATE LIMITED",
"MOTEX TRADERS PVT LTD",
"MOTH MUSIC RECORDS PRIVATE LIMITED",
"MOTHER AND BABY CARE INC",
"MOTHER ATHENA SCHOOL BUDAUN",
"MOTHER CARE HOLIDAYS RESORTS PRIVATE LIMITED",
"MOTHER CHEM INDIA PRIVATE LIMITED",
"MOTHER DAIRY",
"MOTHER DAIRY FRUIT AND VEGETABLE PRIVATE LIMITED",
"MOTHER EARTH ENVIRON TECH PRIVATE LIMITED",
"MOTHER EARTH RESOURCES PRIVATE LIMITED",
"MOTHER HITECH BOARDS PRIVATE LIMITED",
"MOTHER HOSPITAL",
"MOTHER INDIA AGROFOODS PRIVATE LIMITED",
"MOTHER INDIA CONSTRUCTION PVT. LTD.",
"MOTHER INDIA FORMING PRIVATE LIMITED",
"MOTHER INDIA INTERNATIONAL LIMITED",
"MOTHER INDIA ORGANICS AND NATURALS PRIVATE LIMITED",
"MOTHER INDIA REFRIGERATION INDUSTRIES PRIVATE LIMITED",
"MOTHER INDIA SECURITIES PRIVATE LIMITED",
"MOTHER LAM PRIVATE LIMITED",
"MOTHER LAND TEXTILE INDIA PRIVATE LIMITED",
"MOTHER MARY TOURS AND TRAVELS PRIVATE LIMITED",
"MOTHER POWERHOUSE PRIVATE LIMITED",
"MOTHER S AGRO FOODS PRIVATE LIMITED",
"MOTHER SPARSH BABY CARE PRIVATE LIMITED",
"MOTHER TEACHER INTERNATIONAL SCHOOL",
"MOTHER TEACHER PREPARATORY SCHOOL",
"MOTHER TERASA LAW COLLEGE",
"MOTHER TERESA HARYANA SAKET COUNCIL CHANDIMANDOR",
"MOTHER TERESA MISSION HIGHER SECONDARY SCHOOL",
"MOTHER TERESA MULTISPECIALITY HOSPITAL",
"MOTHER TERESA NURSING SCHOOL",
"MOTHER THERESA POST GRADUATE & RESEARCH INSTITUTE OF HEALTH SCIENCES",
"MOTHER THERESA WOMENS UNIVERSITY",
"MOTHER THERESSA EDUCATIONAL SOCIETY",
"MOTHER ZAINAB JUNIOR SCIENCE COLLEGE",
"MOTHERCARE PACKAGING PRIVATE LIMITED",
"MOTHERCARE SOURCING INDIA PRIVATE LIMITED",
"MOTHERCELL BIOSCIENCES PRIVATE LIMITED",
"MOTHERCODE SOFTWARE SYSTEMS PRIVATE LIMITED",
"MOTHERHOOD INSTITUTE OF MANAGEMENT AND TECHNOLOGY",
"MOTHERHOOD UNIVERSITY",
"MOTHERHOOD WOMEN'S & CHILD CARE HOSPITAL PRIVATE LIMITED",
"MOTHERLAND EBUSINESS PRIVATE LIMITED",
"MOTHERLAND GARMENTS PRIVATE LIMITED",
"MOTHERLAND JOINT VENTURES PRIVATE LIMITED",
"MOTHERLAND TEA PLANTATION PRIVATE LIMITED",
"MOTHERS CERAMICS & TILES PRIVATE LIMITED",
"MOTHER'S EYE PRODUCTION PRIVATE LIMITED",
"MOTHER'S HOSPITALITY PRIVATE LIMITED",
"MOTHER'S PET EDUCATION SOCIETY",
"MOTHERS PET KINDERGARTEN",
"MOTHERS PUBLIC SCHOOL",
"MOTHERSHREE COLD STORAGE PRIVATE LIMITED",
"MOTHERSON ADVANCED TOOLING SOLUTIONS LIMITED",
"MOTHERSON AIR TRAVEL AGENCIES LIMITED",
"MOTHERSON AUTO LIMITED",
"MOTHERSON AUTO SOLUTIONS LIMITED",
"MOTHERSON AUTOMOTIVE TECHNOLOGIES & ENGINEERING",
"MOTHERSON BERGSTROM HVAC SOLUTIONS PRIVATE LIMITED",
"MOTHERSON CONSULTANCIES SERVICE LIMITED",
"MOTHERSON ENGINEERING RESEARCH & INTEGRATED TECHNOLOGIES LIMITED",
"MOTHERSON INNOVATIONS TECH LIMITED",
"MOTHERSON INVENZEN XLAB PRIVATE LIMITED",
"MOTHERSON LEASE SOLUTION LIMITED",
"MOTHERSON MACHINERY AND AUTOMATIONS LIMITED",
"MOTHERSON MOLDS AND DIECASTING LIMITED",
"MOTHERSON SPIRITED AUTO RETAILS INDIA LIMITED",
"MOTHERSON SUMI SYSTEMS LIMITED",
"MOTHERSON SUMI WIRING INDIA LIMITED",
"MOTHERSON TECHNO TOOLS LIMITED",
"MOTHERSON TECHNOLOGY SERVICES LIMITED",
"MOTHERTOUCH PUBLICATIONS INDIA PRIVATE LIMITED",
"MOTHI SPINNER LIMITED",
"MOTI AAHAR PRIVATE LIMITED",
"MOTI INDUSTRIES",
"MOTI INSECTICIDES PRIVATE LIMITED",
"MOTI INTERNATIONAL PRIVATE LIMITED",
"MOTI LAL NEHRU MEDICAL COLLEGE",
"MOTI LAMINATES PVT LTD",
"MOTI MAHAL FOODS PRIVATE LIMITED",
"MOTI NAMKEEN PRIVATE LIMITED",
"MOTI PLASTICS AND ESTATES PRIVATE LIMITED",
"MOTI POLYMERS PVT LTD",
"MOTI POULTRY DEVELOPERS PRIVATE LIMITED",
"MOTI PRIVATE LIMITED",
"MOTI RESEARCH AND DIAGNOSTICS LIMITED",
"MOTI SOAP FACTORY PRIVATE LIMITED",
"MOTI SURGICAL UDYOG PRIVATE LIMITED",
"MOTI TEXTILES PRIVATE LIMITED",
"MOTI VAV PRIMARY SCHOOL",
"MOTIAZ PRIVATE LIMITED",
"MOTIF DEKOR PRIVATE LIMITED",
"MOTIF ENGINEERS PRIVATE LIMITED",
"MOTIF GRAPHICS PRIVATE LIMITED",
"MOTIF INDIA INFOTECH PRIVATE LIMITED",
"MOTIFWORKS INDIA PRIVATE LIMITED",
"MOTIFWORKS TECHNOLOGY SOLUTIONS LLP",
"MOTIJHEEL COLLEGE",
"MOTIKA ROADWAYS PVT LTD",
"MOTIL DEVI ORGANIC FOOD INDUSTRIES PRIVATE LIMITED",
"MOTILAL DHOOT SAND AND STONE PRIVATE LIMITED",
"MOTILAL DISHED-ENDS WORKS PRIVATE LIMITED",
"MOTILAL DULI CHAND PRIVATE LIMITED",
"MOTILAL LAXMINARAYAN CONSTRUCTIONS PRIVATE LIMITED",
"MOTILAL MAHESH PRASAD TRADING CO. PRIVATE LIMITED",
"MOTILAL NEHRU COLLEGE",
"MOTILAL OSWAL ASSET MANAGEMENT COMPANY LIMITED",
"MOTILAL OSWAL BROKING AND DISTRIBUTION LIMITED",
"MOTILAL OSWAL CAPITAL MARKETS PRIVATE LIMITED",
"MOTILAL OSWAL COMMODITIES BROKER PRIVATE LIMITED",
"MOTILAL OSWAL FINANCIAL SERVICES LIMITED",
"MOTILAL OSWAL FINSEC IFSC LIMITED",
"MOTILAL OSWAL FINVEST LIMITED",
"MOTILAL OSWAL HOME FINANCE LIMITED",
"MOTILAL OSWAL INSURANCE BROKERS PRIVATE LIMITED",
"MOTILAL OSWAL INVESTMENT ADVISORS LIMITED",
"MOTILAL OSWAL INVESTMENT ADVISORS PRIVATE LIMITED",
"MOTILAL OSWAL SECURITIES INTERNATIONAL PRIVATE LIMITED",
"MOTILAL OSWAL WEALTH MANAGEMENT LIMITED",
"MOTILAL PADAMPAT UDYOG PRIVATE LIMITED",
"MOTIMALA TRADING PRIVATE LIMITED",
"MOTION & PACOLLS PRIVATE LIMITED",
"MOTION DRIVETRONICS PRIVATE LIMITED",
"MOTION DYNAMICS PRIVATE LIMITED",
"MOTION FLUID TECHNOLOGY PRIVATE LIMITED",
"MOTION IDENTIX INDIA PRIVATE LIMITED",
"MOTION MAKERS ANIMATION STUDIO PRIVATE LIMITED",
"MOTION METRIKS COMPONENTS PRIVATE LIMITED",
"MOTION PHILM CGI PRIVATE LIMITED",
"MOTION TECHNIQUE (INDIA) PRIVATE LIMITED",
"MOTIONMAN SCOOTERS PRIVATE LIMITED",
"MOTIONUP HANDLING PRIVATE LIMITED",
"MOTIPRABHA INFRATECH PRIVATE LIMITED",
"MOTIPRABHA SB INDUSTRIES PRIVATE LIMITED",
"MOTIPURA PAGAR KENDRA SHALA",
"MOTIRAM KUNDANDAS GRAIN MERCHANTS LIMITED",
"MOTISONS COMMODITIES PRIVATE LIMITED",
"MOTISONS GLOBAL PRIVATE LIMITED",
"MOTISONS JEWELLERS LIMITED",
"MOTISONS SHARES PRIVATE LIMITED",
"MOTIVE AGRO OILS PRIVATE LIMITED",
"MOTIVEER ENTERPRISE PRIVATE LIMITED",
"MOTIVEMINDS CONSULTING PRIVATE LIMITED",
"MOTIVITY LABS PRIVATE LIMITED",
"MOTIWALA & SONS GOLD & DIAMONDS PRIVATE LIMITED",
"MOTIWALA COLLEGE OF PHYSIOTHERAPY",
"MOTIWALA JEWELLERY EXPORTS PRIVATE LIMITED",
"MOTIWALA STEEL PRIVATE LIMITED",
"MOTIWALE H. A. GEMS & PEARLS PRIVATE LIMITED",
"MOTLEY APPLIANCES PRIVATE LIMITED",
"MOTLEY WRENCHYARN PRIVATE LIMITED",
"MOTO CONTROLS PRIVATE LIMITED",
"MOTO SPORTS ACCESSORIES (INDIA) PRIVATE LIMITED",
"MOTO TECHNICA HYDRO PARTS PRIVATE LIMITED",
"MOTO TECHNOLOGY PRIVATE LIMITED",
"MOTOCARE INDIA PRIVATE LIMITED",
"MOTOCAST POWER ALLOYS PRIVATE LIMITED",
"MOTOCRUIZER TECHNOLOGIES INDIA PRIVATE LIMITED",
"MOTODEN AUTOMOTIVE PRIVATE LIMITED",
"MOTOHUNGER PRIVATE LIMITED",
"MOTOLOGIC AUTO PRIVATE LIMITED",
"MOTOMATE INFO VENTURES PRIVATE LIMITED",
"MOTONAS LUBE (INDIA) PRIVATE LIMITED",
"MOTONOVA MOBILITY PRIVATE LIMITED",
"MOTONOVA SUPERBIKES PRIVATE LIMITED",
"MOTOR AND GENERAL SALES PRIVATE LIMITED",
"MOTOR FUEL & STORES PVT LTD",
"MOTOR HEAVEN PRIVATE LIMITED",
"MOTOR HOUSE LTD",
"MOTOR SALES PRIVATE LIMITED",
"MOTOR WORLD PRIVATE LIMITED",
"MOTORCRAFT INDIA PRIVATE LIMITED",
"MOTORCRAFT SALES PRIVATE LIMITED",
"MOTORFAB SALES PRIVATE LIMITED",
"MOTORLINE AUTO PRIVATE LIMITED",
"MOTORMISTRI.COM PRIVATE LIMITED",
"MOTOROIL LUBRICANTS PRIVATE LIMITED",
"MOTOROLA AUTO INDIA PRIVATE LIMITED",
"MOTOROLA MOBILITY CHENNAI PRIVATE LIMITED",
"MOTOROLA MOBILITY INDIA PRIVATE LIMITED",
"MOTOROLA SOLUTIONS INC.",
"MOTORONE INDIA PRIVATE LIMITED",
"MOTOSPEED INDUSTRIES PRIVATE LIMITED",
"MOTOSUAVE PRIVATE LIMITED",
"MOTOTECH HARNESSING SOLUTIONS PRIVATE LIMITED",
"MOTOWORKS AUTOMOBILES PRIVATE LIMITED",
"MOTOZEN FUEL SYSTEMS PRIVATE LIMITED",
"MOTRAC MOTORS PRIVATE LIMITED",
"MOTRADE PRIVATE LIMITED",
"MOTRAS SCIENTIFIC INSTRUMENTS PRIVATE LIMITED",
"MOTREX AUTOMOTIVE INDIA PRIVATE LIMITED",
"MOTS REALTORS & TRADING PRIVATE LIMITED",
"MOTT MACDONALD PRIVATE LIMITED",
"MOTTO STONE PRIVATE LIMITED",
"MOTTO TILES PRIVATE LIMITED",
"MOTTOTECH INDUSTRIES PRIVATE LIMITED",
"MOTUL INDIA PRIVATE LIMITED",
"MOTUS ENTERPRISE PRIVATE LIMITED",
"MOTUS MERCHANDISE PRIVATE LIMITED",
"MOTVIC ENGINEERING GLOBAL PRIVATE LIMITED",
"MOTWANE CONSULTANCY PRIVATE LIMITED",
"MOTWANI CERAMICS PRIVATE LIMITED",
"MOUAR CONSTRUCTION PRIVATE LIMITED",
"MOUJI SILK MILLS PRIVATE LIMITED",
"MOUKTHIKA ENTERPRISES PRIVATE LIMITED",
"MOUKTIK CONSULTING SERVICES PRIVATE LIMITED",
"MOULANA ABDUL KALAM HIGH SCHOOL SUBHASHNAGAR",
"MOULANA AZAD COLLEGE",
"MOULANA AZAD URDU HIGH SCHOOL DARYAPUR",
"MOULANA COMPANY PRIVATE LIMITED",
"MOULANA HOSPITAL",
"MOULD ENGINEERING AND CONSTRUCTION PRIVATE LIMITED",
"MOULD INJECTION TECHNOLOGY PRIVATE LIMITED",
"MOULD MAKERS PRIVATE LIMITED",
"MOULD TECH",
"MOULDERS SITARAM INDIA PRIVATE LIMITED",
"MOULDING MACHINE MANUFACTURING PRIVATE LIMITED",
"MOULI SPINNER LIMITED",
"MOULIK TECHNOCAST PRIVATE LIMITED",
"MOULIS ADVERTISING SERVICE PRIVATE LIMITED",
"MOULYA TECHSOLUTIONS PRIVATE LIMITED",
"MOUNISH HOSPITALITY PRIVATE LIMITED",
"MOUNT ABU BUILDWELL PRIVATE LIMITED",
"MOUNT ABU PUBLIC SCHOOL",
"MOUNT CARMEL CENTRAL SCHOOL",
"MOUNT CARMEL COLLEGE",
"MOUNT CARMEL ENG HIGH SCHOOL",
"MOUNT CARMEL HIGH SCHOOL",
"MOUNT CARMEL KINDERGARTEN",
"MOUNT CARMEL SCHOOL",
"MOUNT CARMEL SOCIETY PUNE",
"MOUNT CARMEL WOMENS COLLEGE",
"MOUNT COLD STORAGE PRIVATE LIMITED",
"MOUNT ENLIGHTENMENT INTERNATIONAL PRIVATE LIMITED",
"MOUNT EVEREST BREWERIES LIMITED",
"MOUNT GEO TECHNICAL SERVICES PRIVATE LIMITED",
"MOUNT HOSPITAL",
"MOUNT HOUSING AND INFRASTRUCTURE LIMITED",
"MOUNT INDEX INTERNATIONAL SCHOOL INDORE",
"MOUNT INFRA PROJECT",
"MOUNT INTRA FINANCE PVT LTD",
"MOUNT JUBLIANT INTERIORS PRIVATE LIMITED",
"MOUNT KAILASH HI-TECH INDUSTRIES PRIVATE LIMITED",
"MOUNT KAILASH PROCESSED FOODS PRIVATE LIMITED",
"MOUNT LITERA ZEE SCHOOL",
"MOUNT LITERA ZEE SCHOOL BALODA BAZAR",
"MOUNT MALTBRU LIMITED",
"MOUNT MARY ENGLISH HIGH SCHOOL & JR COLLEGE",
"MOUNT MED LIFE SCIENCES PRIVATE LIMITED",
"MOUNT MERU DESIGN PRIVATE LIMITED",
"MOUNT MERU GROUP",
"MOUNT MERU INDIA PRIVATE LIMITED",
"MOUNT MULTISPECIALITY HOSPITALS PRIVATE LIMITED",
"MOUNT OLIVET SENIOR SECONDARY SCHOOL",
"MOUNT OVERSEAS PRIVATE LIMITED",
"MOUNT PACKAGING MACHINERY PRIVATE LIMITED",
"MOUNT ROOFING AND STRUCTURES PRIVATE LIMITED",
"MOUNT SEENA COLLEGE OF ARTS AND SCIENCE",
"MOUNT SHIKHAR FINANCIAL SERVICES LIMITED",
"MOUNT TALENT CONSULTING PRIVATE LIMITED",
"MOUNT TOOLS & ACCESSORIES PRIVATE LIMITED",
"MOUNT VICTORIA GRANITES LIMITED",
"MOUNT VIEW BUILDESTATES PRIVATE LIMITED",
"MOUNT WAYNE IMPEX PRIVATE LIMITED",
"MOUNT ZION INTERNATIONAL SCHOOL",
"MOUNT ZION SCHOOL",
"MOUNTAIN ADVENTURES PRIVATE LIMITED",
"MOUNTAIN INN HOTELS PRIVATE LIMITED",
"MOUNTAIN MANAGERS PRIVATE LIMITED",
"MOUNTAIN MINERALS AND MICRONS LIMITED",
"MOUNTAIN RANGE PROPERTIES & RESORTS PRIVATE LIMITED",
"MOUNTAIN SHADOWS RESORTS PRIVATE LIMITED",
"MOUNTAIN SPRING PLASTICS INDIA PRIVATE LIMITED",
"MOUNTAIN STEELS PRIVATE LIMITED",
"MOUNTAIN TOUCH BUILDERS PRIVATE LIMITED",
"MOUNTAIN TOURS AND RESORTS HOTELS PRIVATE LIMITED",
"MOUNTAIN VALLEY SPRINGS INDIA PRIVATE LIMITED",
"MOUNTAINSTAR INDIA OFFICE PARKS PRIVATE LIMITED",
"MOUNTAINTOP INDUSTRIAL SERVICES PRIVATE LIMITED",
"MOUNTBLUE TECHNOLOGIES PRIVATE LIMITED",
"MOUNTHILL REALTY PRIVATE LIMITED",
"MOUNTING SOLAR-KIT PRIVATE LIMITED",
"MOUNTMINE IMPEX PRIVATE LIMITED",
"MOUNTO BRICKS PRIVATE LIMITED",
"MOUNTSKY SHIPPING PRIVATE LIMITED",
"MOUNTT AGROVET PRIVATE LIMITED",
"MOUNTVIEW TEA CO PRIVATE LIMITED",
"MOUPRIYA FOREX AND TRAVELS PRIVATE LIMITED",
"MOURI TECH LIMITED",
"MOURVINANDAN TRADERS & CONSULTANTS PRIVATE LIMITED",
"MOURYA AQUEX PRIVATE LIMITED",
"MOURYA CONCEPTS (OPC) PRIVATE LIMITED",
"MOURYA EDIBLES PRIVATE LIMITED",
"MOURYA ENCON PRIVATE LIMITED",
"MOURYA INFRAVENTURE PRIVATE LIMITED",
"MOURYA REALTY ASSOCIATES INDIA PRIVATE LIMITED",
"MOURYA SHIKSHAN SANSTHA",
"MOUSER ELECTRONICS INDIA PRIVATE LIMITED",
"MOUSTACHE INDUSTRIES PRIVATE LIMITED",
"MOUTHFUL RESTAURERS PRIVATE LIMITED",
"MOUTHSHUT COM INDIA PRIVATE LIMITED",
"MOUTHWATERING HOSPITALITY PRIVATE LIMITED",
"MOVA PHARMACEUTICALS PRIVATE LIMITED",
"MOVANTIS MOBILZA PRIVATE LIMITED",
"MOVAR LOGISTICS PRIVATE LIMITED",
"MOVATE TECHNOLOGIES PRIVATE LIMITED",
"MOVE CONSULTANTS PRIVATE LIMITED",
"MOVE OFFSHORE CALL CENTER PRIVATE LIMITED",
"MOVEINSYNC TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"MOVEMATE LOGISTICS PRIVATE LIMITED",
"MOVEMAX SYSTEM LOGISTICS PRIVATE LIMITED",
"MOVEMENT IMPEX TRADING CO.",
"MOVEON DELIVERY INTIME PRIVATE LIMITED",
"MOVEON MEDIA PRIVATE LIMITED",
"MOVEON TRADING PRIVATE LIMITED",
"MOVEON XPRESS PRIVATE LIMITED",
"MOVERS",
"MOVERS INTERNATIONAL CONSULTANCY PRIVATE LIMITED",
"MOVERS INTERNATIONAL FAIRS AND EVENTS PRIVATE LIMITED",
"MOVERS INTERNATIONAL PRIVATE LIMITED",
"MOVERS ON TIME PRIVATE LIMITED",
"MOVETECH CONVEYORS PRIVATE LIMITED",
"MOVETIME TECHNOLOGIES PRIVATE LIMITED",
"MOVEX AG. (INDIA) PRIVATE LIMITED",
"MOVEX CARGO PRIVATE LIMITED",
"MOVEX RELOCATIONS PRIVATE LIMITED",
"MOVEX SERVICES PRIVATE LIMITED",
"MOVEZ EV BUS (ONE) PRIVATE LIMITED",
"MOVI DIECASTER PRIVATE LIMITED",
"MOVIE TIME CINEMAS PRIVATE LIMITED",
"MOVIE TIME CINEPLEX PRIVATE LIMITED",
"MOVIE TIME MULTIPLEX PRIVATE LIMITED",
"MOVIE WORLD VISUAL MEDIA PRIVATE LIMITED",
"MOVIEMATH STUDIOS PRIVATE LIMITED",
"MOVILITAS INDIA LLP",
"MOVING D NEEDLE ENTERPRISE PRIVATE LIMITED",
"MOVING PIXELS PRIVATE LIMITED",
"MOVING WALLS INDIA PRIVATE LIMITED",
"MOVISH AUTOMOBILE PRIVATE LIMITED",
"MOVISH LOGISTICS PARK PRIVATE LIMITED",
"MOVISH MOTORS PRIVATE LIMITED",
"MOVISH REALTECH PRIVATE LIMITED",
"MOVIUS SOFTWARE PRIVATE LIMITED",
"MOVVA HEALTH CARE LLP",
"MOVVA HEALTH CARE MUMBAI LLP",
"MOVVA SECURITIES LIMITED",
"MOWEB TECHNOLOGIES PRIVATE LIMITED",
"MOWTHI NURSING HOME PRIVATE LIMITED",
"MOXA INDIA INDUSTRIAL NETWORKING PRIVATE LIMITED",
"MOXIE CAPITAL SERVICES PRIVATE LIMITED",
"MOXIE DEVICES PRIVATE LIMITED",
"MOXIE SUPPLY PRIVATE LIMITED",
"MOXIEIT DIGITAL PRIVATE LIMITED",
"MOXIKART INTERNET PRIVATE LIMITED",
"MOXIT GEMS PRIVATE LIMITED",
"MOXIT TEXTILE PRIVATE LIMITED",
"MOXPERT TRADESERVICES INDIA PRIVATE LIMITED",
"MOXSH OVERSEAS EDUCON LIMITED",
"MOXTRA SOLUTIONS PRIVATE LIMITED",
"MOYAA ENGINEERING PRIVATE LIMITED",
"MOYALAN AGRO PIPES",
"MOZAIQ AUTOMATION PRIVATE LIMITED",
"MOZAK FASHIONS PRIVATE LIMITED",
"M-OZARK MANAGEMENT CONSULTANCY PRIVATE LIMITED",
"MOZART HR FABRIKS PRIVATE LIMITED",
"MOZART IMPEX PRIVATE LIMITED",
"MOZART VITRIFIED PRIVATE LIMITED",
"MOZE TECH SOLUTIONS PRIVATE LIMITED",
"MOZILOR TECHNOLOGIES PRIVATE LIMITED",
"MP AKSHAYA MOTORS PRIVATE LIMITED",
"MP AUTOMOTORS PRIVATE LIMITED",
"MP BIOMEDICALS INDIA PRIVATE LIMITED",
"MP BIRLA HIGH SCHOOL CALCUTTA",
"MP BIRLA INSTITUTE OF MANAGEMENT",
"MP BORDER CHECKPOST DEVELOPMENT COMPANY LIMITED",
"MP CHRISTIAN COLLEGE OF ENG & TECH",
"MP CONSOL INDIA PRIVATE LIMITED",
"MP D REALTORS AND INFRASTRUCTURES LIMITED",
"MP DAY RAJYA GRAMIN AJIVIKA MISSION JILA SEHORE",
"MP ECO PRODUCTS PRIVATE LIMITED",
"MP ENSYSTEMS ADVISORY PRIVATE LIMITED",
"MP FILTRI INDIA PRIVATE LIMITED",
"MP GRAINS & FOODS (INDIA) PRIVATE LIMITED",
"MP HIGHWAYS PRIVATE LIMITED",
"MP HOLIDYAS",
"MP HUMAN RIGHTS COMMISSION",
"MP INDUSTRIAL DEVELOPMENT CORPORATION LIMITED",
"MP JAYPEE COAL LIMITED",
"MP MONNET MINING COMPANY LIMITED",
"MP OFFSHORE PRIVATE LIMITED",
"MP ONLINE LIMITED",
"MP PASHCHIM KSHETRA VIDYUT VITRAN CO LTD",
"MP POWER TRANSMISSION COMPANY LIMITED",
"MP POWER TRANSMISSION PACKAGE-I LIMITED",
"MP POWER TRANSMISSION PACKAGE-II LIMITED",
"MP RAJYA BEEJ EVAM FARM VIKAS NIGAM BHOPAL",
"MP RURAL ROAD DEVELOPMENT AUTHORITY JABALPUR",
"MP SARAF AND SD SARAF SERVICES PRIVATE LIMITED",
"MP SMART GRID PRIVATE LIMITED",
"MP SONS TRADING PRIVATE LIMITED",
"MP STATE AGRICULTURE MARKETING MANDI BOARD",
"MP STATE AIDS CONTROL SOCIETY BHOPAL",
"MP STATE COOPERATIVE DAIRY FEDERATION LTD",
"MP STATE ELECTION COMMISSION BPL",
"MP TRADE & INVESTMENT FACILITATION CORP LIMITED",
"MP VENEERS PRIVATE. LIMITED.",
"MP WAQF BOARD BHOPAL",
"MP2 TRANQUILITY CONSULTANCY PRIVATE LIMITED",
"MPA FINANCIAL SERVICES PRIVATE LIMITED",
"MPA FOOD PRODUCTS PRIVATE LIMITED",
"MPA INVESTMENT PRIVATE LIMITED",
"MPA PROJECTS PRIVATE LIMITED",
"MPAC CAREER PRIVATE LIMITED",
"MPACT FOREX PRIVATE LIMITED",
"MPC CLOUD CONSULTING PRIVATE LIMITED",
"MPC INFOTECH OPC PRIVATE LIMITED",
"MPCG MOBILE PRIVATE LIMITED",
"MPCL INDUSTRIES LIMITED",
"MPCON LIMITED",
"MPCT HOSPITAL",
"MPDL LIMITED",
"MPEE KITCHENETTE PRIVATE LIMITED",
"MPEE STORAGE SYSTEMS PRIVATE LIMITED",
"M-PET CONTAINERS PRIVATE LIMITED",
"MPFC COLD CHAIN PRIVATE LIMITED",
"MPG BUSINESS INFORMATION SYSTEMS PRIVATE LIMITED",
"MPG EXIM PRIVATE LIMITED",
"MPG HOTELS AND INFRASTRUCTURE VENTURES PRIVATE LIMITED",
"MPG SECURITY GROUP PRIVATE LIMITED",
"MPG STONE PRIVATE LIMITED",
"MPGA DISTRIBUTORSHIP PRIVATE LIMITED",
"MPHASIS LIMITED",
"MPHASIS SOFTWARE AND SERVICES INDIA PRIVATE LIMITED",
"MPHATEK SYSTEMS PRIVATE LIMITED",
"MPI EXPORTS PRIVATE LIMITED",
"MPI HEALTHCARE EDUCATIONS PRIVATE LIMITED",
"MPI PAPERS PRIVATE LIMITED",
"MPIL CORPORATION LTD",
"MPIL STEEL STRUCTURES LIMITED",
"MPINNO PROPERTIES PRIVATE LIMITED",
"MPJ JEWELLERS GB PRIVATE LIMITED",
"MPL CEMENT & SPONGE PRIVATE LIMITED",
"MPL ENTERPRISES LIMITED",
"MPL INFRA ENGINEERS PRIVATE LIMITED",
"MPL LIGHT VEHICLES PRIVATE LIMITED",
"MPL MINERAL PROCESSING PRIVATE LIMITED",
"MPL SHWE PAING HUMAN HAIR ENTERPRISE PRIVATE LIMITED",
"MPL STEEL INDUSTRIES PRIVATE LIMITED",
"MPLIFY TECH SERVICES PRIVATE LIMITED",
"MPLP ENGINEERS (INDIA) PRIVATE LIMITED",
"MPM - DURRANS REFRACOAT PRIVATE LIMITED",
"MPM REALTY PRIVATE LIMITED",
"MPM TEXTILES PRIVATE LIMITED",
"MPM VENTURES PRIVATE LIMITED",
"MPMH LOGISTICS PRIVATE LIMITED",
"MPN ASSOCIATES PRIVATE LIMITED",
"MPOINT CONSULTING PRIVATE LIMITED",
"MPOKKET FINANCIAL SERVICES PRIVATE LIMITED",
"MPORTAL INDIA WIRELESS SOLUTIONS PRIVATE LIMITED",
"MPOVER INDIA TYRE ESERVICE AND AMC PRIVATE LIMITED",
"MPOWER BUSINESS FACILITATORS LIMITED",
"MPOWER FACILITY SERVICES PRIVATE LIMITED",
"MPOWER GREEN ENERGY PRIVATE LIMITED",
"MPOWER INFORMATION SYSTEMS PRIVATE LIMITED",
"MPOWER INFRABUILD PRIVATE LIMITED",
"MPOWER INFRATECH INDIA PRIVATE LIMITED",
"MPOWER INTERNATIONAL STUDENT SERVICES LLP",
"MPOWER PLUS INDIA PRIVATE LIMITED",
"MPOWERBIZ SOLUTIONS PRIVATE LIMITED",
"MPOWERED HEALTH INFOTECH PRIVATE LIMITED",
"MPP LEATHERS PRIVATE LIMITED",
"MPP TECHNOLOGIES PRIVATE LIMITED",
"MPPC STEEL PRIVATE LIMITED",
"MPPL BIOTIC PRIVATE LIMITED",
"MPR BEARING & INVESTMENT PRIVATE LIMITED",
"MPR INFRATECH PRIVATE LIMITED",
"MPR REFRACTORIES LIMITED",
"MPRIME PREMISES PRIVATE LIMITED",
"MPROFIT SOFTWARE PRIVATE LIMITED",
"MPRS BIOLOGICAL PRIVATE LIMITED",
"MPRS SHIPPING AND LOGISTICS PRIVATE LIMITED",
"MPS AUDIO SOLUTIONS PRIVATE LIMITED",
"MPS BUILDCON PRIVATE LIMITED",
"MPS CONTRACTORS PRIVATE LIMITED",
"MPS DEY INTERNATIONAL PRIVATE LIMITED",
"MPS EQUIPMENTS PRIVATE LIMITED",
"MPS FACILITY PRIVATE LIMITED",
"MPS INFORMATICS PRIVATE LIMITED",
"MPS INFOTECNICS LIMITED",
"MPS INTERACTIVE SYSTEMS LIMITED",
"MPS INTERNATIONAL SCHOOL",
"MPS LIMITED",
"MPS MOTORS PRIVATE LIMITED",
"MPS PACKERS PRIVATE LIMITED",
"MPS PRECISION ENGINEERING PRIVATE LIMITED",
"MPS SOLUTIONS PRIVATE LIMITED",
"MPS TECH ENGINEERING & CONSULTANCY INDIA PRIVATE LIMITED",
"MPS TELECOM PRIVATE LIMITED",
"MPS TELECOM RETAIL PRIVATE LIMITED",
"MPS TRADING PRIVATE LIMITED",
"MPS WOOD PRODUCTS PRIVATE LIMITED",
"MPSELECTROPLAST PRIVATE LIMITED",
"MPSEZ UTILITIES LIMITED",
"MPSEZ UTILITIES PRIVATE LIMITED",
"MPT LOGISTICS PRIVATE LIMITED",
"MPT TRACTORS PRIVATE LIMITED",
"MPTA EDUCATION",
"MPTJ COMMODITIES PRIVATE LIMITED",
"MPYS INFRATECH PRIVATE LIMITED",
"MPZ BEARINGS PRIVATE LIMITED",
"MPZ IMPEX PRIVATE LIMITED",
"MQDC INDIA REAL ESTATE PRIVATE LIMITED",
"MQS TECHNOLOGIES PRIVATE LIMITED",
"MR BANGUR HOSPITAL",
"MR BIG FIRE WORKS PRIVATE LIMITED",
"MR BIT PRIVATE LIMITED",
"MR BRAND ELASTICS PRIVATE LIMITED",
"MR BROTHERS PRIVATE LIMITED",
"MR CAR MS PRIVATE LIMITED",
"MR CARE CENTRE PRIVATE LIMITED",
"MR GLOBAL MERCHANDISE PRIVATE LIMITED",
"MR GUJARATAIRCOMPRESSOR PRIVATE LIMITED",
"MR INTERIORS INDIA PRIVATE LIMITED",
"MR LIGHT TECHNOLOGY PRIVATE LIMITED",
"MR PAYROLL PRIVATE LIMITED",
"MR PLASTIVA PRIVATE LIMITED",
"MR PROCESSED & FRESH FRUITS PRIVATE LIMITED",
"MR PROVIEW REAL TECH PRIVATE LIMITED",
"MR SHEETFED INDIA PRIVATE LIMITED",
"MR SURYA ELECTRONICS INDIA PRIVATE LIMITED",
"MR WORK SOLUTION PRIVATE LIMITED",
"MR. BREEZE COOLING EQUIPMENTS PRIVATE LIMITED",
"MR. BROWN BAKERY & FOOD PRODUCTS PRIVATE LIMITED",
"MR. CAKE PRIVATE LIMITED",
"MR. UDAYSHIVAKUMAR",
"MRA INFRA VENTURE PRIVATE LIMITED",
"MRA SONS ENTERPRIES PRIVATE LIMITED",
"MRADUL CONSTRUCTIONS PRIVATE LIMITED.",
"MRARA REAL ESTATE PRIVATE LIMITED",
"MRB ASSOCIATES PRIVATE LIMITED",
"MRB CREDIT AND LEASING LIMITED",
"MRB PIPE & TUBES PRIVATE LIMITED",
"MRC AGROTECH LIMITED",
"MRC GLOBAL INC.",
"MRC LOGISTICS (INDIA) PRIVATE LIMITED",
"MRC LOGISTICS PRIVATE LIMITED",
"MRC VANGARA",
"MRCC IT SOLUTIONS PRIVATE LIMITED",
"MRCC TRANSFORMATION SOLUTIONS PRIVATE LIMITED",
"MRE SERVICES INDIA.COM PRIVATE LIMITED",
"MRELATE SOLUTIONS PRIVATE LIMITED",
"MRESULT SERVICES PRIVATE LIMITED",
"MRF CORP LIMITED",
"MRF LIMITED",
"MRG ALLOYS PRIVATE LIMITED",
"MRG MARKETING PRIVATE LIMITED",
"MRG SCHOOL",
"MRH SOUND SOLUTIONS PRIVATE LIMITED",
"MRHM PHARMA PRIVATE LIMITED",
"MRI SOFTWARE INDIA PRIVATE LIMITED",
"MRIDA CONSTRUCTION SOLUTION PRIVATE LIMITED",
"MRIDA GREENS & DEVELOPMENT PRIVATE LIMITED",
"MRIDA HEART 'N SOIL FOUNDATION",
"MRIDANI BUS SERVICE PRIVATE LIMITED",
"MRIDHUL TIMBERS PRIVATE LIMITED",
"MRIDHVIKA PROPERTY MANAGEMENT PRIVATE LIMITED",
"MRIDUL BUILD TECH PRIVATE LIMITED",
"MRIDUL INTERNATIONAL PRIVATE LIMITED",
"MRIDUL MANURE MILLS PRIVATE LIMITED",
"MRIDUL PROPERTIES PRIVATE LIMITED",
"MRIDULA ENGINEERING PRIVATE LIMITED",
"MRIDULA EXIM PRIVATE LIMITED",
"MRIDULA HEALTHCARE PRIVATE LIMITED",
"MRIDULI PROPERTIES PRIVATE LIMITED",
"MRIG SERVICES PRIVATE LIMITED",
"MRIG TECHNOLOGIES PRIVATE LIMITED",
"MRIGAYA INVESTMENTS AND MARKETING PVT LTD",
"MRIGDHARA AGRO INDIA PRIVATE LIMITED",
"MRIGENDRA RICE MILL PVT LTD",
"MRIGNAYANI ELECTRICAL PVT.LTD.",
"MRIGNAYANI TEA PRIVATE LIMITED",
"MRIGNAYNI INFRASTRUCTURE PRIVATE LIMITED",
"MRINALINI BIRI MANUFACTURING CO. PRIVATE LIMITED",
"MRINALINI DATTA MAHAVIDYAPITH",
"MRINALINI DISTRIBUTORS PRIVATE LIMITED",
"MRINMAYE TRADING & MOVERS PRIVATE LIMITED",
"MRINMOYEE SUPPLY PRIVATE LIMITED",
"MRITYUANJAY LIFE SCIENCES PRIVATE LIMITED",
"MRITYUNJAY HEALTH CARE PRIVATE LIMITED",
"MRITYUNJAYA SHREEM PRIVATE LIMITED",
"MRIYA CONCEPTS AND DESIGNS PRIVATE LIMITED",
"MRJ CHEMICALS PRIVATE LIMITED",
"MRJ HOME IMPROVEMENT PRIVATE LIMITED",
"MRJ INFRAHEIGHTS PRIVATE LIMITED",
"MRJS CROWN INDUSTRIES PRIVATE LIMITED",
"MRJS LEAD PRIVATE LIMITED",
"MRK CAPITAL LIMITED.",
"MRK FOODS PRIVATE LIMITED",
"MRK FURNITURE AND INTERIOR PRIVATE LIMITED",
"MRK HEALTHCARE PRIVATE LIMITED",
"MRK IMPEX PRIVATE LIMITED",
"MRK JEWELS PRIVATE LIMITED",
"MRK MARKETING PRIVATE LIMITED",
"MRK TRADEX PRIVATE LIMITED",
"MRKL FAB PRIVATE LIMITED",
"MRL CLEARING AND FORWARDING PRIVATE LIMITED",
"MRL COATERS AND PLATERS PRIVATE LIMITED",
"MRL LUBRICANTS INDIA LIMITED",
"MRL PRINTING ROLLS PRIVATE LIMITED",
"MRL SENIOR SECONDARY SCHOOL",
"MRL TRANSPORT PRIVATE LIMITED",
"MRL TYRES LIMITED",
"MRM ENTERPRISES PRIVATE LIMITED",
"MRM INFOTECH PRIVATE LIMITED",
"MRM MARKETING PVT. LTD.",
"MRM MINING PRIVATE LIMITED",
"MRMC FOODS PRIVATE LIMITED",
"MRN CANE POWER INDIA LIMITED",
"MRN CIVIL TECH PRIVATE LIMITED",
"MRN DIGITAL SERVICES PRIVATE LIMITED",
"MRN INDUSTRIES",
"MRN SUPERMARKET PRIVATE LIMITED",
"MRO TEK REALTY LIMITED",
"MRON INTERNATIONAL PRIVATE LIMITED",
"MRP - MDI RUBBER SOLUTIONS PRIVATE LIMITED",
"MRP AGRO LIMITED",
"MRP AUTORUB PRIVATE LIMITED",
"MRP ENTERPRISES LIMITED",
"MRP HOME APPLIANCES PRIVATE LIMITED",
"MRPGROWTH MICROFINANCE FOUNDATION",
"MRPK INFRAREALCON PRIVATE LIMITED",
"MRPL JANASEVA TRUST",
"MRPOWER TECH PRIVATE LIMITED",
"MRR CARDBOARD CONTAINERS PRIVATE LIMITED",
"MRR SOFT",
"MRRIDSYS TECHNOLOGIES PRIVATE LIMITED",
"MRS A V N COLLEGE",
"MRS BEARINGS PRIVATE LIMITED",
"MRS BECTORS FOOD SPECIALITIES LIMITED",
"MRS CHAINS PRIVATE LIMITED",
"MRS ONLINE TESTING SERVICES PRIVATE LIMITED",
"MRS PARIVAHAN PRIVATE LIMITED",
"MRS REALTY PRIVATE LIMITED",
"MRS.BECTORS FOOD SPECIALITIES LIMITED",
"MRSS AND SONS PRIVATE LIMITED",
"MRSV OVERSEAS PRIVATE LIMITED",
"MRT RESEARCH INSTITUTE PRIVATE LIMITED",
"MRTC INDUSTRIES PRIVATE LIMITED",
"MRUGAL OFFSET PRINTER",
"MRUNAL AGENCY AND FINANCIALS PRIVATE LIMITED",
"MRUNALANIS AYURVEDA PRIVATE LIMITED",
"MRUNMAI PROPERTIES LIMITED",
"MRUTEC PRIVATE LIMITED",
"MRV ENGINEERS PRIVATE LIMITED",
"MRV INFOTECH INDIA PRIVATE LIMITED",
"MRV INN PRIVATE LIMITED",
"MS 5 FOODS PRIVATE LIMITED",
"MS AGARWAL FOUNDRIES PRIVATE LIMITED",
"MS AGROLAND SERVICES PRIVATE LIMITED",
"MS AK CONSTRUCTIONS",
"MS ASHA CONSULTANCY SERVICES",
"MS ASHAPURA ENTERPRISE",
"MS ATOZ MAKE HOUSE EASY PRIVATE LIMITED",
"MS AYURVED COLLEGE",
"MS BAHRAINI DEERGHAKAR BAHU U DADESHEYA SAHAKARI SAMITI LTD",
"MS BHARAT ENTERPRISES",
"MS BIOTECH PRIVATE LIMITED",
"MS BITUMEN & CHEM INDIA PRIVATE LIMITED",
"MS BUSINESS CENTER",
"MS CERTIFICATION SERVICES PVT LTD",
"MS CLINICAL RESEARCH PRIVATE LIMITED",
"MS CURATIVE PRIVATE LIMITED",
"MS D V GOLHAR",
"MS ENTERPRISES",
"MS FIBRE WORK INDUSTRIES PRIVATE LIMITED",
"MS FINCAP PRIVATE LIMITED",
"MS FINLINE PRIVATE LIMITED",
"MS FOCUS FACILITY SECURITY SERVICES",
"MS FOUNDATIONS PRIVATE LIMITED",
"MS GLOBAL INDIA AUTOMOTIVE PRIVATE LIMITED",
"MS GOVT HOSPITAL, NELLORE",
"MS HYDRO SOLUTIONS PRIVATE LIMITED",
"MS IDEAL VISUM INDIA PRIVATE LIMITED",
"MS IMPEX",
"MS INDUSTRIES",
"MS INDUSTRIES & SPIRITS PRIVATE LIMITED",
"MS INTERIOR & CONSTRUCTION PRIVATE LIMITED",
"MS KANJI SURGICAL PRIVATE LIMITED",
"MS KNOWLEDGE PROCESSING PRIVATE LIMITED",
"MS LAL JI GOPINATH INDUSTRIES",
"MS LOGISTICS PRIVATE LIMITED",
"MS LUVISH HOSPITALITY PRIVATE LIMITED",
"MS MAHAVIR OPTICS",
"MS MANMALKA SALT PRIVATE LIMITED",
"MS NAVALAKHA SEED PVT LTD",
"MS OMKAR OUTSOURCING PRIVATE LIMITED",
"MS PARAG ENTERPRISES",
"MS PORT TERMINAL PRIVATE LIMITED",
"MS RAMAIAH COLLEGE OF ARTS SCIENCE",
"MS RAMAIAH INSTITUTE OF TECHNOLOGY",
"MS RAMAIAH MEDICAL COLLEGE",
"MS RAMAIAH MEMORIAL HOSPITAL",
"MS ROAD TRANSPORT PRIVATE LIMITED",
"MS SANGHAR BATHS & CERAMICS",
"MS SEISAKUSHO INDIA PRIVATE LIMITED",
"MS SHARWIN COTTEX PRIVATE LIMITED",
"MS SHIV SHAKTI INDUSTRIES PRIVATE LIMITED",
"MS SHRING CONSTRUCTION",
"MS SOLVEX PRIVATE LIMITED",
"MS STAR COMPUTERS PRIVATE LIMITED",
"MS STAR MOBILE ACCESSORIES PRIVATE LIMITED",
"MS SUPPORT SERVICES PRIVATE LIMITED",
"MS TECHMENT TECHNOLOGY PRIVATE LIMITED",
"MS TRANSLOGISTICS PRIVATE LIMITED",
"MS UNIVERSITY OF BARODA",
"MS USHA SERVICES",
"MS VIJAY AND COMPANY INDIA PRIVATE LIMITED",
"MS VINOD DAYA PARAJPATI",
"MS.SHUBHANGI TULI",
"MSA (INDIA) LIMITED",
"MSA AGROTECH PRIVATE LIMITED",
"MSA CONSTRUCTION PVT LTD",
"MSA GLOBAL LOGISTIC PRIVATE LIMITED",
"MSA GLOBAL LOGISTICS (CHENNAI) PRIVATE LIMITED",
"MSA GLOBAL TECHNOLOGY & ENGINEERING PRIVATE LIMITED",
"MSA GUJARAT MOLECULAR IMAGING (INDIA) PRIVATE LIMITED",
"MSAF BIO ORGANICS PRIVATE LIMITED",
"MSAFE EQUIPMENTS PRIVATE LIMITED",
"MSAJ MANAGEMENT SERVICES PRIVATE LIMITED",
"MSAS AGRO PRIVATE LIMITED",
"MSB AUTOMOTIVE PRIVATE LIMITED",
"MSB CONSULTING PRIVATE LIMITED",
"MSB CORPORATION PRIVATE LIMITED",
"MSB DIGITAL PRIVATE LIMITED",
"MSB EDUCATIONAL INSTITUTE",
"MSB E-TRADE SECURITIES LIMITED",
"MSB PUBLISHERS PRIVATE LIMITED",
"MSB SCHOOL NO 3",
"MSBC SOLUTIONS INDIA PRIVATE LIMITED",
"MSC AGENCY INDIA PRIVATE LIMITED",
"MSC ALICE",
"MSC CREWING SERVICES PRIVATE LIMITED",
"MSC GROUP SOFTWARE AND SYSTEMS INDIA PRIVATE LIMITED",
"MSC INDIA CONSULTING PRIVATE LIMITED",
"MSC INTERNATIONAL IMPORT EXPORT PRIVATE LIMITED",
"MSC MARINE SERVICES PRIVATE LIMITED",
"MSC ROADS AND BRIDGES PRIVATE LIMITED",
"MSC SERVICE CENTER INDIA PRIVATE LIMITED",
"MSC TECHNOLOGY (INDIA) PRIVATE LIMITED",
"MSC TRANSFORMERS PRIVATE LIMITED",
"MSCI SERVICES PRIVATE LIMITED",
"MSCORPRES AUTOMATION PRIVATE LIMITED",
"MSD ED TECHNOLOGIES PRIVATE LIMITED",
"MSD FREIGHT LOGISTICS (OPC) PRIVATE LIMITED",
"MSD MULTI SERVICES PRIVATE LIMITED",
"MSD PACKAGING PRIVATE LIMITED",
"MSD PHARMACEUTICALS PRIVATE LIMITED",
"MSD REAL INFRA PROJECTS PRIVATE LIMITED",
"MSD SYNTEX PRIVATE LIMITED",
"MSD TELEMATICS PRIVATE LIMITED",
"MSD TRADELINK PRIVATE LIMITED",
"MSD WELLCOME TRUST HILLEMAN LABORATORIES PRIVATE LIMITED",
"MSE ENTERPRISES LIMITED",
"MSE FINANCIAL SERVICES LIMITED",
"MSE FORWARDERS INDIA PRIVATE LIMITED",
"MSE MANAGEMENT SERVICES PRIVATE LIMITED",
"MSEB HOLDING COMPANY LIMITED",
"M-SET SCAFFOLDINGS PRIVATE LIMITED",
"MSF CONSULTING PRIVATE LIMITED",
"MSF INDIA PRIVATE LIMITED",
"MSFIN CREDIT PRIVATE LIMITED",
"MSG ALL TRADING INTERNATIONAL PRIVATE LIMITED",
"MSG GLOBAL INNOVATION PRIVATE LIMITED",
"MSG GLOBAL SOLUTIONS INDIA PRIVATE LIMITED",
"MSG INFRABUILD PRIVATE LIMITED",
"MSG PERSONNEL VISION PRIVATE LIMITED",
"MSG PETROLEUM PRODUCTS PRIVATE LIMITED",
"MSG STRATEGIC CONSULTING PRIVATE LIMITED",
"MSGAI LABS PRIVATE LIMITED",
"MSGAJAA PROPERTIES PRIVATE LIMITED",
"MSH BUSINESS CONSULTING PRIVATE LIMITED",
"MSH SAREES PRIVATE LIMITED",
"MSH SILK INDIA PRIVATE LIMITED",
"MSHP INDUSTRIES PRIVATE LIMITED",
"MSI SERVICES PRIVATE LIMITED",
"MSI SHIPPING SERVICES INDIA PRIVATE LIMITED",
"MSITEK SOFTWARE SOLUTIONS PRIVATE LIMITED",
"MSJ & SONS REALTORS & PROMOTERS PRIVATE LIMITED",
"MSJ BATH FITTINGS AND ACCESSORIES PRIVATE LIMITED",
"MSJ GOVT COLLEGE BHARATPUR",
"MSJATHIN INFRA PRIVATE LIMITED",
"MSK FOOD SUPPLY PRIVATE LIMITED",
"MSKA & ASSOCIATES",
"MSKA AND ASSOCIATES",
"MSKA AND ASSOSCIATES",
"MSKH SEATING SYSTEMS INDIA PRIVATE LIMITED",
"MSKWORLDWIDE EXPRESS PRIVATE LIMITED",
"MSL CHEMICALS PRIVATE LIMITED",
"MSL DRIVELINE SYSTEMS LIMITED",
"MSL FISH TRADERS PRIVATE LIMITED",
"MSL INFOTECH INDIA PRIVATE LIMITED",
"MSLJ CONSTRUCTION PRIVATE LIMITED",
"MSLR PRIVATE LIMITED",
"MSM ASSOCIATES PRIVATE LIMITED",
"MSM DISCOVERY PRIVATE LIMITED",
"MSM GLOBAL EDUCATION PRIVATE LIMITED",
"MSM IT SOLUTIONS PRIVATE LIMITED",
"MSM MICROFINANCE LIMITED",
"MSM OIL INDUSTRIES PRIVATE LIMITED",
"MSM PROCESS SOLUTIONS PRIVATE LIMITED",
"MSM RETAIL PRIVATE LIMITED",
"MSM SPRING INDIA PRIVATE LIMITED",
"MSMC ADKOLI NATURAL RESOURCES LIMITED",
"MSME DEVELOPMENT FORUM",
"MSME DEVELOPMENT INSTITUTE",
"MSM-WORLDWIDE FACTUAL MEDIA PRIVATE LIMITED",
"MSMY HOSPITALITY PRIVATE LIMITED",
"MSN AGRO SEEDS PRIVATE LIMITED",
"MSN AND SPJ ENGINEERING CONTRACTOR",
"MSN CONTAINER LINE PRIVATE LIMITED",
"MSN INTEMEDIATES PRIVATE LIMITED",
"MSN LABORATORIES PRIVATE LIMITED",
"MSN LIFE SCIENCES PRIVATE LIMITED",
"MSN ORGANICS PRIVATE LIMITED",
"MSN PHARMACHEM PRIVATE LIMITED",
"MSN PROJECTS PRIVATE LIMITED",
"MSN RESEARCH & DEVELOPMENT PRIVATE LIMITED",
"MSNHM CONSTRUCTION AND ENGINEERING PRIVATE LIMITED",
"MSONA AUTOMOTIVE COMPONENTS PRIVATE LIMITED",
"MSOURCE INDIA PRIVATE LIMITED",
"MSP BUILDCON PRIVATE LIMITED",
"MSP CONSULTING PRIVATE LIMITED",
"MSP HITECT SERVICES PRIVATE LIMITED",
"MSP INFRACON PRIVATE LIMITED",
"MSP IT CONCEPTS PRIVATE LIMITED",
"MSP KNIT GARMENTS PRIVATE LIMITED",
"MSP RETAIL PRIVATE LIMITED",
"MSP SOFTWARE PRIVATE LIMITED",
"MSP SPONGE IRON LIMITED",
"MSP STEEL & POWER LIMITED",
"MSP TRANSCO PRIVATE LIMITED",
"MSP VENTURES PRIVATE LIMITED",
"MSP1 IT MANAGE SERVICES PRIVATE LIMITED",
"MSPACE INDIA PRIVATE LIMITED",
"MSPL GASES LIMITED",
"MSPL LIMITED",
"MSPL UNIT 1 LIMITED",
"MSPRING INFO TECH INDIA PRIVATE LIMITED",
"MSQ STEEL PRIVATE LIMITED",
"MSQUAR ENGINEERING",
"M-SQUARE CLOTHING (INDIA) PRIVATE LIMITED",
"MSQUARE FURNITECH PRIVATE LIMITED",
"MSQUARE INNOTECH SOLUTIONS PRIVATE LIMITED",
"MSQUARE LABS TECHNOLOGIES PRIVATE LIMITED",
"MSQUARE POLYPACK PRIVATE LIMITED",
"MSR BROADCASTING PRIVATE LIMITED",
"MSR ENTERPRISES",
"MSR FABRICS INDIA PRIVATE LIMITED",
"MSR INDIA LIMITED",
"MSR INFRATECH PRIVATE LIMITED",
"MSR IT SOLUTION PRIVATE LIMITED",
"MSR MEGA BIO POWER LIMITED",
"MSR PARIVAR PRIVATE LIMITED",
"MSRB FOOD PRODUCTS PRIVATE LIMITED",
"MSRDC INFRASTRUCTURE PROJECTS LIMITED",
"MSRDC SEA LINK LIMITED",
"MSRDC TUNNELS LIMITED",
"MSRL FOOD PRODUCTS PRIVATE LIMITED",
"MSRM INTERNATIONAL TRADING PRIVATE LIMITED",
"MSRM ORGANICS PRIVATE LIMITED",
"MSRS EXPORTS PRIVATE LIMITED",
"MSRTC AMRAVATI",
"MSS CONSTRUCTIONS PRIVATE LIMITED",
"MSS CONTRACTS PRIVATE LIMITED",
"MSS FILTRATION ENGINEERING PROCESS PRIVATE LIMITED",
"MSS INDIA PRIVATE LIMITED",
"MSS INFRACON PRIVATE LIMITED",
"MSS INSTRUMENTS PRIVATE LIMITED",
"MSS MEDITECHNO (INDIA) PRIVATE LIMITED",
"MSS RUBBER AND RECLAIMS PRIVATE LIMITED",
"MSS SECURITIES PRIVATE LIMITED",
"MSS TECH INDIA PRIVATE LIMITED",
"MSS VENTURES PRIVATE LIMITED",
"MST ELECTRICAL SERVICES PRIVATE LIMITED",
"MST HARDWARE PRODUCTS PRIVATE LIMITED",
"MST IMPEX PRIVATE LIMITED",
"MST MANUFACTURING SOLUTIONS PRIVATE LIMITED",
"MST MANUFACTURING TECHNOLOGIES PRIVATE LIMITED",
"MST TECHPRO PRIVATE LIMITED",
"M-STAR HERITAGE HOTELS PRIVATE LIMITED",
"M-STAR HOTELS KODUVAYUR PRIVATE LIMITED",
"M-STAR HOTELS PRIVATE LIMITED",
"M-STAR SATELLITE COMMUNICATIONS PRIVATE LIMITED",
"MSTARLEX MANAGED SOLUTIONS PRIVATE LIMIT ED",
"MSTC LIMITED",
"MSTRONG MANAGEMENT PRIVATE LIMITED",
"MSTRONICS SMT SOLUTIONS INDIA PRIVATE LIMITED",
"MSU PROPERTIES PRIVATE LIMITED",
"M-SUI MACHINES PRIVATE LIMITED",
"MSV DECORS PRIVATE LIMITED",
"MSV DIES AND MOULDS PRIVATE LIMITED",
"MSV INTERNATIONAL INC",
"MSV INTERNATIONAL INDIA LIMITED",
"MSV INTERNATIONAL TECH PRIVATE LIMITED",
"MSV LOGISTICS PRIVATE LIMITED",
"MSV TRAVELCATIONS PRIVATE LIMITED",
"MSW BHUBANESWAR LIMITED",
"MSYS INC",
"MSYS TECH INDIA PRIVATE LIMITED",
"MSZ LOGISTICS PRIVATE LIMITED",
"MT COY 2STC",
"MT DATA OPERATIONS INDIA PRIVATE LIMITED",
"MT K KAPITAL PRIVATE LIMITED",
"MT PORTABLE CABIN SOLUTION PRIVATE LIMITED",
"MTA AUTOMOTIVE SOLUTIONS PRIVATE LIMITED",
"MTA DESTINATION EXPERTS PRIVATE LIMITED",
"MTAB ENGINEERS PRIVATE LIMITED",
"MTAB TECHNOLOGY CENTER PRIVATE LIMITED",
"MTALKZ MOBILITY SERVICES PRIVATE LIMITED",
"MTANDT LIMITED",
"MTANDT RENTALS LIMITED",
"MTAP TECHNOLOGIES PRIVATE LIMITED",
"MTAR TECHNOLOGIES LIMITED",
"MTAR TECHNOLOGIES PRIVATE LIMITED",
"MTB INDUSTRIES PRIVATE LIMITED",
"MTB JNANA JYOTHI VIDYANIKETHAN CBSE",
"MTC BUSINESS PRIVATE LIMITED",
"MTC INDIA GASES PVT LTD",
"MTC INDIA RUBBER METAL COMPONENTS PRIVATE LIMITED",
"MTC RECYCLING PRIVATE LIMITED",
"MTC TOYS PRIVATE LIMITED",
"MTD PRODUCTS INDIA PRIVATE LIMITED",
"MTDERM MEDICAL PRODUCTS PRIVATE LIMITED",
"MTE ENTERPRISE PRIVATE LIMITED",
"MTE EXIM PRIVATE LIMITED",
"MTE INDUSTRIES PRIVATE LIMITED",
"MTE STRUCTURES PRIVATE LIMITED",
"MTECH INDIA PRIVATE LIMITED",
"M-TECH SOFTWARE PRIVATE LIMITED",
"M-TECH SYSTEMS PVT LTD",
"M-TECH VISION PRIVATE LIMITED",
"MTEK HEALTHCARE INDIA PRIVATE LIMITED",
"MTEKPRO TECHNOLOGIES PRIVATE LIMITED",
"MTES S ENGLISH SCHOOL",
"M-TEX MACHINES PRIVATE LIMITED",
"MTEXT DIGITAL MEDIA PRIVATE LIMITED",
"MTG INFRATECH PRIVATE LIMITED",
"MTG LEARNING MEDIA PRIVATE LIMITED",
"MTG TRAVELS PRIVATE LIMITED",
"MTH DOORS INDIA PRIVATE LIMITED",
"MTH TRADE INDIA PRIVATE LIMITED",
"MTI INDUSTRIES PRIVATE LIMITED",
"MTI INTEGRATION SERVICES INDIA PRIVATE LIMITED",
"MTI INTEGRATION SERVICES INDIA PRIVATE LIMTED",
"MTI LOGISTICS PRIVATE LIMITED",
"MTI MATERIALS PRIVATE LIMITED",
"MTITANIUM APARTMENTS PRIVATE LIMITED",
"MTJ INDUSTRIES PRIVATE LIMITED",
"MTJR ENTERPRISES PRIVATE LIMITED",
"MTK FOODS PRIVATE LIMITED",
"MTK TOOLING & ENGINEERING PRIVATE LIMITED",
"MTL INSTRUMENTS PRIVATE LIMITED",
"MTL PIPES INDIA LIMITED",
"MTM WINES AND BOTTLERS PRIVATE LIMITED",
"MTM WORKPLACE SOLUTIONS PRIVATE LIMITED",
"MTMS ENGINEERS PRIVATE LIMITED",
"MTNLSTPI IT SERVICES LIMITED",
"M-TOMATO FARMERS PRODUCER COMPANY LIMITED",
"MTOR LIFE SCIENCES PRIVATE LIMITED",
"MTOUGH ENTERPRISES PRIVATE LIMITED",
"MTPI PRODUCTS PRIVATE LIMITED",
"MTPI TECHNOLOGIES PRIVATE LIMITED",
"MTPL PROJECTS PRIVATE LIMITED",
"ORKLA INDIA PRIVATE LIMITED",
"MTR INFRA PROJECTS PRIVATE LIMITED",
"MTREE SOFTWARE PRIVATE LIMITED",
"MTS (MAHALAXMI TRANSPORT) PRIVATE LIMITED",
"MTS ENGINEERS PRIVATE LIMITED",
"MTS INFONET MEDIA PRIVATE LIMITED",
"MTS K S GARDI GIRLS HIGH SCHOOL",
"MTS LOGISTICS PRIVATE LIMITED",
"MTS MINERALS PRIVATE LIMITED",
"MTS PAPERS INDIA LIMITED",
"MTS PIPES AND TUBES PRIVATE LIMITED",
"MTS TECHNOLOGIES LIMITED",
"MTS TOOLING PRIVATE LIMITED",
"MTSG IT SERVICE PRIVATE LIMITED",
"MTU INDIA PRIVATE LIMITED",
"MTV JEWELLERS PRIVATE LIMITED",
"MTX IT CONSULTING SERVICES PRIVATE LIMITED",
"MU GAMMA CONSULTANTS PRIVATE LIMITED",
"MU LOGISTIC PRIVATE LIMITED",
"MU VENTURES INDIA PRIVATE LIMITED",
"MUAH RETAILS PRIVATE LIMITED",
"MUB IT SERVICES PRIVATE LIMITED",
"MUBARAK OVERSEAS PRIVATE LIMITED",
"MUBASA ELECTRICAL PRIVATE LIMITED",
"MUBASA POWERS PRIVATE LIMITED",
"MUBBLE NETWORKS PRIVATE LIMITED",
"MUBEA AUTOMOTIVE COMPONENTS INDIA PRIVATE LIMITED",
"MUBH BITCON LIMITED",
"MUBH INDUSTRIES LIMITED",
"MUBINA VAZIRALLI PRODUCTIONS PRIVATE LIMITED",
"MUBLE SOLUTIONS PRIVATE LIMITED",
"MUCHIM FOODS LIMITED",
"MUCKBOTICS GLOBAL PRIVATE LIMITED",
"MUDAS IMPEX PRIVATE LIMITED",
"MUDHAR PLYWOOD PRIVATE LIMITED",
"MUDHOL LAND HOLDINGS COMPANY PRIVATE LIMITED",
"MUDHOLKAR PETH MAHILA MANDAL PRIMARY SCHOOL",
"MUDIT FINLEASE LIMITED",
"MUDIT GLASSWORKS PRIVATE LIMITED",
"MUDIT IMPEX PRIVATE LIMITED",
"MUDIT MANAGEMENT PRIVATE LIMITED",
"MUDIT POLYTEX PRIVATE LIMITED",
"MUDIT PROPERTIES PRIVATE LIMITED",
"MUDIT VANIJYA PRIVATE LIMITED",
"MUDITA EXPRESS CARGO PRIVATE LIMITED",
"MUDITA JAIPURIA LIFESTYLE PRIVATE LIMITED",
"MUDITA PROPERTIES PRIVATE LIMITED",
"MUDMA CONSTRUCTION PRIVATE LIMITED",
"MUDO FASHION PRIVATE LIMITED",
"MUDRA ARTS (INDIA) PRIVATE LIMITED",
"MUDRA BULLIONS PRIVATE LIMITED",
"MUDRA COMPONENTS PRIVATE LIMITED",
"MUDRA DIES & PATTERNS PRIVATE LIMITED",
"MUDRA ENGG-SOLUTIONS PRIVATE LIMITED",
"MUDRA FINANCE LIMITED",
"MUDRA FINANCIAL SERVICES LIMITED",
"MUDRA FINVEST (GUJARAT) LIMITED",
"MUDRA FOREX PRIVATE LIMITED",
"MUDRA INSTITUE OF COMMUNICATION",
"MUDRA ONLINE TECHNOLOGIES PRIVATE LIMITED",
"MUDRA PRINTS PRIVATE LIMITED",
"MUDRA STRUCTURES AND BUILDERS PRIVATE LIMITED",
"MUDRA SUGAR INDUSTRIES INDIA PRIVATE LIMITED",
"MUDRA UNIFORMS INDIA PRIVATE LIMITED",
"MUDRAKSHI HYTECH INDIA PRIVATE LIMITED",
"MUDRAN EVM LEKHAN SAMAGRI UP",
"MUDRANIK TECHNOLOGIES PRIVATE LIMITED",
"MUDREMANE COFFEE CURERS",
"MUDRIKA CERAMICS (INDIA) PRIVATE LIMITED",
"MUDRIKA CERAMICS INDIA PRIVATE LIMITED",
"MUDRIKA ENERGY AND TELECOM PRIVATE LIMITED",
"MUDRIKA LABELS PRIVATE LIMITED",
"MUDRIKA SANG BONG FOILS (INDIA) PRIVATE LIMITED",
"MUDS MANAGEMENT PRIVATE LIMITED",
"MUDUNURU LIMITED",
"MUDUNURU ONE FINTECH PRIVATE LIMITED",
"MUEHLBAUER (INDIA) PRIVATE LIMITED",
"MUELLER DOTKONNECT LLP",
"MUELLER PROST SHARED SERVICES PRIVATE LIMITED",
"MUENZER BHARAT PRIVATE LIMITED",
"MUEZ HEST INDIA PRIVATE LIMITED",
"MUFFAKHAM JAH COLLEGE OF ENGINEERING & TECHNOLOGY MJCET",
"MUFFET RETAIL PRIVATE LIMITED",
"MUFFIN DESIGN SOLUTIONS PRIVATE LIMITED",
"MUFG BANK LIMITED",
"MUFG GLOBAL SERVICE PRIVATE LIMITED",
"MUFIN GREEN FINANCE LIMITED",
"MUFRONT TECHNOLOGIES PRIVATE LIMITED",
"MUGAFI PRIVATE LIMITED",
"MUGENESYS SOFTWARE PRIVATE LIMITED",
"MUGHAL CUISINE FOODS PRIVATE LIMITED",
"MUGHAL HOLIDAYS PRIVATE LIMITED",
"MUGHAL JEWELS AND CRAFTS EMPORIUM PVT LTD",
"MUGMA COKE OVEN PRIVATE LIMITED",
"MUHAVRA ENTERPRISES PRIVATE LIMITED",
"MUJAHID E MILLAT GSF PRIMARY SCHOOL",
"MUJAWADIA TRACTORS PRIVATE LIMITED",
"MUJTABA MARINE PRIVATE LIMITED",
"MUKAND INDUSTRIES LIMITED",
"MUKAND INFOTEL PRIVATE LIMITED",
"MUKAND INFRASTRUCTURE PRIVATE LIMITED",
"MUKAND LAL PUBLIC SCHOOL",
"MUKAND LIMITED",
"MUKAND SUMI METAL PROCESSING LIMITED",
"MUKAND SUMI SPECIAL STEEL LIMITED",
"MUKAND SYSTEMS AND NETWORKING PRIVATE LIMITED",
"MUKANDLAL MOTILAL WOOLLENS PRIVATE LIMITED",
"MUKARRAM INTER COLLEGE PAHASU BULANDSHAHR",
"MUKAT HOSPITAL",
"MUKAT PIPES LIMITED",
"MUKAT PUBLIC SCHOOL",
"MUKAT TANKS AND VESSELS PRIVATE LIMITED",
"MUKBADHIR NIVASI SHALA INDAPUR",
"MUKBADHIR NIWASI VIDYALAYA TABARAJURI PATODA BEED",
"MUKESH & ASSOCIATES CONSULTANTS & ENGINEERS",
"MUKESH BABU FINANCIAL SERVICES LIMITED",
"MUKESH BROKERAGE AND FINANCIAL INDIA LIMITED",
"MUKESH CLOTHS PRIVATE LIMITED",
"MUKESH COMMOTRADE PRIVATE LIMITED",
"MUKESH FASHIONS PRIVATE LIMITED",
"MUKESH FURNISHINGS PRIVATE LIMITED",
"MUKESH GARMENTS PRIVATE LIMITED",
"MUKESH GOYAL DEVELOPERS PRIVATE LIMITED",
"MUKESH INCENSE ENTERPRISES PRIVATE LIMITED",
"MUKESH INDUSTRIES LIMITED",
"MUKESH IRON FOUNDRY PRIVATE LIMITED",
"MUKESH METAL INDUSTRIES PRIVATE LIMITED",
"MUKESH NATURAL STONES PRIVATE LIMITED",
"MUKESH OIL MILL PRIVATE LIMITED",
"MUKESH PHARMA PRIVATE LIMITED",
"MUKESH QUARTZ PRIVATE LIMITED",
"MUKESH RESTYLES PRIVATE LIMITED",
"MUKESH SAREES PRIVATE LIMITED",
"MUKESH SYNTHETICS PRIVATE LIMITED",
"MUKESH TEXFAB PRIVATE LIMITED",
"MUKESH TRENDS LIFE STYLE LIMITED",
"MUKETOSH UTILITIES PRIVATE LIMITED",
"MUKHERJEE FARMS PRIVATE LIMITED",
"MUKHI APPARELS PRIVATE LIMITED",
"MUKHI HOSPITALS AND NURSING HOME PRIVATE LIMITED",
"MUKHY VASTUVID MP PUBLIC WORKS DEPARTMENT BHOPAL",
"MUKKA PROTEINS LIMITED",
"MUKKADANS FOREX PRIVATE LIMITED",
"MUKKUNNOTH ECOMMERCE PRIVATE LIMITED",
"MUKNOGY MICRO FINANCE FOUNDATION",
"MUKON CONSTRUCTIONS PRIVATE LIMITED",
"MUK-SAN STEELS PRIVATE LIMITED",
"MUKTA A2 CINEMAS LIMITED",
"MUKTA AGRICULTURE LIMITED",
"MUKTA AUTOMATION PRIVATE LIMITED",
"MUKTA HEIGHTS PRIVATE LIMITED",
"MUKTA OVERSEAS PRIVATE LIMITED",
"MUKTA V N FILMS LIMITED",
"MUKTAA MAHILA MILK PRODUCER COMPANY LIMITED",
"MUKTABAI HIGH SCHOOL NAGZARI",
"MUKTANGAN EDUCATION TRUST",
"MUKTAR AUTOMOBILES PRIVATE LIMITED",
"MUKTESHWAR SUGAR MILLS LIMITED",
"MUKTHA FOUNDATIONS PRIVATE LIMITED",
"MUKTHA HOUSING AND ESTATES PRIVATE LIMITED",
"MUKTI EXPORT PRIVATE LIMITED",
"MUKTI FIRMS PRIVATE LIMITED",
"MUKTI GOLD PRIVATE LIMITED",
"MUKTI KITCHENWARE PRIVATE LIMITED",
"MUKTI PROJECTS LIMITED",
"MUKTI VANIJYA PRIVATE LIMITED",
"MUKTINATH MARITIME PRIVATE LIMITED",
"MUKTSAR COTTON PRIVATE LIMITED",
"MUKUL BROTHERS ENGINEERING WORKS LIMITED",
"MUKUL CONSULTANTS INDIA PRIVATE LIMITED",
"MUKUL DYESTUFF PRIVATE LIMITED",
"MUKUL ENTERPRISES",
"MUKUL EXPORTS",
"MUKUL GHOSH MEMURIAL INSTITUTION",
"MUKUL GUPTA MARKETING PRIVATE LIMITED",
"MUKUL MANDIR P S",
"MUKUL METALS PRIVATE LIMITED",
"MUKUL OVERSEAS PRIVATE LIMITED",
"MUKUL PAPER AND CHEMICALS PVT.LTD.",
"MUKUM MARINE PRIVATE LIMITED",
"MUKUND BUILDERS AND CONTRACTORS PRIVATE LIMITED",
"MUKUND CORRUPACK PRIVATE LIMITED",
"MUKUND ELECTRIC PRIVATE LIMITED",
"MUKUND FASHION PRIVATE LIMITED",
"MUKUND HOSPITALITY PRIVATE LIMITED",
"MUKUND IMPEX AND PROJECTS PRIVATE LIMITED",
"MUKUND INTERNATIONAL PRIVATE LIMITED",
"MUKUND INTERNATIONAL SCHOOL",
"MUKUND OIL MILLS PVT LTD",
"MUKUND OVERSEAS",
"MUKUND ROADLINES PRIVATE LIMITED",
"MUKUND SANITATION PRIVATE LIMITED",
"MUKUND SECURITY & INVESTMENT LIMITED",
"MUKUND SERVICE STATION PRIVATE LIMITED",
"MUKUND STONE PRIVATE LIMITED",
"MUKUND SULZ PRIVATE LIMITED",
"MUKUND YARNS PRIVATE LIMITED",
"MUKUNDA CASTINGS & ENGINEERING INDUSTRIES PRIVATE LIMITED",
"MUKUNDA DAIRY PRODUCTS PRIVATE LIMITED",
"MUKUNDLAL BANSILAL AND SONS PRIVATE LIMITED",
"MUKUNDRA INFRA PROJECTS PRIVATE LIMITED",
"MUKUNDRA SEEDS AND RESEARCH PRIVATE LIMITED",
"MUKUNDRA TOUGHENED GLASS PRIVATE LIMITED",
"MUKUT HOTELS AND RESORTS PVT. LTD.",
"MUKUT JEWELS PRIVATE LIMITED",
"MUKUT MAHAL BANQUETTE PRIVATE LIMITED",
"MUKUT MANI CREATION PRIVATE LIMITED",
"MUKUTBIHARI PROCESSORS PRIVATE LIMITED",
"MUL PODSA ROADWAYS PRIVATE LIMITED",
"MULA AGRO PRODUCTS PVT LTD",
"MULAKSHAR PRODUCTIONS PRIVATE LIMITED",
"MULAMAI AGRO FARMERS PRODUCER COMPANY LIMITED",
"MULAMOOTTIL FINANCIERS LIMITED",
"MULAMOOTTIL NIDHI LIMITED",
"MULANUR RENEWABLE ENERGY LIMITED",
"MULANUR SARVODAYA SANGH",
"MULAY DIAGNOSTIC SERVICES PRIVATE LIMITED",
"MULAY POLYMERS PRIVATE LIMITED",
"MULBERRY PROCESSING PRIVATE LIMITED",
"MULBERRY PROJECTS PRIVATE LIMITED",
"MULBERRY SILKS LIMITED",
"MULBERRY UNITED PRIVATE LIMITED",
"MULCHAND BHERULAL CRUSHINGS PRIVATE LIMITED",
"MULCHAND BHERULAL INFRASTRUCTURES PRIVATE LIMITED",
"MULCHAND FIBER PRIVATE LIMITED",
"MULCHAND PHULCHAND KRISHI UDYOG PRIVATE LIMITED",
"MULDER INDIA PRIVATE LIMITED",
"MULGUNDS ENERGY PRIVATE LIMITED",
"MULINCHE SAMARTH VIDYALAY\n",
"MULJI MEHTA AND SONS PVT LTD",
"MULKH RAJ AND COMPANY PRIVATE LIMITED",
"MULLACKAL POLYMERS PRIVATE LIMITED",
"MULLACKALS MEDICARE PRIVATE LIMITED",
"MULLEN LINTAS PRIVATE LIMITED",
"MULLER & PHIPPS INDIA LIMITED",
"MULLER INDIA PRIVATE LIMITED",
"MULLER MARTINI (INDIA) PRIVATE LIMITED",
"MULLER-BBM ACOUSTIC TECHNOLOGY PRIVATE LIMITED",
"MULPURI AQUA PROCESSORS PRIVATE LIMITED",
"MULSAN INFORMATION TECHNOLOGY PRIVATE LIMITED",
"MULTAN AIR PRODUCTS PRIVATE LIMITED",
"MULTANI MAL COLLEGE",
"MULTANI PHARMACEUTICALS LIMITED",
"MULTI - TECH ZIPPERS ( INDIA ) PRIVATE LIMITED",
"MULTI -ACT CONSTRUCTION PRIVATE LIMITED",
"MULTI- ACT EQUITY RESEARCH SERVICES PRIVATE LIMITED",
"MULTI ACT REALTY ENTERPRISES PVT LTD",
"MULTI CAR TECH PRIVATE LIMITED",
"MULTI CARTONS PVT LTD",
"MULTI CHEMICAL INDUSTRIES PVT LTD",
"MULTI COLOR STEELS INDIA PRIVATE LIMITED",
"MULTI COMMODITY EXCHANGE CLEARING CORPORATION LIMITED",
"MULTI COMMODITY EXCHANGE OF INDIA LIMITED",
"MULTI DECOR INDIA PRIVATE LIMITED",
"MULTI FASTNERS PRIVATE LIMITED",
"MULTI FOOD PRODUCTS PRIVATE LIMITED",
"MULTI FORM INDUSTRIES INDIA PRIVATE LIMITED",
"MULTI GLOBE DAIRIES PRIVATE LIMITED",
"MULTI INFOMEDIA PRIVATE LIMITED",
"MULTI INFRASTRUCTURE & ENGINEERING PRIVATE LIMITED",
"MULTI INFRATECH PRIVATE LIMITED",
"MULTI LIGHTING CONTROLS PRIVATE LIMITED",
"MULTI MANTECH INTERNATIONAL PRIVATE LIMITED",
"MULTI MARINE SHIPPING AND LOGISTIC PRIVATE LIMITED",
"MULTI MAX ENGINEERING WORKS PRIVATE LIMITED",
"MULTI MEDIA CONSULTANTS PVT LTD",
"MULTI MEDIA HRD PVT LTD",
"MULTI MEDIA INFORMATICS PRIVATE LIMITED",
"MULTI MODAL OVERSEAS PRIVATE LIMITED",
"MULTI MODES TRANSPORT PRIVATE LIMITED",
"MULTI NANO SENSE TECHNOLOGIES PRIVATE LIMITED",
"MULTI ORGANICS PRIVATE LIMITED",
"MULTI OVERSEAS INDIA PVT LTD",
"MULTI POLYPLAST PRIVATE LIMITED",
"MULTI SAFETY SYSTEM PRIVATE LIMITED",
"MULTI SALES PRIVATE LIMITED",
"MULTI SERVE ROLLS PRIVATE LIMITED",
"MULTI SPECIALIST MEDICAL BILLING SOLUTIONS PRIVATE LIMITED",
"MULTI SPECIALITY EXTRUSIONS PRIVATE LIMITED",
"MULTI SPECIALITY PRODUCTS INDIA PRIVATE LIMITED",
"MULTI SPRINGS AND ENGINEERING PRIVATE LIMITED",
"MULTI STOCK BROKING PRIVATE LIMITED",
"MULTI SYSTEM AUTOMECH PRIVATE LIMITED",
"MULTI TALENT HUMAN RESOURCES PRIVATE LIMITED",
"MULTI TECH ENGINEERING PVT LTD",
"MULTI TEK CONTROLS INDIA PRIVATE LIMITED",
"MULTI TRADE TECHNOLOGIES PRIVATE LIMITED",
"MULTI VENTURE PROJECTS PRIVATE LIMITED",
"MULTI WAY AUTOMATION PRIVATE LIMITED",
"MULTI WEIGH INDIA PRIVATE LIMITED",
"MULTI WING INDIA PRIVATE LIMITED",
"MULTI WRAPS PRIVATE LIMITED",
"MULTI-ACT EQUITY CONSULTANCY PRIVATE LIMITED",
"MULTI-ACT TRADE AND INVESTMENTS PRIVATE LIMITED",
"MULTIBASE INDIA LIMITED",
"MULTIBHASHI SOLUTIONS PRIVATE LIMITED",
"MULTIBOX PRIVATE LIMITED",
"MULTIBRANDS SERVICES INDIA PRIVATE LIMITED",
"MULTICARE SERVICES INDIA PRIVATE LIMITED",
"MULTICHANNEL ELECTRONICS PVT LTD",
"MULTICHEM COLORANTS PRIVATE LIMITED",
"MULTICHEM INDUSTRIES PRIVATE LIMITED",
"MULTICHEM SPECIALITIES PRIVATE LIMITED",
"MULTICITY HOSPITALITIES LIMITED LIABILITY PARTNERSHIP",
"MULTICO EXPORTS PRIVATE LIMITED",
"MULTICOAT COATING TECHNOLOGIES PRIVATE LIMITED",
"MULTICODES SERVICES PRIVATE LIMITED",
"MULTICOM TRADING INDIA PRIVATE LIMITED",
"MULTICON REALTY LIMITED",
"MULTICOREWARE INDIA PRIVATE LIMITED",
"MULTICRAFT DIGITAL TECHNOLOGIES PRIVATE LIMITED",
"MULTICUBE DISTRIBUTORS LIMITED",
"MULTI-DESTINATION OVERSEAS EDUCATION CONSULTANTS PRIVATE LIMITED",
"MULTIDIMENSION WARANGAL MULTIPLEX PRIVATE LIMITED",
"MULTIDOTS SOLUTIONS PRIVATE LIMITED",
"MULTIFAB ENGINEERS PRIVATE LIMITED",
"MULTIFACET SOFTWARES SYSTEMS PRIVATE LIMITED",
"MULTIFILMS PLASTICS PRIVATE LIMITED",
"MULTIFIT WELLNESS PRIVATE LIMITED",
"MULTIFLEX POLYBAGS PRIVATE LIMITED",
"MULTIFLEX POLYFILMS PRIVATE LIMITED",
"MULTIFLO INSTRUMENTS PRIVATE LIMITED",
"MULTIFORM ALUMINIUM PRIVATE LIMITED",
"MULTIGRAIN FOOD PRIVATE LIMITED",
"MULTIGRAPH MACHINERY COMPANY LIMITED",
"MULTIGRAPHICS PRINT PRIVATE LIMITED",
"MULTILINE BUSINESS SOLUTION",
"MULTI-LINE BUSINESS SOLUTIONS PRIVATE LIMITED",
"MULTILINE ELECTRONICS PRIVATE LIMITED",
"MULTILINE FREIGHT SERVICES PRIVATE LIMITED",
"MULTILINE HYGIENE CARE PRIVATE LIMITED",
"MULTILINE POLYMERS PRIVATE LIMITED",
"MULTILINE SHARE MERCANTILE PRIVATE LIMITED",
"MULTILINK COMPUTERS PRIVATE LIMITED",
"MULTILIVING TECHNOLOGIES PRIVATE LIMITED",
"MULTILOGIX DISPLAY & DEVICES PRIVATE LIMITED",
"MULTIMEDIA COMPUTER SYSTEMS PRIVATE LIMITED",
"MULTIMEDIA FINSEC PRIVATE LIMITED",
"MULTIMEDICS LLP",
"MULTIMELT STEELS PRIVATE LIMITED",
"MULTIMET TECH FAB PRIVATE LIMITED",
"MULTI-METAL FUSION TECHNOLOGY PRIVATE LIMITED",
"MULTIMETALS LIMITED",
"MULTI-MODAL FREIGHT SYSTEMS PVT LTD",
"MULTIMODAL STORAGE SOLUTIONS PRIVATE LIMITED",
"MULTIMODE LOGISTICS (INDIA) PRIVATE LIMITED",
"MULTIMODE MARKETING PRIVATE LIMITED",
"MULTINET (UDAIPUR) PRIVATE LIMITED",
"MULTINET WORLDWIDE PRIVATE LIMITED",
"MULTIPLAST POLYMER PRIVATE LIMITED",
"MULTIPLE COMPUTECH PRIVATE LIMITED",
"MULTIPLE EDUCATIONAL & MANPOWER",
"MULTIPLE SPECIAL STEEL PRIVATE LIMITED",
"MULTIPLES ALTERNATE ASSET MANAGEMENT PRIVATE LIMITED",
"MULTIPLEX AGRICARE PRIVATE LIMITED",
"MULTIPLEX APPLIANCES PRIVATE LIMITED",
"MULTIPLEX BIO-TECH PRIVATE LIMITED",
"MULTIPLEX BUILDERS PRIVATE LIMITED",
"MULTIPLEX CAPITAL LIMITED",
"MULTIPLEX CINEVISION PRIVATE LIMITED",
"MULTIPLEX CONSTRUCTIONS INDIA PRIVATE LIMITED",
"MULTIPLEX ENTERPRISES PVT LTD",
"MULTIPLEX EQUIPMENTS & SERVICES PRIVATE LIMITED",
"MULTIPLEX INTERNATIONAL PRIVATE LIMITED",
"MULTIPLEX INTERNET VENTURES PRIVATE LIMITED",
"MULTIPLEX SYSTEMS PRIVATE LIMITED",
"MULTIPLEX URBAN GREEN (INDIA) PRIVATE LIMITED",
"MULTIPLEX VYAPAAR PRIVATE LIMITED",
"MULTIPLIER BRAND SOLUTIONS PRIVATE LIMITED",
"MULTIPLIER SHARE AND STOCK ADVISORS PRIVATE LIMITED",
"MULTIPLIER TECHNOLOGIES INDIA PRIVATE LIMITED",
"MULTIPLUS HOLDINGS LIMITED",
"MULTIPLUS LOGISTICS PRIVATE LIMITED",
"MULTIPLUS SECURITY SERVICES",
"MULTIPLY PAPER PACKAGING INDUSTRIES PRIVATE LIMITED",
"MULTIPRENE INTERNATIONALS PRIVATE LIMITED",
"MULTIPRO MACHINES PRIVATE LIMITED",
"MULTIQUADRANT INDUSTRIAL CONTROLS INDIA PRIVATE LIMITED",
"MULTIQUIP (INDIA) PRIVATE LIMITED",
"MULTIREACH MEDIA PRIVATE LIMITED",
"MULTI-RELIABLE SOLUTIONS PRIVATE LIMITED",
"MULTIROLE TRANSPORT AIRCRAFT LIMITED",
"MULTISERV INDIA PRIVATE LIMITED",
"MULTISKILL ENGINEERING PRIVATE LIMITED",
"MULTISOFT INFOCOM PRIVATE LIMITED",
"MULTISOFT SYSTEMS TECHNOLOGY CONSULTANCY PRIVATE LIMITED",
"MULTISOFT VIRTUAL ACADEMY PRIVATE LIMITED",
"MULTISORB TECHNOLOGIES INDIA PRIVATE LIMITED",
"MULTISPAN CONTROL INSTRUMENTS PRIVATE LIMITED",
"MULTISPECIALITY CARE CONSULTANTS PRIVATE LIMITED",
"MULTISPHERE POWER SOLUTIONS PRIVATE LIMITED",
"MULTISPICE PROCESSING PRIVATE LIMITED",
"MULTISTAR LOGISTICS PRIVATE LIMITED",
"MULTISTAR POLYFILMS PRIVATE. LIMITED",
"MULTISTONE GRANITO PRIVATE LIMITED",
"MULTITEC AIDS PRIVATE LIMITED",
"MULTITEC INDUSTRIES LIMITED",
"MULTITECH AUTO PRIVATE LIMITED",
"MULTITECH COMPONENTS PRIVATE LIMITED",
"MULTITECH HEAVY ENGINEERING PRIVATE LIMITED",
"MULTITECH INDUSTRIES INDIA PRIVATE LIMITED",
"MULTITECH INFRACON PRIVATE LIMITED",
"MULTITECH LASER ENGINEERING (INDIA) PRIVATE LIMITED",
"MULTITECH MEDICAL SYSTEMS PRIVATE LIMITED",
"MULTITECH METALLIC PRODUCTS PRIVATE LIMITED",
"MULTITECH POLYMERS PRIVATE LIMITED",
"MULTITECH PRODUCTS PRIVATE LIMITED",
"MULTITEX FILTERS PRIVATE LIMITED",
"MULTITEX FILTRATION ENGINEERS LIMITED",
"MULTITON POLYPACK PRIVATE LIMITED",
"MULTITRACK ENGINEERING PRIVATE LIMITED",
"MULTITRADE TECHNOLOGIES PRIVATE LIMITED",
"MULTITRADE TRANSCATIONS AND SOLUTIONS PRIVATE LIMITED",
"MULTITUDE INFRASTRUCTURES PRIVATE LIMITED",
"MULTITV TECH SOLUTION PRIVATE LIMITED",
"MULTIURBAN INFRA SERVICES PRIVATE LIMITED",
"MULTIVAC INDIA PRIVATE LIMITED",
"MULTIVAC LARAON INDIA PRIVATE LIMITED",
"MULTIVERSAL INFRA PRIVATE LIMITED",
"MULTIVERSE EXIM PRIVATE LIMITED",
"MULTIVERSE SOLUTIONS PRIVATE LIMITED",
"MULTIVERSITY PRIVATE LIMITED",
"MULTIVISION FOOTWEAR PRIVATE LIMITED",
"MULTIVISION MUL TIMEDIA INDIA PRIVATE LIMITED",
"MULTIVISION RETAIL PRIVATE LIMITED",
"MULTIVISTA GLOBAL PRIVATE LIMITED",
"MULTIWAL DUPLEX PRIVATE LIMITED",
"MULTIWAY PROJECTS PVT LTD",
"MULTIWAY TRANS POWER PRIVATE LIMITED",
"MULTIWYN EXPORTS LIMITED",
"MULTIWYN FOAMS PVT LTD",
"MULTIWYN INVESTMENTS AND HOLDINGS PRIVATE LIMITED",
"MULTIWYN VINCOM PRIVATE LIMITED",
"MULTUNUS SOFTWARE PRIVATE LIMITED",
"MULTYWAVE TECHNOLOGIES PRIVATE LIMITED",
"MULUND VIDYAMANDIR EDUCATION",
"MULURA LOGISTICS PRIVATE LIMITED",
"MUMAL MARBLES PRIVATE LIMITED.",
"MUMAL MICRONS PRIVATE LIMITED",
"MU-MAN MOTELS PVT. LTD.",
"MUMBAI 9 GUARDS PRIVATE LIMITED",
"MUMBAI ACCESSORY PRIVATE LIMITED",
"MUMBAI AIRPORT LOUNGE SERVICES PRIVATE LIMITED",
"MUMBAI AUTOMATION INFOTECH PRIVATE LIMITED",
"MUMBAI AVIATION FUEL FARM FACILITY PRIVATE LIMITED",
"MUMBAI BRAHAMAPUTRA INFRACON PRIVATE LIMITED",
"MUMBAI CARGO SERVICE CENTER AIRPORT PRIVATE LIMITED",
"MUMBAI CARGO SERVICE CENTER COLD CHAIN SOLUTIONS PRIVATE LIMITED",
"MUMBAI CITICLINIC PRIVATE LIMITED",
"MUMBAI DISTRICT CENTRAL CO-OPERATIVE BANK LTD",
"MUMBAI DISTRICT TB CONTROL SOCIETY",
"MUMBAI DISTRICT TUBERCULOSIS CONTROL SOCITEY",
"MUMBAI DISTRICTS AIDS CONTROL SOCIETY",
"MUMBAI EDUCATIONAL TRUST",
"MUMBAI FABRICS PRIVATE LIMITED",
"MUMBAI FALCONS RACING LIMITED",
"MUMBAI FRESH PRIVATE LIMITED",
"MUMBAI GEMS & DIAMONDS PRIVATE LIMITED",
"MUMBAI GWALAS PRIVATE LIMITED",
"MUMBAI HOUSING REDEVELOPMENT PRIVATE LIMITED",
"MUMBAI INTERNATIONAL AIRPORT LIMITED",
"MUMBAI INTERNATIONAL AIRPORT PRIVATE. LIMITED",
"MUMBAI MANTRA MEDIA LIMITED",
"MUMBAI MARKETING PRIVATE LIMITED",
"MUMBAI METRO HOTELS PRIVATE LIMITED",
"MUMBAI METRO ONE PRIVATE LIMITED",
"MUMBAI METRO ONE PRIVATE LIMITED.",
"MUMBAI METRO RAIL CORPORATION LIMITED",
"MUMBAI METROPOLITAN REGION DEVELOPMENT AUTHORITY",
"MUMBAI MOBILE CRECHES",
"MUMBAI MOVIE STUDIOS PRIVATE LIMITED",
"MUMBAI NASIK EXPRESSWAY PRIVATE LIMITED",
"MUMBAI PORT TRUST",
"MUMBAI PUBLIC SCHOOL",
"MUMBAI PUNE EXPRESSWAY LIMITED",
"MUMBAI RAILWAY VIKAS CORPORATION",
"MUMBAI ROZGAAR PRIVATE LIMITED",
"MUMBAI SEZ LIMITED",
"MUMBAI SHELTER HOUSING DEVELOPMENT PRIVATE LIMITED",
"MUMBAI SOUTHERN ROADWAYS PRIVATE LIMITED",
"MUMBAI TRAVEL RETAIL PRIVATE LIMITED",
"MUMBAI URDU HIGH SCHOOL",
"MUMBAI URJA MARG LIMITED",
"MUMBAI WASTE MANAGEMENT LIMITED",
"MUMBAI WINES & TRADERS PRIVATE LIMITED",
"MUMBAI-JNPT PORT ROAD COMPANY LIMITED",
"MUMBAIKAR DECOR AND EVENTS PRIVATE LIMITED",
"MUMMAMIA FOODS INDIA PRIVATE LIMITED",
"MUMMY FOOD PRODUCTS PRIVATE LIMITED",
"MUMTAZ COLLEGE",
"MUMTAZ HOTELS LIMITED",
"MUMUSO RETAIL PRIVATE LIMITED",
"MUN HEALTH PRODUCT (INDIA) PRIVATE LIMITED",
"MUNAK CREDIT AND INVESTMENT PVT LTD",
"MUNARA AGRO TECHNOLOGIES PRIVATE LIMITED",
"MUNCH DESIGN WORKSHOP PRIVATE LIMITED",
"MUNCHBOX FREZEN FOODS PRIVATE LIMITED",
"MUNCHENER RUCKVERSICHERUNGS GESELLSCHAFT",
"MUNCHENER RUCKVERSICHERUNGS-GESELLSCHAFT AKTIENGESELLSCHAFT",
"MUNCHUR MACHINES PRIVATE LIMITED",
"MUNCIPAL CORPORATION OF AMBALA",
"MUNCIPAL CORPORATION OF GREATER MUMBAI",
"MUNCIPLE COUNCIL KAMPTEE",
"MUNDAN INFRAPROJECTS PRIVATE LIMITED",
"MUNDANE ORE MANAGEMENT SERVICE PRIVATE LIMITED",
"MUNDEJA PACKWELL PRIVATE LIMITED",
"MUNDESHWARI MULTICON PRIVATE LIMITED",
"MUNDHAR BAKERY & FOOD PRIVATE LIMITED",
"MUNDHARA WATERPROOF PRIVATE LIMITED",
"MUNDHE INDUSTRIES PRIVATE LIMITED",
"MUNDHRA AGENCIES PRIVATE LIMITED",
"MUNDHRA AND CO. PRIVATE LIMITED",
"MUNDHRA BULLION PRIVATE LIMITED",
"MUNDHRA CHEMICALS PRIVATE LTD",
"MUNDHRA CONTAINER FREIGHT STATION PRIVATE LIMITED",
"MUNDHRA EXIM PRIVATE LIMITED",
"MUNDHRA FISCAL SERVICES PVT LTD",
"MUNDHRA HOLDING PVT LTD",
"MUNDHRA HOSPITAL PRIVATE LIMITED",
"MUNDHRA MERCANTILE PRIVATE LIMITED",
"MUNDHRA POLYCOM PRIVATE LIMITED",
"MUNDHRA TRADERS PRIVATE LIMITED",
"MUNDIAL EXPORT IMPORT FINAME PVT LTD",
"MUNDIWALE KISHAN LAL SONI JEWELLERS PRIVATE LIMITED",
"MUNDRA AGRO PRIVATE LIMITED",
"MUNDRA DREAM HOMES PRIVATE LIMITED",
"MUNDRA ENERGY PRIVATE LIMITED",
"MUNDRA ENTERPRISES PRIVATE LIMITED",
"MUNDRA EXPORTS PRIVATE LIMITED",
"MUNDRA HOMETEX PRIVATE LIMITED",
"MUNDRA INTERNATIONAL AIRPORT LIMITED",
"MUNDRA INTERNATIONAL CONTAINER TERMINAL PRIVATE LIMITED",
"MUNDRA INVESTMENTS PRIVATE LIMITED",
"MUNDRA LPG TERMINAL PRIVATE LIMITED",
"MUNDRA OIL PRIVATE LIMITED",
"MUNDRA PETROCHEM LIMITED",
"MUNDRA PORT PTY LIMITED",
"MUNDRA SEZ TEXTILE AND APPAREL PARK PRIVATE LIMITED",
"MUNDRA SOLAR ENERGY LIMITED",
"MUNDRA SOLAR LIMITED",
"MUNDRA SOLAR PV LIMITED",
"MUNDRA SOLAR TECHNOPARK PRIVATE LIMITED",
"MUNDRA STEEL AND ALLOY PRIVATE LIMITED",
"MUNDRA TRACTORS",
"MUNDRA WOOLEN MILLS PVT. LTD.",
"MUNEER ENTERPRISES PRIVATE LIMITED",
"MUNEER MOTORS PRIVATE LIMITED",
"MUNESHWARI AGRO PRIVATE LIMITED",
"MUNEVY INFRASTRUCTURE PRIVATE LIMITED",
"MUNGASAJI MAHARAJ MAHAVIDYALAYA",
"MUNGEKAR & SONS CHB PRIVATE LIMITED",
"MUNGI ENGINEERS PRIVATE LIMITED",
"MUNGI METALCRAFT LLP",
"MUNGIPA CORPORATION INDIA PRIVATE LIMITED",
"MUNGIPA IRRITECH PRIVATE LIMITED",
"MUNI ROLLER FLOUR MILLS PVT LTD",
"MUNI SEVA ASHRAM",
"MUNI SUBHRAT NATH STEELS PRIVATE LIMITED",
"MUNIBISH FREIGHT PRIVATE LIMITED",
"MUNICH RE INDIA SERVICES PRIVATE LIMITED",
"MUNICIPAL COMMITTEE",
"MUNICIPAL CORPORATION",
"MUNICIPAL CORPORATION BILASPUR",
"MUNICIPAL CORPORATION CHANDIGARH",
"MUNICIPAL CORPORATION JALANDHAR",
"MUNICIPAL CORPORATION KORBA",
"MUNICIPAL CORPORATION LUDHIANA",
"MUNICIPAL CORPORATION OF DELHI",
"MUNICIPAL CORPORATION OF GREATER MUMBAI",
"MUNICIPAL CORPORATION PRIMARY SCHOOL NO 15 SANGLI",
"MUNICIPAL COUNCIL ACHALPUR",
"MUNICIPAL COUNCIL CHANDUR BAZAR",
"MUNICIPAL COUNCIL KAMPTEE",
"MUNICIPAL COUNCIL MANDI DABWALI",
"MUNICIPAL DISTRICT EDUCATION COMMITTEE MANAGED PRIMARY SCHOOL TEACHER",
"MUNICIPAL DISTRICT EDUCATION COMMITTEE MANAGED PRIMARY SCHOOL TEACHER NAGAR PRIMARY SCHOOL",
"MUNICIPAL HOSPITAL",
"MUNICIPAL HOSPITAL BHUBANESWAR",
"MUNICIPAL SCHOOL BOARD SURAT",
"MUNICIPAL SCHOOL BORAD SURAT",
"MUNIMJI FOODS AND SPICES PRIVATE LIMITED",
"MUNIRAJ COLOURS PRIVATE LIMITED",
"MUNISH FORGE PRIVATE LIMITED",
"MUNISH INDUSTRIAL CHEMICALS PVT LTD",
"MUNISH INTERNATIONAL PRIVATE LIMITED",
"MUNISUVRAT SILK MILLS PRIVATE LIMITED",
"MUNITIONS INDIA LIMITED",
"MUNIX (INDIA) PRIVATE LIMITED",
"MUNJAAL BOTIQUE HOMES PRIVATE LIMITED",
"MUNJAL AUTO INDUSTRIES LIMITED",
"MUNJAL CHAKRABORTY SOFTWARES AND MEDIA PRIVATE LIMITED",
"MUNJAL INVESTMENTS PVT LTD",
"MUNJAL JAIN ESTATES PRIVATE LIMITED",
"MUNJAL KIRIU INDUSTRIES PRIVATE LIMITED",
"MUNJAL SHOWA LIMITED",
"MUNJANI BROTHERS",
"MUNJANI FABTEX PRIVATE LIMITED",
"MUNJAPARA TEXTILE PRIVATE LIMITED",
"MUNJRAL BROTHERS (DISTRIBUTION) PRIVATE LIMITED",
"MUNKA DAL AND OIL MILLS PVT LTD",
"MUNMUN AGROTECH PRIVATE LIMITED",
"MUNN ENGINEERS AND DEVELOPERS PRIVATE LIMITED",
"MUNNA CONSTRUCTION COMPANY PRIVATE LIMITED",
"MUNNA LAL MILLS STORE PRIVATE LIMITED",
"MUNNALAL MAHESHLAL ARYA JEWELLERS PRIVATE LIMITED",
"MUNNALAL PANNALAL CONSTRUCTIONS PVT LTD",
"MUNNANGI SEAFOODS PRIVATE LIMITED",
"MUNNAR BUILDCON PRIVATE LIMITED",
"MUNNAR PLANTATIONS PRIVATE LIMITED",
"MUNNAUNITED HOSPITALITY SERVICES PRIVATE LIMITED",
"MUNNI LAL TANDOORS PRIVATE LIMITED",
"MUNNUS FASHIONS PRIVATE LIMITED",
"MUNOT FINCON LIMITED",
"MUNOT INVESTMENT PRIVATE LIMITED (OPC)",
"MUNOT ROOFING SOLUTIONS PRIVATE LIMITED",
"MUNOT TEXTILES MILL",
"MUNOTH FINANCIAL SERVICES LIMITED",
"MUNRO ACOUSTICS LLP",
"MUNSHI KEWAL STEELS (INDIA) PRIVATE LIMITED",
"MUNSHI PANNA MASALA UDYOG PRIVATE LIMITED",
"MUNTAHA CONSTRUCTION PRIVATE LIMITED",
"MUNTAHA FOODS PRIVATE LIMITED",
"MUNTAJAT INDIA PRIVATE LIMITED",
"MUNTERS INDIA HUMIDITY CONTROL PRIVATE LIMITEDAMBERNATH",
"MUNZING MUMBAI PRIVATE LIMITED",
"MUPPA AKSHAJA PROJECTS PRIVATE LIMITED",
"MUPPA PROJECTS INDIA PRIVATE LIMITED",
"MUPRO INDIA PRIVATE LIMITED",
"MUQEEM & BROTHERS PRIVATE LIMITED",
"MURA COLLECTIVE TEXTILES & CRAFTS PRIVATE LIMITED",
"MURA INDIA ENTERPRISES PRIVATE LIMITED",
"MURA ITALIA KAMPENI PRIVATE LIMITED",
"MURAAI INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"MURABLACK VYAPAAR PVT.LTD.",
"MURAE ORGANISOR LIMITED",
"MURAHAR INVESTMENTS AND TRADING COMPANY LIMITED",
"MURAJ PLAST PRIVATE LIMITED",
"MURAKAMI MANUFACTURING INDIA PRIVATE LIMITED",
"MURALI AUTOMOBILES PRIVATE LIMITED",
"MURALI KRISHNA DAIRY PRIVATE LIMITED",
"MURALI SESH ENVIRO ENGINEERS PRIVATE LIMITED",
"MURALI VIJAYA AGENCIES PRIVATE LIMITED",
"MURALIDHAR GIRLS COLLEGE",
"MURALIDHAR GRAINS PRIVATE LIMITED",
"MURALIKRISHNA FISHERIES PVT.LTD.",
"MURALIKRISHNA MILK PRODUCTS PRIVATE LIMITED",
"MURALIMANOHARA AGRO FOOD PRODUCTS PRIVATE LIMITED",
"MURALO CHEMICALS AND PAINTS PRIVATE LIMITED",
"MURALYA DAIRY PRODUCTS PRIVATE LIMITED",
"MURALYA HOTELS AND RESORTS PRIVATE LIMITED",
"MURANO TILES PRIVATE LIMITED",
"MURARI AND MOKSHAGNA LOGISTICS PRIVATE LIMITED",
"MURARI CAP PRIVATE LIMITED",
"MURARI GASES PRIVATE LIMITED",
"MURARI INVESTMENT & TRADING CO LTD",
"MURARI MOHAN FLOUR MILL PRIVATE LIMITED",
"MURARI MOHAN HOTELS PRIVATE LIMITED",
"MURARI MOHAN RICE MILLS PRIVATE LIMITED",
"MURARI SECURITIES LIMITED",
"MURARI STEELS PRIVATE LIMITED",
"MURARKA BISCUITS PRIVATE LIMITED",
"MURARKA DISTRIBUTORS PRVATE LIMITED",
"MURARKA EXIM PRIVATE LIMITED",
"MURARKA IMPEX PRIVATE LIMITED",
"MURARKA PAINT & VARNISH WORKS LTD",
"MURARKA SUITINGS PRIVATE LIMITED",
"MURARKA TEXTILES PRIVATE LIMITED",
"MURASIT BAUCHEMIE GOA PRIVATE LIMITED",
"MURASPEC DISTRIBUTORS INDIA PRIVATE LIMI TED",
"MURAT PVC & ALUMINIUM MACHINES INDIA PRIVATE LIMITED",
"MURATA BUSINESS ENGINEERING (INDIA) PRIVATE LIMITED",
"MURATA ELECTRONICS INDIA PRIVATE LIMITED",
"MURATA IMPEX PRIVATE LIMITED",
"MURATA MACHINERY INDIA PRIVATE LIMITED",
"MURATA VIOS PRIVATE LIMITED",
"MURAYA NETWORK PRIVATE LIMITED",
"MURBAD NAGARPANCHAYAT MURBAD",
"MURDESHWAR INFRA PROJECTS PRIVATE LIMITED",
"MURE MEMORIAL HOSPITAL",
"MUREN IMPEX PRIVATE LIMITED",
"MURJI MEGHAN",
"MURLAX ENTERPRISES PRIVATE LIMITED",
"MURLI AGRO PRODUCTS LIMITED",
"MURLI CEMENT",
"MURLI COLD STORAGE PVT LTD",
"MURLI FLOUR MILLS PRIVATE LIMITED",
"MURLI INDUSTRIES LIMITED CN",
"MURLI KRISHNA CHICORY PROCESSORS PRIVATE LIMITED",
"MURLI KRISHNA EXPORTS PRIVATE LIMITED",
"MURLI KRISHNA PHARMA PRIVATE LIMITED",
"MURLI REALTORS PRIVATE LIMITED",
"MURLI REFRIGERATION PRIVATE LIMITED",
"MURLIDHAR JEWELLERS",
"MURLIDHAR PRINTERS PRIVATE LIMITED",
"MURLIDHAR RAMSWARUP UPADHYAY PRIVATE LIMITED",
"MURLIDHAR RATANLAL EXPORTS LIMITED",
"MURLIDHAR SALES PRIVATE LIMITED",
"MURLIDHAR TEX PRINTS PRIVATE LIMITED",
"MURLIKRISHNA FOODS PRIVATE LIMITED",
"MURLIWALA AGROTECH PRIVATE LIMITED",
"MURLIWALA DYEING AND PRINTING MILLS PRIVATE LIMITED",
"MURLIWALA MINERALS PRIVATE LIMITED",
"MURLIWALA STONE INDUSTRY LIMITED",
"MURPHY USA INC.",
"MURRAYA E-AUTO ENGINEERING WORKS PRIVATE LIMITED",
"MURREN CONSULTING PRIVATE LIMITED",
"MURSHIDABAD SILKS PRIVATE LIMITED",
"MURTAJA HUSAIN MEMORIAL HIGH SCHOOL",
"MURTHAL AUTO PRIVATE LIMITED",
"MURTHY FABRICS PRIVATE LIMITED",
"MURTHY GLASS & PLYWOODS PRIVATE LIMITED",
"MURTHY IMMIGRATION SERVICES PRIVATE LIMITED",
"MURTHY'S LAB GLASS WORKS PRIVATE LIMITED",
"MURTI HOSPITALITY PRIVATE LIMITED",
"MURTI SHIP MANAGEMENT PRIVATE LIMITED",
"MURTI SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED",
"MURTI TUBES PRIVATE LIMITED",
"MURTI UDYOG LIMITED",
"MURTI WOOD FLOORS PRIVATE LIMITED",
"MURUDESHWAR CERAMICS LIMITED",
"MURUDESHWAR POWER CORPORATION PRIVATE LIMITED",
"MURUGA DHANUSHKODI GIRLS HR.SEC.SCH",
"MURUGAN ENTERPRISE PRIVATE LIMITED",
"MURUGAN HOSPITALS",
"MURUGAN REFINERIES PRIVATE LIMITED",
"MURUGAN TEXTILES",
"MURUGAPPA EDUCATIONAL AND MEDICAL FOUNDATION",
"MURUGAPPA MANAGEMENT SERVICES LIMITED",
"MURUGAPPA MANAGEMENT SERVICES PRIVATE LIMITED",
"MURUGAPPA MORGAN THERMAL CERAMICS LIMITED",
"MURUGAPPA WATER TECHNOLOGY AND SOLUTIONS PRIVATE LIMITED",
"MURULIDHAR GIRLS COLLEGE",
"MURZELLO ENGINEERING SERVICES PRIVATE LIMITED",
"MUSADDILAL GEMS AND JEWELS (INDIA) PRIVATE LIMITED",
"MUSADDILAL HOLDINGS PRIVATE LIMITED",
"MUSADDILAL PROJECTS PRIVATE LIMITED",
"MUSADDILAL PROPERTIES PRIVATE LIMITED",
"MUSADDILALS JEWELLERS (INDIA) PRIVATE LIMITED",
"MUSAFIR AUTO SALES AND SERVICES PRIVATE LIMITED",
"MUSAFIR CONFERENCE & SERVICES PRIVATE LIMITED",
"MUSAFIR.COM INDIA PRIVATE LIMITED",
"MUSALE LOGISTICS PRIVATE LIMITED",
"MUSARUBRA SOFTWARE INDIA PRIVATE LIMITED",
"MUSASHI AUTO PARTS INDIA PRIVATE LIMITED",
"MUSASHI PAINT INDIA PRIVATE LIMITED",
"MUSCAT ENGINEERING CONSULTANCY PRIVATE LIMITED",
"MUSCLE BABYY INTERNATIONAL PRIVATE LIMITED",
"MUSCLE DOMINATOR PRIVATE LIMITED",
"MUSCLE HOUSE I PRIVATE LIMITED",
"MUSCLEPRO NUTRITION PRIVATE LIMITED",
"MUSCOVITE UNIVERSAL INFRA PRIVATE LIMITED",
"MUSEE MUSICAL PRIVATE LIMITED",
"MUSEWW COMMUNICATIONS PRIVATE LIMITED",
"MUSH TEXTILE PRIVATE LIMITED",
"MUSHKIYA LIFESTYLE PRIVATE LIMITED",
"MUSHROOM HUB",
"MUSHROOM WORLD AYURVED & FOOD PRIVATE LIMITED",
"MUSIC & MORE DISTRIBUTION CO. PRIVATE LIMITED",
"MUSIC BROADCAST LIMITED",
"MUSIC PRODUCTS AND ACCESSORIES PRIVATE LIMITED",
"MUSIC TRIBE INNOVATION PRIVATE LIMITED",
"MUSIC WORLD RETAIL LIMITED",
"MUSICAL RESTAURANT PRIVATE LIMITED",
"MUSIGMA BUSINESS SOLUTIONS PRIVATE LIMITED",
"MUSIKSHACK INTERNATIONAL PRIVATE LIMITED",
"MUSING TRADE PRIVATE LIMITED",
"MUSIRI BLUE METALS AND SANDS PRIVATE LIMITED",
"MUSK FREIGHT SERVICES PRIVATE LIMITED",
"MUSKAAN ROTOPACK PRIVATE LIMITED",
"MUSKAAN SAFETY SOLUTIONS PRIVATE LIMITED",
"MUSKAAN TRADEX PRIVATE LIMITED",
"MUSKAN AGENCIES & TRADING LTD",
"MUSKAN CONSTRUCTIONS PRIVATE LIMITED",
"MUSKAN CONTAINER LINES PRIVATE LIMITED",
"MUSKAN EDUCATION SYSTEM",
"MUSKAN HIGHRISE PRIVATE LIMITED",
"MUSKAN HOSPITALITY PRIVATE LIMITED",
"MUSKAN INFRAESTATE LIMITED",
"MUSKAN LOOMTEX PRIVATE LIMITED",
"MUSKAN MEDICAL CENTRE PRIVATE LIMITED",
"MUSKAN MINERALS PRIVATE LIMITED",
"MUSKAN OVERSEAS PRIVATE LIMITED",
"MUSKAN PAPERS PRIVATE LIMITED",
"MUSKAN RUGNALAYA PRIVATE LIMITED",
"MUSKAN TOURS",
"MUSKAN TOWERS PRIVATE LIMITED",
"MUSKETEERS SECURITY PRIVATE LIMITED",
"MUSKURAHAT FOUNDATION",
"MUSLIM MATERNITY AND CHILDREN'S HOSPITAL",
"MUSLUNKAR JEWELLERS PRIVATE LIMITED",
"MUSOU MICRO FLASH FOAMS PRIVATE LIMITED",
"MUSSOORIE INTERNATIONAL SCHOOL",
"MUSSOORIE TRADING CO PRIVATE LIMITED",
"MUST & MORE HEALTH CARE PRIVATE LIMITED",
"MUST IT SERVICES PRIVATE LIMITED",
"MUSTAFA TRADERS PRIVATE LIMITED",
"MUSTANG MOTORS PRIVATE LIMITED",
"MUSTANG MOULDINGS PRIVATE LIMITED",
"MUSTANG PROPERTIES PVT LTD",
"MUSTANG SERVICES",
"MUSTARD CLOTHING COMPANY PRIVATE LIMITED",
"MUSTARO TECHNOSERVE PRIVATE LIMITED",
"MUSTE IMPEX PRIVATE LIMITED",
"MUSTKIM AND JAMIRUDDIN POWER PRIVATE LIMITED",
"MUTANT FILMS PRIVATE LIMITED",
"MUTC LOGISTICS PRIVATE LIMITED",
"MUTCHALL ENGINEERING PRIVATE LIMITED",
"MUTE WEB TECHNOLOGIES PRIVATE LIMITED",
"MUTESEAL ACOUSTICS PRIVATE LIMITED",
"MUTEX SOFT SOLUTIONS PRIVATE LIMITED",
"MUTHA ENGINEERING PRIVATE LIMITED",
"MUTHA FOUNDERS PRIVATE LIMITED",
"MUTHA FOUNDERS PVT LTD",
"MUTHA INDUSTRIES PRIVATE LIMITED",
"MUTHA TUBES & PIPES PRIVATE LIMITED",
"MUTHALAGU FINANCE PRIVATE LIMITED",
"MUTHALAMMAN METAL INDUSTRIES",
"MUTHAMMAL ESTATES PRIVATE LIMITED",
"MUTHAYAMMAL COLLEGE OF ARTS AND SICENCE",
"MUTHIAH MOTORS PRIVATE LIMITED",
"MUTHOOT ASSET MANAGEMENT PRIVATE LIMITED",
"MUTHOOT AUTOMOTIVE (INDIA) PRIVATE LIMITED",
"MUTHOOT BROADCASTING PRIVATE LIMITED",
"MUTHOOT CAPITAL SERVICES LIMITED",
"MUTHOOT COMMODITIES LIMITED",
"MUTHOOT EXIM PRIVATE LIMITED",
"MUTHOOT FINANCE LIMITED",
"MUTHOOT FINCORP LIMITED",
"MUTHOOT FOREX LIMITED",
"MUTHOOT HEALTH CARE PRIVATE LIMITED",
"MUTHOOT HOMEFIN INDIA LIMITED",
"MUTHOOT HOTELS PRIVATE LIMITED",
"MUTHOOT HOUSING FINANCE COMPANY LIMITED",
"MUTHOOT INSURANCE BROKERS PRIVATE LIMITED",
"MUTHOOT LEISURE AND HOSPITALITY SERVICES PRIVATE LIMITED",
"MUTHOOT M GEORGE INSTITUTE OF TECHNOLOGY",
"MUTHOOT MARKETING SERVICES PRIVATE LIMITED",
"MUTHOOT MERCANTILE LIMITED",
"MUTHOOT MICROFIN LIMITED",
"MUTHOOT MONEY LIMITED",
"MUTHOOT MOTORS PVT LTD",
"MUTHOOT PAPPACHAN CENTRE OF EXCELLENCE IN SPORTS",
"MUTHOOT PAPPACHAN CHITS INDIA PRIVATE LIMITED",
"MUTHOOT PAPPACHAN TECHNOLOGIES LIMITED",
"MUTHOOT RISK INSURANCE AND BROKING SERVICES PRIVATE LIMITED",
"MUTHOOT SECURITIES LIMITED",
"MUTHOOT SYSTEMS AND TECHNOLOGIES PRIVATE LIMITED",
"MUTHOOT VEHICLE & ASSET FINANCE LIMITED",
"MUTHOOTTU MINI FINANCIERS LIMITED",
"MUTHOOTTU MINI NIDHI LIMITED",
"MUTHOOTTU URBAN NIDHI LIMITED",
"MUTHOTTU MINI THEATRES PRIVATE LIMITED",
"MUTHTHAMIZ MALAI MEDIA PRIVATE LIMITED",
"MUTHU AUTOS PRIVATE LIMITED",
"MUTHU BARRELS TRADING PRIVATE LIMITED",
"MUTHU FOREX PRIVATE LIMITED",
"MUTHU HOSPITAL ENTERPRISES PRIVATE LIMITED",
"MUTHU MULTI SPECIALITY HOSPITAL",
"MUTHU PHARMA PRIVATE LIMITED",
"MUTHU PHARMACY PRIVATE LIMITED",
"MUTHU PIPES PRIVATE LIMITED",
"MUTHU POULTRY AGENCIES",
"MUTHU SOFT LABS PRIVATE LIMITED",
"MUTHU SPINNING MILLS PRIVATE LIMITED",
"MUTHU TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"MUTHUR MURUGAN MILLS LIMITED",
"MUTHURANGAM GOVT COLLEGE",
"MUTHUSWAMY CATERING SERVICES PRIVATE LIMITED",
"MUTIARA ROOFING INDUSTRIES PRIVATE LIMITED",
"MUTTA STEELAGE PVT.LTD.",
"MUTUAL AUTOMOTIVE PRIVATE LIMITED",
"MUTUAL ENGINEERING PRIVATE LIMITED",
"MUTUAL GLOBAL INSURANCE BROKING PRIVATE LIMITED",
"MUTUAL INDUSTRIES LIMITED",
"MUTUAL PR CONSULTING PRIVATE LIMITED",
"MUTUALMOBILE SOLUTIONS PRIVATE LIMITED",
"MUTYAM STEEL PRIVATE LIMITED",
"MUVA INDUSTRIES PRIVATE LIMITED",
"MUVALL CASTORS PRIVATE LIMITED",
"MUVI ENTERTAINMENT PRIVATE LIMITED",
"MUVR TECHNOLOGY PRIVATE LIMITED",
"MUVTONS CASTORS PRIVATE LIMITED",
"MUWAL CONSTRUCTION PRIVATE LIMITED",
"MUZAFFARPUR HEART HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED",
"MUZALI ARTS LIMITED",
"MUZASHI RECYCLERS PRIVATE LIMITED",
"MUZIRIS SOFTECH PRIVATE LIMITED",
"MUZOOMDAR ASSOCIATES PRIVATE LIMITED",
"MV ASTROSUNSHINE PRIVATE LIMITED",
"MV CLOUDS PRIVATE LIMITED",
"MV COLLEGE OF COMMERCE",
"MV DEALERS PRIVATE LIMITED",
"MV ELECTRONICS PRIVATE LIMITED",
"MV ELECTROSYSTEMS LIMITED",
"MV MANDALLS COLLEGES OF COMMERCE AND SCIENCE",
"MV MOBILITY LIMITED",
"MV SALTS AND CHEMICALS PVT LTD",
"MV SUPER ALLOYS PRIVATE LIMITED",
"MV TEMPANES PRIVATE LIMITED",
"MV2 PRECISION PRODUCTS PRIVATE LIMITED",
"MVD BUILDWELL PRIVATE LIMITED",
"MVD CEMENTATION AND CONSTRUCTION PRIVATE LIMITED",
"MVD FASTENERS PRIVATE LIMITED",
"MVD FINSEC PRIVATE LIMITED",
"MVD TECHNOLOGIES PRIVATE LIMITED",
"MVDCO ADVISORY SERVICES PRIVATE LIMITED",
"MVD'S ASSOCIATES PRIVATE LIMITED",
"MVENDORS ECOMMERCE MARKETPLACE PRIVATE LIMITED",
"MVENKATA RAO INFRA PROJECTS PRIVATE LIMITED",
"MVG BUILDERS & DEVELOPERS PRIVATE LIMITED",
"MVG DIGITAL CONSULTING PRIVATE LIMITED",
"MVGR COLLEGE OF ENGINEERING",
"MVH PRINTERS",
"MVI TECHNOLOGIES INDIA PRIVATE LIMITED",
"MVIKAS TECHNOLOGIES PRIVATE LIMITED",
"MVIRDC",
"MVITO INDUSTRIES PRIVATE LIMITED",
"MVJ COLLEGE OF ENGINEERING",
"MVJ MEDICAL COLLEGE AND RESEARCH HOSPITAL",
"MVJ PU COLLEGE",
"MVK INDUSTRIES PRIVATE LIMITED",
"MVKS OFFICE SOLUTIONS PRIVATE LIMITED",
"MVL CONSULTING PRIVATE LIMITED",
"MVL MEDISYNTH PRIVATE LIMITED",
"MVLK INFRA PROJECTS PRIVATE LIMITED",
"MVM COMMODITIES PRIVATE LIMITED",
"MVM PERFECT TOOL MAKERS PRIVATE LIMITED",
"MVM SECURITIES PRIVATE LIMITED",
"MVM SOLAR PRIVATE LIMITED",
"MVN ASSOCIATES PRIVATE LIMITED",
"MVN FINANCIAL ADVISORS PRIVATE LIMITED",
"MVN INFRASTRUCTURE PRIVATE LIMITED",
"MVN SCHOOL ARAVALI HILLS",
"MVOMNI SHAYONA BIPL (PALANPUR) PRIVATE LIMITED",
"MVOMNI SHAYONA BIPL (RAJKOT) PRIVATE LIMITED",
"MVP HOSPITAL",
"GROMA INFRASTRUCTURE LIMITED",
"MVR AUTOMOBILES PRIVATE LIMITED",
"MVR AUTOMOTIVE PRIVATE LIMITED",
"MVR COLLEGE",
"MVR DEGREE PG COLLEGE",
"MVR DIESEL ELECTROMECH ENGINEERS",
"MVR EXPLANATION PRIVATE LIMITED",
"MVR MEDICAL SERVICES PRIVATE LIMITED",
"MVR PG DEGREE COLLEGE",
"MVR SEAVIEW HOMES PRIVATE LIMITED",
"MVS ACMEI TECHNOLOGIES PRIVATE LIMITED",
"MVS DATA CORPORATION PRIVATE LIMITED",
"MVS EDUEXCELLENCE PRIVATE LIMITED",
"MVS ENGINEERING PRIVATE LIMITED",
"MVS ESTATE & CONSULTANT PRIVATE LIMITED",
"MVS LEASING PVT. LTD.",
"MVS THREADS PRIVATE LIMITED",
"MVSD FOODS INDIA LLP",
"MVSR ENG COLLEGE",
"MVV WATER UTILITY PRIVATE LIMITED",
"MVVS MARITIME FOUNDATION",
"MVW NETWORK INTERNATIONAL PRIVATE LIMITED",
"MW COM INDIAPRIVATE LIMITED",
"MW HIGH TECH PROJECTS INDIA PRIVATE LIMITED",
"MW MINES PRIVATE LIMITED",
"MW WIRETEC PRIVATE LIMITED",
"MWB TECHNOLOGIES INDIA PRIVATE LIMITED",
"MWEBWARE SOFTWARE SERVICES PRIVATE LIMITED",
"MWF LOGISTICS LIMITED",
"MWH INDIA PRIVATE LIMITED",
"MWI INDIA PRIVATE LIMITED",
"MWI MYWORLD INDIA PRIVATE LIMITED",
"M-WORTH FACILITY SERVICES PRIVATE LIMITED",
"MWT EDUCATION CONSULTANCY PRIVATE LIMITED",
"MWT TECHNOLOGIES PRIVATE LIMITED",
"MWV INDIA PAPERBOARD PACKAGING PRIVATE LIMITED",
"MWW GACHIBOWLI PRIVATE LIMITED",
"MWYN TECH PRIVATE LIMITED",
"MX ADVERTISING PRIVATE LIMITED",
"MX ELECTRONICS PRIVATE LIMITED",
"MX INFORMATION SYSTEMS PRIVATE LIMITED",
"MX SYSTEMS INTERNATIONAL PRIVATE LIMITED",
"MXB AGRO INPUTS PRIVATE LIMITED",
"MXC SOLUTIONS INDIA PRIVATE LIMITED",
"MXI CODERS PRIVATE LIMITED",
"MXM.CLUB PRIVATE LIMITED",
"MX-MDR TECHNOLOGIES LIMITED",
"MXNS IT SERVICES PRIVATE LIMITED",
"MXP MEDIA INDIA LIMITED",
"MXRADY LAB SOLUTIONS PRIVATE LIMITED",
"MY 247 SERVICES PRIVATE LIMITED",
"MY 7 DAYS FOREX SERVICES PRIVATE LIMITED",
"MY ARKAY COMMUNICATION SOLUTION PRIVATE LIMITED",
"MY AUTO WORLD (KANPUR) PRIVATE LIMITED",
"MY BIOTECH PRIVATE LIMITED",
"MY BOX TECHNOLOGIES PRIVATE LIMITED",
"MY BRANCH INFRASTRUCTURE PRIVATE LIMITED",
"MY BRANCH SERVICES PRIVATE LIMITED",
"MY CAR NEXA PRIVATE LIMITED",
"MY CAR PRIVATE LIMITED",
"MY CAR PUNE PRIVATE LIMITED",
"MY CHHOTA SCHOOL PRIVATE LIMITED",
"MY CHOICE ARCHERY PRIVATE LIMITED",
"MY CHOICE SAREES PRIVATE LIMITED",
"MY DEAR COSMETICS PRIVATE LIMITED",
"MY FINANCE CLUB LIMITED",
"MY FITNESS WALLET PRIVATE LIMITED",
"MY GLOBAL EXPRESS PRIVATE LIMITED",
"MY HEALTH CARE SHOPPEE PRIVATE LIMITED",
"MY HEALTHSKAPE MEDICALS PRIVATE LIMITED",
"MY HOME CONSTRUCTIONS PRIVATE LIMITED",
"MY HOME INDUSTRIES PRIVATE LIMITED",
"MY HOME INFRASTRUCTURES PRIVATE LIMITED",
"MY HOME PROPERTIES & SERVICES PRIVATE LIMITED",
"MY INBOX MEDIA PRIVATE LIMITED",
"MY INDIA KART PRIVATE LIMITED",
"MY INDIFUELS PRIVATE LIMITED",
"MY IRIGACIO WORLD PRIVATE LIMITED",
"MY LIFE MY STYLE PRIVATE LIMITED",
"MY MILESTONES FASHION ESSENTIALS PRIVATE LIMITED",
"MY MILLIONLINES AYURVEDA PRIVATE LIMITED",
"MY MONEY SECURITIES LIMITED",
"MY MUDRA FINCORP LIMITED",
"MY NUTRITION HEALTH & WELLNESS INDIA PRIVATE LIMITED",
"MY NUTRITION SUPPLEMENTS PRIVATE LIMITED",
"MY OWN ECO-ENERGY PRIVATE LIMITED",
"MY OWN SCHOOL",
"MY PERSONAL HEALTH RECORD EXPRESS INDIA PRIVATE LIMITED",
"MY PLAST INDUSTRIES PRIVATE LIMITED",
"MY PROPERTY BOUTIQUE PRIVATE LIMITED",
"MY RECHARGE PRIVATE LIMITED",
"MY SEEDS PRIVATE LIMITED",
"MY SHANNEN SCHOOL",
"MY SWEET INDIA FOOD PRODUCTS PRIVATE LIMITED",
"MY TEXTILES PRIVATE LIMITED",
"MY TURF HOSPITALITY PRIVATE LIMITED",
"MY VAN PRIVATE LIMITED",
"MY VIRTUAL TEAMS PRIVATE LIMITED",
"MY WINGS PRIVATE LIMITED",
"MYAASHIANA MANAGEMENT SERVICES PRIVATE LIMITED",
"MYACCOUNTS ONLINE SOFTWARES PRIVATE LIMITED",
"MYADVO TECHSERVE PRIVATE LIMITED",
"MYAFAT TANNERIES PRIVATE LIMITED",
"MYAKAN KNITS (INDIA) PRIVATE LIMITED",
"MYALTERNATES FINANCIAL SERVICES PRIVATE LIMITED",
"MYARA TRADE & SERVICES PRIVATE LIMITED",
"MYATRA SALT WORKS PRIVATE LIMITED",
"MYBABY FASHIONS PRIVATE LIMITED",
"MYBABY RETAIL INDIA PRIVATE LIMITED",
"MYBRA INTIMATES PRIVATE LIMITED",
"MYBRA LINGERIE PRIVATE LIMITED",
"MYBUTLER FACILITY MANAGEMENT PRIVATE LIMITED",
"MYC INDIA EDUCATION PRIVATE LIMITED",
"MYCAPELLA IT SOLUTIONS PRIVATE LIMITED",
"MYCARE HEALTH SOLUTIONS PRIVATE LIMITED",
"MYCITIUS TEX PRIVATE LIMITED",
"MYCLASSBOARD EDUCATIONAL SOLUTIONS PRIVATE LIMITED",
"MYCO ELECTRICALS PRIVATE LIMITED",
"MYCO INFRA PRIVATE LIMITED",
"MYCO SOIL (INDIA) PRIVATE LIMITED",
"MYCO TECH PRIVATE LIMITED",
"MYCOL DISTRIBUTORS PRIVATE LIMITED",
"MYCOM IMAGING SUPPLIES PRIVATE LIMITED",
"MYCOM OSI SOLUTIONS INDIA PRIVATE LIMITED",
"MYCON CONSTRUCTION LIMITED",
"MYCOR HUMAN CAPITAL SOLUTIONS PRIVATE LIMITED",
"MYCOZOOM BIOTECH INDIA PRIVATE LIMITED",
"MYDEALS247 ECOMMERCE PRIVATE LIMITED",
"MYDESQ TECHNOLOGY INDIA PRIVATE LIMITED",
"MYDHILI HOSPITAL",
"MYDIGITAL ACCOUNTS PRIVATE LIMITED",
"MYDSM GLOBAL SERVICES PRIVATE LIMITED",
"MYELIN INNOVATION PRIVATE LIMITED",
"MYENVIRE DEVELOPERS PRIVATE LIMITED",
"MYEXIM LOGISTICS INDIA PRIVATE LIMITED",
"MYFITSOUL TECHNOLOGIES PRIVATE LIMITED",
"MYFRA INDIA PRIVATE LIMITED",
"MYGO CONSULTING INDIA PRIVATE LIMITED",
"MYGOLA TECHNOLOGIES PRIVATE LIMITED",
"MYGOV",
"MYGREEN ENVIROPRODUCTS PRIVATE LIMITED",
"MYGURU ONLINE INDIA PRIVATE LIMITED",
"MYHNA PROPERTIES PRIVATE LIMITED",
"MYHOME COLLECTIONS PRIVATE LIMITED",
"MYK ARMENT PRIVATE LIMITED",
"MYK LATICRETE INDIA PRIVATE LIMITED",
"MYK SPINNING INDUSTRIES LIMITED",
"MYKA EVENT SOLUTIONS PRIVATE LIMITED",
"MYKA GIFTING PRIVATE LIMITED",
"MYKIND VACATIONS PRIVATE LIMITED",
"MYKINGDOM FOODS PRIVATE LIMITED",
"MYL NETWORKS PRIVATE LIMITED",
"MYLAB DISCOVERY SOLUTIONS PRIVATE LIMITED",
"MYLAN INC.",
"MYLAN LABORATORIES LIMITED",
"MYLAN PHARMACEUTICALS PRIVATE LIMITED",
"MYLAR SUGARS LIMITED",
"MYLEAD FINTECH PRIVATE LIMITED",
"MYLOANCARE VENTURES PRIVATE LIMITED",
"MYLOCKER TECH PRIVATE LIMITED",
"MYLON METALLICS PRIVATE LIMITED",
"MYM HOSPITALITIES PRIVATE LIMITED",
"MYMIRROR PUBLISHING HOUSE PRIVATE LIMITED",
"MYMO WIRELESS TECHNOLOGY PRIVATE LIMITED",
"MYMONEYKARMA INFOMATICS INDIA PRIVATE LIMITED",
"MYNA HOMES PRIVATE LIMITED",
"MYNAA AGROS PRIVATE LIMITED",
"MYNAH INDUSTRIES LIMITED",
"MYNAKAM GENERAL FINANCE PRIVATE LIMITED",
"MYNAX CABLES PRIVATE LIMITED",
"MYND FINANCIAL SERVICES PRIVATE LIMITED",
"MYND FINTECH PRIVATE LIMITED",
"MYND INTEGRATED SOLUTIONS PRIVATE LIMITED",
"MYND SOLUTIONS PRIVATE LIMITED",
"MYNOR ENTERPRISES PRIVATE LIMITED",
"MYNORES INDIA PVT. LTD",
"MYNTRA JABONG INDIA PRIVATE LIMITED",
"MYNTRASUTRA MICRO ASSOCIATION",
"MYO FLEX NUTRITION PRIVATE LIMITED",
"MYOHO CREATION PRIVATE LIMITED",
"MYOKSHA TRAVELS PRIVATE LIMITED",
"MYON FASHION TRENDZ PRIVATE LIMITED",
"MYOSYNTH LABORATORIES PRIVATE LIMITED",
"DAESEONG INDIA AUTOMOTIVE PRIVATE LIMITED",
"MYOVATEC SURGICAL SYSTEMS PVT LTD",
"MYPAPER KART PRIVATE LIMITED",
"MYPATH HEALTHCARE SERVICES PRIVATE LIMITED",
"MYPHER PHARMACEUTICALS LLP",
"MYPORT SERVICES INDIA PRIVATE LIMITED",
"MYPOWERKART ONLINE SOLUTIONS PRIVATE LIMITED",
"MYPREFERRED TRANSFORMATION AND HOSPITALITY PRIVATE LIMITED",
"MYPROMOVIDEOS PRIVATE LIMITED",
"MYPULSE.IO PRIVATE LIMITED",
"MYQSOFT INFOTECH PRIVATE LIMITED",
"MYQUEST INTERNATIONAL PRIVATE LIMITED",
"MYRA ALUCOP PRIVATE LIMITED",
"MYRA DESIGNS PRIVATE LIMITED.",
"MYRA DIGITAL (INDIA) PRIVATE LIMITED",
"MYRA ENTERPRISES PRIVATE LIMITED",
"MYRA FOILS PRIVATE LIMITED",
"MYRA HYGIENE PRODUCTS PRIVATE LIMITED",
"MYRA MALL MANAGEMENT COMPANY PRIVATE LIMITE",
"MYRA MULTIMEDIA ENTERPRISE PRIVATE LIMITED",
"MYRA TECHNO PACKERS PRIVATE LIMITED",
"MYRA TECHNOLABS",
"MYRA WOMEN'S HOSPITAL PRIVATE LIMITED",
"MYRAH SPA AND PRODUCTS PRIVATE LIMITED",
"MY-RETURN SOLUTIONS PRIVATE LIMITED",
"MYRIAD TEXTILES PRIVATE LIMITED",
"MYRICA HEALTHCARE PRIVATE LIMITED",
"MYROOTS INDIA PRIVATE LIMITED",
"MYROOTS RURAL BUSINESS CENTRES PRIVATE LIMITED",
"MYROOTS SEEDS PRIVATE LIMITED",
"MYRRA FMCG INDIA PRIVATE LIMITED",
"MYRTLE ADVISORY PRIVATE LIMITED",
"MYRTLE PROJECT AND CONSULTANCY PRIVATE LIMITED",
"MYS HOLDINGS PRIVATE LIMITED",
"MYSALARYDOST FINTECH PRIVATE LIMITED",
"MYSAVINGEXPERTS PRIVATE LIMITED",
"MYSCAPE PROPERTIES PRIVATE LIMITED",
"MYSCHOOLSTUFFSOLUTIONS PRIVATE LIMITED",
"MYSIM THERAPEUTICS PRIVATE LIMITED",
"MYSMARTPRICE WEB TECHNOLOGY PRIVATE LIMITED",
"MYSOFTLABS LLP",
"MYSORE AMALGAMATED COFFEE ESTATES LIMITED",
"MYSORE AMMONIA AND CHEMICALS LIMITED",
"MYSORE AMMONIA ENVIROTECH PRIVATE LIMITED",
"MYSORE AMMONIA PRIVATE LIMITED",
"MYSORE BIO PROTEINS PRIVATE LIMITED",
"MYSORE BOX PRIVATE LIMITED",
"MYSORE CONSULTANTS PRIVATE LIMITED",
"MYSORE DIAGNOSTIC CENTER PRIVATE LIMITED",
"MYSORE ENGINEERS (INDIA) PRIVATE LIMITED",
"MYSORE ESDM CLUSTER",
"MYSORE FRUIT PRODUCTS PRIVATE LIMITED",
"MYSORE HOLDINGS PRIVATE LIMITED",
"MYSORE INTERCONTINENTAL HOTELS PRIVATE LIMITED",
"MYSORE LIGHT & INTERIORS PRIVATE LIMITED",
"MYSORE LIGHTS AND INTERIOR PRIVATE LIMITED",
"MYSORE MERCANTILE COMPANY LIMITED",
"MYSORE PAINTS AND VARNISH LIMITED",
"MYSORE PETRO CHEMICALS LIMITED",
"MYSORE POLYMERS AND RUBBER PRODUCTS PRIVATE LIMITED",
"MYSORE POLYMERS PRIVATE LIMITED",
"MYSORE POLYSET PRIVATE LIMITED,",
"MYSORE PROJECTS PRIVATE LIMITED",
"MYSORE SALES INTERNATIONAL LIMITED",
"MYSORE SCIENCE AND TECHNOLOGY SERVICES PRIVATE LIMITED",
"MYSORE STEELS LIMITED",
"MYSORE THERMO ELECTRIC PRIVATE LIMITED",
"MYSORE WATER SERVICES PRIVATE LIMITED",
"MYSORE WIFILTRONICS PRIVATE LIMITED",
"MYSORE WIRE NETTING CO PRIVATE LIMITED",
"MYSORE-BELLARY HIGHWAY PRIVATE LIMITED",
"MYSOURCE INNOVENTURES PRIVATE LIMITED",
"MYSPACE ENGINEERING SERVICES PRIVATE LIMITED",
"MYSPACE REALTY PRIVATE LIMITED",
"MYSTARTUPCFO SHARED SERVICES PRIVATE LIMITED",
"MYSTERY MONKS ENTERTAINMENT PRIVATE LIMITED",
"MYSTIC ELECTRONICS LIMITED",
"MYSTIC SHIPPING PRIVATE LIMITED",
"MYSTICAL BIOTECH PRIVATE LIMITED",
"MYSTICAL PAPER PACK PRIVATE LIMITED",
"MYSTICAL PROPACK PRIVATE LIMITED",
"MYSTICAL TECHPLAST PRIVATE LIMITED",
"MYSTIFLY CONSULTING INDIA PRIVATE LIMITED",
"MYSTIKOE WEB SERVICES PRIVATE LIMITED",
"MYSTIQUE ATHLEISURE RETAIL PRIVATE LIMITED",
"MYSTIQUE AUDIT AND ALLIED SERVICES PRIVATE. LIMITED",
"MYSTIQUE LOGISTICS PRIVATE LIMITED",
"MYSTIQUE MEDIA PRIVATE LIMITED",
"MYSTUDIA PRIVATE LIMITED",
"MYSUPPLIER BUILDING TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"MYSURU SPECIALITY HOSPITALS PRIVATE LIMITED",
"MYSWA VENTURES PRIVATE LIMITED",
"MY-T CLOTHING INDUSTRIES PRIVATE LIMITED",
"MYTEAM RETAIL PRIVATE LIMITED",
"MYTEC ESTATE DEVELOPERS & BUILDERS PRIVATE LIMITED",
"MYTEC PROCESS PRIVATE LIMITED",
"MY-TEC SOFTWARE PRIVATE LIMITED",
"MYTECH GLOBAL PRIVATE LIMITED",
"MYTEK INNOVATIONS PRIVATE LIMITED",
"MYTEX (INDIA) SILK MILLS PRIVATE LIMITED",
"MYTEX POLYMERS INDIA PRIVATE LIMITED",
"MYTH MEDIA SOLUTION PRIVATE LIMITED",
"MYTH PHARMA CARE PRIVATE LIMITED",
"MYTHI PAINTS LLP",
"MYTHOCLAST TECHNOLOGIES INDIA PRIVATE LIMITED",
"MYTHRAYA RETAILERS PRIVATE LIMITED",
"MYTHRI FOOD PRODUCTS PRIVATE LIMITED",
"MYTHRI INFRASTRUCTURE AND MINING INDIA PRIVATE LIMITED",
"MYTHRI METALLIZING PRIVATE LIMITED",
"MYTHRI MULTI SPECIALITY HOSPITAL",
"MYTHRI SECURITY SERVICES INDIA PRIVATE LIMITED",
"MYTHRI TECHNO SOLUTIONS PRIVATE LIMITED",
"MYTRAH AADHYA POWER PRIVATE LIMITED",
"MYTRAH AAKASH POWER PRIVATE LIMITED",
"MYTRAH ABHINAV POWER PRIVATE LIMITED",
"MYTRAH ADARSH POWER PRIVATE LIMITED",
"MYTRAH AKSHAYA ENERGY PRIVATE LIMITED",
"MYTRAH ENERGY INDIA PRIVATE LIMITED",
"MYTRAH VAYU (GODAVARI) PRIVATE LIMITED",
"MYTRAH VAYU (INDRAVATI) PRIVATE LIMITED",
"MYTRAH VAYU (KRISHNA) PRIVATE LIMITED",
"MYTRAH VAYU (PENNAR) PRIVATE LIMITED",
"MYTRAH VAYU (TUNGABHADRA) PRIVATE LIMITED",
"MYTRAH VAYU MANJIRA PRIVATE LIMITED PHASE II",
"MYTRAH VAYU SOM PRIVATE LIMITED",
"MYTRAH VAYU URJA PRIVATE LIMITED",
"MYTRI AVIATION PRIVATE LIMITED",
"MYUNG SUNG INDIA PRECISION PRIVATE LIMITED",
"MYUNG SUNG INDUSTRIAL COMPANY INDIA PRIVATE LIMITED",
"MYUNGHWA AUTOMOTIVE INDIA PRIVATE LIMITED",
"MYVALUE TRIP PRIVATE LIMITED",
"MYVI FOODS PRIVATE LIMITED",
"MYVISHWA TECHNOLOGIES PRIVATE LIMITED",
"MYVISION MEDICAL PRIVATE LIMITED",
"MYWISH MARKETPLACES PRIVATE LIMITED",
"MYYOGATEACHER INDIA PRIVATE LIMITED",
"MYZEAL IT SOLUTIONS PRIVATE LIMITED",
"MYZINGO E COMMERCE SERVICES PRIVATE LIMITED",
"MZ FOOD PRODUCTS PRIVATE LIMITED",
"MZD STEELS PRIVATE LIMITED",
"MZEE FASHIONS PRIVATE LIMITED",
"MZIM AGROCHEM PRIVATE LIMITED",
"MZM ANALYTICS PRIVATE LIMITED",
"N & N COMTRADE PRIVATE LIMITED",
"N & N DEVELOPERS LIMITED",
"N & T ENGITECH PRIVATE LIMITED",
"N .K. COMMOTRADE PRIVATE LIMITED",
"N A CONSTRUCTION PRIVATE LIMITED",
"N A LEASING & CREDIT PRIVATE LIMITED",
"N A M EXPRESSWAY LIMITED",
"N A R INFRA PRIVATE LIMITED",
"N A SHAH ASSOCIATES LLP",
"N A SPORTZ INTERACTIVE PRIVATE LIMITED",
"N AND S SOLUTIONS PRIVATE LIMITED",
"N B COMMERCIAL ENTERPRISES LIMITED",
"N B CONSTRUCTION COMPANY",
"N B CONSTRUCTIONS PRIVATE LIMITED",
"N B COTEX PRIVATE LIMITED",
"N B INDUSTRIES (METERS) PVT LTD",
"N B MARKETING PRIVATE LIMITED",
"N B MERCANTILE COMPANY PRIVATE LIMITED",
"N B PHARMA PRIVATE LIMITED",
"N B R AGRO EXPORTS PRIVATE LIMITED",
"N B S S PUNE SHANTATAI ATHWALE PRIMARY SCHOOL KOTHRUD",
"N B S SECURITIES PRIVATE LTD",
"N B T AUTOCORP INDIA PRIVATE LIMITED",
"N B T EXPORT PRIVATE LIMITED",
"N B TECHNOCRATS PRIVATE LIMITED",
"N BABA PACKERS PRIVATE LIMITED",
"N C I INDIA PRIVATE LIMITED",
"N C JINDAL PUBLIC SCHOOL",
"N C JOHN AND SONS PRIVATE LIMITED",
"N C SHAW & CO. BEVERAGES PRIVATE LIMITED",
"N C VEDIC INT COLL AGRA CANTT",
"N CHIMANLAL AND CO PRIVATE LIMITED",
"N CHIRAG TRAVELS PRIVATE LIMITED",
"N CONCEPTS ADVERTISING PRIVATE LIMITED",
"N D A (NATIONAL DEFENCE ACADEMY)",
"N D A SECURITIES LIMITED",
"N D B K PROJECTS (INDIA) PRIVATE LIMITED",
"N D BIOTECH PRIVATE LIMITED",
"N D CLOTHING PRIVATE LIMITED",
"N D K HOTELS AND RESORTS LTD",
"N D R PLANTATIONS PRIVATE LIMITED",
"N D R WARE HOUSING PRIVATE LIMITED",
"N D T SYSTEMS PRIVATE LIMITED",
"N D TECHNO ENGINEERING PVT LTD",
"N D WINES PRIVATE LIMITED",
"N DESAI PAPERS PVT LTD",
"N DOT DORWIN FACADE SOLUTIONS PRIVATE LIMITED",
"N E FERRO & ALLOYS PRIVATE LIMITED",
"N E IMPEX PRIVATE LIMITED",
"N E REALCON PRIVATE LIMITED",
"N E S SCIENCE COLLEGE NANDED",
"N E T PUBLIC SCHOOL",
"N E THERMION PRIVATE LIMITED",
"N G A STEELS PRIVATE LIMITED",
"N G ELECTRO PRODUCTS PRIVATE LIMITED",
"N G FERTILIZERS AND CHEMICALS PRIVATE LIMITED",
"N G INDUSTRIES LTD",
"N G K TRADING COMPANY",
"N G PACKAGING PRIVATE LIMITED",
"N G PATEL FINLEASE PVT LTD",
"N G PHOSPHATES PRIVATE LIMITED",
"N G PROJECTS LIMITED",
"N G REALTY PRIVATE LIMITED",
"N GOPALDAS GEMS & JEWELLERY EXPORTS PRIVATE LIMITED",
"N H CONSTRUCTION PRIVATE LIMITED",
"N H PATEL COLLEGE OF EDUCATION",
"N I C CONSTRUCTION INDIA PRIVATE LIMITED",
"N I ENGINEERING TECHNOLOGIES PRIVATE LIMITED",
"N I INFRA ENGINEERING PRIVATE LIMITED",
"N J AGROCHEM PRIVATE LIMITED",
"N J COLD STORAGE PRIVATE LIMITED",
"N J DEVANI BUILDERS PVT LTD",
"N J GARMENTS PRIVATE LIMITED",
"N J R CONSTRUCTIONS PRIVATE LIMITED",
"N J STEEL INDUSTRIES PRIVATE LIMITED",
"N J TEXTURISERS PRIVATE LIMITED",
"N JEWELLERY TECHNIQUES PRIVATE LIMITED",
"N JOHNSON ENGINEERS PRIVATE LIMITED",
"N K AGARWAL BUILDCON PRIVATE LIMITED",
"N K AGRO COLD STORAGES PRIVATE LIMITED",
"N K AGRO EXPORTS (INDIA) PRIVATE LIMITED",
"N K B INFRASTRUCTURE PRIVATE LIMITED",
"N K C M SPINNERS PRIVATE LIMITED",
"N K E S HIGH SCHOOL",
"N K G PROPERTIES PRIVATE LIMITED",
"N K GOSSAIN PRINTING PRESS PRIVATE LIMITED",
"N K HIGH SCHOOL PETLAD",
"N K JAIN INSTRUMENTS PVT LTD",
"N K MICRO PRIVATE LIMITED",
"N K MULTI-TECH FILTERS PRIVATE LIMITED",
"N K OIL MILLS PVT LTD",
"N K ORCHID COLLEGE OF ENGINEERING & TECHNOLOGY SOLAPUR",
"N K ORGANIC INORGANIC INDUSTRIES PRIVATE LIMITED",
"N K OVERSEAS TRADERS PRIVATE LIMITED",
"N K P SALVE INSTITUTE OF MEDICAL SCIENCE",
"N K PROSALES PVT LTD",
"N K PROTEINS PRIVATE LIMITED",
"N K R ENGINEERS PRIVATE LIMITED",
"N K REALTORS PRIVATE LIMITED",
"N K SECURITIES PVT LTD",
"N K SHARMA ENTERPRISES PRIVATE LIMITED",
"N K TRADING AND CONSULTANCY PRIVATE LIMITED",
"N KUMAR ASSOCIATES INTERNATIONAL PRIVATE LIMITED",
"N KUMAR ELECTRONICS PRIVATE LIMITED",
"N L DALMIA INSTITUTE OF MANAGEMENT STUDIES AND RESEARCH",
"N L ENGINEERS PRIVATE LIMITED",
"N L K PUBLIC SCHOOL",
"N L PACKAGING PRIVATE LIMITED",
"N M AGGARWAL AND COMPANY PRIVATE LIMITED",
"N M AGROFOOD PRODUCTS PRIVATE LIMITED",
"N M BUILDWELL PRIVTE LIMITED",
"N M DUBASH STONE & LIME COMPANY PVT LTD",
"N M EDIBLE OILS PRIVATE LIMITED",
"N M FASHION DESIGNS PRIVATE LIMITED",
"N M FOOTWEARS PRIVATE LIMITED",
"N M MARBLES PRIVATE LIMITED",
"N M PROJECTS PRIVATE LIMITED",
"N M R PHYROCHEM PRIVATE LIMITED",
"N M STONES PRIVATE LIMITED",
"N M T ACADEMY ENGLISH MEDIUM SCHOOL",
"N M WADIA INSTITUTE OF CARDIOLOGY",
"N MISTRY PROJECT PRIVATE LIMITED",
"N MOHANLAL AND COMPANY PRIVATE LIMITED",
"N MOHANLAL RAILTRACT PRIVATE LIMITED",
"N N AIRCON SYSTEMS PRIVATE LIMITED",
"N N INTERNATIONAL PRIVATE LIMITED",
"N N ISPAT PRIVATE LIMITED",
"N N MOULDING PRIVATE LIMITED",
"N N PATEL HOTELS PRIVATE LIMITED",
"N N PRINT AND PACK PVT LTD",
"N N SHIPBUILDERS AND ENGINEERS PRIVATE LIMITED",
"N P FRESH FOODS PRIVATE LIMITED",
"N P INVESTMENT AND LEASING PRIVATE LIMITED",
"N P K ENTERPRISE PRIVATE LIMITED",
"N P KINARIWALA PVT LTD",
"N P S COLD STORAGE PRIVATE LIMITED",
"N P U P SCHOOL NO 8 KATOL",
"N Q SOLUTIONS INDIA PRIVATE LIMITED",
"N R AGARWAL INDUSTRIES LIMITED",
"N R BROTHERS ROLLER FLOUR MILLS PRIVATE LIMITED",
"N R C INDUSTRIES LIMITED",
"N R ENGINEERS PRIVATE LIMITED",
"N R FUEL ADS PRIVATE LIMITED",
"N R GOLD LIMITED",
"N R GREENWOOD CONSTRUCTION PRIVATE LIMITED",
"N R I ACADEMY OF SCIENCES",
"N R INFRASTRUCTURE PRIVATE LIMITED",
"N R KITCHENWARE PRIVATE LIMITED",
"N R L MOTORS PRIVATE LIMITED",
"N R MANAGEMENT CONSULTANTS INDIA PRIVATE LIMITED",
"N R P TECHNOLOGIES PRIVATE LIMITED",
"N R PLYWOOD PRIVATE LIMITED",
"N R S ESTATES PRIVATE LIMITED",
"N R S MEDICAL COLLEGE HOSPITAL",
"N R S POULTRY FARMS PRIVATE LIMITED",
"N R SONS UTENSILS PRIVATE LIMITED",
"N R SPONGE PRIVATE LIMITED",
"N R U SPINNING MILLS LIMITED",
"N R WHEAT PRODUCTS PRIVATE LIMITED",
"N RANGA RAO & SONS PRIVATE LIMITED",
"N S ASSOCIATES PRIVATE LIMITED",
"N S AUTO ENGINEERS PRIVATE LIMITED",
"N S C GOVERNMENT MEDICAL COLLEGE KHANDWA",
"N S C SPINNING MILLS PRIVATE LIMITED",
"N S CONCRETES PRIVATE LIMITED",
"N S G TEXTILES PRIVATE LIMITED",
"N S GRAMMAR HIGH SCHOOL",
"N S INFOTECH PRIVATE LIMITED",
"N S INTERNATIONAL PRIVATE LIMITED",
"N S JAIN AND COMPANY PRIVATE LIMITED",
"N S LEATHER PRODUCTS PRIVATE LIMITED",
"N S MARKETING PRIVATE LIMITED",
"N S P ENTERPRISES",
"N S PRECISION WORKS PRIVATE LIMITED",
"N S PUBLICITY INDIA PRIVATE LIMITED",
"N SIGHT CONSULTING GROUP PRIVATE LIMITED",
"N SIVAJI AGRO INFRA PRIVATE LIMITED",
"N SOFT INDIA SERVICES PRIVATE LIMITED",
"N SQUARED TECHNOLOGIES INDIA PRIVATE LIMITED",
"N ST MATHEW'S PUBLIC SCHOOL",
"N T COMPANY CLEARING AND FORWARDING PRIVATE LIMITED",
"N TECH GLOBAL SOLUTION",
"N V GRAPHICS AND ADVERTISING PRIVATE LIMITED",
"N V HEALTH CARE PRIVATE LIMITED",
"N V JOSEPH EXPORTS PRIVATE LIMITED",
"N V KHAROTE CONSTRUCTIONS PRIVATE LIMITED",
"N V LIFESTYLES PRIVATE LIMITED",
"N V TRADING COMPANY PRIVATE LIMITED",
"N WADIA COLLEGE",
"N WADIA INSTITUTE OF MANAGEMENT STUDIES",
"N Y HOSPITALITIES & HOLDINGS PRIVATE LIMITED",
"N&L INFRATECH PRIVATE LIMITED",
"N&M COMMOTRADE PRIVATE LIMITED",
"N. B. HIGHRISE PRIVATE LIMITED",
"N. D. MACHINO - TECH PRIVATE LIMITED",
"N. F. VENTURES PRIVATE LIMITED",
"N. G. TEX PRINT PRIVATE LIMITED",
"N. J. ECO-BUILD PRIVATE LIMITED",
"N. J. TEXTILE INDUSTRIES PRIVATE LIMITED",
"N. JIVANLAL CHEMICAL INDUSTRIES PRIVATE LIMITED",
"N. K SYNTHESIS PRIVATE LIMITED",
"N. K. AUTOWINGS PRIVATE LIMITED",
"N. K. SILKS (INDIA) PRIVATE LIMITED",
"N. K. TEMPLES PRIVATE LIMITED",
"N. K. TOOLS (NASHIK) PRIVATE LIMITED",
"N. L. DALMIA CENTRE FOR EXCELLENCE PRIVATE LIMITED",
"N. M. AUTO PARTS PRIVATE LIMITED",
"N. M. INFRATECH PRIVATE LIMITED",
"N. M. JARIWALA PRIVATE LIMITED",
"N. N. AGGARWAL JEWELLERS PRIVATE LIMITED.",
"N. N. GLOBAL MERCANTILE PRIVATE LIMITED",
"N. N. SAHA & SONS AGRO PRIVATE LIMITED",
"N. P. BEARINGS (INDIA) PRIVATE LIMITED",
"N. PUNJAB SUGARS PRIVATE LIMITED",
"N. R. AEREN AGRO PRIVATE LIMITED",
"N. S. TECHNOCRATS PRIVATE LIMITED",
"N. SARKAR AGRO PRODUCTS PRIVATE LIMITED",
"N. STEELS PRIVATE LIMITED",
"N. V. ENTERPRISES PRIVATE LIMITED",
"N.A. GRAPHICS SIGN PRIVATE LIMITED",
"N.A.M.EXPRESSWAY LIMITED",
"N.B HI-TECH COLD STORAGE",
"N B COMMUNICATION PRIVATE LIMITED",
"N.B.I.INDUSTRIAL FINANCE COMPANY LTD.",
"N.B.K. TRADE LINKERS PRIVATE LIMITED",
"N.B.RUBBER PRIVATE LIMITED",
"N.C RICE FOODS PRIVATE LIMITED",
"N.C. JINDAL PUBLIC SCHOOL",
"N.C.L.RESEARCH AND FINANCIAL SERVICES LTD.",
"N.D. DEVELOPERS PRIVATE LIMITED",
"N.D. RELATORS AND BUILDERS PRIVATE LIMITED",
"N.D. ROADLINES PRIVATE LIMITED",
"N.D.COLD STORAGE PRIVATE LIMITED",
"N.D.ROLLER FLOUR MILLS PRIVATE LIMITED",
"N.D.SHIPPING AGENCY PRIVATE LIMITED",
"N.G. ELECTRONICS PRIVATE LIMITED",
"N.G. JOSHI CLEARING AND FORWARDING AGENTS PRIVATE LIMITED",
"N.G. MERCANTILE PRIVATE LIMITED",
"N.G. TREXIM PVT.LTD.",
"N.G.S. BULK CARRIERS PRIVATE LIMITED",
"N.H. CONSTRUCTIONS PRIVATE LIMITED",
"N.H. STEELS PRIVATE LIMITED",
"N.J. ENTERPRISES PRIVATE LIMITED",
"N.K MINERALS PRIVATE LIMITED",
"N.K. BAHETY TEXTILE PRIVATE LIMITED",
"N.K. DEVICES PRIVATE LIMITED",
"N.K. FUTURE PLAST PRIVATE LIMITED",
"N.K. GOSSAIN OFFSET PRIVATE LIMITED",
"N.K. HANDICRAFTS PRIVATE LIMITED",
"N.K. LAMINATES PRIVATE LIMITED",
"N.K. LEASING & CONSTRUCTIONS LIMITED",
"N.K. LOGISTICS PRIVATE LIMITED",
"N.K. LUBRICANTS PRIVATE LIMITED",
"N.K. PLY PRIVATE LIMITED",
"N.K. RF PRODUCTS & SERVICES PRIVATE LIMITED",
"N.K.AGENCIES PRIVATE LIMITED",
"N.K.B. INDUSTRIAL PRODUCTS PRIVATE LIMITED",
"N.K.BUILDCON PRIVATE LIMITED",
"N.K.D. JEWELLERS PRIVATE LIMITED",
"N.K.G. BUILDWELL PRIVATE LIMITED",
"N.K.GUPTA BUILDERS PRIVATE LIMITED",
"N.K.VENTURES PRIVATE LIMITED",
"N.KAM INFOBYTES PRIVATE LIMITED",
"N.L. REFINERY AND AGRO PRIVATE LIMITED",
"N.L.IMPERIAL FOOD & BEVERAGES PRIVATE LIMITED",
"N.M.A.TRADING PVT. LTD",
"N.M.DYEING PRIVATE LIMITED",
"N.N REMEDIES PRIVATE LIMITED",
"N.N. FACILITY SERVICES PRIVATE LIMITED",
"N.N.AUTOLYNX PRIVATE LIMITED",
"N.N.C. FOREX PRIVATE LIMITED",
"N.N.ISPAT PRIVATE LIMITED",
"N.P HIGH SCHOOL KALMESHWAR",
"N.P. AGRO INDIA INDUSTRIES LIMITED",
"N.P. INFRAPROJECTS PRIVATE LIMITED",
"N.P. JEWELLERY HOUSE PRIVATE LIMITED",
"N.P. RIBBONS AND HANKIES PVT. LTD",
"N.P.R. ENTERPRISES PRIVATE LIMITED",
"N.PLUS INNOVATIONS PRIVATE LIMITED",
"N.R. COLOURS LIMITED",
"N.R. CONSTRUCTION PRIVATE LIMITED",
"N.R. CONSTRUCTIONS",
"N.R. CONSULTANTS AND PLANNERS INDIA PRIVATE LIMITED",
"N.R. DESIGN CENTRE PVT. LTD.",
"N.R. FABTECH PRIVATE LIMITED",
"N.R. FURNISHINGS PRIVATE LIMITED",
"N.R. GHOSH AND CO PVT LTD",
"N.R. PHARMACEUTICALS PRIVATE LIMITED",
"N.R.FOODS PVT LTD",
"N.R.MEDIA AND MARKETING PRIVATE LIMITED",
"N.R.WIRES PRIVATE LIMITED",
"N.ROSE DEVELOPERS PRIVATE LIMITED",
"N.S. ADVISORY SERVICES PRIVATE LIMITED",
"N.S. CONCRETE SOLUTIONS PRIVATE LIMITED",
"N.S. ISPAT (INDIA) PRIVATE LIMITED",
"N.S. READYMIX PRIVATE LIMITED",
"N.S.K.ANAMTHARA RESORT PRIVATE LIMITED",
"N.S.RATHINAM & SONS PRIVATE LIMITED",
"N.SATISH EXPORTS PRIVATE LIMITED",
"N.T. WOODS PRIVATE LIMITED",
"N.U INDIAN HERBAL RESEARCH LABORATORY PRIVATE LIMITED",
"N.V. AGGARWAL TEXTILE MILLS PRIVATE LIMITED",
"N.V. ALUMINIUM CAST PRIVATE LIMITED",
"N.V. MANAGEMENTS PRIVATE LIMITED",
"N.V. TEXOFAB PRIVATE LIMITED",
"N.V.BROTHERS ENGINEERING PRIVATE LIMITED",
"N.V.PAPER PRODUCTS PRIVATE LIMITED",
"N.Y. INFRA BUILD ESSENTIALS PRIVATE LIMITED",
"N.Y. LEASING PRIVATE LIMITED",
"N19 FOODS AGRO PRIVATE LIMITED",
"N2 SMART PAYMENT SOLUTIONS INDIA PRIVATE LIMITED",
"N2 SOFTWARE SERVICES PRIVATE LIMITED",
"N2 SYSTEMS PRIVATE LIMITED",
"N2B CONSUMER PRODUCTS PRIVATE LIMITED",
"N2N SOLUTION AND SECURITY PRIVATE LIMITED",
"N2S TECHNOLOGIES PRIVATE LIMITED",
"N3 ENTERPRISES PRIVATE LIMITED",
"N4B MEDIA & TRADE PRIVATE LIMITED",
"N9 WORLD TECHNOLOGIES PRIVATE LIMITED",
"NA INVESTMENTS PRIVATE LIMITED",
"NA MEDIA VENTURES PRIVATE LIMITED",
"NA PHARMAA MACHINERY PRIVATE LIMITED",
"NA SPORTZ DIGITAL SOLUTIONS PRIVATE LIMITED",
"NA SYSTEMS PRIVATE LIMITED",
"NA ZAMINWALE PRIVATE LIMITED",
"NAABHYA INTERCONNECT LLP",
"NAAC ENERGY CONTROLS PRIVATE LIMITED",
"NAACHIAR PACKAGING PRIVATE LIMITED",
"NAACHIYAAR EDIBLE OIL AND FOODS PRIVATE LIMITED",
"NAAD NONWOVEN PRIVATE LIMITED",
"NAAD WELLNESS PRIVATE LIMITED",
"NAADBRAMHA FOOD & BEVERAGES PRIVATE LIMITED",
"NAAGAAMII INFRATECH PRIVATE LIMITED",
"NAAGAL GARMENT INDUSTRIEZ PRIVATE LIMITED",
"NAAJ AGRO FOOD PRIVATE LIMITED",
"NAAMDEV CONCOM LIMITED",
"NAANAL TECHNOLOGIES PRIVATE LIMITED",
"NAANDEE FREIGHT SOLUTION PRIVATE LIMITED",
"NAANDI COMMUNITY WATER SERVICES PRIVATE LIMITED",
"NAANDI FOUNDATION",
"NAANDI INFRATECH PRIVATE LIMITED",
"NAAPBOOKS LIMITED",
"NAAPTOL ONLINE SHOPPING PRIVATE LIMITED",
"NAARA MOTORS LLP",
"NAARAAYANI MINERALS PRIVATE LIMITED",
"NAARGO INDUSTRIES PRIVATE LIMITED",
"NAARI PHARMA PRIVATE LIMITED",
"NAARM-NATIONAL ACADEMY OF AGRICULTURAL RESEARCH MANAGEMENT",
"NAATH INDUSTRIES PRIVATE LIMITED",
"NAAVA FREIGHT SERVICES PRIVATE LIMITED",
"NAAVINYA CAD SOFT PRIVATE LIMITED",
"NAAZ CHAPPAL CO PRIVATE LIMITED",
"NAAZ EXPORTS PRIVATE LIMITED",
"NAAZ HOTEL CONSULTANTS PRIVATE LIMITED",
"NAAZ IMPEX (INDIA) PRIVATE LIMITED",
"NAAZ JEWELS PRIVATE LIMITED",
"NAAZ SEA FOODS PRIVATE LIMITED",
"NAAZ STEELS PRIVATE LIMITED",
"NABA DIGANTA WATER MANAGEMENT LIMITED",
"NABA MUDRAN PVT LTD",
"NABAJIBAN HOSPITAL PRIVATE LIMITED",
"NABANIR HOSPITAL & DIAGNOSTICS PRIVATE LIMITED",
"NABAPALLY JOGENDRANATH BALIKA VIDYAMANDIR",
"NABARD",
"NABARD CONSULTANCY SERVICES PRIVATE LIMITED",
"NABARUN MANUFACTURING & ENGINEERING PRIVATE LIMITED",
"NABASAN HIGH SCHOOL",
"NABEEN KISHAN BIO TECHNOLOGIES PRIVATE LIMITED",
"NABERA WOOLLEN MILLS PRIVATE LIMITED",
"NABERLY TECHNOLOGIES PRIVATE LIMITED",
"NABFINS LIMITED",
"NABH CONSTRUCTION AND DEVELOPERS PRIVATE LIMITED",
"NABHA DUPLEX LIMITED",
"NABHA PAPER MILLS PRIVATE LIMITED",
"NABHA POWER LIMITED",
"NABHA STEELS PRIVATE LTD.",
"NABHI",
"NABHIRAJA SOFTWARE DESIGN",
"NABHIVARSA SECURITY SOLUTIONS PRIVATE LIMITED",
"NABI ENTERPRISES PRIVATE LIMITED",
"NABIRA MAHAVIDYALAY",
"NABISCO CONFECTIONERY AND FOOD INDIA PVT. LTD.",
"NABKISAN FINANCE LIMITED",
"NABLA INFOTECH PRIVATE LIMITED",
"NABLASOL DIGITAL SERVICES PRIVATE LIMITED",
"NABLER WEB SOLUTIONS PRIVATE LIMITED",
"NABROCO TOOLS & TECHNOLOGIES PRIVATE LIMITED",
"NABROS PHARMA PRIVATE LIMITED",
"NABROS TRANSPORT PRIVATE LIMITED",
"NABROS TRANSPORT PVT LTD",
"NABSAMRUDDHI FINANCE LIMITED",
"NABTESCO INDIA PRIVATE LIMITED",
"NABVENTURES LIMITED",
"NAC BUILDCON PRIVATE LIMITED",
"NAC GLOBAL FOODS PRIVATE LIMITED",
"NAC JEWELLERS PRIVATE LIMITED",
"NAC MOTORS PRIVATE LIMITED",
"NAC NOSE INDIA PRIVATE LIMITED",
"NAC QUIPPO EQUIPMENT SERVICES LIMITED",
"NACDAC INFRASTRUCTURE LIMITED",
"NACHAS WIND ENERGY PRIVATE LIMITED",
"NACHI MOTHERSON PRECISION PRIVATE LIMITED",
"NACHI MOTHERSON TOOL TECHNOLOGY LIMITED",
"NACHI PRECISION TOOL INDIA PRIVATE LIMITED",
"NACHI TECHNOLOGY INDIA PRIVATE LIMITED",
"NACHI TEXTILE EXPORT PRIVATE LIMITED",
"NACHIAR HEALTH CARE FABRICS PRIVATE LIMITED",
"NACHIAR SPINNING MILLS PRIVATE LIMITED",
"NACHIAS FASHION PRIVATE LIMITED",
"NACHIKET PROCON PRIVATE LIMITED",
"NACHIKETA COMMERCIAL PRIVATE LIMITED",
"NACHIKETA FINVEST PRIVATE LIMITED",
"NACHIKETA GIFT-ADS PVT LTD",
"NACHIKETA PAPERS LIMITED",
"NACHIKETA SCHOOLING SYSTEM",
"NACHIKETAS PUBLISHERS INDIA PRIVATE LIMITED",
"NACHIMUTHU INDUSTRIAL ASSOCIATION",
"NACHIMUTHU POLYTECHNIC COLLEGE",
"NACHSTER ENTERPRISES PRIVATE LIMITED",
"NACHSTER TECHSERVICES PRIVATE LIMITED",
"NACL INDUSTRIES LIMITED",
"NACL SPEC-CHEM LIMITED",
"NAD BINDU INFRATECH PRIVATE LIMITED",
"NADAGOUDA ENERGIES PRIVATE LIMITED",
"NADAGOUDA ROADLINES PRIVATE LIMITED",
"NADATHUR ESTATES PRIVATE LIMITED",
"NADEEM MINERALS PRIVATE LIMITED",
"NADELLA INFO TECHNOLOGIES PRIVATE LIMITED",
"NADHI BIO PRODUCTS PRIVATE LIMITED",
"NADI AIRTECHNICS PRIVATE LIMITED",
"NADIA AGRO AND DAIRY INDUSTRIES PRIVATE LIMITED",
"NADIA DISTRICT MODERN RICE MILL PRIVATE LIMITED",
"NADIAD METALS PRIVATE LIMITED",
"NADIADWALA GRANDSON ENTERTAINMENT PRIVATE LIMITED",
"NADIG CONSULTING PRIVATE LIMITED",
"NADIMPALLI SATYANARAYANA RAJU INSTITUTE OF TECHNOLOGY",
"NADIR EDUSERVICES PRIVATE LIMITED",
"NADIRA PROPERTIES PRIVATE LIMITED",
"NADISH REAL ESTATE PRIVATE LIMITED",
"NADIYA BIOTECH PRIVATE LIMITED",
"NADIYA FERTILIZERS & CHEMICALS PRIVATE LIMITED",
"NADIYA TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"NADKARNI CLASSES PRIVATE LIMITED",
"NADKARNI'S 21 ST CENTURY HOSPITALS PRIVATE LIMITED",
"NADKAS INFRATECHNO PRIVATE LIMITED",
"NADRIX SOLUTIONS PRIVATE LIMITED",
"NAEEKA HOTELS PRIVATE LIMITED",
"NAEEM SONS ELECTRONICS PRIVATE LIMITED",
"NAEHAS SOFTWARE INDIA PRIVATE LIMITED",
"NAETEK FERROCASTINGS PRIVATE LIMITED",
"NAETHRA TECHNOLOGIES PRIVATE LIMITED",
"NAFA ASSET MANAGERS PRIVATE LIMITED",
"NAFEES BAKERS (INDIA) PRIVATE LIMITED",
"NAFEES CITY BUS PRIVATE LIMITED",
"NAFFA INNOVATIONS PRIVATE LIMITED",
"NAFFAR CHANDRA JUTE MILLS LTD",
"NAFFCO INDIA PRIVATE LIMITED",
"NAFISA NOOR",
"NAFREF ENGINEERS PRIVATE LIMITED",
"NAG INTERIORS PRIVATE LIMITED",
"NAG VETRINARY COLLEGE",
"NAGA AGRIMATE PRIVATE LIMITED",
"NAGA DHUNSERI GROUP LTD.",
"NAGA HANUMAN AGRO OILS PRIVATE LIMITED",
"NAGA HANUMAN SOLVENT OILS PRIVATE LIMITED",
"NAGA INFO SOLUTIONS PRIVATE LIMITED",
"NAGA LIMITED",
"NAGA MOBILE SHOPPE",
"NAGA PUMPS PRIVATE LIMITED",
"NAGA SAI OILS PRIVATE LIMITED",
"NAGA SINDHU SPINNING & GINNING MILLS PRIVATE LIMITED",
"NAGABANDI'S HOTEL'S & RESORT'S PRIVATE LIMITED",
"NAGABHUSHANAM & CO.",
"NAGABHYRU INFRASTRUCTURES PRIVATE LIMITED",
"NAGAD NARAYAN AGROFOODS PRIVATE LIMITED",
"NAGAD NARAYAN FOODS INTERNATIONAL PRIVATE LIMITED",
"NAGADI CONSULTANTS PRIVATE LIMITED",
"NAGADNARAYN VIDAYALAYA NARAYANGAD BEED",
"NAGAHAT TEA ESTATE PRIVATE LIMITED",
"NAGAI NIDHI LIMITED",
"NAGALAKSHMI ENGG INDUSTRY PRIVATE LIMITED",
"NAGALAKSHMI TECH SOLUTIONS PRIVATE LIMITED",
"NAGAM PRIVATE LIMITED",
"NAGAMALAI TEXTILES INDIA PRIVATE LIMITED",
"NAGAMMAI COTTON MILLS PRIVATE LIMITED",
"NAGAMMAL MILLS PRIVATE LIMITED",
"NAGANO INDIA PRIVATE LIMITED",
"NAGANU FOODS PRIVATE LIMITED",
"NAGAON SCAN PRIVATE LIMITED",
"NAGAPPA AND NAGAPPA SPINTEX PRIVATE LIMITED",
"NAGAPPA MOTORS PRIVATE LIMITED",
"NAGAR EXPORTS PRIVATE LIMITED",
"NAGAR NIGAM",
"NAGAR NIGAM LUCKNOW",
"NAGAR NIGAM SAHARANPUR",
"NAGAR PALIKA",
"NAGAR PALIKA BARDOLI",
"NAGAR PALIKA INTER COLLEGE BUDAUN",
"NAGAR PALIKA INTER COLLEGE MUGHALSARAI",
"NAGAR PALIKA NIGAM",
"NAGAR PALIKA NIGAM RATLAM",
"NAGAR PANCHAYAT",
"NAGAR PANCHAYAT KARYALAY BHATKULI DIST AMRAVATI",
"NAGAR PANCHAYAT RENAPUR",
"NAGAR PARISHAD AMBEJOGAI",
"NAGAR PARISHAD GONDIA",
"NAGAR PARISHAD JAITWARA",
"NAGAR PARISHAD JALNA",
"NAGAR PARISHAD KAMPTEE",
"NAGAR PARISHAD KARYALAY CHANDUR BAZAR",
"NAGAR PARISHAD KHAPA",
"NAGAR PARISHAD OFFICE JALNA",
"NAGAR PARISHAD OFFICE WARDHA",
"NAGAR PARISHAD PAITHAN",
"NAGAR PARISHAD PRATHAMIK SCHOOL HINDI ACHALPUR",
"NAGAR PARISHAD PRIMARY GIRLS MARATHI SCHOOL AKKALKOT",
"NAGAR PARISHAD SAONER",
"NAGAR PARISHAD UCCHA PRATHAMIK SHALA",
"NAGAR PARISHAD URDU PRI SCHOOL",
"NAGAR PARISHAD URDU SCHOOL¬†",
"NAGAR PARISHAND VIDYALAY CHANDUR BAZAR",
"NAGAR PRATHMIK SHIKSHAN SAMITI VADODARA",
"NAGAR PRIMARY SCHOOL",
"NAGAR URBAN CO OP BANK LTD AHMEDNAGAR",
"NAGARAJAN CONSTRUCTION COMPANY PRIVATE LIMITED",
"NAGARI AROGYA KENDRA NMMC HOSPITAL",
"NAGARI NIVARA PARISHAD SANCHALIT NIVARA VIDYALAYA",
"NAGARJUN PHARMACEUTICALS PRIVATE LIMITED",
"NAGARJUN TEXTILES (INDIA) PVT LTD",
"NAGARJUNA AGRI-TECH LIMITED",
"NAGARJUNA AYURVEDIC CENTRE LIMITED",
"NAGARJUNA CERACHEM PRIVATE LIMITED",
"NAGARJUNA COLLEGE OF ENGINEERING AND TECHNOLOGY BANGALORE",
"NAGARJUNA CROP SCIENCES PRIVATE LIMITED",
"NAGARJUNA EDUCATION SOCIETY",
"NAGARJUNA ENGINEERING CONSTRUCTIONS",
"NAGARJUNA HERBAL CONCENTRATES LIMITED",
"NAGARJUNA HOSPITALS PRIVATE LIMITED",
"NAGARJUNA HYDRO ENERGY PRIVATE LIMITED",
"NAGARJUNA POLYMERS",
"NAGARJUNA PUBLIC SCHOOL",
"NAGARJUNA STEELS LIMITED",
"NAGARKAR GOLD & PEARLS PRIVATE LIMITED",
"NAGARKOT FORWARDERS PRIVATE LIMITED",
"NAGARKOT LOGISTICS PRIVATE LIMITED",
"NAGARMAL SARAF SECURITIES PRIVATE LIMITED",
"NAGARPALIKA SHALA NO 10 SIDDHANATHWADI WAI",
"NAGARRO ENTERPRISE SERVICES PRIVATE LIMITED",
"NAGARRO SOFTWARE PRIVATE LIMITED",
"NAGARWALA ENTERPRISES",
"NAGARWALLA ENGINERING COMPANY PRIVATE LIMITED",
"NAGASAE AUTOMOTIVE INDIA PRIVATE LIMITED",
"NAGASAI PRECISION ENGINEERS PVT LTD",
"NAGASE INDIA PRIVATE LIMITED",
"NAGASURI CHITFUNDS PRIVATE LIMITED",
"NAGATA AUTO ENGINEERING INDIA PRIVATE LIMITED",
"NAGATA INDIA PRIVATE LIMITED",
"NAGAUR AUTOMOBILES PRIVATE LIMITED",
"NAGAUR MOTORS PRIVATE LIMITED",
"NAGAUR MUKUNDGARH HIGHWAYS PRIVATE LIMITED",
"NAGAVARA ESTATES PRIVATE LIMITED",
"NAGDEVI TRADING AND INVESTMENT COMPANY LIMITED",
"NAGEEN PRAKASHAN PRIVATE LIMITED",
"NAGEEN PRINT-PACK PRIVATE LIMITED",
"NAGEEN TRADERS AND MOULDING INDIA PRIVATE LIMITED",
"NAGEL SPECIAL MACHINES PRIVATE LIMITED",
"NAGESH COMMERICIAL PVT LTD",
"NAGESHWAR BUILDERS PRIVATE LIMITED",
"NAGESHWAR FABRIC PRIVATE LIMITED",
"NAGESHWAR SYNTHETICS PRIVATE LIMITED",
"NAGESHWARI CERAMIC PRIVATE LIMITED",
"NAGI JEWELLERS PRIVATE LIMITED",
"NAGINA ENTERPRISES PRIVATE LIMITED",
"NAGINA FOOD PRIVATE LIMITED",
"NAGINA FOOTWEARS PVT LTD",
"NAGINA SHOES PRIVATE LIMITED",
"NAGMAN INSTRUMENTS AND ELECTRONICS PRIVATE LIMITED",
"NAGMANI & KASHYAP CONSTRUCTION PRIVATE LIMITED",
"NAGNECHI CONSTRUCTION PRIVATE LIMITED",
"NAGODAS FISH FARMING AND CONSULTANCY PRIVATE LIMITED",
"NAGODE INTERNATIONAL PRIVATE LIMITED",
"NAGOMI CONSULTING PRIVATE LIMITED",
"NAGOORA FABRICS PRIVATE LIMITED",
"NAGORAO AUTO ENGINEERING WORKS PRIVATE LIMITED",
"NAGORI PLY ARCADE LIMITED",
"NAGORY INNOVATIVE ARTS PRIVATE LIMITED",
"NAGPAL ENTERPRISES PVT LTD",
"NAGPAL FABRICS PRIVATE LIMITED",
"NAGPAL FROZEN FOOD PRIVATE LIMITED",
"NAGPAL MERCANTILE PRIVATE LIMITED",
"NAGPAL PACKAGING MACHINERY PRIVATE LIMITED",
"NAGPAL PROJECTS AND CONSTRUCTIONS PRIVATE LIMITED",
"NAGPHANI PARASAVNATH MARBLES PVT. LTD.",
"NAGPUR - SEONI EXPRESS WAY PRIVATE LIMITED",
"NAGPUR AGENCIES PRIVATE LIMITED",
"NAGPUR AGRICULTURAL EQUIPMENTS ENGINEERS PRIVATE LIMITED",
"NAGPUR AYURVEDIK COLLEGE",
"NAGPUR BUSINESS FORM PRIVATE LIMITED",
"NAGPUR CANCER HOSPITAL & RESEARCH INSTITUTE PRIVATE LIMITED",
"NAGPUR CARBON PVT LTD",
"NAGPUR COLLEGE OF AGRICULTURE",
"NAGPUR COLLEGE OF PHARMACY",
"NAGPUR DISTILLERS PRIVATE LIMITED",
"NAGPUR DISTRICT SECURITY GUARD BOARD",
"NAGPUR ESTATES PRIVATE LIMITED",
"NAGPUR FOUNDRIES LIMITED",
"NAGPUR GAS DOMESTIC APPLIANCES AND SERVICES PRIVATE LIMITED",
"NAGPUR HOMEOPATHIC BIOCHEMISTRY COLLEG",
"NAGPUR IMPROVEMENT TRUST",
"NAGPUR INSTITUTE OF SURGICAL SCIENCES & RESEARCH CENTRE PRIVATE LIMITED",
"NAGPUR INTEGRATED TOWNSHIP PRIVATE LIMITED",
"NAGPUR LOGISTICS PARK PRIVATE LIMITED",
"NAGPUR MASS TRANSPORT COMPANY PRIVATE LIMITED",
"NAGPUR MODERN HOSPITALITY PRIVATE LIMITED",
"NAGPUR MOULDERS AND PROCESSORS PRIVATE LIMITED",
"NAGPUR MUMBAI SUPER COMMUNICATION EXPRESSWAY LIMITED",
"NAGPUR MUNICIPAL CORPORATION",
"NAGPUR MUNICIPLE CORPORATION",
"NAGPUR NAGARIK SAHAKARI BANK LIMITED",
"NAGPUR NEURO SCIENCES CLINICS PRIVATE LIMITED",
"NAGPUR PAPER COATING AND LAMINATING PVT LTD",
"NAGPUR POLYFILMS PRIVATE LIMITED",
"NAGPUR POWER AND INDUSTRIES LIMITED",
"NAGPUR PYROLUSITE P LTD",
"NAGPUR SHARIRIK SHAKSHAN COLLEGE",
"NAGPUR SHARIRIK SHIKSHAN MAHAVIDYALAYA",
"NAGPUR SMART AND SUSTAINABLE CITY DEVELOPMENT CORPORATION LIMITED",
"NAGPUR SORTEX",
"NAGPUR TOOLS PRIVATE LIMITED",
"NAGPUR UNIVERSITY",
"NAGPUR WASTE WATER MANAGEMENT PRIVATE LIMITED",
"NAGPURE VIDYALAYA BHARAT NAGAR NAGPUR",
"NAGRA MEDIA PRIVATE LIMITED",
"NAGRA MOTELS PRIVATE LIMITED",
"NAGRAJ INFRACON PRIVATE LIMITED",
"NAGRALL INDIA PRIVATE LIMITED",
"NAGRANI INDUSTRIES PRIVATE LIMITED",
"NAGRATH ALUMINIUM PRIVATE LIMITED",
"NAGRAVISION INDIA PRIVATE LIMITED",
"NAGREEKA BRIJ HOTELS BHAVNAGAR PRIVATE LIMITED",
"NAGREEKA CAPITAL & INFRASTRUCTURE LIMITED",
"NAGREEKA EXPORTS",
"NAGREEKA HYDROCARBONS PRIVATE LIMITED",
"NAGREEKA INDCON PRODUCTS PRIVATE LIMITED",
"NAGRIFARM TEA COMPANY LIMITED",
"NAGRIK SAHAKARI BANK¬† MARYADIT GWALIOR",
"NAGRIK SAHAKARI RUGNALAYA RESEARCH CEN",
"NAGRIK STORES PRIVATE LIMITED",
"NAGRIK SURAKSHA AVAM SEVAYE PRIVATE LIMITED OPC",
"NAGSEN VIDYALAYA",
"NAGSHANTI CARS PRIVATE LIMITED",
"NAGSHANTI ENTERPRISES PRIVATE LIMITED",
"NAGSHANTI MOTORS PRIVATE LIMITED",
"NAGWAN EXPRESS LOGISTICS PRIVATE LIMITED",
"NAGYAN CONSTRUCTIONS PRIVATE LIMITED",
"NAHALCHAND LALOO CHAND PRIVATE LIMITED",
"NAHAN FERRO ALLOYS AND CHEMICALS PVT LTD",
"NAHAR BUILDERS LIMITED",
"NAHAR CAPITAL AND FINANCIAL SERVICES LIMITED",
"NAHAR COLOURS AND COATING PRIVATE LIMITED",
"NAHAR CONSTRUCTION PRIVATE LIMITED",
"NAHAR COTSYN PRIVATE LIMITED",
"NAHAR CREDITS PRIVATE LIMITED",
"NAHAR EXCALIBUR PROJECT PRIVATE LIMITED",
"NAHAR FOUNDATION`S PRIVATE LIMITED",
"NAHAR FROZEN FOODS & ICE CREAM PRIVATE LIMITED",
"NAHAR GRANITES PRIVATE LIMITED",
"NAHAR HOSPITAL",
"NAHAR INDUSTRIAL ENTERPRISES LIMITED",
"NAHAR INTEGRATED SYSTEM SERVICES PRIVATE LIMITED",
"NAHAR INTERNATIONAL SCHOOL",
"NAHAR LOGISTICS PARK PRIVATE LIMITED",
"NAHAR PAPER AND BOARD MILLS PVT LTD",
"NAHAR POLY FILMS LIMITED",
"NAHAR POLYMERS PRIVATE LIMITED",
"NAHAR RETAIL TRADING SERVICES LIMITED",
"NAHAR SPINNING MILLS LIMITED",
"NAHAR TEXTILES PRIVATE LIMITED",
"NAHARS ENGINEERING INDIA PRIVATE LIMITED",
"NAHATA BHATTAR INFRASTRUCTURE PRIVATE LIMITED",
"NAHATA COMFORT SYSTEMS PVT LTD",
"NAHATA DATA PRODUCTS PRIVATE LIMITED",
"NAHATA DEVELOPERS PRIVATE LIMITED",
"NAHATA FABRICS LIMITED",
"NAHATA HOMEWARE PRIVATE LIMITED",
"NAHATA IMPEX PRIVATE LIMITED",
"NAHATA MADIRA TRADING PRIVATE LIMITED",
"NAHATA METAL & AIR PRODUCTS PRIVATE LIMITED",
"NAHATA MOTORS PRIVATE LIMITED",
"NAHATA PLASTIC VYAPAAR PRIVATE LIMITED",
"NAHATA RETAIL PRIVATE LIMITED",
"NAHATA TEXTILE MILLS LIMITED",
"NAHDI PRIVATE LIMITED",
"NAHESH MARINE EXPORTS LIMITED",
"NAHORBARI TEA COMPANY PRIVATE LIMITED",
"NAHOUM & SONS PVT LTD",
"NAHTA SALT AND CHEMICAL PRIVATE LIMITED",
"NAI DUNIA",
"NAI NATH COMMODITIES PRIVATE LIMITED",
"NAI SADI PRAKASHAN PRIVATE LIMITED",
"NAIA RECRUITMENT CONSULTANCY PRIVATE LIMITED",
"NAIA SOFTWARE SOLUTIONS INDIA PRIVATE LIMITED",
"NAICE JEWELS PRIVATE LIMITED",
"NAICO INFORMATION TECHNOLOGY SERVICES PRIVATE LIMITED",
"NAICON FMS PRIVATE LIMITED",
"NAIDU HALL THE FAMILY STORE",
"NAIDU HOSPITAL",
"NAIDUHALL APPARELS",
"NAIGAONKAR TRADERS",
"NAIIMISHA FASHIONS PRIVATE LIMITED",
"NAIK ENVIRONMENTAL ENGINEERS PRIVATE LIMITED",
"NAIK FROZEN FOODS PRIVATE LIMITED",
"NAIK MOTORS",
"NAIK OCEANIC EXPORTS PRIVATE LIMITED",
"NAIK SEAFOODS PRIVATE LIMITED",
"NAIKNAVARE CHEMICALS LIMITED",
"NAIKNAVARE CONSTRUCTIONS PRIVATE LIMITED",
"NAIKNAVARE HOUSING DEVELOPMENTS PRIVATE LIMITED",
"NAIKNAVARE PROFILE CONSTRUCTIONS PRIVATE LIMITED",
"NAIK'S HOLIDAY INN PRIVATE LIMITED",
"NAIL SPA TRAINERS AND DISTRIBUTORS PRIVATE LIMITED",
"NAILBITER RESEARCH PRIVATE LIMITED",
"NAILEXE ENGINEERING WORKS PRIVATE LIMITED",
"NAILLESS BOXES PRIVATE LIMITED",
"NAILWAL SONS PRIVATE LIMITED",
"NAIMEX",
"NAIMINATH HOMOEOPATHIC MEDICAL COLLEGE HOSPITAL AND RESEARCH CENTRE",
"NAIMISH INFRASTRUCTURE PRIVATE LIMITED",
"NAIN HATCHERIES PRIVATE LIMITED",
"NAINA DEVI TRADERS PRIVATE LIMITED",
"NAINA EXPRESS PRIVATE LIMITED",
"NAINA POWER PRIVATE LIMITED",
"NAINA SALES PRIVATE LIMITED",
"NAINA TUBE TECH PRIVATE LIMITED",
"NAINA'S APPAREL PRIVATE LIMITED",
"NAINI AEROSPACE LIMITED",
"NAINI EXPORTS PRIVATE LIMITED",
"NAINI FINCAP LTD",
"NAINI PAPERS LIMITED",
"NAINI PLYWOOD PRIVATE LIMITED",
"NAINITA COT SPIN PRIVATE LIMITED",
"NAINITAL AUTOWHEELS PRIVATE LIMITED",
"NAINITAL BUILDCON PRIVATE LIMITED",
"NAINITAL HOTEL COMPANY PRIVATE LIMITED",
"NAINITAL MOTORS PRIVATE LIMITED",
"NAINITAL ROLLER FLOUR MILL PRIVATE LIMITED",
"NAINITAL STONE CRUSHER PRIVATE LIMITED",
"NAIPATRAWARTA PUBLICATIONS PRIVATE LIMITED",
"NAIPUNNYA INSTITUTE OF MANAGEMENT AND INFORMATION TECHNOLOGY",
"NAIR COAL SERVICES PRIVATE LIMITED",
"NAIRATY MULTIINFRA PRIVATE LIMITED",
"NAIRITI MULTIMEDIA PRIVATE LIMITED",
"NAISADH FABRICS PRIVATE LIMITED",
"NAISH SOLUTIONS PRIVATE LIMITED",
"NAISHA EMPTY PARK PRIVATE LIMITED",
"NAISHA EXPORTS PRIVATE LIMITED",
"NAITIK FASHIONS PRIVATE LIMITED",
"NAITIK VINIMAY PRIVATE LIMITED",
"NAIVE PLUS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"NAIVE POWER PROJECTS PRIVATE LIMITED",
"NAIVEDHYAM BANQUETS & FOODS PRIVATE LIMITED",
"NAIVEDYAM INFO SOLUTIONS PRIVATE LIMITED",
"NAJA ESTATES DEVELOPERS PRIVATE LIMITED",
"NAJAF ENGINEERING PRIVATE LIMITED",
"NAJAM STEEL ASSOCIATES PRIVATE LIMITED",
"NAJIN EXPORT PRIVATE LIMITED",
"NAJMI ELECTRICALS AND HARDWARES PVT LTD",
"NAK ELECTRONICS PRIVATE LIMITED",
"NAK SEALING TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"NAKA MICHI TECHNO PRIVATE LIMITED",
"NAKALANK DIGITAL INDIA PRIVATE LIMITED",
"NAKAMICHI SECURITIES LTD",
"NAKAMURA SHINWA ELECTRONICS INDIA PRIVATE LIMITED",
"NAKASA CROP SCIENCE PRIVATE LIMITED",
"NAKASHI JEWELS (OPC) PRIVATE LIMITED",
"NAKED EYE ADVERTISING PRIVATE LIMITED",
"NAKHAT REAL ESTATES PRIVATE LIMITED",
"NAKHLUN OVERSEAS PRIVATE LIMITED",
"NAKHYE'S EVEREST ESTATE PRIVATE LIMITED",
"NAKODA ANODIZING & POWDER COATING PRIVATE LIMITED",
"NAKODA BIOCONTROLS PRIVATE LIMITED",
"NAKODA CABLES PRIVATE LIMITED",
"NAKODA CHEMICALS LIMITED",
"NAKODA CHEMICALS PRIVATE LIMITED",
"NAKODA DAIRY PRIVATE LIMITED",
"NAKODA DECORES PRIVATE LIMITED",
"NAKODA FASHION PRIVATE LIMITED",
"NAKODA FINCON PRIVATE LIMITED",
"NAKODA FOREX PRIVATE LIMITED",
"NAKODA GROUP OF INDUSTRIES LIMITED",
"NAKODA HAIR ACCESSORIES PRIVATE LIMITED",
"NAKODA LIFESTYLE PRIVATE LIMITED",
"NAKODA MACHINERY PRIVATE LIMITED",
"NAKODA MAHAVIR AGRO INFRA PRIVATE LIMITED",
"NAKODA NAMKEEN & SNACKS PRIVATE LIMITED",
"NAKODA PLAST INDUSTRIES PRIVATE LIMITED",
"NAKODA ROADLINES PRIVATE LIMITED",
"NAKODA TRADELINKS PRIVATE LIMITED",
"NAKODAJI TEXTILES PVT LTD",
"NAKODAR HOTELS PRIVATE LIMITED",
"NAKOLE HIGH SCHOOL",
"NAKOSHI GLOBAL PRIVATE LIMITED",
"NAKS ADVISORS PRIVATE LIMITED",
"NAKS CREATORS PRIVATE LIMITED",
"NAKSATHRA EGGS FARMS PRIVATE LIMITED",
"NAKSH EXPORT",
"NAKSH LOGISTICS AND TRANSPORT PRIVATE LIMITED",
"NAKSH LOGISTICS PRIVATE LIMITED",
"NAKSHA TECH PRIVATE LIMITED",
"NAKSHATRA BUILDERS",
"NAKSHATRA CORPORATE ADVISORS LIMITED",
"NAKSHATRA CREATIONS PRIVATE LIMITED",
"NAKSHATRA FEEDS INDIA PRIVATE LIMITED",
"NAKSHATRA HEALTH CARE PRIVATE LIMITED",
"NAKSHATRA HOSPITALS",
"NAKSHATRA IT SOLUTIONS INDIA PRIVATE LIMITED",
"NAKSHATRA REGENCY PRIVATE LIMITED",
"NAKSHATRA RESIDENCY PRIVATE LIMITED",
"NAKSHATRA TECHNOHUB INDIA PRIVATE LIMITED",
"NAKSHI CREATIONS PRIVATE LIMITED",
"NAKSHI IMPEX PRIVATE LIMITED",
"NAKSHTRA URBAN CO-OPERATIVE CREDIT SOCIETY LTD",
"NAKUL AGRI SCIENCES PRIVATE LIMITED",
"NAKUL TEXTILE MILL PRIVATE LIMITED",
"NAKULARCH MEDITECH PRIVATE LIMITED",
"NAKULESHWAR AGRO PRODUCT PRIVATE LIMITED",
"NAL NEEL CONSTRUCTIONS PRIVATE LIMITED",
"NALA HOTELS PRIVATE LIMITED",
"NALAMM HOSPITAL PRIVATE LIMITED",
"NALANDA AUTO MOTIVE PRIVATE LIMITED",
"NALANDA AUTOMECH PRIVATE LIMITED",
"NALANDA BAKERS PRIVATE LIMITED",
"NALANDA BISCUIT COMPANY LIMITED",
"NALANDA BONE & SPINE CENTRE PRIVATE LIMITED",
"NALANDA BUILDERS AND DEVELOPERS INDIA LIMITED",
"NALANDA BUILTCON PVT LTD",
"NALANDA C.P. CERAMICS PRIVATE LIMITED",
"NALANDA CAPITAL INDIA ADVISORS PRIVATE LIMITED",
"NALANDA CAPITAL SERVICES PRIVATE LIMITED",
"NALANDA CHARITABLE FOUNDATION",
"NALANDA CORPORATE SERVICES PRIVATE LIMITED",
"NALANDA CRUSHERS PRIVATE LIMITED",
"NALANDA EDUCATION FOUNDATION",
"NALANDA EDUCATIONAL INSTITUTIONS",
"NALANDA ENGICON PRIVATE LIMITED",
"NALANDA ESTATES PRIVATE LIMITED",
"NALANDA HOTELS AND PROPERTIES LIMITED",
"NALANDA IMPEX PRIVATE LIMITED",
"NALANDA INFRASTRUCTURE PRIVATE LIMITED",
"NALANDA INSTITUTE FOR COMPUTER AND VOCATIONAL TRAINING PRIVATE LIMITED",
"NALANDA JUNIOR COLLEGE OF SCIENCE & ARTS",
"NALANDA KNOWLEDGE FOUNDATION TR. CO.",
"NALANDA LAW COLLEGE",
"NALANDA MEDI EQUIPMENTS PRIVATE LIMITED",
"NALANDA MERCANTILES PRIVATE LIMITED",
"NALANDA MODERN PUBLIC SCHOOL",
"NALANDA PRE-CAST PRIVATE LIMITED",
"NALANDA PUBLIC SCHOOL",
"NALANDA SECURITIES PRIVATE LIMITED",
"NALANDA TRADELINK PRIVATE LIMITED",
"NALANDA VIDHYA VIHAR",
"NALANDA VIDHYALAY",
"NALARI FERRO ALLOYS PRIVATE LIMITED",
"NALASHAA SOLUTIONS INDIA PRIVATE LIMITED",
"NALASHAA TECHNOLOGIES INDIA PRIVATE LIMITED",
"NALBARI FOOD PROCESSING PRIVATE LIMITED",
"NALCO METAL PRODUCTS LTD",
"NALCO WATER INDIA PRIVATE LIMITED",
"NALGE INFRASTRUCTURES PRIVATE LIMITED",
"NALGONDA REALTORS PRIVATE LIMITED",
"NALHATESHWARI FOODS & EXPORTS PRIVATE LIMITED",
"NALI CLOCKSOFTWARE SOLUTIONS PRIVATE LIMITED",
"NALIN LEASE FINANCE LIMITED",
"NALIN SYNTEX PRIVATE LIMITED",
"NALINAKSHA AGRO PRODUCTS PRIVATE LIMITED",
"NALINAM ENTERPRISES PRIVATE LIMITED",
"NALINI DEVI WOMENS COLLEGE",
"NALINI OF NALINI AND YASMIN SALON PRIVATE LIMITED",
"NALISHA AUTOMATION PRIVATE LIMITED",
"NALKA METAL INDUSTRIES PRIVATE LIMITED",
"NALL SOFT TECH PRIVATE LIMITED",
"NALLA MALLA REDDY ENGINEERING COLLEGE",
"NALLA NARASIMHA REDDY EDUCATION SOCIETY'S GROUP OF INSTITUTIONS",
"NALLABOLU INDUSTRIES PRIVATE LIMITED",
"NALLAPATI INFRA PROJECTS PRIVATE LIMITED",
"NALLAS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"NALLI SILK SAREES PRIVATE LIMITED",
"NALS OUTDOORS INDIA PRIVATE LIMITED",
"NALSAN ENTERPRISES PRIVATE LIMITED",
"NALSOFT PRIVATE LIMITED",
"NALTOLI TEA PRIVATE LIMITED",
"NALUX ELECTRONICS PRIVATE LIMITED",
"NALVETHA CAST STEELS PRIVATE LIMITED",
"NALWA INVESTMENTS LTD",
"NALWA LABORATORIES PRIVATE LIMITED",
"NALWA LOGISTICS PRIVATE LIMITED",
"NALWA METALS & ALLOYS LIMITED",
"NALWA SONS INVESTMENTS LIMITED TFR.FROM HARYANA TO DELHI",
"NALWA STEEL AND POWER LIMITED",
"NALWA TRADING LIMITED",
"NALWAYA MINERAL INDUSTRIES PRIVATE LIMITED",
"NAM ESTATES PRIVATE LIMITED",
"NAM PACKAGING PRIVATE LIMITED",
"NAMA HOTELS PRIVATE LIMITED",
"NAMA INVESTMENTS LIMITED",
"NAMAAMI SHANKARA PRIVATE LIMITED",
"NAMAH CAPITAL RESOURCES LIMITED",
"NAMAH ENERGY PRIVATE LIMITED",
"NAMAH PET PRIVATE LIMITED",
"NAMAH PICTURES PRIVATE LIMITED",
"NAMAKKAL LOGISTICS (INDIA) PRIVATE LIMITED",
"NAMAKKAL TRANSPORT CARRIERS PRIVATE. LIMITED.",
"NAMAMI PLYBOARD PRIVATE LIMITED",
"NAMAMIGANGE INFRATECH PRIVATE LIMITED",
"NAMAN CASTINGS PRIVATE LIMITED",
"NAMAN COTTON",
"NAMAN ELECTRIC PRIVATE LIMITED",
"NAMAN EQUIPMENTS & CONSTRUCTIONS (INDIA) PRIVATE LIMITED",
"NAMAN FINANCE AND INVESTMENT PVT LTD",
"NAMAN FINLEASE PRIVATE LIMITED",
"NAMAN GLOBAL IMPEX PRIVATE LIMITED",
"NAMAN HOME MAKERS PRIVATE LIMITED",
"NAMAN IN STORE INDIA PRIVATE LIMITED",
"NAMAN IN-STORE (INDIA) LIMITED",
"NAMAN INTEGRATED MANAGEMENT SERVICES PRIVATE LIMITED",
"NAMAN MALL MANAGEMENT COMPANY PRIVATE LIMITED",
"NAMAN METAWARES PRIVATE LIMITED",
"NAMAN PETRO PRIVATE LIMITED",
"NAMAN PRIMARY SCHOOL",
"NAMAN RETAIL PRIVATE LIMITED",
"NAMAN SHARE TRADERS PRIVATE LIMITED",
"NAMAN SHREEGOVINDAM REALESTATE PRIVATE LIMITED",
"NAMAN STATIONERS PRIVATE LIMITED",
"NAMAN STAY PRIVATE LIMITED",
"NAMAN TEA PVT LTD",
"NAMAN TEXTILES PRIVATE LIMITED",
"NAMAN TEXTURISERS PRIVATE LIMITED",
"NAMAN VIDYA",
"NAMAN VINCOM PVT LTD",
"NAMANIDHI PHARMACEUTICAL PRIVATE LIMITED",
"NAMANVIDHI WORLDTRADE PRIVATE LIMITED",
"NAMASKAAR CORPORATION PRIVATE LIMITED",
"NAMASKAR APPARELS PRIVATE LIMITED",
"NAMASKAR BLUE METAL INDUSTRIES PRIVATE LIMITED",
"NAMASKAR IMPORTS AND EXPORTS PRIVATE LIMITED",
"NAMASKAR INSTYLE PRIVATE LIMITED",
"NAMASTASYE SERVICES PRIVATE LIMITED",
"NAMASTE AIRPORT SERVICES PRIVATE LIMITED",
"NAMASTE EXPORTS LIMITED",
"NAMASTE INDIA AVIATION PRIVATE LIMITED",
"NAMASTE TOURS PRIVATE LIMITED",
"NAMASTE VENTURES PRIVATE LIMITED",
"NAMASTEY CARGO LOGISTICS PRIVATE LIMITED",
"NAMASTEYHOMES TECHNO SOLUTIONS PRIVATE LIMITED",
"NAMAZCO TRADES & EXPORTS PRIVATE LIMITED",
"NAMBERDAR DEV RAJ CARRIER PRIVATE LTD",
"NAMBI BUILDWELL LIMITED",
"NAMBIAR BUILDERS PRIVATE LIMITED",
"NAMBISAN 'S DAIRY PRIVATE LIMITED",
"NAMBURNADI TEA COMPANY LIMITED",
"NAMCO INDUSTRIES PRIVATE LIMITED",
"NAMDEO UMAJI AGRITECH INDIA PRIVATE LIMITED",
"NAMDEV ASHOK KUMAR TEXTILES PRIVATE LIMITED",
"NAMDEV FINVEST PRIVATE LIMITED",
"NAMDHARI AGRO-FRESH PRIVATE LIMITED",
"NAMDHARI ANIMAL GENETICS PRIVATE LIMITED",
"NAMDHARI AUDIO VISUAL EQUIPMENT PRIVATE LIMITED",
"NAMDHARI BAJAJ PRIVATE LIMITED",
"NAMDHARI INDUSTRIAL TRADERS PRIVATE LIMITED",
"NAMDHARI SEEDS PRIVATE LIMITED",
"NAMDHARI SHOPPING CENTRE PRIVATE LIMITED",
"NAMDHARI TIMMBER PRIVATE LIMITED",
"NAMECHEAP WEB SERVICES PRIVATE LIMITED",
"NAMEDI HOSPITALS PRIVATE LIMITED",
"NAMEH HOTELS PRIVATE LIMITED",
"NAMEH HOUSING PRIVATE LIMITED",
"NAMESAKE DIAMOND AND JEWELLERY PRIVATE LIMITED",
"NAMHYA FOODS PRIVATE LIMITED",
"NAMI CAPITAL PRIVATE LIMITED",
"NAMINATH ENGINEERING PRIVATE LIMITED",
"NAMINATH MOTORS PRIVATE LIMITED",
"NAMISH DISTRIBUTORS PRIVATE LIMITED",
"NAMISHA BRISTLE INDIA PRIVATE LIMITED",
"NAMISHREE INFRASTRUCTURE & PROJECTS PRIVATE LIMITED",
"NAMISHRREE JEWELS PRIVATE LIMITED",
"NAMIT AGRO PRODUCTS PRIVATE LIMITED",
"NAMITA LOGISTICS PRIVATE LIMITED",
"NAMITA RICE MILL PRIVATE LIMITED",
"NAMLA DEVELOPERS PRIVATE LIMITED",
"NAMLABS TECHNOLOGIES PRIVATE LIMITED",
"NAMMA HOMEOPATHY PRIVATE LIMITED",
"NAMMAN BUILDWELLS PRIVATE LIMITED",
"NAMMANE CONSTRUCTIONS PRIVATE LIMITED",
"NAMMO INDIA PRIVATE LIMITED",
"NAMO ARIHANT CONFECTIONERIES PRIVATE LIMITED",
"NAMO CAPS PRIVATE LIMITED",
"NAMO CONSULTANCY PRIVATE LIMITED",
"NAMO DIAMONDS PRIVATE LIMITED",
"NAMO EDU INFRASTRUCTURE PRIVATE LIMITED",
"NAMO EWASTE MANAGEMENT LIMITED",
"NAMO FIBRES PRIVATE LIMITED",
"NAMO KITCHENWARES PRIVATE LIMITED",
"NAMO LANDBASE PRIVATE LIMITED",
"NAMO NAMAH EXIM PRIVATE LIMITED",
"NAMO NAMOKAR ENGINEERING PRIVATE LIMITED",
"NAMO OILS PRIVATE LIMITED",
"NAMO ORGANISATIONS PRIVATE LIMITED",
"NAMO PACKAGING SOLUTIONS PRIVATE LIMITED",
"NAMO TRACTORS PRIVATE LIMITED",
"NAMOASIS TECHNO PRIVATE LIMITED",
"NAMOHA FOUNDRIES PVT LTD",
"NAMOHA MULTIVENTURES PRIVATE LIMITED",
"NAMOHARIHANT C Z JEWELLERS PRIVATE LIMITED",
"NAMOKAR METALLICS PRIVATE LIMITED",
"NAMONKAR ELECTRICALS PRIVATE LIMITED",
"NAMOSHIVAI APPARELS PRIVATE LIMITED",
"NAMOSTU INFRA PRIVATE LIMITED",
"NAMOVA FABRICS PRIVATE LIMITED",
"NAMPONG PLY PVT LTD",
"NAMRA FINANCE LIMITED",
"NAMRATA AGENCIES PRIVATE LIMITED",
"NAMRATA CAPITAL PRIVATE LIMITED",
"NAMRATA CREATION PRIVATE LIMITED",
"NAMRATA DEVELOPERS PRIVATE LIMITED",
"NAMRATA DIAGNO-CARE PRIVATE LIMITED",
"NAMRATA GROUP",
"NAMRATA KITCHEN APPLIANCES PRIVATE LIMITED",
"NAMRATA PROMOTERS AND BUILDERS",
"NAMRATA STONE CRUSHER PRIVATE LIMITED",
"NAMRATHA FEEDS PRIVATE LIMITED",
"NAMRATHA MANAGEMENT SERVICES PRIVATE LIMITED",
"NAMRATHA OIL REFINERIES PRIVATE LIMITED",
"NAMRATTA FINSTOCK AND INVESTMENT PRIVATE LIMITED",
"NAMROH INDUSTRIES PRIVATE LIMITED",
"NAMSBEL GLOBAL PRIVATE LIMITED",
"NAMTECH CONSULTANTS PRIVATE LIMITED",
"NAMTECH PROPERTIES LIMITED",
"NAMTEL TECHNOLOGIES PRIVATE LIMITED",
"NAN PAO RESINS INDIA PRIVATE LIMITED",
"NANA BUILDERS & DEVELOPERS PRIVATE LIMITED",
"NANA ENTERPRISE PRIVATE LIMITED",
"NANAJI DESHMUKH VETERINARY SCIENCE UNIVERSITY",
"NANAJI FARMER PRODUCER COMPANY LIMITED",
"NANAJI FOODS AND BEVERAGES PRIVATE LIMITED",
"NANAK DOOR FITTINGS PRIVATE LIMITED",
"NANAK FURNISHERS PRIVATE LTD",
"NANAK HI-TECH PRIVATE LIMITED",
"NANAK INFRASTRUCTURE ENGINEERING SERVICES PRIVATE LIMITED",
"NANAK LABORATORIES PRIVATE LIMITED",
"NANAK LAMA VENTURES PRIVATE LIMITED",
"NANAK LOGISTICS PRIVATE LIMITED",
"NANAK MARBLES PRIVATE LIMITED",
"NANAK NUTRITIONS FOOD (TALOJA) PRIVATE LIMITED",
"NANAK PROPERTIES PRIVATE LIMITED",
"NANAKWADA NAVINAGRI VARGSHALA",
"NANAL HYDRO POWER CONSULTANCY PRIVATE LIMITED",
"NANALAL INDUSTRIES PRIVATE LIMITED",
"NANAP TRANSFORMERS PRIVATE LIMITED",
"NANASA PIDGAON ROAD PRIVATE LIMITED",
"NANASAHEB BHINTADE SPACESS PRIVATE LIMITED",
"NANASAHEB PATILMAHADYAMIK VIDYA SCHOOL",
"NANASAHEB Y N CHAVAN ARTS SCIENCE & COMMERCE COLLEGE",
"NANATVA INFRA PROJECTS PRIVATE LIMITED",
"NANAVATI AUTOSQUARE PRIVATE LIMITED",
"NANAVATI CARS PRIVATE LIMITED",
"NANAVATI DEVELOPERS PRIVATE LIMITED",
"NANAVATI HOSPITAL",
"NANAVATI MOTORS PRIVATE LIMITED",
"NANAVATI SONS PRIVATE LIMITED",
"NANAVATI SPECIALITY CHEMICALS PRIVATE LIMITED",
"NANAVATI VENTURES LIMITED",
"NANAYASURABHI AFFORDABLE HOUSING FINANCE LIMITED",
"NANCO CHEM PRODUCTS PRIVATE LIMITED",
"NANCY IMPEX PRIVATE LIMITED",
"NANCY ISPAT PRIVATE LIMITED",
"NANCY KRAFTS",
"NANCY PACKAGES PRIVATE LIMITED",
"NANCY PAPER PRODUCTS PRIVATE LIMITED",
"NANCY REAL ESTATE PRIVATE LIMITED",
"NAND COMPOSITES PRIVATE LIMITED",
"NAND ENTERPRISES",
"NAND EQUIPMENTS PRIVATE LIMITED",
"NAND ESTATE DEVELOPERS PRIVATE LIMITED",
"NAND GOPAL AGRO INDUSTRIES PRIVATE LIMITED",
"NAND HOSPITALITY PRIVATE LIMITED",
"NAND KESHAV SALES PRIVATE LIMITED",
"NAND KISHOR SINGH CONSTRUCTION PRIVATE LIMITED",
"NAND KISHORE MEGHRAJ JEWELLERS PRIVATE LIMITED",
"NAND KISHORE MONGA FOODS PRIVATE LIMITED",
"NAND LAL HOTELS AND INFRASTRUCTURES PRIVATE LIMITED",
"NAND LAL PURI AND SONS PRIVATE LIMITED",
"NAND MULTISPECIALITY HOSPITALS PRIVATE LIMITED",
"NAND NIKETAN SERVICES PRIVATE LIMITED",
"NAND RAJ ROLLER FLOUR MILLS PRIVATE LIMITED",
"NAND RAMAUTAR TELECOM SERVICES PRIVATE LIMITED",
"NAND TRADING PRIVATE LIMITED",
"NAND VIDYA NIKETAN",
"NANDA AGRO UDYOG PRIVATE LIMITED",
"NANDA AUTOMOBILES (GUJARAT) PRIVATE LIMITED",
"NANDA AUTOMOBILES PRIVATE LIMITED",
"NANDA CHEMICALS PRIVATE LIMITED",
"NANDA FEEDS PRIVATE LIMITED",
"NANDA INFRA CONSTRUCTION PRIVATE LIMITED",
"NANDA MOTORS PRIVATE LIMITED",
"NANDADEEP CHEMICALS PRIVATE LIMITED",
"NANDADEEP EYE HOSPITAL",
"NANDADEEP HOMES PRIVATE LIMITED",
"NANDAI TEXTILES",
"NANDAKINI CONTRACTORS PRIVATE LIMITED",
"NANDAKINI REALINFRA PRIVATE LIMITED",
"NANDAL FINANCE AND LEASINGPRIVATE LIMITED",
"NANDAN AGRO PRIVATE LIMITED",
"NANDAN AQUATECH (INDIA) PRIVATE LIMITED",
"NANDAN AUTO TECH LIMITED",
"NANDAN BUILDCON PRIVATE LIMITED",
"NANDAN DENIM LIMITED",
"NANDAN DIAGNOSTICS PRIVATE LIMITED",
"NANDAN FILMS PRIVATE LIMITED",
"NANDAN GROUND SUPPORT EQUIPMENT PRIVATE LIMITED",
"NANDAN GSE PVT LTD",
"NANDAN IMPEX PVT LTD",
"NANDAN INDUSTRIES PRIVATE LIMITED",
"NANDAN INFRASTRUCTURE PRIVATE LIMITED",
"NANDAN METALS AND TUBES PRIVATE LIMITED",
"NANDAN NAGAR ADARSHA UCHCHA BALIKA VIDYABIDAYALAYA",
"NANDAN PETROCHEM LIMITED",
"NANDAN PHARMA PRIVATE LIMITED",
"NANDAN SAHA STEEL PRIVATE LIMITED",
"NANDAN SALES CORPORATION",
"NANDAN STEELS AND POWER LIMITED",
"NANDAN TERRY LIMITED",
"NANDAN TERRY PRIVATE LIMITED",
"NANDAN TEXTILES PRIVATE LIMITED",
"NANDANA ELECTRIC AND ENERGY SOLUTIONS PRIVATE LIMITED",
"NANDANAM ARTS COLLEGE",
"NANDANI CREATION LIMITED",
"NANDANI MEDICAL LABORATORIES PVT LTD",
"NANDANI ROOFING PRIVATE LIMITED",
"NANDANI ROOFING SYSTEMS PRIVATE LIMITED",
"NANDANKANAN BARTER PVT.LTD.",
"NANDANVAN COMMERCIAL PVT LTD",
"NANDAY INVESTEMNTS LIMITED",
"NANDED CITY DEVELOPMENT AND CONSTRUCTION COMPANY LIMITED",
"NANDED MATHADI AND UNPROTECTED LABOUR BOARD",
"NANDED PRAGATI AGRO PRODUCER COMPANY LIMITED",
"NANDED WAGHALA CITY MUNICIPAL CORPORATION NANDED",
"NANDEESHWARA COLDSTORAGE PRIVATE LIMITED",
"NANDESARI ENVIRONMENT CONTROLS LIMITED",
"NANDESARI WATER AND UTILITIES LIMITED",
"NANDESHWARI STEEL LIMITED",
"NANDESHWER TOOLS PRIVATE LIMITED",
"NANDHA MEDICAL COLLEGE AND HOSPITAL",
"NANDHANA FOODS PRIVATE LIMITED",
"NANDHINI HOTELS PRIVATE LIMITED",
"NANDHINI RUBBER PRIVATE LIMITED",
"NANDHINI TRANSPORTS PRIVATE LIMITED",
"NANDHISHIV IMPEX PRIVATE LIMITED",
"NANDHRA ENGINEERING AND CONSTRUCTION (SPV) PRIVATE LIMITED",
"NANDHVART INVESTMENT PRIVATE LIMITED",
"NANDI AGRO INITIATIVE PRIVATE LIMITED",
"NANDI AGROTECH PRIVATE LIMITED",
"NANDI BUILDWELL PRIVATE LIMITED",
"NANDI COLD STORAGES PRIVATE LIMITED",
"NANDI ECONOMIC CORRIDOR ENTERPRISES LIMITED",
"NANDI FEEDS PRIVATE LIMITED",
"NANDI FERTILISERS PRIVATE LIMITED",
"NANDI FOOTWEARS PRIVATE LIMITED",
"NANDI GRAIN DERIVATIVES PRIVATE LIMITED",
"NANDI HIGHWAY DEVELOPERS LIMITED",
"NANDI HOUSING PRIVATE LIMITED",
"NANDI INFRASTRUCTURE CORRIDOR ENTERPRISE LIMITED",
"NANDI INFRATECH PRIVATE LIMITED",
"NANDI INTERNATIONAL PRIVATE LIMITED",
"NANDI IRRIGATION SYSTEMS LIMITED",
"NANDI MILK PRODUCTS PRIVATE LIMITED",
"NANDI P U COLLEGE",
"NANDI POLYMERS INDIA PRIVATE LIMITED",
"NANDI POWERTRONICS PRIVATE LIMITED",
"NANDI RICE AND GENERAL MILLS",
"NANDI RIDERS PRIVATE LIMITED",
"NANDI ROLLER FLOUR MILLS PRIVATE LIMITED",
"NANDI RUBBER INDUSTRIES PVT LTD",
"NANDI SCHOOL C B S E BELLARY",
"NANDI SEEDS PRIVATE LIMITED",
"NANDI TEA COMPANY PVT LTD.",
"NANDI TEXFAB LIMITED",
"NANDI TYRES PRIVATE LIMITED",
"NANDIGARI HOME SOLUTIONS PRIVATE LIMITED",
"NANDIGHOSE SPONGE & POWER PRIVATE LIMITED",
"NANDIGHOSH ESTATES PRIVATE LIMITED",
"NANDIGRAM REALTECH PRIVATE LIMITED",
"NANDIGRAM VIDYALAY NANDUR(GHAT)",
"NANDIKA PAPER PRODUCTS PRIVATE LIMITED",
"NANDIKA PHARMA PRIVATE LIMITED",
"NANDILATH G-MART",
"NANDINA IRON AND STEELS LTD",
"NANDINEE CORPORATION PRIVATE LIMITED",
"NANDINI AGARBATTI COMPANY PRIVATE LIMITED",
"NANDINI AGRO SHED NETS PRIVATE LIMITED",
"NANDINI BUILDHOME CONSORTIUM PRIVATE LIMITED",
"NANDINI CLOTHING PRIVATE LIMITED",
"NANDINI CREATION",
"NANDINI ELECTRICAL SYSTEMS AND SERVICES PRIVATE LIMITED",
"NANDINI HERBAL-CARE PRIVATE LIMITED",
"NANDINI INFOSYS PRIVATE LIMITED",
"NANDINI KJITCHEN APPLIANCES PRIVATE LIMITED",
"NANDINI MILKS PRIVATE LIMITED",
"NANDINI STEELS & SECURITIES PVT. LTD.",
"NANDINI TEXCOM (INDIA) LIMITED",
"NANDINI TRADEX PRIVATE LIMITED",
"NANDINI WASTE MANAGEMENT PRIVATE LIMITED",
"NANDISH ALLOYS LIMITED",
"NANDISH ENTERPRISES PRIVATE LIMITED",
"NANDISH MARBLE PVT LTD",
"NANDISHWAR ICE AND COLD STORAGE PRIVATE LIMITED",
"NANDISHWAR POLYMERS PRIVATE LIMITED",
"NANDKRISHNA CHEMICALS PRIVATE LIMITED",
"NANDLAL BANKATLAL PRIVATE LIMITED",
"NANDLAL SYNTHETICS MILLS PRIVATE LIMITED",
"NANDLALA INTERNATIONAL PRIVATE LIMITED",
"NANDLALL & SONS TEA INDUSTRIES PVT LTD",
"NANDNANDAN SILK MILLS PRIVATE LIMITED",
"NANDNI ELECTRICAL WORKS PRIVATE LIMITED",
"NANDOLIA ORGANIC CHEMICALS PRIVATE LIMITED",
"NANDOS SERVICES INDIA PRIVATE LIMITED",
"NANDOSAL CHEM INDUSTRIES PVT LTD",
"NANDPRIYA FABRICS PRIVATE LIMITED",
"NANDRAJ RICE MILL",
"NANDRAM GAJANAND PRIVATE LIMITED",
"NANDRATAN FOUNDRY AND ENGINEERING WORKS PVT LTD",
"NANDU BAKERY",
"NANDU CHEMICALS PRIVATE LIMITED",
"NANDURA CHIKHLI HIGHWAYS PRIVATE LIMITED",
"NANDURBAR TALUKA VIDHAYAK SAMITI COLLEGE OF EDUCATION",
"NANDVIJAY COTTON PRIVATE LIMITED",
"NANDWANA CHEMICALS AND FERTILIZERS PRIVATE LIMITED",
"NANDY SEWING SOLUTIONS PRIVATE LIMITED",
"NANDYALA SATYANARAYANA",
"NANDYAVART TRADING PRIVATE LIMITED",
"NANESH ENGINEERS PRIVATE LIMITED",
"NANGALIA BROTHERS PVT LTD",
"NANGALIA FOOD INDUSTRIES PRIVATE LIMITED",
"NANGALIA SIZERS PRIVATE LIMITED",
"NANGALIA STOCK BROKING PRIVATE LIMITED",
"NANGALIA SYNTHETICS PRIVATE LIMITED",
"NANGALIA TELECOM PVT LTD",
"NANGALIA UDYOG PRIVATE LIMITED",
"NANGALWALA CHEMICALS INDUSTRIES",
"NANGIA & CO LLP",
"NANGIA ASSOCIATES PVT LTD",
"NANGIA AUTOMOTIVE PRIVATE LIMITED",
"NANGIA CARS PRIVATE LIMITED",
"NANGIA TRADERS PRIVATE LIMITED",
"NANGLOI WATER SERVICES PRIVATE LIMITED",
"NANGUNERI-KANYAKUMARI TOLLWAY PRIVATE LIMITED",
"NANHE MAL AGRO (INDIA) LIMITED",
"NANHI PARI SEEMANT ENGINEERING INSTITUTE",
"NANI AGRO FOODS PRIVATE LIMITED",
"NANI ASSOCIATES",
"NANI ELECTRO TECHNIC PRIVATE LIMITED",
"NANI NAROLI WELFARE HIGH SCHOOL",
"NANI RESORTS AND FLORICULTURE PRIVATE LIMITED",
"NANI S BUILDCON PRIVATE LIMITED",
"NANI VIRANI WIND ENERGY PRIVATE LIMITED",
"NANIBALA COLD STORAGE PRIVATE LIMITED",
"NANIWADEKAR HOSPITALITY PRIVATE LIMITED",
"NANJ SOLAR PRIVATE LIMITED",
"NANJAPPA HOSPITALS PRIVATE LIMITED",
"NANJAPPA TRUST",
"NANJGEL SOLUTIONS PRIVATE LIMITED",
"NANJIL AGRO PRODUCTS DEVELOPMENT FOUNDATION",
"NANJIL INTEGRATED DAIRY DEVELOPMENT",
"NANJING ELECTRIC INDIA PRIVATE LIMITED",
"NANJU PACKAGING",
"NANJUNDESHWARA INFRASTRUCTURES PRIVATE LIMITED",
"NANKANI CONSTRUCTION & DEVELOPERS PRIVATE LIMITED",
"NANKI AUTOMOTIVES AND ENTERPRISES PRIVATE LIMITED",
"NANKI IMPEX PRIVATE LIMITED",
"NANLIU MANUFACTURING (INDIA) PRIVATE LIMITED",
"NANMA PROPERTIES LIMITED",
"NANNAPANENI VENKAT RAO COLLAGE OF ENGINEERING AND TECHNOLOGY",
"NANNOOH BROTHERS PRIVATE LIMITED",
"NANNU FOODS AND CHEMELEMENT PRIVATE LIMITED",
"NANO AVIATION INDIA PRIVATE LIMITED",
"NANO HOSPITALS PRIVATE LIMITED",
"NANO JOB CONSULTANTS PRIVATE. LIMITED.",
"NANO KERNEL LIMITED",
"NANO MAG TECHNOLOGIES PRIVATE LIMITED",
"NANO POLYMERS INDIA PRIVATE LIMITED",
"NANO PV VOLTECH SOLAR PRIVATE LIMITED",
"NANO TECH CHEMICAL BROTHERS PRIVATE LIMITED",
"NANO THERAPEUTICS PRIVATE LIMITED",
"NANO WICORE LABS PRIVATE LIMITED",
"NANO-AGRO FOODS PRIVATE LIMITED",
"NANOBI DATA AND ANALYTICS PRIVATE LIMITED",
"NANOBOT HOUSEWARES SOLUTIONS PRIVATE LIMITED",
"NANOCARE HEALTH SERVICES PRIVATE LIMITED",
"NANOCELL NETWORKS PRIVATE LIMITED",
"NANOCEUT THERAPEUTICS PRIVATE LIMITED",
"NANOCRYST TRANSCORE PRIVATE LIMITED",
"NANOFIL TECHNOLOGIES PRIVATE LIMITED",
"NANOLITE INFRATECH PRIVATE LIMITED",
"NANOO ELECTRONICS PRIVATE LIMITED",
"NANOPIX INTEGRATED SOFTWARE SOLUTIONS PRIVATE LIMITED",
"NANOPRECISE DATA SERVICES PRIVATE LIMITED",
"NANOS MEDICARE PRIVATE LIMITED",
"NANOSPAN INDIA PRIVATE LIMITED",
"NANOSTUFFS TECHNOLOGIES PRIVATE LIMITED",
"NANOTECH HEALTHCARE PRIVATE LIMITED",
"NANOTECH PRINTING INKS (INDIA) PRIVATE LIMITED",
"NANOTECH SOFTWARE N APPLICATION IT SOLUT ION LLP",
"NANOTEK TEXCHEM PRIVATE LIMITED",
"NANOTUFF INTERNATIONAL PRIVATE LIMITED",
"NANOWAY ENGINEERING PRIVATE LIMITED",
"NANSHENG MACHINERY (INDIA) PRIVATE LIMITED",
"NANSOM HEALTH CARE PRIVATE LIMITED",
"NANSON OVERSEAS PRIVATE LIMITED",
"NANTECH POWER SYSTEMS PRIVATE LIMITED",
"NANTI HYDRO POWER PRIVATE LIMITED",
"NANU ENGINEERS PRIVATE LIMITED",
"NANU ESTATES PRIVATE LIMITED",
"NANU INDUSTRIES",
"NANU RAM GOYAL CONSTRUCTION CO PRIVATE LIMITED",
"NANU RAM JINDAL GUM AND CHEMICALS PRIVATE LIMITED",
"NANU RESORTS PRIVATE LIMITED",
"NANU TRADECOM PRIVATE LIMITED",
"NANYA AIRCONN PRIVATE LIMITED",
"DATAGAPS INDIA PRIVATE LIMITED",
"NANZ MED SCIENCE PHARMA PRIVATE LIMITED",
"NAO SPIRITS & BEVERAGES PRIVATE LIMITED",
"NAOKI INTERNATIONAL TECHNOLOGIES PRIVATE LIMITED",
"NAOLIN INFRASTRUCTURE PRIVATE. LIMITED.",
"NAOLIN PROJECTS PRIVATE LIMITED",
"NAOMI MANUFACTURING INDIA PRIVATE LIMITED",
"NAOMI SEEDS PRIVATE LIMITED",
"NAOOLIN REALCON PRIVATE LIMITED",
"NAOS SKIN CARE INDIA PRIVATE LIMITED",
"NAP & SONS ENTERPRISES & BUSINESS PRIVATE LIMITED.",
"NAP AND SONS E RETAILING SOLUTIONS PRIVATE",
"NAP CONSTRUCTIONS & PROJECTS PRIVATE LIMITED",
"NAP MOTORS & FINANCE PRIVATE LIMITED",
"NAPA AUTOFORGE PRIVATE LIMITED",
"NAPA SOFTWARE SERVICES INDIA PRIVATE LIMITED",
"NAPAR PHARMACHEM PRIVATE LIMITED",
"NAPASAR POLYMER PRIVATE LIMITED",
"NAPASAR SPINNERS PRIVATE LIMITED",
"NAPC LIMITED",
"NAPCLOUD INDIA PRIVATE LIMITED",
"NAPCO MACHINERY PRIVATE LIMITED",
"NAPESCO INDIA LLP",
"NAPH GRAPHICS PRIVATE LIMITED",
"NAPIER HEALTHCARE SOLUTIONS (INDIA) PRIVATE LIMITED",
"NAPIER HEALTHCARE SOLUTIONS INDIA LIMITED",
"NAPINO AUTO AND ELECTRONICS LIMITED",
"NAPINO CONTINENTAL VEHICLE ELECTRONICS PRIVATE LIMITED",
"NAPINO CONTROL SYSTEMS PRIVATE LIMITED",
"NAPOLITAN TRAVEL AGENCY COMPANY LIMITED",
"NAPPA DORI PRIVATE LIMITED",
"NAPRAAJ COMMERCIAL PVT.LTD.",
"NAPROD LIFE SCIENCES PRIVATE LIMITED",
"NAPS (INDIA) SHOES PRIVATE LIMITED",
"NAPS GLOBAL INDIA PRIVATE LIMITED",
"NAPSA PRIVATE LIMITED",
"NAPSES TECHNOLOGIES PRIVATE LIMITED",
"NAPSON LUBRICANTS PRIVATE LIMITED",
"NAPTECH PACKAGINGS PRIVATE LIMITED",
"NAPTHA RESINS CHEMICALS PRIVATE LIMITED",
"NAPTICO SERVICES PRIVATE LIMITED",
"NAQ FOODS INDIA PRIVATE LIMITED",
"NAQVI BUILDCON PRIVATE LIMITED",
"NAR FURNITURE PRIVATE LIMITED",
"NAR LANGUAGE SOLUTIONS PRIVATE LIMITED",
"NAR SINGH UPS KASISON",
"NARA CONSTRUCTION",
"NARA GLOBAL (INDIA) PRIVATE LIMITED",
"NARAIN COLLEGE SHIKOHABAD",
"NARAIN LABELS (INDIA) P LTD",
"NARAIN OILS PRIVATE LIMITED",
"NARAIN PAPERS PRIVATE LIMITED",
"NARAIN PRINTERS AND BINDERS",
"NARAIN PRO AUDIO LIGHTING PRIVATE LIMITED",
"NARAIN SYNTHETICS PVT LTD",
"NARAIN WOOD PRIVATE LIMITED",
"NARAINA MEDICAL COLLEGE AND HOSPITAL",
"NARAINDAS CONSTRUCTION PVT LTD",
"NARAINDASS R. ISRANI & CO PRIVATE LIMITED",
"NARAINGARH SUGAR MILLS LIMITED",
"NARAIURAN CONTROLS INDIA PRIVATE LIMITED",
"NARAN CHIRAKKAL CORPORATE PRIVATE LIMITED",
"NARANDAS & SONS FABRICATORS PRIVATE LIMITED",
"NARANG ACCESS PRIVATE LIMITED",
"NARANG BAO SANT INFRASTRUCTURES PRIVATE LIMITED",
"NARANG BIOTEC PRIVATE LIMITED",
"NARANG CONSTRUCTION AND FINANCERS PRIVATE LIMITED",
"NARANG ETHANIC",
"NARANG INTERMEDIARIES PRIVATE LIMITED",
"NARANG LITES PRIVATE LIMITED",
"NARANG MEDICAL LIMITED",
"NARANG NIRANKARI JEWELLERS PRIVATE LIMITED",
"NARANG PLASTICS PRIVATE LIMITED",
"NARANG SAREE EMPORIUM PRIVATE LIMITED",
"NARANG SCIENTIFIC WORKS PRIVATE LIMITED",
"NARANG VENTURES PRIVATE LIMITED",
"NARANGI ANCHALIK MAHAVIDYALAYA",
"NARANGI PLASTICS PRIVATE LIMITED",
"NARANGS HOSPITALITY SERVICES PRIVATE LIMITED",
"NARANGS INTERNATIONAL HOTELS PRIVATE LIMITED",
"NARANLALA PRIVATE LIMITED",
"NARANTAK DEALCOMM LTD",
"NARASARAOPETA ENGINEERING COLLEGE",
"NARASIMHA INDUSTRIES",
"NARASIMHAN ENGINEERING CONTRACTORS PRIVATE LIMITED",
"NARASIMHASWAMY SOLAR GENERATIONS PRIVATE LIMITED",
"NARASIPUR AUTO COMPONENTS PRIVATE LIMITED",
"NARASIPUR PRECISION PRIVATE LIMITED",
"NARASUS SAARATHY ENTERPRISES PRIVATE LIMITED",
"NARASUS SARATHY INSTITUTE OF TECHNOLOGY",
"NARAVI INFRA & UTILITIES PRIVATE LIMITED",
"NARAYAN AGENCIES AND ESTATES PRIVATE LIMITED.",
"NARAYAN AGRI PRODUCT PRIVATE LIMITED",
"NARAYAN AGRIBUSINESS PRIVATE LIMITED",
"NARAYAN AGRO FOODS LIMITED",
"NARAYAN AGROTRADE PRIVATE LIMITED",
"NARAYAN AND KOMALAM PRIVATE LIMITED",
"NARAYAN ART PRINTERS PRIVATE LIMITED",
"NARAYAN CARS PRIVATE LIMITED",
"NARAYAN CASHEW INDUSTRIES PRIVATE LIMITED",
"NARAYAN COLD STORAGE PRIVATE LIMITED",
"NARAYAN COLD STORAGE PVT LTD",
"NARAYAN COLLEGE FIROZABAD",
"NARAYAN COLLEGE OF SCIENCE AND ART",
"NARAYAN COLOUR FAB PRIVATE LIMITED",
"NARAYAN CONSTRUCTIONS",
"NARAYAN COTEX PRIVATE LIMITED",
"NARAYAN DAL UDYOG PRIVATE LIMITED",
"NARAYAN DAS AND SONS (HOTELS) PRIVATE LIMITED",
"NARAYAN DAS GEMS & JEWELS PRIVATE LIMITED",
"NARAYAN DATTA PAINTING",
"NARAYAN DEVELOPERS",
"NARAYAN DYE STUFF PRIVATE LIMITED",
"NARAYAN ENGIMECH PRIVATE LIMITED",
"NARAYAN ENGINEERING PRIVATE LIMITED",
"NARAYAN EPOXY COMPONENTS PRIVATE LIMITED",
"NARAYAN FOOD PRODUCTS PRIVATE LIMITED",
"NARAYAN FORGING AND GEARS PVT LTD",
"NARAYAN FRUITS & VEGETABLES COLD STORAGE PRIVATE LIMITED",
"NARAYAN GINNING AND OIL MILLS PRIVATE LIMITED",
"NARAYAN HEALTH SERVICES PRIVATE LIMITED",
"NARAYAN HOSPITAL & TRAUMA CENTRE",
"NARAYAN INFRAHIGHT PRIVATE LIMITED",
"NARAYAN ISPAT PRIVATE LIMITED",
"NARAYAN KUMAR INFRASTRUCTURE PRIVATE LIMITED",
"NARAYAN MARINE TECH PRIVATE LIMITED",
"NARAYAN MUNI SPINNERS PRIVATE LIMITED",
"NARAYAN MUNI SPINTEX PRIVATE LIMITED",
"NARAYAN OFFSET WORKS PRIVATE LIMITED",
"NARAYAN ORGANICS PVT LTD",
"NARAYAN OXYGEN CO. PRIVATE LIMITED",
"NARAYAN POLYSPIN PRIVATE LIMITED",
"NARAYAN POLYURETHANE INDUSTRIES",
"NARAYAN POWER TECH PRIVATE LIMITED",
"NARAYAN PROCON PRIVATE LIMITED",
"NARAYAN PUBLIC SCHOOL",
"NARAYAN PUBLICATION PRIVATE LIMITED",
"NARAYAN RUBBER PRIVATE LIMITED",
"NARAYAN SEEDS PRIVATE LIMITED",
"NARAYAN SHAILENDRA INFRA PRIVATE LIMITED",
"NARAYAN SHIVRAM SHIPPING PRIVATE LIMITED",
"NARAYAN SPINNING MILLS PRIVATE LIMITED",
"NARAYAN STONE CHIPS PRIVATE LIMITED",
"NARAYAN TEXFAB PRIVATE LIMITED",
"NARAYAN TOURISM PRIVATE LIMITED",
"NARAYAN WIRES PVT LTD",
"NARAYANA AGRO OILS PRIVATE LIMITED",
"NARAYANA DIAGNOSTICS",
"NARAYANA EDUCATIONAL",
"NARAYANA EDUCATIONAL INSTITUTIONS",
"NARAYANA EDUCATIONAL SOCIETY",
"NARAYANA EDUCATIONAL TRUST",
"NARAYANA FOUNDATION",
"NARAYANA GROUP OF EDUCATIONAL INSTITUTIONS",
"NARAYANA HOSPITAL",
"NARAYANA HOSPITALS PRIVATE LIMITED",
"NARAYANA HRUDAYALAYA LIMITED",
"NARAYANA HRUDAYALAYA SURGICAL HOSPITAL PRIVATE LIMITED",
"NARAYANA JUNIOR COLLEGE",
"NARAYANA LEARNING PRIVATE LIMITED",
"NARAYANA NETHRALAYA",
"NARAYANA OLYMPIAD SCHOOL RESIDENTIAL CAMPUS",
"NARAYANA PEARLS (INDIA) PRIVATE LIMITED",
"NARAYANA PROCESSED FOOD PRIVATE LIMITED",
"NARAYANA PUBLIC SCHOOL",
"NARAYANA VAISHNO DEVI SPECIALTY HOSPITALS PRIVATE LIMITED",
"NARAYANA WIND POWER PRIVATE LIMITED",
"NARAYANADRI HOSPITALS AND RESEARCH INSTITUTE PRIVATE LIMITED",
"NARAYANAN A",
"NARAYANAN BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"NARAYANAN GOLD HOUSE PRIVATE LIMITED",
"NARAYANANA CITY BUS OPERATIONS PRIVATE LIMITED",
"NARAYANASWAMY SUPER SPECIALITY HOSPITALS PRIVATE LIMITED",
"NARAYANBHAI KALU TAMBOLI MADHYAMIK VIDYALAYA & KANISHTA MAHAVIDYALAYA RANALE",
"NARAYANDAS PHOOLCHAND MISHRA INFRASTRUCTURES PRIVATE. LIMITED.",
"NARAYANDAS SARAF JEWELLERS PRIVATE LIMITED",
"NARAYANI ABASAN PVT LTD",
"NARAYANI ASSOCIATES PRIVATE LIMITED",
"NARAYANI AUTO CENTRE PVT LTD",
"NARAYANI CHEMIST PRIVATE LIMITED",
"NARAYANI COKE PRIVATE LIMITED",
"NARAYANI CONSTRUCTION PRIVATE LIMITED",
"NARAYANI EQUIPMENTS PRIVATE LIMITED",
"NARAYANI FUELS PRIVATE LIMITED",
"NARAYANI GEMS AND ORNAMENTS PRIVATE LIMITED",
"NARAYANI HITECHPACK PRIVATE LIMITED",
"NARAYANI ISPAT PRIVATE. LIMITED.",
"NARAYANI LAMINATES PRIVATE LIMITED",
"NARAYANI MANUFACTURING PRIVATE LIMITED",
"NARAYANI MOTORS PRIVATE LIMITED",
"NARAYANI PACKAGING PRIVATE LIMITED",
"NARAYANI PLASTICS PRIVATE LIMITED",
"NARAYANI PLY AND BOARDS PRIVATE LIMITED",
"NARAYANI POLYCHEM PRIVATE LIMITED",
"NARAYANI RAIL PRODUCTS PRIVATE LIMITED",
"NARAYANI RESOURCES PRIVATE LIMITED",
"NARAYANI SONS INDIA PRIVATE LIMITED",
"NARAYANI TECHNOCONTAINERS PRIVATE LIMITED",
"NARAYANI TIE UP PVT LTD",
"NARAYANIGN INDUSTRIES PRIVATE LIMITED",
"NARAYANJI GAJAKWALE PRIVATE LIMITED",
"NARAYANJI SPICES AND PULSES PRIVATE LIMITED",
"NARAYANKRUPA TOWNSHIP PRIVATE LIMITED",
"NARAYANPUR TEA COMPANY PRIVATE LIMITED",
"NARAYANRAO KUCHAN PRATHMIK SHALA SOLAPUR",
"NARAYANRAO WAGHMARE MAHAVIDYALAYA",
"NARBADA DAIRY FOODS AND FARMS PRIVATE LIMITED",
"NARBADA FOREST INDUSTRIES PRIVATE. LIMITED.",
"NARBADA GEMS AND JEWELLERY LIMITED",
"NARBADA IMPEX PRIVATE LIMITED",
"NARBADA STEELS LIMITED",
"NARBADA TEXTILES PRIVATE LIMITED",
"NARBADA TRAVELS PRIVATE LIMITED",
"NARBHAVI MULTI SPECIALITY HOSPITALS PRIVATE LIMITED",
"NARBHERAM FINANCE CO. LIMITED",
"NARBHERAM FINANCE CO. PRIVATE LIMITED",
"NARBHERAM LEASING COMPANY PRIVATE LIMITED",
"NARBHERAM MOTORS PRIVATE LIMITED",
"NARBHERAM POWER AND STEEL PRIVATE LIMITED",
"NARBHERAM REALTY PRIVATE LIMITED",
"NARBOD CONSTRUCTIONS PRIVATE LIMITED",
"NARDIL ENTERPRISE PRIVATE LIMITED",
"NAREDCO WEST FOUNDATION",
"NAREDI INTERNATIONAL PRIVATE LIMITED",
"NAREDI POLYPACK PRIVATE LIMITED",
"NAREDI TEXFAB PRIVATE LIMITED",
"NAREENA LIFESCIENCES PRIVATE LIMITED",
"NARELA AUTOMOBILES PRIVATE LIMITED",
"NARELA FAUJI MOTOR TRANSPORT CO PVT LTD",
"NAREN CHITS PRIVATE LIMITED",
"NAREN GEMS PRIVATE LIMITED (TRF.)",
"NAREN TEXTILE ENGINEERS INDIA PRIVATE LIMITED",
"NARENDRA COTTON GINNING & PRESSING COMPANY PRIVATE LIMITED",
"NARENDRA DUTTA EDUCATION PRIVATE LIMITED",
"NARENDRA EXIM LOGISTICS INDIA PRIVATE LIMITED",
"NARENDRA EXPLOSIVES LIMITED",
"NARENDRA FLEXIPACK COMPANY PRIVATE LIMITED",
"NARENDRA FORWARDERS PRIVATE LIMITED",
"NARENDRA FROZEN FOOD STORE PRIVATE LIMITED",
"NARENDRA GRAVURE PRIVATE LIMITED",
"NARENDRA INTERIORS PRIVATE LIMITED",
"NARENDRA LOGISTICS PRIVATE LIMITED",
"NARENDRA MOHAN HOSPITAL",
"NARENDRA NATH COLD STORAGE PRIVATE LIMITED",
"NARENDRA PACKAGING PVT LTD",
"NARENDRA POLYCHEM PRIVATE LIMITED",
"NARENDRA POLYMERS PRIVATE LIMITED",
"NARENDRA PRE UNIVERSITY COLLEGE",
"NARENDRA PRESS-TECH PRIVATE LIMITED",
"NARENDRA PROPERTIES LIMITED",
"NARENDRA SALES CORPORATION",
"NARENDRA SHARMA CONSTRUCTION PRIVATE LIMITED",
"NARENDRA SURFACTANT AND SPECIALITY CHEMI CALS PRIVATE LIMITED",
"NARENDRA TEXTILES PRIVATE LIMITED",
"NARENDRA UDYOG PVT LTD",
"NARENDRAPUR TEA COMPANY PVT LTD",
"NARENKUMAR JEWELLERS PRIVATE LIMITED",
"NARENPUR PURNEA HIGHWAYS LIMITED",
"NARESH AGGARWAL AGENCIES PRIVATE LIMITED",
"NARESH APPARELS PRIVATE LIMITED",
"NARESH BUILD AND HOME PRIVATE LIMITED",
"NARESH DI HATTI FOODS PRIVATE LIMITED",
"NARESH DISTRIBUTORS PRIVATE LIMITED",
"NARESH ELECTRICAL & AUTOMATION PRIVATE LIMITED",
"NARESH INFRA PROJECT PRIVATE LIMITED",
"NARESH JEWELLERS PRIVATE LIMITED",
"NARESH KUMAR & COMPANY PVT LTD",
"NARESH KUMAR GUPTA & CO PRIVATE LIMITED",
"NARESH OVERSEAS PRIVATE LIMITED",
"NARESH STEEL INDUSTRIES PRIVATE LIMITED",
"NARESH STOCK SERVICES PRIVATE LIMITED",
"NARESH SWEETS PRIVATE LIMITED",
"NARESH TRADELINK PRIVATE LIMITED",
"NARGIS FASHION PRIVATE LIMITED",
"NARIE CONSTRUCTIONS PRIVATE LIMITED",
"NARIKULAM PRIVATE LIMITED",
"NARIMAN FINVEST PVT. LTD.",
"NARIMAN SAREES PRIVATE LIMITED",
"NARIMAN SYNTHETICS PRIVATE LIMITED",
"NARINDER MOHAN HOSPITAL AND HEART CENTRE",
"NARINDER SINGH AND SONS PVT LTD",
"NARITA HOTELS PRIVATE LIMITED",
"NARITAA TOOLING PRIVATE LIMITED",
"NARITH BUSINESS SERVICES PRIVATE LIMITED",
"NARKHEDE SWITCHGEAR PRIVATE LIMITED",
"NARMA INTERNATIONAL PRIVATE LIMITED",
"NARMADA & WATER RESOURCES DEPTT UKAI CIRCLE",
"NARMADA AGRO COTTEX PRIVATE LIMITED",
"NARMADA AGRO FOODS PRIVATE LIMITED",
"NARMADA AGROBASE LIMITED",
"NARMADA AMRIT FOOD PRIVATE LIMITED",
"NARMADA AND WATER RESOURCES WATER SUPLY AND KALPASAR SEPARTMENT",
"NARMADA ARTS SCIENCE & COMMERCE JUNIOR COLLEGE",
"NARMADA BIO-CHEM PRIVATE LIMITED",
"NARMADA CALCINORS PRIVATE LIMITED",
"NARMADA CARS PRIVATE LIMITED",
"NARMADA CLEAN TECH",
"NARMADA COLLEGE OF MANAGEMENT",
"NARMADA COLOURS PRIVATE LIMITED",
"NARMADA CONCAST PRIVATE LIMITED",
"NARMADA CONTROL AUTHORITY",
"NARMADA COTEX",
"NARMADA DESIGN CENTRE PVT LTD",
"NARMADA DISTRICT EDUCATION COMMITTEE MANAGED PRIMARY SCHOOL TEACHER",
"NARMADA ENGITECH PRIVATE LIMITED",
"NARMADA EQUIPMENTS PRIVATE LIMITED",
"NARMADA FINTRADE PRIVATE LIMITED",
"NARMADA GARDENS PRIVATE LIMITED",
"NARMADA GELATINES LIMITED",
"NARMADA GLOBAL WELLNESS PRIVATE LIMITED",
"NARMADA GROUP OF HOTELS",
"NARMADA HOSPITAL",
"NARMADA HOSPITALITY SERVICES PRIVATE LIMITED",
"NARMADA IRON AND ASSOCIATES PRIVATE LIMITED",
"NARMADA IRON AND STEEL PVT LTD.",
"NARMADA JACKSONS",
"NARMADA MACPLAST DRIP IRRIGATION SYSTEMS LIMITED",
"NARMADA MILK PRIVATE LIMITED",
"NARMADA MOULDS PRIVATE LIMITED",
"NARMADA MULTISPECIALITY HOSPITAL AND RESEARCH CENTRE",
"NARMADA OFFSHORE CONSTRUCTIONS PRIVATE LIMITED",
"NARMADA PHOSPHATE LIMITED",
"NARMADA POLYMERS MANESAR LIMITED",
"NARMADA RINGS PRIVATE LIMITED",
"NARMADA ROADLINES PRIVATE LIMITED",
"NARMADA SILK INDUSTRIES PRIVATE LIMITED",
"NARMADA SOLVEX PRIVATE LIMITED",
"NARMADA SUGAR PRIVATE LIMITED",
"NARMADA SWITCHGEAR PRIVATE LIMITED",
"NARMADA TRANSFORMERS PRIVATE LIMITED",
"NARMADA TRANSMISSION PRIVATE LIMITED",
"NARMADA TRAUMA CENTRE PRIVATE LIMITED",
"NARMADA TRIDEV HEALTHCARE AND SERVICES PRIVATE LIMITED",
"NARMADA TUBES PRIVATE LIMITED",
"NARMADA VALLEY RUBBERS PRIVATE LIMITED",
"NARMADA VELLY GREEN LAND PVT LTD",
"NARMADA WAREHOUSE PRIVATE LIMITED",
"NARMADA WIND ENERGY PRIVATE LIMITED",
"NARMADASAGAR AGRISEEDS PRIVATE LIMITED",
"NARMADESHWAR RICE MILLS PRIVATE LIMITED",
"NARMATHAA TEXTILES LIMITED",
"NARMWARE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"NARNARAYAN CONSTRUCTION PRIVATE LIMITED",
"NARNARAYAN INFRASTRUCTURE PRIVATE LIMITED",
"NARNARAYAN SHASTRI INSTITUTE OF NURSING",
"NARNARAYAN SHASTRI INSTITUTE OF TECHNOLOGY",
"NARNOLI APPARELS PRIVATE LIMITED",
"NARNOLIA FINANCIAL SERVICES LIMITED",
"NARNOLIA INVESTMENT ADVISORS PRIVATE",
"NARNOLIA SALES AND AUCTION PRIVATE LIMITED",
"NARNOLIA SECURITIES LIMITED",
"NARODA ORTHOPAEDIC HOSPITAL",
"NARODA UTILITIES SERVICES",
"NAROL TEXTILE INFRASTRUCTURE & ENVIRO MANAGEMENT",
"NAROLA INFOTECH SOLUTIONS LLP",
"NAROLA MACHINES",
"NAROMA TEXTILES IMPEX PRIVATE LIMITED",
"NAROSA BOOK DISTRIBUTORS PRIVATE LTD",
"NAROTAM FURNISHERS PRIVATE LIMITED",
"NAROTAM SEKHSARIA FOUNDATION",
"NAROTTAM GRANITES PRIVATE LIMITED",
"NAROTTAMKA COMMODITIES PVT LTD",
"NAROTTAMKA TRADE & VYAPAAR PRIVATE LIMITED",
"NARPAVI LOGISTICS PRIVATE LIMITED",
"NARR COTTON EXPORTS PRIVATE LIMITED",
"NARRA CONSTRUCTIONS PRIVATE LIMITED",
"NARROW FABRIC MANUFACTURERS (BOMBAY) PRIVATE LIMITED",
"NARROWCASTERS INDIA PRIVATE LIMITED",
"NARSAPUR AUTO PRIVATE LIMITED",
"NARSARAOPET INSTITUTE OF TECHNOLOGY",
"NARSARIA CONSTRUCTION PRIVATE LIMITED",
"NARSEE MONJEE INSTITUTE OF MANAGEMENT STUDIES",
"NARSHI & ASSOCIATES",
"NARSI INTERIOR INFRASTRUCTURES PRIVATE LIMITED",
"NARSIGH VIDYALAYA RANIANKULGA",
"NARSIM BAGS PRIVATE LIMITED",
"NARSIMHA IRON & STEEL PRIVATE LIMITED",
"NARSIMHA REDDY ENGINEERING COLLEGE",
"NARSING TEXTILES INDUSTRIES PRIVATE LIMITED",
"NARSING TRADING COMPANY PRIVATE LIMITED",
"NARSINGH CONSTRUCTIONS AND CONSULTANCY PRIVATE LIMITED",
"NARSINGH DASS AND COMPANY PRIVATE LIMITED",
"NARSINGH FARMERS CROP PRODUCER COMPANY PRIVATE LIMITED",
"NARSINGH ISPAT LIMITED",
"NARSINGH ISPAT UDYOG PRIVATE LIMITED",
"NARSINGH MERCANTILE PRIVATE LIMITED",
"NARSINGH MULTI TRADELINK PRIVATE LIMITED",
"NARSINGH RUBBER AND OIL PRIVATE LIMITED",
"NARSINGPORE TEA CO PVT LTD",
"NARSINHBHAI PATEL DENTAL COLLEGE & HOSPITAL",
"NARSIPUR CHEMICALS P LTD",
"NARSONS FURNITURE PRIVATE LIMITED",
"NARULA BUILD WELL PRIVATE LIMITED",
"NARULA CORPORATE RELOCATION SERVICES PRIVATE LIMITED",
"NARULA EXPORTS",
"NARULA FASHIONS PRIVATE LIMITED",
"NARULA INFRASTRUCTURE PRIVATE LIMITED",
"NARULA INSTITUTE OF TECHNOLOGY",
"NARULA PAINTS PRIVATE LIMITED",
"NARULA RETAILS PRIVATE LIMITED",
"NARULA UDYOG(INDIA)PVT LTD",
"NARUVI HOSPITALS",
"NARUVIZHI AMBAL MODERN RICE MILL PRIVATE LIMITED",
"NARVADA DYE-CHEM (INDIA) PRIVATE LIMITED",
"NARVAR INDIA PRIVATE LIMITED",
"NARVEDA MOTORS PRIVATE LIMITED",
"NARVS PHARMA PRIVATE LIMITED",
"NARWAL FOOD PRODUCTS PRIVATE LIMITED",
"NARWAL TECHNOLOGIES PRIVATE LIMITED",
"NARWANA INFRA PRIVATE LIMITED",
"NARWHAL CHEMICALS AND FERTILIZERS INTERNATIONAL PRIVATE LIMITED",
"NARYALA ELECTRICALS PRIVATE LIMITED",
"NAS AVIATION SERVICES INDIA PRIVATE LIMITED",
"NAS BABU CONSTRUCTIONS PRIVATE LIMITED",
"NAS BROADBAND PRIVATE LIMITED",
"NAS FISHERIES PVT LTD",
"NASA AGRO INDUSTRIES PRIVATE LTD",
"NASA CONSTRUCTIONS P LTD",
"NASA EXIM (OPC) PRIVATE LIMITED",
"NASA FIRE TECHNOLOGY LIMITED",
"NASA INFRACON PRIVATE LIMITED",
"NASA MARKETING SOLUTIONS PRIVATE LIMITED",
"NASA SAFETY SOLUTIONS PRIVATE LIMITED",
"NASADIYA TECHNOLOHIES PRIVATE LIMITED",
"NASAN MEDICAL ELECTRONICS PRIVATE LIMITED",
"NASAR ENTERPRISE PRIVATE LIMITED",
"NASCENCER TECHNOLOGY PRIVATE LIMITED",
"NASCENT AND SAGACIOUS PRIVATE LIMITED",
"NASCENT BUILDERS PRIVATE LIMITED",
"NASCENT INFO TECHNOGIES PRIVATE LIMITED",
"NASCENT LEASING AND INFOTECH PRIVATE LIMITED",
"NASCENT LIFESCIENCE PRIVATE LIMITED",
"NASCENT MARITIME PRIVATE LIMITED",
"NASCENT MINE TECH CORPORATION PRIVATE LIMITED",
"NASCENT SPECIALITY ADDITIVES PRIVATE LIMITED",
"NASCENT VENTURES PRIVATE LIMITED",
"NASCO CEMENTS INDIA PRIVATE LIMITED",
"NASCO STEELS PRIVATE LIMITED",
"NASCOM SALES PRIVATE LIMITED",
"NASCOT TEXTILES PRIVATE LIMITED",
"NASCOZ INDIA PRIVATE LIMITED",
"NASDAQ CORPORATE SOLUTIONS INDIA PRIVATE LIMITED",
"NASEEB HOLDINGS PVT LTD",
"NASEEB LABS PRIVATE LIMITED",
"NASEMA FABRICATION",
"NASENSE LABS PRIVATE LIMITED",
"NASEQUIP SYSTEMS PRIVATE LIMITED",
"NASH FASHION (INDIA) LIMITED",
"NASH INDUSTRIES INDIA PRIVATE LIMITED",
"NASH PRODUCTS",
"NASH ROBOTICS & AUTOMATION PRIVATE LIMITED",
"NASH SHIPPING PRIVATE LIMITED",
"NASH TECHNOLOGIES PRIVATE LIMITED",
"NASHER MILES PRIVATE LIMITED",
"NASHIK AUTOTECH PRIVATE LIMITED",
"NASHIK AUTOWELD SYSTEMS PRIVATE LIMITED",
"NASHIK CAMBRIDGE SCHOOL",
"NASHIK DISTRICT CENTRAL CO-OPP BANK NASHIK",
"NASHIK DISTRICT SHAY ROG NIYATRN SOCIETY",
"NASHIK ENGINEERING CLUSTER",
"NASHIK INFRASTRUCTURE DEVELOPERS PRIVATE LIMITED",
"NASHIK INSTITUTE OF CARDIAC SCIENCES PRIVATE LIMITED",
"NASHIK INSULATIONS PRIVATE LIMITED",
"NASHIK MAHANAGAR PARIVAHAN MAHAMANDAL LIMITED",
"NASHIK MUNICIPAL CORPORATION",
"NASHIK PACKAGING PRIVATE LIMITED",
"NASHIK PAINTS PRIVATE LIMITED",
"NASHIK SINNAR TOLLWAYS LIMITED",
"NASHIK TECHNOMET PRIVATE LIMITED",
"NASHIK WASTE MANAGEMENT PRIVATE LIMITED",
"NASHIK'S BALAJI NURSERY PRIVATE LIMITED",
"NASHTRONICS TRADING PRIVATE LIMITED",
"NASHVIILLE INFRA SERVICES LIMITED",
"NASHWIN ELECTRIC PRIVATE LIMITED",
"NASIK FARM VENTURES PRIVATE LIMITED",
"NASIK INGOTS PRIVATE LIMITED",
"NASIK ISPAT PRIVATE LIMITED",
"NASIK METALDUST PVT LTD",
"NASIK OXYGEN COMPANY PRIVATE LIMITED",
"NASIK STEEL PVT LTD",
"NASIK SUPER TOOLS COMPANY PRIVATE LIMITED",
"NASIK WELDING PRODUCTS PRIVATE LIMITED",
"NASIM AHSAN CONSTRUCTION PRIVATE LIMITED",
"NASIT LOGISTICS PRIVATE LIMITED",
"NASKAR'S DELCO MECHANICAL ENGINEERING PRIVATE LIMITED",
"NASKON SOFT SOLUTIONS PRIVATE LIMITED",
"NASLA CREATION PRIVATE LIMITED",
"NASMYTH ASIA IN PRIVATE LIMITED",
"NASONTA HEALTHCARE PRIVATE LIMITED",
"NASR BOYS SCHOOL",
"NASRIN FACILITY PRIVATE LIMITED",
"NASS ENGINEERING SERVICES PRIVATE LIMITED",
"NASSCON INFRA PRIVATE LIMITED",
"NASTESCO MARINE ENGINEERING PRIVATE LIMITED",
"NASWIZ RETAILS PRIVATE LIMITED",
"NAT IT SERVICES PRIVATE LIMITED",
"NAT STEEL EQUIPMENT PRIVATE LIMITED",
"NATA DEVICES INDIA PRIVATE LIMITED",
"NATAA AUTOMOBILES PRIVATE LIMITED",
"NATARAJ COLD STORAGE PVT LTD",
"NATARAJ IRONMART PRIVATE LIMITED",
"NATARAJ JEWELLERY MART PRIVATE LIMITED",
"NATARAJ MOBILES PRIVATE LIMITED",
"NATARAJ OIL MILLS PRIVATE LIMITED",
"NATARAJ POLYPLAST PRIVATE LIMITED",
"NATARAJ ROOFING PRIVATE LIMITED",
"NATARAJ SAROVAR PORTICO",
"NATASHA AUTOMOBILES PRIVATE LIMITED",
"NATASHA CONSTRUCTION PROJECTS PRIVATE LIMITED",
"NATASHA ENGINEERING",
"NATASHA ENGINEERS PRIVATE LIMITED",
"NATASHA FIN TUBES PRIVATE LIMITED",
"NATBIOME SPECIALITY HEALTHCARE PRIVATE LIMITED",
"NATBRO INDIA PRIVATE LIMITED",
"NATBURY LIFECARE PRIVATE LIMITED",
"NATCHART PRIVATE LIMITED",
"NATCHART SHIPPING PRIVATE LIMITED",
"NATCO EXPORTS PRIVATE LIMITED",
"NATCO PHARMA LIMITED",
"NATCO PRODUCTS INDIA PRIVATE LIMITED",
"NATCOMP COMPUTERS PRIVATE LIMITED",
"NATCON BIOLIFESCIENCES PRIVATE LIMITED",
"NATCURE BIOTECH PRIVATE LIMITED",
"NATECH SOLUTIONS INDIA PRIVATE LIMITED",
"NATESAN PRECISION COMPONENTS PRIVATE LIMITED",
"NATESAN SYNCHROCONES PRIVATE LIMITED",
"NATESH TRADERS P.LTD.",
"NATGEN PLASTOMER PRIVATE LIMITED",
"NATH ADVERTISERS PRIVATE LIMITED",
"NATH BIO CHEMICAL INDUSTRIES PRIVATE LIMITED",
"NATH BIO-GENES INDIA LIMITED",
"NATH BROTHERS EXIM INTERNATIONAL LIMITED",
"NATH CHIKAN IMPORT AND EXPORT PRIVATE LIMITED",
"NATH FOILS PRIVATE LIMITED",
"NATH INDUSTRIES LIMITED",
"NATH JUNIOR COLLEGE NATHAPUR BEED",
"NATH LOGISTICS & SHIPPING PRIVATE LIMITED",
"NATH MADHYAMIK VIDYALAY",
"NATH OUTSOURCING SOLUTIONS PRIVATE LIMITED",
"NATH PAPER PRIVATE LIMITED",
"NATH PETERS HYGEIAN LIMITED",
"NATH REALTY PRIVATE LIMITED",
"NATH SOLVENT EXTRACTIONS PVT LTD",
"NATH TITANATES PRIVATE LIMITED",
"NATH VALLEY SCHOOL",
"NATHA ARTS AND CRAFTS PVT LTD",
"NATHA CREATION PRIVATE LIMITED",
"NATHAN AND NATHAN CONSULTANTS PRIVATE LIMITED",
"NATHAN ARK SOFTWARE PRIVATE LIMITED",
"NATHAN INFRA PRIVATE LIMITED",
"NATHAN MAL EXIM PRIVATE LIMITED",
"NATHAN RESEARCH SYSTEMS PRIVATE LIMITED",
"NATHANI DIAGNOSTIC SERVICES PRIVATE LIMITED",
"NATHANI INDUSTRIAL SERVICES PRIVATE LIMITED",
"NATHANI INDUSTRIAL SERVICES PVT LTD",
"NATHANI INSURANCE SURVEYORS AND LOSS ASSESSORS PRIVATE LIMITED",
"NATHANI PAREKH CONSTRUCTIONS PRIVATE LIMITED",
"NATHANI STEEL PRIVATE LIMITED",
"NATHANS PACKAGING PRIVATE LIMITED",
"NATHCORP PRIVATE LIMITED",
"NATHDWARA DEVELOPERS PVT LTD",
"NATHDWARA LIFESPACES PRIVATE LIMITED",
"NATHIKA CASTING PRIVATE LIMITED",
"NATHOO COMMODITIES PVT LTD",
"NATHSAGAR BIO-GENETICS PRIVATE LIMITED",
"NATHSON FARMERS PRODUCER COMPANY LIMITED",
"NATHU SWEETS PRIVATE LIMITED",
"NATHURAM RAMNARAYAN PVT LTD",
"NATHURMAL ECO MINERALS PRIVATE LIMITED",
"NATICON RESEARCH LABS PRIVATE LIMITED",
"NATIO HEALTHCARE LLP",
"NATIONAL ACADEMY FOR LEARNING",
"NATIONAL ACADEMY OF CONSTUCTION",
"NATIONAL ACADEMY OF INDIAN RAILWAYS",
"NATIONAL ACADEMY OF RUDSETI",
"NATIONAL ADVERTISING AGENCY",
"NATIONAL AGRICULTURE AND FOOD ANALYSIS AND RESEARCH INSTITUTE",
"NATIONAL AIDS RESEARCH INSTITUTE",
"NATIONAL AIRCON INDIA PRIVATE LIMITED",
"NATIONAL ALUMINIUM COMPANY LIMITED",
"NATIONAL ARCHIVES OF INDIA",
"NATIONAL ASSET RECONSTRUCTION COMPANY LIMITED",
"NATIONAL ASSOCIATION OF SOFTWARE & SERVICE COMPANIES",
"NATIONAL AUSTRALIA BANK",
"NATIONAL AUTOMOTIVE TESTING AND R & D IN",
"NATIONAL BACKWARD CLASSES FINANCE AND DEVELOPMENT CORPORATIO",
"NATIONAL BANK FOR AGRICULTURE & RURAL DEVELOPMENT NABARD",
"NATIONAL BANK OF ABU DHABI",
"NATIONAL BICYCLE CORPORATION OF INDIA LTD",
"NATIONAL BOARD FOR WORKERS EDUCATION AND DEVELOPMENT",
"NATIONAL BOOK TRUST INDIA",
"NATIONAL BOOK TRUST.",
"NATIONAL BUILDERS INFRASTRUCTURES PRIVATE LIMITED",
"NATIONAL BUILDING ORGANISATION",
"NATIONAL BULK HANDLING CORPORATION PRIVATE LIMITED",
"NATIONAL CANCER INSTITUTE NAGPUR",
"NATIONAL CAPITAL REGION ELECTRONICS PRIVATE LIMITED",
"NATIONAL CAPITAL REGION INSTITUTE OF MEDICAL SCIENCES",
"NATIONAL CAPITAL REGION TRANSPORT CORPORATION",
"NATIONAL CAPITAL REGION TRANSPORT CORPORATION LIMITED",
"NATIONAL CAPSULES PRIVATE LIMITED",
"NATIONAL CAR CARE",
"NATIONAL CAREER SERVICE CENTRE FOR DIFFERENTLY ABLED",
"NATIONAL CARRIERS CORPORATION PRIVATE LIMITED",
"NATIONAL CENTRE FOR AUTISM INDIA",
"NATIONAL CENTRE FOR CELL SCIENCE",
"NATIONAL CENTRE FOR FINANCIAL EDUCATION",
"NATIONAL CENTRE FOR GOOD GOVERNANCE",
"NATIONAL CENTRE FOR SUSTAINABLE AQUACULTURE",
"NATIONAL CENTRE FOR SUSTAINABLE COASTAL MANAGEMENT",
"NATIONAL CENTRE FOR THE PERFORMING ARTS",
"NATIONAL CENTRE FOR VOCATIONAL AND TECHNICAL EDUCATION",
"NATIONAL CEREALS PRODUCTS LIMITED",
"NATIONAL CHEMICAL LABORATORY",
"NATIONAL CLOTHING SUPPLY (INDIA) PVT LTD",
"NATIONAL CO OPERATIVE DAIRY FEDERATION OF INDIA LTD",
"NATIONAL COLD STORAGE AND REFRIGERATION PRIVATE LIMITED",
"NATIONAL COMMISSION FOR WOMEN",
"NATIONAL COMMODITY AND DERIVATIVES EXCHANGE LIMITED",
"NATIONAL COMMODITY CLEARING LIMITED",
"NATIONAL COMPANY",
"NATIONAL CONCIL OF EDUCATIONAL RESEARCH & TRAINNING",
"NATIONAL CONTRACTING COMPANY INDIA PRIVATE LIMITED",
"NATIONAL COOPERATIVE DEVELOPMENT CORPORATION",
"NATIONAL COOPERATIVE HOUSING SOCIETY LTD",
"NATIONAL COUNCIL OF EDUCATIONAL RES",
"NATIONAL CREDIT GUARANTEE TRUSTEE COMPANY LIMITED",
"NATIONAL DAIRY AGRO PRIVATE LIMITED",
"NATIONAL DAIRY DEV BOARD",
"NATIONAL DAIRY RESEARCH INSTITUTE",
"NATIONAL DEFENCE ACADEMY",
"NATIONAL DEVELOPMENT BANK",
"NATIONAL DIARY RESEARCH INSTITUE",
"NATIONAL DISASTER RESPONSE FORCE",
"NATIONAL DIVYANGJAN FINANCE AND DEVELOPMENT CORPORATION",
"NATIONAL E- GOVERNANCE SERVICES LIMITED",
"NATIONAL EDUCATION FOUNDATION",
"NATIONAL EDUCATION SOCIETY",
"NATIONAL ENERGY TRADING AND SERVICES LIMITED",
"NATIONAL ENGINEERING",
"NATIONAL ENGINEERING INDUSTRIES LIMITED",
"NATIONAL ENGLISH PRIMARY SCHOOL VIRAR WEST",
"NATIONAL ENTREPRENEURSHIP NETWORK",
"NATIONAL ENVIRONMENTAL ENGINEERING RESEARCH INSTITUTE",
"NATIONAL EXIM PRIVATE LIMITED",
"NATIONAL FABRO TECHNOLOGIES PRIVATE LIMITED",
"NATIONAL FERTILIZERS LIMITED",
"NATIONAL FILM ARCHIVE OF INDIA",
"NATIONAL FILM DEVELOPMENT CORP0RATION LIMITED",
"NATIONAL FINANCIAL HOLDINGS COMPANY LIMITED",
"NATIONAL FITTINGS LIMITED",
"NATIONAL FORENSIC SCIENCES UNIVERSITY",
"NATIONAL GEMS HIGHER SECONDARY SCHOOL",
"NATIONAL GEOPHYSICAL RESEARCH INSTI",
"NATIONAL GINNING AND PRESSING INDUSTRIES",
"NATIONAL GREEN TRIBUNAL",
"NATIONAL HANDICRAFTS",
"NATIONAL HANDLOOM DEVELOPMENT CORPORATION LIMITED",
"NATIONAL HEALTH MISSION",
"NATIONAL HEALTH MISSION GUJARAT",
"NATIONAL HEALTH SYSTEMS RESOURCE CENTRE",
"NATIONAL HEART INSTITUTE",
"NATIONAL HEAT PUMPS PRIVATE LIMITED",
"NATIONAL HIGH POWER TEST LABORATORY PRIVATE LIMITED",
"NATIONAL HIGH SPEED RAIL CORPORATION LIMITED",
"NATIONAL HIGHWAYS AUTHORITY OF INDIA",
"NATIONAL HIGHWAYS INFRA INVESTMENT MANAGERS PRIVATE LIMITED",
"NATIONAL HIGHWAYS LOGISTICS MANAGEMENT LIMITED",
"NATIONAL HORTICULTURAL RESEARCH AND DEVELOPMENT FOUNDATION",
"NATIONAL HORTICULTURE BOARD (NHB)",
"NATIONAL HOSPITAL",
"NATIONAL HOTELS LIMITED",
"NATIONAL HOUSING BANK",
"NATIONAL HUMAN RIGHTS COMMISSION INDIA",
"NATIONAL HYDROGRAPHIC OFFICE",
"NATIONAL IMAGING & PATH LABS",
"NATIONAL INDUSTRIAL APPARELS PRIVATE LIMITED",
"NATIONAL INDUSTRIAL CORPN LIMITEID",
"NATIONAL INDUSTRIAL CORPORATION LIMITED",
"NATIONAL INDUSTRIAL CORRIDOR DEVELOPMENT CORPORATION LIMITED",
"NATIONAL INFORMATICS CENTRE SERVICES INC",
"NATIONAL INFRAINDUSTRIES LIMITED",
"NATIONAL INNOVATION FOUNDATION",
"NATIONAL INST OF SMALL IND EXE TRG",
"NATIONAL INST OF TECHNICAL TEACHERS",
"NATIONAL INSTITUTE FOR MICRO SMALL AND MEDIUM ENTERPRISE",
"NATIONAL INSTITUTE FOR RESEARCH IN TUBERCULOSIS",
"NATIONAL INSTITUTE FOR SMART GOVERNMENT",
"NATIONAL INSTITUTE FOR THE EMPOWERMENT OF PERSONS",
"NATIONAL INSTITUTE OF BIOLOGICALS",
"NATIONAL INSTITUTE OF CONSTRUCTION MANAGEMENT AND RESEARCH",
"NATIONAL INSTITUTE OF DESIGN",
"NATIONAL INSTITUTE OF ELECTRONICS & INFORMATION TECHNOLOGY",
"NATIONAL INSTITUTE OF EPIDEMIOLOGY",
"NATIONAL INSTITUTE OF FASHION TECHNOLOGY",
"NATIONAL INSTITUTE OF FINANCILA MANAGEMENT",
"NATIONAL INSTITUTE OF HYDROLOGY",
"NATIONAL INSTITUTE OF IMMUNOLOZY",
"NATIONAL INSTITUTE OF INDUSTRIAL ENGINEERING",
"NATIONAL INSTITUTE OF MENTAL HEALTH AND NEURO SCIENCE NIMHANS",
"NATIONAL INSTITUTE OF NATURAL FIBRE ENGINEERING & TECHNOLOGY",
"NATIONAL INSTITUTE OF NUTRITION",
"NATIONAL INSTITUTE OF OCEAN TECHNOLOGY",
"NATIONAL INSTITUTE OF OPHTHALMOLOGY",
"NATIONAL INSTITUTE OF PATHOLGY",
"NATIONAL INSTITUTE OF POST HARVEST TECHNOLOGY",
"NATIONAL INSTITUTE OF PUBLIC HEALTH TRAINING AND RESEARCH",
"NATIONAL INSTITUTE OF RURAL DEVELOPMENT & PANCHAYATI RAJ",
"NATIONAL INSTITUTE OF SOLAR ENERGY",
"NATIONAL INSTITUTE OF TECHNOLOGY",
"NATIONAL INSTITUTE OF TUBERCULOSIS AND RESPIRATORY DISEASES",
"NATIONAL INSTITUTE OF UNANI MEDICINE",
"NATIONAL INSTRUCTIONAL MEDIA INSTITUTE",
"NATIONAL INSTRUMENTS",
"NATIONAL INSURANCE COMPANY LIMITED",
"NATIONAL INVESTMENT AND INFRASTRUCTURE FUND INDIA",
"NATIONAL INVESTMENT AND INFRASTRUCTURE FUND TRUSTEE LIMITED",
"NATIONAL ISPAT & POWER PRIVATE LIMITED",
"NATIONAL JUDICIAL ACADEMY",
"NATIONAL JUTE MANUFACTURERS CORPORA",
"NATIONAL JUTE MANUFACTURES CORPRATION LIMITED",
"NATIONAL LABOUR COOPERATIVES FEDERATION OF INDIA LIMITED",
"NATIONAL LAW UNIVERSITY DELHI",
"NATIONAL LAW UNIVERSITY JODHPUR",
"NATIONAL MARATHI PRIMARY SCHOOL NALDURG",
"NATIONAL MARINE AND INFRASTRUCTURE INDIA PRIVATE LIMITED",
"NATIONAL MATRICULATION HIGHER SECONDARY SCHOOL",
"NATIONAL MERCANTILE CO-OPERATIVE BANK LIMITED",
"NATIONAL METALLURGICAL",
"NATIONAL METALLURGICAL LABORATORY",
"NATIONAL MINORITIES DEVELOPMENT AND FINANCE CORPORATION",
"NATIONAL MULTI-COMMODITY EXCHANGE OF INDIA LIMITED",
"NATIONAL OILWELL VARCO INC.",
"NATIONAL OXYGEN LIMITED",
"NATIONAL PAINTS FACTORIES INDIA PRIVATE LIMITED",
"NATIONAL PAYMENTS CORPORATION OF INDIA",
"NATIONAL PEROXIDE LIMITED",
"NATIONAL PHARMACY COLLEGE",
"NATIONAL PLASTIC HOUSEHOLD PRODUCTS PRIVATE LIMITED",
"NATIONAL PLASTIC INDUSTRIES LIMITED",
"NATIONAL PLASTIC TECHNOLOGIES LIMITED",
"NATIONAL PLASTO CONTAINERS PRIVATE LIMITED",
"NATIONAL PLASTO PRODUCTS PRIVATE LIMITED",
"NATIONAL POLY YARN PRIVATE LIMITED",
"NATIONAL POLYPLAST INDIA PRIVATE LIMITED",
"NATIONAL POWER TRAINING INSTITUTE",
"NATIONAL PROCESS PVT LTD",
"NATIONAL PRODUCTIVITY COUNCIL",
"NATIONAL PROJECTS CONSTRUCTION CORPORATION LIMITED",
"NATIONAL PUBLIC SCHOOL",
"NATIONAL RESEARCH CENTRE IN CAMEL NRCC",
"NATIONAL RESEARCH CENTRE ON SEED SPICES",
"NATIONAL SAFAI KARAMCHARIS FINANCE AND DEVELOPMEN CRPN (U S 25)",
"NATIONAL SAMPLE SURVEY OFFICE",
"NATIONAL SAMPLE SURVEY OFFICE SURVEY DESIGN AND RESEARCH DIVISION KOLKATA",
"NATIONAL SANSKRIT UNIVERSITY",
"NATIONAL SAVINGS ORGANISATION",
"NATIONAL SCHEDULED CASTES FINANCE AND DEVELOPMENT CORPORATION",
"NATIONAL SCHEDULED TRIBES FINANCE AND DEVELOPMENT CORPORATION",
"NATIONAL SCHEDULED TRIBES FINANCE AND DEVELOPMENT CORPORATION CO U S 25",
"NATIONAL SCHOOL OF DRAMA BAHAWALPUR HOUSE",
"NATIONAL SECURITIES DEPOSITORY LIMITED",
"NATIONAL SECURITY COUNCIL SECRETERIAT",
"NATIONAL SECURITY GUARD",
"NATIONAL SEEDS CORPORATION LIMITED",
"NATIONAL SERVICE SCHEME",
"NATIONAL SKILL DEVELOPMENT CORPORATION",
"NATIONAL SOLAR ENERGY FEDRARTION OF INDIA",
"NATIONAL SPOT EXCHANGE LIMITED",
"NATIONAL STARCH INDUSTRIES PRIVATE LIMITED",
"NATIONAL STATISTICAL OFFICE FOD",
"NATIONAL STEEL AND AGRO INDUSTRIES LIMITED",
"NATIONAL STOCK EXCHANGE OF INDIA LIMITED",
"NATIONAL SUGAR INSTITUTE",
"NATIONAL TB ELIMINATION PROGRAM",
"NATIONAL TECHNICAL RESEARCH ORGANISATION",
"NATIONAL TEST HOUSE WR MUMBAI",
"NATIONAL TESTING LABORATORY PRIVATE LIMITED",
"NATIONAL TEXTILE CORPN LIMITED",
"NATIONAL TRUST HOUSING FINANCE LIMITED",
"NATIONAL TUBERCULOSIS ELIMINATION PROGRAMME",
"NATIONAL URDU PRIMARY SCHOOL BEED",
"NATIONAL URDU PRIMARY SCHOOL CHOPDA",
"NATIONAL VENTURES PRIVATE LIMITED",
"NATIONAL VICTOR PUBLIC SCHOOL",
"NATIONAL VOCATIONAL TRAINING INSTITUTE F",
"NATIONAL WATER DEV AGENCY",
"NATIONAL WESTMINSTER BANK",
"NATIONAL WIRE HEALD WORKS PRIVATE LIMITED",
"NATIONWIDE IMMIGRATION SERVICES PRIVATE LIMITED",
"NATIONWIDE MUTUAL INSURANCE CO.",
"NATIONWIDE PRIMARY HELTHCARE SERVICE P L",
"NATIONWIDE SHIPPING SERVICES LIMITED",
"NATIVE BUILDCON PRIVATE LIMITED",
"NATIVE NINJA LOCALISATION SERVICES PRIVATE LIMITED",
"NATIVE NINJA MEDIA SERVICES LLP",
"NATIVE SPECIAL PRODUCTS PRIVATE LIMITED",
"NATIVE STAINLESS PRIVATE LIMITED",
"NATIXIS GLOBAL SERVICES (INDIA) PRIVATE LIMITED",
"NATLIFE BEVERAGES INDIA PRIVATE LIMITED",
"NATOBOTICS TECHNOLOGIES PRIVATE LIMITED",
"NATRAJ AND SIDDHARTH METACARE PRIVATE LIMITED",
"NATRAJ COTTON PRIVATE LIMITED",
"NATRAJ DEVELOPERS PRIVATE LIMITED",
"NATRAJ DRUM INDUSTRIES PRIVATE LIMITED",
"NATRAJ ELECTRO CASTING PRIVATE LIMITED",
"NATRAJ ENGINEERS PRIVATE LIMITED",
"NATRAJ FOREX PRIVATE LIMITED",
"NATRAJ GROUP PROTECTION PRIVATE LIMITED",
"NATRAJ HANDLOOMS PRIVATE LIMITED",
"NATRAJ INDUSTRIES",
"NATRAJ INFOTECH PRIVATE LIMITED",
"NATRAJ INFRATECH PRIVATE LIMITED",
"NATRAJ IRON & CASTINGS PRIVATE LIMITED",
"NATRAJ JEWELLERS PRIVATE LIMITED",
"NATRAJ MACHINERY PVT LTD",
"NATRAJ MOTELS PRIVATE LIMITED",
"NATRAJ MULTI-GASES PRIVATE LIMITED",
"NATRAJ PACKAGING PRIVATE LIMITED",
"NATRAJ POLYCHEM PRIVATE LIMITED",
"NATRAJ PROTEINS LIMITED.",
"NATRAJ RICE MILLS PRIVATE LIMITED",
"NATRAJ SHEET GRAH PRIVATE LIMITED",
"NATRAJ STATIONERY PRODUCTS PRIVATE LIMITED",
"NATRAJ TECHNOSOFT PRIVATE LIMITED",
"NATRAJ WOOLTEX LIMITED",
"NATRAJA NUTRIFEED PRIVATE LIMITED",
"NATRINAI TECHNOLOGIES PRIVATE LIMITED",
"NATRINAI VENTURES PRIVATE LIMITED",
"NATRIX SOFTWARE PRIVATE LIMITED",
"NATRIZEN CHEMICALS PRIVATE LIMITED",
"NATRON EQUIPMENT AND SPARES PRIVATE LIMITED",
"NATROYAL INDUSTRIES PRIVATE LIMITED",
"NATSON FOAM MANUFACTURERS PRIVATE LTD.",
"NATTER DIGITAL SOLUTIONS PRIVATE LIMITED",
"NATTIKA BEACH RESORTS PRIVATE LIMITED",
"NATTY SOLUTIONS PRIVATE LIMITED",
"NATU'OIL SERVICES (INDIA) PRIVATE LIMITED",
"NATUR TEC INDIA PRIVATE LIMITED",
"NATURA BIOSCIENCE INDUSTRIES PRIVATE LIMITED",
"NATURA BIOTECHNOL PRIVATE LIMITED",
"NATURA ECOENERGY PRIVATE LIMITED",
"NATURA GRANITES INDIA PRIVATE LIMITED",
"NATURA GREENTECH PRIVATE LIMITED",
"NATURA OUTDOOR EDU AND TRA SOLUTIONS P L",
"NATURAGREEN FOOD PRODUCTS PRIVATE LIMITED",
"NATURAL AEROGAS PRIVATE LIMITED",
"NATURAL AGRITECH PRIVATE LIMITED",
"NATURAL AGROCOM INDIA PRIVATE LIMITED",
"NATURAL ALUMINIUM PRIVATE LIMITED",
"NATURAL AND ESSENTIAL OILS PRIVATE LIMITED",
"NATURAL AROMA PRODUCTS PRIVATE LIMITED",
"NATURAL BATH & BODY PRODUCTS PRIVATE LIMITED",
"NATURAL BAZAR CONSUMERS STORES LIMITED",
"NATURAL BEVERAGES",
"NATURAL BIOCON (INDIA) LIMITED",
"NATURAL BOX RETAIL PRIVATE LIMITED",
"NATURAL CAPSULES LIMITED",
"NATURAL CATTLE FEED PRIVATE LIMITED",
"NATURAL CEMENTS PRIVATE LIMITED",
"NATURAL CONSUMERCARE MARKETING PRIVATE LIMITED",
"NATURAL COTTON SPINNERS PRIVATE LIMITED",
"NATURAL CRAFTWOODS PRIVATE LIMITED",
"NATURAL CROP SOLUTIONS PRIVATE LIMITED",
"NATURAL DEHYDRATED VEGETABLES PRIVATE LIMITED",
"NATURAL FRUITS PRIVATE LIMITED",
"NATURAL GOLD PULSE AND FLOUR MILL",
"NATURAL GROWERS PRIVATE LIMITED",
"NATURAL HERBS AND FORMULATION PRIVATE LIMITED",
"NATURAL ICECREAM PVT LTD",
"NATURAL LIFESTYLE PRODUCTS PRIVATE LIMITED",
"NATURAL LIVING PRIVATE LIMITED",
"NATURAL MARBLES PRIVATE LIMITED",
"NATURAL ODOURS AND POLYMERS PRIVATE LIMITED",
"NATURAL PETRO PRODUCTS PRIVATE LIMITED",
"NATURAL PETROCHEMICALS PRIVATE LIMITED",
"NATURAL PLANT PROTECTION LIMITED",
"NATURAL PRODUCT EXPORT CORPORATION LIMITED",
"NATURAL PROJECTS PRIVATE LIMITED",
"NATURAL REAL VENTURES PRIVATE LIMITED",
"NATURAL REMEDIES PRIVATE LIMITED",
"NATURAL RESOURCE BIOCHEM PRIVATE LIMITED",
"NATURAL SOFTWARES PVT. LTD",
"NATURAL STONE IMPRESSIONS PRIVATE LIMITED",
"NATURAL STONEAGE PRIVATE LIMITED",
"NATURAL STORAGE SOLUTIONS PRIVATE LIMITED",
"NATURAL SUGAR AND ALLIED INDUSTRIES LIMITED",
"NATURAL TEX YARN PRIVATE LIMITED",
"NATURAL TIE UP PRIVATYE LIMITED",
"NATURAL WOOD AND VENEERS PRIVATE LIMITED",
"NATURAL WOOLS LAB PRIVATE LIMITED",
"NATURALISM FOOD LABS PRIVATE LIMITED",
"NATURALS DAIRY PRIVATE LIMITED",
"NATURAPURE FOODS PRIVATE LIMITED",
"NATURASIA INGREDIENTS PRIVATE LIMITED",
"NATURAYUVA INDIA PRIVATE LIMITED",
"NATURE AGRO COMPLEX PRIVATE LIMITED",
"NATURE AND WASTE MANAGEMENT INDIA PRIVATE LIMITED",
"NATURE BIO-FOODS LIMITED",
"NATURE BITE FOODS PRIVATE LIMITED",
"NATURE BORN PROJECTS PRIVATE LIMITED",
"NATURE CARE CARTONS PRIVATE LIMITED",
"NATURE CLEAN ENVIRO SERVICES PRIVATE LIMITED",
"NATURE CONSERVANCY INDIA SOLUTIONS PRIVATE LIMITED",
"NATURE CREATION INFRATECH (INDIA) PRIVATE LIMITED",
"NATURE DECOR TEXTILES PRIVATE LIMITED",
"NATURE DELIGHT DAIRY & DAIRY PRODUCTS PRIVATE LIMITED",
"NATURE FEEDS LIMITED",
"NATURE FRESH ORGANIC FOOD I PRIVATE LIMITED",
"NATURE GREEN ENERGY PRIVATE LIMITED (OPC)",
"NATURE GREEN TOOLS & MACHINES PRIVATE LIMITED",
"NATURE HEALTH FARMS PRIVATE LIMITED",
"NATURE HYBRID SEEDS PRIVATE LIMITED",
"NATURE INTERNATIONAL PRIVATE LIMITED",
"NATURE LUBE PRIVATE LIMITED",
"NATURE MARKETING PRIVATE LIMITED",
"NATURE MILLS PRIVATE LIMITED",
"NATURE MORTE ART LIMITED",
"NATURE MORTE EXIM PRIVATE LIMITED",
"NATURE NAO PRIVATE LIMITED",
"NATURE OILS & GRAINS INDIA PRIVATE LIMITED",
"NATURE ONE FRESH PRODUCE PRIVATE LIMITED",
"NATURE PEARLS PRIVATE LIMITED",
"NATURE PULSE BOTANICALS PRIVATE LIMITED",
"NATURE PURE SUPERCRITICAL EXTRACTS PRIVATE LIMITED",
"NATURE PURE WELLNESS PRIVATE LIMITED",
"NATURE RESORTS AND SPA INDIA PRIVATE LIMITED",
"NATURE S GRACE INTERNATIONAL PRIVATE LIMITED",
"NATURE TECH ENVIRO PROTECTION LIMITED",
"NATURE TECHNOLOGIES PRIVATE LIMITED",
"NATURE TRAILS RESORTS PRIVATE LIMITED",
"NATURECARE FERTILIZERS PRIVATE LIMITED",
"NATUREDGE BEVERAGES PRIVATE LIMITED",
"NATUREFRESH INDUSTRIES LIMITED",
"NATUREGEN TECHNOLOGIES PRIVATE LIMITED",
"NATURELAND ORGANIC FOODS PRIVATE LIMITED",
"NATURELL INDIA PRIVATE LIMITED",
"NATURENCE RESEARCH LABS PRIVATE LIMITED",
"NATURENURTURE EDUSERV PRIVATE LIMITED",
"NATURENURTURE SOLUTIONS PRIVATE LIMITED",
"NATURES BASKET LIMITED",
"NATURES BOUNTY WINES AND ALLIED PRODUCTS PRIVATE LIMITED",
"NATURES CHOICE FOOD PRIVATE LIMITED",
"NATURES COIR PRIVATE LIMITED",
"NATURE'S FIRST INDIA PRIVATE LIMITED",
"NATURES FRESH ENTERPRISES PRIVATE LIMITED",
"NATURES MIST INTERNATIONAL PRIVATE LIMITED",
"NATURES NATURAL INDIA OILS PRIVATE LIMITED",
"NATURES ORGANIC PRODUCTS (SARISKA) PRIVATE LIMITED",
"NATURES ORGANICS",
"NATURE'S TREAT FOODS PRIVATE LIMITED",
"NATURETECH INFRASTRUCTURE PRIVATE LIMITED",
"NATURE-TECH INGREDIENTS PRIVATE LIMITED",
"NATUREVOLT RECYCLERS INDIA PRIVATE LIMITED",
"NATUREWORX BIOPRODUCTS PRIVATE LIMITED",
"NATURIS COSMETICS PRIVATE LIMITED",
"NATURISE CONSUMER PRODUCTS PRIVATE LIMITED",
"NATURITE AGRO PRODUCTS LIMITED",
"NATURLAND SECURITIES PRIVATE LIMITED",
"NATURO FOOD AND FRUIT PRODUCTS PRIVATE LIMITED",
"NATURO INDIABULL LIMITED",
"NATURO SEEDTECH PRIVATE LIMITED",
"NATUROIL AROMATICS PRIVATE LIMITED",
"NATUROMA AGRI COMMODITIES PRIVATE LIMITED",
"NATUROMA HERBALS PRIVATE LIMITED",
"NATUROPATHY HOSPITAL",
"NATURRALIS FOOD PROCESSING PRIVATE LIMITED",
"NATVAR COTEX PRIVATE LIMITED",
"NATVAR IRON AND STEEL WORKS PRIVATE LIMITED",
"NATVAR PARIKH INDUSTRIES PRIVATE LIMITED",
"NATVAR PROPERTIES PRIVATE LIMITED",
"NATVERLAL AND SONS STOCKBROKERS PRIVATE LIMITED",
"NATWEST DIGITAL SERVICES INDIA PRIVATE LIMITED",
"NATWEST FINANCE PRIVATE LIMITED",
"NATWOOD FURNITURE PRIVATE LIMITED",
"NAUGE PHARMACEUTICALS PVT LTD",
"NAUGHTY FOODS PRIVATE LIMITED",
"NAUGHTY NINOS PRIVATE LIMITED",
"NAUKHAL INVESTMENT PRIVATE LTD",
"NAUKRI INTERNET SERVICES LIMITED",
"NAUNARAYANI POLYMERS PRIVATE LIMITED",
"NAUNIDH ENTERPRISES PRIVATE LIMITED",
"NAUNIDH FOODS PRIVATE LIMITED",
"NAURASFRESH CONSUMER INDIA PRIVATE LIMITED",
"NAUTANKI FILMS PRIVATE LIMITED",
"NAUTEX MARITIME PRIVATE LIMITED",
"NAUTICAL CONTAINER LINE PRIVATE LIMITED",
"NAUTICAL LINES PRIVATE LIMITED",
"NAUTICAL MARINE MANAGEMENT SERVICES PRIVATE LIMITED",
"NAUTICSIT CYBERTECH INDIA PRIVATE LIMITED",
"NAUTILUS MOBILE APP PRIVATE LIMITED",
"NAUTILUS SHIPPING INDIA PRIVATE LIMITED",
"NAUTIYAL INFRACON PRIVATE LIMITED",
"NAUVATA ENERGY TRANSITION ENTERPRISE PRIVATE LIMITED",
"NAV AGRO PRIVATE LIMITED",
"NAV BHARAT CLEARING AGENTS PRIVATE LIMITED",
"NAV BHARAT ENGINEERING INDUSTRIES PRIVATE LIMITED",
"NAV BHARAT METALIC OXIDE INDUSTRIES PRIVATE LIMITED",
"NAV BHARAT RICE & GENERAL MILLS",
"NAV BHARAT ROLLER FLOUR MILLS PVT LTD",
"NAV BHARAT TRADEX PRIVATE LIMITED",
"NAV BHARATI CHEMICALS PRIVATE LIMITED",
"NAV BHARTI SEVA SAMITI",
"NAV CHETNA AGRO CENTER PRODUCER COMPANY LIMITED",
"NAV DEVELOPERS LIMITED",
"NAV DURGA AGROTECH PRIVATE LIMITED",
"NAV DURGA AVIATION PRIVATE LIMITED",
"NAV DURGA CHROMATICS PVT LTD",
"NAV DURGA CREATION PVT LTD",
"NAV DURGA ENCLAVE PRIVATE LIMITED",
"NAV DURGA FUEL PRIVATE LIMITED",
"NAV DURGA LOGISTICS PRIVATE LIMITED",
"NAV DURGA POLY CREATION PRIVATE LIMITED",
"NAV DURGA POLYFAB PRIVATE LIMITED",
"NAV DURGA RMC",
"NAV JEEVAN FIBER GLASS PRIVATE LIMITED",
"NAV JEWELS PRIVATE LIMITED",
"NAV JOYTI EPROBUILD PRIVATE LIMITED",
"NAV JYOTI MIDDLE SCHOOL NINDANA KHAS ROHTAK",
"NAV LABELS PRIVATE LIMITED",
"NAV LAXMI VIKAS PRIVATE LIMITED",
"NAV MAHARASHTRA VIDYALAYA KHARABAVADI",
"NAV MEET CARGO PRIVATE LIMITED",
"NAV NIDHAN ORGANICS PRIVATE LIMITED",
"NAV NIDHI DYEING AND PRINTING MILLS PRIVATE LIMITED",
"NAV NIRMAN FORMWORK SYSTEMS PRIVATE LIMITED",
"NAV NIRMAN SEWA SAMITI",
"NAV RECORDS PRIVATE LIMITED",
"NAV SANKALP AGRO SOLUTIONS PRIVATE LIMITED",
"NAV SHAKTI INFRAREALTORS PRIVATE LIMITED",
"NAV SHAKTI TEXTILE PROCESSOR PVT LTD",
"NAV SHIKHA POLYPACK INDUSTRIES PRIVATE LIMITED",
"NAV SOLAR POWER PRIVATE LIMITED",
"NAV TECH ELECTRONICS INDIA PRIVATE LIMITED",
"NAV TECHNOCRATS PRIVATE LIMITED",
"NAV VIKAS COATERS PRIVATE LIMITED",
"NAV2DX MEDICARE PRIVATE LIMITED",
"NAVA BHARAT ENERGY INDIA LIMITED,",
"NAVA BHARAT PRESS (BHOPAL) PVT LTD",
"NAVA BHARAT PRESS LIMITED",
"NAVA BHARAT PROJECTS LIMITED",
"NAVA BHARATH FERTILIZERS LIMITED",
"NAVA BHARATH NATIONAL SCHOOL",
"NAVA HEALTHCARE PRIVATE LIMITED",
"NAVA JEEVAN MEDICAL FOUNDATIONS PRIVATE LIMITED",
"NAVA JYOTHI SHELTERS PRIVATE LIMITED",
"NAVA LIMITED\n",
"NAVA NIDHI BUILDTECH PRIVATE LIMITED",
"NAVA NIRMAN FABRICATION PRIVATE LIMITED",
"NAVA PIPLIYA PRASHALA",
"NAVA VIGNANA BHARATHI JUNIOR COLLEGE",
"NAVABHARAT INFRAVENTURES PRIVATE LIMITED",
"NAVABHARAT LIMITED",
"NAVABHARAT NEWS MEDIA PRIVATE LIMITED",
"NAVABHARATH PACKAGING PRIVATE LIMITED",
"NAVABRIND IT SOLUTIONS PRIVATE LIMITED",
"NAVACHETANA ENTERPRISES HAVERI PRIVATE LIMITED",
"NAVACHETANA MICROFIN SERVICES PRIVATE LIMITED",
"NAVACHETHANA CHITS COMPANY PRIVATE LIMITED",
"NAVACHETHANA HOSPITAL",
"NAVADHANE AGRO FOODS PRIVATE LIMITED",
"NAVADHIRA EDUCATIONAL FOUNDATION",
"NAVADHITI BUSINESS CONSULTANCY SERVICES PRIVATE LIMITED",
"NAVADURGA ENTERPRISES PRIVATE LIMITED",
"NAVAERA SOFTWARE SERVICES PRIVATE LIMITE D",
"NAVAGEN PRODUCTS PRIVATE LIMITED",
"NAVAGRAHA PRINT & PACK COMPANY PRIVATE LIMITED",
"NAVAID ENERGY PRIVATE LIMITED",
"NAVAIR INTERNATIONAL PRIVATE LIMITED",
"NAVAJAT PRINTERS & MEDIA PRIVATE LIMITED",
"NAVAJNA TECHNOLOGIES PRIVATE LIMITED",
"NAVAJYOTI PRINTING PRESS PRIVATE LIMITED",
"NAVAKAR TRADING COMPANY PRIVATE LIMITED",
"NAVAKERALAM FOOTWEAR PRIVATE LIMITED",
"NAVAL ARMAMENT DEPT",
"NAVAL AUTO INDUSTRIES PRIVATE LIMITED",
"NAVAL DOCKYARD",
"NAVAL EXPORTERS AND IMPORTERS PRIVATE LIMITED",
"NAVAL GROUP INDIA PRIVATE LIMITED",
"NAVAL MARBLES PRIVATE LIMITED",
"NAVAL MARMO PRIVATE LIMITED",
"NAVAL OFFICER IN CHARGE (WEST BENGAL) KOLKATA",
"NAVAL PAY OFFICE",
"NAVAL PHYSICAL AND OCEANOGRAPHIC LABORATORY",
"NAVAL SCIENCE AND TECHNOLOGICAL LAB",
"NAVAL SILK MILLS PVT LTD",
"NAVAL STONES PRIVATE LIMITED",
"NAVALADI TRADE LINKS PRIVATE LIMITED",
"NAVALE PUNDALIKAPPA COLD STORAGE PRIVATE LIMITED",
"NAVALE SPEECH V HEARING CLINIC",
"NAVALIKA CHIT FUNDS PRIVATE LIMITED",
"NAVAL'S NATIONAL ACADEMY",
"NAVALT SOLAR & ELECTRIC BOATS PRIVATE LIMITED",
"NAVAMI ENGINEERING PRIVATE LIMITED",
"NAVAMI INDUSTRIES PRIVATE LIMITED",
"NAVAMI PLAZA PRIVATE LIMITED",
"NAVAMI SHIPPING SERVICE PRIVATE LIMITED",
"NAVANAAMI PROJECTS PRIVATE LIMITED",
"NAVANATH SALES PRIVATE LIMITED",
"NAVANI MEDITEX PRIVATE LIMITED",
"NAVANT INFOTECH PRIVATE LIMITED",
"NAVANTUC TREXIM PVT.LTD.",
"NAVAPRAJNA PUBLIC SCHOOL",
"NAVARANG FOREX PRIVATE LIMITED",
"NAVARATAN CONSTRUCTION & INVESTMENT PRIVATE LIMITED",
"NAVARATAN PROPERTY HOLDINGS PRIVATE LIMITED",
"NAVARATAN TECHNOLOGIES PRIVATE LIMITED",
"NAVARATHNA HOUSING FINANCE LIMITED",
"NAVARATNA MULTI-BOOKS PRIVATE LIMITED",
"NAVARATNAA CROPSCIENCE PRIVATE LIMITED",
"NAVARUN COMPONENTS PRIVATE LIMITED",
"NAVASASYAM DANDEKAR PRIVATE LIMITED",
"NAVASHAKTHI NETHRALAYA PRIVATE LIMITED",
"NAVASHYA CONSUMER PRODUCTS PRIVATE LIMITED",
"NAVATA TRANSPORT PRIVATE LIMITED",
"NAVATAR CONSULTING PRIVATE LIMITED",
"NAVATELANGANA PRINTERS PRIVATE LIMITED",
"NAVAVYA EKNATH INDIA PRIVATE LIMITED",
"NAVAYUG INDIA FACILITY MANAGEMENT PRIVATE LIMITED",
"NAVAYUG LABOUR CONTRACTORS PRIVATE LIMITED",
"NAVAYUGA ENGINEERING COMPANY LIMITED",
"NAVAYUGA EXPORTS LTD",
"NAVAYUGA INFRA PROJECTS PRIVATE LIMITED",
"NAVAYUGA ROAD PROJECTS PRIVATE LIMITED",
"NAVAYUGA SEEDS PRIVATE LIMITED",
"NAVAYUGA UDUPI TOLLWAY PRIVATE LIMITED",
"NAVAYUGA WORLD SCHOOL",
"NAVAYUVA PREFAB PRIVATE LIMITED",
"NAVBHARAT ARCHIVE XPRESS PRIVATE LIMITED",
"NAVBHARAT BUILDCON PRIVATE LIMITED",
"NAVBHARAT CONSOLIDATION PRIVATE LIMITED",
"NAVBHARAT DWELLINGS PRIVATE LIMITED",
"NAVBHARAT ENGICON PRIVATE LIMITED",
"NAVBHARAT ESTATE DEVELOPMENTS PRIVATE LIMITED",
"NAVBHARAT GLOBAL SERVICES PRIVATE LIMITED",
"NAVBHARAT IRON CONCAST PRIVATE LIMITED",
"NAVBHARAT METAL CONTAINERS PRIVATE LIMITED",
"NAVBHARAT NIRMAN COMPANY",
"NAVBHARAT NUTAN VIDYALAY",
"NAVBHARAT NUTUN VIDYALAYA",
"NAVBHARAT PACKAGING INDUSTRIES PRIVATE LIMITED",
"NAVBHARAT POLYWEAVES PRIVATE LIMITED",
"NAVBHARAT POTTERIES PRIVATE LIMITED",
"NAVBHARAT POWER INFRA PROJECTS PRIVATE LIMITED",
"NAVBHARAT SEEDS PVT LTD",
"NAVBHARAT SHIPPING (INDIA) LIMITED",
"NAVBHARAT TEA PROCESSING PRIVATE LIMITED",
"NAVBHARAT TUBES PRIVATE LIMITED",
"NAVBHARAT WATER PRIVATE LIMITED",
"NAVBHARTI BUILDERS (INDIA) PRIVATE LIMITED",
"NAVBIZ SOLUTIONS PRIVATE LIMITED",
"NAVDANYA FOODS PRIVATE LIMITED",
"NAVDANYA NATURAL PRODUCTS PRIVATE LIMITED",
"NAVDEEP AUTOCOPS PRIVATE LIMITED",
"NAVDEEP CHEMICALS PRIVATE LIMITED",
"NAVDEEP CONSTRUCTION COMPANY",
"NAVDEEP INVESTMENT PRIVATE LIMITED",
"NAVDEEP JEWELLERS PRIVATE LIMITED",
"NAVDEEP MOTORS",
"NAVDEEP PUBLICATIONS",
"NAVDEEP REAL ESTATE PRIVATE LIMITED",
"NAVDEEP SHIPPING PRIVATE LIMITED",
"NAVDEEP STEEL PRIVATE LIMITED",
"NAVDEEP TEKNIKS PRIVATE LIMITED",
"NAVDEEP THEATRES PVT LTD",
"NAVDEEP TOOLS PRIVATE LIMITED",
"NAVDEEP VALVES AND TUBES PVT LTD",
"NAVDHA ADVISORY (OPC) PRIVATE LIMITED",
"NAVDIGI SOLUTIONS PRIVATE LIMITED",
"NAVDIP FORGE PRIVATE LIMITED",
"NAVDRISHTI EDUCATIONAL TRUST",
"NAVDURGA BUILDCON PRIVATE LIMITED",
"NAVDURGA ELECTROCONSTRUCTION PRIVATE LIMITED",
"NAVDURGA FOREX PRIVATE LIMITED",
"NAVDURGA INFRAVENTURES LIMITED",
"NAVDURGA INVESTMENTS PRIVATE LIMITED",
"NAVDURGA ISPAT PRIVATE LIMITED",
"NAVDURGA METALS PRIVATE LIMITED",
"NAVDURGA PAPAD PRIVATE LIMITED",
"NAVDURGA PULP AND PAPER MILLS INDIA PRIVATELIMITED",
"NAVDURGA ROADLINES",
"NAVDURGA SALES PRIVATE LIMITED",
"NAVDURGA STEEL CASTING PRIVATE LIMITED",
"NAVDURGA WIRES PRIVATE LIMITED",
"NAVDURGAA SAREE PRIVATE LIMITED",
"NAVED INVESTMENT AND TRADING CO PVT LTD",
"NAVEDAS TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"NAVEEN ADVERTISEMENTS PRIVATE LIMITED",
"NAVEEN AIR TRAVELS PRIVATE LIMITED",
"NAVEEN BHARAT FURNISHING PRIVATE LIMITED",
"NAVEEN BISCUITS PRIVATE LIMITED",
"NAVEEN COTTON MILL PRIVATE LIMITED",
"NAVEEN ENTERPRISES PRIVATE LIMITED",
"NAVEEN EXPORTS PVT LTD",
"NAVEEN FILTERS PRIVATE LIMITED",
"NAVEEN FURNITURES PRIVATE LIMITED",
"NAVEEN GRAPHICS PRIVATE LIMITED",
"NAVEEN HARIT SHAKTI INDIA PRIVATE LIMITED",
"NAVEEN HOTELS PRIVATE LIMITED",
"NAVEEN INFRADEVELOPERS AND ENGINEERS PRIVATE LIMITED",
"NAVEEN JEWELLERS PRIVATE LIMITED",
"NAVEEN KUMAR MANAGEMENT SERVICES PRIVATELIMITED",
"NAVEEN MECHANICAL WORKS PRIVATE LIMITED",
"NAVEEN MERICO ENGINEERING CO. PRIVATE LIMITED",
"NAVEEN OIL CARRIER PRIVATE LIMITED",
"NAVEEN POULTRY FARMS PRIVATE LIMITED",
"NAVEEN PRINTS PRIVATE LIMITED",
"NAVEEN RICE MILLS",
"NAVEEN SURGICAL PVT LTD",
"NAVEEN TIMBER PRIVATE LIMITED..",
"NAVEEN TRAVELS PRIVATE LIMITED",
"NAVEENA QUALITY FOODS PRIVATE LIMITED",
"NAVEENA VIDYA NIKETHAN HIGH SCHOOL",
"NAVEENAM TECH PRIVATE LIMITED",
"NAVERIYA GAS PRIVATE LIMITED",
"NAVGAN SIKSHAN SANSTHA RAJURI JAHAGRMOHA HIGHSCHOOL",
"NAVGRAH FASTNERS PRIVATE LIMITED",
"NAVGRAHA WAREHOUSING AND MINERALS PRIVATE LIMITED",
"NAVGRAHAA JEWELS PRIVATE LIMITED",
"NAVGRIH BUILDWELL PRIVATE LIMITED",
"NAVGYAN CIVILTECH SERVICES PRIVATE LIMITED",
"NAVHAL PAINTS PRIVATE LIMITED",
"NAVHARI FOOD PRODUCTS PRIVATE LIMITED",
"NAVI AMC LIMITED",
"NAVI FINSERV LIMITED",
"NAVI MUMBAI INTERNATIONAL AIRPORT PRIVATE LIMITED",
"NAVI MUMBAI MUNICIPAL TRANSPORT",
"NAVI MUMBAI SEZ PRIVATE LIMITED",
"NAVI MUMBAI SMART CITY INFRASTRUCTURE LIMITED",
"NAVI POWEROL PRIVATE LIMITED",
"NAVIA LIFE CARE PRIVATE LIMITED",
"NAVIA MARKETS LIMITED",
"NAVIC OIL & FOOD INDUSTRIES PRIVATE LIMITED",
"NAVICARE PHARMA PRIVATE LIMITED",
"NAVICOM SYNERGIES PRIVATE LIMITED",
"NAVICOM TECHNOLOGY INTERNATIONAL PRIVATE LIMITED",
"NAVIDIUM INDIA PRIVATE LIMITED",
"NAVIG8 INDIA PRIVATE LIMITED",
"NAVIG8 SHIPMANAGEMENT PTE LIMITED",
"NAVIGANT CORPORATE ADVISORS LIMITED",
"NAVIGANT TECHNOLOGIES PRIVATE LIMITED",
"NAVIGATE CONSULTING BUSINESS SOLUTIONS INDIA PRIVATE LIMITED",
"NAVIGATO PRIVATE LIMITED",
"NAVIGATOR SOURCING SERVICES INDIA PRIVATE LIMITED",
"NAVIGATOR SYSTEMS PRIVATE LIMITED",
"NAVIGATORS LOGISTICS COMPANY PRIVATE LIMITED",
"NAVIGATORS OVERSEAS SOLUTIONS PRIVATE LIMITED",
"NAVIGATORS SOFTWARE PRIVATE LIMITED",
"NAVIGATORS VISA GLOBAL LOGISTICS LIMITED",
"NAVIGAZIONE MONTANARI IMS SHIP MANAGEMENT INDIA PRIVATE LIMITED",
"NAVIGEM DATA PRIVATE LIMITED",
"NAVIKAH TOREDOH PRIVATE LIMITED",
"NAVIKENZ INDIA PRIVATE LIMITED",
"NAVILAN MERCHANTS PVT. LTD.",
"NAVIN COLD STORAGE PVT LTD",
"NAVIN DRILLING FLUIDS AND MINERALS PRIVATE LIMITED",
"NAVIN FLUORINE ADVANCED SCIENCES LIMITED",
"NAVIN FLUORINE INTERNATIONAL LIMITED",
"NAVIN GINNING FACTORY",
"NAVIN HOSPITAL",
"NAVIN HOSPITALS PRIVATE LIMITED",
"NAVIN HOUSING AND PROPERTIES PRIVATE LIMITED",
"NAVIN INFRASOLUTIONS PRIVATE LIMITED",
"NAVIN JUTE PRIVATE LIMITED",
"NAVIN MARATHI SCHOOL AMALNER",
"NAVIN MATEL SLITTERS PRIVATE LIMITED",
"NAVIN MEDICARE PRIVATE LIMITED",
"NAVIN MEDITECH PRIVATE LIMITED",
"NAVIN SAXENA RESEARCH AND TECHNOLOGY PRIVATE LIMITED",
"NAVIN STEEL INDUSTRIES PRIVATE LIMITED",
"NAVIN SYNTEX PRIVATE LIMITED",
"NAVIN TEXTILE MARKETING PRIVATE LIMITED",
"NAVIN TRADELINK PRIVATE LIMITED",
"NAVIN UPCHAR SADAN PRIVATE LIMITED",
"NAVINBHAI CABLES PRIVATE LIMITED",
"NAVINCHANDRA & CO.",
"NAVINS TRUCKS PRIVATE LIMITED",
"NAVIN-VIKAS PRIVATE LIMITED",
"NAVIO SHIPPING PRIVATE LIMITED",
"NAVION ELECTRONICS PRIVATE LIMITED",
"NAVIPOINT HEALTH INDIA PRIVATE LIMITED",
"NAVIRUD ENTERPRISES PRIVATE LIMITED",
"NAVIS HUMAN RESOURCES PRIVATE LIMITED",
"NAVIS SOFTWARE INDIA PRIVATE LIMITED",
"NAVISION INDIA INFOTECH PRIVATE LIMITED",
"NAVISITE INDIA PRIVATE LIMITED",
"NAVISTAAR SOLUTIONS PRIVATE LIMITED",
"NAVISTAR INTERNATIONAL PRIVATE LIMITED",
"NAVITA SURESH SHELAR",
"NAVITAS ALPHA RENEWABLES PRIVATE LIMITED",
"NAVITAS ENTERPRISES PRIVATE LIMITED",
"NAVITAS GENSETS PRIVATE LIMITED",
"NAVITAS GREEN POWER (FUEL MANAGEMENT) PRIVATE LIMITED",
"NAVITAS GREEN SOLUTIONS PRIVATE LIMITED",
"NAVITAS LLP",
"NAVITASYS INDIA PRIVATE LIMITED",
"NAVITECH MANAGEMENT SERVICES PRIVATE LIMITED",
"NAVITEK LOGISTICS PRIVATE LIMITED",
"NAVITRANCE LOGISTICS INDIA PRIVATE LIMITED",
"NAVITUS CONTROLS & EQUIPMENT PRIVATE LIMITED",
"NAVJEET INDIA PRIVATE LIMITED",
"NAVJEEVAN CARE HOME (GUJARAT)PRIVATE LIMITED",
"NAVJEEVAN EQUITY BROKING PRIVATE LIMITED",
"NAVJEEVAN HATCHERIES PRIVATE LIMITED",
"NAVJEEVAN LIFECARE PRIVATE LIMITED",
"NAVJEEVAN NURSING HOME PVT LTD",
"NAVJEEVAN PEDIATRICS PRIVATE LIMITED",
"NAVJEEVAN PUBLICATIONS PRIVATE LIMITED",
"NAVJEEVAN SYNTHETICS PRIVATE LIMITED",
"NAVJEEVAN TRADE AND COMMODITIES PRIVATE LIMITED",
"NAVJEEVANHOSPITALS",
"NAVJIVAN AUTO SQUARE PRIVATE LIMITED",
"NAVJIVAN AUTOMOBILES PRIVATE LIMITED",
"NAVJIVAN AUTOMOTIVE",
"NAVJIVAN CARS PRIVATE LIMITED",
"NAVJIVAN COTTON INDUSTRIES",
"NAVJIVAN LUXURY CARS PRIVATE LIMITED",
"NAVJIVAN MINERALS AND MINES PRIVATE LIMITED",
"NAVJIVAN MOTORS PRIVATE LIMITED",
"NAVJIVAN MULTISPECIALITY HOSPITAL & RESEARCH CENTRE PRIVATE LIMITED",
"NAVJIVAN ORGANICS PVT LTD",
"NAVJIVAN POLYFAB PRIVATE LIMITED",
"NAVJIVAN ROLLER FLOUR AND PULSE MILLS PRIVATE LIMITED",
"NAVJIVAN VIDYALAYA HIGH SCHOOL",
"NAVJOT CEMENTS AND CONSTRUCTIONS PRIVATE LIMITED",
"NAVJOT EDUCATIONAL AND TRAINING PRIVATE LIMITED NIIT",
"NAVJOT FROZEN FOOD CARRIERS PRIVATE LIMITED",
"NAVJOT PRINTERS PRIVATE LIMITED",
"NAVJUT FASHIONS PRIVATE LIMITED",
"NAVJYOT CHEMICALS AND COMMODITIES PRIVATE LIMITED",
"NAVJYOT ENTERPRISES PRIVATE LIMITED",
"NAVJYOT IMPEX PRIVATE LIMITED",
"NAVJYOT INTERNATIONAL PRIVATE LIMITED",
"NAVJYOTI COMMODITY MANAGEMENT SERVICES LIMITED",
"NAVJYOTI GLOBAL SOLUTIONS PRIVATE LIMITED",
"NAVJYOTI INFRACON PRIVATE LIMITED",
"NAVKAAR ALUFORM SERVICES PRIVATE LIMITED",
"NAVKAAR FASHION PRIVATE LIMITED",
"NAVKAAR ISPAT LIMITED",
"NAVKAR ALLOY PRIVATE LIMITED",
"NAVKAR BRINKER INTERNATIONAL PRIVATE LIMITED",
"NAVKAR BUILDCON",
"NAVKAR COLD STORAGES PRIVATE LIMITED",
"NAVKAR CONSTECH PRIVATE LIMITED",
"NAVKAR CONTAINER LINE PRIVATE LIMITED",
"NAVKAR CORPORATION LIMITED",
"NAVKAR DIAMONDS PRIVATE LIMITED",
"NAVKAR DIGITAL INSTITUTE PRIVATE LIMITED",
"NAVKAR ESTATE & HOMES PRIVATE LIMITED",
"NAVKAR FABTEX PRIVATE LIMITED",
"NAVKAR FILTECH PRIVATE LIMITED",
"NAVKAR FITTINGS AND FORGINGS PRIVATE LIMITED",
"NAVKAR FOILS PRIVATE LIMITED",
"NAVKAR HOME PRIVATE LIMITED",
"NAVKAR HYBRID SEEDS PRIVATE LIMITED",
"NAVKAR INFOTECH PRIVATE LIMITED",
"NAVKAR INTERNATIONAL PVT LTD",
"NAVKAR IRON AND STEELS PRIVATE LIMITED",
"NAVKAR ISPAT PRIVATE LIMITED",
"NAVKAR LAMINATORS PRIVATE LIMITED",
"NAVKAR LOGISTICS PRIVATE LIMITED",
"NAVKAR METASTEELS PRIVATE LIMITED",
"NAVKAR MULTIVENTURES PRIVATE LIMITED",
"NAVKAR POLY FILMS PRIVATE LIMITED",
"NAVKAR PROTEINS PRIVATE LIMITED",
"NAVKAR PULSES PRIVATE LIMITED",
"NAVKAR RAYONS PRIVATE LIMITED",
"NAVKAR REALCON PRIVATE LIMITED",
"NAVKAR SHARE AND STOCK BROKERS PRIVATE LIMITED",
"NAVKAR SURFACTANTS PRIVATE LIMITED",
"NAVKAR TECHPLAST PRIVATE LIMITED",
"NAVKAR TECHTEX LIMITED",
"NAVKAR TERRYTEX PRIVATE LIMITED",
"NAVKAR TRADELINKS PRIVATE LIMITED",
"NAVKAR TRANSCORE PRIVATE LIMITED",
"NAVKAR TRAVELS PRIVATE LIMITED",
"NAVKAR URBANSTRUCTURE LIMITED",
"NAVKAR WATER SOLUTION PRIVATE LIMITED",
"NAVKAR WHEELS PRIVATE LIMITED",
"NAVKAR WIRES PVT LTD",
"NAVKAR WOOLLENS PRIVATE LIMITED",
"NAVKARDEEP STEEL PRIVATE LIMITED",
"NAVKARMIK INFRA & DEVELOPMENT PRIVATE LIMITED",
"NAVKETAN FASTENERS PVT LTD",
"NAVKETAN NURSING HOME PRIVATE LIMITED",
"NAVKETAN PHARMA PRIVATE LIMITED",
"NAVKETAN RESEARCH AND LABORATORIES PRIVATE LIMITED",
"NAVKETAN ROLLER FLOUR MILLS PRIVATE LIMITED",
"NAVKETAN SAREES PRIVATE LIMITED",
"NAVKETTAN LOCKERS PRIVATE LIMITED",
"NAVKIRAN ENTERPRISES PRIVATE LIMITED",
"NAVKIRAN INFOTECH (OPC) PRIVATE LIMITED",
"NAVKIRAN TECHNO FEEDS",
"NAVKIS CENTRAL TRUST OFFICE",
"NAVKIS GIRLS PU COLLEGE",
"NAVKISAN BIO PLAANTEC LIMITED",
"NAVLOK EXHIBITORS PVT LTD",
"NAVMAHARASHTRA VID SHIVNAGAR RAIGAON",
"NAVNATH HEALTH CARE",
"NAVNATH INFRAPROJECT DEVELOPERS PRIVATE LIMITED",
"NAVNATH SPICES PRIVATE LIMITED",
"NAVNEET AGENCIES PRIVATE LIMITED",
"NAVNEET BUILDCON PRIVATE LIMITED",
"NAVNEET CEMTECH PRIVATE LIMITED",
"NAVNEET CERAMICS PRIVATE LIMITED",
"NAVNEET DEALERS PRIVATE LIMITED",
"NAVNEET EDUCATION LIMITED",
"NAVNEET FOUNDATION",
"NAVNEET OVERSEAS PRIVATE LIMITED",
"NAVNEET RO SYSTEMS PRIVATE LIMITED",
"NAVNEET ROLLER FLOUR MILLS PRIVATE LIMITED",
"NAVNEET SYNTHETICS LIMITED",
"NAVNETRA TRADING PRIVATE LIMITED",
"NAVNETRI GAMIKA PRIVATE LIMITED",
"NAVNI STRUCTURAL SYSTEMS PRIVATE LIMITED",
"NAVNIDHI FERROMET PRIVATE LIMITED",
"NAVNIDHI HOMES PRIVATE LIMITED",
"NAVNIDHI INFRASTRUCTURE PRIVATE LIMITED",
"NAVNIDHI LIFESCIENCE PRIVATE LIMITED",
"NAVNIDHI STEEL AND ENGINEERING COMPANY PRIVATE LIMITED",
"NAV-NIDHI SYNTHETICS PVT LTD",
"NAVNIRMAN ELECTRICS P LTD",
"NAVNIRMAN HIGHWAY PROJECTS PRIVATE LIMITED",
"NAVNIRMAN INFRAHEIGHTS AND MOVERS PRIVATE LIMITED",
"NAVNIRMAN SAMAJ VIKAS KENDRA",
"NAVNIRMAN SSR PATHWAYS PRIVATE LIMITED",
"NAVNIRMAN STRUCTURE & ROAD PRIVATE LIMITED",
"NAVNIT AUTOMOBILE",
"NAVNIT BLISTER PACKS PRIVATE LIMITED",
"NAVNIT CARS PRIVATE LIMITED",
"NAVNIT INSURANCE BROKING PRIVATE LIMITED",
"NAVNIT MARINE PRIVATE LIMITED",
"NAVNIT MOTORS PRIVATE LIMITED",
"NAVNITLAL PRIVATE LIMITED",
"NAVO INFORMATICA PRIVATE LIMITED",
"NAVOCHEM INDIA PRIVATE LIMITED",
"NAVODAY ENTERPRISES LIMITED",
"NAVODAYA DENTAL COLLEGE",
"NAVODAYA EDUCATION TRUST",
"NAVODAYA ENERGY PRIVATE LIMITED",
"NAVODAYA HOSPITALITY PRIVATE LIMITED",
"NAVODAYA INSTITUTE OF TECHNOLOGY",
"NAVODAYA MEDICAL COLLEGE",
"NAVODAYA PHARMACEUTICALS PRIVATE LIMITED",
"NAVODAYA SERVICE CENTER",
"NAVODAYA TIMES PRIVATE LIMITED",
"NAVODHYA VIDYALAYA SEMI GOVERNMENT",
"NAVODIT PROJECTS PRIVATE LIMITED",
"NAVODYA HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED",
"NAVPAD INTERIOR SOLUTIONS PRIVATE LIMITED",
"NAVPAD PIGMENTS PRIVATE LIMITED",
"NAVRAAV ELECTRO LIMITED",
"NAVRACHANA INTERNATIONAL SCHOOL",
"NAVRACHANA UNIVERSITY",
"NAVRACHNA CONSTRUCTION PRIVATE LIMITED",
"NAVRAJ ENTERPRISES PRIVATE LIMITED",
"NAVRAJ FINANCE PRIVATE LIMITED",
"NAVRANG AUDIO VEDIO PRIVATE LIMITED",
"NAVRANG DAIRIES PRIVATE LIMITED",
"NAVRANG HOSPITALITY PRIVATE LIMITED",
"NAVRANG MACHINERY PRIVATE LIMITED",
"NAVRANG MADHYAMIK SHALA",
"NAVRANG PLASTIC",
"NAVRANG POLYFILMS PRIVATE LIMITED",
"NAVRANG SAREES PRIVATE LIMITED",
"NAVRANG SHIPPING PRIVATE LIMITED",
"NAVRANG VINIYOG PVT LTD",
"NAVRAS ELECTRICAL PRIVATE LIMITED",
"NAVRAS TRAVELS PRIVATE LIMITED",
"NAVRAT FRAGRANCES PRIVATE LIMITED",
"NAVRATAN SPECIALTY CHEMICALS LLP",
"NAVRATAN VINIMAY PVT LTD",
"NAVRATANMAL ASHOK KUMAR SURANA WOOLLEN PRIVATE LIMITED",
"NAVRATHAN JEWELLERS PRIVATE LIMITED",
"NAVRATNA AHMEDABAD GOLF INFRASTRUCTURE PRIVATE LIMITED",
"NAVRATNA FACILITY MANAGEMENT LLP",
"NAVRATNA MANGNESE PRODUCTS LLP",
"NAVRATNA ORGANISERS AND DEVELOPERS PRIVATE LIMITED",
"NAVRATNA SOLUTIONS PRIVATE LIMITED",
"NAV-RATNA TEXTILE MILLS PVT LTD",
"NAVRATRA TRADELINK PRIVATE LIMITED",
"NAVRATRI SHARE TRADING PRIVATE LIMITED",
"NAVRATTAN CEMENT INDUSTRIES LLP",
"NAVRIT MARKETING PRIVATE LIMITED",
"NAVRITI TECHNOLOGIES PRIVATE LIMITED",
"NAVSAHVI INTERIOR PRIVATE LIMITED",
"NAVSAHYADRI INSTITUTE OF PHARMACY",
"NAVSAHYADRI INSTITUTE OF TECHNOLOGY POLYTECHNIC COLLEGE",
"NAVSAI INVESTMENTS PVT LTD",
"NAVSAMVAT LAW COLLEGE UJJAIN",
"NAVSANDHAN KISAN PRODUCER COMPANY LIMITED",
"NAVSANJEEVANI FARMERS PRODUCER COMPANY LIMITED",
"NAVSANSKAR HINDI HIGH SCHOOL GHATLODIYA AHMEDABAD",
"NAVSAR ENGINEERING INTERNATIONAL PRIVATE LIMITED",
"NAVSARI AGRICULTURAL UNIVERSITY",
"NAVSARI FOOD PRODUCTS PRIVATE LIMITED",
"NAVSARI MARKETING PRIVATE LIMITED",
"NAVSARI VIJALPOR NAGARPALIKA",
"NAVSARJAN ENGINEERING PRIVATE LIMITED",
"NAVSEMI TECHNOLOGIES PRIVATE LIMITED",
"NAVSHAKTI CLEARING & CREDIT PVT LTD",
"NAVSHAKTI FILAMENTS",
"NAVSHAKTI SECURITY FORCE PRIVATE LIMITED",
"NAVSOFT TRAINING AND DEVELOPMENT SERVICES PRIVATE LIMITED",
"NAVSRISHTI PHARMACEUTICAL PRIVATE LIMITED",
"NAVSTAR INTEGRATED SYSTEMS PRIVATE LIMITED",
"NAVTAPPI INTER COLLEGE DEORIA",
"NAVTECH CREATION PRIVATE LIMITED",
"NAVTEJ INFRASTRUCTURE PRIVATE LIMITED",
"NAVTEX COMMERCIAL PRIVATE LIMITED",
"NAVTOR (INDIA) PRIVATE LIMITED",
"NAVUS IT SERVICES PRIVATE LIMITED",
"NAVY CHILDREN SCHOOL MUMBAI",
"NAVYA BAKES & CONFECTIONERIES INDIA PRIVATE LIMITED",
"NAVYA CABLE NETWORK PRIVATE LIMITED",
"NAVYA CAPITAL MARKET PRIVATE LIMITED",
"NAVYA CERAMIC",
"NAVYA CONTAINERS PRIVATE LIMITED",
"NAVYA ENTERPRISES",
"NAVYA FARMS PRIVATE LIMITED",
"NAVYA FASHIONS PRIVATE LIMITED",
"NAVYA FOODS PRIVATE LIMITED",
"NAVYA IMPEX PRIVATE LIMITED",
"NAVYA JUTE MILLS PRIVATE LIMITED",
"NAVYA METALS PRIVATE LIMITED",
"NAVYA TECHNOLOGIES PRIVATE LIMITED",
"NAVYA VENTURES PRIVATE LIMITED",
"NAVYAL SOFTECK SOLUTIONS PRIVATE LIMITED",
"NAVYATI VYAPAAR PRIVATE LIMITED",
"NAVYAX TECHNOLOGIES PRIVATE LIMITED",
"NAVYLLOYED SHIPPING PRIVATE LIMITED",
"NAVYODHAM TRADELINK PRIVATE LIMITED",
"NAVYUG ALLOYS PRIVATE LIMITED",
"NAVYUG CHEMICALS PRIVATE LIMITED",
"NAVYUG COMMERCIALS PRIVATE LIMITED",
"NAVYUG EDUCATION PRIVATE LIMITED",
"NAVYUG GLOBAL VENTURES PRIVATE LIMITED",
"NAVYUG INDIA LIMITED",
"NAVYUG INFOSOLUTIONS PRIVATE LIMITED",
"NAVYUG IRON PRIVATE LIMITED",
"NAVYUG MEDICAL CENTER PRIVATE LIMITED",
"NAVYUG MINERALS & AGGREGATES LIMITED",
"NAVYUG OVERSEAS PRIVATE LIMITED",
"NAVYUG PHARMA- CHEM PVT. LTD.",
"NAVYUG POLYSTOCK CENTRE PRIVATE LIMITED",
"NAVYUG SARVJANIK MADHYAMIK SHALA",
"NAVYUG SCHOOL DARBHANGA HOUSE",
"NAVYUG SUPPLIERS PRIVATE LIMITED",
"NAVYUG TELEFILMS P LTD",
"NAVYUG VIDHYALAY",
"NAWAB DEVELOPERS PRIVATE LIMITED",
"NAWAB INFRASTRUCTURE PRIVATE LIMITED",
"NAWAB PRODUCTS PRIVATE LIMITED",
"NAWAB SINGH CHAUHAN GRAMODAY INTER COLLEGE KASIMPUR POWER HOUSE ALIGARH",
"NAWAL AGRO & PLANTATION PRIVATE LIMITED",
"NAWAL INFRATECH PRIVATE LIMITED",
"NAWAL KISHOR GUPTA &SONS",
"NAWAL OILS AND CONTAINERS PRIVATE LIMITED",
"NAWAL PRAKASH AVIKEM PRIVATE LIMITED",
"NAWAL SINGH CONSTRUCTION PRIVATE LIMITED",
"NAWANSHAHR CRITICAL CARE AND TRAUMA CENTRE PRIVATE LIMITED",
"NAWANSHAHR POWER PRIVATE LIMITED",
"NAWANY CORP (I) LIMITED",
"NAWAS ISPAT ENGINEERING PRIVATE LIMITED",
"NAWAZ INFRASTRUCTURE & DEVELOPERS PRIVATE LIMITED",
"NAWCON INFRASTRUCTURE PRIVATE LIMITED",
"NAWKIRAN POLYPLAST PRIVATE LIMITED",
"NAWLA ISPAT PRIVATE LIMITED",
"NAWSHERA TRANSPORT COMPANY PVT LTD",
"NAX AIR SOLUTIONS INDIA PRIVATE LIMITED",
"NAXATRA VFX STUDIOS PRIVATE LIMITED",
"N-AXIS SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"NAXPAR HEALTH CONCEPTS PRIVATE",
"NAXPAR PHARMA PRIVATE LIMITED",
"NAY ENERGY PRIVATE LIMITED",
"NAYA JEEVAN RETAILS LIMITED",
"NAYAB TAHSILDAR ELECTION",
"NAYAGAADI ONLINE MARKETPLACE PRIVATE LIMITED",
"NAYAGARA HOTELS PRIVATE LIMITED",
"NAYAGARH RICE PRIVATE LIMITED",
"NAYAGI INDUSTRIAL TECHNOLOGIES PRIVATE LIMITED",
"NAYAK AGENCIES PRIVATE LIMITED",
"NAYAK AVIATION SERVICES PRIVATE LIMITED",
"NAYAK BABA FREEZING ENTERPRISE PRIVATE LIMITED",
"NAYAK DIESELS & ELECTRICALS PRIVATE LIMITED",
"NAYAK HOLDINGS PRIVATE LIMITED",
"NAYAK SANITATIONS PRIVATE LIMITED",
"NAYAK TEXTILE PRIVATE LIMITED",
"NAYAKEM ORGANICS PRIVATE LIMITED",
"NAYAK'S HEARING CARE CLINIC PRIVATE LIMITED",
"NAYAK'S TUTORIALS PRIVATE LIMITED",
"NAYAL SOLUTIONS AND SERVICES PRIVATE LIMITED",
"NAYAMSOFT INDIA PRIVATE LIMITED",
"NAYAN AGRO LIMITED",
"NAYAN HARDWARE PRIVATE LIMITED",
"NAYAN M VALA SECURITIES PRIVATE LIMITED",
"NAYAN TARA CHEMICALS PRIVATE LIMITED",
"NAYAN TIE-UP PRIVATE LIMITED",
"NAYANAM FOOD SPECIALTIES PRIVATE LIMITED",
"NAYANTARA CONSTRUCTIONS PRIVATE LIMITED",
"NAYANTARA JEWELLERS PRIVATE LIMITED",
"NAYAPUR MATERNITY HOSPITAL",
"NAYAR BUSINESS CENTRE PRIVATE LIMITED",
"NAYARA ENERGY LIMITED",
"NAYASA SUPERPLAST",
"NAYATI ENTERPRISES PRIVATE LIMITED",
"NAYATI HEALTHCARE & RESEARCH PRIVATE LIMITED",
"NAYEK PAPER INDUSTRIES LIMITED",
"NAYOVI CRAFT & BUILD PRIVATE LIMITED",
"NAYOVI DEVELOPERS PRIVATE LIMITED",
"NAYSAA SECURITIES LIMITED",
"NAYVEAU PRIVATE LIMITED",
"NAYYAR MEDICAL CENTRE PVT LTD",
"NAZ MARITIME SERVICES PRIVATE LIMITED",
"NAZAR CHEMICALS PRIVATE LIMITED",
"NAZAR OPTICALS AND PHARMACEUTICALS PRIVATE LIMITED",
"NAZARA FASHION",
"NAZARA TECHNOLOGIES LIMITED",
"NAZARAT SECTION",
"NAZARBAD MEDICAL SERVICES PRIVATE LIMITED",
"NAZARETH FOODS PRIVATE LIMITED",
"NAZARETH MATRICULATION HIGHER SECONDARY SCHOOL",
"NAZCA ENERGY PRIVATE LIMITED",
"NAZEER FOODS PRIVATE LIMITED",
"NAZEER HOSPITALITY PRIVATE LIMITED",
"NAZRUL ENTERPRISE PRIVATE LIMITED",
"NB AUTOMOBILES PRIVATE LIMITED",
"NB ENTREPRENEURS INDIA PRIVATE LIMITED",
"NB EQUIPMENTS & ENGINEERING PRIVATE LIMITED",
"NB HEALTHCARE PRIVATE LIMITED",
"NB HEALTHCARE TECHNOLOGIES PRIVATE LIMITED",
"NB HITECH INDUSTRIES PRIVATE LIMITED",
"NB INSTRUMENT PRIVATE LIMITED",
"NB PAMAS POLYPACK PRIVATE LIMITED",
"NB SCIENCE COLLEGE",
"NB SURVEYS KIRPALANEY PRIVATE LIMITED",
"NB TECHNOLOGIES PRIVATE LIMITED",
"NB VISA WORLD PRIVATE LIMITED",
"NBA INDIA BASKETBALL PRIVATE LIMITED",
"NBAZAAR RETAIL PRIVATE LIMITED",
"NBC FASHION INDIA PRIVATE LIMITED",
"NBCC INDIA LIMITED",
"NBCC SERVICES LIMITED",
"NBCUNIVERSAL MEDIA DISTRIBUTION SERVICES PRIVATE LIMITED",
"NBD PAPERS PRIVATE LIMITED",
"NBE MOTORS PRIVATE LIMITED",
"NBG PRINTO GRAPHIC MACHINERY COMPANY PVT LTD",
"NBG TECH PRIVATE LIMITED",
"NBHC ENTERPRISES PRIVATE LIMITED",
"NBI INDIA PRIVATE LIMITED",
"NBIONS SOLUTIONS PRIVATE LIMITED",
"NBKR INSTITUTE OF SCIENCE AND TECHNOLOGY",
"NBM IRON AND STEEL TRADING PRIVATE LIMITED",
"NBM MEDIA PRIVATE LIMITED",
"NBMS GLOBAL TRADE PRIVATE LIMITED",
"NBN PROJECTS PRIVATE LIMITED",
"NBOS TECHNOLOGIES PRIVATE LIMITED",
"NBR COOLING SYSTEMS PRIVATE LIMITED",
"NBRL EXPRESS SERVICES PRIVATE LIMITED",
"NBS ENGINEERING SOLUTIONS PRIVATE LIMITED",
"NBS HEIGHTS PRIVATE LIMITED",
"NBS INTERNATIONAL LIMITED",
"NBS MY MANPOWER RESOURCES PRIVATE LIMITED",
"NBSL ELEVATOR COMPONENTS INDIA PRIVATE LIMITED",
"NBSTC",
"NBT CLOTHING PRIVATE LIMITED",
"NBT INNOVATIVE INDIA PRIVATE LIMITED",
"NBT LIMITED",
"NBU BEARINGS PRIVATE LIMITED",
"NC ASSOCIATES PRIVATE LIMITED",
"NC ENERGY LIMITED",
"NC HOSPITALITY PRIVATE LIMITED",
"NC INFRACON PRIVATE LIMITED",
"NC MEDIA NETWORKS PRIVATE LIMITED",
"NC PRINT PRIVATE LIMITED",
"NCBRAIN (INDIA) SOFTWARE PRIVATE LIMITED",
"NCC CROWNS PRIVATE LIMITED",
"NCC INFRASPACE PRIVATE LIMITED",
"NCC LIMITED",
"NCC OFFICERS TRAINING ACADEMY GWALIOR",
"NCC POWER PROJECTS LIMITED",
"NCC TELECOM PRIVATE LIMITED",
"NCC TRANS LOGISTICS PRIVATE LIMITED",
"NCC URBAN",
"NCC VIZAG URBAN INFRASTRUCTURE LIMITED",
"NCD IMMUNOMEDICARE PRIVATE LIMITED",
"NCDEX E MARKETS LIMITED",
"NCDEX INSTITUTE OF COMMODITY MARKETS AND RESEARCH",
"NCG CORPORATE ENGINEERS PRIVATE LIMITED",
"NCG DEVELOPERS AND INFRASTRUCTURE",
"NCGB MARINE PVT.LTD.",
"NCH INDIA PRIVATE LIMITED",
"NCH SERVICES PRIVATE LIMITED",
"NCI INDIA PRIVATE LIMITED",
"NCI PAINTS (INDIA) PRIVATE LIMITED",
"NCIRCLE TECH PRIVATE LIMITED",
"NCJ INFRASTRUCTURE PRIVATE LIMITED",
"NCJ SHARE AND STOCK BROKERS LIMITED",
"NCL BUILDTEK LIMITED",
"NCL CARGO AND LOGISTICS PRIVATE LIMITED",
"NCL HOLDINGS (A&S) LIMITED",
"NCL HOMES LIMITED",
"NCL INDUSTRIES LIMITED",
"NCL VEKA PRIVATE LIMITED",
"NCL WINTECH INDIA LIMITED",
"NCLR BHARATH HI-TECCH INFRASTRUCTURE PRIVATE LIMITED",
"NCML FINANCE PRIVATE LIMITED",
"NCML KB PRIVATE LIMITED",
"NCM-SHOAVA ENGINEERS PRIVATE LIMITED",
"NCO SECURITIES AND SHARE BROKING PRIVATE LIMITED",
"NCOME TECH SOLUTIONS PRIVATE LIMITED",
"NCOMPUTING SALES AND MARKETING PRIVATE LIMITED",
"NCON TURBO TECH PRIVATE LIMITED",
"NCOURAGE SOCIAL ENTERPRISE FOUNDATION",
"NCP COMMERCIALS PRIVATE LIMITED",
"NCPE INFRASTRUCTURE INDIA PRIVATE LIMITED",
"NCPL SERVICES PRIVATE LIMITED",
"NCR CORPORATION INDIA PRIVATE LIMITED",
"NCR DATA VOIZ COMM PRIVATE LIMITED",
"NCR EDUSERVICES PRIVATE LIMITED",
"NCR MOTORS INDIA PRIVATE LIMITED",
"NCR RESIDENCY PRIVATE LIMITED",
"NCR VEHICLES PRIVATE LIMITED",
"NCRD'S STERLING INSTITUTE OF MANAGEMENT STUDIES",
"NCRTC EXPRESS TRANSIT LIMITED",
"NCRUST SOFTWARE PRIVATE LIMITED",
"NCRYPTED TECHNOLOGIES PRIVATE LIMITED",
"NCS AUTO CRAFT PRIVATE LIMITED",
"NCS AUTO HUB PRIVATE LIMITED",
"NCS AUTOCARS PRIVATE LIMITED",
"NCS AUTOMOTIVES PRIVATE LIMITED",
"NCS DIAGNOSTICS PRIVATE LIMITED",
"NCS ESTATES PRIVATE LIMITED",
"NCS FINANCE PRIVATE LIMITED",
"NCS GREEN EARTH PRIVATE LIMITED",
"NCS INDUSTRIES PRIVATE LIMITED",
"NCS INFRASTRUCTURE LIMITED",
"NCS LOGISTICS AND DISTRIBUTION PRIVATE LIMITED",
"NCS SEAPORT SERVICES PRIVATE LIMITED",
"NCS SOFT SOLUTIONS PRIVATE LIMITED",
"NCS STORAGE SYSTEMS PRIVATE LIMITED",
"NCSI TECHNOLOGIES INDIA PRIVATE LIMITED",
"NCUBATE INDIA SERVICES PRIVATE LIMITED",
"NCUBE PLANNING AND DESIGN PRIVATE LIMITED",
"NCVI ENTERPRISES LIMITED",
"ND APPARELS PRIVATE LIMITED",
"ND CHAIR PARTS SOLUTIONS PRIVATE LIMITED",
"ND INFO SYSTEMS PRIVATE LIMITED",
"ND LAMINATES PRIVATE LIMITED",
"ND PHARMA PRIVATE LIMITED",
"ND SARRAF JEWELS WHOLESALE PRIVATE LIMITED",
"ND SHIPPING SERVICES PRIVATE LIMITED",
"ND SPICES PRIVATE LIMITED",
"ND24 PRIVATE LIMITED",
"NDA SECURITIES LIMITED",
"NDB SECURITIES PRIVATE LIMITED",
"NDC DIAGNOSTICS CENTRE MULUND",
"NDC DRUG AND CHEMICAL COMPANY PRIVATE LIMITED",
"NDC INSTITUTE OF AIRCRAFT MAINTENANCE ENGINEERING",
"NDCARE NIROGAM PRIVATE LIMITED",
"NDD INFRATECH PRIVATE LIMITED",
"NDDB DAIRY SERVICES",
"NDEH EXPORT HOUSE PRIVATE LIMITED",
"NDG MOTORS PRIVATE LIMITED",
"NDIMENSIONS RESEARCH & TRAINING SERVICES PRIVATE LIMITED",
"NDIMENSIONZ SOLUTIONS PRIVATE LIMITED",
"NDJ SOLAR POWER PRIVATE LIMITED",
"NDL POWER LIMITED",
"NDL VENTURES LIMITED",
"NDM CROP SCIENCE PRIVATE LIMITED",
"NDM HOSPITALITY LIMITED",
"NDM MARKETING PRIVATE LIMITED",
"NDM SEA FOOD PROCESSORS AND EXPORTERS PRIVATE LIMITED",
"NDNX PRIVATE LIMITED",
"NDO INDIA PRIVATE LIMITED",
"NDOT TECHNOLOGIES PRIVATE LIMITED",
"NDPC LOGISTIC PRIVATE LIMITED",
"NDPL INFRA LIMITED",
"NDPR LOGISTICS PRIVATE LIMITED",
"NDR ASSET MANAGEMENT PRIVATE LIMITED",
"NDR AUTO COMPONENTS LIMITED",
"NDR FACTOR PRIVATE LIMITED",
"NDR GLOBAL INDIA PRIVATE LIMITED",
"NDRAVG BUSINESS PARK PRIVATE LIMITED",
"NDS INFOTECH LIMITED",
"NDT AND PWHT SOLUTIONS PRIVATE LIMITED",
"NDT LABORATORIES PRIVATE LIMITED",
"NDT TECHNOLOGIES PRIVATE LIMITED",
"NDT TRAINING CONSULTANCY & INSPECTION SERVICES PRIVATE LIMITED",
"NDTEE SERVICES PRIVATE LIMITED",
"NDTP FOODS PRIVATE LIMITED",
"NDTS INDIA PRIVATE LIMITED",
"NDTV CONVERGENCE LIMITED",
"NDTV MEDIA LIMITED",
"NDTV NETWORKS LIMITED",
"NDTV WORLDWIDE LIMITED",
"NDVN PROPERTIES PRIVATE LIMITED",
"NDVOR IT SOLUTIONS PRIVATE LIMITED",
"NDX FINANCIAL SERVICES PRIVATE LIMITED",
"NDX P2P PRIVATE LIMITED",
"NE MANPOWER PRIVATE LIMITED",
"NE OILFIELD SERVICES PRIVATE LIMITED",
"NE RUBBER MILLS PRIVATE LIMITED",
"NE TECHNOLOGIES INDIA PRIVATE LIMITED",
"NEA DESIGNS PRIVATE LIMITED",
"NEAL ANALYTICS SERVICES PRIVATE LIMITED",
"NEALEX ALLOYS PRIVATE LIMITED",
"NEAM CAPS PRIVATE LIMITED",
"NEAR INDIA PRIVATE LIMITED",
"NEARBY INSURANCE BROKING SERVICES PRIVATE LIMITED",
"NEARBY NEODIGITAL SERVICES PRIVATE LIMITED",
"NEARBY TECHNOLOGIES PRIVATE LIMITED",
"NEARBYMART MERCANTILES PRIVATE LIMITED",
"NEAREX TECHNOLOGIES PRIVATE LIMITED",
"NEARMALLSZONE INDIA PRIVATE LIMITED",
"NEAT AND CLEAN SERVICES PRIVATE LIMITED",
"NEAT GRAPHICS PRIVATE LIMITED",
"NEAT WIND INDUSTRIES",
"NEATMAINT SERVICES PRIVATE LIMITED",
"NEATNATURE SOLUTIONS PRIVATE LIMITED",
"NEATVIN ENTERPRISES PRIVATE LIMITED",
"NEB SPORTS ENTERTAINMENT PRIVATE LIMITED",
"NEBBIA TECHNOLOGIES INDIA PRIVATE LIMITED",
"NEBCO TEXTILE INDUSTRIES PRIVATE LIMITED",
"NEBERO SYSTEMS PRIVATE LIMITED",
"NEBISCO INDUSTRIES PRIVATE LIMITED",
"NEBU LABS PRIVATE LIMITED",
"NEBULA BIOCHEM PRIVATE LIMITED",
"NEBULA COMPUTERS PRIVATE LIMITED",
"NEBULA HEALTHCARE LIMITED",
"NEBULA HOME PRODUCTS PRIVATE LIMITED",
"NEBULA INFOMATIQUE PRIVATE LIMITED",
"NEBULA MULTITRADE PRIVATE LIMITED",
"NEBULA SURGICAL PRIVATE LIMITED",
"NEBULA3D SERVICES PRIVATE LIMITED",
"NEBULARC TECHNOLOGIES PRIVATE LIMITED",
"NEBULOGIC IT SOLUTIONS PRIVATE LIMITED",
"NEC CORPORATION INDIA PRIVATE LIMITED",
"NEC ENERGY PRIVATE LIMITED",
"NEC INFRATECH PRIVATE LIMITED",
"NEC PACKAGING LIMITED",
"NEC SOFTWARE SOLUTIONS INDIA PRIVATE LIMITED",
"NECAS AUTOMATION PRIVATE LIMITED",
"NECCO SHIPPING COMPANY PRIVATE LIMITED",
"NECCON POWER AND INFRA LIMITED",
"NECHRA MARKETING PRIVATE LIMITED",
"NECKED JEANS PRIVATE LIMITED",
"NECLEUS CENTRICAST PRIVATE LIMITED",
"NECO HEAVY ENGINEERING AND CASTINGS PRIVATE LIMITED",
"NECO MINING COMPANY PRIVATE LIMITED",
"NECROMATIC POLYCHEM PRIVATE LIMITED",
"NECRON IT SOLUTIONS PRIVATE LIMITED",
"NECS PHARMA LLP",
"NECTA TECHNOLOGY PRIVATE LIMITED",
"NECTAR BIOPHARMA PRIVATE LIMITED",
"NECTAR CRAFTS",
"NECTAR CROP SCIENCES PRIVATE LIMITED",
"NECTAR DRUGS PRIVATE LIMITED",
"NECTAR INFOSYSTEMS INDIA PRIVATE LIMITED",
"NECTAR INFOTEL SOLUTIONS PRIVATE LIMITED",
"NECTAR LABORATORIES PRIVATE LIMITED",
"NECTAR LIFESCIENCES LIMITED",
"NECTAR MEDIPHARMA PRIVATE LIMITED",
"NECTAR PHYTOCHEMS PRIVATE LIMITED",
"NECTAR PROJECTS PRIVATE LIMITED",
"NECTARBITS PRIVATE LIMITED",
"NECTOR EXPORTS PRIVATE LIMITED",
"NECTOR FOODS PRIVATE LIMITED",
"NECTOR GRAPHICS PRIVATE LIMITED",
"NECTOR INDUSTRIES PRIVATE LIMITED",
"NECTOR TRADING & INVESTMENT PVT LTD",
"NECTOWAVE MEDRECORD PRIVATE LIMITED",
"NECTRINE CHEMICALS INDIA PRIVATE LIMITED",
"NED ENERGY LIMITED",
"NED METALS PRIVATE LIMITED",
"NED TECHNOLOGY PRIVATE LIMITED (QDXSOFT SOLUTIONS PRIVATE LIMITED)",
"NEDERMAN INDIA PRIVATE LIMITED",
"NEDFI TRUSTEE LIMITED",
"NEDFI VENTURE CAPITAL LIMITED",
"NEDGE TECHNOLOGIES PRIVATE LIMITED",
"NEDLLOYD LOGISTICS INDIA PRIVATE LIMITED",
"NEDSPICE PROCESSING INDIA PRIVATE LIMITED",
"NEDUMPARAMBIL ESTATES PRIVATE LIMITED",
"NEDUMPARAMBIL NIDHI LIMITED",
"NEDUMPILLIL FINANCIAL COMPANY LIMITED",
"NEDUNGAT CONSTRUCTION PRIVATE LIMITED",
"NEE COMPONENTS PRIVATE LIMITED",
"NEE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"NEEBAL TECHNOLOGIES PRIVATE LIMITED",
"NEEC REINFRA PRIVATE LIMITED",
"NEECO ICT SERVICES PRIVATE LIMITED",
"NEECO OILFIELD PRODUCT PRIVATE LIMITED",
"NEECS ELECTRICALS PRIVATE LIMITED",
"NEED LIVELIHOOD MICROFINANCE PRIVATE LIMITED",
"NEED PRAKASHAN PRIVATE LIMITED",
"NEED SOFT TECHNOLOGIES PRIVATE LIMITED",
"NEED TECH PRIVATE LIMITED",
"NEEDFUL DEALCOMM PRIVATE LIMITED",
"NEEDLE EYE PLASTIC INDUSTRIES PRIVATE LTD.",
"NEEDLE INDUSTRIES INDIA PRIVATE ELIMITED",
"NEEDLEDUST PRIVATE LIMITED",
"NEEDLES AND ELEMENTS INDIA PVT LTD",
"NEEDLES MARKETING PRIVATE LIMITED",
"NEEDLEWORK CLOTHING PRIVATE LIMITED",
"NEEDS (INDIA) PRIVATE LIMITED",
"NEEDS INFORMATION SERVICES LIMITED",
"NEEDS MANPOWER SUPPORT SERVICES PRIVATE LIMITED",
"NEEDS SUPERMART PRIVATE LIMITED",
"NEEDS24 RETAILMART PRIVATE LIMITED",
"NEEDS24 SWEETS & NAMKEEN PRIVATE LIMITED",
"NEEDSTREET WEB TECHNOLOGIES PRIVATE LIMITED",
"NEEDUMBRA INDUSTRIES PRIVATE LIMITED",
"NEEGA SECURITY SERVICES INDIA PRIVATE LIMITED",
"NEEHA IT SERVICES (INDIA) PRIVATE LIMITED",
"NEEL AUTO PRIVATE LIMITED",
"NEEL BEVERAGES PRIVATE LIMITED",
"NEEL DATA PRO IT SOLUTIONS PRIVATE LIMITED",
"NEEL ENGINEERING EQUIPMENTS PRIVATE LIMITED",
"NEEL FLEXIBLES PRIVATE LIMITED",
"NEEL HOSPITAL MANAGEMENT SERVICES PRIVATE LIMITED",
"NEEL IMPEX",
"NEEL INDUSTRIAL SYSTEMS PRIVATE LIMITED",
"NEEL INDUSTRIES PRIVATE LIMITED",
"NEEL KAMAL APPARELS INDIA PRIVATE LIMITED",
"NEEL KAMAL HOTEL AND RESORTS PRIVATE LIMITED",
"NEEL KAMAL POLYTEX INDUSTRIES PRIVATE LIMITED",
"NEEL KANTH AGROFOOD PRODUCTS PRIVATE LIMITED",
"NEEL KANTH APPARELS PRIVATE LIMITED",
"NEEL KANTH STRIPS PVT LTD",
"NEEL KANTH TEA COMPANY LIMITED",
"NEEL METAL PRODUCTS LIMITED",
"NEEL PIGMENTS PRIVATE LIMITED",
"NEEL RATNA AQUA FARM PRIVATE LIMITED",
"NEEL SAROVAR BUILDTECH PRIVATE LIMITED",
"NEEL SAWHNEY & COMPANY PRIVATE LIMITED",
"NEEL STEELS PRIVATE LIMITED",
"NEEL TECHNICRAFT PRIVATE LIMITED",
"NEEL WATER TREATMENT SYSTEMS PRIVATE LIMITED",
"NEEL WHITE EXPORTS PRIVATE LIMITED",
"NEELA ASBESTOS INDUSTRIES PRIVATE LIMITED",
"NEELA COTTON MILLS PRIVATE LIMITED",
"NEELA EXPORTS PRIVATE LIMITED",
"NEELA FILM PRODUCTIONS PRIVATE LIMITED",
"NEELA SURYA ENTERPRISES PRIVATE LIMITED",
"NEELACHAL CONCRETE PRODUCTS PVT LTD",
"NEELACHAL ISPAT NIGAM LTD",
"NEELACHAL NATURAL RESOURCE PVT LTD",
"NEELACHAL SUPPORT SERVICES PRIVATE LIMITED",
"NEELADHRII CORP ADVISORY PRIVATE LIMITED",
"NEELAJA INFRASTRUCTURES PRIVATE LIMITED",
"NEELAKRISHNA LEAFINS LTD",
"NEELAM AGROTECH PRIVATE LIMITED",
"NEELAM APPLIANCES LIMITED",
"NEELAM APPLIANCES PRIVATE LIMITED",
"NEELAM AQUA AND SPECIALITY CHEM PRIVATE LIMITED",
"NEELAM AUTOMOBILES PRIVATE LIMITED",
"NEELAM COLD STORAGE PRIVATE LIMITED",
"NEELAM CORPORATION PRIVATE LIMITED",
"NEELAM CREATION PRIVATE LIMITED",
"NEELAM FINANCE BOMBAY PRIVATE LIMITED",
"NEELAM GLOBAL PRIVATE LIMITED",
"NEELAM HOSPITAL",
"NEELAM JUTE PVT LTD",
"NEELAM LACE PRIVATE LIMITED",
"NEELAM LINENS AND GARMENTS (INDIA) LIMITED",
"NEELAM MOTORS PRIVATE LIMITED",
"NEELAM PORTFOLIO LIMITED",
"NEELAM THREAD PRIVATE LIMITED",
"NEELAM WATER TECHNOLOGIES PRIVATE LIMITED",
"NEELAMALAI AGRO INDUSTRIES LIMITED",
"NEELAMBAR INDUSTRIES PRIVATE LIMITED",
"NEELAMBARAI BUSINESS SOLUTIONS PRIVATE LIMITED",
"NEELAMBER AGROTECH PRIVATE LIMITED",
"NEELAMBER CATTERERS PVT. LTD.",
"NEELAMMEGHA INVESTMENT AND TRADING CO PVT LTD",
"NEELANCHAL BUILD-TECH & RESORTS PRIVATE LIMITED",
"NEELANCHAL CONSTRUCTIONS PRIVATE LIMITED",
"NEELANCHAL GRIHA NIRMAN PRIVATE LIMITED",
"NEELANCHAL LEASING LIMITED",
"NEELANCHAL REALTORS LLP",
"NEELANCHAL ROADWAYS PRIVATE LIMITED",
"NEELANG HOLDING PVT LTD",
"NEELANJAN LOGISTICS PRIVATE LIMITED",
"NEELANSH ELECTROTECH SYSTEM PRIVATE LIMITED",
"NEELAY AGRO INFRA PRIVATE LIMITED",
"NEELDEEP DEVELOPERS PRIVATE LIMITED",
"NEELDEEP HOTELS PRIVATE LIMITED",
"NEELESH INDUSTRIAL AGENCY PRIVATE LIMITED",
"NEELGAGAN INFRASTRUCTURE PRIVATE LIMITED",
"NEELGIRI BATHWARE PRIVATE LIMITED",
"NEELGIRI ELECTRICALS",
"NEELGIRI MACHINERY GLOBAL PRIVATE LIMITED",
"NEELGIRI POLY PLAST PRIVATE LIMITED",
"NEELGUND DEVELOPERS AND BUILDERS PRIVATE LIMITED",
"NEELI SEA FOODS PRIVATE LIMITED",
"NEELIKON FOOD DYES AND CHEMICALS LIMITED",
"NEELIMA ASSOCIATES PRIVATE LIMITED",
"NEELIMA HOSPITALS PRIVATE LIMITED",
"NEELKAMAL AGENCY PRIVATE LIMITED",
"NEELKAMAL CINEPLEX PRIVATE LIMITED CO. WITH PART IX CATAGORY",
"NEELKAMAL REALTORS AND BUILDERS PRIVATE LIMITED",
"NEELKAMAL REALTORS SUBURBAN PRIVATE LIMITED",
"NEELKAMAL REALTORS TOWER PRIVATE LIMITED",
"NEELKAMAL RUBBERS PRIVATE LIMITED",
"NEELKAMAL SAREES PRIVATE LIMITED",
"NEELKAMAL STEELS PRIVATE LIMITED",
"NEELKANTH ALLOYS PRIVATE LIMITED",
"NEELKANTH COAL MANUFACTURING PRIVATE LIMITED",
"NEELKANTH CONCLAVE PRIVATE LIMITED",
"NEELKANTH CONSTRUCTION PRIVATE LIMITED",
"NEELKANTH DIGITAL INFONET PRIVATE LIMITED",
"NEELKANTH DRUGS PRIVATE LIMITED",
"NEELKANTH ELECTRICALS",
"NEELKANTH ENTERPRISES PRIVATE LIMITED",
"NEELKANTH ENTREPRENEURS PRIVATE LIMITED",
"NEELKANTH FABRICATORS PRIVATE LIMITED",
"NEELKANTH FABRICS PVT LTD",
"NEELKANTH FIBRES PRIVATE LIMITED",
"NEELKANTH FINTRADE LIMITED",
"NEELKANTH FLOORS PRIVATE LIMITED",
"NEELKANTH HEALTH CARE PRIVATE LIMITED",
"NEELKANTH HOSPITALS PRIVATE LIMITED",
"NEELKANTH INFRATECH PRIVATE LIMITED",
"NEELKANTH INSTITUTE OF ENGINEERING & TECHNOLOGY",
"NEELKANTH IVF",
"NEELKANTH MAHADEV MARKETING PRIVATE LIMITED",
"NEELKANTH MANSIONS AND INFRASTRUCTURE PRIVATE LIMITED",
"NEELKANTH MEDICARE PRIVATE LIMITED",
"NEELKANTH MOTELS AND HOTELS LIMITED",
"NEELKANTH OFFSET PRIVATE LIMITED",
"NEELKANTH PACKERS PVT LTD",
"NEELKANTH POLYCHEM PRIVATE LIMITED",
"NEELKANTH POLYTECH PRIVATE LIMITED",
"NEELKANTH POULTRY FARMS PRIVATE LIMITED",
"NEELKANTH PRODUCT PRIVATE LIMITED",
"NEELKANTH PUBLISHERS PRIVATE LIMITED",
"NEELKANTH PULP & PAPER BOARDS",
"NEELKANTH REALTORS PRIVATE LIMITED",
"NEELKANTH RECYCLING PRIVATE LIMITED",
"NEELKANTH RESIDENTIAL SCHOOL",
"NEELKANTH RUBBER MILLS",
"NEELKANTH SALT CHEM INDIA PRIVATE LIMITED",
"NEELKANTH SODA CLAYS PRIVATE LIMITED",
"NEELKANTH SWEETS PRIVATE LIMITED",
"NEELKANTH SYNTHETICS AND CHEMICALS PRIVATE LIMITED",
"NEELKANTH URBAN DEVELOPERS PRIVATE LIMITED",
"NEELKANTH VINAYAK REALTORS PRIVATE LIMITED",
"NEELKANTH WHEAT PRODUCTS PRIVATE LIMITED",
"NEELKANTHA MOBILES PRIVATE LIMITED",
"NEELKANTHA STEELS PRIVATE LIMITED",
"NEELKANTHAM SYSTEMS PRIVATE LIMITED",
"NEELKANTHFERTILITY AND WOMEN CARE HOSPITAL PRIVATE LIMITED",
"NEELMANI JEWELLERS PRIVATE LIMITED",
"NEELMANI MINES AND MARBLES LTD",
"NEELMANI PROJECTS INDIA PRIVATE LIMITED",
"NEELPAREE PLASTICS INDUSTRIES PRIVATE LIMITED",
"NEELPLAST POLYMERS PRIVATE LIMITED",
"NEELRASHI TRAVELS PRIVATE LIMITED",
"NEELS ENTERPRISES PRIVATE LIMITED",
"NEELSON PORSELANO LLP",
"NEEL-TECH INTERNATIONAL PRIVATE LIMITED",
"NEELU ELECTRICALS PVT LTD",
"NEELWARE DECOMPOSABLE PRIVATE LIMITED",
"NEELWARNA SERVICES INDIA PRIVATE LIMITED",
"NEELYOG CONSTRUCTION PRIVATE LIMITED",
"NEEM AGRO PRIVATE LIMITED",
"NEEM DIGITAL PRIVATE LIMITED",
"NEEM FURNITECH",
"NEEM HOLIDAYS PRIVATE LIMITED",
"NEEM TREE CONSULTANTS PRIVATE LIMITED",
"NEEM TREE INSURANCE BROKING AND ADVISORY PRIVATE LIMITED",
"NEEM TREE MODULAR PRIVATE LIMITED",
"NEEMA HOSPITALS PRIVATE LIMITED",
"NEEMA MEDINEEDS PRIVATE LIMITED",
"NEEMA NIDHI LIMITED",
"NEEMAN SEATING SOLUTION PRIVATE LIMITED",
"NEEMANS PRIVATE LIMITED",
"NEEMRANA HOTELS PRIVATE LIMITED",
"NEEMRANA KNITFAB PRIVATE LIMITED",
"NEEMRANA STEEL SERVICE CENTER INDIA PRIVATE LIMITED",
"NEEMSBORO FARMS PRIVATE LIMITED",
"NEEMTREE HEALTHCARE PRIVATE LIMITED",
"NEEMTREE INTERNET PRIVATE LIMITED",
"NEEMUCH SOLAR POWER PRIVATE LIMITED",
"NEENDOOR HIRE PURCHASE AND CREDITS PVT LTD",
"NEENJAS MFG PRIVATE LIMITED",
"NEENJAS TECHNOLOGIES PRIVATE LIMITED",
"NEENV ENT AND CANCER HOSPITALS PRIVATE LIMITED",
"NEENV INFRASTRUCTURES PRIVATE LIMITED",
"NEEPA REAL ESTATES PRIVATE LIMITED",
"NEER AQUACULTURE EXPORTS PRIVATE LIMITED",
"NEER GREEN PRIVATE LIMITED",
"NEER INFO SOLUTIONS PRIVATE LIMITED",
"NEER INFRATECH PRIVATE LIMITED",
"NEER POLYMER PRIVATE LIMITED",
"NEER SEA FOOD PRIVATE LIMITED",
"NEERA CHEMICALS AND FERTILIZERS PRIVATE LIMITED",
"NEERA PUMPS & VALVES PRIVATE LIMITED",
"NEERA SHAWLS PRIVATE LIMITED",
"NEERAJ AGENCIES PRIVATE LIMITED",
"NEERAJ BUILDERS",
"NEERAJ CAMELLIA PRIVATE LIMITED",
"NEERAJ DANGI CONSTRUCTION PRIVATE LIMITED",
"NEERAJ ENTERPRISES PRIVATE LIMITED",
"NEERAJ FLAVOUR AND TEA PLANTATION PRIVATE LIMITED",
"NEERAJ HOTICULTURISTS PVT LTD",
"NEERAJ INFRA PRIVATE LIMITED",
"NEERAJ INSULATION PRIVATE LIMITED",
"NEERAJ KUMAR SURAJ KUMAR JEWELLERS",
"NEERAJ KUMAR SURAJ KUMAR JEWELLERS PRIVATE LIMITED",
"NEERAJ PAPER AGENCIES LIMITED",
"NEERAJ PAPER MARKETING LIMITED",
"NEERAJ POTATO PRESERVATION AND FOOD PRODUCTS PRIVATE LIMITED",
"NEERAJ POWER PRIVATE LIMITED",
"NEERAJ PROJECTS PRIVATE LIMITED",
"NEERAJ SALES PRIVATE LIMITED",
"NEERAJ TRADERS PRIVATE LIMITED",
"NEERAJA TRADING CORPORATION",
"NEERAKKAL LATEX",
"NEERAVA HYGIENE PRODUCTS INDIA PRIVATE LIMITED",
"NEERCARE INDIA PRIVATE LIMITED",
"NEERJA HOSPITAL PRIVATE LIMITED",
"NEERJA MODI SCHOOL",
"NEERJA REALTORS PRIVATE LIMITED",
"NEERJA SOFTWARES PRIVATE LIMITED",
"NEERJA VIDHYA VIHAR INTERNATIONAL SCHOOL MATHANIA",
"NEERPATI BIOFUELS PRIVATE LIMITED",
"NEERU ENTERPRISES",
"NEERU INFRATECH PRIVATE LIMITED",
"NEERU MARKETING PRIVATE LIMITED",
"NEERU MECHANICALS AND CONSULTANTS PRIVATE LIMITED",
"NEERU MENTHOL PRIVATE LIMITED",
"NEESH PERFUMES PRIVATE LIMITED",
"NEESL PRIVATE LIMITED",
"NEESU ENTERPRISES PRIVATE LIMITED",
"NEET ADVISOR PRIVATE LIMITED",
"NEET TEXTILE PRIVATE LIMITED",
"NEETA CONSUMER PRODUCTS PRIVATE LIMITED",
"NEETA LOGISTICS INDIA PRIVATE LIMITED",
"NEETABLE TECHNOLOGIES PRIVATE LIMITED",
"NEETDEEP GROUP",
"NEETEE CLOTHING PRIVATE LIMITED",
"NEETHI ENTERPRISES PRIVATE LIMITED",
"NEETI CLINICS PRIVATE LIMITED",
"NEETI MILK PRODUCER COMPANY LIMITED",
"NEETI NAGPAL ESTATES PRIVATE LIMITED",
"NEETRYA-A EYE CARE PRIVATE LIMITED",
"NEETU FASHIONS PRIVATE LIMITED",
"NEEV BIOCHEM PRIVATE LIMITED",
"NEEV BUILDTECH PRIVATE LIMITED",
"NEEV CREDIT PRIVATE LIMITED",
"NEEV ENERGY DEVELOPMENT PRIVATE LIMITED",
"NEEV ERA STEEL PRIVATE LIMITED",
"NEEV IMPEX PRIVATE LIMITED",
"NEEV INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"NEEV INTERIOR TURNKEY SOLUTIONS PRIVATE LIMITED",
"NEEV KNOWLEDGE MANAGEMENT PRIVATE LIMITED",
"NEEV RESOURCES PRIVATE LIMITED",
"NEEV SCHOOLS PRIVATE LIMITED",
"NEEV SECURITY SERVICES PRIVATE LIMITED",
"NEEV SYSTEMS PRIVATE LIMITED",
"NEEV TRUST",
"NEEV VIDYAPEETH PRIVATE LIMITED",
"NEEVA FOODS PRIVATE LIMITED",
"NEEVANTA CONSTRUCTION PRIVATE LIMITED",
"NEEWEE ANALYTICS PRIVATE LIMITED",
"NEEXWELL ENGINEERING SERVICES PRIVATE LIMITED",
"NEEYAMO STAFFING SERVICES PRIVATE LIMITED",
"NEEYAMOWORKS TECHNOLOGIES PRIVATE LIMITED",
"NEF COLLEGE OF HEALTH SCIENCES",
"NEF WEAVES INDIA PRIVATE LIMITED",
"NEFA BREWERIES PRIVATE LIMITED",
"NEFAB INDIA PRIVATE LIMITED",
"NEFCO FIRE SYSTEMS PRIVATE LIMITED",
"NEFF APPLIANCES LIMITED",
"NEFRAA INFOSERVICES INDIA PRIVATE LIMITED",
"NEGATIVE CARBON ENTERPRISES PRIVATE LIMITED",
"NEGEN CAPITAL SERVICES PRIVATE LIMITED",
"NEGEN POLYSOLUTIONS PRIVATE LIMITED",
"NEGOCE DISTRIBUTORS AND SERVICES PRIVATE LIMITED",
"NEGOCIOS IT SOLUTIONS PRIVATE LIMITED",
"NEGOLICE INDIA LIMITED",
"NEGRI BOSSI INDIA PRIVATE LIMITED",
"NEHA AVIATION MANAGEMENT PRIVATE LIMITED",
"NEHA AVIATION SERVICES PRIVATE LIMITED",
"NEHA BUILDPRO PRIVATE LIMITED",
"NEHA BUS SERVICES PRIVATE LIMITED",
"NEHA BUSINESS AND INVESTMENT PRIVATE LIMITED",
"NEHA COMMERCIAL DESIGNERS PVT LTD",
"NEHA CONSTRUCTION PVT LTD",
"NEHA ELECON SERVICES PRIVATE LIMITED",
"NEHA ENGINEERS AND CONTRACTORS (I) PRIVATE LIMITED",
"NEHA ENTERPRISES",
"NEHA EYE CENTRE PVT LTD",
"NEHA FOREX PRIVATE LIMITED",
"NEHA GARMENTS PRIVATE LIMITED",
"NEHA HERBALS PRIVATE LIMITED",
"NEHA IMPEX PVT.LTD.",
"NEHA INFRADEV PRIVATE LIMITED",
"NEHA JEWELLERS PRIVATE LIMITED.",
"NEHA LIFE SCIENCE PRIVATE LIMITED",
"NEHA LOGISTICS PRIVATE LIMITED",
"NEHA NURSERY PRIVATE LIMITED",
"NEHA PHARMA PVT LTD",
"NEHA POLYMERS PRIVATE LIMITED",
"NEHA POWER TECH (I) PRIVATE LIMITED",
"NEHA PROTECTION SERVICES PRIVATE LIMITED",
"NEHA ROADLINES PRIVATE LIMITED",
"NEHA WUDLAM PRIVATE LIMITED (TREANSER FROM W.B. TO RAJASTHAN",
"NEHAA COSMETICS PRIVATE LIMITED",
"NEHAL HOLDINGS AND TRADINGS COPANY PVT LTD",
"NEHAL IMPORTS PVT LTD",
"NEHAL STEELS PRIVATE LIMITED",
"NEHAL TRADING AND INVESTMENTS PRIVATE LIMITED",
"NEHAN CORPADVISE PRIVATE LIMITED",
"NEHAR ENGINEERING PRIVATE LIMITED",
"NEHAR TRADINGG PRIVATE LIMITED",
"NEHARAJ STOCK BROKERS PRIVATE LIMITED",
"NEHARI INTERMIDIATE COLLEGE KUSHINAGAR",
"NEHARIKA ELECTRICALS PRIVATE LIMITED",
"NEHAT TECH SOLUTIONS PRIVATE LIMITED",
"NEHRU ACADEMY JUNIOR HIGH SCHOOL",
"NEHRU ARTS & SCIENCE COLLEGE",
"NEHRU CENTRE",
"NEHRU COLLEGE OF AERONAUTICS & APPLIED S",
"NEHRU COLLEGE OF MANAGEMENT",
"NEHRU INSTITUTE OF ENGINEERING AND TECHNOLOGY",
"NEHRU INTER COLLEGE",
"NEHRU INTER COLLEGE PAHARPUR SUBHASH UNNAO",
"NEHRU INTER COLLEGE TOPRI",
"NEHRU INTERNATIONAL SCHOOL",
"NEHRU MEMORIAL COLLEGE",
"NEHRU MEMORIAL MUSEUM & LIBRARY",
"NEHRU MEMORIAL TECHNO GLOBAL HOSPITAL",
"NEHRU PLACE HOTELS AND REAL ESTATES PRIVATE LIMITED",
"NEHRU PLACE HOTELS PRIVATE LIMITED",
"NEHRU SCHOOL OF ARCHITECTURE",
"NEHRU SCIENCE CENTRE",
"NEHRU SMARAK INTER COLLEGE",
"NEHRU VIDYALAYA NAIGAON",
"NEHRU WORLD SCHOOL",
"NEHRU YUVA KENDRA SANGATHAN",
"NEHUL TRADERS PRIVATE LIMITED",
"NEI AMSTED SEALS & FORMING LIMITED",
"NEIGHBOURHOOD HOSPITAL PRIVATE LIMITED",
"NEIGHBOURHOOD HOSPITALITY PRIVATE LIMITED",
"NEIL COMPUTECH PRIVATE LIMITED",
"NEIL GOGTE INSTITUTE OF TECHNOLOGY",
"NEIL INDUSTRIES LTD",
"NEIL MAXINFRA PRIVATE LIMITED",
"NEIL PROPERTIES PRIVATE LIMITED",
"NEILMED DEVICES PRIVATE LIMITED",
"NEILSOFT LIMITED",
"NEILSOFT PRIVATE LIMITED",
"NEISS LABS LIMITED",
"NEKKANTI MEGA FOOD PARK PRIVATE LIMITED",
"NEKKANTI SEA FOODS LTD",
"NEKKANTI SYSTEMS PRIVATE LIMITED",
"NEKODA GLOBAL LOGISTICS INDIA PRIVATE LIMITED",
"NEKRTC",
"NEKTAR THERAPEUTICS INDIA PRIVATE LIMITED",
"NELAMANGALA DEVIHALLI EXPRESSWAY PRIVATE LIMITED",
"NELCAST LIMITED",
"NELCO (INDIA) PRIVATE LIMITED",
"NELCO ELECTRICALS PRIVATE LIMITED",
"NELCO LIMITED",
"NELCO NETWORK PRODUCTS LIMITED",
"NELCO SHIELDING SOLUTIONS PRIVATE LIMITED",
"NELCON INDUSTRIES INDIA PRIVATE LIMITED",
"NELES INDIA PRIVATE LIMITED",
"NELITO SYSTEMS PRIVATE LIMITED",
"NELIVIGI MULTISPECIALITY HOSPITAL",
"NELKINDA SOFTWARE CRAFT PRIVATE LIMITED",
"NELL INFOTECH PRIVATE LIMITED",
"NELLAI CONCRETE PRODUCTS AND CONSTRUCTION COMPANY PRIVATE LIMITED",
"NELLAI MOTOR VEHICLE PRIVATE LIMITED",
"NELLAI NADAR MATRICULATION HIGER SECONDARY SCHOOL",
"NELLERISM VENTURES PRIVATE LIMITED",
"NELLIMARLA JUTE MILLS CO LTD",
"NELLORE MUNICIPALITY",
"NELSON ENGINEERS PRIVATE LIMITED",
"NELSON GLOBAL PRODUCTS INDIA PRIVATE LIMITED",
"NELSON HOSPITAL",
"NELSON LAMINATE PRIVATE LIMITED",
"NELSON MEDICARE PRIVATE LIMITED",
"NELSON MEMORIAL CHILDREN'S HOSPITAL PRIVATE LIMITED",
"NELSON PLANNING AND DESIGN PRIVATE LIMITED",
"NELSON PROJECTS PRIVATE LIMITED",
"NELSUN COIR PRODUCTS PRIVATE LIMITED",
"NELSUN PAPER MILL PRIVATE LIMITED",
"NELTNER BUSINESS SERVICES PRIVATE LIMITED",
"NELUMBO ICONA CONTROLS PRIVATE LIMITED",
"NELUX TECHNOLOGIES PRIVATE LIMITED",
"NEM CON PRIME INTERNATIONAL PRIVATE LIMITED",
"NEM INFRA PROJECTS PRIVATE LIMITED",
"NEM LABORATORIES PRIVATE LIMITED",
"NEMA AUTOMOBILES PRIVATE LIMITED",
"NEMA ELDERCARE PRIVATE LIMITED",
"NEMADE ENGINEERS PRIVATE LIMITED",
"NEMAK ALUMINIUM CASTINGS INDIA PRIVATE LIMITED",
"NEMALA INFRASTRUCTURE PRIVATE LIMITED",
"NEMAN CARPETS PRIVATE LIMITED",
"NEMANI PANELS PRIVATE LIMITED",
"NEMANI PLASPACK PRIVATE LIMITED",
"NEMANI PLYWOOD PRIVATE LIMITED",
"NEMANI POLY PRODUCTS PRIVATE LIMITED",
"NEMANI STEELS P LTD",
"NEMARIT ENGINEERING PRIVATE LIMITED",
"NEMAT ENGINEERING PRIVATE LIMITED",
"NEMCARE FOUNDATION",
"NEMCARE HOSPITAL TEZPUR PRIVATE LIMITED",
"NEMCARE HOSPITALS PRIVATE LIMITED",
"NEMCON INFRA PRIVATE LIMITED",
"NEMETSCHEK INDIA PRIVATE LIMITED",
"NEMI LANDMARKS PRIVATE LIMITED",
"NEMICHAND BAMALWA JEWELLERS PRIVATE LIMITED",
"NEMICHAND KHEMRAJ FOREX PRIVATE LIMITED",
"NEMICHAND NIRMAL KUMAR PRIVATE LIMITED",
"NEMINATH ELECTRONICS PRIVATE LIMITED",
"NEMINATH HOMES PRIVATE LIMITED",
"NEMINATH HOUSING PRIVATE LIMITED",
"NEMINATH INFRASTRUCTURE AND DEVELOPERS PVT. LTD.",
"NEMINATH MARMO PRIVATE LIMITED",
"NEMINATH PORTFOLIO MANAGEMENT SERVICES PRIVATE LIMITED",
"NEMINATH WOOD INDUSTRY PRIVATE LIMITED",
"NEMINATHAY METALS PRIVATE LIMITED",
"NEMKO INDIA PRIVATE LIMITED",
"NEMLAXMI BOOKS INDIA PRIVATE LIMITED",
"NEMO SOFTWARE PRIVATE LIMITED",
"NEMO TECHNOLOGIES PRIVATE LIMITED",
"NEMPRAKASH INTREX PRIVATE LIMITED",
"NEMR INDUSTRIES PRIVATE LIMITED",
"NEMUS PHARMACEUTICALS PRIVATE LIMITED",
"NENDRASYS TECHNOLOGIES PRIVATE LIMITED",
"NENI MEMI FOODS PRIVATE LIMITED",
"NENI TECHNOLOGIES PRIVATE LIMITED",
"NENOSYSTEMS CONSULTING SERVICES PRIVATE LIMITED",
"NENSEY POULTRY FARM PVT LTD",
"NEO ALLIANCE HEALTHCARE TECHNOLOGIES PRIVATE LIMITED",
"NEO ALPHAMETRIC INFOTECH PRIVATE LIMITED",
"NEO AUTOMOTIVES PRIVATE LIMITED",
"NEO BRIGHT EXPRESS TRANSPORT PRIVATE LIMITED",
"NEO CAPITAL INFRAWORKS PRIVATE LIMITED",
"NEO CARBONS PVT LTD",
"NEO CARE HEALTH PRIVATE LIMITED",
"NEO COCHIN INFRASTRUCTURE SERVICES PRIVATE LIMITED",
"NEO CRAFTS IMPEX PRIVATE LIMITED",
"NEO DEVELOPERS PRIVATE LIMITED",
"NEO ESSEL DISPOWARE PRIVATE LIMITED",
"NEO FACILITY MANAGEMENT PRIVATE LIMITED",
"NEO FEEDS PRIVATE LIMITED",
"NEO FIBRETECH PRIVATE LIMITED",
"NEO FINCOM PRIVATE LIMITED",
"NEO FOODS PRIVATE LIMITED",
"NEO GALLANT SECURITY SERVICE PRIVATE LIMITED",
"NEO GENESIS ART AND GLASS PRIVATE LIMITED",
"NEO GENESIS INFRATECH PRIVATE LIMITED",
"NEO HEIGHTS BUILDERS & PROMOTERS PRIVATE LIMITED",
"NEO HOME AUTOMATION PRIVATE LIMITED",
"NEO HOSPITAL",
"NEO HOSPITALS PRIVATE LIMITED",
"NEO IMPEX STAINLESS PRIVATE LIMITED",
"NEO IMPRESSIONS PRIVATE LIMITED",
"NEO INDUSTRIES METAL PROCESSING PRIVATE LIMITED",
"NEO INFRACON LIMITED",
"NEO ISPAT PRIVATE LIMITED",
"NEO KINETIC SERVICES INDIA PRIVATE LIMITED",
"NEO LEGNO PRODUCTS PRIVATE LIMITED",
"NEO LUCKYSTAR AUTO ENGINEERING PRIVATE LIMITED",
"NEO MACHINE MFG. CO PVT LTD",
"NEO METALIKS LIMITED",
"NEO MOBILE INDIA PRIVATE LIMITED",
"NEO PACK PLAST INDIA PRIVATE LIMITED",
"NEO PALATES PRIVATE LIMITED",
"NEO PETCON (INDIA) PRIVATE LIMITED",
"NEO PHARMA PRIVATE LIMITED",
"NEO PLAST PVT LTD",
"NEO POLITICALEDGE CONSULTING PRIVATE LIMITED",
"NEO POWER ELECTRONICS AND PROJECTS PRIVATE LIMITED",
"NEO PRECISION ENGINEERING & SERVICES PRIVATE LIMITED",
"NEO PRISM ANALTICAL SOLUTIONS INDIA PRIVATE LIMITED",
"NEO QUANT SOLUTIONS PRIVATE. LIMITED",
"NEO RADIANT PAINTS PVT LTD",
"NEO SAFETY PRODUCTS PRIVATE LIMITED",
"NEO SEAMLESS TUBES LIMITED",
"NEO SEEDS INDIA PRIVATE LIMITED",
"NEO SENSE VECTOR TECHNOLOGY PRIVATE LIMITED",
"NEO SNOW AMUSEMENTS AND PARKS INDIA PRIVATE LIMITED",
"NEO SOFT TECHNOLOGIES INTERNATIONAL",
"NEO SOLREN PRIVATE LIMITED",
"NEO STAR ENGINEERING PRIVATE LIMITED",
"NEO STIK TAPES PRIVATE LIMITED",
"NEO STRUCTO CONSTRUCTION PRIVATE LIMITED",
"NEO SUN INDUSTRIES LIMITED",
"NEO SURGITECH PRIVATE LIMITED",
"NEO TECH AMUSEMENTS AND RESORTS PRIVATE LIMITED",
"NEO TECH ENERGY SYSTEMS PRIVATE LIMITED",
"NEO THERMAL INSULATION (INDIA) PRIVATE LIMITED",
"NEO TRANS LOGISTICS PRIVATE LIMITED",
"NEO VEHICLEAIDS PRIVATE LIMITED",
"NEO VISION EYE CARE & LASER CENTRE PRIVATE LIMITED",
"NEO WEALTH MANAGEMENT PRIVATE LIMITED",
"NEO WHEELS LIMITED (CN)",
"NEO WIRES AND ALLIED PRODUCTS PRIVATE LIMITED",
"NEO ZINC OXIDE PRIVATE LIMITED",
"NEOAEGIS MEDICARE PRIVATE LIMITED",
"NEOAIRTECH INDIA PRIVATE LIMITED",
"NEOARC EXIM PRIVATE LIMITED",
"NEOASTRA DRUGS PRIVATE LIMITED",
"NEOASTRA SYSTEMS INDIA PRIVATE LIMITED",
"NEOBILLION FINTECH PRIVATE LIMITED",
"NEOBLISS HEALTH SERVICES PRIVATE LIMITED",
"NEOBRIC IT SOLUTIONS PRIVATE LIMITED",
"NEOBYTES SOFTWARE SOLUTIONS PRIVATE LIMITED",
"NEOCAB POWER PRIVATE LIMITED",
"NEOCANDY CHILDREN'S HOSPITAL PRIVATE LIMITED",
"NEOCAST ALLOYS PRIVATE LIMITED",
"NEOCEPTS PRIVATE LIMITED",
"NEOCHEM TECHNOLOGIES PRIVATE LIMITED",
"NEOCHLORUS ENERGY SOLUTIONS PRIVATE LIMITED",
"NEOCHLORUS SOLAR SOLUTIONS PRIVATE LIMITED",
"NEOCORP ENGINEERING PRIVATE LIMITED",
"NEOCRETE TECHNOLOGIES PRIVATE LIMITED",
"NEODX BIOTECH LABS PRIVATE LIMITED",
"NEOEYED INC",
"NEOGAL POWER COMPANY PVT LIMITED",
"NEOGEN CHEMICALS LIMITED",
"NEOGEN DIAGNOSTICS & POLY CLINIC PRIVATE LIMITED",
"NEOGEN DOORS PRIVATE LIMITED",
"NEOGEN FOOD AND ANIMAL SECURITY (INDIA) PRIVATE LIMITED",
"NEOGEN FOOD AND ANIMAL SECURITY INDIA PRIVATE LIMITED",
"NEOGEN LABS PRIVATE LIMITED",
"NEO-GENE AGRI INPUTS PRIVATE LIMITED",
"NEOGENETICS FOODS PRIVATE LIMITED",
"NEOGI STATIONERY SERVICES PRIVATE LIMITED",
"NEOGI TECHNOLOGIES AND RESEARCH PRIVATE LIMITED",
"NEOGRAFIKS (INDIA) PRIVATE LIMITED",
"NEOGROWTH CREDIT PRIVATE LIMITED",
"NEOITO TECHNOLOGIES PRIVATE LIMITED",
"NEOKRAFT GLOBAL PRIVATE LIMITED",
"NEOKRAFT MEDICAL PRIVATE LIMITED",
"NEOLAND PROJECTS PRIVATE LIMITED",
"NEOLIFE MULTISPECIALITY HOSPITAL PRIVATE LIMITED",
"NEOLITE BUILDCON PRIVATE LIMITED",
"NEOLITE ZKW LIGHTINGS PRIVATE LIMITED",
"NEOLITHIC CERAMICA PRIVATE LIMITED",
"NEOLOBA SPECIALTY PRIVATE LIMITED",
"NEOLOGIC ENGINEERS PRIVATE LIMITED",
"NEOLOGIE BIO-INNOVATIONS (I) PRIVATE LIMITED",
"NEOLOGIX SOFTWARE SOLUTIONS INDIA PRIVATE LIMITED",
"NEOLOTEX BUSINESS SOLUTIONS PRIVATE LIMITED",
"NEOLYNC ELECTRONICS PRIVATE LIMITED",
"NEOLYNC SOLUTIONS PRIVATE LIMITED",
"NEOLYNC TELE COMMUNICATIONS PRIVATE LIMITED",
"NEOM TRADING AND TECHNOLOGY SERVICES PRIVATE LIMITED",
"NEOMA SERVICES PRIVATE LIMITED",
"NEOMAC PHARMACEUTICALS PRIVATE LIMITED",
"NEOMAX PROPERTIES PRIVATE LIMITED",
"NEOMAX REALTORS PRIVATE LIMITED",
"NEOMAXX LIGHTS PRIVATE LIMITED",
"NEOMEDIISPECS PRIVATE LIMITED",
"NEOMEDIX HEALTHCARE INDIA PRIVATE LIMITED",
"NEOMETRIX DEFENCE LIMITED",
"NEOMI PHARMACEUTICALS PRIVATE LIMITED",
"NEOMILE CORPORATE ADVISORY LIMITED",
"NEOMIS ENTERPRISES PRIVATE LIMITED",
"NEOMOTION ASSISTIVE SOLUTIONS PRIVATE LIMITED",
"NEON CABLES PRIVATE LIMITED",
"NEON FABRICATIONS PRIVATE LIMITED",
"NEON FUEL LIMITED",
"NEON INTERNATIONAL PRIVATE LIMITED",
"NEON LABORATORIES LIMITED",
"NEON METAL INDUSTRIES",
"NEON METALS IMPEX PRIVATE LIMITED",
"NEON MOTORS PRIVATE LIMITED",
"NEON PROPERTIES PRIVATE LIMITED.",
"NEON SECURITY AGENCY PRIVATE LIMITED",
"NEON STRAPS PRIVATE LIMITED",
"NEON TECHNOCAST PRIVATE LIMITED",
"NEONATAL CARE & RESEARCH INSTITUTE PRIVATE LIMITED",
"NEONEX NEWBORN HOSPITAL PRIVATE LIMITED",
"NEONICHE INTEGRATED SOLUTIONS PRIVATE LIMITED",
"NEONITE CONSUMER PRODUCTS PRIVATE LIMITED",
"NEONSCAPE PAINTS & COATINGS PRIVATE LIMITED",
"NEOPACK ENTERPRISE PRIVATE LIMITED",
"NEOPATH DIAGNOSTICS EXCELLENCE",
"NEOPERKS MARKETING SOLUTIONS PRIVATE LIMITED",
"NEOPERL INDIA PRIVATE LIMITED",
"NEOPLAST ENGINEERING PRIVATE LIMITED",
"NEOPOWER TECHNOLOGIES PRIVATE LIMITED",
"NEOPRIME PRIVATE LIMITED",
"NEORA TILES PRIVATE LIMITED",
"NEORAJKOT FOUNDATION",
"NEORANGERS SERVICES PRIVATE LIMITED",
"NEORIS CONSULTING SERVICES INDIA PRIVATE LIMITED",
"NEOS AIR FILTRATION PRIVATE LIMITED",
"NEOSA ELECTRONICS PRIVATE LIMITED",
"NEOSALPHA TECHNOLOGIES INDIA PRIVATE LIMITED",
"NEOSAY TECHNOLOGIES AND SOLUTIONS PRIVATE LIMITED",
"NEOSCIENCE LABS PRIVATE LIMITED",
"NEOSEAL ADHESIVE PRIVATE LIMITED",
"NEOSEAL ENGINNEERING PRIVATE LIMITED",
"NEOSINMAR DEVELOPERS PRIVATE LIMITED",
"NEOSIS LOGISTICS PRIVATE LIMITED",
"NEOSOFT TECHNOLOGIES AND SOFTWARE LIMITED",
"NEOSOL TECHNOLOGIES PRIVATE LIMITED",
"NEOSPAN PHARMA CARE PRIVATE LIMITED",
"NEOSPARK DRUGS AND CHEMICALS PRIVATE LIMITED",
"NEOSTAR REALTY PRIVATE LIMITED",
"NEOSTAR VENTURES PRIVATE LIMITED",
"NEOSYM INDUSTRY LIMITED",
"NEOTAS DEVELOPMENT PRIVATE LIMITED",
"NEOTECH COMPANY PRIVATE LIMITED",
"NEOTECH EDUCATION FOUNDATION",
"NEOTECH EQUIPMENTS PRIVATE LIMITED",
"NEOTECH GLOBAL PRIVATE LIMITED",
"NEOTECH MEDICAL PRIVATE LIMITED",
"NEOTECH NUTRIENTS PRIVATE LIMITED",
"NEOTECRA INDIA PRIVATE LIMITED",
"NEOTEL COMMUNICATIONS PRIVATE LIMITED",
"NEOTERIC AGRI SOLUTIONS LIMITED",
"NEOTERIC AGRO VENTURES PRIVATE LIMITED",
"NEOTERIC CREATIONS PRIVATE LIMITED",
"NEOTERIC GLOBE SERVICES PRIVATE LIMITED",
"NEOTERIC INVESTMENT AND TRADING CO. PVT LTD",
"NEOTERIC PRECITECH PRIVATE LIMITED",
"NEOTERIC SYSTEMS PVT LTD",
"NEOTEX POLYMER & PACKAGING PRIVATE LIMITED",
"NEOTI BOOK AGENCY PRIVATE LIMITED",
"NEOTISS LIMITED",
"NEOTREX STEEL LIMITED",
"NEOTRONIKS PRIVATE LIMITED",
"NEOVA BIOGENE PRIVATE LIMITED",
"NEOVA SOLUTIONS PRIVATE LIMITED",
"NEOVAE BIO MEDICS PRIVATE LIMITED",
"NEOVANTAGE BIO-TECHNOLOGY PRIVATE LIMITED",
"NEOVANTAGE INNOVATION PARK PRIVATE LIMITED",
"NEOVANTAGE SCIENCE & TECHNOLOGY PARK PRIVATE LIMITED",
"NEOVATIC TECHNOLOGIES PRIVATE LIMITED",
"NEOVATION CONSULTANCY SERVICES",
"NEOVATION GRAPHICS PRIVATE LIMITED",
"NEOVATUS HEALTH SOLUTIONS PRIVATE LIMITED",
"NEOVEL PHARMA PRIVATE LIMITED",
"NEOVIA LOGISTICS SERVICES INDIA PRIVATE LIMITED",
"NEOWARE TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"NEOWORTH COMMERCIAL PVT LTD",
"NEOWORTH VYAPAAR PRIVATE LIMITED",
"NEOZ ENERGY PRIVATE LIMITED",
"NEOZONE SUPPLIERS PRIVATE LIMITED",
"NEOZONE VYAPAAR PRIVATE LIMITED",
"NEP INDIA PRIVATE LIMITED",
"NEPA INDIA PRIVATE LIMITED",
"NEPA LTD",
"NEPA PRODUCTION INDIA PRIVATE LIMITED",
"NEPAL RASTRIYA BANK KATHMANDU",
"NEPANI COMPONENTS AND SYSTEMS PRIVATE LIMITED",
"NEPC AGRO FOODS LIMITED",
"NEPC TEXTILES LIMITED",
"NEPCON INDIA PRIVATE LIMITED",
"NEPENTHE COFFEE AND CHOCOLATES PRIVATE LIMITED",
"NEPHCORE INDIA PRIVATE LIMITED",
"NEPHRITE INFOTECH AND LEASING PRIVATE LIMITED",
"NEPHRO CARE INDIA PRIVATE LIMITED",
"NEPHRO CRAFT PRIVATE LIMITED",
"NEPHROCARE HEALTH SERVICES PRIVATE LIMITED",
"NEPHRON HOSPITALS PRIVATE LIMITED",
"NEPHROWORLD PRIVATE LIMITED",
"NEPHUROCARE PHARMA PRIVATE LIMITED",
"NEPRA ENVIRONMENTAL SOLUTIONS PRIVATE LIMITED",
"NEPRA RESOURCE MANAGEMENT PRIVATE LIMITED",
"NEPS TECHNOLOGIES PRIVATE LIMITED",
"NEPTUNE AUTOMATIC PRIVATE LIMITED",
"NEPTUNE CAST PRIVATE LIMITED",
"NEPTUNE CHEM (INDIA) PRIVATE LIMITED",
"NEPTUNE CHEMPASTEL PRIVATE LIMITED",
"NEPTUNE CONTROLS PRIVATE LIMITED",
"NEPTUNE CORPORATE SERVICES PRIVATE LIMITED",
"NEPTUNE DIAMONDS PRIVATE LIMITED",
"NEPTUNE ENGINEERING PRIVATE LIMITED",
"NEPTUNE FAIRDEAL PRODUCTS PRIVATE LIMITED",
"NEPTUNE FINANCIAL SOFTWARE PRIVATE LIMITED",
"NEPTUNE FOREX PRIVATE LIMITED",
"NEPTUNE HOLIDAYS PRIVATE LIMITED",
"NEPTUNE HYDROCARBONS MFG PRIVATE LIMITED",
"NEPTUNE INDIA LIMITED",
"NEPTUNE INDUSTRIES LIMITED",
"NEPTUNE INFOSOFT PRIVATE LIMITED",
"NEPTUNE INFOSOLUTIONS PRIVATE LIMITED",
"NEPTUNE INFRASPACE PRIVATE LIMITED",
"NEPTUNE ISPAT PRIVATE LIMITED",
"NEPTUNE LAMINATES PRIVATE LIMITED",
"NEPTUNE LIFESCIENCES PVT LTD",
"NEPTUNE LIGHTS INDIA PRIVATE LIMITED",
"NEPTUNE ORTHOPAEDICS PRIVATE LIMITED",
"NEPTUNE PACKAGING PRIVATE LIMITED",
"NEPTUNE POLYMERS PVT LTD",
"NEPTUNE READYMIX CONCRETE PRIVATE LIMITED",
"NEPTUNE REAL ESTATE PRIVATE LIMITED",
"NEPTUNE REALTY PRIVATE LIMITED",
"NEPTUNE REFRIGERATION CO PRIVATE LIMITED",
"NEPTUNE SUPPLIERS PRIVATE LIMITED",
"NEPTUNE TOURS & TRAVELS PRIVATE LIMITED",
"NEPTUNE TRADERS PVT LTD",
"NEPTUNE TRAVELS INDIA PRIVATE LIMITED",
"NEPTUNE UBICOM PRIVATE LIMITED",
"NEPTUNETRANS LOGISTICS PRIVATE LIMITED",
"NEPTUNUS POWER PLANT SERVICES PRIVATE LIMITED",
"NEPUCHAPUR TEA CO LTD",
"NEPZ PACK INDUSTRIES PRIVATE LIMITED",
"NER AGRO INDUSTRIES LIMITED",
"NER II TRANSMISSION LIMITED",
"NER SCHOOL OF EXCELLENCE",
"NERC SOLUTIONS LLP",
"NERDAPPLABS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"NERDPINE SOLUTIONS PRIVATE LIMITED",
"NEREUS CONSULTANTS PRIVATE LIMITED",
"NEREUS MARINE PRIVATE LIMITED",
"NEREUS SPORT PRODUCTS PRIVATE LIMITED",
"NERFBLUT SCREEN MEDICAL SERVICES PRIVATE LIMITED",
"NERI LIGHTING INDIA PRIVATE LIMITED",
"NERIDA SHIPPING PRIVATE LIMITED",
"NERKA CHEMICALS PRIVATE LIMITED",
"NEROFIX PRIVATE LIMITED",
"NEROLEX POLYPLAST PRIVATE LIMITED",
"NEROLI BEAUTY SERVICES PRIVATE LIMITED",
"NEROTEK TAPES PRIVATE LIMITED",
"NEROTH PLANTATIONS PVT LTD",
"NERVE SOLUTIONS",
"NERYA PRIVATE LIMITED",
"NES GLOBAL SPECIALIST ENGINEERING SERVICES PRIVATE LIMITED",
"NES INTERNATIONAL SCHOOL MUMBAI",
"NES MEDICORP PRIVATE LIMITED",
"NESA PUMPS PRIVATE LIMITED",
"NESAM FINSERVE INDIA PRIVATE LIMITED",
"NESAN COLOURS PRIVATE LIMITED",
"NESANS MINING AND AUTOMATION PRIVATE LIMITED",
"NESAR FARM INPUTS PRIVATE LIMITED",
"NESAVU TEXTILES INDIA PRIVATE LIMITED",
"NESBEE SPICES & FOODS PRIVATE LIMITED",
"NESCA TECH PRIVATE LIMITED",
"NESCO INFOSYSTEM PRIVATE LIMITED",
"NESCO LIMITED",
"NESH INDIA INFRASTRUCTURE PRIVATE LIMITED",
"NESH INFO TECH PRIVATE LIMITED",
"NESH LOGITECH SOLUTIONS PRIVATE LIMITED",
"NESH TECHNOLOGIES PRIVATE LIMITED",
"NESHIEL AGROCHEM PRIVATE LIMITED",
"NESHLA FOODS PRIVATE LIMITED",
"NESHO RECYCLING WORLD PRIVATE LIMITED",
"NESKEB CABLES PRIVATE LIMITED",
"NESL E-INFRASTRUCTURE LIMITED",
"NESS DIGITAL ENGINEERING INDIA PRIVATE LIMITED",
"NESS WADIA COLLEGE OF COMMERCE",
"NESSA HEARING INDIA PRIVATE LIMITED",
"NESSA SHIP MANAGEMENT PRIVATE LIMITED",
"NEST 3RD PARTY LOGISTICS PRIVATE LIMITED",
"NEST CHILDREN HOSPITALS PRIVATE LIMITED",
"NEST EDU-SOLUTION LLP",
"NEST HABITATION DEVELOPERS PRIVATE LIMITED",
"NEST HEALTHCARE PRIVATE LIMITED",
"NEST HOTELS AND RESORTS (KODAIKANAL) PRIVATE LIMITED",
"NEST INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"NEST INNOVATIVE SOLUTIONS PRIVATE LIMITED",
"NEST 'N MIST HOSPITALITY PRIVATE LIMITED",
"NEST PHARMA PRIVATE LIMITED",
"NEST ZONE INDIA PRIVATE LIMITED",
"NESTART EXHIBIT INDIA PRIVATE LIMITED",
"NESTAWAY INDIA PRIVATE LIMITED",
"NESTAWAY TECHNOLOGIES PRIVATE LIMITED",
"NESTCON SHELTERS PRIVATE LIMITED",
"NESTECH CONSULTING PRIVATE LIMITED",
"NESTING RACKS PRIVATE LIMITED",
"NESTIVA HEALTHCARE PRIVATE LIMITED",
"NESTIVA MEDICARE PRIVATE LIMITED",
"NESTLE INDIA LIMITED",
"NESTLER PROTEC (INDIA) LIMITED",
"NESTLER YARNS PRIVATE LIMITED",
"NESTLING TECHNOLOGIES INDIA PRIVATE LIMITED",
"NESTLINKS IMPEX PRIVATE LIMITED",
"NESTOR CONVERTERS PRIVATE LIMITED",
"NESTOR HOTELS PRIVATE LIMITED",
"NESTOR INDUSTRIES PRIVATE LIMITED",
"NESTOR PHARMACEUTICALS LIMITED",
"NESTORIA BUILDCON PRIVATE LIMITED",
"NESTOYA HOMES PRIVATE LIMITED",
"NESTPRO GLOBAL PRIVATE LIMITED",
"NET 4 U SERVICES PRIVATE LIMITED",
"NET 9 ONLINE HATHWAY PRIVATE LIMITED",
"NET ACCESS INDIA LIMITED",
"NET ANALYTICS LLC (A UNIT OF AVANZAR SOLUTION )",
"NET AVENUE TECHNOLOGIES LIMITED",
"NET AVENUE TECHNOLOGIES PRIVATE LIMITED",
"NET BROKERES PRIVATE LIMITED",
"NET BUSINESS SOLUTIONS PRIVATE LIMITED",
"NET CASCADE AUTOMATION PRIVATE LIMITED",
"NET CHECK SOLUTIONS INDIA PRIVATE LIMITED",
"NET COMMUNICATION I PRIVATE LIMITED",
"NET CONNECT PRIVATE LIMITED",
"NET CRADLE INDIA PRIVATE LIMITED",
"NET DISTRIBUTION SERVICES PRIVATE LIMITED",
"NET EMPLOYMENT SERVICES PRIVATE LIMITED",
"NET ENERGY PRIVATE LIMITED",
"NET GURU LIMITED",
"NET MAGNUS SOLUTIONS INDIA PRIVATE LIMITED",
"NET PARADIGM INDIA PRIVATE LIMITED",
"NET RIGHT TECHNOLOGIES PRIVATE LIMITED",
"NET SQUARE SOLUTIONS PRIVATE LIMITED",
"NET TECH SERVICES INDIA PRIVATE LIMITED",
"NET VIGIL SOFTWARE PRIVATE LIMITED",
"NET WORK LEATHER GOODS PRIVATE LIMITED",
"NET WORKS EXPORTS PVT LTD",
"NET.ORANGE TECHNOLOGIES PRIVATE LIMITED",
"NET2SOURCE CONSULTING LIMITED",
"NET4NUTS LIMITED",
"NET4SITE CONSULTING INDIA PRIVATE LIMITED",
"NET7 TECHNOLOGY SOLUTIONS INDIA PRIVATE LIMITED",
"NETA ENGINEERING WORKS PRIVATE LIMITED",
"NETA SECURITY SERVICES PRIVATE LIMITED",
"NETAFIM AGRICULTURAL FINANCING AGENCY PRIVATE LIMITED",
"NETAFIM IRRIGATION INDIA PRIVATE LIMITED",
"NETAI CHARAN DEY COLD STORAGE PVT LTD",
"NETAI STATIONERY WORKS PRIVATE LIMITED",
"NETAJI APPAREL PARK",
"NETAJI ENGLISH MEDIUM SCHOOL",
"NETAJI OIL DEPOT PRIVATE LIMITED",
"NETAJI SUBHAS CHANDRA BOSE CANCER HOSPITAL",
"NETAJI SUBHAS CHANDRA BOSE VIDYALAYA KINGAON",
"NETAJI SUBHAS INSTITUTE OF TECHNOLOGY",
"NETAJI SUBHAS MEDICAL COLLEGE AND HOSPITAL",
"NETAJI SUBHAS MEMORIAL CITY COLLEGE",
"NETAJI SUBHAS UNIVERSITY OF TECHNOLOGY",
"NETAJI SUBHASH CHANDRA BOSE GOVERMENT GIRLS COLLEGE SEONI",
"NETAJI SUBHASH CHANDRA BOSE GOVT MEDICAL COLLAGE",
"NETAJI SUBHASH CHANDRA BOSE INTER COLLAGE",
"NETAJI SUBHASH CHANDRA BOSE MEDICAL COLLEGE JABALPUR",
"NETAJI SUBHASH ENGINEERING COLLEGE",
"NETAJI SUBHASHACHANDRA BOS VIDYALAYA KINGAON",
"NETAJI SUBHASHCHANDRA BOSE BOY'S MILITRY SCHOOL",
"NETAJI SUBHASHCHANDRA BOSE SEC AND HIGH SEC SCHOOL PANBHOSI",
"NETAJI SUBHASHCHANDRA BOSE UCH PRATHMIK SHALA",
"NETAJINAGAR COLLEGE",
"NETAJINAGAR COLLEGE FOR WOMEN",
"NETAJINAGAR DAY COLLEGE",
"NETALTER SOFTWARE LIMITED",
"NETAMBIT INFOSOURCE AND E SERVICES PRIVATE LIMITED",
"NETAMBIT INSURANCE BROKING INDIA LIMITED",
"NETAMBIT VALUEFIRST SERVICES PRIVATE LIMITED",
"NETANALYTIKS TECHNOLOGIES PRIVATE LIMITED",
"NETAPP INDIA MARKETING AND SERVICES PRIVATE LIMITED",
"NETAPP INDIA PRIVATE LIMITED",
"NETAXIS IT SOLUTIONS PRIVATE LIMITED",
"NETBUSINESS SOLUTIONS (INDIA) LIMITED",
"NETCARROTS COM PRIVATE LIMITED",
"NETCLUES TECHNOLOGIES PRIVATE LIMITED",
"NETCO CABLE INDUSTRIES PRIVATE LIMITED",
"NETCO CONVERGE PRIVATE LIMITED",
"NETCOM IMPO EXPO PRIVATE LIMITED",
"NETCOM INFOTECH PRIVATE LIMITED",
"NETCOM LEARNING INDIA PRIVATE LIMITED",
"NETCOM SOFTECH PRIVATE LIMITED",
"NETCOMINFRA PRIVATE LIMITED",
"NETCOMM IT SOLUTIONS PRIVATE LIMITED",
"NETCOMM LABS PRIVATE LIMITED",
"NETCON CONSTRUCTION PRIVATE LIMITED",
"NETCON TECHNOLOGIES INDIA PRIVATE LIMITED",
"NETCONV IT INFRA SOLUTIONS PRIVATE LIMITED",
"NETCORE CLOUD PRIVATE LIMITED",
"NETCRACKER ONLINE SERVICES PRIVATE LIMITED",
"NETCRACKER TECHNOLOGY INDIA PRIVATE LIMITED",
"NETCRACKER TECHNOLOGY SOLUTIONS (INDIA) PRIVATE LIMITED",
"NETCRAFT RETAIL SOLUTIONS PRIVATE LIMITED",
"NETCREATIVEMIND SOLUTIONS PRIVATE LIMITED",
"NET-DOT SOLUTIONS PRIVATE LIMITED",
"NETE RETAIL PRIVATE LIMITED",
"NETEDGE TECHNOLOGY PRIVATE LIMITED",
"NETEL INDIA LIMITED",
"NETELEC TECHNOLOGIES PRIVATE LIMITED",
"NETELIXIR EMARKETING SOLUTIONS PRIVATE LIMITED",
"NETENRICH TECHNOLOGIES PRIVATE LIMITED",
"NETERSON TECHNOLOGIES PRIVATE LIMITED",
"NETERWALA AIBARA LLP",
"NETESOFT INDIA LIMITED",
"NETFAB ENGINEERING PRIVATE LIMITED",
"NETFIL TECHNIK PRIVATE LIMITED",
"NETFLEX HOMES PRIVATE LIMITED",
"NETFLEX INDIA PRIVATE LIMITED",
"NETFLIX ENTERTAINMENT SERVICES INDIA LLP",
"NETFLOW TECHNOLOGIES INDIA PRIVATE LIMITED",
"NETFORCHOICE SOLUTIONS PRIVATE LIMITED",
"NETFUSION SERVICES PRIVATE LIMITED",
"NETGAINS INDIA INTERNET PRIVATE LIMITED",
"NETGAINS NETWORK SOLUTION PRIVATE LIMITED",
"NETGAINS TECHNOLOGIES PRIVATE LIMITED",
"NETGEAR RESEARCH INDIA PRIVATE LIMITED",
"NETGEAR TECHNOLOGIES INDIA PRIVATE LIMITED",
"NETHAAT INTERACTIVE SOLUTIONS PRIVATE LIMITED",
"NETHAWK NETWORKS INDIA PRIVATE LIMITED",
"NETHERLANDS INDIA COMMUNICATIONS ENTERPRISES LIMITED",
"NETHORITY TECHNOLOGIES PRIVATE LIMITED",
"NETHRA CROP SCIENCES PRIVATE LIMITED",
"NETHRA ELECTRICALS INDIA PRIVATE LIMITED",
"NETHRA ENGINEERING PRIVATE LIMITED",
"NETHRA HOMOEOPATHY MEDICAL COLLEGE HOS",
"NETHRADHAMA HOSPITALS PRIVATE LIMITED",
"NETHUB SERVICES PRIVATE LIMITED",
"NETHUES TECHNOLOGIES PRIVATE LIMITED",
"NETI FABRICS PRIVATE LIMITED",
"NETIAPPS SOFTWARE PRIVATE LIMITED",
"NETIMPACT SOLUTIONS PRIVATE LIMITED",
"NETINCON LOGISTICS PRIVATE LIMITED",
"NETINCON MARKETING PRIVATE LIMITED",
"NETIP TECHNOLOGIES PRIVATE LIMITED",
"NETIZENS FOUNDATION SCHOOL",
"NETLAB SOLUTIONS INDIA PRIVATE LIMITED",
"NETLABS GLOBAL IT SERVICES PRIVATE LIMITED",
"NETLEON TECHNOLOGIES PRIVATE LIMITED",
"NETLINK BUSINESS SYSTEMS PRIVATE LIMITED",
"NETLINK DIGITAL SOLUTION INDIA PRIVATE LIMITED",
"NETLINK ICT PRIVATE LIMITED",
"NETLINK SOFTWARE PRIVATE LIMITED",
"NETLINK STRATEGIC SOLUTIONS PRIVATE LIMITED",
"NETLINKS BUSINESS CONSULTANTS (INDIA) PRIVATE LIMITED",
"NETLOGIC SYSTEMS (INDIA) PRIVATE LIMITED",
"NETLYNX SOLUTIONS PRIVATE LIMITED",
"NETMAGIC SOLUTIONS PRIVATE LIMITED",
"NETMATRIX CROP CARE LIMITED",
"NETMATRIX CROP CARE PRIVATE LIMITED",
"NETMECH ENGINEERING PRIVATE LIMITED",
"NETMEDS HEALTHCARE LIMITED",
"NETMINI ENTERPRISES PRIVATE LIMITED",
"NETMONASTERY NETWORK SECURITY PRIVATE LIMITED",
"NETNEX GLOBAL PRIVATE LIMITED",
"NETNUBE TECHNOLOGIES PRIVATE LIMITED",
"NETNXT NETWORK PRIVATE LIMITED",
"NETOBJEX (INDIA) PRIVATE LIMITED",
"NETOBYTE INDIA PRIVATE LIMITED",
"NETOPS FIBER SOLUTIONS LLP",
"NETOSTING TECHNOLOGIES PRIVATE LIMITED",
"NETPACE TECHNOLOGIES AND SOLUTIONS PRIVATE LIMITED",
"NETPEOPLE KART PRIVATE LIMITED",
"NETPLACE TECHNOLOGIES PRIVATE LIMITED",
"NETPLAST PRIVATE LIMITED",
"NETPLAY SPORTS PRIVATE LIMITED",
"NETPRO ENGINEERING PRIVATE LIMITED",
"NETPRO RENEWABLE ENERGY(INDIA)PRIVATE LIMITED.",
"NETPROMEDIA ADVERTISING PRIVATE LIMITED",
"NETPROPHETS CYBERWORKS PRIVATE LIMITED",
"NETPULSE SERVICES INDIA PRIVATE LIMITED",
"NETQOM SOFTWARE PRIVATE LIMITED",
"NETQUALL TECHNOLOGIES PRIVATE LIMITED",
"NETRA DIAGNOSTICS PRIVATE LIMITED",
"NETRA POLYPLAST PRIVATE LIMITED",
"NETRA SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"NETRACK ENCLOSURES PRIVATE LIMITED",
"NETRADEEP EYE HOSPITAL PRIVATE LIMITED",
"NETRADYNE TECHNOLOGY INDIA PRIVATE LIMITED",
"NETRAM EYE HOSPITAL AND CORNEAL CENTRE",
"NETRAVATI POLYPACK PRIVATE LIMITED",
"NETRI BUILDCON INDIA PRIVATE LIMITED",
"NETRIKA CONSULTING INDIA PRIVATE LIMITED",
"NETRIPPLES SOFTWARE LIMITED",
"NETRIX WORLDWIDE PRIVATE LIMITED",
"NETRO ENTERPRISES (OPC) PRIVATE LIMITED",
"NETRO NETWORKS PRIVATE LIMITED",
"NETRONIX TECHNOLOGIES",
"NETROVERT SOFTWARE PRIVATE LIMITED",
"NETSCAPE VENTURES PRIVATE LIMITED",
"NETSCORE TECHNOLOGIES PRIVATE LIMITED",
"NETSCOUT SYSTEMS INDIA PRIVATE LIMITED",
"NETSCOUT SYSTEMS SOFTWARE INDIA PRIVATE LIMITED",
"NETSCRIBES DATA & INSIGHTS PRIVATE LIMITED",
"NETSCRIBES INDIA PRIVATE LIMITED",
"NETSENTRIES INFOSEC SOLUTIONS PRIVATE LIMITED",
"NETSET SOFTWARE PRIVATE LIMITED",
"NETSETGO MEDIA PRIVATE LIMITED",
"NETSHAPE ENGINEERING SERVICES PRIVATE LIMITED",
"NETSITY SYSTEMS PRIVATE LIMITED",
"NETSKOPE SOFTWARE INDIA PRIVATE LIMITED",
"NETSMARTZ INFOTECH INDIA PRIVATE LIMITED",
"NETSOFTERS LLP",
"NETSOL IT SOLUTIONS PRIVATE LIMITED",
"NETSOL NETWORK CONSULTANCY PRIVATE LIMITED",
"NETSOL WATER SOLUTIONS PRIVATE LIMITED",
"NETSOPHY PRIVATE LIMITED",
"NETSPACE INFOSOLUTIONS PRIVATE LIMITED",
"NETSPI INDIA PRIVATE LIMITED",
"NETSPIDER INFOTECH INDIA LIMITED",
"NETSQUARE AUTOMATION PRIVATE LIMITED",
"NETSTACK INFRATECH PRIVATE LIMITED",
"NETSTERZ INFOTECH PRIVATE LIMITED",
"NETSURE IT SOLUTION PRIVATE LIMITED",
"NETSURF COMMUNICATIONS PRIVATE LIMITED",
"NETSURF RESEARCH LABS PRIVATE LIMITED",
"NETSURION TECHNOLOGIES PRIVATE LIMITED",
"NETSUTRA",
"NETTANTRA TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"NETTEL SOLUTIONS PRIVATE LIMITED",
"NETTER HEALTHCARE PRIVATE LIMITED",
"NETTIGRITTY PRIVATE LIMITED",
"NETTLES VINIMAY PRIVATE LIMITED",
"NETTLINX TECHNOLOGIES PRIVATE LIMITED",
"NETTUR TECHNICAL TRAINING FOUNDATION",
"NETTX MARKETING SERVICES",
"NETTY BRAINS PRIVATE LIMITED",
"NETURIA LAMPS LTD",
"NETVERK STEEL & CONSTRUCTION SOLUTIONS PRIVATE LIMITED",
"NETVISION AWADH NETWORKS PRIVATE LIMITED",
"NETWARE COMPUTERS PRIVATE LIMITED",
"NETWARE SYSTEMS PRIVATE LIMITED",
"NETWAY HOME PRODUCTS (INDIA) PRIVATE LIMITED",
"NETWAY INDIA PRIVATE LIMITED",
"NETWAY INTERNET PRIVATE LIMITED",
"NETWEB SOFTWARE PRIVATE LIMITED",
"NETWEB TECHNOLOGIES INDIA LIMITED",
"NETWEB TECHNOLOGIES INDIA PRIVATE LIMITED",
"NETWIN AGRO & BIOTECH PRIVATE LIMITED",
"NETWIN INFOSOLUTIONS PRIVATE LIMITED",
"NETWIN SYSTEMS AND SOFTWARE INDIA PRIVATE LIMITED",
"NETWIN VENTURES PRIVATE LIMITED",
"NETWOOD ENTERTAINMENT INDUSTRY PRIVATE LIMITED",
"NETWORK 4 BARTER PRIVATE LIMITED",
"NETWORK ADVERTISING PVT LTD",
"NETWORK AIRLINE SERVICES PRIVATE LIMITED",
"NETWORK BULLS TECHNOLOGIES PRIVATE LIMITED",
"NETWORK BULLSTUDY PRIVATE LIMITED",
"NETWORK CABLE SOLUTIONS PRIVATE LIMITED",
"NETWORK CARRYING COMPANY PRIVATE LIMITED",
"NETWORK CLOTHING COMPANY PRIVATE LIMITED",
"NETWORK COMPONENTS PRIVATE LIMITED",
"NETWORK DETECTIVE AGENCY PRIVATE LIMITED",
"NETWORK ELECTRODEVICES PRIVATE LIMITED",
"NETWORK FOR ENGINEERING & ECO RESEARCH & MANAGEMENT PRIVATE LIMITED",
"NETWORK INDUSTRIES LIMITED",
"NETWORK INFORMATICS PRIVATE LIMITED",
"NETWORK INTEGRATORS INDIA PRIVATE LIMITED",
"NETWORK INTELLIGENCE INDIA PRIVATE LIMITED",
"NETWORK LIMITED",
"NETWORK LOGISTICS PRIVATE LIMITED",
"NETWORK MARVELS (INDIA) PRIVATE LIMITED",
"NETWORK ORBITER PRIVATE LIMITED",
"NETWORK PEOPLE SERVICES TECHNOLOGIES LIMITED",
"NETWORK POLYMERS PRIVATE LIMITED",
"NETWORK REDUX INDIA PRIVATE LIMITED",
"NETWORK SOLUTIONS AND CONSULTING PRIVATE LIMITED",
"NETWORK TECHLAB INDIA PRIVATE LIMITED",
"NETWORKCITY INNOVATIONS PRIVATE LIMITED",
"NETWORK-IE INFOSYSTEMS PRIVATE LIMITED",
"NETWORKKINGS IT SERVICES PRIVATE LIMITED",
"NETWORKS PRIVATE LIMITED",
"NETWORTH CORPORATE SERVICES PRIVATE LIMITED",
"NETWORTH DATA PRODUCTS PRIVATE LIMITED",
"NETWORTH ESTATE AND RESORTS PRIVATE LIMITED",
"NETWORTH RCM SERVICES OPC PRIVATE LIMITED",
"NETWORTHSYSTEMS PRIVATE LIMITED",
"NETWOVEN INDIA PRIVATE LIMITED",
"NETXCELL LIMITED",
"NETXD SOFTWARE INDIA PRIVATE LIMITED",
"NETXX MARKETING SERVICES",
"NETZEALOUS SERVICES INDIA PRIVATE LIMITED.",
"NETZONE MANAGEMENT SERVICES PRIVATE LIMITED",
"NETZONE NETMEDIA PRIVATE LIMITED",
"NETZSCH TECHNOLOGIES INDIA PRIVATE LIMITED",
"NEU ELEMENTS PRIVATE LIMITED",
"NEUALTO TECHNOLOGIES PRIVATE LIMITED",
"NEUATION TECHNOLOGIES PRIVATE LIMITED",
"NEUBERG A G DIAGNOSTICS PRIVATE LIMITED",
"NEUBERG ABHA LABORATORY PRIVATE LIMITED",
"NEUBERG AJAY SHAH LABORATORY PRIVATE LIMITED",
"NEUBERG ANAND ACADEMY OF LABORATORY MEDICINE PRIVATE LIMITED",
"NEUBERG ANAND REFERENCE LABORATORY PRIVATE LIMITED",
"NEUBERG DIAGNOSTICS PRIVATE LIMITED",
"NEUBERG EHRLICH LABORATORY PRIVATE LIMITED",
"NEUBERG SUPRATECH RAJKOT PRIVATE LIMITED",
"NEUBERG SUPRATECH REFERENCE LABORATORIES PRIVATE LIMITED",
"NEUCLES COACHING CLASSES PRIVATE LIMITED",
"NEUCOM CONSULTING PRIVATE LIMITED",
"NEUDESIC TECHNOLOGIES PRIVATE LIMITED",
"NEUE LIGHT PRIVATE LIMITED",
"NEUECO PACKSOLUTIONS PRIVATE LIMITED",
"NEUFVASI DIGITAL SOLUTIONS PRIVATE LIMITED",
"NEUGEN EMBEDDED SOLUTIONS PRIVATE LIMITED",
"NEUGROW OPTOELECTRONIC TECHNOLOGIES PRIVATE LIMITED",
"NEUHEIT PHARMA TECHNOLOGIES PRIVATE LIMITED",
"NEULAND LABORATORIES LIMITED",
"NEULIFE NUTRITION INDIA PRIVATE LIMITED",
"NEUMAN AND ESSER COMPRESSOR APPLICATION CENTRE PRIVATE LIMITED",
"NEUMAN AND ESSER ENGINEERING INDIA PRIAVTE LIMITED",
"NEUMANN COMPONENTS PRIVATE LIMITED",
"NEUMATIC PAINTS (INDIA) PRIVATE LIMITED",
"NEUMATICA TECHNOLOGIES PRIVATE LIMITED",
"NEUMEC HEALTHCARE PRIVATE LIMITED",
"NEUMERIC TECHNOLOGIES PRIVATE LIMITED",
"NEUMESH LABS PRIVATE LIMITED",
"NEUMET ENGINEERS (INDIA) PRIVATE LIMITED",
"NEUMEX ENTERPRISES",
"NEUNEX BLOEMS PRIVATE LIMITED",
"NEUOME TECHNOLOGIES PRIVATE LIMITED",
"NEURACLE LIFESCIENCES PRIVATE LIMITED",
"NEURAFLASH INDIA PRIVATE LIMITED",
"NEURAL INTEGRATED SYSTEMS PRIVATE LIMITED",
"NEURAL IT PRIVATE LIMITED",
"NEURAL NETWORKS PRIVATE LIMITED",
"NEURALBITS TECHNOLOGIES PRIVATE LIMITED",
"NEURALRAYS AI INDIA PRIVATE LIMITED",
"NEURAPSES TECHNOLOGIES PRIVATE LIMITED",
"NEURO CARE HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED",
"NEURO CENTER HOSPITAL",
"NEURO SHARP SOFTWARE PRIVATE LIMITED",
"NEUROBYTE VENTURES PRIVATE LIMITED",
"NEUROCHEM LABORATORIES PRIVATE LIMITED",
"NEUROCITI IMAGING",
"NEUROGAINT SYSTEMS PRIVATE LIMITED",
"NEUROGLIA HEALTH PRIVATE LIMITED",
"NEURON PATHOLOGY & DIAGNOSTICS PRIVATE LIMITED",
"NEURON PHARMA PRIVATE LIMITED",
"NEURONES-IT INDIA PRIVATE LIMITED",
"NEURONIMBUS SOFTWARE SERVICES PRIVATE LIMITED",
"NEUROPSYCHIATRY AND CRITICAL CARE HOSPITAL PRIVATE LIMITED",
"NEUROSENSUM INTERNATIONAL INDIA PRIVATE LIMITED",
"NEUROSPEECH TECHNOLOGIES PRIVATE LIMITED",
"NEUROSYNAPTIC COMMUNICATIONS PRIVATE LIMITED",
"NEUROTRONIX SYSTEMS INDIA PRIVATE LIMITED",
"NEUSTRO POLY PRODUCTS PRIVATE LIMITED",
"NEUTARA TECHNOLOGIES PRIVATE LIMITED",
"NEUTEC HEALTHCARE PRIVATE LIMITED",
"NEUTRACIAA LIFESCIENCES PRIVATE LIMITED",
"NEUTRAL GLASS AND ALLED INDUSTRIES PRIVATE LIMITED",
"NEUTRAL NVOCC PRIVATE LIMITED",
"NEUTRAL PUBLISHING HOUSE LTD",
"NEUTRAWELL HEALTHCARE PRIVATE LIMITED",
"NEUTRINO DIGITAL COMMUNICATIONS PRIVATE LIMITED",
"NEUTRINO POWER AND ENERGY PRIVATE LIMITED",
"NEUTRINO TRADING PRIVATE LIMITED",
"NEUTRINOS MXP LLP",
"NEUTRON DRUGS & PHARMACEUTICALS PRIVATE LIMITED",
"NEUTRON ELECTRONIC SYSTEMS PRIVATE LIMITED",
"NEUTRON ENTERPRISES PRIVATE LIMITED",
"NEUTRON SURGICALS PRIVATE LIMITED",
"NEUVERA WELLNESS VENTURES PRIVATE LIMITED",
"NEUZEN FINANCE PRIVATE LIMITED",
"NEUZEN TECHNOLOGIES PRIVATE LIMITED",
"NEVA GARMENTS LIMITED",
"NEVA POLYMERS PRIVATE LIMITED",
"NEVAAN MOTORS PRIVATE LIMITED",
"NEVAEH FIRST SOURCE SOLUTIONS PRIVATE LIMITED",
"NEVAEH TECHNOLOGY PRIVATE LIMITED",
"NEVANSH BUSINESS SUPPORT SERVICES PRIVATE LIMITED",
"NEVATIA STEEL & ALLOYS PRIVATE LIMITED",
"NEVCO ENGINEERS PRIVATE LIMITED",
"NEVELOS GRAFFITI SCANNING (INDIA) PRIVATE LIMITED",
"NEVER GROW UP WORKSHOPS PRIVATE LIMITED",
"NEVER NINE PRIVATE LIMITED",
"NEVERA INFRATECH PRIVATE LIMITED",
"NEVIK FOOD INDUSTRIES PRIVATE LIMITED",
"NEVILLE FABRICS PVT LTD",
"NEVIQ INFRATECH PRIVATE LIMITED",
"NEVITAD DISTILLERS PRIVATE LIMITED",
"NEVITECH DATA SOLUTIONS PRIVATE LIMITED",
"NEVITON SOFTECH PRIVATE LIMITED",
"NEVON SOLUTIONS PRIVATE LIMITED",
"NEVPRO BUSINESS SOLUTIONS PRIVATE LIMITED",
"NEW & RENEWABLE ENERGY DEVELOPMENT CORPORATION OF ANDHRA PRADESH LIMITED",
"NEW (INDIA) IMAGING INDUSTRIES PRIVATE LIMITED",
"NEW A. V. SONS SUPER STORE PRIVATE LIMITED",
"NEW AGE ACOUSTICS PRIVATE LIMITED",
"NEW AGE ALLOYS PRIVATE LIMITED",
"NEW AGE EDUCATION AND SKILLS FOUNDATION (AN ARCELORMITTAL NIPPON STEEL INITIATIVE)",
"NEW AGE ENCLAVE PRIVATE LIMITED",
"NEW AGE FAB TECHNOLOGIES PRIVATE LIMITED",
"NEW AGE FINANCIAL ADVISORY PRIVATE LIMITED",
"NEW AGE HEALTHTECH PRIVATE LIMITED",
"NEW AGE HOME CREATIONS PRIVATE LIMITED",
"NEW AGE HOTELS AND RESORTS LIMITED",
"NEW AGE INSTRUMENTS AND MATERIALS PRIVATE LIMITED",
"NEW AGE INTERNATIONAL PRIVATE LIMITED",
"NEW AGE LIFE SCIENCES PRIVATE LIMITED",
"NEW AGE MEDIA & PUBLICATIONS PRIVATE LIMITED",
"NEW AGE PETCOKE PRIVATE LIMITED",
"NEW AGE SOFTWARE AND SOLUTIONS INDIA PRIVATE LIMITED",
"NEW AGE TECHSCI RESEARCH PRIVATE LIMITED",
"NEW AGE TRADING AND INVESTMENT PRIVATE LIMITED",
"NEW AGE VEHICLES PRIVATE LIMITED",
"NEW AIRWAYS TRAVELS PRIVATE.LIMITED",
"NEW ALIPORE COLLEGE",
"NEW ALLIANCE FINE CHEM PRIVATE LIMITED",
"NEW AMBADI ESTATES PRIVATE LIMITED",
"NEW AMBICA CRANES PRIVATE LIMITED",
"NEW AMIT MISTHAAN PRIVATE LIMITED",
"NEW AMP AND OHM APPLICATIONS PRIVATE LIMITED",
"NEW AMRUTHA MEDICAL AND RESEARCH CENTRE (RAICHUR) PRIVATE LIMITED",
"NEW ANANT ASSOCIATES",
"NEW ANIKET PACKAGING INDUSTRIES PRIVATE LIMITED",
"NEW ANPURNA SAMRUDDHI PRODUCER COMPANY LIMITED",
"NEW AQUARIA ELECTECH PRIVATE LIMITED",
"NEW ARTS COMMERCE AND SCIENCE COLLEGE AHMEDNAGAR",
"NEW ARTS STRUCTURES PRIVATE LIMITED",
"NEW ARVIND TOURS & TRAVELS OF INDIA PRIVATE LIMITED",
"NEW ASARWA CHEMICALS PVT LTD",
"NEW ASIA GLOBICON PRIVATE LIMITED",
"NEW ASIAN INFRASTRUCTURE DEVELOPMENT PVT LIMITED",
"NEW ASSOCIATED ROAD CARRIERS PRIVATE LIMITED",
"NEW AUTO TECH INDIA PRIVATE LIMITED",
"NEW AVM SYSTECH PRIVATE LIMITED",
"NEW BALANCE IT SERVICES INDIA PRIVATE LIMITED",
"NEW BALDWIN INTERNATIONAL RESIDENTIAL SCHOOL",
"NEW BANGLORE GUJRAT ROADWAYS",
"NEW BARRACKPORE MUNICIPALITY",
"NEW BEACH CANDY HEALTH CARE PRIVATE LIMITED",
"NEW BENGAL FOOTWEARS PRIVATE LIMITED",
"NEW BERRY ADVISORS LIMITED",
"NEW BERRY CAPITALS PRIVATE LIMITED",
"NEW BHARAT DYEING AND PRINTING MILLS",
"NEW BHARAT ENGINEERING SOLID WASTE MANAGEMENT PRIVATE LIMITED",
"NEW BHARAT FOR SAFETY",
"NEW BHARAT GOLDEN LOGISTICS PRIVATE LIMITED",
"NEW BHARAT RICE MILLS",
"NEW BHARATH AIDED PRIMARY SCHOOL BHONGIR",
"NEW BHARATH TYRES INDIA PRIVATE LIMITED",
"NEW BHAVANS SCIENCE COLLEGE",
"NEW BLEND TEXTILE MILLS PRIVATE LIMITED",
"NEW BLEND TEXTILE MILLS PRIVATE LIMITED CN",
"NEW BOMBAY (HARDWARE ) TRADERS PVT LTD",
"NEW BOMBAY BUILD TECH PRIVATE LIMITED",
"NEW BOMBAY DELHI ROAD CARRIERS PRIVATE LIMITED",
"NEW BOMBAY HOUSING AGENCY PRIVATE LIMITED",
"NEW BOMBAY NOVELTIES",
"NEW BOMBAY PAPER MILLS PRIVATE LIMITED",
"NEW BONANZA IMPEX PRIVATE LIMITED",
"NEW BONANZA INDIA LIMITED",
"NEW BREED LOGISTICS PRIVATE LIMITED",
"NEW BRIGHT GLASS WORKS (INDIA) PRIVATE LIMITED",
"NEW CELIO ENGINEERING (INDIA) PRIVATE LIMITED",
"NEW CENTURY BOOK HOUSE PRIVATE LIMITED",
"NEW CENTURY FILAMENTS PRIVATE LIMITED",
"NEW CHAITANYA JUNIOR COLLEGE",
"NEW CHANDRA MOTOR CYCLE AGENCY",
"NEW CHEM AGRO PRIVATE LIMITED",
"NEW CHUMTA TEA COMPANY LIMITED",
"NEW CITI HOSPITALS",
"NEW CITY CARRIER PRIVATE LIMITED",
"NEW CITY HOSPITAL",
"NEW CIVIL HOSPITAL",
"NEW CLASSIC AUTOCARE PRIVATE LIMITED",
"NEW CLASSIC CATERERS PRIVATE LIMITED",
"NEW COLLEGE INSTITUTE OF MANAGEMENT STUD",
"NEW COLOR SCREENS PRIVATE LIMITED",
"NEW COMPAIR SERVICES LIMITED.",
"NEW CONCEPT INFORMATION SYSTEMS PRIVATE LIMITED",
"NEW CONCEPT SHOES PRIVATE LIMITED",
"NEW CONSOLIDATED CONSTRUCTION COMPANY LIMITED",
"NEW CONSTELLATION ENERGY PRIVATE LIMITED",
"NEW CONSTRUCTION CONCRETE SYSTEMS PRIVATE LIMITED",
"NEW CRAWN ELEVATORS PRIVATE LIMITED",
"NEW CREATION INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"NEW CREATION PUBLIC SCHOOL",
"NEW DAIRY ENGINEERING AND TRADING COMPANY PRIVATE LIMITEDI",
"NEW DARJEELING UNION TEA CO LTD",
"NEW DELHI CENTRE FOR SIGHT LIMITED",
"NEW DELHI HOTELS LIMITED",
"NEW DELHI HOUSE SERVICES LIMITED",
"NEW DELHI MEDICOS PRIVATE LIMITED",
"NEW DELHI MUNICIPAL COUNCIL",
"NEW DELHI PUBLIC SCHOOL",
"NEW DELHI SECURITY SERVICES PRIVATE LIMITED",
"NEW DELHI TELEVISION LIMITED",
"NEW DELHI THEATRES PRIVATE LIMITED",
"NEW DELHI UP ROAD CARRIERS PRIVATE LIMITED",
"NEW DELHI VAULTS LIMITED",
"NEW DELHI YMCA",
"NEW DELHI YOUNG MEN'S CHRISTIAN ASSOCIATION",
"NEW DELTA GEAR MANUFACTURERS PRIVATE LIMITED",
"NEW DELUX LOGISTICS PRIVATE LIMITED",
"NEW DELUXE HOTELS PRIVATE LIMITED",
"NEW DERIVATIVE CHEMICALS PRIVATE LIMITED",
"NEW DESIGNER.WEB PRIVATE LIMITED",
"NEW DHILLON STAR CARRIERS PRIVATE LIMITED",
"NEW DIAMOND FABTRENDS PRIVATE LIMITED",
"NEW DIAMOND HERBAL PRODUCTS",
"NEW DIGAMBER PUBLIC SCHOOL",
"NEW DIGITAL GALLERY",
"NEW DOON BLOOMS SCHOOL",
"NEW DOON BLOSSOMS SCHOOL",
"NEW EAST INFRA HOLDINGS PRIVATE LIMITED",
"NEW EAST PROJECTS PRIVATE LIMITED",
"NEW ELECTRO METALLICS PRIVATE LIMITED",
"NEW EMERGING WORLD OF JOURNALISM LIMITED",
"NEW ENGINEERING WORKS",
"NEW ENGLISH HIGH SCHOOL & JUNIOR COLLEGE WARDHA",
"NEW ENGLISH SCHOOL",
"NEW ENGLISH SCHOOL & JR COLLAGE KHAMGAON",
"NEW ENGLISH SCHOOL & T P SHETYE JR COLLEGE LANJA",
"NEW ENGLISH SCHOOL MURUD",
"NEW ENGLISH SCHOOL NANDGAON SADO NASHIK",
"NEW ENGLISH SCHOOL PILANI MAZARE",
"NEW ENGLISH SECONDARY SCHOOL",
"NEW ERA ADHESIVE AND SEALENTS PRIVATE LIMITED",
"NEW ERA CONCRETE SOLUTION PRIVATE LIMITED",
"NEW ERA CONVEYORS PRIVATE LIMITED",
"NEW ERA DAIRY ENGINEERS INDIA PRIVATE LIMITED",
"NEW ERA DEALCOM PVT LTD",
"NEW ERA DESIGNS PRIVATE LIMITED",
"NEW ERA EDUCATION SOCIETY",
"NEW ERA ENVIRO VENTURES (MAHBUBNAGAR) PRIVATE LIMITED",
"NEW ERA FABRICS LIMITED",
"NEW ERA FASHION PRIVATE LIMITED",
"NEW ERA FIRE SYSTEMS PRIVATE LIMITED",
"NEW ERA FOREX PRIVATE LIMITED",
"NEW ERA IMPEX (INDIA) PRIVATE LIMITED",
"NEW ERA INDIA CONSULTANCY PRIVATE LIMITED",
"NEW ERA INDUSTRIAL SERVICES PRIVATE LIMITED",
"NEW ERA INFORMATIQUE PRIVATE LIMITED",
"NEW ERA INTERIOR COLLECTION PRIVATE LIMITED",
"NEW ERA MACHINES PRIVATE LIMITED",
"NEW ERA MEDIA CORPORATION CHENNAI PRIVATE LIMITED",
"NEW ERA MEDIEQUIP PRIVATE LIMITED",
"NEW ERA NATIONAL ENGLISH MEDIUM SCHOOL",
"NEW ERA PETROCHEM PRIVATE LIMITED",
"NEW ERA PRESS PRIVATE LIMITED",
"NEW ERA PROGRESSIVE SCHOOL",
"NEW ERA PUBLIC SCHOOL",
"NEW ERA SCHOOL",
"NEW ERA SEEDS PRIVATE LIMITED",
"NEW ERA SELF HELP INDIA LIMITED",
"NEW ERA SHIPPING PRIVATE LIMITED",
"NEW ERA STRUCTURAL TECHNOLOGIES PRIVATE LIMITED",
"NEW ERA SWITCHGEARS PRIVATE LIMITED",
"NEW ERA TRADING PRIVATE LIMITED OPC",
"NEW ERA WOOLLEN MILLS PVT LTD",
"NEW EROS TRADECOM LIMITED",
"NEW EXCELSIOR THEATRE PVT LTD",
"NEW FAIZAN FOODS",
"NEW FASHION LIFE",
"NEW FATEHGARH SAHIB SIRHIND BUS TRANSPORT PVT LTD",
"NEW FIELD INDUSTRIAL EQUIPMENT PRIVATE LIMITED",
"NEW FIELDS ADVERTISING PRIVATE LIMITED",
"NEW FIRE ENGINEERS PRIVATE LIMITED",
"NEW FIVE STAR BAKERY",
"NEW FLYAIR CHARTER SERVICES PRIVATE LIMITED",
"NEW FORCE LTD",
"NEW FRIENDS COMPANY (CHEMISTS) PRIVATE LIMITED",
"NEW FRIENDS TRADERS PRIVATE LIMITED",
"NEW GEN CROP SOLUTIONS PRIVATE LIMITED",
"NEW GEN MARKETING AGENCY PRIVATE LIMITED",
"NEW GEN PACKPOOL PRIVATE LIMITED",
"NEW GEN PERFORATORS PRIVATE LIMITED",
"NEW GENERAL AGENTS PVT LTD",
"NEW GENERATION EQUITY PRIVATE LIMITED",
"NEW GENERATION MANUFACTURING PRIVATE LIMITED",
"NEW GENERATION MEDIA CORPORATION PRIVATE LIMITED",
"NEW GENERATION MINERALS AND WAREHOUSING PRIVATE LIMITED",
"NEW GLOBAL HEALTH AND EDUCATIONAL TRUST",
"NEW GLOBE LOGISTIK LLP",
"NEW GRAND ELEVATORS",
"NEW GROW SOFTWARE SOLUTIONS PRIVATE LIMITED",
"NEW GROWTH WINES & SPIRITS PRIVATE LIMITED",
"NEW GUJARAT TIN CIRCLE DEPOT PRIVATE LIMITED",
"NEW GURDIAL AGRO INDUSTRIES PRIVATE LIMITED",
"NEW HAIR PALACE PRIVATE LIMITED",
"NEW HAPJAN TEA COMPANY PRIVATE LIMITED",
"NEW HARBOUR LAUNCH SERVICE PRIVATE LIMITED",
"NEW HARMONY PVT LTD",
"NEW HARSH SECURITY & INDUSTRIAL SERVICES PRIVATE LIMITED",
"NEW HARYANA OVERSEASE",
"NEW HAVEN ENTERPRISE PRIVATE LIMITED",
"NEW HEIGHTS CONSTRUCTIONS PRIVATE LIMITED",
"NEW HIGH FLYING TRAVELS PRIVATE LIMITED",
"NEW HIGH SCHOOL",
"NEW HIGH SCHOOL 107 S NAGAR APTA CHOWK SANGLI",
"NEW HIGH SCHOOL APTA CHOWK SANGLI",
"NEW HIGH SCHOOL JAFRABAD",
"NEW HIGHSCHOOL GADANA",
"NEW HIND AGRO PRIVATE LIMITED",
"NEW HINDUSTAN TUBES PRIVATE LIMITED",
"NEW HOPE FOOD INDUSTRIES PRIVATE LIMITED",
"NEW HOPE KOLKATA ANIMAL FEED PRIVATE LIMITED",
"NEW HORIZON BUILDWELL PRIVATE LIMITED",
"NEW HORIZON COLLEGE OF ENGINEE",
"NEW HORIZON ENGINEERING PRIVATE LIMITED",
"NEW HORIZON KNITS PRIVATE LIMITED",
"NEW HORIZON PUBLIC SCHOOL",
"NEW HORIZON SCHOLARS SCHOOL",
"NEW HORIZONS ALLIANCE PRIVATE LIMITED",
"NEW HORIZONS CONSULTING ENGINEERS LLP",
"NEW HORIZONS CYBERSOFT LIMITED",
"NEW HORIZONS LOGIWARE PRIVATE LIMITED",
"NEW HORIZONS PRIVATE LIMITED",
"NEW HORIZONS SHIP MANAGEMENT PRIVATE LIMITED",
"NEW HOTEL KOLIWADA",
"NEW HOWRAH BAKERY (BAPU JI)PRIVATE LIMITED",
"NEW INDIA ACID (BARODA) PRIVATE LIMITED",
"NEW INDIA ASSURANCE",
"NEW INDIA CABLES TRADING PRIVATE LIMITED",
"NEW INDIA COLOUR COMPANY LIMITED",
"NEW INDIA CONDUITS PVT LTD",
"NEW INDIA CONTRACTORS AND DEVELOPERS PRIVATE LIMITED",
"NEW INDIA CO-OPERATIVE BANK LIMITED",
"NEW INDIA CUPROTEC",
"NEW INDIA DETERGENTS PRIVATE LIMITED",
"NEW INDIA ELECTRICALS LIMITED",
"NEW INDIA ENGINEERING COMPANY",
"NEW INDIA EXPORTS PRIVATE LIMITED",
"NEW INDIA EXTRUSIONS PRIVATE LIMITED",
"NEW INDIA FINANCIAL SERVICES LIMITED",
"NEW INDIA FINVEST PRIVATE LIMITED",
"NEW INDIA INFRA BUILDTECH LIMITED",
"NEW INDIA INSURANCE CO LIMITED",
"NEW INDIA INVESTMENT CORPN LTD",
"NEW INDIA POLYVINYL PRIVATE LIMITED",
"NEW INDIA RETAILING & INVESTMENT LIMITED",
"NEW INDIA RUBBER WORKS PVT LTD",
"NEW INDIA STRUCTURES PRIVATE LIMITED",
"NEW INDIA TRANSLINE PRIVATE LIMITED",
"NEW INDIA WATERSEAL PRIVATE LIMITED",
"NEW INDIAN SCHOOL OF NURSING",
"NEW INDICTRANS TECHNOLOGIES PRIVATE LIMITED",
"NEW INDUSTRIAL SECURITY AGENCIES PRIVATE LIMITED",
"NEW INK PUBLICATIONS PRIVATE LIMITED",
"NEW INTERPORT SHIPPING SERVICES PRIVATE LIMITED",
"NEW JACK PRINTING PRESS PRIVATE LIMITED",
"NEW JAI GAGANGIRI FABRICATION",
"NEW JAMMU FLOUR MILLS PRIVATE LIMITED.",
"NEW KAMATH TOBACCO COMPANY PRIVATE LIMITED",
"NEW KANDLA SALT AND CHEMICAL COMPANY PRIVATE LIMITED",
"NEW KASTURBA MARATHI VIDYALAYA",
"NEW KENILWORTH HOTEL PRIVATE LIMITED",
"NEW KESSLER ENGINEERING PRIVATE LIMITED",
"NEW KHETRAPAL ENGINEERING",
"NEW KINGS FURNITURE",
"NEW LAKHANPUR HOSPITAL & TRAUMA CENTER PRIVATE LIMITED",
"NEW LAXMI INDUSTRIES PRIVATE LIMITED",
"NEW LAXMI STEEL & POWER PRIVATE LIMITED",
"NEW LEAF DYNAMIC TECHNOLOGIES PRIVATE LIMITED",
"NEW LEAF HEALTHY FOODS INDIA PRIVATE LIMITED",
"NEW LEAF RETAIL TECHNOLOGIES PRIVATE LIMITED",
"NEW LEAF TEA PLANTATION PRIVATE LIMITED",
"NEW LIFE CARE DE ADDICTION & REHABILITATION TRUST",
"NEW LIFE ENTERTAINMENT INDIA PRIVATE LIMITED",
"NEW LIFE HOSPITALS PRIVATE LIMITED",
"NEW LIFE HOTELS AND RESORTS PRIVATE LIMITED",
"NEW LIFE LABORATORIES PRIVATE LIMITED",
"NEW LIFE MEDICALS PRIVATE LIMITED",
"NEW LIFE MULTISPECIALITY HOSPITAL",
"NEW LIFELINE MULTISPECIALITY HOSPITAL PRIVATE LIMITED",
"NEW LIGHT APPARELS LIMITED",
"NEW LIGHT HOTELS AND RESORTS LIMITED",
"NEW LIKE BUILDING SYSTEM PRIVATE LIMITED",
"NEW LINE BUILD-CAP PRIVATE LIMITED",
"NEW LINK OVERSEAS FINANCE LIMITED",
"NEW LOOK BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"NEW LOOK SKIN CARE LIMITED",
"NEW LUBRISALES INDIA PRIVATE LIMITED",
"NEW MAHALAXMI SILK MILLS PRIVATE LIMITED",
"NEW MALAKSHMI PADDY MILLS PRIVATE LIMITED",
"NEW MAN EXPORTS",
"NEW MANAK OVERSEAS LIMITED",
"NEW MANAS TEA ESTATES PVT LTD",
"NEW MANGALORE PORT",
"NEW MANN ELECTRIC CONTROLS PRIVATE LIMITED",
"NEW MAX FIRE SYSTEM PRIVATE LIMITED",
"NEW MECH VYAPAAR PRIVATE LIMITED",
"NEW MEDIA COMMUNICATION PRIVATE LIMITED",
"NEW MEDIA GURU INDIA PRIVATE LIMITED",
"NEW MEDICON PHARMA LAB PRIVATE LIMITED",
"NEW MEENABAZAR INTERNATIONL PRIVATE LIMITED",
"NEW MELTING CENTRE PRIVATE LIMITED",
"NEW METAL VISION PRIVATE LIMITED",
"NEW MILLENNIUM KURIES PRIVATE LIMITED",
"NEW MILLENNIUM LIMITED",
"NEW MILLENNIUM TECHNOLOGY MANAGEMENT PRI VATE LIMITED",
"NEW MODEL IMPEX PRIVATE LIMITED",
"NEW MODERN BAZAAR DEPARTMENTAL STORES PRIVATE LIMITED",
"NEW MODERN BUILDWELL PRIVATE LIMITED",
"NEW MODERN TECHNOMECH PRIVATE LIMITED",
"NEW MOON COSMETICS PRIVATE LIMITED",
"NEW MUKHIYA JI AGRO PRESERVATION PRIVATE LIMITED",
"NEW MULTIFAB ENGINEERS PRIVATE LIMITED",
"NEW MURLI BAKERY PRIVATE LIMITED",
"NEW NEXUS EDUCATIONAL SERVICES PRIVATE LIMITED",
"NEW NIRANJAN ROADLINES PRIVATE LIMITED",
"NEW NISHAT ROLLER FLOUR MILLS (J&K) PRIVATE LIMITED",
"NEW NOBLE JR DEGREE COLLEGE",
"NEW NORTHEAST ELECTRIC INDIA PRIVATE LIMITED",
"NEW OKHLA INDUSTRIAL DEVELOPMENT AU",
"NEW OLOG LOGISTICS PRIVATE LIMITED",
"NEW OPPORTUNITY CONSULTANCY PRIVATE LIMITED",
"NEW PANDIAN TRAVELS PRIVATE LIMITED",
"NEW PARADISE BONDED WAREHOUSE PRIVATE LIMITED",
"NEW PATH DEVELOPERS LLP",
"NEW PEARL VITRIFIED PRIVATE LIMITED",
"NEW PERIPHERALS TECHNOLOGY PRIVATE LIMITED",
"NEW PHALTAN SUGAR WORKS DISTILLERY DIVISION LIMITED",
"NEW PIG INDIA PRIVATE LIMITED",
"NEW PIYAR BUS SERVICE PVT LTD",
"NEW POONA COTTON FACTORY PRIVATE LIMITED",
"NEW POWER CIRCUITS (CHENNAI) PRIVATE LIMITED",
"NEW POWER ELECTRICALS PRIVATE LIMITED",
"NEW PRINT INDIA PRIVATE LIMITED",
"NEW PROPELLER TECHNOLOGIES RESEARCH AND DEVELOPMENT PRIVATE LIMITED",
"NEW RAIN (BANGALORE) PAPER AGENCIES PRIVATE LIMITED",
"NEW RAIN COMMODITIES PRIVATE LIMITED",
"NEW RAIN PAPERS PRIVATE LIMITED",
"NEW RAJDHANI LOGISTICS PRIVATE LIMITED",
"NEW RAJU TENT HOUSE PRIVATE LIMITED",
"NEW RAMDEV HEALTH AND WELLNESS PRIVATE LIMITED",
"NEW RAMPGREEN TECHNOLOGIES PRIVATE LIMITED",
"NEW RANGSALI TEA PLANTATION PRIVATE LIMITED",
"NEW RED ROSE CARGO SERVICES PRIVATE LIMITED",
"NEW RICHA STEELS PRIVATE LIMITED",
"NEW RISHTA AGRO INDIA LIMITED",
"NEW ROK HOTELS PRIVATE LIMITED",
"NEW ROYAL FOOD SERVICES PRIVATE LIMITED",
"NEW RUBY CARGO PRIVATE LIMITED",
"NEW RUBY HOSPITAL",
"NEW SANROS AYURVEDIC PRIVATE LIMITED",
"NEW SARASWATI HOUSE INDIA PRIVATE LIMITED",
"NEW SARAVANA STORES BRAMANDAMAI PRIVATE LIMITED",
"NEW SATNAM HANDLING AND LOGIWAYS PRIVATE LIMITED",
"NEW SATNAM INFRACON PRIVATE LIMITED",
"NEW SCIENCE COLLEGE",
"NEW SEARCH LIFE SCIENCES PRIVATE LIMITED",
"NEW SHAHID BHAGATSINGH KILBIL PS RANJANGAON SHENPUNJI",
"NEW SHAKTI HIGHWAY CARRIERS PRIVATE LIMITED",
"NEW SHAMA LABORATORIES PRIVATE LIMITED",
"NEW SHIVAM BATTERY HOUSE PRIVATE LIMITED",
"NEW SHIVAM FOREX PRIVATE LIMITED",
"NEW SOUND HEARING AID PRIVATE LIMITED",
"NEW SOUTH WALES KARGO PRIVATE LIMITED",
"NEW SPICE SOLUTIONS PRIVATE LIMITED",
"NEW SRI BHAGAVAN NIKETAN LIMITED",
"NEW STANDARD SECURITY SERVICE PRIVATE LIMITED",
"NEW STAR SYSTEM SOLUTIONS PRIVATE LIMITED",
"NEW STARS SERVICES PRIVATE LIMITED",
"NEW STATESMAN MEDIA LLP",
"NEW STEEL TRADING PRIVATE LIMITED",
"NEW STREET TECHNOLOGIES PRIVATE LIMITED",
"NEW STYLE FABRICATORS PRIVATE LIMITED",
"NEW STYLE INFO SYSTEMS PRIVATE LIMITED",
"NEW STYLE RECREATION AND AMUSEMENT PRIVATE LIMITED",
"NEW SUPER POLYMERS INDIA PRIVATE LIMITED",
"NEW SWAMI SELECTION",
"NEW SWAN COMPONENTS PRIVATE LIMITED",
"NEW SWAN MULTITECH LIMITED",
"NEW TEA BEVERAGES EXPORTS PRIVATE LIMITED",
"NEW TEA CO LTD",
"NEW TEA IMPEX PRIVATE LIMITED",
"NEW TEA MARKETING PRIVATE LIMITED",
"NEW TEC HYDRAULLICS PRIVATE LIMITED",
"NEW TECH BUILDING SOLUTIONS PRIVATE LIMITED",
"NEW TECH DISTRIBUTORS PRIVATE LIMITED",
"NEW TECH EQUIPMENTS PRIVATE LIMITED",
"NEW TECH INFRA CONTRACTORS PRIVATE LIMITED",
"NEW TECH ISPAT PRIVATE LIMITED",
"NEW TECH POLYCHEM PRIVATE LIMITED",
"NEW TECH STEEL & ALLOYS PRIVATE LIMITED",
"NEW TECH TELE PRODUCTS PRIVATE LIMITED",
"NEW TECHNOLOGY RESEARCH SOFTWARE SERVICES PRIVATE LIMITED",
"NEW TESTAMENT PENTECOSTAL HOLINESS MINISTRIES",
"NEW THACKERS FINE ART PRESS PRIVATE LIMITED",
"NEW TIMES DEVELOPEMENT INDIA PRIVATE LIMITED",
"NEW TIMONHABI TEA CO PVT LTD",
"NEW TIP TOP FORGINGS PRIVATE LIMITED",
"NEW TIRUPUR AREA DEVELOPMENT CORPORATION LIMITED",
"NEW TOWN FARMS PRIVATE LIMITED",
"NEW TOWN INFOTECH PRIVATE LIMITED",
"NEW TOWN NURSING HOME AND DIAGONISTICS CO. PRIVATE LIMITED",
"NEW TOWN TELECOM INFRASTRUCTURE DEVELOPMENT COMPANY LIMITED",
"NEW TRACTOR PARTS PRIVATE LIMITED",
"NEW TRIDEV JEWELLERS",
"NEW UDAI MEDICAL CENTRE PRIVATE LIMITED",
"NEW VAIDEHI INFRACON (OPC) PRIVATE LIMITED",
"NEW VANSHIKA BIO AGRO INDUSTRIES PRIVATE LIMITED",
"NEW VENUS BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"NEW VERTICAL VERA PRIVATE LIMITED",
"NEW VIJAYA STEELS AND ALLOYS PRIVATE LIMITED",
"NEW VIKAS KRISHI YANTRA PRIVATE LIMITED",
"NEW VISION DIGITAL PRIVATE LIMITED",
"NEW VISION E-PUBLISHING SOLUTIONS PRIVATE LIMITED",
"NEW VISION LASER CENTERS HYDERABAD PRIVATE LIMITED",
"NEW VISION LASER CENTERS RAJKOT PRIVATE LIMITED",
"NEW VISION PRINTING SERVICES PRIVATE LIMITED",
"NEW VISION SOFTCOM AND CONSULTANCY PRIVATE LIMITED",
"NEW VISIONS HEALTH AND MEDICAL SERVICES PRIVATE LIMITED",
"NEW WADALA SPORTS CLUB PRIVATE LIMITED",
"NEW WAVE BUILDCON PRIVATE LIMITED",
"NEW WAVE COMPUTING PRIVATE LIMITED",
"NEW WAVE GROUP INDIA BUYING PRIVATE LIMITED",
"NEW WAVE MERCHANDISE PRIVATE LIMITED",
"NEW WAVE SCHOLASTIC AIDS PRIVATE LIMITED",
"NEW WAY HOMES PRIVATE LIMITED",
"NEW WAY OFFICE AUTOMATION PRIVATE LIMITED",
"NEW WAYS DISTRIBUTORS PRIVATE LIMITED",
"NEW WELCOME AGENCIES PRIVATE LIMITED",
"NEW WELCOME HOTEL PRIVATE LIMITED",
"NEW WHITE CABLES INDUSTRIES PRIVATE LIMITED",
"NEW WOODLANDS HOTELS PRIVATE LIMITED",
"NEW WORLD BEARINGS PRIVATE LIMITED",
"NEW WORLD PAINTS PRIVATE LIMITED",
"NEW YORK GLOBAL CONSULTANTS PRIVATE LIMITED",
"NEW YORK TECHNOLOGY INDIA PRIVATE LIMITED",
"NEW ZEALAND FRESH AND NATURAL (INDIA) PRIVATE LIMITED",
"NEWA INVESTMENTS PRIVATE LIMITED",
"NEWA TECHNOCITY (INDIA) PRIVATE LIMITED",
"NEWAETATE PRIVATE LIMITED",
"NEWAGE BEARINGS PRIVATE LIMITED",
"NEWAGE CONCEPTS INDIA PRIVATE LIMITED",
"NEWAGE FIRE FIGHTING COMPANY LIMITED",
"NEWAGE FIRE PROTECTION ENGINEERS PRIVATE LIMITED",
"NEWAGE FIRE PROTECTION INDUSTRIES PRIVATE LIMITED",
"NEWAGE FURNITURE INNOVATIONS PRIVATE LIMITED",
"NEWAGE HONGFA LOGISTICS INDIA PRIVATE LIMITED",
"NEWAGE INDUSTRIAL OILS PRIVATE LIMITED",
"NEWAGE LAMINATORS PRIVATE LIMITED",
"NEWAGE LIVING SOLUTIONS PRIVATE LIMITED",
"NEWAGE MEGAMART PRIVATE LIMITED",
"NEW-AGE PRECISION CAST PRIVATE LIMITED",
"NEWAGE PRODUCT DESIGNS PRIVATE LIMITED",
"NEWAGE PRODUCTS INC",
"NEWAGE SCAFFOLDS (P) LTD",
"NEWAGEIT TECHNOLOGIES PRIVATE LIMITED",
"NEWAGESYS SOLUTIONS PRIVATE LIMITED",
"NEWAR FOOD AND HOSPITALITY PRIVATE LIMITED",
"NEWAR METALS PRIVATE LIMITED",
"NEWARK ENGINEERS PRIVATE LIMITED",
"NEWASHOK WATERPROOF WORKS PRIVATE LIMITED",
"NEWASKAR LOGISTICS PRIVATE LIMITED",
"NEWAY INDUSTRIES PRIVATE LIMITED",
"NEWAY SHIPPING PRIVATE LIMITED",
"NEWBAZAAR TECHNOLOGIES PRIVATE LIMITED",
"NEWBHARAT FIRE PROTECTION SYSTEM PRIVATE LIMITED",
"NEWBIE SOFT SOLUTIONS PRIVATE LIMITED",
"NEWBIE TECHNOLOGY PRIVATE LIMITED",
"NEWBRICK CASTLE LIMITED",
"NEWBRIDGE NETWORKS ASIA LIMITED",
"NEWBURY FASHIONS",
"NEWBY TEAS OVERSEAS PRIVATE LIMITED",
"NEWCASTLE TECHNOLOGIES PRIVATE LIMITED",
"NEWCO AUTO PRIVATE LIMITED",
"NEWCON ENGINEERS PRIVATE LIMITED",
"NEWCORE GLOBAL PRIVATE LIMITED",
"NEWCORE TOOLS PRIVATE LIMITED",
"NEWCS INTERNATIONAL PRIVATE LIMITED",
"NEWDAY INDIA SOFTWARE DEVELOPMENT PRIVATE LIMITED",
"NEWDIMENSIONS DEVELOPERS PRIVATE LIMITED",
"NEWDREAM DATA SYSTEMS PRIVATE LIMITED",
"NEWEDGE RESEARCH AND DEVELOPMENT PRIVATE LIMITED",
"NEWEDGE SOUND OPC PRIVATE LIMITED",
"NEWEL (CALCUTTA) PVT LTD",
"NEWEL INFOTECH PRIVATE LIMITED",
"NEWEL TECHNOLOGIES PRIVATE LIMITED",
"NEWELL RUBBERMAID INC.",
"NEWEN SYSTEMS PRIVATE LIMITED",
"NEWENERGIE RENEWABLES PRIVATE LIMITED",
"NEWERA FEAST & HOSPITALITY PRIVATE LIMITED",
"NEWERA HOSPITALS PRIVATE LIMITED",
"NEWERA SOLUTIONS PRIVATE LIMITED",
"NEWEX LOGISTICS PRIVATE LIMITED",
"NEWFAB ENGINEERING SYSTEM PRIVATE LIMITED",
"NEWFANG NETWORKS PRIVATE LIMITED",
"NEW-FANGLED ENGINEERS PRIVATE LIMITED",
"NEWFIELD ENGINEERS PRIVATE LIMITED",
"NEWFORCE GLOBAL SERVICES INDIA PRIVATE LIMITED",
"NEWFOUND PROPERTIES AND LEASING PRIVATE LIMITED",
"NEWGEN AGRO PROCESSORS PRIVATE LIMITED",
"NEWGEN BOOKS PRIVATE LIMITED",
"NEWGEN DIGITALWORKS PRIVATE LIMITED",
"NEWGEN GAMING PRIVATE LIMITED",
"NEWGEN HOLDINGS PRIVATE LIMITED",
"NEWGEN IMAGING SOLUTIONS PRIVATE LIMITED",
"NEWGEN INDUSTRIAL SECURITY (GUJARAT) PRIVATE LIMITED",
"NEWGEN INFRASERVICES PRIVATE LIMITED",
"NEWGEN INTERNET NETWORKS PRIVATE LIMITED",
"NEWGEN KNOWLEDGE WORKS PRIVATE LIMITED",
"NEWGEN PAYMENT GATEWAY PRIVATE LIMITED",
"NEWGEN TREND CENTRE PRIVATE LIMITED",
"NEWGEN WIRES AND COILS PRIVATE LIMITED",
"NEWGENIC VACUUTEK PRIVATE LIMITED",
"NEWGENRAY TECHNOLOGIES PRIVATE LIMITED",
"NEW-GUJARAT COLA PRIVATE LIMITED",
"NEWJAISA TECHNOLOGIES LIMITED",
"NEWKEM ENGINEERS PVT LTD",
"NEWLAND CHASE PRIVATE LIMITED",
"NEWLAND STATIONERS PRIVATE LIMITED",
"NEWLIFE HOSPITAL AND HEALTHCARE PRIVATE LIMITED",
"NEWLIFE PLACEMENTS PRIVATE LIMTED",
"NEWLINE SOLUTIONS PRIVATE LIMITED",
"NEWLOOK CONSTRUCTIONS PRIVATE LIMITED",
"NEWLOOK METALTECH PRIVATE LIMITED",
"NEWLOOP LOGISTICS PRIVATE LIMITED",
"NEWMALAYALAM STEEL LIMITED",
"NEWMAN IMPEX PRIVATE LIMITED",
"NEWMAN INDIA PRIVATE LIMITED",
"NEWMARK CRE SERVICES PRIVATE LIMITED",
"NEWMEK SOFTWARE SOLUTIONS PRIVATE LIMITED",
"NEWMONT MINING CORPORATION",
"NEWNET TECHNO ENGINEERING INDIA PRIVATE LIMITED",
"NEWNIK LIFECARE PRIVATE LIMITED",
"NEWONIC INVESTORS POINT PRIVATE LIMITED",
"NEWOW INDIA PRIVATE LIMITED",
"NEWPACK PLASTICS PRIVATE LIMITED",
"NEWPAGE DIGITAL HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"NEWPARK DRILLING FLUIDS INDIA PRIVATE LIMITED",
"NEWPATH CONSULTANTS PRIVATE LIMITED",
"NEWPIOUS SYNERGIES PRIVATE LIMITED",
"NEW-PLUS TRANS LOGISTICS PRIVATE LIMITED",
"NEWPOINT CARDS & PRINTERS PRIVATE LIMITED",
"NEWPORT INDIA PRIVATE LIMITED",
"NEWPORT INVESTMENT ADVISORS PRIVATE LIMITED",
"NEWPORT MEDICAL SOLUTIONS INDIA PRIVATE LIMITED",
"NEWPRINCE MANAGEMENT SERVICES INDIA PRIVATE LIMITED",
"NEWPUNJAB TOURIST TRANSPORT PRIVATE LIMITED",
"NEWPUT INFOTECH PRIVATE LIMITED",
"NEWQUEST ADVISORS INDIA LLP",
"NEWQUEST INSURANCE BROKING SERVICES LIMITED",
"NEWRAISE IMPEX PRIVATE LIMITED",
"NEWREKA CHEMICALS PRIVATE LIMITED",
"NEWREKA GREEN SYNTH TECHNOLOGIES PRIVATE LIMITED",
"NEWRISHAV BUSINESS PRIVATE LIMITED",
"NEWS LAUNDRY MEDIA PRIVATE LIMITED",
"NEWS NATION NETWORK PRIVATE LIMITED",
"NEWS24 BROADCAST INDIA LIMITED",
"NEWSABARI ROLLER FLOUR MILLS PRIVATE LIMITED",
"NEWSHRI JEWELLERS PRIVATE LIMITED",
"NEWSMEN ASSOCIATES PRIVATE LIMITED",
"NEWSOL AGRITECHNOLOGIES (OPC) PRIVATE LIMITED",
"NEWSOL PV POWER PRIVATE LIMITED",
"NEWSPACE INDIA LIMITED",
"NEWSPACK LOGISTICS PRIVATE LIMITED",
"NEWSPRINT PACKAGING INDIA PRIVATE LIMITED",
"NEWSRISE FINANCIAL RESEARCH & INFORMATION SERVICES PRIVATE LIMITED",
"NEWSTAR INFORMATION SYSTEMS (INDIA) LIMITED",
"NEWSTAR INJECTORS PRIVATE LIMITED",
"NEWSTAR TOURS AND TRAVELS PRIVATE LIMITED",
"NEWSTECH INDIA PRIVATE LIMITED",
"NEWSTREND NETWORK COMMUNICATION PRIVATE LIMITED",
"NEWSTRIDES CONSULTING PRIVATE LIMITED",
"NEWSTROKES ONLINE PRIVATE LIMITED",
"NEWSWAN TECHNOLOGIES LIMITED",
"NEWT GLOBAL INDIA PRIVATE LIMITED",
"NEWTARAMA ENGG. & NEW MEMARI ROTAVATOR PRIVATE LIMITED",
"NEWTEAM MACHINES PRIVATE LIMITED",
"NEWTEC HYDRAULICS PRIVATE LIMITED",
"NEWTEC PRO MANUFACTURING PRIVATE LIMITED",
"NEWTECH AGRO PRODUCTS PRIVATE LIMITED",
"NEWTECH AUTO COMPONENTS PRIVATE LIMITED",
"NEWTECH AUTOMOTIVE PRIVATE LIMITED",
"NEWTECH BUILDHOME PRIVATE LIMITED",
"NEWTECH BUSINESS SOLUTION PRIVATE LIMITED",
"NEWTECH COMPUTER SERVICES PRIVATE LIMITED",
"NEWTECH FILTER INDIA PRIVATE LIMITED",
"NEWTECH HOME APPLIANCES PRIVATE LIMITED",
"NEW-TECH INFRASTRUCTURE PRIVATE LIMITED",
"NEW-TECH PNEUMATICS PRIVATE LIMITED",
"NEWTECH POWER INDUSTRIES PRIVATE LIMITED",
"NEWTECH PRECISION PRODUCTS PRIVATE LIMITED",
"NEWTECH SWITCHGEAR PRIVATE LIMITED",
"NEWTECH VIDEO SYSTEMS PRIVATE LIMITED",
"NEWTECH VILLA DEVELOPERS PRIVATE LIMITED",
"NEWTECH WATER PURIFIER SYSTEMS PRIVATE LIMITED",
"NEWTEK CONVEY EQUIPMENTS PRIVATE LIMITED.",
"NEWTEX GLOBAL TRADING PRIVATE LIMITED",
"NEWTIMES DEVELOPMENT INDIA PRIVATE LIMITED",
"NEWTO SOLUTIONS CONSULTING PRIVATE LIMITED",
"NEWTON CONSULTING INDIA PRIVATE LIMITED",
"NEWTON ENGINEERING AND CHEMICALS LIMITED",
"NEWTON EQUIPMENTS PRIVATE LIMITED",
"NEWTON FIRETECH SYSTEMS PRIVATE LIMITED",
"NEWTON POLYMERS PRIVATE LIMITED",
"NEWTON SOFTWARE PRIVATE LIMITED",
"NEWTON SOLAR PRIVATE LIMITED",
"NEWTONS APPLE PUBLIC SCHOOL",
"NEWTOWN SQUARE MANAGEMENT SERVICES PRIVATE LIMITED",
"NEWTRACK COMPUTERS PRIVATE LIMITED",
"NEWTRIMED HEALTHCARE PRIVATE LIMITED",
"NEWTRONIC LIFECARE EQUIPMENT PRIVATE LIMITED",
"NEWTTORR PUMPS AND SYSTEMS PRIVATE LIMITED",
"NEWTURN AUTOMATION PRIVATE LIMITED",
"NEWWAVE APPARELS PRIVATE LIMITED",
"NEWWAY BUILDCON PRIVATE LIMITED",
"NEWWILL BIOTECH PRIVATE LIMITED",
"NEWYOK FABRICS PRIVATE LIMITED",
"NEWZONE TIE UP PRIVATE LIMITED",
"NEX FARM PRODUCTS INDIA PRIVATE LIMITED",
"NEX GEN AGRI MARKETING SOLUTIONS PRIVATE LIMITED",
"NEXA CHEMICALS PRIVATE LIMITED",
"NEXA FAIRDEALS CARS PRIVATE LIMITED",
"NEXA HEALTHCARE PRIVATE LIMITED",
"NEXA PROCESSORS PRIVATE LIMITED",
"NEXA SALES SOLUTION PRIVATE LIMITED",
"NEXA SOLAR PRIVATE LIMITED",
"NEXAMATIC SOFTWARE SOLUTIONS PRIVATE LIMITED",
"NEXAMO TECHNOPLAST PRIVATE LIMITED",
"NEXAPP TECHNOLOGIES PRIVATE LIMITED",
"NEXAS ELECTROTECH PRIVATE LIMITED",
"NEXAUM ENERGY PRIVATELIMITED",
"NEXBASE INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"NEXCELL MOBILE PHONES & ACCESSORIES (I) PRIVATE LIMITED",
"NEXCO AUTOMATION TECHNOLOGIES PRIVATE LIMITED",
"NEXCSTEP RETAIL PRIVATE LIMITED",
"NEXDIGM CORPORATE SERVICES PRIVATE LIMITED",
"NEXDIGM PRIVATE LIMITED",
"NEXELLENCE CONSULTING SERVICES PRIVATE LIMITED",
"NEXER PRIVATE LIMITED",
"NEXERA MOTORS PRIVATE LIMITED",
"NEXES SOLUTIONS PRIVATE LIMITED",
"NEXG DEVICES PRIVATE LIMITED",
"NEXG HEALTHCARE SOLUTIONS LLP",
"NEXG HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"NEXG IOT SOLUTIONS PRIVATE LIMITED",
"NEXGE TECHNOLOGIES PRIVATE LIMITED",
"NEXGEN COMPUTERS PRIVATE LIMITED",
"NEXGEN DIGITAL INFRASTRUCTURES PRIVATE LIMITED",
"NEXGEN DRYING SYSTEMS PRIVATE LIMITED",
"NEXGEN EDUCATION AND SERVICES PRIVATE LIMITED",
"NEXGEN EDUCATIONAL TRUST",
"NEXGEN ENERGIA LIMITED",
"NEXGEN FLUOROPOLYMERS PRIVATE LIMITED",
"NEXGEN FOOTWEARS PRIVATE LIMITED",
"NEX-GEN IMAGING PRIVATE LIMITED",
"NEXGEN INDUSTRIAL SOLUTIONS PRIVATE LIMITED",
"NEXGEN INFRACON PRIVATE LIMITED",
"NEXGEN INTEGRATED SYSTEMS PRIVATE LIMITED",
"NEXGEN LOGISTICS PRIVATE LIMITED",
"NEXGEN MANPOWER SERVICES PRIVATE LIMITED",
"NEXGEN RX LIFESCIENCES PRIVATE LIMITED",
"NEXGEN SALES & SERVICES PRIVATE LIMITED",
"NEXGEN SOLUTION PROVIDERS PRIVATE LIMITED",
"NEXGEN TECHNOLOGY SERVICES PRIVATE LIMITED",
"NEXGEN TECHTRONICS PRIVATE LIMITED",
"NEXGEN TELELINKS PRIVATE LIMITED",
"NEXGEN TRAVEL SERVICES PRIVATE LIMITED",
"NEXGEN VENTURES PRIVATE LIMITED",
"NEXGENIX INDIA PRIVATE LIMITED",
"NEXGENMED PHARMACY PRIVATE LIMITED",
"NEXGENSIS TECHNOLOGIES PRIVATE LIMITED",
"NEXGENSOLUTION TECHNOLOGIES PRIVATE. LIMITED.",
"NEXGILE TECHNOLOGIES PRIVATE LIMITED",
"NEXGREEN CONSULTANTS PRIVATE LIMITED",
"NEXHS RENEWABLES PRIVATE LIMITED",
"NEXIA GLOBAL PRIVATE LIMITED",
"NEXIA IMPEX PRIVATE LIMITED",
"NEXIFY BUSINESS SOLUTIONS PRIVATE LIMITED",
"NEXII IT LABS PRIVATE LIMITED",
"NEXILIS ELECTRONICS INDIA PRIVATE LIMITED",
"NEXINFO INDIA PRIVATE LIMITED",
"NEXION AUTOMATION PRIVATE LIMITED",
"NEXION AUTOMOTIVE EQUIPMENT INDIA PRIVATE LIMITED",
"NEXION INTERNATIONAL PRIVATE LIMITED",
"NEXIONPRO ENVIRONMENT SOLUTIONS PRIVATE LIMITED",
"NEXKEM PHARMACEUTICALS PRIVATE LIMITED",
"NEXLEAF ANALYTICS INDIA PRIVATE LIMITED",
"NEXO ENTERPRISES PRIVATE LIMITED",
"NEXO FOOTWEAR PRIVATE LIMITED",
"NEXO INDUSTRIES LIMITED",
"NEXOL ENGINEERS PRIVATE LIMITED",
"NEXON AUTOMATION INDIA PRIVATE LIMITED",
"NEXON OMNIVERSE LIMITED",
"NEXON PAINTS PRIVATE LIMITED",
"NEXPRO SYSTEMS PRIVATE LIMITED",
"NEXRISE ACCESS SOLUTIONS PRIVATE LIMITED",
"NEXROOT SOLUTIONS PRIVATE LIMITED",
"NEXSA BUILDERS PRIVATE LIMITED",
"NEXSALES SOLUTIONS PRIVATE LIMITED",
"NEXSEL TECH PRIVATE LIMITED",
"NEXSTAR EXTRUSIONS PRIVATE LIMITED",
"NEXSTEP INFOTECH PRIVATE LIMITED",
"NEXSTEP MULTIPARKING PRIVATE LIMITED",
"NEXSUN ENERGY PRIVATE LIMITED",
"NEXSUS BUSINESS SOLUTIONS PRIVATE LIMITED",
"NEXSUS ORGANICS PRIVATE LIMITED",
"NEXSUS TECHNOSOLUTIONS PRIVATE LIMITED",
"NEXSYS CONTROLS PRIVATE LIMITED",
"NEXT AGE DEALERS PRIVATE LIMITED",
"NEXT BIG THING MEDIA PRIVATE LIMITED",
"NEXT CARE INC",
"NEXT CHAPTER TECHNOLOGY PRIVATE LIMITED",
"NEXT CONCEPT PRIVATE LIMITED",
"NEXT DIMENSION INFRASTRUCTURE PRIVATE LIMITED",
"NEXT DOOR LEARNING SOLUTIONS PRIVATE LIMITED",
"NEXT ESTATES & PROJECTS PRIVATE LIMITED",
"NEXT FACILITY PRIVATE LIMITED",
"NEXT GEAR INDIA PRIVATE LIMITED",
"NEXT GEN AUTOMOBILES PRIVATE LIMITED",
"NEXT GEN PAPER SOLUTIONS PRIVATE LIMITED",
"NEXT GEN PUBLISHING PRIVATE LIMITED",
"NEXT GEN SECURITY SOLUTIONS PRIVATE LIMITED",
"NEXT GENERATION PROCUREMENT",
"NEXT GENERATION RETAIL PRIVATE LIMITED",
"NEXT GENERATION SIMPLE SOLUTIONS PRIVATE LIMITED",
"NEXT GENERATION STUDIO PRIVATE LIMITED",
"NEXT GENERATION TECHNOLOGY INDUSTRIES PRIVATE LIMITED",
"NEXT IDEA INDIA INTERIOR DESIGNS PRIVATE LIMITED",
"NEXT INDIA RESEARCH FOUNDATION",
"NEXT INSTRUMENTS INDIA PRIVATE LIMITED",
"NEXT INTERIORS PRIVATE LIMITED",
"NEXT LEAP CAREER SOLUTIONS PRIVATE LIMITED",
"NEXT LEVEL PROJECTS PRIVATE LIMITED",
"NEXT LINK PRIVATE LIMITED",
"NEXT MEDIAWORKS LIMITED",
"NEXT MOVE CORPORATE SOLUTIONS PRIVATE LIMITED",
"NEXT MOVE MANUFACTURING INDIA PRIVATE LIMITED",
"NEXT OLIVE TECHNOLOGIES PRIVATE LIMITED",
"NEXT PACKAGING MACHINERY PRIVATE LIMITED",
"NEXT POLYMERS LIMITED",
"NEXT RADIO LIMITED",
"NEXT SERVICES HSS PRIVATE LIMITED",
"NEXT SOURCING SERVICES (INDIA) PRIVATE LIMITED",
"NEXT SPHERE TECHNOLOGIES",
"NEXT STEP BUDDY CONSULTANCY PRIVATE LIMITED",
"NEXT STEP ENGINEERING PRIVATE LIMITED",
"NEXT STEP PACKAGING PRIVATE LIMITED",
"NEXT TECH SOLUTIONS PRIVATE LIMITED",
"NEXT TECHNO ENTERPRISES PRIVATE LIMITED",
"NEXT TREE PRODUCTS PRIVATE LIMITED",
"NEXT TRILLION TECHNOLOGIES PRIVATE LIMITED",
"NEXT WAVE MULTIMEDIA PRIVATE LIMITED",
"NEXT2 DOOR LIVING PRIVATE LIMITED",
"NEXT2NEW VEHICLES PRIVATE LIMITED",
"NEXTAGE ENGINEERING PRIVATE LIMITED",
"NEXTAGE MEDIA PRIVATE LIMITED",
"NEXTAZY SOLUTIONS PRIVATE LIMITED",
"NEXTBILLION TECHNOLOGY PRIVATE LIMITED",
"NEXTBILLION. AI INDIA PRIVATE LIMITED",
"NEXTBITS WEB SOLUTIONS PRIVATE LIMITED",
"NEXTBRAIN TECHNOLOGIES PRIVATE LIMITED",
"NEXTBRICK SOLUTIONS LIMITED",
"NEXTBRIO PRIVATE LIMITED",
"NEXTBYTE TECHNOLOGIES PRIVATE LIMITED",
"NEXTCOWORKS OFFICE SPACE PRIVATE LIMITED",
"NEXTECH ENGINEERING INDIA PRIVATE LIMITED",
"NEXTECH GRAIN PROCESSING & ENGINEERING SOLUTIONS PRIVATE LIMITED",
"NEXTECH SOLUTIONS AND SERVICES PRIVATE LIMITED",
"NEXTECHNO GEN PRIVATE LIMITED",
"NEXTEER AUTOMOTIVE INDIA PRIVATE LIMITED",
"NEXTENDERS INDIA PRIVATE LIMITED",
"NEXTENG ENVIRO PRIVATE LIMITED",
"NEXTENTURE INDIA PRIVATE LIMITED",
"NEXTEP DIAGNOSTIC PRIVATE LIMITED",
"NEXTEP ENGINEERING PRIVATE LIMITED",
"NEXTERA ENERGY INC.",
"NEXTEXPERT TECHNOLOGIES PRIVATE LIMITED",
"NEXTFIRST ENGINEERING TECHNOLOGIES PRIVATE LIMITED",
"NEXTGEN AUTOMATION PRIVATE LIMITED",
"NEXTGEN CLEARING PRIVATE LIMITED",
"NEXTGEN ESOLUTIONS PRIVATE LIMITED",
"NEXTGEN FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"NEXTGEN FASTENERS PRIVATE LIMITED",
"NEXTGEN FIBRES PRIVATE LIMITED",
"NEXTGEN GLOBAL SERVICES PRIVATE LIMITED",
"NEXTGEN GLOBE MARKETING OPC PRIVATE LIMITED",
"NEXTGEN HEALTHCARE INDIA PRIVATE LIMITED",
"NEXTGEN HOSPITALS LLP",
"NEXTGEN INFOWORLD PRIVATE LIMITED",
"NEXTGEN INFRAPROJECTS PRIVATE LIMITED",
"NEXTGEN IN-VITRO DIAGNOSTICS PRIVATE LIMITED",
"NEXTGEN LIFE SCIENCES PRIVATE LIMITED",
"NEXTGEN MANUFACTURING TECHNOLOGIES PRIVATE LIMITED",
"NEXTGEN PROJECT MANAGEMENT SYSTEMS PRIVATE LIMITED",
"NEXTGEN SHOPPING PRIVATE LIMITED",
"NEXTGEN SOFTECH GLOBAL PRIVATE LIMITED",
"NEXTGEN SOLUX POWER PRIVATE LIMITED",
"NEXTGEN TECH IMPEX LIMITED",
"NEXTGEN TECH INITIATIVES PRIVATE LIMITED",
"NEXTGEN TELESOLUTIONS PRIVATE LIMITED",
"NEXTGEN TYREHAUS PRIVATE LIMITED",
"NEXTGEN WEB SERVICES INDIA PRIVATE LIMITED",
"NEXTGENDI SOLUTIONS PRIVATE LIMITED",
"NEXTGENERATION 3DPRINTERS PRIVATE LIMITED",
"NEXTGROWTH LABS PRIVATE LIMITED",
"NEXTHERMAL MANUFACTURING INDIA PRIVATE LIMITED",
"NEXTHINK INDIA DIGITAL EXPERIENCE PRIVATE LIMITED",
"NEXTHIRE LLP",
"NEXTILE MARBOSYS PRIVATE LIMITED",
"NEXTIOR BUILDING PRODUCTS PRIVATE LIMITED",
"NEXTJEN COOLING TOWERS PRIVATE LIMITED",
"NEXTLINK TECHNOLOGIES INDIA PRIVATE LIMITED",
"NEXTNODE BIOSCIENCE PRIVATE LIMITED",
"NEXTNODE SOLUTIONS PRIVATE LIMITED",
"NEXTON FOODS PRIVATE LIMITED",
"NEXTON SERVICES PRIVATE LIMITED",
"NEXTON TELECOM PRIVATE LIMITED",
"NEXTORBIT PLATFORMS AND SOLUTIONS PRIVATE LIMITED",
"NEXTORK TRANSMISSION PRIVATE LIMITED",
"NEXTORY PRIVATE LIMITED",
"NEXTPACK POOLING PRIVATE LIMITED",
"NEXTRA COMMUNICATIONS PRIVATE LIMITED",
"NEXTRA ONLINE SERVICES PRIVATE LIMITED",
"NEXTRAY TECHNOLOGIES PRIVATE LIMITED",
"NEXTREMER SOLUTIONS INDIA PRIVATE LIMITED",
"NEXTRISE FURNITURE PRIVATE LIMITED",
"NEXTROVE IT SOLUTIONS PRIVATE LIMITED",
"NEXTROW PRIVATE LIMITED",
"NEXTSERVICES HEALTHCARE SOURCING SOLUTIONS PRIVATE LIMITED",
"NEXTSTEP INFOTECH PRIVATE LIMITED",
"NEXTSTEPS AI PRIVATE LIMITED",
"NEXTUP TECHNOLOGIES PRIVATE LIMITED",
"NEXTUPLE INDIA PRIVATE LIMITED",
"NEXTURE TECHNOLOGIES PRIVATE LIMITED",
"NEXTVIEW TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"NEXTWAVE COMMUNICATIONS PRIVATE LIMITED",
"NEXTWAY TECHNOLOGIES PRIVATE LIMITED",
"NEXTWEALTH ENTREPRENEURS PRIVATE LIMITED",
"NEXTWEB TECHNOLOGIES PRIVATE LIMITED",
"NEXTWORLD SOLUTIONS PRIVATE LIMITED",
"NEXTYN ADVISORY PRIVATE LIMITED",
"NEXUG INDUSTRIES PRIVATE LIMITED",
"NEXULUS INFORMATICS PRIVATE LIMITED",
"NEXURE LIFESCIENCES PRIVATE LIMITED",
"NEXUS ALLIANCE ADVERTISING AND MARKETING PRIVATE LIMITED",
"NEXUS ALLOYS AND STEELS PRIVATE LIMITED",
"NEXUS BIO SCIENCE PRIVATE LIMITED",
"NEXUS BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"NEXUS BUSINESS SOLUTIONS PRIVATE LIMITED",
"NEXUS CARGO HANDLING PRIVATE LIMITED",
"NEXUS CENTRAL LAB SERVICES PRIVATE LIMITED",
"NEXUS COMPUTERS PRIVATE LIMITED",
"NEXUS CROP SCIENCE PRIVATE LIMITED",
"NEXUS DEVELOPMENT CENTER PRIVATE LIMITED",
"NEXUS DRUGS PRIVATE LIMITED",
"NEXUS FLIGHT OPERATIONS INDIA PRIVATE LIMITED",
"NEXUS GLOBAL LOGISTICS PRIVATE LIMITED",
"NEXUS GLOBAL SOLUTIONS PRIVATE LIMITED",
"NEXUS HR CONSULTANTS PRIVATE LIMITED",
"NEXUS INDIA CAPITAL ADVISORS PRIVATE LIMITED",
"NEXUS INDUSTRIES PRIVATE LIMITED",
"NEXUS INFORMATICS SOLUTIONS INDIA PRIVATE LIMITED",
"NEXUS INFOSOFT PRIVATE LIMITED",
"NEXUS INFOTECH LIMITED",
"NEXUS INFRA DEVELOPERS PRIVATE LIMITED",
"NEXUS INFRATECH PRIVATE LIMITED",
"NEXUS INNOVATIVE SOLUTIONS PRIVATE LIMITED",
"NEXUS LEARNING PRIVATE LIMITED",
"NEXUS LIFECARE PRIVATE LIMITED",
"NEXUS MANGALORE RETAIL PRIVATE LIMITED",
"NEXUS MARCOM PRIVATE LIMITED",
"NEXUS MECHATRONICS PRIVATE LIMITED",
"NEXUS MOTORS PRIVATE LIMITED",
"NEXUS MYSORE RETAIL PRIVATE LIMITED",
"NEXUS NUTRI SCIENCE LIMITED",
"NEXUS OUTSOURCING LIMITED",
"NEXUS PETROCHEM PRIVATE LIMITED",
"NEXUS PHARMA CHEM PRIVATE LIMITED",
"NEXUS POINT CIVIL LINES",
"NEXUS POLYPLAST PRIVATE LIMITED",
"NEXUS PROJECT SOLUTIONS PRIVATE LIMITED",
"NEXUS SAFETY SOLUTIONS PRIVATE LIMITED",
"NEXUS SANITATIONS PRIVATE LIMITED",
"NEXUS SECURITY SERVICES PRIVATE LIMITED",
"NEXUS SOLAR ENERGY PRIVATE LIMITED",
"NEXUS SURGICAL AND MEDICARE LIMITED",
"NEXUS SYSTEM PRIVATE LIMITED",
"NEXUS TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"NEXUS TECHNOWARE SOLUTION PRIVATE LIMITED",
"NEXUS TELECOM PRIVATE LIMITED",
"NEXUS TEST LABS PRIVATE LIMITED",
"NEXUS TRAVEL SOLUTIONS",
"NEXUS VENTURES PRIVATE LIMITED",
"NEXUSLINK SERVICES INDIA PRIVATE LIMITED",
"NEXUSNINE GLOBAL PRIVATE LIMITED",
"NEXUSONE EXPRESS PRIVATE LIMITED",
"NEXUSS SALES & DISTRIBUTIONS PRIVATE LIMITED",
"NEXUSTAR LIGHTING PROJECT PRIVATE LIMITED",
"NEXVAL INFOTECH PRIVATE LIMITED",
"NEXWARE TECHNOLOGIES PRIVATE LIMITED",
"NEXWAVE LEARNING MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"NEXWIN PHARMA PRIVATE LIMITED",
"NEXXA COMPOUNDS PRIVATE LIMITED",
"NEXXBASE MARKETING PRIVATE LIMITED",
"NEXXGEN ISPAT PRIVATE LIMITED",
"NEXXT STEPUP PRIVATE LIMITED",
"NEXZONE ENERGY UTILITIES LLP",
"NEXZU MOBILITY LIMITED",
"NEYADHI TRADERS AND CONTRACTORS PRIVATE LIMITED",
"NEYCER JALAA PRIVATE LIMITED",
"NEYOL INDUSTRIES PRIVATE LIMITED",
"NEYSA APPARELS PRIVATE LIMITED",
"NEYSA JEWELLERY LIMITED",
"NEYVELI LIGNITE CORPORATION LIMITED.",
"NEYVELI UTTAR PRADESH POWER LIMITED",
"NEYYAR ACADEMY PRIVATE LIMITED",
"NEYYAR EDUCATION PRIVATE LIMITED",
"NEYYAR TECHNOLOGIES PRIVATE LIMITED",
"NEZDA TECHNOLOGIES PRIVATE LIMITED",
"NEZHUVINKAL ENTERPRISES PRIVATE LIMITED",
"NEZONE FOODS PRIVATE LIMITED",
"NEZONE GLASS PRIVATE LIMITED",
"NEZONE INDUSTRIES LIMITED",
"NEZONE STRIPS LIMITED",
"NEZONE TUBES (TN) LIMITED",
"NEZONE TUBES (UTKAL) LIMITED",
"NEZONE TUBES LIMITED",
"NEZTA LIFESTYLE PRIVATE LIMITED",
"NF BUSINESS SOLUTIONS PRIVATE LIMITED",
"NF FORGINGS PRIVATE LIMITED",
"NF HEALTHCARE INDIA PRIVATE LIMITED",
"NF INFRATECH SERVICE PRIVATE LIMITED",
"NFA LIFE SECURE PRIVATE LIMITED",
"NFAKTOR SOLUTIONS PRIVATE LIMITED",
"NFB EXOTIK (INDIA) PRIVATE LIMITED",
"NFB POLYMERS PVT.LTD.",
"NFC INDIA PRIVATE LIMITED",
"NFC SOLUTIONS INDIA PRIVATE LIMITED",
"NFERENCE LABS PRIVATE LIMITED",
"NFILADE SECURITY SOLUTIONS PRIVATE LIMITED",
"NFINITY SOLUTIONS PRIVATE LIMITED",
"NFN LABS (OPC) PRIVATE LIMITED",
"NFOLKS SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"NFORCE INFRASTRUCTURE INDIA PRIVATE LIMITED",
"NFS TECHNOLOGY GROUP",
"NFUTURETEC PRIVATE LIMITED",
"NG DIGITAL SOLUTIONS PRIVATE LIMITED",
"NG DIGITAL STUDIOS PRIVATE LIMITED",
"NG GRAPHICS OF INDIA PRIVATE LIMITED",
"NG HOSPITAL PRIVATE LIMITED",
"NG INFRA-BUILDTECH PRIVATE LIMITED",
"NG RATHI INVESTRADES PRIVATE LIMITED",
"NG TECHASSURANCE PRIVATE LIMITED",
"NGA HR INDIA PRIVATE LIMITED",
"NGAGE IMPEX PRIVATE LIMITED",
"NGAGE MEDIA SERVICES PRIVATE LIMITED",
"NGAGE WHEEL PRIVATE LIMITED",
"NGATE TECHNOVISION PRIVATE LIMITED",
"NGB DIAGNOSTICS PRIVATE LIMITED",
"NGB EDUCATION PRIVATE LIMITED",
"NGB FOODS PRIVATE LIMITED",
"NGB LABORATORIES PRIVATE LIMITED",
"NGC BROADBAND PRIVATE LIMITED",
"NGC NETWORK INDIA PRIVATE LIMITED",
"NGC TRANSMISSION INDIA PRIVATE LIMITED",
"NGCT CLEANSYS PRIVATE LIMITED",
"NGDA SERVICES PRIVATE LIMITED",
"NGDA WATCHES PRIVATE LIMITED",
"NGE DRILLSOL PRIVATE LIMITED",
"NGE RENEWABLE ENERGY SYSTEMS PRIVATE LIMITED",
"NGEF (HUBLI) LIMITED",
"NGENIOUS SOLUTIONS PRIVATE LIMITED",
"NGENUX SOLUTIONS PRIVATE LIMITED",
"NGFV INDIA PRIVATE LIMITED",
"NGG POWER TECH INDIA PRIVATE LIMITED",
"NGGAWE NIRMAN TECHNOLOGIES PRIVATE LIMITED",
"NGI APEX IT INDIA PRIVATE LIMITED",
"NGI VENTURES PRIVATE LIMITED",
"NITERRA INDIA PRIVATE LIMITED",
"NGK TECHNOLOGIES INDIA PRIVATE LIMITED",
"NGL FINE CHEM LIMITED",
"NGLC REALTECH PRIVATE LIMITED",
"NGM HYGEINE CARE PRIVATE LIMITED",
"NG-NEXT TECH PRIVATE LIMITED",
"NGP DEVELOPER PRIVATE LIMITED",
"NGP INDUSTRIES PRIVATE LIMITED",
"NGP WEB SMART PRIVATE LIMITED",
"NGPL PAPER PACK PRIVATE LIMITED",
"NGR LABORATORIES PRIVATE LIMITED",
"NGRT SYSTEMS PRIVATE LIMITED",
"NGS BUILDPRO PRIVATE LIMITED",
"NGS ENTERPRISES PRIVATE LIMITED",
"NGS GLOBAL INDIA PRIVATE LIMITED",
"NGSUPPLYCHAIN SOLUTIONS PRIVATE LIMITED",
"NGT FREIGHT CARRIERS PRIVATE LIMITED",
"NGT NIRMAAN PRIVATE LIMITED",
"NGX LOGISTICS PRIVATE LIMITED",
"NH FASHION STUDIO",
"NH7 FACTORY OUTLETS PRIVATE LIMITED",
"NHA INFRAPROJECTS PRIVATE LIMITED",
"NHANCE CONSULTING ENGINEERS PRIVATE LIMITED",
"NHANZ SYSTEMS PRIVATE LIMITED",
"NHAVA SHEVA (INDIA) GATEWAY TERMINAL PRIVATE LIMITED",
"NHAVA SHEVA BUSINESS PARK PRIVATE LIMITED",
"NHAVA SHEVA DISTRIBUTION TERMINAL PRIVATE LIMITED",
"NHAVA SHEVA INTERNATIONAL CONTAINER TERMINAL PRIVATE LIMITED\n",
"NHB AGRO INDUSTRIES PRIVATE LIMITED",
"NHB BALL AND ROLLER LIMITED",
"NHC FOODS LIMITED",
"NHD CONSTRUCTIONS PRIVATE LIMITED",
"NHD FORWARDERS PRIVATE LIMITED",
"NHDC LIMITED",
"NHJ INFRA PRIVATE LIMITED",
"NHK AUTOMOTIVE COMPONENTS INDIA PRIVATE LIMITED",
"NHK F KRISHNA INDIA AUTOMOTIVE SEATING PRIVATE LIMITED",
"NHK SPRING INDIA LIMITED",
"NHL DISTRIBUTION PRIVATE LIMITED",
"NHPC LIMITED",
"NHR CONSTRUCTIONS PRIVATE LIMITED",
"NHRS SOFT SYSTEMS PRIVATE LIMITED",
"NI HON CYLINDERS PRIVATE LIMITED",
"NI MICRO TECHNOLOGIES PRIVATE LIMITED",
"NI RA INFRASTRUCTURE ENGINEERS PRIVATE LIMITED",
"NI SYSTEMS INDIA PRIVATE LIMITED",
"NIA PLAST PRIVATE LIMITED",
"NIA SOFTWARE INDIA PRIVATE LIMITED",
"NIAGARA DEVELOPERS PRIVATE LIMITED",
"NIAGARA FINANCIAL CONSULTANTS PRIVATE LIMITED",
"NIAGARA HEIGHTS PRIVATE LIMITED",
"NIAGARA HOTELS &BUILDERS PRIVATE LIMITED",
"NIAGARA NETWORKS INDIA PRIVATE LIMITED",
"NIAM GUSTO KITCHEN PRIVATE LIMITED",
"NIAM INTERNATIONAL PRIVATE LIMITED",
"NIAN MEDIA PRIVATE LIMITED",
"NIBAARA TECHNOLOGIES PRIVATE LIMITED",
"NIBANA SOLUTIONS PRIVATE LIMITED",
"NIBATEK CHEMICALS PRIVATE LIMITED",
"NIBAV LIFTS PRIVATE LIMITED",
"NIBBLE SYSTEMS PRIVATE LIMITED",
"NIBCO PRIVATE LIMITED",
"NIBCOP FITTINGS PRIVATE LIMITED",
"NIBE LIMITED",
"NIBE TECHNOLOGIES PRIVATE LIMITED",
"NIBEDITA MEDICARE & DIAGNOSTIC PRIVATE LIMITED",
"NIBHA CAPITAL SERVICES PRIVATE LIMITED",
"NIBHA ENTERPRISE PRIVATE LIMITED",
"NIBIR MOTORS PRIVATE LIMITED",
"NIBL KORTA ENGEERING INDIA PRIVATE LIMITED",
"NIBLICK CAPITAL GROWTH PRIVATE LIMITED",
"NIBODH OIL AND TRADES PRIVATE LIMITED",
"NIBORIYA & SONS PRIVATE LIMITED",
"NIBRAS CONSTRUCTION PRIVATE LIMITED",
"NIBRAS SHOES PRIVATE LIMITED",
"NIBRAZ BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"NIBSO METALS PVT LTD",
"NICA TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"NICASA STEEL PRIVATE LIMITED",
"NICASU BULK CARRIERS PRIVATE LIMITED",
"NICCO EASTERN PRIVATE LIMITED",
"NICCO ENGINEERING SERVICES LIMITED",
"NICCO JUBILEE PARK LIMITED",
"NICCO VENTURES LIMITED",
"NICDC HARYANA MULTI MODAL LOGISTIC HUB PROJECT LIMITED",
"NICDC LOGISTICS DATA SERVICES LIMITED",
"NICDC NEEMRANA SOLAR POWER LIMITED",
"NICDIT KRISHNAPATNAM INDUSTRIAL CITY DEVELOPMENT LIMITED",
"NICE AND NATURAL PRODUCTS PRIVATE LIMITED",
"NICE AUTO DEALER PRIVATE LIMITED",
"NICE AUTOMATION PRIVATE LIMITED",
"NICE CERAMIC PRIVATE LIMITED",
"NICE CHEMICALS PRIVATE LIMITED",
"NICE DIAMONDS ( INDIA) PRIVATE LIMITED",
"NICE EXPORTS PVT LTD",
"NICE FRAME PRIVATE LIMITED",
"NICE GOLD PRIVATE LIMITED",
"NICE IMPORTS PRIVATE LIMITED",
"NICE INTERACTIVE SOLUTIONS INDIA PRIVATE LIMITED",
"NICE INTERIORS PRIVATE LIMITED",
"NICE INTERNATIONAL LIMITED",
"NICE LEATHER AND CHAPPALS COMPANY PRIVATE LIMITED",
"NICE NEOTECH MEDICAL SYSTEMS PRIVATE LIMITED",
"NICE PACK INDUSTRIES PRIVATE LIMITED",
"NICE PACK POLY PLAST PVT LTD",
"NICE PAPERS LIMITED",
"NICE PHARMACEUTICALS PRIVATE LIMITED",
"NICE PROJECTS PRIVATE LIMITED",
"NICE QUARTZ & STONES PRIVATE LIMITED",
"NICE RETAILBIZ TECHNOLOGY PRIVATE LIMITED",
"NICE SANJAY ROCKS INDIA PRIVATE LIMITED",
"NICE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"NICE TELECOMMUNICATIONS PRIVATE LIMITED",
"NICE WATER CARE INDUSTRIES PRIVATE LIMITED",
"NICE WEDDING CARDS PRIVATE LIMITED",
"NICEG PRIVATE LIMITED",
"NICETECH TECHNO INDIA PRIVATE LIMITED",
"NICETRENDS JEWELS (INDIA) PRIVATE LIMITED",
"NICHE BEAUTE SOLUTIONS PRIVATE LIMITED",
"NICHE BUSINESS PROMOTIONS PRIVATE LIMITED",
"NICHE COMPUTER CONSULTANTS PRIVATE LIMITED",
"NICHE DECOR PRIVATE LIMITED",
"NICHE EVENTS AND PROMOTIONS PRIVATE LIMITED",
"NICHE FINANCIAL SERVICES PRIVATE LIMITED",
"NICHE FINCAP ADVISORY SERVICES LLP",
"NICHE HEALTH OPTIONS PRIVATE LIMITED",
"NICHE SECURITIES PRIVATE LIMITED",
"NICHE SOFTEK PRIVATE LIMITED",
"NICHE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"NICHEBEES TECHNOSOLUTIONS PRIVATE LIMITED",
"NICHEBIT SOFTECH PRIVATE LIMITED",
"NICHEM OXIDES PRIVATE LIMITED",
"NICHEM SOLUTIONS",
"NICHEPHARM LIFESCIENCES PRIVATE LIMITED",
"NICHETECH COMPUTER SOLUTIONS PRIVATE LIMITED",
"NICHETON CONSULTING LLP",
"NICHEZ INDUSTRIES PRIVATE LIMITED",
"NICHI IN SOFTWARE SOLUTIONS PRIVATE LIMITED",
"NICHI MANUFACTURING PRIVATE LIMITED",
"NICHIA CHEMICAL (INDIA) PRIVATE LIMITED",
"NICHIAS INDUSTRIAL PRODUCTS PRIVATE LIMITED",
"NICHICON ELECTRONICS INDIA PRIVATE LIMITED",
"NICHI-IN BIO-SCIENCES PRIVATE LIMITED",
"NICHIMEN AGRO ASIA PTE LIMITED",
"NICHINO INDIA PRIVATE LIMITED",
"NICHIRIN IMPERIAL AUTOPARTS INDIA PRIVATE LIMITED",
"NICHIYU FORKLIFTS INDIA PRIVATE LIMITED",
"NICHOLAS HEALTHCARE LIMITED",
"NICHOLSON CHEMICAL PRIVATE LIMITED",
"NICHOLSON VANIJYA PVT. LTD.",
"NI-CHROME ALLOY CASTINGS PRIVATE LIMITED",
"NICHROME INDIA LIMITED",
"NICIA FOOD AND DRINKS PRIVATE LIMITED",
"NICK FOODS PRIVATE LIMITED",
"NICK IT SOLUTIONS PRIVATE LIMITED",
"NICK PETROCHEM PRIVATE LIMITED",
"NICKEL SCREENS (INDIA) PVT LTD",
"NICKELFOX TECHNOLOGIES PRIVATE LIMITED",
"NICKS AUTO INDUSTRIES PRIVATE LIMITED",
"NICKUNJ EDM WIRES & CONSUMABLES PRIVATE LIMITED",
"NICKY VICKY IMPEX PRIVATE LIMITED",
"NICMAR UNIVERSITY PUNE",
"NICO AGRO OIL PRODUCTS PVT LTD",
"NICO EXTRUSIONS LIMITED",
"NICO ORGO MARKETING PRIVATE LIMITED",
"NICOBAR DESIGN PRIVATE LIMITED",
"NICOBAR DESIGN STUDIO PRIVATE LIMITED",
"NICOLA EDUCATIONAL AND RESEARCH FOUNDATION",
"NICOLO EXPORTS INDIA PVT.LTD.",
"NICOMATIC INDIA ELECTRONICS PRIVATE LIMITED",
"NICORA INTERIORS PRIVATE LIMITED",
"NICORE INDIA PRIVATE LIMITED",
"NICOSUR TECHNOLOGIES PRIVATE LIMITED",
"NICOTRA INDIA PRIVATE LIMITED",
"NICOX IT SOLUTIONS PRIVATE LIMITED",
"NICRMO FASTENERS PRIVATE LIMITED",
"NICRO ALLOYS COMPANY (INDIA) PVT LTD",
"NICT COMPUTER EDUCATION PRIVATE LIMITED",
"NICT TECHNOLOGIES PRIVATE LIMITED",
"NIDAAN CHEMICALS PVT LTD",
"NIDAAN EXIM PRIVATE LIMITED",
"NIDAEMA INFRACON PRIVATE LIMITED",
"NIDAN DIAGNOSTIC AND HEART CENTRE PRIVATE LIMITED",
"NIDAN LABORATORIES AND HEALTHCARE LIMITED",
"NIDAN TECHNOLOGIES PRIVATE LIMITED",
"NIDEC INDIA PRECISION TOOLS LIMITED",
"NIDEC INDIA PRIVATE LIMITED",
"NIDEC INDUSTRIAL AUTOMATION INDIA PRIVATE LIMITED",
"NIDEC MOBILITY INDIA PRIVATE LIMITED",
"NIDEC-SHIMPO INDIA MANUFACTURING PRIVATE LIMITED",
"NIDEESH MOTORS PRIVATE LIMITED",
"NIDEESHWARAM STEEL PRIVATE LIMITED",
"NIDEK MEDICAL INDIA PRIVATE LIMITED",
"NIDESTER TECHNOLOGIES PRIVATE LIMITED",
"NIDHAAN BUILDCON PRIVATE LIMITED",
"NIDHI ASSOCIATES PRIVATE LIMITED",
"NIDHI AUTO PRIVATE LIMITED",
"NIDHI BROKING SERVICES PRIVATE LIMITED",
"NIDHI CABLES PRIVATE LIMITED",
"NIDHI CONTAINERS PRIVATE LIMITED",
"NIDHI CREATIVE INFRASTRUCTURE PRIVATE LIMITED",
"NIDHI DYEING AND PRINTING MILLS PVT LTD",
"NIDHI ELASTOMER INDIA PRIVATE LIMITED",
"NIDHI EMBROIDERIES PRIVATE LIMITED",
"NIDHI ENCLAVE PRIVATE LIMITED",
"NIDHI ENGICON (INDIA) PRIVATE LIMITED",
"NIDHI FASHION",
"NIDHI HEALTHCARE LIMITED",
"NIDHI INSTITUTE OF CREATIVE ART AND MANAGEMENT",
"NIDHI INVESTMENTS PRIVATE LIMITED",
"NIDHI LAKSHMI FINANCE PRIVATE LIMITED",
"NIDHI LAND INFRASTRUCTURE DEVELOPERS INDIA PRIVATE LIMITED",
"NIDHI MARMO PRIVATE LIMITED",
"NIDHI MERCANTILES LIMITED",
"NIDHI METAL AUTO COMPONENTS PRIVATE LIMITED",
"NIDHI PACKAGING SOLUTIONS PRIVATE LIMITED",
"NIDHI PACKERS PVT LTD",
"NIDHI PETROCHEMICALS PRIVATE LIMITED",
"NIDHI PLAY SYSTEM PRIVATE LIMITED",
"NIDHI SHIPPING PRIVATE LIMITED",
"NIDHI SURGICAL PRIVATE LIMITED",
"NIDHI SYNTHETICS PRIVATE LIMITED",
"NIDHI TRADECOM PRIVATE LIMITED",
"NIDHI VISION INDIA PRIVATE LIMITED",
"NIDHI WIND FARMS PRIVATE LIMITED",
"NIDHI-DUTT CONTENT PRIVATE LIMITED",
"NIDHII INDUSTRIES PRIVATE LIMITED",
"NIDHIKET TECHNICAL SOLUTIONS PRIVATE LIMITED",
"NIDHINARAYAN WEAVES PRIVATE LIMITED",
"NIDI VARSHA STRUCTURES PRIVATE LIMITED",
"NIDIS ALUFAB PRIVATE LIMITED",
"NIDO HOME FINANCE LIMITED",
"NIDO MACHINERIES PRIVATE LIMITED",
"NIDP DEVELOPERS PRIVATE LIMITED",
"NIDRA HOSPITALITY GUJARAT PRIVATE LIMITED",
"NIDRA HOSPITALITY PRIVATE LIMITED",
"NIDRAA LIFESTYLE PRIVATE LIMITED",
"NIDUS ADVERTISING & MARKETING PRIVATE LIMITED",
"NIDUS AGROSCIENCES PRIVATE LIMITED",
"NIDUS EXIM PRIVATE LIMITED",
"NIDUS HEALTHCARE PRIVATE LIMITED",
"NIDUS PHARMA PRIVATE LIMITED",
"NIE POWER ANDENGG.PRIVATE LIMITED",
"NIEDAX INDIA CABLE MANAGEMENT SYSTEMS PRIVATE LIMITED",
"NIEHOFF OF INDIA PRIVATE LIMITED",
"NIELSAN TECHNOLINK PRIVATE LIMITED",
"NIELSEN MEDIA INDIA PRIVATE LIMITED",
"NIELSEN SPORTS I PRIVATE. LIMITED",
"NIELSENIQ (INDIA) PRIVATE LIMITED",
"NIEUWEN PROJECT MANAGEMENT AND WORKFORCE PRIVATE LIMITED",
"NIEVA HOMES PRIVATE LIMITED",
"NIF ISPAT LIMITED",
"NIF MECHANICAL WORKS PRIVATE LIMITED",
"NIF PRIVATE LIMITED",
"NIFA INFOCOMP SERVICES PRIVATE LIMITED",
"NIFARA TRAVELS & TOURS PRIVATE LIMITED",
"NIFAST INDIA PRIVATE LIMITED",
"NIFCO INDIA PRIVATE LIMITED",
"NIFCO SOUTH INDIA MANUFACTURING PRIVATE LIMITED",
"NIFD INSTITUTE OF FASHION DESIGN LIMITED",
"NIFT",
"NIFTEL COMMUNICATIONS PRIVATE LIMITED",
"NIFTY CHEMICALS PRIVATE LIMITED",
"NIFTY INNOVATIONS PVT. LTD.",
"NIFTY LABS PRIVATE LIMITED",
"NIFTY PLASTICS PRIVATE LIMITED",
"NIGACHA FASHIONS PRIVATE LIMITED",
"NIGAM COLD STORAGE PVT LTD",
"NIGAM ENGICON COMPANY PRIVATE LIMITED",
"NIGAM ENGINEERING AND CO.PRIVATE LTD.",
"NIGAM ENTERPRISES",
"NIGAM JEWELS PRIVATE LIMITED",
"NIGAM PRATIBHA VIDAYALAYA-MCD SCHOOL DEL",
"NIGAMA COMPTECH AND SERVICES PRIVATE LIMITED",
"NIGAMANANDA ABASAN PRIVATE LIMITED",
"NIGAMANANDA COLD STORAGE PRIVATE LIMITED",
"NIGANIA STEELS PRIVATE LIMITED",
"NIGHTANGLE VANIJYA PRIVATE LIMITED",
"NIGHTHACK TECHNOLOGY PRIVATE LIMITED",
"NIGHTHOUSE CAFE PRIVATE LIMITED",
"NIGHTINGALE DIAGNOSTIC AND MEDICARE CENTRE PRIVATE LIMITED",
"NIGHTINGALE FINANCE AND LEASING LIMITED",
"NIGHTINGALE FINVEST PRIVATE LIMITED",
"NIGHTINGALE HOME HEALTH SERVICES PRIVATE LIMITED",
"NIGHTINGALE HOSPITAL PRIVATE LIMITED",
"NIGHTJAR FREIGHT PRIVATE LIMITED",
"NIGLA INFRASTRUCTURE & POWER PROJECTS PRIVATE LIMITED",
"NIGLA NISSAN AUTOMOBILES PRIVATE LIMITED",
"NIGRAHA REALTIES PRIVATE LIMITED",
"NIHAAR EQUIPMENT PRIVATE LIMITED",
"NIHAL BUILDWELL PRIVATE LIMITED",
"NIHAL FISCAL SERVICES PVT LTD",
"NIHAL INDUSTRIES PRIVATE LIMITED",
"NIHALA AUTO SOLUTIONS PRIVATE LIMITED",
"NIHALCHAND JAIN INFRA PROJECT PRIVATE LIMITED",
"NIHAN INFRASTRUCTURE PRIVATE LIMITED",
"NIHAN TRADING PRIVATE LIMITED",
"NIHAR HOSPITALITY PRIVATE LIMITED",
"NIHAR INFO GLOBAL LIMITED",
"NIHAR TECHNOCRAFTS PRIVATE LIMITED",
"NIHARIKA DYEING AND PRINTING MILLS PVT LTD",
"NIHARIKA FABRICS INDIA PRIVATE LIMITED",
"NIHARIKA HOLDINGS PVT. LTD.",
"NIHARIKA HOTELS PRIVATE LIMITED",
"NIHARIKA INFOSYSTEMS PRIVATE LIMITED",
"NIHARIKA LOGISTICS PRIVATE LIMITED",
"NIHARIKA PAINTS & CHEMICALS PVT LTD",
"NIHARIKA RETAILS PRIVATE LIMTED",
"NIHARIKA THREADS PRIVATE LIMITED",
"NIHAWK LOGISTICS INDIA PRIVATE LIMITED",
"NIHCHAL ISRANI FOUNDATION",
"NIHILENT LIMITED",
"NIHIR EXTRU MOULD INDUSTRIES",
"NIHIRA BUSINESS SOLUTIONS INDIA PRIVATE LIMITED",
"NIHIT ENTERPRISES PRIVATE LIMITED",
"NIHIT INFRACON PRIVATE LIMITED",
"NIHODO MEDIA PRIVATE LIMITED",
"NIHON COMMUNICATION SOLUTIONS PRIVATE LIMITED",
"NIHON CORPORATE SOLUTIONS PRIVATE LIMITED",
"NIHON DENKEI INDIA PRIVATE LIMITED",
"NIHON EDUTECH PRIVATE LIMITED",
"NIHON IMPEX PVT LTD",
"NIHON INDIA SERVICES PRIVATE LIMITED",
"NIHON ISPAT PVT LTD",
"NIHON KOHDEN INDIA PRIVATE LIMITED",
"NIHON MEDIA OUTDOORS PRIVATE LIMITED",
"NIHON NEEDS INTERNATIONAL PRIVATE LIMITED",
"NIHON PARKERIZING (INDIA) PRIVATE LIMITED",
"NIHON SALES PRIVATE LIMITED",
"NIHON TECHNOLOGY PRIVATE LIMITED",
"NIHSAD NATIONAL INSTITUTE OF HIGH SECURITY ANIMAL DISEASES",
"NIHVA TECHNOLOGIES PRIVATE LIMITED",
"NIIRT CENTRE OF CALIBRATION ANALYSIS & TESTING (NIIRT-CACAT)",
"NIIT INSTITUTE OF FINANCE BANKING AND INSURANCE TRAINING LIMITED",
"NIIT LEARNING SYSTEMS LIMITED",
"NIIT LIMITED",
"NIIT TECHNOLOGIES LIMITED",
"NIIT UNIVERSITY",
"NIITI CONSULTING PRIVATE LIMITED",
"NIIV SOLUTION PRIVATE LIMITED",
"NIJANAND WELDMESH INDIA PRIVATE LIMITED",
"NIJHAWAN TRAVEL SERVICE PRIVATE LIMITED",
"NIJIKO SOLUTIONS PRIVATE LIMITED",
"NIJJAR SCANS & DIAGNOSTIC CENTRE PRIVATE LIMITED",
"NIJJI HEALTHCARE PRIVATE LIMITED",
"NIJRANG ENTERPRISE PRIVATE LIMITED",
"NIK FASTENERS PRIVATE LIMITED",
"NIK MOTORS PRIVATE LIMITED",
"NIK TUBE AND FITTINGS PRIVATE LIMITED",
"NIKA ENGINEERS PRIVATE LIMITED",
"NIKA ONLINE PRIVATE LIMITED",
"NIKAD INDIA BUSINESS SOLUTIONS PRIVATE LIMITED",
"NIKALAS WOMENS COLLEGE",
"NIKAM SINTERED PRODUCTS PRIVATE LIMITED",
"NIKASH CNC ENGINEER PRIVATE LIMITED",
"NIKE ENERGY MANUFACTURING PRIVATE LIMITED",
"NIKE INC.",
"NIKE INDIA PRIVATE LIMITED",
"NIKE INDIA TECHNOLOGY CENTER PRIVATE LIMITED",
"NIKE SOURCING INDIA PRIVATE LIMITED",
"NIKEDA ART PRINTERS PRIVATE LIMITED",
"NIKET FOOD PRODUCTS PRIVATE LIMITED",
"NIKET UDYOG LTD.",
"NIKETAN PAPER BOARD PRIVATE LIMITED",
"NIKETAN PRIVATE LIMITED ONPL",
"NIKHAAR JEWELS PRIVATE LIMITED",
"NIKHAN CONTROLS (OPC) PRIVATE LIMITED",
"NIKHAR DEALERS PVT LTD",
"NIKHAR ESTATES LLP",
"NIKHAR HYGIENE PRODUCTS PRIVATE LIMITED",
"NIKHAR MARBLES PRIVATE LIMITED",
"NIKHARA BHARATH CONSTRUCTION COMPANY LIMITED",
"NIKHARA HEALTHCARE PRIVATE LIMITED",
"NIKHATH NOOR",
"NIKHATOJAS CATTLE NUTRITION PRIVATE LIMITED",
"NIKHI HEALTH CARE PRIVATE LIMITED",
"NIKHIL ADHESIVES LIMITED",
"NIKHIL AUTO WHEELS (I) PRIVATE LIMITED",
"NIKHIL CARRYING CORPORATION PRIVATE LIMITED",
"NIKHIL CERAMICS PRIVATE LIMITED",
"NIKHIL COMMODITY AND DERIVATIVES PRIVATE LIMITED",
"NIKHIL ENGICON WORKS PRIVATE LIMITED",
"NIKHIL EQUIPMENTS PRIVATE LIMITED",
"NIKHIL HOLDINGS PVT LTD",
"NIKHIL HOSPITALS",
"NIKHIL HOSPITALS PRIVATE LIMITED",
"NIKHIL INFRACONS AND ALLIED WORKS PRIVATE LIMITED",
"NIKHIL INFRASPECIALITIES PRIVATE LIMITED",
"NIKHIL INTERNATIONAL CAMPUS GROUP ENTITY",
"NIKHIL LOGISTICS PRIVATE LIMITED",
"NIKHIL MERCANTILE PRIVATE LIMITED",
"NIKHIL METAL PRIVATE LIMITED",
"NIKHIL PULSES PRIVATE LIMITED",
"NIKHIL ROLL CASTINGS PRIVATE LIMITED",
"NIKHIL SPECHEM PRIVATE LIMTED",
"NIKHIL TECHNO CHEM PRIVATE LIMITED",
"NIKHIL TREXIM PVT LTD",
"NIKHIL YARN PRIVATE LIMITED",
"NIKHILA DESIGN AND FACILITIES PRIVATE LIMITED",
"NIKHILA ESTATES PRIVATE LIMITED",
"NIKHILAM EYE CARE PRIVATE LIMITED",
"NIKHILESHWARA PLAST PRIVATE LIMITED",
"NIKHILSAI INFRA & ENTERTAINMENT PRIVATE LIMITED",
"NIKHTISH ENGINEERING PRIVATE LIMITED",
"NIKI AGRO PRODUCTS PRIVATE LIMITED",
"NIKI INSULATION PRIVATE LIMITED",
"NIKI JEWELS PRIVATE LIMITED",
"NIKI RESORTS PRIVATE LIMITED",
"NIKIR HEALTHCARE PRIVATE LIMITED",
"NIKIS UTILITY SERVICES PRIVATE LIMITED",
"NIKISA HEALTHCARE SERVICES PRIVATE LIMITED",
"NIKISHA CHEMICAL PRIVATE LIMITED",
"NIKISU FAB PRIVATE LIMITED",
"NIKISU FINE CHEMICALS PRIVATE LIMITED",
"NIKIT CHEM ADHESIVES LIMITED",
"NIKIT SECLYFIN PRIVATE LIMITED",
"NIKITA AGRI PRODUCT PRIVATE LIMITED",
"NIKITA CONTAINERS PRIVATE LIMITED",
"NIKITA ENTERPRISES",
"NIKITA FABTEX PRIVATE LIMITED",
"NIKITA INDUSTRIES PRIVATE LIMITED",
"NIKITA JEWELLERY PRIVATE LIMITED",
"NIKITA MARKETING SERVICES PVT LTD",
"NIKITA META CHEM PRIVATE LIMITED",
"NIKITA METALLURGICALS PRIVATE LIMITED",
"NIKITA MOULDS PRIVATE LIMITED",
"NIKITA PLASTOCHEM PRIVATE LIMITED",
"NIKITA RESOURCES PVT LTD",
"NIKITA SYNTEX PRIVATE LIMITED",
"NIKITA TRANSPHASE ADDUCTS PVT LTD",
"NIKITA TRANSPORT & LOGISTICS PRIVATE LIMITED",
"NIKITASHA HOME APPLIANCES PRIVATE LIMITED",
"NIKITECH ELECTRIC PRIVATE LIMITED",
"NIKITHA BUILD-TECH PRIVATE LIMITED",
"NIKKA INSTRUMENTATION PRIVATE LIMITED",
"NIKKA MAL BABU RAM LUDHIANA WALA JEWELLERS PRIVATE LIMITED",
"NIKKA MAL BRIJ LAL JAIN SARAF PRIVATE LIMITED",
"NIKKAMAL JEWELLERSPRIVATE LIMITED.",
"NIKKAMAL JEWELS PRIVATE LIMITED",
"NIKKEI DENIM PRIVATE LIMITED",
"NIKKEI STOCKBROKERS PRIVATE LIMITED",
"NIKKI INDIA FUEL SYSTEMS PRIVATE LIMITED",
"NIKKI STEELS PRIVATE LIMITED",
"NIKKO AUTO LIMITED",
"NIKKO SYSTEMS PRIVATE LIMITED",
"NIKKO WIRES INDIA PRIVATE LIMITED",
"NIKKON FERRO PRIVATE LIMITED",
"NIKKON LIFESCIENCE PRIVATE LIMITED",
"NIKKON POLYTECH PRIVATE LIMITED",
"NIKKOU LOGISTICS PRIVATE LIMITED",
"NIKKOY MOTORS PRIVATE LIMITED",
"NIKKY OOH TECH PRIVATE LIMITED",
"NIKKYPORE FILTERATION SYSTEMS PRIVATE LIMITED",
"NIKKY'S MERCHANTS PRIVATE LIMITED",
"NIKNAM CHEMICALS PRIVATE LIMITED",
"NIKO MANAGEMENT SERVICES PRIVATE LIMITED",
"NIKO RESOURCES LIMITED",
"NIKOL ADVANCE MATERIALS PRIVATE LIMITED",
"NIKOLAI SOURCING",
"NIKOLE KOZMETICS PRIVATE LIMITED",
"NIKOM INFRASOLUTIONS PRIVATE LIMITED",
"NIKON AIR FREIGHT SERVICES PRIVATE LIMITED",
"NIKON ELECTRONICS PRIVATE LIMITED",
"NIKON ELEVATORS PRIVATE LIMITED",
"NIKON FINLEASE PRIVATE LIMITED",
"NIKON INDIA PRIVATE LIMITED",
"NIKON SYSTEMS PRIVATE LIMITED",
"NIKOO FORGE PVT LTD",
"NIKOPAS ENGINEERING PRIVATE LIMITED",
"NIKOS CONSULTING PRIVATE LIMITED",
"NIKRA MARKETING PRIVATE LIMITED",
"NIKS HAIR SALOON",
"NIKS TECHNOLOGY LIMITED",
"NIKSAR FINVEST PRIVATE LIMITED",
"NIKSEEM MINERALS PRIVATE LIMITED",
"NIKSHE MULTIPRODUCTS PRIVATE LIMITED",
"NIKSPERRI TECHNOLOGIES PRIVATE LIMITED",
"NIKSUN INDIA PRIVATE LIMITED",
"NIKUM ENERGY CONTROL INDIA LIMITED",
"NIKUNJ COMMODITIES PRIVATE LIMITED",
"NIKUNJ EXPORTS",
"NIKUNJ FINANCIAL SERVICES LIMITED",
"NIKUNJ HOSIERY PRIVATE LIMITED",
"NIKUNJ NETWEB SOLUTIONS PRIVATE LIMITED",
"NIKUNJ PROJECTS PRIVATE LIMITED",
"NIKUNJ STOCK BROKERS LIMITED",
"NIKUNJ SYNFAB PRIVATE LIMITED",
"NIKUNJ TEXTILES PRIVATE LIMITED",
"NIKUNJ WOODS PRIVATE LIMITED",
"NIKUNJAM CONSTRUCTIONS PRIVATE LIMITED",
"NIKVIN HEALTHCARE (INDIA) PRIVATE LIMITED",
"NIKY HOTELS PRIVATE LIMITED",
"NIKY PRECISION ENGINEERS PRIVATE LIMITED",
"NIL DHARA LIMITED",
"NIL KAMAL LIMITED",
"NIL LABS INNOVATION PRIVATE LIMITED",
"NILA APPS PRIVATE LIMITED",
"NILA BAKERS AND CONFECTIONERIES (INDIA) PRIVATE LIMITED",
"NILA HOSPITAL PRIVATE LIMITED",
"NILA INFRASTRUCTURES LIMITED.",
"NILA INNOVATIVES PRIVATE LIMITED",
"NILA METALS PRIVATE LIMITED",
"NILA SEA FOODS EXPORTS",
"NILA SEA FOODS PRIVATE LIMITED",
"NILA SPACES LIMITED",
"NILACHAKRA INDUSTRIES PRIVATE LIMITED",
"NILACHAL CARBO METALICKS LIMITED",
"NILACHAL CREDIT MANAGEMENT PRIVATE LIMITED",
"NILACHAL DISTRIBUTORS PRIVATE LIMITED",
"NILACHAL GREENTECH ENGINEERS PRIVATE LIMITED",
"NILACHAL ISPAT PVT LTD",
"NILACHAL PACKAGING PRIVATE LIMITED",
"NILACHAL PETROPRODUCTS PRIVATE LIMITED",
"NILACHAL REFRACTORIES LIMITED",
"NILACHAL SPINNING MILLS PRIVATE LIMITED",
"NILACHAL TRANSLOGISTICS PRIVATE LIMITED",
"NILACHALA ENERGY PRIVATE LIMITED",
"NILAMBARI FASHION PRIVATE LIMITED",
"NILAMBARI SAREES PRIVATE LIMITED",
"NILAMBER DYEING AND BLEACHING MILLS PRIVATE LIMITED",
"NILAMBER SECURITIES PRIVATE LIMITED",
"NILAMBER TOWER PRIVATE LIMITED",
"NILAMBUR BARTER PVT. LTD.",
"NILAMELS AND KAIMALS FOODS PRIVATE LIMITED",
"NILANCHAL POLY EXTRUSION PRIVATE LIMITED",
"NILANG ASPHALT EQUIPMENTS PRIVATE LIMITED",
"NILANG WIRES AND CABLES PRIVATE LIMITED",
"NILANJAN IRON PRIVATE LIMITED",
"NILAY ENTERPRISES PRIVATE LIMITED",
"NILAYA CHEMICALS PRIVATE LIMITED",
"NILAYA INFRA PRIVATE LIMITED",
"NILAYA LIFE AND SKILLS EDUCARES PRIVATE LIMITED",
"NILCHANDRA ENGINEERING PRIVATE LIMITED",
"NILE EXPRESS PRIVATE LIMITED",
"NILE GLOBAL INDIA PRIVATE LIMITED",
"NILE HOSPITALITY LLP",
"NILE LIMITED",
"NILE MIGRATION PRIVATE LIMITED",
"NILE TECHNOLOGIES PRIVATE LIMITED",
"NILES ENGINEERING WORKS PRIVATE LIMITED",
"NILESH ENGINEERING PRIVATE LIMITED",
"NILESH GAIKWAD GROUP PRIVATE LIMITED",
"NILESH GHANSHYAMBHAI GADHIYA",
"NILESH IMPEX INDIA PRIVATE LIMITED",
"NILESH SHARE BROKERS LIMITED",
"NILESH SUPER MARKET PRIVATE LIMITED",
"NILESH TEXTILES PRIVATE LIMITED",
"NILESH TRADERS PVT LTD",
"NILETECH INFRABUILD PRIVATE LIMITED",
"NILFISK INDIA PRIVATE LIMITED",
"NILGAI FOODS PRIVATE LIMITED",
"NILGIRI AGRO AGENCIES PRIVATE LIMITED",
"NILGIRI FOOD PRODUCTS PRIVATE LIMITED",
"NILGIRI GLENBURN TEA PRIVATE LIMITED",
"NILGIRI HERBS PRIVATE LIMITED",
"NILGIRI INFRASTRUCTURE DEVELOPMENT LIMITED",
"NILGIRI INFRASTRUCTURE LIMITED",
"NILGIRI INVESTMART SERVICES LIMITED",
"NILGIRI LAND DEVELOPMENT LIMITED",
"NILGIRI LAND HOLDINGS LIMITED",
"NILGIRI LANDS LIMITED",
"NILGIRI MONARCH TEA PRIVATE LIMITED",
"NILGIRI PLANTATIONS LTD",
"NILGIRI POWER PRIVATE LIMITED",
"NILGIRI SALES PROMOTION PVT LTD",
"NILGIRI TEXTILES PRIVATE LIMITED",
"NILGIRI TRADE-LINK PRIVATE LIMITED",
"NILGIRI VANIJYA PRIVATE LIMITED",
"NILGIRIS MECHANISED BAKERY PRIVATE. LIMITED",
"NILHAT PROMOTERS & FISCAL PVT LTD",
"NILIMA HERBS PRIVATE LIMITED",
"NILJA SHIPPING PRIVATE LIMITED",
"NILKAMAL BITO STORAGE PRIVATE LIMITED",
"NILKAMAL BITO STORAGE SYSTEMS PRIVATE LIMITED",
"NILKAMAL CONTROL SYSTEMS PRIVATE LIMITED",
"NILKAMAL LIMITED",
"NILKANTA HIMGHAR PVT LTD",
"NILKANTH CHAWAL MILLS PRIVATE LIMITED",
"NILKANTH CONCAST PRIVATE LIMITED",
"NILKANTH CONCRETE PRIVATE LIMITED",
"NILKANTH CONSTRUCTION PRIVATE LIMITED (OPC)",
"NILKANTH COTTON INDUSTRIES",
"NILKANTH CREATION",
"NILKANTH FERRO LIMITED",
"NILKANTH FOREX PRIVATE LIMITED",
"NILKANTH GLAZED PRIVATE LIMITED",
"NILKANTH HEALTH CHEM INDIA PRIVATE LIMITED",
"NILKANTH INFRAPROJECTS PRIVATE LIMITED",
"NILKANTH ORGANICS PRIVATE LIMITED",
"NILKANTH POLY PLAST PRIVATE LIMITED",
"NILKANTH RESORTS PRIVATE LIMITED",
"NILKANTH TECH PARK CONSTRUCTION PRIVATE LIMITED",
"NILLSAGAR DREAM PLANET PRIVATE LIMITED",
"NILMAC PACKAGING INDUSTRIES PRIVATE LIMITED",
"NILMANI PULSE PRODUCT PRIVATE LIMITED",
"NILOFAR ENGG PRIVATE LIMITED",
"NILON VALVES PRIVATE LIMITED",
"NILONS ENTERPRISES PRIVATE LIMITED",
"NILONS FOODS PRIVATE LIMITED",
"NILORN INDIA PRIVATE LIMITED",
"NILOUFER HOSPITAL",
"NILPAR INTERNATIONAL PRIVATE LIMITED",
"NILPETER INDIA PRIVATE LIMITED",
"NILRAJ ENGINEERING WORKS PRIVATE LIMITED",
"NILSAN NISHOTECH SYSTEM PRIVATE LIMITED",
"NILSAN PHARMACEUTICALS PRIVATE LIMITED",
"NILSAN PRIME INDIA PRIVATE LIMITED",
"NILUFER AESTHETICS PRIVATE LIMITED",
"NIM AGRO FOOD PRODUCTS PRIVATE LIMITED",
"NIM INFRA PRIVATE LIMITED",
"NIMA ENTERPRISES PRIVATE LIMITED",
"NIMAAI DAIRY FARM PRIVATE LIMITED",
"NIMAI DEVELOPERS PRIVATE LIMITED",
"NIMAI INFRATECH PRIVATE LIMITED",
"NIMAI INSTITUTE OF MEDICAL SCIENCES PRIVATE LIMITED",
"NIMAI TRADES PRIVATE LIMITED",
"NIMAL MAULA INDUSTRIES PRIVATE LIMITED",
"NIMANTRAN CLOTHING PRIVATE LIMITED",
"NIMANTRAN FOODS AND BEVERAGES PRIVATE LIMITED",
"NIMANTRAN HORTICULTURE PRIVATE LIMITED",
"NIMAP INFOTECH LLP",
"NIMAR MOTORS PRIVATE LIMITED",
"NIMATYA BUILD CON PRIVATE LIMITED",
"NIMAYATE CORPORATE SOLUTIONS PRIVATE LIMITED",
"NIMBA NATURE CARE & HOLISTIC HEALTH CARE CENTRE",
"NIMBA NATURE CURE",
"NIMBARK ENGINEERING PRIVATE LIMITED",
"NIMBARK FASHIONS LIMITED",
"NIMBARKA LOGISTICS PRIVATE LIMITED",
"NIMBEON INTER TECHNOLOGIES PRIVATE LIMITED",
"NIMBLE APPGENIE",
"NIMBLE ENTERPRISE PRIVATE LIMITED",
"NIMBLE SPORTS AND EVENTS PRIVATE LIMITED",
"NIMBLE TECHNOPLAST ELECTRICALS PRIVATE LIMITED",
"NIMBLE TOURS PRIVATE LIMITED",
"NIMBLE WIRELESS PRIVATE LIMITED",
"NIMBLEGROWTH CONSULTANCY SERVICES PRIVATE LIMITED",
"NIMBLEGROWTH ORGANICS PRODUCER COMPANY LIMITED",
"NIMBLEPACC PACKAGING PRIVATE LIMITED",
"NIMBLES BIOTECH PRIVATE LIMITED",
"NIMBRAJ MILK AND AGRO PRODUCTS PRIVATE LIMITED",
"NIMBUA GREENFIELD (PUNJAB) ASSOCIATION",
"NIMBUS ADCOM PRIVATE LIMITED",
"NIMBUS ADVENTURES PRIVATE LIMITED",
"NIMBUS ADVERTISING COMPANY PRIVATE LIMITED",
"NIMBUS BUILDWELL PRIVATE LIMITED",
"NIMBUS COMPUTER PRIVATE LIMITED",
"NIMBUS CONSULTING PRIVATE LIMITED",
"NIMBUS COOLING PRIVATE LIMITED",
"NIMBUS FOODS LIMITED",
"NIMBUS HARBOR FACILITIES MANAGEMENT PRIVATE LIMITED",
"NIMBUS INDIA LIMITED",
"NIMBUS INFRA SERVICES PRIVATE LIMITED",
"NIMBUS IRRIGATION PVT. LTD.",
"NIMBUS MARINE SERVICES PRIVATE LIMITED",
"NIMBUS MOTORS PRIVATE LIMITED",
"NIMBUS PACKAGING LLP",
"NIMBUS PROJECTS LIMITED",
"NIMBUS PROPERTIES PRIVATE LIMITED",
"NIMBUS SYSTEMS PRIVATE LIMITED",
"NIMBUS TECHCRAFT PRIVATE LIMITED",
"NIMBUSONE IT SERVICES PRIVATE LIMITED",
"NIMBUSPOST PRIVATE LIMITED",
"NIMCO PRECAST PRIVATE LIMITED",
"NIMEESHA INFRATECH PRIVATE LIMITED",
"NIMEHER E&E PRIVATE LIMITED",
"NIMESH ENERGY SOLUTIONS PRIVATE LIMITED",
"NIMEX INTERNATIONAL PRIVATE LIMITED",
"NIMI CONSTRUCTIONS PRIVATE LIMITED",
"NIMI DEVELOPERS PRIVATE LIMITED",
"NIMISH SYNTEX NS",
"NIMIT BUILDERS PRIVATE LIMITED",
"NIMIT ELECTRONICS PRIVATE LIMITED",
"NIMIT FINANCE PVT LTD",
"NIMIT TECHNOLOGIES PRIVATE LIMITED",
"NIMITAYA INFOTECH PRIVATE LIMITED.",
"NIMITAYA INFRASTRUCTURE PRIVATE LIMITED.",
"NIMKARTEK TECHNICAL SERVICES PRIVATE LIMITED",
"NIMLA ORGANICS PRIVATE LIMITED",
"NIMMA NARAYAN ENGINEERS & CONTRACTORS",
"NIMMADHI COIR MATRESSES PRIVATE LIMITED",
"NIMMI BUILD TECH PRIVATE LIMITED",
"NIMMIT PHARMACEUTICALS PRIVATE LIMITED",
"NIMMS HOSPITAL",
"NIMO FASHIONS PRIVATE LIMITED",
"NIMOCULE PHARMACEUTICALS PRIVATE LIMITED",
"NIMOTHERM ENGINEERING PRIVATE LIMITED",
"NIMOTO SOLAR PRIVATE LIMITED",
"NIMP HEALTHCARE PRIVATE LIMITED",
"NIMPAA TELECOMMUNICATIONS PRIVATE LIMITED",
"NIMPRA EQUIPMENTS PRIVATE LIMITED",
"NIMRIWALA TRADE & COMMERCE PVT.LTD.",
"NIMS HOSPITAL",
"NIMS UNIVERSITY",
"NIMSHA INDUSTRIES PRIVATE LIMITED",
"NINA AGROTECH PRIVATE LIMITED",
"NINA CONCRETE SYSTEMS PRIVATE LIMITED",
"NINA MOTORS PRIVATE LIMITED",
"NINA PERCEPT PRIVATE LIMITED",
"NINA WATERPROOFING",
"NINA WATERPROOFING SYSTEMS PRIVATE LIMITED",
"NINAAD FINANCE AND PROPERTIES PRIVATE LIMITED",
"NINAD AGRO PLAST PRIVATE LIMITED",
"NINAI AGRO BIOTECH PRIVATE LIMITED",
"NINE 2 FIVE STAYS PRIVATE LIMITED",
"NINE A BUSINESS CONNECT PRIVATE LIMITED",
"NINE BEARINGS (INDIA) PRIVATE LIMITED",
"NINE CAFFE 9 HOSPITALITY SERVICES PRIVATE LIMITED",
"NINE CORPORATE TRADE PRIVATE LIMITED",
"NINE DIMENSIONS INFOTECH PRIVATE LIMITED",
"NINE HERTZ INDIA PRIVATE LIMITED",
"NINE HILLS EDUCATION PRIVATE LIMITED",
"NINE INTERNATIONAL SECURITIES PRIVATE LIMITED",
"NINE JEWELS PRIVATE LIMITED",
"NINE LABS PRIVATE LIMITED",
"NINE POWER INFRA PRIVATE LIMITED",
"NINE PROJECTS PRIVATE LIMITED",
"NINE REALCON INFRA PRIVATE LIMITED",
"NINE RED PRIVATE LIMITED",
"NINE RIVERS CAPITAL HOLDINGS PRIVATE LIMITED",
"NINE SQUARE PRINTS (INDIA) PRIVATE LIMITED",
"NINE SQUARE PRINTS INDIA PRIVATE LIMITED",
"NINE STAR BROKING PRIVATE LIMITED",
"NINE STAR NOVELTIES PRIVATE LIMITED",
"NINE T NINE AUTOMOTIVES PRIVATE LIMITED",
"NINE TRIANGLES DIGITAL PRIVATE LIMITED",
"NINE TWO NINE FOREX PRIVATE LIMITED",
"NINE UNITED TRADING PRIVATE LIMITED",
"NINEBALLS SPORTS & ENTERTAINMENT PRIVATE LIMITED",
"NINEDOTS CORPORATE TRAINING SOLUTIONS PRIVATE LIMITED",
"NINEGRAPES INTEGRATED SERVICES PRIVATE LIMITED",
"NINEK NANOTECH PRIVATE LIMITED",
"NINELEAPS TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"NINEPLAST INDUSTRIES PRIVATE LIMITED",
"NINESEC INTEGRATION PRIVATE LIMITED",
"NINESKY TECHNOLOGY AND INDUSTRIAL PRIVATE LIMITED",
"NINESTAR MOTORCYCLES BANGALORE PRIVATE LIMITED",
"NINESTEPS (INDIA) PRIVATE LIMITED",
"NINETECH INFRA SOLUTIONS PRIVATE LIMITED",
"NINETY DEGREE STONE PRIVATE LIMITED",
"NINETY DEGREES CONSTRUCTION PRIVATE LIMITED",
"NINETY NINE BUILDERS PRIVATE LIMITED",
"NINETY NINE GENERAL RETAIL PRIVATE LIMITED",
"NINETY NINE ORANGES TECHNOLOGIES PRIVATE LIMITED",
"NINETY NINE TRAVELS PRIVATE LIMITED",
"NINETYDEGREENORTH TECHNOLOGIES PRIVATE LIMITED",
"NINE-WEST INFOTECH PRIVATE LIMITED",
"NINEX BUILDCON PRIVATE LIMITED",
"NINEX WAREHOUSING PRIVATE LIMITED",
"NINJA CONSTRUCTIONS PRIVATE LIMITED",
"NINJA METALS PRIVATE LIMITED",
"NINJA SECURITIES PRIVATE LIMITED",
"NINJA TECHNOLABS",
"NINJAAI SOFTWARE PRIVATE LIMITED",
"NINJAAS LABS PRIVATE LIMITED",
"NINJACART SERVICES PRIVATE LIMITED",
"NINNIKU EXPORTS PVT LTD",
"NINO FOODS PRIVATE LIMITED",
"NINOBI AGRO CROPS PRIVATE LIMITED",
"NINTEC BUSINESS CONSULTING LLP",
"NINTEC SYSTEMS LIMITED",
"NINTH AVENUE INDUSTRIES PRIVATE LIMITED",
"NINTH DIMENSION HOTELS & RESORTS P LIMITED",
"NINTH DIMENSION IT SOLUTIONS PRIVATE LIMITED",
"NINTON TECHNOLOGIES PRIVATE LIMITED",
"NINU MEDIA PRIVATE LIMITED",
"NIOBE BUILDERS & DEVELOPERS PRIVATE LIMITED",
"NIOMODA CLOTHING PRIVATE LIMITED",
"NIORN SYSTEMS AND SERVICES PRIVATE LIMITED",
"NIP POWER PRIVATE LIMITED",
"NIPA INTERNATIONAL PRIVATE LIMITED",
"NIPANE INDUSTRY PRIVATE LIMITED",
"NIPANI INDUSTRIES",
"NIPB INDUSTRIAL BRUSHES INDIA PRIVATE LIMITED",
"NIPHA EXPORTS P LIMITED",
"NIPHA INDIA PVT. LTD.",
"NIPHA STEELS LTD",
"NIPMAN FASTENER INDUSTRIES PRIVATE. LIMITED",
"NIPON AGRO PRIVATE LIMITED",
"NIPON ZIP INDUSTRY PRIVATE LIMITED",
"NIPPAI SHALIMAR FEEDS PRIVATE LIMITED",
"NIPPO INDIA PRIVATE LIMITED",
"NIPPON CARBIDE INDIA PRIVATE LIMITED",
"NIPPON CRYO PRIVATE LIMITED",
"NIPPON DATA SYSTEMS LIMITED",
"NIPPON DISTRIBUTORS PRIVATE LIMITED",
"NIPPON EXPRESS (INDIA) PRIVATE LIMITED",
"NIPPON INSTRUMENTS (INDIA) PRIVATE LIMITED",
"NIPPON KOEI INDIA PRIVATE LIMITED",
"NIPPON KONPO INDIA PRIVATE LIMITED",
"NIPPON LEAKLESS TALBROS PRIVATE LIMITED",
"NIPPON LIFE INDIA AIF MANAGEMENT LIMITED",
"NIPPON LIFE INDIA ASSET MANAGEMENT LIMITED",
"NIPPON LIFE INDIA TRUSTEE LIMITED",
"NIPPON MOTOR CORPORATION PRIVATE LIMITED",
"NIPPON OIL PUMP INDIA PRIVATE LIMITED",
"NIPPON PAINT (INDIA) PRIVATE LIMITED",
"NIPPON PAPER FOODPAC PRIVATE LIMITED",
"NIPPON PIPES PRIVATE LIMITED",
"NIPPON POLYMERS PRIVATE LIMITED",
"NIPPON POWER LTD",
"NIPPON Q1 PROJECTS PRIVATE LIMITED",
"NIPPON SEIKO K.K.",
"NIPPON SIGNAGE INDIA PRIVATE LIMITED",
"NIPPON SIGNAL CO.LIMITED",
"NIPPON SIGNAL INDIA PRIVATE LIMITED",
"NIPPON STEEL AND SUMIKIN ENGINEERING INDIA PRIVATE LIMITED",
"NIPPON STEEL CHEMICAL & MATERIAL INDIA PRIVATE LIMITED",
"NIPPON STEEL ENGINEERING INDIA PRIVATE LIMITED",
"NIPPON STEEL INDIA PRIVATE LIMITED",
"NIPPON STEEL PIPE INDIA PRIVATE LIMITED",
"NIPPON STEEL TRADING INDIA PRIVATE LIMITED",
"NIPPON THERMOSTAT INDIA LIMITED",
"NIPPON TOWERS AND ESTATES KERALA PRIVATE LIMITED",
"NIPPON TUBES LIMITED",
"NIPRA FABRICS PRIVATE LIMITED",
"NIPRA GREEN TECHNOLOGIES PRIVATE LIMITED",
"NIPRA INDUSTRIES PRIVATE LIMITED",
"NIPRA TRADING PRIVATE LIMITED",
"NIPRO INDIA CORPORATION PRIVATE LIMITED",
"NIPRO MEDICAL INDIA PRIVATE LIMITED",
"NIPRO PHARMAPACKAGING INDIA PRIVATE LIMITED",
"NIPRO TECHNOLOGIES LIMITED",
"NIPRO TREXIM PVT. LTD",
"NIPS SERVICES PRIVATE LIMITED",
"NIPSO POLYFABRICS LTD",
"NIPUN AGRO ENGINEERING PRIVATE LIMITED",
"NIPUN BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"NIPUN INSURANCE BROKERS PRIVATE LIMITED",
"NIPUN NET SOLUTIONS PRIVATE LIMITED",
"NIPUN SANYANTRA PRIVATE LIMITED",
"NIPUN STEELS PRIVATE LIMITED",
"NIPUN TECHNOWEAVE PRIVATE LIMITED",
"NIPUN-IT SOLUTIONS PRIVATE LIMITED",
"NIPUR CHEMICALS LIMITED",
"NIPURN ENGINEERING PVT LTD",
"NIQX INFORMATICS AND ANALYSIS PRIVATE LIMITED",
"NIR NAR AQUA PRIVATE LIMITED",
"NIRA LIFE SCIENCES PRIVATE LIMITED",
"NIRA VALLEY GRAPE WINES PRIVATE LIMITED",
"NIRAAG INDIA PRIVATE LIMITED",
"NIRAAMAYA ARADURA RETREATS PRIVATE LIMITED",
"NIRAAMAYA RETREATS KOVALAM PRIVATE LIMITED",
"NIRAAMAYA RETREATS KUMARKOM PRIVATE LIMITED",
"NIRAHUA ENTERTAINMENT PRIVATE LIMITED",
"NIRAJ AGRO PRODUCTS PRIVATE LIMITED",
"NIRAJ CARGO MOVERS PRIVATE LIMITED",
"NIRAJ CEMENT STRUCTURALS LIMITED",
"NIRAJ EDUCATIONAL SOCIETY",
"NIRAJ ENGINEERING COMPANY PVT LTD",
"NIRAJ EQUIPMENTS PRIVATE LIMITED",
"NIRAJ FABRICS (INDIA) PRIVATE LIMITED",
"NIRAJ INDUSTRIES PRIVATE LIMITED",
"NIRAJ INTENSIVE AND ANESTHESIA CARE PRIVATE LIMITED",
"NIRAJ ISPAT INDUSTRIES LIMITED",
"NIRAJ KUMAR ASSOCIATES PRIVATE LIMITED",
"NIRAJ METAL AND ALLOYS PRIVATE LIMITED",
"NIRAJ PUBLIC SCHOOL",
"NIRAJ TECHNOCOM PRIVATE LIMITED",
"NIRAJ THERMOCOLS AND ELECTRICALS PRIVATE LIMITED",
"NIRAJAGRO BIO ENERGY FARMER PRODUCER COMPANY LIMITED",
"NIRAKAR ENGINEERING PRIVATE LIMITED",
"NIRAKAR SECURITY & CONSULTANCY SERVICES PRIVATE LIMITED",
"NIRALA HOUSING PRIVATE LIMITED",
"NIRALA INFRATECH PRIVATE LIMITED",
"NIRALA PROJECTS PRIVATE LIMITED",
"NIRALI ABHINANDAN INDUSTRIES PRIVATE LIMITED",
"NIRALI MEMORIAL MEDICAL TRUST",
"NIRALI PRAKASHAN",
"NIRAMAI HEALTH ANALYTIX PRIVATE LIMITED",
"NIRAMAYA HOLISTIC HEALTH SERVICES PRIVATE LIMITED",
"NIRAMAYA HOSPITALS PRIVATE LIMITED",
"NIRAMAYA PATHLABS PRIVATE LIMITED",
"NIRAN MOTORS PRIVATE LIMITED",
"NIRANI SUGARS LIMITED.",
"NIRANJAN AGARWAL HYPERMARKET PRIVATE LIMITED",
"NIRANJAN AUTO COMPONENTS PRIVATE LIMITED",
"NIRANJAN HOUSING PRIVATE LIMITED",
"NIRANJAN METALLIC LIMITED",
"NIRANJAN PAINTS PRIVATE LIMITED",
"NIRANJAN PLYWOOD PRIVATE LIMITED",
"NIRANJAN RAI",
"NIRANJANA COTEX PRIVATE LIMITED",
"NIRANJANA PROPERTIES PRIVATE LIMITED",
"NIRANJANA SOLAR ENERGY PRIVATE LIMITED",
"NIRANKAR INFRASTRUCTURE PRIVATE LIMITED",
"NIRANKARI ELECTROCHEM PRIVATE LIMITED",
"NIRANKARI GEMS & JEWELS PRIVATE LIMITED",
"NIRANKARI JEWELS PRIVATE LIMITED",
"NIRANKARI SONS JEWELLERS PRIVATE LIMITED",
"NIRANTA SOLUTIONS AND SERVICES PRIVATE LIMITED",
"NIRANTARA FINACCESS PRIVATE LIMITED",
"NIRANTHARA INFRA PRIVATE LIMITED",
"NIRASYS INFOTECH INDIA PRIVATE LIMITED",
"NIRAV BIOSOLUTIONS PRIVATE LIMITED",
"NIRAV COMMERCIALS LIMITED",
"NIRAV COTTON PRIVATE LIMITED",
"NIRAV DYES AND CHEMICALS PRIVATE LIMITED",
"NIRAV ENTERPRISES PRIVATE LIMITED",
"NIRAV GEMS",
"NIRAV MERCANTILE PRIVATE LIMITED",
"NIRAV METALS PRIVATE LIMITED",
"NIRAV SILK MILLS PRIVATE LIMITED",
"NIRAVATHJUBILY CHITS INDIA PRIVATE LIMITED",
"NIRAVU FARMERS PRODUCER COMPANY LIMITED",
"NIRAWIN AGRI SEEDS PRIVATE LIMITED",
"NIRAYU LIMITED",
"NIRBAN INDUSTRIAL COMPONENTS PRIVATE LIMITED",
"NIRBAN INFRASTRUCTURE PRIVATE LIMITED",
"NIRBHAI ROADWAYS PVT LTD",
"NIRBHAY KNITTING INDUSTRIES PVT LTD",
"NIRBHAY MULTITRADE PRIVATE LIMITED",
"NIRBHAY ORGANICS PRIVATE LIMITED",
"NIRBHAY RASAYAN PRIVATE LIMITED",
"NIRCHEM DYES & CHEMICALS PRIVATE LIMITED",
"NIRDESA NETWORKS PRIVATE LIMITED",
"NIRDHAN DEVELOPMENT & MICROFINANCE",
"NIREEKSHAN ENGINEERING SERVICES PRIVATE LIMITED",
"NIRGANDH PRIVATE LIMITED",
"NIRGUNA TRADING PRIVATE LIMITED",
"NIRHAN INDIA PRIVATE LIMITED",
"NIRIHUMS TECH PRIVATE LIMITED",
"NIRISH IMPEX PRIVATE LIMITED",
"NIRJA PETRO COAL PRIVATE LIMITED",
"NIRJARA SOLAIRE URJA PRIVATE LIMITED",
"NIRJAY IMPEX PRIVATE LIMITED",
"NIRJHAR FINANCIAL ADVISORY PRIVATE LIMITED",
"NIRJHAR PROJECTS (OPC) PRIVATE LIMITED",
"NIRLEP APPLIANCES PRIVATE LIMITED",
"NIRLON KITCHENWARE PRIVATE LIMITED",
"NIRLON MANAGEMENT SERVICES PRIVATE LIMITED",
"NIRLON STEEL PRIVATE LIMITED",
"NIRMA CHEMICAL WORKS PRIVATE LIMITED",
"NIRMA CREDIT AND CAPITAL PRIVATE LIMITED",
"NIRMA INDUSTRIES PRIVATE LIMITED",
"NIRMA INSTITUTE OF DIPLOMA STUDIES",
"NIRMA INSTITUTE OF MANAGEMENT",
"NIRMA INSTITUTE OF PHARMACY",
"NIRMA LIMITED",
"NIRMA UNIVERSITY",
"NIRMA VIDYAVIHAR",
"NIRMAAN GROUP",
"NIRMAAN INTERIORS PROJECTS PRIVATE LIMITED",
"NIRMAAN POLYCHEM PRIVATE LIMITED",
"NIRMAL AGRI PRODUCTS PRIVATE LIMITED",
"NIRMAL ALUMINIUM INDUSTRIES LIMITED",
"NIRMAL AQUASOL PRIVATE LIMITED",
"NIRMAL ARCHITECTURE PRIVATE LIMITED",
"NIRMAL AUTO TECH INDUSTRIES PRIVATE LIMITED",
"NIRMAL AUTOMATION PRIVATE LIMITED",
"NIRMAL BAKERY PRIVATE LIMITED",
"NIRMAL BANG COMMODITIES PRIVATE LIMITED",
"NIRMAL BANG EQUITIES PRIVATE LIMITED",
"NIRMAL BANG FINANCIAL SERVICE PRIVATE LIMITED",
"NIRMAL BANG INSURANCE BROKING PRIVATE LIMITED",
"NIRMAL BANG SECURITIES PRIVATE LIMITED",
"NIRMAL BHARTIA SCHOOL",
"NIRMAL BOT PRIVATE LIMITED",
"NIRMAL BUILDINFRA PRIVATE LIMITED",
"NIRMAL BUILDTECH INDIA PRIVATE LIMITED",
"NIRMAL CHEM-PLAST PRIVATE LIMITED",
"NIRMAL COTTON PRIVATE LIMITED",
"NIRMAL DARSHAN CHARITABLE TRUST JAWAHAR JYOTI",
"NIRMAL DATACOMM PRIVATE LIMITED",
"NIRMAL DESIGNS PRIVATE LIMITED",
"NIRMAL ENERGY LIMITED",
"NIRMAL ENVIRO SOLUTIONS PRIVATE LIMITED",
"NIRMAL EPM SERVICES LLP",
"NIRMAL EQUIPMENTS PRIVATE LIMITED",
"NIRMAL EXIM PRIVATE LIMITED",
"NIRMAL FABRICATION AND ERECTION PRIVATE LIMITED",
"NIRMAL FIBRES PRIVATE LIMITED",
"NIRMAL HANDLOOM HOUSE PRIVATE LIMITED",
"NIRMAL HOSPITAL PRIVATE LIMITED",
"NIRMAL INDUSTRIAL CONTROLS PRIVATE LIMITED",
"NIRMAL INDUSTRIES",
"NIRMAL INDUSTRIES PRIVATE LIMITED",
"NIRMAL INFO PARK (INDIA) LIMITED",
"NIRMAL INFOLINE PRIVATE LIMITED",
"NIRMAL INTELLIGENCE AND SECURITY SERVICES PRIVATE LIMITED",
"NIRMAL KRIDA AND SAMAJ PRABHODHAN TRUST ARTS, SCIENCE AND COMMERCE COLLEGE",
"NIRMAL MARBLE LIMITED",
"NIRMAL MULTI PRODUCTS PRIVATE LIMITED",
"NIRMAL OFFSET PRIVATE LIMITED",
"NIRMAL OVERSEAS PRIVATE LIMITED",
"NIRMAL PACKAGING SYSTEMS PRIVATE LIMITED",
"NIRMAL POLY PLAST PRIVATE LIMITED",
"NIRMAL POLYFAB PVT LTD",
"NIRMAL POLYMERS PRIVATE LIMITED",
"NIRMAL POLYTHREAD INDUSTRIES PRIVATE LIMITED",
"NIRMAL POWERS",
"NIRMAL PUMPS PRIVATE LIMITED",
"NIRMAL RECRUITMENT SERVICES PRIVATE LIMITED",
"NIRMAL SAI SYSTEMS SOLUTIONS PRIVATE LIMITED",
"NIRMAL SEEDS PRIVATE LIMITED",
"NIRMAL SHELTERS PRIVATE LIMITED",
"NIRMAL SPINNING MILLS PRIVATE LIMITED",
"NIRMAL STAPLE FOODS PRIVATE LIMITED",
"NIRMAL STICKERS AND LABELS PRIVATE LIMITED",
"NIRMAL STORE PRIVATE LIMITED",
"NIRMAL STORES",
"NIRMAL SUPERMARKETS PRIVATE LIMITED",
"NIRMAL TEX PRINT PRIVATE LIMITED",
"NIRMAL TEXIM PRIVATE LIMITED",
"NIRMAL TEXTILES PRIVATE LIMITED",
"NIRMAL TRANS BELTS PRIVATE LIMITED",
"NIRMAL UTILITY SERVICES PRIVATE LIMITED",
"NIRMAL VASUNDHARA PRIVATE LIMITED",
"NIRMAL VIDHYALAY U MADHYAMIK SHALA",
"NIRMAL WIRES PRIVATE. LIMITED.",
"NIRMALA AUTOMOBILES PRIVATE LIMITED",
"NIRMALA BUILDWELL PRIVATE LIMITED",
"NIRMALA COLLEGE FOR WOMEN - 641018",
"NIRMALA COLLEGE RANCHI",
"NIRMALA CONVENNT SCHOOL",
"NIRMALA DEVI NURSING PRIVATE LIMITED",
"NIRMALA ENGLISH MEDIUM SCHOOL",
"NIRMALA FILAMENTS INDIA PRIVATE LIMITED",
"NIRMALA GARMENTS PRIVATE LIMITED",
"NIRMALA GOENKA ESTATES PRIVATE LIMITED",
"NIRMALA HOSPITAL",
"NIRMALA INFRA PROJECTS INDIA PRIVATE LIMITED",
"NIRMALA INFRADEVELOPERS LIMITED",
"NIRMALA INSTITUTE OF EDUCATION",
"NIRMALA INSTITUTE OF TECHNOLOGY",
"NIRMALA MATHA CONVENT SCHOOL ICSE/ISC",
"NIRMALA MATRICULATION HIGHER SECONDARY SCHOOL",
"NIRMALA MEMORIAL FOUNDATION JUNIOR COLLEGE OF COMMERCE AND SCIENCE",
"NIRMALA MONOFIL PRIVATE LIMITED",
"NIRMALA NIKETAN",
"NIRMALA POLYROPES INDIA PRIVATE LIMITED",
"NIRMALA REALINFRASTRUCTURE PRIVATE LIMITED",
"NIRMALA RICE PRIVATE LIMITED",
"NIRMALA ROTOPLAST PRIVATE LIMITED",
"NIRMALA SHEETGRAH PRIVATE LIMITED",
"NIRMALANAND BUILDCON PRIVATE LIMITED",
"NIRMALSON FOREX PRIVATE LIMITED",
"NIRMALSONS DISTRIBUTORS PRIVATE LIMITED",
"NIRMALYA LABS PRIVATE LIMITED",
"NIRMALYAM VEG CUISINE PRIVATE LIMITED",
"NIRMAN ADVERTISING PRIVATE LIMITED",
"NIRMAN AGRI GENETICS LIMITED",
"NIRMAN CONCRETE PRIVATE LIMITED",
"NIRMAN CONSULTANTS PRIVATE LIMITED",
"NIRMAN ELECTRONICS PRIVATE LIMITED",
"NIRMAN ENGICONS PRIVATE LIMITED",
"NIRMAN ENGINEERING COSULTANTS PVT LTD",
"NIRMAN ENTERPRISES",
"NIRMAN FABRICATORS AND ENGINEERS PRIVATE LIMITED",
"NIRMAN FERTILIZERS PRIVATE LIMITED",
"NIRMAN FINCAP PRIVATE LIMITED",
"NIRMAN HIGH SCHOOL",
"NIRMAN HITECH DIAGNOSTIC CENTRE PRIVATE LIMITED",
"NIRMAN HOTELS PRIVATE LIMITED",
"NIRMAN IMPRESSE PRIVATE LIMITED",
"NIRMAN INDIA CONSTRUCTIONS PRIVATE LIMITED",
"NIRMAN INFRA-STEEL PRIVATE LIMITED",
"NIRMAN MULTIARTS PRIVATE LIMITED",
"NIRMAN ORTHOPAEDICS PRIVATE LIMITED",
"NIRMAN SERVICES PRIVATE LIMITED",
"NIRMAN SHARE BROKERS PRIVATE LIMITED",
"NIRMAN SHELTERS BANGALOREPRIVATE LIMITED",
"NIRMAN TMT STEEL PRIVATE LIMITED",
"NIRMAN TRANSFORMERS PRIVATE LIMITED",
"NIRMANGHAR TRADERS PRIVATE LIMITED",
"NIRMANVRIDHI CONSTRUCTIONS PRIVATE LIMITED",
"NIRMATA ENGINEERING CONSTRUCTION CO PRIVATE LIMITED",
"NIRMAYAK BUILDERS PRIVATE LIMITED",
"NIRMAYMED PHARMA PRIVATE LIMITED",
"NIRMESH ENTERPRISES PRIVATE LIMITED",
"NIRMIITA VIGOR PRIVATE LIMITED",
"NIRMIT CIVILTECH PRIVATE LIMITED",
"NIRMIT EDUSOL PRIVATE LIMITED",
"NIRMIT POLYMER PRIVATE LIMITED",
"NIRMIT TELE INFRA PRIVATE LIMITED",
"NIRMITEE CONSTRUCTION AND PROJECT MANAGEMENT¬†CONSULTANTS",
"NIRMITEE ELECTRICAL COMPANY INDIA PRIVATE LIMITED",
"NIRMITEE ELECTRICAL SERVICES PRIVATE LIMITED",
"NIRMITEE INTERIORS PVT LTD",
"NIRMITEE MACHINES PRIVATE LIMITED",
"NIRMITEE ROBOTICS INDIA LIMITED",
"NIRMITI DESIGN ENGINEERS PRIVATE LIMITED",
"NIRMITI DEVELOPERS PRIVATE LIMITED",
"NIRMITI PRECISION PRIVATE LIMITED",
"NIRMOHA FASHION HOUSE PRIVATE LIMITED",
"NIRNAYA SYSTEM AND SOLUTIONS PRIVATE LIMITED",
"NIRNAYAN HEALTH CARE PRIVATE LIMITED",
"NIRNIDHI MARKETING PRIVATE LIMITED",
"NIRNIDHI VYAPAAR PVT LTD",
"NIRNOY HOSPITAL PRIVATE LIMITED",
"NIRO CERAMIC INDIA PRIVATE LIMITED",
"NIROG HOSPITALS AND RESEARCH CENTRE PRIVATE LIMITED",
"NIROGAM INDIA PRIVATE LIMITED",
"NIRON HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED",
"NIROS ISPAT PRIVATE LIMITED",
"NIROSHA BUSINESS SPECIALITIES LIMITED",
"NIROSHA DEALCOM PRIVATE LIMITED",
"NIROSHA MOTOR PRIVATE LIMITED",
"NIROSHA POWER PRIVATE LIMITED",
"NIROTECH INDUSTRIES PRIVATE LIMITED",
"NIRPAN SECURITIES PRIVATE LIMITED",
"NIRPURIA VENTURES PRIVATE LIMITED",
"NIRSAN HEALTH PRIVATE LIMITED",
"NIRSHILP COMMODITIES AND TRADING PRIVATE LIMITED",
"NIRTECH PRIVATE LIMITED",
"NIRULAS STARLIGHT IMPEX PRIVATE LIMITED",
"NIRUPAM ENGINEERS PRIVATE LIMITED",
"NIRUPAMA COLD STORAGE PRIVATE LIMITED",
"NIRUPAMA MINING AND TRANSPORTING PRIVATE LIMITED",
"NIRUPAMA VENTURES PRIVATE LIMITED",
"NIRUPOMA MEDICURE INDIA PRIVATE LIMITED",
"NIRUTHI CLIMATE & ECOSYSTEMS PRIVATE LIMITED",
"NIRVA PIGMENTS PRIVATE LIMITED",
"NIRVAA SOLUTIONS PRIVATE LIMITED",
"NIRVAAN CAREER INSTITUTE",
"NIRVAAN DESIGN PRIVATE LIMITED.",
"NIRVAAN HOMES PRIVATE LIMITED",
"NIRVAAN INFRACOM PRIVATE LIMITED",
"NIRVAANIC LIFE FOODS PRIVATE LIMITED",
"NIRVAANRAJ ENERGY PRIVATE LIMITED",
"NIRVAN AGRO PACKAGING PRIVATE LIMITED",
"NIRVAN PHARMACEUTICALS PRIVATE LIMITED",
"NIRVAN SILK MILLS PRIVATE LIMITED",
"NIRVANA DIGITAL STUDIOS PRIVATE LIMITED",
"NIRVANA HAMMOCKS PRIVATE LIMITED",
"NIRVANA HIMALAYAN RETREAT PRIVATE LIMITED",
"NIRVANA HOLDINGS PRIVATE LIMITED",
"NIRVANA INDIA PRIVATE LIMITED",
"NIRVANA INFRACON PRIVATE LIMITED",
"NIRVANA LANDSCAPES PRIVATE LIMITED",
"NIRVANA LIGHTING PRIVATE LIMITED",
"NIRVANA NEST BUILDCON PRIVATE LIMITED",
"NIRVANA NICHE PRODUCTS PRIVATE LIMITED",
"NIRVANA OPENACCESS SOLUTIONS PRIVATE LIMITED",
"NIRVANA PRIVATE LIMITED",
"NIRVANA RECYCLING PRIVATE LIMITED",
"NIRVANA SOLUTIONS INDIA PRIVATE LIMITED",
"NIRVANA VENTURE ADVISORS PRIVATE LIMITED",
"NIRVASA HEALTHCARE PRIVATE LIMITED",
"NIRVATA INFRA PRIVATE LIMITED",
"NIRVIGHNA IMPEX PRIVATE LIMITED",
"NIRVIGHNAM HEALTHCARE & RESEARCH CENTRE PRIVATE LIMITED",
"NIRVIN COLD STORAGE PVT LTD",
"NIRVIP PRIVATE LIMITED",
"NIRVITTA PHARMACEUTICALS PRIVATE LIMITED",
"NIRVVAN LIFESCIENCE PRIVATE LIMITED",
"NIRWAN INTERNATIONAL PRIVATE LIMITED",
"NIRWANA HOTELS AND RESORTS PRIVATE LIMITED",
"NIRYAT SAM APPARELS INDIA LIMITED",
"NIRYATH LOGISTICS PRIVATE LIMITED",
"NIS FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"NIS MANAGEMENT LIMITED",
"NIS MANAGEMENT PRIVATE LIMITED",
"NIS MARKETING PRIVATE LIMITED",
"NIS SPARTA",
"NISA INDUSTRIAL SERVICES PRIVATE LIMITED",
"NISAGRA RENEWABLE ENERGY PRIVATE LIMITED",
"NISAN CLOTHSMITH LLP",
"NISAN ELECTRICALS INDIA PRIVATE LIMITED",
"NISAN SCIENTIFIC PROCESS EQUIPMENTS PVT LTD",
"NISANTA AUTOMOBILE PRIVATE LIMITED",
"NISAR PROPERTIES PRIVATE LIMITED",
"NISARG APPLIANCES PRIVATE LIMITED",
"NISARG BIOSCIENCES PRIVATE LIMITED",
"NISARG ENGINEERING PRIVATE LIMITED",
"NISARG GOLD INFOTECH PRIVATE LIMITED",
"NISARG ISPAT PRIVATE LIMITED",
"NISARG JEWELS PRIVATE LIMITED",
"NISARG POLYMERS PRIVATE LIMITED",
"NISARG REALTORS PRIVATE LIMITED",
"NISARG TEXTILES PRIVATE LIMITED",
"NISARG VIKAS PRODUCER COMPANY LIMITED",
"NISARGA BLISS PRIVATE LIMITED",
"NISARGA CROP CARE INDIA PRIVATE LIMITED",
"NISARGA DHAMA ESTATES PRIVATE LIMITED",
"NISARGA FRESH PROCESSING PRIVATE LIMITED",
"NISARGA HEALTHCARE PRIVATE LIMITED",
"NISARGA HOSPITALITY PRIVATE LIMITED",
"NISARGA INFORMATION TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"NISARGA PRODUCTION AND MEDIA SERVICES PRIVATE LIMITED",
"NISARGALAYA DRUG UNIT PRIVATE LIMITED",
"NISC EXPORT SERVICES PRIVATE LIMTED",
"NISCHAL ENGINEERING COMPANY PRIVATE LIMITED",
"NISCHAL'S SMART LEARNING SOLUTIONS PRIVATE LIMITED",
"NISCHAY CORPORATION PRIVATE LIMITED",
"NISCHAY HOUSING PRIVATE LIMITED",
"NISCHAY IMPEX PVT.LTD.",
"NISCHAY INFOTECH PRIVATE LIMITED",
"NISCHAYA COMMERCIAL PRIVATE LIMITED",
"NISCHINT FOODS PRIVATE LIMITED",
"NISCHINT MULTISERVICE PRIVATE LIMITED",
"NISCHINT TRADERS PRIVATE LIMITED",
"NISCHIT CEMENT PRIVATE LIMITED",
"NISCO AEGIS POLYMERS PRIVATE LIMITED",
"NISCO AGRI TECH(BANGALORE) PRIVATE LIMITED",
"NISCO PRECISION PRIVATE LIMITED",
"NISCOM TELE INFRA PRIVATE LIMITED",
"NISE LEISURE AND HOLIDAYS PRIVATE LIMITED",
"NISE PHARMA CHEM PRIVATE LIMITED",
"NISEVA TECHNOLOGIES PRIVATE LIMITED",
"NISH DEVELOPERS PRIVATE LIMITED",
"NISH ELGHA TECHNOLOGIES PRIVATE LIMITED",
"NISH TECHNO PROJECTS PRIVATE LIMITED",
"NISH TOOLING PRIVATE LIMITED",
"NISHA CABLE CO. PRIVATE LIMITED",
"NISHA FOOD PRODUCTS PRIVATE LIMITED",
"NISHA ROADWAYS PRIVATE LIMITED",
"NISHA TRADERS PRIVATE LIMITED",
"NISHA VALVES (INDIA) LIMITED",
"NISHAD CONSTRUCTIONS PRIVATE LIMITED",
"NISHAL CONTRUCTION PRIVATE LIMITED",
"NISHAL ENTERPRISES PRIVATE LIMITED",
"NISHAN CONSTRUCTION PRIVATE LIMITED",
"NISHAN MULTITRADE PRIVATE LIMITED",
"NISHAN PRODUCTS",
"NISHANT AROMAS PRIVATE LIMITED",
"NISHANT CONSTRUCTION PRIVATE LIMITED",
"NISHANT ENGINEERS PVT LTD",
"NISHANT HEALTH CARE PRIVATE LIMITED",
"NISHANT INBUILD LIMITED",
"NISHANT ISPAT PRIVATE LIMITED",
"NISHANT JEWELLERS PRIVATE LIMITED",
"NISHANT MOULDINGS PRIVATE LIMITED",
"NISHANT ORGANICS PRIVATE LIMITED",
"NISHANT OXYGEN PRIVATE LIMITED",
"NISHANT POLYCOATS PRIVATE LIMITED",
"NISHANT POWER SOLUTION PRIVATE LIMITED",
"NISHANT PROMOTERS PRIVATE LIMITED",
"NISHANT SECURITY AND ALLIED SERVICES PRIVATE LIMITED",
"NISHANTH INFRA DEVELOPERS PRIVATE LIMITED",
"NISHAPATI COLD STORAGE PVT LTD",
"NISHAT HOSPITALS AND RESEARCH CENTRE PRIVATE LIMITED",
"NISHCHAL FOUNDATION",
"NISHCHAYA TRADINGS PRIVATE LIMITED",
"NISHCHEM INTERNATIONAL PRIVATE LIMITED",
"NISHCON REALTY PRIVATE LIMITED",
"NISHDIN DISTRIBUTORS PRIVATE LIMITED",
"NISHETTY PROJECTS PRIVATE LIMITED",
"NISHI EGG POULTRY PRODUCT PRIVATE LIMITED",
"NISHI EXPORTS PRIVATE LIMITED",
"NISHI INDUSTRIES PRIVATE LIMITED",
"NISHI LABELS PRIVATE LIMITED",
"NISHI SECURITIES PRIVATE LIMITED",
"NISHICA IMPEX PRIVATE LIMITED",
"NISHIGANDHA INDUSTRIES PRIVATE LIMITED",
"NISHIGANDHA POLYMERS PRIVATE LIMITED",
"NISHIGANDHA TRADING PRIVATE LIMITED",
"NISHIGANJ AGRO FOODS PRIVATE LIMITED",
"NISHIINDO FOODS PRIVATE LIMITED",
"NISHIJA ESTATES PRIVATE LIMITED",
"NISHIKAWA COMMUNICATIONS INDIA PRIVATE LIMITED",
"NISHILAND PARK",
"NISHIT CHEMICALS PRIVATE LIMITED",
"NISHIT INFRATECH PRIVATE LIMITED",
"NISHITH DESAI ASSOCIATES LLP",
"NISHITH HEIGHTS PRIVATE LIMITED",
"NISHIVIN FINANCE AND INVESTMENT PRIVATE LIMITED",
"NISHK CREDIT SERVICES PRIVATE LIMITED",
"NISHKA ELECTRONICS PRIVATE LIMITED",
"NISHKAM IMAGING SOLUTIONS PRIVATE LIMITED",
"NISHKARSH CEMENT CONCRETE BY PRODUCTS PRIVATE LIMITED",
"NISHKARSH CONSULTANTS PVT. LTD.",
"NISHKO INSTRUMENTS PRIVATE LIMITED",
"NISHNAT DHATUKARMI PRIVATE LIMITED",
"NISHRIN TRADING AND INVESTMENT PRIVATE LIMITED",
"NISHTA MALL MANAGEMENT COMPANY PRIVATE LIMITED",
"NISHTASHA DIGITAL MEDIA PRIVATE LIMITED",
"NISHTHA ENTERPRISES PRIVATE LIMITED",
"NISHTHA INVESTMENTS PVT. LTD",
"NISHTHA WELLNESS PRIVATE LIMITED",
"NISHTYA INFOTECH PRIVATE LIMITED",
"NISHU DRYFRUITS & SPICES PRIVATE LIMITED",
"NISHYAM CONSTRUCTIONS PRIVATE LIMITED",
"NISHYAM REALTORS PRIVATE LIMITED",
"NISIKI INDIA PRIVATE LIMITED",
"NISIKI TECHNOLOGIES PRIVATE LIMITED",
"NISITH KESHARI CONSTRUCTIONS PRIVATE LIMITED",
"NISKALP INVESTMENTS TRADING CO. LIMITED",
"NISKHA FINANCE PRIVATE LIMITED",
"NISMAH TECHNOLOGIES PRIVATE LIMITED",
"NISOL MANUFACTURING COMPANY PRIVATE LIMITED",
"NISON CONSULTANTS PRIVATE LIMITED",
"NISPANA INNOVATIVE PLATFORMS PRIVATE LIMITED",
"NISRAJ REAL ESTATE AND EXPORT PRIVATE LIMITED",
"NISROCH CHEMICALS PRIVATE LIMITED",
"NISSAN AGRO TECH INDIA PRIVATE LIMITED",
"NISSAN ASHOK LEYLAND POWERTRAIN LIMITED",
"NISSAN CERAMICS PRIVATE LIMITED",
"NISSAN CLEAN INDIA PRIVATE LIMITED",
"NISSAN DIGITAL INDIA LLP",
"NISSAN ENTERPRISES LIMITED",
"NISSAN MOTOR INDIA PRIVATE LIMITED",
"NISSAN PLASTICS PRIVATE LIMITED",
"NISSAN RENAULT FINANCIAL SERVICES INDIA PRIVATE LIMITED",
"NISSAN SEEDS PRIVATE LIMITED",
"NISSAN SYNTEX PRIVATE LIMITED",
"NISSAN TRADING INDIA PRIVATE LIMITED",
"NISSAR TRANSFORMERS PRIVATE LIMITED",
"NISSEI ELECTRIC INDIA PRIVATE LIMITED",
"NISSEI PLASTIC INDIA PRIVATE LIMITED",
"NISSENKEN QUALITY EVALUATION INDIA PRIVATE LIMITED",
"NISSHINBO MECHATRONICS INDIA PRIVATE LIMITED",
"NISSI ENGINEERING SOLUTION PRIVATE LIMITED",
"NISSIM INDIA PRIVATE LIMITED",
"NISSIN ABC LOGISTICS PRIVATE LIMITED",
"NISSIN ADVANCED COATING INDO CO PRIVATE LIMITED",
"NISSIN BRAKE INDIA PRIVATE LIMITED.",
"NIST INSTITUTE PRIVATE LIMITED",
"NISTHA FOOD PRODUCTS PRIVATE LIMITED",
"NISTHA ROADWAYS PVT.LTD.",
"NISTUL MACHINES PRIVATE LIMITED",
"NISU GLASS PRIVATE LIMITED",
"NISU INFRASTRUCTURE PRIVATE LIMITED",
"NISUKA INDUSTRIES PRIVATE LIMITED",
"NISUM CONSULTING PRIVATE LIMITED",
"NISUS FINANCE SERVICES CO PRIVATE LIMITED",
"NISVAN HR SOLUTIONS PRIVATE LIMITED",
"NISWA ENGG SOLUTIONS (INDIA) PRIVATE LIMITED",
"NISWIN FOODS PRIVATE LIMITED",
"NISYA ELECTRICALS INDIA PRIVATE LIMITED",
"NIT GRADUATE SCHOOL OF MANAGEMENT",
"NIT POLYTECHNIC",
"NIT SECURITY INDIA PRIVATE LIMITED",
"NITAI CLOTHINGS PRIVATE LIMITED",
"NITAI PRESS CAMP PRIVATE LIMITED",
"NITALIKAR AGRO FARMERS PRODUCER COMPANY LIMITED",
"NITANJALI SECURITY DEVICES PRIVATE LIMITED",
"NITANT REAL ESTATE PRIVATE LIMITED",
"NITARA INDIA PRIVATE LIMITED",
"NITARA PROJECTS LIMITED",
"NITARYA SERVICES PRIVATE LIMITED",
"NITASHA CONSTRUCTIONS",
"NITCAB ELECTRIC INDIA PRIVATE LIMITED",
"NITCO CONSTRUCTION MATERIALS PRIVATE LIMITED",
"NITCO LIMITED",
"NITCO LOGISTICS P LIMITED",
"NITEEN PARULEKAR ARCHITECTS PRIVATE LIMITED",
"NITEO IT SOLUTIONS PRIVATE LIMITED",
"NITEO TECHNOLOGIES PRIVATE LIMITED",
"NITESH AUTO ENGINEERING PRIVATE LIMITED",
"NITESH AUTOMOBILES PRIVATE LIMITED",
"NITESH CHAINS PRIVATE LIMITED",
"NITESH FASHION PRIVATE LIMITED",
"NITESH ISPAT PRIVATE LIMITED",
"NITESH PUNE MALL PRIVATE LIMITED",
"NITHI AIRCONDITIONING ENGINEERS PRIVATE LIMITED",
"NITHIN SAI INDIA INFRA PRIVATE LIMITED",
"NITHIN'S AIRCON PRIVATE LIMITED",
"NITHRA APPS INDIA PRIVATE LIMITED",
"NITHYA BHARATH TEXTILE PRIVATE. LIMITED.",
"NITHYA ESTATES AND DEVELOPERS INDIA PRIVATE LIMITED",
"NITHYA PACKAGING PRIVATE LIMITED",
"NITHYAHARITHA HEALTH CARE PRIVATE LIMITED",
"NITHYANANDA AGENCIES PRIVATE LIMITED",
"NITHYARJUNA PROPERTIES AND DEVELOPERS PRIVATE LIMITED",
"NITHYASAI INDUSTRIES LIMITED",
"NITI AAYOG",
"NITI COAL MERCHANTS PRIVATE LIMITED",
"NITI FASHION PRIVATE LIMITED",
"NITIDEEP COLLECTION PRIVATE LIMITED",
"NITIGURA MARS INDIA PRIVATE LIMITED",
"NITIGYA CONSTRUCTIONS PRIVATE LIMITED",
"NITIH INFOTECH PRIVATE LIMITED",
"NITIKA ENTERPRISES PRIVATE LIMITED",
"NITIKA FINANCE PVT.LTD.",
"NITIKA PHARMACEUTICAL SPECIALITIES PRIVATE LIMITED",
"NITIKET INVESTMENTS PRIVATE LIMITED",
"NITIMAN TRADING PRIVATE LIMITED",
"NITIN ALLOYS GLOBAL LIMITED",
"NITIN BAKERS PRIVATE LIMITED",
"NITIN DEVELOPERS PRIVATE LIMITED",
"NITIN DYE-CHEM PRIVATE LIMITED",
"NITIN ENGINEERING WORKS (INDIA) PRIVATE LIMITED",
"NITIN FASTNERS PRIVATE LIMITED",
"NITIN FINANCE AND INVESTMENT PRIVATE LIMITED",
"NITIN FOOTWEARS PRIVATE LIMITED",
"NITIN ISPAT PRIVATE LIMITED",
"NITIN KITCHENWARE INDIA PRIVATE LIMITED",
"NITIN LIFESCIENCES LIMITED",
"NITIN M PEKHALE",
"NITIN MARKETING SERVICES PRIVATE LIMITED",
"NITIN PACKAGINGS PRIVATE LIMITED",
"NITIN ROAD LINES OF INDIA PVT LTD",
"NITIN SAI CONSTRUCTIONS PRIVATE LIMITED",
"NITIN SOLVENTS AND ADHESIVES PRIVATE LIMITED",
"NITIN SPINNERS LIMITED",
"NITIN WIRENETTING (INDIA) PRIVATE LIMITED",
"NITIN WIRES AND MESHES PRIVATE LIMITED",
"NITINSAI CONSTRUCTIONS PRIVATE LIMITED",
"NITIRAJ ENGINEERS LIMITED",
"NITIRAJ MOTORS PRIVATE LIMITED",
"NITISH FOODS PRIVATE LIMITED",
"NITISH METAWARE INDIA PRIVATE LIMITED",
"NITISHA FLEXO PRIVATE LIMITED",
"NITMID ELECTRONICS PRIVATE LIMITED",
"NITON VALVE INDUSTRIES PRIVATE LIMITED",
"NITOR INFOTECH PRIVATE LIMITED",
"NITORI INDIA PRIVATE LIMITED",
"NITRAA FURNITURES PRIVATE LIMITED",
"NITREX CHEMICALS INDIA LIMITED",
"NITRO ORGANICS PRIVATE LIMITED",
"NITROAIR ENGINEERS PRIVATE LIMITED",
"NITROALKANES SPECIALIST PRIVATE LIMITED",
"NITROCHEM INDIA PRIVATE LIMITED (TRANSFER COMPANY)",
"NITROGENIUM INNOVATIONS & FILTERATION INDIA PRIVATE LIMITED",
"NITROJAIN INNOVATIONS PRIVATE LIMITED",
"NITROSURGE BRANDS PRIVATE LIMITED",
"NITROTECH ENERGY PRIVATE LIMITED",
"NITROUS DESIGN PRIVATE LIMITED",
"NITROX ENGINEERING PRIVATE LIMITED",
"NITS SOLUTIONS (INDIA) PRIVATE LIMITED",
"NITSAN TECHNOLOGIES PRIVATE LIMITED",
"NITSDATA",
"NITSON AND AMITSU BUILDING SYSTEMS PRIVATE LIMITED",
"NITSTONE FINSERV PRIVATE LIMITED",
"NITTA CORPORATION INDIA PRIVATE LIMITED",
"NITTA GELATIN INDIA LIMITED",
"NITTAN INDIA TECH PRIVATE LIMITED",
"NITTANY CREATIVE SERVICES LLP",
"NITTANY CREATIVE SOLUTIONS PRIVATE LIMITED",
"NITTE EDUCATION TRUST",
"NITTE INSTITUTE OF ARCHITECTURE",
"NITTE MEENAKSHI INSTITUTE OF TECHNOLOGY",
"NITTE SCHOOL OF FASHION TECHNOLOGY AND INTERIOR DESIGN",
"NITTE UNIVERSITY",
"NITTIN CREATIONS (INDIA) PRIVATE LIMITED",
"NITTIO SOLUTIONS PRIVATE LIMITED",
"NITTITO EXIM (I) LIMITED",
"NITTO DENKO INDIA PRIVATE LIMITED",
"NITTSU LOGISTICS INDIA PRIVATE LIMITED",
"NITTSU SHOJI INDIA PRIVATE LIMITED",
"NITTU CREATIONS PRIVATE LIMITED",
"NITU FASHION PRIVATE LIMITED",
"NITX GAMES PRIVATE LIMITED",
"NITYA COUTURE FASHION PRIVATE LIMITED",
"NITYA CREATION PRIVATE LIMITED",
"NITYA FIBRES PRIVATE LIMITED",
"NITYA HOTELS PRIVATE LIMITED",
"NITYA NAND AND SONS CONTRACTORS PRIVATE LIMITED",
"NITYA NATURALS PRIVATE LIMITED",
"NITYA POWER PROJECTS PRIVATE LIMITED",
"NITYA SOFTWARE INDIA PRIVATE LIMITED",
"NITYA SUPPLIERS MULTITRADE PRIVATE LIMITED",
"NITYA TRANSPORT & LOGISTICS PRIVATE LIMITED",
"NITYAM RESOURCES PRIVATE LIMITED",
"NITYAM SOFTWARE SOLUTIONS PRIVATE LIMITED",
"NITYANAND INFRAPROJECTS PRIVATE LIMITED",
"NITYANAND MULTITRADE PRIVATE LIMITED",
"NITYANAND UDYOG PRIVATE LIMITED",
"NITYANANDA AGRO COMPANY LIMITED",
"NITYANANDA FOOD PRODUCTS PRIVATE LIMITED",
"NITYANANDA RICE MILLS PRIVATE LIMITED",
"NITYANTA INFRAPROJECTS PRIVATE LIMITED",
"NITYAOBJECT SOFTWARE SERVICES PRIVATE LIMITED",
"NITYASACH FITNESS PRIVATE LIMITED",
"NITYO INFOTECH SERVICES PRIVATE LIMITED",
"NIUM INDIA PRIVATE LIMITED",
"NIVA BUPA HEALTH INSURANCE COMPANY LIMITED",
"NIVA ECOTECH PRIVATE LIMITED",
"NIVA ORGANICS PRIVATE LIMITED",
"NIVAARA CHEMICALS PRIVATE LIMITED",
"NIVAATA SYSTEMS PRIVATE LIMITED",
"NIVADE WINDFARM LIMITED",
"NIVAGEN PHARMA (INDIA) PRIVATE LIMITED",
"NIVAKA FASHIONS LIMITED",
"NIVAM TRADING PRIVATE LIMITED",
"NIVAN BALAJI AUTOMOVERS PRIVATE LIMITED",
"NIVANSYS TECHNOLOGIES PRIVATE LIMITED",
"NIVARA HOME FINANCE LIMITED",
"NIVARAN DIAGNOSTIC CENTER PRIVATE LIMITED",
"NIVARAN HEALTHCARE PRIVATE LIMITED",
"NIVARAN PAIN RELIEF CENTRE PRIVATE LIMITED",
"NIVARI FARMER PRODUCER COMPANY LIMITED",
"NIVASA RETAIL PRIVATE LIMITED",
"NIVASAN HOMES PRIVATE LIMITED",
"NIVASAT FOODS PRIVATE LIMITED",
"NIVATI HEALTH PRIVATE LIMITED",
"NIVAYA RESOURCES PRIVATE LIMITED",
"NIVEA INDIA PRIVATE LIMITED",
"NIVEDAN SALES PRIVATE LIMITED",
"NIVEDITA CHEMCON PRIVATE LIMITED",
"NIVEDITA CHEMICALS PRIVATE LIMITED",
"NIVEE METAL PRODUCTS PRIVATE LIMITED",
"NIVEE PROPERTY DEVELOPERS PRIVATE LIMITED",
"NIVELCO INSTRUMENTS INDIA PRIVATE LIMITED",
"NIVERA PAINTS (INDIA) PRIVATE LIMITED",
"NIVERA WIRES PRIVATE LIMITED",
"NIVESH MANDI PRIVATE LIMITED",
"NIVESHAK MPOWERED PRIVATE LIMITED",
"NIVESHAN TECHNOLOGIES INDIA PRIVATE LIMITED",
"NIVETTI SYSTEMS PRIVATE LIMITED",
"NIVEUS SOLUTIONS PRIVATE LIMITED",
"NIVI SOFTWARE SOLUTIONS PRIVATE LIMITED",
"NIVI SOLUTIONS",
"NIVIA SYNTHETICS PRIVATE LIMITED",
"NIVICON PROCESS AUTOMATION PRIVATE LIMITED",
"NIVID REWARDS PRIVATE LIMITED",
"NIVID SOFT TECH PRIVATE LIMITED",
"NIVID TECHNOLOGIES INDIA PRIVATE LIMITED",
"NIVID TELECOM INDIA PRIVATE LIMITED",
"NIVIDOUS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"NIVIK INDUSTRIES PRIVATE LIMITED",
"NIVO CONTROLS PRIVATE LIMITED",
"NIVON TEXTILE INDUSTRIES PRIVATE LIMITED",
"NIVOXAA BIOTECH INDIA PRIVATE LIMITED",
"NIVRITTI FOODS PRIVATE LIMITED",
"NIVSHAKTI BIOENERGY PRIVATE LIMITED",
"NIVULIA LIFESCIENCES PRIVATE LIMITED",
"NIVVEDITA FOODS & BEVERAGES PRIVATE LIMITED",
"NIVY REMEDIES PRIVATE LIMITED",
"NIVYA PACKAGING PRIVATE LIMITED",
"NIWALI FARMERS PRODUCER COMPANY LIMITED",
"NIWAS COLONISERS PRIVATE LIMITED",
"NIWAS IRON AND STEEL PRIVATE LIMITED",
"NIWAS RESIDENTIAL & COMMERCIAL PROPERTIES PRIVATE LIMITED",
"NIWASI MATIMAND VIDYALAY BHAWAN",
"NIWASI MATIMAND VIDYALAY BHAWAN SILLOD",
"NIWTONTECH E- LEARNING PRIVATE LIMITED",
"NIX TOUR INDIA PRIVATE LIMITED",
"NIXCEL SOFTWARE SOLUTIONS PRIVATE LIMITED",
"NIXI LABORATORIES PRIVATE LIMITED",
"NIXIES METERS PRIVATE LIMITED",
"NIXINN INSIGHTS PRIVATE LIMITED",
"NIXON INTERNATIONAL PRIVATE LIMITED",
"NIXSA TECHNOLOGIES PRIVATE LIMITED",
"NIXSERV I.T SOLUTIONS PRIVATE LIMITED",
"NIXSOL INDIA PRIVATE LIMITED",
"NIXYNOVA MOTOREN PRIVATE LIMITED",
"NIYA HEALTHCARE PRIVATE LIMITED",
"NIYAJI URDU JUNIOR AND HIGH SCHOOL",
"NIYAMAK CONSULTANCY PRIVATE LIMITED",
"NIYATI COMMODITIES PRIVATE LIMITED",
"NIYATI COMMUNICATIONS PRIVATE LIMITED",
"NIYATI ENGINEERING PRIVATE LIMITED",
"NIYATI FOOD PRODUCTS PRIVATE LIMITED",
"NIYATI FOODS PRIVATE LIMITED",
"NIYATI TECHNOLOGIES PRIVATE LIMITED",
"NIYOGI BOOKS PRIVATE LIMITED",
"NIYOGI ENTERPRISE PRIVATE LIMITED",
"NIYOGI OFFSET PRIVATE LIMITED",
"NIYOGIN FINTECH LIMITED",
"NIYUJ ENTERPRISE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"NIYURA LIFESTYLE PRIVATE LIMITED",
"NIYURA TECHNOLOGIES PRIVATE LIMITED",
"NIZAM COLLEGE",
"NIZAM MATCHES PRIVATE LIMITED",
"NIZAM SUGARS LIMITED",
"NIZAMABAD AGRO PRIVATE LIMITED",
"NIZAMABAD PROGRESSIVE FARMERS PRODUCER COMPANY LIMITED",
"NIZAMI APPARELS PRIVATE LIMITED",
"NIZAMIA HIGH SCHOOL KONDHALI",
"NIZAMS INSTITUTE OF MEDICAL SCIENCE",
"NIZAM'S INSTITUTE OF MEDICAL SCIENCES NIMS",
"NIZAMUDDIN LOGISTICS PRIVATE LIMITED",
"NIZANTA RETAIL VENTURES PRIVATE LIMITED",
"NIZARNESHWAR DAIRY PRODUCTS LIMITED",
"NIZEROLLES SYSTEMS ELECTRONICS INDIA PRIVATE LIMITED",
"NIZMAR HOTELS PRIVATE LIMITED",
"NIZONA MARINE PRODUCTS PRIVATE LIMITED",
"NJ ASSET MANAGEMENT PRIVATE LIMITED",
"NJ CAPITAL PRIVATE LIMITED",
"NJ CHEMSOLV PRIVATE LIMITED",
"NJ INDIA INVEST PRIVATE LIMITED",
"NJ INDIAINVEST PRIVATE LIMITED",
"NJ INSURANCE BROKERS PRIVATE LIMITED",
"NJ MART PRIVATE LIMITED",
"NJ OVERSEAS PRIVATE LIMITED",
"NJ PLASTIC INDUSTRIES PRIVATE LIMITED",
"NJ REALTY SERVICES PRIVATE LIMITED",
"NJ RENEWABLE ENERGY PRIVATE LIMITED",
"NJ WEALTH MANAGEMENT PRIVATE LIMITED",
"NJA GARMENTS PRIVATE LIMITED",
"NJA INDUSTRIES PRIVATE LIMITED",
"NJA MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"NJAVALLIL LATEX PRIVATE LIMITED",
"NJB EDUCATION AND RESEARCH FOUNDATION",
"NJBIO INDIA PHARMACEUTICAL PRIVATE LIMITED",
"NJD CAPITAL PRIVATE LIMITED",
"NJK PHARMACY PRIVATE LIMITED",
"NJM BLENDS PRIVATE LIMITED",
"NJN EXPRESS WHEELS PRIVATE LIMITED",
"NJORD SEAFOODS PRIVATE LIMITED",
"NJP BUILDTECH PRIVATE LIMITED",
"NJP HEALTHCARE PRIVATE LIMITED",
"NJR FINANCE PVT LTD",
"NJS ENGINEERS INDIA PRIVATE LIMITED",
"NJT FINANCE PRIVATE LIMITED",
"NJUTA TECHNOLOGIES PRIVATE LIMITED",
"NK CHEMICALS PVT LTD",
"NK FREIGHT CARRIERS PRIVATE LIMITED",
"NK GUPTA BUILDERS PRIVATE LIMITED",
"NK INSTRUMENTS PRIVATE LIMITED",
"NK REMEDIES PRIVATE LIMITED",
"NK SECURITIES RESEARCH PRIVATE LIMITED",
"NK SHEET METAL WORKS PRIVATE LIMITED",
"NK SOLUTIONS PRIVATE LIMITED",
"NK TECHNO CRAFT INDIA PRIVATE LIMITED",
"NK TOLL ROAD LIMITED",
"NKA FINANCIAL SERVICES PRIVATE LIMITED",
"NKAK CLOTHING PRIVATE LIMITED",
"NKAS SERVICES PRIVATE LIMITED",
"NKB CONSTRUCTION EQUIPMENTS PRIVATE LIMITED",
"NKB EXTRUSIONS PRIVATE LIMITED",
"NKB INDUSTRIAL PRODUSCTS PRIVATE LIMITED",
"NKBJ INFOTECH PRIVATE LIMITED",
"NKBR ACADEMY",
"NKC CONSTRUCTIONS PRIVATE LIMITED",
"NKC CONVEYOR INDIA PRIVATE LIMITED",
"NKC FINANCE PRIVATE LIMITED",
"NKC PROJECTS PRIVATE LIMITED",
"NKD AGENCY PRIVATE LIMITED",
"NKD MARKETING PRIVATE LIMITED",
"NKG ADVISORY BUSINESS AND CONSULTING SERVICES PRIVATE LIMITED",
"NKG INDIA COFFEE PRIVATE LIMITED",
"NKG INFRASTRUCTURE LIMITED",
"NKG PLASTOCHEM PRIVATE LIMITED",
"NKGC WORLDWIDE VENTURES PRIVATE LIMITED",
"NKGSB CO-OPERATIVE BANK LTD",
"NKH ALLOYS PRIVATE LIMITED",
"NKH HAMMERS PRIVATE LIMITED",
"NKH MEDICARE PRIVATE LIMITED",
"NKINN VENTURES PRIVATE LIMITED",
"NKJA INFRA DEVELOPMENT PRIVATE LIMITED",
"NKK BUILDHOME PRIVATE LIMITED",
"NKK SHIPPINGAND LOGISTICS PRIVATE LIMITED",
"NKKM INDUSTRIES PRIVATE LIMITED",
"NKL AUTOMOTIVES INDIA PRIVATE LIMITED",
"NKM CABLES AND STRIPS PRIVATE LIMITED",
"NKN MEDIA PRIVATE LIMITED",
"NKORR TECHNOLOGIES PRIVATE LIMITED",
"NKP EMPIRE VENTURES PRIVATE LIMITED",
"NKP PHARMA PRIVATE LIMITED",
"NKP SALVE INSTITUTE OF MEDICAL SCIENCES AND RESEARCH CENTRE",
"NKP STATIONARY & GIFT ARTICLE PRIVATE LIMITED",
"NKR LOGISTICS PRIVATE LIMITED",
"NKRK STEELS PRIVATE LIMITED",
"NKS AGRO & ECO ENERGY & TECHNOLOGIES PRIVATE LIMITED",
"NKS CONSTRUCTION AND ENGINEERS PRIVATE LIMITED",
"NKS HOSPITAL",
"NKS MINING LIMITED",
"NKSQUARED GLOBAL PRIVATE LIMITED",
"NKT OPERATIONS INDIA PRIVATE LIMITED",
"NKT SOUTH ASIA PRIVATE LIMITED",
"NKV FARMHOUSE & DEVELOPERS PRIVATE LIMITED",
"NL BLINDS PRIVATE LIMITED",
"NL CLOTHING COMPANY PRIVATE LIMITED",
"NL INFRASTRUCTURE AND PROJECTS PRIVATE LIMITED",
"NL TECHNOLOGIES PRIVATE LIMITED",
"NL TILE ART PRIVATE LIMITED",
"NLA INFRASTRUCTURE PRIVATE LIMITED",
"NLB PROJECT MANAGEMENT I PRIVATE LIMITED",
"NLB SERVICES PRIVATE LIMITED",
"NLB STEELS PRIVATE LIMITED",
"NLB TECHNOLOGY SERVICES PRIVATE LIMITED",
"NLC INDIA LIMITED",
"NLC TAMIL NADU POWER LIMITED",
"NLEAGUE TECHNOLOGIES PRIVATE LIMITED",
"NLGIC SUPPORT SERVICES PRIVATE LIMITED",
"NLI PACKAGING MACHINES PRIVATE LIMITED",
"NLINE ROTO PRIVATE LIMITED",
"NLINK TECH PRIVATE LIMITED",
"NLITE ENERGY SOLUTIONS LLP",
"NLMK INDIA SERVICE CENTER PRIVATE LIMITED",
"NLP LABS PRIVATE LIMITED",
"NLS FLEETS PRIVATE LIMITED",
"NLT AGRO FOODS PRIVATE LIMITED",
"NM ADVERTISER PRIVATE LIMITED",
"NM AUTOMATION & CONTROL PRIVATE LIMITED",
"NM FINANCIERS PRIVATE LIMITED",
"NM FOODIMPEX PRIVATE LIMITED",
"NM GAADLAWALA VENTURES PRIVATE LIMITED",
"NM HITECH CARRIERS PVT LTD",
"NM INDIA BIO PRIVATE LIMITED",
"NM INGENIOUS MANAGEMENT SERVICES PRIVATE LIMITED",
"NM INSTITUTE OF ENGINEERING & TECHNOLOGY",
"NM WADIA INSTITUTE OF CARDIOLOGY",
"NMAH & CO",
"NMAM INSTITUTE OF TECHNOLOGY",
"NMAMI TRADE PRIVATE LIMITED",
"NMAY IMPEX PRIVATE LIMITED",
"NMB COLD STORAGE PRIVATE LIMITED",
"NMB MINEBEA INDIA PRIVATE LIMITED",
"NMB RETAIL LLP",
"NMBR SYSTEMS PRIVATE LIMITED",
"NMC AUTOMOBILES (INDIA) PRIVATE LIMITED",
"NMC GENETICS INDIA PRIVATE LIMITED",
"NMC INDUSTRIES PRIVATE LIMITED",
"NMC PROVECTUS SOLUTIONS PRIVATE LIMITED",
"NMCH NALENDA MEDICAL COLAG 7 HOSPIT",
"NMDC CSR FOUNDATION",
"NMDC LIMITED",
"NMDC STEEL LIMITED",
"NMDC-CMDC LIMITED",
"NMF EQUIPMENTS AND PLANTS PRIVATE LIMITED",
"NMFASHION RETAIL PRIVATE LIMITED",
"NMG DIGITAL PRIVATE LIMITED",
"NMK INDUSTRIES PRIVATE LIMITED",
"NMK TEXTILE MILLS INDIA PRIVATE LIMITED",
"NMKRV FIRST GRADE COLLEGE FOR WOMEN",
"NMKRV PU COLLEGE",
"NMKRV WOMENS COLLEGE",
"KERALA PUBLIC SCHOOL",
"NMO ENERGY PRIVATE LIMITED",
"NMP DESIGN PRIVATE LIMITED",
"NMP READYMADES PRIVATE LIMITED",
"NMPC HEALTH CARE PRIVATE LIMITED",
"NMR AGRO FOOD PRIVATE LIMITED",
"NMR DIAGNOSTICS PRIVATE LIMITED",
"NMR ENTERPRISES PRIVATE LIMITED",
"NMR IMAGING PRIVATE LIMITED",
"NMR KNITFAB PRIVATE LIMITED",
"NMR LOGISTICS PRIVATE LIMITED",
"NMR MEDICAL INSTITUTE PRIVATE LIMITED",
"NMRM INFOTECH PRIVATE LIMITED",
"NMS ENTERPRISES LIMITED",
"NMS RESOURCES GLOBAL LIMITED",
"NMSWORKS SOFTWARE PRIVATE LIMITED",
"NMT ENGINEERING & SERVICES PRIVATE LIMITED",
"NMT PACKAGING PRIVATE LIMITED",
"NMT SHIPPING PRIVATE LIMITED",
"NMTG MECHTRANS TECHNIQUES PRIVATE LIMITED",
"NMTRONICS INDIA PRIVATE LIMITED",
"NMV ENERGY PRIVATE LIMITED",
"NMV REALTOR PRIVATE LIMITED",
"NN OVERSEAS PRIVATE LIMITED",
"NN VEEN INDUSTRIES PRIVATE LIMITED",
"N-NATTUKADA PRIVATE LIMITED",
"NNB ENGINEERS PRIVATE LIMITED",
"NND AMBERNATH LLP",
"NND AND SONS PRIVATE LIMITED",
"NNE PHARMAPLAN INDIA LIMITED",
"NNE PRIVATE LIMITED",
"NNEETI POLYMERS PRIVATE LIMITED",
"NNEMA ENDEAVOUR PRIVATE LIMITED",
"NNEPTUNE HOUSE FURRNISHINGS PRIVATE LIMITED",
"NNINJAS MODEL MANAGEMENT PRIVATE LIMITED",
"NNK MARINE EXPORTS PRIVATE LIMITED",
"NNM NEXTGEN ADVISORY PRIVATE LIMITED",
"NNM SECURITIES PRIVATE LIMITED",
"NNOWETA PERFORMANCE CHEMICALS PRIVATE LIMITED",
"NNP BUILDCON PRIVATE LIMITED",
"NNPI PLASTIC PRIVATE LIMITED",
"NNR GLOBAL LOGISTICS INDIA PRIVATE LIMITED",
"NNS CONSTRUCTIONS AND ENGINEERING PRIVATE LIMITED",
"NNS EVENTS & EXHIBITIONS PRIVATE LIMITED",
"NNS ONLINE PRIVATE LIMITED",
"NNS PROCON PRIVATE LIMITED",
"NNT DEVELOPERS PRIVATE LIMITED",
"NNTS PRIVATE LIMITED",
"NO 1 AIR FORCE SCHOOL GWALIOR",
"NO 1 WORLDWIDE EXPRESS PRIVATE LIMITED",
"NO BORDERS TECHNOLOGIES PRIVATE LIMITED",
"NO NASTIES PRIVATE LIMITED",
"NOA JEWELS PRIVATE LIMITED",
"NOAF INTERIORS PRIVATE LIMITED",
"NOAH EQUIPMENT PRIVATE LIMITED",
"NOAHINDIA ENGINEERING PRIVATE LIMITED",
"NOAPARA RASHBIHARI INSTITUTION FOR GIRLS",
"NOATUM LOGISTICS INDIA PRIVATE LIMITED",
"NOBAL JEWELS PRIVATE LIMITED",
"NOBEL ASSETS MANAGEMENT LLP",
"NOBEL AUTOMOTIVE INDIA PRIVATE LIMITED",
"NOBEL BIOCARE INDIA PRIVATE LIMITED",
"NOBEL DEALCOM PRIVATE LIMITED",
"NOBEL HIGH SCHOOL",
"NOBEL HYGIENE PRIVATE LIMITED",
"NOBEL IMPEX",
"NOBEL OVERSEAS PRIVATE LIMITED",
"NOBEL PRIME MEDICARE SERVICES AND RESEARCH PRIVATE LIMITED",
"NOBEL SOFTWARE SYSTEMS PRIVATE LIMITED",
"NOBEL TEXTILES (INDORE) PRIVATE LIMITED",
"NOBI FOODS PRIVATE LIMITED",
"NOBILITAS INFOTECH PRIVATE LIMITED",
"NOBILITY ESTATES PRIVATE LIMITED",
"NOBIOUS TECHNOLOGIES PRIVATE LIMITED",
"NOBIS TECHNOLOGIES PRIVATE LIMITED",
"NOBLE AEROSPACE PRIVATE LIMITED",
"NOBLE AGRO BIOTECH PRIVATE LIMITED",
"NOBLE AGRO FOOD PRODUCTS PRIVATE LIMITED",
"NOBLE AGRO VET PRIVATE LIMITED",
"NOBLE ALCHEM PRIVATE LIMITED",
"NOBLE AUTO SPARES PRIVATE LIMITED",
"NOBLE AYU COLLEGE AND RESEARCH",
"NOBLE CARE HOSPITAL",
"NOBLE CARE HOSPITAL PRIVATE LIMITED",
"NOBLE CAST COMP PRIVATE LIMITED",
"NOBLE CLINIC",
"NOBLE COLLEGE",
"NOBLE COMMUNICATIONS PVT. LTD.",
"NOBLE CONSTRUCTIONS PROJECT SERVICES PRIVATE LIMITED",
"NOBLE CORRUGATORS PVT LTD",
"NOBLE DAIRY PRIVATE LIMITED",
"NOBLE DENTON INDIA PRIVATE LIMITED",
"NOBLE DIAGNOSTICS PRIVATE LIMITED",
"NOBLE DREAM PROJECTS PRIVATE LIMITED",
"NOBLE EDUCATIONAL TRUST",
"NOBLE ELECTRADE PRIVATE LIMITED",
"NOBLE ELECTRIC COMPANY PRIVATE LIMITED",
"NOBLE ELECTRODES PVT LTD",
"NOBLE ENERGY INC.",
"NOBLE ENGLISH MEDIUM HIGH SCHOOL",
"NOBLE FERROMET PRIVATE LIMITED",
"NOBLE FOUNDATION",
"NOBLE GAS LIMITED",
"NOBLE GENETICS PRIVATE LIMITED",
"NOBLE GLASS WORKS PRIVATE LIMITED",
"NOBLE GREEN AGRITECH PRIVATE LIMITED",
"NOBLE HEIGHTS PRIVATE LIMITED",
"NOBLE HIGHER SECONDARY SCHOOL",
"NOBLE HOMEO COLLEGE AND RESEARCH",
"NOBLE HOMO COLLEGE AND RESEARCH",
"NOBLE HOSPITAL",
"NOBLE HOSPITALS PUNE",
"NOBLE HOUSE CONSULTING INDIA PRIVATE LIMITED",
"NOBLE HOUSE SECURITIES AND HOLDINGS LIMITED",
"NOBLE INSTITUTE FOR PREMIER STUDIES AND TECHNOLOGIES LIMITED",
"NOBLE INTERMEDIATES PRIVATE LIMITED",
"NOBLE ISPAT PRIVATE LIMITED",
"NOBLE KING PURCHASE SOLUTIONS PRIVATE LIMITED",
"NOBLE LAMINATES PRIVATE LIMITED",
"NOBLE LAYER FARM PRIVATE LIMITED",
"NOBLE LUGGAGE PVT LTD",
"NOBLE MARKETIERS PRIVATE LIMITED",
"NOBLE MEDICHEM PRIVATE LIMITED",
"NOBLE MOTORS INDIA PRIVATE LIMITED",
"NOBLE MOULDS PRIVATE LIMITED",
"NOBLE PHARMA & LOGISTIC PRIVATE LIMITED",
"NOBLE PROCON PRIVATE LIMITED",
"NOBLE PROTECTIVE SYSTEMS PRIVATE LIMITED",
"NOBLE RESOURCES AND TRADING INDIA PRIVATE LIMITED.",
"NOBLE SEEDS PRIVATE LIMITED",
"NOBLE SHIPPING PRIVATE LIMITED",
"NOBLE SOLUTIONS LLP",
"NOBLE SONICS PRIVATE LIMITED",
"NOBLE STAR ENGINEERING COLLEGE",
"NOBLE SUPERSPECIALITY HOSPITAL PRIVATE LIMITED",
"NOBLE SYSTEMS INDIA PRIVATE LIMITED",
"NOBLE TECH ENGINEERING PRIVATE LIMITED",
"NOBLE TECH INDUSTRIES PRIVATE LIMITED",
"NOBLE TRANSPORT COMPANY PRIVATE LIMITED",
"NOBLE WEB STUDIO PRIVATE LIMITED",
"NOBLEKIND ORGANIC FARMERS PRODUCER COMPANY LIMITED",
"NOBLESERVE SYSTEMS PRIVATE LIMITED",
"NOBLESOFT SOLUTIONS INDIA PRIVATE LIMITED",
"NOBLESTAR HEALTH SERVICES PRIVATE LIMITED",
"NOBLETEX INDUSTRIES LIMITED",
"NOCCARC ROBOTICS PRIVATE LIMITED",
"NOCCI BALASORE INFRASTRUCTURE COMPANY",
"NOCIL LIMITED",
"NOCME TECHNOLOGIES PRIVATE LIMITED",
"NOCODEZ SOFTWARE SERVICES INDIA PRIVATE LIMITED",
"NOCTE LUMBERS PRIVATE LIMITED",
"NOCTEL TECHNICAL SOLUTIONS PRIVATE LIMITED",
"NOCTILUCENT PROJECTS PRIVATE LIMITED",
"NOCTURNAL NETWORKS PRIVATE LIMITED",
"NOD AGRO PRIVATE LIMITED",
"NOD BEARINGS PRIVATE LIMITED",
"NODAL ENGINEERING PRIVATE LIMITED",
"NODDING HEADS GAMES PRIVATE LIMITED",
"NODDY AUTO PRIVATE LIMITED",
"NODE TECHNOLOGIES INDIA PRIVATE LIMITED",
"NODWIN GAMING PRIVATE LIMITED",
"NOE TECH INTERNATIONAL PRIVATE LIMITED",
"NOEL CONSTRUCTION COMPANY PRIVATE LIMITED",
"NOEL MEDIA & ADVERTISING PRIVATE LIMITED",
"NOEL MERCANTILE PRIVATE LIMITED",
"NOEL TEXTILES ( INDIA) PRIVATE LIMITED",
"NOEMI MULTITRADING PRIVATE LIMITED",
"NOESIS CONSULTING PRIVATE LIMITED",
"NOESIS KNOWLEDGE SOLUTIONS PRIVATE LIMITED",
"NOESIS KRONOS PRIVATE LIMITED",
"NOESIS PUBLISHING SERVICES PRIVATE LIMITED",
"NOESIS VENTURES PRIVATE LIMITED",
"NOESYS SOFTWARE PRIVATE LIMITED",
"NOETIC FINANCE PRIVATE LIMITED",
"NOEXIT CLOTHING PRIVATE LIMITED",
"NOFILTR SOCIAL LLP",
"NOGI & COMPANY PRIVATE LIMITED",
"NOGUILT FITNESS AND NUTRITION INDIA PRIVATE LIMITED",
"NOHAR CHAND & SONS STEELS PRIVATE LIMITED",
"NOHMI BOSAI INDIA PRIVATE LIMITED",
"NOIDA ALUMINIUM COMPANY PRIVATE LIMITED",
"NOIDA BUILDMART PRIVATE LIMITED",
"NOIDA CEMENT PRIVATE LIMITED",
"NOIDA CONTAINERS PRIVATE LIMITED",
"NOIDA CYBERPARK PRIVATE LIMITED",
"NOIDA EXIM PRIVATE LIMITED",
"NOIDA FABCON MACHINES PRIVATE LIMITED",
"NOIDA FORTUNE PROPMART PRIVATE LIMITED",
"NOIDA HOLDINGS PRIVATE LIMITED",
"NOIDA HOME DECOR PRIVATE LIMITED",
"NOIDA INSTITUTE OF ENGINEERING AND TECHNOLOGY",
"NOIDA INTERATIONAL UNIVERSITY",
"NOIDA INTERNATIONAL INSTITITUTE OF MEDICAL SCIENCES",
"NOIDA MANAGEMENT SYSTEM PRIVATE LIMITED",
"NOIDA METRO RAIL CORPORATION LIMITED",
"NOIDA POLYCHEM PVT LTD",
"NOIDA POLYPACK PRIVATE LIMITED",
"NOIDA POWER COMPANY LIMITED",
"NOIDA TOLL BRIDGE COMPANY LIMITED",
"NOIDA TOWERS PRIVATE LIMITED",
"NOIR FASHIONS PRIVATE LIMITED",
"NOISE CONSULTING INDIA PRIVATE LIMITED",
"NOJISH TECHNOLOGIES PRIVATE LIMITED",
"NOKA FREIGHT CARRIER PRIVATE LIMITED",
"NOKANG INFRA PRIVATE LIMITED",
"NOKEN VITRIFIED PRIVATE LIMITED",
"NOKHA AGRO SERVICES PRIVATE LIMITED",
"NOKHA AGROTECH PRIVATE LIMITED",
"NOKI TECHNOLOGIES PRIVATE LIMITED",
"NOKIA INDIA LIMITED",
"NOKIA INDIA SALES PRIVATE LIMITED",
"NOKIA SOLUTIONS AND NETWORKS INDIA PRIVATE LIMITED",
"NOKOR BHOOMI PRIVATE LIMITED",
"NOKOR SOLAR ENERGY PRIVATE LIMITED",
"NOLIMIT CITY INDIA PRIVATE LIMITED",
"NOLKHA BROTHERS PRIVATE LIMITED",
"NOLTA INDIA PRIVATE LIMITED",
"NOMA HOTELS PRIVATE LIMITED",
"NOMA INFRASTRUCTURE PRIVATE LIMITED",
"NOMAD ORIGINALS OVERSEAS PRIVATE LIMITED",
"NOMAD STUDY ABROAD CONSULTANT PRIVATE LIMITED",
"NOMAD TRAVELS PRIVATE",
"NOMADIK SOUL PRIVATE LIMITED",
"NOMADS PROPERTIES PRIVATE LIMITED",
"NOMAX ELECTRICAL STEEL PRIVATE LIMITED",
"NOMINAL CAPITAL INFIN PRIVATE LIMITED",
"NOMINATE IT PRIVATE LIMITED",
"NOMISMA MOBILE SOLUTIONS PRIVATE LIMITED",
"NOMURA CAPITAL INDIA PRIVATE LIMITED",
"NOMURA FIN SERVICES INDIA PRIVATE LIMITED",
"NOMURA FINANCIAL ADVISORY AND SECURITIES INDIA PRIVATE LIMITED",
"NOMURA FIXED INCOME SECURITIES LIMITED",
"NOMURA RESEARCH INSTITUTE CONSULTING AND SOLUTIONS INDIA PRIVATE LIMITED",
"NOMURA RESEARCH INSTITUTE FINANCIAL TECHNOLOGIES INDIA PRIVATE LIMITED",
"NOMURA SERVICES INDIA PRIVATE LIMITED",
"NOMURA STRUCTURED FINANCE SERVICES PRIVATE LIMITED",
"NOMUS COMM-SYSTEMS PRIVATE LIMITED",
"NON FERROUS METAL INDUSTRIES PRIVATE LIMITED",
"NON STOP PACKAGING PRIVATE LIMITED",
"NON SUCH TEA ESTATE LIMITED",
"NONA CHAND PUKUR MANMATHA NATH GIRLS HIGH SCHOOL",
"NONA TECHNOLOGIES PRIVATE LIMITED",
"NONATEL SOLUTIONS GLOBAL PRIVATE LIMITED",
"NONCEBLOX PRIVATE LIMITED",
"NONGWOO SEED INDIA PRIVATE LIMITED",
"NONSTOP IO TECHNOLOGIES PRIVATE LIMITED",
"NONY INDUSTRIES PRIVATE LIMITED",
"NOODLE ANALYTICS PRIVATE LIMITED",
"NOOHMEDIA & TECHNOLOGIES (OPC) PRIVATE LIMITED",
"NOOKS TECHNOLOGIES PRIVATE LIMITED",
"NOON E-COMMERCE INDIA PRIVATE LIMITED",
"NOOOR TECHNOLOGIES PRIVATE LIMITED",
"NOOPUR TRADITIONS PRIVATE LIMITED",
"NOOR AZIZ BUILDERS & DEVELOPERS PRIVATE LIMITED",
"NOOR ENTERPRISE PRIVATE LIMITED",
"NOOR ICE AND COLD STORAGES PRIVATE LIMITED",
"NOOR IMPEX PRIVATE LIMITED",
"NOOR INDIA BUILDCON PRIVATE LIMITED",
"NOOR INSTITUTE OF MEDICAL SPECIALITIES PRIVATE LIMITED",
"NOOR LIFTERS PRIVATE LIMITED",
"NOOR NISHAN PRIVATE LIMITED",
"NOOR STEELS PRIVATE LIMITED",
"NOOR UL ISLAM URDU HIGH SCHOOL & JUNIOR COLLEGE",
"NOORANI PROPERTIES PRIVATE LIMITED",
"NOORJEHAN EXPORTS LLP",
"NOORUL ISLAM URDU HIGH SCHOOL & JUNIOR COLLEGE GOVANDI WEST",
"NOORVEER CREATIONS PRIVATE LIMITED",
"NOOTAN COLLEGE OF PHARMACY",
"NOOTAN GENERAL HOSPITAL",
"NOOVOCOM ADVANTAGES PRIVATE LIMITED",
"NOPANY INSTITUTE OF MANAGEMENT STUDIES",
"NOPS INFRASTRUCTURE PRIVATE LIMITED",
"NOR BLACK NOR WHITE PRIVATE LIMITED",
"NOR LINK IT SOLUTIONS PRIVATE LIMITED",
"NOR TRADERS PRIVATE LIMITED",
"NORAAH JEWELS PRIVATE LIMITED",
"NORAH CLINICAL SOLUTION (INDIA) PRIVATE LIMITED",
"NORATEL INDIA POWER COMPONENTS PRIVATE LIMITED",
"NORBE MEDICARE PRIVATE LIMITED",
"NORBEN TEA & EXPORTS LTD",
"NORCA ENTERPRISE PRIVATE LIMITED",
"NORCAL IT PRIVATE LIMITED",
"NORD ANGLIA EDUCATION INDIA PRIVATE LIMITED",
"NORD ANGLIA EDUCATION INFRASTRUCTURE PRIVATE LIMITED",
"NORD ANGLIA EDUCATION KNOWLEDGE PRIVATE LIMITED",
"NORD DRIVESYSTEMS PRIVATE LIMITED",
"NORD FOREX INDIA PRIVATE LIMITED",
"NORD INFOTECH PRIVATE LIMITED",
"NORDBERG SINGAPORE PTE LIMITED",
"NORDEA LIFESCIENCE PRIVATE LIMITED",
"NORDEN COMMUNICATION PRIVATE LIMITED",
"NORDEX INDIA MANUFACTURING PRIVATE LIMITED",
"NORDEX INDIA PRIVATE LIMITED",
"NORDIA INFOTECH PRIVATE LIMITED",
"NORDIC BAZAAR (INDIA) PRIVATE LIMITED",
"NORDIC DRIZIT TECH PRIVATE LIMITED",
"NORDIC FORMULATIONS PRIVATE LIMITED",
"NORDIC KOLEKTIVE PRIVATE LIMITED",
"NORDIC SEMICONDUCTOR INDIA PRIVATE LIMITED",
"NORD-LOCK (INDIA) PRIVATE LIMITED",
"NORDMECCANICA INDIA PRIVATE LIMITED",
"NORD-SCHROTT INDIA PRIVATE LIMITED",
"NORDSON INDIA PRIVATE LIMITED",
"NOREL NBPL INDIA PRIVATE LIMITED",
"NOREN HEALTHCARE PRIVATE LIMITED",
"NORETSA PHARMACEUTICALS PRIVATE LIMITED",
"NOREX FLAVOURS PRIVATE LIMITED",
"NORFOLK SOUTHERN CORPORATION",
"NORG BIOTECH PRIVATE LIMITED",
"NORINCO PRIVATE LIMITED",
"NORIS MEDICAL PRIVATE LIMITED",
"NORISYS TECHNOLOGY LIMITED",
"NORISYS TECHNOLOGY PRIVATE LIMITED",
"NORITSU INDIA PRIVATE LIMITED",
"NORKA-ROOTS (SEC 25 COMPANY)",
"NORLANKA MANUFACTURING INDIA PRIVATE LIMITED",
"NORMA DND PRODUCTS PRIVATE LIMITED",
"NORMA GROUP PRODUCTS INDIA PRIVATE LIMITED",
"NORMA INDIA LIMITED",
"NORMA STEEL AND ALLOYS PRIVATE LIMITED",
"NORMAK FASHIONS PRIVATE LIMITED",
"NORMALIEN TOOLING SYSTEMS PVT LTD",
"NORMAN ENVIRO PROJECTS PRIVATE LIMITED",
"NORMAN REALTORS PRIVATE LIMITED",
"NORMAN STEWART & COMPANY PVT LTD",
"NORMANDY BREWERIES AND DISTILLERIES PRIVATE LIMITED",
"NORMECH ENGINEERING INDIA PRIVATE LIMITED",
"NORMET INDIA PRIVATE LIMITED",
"NORMEX VALVES PVT LTD",
"NORNAMENT DESIGNERS PRIVATE LIMITED",
"NOROC SOLUTIONS PRIVATE LIMITED",
"NORONHA LOGISTICS PRIVATE LIMITED",
"NORONIC PHARMACEUTICAL PRIVATE LIMITED",
"NOROO BEE AUTOMOTIVE COATINGS INDIA PRIVATE LIMITED",
"NORPACK ENTERPRISES PRIVATE LIMITED",
"NORQUEST BRANDS PVT LTD",
"NORRIS MEDICINES LIMITED",
"NORSCOT DRILLING AND PRODUCTION PRIVATE LIMITED",
"NORSK HYDRO ASA",
"NORSPIN INTERNATIONAL PRIVATE LIMITED",
"NORTAKS JK EXIM PRIVATE LIMITED",
"NORTAN PROPERTY SOLUTIONS PRIVATE LIMITED",
"NORTE EUROCAO INDIA PRIVATE LIMITED",
"NORTECH FERRO ALLOYS PRIVATE LIMITED",
"NORTECH INFONET PRIVATE LIMITED",
"NORTECH POWER PROJECTS PRIVATE LIMITED",
"NORTECH PROPERTY PRIVATE LIMITED",
"NORTEL NETWORKS INDIA PRIVATE LIMITED",
"NORTEX REALTY LIMITED",
"NORTH 24 PARGANAS REGULATED MARKET COMMITTEE",
"NORTH ARMOUR ENTERPRISES PRIVATE LIMITED",
"NORTH BARRACKPORE MUNICIPALITY",
"NORTH BENGAL CLINIC PVT LTD",
"NORTH BENGAL FEED INDUSTRIES PVT LTD.",
"NORTH BENGAL FOOD PRODUCTS PRIVATE LIMITED",
"NORTH BENGAL HEALTHCARE PRIVATE LIMITED",
"NORTH BENGAL INDUSTRIAL SECURITY SERVICES PRIVATE LIMITED",
"NORTH BENGAL IRON & STEEL PRIVATE LIMITED",
"NORTH BENGAL MANOKAMNA VYAPAR PRIVATE LIMITED",
"NORTH BENGAL MEDICAL COLLEGE & HOSPITAL",
"NORTH BENGAL METAL AND ALLIED INDUSTRIES PRIVATE LIMITED",
"NORTH BENGAL NEURO CENTRE PRIVATE LIMITED",
"NORTH BENGAL POLY FEBS INDUSTRY PRIVATE LIMITED",
"NORTH BENGAL RICE MILLS PRIVATE LIMITED",
"NORTH BENGAL STATE TRANSPORT CORPORATION",
"NORTH BENGAL TRADE & ROLLING INDUSTRIES PVT LTD",
"NORTH BIHAR AGRO AGENCIES PRIVATE LIMITED",
"NORTH BIHAR CONSTRUCTION PVT LTD",
"NORTH BIHAR HIGHWAY LIMITED.",
"NORTH BURDWAN RICE MILL PRIVATE LIMITED",
"NORTH CENTRAL RAILWAY",
"NORTH CHENNAI POWER COMPANY LIMITED",
"NORTH CITY DIAGNOSTIC CENTRE PRIVATE LIMITED",
"NORTH CITY HOSPITAL & NEURO INSTITUTE PRIVATE LIMITED",
"NORTH COASTAL INTEGRATED FOOD PARK PRIVATE LIMITED",
"NORTH COTT GINNING AND TRADING COMPANY PRIVATE LIMITED",
"NORTH DELHI MUNICIPAL CORPORATION",
"NORTH DELHI NURSING HOME PRIVATE LIMITED",
"NORTH DINAJPUR TEA AGRO PRIVATE LIMITED",
"NORTH EAST AGROVET PRIVATE LIMITED",
"NORTH EAST CARRIERS PRIVATE LIMITED",
"NORTH EAST COMMUNICATIONS PRIVATE LIMITED",
"NORTH EAST CONTRACTORS PRIVATE LIMITED",
"NORTH EAST DISTRIBUTORS PRIVATE LIMITED",
"NORTH EAST ENVIRO TECH PRIVATE LIMITED",
"NORTH EAST FERRO ALLOYS COMPANY PRIVATE LIMITED",
"NORTH EAST GARMENTS PRIVATE LIMITED",
"NORTH EAST HEALTH CARE PRIVATE LIMITED",
"NORTH EAST HEALTH CITY PRIVATE LIMITED",
"NORTH EAST HEALTHCARE PRIVATE LIMITED",
"NORTH EAST IMPEX PRIVATE LIMITED",
"NORTH EAST INFRABUILD PRIVATE LIMITED",
"NORTH EAST IODISED SALT PRIVATE LIMITED",
"NORTH EAST MEDICAL CARE AND RESEARCH CENTRE PRIVATE LIMITED",
"NORTH EAST MEGA FOOD PARK LIMITED",
"NORTH EAST NUTRIENTS PRIVATE LIMITED",
"NORTH EAST ONCO CARE LIMITED",
"NORTH EAST ORGANISED FLORITECH PRIVATE LIMITED",
"NORTH EAST PACKAGING PRIVATE LIMITED",
"NORTH EAST PLANTATIONS & COMMERCIAL PRIVATE LIMITED",
"NORTH EAST POULTRY HOUSE PRIVATE LIMITED",
"NORTH EAST POWER LINE INDUSTRIES",
"NORTH EAST ROOFING PRIVATE LIMITED",
"NORTH EAST SMALL FINANCE BANK LIMITED",
"NORTH EAST TRANSMISSION COMPANY LIMITED",
"NORTH EASTERN CABLES PRIVATE LIMITED",
"NORTH EASTERN CARRYING CORPN.LIMITED",
"NORTH EASTERN DEVELOPMENT FINANCE CORPORATION LIMITED",
"NORTH EASTERN DRILLING AND WORKOVER SERVICES CO PVT LTD",
"NORTH EASTERN EDUCARE & RESEARCH PRIVATE LIMITED",
"NORTH EASTERN ELECTRIC POWER CORPORATION LIMITED",
"NORTH EASTERN ELECTRICITY SUPPLY COMPANY OF ODISHA LIMITED",
"NORTH EASTERN HANDICRAFTS AND HANDLOOMS DEVELOPMENT CORPORATION LIMITED",
"NORTH EASTERN MEDICAL RESEARCH INSTITUTE LIMITED",
"NORTH EASTERN RAILWAY",
"NORTH EASTERN SECURITY SERVICE (NESS) PRIVATE LIMITED",
"NORTH END FOODS MARKETING PRIVATE LIMITED",
"NORTH EXPRESS LOGISTICS PRIVATE LIMITED",
"NORTH FRESH AGRO COLD CHAIN PRIVATE LIMITED",
"NORTH GUJARAT SAT ISABGUL INDS PRIVATE LIMITED",
"NORTH HEALTH CARE DIAGNOSTICS PRIVATE LIMITED",
"NORTH INDIA FINSERVE PRIVATE LIMITED",
"NORTH INDIA FINSERVE PVT LTD",
"NORTH INDIA HOTELS AND INDUSTRIES PRIVATE LIMITED (TRF. CO PUNJAB TO DELHI)",
"NORTH INDIA ISPAT PRIVATE LIMITED",
"NORTH INDIA LIFE SCIENCE PRIVATE LIMITED",
"NORTH INDIA LPG CYLINDERS LIMITED",
"NORTH INDIA PHARMA PRIVATE LIMITED",
"NORTH INDIA STEEL COMPANY",
"NITCON LIMITED",
"NORTH INDIA TOP COMPANY PRIVATE LIMITED",
"NORTH KARANPURA TRANSCO LIMITED",
"NORTH KARNATAKA ROLLER FLOUR MILLS PRIVATE LIMITED",
"NORTH LAND (INDIA) PRIVATE LTD",
"NORTH LAND AGRI SOLUTIONS PRIVATE LIMITED",
"NORTH LIFE SPACES LLP",
"NORTH POINT HOSPITALS PRIVATE LIMITED",
"NORTH POINT MEDICARE & RESEARCH CENTRE PRIVATE LIMITED",
"NORTH POINT RESIDENTIAL SCHOOL",
"NORTH POLE BUILDERS PRIVATE LIMITED",
"NORTH POLE COOLING SYSTEM PRIVATE LIMITED",
"NORTH PROPERTY DEVELOPERS LLP",
"NORTH SATELLITE LINK PVT.LTD.",
"NORTH SHORE TECHNOLOGIES PRIVATE LIMITED",
"NORTH SOUTH EYE CARE ASSOCIATES PRIVATE LIMITED",
"NORTH SOUTH MARITIME (INDIA) PRIVATE LIMITED",
"NORTH STAR DIAGNOSTICS PRIVATE LIMITED",
"NORTH STAR ENGINEERING SERVICES PRIVATE LIMITED",
"NORTH STAR TECHNO SERVICES PRIVATE LIMITED",
"NORTH STREET COOLING TOWERS PRIVATE LIMITED",
"NORTH SUBURBAN HOSPITAL",
"NORTH TOWN ESTATES PRIVATE LIMITED",
"NORTH TUKVAR TEA COMPANY LIMITED",
"NORTH WEST CARRYING COMPANY LLP",
"NORTH WEST GASES PRIVATE LIMITED",
"NORTH WEST INDUSTRIES PRIVATE LIMITED",
"NORTH WEST TRANSWAYS PRIVATE LIMITED",
"NORTH WESTERN EDUCATION SERVICES PRIVATE LIMITED",
"NORTH WESTERN INDIA LOGISTICS PRIVATE LIMITED.",
"NORTH WESTERN RAILWAY",
"NORTH WESTERN RAILWAY JAIPUR",
"NORTH WIND EXIM PRIVATE LIMITED",
"NORTHAKROSS SYNTEX PRIVATE LIMITED",
"NORTHAKROSS TECHNOLOGIES PRIVATE LIMITED",
"NORTHALLEY INDIA PRIVATE LIMITED",
"NORTHBENGAL CEMENT CO LIMITED",
"NORTHBOUND INVESTMENT ADVISORS PRIVATE LIMITED",
"NORTHBROOK JUTE COMPANY LIMITED",
"NORTHCAP SERVICES PRIVATE LIMITED",
"NORTHCORP SOFTWARE PRIVATE LIMITED",
"NORTHCOTE NURSING HOME PRIVATE LIMITED",
"NORTHCRED SERVICES PRIVATE LIMITED",
"NORTHEAST BROKING SERVICES LIMITED",
"NORTHEAST DATAA NETWORK PRIVATE LIMITED",
"NORTHEAST FRONTIER RAILWAY",
"NORTH-EAST INFRASTRUCTURE PRIVATE LIMITED",
"NORTHEAST INITIATIVE DEVELOPMENT AGENCY",
"NORTHEAST TRAVELS & TRANSPORT LIMITED",
"NORTHEAST UTILITIES",
"NORTHEN RAILWAY",
"NORTHEREN INDIA INSTITUTEOF FASHION TECHNOLOGY",
"NORTHERLY AUTOMOTIVE SOLUTIONS PRIVATE LIMITED",
"NORTHERN ALLIANCE PRIVATE LIMITED",
"NORTHERN ALLOYS BHAVNAGAR LIMITED",
"NORTHERN ANIMATED ANIMAL FEED PVT LTD",
"NORTHERN ARC CAPITAL LIMITED",
"NORTHERN ARC FOUNDATION",
"NORTHERN ARC INVESTMENT MANAGERS PRIVATE LIMITED",
"NORTHERN AROMATICS LIMITED.",
"NORTHERN AROMATICS PRIVATE LIMITED.",
"NORTHERN BENGAL TEA CORPN LTD",
"NORTHERN BOILER AND INDUSTRIES PRIVATE LIMITED",
"NORTHERN CERAMICS PRIVATE LIMITED",
"NORTHERN COALFIELDS LIMITED",
"NORTHERN CONSUMABLES PRIVATE LIMITED",
"NORTHERN CREDIT AND COLLECTION BUSINESS PRIVATE LIMITED",
"NORTHERN DOORS PRIVATE LIMITED",
"NORTHERN ELECTRIC CABLES PRIVATE LIMITED",
"NORTHERN EXIM PRIVATE LIMITED TFR. FROM KANPUR TO DELHI",
"NORTHERN FRONTIER RAILWAY NFR",
"NORTHERN HOSPITALITY PRIVATE LIMITED",
"NORTHERN INDIA CYCO PARTS PRIVATE LIMITED",
"NORTHERN INDIA HOTELSLIMITED",
"NORTHERN INDIA LEATHER CLOTH MANUFACTURING COMPANY PRIVATE LIMITED",
"NORTHERN INDIA TRADING CO",
"NORTHERN INFRACON INDIA PRIVATE LIMITED",
"NORTHERN INSECTICIDES PRIVATE LIMITED",
"NORTHERN LIGHT HOSPITAL & RESEARCH CENTRE PRIVATE LIMITED",
"NORTHERN LIGHTS SECURECOM PRIVATE LIMITED",
"NORTHERN LIGHTS TECHNOLOGY DEVELOPMENT CHENNAI PRIVATE LIMITED",
"NORTHERN LUBE TECHNOLOGY PRIVATE LIMITED",
"NORTHERN MARINE MANAGEMENT (INDIA) PRIVATE LIMITED",
"NORTHERN MEDI AIDS (INDIA) PRIVATE LIMITED",
"NORTHERN METALS PRIVATE LIMITED",
"NORTHERN MOTORS PRIVATE LIMITED",
"NORTHERN OPERATING SERVICES PRIVATE LIMITED",
"NORTHERN OPERATING SOLUTIONS PRIVATE LIMITED",
"NORTHERN POWER DISTRIBUTION COMPANY OF TELANGANA LIMITED",
"NORTHERN RAILWAY",
"NORTHERN SERVICES & SUPPLY CO PVT LTD",
"NORTHERN SKY PROPERTIES PRIVATE LIMITED",
"NORTHERN SOLAIRE PRAKASH PRIVATE LIMITED",
"NORTHERN SPIRITS LIMITED",
"NORTHERN STAR HEIGHTS INFRASTRUCTURE PRIVATE LIMITED",
"NORTHERN STEEL AND GENERAL MILLS PRIVATE LIMITED",
"NORTHERN STRIPS PRIVATE LIMITED",
"NORTHERN TELECOM LIMITED",
"NORTHERN TOOLS & GAUGES PVT LTD",
"NORTHERN TRUST INDIA PRIVATE LIMITED",
"NORTHERN ZONE RAILWAY EMPLOYEES CO-OPERATIVE THRIFT AND CREDIT SOCIETY LIMITED",
"NORTHERNEXPRESS INFRADEVELOPERS PRIVATE LIMITED",
"NORTHEX LOGISTICS PRIVATE LIMITED",
"NORTHGREEN ENERGY PRIVATE LIMITED",
"NORTHINDIA TOURISM PRIVATE LIMITED",
"NORTHKOTPURA PRIMARY SCHOOL",
"NORTHLAB INDIA PRIVATE LIMITED",
"NORTHLAND CONSTRUCTIONS PRIVATE LIMITED",
"NORTHLAND CONTROLS (INDIA) PRIVATE LIMITED",
"NORTHLAND HOLDING COMPANY PRIVATE LIMITED",
"NORTHLAND INTERNATIONAL SCHOOL MANPUR",
"NORTHLITE ENERGY SYSTEMS PRIVATE LIMITED",
"NORTHOUT SOLUTIONS PRIVATE LIMITED",
"NORTHROP GRUMMAN CORPORATION",
"NORTHSHORE FOODS PRIVATE LIMITED",
"NORTHSOUTH GIS INDIA PRIVATE LIMITED",
"NORTHSTAR AUTOCOMP PRIVATE LIMITED",
"NORTHSTAR ENTERTAINMENT PRIVATE LIMITED",
"NORTHSTAR FASTNERS",
"NORTHSTAR SOLAR POWER PRIVATE LIMITED",
"NORTHSTAR TECHNICAL SERVICES PRIVATE LIMITED",
"NORTHWEST ENERGY PRIVATE LIMITED",
"NORTHWEST HEALTHCARE PRIVATE LIMITED",
"NORTHWEST ROADLINES PRIVATE LIMITED",
"NORTHWIND COOL BLOWER LIMITED",
"NORTIS BIOTECH PRIVATE LIMITED",
"NORTON CHEMICALS & SPECIALTIES PRIVATE LIMITED",
"NORTON GASKETS PRIVATE LIMITED",
"NORTON GRANITES AND PROPERTIES PRIVATE LIMITED",
"NORTON PRODUCTS PRIVATE LIMITED",
"NORTONLIFELOCK INDIA PRIVATE LIMITED",
"NORTONLIFELOCK SOFTWARE AND SERVICES INDIA PRIVATE LIMITED",
"NORTONS EXIM PVT LTD",
"NORVERDEN KONSULENT PRIVATE LIMITED",
"NORVIC SHIPPING INDIA PRIVATE LIMITED",
"NORVICK ENTERPRISES PRIVATE LIMITED",
"NORVIK DESIGN PRIVATE LIMITED",
"NORVIK ROCK TECHNOLOGY PRIVATE LIMITED",
"NORVILLE AUTOFLOW INDIA PRIVATE LIMITED",
"NORWAYSTAR INDIA PRIVATE LIMITED",
"NORWEGAIN CRUISE LINE",
"NORWEST INDUSTRIES LIMITED",
"NORWICH CLINICAL SERVICES PRIVATE LIMITED",
"NORWIN TECHNOLOGIES INDIA PRIVATE LIMITED",
"NORWOOD HOLIDAYS PRIVATE LIMITED",
"NORZONE TECHNOS (OPC) PRIVATE LIMITED",
"NOS2 RESEARCH & DEVELOPMENT PRIVATE LIMITED",
"NOSCH LABS PRIVATE LIMITED",
"NOSHE OCEANIC PRIVATE LIMITED",
"NOSTALGIA BUSINESS CORPORATE SERVICES PRIVATE LIMITED",
"NOSTALGIC FOODS RETAIL PRIVATE LIMITED",
"NOSTER ASSOCIATES PRIVATE LIMITED",
"NOSTRI DESIGN CONSULTANTS PRIVATE LIMITED",
"NOSTRUM FASHION PRIVATE LIMITED",
"NOSTRUM REMEDIES PRIVATE LIMITED",
"NOSTRUM SURFACE PRODUCTS PRIVATE LIMITED",
"NOTA BENE GLOBAL SERVICES PRIVATE LIMITED",
"NOTANDAS GEMS PRIVATE LIMITED",
"NOTANDAS JEWELLERS PRIVATE LIMITED",
"NOTANDAS REALTY PRIVATE LIMITED",
"NOTCHUP TOOLING PRIVATE LIMITED",
"NOTION ONLINE SOLUTIONS PRIVATE LIMITED",
"NOTION PRESS MEDIA PRIVATE LIMITED",
"NOTIONAL SYSTEMS PRIVATE LIMITED",
"NOTRE DAME SCHOOL",
"NOTROX RESEARCH PRIVATE LIMITED",
"NOTUS INFRASTRUCTURE LIMITED",
"NOU VENTURES PRIVATE LIMITED",
"NOUAM FINANCIAL CONSULTANTS PRIVATE LIMITED",
"NOURISH DEVELOPERS PRIVATE LIMITED",
"NOURISH ORGANIC FOODS PRIVATE LIMITED",
"NOURISH PHARMACEUTICAL PRIVATE LIMITED",
"NOURISHCO BEVERAGES LIMITED",
"NOURISHING FOODS PRIVATE LIMITED",
"NOURYON CHEMICALS INDIA PRIVATE LIMITED",
"NOUS INFOSOLUTIONS LLP",
"NOUS INFOSYSTEMS PVT.LTD",
"NOUVEAU BUSINESS STRATEGY (OPC) PRIVATE LIMITED",
"NOUVEAU DIAMONDS LLP",
"NOUVEAU GLOBAL VENTURES LIMITED",
"NOUVEAU LABS PRIVATE LIMITED",
"NOUVEAU MEDICAMENT PRIVATE LIMITED",
"NOUVEAUX INDUSTRIES PRIVATE LIMITED",
"NOUVEL FACILITIES PRIVATE LIMITED",
"NOUVELLE SECURITIES PRIVATE LIMITED",
"NOUVELLE TEA PRIVATE LIMITED",
"NOUVIO LIFESTYLE PRIVATE LIMITED",
"NOV INDIA PRIVATE LIMITED",
"NOV MFG INDIA PRIVATE LIMITED",
"NOVA AGRI SCIENCES PRIVATE LIMITED",
"NOVA AGRI TECH PRIVATE LIMITED",
"NOVA AGRITECH PRIVATE LIMITED",
"NOVA BATTERIES PRIVATE LIMITED",
"NOVA BIOLOGICAL SYSTEMS PRIVATE LIMITED",
"NOVA BULK HANDLERS PRIVATE LIMITED",
"NOVA CAPITAL ADVISORS PRIVATE LIMITED",
"NOVA CARBONS INDIA PRIVATE LIMITED",
"NOVA CBRN TECHNOLOGIES PRIVATE LIMITED",
"NOVA CHEMDRUGS PRIVATE LIMITED",
"NOVA CID PVT LTD",
"NOVA CINEMAZ PRIVATE LIMITED",
"NOVA COSMETICS PRIVATE LIMITED",
"NOVA DYESTUFF INDUSTRIES PRIVATE LIMITED",
"NOVA ENT HEAD & NECK HOSPITAL PRIVATE LIMITED",
"NOVA FERTILITY EAST PRIVATE LIMITED",
"NOVA FLEXIPACK PRIVATE LIMITED",
"NOVA FORMWORKS PRIVATE LIMITED",
"NOVA GAS TECHNIQUES PRIVATE LIMITED",
"NOVA GLOBAL MEDICARE PRIVATE LIMITED",
"NOVA HOME APPLIANCES PRIVATE LIMITED",
"NOVA HOSPITAL LIMITED",
"NOVA HUMAN RESOURCES OUTSOURCING PRIVATE LIMITED",
"NOVA INDUSTRIAL GASES PRIVATE LIMITED",
"NOVA INTEGRATED SYSTEMS LIMITED",
"NOVA INTERCHEM PRIVATE LIMITED",
"NOVA IRON AND STEEL LIMITED",
"NOVA LIFE SPACE PRIVATE LIMITED",
"NOVA MARKETING PRIVATE LIMITED",
"NOVA MEDICAL CENTERS PRIVATE LIMITED",
"NOVA NUTRI FOODS PRIVATE LIMITED",
"NOVA ORTHOALIGN PRIVATE LIMITED",
"NOVA PET PRIVATE LIMITED",
"NOVA POLYCHEM PRIVATE LIMITED",
"NOVA PUBLICATIONS",
"NOVA PUBLICATIONS & PRINTERS PRIVATE LIMITED",
"NOVA PULSE IVF CLINIC AHMEDABAD PRIVATE LIMITED",
"NOVA PULSE IVF CLINIC PRIVATE LIMITED",
"NOVA SANCOALE SERVICES PRIVATE LIMITED",
"NOVA SEA FOODS PRIVATE LIMITED",
"NOVA SECURITY SERVICES PVT LIMITED",
"NOVA SPACES PRIVATE LIMITED",
"NOVA STREET PRIVATE LIMITED",
"NOVA SUD PHARMACEUTICALS PRIVATE LIMITED",
"NOVA SURFACE CARE CENTRE PRIVATE LIMITED",
"NOVA SYNTHETIC LIMITED",
"NOVA TECHNOCAST PRIVATE LIMITED",
"NOVA TECHSET LIMITED",
"NOVA TECHSET PRIVATE LIMITED",
"NOVA TEXTILES PRIVATE LIMITED",
"NOVA TRANSFERS PRIVATE LIMITED",
"NOVA WEATHERWORKS ACR INDIA PRIVATE LIMITED",
"NOVA WEB INNOVATIONS PRIVATE LIMITED",
"NOVAAIR PRIVATE LIMITED",
"NOVAAIR TECHNOLOGIES PRIVATE LIMITED",
"NOVABENEFITS PRIVATE LIMITED",
"NOVAC ADVISORS PRIVATE LIMITED",
"NOVAC TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"NOVACARE APPLIANCES PRIVATE LIMITED",
"NOVACARE HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"NOVACEPT ENGINEERING SOLUTIONS PRIVATE LIMITED",
"NOVACOM DIGITRONICS PRIVATE LIMITED",
"NOVACOM FIRE AND SECURITY TECHNICS PRIVATE LIMITED",
"NOVACON INFRASTRUCTURE & TRADING PRIVATE LIMITED",
"NOVADERS LLP",
"NOVAGEN HEALTHCARE PRIVATE LIMITED",
"NOVAK WIRES PRIVATE LIMITED",
"NOVAL FACILITY SERVICES",
"NOVAL MILK PRODUCTS PRIVATE LIMITED",
"NOVALAB HEALTH CARE PRIVATE LIMITED",
"NOVALEE TEXOFAB PRIVATE LIMITED",
"NOVALIFE HOSPITALS LIMITED",
"NOVALNET SOFTWARE SOLUTIONS WORLDWIDE PRIVATE LIMITED",
"NOVAMARK SPECIALITIES PRIVATE LIMITED",
"NOVAMED ORTHOTICS PRIVATE LIMITED",
"NOVANATIVE PLASTIX SOLUTIONS PRIVATE LIMITED",
"NOVANET LIMITED",
"NOVAPHENE SPECIALITIES PRIVATE LIMITED",
"NOVARAD INDIA PRIVATE LIMITED",
"NOVARCH CONSULTANTS INDIA PRIVATE LIMITED",
"NOVARES INDIA AUTOMOTIVE PRIVATE LIMITED",
"NOVARTIS HEALTHCARE PRIVATE LIMITED",
"NOVARTIS INDIA LIMITED",
"NOVASATUM FOODS PRIVATE LIMITED",
"NOVASERRA TECHNOLOGIES PRIVATE LIMITED",
"NOVASOLAR THERMAL SYSTEMS INDIA PRIVATE LIMITED",
"NOVASTAR COMMUNICATION PRIVATE LIMITED",
"NOVASTRID IT VENTURES PRIVATE LIMITED",
"NOVASYS GREENERGY PRIVATE LIMITED",
"NOVATECH AGRO PRODUCTS I PRIVATE LIMITED",
"INCICO INDIA ENGINEERING PRIVATE LIMITED",
"NOVATECH ENVIRO SYSTEMS PRIVATE LIMITED",
"NOVA-TECH FILTERS PRIVATE LIMITED",
"NOVATECH OIL (I) PRIVATE LIMITED",
"NOVATECH POLYMERS PRIVATE LIMITED",
"NOVATECH PROJECTS INDIA PRIVATE. LIMITED.",
"NOVA-TECH REFRACTORIES PRIVATE LIMITED",
"NOVATECH SOFTWARE PRIVATE LIMITED",
"NOVATEK ELECTROENGINEERS PRIVATE LIMITED",
"NOVATEOR RESEARCH LABORATORIES LIMITED",
"NOVATEUR ELECTRICAL & DIGITAL SYSTEMS PRIVATE LIMITED",
"NOVATIC COATINGS PRIVATE LIMITED",
"NOVATION AUTOMOTIVE PRIVATE LIMITED",
"NOVATION HUB PRIVATE LIMITED",
"NOVATIS FINOVATIVE LIMITED",
"NOVATIS HYGIENE PRODUCTS INDIA PRIVATE LIMITED",
"NOVATIUM SOLUTIONS PRIVATE LIMITED",
"NOVATK TECHNOGLOBAL PRIVATE LIMITED",
"NOVATRIX DESIGNS PRIVATE LIMITED",
"NOVATURE TECH PRIVATE LIMITED",
"NOVEJOT ABRASIVES PRIVATE LIMITED",
"NOVEL APP SOLUTIONS PRIVATE LIMITED",
"NOVEL ASSEMBLER PRIVATE LIMITED",
"NOVEL AUTOMATION LIMITED",
"NOVEL ELECTRONICS PRIVATE LIMITED",
"NOVEL EXICCON PRIVATE LIMITED",
"NOVEL FACILITY SERVICES PRIVATE LIMITED",
"NOVEL FINANCIAL SOLUTIONS PRIVATE LIMITED",
"NOVEL HATCHERY PRIVATE LIMITED",
"NOVEL INFRAPROJECTS PRIVATE LIMITED",
"NOVEL JEWELS LIMITED",
"NOVEL KIDS",
"NOVEL LINES AND LOGISTICS PRIVATE LIMITED",
"NOVEL LOGITECH CORPORATION PRIVATE LIMITED",
"NOVEL NUTRIENTSS PRIVATE LIMITED",
"NOVEL OFFICE CENTRE LLP",
"NOVEL PATENT SERVICES PRIVATE LIMITED",
"NOVEL SEEDS PRIVATE LIMITED",
"NOVEL SOLUTIONS AND SERVICES PRIVATE LIMITED",
"NOVEL SPENT ACID MANAGEMENT",
"NOVEL SUGAR LIMITED",
"NOVEL SUPPLIERS PVT LTD",
"NOVEL TECHNOPLAST PRIVATE LIMITED",
"NOVEL TELENET PRIVATE LIMITED",
"NOVEL TISSUES PRIVATE LIMITED",
"NOVEL VALVES INDIA PRIVATE LIMITED",
"NOVEL VERITAS PRIVATE LIMITED",
"NOVELCO TECHNOLOGIES PRIVATE LIMITED",
"NOVELITE INDIA PRIVATE LIMITED",
"NOVELL INDIA PRIVATE LIMITED",
"NOVELLERP SOLUTIONS PRIVATE LIMITED",
"NOVELLOGLOBE ENTERPRISES PRIVATE LIMITED",
"NOVEL-SUPERTV DIGI TECH PRIVATE LIMITED",
"NOVELTECH FEEDS PRIVATE LIMITED",
"NOVELTEX PRIVATE LIMITED",
"NOVELTIES AIR GASES PRIVATE LIMITED",
"NOVELTY ASSOCIATES PRIVATE LIMITED",
"NOVELTY AUTO SALES PRIVATE LIMITED",
"NOVELTY CARS PRIVATE LIMITED",
"NOVELTY CLOTHING PRIVATE LIMITED",
"NOVELTY DRESS EMPORIUM PRIVATE LIMITED",
"NOVELTY HEALTHSHINE PRIVATE LIMITED",
"NOVELTY PROPERTIES AND INVESTMENT PRIVATE LIMITED",
"NOVELTY REDDY AND REDDY MOTORS PRIVATE LIMITED",
"NOVELTY WHEELS PRIVATE LIMITED",
"NOVELVISTA LEARNING SOLUTIONS PRIVATE LIMITED",
"NOVELVOX SOFTWARE INDIA PRIVATE LIMITED",
"NOVEM ADVISORS PRIVATE LIMITED",
"NOVEM SOLUTIONS PRIVATE LIMITED",
"NOVEMBER CONSTRUCTION PRIVATE LIMITED",
"NOVEN LIFESCIENCES PRIVATE LIMITED",
"NOVERGY ENERGY SOLUTIONS PRIVATE LIMITED",
"NOVERTO BUSINESS SERVICES PRIVATE LIMITED",
"NOVETEK CONSULTANTS PRIVATE LIMITED",
"NOVETUZ MARKETING PRIVATE LIMITED",
"NOVEX COMMUNICATIONS PRIVATE LIMITED",
"NOVEX POLY FILMS PRIVATE LIMITED",
"NOVEXIS HEALTHCARE PRIVATE LIMITED",
"NOVEXX SOLUTIONS INDIA PRIVATE LIMITED",
"NOVHO CAREERS PRIVATE LIMITED",
"NOVI DIGITAL ENTERTAINMENT PRIVATE LIMITED",
"NOVICA ARTS AND HANDICRAFTS (INDIA) PRIVATE LIMITED",
"NOVICK BIO-SCIENCES PRIVATE LIMITED",
"NOVICLE TECHNOLOGIES PRIVATE LIMITED",
"NOVIE AGRO INVESTMENTS PRIVATE LIMITED",
"NOVIGO INTEGRATED SERVICES PRIVATE LIMITED",
"NOVIGO PARTNERS PRIVATE LIMITED",
"NOVIGO SOLUTIONS PRIVATE LIMITED",
"NOVIQUE LIFESCIENCES PRIVATE LIMITED",
"NOVIRE TECHNOLOGIES PRIVATE LIMITED",
"NOVISYNC SOLUTIONS INDIA PRIVATE LIMITED",
"NOVITA HEALTHCARE PRIVATE LIMITED",
"NOVITATES TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"NOVITIUM LABS PRIVATE LIMITED",
"NOVIUS TECHNOLOGIES INDIA PRIVATE LIMITED",
"NOVO EXCIPIENTS PRIVATE LIMITED",
"NOVO HEALTHCARE LIMITED",
"NOVO INSURANCE BROKING SERVICES PRIVATE LIMITED",
"NOVO IRESC INDIA PRIVATE LIMITED",
"NOVO MANAGEMENT CONSULTING PRIVATE LIMITED",
"NOVO MEDI SCIENCES PRIVATE LIMITED",
"NOVO MEDIX PHARMACEUTICAL PRIVATE LIMITED",
"NOVO NORDISK INDIA PRIVATE LIMITED",
"NOVO NORDISK SERVICE CENTRE INDIA PRIVATE LIMITED",
"NOVO TEXCOM PRIVATE LIMITED",
"NOVO THERMOSET PRIVATE LIMITED",
"NOVOCHEM RESOURCES PRIVATE LIMITED",
"NOVOFLEX INDUSTRIES PRIVATE LIMITED",
"NOVOFLEX MARKETING PRIVATE LIMITED",
"NOVOGENIE SERVICES PRIVATE LIMITED",
"NOVOGEO ENGITECH PRIVATE LIMITED",
"NOVOGOLD SEEDS PRIVATE LIMITED",
"NOVOINVENT SOFTWARE PRIVATE LIMITED",
"NOVOLIFE HEALTHCARE PRIVATE LIMITED",
"NOVOMED INCORPORATION PRIVATE LIMITED",
"NOVOPAN INDUSTRIES LIMITED",
"NOVOPAN INDUSTRIES PRIVATE LIMITED",
"NOVOPAY SOLUTIONS PRIVATE LIMITED",
"NOVOPHARM LIFE SCIENCES PRIVATE LIMITED",
"NOVORISE FINTECH INDIA PRIVATE LIMITED",
"NOVOSYNTH INDUSTRIES PRIVATE LIMITED",
"NOVOSYS LIFE SCIENCES PRIVATE LIMITED",
"NOVOTECH CLINICAL RESEARCH INDIA PRIVATE LIMITED",
"NOVOTECH STEEL & ALLOYS PRIVATE LIMITED",
"NOVOTEL AHMEDABAD",
"NOVOTEL GOA HOTELS AND RESORTS",
"NOVOTEL IBIS BENGALURU OUTER RING ROAD",
"NOVOTEL KOLKATA",
"NOVOTEL MUMBAI JUHU BEACH",
"NOVOZYMES SOUTH ASIA PRIVATE LIMITED",
"NOVUM STRUCTURES INDIA PRIVATE LIMITED",
"NOVUMLAKE PARTNERS PRIVATE LIMITED",
"NOVUS ANIMAL NUTRITION (INDIA) PRIVATE LIMITED",
"NOVUS ARC DESIGN PRIVATE LIMITED",
"NOVUS CARGO SOLUTIONS PRIVATE LIMITED",
"NOVUS COMPUTRONICS PRIVATE LIMITED",
"NOVUS FORGE & CAST PRIVATE LIMITED",
"NOVUS GREEN ENERGY SYSTEMS LIMITED",
"NOVUS INSIGHTS PRIVATE LIMITED",
"NOVUS LIFE SCIENCES PRIVATE LIMITED",
"NOVUS NEXUS INDIA PRIVATE LIMITED",
"NOVUS PLATFORM OPC PRIVATE LIMITED",
"NOVUS PROFESSIONAL SERVICES PRIVATE LIMITED",
"NOVUS RESEARCH AND ADVISORY INTERNATIONAL PRIVATE LIMITED",
"NOVUS SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED",
"NOVUS TECHNOLOGIES PRIVATE LIMITED",
"NOVVAPAVE BITUMEN INDIA PRIVATE LIMITED",
"NOW DISTRIBUTION INDIA PRIVATE LIMITED",
"NOW REALTY PROMOTERS & BUILDERS PRIVATE LIMITED",
"NOWAPPS TECHNOLOGIES PRIVATE LIMITED",
"NOWDEAL TECHNOLOGIES PRIVATE LIMITED",
"NOWELCO INDUSTRIES PRIVATE LIMITED",
"NOWFLOATS TECHNOLOGIES LIMITED",
"NOWGRAY IT SERVICES PRIVATE LIMITED",
"NOWONEXT PRIVATE LIMITED",
"NOWOTEK TEXTILES PRIVATE LIMITED",
"NOWRANGROY AGRO PRIVATE LIMITED",
"NOWROSJEE WADIA AND SONS LIMITED",
"NOWROSJEE WADIA COLLEGE PUNE",
"NOWROSJEE WADIA MATERNITY HOSPITAL",
"NOX ENGINEERING PRIVATE LIMITED",
"NOXMAT COMBUSTION TECHNOLOGY PRIVATE LIMITED",
"NOXX & CHEF'S DECK PRIVATE LIMITED",
"NOYA LIFESTYLES PRIVATE LIMITED",
"NOYAL COLLEGE OF INTERIOR DESIGNING",
"NOYBL INFOTECH PRIVATE LIMITED",
"NP BUILDWELL PRIVATE LIMITED",
"NP ENTERPRISES PRIVATE LIMITED",
"NP INFRAAGRO PROJECTS PRIVATE LIMITED",
"NP INFRAPROJECTS INDIA PRIVATE LIMITED",
"NP RAM KRISHNA ENTERPRISES PRIVATE LIMITED",
"NP TEXTILES",
"NPA CONSULTANTS PRIVATE LIMITED",
"NPB CONSULTANTS PRIVATE LIMITED",
"NPC PLASTO PRODUCTS PRIVATE LIMITED",
"NPCC ENGINEERING PRIVATE LIMITED",
"NPCI BHARAT BILLPAY LIMITED",
"NPCI INTERNATIONAL PAYMENTS LIMITED",
"NPCIL - INDIANOIL NUCLEAR ENERGY CORPORATION LIMITED",
"NPEC CONSULTANCY PRIVATE LIMITED",
"NPF POLYFILMS PRIVATE LIMITED",
"NPG RICE MILL PRIVATE LIMITED",
"NPH TECHNOLOGY PRIVATE LIMITED",
"NPI PAPER & BOARD PRIVATE LIMITED",
"NPK COATINGS PRIVATE LIMITED",
"NPK COMMERCIAL LTD",
"NPKG TRUEMAN CONSULTANCY PRIVATE LIMITED",
"NPKS MOTORS PRIVATE LIMITED",
"NPL BLUESKY AUTOMOTIVE PRIVATE LIMITED",
"NPL IMPEX PRIVATE LIMITED",
"NPM AQUATIC FISH LINKS PRIVATE LIMITED",
"NPM FRUITS",
"NPM JOBAT-NANPUR PATHWAYS PRIVATE LIMITED",
"NPM MACHINERY PRIVATE LIMITED",
"NPM PHARMA INDUSTRIES PRIVATE LIMITED",
"NPMI PRODUCTS PRIVATE LIMITED",
"NPR AUTO PARTS MANUFACTURING INDIA PRIVATE LIMITED",
"NPR CONNECT PRIVATE LIMITED",
"NPR FINANCE LTD.",
"NPR LOGISTICS PRIVATE LIMITED",
"NPR TECHNOLOGY PRIVATE LIMITED",
"NPRS FINANCIAL SERVICES PRIVATE LIMITED",
"NPS HEALTHCARE PRIVATE LIMITED",
"NPS INTERNATIONAL SCHOOL",
"NPSH DEVELOPERS PRIVATE LIMITED",
"NPSS CONSTRUCTION PRIVATE LIMITED",
"NPT OFFSET PRIVATE LIMITED",
"NPT OVERSEAS PRIVATE LIMITED",
"NPT PAPERS PRIVATE LIMITED",
"NPT TEXTILES PRIVATE LIMITED",
"NPV CORPORATE SERVICES PRIVATE LIMITED",
"NQA CERTIFICATION PRIVATE LIMITED",
"NR BUTTA ENTERPRISES PRIVATE LIMITED",
"NR COMMERCE PRIVATE LIMITED",
"NR EPC PROJECT PRIVATE LIMITED",
"NR FOREX SERVICES PRIVATE LIMITED",
"NR HYTECH ENGINEERS PRIVATE LIMITED",
"NR ISPAT AND POWER PRIVATE LIMITED",
"NR MOTORS PRIVATE LIMITED",
"NR OMNI RETAIL PRIVATE LIMITED",
"NR OVERSEAS EDUCATION AND IMMIGRATION CONSULTANTS PRIVATE LIMITED",
"NR STEEL AND FERRO PRIVATE LIMITED",
"NR SWITCH N RADIO SERVICES PRIVATE LIMITED",
"NR TECHNOSERVE PRIVATE LIMITED",
"NRA HEALTHCARE PRIVATE LIMITED",
"NRACK ACCESSORIES PRIVATE LIMITED",
"NRASTRIYA INTER COLLEGE",
"NRB BEARINGS LIMITED (FULL FLEDGED PUBLIC CO)",
"NRB HYDRAULICS PRIVATE LIMITED",
"NRB INDUSTRIAL BEARINGS LIMITED",
"NRB TRANS PRIVATE LIMITED",
"NRB-IBC BEARINGS PRIVATE LIMITED",
"NRC HQ ARTY CENTRE",
"NRC LIMITED",
"NRCONTAINERS PRIVATE LIMITED",
"NRD ENTERPRISE PVT LTD",
"NRDS MANAGEMENT PRIVATE LIMITED",
"NREACH ONLINE SERVICES PRIVATE LIMITED",
"NRG CONSULTANTS PRIVATE LIMITED",
"NRG CREATIONS PRIVATE LIMITED",
"NRG ENERGY INC.",
"NRG FOODS PRIVATE LIMITED",
"NRG MINCHEM PRIVATE LIMITED",
"NRG TECHNOLOGISTS PRIVATE LIMITED",
"NRI ACADEMY OF SCIENCES",
"NRI AGRITECH PRIVATE LIMITED",
"NRI- BUILDTECH (INDIA) PRIVATE LIMITED",
"NRI EDUCATIONAL SOCIETY",
"NRI GROUP OF INSTITUTIONS",
"NRI INSTITUTE OF TECHNOLOGY",
"NRI MEDICAL COLLEGE",
"NRI ONLINE PRIVATE LIMITED",
"NRI VISION CARE INDIA LIMITED",
"NRI VISION CARE PRIVATE LIMITED",
"NRICH NATURALS PRIVATE LIMITED",
"NRIGHT NUTRITION PRIVATE LIMITED",
"NRIPENDRANATH INSTITUTION",
"NRISINGHA CHANDRA NANDY AND SONS CEMENT PRIVATE LIMITED",
"NRJ ELECTRIC MOTOR VEHICLES PRIVATE LIMITED",
"NRJ HITECH ENGINEERS PRIVATE LIMITED",
"NRJ PHARMACHEM PRIVATE LIMITED",
"NRL CARS PRIVATE LIMITED",
"NRL SEEDS PRIVATE LIMITED",
"NRM CONSULTANTS PRIVATE LIMITED",
"NRM CORPORATE LEASING PRIVATE LIMITED",
"NRM INFRADESIGN PRIVATE LIMITED",
"NRM INTERIOR CONSTRUCTION PRIVATE LIMITED",
"NRM INTERNATIONAL PRIVATE LIMITED",
"NROAD INDIA PRIVATE LIMITED",
"NRP ENTERTAINMENT AND NETWORK PRIVATE LIMITED",
"NRP PACKERS PRIVATE LIMITED",
"NRP PROJECTS PRIVATE LIMITED",
"NRS AGRO PRIVATE LIMITED",
"NRS BRIDGE CONSTRUCTION INDIA PRIVATE LIMITED",
"NRS EXIM PRIVATE LIMITED",
"NRS HOSPITALITY PRIVATE LIMITED",
"NRS KITCHEN PRIVATE LIMITED",
"NRS MERCANTILE SERVICES PVT LTD",
"NRS SOFTWARE GLOBAL PRIVATE LIMITED",
"NRSS XXIX TRANSMISSION LIMITED",
"NRSS XXXI (B) TRANSMISSION LIMITED",
"NRSS XXXVI TRANSMISSION LIMITED",
"NRTMT (INDIA) PRIVATE LIMITED",
"NRTU FOUNDATION",
"NRU VENTURES PRIVATE LIMITED",
"NRUPATUNGA DEGREE COLLEGE",
"NRUSINHA VIDHYA MANDIR PS WALUJ",
"NRV DESIGNX PRIVATE LIMITED",
"NRV LOGISTICS PRIVATE LIMITED",
"NRV YARNS PRIVATE LIMITED",
"NRVS STEELS LIMITED",
"NS AUTOCARE (OPC) PRIVATE LIMITED",
"NS EVENT MANAGEMENT PRIVATE LIMITED",
"NS INFRAPROJECTS PRIVATE LIMITED",
"NS INSTRUMENTS INDIA PRIVATE LIMITED",
"NS INTERIOR CONTRACTS PRIVATE LIMITED",
"NS MATRIX SERVICES PRIVATE LIMITED",
"NS MINT PRODUCTS PRIVATE LIMITED",
"NS ROLLING STEEL PRIVATE LIMITED",
"NS TOURS & TRAVELS PRIVATE LIMITED",
"NS TRANSMISSION PRIVATE LIMITED",
"NS TRANSPORT PRIVATE LIMITED",
"NS4 HAIR & BEAUTY SALON",
"NSA BUILDTECH PRIVATE LIMITED",
"NSA ENTERPRISES PRIVATE LIMITED",
"NSB AUTOMATION INDIA PRIVATE LIMITED",
"NSB BPO SOLUTIONS LIMITED",
"NSB BPO SOLUTIONS PRIVATE LIMITED",
"NSBP & CO. (CHARTERED ACCOUNTANTS)",
"NSBP SHIPPING & LOGISTICS PRIVATE LIMITED",
"NSC INFRATECH PRIVATE LIMITED",
"NSC INTERNATIONAL PRIVATE LIMITED",
"NSC PROJECTS PRIVATE LIMITED",
"NSC SERVICE SENTER",
"NSCB GIRLS HOSTEL SAJJANPUR",
"NSD IMPEX LIMITED",
"NSD INFOSERVICES PRIVATE LIMITED",
"NSD PRINTERS PRIVATE LIMITED",
"NSD ROOFING INDUSTRIES PRIVATE LIMITED",
"NSDL DATABASE MANAGEMENT LIMITED",
"NSDL PAYMENTS BANK LIMITED",
"NSE ACADEMY LIMITED",
"NSE CLEARING LIMITED",
"NSE DATA & ANALYTICS LIMITED",
"NSE FOUNDATION",
"NSE IFSC LIMITED",
"NSE INDICES LIMITED",
"NSE INFOTECH SERVICES LIMITED",
"NSE INVESTMENTS LIMITED",
"NSEG PRIVATE LIMITED",
"NSEIT LIMITED",
"NSF SAFETY AND CERTIFICATIONS INDIA PRIVATE LIMITED",
"NSG SYSTEM PRIVATE LIMITED",
"NSH FREIGHTERS PRIVATE LIMITED",
"NSH NAVIGATOR PRIVATE LIMITED",
"NSHC DERMA AESTHETICS PRIVATE LIMITED",
"NSHM KNOWLEDGE CAMPUS",
"NSHM UDAAN SKILLS PRIVATE LIMITED",
"NSI CASTINGS PRIVATE LIMITED",
"NSI EQUIPMENTS PRIVATE LIMITED",
"NSI INFINIUM GLOBAL PRIVATE LIMITED",
"NSI TECHNOLOGIES INDIA PRIVATE LIMITED",
"NSIB MANAGEMENT SERVICES PRIVATE LIMITED",
"NSIB SECURITY SERVICES PRIVATE LIMITED",
"NSIGHT SOLUTIONS PRIVATE LIMITED",
"NSIL EXPORTS LIMITED",
"NSJ PRAYOG LIFE SCIENCES PRIVATE LIMITED",
"NSK BEARINGS INDIA PRIVATE LIMITED",
"NSK HOME PRODUCTS PRIVATE LIMITED",
"NSK SFS PRIVATE LIMITED",
"NSK SHIP MANAGEMENT PRIVATE LIMITED",
"NSL CONSTRUCTIONS PRIVATE LIMITED",
"NSL COTTON CORPORATION PRIVATE LIMITED",
"NSL ENERGY VENTURES PRIVATE LIMITED",
"NSL ESTATES PRIVATE LIMITED",
"NSL FASHION PRIVATE LIMITED",
"NSL FERTILIZER VENTURES PRIVATE LIMITED",
"NSL RENEWABLE POWER PRIVATE LIMITED",
"NSL SEZ (HYDERABAD) PRIVATE LIMITED",
"NSL SUGARS LIMITED",
"NSL TEXTILES LIMITED",
"NSL WIND POWER COMPANY (KAYATHAR) PRIVATE LIMITED",
"NSL WIND POWER COMPANY (PHOOLWADI) PRIVATE LIMITED",
"NSL WIND POWER COMPANY (SATARA) PRIVATE LIMITED",
"NSL WIND POWER COMPANY (SAYAMALAI) PRIVATE LIMITED",
"NSM AUTOMATION PRIVATE LIMITED",
"NSM BODY WORKS PRIVATE LIMITED",
"NSM FINE JEWELLERY PRIVATE LIMITED",
"NSM POLYMERS PRIVATE LIMITED",
"NSM SERVICES PRIVATE LIMITED",
"NSM TECHNOLOGIES PRIVATE LIMITED",
"NSN MATRICULATION HIGHER SECONDARY SCHOOL",
"NSN MEMORIAL SENIOR SECONDARY SCHOOL",
"NSN PACKPRINTS PRIVATE LIMITED",
"NSO SERVICES PRIVATE LIMITED",
"NSP BIOSCIENCES PRIVATE LIMITED",
"NSP HOSPITECH INDIA PRIVATE LIMITED",
"NSP PUMPS PRIVATE LIMITED",
"NSP VEHICLES PRIVATE LIMITED",
"NSPB SHAHEED BHAGAT SINGH EYE HOSPITAL",
"NSPIRA MANAGEMENT SERVICES PRIVATE LIMITED",
"NSPLUS TECHNOLOGY PRIVATE LIMITED",
"NSPP INDIA PRIVATE LIMITED",
"NSPR CONSTRUCTIONS INDIA PRIVATE LIMITED",
"NSPR KP ROAD PROJECTS PRIVATE LIMITED",
"NSQUAREIT OFFSHORE AGENCY",
"NSR AND FACILITY SERVICES PRIVATE LIMITED",
"NSR AQUA FARMS PRIVATE LIMITED",
"NSR HOUSING PRIVATE LIMITED",
"NSR INFORMATION SYSTEMS INDIA PRIVATE LIMITED",
"NSR INTERIORS PRIVATE LIMITED",
"NSR INTERNATIONAL PRIVATE LIMITED",
"NSR LIBER PRIVATE LIMITED",
"NSRK RECREATIONS PRIVATE LIMITED",
"NSS COLLEGE OF ENGINEERING",
"NSS SHIPPING PRIVATE LIMITED",
"NSS STORES SUPPLY AGENCY PRIVATE LIMITED",
"NSS TRADE (INDIA) PRIVATE LIMITED",
"NSSE FAB PRIVATE LIMITED",
"NSSPL SUVIDHA SERVICES PRIVATE LIMITED",
"NST LASER TECHNO PRIVATE LIMITED",
"NST PRIVATE LIMITED",
"NSTARX INDIA PRIVATE LIMITED",
"NSURE RELIABLE POWER SOLUTIONS PRIVATE LIMITED",
"NSV INVESTMENTS PRIVATE LIMITED",
"NSV TRADING PRIVATE LIMITED",
"NSVP INDUCTION CASTING PRIVATE LIMITED",
"NSW AUDIO ACCESSORIES PRIVATE LIMITED",
"NSW INDIA LIMITED",
"NSWM PRIVATE LIMITED",
"NT DIAGNOSTIC CENTRE PRIVATE LIMITED",
"NT HOLDINGS PRIVATE LIMITED",
"NT INNOVATIONS PRIVATE LIMITED",
"NT N-TECH SOLUTIONS PRIVATE LIMITED",
"NTARA RESOURCE MANAGEMENT SERVICES PRIVATE LIMITED",
"NTB INTERNATIONAL PRIVATE LIMITED",
"NTC ENGINEERING SERVICES PRIVATE LIMITED",
"NTC FINANCE PRIVATE LIMITED",
"NTC GOLDEN FORWARDERS PRIVATE LIMITED",
"NTC INDUSTRIES LIMITED",
"NTC INFRASTRUCTURE AND ENGINEERING PRIVATE LIMITED",
"NTC LOGISTICS INDIA PRIVATE LIMITED",
"NTC NIDHI LIMITED",
"NTC SHIPPING SERVICES PRIVATE LIMITED",
"NTC SOFTECH INDIA PRIVATE LIMITED",
"NTC STAFF TRAINING COLLEGE - 641 004",
"NTC SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED",
"NTC VENTURES PRIVATE LIMITED",
"NTCIL REAL ESTATE PRIVATE LIMITED",
"NTDC PRIVATE LIMITED",
"NTE INDIA PRIVATE LIMITED",
"NTEC INFRATEL PRIVATE LIMITED",
"N-TECH INFOSOLUTIONS PRIVATE LIMITED",
"NTECK AUTOMOTIVE PRIVATE LIMITED",
"NTEGRATED SHIPPING PRIVATE LIMITED",
"NTEK INDUSTRIAL PIPING PRIVATE LIMITED",
"NTERONE INDIA PRIVATE LIMITED",
"NTERPORT IMPEX PRIVATE LIMITED",
"NTEXX TEXTILES PRIVATE LIMITED",
"NTF HOLDINGS PRIVATE LIMITED",
"NTF INDIA PRIVATE LIMITED",
"NTH PIXEL FACTORY PRIVATE LIMITED",
"NTHRIVE GLOBAL SOLUTIONS PRIVATE LIMITED",
"NTI TECHNOLOGIES PRIVATE LIMITED",
"N-TIER BUSINESS SOLUTIONS PRIVATE LIMITED",
"NTL INDIA PRIVATE LIMITED",
"NTL LOGISTICS INDIA PRIVATE LIMITED",
"NTM SHAWLS PRIVATE LIMITED",
"NTM VEGIORGANIC PRODUCTS PRIVATE LIMITED",
"NTN BEARING INDIA PRIVATE LIMITED",
"NTN LOGISTICS PRIVATE LIMITED",
"NTN NEI MANUFACTURING INDIA PRIVATE LIMITED",
"NTNY TECH WORLD PRIVATE LIMITED",
"NTO LOGISTICS PRIVATE LIMITED",
"NTOP INFOSEC PRIVATE LIMITED",
"NTP TAR PRODUCTS PRIVATE LIMITED",
"NTPC BHEL POWER PROJECTS PRIVATE LIMITED",
"NTPC EDMC WASTE SOLUTIONS PRIVATE LIMITED",
"NTPC ELECTRIC SUPPLY COMPANY LIMITED",
"NTPC GE POWER SERVICES PRIVATE LIMITED",
"NTPC LIMITED",
"NTPC MINING LIMITED",
"NTPC RENEWABLE ENERGY LIMITED",
"NTPC TAMIL NADU ENERGY COMPANY LIMITED",
"NTPC VIDYUT VYAPAR NIGAM LIMITED",
"NTPC-SAIL POWER COMPANY PRIVATE LIMITED",
"NTPL EXPORTS PRIVATE LIMITED",
"NTR HEALTH UNIVERSITY",
"NTR MEMORIAL TRUST",
"NTRC INFRAPROJECTS INDIA PRIVATE LIMITED",
"NTRIX INNOVATIONS PRIVATE LIMITED",
"NTRM INTERIORS PRIVATE LIMITED",
"NTRUST INFOTECH PRIVATE LIMITED",
"NTRUST INSURANCE BROCKING SERVICES PRIVATE LIMITED",
"NTS AUTOMATION LABS PRIVATE LIMITED",
"NTS HOSPITALITY PRIVATE LIMITED",
"NTS NAVRATTAN JEWELLERS PRIVATE LIMITED",
"NTS SCAFFOLDINGS PRIVATE LIMITED",
"NTS TECHNOLOGY SERVICES PRIVATE LIMITED",
"NTT CLOUD INFRASTRUCTURE INDIA PRIVATE LIMITED",
"NTT COMMUNICATIONS INDIA NETWORK SERVICES PRIVATE LIMITED",
"NTT DATA BUSINESS SOLUTIONS PRIVATE LIMITED",
"NTT DATA FA INSURANCE SYSTEMS INDIA PRIVATE LIMITED",
"NTT DATA GLOBAL DELIVERY SERVICES PRIVATE LIMITED",
"NTT DATA GLOBAL TECHNOLOGY SERVICES PRIVATE LIMITED",
"NTT DATA INFORMATION PROCESSING SERVICES PRIVATE LIMITED",
"NTT DATA PAYMENT SERVICES INDIA PRIVATE LIMITED",
"NTT GLOBAL DATA CENTERS & CLOUD INFRASTRUCTURE INDIA PRIVATE LIMITED",
"NTT GLOBAL DATA CENTERS BOM8 PRIVATE LIMITED",
"NTT GLOBAL NETWORKS PRIVATE LIMITED",
"NTT INDIA DIGITAL BUSINESS SOLUTIONS PRIVATE LIMITED",
"NTT INDIA DIGITAL PRIVATE LIMITED",
"NTT INDIA GDC PRIVATE LIMITED",
"NTT INDIA PRIVATE LIMITED",
"NTT INDIA SOLUTIONS PRIVATE LIMITED",
"NTT MANAGED SERVICES INDIA PRIVATE LIMITED",
"NTT SECURITY INDIA PRIVATE LIMITED",
"NTTF CORP",
"NU BRANDING PRIVATE LIMITED",
"NU CARE MARKETING",
"NU CORK PRODUCTS PVT LTD",
"NU FASHION FOOTWEAR PRIVATE LIMITED",
"NU FOODS PVT LTD",
"NU FUTURE DIGITAL INDIA LIMITED",
"NU GENES PRIVATE LIMITED",
"NU HOSPITALS PRIVATE LIMITED",
"NU HOSPITALS-SOUTH",
"NU INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"NU REALTY GROUP PRIVATE LIMITED",
"NU SKILLS COATERS LLP",
"NU SRI SHYAM PHARMACEUTICALS PRIVATE LIMITED",
"NU VISTA LIMITED",
"NU VU CONAIR PRIVATE LIMITED",
"NU WAY INDUSTRIES PRIVATE LIMITED",
"NUAGE BIZTECH PRIVATE LIMITED",
"NUAGE EDTECH PRIVATE LIMITED",
"NUAGE HEALTH DEVICES PRIVATE LIMITED",
"NUAGE JUTE PROCESSING PRIVATE LIMITED",
"NUAGE TECHSOL PRIVATE LIMITED",
"NUALCO PRIVATE LIMITED",
"NUANCE GROUP (INDIA) PRIVATE LIMITED",
"NUANCE GROUP FASHION AND LUXURY DUTY FREE PRIVATELIMITED",
"NUANCE GROUP INDIA PRIVATE LIMITED",
"NUANCE INDIA PRIVATE LIMITED",
"NUANCE JEWEL PRIVATE LIMITED",
"NUARCH DECOR PRIVATE LIMITED",
"NUATOM INNOVATIONS PRIVATE LIMITED",
"NUBE STUDIO LLP",
"NUBENO HEALTHCARE PRIVATE LIMITED",
"NUBERG ENGINEERING LIMITED",
"NUBERG EXPORTS PRIVATE LIMITED",
"NUBERRY STORES PRIVATE LIMITED",
"NUBESOL TECHNOLOGIES PRIVATE LIMITED",
"NUBIC INDIA PRIVATE LIMITED",
"NUBIGO TECHNOLOGIES PRIVATE LIMITED",
"NUBIOLA INDIA PRIVATE LIMITED",
"NUBIZ SOLUTIONS PRIVATE LIMITED",
"NUBLISS SLEEPTECH PRIVATE LIMITED",
"NUBYS TECHNOLOGY PRIVATE LIMITED",
"NUC SOFT LIMITED",
"NUCERA TILES PRIVATE LIMITED",
"NUCGNEX LIFESCIENCES PRIVATE LIMITED",
"NUCHEM DYE STUFFS PRIVATE LIMITED",
"NU-CHEM FOODS PRIVATE LIMITED",
"NU-CHEM OILS PRIVATE LIMITED",
"NUCLAY SOLUTIONS PRIVATE LIMITED",
"NU-CLEAN INFRA SERVICES PRIVATE LIMITED",
"NUCLEAR FUEL COMPLEX",
"NUCLEAR MOTORS SALES & SERVICE PRIVATE LIMITED",
"NUCLEAR OFFSET PRINTERS PRIVATE LIMITED",
"NUCLEAR POWER CORPORATION OF INDIA LIMITED",
"NUCLEIC HEALTH INNOVATIONS PRIVATE LIMITED",
"NUCLEO EVENTS & PROMOTIONS PRIVATE LIMITED",
"NUCLEOME INFORMATICS PRIVATE LIMITED",
"NUCLEONICS TRAFFIC EQUIPMENTTS PRIVATE LIMITED",
"NUCLEONIX SYSTEMS PRIVATE.LIMITED",
"NUCLEUS ANALYTICS PRIVATE LIMITED",
"NUCLEUS BULLIONS PRIVATE LIMITED",
"NUCLEUS CORPORATE SERVICES PRIVATE LIMITED",
"NUCLEUS ENENRGY PRIVATE LIMITED",
"NUCLEUS EQUITY PRIVATE LIMITED",
"NUCLEUS INFOTECH PRIVATE LIMITED",
"NUCLEUS INSIGHTS PRIVATE LIMITED",
"NUCLEUS IT ENABLED SERVICES LIMITED",
"NUCLEUS MEDISURGE PRIVATE LIMITED",
"NUCLEUS OFFICE PARKS PRIVATE LIMITED",
"NUCLEUS POWER CONTROL EQUIPMENT PRIVATE LIMITED",
"NUCLEUS SOFTWARE ENGINEERS PRIVATE LIMITED",
"NUCLEUS SOFTWARE EXPORTS LIMITED",
"NUCLEUS STOCKS BROKERS PRIVATE LIMITED",
"NUCLEUSSITES VENTURES PRIVATE LIMITED",
"NUCLEUSTEQ CONSULTING PRIVATE LIMITED",
"NUCLOTEC REMEDIES PRIVATE LIMITED",
"NUCON AEROSPACE PRIVATE LIMITED",
"NUCON AMETRA ELECTRONICS SYSTEMS PRIVATE LIMITED",
"NUCON METALS PRIVATE LIMITED",
"NUCON PNEUMATICS PRIVATE LIMITED",
"NUCON POWER CONTROLS PRIVATE LIMITED",
"NUCON PRODUCTS PRIVATE LIMITED",
"NUCON SWITCHGEARS PRIVATE LIMITED",
"NUCOR WELD INDIA PRIVATE LIMITED",
"NUCORE TRANSFORMERS PRIVATE LIMITED",
"NUCREST PHARMA PRIVATE LIMITED",
"NUDGE DIGITAL LABS PRIVATE LIMITED",
"NUDGE LIFESKILLS FOUNDATION",
"NUDRUG PHARMACEUTICAL PRIVATE LIMITED",
"NUDYNA ENGINEERS PRIVATE LIMITED",
"NUECLEAR HEALTHCARE LIMITED",
"NUENERGI & INFRA EPC LIMITED",
"NUETECH SOLAR SYSTEMS PRIVATE LIMITED",
"NUEVAS TECHNOLOGIES PRIVATE LIMITED",
"NUEVE ENTERPRISES PRIVATE LIMITED",
"NUEVED BUSINESS SERVICES PRIVATE LIMITED",
"NUEVO CONSULTANCY SERVICES PRIVATE LIMITED",
"NUEVO POLYMERS PRIVATE LIMITED",
"NUEVORA ANALYTICS TECHNOLOGIES PRIVATE LIMITED",
"NUEVOSCOPE TECHNOLOGIES PRIVATE LIMITED",
"NUEVOSOL ENERGY PRIVATE LIMITED",
"NUEVOTECH INDUSTRIES PRIVATE LIMITED",
"NUFAB TECHNICAL TEXTILES PRIVATE LIMITED",
"NUFARM FROZENS PRIVATE LIMITED",
"NUFIELD GENETICS PRIVATE LIMITED",
"NUFLOWER FOODS AND NUTRITION PRIVATE LIMITED",
"NUFLUX ELECTROMAGNETICS PRIVATE LIMITED",
"NUFUTURE DIGITAL INDIA LIMITED",
"NUGA INDIA ENTERPRISES PRIVATE LIMITED",
"NUGABEST MEDICAL INDIA PRIVATE LIMITED",
"NUGEN LABORATORIES PRIVATE LIMITED",
"NUGEN MACHINERIES LIMITED",
"NUGENIC PHARMA PRIVATE LIMITED",
"NUGREEN BUILDING TECHNOLOGIES PVT LTD",
"NU-HORIZEN METCHEM PRIVATE LIMITED",
"NU-INFRA ENGINEERING PRIVATE LIMITED",
"NUION PHARMA",
"NUKART DIGITAL SOLUTIONS PRIVATE LIMITED",
"NUKEBOX STUDIOS PRIVATE LIMITED",
"NUKG BUSINESS SOLUTIONS PRIVATE LIMITED",
"NUKI INVESTMENTS PRIVATE LIMITED",
"NUKIND HEALTHCARE PRIVATE LIMITED",
"NUKKAD PRINTER PRIVATE LIMITED",
"NUKKAD SHOPS TECHNOLOGIES INDIA PRIVATE LIMITED",
"NUKLEUS OFFICE SOLUTIONS PRIVATE LIMITED",
"NULIFE CONSULTANTS AND DISTRIBUTORS PRIVATE LIMITED.",
"NULIFE HOSPITAL",
"NULIFE PHARMACEUTICALS PRIVATE LIMITED",
"NULIFE ULTRASOUND AND DIAGNOSTIC PRIVATE LIMITED",
"NULITH GRAPHIC PRIVATE LIMITED",
"NULURN EDUTECH PRIVATE LIMITED",
"NUMA BENGALURU INNOVATIONS PRIVATE LIMITED",
"NUMAC ENGINEERING PRIVATE LIMITED",
"NUMADIC IOT PRIVATE LIMITED",
"NUMALIGARH REFINERY LIMITED",
"NUMANN PRECISION PRODUCTS PRIVATE LIMITED",
"NUMANTA CARE PRIVATE LIMITED",
"NUMANTRA TECHNOLOGIES PRIVATE LIMITED",
"NUMASCALE INDIA PRIVATE LIMITED",
"NUMATIK ENGINEERS PRIVATE LIMITED",
"NUMATO SYSTEMS PRIVATE LIMITED",
"NUMAWARE TECHNOLOGIES PRIVATE LIMITED",
"NUMAX ENERGY SOLUTIONS PRIVATE LIMITED",
"NUMAX FOODS PRIVATE LIMITED",
"NUMBER THEORY SOFTWARE PRIVATE LIMITED",
"NUMBERS CONSULTING PRIVATE LIMITED",
"NUMED LABORATORIES PRIVATE LIMITED",
"NUMED SUPER SPECIALITY HOSPITAL",
"NUMED SYSTEMS PRIVATE LIMITED",
"NUMENTICA TECHNOLOGIES PRIVATE LIMITED",
"NUMERATOR INDIA PRIVATE LIMITED",
"NUMERIC AUTO-CONTROLS PRIVATE LIMITED",
"NUMERIC INKJET TECHNOLOGIES PRIVATE LIMITED",
"NUMERIC TECHNOLOGIES INDIA PRIVATE LIMITED",
"NUMERICAL ANALYTICS INSTRUMENTS PRIVATE LIMITED",
"NUMERICAL ONE9 ONLINE MEDIA SOLUTIONS PRIVATE LIMITED",
"NUMERIFY SOFTWARE INDIA PRIVATE LIMITED",
"NUMERO MOBILE PRIVATE LIMITED",
"NUMERO UNO CLOTHING LIMITED",
"NUMEROUNO EDUCATION MARKETING SERVICE PRIVATE LIMITED OPC",
"NUMEROUS CABS PRIVATE LIMITED",
"NUMET CHEMICALS PRIVATE LIMITED",
"NUMEX BLOCKS INDIA PRIVATE LIMITED",
"NUMEX ENGINEERS PRIVATE LIMITED",
"NUMIDA BIOCARE PRIVATE LIMITED",
"NUMILE SOLUTIONS PRIVATE LIMITED",
"NUMINO LABS PRIVATE LIMITED",
"NUMINOUS IMPEX INDIA PRIVATE LIMITED",
"NUMIV RESEARCH PRIVATE LIMITED",
"NUMPY TECHNOLOGIES PRIVATE LIMITED",
"NUMRO CONSTRUCTIONS PRIVATE LIMITED",
"NUNAM TECHNOLOGIES INDIA PRIVATE LIMITED",
"NUNC SYSTEMS PRIVATE LIMITED",
"NUNHEMS INDIA PRIVATE LIMITED",
"NUNTIARE PROMOTIONS PRIVATE LIMITED",
"NUOFOX LABS PRIVATE LIMITED",
"NUOVA FIL AND INFOTECK PRIVATE LIMITED",
"NUOVA SIVAM AND GENVER COATINGS PRIVATE LIMITED",
"NUOVO FASTENINGS PRIVATE LIMITED",
"NUOVOGEN BUILDTECH PRIVATE LIMITED",
"NUOVOMONDO CHEMICALS PRIVATE LIMITED",
"NUPACK CARTONS AND CLOSURES LIMITED",
"NUPAL REMEDIES PRIVATE LIMITED",
"NUPAS CADMATIC INDIA PRIVATE LIMITED",
"NUPEAK IT SOLUTIONS LLP",
"NU-PIE MANAGEMENT CONSULTANCY SERVICES PRIVATE LIMITED",
"NUPLANET VENTURES INDIA PRIVATE LIMITED",
"NUPLUS INDUSTRIES PRIVATE LIMITED",
"NUPOORA DEVELOPERS PVT LTD",
"NUPORE FILTRATION SYSTEMS PRIVATE LIMITED",
"NUPOWER RENEWABLES PRIVATE LIMITED",
"NUPOWER WIND FARMS LIMITED",
"NUPUR HEIGHTS PRIVATE LIMITED",
"NUPUR INTERNATIONAL PRIVATE LIMITED",
"NUPUR MERCHANDISE PRIVATE LIMITED",
"NUPUR PHARMA PRIVATE LIMITED",
"NUPUR RECYCLERS LIMITED",
"NUPUR REMEDIES PVT LTD",
"NUPUR TECHNOLOGIES PRIVATE LIMITED",
"NUPUR VINIMAY PRIVATE LIMITED",
"NUR BIRI WORKS PVT. LTD.",
"NURALTECH PRIVATE LIMITED",
"NURATECH CONSULTANCY SERVICES PRIVATE LIMITED",
"NURATRADE MULTIBIZ PRIVATE LIMITED",
"NURAY CHEMICALS PRIVATE LIMITED",
"NURE CAMPUSLABS PRIVATE LIMITED",
"NURECA LIMITED",
"NURECA TECHNOLOGIES PRIVATE LIMITED",
"NUREXA PHARMA PRIVATE LIMITED",
"NURNEHER AGRO PRODUCTS PRIVATE LIMITED",
"NURPUR GASES PRIVATE LIMITED",
"NURSING COLLEGE",
"NURSING NEXT EXAM PREP PRIVATE LIMITED",
"NURSING STATION HEALTH CARE PRIVATE LIMITED",
"NURSING VANIJYA LTD",
"NURTURE AGTECH LIMITED",
"NURTURE AGTECH PRIVATE LIMITED",
"NURTURE AQUA TECHNOLOGY PRIVATE LIMITED",
"NURTURE ORGANICS PRIVATE LIMITED",
"NURTUREPLUS BIOTECH PRIVATE LIMITED",
"NURTUREU ENTERPRISE PRIVATE LIMITED",
"NURTURING GREEN PLANTATION PRIVATE LIMITED",
"NUSARWAR MERCHANTS PVT LTD",
"NUSECOND TECHNOLOGIES PRIVATE LIMITED",
"NUSHKI TRAVEL AND FOREX SERVICES INDIA PRIVATE LIMITED",
"NUSMITH PHARMA PRIVATE LIMITED",
"NUSRAT ATHAR SURGICAL AND MATERNITY HOME PRIVATE LIMITED",
"NUSRATH METALS PRIVATE LIMITED",
"NUSTAR EXIM PRIVATE LIMITED",
"NUSYN DIGITAL SOLUTIONS PRIVATE LIMITED",
"NUT VALLEY PRIVATE LIMITED",
"NUTAN AUTOMOTIVE PRIVATE LIMITED",
"NUTAN BUILDERS PRIVATE LIMITED",
"NUTAN COTTON INDUSTRIES",
"NUTAN DOMRESHWAR VIDYA MANDIR BEED",
"NUTAN FOOD PRIVATE LIMITED",
"NUTAN GLASS PRIVATE LIMITED",
"NUTAN HIGH SCHOOL MOHADI P D",
"NUTAN HIGH SCHOOL MOHADI PD",
"NUTAN INDUSTRIAL SECURITY SERVICES PRIVATE LIMITED",
"NUTAN MARATHI VIDYALAY ICHALKARANJI",
"NUTAN MARATHI VIDYALAYA NERUL",
"NUTAN MUK BADHIR VIDYALAY",
"NUTAN NAGARIK SAHAKARI BANK LTD",
"NUTAN NIRMAN PRIVATE LIMITED",
"NUTAN NIRMAN PVT. LTD.",
"NUTAN RAJUMANI TRANSPORT PVT LTD",
"NUTAN REALTIES (INDIA) LIMITED",
"NUTAN SARASWATI VIDYALAYA AND JUNIOR COLLEGE",
"NUTAN SARSWATI VIDYALAYA AND JUNIOR COLLEGE",
"NUTAN TOBACCO PRIVATE LIMITED",
"NUTAN TRAVELS",
"NUTAN VIDHYALAYA",
"NUTAN VIDYA MANDIR",
"NUTANIX TECHNOLOGIES INDIA PRIVATE LIMITED",
"NUTASTE FOOD AND DRINK LABS PRIVATE LIMITED",
"NUTASTE FOOD LABS PRIVATE LIMITED",
"NUTEC INFOTECH PRIVATE LIMITED",
"NU-TECH AGRI MACHINES PRIVATE LIMITED",
"NUTECH AUTO PRIVATE LIMITED",
"NUTECH BIOSCIENCES INDIA PRIVATE LIMITED",
"NUTECH CONTRACTS PRIVATE LIMITED",
"NU-TECH DAIRY ENGINEERS PRIVATE LIMITED",
"NUTECH DEALCOM PRIVATE LIMITED",
"NUTECH DUCTING SOLUTIONS PRIVATE LIMITED",
"NUTECH ENGINEERING TECHNOLOGIES LIMITED",
"NUTECH GLOBAL LIMITED",
"NUTECH GRAPHICS PRIVATE LIMITED",
"NUTECH HEALTHCARE PRIVATE LIMITED",
"NU-TECH INDUSTRIAL PARTS PRIVATE LIMITED",
"NUTECH INDUSTRIES",
"NUTECH INFRASTRUCTURE PRIVATE LIMITED",
"NUTECH JETTING EQUIPMENTS INDIA PRIVATE LIMITED",
"NUTECH OFFICE SYSTEM PRIVATE LIMITED",
"NUTECH PHOTO LITHOGRAPHERS PRIVATE LIMITED",
"NUTECH POLYMERS PRIVATE LIMITED",
"NUTECH PRINTING AND PACKAGING SOLUTIONS PRIVATE LIMITED",
"NUTECH REALTY PROJECTS PRIVATE LIMITED",
"NUTECH SINTERED PRODUCTS PRIVATE LIMITED",
"NUTECH TECHNOSERVICES PRIVATE LIMITED",
"NU-TECK ENGIMECH PRIVATE LIMITED",
"NU-TECK ENGINEERING COMPANY PRIVATE LIMITED",
"NUTECK POWER EQUIPMENTS PRIVATE LIMITED",
"NUTEC-THERMO FURNACES AND EQUIPMENTS PRIVATE LIMITED",
"NUTEK TECHNOLOGIES PRIVATE LIMITED",
"NUTEMA BLOOD BANK PRIVATE LIMITED",
"NUTEMA HEALTH CARE PRIVATE LIMITED",
"NUTEMA PHARMACY PRIVATE LIMITED",
"NUTEX APPAREL LIMITED",
"NUTEX DURO ELAST PRIVATE LIMITED",
"NUTKHUT FOODS PRIVATE LIMITED",
"NUTORAS FOODS PRIVATE LIMITED",
"NUTRA FOODS INDIA PRIVATE LIMITED",
"NUTRA LIFE HEALTHCARE PRIVATE LIMITED",
"NUTRACOS LIFESCIENCES PRIVATE LIMITED",
"NUTRAGENIX HEALTHCARE PRIVATE LIMITED",
"NUTRAHELIX BIOTECH PRIVATE LIMITED",
"NUTRANOVEL ADDITIVES PRIVATE LIMITED",
"NUTRANTA SEEDS PRIVATE LIMITED",
"NUTRAOIL PRIVATE LIMITED",
"NUTRAVO LIFECARE PRIVATE LIMITED",
"NUTREND LIFESTYLES PRIVATE LIMITED",
"NUTRESTA FOODS PRIVATE LIMITED",
"NUTRI - AGROVET PRIVATE LIMITED",
"NUTRI AGRO EXPORTS PRIVATE LIMITED",
"NUTRI CEREALS FOOD PROCESSING PRIVATE LIMITED",
"NUTRI FEEDS AND FARMS PRIVATE LIMITED",
"NUTRI FLAVOURS PRIVATE LIMITED",
"NUTRI INDIA IMPEX PRIVATE LIMITED",
"NUTRI TECH INDIA PRIVATE LIMITED",
"NUTRIBIOSCIENCES PRIVATE LIMITED",
"NUTRIBURST INDIA PRIVATE LIMITED",
"NUTRICA PUSTI HEALTHCARE PRIVATE LIMITED",
"NUTRICARE BIO SCIENCE PRIVATE LIMITED",
"NUTRICARE LIFE SCIENCES LIMITED",
"NUTRICH FOODS PRIVATE LIMITED",
"NUTRICIA INTERNATIONAL PRIVATE LIMITED",
"NUTRICIRCLE LIMITED",
"NUTRICON BIOSCIENCES PRIVATE LIMITED",
"NUTRICONCEPT FOODS PRIVATE LIMITED",
"NUTRICORE BIOSCIENCES PRIVATE LIMITED",
"NUTRICREAMS PRIVATE LIMITED",
"NUTRICURE INDIA PRIVATE LIMITED",
"NUTRIENT BIO-AGRO TECH PRIVATE LIMITED",
"NUTRIFEAST MART PRIVATE LIMITED",
"NUTRIFERT AGRI INPUTS PRIVATE LIMITED",
"NUTRIFERT CROP CARE PRIVATE LIMITED",
"NUTRIFRESH FARM TECH INDIA PRIVATE LIMITED",
"NUTRIFRESH TASTY FOODS AND BEVERAGES PRIVATE LIMITED",
"NUTRIGLOW COSMETICS PRIVATE LIMITED",
"NUTRIGO FEEDS PRIVATE LIMITED",
"NUTRIGOLD HEALTHTECH LLP",
"NUTRIGRIP FOODS PRIVATE LIMITED",
"NUTRIHUB INDIA PRIVATE LIMITED",
"NUTRIKRAFT INDIA PRIVATE LIMITED",
"NUTRILEY HEALTHCARE PRIVATE LIMITED",
"NUTRILIS HEALTHCARE PRIVATE LIMITED",
"NUTRILITE AGRO PRODUCTS PRIVATE LIMITED",
"NUTRIMAX FOOD PRIVATE LIMITED",
"NUTRIMED HEALTHCARE PRIVATE LIMITED",
"NUTRINE CONFECTIONERY CO. LIMITED",
"NUTRIS CROP SOLUTIONS INDIA PRIVATE LIMITED",
"NUTRITAP TECHNOLOGIES PRIVATE LIMITED",
"NUTRITI INGREDIENTS PRIVATE LIMITED",
"NUTRITI LIFE WINS PRIVATE LIMITED",
"NUTRITIMES HEALTHCARE PRIVATE LIMITED",
"NUTRITION INTERNATIONAL",
"NUTRITION PLANET PRIVATE LIMITED",
"NUTRITIONALAB PRIVATE LIMITED",
"NUTRITIUS FOODS",
"NUTRIUNT FOODS AND AGRO PRIVATE LIMITED",
"NUTRIVA LIFESCIENCES PRIVATE LIMITED",
"NUTRIVATIVE FOODS PRIVATE LIMITED",
"NUTRIVEGA FOODS PRIVATE LIMITED",
"NUTRIVET COMPANY PRIVATE LIMITED",
"NUTRIVET FARM CARE PRIVATE LIMITED",
"NUTRIVITA FOODS PRIVATE LIMITED",
"NUTRIWEL HEALTH INDIA PRIVATE LIMITED",
"NUTRIX INDIA PRIVATE LIMITED",
"NUTRIXUS BAKER'S PRIVATE LIMITED",
"NUTRIZO ADVANCIS HEALTHCARE PRIVATE LIMITED",
"NUTRIZOE NUTRIIFOODS PRIVATE LIMITED",
"NUTROACTIVE INDUSTRIES PRIVATE LIMITED",
"NUTRON PHARMACEUTICALS PRIVATE LIMITED",
"NUTRON SYSTEMS PRIVATE LIMITED",
"NUTROVIE AGRO FARMER PRODUCER COMPANY LIMITED",
"NUTS & BERRIES INDIA PRIVATE LIMITED",
"NUTS DELISH PRIVATE LIMITED",
"NUTSHELL ADVERTISING PRIVATE LIMITED",
"NUTSHELL DRY FRUITS PRIVATE LIMITED",
"NUTSHELL MEDIA PRIVATE LIMITED",
"NUTSHELL PUBLICITY PRIVATE LIMITED",
"NUTSHELL TECHNOLOGIES PRIVATE LIMITED",
"NUTTOZ FOOD INDUSTRIES PRIVATE LIMITED",
"NUTTY NUTS PRIVATE LIMITED",
"NUTURN AGRI-TECH PRIVATE LIMITED",
"NUTZCART PRIVATE LIMITED",
"NUVA MACHINE WORKS INDIA PRIVATE LIMITED",
"NUVAE HEALTHCARE PRIVATE LIMITED",
"NUVAMA ASSET MANAGEMENT LIMITED",
"NUVAMA CAPITAL SERVICES (IFSC) LIMITED",
"NUVAMA WEALTH AND INVESTMENT LIMITED",
"NUVAMA WEALTH MANAGEMENT LIMITED",
"NUVEDA LEARNING PRIVATE LIMITED",
"NUVEM LABS PRIVATE LIMITED",
"NUVENEX LABS PRIVATE LIMITED",
"NUVENTO SYSTEMS PRIVATE LIMITED",
"NUVENTURE CONNECT PRIVATE LIMITED",
"NUVENTURE TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"NUVEQ ENGINEERS PRIVATE LIMITED",
"NUVEQ HOLIDAYS PRIVATE LIMITED",
"NUVEVA INTERNATIONAL NUTRITION PRIVATE LIMITED",
"NUVIASEMI INDIA PRIVATE LIMITED",
"NUVICARE PHARMACEUTICALS PRIVATE LIMITED",
"NUVIGEN LIFE SCIENCES PRIVATE LIMITED",
"NUVISION COMMERCIAL & ESCORT SERVICES",
"NUVISION INSTRUMENTATION SOLUTIONS PRIVATE LIMITED",
"NUVISION LASER CENTRE (POONA) PRIVATE LIMITED",
"NUVISO NETWORKS PRIVATE LIMITED",
"NUVISTA TECHNOLOGIES PRIVATE LIMITED",
"NUVIZZ SOFTWARE SOLUTIONS PRIVATE LIMITED",
"NUVO AEON DIAMOND AND JEWELLERY LLP",
"NUVO BUS TRANSIT SYSTEMS PRIVATE LIMITED",
"NUVO HOME FASHIONS PRIVATE LIMITED",
"NUVO LOGISTICS PRIVATE LIMITED",
"NUVO MEDSURG PRIVATE LIMITED",
"NUVOCO VISTAS CORPORATION LIMITED",
"NUVOCRAFT APPARELS INDIA PRIVATE LIMITED",
"NUVOLO TECHNOLOGIES INDIA PRIVATE LIMITED",
"NUVORETAIL PRIVATE LIMITED",
"NUVOTEC TITANIUM PROCESS EQUIPMENT PRIVATE LIMITED",
"NUVOTON TECHNOLOGY INDIA PRIVATE LIMITED",
"NUVOTRONIX ENERGY SYSTEMS INDIA PRIVATE LIMITED",
"NUVOX HEALTHCARE PRIVATE LIMITED",
"NUVRI INDIA PRIVATE LIMITED",
"NUVTEQ SOLUTIONS PRIVATE LIMITED",
"NUVVEN INDIA PRIVATE LIMITED",
"NUWARE SYSTEMS LLP",
"NUWAVE COMMUNICATIONS PRIVATE LIMITED",
"NUWAVE ESOLUTIONS PRIVATE LIMITED",
"NUWAVES GLASS PRIVATE LIMITED",
"NU-WAY ENGINEERING PRIVATE LIMITED",
"NU-WAY HEATRANSFER PRIVATE LIMITED",
"NUWAYS CREATION PRIVATE LIMITED",
"NUWAYULTRA PROJECTS PRIVATE LIMITED",
"NUWILL RESEARCH AND INNOVATIONS PRIVATE LIMITED",
"NUWORLD CHEMICALS PRIVATE LIMITED",
"NUXALBARI TEA COMPANY PRIVATE LIMITED",
"NUZEN HERBAL PRIVATE LIMITED",
"NUZEN INDUSTRIES PRIVATE LIMITED",
"NUZHAT JUTE BAGS FACTORY PRIVATE LIMITED",
"NUZIVEEDU SEEDS LIMITED",
"NV AUTOSPARES PRIVATE LIMITED",
"NV DISTILLERIES AND BREWERIES PRIVATE LIMITED",
"NV DISTILLERIES PRIVATE LIMITED",
"NV INFOTECH DOMAIN PRIVATE LIMITED",
"NV INTERNATIONAL PRIVATE LIMITED",
"NV LOGISTICS PRIVATE LIMITED",
"NV MUMBAI ESTATE PRIVATE LIMITED",
"NV ORGANICS PRIVATE LIMITED",
"NV PROJECTS PRIVATE LIMITED",
"NV PUNE ESTATE PRIVATE LIMITED",
"NV REMEDIES PRIVATE LIMITED",
"NV SPACES & REALTY PRIVATE LIMITED",
"NV TECH SOLUTION OPC PRIVATE LIMITED",
"NV TECH SPACES PRIVATE LIMITED",
"NVA CONSTRUCTIONS PRIVATE LIMITED",
"NVAHAN TEXTILE PRIVATE LIMITED",
"NVAYO GLOBAL SERVICES PRIVATE LIMITED",
"NVB JUNIOR COLLEGE",
"NVC LOGISTICS PRIVATE LIMITED",
"NVD TECHNOLOGY SERVICES PRIVATE LIMITED",
"NVDA NARMADA BHAWAN BHOPAL",
"NVENT CONSTRUCTIONS PRIVATE LIMITED",
"NVENT ELECTRICAL PRODUCTS INDIA PRIVATE LIMITED",
"NVENT THERMAL INDIA PRIVATE LIMITED",
"NVEST SOLUTION PRIVATE LIMITED",
"NVH INDIA ANANTAPUR AUTO PARTS PRIVATE LIMITED",
"NVH INDIA AUTO PARTS PRIVATE LIMITED",
"NVIDIA GRAPHICS PRIVATE LIMITED",
"NVIERA TECHNOLOGIES PRIVATE LIMITED",
"NVINCY SOLUTIONS PRIVATE LIMITED",
"NVIRO ELEMENTS PRIVATE LIMITED",
"NVIRON CONSULTING PRIVATE LIMITED",
"NVIS TECHNOLOGIES PRIVATE LIMITED",
"NVISH SOLUTIONS PRIVATE LIMITED",
"NVISION PRODUCTS PRIVATE LIMITED",
"NVIZION SOLUTIONS PRIVATE LIMITED",
"NVK INNFRA PRIVATE LIMITED",
"NVL HOLDINGS PRIVATE LIMITED",
"NVLN CONSTRUCTIONS PRIVATE LIMITED",
"NVM PLASTIC PRIVATE LIMITED",
"NVN BUILDCON LLP",
"NVNR (RAMANNAPET I) POWER PLANT PRIVATE LIMITED",
"NVNR (RAMANNAPET II) POWER PLANT PRIVATE LIMITED",
"NVNR POWER & INFRA PRIVATE LIMITED",
"NVP COMMERCIAL PRIVATE LIMITED",
"NVP VENTURE CAPITAL INDIA PRIVATE LIMITED",
"NVR AND ASSOCIATES LIMITED",
"NVR INFRASTRUCTURE & SERVICES PRIVATE. LIMITED.",
"NVR LOGISTICS PRIVATE LIMITED",
"NVRON LIFE SCIENCE LIMITED",
"NVS BROKERAGE PRIVATE LIMITED",
"NVS CORPORATE CONSULTANCY SERVICES PRIVATE LIMITED",
"NVS TRAVEL SOLUTIONS PRIVATE LIMITED",
"NVSV FOODS PRIVATE LIMITED",
"NVT QUALITY BUILD SOLUTIONS PRIVATE LIMITED",
"NVT QUALITY CERTIFICATION PRIVATE LIMITED",
"NVT QUALITY LIFESTYLE PROJECTS PRIVATE LIMITED",
"NWARESOFT PRIVATE LIMITED",
"NWAY TECHNOLOGIES PRIVATE LIMITED",
"NWCC ISPAT PRIVATE LIMITED",
"NWCC SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED",
"NWR",
"NWR AJMER DIV",
"NWS DIGITAL INDIA PRIVATE LIMITED",
"NWT MALL MANAGEMENT PRIVATE LIMITED",
"NX LOGISTICS INDIA PRIVATE LIMITED",
"NX PACK PRIVATE LIMITED",
"NX TECHNOSYS PRIVATE LIMITED",
"NXG FOOD SAFETY WORKS INDIA PRIVATE LIMITED",
"NXG HOMES INDIA PRIVATE LIMITED",
"NXG RECRUITMENT PRIVATE LIMITED",
"NXM INDIA PRIVATE LIMITED",
"NXP INDIA PRIVATE LIMITED",
"NXT AUTOMART (INDIA) LIMITED",
"NXT DOOR RETAIL PRIVATE LIMITED",
"NXT POLYESTER PRIVATE LIMITED",
"NXT TRADE & AGENCY SERVICES INDIA PRIVATE LIMITED",
"NXTDIGITAL LIMITED",
"NXTEK YANTRA PRIVATE LIMITED",
"NXTGEN DATACENTER & CLOUD TECHNOLOGIES PRIVATE LIMITED",
"NXTIFY TECHNOLOGIES PRIVATE LIMITED",
"NXTIGEN SERVICES PRIVATE LIMITED",
"NXT-INFRA CGRG HIGHWAYS LIMITED",
"NXT-INFRA CT HIGHWAYS PRIVATE LIMITED",
"NXT-INFRA GSY HIGHWAYS LIMITED",
"NXTRA DATA LIMITED",
"NXTWAVE DISRUPTIVE TECHNOLOGIES PRIVATE LIMITED",
"NXV BEARINGS PRIVATE LIMITED",
"NY APPARELS PRIVATE LIMITED",
"NY SOFTECH INDIA PRIVATE LIMITED",
"NY TECHNOLOGY INDIA PRIVATE LIMITED",
"NY VFXWAALA LLP",
"NY.RANADE V.JR.COLLEGE KAPASHI",
"NYAGATARE AGRO VENTURES PRIVATE LIMITED",
"NYAL FASHION PRIVATE LIMITED",
"NYALAZONE SOLUTIONS PRIVATE LIMITED",
"NYALKARAN SOLUTIONS PRIVATE LIMITED",
"NYALKARAN STEEL PRIVATE LIMITED",
"NYAME COMMODITIES PRIVATE LIMITED",
"NYASA ENTERPRISES PRIVATE LIMITED",
"NYASA PHARMA PRIVATE LIMITED",
"NYASSA ASTROCORP PRIVATE LIMITED",
"NYASSA RETAIL PRIVATE LIMITED",
"NYASYLEE TEA ESTATE PRIVATE LIMITED",
"NYATI CONSTRUCTION PRIVATE LIMITED",
"NYATI ENGINEERS & CONSULTANTS PRIVATE LIMITED",
"NYATI ENGINEERS & CONSULTANTS PRIVATE LIMITED",
"NYATI HOTELS AND RESORTS PRIVATE LIMITED",
"NYATI TECHNOLOGIES PRIVATE LIMITED",
"NYC IMPEX PRIVATE LIMITED",
"NYCE SECURITIES AND DERIVATIVES LIMITED",
"NYDEL RESOURCES PRIVATE LIMITED",
"NYEI DESIGN SERVICES PRIVATE LIMITED",
"NYG ENERGY SOLUTIONS PRIVATE LIMITED",
"NYK INDIA PRIVATE LIMITED",
"NYK LINE INDIA PRIVATE LIMITED",
"NYK SHIPMANAGEMENT INDIA PRIVATE LIMITED",
"NYK SHIPMANAGEMENT PTE LIMITED",
"NYKA EVENTS PRIVATE LIMITED",
"NYKAA E- RETAIL LIMITED",
"NYKAA FASHION LIMITED",
"NYKAA FASHION PRIVATE LIMITED",
"NYKAA KK BEAUTY PRIVATE LIMITED",
"NYL ELECTRIC PRIVATE LIMITED",
"NYLETECH SOLUTIONS PRIVATE LIMITED",
"NYLOFILMS PRIVATE LIMITED",
"NYLOPLAST PRECISION INDUSTRIES PRIVATE LIMITED",
"NYMPHAEA FASHION DESIGNS PRIVATE LIMITED",
"NYMPHETTE TOURS PRIVATE LIMITED",
"NYMS DEVBHOOMI AROMATICS PRIVATE LIMITED",
"NYNAS NAPHTHENICS PRIVATE LIMITED",
"NYNE ORGANICS PRIVATE LIMITED",
"NYNEX REALTY VENTURE PRIVATE LIMITED",
"NYONI ENTERPRISES PRIVATE LIMITED",
"NYPUN TOOLINGS AND PRESS COMPONENTS PRIVATE",
"NYR INDUSTRIES PRIVATE LIMITED",
"NYRI COAL TAR PITCH PRIVATE LIMITED",
"NYSA COMMUNICATIONS PRIVATE LIMITED",
"NYSA CONSUMER PRODUCTS PRIVATE LIMITED",
"NYSA FOREX PRIVATE LIMITED",
"NYSA INTERPACK PRIVATE LIMITED",
"NYSA MED PRIVATE LIMITED",
"NYSAA RETAIL PRIVATE LIMITED",
"NYSCOM TECHNOLOGY PRIVATE LIMITED",
"NYT NEWS BUREAU (INDIA) PRIVATE LIMITED",
"NYTEC BEAUTY INTERNATIONAL PRIVATE LIMITED",
"NYUCEL WELLNESS PRIVATE LIMITED",
"NYX HOSPITALITY PRIVATE LIMITED",
"NYX MEDICAL SOLUTIONS PRIVATE LIMITED",
"NYX PROJECT VENTURES PRIVATE LIMITED",
"NYX SOFTWARE DESIGN PRIVATE LIMITED",
"NYX WOLVES FREELANCE & BUSINESS SOLUTIONS PRIVATE LIMITED",
"NYZA OVERSEAS PRIVATE LIMITED",
"NZ BUILDCON PRIVATE LIMITED",
"NZ NUTRACARE PRIVATE LIMITED",
"NZ SEASONAL WEAR PRIVATE LIMITED",
"NZ TECH TEXTILE INDIA PRIVATE LIMITED",
"NZ TECHNOLOGIES PRIVATE LIMITED",
"O & G SKILLS INDIA PRIVATE LIMITED",
"O & S ASSOCIATES PRIVATE LIMITED",
"O A COMPSERVE PRIVATE LIMITED",
"O AND M SOLUTIONS PRIVATE LIMITED",
"O B INFRASTRUCTURE LIMITED",
"O C I COPPER PRIVATE LIMITED",
"O C SWEATERS LLP",
"O C TANNER INDIA PRIVATE LIMITED",
"O CLOCK SOFTWARE PRIVATE LIMITED",
"O D FINANCE AND INVESTMENT PRIVATE LIMITED",
"O E N INDIA LIMITED",
"O G SPINNERS PRIVATE LIMITED",
"O H P FOOD PRODUCTS PRIVATE LIMITED",
"O J FINANCIAL SERVICES LIMITED",
"O K AUTO COMPONENTS PRIVATE LIMITED",
"O K GLASS FIBRE PRIVATE LIMITED",
"O K PLAY INDIA LIMITED",
"O L C I ENGINEERING INDIA PRIVATE LIMITED",
"O LIFE PRIVATE LIMITED",
"O P B K CONSTRUCTIONS PRIVATE LIMITED",
"O P GARG AND SONS PRIVATE LIMITED",
"O P GUPTA CONTRACTORS PRIVATE LIMITED",
"O P JINDAL GLOBAL UNIVERSITY",
"O P JINDAL SCHOOL RAIGARH",
"O P JINDAL SCHOOL TARAIMAL",
"O P K WOOLLEN MILLS PVT LTD",
"O P KANDOI & COMPANY PVT LTD",
"O P MARINE SERVICES PRIVATE LIMITED",
"O P MITTAL INDUSTRIES LIMITED",
"O P T SERVICES INDIA PRIVATE LIMITED",
"O R N REMEDIES PRIVATE LIMITED",
"O S AYURVED PRIVATE LIMITED",
"O S CARS PRIVATE LIMITED",
"O S ELECTRONICS INDIA PRIVATE LIMITED",
"O S S AIR MANAGEMENT PRIVATE LIMITED",
"O SOURCE INDIA PRIVATE.LIMITED",
"O T M JEWELLERY PRIVATE LIMITED",
"O T TEXTILES PVT LTD",
"O&M HALYARD HEALTH INDIA PRIVATE LIMITED",
"O. P. CHAINS LIMITED",
"O. P. S. CARRIER PRIVATE LIMITED",
"O. S. FOOD PRIVATE LIMITED",
"O.K. CARGO CRAFT PRIVATE LIMITED",
"O.K. ENTERPRISES PRIVATE LIMITED",
"O.K. VENTURES PRIVATE LIMITED",
"O.M. BOOKS FOUNDATION",
"O.M.A. KNITTING WORKS PVT LTD",
"O.M.R CONSTRUCTION COMPANY PRIVATE LIMITED",
"O.M.S. MOTORS PRIVATE LIMITED",
"O.M.S. TAMARIND MERCHANTS PRIVATE LIMITED",
"O.P. ASSOCIATES",
"O.P. ASSOCIATES PRIVATE LIMITED",
"O.P. GUPTA IRON PRIVATE LIMITED",
"O.P. PHARMA PRIVATE LIMITED",
"O.R LASER TECHNOLOGIE INDIA PRIVATE LIMITED",
"O.S.AUTOMOBILES PRIVATE LIMITED",
"O.S.MOTORS PRIVATE LIMITED",
"O.W.M LOGISTICS PRIVATE LIMITED",
"O/O THE B D O UDAYNARAYANPUR",
"O/O THE REGISTRAR SCIENCE & TECHNOLOGY & BIOTECHNOLOGY DEPT",
"O2 INDIA PRIVATE LIMITED",
"O2 INDUSTRIES PRIVATE LIMITED",
"O2 PATHLABS PRIVATE LIMITED",
"O2 POWER PRIVATE LIMITED",
"O2B TECHNOLOGIES",
"O2B TECHNOLOGIES PRIVATE LIMITED",
"O2F INFO SOLUTIONS PRIVATE LIMITED",
"O2H DISCOVERY PRIVATE LIMITED",
"O2-MATIC PRODUCTS PRIVATE LIMITED",
"O2Z TRADING & INDUSTRIES PRIVATE LIMITED",
"O3 ALTERNATIVES PRIVATE LIMITED",
"O3 CAPITAL GLOBAL ADVISORY PRIVATE LIMITED",
"O3 EVENTS & ENTERTAINMENT MEDIA PRIVATE LIMITED",
"O3 SECURITIES PRIVATE LIMITED",
"O3M DIRECTIONAL MARKETING PRIVATE LIMITED",
"O4 DIGITAL MEDIA PRIVATE. LIMITED",
"O9 SOLUTIONS MANAGEMENT INDIA PRIVATE LIMITED",
"OA SERVICES LLP",
"OAB STUDIOS SOFTWARE PRIVATE LIMITED",
"OAC WOOLLENS PRIVATE LIMITED",
"OAGRI FARM PRIVATE LIMITED",
"OAHFEO DREAMS PRIVATE LIMITED",
"OAISIS ALCOHOL INDIA PRIVATE LIMITED",
"OAJ INSTITUTE OF SCIENCE",
"OAK AND STONE CONSTRUCTION PRIVATE LIMITED",
"OAK FOREX PRIVATE LIMITED",
"OAK INFRASTRUCTURE DEVELOPERS LIMITED",
"OAK LEASING AND INFOTECH PRIVATE LIMITED",
"OAK N SAND CONSTRUCTION PRIVATE LIMITED",
"OAK SHIPPING SERVICES PRIVATE LIMITED",
"OAK SYSTEMS PRIVATE LIMITED",
"OAK TREE SOFTWARE PRIVATE LIMITED",
"OAK VANCE LIFE SCIENCES PRIVATE LIMITED",
"OAKBRIDGE PUBLISHING PRIVATE LIMITED",
"OAKDALE EDUCATIONAL SOCIETY",
"OAKDENEINDIA SOFTWARE SERVICES PRIVATE LIMITED",
"OAKEN GOLD BOTTLING PRIVATE LIMITED",
"OAKHILL LAND DEVELOPERS PRIVATE LIMITED",
"OAKLAND BOTTLERS PRIVATE LIMITED.",
"OAKLAND ESTATES PRIVATE LIMITED",
"OAKLAND INFRA PRIVATE LIMITED",
"OAKLAND SYSTEMS PRIVATE LIMITED",
"OAKLAWN IT SOLUTION PRIVATE LIMITED",
"OAKLEY BOWDEN & CO (MADRAS) PRIVATE LIMITED",
"OAKNET HEALTHCARE PRIVATE LIMITED",
"OAKNORTH GLOBAL PRIVATE LIMITED",
"OAKNORTH INDIA PRIVATE LIMITED",
"OAKRIDGE ENERGY PRIVATE LIMITED",
"OAKRIDGE INTERNATIONAL SCHOOL",
"OAKS ASSET MANAGEMENT PRIVATE LIMITED",
"OAKS MANAGEMENT CONSULTANCY PRIVATE LIMITED",
"OAKTREE CAPITAL GROUP LLC",
"OAKTREE FISHERIES PRIVATE LIMITED",
"OAKTREE ILLUMINANCE & INFRA SOLUTIONS PRIVATE LIMITED",
"OAKTREE INFRA DEVELOPERS PRIVATE LIMITED",
"OAKTREE PROPERTIES PRIVATE LIMITED",
"OAKTREE TECHNOLOGIES PRIVATE LIMITED",
"OAKWOOD LIQUORS PRIVATE LIMITED",
"OAKWOOD RESIDENCE KAPIL HYDERABAD",
"OAKWOOD WINERY PRIVATE LIMITED",
"OAKYA SOLUTIONS PRIVATE LIMITED",
"OAM INDUSTRIES INDIA PRIVATE LIMITED",
"OAN INDUSTRIES PRIVATE LIMITED",
"OANDS RATNA ALUMINIUM FABRICATORS PRIVATE LIMITED",
"OAO INFO INDIA PRIVATE LIMITED",
"OAP MEDIATECH PRIVATE LIMITED",
"OAS REALTY PRIVATE LIMITED",
"OASIS ACCOUNTANTS PRIVATE LIMITED",
"OASIS AGRO INDUSTRIES PRIVATE LIMITED",
"OASIS BUILDHOME PRIVATE LIMITED",
"OASIS BUILDMART (INDIA) PRIVATE LIMITED",
"OASIS CAPITAL SERVICES PRIVATE LIMITED",
"OASIS COMMERCIAL PRIVATE LIMITED",
"OASIS CONNECTIVITY PRIVATE LIMITED",
"OASIS CONTRACTORS AND CONSULTANTS PRIVATE LIMITED",
"OASIS CONTRIVER PRIVATE LIMITED",
"OASIS COUNSEL & ADVISORY PRIVATE LIMITED",
"OASIS CROP CARE PRIVATE LIMITED",
"OASIS DALE AGGREGATE PRODUCTS PRIVATE LIMITED",
"OASIS DECOR PRIVATE LIMITED",
"OASIS DISTILLERIES LIMITED",
"OASIS EDUCATIONAL SERVICES PRIVATE LIMITED",
"OASIS ELECTRO MECH PRIVATE LIMITED",
"OASIS ENTERPRISES PRIVATE LIMITED",
"OASIS EPC SOLUTIONS LIMITED",
"OASIS GREEN ENERGY PRIVATE LIMITED",
"OASIS HOMETEX PRIVATE LIMITED",
"OASIS INDIA A-NETWORK PRIVATE LIMITED",
"OASIS INDUSTRIES PRIVATE LIMITED",
"OASIS INFRASTRUCTURE PRIVATE LIMITED",
"OASIS INSULATION PRIVATE LIMITED",
"OASIS INTERNATIONAL PVT LTD",
"OASIS INTERNATIONAL SCHOOL",
"OASIS IRRIGATION EQUIPMENT CO LIMITED",
"OASIS I-TECH PRIVATE LIMITED",
"OASIS JEWELLS PRIVATE LIMITED",
"OASIS LABORATORIES PVT LTD",
"OASIS LIFE SPACES PRIVATE LIMITED",
"OASIS LIMITED",
"OASIS MARINE PRIVATE LIMITED",
"OASIS PHARMACEUTICALS LIMITED",
"OASIS POLY PROFILE PRIVATE LIMITED",
"OASIS PROJECTS LIMITED",
"OASIS REALITY AOP",
"OASIS REALTECH PRIVATE LIMITED",
"OASIS REALTORS PRIVATE LIMITED",
"OASIS REALTY",
"OASIS RENEWABLES AND WATER TREATMENT LIMITED",
"OASIS RESOURCE MANAGEMENT",
"OASIS SCHOOL OF EXCELLENCE",
"OASIS SECURITIES LIMITED",
"OASIS SECURITY AND PLACEMENT SERVICES PRIVATE LIMITED",
"OASIS SHIPPING PRIVATE LIMITED",
"OASIS SPIRITS PRIVATE LIMITED",
"OASIS STEEL LIMITED",
"OASIS TECHNO ENGINEERS PRIVATE LIMITED",
"OASIS TECHNOSOFT PRIVATE LIMITED",
"OASIS TEST HOUSE LIMITED",
"OASIS TEXFAB INDIA PRIVATE LIMITED",
"OASIS TOURS INDIA PRIVATE.LIMITED",
"OASIS ULTRATECH PRIVATE LIMITED",
"OASIS VITRIFIED PRIVATE LIMITED",
"OASIS VOYAGES PRIVATE LIMITED",
"OASIS WATER TREATMENTS PRIVATE LIMITED",
"OASIS WEAVING MILLS PRIVATE LIMITED",
"OASYS CYBERNETICS PRIVATE LIMITED",
"OASYS IT SOLUTIONS PRIVATE LIMITED",
"OASYS TECHSOLUTION PRIVATE LIMITED",
"OAT & IIL INDIA LABORATORIES PRIVATE LIMITED",
"OATAIK TECHNOLOGIES PRIVATE LIMITED",
"OATH GREEN SOLAR PRIVATE LIMITED",
"OATS MANAGEMENT CONSULTANCY PRIVATE LIMITED",
"OATSYSTEMS SOFTWARE INDIA PRIVATE LIMITED",
"OAY KAY FORGINGS PRIVATE LIMITED",
"OBAN FASHIONS PRIVATE LIMITED",
"OBAN TECH PRIVATE LIMITED",
"OBARA INDIA PRIVATE LIMITED",
"OBAYASHI CORPORATION JAPAN",
"OBBSERV ONLINE SERVICES PRIVATE LIMITED",
"OBEETEE PRIVATE LIMITED",
"OBEETEE RETAIL PRIVATE LIMITED",
"TWE OBT PRIVATE LIMITED",
"OBEL COMPUTERS PRIVATE LIMITED",
"OBEL SYSTEMS PRIVATE LIMITED",
"OBENOL CHEMICALS PRIVATE LIMITED",
"OBERAI EDUCATIONAL TRUST",
"OBERAI MOTORS LIMITED",
"OBEROI CONSTRUCTIONS LIMITED",
"OBEROI FENESTRATIONS PRIVATE LIMITED",
"OBEROI IBC INDIA PRIVATE LIMITED",
"OBEROI INDUSTRIES PRIVATE LIMITED",
"OBEROI INTERNATIONAL SCHOOL",
"OBEROI MALL LIMITED",
"OBEROI ONE FOUNDATION FOR SOCIAL WELFARE",
"OBEROI PAINTS PRIVATE LIMITED",
"OBEROI PLAZA PVT LTD",
"OBEROI REALTY LIMITED",
"OBEROI SONS (INDIA) PRIVATE LIMITED",
"OBEROI THERMIT PRIVATE LIMITED",
"OBEROI WOOD PRODUCTS PRIVATE LIMITED",
"OBERON EDIFICES AND ESTATES PRIVATE LIMITED",
"OBERTHUR TECHNOLOGIES INDIA PRIVATE LIMITED",
"OBERU RETAIL PRIVATE LIMITED",
"OBEXA PHARMACARE PRIVATE LIMITED",
"OBEYA UNDERPINNINGS LLP",
"OBGENIX SOFTWARE PRIVATE LIMITED",
"OBHAN WAREHOUSING PRIVATE LIMITED",
"OBI BOOK SHOP PRIVATE LIMITED",
"OBI INTERIORS INDIA PRIVATE LIMITED",
"OBIAL INDIA PRIVATE LIMITED",
"OBJECT AUTOMATION SYSTEM SOLUTIONS PRIVATE LIMITED",
"OBJECT EDGE INDIA SERVICES PRIVATE LIMITED",
"OBJECT- FRONTIER SOFTWARE PRIVATE LIMITED",
"OBJECT TECHNOLOGY SOLUTIONS INDIA PRIVATE LIMITED",
"OBJECTIFY TECHNOLOGIES PRIVATE LIMITED",
"OBJECTIWITTY AGROTECH PRIVATE LIMITED",
"OBJECTONE INFORMATION SYSTEMS LIMITED",
"OBJECTONE INFRA TECH LIMITED",
"OBJECTORB TECHNOLOGIES PRIVATE LIMITED",
"OBJECTSOL TECHNOLOGIES PRIVATE LIMITED",
"OBJECTWAYS TECHNOLOGIES",
"OBJECTWIN INTERNATIONAL PRIVATE LIMITED",
"OBJECTWIN TECHNOLOGY INDIA PRIVATE LIMITED",
"OBLUM ELECTRICAL INDUSTRIES PRIVATE LIMITED",
"OBM AUTOMATION PRIVATE LIMITED",
"OBN ASSOCIATE EXPRESS INDUSTRIES PRIVATE LIMITED",
"OBO BETTERMANN INDIA PRIVATE LIMITED",
"OBOPAY MOBILE TECHNOLOGY INDIA PRIVATE LIMITED",
"OBOX HR SOLUTIONS PRIVATE LIMITED",
"OBRA C BADAUN TRANSMISSION LIMITED",
"OBSC PERFECTION PRIVATE LIMITED",
"OBSERVANT INFRA PRIVATE LIMITED",
"OBSERVER RESEARCH FOUNDATION MUMBAI",
"OBSESSORY ONLINE SERVICES PRIVATE LIMITED",
"OBSI TECHNOLOGIES PRIVATE LIMITED",
"OBSIDIAN SOFTWARE PRIVATE LIMITED",
"OBSON INTERNATIONAL PRIVATE LIMITED",
"OBSURGE BIOTECH LIMITED",
"OBTENIR SOLUTIONS PRIVATE LIMITED",
"OBUL CONSULTANCY AND CONTRACTS PRIVATE LIMITED",
"OBVEZ LABS PRIVATE LIMITED",
"OBVIOUS VENTURES PRIVATE LIMITED",
"OC LOGISTICS INDIA PRIVATE LIMITED",
"OC SPECIALITIES CHEMICALS PRIVATE LIMITED",
"OC SPECIALITIES PRIVATE LIMITED",
"OCA PRODUCTIONS PRIVATE LIMITED",
"OCA SOLUTIONS PRIVATE LIMITED",
"OCAP CHASSIS PARTS PRIVATE LIMITED",
"OCASA DESIGN STUDIO PRIVATE LIMITED",
"OCCAM‚ÄôS PARADIGM",
"OCCASION XPERTS PRIVATE LIMITED",
"OCCASSIONS FOODS PRIVATE LIMITED",
"OCCIDENTAL PETROLEUM CORPORATION",
"OCCPL LOGISTICS PRIVATE LIMITED",
"OCEA MARINE COSMETICS PRIVATE LIMITED",
"OCEAIR INTERNATIONAL PRIVATE LIMITED",
"OCEALAND LOGISTICS INDIA PRIVATE LIMITED",
"OCEAN 2 DOOR INDIA PRIVATE LIMITED",
"OCEAN AGRO INDUSTRIES LIMITED",
"OCEAN AGRO INDUSTRIES PRIVATE LIMITED",
"OCEAN AQUAMIN PRIVATE LIMITED",
"OCEAN ARTS AND MERCANTILE PRIVATE LIMITED",
"OCEAN ASIATIC PRIVATE LIMITED",
"OCEAN BLUE BOATING PRIVATE LIMITED",
"OCEAN BLUE MANAGEMENT PRIVATE LIMITED",
"OCEAN CABLES PRIVATE LIMITED",
"OCEAN CAPITAL MARKET LTD.",
"OCEAN CARGO CONSOLIDATORS INDIA PRIVATE LIMITED",
"OCEAN CARPETS AND FURNISHING (INDIA) PRIVATE LIMITED",
"OCEAN CASSETTE BUSINESS COPIER PVT LTD",
"OCEAN CASTINGS PRIVATE LIMITED",
"OCEAN COGNIZANCE PRIVATE LIMITED",
"OCEAN CONSTRUCTIONS (INDIA) PRIVATE LIMITED",
"OCEAN CONTRACTORS PRIVATE LIMITED",
"OCEAN DIAL ADVISERS PRIVATE LIMITED",
"OCEAN DIAL ASSET MANAGEMENT INDIA PRIVATE LIMITED",
"OCEAN DREAM SPACES PRIVATE LIMITED",
"OCEAN DRINKS PRIVATE LIMITED",
"OCEAN ELEVATOR PRIVATE LIMITED",
"OCEAN EXIM INDIA PRIVATE LIMITED",
"OCEAN EXPRESS MANAGEMENT PRIVATE LIMITED",
"OCEAN EXTRUSIONS PRIVATE LIMITED",
"OCEAN FASTOGISTICS PRIVATE LIMITED",
"OCEAN FILAMENTS PRIVATE LIMITED",
"OCEAN FILM COMPANY PRIVATE LIMITED",
"OCEAN GATE CONTAINER TERMINALS PRIVATE LIMITED",
"OCEAN GEMS AND PEARLS DEALERS PRIVATE LIMITED",
"OCEAN GIGABYTES PRIVATE LIMITED",
"OCEAN GLASS TRADING INDIA PRIVATE LIMITED",
"OCEAN GLASS WORKS PRIVATE LIMITED",
"OCEAN GRANIMARMO PRIVATE LIMITED",
"OCEAN HEALTHCARE PRIVATE LIMITED",
"OCEAN IMPEX CONSTRUCTION INDIA PRIVATE LIMITED",
"OCEAN INFOWAYS PRIVATE LIMITED",
"OCEAN KING SHIPPING SERVICES PRIVATE LIMITED",
"OCEAN LIFECARE PRIVATE LIMITED",
"OCEAN LIFESPACES INDIA PRIVATE LIMITED",
"OCEAN LIFESPACES INFRA INDIA PRIVATE LIMITED",
"OCEAN MARINE ENVIRONMENT COATINGS PRIVATE LIMITED",
"OCEAN MOTORS PRIVATE LIMITED",
"OCEAN NAILS INDUSTRIES PRIVATE LIMITED",
"OCEAN NEON POWER INDIA PRIVATE LIMITED",
"OCEAN NETWORK EXPRESS INDIA PRIVATE LIMITED",
"OCEAN NON WOVENS PRIVATE LIMITED",
"OCEAN ONE PRIVATE LIMITED",
"OCEAN ORGANICS PRIVATE LIMITED",
"OCEAN PARK MULTI TECH PRIVATE LIMITED",
"OCEAN PEARL HOTELS MANGALORE",
"OCEAN PEARL HOTELS PRIVATE LIMITED",
"OCEAN PHARMACOAT PRIVATE LIMITED",
"OCEAN POLYMER TECHNOLOGIES PRIVATE LIMITED",
"OCEAN PRIDE LOGISTICS INDIA PRIVATE LIMITED",
"OCEAN PROTEINS PRIVATE LIMITED",
"OCEAN SCIENCE AND SURVEYING PRIVATE LIMITED",
"OCEAN SEA AND AIR LOGISTICS PRIVATE LIMITED",
"OCEAN SHELL PROJECTS PRIVATE LIMITED",
"OCEAN SPARKLE LIMITED",
"OCEAN STAR TECHNOLOGIES PRIVATE LIMITED",
"OCEAN STEELS PRIVATE LIMITED",
"OCEAN THERMOPLASTIC ELASTOMERS PRIVATE LIMITED",
"OCEAN TRANSWORLD LOGISTICS PRIVATE LIMITED",
"OCEAN UNICARE SECURITY SERVICES PRIVATE LIMITED",
"OCEAN WATERTECH INDIA PRIVATE LIMITED",
"OCEAN WAVES LEISURE PRIVATE LIMITED",
"OCEANBRAVE SHIPPING PRIVATE LIMITED",
"OCEANDEEP ENERGIES PRIVATE LIMITED",
"OCEANEERING INTERNATIONAL SERVICES LIMITED",
"OCEANGLOBE CONTAINER SERVICES INDIA PRIVATE LIMITED",
"OCEANIA AQUA (INDIA) PRIVATE LIMITED",
"OCEANIA SOFTWARE SOLUTIONS PRIVATE LIMITED",
"OCEANIC ARTS AND TILES PRIVATE LIMITED",
"OCEANIC AUTO FINLEASE PRIVATE LIMITED",
"OCEANIC BIO-HARVESTS LIMITED",
"OCEANIC BUILDCON PRIVATE LIMITED",
"OCEANIC CHLORIDES (INDIA) PRIVATE LIMITED",
"OCEANIC CONSULTANTS PRIVATE LIMITED",
"OCEANIC DEVELOPERS PVT LTD",
"OCEANIC ENVIRO (INDIA) PRIVATE LIMITED",
"OCEANIC FITNESS PRIVATE LIMITED",
"OCEANIC FOODS LIMITED",
"OCEANIC LABORATORIES PRIVATE LIMITED",
"OCEANIC PHARMACHEM PRIVATE LIMITED",
"OCEANIC SANDS PRIVATE LIMITED",
"OCEANIC SPIRITS PRIVATE LIMITED",
"OCEANIC TECHNO CHEM PRIVATE LIMITED",
"OCEANIC TRADE MINERALS PRIVATE LIMITED",
"OCEANID LOGISTICS PRIVATE LIMITED",
"OCEANIK BUILDTECH AND CONSTRUCTIONS PRIVATE LIMITED",
"OCEANKING LOGISTICS PRIVATE LIMITED",
"OCEANLIFE CREATIONS PRIVATE LIMITED",
"OCEANLINER SERVICES PRIVATE LIMITED",
"OCEANS CONNECT INDIA PRIVATE LIMITED",
"OCEAN'S PRIDE MARINE SERVICES PRIVATE LIMITED",
"OCEANSIDE TECHNOLOGIES PRIVATE LIMITED",
"OCEANTEK MARINE PRIVATE LIMITED",
"OCEANUM SHIPPING & LOGISTICS PRIVATE LIMITED",
"OCEANUS DWELLINGS PRIVATE LIMITED",
"OCEANVIEW LOGISTICS PRIVATE LIMITED",
"OCEANWHARF SHIPPING SERVICES PRIVATE LIMITED",
"OCEANWORLD SHIPPING & LOGISTICS (INDIA) PRIVATE LIMITED",
"OCECO ENERGY PRIVATE LIMITED",
"OCEL FABTECH PRIVATE LIMITED",
"OCELLI SYSTEMS PRIVATE LIMITED",
"OCELLUS CONSULTING PRIVATE LIMITED",
"OCEM AIRFIELD INDIA PRIVATE LIMITED",
"OCFO ENTERPRISES PRIVATE LIMITED",
"OCH DIGITECH PRIVATE LIMITED",
"OCHER LV SOLUTIONS PRIVATE LIMITED",
"OCHINT MARKETING PRIVATE LIMITED",
"OCHRE AND BLACK PRIVATE LIMITED",
"OCHRE INFRA PRIVATE LIMITED",
"OCHRE MEDIA PRIVATE LIMITED",
"OCHRON INTERIORS PRIVATE LIMITED",
"OCIMUM BIO SOLUTIONS INDIA LIMITED",
"OCIMUM LABS PRIVATE LIMITED",
"OCIMUM LIFE SCIENCES PRIVATE LIMITED",
"OCIMUM SYSTEMS PRIVATE LIMITED",
"OCIO HOLIDAYS PRIVATE LIMITED",
"OCL CONTAINER LINES (INDIA) PRIVATE LIMITED",
"OCL INVESTMENTS AND LEASING LTD",
"OCL SHIPPING (INDIA) PRIVATE LIMITED",
"OCM LOGISTICS LIMITED",
"OCMI GLASS MACHINERY MANUFACTURERS INDIA PRIVATE LIMITED",
"OCP INDIA PRIVATE LIMITED",
"OCP SUPPORT SERVICES PRIVATE LIMITED",
"OCREX ENTERPRISES PRIVATE LIMITED",
"OCRIM INTERNATIONAL TECHNOLOGIES PRIVATE LIMITED",
"OCROLUS EAST PRIVATE LIMITED",
"OCS DESIGNS PRIVATE LIMITED",
"OCS ENGINEERING & CONSTRUCTION (INDIA) PRIVATE LIMITED",
"OCS NETWORKING SOLUTIONS PRIVATE LIMITED",
"OCS SERVICES INDIA PRIVATE LIMITED",
"OCS TECHNICAL SOLUTIONS INDIA PRIVATE LIMITED",
"OCT DATA SYSTEMS PRIVATE LIMITED",
"OCTA 8 EVOLUTIONS PRIVATE LIMITED",
"OCTAGON FREIGHT EXPRESS PRIVATE LIMITED",
"OCTAGON MEASUREMENT SOLUTIONS PRIVATE LIMITED",
"OCTAGON OILS LLP",
"OCTAGON PRECISION INDIA PRIVATE LIMITED",
"OCTAGON PULSES PRIVATE LIMITED",
"OCTAGON SOLAR PRIVATE LIMITED",
"OCTAGONA INDIA PRIVATE LIMITED",
"OCTAL CREDIT CAPITAL LTD.",
"OCTAL IT SOLUTION LLP",
"OCTAL SALES PRIVATE LIMITED",
"OCTANE BIOTECH PRIVATE LIMITED",
"OCTANE CAR RENTAL LLP",
"OCTANE CONTROL & INSTRUMENTATION PRIVATE LIMITED",
"OCTANE ECOWARES PRIVATE LIMITED",
"OCTANE MARKETING PRIVATE LIMITED",
"OCTANE MOBILE PRIVATE LIMITED",
"OCTANE SEALING TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"OCTANE SOFTWARE SOLUTIONS INDIA LLP",
"OCTANTIS SERVICES PRIVATE LIMITED",
"OCTASHOP ERETAIL SERVICES PRIVATE LIMITED",
"OCTAUNITECH SOLUTIONS PRIVATE LIMITED",
"OCTAVE DISTRIBUTORS PRIVATE LIMITED",
"OCTAVE INFOTECH PRIVATE LIMITED",
"OCTAVIUS INDUSTRIES LIMITED",
"OCTAVIUS PHARMA PRIVATE LIMITED",
"OCTAVIUS PLANTATIONS LIMITED",
"OCTAVO SOLUTIONS PRIVATE LIMITED",
"OCTAVUS CONSULTING PRIVATE LIMITED",
"OCTAWARE INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"OCTEL NETWORKS PRIVATE LIMITED",
"OCTET CHEMICALS PRIVATE LIMITED",
"OCTET PHARMACHEM PRIVATE LIMITED",
"OCTEX PROCESSORS PRIVATE LIMITED",
"OCTILLION POWER SYSTEMS INDIA PRIVATE LIMITED",
"OCTOGEN TRADELINKS (INDIA) PRIVATE LIMITED",
"OCTONUS DIA TECH PRIVATE LIMITED",
"OCTOPOLIS TECHNOLOGIES PRIVATE LIMITED",
"OCTOPUS ENTERTAINMENT PRIVATE LIMITED",
"OCTOPUS SYSTEMS PRIVATE LIMITED",
"OCTOZE TECHNOLOGIES PRIVATE LIMITED",
"OCTUS LIFECARE PRIVATE LIMITED",
"OCULAR HOLOGRAPHY FILMS PRIVATE LIMITED",
"OCULUS BUILDING PRODUCTS PRIVATE LIMITED",
"OCUS FACILITY MANAGEMENT PRIVATE LIMITED",
"OCUS SKYSCRAPERS REALTY PRIVATE LIMITED",
"OCWEN FINANCIAL SOLUTIONS PRIVATE LIMITED",
"OD BUSINESS SOLUTIONS PRIVATE LIMITED",
"OD COMMUNICATIONS PRIVATE LIMITED",
"OD CREATIONS PRIVATE LIMITED",
"ODAK SOLUTIONS PRIVATE LIMITED",
"ODC UNIVERSAL TECHNOLOGICAL SOLUTIONS PRIVATE LIMITED",
"ODCEM TECHNOLOGIES PRIVATE LIMITED",
"ODD GIRAFFE LIFESTYLE PRIVATE LIMITED",
"ODD JOBS INDIA PRIVATE LIMITED",
"ODDAKA INFRATECH PRIVATE LIMITED",
"ODDINARY MARKETING INDIA PRIVATE LIMITED",
"ODDITY HEALTHCARE PRIVATE LIMITED",
"ODDMANS INDIA PRIVATE LIMITED",
"ODDWAY ICARE PRIVATE LIMITED",
"ODE CONSULTANTS PRIVATE LIMITED",
"ODEI ENGINEERS INDIA PRIVATE LIMITED",
"ODEK APPCRAFT PRIVATE LIMITED",
"ODEL SYSTEMS PRIVATE LIMITED",
"ODEON CONSTRUCTIONS AND DEVELOPERS PRIVATE LIMITED",
"ODESSA SOLUTIONS PRIVATE LIMITED",
"ODESSA TECHNOLOGIES",
"ODEX INDIA SOLUTIONS PRIVATE LIMITED",
"ODGERS BERNDTSON INDIA PRIVATE LIMITED",
"ODHAV ENVIRO PROJECTS LIMITED",
"ODHAV ESTATE INFRASTRUCTURE DEVELOPMENT LIMITED",
"ODHAV MET TRADE PRIVATE LIMITED",
"ODHAV REALTIES PRIVATE LIMITED",
"ODHAVRAM OVERSEAS PRIVATE LIMITED",
"ODICEA DISTRIBUTION TECHNOLOGIES PRIVATE LIMITED",
"ODIGMA CONSULTANCY SOLUTIONS LIMITED",
"ODIGOTECH SOLUTIONS PRIVATE LIMITED",
"ODIN CONTROLS PVT LTD",
"ODIN HEALTHCARE PRIVATE LIMITED",
"ODIN INSURANCE BROKING SERVICES PRIVATE LIMITED",
"ODIN SYSTEM PRIVATE LIMITED",
"ODIO ZONE PRIVATE LIMITED",
"ODI-RAY INDUSTRIES LIMITED",
"ODISERVE TOURS AND HOSPITALITY PRIVATE LIMITED",
"ODISHA ADARSHA VIDYALAYA",
"ODISHA AGRI BIOGENETICS PRIVATE LIMITED",
"ODISHA AGRO INDUSTRIES CORPORATION LIMITED",
"ODISHA AQUA TRADERS AND MARINE EXPORTERS PRIVATE LIMITED",
"ODISHA BRIDGE AND CONSTRUCTION CORPORATION LIMITED",
"ODISHA COAL AND POWER LIMITED",
"ODISHA COMPUTER APPLICATION CENTRE",
"ODISHA ELECTRONIC PARK LIMITED",
"ODISHA FOREST DEVELOPMENT CORPORATION LIMITED",
"ODISHA GENERATION PHASE-II TRANSMISSION LIMITED",
"ODISHA GRAMYA BANK",
"ODISHA HYDRO POWER CORPORATION LIMITED",
"ODISHA INFRAPOWER LIMITED",
"ODISHA KNOWLEDGE CORPORATION LIMITED",
"ODISHA MINERAL BEARING AREAS DEVELOPMENT CORPORATION",
"ODISHA MINING CORPORATION LIMITED",
"ODISHA MULTISPECIALITY HOSPITAL AND TRAUMA CARE CENTRE PRIVATE LIMITED",
"ODISHA ORTHOPAEDICS HOSPITAL PRIVATE LIMITED",
"ODISHA POWER GENERATION CORPORATION LIMITED",
"ODISHA POWER TRANSMISSION CORPORATION LIMITED",
"ODISHA POWERCARE PRIVATE LIMITED",
"ODISHA PREFAB ENGINEERING PRIVATE LIMITED",
"ODISHA PRODUCER COMPANY LIMITED",
"ODISHA RAIL INFRASTRUCTURE DEVELOPMENT LIMITED",
"ODISHA SHRIMP TRADING & EXPORTS PRIVATE LIMITED",
"ODISHA STATE ARCHALOGY",
"ODISHA STATE BEVERAGES CORPORATION LIMITED",
"ODISHA STATE CIVIL SUPPLIES CORPORATION LIMITED",
"ODISHA STATE CO-OPERATIVE MARKETING FEDERATION LTD",
"ODISHA STATE HOUSING BOARD",
"ODISHA STATE POLICE HOUSING AND WELFARE CORPORATION LIMITED",
"ODISHA TELEVISION LIMITED",
"ODISHA THERMAL POWER CORPORATION LIMITED",
"ODISHA TOURISM DEVELOPMENT CORPORATION LIMITED",
"ODISHA UNIVERSITY OF AGRICULTURE AND TECHNOLOGY",
"ODISHA VACATIONS SERVICES PRIVATE LIMITED",
"ODISHI TOOLS PRIVATE LIMITED",
"ODISSA WATER SUPPLY AND SEWERAGE BOARD",
"ODI-TECH PROPERTIES PRIVATE LIMITED",
"ODITEK SOLUTIONS PRIVATE LIMITED",
"ODITI GLOBAL SOLUTIONS PRIVATE LIMITED",
"ODIVISSA HEALTH RESEARCH PRIVATE LIMITED",
"ODM DIGITAL LLP",
"ODN DIGITAL SERVICES PRIVATE LIMITED",
"ODOO IN PRIVATE LIMITED",
"ODRA ASSOCIATES PRIVATE LIMITED",
"ODRWAYS SOLUTIONS PRIVATE LIMITED",
"ODS PROTECTIVE SERVICES PRIVATE LIMITED",
"ODSF AGRO PRODUCER COMPANY LIMITED",
"ODT INDIA CENTER OF EXCELLENCE PRIVATE LIMITED",
"ODYSSE ELECTRIC VEHICLES PRIVATE LIMITED",
"ODYSSEUS SOLUTIONS PRIVATE LIMITED",
"ODYSSEY CAPITAL PRIVATE LIMITED",
"ODYSSEY COMPUTER SERVICES PRIVATE. LIMITED",
"ODYSSEY CORPORATION LIMITED",
"ODYSSEY CRAFT PRIVATE LIMITED",
"ODYSSEY DISTRIBUTORS PRIVATE LIMITED",
"ODYSSEY JEWELS PRIVATE LIMITED",
"ODYSSEY LOGISTICS PRIVATE. LIMITED.",
"ODYSSEY MICROTRENDS PRIVATE LIMITED",
"ODYSSEY MOTORS PRIVATE LIMITED",
"ODYSSEY ORGANICS PRIVATE LIMITED",
"ODYSSEY TECHNOLOGIES LIMITED",
"ODYSSEY TOURS AND TRAVELS PRIVATE LIMITED",
"ODZ SERVICES",
"OEASY MART GROCERY PRIVATE LIMITED",
"OEC INDIA SERVICES PRIVATE LIMITED",
"OEC RECORDS MANAGEMENT COMPANY PRIVATE LIMITED",
"OECL SHIPPING AND LOGISTICS PRIVATE LIMITED",
"O-EIGHT RETAIL PRIVATE LIMITED",
"OEL SHIPPING PRIVATE LIMITED",
"OEM GURU INDUSTRIES PRIVATE LIMITED",
"OEM HI-TECH GLOBAL PRIVATE LIMITED",
"OEMZ4U IT SOLUTIONS PRIVATE LIMITED",
"OEPL COMMUNICATION PRIVATE LIMITED",
"OERLIKON BALZERS COATING INDIA PRIVATE LIMITED",
"OERLIKON FRICTION SYSTEMS (INDIA) PRIVATE LIMITED",
"OERLIKON FRICTION SYSTEMS INDIA LIMITED",
"OERLIKON LEYBOLD VACUUM INDIA PRIVATE LIMITED",
"OERLIKON TEXTILE INDIA PRIVATE LIMITED",
"OES EXPORT IMPORT PRIVATE LIMITED",
"OESPL PRIVATE LIMITED",
"OETIKER INDIA PRIVATE LIMITED",
"OFACTO FASHION EXPORTS PRIVATE LIMITED",
"OFB TECH PRIVATE LIMITED",
"OFC FOODS & CONFECTIONERY PRIVATE LIMITED",
"OFCA POWER TECHNOLOGY PRIVATE LIMITED",
"OFER MIZRAHI DIAMOND PRIVATE LIMITED",
"OFF OF THE DIRECTOR OF ACCTS CABINET SECRETARIAT",
"OFF ROAD FILMS PRIVATE LIMITED",
"OFFBEAT APPARELS INDIA PRIVATE LIMITED",
"OFFBEAT DEVELOPERS PRIVATE LIMITED",
"OFFBEAT TRAILS PRIVATE LIMITED",
"OFFCE OF DISTRICT CO-ORDINATOR",
"OFFGRID ENERGY LABS PRIVATE LIMITED",
"OFF-HIGHWAY RESEARCH INDIA PRIVATE LIMITED",
"OFFICE 2000 SOLUTIONS PRIVATE LIMITED",
"OFFICE ASSISTANT ENGINEER PUBLIC HEALTH MECHANICAL MAINTENANCE",
"OFFICE BANDOBAST ADHIKARI CHAKBANDHI",
"OFFICE BEACON ADMINISTRATIVE SERVICES PRIVATE LIMITED",
"OFFICE CARE SERVICES LIMITED",
"OFFICE DEPOT INC.",
"OFFICE DEPUTY COMMISSIONER GST KANPUR",
"OFFICE DISTRICT HOMEOPATHIC MEDICAL OFFICER LUCKNOW",
"OFFICE DISTRICT JUDGE",
"OFFICE JANPAD PANCHYAT",
"OFFICE OF ADDITIONAL DIRECTOR GENERAL (DESIGN & CONSULTANCY )",
"OFFICE OF ASSISTANT COMMISSIONAR",
"OFFICE OF BLOCK MEDICAL OFFICER",
"OFFICE OF CHIEF ENGINEER PUBLIC HEALTH ENGINEERING DEPARTMENT",
"OFFICE OF CHIEF EXECUTIVE OFFICE",
"OFFICE OF CHIEF MEDICAL SUPERINTENDENT CIVIL HOSPITAL",
"OFFICE OF DIRECTOR GENERAL INSTITUTIONAL FINANCE , BIMA AND EXTERNAL AIDED PROJESCT U.P",
"OFFICE OF JILA MAGISTRATE",
"OFFICE OF LOKAYUKTA",
"OFFICE OF MADARSA JAMA E MAHDIA",
"OFFICE OF MUNICIPAL COUNCIL MAHIDPUR DIST UJJAIN",
"OFFICE OF NAGAR PANCHAYAT",
"OFFICE OF NAGAR PANCHAYAT DONGARGAON",
"OFFICE OF REGIONAL HEAD DIRECTORATE OF GEOLOGY & MINING CHHATTISGHAR REGIONAL OFFICE BAHATARI ROAD BILASPUR CG",
"OFFICE OF SUPERINTENDENT",
"OFFICE OF THE ACCOUNTANT GENERAL",
"OFFICE OF THE ASSISTANT DIRECTOR OF AGRICULTUREADMINISTRATIONSOCIO ECONOMIC & EVALUATION",
"OFFICE OF THE ASSISTANT DIRECTOR OF CO-OPERATIVE AUDIT",
"OFFICE OF THE ASSISTANT DIRECTOR OF FISHERIES",
"BLOCK EDUCATION OFFICER DASARATHPUR",
"OFFICE OF THE BLOCK EDUCATION OFFICER TOKAPAL BLOCK",
"OFFICE OF THE BLOCK EDUCATION OFFICER,ANGUL",
"OFFICE OF THE BLOCK MEDICAL OFFICER COMMUNITY HEALTH CENTRE DHARSIWA RAIPUR",
"OFFICE OF THE BMO UDAIPURSURGUJA CG",
"OFFICE OF THE BOARD OF COUNCILLORS NEW BARRACKPORE MUNICIPALITY",
"OFFICE OF THE CANE COMMISSIONER UP",
"OFFICE OF THE CDA COAST GUARD DELHI",
"OFFICE OF THE CHHATTISGSRH INSTITUTE OF MEDICAL SCIENC",
"OFFICE OF THE CHIEF ACCOUNTS OFFICER G A D C G MANTRALAYA NAYA RAIPUR",
"OFFICE OF THE CHIEF DISTRICT MEDICAL & PUBLIC HEALTH OFFICER",
"OFFICE OF THE CHIEF METROPOLITAN MAGISTRATE CALCUTTA",
"OFFICE OF THE CIVIL SURGEN CUM CHIEF HOSPITAL SUPERINTENDENT DISTRICT HOSPITAL",
"OFFICE OF THE COLLECTOR AND DISTRICT MAGISTRATE",
"OFFICE OF THE COMMSSIONER OF POLICE",
"OFFICE OF THE DEAN &CEO DR LAXMINARAYAN PANDEY GOVT MEDICAL COLLAGE RATLAM",
"OFFICE OF THE DEAN AND CEO GOVT MEDICAL COLLEGE RATLAM RATLAM",
"OFFICE OF THE DEAN CHHINDWARA INSTITUTE OF MEDICAL SCIENCES CHHINDWARA",
"OFFICE OF THE DEAN GOA MEDICAL COLLEGE BAMBOLIM",
"OFFICE OF THE DEAN MEDICAL COLLEGE JABALPUR",
"OFFICE OF THE DEPUTY CHIEF LABOUR COMMISSIONER(CENTRAL) MUMBAI",
"OFFICE OF THE DEPUTY COMMISSIONER OF POLICE SOUTH WEST DIVIN BEHELA KOLKATA",
"OFFICE OF THE DEPUTY CONTROLLER GOVT CENTRAL PRESS BHOPAL",
"OFFICE OF THE DEPUTY CONTROLLER OF RATIONING",
"OFFICE OF THE DEPUTY DIRECTOR MINI FORENSIC SCIENCE LABORATORY RATNAGIRI",
"OFFICE OF THE DEPUTY EXECUTIVE ENGINEER MEDICAL R&B SUB DIVISION JAMNAGAR",
"OFFICE OF THE DIRECTOR GEER FOUNDATION GANDHINAGAR",
"OFFICE OF THE DIRECTOR GENERAL OF AUDIT",
"OFFICE OF THE DIRECTOR REGIONAL INSTITUTE OF OPHTHALMOLOGY M D EYE HOSPITAL",
"OFFICE OF THE DISTRICT & SESSIONS JUDGE",
"OFFICE OF THE DISTRICT MAGISTRATE KANPUR DEHAT",
"OFFICE OF THE DISTRICT MALARIA OFFICER",
"OFFICE OF THE DISTRICT MARKETING OFFICER",
"OFFICE OF THE DISTT CANE OFFICER BAREILLY",
"OFFICE OF THE DIVISIONAL FOREST OFFICER GOVT T.T AND S PLANT DIVISION",
"OFFICE OF THE EXECUTIVE ENGINEER DAMANGANGA PROJECT",
"OFFICE OF THE EXECUTIVE ENGINEER MINIMATA BANGO DAM DIVISION NO 3 MACHDOLI KORBA CHHTISHGARH",
"OFFICE OF THE EXECUTIVE ENGINEER NATIONAL HIGHWAY DIVISION",
"OFFICE OF THE EXECUTIVE ENGINEER PWD DURG DIVISION DURG",
"OFFICE OF THE EXECUTIVE ENGINEER WATER RESOURCES DIVISION",
"OFFICE OF THE FOOD CONTROLER",
"OFFICE OF THE FOOD CONTROLER JAGDALPUR",
"OFFICE OF THE GARRISON ENGINEER (ARMY) BARODA",
"OFFICE OF THE GENERAL MANAGER MPRRDA PIU 1 KHARGONE",
"OFFICE OF THE INSPECTOR GENERAL FRONTIER HQRS SSB",
"OFFICE OF THE JOINT COMMISSIONER OF COMMERCIAL TAX DIVISON -1",
"OFFICE OF THE JOINT DIRECTOR CUM SUPERINTENDENT GANDHI MEMORIAL HOSPITAL REWA M.P",
"OFFICE OF THE JOINT DIRECTOR OF HEALTH SERVICE",
"OFFICE OF THE JUDGES COURT BAREILLY",
"OFFICE OF THE MAMLATDAR MAJURA SURAT",
"OFFICE OF THE MANAGING DIRECTOR DISTRICT UNION RAJNANDGAON",
"OFFICE OF THE MEDICAL SUPERINTENDENT CUM VICE PRINCIPAL",
"OFFICE OF THE MEDICAL SUPERINTENDENT ESIS HOSPITAL VASHI",
"OFFICE OF THE MEDICAL SUPERINTENDENT RURAL HOPITAL RAJUR TALUKA BHOKARDAN DISTRICT JALNA",
"OFFICE OF THE MEDICAL SUPERITENDENT CLASS 1 RURAL HOSPITAL SHIRUR ANANTPAL",
"OFFICE OF THE MENTAL HOSPITAL BAREILLY",
"OFFICE OF THE OFFICIAL LIQUIDATOR HIGH COURT CALCUTTA",
"OFFICE OF THE POLICE TRAINING SCHOOL",
"OFFICE OF THE PRINCIPAL ACCOUNTANT GENERAL AANDE",
"OFFICE OF THE PRINCIPAL ASSAM MEDICAL COLLEGE GOVT OF ASSAM",
"OFFICE OF THE PRINCIPAL CHIEF CONSERVATOR OF FOREST",
"OFFICE OF THE PRINCIPAL G S V M MEDICAL COLLEGE",
"OFFICE OF THE PRINCIPAL GOVT H S S NIYANAR",
"OFFICE OF THE PRINCIPAL GOVT HIGHER SECONDARY SCHOOL",
"OFFICE OF THE PRINCIPAL GOVT. POLYTECHNIC COLLEGE DHAR",
"OFFICE OF THE PRINCIPAL GURU GOBIND SINGH MEDICAL COLLEGE",
"OFFICE OF THE PRINCIPAL NEW GOVERNMENT ENGINEERING COLLEGE",
"OFFICE OF THE PROFESSOR OF RADIOTHERAPY CUM SUPRITENDENT CANCER HOSPITAL JABALPUR",
"OFFICE OF THE PURI MUNICIPALITY PURI",
"OFFICE OF THE R H & CHC SONGADH DIST TAPI",
"OFFICE OF THE REGIONAL COMMISSIONER COAL MINES PROVIDENT FUND ORGANIZATION GOVT. OF INDIA MINISTRY OF COAL",
"OFFICE OF THE SPECIAL PUBLIC PROSECUTOR UNDER OPID ACT CUTTACK",
"OFFICE OF THE SUB DIVISIONAL OFFICER BASIRHAT",
"OFFICE OF THE SUPERINTENDENT DISTRICT HOSPITAL NODIA",
"OFFICE OF THE SUPERINTENDENT REFERAL HOSPITAL AND CHC JAMBUDA",
"OFFICE OF THE SUPRITENDENT OF POLICE",
"OFFICE OF THE TAHSILDAR AMBIKAPUR",
"OFFICE OF THE TAHSILDAR TOKAPAL",
"OFFICE OF THE TOWN PLANNER HIMATNAGAR",
"OFFICE OF THE ZILA PANCHAYAT KHARGONE",
"OFFICE PLUS LIMITED",
"OFFICE PRINCIPAL RAJKIYA BALIKA INTER COLLEGE UNNAO",
"OFFICE STAG SOLUTIONS PRIVATE LIMITED",
"OFFICE¬†OF THE COLLECTOR¬†FOOD CONTROLLER¬†IN¬†JAGDALPUR",
"OFFICEBAZZAR E-STORE PRIVATE LIMITED",
"OFFICEDECK TECHNOLOGIES PRIVATE LIMITED",
"OFFICEFRAMEWORK OPERATIONS CENTER PRIVATE LIMITED",
"OFFICEPULSE TECHNOLOGY PRIVATE LIMITED",
"OFFICER COMMANDING 1 MP BN REGT NCC JABALPUR MADHYA PRADESH",
"OFFICER INCHARGE REG PUB HEALTH LAB NAGPUR",
"OFFICERS IAS ACADEMY",
"OFFICUS INFRASTRUCTURE PRIVATE LIMITED",
"OFFING GROUP PRIVATE LIMITED",
"OFFSHOOT AGENCY PRIVATE LIMITED",
"OFFSHOOT GREEN RECYCLING INDUSTRIES PRIVATE LIMITED",
"OFFSHORE A ONE TECHNOLOGY PRIVATE LIMITED",
"OFFSHORE ACCOUNTING AND TAXATION SERVICES PRIVATE LIMITED",
"OFFSHORE ENGINEERING DESIGN AND ENERGY CONSULTANTS PRIVATE LIMITED",
"OFFSHORE EVOLUTION PRIVATE LIMITED",
"OFFSHORE FINVEST LTD",
"OFFSHORE HCL GLOBAL SYSTEMS INDIA PRIVATE LIMITED",
"OFFSHORE HOOKUP AND CONSTRUCTION SERVICES (I) PVT LTD",
"OFFSHORE INFRASTRUCTURES LIMITED",
"OFFSHORE INTERNATIONAL MANAGEMENT PRIVATE LIMITED",
"OFFSHORE IT SERVICES PRIVATE LIMITED",
"OFFSHORE MARINE COMPLEX INDIA PRIVATE LIMITED",
"OFFSHORE MARINETECH PRIVATE LIMITED",
"OFFSHORE PETROCHEM PRIVATE LIMITED",
"OFFSHORE PETROLUBES PRIVATE LIMITED",
"OFFSHORE TECHNOLOGY CONSULTANTS PRIVATE LIMITED",
"OFFSHORE UT IN PRIVATE LIMITED",
"OFFSHORENT SOLUTIONS PRIVATE LIMITED",
"OFFSPRING ENGINEERING SOLUTIONS PRIVATE LIMITED",
"OFG MANUFACTURING BUSINESSES PRIVATE LIMITED",
"OFIC BUILDING MATERIALS INDIA PRIVATE LIMITED",
"OFNI SERVICES PRIVATE LIMITED",
"OFR TELECOM PRIVATE LIMITED",
"OFS CARGO PRIVATE LIMITED",
"OFS INDUSTRIES PRIVATE LIMITED",
"OG CORPORATION INDIA PRIVATE LIMITED",
"OG GROCERY AND SERVICES PRIVATE LIMITED",
"OG HEATHCARE TECHNOLOGIES PRAIVATE LIMITED",
"OG INFRASTRUCTURE PRIVATE LIMITED",
"OGAAN INDIA PRIVATE LIMITED",
"OGAAN MEDIA PRIVATE LIMITED",
"OGAAN RETAIL PRIVATE LIMITED",
"OGAS EQUIPMENTS PRIVATE LIMITED",
"OGATA MOTORS INDIA PRIVATE LIMITED",
"OGD SERVICES LIMITED",
"OGEE STUDIO INDIA PRIVATE LIMITED",
"OGEMS CONTROLS PRIVATE LIMITED",
"OGENE SYSTEMS INDIA LIMITED",
"OGES SOLUTIONS PRIVATE LIMITED",
"OGI SOFTWARE PRIVATE LIMITED",
"OGI TECHNOLOGIES PRIVATE LIMITED",
"OGILVY AND MATHER PRIVATE LIMITED",
"OGIVES COOLING SYSTEMS PRIVATE LIMITED",
"OGMA CONSULTING PRIVATE LIMITED",
"OGMA IT CONCEPTIONS PRIVATE LIMITED",
"OGN POWER & INFRA PRIVATE LIMITED",
"OGNAM TECHNOLOGY SERVICES PRIVATE LIMITED",
"OGNIBENE INDIA PRIVATE LIMITED",
"OGO FIBERS INDIA PRIVATE LIMITED",
"OGONGLOBAL PRIVATE LIMITED",
"OGR ESTATES PRIVATE LIMITED",
"OGRELOGIC SOLUTIONS PRIVATE LIMITED",
"OGS PAYLAB PRIVATE LIMITED",
"OGSET TECHNOLOGIES PRIVATE LIMITED",
"OGSP OIL & GAS PRIVATE LIMITED",
"OGURA CLUTCH INDIA PRIVATE LIMITED",
"OH SO STONED ICE CREAMS PRIVATE LIMITED",
"OH TRAVEL EXPERIENCES PRIVATE LIMITED",
"OHA COMMUTE PRIVATE LIMITED",
"OHAD PHARMACEUTICALS PRIVATE LIMITED",
"OHANA FIRST CAPITAL PRIVATE LIMITED",
"OHAUS WEIGHING INDIA PRIVATE LIMITED",
"OHEALER HEALTHCARE SERVICES PRIVATE LIMITED",
"OHM ARTS PRIVATE LIMITED",
"OHM AUTOMOTIVE PRIVATE LIMITED",
"OHM DESIGNS",
"OHM DOVETAIL PRIVATE LIMITED",
"OHM EDUBRIDGE PRIVATE LIMITED",
"OHM ENERGY MANAGEMENT SYS PRIVATE LIMITED",
"OHM ENGINEERS AND ELECTRICALS PRIVATE LIMITED",
"OHM ENTERTAINMENT PRIVATE LIMITED",
"OHM HOSPITAL",
"OHM HOSPITAL PRIVATE LIMITED",
"OHM PACKAGINGS PRIVATE LIMITED",
"OHM PIPES PRIVATE LIMITED",
"OHM POLYTECH PRIVATE LIMITED",
"OHM PORTFOLIO EQUI RESEARCH PRIVATE LIMITED",
"OHM STOCK BROKER PRIVATE LIMITED",
"OHMARK CONTROLS PRIVATE LIMITED",
"OHMASCON PRIVATE LIMITED",
"OHMI INDUSTRIES ASIA PRIVATE LIMITED",
"OHMS ENERGY PRIVATE LIMITED",
"OHMSAKTHI INFRADEV PRIVATE LIMITED",
"OHRI PRODUCTIONS PRIVATE LIMITED",
"OHRI STEELS PRIVATE LIMITED",
"OHRN ENTERPRISES PRIVATE LIMITED",
"OHSAN FORM-TECH PRIVATE LIMITED",
"OHSUNG INDIA PRIVATE LIMITED",
"OHUM HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"OHV DIAGNOSTIC PRIVATE LIMITED",
"OI DIGITAL PRIVATE LIMITED",
"OIA GLOBAL INDIA PRIVATE LIMITED",
"OIKOS INDIA PRIVATE LIMITED",
"OIL & GAS PLANT ENGINEERS (INDIA) PRIVATE LIMITED",
"OIL AND NATURAL GAS CORPORATION LIMITED",
"OIL FIELD INSTRUMENTATION (INDIA) PRIVATE LIMITED",
"OIL FIELD WAREHOUSE & SERVICES LIMITED",
"OIL FIELD WAREHOUSE & SERVICES PRIVATE LIMITED",
"OIL INDIA LIMITED",
"OIL LUBE SYSTEMS PRIVATE LIMITED",
"OIL PALM INDIA LIMITED",
"OIL STATES INDUSTRIES (INDIA) PRIVATE LIMITED",
"OIL VALLEY ENTERPRISES PRIVATE LIMITED",
"OILCHEM INDUSTRIES PRIVATE LIMITED",
"OILCO SERVICES INDIA LIMITED",
"OILES INDIA PRIVATE LIMITED",
"OILEX ENGINERS (INDIA) PVT LTD",
"OILEX TRADING PRIVATE LIMITED",
"OILFIELD COMPONENTS (INDIA) PRIVATE LIMITED",
"OILFIELD EQUIPMENTS PRIVATE LIMITED",
"OILFIELD SERVICES & SUPPLIES KAKINADA PRIVATE LIMITED",
"OILFIELD SERVICES AND SUPPLIES INDIA PRIVATE LIMITED",
"OILGEAR INDIA PRIVATE LIMITED",
"OILMAX ENERGY PRIVATE LIMITED",
"OILMAX SYSTEMS PRIVATE LIMITED",
"OILMEC DRILLING EQUIPMENTS PRIVATE LIMITED",
"OILTECH ENGINEERING INDIA PRIVATE LIMITED",
"OILTECH LUBRICANTS PRIVATE LIMITED",
"OILWELL PRODUCTS INDIA PRIVATE LIMITED",
"OIPL INDIA PRIVATE LIMITED",
"OIS VISA SERVICES PRIVATE LIMITED",
"OISHI FOODS PRIVATE LIMITED",
"OISHI MACHINE INDIA PRIVATE LIMITED",
"OISIN TRADERS PRIVATE LIMITED",
"OIT INFRASTRUCTURE MANAGEMENT LIMITED",
"OITOLABS TECHNOLOGIES PRIVATE LIMITED",
"OIVI TECH PRIVATE LIMITED",
"OIZOM INSTRUMENTS PRIVATE LIMITED",
"OIZTA SCREENOX MEDIA PRIVATE LIMITED",
"OJ FASHIONS INDIA PRIVATE LIMITED",
"OJ INSURANCE BROKERS PRIVATE LIMITED",
"OJA AUTOMOBILES PRIVATE LIMITED",
"OJA MOTORS DEALER PRIVATE LIMITED",
"OJAANK FOUNDATION PRIVATE LIMITED",
"OJAH COMMUNICATION & CONTRACTS PRIVATE LIMITED",
"OJAS ASSET RECONSTRUCTION COMPANY LIMITED",
"OJAS COLLEGE OF PHARMACY",
"OJAS INNOVATIVE TECHNOLOGIES PRIVATE LIMITED",
"OJAS LIFE SCIENCES (OPC) PRIVATE LIMITED",
"OJAS MALL MANAGEMENT PRIVATE LIMITED",
"OJAS MEDICAL SERVICES PRIVATE LIMITED",
"OJAS MULTISPECIALITY HOSPITAL",
"OJAS SALES PRIVATE LIMITED",
"OJAS SOFTECH PRIVATE LIMITED",
"OJAS SUPPLIERS LIMITED",
"OJAS SYSTEMS PRIVATE LIMITED",
"OJAS TARMAKE LIMITED",
"OJASHAVI MULTISERVICES PRIVATE LIMITED",
"OJASS AUTO COMPONENTS PRIVATE LIMITED",
"OJASVI MACHINES PRIVATE LIMITED",
"OJASVI TOURS AND TRAVELS PRIVATE LIMITED",
"OJASWA POLY PACK PRIVATE LIMITED",
"OJASWI MARBLES AND GRANITES PRIVATE LIMITED",
"OJASYNC PRIVATE LIMITED",
"OJB HERBALS PRIVATE LIMITED",
"OJEWEL INDUSTRIES PRIVATE LIMITED",
"OJI INDIA PACKAGING PRIVATE LIMITED",
"OJI INTERPACK INDIA PRIVATE LIMITED",
"OJOS DEVELOPERS PRIVATE LIMITED",
"OJUS TECH SOLUTIONS PRIVATE LIMITED",
"OK FOOD PRIVATE LIMITED",
"OK HOSIERY MILLS PRIVATE LIMITED",
"OK LIFECARE PRIVATE LIMITED",
"OK PLAY AUTO PRIVATE LIMITED",
"OKA-BASU'S METAL TECHNOLOGIES PRIVATE LIMITED",
"OKARA FUELOGICS PRIVATE LIMITED",
"OKARANGO DATA TECHNOLOGIES PRIVATE LIMITED",
"OKASA PRIVATE LIMITED",
"OKAY AUXIPOL PRIVATE LIMITED",
"OKAY CALL CENTRE PRIVATE LIMITED",
"OKAY DIAGNOSTIC RESEARCH CENTRE PRIVATE LIMITED",
"OKAY FERN PRECISION CASTINGS PRIVATE LIMITED",
"OKAY LOGISTICS PRIVATE LIMITED",
"OKAY MICRON PRIVATE LIMITED",
"OKAY PAPER PRODUCTS PRIVATE LIMITED",
"OKAY TOOLS PVT LTD",
"OKAYA & CO INDIA PRIVATE LIMITED",
"OKAYA ENERGY STORAGE SOLUTIONS PRIVATE LIMITED",
"OKAYA EV PRIVATE LIMITED",
"OKAYA INFOCOM PRIVATE LIMITED",
"OKAYA POWER PRIVATE LIMITED",
"OKAYTI TEA CO LTD",
"OKAZ BIO-TECH PRIVATE LIMITED",
"OKEMO OVERSEAS PRIVATE LIMITED",
"OKEY MOTORS PRIVATE LIMITED",
"OKHAE ELECTRONICS INDIA PRIVATE LIMITED",
"OKHLA CONSTRUCTIONS PRIVATE LIMITED",
"OKHLA VENTURES PRIVATE LIMITED",
"OKI INDIA PRIVATE LIMITED",
"OKIE VENTURES PRIVATE LIMITED",
"OKINAWA AUTOTECH INTERNATIONALL PRIVATE LIMITED",
"OKINAWA PARTS INDIA PRIVATE LIMITED",
"OKINAWA PHARMACEUTICALS PRIVATE LIMITED",
"OKITSUMO PAINTS INDIA PRIVATE LIMITED",
"OKNA DESIGNS PRIVATE LIMITED",
"OKOBOJI GLOBAL PRIVATE LIMITED",
"OKOOL MANPOWER RECRUITMENT SERVICES PRIVATE LIMITED",
"OKRUTI IT CONSULTING PRIVATE LIMITED",
"OKS EDUCATION PRIVATE LIMITED",
"OKS GROUP INTERNATIONAL PRIVATE LIMITED",
"OKS PRE PRESS SERVICES PRIVATE LIMITED",
"OKS SPAN TECH PRIVATE. LIMITED",
"OKSBIRD ONLINE SERVICES PRIVATE LIMITED",
"OKTECH AA INFORMATION SERVICES PRIVATE LIMITED",
"OKTOBUZZ DIGITAL SOLUTIONS PRIVATE LIMITED",
"OKU TECH PRIVATE LIMITED",
"OKUMA INDIA PRIVATE LIMITED",
"OKUSA AUTOMOBILES PRIVATE LIMITED",
"OLA ELECTRIC MOBILITY PRIVATE LIMITED",
"OLA ELECTRIC TECHNOLOGIES PRIVATE LIMITED",
"OLA FINANCIAL SERVICES PRIVATE LIMITED",
"OLA FLEET TECHNOLOGIES PRIVATE LIMITED",
"OLA STORES TECHNOLOGIES PRIVATE LIMITED",
"OLA TRADERS PRIVATE LIMITED",
"OLAER HYDRAULICS (INDIA) PRIVATE LIMITED",
"OLALIAN ESTATE PRIVATE LIMITED",
"OLAM AGRI INDIA PRIVATE LIMITED",
"OLAM ENTERPRISES INDIA PRIVATE LIMITED",
"OLAM FOOD INGREDIENTS INDIA PRIVATE LIMITED",
"OLAP SYSTEMS INTERNATIONAL PRIVATE LIMITED",
"OLATECH SOLUTIONS LIMITED",
"OLAYAN FINANCING COMPANY",
"OLD BRIDGE CAPITAL MANAGEMENT PRIVATE LIMITED",
"OLD FIR ADVISORS INDIA PRIVATE LIMITED",
"OLD FOX SECURITY SYSTEMS PRIVATE LIMITED",
"OLD MADRAS BAKING COMPANY PRIVATE LIMITED",
"OLD MONK ENTERTAINMENT PRIVATE LIMITED",
"OLE AUTOMATION INDIA PRIVATE LIMITED",
"O'LECHE DAIRY FARMS PRIVATE LIMITED",
"OLECTRA GREENTECH LIMITED",
"OLEFIA LIMITED",
"OLENASONS INDIA PRIVATE LIMITED",
"OLENS HEALTHCARE PRIVATE LIMITED",
"OLEO BUFFERS INDIA PRIVATE LIMITED",
"OLF (INDIA) SOFTWARE PRIVATE LIMITED",
"OLGA EN FAB PRIVATE LIMITED",
"OLGA TRADING PRIVATE LIMITED",
"OLI VIBRATORS INDIA PRIVATE LIMITED",
"OLIB APPARELS PRIVATE LIMITED",
"OLIKARA LIGHTING TOWERS PRIVATE LIMITED",
"OLIMBIA CAR CARE PRIVATE LIMITED",
"OLINEO NEXUS INDIA PRIVATE LIMITED",
"OLIOGLOBAL",
"OLIRIA FOODS AND BEVERAGES LIMITED",
"OLIRUM INDIA TRUST",
"OLIS INFOSYSTEMS PRIVATE LIMITED",
"OLISA REALITY PRIVATE LIMITED",
"OLIVA DIE CASTING PRIVATE LIMITED",
"OLIVE PLUS TWIST AVENUES PRIVATE LIMITED",
"OLIVE ADVANCED SECURITY INTEGRATED SOLUTIONS PRIVATE LIMITED",
"OLIVE AUTO PRIVATE LIMITED",
"OLIVE BAR AND KITCHEN PRIVATE LIMITED",
"OLIVE BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"OLIVE CABLES (INDIA) PRIVATE LIMITED",
"OLIVE DIAGNOSTICS PRIVATE LIMITED",
"OLIVE E-BUSINESS PRIVATE LIMITED",
"OLIVE ECOPOWER PRIVATE LIMITED",
"OLIVE EXPORTS PRIVATE LIMITED",
"OLIVE GREENS MANPOWER SOLUTIONS PVT LTD",
"OLIVE HEALTHCARE",
"OLIVE HEALTHCARE PRIVATE LIMITED",
"OLIVE HOSPITALS PRIVATE LIMITED",
"OLIVE INFRARESORTS PRIVATE LIMITED",
"OLIVE INTERNATIONAL EDUCATION FOUNDATION",
"OLIVE LIFESCIENCES PRIVATE LIMITED",
"OLIVE NEST PRIVATE LIMITED",
"OLIVE POLYMERS PRIVATE LIMITED",
"OLIVE PUBLICATIONS PRIVATE LIMITED",
"OLIVE ROOTS INDIA PRIVATE LIMITED",
"OLIVE TECHNOLOGY LIMITED",
"OLIVE TEX SILK MILLS PRIVATE LIMITED",
"OLIVE TREE RETAIL PRIVATE LIMITED",
"OLIVEBOARD COMPTECH PRIVATE LIMITED",
"OLIVEMOUNT GLOBAL SCHOOL",
"OLIVER APPARELS PRIVATE LIMITED",
"OLIVER NIRYAT PVT. LTD.",
"OLIVER PET CARE SOLUTIONS PRIVATE LIMITED",
"OLIVER VALVES INDIA PRIVATE LIMITED",
"OLIVER WYMAN LIMITED",
"OLIVER'S FOODS SPECIALITIES (OPC) PRIVATE LIMITED",
"OLIVET PHARMA PRIVATE LIMITED",
"OLIVIA CERAMIC PRIVATE LIMITED",
"OLIVIA IMPEX PRIVATE LIMITED",
"OLIYA INFRATECH PRIVATE LIMITED",
"OLIYA STEEL PRIVATE LIMITED",
"OLLERACOMP IT SERVICES PRIVATE LIMITED",
"OLLION CONSULTANCY PRIVATE LIMITED",
"OLLOSOFT TECHNOLOGIES PRIVATE LIMITED",
"OLMILESTONE TRADEVISION PRIVATE LIMITED",
"OLON ACTIVE PHARMACEUTICAL INGREDIENTS INDIA PRIVATE LIMITED",
"OLOOP TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"OLPAD AQUA PRIVATE LIMITED",
"OLPAD TALUKA PANCHAYAT",
"OLR INDIA CONSULTING PRIVATE LIMITED",
"OLTEX TRADING PRIVATE LIMITED",
"OLTIMO LUBES & CHEMICALS PRIVATE LIMITED",
"OLUMPUS GLASSES LIMITED",
"OLUMPUS GLASSES PRIVATE LIMITED",
"OLWEN LIFESCIENCES PRIVATE LIMITED",
"OLWIN TILES (INDIA) PRIVATE LIMITED",
"OLYENDER FOODS PRIVATE LIMITED",
"OLYMPIA CREDITS & MERCANTILE PRIVATE LIMITED",
"OLYMPIA CYBERSPACE PRIVATE LIMITED",
"OLYMPIA ELEVATORS PRIVATE LIMITED",
"OLYMPIA GAMES AND TOYS PRIVATE LIMITED",
"OLYMPIA INDUSTRIES LIMITED",
"OLYMPIA MERLIN DEVELOPERS PRIVATE LIMITED",
"OLYMPIA PROPERTY SERVICES PRIVATE LIMITED",
"OLYMPIA SHIP MANAGEMENT PRIVATE LIMITED",
"OLYMPIA SPORTZ & EVENTS PRIVATE LIMITED",
"OLYMPIA TECH PARK CHENNAI PRIVATE LIMITED",
"OLYMPIANS TELECOM INFRA PRIVATE LIMITED",
"OLYMPIC CYLINDER PRIVATE LIMITED",
"OLYMPIC DECOR LLP",
"OLYMPIC ENGINEERS PRIVATE LIMITED",
"OLYMPIC OVERSEAS PRIVATE LIMITED",
"OLYMPIC PHARMACARE PRIVATE LTD",
"OLYMPIC PLASTICS PVT LTD",
"OLYMPIC SECURITY SOLUTIONS INDIA PRIVATE LIMITED",
"OLYMPIC SYNTHETIC SACKS PVT LTD",
"OLYMPIC ZIPPERS LIMITED",
"OLYMPUS CAPITAL HOLDINGS ASIA INDIA ADVISORS PRIVATE LIMITED",
"OLYMPUS FABRICATORS PRIVATE LIMITED",
"OLYMPUS MEDICAL SYSTEMS INDIA PRIVATE LIMITED",
"OLYMPUS MOTORS PRIVATE LIMITED",
"OLYMPUS PERSONNEL ALLIED SERVICES PRIVATE LIMITED",
"OLYMPUS PREMEDIA PRIVATE LIMITED",
"OLYMPUS SCHOOL OF EXCELLENCE",
"OLYMPUS SECURE PROCESS PRIVATE LIMITED",
"OLYMPUS THERAPEUTICS PRIVATE LIMITED",
"OLYPUB PVT LTD",
"OLZWELL HEALTHCARE PRIVATE LIMITED",
"OM - BALAJI INORGO METAL PRIVATE LIMITED",
"OM ADVANCE AUTOMOBILES PRIVATE LIMITED",
"OM AGRO FOODS AND FEEDS PRIVATE LIMITED",
"OM AGROENERGY PRIVATE LIMITED",
"OM AHINSAK PRODUCTS PRIVATE LIMITED",
"OM ARHAM APPAREL PRIVATE LIMITED",
"OM ARIHANT KRIPA COMMODITIES & MERCHANDISE PRIVATE LIMITED",
"OM ARIHANT LABELS PRIVATE LIMITED",
"OM ASSOCIATES",
"OM AUTO PRIVATE LIMITED",
"OM AUTO TRADING PRIVATE LIMITED",
"OM AUTOELECTRO PRIVATE LIMITED",
"OM AUTOGAS PRIVATE LIMITED",
"OM AUTOMOBILES PRIVATE LIMITED",
"OM AUTOMOTORS PRIVATE LIMITED",
"OM BALAJEE AUTOMOBILE INDIA PRIVATE LIMITED",
"OM BALAJI PRECIOUS METAL SOLUTIONS PRIVATE LIMITED",
"OM BAROT CONSULTANTS PRIVATE LIMITED",
"OM BESCO SUPER FRICTION PRIVATE LIMITED",
"OM BHAKTI SAMAGRI KREATIONS PRIVATE LIMITED",
"OM BINAYAK TEXTILES PRIVATE LIMITED",
"OM BIOGENICS PRIVATE LIMITED",
"OM BIOMEDIC PRIVATE LIMITED",
"OM BUILDCON PROJECTS PRIVATE LIMITED",
"OM CAREERS",
"OM CARS PRIVATE LIMITED",
"OM CHAINS PRIVATE LIMITED",
"OM CHAMUNDA MAA TRADING PRIVATE LIMITED",
"OM CHEMICAL INDUSTRIES LIMITED",
"OM CHICKS INDIA PRIVATE LIMITED",
"OM CIRCUIT BOARDS PRIVATE LIMITED",
"OM CLEANING AND PROCESSORS PVT LTD",
"OM CLEARING AND FORWARDING PRIVATE LIMITED",
"OM COAL COMPANY PRIVATE LIMITED",
"OM COLD STORAGE PVT LTD",
"OM COLLECTIONS PRIVATE LIMITED",
"OM COMMODITY TRADING (INDIA) PRIVATE LIMITED",
"OM COMPONENTS AND SYSTEMS PRIVATE LIMITED",
"OM CONTAINERS PRIVATE LIMITED",
"OM COOLING SYSTEM PRIVATE LIMITED",
"OM CORRUGATED PACK PRIVATE LIMITED",
"OM COTEX",
"OM COTTON & OIL INDUSTRIES",
"OM CREATION PRIVATE LIMITED",
"OM CREDIT PVT LTD",
"OM CRITICAL CARE CENTRE PRIVATE LIMITED",
"OM DAILYNEEDS RETAILING PRIVATE LIMITED",
"OM DARSHAN SPECIALITY SURFACES PRIVATE LIMITED",
"OM DATTA BHADRA AGRO PRODUCTION PROCESS & MARKETING PRIVATE LIMITED",
"OM DAYAL HOLDINGS LIMITED",
"OM DHAR ENGINEERING PRIVATE LIMITED",
"OM DIAMOND MANUFACTURING PRIVATE LIMITED",
"OM DIESELS PRIVATE LIMITED",
"OM DRISHIAN INTERNATIONAL LIMITED",
"OM EDIBLE OIL & FATS PRIVATE LIMITED",
"OM ENERGY EQUIPMENT",
"OM ENGINEERING WORKS INDIA PVT LTD",
"OM ENGINEERS & PACKING SYSTEMS PRIVATE LIMITED",
"OM ESHA AGRO PRODUCTS PRIVATE LIMITED",
"OM EXIM PRIVATE LIMITED",
"OM FABTECH PRIVATE LIMITED",
"OM FIRE SAFETY COMPANY PRIVATE LIMITED",
"OM FIXTURES PRIVATE LIMITED",
"OM FOAM PRIVATE LIMITED",
"OM FOODS AND BEVERAGES PRIVATE LIMITED",
"OM FOODS SUPPLIERS PRIVATE LIMITED",
"OM FOREX PRIVATE LIMITED",
"OM FORGE AUTO INDUSTRIES PRIVATE LIMITED",
"OM FREIGHT FORWARDERS PRIVATE LIMITED",
"OM FREIGHT SOLUTIONS PRIVATE LIMITED",
"OM GALAXY PRECISION MOULD CRAFTS PRIVATE LIMITED",
"OM GANESH CHILLING PLANT & PRESERVATIONS PRIVATE LIMITED",
"OM GANESH JEWELLERS PRIVATE LIMITED",
"OM GAYATRI BENCH TECH PRIVATE LIMITED",
"OM GAYATRI FARMER PRODUCER COMPANY LIMITED",
"OM GINNING AND PRESSING FACTORY",
"OM GLASS WORKS PRIVATE LIMITED",
"OM GOLD PRODUCTS PRIVATE LIMITED",
"OM GURU MAATA AGRO PRODUCTS",
"OM HARDWARE AND STEEL CENTRE",
"OM HARI NARAYAN INFRASTRUCTURE PRIVATE LIMITED",
"OM HARIHAR EDUCATIONAL SERVICES PRIVATE LIMITED",
"OM HEALTHCARE ENTERPRISES LIMITED",
"OM HOSPITALITY PRIVATE LIMITED",
"OM HUMAN RESOURCE AGENCY PRIVATE LIMITED",
"OM HYDROPOWER LIMITED",
"OM IMAGING & DIAGNOSTIC CENTRE PRIVATE LIMITED",
"OM IMPORT EXPORT LIMITED",
"OM INDIA STAINLESS TUBE LIMITED",
"OM INDIA TRADING COMPANY PRIVATE LIMITED",
"OM INDO AUTO MACHINES PRIVATE LIMITED",
"OM INDUSTRIES",
"OM INDUSTRIES - DHULE",
"OM INFRA LIMITED",
"OM INNOVATION CALL SERVICES PRIVATE LIMITED",
"OM IRRITECH LIMITED",
"OM IT-SOLUTIONS PRIVATE LIMITED",
"OM JAY SILK COMPANY PRIVATE LIMITED",
"OM JEWELLERS PRIVATE LIMITED",
"OM JVM INFRAPROJECTS PRIVATE LIMITED",
"OM JYOTI APPARELS",
"OM JYOTI TEXFAB PRIVATE LIMITED",
"OM KAPEESH ENTERTAINMENT PRIVATE LIMITED",
"OM LEATHER ART DECO PRIVATE LIMITED",
"OM LOGISTICS LIMITED",
"OM MANSA DEVI CONSTRUCTION AND DEVELOPERS PRIVATE LIMITED",
"OM MEDICENTRE PRIVATE LIMITED",
"OM MEDISCAN & DIAGNOSTICS PRIVATE LIMITED",
"OM MEDITRONICS PRIVATE LIMITED",
"OM METALLOGIC LIMITED",
"OM METALS AUTO PRIVATE LIMITED",
"OM MHE TECH PRIVATE LIMITED",
"OM MULTI PACK PRIVATE LIMITED",
"OM MULTIMEDIA PRIVATE LIMITED",
"OM MULTIPLEX AND BUILDER PRIVATE LIMITED",
"OM MULTISPECIALITY HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED",
"OM MURUGA HARDWARES",
"OM MURUGA SAREES PRIVATE LIMITED",
"OM NAMAH CREATION PRIVATE LIMITED",
"OM NAMAH ELECTROPOWER PRIVATE LIMITED",
"OM NAMAH SHIVAY LOGISTICS INTERNATIONAL PRIVATE LIMITED",
"OM NANOTECH PRIVATE LIMITED",
"OM NATH HOSPITAL PRIVATE LIMITED",
"OM NAVDURGA MOTORS PRIVATE LIMITED",
"OM NAVJEEVAN HOSPITAL PRIVATE LIMITED",
"OM OIL AND FLOUR MILLS LIMITED",
"OM OPTEL INDUSTRIES PRIVATE LIMITED",
"OM ORGANIC COTTON PRIVATE LIMITED",
"OM PAPER KRAFTS (INDIA) PRIVATE LIMITED",
"OM PARKASH GOYAL AND SONS PRIVATE LIMITED",
"OM PARKASH NARGOTRA CONSTRUCTIONS PRIVATE LIMITED",
"OM PARKASH SURINDER MOHAN",
"OM PATTERNS LAM PRIVATE LIMITED",
"OM PETROMART OPC PRIVATE LIMITED",
"OM PHARMACEUTICALS LIMITED",
"OM PILE PRIVATE LIMITED",
"OM PLAST (INDIA) PRIVATE LIMITED",
"OM PLYWOODS PRIVATE LIMITED",
"OM POLYPACKS PRIVATE LIMITED",
"OM POLYSACK PRIVATE LIMITED",
"OM POLYTECHNIC WARDHA",
"OM POULTRY PRODUCT PRIVATE LIMITED",
"OM POWER TRANSMISSION PRIVATE LIMITED",
"OM POWERTECH PRIVATE LIMITED",
"OM PRAKASH AGRO OVERSEAS PRIVATE LIMITED",
"OM PRAKASH AMARNATH",
"OM PRAKASH AND COMPANY PRIVATE LIMITED",
"OM PRAKASH JWALA DEVI INTER COLLEGE",
"OM PRAKASH POWER SYSTEMS PRIVATE LIMITED",
"OM PRAKASH SARAF & SONS PRIVATE LIMITED",
"OM PRAMILA STOCKS PRIVATE LIMITED (OPC)",
"OM PRATHMIK VIDYA MANDIR",
"OM PRIMARY VIDYA MANDIR",
"OM PROCESSORS PRIVATE LIMITED",
"OM RICE MILLS PRIVATE LIMITED",
"OM ROAD CARRIERS PRIVATE LIMITED",
"OM RUDRA METATECH PRIVATE LIMITED",
"OM SAGAR DEVELOPERS",
"OM SAI AAROGYA CARE PRIVATE LIMITED",
"OM SAI ADHUNIK FARMER PRODUCER COMPANY LIMITED",
"OM SAI AGRIFACILITIES PRIVATE LIMITED",
"OM SAI BEVERAGES PRIVATE LIMITED",
"OM SAI CHARAN RESTOBAR PRIVATE LIMITED",
"OM SAI CREDIT COLLECTION SERVICES PRIVATE LIMITED",
"OM SAI DAHEJ SALT MANDLI PRIVATE LIMITED",
"OM SAI DAIRY PRIVATE LIMITED",
"OM SAI ELECTROMECH PRIVATE LIMITED",
"OM SAI ENGINEERING",
"OM SAI ENGLISH HIGH SCHOOL AND JR COLLEGE",
"OM SAI ENGLISH SCHOOL",
"OM SAI ENTERPRISES UVSL",
"OM SAI FLEET MANAGEMENT INDIA PRIVATE LIMITED",
"OM SAI FLOCK PRIVATE LIMITED",
"OM SAI FOOD PRODUCTS PRIVATE LIMITED",
"OM SAI GLOBAL MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"OM SAI GRIHA NIRMAN PRIVATE LIMITED",
"OM SAI HEALTH EVENTS PRIVATE LIMITED",
"OM SAI HI-TECH FIRE SAFETY PRIVATE LIMITED",
"OM SAI HOSPITALITY",
"OM SAI HOTELS PRIVATE LIMITED",
"OM SAI INFRA",
"OM SAI INTERIORS PRIVATE LIMITED",
"OM SAI INTEX PRIVATE LIMITED",
"OM SAI MANPOWER SERVICES PRIVATE LIMITED",
"OM SAI MEDICARE & RESEARCH CENTRE PRIVATE LIMITED",
"OM SAI MOBILES",
"OM SAI MOTORS PRIVATE LIMITED",
"OM SAI MOULDS & PLASTICS",
"OM SAI OM CONSTRUCTION PRIVATE LIMITED",
"OM SAI PHARMA PACK",
"OM SAI RAM BUILDTECH PRIVATE LIMITED",
"OM SAI SAFEGUARD SERVICES PRIVATE LIMITED",
"OM SAI SIGN GRAFIX PRIVATE LIMITED",
"OM SAI SWARAHANTRA PRIVATE LIMITED",
"OM SAI VETCARE PRIVATE LIMITED",
"OM SAI WORLDWIDE",
"OM SAINATH IRON ORE TRADE PRIVATE LIMITED",
"OM SANKESHWARA GEMS & JEWELLERS PRIVATE LIMITED",
"OM SAPTARSHI INTERNATIONAL SERVICE PRIVATE LIMITED",
"OM SARALA SECURITY SERVICES PRIVATE LIMITED",
"OM SEATRANS",
"OM SEAWAYS CARGO PRIVATE LIMITED",
"OM SECTECH INDIA PRIVATE LIMITED",
"OM SHAILSHUTA LOGISTICS PRIVATE LIMITED",
"OM SHAKTHY AGENCIES (MADRAS)PRIVATE LIMITED",
"OM SHAKTHY FIRE REALTY PRIVATE LIMITED",
"OM SHAKTHY HOSPITALITIES PRIVATE LIMITED",
"OM SHAKTI EDUCATIONAL SOCIETY",
"OM SHAKTI ENTERPRISES PRIVATE LIMITED",
"OM SHAKTI SMELTERS PRIVATE LIMITED",
"OM SHAKTI TRANSFORMERS LIMITED",
"OM SHANKAR AGRO MILLS PRIVATE LIMITED",
"OM SHANKER COLD STORAGE PVT. LTD.",
"OM SHANTI HIGHER SECONDARY VIDYALAYA",
"OM SHANTI ROADWAYS PRIVATE LIMITED",
"OM SHANTI STEEL AND CASTING PRIVATE LIMITED",
"OM SHANTI TRADELINK PRIVATE LIMITED",
"OM SHARDA LOGISTICS PRIVATE LIMITED",
"OM SHARDA LOGISTICS SOLUTIONS PRIVATE LIMITED",
"OM SHIV ENGINEERING AND CONSTRUCTION OPERATIONS PRIVATE LIMITED",
"OM SHIV MANGALAM BUILDERS PRIVATE LIMITED",
"OM SHIV SHAKTI ENTERPRISES PRIVATE LIMITED",
"OM SHIV SHAKTI IRON INDUSTRIES PRIVATE LIMITED",
"OM SHIVA DAIRY",
"OM SHIVA TEXTILE PRIVATE LIMITED",
"OM SHIVAM BUILDCON PRIVATE LIMITED",
"OM SHIVAM BUILDERS PRIVATE LIMITED",
"OM SHIVAM CHICORY PROCESSOR PRIVATE LIMITED",
"OM SHIVAM MULTISPECIALITY HOSPITAL",
"OM SHIVAY SPECIALITY PAPER PRIVATE LIMITED",
"OM SHREE AGRO INDUSTRIES PRIVATE LIMITED",
"OM SHREE GANESH (INDIA) PRIVATE LIMITED",
"OM SHREE GANESH CONTAINERS PRIVATE LIMITED",
"OM SHREE INTERNATIONAL PRIVATE LIMITED",
"OM SHREE KRIPA MARBLES PRIVATE LIMITED",
"OM SHREE LOGISTICS PRIVATE LIMITED",
"OM SHREE PACKAGING PRIVATE LIMITED",
"OM SHREE RAM FINCAP PRIVATE LIMITED",
"OM SHREE RUPESH STEEL PRIVATE LIMITED",
"OM SHRI BALAJI JYOTISH PRIVATE LIMITED",
"OM SHRI SHUBH LABH AGRIFRESH PRIVATE LIMITED",
"OM SHRI SHUBH LABH AGRITECH PRIVATE LIMITED",
"OM SHRI SHUBH LABH AGRITECH RETAILERS PRIVATE LIMITED",
"OM SHRI VARI STONES PRIVATE LIMITED",
"OM SHWETA FOOD AND FEEDS INDIA PRIVATE LIMITED",
"OM SHYAMJI FOODS PRIVATE LIMITED",
"OM SIDDH VINAYAK IMPEX PRIVATE LIMITED",
"OM SIDDHI CONSTRUCTIONS PRIVATE LIMITED",
"OM SILK MILLS PRIVATE LIMITED",
"OM SMELTERS AND ROLLERS PRIVATE LIMITED",
"OM SOAPS AND DETERGENTS PVT LTD",
"OM SONS ENTERPRISES PRIVATE LIMITED",
"OM SONS PROJECTS PRIVATE LIMITED",
"OM SPARE PARTS PRIVATE LIMITED",
"OM SPICES AND FOODS PRIVATE LIMITED",
"OM SREE BHAVANASAI WAREHOUSING PRIVATE LIMITED",
"OM SREE PAPERTEK PRIVATE LIMITED",
"OM SREE SAI GANESH ENGINEERS PRIVATE LIMITED",
"OM SRI LAKSHMI VENKATESWARA AGRO BOARDS PRIVATE LIMITED",
"OM SRI SAIRAM CATERING SERVICES PRIVATE LIMITED",
"OM STAFFING AND LABOUR SOLUTION INDIA PRIVATE LIMITED",
"OM STAMPINGS PRIVATE LIMITED",
"OM STEEL PRIVATE LIMITED",
"OM STEEL SOLUTIONS PRIVATE LIMITED",
"OM STEEL TUBES LIMITED",
"OM STERLING GLOBAL UNIVERSITY",
"OM SUITES PRIVATE LIMITED",
"OM SURYA ELECTRONICS PRIVATE LIMITED",
"OM SWEETS PRIVATE LIMITED",
"OM SYNTEX PRIVATE LIMITED",
"OM SYSTEMS AND SERVICES PRIVATE LIMITED",
"OM TAT SAT SOLUTIONS PRIVATE LIMITED",
"OM TEA PRIVATE LIMITED",
"OM TECHNOCON PRIVATE LIMITED",
"OM TECHNO-CRAT PRIVATE LIMITED",
"OM TELECOM LOGISTICS PRIVATE LIMITED",
"OM TEX CHEM PRIVATE LIMITED",
"OM THREADS PRIVATE LIMITED",
"OM TOWERS PVT LTD",
"OM TRANS LOGISTICS LIMITED",
"OM TRANSCONNECT PRIVATE LIMITED",
"OM TRANSLINK COMPANY (INDORE) PRIVATE LIMITED",
"OM TRAX PACKAGING SOLUTIONS LIMITED",
"OM URJA PRIVATE LIMITED",
"OM VAISHNAVI TELECOMP SOLUTIONS PRIVATE LIMITED",
"OM VINYLS PRIVATE LIMITED",
"OM WAREHOUSING PRIVATE LIMITED",
"OM WELFARE SOCIETY",
"OM WHEELS PRIVATE LIMITED",
"OM WOOLLENS PRIVATE LIMITED",
"OM YADAV INFRA HEIGHTS PRIVATE LIMITED",
"OM YARN PLUS PRIVATE LIMITED",
"OM YASH PROJECTS PRIVATE LIMITED",
"OMA DIGITAL SOLUTIONS PRIVATE LIMITED",
"OMA LIVING PRIVATE LIMITED",
"OMALCO EXTRUSION PRIVATE LIMITED",
"OMAM CONSULTANTS PRIVATE LIMITED",
"OMAN & UAE EXCHANGE CENTRE & CO. LLC",
"OMAN AIR SAOC",
"OMAN INDIA JOINT INVESTMENT FUND - MANAGEMENT COMPANY PRIVATE LIMITED",
"OMAN INDIA JOINT INVESTMENT FUND MANAGEMENT COMPAN",
"OMAN INDIA JOINT INVESTMENT FUND MANAGEMENT COMPANY PRIVATE LIMITED",
"OMAN INTERNATIONAL BANK",
"OMAN TRANSFORMERS INDIA PRIVATE LIMITED",
"OMAR COLD STORAGE PRIVATE LIMITED",
"OMAR MONDAL DAL & SPICES PRIVATE LIMITED",
"OMARA VENTURES INDIA PRIVATE LIMITED",
"OMARK LIFESCIENCES PRIVATE LIMITED",
"OMARTH PUMPS PRIVATE LIMITED",
"OMAT WEST LIMITED",
"OMATEK BUSINESS INDIA PRIVATE LIMITED",
"OMATICS SOLUTIONS PRIVATE LIMITED",
"OMATRA HOSPITALITY SERVICES PRIVATE LIMITED",
"OMATRIX SOLUTIONS PRIVATE LIMITED",
"OMAX AUTOS LIMITED",
"OMAX COTSPIN PRIVATE LIMITED",
"OMAX FUSIONS PRIVATE LIMITED",
"OMAX MINERALS PRIVATE LIMITED",
"OMAX SECURITY SERVICES PRIVATE LIMITED",
"OMAX TRANSOLUTION PRIVATE LIMITED",
"OMAX WATCHES INDIA PRIVATE LIMITED",
"OMAXE BUILDHOME LIMITED",
"OMAXE BUILDWELL LIMITED",
"OMAXE FOREST SPA AND HILLS DEVELOPERS LIMITED",
"OMAXE INTERNATIONAL BAZAAR PRIVATE LIMITED",
"OMAXE LIMITED",
"OMAXE NEW CHANDIGARH DEVELOPERS PRIVATE LIMITED",
"OMAXE PANCHAM REALCON PRIVATE LIMITED",
"OMAXE WORLD STREET PRIVATE LIMITED",
"OMAYAL ACHI COLLEGE OF NURSING",
"OMB SALERI VALVES INDIA PRIVATE LIMITED",
"OMBL INFRAPROJECTS PRIVATE LIMITED",
"OMBRE MEDIA PRIVATE LIMITED",
"OMBRE STAINLESS PRIVATE LIMITED",
"OMC CHEMICALS AND ALLIED CHROMATOGRAPHY PRIVATE LIMITED",
"OMC POWER PRIVATE LIMITED",
"OMCAM POWER PRODUCTS PRIVATE LIMITED",
"OMCARETAKER SECURITY SERVICES PRIVATE LIMITED",
"OMCARGO LOGISTIC PRIVATE LIMITED",
"OMCI RIG TECHNICAL & SUPPORT SERVICES PRIVATE LIMITED",
"OMCI SHIPMANAGEMENT PRIVATE LIMITED",
"OMCO ENTERPRISES PRIVATE LIMITED",
"OMCONS ENGINEERING PRIVATE LIMITED",
"OMCONSTRUCTIONS SHAMBHAVI PRIVATE LIMITED",
"OMDEO PACKERS AND MOVERS PRIVATE LIMITED",
"OMDEV PLASTIC PRIVATE LIMITED",
"OMECH COMPONENTS PVT LTD",
"OMECH ENGINEERING COMPANY PRIVATE LIMITED",
"OMEGA ALLIANCE RECOVERY SOLUTIONS PRIVATE LIMITED",
"OMEGA APPLIANCES PRIVATE LIMITED",
"OMEGA AUTOMOTIVE PRIVATE LIMITED",
"OMEGA BIOTECH LIMITED",
"OMEGA BOILERS PRIVATE LIMITED",
"OMEGA BRIGHT STEEL & COMPONENTS PRIVATE LIMITED",
"OMEGA BRIGHT STEEL PRIVATE LIMITED",
"OMEGA BROADCAST PRIVATE LIMITED",
"OMEGA CENTURY INSTITUTE OF ONCOLOGY PRIVATE LIMITED",
"OMEGA CLINICAL DIAGNOSTICS PRIVATE LIMITED",
"OMEGA COLORS PRIVATE LIMITED",
"OMEGA COMPLIANCE INDIA PRIVATE LIMITED",
"OMEGA COMPTECH PRIVATE LIMITED",
"OMEGA CONCEPTS",
"OMEGA CONSTRUCTION PRIVATE LIMITED",
"OMEGA CONTROLS PRIVATE LIMITED",
"OMEGA CORRUGATORS PRIVATE LIMITED",
"OMEGA CREATIONS PRIVATE LIMITED",
"OMEGA CREDIT INFORMATION INDIA PRIVATE LIMITED",
"OMEGA DESIGNS",
"OMEGA DX ASIA PRIVATE LIMITED",
"OMEGA ELECTRONIC SCALE COMPANY LIMITED",
"OMEGA ELEVATORS",
"OMEGA ENGINEERING INDIA PRIVATE LIMITED",
"OMEGA EXIM PRIVATE LIMITED",
"OMEGA FINECHEM PRIVATE LIMITED",
"OMEGA FINHOLD PRIVATE LIMITED",
"OMEGA FISHMEAL AND OIL PRIVATE LIMITED",
"OMEGA GLASS PRIVATE LIMITED",
"OMEGA HEALTHCARE MANAGEMENT SERVICES PRIVATE LIMITED",
"OMEGA HIRES",
"OMEGA HOSPITALS",
"OMEGA HR CONSULTANTS PRIVATE LIMITED",
"OMEGA ICEHILL PRIVATE LIMITED",
"OMEGA INDUSTRIES PVT LTD",
"OMEGA INFO PROJECTS PRIVATE LIMITED",
"OMEGA INFRA ESTATES PRIVATE LIMITED",
"OMEGA INFRABUILD PRIVATE LIMITED",
"OMEGA INSTRUMENTS (INDIA) PVT LTD",
"OMEGA INTERMODAL CONTAINER SERVICES PRIVATE LIMITED",
"OMEGA INVESTMENTS AND PROPERTIES LIMITED",
"OMEGA IT RESOURCES PRIVATE LIMITED",
"OMEGA LIFE STYLES PRIVATE LIMITED",
"OMEGA LINERS (INDIA) PRIVATE LIMITED",
"OMEGA MANPOWER PRIVATE LIMITED",
"OMEGA MANUFACTURING COMPANY PRIVATE LIMITED",
"OMEGA MARKETING PRIVATE LIMITED",
"OMEGA MOTORS PRIVATE LIMITED",
"OMEGA MOULDS PRIVATE LIMITED",
"OMEGA MULTIPLEX PRIVATE LIMITED",
"OMEGA NUTRACEUTICALS PRIVATE LIMITED",
"OMEGA PACKWELL PRIVATE LIMITED",
"OMEGA PAPER PACK PRIVATE LIMITED",
"OMEGA PARKASHAN PRIVATE LIMITED",
"OMEGA PETROENERGY PRIVATE LIMITED",
"OMEGA PLASTO LIMITED",
"OMEGA POLY AND ENGINEERING PVT LTD",
"OMEGA POLYMICRONS PRIVATE LIMITED",
"OMEGA PREMISES PRIVATE LIMITED",
"OMEGA PRINTERS & PUBLISHERS PVT LTD",
"OMEGA PRINTOPACK PRIVATE LIMITED",
"OMEGA PRODUCTS PRIVATE LIMITED",
"OMEGA QMS PRIVATE LIMITED",
"OMEGA RAIL SPARES AND SERVICES PRIVATE LIMITED",
"OMEGA REALTECH LIMITED",
"OMEGA REALTORS PRIVATE LIMITED",
"OMEGA REMEDIES PRIVATE LIMITED",
"OMEGA RENK BEARINGS PRIVATE LIMITED",
"OMEGA ROLLING MILLS PRIVATE LIMITED",
"OMEGA ROOFING INDUSTRIES PRIVATE LIMITED",
"OMEGA SANE FOUNDRY MACHINERY PRIVATE LIMITED",
"OMEGA SCAN DIAGNOSTICS PRIVATE LIMITED",
"OMEGA SCIENTIFIC INSTRUMENTS PRIVATE LIMITED",
"OMEGA SECURITIES AND TRADING COMPANY PRIVATE LTD",
"OMEGA SEIKI MOBILITY PRIVATE LIMITED",
"OMEGA SEIKI PRIVATE LIMITED",
"OMEGA SHELTERS PRIVATE LIMITED",
"OMEGA SHIPPING AGENCIES PRIVATE LIMITED",
"OMEGA SHIPPING PVT LTD",
"OMEGA SOLAR PROJECTS PRIVATE LIMITED",
"OMEGA TANNERY INDIA PRIVATE LIMITED",
"OMEGA TECHNIKS INDIA PRIVATE LIMITED",
"OMEGA TECHNOCAST PRIVATE LIMITED",
"OMEGA TELECOM HOLDINGS PRIVATE LIMITED",
"OMEGA TEX-RISING (INDIA) LIMITED",
"OMEGA THREADS PRIVATE LIMITED",
"OMEGA TUBES PROFILE PRIVATE LIMITED",
"OMEGA TV MEDIA PRIVATE LIMITED",
"OMEGA WELDEDMESH COMPANY PRIVATE LIMITED",
"OMEGACUBE TECHSYSTEMS PRIVATE LIMITED",
"OMEGA-KEMIX PRIVATE LIMITED",
"OMELECTRONICS AND BATTERIES PRIVATE LIMITED",
"OMEN GLOBAL PRIVATE LIMITED",
"OMEN PUBLISHING HOUSE PRIVATE LIMITED",
"OMEN VITRIFIED PRIVATE LIMITED",
"OMENTA PHARMA P LIMITED",
"OMEON SOLUTIONS PRIVATE LIMITED",
"OMET INDIA PRIVATE LIMITED",
"OMETA NET PRIVATE LIMITED",
"OMEX METALS PRIVATE LIMITED",
"OMEX OILS INDIA PRIVATE LIMITED",
"OMEX PACKERS PRIVATE LIMITED",
"OMFA RUBBERS LIMITED",
"OMFB INDIA PRIVATE LIMITED",
"OMFURN INDIA PRIVATE LIMITED",
"OMFYS TECHNOLOGIES INDIA PRIVATE LIMITED",
"OMG AUTO MOULD PRIVATE LIMITED",
"OMG DIGITAL INDIA PRIVATE LIMITED",
"OMG NETWORK INDIA PRIVATE LIMITED",
"OMGAJRAJ INFRASTRUCTURE PRIVATE LIMITED",
"OMGAYATRI AGROMALL PRIVATE LIMITED",
"OMGENE LIFE SCIENCES PRIVATE LIMITED",
"OMGVH ELECTRONICS PRIVATE LIMITED",
"OMICRON ENERGY SOLUTIONS PRIVATE LIMITED",
"OMICRON MACHINE TOOLS PRIVATE LIMITED",
"OMICRON POWER ENGINEERS PRIVATE LIMITED",
"OMICRON SENSING PRIVATE LIMITED",
"OMICS INTERNATIONAL PRIVATE LIMITED",
"OMIDYAR NETWORK INDIA ADVISORS PRIVATE LIMITED",
"OMIKKA CREATIONS PRIVATE LIMITED",
"OMINFRA DESIGN PRIVATE LIMITED",
"OMINTO INDIA PRIVATE LIMITED",
"OMIRA MACHINETEC PRIVATE LIMITED",
"OMISH LABORATORIES PRIVATE LIMITED",
"OMITI ENGINEERING PRIVATE LIMITED",
"OMIZ SOLUTIONS PRIVATE LIMITED",
"OMJAY FACILITY PRIVATE LIMITED",
"OMJI PROMOTERS PVT. LTD.",
"OMK ADVISORS PRIVATE LIMITED",
"OMKAAR FINMAX PRIVATE LIMITED",
"OMKALA BOOK DEPOT PRIVATE LIMITED",
"OMKALESHWAR FARMER PRODUCER COMPANY LIMITED",
"OMKAM CAPITAL MARKETS PRIVATE LIMITED",
"OMKAM COMMODITIES PRIVATE LIMITED",
"OMKAMAL STEEL PRIVATE LIMITED",
"OMKAR (INDIA) PRIVATE LIMITED",
"OMKAR AGRI GLOBAL PRIVATE LIMITED",
"OMKAR AGRO CHEMICALS PRIVATE LIMITED",
"OMKAR AGROTECH PRIVATE LIMITED",
"OMKAR BIRD PROOFING INDIA PRIVATE LIMITED",
"OMKAR BODY FABRICATION AND AUTO CARE PRIVATE LIMITED",
"OMKAR BUILDILITY LIMITED",
"OMKAR CARRIERS & MOVERS PRIVATE LIMITED",
"OMKAR CLEAN ENERGY SERVICES PRIVATE LIMITED",
"OMKAR CLEARING FORWARDING PRIVATE LIMITED",
"OMKAR COMPOSITES PRIVATE LIMITED",
"OMKAR CONSTRUCTION PRIVATE LIMITED",
"OMKAR COTTON GINNING PRIVATE LIMITED",
"OMKAR CRANES (INDIA) PRIVATE LIMITED",
"OMKAR DAIRY EQUIPMENTS PRIVATE LIMITED",
"OMKAR ENGINEERING INDIA PRIVATE LIMITED",
"OMKAR ENGINEERING WORKS PRIVATE LIMITED",
"OMKAR ENGINEERS AND CONTRACTORS",
"OMKAR ENGLISH MEDIUM SCHOOL",
"OMKAR EQUIPMENTS PRIVATE LIMITED",
"OMKAR FABRICS PRIVATE LIMITED",
"OMKAR FABROPLAST PRIVATE LIMITED",
"OMKAR FERTILISERS PRIVATE LIMITED",
"OMKAR FREIGHT FORWARDERS PRIVATE LIMITED",
"OMKAR GALVANIZERS PRIVATE LIMITED",
"OMKAR GLOBAL LOGISTICS SERVICES INDIA PRIVATE LIMITED",
"OMKAR HEAVY ENGINEERING LIMITED",
"OMKAR HOTELSHOSPITALITY PRIVATE LIMITED",
"OMKAR IMPEX INDIA PRIVATE LIMITED",
"OMKAR INDUSTRIES LIMITED",
"OMKAR INFRACON PRIVATE LIMITED",
"OMKAR INFRAPROMOTERS PRIVATE LIMITED",
"OMKAR INFRATECH LIMITED",
"OMKAR INTEGRATED AUTOMATION SOLUTIONS PRIVATE LIMITED",
"OMKAR MACHINING CENTRE PRIVATE LIMITED",
"OMKAR MANPOWER SOLUTIONS PRIVATE LIMITED",
"OMKAR MEDICAL DISTRIBUTORS PRIVATE LIMITED",
"OMKAR MINT PRIVATE LIMITED",
"OMKAR NATURAL RESOURCES PRIVATE LIMITED",
"OMKAR NESTS PRIVATE LIMITED",
"OMKAR PRINT LAB PRIVATE LIMITED",
"OMKAR PROPERTIES PRIVATE LIMITED",
"OMKAR PUF INSULATION PRIVATE LIMITED",
"OMKAR REALTORS & DEVELOPERS PRIVATE LIMITED",
"OMKAR REALTORS PROJECTS PRIVATE LIMITED",
"OMKAR REFRACTORIES PRIVATE LIMITED",
"OMKAR SAFETY AND POWER PRIVATE LIMITED",
"OMKAR SECURITY AND LABOUR SERVICES PRIVATE LIMITED",
"OMKAR SHILP INDIA PRIVATE LIMITED",
"OMKAR SOFTWARE PRIVATE LIMITED",
"OMKAR SPECIALITY CHEMICALS LIMITED",
"OMKAR SUPRANATIONAL PRIVATE LIMITED",
"OMKAR SYNTHETICS PRIVATE LIMITED",
"OMKAR TEXTILE MILLS PRIVATE LIMITED",
"OMKAR TOWNSHIP AND SERVICES PRIVATE LIMITED",
"OMKAR TRANSLOGISTICS PRIVATE LIMITED",
"OMKAR VALVES PRIVATE LIMITED",
"OMKAR VANIJYA PRIVATE LIMITED",
"OMKARA ASSETS RECONSTRUCTION PRIVATE LIMITED",
"OMKARA CAPITAL PRIVATE LIMITED",
"OMKARA COMMERCIAL PRIVATE LIMITED",
"OMKARA DEALER PRIVATE LIMITED",
"OMKARA ENGICON PRIVATE LIMITED",
"OMKARA POLES PRIVATE LIMITED",
"OMKARA VIJAYALAKSHMI STRIPS PRIVATE LIMITED",
"OMKARE COSMETICS PRIVATE LIMITED",
"OMKARESHWAR BUILDERS PRIVATE LIIMITED",
"OMKARESHWAR MINES & MINERALS PRIVATE LIMITED",
"OMKARESHWAR TIE-UP PRIVATE LIMITED",
"OMKARPRO BUILDING PRODUCTS PRIVATE LIMITED",
"OMKASHI INTERNATIONAL PRIVATE LIMITED",
"OMKE NEER PRIVATE LIMITED",
"OMKILKARI MULTISPECIALITY HOSPITAL AND FERTILITY CENTRE PRIVATE LIMITED",
"OMKRIPA INFRALAND PRIVATE LIMITED",
"OMKROWN PHARAM-CHEM PRIVATE LIMITED",
"OML ENTERTAINMENT PRIVATE LIMITED",
"OMLOGIC CONSULTING PRIVATE LIMITED",
"OMM LAXMINARAYAN INFRATECH PRIVATE LIMITED",
"OMM MAA BARUNEI TRADERS PRIVATE LIMITED",
"OMM MAA LOGI-VENTURES PRIVATE LIMITED",
"OMM REALTY AND INFRASTRUCTURE PRIVATE LIMITED",
"OMM SACHCHIYA INTERNATIONAL (OPC) PRIVATE LIMITED",
"OMM SAI UDYOG",
"OMM SATYASAI HOUSING PRIVATE LIMITED",
"OMMCOM MEDIA PRIVATE LIMITED",
"OMME ELECTROMECH PRIVATE LIMITED",
"OMMEENA PHARMA DISTRIBUTORS PRIVATE LIMITED",
"OMMI FORGE PRIVATE LIMITED",
"OMNAGESHWAR TOURS AND TRAVELS PRIVATE LIMITED",
"OMNAMO FOODS AND AGROTECH INDIA PRIVATE LIMITED",
"OMNEPRESENT TECHNOLOGIES PRIVATE LIMITED",
"OMNI AGENCY PRIVATE LIMITED",
"OMNI AUTO LIMITED",
"OMNI CANS AND PRINTERS PRIVATE LIMITED",
"OMNI CEMENT PRIVATE LIMITED",
"OMNI DECORATIVES PRIVATE LIMITED",
"OMNI EXIM PRIVATE LIMITED",
"OMNI FARMS PRIVATE LIMITED",
"OMNI FOOTWEAR PRIVATE LIMITED",
"OMNI HEALTH CARE (INDIA) PRIVATE LIMITED",
"OMNI HOSPITALS AUNIT OF INCOR HOSPITALS",
"OMNI IMPEX PRIVATE. LIMITED.",
"OMNI INFOWORD PRIVATE LIMITED",
"OMNI INFRASTRUCTURE PRIVATE LIMITED",
"OMNI LABORATORIES PRIVATE LIMITED",
"OMNI LENS PRIVATE LIMITED",
"OMNI LIFESCIENCES PRIVATE LIMITED",
"OMNI MATRIX PRIVATE LIMITED",
"OMNI MEDIA COMMUNICATIONS PRIVATE LIMITED",
"OMNI PACIFIC COLONIZERS PRIVATE LIMITED",
"OMNI PAPER CONVERTORS PRIVATE LIMITED",
"OMNI PLAST PRIVATE LIMITED",
"OMNI PROTECH DRUGS PRIVATE LIMITED",
"OMNI TECHNOSOFT PRIVATE LIMITED",
"OMNI WELLNESS AND NUTRITION LIMITED",
"OMNIA APPLIANCES PRIVATE LIMITED.",
"OMNIA EDUCATION PRIVATE LIMITED",
"OMNIA TECHNOLOGIES PRIVATE LIMITED",
"OMNIA TOYS INDIA PRIVATE LIMITED",
"OMNIACTIVE HEALTH TECHNOLOGIES LIMITED",
"OMNIADS MEDIA PRIVATE LIMITED",
"OMNIARCH MARITIME PRIVATE LIMITED",
"OMNIBRIDGE TECHNOLOGIES PRIVATE LIMITED",
"OMNIBRX BIOTECHNOLOGIES PRIVATE LIMITED",
"OMNIBUS INDUSTRIAL DEVELOPMENT CORPORATION OF DAMAN DIU AND DADRA NAGAR HAVELI LIMITED",
"OMNICALS PHARMA PRIVATE LIMITED",
"OMNICARE INC.",
"OMNICOM MEDIA GROUP INDIA PRIVATE LIMITED",
"OMNICOMM ECLINICAL SOLUTIONS PRIVATE LIMITED",
"OMNICOMM FUEL MONITORING TECHNOLOGIES INDIA PRIVATE LIMITED",
"OMNICURIS HEALTHCARE PRIVATE LIMITED",
"OMNIDHI TRADING PRIVATE LIMITED",
"OMNIE SOLUTIONS INDIA PRIVATE LIMITED",
"OMNIFAB ENGINEERS PRIVATE LIMITED",
"OMNIFIC HEALTHCARE PRIVATE LIMITED",
"OMNIFICENT TECHNOLOGIES PRIVATE LIMITED",
"OMNIGROWTH MEDI SERVICES PRIVATE LIMITED",
"OMNI-ID INDIA PRIVATE LIMITED",
"OMNIISM TECHNOLOGIES PRIVATE LIMITED",
"OMNILANJAN INFRA PRIVATE LIMITED",
"OMNIMEDIA PUBLICATIONS INDIA PRIVATE LIMITED",
"OMNINET TECHNOLOGIES PRIVATE LIMITED",
"OMNINGINEERS POWER PRIVATE LIMITED",
"OMNINO SOLUTIONS PRIVATE LIMITED",
"OMNION POWER (INDIA) PRIVATE LIMITED",
"OMNION PREMEDIA PRIVATE LIMITED",
"OMNIPAYMENTS SOFTWARE PRIVATE LIMITED",
"OMNIPHY INDIA PRIVATE LIMITED",
"OMNIPOTENT INDUSTRIES LIMITED",
"OMNIPRESENT LIFE STYLE LLP",
"OMNIPRESENT RETAIL INDIA PRIVATE LIMITED",
"OMNIPRESENT ROBOT TECHNOLOGIES PRIVATE LIMITED",
"OMNISCIENT AUTOMATION PRIVATE LIMITED",
"OMNISCIENT ELECTRONICS PRIVATE LIMITED",
"OMNISCIENT HEALTHCARE PRIVATE LIMITED",
"OMNISCIENT SERVICES PRIVATE LIMITED",
"OMNISCIENT SOFTWARE PRIVATE LIMITED",
"OMNISERVE INFOSYSTEMS PRIVATE LIMITED",
"OMNISM ENTERPRISES PRIVATE LIMITED",
"OMNISOFT TECHNOLOGIES PRIVATE LIMITED",
"OMNIST TECHHUB SOLUTIONS PRIVATE LIMITED",
"OMNISUN GSS INDIA PRIVATE LIMITED",
"OMNITECH ENGINEERS INDIA PVT LTD",
"OMNITECH INDUSTRIES LTD",
"OMNITRADE MARKETING SERVICES PRIVATE LIMITED",
"OMNIVISION SEMICONDUCTOR TECHNOLOGIES MARKETING INDIA PRIVATE LIMITED",
"OMNIVORE CAPITAL MANAGEMENT ADVISORS PRIVATE LIMITED",
"OMNIVORE FOODS PRIVATE LIMITED",
"OMNIWARE PAYMENTS PRIVATE LIMITED",
"OMNIWYSE TECHNOLOGIES PRIVATE LIMITED",
"OMNI-X BENDING PRIVATE LIMITED",
"OMNYK INDIA PRIVATE LIMITED",
"OMORI INDIA PRIVATE LIMITED",
"OMOTENASHI TOURS & TRAVELS PRIVATE LIMITED",
"OMP INDIA PRIVATE LIMITED",
"OMPITRA FABTRADE PRIVATE LIMITED",
"OMPRAKASH AGRAWAL AGRO MILLS PRIVATE LIMITED",
"OMPRAKASH PACKAGING PRIVATE LIMITED",
"OMPRAKASH ROLLER FLOUR MILL PRIVATE LIMITED",
"OMPRAKASH SOMNATH",
"OMPREXH INDUSTRIES PRIVATE LIMITED",
"OMPRIME TECHNOLOGY PRIVATE LIMITED",
"OMR BAGLA AUTOMOTIVE SYSTEMS INDIA LIMITED",
"OMR INDUSTRIES PRIVATE LIMITED",
"OMR MALL DEVELOPERS PRIVATE LIMITED",
"OMR PRIYA DIAGNOSTIC CENTRE PRIVATE LIMITED",
"OMR REALTY PRIVATE LIMITED",
"OMR SHIPPING INDIA PRIVATE LIMITED",
"OMRAN INFRASTRUCTURE AND HOSPITALITIES PRIVATE LIMITED",
"OMRIM EXIM PRIVATE LIMITED",
"OMRON AUTOMATION PRIVATE LIMITED",
"OMRON HEALTHCARE INDIA PRIVATE LIMITED",
"OMROX GREEN POWER PRIVATE LIMITED",
"OMRV HOSPITALS PRIVATE LIMITED",
"OMS INFRA CONSULTANTS PRIVATE LIMITED",
"OMS SOFTWARE SOLUTIONS INDIA PRIVATE LIMITED",
"OMSAAR INTERNATIONAL PRIVATE LIMITED",
"OMSAI DISTRIBUTORS PRIVATE LIMITED",
"OMSAI PRINTS PRIVATE LIMITED",
"OMSAI PROFESSONAL DETECTIVE AND SECURITY SERVICES PRIVATE LIMITED",
"OMSAI RESIDENCY PRIVATE LIMITED",
"OMSAIMAALIKH SALES PRIVATE LIMITED",
"OMSAT SERVICES PRIVATE LIMITED",
"OMSATYA EXIM PRIVATE LIMITED",
"OMSATYAM BUILDCONS PRIVATE LIMITED",
"OMSAV PHARMA RESEARCH PRIVATE LIMITED",
"OMSG PRIVATE LIMITED",
"OMSGURU SOLUTIONS PRIVATE LIMITED",
"OMSHAKTHI IMPEX PRIVATE LIMITED",
"OMSHANKAR CONSTRUCTIONS PRIVATE LIMITED",
"OMSHANKAR MILKFOOD INDUSTRIES PRIVATE LIMITED",
"OMSHANTI ESTATES PRIVATE LIMITED",
"OMSHILPI JEWELS AND GEMS PRIVATE LIMITED",
"OMSHIVA FORMULATION PRIVATE LIMITED",
"OMSHIVSHAKTI INFRACON PRIVATE LIMITED",
"OMSHREE AGRO TECH PRIVATE LIMITED",
"OMSHREE GULAB TEX PRIVATE LIMITED",
"OMSHREE PAPERS PRIVATE LIMITED",
"OMSHRI CARGO CARRIERS PRIVATE LIMITED",
"OMSHRINE GLOBAL VENTURES PRIVATE LIMITED",
"OMSHRRI PROJECTS(INDIA) PRIVATE LIMITED",
"OMSON DEVELOPERS PRIVATE LIMITED",
"OMSONS GLASSWARE PRIVATE LIMITED",
"OMSONS INDUSTRIES PRIVATE LIMITED",
"OMSONS MARKETING PRIVATE LIMITED",
"OMSONS MERCANTILE PRIVATE LIMITED",
"OMSONS STEEL PRIVATE LIMITED",
"OMSTAR CONSTRUCTIONS PRIVATE LIMITED",
"OMSTER STORAGE PRIVATE LIMITED",
"OMSUN GOLD SEEDS PRIVATE LIMITED",
"OMSYS BUSINESS SOLUTIONS PRIVATE LIMITED",
"OMT PLUMBING ENGINEERING PRIVATE LIMITED",
"OMTARA DESIGNS PRIVATE LIMITED",
"OMTARANG DATA PRIVATE LIMITED",
"OMTECH CHEMICAL INDUSTRIES PRIVATE LIMITED",
"OMTECH ELECTRICALS SOLUTIONS PRIVATE LIMITED",
"OMTECH SPECIALITY POLYMER CHEMICALS PRIVATE LIMITED",
"OMTRADERS SCRAP MANAGEMENT SERVICES PRIVATE LIMITED",
"OMTRON POWER SYSTEMS PRIVATE LIMITED",
"OMULLANE MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"OMULUS INFOTECH PRIVATE LIMITED",
"OMVAISHNAV KANISHTHA MAHAVIDYALAYA",
"OMVAL CONTROLS PRIVATE LIMITED",
"OMVEERA ICE CREAMS PRIVATE LIMITED",
"OMVIJAY COLLECTION PRIVATE LIMITED",
"OMVIK ENGINEERS PRIVATE LIMITED",
"OMVIR SINGH",
"OMVIRAS MARINE SERVICES PRIVATE LIMITED",
"OMVISHWA GRAINS PRIVATE LIMITED",
"OMX CARGO LIMITED",
"OMX INFO MANAGEMENT LIMITED",
"OMYA HEALTHCARE LIMITED",
"OMYA INDIA PRIVATE LIMITED",
"OMYAH CONSUMER PRODUCTS PRIVATE LIMITED",
"ON & OFF SHORE SURVEY ENGINEERING PRIVATE LIMITED",
"ON AIR MEDIA PRIVATE LIMITED",
"ON DEMAND AGILITY SOFTWARE PRIVATE LIMITED",
"ON DEMAND CONTENT PRIVATE LIMITED",
"ON DESIGN PRIVATE LIMITED",
"ON DIRECT MARKETING SERVICES LLP",
"ON DOOR CONCEPTS LIMITED",
"ON DOOR CONCEPTS PRIVATE LIMITED",
"ON DOT COURIER AND EXPRESS CARGO PRIVATE LIMITED",
"ON EVENTS & PROMOTIONS PRIVATE LIMITED",
"ON GRAPH TECHNOLOGIES PRIVATE LIMITED",
"ON POINT MAINTENANCE SERVICE PRIVATE LIMITED",
"ON QUEST MERCHANDISING INDIA PRIVATE LIMITED",
"ON SPOT TECHNICAL SERVICES PRIVATE LIMITED",
"ON SPOT TECHNOLOGY PRIVATE LIMITED",
"ON STREAM ENGINEERING SERVICES PRIVATE LIMITED",
"ON THE HOUSE PRIVATE LIMITED",
"ON THE MOVE LOGISTICS PRIVATE LIMITED",
"ON THE MOVE TRAVELS & TOURS PVT.LTD.",
"ON TIME INTERNATIONAL LOGISTICS PRIVATE LIMITED",
"ON TIME MANAGEMENT SERVICES PRIVATE LIMITED",
"ON TIME SERVICE ABROAD (OPC) PRIVATE LIMITED",
"ON TOES SECURITY SOLUTION OPC PRIVATE LIMITED",
"ON TRACK VINIMAY PVT LTD",
"ONACTUATE SOFTWARE CONSULTING INDIA PRIVATE LIMITED",
"ONAM AGARBATHI PRIVATE LIMITED",
"ONAMA CONSULTANTS PRIVATE LIMITED",
"ONART QUEST LIMITED",
"ONASHI NATURE PRIVATE LIMITED",
"ONASSIS AUTO LIMITED",
"ONASSIS EXPORTS PRIVATE LIMITED",
"ONATO PRIVATE LIMITED",
"ONAYA FASHIONS PRIVATE LIMITED",
"ONB TECHNOLOGIES INDIA PRIVATE LIMITED",
"ONBOARD IDEAS AND INNOVATION PRIVATE LIMITED",
"ONBOARD LOGISTICS PRIVATE LIMITED",
"ONBV SERVICES INDIA PRIVATE LIMITED",
"ONBV TEXTILES INDIA PRIVATE LIMITED",
"ONCE UPON A TIME",
"ONCE UPON A TIME FILM PRODUCTIONS PRIVATE LIMITED",
"ONCE UPON A TRUNK PRIVATE LIMITED",
"ONCEHUB TECHNOLOGIES PRIVATE LIMITED",
"ONCEMORE BEVERAGES PRIVATE LIMITED",
"ONCHIP TECHNOLOGIES INDIA PRIVATE LIMITED",
"ONCO LIFE CANCER CENTER",
"ONCO LIFE CANCER CENTRE PRIVATE LIMITED",
"ONCO LIFE SCIENCES PRIVATE LIMITED",
"ONCOBIOTEK DRUGS PRIVATE LIMITED",
"ONCOCARE MEDICALS PRIVATE LIMITED",
"ONCOCHAIN HEALTHCARE SERVICES PRIVATE LIMITED",
"ONCOFOCUS SOLUTIONS PRIVATE LIMITED",
"ONCOLOGY INTERNATIONAL INDIA PRIVATE LIMITED",
"ONCOMED PHARMACEUTICALS INDIA PRIVATE LIMITED",
"ONCOSPARK INDIA PRIVATE LIMITED",
"ONCOSTEM DIAGNOSTICS PRIVATE LIMITED",
"ONCOURSE VANTAGE PRIVATE LIMITED",
"ONCOVILLE PRIVATE LIMITED",
"ONCOWIN CANCER CENTER LLP",
"ONDESK VENTURES PRIVATE LIMITED",
"ONDEVICE IT SOLUTIONS PRIVATE LIMITED",
"ONDOT MEDIA INDIA PRIVATE LIMITED",
"ONDOT SYSTEMS INDIA PRIVATE LIMITED",
"ONDOT TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"ONDRAGA DIGITAL PRIVATE LIMITED",
"ONE ABOVE DESTINATION MANAGEMENT SERVICES PRIVATE LIMITED",
"ONE AD DISPLAY PRIVATE LIMITED",
"ONE ARC LABS PRIVATE LIMITED",
"ONE ASIA NETWORK INDIA PRIVATE LIMITED",
"ONE AUTO PRIVATE LIMITED",
"ONE BKC REALTORS PRIVATE LIMITED",
"ONE BUSINESS CONSULTING GROUP PRIVATE LIMITED",
"ONE CHAMPIONSHIP PRIVATE LIMITED",
"ONE CHEMICAL PRIVATE LIMITED",
"ONE CITY INFRASTRUCTURE PRIVATE LIMITED",
"ONE CLICK INNOVATIONS PRIVATE LIMITED",
"ONE COM INDIA PRIVATE LIMITED",
"ONE CONVERGENCE DEVICES PRIVATE LIMITED",
"ONE CUBE SOLUTIONS PRIVATE LIMITED",
"ONE DIRECTION SKILL SOLUTIONS PRIVATE LIMITED",
"ONE E INFO PRIVATE LIMITED",
"ONE EDUCATION INITIATIVES PRIVATE LIMITED",
"ONE EIGHT TECHNOLOGIES PRIVATE LIMITED",
"ONE EIGHTY AAMOKSH TECHNOLOGIES PRIVATE LIMITED",
"ONE EVOLVE ENTERPRISE PRIVATE LIMITED",
"ONE FINE DAY PRIVATE LIMITED",
"ONE FREIGHT FORWARDERS PRIVATE LIMITED",
"ONE GLOBAL SERVICE PROVIDER LIMITED",
"ONE GRAM PRIVATE LIMITED",
"ONE HUNDRED FEET ANALYTICS INDIA PRIVATE LIMITED",
"ONE IDENTITY TECHNOLOGY SYSTEMS INDIA PRIVATE LIMITED",
"ONE INDIA INFORMATION TECH PRIVATE LIMITED",
"ONE INTERNATIONAL CENTER PRIVATE LIMITED",
"ONE KOSMOS TECHNOLOGY PRIVATE LIMITED",
"ONE LIFE CARE PRIVATE LIMITED",
"ONE LIFE EVENTS PRIVATE.LIMITED",
"ONE LIFE STUDIOS PRIVATE LIMITED",
"ONE LOGISTICS PRIVATE LIMITED",
"ONE MOBIKWIK SYSTEMS LIMITED",
"ONE NEST MARKETING PRIVATE LIMITED",
"ONE NETWORK CONSULTING PRIVATE LIMITED",
"ONE NETWORK ENTERPRISES INDIA PRIVATE LIMITED",
"ONE NETWORK ENTERTAINMENT PRIVATE LIMITED",
"ONE OFF BENTEL PRIVATE LIMITED",
"ONE ONE APPARELS PRIVATE LIMITED",
"ONE PHARMA DRUGS & PHARMACEUTICALS PRIVATE LIMITED",
"ONE PLACE COMMERCIALS PRIVATE LIMITED",
"ONE PLANET RECYCLING PRIVATE LIMITED",
"ONE PLUS HOLIDAYS PRIVATE LIMITED",
"ONE POINT LOGISTICS SOLUTION PRIVATE LIMITED",
"ONE POINT ONE SOLUTIONS LIMITED",
"ONE POINT REALTY PRIVATE LIMITED",
"ONE QUBE REALTORS PRIVATE LIMITED",
"ONE RX INDIA PRIVATE LIMITED",
"ONE SOURCE CONSULTANCY PRIVATE LIMITED",
"ONE SOURCE TECHNOLOGIES LLP",
"ONE STOP MARINE (INDIA) PRIVATE LIMITED",
"ONE STOP SUPER MARKET PRIVATE LIMITED",
"ONE TIME SOLUTIONS SERVICES PRIVATE LIMITED",
"ONE TOUCH BUSINESS SOLUTIONS PRIVATE LIMITED",
"ONE TOUCH INFRATEL PRIVATE LIMITED",
"ONE TOUCH MEDICAL PRODUCTS PRIVATE LIMITED",
"ONE TOUCH SOLUTIONS I PRIVATE LIMITED",
"ONE UNIVERSE EDUCATIONAL TRUST",
"ONE UP APPARELS PRIVATE LIMITED",
"ONE UP TRADE PRIVATE LIMITED",
"ONE WOLF AGRO PRIVATE LIMITED",
"ONE WORLD CENTER PRIVATE LIMITED",
"ONE WORLD PHARMA PRIVATE LIMITED",
"ONE2N CONSULTING PRIVATE LIMITED",
"ONE47",
"ONEAPPS CONSULTING INDIA PRIVATE LIMITED",
"ONEASSIST CONSUMER SOLUTIONS PRIVATE LIMITED",
"ONEBANC TECHNOLOGIES PRIVATE LIMITED",
"ONEBILL SOFTWARE INDIA PRIVATE LIMITED",
"ONECALL HEALTH SERVICES PRIVATE LIMITED",
"ONECENTRA SOLUTIONS PRIVATE LIMITED",
"ONECERT INTERNATIONAL PRIVATE LIMITED",
"ONECLICK BIM PRIVATE LIMITED",
"ONECLICK IT CONSULTANCY PRIVATE LIMITED",
"ONECOM SOFTWARE INDIA PRIVATE LIMITED",
"ONECORE MARKETING LLP",
"ONE-DAY SURGERY INDIA PRIVATE LIMITED",
"ONEDIGITALS SOFT SOLUTION INDIA PRIVATE LIMITED",
"ONEDIOS SERVICES PRIVATE LIMITED",
"ONEGEN SOCIAL INNOVATION LABS PRIVATE LIMITED",
"ONEGLOBE LOGISTICS INDIA PRIVATE LIMITED",
"ONEGLOBE SYSTEMS LLP",
"ONEHPLUS HEALTHCARE PRIVATE LIMITED",
"ONEHUB (CHENNAI) PRIVATE LIMITED",
"ONEIN DIGITECH MEDIA PRIVATE LIMITED",
"ONEINDIA BSC PRIVATE LIMITED",
"ONEINDIG TECHNOLOGIES PRIVATE LIMITED",
"ONEIRIC APPLIANCES PRIVATE LIMITED",
"ONEIRIX ENGINEERING LABORATORIES PRIVATE LIMITED",
"ONEIRO LIFECARE PRIVATE LIMITED",
"ONEJMD INTERNATIONAL PRIVATE LIMITED",
"ONELEAP SOLUTIONS PRIVATE LIMITED",
"ONELIFE CAPITAL ADVISORS LIMITED",
"ONELLA DISTRIBUTION & NETWORK PRIVATE LIMITED",
"ONEMAGNIFY INDIA PRIVATE LIMITED",
"ONEMAHANET INTERTAINMENT PRIVATE LIMITED",
"ONEMARKET INDIA LLP",
"ONEMAX YARN MERCHANTS PRIVATE LIMITED",
"ONEMI TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"ONEMOMENT CONSULTANCY LLP",
"CEREONE MEDIA PRIVATE LIMITED",
"ONENESS CONTROLPANELS PRIVATE LIMITED",
"ONENESS FOUNDATION",
"ONENESS POLYCHEM INDIA PRIVATE LIMITED",
"ONEOHM THOUGHT POWER INDIA PRIVATE LIMITED",
"ONEOTT INTERTAINMENT LIMITED",
"ONEPAPER RESEARCH ANALYSTS PRIVATE LIMITED",
"ONEPATH INTEGRATED SOLUTIONS PRIVATE LIMITED",
"ONEPLEX TELEVISION PRIVATE LIMITED",
"ONEPLUS TECHNOLOGY INDIA PRIVATE LIMITED",
"ONERANK INFRATECH PRIVATE LIMITED",
"ONEROUF RESOURCES PRIVATE LIMITED",
"ONESHIELD INDIA PRIVATE LIMITED",
"ONESKY OFFSHORE PRIVATE LIMITED",
"ONESOURCE POLYMERS PRIVATE LIMITED",
"ONESS INFRA PRIVATE LIMITED",
"ONEST LIMITED",
"ONESTEP HEALTHCARE PRIVATE LIMITED",
"ONE-STEP LIFESTYLE SOLUTIONS PRIVATE LIMITED",
"ONESTO LABS PRIVATE LIMITED",
"ONESTOP RETAIL PRIVATE LIMITED",
"ONESTORE INDIA PRIVATE LIMITED",
"ONETAKEMEDIA.COM PRIVATE LIMITED",
"ONETAPE (INDIA) PRIVATE LIMITED",
"ONETEAM FREIGHT MANAGEMENT PRIVATE LIMITED",
"ONETICK TECHNOLOGIES PRIVATE LIMITED",
"ONETO11 PRIVATE LIMITED",
"ONETREE CAPITAL MANAGEMENT PRIVATE LIMITED",
"ONEUP ENTERTAINMENT PRIVATE LIMITED",
"ONEUP EXTRUSION PRIVATE LIMITED",
"ONE-UP FINANCIAL CONSULTANTS PVT LTD",
"ONEUP FURNITURE PRIVATE LIMITED",
"ONEUP INDUSTRIES PRIVATE LIMITED",
"ONEUP MOTORS INDIA PRIVATE LIMITED",
"ONEVISION SOFTWARE INDIA PRIVATE LIMITED",
"ONEWAY FILMS PRIVATE LIMITED",
"ONEWAY IT SOLUTIONS PRIVATE LIMITED",
"ONEWORKS BIM TECHNOLOGIES PRIVATE LIMITED",
"ONEWORLD CORPORATION PRIVATE LIMITED",
"ONEWORLD LOGISTICS PRIVATE LIMITED",
"ONEWORLD RETAIL DIVISION",
"ONEWORLD SHIPPING SERVICES PRIVATE LIMITED",
"ONEX INDUSTRIES PRIVATE LIMITED",
"ONEX LIFE SCIENCE PRIVATE LIMITED",
"ONEX SOFTECH PRIVATE LIMITED",
"ONEXIS AUTOMATIONS PRIVATE LIMITED",
"ONEXTEL MEDIA PRIVATE LIMITED",
"ONFIDO SERVICES INDIA PRIVATE LIMITED",
"ONFIELD VENTURES PRIVATE LIMITED",
"ONFLEEK MEDIA AND TECHNOLOGIES PRIVATE LIMITED",
"ONGC ENERGY CENTRE TRUST",
"ONGC MANGALORE PETROCHEMICALS LIMITED",
"ONGC PETRO ADDITIONS LIMITED",
"ONGC PUBLIC SCHOOL",
"ONGC TERI BIOTECH LIMITED",
"ONGC TRIPURA POWER COMPANY LIMITED",
"ONGC VIDESH LIMITED",
"ONGC VIDESH ROVUMA LIMITED",
"ONGOLE EDUCATIONAL ACADAMY PRIVATE LIMITED",
"ONGOLE LOGISTICS PRIVATE LIMITED",
"ONGOLE MILKLINE PRIVATE LIMITED",
"ONICRA CREDIT INFORMATION COMPANY PRIVATE LIMITED",
"ONICRA CREDIT RATING AGENCY OF INDIA PRIVATE LIMITED",
"ONILE RETAIL PRIVATE LIMITED",
"ONIO DESIGN PRIVATE LIMITED",
"ONIO SELLER SERVICES PRIVATE LIMITED",
"ONION CONSULTING PRIVATE LIMITED",
"ONION HEALTHCARE PRIVATE LIMITED",
"ONION INSIGHTS PRIVATE LIMITED",
"ONIONDEV TECHNOLOGIES PRIVATE LIMITED",
"ONIONS CREATIVE MEDIA PRIVATE LIMITED",
"ONIP LIFESTYLE PRIVATE LIMITED",
"ONIS HOTELS PRIVATE LIMITED",
"ONIT INDIA PRIVATE LIMITED",
"ONIX ENCLAVES PRIVATE LIMITED",
"ONIX RENEWABLE LIMITED",
"ONIX STRUCTURE PRIVATE LIMITED",
"ONIX TRANS POWER PRIVATE LIMITED",
"ONJECTION LABS PRIVATE LIMITED",
"ONKAR BEARING PRIVATE LIMITED",
"ONKAR CONSTRUCTION COMPANY PVT LTD",
"ONKAR DIES PRIVATE LIMITED",
"ONKAR DIESEL WORKS INDIA PRIVATE LIMITED",
"ONKAR EDUCATIONAL ACADEMY PRIVATE LIMITED",
"ONKAR EXIM PRIVATE LIMITED",
"ONKAR FODDER MILLS PVT LTD",
"ONKAR INDUSTRIAL AND SECURITY SERVICES PRIVATE LIMITED",
"ONKAR INFOTECH PRIVATE LIMITED",
"ONKAR INTERNATIONAL PRIVATE LIMITED",
"ONKAR JEWELLERS PRIVATE LIMITED",
"ONKAR NATH BHALLA & SONS CONTRACTOR PRIVATE LIMITED",
"ONKAR PARIVAHAN FINANCE PVT LTD",
"ONKAR POLYMERS PRIVATE LIMITED",
"ONKAR POLYPLAST PRIVATE LIMITED",
"ONKAR ROADWAYS PRIVATE LIMITED",
"ONKAR SEEDS CORPORATION",
"ONKAR TRADECOM PRIVATE LIMITED",
"ONKARA BEVERAGES & HOSPITALITY PRIVATE LIMITED",
"ONKARNATH RICE MILL PRIVATE LIMITED",
"ONKARPIT TECHNO PRIVATE LIMITED",
"ONKNATH VIDHYALAY SHAMGAON",
"ONLANE SERVICES PRIVATE LIMITED",
"ONLIEST EDUTECH PRIVATE LIMITED",
"ONLINE CONFIN PRIVATE LIMITED",
"ONLINE GIFTKARTING PRIVATE LIMITED",
"ONLINE INSTRUMENTS INDIA PRIVATE LIMITED",
"ONLINE IT SOLUTIONS PRIVATE LIMITED",
"ONLINE MICRO CONTROLS PRIVATE LIMITED",
"ONLINE NETSYS INDIA PRIVATE LIMITED",
"ONLINE PACKAGING PRIVATE LIMITED",
"ONLINE PERFUMES PRIVATE LIMITED",
"ONLINE PRINT AND PACK PRIVATE LIMITED",
"ONLINE PRODUCTIVITY SOLUTIONS PRIVATE LIMITED",
"ONLINE PSB LOANS LIMITED",
"ONLINE RECHARGE SERVICES PRIVATE LIMITED",
"ONLINE REPUTATION MANAGEMENT PRIVATE LIMITED",
"ONLINE RES INDIA PRIVATE LIMITED",
"ONLINE SECURITIES (INDIA) PRIVATE LIMITED",
"ONLINE SMART HEALTH PRIVAT LIMITED",
"ONLINE SOLUTIONS (IMAGING) PRIVATE LIMITED",
"ONLINE XPRESS SERVICES PRIVATE LIMITED",
"ONLINEBECHO SOLUTIONS INDIA PRIVATE LIMITED",
"ONLINETEKSUPPORT IT SOLUTIONS PRIVATE LIMITED",
"ONLY B2B ITES PRIVATE LIMITED",
"ONLY IT CONSULTING INDIA PRIVATE LIMITED",
"ONLY ONE DIGI E INDOWORLD PRIVATE LIMITED",
"ONLY RETAIL PRIVATE LIMITED",
"ONLY SUCCESS LEARNING TECHNOLOGIES PRIVATE LIMITED",
"ONMOBILE GLOBAL LIMITED",
"ONMOVE LOGISTICS PRIVATE LIMITED",
"ONNET SYSTEMS INDIA PRIVATE LIMITED",
"ONNIVATION VENTURES PRIVATE LIMITED",
"ONNSYNEX VENTURES PRIVATE LIMITED",
"ONNYX ELECTRONISYS PRIVATE LIMITED",
"ONNYYXX PETROCHEM PRIVATE LIMITED",
"ONO LIFESTYLE LIMITED",
"ONO SOKKI INDIA PRIVATE LIMITED",
"ONORA HOSPITALITY PRIVATE LIMITED",
"ONPROCESS TECHNOLOGY INDIA PRIVATE LIMITED",
"ONQANET TECHNOLOGIES PRIVATE LIMITED",
"ONS AGRI LIFE SCIENCES PRIVATE LIMITED",
"ONS EQUIPMENT PRIVATE LIMITED",
"ONS EXPRESS & LOGISTICS ( INDIA ) PRIVATE LIMITED",
"ONS FREIGHT SOLUTION PRIVATE LIMITED",
"ONS IMPEX TRADERS PRIVATE LIMITED",
"ONS INTERACTIVE SOLUTIONS PRIVATE LIMITED",
"ONS MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"ONS PERSONAL CARE PRIVATE LIMITED",
"ONS SOFTWARE SYSTEM PRIVATE LIMITED",
"ONSET EXPORTERS PRIVATE LIMITED",
"ONSET INTERIORS PRIVATE LIMITED",
"ONSHORE CONSTRUCTION COMPANY PRIVATE LIMITED",
"ONSHORE ENGINEERING AND PROJECTS PRIVATE LIMITED",
"ONSHORE INFRASTRUCTURE DEVELOPMENT PROJECTS PRIVATE LIMITED",
"ONSIGHT ANALYTICS SOLUTIONS INDIA PRIVATE LIMITED",
"ONSITE INDIA PRIVATE LIMITED",
"ONSITE PHONES PRIVATE LIMITED",
"ONSMECHCON PROJECT PRIVATE LIMITED",
"ONSPACE TECHNOLOGIES PRIVATE LIMITED",
"ONSTRUQ INTERLAYER PRIVATE LIMITED",
"ONSUMAYE WEB SOLUTIONS PRIVATE LIMITED",
"ONTEAM HOSPITALITY LLP",
"ONTIC TECHNOLOGIES INDIA PRIVATE LIMITED",
"ONTIME HIREPURCHASE AND AGENCIES PVT LTD",
"ONTIME SOLUTIONS PRIVATE LIMITED",
"ONTIME TRAVELS PRIVATE LIMITED",
"ONTOGENY ENGITECH PRIVATE LIMITED",
"ONTOP PHARMACEUTICALS PRIVATE LIMITED",
"ONTOS INFORMATION SYSTEMS PRIVATE LIMITED",
"ONTRACK BUSINESS SOLUTIONS PRIVATE LIMITED",
"ONTRACK HR SERVICES PRIVATE LIMITED",
"ONTRUST CAPITAL MARKETS PRIVATE LIMITED",
"ONUS HEALTHCARE PRIVATE LIMITED",
"ONUS IMPEX PRIVATE LIMITED",
"ONVA TELESYSTEMS PRIVATE LIMITED",
"ONWARD CHEMICALS PRIVATE LIMITED",
"ONWARD COMMODEAL PRIVATE LIMITED",
"ONWARD COWORKX PRIVATE LIMITED",
"ONWARD ESERVICES LIMITED",
"ONWARD KNITWEAR SOLUTIONS PRIVATE LIMITED",
"ONWARD PLASTIC PRIVATE LIMITED",
"ONWARD SHIPPING (INDIA) PRIVATE LIMITED",
"ONWARD TECHNOLOGIES LIMITED",
"ONWEB SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"ONYA DIGITAL SOLUTIONS PRIVATE LIMITED",
"ONYCON ENGINEERS",
"ONYX BIOTEC PRIVATE LIMITED",
"ONYX EQUIPMENTS INDIA PRIVATE LIMITED",
"ONYX EXPO-TRADERS PRIVATE LIMITED",
"ONYX HOTELS PRIVATE LIMITED",
"ONYX INDIA ENGINEERING PRIVATE LIMITED",
"ONYX MACHINERY PRIVATE LIMITED",
"ONYX OIL INDIA PRIVATE LIMITED",
"ONYX TECHNO SYSTEM PRIVATE LIMITED",
"ONYX TECHNOSERVE PRIVATE LIMITED",
"ONZE TECHNOLOGIES INDIA PRIVATE LIMITED",
"OO PCCF MP BHOPAL MADHYA PRADESH",
"OO S I S I GOVT OF INDIA",
"OO7 TRADE INTERNATIONAL PRIVATE LIMITED",
"OOA EMPORIO PRIVATE LIMITED",
"OOBEDU PRIVATE LIMITED",
"OOCL INDIA PRIVATE LIMITED",
"OOCL LOGISTICS (INDIA) PRIVATE LIMITED",
"OODLES TECHNOLOGIES PRIVATE LIMITED",
"OODLIFE RETAIL FRANCHISE PRIVATE LIMITED",
"OODU IMPLEMENTERS PRIVATE LIMITED",
"OOFOAM FOOTWEARS PRIVATE LIMITED",
"OOH ADVT SERVICES PRIVATE LIMITED",
"OOH FOODS PRIVATE LIMITED",
"OOHMA MULTIMEDIA PRIVATE LIMITED",
"OOHTECH MEDIA PRIVATE LIMITED",
"OOJ ORGANIC PRODUCTS PRIVATE LIMITED",
"OOLYMPUS HOSPITALS (OPC) PRIVATE LIMITED",
"OOMKAR TECHNICAL SERVICES PRIVATE LIMITED",
"OOMS POLYMER MODIFIED BITUMEN PRIVATE LIMITED",
"OORJA DEVELOPMENT SOLUTIONS INDIA PRIVATE LIMITED",
"OORJA ENERGY ENGINEERING SERVICES HYDERABAD PRIVATE LIMITED",
"OORJA ON MOVE INFRA PRIVATE LIMITED",
"OORJA TECHNICAL SERVICES PRIVATE LIMITED",
"OORJAN CLEANTECH PRIVATE LIMITED",
"OORJEESHAA MIRACLES OORJEESHAA PRIVATE LIMITED",
"OORJITA BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"OORJITA PROJECTS PRIVATE LIMITED",
"OORMI CHITFUNDS (INDIA) PRIVATE LIMITED",
"OORWIN LABS INDIA PRIVATE LIMITED",
"OOSTELIJKE ONDERNEMING LLP",
"OOTACAMUND GYMKHANA CLUB",
"OP & SONS TRADERS PRIVATE LIMITED",
"OP AGRO OIL PRIVATE LIMITED",
"OP INDIA PRIVATE LIMITED",
"OP JINDAL GLOBAL UNIVERSITY",
"OP JINDAL UNIVERSITY",
"OP MOTORS PRIVATE LIMITED",
"OP PHARMA DISTRIBUTOR PRIVATE LIMITED",
"OPA HOSPITALITY PRIVATE LIMITED",
"OPA MARKETING TECH PRIVATE LIMITED",
"OPA WEAVES PRIVATE LIMITED",
"OPA YARN PRIVATE LIMITED",
"OPAL ASIA INDIA PRIVATE LIMITED",
"OPAL CYBER SOLUTIONS PRIVATE LIMITED",
"OPAL ENGINES PVT LTD",
"OPAL FABRICS PRIVATE LIMITED",
"OPAL HOSPITAL PRIVATE LIMITED",
"OPAL HOSPITALITY SERVICES PRIVATE LIMITED",
"OPAL HVAC ENGINEERS PRIVATE LIMITED",
"OPAL INFRATECH PRIVATE LIMITED",
"OPAL METAL ENGINEERING PRIVATE LIMITED",
"OPAL PAINTS PRODUCTS PRIVATE LIMITED",
"OPAL PHARMACEUTICALS PVT LTD",
"OPAL POLYMERS PRIVATE LIMITED",
"OPALFORCE SOFTWARE INDIA LIMITED",
"OPALINA TECHNOLOGIES PRIVATE LIMITED",
"OPAL-RT TECHNOLOGIES INDIA PRIVATE LIMITED",
"OPAQUE CERAMICS PRIVATE LIMITED",
"OPASA SOFTWARE SERVICES INDIA PRIVATE LIMITED",
"OPASIL PIGMENTS AND CHEMICALS PRIVATE LIMITED",
"OPC ASSET SOLUTIONS PRIVATE LIMITED",
"OPC TECHNOLOGY JAPAN PRIVATE LIMITED",
"OPC TURNKEY SOLUTIONS PRIVATE LIMITED",
"OPC WOOLLENS PRIVATE LIMITED",
"OPCITO TECHNOLOGIES PRIVATE LIMITED",
"OPCOMMERCE ONLINE PRIVATE LIMITED",
"OPCORD CONSULTANCY SERVICES PRIVATE LIMITED",
"OPCORE SERVICES LIMITED",
"OPCORE SERVICES PRIVATE LIMITED",
"OPEC UDYOG PRIVATE LIMITED",
"OPEL AUTO ELECTROTECH PRIVATE LIMITED",
"OPEL AUTO PRODUCTS PRIVATE LIMITED",
"OPEL ELECTRICA PRIVATE LIMITED",
"OPEL ENERGY SYSTEMS PRIVATE LIMITED",
"OPEL FABRICS PRIVATE LIMITED",
"OPEL LIFTS PRIVATE LIMITED",
"OPEL SULZ PRIVATE LIMITED",
"OPEL SYSTEMS AND CONSULTANTS PRIVATE LIMITED",
"OPEL TRANSPORT PRIVATE LIMITED",
"OPELFUSION PREMEDIA PRIVATE LIMITED",
"OPELINA SUSTAINABLE SERVICES PRIVATE LIMITED",
"OPELOX TECHNOLOGIES PRIVATE LIMITED",
"OPEN ACCESS ELECTRICITY PRIVATE LIMITED",
"OPEN ACCESS TECHNOLOGY INDIA PRIVATE LIMITED",
"OPEN ART PROJECT DIGITAL PRIVATE LIMITED",
"OPEN DESTINATION INFOTECH PRIVATE LIMITED",
"OPEN DOORS FINTECH PRIVATE LIMITED",
"OPEN FINANCIAL TECHNOLOGIES PRIVATE LIMITED",
"OPEN FUTURES & COMMODITIES PRIVATE LIMITED",
"OPEN FUTURES & DERIVATIVES PRIVATE LIMITED",
"OPEN GROUP INDIA PRIVATE LIMITED",
"OPEN MEDIA NETWORK PRIVATE LIMITED",
"OPEN MIND CADCAM TECHNOLOGIES INDIA PRIVATE LIMITED",
"OPEN MIND SERVICES LIMITED",
"OPEN MINDS A BIRLA SCHOOL",
"OPEN MINDS SERVICES PRIVATE LIMITED",
"OPEN ONLINE SECURITIES PRIVATE LIMITED",
"OPEN SILICON RESEARCH PRIVATE LIMITED",
"OPEN SOFTWARE TECHNOLOGY INDIA LIMITED",
"OPEN SOLUTIONS SOFTWARE SERVICES PRIVATE LIMITED",
"OPEN STRATEGY & DESIGN PRIVATE LIMITED",
"OPEN TEXT CORPORATION INDIA PRIVATE LIMITED",
"OPEN TEXT TECHNOLOGIES INDIA PRIVATE LIMITED",
"OPEN WEAVER INDIA PRIVATE LIMITED",
"OPEN WINDOW SYSTEMS PRIVATE LIMITED",
"OPEN WORLD INSURANCE BROKING LIMITED",
"OPENDOORS FINTECH PRIVATE LIMITED",
"OPENDR BUSINESS SERVICES PRIVATE LIMITED",
"OPENGATEWAY LLP",
"OPENGROWTH MEDIA PRIVATE LIMITED",
"OPENLX TECHNOLOGIES PRIVATE LIMITED",
"OPENMARKET SERVICES INDIA PRIVATE LIMITED",
"OPENMIND CONSULTANTS PRIVATE LIMITED",
"OPENMIND E- DESIGN PRIVATE LIMITED",
"OPENMIND INNOVATIONS PRIVATE LIMITED",
"OPENPLAY TECHNOLOGIES PRIVATE LIMITED",
"OPENPRISE TECHNOLOGIES PRIVATE LIMITED",
"OPENSENSE LABS PRIVATE LIMITED",
"OPENSPACE SERVICES PRIVATE LIMITED",
"OPENTEQ CONSULTANTS PRIVATE LIMITED",
"OPENTRENDS TECHNOLOGIES PRIVATE LIMITED",
"OPENTURF TECHNOLOGIES PRIVATE LIMITED",
"OPENVIEW TECHNOLOGIES PRIVATE LIMITED",
"OPENWAVE COMPUTING SERVICES PRIVATE LIMITED",
"OPENWAVE INDIA PRIVATE LIMITED",
"OPENXCELL TECHNOLABS PRIVATE. LIMITED",
"OPEPL FRESH PRIVATE LIMITED",
"OPERA CLOTHING",
"OPERA ELETECH PRIVATE LIMITED",
"OPERA ELEVATORS PRIVATE LIMITED",
"OPERA GLOBAL PRIVATE LIMITED",
"OPERA GRATIA PRIVATE LIMITED",
"OPERA HOSPITAL MEDICAL AND RESEARCH CENTRE PRIVATE LIMITED",
"OPERA HOUSING PRIVATE LIMITED",
"OPERA IMPEX PRIVATE LIMITED",
"OPERA INFRA PROJECTS PRIVATE LIMITED",
"OPERA INTERNATIONAL SCHOOL",
"OPERA POLY PACK PRIVATE LIMITED",
"OPERA SOFTWARE INDIA PRIVATE LIMITED",
"OPERA SOLUTIONS INDIA PRIVATE LIMITED",
"OPERA ZEN FOODS PRIVATE LIMITED",
"OPERA-INFRASTRUCTURES LLP",
"OPERANT INFOTECH PRIVATE LIMITED",
"OPERATION BLESSING INDIA",
"OPERATION MERCY INDIA FOUNDATION",
"OPERATIONAL ENERGY GROUP INDIA LIMITED",
"OPERATIONDESK IT SOLUTIONS PRIVATE LIMITED",
"OPERATIVE INDIA PRIVATE LIMITED",
"OPES HEALTH CARE PRIVATE LIMITED",
"OPEXWORKS SOLUTIONS PRIVATE LIMITED",
"OPEZEE PRIVATE LIMITED",
"OPFIN SOFTWARE PRIVATE LIMITED",
"OPG BUSINESS CENTRE PRIVATE LIMITED",
"OPG ENERGY PRIVATE. LIMITED.",
"OPG METALS PRIVATE LIMITED",
"OPG POWER GENERATION PRIVATE. LIMITED.",
"OPG POWER SYSTEMS PRIVATE LIMITED",
"OPG RENEWABLE ENERGY PRIVATE LIMITED",
"OPG SECURITIES PRIVATE LIMITED",
"OPHAL OPTRONICS INDIA PRIVATE LIMITED",
"OPIANT TECHNOLOGIES PRIVATE LIMITED",
"OPJ FINANCIAL SERVICES PRIVATE LIMITED",
"OPJ STEEL TRADING PRIVATE LIMITED",
"OPJ TRADING PRIVATE LIMITED",
"OPK E SERVICES PRIVATE LIMITED",
"OPK INFOTECH PRIVATE LIMITED",
"OPL DIGITAL SERVICES PRIVATE LIMITED",
"OPLIFI DIGITAL PRIVATE LIMITED",
"OPLUS INDIA RESEARCH AND DEVELOPMENT PRIVATE LIMITED",
"OPLUS MOBITECH INDIA PRIVATE LIMITED",
"OPM LOGISTICS PRIVATE LIMITED",
"OPN ADVERTISING PRIVATE LIMITED",
"OPOLIS MEDICAL DIAGNOSTIC CENTER PRIVATE LIMITED",
"OPOS VISIONARIES PRIVATE LIMITED",
"OPOYI PRIVATE LIMITED",
"OPPENHEIMER FAITH FOODS PRIVATE LIMITED",
"OPPIDEA CONSULTING PRIVATE LIMITED",
"OPPLE LIGHTING INDIA PRIVATE LIMITED",
"OPPO MOBILES INDIA PRIVATE LIMITED",
"OPPO MOBILES TN PRIVATE LIMITED",
"OPPORTUNE TECHNOLOGIES PRIVATE LIMITED",
"OPPORTUNITY MICROINSURANCE DEVELOPMENT CENTRE",
"OPPTUM SOLUTIONS PRIVATE LIMITED",
"OPRAAHFX ADTECH PRIVATE LIMITED",
"OPRS ENTERPRISES PRIVATE LIMITED",
"OPRT DEVELOPMENT CENTER PRIVATE LIMITED",
"OPRUSS (INDIA) PRIVATE LIMITED",
"OPS JEWELLERS PRIVATE LIMITED.",
"OPS JEWELS PRIVATE LIMITED",
"OPS RAMP INDIA PRIVATE LIMITED",
"OPSARA INDIA PRIVATE LIMITED",
"OPSAWAY IT SERVICES PRIVATE LIMITED",
"OPSCRUISE TECHNOLOGIES PRIVATE LIMITED",
"OPSEC SERVICES INDIA PRIVATE LIMITED",
"OPSERA (INDIA) PRIVATE LIMITED",
"OPSFUSE TECHNOLOGIES PRIVATE LIMITED",
"OPSHUB TECHNOLOGIES PRIVATE LIMITED",
"OPSIS PROJECTS INDIA PRIVATE LIMITED",
"OPSISCARE LIFESCIENCES PRIVATE LIMITED",
"OPSMAINT INDIA BRIDGE DC PLATFORM PRIVATE LIMITED",
"OPSRAMP INDIA PRIVATE LIMITED",
"OPSVEDA ASIA PRIVATE LIMITED",
"OPT CORPORATE WINGS PRIVATE LIMITED",
"OPT DECOR PRIVATE LIMITED",
"OPT INDUSTRIAL SOLUTIONS PRIVATE LIMITED",
"OPT IT TECHNOLOGIES INDIA PRIVATE LIMITED",
"OPT MAN POWER SOLUTIONS PRIVATE LIMITED",
"OPTACREDIT FINTECH PRIVATE LIMITED",
"OPTAM CLINICS PRIVATE LIMITED",
"OPTAMARK BACKEND SOLUTIONS PRIVATE LIMITED",
"OPTBYTE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"OPTC IMPEX PRIVATE LIMITED",
"OPTEAMIX INDIA BUSINESS SOLUTIONS PRIVATE LIMITED",
"OPTEC REALTY PRIVATE LIMITED",
"OPTECH ENGINEERING PRIVATE LIMITED",
"OPTECH SOLUTIONS",
"OPTEGRAL ADVISORY SERVICES PRIVATE LIMITED",
"OPTEL METALS PRIVATE LIMITED",
"OPTEL VISION INDIA PRIVATE LIMITED",
"OPTERNA TECHNOLOGIES PRIVATE LIMITED",
"OPTESSA SOLUTIONS PRIVATE LIMITED",
"OPTHALMOLOGY INSTITUTE",
"OPTHO LIFE SCIENCES PRIVATE LIMITED",
"OPTHO REMEDIES PRIVATE LIMITED",
"OPTIBELT POWER TRANSMISSION INDIA PRIVATE LIMITED",
"OPTIC ELECTRONIC (INDIA) PRIVATE LIMITED",
"OPTIC LITING PRIVATE LIMITED",
"OPTICA SYSTEMS INDIA PRIVATE LIMITED",
"OPTICAL CONTROL SYSTEMS GMBH",
"OPTICAL GALLERY PRIVATE LIMITED",
"OPTICAL HUT PRIVATE LIMITED",
"OPTICO SOLUTIONS PRIVATE LIMITED",
"OPTICOM INFOWAY PRIVATE LIMITED",
"OPTICS AND ALLIED ENGINEERING PRIVATE LIMITED",
"OPTICS INDIA EQUIPMENTS PRIVATE LIMITED",
"OPTICVYU",
"OPTICVYU CONSTRUCTION MONITORING & DOCUMENTATION SERVICES",
"OPTIEMUS ELECTRONICS LIMITED",
"OPTIEMUS INFRACOM LIMITED",
"OPTIGMA SERVICESS LLP",
"OPTIGRISE TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"OPTIKS INNOVATIONS PRIVATE LIMITED",
"OPTIKS MECHATRONICS PRIVATE LIMITED",
"OPTILAN (INDIA) PRIVATE LIMITED",
"OPTILINK NETWORKS PRIVATE LIMITED",
"OPTIMA AUTO PRODUCTS PRIVATE LIMITED",
"OPTIMA DIAMOND TOOLS PRIVATE LIMITED",
"OPTIMA EXIM PVT LTD",
"OPTIMA FOODTECH PRIVATE LIMITED",
"OPTIMA INDIA PACKAGING MACHINES PRIVATE LIMITED",
"OPTIMA INSURANCE BROKERS PRIVATE LIMITED",
"OPTIMA LIFE SCIENCES PRIVATE LIMITED",
"OPTIMA MACHINERY PRIVATE LIMITED",
"OPTIMA MANUFACTURING INDUSTRIES PRIVATE LIMITED",
"OPTIMA MART (OPC) PRIVATE LIMITED",
"OPTIMA POULTRY PRIVATE LIMITED",
"OPTIMA POWER SOLUTIONS INDIA PRIVATE LIMITED",
"OPTIMA RESOURCE INDIA PRIVATE LIMITED",
"OPTIMA RESPONSE MANAGEMENT PRIVATE LIMITED",
"OPTIMA WEIGHTECH PRIVATE LIMITED",
"OPTIMAL CONSULTANCY SERVICES PRIVATE LIMITED",
"OPTIMAL CORPORATE SERVICES PRIVATE LIMITED",
"OPTIMAL DIGITECH PRIVATE LIMITED",
"OPTIMAL INFOTECH PRIVATE LIMITED",
"OPTIMAL POWER SYNERGY INDIA PRIVATE LIMITED",
"OPTIMAL STRATEGIX CONSULTING PRIVATE LIMITED",
"OPTIMAL TELEMEDIA PRIVATE LIMITED",
"OPTIMAL TRANSNATIONAL INDIA PRIVATE. LIMITED",
"OPTIMAS OE SOLUTIONS INDIA PRIVATE LIMITED",
"OPTIMAX NUTRITIONS PRIVATE LIMITED",
"OPTIMINT SOLUTIONS PRIVATE LIMITED",
"OPTIMISE MEDIA GROUP SERVICES PRIVATE LIMITED",
"OPTIMIST PLASTICS PRIVATE LIMITED",
"OPTIMISTIC GREEN ENERGY PRIVATE LIMITED",
"OPTIMISTIC GREEN ENERGY THREE PRIVATE LIMITED",
"OPTIMISTIC TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"OPTIMIZE COURIERS PRIVATE LIMITED",
"OPTIMIZE IT SYSTEMS PRIVATE LIMITED",
"OPTIMIZED SOLUTIONS LIMITED",
"OPTIMIZING RESOURCES PRIVATE LIMITED",
"OPTIMIZORY TECHNOLOGIES PRIVATE LIMITED",
"OPTIMUM COMMERCIALS PRIVATE LIMITED",
"OPTIMUM COMPLIANCE CONSULTANTS PRIVATE LIMITED",
"OPTIMUM DESIGN PRIVATE LIMITED",
"OPTIMUM FINANCIAL SOLUTIONS PRIVATE LIMITED",
"OPTIMUM GOLD AND DIAMONDS PRIVATE LIMITED",
"OPTIMUM INFOSYSTEM PRIVATE LIMITED",
"OPTIMUM LOGISTICS PRIVATE LIMITED",
"OPTIMUM LUXURY RETAIL PRIVATE LIMITED",
"OPTIMUM MEDIA SERVICES PRIVATE LIMITED",
"OPTIMUM OUTWEAR PRIVATE LIMITED",
"OPTIMUM POWER SOLUTION PRIVATE LIMITED",
"OPTIMUM SECURITY SOLUTIONS PRIVATE LIMITED",
"OPTIMUM SILK MILLS PRIVATE LIMITED",
"OPTIMUM TECHNOLOGIES PRIVATE LIMITED",
"OPTIMUM THERAPEUTICS PRIVATE LIMITED",
"OPTIMUM VIKING SATCOM INDIA PRIVATE LIMITED",
"OPTIMUMBREW TECHNOLOGY LLP",
"OPTIMUS COMMODITY FUTURES PRIVATE LIMITED",
"OPTIMUS DRUGS PRIVATE LIMITED",
"OPTIMUS ENTERPRISE PRIVATE LIMITED",
"OPTIMUS ENVIROPRO PRIVATE LIMITED",
"OPTIMUS FINANCE LIMITED",
"OPTIMUS GLOBAL SERVICES LIMITED",
"OPTIMUS HEALTHCARE & RESEARCH PRIVATE LIMITED",
"OPTIMUS INFORMATION INDIA PRIVATE LIMITED",
"OPTIMUS INTEGRATED SOLUTIONS",
"OPTIMUS LIFESTYLE PRIVATE LIMITED",
"OPTIMUS MEDICAL SERVICES PRIVATE LIMITED",
"OPTIMUS PHARMA PRIVATE LIMITED",
"OPTIMUS TRADELINKS PRIVATE LIMITED",
"OPTIMUSLOGIC SYSTEMS INDIA PRIVATE LIMITED",
"OPTIMYSTIX ENTERTAINMENT INDIA PRIVATE LIMITED",
"OPTINNO MOBITECH PRIVATE LIMITED",
"OPTINUVA TECHNOLOGIES PRIVATE LIMITED",
"OPTIOLOGIC TECHNOLOGIES PRIVATE LIMITED",
"OPTION ENGINEERING PRIVATE LIMITED",
"OPTION TILES PRIVATE LIMITED",
"OPTION TRANSPORT PRIVATE LIMITED",
"OPTION45 INVESTMENT PRIVATE LIMITED",
"OPTIONS CLOTHING COMPANY PRIVATE LIMITED",
"OPTIONS GROUP STRATEGIC CONSULTING INDIA PRIVATE LIMITED",
"OPTIONS MEDIA PRIVATE LIMITED",
"OPTIPACE TECHNOLOGIES PRIVATE LIMITED",
"OPTIPHOENIX XPERTS PRIVATE LIMITED",
"OPTIQUA PIPES AND ELECTRICALS PRIVATE LIMITED",
"OPTIRISE SOFTWARE PRIVATE LIMITED",
"OPTISERV SOLUTIONS PRIVATE LIMITED",
"OPTISOL BUSINESS SOLUTIONS PRIVATE LIMITED",
"OPTISUPPLY CHAIN SOLUTION PRIVATE LIMITED",
"OPTISURE INTEGRATED SERVICES (OPC) PRIVATE LIMITED",
"OPTISURGICARE (INDIA) PRIVATE LIMITED",
"OPTITEX INDIA PRIVATE LIMITED",
"OPTIV SECURITY INDIA PRIVATE LIMITED",
"OPTIVA INDIA TECHNOLOGIES PRIVATE LIMITED",
"OPTIVAL HEALTH SOLUTIONS PRIVATE LIMITED",
"OPTIVALUE TEK CONSULTING PRIVATE LIMITED",
"OPTIWISE TECHNOLOGIES PRIVATE LIMITED",
"OPTIZM CONSULTING PRIVATE LIMITED",
"OPTLOG SUPPLY CHAIN PRIVATE LIMITED",
"OPTM HEALTH CARE PRIVATE LIMITED",
"OPTM MEDIA SOLUTIONS PRIVATE LIMITED",
"OPTO AUDIO ELECTRONIC PRODUCTS PVT LTD",
"OPTO ELECTRONIC FACTORY",
"OPTO MARKETING CO PVT LTD",
"OPTO-FINE INSTRUMENTS PRIVATE LIMITED",
"OPTOL TECHNOLOGIES PRIVATE LIMITED",
"OPTOMECH ENGINEERS PVT LTD",
"OPTON INFOCOM PRIVATE LIMITED",
"OPTONET TECHNOLOGIES PRIVATE LIMITED",
"OPTRA SYSTEMS PRIVATE LIMITED",
"OPTRA TECHNOLOGIES PRIVATE LIMITED",
"OPTRASCAN INDIA PRIVATE LIMITED",
"OPTRICA PHARMA PRIVATE LIMITED",
"OPTRONICS TECHNOLOGIES PRIVATE LIMITED",
"OPTRUM METALWARE PRIVATE LIMITED",
"OPTSOFT IT BUSINESS SOLUTIONS PRIVATE LIMITED",
"OPTUM GLOBAL SOLUTIONS INDIA PRIVATE LIMITED",
"OPTUM HEALTH & TECHNOLOGY INDIA PRIVATE LIMITED",
"OPTUMINSIGHT INDIA PRIVATE LIMITED",
"OPTUMSOFT RESEARCH PRIVATE LIMITED",
"OPTUS DEVELOPERS PRIVATE LIMITED",
"OPTUS HOTELS PRIVATE LIMITED",
"OPTUS IMPEX PRIVATE LIMITED",
"OPTYM INDIA PRIVATE LIMITED",
"OPTYMICE GROWTH CONSULTING PRIVATE LIMITED",
"OPULAINCE CAPITAL SERVICES PRIVATE LIMITED",
"OPULENCE WEALTH PRIVATE LIMITED",
"OPULENT AUTO CARE PRIVATE LIMITED",
"OPULENT AUTOMOBILES PRIVATE LIMITED",
"OPULENT FACILITY MANAGEMENT PRIVATE LIMITED",
"OPULENT FINSERV PRIVATE LIMITED",
"OPULENT GREEN ENERGY PRIVATE LIMITED",
"OPULENT INVESTMENT ADVISER PRIVATE LIMITED",
"OPULENT JEWELS PRIVATE LIMITED",
"OPULENT STYLES & TILES PRIVATE LIMITED",
"OPULUS ELECTRICALS INDIA PRIVATE LIMITED",
"OPUS ADVISORY PRIVATE LIMITED",
"OPUS DEI LOGISTICS INDIA PRIVATE LIMITED",
"OPUS FASHIONS PRIVATE LIMITED",
"OPUS INDUSTRIES PRIVATE LIMITED",
"OPUS MEDIA PRIVATE LIMITED",
"OPUS MULTI MEDIA SERVICES PRIVATE LIMITED",
"OPUS PET PRIVATE LIMITED",
"OPUS PROJECTS LIMITED",
"OPUS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"OPUS SOLUTIONS PRIVATE LIMITED",
"OPUSING INFORMATION SERVICES PRIVATE LIMITED",
"OPUSKART INDIA PRIVATE LIMITED",
"OPWELL CERAMIC PRIVATE LIMITED",
"OQ MARKETING LLP",
"ORA ESSENTIAL'S INDIA PRIVATE LIMITED",
"ORA INDIA PRIVATE LIMITED",
"ORA MOTORS PRIVATE LIMITED",
"ORABELLA HOSPITALITY PRIVATE LIMITED",
"ORABLUE CHEM PRIVATE LIMITED",
"ORACHHAVLAL SHETH HIGH SCHOOL",
"ORACITY LIFE SCIENCES LLP",
"ORACLE CERNER HEALTHCARE SOLUTIONS INDIA PRIVATE LIMITED",
"ORACLE COMMUNICATIONS",
"ORACLE CORPORATION",
"ORACLE FINANCIAL SERVICES SOFTWARE LIMITED",
"ORACLE HEALTH PARK PRIVATE LIMITED",
"ORACLE HOSPITAL",
"ORACLE INDIA PRIVATE LIMITED",
"ORACLE MEDICARE PRIVATE LIMITED",
"ORACLE OFSS ASP PRIVATE LIMITED",
"ORACLE OFSS BPO SERVICES LIMITED",
"ORACLE OFSSPROCESSING SERVICES LIMITED",
"ORACLE PLASTICS PRIVATE LIMITED",
"ORACLE POLYMER INDUSTRIES PRIVATE LIMITED",
"ORACLE POLYPLAST",
"ORACLE SECURITIES PRIVATE LIMITED",
"ORACLE SOLUTION SERVICES INDIA PRIVATE LIMITED",
"ORACURA SOLUTIONS PRIVATE LIMITED",
"ORAFACT SOLUTIONS PRIVATE LIMITED",
"ORAFIN FINANCIAL CONSULTANCY PRIVATE LIMITED",
"ORAFUSION CONSULTANTS PRIVATE LIMITED",
"ORAH NUTRICHEM PRIVATE LIMITED",
"ORAI FLOUR MILLS PRIVATE LIMITED",
"ORAI ROBOTICS PRIVATE LIMITED",
"ORAL-3D HEALTH CARE PRIVATE LIMITED",
"ORALFISH AD VENTURES PRIVATE LIMITED",
"ORALIUM LIMITED",
"ORAN INTERNATIONAL VENTURES PRIVATE LIMITED",
"ORANA INDIA PRIVATE LIMITED",
"ORANE CONSULTING PRIVATE LIMITED",
"ORANE FURNISHING PRIVATE LIMITED",
"ORANE HEALTHCARE INDIA PRIVATE LIMITED",
"ORANE INTERNATIONAL PRIVATE LIMITED",
"ORANE REFRACTORIES PRIVATE LIMITED",
"ORANGE & GREEN INTERIORS PRIVATE LIMITED",
"ORANGE AUTO MOTORS PRIVATE LIMITED",
"ORANGE AUTO PRIVATE LIMITED",
"ORANGE AUTOMOTIVE PRIVATE LIMITED",
"ORANGE BIO SCIENCE PRODUCTS PRIVATE LIMITED",
"ORANGE BIOTECH PRIVATE LIMITED",
"ORANGE BUSINESS SERVICES INDIA SOLUTIONS PRIVATE LIMITED",
"ORANGE BUSINESS SERVICES INDIA TECHNOLOGY PRIVATE LIMITED",
"ORANGE BUSINESS SERVICESS INDIA NETWORK PRIVATE LIMITED",
"ORANGE CABS PRIVATE. LIMITED",
"ORANGE CAPITAL INSURANCE BROKING PRIVATE LIMITED",
"ORANGE CARE SOLUTIONS INDIA PRIVATE LIMITED",
"ORANGE CARGO SOLUTIONS PRIVATE LIMITED",
"ORANGE CITY ALLOYS PRIVATE LIMITED",
"ORANGE CITY COLLEGE OF SOCIAL WORK",
"ORANGE CITY GARMENT CLUSTER PRIVATE LIMITED",
"ORANGE CITY GARMENTS LLP",
"ORANGE CITY HOUSING FINANCE PRIVATE LIMITED",
"ORANGE CITY HYDRAULIC WORKS PRIVATE LIMITED",
"ORANGE CITY STEEL INDUSTRIES PRIVATE LIMITED",
"ORANGE CITY WATER PRIVATE LIMITED",
"ORANGE COUNTY RESORTS & HOTELS LIMITED",
"ORANGE DECORS PRIVATE LIMITED",
"ORANGE EDUCATION PRIVATE LIMITED",
"ORANGE EDUCATIONAL SOCIETY",
"ORANGE EEDUCATION PRIVATE LIMITED",
"ORANGE EYES CONSULTING (OPC) PRIVATE LIMITED",
"ORANGE FASHION DESIGNS PRIVATE LIMITED",
"ORANGE FISH ENTERTAINMENT PRIVATE LIMITED",
"ORANGE FOOTWEAR PRIVATE LIMITED",
"ORANGE FOX STEELS PRIVATE LIMITED",
"ORANGE GPS SOLUTIONS PRIVATE LIMITED",
"ORANGE HERMITAGE PRIVATE LIMITED",
"ORANGE HOSPITALS",
"ORANGE HOUSE PRIVATE LIMITED",
"ORANGE IMPEX PRIVATE LIMITED",
"ORANGE INFOCOM PRIVATE LIMITED",
"ORANGE INFRACON PRIVATE LIMITED",
"ORANGE INN PRIVATE LIMITED",
"ORANGE LABS AND SCANS",
"ORANGE MACHINETECH PRIVATE LIMITED",
"ORANGE MEDIPHARMACEUTICALS PRIVATE LIMITED",
"ORANGE MEGASTRUCTURE LLP",
"ORANGE MONEY CHANGER PRIVATE LIMITED",
"ORANGE NUTRACEUTICAL PRIVATE LIMITED",
"ORANGE O TEC PRIVATE LIMITED",
"ORANGE OFFICE TECHNOLOGIES PRIVATE LIMITED",
"ORANGE OVERSEAS PRIVATE LIMITED",
"ORANGE PET NUTRITION PRIVATE LIMITED",
"ORANGE POWER TRANSMISSION & DISTRIBUTION EQUIPMENTS PRIVATE LIMITED",
"ORANGE PRINTERS PRIVATE LIMITED",
"ORANGE PRODUCTIONS PRIVATE LIMITED",
"ORANGE RADIUS ARTS PRIVATE LIMITED",
"ORANGE RENEWABLE POWER PRIVATE LIMITED",
"ORANGE RETAIL FINANCE INDIA PRIVATE LIMITED",
"ORANGE SECURITAS PRIVATE LIMITED",
"ORANGE SORTING MACHINES INDIA PRIVATE LIMITED",
"ORANGE SPA HOTELS & RESORTS PRIVATE LIMITED",
"ORANGE STEELS INDIA PRIVATE LIMITED",
"ORANGE TIGER HOSPITALITY PRIVATE LIMITED",
"ORANGE TOURS & TRIPS PRIVATE LIMITED",
"ORANGE TRADELINK PRIVATE LIMITED",
"ORANGE TREE TECHNOLOGIES PRIVATE LIMITED",
"ORANGE WAVES NETWORKS PRIVATE LIMITED",
"ORANGE WEAVING ENGINEERING PRIVATE LIMITED",
"ORANGE WHEELS INDIA PRIVATE LIMITED",
"ORANGE WORLDWIDE PRIVATE LIMITED",
"ORANGEBELLY FOOD AND BEVERAGES PRIVATE LIMITED",
"ORANGEBITS SOFTWARE TECHNOLOGIES (INDIA) PRIVATE LIMITED\n",
"ORANGEBYTES SYSTEMS PRIVATE LIMITED",
"ORANGEMANTRA TECHNOLOGY PRIVATE LIMITED",
"ORANGEMAX LINKS PRIVATE LIMITED",
"ORANGESTAR LOGISTICS PRIVATE LIMITED",
"ORANGESUN MULTITRADE PRIVATE LIMITED",
"ORANGETAG DISTRIBUTION PRIVATE LIMITED",
"ORAREGA TECHNOLOGIES (OPC) PRIVATE LIMITED",
"ORASI GLOBAL SERVICES INDIA PRIVATE LIMITED",
"ORASI TECHNOLOGY INDIA PRIVATE LIMITED",
"ORASIS INFOTECH PRIVATE LIMITED",
"ORAVAN INDUSTRIAL LOGISTICS AND WAREHOUSING PRIVATE LIMITED",
"ORAVEL STAYS LIMITED",
"ORAVEL STAYS PRIVATE LIMITED",
"ORAYA GAS INDIA PRIVATE LIMITED",
"ORAYAN LOGISTICS PRIVATE LIMITED",
"ORAZONE PAPER PRIVATE LIMITED",
"ORB CERAMIC PRIVATE LIMITED",
"ORB ENERGY PRIVATE LIMITED",
"ORB INDIA TECHSOLENCY PRIVATE LIMITED",
"ORBCOMM TECHNOLOGIES INDIA PRIVATE LIMITED",
"ORBEES BUSINESS SOLUTIONS PRIVATE LIMITED",
"ORBI HEALTH PRIVATE LIMITED",
"ORBI SEEDS INTERNATIONAL PRIVATE LIMITED",
"ORBIC BPO SERVICES PRIVATE LIMITED",
"ORBICULAR PHARMACEUTICAL TECHNOLOGIES PRIVATE LIMITED",
"ORBINOX INDIA PRIVATE LIMITED",
"ORBION PHARMACEUTICALS PRIVATE LIMITED",
"ORBIQE TECHNOLOGIES PRIVATE LIMITED",
"ORBIS ELEVATOR COMPANY LIMITED",
"ORBIS ENGICON LIMITED",
"ORBIS FINANCIAL CORPORATION LIMITED",
"ORBIS HOSPITALITY SERVICES PRIVATE LIMITED",
"ORBIS LUMINAIRES PRIVATE LIMITED",
"ORBIS TRUSTEESHIP SERVICES PRIVATE LIMITED",
"ORBISIS FOOD PRIVATE LIMITED",
"ORBIT ADWORKS PRIVATE LIMITED",
"ORBIT APARTMENT CONSTRUCTION PRIVATE LIMITED",
"ORBIT BEARINGS INDIA PRIVATE LIMITED",
"ORBIT BI PRIVATE LIMITED",
"ORBIT BUILDTECH PRIVATE LIMITED",
"ORBIT CARDIAC CENTER",
"ORBIT CERATILES PRIVATE LIMITED",
"ORBIT CHEM PHARMACEUTICALS PRIVATE LIMITED",
"ORBIT COATINGS PRIVATE LIMITED",
"ORBIT COMPUTERS PRIVATE LIMITED",
"ORBIT CORPORATE & LEISURE TRAVELS I PRIVATE LIMITED",
"ORBIT DIAGNOSTICS PRIVATE LIMITED",
"ORBIT ELECTRICALS PRIVATE LIMITED",
"ORBIT ELECTRODOMESTICS INDIA PRIVATE LIMITED",
"ORBIT ELECTROMECH INDIA PRIVATE LIMITED",
"ORBIT ENGIFAB PROJECTS PRIVATE LIMITED",
"ORBIT ENGLISH SCHOOL",
"ORBIT EQUIPMENTS PRIVATE LIMITED",
"ORBIT ESTATE CONSULTANTS PRIVATE LIMITED",
"ORBIT EXPORTS LIMITED",
"ORBIT HYG COSMETICS EXPORTS PRIVATE LIMITED",
"ORBIT IMAGING AND PATHLAB PRIVATE LIMITED",
"ORBIT IMPEX PRIVATE LIMITED",
"ORBIT IMPOTRADE PRIVATE LIMITED",
"ORBIT INDUSTRIES",
"ORBIT INFRA MARKETING PRIVATE LIMITED",
"ORBIT INSTITUTES PRIVATE LIMITED",
"ORBIT LEATHERS PVT.LTD.",
"ORBIT LIFE SCIENCE PRIVATE LIMITED",
"ORBIT LIFESCIENCE PRIVATE LIMITED",
"ORBIT MARKETING PRIVATE LIMITED",
"ORBIT METAL INDUSTRIES",
"ORBIT MOTORS PRIVATE LIMITED",
"ORBIT MULTITECH PRIVATE LIMITED",
"ORBIT NET SOLUTIONS PRIVATE LIMITED",
"ORBIT POLY PIPES PRIVATE LIMITED",
"ORBIT PROJECT CONSULTANTS INDIA PRIVATE LIMITED",
"ORBIT PROJECTS PRIVATE LIMITED OPPL",
"ORBIT PUMPS & SYSTEMS PRIVATE LIMITED",
"ORBIT RESEARCH ASSOCIATES PRIVATE LIMITED",
"ORBIT SKY GARDENS OWNERS ASSOCIATION",
"ORBIT SOFTWARE SOLUTIONS PRIVATE LIMITED",
"ORBIT SPECIALITY COATINGS PRIVATE LIMITED",
"ORBIT SUPPORT SERVICES PRIVATE LIMITED",
"ORBIT TECHNOLOGIES PRIVATE LIMITED",
"ORBIT TECHSOL INDIA PRIVATE LIMITED",
"ORBIT TECHSOL PRIVATE LIMITED",
"ORBIT TECHSOL W PRIVATE LIMITED",
"ORBIT TEX-PLAS INDUSTRIES PVT LTD",
"ORBIT TIRUPATI TOWERS PRIVATE LIMITED",
"ORBIT TRAVEL AND TOURS PRIVATE LIMITED",
"ORBIT WIRES INDIA PRIVATE LIMITED",
"ORBITAL AUTOMATION PRIVATE LIMITED",
"ORBITAL NETWORK MARKETING PRIVATE LIMITED",
"ORBITAL SYSTEMS (BOMBAY) PVT LTD",
"ORBITECH INFOWARE PRIVATE LIMITED",
"ORBITECH PRIVATE LIMITED",
"ORBITSYS TECHNOLOGIES PRIVATE LIMITED",
"ORBITTAL ELECTROMECH ENGINEERING PROJECTS PRIVATE LIMITED",
"ORBIX DESIGNS PRIVATE LIMITED",
"ORBIZ ANALYTICS INDIA PRIVATE LIMITED",
"ORBLIKE TECHNOLOGIES PRIVATE LIMITED",
"ORBTERRA INFO VISION PRIVATE LIMITED",
"ORBYSOL SYSTEMS PRIVATE LIMITED",
"ORCA HEALTH CARE INDIA PRIVATE LIMITED",
"ORCA RADIO SYSTEMS PRIVATE LIMITED",
"ORCAPOD CONSULTING SERVICES PRIVATE LIMITED",
"ORCH LABORATORIES INDIA PRIVATE LIMITED",
"ORCHARD ADVERTISING PRIVATE LIMITED",
"ORCHARD BRANDS PRIVATE LIMITED",
"ORCHARD BUILDWELL PRIVATE LIMITED",
"ORCHARD EXTRACTIONS PRIVATE LIMITED",
"ORCHARD FRESH COLD CHAIN PRIVATE LIMITED",
"ORCHARD HEALTHCARE PRIVATE LIMITED",
"ORCHESTRA BUYING AND RETAIL INDIA PRIVATE LIMITED",
"ORCHESTRA TELECOM SERVICES PRIVATE LIMITED",
"ORCHESTRATE SYSTEMS PRIVATE LIMITED",
"ORCHESTRATEHR SOLUTIONS PRIVATE LIMITED",
"ORCHEV PHARMA PVT LTD",
"ORCHID (INTERIOR DECORATORS) PVT LTD",
"ORCHID BIO TECH LIMITED",
"ORCHID BIOMEDICAL SYSTEMS PRIVATE LIMITED",
"ORCHID BUILTCON PRIVATE LIMITED",
"ORCHID CERAMICS PRIVATE LIMITED",
"ORCHID CONTAINER LINE PRIVATE LIMITED",
"ORCHID COOLING AND CLEANING PRIVATE LIMITED",
"ORCHID CORPORATE SERVICES INDIA PRIVATE LIMITED",
"ORCHID CREDITS PRIVATE LIMITED",
"ORCHID CROP SCIENCE",
"ORCHID CURE AND CARE PRIVATE LIMITED",
"ORCHID DESIGNS PRIVATE LIMITED",
"ORCHID DEVELOPERS PRIVATE LIMITED",
"ORCHID DMC PRIVATE LIMITED",
"ORCHID ENT OUTFIT PRIVATE LIMITED",
"ORCHID EXIM (INDIA) PRIVATE LIMITED",
"ORCHID FACILITY MANAGEMENT PRIVATE LIMITED",
"ORCHID FIBRES PRIVATE LIMITED",
"ORCHID FOAMS & BUBBLE PRIVATE LIMITED",
"ORCHID GRAND HOSPITALITY PRIVATE LIMITED",
"ORCHID GROUP OF INSTITUTION",
"ORCHID HOSPITALITY AND HOLIDAYS PRIVATE LIMITED",
"ORCHID HOTELS PRIVATE LIMITED",
"ORCHID INDIA MEDISOLUTIONS PRIVATE LIMITED",
"ORCHID INFRASTRUCTURE & HOME DEVELOPERS PRIVATE LIMITED",
"ORCHID INFRASTRUCTURE DEVELOPERS PRIVATE LIMITED",
"ORCHID INSTITUTE OF HEALTHCARE AND RESEARCH PRIVATE LIMITED",
"ORCHID LAMINATES PRIVATE LIMITED",
"ORCHID LOGISTICS PRIVATE LIMITED",
"ORCHID LOGITECH PRIVATE LIMITED",
"ORCHID LOYALTY PRIVATE LIMITED",
"ORCHID MANPOWER CONSULTING PRIVATE LIMITED",
"ORCHID MARINE EXPORTS PRIVATE LIMITED",
"ORCHID MEDICAL CENTRE PRIVATE LIMITED",
"ORCHID MEDISERVICES AND RESEARCH PRIVATE LIMITED",
"ORCHID MEDLIFE PRIVATE LIMITED",
"ORCHID MULTISPECIALITY HOSPITAL",
"ORCHID ONLINE RESEARCH PRIVATE LIMITED",
"ORCHID OVERSEAS PRIVATE LIMITED",
"ORCHID PACKAGING PRIVATE LIMITED",
"ORCHID PHARMA LIMITED",
"ORCHID PROFILES PRIVATE LIMITED",
"ORCHID RENEWABLE POWERTECH PRIVATE LIMITED",
"ORCHID SCIENTIFIC & INNOVATIVE INDIA PRIVATE LIMITED",
"ORCHID SHIPPING PRIVATE LIMITED",
"ORCHID SOFTWARE SERVICES PRIVATE LIMITED",
"ORCHID TIEUP PRIVATE LIMITED",
"ORCHIDACEA GREENHOUSE PVT LTD",
"ORCHIDBOOKS PRIVATE LIMITED",
"ORCHIDS APARTMENTS PRIVATE LIMITED",
"ORCHIDS DIAMOND TOOLS PRIVATE LIMITED",
"ORCHIDS NETWORK & SYSTEMS INDIA PRIVATE LIMITED",
"ORCHIDS THE INTERNATIONAL SCHOOL",
"ORCUS TRADERS PRIVATE LIMITED",
"ORDAIN HEALTH CARE GLOBAL PRIVATE LIMITED",
"ORDANCE FACTORY AMBERNATH",
"ORDEFENCE SYSTEMS LIMITED",
"ORDEN PLATZ (INDIA) PRIVATE LIMITED",
"ORDERGENIE SYNERGY PRIVATE LIMITED",
"ORDINAREE TRIBE PRIVATE LIMITED",
"ORDINEM ENGITECH( INDIA) PRIVATE LIMITED",
"ORDNANCE CLOTHING FACTORY",
"ORDNANCE DEPOT TALEGAON DABHADE",
"ORDNANCE EQUIPMENT FACTORY PHOOL BHAG",
"ORDNANCE FACTORIES BOARD",
"ORDNANCE FACTORY",
"ORDNANCE FACTORY AMBARNATH",
"ORDNANCE FACTORY BHANDARA",
"ORDNANCE FACTORY BHUSAWAL",
"ORDNANCE FACTORY CHANDA",
"ORDNANCE FACTORY KANPUR",
"ORDNANCE FACTORY KHAMARIA",
"ORDNANCE PARACHUTE FACTORY KANPUR",
"ORDR INDIA PRIVATE LIMITED",
"ORE TECH INDUSTRIES PRIVATE LIMITED",
"ORECAL ELECTRO HUB PRIVATE LIMITED",
"OREGANO LIFE PRIVATE LIMITED",
"OREGENAL ELECTRICALS INDIA PRIVATE LIMITED",
"OREGO BIZ SOLUTIONS PRIVATE LIMITED",
"OREL SOUTH ASIA PRIVATE LIMITED",
"ORELIA METALS AND CHEMICALS PRIVATE LIMITED",
"ORELL SOFTWARE SOLUTIONS PRIVATE LIMITED",
"OREM ENTERPRISES PRIVATE LIMITED",
"OREMET ALLOYS AND CASTINGS PRIVATE LIMITED",
"OREMUS CORPORATE SERVICES PRIVATE LIMITED",
"ORENDA FOODS PRIVATE LIMITED",
"ORENGE INDIA BRASS METAL WORKS PRIVATE LIMITED",
"ORENZTECH PRIVATE LIMITED",
"OREOPS FRAMEWORK PRIVATE LIMITED",
"ORES ISPAT PRIVATE LIMITED",
"OREVA ENERGY PRIVATE LIMITED",
"OREX PHARMA PRIVATE LIMITED",
"ORFEO SPINNING MILLS PRIVATE LIMITED",
"ORFINA CERAMIC PRIVATE LIMITED",
"ORFLAX (INDIA) PRIVATE LIMITED",
"ORGADATA INDIA PRIVATE LIMITED",
"ORGAEARTH CLEANSOL PRIVATE LIMITED",
"ORGAFEED PRIVATE LIMITED",
"ORGAMATION TECH PRIVATE LIMITED",
"ORGAMINE CHEMICALS (INDIA) PVT LTD",
"ORGAN AGRICHEM & SEEDS PRIVATE LIMITED",
"ORGANATURE AGROFOODS PRIVATE LIMITED",
"ORGANI BOTANIKA INDIA PRIVATE LIMITED",
"ORGANIC BRAND PROMOTION SERVICES PRIVATE LIMITED",
"ORGANIC CHEMOILS",
"ORGANIC COATINGS LIMITED",
"ORGANIC DEHYDRATED FOODS PRIVATE LIMITED",
"ORGANIC GREEN FOODS LIMITED",
"ORGANIC GREENARY SYSTEMS PRIVATE LIMITED",
"ORGANIC HERBS PRIVATE LIMITED",
"ORGANIC INDIA PRIVATE LIMITED",
"ORGANIC INDUSTRIES PRIVATE LIMITED",
"ORGANIC INFORMATION SERVICES PRIVATE LIMITED",
"ORGANIC PLASTICS PRIVATE LIMITED",
"ORGANIC RECYCLING SYSTEMS LIMITED",
"ORGANIC RECYCLING SYSTEMS PRIVATE LIMITED",
"ORGANIC WORLD PRIVATE LIMITED",
"ORGANICA AROMATICS PRIVATE LIMITED",
"ORGANICA BIOTECH PRIVATE LIMITED",
"ORGANICA PURE FARM PRODUCTS PRIVATE LIMITED",
"ORGANICA WATER PRIVATE LIMITED",
"ORGANICO AGRO-FOODS & BEVERAGES PRIVATE LIMITED",
"ORGANICUT FRESH PRIVATE LIMITED",
"ORGANICWELLNESS PRODUCTS PRIVATE LIMITED",
"ORGANIK MEDIA SERVICES PRIVATE LIMITED",
"ORGANINC STUDIOS PRIVATE LIMITED",
"ORGANISATION OF PHARMACEUTICAL PRODUCERS OF INDIA",
"ORGANISED TRANS SOLUTIONS PRIVATE LIMITED",
"ORGANO BIOTECH LABORATORIES PRIVATE LIMITED",
"ORGANO ECO HABITATS PRIVATE LIMITED",
"ORGANO FERTILIZERS INDIA PRIVATE LIMITED",
"ORGANO GREEN FARMS PRIVATE LIMITED",
"ORGANON HOMOEO LABORATORY PVT LTD",
"ORGANON INDIA PRIVATE LIMITED",
"ORGANOSYN LIFE SCIENCES PRIVATE LIMITED",
"ORGANOVA BIO-AGRICULTURE PRIVATE LIMITED",
"ORGATMA ORGANIC SCIENCE PRIVATE LIMITED",
"ORGATREATMENTS PRIVATE LIMITED",
"ORGFARM SUPPLIES PRIVATE LIMITED",
"ORGO CHEM (GUJRAT) PVT LTD",
"ORGOGROWTH INDIA PRIVATE LIMITED",
"ORGOHILLS FARMERS PRODUCER COMPANY LIMITED",
"ORGPICK PRIVATE LIMITED",
"ORGSPIRE INFO TECHNOLOGIES P LIMITED",
"ORGWARE TECHNOLOGIES PRIVATE LIMITED",
"ORGYN LABORATORIES PRIVATE LIMITED",
"ORHAN SHIPPING PRIVATE LIMITED",
"ORI MAN SURVEY AND ENGINEERING PRIVATE LIMITED",
"ORI PLAST LTD",
"ORI VENTURES PRIVATE LIMITED",
"ORIAL IMARA PRIVATE LIMITED",
"ORIANA COMMUNICATIONS PRIVATE LIMITED",
"ORIANA HEALTHINSIGHT ANALYTICS PRIVATE LIMITED",
"ORIANA HOSPITAL PRIVATE LIMITED",
"ORIANA POWER LIMITED",
"ORIANA POWER PRIVATE LIMITED",
"ORIANAA DECORPACK PRIVATE LIMITED",
"ORIANO CLEAN ENERGY PRIVATE LIMITED",
"ORICAST INTERNATIONAL PRIVATE LIMITED",
"ORICCA CORPORATE PRIVATE LIMITED",
"ORICLEAN PRIVATE LIMITED",
"ORICO IMPEX PRIVATE LIMITED",
"ORICON ENGINEERS PRIVATE LIMITED",
"ORICON ENTERPRISES LIMITED",
"ORICON EQUIPMENTS PRIVATE LIMITED",
"ORIEARTH NATURE FOUNDATION",
"ORIEL COMMERCIAL PRIVATE LIMITED",
"ORIEL FINANCIAL SOLUTIONS PRIVATE LIMITED",
"ORIEL HEALTHCARE PRIVATE LIMITED",
"ORIEL WINDOWS PRIVATE LIMITED",
"ORIEN ENGINEERS PVT LTD",
"ORIENS GLOBAL MARKETING PRIVATE LIMITED",
"ORIENT (GOA) PRIVATE LIMITED",
"ORIENT ABRASIVES LIMITED",
"ORIENT ABRATECH PRIVATE LIMITED",
"ORIENT ADVANCED MATERIALS PRIVATE LIMITED",
"ORIENT AGENCY PRIVATE LIMITED",
"ORIENT ALUMINIUMS PRIVATE LIMITED",
"ORIENT AROMA CHEMICAL INDUSTRIES PRIVATE LIMITED",
"ORIENT BATH PRIVATE LIMITED",
"ORIENT BELL LIMITED",
"ORIENT BEVERAGES LIMITED",
"ORIENT BLACKSWAN PRIVATE LIMITED",
"ORIENT BOARD AND PAPER MILLS PRIVATE LIMITED",
"ORIENT BODY SHOP SOLUTIONS INDIA PRIVATE LIMITED",
"ORIENT BONDS AND STOCK LIMITED",
"ORIENT BOX MOVERS PRIVATE LIMITED",
"ORIENT BUSINESS SERVICES PVT LTD.",
"ORIENT CABLES INDIA PRIVATE LIMITED",
"ORIENT CEMENT LIMITED",
"ORIENT CERAMICS",
"ORIENT CERATECH LIMITED",
"ORIENT CLUB PRIVATE LIMITED",
"ORIENT COATED PRIVATE LIMITED",
"ORIENT COLOR ART PRINTERS PRIVATE LIMITED",
"ORIENT COMPONENTS PRIVATE LIMITED",
"ORIENT COMPRESSOR ACCESSORIES P LIMITED",
"ORIENT CONSTRUCTIONS PVT LTD",
"ORIENT CRAFT EXCHANGE LIMITED",
"ORIENT DRUGS PRIVATE LIMITED",
"ORIENT ECO SYSTEMS PRIVATE LIMITED",
"ORIENT ELECTRIC A DIV OF ORIENT PAPER & INDUSTRIES LIMITED",
"ORIENT ELECTRIC HOUSE PRIVATE LIMITED",
"ORIENT ELECTRIC LIMITED",
"ORIENT ELECTRICALS AND ENGINEERS INDIA PRIVATE LIMITED",
"ORIENT ENTERPRISE GUJARAT PRIVATE LIMITED",
"ORIENT EXCHANGE AND FINANCIAL SERVICES PRIVATE LIMITED",
"ORIENT EXPLOSIVES PVT LTD",
"ORIENT EXPORTS PRIVATE LIMITED",
"ORIENT EXPRESS PRIVATE LIMITED.",
"ORIENT EXPRESS SHIP MANAGEMENT LIMITED",
"ORIENT FASHION EXPORTS INDIA PRIVATE LIMITED",
"ORIENT FINCORP LIMITED",
"ORIENT FIRE CURTAINS INDIA PRIVATE LIMITED",
"ORIENT FLIGHTS PRIVATE LIMITED",
"ORIENT FORWARDERS (INDIA) PRIVATE LIMITED",
"ORIENT GEMS & ORNAMENTS PRIVATE LIMITED",
"ORIENT GENERAL AGENCIES (BOMBAY) PRIVATE LIMITED",
"ORIENT GLAZES PRIVATE LIMITED",
"ORIENT GREEN POWER COMPANY (RAJASTHAN) PRIVATE LIMITED",
"ORIENT HERBS LTD",
"ORIENT HOSPITAL PRIVATE LIMITED",
"ORIENT INFRACON PRIVATE LIMITED",
"ORIENT ISPAT PRIVATE LIMITED",
"ORIENT KAGAZ CONVERTERS PRIVATE LIMITED.",
"ORIENT LINKS PRIVATE LIMITED",
"ORIENT MARINE LINES LOGISTICS & WAREHOUSING PRIVATE LIMITED",
"ORIENT MICRO ABRASIVES LIMITED",
"ORIENT MULTIPRODUCTS WORLDWIDE PRIVATE LIMITED",
"ORIENT PACKAGING",
"ORIENT PACKAGINGS LIMITED",
"ORIENT PALACES",
"ORIENT POLYFILMS PRIVATE LIMITED",
"ORIENT PRESS LIMITED",
"ORIENT PROCESSORS PVT LTD",
"ORIENT PUBLICITY SERVICE PRIVATE LIMITED",
"ORIENT REFRACTORIES LIMITED",
"ORIENT RUBBER PRODUCTS PRIVATE LIMITED",
"ORIENT SERVICES INDIA PRIVATE LIMITED",
"ORIENT SHIP MANAGEMENT AND MANNING PRIVATE LIMITED",
"ORIENT SPECTRA CONSULTING PRIVATE LIMITED",
"ORIENT STAR TRANSPORT INTERNATIONAL PRIVATE LIMITED",
"ORIENT TECHNOLOGIES LIMITED",
"ORIENT TECHNOLOGIES PRIVATE LIMITED",
"ORIENT TEXFABS PRIVATE LIMITED",
"ORIENT TRADELINK LIMITED",
"ORIENT WINE COMPANY PRIVATE LIMITED",
"ORIENT WIRE ROPES PRIVATE LIMITED",
"ORIENTA CINE ADVERTISING PRIVATE LIMITED",
"ORIENTA LIFE SCIENCES PRIVATE LIMITED",
"ORIENTAL AGENCIES",
"ORIENTAL AIR AND SHIP SERVICES LIMITED",
"ORIENTAL AIR CONDITIONING SERVICES PRIVATE LIMITED",
"ORIENTAL AQUAFLORA PRIVATE LTD",
"ORIENTAL AROMATICS LIMITED",
"ORIENTAL AUTOMATION SYSTEMS PRIVATE LIMITED",
"ORIENTAL BANK OF COMMERCE",
"ORIENTAL BIOTECH LIMITED",
"ORIENTAL BOTTLING PRIVATE LIMITED",
"ORIENTAL BUILDTECH PRIVATE LIMITED",
"ORIENTAL CARBON & CHEMICALS LIMITED",
"ORIENTAL CARBON & CHEMICALS LTD",
"ORIENTAL CARRIERS PVT LTD",
"ORIENTAL CASTINGS PVT LTD",
"ORIENTAL CERAMICS & REFRACTORIES P LIMITED",
"ORIENTAL CHEMICAL WORKS PRIVATE LIMITED",
"ORIENTAL COKE MANUFACTURING PRIVATE LIMITED",
"ORIENTAL COLLEGE OF NURSING MANIKPUR DISTT KORBA C.G.",
"ORIENTAL CONSOLIDATORS PRIVATE LIMITED",
"ORIENTAL CONSULTANTS INDIA PRIVATE LIMITED",
"ORIENTAL CRAFTS MANUFACTURING COMPANY PRIVATE LIMITED",
"ORIENTAL CUISINES PRIVATE LIMITED",
"ORIENTAL DYEING AND PRINTING MILLS PRIVATE LIMITED",
"ORIENTAL EDUMED PRIVATE LIMITED",
"ORIENTAL ELECTRICAL COMPONENTS PRIVATE LIMITED",
"ORIENTAL ENGINEERING COMPANY",
"ORIENTAL ENGINEERING WORKS PRIVATE LIMITED",
"ORIENTAL ENGINEERS INDIA PRIVATE LIMITED",
"ORIENTAL EPC PRIVATE LIMITED",
"ORIENTAL FABRITECH PRIVATE LIMITED",
"ORIENTAL FERRO-ALLOYS PRIVATE LIMITED",
"ORIENTAL FOUNDRY PRIVATE LIMITED",
"ORIENTAL FURNISHERS PVT LTD",
"ORIENTAL GEMCO PRIVATE LIMITED",
"ORIENTAL HOTELS LIMITED",
"ORIENTAL INTEGRATED FACILITY MANAGEMENT PRIVATE LIMITED",
"ORIENTAL JWELLERY MANUFACTURING PRIVATE LIMITED",
"ORIENTAL KNITFABS PRIVATE LIMITED",
"ORIENTAL METAL WORKS",
"ORIENTAL METALS INDIA PRIVATE LIMITED",
"ORIENTAL MULTIMODAL TRANSPORT PRIVATE LIMITED",
"ORIENTAL NAGPUR BETUL HIGHWAY LIMITED",
"ORIENTAL NAGPUR BYE PASS CONSTRUCTION PRIVATE LIMITED",
"ORIENTAL OUTSOURCING CONSULTANTS PRIVATE LIMITED",
"ORIENTAL PATHWAYS (AGRA) PRIVATE LIMITED",
"ORIENTAL PATHWAYS (INDORE) PRIVATE LIMITED",
"ORIENTAL PATHWAYS (NAGPUR) PRIVATE LIMITED",
"ORIENTAL PERFUMES PRIVATE LIMITED",
"ORIENTAL PHARMACEUTICAL INDUSTRIES LIMITED",
"ORIENTAL PLANTS AND EQUIPMENTS PRIVATE LIMITED",
"ORIENTAL PLASTOWARES PRIVATE LIMITED",
"ORIENTAL PLYBOARD PRIVATE LIMITED",
"ORIENTAL POWER CABLES LTD",
"ORIENTAL POWER ELECTRICALS PRIVATE LIMITED",
"ORIENTAL PRIMARY SCHOOL",
"ORIENTAL PROMOTERS LIMITED",
"ORIENTAL PUBLISHERS AND DISTRIBUTORS PRIVATE LIMITED",
"ORIENTAL QUARRIES AND MINES PRIVATE LIMITED",
"ORIENTAL RADIOS PRIVATE LIMITED",
"ORIENTAL RAIL INFRASTRUCTURE LIMITED",
"ORIENTAL RESIDENCY HOTELS PRIVATE LIMITED",
"ORIENTAL RETAILERS & LOGISTICS PRIVATE LIMITED",
"ORIENTAL RUBBER INDUSTRIES PRIVATE LIMITED",
"ORIENTAL RUBBER TRADING COMPANY (MYSORE) PRIVATE LIMITED",
"ORIENTAL RUGS PRIVATE LIMITED",
"ORIENTAL SALES CORPORATION",
"ORIENTAL SAREE HOUSE PRIVATE LIMITED",
"ORIENTAL SKILLS AND SAFETY SERVICES PVT LTD",
"ORIENTAL SOAP STONE PRIVATE LIMITED",
"ORIENTAL SOLUTIONS PRIVATE LIMITED",
"ORIENTAL SOUTH DELHI HOTELS PRIVATE LIMITED",
"ORIENTAL STRUCTURAL ENGINEERS PRIVATE LIMITED",
"ORIENTAL TECHNOCRAFT PRIVATE LIMITED",
"ORIENTAL TEXTILE PROCESSING CO PVT LTD",
"ORIENTAL TOLLWAYS PRIVATE LIMITED",
"ORIENTAL TRADING CO PRIVATE LIMITED",
"ORIENTAL TREXIM PRIVATE LIMITED",
"ORIENTAL TRIMEX LIMITED",
"ORIENTAL UNIVERSITY",
"ORIENTAL VEHICLES PRIVATE LIMITED",
"ORIENTAL VENEER PRODUCTS LIMITED",
"ORIENTAL VISION ENTERPRISES PRIVATE LIMITED",
"ORIENTAL WEAVING & PROCESSING MILLS PRIVATE LIMITED",
"ORIENTAL YEAST INDIA PRIVATE LIMITED",
"ORIENTALLABS RETAIL SERVICES PRIVATE LIMITED",
"ORIES ELEVATORS & ESCALATORS (INDIA) PRIVATE LIMITED",
"ORIFLAME INDIA PRIVATE LIMITED",
"ORIFOOD AND BEVERAGE PRIVATE LIMITED",
"ORIGAMI CELLULO PRIVATE LIMITED",
"ORIGAMI CREATIVE CONCEPTS PRIVATE LIMITED",
"ORIGAMI DRIPBAG PRIVATE LIMITED",
"ORIGAMI HOSPITALITY PRIVATE LIMITED",
"ORIGAMI MACHINES PRIVATE LIMITED",
"ORIGEN LIFE SCIENCES PRIVATE LIMITED",
"ORIGEN TEST RESEARCH & IMPLEMENTATION BU",
"ORIGENCE EDUCARE",
"ORIGENT TECHNOLOGIES",
"ORIGIN BUILDWELL PRIVATE LIMITED",
"ORIGIN CLOTHING COMPANY INDIA PRIVATE LIMITED",
"ORIGIN COFFEE PRIVATE LIMITED",
"ORIGIN CORPORATE SERVICES PRIVATE LIMITED",
"ORIGIN CORPORATION",
"ORIGIN ENGINEERS PRIVATE LIMITED",
"ORIGIN HANDLOOM PRIVATE LIMITED",
"ORIGIN HR PRIVATE LIMITED",
"ORIGIN INFO MEDIA PRIVATE LIMITED",
"ORIGIN INTERNATIONAL FERTILITY CENTRE PRIVATE LIMITED",
"ORIGIN ITFS PRIVATE LIMITED",
"ORIGIN LOGISTICS PRIVATE LIMITED",
"ORIGIN MARKETING PRIVATE LIMITED",
"ORIGIN MOULDINGS PRIVATE LIMITED",
"ORIGIN MULTIPLEX PRIVATE LIMITED",
"ORIGIN OVERSEAS PRIVATE LIMITED",
"ORIGIN REALTORS LLP",
"ORIGIN RENEWABLES PRIVATE LIMITED",
"ORIGIN SIGNAGE EQUIPMENTS PRIVATE LIMITED",
"ORIGIN TECHSERVE PRIVATE LIMITED",
"ORIGINAL ART GALLERIES PRIVATE LIMITED",
"ORIGINAL HOMOEO MEDICALS PRIVATE LIMITED",
"ORIGINAL LASER PRIVATE LIMITED",
"ORIGINAL TRADING COMPANY PRIVATE LIMITED",
"ORIGINATIVE SOLUTIONS NETWORK PRIVATE LIMITED",
"ORIGINBLUY PRIVATE LIMITED",
"ORIGINE INDIA IMPEX PRIVATE LIMITED",
"ORIGINS ADVERTISING PRIVATE LIMITED",
"ORIGINS BR DIGITALSIGNS PRIVATE LIMITED",
"ORIGINS INVESTMENT CONSULTANTS PRIVATE LIMITED",
"ORIGIO INDIA PRIVATE LIMITED",
"ORIGIUS SYSTEMS PRIVATE LIMITED",
"ORIGO COMMODITIES INDIA PRIVATE LIMITED",
"ORIGO COSMECEUTICALS PRIVATE LIMITED",
"ORIGO FINANCE PRIVATE LIMITED",
"ORIGO MARKETS PRIVATE LIMITED",
"ORIGON CONSULTANTS (INDIA) PRIVATE LIMITED",
"ORIGYN FERTILITY AND IVF PRIVATE LIMITED",
"ORIHEAL LIFESCIENCES PRIVATE LIMITED",
"ORIILON INDIA PRIVATE LIMITED",
"ORIIZZA INTERNATIONAL PRIVATE LIMITED",
"ORIKAM HEALTHCARE INDIA PRIVATE LIMITED",
"ORIKASEE AGRO-TECH AND RESORTS PRIVATE LIMITED",
"ORIKEET ELECTRICALS PRIVATE LIMITED",
"ORIND SPECIAL REFRACTORIES PRIVATE LIMITED",
"ORINOCO SHIP MANAGEMENT PRIVATE LIMITED",
"ORIO SHANGHAI COLOURS PRIVATE LIMITED",
"ORIOLE DR. FRESH HOTELS PRIVATE LIMITED",
"ORIOLES HEALTH INDIA PRIVATE LIMITED",
"ORION ABASAAN PRIVATE LIMITED",
"ORION AGENCIES LIMITED",
"ORION APPAREL TRIMS PRIVATE LIMITED",
"ORION BIOTECH PRIVATE LIMITED",
"ORION BOOK BINDERS PRIVATE LIMITED",
"ORION CHEM PRIVATE LIMITED",
"ORION COMMODITIES SERVICES PRIVATE LIMITED",
"ORION CORPORATE ALLIANCE PRIVATE LIMITED",
"ORION DIGITAL PRIVATE LIMITED",
"ORION DRIVES & MACHINES PRIVATE LIMITED",
"ORION EDUTECH PRIVATE LIMITED",
"ORION ELECTRIK CONTROLS PRIVATE LIMITED",
"ORION ELEVATORS CONTRACTING PRIVATE LIMITED",
"ORION ENTERPRISES PRIVATE LIMITED",
"ORION ESOLUTIONS PRIVATE LIMITED",
"ORION EXPRESS CONTAINER LINES PRIVATE LIMITED",
"ORION FACILITIES & SECURITY SERVICES PRIVATE LIMITED",
"ORION FERRO ALLOYS PRIVATE LTD",
"ORION FLORA PRIVATE LIMITED",
"ORION FURNISHINGS PRIVATE LIMITED",
"ORION GRAPHICS AND PRINTS PRIVATE LIMITED",
"ORION HEALTH FOODS PRIVATE LIMITED",
"ORION HOSIERY PRIVATE LIMITED",
"ORION I.T. PARKS PRIVATE LIMITED",
"ORION INBOUND PRIVATE LIMITED",
"ORION INDIA SYSTEMS PRIVATE LIMITED",
"ORION INFRA CONSULTING PRIVATE LIMITED",
"ORION INFRAREALTORS PRIVATE LIMITED",
"ORION MALL MANAGEMENT COMPANY LIMITED",
"ORION MARITIME PRIVATE LIMITED",
"ORION MARKETING & COMMUNICATIONS PRIVATE LIMITED",
"ORION METAL POWDER PRIVATE LIMITED",
"ORION MOTORS PRIVATE LIMITED",
"ORION MULTISPECIALITY HOSPITAL PRIVATE LIMITED",
"ORION NUTRITIONALS PRIVATE LIMITED",
"ORION OUTSOURCING PRIVATE LIMITED",
"ORION PEST SOLUTIONS PRIVATE LIMITED",
"ORION PR AND DIGITAL PRIVATE LIMITED",
"ORION PRECAST PRIVATE LIMITED",
"ORION PROCESSORS PRIVATE LIMITED",
"ORION REALTY PRIVATE LIMITED",
"ORION SCIENTIFIC SUPPLIERS PRIVATE LIMITED",
"ORION SECURITY SOLUTIONS PRIVATE LIMITED",
"ORION STOCKS LIMITED",
"ORION SUPPLY CHAIN PRIVATE LIMITED",
"ORION TECHNOCRATS PRIVATE LIMITED",
"ORION TEXCORP PRIVATE LIMITED",
"ORION WATER TREATMENT INFRASTRUCTURE PRIVATE LIMITED",
"ORIONCODERS DIGITAL PRIVATE LIMITED",
"ORIONE HYDRAULICS PRIVATE LIMITED",
"ORIONEX FORMULATIONS PRIVATE LIMITED",
"ORIONHOTELS PRIVATE LIMITED",
"ORIONSPICA IT SOLUTIONS PRIVATE LIMITED",
"ORIONVALLEY SOLAR PRIVATE LIMITED",
"ORIRAL PRIVATE LIMITED",
"ORIS PACKAGING PRIVATE LIMITED",
"ORIS TECHNOLOGIES INDIA PRIVATE LIMITED",
"ORISENC TECHNOLOGIES PRIVATE LIMITED",
"ORISMART SERVICES PRIVATE LIMITED",
"ORISON PLASTIC PRIVATE LIMITED",
"ORISSA AGRICO PRIVATE LIMITED",
"ORISSA ALLOY STEEL PRIVATE LIMITED",
"ORISSA ARTISANS AND WEAVERS LIMITED",
"ORISSA BENGAL CARRIER LTD",
"ORISSA BIODIESEL JATROPHA PRIVATE LIMITED",
"ORISSA CHROME EXPORT AND MINING CO LIMITED",
"ORISSA COMPUTERS AND COMMUNICATION PRIVATE LIMITED",
"ORISSA CONCRETE & ALLIED INDUSTRIES LIMITED.",
"ORISSA CONFECTIONERY PVT LTD",
"ORISSA DIESEL ENGINES PRIVATE LIMITED",
"ORISSA ENGINEERING UDYOG PRIVATE LIMITED",
"ORISSA EXIM PRIVATE LIMITED",
"ORISSA FERROTECHS PRIVATE LIMITED",
"ORISSA GEMS PVT. LTD",
"ORISSA INFORMATION TECHNOLOGY PRIVATE LIMITED",
"ORISSA INFRASTRUCTURE PRIVATE LIMITED",
"ORISSA INTEGRATED POWER LIMITED",
"ORISSA LIFT IRRIGATION CORPORATION",
"ORISSA METALIKS PRIVATE LIMITED",
"ORISSA METALLURGICAL INDUSTRY PRIVATE LIMITED",
"ORISSA MOTORS PRIVATE LIMITED",
"ORISSA PLASTO PIPES PVT LTD",
"ORISSA PLY AND HARDWARES PRIVATE LIMITED",
"ORISSA POULTRY PRIVATE LIMITED",
"ORISSA POWER CONSORTIUM LIMITED",
"ORISSA SALES NETWORK (I) PRIVATE LIMITED",
"ORISSA SPONGE IRON AND STEEL LIMITED",
"ORISSA STEEL & POWER PRIVATE LIMITED",
"ORISSA STEEL AND WIRE PRODUCTS PVT.LTD.",
"ORISSA STEELMETALIKS PRIVATE LIMITED",
"ORISSA STEVEDORES LIMITED",
"ORISSA STEVEDORES OVERSEAS PRIVATE LIMITED",
"ORISSA TELEMATICS",
"ORISSA TRADING CORPORATION LIMITED",
"ORISSA TRANSFORMERS PVT LTD",
"ORISSA UNIVERSITY OF AGRICULTURE AND TEC",
"ORISTA INDUSTRIES PRIVATE LIMITED",
"ORISTAR TECHNOLOGIES PRIVATE LIMITED",
"ORITECH SOLUTIONS PRIVATE LIMITED",
"ORITO POLYFAB PRIVATE LIMITED",
"ORITSO PRIVATE LIMITED",
"ORIX AUTO INFRASTRUCTURE SERVICES LIMITED",
"ORIX HI FIDELITY PRIVATE LIMITED",
"ORIX LEASING & FINANCIAL SERVICES INDIA LIMITED",
"ORIX PACKAGING PRIVATE LIMITED",
"ORIYON NATURAL FLAVOURS PRIVATE LIMITED",
"ORIZIN TECHNOLOGIES PRIVATE LIMITED",
"ORIZZONTE INTERIORS PRIVATE LIMITED",
"ORJET INTERMEDIATES PRIVATE LIMITED",
"ORKA CONSULTING SERVICES PRIVATE LIMITED",
"ORKAN ENERGY PRIVATE LIMITED",
"ORKASH SERVICES PRIVATE LIMITED",
"ORKAY CONSTECH INDIA PRIVATE LIMITED",
"ORKEN CERAMIC PRIVATE LIMITED",
"ORKID BAKES AND FOODS PRIVATE LIMITED",
"ORKID MEDILIFE PRIVATE LIMITED",
"ORKIDE EXPORTS AND CONSULTANTS PRIVATE LIMITED",
"ORLAB INSTRUMENTS PRIVATE LIMITED",
"ORLANDO MEDISYSTEMS PRIVATE LIMITED",
"ORLANDO TRADING PRIVATE LIMITED",
"ORLEY LABORATORIES PRIVATE LIMITED",
"ORLOV GREENTECH PRIVATE LIMITED",
"ORLUCK AEROSPACE PRIVATE LIMITED",
"ORM ENGINEERING PRIVATE LIMITED",
"ORMA TIMBERS PRIVATE LIMITED",
"ORMAE LLP",
"ORMAX CONSULTANTS PRIVATE LIMITED",
"ORMAX MEDIA PRIVATE LIMITED",
"ORMEAL FOODS PRIVATE LIMITED",
"ORMED MEDICAL TECHONOLOGY LIMITED",
"ORMIN INFRASTRUCTURE PRIVATE LIMITED",
"ORMS PAVAN INSTRUMENTATIONS PRIVATE. LIMITED",
"ORN TRIP FACTORY PRIVATE LIMITED",
"ORNAMENTATIONS (INDIA) PRIVATE LIMITED",
"ORNATE AGENCIES PRIVATE LIMITED",
"ORNATE COMMUNICATIONS PRIVATE LIMITED",
"ORNATE COMPUTERS PRIVATE LIMITED",
"ORNATE EXIM HOME PRIVATE LIMITED",
"ORNATE GEMS AND JEWELS PRIVATE LIMITED",
"ORNATE INTERIORS INDIA PRIVATE LIMITED",
"ORNATE ISPAT PRIVATE LIMITED",
"ORNATE LABS PRIVATE LIMITED",
"ORNATE LIQUID CHEMICALS & FLOORINGS PRIVATE LIMITED",
"ORNATE MERCANTILE PRIVATE LIMITED",
"ORNATE PHARMA PVT LTD",
"ORNATE PLASTICS PVT LTD",
"ORNATE PRINT-TECH PRIVATE LIMITED",
"ORNATE QUALITY SERVICES PRIVATE LIMITED",
"ORNATE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"ORNATE TECHNOSERVICES PRIVATE LIMITED",
"ORNATE UNIVERSAL DEVELOPERS PRIVATE LIMITED",
"ORNAZ JEWELLERY PRIVATE LIMITED",
"ORNELLAS PRIMARY SCHOOL",
"ORNET INTERMEDIATES PRIVATE LIMITED",
"ORNET TECHNOLOGIES PRIVATE LIMITED",
"ORNET TRANSFORMERS LLP",
"ORNISA PRIVATE LIMITED",
"ORNO COMPUTERS PRIVATE LIMITED",
"ORNO INFRAPROJECTS PRIVATE LIMITED",
"ORO AGRI INDIA PRIVATE LIMITED",
"ORO CONSTRUCTIONS PRIVATE LIMITED",
"ORO DECOR PRIVATE LIMITED",
"ORO PHARMACEUTICALS PRIVATE LIMITED",
"ORO PRECIOUS METALS PRIVATE LIMITED",
"ORO SOFTWARE PRIVATE LIMITED",
"ORO TUFF GLASSES PRIVATE LIMITED",
"OROCAT DIGITAL SOLUTIONS (OPC) PRIVATE LIMITED",
"OROCHEM INDIA PRIVATE LIMITED",
"ORON HEALTHCARE PRIVATE LIMITED",
"OROR FLAVOURS AND CHEMICALS PRIVATE LIMITED",
"OROS FINE JEWELLERY PRIVATE LIMITED",
"OROSOFT SOLUTIONS PRIVATE LIMITED",
"OROTEX CHEMICALS INDIA PRIVATE LIMITED",
"OROVIA SOFTWARE PRIVATE LIMITED",
"ORPAC SYSTEMS PRIVATE LIMITED",
"ORPAK SYSTEMS INDIA PRIVATE LIMITED",
"ORPAT MARKETING PRIVATE LIMITED",
"ORPHIC EMBROIDERY",
"ORPID SMART TECH PRIVATE LIMITED",
"ORRA FINE JEWELLERY PRIVATE LIMITED",
"ORRA REALTORS PRIVATE LIMITED",
"ORRANJE AGRI SCIENCE PRIVATE LIMITED",
"ORRE JEWELZ PRIVATE LIMITED",
"ORRIL BIOMASS GRANULES PRIVATE LIMITED",
"ORRIL ENERGY SERVICES PRIVATE LIMITED",
"ORRIONSTARS INNOVATES PRIVATE LIMITED",
"ORRIS INFO LAB PRIVATE LIMITED",
"ORRIS INFRASTRUCTURE PRIVATE LIMITED",
"ORRIS OVERSEAS PRIVATE LIMITED",
"ORRIS PHARMACEUTICALS PRIVATE LIMITED",
"ORRIS SOLUTIONS PRIVATE LIMITED",
"ORRIX EXIM PRIVATE LIMITED",
"ORRYWORX PRIVATE LIMITED",
"ORSCHELN TECHNOLOGIES PRIVATE LIMITED",
"ORSETT HYDRAULICS PRIVATE LIMITED",
"ORSH ASSOCIATES PRIVATE LIMITED",
"ORSON COTTON & SILK MILLS PRIVATE LIMITED",
"ORSON HOLDINGS COMPANY LIMITED",
"ORSON RESINS AND COATINGS PRIVATE LIMITED",
"ORSON TECHNOCAST PRIVATE LIMITED",
"ORSU NARSIMHA CONSTRUCTIONS PRIVATE LIMITED",
"ORTECH ENGINEERING SERVICES",
"ORTECH TECHNOLOGY PRIVATE LIMITED",
"ORTEM CREDIT PVT.LTD.",
"ORTEM EQUITY PRIVATE LIMITED",
"ORTEM SECURITIES LIMITED",
"ORTEM SUPPLIERS PRIVATE LIMITED",
"ORTHO CLINICAL DIAGNOSTICS INDIA PRIVATE LIMITED",
"ORTHO LIFE SYSTEMS PRIVATE LIMITED",
"ORTHO MAX MANUFACTURING COMPANY PRIVATE LIMITED",
"ORTHO MED HOSPITAL PRIVATE LIMITED",
"ORTHOCURE HEALTHCARE PRIVATE LIMITED",
"ORTHODONTIC SUPPLIES PRIVATE LIMITED",
"ORTHOFIT HEALTHCARE PRIVATE LIMITED",
"ORTHOFORCE TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"ORTHOFX PRIVATE LIMITED",
"ORTHOMED HOSPITAL",
"ORTHONOVA HOSPITAL",
"ORTHONOVA JOINT AND TRAUMA HOSPITAL PRIVATE LIMITED",
"ORTHOSQUARE MULTISPECIALITY DENTAL CLINIC PRIVATE LIMITED",
"ORTHOSURGIMED SOLUTIONS PRIVATE LIMITED",
"ORTHOTECH INDIA PRIVATE LIMITED",
"ORTIN LABORATORIES LIMITED",
"ORTIVA REALTY AND DEVELOPERS PRIVATE LIMITED",
"ORTIV-Q3 RESEARCH PRIVATE LIMITED",
"ORTLER SOLUTIONS PRIVATE LIMITED",
"ORTON CABLES PRIVATE LIMITED",
"ORTON ENGINEERING PRIVATE LIMITED",
"ORTUS AUTOMATION PRIVATE LIMITED",
"ORTUS MARKET RESEARCH PRIVATE LIMITED",
"ORTUS POLYMERS PRIVATE LIMITED",
"ORU INDIA PRIVATE LIMITED",
"ORUM ENTERPRISES PRIVATE LIMITED",
"ORUMA PRINTERS AND PUBLISHERS LIMITED",
"ORUN EXIM PRIVATE LIMITED",
"ORVA NETWORKS PRIVATE LIMITED",
"ORVIN POLYTRADE PRIVATE LIMITED",
"ORVIS PAINTS INDIA PRIVATE LIMITED",
"ORVITO TECHNOLOGIES INDIA PRIVATE LIMITED",
"ORXA ENERGIES PRIVATE LIMITED",
"ORYANA VENTURES PRIVATE LIMITED",
"ORYGGI TECHNOLOGIES PRIVATE LIMITED",
"ORYGIN REMEDIES PRIVATE LIMITED",
"ORYX INTERNATIONAL LOGISTICS PRIVATE LIMITED",
"ORYX SECURITY FORCE PRIVATE LIMITED",
"ORYZA EXIM PRIVATE LIMITED",
"ORZEL MARITIME PRIVATE LIMITED",
"OS AGENCY PRIVATE LIMITED",
"OS FACILITY MANAGEMENT PRIVATE LIMITED",
"OS HRS INDIA PRIVATE LIMITED",
"OS SECURITY INDIA PRIVATE LIMITED",
"OS3 INFOTECH PRIVATE LIMITED",
"OSAAE'Z ACCESSORIZE PRIVATE LIMITED",
"OSAKA ALLOYS AND STEELS PVT LTD",
"OSAKA FURNISHINGS LIMITED",
"OSAKA RUBBER PRIVATE LIMITED",
"OSAKA SECURITY AND HOUSE KEEPING SERVICES PRIVATE LIMITED",
"OSAKA SYNTHETICS PVT LTD",
"OSAKATEK INDIA PRIVATE LIMITED",
"OSAM SPECIALITY CHEMICALS PRIVATE LIMITED",
"OSAW AGRO INDUSTRIES PRIVATE LIMITED",
"OSAW INDUSTRIAL PRODUCTS PRIVATE LIMITED",
"OSB AGENCIES PRIVATE LIMITED",
"OSB INDIA PRIVATE LIMITED",
"OSB OVERSEAS PRIVATE LIMITED",
"OSBORN ENTERPRISES PRIVATE LIMITED",
"OSBORN LIPPERT INDIA PRIVATE LIMITED",
"OSBORN MARKETING PRIVATE LIMITED",
"OSBRO PHARMACEUTICAL PRIVATE LIMITED",
"OSC GLOBAL PROCESSING PRIVATE LIMITED",
"OSC STEEL PRIVATE LIMITED",
"OSCAN ELEVATORS PRIVATE LIMITED",
"OSCAR CERAMICS",
"OSCAR CHEMICALS PVT LTD",
"OSCAR CLUB (MUMBAI) PRIVATE LIMITED",
"OSCAR CROP SCIENCES LLP",
"OSCAR DIAGNOSTIC SERVICES PRIVATE LIMITED",
"OSCAR ELEVATORS PRIVATE LIMITED",
"OSCAR ENCLAVE PVT LTD",
"OSCAR EQUIPMENTS PRIVATE LIMITED",
"OSCAR FREIGHT PRIVATE LIMITED",
"OSCAR FX PRIVATE LIMITED",
"OSCAR INFRA PRIVATE LIMITED",
"OSCAR INTERNATIONAL LIMITED",
"OSCAR MEDIA PRIVATE LIMITED",
"OSCAR MEDICARE PRIVATE LIMITED",
"OSCAR MULTISPECIALITY HOSPITAL",
"OSCAR SHIPPING AND LOGISTICS PRIVATE LIMITED",
"OSCAR SUPER SPECIALITY HOSPITAL AND TRAUMA CENTER PRIVATE LIMITED",
"OSCAR VALVES PRIVATE LIMITED",
"OSCAR WEAR PRIVATE. LIMITED",
"OSCEOLA STAFFING PRIVATE LIMITED",
"OSCILLATE INFOTECH PRIVATE LIMITED",
"OSCON INDUSTRIAL SUPPLIES PRIVATE LIMITED",
"OSCON VAC-TECH PRIVATE LIMITED",
"OSCORP CONSTRUCTION PRIVATE LIMITED",
"OSCORP INDUSTRIES PRIVATE LIMITED",
"OSCORP TECHNOLOGIES PRIVATE LIMITED",
"OSDAV PUBLIC SCHOOL",
"OSE HUNGUND HOSPET HIGHWAYS PRIVATE LIMITED",
"OSE PACKAGING PRIVATE LIMITED",
"OSEL DEVICES PRIVATE LIMITED",
"OSEM INDIA PRIVATE LIMITED",
"OSF COMMERCE INDIA PRIVATE LIMITED",
"OSG AUTO CARRIERS PRIVATE LIMITED",
"OSG INDIA PRIVATE LIMITED",
"OSG LAPAROSCOPY HOSPITAL & DIAGNOSTIC CENTRE PRIVATE LIMITED",
"OSG MINERALS PRIVATE LIMITED",
"OSG ORIANA INDIA PRIVATE LIMITED",
"OSGAN CONSULTANTS PVT LTD",
"OSGOOD TIE-UP PRIVATE LIMITED",
"OSHEEN FARM AND INFRA DEVELOPERS PRIVATE LIMITED",
"OSHEEN LOGISTICA PRIVATE LIMITED",
"OSHI CONSTRUCTION PRIVATE LIMITED",
"OSHIAN LIFECARE PRIVATE LIMITED",
"OSHIAN REALTORS INDIA PRIVATE LIMITED",
"OSHIMA SYSTEMS PRIVATE LIMITED",
"OSHIN ENGINEERING PRIVATE LIMITED",
"OSHINA EXPO PRIVATE LIMITED",
"OSHINO DRUGS PRIVATE LIMITED",
"OSHISH INFRA & SERVICES PRIVATE LIMITED",
"OSHIWARA SYNTHETICS PVT LTD",
"OSHIYA METALS PRIVATE LIMITED",
"OSHKOSH INDIA PRIVATE LIMITED",
"OSHNIC CROP SCIENCE LIMITED",
"OSHO AUTOMATION PRIVATE LIMITED",
"OSHO COATINGS PRIVATE LIMITED",
"OSHO CROP CARE PRIVATE LIMITED",
"OSHO ENGINEERING PRIVATE LIMITED",
"OSHO FORGE LIMITED",
"OSHO GARMENT FINISHERS & LAUNDERERS PRIVATE LIMITED",
"OSHO INDUSTRIES LIMITED",
"OSHO MINERALS INIDA PRIVATE LIMITED",
"OSHO PACKAGING PRIVATE LIMITED",
"OSHO PET FILMS PRIVATE LIMITED",
"OSHO SANITARYWARES PRIVATE LIMITED",
"OSHO TOOLS PRIVATE LIMITED",
"OSHUN FOOD PRODUCTS PRIVATE LIMITED",
"OSHYAN MERCANTILE PRIVATE LIMITED",
"OSI DIGITAL PRIVATE LIMITED",
"OSI ENERGY AUTOMATION INDIA PRIVATE LIMITED",
"OSI STEEL PRIVATE LIMITED",
"OSI SYSTEMS PRIVATE LIMITED",
"OSI TECHNOLOGIES PRIVATE LIMITED",
"OSIA DISTRIBUTORS PRIVATE LIMITED",
"OSIA GEMS PRIVATE LIMITED",
"OSIA HYPER RETAIL LIMITED",
"OSIA INFRASTRUCTURE LIMITED",
"OSIAN INFOTECH PRIVATE LIMITED",
"OSIAN STAINLESS PRIVATE LIMITED",
"OSIAN STAR EXPORTS LLP",
"OSIRIS CONSULTANTS PRIVATE LIMITED",
"OSIRIS DIGITAL MEDIA PRIVATE LIMITED",
"OSIRIS INFOTECH PRIVATE LIMITED",
"OSIRIS SOFTWARE PRIVATE LIMITED",
"OSISOFT INDIA PRIVATE LIMITED",
"OSIYA IMPEX PVT LTD",
"OSIYA PETROCHEM PRIVATE LIMITED",
"OSIYATECH",
"OSIZ TECHNOLOGIES PRIVATE LIMITED",
"OSK INDIA PRIVATE LIMITED",
"OSKAR APPARTMENTS PRIVATE LIMITED",
"OSKI TECHNOLOGY PRIVATE LIMITED",
"OSKO BUILDERS INDIA PRIVATE LIMITED",
"OSL AUTO PRIVATE LIMITED",
"OSL AUTOMOTIVES PRIVATE LIMITED",
"OSL EXCLUSIVE PRIVATE LIMITED",
"OSL LOGISTICS PRIVATE LIMITED",
"OSL LUXURY COLLECTIONS PRIVATE LIMITED",
"OSL MOTOCORP PRIVATE LIMITED",
"OSL MOTORS PRIVATE LIMITED",
"OSL PRESTIGE PRIVATE LIMITED",
"OSL RIPLEY SHIPPING PRIVATE LIMITED",
"OSL SHIPPING AGENCIES INDIA PRIVATE LIMITED",
"OSLABS TECHNOLOGY",
"OSM AVIATION INDIA LLP",
"OSM CAPITAL ADVISORS PRIVATE LIMITED",
"OSM FLEET MANAGEMENT INDIA PRIVATE LIMITED",
"OSM INVESTMENT & TRADING CO LTD",
"OSM PROJECTS PRIVATE LIMITED",
"OSMANABAD JANATA SAHAKARI BANK LTD",
"OSMANIA MEDICAL COLLEGE",
"OSMANIA UNIVERSITY",
"OSMED FORMULATIONS PRIVATE LIMITED",
"OSMGOODS PRIVATE LIMITED",
"OSMIC GLASS (OPC) PRIVATE LIMITED",
"OSMOCHEM INDIA PRIVATE LIMITED",
"OSMOFLO ENGINEERING SERVICES PRIVATE LIMITED",
"OSMOSIS AUTOPUMP INDIA PRIVATE LIMITED",
"OSMOSIS TRADING AND LEASING PRIVATE LIMITED",
"OSMOSYS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"OSMUND CRANES PRIVATE LIMITED",
"OSN BUILDWELL PRIVATE LIMITED",
"OSNA ELECTRONICS PPRIVATE LIMITED",
"OSNAR CHEMICAL PRIVATE LIMITED",
"OSO BATH FITTINGS PRIVATE LIMITED",
"OSO INFRASTRUCTURE PRIVATE LIMITED",
"OSO PETRO PRODUCTS PRIVATE LIMITED",
"OSO SOURCING PRIVATE LIMITED",
"OSON CONSTRUCTION PRIVATE LIMITED",
"OSOURCE GLOBAL PRIVATE LIMITED",
"OSOURCE INDIA PRIAVTE LIMITED",
"OSP LABS PRIVATE LIMITED",
"OSPER FORMULATIONS PRIVATE LIMITED",
"OSPICARE LIFE SCIENCES PRIVATE LIMITED",
"OSPO SPORTS PRIVATE LIMITED",
"OSPREY E-COMMERCE PRIVATE LIMITED",
"OSPREY LOGISTICS PRIVATE LIMITED",
"OSPREY SHIPPING PRIVATE LIMITED",
"OSPROSYS SOFTWARE PRIVATE LIMITED",
"OSPRZET TECHNOLOGIES PRIVATE LIMITED",
"OSPS TELECOMSERVICES PRIVATE LIMITED",
"OSPYN TECHNOLOGIES PRIVATE LIMITED",
"OSR FINANCIAL SERVICES",
"OSR HOTELS PRIVATE LIMITED",
"OSR INTERNATIONAL",
"OSR PRINTS AND ADS PRIVATE LIMITED",
"OSR TELESERVICES PRIVATE LIMITED",
"OSRAM LIGHTING PRIVATE LIMITED",
"OSREN HEALTHCARE PRIVATE LIMITED",
"OSRIK RESOLUTION PRIVATE LIMITED",
"OSRM TECH PACK PRIVATE LIMITED",
"OSRX LOGISTICS PRIVATE LIMITED",
"OSS AVIATION PRIVATE LIMITED",
"OSS CONSTRUCTION PRIVATE LIMITED",
"OSSAAT TECHNOLOGIES PRIVATE LIMITED",
"OSSEOUS HEALTHCARE PRIVATE LIMITED",
"OSSIFY INDUSTRIES PRIVATE LIMITED",
"OSSISKO LIFE SCIENCES PRIVATE LIMITED",
"OSSOM FOODS PRIVATE LIMITED",
"OSSOOR ESTATES LIMITED",
"OSSTEM IMPLANT INDIA PRIVATE LIMITED",
"OSSUR INDIA PRIVATE LIMITED",
"OSSWAL INFOSYSTEM PRIVATE LIMITED",
"OST ELECTRONICS PRIVATE LIMITED",
"OST LABZ PRIVATE LIMITED",
"OST SLOPE PROTECTION ENGINEERING INDIA PRIVATE LIMITED",
"OSTBERG INDIA PRIVATE LIMITED",
"OSTER INDIA PRIVATE LIMITED",
"OSTER KNIT PRIVATE LIMITED",
"OSTERN PRIVATE LIMITED",
"OSTIUM MEDICOMM PRIVATE LIMITED",
"OSTRICH DEVELOPERS PRIVATE LIMITED",
"OSTRICH ELEVATORS PRIVATE LIMITED",
"OSTRICH MOBILITY INSTRUMENTS PRIVATE LIMITED",
"OSTRICH PHARMACEUTICALS PRIVATE LIMITED",
"OSTRO ALPHA WIND PRIVATE LIMITED",
"OSTRO ANANTAPUR PRIVATE LIMITED",
"OSTRO ANDHRA WIND PRIVATE LIMITED",
"OSTRO AP WIND PRIVATE LIMITED",
"OSTRO BHESADA WIND PRIVATE LIMITED",
"OSTRO DAKSHIN POWER PRIVATE LIMITED",
"OSTRO ENERGY PRIVATE LIMITED",
"OSTRO JAISALMER PRIVATE LIMITED",
"OSTRO KANNADA POWER PRIVATE LIMITED",
"OSTRO KUTCH WIND PRIVATE LIMITED",
"OSTRO MADHYA WIND PRIVATE LIMITED",
"OSTRO MAHAWIND POWER PRIVATE LIMITED",
"OSTRO RENEWABLES PRIVATE LIMITED",
"OSTRO URJA WIND PRIVATE LIMITED",
"OSTWAL JEWELS PRIVATE LIMITED",
"OSV SOLUTIONS PRIVATE LIMITED",
"OSWAAL BOOKS AND LEARNING PRIVATE LIMITED",
"OSWAL AAYUSH SUPER SPECIALITY HOSPITAL",
"OSWAL AGRICOMM PRIVATE LIMITED",
"OSWAL AGRO CHEMICAL AND FERTILIZERS PRIVATE LIMITED",
"OSWAL AGRO MILLS LIMITED",
"OSWAL ALLOYS PRIVATE LIMITED",
"OSWAL ARTS PRIVATE LIMITED",
"OSWAL CABLE PRODUCTS",
"OSWAL CABLES PVT LTD",
"OSWAL CALENDER COMPANY PRIVATE LIMITED",
"OSWAL CANCER HOSPITAL",
"OSWAL CASTINGS PRIVATE LIMITED",
"OSWAL CHEM (INDIA) PRIVATE LIMITED",
"OSWAL CO PVT LTD",
"OSWAL COMPUTERS & CONSULTANTS PRIVATE LIMITED",
"OSWAL CROP PROTECTION PRIVATE LIMITED",
"OSWAL DHAN PVT LTD",
"OSWAL DIE CASTERS PRIVATE LIMITED",
"OSWAL DYECHEM PRIVATE LIMITED",
"OSWAL DYEING AND FINISHING MILLS PRIVATE LIMITED",
"OSWAL ELECTRICALS PRIVATE LIMITED",
"OSWAL EXTRUSION LIMITED",
"OSWAL FABRICS",
"OSWAL GLOBAL PRIVATE LIMITED",
"OSWAL HI-TECH PRIVATE LIMITED",
"OSWAL HORTITECH PRIVATE LIMITED",
"OSWAL INDUSTRIAL ENTERPRISE PRIVATE LIMITED",
"OSWAL INDUSTRIES LIMITED",
"OSWAL INFO WORLD PRIVATE LIMITED",
"OSWAL ENERGIES LIMITED",
"OSWAL LUMBERS PVT LTD",
"OSWAL MEGA SALE PRIVATE LIMITED",
"OSWAL MINERALS LIMITED",
"OSWAL MOTELS AND RESORTS LIMITED",
"OSWAL MOTORSALES PRIVATE LIMITED",
"OSWAL OVERSEAS LIMITED",
"OSWAL PAPERS PRIVATE LIMITED",
"OSWAL PIPES AND LIGHTS INDUSTRIES PRIVATE LIMITED",
"OSWAL POLY CHEM PRIVATE LIMITED",
"OSWAL POLYPACK INDIA LIMITED",
"OSWAL POLYPLAST PRIVATE LIMITED",
"OSWAL PREMIUM SILK MILLS LIMITED",
"OSWAL PRINTERS AND PUBLISHERS PRIVATE LTD.",
"OSWAL PRINTS PRIVATE LIMITED",
"OSWAL PROMOTERS PRIVATE LIMITED",
"OSWAL PROPERTIES PRIVATE LIMITED",
"OSWAL PUMPS LIMITED",
"OSWAL RUBBERS PVT LTD",
"OSWAL SHARES AND SECURITIES LIMITED",
"OSWAL SMELTERS PRIVATE LIMITED",
"OSWAL SYNTHETICS PRIVATE LIMITED",
"OSWAL THREAD PVT LTD",
"OSWAL TRADE LINKS PVT LTD",
"OSWAL TRADERS AND TRAVELS PRIVATE LIMITED",
"OSWAL TRANSFORMERS PRIVATE LIMITED",
"OSWAL WOOLLEN MILLS LIMITED",
"OSWIN PLASTICS PVT LTD",
"OSWIN WOOD PANELS PRIVATE LIMITED",
"OSWORLD SCIENTIFIC EQUIPMENTS PRIVATE LIMITED",
"OSX TECHLABS PRIVATE LIMITED",
"OSYAN TRADING ENTERPRISE PRIVATE LIMITED",
"OT PARK PRIVATE LIMITED",
"OT SERVICES INDIA PRIVATE LIMITED",
"OTA KANDLA PRIVATE LIMITED",
"OTABU GLOBAL SERVICES PRIVATE LIMITED",
"OTABU HEALTHCARE LIMITED",
"OTBT INFOTECH PRIVATE LIMITED",
"OTC GLOBAL LIMITED",
"OTC SPICES PRIVATE LIMITED",
"OTCO INTERNATIONAL LIMITED",
"OTCS PRIVATE LIMITED",
"OTECH SOFT SOLUTION PRIVATE LIMITED",
"OTG TECHNOLOGIES PRIVATE LIMITED",
"OTH ONLINE PRIVATE LIMITED",
"OTHAIN SOFTWARE SERVICES INDIA PRIVATE LIMITED",
"OTHELLO FAUCETS PRIVATE LIMITED",
"OTHELLO PROJECTS PRIVATE LIMITED",
"OTHER OFFICE UNDER CORPORATION BHILAI",
"OTHER OFFICE UNDER CORPORATION BHILAI ZONE-03",
"OTHREE AGRO PRODUCER COMPANY LIMITED",
"OTIC HEARING SOLUTIONS PRIVATE LIMITED",
"OTIC PARTICION INDIA PRIVATE LIMITED",
"OTIS ELEVATOR CO INDIALTD",
"OTIS GLOBAL SERVICES CENTER PRIVATE LIMITED",
"OTL INFRA PRIVATE LIMITED",
"OTL TECHNOLOGY AND SOLUTIONS PRIVATE LIMITED",
"OTM LABS INDIA PRIVATE LIMITED",
"OTO MOTIVE PRODUCTS (INDIA) PRIVATE LIMITED",
"OTOKLIN GLOBAL BUSINESS LIMITED",
"OTOMEYTWORLD LLP",
"OTR & INDUSTRIAL TYRE SERVICES INDIA PRIVATE LIMITED",
"OTR LAMINATED TYRES INDIA PRIVATE LIMITED",
"OTR PAPERS PVT. LTD.",
"OTRAC INTERNATIONAL TRADING PRIVATE LIMITED",
"OTS ADVERTISING PVT LTD",
"OTS CONSULTING SERVICES LLP",
"OTS INFRASTRUCTURES PRIVATE LIMITED",
"OTS LTD",
"OTS OFFICETECH SYSTEMS PRIVATE LIMITED",
"OTSUKA CHEMICAL INDIA PRIVATE LIMITED",
"OTSUKA PHARMACEUTICAL INDIA PRIVATE LIMITED",
"OTSUKA VENUS AUTOMOTIVE INDIA PRIVATE LIMITED",
"OTSUSA INDIA PRIVATE LIMITED",
"OTT LOGISTICS INDIA PRIVATE LIMITED",
"OTT SCIENTIFIC INDIA PRIVATE LIMITED",
"OTT TRAVELS PRIVATE LIMITED",
"OTTAPATH PROJECTS AND DEVELOPERS PRIVATE LIMITED",
"OTTER CONTROLS INDIA PRIVATE LIMITED",
"OTTILA INTERNATIONAL PRIVATE LIMITED",
"OTTO AGN INTERNATIONAL LIMITED",
"OTTO BILZ INDIA PRIVATE LIMITED",
"OTTO BOCK HEALTHCARE INDIA PRIVATE LIMITED",
"OTTO CLOTHING PRIVATE LIMITED",
"OTTO HOFSTETTER INDIA PRIVATE LIMITED",
"OTTO WASTE SYSTEMS (INDIA) PRIVATE LIMITED",
"OTTOMAN TUBES PRIVATE LIMITED",
"OTTOMATE INTERNATIONAL PRIVATE LIMITED",
"OTTONOMY IO PRIVATE LIMITED",
"OTTY COTFAB PRIVATE LIMITED",
"OTV ENGINEERING CENTER INDIA PRIVATE LIMITED",
"OUDWOOD CLINIC PRIVATE LIMITED",
"OUM ELECMECH PRIVATE LIMITED",
"OUM LAMITECH PRIVATE LIMITED",
"OUM TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"OUM TRANSMUTE PRIVATE LIMITED",
"OUMKARA MEDTECK (PRIVATE) LIMITED",
"OUR COMP SOLUTIONS PRIVATE LIMITED",
"OUR LADY OF FATIMA CONVENT SCHOOL",
"OUR LADY OF FATIMA SENIOR SECONDARY SCHOOL ALIGARH",
"OUR LADY OF GRACE HIGH SCHOOL",
"OUR LADY OF HEALH HIGH SCHOOL",
"OUR LADY OF HEALTH HOSPITAL",
"OUR LADY OF HEALTH MATRIC HR SEC SCHOOL",
"OUR LADY OF HELP ENGLISH SCHOOL",
"OURBUS INDIA PRIVATE LIMITED",
"OURDREAMS NETMART PRIVATE LIMITED",
"OURLAND ENGINEERING WORKS PRIVATE LIMITED",
"OURSPACE SOLUTIONS PRIVATE LIMITED",
"OUST LABS INDIA PRIVATE LIMITED",
"OUSTFIRE SAFETY ENGINEERS PRIVATE LIMITED",
"OUT N OUT INFOTECH (INDIA) LLP",
"OUT THINKING ELECTRONICS PRIVATE LIMITED",
"OUT THINKING PRIVATE LIMITED",
"OUTBOOKS OUTSOURCING PRIVATE LIMITED",
"OUTBRAIN INDIA PRIVATE LIMITED",
"OUTCARE MEDICAL DEVICES PRIVATE LIMITED",
"OUTCOME COMMERCIAL PRIVATE LIMITED",
"OUTCOMES OPERATING INDIA PRIVATE LIMITED",
"OUTCUE MEDIA PRIVATE LIMITED",
"OUTDO ONLINE PRIVATE LIMITED",
"OUTDOOR CAFE ADVERTISING PRIVATE LIMITED",
"OUTDOOR CATALYST MEDIA SERVICES PRIVATE LIMITED",
"OUTDOOR COMMUNICATIONS PRIVATE LIMITED",
"OUTDOOR EDGE SOLUTIONS PRIVATE LIMITED",
"OUTDOOR MANTRA PRIVATE LIMITED",
"OUTDU MEDIATECH PRIVATE LIMITED",
"OUTFORCE SERVICES PRIVATE LIMITED",
"OUTFOX ADVISORS PRIVATE LIMITED",
"OUTINORD FORMWORKS PRIVATE LIMITED",
"OUTLETWISE RETAIL PRIVATE LIMITED",
"OUTLINE BUSINESS COMMUNICATIONS",
"OUTLINE DESIGN N INTERIORS INDIA PRIVATE LIMITED",
"OUTLINE INDIA RESEARCH PRIVATE LIMITED",
"OUTLINE INFRACON PRIVATE LIMITED",
"OUTLINE SYSTEMS INDIA PRIVATE LIMITED",
"OUTLINE TRADE TECH (I) (OPC) PRIVATE LIMITED",
"OUTLOOK COMMUNICATIONS PRIVATE LIMITED",
"OUTLOOK DESIGNERS PRIVATE LIMITED",
"OUTLOOK ENGINEERS PRIVATE LIMITED",
"OUTLOOK GEMS AND JEWELLERY PRIVATE LIMITED",
"OUTLOOK INTERNATIONAL (INDIA) PRIVATE LIMITED",
"OUTLOOK PROMOTERS PRIVATE LIMITED",
"OUTLOOK TEXTILES PRIVATE LIMITED",
"OUTMATCH PRIVATE LIMITED",
"OUTOKUMPU INDIA PRIVATE LIMITED",
"OUTOTEC INDIA PRIVATE LIMITED",
"OUTPACE CONSULTING SERVICES PRIVATE LIMITED",
"OUTPACE FURNITURES PRIVATE LIMITED",
"OUTPOST VISUAL EFFECTS PRIVATE LIMITED",
"OUTREACH ADVERTISING PRIVATE LIMITED",
"OUTREACH INTEGRATED SERVICES PRIVATE LIMITED",
"OUTRIGHT SOLUTIONS PRIVATE LIMITED",
"OUTRIX WAVE INFOTECH PRIVATE LIMITED",
"OUT-SEL PROMOTIONS INDIA PRIVATE LIMITED",
"OUTSHINY INDIA PRIVATE LIMITED",
"OUTSIZED INDIA PRIVATE LIMITED",
"OUTSOURCE INFOTECH SERVICES PRIVATE LIMITED",
"OUTSOURCEACE IT AND ITES SOLUTIONS PRIVATE LIMITED",
"OUTSOURCED CONSULTING AND SOLUTIONS PRIVATE LIMITED",
"OUTSOURCED SOLUTIONS PRIVATE LIMITED",
"OUTSOURCEPARTNERS INTERNATIONAL PRIVATE LIMITED",
"OUTSTRIP INFOTECH PRIVATE LIMITED",
"OUTSTRIVE SOLUTIONS PRIVATE LIMITED",
"OUTWORKS SOLUTIONS PRIVATE LIMITED",
"OV TECHNOLOGY SERVICES PRIVATE LIMITED",
"OVAC SWITCHGEAR SERVICES PRIVATE LIMITED",
"OVAL AGROTECH PRIVATE LIMITED",
"OVAL HARVEST PRIVATE LIMITED",
"OVAL HEALTHCARE PRIVATE LIMITED",
"OVAL IMPEX PRIVATE LIMITED",
"OVAL POULTRY INDUSTRIES PRIVATE LIMITED",
"OVAL PROJECTS ENGINEERING PRIVATE LIMITED",
"OVAL SECURITIES PRIVATE LIMITED",
"OVALEDGE INDIA PRIVATE LIMITED",
"OVALELABS PRIVATE LIMITED",
"OVARON INFRASTRUCTURE PRIVATE LIMITED",
"OVATION SERVICES PRIVATE LIMITED",
"OVEARTH PRIVATE LIMITED",
"OVEE CRANES & PEB INDUSTRIES PRIVATE LIMITED",
"OVEL IMPEX PRIVATE LIMITED",
"OVER THE TOP RESTAURANTS PRIVATE LIMITED",
"OVERALL VENTURES PRIVATE LIMITED",
"OVERBROOK TECHNOLOGY SERVICES PRIVATE LIMITED",
"OVERDRIVE ELECTRONICS PRIVATE LIMITED",
"OVERLEAP ENERGY PRIVATE LIMITED",
"OVERLEAP NETWORKS PRIVATE LIMITED",
"OVERNIGHT LOGISTICS INDIA PRIVATE LIMITED",
"OVERSEAS AGRO PRODUCT PRIVATE LIMITED",
"OVERSEAS BEAUTY ART FURNITURE EXPORTS PRIVATE LIMITED",
"OVERSEAS BEVERAGES PRIVATE LIMITED",
"OVERSEAS CARPETS LIMITED.",
"OVERSEAS CASTINGS PRIVATE LIMITED",
"OVERSEAS CORPN PVT LTD",
"OVERSEAS COURIER SERVICE (INDIA) PRIVATE LIMITED",
"OVERSEAS DEVELOPMENT AND EMPLOYMENT PROMOTION CONSULTANTS LTD",
"OVERSEAS EDUCATION AND CAREER CONSULTANTS INDIA PRIVATE LIMITED",
"OVERSEAS GALLERY PRIVATE LIMITED",
"OVERSEAS HEALTH CARE PRIVATE LIMITED",
"OVERSEAS INFRASTRUCTURE ALLIANCE INDIA PRIVATE LIMITED",
"OVERSEAS IRON FOUNDRY PVT LTD",
"OVERSEAS KERALITES INVESTMENT AND HOLDING LIMITED",
"OVERSEAS LOGISTICS PRIVATE LIMITED",
"OVERSEAS MANPOWER CORPORATION LIMITED",
"OVERSEAS MARITIME AGENCIES PRIVATE LIMITED",
"OVERSEAS MERCANDISE INSPECTION CO INDIA PVT LTD",
"OVERSEAS PACKAGING INDUSTRIES PRIVATE LIMITED",
"OVERSEAS PLASTIC MOULDERS INDIA LIMITED",
"OVERSEAS PLASTIC MOULDERS INDIA PRIVATE LIMITED",
"OVERSEAS POLYMERS PRIVATE LIMITED",
"OVERSEAS SADDLERY PRIVATE LIMITED",
"OVERSEAS UNION BANK BERHAD",
"OVERSEAS WAREHOUSING PRIVATE LIMITED",
"OVERSTOCK RETAIL VENTURES PRIVATE LIMITED",
"OVERTONE AUDIO PRIVATE LIMITED",
"OVERTONE BUSINESS SOLUTIONS PRIVATE LIMITED",
"OVERTOP INFOTECH PRIVATE LIMITED",
"OVERTURE NETWORKS INDIA PRIVATE LIMITED",
"OVERTURE REDE PRIVATE LIMITED",
"OVHAL TRADING COMPANY PRIVATE LIMITED",
"OVHTECH R&D INDIA PRIVATE LIMITED",
"OVI ENGINEERS PRIVATE LIMITED",
"OVI HOSTING PRIVATE LIMITED",
"OVI INDUSTRIES PRIVATE LIMITED",
"OVIANI PHARMA CHEM PRIVATE LIMITED",
"OVILITE PRIVATE LIMITED",
"OVIN TECHNOLOGIES PRIVATE LIMITED",
"OVINGTON FINANCE PRIVATE LIMITED",
"OVINOX INDUSTRIES INDIA PRIVATE LIMITED",
"OVION LIFESTYLE PRIVATE LIMITED",
"OVIS EQUIPMENTS PRIVATE LIMITED",
"OVITTAL TECHNOLOGIES",
"OVIVO INDIA PRIVATE LIMITED",
"OVIYA MEDSAFE PRIVATE LIMITED",
"OVM ENG-TECH INDIA PRIVATE LIMITED",
"OVN INDUSTRIES PRIVATE LIMITED",
"OVN TRADING ENGINEERS PRIVATE LIMITED",
"OVO FARM PRIVATE LIMITED",
"OVO LAYER FARMS PRIVATE LIMITED",
"OVOCOM SOFTWARE PRIVATE LIMITED",
"OVOL FIBRE SOLUTION INDIA PRIVATE LIMITED",
"OVOS ELECTRONICS PRIVATE LIMITED",
"OVS INDIA SOURCING PRIVATE LIMITED",
"OVT INDIA PRIVATE LIMITED",
"OVUM WOMEN & CHILD SPECIALITY HOSPITAL",
"OW DATALEADS PRIVATE LIMITED",
"OW LOGISTICS PRIVATE LIMITED",
"OW SPORTS MANAGEMENT PRIVATE LIMITED",
"OWA INFOTECH PRIVATE LIMITED",
"OWAIS ENTERPRISES PRIVATE LIMITED",
"OWAISI HOSPITAL& REASERCH CENTRE",
"OWARI PRECISION PRODUCTS INDIA PRIVATE LIMITED",
"OWASI JR COLLEGE",
"OWEN MEDIA INDIA PRIVATE LIMITED",
"OWENS ASIA PRIVATE LIMITED",
"OWENS CORNING",
"OWENS-CORNING INDIA PRIVATE LIMITED",
"OWIT SERVICES INDIA PRIVATE LIMITED",
"OWL HANDICRAFT AND STONE PRIVATE LIMITED",
"OWLER INDIA PRIVATE LIMITED",
"OWLSPRIORITY INDIA PRIVATE LIMITED",
"OWN INFRACON PRIVATE LIMITED",
"OWN NETWORK PRIVATE LIMITED",
"OWNBACKUP INDIA PRIVATE LIMITED",
"OWO TECHNOLOGIES PRIVATE LIMITED",
"OXAIR PRESSURE VESSEL MANUFACTURING PRIVATE LIMITED",
"OXALER HOME APPLIANCES PRIVATE LIMITED",
"OXALIS PROPERTIES PRIVATE LIMITED",
"OXALIS SPECIALITY CHEMICALS & SERVICES PRIVATE LIMITED",
"OXANE PARTNERS INDIA PRIVATE LIMITED",
"OXAVIA SYSTEMS PRIVATE LIMITED",
"OXBRIDGE SCHOOL",
"OXBUILT INFRATECH PRIVATE LIMITED",
"OXEMBERG FASHION LIMITED",
"OXERA PRECISION TECH PRIVATE LIMITED",
"OXFAM INDIA",
"OXFEN ARCADE PRIVATE LIMITED",
"OXFORD CHEMICALS PRIVATE LIMITED",
"OXFORD ENGINEERING COLLEGE",
"OXFORD ENGLISH MEDIUM SCHOOL",
"OXFORD EXPRESS PRIVATE LIMITED",
"OXFORD FINVEST LTD",
"OXFORD GLOBAL PROPERTIES PRIVATE LIMITED UNDER PART IX",
"OXFORD GOLF & RESORTS PRIVATE LIMITED",
"OXFORD HOSPITAL PRIVATE LIMITED",
"OXFORD INTERNATIONAL EDUCATION GROUP",
"OXFORD INTERNATIONAL SCHOOL",
"OXFORD LABORATORIES PRIVATE LIMITED",
"OXFORD LIFESCIENCES PRIVATE LIMITED",
"OXFORD PAPER PRODUCTS PVT LTD",
"OXFORD PLAST INDIA PRIVATE LIMITED",
"OXFORD POLICY MANAGEMENT INDIA PRIVATE LIMITED",
"OXFORD REALTORS ( INDIA ) PRIVATE LIMITED",
"OXFORD RUBBERS PRIVATE LIMITED",
"OXFORD SHELTERS PRIVATE LIMITED",
"OXFORD SR SECONDARY SCHOOL",
"OXFORD UNIVERSITY PRESS INDIA PRIVATE LIMITED",
"OXIDE (INDIA) PRIVATE LTD",
"OXIGEN ONLINE SERVICES INDIA PRIVATE LIMITED",
"OXIGENO INTERNATIONAL BIZ PRIVATE LIMITED",
"OXILITE TECHNO INDUSTRIES PRIVATE LIMITED",
"OXILON PRIVATE LIMITED",
"OXIMOBI MEDIA PRIVATE LIMITED",
"OXIMUS REMEDIES PRIVATE LIMITED",
"OXINA CARS PRIVATE LIMITED",
"OXINO PEB PRIVATE LIMITED",
"OXIRA ENVIRONMENTAL SOLUTION PRIVATE LIMITED",
"OXIRICH CONSTRUCTION PRIVATE LIMITED",
"OXIRICH DEVELOPERS AND PROMOTORS PRIVATE LIMITED",
"OXIRICH LIFESTYLE HOMES PRIVATE LIMITED",
"OXIRICH REALTORS PRIVATE LIMITED",
"OXLAND LOGISTICS PRIVATE LIMITED",
"OXO CONSULTANTS PRIVATE LIMITED",
"OXONE INFRATECH PRIVATE LIMITED",
"OXONIYA BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"OXOR ELECTRICALS PRIVATE LIMITED",
"OXPER MARTECH (OPC) PRIVATE LIMITED",
"OXPRO PHARMA PRIVATE LIMITED",
"OXROCK INDIA PRIVATE LIMITED",
"OXSTREN WEARABLE TECHNOLOGIES PRIVATE LIMITED",
"OXY GLOW COSMETICS PRIVATE LIMITED",
"OXY HOMEZ PROMOTERS PRIVATE LIMITED",
"OXY TRADERS",
"OXYBEE SOLUTIONS PRIVATE LIMITED",
"OXYDE CHEMICALS AND POLYMERS INDIA PRIVATE LIMITED",
"OXYEASE HEALTHCARE SERVICES PRIVATE LIMITED",
"OXYFLOW CONTROLS PRIVATE LIMITED",
"OXYGEN BUSINESS PARK PRIVATE LIMITED",
"OXYGEN ENTERTAINMENT & MEDIA SOLUTIONS PRIVATE LIMITED",
"OXYGEN FASHIONS PRIVATE LIMITED",
"OXYGEN MEDICARE CANCER CARE PRIVATE LIMITED",
"OXYGEN NETWORKS PRIVATE LIMITED",
"OXYGEN PHARMA CARE PRIVATE LIMITED",
"OXYGEN PLASTICARE PRIVATE LIMITED",
"OXYGEN PROTECH PRIVATE LIMITED",
"OXYGENTA SERVICES PRIVATE LIMITED",
"OXYGENX INDUSTRIES PRIVATE LIMITED",
"OXYGROW AGRO TECH PRIVATE LIMITED",
"OXYLINK HEALTHCARE PRIVATE LIMITED",
"OXYM CRAFTS PRIVATE LIMITED",
"OXYMED HOSPITAL AND RESEARCH INSTITUTE PRIVATE LIMITED",
"OXYMED HOSPITALS",
"OXYPC COMPUTERS PRIVATE LIMITED",
"OXYPLANTS INDIA PRIVATE LIMITED",
"OXYRICH VENTURES PRIVATE LIMITED",
"OXYTO GLOBAL SOLUTIONS LLP",
"OXYZENFIN PRIVATE LIMITED",
"OXYZO FINANCIAL SERVICES LIMITED",
"OXYZO FINANCIAL SERVICES PRIVATE LIMITED",
"OXYZONE HOSPITAL PRIVATE LIMITED",
"OYE FINTECH PRIVATE LIMITED",
"OYE MESSENGER LIMITED",
"OYEDESI PRIVATE LIMITED",
"OYEPAISA CONSULTING PRIVATE LIMITED",
"OYESTER TRADING COMPANY PRIVATE LIMITED",
"OYNX HOME DEVELOPERS PRIVATE LIMITED",
"OYNX MANAGEMENT SERVICES PRIVATE LIMITED",
"OYO APARTMENT INVESTMENTS LLP",
"OYO CERAMIC PRIVATE LIMITED",
"OYO WORKSPACES INDIA PRIVATE LIMITED",
"OYSTER AND PEARL HOSPITALS PRIVATE LIMITED",
"OYSTER BATH CONCEPTS PRIVATE LIMITED",
"OYSTER BUILDING INDIA PRIVATE LIMITED",
"OYSTER EXIM PRIVATE LIMITED",
"OYSTER FRESH MILK PRIVATE LIMITED",
"OYSTER INDUSTRIES PRIVATE LIMITED",
"OYSTER INFRASTRUCTURE PRIVATE LIMITED",
"OYSTER MARITIME (INDIA) PRIVATE LIMITED",
"OYSTER MURAL PRIVATE LIMITED",
"OYSTER PRINTERS AND PUBLISHERS PRIVATE LIMITED",
"OYSTER WORLD TOUR & TRAVEL PRIVATE LIMITED",
"OYSTERS ADVERTISING PRIVATE LIMITED",
"OYSTRA CONCEPTS PRIVATE LIMITED",
"OYZEL LUBES PRIVATE LIMITED",
"OZ INFOTECH PRIVATE LIMITED",
"OZA PIPING SYSTEM PRIVATE LIMITED",
"OZAR AGRO & INFRA PRIVATE LIMITED",
"OZARK ENGINEERING PRIVATE LIMITED",
"OZAT FARMERS PRODUCER COMPANY LIMITED",
"OZDOCS INDIA PRIVATE LIMITED",
"OZEAN MARINE EXPORTS PRIVATE LIMITED",
"OZELL COONER PAINTS",
"OZEN REALTORS INDIA PRIVATE LIMITED",
"OZIEL PHARMACEUTICALS PRIVATE LIMITED",
"OZLA PLASTOCRAFT PRIVATE LIMITED",
"OZO ENERGY PRIVATE LIMITED",
"OZO PESTICIDE INDIA PRIVATE LIMITED",
"OZOLIN GEOTECH PRIVATE LIMITED",
"OZONE BIOSECURITY AND NUTRITIONAL SERVICES PRIVATE LIMITED",
"OZONE BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"OZONE DEVCON PRIVATE LIMITED",
"OZONE DIAGNOSTIC PRIVATE LIMITED",
"OZONE DIAMONDS PRIVATE LIMITED",
"OZONE ELECTRONICS PRIVATE LIMITED",
"OZONE GRANITES PRIVATE LIMITED",
"OZONE HOMES PRIVATE LIMITED",
"OZONE HOSPITALS",
"OZONE INDIA LIMITED",
"OZONE INDUSTRIES PRIVATE LIMITED",
"OZONE INFO-ENGINEERING PRIVATE LIMITED",
"OZONE INFRA CON PRIVATE LIMITED",
"OZONE INFRA DEVELOPERS PRIVATE LIMITED",
"OZONE INFRA PROJECTS",
"OZONE INSTITUTE OF MEDICAL SCIENCES PRIVATE LIMITED",
"OZONE LIFESTYLE PROJECTS PRIVATE LIMITED",
"OZONE LOGISTICS PRIVATE LIMITED",
"OZONE LYF PRIVATE LIMITED",
"OZONE OVERSEAS PRIVATE LIMITED",
"OZONE PB SPINTEX LIMITED",
"OZONE PHARMACEUTICALS LIMITED",
"OZONE POLYFORM PRIVATE LIMITED",
"OZONE PROCON PRIVATE LIMITED",
"OZONE PROJECTS PRIVATE LIMITED",
"OZONE PROPERTIES PRIVATE LIMITED",
"OZONE PROPEX PRIVATE LIMITED",
"OZONE REALTORS PRIVATE LIMITED",
"OZONE RESEARCH AND APPLICATIONS (INDIA) PRIVATE LIMITED",
"OZONE SECUTECH PRIVATE LIMITED",
"OZONE SPA PRIVATE LIMITED",
"OZONE TECHNOLOGIES AND SYSTEMS (INDIA) PRIVATE LIMITED",
"OZONE TEXTILE PRIVATE LIMITED",
"OZONE TUSCANY PRIVATE LIMITED",
"OZONELAND PRIVATE LIMITED",
"OZONETEK LIMITED",
"OZONETEL COMMUNICATIONS PRIVATE LIMITED",
"OZOTEC AUTOMOBILE PRIVATE LIMITED",
"OZPEC CHEMICAL INDUSTRIAL PRIVATE LIMITED",
"OZRAN HEIGHTS BEACH RESORT PRIVATE LIMITED",
"OZTEK SOFTWARE P LIMITED",
"OZVID TECHNOLOGIES PRIVATE LIMITED",
"P & A FASHIONS PRIVATE LIMITED",
"P & B MANUFACTURING PRIVATE LIMITED",
"P & C ANIMAL HEALTH LLP",
"P & M INFRASTRUCTURES LIMTED",
"P & N BUSINESS VENTURES PRIVATE LIMITED",
"P & R GOGRIPUR HYDRO POWER PRIVATE LIMITED",
"P & R GURDITTIWALA HYDRO POWER PRIVATE LIMITED",
"P & R INFRAPROJECTS LIMITED",
"P & SONS EXPORT PRIVATE LIMITED",
"P 2 POWER SOLUTIONS PRIVATE LIMITED",
"P A AZIZ COLLEGE OF ENGINEERING & TECHNO",
"P A COLLEGE OF PHARMACY",
"P A FOOTWEAR PRIVATE LIMITED",
"P A HOSPITAL",
"P A PROJECTS PRIVATE LIMITED",
"P A R K INDUSTRIES PRIVATE LIMITED",
"P A R K NON-WOVEN PRIVATE LIMITED",
"P A R Y DEVELOPERS PRIVATE LIMITED",
"P A S COTTON MILLS PRIVATE LIMITED",
"P AND A ADVERTISING AGENCY PRIVATE LIMITED",
"P AND A VALUETECH PRIVATE LIMITED",
"P AND G ENTERPRISES PRIVATE LIMITED",
"P AND K PLINTH PRIVATE LIMITED",
"P AND P BRAKES AND CLUTCHES PRIVATE LIMITED",
"P AND P PHARMACETICAL",
"P AND R ENGINEERING SERVICES PRIVATE LIMITED",
"P B COPPERS PRIVATE LIMITED",
"P B ENTERPRISES",
"P B I INDIA PRIVATE LIMITED",
"P B L TRANSPORT CORPORATION PRIVATE LIMITED",
"P B NIRMAN UDYOG PVT LTD",
"P B S FOODS (SUGAR) PRIVATE LIMITED",
"P B SHAH TILE BATH KITCHEN PRIVATE LIMITED",
"P B TECH IMPACT SOLUTIONS PRIVATE LIMITED",
"P BAPUJI SALUNKHE VIDHYALAY ASAWALI",
"P BHOGILAL PVT LTD",
"P C BANGUR MINERALS LIMITED",
"P C CHANDRA & SONS (INDIA) PRIVATE LIMITED",
"P C CHANDRA (GEMS) PRIVATE LIMITED",
"P C CHANDRA (JEWELLERS) PRIVATE LIMITED",
"P C CHANDRA EXPORTS PVT LTD",
"P C CHANDRA HOLDINGS PRIVATE LIMITED",
"P C CHANDRA JEWELLERY APEX PRIVATE LIMITED",
"P C CHANDRAS FINANCIAL SERVICES PVT LTD",
"P C DEVELOPERS SERVICES PVT LTD",
"P C GHADIALI AND CO LLP",
"P C JAIN TEXTILE PRIVATE LIMITED",
"P C OF A FYS KOLKATA",
"P C P CARRIERS AND AGENCIES PVT LTD",
"P C PATEL INFRA PRIVATE LIMITED",
"P C PATRA AND SONS RETAIL PRIVATE LIMITED",
"P C R. WARE HOUSING LIMITED",
"P C S COMMODITIES PRIVATE LIMITED",
"P C S FINTEC CONSULTANCY PRIVATE LIMITED",
"P CUBE EQUIPMENTS PRIVATE LIMITED",
"P CUBE INDUSTRIAL ENTERPRISES PRIVATE LIMITED",
"P CUBE IT SERVICES PRIVATE LIMITED",
"P D AGRAWAL INFRASTRUCTURE LIMITED",
"P D ARYA AND CO. PRIVATE LIMITED",
"P D E A S INSTITUTE OF TECHNOLOGY",
"P D FORGE PRIVATE LIMITED",
"P D GUPTA MEDISCAN CENTRE PRIVATE LIMITED",
"P D HINDUJA HOSPITAL & MEDICAL RESEARCH CENTRE",
"P D HINDUJA K G CLASESS",
"P D HINDUJA NATIONAL HOSPITAL",
"P D INFRAPROJECT PRIVATE LIMITED",
"P D K IMPEX PRIVATE LIMITED",
"P D METAL CRAFT PRIVATE LIMITED",
"P D NAVKAR BIO CHEM PRIVATE LIMITED",
"P D P STEELS LTD",
"P D POLYCHEM PRIVATE LIMITED",
"P D PRASAD AND SONS PVT.LTD.",
"P D RANGDALE VIDYALAYA AND JUNIOR COLLEGE GOREGAON",
"P D RATHI CHEMICALS PRIVATE LIMITED",
"P D S HOSPITAL PRIVATE LIMITED",
"P D S LOGISTICS INTERNATIONAL PRIVATE LIMITED",
"P D SCIENTIFIC INDUSTRIES PRIVATE LIMITED",
"P D SEKHSARIA TRADING COMPANY PRIVATE LIMITED",
"P D U GOVT MEDICAL COLLEGE RAJKOT",
"P DAS INFRASTRUCTURE",
"P DASS FORGING PRIVATE LIMITED",
"P E ANALYTICS LIMITED",
"P E ENGINEERS PVT LTD",
"P E S GIRLS HIGH SCHOOL",
"P E S GROUP OF INSTITUTIONS",
"P F P SERVICES PRIVATE LIMITED",
"P G COLLEGE OF COMMERCE MANAGEMENT STU",
"P G FOILS LIMITED",
"P G GARODIA SCHOOL",
"P G ICE AND COLD STORAGE PRIVATE LIMITED",
"P G INFRAWORLD PRIVATE LIMITED",
"P G INSTITUTE OF MANAGEMENT DEVELOPMENT",
"P G INSTT OF MEDICAL EDCU AND RES -CHD",
"P G PACKAGING PRIVATE LIMITED",
"P G PATKI ARCHITECTS PRIVATE LIMITED",
"P G RESINS AND COATINGS PRIVATE LIMITED",
"P G SETTY CONSTRUCTION TECHNOLOGY PRIVATE LIMITED",
"P GOVT ENGINEERING COLLEGE SAGAR MADHYA PRADESH",
"P H & F W DEPOT GOVT OF CHHATISGARH CIVIL SURGEON CUM CHIEF HOSPITAL",
"P H AGRO AND FOOD IMPEX PRIVATE LIMITED",
"P H CAPITAL LIMITED",
"P H DIAGNOSTIC CENTRE PRIVATE LIMITED",
"P H FINANCIALS AND INVESTMENTS PRIVATE LIMITED",
"P H HEALTHCARE PRIVATE LIMITED",
"P H PATEL SANSKAR KANYA VIDHYAMANDIR",
"P HANS INTERNATIONAL C/O ENDYMINO",
"P HITESH & CO",
"P I C DEPARTMENTALS PRIVATE.LIMITED",
"P I INFOSOFT PRIVATE LIMITED",
"P J B ENGINEERS PRIVATE LIMITED",
"P J INDUSTRIES (INDORE) PVT LTD",
"P J JOHNSONS FRUIT COMPANY PRIVATE LIMITED",
"P J NETWORKS PRIVATE LIMITED",
"P K & COMPANY",
"P K AND SONS TRADELINK PRIVATE LIMITED",
"P K BEHURA & CO INFRA PRIVATE LIMITED",
"P K CARDBOARD COMPANY PRIVATE LIMITED",
"P K D MATRIC HIGHER SECONDARY SCHOOL",
"P K FURNITURE PRIVATE LIMITED",
"P K GANGWAL & SONS PVT LTD",
"P K INFRAPROJECT PRIVATE LIMITED",
"P K INTERMEDIATES PRIVATE LIMITED",
"P K INTERNATIONAL PRIVATE LIMITED",
"P K JEWELLERS PRIVATE LIMITED",
"P K KATHA INDUSTRIES PRIVATE LIMITED",
"P K LAKSHMI MILL INDIA PRIVATE LIMITED",
"P K MININGS PRIVATE LIMITED",
"P K P N SPINNING MILLS PRIVATE LIMITED",
"P K P SWAMY MATRICULATION HIGHER SECONDARY SCHOOL",
"P K PACKAGING PRIVATE LIMITED",
"P K PHARMATECH PRIVATE LIMITED",
"P K PRINT & PACK PRIVATE LIMITED",
"P K SAXENA CONTRACTOR",
"P K TECHNO PROJECT PRIVATE LIMITED",
"P K THAKUR & CO P LTD",
"P K TRANSMISSION PRODUCTS PRIVATE LIMITED",
"P K TUBES AND FITTINGS PRIVATE LIMITED",
"P K WEAVING MILLS PRIVATE LIMITED",
"P KISHANCHAND TEXTILES LIMITED",
"P KRISHNAPILLAI MEMORIAL PRINTING AND PUBLISHING CO PVT LTD",
"P L & SONS INFRASTRUCTURE PRIVATE LIMITED",
"P L AUTOMOBILES PRIVATE LIMITED",
"P L CARS PRIVATE LIMITED",
"P L FOOTWEAR PRIVATE LIMITED",
"P L GRANDSONS ASTEC PRIVATE LIMITED",
"P L JAIN STEEL COMPANY PRIVATE LIMITED",
"P L MARKETING PRIVATE LIMITED",
"P L MOTORS LIMITED",
"P L R PROJECTS PRIVATE LIMITED",
"P L RAJU CONSTRUCTIONS LIMITED",
"P LAL EXPORTS PRIVATE LIMITED",
"P M BHIMANI ORGOCHEM PRIVATE LIMITED",
"P M C LOGISTICS PRIVATE LIMITED",
"P M DIESELS PRIVATE LIMITED",
"P M ELECTRO-AUTO PRIVATE LIMITED",
"P M HEALTH & LIFE CARE PRIVATE LIMITED",
"P M K IMPEX PRIVATE LIMITED",
"P M MALL PRIVATE LIMITED",
"P M MARKETING PRIVATE LIMITED",
"P M OVERSEAS PRIVATE LIMITED",
"P M R STEEL PRIVATE LIMITED",
"P M RELOCATIONS PRIVATE LIMITED",
"P M S ENERGY INDIA PRIVATE LIMITED",
"P M SHAH AND COMPANY JEWELLERS PRIVATE LIMITED",
"P M V POLYTECHNIC",
"P MITTAL MANUFACTURING PRIVATE LIMITED",
"P MURALI CONSULTANTS PRIVATE LIMITED",
"P N DAS COLLEGE",
"P N GADGIL & SONS LIMITED",
"P N GADGIL JEWELLERS LIMITED",
"P N GADGIL JEWELLERS PRIVATE LIMITED",
"P N GHOSH AND ASSOCIATES PRIVATE LIMITED",
"P N K PIPE PRODUCTS PRIVATE LIMITED",
"P N R HOMES PRIVATE LIMITED",
"P N RAO",
"P N S BUSINESS PRIVATE LIMITED",
"P N WRITER AND COMPANY PRIVATE LIMITED",
"P NARASIMHA RAO AND COMPANY",
"P O STATE WAQF TRIBUNAL BHOPAL",
"P P ¬†PATEL HIGH SCHOOL & K P PATEL HIGHER SEC SCHOOL CHANASMA",
"P P AUTOMOTIVE PRIVATE LIMITED",
"P P BAFNA VENTURES PRIVATE LIMITED",
"P P BOOKS PRIVATE LIMITED",
"P P BUILDWELL PRIVATE LIMITED",
"P P DIAMONDS",
"P P GLOBALS PRIVATE LIMITED",
"P P I PUMPS PRIVATE LIMITED",
"P P IMITATIONS PRIVATE LIMITED",
"P P INDUSTRIES PRIVATE LIMITED",
"P P INTER COLLEGE",
"P P INTERNATIONAL",
"P P INTERNATIONAL PRIVATE LIMITED",
"P P JAIN EXPORTS PRIVATE LIMITED",
"P P KHARPATIL CONSTRUCTIONS PRIVATE LIMITED",
"P P OIL PRIVATE LIMITED",
"P P ORGANICS PRIVATE LIMITED",
"P P PRODUCTS PRIVATE LIMITED",
"P P REALCON PRIVATE LIMITED",
"P P ROLLING MILLS MFGING COMPANY PRIVATE LIMITED",
"P P RUBBER PRODUCTS PVT LTD",
"P P S CERAMIC CITI PRIVATE LIMITED",
"P P S STEELS KERALA PRIVATE LIMITED",
"P P S. STEELS INDIA PRIVATE LIMITED",
"P P SAVANI CENTRE FOR EXCELLENCE",
"P P SAVANI CHAITANYA VIDHYA SANKUL",
"P P SAVANI SCHOOL",
"P P SAVANI UNIVERSITY",
"P P TELECELL MARKETING PRIVATE LIMITED",
"P P TEXOFAB PRIVATE LIMITED",
"P P TUBE MILLS MFGING CO PRIVATE LIMITED",
"P R B SECURITIES PVT LTD",
"P R COATINGS PRIVATE LIMITED",
"P R D RIGS INDIA PRIVATE LIMITED",
"P R E MACHINES (INDIA) PRIVATE LIMITED",
"P R EXPORTS LTD",
"P R FABRICS PRIVATE LIMITED",
"P R FEED AND AGRO PRIVATE LIMITED",
"P R IMPEX PRIVATE LIMITED",
"P R INFRA AVENUES PRIVATE LIMITED",
"P R INFRACON PRIVATE LIMITED",
"P R K COMMODITIES PRIVATE LIMITED",
"P R MOTORS PRIVATE LIMITED",
"P R NAYAK ASSOCIATES PRIVATE LIMITED",
"P R O MARINE SOLUTIONS PRIVATE LIMITED",
"P R PATELL AND COMPANY PRIVATE LIMITED",
"P R PHARMA SOURCE PRIVATE LIMITED",
"P R POTE PATIL COLLEGE OF ENGINEERING & MANAGEMENT AMRAVATI",
"P R POTE PATIL COLLEGE OF PHARMACY",
"P R PROMOTERS & DEVELOPERS PRIVATE LTD",
"P R SALES CORPORATION PRIVATE LIMITED",
"P R T PRINTS PRIVATE LIMITED",
"P RAJESH SHIP BREAKING PVT LTD",
"P S AGRITECH PRIVATE LIMITED",
"P S ASSOCIATES",
"P S ATREE AND CO PRIVATE LIMITED",
"P S AUTO PRIVATE LIMITED",
"P S C INFOTECH PRIVATE LIMITED",
"P S COLD STORAGE PRIVATE LIMITED",
"P S FABRICATORS PVT LTD",
"P S GLOWTECH PRIVATE LIMITED",
"P S GROUP REALTY PRIVATE LIMITED",
"P S I SALES PRIVATE LTD.",
"P S INNS PVT LTD",
"P S M PUBLIC SCHOOL",
"P S P FARMS PRIVATE LIMITED",
"P S P LASER TECH PRIVATE LIMITED",
"P S PRAJAPATI EXIM PRIVATE LIMITED",
"P S R GRANITES PRIVATE LIMITED",
"P S RAJ STEELS PRIVATE LIMITED",
"P S SENIOR SECONDARY SCHOOL",
"P S SUMUKHA PRIVATE LIMITED",
"P S TEX EXIM PRIVATE LIMITED",
"P SARKAR FABRICATORS PRIVATE LIMITED",
"P SATYANARAYAN SONS PRIVATE LIMITED",
"P SEVEN GENERAL FINANCE PRIVATE LIMITED",
"P SQUARE FITCLUB",
"P T INSTRUMENTS PRIVATE LIMITED",
"P T LEE CHEN COLLEGE",
"P T LEE CHENGALVARAYA NAICKER HIGHER SECONDARY SCHOOL",
"P T M HOSIERY PVT LTD",
"P T MOTORS PRIVATE LIMITED",
"P U CHEMICALS PRIVATE LIMITED",
"P V JEWELLERS AND FOREX PRIVATE LIMITED",
"P V LINE PRIVATE LIMITED",
"P V NARSIMHA RAO TELANGANA VETERINARY UNIVERSITY",
"P V P REFINERIES PRIVATE LIMITED",
"P V SPINNING MILL INDIA PRIVATE LIMITED",
"P VENKATA RAMANAIAH ENGINEERS & CONTRACTORS PRIVATE LIMITED",
"P VENKATESWARLU PRIVATE LIMITED",
"P W S ARTS-COMMERCE COLLEGE",
"P&C INFRATECH PRIVATE LIMITED",
"P&C PROJECTS PRIVATE LIMITED",
"P&D GLOBAL TECHNOLOGIES PRIVATE LIMITED",
"P&G GEOHAZARD SOLUTIONS PRIVATE LIMITED",
"P&M LINER AND LOGISTICS PRIVATE LIMITED",
"P&M MOVIES PRIVATE LIMITED",
"P&O INTERNATIONAL PRIVATE LIMITED",
"P&P ENTREPRENEURIAL MANAGEMENTSERVICES PRIVATE LIMITED",
"P&P METALLOYS PRIVATE LIMITED",
"P&Y PROJECTS PRIVATE LIMITED",
"P. B. MANAF",
"P. B. MARKETING INDIA PRIVATE LIMITED",
"P. B. S. FOODS PRIVATE LIMITED",
"P. C. CHANDRA JUELS INTERNATIONAL PRIVATE LIMITED",
"P. CHANDRA REDDY AND CO.",
"P. COM. SOLUTIONS PRIVATE LIMITED",
"P. D. BAJORIA & SONS TEA COMPANY PRIVATE LIMITED",
"P. D. BAJORIA TEA AND AGRO PRODUCTS PRIVATE LIMITED",
"P. D. INDUSTRIES PRIVATE LIMITED",
"P. D. MEMORIAL RELIGIOUS & EDUCATIONAL ASSOCIATION",
"P. D. POLYSTER PRIVATE LIMITED",
"P. D. R. D. RICE MILLS PRIVATE LIMITED",
"P. D. SHAH AND SONS",
"P. DURAISAMY MAHARAJHA RICE MILLS PRIVATE LIMITED",
"P. G. INFRASTRUCTURE & SERVICES PRIVATE LIMITED",
"P. G. PISAL & SONS CONSTRUCTIONS PRIVATE LIMITED",
"P. H. FASHIONS PRIVATE LIMITED",
"P. H. RUPRIT AGENCY PRIVATE LIMITED",
"P. H. TEKNOW PRIVATE LIMITED",
"P. H. WOVEN SACKS PRIVATE LIMITED",
"P. I. COTTON PRIVATE LIMITED",
"P. K. A. CAPITAL PRIVATE LIMITED",
"P. K. AGRI LINK PRIVATE LIMITED",
"P. K. CEREALS PRIVATE LIMITED",
"P. K. EARTHMOVERS EQUIPMENTS PRIVATE LIMITED",
"P. K. PUMPS AND PRECICAST PRIVATE LIMITED",
"P. L. G. INCUBATION SERVICES PRIVATE LIMITED",
"P. MANGATRAM JEWELLERS PRIVATE LIMITED",
"P. N. PACKAGING PRIVATE LIMITED",
"P. P LOGISTICS PRIVATE LIMITED",
"P. P. DIAGNOSTICS PRIVATE LIMITED",
"P. P. SAVANI KNOWLEDGE CITY",
"P. PRABHAKARAN",
"P. PRABHUDAS ENGINEERING PRIVATE LIMITED",
"P. R. E. INFRASTRUCTURESS PRIVATE LIMITED",
"P. R. PATEL AND CO.",
"P. S. DAIMA AND SONS",
"P. S. ENTERPRISES",
"P. S. FUNERAL AND AMBULANCE SERVICES PRIVATE LIMITED",
"P. S. INFRABUILD PRIVATE LIMITED",
"P. S. MINT & ALLIED PRODUCTS PRIVATE LIMITED",
"P. S. POWER SYSTEMS PRIVATE LIMITED",
"P. S. SECURITY SERVICES PRIVATE LIMITED",
"P. V. R. & SONS ENGINEERS PRIVATE LIMITED",
"P. VISHRAM DISTRIBUTORS PRIVATE LIMITED",
"P.A.R.K. FELTS PRIVATE LIMITED",
"P.B. HOLOTECH INDIA PRIVATE LIMITED",
"P.B. TRADERS PVT. LTD.",
"P.B.KHOSE INFRASTRUCTURES PRIVATE LIMITED",
"P.B.M. INSULATIONS PRIVATE LIMITED",
"P.B.P ENTERPRISES PRIVATE LIMITED",
"P.B.SAMUI WINES PRIVATE LIMITED",
"P.C. CHANDRA GLOBAL JEWELRY PRIVATE LIMITED",
"P.C. SNEHAL CONSTRUCTION PRIVATE LIMITED",
"P.C. SONS CASTINGS PRIVATE LIMITED",
"P.C.B. DYEING PRIVATE LIMITED",
"P.C.CHANDA & CO. PRIVATE LIMITED",
"P.C.I ENGINEERS INDIA PRIVATE LIMITED",
"P.C.NEWS AGENCY PRIVATE LIMITED",
"P.C.PROCESS PRIVATE LIMITED",
"P.D. COMMERCIALS PRIVATE LIMITED",
"P.D. CONTECH PRIVATE LIMITED",
"P.D. FASHION PRIVATE LIMITED",
"P.D.AGRAWAL CONSTRUCTIONS PRIVATE LIMITED",
"P.D.GOYAL TRADE AND INVESTMENT LIMITED",
"P.D.INDUSTRIES PVT LTD",
"P.D.S. FOILS INDIA PRIVATE LIMITED",
"P.E. ERECTORS PRIVATE LIMITED",
"P.G EAPPEN CONSTRUCTION PRIVATE LIMITED",
"P.G. MACHINE FABRIKS PRIVATE LIMITED",
"P.G.A.S. ISPAT PRIVATE LIMITED",
"P.G.ASSOCIATES PRIVATE LIMITED",
"P.G.H. INTERNATIONAL PRIVATE LIMITED",
"P.H. WOOLLEN MILLS PRIVATE LIMITED",
"P.H.MARKETING PVT LTD.",
"P.I. PRESTIGE INTERNATIONAL INDIA PRIVATE LIMITED",
"P.I.P. POLYMERS PRIVATE LIMITED",
"P.J. AGRO TECH LIMITED",
"P.J.CYCLES PRIVATE LIMITED",
"P.K DELICACIES PRIVATE LIMITED",
"P.K ECOPACK PRIVATE LIMITED",
"P.K. ADVERTISING SERVICES PRIVATE LIMITED",
"P.K. BAJAJ SECURITIES PRIVATE LIMITED",
"P.K. CONSTRUCTION SHIMLA PRIVATE LIMITED",
"P.K. ENGINEERING & FORGING PVT LTD",
"P.K. FOODS",
"P.K. MARBLES PRIVATE LIMITED",
"P.K. PRESSMETAL PRIVATE LIMITED",
"P.K. TRANSFORMERS PRIVATE LIMITED",
"P.K.I. SOLUTIONS PRIVATE LIMITED",
"P.K.TEXTILES LTD",
"P.L. AUTOHOUSE PRIVATE LIMITED",
"P.L. ESTATES PRIVATE LIMITED",
"P.L.S. AUTO SHELL INDUSTRIES PRIVATE LIMITED",
"P.M. CLOSURE PRODUCTS PRIVATE LIMITED",
"P.M. ENGINEERS PRIVATE LIMITED",
"P.M. IMPEX PRIVATE LIMITED",
"P.M. INFRASTRUCTURE PRIVATE LIMITED",
"P.M. INTERSEAS PRIVATE LIMITED",
"P.M. RATHOD AND COMPANY PVT. LIMITED",
"P.M. REFRIGERATION PRIVATE LIMITED",
"P.M. SWITCHGEAR CONTROL EQUIPMENT PRIVATE LIMITED",
"P.M. TELELINNKS LIMITED",
"P.M. WOODCRAFTS PRIVATE LIMITED",
"P.M. ZARI EXCLUSIVES PRIVATE LIMITED",
"P.M.G.STRUCTURALS PRIVATE LIMITED",
"P.M.GRANITE EXPORT PRIVATE LIMITED",
"P.M.K CONSTRUCTIONS (INDIA) PRIVATE LIMITED",
"P.M.P. IRON AND STEELS (INDIA) LIMITED",
"P.M.P. TEXTILES SPINNING MILLS LIMITED",
"P.MANOHARLAL AND SONS JEWELLERS PRIVATE LIMITED",
"P.N. GAWANDE GINNING PRESSING & OIL MILL PRIVATE LIMITED",
"P.N. WRITER & COMPANY PRIVATE LIMITED",
"P.N.S INFRATECH PRIVATE LIMITED",
"P.N.SHIDHORE CIVIL ENGINEERS (INDIA) PRIVATE LIMITED",
"P.ORR & SONS PRIVATE LIMITED",
"P.P. AUTOTEK PRIVATE LIMITED",
"P.P. POLYPLAST PRIVATE LIMITED",
"P.P. SHETH AROMAS PRIVATE LIMITED",
"P.P.BUILDCON PRIVATE LIMITED",
"P.P.FABRICS PVT LTD",
"P.P.GOGAD",
"P.P.PANDEY INFRASTRUCTURE PRIVATE LIMITED",
"P.PAUL & BROTHERS PVT LTD",
"P.PURIA IRON & STEEL CO. PVT LTD",
"P.R. COMPONENTS PRIVATE LIMITED",
"P.R. FASTENERS PRIVATE LIMITED",
"P.R. INNOVATIONS PRIVATE LIMITED",
"P.R. MINERALS PVT LTD",
"P.R. MODI & SONS TEXTILE PRIVATE LIMITED",
"P.R. PACKAGINGS LIMITED",
"P.R. SEEDS AND GRAINS PRIVATE LIMITED",
"P.R. VYAPAR PRIVATE LIMITED",
"P.R.7 SECURITY & PLACEMENT SERVICES PRIVATE LIMITED",
"P.R.J. WAREHOUSING PRIVATE LIMITED",
"P.R.K DIAMONDS PRIVATE LIMITED",
"P.R.MANI ELECTRONICS PRIVATE LIMITED",
"P.R.T.S INDUSTRIES PRIVATE LIMITED",
"P.R.TECHNOPLAST PRIVATE LIMITED",
"P.R.V CONSTRUCTIONS PRIVATE LIMITED",
"P.RAYIN CONSTRUCTIONS COMPANY PRIVATE LIMITED",
"P.S. CONSTRUCTION PRIVATE LIMITED",
"P.S. ENGINEERING INFRASTRUCTURE PRIVATE LIMITED",
"P.S. INDUSTRIES REGD",
"P.S. SAINI INFRATECH AND CONSTRUCTION PRIVATE LIMITED",
"P.S. SOHAN SINGH PRIVATE LIMITED",
"P.S. STEEL TUBES PRIVATE LIMITED",
"P.S.B. INVESTMENT PRIVATE LIMITED",
"P.S.S. KRISHNAMURTHI EXPORTS PRIVATE LIMITED",
"P.S.U INFRAPROJECTS PRIVATE LIMITED",
"P.T. DOTCOM PRIVATE LIMITED",
"P.T.EDUCATION AND TRAINING SERVICES PRIVATE LIMITED",
"P.V. AGRI MARKETING PRIVATE LIMITED",
"P.V. ENGINEERING ASSOCIATES PRIVATE LIMITED",
"P.V. FORGE PRIVATE LIMITED",
"P.V. INFRA PROJECTS PRIVATE LIMITED",
"P.V.AGENCIES FREIGHT FORWARDERS PRIVATE LIMITED",
"P.V.BIO-CHEM INDIA PRIVATE LIMITED",
"P.V.N.V. INDUSTRIES PRIVATE LIMITED",
"P.V.S. BEEDIES PRIVATE LIMITED",
"P.WIRES (INDIA) PRIVATE LIMITED",
"P2B ACE SOLUTIONS PRIVATE LIMITED",
"P2B EXPRESS LOGISTICS PRIVATE LIMITED",
"P2P MICROFINANCE & ALLIED SERVICES",
"P3 FREIGHT LOGISTICS INDIA (OPC) PRIVATE LIMITED",
"P3 INDUSTRIES PRIVATE LIMITED",
"P3P PRODUCTIONS PRIVATE LIMITED",
"P4 TEX FAB PRIVATE LIMITED",
"P4I CONSULTING PRIVATE LIMITED",
"P9 FARMS PRIVATE LIMITED",
"P9 TECHNOLOGIES PRIVATE LIMITED",
"P99SOFT PRIVATE LIMITED",
"PA BUSINESS SOLUTIONS PRIVATE LIMITED",
"PA CONSULTING SERVICES INDIA PRIVATE LIMITED",
"PA FIRST GRADE COLLEGE",
"PA LILY FACTORY LLP",
"PA PU GODAVARI MATA MADHYAMIK VA UCCHA MADHYAMIK VIDYALAYA MHASAWAD",
"PA RESEARCH & CONSULTANTS PRIVATE LIMITED",
"PAAKHI BUSINESS PRIVATE LIMITED",
"PAALANA INSTITUTE OF MEDICAL SCIENCES",
"PAALGUNA POULTRY BREEDING FARMS PRIVATE LIMITED",
"PAAM BIOTECH PRIVATE LIMITED",
"PAAM COMMERCIAL PRIVATE LIMITED",
"PAAMA AGRICO PRIVATE LIMITED",
"PAAMGLOBAL INTIMATES PRIVATE LIMITED",
"PAANERI EXIM PRIVATE LIMITED",
"PAANINI INNOVATIONS INDIA PRIVATE LIMITED",
"PAANITECH INDIA PRIVATE LIMITED",
"PAAR BROKING PRIVATE LIMITED",
"PAAR GLOBAL HEALTH CARE PRIVATE LIMITED",
"PAAR KITCHEN SOLUTIONS PRIVATE LIMITED",
"PAAR VENTURES PRIVATE LIMITED",
"PAARAMI DIGITAL CONSULTING LLP",
"PAARAS GSW PRIVATE LIMITED",
"PAARDOS SECURITY & CONSULTANCY PRIVATE LIMITED",
"PAARSH ISPAT PRIVATE LIMITED",
"PAARTH INFRABUILD PRIVATE LIMITED",
"PAARTH INFRAWORKS PRIVATE LIMITED",
"PAARTH MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"PAARTH SARTHI AUTOMOTIVE ENGINEERS PRIVATE LIMITED",
"PAARUS CONTAINERS & CARTONS PRIVATE LIMITED",
"PAAS RESEARCH PRIVATE LIMITED",
"PAASH ESTATES PRIVATE LIMITED",
"PAAVAI ENGINEERING COLLEGE",
"PAAVAN COMMERCIAL PRIVATE LIMITED",
"PAAVANA INSURANCE BROKERS PRIVATE LIMITED",
"PAAWAK FOODS PRIVATE LIMITED",
"PAAWAN ENERGY INDIA PRIVATE LIMITED",
"PAAYAS MILK PRODUCER COMPANY LIMITED",
"PAB ENGINEERING WORKS PRIVATE LIMITED",
"PAB ORGANICS PRIVATE LIMITED",
"PABAL HOUSING PRIVATE LIMITED",
"PABANSO INDIA PRIVATE LIMITED",
"PABITRA ELECTRICAL WORKS PRIVATE LIMITED",
"PABLA BEARINGS LIMITED",
"PAC ASIA EDUSERVE LLP",
"PAC COSMETICS PRIVATE LIMITED",
"PAC EDGE LABELS PRIVATE LIMITED",
"PAC FORTUNE VENTURES PRIVATE LIMITED",
"PAC INDIA PRIVATE LIMITED",
"PAC MACHINE TOOLS INDIA LLP",
"PAC MED BIOTECH PRIVATE LIMITED",
"PACARD POWER PRIVATE LIMITED",
"PACAVO IT CONSULTING PRIVATE LIMITED",
"PACCAR INC",
"PACCAR INDIA PRIVATE LIMITED",
"PACCORE SOFTWARE INDIA PRIVATE LIMITED",
"PACCS HEALTHCARE PRIVATE LIMITED",
"PACE AFTERMARKET PRIVATE LIMITED",
"PACE AUTOAIDS PRIVATE LIMITED",
"PACE AUTOPARTS PRIVATE LIMITED",
"PACE BIOTECH PRIVATE LIMITED",
"PACE BUSINESS MACHINES PRIVATE LIMITED",
"PACE COMMODITY BROKERS PRIVATE LIMITED",
"PACE COMPUTECH (INDIA) PRIVATE LIMITED",
"PACE COMPUTECH PRIVATE LIMITED",
"PACE COMPUTER CONSULTANTS PRIVATE LIMITED",
"PACE DIGITEK INFRA PRIVATE LIMITED",
"PACE DISTRIBUTION & MARKETING PRIVATE LIMITED",
"PACE E-COMMERCE VENTURES LIMITED",
"PACE EDUCARE PRIVATE LIMITED",
"PACE EDUCATION AND FINANCIAL SERVICES PRIVATE LIMITED",
"PACE ELECTRICALS PRIVATE LIMITED",
"PACE ENGINEERING INDUSTRIES PRIVATE LIMITED",
"PACE EXPRESS PRIVATE LIMITED",
"PACE EXPRESS TRAVELS AND CARGO PRIVATE LIMITED",
"PACE FINANCIAL INVESTMENT ADVISER PRIVATE LIMITED",
"PACE FINCAP PRIVATE LIMITED",
"PACE HEART CENTER PRIVATE LIMITED",
"PACE HOSPITAL",
"PACE INFOSOLUTIONS PRIVATE LIMITED",
"PACE INFOTECH INDIA PRIVATE LIMITED",
"PACE INFRA PROJECTS",
"PACE INFRATECH PRIVATE LIMITED",
"PACE INSTITUTE OF TECHNOLOGY & SCIENCES",
"PACE JUNIOR SCIENCE COLLEGE",
"PACE MARINE SOLUTIONS PRIVATE LIMITED",
"PACE PACKAGING MACHINES PRIVATE LIMITED",
"PACE PHARMATECH PRIVATE LIMITED",
"PACE PRE UNIVERSITY COLLEGE",
"PACE PRINTERS PRIVATE LIMITED",
"PACE PROCESS CONTROLS PRIVATE LIMITED",
"PACE PROFESSIONAL SERVICES PRIVATE LIMITED",
"PACE PROJECTS AND LOGISTICS PRIVATE LIMITED",
"PACE RENEWABLE ENERGIES PRIVATE LIMITED",
"PACE RESOURCES PRIVATE LIMITED",
"PACE SEATING SYSTEMS PRIVATE LIMITED",
"PACE SETTERS BUSINESS SOLUTIONS PRIVATE LIMITED",
"PACE SOLUTIONS INDIA PRIVATE LIMITED",
"PACE STOCK BROKING SERVICES PRIVATE LIMITED TFR. FROM DELHI TO HARYANA",
"PACE STOCKS & SHARES PRIVATE LIMITED",
"PACE TEL SYSTEMS PRIVATE LIMITED",
"PACE ULTRA MODERN PU COLLEGE",
"PACE VENTURES PRIVATE LIMITED",
"PACE WISDOM SOLUTIONS PRIVATE LIMITED",
"PACECOM TECHNOLOGIES PRIVATE LIMITED",
"PACEINFRACON PRIVATE LIMITED",
"PACEMAN FINANCE INDIA PRIVATE LIMITED",
"PACENET MEGHBELA BROADBAND PRIVATE LIMITED",
"PACER AUTOMATION PRIVATE LIMITED",
"PACER POWER SOLUTION PRIVATE LIMITED",
"PACER SECURE SERVICES PRIVATE LIMITED",
"PACHAIAPPAS COLLEGE",
"PACHAIYAPPAS SILKS PRIVATE LIMITED",
"PACHAL TRANSFORMERS PVT LTD",
"PACHAMUTHU MATRIC HIGHER SECONDARY SCHOOL",
"PACHARIA EXPORTS PVT LTD",
"PACHERIA CASTINGS PVT LTD",
"PACHEYAYE SILOS CONSTRUCTIONS PRIVATE LIMITED",
"PACHHWARA COAL MINING PRIVATE LIMITED",
"PACHIS FRAME PRODUCTION PRIVATE LIMITED",
"PACHISIA MULTITECH PVT LTD",
"PACHOULI AESTHETICS AND WELLNESS PRIVATE LIMITED",
"PACHOULI WELLNESS CLINIC",
"PACHRANGA INTERNATIONAL PVT LTD",
"PACHRANGA SYNDICATE PRIVATE LIMITED",
"PACHUNDKAR HOSPITAL",
"PACICON INFOPOWER PRIVATE LIMITED",
"PACIFFIC SPIRITS PRIVATE LIMITED",
"PACIFIC ADVISORY SOLUTIONS PRIVATE LIMITED",
"PACIFIC AESTHETIC INDIA PRIVATE LIMITED",
"PACIFIC AGRO TECH PRIVATE LIMITED",
"PACIFIC ALLOYS PRIVATE LIMITED",
"PACIFIC AQUATECH INDIA PRIVATE LIMITED",
"PACIFIC BEARINGS PVT LTD",
"PACIFIC BIOCHEM PRIVATE LIMITED",
"PACIFIC BIOENGINEERING PRIVATE LIMITED",
"PACIFIC BLU SUBSEA SERVICES PRIVATE LIMITED",
"PACIFIC BLUE CARGO PRIVATE LIMITED",
"PACIFIC BPO PRIVATE LIMITED",
"PACIFIC BRAND (INDIA) PRIVATE LIMITED",
"PACIFIC BULK BAGS PRIVATE LIMITED",
"PACIFIC CITI FONE DEALS PRIVATE LIMITED",
"PACIFIC COLLEGE OF PHYSIOTHERAPY",
"PACIFIC CONSOLIDATED INDUSTRIES (PCI) GASES INDIA PRIVATE LIMITED",
"PACIFIC CONSTRUCTIONS PC",
"PACIFIC CONSULTING PRIVATE LIMITED",
"PACIFIC CONTROL (INDIA) PRIVATE LIMITED",
"PACIFIC CUSTOMS BROKER SERVICES PRIVATE LIMITED",
"PACIFIC CYBER TECHNOLOGY PRIVATE LIMITED",
"PACIFIC DEVELCON PRIVATE LIMITED",
"PACIFIC DEVELOPMENT CORPORATION LIMITED",
"PACIFIC ELECTRIC POWER DEVELOPMENT CORPORATION.",
"PACIFIC EXPORTS AND IMPORTS",
"PACIFIC FIRE CONTROLS PRIVATE LIMITED",
"PACIFIC FORGINGS AND FASTENERS PVT LTD",
"PACIFIC FREIGHT FORWARDERS PRIVATE LIMITED",
"PACIFIC GAMING PRIVATE LIMITED",
"PACIFIC GARMENTS PRIVATE LIMITED",
"PACIFIC GIANTS SHIPPING LINE PRIVATE LIMITED",
"PACIFIC GLOBAL SOLUTIONS LIMITED",
"PACIFIC GOLDEN LOGISTICS (INDIA) PRIVATE LIMITED",
"PACIFIC GOLDEN LOGISTICS PARK PRIVATE LIMITED",
"PACIFIC GRANITES (INDIA) PRIVATE LIMITED",
"PACIFIC I T CONSULTING PRIVATE LIMITED",
"PACIFIC IMAGES PRIVATE LIMITED",
"PACIFIC INDUSTRIES LIMITED",
"PACIFIC INTERIO PRIVATE LIMITED",
"PACIFIC INTERIORS INDIA PRIVATE LIMITED",
"PACIFIC INTERNATIONAL PRIVATE LIMITED",
"PACIFIC INTERNET INDIA PRIVATE LIMITED",
"PACIFIC IRON MANUFACTURING LIMITED",
"PACIFIC JUTE LIMITED",
"PACIFIC LEATHER PRIVATE LIMITED",
"PACIFIC LIFE",
"PACIFIC MAINTENANCE SERVICES PRIVATE LIMITED",
"PACIFIC MARINE SURVEYORS & CONSULTANTS PRIVATE LIMITED",
"PACIFIC MARITIME PRIVATE LIMITED",
"PACIFIC MEDICAL COLLEGE AND HOSPITAL",
"PACIFIC MEDITECH PRIVATE LIMITED",
"PACIFIC MINDWARE ENGINEERING PRIVATE LIMITED",
"PACIFIC MINERALS PVT LTD",
"PACIFIC MOTELS PRIVATE LIMITED",
"PACIFIC NATURA BIOTECH PRIVATE LIMITED.",
"PACIFIC NEWS PRIVATE LIMITED",
"PACIFIC ORGANICS P.LTD.",
"PACIFIC ORGOCHEM LIMITED",
"PACIFIC PALLETS PRIVATE LIMITED",
"PACIFIC PIPE SYSTEMS PRIVATE LIMITED",
"PACIFIC PLASTICS INDUSTRIES PRIVATE LIMITED",
"PACIFIC POULTRIES PRIVATE LIMITED",
"PACIFIC POWER PROJECTS PRIVATE LIMITED",
"PACIFIC QUARTZ SURFACES",
"PACIFIC QUARTZ SURFACES LLP",
"PACIFIC REFRACTORIES LIMITED",
"PACIFIC RESORTS AND HOTELS LIMITED",
"PACIFIC SCHOOL OF ENGINEERING",
"PACIFIC SECURITY SOLUTIONS PRIVATE LIMITED",
"PACIFIC SILK MILLS PRIVATE LIMITED",
"PACIFIC TECHNOPRODUCTS INDIA PRIVATE LIMITED",
"PACIFIC TEXCHEM PRIVATE LIMITED",
"PACIFIC THERAPEUTICS PRIVATE LIMITED",
"PACIFIC TOOLS PRIVATE LIMITED",
"PACIFIC TRANS EXPRESS TRADES PRIVATE LIMITED",
"PACIFIC TRENDS PRIVATE LIMITED",
"PACIFIC UNIVERSITY",
"PACIFIC VYAPAAR PRIVATE LIMITED",
"PACIFIC WATER SOLUTION PRIVATE LIMITED",
"PACIFIC WELD SYSTEMS PRIVATE LIMITED",
"PACIFIC WORLD SCHOOL",
"PACIFICA (INDIA) PROJECTS PRIVATE LIMITED",
"PACIFICA ART INDIA PRIVATE LIMITED",
"PACIFICA BUILDERS PRIVATE LIMITED",
"PACIFICA CONSTRUCTION PRIVATE LIMITED",
"PACIFICA CROP BREEDERS PRIVATE LIMITED",
"PACIFICA DEVELOPERS PRIVATE LIMITED",
"PACIFICA HOTELS BANGLORE PROJECT PRIVATE LIMITED",
"PACIFICA HOTELS INDIA PRIVATE LIMITED",
"PACIFICA INDUSTRIAL SERVICES PRIVATE LIMITED",
"PACIO TRADERS PRIVATE LIMITED",
"PACITECH CHEMICAL ENGINEERING PRIVATE LIMITED",
"PACK CARE INDIA PRIVATE LIMITED",
"PACK FILMS PRIVATE LIMITED",
"PACK MAKER MACHINES PRIVATE LIMITED",
"PACK N PRINT PACKAGING PRIVATE LIMITED",
"PACK PACK (INDIA) PRIVATE LIMITED",
"PACK PAPER AGENCIES PRIVATE LIMITED",
"PACK PERFECT PRIVATE LIMITED",
"PACK PRINT INDUSTRIES INDIA PRIVATE LIMITED",
"PACKAGERR",
"PACKAGING BROS PRIVATE LIMITED",
"PACKAGING SOLUTIONS PRIVATE LIMITED",
"PACKAID ECOPACK PRIVATE LIMITED",
"PACKAID PACKAGING PRIVATE LIMITED",
"PACKAM CONTROLS PRIVATE LIMITED",
"PACKAPEER ACADEMY PRIVATE LIMITED",
"PACKEDGE INDUSTRIES PRIVATE LIMITED",
"PACKET LOGICS PRIVATE LIMITED",
"PACKETEER PRIVATE LIMITED",
"PACKETPATH TECHNOLOGIES PRIVATE LIMITED",
"PACKINGS & JOINTINGS GASKETS PRIVATE LIMITED",
"PACKKOID INDUSTRIES PRIVATE LIMITED",
"PACKMAN PACKAGING PRIVATE LIMITED",
"PACKMASTER MACHINERY PRIVATE LIMITED",
"PACKME INDUSTRIES PRIVATE LIMITED",
"PACKMEN EXIM PRIVATE LIMITED",
"PACKMEN MACHINERIES PRIVATE LIMITED",
"PACKMILE PRIVATE LIMITED",
"PACKNBACK SOLUTIONS PRIVATE LIMITED",
"PACKNOWCRAT (INDIA) PRIVATE LIMITED",
"PACKRAFT CORRUGATE (INDIA) PRIVATE LIMITED",
"PACKRFT CONTAINER INDIA PRIVATE LIMITED",
"PACKSEAL PACKAGING & CODING SOLUTIONS PRIVATE LIMITED",
"PACKSMART INDIA PRIVATE LIMITED",
"PACKSMITH INDIA PRIVATE LIMITED",
"PACKSO TECHNOLOGY PRIVATE LIMITED",
"PACKSON IMPEX PRIVATE LIMITED",
"PACKSWELL COMBINE PRIVATE LIMITED",
"PACKT PUBLISHING PRIVATE LIMITED",
"PACKTECH MATERIALS PRIVATE LIMITED",
"PACKTIME INNOVATIONS PRIVATE LIMITED",
"PACKWEL COIMBATORE PRIVATE LIMITED",
"PACKWELL COMMERCIAL PRIVATE LIMITED",
"PACKWELL GASKETS PRIVATE LIMITED",
"PACK-WELL INDUSTRIES (VALSAD) PVT LTD",
"PACKWELL SOLUTION PRIVATE LIMITED",
"PACKWELL THERMOFORMERS PRIVATE LIMITED",
"PACKWELL(INDIA) PVT LTD.,",
"PACKWIN PACKAGES PRIVATE LIMITED",
"PACLEAN VENTURES PRIVATE LIMITED",
"PACMAC ENGINEERS PRIVATE LIMITED",
"PACMAC SOLUTION PRIVATE LIMITED",
"PACMAT POLYMERS INDIA PRIVATE LIMITED",
"PACMATIC INDUSTRIES PRIVATE LIMITED",
"PACNIDS PRIVATE LIMITED",
"PACOLINE INDUSTRIES PRIVATE LIMITED",
"PACRYLIC STRAP INDIA PRIVATE LIMITED",
"PACSEAL GASKETS INDIA PRIVATE LIMITED",
"PACT CLOSURE SYSTEMS INDIA PRIVATE LIMITED",
"PACT INDUSTRIES LIMITED",
"PACT LABS PRIVATE LIMITED",
"PACT MACHINES PRIVATE LIMITED",
"PACT POWER SOLUTION LLP",
"PACT REAL ESTATE PRIVATE LIMITED",
"PACT SECURITIES AND FINANCIAL SERVICES LTD",
"PACT SOFTWARE SERVICES PRIVATE LIMITED",
"PACTECH MACHINERY LLP",
"PACTIL ELECTRONICS PRIVATE LIMITED",
"PACTION SERVICES PRIVATE LIMITED",
"PACTORA INDIA PRIVATE LIMITED",
"PACTRON INDIA PRIVATE LIMITED",
"PAD INTEGRATED MARKETING & COMMUNICATIONS PRIVATE LIMITED",
"PADAH SOLUTIONS PRIVATE LIMITED",
"PADAIAPPA TEXTILE PRIVATE LIMITED",
"PADALE CONSTRUCTIONS PRIVATE LIMITED",
"PADAM CHAND BEARING & BELTS PRIVATE LIMITED",
"PADAM CHAND STEELS PRIVATE LIMITED",
"PADAM COLD STORAGE PRIVATE LIMITED",
"PADAM COTTON YARNS LIMITED",
"PADAM ELECTRICALS LIMITED",
"PADAM INTERIORS PRIVATE LIMITED",
"PADAM MOTORS PRIVATE LIMITED",
"PADAM PRABHU KNITS PRIVATE LIMITED",
"PADAM PRABHU MARBLES PRIVATE LIMITED",
"PADAM PRINT PACK INDUSTRIES PRIVATE LIMITED",
"PADAM PRODUCTS PRIVATE LIMITED",
"PADAM SHREE TEX FEB PRIVATE LIMITED",
"PADAM SYNTHETICS PRIVATE LIMITED",
"PADAM TRADING PRIVATE LIMITED",
"PADAMNABH TRADING PRIVATE LIMITED",
"PADAMRAMAN VYANKATESHWAR TRADING PRIVATE LIMITED",
"PADAMSHREE GLOBE TRADELINK LIMITED",
"PADAMSHREE INFRADEVELOPERS PRIVATE LIMITED",
"PADAMSHREE PROCESSORS PRIVATE LIMITED",
"PADAMSHREE WVG & MFG MILLS PRIVATE LIMITED",
"PADAMSIDDHI TRADERS AND EXPORTERS PVT LTD",
"PADANJALI TEA & AGRO PRIVATE LIMITED",
"PADARIA CONSULTANTS PRIVATE LIMITED",
"PADARSH PHARMACEUTICALS PRIVATE LIMITED",
"PADCARE LABS PRIVATE LIMITED",
"PADDER CONSTRUCTIONS PRIVATE LIMITED",
"PADDLE POINT BPO SERVICES PRIVATE LIMITED",
"PADDY HOSPITALITY PRIVATE LIMITED",
"PADECO INDIA PRIVATE LIMITED",
"PADGET ELECTRONICS PRIVATE LIMITED",
"PADGILWAR AGRO INDUSTRIES",
"PADHAM STEEL ENTERPRISES PRIVATE LIMITED",
"PADHAS HYDEL PROJECTS PRIVATE LIMITED",
"PADHCHIN INFORMATION TECHNOLOGY & MARKETING SERVICES PRIVATE LIMITED",
"PADIA EXPORTS PRIVATE LIMITED",
"PADINJAREKARA POLYMERS PVT LTD",
"PADM CHEM RESEARCH PRIVATE LIMITED",
"PADM LABORATORIES PRIVATE LIMITED",
"PADMA - BHAVAM ENGINEERS PRIVATE LIMITED",
"PADMA ADARSH HIGHER SECONDARY SCHOOL",
"PADMA BALAJI HOLDINGS PRIVATE LIMITED",
"PADMA FASHIONS PRIVATE LIMITED",
"PADMA GEMS",
"PADMA HOSPITALITY PRIVATE LIMITED",
"PADMA INFOCOM PRIVATE LIMITED",
"PADMA JEWELS PRIVATE LIMITED",
"PADMA LOGISTIC AND KHANIJ PRIVATE LIMITED",
"PADMA MOTORS PRIVATE LIMITED",
"PADMA NUTRI HEALTH PRODUCTS PRIVATE LIMITED",
"PADMA PERFUMERY WORKS",
"PADMA POLYCHEM PRIVATE LIMITED",
"PADMA PRIYA HOSPITAL PRIVATE LIMITED",
"PADMA PULSE PROCESSORS PRIVATE LIMITED",
"PADMA RAGA COMMERCIALS PRIVATE LIMITED",
"PADMA SAI FINANCE PRIVATE LIMITED",
"PADMA SESHADRI BALA BHAVAN",
"PADMA SRI RICE MILL",
"PADMAA FINCAP PRIVATE LIMITED",
"PADMAAS CATERING PRIVATE LIMITED",
"PADMABALAJI SPINNERS PRIVATE LIMITED",
"PADMABATI INFRA PROJECTS PRIVATE LIMITED",
"PADMABATI POULTRY FOODS PRIVATE LIMITED",
"PADMABHUSHAN DR VASANTRAODADA PATIL MAHAVIDYALAYA TASGAON",
"PADMADEEPA INTERNATIONAL SCHOOL",
"PADMAJA AREO BIOLOGICALS PRIVATE LIMITED",
"PADMAJA ENGINEERING SERVICES PRIVATE LIMITED",
"PADMAJA FARMS",
"PADMAJA HERBS AND FOODS PRIVATE LIMITED",
"PADMAJA HOSPITAL",
"PADMAJA LABORATORIES PRIVATE LITD",
"PADMAJA MOTORS PRIVATE LIMITED",
"PADMAJA PACKAGING INDUSTRIES LTD",
"PADMAJA POLY PACKS PRIVATE LIMITED",
"PADMAJA SYSTEMS & SERVICES PRIVATE LIMITED",
"PADMAJA TARVELS PRIVATE.LIMITED",
"PADMAJIWADI SOLAR PRIVATE LIMITED",
"PADMALAYA HOSPITAL PRIVATE LIMITED",
"PADMALAYA INFRASTRUCTURE PRIVATE LIMITED",
"PADMAMBA ENTERPRISES PRIVATE LIMITED",
"PADMANABH ALLOYS AND POLYMERS LIMITED",
"PADMANABH CREATION PRIVATE LIMITED",
"PADMANABH HEALTHCARE PRIVATE LIMITED",
"PADMANABH TRADING PRIVATE LIMITED",
"PADMANSHA TECHNOLOGIES PRIVATE LIMITED",
"PADMAPARSHVA INFRASTRUCTURES PRIVATE LIMITED",
"PADMAPRABHU COMMODITY TRADING PRIVATE LIMITED",
"PADMAPRABHU INFRASTRUCTURE & REALTY PRIVATE LIMITED",
"PADMAPRIYA PROPERTIES PRIVATE LIMITED",
"PADMAPUKUR RAMKRISHNA VIDYAMANDIR HIGH",
"PADMARAJE VIDYALAY & JR COLLEGE SHIROL",
"PADMASH LEATHERS AND EXPORTS PRIVATE LIMITED",
"PADMASHALI SHIKSHAN SANSTHA SOLAPUR",
"PADMASHREE DY PATIL INSTITUTE OF ENGG. & TECH",
"PADMASHREE INC.",
"PADMASHREE MEDICARE PRIVATE LIMITED",
"PADMASHREE SCHOOL",
"PADMASHRI DR D Y PATIL SAHAKARI SAKHAR KARKHANA LIMITED",
"PADMASHRI FINANCIAL SOLUTIONS PRIVATE LIMITED",
"PADMASHRI WATER SOLUTIONS PRIVATE LIMITED",
"PADMASREE AGRITECH PRIVATE LIMITED",
"PADMASREE HOTELS PRIVATE LIMITED",
"PADMASREE STEELS PRIVATE LIMITED",
"PADMASRI DR B V RAJU INSTITUTE OF TECHNOLOGY",
"PADMASRI ORGANICS PRIVATE LIMITED",
"PADMASRI PAPER BOARDS PRIVATE LIMITED",
"PADMASRI TOWNSHIPS PRIVATE LIMITED",
"PADMATECH INDUSTRIES PRIVATE LIMITED",
"PADMATHEERTHAM INFRASTRUCTURE DEVELOPERS PRIVATE LIMITED",
"PADMAVAHINI TRANSFORMERS PRIVATE LIMITED",
"PADMAVAT PLASTICS PRIVATE LIMITED",
"PADMAVATHI CASHEWS AND COFFEE PRIVATE LIMITED",
"PADMAVATHI FIBRES AND YARNS PRIVATE LIMITED",
"PADMAVATHI HOSPITALITY & FACILITIES MANAGEMENT SERVICE",
"PADMAVATHI MANSIONS PRIVATE LIMITED",
"PADMAVATHI VOCATIONAL JR COLLEGE",
"PADMAVATI AGRICO (INDIA) PRIVATE LIMITED",
"PADMAVATI ALMEX PRIVATE LIMITED",
"PADMAVATI CASTINGS PRIVATE LIMITED",
"PADMAVATI CHAINS PRIVATE LIMITED",
"PADMAVATI CHEMICALS PVT LTD",
"PADMAVATI CHEMTECH PRIVATE LIMITED",
"PADMAVATI DECOR PRIVATE LIMITED",
"PADMAVATI DEVI STEELS PRIVATE LIMITED",
"PADMAVATI EXPOCHEM PRIVATE LIMITED",
"PADMAVATI FERROUS LIMITED",
"PADMAVATI FITTINGS PRIVATE LIMITED",
"PADMAVATI FOREX (INDIA) PRIVATE LIMITED",
"PADMAVATI FORGE PVT LTD",
"PADMAVATI GREEN ENERGY AND VENTURES PRIVATE LIMITED",
"PADMAVATI ICE AND COLD STOREGE PVT LTD",
"PADMAVATI INFRASTRUCTURE COMPANY",
"PADMAVATI INVESTMENT PRIVATE LIMITED",
"PADMAVATI JEWELLERS PRIVATE LIMITED",
"PADMAVATI PLASTOFILM INDUSTRIES",
"PADMAVATI PLY PRIVATE LIMITED",
"PADMAVATI PROJECTS PRIVATE LIMITED",
"PADMAVATI PULP & PAPER MILLS",
"PADMAVATI RESINS PRIVATE LIMITED",
"PADMAVATI RETAIL INDIA PRIVATE LIMITED",
"PADMAVATI SALT PRIVATE LIMITED",
"PADMAVATI STEELS LIMITED",
"PADMAVATI TRADELINK LIMITED",
"PADMAVATI WEAVES PRIVATE LIMITED",
"PADMAWATI CAPITAL SERVICES PRIVATE LIMITED",
"PADMAWATI EXTRUSION PRIVATE LIMITED",
"PADMAWATI IMPORTS PRIVATE LIMITED",
"PADMAWATI MARKETING PRIVATE LIMITED",
"PADMAWATI POLYFILMS PRIVATE LIMITED",
"PADMESH BEVERAGES",
"PADMINI AROMATICS PRIVATE LIMITED",
"PADMINI BAKERS PRIVATE LIMITED",
"PADMINI DIESEL EMISSION CONTROL PRIVATE LIMITED",
"PADMINI IMPEX PRIVATE LIMITED",
"PADMINI INFRASTRUCTURE DEVELOPERS INDIA LIMITED",
"PADMINI INNOVATIVE MARKETING SOLUTIONS PRIVATE LIMITED",
"PADMINI PRODUCTS PRIVATE LIMITED",
"PADMINI SYNTEX PRIVATE LIMITED",
"PADMINI VNA EMISSION CONTROL SYSTEM PRIVATE LIMITED",
"PADMINI VNA MECHATRONICS LIMITED",
"PADMINI VNA MECHATRONICS PRIVATE LIMITED",
"PADREA GLOBAL SERVICES LIMITED",
"PADRONE MARKETING PVT LTD",
"PADSONS INDUSTRIES PRIVATE LIMITED",
"PADUA PRE UNIVERSITY COLLEGE",
"PADUKONE SPORTS MANAGEMENT PRIVATE LIMITED",
"PAE CONSTRUCTION INDIAN (OPC) PRIVATE LIMITED",
"PAE CONTROLS (INDIA) PRIVATE LIMITED",
"PAEAN LABORATORIES PRIVATE LIMITED",
"PAEDNEST MEDICAL AND RESEARCH CENTRE PRIVATE LIMITED",
"PAEXSKIN SOLUTIONS PRIVATE LIMITED",
"PAFEX LIFESTYLE PRIVATE LIMITED",
"PAFFY INDUSTRIES PRIVATE LIMITED",
"PAFLOG SUPPLY CHAIN SERVICES PRIVATE LIMITED",
"PAFT FINANCE LIMITED",
"PAG INTERNATIONAL PRIVATE LIMITED",
"PAGADALA CONSTRUCTIONS PRIVATE LIMITED",
"PAGAN PAINTS AND CHEMICALS PRIVATE LIMITED",
"PAGAR & SONS JEWELLERS PRIVATE LIMITED",
"PAGARANI UNIVERSAL INFRASTRUCTURE PRIVATE LIMITED",
"PAGARAV HOSPITAL & ICU PRIVATE LIMITED",
"PAGARIA ADVISORY PRIVATE LIMITED",
"PAGARIA ELECTRONICS PRIVATE LIMITED",
"PAGARIYA AUTO PRIVATE LIMITED",
"PAGARIYA CONSUMER FOODS PRIVATE LIMITED",
"PAGARIYA EXPORTS PRIVATE LIMITED",
"PAGARIYA FOOD PRODUCTS PRIVATE LIMITED",
"PAGARIYA INDUSTRIES PRIVATE LIMITED",
"PAGARIYA OVERSEAS PRIVATE LIMITED",
"PAGARIYA TEXTILES PRIVATE LIMITED",
"PAGE 3 FASHIONS PRIVATE LIMITED",
"PAGE GARMENT EXPORTS PRIVATE LIMITED",
"PAGE INDUSTRIES LIMITED",
"PAGE JUNIOR COLLEGE",
"PAGE SOLUTIONS PRIVATE LIMITED",
"PAGE-3 MEDIA & ENTERTAINMENT PRIVATE LIMITED",
"PAGES CONSULTANCY PRIVATE LIMITED",
"PAGESTITCH TECHNOLOGY PRIVATE LIMITED",
"PAGESUITE (INDIA) PRIVATE LIMITED",
"PAGETRAFFIC WEB-TECH PRIVATE LIMITED",
"PAGEWORK INDIA PRIVATE LIMITED",
"PAGODA CABLES PRIVATE LIMITED",
"PAGODA ENGINEERING PRIVATE LIMITED",
"PAGODA REALTORS PRIVATE LIMITED",
"PAGODA STEELS PRIVATE LIMITED",
"PAGONXT MERCHANT SOLUTIONS INDIA PRIVATE LIMITED",
"PAGRO FROZEN FOODS PRIVATE LIMITED",
"PAHADI GOODNESS PRIVATE LIMITED",
"PAHADI MARKETING PRIVATE LIMITED",
"PAHADIA VANIJYA PRIVATE LIMITED",
"PAHADIYA COMMERCIAL LIMITED",
"PAHAL ARTIFICIAL AND LADIES SHOPEE",
"PAHAL ENGINEERS",
"PAHAL ENTERPRISES",
"PAHAL FINANCIAL SERVICES PRIVATE LIMITED",
"PAHAR PLASTIC INDUSTRIES PRIVATE LIMITED",
"PAHARGOOMIAH TEA INDUSTRIES PRIVATE LIMITED",
"PAHARI MATA CREATIONS PRIVATE LIMITED",
"PAHARI MATA ROLLER FLOUR MILLS PVT LTD",
"PAHARIMATA AGRO TRADING LIMITED",
"PAHARIMATA COMMODITIES PVT.LTD.",
"PAHARIMATA ENGINEERING PRIVATE LIMITED",
"PAHARIMATA PACKAGING PRIVATE LIMITED",
"PAHARIMATA TRADING & INVESTMENT PRIVATE LIMITED",
"PAHARIMATA WAREHOUSES PRIVATE LIMITED",
"PAHARPUR 3P UNIT II PRIVATE LIMITED",
"PAHARPUR COOLING TOWERS LTD",
"PAHARPUR INDUSTRIES LIMITED",
"PAHARPUR-PRAGNYA TECH PARK PRIVATE LIMITED",
"PAHINI JEWELLERY PRIVATE LIMITED",
"PAHIRA STEEL & TUBES PRIVATE LIMITED",
"PAHIYA SERVICES PRIVATE LIMITED",
"PAHLADRAI CONFECTIONERIES PRIVATE LIMITED",
"PAHLAJANI DEVELOPERS PRIVATE LIMITED",
"PAHUJA AIRCON PRIVATE LIMITED",
"PAHUJA HOMES PRIVATE LIMITED",
"PAHUJA SEEDS PRIVATE LIMITED",
"PAHWA AUTOWORLD PRIVATE LIMITED",
"PAHWA BUILDCON PRIVATE LIMITED",
"PAHWA BUILDTECH PRIVATE LIMITED",
"PAHWA BUILDWELL PRIVATE LIMITED",
"PAHWA CHAINS PVT LTD",
"PAHWA CLOTHING PRIVATE LIMITED",
"PAHWA FURFABRICS PRIVATE LIMITED",
"PAHWA METALTECH PRIVATE LIMITED",
"PAHWA PLASTICS PRIVATE LIMITED",
"PAI AND PAI CHEMICALS INIDA PRIVATE LIMITED",
"PAI AUTOMOBILES PRIVATE LIMITED",
"PAI BROTHERS ENGINEERS PRIVATE LIMITED",
"PAI CELL SALES PRIVATE LIMITED",
"PAI CONSTRUCTION INDIA PRIVATE LIMITED",
"PAI CRISTAL INDIA PRIVATE LIMITED",
"PAI INTERNATIONAL ELECTRONICS LIMITED",
"PAI MANASA RESIDENCY PRIVATE LIMITED",
"PAI SALES PRIVATE LIMITED",
"PAI VAIBHAV HOTELS (INDIA) PRIVATE LIMITED",
"PAI VETERINARY PRODUCTS PRIVATE LIMITED",
"PAIKAR REAL ESTATES PRIVATE LIMITED",
"PAIN RELIEF AND PALLIATIVE CARE SOCIETY",
"PAINT BRUSH LIMITED",
"PAINTMYTRIP.COM OTA PRIVATE LIMITED",
"PAINTS AND COATINGS SKILL COUNCIL",
"PAINUTHARA TRADES PRIVATE LIMITED",
"PAIR AGROKING PRIVATE LIMITED",
"PAIR ENGINEERS PRIVATE LIMITED",
"PAIR SOFTECH INDIA PRIVATE LIMITED",
"PAIRAN PYROLYSIS PRIVATE LIMITED",
"PAIRSYS INFOTECH PRIVATE LIMITED",
"PAIS AUTO PRIVATE LIMITED",
"PAISABAZAAR MARKETING AND CONSULTING PRIVATE LIMITED",
"PAISABOX ECOMMERCE PRIVATE LIMITED",
"PAISABUDDY FINANCE PRIVATE LIMITED",
"PAISALO DIGITAL LIMITED",
"PAISHING PACKAGING VENTURES PRIVATE LIMITED",
"PAISLEY EXPORTS PRIVATE LIMITED",
"PAISSO TECHNOLOGY PRIVATE LIMITED",
"PAIT BIZ SYSTEMS PRIVATE LIMITED",
"PAITHAN MEGA FOOD PARK PRIVATE LIMITED",
"PAIVA ENGINEERING PRIVATE LIMITED",
"PAIX TECHNOLOGIES PRIVATE LIMITED",
"PAIYUR FRUIT PRODUCTS PRIVATE LIMITED",
"PAKHI ADHESIVE TAPE PRIVATE LIMITED",
"PAKHI MERCANTILES PRIVATE LIMITED",
"PAKIRA EXPORT PRIVATE LIMITED",
"PAKIZA FASHIONS PVT LTD",
"PAKIZA RETAIL PRIVATE LIMITED",
"PAKKA TRADING PRIVATE LIMITED",
"PAKKAPROFILE PSYCHOMETRICS PRIVATE LIMITED",
"PAKRI TECH PRIVATE LIMITED",
"PAKS FOODS PRIVATE LIMITED",
"PAKSH DEVELOPERS PRIVATE LIMITED",
"PAKSHAL IMPEX PRIVATE LIMITED",
"PAKSON INDIA PRIVATE LIMITED",
"PAKSONS PHARMACEUTICALS PRIVATE LIMITED",
"PAKWARASA KARYA PRIVATE LIMITED",
"PAL ALLOY & STEELCASTING PRIVATE LIMITED",
"PAL AND PAL INFRASTRUCTURES PRIVATE LIMITED",
"PAL AND PAUL BUILDERS LIMITED",
"PAL AUTOMOTIVES PRIVATE LIMITED",
"PAL CEMENT AND STEEL PRIVATE LIMITED",
"PAL CHEMICALS PRIVATE LIMITED",
"PAL ELECTRICALS PRIVATE.LIMITED",
"PAL FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"PAL FASHIONS PRIVATE LIMITED",
"PAL FILAMENT PRIVATE LIMITED",
"PAL HOSPITAL",
"PAL INFOCOM TECHNOLOGIES PRIVATE LIMITED",
"PAL INNOVATIONS PVT LTD",
"PAL INTERNATIONAL REALTORS AND TRADERS PRIVATE LIMITED",
"PAL JAY AUTOMOBILES PRIVATE LIMITED",
"PAL LIFEWARE PRIVATE LIMITED",
"PAL MINERAL INDUSTRIES PRIVATE LIMITED",
"PAL MOVERS PRIVATE LIMITED",
"PAL PAR VENTURE PRIVATE LIMITED",
"PAL PRATEEK AUTO SALES PRIVATE LIMITED",
"PAL PRATEEK MOTORS PRIVATE LIMITED",
"PAL RESORTS PRIVATE LIMITED",
"PAL ROAD CARRIERS PRIVATE LIMITED",
"PAL ROLLER FLOUR MILLS PVT LTD",
"PAL S AGRO INDUSTRIES PVT LTD",
"PAL SALES & SERVICE PRIVATE LIMITED",
"PAL SHELLCAST PRIVATE LIMITED",
"PAL STONE INDUSTRIES PRIVATE LIMITED",
"PAL SVAM POWER SOLUTIONS PRIVATE LIMITED",
"PAL TECHNOLOGY PRIVATE LIMITED",
"PAL TRAVELS PRIVATE LIMITED",
"PALAASH VENTURES PRIVATE LIMITED",
"PALACE HOSPITAL PRIVATE LIMITED",
"PALACE JEWELLERS PRIVATE LIMITED",
"PALACE SOLAR ENERGY PRIVATE LIMITED",
"PALACEIO PROPERTY DEVELOPERS PRIVATE LIMITED",
"PALADIN PAINTS AND CHEMICALS PRIVATE LIMITED",
"PALADION NETWORKS PRIVATE LIMITED",
"PALADUGU ENTERPRISES PRIVATE LIMITED",
"PALADUGU PIPES & TUBES PRIVATE LIMITED",
"PALAGIC MARITIME SERVICES PRIVATE LIMITED",
"PALAK AGENCY PRIVATE LIMITED",
"PALAK COOL CONNEXION PRIVATE LIMITED",
"PALAK FASHION PRIVATE LIMITED",
"PALAK FERRO ALLOYS",
"PALAK FOREX PRIVATE LIMITED",
"PALAK INFOTECH PRIVATE LIMITED",
"PALAK INFRA PRIVATE LIMITED",
"PALAK INTERMEDIATES PRIVATE LIMITED",
"PALAK JEWELLERS PRIVATE LIMITED",
"PALAK LOGISTICS PRIVATE LIMITED",
"PALAK ORCHID PRIVATE LIMITED",
"PALAK PLASTIC PRIVATE LIMITED",
"PALAK SUPERMARKET",
"PALAK TAPES PRIVATE LIMITED",
"PALAKKAD ENGINEERING KERALA PRIVATE LIMITED",
"PALAKKAD GRANITE SANDS PRIVATE LIMITED",
"PALAKKAD MEDICAL AND RESEARCH CENTRE LTD",
"PALAKKAD RUBBER PVT LTD",
"PALAKKAD STEELS PVT LTD",
"PALAKKAD SURGICAL INDUSTRIES PRIVATE LIMITED",
"PALAKKAL GRANITE PRODUCTS PRIVATE LIMITED",
"PALAKKANDY STEELS PRIVATE LIMITED",
"PALAKSHREE FORESIGHTS LIMITED",
"PALAL MOBILITY PRIVATE LIMITED",
"PALAM PHARMA PRIVATE LIMITED",
"PALAM PLASTICS PRIVATE LIMITED",
"PALAM SECURITY DEVICES PRIVATE LIMITED",
"PALAMOOR DIGITAL MEDIA PRIVATE LIMITED",
"PALAMOOR SEEDS PRIVATE LIMITED",
"PALAMUR BIOSCIENCES PRIVATE LIMITED",
"PALAMURU UNIVERSITY",
"PALAN REALTY PRIVATE LIMITED",
"PALAN-G INDUSTRIES PRIVATE LIMITED",
"PALANI ANDAVAR FEEDS PRIVATE LIMITED",
"PALANI MUTHU TEXTILES PRIVATE LIMITED",
"PALANI VIJAY COTTSPIN PRIVATE LIMITED",
"PALANIAPPA INTERTNATIONAL SCHOOL",
"PALANIAPPA'S MOTORS PRIVATE LIMITED",
"PALANIVELSRI BLUE METALLS INDIA PRIVATE LIMITED",
"PALANNTECH INDIA PRIVATE LIMITED",
"PALANPUR ENGINEERING AND FABRICATIONS LIMITED",
"PALANPUR HOLDINGS AND INVESTMENTS PRIVATE LTD",
"PALANPUR TRADERS LTD",
"PALANQUIN INVESTMENTS PRIVATE LIMITED",
"PALANTIR ECONOMIC SOLUTIONS INDIA PRIVATE LIMITED",
"PALANTUS INFRATECH PRIVATE LIMITED",
"PALAPARTHI SUPER SPECIALITY HOSPITALS PRIVATE LIMITED",
"PALAPPILLIL SPECIFIED BLOCK RUBBERS PRIVATE LIMITED",
"PALAS PHARMACEUTICALS PRIVATE LIMITED",
"PALAS SOFTWARE PRIVATE LIMITED",
"PALASH CARS PRIVATE LIMITED",
"PALASH COLOURS PRIVATE LIMITED",
"PALASH HEALTHCARE SYSTEMS PRIVATE LIMITED",
"PALASH INTERNATIONAL PRIVATE LIMITED",
"PALASH UDYOG FOODS PRIVATE LIMITED",
"PALATHRA CONSTRUCTIONS PRIVATE LIMITED",
"PALATHRA INTERLOCKS PRIVATE LIMITED",
"PALATHRA TELECOM INFRASTRUCTURE PRIVATE LIMITED",
"PALATIAL BUILDERS PRIVATE LIMITED",
"PALATIAL GOLD ORNAMENTS PRIVATE LIMITED",
"PALAV ENERGY PRIVATE LIMITED",
"PALAVA CITY MANAGEMENT PRIVATE LIMITED",
"PALAVALA CONSTRUCTIONS PRIVATE LIMITED",
"PALAVE PATIL REALTY PRIVATE LIMITED",
"PALAVELLI BOUTIQUE RESORTS PRIVATE LIMITED",
"PALAZHY LATEX PVT LTD",
"PALAZZO HOME DESIGNS PRIVATE LIMITED",
"PALAZZO INFOTECH AND LEASING PRIVATE LIMITED",
"PALAZZO INN SERVICES PRIVATE LIMITED",
"PALBRO INDUSTRIES PRIVATE LIMITED",
"PALC NETWORKS PRIVATE LIMITED",
"PALCO ENTERPRISES PRIVATE LIMITED",
"PALCO RECYCLE INDUSTRIES LIMITED",
"PALCO TEX FAB LIMITED",
"PALDEWAR PRASHANT AGRO TECH PRIVATE LIMITED",
"PALE HOLDINGS PRIVATE LIMITED",
"PALECHA TRADE SERVICES PRIVATE LIMITED",
"PALEDIUM SECURITY SERVICES LLP",
"PALEKAR BAKERY PRIVATE LIMITED",
"PALEKAR FOOD PRODUCTS PVT LTD",
"PALEO CRYSTAL ENVIRO TECHNOLOGIES PRIVATE LIMITED",
"PALEPU PHARMA PRIVATE LIMITED",
"PALETTE HOTELS INDIA PRIVATE LIMITED",
"PALEX EXPRESS SERVICES PRIVATE LIMITED",
"PALFINGER CRANES INDIA PRIVATE LIMITED",
"PALGER-Q TRADING PRIVATE LIMITED",
"PALGHAR COIL PRODUCTS PRIVATE LIMITED",
"PALGHAR PLYWOOD PRODUCTS PVT LTD",
"PALGHAR ROAD PROJECT PRIVATE LIMITED",
"PALGOTTA METAL PRIVATE LIMITED",
"PALI AD N CLICK PVT LTD",
"PALI HILLS TOURIST HOTEL PRIVATE LIMITED",
"PALI INTER COLLEGE",
"PALI MEDIA PRIVATE LIMITED",
"PALI OIL PRODUCTS PRIVATE LIMITED",
"PALI RESORT AND CLUB PRIVATE LIMITED",
"PALI TRANSLINES PRIVATE LIMITED",
"PALIKA HOTELS PRIVATE LIMITED",
"PALIKA VINAYAK HOSPITAL PRIVATE LIMITED",
"PALIMARWAR SOLAR HOUSE PRIVATE LIMITED",
"PALIMARWAR SOLAR PROJECT PRIVATE LIMITED",
"PALINDROME MEDIA PRIVATE LIMITED",
"PALIS ECO VEHICLES PRIVATE LIMITED",
"PALISANDR HANDICRAFTS PRIVATE LIMITED",
"PALISONS PRIVATE LIMITED",
"PALIWAL DEVELOPERS LIMITED",
"PALIWAL DIAGNOSTICS PRIVATE LIMITED",
"PALIWAL EYE HOSPITAL",
"PALIWAL FIBRES PRIVATE LIMITED",
"PALIWAL FOODS PRIVATE LIMITED",
"PALIWAL HOTELS PRIVATE LTD",
"PALIWAL INFRASTRUCTURE PRIVATE LIMITED",
"PALIWAL LIFE SCIENCE INDIA PRIVATE LIMITED",
"PALIWAL MEDICARE PRIVATE LIMITED",
"PALIWAL MILK PRODUCTS PRIVATE LIMITED",
"PALIWAL OVERSEAS PRIVATE LIMITED",
"PALIWAL REAL ESTATE LIMITED",
"PALIWAL SONS DAIRY PRIVATE LIMITED",
"PALKANI TRADE AGENCY PRIVATE LIMITED",
"PALKI FASHION PRIVATE LIMITED",
"PALKI FOODS INDIA PRIVATE LIMITED",
"PALKI INDUSTRIES PRIVATE LIMITED",
"PALKIT IMPEX PRIVATE LIMITED",
"PALL INDIA PRIVATE LIMITED",
"PALLA VAJARA KIRAN TEXTILES PRIVATE LIMITED",
"PALLADAM HI-TECH WEAVING PARK",
"PALLADIAN HOTELS PRIVATE LIMITED",
"PALLADIUM CONSTRUCTIONS PRIVATE LIMITED",
"PALLADIUM CONSULTING INDIA PRIVATE LIMITED",
"PALLADIUM PRODUCTS",
"PALLADIUM SAFETY SOLUTIONS PRIVATE LIMITED",
"PALLAKAD DISTRICT CO-OP BANK",
"PALLAKKI NDT EXCELLENCE CENTER PRIVATE LIMITED",
"PALLAS FINCAP PRIVATE LIMITED",
"PALLATTIL AGRI GARDENS PRIVATE LIMITED",
"PALLAV CHEMICALS & SOLVENTS PRIVATE LIMITED",
"PALLAVA FINE FAB PRIVATE LIMITED",
"PALLAVA GRANITE INDUSTRIES (INDIA) PRIVATE LIMITED",
"PALLAVA GRANITE INDUSTRIES CHENNAI PRIVATE LIMITED",
"PALLAVA HOSPITAL PRIVATE LIMITED",
"PALLAVA SPINNING MILLS PRIVATE LIMITED",
"PALLAVA TEXTILES PRIVATE LIMITED",
"PALLAVAN COLLEGE-KANCHEEPURAM",
"PALLAVAN GRAMA BANK",
"PALLAVAN PHARMACY COLLEGE IYYENGARKULAM",
"PALLAVAN POLYTECHNIC COLLEGE IYYENGARKU",
"PALLAVAN TRANSPORT CONSULTANCY SERV",
"PALLAVARAM TANNERS INDUSTRIAL EFFLUENT TREATMENT COMPANY LIMITED",
"PALLAVARED GRANITE PRIVATE LIMITED",
"PALLAVI ADVERTISING PRIVATE LIMITED",
"PALLAVI AWARE INTERNATIONAL SCHOOL",
"PALLAVI AWARE SCHOOL",
"PALLAVI COPPER PIPES PRIVATE LIMITED",
"PALLAVI EDUCOM MANAGEMENT SERVICES LIMITED",
"PALLAVI ENGINEERING COLLEGE",
"PALLAVI ENTERPRISES",
"PALLAVI INTERNATIONAL PRIVATE LIMITED",
"PALLAVI INTERNATIONAL SCHOOL",
"PALLAVI MODEL SCHOOL",
"PALLAVI MOTORS PRIVATE LIMITED",
"PALLAVI REAL ESTATES PVT LTD",
"PALLAVI RETAIL PRIVATE LIMITED",
"PALLAVI SYNDICATE PRIVATE LIMITED",
"PALLAVOOR HI-TECH AGRO MILLS PRIVATE LIMITED",
"PALLAWI RESOURCES PRIVATE LIMITED",
"PALLAZZIO HOTELS & LEISURE LIMITED",
"PALLETTE ARTS PRIVATE LIMITED",
"PALLI PRAGOTI FINANCIAL SERVICES PRIVATE LIMITED",
"PALLIA TRANS LOGISTICS PRIVATE LIMITED",
"PALLIATIVE CARE HOSPITAL",
"PALLICHIRA MEDLOUNGES HEALTHCARE PRIVATE LIMITED",
"PALLICKAL ROLLER FLOUR MILLS PRIVATE LIMITED",
"PALLICKAMALIL CINEMA COMPANY PRIVATE LIMITED",
"PALLIPALAYAM SPINNERS PRIVATE LIMITED",
"PALLISHREE AGRI BIOTECH PRIVATE LIMITED",
"PALLISHREE LTD",
"PALLIUM MARKETING PRIVATE LIMITED",
"PALLONJI LEASING PVT LIMITED",
"PALLORBUND TEA LIMITED",
"PALM ALLOY STEELS PVT LTD",
"PALM ART APPARELS PRIVATE LIMITED",
"PALM BEACH INVESTMMENTS PRIVATE LIMITED",
"PALM FIBRE INDIA PRIVATE LIMITED",
"PALM GROVE BEACH HOTELS PRIVATE LIMITED",
"PALM INFRACON PRIVATE LIMITED",
"PALM INSURANCE BROKERS PRIVATE LIMITED",
"PALM JEWELS LIMITED",
"PALM LAND HOSPITALITY PRIVATE LIMITED",
"PALM MASON INDIA PRIVATE LIMITED",
"PALM STREET INFRASTRUCTURE & DEVELOPERS PRIVATE LIMITED",
"PALMA GUMLA HIGHWAY PRIVATE LIMITED",
"PALMARY PROJECT & SERVICES PRIVATE LIMITED",
"PALME POLYPACK PRIVATE LIMITED",
"PALMERA REALCON PRIVATE LIMITED",
"PALMFLEX PACKAGING PRIVATE LIMITED",
"PALMG PROJECTS (OPC) PRIVATE LIMITED",
"PALMGOLD AMUSEMENTS AND LEISURE (INDIA) PRIVATE LIMITED",
"PALMIRO TECHNOLOGIES PRIVATE LIMITED",
"PALMO INDUSTRIAL SILICONES PRIVATE LIMITED",
"PALMORE LUXURY DEVELOPERS PRIVATE LIMITED",
"PALMOTOR WAYS PRIVATE LIMITED",
"PALMSPRING MATTRESSES PRIVATE LIMITED",
"PALMY FOOD PRODUCTS PRIVATE LIMITED",
"PALMYRA RESORTS PRIVATE LIMITED",
"PALMYRAH MICRO FINANCE",
"PALNADU INFRASTRUCTURE PRIVATE LIMITED",
"PALNADU SOLAR POWER PRIVATE LIMITED",
"PALNAR CONSULTING SERVICES PRIVATE LIMITED",
"PALNAR TRANSMEDIA PRIVATE LIMITED",
"PALNI INDIA PRIVATE LIMITED",
"PALO ALTO NETWORKS (INDIA) TECHNOLOGIES PRIVATE LIMITED",
"PALO ALTO NETWORKS INDIA PRIVATE LIMITED",
"PALOD ENTERPRISES PRIVATE LIMITED",
"PALOD HIMSON MACHINES PRIVATE LIMITED",
"PALOMA FOODJOINT (OPC) PRIVATE LIMITED",
"PALOMA TURNING CO PRIVATE LIMITED",
"PALOMINO HOSPITALITY PRIVATE LIMITED",
"PALRA CONECRUSHER PRIVATE LIMITED",
"PALRAM INDIA PRIVATE LIMITED",
"PALREAL NIRMAN PRIVATE LIMITED",
"PALRECHA CABLES INDUSTRIES PRIVATE LIMITED",
"PALRED ELECTRONICS PRIVATE LIMITED",
"PALRED TECHNOLOGIES LIMITED",
"PALRIWAL CHEMICALS PRIVATE LIMITED",
"PALRIWAL INDUSTRIES PRIVATE. LIMITED.",
"PALS AND PEERS ENTERTAINMENT PRIVATE LIMITED",
"PALS JEWELS PRIVATE LIMITED",
"PALS PLUSH INDIA PRIVATE LIMITED",
"PALSANA ENVIRO PROTECTION LIMITED",
"PALSANA INFRASTRUCTURE PRIVATE LIMITED",
"PALSANA INVESTMENTS ADVISORY PRIVATE LIMITED",
"PALSANI JEWELLERS PRIVATE LIMITED",
"PALSHELLCAST PRIVATE LIMITED",
"PALSONS AUTOMOTIVE PRIVATE LIMITED",
"PALSONS SERVICES PVT LTD",
"PALUCK CREATION PRIVATE LIMITED",
"PALUCK TECHNOLOGIES LIMITED",
"PALUCK TECHNOLOGIES PRIVATE LIMITED",
"PALURI CHEMICALS PRIVATE LIMITED",
"PALUS SAHAKARI BANK LIMITED",
"PALUS SAHAKARI BANK LTD",
"PALVI INDUSTRIES LIMITED",
"PALVIT HOMES PRIVATE LIMITED",
"PALWE PEST CONTROL PRIVATE LIMITED",
"PALYA FOOTWEAR PRIVATE LIMITED",
"PALZ HOSPITALITY PRIVATE LIMITED",
"PAM COSMETICS AND GLASSES PRIVATE LIMITED",
"PAM SYSTEMS PRIVATE LIMITED",
"PAM TECHNOLOGIES PRIVATE LIMITED",
"PAMA ENGINEERING SERVICES",
"PAMA MACHINE TOOLS INDIA PRIVATE LIMITED",
"PAMAC FINSERVE PRIVATE LIMITED",
"PAMAN DAS & COMPANY",
"PAMAS HOLDINGS PRIVATE LIMITED",
"PAMAS PARTICLE COUNTERS INDIA PRIVATE LIMITED",
"PAMASA AGRO INDUSTRIES PRIVATE LIMITED",
"PAMBA RUBBERS LTD",
"PAMCO FOODS PVT LTD",
"PAMCON ENGINEERS PRIVATE LTD",
"PAMG HEALTHBUDDY SERVICES PRIVATE LIMITED",
"PAMIDI RSB BUILD-TECH PRIVATE LIMITED",
"PAMM ADVERTISING & MARKETING",
"PAMMVI AVIATION PRIVATE LIMITED",
"PAMMVI EXPORTS PRIVATE LIMITED",
"PAMOSA INTERNATIONAL MARKETING PRIVATE LIMITED",
"PAMP PRECISION MANUFACTURING INDIA PRIVATE LIMITED",
"PAMP TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"PAMPA AGRO PRODUCTS PRIVATE LIMITED",
"PAMPAR OVENFRESH FOODS PRIVATE LIMITED",
"PAMPOSH CHEMICALS PRIVATE LIMITED",
"PAMPOSH CONSTRUCTIONS (INDIA) PRIVATE LIMITED",
"PAMR INDUSTRIES PRIVATE LIMITED",
"PAMS BEVERAGES PRIVATE LIMITED",
"PAMTEC ENVIRO SYSTEMS PRIVATE LIMITED",
"PAMTEN SOFTWARE SOLUTIONS PRIVATE LIMITED",
"PAMURU MILKLINE PRIVATE LIMITED",
"PAMVI HOSPITALITY LIMITED",
"PAN ASIA FREIGHT FORWARDING & LOGISTICS INDIA PRIVATE LIMITED",
"PAN ASIA HOSPITALS PRIVATE LIMITED",
"PAN ASIA HR SOLUTION PRIVATE LIMITED",
"PAN ASIA LOGISTICS PRIVATE LIMITED",
"PAN ASIA STEELS PRIVATE LIMITED",
"PAN BAHAR PRODUCTS PRIVATE LIMITED",
"PAN BAN ASSOCIATES PRIVATE LIMITED",
"PAN BUSINESS LISTS PRIVATE LIMITED",
"PAN COMMUNICATIONS PVT LTD",
"PAN DRUGS LIMITED",
"PAN ELECTRICALS PRIVATE LIMITED",
"PAN ELECTRONICS (INDIA) LIMITED",
"PAN EMAMI COSMED LIMITED",
"PAN EX LOGISTICS PRIVATE LIMITED",
"PAN GLOBAL FABRICS PRIVATE LIMITED",
"PAN GUJARAT SPORTSWEAR PRIVATE LIMITED",
"PAN GULF TECHNOLOGIES PRIVATE LIMITED",
"PAN HEALTHCARE PRIVATE LIMITED",
"PAN HR SOLUTION PRIVATE LIMITED",
"PAN INDIA CONSULTANTS PRIVATE LIMITED",
"PAN INDIA FOOD SOLUTIONS PRIVATE LIMITED",
"PAN INDIA FOODS PRIVATE LIMITED",
"PAN INDIA INTERNET PRIVATE LIMITED",
"PAN INDIA NETWORK INFRAVEST LIMITED",
"PAN INDIA PARYATAN PRIVATE LIMITED",
"PAN INTELLECOM LIMITED",
"PAN MACMILLAN PUBLISHING INDIA PRIVATE LIMITED",
"PAN NAGARABHAVI HOSPITALS PRIVATE LIMITED",
"PAN OCEANIC SEED SOLUTIONS PRIVATE LIMITED",
"PAN OFFICE SYSTEMS PRIVATE LIMITED",
"PAN OLEO ENERGY LIMITED",
"PAN OLEO ENTERPRISE PRIVATE LIMITED",
"PAN PACIFIC ENGINEERING SERVICES PRIVATE LIMITED",
"PAN PARAG INDIA LIMITED",
"PAN PLAST PRIVATE LIMITED",
"PAN SEEDS PRIVATE LIMITED",
"PAN SOLUTIONS PRIVATE LIMITED",
"PAN SYNTHETICS PRIVATE LIMITED",
"PAN TECH POLYCOATS PRIVATE LIMITED",
"PAN TEX NONWOVEN PRIVATE LIMITED",
"PAN TIME FINANCE COMPANY PRIVATE. LIMITED.",
"PAN TRADEXPO PRIVATE LIMITED",
"PANA ENGINEERING PRIVATE LIMITED",
"PANACEA ALLOYS PRIVATE LIMITED",
"PANACEA BIOTEC LIMITED",
"PANACEA BIOTEC PHARMA LIMITED",
"PANACEA DIGITAL SYSTEMS PRIVATE LIMITED",
"PANACEA FACILITIES PRIVATE LIMITED",
"PANACEA FILMS PRIVATE LIMITED",
"PANACEA FUTURESOLUTIONS PRIVATE LIMITED",
"PANACEA INFOSEC PRIVATE LIMITED",
"PANACEA INFOTECH PRIVATE LIMITED",
"PANACEA LIFE SCIENCES LIMITED",
"PANACEA MEDICAL TECHNOLOGIES PRIVATE LIMITED",
"PANACEA MERIDIAN HOSPITAL",
"PANACEA PHYTOEXTRACTS PRIVATE LIMITED",
"PANACEA SPICES (INDIA) PRIVATE LIMITED",
"PANACEA WOMEN AND HEART CARE CENTRE PRIVATE LIMITED",
"PANACEALIFE HEALTHZONE PRIVATE LIMITED",
"PANACEAN CONNECTIONS PRIVATE LIMITED",
"PANACEAN ENTERPRISE PRIVATE LIMITED",
"PANACHE DEALTRADE PRIVATE LIMITED",
"PANACHE DEVELOPER PRIVATE LIMITED",
"PANACHE DIGILIFE LIMITED",
"PANACHE GREENTECH SOLUTIONS PRIVATE LIMITED",
"PANACHE INFRASTRUCTURE PRIVATE LIMITED",
"PANACHE INNOVATIONS LIMITED",
"PANACHE NATURAL FOODS PRIVATE LIMITED",
"PANACHE PROMOTIONS PRIVATE LIMITED",
"PANACHE RESORTS PRIVATE LIMITED",
"PANACHE TRADE LAND PRIVATE LIMITED",
"PANACIA HEALTH CARE PRIVATE LIMITED",
"PANACOR MANAGEMENT SERVICES PRIVATE LIMITED",
"PANAGARH ENGINEERING WORKS (PATNA) PRIVATE LTD.",
"PANALFA ENTERPRISES PRIVATE LIMITED",
"PANALINK INFOTECH LIMITED",
"PANALPINA GLOBAL BUSINESS SERVICES INDIA PRIVATE LIMITED",
"PANALPINA WORLD TRANSPORT INDIA PRIVATE LIMITED",
"PANAM BIOCHEM INDIA PRIVATE LIMITED",
"PANAM ENGINEERS LIMITED",
"PANAM FOODS PRIVATE LIMITED",
"PANAM HOLIDAYS AND RESORTS PRIVATE LIMITED",
"PANAM PROJECTS PRIVATE LIMITED",
"PANAM TEXFAB PRIVATE LIMITED",
"PANAMA AGRICULTURE PRIVATE LIMITED",
"PANAMA HOLDING PRIVATE LIMITED",
"PANAMA PAPERS PRIVATE LIMITED",
"PANAMA PETROCHEM LIMITED",
"PANAMA PROPERTIES PRIVATE LIMITED",
"PANAMA RENEWABLE ENERGY PRIVATE LIMITED",
"PANAMA WIND ENERGY DEVELOPERS PRIVATE LIMITED",
"PANAMA WIND ENERGY GODAWARI PRIVATE LIMITED",
"PANAMA WIND ENERGY PRIVATE LIMITED",
"PANAMAX INFOTECH LIMITED",
"PANAMAX LIMITED",
"PANAMBI VACATIONS PRIVATE LIMITED",
"PANAMETRICS ENGINEERING PRIVATE LIMITED",
"PANARA CERAMIC PRIVATE LIMITED",
"PANARA LAMINATE PRIVATE LIMITED",
"PANARIAGROUP INDIA INDUSTRIE CERAMICHE PRIVATE LIMITED",
"PANAROMIC TECHNOLOGIES PRIVATE LIMITED",
"PANASA WEB SOLUTIONS PRIVATE LIMITED",
"PANASIA ENGINEERS PRIVATE LIMITED",
"PANASIA HERBAL PRIVATE LIMITED",
"PAN-ASIA PETROLEUM PRIVATE LIMITED",
"PANASIAN CONSTRUCTION COMPANY PRIVATE LIMITED",
"PANASIAN IMPEX PRIVATE LIMITED",
"PANASONIC APPLIANCES INDIA CO. LIMITED",
"PANASONIC APPLIANCES INDIA COMPANY LIMITED",
"PANASONIC CARBON INDIA CO. LIMITED",
"PANASONIC CONSUMER INDIA PRIVATE LIMITED",
"PANASONIC ENERGY INDIA COMPANY LIMITED",
"PANAT HOSPITAL PRIVATE LIMITED",
"PANATONE FINVEST LIMITED",
"PANAV POLY TRADES PRIVATE LIMITED",
"PANAV TEXTILES PRIVATE LIMITED",
"PANAYA EDUCATION PRIVATE LIMITED",
"PANAZAN ENTERPRISES PRIVATE LIMITED",
"PANBASE RESOURCES PRIVATE LIMITED",
"PANBRO AVS PRIVATE LIMITED",
"PANCARBO GREENFUELS PRIVATE LIMITED",
"PANCAYAT SAMITEE MALEGAON",
"PANCH MOHAN CHEMICALS PRIVATE LIMITED",
"PANCH PARGANA KISAN COLLEGE BUNDU",
"PANCH RATNA HOSPITALITY SERVICES PRIVATE LIMITED",
"PANCH TATVA PROMOTERS PRIVATE LIMITED",
"PANCHAGANGA BIO-TECH PRIVATE LIMITED",
"PANCHAGANGA FARM SOLUTIONS PRIVATE LIMITED",
"PANCHAGANGA ROLLER FLOUR MILLS PRIVATE LIMITED",
"PANCHAGANGA SEEDS PRIVATE LIMITED",
"PANCHAJANYA ASSOCIATES PRIVATE LIMITED",
"PANCHAJANYA SERVICES PRIVATE LIMITED",
"PANCHAJANYA TRUST",
"PANCHAKROSHI MADHYAMIK VA UCCHAMADHYAMIK VIDHYALAY JAVALE LOHOM PHATA",
"PANCHAL ENGINEERS INDIA PRIVATE LIMITED",
"PANCHAL ENTERPRISES PRIVATE LIMITED",
"PANCHAL EXIM PRIVATE LIMITED",
"PANCHAL FABRICATORS PRIVATE LIMITED",
"PANCHAL MANUFACTURING CO PRIVATE LIMITED",
"PANCHAL MECHANICALS PRIVATE LIMITED",
"PANCHAL MEDITECH PRIVATE LIMITED",
"PANCHAL MEDITECH PVT LTD",
"PANCHAL PLASTIC MACHINERY PRIVATE LIMITED",
"PANCHAM AQUACULTURE FARMS LIMITED",
"PANCHAM HOSPITALS PRIVATE LIMITED",
"PANCHAM NISHAD CREATIVES PRIVATE LIMITED",
"PANCHAM PLYWOOD PRIVATE LIMITED",
"PANCHAM TECHNO PET PRIVATE LIMITED",
"PANCHAMI ELECTRONICS PRIVATE LIMITED",
"PANCHAMI PIPES PRIVATE LIMITED",
"PANCHAMRUT CHEMICALS PVT LTD",
"PANCHAMRUT ENTERPRISE PRIVATE LIMITED",
"PANCHAMRUTHA INDUSTRIES PRIVATE LIMITED",
"PANCHAMUKHI ENTERPRISES",
"PANCHAMUKI AUTOMOTIVE MOTORS PRIVATE LIMITED",
"PANCHANAN COLD STORAGE PVT LTD",
"PANCHANAN INTERIORS PRIVATE LIMITED",
"PANCHANAN INTERNATIONAL P LIMITED",
"PANCHANAN RICE MILL PVT LTD",
"PANCHARATHNA INTERNATIONAL PRIVATE LIMITED",
"PANCHARATHNA PLASTIC ENTERPRISES PRIVATE LIMITED",
"PANCHARATNA BUILDCON PRIVATE LIMITED",
"PANCHASHIL INDUSTRIES (NASHIK) PRIVATE LIMITED",
"PANCHATARA INDUSTRIES PRIVATE LIMITED",
"PANCHAVATI ELITE INN PRIVATE LIMITED",
"PANCHAVATI EXPORTS PRIVATE LIMITED",
"PANCHAVATI FACILITIES PRIVATE LIMITED",
"PANCHAVATI POLYFIBRES PRIVATE LIMITED",
"PANCHAY SAMITI RENAPUR",
"PANCHAYAT & RURAL DEVELOPMENT DEPARTMENT",
"PANCHAYAT AND RURAL DEVELOPMENT DEPARTMENT MP",
"PANCHAYAT INTER COLLEGE",
"PANCHAYAT RAJ OFFICE NIZAMABAD",
"PANCHAYAT SAMETI KATOL",
"PANCHAYAT SAMIT SAKOLI",
"PANCHAYAT SAMITEE KALMESHWAR",
"PANCHAYAT SAMITEE KAMPTEE",
"PANCHAYAT SAMITEE MAUDA",
"PANCHAYAT SAMITEE WADGAON MAVAL",
"PANCHAYAT SAMITHI VASAI",
"PANCHAYAT SAMITI AKKALKUWA",
"PANCHAYAT SAMITI ALIBAG",
"PANCHAYAT SAMITI AUSA",
"PANCHAYAT SAMITI DHADGAON",
"PANCHAYAT SAMITI DHULE",
"PANCHAYAT SAMITI EDUCATION DEPARTMENT AKKALKOT",
"PANCHAYAT SAMITI EDUCATION DEPARTMENT SOUTH SOLAPUR",
"PANCHAYAT SAMITI HINGNA",
"PANCHAYAT SAMITI KALAMB",
"PANCHAYAT SAMITI KALYAN (EDUCATION)",
"PANCHAYAT SAMITI MAVAL",
"PANCHAYAT SAMITI MOHOL",
"PANCHAYAT SAMITI NAGBID",
"PANCHAYAT SAMITI NILANGA",
"PANCHAYAT SAMITI PARNER",
"PANCHAYAT SAMITI PHALASIYA",
"PANCHAYAT SAMITI RALEGAON¬†DIST YAVATMAL",
"PANCHAYAT SAMITI SAMUDRAPUR",
"PANCHAYAT SAMITI SANGANER",
"PANCHAYAT SAMITI SHAHADA",
"PANCHAYAT SAMITI SOUTH SOLAPUR",
"PANCHAYATI RAJ DEPARTMENT",
"PANCHAYITHI RAJ",
"PANCHCROSHI VID MALCHOUNDI",
"PANCHDEEP CONSTRUCTIONS LIMITED.",
"PANCHDEEP COTTON INDUSTRIES PRIVATE LIMITED",
"PANCHDEO COLD STORAGE PRIVATE LIMITED",
"PANCHDEV FOODS AND CHEMICALS PRIVATE LIMITED",
"PANCHGACHIA MANOHARVAHAL KAMALA GIRLS HIGH SCHOOL",
"PANCHGANGA AUTOMOBILES SERVICES PRIVATE LIMITED",
"PANCHGANI ENTERPRISES PRIVATE LIMITED",
"PANCHGAON RESTAURANT VENTURES PRIVATE LIMITED",
"PANCHGOLD INFRA PRIVATE LIMITED",
"PANCHHI FOODS PRIVATE LIMITED",
"PANCHHOR HYDRO POWER PRIVATE LIMITED",
"PANCHJANYA PLY & BOARDS PRIVATE LIMITED",
"PANCHKULA FARMS PRIVATE LIMITED",
"PANCHKULA GOLDWHEELS PRIVATE LIMITED",
"PANCHKULA ROLLER FLOUR MILLS LIMITED",
"PANCHKULA STEEL PVT LTD",
"PANCHLOK MARKETING PRIVATE LIMITED",
"PANCHMAHAL DIES AND TOOLS PVT LTD",
"PANCHMAHAL DIST CO-OPERATIVE MILK PRODUCERS' UNION LTD",
"PANCHMAHAL DISTRICT EDUCATION COMMITTEE MANAGED PRIMARY SCHOOL TEACHER",
"PANCHMAHAL STEEL LTD",
"PANCHMUKHI AIR AND TRAIN AMBULANCE SERVICES PRIVATE LIMITED",
"PANCHMUKHI BALAJI SALES PRIVATE LIMITED",
"PANCHMUKHI COAL AND MINERALS PRIVATE LIMITED",
"PANCHMUKHI GLOBAL AGRO CARE PRIVATE LIMITED",
"PANCHMUKHI JWELLERS PRIVATE LIMITED",
"PANCHMUKHI SUGAR INDUSTRIES PRIVATE LIMITED",
"PANCHMUKHI YARNS & TWINES PRIVATE LIMITED",
"PANCHNATH AUTO PRIVATE LIMITED",
"PANCHRASHI PROPERTIES PRIVATE LIMITED",
"PANCHRATAN STEELS PRIVATE LIMITED",
"PANCHRATNA DELIGHT FARMERS PRODUCER COMPANY LIMITED",
"PANCHRATNA EXTRUSION PRIVATE LIMITED",
"PANCHRATNA JEWELLERS PRIVATE LIMITED",
"PANCHRATNA METAL PROCESSING LIMITED",
"PANCHRATNA PROMOTERS PRIVATE LIMITED",
"PANCHSHEEL BUILDTECH PRIVATE LIMITED",
"PANCHSHEEL CHEMICAL AND MINERAL INDUSTRIES PRIVATE LIMITED",
"PANCHSHEEL FASTNERS PRIVATE LIMITED",
"PANCHSHEEL FILTERS PVT LTD",
"PANCHSHEEL GLOBAL PRIVATE LIMITED",
"PANCHSHEEL H S BALABHAUPETH",
"PANCHSHEEL HOSPITALS PRIVATE LIMITED",
"PANCHSHEEL NURSING HOME PRIVATE LIMITED",
"PANCHSHEEL ORGANICS LIMITED",
"PANCHSHEEL PLASTICS PRIVATE LIMITED",
"PANCHSHEEL PRI MAR SCHOOL",
"PANCHSHEEL REALTECH PRIVATE LIMITED",
"PANCHSHEEL SOLVENT PRIVATE LIMITED",
"PANCHSHEEL VIDYALAYA¬†DAHISATH",
"PANCHSHEEL WIRES PRIVATE LIMITED",
"PANCHSHEELA CONSTRUCTIONS PRIVATE LIMITED",
"PANCHSHEELA PROP-BUILD PRIVATE LIMITED",
"PANCHSHIL CORPORATE PARK PRIVATE LIMITED",
"PANCHSHIL HOTELS PRIVATE LIMITED",
"PANCHSHIL INFRASTRUCTURE HOLDINGS PRIVATE LIMITED",
"PANCHSHIL IT PARK PRIVATE LIMITED",
"PANCHSHIL TECHPARK PRIVATE LIMITED",
"PANCHSHLOK INFRASTRUCTURE PRIVATE LIMITED",
"PANCHSHOOL INFRASTRUCTURES PRIVATE LIMITED",
"PANCHTATWA MILK INDUSTRIES PRIVATE LIMITED",
"PANCHVAKTRAM ENGINEERING PRIVATE LIMITED",
"PANCHVATI HOSPITAL",
"PANCHVATI VALVES AND FLANGES PVT LTD",
"PANCHWATI COLONISER & CONSTRUCTIONS PRIVATE LIMITED",
"PANCHWATI PRAYOGSHALA PRIVATE LIMITED",
"PANCHWATI PROMOTERS PRIVATE LIMITED",
"PANCHYAT SAMITEE BADNAPUR",
"PANCHYAT SAMITEE KHED RAJGURU NAGAR PUNE",
"PANCHYAT SAMITI GANGAPUR",
"PANCO PHARMA PRIVATE LTD",
"PANDA BIO PROTEINS PRIVATE LIMITED",
"PANDA DAIRY PRODUCTS PRIVATE LIMITED",
"PANDA FOODS INDIA PRIVATE LIMITED",
"PANDA INFRASTRUCTURES PRIVATE LIMITED",
"PANDA INFRATECH LIMITED",
"PANDA MEDICALS PRIVATE LIMITED",
"PANDA RETAIL PRIVATE LIMITED",
"PANDA WATER TECH PRIVATE LIMITED",
"PANDAJE WEB SERVICES PRIVATE LIMITED",
"PANDALAI CLINIC & NURSING HOME PRIVATE LIMITED",
"PANDAV COLLEGE OF LIBRARY SCIENCE",
"PANDAV ELECTRICALS PRIVATE LIMITED",
"PANDAV TECHNOLOGY PRIVATE LIMITED",
"PANDE AND GULHANE PRIVATE LIMITED",
"PANDESARA INFRASTRUCTURE LIMITED",
"PANDEX STORAGE SYSTEMS PRIVATE LIMITED",
"PANDEY CHEMICAL PVT LTD",
"PANDEY EARTHWORKS PRIVATE LIMITED",
"PANDEY MOTORS PRIVATE LIMITED",
"PANDEY PETROLEUM PRIVATE LIMITED",
"PANDHARIBAPU GHATBANDHE HIGH SCHOOL",
"PANDI CORRESPONDENTS PRIVATE LIMITED",
"PANDI DEVI OIL PRIVATE LIMITED",
"PANDI STEEL AND ALLOYS PRIVATE LIMITED",
"PANDIAN ADVANCED MEDICAL CENTRE PRIVATE LIMITED",
"PANDIAN CHEMICALS LIMITED",
"PANDIAN INFRA PRIVATE LIMITED",
"PANDIAN SURFACTANTS PRIVATE LIMITED",
"PANDIAN TEXTILE MILLS PRIVATE LIMITED",
"PANDIT AGROTECH PRIVATE LIMITED",
"PANDIT AUTOMOBILES PRIVATE LIMITED",
"PANDIT BENISINGH BHARAT INTER COLLEGE",
"PANDIT DEENDAYAL ENERGY UNIVERSITY",
"PANDIT DEENDAYAL PETROLEUM UNIVERSITY",
"PANDIT DEENDAYAL UPADHYAY MED COLG",
"PANDIT DEENDAYAL UPADHYAY RAJKIYA ASHRAM PADDHATI VIDYALAY",
"PANDIT DEVPRABHKAR SHASTRI COLLEGE OF TECHNOLOGY",
"PANDIT ELECTRICALS PRIVATE LIMITED",
"PANDIT HANDLOOMS PRIVATE LIMITED",
"PANDIT JEWELLERS PRIVATE LIMITED",
"PANDIT LR COLLEGE OF PHARMRNCY",
"PANDIT MADAN MOHAN MALAVIYA HOSPITAL",
"PANDIT NEHARU PU COLLEGE BELGAUM",
"PANDIT NEHRU VIDHYAVIHAR",
"PANDIT PRITHI NATH COLLEGE KANPUR",
"PANDIT VENTURES PRIVATE LIMITED",
"PANDITA RAMABAI MUKTI MISSION",
"PANDIYA AGRI SOLUTIONS PRIVATE LIMITED",
"PANDIYAN HERITAGE RESTAURANTS PRIVATE LIMITED",
"PANDJ CRETECHEM PRIVATE LIMITED",
"PANDORA PROJECTS PRIVATE LIMITED",
"PANDORA R&D LABS PRIVATE LIMITED",
"PANDORIAN LOGISTICS PRIVATE LIMITED",
"PANDOUL FLOUR MILLS PRIVATE LIMITED",
"PANDOZA SOLUTIONS PRIVATE LIMITED",
"PANDP AQUA PRIVATE LIMITED",
"PANDROL RAHEE TECHNOLOGIES PRIVATE LTD",
"PANDURANG BHAGWAN CLEARING AGHENCY PVT LTD",
"PANDURANG SHAFTS PRIVATE LIMITED",
"PANDURANGA COFFEE PRIVATE LIMITED",
"PANDYAN AUTOMOBILES PRIVATE LIMITED",
"PANDYAN GRAMA BANK",
"PANDYAN HOTELS LIMITED",
"PANDYAN INDUSTRIAL EQUIPMENTS PRIVATE LIMITED",
"PANEL DECOR PRIVATE LIMITED",
"PANEL INDIA INTERIOR & CONTRACTS PRIVATE LIMITED",
"PANEL OPTODISPLAY TECHNOLOGY PRIVATE LIMITED",
"PANEL PIN MFG CO PVT LTD",
"PANELLA FOODS AND BEVERAGES PRIVATE LIMITED",
"PANELLI PUMPS & MOTORS PRIVATE LIMITED",
"PANEM INDUSTRIES PRIVATE LIMITED",
"PANEM STEELS PRIVATE. LIMITED.",
"PANERA BIOTECH PRIVATE LIMITED",
"PANESAR AGRICULTURE WORKS PRIVATE LIMITED",
"PANESAR STEEL AND POWER LIMITED",
"PANEXCELL CLINICAL LAB PRIVATE LIMITED",
"PANGABARI TEA & AGRO PRIVATE LIMITED",
"PANGAEA STONE INTERNATIONAL PRIVATE LIMITED",
"PANGASA CHETANA DESIGNS PRIVATE LIMITED",
"PANGEA CHEMICALS PRIVATE LIMITED",
"PANGEA ECONETASSETS PRIVATE LIMITED",
"PANGEA ENTERPRISES PRIVATE LIMITED",
"PANGEA3 LEGAL DATABASE SYSTEMS PRIVATE LIMITED",
"PANGHAT CREATION PRIVATE LIMITED",
"PANGHAT SAREES PRIVATE LIMITED",
"PANGLOBAL MACHINERIES PRIVATE LIMITED",
"PANGULF TECHNOLOGIES PRIVATE LIMITED",
"PANHAS CHEMICALS PVT LTD",
"PANI RESORTS PRIVATE LIMITED",
"PANICKER'S TRAVEL (INDIA) PRIVATE LIMITED",
"PANICKKER SWITCHGEAR PRIVATE LIMITED",
"PANICLE FOODS PRIVATE LIMITED",
"PANICLE WORLDWIDE PRIVATE LIMITED",
"PANIHATI MUNICIPALITY",
"PANIHATI RUBBER LTD",
"PANIL INFRA PRIVATE LIMITED",
"PANILA CHEM LIMITED",
"PANIMALAR ENGG COLLEGE",
"PANIMALAR ENGINEERING COLLEGE",
"PANIMALAR INSTITUTE OF TECHNOLOGY",
"PANIMALAR MEDICAL COLLEGE HOSPITAL AND RESEARCH INSTITUE",
"PANIMALAR POLYTECHNIC COLLEGE",
"PANINDIA EDUCATION INFRA SUPPORT SERVICES PRIVATE LIMITED",
"PANINDIA MARINE SERVICES PRIVATE LIMITED",
"PANINDIA TELECOMMUNICATIONS NETWORK PRIVATE LIMITED",
"PANINI GRANITES PRIVATE LIMITED",
"PANINI INFOTECH PRIVATE LIMITED",
"PANINIYA CARE PRIVATE LIMITED",
"PANIPAT CHEMICALS PVT LTD",
"PANIPAT IMPEX PRIVATE LIMITED",
"PANIPAT INSTITUE OF ENGINEERING & TECHNOLOGY",
"PANIPAT JALANDHAR NH-1 TOLLWAY PRIVATE LIMITED",
"PANIPAT TEXO FABS PRIVATE LIMITED",
"PANIPAT WEAVING AND PROCESSING PRIVATE LIMITED",
"PANJAB AGRICULTURAL UNIVERSITY - LUDHIAN",
"PANJAB SOUTH ROAD CARRIER PRIVATE LIMITED",
"PANJAB TECHNICAL UNIVERSITY - JALLANDHAR",
"PANJARI TRAVELS PRIVATE LIMITED",
"PANJETANI BUILDWELL PRIVATE LIMITED",
"PANJI ENGINEERING PRIVATE LIMITED",
"PANJON LIMITED",
"PANJU AGRICULTURE INDUSTRIES PRIVATE LIMITED",
"PANKAJ ADVERTISING PRIVATE LIMITED",
"PANKAJ AGARWAL EDUCARE PRIVATE LIMITED",
"PANKAJ AGRO PROCESSING PRIVATE LIMITED",
"PANKAJ ALUMINIUM INDUSTRIES PRIVATE LIMITED",
"PANKAJ BUILDWELL LIMITED",
"PANKAJ CROP SCIENCE PRIVATE LIMITED",
"PANKAJ DHARKAR & ASSOCIATES",
"PANKAJ DYES AND CHEMICALS PRIVATE LIMITED",
"PANKAJ ENKA PRIVATE LIMITED",
"PANKAJ EXPORTS PRIVATE LIMITED",
"PANKAJ FASHIONS PRIVATE LIMITED",
"PANKAJ FASTENERS PRIVATE LIMITED",
"PANKAJ GAS CYLINDERS PRIVATE LIMITED",
"PANKAJ GUPTA PVT LTD",
"PANKAJ INFRATEX PRIVATE LIMITED",
"PANKAJ INTERNATIONAL PRIVATE LIMITED",
"PANKAJ ISPAT LIMITED",
"PANKAJ JEWELLERS PRIVATE LIMITED",
"PANKAJ KUMAR SINGH CONSTRUCTION COMPANY PRIVATE LIMITED",
"PANKAJ M PATEL CONSULTANTS PRIVATE LIMITED",
"PANKAJ PAINTS PRIVATE LIMITED",
"PANKAJ PIYUSH TRADE AND INVESTMENT LIMITED",
"PANKAJ PLASTIC INDUSTRIES PRIVATE LIMITED",
"PANKAJ POLYCHEM PRIVATE LIMITED",
"PANKAJ POLYMERS LIMITED",
"PANKAJ POLYTEC PRIVATE LIMITED",
"PANKAJ POTENTIOMETERS PVT LTD",
"PANKAJ SCANNING AND PATHOLOGY RESEARCH CENTRE PVT.LTD.",
"PANKAJ SHAWLS PRIVATE LIMITED",
"PANKAJ SILK MILLS PVT LTD",
"PANKAJ SOOT(INDIA)PRIVATE LIMITED",
"PANKAJ STEEL CORPORATION",
"PANKAJ TEXTILE AGENCIES PRIVATE LIMITED",
"PANKAJ VIDHYALAY SAMPA",
"PANKAJA KASTHURI HERBALS INDIA PRIVATE LIMITED",
"PANKAJINI INTERNATIONAL PRIVATE LIMITED",
"PANKH AUTOWHEELS PRIVATE LIMITED",
"PANKH FASHIONS PRIVATE LIMITED",
"PANKHURI ENTERPRISES PRIVATE LIMITED",
"PANKHURI LAMINATORS PRIVATE LIMITED",
"PANKTI MANAGEMENT CONSULTANCY PRIVATE LIMITED.",
"PANKYPUNNU E-COMMERCE PRIVATE LIMITED",
"PANMODAL LOGISTICS PRIVATE LIMITED",
"PANNA AGROTECH COLDSTORAGE PRIVATE LIMITED",
"PANNA CHEMICALS AND SOLVENTS PVT LTD",
"PANNA GEMS & JEWELLERY PRIVATE LIMITED",
"PANNA LAL GURPRASAD PRIVATE LIMITED.",
"PANNA LAL OM PARKASH AND COMPANY PRIVATE LIMITED",
"PANNA LAL SHRI KRISHAN DASS PRIVATE LIMITED",
"PANNA MARKETING PRIVATE LIMITED",
"PANNALAL COLD STORAGE PRIVATE LIMITED",
"PANNALAL EXPORTS PRIVATE LIMITED",
"PANNALAL INSTITUTION",
"PANNALAL MAHESH CHANDRA JEWELLERS",
"PANNAR STRIPS PRIVATE LIMITED",
"PANNEST INTEGRATED SERVICES PRIVATE LIMITED",
"PANNIVELIL MOTORS PRIVATE LIMITED",
"PANNU INFRA PRIVATE LIMITED",
"PANNU ROADLINES PRIVATE LIMITED",
"PANOBIZ BUSINESS TECHNOLOGIES PRIVATE LIMITED",
"PANOLI AQUA CHLORIDE PRIVATE LIMITED",
"PANOLI ENVIRO TECHNOLOGY LIMITED",
"PANOLI INTERMEDIATES INDIA PRIVATE LIMITED",
"PANOPLY DIGITAL PRIVATE LIMITED",
"PANOPLY PACKAGINGS PRIVATE LIMITED",
"PANOPTIC AGRO VENTURES PRIVATE LIMITED",
"PANORAMA AUTO MOTIVEINDVSTRIES PRIVATE LIMITED",
"PANORAMA ELECTRONICS PVT LTD",
"PANORAMA EXPORTS PVT LTD",
"PANORAMA MARKETING PRIVATE LIMITED",
"PANORAMA PACKAGING PVT LTD",
"PANORAMA RESORTS PVT LTD",
"PANORAMA STUDIOS INTERNATIONAL LIMITED",
"PANORAMA STUDIOS PRIVATE LIMITED",
"PANORAMA TELEVISION PRIVATE LIMITED",
"PANORAMIC EDUCARE PRIVATE LIMITED",
"PANORAMIC HOLIDAYS LIMITED",
"PANORAMIC RESORTS INDIA LIMITED",
"PANORAMIC TOUR AND TRAVELS LIMITED",
"PANORTHO PRIVATE LIMITED",
"PANSAMBAL CONSULTANTS PRIVATE LIMITED",
"PANSARI DEVELOPERS LIMITED",
"PANSARI ROLLER FLOUR MILLS PRIVATE LIMITED",
"PANSARI STEELS PRIVATE LIMITED",
"PANSARI VEGETABLE & OILS PVT LTD",
"PANSAS BUILDERS & DEVELOPERS PRIVATE LIMITED",
"PANSEIS GEO SERVICES PRIVATE LIMITED",
"PANSEN ENGINEERING INDIA PRIVATE LIMITED",
"PANSHUL MULTITRADE PRIVATE LIMITED",
"PANSOFT DATA SOLUTIONS PRIVATE LIMITED",
"PANSOFT TECHNOLOGIES PRIVATE LIMITED",
"PANSONS DISTRIBUTORS PRIVATE LIMITED",
"PANSURIYA IMPEX",
"PANSUT UDYOG PRIVATE LIMITED",
"PANSWORLD TELEVISION INDIA PRIVATE LIMITED",
"PANT DIAGNOSTICS PRIVATE LIMITED",
"PANT SAMARTH VIDYA MANDIR",
"PANTAGON SIGN SECURITIES PRIVATE LIMITED",
"PANTAGONE TECHNOLOGIES INDIA PRIVATE LIMITED",
"PANTALOON RETAIL INDIA LIMITED",
"PANTELWAR PRIVATE LIMITED",
"PANTH FINMART PRIVATE LIMITED",
"PANTH INFINITY LIMITED",
"PANTHEON BUILDCON PRIVATE LIMITED",
"PANTHEON EVENTS AND HOSPITALITY PRIVATE LIMITED",
"PANTHEON INDIA PRIVATE LIMITED",
"PANTHEON MANAGEMENT PRIVATE LIMITED",
"PANTHEON SAMPLE INDIA PRIVATE LIMITED",
"PANTHEON TECHNOLOGIES PRIVATE LIMITED",
"PANTHER COMMOSALES PRIVATE LIMITED",
"PANTHER FINVEST PRIVATE LIMITED",
"PANTHER GUARDS PVT LTD",
"PANTHER IMPEX PRIVATE LIMITED",
"PANTHER LOGISTICS PRIVATE LIMITED",
"PANTHER SAFETY SOLUTIONS PRIVATE LIMITED",
"PANTHER SECURE SOLUTIONS PRIVATE LIMITED",
"PANTHER SECURITY SERVICES PRIVATE LIMITED",
"PANTHER STUDIO PRIVATE LIMITED",
"PANTHER TRANSFREIGHT LIMITED",
"PANTHER UNIT INFRASTRUCTURE PRIVATE LIMITED",
"PANTHERUN TECHNOLOGIES PRIVATE LIMITED",
"PANTHERYX MEDICAL PRIVATE LIMITED",
"PANTHOIBI HOUSING FINANCE COMPANY LIMITED",
"PANTHOR TURNKEY PROJECTS PRIVATE LIMITED",
"PANTIHAL DAMODAR INSTITUTION",
"PANTNAGAR CETP PRIVATE LIMITED",
"PANTOMATH CAPITAL ADVISORS PRIVATE LIMITED",
"PANTOMATH FINANCE PRIVATE LIMITED",
"PANTONE ENTERPRISES PRIVATE LIMITED",
"PANTONE TEXTILES MILLS PRIVATE LIMITED",
"PANTOSSCOPE ONE PRIVATE LIMITED",
"PANTREE HOSPITALITY & SERVICES PRIVATE LIMITED",
"PANTRON AUTOMATION PRIVATE LIMITED",
"PANTS THEORY PRIVATE LIMITED",
"PANTSON PHARMA PRIVATE LIMITED",
"PANVA ENGINEERING PRIVATE LIMITED",
"PANVA TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"PANVEL INDUSTRIAL FASTENERS PRIVATE LIMITED",
"PANVEL MAHANAGARPALIKA",
"PANVEL MEDICAL RESEARCH CENTRE PRIVATE LIMITED",
"PANVO ORGANICS PRIVATE LIMITED",
"PANWAR CASTING PRIVATE LIMITED",
"PANZER DIVISION SECURITY & ALLIED SERVICES PRIVATE LIMITED",
"PANZER LOGISTICS PRIVATE LIMITED",
"PANZER PHARMACEUTICAL PRIVATE LIMITED",
"PANZER TECHNOLOGIES PRIVATE LIMITED",
"PAO AND SONS PVT LTD",
"PAO ARCHEOLOGICAL SURVEY OF INDIA",
"PAO ARCHEOLOGICAL SURVEY OF INDIA NEW DELHI",
"PAO C EX IV KOLKATA",
"PAO CGWB FARIDABAD",
"PAO COLLEC OF CENTRAL EXCISE",
"PAO CWPRS PUNE",
"PAO DEPARTMENT OF FINANCIAL SERVICES",
"PAO DGE&T-11 CHENNAI",
"PAO DGFASLI MUMBAI",
"PAO EAST ZONE CPWD KOLKATA",
"PAO GREF",
"PAO IMD M/O EARTH SCIENCE PUNE",
"PAO JAWAHAR CUSTOMS HOUSE NHAVA SHEVA",
"PAO MSD MUMBAI",
"PAO O O THE AG (A AND E)I UP ALLAHABAD",
"PAO O/O PR AG (A AND E) I MAHARASHTRA MUMBAI",
"PAO O/O THE PR.AG AUDIT DELHI",
"PAO ORS THE GUARDS",
"PAO PD & TM",
"PAO STATISTICS NEW DELHI",
"PAO WEST ZONE CPWD",
"PAO YOUTH AFFAIRS AND SPORTS NEW DELHI",
"PAO, FILMS DIVISION, MUMBAI",
"PAOCOLLEC. OF CENTRAL EXCISE-I MUMBAI",
"PAOCOLLECTORATE OF CUSTOMSMUMBAI",
"PAOMAIN SECTT MINISTRY OF LABOUR NEW DELHI",
"PAONA CHEMPRO PRIVATE LIMITED",
"PAP COAT (INDIA) PRIVATE LIMITED",
"PAPA CONSULTANCY PRIVATE LIMITED",
"PAPA LOGISTICS PRIVATE LIMITED",
"PAPA REDDY POULTRIES PRIVATE LIMITED",
"PAPAGOYA EDUCATION PRIVATE LIMITED",
"PAPANASAM BENEFIT FUND LIMITED",
"PAPAS TRADING PRIVATE LIMITED",
"PAPAYA CONSTRUCTIONS PRIVATE LIMITED",
"PAPCEL PULP AND PAPER TECHNOLOGY PRIVATE LIMITED",
"PAPCO OFFSET PRIVATE LIMITED",
"PAPCON INDORE PVT LTD",
"PAPELTON INNOVATIONS AND TECHNOLOGIES PRIVATE LIMITED",
"PAPER & INK PRODUCTIONS PRIVATE LIMITED",
"PAPER & LABEL PRODUCTS INDIA PRIVATE LIMITED",
"PAPER BOAT APPS PRIVATE LIMITED",
"PAPER CONTAINERS (INDIA) PRIVATE LIMITED",
"PAPER DISTRIBUTORS PVT LTD",
"PAPER DREAMS PRIVATE LIMITED",
"PAPER EXIM PRIVATE LIMITED",
"PAPER KRAFT MANUFACTURING (INDIA) PVT LTD",
"PAPER PACKAGING PRIVATE LIMITED",
"PAPER PIXEL PEOPLE INTEGRATED SOLUTIONS PRIVATE LIMITED",
"PAPER PLANE DESIGN SOLUTIONS PRIVATE LIMITED",
"PAPER PLATE PICTURES PRIVATE LIMITED",
"PAPER TRADE LINKS PRIVATE LIMITED",
"PAPER TUBE MACHINES PRIVATE LIMITED",
"PAPER UDYOG (BOMBAY) PRIVATE LIMITED",
"PAPERBOAT DESIGN STUDIOS PRIVATE LIMITED",
"PAPERCARE MACHINE PRIVATE LIMITED",
"PAPERCHASE ACCOUNTANCY INDIA PRIVATE LIMITED",
"PAPERCHASE BUSINESS SERVICES PRIVATE LIMITED",
"PAPERFLITE MARKETING TECHNOLOGY PRIVATE LIMITED",
"PAPERFOLKS CREATIVE STUDIOS PRIVATE LIMITED",
"PAPERLESS LAB WORKS PRIVATE LIMITED",
"PAPERLINK SOFTWARES PRIVATE LIMITED",
"PAPERMAN ENVIRONMENTAL SOLUTIONS PRIVATE LIMITED",
"PAPERPEDIA PRIVATE LIMITED",
"PAPERPINK CONSULTANTS PRIVATE LIMITED",
"PAPERS WORLDWIDE INDIA SERVICES PRIVATE LIMITED",
"PAPERTECH ENGINEERS PRIVATE LIMITED",
"PAPERTEX SPECIALITY CHEMICALS PRIVATE LIMITED",
"PAPIER HYGIENE PRIVATE LIMITED",
"PAPILLON BUILDCON LIMITED",
"PAPILLON BUILDTECH LIMITED",
"PAPILLON PHARMACEUTICAL PRIVATE LIMITED",
"PAP-PRINT (INDIA) PRIVATE LIMITED",
"PAPPU HOSIERY PRIVATE LIMITED",
"PAPPU POOJA BHIWANI FEED PRIVATE LIMITED",
"PAPPU TRACTORS PRIVATE LIMITED",
"PAPRIKA HOSPITALITY PRIVATE LIMITED",
"PAPRIKA OLEO'S (INDIA) LIMITED",
"PAPTRONICS PRIVATE LIMITED",
"PAPUMPARE TEA ESTATE PRIVATE LIMITED",
"PAPYRUS PAPER PRODUCTS",
"PAQUES ENVIRONMENTAL TECHNOLOGY INDIA PRIVATE LIMITED",
"PAR ACTIVE TECHNOLOGIES PRIVATE LIMITED",
"PAR AGRI FARMS PRIVATE LIMITED",
"PAR AIR PRIVATE LIMITED",
"PAR COMPUTING SOLUTIONS PRIVATE LIMITED",
"PAR DRUGS AND CHEMICALS PRIVATE LIMITED",
"PAR ENTERPRISES PRIVATE LIMITED",
"PAR EXCELLENCE CONSULTANCY SERVICES PRIVATE LIMITED",
"PAR EXCELLENCE LEADERSHIP SOLUTIONS PRIVATE LIMITED",
"PAR EXCELLENCE REAL ESTATE PRIVATE LIMITED",
"PAR FILTERS PRIVATE LIMITED",
"PAR FORMULATIONS PRIVATE LIMITED",
"PAR HI-TECH BUILDCON PRIVATE LIMITED",
"PAR HORIZON EXIM PRIVATE LIMITED",
"PAR INDUSTRIES PRIVATE LIMITED",
"PAR REALTY & SERVICES PRIVATE LIMITED",
"PAR SOLAR PRIVATE LIMITED",
"PAR SPECIALTY POLYMERS PRIVATE LIMITED",
"PAR TECHNO-HEAT PVT LTD",
"PARA ENTERPRISES PRIVATE LIMITED",
"PARA INFRASTRUCTURE PRIVATE LIMITED",
"PARA LAB PVT LTD",
"PARA PRODUCTS PRIVATE LIMITED",
"PARA UNISON SERVICES PRIVATE LIMITED",
"PARAAG FABRICS LIMITED",
"PARABLU SYSTEMS PRIVATE LIMITED",
"PARABOLIC LEADS PRIVATE LIMITED",
"PARABOLIC LIFESCIENCES PRIVATE LIMITED",
"PARABRAM HEALTH SERVICES PRIVATE LIMITED",
"PARACASA INTERIO PRIVATE LIMITED",
"PARACHUTE KALPAVRIKSHA FOUNDATION",
"PARACLETE MANAGEMENT SERVICES PRIVATE LIMITED",
"PARACOAT PRODUCTS LIMITED",
"PARAD CORPORATION PRIVATE LIMITED",
"PARADEEP FERTICHEM INDUSTRY PRIVATE LIMITED",
"PARADEEP OXYGEN PRIVATE LIMITED",
"PARADEEP PARIVAHAN PRIVATE LIMITED",
"PARADEEP PHOSPHATES LTD",
"PARADEEP PLASTIC PARK LIMITED",
"PARADIGM COATINGS PRIVATE LIMITED",
"PARADIGM CONSTRUCTIONS PRIVATE LIMITED",
"PARADIGM DATA SERVICES PRIVATE LIMITED",
"PARADIGM DOTOM BUILDHEIGHTS LLP",
"PARADIGM EDUCARE PRIVATE LIMITED",
"PARADIGM ENVIRONMENTAL STRATEGIES PRIVATE LIMITED",
"PARADIGM FACILITY AND PROPERTY MANAGEMENT PRIVATE LIMITED",
"PARADIGM GEOPHYSICAL INDIA PRIVATE LIMITED",
"PARADIGM GRANITE PRIVATE LIMITED",
"PARADIGM INFRABUILD PRIVATE LIMITED",
"PARADIGM INTEGRATED FACILITY SERVICES PRIVATE LIMITED",
"PARADIGM IT PRIVATE LIMITED",
"PARADIGM LEATHER ACCESSORIES PRIVATE LIMITED",
"PARADIGM LOGISTICS & DISTRIBUTION PRIVATE LIMITED",
"PARADIGM MARINE AND TECHNICAL SERVICES PRIVATE LIM",
"PARADIGM MARINE AND TECHNICAL SERVICES PRIVATE LIMITED",
"PARADIGM PLUS SOLUTIONS PRIVATE LIMITED",
"PARADIGM ROCKS PRIVATE LIMITED",
"PARADIGM SERVICES PRIVATE LIMITED",
"PARADIGM STONE INDIA PRIVATE LIMITED",
"PARADIGM STRUCTURES LLP",
"PARADIGM TECHNOLOGIES PRIVATE LIMITED",
"PARADIGM VENTURES PRIVATE LIMITED",
"PARADIGMIT TECHNOLOGY SERVICES PRIVATE LIMITED",
"PARADIGMPLUS MARKETING COMMUNICATIONS PRIVATE LIMITED",
"PARADIME TECHNOLOGIES PRIVATE LIMITED",
"PARADIP CALCINER LIMITED",
"PARADIP EAST QUAY COAL TERMINAL PRIVATE LIMITED",
"PARADIP INTERNATIONAL CARGO TERMINAL PRIVATE LIMITED",
"PARADIP PORT ROAD COMPANY LIMITED",
"PARADIP PORT TRUST",
"PARADISE AGENCIES PRIVATE LIMITED",
"PARADISE ALUMINIUM EXTRUSIONS PRIVATE LIMITED",
"PARADISE AUTOCORP PRIVATE LIMITED",
"PARADISE BONDED WAREHOUSE PRIVATE LIMITED",
"PARADISE CARGO SERVICES PRIVATE LIMITED",
"PARADISE CERAMICA INDIA PRIVATE LIMITED",
"PARADISE CITADEL PROJECTS PRIVATE LIMITED",
"PARADISE COMMERCIAL PRIVATE LIMITED",
"PARADISE DISTILLERIES PRIVATE LIMITED",
"PARADISE ELECTRICALS PRIVATE LIMITED",
"PARADISE ENTERPRISES PVT LTD",
"PARADISE FITNESS & HEALTH PRIVATE LIMITED",
"PARADISE FOOD COURT PRIVATE LIMITED",
"PARADISE FOOTWEAR INDUSTRIES PRIVATE LIMITED",
"PARADISE INFRA-CON PRIVATE LIMITED",
"PARADISE INSTRUMENTS PRIVATE LIMITED",
"PARADISE ISLE BEACH RESORT PRIVATE LIMITED",
"PARADISE JUICE PRIVATE LIMITED",
"PARADISE LABELS PRIVATE LIMITED",
"PARADISE LAMINATORS PRIVATE LIMITED",
"PARADISE LIFESTYLES PRIVATE LIMITED",
"PARADISE MARKCOM PRIVATE LIMITED",
"PARADISE MERCHANTS PRIVATE LIMITED",
"PARADISE NUTS LIMITED",
"PARADISE PACKAGING PRIVATE LIMITED",
"PARADISE PLASTICS ENTERPRISE LIMITED",
"PARADISE PLASTOPACK PRIVATE LIMITED.",
"PARADISE POULTRIES PRIVATE LIMITED",
"PARADISE POWER & SPONGE LIMITED",
"PARADISE POWER CABLES PVT LTD",
"PARADISE RESTAURANT PRIVATE LIMITED",
"PARADISE SANITARY WARE PRIVATE LIMITED",
"PARADISE SCAFFOLDINGS PRIVATE LIMITED",
"PARADISE SHEETS PRIVATE LIMITED",
"PARADISE STEELS PRIVATE LIMITED",
"PARADISE TECHSOFT SOLUTIONS PRIVATE LIMITED",
"PARADISE TRANSPOTS PRIVATE LIMITED",
"PARADISE WIRES LIMITED",
"PARADISO JEWELS PRIVATE LIMITED",
"PARADISO SOFTWARE PRIVATE LIMITED",
"PARADOX DESIGN PRIVATE LIMITED",
"PARADOX EVENTS PRIVATE LIMITED",
"PARADOX PETROCHEM PRIVATE LIMITED",
"PARADOX TECHNOLOGIES PRIVATE LIMITED",
"PARAG AGRO FOODS AND ALLIED PRODUCTS PRIVATE LIMITED",
"PARAG COPIGRAPH PRIVATE LIMITED",
"PARAG DESHPANDE CONSULTING ENGINEERS PRIVATE LIMITED",
"PARAG ELECTRODES AGENCIES PRIVATE LIMITED",
"PARAG ENGINEERING PRODUCTS PRIVATE LIMITED",
"PARAG ENTERPRISE",
"PARAG FANS AND COOLING SYSTEM LIMITED",
"PARAG GASES AND CHEMICALS PRIVATE LIMITED",
"PARAG JEWELLERY PRIVATE LIMITED",
"PARAG MILK FOODS LIMITED",
"PARAG PARIKH FINANCIAL ADVISORY SERVICES LIMITED",
"PARAG PARIKH FINANCIAL ADVISORY SERVICES PRIVATE LIMITED",
"PARAG RECYCLING PRIVATE LIMITED",
"PARAG SEEDS PVT. LTD.",
"PARAG STEEL & ALLOYS PRIVATE LIMITED",
"PARAG TECHNOBUILD PRIVATE LIMITED",
"PARAG VANIJYA PRIVATE LIMITED",
"PARAG VELVETS PRIVATE LIMITED",
"PARAG VINIMAY PRIVATE LIMITED",
"PARAGATE SERVICES PRIVATE LIMITED",
"PARAGON ACCESSORIES PRIVATE LIMITED",
"PARAGON APPAREL PRIVATE LIMITED",
"PARAGON AUTOTECH PRODUCTS PRIVATE LIMITED",
"PARAGON AVENUES PRIVATE LIMITED",
"PARAGON BEAUTY GARDEN PRIVATE LIMITED",
"PARAGON BUSINESS SOLUTIONS LIMITED",
"PARAGON CONSUMER CARE PRIVATE LIMITED",
"PARAGON DIGITAL SERVICES PRIVATE LIMITED",
"PARAGON DYNAMICS INFO SYSTEMS PRIVATE LIMITED",
"PARAGON ELECTRICALS PRIVATE LIMITED",
"PARAGON FASTENERS PRIVATE LIMITED",
"PARAGON FINANCE LTD",
"PARAGON FINE AND SPECIALITY CHEMICAL LIMITED",
"PARAGON GROWERS & TEA PLANTERS PRIVATE LIMITED",
"PARAGON HOSPITAL KERALA PRIVATE LIMITED",
"PARAGON IRRIGATION PRIVATE LIMITED",
"PARAGON KNITS LIMITED",
"PARAGON PEOPLE PETRO-PLAST PRIVATE LIMITED",
"PARAGON POLY FILMS PRIVATE LIMITED",
"PARAGON POLYMER PRODUCTS PRIVATE LIMITED",
"PARAGON PROPERTY ENTERPRISES PRIVATE LIMITED",
"PARAGON PURVA LIMITED",
"PARAGON SALES PVT LTD",
"PARAGON SCM PRIVATE LIMITED",
"PARAGON SEA FOODS PRIVATE LIMITED",
"PARAGON SHIPPING PRIVATE LIMITED",
"PARAGON SOLUTIONS PRIVATE LIMITED",
"PARAGON SYNTHETICS AND POLYMERS LIMITED",
"PARAGON TELELINKS PRIVATE LIMITED",
"PARAGON TEXTILE MILLS PRIVATE LIMITED",
"PARAGON VENTURES PRIVATE LIMITED",
"PARAGON VIAL CAPS PRIVATE LIMITED",
"PARAGON WATER TECHNOLOGIES PRIVATE LIMITED",
"PARAGON XT",
"PARAGYTE TECHNOLOGIES PRIVATE LIMITED",
"PARAHIT TECHNOLOGIES LIMITED",
"PARAIDSE INFRA",
"PARAISO HOMES PRIVATE LIMITED",
"PARAIZO CLUB LIMITED",
"PARAKEET SPIRITS PRIVATE LIMITED",
"PARAKH AGRO INDUSTRIES LIMITED",
"PARAKH AGRO PRIVATE LIMITED",
"PARAKH BROTHERS PVT LTD",
"PARAKH FINVEST PRIVATE LIMITED",
"PARAKH FOODS AND OILS LIMITED",
"PARAKH HOSPITALS PRIVATE LIMITED",
"PARAKH PLEXUS REALTY LIMITED",
"PARAKH PROJECTS PRIVATE LIMITED",
"PARAKH ROADLINES PRIVATE LIMITED",
"PARAKH TEA SALES PRIVATE LIMITED",
"PARAKH VANIJYA PVT. LTD.",
"PARAKKAT BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"PARAKKAT PEARLS AND JEWELS (INDIA) PRIVATE LIMITED",
"PARAKRAM SECURITY INDIA PRIVATE LIMITED",
"PARALAM GLOBAL PRIVATE LIMITED",
"PARALLEL HR SOLUTIONS PRIVATE LIMITED",
"PARALLEL PLAIDS UNIFORMS PRIVATE LIMITED",
"PARALLEL WIRELESS INDIA PRIVATE LIMITED",
"PARALLELDOTS TECHNOLOGY PRIVATE LIMITED",
"PARALLELE INTERIORS PRIVATE LIMITED",
"PARALSO REALTY PRIVATE LIMITED",
"PARAM AD-VENTURES PRIVATE LIMITED",
"PARAM AGRIREVOLUTION PRIVATE LIMITED",
"PARAM APPLIANCES PRIVATE LIMITED",
"PARAM ARC PETROCHEMICAL & ENERGY PRIVATE LIMITED",
"PARAM AUTOMOBILES PRIVATE LIMITED",
"PARAM BUILDCON PRIVATE LIMITED",
"PARAM CAPITAL RESEARCH PRIVATE LIMITED",
"PARAM CHEMICALS PRIVATE LIMITED",
"PARAM DAIRY LIMITED.",
"PARAM DIAGNOSTIC CENTRE PRIVATE LIMITED",
"PARAM DIAMOND",
"PARAM DIGITAL SOLUTION PRIVATE LIMITED",
"PARAM ENTERPRISES PVT LTD",
"PARAM FOOD INDUSTRIES PRIVATE LIMITED",
"PARAM GEMS PRIVATE LIMITED",
"PARAM HANS AVIATION INDIA PRIVATE LIMITED",
"PARAM HANS CREATIONS",
"PARAM HYDRAULICS PRIVATE LIMITED",
"PARAM INDIA LTD",
"PARAM INDUSTRIES",
"PARAM INTERNATIONAL PRIVATE LIMITED",
"PARAM JEWELS PRIVATE LIMITED",
"PARAM JYOTI TOBACCO PRODUCTS LIMITED",
"PARAM KRAFT PAPER PRIVATE LIMITED",
"PARAM MACHINING TECHNOLOGIES PRIVATE LIMITED",
"PARAM PACKAGING PRIVATE LIMITED",
"PARAM PROTEINS PRIVATE LIMITED",
"PARAM RENEWABLE ENERGY PRIVATE LIMITED",
"PARAM SHAKTI DHATU UDYOG PRIVATE LIMITED",
"PARAM SHUBHAM VANIJYA LIMITED",
"PARAM SKILLS TRAINING INDIA PRIVATE LIMITED",
"PARAM TEX FAB PRIVATE LIMITED",
"PARAM TREASURY (INDIA) PRIVATE LIMITED",
"PARAM WOOD MOULDING PRIVATE LIMITED",
"PARAMA HEARTBEAT SPORTS (INDIA) PRIVATE LIMITED",
"PARAMA TEXMACH PRIVATE LIMITED",
"PARAMAHANSA AGRO UDYOG PRIVATE LIMITED",
"PARAMAKUDI ENGINEERING CLUSTER PRIVATE LIMITED",
"PARAMANANDA RICE MILL PRIVATE LIMITED",
"PARAMARSH INFORMATICS PRIVATE LIMITED",
"PARAMASHIVA MOTORS PRIVATE LIMITED",
"PARAMATRIX INFO SOLUTIONS PRIVATE LIMITED",
"PARAMATRIX TECHNOLOGIES LIMITED",
"PARAMATRIX TECHNOLOGIES PRIVATE LIMITED",
"PARAMAX PROJECTS PRIVATE LIMITED",
"PARAMDHAM ENTERPRISES PRIVATE LIMITED",
"PARAMESHWARA COTTON AGRO PRODUCTS",
"PARAMESHWARA HANDY SERVICES AND PROJECTS PRIVATE LIMITED",
"PARAMESHWARI EXPORTS PRIVATE LIMITED",
"PARAMESU BIOTECH PRIVATE LIMITED",
"PARAMESWAR COMMOSALES PRIVATE LIMITED",
"PARAMESWARA TIMBER HUB PRIVATE LIMITED",
"PARAMETRIC TECHNOLOGY INDIA PRIVATE LIMITED",
"PARAMHANS ASSOCIATES PRIVATE LIMITED",
"PARAMHANS BUILDERS PRIVATE LIMITED",
"PARAMHANS HOLIDAYS PRIVATE LIMITED",
"PARAMHANS WIRES PRIVATE LIMITED",
"PARAMI PLAST VENTURES PRIVATE LIMITED",
"PARAMIC GOODS PVT LTD",
"PARAMITA HERITAGE SCHOOL",
"PARAMITA HIGH SCHOOL",
"PARAMITA HOSPITALITY PRIVATE LIMITED",
"PARAMITHA CHILDREN'S HOSPITAL KOMPALLY PRIVATE LIMITED",
"PARAMITHA CHILDREN'S HOSPITAL PRIVATE LIMITED",
"PARAMITHA MED AND INFRA PRIVATE LIMITED",
"PARAMITHA WOMEN & CHILDREN'S HOSPITAL CHANDANAGAR PRIVATE LIMITED",
"PARAMITRA HOLDINGS PRIVATE LIMITED",
"PARAMJIT POULTRY FARM AND HATCHERY PRIVATE LIMITED",
"PARAMJYOTI INFRATECH PRIVATE LIMITED",
"PARAMJYOTI MOVERS PRIVATE LIMITED",
"PARAMLOGIC INFOTECH PRIVATE LIMITED",
"PARAMOOUNT NIRYAAT PRIVATE LIMITED",
"PARAMOTOR DIGITAL TECHNOLOGY PRIVATE LIMITED",
"PARAMOUNT APARTMENTS PVT.LTD.",
"PARAMOUNT APPARELS PRIVATE LIMITED",
"PARAMOUNT AROMACHEM PRIVATE LIMITED",
"PARAMOUNT ART PRINTS PRIVATE LIMITED",
"PARAMOUNT AUTOTECH PRIVATE LIMITED",
"PARAMOUNT BED INDIA PRIVATE LIMITED",
"PARAMOUNT BIO-SCIENCE PRIVATE LIMITED",
"PARAMOUNT BUILDING SOLUTIONS PRIVATE LIMITED",
"PARAMOUNT BUILDTECH PRIVATE LIMITED",
"PARAMOUNT BUILTECH PRIVATE LIMITED",
"PARAMOUNT CARS INDIA PRIVATE LIMITED",
"PARAMOUNT CHIKAN EXPORT PRIVATE LIMITED",
"PARAMOUNT COMMERCIAL CORPN PVT LTD",
"PARAMOUNT COMPLEXES LIMITED",
"PARAMOUNT CONDUCTORS LIMITED",
"PARAMOUNT COPPER ROLLING MILLS PRIVATE LIMITED",
"PARAMOUNT CORPORATE NETWORK LIMITED",
"PARAMOUNT COSMETICS INDIA LIMITED",
"PARAMOUNT DIGITAL BUSINESS SYSTEMS PRIVATE LIMITED",
"PARAMOUNT DIGITAL MEDIA SERVICES PRIVATE LIMITED",
"PARAMOUNT DYES AND CHEMICALS PVT LTD",
"PARAMOUNT ECOAIR TECHNIQUES PRIVATE LIMITED",
"PARAMOUNT ENTERPRISES LIMITED",
"PARAMOUNT EXPORTS",
"PARAMOUNT FABRICS PRIVATE LIMITED",
"PARAMOUNT FARMS INTERNATIONAL PRIVATE LIMITED",
"PARAMOUNT FENESTRATION PRIVATE LIMITED",
"PARAMOUNT FORGE",
"PARAMOUNT GANAPATI MEDICARE PRIVATE LIMITED",
"PARAMOUNT GEOSPATIAL PRIVATE LIMITED",
"PARAMOUNT GLOBAL SERVICES PRIVATE LIMITED",
"PARAMOUNT HEALTH GROUP",
"PARAMOUNT HEALTH SERVICES & INSURANCE TPA PRIVATE LIMITED",
"PARAMOUNT HEALTHCARE MANAGEMENT PRIVATE LIMITED",
"PARAMOUNT HOSPITALS PVT. LTD.",
"PARAMOUNT INFINET PRIVATE LIMITED",
"PARAMOUNT INFRABUILD PRIVATE LIMITED",
"PARAMOUNT INFRATEK PRIVATE LIMITED",
"PARAMOUNT INSTRUMENTS PRIVATE LIMITED",
"PARAMOUNT INTERCONTINENTAL PRIVATE LIMITED",
"PARAMOUNT INTERNATIONAL SCHOOL",
"PARAMOUNT IRON AND STEEL WORKS PRIVATE LIMITED",
"PARAMOUNT LIFESTYLE PRIVATE LIMITED",
"PARAMOUNT LIMITED",
"PARAMOUNT LOOMS PRIVATE LIMITED",
"PARAMOUNT MINERALS AND CHEMICALS LIMITED",
"PARAMOUNT MONEY CHANGERS PRIVATE LIMITED",
"PARAMOUNT NUTRITIONS INDIA PRIVATE LIMITED",
"PARAMOUNT OFFICE SYSTEMS PRIVATE LIMITED",
"PARAMOUNT PESTICIDES LIMITED",
"PARAMOUNT PLASTICS PVT LTD",
"PARAMOUNT POLISH PROCESSORS PRIVATE LIMITED",
"PARAMOUNT POLYMERS PRIVATE LIMITED",
"PARAMOUNT POLYTREAT CHEMICALS PRIVATE LIMITED",
"PARAMOUNT PRATISHTHAN PRIVATE LIMITED",
"PARAMOUNT PRODUCTS PRIVATE LIMITED",
"PARAMOUNT PROJECT ENDEAVORS PRIVATE LIMITED",
"PARAMOUNT PROTECTIVE SYSTEMS INDIA PRIVATE LIMITED",
"PARAMOUNT PUBLIC SCHOOL",
"PARAMOUNT PULSES PRIVATE LIMITED",
"PARAMOUNT RAIL INFRA PRIVATE LIMITED",
"PARAMOUNT RESTAURANTS PRIVATE LIMITED",
"PARAMOUNT RICE PRIVATE LIMITED",
"PARAMOUNT SECURITIES PRIVATE LIMITED",
"PARAMOUNT SECUTORS PRIVATE LIMITED",
"PARAMOUNT SHIPPING SERVICES PRIVATE LIMITED",
"PARAMOUNT SILK MILLS PVT LTD",
"PARAMOUNT STEEL STRUCTURES PRIVATE LIMITED",
"PARAMOUNT SURGIMED LIMITED",
"PARAMOUNT SYNCOT PRIVATE LIMITED",
"PARAMOUNT SYNTEX PRIVATE LIMITED",
"PARAMOUNT TEA MARKETING PVT LTD",
"PARAMOUNT TEA MARKETING SOUTH INDIA PRIVATE LIMITED",
"PARAMOUNT TELECABLES LIMITED",
"PARAMOUNT TEXCHEM PRIVATE LIMITED",
"PARAMOUNT TEXFAB PRIVATE LIMITED",
"PARAMOUNT TEXTILE MILLS PRIVATE LIMITED",
"PARAMOUNT THREAD PRIVATE LIMITED",
"PARAMOUNT TRADECOM PRIVATE LIMITED",
"PARAMOUNT UNIVERSAL PRIVATE LIMITED",
"PARAMOUNT VACATION PLANNERS PRIVATE LIMITED",
"PARAMOUNT WIRES AND CABLES LIMITED",
"PARAMOUNTCY RESEARCH AND DIAGNOSTIC CENTRE PRIVATE LIMITED",
"PARAMOUNTHYDRAULICS INDIA PRIVATE LIMITED",
"PARAMOUNT'S VIDHYASHRAM SCHOOL",
"PARAMOX INDUSTRIES PRIVATE LIMITED",
"PARAMPARA BUILDERS PRIVATE LIMITED",
"PARAMPARA SPINNING MILLS PRIVATE LIMITED",
"PARAMPUJYA SOLAR ENERGY PRIVATE LIMITED",
"PARAMSHUDH AGRO PRIVATE LIMITED",
"PARAMSNEH JEWELLERS (INDIA) PRIVATE LIMITED",
"PARAMTECH CAD SERVICES PRIVATE LIMITED",
"PARAMUN ENGINEERING EXIM (INDIA) PRIVATE LIMITED",
"PARAMVAH NETWORKS PRIVATE LIMITED",
"PARAMVAH STUDIOS PRIVATE LIMITED",
"PARAMVEER BANASINGH VIDYA ACADEMY OF EXCELLENCE MATRIC HR SEC SCHOOL",
"PARAMVEER MATRICULATION HIGHER SECONDARY SCHOOL",
"PARAN POLYMERS PRIVATE LIMITED",
"PARANGAT TECHNOLOGIES",
"PARANI RESORTS PRIVATE LIMITED",
"PARANI SPINNING MILLS PRIVATE LIMITED",
"PARANJAPE AUTOCAST PRIVATE LIMITED",
"PARANJAPE GRIHA NIRMAN PVT LTD",
"PARANJAPE PREMISES PRIVATE LIMITED",
"PARANJAPE SCHEMES CONSTRUCTION LIMITED",
"PARANJAPE SPACES AND SERVICES PRIVATE LIMITED",
"PARANKUSH FOOD PROCESSING & RICE MILL PRIVATE LIMITED",
"PARANTHAMAN EXPORTERS",
"PARAPO CRAFTAILS",
"PARAS AEROSPACE PRIVATE LIMITED",
"PARAS AGRI BUSINESS PRIVATE LIMITED",
"PARAS ALUMINIUM PRIVATE LIMITED",
"PARAS ART STUDIO PRIVATE LIMITED",
"PARAS AUTO WHEELS PRIVATE LIMITED",
"PARAS BIOTECH PRIVATE LIMITED",
"PARAS BRASS EXTRUSION PRIVATE LIMITED",
"PARAS BUILDTECH INDIA PRIVATE LIMITED",
"PARAS CADD PRIVATE LIMITED",
"PARAS CAPFIN COMPANY PRIVATE LIMITED",
"PARAS CASTING AND ALLOYS PRIVATE LIMITED",
"PARAS CLEARING & FORWARDING AGENCIES PRIVATE LIMITED",
"PARAS CONSTRO-HUB PRIVATE LIMITED",
"PARAS COTSPIN LIMITED",
"PARAS DEALTRADE PRIVATE LIMITED",
"PARAS DEFENCE & SPACE TECHNOLOGIES LIMITED",
"PARAS DIAMONDS PVT LTD",
"PARAS DYEING AND PRINTING MILLS",
"PARAS DYES & CHEMICALS PRIVATE LIMITED",
"PARAS ENERGY PRIVATE LIMITED",
"PARAS ENGINEERING WORKS (MUMBAI) PRIVATE LIMITED",
"PARAS FABPLAST PRIVATE LIMITED",
"PARAS FITTINGS PRIVATE LIMITED",
"PARAS FOODS",
"PARAS FOREX PRIVATE LIMITED",
"PARAS GENETECH PRIVATE LIMITED",
"PARAS GLASS WARE PRIVATE LIMITED",
"PARAS GYPSUM PLASTER",
"PARAS HEALTHCARE PRIVATE LIMITED",
"PARAS HOLIDAYS PRIVATE LIMITED",
"PARAS HOMES PVT LTD",
"PARAS HOUSING (INDIA) PRIVATE LIMITED",
"PARAS HYDROTECH PRIVATE LIMITED",
"PARAS IMPO-EXPO PRIVATE LIMITED",
"PARAS INTERMEDIATES PRIVATE LIMITED",
"PARAS LABORATORIES LIMITED",
"PARAS LAMINATES PRIVATE LIMITED",
"PARAS LIFESTYLES PRIVATE LIMITED",
"PARAS MEDICAL AGENCY PRIVATE LIMITED",
"PARAS MEDICINES PRIVATE LIMITED",
"PARAS MIRACLE POLY PRODUCTS PRIVATE LIMITED",
"PARAS MOOL CHAND CHATTER HOSPITALS PRIVATE LIMITED",
"PARAS MOTORCOACHES PRIVATE LIMITED",
"PARAS NUTRIMENT PRIVATE LIMITED",
"PARAS NUTRITION PRIVATE LIMITED",
"PARAS OFFSET PRIVATE LIMITED",
"PARAS OIL EXTRACTION PRIVATE LIMITED",
"PARAS OXIDE PRIVATE LIMITED",
"PARAS PAN PRODUCTS PRIVATE LIMITED",
"PARAS PANNA FAB TEX PRIVATE LIMITED",
"PARAS PARIVAAR PRIVATE LIMITED",
"PARAS PEN PVT LTD",
"PARAS PETROFILS LIMITED",
"PARAS PLAZA PRIVATE LIMITED",
"PARAS POLY FAB PRIVATE LIMITED",
"PARAS POLYCAB PRIVATE LIMITED",
"PARAS POLYMERS PRIVATE LIMITED",
"PARAS POWER AND COAL BENEFICATION LIMITED",
"PARAS POWER ENGINEERING PRIVATE LIMITED",
"PARAS PUBLIC SCHOOL",
"PARAS PUBLICATION PRIVATE LIMITED",
"PARAS PUMP PRIVATE LIMITED",
"PARAS PVC PIPES & FITTINGS PRIVATE LIMITED",
"PARAS RAILTECH PRIVATE LIMITED",
"PARAS RAM TEXTILES PVT LTD",
"PARAS RAMPURIA HOTELS PRIVATE LIMITED",
"PARAS RANG RASAYAN PRIVATE LIMITED",
"PARAS RE FACILITIES MANAGEMENT PRIVATE LIMITED",
"PARAS REALTECH LIMITED",
"PARAS RICE PRODUCTS PRIVATE LIMITED",
"PARAS RINGS PRIVATE LIMITED",
"PARAS SEASONS HAVEN PRIVATE LIMITED",
"PARAS SEEDS PRIVATE LIMITED",
"PARAS SHARE BROKERS PRIVATE LIMITED",
"PARAS SPICES PRIVATE LIMITED",
"PARAS TARP INDUSTRIES",
"PARAS TEA PRODUCTS PRIVATE LIMITED",
"PARAS TRAVEL LINES",
"PARAS VANASPATI PRIVATE LIMITED",
"PARAS WEBCOAT PRIVATE LIMITED",
"PARAS WIRES PRIVATE LIMITED,",
"PARASAKTHI CEMENTS INDUSTRIES LIMITED",
"PARASAKTHI TRADING COMPANY PRIVATE LIMITED",
"PARASAKTI CEMENTS INDUSTRIES LIMITED",
"PARASAVNATH CARS PRIVATE LIMITED",
"PARASAVNATH MOTORS PRIVATE LIMITED",
"PARASHAR AGROTECH BIO PRIVATE LIMITED",
"PARASHAR AUTOMOBILES PRIVATE LIMITED",
"PARASHAR MICRO MEASUREMENT PRIVATE LIMITED",
"PARASHAR MOTORS PRIVATE LIMITED",
"PARASHARA SOFTWARE PRIVATE LIMITED",
"PARASHAV WEAVING & TEXTILES PRIVATE LIMITED",
"PARASHMANI MEDICAL CENTRE PRIVATE LIMITED",
"PARASHMONI CONSTRUCTION PRIVATE LIMITED",
"PARASMAL PAGARIYA AND SONS",
"PARASMANI BUILDWELL PRIVATE LIMITED",
"PARASMANI ENTERPRISES PRIVATE LIMITED",
"PARASMANI GEMS PRIVATE LIMITED",
"PARASMANI MARBLES PRIVATE LIMITED",
"PARASMANI PLANING & DEVELOPMENT PRIVATE LIMITED",
"PARASMANI ROADLINES PVT LTD",
"PARASMANI SEEDS PRIVATE LIMITED",
"PARASMANI TUBES PVT LTD",
"PARASMONI ORGANIC & AGRI-PRODUCTS PRIVATE LIMITED",
"PARASNATH AND ASSOCIATES PRIVATE LIMITED",
"PARASNATH HOUSEHOLD PRIVATE LIMITED",
"PARASNATH INDUSTRIES PRIVATE LIMITED",
"PARASNATH LOOMTEX PRIVATE LIMITED",
"PARASNATH ORGANICS PRIVATE LIMITED",
"PARASNATH PRINTERS PRIVATE LIMITED",
"PARASNATH TECHGARMENTS PRIVATE LIMITED",
"PARASOFT INDIA PRIVATE LIMITED",
"PARASOL LABORATORIES INDIA PRIVATE LIMITED",
"PARASOL TELECOM SOLUTION PRIVATE LIMITED",
"PARASON MACHINERYINDIA PRIVATE LIMITED",
"PARASPARAGON PRIVATE LIMITED",
"PARASPRITHVI JEWELS LLP",
"PARASPYARA COMMERCIAL PRIVATE LIMITED",
"PARASRAM FABRICS PRIVATE LIMITED",
"PARASRAM MANNULAL DALL MILL PRIVATE LIMITED",
"PARASRAMKA ENGINEERING PVT LTD",
"PARASRAMKA TRADE LINK PRIVATE LIMITED",
"PARAS-RAM-PURIA CEMENT PRIVATE LIMITED",
"PARASRAMPURIA ENGINEERS PRIVATE LIMITED",
"PARASRAMPURIA FOREX SERVICES PRIVATE LIMITED",
"PARASRAMPURIA TEXTILES PVT LTD",
"PARASRATNA REAL ESTATE (INDIA) LIMITED",
"PARASU DENTAL HOSPITALS PRIVATE LIMITED",
"PARATECH CONSTRUCTIONS PRIVATE LIMITED",
"PARATUS REAL ESTATES PRIVATE LIMITED",
"PARAYIL AGRO FOODS PRIVATE LIMITED",
"PARAYIL FOOD PRODUCTS PRIVATE LIMITED",
"PARAZELSUS INDIA PRIVATE LIMITED",
"PARBA INTERNATIONAL PRIVATE LIMITED",
"PARBATI GHANASHYAM RICE MILLS PRIVATE LIMITED",
"PARBATI KOLDAM TRANSMISSION COMPANY LIMITED",
"PARBATI MOTORS PRIVATE LIMITED",
"PARBATI TYRES & TUBES PRIVATE LIMITED",
"PARBHANI AGROTECH PRIVATE LIMITED",
"PARBHAT HEAVY FORGE PRIVATE LIMITED",
"PARBHAT INFRATECH PRIVATE LIMITED",
"PARBHAT METALS & ALLOYS PRIVATE LIMITED",
"PARBHUDAS KISHOREDAS TOBACCO PRODUCTS PRIVATE LIMITED",
"PARC DESIGNS PRIVATE LIMITED",
"PARC ROBOTIC SYSTEMS PRIVATE LIMITED",
"PARCELHERO INDIA PRIVATE LIMITED",
"PARCHABBISPUR UTTAR PRIMARY SCHOOL",
"PARCHAND STEEL PRIVATE LIMITED",
"PARCHURE ENGINEERS PRIVATE LIMITED",
"PARCO ENGINEERS (MUMBAI) PRIVATE LIMITED",
"PARCO INSTITUTE OF MEDICAL SCIENCES PRIVATE LIMITED",
"PARCOMM HYDRAULICS PRIVATE LIMITED",
"PARCON INDIA PRIVATE LIMITED",
"PARCOS CONTROL AND SYSTEMS PRIVATE LIMITED",
"PARDA AGENCIES PVT LTD",
"PARDAYA MEMORIAL HOSPITAL",
"PARDEEP ELECTRICALS & BUILDERS PRIVATE LIMITED",
"PARDEEP HATCHERIES PRIVATE LIMITED",
"PARDEEP ISPAT PRIVATE LIMITED",
"PARDES QUICK FOODS & DEHYDRATION PRIVATE LIMITED",
"PARDESHI VISHAL AUTO PRIVATE LIMITED",
"PARDESHI ZIGWHEELS PRIVATE LIMITED",
"PARDESI DEVELOPERS PRIVATE LIMITED",
"PARDHANANI INTERNATIONAL INVESTMENTS & HOLDINGS PRIVATE LIMITED",
"PARDIAM EXPORTS PRIVATE LIMITED",
"PARDOS REAL ESTATE PRIVATE LIMITED",
"PARDY PANDA STUDIOS PRIVATE LIMITED",
"PARE INNOVATIONS PRIVATE LIMITED",
"PAREBA LOGISTICS PRIVATE LIMITED",
"PAREECHA STOCK BROKERS PRIVATE LIMITED",
"PAREEK POWER & PUMPS PRIVATE LIMITED",
"PAREEN JEWELS PRIVATE LIMITED",
"PAREENA BUILDERS & PROMOTERS PRIVATE LIMITED",
"PAREENA FASHION PRIVATE LIMITED",
"PAREENA INFRASTRUCTURES PRIVATE LIMITED",
"PAREENA METALS PRIVATE LIMITED",
"PAREKH CARDS PRIVATE LIMITED",
"PAREKH ENGINEERING WORKS PRIVATE LIMITED",
"PAREKH GADGETS PRIVATE LIMITED",
"PAREKH INNOVATIVE LOGISTICS SOLUTIONS PRIVATE LIMITED",
"PAREKH INTEGRATED SERVICES PRIVATE LIMITED",
"PAREKH JEWELLERS LIMITED",
"PAREKH MARINE SERVICES PRIVATE LIMITED",
"PAREKH MARKETING LIMITED",
"PAREKH MEDISALES PRIVATE LIMITED",
"PAREKH METAL INDUSTRIES PVT LTD",
"PAREKH PLASTICHEM DISTRIBUTORS LLP",
"PAREKH SHARE CONSULTANCY SERVICES PRIVATE LIMITED",
"PAREKH TEXTILES PRIVATE LIMITED",
"PAREKH TIMBER PRIVATE LIMITED",
"PAREKH VINYLES PRIVATE LIMITED",
"PAREKHPLAST INDIA LIMITED",
"PAREKHS HOSPITAL PRIVATE LIMITED",
"PAREL HOSPITAL PRIVATE LIMITED",
"PARENTOF THOUGHT NET SOLUTIONS PRIVATE LIMITED",
"PARENTPAY INDIA PRIVATE LIMITED",
"PARERHAT CHEMICALS PRIVATE LIMITED",
"PARERHAT INFRASTRUCTURE PRIVATE LIMITED",
"PARESH AGRO PRIVATE LIMITED",
"PARESH CONSTRUCTIONS AND FOUNDATIONS PRIVATE LIMITED",
"PARESH FOREX PRIVATE LIMITED",
"PARESH PLASTICS PVT LTD",
"PARESH TEA COMPANY PRIVATE LIMITED",
"PARETO CAPITAL FINANCE PRIVATE LIMITED",
"PAREWA INTERIORS PRIVATE LIMITED",
"PAREXEL INTERNATIONAL CLINICAL RESEARCH PRIVATE LIMITED",
"PAREXEL INTERNATIONAL INDIA PRIVATE LIMITED",
"PAREXEL INTERNATIONAL INDIA SAFETY SERVICES PRIVATE LIMITED",
"PAREXEL INTERNATIONAL SERVICES INDIA PRIVATE LIMITED",
"PARFAIT ENGINEERS & CONTRACTORS PRIVATE LIMITED",
"PARFAIT FINANCE AND INVESTMENTS PRIVATE LIMITED",
"PARFAIT LINGERIE INDIA PRIVATE LIMITED",
"PARFAIT METALS PRIVATE LIMITED",
"PARGAON MADHYAMIK V UCCHA MADHYAMIK VIDYALAYA BEED",
"PARGRO INVESTMENTS PRIVATE LIMITED",
"PARI AGENCIES PRIVATE LIMITED",
"PARI AGRI GRAIN INDUSTRIES PRIVATE LIMITED",
"PARI COMPUTERS PRIVATE LIMITED",
"PARI INDIA",
"PARI MACHINERY (INDIA) PRIVATE LIMITED",
"PARI WASHINGTON COMPANY ADVISORS PRIVATE LIMITED",
"PARI WASHINGTON INVESTMENT MANAGERS PRIVATE LIMITED",
"PARIADI EXIM PRIVATE LIMITED",
"PARICHAY DEPARTMENT STORES PRIVATE LIMITED",
"PARICHAY HOTELS PRIVATE LIMITED",
"PARICHHA THERMAL POWER PROJECT PARICHHA JHANSI",
"PARICOTT INDIA PAPERCUP PRIVATE LIMITED",
"PARIDHAN GARMENT PARK WELFARE ASSOCIATION",
"PARIDHAN TEXFAB PRIVATE LIMITED",
"PARIDHI APPARELS PRIVATE LIMITED",
"PARIDHI FASHIONS PRIVATE LIMITED",
"PARIDHI FINVEST PRIVATE LIMITED",
"PARIDHI HEALTH CARE PRIVATE LIMITED",
"PARIDHI HEALTHCARE PRIVATE LIMITED.",
"PARIDHI SAREES PRIVATE LIMITED",
"PARIHAR & COMPANY",
"PARIHAR AGRO PRIVATE LIMITED",
"PARIHAR BNTSISSKARU VENTI PRIVATE LIMITED",
"PARIHAR GRANITES PRIVATE LIMITED",
"PARIHAR PLASTIC AND HARDWARE",
"PARIHAR'S MILAN MITHAI PRIVATE LIMITED",
"PARIINFRA INDUSTRIES PRIVATE LIMITED",
"PARIJA CONSTRUCTION COMPANY PRIVATE LIMITED",
"PARIJAAT METALS & MINERALS PRIVATE LIMITED",
"PARIJAT AGROWOOD PRODUCTS PRIVATE LIMITED",
"PARIJAT ENTERTAINMENT PRIVATE LIMITED",
"PARIJAT FITNESS PRIVATE LIMITED",
"PARIJAT INDUSTRIES INDIA PRIVATE LIMITED",
"PARIJAT INNOVATIONS PRIVATE LIMITED",
"PARIJAT INVESTMENTS LTD",
"PARIJAT LOGISTICS PRIVATE LIMITED",
"PARIJAT MINING INDUSTRIES (INDIA) PRIVATE LIMITED",
"PARIJAT OIL AND FEEDS PRIVATE LIMITED",
"PARIJAT PAPER MILLS LIMITED",
"PARIJATA TRADING PRIVATE LIMITED",
"PARIJATHA BUSINESS SOLUTION PRIVATE LIMITED",
"PARIJATHA HOMES AND DEVELOPERS PRIVATE LIMITED",
"PARIK ROADWAYS PRIVATE LIMITED",
"PARIKALP CARE LIMITED",
"PARIKAR BUSINESS & KNOWLEDGE SERVICES PRIVATE LIMITED",
"PARIKAR PHARMACHEM PRIVATE LIMITED",
"PARIKH AND KULKARNI CONSULTING ENGINEERS PVT LTD",
"PARIKH BIKES PRIVATE LIMITED",
"PARIKH BROTHERS",
"PARIKH CHEMICAL INDUSTRIES",
"PARIKH CLEARING AGENCY PRIVATE LIMITED",
"PARIKH ENTERPRISE PRIVATE LIMITED",
"PARIKH FLEXIBLES PRIVATE LIMITED",
"PARIKH INFO SOLUTIONS PRIVATE LIMITED",
"PARIKH INVESTMENT AND DEVELOPMENT PRIVATE LIMITED",
"PARIKH MARKETING PRIVATE LIMITED",
"PARIKH MEDICAL AGENCIES",
"PARIKH METACAST PRIVATE LIMITED",
"PARIKH METALIKS PRIVATE LIMITED",
"PARIKH PACKAGING PRIVATE LIMITED",
"PARIKH POWER PRIVATE LIMITED",
"PARIKH REAL ESTATE MANAGEMENT PRIVATE LIMITED",
"PARIKH TRAVELS AND TOURS",
"PARIKSHA LABS PRIVATE LIMITED",
"PARIKSHIT CONSTRUCTION PRIVATE LIMITED",
"PARIKSHIT DECOR PRIVATE LIMITED",
"PARIKSHIT GARH INTER COLLEGE",
"PARIKSHIT HOSPITALITY PRIVATE LIMITED",
"PARIKSHIT INDUSTRIES PRIVATE LIMITED",
"PARIKSHIT LAMINATE PRIVATE LIMITED",
"PARIKUSH BUSINESS SOLUTIONS PRIVATE LIMITED",
"PARILAY GLOBAL ENTERPRISE PRIVATE LIMITED",
"PARIM FINSERV PRIVATE LIMITED",
"PARIMAL (ELECTRICAL) SERVICES PRIVATE LIMITED",
"PARIMAL CLEAN-ENERGY SYSTEMS PRIVATE LIMITED",
"PARIMAL POLYPET INDUSTRIES LIMITED",
"PARIMALA AGRO FOODS AND FEEDS PRIVATE LIMITED",
"PARIMALA EXTRACTIONS PRIVATE LIMITED",
"PARIMITY SOLUTIONS & SERVICES PRIVATE LIMITED",
"PARIN CASTING PRIVATE LIMITED",
"PARIN DHEVI HOSPITALS",
"PARIN FURNITURE PRIVATE LIMITED",
"PARIN MULTIMEDIA PRIVATE LIMITED",
"PARIN ORNA PRIVATE LIMITED",
"PARINAAM FOUNDATION",
"PARINAMITRA ELECTRICALS PRIVATE LIMITED",
"PARINAY COMMUNICATIONS PRIVATE LIMITED",
"PARINDHEVI HOSPITALS",
"PARINEE CONTOUR CONSTRUCTION PRIVATE LIMITED",
"PARINEE HOMES PRIVATE LIMITED",
"PARINEE REALTY PRIVATE LIMITED",
"PARINEE SHELTERS PRIVATE LIMITED",
"PARINITA INVESTMENTS PRIVATE LIMITED",
"PARINITA PROJECTS PRIVATE LIMITED",
"PARINOX PRIVATE LIMITED",
"PARIPLAY INDIA PRIVATE LIMITED",
"PARIPOORNA SHELTERS PRIVATE LIMITED",
"PARIPOORNA SOFTWARE SOLUTION SERVICE PRIVATE LIMITED",
"PARIPOSA SEEDS INDIA PRIVATE LIMITED",
"PARIPURNA SEEDS PRIVATE LIMITED",
"PARIS AGROTECH",
"PARIS ELYSEES INDIA PRIVATE LIMITED",
"PARIS GARMENTS CATERS & GENERAL ORDER SUPPLIER",
"PARISHEK FINANCE PRIVATE LTD",
"PARISHIL LABORATORIES PRIVATE LIMITED",
"PARISHRAM FAB PRIVATE LIMITED",
"PARISHRAM INDUSTRIES PRIVATE LIMITED",
"PARISHRAM RESOURCES PRIVATE LIMITED",
"PARISHRAMA EDUCATION PRIVATE LIMITED",
"PARISHUDH FIBRES PVT. LTD",
"PARISHUDH MACHINES PRIVATE LIMITED",
"PARISKQ IOT SOLUTIONS PRIVATE LIMITED",
"PARISOHA FOUNDATION PRIVATE LIMITED",
"PARISON POLYMERS PRIVATE LIMITED",
"PARISONS AGROTECH PRIVATE LIMITED",
"PARISONS ESTATES AND INDUSTRIES PRIVATE LIMITED",
"PARISONS FOODS PRIVATE LIMITED",
"PARISONS INFRASTRUCTURE PRIVATE LIMITED",
"PARISONS MILLING COMPANY PRIVATE LIMITED",
"PARISONS ROLLER FLOUR MILLS PRIVATE LIMITED",
"PARISONS TRADING PRIVATE LIMITED",
"PARISUDH ECO CONCEPTS PRIVATE LIMITED",
"PARISUDHAM OILS PRIVATE LIMITED",
"PARITOSH COLD STORAGE PRIVATE LIMITED",
"PARITOSH ELECTRICALS PVT LTD",
"PARITOSH ESTATES PRIVATE LIMITED",
"PARITOSH GHOSH CONSTRUCTION PVT LTD",
"PARITRASHA FINANCIALS & INVESTMENTS PRIVATE LIMITED",
"PARITY CONSULTING AND TRAINING PRIVATE LIMITED",
"PARITY CONSUMER CARE PRIVATE LIMITED",
"PARITY CUBE PRIVATE LIMITED",
"PARITY INFOTECH SOLUTIONS PRIVATE LIMITED",
"PARIVAHAN SEWA",
"PARIVAR ENCLAVE PRIVATE LIMITED",
"PARIVAR FOREX PRIVATE LIMITED",
"PARIVAR HOSPITAL MULTI SPECIALITY AND RESEARCH CENTER",
"PARIVAR REAL ESTATE & DEVELOPERS PRIVATE LIMITED",
"PARIVARTAN AGRO & REAL ESTATE INDIA PRIVATE LIMITED",
"PARIVARTAN FOODS AND BEVERAGES PRIVATE LIMITED",
"PARIVARTAN PREMIUM FACILITY SERVICES PRIVATE LIMITED",
"PARIVARTANA CONSULTING PRIVATE LIMITED",
"PARIVARTANA PU COLLEGE",
"PARIVESH CREATION PRIVATE LIMITED",
"PARIVESH DEVELOPERS AND BUILDERS PRIVATE LIMITED",
"PARIWAR DEVELOPERS & TRADERS PRIVATE LIMITED",
"PARIWAR FINANCE AND INVESTMENT (INDIA) LIMITED",
"PARIWAR NAMKEEN AND SNACKS PRIVATE LIMITED",
"PARIWAR SEEDS PRIVATE LIMITED",
"PARIWAR TRADING COMPANY PRIVATE LIMITED",
"PARIXIT IRRIGATION LIMITED",
"PARIYATH ESTATES PRIVATE LIMITED",
"PARIYUR AMMAN SPINNING MILLS PRIVATE LIMITED",
"PARK AVENUE HOSPITALITY SERVICES PRIVATE LIMITED",
"PARK CERAMICS PRIVATE LIMITED",
"PARK CHAMBERS LTD",
"PARK CITY CO.OP HSG. SOC. LTD SILVASSA",
"PARK COLLEGE OF ENGG - 638659",
"PARK COMMON EFFLUENT TREATMENT PLANT PRIVATE LIMITED",
"PARK CONTINENTAL PRIVATE LIMITED",
"PARK CONTROLS & COMMUNICATIONS PRIVATE LIMITED",
"PARK DIAGNOSTICS CENTRE PRIVATE LIMITED",
"PARK GLOBAL METALS PRIVATE LIMITED",
"PARK HEALTH SYSTEMS PRIVATE LIMITED",
"PARK HOLIDAYS AND RESORTS PRIVATE LIMITED",
"PARK HOSPITALS",
"PARK HYATT CHENNAI",
"PARK HYATT HYDERABAD",
"PARK INFRA HI PRIVATE LIMITED",
"PARK INFRASTRUCTURE LIMITED",
"PARK INN BY RADDISON IP EXTN",
"PARK INN BY RADISSON",
"PARK INTELLI SOLUTIONS PRIVATE LIMITED",
"PARK LINE CLOTHING PRIVATE LIMITED",
"PARK MEDI WORLD PRIVATE LIMITED",
"PARK MEDICENTERS AND INSTITUTIONS PRIVATE LIMITED",
"PARK MEDICITY (HARYANA) PRIVATE LIMITED",
"PARK MEDICITY PRIVATE LIMITED",
"PARK MEDICLAIM TPA PRIVATE LIMITED",
"PARK N CHEM PHARMACEUTICALS PRIVATE LIMITED",
"PARK NEST HOTELS PRIVATE LIMITED",
"PARK NETWORK PRIVATE LIMITED",
"PARK NURSERY & PRIMARY SCHOOL",
"PARK NURSING HOME AND DIAGNOSITC CLINIC PVT LTD",
"PARK PHARMACEUTICALS",
"PARK PLACE TECHNOLOGIES INDIA PRIVATE LIMITED",
"PARK PLAZA",
"PARK PRIVIERA HOSPITALITY PRIVATE LIMITED",
"PARK PROJECTS CONSULTANCY PRIVATE LIMITED",
"PARK RETAIL MARKETING PRIVATE LIMITED",
"PARK SARVAMANGLA PROJECTS PRIVATE LIMITED",
"PARK SMART SOLUTIONS LIMITED",
"PARK SUITES PRIVATE LIMITED",
"PARK TOWN COMPLEX PRIVATE LIMITED",
"PARK VIEW FACILITIES PRIVATE.LIMITED",
"PARK VIEW HOSPITALITY AND HOTEL PRIVATE LIMITED",
"PARK WELLNESS SERVICES PRIVATE LIMITED",
"PARKAR AGROTECH PRIVATE LIMITED",
"PARKAR COMMUNICATIONS PRIVATE LIMITED",
"PARKAR CONSULTING PRIVATE LIMITED",
"PARKAR GLOBAL TECHNOLOGIES PRIVATE LIMITED",
"PARKAR HOSPITAL AND RESEARCH INSTITUTE PRIVATE LIMITED",
"PARKAR LOGISTICS PRIVATE LIMITED",
"PARKAR MEDICAL FOUNDATIONS SCHOOL OF NURSING RATNAGIRI",
"PARKASH AMUSEMENT RIDES AND FUN WORLD PRIVATE LIMITED",
"PARKASH AUTOMOTIVE INDUSTRIES PRIVATE LIMITED",
"PARKASH BEVERAGES PRIVATE LIMITED",
"PARKASH CANDLE WORKS PRIVATE LIMITED",
"PARKASH CONFECTIONERS AND BAKERS PRIVATE LIMITED",
"PARKASH CONTRACTORS PRIVATE LIMITED",
"PARKASH ENTERPRISES PRIVATE LIMITED",
"PARKASH HANDLOOM PRIVATE LIMITED",
"PARKASH INFRASTRUCTURE AND DEVELOPERS PRIVATE LIMITED",
"PARKASH MONOMERS PRIVATE LIMITED",
"PARKASH MULTIMETALS PRIVATE LIMITED",
"PARKASH PULSES",
"PARKASH THREADS AND POLYTEX PRIVATE LIMITED",
"PARKCITY SPORTING VENTURES PRIVATE LIMITED",
"PARKEEN PNEUMATICS PVT LTD",
"PARKEM DYES AND CHEMICALS PRIVATE LIMITED",
"PARKEN SOLUTION PRIVATE LIMITED",
"PARKER AGRO-CHEM EXPORTS LIMITED",
"PARKER AGROCHEM PRODUCTS PRIVATE LIMITED",
"PARKER BIOTECH PRIVATE LIMITED",
"PARKER BUILDERS PRIVATE LIMITED",
"PARKER DERIVATIVES(INDIA) PRIVATE LIMITED",
"PARKER ELECTRONICS PRIVATE LIMITED",
"PARKER ENGINEERING (INDIA) PRIVATE LIMITED",
"PARKER ESTATE DEVELOPERS PRIVATE LIMITED",
"PARKER FINANCIAL SERVICES PRIVATE LIMITED",
"PARKER HANNIFIN INDIA PRIVATE LIMITED",
"PARKER IMPERIUM SERVICES PRIVATE LIMITED",
"PARKER INDUSTRIES PRIVATE LIMITED",
"PARKER MULTI-COMMODITIES (INDIA) PRIVATE LIMITED",
"PARKER OVERSEAS PRIVATE LIMITED",
"PARKER SECURITY AND ALLIED SERVICES PRIVATE LIMITED",
"PARKER TILES PRIVATE LIMITED",
"PARKER VRC INFRASTRUCTURE PRIVATE LIMITED",
"PARKER-HANNIFIN CORPORATION",
"PARKER-PCP AUTO COMPONENTS PRIVATE LIMITED",
"PARKHI HOSPITALITY",
"PARKHYA SOLUTIONS PRIVATE LIMITED",
"PARKINS MANAGEMENT SERVICES PRIVATE LIMITED",
"PARKINSON- SAN SYSTEMS PRIVATE LIMITED",
"PARKKOT MARITIMA AGENCIES PRIVATE LIMITED",
"PARKLAND HOME SOLUTIONS PRIVATE LIMITED",
"PARKLANDS SOLAR PRIVATE LIMITED",
"PARKLANE AUTO PRIVATE LIMITED",
"PARKLANE MOTORS PRIVATE LIMITED",
"PARKLAYER PRIVATE LIMITED",
"PARKLETON PRIVATE LIMITED",
"PARKLIGHT SECURITIES PRIVATE LIMITED",
"PARKLINE DIAGNOSTICS PRIVATE LIMITED",
"PARKMAN ELASTOMERS PRIVATE LIMITED",
"PARKMILL INDUSTRIES PRIVATE LIMITED",
"PARKMORE PRIVATE LIMITED",
"PARKNSECURE INDIA PRIVATE LIMITED",
"PARKQUILITY PRIVATE LIMITED",
"PARKSHED INDIA PRIVATE LIMITED",
"PARKSLEY GLOBAL PRIVATE LIMITED",
"PARKSMART TECHNOLOGIES PRIVATE LIMITED",
"PARKSONS CARTAMUNDI PRIVATE LIMITED",
"PARKSONS DYESTUFF INDUSTRIES PRIVATE LIMITED",
"PARKSONS ENGINEERING CO. PRIVATE LIMITED",
"PARKSONS GRAPHICS PRIVATE LIMITED",
"PARKSONS PACKAGING LIMITED",
"PARKVICTORIA HOTELS PRIVATE LIMITED",
"PARKVIEW CITY LIMITED",
"PARKVIEW FACILITIES PRIVATE LIMITED",
"PARKVIEW HOTELS PRIVATE LIMITED",
"PARKWAY SALES PRIVATE LIMITED",
"PARKWOOD ESTATES PRIVATE LIMITED",
"PARKWOOD INFRASTRUCTURE PRIVATE LIMITED",
"PARLAX INFRASTRUCTURES PRIVATE LIMITED",
"PARLAY ENGINEERING AND CONSTRUCTION PRIVATE LIMITED.",
"PARLE AGRO PRIVATE LIMITED",
"PARLE BISCUITS PRIVATE LIMITED",
"PARLE BISLERI PRIVATE LIMITED",
"PARLE ELIZABETH TOOLS PRIVATE LIMITED",
"PARLE FRUITS AND FOODS PRIVATE LIMITED",
"PARLE GLOBAL TECHNOLOGIES PRIVATE LIMITED",
"PARLE KOVAI MACHINERY PRIVATE LIMITED",
"PARLE PRODUCTS PRIVATE LIMITED",
"PARLE TILAK VIDAYALAYA ASSOCIATIONS",
"PARLE TILAK VIDYALAYA ASSOCIATION",
"PARLIAMENT OF INDIA LOK SABHA SECRE",
"PARLIAMENT OF INDIA RAJYA SABHA SECRETARIAT",
"PARLOK TEXTILES PRIVATE LIMITED",
"PARMA AND PARMA (INDIA) PVT LIMITED",
"PARMA CLIMA TECHNOLOGIES INDIA PRIVATE LIMITED",
"PARMA IMPEX PRIVATE LIMITED",
"PARMA TEXTILES PRIVATE LIMITED",
"PARMAARTH INTERNATIONAL TRADING PRIVATE LIMITED",
"PARMAN BUILDCON PRIVATE LIMITED",
"PARMANAND & SONS FOOD PRODUCTS PRIVATE LIMITED",
"PARMANAND ANIL BHATIA COLD STORAGE PRIVATE LIMITED",
"PARMANAND MARKETING PRIVATE LIMITED",
"PARMANANDKA FABYARN MILLS PRIVATE LIMITED",
"PARMAR DEVELOPERS AND PROPERTIES PRIVATE LIMITED",
"PARMAR DIGITAL AND CONSULTANCY SERVICES PRIVATE LIMITED",
"PARMAR INTERNATIONAL PRIVATE LIMITED",
"PARMAR JEWELLERS PRIVATE LIMITED",
"PARMAR LOGISTICS PRIVATE LIMITED",
"PARMAR METALS PRIVATE LIMITED",
"PARMAR PROPERTIES PRIVATE LIMITED",
"PARMAR RICE AND SEEDS PRIVATE LIMITED",
"PARMAR STEEL TUBES PRIVATE LIMITED",
"PARMAR THERMOPACK PRIVATE LIMITED",
"PARMARTH INDUSTRIES PRIVATE LIMITED",
"PARMARTH WIND ENERGY PRIVATE LIMITED",
"PARMATMA ALLIED FEED COMPANY PRIVATE LIMITED",
"PARMATMA COTTONS PRIVATE LIMITED",
"PARMAX PHARMA LIMITED",
"PARMAZ ESTATES PRIVATE LIMITED",
"PARMESH CONSTRUCTION COMPANY LIMITED",
"PARMESH FINLEASE LIMITED",
"PARMESHWAR ALLOYS PRIVATE LIMITED",
"PARMESHWAR COLD STORAGE PRIVATE LIMITED",
"PARMESHWAR ELECTROTECH PRIVATE LIMITED",
"PARMESHWAR IMPEX PRIVATE LIMITED",
"PARMESHWAR INDUSTRIES PRIVATE LIMITED",
"PARMESHWAR METAL LIMITED",
"PARMESHWARI (INDIA) PRIVATE LIMITED",
"PARMESHWARI ENTERPRISES PRIVATE LIMITED",
"PARMESHWARI ICECREAM PRIVATE LIMITED",
"PARMESHWARI POLYPLAST (INDIA) PRIVATE LIMITED",
"PARMESHWARI SILK MILLS LIMITED",
"PARMESHWARKRUPA INFRACON PRIVATE LIMITED",
"PARMESWARI STRIPS PRIVATE LIMITED",
"PARMESWRI SALE AND SERVICES PRIVATE LIMITED",
"PARMEX SERVICES PRIVATE LIMITED",
"PARNACELL CHEMICALS PRIVATE LIMITED",
"PARNAMI AGROTECH PRIVATE LIMITED",
"PARNAMI BUILDCON PRIVATE LIMITED",
"PARNAMI HOSPITALS PVT LTD",
"PARNAMI INCENSE PRIVATE LIMITED",
"PARNAMI LOGISTICS AND PACKING CENTRE PRIVATE LIMITED",
"PARNAMI LOGISTICS INDIA PRIVATE LIMITED",
"PARNAMI PUMP AND PROJECT PRIVATE LIMITED",
"PARNAMI SALES CORPORATION",
"PARNAMI SECURITY & MAN POWER SERVICES PRIVATE LIMITED",
"PARNASA MEDIWORLD PRIVATE LIMITED",
"PARNASHA ENGINEERS PRIVATE LIMITED",
"PARNAV AGENCIES PRIVATE LIMITED",
"PARNAV ONLINE SOLUTIONS PRIVATE LIMITED",
"PARNAX LAB LIMITED",
"PARNEET TEXTILES PRIVATE LIMITED",
"PARNER TALUKA SAINIK SAHAKARI BANK LTD",
"PARNIKA COMMERCIAL AND ESTATES PRIVATE LIMITED",
"PARNIKA ESTATES PRIVATE LIMITED",
"PAROHA DEVELOPERS PRIVATE LIMITED",
"PAROMA SHOES PRIVATE LIMITED",
"PAROPKAR CONSULTANT PVT LTD",
"PAROPKAR ESTATE PRIVATE LIMITED",
"PAROSCALE TECHNOLOGIES PRIVATE LIMITED",
"PAR-PACT ENVIRONMENTAL ENGINEERING PRIVATE LIMITED",
"PARR COMPUTERS PRIVATE LIMITED",
"PARRAGON PUBLISHING INDIA PRIVATE LIMITED",
"PARRAJ MOTORS PRIVATE LIMITED",
"PARRK PETROCHEM PRIVATE LIMITED",
"PARROGATE INDUSTRIES PRIVATE LIMITED",
"PARROT INFOSOFT PRIVATE LIMITED",
"PARROT PLASTIC INDUSTRIES PRIVATE LIMITED",
"PARRY AGRI SEEDS (I) PRIVATE LIMITED",
"PARRY AGRO INDUSTRIES LIMITED",
"PARRY ENGINERING AND ELECTRONICS PRIVATE LIMITED",
"PARRY ENTERPRISES INDIA LIMITED",
"PARRY INFRASTRUCTURE COMPANY PRIVATE LIMITED",
"PARRY SUGARS REFINERY INDIA PRIVATE LIMITED",
"PARRY TECHNOLOGY INDIA PRIVATE LIMITED",
"PARRYS EASTERN PRIVATE LIMITED",
"PARSA KENTE COLLIERIES LIMITED",
"PARSAN ENGINEERS AND CONSULTANTS",
"PARSAN OVERSEAS PRIVATE LIMITED",
"PARSAN TECHNOLOGY PRIVATE LIMITED",
"PARSEE LEASING AND FINVEST LIMITED",
"PARSEKAR FOODS PRIVATE LIMITED",
"PARSEQ INDIA PRIVATE LIMITED",
"PARSERAY LOGISTICS PRIVATE LIMITED",
"PARSEWAR AND COMPANY",
"PARSHAVNATH MEDIA PRIVATE LIMITED",
"PARSHAWA MOTORS PRIVATE LIMITED",
"PARSHI TRAINING AND TECHNICAL SERVICES PRIVATE LIMITED",
"PARSHOTAM LAL AND CO.",
"PARSHURAM EDUCATIONS PRIVATE LIMITED",
"PARSHURAM FIINANCE PVT LTD",
"PARSHURAM TECHNOCRAFTS PRIVATE LIMITED",
"PARSHURAMJI-E-COMM PRIVATE LIMITED",
"PARSHV AUTORIDERS PRIVATE LIMITED",
"PARSHV LABELS PRIVATE LIMITED",
"PARSHVA AUTOCOMP PRIVATE LIMITED",
"PARSHVA COMPUTERS",
"PARSHVA DIESELS PRIVATE LIMITED",
"PARSHVA ENTERPRISES LIMITED",
"PARSHVA FOOD INTERNATIONAL",
"PARSHVA MEDICARE PRIVATE LIMITED",
"PARSHVA NIRMAN PRIVATE LIMITED",
"PARSHVA PRINT PACK PRIVATE LIMITED",
"PARSHVA TEXCHEM (INDIA) PRIVATE LIMITED",
"PARSHVAGEE INFRA PRIVATE LIMITED",
"PARSHVANATH BUILDMART PRIVATE LIMITED",
"PARSHVANATH CHARRITABLE TRUSTS",
"PARSHVANATH COMPLEX PRIVATE LIMITED",
"PARSHVANATH FINVEST PRIVATE LIMITED",
"PARSHVANATH OVERSEAS",
"PARSHVANATH PLASTIC PRIVATE LIMITED",
"PARSHVANATH REALHOME PRIVATE LIMITED",
"PARSHVANATH SALES LIMITED",
"PARSHVANATH SHARE BROKING PRIVATE LIMITED",
"PARSHVANATH TRADING AND LOGISTICS PRIVATE LIMITED",
"PARSHVANATH TURMERIC PRIVATE LIMITED",
"PARSHVI TECHNOLOGY (INDIA) PRIVATE LIMITED",
"PARSHWA COMPUTER",
"PARSHWA FIBRE GLASS PRIVATE LIMITED",
"PARSHWA FOOD (INDIA) PRIVATE LIMITED",
"PARSHWA FURNITURE PRIVATE LIMITED",
"PARSHWA INFRACREATION PRIVATE LIMITED",
"PARSHWA INFRASPACE PRIVATE LIMITED",
"PARSHWA ORGANO BIOTECH PRIVATE LIMITED",
"PARSHWA PETROCHEMICALS PRIVATE LIMITED",
"PARSHWA PRISM GEMS AND JEWELLERY LIMITED",
"PARSHWA VEER BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"PARSHWANATH BUILDCON PRIVATE LIMITED",
"PARSHWANATH CARDIAC SOLUTION PRIVATE LIMITED",
"PARSHWANATH COMMODITY PRIVATE LIMITED",
"PARSHWANATH CORPORATION LIMITED",
"PARSHWANATH DYECHEM INDUSTRIES PRIVATE LIMITED",
"PARSHWANATH ICE AND COLD STORAGE PRIVATE LIMITED",
"PARSHWANATH INFRASTRUCTURE PRIVATE LIMITED",
"PARSHWANATH ISPAT PRIVATE LIMITED",
"PARSHWANATH OVERSEAS PRIVATE LIMITED",
"PARSHWANATH POLYMERS PRIVATE LIMITED",
"PARSHWANATH PROCESS PRIVATE LIMITED",
"PARSHWANATH STONES PRIVATE LIMITED",
"PARSHWANATH TRAVELS PRIVATE LIMITED",
"PARSHWNATH PIGMENTS LIMITED",
"PARSI NARASIMHULU MEMORIAL HIGH SCHOOL",
"PARSIVA COMMTRADE PRIVATE LIMITED",
"PARSN TECHNOLOGIES PRIVATE LIMITED",
"PARSOFT SYSTEMS PRIVATE LIMITED",
"PARSON ADHESIVES INDIA PRIVATE LIMITED",
"PARSONS BRINCKERHOFF INDIA PRIVATE LIMITED",
"PARSONS NUTRITIONALS PRIVATE LIMITED",
"PARSONS PAINTS (INDIA) PRIVATE LIMITED",
"PARSURAM ARAWALI HIGHWAYS PRIVATE LIMITED",
"PARSURAM TEA MANUFACTURER PRIVATE LIMITED",
"PARSVA PACKERS PRIVATE LIMITED",
"PARSVANATH DEVELOPERS & CREATORS PRIVATE LIMITED",
"PARSVANATH VANIJYA PRIVATE LIMITED",
"PARSVATECH WORKSPACES PRIVATE LIMITED",
"PARSVIR ALLOYS PRIVATE LIMITED",
"PARSVNATH BUILDWELL PRIVATE LIMITED",
"PARSVNATH ESTATE DEVELOPERS PRIVATE LIMITED",
"PARSVNATH LANDMARK DEVELOPERS PRIVATE LIMITED",
"PARSVNATH PAPERS PRIVATE LIMITED",
"PARSVNATH REALCON PRIVATE LIMITED",
"PARSVNATH REALTY VENTURES LIMITED",
"PARSWA CONSTRUCTIONS PRIVATE LIMITED",
"PARSWA EXPORTS PRIVATE LIMITED",
"PARTAKE EXPORTS PRIVATE LIMITED",
"PARTAP COTEX PRIVATE LIMITED",
"PARTAP FABRICS PRIVATE LIMITED",
"PARTAP FOODS AND RESTAURANT PRIVATE LIMITED",
"PARTAP INDUSTRIES LIMITED",
"PARTAP INFRATECH PRIVATE LIMITED",
"PARTAP LANDMARKS PRIVATE LIMITED",
"PARTAP MOULDS AND TOOLS MANUFACTURING PRIVATE LIMITED",
"PARTAP SINGH & SONS (A.O.)",
"PARTAP SPINTEX PRIVATE LIMITED",
"PARTAP WIRES (INDIA) PRIVATE LIMITED",
"PARTECH SEEDS PRIVATE LIMITED",
"PARTENZA SOLUTIONS PRIVATE LIMITED",
"PARTEX AEROMARINE LOGISTICS PRIVATE LIMITED",
"PARTEX MARKING SYSTEMS INDIA PRIVATE LIMITED",
"PARTH BIOAGRCULTURE PRIVATE LIMITED",
"PARTH BIZLITE PRIVATE LIMITED",
"PARTH BUILTECH PRIVATE LIMITED",
"PARTH COMMERCIAL PRIVAT ELIMITED",
"PARTH COMMODITY SERVICES PRIVATE LIMITED",
"PARTH CONCAST LIMITED",
"PARTH DECOR PVT LTD",
"PARTH DIAMOND PRIVATE LIMITED",
"PARTH DYE CHEM PRIVATE LIMITED",
"PARTH ELECTRICALS & ENGINEERING PRIVATE LIMITED",
"PARTH ENERGY SYSTEMS PRIVATE LIMITED",
"PARTH ENGIMECH PRAIVATE LIMITED",
"PARTH ENGINEERING PRIVATE LIMITED",
"PARTH EQUIPMENT LIMITED",
"PARTH FOREX PRIVATE LIMITED",
"PARTH GEMJEWELS PRIVATE LIMITED",
"PARTH HEALTH CARE PRIVATE LIMITED",
"PARTH HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED",
"PARTH INFIN BROKERS PRIVATE LIMITED",
"PARTH INFOTECH SOLUTIONS PRIVATE LIMITED",
"PARTH INFRASTRUCTURE PRIVATE LIMITED",
"PARTH INTERNATIONAL PRIVATE LIMITED",
"PARTH ISPAT (INDIA) PRIVATE LIMITED",
"PARTH LABORATORIES PVT LTD",
"PARTH LIFECARE PRIVATE LIMITED",
"PARTH LOGISTICS PRIVATE LIMITED",
"PARTH NATURAL STONES PRIVATE LIMITED",
"PARTH ORNAMENTS PRIVATE LIMITED",
"PARTH PARIVAHAN PRIVATE LIMITED",
"PARTH POLY COAT YARN PRIVATE LIMITED",
"PARTH POLY FAB",
"PARTH POLY VALVES PRIVATE LIMITED",
"PARTH POLYWOVEN PVT LTD",
"PARTH PROJECTS AND CONSTRUCTION PVT LTD",
"PARTH RASAYAN PRIVATE LIMITED",
"PARTH RUBBER TECH PRIVATE LIMITED",
"PARTH SARTHI BUILDESTATE PRIVATE LIMITED",
"PARTH SCAFFOLDINGS PRIVATE LIMITED",
"PARTH SHEEL HEALTHCARE PRIVATE LIMITED",
"PARTH SPECIALTY RESINS AND MARKETING PRIVATE LIMITED",
"PARTH THREAD PRIVATE LIMITED",
"PARTH TOOLING PRIVATE LIMITED",
"PARTH UNIVERSAL PRIVATE LIMITED",
"PARTHA AGRITRADE PRIVATE LIMITED",
"PARTHA DENTAL CARE INDIA PRIVATE LIMITED",
"PARTHASARATHY TRANSPORTS PRIVATE LIMITED",
"PARTHAVA SECURITIES PRIVATE LIMITED",
"PARTHCON ENGGINFRA PRIVATE LIMITED",
"PARTHENON ARCHITECTS PRIVATE LIMITED",
"PARTHENON INDIA PRIVATE LIMITED",
"PARTHENON TECHNOLOGIES PRIVATE LIMITED",
"PARTHEX SURVEILLANCE INDIA PRIVATE LIMITED",
"PARTHIV CORPORATE ADVISORY PRIVATE LIMITED",
"PARTHIV GLOBAL INDUSTRIES PRIVATE LIMITED",
"PARTHIV POLY-EXTRUSIONS PRIVATE LIMITED",
"PARTHIVI CONSTRUCTIONS PVT LTD",
"PARTHSARTHY CONCRETE PRIVATE LIMITED",
"PARTHSARTHY INFRASTRUCTURES PRIVATE LIMITED",
"PARTHTECH DEVELOPERS LLP",
"PARTHYS REVERSE INFORMATICS ANALYTIC SOLUTIONS PRIVATE LIMITED",
"PARTI SAI CONTRACTORS PRIVATE LIMITED",
"PARTICIPATORY LEARNING AND ACTION NETWORK FOUNDATION",
"PARTICLE41 INDIA LLP",
"PARTICLES STUDIO PRIVATE LIMITED",
"PARTNERS ADVERTISING PRIVATE LIMITED",
"PARTNERS GROUP (INDIA) PRIVATE LIMITED",
"PARTON TRADERS PRIVATE LIMITED",
"PARTS CITY PRIVATE LIMITED",
"PARTSBIGBOSS LIMITED",
"PARTUM FOODS PRIVATE LIMITED",
"PARTY CRUISERS LIMITED",
"PARTYTIME ICE PRIVATE LIMITED",
"PARU SPICES PRIVATE LIMITED",
"PARUCCO FOUNDRY PRIVATE LIMITED",
"PARUCHURI COTTON PRODUCTS PRIVATE LIMITED",
"PARUL ASSOCIATES INTERIORS PRIVATE LIMITED",
"PARUL FOODS SPECIALITIES PRIVATE LIMITED",
"PARUL FOUNDRY PRIVATE LIMITED",
"PARUL HOMOEO LABORATORIES PRIVATE LIMITED",
"PARUL HOSPITAL PRIVATE LIMITED",
"PARUL INSTITUTE OF BUSINESS ADMINISTRATION",
"PARUL INSTITUTE OF ENGINEERING & TECHNOLOGY",
"PARUL INSTITUTE OF MANAGEMENT & RESEARCH",
"PARUL PRAKASHANI PRIVATE LIMITED",
"PARUL REALTORS PRIVATE LIMITED",
"PARUL TOYS INDIA PRIVATE LIMITED",
"PARUL UNIVERSITY GUJARAT",
"PARULEKARS SHIPPING PRIVATE LIMITED",
"PARUSHNI INTERIOR DESIGNS PRIVATE LIMITED",
"PARUTHI ENGINEERS PRIVATE LIMITED",
"PARV DESIGNER PRIVATE LIMITED",
"PARV INSURANCE BROKERS PRIVATE LIMITED",
"PARV MULTISPECIALITY HOSPITAL PRIVATE LIMITED",
"PARV TEX INDIA",
"PARVAHA HOSPITALITY PRIVATE LIMITED",
"PARVATA FOODS PRIVATE LIMITED",
"PARVATHANENI BRAHMAYYA SIDDHARTHA COLLEGE OF ARTS & SCIENCE",
"PARVATHEE HOSPITAL",
"PARVATHI DYEING",
"PARVATHI PARAMESHWARA TRANSLOGISTICS PRIVATE LIMITED",
"PARVATHY ORTHO HOSPITAL PRIVATE LIMITED",
"PARVATHY'S ANUGRAHAA¬†INTERNATIONAL SCHOOL",
"PARVATI FABRICS LIMITED",
"PARVATI HOSPITAL PRIVATE LIMITED",
"PARVATI INTERNATIONAL PRIVATE LIMITED",
"PARVATI MULTISTATE COP OPRATIVE CREDIT SOCIETY LIMITED",
"PARVATI ORGANIZERS PRIVATE LIMITED",
"PARVATI POLYEXTRUSION (I) PRIVATE LIMITED",
"PARVATI PRIVATE LIMITED",
"PARVATI SUPER CEMENT PRIVATE LIMITED",
"PARVATI SWEETNERS AND POWER LIMITED",
"PARVATIBAI CHOWGULE COLLEGE OF ARTS AND SCIENCE",
"PARVATIBAI GENBA MOZE COLLEGE OF ENGINEERING",
"PARVATIYA POWER LIMITED",
"PARVATIYA PROMOTORS AND BUILDERS PRIVATE LIMITED",
"PARVEEN AUTOMOBILES PRIVATE LIMITED",
"PARVEEN FABRICS PVT LTD",
"PARVEEN HOLIDAYS PRIVATE LIMITED",
"PARVEEN HOSPITAL PRIVATE LIMITED",
"PARVEEN INDUSTRIES PRIVATE LIMITED",
"PARVEEN JINDAL CLASSES PRIVATE LIMITED",
"PARVEEN KUSHBOO MARKETING PRIVATE LIMITED",
"PARVEEN TRAVELS PRIVATE LIMITED",
"PARVESH WOOLTEX PRIVATE LIMITED",
"PARVEZ SHOES PRIVATE LIMITED",
"PARVG SALES PRIVATE LIMITED",
"PARVIN APPARELS (INDIA) PRIVATE LIMITED",
"PARVIN COTEX PRIVATE LIMITED",
"PARVIN GENERAL TRADING COMPANY PRIVATE LIMITED",
"PARVIOM TECHNOLOGIES PRIVATE LIMITED",
"PARVIR WELLNESS PRIVATE LIMITED",
"PARVISH NURSING HOME PRIVATE LIMITED",
"PARVVA DIAGNOSTICS AND HEALTH CARE PRIVATE LIMITED",
"PARWANI BUILDERS PRIVATE LIMITED",
"PARWANI CASTINGS AND MACHINES PRIVATE LIMITED",
"PARWANI FASHIONS PRIVATE LIMITED",
"PARWATI CAPITAL MARKET PRIVATE LIMITED",
"PARWATI COMMODITY MARKET PVT LTD",
"PARWATI DAIRY PRIVATE LIMITED",
"PARWATI LAKH UDYOG PVT LTD",
"PARWATI STRIPS PRIVATE LIMITED",
"PARWAZ OVERSEAS PRIVATE LIMITED",
"PARYAAVARNEER ENGINEERS & CONSULTANTS PRIVATE LIMITED",
"PARYAH MANAGEMENT & INFRASTRUCTURE SERVICES PRIVATE LIMITED",
"PARYAPT SOLAR ENERGY PRIVATE LIMITED",
"PARYKAM AUTO PRIVATE LIMITED",
"PAS DIGITAL PRIVATE LIMITED",
"PAS FREIGHT SERVICES PRIVATE LIMITED",
"PAS MARKETING PRIVATE LIMITED",
"PAS PROJECTS PRIVATE LIMITED",
"PAS STEEL PRIVATE LIMITED",
"PAS TRADING HOUSE",
"PASA (INDIA) PRIVATE LIMITED",
"PASA ASSOCIATES PRIVATE LIMITED",
"PASA CREDIT AND INVESTMENT LIMITED",
"PASA RESOURCES PRIVATE LIMITED",
"PASAD GARMENTS PRIVATE LIMITED",
"PASADENA RETAIL PRIVATE LIMITED",
"PASAKA INDIA PRIVATE LIMITED",
"PASARI CASTING AND ROLLING MILLS PRIVATE LIMITED",
"PASARI SILK INDUSTRIES LIMITED",
"PASARI TEXTILES PVT LTD",
"PASARPOLIS INDIA TECHNOLOGY PRIVATE LIMITED",
"PASBY PETROCHEMICALS (INDIA) PRIVATE LIMITED",
"PASCAL COMPUTERS PVT LTD",
"PASCAL INDUSTRIAL EQUIPMENTS MANUFACTURING & CONSULTANCY PVT. LTD.",
"PASCAL SWITCHCARE INDIA PRIVATE LIMITED",
"PASCAL SYSTEMTECHNIK PRIVATE LIMITED",
"PASCHAL FORM WORK INDIA PRIVATE LIMITED",
"PASCHIM CHAMINI FP SCHOOL",
"PASCHIM CHEMICALS PRIVATE LIMITED",
"PASCHIM FINANCE AND CHIT FUND PRIVATE LIMITED",
"PASCHIM GUJARAT VIJ COMPANY LIMITED",
"PASCHIMBANGA AGRI MARKETING CORPORATION LIMITED",
"PASCHIMPARA HIGH SCHOOL",
"PASCHION RESTAURANTS PRIVATE LIMITED",
"PASCO AQUA NEEDS PRIVATE LIMITED",
"PASCO AUTOMOBILES",
"PASCO HOTELS PRIVATE LIMITED",
"PASCO MOTELS PRIVATE LIMITED",
"PASCO MOTORS LLP",
"PASCO MOTORS UDAIPUR LLP",
"PASCO STEEL PRIVATE LIMITED",
"PASCOS",
"PASH JEY CHEM FABSS PRIVATE LIMITED",
"PASHANKAR AUTO PRIVATE LIMITED",
"PASHAVA ENERGY PRIVATE LIMITED",
"PASHCHIMANCHAL VIDYUT VITRAN NIGAM LIMITED",
"PASHIN FORGE PRIVATE LIMITED",
"PASHION CLOTHING PRIVATE LIMITED",
"PASHMINA BUILDERS & DEVELOPERS PRIVATE LIMITED",
"PASHMINA REALTY PRIVATE LIMITED",
"PASHTUSH INDIA PRIVATE LIMITED",
"PASHU SHEVA KENDRA BERI",
"PASHUPALAN ¬†VIBHAG ¬†UTTAR PRADESH",
"PASHUPATI ALCOBEV PRIVATE LIMITED",
"PASHUPATI AND PRASAD FOODS PRIVATE LIMITED",
"PASHUPATI BEARINGS PRIVATE LIMITED",
"PASHUPATI CAPITAL SERVICES PRIVATE LIMITED",
"PASHUPATI COMMERCE PRIVATE LIMITED",
"PASHUPATI COTSPIN LIMITED",
"PASHUPATI COTTON INDUSTRIES",
"PASHUPATI DAS & SONS PVT LTD",
"PASHUPATI EFFECTS PRIVATE LIMITED",
"PASHUPATI EXCRUSION PRIVATE LIMITED",
"PASHUPATI LAMINATORS PRIVATE LIMITED",
"PASHUPATI NATH AGRO INDIA PRIVATE LIMITED",
"PASHUPATI NATH RESORTS PRIVATE LIMITED",
"PASHUPATI PLY INDUSTRIES PRIVATE LIMITED",
"PASHUPATI POLYTEX PRIVATE LIMITED",
"PASHUPATI PRINTS PVT LTD",
"PASHUPATI ROAD CARRIER PRIVATE LIMITED",
"PASHUPATI ROLLER FLOUR MILL PRIVATE LIMITED",
"PASHUPATI SPIRITS INDIA PRIVATE LIMITED",
"PASHUPATI TEXSPIN EXPORT LLP",
"PASHUPATI TRADEFAB PRIVATE LIMITED",
"PASHUPATI TRADEX PRIVATE LIMITED",
"PASHUPATINATH DISTRIBUTORS PRIVATE LIMITED",
"PASHUPATINATH MANUFACTURING PRIVATE LIMITED",
"PASHWA PADMAVATI FERROMET PRIVATE LIMITED",
"PASIDI PANTA PRIVATE LIMITED",
"PASITHEA INFRASTRUCTURE LIMITED",
"PASK OVERSEAS INDIA PRIVATE LIMITED",
"PASKALS FLUID SYSTEMS PRIVATE LIMITED",
"PASL PRIVATE LIMITED",
"PASL WIND SOLUTIONS PRIVATE LIMITED",
"PASL WINDTECH PRIVATE LIMITED",
"PASLA FOREIGN EXCHANGE PRIVATE LIMITED",
"PASOLITE ELECTRICALS PRIVATE LIMITED",
"PASONA INDIA PRIVATE LIMITED",
"PASONDIA CABLES PRIVATE LIMITED",
"PASRICHA HOTELS PRIVATE LIMITED",
"PASRICHA MEDICAL HALL PRIVATE LIMITED",
"PASS CODE HOSPITALITY PRIVATE LIMITED",
"PASS GERHARD CONSULTING ALLIANCE SOLUTIONS CENTRE PRIVATE LIMITED",
"PASS MICRONS MINERALS PRIVATE LIMITED",
"PASSAGE TO WORLD PRIVATE LIMITED",
"PASSARY MINERALS MADHYA PRIVATE LIMITED",
"PASSARY MINERALS PRIVATE LIMITED",
"PASSARY MINERALS PURAB PRIVATE LIMITED",
"PASSAVANT ENERGY & ENVIRONMENT INDIA PRIVATE LIMITED",
"PASSCO ENVIRONMENTAL SOLUTIONS PRIVATE LIMITED",
"PASSCO IMPEX PRIVATE LIMITED",
"PASSCOM SYSTEM AND SERVICES PRIVATE LIMITED",
"PASSERINE SPORTS PRIVATE LIMITED",
"PASSERINE WEALTH SOLUTIONS PRIVATE LIMITED",
"PASSI HEALTHCOM PRIVATE LIMITED",
"PASSI LEATHER PRODUCTS PRIVATE LIMITED",
"PASSION BARTER PVT LTD",
"PASSION COMMODITIES PRIVATE LIMITED",
"PASSION GAMING PRIVATE LIMITED",
"PASSION HOSPITALITY PRIVATE LIMITED",
"PASSION INDULGE PRIVATE LIMITED",
"PASSION INDUSTRIES PRIVATE LIMITED",
"PASSION PLAY INDIA PRIVATE LIMITED",
"PASSION POTATO PRIVATE LIMITED",
"PASSION RESTAURANT PRIVATE LIMITED",
"PASSION TRAIL LIMITED",
"PASSION VITRIFIED PRIVATE LIMITED",
"PASSION ZONE",
"PASSIVE INFRA PROJECTS PRIVATE LIMITED",
"PASSL LOGISTICS PRIVATE LIMITED",
"PASSPORT OFFICE",
"PASTA STREET INDIA PRIVATE LIMITED",
"PASTEUR HEALTHCARE INDIA PRIVATE LIMITED",
"PASTEUR LABORATORIES PVT LTD",
"PASTICHE ENERGY SOLUTIONS PRIVATE LIMITED",
"PASUMAI PHARMACIES INDIA PRIVATE LIMITED",
"PASUPALA FOODS PRIVATE LIMITED",
"PASUPARTHY POLYMERS PRIVATE LIMITED",
"PASUPATI ACRYLON LIMITED",
"PASUPATI AGROVET PRIVATE LIMITED",
"PASUPATI AQUATICS PRIVATE LIMITED",
"PASUPATI CREAMERIES PRIVATE LIMITED",
"PASUPATI MINERALS & STEELS PRIVATE LIMITED",
"PASUPATI ORGANICS PRIVATE LIMITED",
"PASUPATI RICE MILLS PRIVATE LIMITED",
"PASUPATI SALES AND SERVICES PRIVATE LIMITED",
"PASUPATINATH PROJECTS AND ELECTRICALS PRIVATE LIMITED",
"PASUPATY SPRINGS PRIVATE LIMITED",
"PASURA CROP CARE PRIVATE LIMITED",
"PASVID GLOBAL PRIVATE LIMITED",
"PASWARA CHEMICALS LIMITED",
"PASWARA IMPEX LIMITED",
"PASWARA PAPERS LIMITED",
"PASWARA POLYTEX PRIVATE LIMITED",
"PASWAY CLOTHING PRIVATE LIMITED",
"PAT FINANCIAL CONSULTANTS PVT LTD",
"PAT GRANITES PRIVATE LIMITED",
"PAT INTERNATIONAL PRIVATE LIMITED",
"PAT PRODUCTIVITY SOLUTIONS PRIVATE LIMITED",
"PATAKA INDUSTRIES PRIVATE LIMITED",
"PATALGANGA MINERALS PRIVATE LIMITED",
"PATAN AGROPRODUCTS PRIVATE LIMITED",
"PATAN DISTRICT EDUCATION COMMITTEE MANAGED PRIMARY SCHOOL TEACHER",
"PATAN FOOD PROCESSORS PRIVATE LIMITED",
"PATAN JILLA SHIKSHAN SAMITINI PRATHMIK SHALA",
"PATAN NAGARPALIKA",
"PATANGE INDUSTRIES PRIVATE LIMITED",
"PATANI SECURITIES PRIVATE LIMITED",
"PATANJALI AGRO INDIA PRIVATE LIMITED",
"PATANJALI AYURVED HOSPITAL",
"PATANJALI AYURVED LIMITED",
"PATANJALI DISTRIBUTORS PRIVATE LIMITED",
"PATANJALI FOOD & HERBAL PARK NAGPUR PRIVATE LIMITED",
"PATANJALI FOOD & HERBAL PARK PRIVATE LIMITED",
"PATANJALI FOODS LIMITED",
"PATANJALI GURUKULAM",
"PATANJALI HOSPITALS PRIVATE LIMITED",
"PATANJALI MEDIA PRIVATE LIMITED",
"PATANJALI NATURAL BISCUITS PRIVATE LIMITED",
"PATANJALI NATURAL COLOROMA PRIVATE LIMITED",
"PATANJALI ORGANIC RESEARCH INSTITUTE PRIVATE LIMITED",
"PATANJALI PARIDHAN PRIVATE LIMITED",
"PATANJALI PARIVAHAN PRIVATE LIMITED",
"PATANJALI PEYA PRIVATE LIMITED",
"PATANJALI RENEWABLE ENERGY PRIVATE LIMITED",
"PATANJALI RISHIKUL PRAYAGRAJ",
"PATANJALI VANIJYA ENTERPRISES PRIVATE LIMITED",
"PATANJALI WELLNESS LIMITED",
"PATANKAR FERTILITY SOLUTIONS PRIVATE LIMITED",
"PATANKAR HOSPITAL PRIVATE LIMITED",
"PATANKAR KALE CONSTRUCTIONS PRIVATE LIMITED",
"PATANKAR'S CREATIVE TURNKEY PROJECTS PRIVATE LIMITED",
"PATANSAWANGI HINGNA ROADWAYS PRIVATE LIMITED",
"PATANWALA DAIRY FOODS INDIA PRIVATE LIMITED",
"PATANWALA STEEL PRIVATE LIMITED",
"PATASKAR DEVELOPERS PRIVATE LIMITED",
"PATAWALA INFRA PROJECT PRIVATE LIMITED",
"PATAWARDHAN PROPERTIES PRIVATE LIMITED",
"PATCH INFOTECH PRIVATE LIMITED",
"PATCHALA SPINTEX PRIVATE LIMITED",
"PRISTINE VALUE LOGISTICS PRIVATE LIMITED",
"PATCHWORK PATTERN PRIVATE LIMITED",
"PATCO CABS PRIVATE LIMITED",
"PATCO ENGINEERING COMPANY PRIVATE LIMITED",
"PATCO EXPORTS PVT LTD",
"PATCO LINERS PVT LTD",
"PATCO PHARMACEUTICALS PRIVATE LIMITED",
"PATCO POLYPACK PRIVATE LIMITED",
"PATCO PRECISION COMPONENTS PRIVATE LIMITED",
"PATCO TECH INDIA PRIVATE LIMITED",
"PATCORP CONSTRUCTION PRIVATE LIMITED",
"PATCOS COSMETICS INDIA PRIVATE LIMITED",
"PATDIAM JEWELLERY LIMITED",
"PATE DEVELOPERS",
"PATEL AGRI INDUSTRIES PRIVATE LIMITED",
"PATEL AUTO ENGINEERING COMPANY INDIA PRIVATE LIMITED",
"PATEL AUTO SERVICE MALL PRIVATE LIMITED",
"PATEL AUTO SERVICES PRIVATE LTD",
"PATEL AUTOMOTIVE PRIVATE LIMITED",
"PATEL BATTERY HOUSE PRIVATE LIMITED",
"PATEL BEER PRIVATE LIMITED",
"PATEL BEVERAGES PRIVATE LIMITED",
"PATEL BRASS TURNOMATICS PRIVATE LIMITED",
"PATEL BRASS WORKS PRIVATE LIMITED",
"PATEL BRIDGE NIRMAN PRIVATE LIMITED",
"PATEL CAR ACCESSORIES PRIVATE LIMITED",
"PATEL CARS PRIVATE LIMITED",
"PATEL CHEM SPECIALITIES PRIVATE LIMITED",
"PATEL CHOLOPURAM-THANJAVUR HIGHWAY PRIVATE LIMITED",
"PATEL COIR PRODUCTS PRIVATE LIMITED",
"PATEL CONSTRUCTION (BIAORA) PRIVATE LIMITED",
"PATEL CONSULTANCY SERVICES PRIVATE LIMITED",
"PATEL CORRUGATIONS PRIVATE LIMITED",
"PATEL COTTON INDUSTRIES PCI",
"PATEL D J TOBACCO PRODUCTS PRIVATE LIMITED",
"PATEL DAIRY PRODUCTS PRIVATE LIMITED",
"PATEL DARAH-JHALAWAR HIGHWAY PRIVATE LIMITED",
"PATEL ENGINEERING COMPANY (SAURASHTRA) PRIVATE LIMITED",
"PATEL ENGINEERING LIMITED",
"PATEL ENTERPRISES",
"PATEL FABRITECH PRIVATE LIMITED",
"PATEL FLEET LOGISTICS PRIVATE LIMITED",
"PATEL FRESH FRUITS PRIVATE LIMITED",
"PATEL FURNACE AND FORGING PRIVATE LIMITED",
"PATEL GINNING AND PRESSING PRIVATE LIMITED",
"PATEL GOODS CARRIERS PRIVATE LIMITED",
"PATEL GRINDING INDUSTRIES PRIVATE LIMITED",
"PATEL GROUP OF INSTITUTION",
"PATEL HEAT EXCHANGERS PRIVATE LIMITED",
"PATEL HOSPITAL PRIVATE LIMITED",
"PATEL HYBRID SEEDS PVT. LTD",
"PATEL IMPORTS PRIVATE LIMITED",
"PATEL INFRASTRUCTURE LIMITED",
"PATEL INN AND TRAVELS PRIVATE LIMITED",
"PATEL INTEGRATED LOGISTICS LIMITED CN",
"PATEL ISPAT PRIVATE LIMITED",
"PATEL JAIN AND ASSOCIATES",
"PATEL JEWELLERS INDIA PRIVATE LIMITED",
"PATEL JEWELLERS PRIVATE LIMITED",
"PATEL JIVA SALES PRIVATE LIMITED",
"PATEL KENWOOD PRIVATE LIMITED",
"PATEL KITCHENWARE PRIVATE LIMITED",
"PATEL KNR HEAVY INFRASTRUCTURES LIMITED",
"PATEL KNR INFRASTRUCTURES LIMITED",
"PATEL LOGISTICS PRIVATE LIMITED",
"PATEL MECHEM PVT LTD",
"PATEL METALS & TUBES PRIVATE LIMITED",
"PATEL MICRODATA PRIVATE LIMITED",
"PATEL MONEY CHANGERS PRIVATE LIMITED",
"PATEL MOTORS INDORE PVT LTD",
"PATEL NAGAR MINERALS & INDUSTRIES PVT LTD",
"PATEL PARCEL SERVICES PVT. LTD.",
"PATEL PATRON PRIVATE LIMITED",
"PATEL PETRO PRIVATE LIMITED",
"PATEL PHOSCHEM LIMITED",
"PATEL PLASTIC BAGS PRIVATE LIMITED",
"PATEL PRECISION PRIVATE LIMITED",
"PATEL PRINTING PRESS PRIVATE LIMITED",
"PATEL PROCESSING PRIVATE LIMITED",
"PATEL PROFILES PRIVATE LIMITED",
"PATEL PROTEINS PRIVATE LIMITED",
"PATEL PUNIT BUILDERS PVT LTD",
"PATEL R J HIGH SCHOOL DHANPURA",
"PATEL RAMAN BROTHERS ARTS AND PATEL GOPALBHAI RANCHHODJI COMMERCE COLLEGE BARDOLI",
"PATEL REMEDIES PVT LTD",
"PATEL RETAIL LIMITED",
"PATEL RETAIL PRIVATE LIMITED",
"PATEL SAREES PRIVATE LIMITED",
"PATEL SCIENTIFIC INSTRUMENTS PRIVATE LIMITED",
"PATEL SETHIYAHOPU-CHOLOPURAM HIGHWAY PRIVATE LIMITED",
"PATEL SHANTI STEELS PRIVATE LIMITED",
"PATEL SOLARTECH PRIVATE LIMITED",
"PATEL STONE CRUSHERS ENGG. WORKS PRIVATE LIMITED",
"PATEL STRUCTURAL PRIVATE LIMITED",
"PATEL SUGAR AND KHANDSARI UDHYOG PRIVATE LIMITED",
"PATEL TECHNOCAST PRIVATE LIMITED",
"PATEL TECHNOMATION PRIVATE LIMITED",
"PATEL TRAVELLERS PRIVATE LIMITED",
"PATEL VADODARA-KIM EXPRESSWAY PRIVATE LIMITED",
"PATEL VENEERS PRIVATE LIMITED",
"PATEL WAREHOUSING PRIVATE LIMITED",
"PATEL WEALTH ADVISORS PRIVATE LIMITED",
"PATEL WOODSCAPE PRIVATE LIMITED",
"PATELMECH PREQUASINE PRIVATE LIMITED",
"PATELNAGAR REFRACTORIES PRIVATE LIMITED",
"PATELS AIRFLOW LIMITED",
"PATELS AIRTEMP INDIA LIMITED",
"PATEL'S ANALOG AND DIGITAL MEASUREMENT CO.PVT LTD",
"PATEL'S CERAMICS PRIVATE LIMITED",
"PATENT ENGINEERS INDIA PRIVATE LIMITED",
"PATENTMANIAC CONSULTING PRIVATE LIMITED",
"PATENTWIRE CONSULTANTS PRIVATE LIMITED",
"PATERSON SECURITIES PRIVATE LIMITED",
"PATEX EXPORT SERVICES PRIVATE LIMITED",
"PATGRO EXIM PRIVATE LIMITED",
"PATH CONNECT PRIVATE LIMITED",
"PATH FOUNDATION",
"PATH INFOTECH LIMITED",
"PATH ORIENTAL HIGHWAYS LIMITED",
"PATH SOLUTIONS INDIA PRIVATE LIMITED",
"PATH2WAY HR SOLUTIONS PRIVATE LIMITED",
"PATH2WAY SOFTECH SERVICES PRIVATE LIMITED",
"PATHABHAVAN MONTESSORI & PRIMARY DEPARTMENT",
"PATHAK AUTO SALES PRIVATE LIMITED",
"PATHAK HOSPITAL",
"PATHAK INFRACON PRIVATE LIMITED",
"PATHAK MACHINE TOOLS PVT LTD",
"PATHAK TELECOM COMPANY PRIVATE LIMITED",
"PATHANIA PUBLIC SCHOOL",
"PATHANKOT VEHICLEADES PRIVATE LIMITED",
"PATHCARE LABS PRIVATE LIMITED",
"PATHCOM TECHNOLOGIES PRIVATE LIMITED",
"PATHCURE LABORATORY AND RESEARCH CENTRE PRIVATE LIMITED",
"PATHFINDER ACADEMY PRIVATE LIMITED",
"PATHFINDER BUSINESS ANALYSIS PRIVATE LIMITED",
"PATHFINDER EDUCATIONAL CENTRE",
"PATHFINDER ENTERPRISE SOLUTIONS PRIVATE LIMITED",
"PATHFINDER EXPRESS FREIGHT PRIVATE LIMITED",
"PATHFINDER HIGHER SECONDARY PUBLIC SCHOOL JODHPUR PARK",
"PATHFINDER INFRASTRUCTURES PRIVATE LIMITED",
"PATHFINDER INTERNATIONAL",
"PATHFINDER MANAGEMENT CONSULTING (INDIA) LIMITED",
"PATHFINDER PAYROLL SOLUTIONS PRIVATE LIMITED",
"PATHFINDER PUBLISHING PRIVATE LIMITED",
"PATHFINDERS HOLIDAYS PRIVATE LIMITED",
"PATHIK LOGISTICS PRIVATE LIMITED",
"PATHIK OVERSEAS PRIVATE LIMITED",
"PATHIK SALES PVT LTD",
"PATHIKA METALS PRIVATE LIMITED",
"PATHLABS UNIFIERS PRIVATE LIMITED",
"PATHNSITU BIOTECHNOLOGIES PRIVATE LIMITED",
"PATHPARTNER TECHNOLOGY PRIVATE LIMITED",
"PATHRAKALI AMMAN AGRO PRIVATE LIMITED",
"PATHRAPALI-KATHGHORA HIGHWAYS PRIVATE LIMITED",
"PATHRIA ANALYTICS INDIA PRIVATE LIMITED",
"PATHSTOLEARN TECHNOLOGIES LLP",
"PATHTOEXCEL PRIVATE LIMITED",
"PATHWAY KNOWLEDGE RESOURCE PRIVATE LIMITED",
"PATHWAY SERVICES INDIA PRIVATE LIMITED",
"PATHWAYS BUSINESS EFFICIENCY SERVICES PRIVATE LIMITED",
"PATHWAYS CORPORATE SERVICES PRIVATE LIMITED",
"PATHWAYS WORLD SCHOOL",
"PATI RAM ENTERPRISES PRIVATE LIMITED",
"PATIALA BUS HIGHWAYS SERVICE PRIVATE LIMITED",
"PATIALA COTSPIN PRIVATE LIMITED",
"PATIALA DISTILLERS AND MANUFACTURERS LIMITED",
"PATIDAR BUILDCON LIMITED",
"PATIDAR COT-SPIN PRIVATE LIMITED",
"PATIDAR EXPORTS PRIVATE LIMITED",
"PATIDAR HOSPITAL & RESEARCH CENTRE",
"PATIDAR INDUSTRIES PRIVATE LIMITED",
"PATIDAR SEEDS PRIVATE LIMITED",
"PATIDAR TRAVELS PRIVATE LIMITED",
"PATIDAR VENEER PRIVATE LIMITED",
"PATIDAR WOOD PRIVATE. LIMITED.",
"PATIDAR WOODTECH PRIVATE LIMITED",
"PATIENT VERIFICATION SOLUTIONS PRIVATE LIMITED",
"PATIKARI POWER PRIVATE LIMITED",
"PATIL AUTOMATION PRIVATE LIMITED",
"PATIL BIOTECH PRIVATE LIMITED",
"PATIL CONSTRUCTION AND INFRASTRUCTURE LIMITED",
"PATIL CONTAINER LINES PRIVATE LIMITED",
"PATIL ELECTRIC WORKS PRIVATE LIMITED",
"PATIL HOSPITALS PRIVATE LIMITED",
"PATIL MACHINES PRIVATE LIMITED",
"PATIL PARIMALA WORKS",
"PATIL RAIL INFRASTRUCTURE PRIVATE LIMITED",
"PATIL SMH JV PRIVATE LIMITED",
"PATIL SMH RAIL PRIVATE LIMITED",
"PATILS ALPHA AIR TRAVELS PRIVATE LIMITED",
"PATINA DESIGN PRIVATE LIMITED",
"PATINA GOLD ORNAMENTS PRIVATE LIMITED",
"PATISWARA CREDIT SERVICES PRIVATE LIMITED",
"PATITAPAWAN CONSTRUCTION PRIVATE LIMITED",
"PATKAR AND SONS SHIPPING AGENCIES PRIVATE LIMITED",
"PATKAR EXTRUSIONS PRIVATE LIMITED",
"PATKIN TRACOM PVT. LTD.",
"PATLE BUISNESS SERVICES PRIVATE LIMITED",
"PATLE EDUSKILLS FOUNDATION",
"PATLIPUTRA CREDIT AND SECURITIES LIMITED",
"PATLIPUTRA DISTRIBUTORS PRIVATE LIMITED",
"PATLIPUTRA EARTHMOVER PRIVATE LIMITED",
"PATLIPUTRA EQUIPMENTS PRIVATE LIMITED",
"PATLIPUTRA FASHION PRIVATE LIMITED",
"PATLIPUTRA INDUSTRIAL GASES PRIVATE LIMITED",
"PATLIPUTRA INFRA CONSTRUCTION PRIVATE LIMITED",
"PATLIPUTRA LOGISTICS PRIVATE LIMITED",
"PATLIPUTRA PHARMACEUTICAL & HEALTHCARE PRIVATE LIMITED",
"PATLIPUTRA POLYMER PRIVATE LIMITED",
"PATLIPUTRA POULTRY PRIVATE LIMITED",
"PATLIPUTRA RESIDENCY PRIVATE LIMITED",
"PATLIPUTRA RESOURCE PRIVATE LIMITED",
"PATLIPUTRA SOLUTIONS PRIVATE LIMITED",
"PATLON YARN PRIVATE LIMITED",
"PATNA BAKHTIYARPUR TOLLWAY LIMITED",
"PATNA CARE HOSPITAL PRIVATE LIMITED",
"PATNA HIGH COURT GOVERNMENT OF BIHAR",
"PATNA HIGHWAY PROJECTS LIMITED",
"PATNA IRON PRIVATE LIMITED",
"PATNA MEDICAL COLLEGE P.M.C.H GOVERNMENT OF BIHAR",
"PATNA METRO RAIL CORPORATION LIMITED",
"PATNA MOTORS PRIVATE LIMITED",
"PATNA NAGAR NIGAM GOVERNMENT OF BIHAR",
"PATNA ORTHOPEDIC AND TRAUMA HOSPITAL PRIVATE LIMITED",
"PATNA PAPER MILLS PRIVATE LIMITED",
"PATNA SAHIB INFRASTRUCTURE & DEVELOPERS PRIVATE LIMITED",
"PATNA UNIVERSITY",
"PATNAIK CONSULTANCY PRIVATE LIMITED",
"PATNAIK MINERALS PRIVATE LIMITED",
"PATNAIK PLANTATIONS AND ESTATES PRIVATE LIMITED",
"PATNAIK STEEL INTERNATIONAL LIMITED",
"PATNALA RICELAND PRIVATE LIMITED",
"PATNESWARI AGRI PRODUCER COMPANY LIMITED",
"PATNI - ENTERPRISES PRIVATE LIMITED",
"PATNI FINANCIAL ADVISORS PRIVATE LIMITED",
"PATNI FINANCIAL SERVICES PVT LTD",
"PATNI GEMS PRIVATE LIMITED",
"PATNI HEALTHCARE",
"PATNI HEALTHCARE LIMITED",
"PATNI HOLDINGS PVT LTD",
"PATNI INFRASERVICES PRIVATE LIMITED",
"PATNI LABORATORIES PRIVATE LIMITED",
"PATNI PLASTIC PRIVATE LIMITED",
"PATNI PRECISION PRODUCTS PRIVATE LIMITED",
"PATNI RESOURCES PVT LTD",
"PATNI SORTECH PRIVATE LIMITED",
"PATNI STEELS PRIVATE LIMITED",
"PATNY SYSTEMS PRIVATE LIMITED",
"PATODI COTTON GINNING FACTORY",
"PATODIA CHEMICALS PRIVATE LIMITED",
"PATODIA FILAMENTS PRIVATE LIMITED",
"PATODIA FORGINGS & GEARS LIMITED",
"PATODIA SYNTEX LIMITED",
"PATODIA WEAVING MILLS PRIVATE LIMITED",
"PATOLA OF PATAN PRIVATE LIMITED",
"PATPERT TEKNOW SYSTEMS PRIVATE LIMITED",
"PATRA & CHANDA MFG. & ENGG. (INDIA) PRIVATE LIMITED",
"PATRA FLOUR MILL PRIVATE LIMITED",
"PATRA INDIA BPO SERVICES PRIVATE LIMITED",
"PATRA JUTE MILL PRIVATE LIMITED",
"PATRA POWER SOLUTIONS PRIVATE LIMITED",
"PATRA SHIPPING PRIVATE LIMITED",
"PATRAANI STYLE PRIVATE LIMITED",
"PATRAKAR PRAKASHAN PVT LTD",
"PATRAM PUBLICATION PRIVATE LIMITED",
"PATRAN FOODS PRIVATE LIMITED",
"PATRAN TRANSMISSION COMPANY LIMITED",
"PATRATU VIDYUT UTPADAN NIGAM LIMITED",
"PATRICIA HOLDINGS PRIVATE LIMITED",
"PATRICIAN COLLEGE OF ARTS & SCIENCE",
"PATRICK AND CO MODULAR TEC",
"PATRON AGRO SERVICES PRIVATE LIMITED",
"PATRON MANAGEMENT SERVICES PRIVATE LIMITED",
"PATRON ORGANICS PRIVATE LIMITED",
"PATRON VANIJYA PRIVATE LIMITED",
"PATRONAGE FILTEX INDIA PRIVATE LIMITED",
"PATRONAGE INSTITUTE OF PROFESSIONAL STUDIES",
"PATRONCARE PRIVATE LIMITED",
"PATRONSYS INDIA PRIVATE LIMITED",
"PATSON AUTO PRODUCTS PRIVATE LIMITED",
"PATSON AUTOMOBILES PRIVATE LIMITED",
"PATSON FOODS INDIA PRIVATE LIMITED",
"PATSON GLOBAL LIMITED",
"PATSON LABORATORIES PRIVATE LIMITED",
"PATSON MACHINES PRIVATE LIMITED",
"PATSON MOTORS PRIVATE LIMITED",
"PATSON PAPERS PRIVATE LIMITED",
"PATSON STEELS PRIVATE LIMITED",
"PATSON TECHNO SOLUTIONS PRIVATE LIMITED",
"PATSON TOOLSTECH INDIA PRIVATE LIMITED",
"PATSONS COATINGS PVT LTD",
"PATSONS HARVEST GOLD PRIVATE LIMITED",
"PATSONS PAINTS PVT LTD",
"PATSONS POLYESTERS PRIVATE LIMITED",
"PATSPIN INDIA LIMITED",
"PATTABHI AGRO FOODS PRIVATE LIMITED",
"PATTABHI RAMA POULTRY FARMS PRIVATE LIMITED",
"PATTABI ENTERPRISES",
"PATTABI ENTERPRISES PRIVATE LIMITED",
"PATTANAVALLIL TRADERS PRIVATE LIMITED",
"PATTANCHERU ENVIRO TECH LIMITED",
"PATTANIYIL CONSTRUCTIONS PRIVATE LIMITED",
"PATTANIYIL TRADING AND MANUFACTURING EQUIPMENTS PRIVATE LIMITED",
"PATTEESWARA DEVELOPERS INDIA PRIVATE LIMITED",
"PATTERN APPAREL PRIVATE LIMITED",
"PATTERN TECHNOLOGIES INDIA PRIVATE LIMITED",
"PATTERNS SOFTWARE DESIGN INSTITUTE PRIVATE LIMITED",
"PATTON DEVELOPERS PRIVATE LIMITED",
"PATTON INTERNATIONAL LIMITED",
"PATTON WAREHOUSING PRIVATE LIMITED",
"PATTUKKOTTAI POLYTECHNIC COLLEGE",
"PATUCK GALA COLLEGE OF COMMERCE & MANAGEMENT MUMBAI",
"PATUCK PREPRIMARY SCHOOL",
"PATULA BIO-CHEM PRIVATE LIMITED",
"PATURU AGRI BIOTECH PRIVATE LIMITED",
"PATVIN ENGINEERING PRIVATE LIMITED",
"PATWA AGRO PRIVATE LIMITED",
"PATWA AUTO DRIVE PRIVATE LIMITED",
"PATWA BROTHERS TEXTILE PRIVATE LIMITED",
"PATWA KINARIVALA ELKCTRONICS LIMITED",
"PATWA MOTORS PRIVATE LIMITED",
"PATWA STEELS INDORE PRIVATE LIMITED",
"PATWALA MINERALS AND MINES PRIVATE LIMITED",
"PATWARI",
"PATWARI ALLOYS PRIVATE LIMITED",
"PATWARI BAKERS PRIVATE LIMITED",
"PATWARI ELECTRICALS",
"PATWARI FOODS PRIVATE LIMITED",
"PATWARI FORGINGS PRIVATE LIMITED",
"PATWARI MARBLES PRIVATE LIMITED",
"PATWARI PLASTICS PRIVATE LIMITED",
"PATWARI ROADWAYS PRIVATE LIMITED",
"PATWARI STEELS PRIVATE LIMITED",
"PATWARI TEXTILE COMPANY PVT LTD",
"PATWARI VANIJYA PRIVATE LIMITED",
"PAUHAARIJI ENGINEERING PRIVATE LIMITED",
"PAUL & COMPANY STEEL MERCHANTS PRIVATE LIMITED",
"PAUL AIR TRANSPORT PRIVATE LIMITED",
"PAUL ALUKKAS DEVELOPERS PRIVATE LIMITED",
"PAUL ASSET CONSULTANT PRIVATE LIMITED",
"PAUL BREATHING EQUIPMENT COMPANY PRIVATE LIMITED",
"PAUL BRO LEATHERS PVT LTD",
"PAUL BUILDERS PRIVATE LIMITED",
"PAUL COMPONENTS PRIVATE LIMITED",
"PAUL GEORGE GLOBAL SCHOOL",
"PAUL JEWELLERY HOUSE PRIVATE LIMITED",
"PAUL LOGISTICS (INDIA) PRIVATE LIMITED",
"PAUL MASON CONSULTING INDIA PRIVATE LI MITED",
"PAUL MERCHANTS FINANCE PRIVATE LIMITED",
"PAUL MERCHANTS LIMITED",
"PAUL RESORTS & HOTELS PRIVATE LIMITED",
"PAUL SALES PRIVATE LIMITED",
"PAUL SHOE INDIA PRIVATE LIMITED",
"PAUL STEELS PVT LTD",
"PAUL STRIPS AND TUBES PRIVATE LIMITED",
"PAUL VET HEALTHCARE PRIVATE LIMITED",
"PAUL WURTH INDIA PRIVATE LIMITED",
"PAULABRAO AGENCIES PRIVATE LIMITED",
"PAULCO DISTRIBUTORS PRIVATE LIMITED",
"PAULMECH INFRASTRUCTURE PRIVATE LIMITED",
"PAULO TRAVELS PRIVATE LIMITED",
"PAULOSE GEORGE CONSTRUCTION COMPANY PRIVATE LIMITED",
"PAULS 3DE TECHNOLOGY INDIA PRIVATE LIMITED",
"PAULSON HOTEL AND RESORTS PRIVATE LIMITED",
"PAULSONS BEAUTY AND FASHION PRIVATE LIMITED",
"PAUSHAK LIMITED",
"PAUSHTIK AGRO FOOD I PRIVATE LIMITED",
"PAVAI ARTS AND SCIENCE COLLEGE FOR WOMEN",
"PAVAI PRINTERS PRIVATE LIMITED",
"PAVAJI FMCG PRIVATE LIMITED",
"PAVAK SECURITIES PRIVATE LIMITED",
"PAVAK WORLDWIDE PRIVATE LIMITED",
"PAVAN COTTON PRODUCTS PRIVATE LIMITED",
"PAVAN INDUSTRIAL GASES PVT LTD",
"PAVAN LAMINATES PRIVATE LIMITED",
"PAVAN MACHINE TOOLS & SERVICES INDIA PRIVATE LIMITED",
"PAVAN MOTORS PRIVATE LIMITED",
"PAVAN MOULD PRODUCTS PRIVATE LIMITED",
"PAVAN OILS PRIVATE LIMITED",
"PAVAN POLY JUTE PRIVATE LIMITED",
"PAVAN RICE INDUSTRIES",
"PAVAN SAI HOSPITAL",
"PAVAN SILK MILLS PRIVATE LIMITED",
"PAVAN TRADERS",
"PAVAN VIDYALAY AVANIYA",
"PAVANA SAHAKARI BANK LTD",
"PAVANA SAI EDUCATIONAL SCOIETY",
"PAVANASUTA RENEWABLE ENERGY PRIVATE LIMITED",
"PAVANGATI AGRO PRIVATE LIMITED",
"PAVANGIREE ENGINEERING PRIVATE LIMITED",
"PAVANI CONTROLS AND PANELS LIMITED",
"PAVANI ESTATES PRIVATE LIMITED",
"PAVANI POWER SYSTEMS PRIVATE LIMITED",
"PAVANKUMAR SANWARIA REALTY PRIVATE LIMITED",
"PAVANPUTRA SHEETGRAH PRIVATE LIMITED",
"PAVANPUTRA WAFERS PRIVATE LIMITED",
"PAVANSUT METAL CAST PRIVATE LIMITED",
"PAVANSUT PAPER MILL PRIVATE LIMITED",
"PAVANSUT POLYTEX PRIVATE LIMITED",
"PAVAPURI EXPORTS PRIVATE LIMITED",
"PAVAS POLYCHEM PRIVATE LIMITED",
"PAVATHAL SPINNING MILLS PRIVATE LIMITED",
"PAVE INFRASTRUCTURE PRIVATE LIMITED",
"PAVE PATH ENGINEERING & INFRASTRUCTURE PRIVATE LIMITED",
"PAVEHOUSE EXPORTS OVERSEAS PRIVATE LIMITED",
"PAVENDAR BHARATHIDASAN COLLEGE OF ENGINEERING & TECHNOLOGY",
"PAVERS ENGLAND LIMITED",
"PAVEWAY AUTOMATION PRIVATE LIMITED",
"PAVEWAY CONSTRUCTIONS P LTD",
"PAVI BUILDWELL PRIVATE LIMITED",
"PAVIK INDIA PRIVATE LIMITED",
"PAVILION INFRASTRUCTURE PRIVATE LIMITED",
"PAVILIONDATA SYSTEMS INDIA PRIVATE LIMITED",
"PAVILIONS AND INTERIORS INDIA PRIVATE LIMITED",
"PAVING STONE INDIA PRIVATE LIMITED",
"PAVIOUR PHARMACEUTICALS PRIVATE LIMITED",
"PAVIT CERAMICS PRIVATE LIMITED",
"PAVITER METALS PRIVATE LIMITED",
"PAVITHA POULTRY FARM PRIVATE LIMITED",
"PAVITHRA AGRO FRESH COLD STORAGE PVT LTD",
"PAVITHRA CONSTRUCTIONS PRIVATE LIMITED",
"PAVITHRA HOSPITAL",
"PAVITRA ASSOCIATES PRIVATE LIMITED",
"PAVITRA COMMERCIALS LIMITED",
"PAVITRA COMMOTRADE PRIVATE LIMITED",
"PAVITRA CONBUILD PRIVATE LIMITED",
"PAVITRA HARSH SNEH PRIVATE LIMITED",
"PAVITRA LIFESTYLE PRIVATE LIMITED",
"PAVITRAA GRAPHICS LIMITED",
"PAVITRAA RICE TECH PRIVATE LIMITED",
"PAVITRAM TOURS & TRAVELS PRIVATE LIMITED",
"PAVITRAM TUBES PRIVATE LIMITED",
"PAVITRAMENTHE FAIR ORGANIC PRIVATE LIMITED",
"PAVITTAR PHARMACEUTICALS PRIVATE LIMITED",
"PAVIZHAM HEALTHIER DIET PRIVATE LIMITED",
"PAVLOVA ESTATES PRIVATE LIMITED",
"PAVNA AUTO ENGINEERING PRIVATE LIMITED",
"PAVNA GOYAM AUTO PRIVATE LIMITED",
"PAVNA INDUSTRIES LIMITED",
"PAVNA MARKETING PRIVATE LIMITED",
"PAVO POWER ENGINEERING PRIVATE LIMITED",
"PAVONINE LIFESTYLE PRIVATE LIMITED",
"PAVOOR EDUCATION TRUST",
"PAWA BUILDERS PRIVATE LIMITED",
"PAWAK CHEMICALS PRIVATE LIMITED",
"PAWAN AND COMPANY ENGITECH PRIVATE LIMITED",
"PAWAN AUTO PRIVATE LIMITED",
"PAWAN AUTOWHEELS PRIVATE LIMITED",
"PAWAN BAKERS AND CONFECTIONERS PRIVATE LIMITED",
"PAWAN CARGO FORWARDS PRIVATE LIMITED",
"PAWAN CASTINGS MEGHALAYA PRIVATE LIMITED",
"PAWAN CEMENT COMPANY PRIVATE LIMITED",
"PAWAN COMMOTRADE PRIVATE LIMITED",
"PAWAN COMMUNICATIONS PRIVATE LIMITED",
"PAWAN COT-FIBRES PRIVATE LIMITED",
"PAWAN COTTON INDUSTRIES",
"PAWAN CREATIONS PRIVATE LIMITED",
"PAWAN DRESS MATERIAL PRIVATE LIMITED",
"PAWAN EDIFICE PRIVATE LIMITED",
"PAWAN ENTERPRISES",
"PAWAN EXPORTS",
"PAWAN FABTEX PRIVATE LIMITED",
"PAWAN FIBERS PRIVATE LIMITED",
"PAWAN FOREX AND LIESURE PRIVATE LIMITED",
"PAWAN FORMALIN PRIVATE LIMITED",
"PAWAN GANDHI HEALTH CARE PRIVATE LIMITED",
"PAWAN GANGA EDUCATIONAL SOCIETY",
"PAWAN HANS LIMITED",
"PAWAN HEALTHCARE PRIVATE LIMITED",
"PAWAN HOSPITAL PRIVATE LIMITED",
"PAWAN INFRADEVELOPERS PRIVATE LIMITED",
"PAWAN INFRASPACE PRIVATE LIMITED",
"PAWAN INORGANICS PRIVATE LIMITED",
"PAWAN INTERIOR PRIVATE LIMITED",
"PAWAN KUMAR GOVT CONTRACTER & ENGINEERS",
"PAWAN MACHINERIES PVT LIMITED",
"PAWAN MARKETING PVT. LTD.",
"PAWAN MEDICO",
"PAWAN OVERSEAS PRIVATE LIMITED",
"PAWAN PACKAGING PRIVATE LIMITED",
"PAWAN PANEL PRIVATE LIMITED",
"PAWAN POLYTEX PRIVATE LIMITED",
"PAWAN POWER & TELECOM LIMITED",
"PAWAN PULSES PRIVATE LIMITED",
"PAWAN PUTRA PLYWOOD INDUSTRIES PRIVATE LIMITED",
"PAWAN PUTRA SECURITIES PRIVATE LIMITED",
"PAWAN REFINERIES PRIVATE LIMITED",
"PAWAN SACHDEVA VOGUE INTERNATIONAL PRIVATE LIMITED",
"PAWAN SHREE FOOD INTERNATIONAL PRIVATE LIMITED",
"PAWAN SYNTEX PRIVATE LIMITED",
"PAWAN TANAY CHEM PLAST PRIVATE LIMITED",
"PAWAN TOURS AND HR SOLUTIONS PRIVATE LIMITED",
"PAWAN TRACON PRIVATE LIMITED",
"PAWAN TRADE CONNECT PRIVATE LIMITED",
"PAWAN TRADECORP PRIVATE LIMITED",
"PAWAN UDYOG LTD",
"PAWANA ENGINEERING PROJECTS PRIVATE LIMITED",
"PAWANA INFRA DEVELOPMENT PRIVATE LIMITED",
"PAWANDOOT MERCHANTS PVT. LTD.",
"PAWANI INFRASTRUCTURE AND DEVELOPER PRIVATE LIMITED",
"PAWANJAY SPONGE IRON LIMITED",
"PAWANPUTRA ECOKE PRIVATE LIMITED",
"PAWANPUTRA ENGINEERS PRIVATE LIMITED",
"PAWANPUTRA INNOVATIVE SOLUTIONS PRIVATE LIMITED",
"PAWANPUTRA MACHINE TOOLS PRIVATE LIMITED",
"PAWANPUTRA POLYWEAVES PRIVATE LIMITED",
"PAWANPUTRA WIRES PRIVATE LIMITED",
"PAWANSHREE FOOD INTERNATIONAL PRIVATE LIMITED",
"PAWANSUT AD-CREATIONS PRIVATE LIMITED",
"PAWANSUT ENTERPRISES",
"PAWANSUT FOODMART PRIVATE LIMITED",
"PAWANSUT FOREX PRIVATE LIMITED",
"PAWANSUT HANUMAN CONSTRUCTION COMPANY PRIVATE LIMITED",
"PAWANSUT INFRA DEVELOPERS PRIVATE LIMITED",
"PAWANSUT INFRA PROJECTS PRIVATE LIMITED",
"PAWANSUT MARKETING PRIVATE LIMITED",
"PAWANSUT MOTORS PRIVATE LIMITED",
"PAWANSUT RICE MILLS PRIVATE LIMITED",
"PAWANSUT SECURITY SERVICES PRIVATE LIMITED",
"PAWAR AGENCIES PRIVATE LIMITED",
"PAWAR BULLION PRIVATE LIMITED",
"PAWAR DELTA FORCE PRIVATE LIMITED",
"PAWAR HOSPITAL",
"PAWAR MULTISPECIALITY HOSPITAL AND DIAGNOSTIC CENTRE PRIVATE LIMITED",
"PAWAR PATKAR CONSTRUCTIONS PRIVATE LIMITED",
"PAWAR PUBLIC SCHOOL",
"PAWAR TEXTILES PRIVATE LIMITED",
"PAWARIA INFRASTRUCTURE PRIVATE LIMITED",
"PAWAS TECHNO ALLIANCE PRIVATE LIMITED",
"PAWFECT PET FOODS PRIVATE LIMITED",
"PAWNI ENVIRONMENT & ENERGY MANAGEMENT PRIVATE LIMITED",
"PAWPL VENTURES PRIVATE LIMITED",
"PAWSNCOLLARS PRIVATE LIMITED",
"PAX INNOVATION ICT SERVICES PRIVATE LIMITED",
"PAX POS SOLUTIONS INDIA PRIVATE LIMITED",
"PAXAL CORPORATION",
"PAXAL STAINLESS PRIVATE LIMITED",
"PAXANIMI SERVICES PRIVATE LIMITED",
"PAXCOM INDIA PRIVATE LIMITED",
"PAXDHA FINTECH PVT LTD",
"PAXEL TECHNOLABS INDIA PRIVATE LIMITED",
"PAXIMA PRIVATE LIMITED",
"PAXSHELL PRIVATE LIMITED",
"PAXSON INDUSTRIES PRIVATE LIMITED",
"PAXTON OVERSEAS PRIVATE LIMITED",
"PAXTON TREXIM PRIVATE LIMITED",
"PAY & ACCOUNTS OFFICER",
"PAY ASIA MANAGEMENT PRIVATE LIMITED",
"PAY CENTER PRATHMIK SHALA",
"PAY POINT INDIA NETWORK PRIVATE LIMITED",
"PAY WITH INDIAMART PRIVATE LIMITED",
"PAY2ALL SERVICES PRIVATE LIMITED",
"PAY5X INFOTECH PRIVATE LIMITED",
"PAYABHI PAYMENTS PRIVATE LIMITED",
"PAYADDA SERVICES PRIVATE LIMITED",
"PAYAGRI INNOVATIONS PRIVATE LIMITED",
"PAYAL AGENCIES",
"PAYAL BOLT PRIVATE LIMITED",
"PAYAL CABLES PRIVATE LIMITED",
"PAYAL COMMERCIAL CO LTD",
"PAYAL DEALERS PVT LTD",
"PAYAL DYEING AND PRINTING MILLS PRIVATE LIMITED",
"PAYAL EMPORIUMS PRIVATE LIMITED",
"PAYAL FINANCE SERVICES PRIVATE LIMITED",
"PAYAL GOLD PRIVATE LIMITED",
"PAYAL INTERNATIONAL LIMITED",
"PAYAL PETROPACK PRIVATE LIMITED",
"PAYAL POLYPLAST PRIVATE LIMITED",
"PAYAL PORTFOLIO PRIVATE LIMITED",
"PAYAL PRINTS PRIVATE LIMITED",
"PAYAL PROPERTIES PRIVATE LIMITED",
"PAYAL SANCHETI JEWELLERS PRIVATE LIMITED",
"PAYALLMART PRIVATE LIMITED",
"PAYAS SHIPPING LINES PRIVATE LIMITED",
"PAYASWINI CONCAST PRIVATE LIMITED",
"PAYASWINI STEEL PRIVATE LIMITED",
"PAYATU SECURITY CONSULTING PRIVATE LIMITED",
"PAYATU TECHNOLOGIES PRIVATE LIMITED",
"PAYBOOKS TECHNOLOGIES INDIA PRIVATE LIMITED",
"PAYCHARGE SOLUTIONS PRIVATE LIMITED",
"PAYCHEX IT SOLUTIONS INDIA PRIVATE LIMITED",
"PAYCHQ SOLUTION PRIVATE LIMITED",
"PAYCORP SOLUTIONS PRIVATE LIMITED",
"PAYCRAFT SOLUTIONS PRIVATE LIMITED",
"PAYCRAFT URBAN SOLUTIONS PRIVATE LIMITED",
"PAYDECK TECHNOLOGIES PRIVATE LIMITED",
"PAYEL FOOD PRODUCTS PRIVATE LIMITED",
"PAYEL MOTORS PRIVATE LIMITED",
"PAYFIN SOLUTIONS PRIVATE LIMITED",
"PAYGATE INDIA PRIVATE LIMITED",
"PAYGEEK SOFT SOLUTIONS PRIVATE LIMITED",
"PAYGLOCAL TECHNOLOGIES PRIVATE LIMITED",
"PAYGURU TECHNOSOFT PRIVATE LIMITED",
"PAYHUDDLE SOLUTIONS PRIVATE LIMITED",
"PAYIK SENTINELS PRIVATE LIMITED",
"PAYINC PRIVATE LIMITED",
"PAYJOY INDIA PRIVATE LIMITED",
"PAYKUN PAYMENT SOLUTIONS PRIVATE LIMITED",
"PAYLINE INDIA ACCOUNTING SERVICES PRIVATE LIMITED",
"PAYMARK PAYMENT TECHNOLOGIES & SERVICES PRIVATE LIMITED",
"PAYMATE INDIA LIMITED",
"PAYMATE INDIA PRIVATE LIMITED",
"PAYMAX CONSULTING PRIVATE LIMITED",
"PAYME INDIA FINANCIAL SERVICES PRIVATE LIMITED",
"PAYMENT GATEWAY SOLUTIONS PRIVATE LIMITED",
"PAYMENTWALL INDIA PRIVATE LIMITED",
"PAYNA FP",
"PAYNE REALTORS PRIVATE LIMITED",
"PAYNET SYSTEMS PRIVATE LIMITED",
"PAYNEXT PRIVATE LIMITED",
"PAYNX TECHNOLOGIES PRIVATE LIMITED",
"PAYOBILL97 TECHNOLOGIES PRIVATE LIMITED",
"PAYODA TECHNOLOGIES PRIVATE LIMITED",
"PAYODHI FOODS PRIVATE LIMITED",
"PAYODSOFT CONSULTING SERVICES PRIVATE LIMITED",
"PAYONEER INDIA COMMERCE LLP",
"PAYORITE PRINT MEDIA PRIVATE LIMITED",
"PAYPAL INDIA PRIVATE LIMITED",
"PAYPER BAGGING INDIA PRIVATE LIMITED",
"PAYPERMINT PRIVATE LIMITED",
"PAYPORTAL SERVICES PRIVATE LIMITED",
"PAYRULE SERVICES PRIVATE LIMITED",
"PAYS SERVICES INDIA LLP",
"PAYSENSE SERVICES INDIA PRIVATE LIMITED",
"PAYSHARP PRIVATE LIMITED",
"PAYSPRINT PRIVATE LIMITED",
"PAYSQUARE CONSULTANCY LIMITED",
"PAYSQUARE HR SERVICES PRIVATE LIMITED",
"PAYSTAT ONESTOP SOLUTIONS PRIVATE LIMITED",
"PAYSWIFF SOLUTIONS PRIVATE LIMITED",
"PAYSWIFF TECHNOLOGIES PRIVATE LIMITED",
"PAYSWIFT TECHNOLOGY PRIVATE LIMITED",
"PAYTAIL COMMERCE PRIVATE LIMITED",
"PAYTEL FINANCIAL TECHNOLOGIES PRIVATE LIMITED",
"PAYTHROUGH SOFTWERES AND SOLUTIONS P LIMITED",
"PAYTON CONSULTANCY SERVICES PRIVATE LIMITED",
"PAYTRONIC NETWORK PRIVATE LIMITED",
"PAYU FINANCE INDIA PRIVATE LIMITED",
"PAYU PAYMENTS PRIVATE LIMITED",
"PAYUMART ADVISORY PRIVATE LIMITED",
"PAYVORITE INDIA (OPC) PRIVATE LIMITED",
"PAYWALL INFORMATION SYSTEMS (INDIA) PRIVATE LIMITED",
"PAYWORLD DIGITAL SERVICES PRIVATE LIMITED",
"PAYWORTH CONSULTANCY",
"PAYXFER TECHNOLOGIES PRIVATE LIMITED",
"PAYYADE INTERNATIONAL HOTELS PVT LTD",
"PAYYADE RESORTS BARDEZ PRIVATE LIMITED",
"PAYYANUR MEDICAL SERVICE AND RESEARCH CENTRE PRIVATE LIMITED",
"PAYYAPPS CONSULTING SERVICES PRIVATE LIMITED",
"PAYZONE TRADING SERVICES PRIVATE LIMITED",
"PAZER NETWORK SOLUTIONS PRIVATE LIMITED",
"PAZHOOR IDEAL SYSTEMS PRIVATE LIMITED",
"PAZO INNOVATIONS PRIVATE LIMITED",
"PB COMPUTERS PRIVATE LIMITED",
"PB EDIBLE OIL PRODUCTS PRIVATE LIMITED",
"PB FINTECH LIMITED",
"PB GLOBAL LIMITED",
"PB HOMES PRIVATE LIMITED",
"PB INDIA PRIVATE LIMITED",
"PB LIFESTYLE LIMITED",
"PB STATCLEAN SOLUTIONS PRIVATE LIMITED",
"PB VENTURES LLP",
"PBC CARRIERS PVT. LTD.",
"PBC INFRASTRUCTURE (INDIA) PRIVATE LIMITED",
"PBC LOGISTICS PRIVATE LIMITED",
"PBC TECHPLAST PRIVATE LIMITED",
"PBG AUTO PRIVATE LIMITED",
"PBG INTELLIGENT FORCE PRIVATE LIMITED",
"PBH ENGINEERING & CONSTRUCTION PRIVATE LIMITED",
"PBI ANALYTICS PRIVATE LIMITED",
"PBJ AUTO EXIM PRIVATE LIMITED",
"PBL LIFE CARE PRIVATE LIMITED",
"PBM NIDHI LIMITED",
"PBM POLYTEX",
"PBMAS H V DESAI EYE HOSPITAL",
"PBN CONSTRUCTIONS PRIVATE LIMITED",
"PBO IT SERVICES INDIA PRIVATE LIMITED",
"PBOPLUS CONSULTING SERVICES PRIVATE LIMITED",
"PBR DEVELOPERS PRIVATE LIMITED",
"PBR INFRATECH PRIVATE LIMITED",
"PBR TOWERS PRIVATE LIMITED",
"PBR VISVODAYA INSTITUTE OF TECHNOLOGY & SCIENCE",
"PBS FRAGRANCES PRIVATE LIMITED",
"PBS GOURMET FOODS PRIVATE LIMITED",
"PBS LIFE SCIENCES PRIVATE LIMITED",
"PBS OIL INDUSTRIES PRIVATE LIMITED",
"PBS PAPER INDUSTRY SOLUTIONS PRIVATE LIMITED",
"PBSR DEVELOPERS PRIVATE LIMITED",
"PBT DISTRIBUTORS PRIVATE LIMITED",
"PBW BEARINGS PRIVATE LIMITED",
"PC & S (HVAC) SERVICES PVT LTD",
"PC CARE AIRWAY INFRATEL PRIVATE LIMITED",
"PC CARE247 SOLUTIONS PRIVATE LIMITED",
"PC COLOUR SOFT FABRICS PRIVATE LIMITED",
"PC DESIGNS PRIVATE LIMITED",
"PC DEVELOPERS PRIVATE LIMITED",
"PC DYE CHEM PRIVATE LIMITED",
"PC JEWELLER LIMITED",
"PC MANTRA INFOSYSTEM PRIVATE LIMITED",
"PC PATEL MAHALAXMI SIMPLEX CONSORTIUM PRIVATE LIMITED",
"PC PRINT CONTROL PRIVATE LIMITED",
"PC SHOP INDIA PRIVATE LIMITED",
"PC SOLUTIONS PRIVATE LIMITED",
"PC TECHNO PROJECTS PRIVATE LIMITED",
"PC TECHNOWLEDGE CENTRE PRIVATE LIMITED",
"PC TRAINING INSTITUTE LIMITED",
"PC UNIVERSAL PRIVATE LIMITED",
"PC ZONES IT SERVICES PRIVATE LIMITED",
"PC2 SCIENTIFIC SERVICES PRIVATE LIMITED",
"PCA AUTOMOBILES INDIA PRIVATE LIMITED",
"PCA MOTORS PRIVATE LIMITED",
"PCB APPS GLOBAL PRIVATE LIMITED",
"PCB PLANET INDIA PRIVATE LIMITED",
"PCB POWER INDIA LIMITED",
"PCBC FOREX AND TRAVELS PRIVATE LIMITED",
"PCBEXCELLENT INDIA PRIVATE LIMITED",
"PCBL (TN) LIMITED",
"PCBL LIMITED",
"PCC INFRASTRUCTURE PRIVATE LIMITED",
"PCC LOGISTICS PRIVATE LIMITED",
"PCC SOFTWARE & WEB SOLUTIONS",
"PCCF DEVELOPMENT MADHYA PRADESH BHOPAL",
"PCCP INDUSTRIES PRIVATE LIMITED",
"PCCS LOGISTICS PRIVATE LIMITED",
"PCDA NAVY",
"PCDA(AF) DEHRASDUN",
"PCDAPENSIONSPRAYAGRAG",
"PCDF LIMITED",
"PCE PROJECTS PVT LTD",
"PIMPRI CHINCHWAD COLLEGE OF ENGINEERING",
"PCF LOGISTICS PRIVATE LIMITED",
"PCG BUSINESS SOLUTIONS PRIVATE LIMITED",
"PCG COAL CARRIERS PRIVATE LIMITED",
"PCG FINVEST PRIVATE LIMITED",
"PCG LOGISTICS PRIVATE LIMITED",
"PCGI INDIA LLP",
"PCI ANALYTICS PRIVATE LIMITED",
"PCI AUTOTRONICS PRIVATE LIMITED",
"PCI CABLES INDUSTRIES PRIVATE LIMITED",
"PCI PEST CONTROL PRIVATE LIMITED",
"PCI PRECISION ENGINEERING LIMITED",
"PCI SOFTWARE PRIVATE LIMITED",
"PCIL HAM ASHTAVINAYAK THEUR PRIVATE LIMITED",
"PCIL HAM BELHE SHIKRAPUR PRIVATE LIMITED",
"PCIL HAM INDUSTRIAL SECTOR CHAKAN TALEGAON PRIVATE LIMITED",
"PCIL HAM PADOLI RAJURA PRIVATE LIMITED",
"PCIL HAM RANJANGAON NARAYANGAON PRIVATE LIMITED",
"PCIS SOLUTIONS PRIVATE LIMITED",
"PCJ HOLDINGS PRIVATE LIMITED",
"PCJ REALTECH PRIVATE LIMITED",
"PCK BUDERUS INDIA SPECIAL STEELS PRIVATE LIMITED",
"PCK COTTON PRIVATE LIMITED",
"PCL HEALTHCARE PRIVATE LIMITED",
"PCL LOGISTICS PRIVATE LIMITED",
"PCL OIL AND SOLVENTS LIMITED",
"PCL SHIPPING PRIVATE LIMITED",
"PCL TECHNOLOGIES PRIVATE LIMITED",
"PCL-SUMO AIR TECHNOLOGY PRIVATE LIMITED",
"PCM AGRO PRODUCTS PRIVATE LIMITED",
"PCM ALLOYS STEELS PRIVATE LIMITED",
"PCM APPARELS PRIVATE LIMITED",
"PCM CEMENT CONCRETE PVT. LTD.",
"PCM CONSULTANTS PRIVATE LIMITED",
"PCM INFRAPROJECTS PRIVATE LIMITED",
"PCM MANAGEMENT SERVICES PRIVATE LIMITED",
"PCM TEA PROCESSING PRIVATE LIMITED",
"PCM WORLDWIDE FLIGHTS PRIVATE LIMITED",
"PCMBPLUS TECHNOLOGIES PRIVATE LIMITED",
"PCMR INFRASTRUCTURE PRIVATE LIMITED",
"PCMX HYGIENE PRODUCTS PVT LTD",
"PCNET INFOTECH PRIVATE LIMITED",
"PCON UTILITIES PRIVATE LIMITED",
"PCP CHEMICALS PRIVATE LIMITED",
"PCP FLYASH INDIA PRIVATE LIMITED",
"PCP INTERNATIONAL LIMITED",
"PCP TECHNOLOGIES PRIVATE LIMITED",
"PCR BUILDTECH PRIVATE LIMITED",
"PCR INVESTMENTS LIMITED",
"PCR TRANSPORT PRIVATE LIMITED",
"PCS ELECTRIC PANEL INDIA PRIVATE LIMITED",
"PCS FACILITY SERVICES INDIA PRIVATE LIMITED",
"PCS GREENTECH PRIVATE LIMITED",
"PCS INDUSTRIES PRIVATE LIMITED",
"PCS IT SOLUTIONS PRIVATE LIMITED",
"PCS MANAGEMENT CONSULTANCY PRIVATE LIMITED",
"PCS PROJECT MANAGEMENT PRIVATE LIMTED",
"PCS SECURITIES AND CONSULTANTS LLP",
"PCS TECHNOLOGY LIMITED",
"PCSL INFRACONSTRUCTIONS & MERCHANDISING PRIVATE LIMITED",
"PCSOFT ERP SOLUTIONS PRIVATE LIMITED",
"PCSS SOLUTIONS PRIVATE LIMITED",
"PCSSECURITIES LIMITED",
"PCTE GROUP OF INSTITUTES",
"PCTRONICS SOLUTIONS INDIA PRIVATE LIMITED",
"PCYANTRA COMPUTERS SOLUTIONS PRIVATE LIMITED",
"PD CARS PRIVATE LIMITED",
"PD HOTELS PRIVATE LIMITED",
"PD LEARNING CURVE PRIVATE LIMITED",
"PD SQUARE DESIGN STUDIO PRIVATE LIMITED",
"PDA VENTURES PRIVATE LIMITED",
"PDAC CONSULTANCY PRIVATE LIMITED",
"PDB TECHNOLOGIES AND SOLUTIONS PRIVATE LIMITED",
"PDC EXPLO CHEM PRIVATE LIMITED",
"PDC INFRAPROJECTS PRIVATE LIMITED",
"PDC SERVICES PRIVATE LIMITED",
"PDCOR LIMITED",
"PDCS PROJECTS INDIA PRIVATE LIMITED",
"PDF ENGINEERS PRIVATE LIMITED",
"PDG SOFTWARE INDIA PRIVATE LIMITED",
"PDH LOGISTICS PRIVATE LIMITED",
"PDI SOFTWARE INDIA LLP",
"PDK PROPERTY PRIVATE LIMITED",
"PDKJ COMMERCE CO PRIVATE LIMITED",
"PDL AUTOHUB",
"PDL REALTY PRIVATE LIMITED",
"PDM EXTRUSIONS PRIVATE LIMITED",
"PDM INVESTMENT & TRADING COMPANY PVT LTD",
"PDM MEDIA INDIA PRIVATE LIMITED",
"PDM SPINNING INDUSTRIES PRIVATE LIMITED",
"PDN DEVELOPERS PRIVATE LIMITED",
"PDP EMBROIDERY WORKS (OPC) PRIVATE LIMITED",
"PDP LIFE SCIENCE LOGISTICS INDIA PRIVATE LIMITED",
"PDP SHIPPING & PROJECTS LIMITED",
"PDP STEELS LIMITED",
"PDPU INNOVATION AND INCUBATION CENTRE",
"PDR CONSTRUCTIONS",
"PDR ENGINEERING COMPANY PRIVATE LIMITED",
"PDR ORTHOPAEDIC HOSPITAL",
"PDR PROJECTS PRIVATE LIMITED",
"PDR VIDEOTRONICS (INDIA) PRIVATE LIMITED",
"PDS ENGINEERING SOLUTION PRIVATE LIMITED",
"PDS INTERNATIONAL PRIVATE LIMITED",
"PDS LIMITED",
"PDS MULTINATIONAL FASHIONS LIMITED",
"PDS TRADING & WAREHOUSING COMPANY PVT LTD",
"PDSONI JEWELLERS PRIVATE LIMITED",
"PDSVISION (INDIA) PRIVATE LIMITED",
"PE - ARISTI PROJECTS AND ENGINEERING PRIVATE LIMIT",
"PE - ARISTI PROJECTS AND ENGINEERING PRIVATE LIMITED",
"PE ENGINEERS PRIVATE LIMITED",
"PE INSTRUMENTATION & INDUSTRIAL CONTROLS PRIVATE LIMITED",
"PEACE HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"PEACE INDIA LIMITED",
"PEACE INFRATECH PRIVATE LIMITED",
"PEACE OF MIND KNIT PRIVATE LIMITED",
"PEACE PARK HOTELS PRIVATE LIMITED",
"PEACE POWER PRIVATE LIMITED",
"PEACE PUBLIC SCHOOL",
"PEACE REALTY PRIVATE LIMITED",
"PEACE STORAGE SYSTEM PRIVATE LIMITED",
"PEACEFORT CHEM-IND ENGINEERING PRIVATE LIMITED",
"PEACH BLOSSOM INVESTMENT PVT LTD",
"PEACH ENGINEERING PRIVATE LIMITED",
"PEACH TECHNOVATIONS PRIVATE LIMITED",
"PEACHTREE HOME ACCENTS PRIVATE LIMITED",
"PEACOCK ADVERTISING (INDIA) PRIVATE LIMITED",
"PEACOCK ANIMATION ACADEMY PRIVATE LIMITED",
"PEACOCK APPARELS PRIVATE LIMITED",
"PEACOCK CHEMICALS PVT LTD",
"PEACOCK ENGINEERING INDIA PRIVATE LIMITED",
"PEACOCK EVENTS & EXHIBITIONS PRIVATE LIMITED",
"PEACOCK HOSPITALS PRIVATE LIMITED",
"PEACOCK PRINTS PRIVATE LIMITED",
"PEAFOWL TECHNOLOGIES PRIVATE LIMITED",
"PEAK AIR PRIVATE LIMITED",
"PEAK AUTOMOBILES INDIA PRIVATE LIMITED",
"PEAK BUSINESS INSIGHT PRIVATE LIMITED",
"PEAK FREIGHT SOLUTIONS PRIVATE LIMITED",
"PEAK INFRASTRUCTURE MANAGEMENT SERVICES PRIVATE LIMITED",
"PEAK PACIFIC KNOWLEDGE PRIVATE LIMITED",
"PEAK SCIENTIFIC INSTRUMENTS INDIA PRIVATE LIMITED",
"PEAK SYSTEMS REFRIGERATION PRIVATE LIMITED",
"PEAK XV NETWORKS PRIVATE LIMITED",
"PEAKALPHA INVESTMENT SERVICES PRIVATE LIMITED",
"PEAKLAND FARMERS PRODUCER COMPANY LIMITED",
"PEAKOK JEWELLERY LIMITED",
"PEAKS & APEX BUSINESS SOLUTION PRIVATE LIMITED",
"PEAKS AGRO WAREHOUSING PRIVATE LIMITED",
"PEAKS AUTO JAMMU PRIVATE LIMITED",
"PEAKS AUTO PRIVATE LIMITED",
"PEANUTS RETAIL PRIVATE LIMITED",
"PEAREY LAL AND SONS PRIVATE LIMITED",
"PEAREY LALL & SONS E.P. PRIVATE LIMITED",
"PEARL ACADEMY",
"PEARL ADHESIVES PRIVATE LIMITED",
"PEARL ALLOYS PRIVATE LIMITED",
"PEARL ASSOCIATES COMPUTECH PRIVATE LIMITED",
"PEARL BEVERAGES LIMITED",
"PEARL BOOKS PRIVATE LIMITED",
"PEARL BOTTLING PRIVATE LIMITED",
"PEARL BROKING SERVICES LIMITED",
"PEARL BUILDTECH PRIVATE LIMITED",
"PEARL CARZONRENT PRIVATE LIMITED",
"PEARL CITY MARINE PRODUCTS PRIVATE LIMITED",
"PEARL CONSTRUCTION AND DEVELOPERS",
"PEARL COSCHEM PRIVATE LIMITED",
"PEARL DRINKS LIMITED",
"PEARL ENERGY SOLUTIONS (INDIA) PRIVATE LIMITED",
"PEARL FARBEN CHEM PRIVATE LIMITED",
"PEARL FASHIONS PRIVATE LIMITED",
"PEARL FIBRES PRIVATE LIMITED (TRANSFER FROM HARYAN TO RAJASTHAN)",
"PEARL FREIGHT SERVICES PRIVATE LIMITED",
"PEARL FURNITURE PRIVATE LIMITED",
"PEARL GARDEN CONSTRUCTIONS PRIVATE LIMITED",
"PEARL GEM & JEWELRY PRIVATE LIMITED",
"PEARL GENERATORS PRIVATE LIMITED",
"PEARL GLOBAL INDUSTRIES LIMITED",
"PEARL GRANEXPO PRIVATE LIMITED",
"PEARL GREEN CLUBS AND RESORTS LIMITED",
"PEARL GREEN ENERGY PRIVATE LIMITED",
"PEARL HEALTH CARE PRODUCTS PRIVATE LIMITED",
"PEARL INFRASOLUTIONS PRIVATE LIMITED",
"PEARL INTERIORS STUDIO PRIVATE LIMITED",
"PEARL INTERNATIONAL SERVICES PRIVATE LIMITED",
"PEARL INVESTMENTS & FINANCE CO LIMITED",
"PEARL LIESURE PRIVATE LIMITED",
"PEARL MEDICAL AIDS & EQUIPMENTS PRIVATE LIMITED",
"PEARL MEDICALS PRIVATE LIMITED",
"PEARL METACHEM PRIVATE LIMITED",
"PEARL METAL CAST PMC",
"PEARL MINERAL AND MINES PRIVATE LIMITED",
"PEARL MINERAL PRIVATE LIMITED",
"PEARL MOTORS PRIVATE LIMITED",
"PEARL OYSTER AIR CONDITIONERS INDIA PRIVATE LIMITED",
"PEARL PLAST (NASIK) PRIVATE LIMITED",
"PEARL POLY INDUSTRIES PVT LTD",
"PEARL PORTS & WAREHOUSING PRIVATE LIMITED",
"PEARL PRECISION PRODUCTS PRIVATE LIMITED",
"PEARL PRINT PACK PRIVATE LIMITED",
"PEARL PRINT WELL LIMITED",
"PEARL PRINTERS & PUBLISHERS PRIVATE LIMITED",
"PEARL QUARTZ STONE PRIVATE LIMITED",
"PEARL RETAIL SOLUTIONS PRIVATE LIMITED",
"PEARL SHIPPING PRIVATE LIMITED",
"PEARL SHIPTRANS PRIVATE LIMITED",
"PEARL STRIPS PVT LTD",
"PEARL THERMOPLAST PRIVATE LIMITED",
"PEARL VANIJYA PRIVATE LIMITED",
"PEARL VIEW HOTELS PRIVATE LIMITED",
"PEARL WOOD PRODUCTS PRIVATE LIMITED",
"PEARLCON REAL ESTATES PRIVATE LIMITED",
"PEARL-CORAL GEMS PRIVATE LIMITED",
"PEARLICE COLD CHAIN PRIVATE LIMITED",
"PEARLITE LINERS PRIVATE LIMITED",
"PEARLITE REAL PROPERTIES PRIVATE LIMITED",
"PEARLITE STEEL PRIVATE LIMITED",
"PEARLPINE AGRO-TRADE PRIVATE LIMITED",
"PEARLS & SWARAAJ COLLSER PRIVATE LIMITED",
"PEARLSPOT RESORTS PRIVATE LIMITED",
"PEARLSTONE TECHNOLOGY PRIVATE LIMITED",
"PEARLTREE HOTELS & RESORTS PRIVATE LIMITED",
"PEARLTREE INFRASTRUCTURE PRIVATE LIMITED",
"PEARLTRI FOODS PRIVATE LIMITED",
"PEARLWHITE PAINTS PRIVATE LIMITED",
"PEARSON SCHOOL KOMPALLY",
"PEASS INDUSTRIAL ENGINEERS PRIVATE LIMITED",
"PEATON ELECTRICAL COMPANY LIMITED",
"PEB METAL BUILDINGS PRIVATE LIMITED",
"PEB STEEL LLOYD (INDIA) LIMITED",
"PEBBLE EXPORTS PRIVATE LIMITED",
"PEBBLE MULTI SERVICES PRIVATE LIMITED",
"PEBBLE STREET HOSPITALITY PRIVATE LIMITED",
"PEBBLE TRADING AND FINANCE PRIVATE LIMITED",
"PEBBLES AND SAND CONSULTING SERVICES PRIVATE LIMITED",
"PEBBLES INFRA-TECH PRIVATE LIMITED",
"PEBBLES WELFARE & CHARITABLE TRUST",
"PEBCO INDUSTRIES LIMITED",
"PEBCO MOTORS LTD",
"PEBPLUS GLOBAL PRIVATE LIMITED",
"PEC ATTESTATION AND APOSTILLE SERVICES INDIA PRIVATE LIMITED",
"PEC LIMITED",
"PEC POWER INFRA PRIVATE LIMITED",
"PEC THERM PRIVATE LIMITED",
"PEC VENTURES PRIVATE LIMITED",
"PECAN ADVISORS PRIVATE LIMITED",
"PECANZ FASHION PRIVATE LIMITED",
"PECIFIC STEEL PRIVATE LIMITED",
"PECK BIOTECH PRIVATE LIMITED",
"PECMA AIR SYSTEMS PRIVATE LIMITED",
"PECO PROJECTS & INFRASTRUCTURE PRIVATE LIMITED",
"PECO PROJECTS PRIVATE LIMITED",
"PECON DISTRIBUTORS PVT LTD",
"PECON SOFTWARE LIMITED",
"PECOPP PEST CONTROL SERVICES PRIVATE LIMITED",
"PECOS HOTELS AND PUBS LIMITED",
"PECTRO BIOTECH PRIVATE LIMITED",
"PECULIAR LOGISTICS PRIVATE LIMITED",
"PEDDADA MANUFACTURERS PRIVATE LIMITED (OPC)",
"PEDDAR REALTY LIMITED",
"PEDDER'S INVESTMENT HOLDINGS PRIVATE LIMITED",
"PEDDINGTON LUBRICANTS & COATINGS PRIVATE LIMITED",
"PEDDLE DIGITALS PRIVATE LIMITED",
"PEDERSEN CONSULTANTS INDIA PRIVATE LIMITED",
"PEDHIWALA CERAMICS PRIVATE LIMITED",
"PEDROLLO PUMPS PRIVATE LIMITED",
"PEDVAK TECHNOLOGIES PRIVATE LIMITED",
"PEE AAR AUTOMOTIVE TECHNOLOGIES PRIVATE LIMITED",
"PEE AAR ORGANICS AND CHEMICALS PRIVATE LIMITED",
"PEE AAR SECURITIES LIMITED",
"PEE CEE CASTINGS PVT LTD",
"PEE CEE COSMA SOPE LIMITED",
"PEE CEE TEXFEB PRIVATE LIMITED",
"PEE DEE CYCLES PRIVATE LIMITED",
"PEE EEM AUTO TECH PRIVATE LIMITED",
"PEE EMPRO EXPORTS PRIVATE LIMITED",
"PEE ESS DISHNET PRIVATE LIMITED",
"PEE GEE DIGI PRINTS PRIVATE LIMITED",
"PEE GEE FABRICS PRIVATE LIMITED",
"PEE JAY FABRICS PRIVATE LIMITED",
"PEE KAY FURNISHINGS PRIVATE LIMITED",
"PEE KAY PAPER AND BOARD PVT LTD",
"PEE KAY SCAFFOLDINGS AND SHUTTERINGS LIMITED",
"PEE KAY STRUCTURAL EQUIPMENTS PRIVATE LIMITED",
"PEE PEE APPLIANCES PRIVATE LIMITED",
"PEE PEE MANDAL PROJECTS PRIVATE LIMITED",
"PEE PEE MANUFACTURING COMPANY PRIVATE LIMITED",
"PEE PEE PUBLISHERS AND DISTRIBUTORS PRIVATE LIMITED",
"PEE TEE DISTRIBUTORS PRIVATE LIMITED",
"PEE TEE TURNERS LIMITED",
"PEE VEE TEXTILES LIMITED",
"PEEAAR FINANCE COMPANY PRIVATE LIMITED",
"PEECH STUDIO INDIA PRIVATE LIMITED",
"PEECO AGENCIES PRIVATE LIMITED",
"PEECO POLYTECH PRIVATE LIMITED",
"PEEJAY RUBBER INDUSTRIES PRIVATE LIMITED",
"PEEK-A-BOO-ZOO PRIVATE LIMITED",
"PEEKAY AGENCIES PVT LTD",
"PEEKAY AIR FILTERS PRIVATE LIMITED",
"PEEKAY CREDIT SERVICES PVT LTD",
"PEEKAY FARM EQUIPMENTS (INDIA) PRIVATE LIMITED",
"PEEKAY PETROCHEM PRIVATE LIMITED",
"PEEKAY ROLLING MILLS PRIVATE LIMITED",
"PEEKAY STEEL CASTINGS PRIVATE LIMITED",
"PEEKAY SYNTHETICS PRIVATE LIMITED",
"PEEKAY WINE MERCHANTS PRIVATE LIMITED",
"PEEKEYEM CONSTRUCTIONS PRIVATE LIMITED",
"PEEL WORKS PRIVATE LIMITED",
"PEELIFE PHARMACEUTICALS PRIVATE LIMITED",
"PEENYA FINE COMP PRIVATE LIMITED",
"PEENYA INDUSTRIAL GASES PRIVATE LIMITED",
"PEENYA PHARMACEUTICALS PRIVATE LIMITED",
"PEEPAL SOFTWARE SOLUTIONS PRIVATE LIMITED",
"PEEPAL TECHNOLOGY AND MANAGEMENT CONSULTING PRIVATE LIMITED",
"PEEPUL CAPITAL ADVISORS PRIVATE LIMITED",
"PEEPUL CAPITAL INVESTMENT ADVISORS PRIVATE LIMITED",
"PEER CONSULTING INDIA PRIVATE LIMITED",
"PEER INVESTMENTS PRIVATE LIMITED",
"PEER PAPERMACHINES PRIVATE LIMITED",
"PEERAGE PHARMA PRIVATE LIMITED",
"PEERBITS SOLUTION PRIVATE LIMITED",
"PEERBRAINS TECHNOLOGIES PRIVATE LIMITED",
"PEERLESS BIOTECH PRIVATE LIMITED",
"PEERLESS FINANCIAL PRODUCTS DISTRIBUTION",
"PEERLESS FINANCIAL SERVICES LTD",
"PEERLESS HOSPITAL B K ROY RES CENTRE",
"PEERLESS HOSPITEX HOSPITAL AND RESEARCH CENTER LIMITED",
"PEERLESS HOTELS LTD",
"PEERLESS PRINTING PRIVATE LIMITED",
"PEERLESS SBA (OPC) PRIVATE LIMITED",
"PEERLESS SECURITIES",
"PEERLESS SOFTWARE PRIVATE LIMITED",
"PEERME SOFTWARE TECHNOLOGY PRIVATE LIMITED",
"PEERTECHZ PUBLICATIONS PRIVATE LIMITED",
"PEERUMADE FARMERS PRODUCER COMPANY LIMITED",
"PEESONS POLYMERS PRIVATE LIMITED",
"PEETAMBRA COMMUNICATION PRIVATE LIMITED",
"PEETI SECURITIES LIMITED",
"PEEVEE PHARMA AND FEEDS LIMITED",
"PEEVEE PRECISION WORKS PRIVATE LIMITED",
"PEEVEES PROJECTS PRIVATE LIMITED",
"PEEYESYEM HK MOTORS LLP",
"PEGADO FIXING SOLUTIONS PRIVATE LIMITED",
"PEGAONE SOFTWARE SOLUTIONS (INDIA) PRIVATE LIMITED",
"PEGASUS ADVISORY PRIVATE LIMITED",
"PEGASUS ASSETS RECONSTRUCTION PRIVATE LIMITED",
"PEGASUS ASSOCIATES (I) PRIVATE LIMITED",
"PEGASUS BUILDTECH PRIVATE LIMITED",
"PEGASUS CREST INTERNATIONAL PRIVATE LIMITED",
"PEGASUS CUSTOM HOUSE AGENCY PRIVATE LIMITED",
"PEGASUS EVENTS PRIVATE LIMITED",
"PEGASUS FARMACO INDIA PRIVATE. LIMITED.",
"PEGASUS HRD CENTRE PRIVATE LIMITED",
"PEGASUS INFOCORP PRIVATE LIMITED",
"PEGASUS INLAND CONTAINER DEPOT PRIVATE LIMITED",
"PEGASUS KNOWLEDGE SOLUTIONS INDIA PRIVATE LIMITED",
"PEGASUS LABORATORIES PRIVATE LIMITED",
"PEGASUS LAND AND HOUSING PRIVATE LIMITED",
"PEGASUS LANE PRIVATE LIMITED",
"PEGASUS PANELS PRIVATE LIMITED",
"PEGASUS PROPERTIES PRIVATE LIMITED",
"PEGASUS RETAIL INDIA PRIVATE LIMITED",
"PEGASUS SEWING MACHINE PTE LIMITED",
"PEGASUS SUSTAINABILITY PRIVATE LIMITED",
"PEGASUS TECHNOCRATS PRIVATE LIMITED",
"PEGASUS TOWNSHIPS LIMITED",
"PEGASUS TOY-KRAFT PRIVATE LIMITED",
"PEGASUS WASTE MANAGEMENT PRIVATE LIMITED",
"PEGASYS INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"PEGASYS MACHINES PRIVATE LIMITED",
"PEGASYSTEMS WORLDWIDE INDIA PRIVATE LIMITED",
"PEGATRON TECHNOLOGY INDIA PRIVATE LIMITED",
"PEGAZ TECHNOLOGY AND SOLUTIONS PRIVATE LIMITED",
"PEGEEN BUILDERS & DEVELOPERS PRIVATE LIMITED",
"PEGG CONSULTANT AND ENGINEERS PRIVATE LIMITED",
"PEGMA RESOURCES PRIVATE LIMITED",
"PEHACHAN ADVERTISING AND MARKETING PRIVATE LTD",
"PEHAL PHARMA AND CHEMICALS INDIA LIMITED",
"PEHALWAAN AGRO INDIA PRIVATE LIMITED",
"PEHEL FOUNDATION",
"PEHLAY AKSHAR FOUNDATION",
"PEHOWA VEGETABLE PRODUCER COMPANY LIMITED",
"PEI-GENESIS CONNECTIVITY SOLUTIONS INDIA PRIVATE LIMITED",
"PEINER SMAG MACHINERY INDIA PRIVATE LIMITED",
"PEIRCE & LESLIE TRAVEL PRIVATE LIMITED",
"PEIRCE LESLIE INDIA LIMITED",
"PEKETI VENTURES PRIVATE LIMITED",
"PEKON HOUSING PVT.LTD.",
"PEKT LOCKS & HARDWARE PRIVATE LIMITED",
"PEL ASSET AND INFRASTRUCTURE LIMITED",
"PELAGIA MARINE SERVICES PRIVATE LIMITED",
"PELATIS RIGAS",
"PELATRO SOLUTIONS PRIVATE LIMITED",
"PELEMIX INDIA PRIVATE LIMITED",
"PELF INFOTECH PRIVATE LIMITED",
"PELFIZZ BIOTECH PRIVATE LIMITED",
"PELICAN AIR PRIVATE LIMITED",
"PELICAN ASSOCIATES PRIVATE LIMITED",
"PELICAN BATHWARE PRIVATE LIMITED",
"PELICAN BUILDMAT PRIVATE LIMITED",
"PELICAN BUSINESS VENTURES PRIVATE LIMITED",
"PELICAN CARBON BRUSH PRIVATE LIMITED",
"PELICAN CERAMIC INDUSTRIES PRIVATE LIMITED",
"PELICAN CONFECTIONERS PRIVATE LIMITED",
"PELICAN ENGITECH PRIVATE LIMITED",
"PELICAN FACILITIES MANAGEMENT PRIVATE LIMITED",
"PELICAN FOREX PRIVATE LIMITED",
"PELICAN GRANI MARMO PRIVATE LIMITED",
"PELICAN HOSPITALITY PRIVATE LIMITED",
"PELICAN POLY & PALLETS PRIVATE LIMITED",
"PELICAN REALTY PROJECTS PRIVATE LIMITED",
"PELICAN ROTOFLEX PRIVATE LIMITED",
"PELICAN TELECOM PRIVATE LIMITED",
"PELICAN TRAVXPERT PRIVATE LIMITED",
"PELICANS AUTOMOTIVE & PROMOTIONAL PRODUCTS PRIVATE LIMITED",
"PELICON HOMES PRIVATE LIMITED",
"PELIKAN DOSSIER PRIVATE LIMITED",
"PELIKAN OFFICE AUTOMATION PRIVATE LIMITED",
"PELISWAN IMPEX PRIVATE LIMITED",
"PELIXIR HABITAT AND DESIGNS PRIVATE LIMITED",
"PELL TECH HEALTH CARE PRIVATE LIMITED",
"PELLAGIC FOOD INGREDIENTS PRIVATE LIMITED",
"PELLE & CARTA TECNOLOGI LLP",
"PELLE INDIA PRIVATE LIMITED",
"PELLETS PHARMA LIMITED",
"PELLSYS PHARMA PRIVATE LIMITED",
"PELLUCID HEALTHCARE NETWORKS PRIVATE LIMITED",
"PELLUCID LIFESCIENCES PRIVATE LIMITED",
"PELO CONSTRUCTION PRIVATE LIMITED",
"PELORUS TECHNOLOGIES PRIVATE LIMITED",
"PELOTON CONSULTING INDIA PRIVATE LIMITED",
"PELTON POWER TECHNOLOGIES PRIVATE LIMITED",
"PEMA PRESERVE PRIVATE LIMITED",
"PEMAC PROJECTS PRIVATE LIMITED",
"PEMARI TECHNOLOGY PRIVATE LIMITED",
"PEMAX EXPORTS PRIVATE LIMITED",
"PEMMASANI PROPERTIES & INVESTMENTS PRIVATE LIMITED",
"PEMMASANI SOLAR POWER PRIVATE. LIMITED.",
"PEMS ENGINEERING CONSULTANTS PRIVATE LIMITED",
"PEN INDIA LIMITED",
"PEN MARUDHAR CINE ENTERTAINMENT PRIVATE LIMITED",
"PEN MUSIC PRIVATE LIMITED",
"PENA POWER ENGINEERING AND AUTOMATION PRIVATE LIMITED",
"PENA4 TECH SOLUTIONS INDIA PRIVATE LIMITED",
"PENAM LABORATORIES LIMITED",
"PENANG ENTERPRISES PRIVATE LIMITED",
"PENBROOK CAPITAL ADVISORS PRIVATE LIMITED",
"PENCH TIGER RETREAT PRIVATE LIMITED",
"PENCIL MARK INTERIOR SOLUTIONS LLP",
"PENCILWORKS LEARNING SOLUTIONS PRIVATE LIMITED",
"PENDO PLAST PRIVATE LIMITED",
"PENETRON INDIA PRIVATE LIMITED",
"PENETRON PRODUCTS PRIVATE LIMITED",
"PENEX HVAC INDUSTRIES PRIVATE LIMITED",
"PENG YOU QUAN PRIVATE LIMITED",
"PENGALA LEARNING PRIVATE LIMITED",
"PENGG USHA MARTIN WIRES PRIVATE LIMITED",
"PENGORIA OIL MILLS PRIVATE LIMITED",
"PENGORIYA DAL MILLS PRIVATE LIMITED",
"PENGUIN APPARELS PRIVATE LIMITED",
"PENGUIN BOOKS INDIA PRIVATE LIMITED",
"PENGUIN COLDSTORAGES PRIVATE LIMITED",
"PENGUIN CRM PRIVATE LIMITED",
"PENGUIN EDUCATION PRIVATE LIMITED",
"PENGUIN ELECTRONICS LIMITED",
"PENGUIN ELECTRONICS PRIVATE LIMITED",
"PENGUIN ENGINEERS & INFRATECH PRIVATE LIMITED",
"PENGUIN GARMENTS PRIVATE LIMITED",
"PENGUIN HOLIDAYS PRIVATE LIMITED",
"PENGUIN HOMES PRIVATE LIMITED",
"PENGUIN PETROLEUM SERVICES PRIVATE LIMITED",
"PENGUIN PLYWOOD PRIVATE LIMITED",
"PENGUIN POLYFOAM (GUJARAT) PRIVATE LIMITED",
"PENGUIN RANDOM HOUSE INDIA PRIVATE LIMITED",
"PENGUIN RESORTS PRIVATE LIMITED",
"PENGUIN TRADING & AGENCIES LIMITED",
"PENIEL ELECTRICAL ENGINEERING PRIVATE LIMITED",
"PENINSULA CROSSROADS PRIVATE LIMITED",
"PENINSULA DATA SECURE PRIVATE LIMITED",
"PENINSULA DESIGNS PRIVATE LIMITED",
"PENINSULA FACILITY MANAGEMENT SERVICES LIMITED",
"PENINSULA GRAND HOTEL",
"PENINSULA HOLDINGS AND INVESTMENTS PRIVATE LIMITED",
"PENINSULA INFRA DEVELOPMENTS PRIVATE LIMITED",
"PENINSULA LAND LIMITED",
"PENINSULA PICTURES PRIVATE LIMITED",
"PENINSULA PROJECTS BANGALORE PRIVATE LIMITED",
"PENINSULAR ART WORKS",
"PENINSULAR FISHERIES PRIVATE LIMITED",
"PENINSULAR INVESTMENTS PRIVATE LIMITED",
"PENINSULAR MARITIME INDIA PRIVATE LIMITED",
"PENINSULAR MARKETING PRIVATE LIMITED",
"PENINSULAR TANKERS PRIVATE LIMITED",
"PENN ELCOM HARDWARE PRIVATE LIMITED",
"PENN FROZEN FOODS PRIVATE LIMITED",
"PENNA CEMENT INDUSTRIES LIMITED",
"PENNA SEEDS PRIVATE LIMITED",
"PENNA SHIPPING LIMITED",
"PENNANT CONSULTING SERVICES PRIVATE LIMITED",
"PENNANT ENGINEERING PRIVATE LIMITED",
"PENNANT INTERNATIONAL CORPORATION INDIA PRIVATE LIMITED",
"PENNANT TECHNOLOGIES PRIVATE LIMITED",
"PENNAR ENGINEERED BUILDING SYSTEMS LIMITED",
"PENNAR ENVIRO LIMITED",
"PENNAR INDUSTRIES LIMITED",
"PENNAR RENEWABLES PRIVATE LIMITED",
"PENNAR TRADING PVT. LTD.",
"PENNAZHAGI HOTELS PRIVATE LIMITED",
"PENNCO CEMENT INDUSTRIES PVT LTD",
"PENNCO ENTERPRISES PRIVATE LIMITED",
"PENNON SHIPPING PVT LTD",
"PENNSUMMIT TUBULAR ENGINEERING PRIVATE LIMITED.",
"PENNWALT PRIVATE LIMITED",
"PENNYWISE SOLUTIONS PRIVATE LIMITED",
"PENPENNY INFOTECH PRIVATE LIMITED",
"PENREX CHROME STATIONERY PRIVATE LIMITED",
"PENROSE HEALTHCARE PRIVATE LIMITED",
"PENSANDO SYSTEMS INDIA PRIVATE LIMITED",
"PENSELL ADVERTISING PRIVATE LIMITED",
"PENSHIBAO WANG PRIVATE LIMITED",
"PENSIA BIOTECH",
"PENSIONER OF RANCHI UNIVERSITY",
"PENSLA STEELS PRIVATE LIMITED",
"PENSOL EXPORTS PRIVATE LIMITED",
"PENSOL INDUSTRIES LIMITED",
"PENSOL OIL COMPANY PVT.LTD.",
"PENSYS SOFTWARE PRIVATE LIMITED",
"PENTA AQUA PRIVATE LIMITED",
"PENTA AUTO EQUIPMENTS PRIVATE LIMITED",
"PENTA AUTO FEEDING INDIA LIMITED",
"PENTA AUTOMATION SYSTEMS PRIVATE. LIMITED",
"PENTA COAL PRIVATE LIMITED",
"PENTA CONTRACTORS PRIVATE LIMITED",
"PENTA CUT TOOLS PRIVATE LIMITED",
"PENTA DESIGNERS AND ENGINEERS PRIVATE LIMITED",
"PENTA ELECTROMEC PRIVATE LIMITED",
"PENTA FORGE ENGINEERING WORKS PRIVATE LIMITED",
"PENTA FOUR SECURITY SERVICES PRIVATE LIMITED",
"PENTA FREIGHT PRIVATE LIMITED",
"PENTA GLOBAL ENGINEERING AND CONSTRUCTIONS PRIVATE LIMITED",
"PENTA GOLD PRIVATE LIMITED",
"PENTA INDIA TECHNICAL CONSULTANTS PRIVATE LIMITED",
"PENTA PHARMA PRIVATE LIMITED",
"PENTA RENEW ENERGY PRIVATE LIMITED",
"PENTA SOFTWARE PRIVATE. LIMITED.",
"PENTA TRAVELS (INDIA) PRIVATE LIMITED",
"PENTACLE CONSULTANTS I PRIVATE LIMITED",
"PENTACLE CREATIONZ PRIVATE LIMITED",
"PENTACLE HOTELS AND RESTAURANT PRIVATE LIMITED",
"PENTACLE IT SOLUTIONS PRIVATE LIMITED",
"PENTACO AUTOMATION PRIVATE LIMITED",
"PENTAEGIS SECURITY AND FACILITY SERVICES PRIVATE LIMITED",
"PENTAFIELD AGRO AND FOODS PRIVATE LIMITED",
"PENTAFLEX FILMS LLP",
"PENTAFLO HYDRO PRIVATE LIMITED",
"PENTAGLOBE PHARMACY PRIVATE LIMITED",
"PENTAGON ALUMINIUM COMPANY PRIVATE LIMITED",
"PENTAGON ASSEMBLY AUTOMATION PRIVATE LIMITED",
"PENTAGON COMMUNICATIONS PRIVATE LIMITED",
"PENTAGON EL MECH SOLUTION PRIVATE LIMITED",
"PENTAGON EL-MECH SOLUTIONS (SOUTH) PRIVATE LIMITED",
"PENTAGON ENGIMECH PRIVATE LIMITED",
"PENTAGON ENTERPRISES PRIVATE LIMITED",
"PENTAGON EVENTS & ACTIVATIONS PRIVATE LIMITED",
"PENTAGON FORGE & MACHINE LIMITED",
"PENTAGON FREIGHT SERVICES INDIA PRIVATE LIMITED",
"PENTAGON GARMENTS PRIVATE LIMITED",
"PENTAGON HEALTHCARE PRIVATE LIMITED",
"PENTAGON INDUSTRIES PRIVATE LIMITED",
"PENTAGON INFRATECH PRIVATE LIMITED",
"PENTAGON INTERNATIONAL FREIGHT SOLUTIONS PRIVATE LIMITED",
"PENTAGON LABS LIMITED",
"PENTAGON LOGISTIX PRIVATE LIMITED",
"PENTAGON LUBRICANTS (INDIA) PRIVATE LIMITED",
"PENTAGON MACHINES AND SERVICES PRIVATE LIMITED",
"PENTAGON MARINE SERVICES PRIVATE LIMITED",
"PENTAGON NETWORK SOLUTIONS PRIVATE LIMITED",
"PENTAGON PLASTIC INDUSTRIES PRIVATE LIMITED",
"PENTAGON PLASTICS PRIVATE LIMITED",
"PENTAGON PLYWOOD PRIVATE LIMITED",
"PENTAGON PREMISES PRIVATE LIMITED",
"PENTAGON PRINTS AND PACK PRIVATE LIMITED",
"PENTAGON PROJECTS PRIVATE LIMITED",
"PENTAGON RUBBER LIMITED",
"PENTAGON RUGGED SYSTEMS (INDIA) PRIVATE LIMITED",
"PENTAGON SEEDS INDIA PRIVATE LIMITED",
"PENTAGON STEELS INDIA PRIVATE LIMITED",
"PENTAGON STOCK BROKERS PRIVATE LIMITED",
"PENTAGON SUPPLYCHAIN MANAGEMENT PRIVATE LIMITED",
"PENTAGON SWITCHGEAR PRIVATE LIMITED",
"PENTAGON SYNERGY SOLUTIONS PRIVATE LIMITED",
"PENTAGON SYSTEM AND SERVICES PRIVATE LIMITED",
"PENTAGON TAPES PRIVATE LIMITED",
"PENTAGON TECH FUSION SERVICES PRIVATE LIMITED",
"PENTAGON WATERLINES PRIVATE LIMITED",
"PENTAGONA CONSTRUCTION PRIVATE LIMITED",
"PENTAGRAM CONSULTING PRIVATE LIMITED",
"PENTAGRAM FILMS PRIVATE LIMITED",
"PENTAGREEN NATURE FIRST INDIA PRIVATE LIMITED",
"PENTAIR THERMAL MANAGEMENT INDIA PRIVATE LIMITED",
"PENTAIR VALVED & CONTROLS INDIA PRIVATE LIMITED",
"PENTAIR WATER INDIA PRIVATE LIMITED",
"PENTANAMI TECHNOLOGIES PRIVATE LIMITED",
"PENTANE LOGISTICS PRIVATE LIMITED",
"PENTANEN ENGINEERING PRIVATE LIMITED",
"PENTANOV INGREDIENTS PRIVATE LIMITED",
"PENTA-OCEAN CONSTRUCTION INDIA PRIVATE LIMITED",
"PENTAPACK POLYMERS PRIVATE LIMITED",
"PENTAPLUS PRINTERS PRIVATE LIMITED",
"PENTAPLUS RUBBER PRODUCTS PRIVATE LIMITED",
"PENTAPURE RO SYSTEMS (INDIA) PRIVATE LIMITED",
"PENTAS ENGINEERING PROJECTS PRIVATE LIMITED",
"PENTASAFE ACADEMY PRIVATE LIMITED",
"PENTASAFE INFOCOM PRIVATE LIMITED",
"PENTASHIVA INFRAVENTURES PRIVATE LIMITED",
"PENTASOFT IT CONSULTANCY PRIVATE LIMITED",
"PENTASPACE CONSULTANTS PRIVATE LIMITED",
"PENTASTAR POWERCON PRIVATE LIMITED",
"PENTA-TECH ENGINEERING PRIVATE LIMITED",
"PENTATION ANALYTICS PRIVATE LIMITED",
"PENTAUR TECHNOLOGY PRIVATE LIMITED",
"PENTAVALENT BIO SCIENCES PRIVATE LIMITED",
"PENTAVOX HERBALS PRIVATE LIMITED",
"PENTAWIS INNOVATIONS PRIVATE LIMITED",
"PENTAX ENGINEERING PRIVATE LIMITED",
"PENTAX MEDICAL INDIA PRIVATE LIMITED",
"PENTAX PLASTICS PRIVATE LIMITED",
"PENTECH BUSINESS MANAGEMENT PRIVATE LIMITED",
"PENTEL STATIONERY INDIA PRIVATE LIMITED",
"PENTIUM CONSTRUCTION PRIVATE LIMITED",
"PENTLAND INDIA TRADING PRIVATE LIMITED",
"PENTOGON POWER INDIA PRIVATE LIMITED",
"PENTRISE DEVELOPERS PRIVATE LIMITED",
"PENUVEL AGENCIES PRIVATE LIMITED",
"PENVER PRODUCTS LIMITED",
"PEOCIT SOFTWARE SOLUTIONS PRIVATE LIMITED",
"PEOL TECHNOLOGIES PRIVATE LIMITED",
"PEOPLE 10 TECHNOSOFT PRIVATE LIMITED",
"PEOPLE 360 D CONSULTING PRIVATE LIMITED",
"PEOPLE COLLEGE OF DENTAL SCIENCES",
"PEOPLE COMBINE AVENUES LIMITED",
"PEOPLE COMBINE BENGALURU KNOWLEDGE INSTITUTIONS PRIVATE LIMITED",
"PEOPLE COMBINE HOSPITALITY PRIVATE LIMITED",
"PEOPLE CONNECT PLACEMENTS PRIVATE LIMITED",
"PEOPLE DESIGN AND COMMUNICATIONS (INDIA) PRIVATE LIMITED",
"PEOPLE EQUITY HR CONSULTING PRIVATE LIMITED",
"PEOPLE FOR THE ETHICAL TREATMENT OF ANIMALS PETS INDIA",
"PEOPLE IN BUSINESS INDIA PRIVATE LIMITED",
"PEOPLE MATTERS MEDIA PRIVATE LIMITED",
"PEOPLE MEDIA FACTORY LLP",
"PEOPLE MESH PRIVATE LIMITED",
"PEOPLE NORTH ADCON PRIVATE LIMITED",
"PEOPLE POSITIVE SOLUTIONS LLP",
"PEOPLE POWER INDIA PRIVATE LIMITED",
"PEOPLE PRIME WORLDWIDE PRIVATE LIMITED",
"PEOPLE PROCESS TECK PRIVATE LIMITED",
"PEOPLE PUBLIC SCHOOL",
"PEOPLE REALM RECRUITMENT SERVICES PRIVATE LIMITED",
"PEOPLE STEAD INDIA PRIVATE LIMITED",
"PEOPLE STRONG HR SERVICES PRIVATE LIMITED",
"PEOPLE TECH ENTERPRISES PRIVATE LIMITED",
"PEOPLE TECH IT CONSULTANCY PRIVATE LIMITED",
"PEOPLE TO PEOPLE HEALTH FOUNDATION",
"PEOPLE TREE HOSPITALSTMI_PRIVATE LIMITED",
"PEOPLE'S TRUSTEESHIP PACKAGING PVT LTD",
"PEOPLE2PAY MANAGEMENT INDIA PRIVATE LIMITED",
"PEOPLEBAY CONSULTANCY SERVICES PRIVATE LIMITED",
"PEOPLECARE BUSINESS SOLUTIONS PRIVATE LIMITED",
"PEOPLECART PRIVATE LIMITED",
"PEOPLEEDGE BUSINESS SOLUTIONS PRIVATE LIMITED.",
"PEOPLEFY INFOSOLUTIONS PRIVATE LIMITED",
"PEOPLEGROVE TECH PRIVATE LIMITED",
"PEOPLELINK UNIFIED COMMUNICATIONS PRIVAT E LIMITED",
"PEOPLELOGIC BUSINESS SOLUTIONS PRIVATE LIMITED",
"PEOPLENET ACCESS SOLUTIONS PRIVATE LIMITED",
"PEOPLENOMIC CONSULTING PRIVATE LIMITED",
"PEOPLEONE TECHNOLOGY PRIVATE LIMITED",
"PEOPLEPRO MANAGEMENT SERVICES PRIVATE LIMITED",
"PEOPLEPROSPER TECHNOLOGIES PRIVATE LIMITED",
"PEOPLES COLLEGE OF MEDICAL SCIENCES & RESEARCH CENTRE",
"PEOPLES EDUCATION SOCIETYS SEC ENG MEDIUM SCHOOL",
"PEOPLE'S EXPORTS PRIVATE LIMITED",
"PEOPLE'S HERITAGE HOSPITAL PRIVATE LIMITED",
"PEOPLES MULTISPECIALITY HOSPITAL",
"PEOPLES MUTUALLY AIDED CO-OPERATIVE CREDIT SOCIETY LIMITED",
"PEOPLES PUBLISHING HOUSE PRIVATE LIMITED",
"PEOPLE'S RESPONSE FOR INDIA'S DEVELOPMENT & EMPOWERMENT CONFEDERATION",
"PEOPLES UNIVERSITY",
"PEOPLESENSE MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"PEOPLESQUARE HUMAN RESOURCE CONSULTING PRIVATE LIMITED",
"PEOPLETECH INFRACON PRIVATE LIMITED",
"PEOPLETREE KNOWLEDGE SERVICES PRIVATE LIMITED",
"PEOPLS URDU PRIMARY SCHOOL AUSA",
"PEORA FASHIONS PRIVATE LIMITED",
"PEP AGRO INDUSTRIES PRIVATE LIMITED",
"PEP TECHNOLOGIES PRIVATE LIMITED",
"PEPAL TECHNOLOGY PRIVATE LIMITED",
"PEPCART LOGISTICS PRIVATE LIMITED",
"PEPCODING EDUCATION (OPC) PRIVATE LIMITED",
"PEPCON CONFECTIONERS PRIVATE LIMITED",
"PEPCOPP PEST CONTROL SERVICES PRIVATE LIMITED",
"PEPCUS SOFTWARE SERVICES PRIVATE LIMITED",
"PEPE JEANS INDIA LIMITED",
"PEPE JEANS INNERFASHION PRIVATE LIMITED",
"PEPERONCINO CUISINE PRIVATE LIMITED",
"PEPFUELS TECHNOLOGIES PRIVATE LIMITED",
"PEPI FABRICS PRIVATE LIMITED",
"PEPPE NUTRITIONS PRIVATE LIMITED",
"PEPPER CLOUD PRIVATE LIMITED",
"PEPPER CONTENT PRIVATE LIMITED",
"PEPPER FARMS PRIVATE LIMITED",
"PEPPER HEALTH PRIVATE LIMITED",
"PEPPER HOTELS PRIVATE LIMITED",
"PEPPER MEDIA PRIVATE LIMITED",
"PEPPER SQUARE SOFTWARE SERVICES PRIVATE LIMITED",
"PEPPERBIZ MARKETING AND FRANCHISE PRIVATE LIMITED",
"PEPPERFRY LIMITED",
"PEPPERFRY PRIVATE LIMITED",
"PEPPERL & FUCHS (INDIA) PRIVATE LIMITED",
"PEPPERL & FUCHS FACTORY AUTOMATION PRIVATE LIMITED",
"PEPPERL & FUCHS MANUFACTURING INDIA PRIVATE LIMITED",
"PEPPERL AND FUCHS INDIA PRIVATE LIMITED",
"PEPPERMINT CLOTHING PRIVATE LIMITED",
"PEPPERMINT PRIVATE LIMITED",
"PEPPL CONSTRUCTION PRIVATE LIMITED",
"PEPPO TECHNOLOGIES PRIVATE LIMITED",
"PEPS INDUSTRIES PRIVATE LIMITED",
"PEPSICO",
"PEPSICO GLOBAL BUSINESS SERVICES INDIA LLP",
"PEPSICO INDIA HOLDINGS PRIVATE LIMITED",
"PEPSICO INDIA SALES PRIVATE LIMITED",
"PEPSU ROAD TRANSPORT CORPORATION",
"PEPTECH BIOSCIENCES LIMITED",
"PEPTECH BUILDERS & DEVELOPERS PRIVATE LIMITED",
"PEPTECH CONSTRUCTIONS PRIVATE LIMITED",
"PER SQUARE FEET REAL ESTATE PRIVATE LIMITED",
"PERAJ INSURANCE BROKERS PRIVATE LIMITED",
"PERAMBALUR SUGAR MILLS LIMITED",
"PERAMOUNT FORGE AND FITTINGS PRIVATE LIMITED",
"PERAPSIS INFOTECH PRIVATE LIMITED",
"PERCEIVESTAR INDIA PRIVATE LIMITED",
"PERCEPT ADVERTISING AND MARKETING SERVICES PRIVATE LIMITED",
"PERCEPT BRANDS PRIVATE LIMITED",
"PERCEPT D MARK INDIA PRIVATE LIMITED",
"PERCEPT DEVICES MARKETING PRIVATE LIMITED",
"PERCEPT FINANCIAL CONSULTANTS PRIVATE LIMITED",
"PERCEPT FINSERVE PRIVATE LIMITED",
"PERCEPT H PRIVATE LIMITED",
"PERCEPT HOLDINGS",
"PERCEPT LIMITED",
"PERCEPT LIVE PRIVATE LIMITED",
"PERCEPT OUT OF HOME PRIVATE LIMITED",
"PERCEPT PRINTING SOLUTIONS PRIVATE LIMITED",
"PERCEPT PROFILE PRIVATE LIMITED",
"PERCEPT TALENT MANAGEMENT PRIVATE LIMITED",
"PERCEPTION CARE INDIA PRIVATE LIMITED",
"PERCEPTION SOLUTIONS PRIVATE LIMITED",
"PERCEPTION SYSTEM PRIVATE LIMITED",
"PERCEPTIVE IDEAS CONSULTING ENGINEERS PRIVATE LIMITED",
"PERCEPTRON NON CONTACT METROLOGY SOLUTIONS PRIVATE LIMITED",
"PERCH RESIDENCES PRIVATE LIMITED",
"PERCH TECHNOLOGIES PRIVATE LIMITED",
"PERCIPERE CONSULTING INDIA PRIVATE LIMITED",
"PERCIPIENT ADVISORS PRIVATE LIMITED",
"PERCOS INDIA PRIVATE LIMITED",
"PERCY LOGISTICS AND INFRASTRUCTURE PRIVATE LIMITED",
"PERDAMAN PHARMACEUTICALS PRIVATE LIMITED",
"PERDURO (OPC) PRIVATE LIMITED",
"PERE CONSULTANTS PRIVATE LIMITED",
"PEREGRINE BUSINESS NETWORKS PRIVATE LIMITED",
"PEREGRINE EXPRESS TECHNOLOGIES PRIVATE LIMITED",
"PEREGRINE GUARDING PRIVATE LIMITED",
"PEREGRINE IT SERVICES PRIVATE LIMITED",
"PEREGRINE LOGISTICS PRIVATE LIMITED",
"PERENNE PERSONAL PRODUCTS PRIVATE LIMITED",
"PERENNIAL CONTRACTORS PRIVATE LIMITED",
"PERENNIAL ENERGY PRIVATE LIMITED",
"PERENNIAL HYDROTECH PRIVATE LIMITED",
"PERENNIAL LIFESCIENCES PRIVATEC LIMITED",
"PERENNIAL METALS PRIVATE LIMITED",
"PERENNIAL REAL ESTATES PRIVATE LIMITED",
"PERENNIAL TECHNOLOGIES PRIVATE LIMITED",
"PERENNIALS INDIA PRIVATE LIMITED",
"PERFACT HATCHERIES AND POULTRY PRODUCTS INDIA PRIVATE LIMITED",
"PERFACT IMPRESSION PRIVATE LIMITED",
"PERFAWARE INDIA PRIVATE LIMITED",
"PERFEASY ENTERPRISES PRIVATE LIMITED",
"PERFECT (NASIK) ENGINEERING SERVICES PRIVATE LIMITED",
"PERFECT ACCOUNTING & SHARED SERVICES PRIVATE LIMITED",
"PERFECT AEROSOL VALVES PRIVATE LIMITED",
"PERFECT AGRI-MANAGEMENT COMPANY PRIVATE LIMITED",
"PERFECT AGROFOOD PRIVATE LIMITED",
"PERFECT ALLIED SAFETY AND SECURITY SERVICES PRIVATE LIMITED",
"PERFECT ALLOY COMPONENTS PRIVATE. LIMITED.",
"PERFECT ALLOYS & STEEL LIMITED",
"PERFECT ARTS AND CRAFTS PRIVATE LIMITED",
"PERFECT ASSAYER'S PRIVATE LIMITED",
"PERFECT AURA RAYS PRIVATE LIMITED",
"PERFECT AURARAYS PRIVATE LIMITED",
"PERFECT AUTOZONE PRIVATE LIMITED",
"PERFECT BAKERY PRIVATE LIMITED",
"PERFECT BELTS LIMITED",
"PERFECT BELTS PRIVATE LIMITED",
"PERFECT BEVERAGES PRIVATE LIMITED",
"PERFECT BREAD PRIVATE LIMITED",
"PERFECT CALIBRATION CENTRE PRIVATE LIMITED",
"PERFECT CAPITAL MARKETS PRIVATE LIMITED",
"PERFECT CAPITAL SERVICES LIMITED",
"PERFECT CARBOUYS PRIVATE LIMITED",
"PERFECT CARDAMOM AND SPICES MARKETING COMPANY PRIVATE LIMITED",
"PERFECT CARGO MOVERS PRIVATE LIMITED",
"PERFECT CHEM & TECHNOLOGIES PRIVATE LIMITED",
"PERFECT CLINICAL LABORATORY",
"PERFECT CLOTHING COMPANY PVT LTD",
"PERFECT CNC TECHNOLOGY PRIVATE LIMITED",
"PERFECT COATED PAPERS INDIA PRIVATE LIMITED",
"PERFECT COLOURANTS AND PLASTICS PRIVATE LIMITED",
"PERFECT COMMUNICATIONS PRIVATE LIMITED",
"PERFECT COMPANION INDIA PRIVATE LIMITED",
"PERFECT COMPUTER SOLUTIONS PRIVATE LIMITED",
"PERFECT CONCAST PRIVATE LIMITED",
"PERFECT CONCRETE PRODUCTS PRIVATE LIMITED",
"PERFECT CONSTECH PRIVATE LIMITED",
"PERFECT CONSTRO PRIVATE LIMITED",
"PERFECT CONTACT LENSES PRIVATE LIMITED",
"PERFECT CONTAINER TERMINAL",
"PERFECT CONTAINERS PRIVATE LIMITED",
"PERFECT COVER SECURITY SERVICES PRIVATE LIMITED",
"PERFECT CREATIVE MEDIA PRIVATE LIMITED",
"PERFECT CROPSCIENCE PRIVATE LIMITED",
"PERFECT DAY INDIA PRIVATE LIMITED",
"PERFECT DEBT MANAGEMENT PRIVATE LIMITED",
"PERFECT DETAILING STEEL SERVICES PRIVATELIMITED",
"PERFECT DIGITAL MEDIA RESOURCES P LIMITED",
"PERFECT DIGITAL MEDIA RESOURCES PRIVATE LIMITED",
"PERFECT DISCONS PRIVATE LIMITED",
"PERFECT ELECTRIC & ELECTRONICS PRIVATE LIMITED",
"PERFECT ELECTRICALS PRIVATE LIMITED",
"PERFECT ELECTRICS & ELECTRONIC PRIVATE LIMITED",
"PERFECT ELECTRONICS AND CONNECTORS PRIVATE LIMITED",
"PERFECT ENGINE COMPONENTS PRIVATE LIMITED",
"PERFECT ENGINEERING ASSOCIATES PRIVATE LIMITED",
"PERFECT ENGINEERING COMPONENTS PRIVATE LIMITED",
"PERFECT ENGITECH & HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"PERFECT ENROLLER INDIA PRIVATE LIMITED",
"PERFECT EQUIPMENTS PRIVATE LIMITED",
"PERFECT ERGONOMICS PRIVATE LIMITED",
"PERFECT FACILITIES MANAGEMENT PRIVATE LIMITED",
"PERFECT FASHIONS PRIVATE LIMITED",
"PERFECT FEEDCHEM PRIVATE LIMITED",
"PERFECT FILAMENTS LIMITED",
"PERFECT FINSEC PRIVATE LIMITED",
"PERFECT FIREBRICKS PRIVATE LIMITED",
"PERFECT GEARS (CHENNAI) PRIVATE LIMITED",
"PERFECT GENERATOR TECHNOLOGIES PRIVATE LIMITED",
"PERFECT GLASS DESIGNING SOLUTION PRIVATE LIMITED",
"PERFECT GLAZE (INDIA) PRIVATE LIMITED",
"PERFECT GREEN ENERGY SOLUTIONS PRIVATE LIMITED",
"PERFECT HANDLING AND LOGISTICS PRIVATE LIMITED",
"PERFECT HARMONY PRODUCTIONS PRIVATE LIMITED",
"PERFECT HAVEN-LUXURY ROOMS AND RESIDENCES PRIVATE LIMITED",
"PERFECT HERBAL CARE PRIVATE LIMITED",
"PERFECT HIRES PRIVATE LIMITED",
"PERFECT HOMES BUILDESTATE PRIVATE LIMITED",
"PERFECT HOMFIN PRIVATE LIMITED",
"PERFECT HOUSE PRIVATE LIMITED",
"PERFECT HOUSEWARE PRIVATE LIMITED",
"PERFECT ID INDIA PRIVATE LIMITED",
"PERFECT INDECOR PRIVATE LIMITED",
"PERFECT INFO SOLUTIONS PRIVATE LIMITED",
"PERFECT INFOSOFT PRIVATE LIMITED",
"PERFECT INFOSYS PRIVATE LIMITED",
"PERFECT INFRACORP PRIVATE LIMITED",
"PERFECT INNOVATIVE COMPUTERS PRIVATE LIMITED",
"PERFECT INSTRUMENTATION CONTROL (INDIA) PRIVATE LIMITED",
"PERFECT JEWELS PRIVATE LIMITED",
"PERFECT KRISHI MARKET YARD PRIVATE LIMITED",
"PERFECT LABEL PRIVATE LIMITED",
"PERFECT LIFESTYLE PRIVATE LIMITED",
"PERFECT LOOK SKIN AND DIAGNOSTIC CENTRE PRIVATE LIMITED",
"PERFECT LOVYA SECURITAS PRIVATE LIMITED",
"PERFECT MACHINE TOOLS COMPANY LIMITED",
"PERFECT MANPOWER SOLUTIONS PRIVATE LIMITED",
"PERFECT MEC SOLUTIONS PRIVATE LIMITED",
"PERFECT MECHANICAL INDUSTRIES PRIVATE LIMITED",
"PERFECT MEDICAL ENTERPRISES PRIVATE LIMITED",
"PERFECT MEGASTRUCTURE PRIVATE LIMITED",
"PERFECT METACRAFT LLP",
"PERFECT METAL CUT SERVICES INDIA PRIVATE LIMITED",
"PERFECT METAL STRUCTURE PRIVATE LIMITED",
"PERFECT METTCAST PRIVATE LIMITED",
"PERFECT MILK PRODUCTS PRIVATE LIMITED",
"PERFECT OFFICE AIDS PRIVATE LIMITED",
"PERFECT PACKERS & COURIERS (MUMBAI) PRIVATE LIMITED",
"PERFECT PAPER CONE AND TUBE PRIVATE LIMITED",
"PERFECT PEN PRIVATE LIMITED",
"PERFECT PIPING COMPONENTS PRIVATE LIMITED",
"PERFECT PLANTEX INDUSTRIES LIMITED",
"PERFECT PLASTIC PRODUCTS PRIVATE LIMITED",
"PERFECT PLY INDUSTRIES PRIVATE. LIMITED.",
"PERFECT POLYCHEM PRIVATE LIMITED",
"PERFECT POLYTECH PRIVATE LIMITED",
"PERFECT POTTERY COMPANY (MADHYA BHARAT) LIMITED",
"PERFECT POULTRY PRODUCTS PRIVATE LIMITED",
"PERFECT POWER TRANSMISSION PRIVATE LIMITED",
"PERFECT PRODUCTS PRIVATE LIMITED",
"PERFECT PROPBUILD PRIVATE LIMITED",
"PERFECT PROPERTY MANAGMENT PRIVATE LIMITED",
"PERFECT PROTECTION (INDIA) PRIVATE LIMITED",
"PERFECT PROTECTION FORCE PRIVATE LIMITED",
"PERFECT PUMP INDUSTRIES PRIVATE LIMITED",
"PERFECT RAYS TECHNOLOGIES PRIVATE LIMITED",
"PERFECT RECOVERY CONSULTANCY PRIVATE LIMITED",
"PERFECT RELATIONS PRIVATE LIMITED",
"PERFECT RESCUE FORCE PRIVATE LIMITED",
"PERFECT RETREADS PRIVATE LIMITED",
"PERFECT RFID TECHNOLOGIES PRIVATE LIMITED",
"PERFECT ROLLS INDIA PRIVATE LIMITED",
"PERFECT S P PRIVATE LIMITED",
"PERFECT SALES ELECTRONICS PRIVATE LIMITED",
"PERFECT SANITARY DISTRIBUTORS PVT LTD",
"PERFECT SANITARY WARES LTD",
"PERFECT SCOT SOLUTIONS PRIVATE LIMITED",
"PERFECT SEALING SYSTEMS PVT LTD",
"PERFECT SECURITIES AND PLACEMENTS PRIVATE LIMITED",
"PERFECT SOFTWARE SOLUTIONS CLT PRIVATE LIMITED",
"PERFECT SPECIALITY CHEMICALS PRIVATE LIMITED",
"PERFECT STAMPING PRIVATE LIMITED",
"PERFECT STAYZ PRIVATE LIMITED",
"PERFECT STONEWARE PIPES LTD",
"PERFECT STRIPS LIMITED",
"PERFECT SURGICARE INDUSTRIES PRIVATE LIMITED",
"PERFECT SYNERGY ADVISORY SERVICES PRIVATE LIMITED",
"PERFECT SYNTHETIC PRIVATE LIMITED",
"PERFECT TECHNOBUILD PRIVATE LIMITED",
"PERFECT TECHNOCONSULTANTS PRIVATE LIMITED",
"PERFECT THREAD MILLS LIMITED.",
"PERFECT TRADELINK PRIVATE LIMITED",
"PERFECT TRAVELS AND TOURS PRIVATE LIMITED",
"PERFECT TUBE CENTRE PVT. LTD.",
"PERFECT TYRES PVT LTD",
"PERFECT VALVES PRIVATE LIMITED",
"PERFECT VISION CLINIC PRIVATE LIMITED",
"PERFECT WASHERS & FASTENERS PVT LTD",
"PERFECT WEBTECH PRIVATE LIMITED",
"PERFECT WHEELS PRIVATE LIMITED",
"PERFECT WIRE INDUSTRIES¬†",
"PERFECT WRITING INSTRUMENTS PRIVATE LIMITED",
"PERFECT12 TECHNOLOGIES SOLUTIONS PRIVATE LIMITED",
"PERFECTION",
"PERFECTION CREATIONS PRIVATE LIMITED",
"PERFECTION IMPORT EXPORT PRIVATE LIMITED",
"PERFECTION INFOWEB PRIVATE LIMITED",
"PERFECTION OFFICE EQUIPMENTS PRIVATE LIMITED",
"PERFECTISHARA AGRO PRIVATE LIMITED",
"PERFECTO TAPES LIMITED",
"PERFECTO TEXTIL CHEMICALS PRIVATE LIMITED",
"PERFECT-OCTAVE MEDIA PROJECTS LIMITED",
"PERFECT-OCTAVE PRIVATE LIMITED",
"PERFETTI VAN MELLE INDIA .PRIVATE.LIMITED",
"PERFETTI VAN MELLE INDIA PRIVATE LIMITED",
"PERFETTO AGGREGATES PRIVATE LIMITED",
"PERFETTO NATURALS PRIVATE LIMITED",
"PERFEXN CHEM SCIENCE MFD PRIVATE LIMITED",
"PERFEXTION SOLUTIONS PRIVATE LIMITED",
"PERFEZ SPACES PRIVATE LIMITED",
"PERFICIENT INDIA PRIVATE LIMITED",
"PERFINT HEALTHCARE PRIVATE LIMITED",
"PERFIOS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"PERFORCE INDIA PRIVATE LIMITED",
"PERFORCE SOFTWARE PRIVATE LIMITED",
"PERFORM INNOVATIVE SPACES PRIVATE LIMITED",
"PERFORM MEDIA INDIA PRIVATE LIMITED",
"PERFORM PROJECTS MANAGEMENT PRIVATE LIMITED",
"PERFORMANCE AUDIO INDIA PRIVATE LIMITED",
"PERFORMANCE CARS PRIVATE LIMITED",
"PERFORMANCE CHEMISERVE LIMITED",
"PERFORMANCE LAUNCHPAD PRIVATE LIMITED",
"PERFORMANCE SPECIALTY PRODUCTS (INDIA) PRIVATE LIMITED",
"PERFORMERS SHIPPING PRIVATE LIMITED",
"PERFORMICS",
"PERFRUOR ENTERPRISES PRIVATE LIMITED",
"PERFSYSTEMS INDIA PRIVATE LIMITED",
"PERFTECH SOLUTIONS PRIVATE LIMITED",
"PERFUMATICS CHEMICALS EXPORTS PRIVATE LIMITED",
"PERFUMERS(INDIA) PRIVATE LIMITED",
"PERFUNOVA INTERNATIONAL LIMITED",
"PERG ELECTRO MECHANICAL PRIVATE LIMITED",
"PERGO INDIA PRIVATE LIMITED",
"PERHAPS FOOD PRIVATE LIMITED",
"PERI EDUCATION",
"PERI INDIA PRIVATE LIMITED",
"PERI INFRASTRUCTURE PRIVATE LIMITED",
"PERI INSTITUTE OF TECHNOLOGY",
"PERI SOFTWARE SOLUTIONS PRIVATE LIMITED",
"PERI WERK (INDIA) PRIVATE LIMITED",
"PERIA PEAK ESTATES PVT LTD",
"PERIDOT KNITWEARS PVT LTD",
"PERIDOT POWER VENTURES LIMITED",
"PERIDOT PROPERTIES PRIVATE LIMITED",
"PERIGEE INFRATECH PRIVATE LIMITED",
"PERIGORD DATA SOLUTIONS INDIA PRIVATE LIMITED",
"PERIGORD PREMEDIA (INDIA) PRIVATE LIMITED",
"PERIGORD PREMEDIA INDIA PRIVATE LIMITED",
"PERIMDEVI FARM PRODUCTS PRIVATE LIMITED",
"PERIMETER ECOMMERCE PRIVATE LIMITED",
"PERINT INFOSYSTEMS INDIA PRIVATE LIMITED",
"PERINYX NEEP PRIVATE LIMITED",
"PERIPHERAL ENGINEERS PRIVATE LIMITED",
"PERIPHERAL STEEL & WOOD INDIA PRIVATE LIMITED",
"PERIPLEKO RETAIL PRIVATE LIMITED",
"PERISCOPE PRINTING AND PACKAGINS INDIA PRIVATE LIMITED",
"PERISSON CONSULTING PRIVATE LIMITED",
"PERITO ANALYTICAL INDIA PRIVATE LIMITED",
"PERITO STAFFING SERVICES LLP",
"PERITUS AI PRIVATE LIMITED",
"PERITUS CONTROL EQUIPMENTS PRIVATE LIMITED",
"PERITUS CORPORATION PRIVATE LIMITED",
"PERITUS EXIM PRIVATE LIMITED",
"PERIURJA ENERGY PRIVATE LIMITED",
"PERIWAL HOSIERY PRIVATE LIMITED",
"PERIWAL POLYMERS PRIVATE LIMITED",
"PERIWINKLE CONSTRUCTIONS PRIVATE LIMITED",
"PERIWINKLE FASHIONS PRIVATE LIMITED",
"PERIWINKLE TECHNOLOGIES PRIVATE LIMITED",
"PERIYAR ARTS AND SCIENCE COLL",
"PERIYAR CENTENARY POLYTECHNIC COLLEGE",
"PERIYAR COLLEGE OF PHARMACEUTICAL SCIENC",
"PERIYAR E V R COLLEGE",
"PERIYAR MANIAMMAI INSTITUTE OF SCIENCE & TECHNOLOGY",
"PERIYAR POLYMERS PRIVATE LIMITED",
"PERIYAR STEEL PVT LTD",
"PERIYAR UNIVERSITY",
"PERIZIA SERVICES INDIA PRIVATE LIMITED",
"PERK MERCANTILE PRIVATE LIMITED",
"PERKAN FOOD PROCESSORS PRIVATE LIMITED",
"PERKINS EASTMAN DESIGN CONSULTANTS INDIA PRIVATE LIMITED",
"PERKINS INDIA PRIVATE LIMITED",
"PERKS LINKS AND SERVICES PRIVATE LIMITED",
"PERLA HYDRO POWER PRIVATE LIMITED",
"PERLEI TEXTILES PRIVATE LIMITED",
"PERMA CONSTRUCTION AIDS PRIVATE LIMITED",
"PERMA HEALTHCARE PRIVATE LIMITED",
"PERMA PAPERS PRIVATE LIMITED",
"PERMAG PRODUCTS PRIVATE LIMITED",
"PERMALI WALLACE PRIVATE LIMITED",
"PERMALIFE RESEARCH AND MARKETING PRIVATE LIMITED",
"PERMALON TRANSMISSIONS PRIVATE LIMITED",
"PERMAN AUTO CONCEPTS PRIVATE LIMITED",
"PERMANENT AGROTECH PRIVATE LIMITED",
"PERMANENT FINCON PRIVATE LIMITED",
"PERMANENT MAGNETS LIMITED",
"PERMA-PIPE INDIA PRIVATE LIMITED",
"PERMASEAL AUTO PRODUCTS PRIVATE LIMITED",
"PERMASTEELISA INDIA PRIVATE LIMITED",
"PERMAWELD PRIVATE LIMITED",
"PERMESHWAR CREATIONS PRIVATE. LIMITED",
"PERMESHWAR FASHIONS IMPEX PRIVATE LIMITED",
"PERMIAN PEAK OIL PRIVATE LIMITED",
"PERMIONICS INDIA LIMITED",
"PERMIONICS MEMBRANES PRIVATE. LIMITED",
"PERMTECH RESEARCH SOLUTIONS (OPC) PRIVATE LIMITED",
"PERNIA QURESHI CONSULTANCY PRIVATE LIMITED",
"PERNIMIUS FINANCIAL TECHNOLOGIES PRIVATE LIMITED",
"PERNOD RICARD INDIA FOUNDATION",
"PERNOD RICARD INDIA PRIVATE LIMITED",
"PERODY BUILDERS PRIVATE LIMITED",
"PERPENDICULAR MAINTENANCE SERVICES PRIVATE LIMITED",
"PERPETUAL FINVEST-LEASE PRIVATE LIMITED",
"PERPETUAL INFRACON PRIVATE LIMITED",
"PERPETUAL POWER SERVICES PRIVATE LIMITED",
"PERPETUALBLOCK TECHNOLOGIES PRIVATE LIMITED",
"PERPETUUITI TECHNOSOFT SERVICES PRIVATE LIMITED",
"PERPLEX AGENT PRIVATE LIMITED",
"PERQ ADVERTISINGS PRIVATE LIMITED",
"PERRIGO LABORATORIES INDIA PRIVATE LIMITED",
"PERRIN VALVES PRIVATE LIMITED",
"PERRON CONSTRUCTION PRIVATE LIMITED",
"PERRY IMPEX LIMITED",
"PERRY JOHNSON ASSOCIATES PRIVATE LIMITED",
"PERRY JOHNSON CERTIFICATION PRIVATE LIMITED",
"PERRY TRADING PRIVATE LIMITED",
"PERRYS BISCUITS PRIVATE LIMITED",
"PERS ENTERPRISES PRIVATE LIMITED",
"PERSANG ALLOY INDUSTRIES PRIVATE LIMITED",
"PERSANG ENTERTAINMENT PRIVATE LIMITED",
"PERSCITUS SOLUTIONS PRIVATE LIMITED",
"PERSEUS FINANCE PRIVATE LIMITED",
"PERSEUS TECH PRIVATE LIMITED",
"PERSEVERANCE IT SOLUTIONS PRIVATE LIMITED",
"PERSHAD INFOTECH PRIVATE LIMITED",
"PERSHAD MARKETING PRIVATE LIMITED",
"PERSHING INDIA OPERATIONAL SERVICES PRIVATE LIMITED",
"PERSIA DARBAR PRIVATE LIMITED",
"PERSIGHT SOLUTIONS PRIVATE LIMITED",
"PERSIL EMBROIDERIES PRIVATE LIMITED",
"PERSIPINA DEVELOPERS PRIVATE LIMITED",
"PERSISTENCE MARKET RESEARCH PRIVATE LIMITED",
"PERSISTENCE OFFSHORE SOLUTIONS PRIVATE LIMITED",
"PERSISTENT ALUMINIUM PRIVATE LIMITED",
"PERSISTENT BUSINESS SERVICES PRIVATE LIMITED",
"PERSISTENT HI-TECH CASTING PRIVATE LIMITED",
"PERSISTENT NETWORKS PRIVATE LIMITED",
"PERSISTENT SYSTEMS LIMITED",
"PERSISTENTB2B PRIVATE LIMITED",
"PERSISTENTCLIMATE INDIA PRIVATE LIMITED",
"PERSOLKELLY INDIA PRIVATE LIMITED",
"PERSONAGE SECURITY SERVICES PRIVATE LIMITED",
"PERSONAL BRUSHES PRIVATE LIMITED",
"PERSONAL TOUCH SERVICES INDIA PRIVATE LIMITED",
"PERSONALISED HOLIDAYS INDIA PRIVATE LIMITED",
"PERSONALITY CARE APPARELS PRIVATE LIMITED",
"PERSONALIZED MEDICINE INSTITUTE PRIVATE LIMITED",
"PERSONATECH INDIA PRIVATE LIMITED",
"PERSONI COSMETICS PRIVATE LIMITED",
"PERSONIGO INDIA PRIVATE LIMITED",
"PERSONIV CONTACT CENTERS INDIA PRIVATE LIMITED",
"PERSONNEL SEARCH SERVICES PRIVATE LIMITED",
"PERSONNEL STAFFING SOLUTIONS PRIVATE LIMITED",
"PERSTORP CHEMICALS INDIA PRIVATE LIMITED",
"PERSUADERS BUSINESS SOLUTIONS PRIVATE LIMITED",
"PERSYST SYSTEMS PRIVATE LIMITED",
"PERT INFOCONSULTING PRIVATE LIMITED",
"PERT TELECOM SOLUTIONS PRIVATE LIMITED",
"PERTANIAN FARMING PRIVATE LIMITED",
"PERTH CERAMIC PRIVATE LIMITED",
"PERTH VERIFICATION AND CREDIT MANAGMENT PRIVATE LIMITED",
"PERTINENT INFRA & ENERGY LIMITED",
"PERTO INDIA PRIVATE LIMITED",
"PERULIMA MOTORS PRIVATE LIMITED",
"PERUMAL SPINNING MILLS PRIVATE LIMITED",
"PERUMBAVOOR HOTELS AND RESORTS PRIVATE LIMITED",
"PERUMBAVOOR PLYWOOD MANUFACTURERS CONSORTIUM PRIVATE LIMITED",
"PERUNDURAI COMMON EFFLUENT TREATMENT PLANT",
"PERUNGUDI REAL ESTATES PRIVATE LIMITED",
"PERYDOT SYSTEMS & SERVICES PRIVATE LIMITED",
"P E S COLLEGE OF ENGINEERING",
"PES ELECTRICAL PRIVATE LIMITED",
"PES ENGINEERS PRIVATE LIMITED",
"PES GROUP OF INSTITUTIONS",
"PES INSTALLATIONS PRIVATE. LIMITED.",
"PES PROJECTS PRIVATE LIMITED",
"PES SPRAY TECH PRIVATE LIMITED",
"PES UNIVERSITY",
"PESANTE ENGINEERINGS PRIVATE LIMITED",
"PESCA MARINE PRODUCTS PVT LTD",
"PESCAVI FOODS (INDIA) PRIVATE LIMITED",
"PESHAVARIA EXPORTS PRIVATE LIMITED",
"PESHAWARI SUPERMARKETS PRIVATE LIMITED",
"PESINO PHARMACEUTICALS PRIVATE LIMITED",
"PESMEL PACKAGING INDIA PRIVATE LIMITED",
"PESS PROTECTION FORCE PRIVATE LIMITED",
"PEST CONTROL AND ERADICATION SERVICES PRIVATE LIMITED",
"PEST CONTROL ASSOCIATES AMB PRIVATE LIMITED",
"PEST CONTROL MANAGEMENT PRIVATE LIMITED",
"PEST CONTROL SHIRLAL PRIVATE LIMITED",
"PEST KARE INDIA PRIVATE LIMITED",
"PEST MASTERS INDIA PRIVATE LIMTIED",
"PEST MORTEM (INDIA) PRIVATE LIMITED",
"PEST RELIEF (INDIA) PRIVATE LIMITED",
"PEST SHIELDS INDIA PRIVATE LIMITED",
"PESTCARE INDIA PRIVATE LIMITED",
"PESTGOGO PRODUCTS AND SERVICES PRIVATE LIMITED",
"PESTICA LABOUR SERVICES PRIVATE LIMITED",
"PESTLE WEED COLLEGE",
"PESTO INDIA SERVICES PRIVATE LIMITED",
"PESTO TECH INDIA PRIVATE LIMITED",
"PESTOKEM INDUSTRIES PRIVATE LIMITED",
"PESTONICS PEST MANAGEMENT PRIVATE LIMITED",
"PESTRO MANAGEMENT PRIVATE LIMITED",
"PET CT ST DIAGNOSTIC PRIVATE LIMITED",
"PET FIBRES PRIVATE LIMITED",
"PET MOULDS PRIVATE LIMITED",
"PET PLASTICS LIMITED",
"PET PROPERTIES AND CONSTRUCTIONS PRIVATE LIMITED",
"PET TOOLS PRIVATE LIMITED",
"PETAINER INNOPAC PACKAGING PRIVATE LIMITED",
"PETAL COMMERCIAL PRIVATE LIMITED",
"PETAL ENVIRO-TECH ENGINEERS PRIVATE LIMITED",
"PETAL MANAGEMENT SERVICES PRIVATE LIMITED",
"PETAL MOTOCON PRIVATE LIMITED",
"PETALS EMBROIDERY PRIVATE LIMITED",
"PETALS ENGINEERS PRIVATE LIMITED",
"PETALS ENLIGHTENMENT INSTITUTES PRIVATE LIMITED",
"PETALS NEWBORN & CHILDREN HOSPITAL",
"PETASENSE TECHNOLOGIES PRIVATE LIMITED",
"PETBRITE VENTURES",
"PETCHEM PRODUCTS PRIVATE LIMITED",
"PETCO STEEL PRIVATE LIMITED",
"PETDOS ONLINE PRIVATE LIMITED",
"PETER AUTOKITS PRIVATE LIMITED",
"PETER ELECTRICALS PRIVATE LIMITED",
"PETER LACKE INDIA PRIVATE LIMITED",
"PETER S FOODS PRIVATE LIMITED",
"PETER WOLTERS PRECISION SOLUTIONS INDIA PRIVATE LIMITED",
"PETERS SURGICAL INDIA PRIVATE LIMITED",
"PETERS WORLDWIDE PRIVATE LIMITED",
"PETERSON TECHNOLOGY PARTNERS (INDIA) PRIVATE LIMITED",
"PETFORM TECHNOLOGIES PRIVATE LIMITED",
"PETFULLY YOURS PRIVATE LIMITED",
"PETGULLY SERVICES PRIVATE LIMITED",
"PETHE BRAKE MOTORS PRIVATE LIMITED",
"PETHE ENGINEERING PRIVATE LIMITED",
"PETHE FOODS PRIVATE LIMITED",
"PETHE INDUSTRIAL MARKETING COMPANY PRIVATE LIMITED",
"PETIT SEMINAIRE HIGHER SECONDARY SCHOOL",
"PETKUS INDIA PRIVATE LIMITED",
"PETLAWAD TRIBAL FARMER PRODUCER COMPANY LIMITED",
"PETNET RADIOPHARMACEUTICAL SOLUTIONS PRIVATE LIMITED",
"PETONIC INFOTECH PRIVATE LIMITED",
"PETRA ASSET AND FACILITY MANAGEMENT PRIVATE LIMITED",
"PETRA CREATIONS PRIVATE LIMITED",
"PETRA ENTERPRISES PRIVATE LIMITED",
"PETRA GLOBAL LOGISTICS PRIVATE LIMITED",
"PETRA SAFETY AND SECURITY SOLUTIONS PRIVATE LIMITED",
"PETRAFOS ENERGY PRIVATE LIMITED",
"PETRALENE PRODUCTS PRIVATE LIMITED",
"PETRAS SOLUTIONS PRIVATE LIMITED",
"PETRO ARALDITE PRIVATE LIMITED",
"PETRO CARBON AND CHEMICALS LIMITED",
"PETRO I T LIMITED",
"PETRO IT SOLUTIONS PRIVATE LIMITED",
"PETRO VALVES PRIVATE LIMITED",
"PETRO6 ENGINEERING & CONSTRUCTION PRIVATE LIMITED",
"PETROCHEM ASIA PRIVATE LIMITED",
"PETROCHEM EPC INFRA PRIVATE LIMITED",
"PETROCHEM MIDDLE EAST ( INDIA) PRIVATE LIMITED",
"PETROCHINA INTERNATIONAL (INDIA) PRIVATE LIMITED",
"PETROCIL ENGINEERING CONSULTANCY PRIVATE LIMITED",
"PETROCIL ENGINEERS & CONSULTANTS PRIVATE LIMITED",
"PETROCON ENGG. & INSPECTION PRIVATE LIMITED",
"PETROFAB ENGINEERING (OPC) PRIVATE LIMITED",
"PETROFAC ENGINEERING INDIA PRIVATE LIMITED",
"PETROFAC ENGINEERING SERVICES INDIA PRIVATE LIMITED",
"PETROFAC INFORMATION SERVICES PRIVATE LIMITED",
"PETROFAC INTERNATIONAL UAE LLC",
"PETROFAC INTLUAE LLC-INDIA PROJECT OFFICES",
"PETROGAS ENERGY INDIA LIMITED",
"PETROGATE MARKETING PRIVATE LIMITED",
"PETROGEL (INDIA) PRIVATE LIMITED",
"PETROGRATE METAL PRODUCTS PRIVATE LIMITED",
"PETROLE SERVICE INDIA PRIVATE LIMITED",
"PETROLEUM AND MINERALS LIMITED",
"PETROLEUM&EXPLOSIVES SAFETY ORGANIZATION PESO",
"PETROLEUMBAZAAR COM (INDIA) PRIVATE LIMITED",
"PETROLINE INDIA PRIVATE LIMITED",
"PETROMAR ENGINEERED SOLUTIONS PRIVATE LIMITED",
"PETROMAT OIL & GAS EQUIPMENTS PRIVATE LIMITED",
"PETROMECH ENGINEERS PRIVATE LIMITED",
"PETRONAS LUBRICANTS INDIA PRIVATE LIMITED",
"PETRONASH ENGINEERING SERVICES PRIVATE LIMITED",
"PETRONAX FOREX AND TRAVEL SERVICES PRIVATE LIMITED",
"PETRONEFT NON-ENTRY ENGINEERING SOLUTIONS PRIVATE LIMITED",
"PETRONEL INFRA PROJECTS PRIVATE LIMITED",
"PETRONET CCK LIMITED",
"PETRONET LNG FOUNDATION",
"PETRONET LNG LIMITED",
"PETRONET MHB LIMITED",
"PETRONET VK LIMITED",
"PETRONEX INDIA PRIVATE LIMITED",
"PETROPATH FLUIDS INDIA PRIVATE LIMITED",
"PETROPOL INDIA LIMITED",
"PETRORUB POLYMERS PRIVATE LIMITED",
"PETROS ELECTRONICS PRIVATE LIMITED",
"PETROSIL INVESTMENTS AND OIL COMPANY LIMITED",
"PETROTECH PRODUCTS INDIA PRIVATE LIMITED",
"PETROTECH VESSELS PRIVATE LIMITED",
"PETROTEC-RETAIL PETROLEUM EQUIPMENT (INDIA) PVT LTD",
"PETROWATCH INFORMATION (INDIA) PRIVATE LIMITED",
"PETROWAYS INDIA PRIVATE LIMITED",
"PETROX PACKAGING (INDIA) PRIVATE LIMITED",
"PETROZOL INDUSTRIES PRIVATE LIMITED",
"PETRYC INTERNATIONAL PRIVATE LIMITED",
"PETSGLAM SERVICES PRIVATE LIMITED",
"PETSMART INC.",
"PETSY STORES PRIVATE LIMITED",
"PETTERSSONS INDIA PRIVATE LIMITED",
"PETTITT'S INDIA TOURS PRIVATE LIMITED",
"PETUNT FOOD PROCESSORS PRIVATE LIMITED",
"PEW ENGINEERING PRIVATE LIMITED",
"PEWAG INDIA PRIVATE LIMITED",
"PEWISE TECH PRIVATE LIMITED",
"PEXI CHEM PRIVATE LIMITED",
"PEYOTE MORGAN CONSULTANCY PRIVATE LIMITED",
"PEZALLI CREATIONS PRIVATE LIMITED",
"PF DIGITAL MEDIA SERVICES LIMITED",
"PFC CONSULTING LIMITED",
"PFC PHARMA FOCUS INDIA PRIVATE LIMITED",
"PFC PROJECTS LIMITED",
"PFEDA SYNTHETICS PRIVATE LIMITED",
"PFEIFFER VACUUM (INDIA) PRIVATE LIMITED",
"PFH MALL & RETAIL MANAGEMENT PRIVATE LIMITED",
"PFICUS DE MED PRIVATE LIMITED",
"PFIFFNER INSTRUMENT TRANSFORMERS PRIVATE LIMITED",
"PFIL SECURITIES LIMITED",
"PFIXS VENTURES PRIVATE LIMITED",
"PFIZER HEALTHCARE INDIA PRIVATE LIMITED",
"PFIZER LIMITED",
"PFIZER PRODUCTS INDIA PRIVATE LIMITED",
"PFL FOOD PRIVATE LIMITED",
"PFL VENTURE PRIVATE LIMITED",
"PFSI SOLUTIONS PRIVATE LIMITED",
"PG ASSOCIATES PRIVATE LIMITED",
"PG CERACOATS PRIVATE LIMITED",
"PG ELECTROPLAST LIMITED",
"PG HOTELS AND RESORTS PRIVATE LIMITED",
"PG INDIA LOGISTICS PRIVATE LIMITED",
"PG INFRACON PRIVATE LIMITED",
"PG POLYCHEM PRIVATE LIMITED",
"PG TECH PRIVATE LIMITED",
"PGAM ANALYTICS PRIVATE LIMITED",
"PGB RETAIL PRIVATE LIMITED",
"PGC INFOTECH INDIA PRIVATE LIMITED",
"PGC LOGISTIC PRIVATE.LIMITED",
"PGD LAND LLP",
"PGDAV COLLEGE",
"PGE INDUSTRIES PRIVATE LIMITED",
"PGES ENGINEERING SERVICES PRIVATE LIMITED",
"PGH HOSPITALS PRIVATE LIMITED",
"PGI DISTRIBUTORS PRIVATE LIMITED",
"PGI TECHNOLOGIES PRIVATE LIMITED",
"PGL FURNITURES PRIVATE LIMITED",
"PGL PROJEKTS LIMITED",
"PGL RAMJI MOTORS PRIVATE LIMITED",
"PGL TUBE PRIVATE LIMITED",
"PGM ELECTRO PRIVATE LIMITED",
"PGM FERRO STEELS PRIVATE LIMITED",
"PGP GLASS PRIVATE LIMITED",
"PGR JUNIOR COLLEGE",
"PGR SYSTEMS & TECHNOLOGIES PRIVATE LIMITED",
"PGR TRANS LOGISTICS PRIVATE LIMITED",
"PGRP WORLDWIDE PRIVATE LIMITED",
"PGRR HOSPITAL 24 POLY CLINIC",
"PGS ECOM EXPRESS PRIVATE LIMITED",
"PGS EXIMS PRIVATE LIMITED",
"PGS FOOTWEARS PRIVATE LIMITED",
"PGS GLOBAL FORWARDING (INDIA) PRIVATE LIMITED",
"PGS INFRACON PRIVATE LIMITED",
"PGS INN PRIVATE LIMITED",
"PGS PARTNER INDIA PRIVATE LIMITED",
"PGS POLYPLAST PRIVATE LIMITED",
"PGS PREMIERE CONFERENCING PRIVATE LIMITED",
"PGS STEELS PRIVATE LIMITED",
"PGS TECHNO GREEN SOLUTIONS PRIVATE LIMITED",
"PH & FW DEPARTMENT OFFICE OF BMO LUNDRA DIST SURGUJA",
"PH & FW DEPATT GOVT OF CHHATTISGARH",
"PH ASSOCIATES PRIVATE LIMITED",
"PH INFRATECH PRIVATE LIMITED",
"PH SUPER FOODS PRIVATE LIMITED",
"PH VALUE SHIPPING PRIVATE LIMITED",
"PH&FW DEPARTMENT OFFICE OF BMO BATOULI DIST SURGUJA C G",
"PH1 INDUSTRIES PRIVATE LIMITED",
"PH4 FOOD & BEVERAGES PRIVATE LIMITED",
"PH91 PRIVATE LIMITED",
"PHA INDIA P LIMITED",
"PHAARMAA ONE (INDIA) PRIVATE LIMITED",
"PHADNIS CLINIC PVT LTD",
"PHADNIS TELECOM LIMITED",
"PHADTARE FABTECH PRIVATE LIMITED",
"PHAEDRUS LIFE SCIENCE PRIVATE LIMITED",
"PHAEROS IT INDIA PRIVATE LIMITED",
"PHAEX POLYMERS PRIVATE LIMITED",
"PHAGI HOSPITAL PRIVATE LIMITED",
"PHAGU RESORTS PRIVATE LIMITED",
"PHAGWARA SUPER SCANNING PRIVATE LIMITED",
"PHALADA AGRO RESEARCH FOUNDATIONS PRIVATE LIMITED",
"PHALADA ORGANIC CONSUMER PRODUCTS PRIVATE LIMITED",
"PHALANX CATALYTIC SOLUTIONS PRIVATE LIMITED",
"PHALANX LABS PRIVATE LIMITED",
"PHALAPRADA PETRO PRODUCTS PRIVATE LIMITED",
"PHALGUNI HEALTHCARE PRIVATE LIMITED",
"PHALNA SHIPPING AGENCIES PRIVATE LIMITED",
"PHALOD SILK MILLS PRIVATE LIMITED",
"PHALOUDI CONSTRUCTIONS AND INFRASTRUCTURE PRIVATE LIMITED",
"PHAMAX ANALYTIC RESOURCES PRIVATE LIMITED",
"PHAMISHED FOODS PRIVATE LIMITED",
"PHANES EDUCATIONS PRIVATE LIMITED VIBGYOR GROUP ENTITY",
"PHANICARE PHARMACEUTICALS PRIVATE LIMITED",
"PHANS TECHNOMOBILITY PRIVATE LIMITED",
"PHANSIDEWA HIGH SCHOOL",
"PHANTOM DIGITAL EFFECTS LIMITED",
"PHANTOM EXPRESS PRIVATE LIMITED",
"PHANTOM HANDS VINTAGE COLLECTIBLES LLP",
"PHANTOM HEALTHCARE IND PRIVATE LIMITED",
"PHANTOM IDEAS PRIVATE LIMITED",
"PHANTOM MARKETING PRIVATE LIMITED",
"PHANTOM STUDIOS INDIA PRIVATE LIMITED",
"PHANTOM TOURS AND TRAVELS PRIVATE LIMITED",
"PHARANDE PROMOTERS & BUILDERS",
"PHARANDE TOWNSHIP PRIVATE LIMITED",
"PHARCHEM PRIVATE LIMITED",
"PHARIND PHARMACEUTICALS PRIVATE LIMITED",
"PHARLINK LABS PRIVATE LIMITED",
"ALLUCENT (INDIA) PRIVATE LIMITED",
"PHARM PRODUCTS PRIVATE LIMITED",
"PHARMA ACCESS PRIVATE LIMITED",
"PHARMA BASE INDIA PRIVATE LIMITED",
"PHARMA CHEM INDUSTRIES (GUJARAT) PRIVATE LIMITED",
"PHARMA CHEMICALS PRIVATE LIMITED",
"PHARMA DISTRIBUTION (INDIA) PRIVATE LIMITED",
"PHARMA IMPEX LABORATORIES PVT LTD",
"PHARMA SEARCH AYURVEDA PRIVATE LIMITED",
"PHARMA SPARES PRIVATE LIMITED",
"PHARMA SYNTH FORMULATIONS LIMITED",
"PHARMA TARGETING RESEARCH PRIVATE LIMITED",
"PHARMA TREK PRIVATE LIMITED",
"PHARMAACE ANALYTICS PRIVATE LIMITED",
"PHARMACARE LOGISTICS PRIVATE LIMITED",
"PHARMACEUTICAL BUSINESS GROUP(INDIA) LIMITED",
"PHARMACEUTICAL INSTITUTE OF INDIA PRIVATE LIMITED",
"PHARMACEUTICAL RESEARCH ASSOCIATES INDIA PRIVATE LIMITED",
"PHARMACEUTICALS EXPORT PROMOTION COUNCIL OF INDIA",
"PHARMACHECK CONSULTING SERVICES PRIVATE LIMITED",
"PHARMACHECK IMPEX PRIVATE LIMITED",
"PHARMACHEM BIOTECH (I) PRIVATE LIMITED",
"PHARMACHEM TRADERS PRIVATE LIMITED",
"PHARMACON VET PRIVATE LIMITED",
"PHARMACOPIUS DRUGS PRIVATE LIMITED",
"PHARMACREST COMPANY PRIVATE LIMITED",
"PHARMADEEP TURNKEY CONSULTANTS AND ENGINEERS PRIVATE LIMITED",
"PHARMADENT REMEDIES PRIVATE LIMITED",
"PHARMADESK SOLUTIONS PRIVATE LIMITED",
"PHARMADULE ENGINEERING INDIA PRIVATE LIMITED",
"PHARMAFFILIATES ANALYTICS AND SYNTHETICS PRIVATE LIMITED",
"PHARMAFLOW LIFESCIENCES PRIVATE LIMITED",
"PHARMAFORCE EXCIPIENTS PRIVATE LIMITED",
"PHARMAFORCE INFOSOFT PRIVATE LIMITED",
"PHARMAFORCE REPORTS PRIVATE LIMITED",
"PHARMAFORTE PRIVATE LIMITED",
"PHARMAGENICA HEALTHCARE PRIVATE LIMITED",
"PHARMAGROWTH SOLUTIONS PRIVATE LIMITED",
"PHARMAK MARETING CO",
"PHARMAKON HEALTH AND BEAUTY CARE PRIVATE LIMITED",
"PHARMAKRAFT PACKAGING PRIVATE LIMITED",
"PHARMALAB FINANCIAL SERVICES PRIVATE LIMITED",
"PHARMALAB INDIA PRIVATE LIMITED",
"PHARMALEAF (INDIA) PRIVATE LIMITED",
"PHARMALEX INDIA PRIVATE LIMITED",
"PHARMAMEDITECH SCIENTIFIC EQUIPMENT PRIVATE LIMITED",
"PHARMANET MEDICAL SERVICES PRIVATE LIMITED",
"PHARMANOVA EXPORTS PRIVATE LIMITED",
"PHARMANOVA INDIA DRUGS PRIVATE LIMITED",
"PHARMANZA (INDIA) PRIVATE LIMITED",
"PHARMANZA HERBAL PRIVATE LIMITED",
"PHARMAPACK TECHNOLOGIES INDIA PRIVATE LIMITED",
"PHARMAPOINT (INDIA) PRIVATE LIMITED",
"PHARMAQUANT INSIGHTS PRIVATE LIMITED",
"PHARMASECURE PAS INDIA PRIVATE LIMITED",
"PHARMA-SERV HEALTHCARE PRIVATE LIMITED",
"PHARMASOFTTECH AWACS PRIVATE LIMITED",
"PHARMASPECTRA INFORMATICS PRIVATE LIMITED",
"PHARMASQUIRE MEDIA & PUBLISHING PRIVATE LIMITED",
"PHARMASTRA LIFECARE PRIVATE LIMITED",
"PHARMASTREET PRIVATE LIMITED",
"PHARMASYS PRIVATE LIMITED",
"PHARMATECH EQUIPMENTS PRIVATE LIMITED",
"PHARMATECH PROCESS EQUIPMENTS",
"PHARMATEK FILTRATION SYSTEMS PRIVATE LIMITED",
"PHARMA-TONE PRIVATE LIMITED",
"PHARMAVEDA INDIA PRIVATE LIMITED",
"PHARMAX CORPORATION LTD",
"PHARMAZELL INDIA PRIVATE LIMITED",
"PHARMAZELL VIZAG PRIVATE LIMITED",
"PHARMAZONE LAB LIMITED",
"PHARMAZZ INDIA PRIVATE LIMITED",
"PHARMED LIMITED",
"PHARMED MEDICARE PRIVATE LIMITED",
"PHARMEDA HEALTHCARE PRIVATE LIMITED",
"PHARMERIT INDIA PRIVATE LIMITED",
"PHARMEX HEALTHCARE",
"PHARMINEXX INDIA",
"PHARMINTECH TURNKEY SOLUTIONS PRIVATE LIMITED",
"PHARMISON VALENTES PHARMA PRIVATE LIMITED",
"PHARMONIX BIOLOGICALS PRIVATE LIMITED",
"PHARMOTIPS HEALTHCARE PRIVATE LIMITED",
"PHARMSIGHT RESEARCH & ANALYTICS PRIVATE LIMITED",
"PHARMSOL INDIA PRIVATE LIMITED",
"PHARMTAK OPTHALMICS I PRIVATE LIMITED",
"PHAROAHS ENTERPRISES LIMITED",
"PHAROSE REMEDIES LIMITED",
"PHAROX GLOBAL PRIVATE LIMITED",
"PHARVINEX HEALTHCARE PRIVATE LIMITED",
"PHASE 1 EVENTS AND ENTERTAINMENT PRIVATE LIMITED",
"PHASE D INDIA PRIVATE LIMITED",
"PHASE POWER AND AUTOMATION PRIVATE LIMITED",
"PHASE POWER PROTECTION PRIVATE LIMITED",
"PHASE3 INDIA PRIVATE LIMITED",
"PHASES INDIA TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"PHASKOWA TEA PLANTATIONS LTD",
"PHATKE PATIL HOSPITAL",
"PHAWA HOSPITAL",
"PHAZR INDIA PRIVATE LIMITED",
"PHBB VALVES PRIVATE LIMITED",
"PHC DHAMANE",
"PHC GUMTHALA",
"PHC KARAD MASUR",
"PHC KARAD SUPANE",
"PHD CHAMBER OF COMMERCE AND INDUSTRY",
"PHDATA SOLUTIONS PRIVATE LIMITED",
"PHDCOMM PRIVATE LIMITED",
"PHE SEALING SOLUTIONS PRIVATE LIMITED",
"PHEDRA PROJECTS PRIVATE. LIMITED",
"PHELAN ENERGY INDIA PRIVATE LIMITED",
"PHELIX SHIPPING VENTURES PRIVATE LIMITED",
"PHELPS AND COMPANY PVT LTD",
"PHENIX DECOR PRIVATE LIMITED",
"PHENIX HARNESS PRIVATE LIMITED",
"PHENIX PHARMA PRIVATE LIMITED",
"PHENIX PROCON PRIVATE LIMITED",
"PHENIX SPINNING PRIVATE LIMITED",
"PHENO ORGANIC PRIVATE LIMITED",
"PHENOM FASHION PRIVATE LIMITED",
"PHENOM PEOPLE PRIVATE LIMITED",
"PHENOM SERVICES PRIVATE LIMITED",
"PHENOMENAL INDUSTRIES LIMITED",
"PHENOMENAL PHARMA PRIVATE LIMITED",
"PHENOMENEX INDIA PRIVATE LIMITED",
"PHENOMTEC SOLUTIONS PRIVATE LIMITED",
"PHEON AUTO TECH PRIVATE LIMITED",
"PHEONIX TECH CONSULTING PRIVATE.LIMITED",
"PHERO HEALTH CARE PRIVATE LIMITED",
"PHEROMONE CHEMICALS PRIVATE LIMITED",
"PHEROZE FRAMROZE AND COMPANY PRIVATE LIMITED",
"PHEROZE KUDIANAVALA CONSULTANTS ENGINEERS PRIVATE LIMITED",
"PHEUTURE STUDIO PRIVATE LIMITED",
"PHF LEASING LIMITED",
"PHFL HOME LOANS AND SERVICES LIMITED",
"PHG HOTELS NEW DELHI PRIVATE LIMITED",
"PHI 21 TECHNOLOGIES PRIVATE LIMITED",
"PHI ADVISORS PRIVATE LIMITED",
"PHI AUDIOCOM SYSTEMS PRIVATE LIMITED",
"PHI BUSINESS SOLUTIONS LIMITED",
"PHI INDIA PRIVATE LIMITED",
"PHI LEARNING PRIVATE LIMITED",
"PHIFER INDIA PRIVATE LIMITED",
"PHIGENE NUTRITECH PRIVATE LIMITED",
"PHIL COAL BENEFICATION PRIVATE LIMITED",
"PHIL ISPAT PRIVATE LIMITED",
"PHIL MINERALS BENEFICATION AND ENERGY PRIVATE LIMITED",
"PHIL SYSTEMS",
"PHIL TECHNOLOGIES PRIVATE LIMITED",
"PHILBRICK TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"PHILCO EXPORTS PVT LTD",
"PHILCON SWITCHGEAR PRIVATE LIMITED",
"PHILI-ORIENT LOGISTICS PRIVATE LIMITED",
"PHILIP ENGINEERING SERVICE",
"PHILIP MORRIS INTERNATIONAL INC.",
"PHILIPAUGUSTINE ASSOCIATES PRIVATE LIMITED",
"PHILIPPINE GUARDING PRIVATE LIMITED",
"VERSUNI INDIA HOME SOLUTIONS LIMITED",
"PHILIPS ENGINEERING SERVICES",
"PHILIPS GLOBAL BUSINESS SERVICES LLP",
"PHILIPS HOSPITAL",
"PHILIPS INDIA LIMITED",
"PHILIRAY ELECTRONICS PRIVATE LIMITED",
"PHILLIP (INDIA) PRIVATE LIMITED",
"PHILLIP CENTRALISED SERVICES INDIA PRIVATE LIMITED",
"PHILLIP COMMODITIES INDIA PRIVATE LIMITED",
"PHILLIP FINANCE & INVESTMENT SERVICES INDIA PRIVATE LIMITED",
"PHILLIP SERVICES INDIA PRIVATE LIMITED",
"PHILLIP VENTURES IFSC PRIVATE LIMITED",
"PHILLIPCAPITAL INDIA PRIVATE LIMITED",
"PHILLIPS",
"PHILLIPS FOODS INDIA PRIVATE LIMITED",
"PHILLIPS MACHINE TOOLS INDIA PRIVATE LIMITED",
"PHILODEN INDUSTRIES PRIVATE LIMITED",
"PHILOSOPHY STUDIO PRIVATE LIMITED",
"PHILS HEAVY ENGINEERING PRIVATE LIMITED",
"PHILSON ELECTRIC COMPANY PRIVATE LIMITED",
"PHIMETRICS TECHNOLOGIES PRIVATE LIMITED",
"PHIMETRICS TELECOM VALUE ADDED SERVICES PRIVATE LIMITED",
"PHINIX CERAMIC PRIVATE LIMITED",
"PHINIX COTTON INDUSTRIES PRIVATE LIMITED",
"PHIROZ N MOTABHOY AND PRIVATE LIMITED",
"PHIROZE SETHNA PRIVATE LIMITED",
"PHISEM CONSULTANCY SERVICES PRIVATE LIMITED",
"PHISTREAM CONSULTING PRIVATE LIMITED",
"PHITECH SOFTWARE PRIVATE LIMITED",
"PHL FININVEST PRIVATE LIMITED",
"PHL PHARMA PRIVATE LIMITED",
"PHLB SERVICES PRIVATE LIMITED",
"PHM GROWTH PRIVATE LIMITED",
"PHMS TECHNOCARE PRIVATE LIMITED",
"PHNIX MACHINERY AND MARKETING PRIVATE LIMITED",
"PHOBOSGOLD TECHNOLOGIES PRIVATE LIMITED",
"PHOCKET INFOTECH PRIVATE LIMITED",
"PHO-COM-NET PRIVATE LIMITED",
"PHOCOS INDIA SOLAR PRIVATE LIMITED",
"PHOEBUS AIRCONDITIONING PRIVATE LIMITED",
"PHOEBUS ANIMATION STUDIOS PRIVATE LIMITED",
"PHOENICIAN MEDICAL CENTER INDIA PRIVATE LIMITED",
"PHOENIIX",
"PHOENIX ADVANCED SOFTWARES PRIVATE LIMITED",
"PHOENIX ADVERTISING PVT LTD",
"PHOENIX AGRO PROCESSING AND BIO-CHEMICAL PRIVATE LIMITED",
"PHOENIX AMALGAMS PRIVATE LIMITED",
"PHOENIX AMERICAN SALESFOCUS SOLUTIONS INDIA PRIVATE LIMITED",
"PHOENIX ARC PRIVATE LIMITED",
"PHOENIX ASSURANCE PRIVATE LIMITED",
"PHOENIX AUTOMATION PRIVATE LIMITED",
"PHOENIX BIOLOGICALS PRIVATE LIMITED",
"PHOENIX BUSINESS CONSULTING INDIA PRIVATE LIMITED",
"PHOENIX BUSINESS INITIATIVES PRIVATE LIMITED",
"PHOENIX CAR ACCESSORIES PRIVATE LIMITED",
"PHOENIX CARS INDIAPRIVATE LIMITED",
"PHOENIX CONTACT INDIA PRIVATE LIMITED",
"PHOENIX CONVEYOR BELT INDIA PRIVATE LIMITED",
"PHOENIX DENTAL AND MEDICAL PRIVATE LIMITED",
"PHOENIX DISTRIBUTORS PRIVATE LIMITED",
"PHOENIX EDUCATIONAL INSTITUTE PRIVATE LIMITED",
"PHOENIX EFS IFM SERVICES PRIVATE LIMITED",
"PHOENIX ELECTRICAL INSULATING MATERIALS COMPANY PRIVATE LIMITED",
"PHOENIX EXPRESS PRIVATE LIMITED",
"PHOENIX FANS PRIVATE LIMITED",
"PHOENIX FERROUS PRIVATE LIMITED",
"PHOENIX FLEXIBLES PRIVATE LIMITED",
"PHOENIX FOILS PRIVATE LIMITED",
"PHOENIX GASES PRIVATE LIMITED",
"PHOENIX GLOBAL RE-SETTLEMENT SERVICES PRIVATE LIMITED",
"PHOENIX GLOBAL TRADE SOLUTIONS PRIVATE LIMITED",
"PHOENIX GLOBALTRANS SOLUTIONS PRIVATE LIMITED",
"PHOENIX HOSPITAL INDORE",
"PHOENIX HOSPITALS PRIVATE LIMITED",
"PHOENIX INDIA VALUE CHAIN PRIVATE LIMITED",
"PHOENIX INDUSTRIES LIMITED",
"PHOENIX INDUSTRIES PRIVATE LIMITED",
"PHOENIX INFOCITY PRIVATE LIMITED",
"PHOENIX INFOTECH PRIVATE LIMITED",
"PHOENIX INFRA ESTATE INTERNATIONAL LIMITED",
"PHOENIX INFRA ZONE PRIVATE LIMITED",
"PHOENIX INFRASTRUCTURE PRIVATE LIMITED",
"PHOENIX INFRATECH INDIA PRIVATE LIMITED",
"PHOENIX INNOVATIVE COATINGS PRIVATE LIMITED",
"PHOENIX INTEGRATED MANAGEMENT SERVICES PRIVATE LIMITED",
"PHOENIX ISPAT PRIVATE LIMITED",
"PHOENIX IT CITY PRIVATE LIMITED",
"PHOENIX LAMPS LIMITED",
"PHOENIX LIFE SCIENCE PRIVATE LIMITED",
"PHOENIX LITTLE STAR ENGLISH MEDIUM SCHOOL",
"PHOENIX LIVING SPACES PRIVATE LIMITED",
"PHOENIX LOGISTICS INDIA PRIVATE LIMITED",
"PHOENIX LOGISTICS PRIVATE LIMITED",
"PHOENIX LUMINARIES PRIVATE LIMITED",
"PHOENIX MACHINES P LTD",
"PHOENIX MANAGED SERVICES INDIA LIMITED",
"PHOENIX MANPOWER & SECURE SOLUTIONS",
"PHOENIX MECANO (INDIA) PRIVATE LIMITED",
"PHOENIX MEDIA PRIVATE LIMITED",
"PHOENIX MEDICAL SYSTEMS PRIVATE LIMITED",
"PHOENIX MOTORS (MOTOR CYCLES DIVISION) PRIVATE LIMITED",
"PHOENIX MOTORS PRIVATE LIMITED",
"PHOENIX MOVERS PRIVATE LIMITED",
"PHOENIX OVERSEAS LIMITED",
"PHOENIX PACK WORLD",
"PHOENIX PHARMA PRIVATE LIMITED",
"PHOENIX POULTRY",
"PHOENIX PROGRESSIVE CERTIFICATIONS ENTERPRISE PRIVATE LIMITED",
"PHOENIX PROJECTS PRIVATE LIMITED",
"PHOENIX REFRIGERATION PRIVATE LIMITED",
"PHOENIX RESIDENCIES PRIVATE LIMITED",
"PHOENIX RESTAURANTS PRIVATE LIMITED",
"PHOENIX RETAIL INDIA PRIVATE LIMITED",
"PHOENIX ROBOTIX PRIVATE LIMITED",
"PHOENIX SERENE SPACES PRIVATE LIMITED",
"PHOENIX SOFTCOM SOLUTIONS PRIVATE LIMITED",
"PHOENIX SOFTNET TECHNOLOGIES PRIVATE LIMITED",
"PHOENIX SOLAR SYSTEMS PRIVATE LIMITED",
"PHOENIX SOLUTION",
"PHOENIX SPACES PRIVATE LIMITED",
"PHOENIX STRUCTURAL AND ENGINEERING PRIVATE LIMITED",
"PHOENIX SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED",
"PHOENIX SURGICALS (INDIA) PRIVATE LIMITED",
"PHOENIX TECH CONSULTING PRIVATE LIMITED",
"PHOENIX TECH ZONE PRIVATE LIMITED",
"PHOENIX TECHCONSULTING PRIVATE LIMITED",
"PHOENIX TECHINFRA PRIVATE LIMITED",
"PHOENIX TELECOM PRIVATE LIMITED",
"PHOENIX TEXTILE ENGINEERING PRIVATE LIMITED",
"PHOENIX TOWNSHIP LIMITED",
"PHOENIX UDYOG PRIVATE LIMITED",
"PHOENIX VENTURES PRIVATE LIMITED",
"PHOENIX WAREHOUSING PRIVATE LIMITED",
"PHOENIX WIRELESS SYSTEMS PRIVATE LIMITED",
"PHOENIXFLEX EXPORTS PRIVATE LIMITED",
"PHOENIXGREEN EDUTECH PRIVATE LIMITED",
"PHOENYX COMMTECH PRIVATE LIMITED",
"PHOINEX SOLUTIONS",
"PHONAK INDIA PRIVATE LIMITED",
"PHONATO STUDIOS PRIVATE LIMITED",
"PHONEIX UDYOG PRIVATE. LIMITED.",
"PHONEME SOLUTIONS PRIVATE LIMITED",
"PHONEPE INSURANCE BROKING SERVICES PRIVATE LIMITED",
"PHONEPE LENDING SERVICES PRIVATE LIMITED",
"PHONEPE PRIVATE LIMITED",
"PHONEX LOGISTICS PRIVATE LIMITED",
"PHONEX TRADERS PRIVATE LIMITED",
"PHONICS GROUP OF INSTITUTIONS",
"PHONO RETAIL PRIVATE LIMITED",
"PHONOGRAPHIC DIGITAL LIMITED",
"PHONOGRAPHIC PERFORMANCE LIMITED",
"PHONON COMMUNICATIONS PRIVATE LIMITED",
"PHONON SOLUTIONS PRIVATE LIMITED",
"PHOOL BOOTI PRIVATE LIMITED",
"PHOOL CHAND INFRASTRUCTURE PRIVATE LIMITED",
"PHOOLCHAND BHAGATSINGH",
"PHOOLTAS TECHNOLOGIES PRIVATE LIMITED",
"PHOOLTAS TRANSRAIL LIMITED",
"PHORON TECHNOSOLUTIONS PRIVATE LIMITED",
"PHOROTECH SURFIN INDIA PRIVATE LIMITED",
"PHOSET FOODS PRIVATE LIMITED",
"PHOTO SYSTEMS (INDIA) PRIVATE LIMITED",
"PHOTOELECTRIC SOLAR SYSTEM PRIVATE LIMITED",
"PHOTOGAUGE INDIA PRIVATE LIMITED",
"PHOTOKINA CHEMICALS PRIVATE LIMITED",
"PHOTON AI PRIVATE LIMITED",
"PHOTON CLOUD TECHNOLOGY PRIVATE LIMITED",
"PHOTON CONTROLS (INDIA) PRIVATE LIMITED",
"PHOTON INFOTECH PRIVATE LIMITED",
"PHOTON INTERACTIVE PRIVATE LIMITED",
"PHOTON LIFE SCIENCES LLP",
"PHOTON PRODUCTIONS PRIVATE LIMITED",
"PHOTON SOLAR POWER PRIVATE LIMITED",
"PHOTON SUNBEAM PRIVATE LIMITED",
"PHOTON SURYAKIRAN PRIVATE LIMITED",
"PHOTONAMA STUDIOS PRIVATE LIMITED",
"PHOTONICS WATERTECH PRIVATE LIMITED",
"PHOTONIX SOLAR PROJECTS PRIVATE LIMITED",
"PHOTONPLAY SYSTEMS PRIVATE LIMITED",
"PHOTOPHONE COMEL PRIVATE LIMITED",
"PHOTOQUIP INDIA LIMITED",
"PHOVOEZOLAR ENERGY PRIVATE LIMITED",
"PHOX INDIA EQUIPMENTS PRIVATE LIMITED",
"PHOZO DIGITAL PRESS PRIVATE LIMITED",
"PHP EXPERT TECHNOLOGIES PRIVATE. LIMITED.",
"PHPL SOLUTIONS PRIVATE LIMITED",
"PHPL TEXTILES PRIVATE LIMITED",
"PHRIA PHARMAOTECH PRIVATE LIMITED",
"PHROG APP LABS PRIVATE LIMITED",
"PHRONESIS CAPITAL LIMITED",
"PHRONESIZ MARKETING VENTURES PRIVATE LIMITED",
"PHS CONSULTANTS PRIVATE LIMITED",
"PHS LIFE SCIENCES PRIVATE LIMITED",
"PHS MACHINERIES PRIVATE LIMITED",
"PHS.FITT PRIVATE LIMITED",
"PHTHALO COLOURS AND CHEMICALS (INDIA) LIMITED",
"PHTHALO COLOURS AND CHEMICALS I LIMITED",
"PHUGURI TEA ESTATE PRIVATE LIMITED",
"PHULAMPUR TEA COMPANY PRIVATE LIMITED",
"PHULCHAND EXPORTS PRIVATE LTD",
"PHULCHAND MANAKLAL SECURITIES PRIVATE LI MITED",
"PHULDEV NARAIN SINGH BUILTECH PRIVATE LIMITED",
"PHULERA INDUSTRIES PRIVATE LIMITED",
"PHULERA MARBLES PVT. LTD",
"PHULESHWAR MEMORIAL CLINIC PRIVATE LIMITED",
"PHULJHORA AGRO PLANTATION PRIVATE LIMITED",
"PHULKIAN PRESS PRIVATE LIMITED",
"PHULL NEURO AND MULTISPECIALITY HOSPITAL",
"PHULWARI EDUCATION PRIVATE LIMITED",
"PHULWARI PAINTS OVERSEAS PRIVATE LIMITED",
"PHULWASO MEMORIAL HOSPITAL PRIVATE LIMITED",
"PHUSARAM MUNDHRA PRIVATE LIMITED",
"PHUTELA MEDIRICH PRIVATE LIMITED",
"PHUTRO FASHION",
"PHX CONSULTING PRIVATE LIMITED",
"PHYBUSOL COMPUTER SOLUTIONS PRIVATE LIMITED",
"PHYCARE SERVICES INDIA PRIVATE LIMITED",
"PHYCHEM TECHNOLOGIES PRIVATE LIMITED",
"PHYGITALXP DESIGNS PRIVATE LIMITED",
"PHYGITECH LEARNING SOLUTIONS PRIVATE LIMITED",
"PHYKON SOLUTIONS PRIVATE LIMITED",
"PHYNYX INDUSTRIAL PRODUCTS PRIVATE LIMITED",
"PHYSFIX FITNESS SOLUTION PRIVATE LIMITED",
"PHYSICAL ACOUSTICS INDIA PRIVATE LIMITED",
"PHYSICIANS INTERACTIVE INDIA PRIVATE LIMITED",
"PHYSICS MOTORS TECHNOLOGY PRIVATE LIMITED",
"PHYSIO REHAB CLINICS INDIA PRIVATE LIMITED",
"PHYSIOLOGIX HEALTHCARE PRIVATE LIMITED",
"PHYSIQUE LIMITED",
"PHYTEC EMBEDDED PRIVATE LIMITED",
"PHYTO DRUGS PRIVATE LIMITED",
"PHYTO INGREDIENTS BIOPHARMA PRIVATE LIMITED",
"PHYTO LIFE SCIENCES PRIVATE LIMITED",
"PHYTO MARKETING PRIVATE LIMITED",
"PHYTO PHARMACEUTICALS PVT LTD",
"PHYTO SPECIALITIES PRIVATE LIMITED",
"PHYTOCELL LIFE MARKETING PRIVATE LIMITED",
"PHYTOCHEM REMEDIES (INDIA) PRIVATE LIMITED",
"PHYTOLAND PRIVATE LIMITED",
"PHYTOSOL INDIA PRIVATE LIMITED",
"PHYTOTRON AGRO PRODUCTS (INDIA) PRIVATE LIMITED",
"PHYTOVEDIC (INDIA) PRIVATE LIMITED",
"PI BEAM LABS PRIVATE LIMITED",
"PI COMMUNICATIONS PRIVATE LIMITED",
"PI GLOBAL INDIA PRIVATE LIMITED",
"PI GREEN CONSULTING PRIVATE LIMITED",
"PI GREEN INNOVATIONS PRIVATE LIMITED",
"PI INDUSTRIES LIMITED",
"PI INTERNATIONAL GLOBAL SOLUTIONS PRIVATE LIMITED",
"PI JAM FOUNDATION",
"PI KUMIAI PRIVATE LIMITED",
"PI LIFE SCIENCE RESEARCH LIMITED",
"PI LOGISTICS INDIA PRIVATE LIMITED",
"PI MINERALS PRIVATE LIMITED",
"PI SQUARE CABLES PRIVATE LIMITED",
"PI TECH SOLUTIONS PRIVATE LIMITED",
"PI TECHNIQUES PRIVATE LIMITED",
"PI2 SQUARE PRIVATE LIMITED",
"PIA CONSULTANCY AND ENGINEERING PRIVATE LIMITED",
"PIAB VACUUM TECHNOLOGY PRIVATE LIMITED",
"PIAGGIO VEHICLES PRIVATE LIMITED",
"PIBCO ENTERPRISES PRIVATE LIMITED",
"PIC INTERNATIONAL METALS & ALLOYS PRIVATE LIMITED",
"PIC REALCON LIMITED",
"PICADO HOME DECORS PRIVATE LIMITED",
"PICANOL INDIA PRIVATE LIMITED",
"PICASONA AGRICULTURE PRODUCTS PRIVATE LIMITED",
"PICASSO ANIMATION PRIVATE LIMITED",
"PICASSO CERAMICS AND COLOURS PRIVATE LIMITED",
"PICASSO DIGITAL MEDIA PRIVATE LIMITED",
"PICASSO HOME PRODUCTS PRIVATE LIMITED",
"PICASSO RETAILS PRIVATE LIMITED",
"PICCADILY AGRO INDUSTRIES LIMITED",
"PICCADILY HOLIDAY RESORTS LIMITED",
"PICCADILY HOTELS PRIVATE LIMITED",
"PICCADILY IMPEX LIMITED",
"PICCADILY SUGAR AND ALLIED INDUSTRIES LIMITED",
"PICCO INFRA SOLUTIONS PRIVATE LIMITED",
"PICHAIN INNOVATIONS PRIVATE LIMITED",
"PICHKAARI DESIGN STUDIO PRIVATE LIMITED",
"PICK MY SOLAR INDIA PRIVATE LIMITED",
"PICK SPEED EXPRESS & LOGISTICS PRIVATE LIMITED",
"PICKET SECURITY SERVICES PRIVATE LIMITED",
"PICKIT GOURMET PRIVATE LIMITED",
"PICKRENEW ENERGY PRIVATE LIMITED",
"PICKRR TECHNOLOGIES PRIVATE LIMITED",
"PICK-UP MOTORS PRIVATE LIMITED.",
"PICKUP SUPPLIERS PVT LTD",
"PICKWICK HYGIENIC PRODUCTS PRIVATE LIMITED",
"PICL (INDIA) PRIVATE LIMITED",
"PICL INDIA PRIVATE LIMITED",
"PICO CAPITAL PRIVATE LIMITED",
"PICO PURO TECHNOLOGIES INDIA PRIVATE LIMITED",
"PICOLA INDIA PRIVATE LIMITED",
"PICONET INNOVATIVE SOLUTIONS PRIVATE LIMITED",
"PICSON CONSTRUCTION EQUIPMENTS PRIVATE LIMITED",
"PICTOR DIAGNOSTICS INDIA PRIVATE LIMITED",
"PICTOR TELEMATICS PRIVATE LIMITED",
"PICTURE PRODUCTIONS (INDIA) PRIVATE LIMITED",
"PICTURE TIME DIGIPLEX PRIVATE LIMITED",
"PICTUREHOUSE MEDIA LIMITED",
"PICU AGRI PRIVATE LIMITED",
"PICWAY TRADELINK PRIVATE LIMITED",
"PID IMPORTS INDIA PRIVATE LIMITED",
"PID PRIVATE LIMITED",
"PIDICHEM PRIVATE LIMITED",
"PIDILITE INDUSTRIES LIMITED",
"PIDILITE LITOKOL PRIVATE LIMITED",
"PIE INFINITY INFRASTRUCTURE PRIVATE LIMITED",
"PIE SOFTWARE PRIVATE LIMITED",
"PIECAN PHARMA PRIVATE LIMITED",
"PIECO INDIA ENGINEERING COMPANY PRIVATE LIMITED",
"PIECODE INFOTECH",
"PIEDMONT DEVELOPMENT COMPANY PRIVATE LIMITED",
"PIEM HOTELS LIMITED",
"PIEPL UDYOG PRIVATE LIMITED",
"PIER 4 INFRA SOLUTIONS PRIVATE LIMITED",
"PIERCING SYSTEMS INDIA PRIVATE LIMITED",
"PIERIAN SERVICES PRIVATE LIMITED",
"PIERIANDX INDIA PRIVATE LIMITED",
"PIERSOFT PRIVATE LIMITED",
"PIET SANSKRITI SCHOOL",
"PIETRO FIORENTINI INDIA PRIVATE LIMITED",
"PIEZO TECHNOLOGY INDIA PRIVATE LIMITED",
"PIEZO-TECH INDUSTRIES PRIVATE LIMITED",
"PIFCA PRIVATE LIMITED",
"PIG IRON SUPPLYING SYNDICATE PVT LTD",
"PIGEON BUILDHOME PRIVATE LIMITED",
"PIGEON EXPORTS INTERNATIONAL PRIVATE LIMITED",
"PIGEON INDIA PRIVATE LIMITED",
"PIGEON INFRASTRUCTURE LIMITED",
"PIGEON PUBLICATIONS PRIVATE LIMITED",
"PIGMENTS & CHEMICAL INDUSTRIES PVT LTD",
"PIGOTT ELEGANCE PRIVATE LIMITED",
"PIHU ENTERPRISES PRIVATE LIMITED",
"PIIU HEALTHCARE PRODUCTS PRIVATE LIMITED",
"PIKA MEDICAL PRIVATE LIMITED",
"PIKKME COMMERCE PRIVATE LIMITED",
"PIKTOR INNOVATION LABS INDIA PRIVATE LIMITED",
"PIL CHEMICALS LIMITED",
"PIL INDIA PRIVATE LIMITED",
"PIL INDUSTRIES LIMITED",
"PIL ITALICA LIFESTYLE LIMITED",
"PIL MUMBAI PRIVATE LIMITED",
"PIL PHARMACEUTICALS LIMITED",
"PILANI ENVIROTECH PRIVATE LIMITED",
"PILANI INDUSTRIAL CORPORATION LIMITED",
"PILANI INVESTMENT AND INDUSTRIES CORPORATION LIMITED",
"PILANIA STEELS PVT LTD",
"PILCO HEALTHCARE PRIVATE LIMITED",
"PILECUBES INDIA PRIVATE LIMITED",
"PILGRIMAGE INCUBATION PRIVATE LIMITED",
"PILIBHIT HOUSE",
"PILKHUWA WATER PROOFING COMPANY PRIVATE LIMITED",
"PILKINGTON AUTOMOTIVE INDIA PRIVATE LIMITED",
"PILLAI HOC COLLEGE OF ENGINEERING AND TECHNOLOGY",
"PILLAR CHEMICALS PRIVATE LIMITED",
"PILLAR IT SERVICES PRIVATE LIMITED",
"PILLARPLUS PRIVATE LIMITED",
"PILLAR'S BIO-HEALTH SOLUTIONS PRIVATE LIMITED",
"PILLER POWER INDIA PRIVATE LIMITED",
"PILOG INDIA PRIVATE LIMITED",
"PILOT 2 WHEELERS PRIVATE LIMITED",
"PILOT COMMERCIALS LLP",
"PILOT CONSULTANTS PRIVATE LTD.",
"PILOT INDUSTRIES LIMITED",
"PILOT MOTORS PRIVATE LIMITED",
"PILOT PNEUMATICS PRIVATE LIMITED",
"PILOTFISH KONCEPTS CONSULTANT & PROJECTS PRIVATE LIMITED",
"PILOTSMITH (INDIA) PRIVATE LIMITED",
"PILZ INDIA PRIVATE LIMITED",
"PIM PACKAGING PRIVATE LIMITED",
"PIMA CONTROLS PRIVATE LIMITED",
"PIMCO MACHINES PVT LTD",
"PIMPARI CHINCHWAD MUNCIPAL COROPORATION",
"PIMPRI CHINCHWAD COLLEGE OF ENGINEERING & RESEARCH",
"PIMPRI CHINCHWAD MAHANAGARPALIKA",
"PIMPRI CHINCHWAD MEDIA COMMUNICATIONS PRIVATE LIMITED",
"PIMPRI CHINCHWAD MUNICIPAL CORPORATION JIJAMATA HOSPITAL",
"PIMPRI CHINCHWAD POLYTECHNIC",
"PIMPRI CHINCHWAD SAHAKARI BANK LIMITED",
"PIMPRI CHINCHWAD SAHAKARI BANK MARYADIT",
"PIMPRI CHINCHWAD SMART CITY LIMITED",
"PIMS HOSPITAL PRIVATE LIMITED",
"PIN CLICK PROPERTY MANAGEMENT PRIVATE LIMITED",
"PIN HIGH INDIA PRIVATE LIMITED",
"PINAACLE TECHNOLOGIES PRIVATE LIMITED",
"PINAAKI EMPRESAS PRIVATE LIMITED",
"PINACA TECHNOLOGIES PRIVATE LIMITED",
"PINACLE RMC CONSTRUCTION PRIVATE LIMITED",
"PINACLE SURFACESS PRIVATE LIMITED",
"PINAK ADVISORY SERVICES PRIVATE LIMITED",
"PINAK INTERNATIONAL LLP",
"PINAK TEXPORT PRIVATE LIMITED",
"PINAKA AEROSPACE SOLUTIONS PRIVATE LIMITED",
"PINAKA CONSTRUCTION PRIVATE LIMITED",
"PINAKEE ENGINEERS & DEVELOPERS PINAKEE",
"PINAKI SOFTCON PRIVATE LIMITED",
"PINAKIIN CREATIONS PRIVATE LIMITED",
"PINAKIN BUSINESS SOLUTIONS PRIVATE LIMITED",
"PINAKIN GREEN ENERGY PRIVATE LIMITED",
"PINAKIN HOTELS PRIVATE LIMITED",
"PINAKIN SECURITY PRIVATE LIMITED",
"PINAKIN STUDIO LLP",
"PINAKINI CORPORATION PRIVATE LIMITED",
"PINAQ REMEDIES (INDIA) PRIVATE LIMITED",
"PINAX PAPER MILLS PRIVATE LIMITED",
"PINAX STEEL INDUSTRIES PRIVATE LIMITED",
"PINAXIS ELEVATOR INDIA PRIVATE LIMITED",
"PINAXIS HI-TECH ENGINEERING PRIVATE LIMITED",
"PINAZ TEXFAB PRIVATE LIMITED",
"PINCAM TECHNOLOGY PRIVATE LIMITED",
"PINCUSHION MONTESSORI INTERNATIONAL SCHOOL",
"PINDARAN METAL & ALLOYS PRIVATE LIMITED",
"PINDI COMMODITIES PRIVATE LIMITED",
"PINE AIR PRIVATE LIMITED",
"PINE CLIFF FOODS PRIVATE LIMITED",
"PINE CONE HILL INDIA PRIVATE LIMITED",
"PINE EQUIPMENT PRIVATE LIMITED",
"PINE EXPORTERS PRIVATE LIMITED",
"PINE HALL SCHOOL",
"PINE LABS PRIVATE LIMITED",
"PINE LAKE VILLA HOTELS PRIVATE LIMITED",
"PINE LAMINATES PRIVATE LIMITED",
"PINE PHARMA PRIVATE LIMITED",
"PINE PLYWOOD PRIVATE LIMITED",
"PINE POLYMERS PRIVATE. LIMITED.",
"PINE TRADING PRIVATE LIMITED",
"PINE TREE CAPITAL MARKETS PRIVATE LIMITED",
"PINE TREE FIN ADVISORY PRIVATE LIMITED",
"PINE TREE HOTEL PRIVATE LIMITED",
"PINE TREE MOTELS PRIVATE LIMITED",
"PINEAPPLE CONSULTING PRIVATE LIMITED",
"PINEAPPLE FASHION PRIVATE LIMITED",
"PINEAPPLE TECHNOLOGIES PRIVATE LIMITED",
"PINEBRIDGE INDIA PRIVATE LIMITED",
"PINEHAM LEARNING AND TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"PINEHILL KIDSWEAR PRIVATE LIMITED",
"PINESUCCEED TECHNOLOGIES PRIVATE LIMITED",
"PINETCO TECHNOLOGIES PRIVATE LIMITED",
"PINETICS PRIVATE LIMITED",
"PINETREE CAPITAL PRIVATE LIMITED",
"PINETREE LUMBERS INDIA PRIVATE LIMITED",
"PINETREE PACKAGING PRIVATE LIMITED",
"PINETREE REALTORS PRIVATE LIMITED",
"PINEVIEW TECHNOLOGY PRIVATE LIMITED",
"PINEWOOD ESTATES PRIVATE LIMITED",
"PINEYARDS SOLUTIONS PRIVATE LIMITED",
"PING AUTOMOTIVE ENGINEERING PRIVATE LIMITED",
"PING DIGITAL BROADCAST PRIVATE LIMITED",
"PING ENGINEERS INDIA PRIVATE LIMITED",
"PING GLOBALSERVICES PRIVATE LIMITED",
"PING IDENTITY INDIA PRIVATE LIMITED",
"PING PONG GLOBAL LIMITED",
"PING TELEMATICS PRIVATE LIMITED",
"PINGA SOLUTIONS PRIVATE LIMITED",
"PINGALA SOFTWARE INDIA PRIVATE LIMITED",
"PINGALAKSHA AGENCIES PRIVATE LIMITED",
"PINGBEE INTERNATIONAL PRIVATE LIMITED",
"PINGGAO GROUP POWER INDIA PRIVATE LIMITED",
"PINGHAX IMPEX PRIVATE LIMITED",
"PINGKAR SERVICES PRIVATE LIMITED",
"PINGLE ALLOYS PRIVATE LIMITED",
"PINGLE CORPORATE SOLUTIONS PRIVATE LIMITED",
"PINGPONG GLOBAL SOLUTIONS INC",
"PINGTHIS PRIVATE LIMITED",
"PINI INDIA PRIVATE LIMITED",
"PINIMA LIFESCIENCE PRIVATE LIMITED",
"PINION DIGITAL SOLUTIONS PRIVATE LIMITED",
"PINION INFOTECH SERVICES PRIVATE LIMITED",
"PINK CITY ENERGY PRIVATE LIMITED",
"PINK CITY FINCAP PVT LTD",
"PINK CITY FURNISHINGS PRIVATE LIMITED",
"PINK CITY HOSPITAL PRIVATE LIMITED",
"PINK CITY MINERALS PRIVATE LIMITED",
"PINK CITY PRESS CLUB LIMITED",
"PINK CITY STEEL ROLLING MILLS PRIVATE LIMITED",
"PINK FOODS HOSPITALITY PRIVATE LIMITED",
"PINK HAND TECHNOLOGIES PRIVATE LIMITED",
"PINK LEMONADE COMMUNICATIONS PRIVATE LIMITED",
"PINK NOISE PROFESSIONALS PRIVATE LIMITED",
"PINK PAPAYA FOODS PRIVATE LIMITED",
"PINK PASSION FOODS PRIVATE LIMITED",
"PINK PEARL HOTEL AND FUN CITY",
"PINK PHARMACY SERVICES PRIVATE LIMITED",
"PINK ROSE PIGMENTS PRIVATE LIMITED",
"PINK TREE AADVISORS PRIVATE LIMITED",
"PINKAPPLE STUDIO PRIVATE LIMITED",
"PINKBLUE SUPPLY SOLUTIONS PRIVATE LIMITED",
"PINKCITY ADVERTISING COMPANY PRIVATE LIMITED",
"PINKCITY AGRO PRIVATE LIMITED",
"PINKCITY BUILDHOME PRIVATE. LIMITED.",
"PINKCITY CAPITAL SERVICES PRIVATE LIMITED",
"PINKCITY ENTERPRISES PRIVATE LIMITED",
"PINKCITY FARMS PRIVATE LIMITED",
"PINKCITY JEWELHOUSE PRIVATE LIMITED",
"PINKCITY LOGISTICS LIMITED",
"PINKCITY MARBLE PRIVATE LIMITED",
"PINKCITY MOTORS PRIVATE LIMITED",
"PINKCITY PACKAGING PRIVATE LIMITED",
"PINKCITY PLYBOARD PRIVATE LIMITED",
"PINKCITY RESINS PRIVATE LIMITED",
"PINKCITY TELECOM PRIVATE LIMITED",
"PINKCITY WOOD PRODUCT PRIVATE LIMITED",
"PINKERTON CORPORATE RISK MANAGEMENT INDIA PRIVATE LIMITED",
"PINKI AIR SERVICES PRIVATE LIMITED",
"PINKI TOURS AND TRAVEL",
"PINKKU TRADERS",
"PINKONNECT EXPRESS PRIVATE LIMITED",
"PINKROSE DEALCOMM LIMITED",
"PINKS INFRACON PRIVATE LIMITED",
"PINKS 'N' BLOOS BEAUTY SALOONS PRIVATE LIMITED",
"PINKSAN TECHNOLOGIES PRIVATE LIMITED",
"PINKVILLA MEDIA PRIVATE LIMITED",
"PINKY FMCG PRODUCT PRIVATE LIMITED",
"PINKY FOREX TOURS AND TRAVELS PRIVATE LIMITED",
"PINKY GRANITES STONES PRIVATE LIMITED",
"PINKY MARBLES PRIVATE LIMITED",
"PINKY MOTORS AND FREIGHT CARRIERS PRIVATE LIMITED",
"PINKY SUIT PRIVATE LIMITED",
"PINMICRO INDIA PRIVATE LIMITED",
"PINNAC CONSULTING PRIVATE LIMITED",
"PINNACLE AGRO AND IRON PRIVATE LIMITED",
"PINNACLE AIR PRIVATE LIMITED",
"PINNACLE BIOMED PRIVATE LIMITED",
"PINNACLE BROCOM PRIVATE LIMITED",
"PINNACLE BUILDTECH PRIVATE LIMITED",
"PINNACLE CAPITAL SOLUTIONS PRIVATE LIMITED",
"PINNACLE CATERER PRIVATE LIMITED",
"PINNACLE CELEBRITY MANAGEMENT",
"PINNACLE CLOTHING CO. LLP",
"PINNACLE COAT-INKS PRIVATE LIMITED",
"PINNACLE CORPORATION PRIVATE LIMITED",
"PINNACLE CREDIT ADVISORS PRIVATE LIMITED",
"PINNACLE DIES & MOULDS PRIVATE LIMITED",
"PINNACLE EDUCATION AND IMMIGRATION CONSULTING PRIVATE LIMITED",
"PINNACLE ELECTRODES PRIVATE LIMITED",
"PINNACLE ENGINEERING SOLUTIONS (INDIA) PRIVATE LIMITED",
"PINNACLE ENGINES INDIA PRIVATE LIMITED",
"PINNACLE ENGPLAST PRIVATE LIMITED",
"PINNACLE ENTERPRISES PVT LTD",
"PINNACLE EQUIPMENTS PRIVATE LIMITED",
"PINNACLE FINANCIAL AND INVESTMENTS SERVICES PRIVATE LIMITED",
"PINNACLE FOREX & SECURITIES PRIVATE LIMITED",
"PINNACLE GENERATORS PRIVATE LIMITED",
"PINNACLE GLOBAL FOUNDATION",
"PINNACLE GLOBAL PRIVATE LIMITED",
"PINNACLE HERBAL EXTRACTIONS PRIVATE LIMITED",
"PINNACLE HI-TECH ENGINEERS PRIVATE LIMITED",
"PINNACLE HORIZON PRIVATE LIMITED",
"PINNACLE HOSPITALS INDIA PRIVATE LIMITED",
"PINNACLE HOUSING PRIVATE LIMITED",
"PINNACLE HYDRO ENERGY PRIVATE LIMITED",
"PINNACLE INDUSTRIAL CONTROLS PRIVATE LIMITED",
"PINNACLE INDUSTRIES LIMITED",
"PINNACLE INFO EDGE PRIVATE LIMITED",
"PINNACLE INFOTECH PRIVATE LIMITED",
"PINNACLE INFOTECH SOLUTIONS",
"PINNACLE INFRAHEIGHTS PRIVATE LIMITED",
"PINNACLE INN PRIVATE LIMITED",
"PINNACLE INNOVATORY SERVICES PRIVATE LIMITED",
"PINNACLE LIFE SCIENCE PRIVATE LIMITED",
"PINNACLE LIFESTYLE PRIVATE LIMITED",
"PINNACLE LOGISTICS (INDIA) PRIVATE LIMITED",
"PINNACLE MARINE SERVICES PRIVATE LIMITED",
"PINNACLE MOBILITY SOLUTIONS PRIVATE LIMITED",
"PINNACLE MOTOCORP INDIA PRIVATE LIMITED",
"PINNACLE MOTOR WORKS PRIVATE LIMITED",
"PINNACLE NANOTECH INDIA PRIVATE LIMITED",
"PINNACLE NEOSTAR CORPORATION PRIVATE LIMITED",
"PINNACLE NEXUS LIMITED",
"PINNACLE OPTICALS PRIVATE LIMITED",
"PINNACLE ORTHOCENTRE LLP",
"PINNACLE OVERSEAS",
"PINNACLE POLYMERS PRIVATE LIMITED",
"PINNACLE POLYTRADE PRIVATE LIMITED",
"PINNACLE PREMIUM SERVICES PRIVATE LIMITED",
"PINNACLE PRIDE PRIVATE LIMITED",
"PINNACLE PRIME CONSTRUCTIONS PRIVATE LIMITED",
"PINNACLE REALTY PROJECTS PRIVATE LIMITED",
"PINNACLE RESORTS PRIVATE LIMITED",
"PINNACLE REWARDS & RECOGNITION PRIVATE LIMITED",
"PINNACLE SOURCING AND CONSULTANCY PRIVATE LIMITED",
"PINNACLE SYSTEMS PRIVATE LIMITED",
"PINNACLE TECHNOLOGY CONSULTANCY SERVICES PRIVATE LIMITED",
"PINNACLE TECHNOSOLUTIONS PRIVATE LIMITED",
"PINNACLE TELESERVICES PRIVATE LIMITED",
"PINNACLE THERAPEUTICS PRIVATE LIMITED",
"PINNACLE TRAXIM PRIVATE LIMITED",
"PINNACLE TUBE PRIVATE LIMITED",
"PINNACLE VASTUNIRMAN PRIVATE.LIMITED.",
"PINNACLE WELLNESS CONCEPTS PRIVATE LIMITED",
"PINNACLES LIGHTING PROJECT PRIVATE LIMITED",
"PINNACLEWORKS INFOTECH PRIVATE LIMITED",
"PINNAKLE HEALTHCARE TECHNOLOGIES PRIVATE LIMITED",
"PINNAXIS IT SOLUTIONS AND CONSULTING PRIVATE LIMITED",
"PINNINTI CHITFUNDS PRIVATE LIMITED",
"PINPOINT BLOCK PRIVATE LIMITED",
"PINPOINT INDIA PRIVATE LIMITED",
"PINQSTORY PRIVATE LIMITED",
"PINSAAR SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"PINSOFT TECHNOLOGIES PRIVATE LIMITED",
"PINSONS HOTELS PRIVATE LIMITED",
"PINSTAR AUTOMOTIVE INDIA PRIVATE LIMITED",
"PINSTORM TECHNOLOGIES LIMITED",
"PINTAIL REALTY DEVELOPERS PRIVATE LIMITED",
"PINTAIL WORLDWIDE PRIVATE LIMITED",
"PINTER SERVICE INDIA PRIVATE LIMITED",
"PINTU UDYOG INDIA PRIVATE LIMITED",
"PINWHEEL TRAVEL & EXPERIENCE PRIVATE LIMITED",
"PINXIT BLUE ADVERTISING PRIVATE LIMITED",
"PIO PAX PRIVATE LIMITED",
"PIO PRINTERS PRIVATE LIMITED",
"PIOCTAVE SOLUTIONS PRIVATE LIMITED",
"PIOLAX INDIA PRIVATE LIMITED",
"PIOMA INDUSTRIES PRIVATE LIMITED",
"PIOMBINO STEEL LIMITED",
"PION GLOBAL PRIVATE LIMITED",
"PION IMPEX PRIVATE LIMITED",
"PIONEER AGRITECH SOLUTIONS PRIVATE LIMITED",
"PIONEER AGRO EXTRACTS LIMITED",
"PIONEER AGRO INDUSTRIES SANVIN LABORATORIES PRIVATE LIMITED",
"PIONEER AIRBOL PRIVATE LIMITED",
"PIONEER ALUMINIUM INDUSTRIES LIMITED",
"PIONEER ALUMINIUM PRIVATE LIMITED",
"PIONEER ARTS SCIENCE COLLEGE- 641047",
"PIONEER ARUNACHALAM PACKAGING PRIVATE LIMITED",
"PIONEER ASIA ENTERPRISES PRIVATE LIMITED",
"PIONEER ASIA INDUSTRIES PRIVATE LIMITED",
"PIONEER ASSURANCE CONSULTANTS LIMITED",
"PIONEER AUTOWORLD GUNTUR PRIVATE LIMITED",
"PIONEER AYURVEDIC COLLEGE AND HOSPITAL",
"PIONEER BIO-PHARMA PRIVATE LIMITED",
"PIONEER BPO SOLUTIONS PRIVATE LIMITED",
"PIONEER BRICKS PRIVATE LIMITED",
"PIONEER BUILDERRS LIMITED",
"PIONEER CAD AND DESIGN SOLUTIONS PRIVATE LIMITED",
"PIONEER CALICOS PRODUCTS PRIVATE LIMITED",
"PIONEER CARBIDE PRIVATE. LIMITED.",
"PIONEER CARBONISATION PRIVATE LIMITED",
"PIONEER CARGO PRIVATE LIMITED",
"PIONEER CERAMIC INDUSTRIES",
"PIONEER CHANNEL FACTORY PRIVATE LIMITED",
"PIONEER CHEMICAL INDUSTRIES PRIVATE LIMITED",
"PIONEER CLIENT ASSOCIATES PRIVATE LIMITED",
"PIONEER COLD STORE AND CLADDING PRIVATE LIMITED",
"PIONEER COLLECTIONS PRIVATE LIMITED",
"PIONEER CONSOLIDATED CONSTRUCTORS PRIVATE LIMITED",
"PIONEER CONSTROTECH PRIVATE LIMITED",
"PIONEER CORPS TRAINING CENTRE",
"PIONEER CRANES & ELEVATORS PRIVATE LIMITED",
"PIONEER DATA SYS (INDIA) PRIVATE LIMITED",
"PIONEER DEBT RESOLUTION PRIVATE LIMITED",
"PIONEER DECOPACK PRIVATE LIMITED",
"PIONEER DEGREE COLLEGE",
"PIONEER DESIGN AND ENGINEERING PRIVATE LIMITED",
"PIONEER DIGITAL INDUSTRY PRIVATE LIMITED",
"PIONEER DISTILLERIES LIMITED",
"PIONEER DRILLING COMPANY PRIVATE LIMITED",
"PIONEER DYEING PRIVATE LIMITED",
"PIONEER E SOLUTIONS PRIVATE LIMITED",
"PIONEER EDUTECH MEDIA SERVICES",
"PIONEER ELABS LIMITED",
"PIONEER EMBROIDERIES LIMITED",
"PIONEER ENGINEERS & PROJECTS (INDIA) PRIVATE LIMITED",
"PIONEER ENGITECH SOLUTION PRIVATE LIMITED",
"PIONEER EN-TECH PRIVATE LIMITED",
"PIONEER ENTERPRISES (INDIA) PRIVATE LIMITED",
"PIONEER ENVIRO LABORATORIES AND CONSULTANTS PRIVATE LIMITED",
"PIONEER ESERVE PRIVATE LIMITED",
"PIONEER ESERVICES PRIVATE LIMITED",
"PIONEER EXTRUDERS PRIVATE LIMITED",
"PIONEER FACILITIES PRIVATE LIMITED",
"PIONEER FACILITY MANAGEMENT LIMITED",
"PIONEER FACOR IT INFRADEVELOPERS PRIVATE LIMITED.",
"PIONEER FIL MED PRIVATE LIMITED",
"PIONEER FIL-MED PRIVATE LIMITED",
"PIONEER FINANCIAL AND MANAGEMENT SERVICES LIMITED",
"PIONEER FINCAP PRIVATE LIMITED",
"PIONEER FINEST LIMITED",
"PIONEER FIRE PROTECTION PRIVATE LIMITED",
"PIONEER FLOAT GLASS PRIVATE LIMITED",
"PIONEER FLYING ACADEMY PRIVATE LIMITED",
"PIONEER FURNACES PRIVATE LIMITED",
"PIONEER GAS POWER LIMITED",
"PIONEER GEL PRIVATE LIMITED",
"PIONEER GENCO LIMITED",
"PIONEER GEOMATICS ENGINEERING PRIVATE LIMITED",
"PIONEER GLOBAL PROJECTS PRIVATE LIMITED",
"PIONEER HARDFACING PRIVATE LIMITED",
"PIONEER HEALTHCARE PRIVATE LIMITED",
"PIONEER HI-BRED PRIVATE LIMITED",
"PIONEER HIM UDYOG PVT LTD",
"PIONEER HOLDINGS PRIVATE LIMITED",
"PIONEER HOLON AGROECOLOGY PRIVATE LIMITED",
"PIONEER HORTI CULTURIST PRIVATE LIMITED",
"PIONEER HORTICULTARIST PRIVATE LIMITED",
"PIONEER HOSE & HYDRAULICS PRIVATE LIMITED",
"PIONEER HOSPITALS",
"PIONEER HR SOLUTIONS PRIVATE LIMITED",
"PIONEER HYDROTHERMAL SERVICES PRIVATE LIMITED",
"PIONEER HYGIENE SALES PRIVATE LIMITED",
"PIONEER IMPEX CHEMFLUX PVT LTD",
"PIONEER INC",
"PIONEER INDIA DEVELOPERS PRIVATE LIMITED",
"PIONEER INDIA ELECTRONICS PRIVATE LIMITED",
"PIONEER INFO SOLUTIONS INDIA PRIVATE LIMITED",
"PIONEER INFOMEDIA PRIVATE LIMITED",
"PIONEER INKS & PACKAGING PRIVATE LIMITED",
"PIONEER INKS AND PIGMENTS PRIVATE LIMITED",
"PIONEER INSTITUTE OF PROFESSIONAL STUDIES",
"PIONEER INSULATION (INDIA) PRIVATE LIMITED.",
"PIONEER INSURANCE & REINSURANCE BROKERS PRIVATE LIMITED",
"PIONEER INTERIOR PROJECTS PRIVATE LIMITED",
"PIONEER INTERTRADE PRIVATE LIMITED",
"PIONEER INVESTCORP LIMITED",
"PIONEER IRON & STEEL CORPN PVT LTD",
"PIONEER IT ASSOCIATES INDIA PRIVATE LIMITED.",
"PIONEER IT SOLUTIONS PRIVATE LIMITED",
"PIONEER JELLICE INDIA PRIVATE LIMITED",
"PIONEER LEATHER APPARELS EXPORT PRIVATE LIMITED",
"PIONEER LEDER TEX PRIVATE LIMITED",
"PIONEER LIFESCIENCES ENTERPRISES PRIVATE LIMITED",
"PIONEER LOGISTIC SOLUTIONZ PRIVATE LIMITED",
"PIONEER LOGISYS PRIVATE LIMITED",
"PIONEER MACHINES & AUTOMATION PRIVATE LIMITED",
"PIONEER MANAGEMENT CONSULTANT PRIVATE LIMITED",
"PIONEER MAX BUSINESS PVT. LTD.",
"PIONEER MEDILASERS PRIVATE LIMITED",
"PIONEER MILL STORES PRIVATE LIMITED",
"PIONEER MOBILE PRIVATE LIMITED",
"PIONEER MOTORS KANNUR PRIVATE LIMITED",
"PIONEER MOTOWORLD PRIVATE LIMITED",
"PIONEER NF FORGINGS INDIA PRIVATE LIMITED",
"PIONEER NON FRIED FOODS PRIVATE LIMITED",
"PIONEER NUTS AND BOLTS PRIVATE LIMITED",
"PIONEER OUTDOOR MEDIA SOLUTIONS PRIVATE LIMITED",
"PIONEER OVERSEAS PRIVATE LIMITED",
"PIONEER PACKAGERS PRIVATE LIMITED",
"PIONEER PACKAGING INDUSTRIES PRIVATE LIMITED",
"PIONEER PANEL PRODUCTS",
"PIONEER PAPER & STATIONERY PRIVATE LIMITED",
"PIONEER PERSONALIZED HOLIDAYS PRIVATE LIMITED",
"PIONEER PESTICIDES PRIVATE LIMITED",
"PIONEER PHARMACY DEGREE COLLEGE",
"PIONEER PLASTIC PRODUCT PRIVATE LIMITED",
"PIONEER POLLUTION CONTROL & AIR SYSTEMS PVT LTD",
"PIONEER POLYLEATHERS LIMITED",
"PIONEER POLYLEATHERS PRIVATE LIMITED",
"PIONEER POLYMERS PVT LTD.",
"PIONEER POLYPLAST PRIVATE LIMITED",
"PIONEER POLYTEX PRIVATE LIMITED",
"PIONEER POWER CORPORATION LIMITED",
"PIONEER POWER ENGINEERS LIMITED",
"PIONEER POWER LIMITED",
"PIONEER POWER SERVICE PRIVATE LIMITED",
"PIONEER POWER SYSTEMS PRIVATE LIMITED",
"PIONEER PRECAST SOLUTIONS PRIVATE LIMITED",
"PIONEER PRESS PRIVATE LIMITED",
"PIONEER PROFILES PRIVATE LIMITED",
"PIONEER PROPERTY MANAGEMENT LIMITED",
"PIONEER PROPERTY ZONE SERVICES PRIVATE LIMITED",
"PIONEER PUBLICITY CORPORATION PRIVATE LIMITED",
"PIONEER PULTRU-TECH ENGINEERING PRIVATE LIMITED",
"PIONEER RADIO TRAINING SERVICES PRIVATE LIMITED",
"PIONEER RAIL EQUIPMENTS PRIVATE LIMITED",
"PIONEER RESEARCH SOLUTIONS INDIA PRIVATE LIMITED",
"PIONEER RUBBER INDUSTRIES PRIVATE LIMITED",
"PIONEER RUBCHEM PRIVATE LIMITED",
"PIONEER SAILING SERVICES PRIVATE LIMITED",
"PIONEER SALES SERVICES & SPARES PRIVATE LIMITED",
"PIONEER SECURITIES PRIVATE LIMITED",
"PIONEER SECURITY AND ALLIED SERVICES PRIVATE LIMITED",
"PIONEER SECURITY SOLUTIONS PRIVATE LIMITED",
"PIONEER SILK MILLS PRIVATE LIMITED",
"PIONEER SMT TECHNOLOGIES PRIVATE LIMITED",
"PIONEER SPINNING AND WEAVING MILLS LIMITED",
"PIONEER STATIONERY PRIVATE LIMITED",
"PIONEER STEELS",
"PIONEER STRIPS LIMITED",
"PIONEER STRUCTCON PRIVATE LIMITED",
"PIONEER SUITINGS PRIVATE LIMITED",
"PIONEER SURFACE SOLUTIONS PRIVATE LIMITED",
"PIONEER SYNTEX PRIVATE. LIMITED.",
"PIONEER TCP STOCK BROKERS LIMITED",
"PIONEER TEA & EXPORTS LIMITED",
"PIONEER TECHNOLOGIES PRIVATE LIMITED",
"PIONEER TOWN PLANNERS PRIVATE LIMITED",
"PIONEER TUFF GLASS PRIVATE LIMITED",
"PIONEER URBAN LAND & INFRASTRUCTURE LIMITED",
"PIONEER WEALTH MANAGEMENT SERVICES LIMITED",
"PIONEER WELD AND WEAVES PRIVATE LIMITED",
"PIONEER WINCON ENERGY SYSTEMS PRIVATE LIMITED",
"PIONEER WOOW INDIA PRIVATE LIMITED",
"PIONEER WORLD SCHOOL",
"PIONEER XENERGY PRIVATE LIMITED",
"PIONEERVISION IMPEX PRIVATE LIMITED",
"PIONNIER ROOFING SOLUTIONS INDIA PRIVATE LIMITED",
"PIONNIER ROOFTILE INDIA PRIVATE LIMITED",
"PIONNIERCRETE INDIA PRIVATE LIMITED",
"PIOS MEDILINKS PRIVATE LIMITED",
"PIOTEX INDUSTRIES LIMITED",
"PIOTEX TEXTECH PRIVATE LIMITED",
"PIOTEX VENTURES PRIVATE LIMITED",
"PIOUS ENGINEERING PRIVATE LIMITED",
"PIOUS FASHION PRIVATE LIMITED",
"PIOUS FOODS (INDIA) PRIVATE LIMITED",
"PIOUS INFOTECH PRIVATE LIMITED",
"PIOUS LABORATORIES PRIVATE LIMITED",
"PIOUSECO PRIVATE LIMITED",
"PIOVAN INDIA PRIVATE LIMITED",
"PIP INDUSTRIES PRIVATE LIMITED",
"PIPA BELLA ACCESSORIES PRIVATE LIMITED",
"PIPAL CAPITAL MANAGEMENT PRIVATE LIMITED",
"PIPAL SOLARTHERM PRIVATE LIMITED",
"PIPAL TREE FOUNDATION",
"PIPAL TREE HOTELS PRIVATE LIMITED",
"PIPAL TREE SKILL VENTURES PRIVATE LIMITED",
"PIPAL TREE VENTURES PRIVATE LIMITED",
"PIPALART MEDIA SERVICES LLP",
"PIPALDA KHETIHAR AGRO PRODUCER COMPANY LIMITED",
"PIPALIA CABLES AND WIRES PRIVATE LIMITED",
"PIPARA & CO LLP",
"PIPARIA SYNTEX PRIVATE LIMITED",
"PIPARTODA RENEWABLE ENERGY PRIVATE LIMITED",
"PIPAVAV O AND M SERVICES PRIVATE LIMITED",
"PIPAVAV RAILWAY CORPORATION LIMITED",
"PIPE AND SECTIONS PRIVATE. LIMITED.",
"PIPE CORPORATION PRIVATE LIMITED",
"PIPE HANGERS & SUPPORTS PRIVATE LIMITED",
"PIPE MASTERS PRIVATE LIMITED",
"PIPECANDY TECHNOLOGIES PRIVATE LIMITED",
"PIPEFIT ENGINEERS PRIVATE LIMITED",
"PIPEFIT SOLUTION PRIVATE LIMITED",
"PIPELINE INFRASTRUCTURE LIMITED",
"PIPELINE MANAGEMENT SERVICES PRIVATE LIMITED",
"PIPELINE SOLUTIONS PRIVATE LIMITED",
"PIPERS CONSULTING INDIA PRIVATE LIMITED",
"PIPETECH ENGINEERING SOLUTION PRIVATE LIMITED",
"PIPE-TECH SERVICES PRIVATE LIMITED",
"PIPIL FREIGHT FORWARDING PRIVATE LIMITED",
"PIPIN FASHIONS AND RETAIL PRIVATE LIMITED",
"PIPING AND ENERGY PRODUCTS PRIVATE LIMITED",
"PIPING ROCK INDIA PRIVATE LIMITED",
"PIPLA SAFETY PRIVATE LIMITED",
"PIPODRA SYNTHETICS PVT LTD",
"PIPPEN HEALTHCARE (OPC) PRIVATE LIMITED",
"PIPPER BEVERAGES PRIVATE LIMITED",
"PIPPIN TECHNOLOGIES INDIA PRIVATE LIMITED",
"PIPRA SOLUTIONS PRIVATE LIMITED",
"PIPS CAPITALS PRIVATE LIMITED",
"PIQUOR TECHNOLOGIES PRIVATE LIMITED",
"PIR JEE TEXTILES PRIVATE LIMITED",
"PIR PANCHAL CONSTRUCTIONS PRIVATE LIMITED",
"PIR PROJECTS & CONSULTANCY PRIVATE LIMITED",
"PIRA SCIENTIFIC (OPC) PRIVATE LIMITED",
"PIRACHE CORDIALITY PRIVATE LIMITED",
"PIRAI INFOTECH PRIVATE LIMITED",
"PIRAMAL ALTERNATIVES PRIVATE LIMITED",
"PIRAMAL BIOTECH PRIVATE LIMITED",
"PIRAMAL CAPITAL & HOUSING FINANCE LIMITED",
"PIRAMAL CORPORATE SERVICES LIMITED",
"PIRAMAL CORPORATE SERVICES PRIVATE LIMITED",
"PIRAMAL ENTERPRISES LIMITED",
"PIRAMAL FINANCE SALES AND SERVICE PRIVATE LIMITED",
"PIRAMAL FOUNDATION",
"PIRAMAL FOUNDATION FOR EDU LEADERSHIP",
"PIRAMAL FUND MANAGEMENT PRIVATE LIMITED",
"PIRAMAL GLASS LIMITED",
"PIRAMAL INTERNATIONAL CONSULTANTS PRIVATE LIMITED",
"PIRAMAL LOGISTICS PRIVATE LIMITED",
"PIRAMAL METALS PRIVATE LIMITED",
"PIRAMAL NATURAL RESOURCES PRIVATE LIMITED",
"PIRAMAL NEXTGEN INDUSTRIES PRIVATE LIMITED",
"PIRAMAL PETROLEUM PRIVATE LIMITED",
"PIRAMAL PHARMA LIMITED",
"PIRAMAL REALTY PRIVATE LIMITED",
"PIRAMAL SONS PRIVATE LIMITED",
"PIRAMAL SUNTECK REALTY PRIVATE LIMITED",
"PIRAMAL SWASTHYA MANAGEMENT AND RESEARCH INSTITUTE",
"PIRAMAL SYSTEMS & TECHNOLOGIES PRIVATE LIMITED",
"PIRAMAL TRUSTEESHIP SERVICES PRIVATE LIMITED",
"PIRAMID FIBECOT PRIVATE LIMITED",
"PIRAMYD FABRICS PRIVATE LIMITED",
"PIRAMYD RETAIL AND MERCHANDISING PRIVATE LIMITED",
"PIRANHA DNV MARINE PRIVATE LIMITED",
"PIRANI STEELS PVT.LTD.",
"PIRELLI TYRE EUROPE S A",
"PIRELLI TYRESUISSE SA",
"PIRGAL CONSULTING PRIVATE LIMITED",
"PIRGORACHAND FOOD PROCESSING PRIVATE LIMITED",
"PIRHOALPHA RESEARCH PRIVATE LIMITED",
"PIRI ELECTROLS PRIVATE LIMITED",
"PIRI.AI PRIVATE LIMITED",
"PIRNAV SOFTWARE SOLUTIONS PRIVATE LIMITED",
"PIRON EDUCATION PRIVATE LIMITED",
"PIRUM MARKETPLACE PRIVATE LIMITED",
"PISCEAN RETAIL PRIVATE LIMITED",
"PISCES CARGO PRIVATE LIMITED",
"PISCES CONTAINER LINES INDIA PRIVATE LIMITED",
"PISCESER1 MARINE INFOTECH PRIVATE LIMITED",
"PISERVE TECHNOLOGIES PRIVATE LIMITED",
"PISHON INFRA PRIVATE LIMITED",
"PISON SUPPLY AND CONTRACTS PRIVATE LIMITED",
"PISTIS MANPOWER PRIVATE LIMITED",
"PISTO OIL AND FATS PRIVATE LIMITED",
"PISTOLPRINT STUDIOS PRIVATE LIMITED",
"PISTOS INTERIORS PRIVATE LIMITED",
"PIT SHOP PRIVATE LIMITED",
"PITAJI ZARDA WORKS PVT LTD",
"PITAMBAR CERELACS PRIVATE LIMITED",
"PITAMBAR COMMODITY FUTURES PRIVATE LIMITED",
"PITAMBAR FOOD PRODUCTS PRIVATE LIMITED",
"PITAMBAR PUBLISHING COMPANY PRIVATE LIMITED",
"PITAMBAR SOLVEX PRIVATE LIMITED",
"PITAMBARA BUILDSQUARE PRIVATE LIMITED",
"PITAMBARA COLD STORAGE PRIVATE LIMITED",
"PITAMBARA ISFS PRIVATE LIMITED",
"PITAMBARA PRIME CITY PRIVATE LIMITED",
"PITAMBARI PRODUCTS PRIVATE LIMITED",
"PITAMBER FLOUR MILLS PRIVATE LIMITED",
"PITAMBER METALFAB PRIVATE LIMITED",
"PITAMBER VYAPAAR PRIVATE LIMITED",
"PITAMBERA POLYMERS INDUSTRIES PRIVATE LIMITED",
"PITAMBRA HARDWARE AND METAL EXPORTS PRIVATE LIMITED",
"PITAMBRA IDEAL CONSTRUCTION PRIVATE LIMITED",
"PITANGENT ANALYTICS AND TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"PITAYA BRANDS SOURCING & RETAIL PRIVATE LIMITED",
"PITCHERS INTERNET PRIVATE LIMITED",
"PITCHMAN COMMUNICATIONS PRIVATE LIMITED",
"PITCO FOODS PRIVATE LIMITED",
"PITERION INDIA PRIVATE LIMITED",
"PITHADAI BUILDCON PRIVATE LIMITED",
"PITHADAI CONSTRUCTION PRIVATE LIMITED",
"PITHAMPUR AUTO CLUSTER",
"PITHAMPUR AUTO PRIVATE LIMITED",
"PITHAPUKURIA FP SCHOOL",
"PITISONS TOBACCO PRIVATE LIMITED",
"PITLIYA MARKETING PRIVATE LIMITED",
"PITNEY BOWES INDIA PRIVATE LIMITED",
"PITRACHAYA BUILDWELL DEVELOPERS PRIVATE LIMITED",
"PITRAKRAPA INDUSTRIES PRIVATE LIMITED",
"PITRASHISH MARKETING ENTERPRISES PRIVATE LIMITED",
"PITRODA FURNITURE PRIVATE LIMITED",
"PITTI CASTINGS PRIVATE LIMITED",
"PITTI ELECTRICAL EQUIPMENT PRIVATE LIMITED",
"PITTI ENGINEERING LIMITED",
"PITTIE CONSUMER PRIVATE LIMITED",
"PITTIE DISTRIBUTORS INDIA PRIVATE LIMITED",
"PITTIE INFRA PRIVATE LIMITED",
"PITTIE POLYMERS PRIVATE LIMITED",
"PITTIE REAL ESTATE PRIVATE LIMITED",
"PITZO INDIA PRIVATE LIMITED",
"PIVETA ESTATES PRIVATE. LIMITED.",
"PIVOT MULTIFAR INDUSTRIAL SERVICES LIMITED",
"PIVOTAL BIO RESEARCH PRIVATE LIMITED (OPC)",
"PIVOTAL ENTERPRISES PRIVATE LIMITED",
"PIVOTAL INFRASTRUCTURE PRIVATE LIMITED",
"PIVOTAL TRADING SERVICES PRIVATE LIMITED",
"PIVOTREE SOLUTIONS INDIA PRIVATE LIMITED",
"PIVOTRICS TECHNOLOGIES LLP",
"PIVOTROOTS DIGITAL PRIVATE LIMITED",
"PIVOX LABS PRIVATE LIMITED",
"PIX ROCK VFX PRIVATE LIMITED",
"PIX TRANSMISSIONS LIMITED",
"PIXADOO VISUALS PRIVATE LIMITED",
"PIXAGONS DIGITAL PRIVATE LIMITED",
"PIXALOT LABS PRIVATE LIMITED",
"PIXCELL E-MOBILITY PRIVATE LIMITED",
"PIXCELLENCE TECHNOLOGIES PRIVATE LIMITED",
"PIXEL 2 PRINT PRIVATE LIMITED",
"PIXEL COMMUNICATION SYSTEM PRIVATE LIMITED",
"PIXEL CONCEPTION TECHNOLOGIES PRIVATE LIMITED",
"PIXEL FILM RESTORE INDIA PRIVATE LIMITED",
"PIXEL FORCE PRIVATE LIMITED",
"PIXEL GALAXY STUDIO PRIVATE LIMITED",
"PIXEL IMAGE INDIA PRIVATE LIMITED",
"PIXEL INFORMATICS PRIVATE LIMITED",
"PIXEL INFOSOLUTIONS & TECHNOLOGIES PRIVATE LIMITED",
"PIXEL INFOTEK PRIVATE LIMITED",
"PIXEL LED PRIVATE LIMITED",
"PIXEL PLAST PVT LTD",
"PIXEL SOFTEK PRIVATE LIMITED",
"PIXEL STUDIOS PRIVATE LIMITED",
"PIXEL-D POST PRIVATE LIMITED",
"PIXELDO MEDIA PRIVATE LIMITED",
"PIXELEXPERT TECHNOLOGY AND SERVICES PRIVATE LIMITED",
"PIXELLD TECHNOLOGY PRIVATE LIMITED",
"PIXELLOGIC SOLUTIONS PRIVATE LIMITED",
"PIXELLOID STUDIOS PRIVATE LIMITED",
"PIXELS AND RES MULTIMEDIA DESIGN PRIVATE LIMITED",
"PIXELTECH SECURITY PRIVATE LIMITED",
"PIXELTEK GAMING SOLUTIONS PRIVATE LIMITED",
"PIXELTRACK DIGITAL PRIVATE LIMITED",
"PIXELVJ DIGITAL SOLUTIONS PRIVATE LIMITED",
"PIXEMO STUDIOS INDIA PRIVATE LIMITED",
"PIXENTIA SOLUTIONS INDIA PRIVATE LIMITED",
"PIXEOM INDIA PRIVATE LIMITED",
"PIXERIS POWER PRIVATE LIMITED",
"PIXETRON VIDEO DISPLAY SOLUTIONS PRIVATE LIMITED",
"PIXGRAMMER PREMEDIA PRIVATE LIMITED",
"PIXIE DREAMS PRIVATE LIMITED",
"PIXIELANES INDIA PRIVATE LIMITED",
"PIXILON SIGN AND DISPLAY PRIVATE LIMITED",
"PIXIMOVE STUDIOS PRIVATE LIMITED",
"PIXINT GRAPHICS PRIVATE LIMITED",
"PIXLOGIX INFOTECH PRIVATE LIMITED",
"PIXLOR DIGITAL DESIGN AGENCY",
"PIXON GREEN ENERGY PRIVATE LIMITED",
"PIXSTONE IMAGES PRIVATE LIMITED",
"PIXSTORY INTERFACE NETWORK & IT PRIVATE LIMITED",
"PIXTECH LABS PRIVATE LIMITED",
"PIXTELLATION SOLUTIONS PRIVATE LIMITED",
"PIXTOP MEDIA SOLUTIONS PRIVATE LIMITED",
"PIXXELSPACE INDIA PRIVATE LIMITED",
"PIXXY ETAIL SOLUTIONS PRIVATE LIMITED",
"PIXY MARKETING PRIVATE LIMITED",
"PIYA FACILITY MANAGEMENT PRIVATE LIMITED",
"PIYANI CREATION PRIVATE LIMITED",
"PIYANSHU CHEMICALS PRIVATE LIMITED",
"PIYARE LAL HARI SINGH BUILDERS PRIVATE LIMITED",
"PIYU CHEM IMPEX PRIVATE LIMITED",
"PIYUSH AND ASSOCIATES PRIVATE LIMITED",
"PIYUSH CREFINVEST PRIVATE LIMITED",
"PIYUSH DISTRIBUTORS PRIVATE LIMITED",
"PIYUSH ELECTROMAC PRIVATE LIMITED",
"PIYUSH ENGINEERING COMPANY PRIVATE LIMITED",
"PIYUSH FABRICATORS PRIVATE LIMITED",
"PIYUSH FABRICS PRIVATE LIMITED",
"PIYUSH IMPEX PRIVATE LIMITED",
"PIYUSH INDUSTRIES PRIVATE LIMITED",
"PIYUSH INFRATECH PRIVATE LIMITED",
"PIYUSH LIFESPACES PRIVATE LIMITED",
"PIYUSH PARAKH ENTERPRISES PRIVATE LIMITED",
"PIYUSH PHARMACHEM (INDIA) PRIVATE LIMITED",
"PIYUSH PLASTO CHEMS PRIVATE LIMITED",
"PIYUSH PLYBOARDS PVT LTD",
"PIYUSH POLYMERS PRIVATE LIMITED",
"PIYUSH POLYTEX INDUSTRIES PVT LTD",
"PIYUSH SECURITIES PVT LTD",
"PIYUSH SMART TRADERS AND DEVELOPERS PRIVATE. LIMITED",
"PIYUSH SUGAR AND POWER PRIVATE LIMITED",
"PIYUSH TRADES & CREDITS PVT. LTD.",
"PIYUTEX SYNFAB (INDIA) PRIVATE LIMITED",
"PIZONE INFOTECH SOLUTION PRIVATE LIMITED",
"PIZZAGRAM",
"PIZZELASO CREATIVES PRIVATE LIMITED",
"PIZZERIA FAST FOODS RESTAURANTS MADRAS PRIVATE LIMITED",
"PJ EDUCATION SERVICES PRIVATE LIMITED",
"PJ FAB INDIA STRUCTURES PRIVATE LIMITED",
"PJ MARGO PRIVATE LIMITED",
"PJ MINARALS INTERNATIONAL PVT LTD",
"PJ RESEARCH AND CONSULTING SERVICES PRIVATE LIMITED",
"PJ SECURITIES PRIVATE LIMITED",
"PJ VALVES MANUFACTURING PRIVATE LIMITED",
"PJ VENTURES (INDIA) PRIVATE LIMITED",
"PJ WEALTH MANAGEMENT AND CONSULTANT PRIVATE LIMITED",
"PJD PROJECTS & INFRASTRUCTURE PRIVATE LIMITED",
"PJD PROPERTIES AND INVESTMENTS PRIVATE LIMITED",
"PJL CLOTHING INDIA LIMITED",
"PJP TAILORSMART SERVICES PRIVATE LIMITED",
"PJPA REALITY PRIVATE LIMITED",
"PJR CDM INDIA PRIVATE LIMITED",
"PJR PROJECT CONSTRUCTIONS PRIVATE LIMITED",
"PJS OVERSEAS LIMITED",
"PJTJ TECHNOLOGIES PRIVATE LIMITED",
"PK & PK JEWELLERS PRIVATE LIMITED",
"PK AGRITECH PRIVATE LIMITED",
"PK CORPORATE SOLUTIONS PRIVATE LIMITED",
"PK FRP INDIA PRIVATE LIMITED",
"PK GLOBAL AUTOELECTRO PRIVATE LIMITED",
"PK MINERALS PRIVATE LIMITED",
"PK ONLINE VENTURES PRIVATE LIMITED",
"PK SECURITY SERVICES PRIVATE LIMITED",
"PK UNIQUE PROJECTS PRIVATE LIMITED",
"PKB INDIA PRIVATE LIMITED",
"PKB PROJECTS PRIVATE LIMITED",
"PKD OVERSEAS PRIVATE LIMITED",
"PKF FINANCE LIMITED",
"PKF O'CONNOR DAVIES INDIA PRIVATE LIMITED",
"PKF PROSERV PRIVATE LIMITED",
"PKF PROSLV PTV LIMITED",
"PKF SRIDHAR & SANTHANAM LLP",
"PKG ESTATES PRIVATE LIMITED",
"PKG FINANCERS PRIVATE LIMITED",
"PKG FINSTOCK PRIVATE LIMITED",
"PKH VENTURES LIMITED",
"PKL LIMITED",
"PKM DEZIGN2 BUILD PRIVATE LIMITED",
"PKM EXPORTS PRIVATE LIMITED",
"PKM FINEFOODSANDSPICES PRIVATE LIMITED",
"PKM METAL BUILDING COMPANY PRIVATE LIMITED",
"PKMCO CONSTRUCTIONS PRIVATE LIMITED",
"PKN MOTORS PRIVATE LIMITED",
"PKNAVRATANA AGRITECH PRIVATE LIMITED",
"PKP BUILDCON PRIVATE LIMITED",
"PKP FOREX INDIA PRIVATE LIMITED",
"PKR EQUIPMENTS PRIVATE LIMITED",
"PKRG SURGICAL MALL (OPC) PRIVATE LIMITED",
"PKRK ENTERPRISES PRIVATE LIMITED",
"PKS CONCLAVE PRIVATE LIMITED",
"PKS EXPORT PRIVATE LIMITED",
"PKS HOUSING AND DEVELOPERS PRIVATE LIMITED",
"PKS TECHNOBUILD PRIVATE LIMITED",
"PKV CONSULTING ENGINEERS PRIVATE LIMITED",
"PKV INFRATECH (OPC) PRIVATE LIMITED",
"PKV REFRACTORY PRIVATE LIMITED",
"PL AGRO TECHNOLOGIES LIMITED",
"PL BUILDING SOLUTIONS PRIVATE LIMITED",
"PL CAPITAL MARKETS PRIVATE LIMITED",
"PL CONTAINERS PRIVATE LIMITED",
"PL DISTRIBUTION COMPANY PRIVATE LIMITED",
"PL ENGINEERING LIMITED",
"PL SOLAR RENEWABLE LIMITED",
"PL SUNRAYS POWER LIMITED",
"PL SURYA VIDYUT LIMITED",
"PL TOUR FAIRY PRIVATE LIMITED",
"PL WORLDWAYS LIMITED",
"PLA ELECTRO APPLIANCES PVT LTD",
"PLA FOODS PRIVATE LIMITED",
"PLA MATELS INDIA PRIVATE LIMITED",
"PLABS VENTURES PRIVATE LIMITED",
"PLACAB AND AGENCIES PRIVATE LIMITED",
"PLACEBO FABTECH PRIVATE LIMITED",
"PLACEMINDS CONSULTING PRIVATE LIMITED",
"PLACENET CONSULTANTS PRIVATE LIMITED",
"PLACERO INTERNATIONAL PRIVATE LIMITED",
"PLACEWELL INDUSTRIAL SERVICES PRIVATE. LIMITED.",
"PLACEWELL JOBS PRIVATE LIMITED",
"PLACEWELL SYSTEMS AND SOLUTIONS PRIVATE LIMITED",
"PLACID LIMITED",
"PLACID PHARMACHEM PRIVATE LIMITED",
"PLACIDUS PHARMA PRIVATE LIMITED",
"PLACKA INSTRUMENTS INDIA PRIVATE LIMITED",
"PLADA INFOTECH SERVICES LIMITED",
"PLADA INFOTECH SERVICES PRIVATE LIMITED",
"PLADA SERVICES & MANAGEMENT PRIVATE LIMITED",
"PLAEUP PRIVATE LIMITED",
"PLAKKATTU GRANITE INDUSTRIES PVT LTD",
"PLAKSHA INDUSTRIES PRIVATE LIMITED",
"PLAMA PLASTICS LIMITED",
"PLAMACH TURNKEYS LIMITED",
"PLAMET TRADING PRIVATE LIMITED",
"PLAMU COMMERCIALS PRIVATE LIMITED",
"PLAN AHEAD WEALTH ADVISORS PRIVATE LIMITED",
"PLAN INDO TOURS PRIVATE LIMITED",
"PLAN INTERNATIONAL INC",
"PLAN ISLAND TRAVEL PRIVATE LIMITED",
"PLAN JOURNEYS PRIVATE LIMITED",
"PLAN REALTECH INFRA PRIVATE LIMITED",
"PLAN SEEDS PRIVATE LIMITED",
"PLAN TREE STRATEGIES PRIVATE LIMITED",
"PLAN Z DIGITAL PRIVATE LIMITED",
"PLAN2EXECUTE INDIA PRIVATE LIMITED",
"PLAN-A DESIGNTEC SOLUTIONS PRIVATE LIMITED",
"PLANAFIN TECHNOLOGIES PRIVATE LIMITED",
"PLANARIND ONLINE SERVICES INDIA PRIVATE LIMITED",
"PLANCESS EDUSOLUTIONS PRIVATE LIMITED",
"PLANCO ENTERPRISES PRIVATE LIMITED",
"PLANEDGE CONSULTANTS PRIVATE LIMITED",
"PLANERA ENTERPRISES PRIVATE LIMITED",
"PLANET 41 MOBI-VENTURE LIMITED",
"PLANET 9 CONSULTING",
"PLANET AGENCIES PRIVATE LIMITED",
"PLANET AUTOMOTIVE PRIVATE LIMITED",
"PLANET BUSINESS SUPPORT SERVICES INDIA PRIVATE LIMITED",
"PLANET CARE LINKERZ PRIVATE LIMITED",
"PLANET CERAMICA PRIVATE LIMITED",
"PLANET CLOTHING PRIVATE LIMITED",
"PLANET DEZIGN INDIA PRIVATE LIMITED",
"PLANET EARTH DESTINATION MANAGEMENT COMPANY PRIVATE LIMITED",
"PLANET E-COM SOLUTIONS P LIMITED",
"PLANET EDU EXAMS PRIVATE LIMITED",
"PLANET EDU PRIVATE LIMITED",
"PLANET EDUCATION LLP",
"PLANET ENERGY TECHNOLOGIES PRIVATE LIMITED",
"PLANET EXPLORER PRIVATE LIMITED",
"PLANET EXPRESS INNOVATIONS PRIVATE LIMITED",
"PLANET FACILITIES MANAGEMENT SERVICES INDIA PRIVATE LIMITED",
"PLANET GARMENTS PRIVATE LIMITED",
"PLANET GREEN RECYCLING PRIVATE LIMITED",
"PLANET HERBS LIFESCIENCES PRIVATE LIMITED",
"PLANET HOLLYWOOD INDIA PRIVATE LIMITED",
"PLANET HOME DECORE PRIVATE LIMITED",
"PLANET I REALTY",
"PLANET INDIA REMEDIES PRIVATE LIMITED PART.IX",
"PLANET INFRAPROMOTERS PRIVATE LIMITED",
"PLANET INFRASTRUCTURE MANAGEMENT PRIVATE LIMITED",
"PLANET INTERACTIVE PRIVATE LIMITED",
"PLANET JEWELS PRIVATE LIMITED",
"PLANET MARATHI SELLER SERVICES PRIVATE LIMITED",
"PLANET NEXTGEN TECHNOLOGIES INDIA PRIVATE LIMITED",
"PLANET NUTRITION PRIVATE LIMITED",
"PLANET PCI INFOTECH LIMITED",
"PLANET PEOPLE AND PROFIT CONSULTING PRIVATE LIMITED",
"PLANET PHARMA WAREHOUSE PRIVATE LIMITED",
"PLANET POWER TOOLS PRIVATE LIMITED",
"PLANET PRODUCTION SERVICES PRIVATE LIMITED",
"PLANET PURE IMPEX PRIVATE LIMITED",
"PLANET RESIDENCY PRIVATE LIMITED",
"PLANET RETAIL HOLDINGS PRIVATE LIMITED",
"PLANET SCUBA INDIA PRIVATE LIMITED",
"PLANET SPINNING MILLS PRIVATE LIMITED",
"PLANET SUPPORT SERVICES INDIA PRIVATE LIMITED",
"PLANET SYNERGY INFOTECH PRIVATE LIMITED",
"PLANET TRADE WINGS PRIVATE LIMITED",
"PLANET TRADELINK PRIVATE LIMITED",
"PLANET TRADERS LIMITED.",
"PLANET VYAPAAR PRIVATE LIMITED",
"PLANET WATER INDIA FOUNDATION",
"PLANET WATER INDIA PRIVATE LIMITED",
"PLANET WEB SOLUTIONS PRIVATE LIMITED",
"PLANET WHEELS PRIVATE LIMITED",
"PLANETCAST MEDIA SERVICES LIMITED",
"PLANETGREEN OUTDOOR SOLUTIONS PRIVATE LIMITED",
"PLANETGREEN TEA PRIVATE LIMITED",
"PLANETRON ELECTRONICS PRIVATE LIMITED",
"PLANETSAFFRON .COM INDIA PRIVATE LIMITED",
"PLANETSURF CREATIONS PRIVATE LIMITED",
"PLANETTO TOOLTECH PRIVATE LIMITED",
"PLANFIRMA TECHNOLOGIES PRIVATE LIMITED",
"PLANFUL SOFTWARE INDIA PRIVATE LIMITED",
"PLANICAL ENGINEERS PRIVATE LIMITED",
"PLANIFY CAPITAL LIMITED",
"PLANIFY ENTERPRISES PRIVATE LIMITED",
"PLANIT DESIGN PRIVATE LIMITED",
"PLANIT TESTING INDIA PRIVATE LIMITED",
"PLANIT TRAVGLOBAL PRIVATE LIMITED",
"PLANK AND WEAVE RETAIL PRIVATE LIMITED",
"PLANMAIN QUALITY CONSULTANTS (INDIA) PRIVATE LIMITED",
"PLANMAN CONSULTING INDIA PRIVATE LIMITED",
"PLANNED SOCIAL CONCERN",
"PLANNERS ADVERTISING PRIVATE LIMITED",
"PLANNERS GROUP PRIVATE LIMITED",
"PLANNET TECHNEST INDIA PRIVATE LIMITED",
"PLANNET TECHNEST SOUTH INDIA PRIVATE LIMITED",
"PLANNING AND INFRASTRUCTURAL DEVELOPMENT CONSULTANTS PRIVATE LIMITED",
"PLANNING DEPTT YOJNA BHAWAN",
"PLANNING ECONOMICS AND STATISTICS DEPARTMENT",
"PLANODRIVES ASIA PRIVATE LIMITED",
"PLANON SOFTWARE SERVICES PRIVATE LIMITED",
"PLANOTECH EVENTS AND MARKETING (OPC) PRIVATE LIMITED",
"PLANSEE INDIA HIGH PERFORMANCE MATERIALS PRIVATE LIMITED",
"PLANSOURCE INDIA OPERATIONS PRIVATE LIMITED",
"PLANSWELL PROFESSIONALS PRIVATE LIMITED",
"PLANT 2 PC ENGINEERING SOLUTIONS PRIVATE LIMITED",
"PLANT ENGINEERING AND GEOMATIC SERVICES PRIVATE LIMITED",
"PLANT HEALTH BIOTECHNOLOGIES PRIVATE LIMITED",
"PLANT LIPIDS PRIVATE LIMITED",
"PLANT PROTECTION OFFICE",
"PLANT REMEDIES PRIVATE LIMITED",
"PLANT SUPERVISION INDIA PRIVATE LIMITED",
"PLANT TECH INDUSTRIAL SERVICES LIMITED",
"PLANTAG COATINGS INDIA PRIVATE LIMITED",
"PLANTECH CONSULTNATS PRIVATE LIMITED",
"PLANTECH MEDICAL SYSTEMS PVT LTD",
"PLANTERS AIRWAYS LTD",
"PLANTETOID AGRO PRODUCTS PRIVATE LIMITED",
"PLANTEX E-COMMERCE PRIVATE LIMITED",
"PLANTEX FLAVOURS PRIVATE LIMITED",
"PLANTGENE BIOLOGICALS PRIVATE LIMITED",
"PLANTGENE SEEDS PRIVATE LIMITED",
"PLANTINFOTECH SOFTWARE PRIVATE LIMITED",
"PLANTIX AGRITECH INDIA PRIVATE LIMITED",
"PLANTRICH AGRI TECH PRIVATE LIMITED",
"PLANTRONICS INDIA PRIVATE LIMITED",
"PLANTS MED LABORATORIES PRIVATE LIMITED",
"PLANTSMANS FARM FRESH PRIVATE LIMITED",
"PLANWEY GLOBAL SERVICES PRIVATE LIMITED",
"PLANYS TECHNOLOGIES PRIVATE LIMITED",
"PLASCARE INDUSTRIES PRIVATE LIMITED",
"PLASMA ALLOYS PRIVATE LIMITED",
"PLASMA BIOTAL INDIA PRIVATE LIMITED",
"PLASMA COMMERCIALS PRIVATE LIMITED",
"PLASMA ELASTICS PVT LTD",
"PLASMA ENTERPRISES (INDIA) PRIVATE LIMITED",
"PLASMA HEALTHCHEK DIAGNOSTICS PRIVATE LIMITED",
"PLASMA INDUCTION (INDIA) PRIVATE LIMITED",
"PLASMA METAL PROCESSING PRIVATE LIMITED",
"PLASMA SOFTECH PRIVATE LIMITED",
"PLASMAGEN BIOSCIENCES PRIVATE LIMITED",
"PLASMAVAC PRIVATE LIMITED",
"PLASMEC ENGINEERING PRIVATE LIMITED",
"PLASMIX PRIVATE LIMITED",
"PLASMOS MEDAIDS PRIVATE LIMITED",
"PLASMOTEC AUTOMOTIVE PRIVATE LIMITED",
"PLASOPAN ENGINEERS INDIA PRIVATE LIMITED",
"PLASPACK SYNTHETICS PRIVATE LIMITED",
"PLASSER INDIA PRIVATE LIMITED",
"PLASSEY TECHNOLOGIES PRIVATE LIMITED",
"PLASSO PLASTIC INDUSTRIES PRIVATE LIMITED",
"PLAST ALLOYS (INDIA) LIMITED",
"PLAST INDIA PACKAGING PRIVATE LIMITED",
"PLASTCOM PRODUCTS PRIVATE LIMITED",
"PLASTECH AUXIQUIP PRIVATE LIMITED",
"PLASTECH FORMWORK SYSTEMS PRIVATE LIMITED",
"PLASTECH INTERNATIONAL PRIVATE LIMITED",
"PLASTEK INNOVATIONS PRIVATE LIMITED",
"PLASTENE FLEXIBLES LIMITED",
"PLASTENE INDIA LIMITED",
"PLASTENE POLYFILMS LIMITED",
"PLASTEX PRODUCTS PRIVATE LIMITED",
"PLASTI LAMI COATS PVT LTD",
"PLASTI SURGE INDUSTRIES PVT LTD",
"PLASTI WEAVE INDUSTRIES",
"PLASTIBLENDS INDIA LIMITED",
"PLASTIC INGENUITIES INDIA PRIVATE LIMITED",
"PLASTIC OMNIUM AUTO EXTERIORS (INDIA) PRIVATE LIMITED",
"PLASTIC OMNIUM AUTO INERGY INDIA PRIVATE LIMITED",
"PLASTIC OMNIUM AUTO INERGY MANUFACTURING INDIA PRIVATE LIMITED",
"PLASTIC PACKAGING INDUSTRIES PRIVATE LIMITED",
"PLASTIC PIGMENT PRIVATE LIMITED",
"PLASTICON TECHNOLOGIES PRIVATE.LIMITED",
"PLASTICS CAPITAL INDIA PRIVATE LIMITED",
"PLASTIN INDUSTRIES PRIVATE LIMITED",
"PLASTIVISION INNOVATION PRIVATE LIMITED",
"PLASTMOULD AUTO ANCILLARIES PRIVATE LIMITED",
"PLASTMOULD CONTAINERS AND PACKAGING SOLUTIONS PRIVATE LIMITED",
"PLASTO CARDS PRIVATE LIMITED",
"PLASTO COLOUR PLUS PRIVATE LIMITED",
"PLASTO CRAFTS INDUSTRIES PRIVATE LIMITED",
"PLASTO ELTRONICS PRIVATE LIMITED",
"PLASTO FAB PRIVATE LIMITED",
"PLASTO INDIA PRIVATE LIMITED",
"PLASTO MOULDERS PRIVATE LIMITED",
"PLASTO PIPES PVT LTD",
"PLASTOCHEM FABRICATION (INDIA) PRIVATE LIMITED",
"PLASTOCHEM INDIA PRIVATE LIMITED",
"PLASTOCHEM PVT LTD",
"PLASTOCON INDUSTRIES PRIVATE LIMITED",
"PLASTOCRAFT SANITARY INDIA PRIVATE LIMITED",
"PLASTOMEN PIPINGS PRIVATE LIMITED",
"PLASTOMETAL ENGINEERING PRIVATE LIMITED",
"PLASTONE UPVC PROFILES PRIVATE LIMITED",
"PLASTO-PACK (INDIA) PVT LTD",
"PLASTOWORLD INDIA PRIVATE LIMITED",
"PLASTRULON PROCESSORS PRIVATE LIMITED",
"PLASTSCAPES OVERSEAS PRIVATE LIMITED",
"PLASTX LABS PRIVATE LIMITED",
"PLAT 5 CONSULTANCY PRIVATE LIMITED",
"PLATANISTA GAMES PRIVATE LIMITED",
"PLATFORM 3 TECHNOLOGIES PRIVATE LIMITED",
"PLATFORM COMMONS SERVICES PRIVATE LIMITED",
"PLATFORM TIRANGA PRIVATE LIMITED",
"PLATFORM9 SYSTEMS INDIA PRIVATE LIMITED",
"PLATFORMATORY LABS PRIVATE LIMITED",
"PLATFORMPLAY MEDIA VENTURES PRIVATE LIMITED",
"PLATI INDIA PRIVATE LIMITED",
"PLATINA BUSINESS MANAGEMENT PRIVATE LIMITED",
"PLATINA HOSPITAL PRIVATE LIMITED",
"PLATINA IMPEX PRIVATE LIMITED",
"PLATINA INFRASERVICES PRIVATE LIMITED",
"PLATINA OIL FIELD PRIVATE LIMITED",
"PLATINA REAL ESTATE PRIVATE. LIMITED.",
"PLATINA VITRIFIED PRIVATE LIMITED",
"PLATINAA INDUSTRIAL CERAMICS PRIVATE LIMITED",
"PLATINEX DB VALVES INDIA PRIVATE LIMITED",
"PLATING SHEEN CHEM (INDIA) PRIVATE LIMITED",
"PLATINIUM TIE-UP PRIVATE LIMITED",
"PLATINO CARS INDIA PRIVATE LIMITED",
"PLATINO CLASSIC MOTORS PRIVATE LIMITED",
"PLATINUM AAC BLOCKS PRIVATE LIMITED",
"PLATINUM ADVERTISING PRIVATE LIMITED",
"PLATINUM ALLOYS PRIVATE LIMITED",
"PLATINUM AUTO COMPONENTS PRIVATE LIMITED",
"PLATINUM AUTOMOBILES PRIVATE LIMITED",
"PLATINUM CEMENTS PRIVATE LIMITED",
"PLATINUM CERAMIC PRIVATE LIMITED",
"PLATINUM COMMUNICATIONS PRIVATE LIMITED",
"PLATINUM CREATIONS PRIVATE LIMITED",
"PLATINUM DIGITAL SOLUTIONS PRIVATE LIMITED",
"PLATINUM EXIM PRIVATE LIMITED",
"PLATINUM EXPORTS PRIVATE LIMITED",
"PLATINUM FABRICS PRIVATE LIMITED",
"PLATINUM FASHION APPAREL PRIVATE LIMITED",
"PLATINUM FINLEASING AND INFRA DEVELOPMENT PRIVATE LIMITED",
"PLATINUM FOREX PRIVATE LIMITED",
"PLATINUM GLOBAL ADDITIVES PRIVATE LIMITED",
"PLATINUM GUILD INDIA PRIVATE LIMITED",
"PLATINUM HOLDINGS PRIVATE LIMITED",
"PLATINUM HOSPITALS MULUND",
"PLATINUM HOSPITALS PRIVATE LIMITED",
"PLATINUM INCENTIVES AND EVENTS PRIVATE LIMITED",
"PLATINUM INDUSTRIES LIMITED",
"PLATINUM INFRADEVELOPMENT PRIVATE LIMITED",
"PLATINUM JUBILEE HIGH SCHOOL",
"PLATINUM LOGISTICS SOLUTIONS INDIA PRIVATE LIMITED",
"PLATINUM MALL PRIVATE LIMITED",
"PLATINUM MANAGEMENT SOLUTION PRIVATE LIMITED",
"PLATINUM MOTOCORP LLP",
"PLATINUM OVERSEAS PVT.LTD.",
"PLATINUM PAINTING ESSENTIALS & TRADING PRIVATE LIMITED",
"PLATINUM POLYMERS PRIVATE LIMITED",
"PLATINUM POLYPLAST PRIVATE LIMITED",
"PLATINUM PORTFOLIO FUND PVT LTD",
"PLATINUM PROJECTS AND ENGINEERS PRIVATE LIMITED",
"PLATINUM REFINERIES PRIVATE LIMITED",
"PLATINUM RENT A CAR INDIA PRIVATE LIMITED",
"PLATINUM RUBBERS PRIVATE LIMITED",
"PLATINUM SERVICES PRIVATE LIMITED",
"PLATINUM SMART TECH INDIA PRIVATE LIMITED",
"PLATINUM SOLAR PRIVATE LIMITED",
"PLATINUM STONES PRIVATE LIMITED",
"PLATINUM TEXTILES LIMITED",
"PLATINUM WORLD HOSPITALITY PRIVATE LIMITED",
"PLATINUMCORP SHELTORS PRIVATE LIMITED",
"PLATINUMCORP SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"PLATINUMONE BUSINESS SERVICES LIMITED",
"PLATINUMONE INSURANCE BROKING PRIVATE LIMITED",
"PLATINUMONE LEARNING SOLUTIONS PRIVATE LIMITED",
"PLATINUMVIEW HOME SOLUTION PRIVATE LIMITED",
"PLATINUS TECHNOLOGIES PRIVATE LIMITED",
"PLATO INDUSTRIES LIMITED",
"PLATONIC LIFESTYLE PRIVATE LIMITED",
"PLATOON SECURITAS PRIVATE LIMITED",
"PLATTER FOODS PRIVATE LIMITED",
"PLATTER HOSPITALITY PRIVATE LIMITED",
"PLAXONIC TECHNOLOGIES PRIVATE LIMITED",
"PLAY CLUB SP GARMENTS PRIVATE LIMITED",
"PLAY GAMES24X7 PRIVATE LIMITED",
"PLAY HARD PRODUCTIONS OPC PRIVATE LIMITED",
"PLAY PLANET INDIA PRIVATE LIMITED",
"PLAY SPORTS SURFACES & RECREATIONAL SOLUTIONS PRIVATE LIMITED",
"PLAY TIME MEDIA INDIA PRIVATE LIMITED",
"PLAYER X MOBILE ENTERTAINMENT INDIA PRIVATE LIMITED",
"PLAYERZPOT MEDIA PRIVATE LIMITED",
"PLAYEVEN INFO PRIVATE LIMITED",
"PLAY-FAIR CAPITAL AND INVESTMENT PRIVATE LIMITED",
"PLAYFUL MINDS ENRICHMENT LIMITED",
"PLAYGRO TOYS INDIA PRIVATE LIMITED",
"PLAYIN GAMES TECHNOLOGIES PRIVATE LIMITED",
"PLAYOTEL PREMIER HOTEL",
"PLAYOTEL PREMIER VIJAY NAGAR",
"PLAYPOWER LABS PRIVATE LIMITED",
"PLAYSIMPLE GAMES PRIVATE LIMITED",
"PLAYTONIA ESPORTS PRIVATE LIMITED",
"PLAYTOR LIFESPACES PRIVATE LIMITED",
"PLAYWELL IMPEX PRIVATE LIMITED",
"PLAZA AGENCIES PRIVATE LIMITED",
"PLAZA CABLE ELECTRIC PRIVATE LIMITED",
"PLAZA ELECTRICAL PRODUCTS PRIVATE LIMITED",
"PLAZA GENERAL ENGINEERS AND CONTRACTORS PRIVATE LIMITED",
"PLAZA KITCHENWARES PRIVATE LIMITED",
"PLAZA PAINTS PVT.LTD.",
"PLAZA POWER AND INFRASTRUCTURE COMPANY",
"PLAZA PROPERTIES LIMITED",
"PLAZA REALTY PRIVATE LIMITED",
"PLAZA TEX INDIA PRIVATE. LIMITED. PTIPL",
"PLAZA WIRES LIMITED",
"PLAZA WIRES PRIVATE LIMITED",
"PLAZMA GRANITO PRIVATE LIMITED",
"PLAZMA TECHNOLOGIES PRIVATE LIMITED",
"PLB DEVELOPERS CONSULTANTS PRIVATE LIMITED",
"PLB INVESTMENTS PVT LTD",
"PLEASANT FOODS PRIVATE LIMITED",
"PLEASANT LOGISTIC PRIVATE LIMITED",
"PLEASANT NIRMAN PRIVATE LIMITED",
"PLEASANT NIRYAT PVT LTD",
"PLEASANT PHARMACEUTICALS PRIVATE LIMITED",
"PLEASE SEE ADVERTISING PRIVATE LIMITED",
"PLEASENT SMILE DENTAL CLINIC",
"PLEASURE HOTELS PRIVATE LIMITED",
"PLEASURE SKETCH HOLIDAYS PRIVATE LIMITED",
"PLEASURE TRIP PRIVATE LIMITED",
"PLEBGRAPH FINANCE PRIVATE LIMITED",
"PLEIADES THERAPEUTICS PRIVATE LIMITED",
"PLENCO CLOSURES PRIVATE LIMITED",
"PLENITUDE BUSINESS PRIVATE LIMITED",
"PLENITUDE FINSERVE PRIVATE LIMITED",
"PLENTEOUS PHARMACEUTICALS LIMITED",
"PLENTIFUEL INDUSTRIES PRIVATE LIMITED",
"PLENTOS VENTURES PRIVATE LIMITED",
"PLENTY PLASTICS PRIVATE LIMITED",
"PLENTYVALLEY PROPERTIES PRIVATE LIMITED",
"PLENUM BIOTECH PRIVATE LIMITED",
"PLENUM NETWORKS LIMITED",
"PLENUM TECH PRIVATE LIMITED",
"PLENUS GLOBAL LOGISTICS SOLUTIONS PRIVATE LIMITED",
"PLETHICO LABORATORIES PRIVATE LIMITED",
"PLETHORA IT & HR SOLUTIONS",
"PLEX SYSTEMS PRIVATE LIMITED",
"PLEXASYS SOLUTIONS PRIVATE LIMITED",
"PLEXITECH SOLUTIONS LLP",
"PLEXO LUBRICANTS PRIVATE LIMITED",
"PLEXONICS TECHNOLOGIES LIMITED",
"PLEXUS CONSTRUCTIONS & ENGINEERING PRIVATE LIMITED",
"PLEXUS PROFESSIONALS NETWORK PRIVATE LIMITED",
"PLEXUS TECHAUDIT PRIVATE LIMITED",
"PLEXWARE AUTOMATIONS PRIVATE LIMITED",
"PLG PHARMACEUTICALS PRIVATE LIMITED",
"PLG PHOTOVOLTAIC PRIVATE LIMITED",
"PLICA INDIA PRIVATE LIMITED",
"PLIME AGRO INDUSTRIES LIMITED",
"P-LINE ELECTRICAL PRIVATE LIMITED",
"PLINNTH BIM & CONSTRUCTION TECHNOLOGY CONSULTANTS PRIVATE LIMITED",
"PLINTHSTONE REMA REALTORS PRIVATE LIMITED",
"PLINTRON MOBILITY SOLUTIONS PRIVATE LIMITED",
"PLIOGRIP RESINS AND CHEMICALS PRIVATE LIMITED",
"PLIROFORIES TECHNOLOGIES PRIVATE LIMITED",
"PLIVO COMMUNICATIONS PRIVATE LIMITED",
"PLK PROPERTIES PRIVATE LIMITED",
"PLL ENTERPRISE PRIVATE LIMITED",
"PLLAZIO HOTELS AND RESORTS PRIVATE. LIMITED.",
"PLLUM LEGNO PRIVATE LIMITED",
"PLM BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"PLM INDISHTECH PRIVATE LIMITED",
"PLM NORDIC TECH PRIVATE LIMITED",
"PLN CONSTRUCTION LIMITED",
"PLN SILKS PRIVATE LIMITED",
"PLOBAL TECH PRIVATE LIMITED",
"PLOCICA CERAMICS PRIVATE LIMITED",
"PLOTSQUARE INFRA DEVELOPER PRIVATE LIMITED",
"PLOTTORACE MARKETING PRIVATE LIMITED",
"PLOUGHMAN AGRO PRIVATE LIMITED",
"PLOUTOS QUANT RESEARCH CAPITAL PRIVATE LIMITED",
"PLOUTUS ADVISORS INDIA PRIVATE LIMITED",
"PLOXIM WEB SOLUTIONS OPC PRIVATE LIMITED",
"PLR FOODS PRIVATE LIMITED",
"PLR PROJECTS PRIVATE LIMITED",
"PLR SYSTEMS PRIVATE LIMITED",
"PLS ENORME PRIVATE LIMITED",
"PLS LAWYERS PRIVATE LIMITED",
"PLT INDUSTRIES PRIVATE LIMITED",
"PLUC NETWORK PRIVATE LIMITED",
"PLUCDIAM INDIA PRIVATE LIMITED",
"PLUCHI TEXNIT PRIVATE LIMITED",
"PLUCHI WORLD PRIVATE LIMITED",
"PLUCKWALK TECHNOLOGIES PRIVATE LIMITED",
"PLUGA PUMPS AND MOTORS PRIVATE LIMITED",
"PLUGSTONE EDGE LLP",
"PLUM MULTITRADE PRIVATE LIMITED",
"PLUMBTECH INDIA PRIVATE LIMITED",
"PLUMBUM CHEMICALS & PIGMENTS PRIVATE LIMITED",
"PLUMSLICE LABS PRIVATE LIMITED",
"PLUMSOFT SOLUTIONS PRIVATE LIMITED",
"PLURAL TECHNOLOGY PRIVATE LIMITED",
"PLURALMIND TECHNOLAB PRIVATE LIMITED",
"PLURALSIGHT INDIA PRIVATE LIMITED",
"PLURALSOFT LIMITED",
"PLUREALTY PRIVATE LIMITED",
"PLURIMO PULTRUSION AND COMPOSITE PRIVATE LIMITED",
"PLURIS GLOBAL HOLDING (INDIA) LIMITED",
"PLUS 360 FAHRENHEIT SOLUTIONS PRIVATE LIMITED",
"PLUS ADVERTISING & PROMOTION PRIVATE LIMITED",
"PLUS AGRO INDUSTRIES PRIVATE LIMITED.",
"PLUS BUSINESS MACHINES LIMITED",
"PLUS CARE INTERNATIONALS PRIVATE LIMITED",
"PLUS CORPORATE VENTURES PRIVATE LIMITED",
"PLUS CREATIONS PRIVATE LIMITED",
"PLUS DISTRIBUTION PRIVATE LIMITED",
"PLUS INFOCOMMUNICATIONS PRIVATE LIMITED",
"PLUS INSULATIONS INDIA PRIVATE LIMITED",
"PLUS LOGISTICS LIMITED",
"PLUS MAX DUTY FREE (KOVAI) PRIVATE LIMITED",
"PLUS MAX DUTY FREE (MADURAI) PRIVATE LIMITED",
"PLUS MAX DUTY FREE (PUNE) PRIVATE LIMITED",
"PLUS MED DEVICES INDIA PRIVATE LIMITED",
"PLUS MEDICARE HOSPITALS PRIVATE LIMITED",
"PLUS ONE DIGITAL LLP",
"PLUS PAPER FOODPAC LIMITED",
"PLUS PLUS CONSULTING AND SERVICES PRIVATE LIMITED",
"PLUS POINT BUILDSWARE PRIVATE LIMITED",
"PLUS POINT MERIT HIGH SCHOOL",
"PLUS POINT PUBLICATIONS PRIVATE LIMITED",
"PLUS TECH ENGINEERING PRIVATE LIMITED",
"PLUS TRADING AND MANAGEMENT PRIVATE LIMITED",
"PLUS VENTILATION PRIVATE LIMITED",
"PLUS91 TECHNOLOGIES PRIVATE LIMITED",
"PLUSE HEART SUPER SPECIALITY HOSPITAL LLP",
"PLUSGROW LOGISTICS PRIVATE LIMITED",
"PLUSGROW MERCHANTRY PRIVATE LIMITED",
"PLUSH FOAMS PRIVATE LIMITED",
"PLUSH INTERIORS PRIVATE LIMITED",
"PLUSMINUS LABS PRIVATE LIMITED",
"PLUSNET COMMUNICATION PRIVATE LIMITED",
"PLUS-ONE MACHINEFABRIK PRIVATE LIMITED",
"PLUSS ADVANCED TECHNOLOGIES LIMITED",
"PLUSS ADVANCED TECHNOLOGIES PRIVATE LIMITED",
"PLUSSTAR ENGINEERING PRIVATE LIMITED",
"PLUSTECH SYSTEMS & SOLUTIONS PRIVATE LIMITED",
"PLUSWEALTH CAPITAL MANAGEMENT LLP",
"PLUTO ATRIZA BUSINESS PARKS PRIVATE LIMITED",
"PLUTO BUSINESS PARKS PRIVATE LIMITED",
"PLUTO FACILITIES MANAGEMENT PRIVATE LIMITED",
"PLUTO FOREX PRIVATE LIMITED",
"PLUTO INFRATECH PRIVATE LIMITED",
"PLUTO PLAZA PRIVATE. LIMITED.",
"PLUTO REALTORS PRIVATE LIMITED",
"PLUTO SEVEN BUSINESS SOLUTIONS PRIVATE LIMITED",
"PLUTO SHIPPING AND LOGISTICS PRIVATE LIMITED",
"PLUTO SHIPPING ANDCONSULTANCY PRIVATE LIMITED",
"PLUTO SHIPPING LIMITED",
"PLUTO SOFTWARE PRIVATE LIMITED",
"PLUTO TRAVELS INDIA PRIVATE LIMITED",
"PLUTOCRAT COMMERCIAL REAL ESTATE PRIVATE LIMITED",
"PLUTON CEMENTS PVT LTD",
"PLUTON EXIM PRIVATE LIMITED",
"PLUTUS BIKES PRIVATE LIMITED",
"PLUTUS BIZZ ADVISORS PRIVATE LIMITED",
"PLUTUS FINRESEARCH PRIVATE LIMITED",
"PLUTUS FUELS PRIVATE LIMITED",
"PLUTUS HOSPITAL",
"PLUTUS RESEARCH PRIVATE LIMITED",
"PLY COM PRIVATE LIMITED",
"PLY SAMRAT (INDIA) PRIVATE LIMITED",
"PLYBANK INDIA PRIVATE LIMITED",
"PLYMARC INDIA PRIVATE LIMITED",
"PLYMEX TIMBER PVT LTD",
"PLYWOOD PARK PRIVATE LIMITED",
"PLYWOOD WALE PRIVATE LIMITED",
"PM AGRO BIOTECH PRIVATE LIMITED",
"PM CARS PRIVATE LIMITED",
"PM CONA INDUSTRIES PRIVATE LIMITED",
"PM CONTRACTORS PRIVATE LIMITED",
"PM CONTROL EQUIPMENT PRIVATE LIMITED",
"PM CONTROL SYSTEMS (INDIA) PRIVATE LIMITED",
"PM CUCINE LUBE INDIA PRIVATE LIMITED",
"PM FINCAP LIMITED",
"PM FOILS & TISSUE PRIVATE LIMITED",
"PM FRESH LIMITED",
"PM INDUSTRIES & PROCESS EQUIPMENTS PRIVATE LIMITED",
"PM JEWELEX PRIVATE LIMITED",
"PM JEWELLERY HOUSE PRIVATE LIMITED",
"PM POWER CONSULTING PRIVATE LIMITED",
"PM PROJECTS AND SERVICES PRIVATE LIMITED",
"PM PUBLISHERS PRIVATE LIMITED",
"PM QUARTZ SURFACES PRIVATE LIMITED",
"PM VENTURES PRIVATE LIMITED",
"PMA AQUACARE PRIVATE LIMITED",
"PMA AUTOMOTIVE PRIVATE LIMITED",
"PMA CONTROLS INDIA LIMITED",
"PMA RESORTS AND REALTORS PRIVATE LIMITED",
"PMAM IT SERVICES PRIVATE LIMITED",
"PMAPS HR CONSULTANTS PRIVATE LIMITED",
"PMC BANK LIMITED",
"PMC BUILDSKILLS PRIVATE LIMITED",
"PMC CONSTRUCTIONS PRIVATE LIMITED",
"PMC CONSULTANTS PRIVATE LIMITED",
"PMC FINCORP LIMITED",
"PMC HYDRAULICS PRIVATE LIMITED",
"PMC PACKAGINGS PRIVATE LIMITED",
"PMC PAINTS PRIVATE LIMITED",
"PMC PLASTO PRIVATE LIMITED",
"PMC PROJECTS INDIA PRIVATE LIMITED",
"PMC RUBBER CHEMICALS INDIA PRIVATE LIMITED",
"PMCHORDIA CONTRACTORS PRIVATE LIMITED",
"PMD CHEMICALS PRIVATE LIMITED",
"PMEA SOLAR SYSTEMS PRIVATE LIMITED",
"PMEC ENGINEERING PRIVATE LIMITED",
"P-MECH CONSULTANT PRIVATE LIMITED",
"PMENTIRE SOLUTIONS PRIVATE LIMITED",
"P-MET HIGH-TECH COMPANY PRIVATE LIMITED",
"PMG AUTOMOBILES PRIVATE LIMITED",
"PMG AUTOS PRIVATE LIMITED",
"PMG ENGINEERING PRIVATE LIMITED",
"PMG INTEGRATED COMMUNICATIONS PRIVATE LIMITED",
"PMG KNOWLEDGE OUTSOURCE LLP",
"PMG METAL WINDOWS PRIVATE LIMITED",
"PMG OUTSOURCE PRIVATE LIMITED",
"PMG STEELS AND TUBES PRIVATE LIMITED",
"PMGS INDIA PRIVATE LIMITED",
"PMH SOLUTIONS PRIVATE LIMITED",
"PMH TRADERS PRIVATE LIMITED",
"PMI COACHES PRIVATE LIMITED",
"PMI ELECTRO MOBILITY SOLUTIONS PRIVATE LIMITED",
"PMI ENGINEERING EXPORTS PRIVATE LIMITED",
"PMI GLOBAL TECHNOLOGIES PRIVATE LIMITED",
"PMI ORGANIZATION CENTRE PRIVATE LIMITED",
"PMIN AGENCY PRIVATE LIMITED",
"PMJ CONSTRUCTIONS PRIVATE LIMITED",
"PMJ GEMS JEWELLERS PRIVATE LIMITED",
"PMJ GOLD PRIVATE LIMITED",
"PMJ PACKAGING AND TRIMS PRIVATE LIMITED",
"PMK BUILD-TECH INDIA PRIVATE LIMITED",
"PMK CONTRACTORS PRIVATE LIMITED",
"PMK DISTILLATIONS PRIVATE LIMITED",
"PMK ENERGY PRIVATE LIMITED",
"PMK INFRA PRIVATE LIMITED",
"PMK MACHINE TOOLS PRIVATE LIMITED",
"PML PESTMAN PRIVATE LIMITED",
"PMP AUTO COMPONENTS PRIVATE LIMITED",
"PMP CONSTRUCTION PRIVATE LIMITED",
"PMP DRIVE SYSTEMS INDIA PRIVATE LIMITED",
"PMP INDIA AGRO FOODS PRIVATE LIMITED",
"PMP INFRATECH LIMITED",
"PMP LOGISTICS PRIVATE LIMITED",
"PMP METAL PLAST PRIVATE LIMITED",
"PMPK WEALTH PRIVATE LIMITED",
"PMPS GLOBAL ENGINEERING SOLUTIONS PRIVATE LIMITED",
"PMR CONSTRUCTION COMPANY",
"PMR INFRASTRUCTURES PRIVATE LIMITED",
"PMR MANAGEMENT & CONSULTING PRIVATE LIMITED",
"PMR MUD RIGGERS INDIA PRIVATE LIMITED",
"PMR SHIPPING AND LOGISTICS INDIA PRIVATE LIMITED",
"PMR SOFTTECH PRIVATE LIMITED",
"PMRY CONSULTANTS PRIVATE LIMITED",
"PMS CUBE PRIVATE LIMITED",
"PMS EXPORTS PRIVATE. LIMITED.",
"PMS FINTECH PRIVATE LIMITED",
"PMS FLASHMATICS PRIVATE LIMITED",
"PMS NIRMAAN INTERIORS PRIVATE LIMITED",
"PMS POLY PLAST INDUSTRIES PRIVATE LIMITED",
"PMS SOFTINFO TECHNOLOGIES PRIVATE LIMITED",
"PMS SYNTEX PRIVATE LIMITED",
"PMSQUARE CONSULTING (INDIA) PRIVATE LIMITED",
"PMSR INFRA PROJECTS PRIVATE LIMITED",
"PMSS BUILDING MATERIAL PRIVATE LIMITED",
"PMT EXIM PRIVATE LIMITED",
"PMT HEALTHCARE PRIVATE LIMITED",
"PMT STEEL INDUSTRIES PRIVATE LIMITED",
"PMT VALVES PRIVATE LIMITED",
"PMV COLD STORAGE PRIVATE LIMITED",
"PMV LIFESCIENCE PRIVATE LIMITED",
"PMV MALTINGS PRIVATE LIMITED",
"PMV NUTRIENT PRODUCTS PRIVATE LIMITED",
"PMW METAL AND ALLOYS PRIVATE LIMITED",
"PMY SHIPPING PRIVATE LIMITED",
"PN CLEAN ENERGY LIMITED",
"PN DIE CASTINGS PRIVATE LIMITED",
"PN INTERNATIONAL PRIVATE LIMITED",
"PN IVF ACCESS PRIVATE LIMITED",
"PN IVF ACCESS TRADING PRIVATE LIMITED",
"PN MEMORIAL NEURO CENTRE & RESEARCH INSTITUTE LIMITED",
"PN POLYBAGS PRIVATE LIMITED",
"PN RAO",
"PN RENEWABLE ENERGY LIMITED",
"PN WORLDWIDE SERVICES (OPC) PRIVATE LIMITED",
"PNA 212 NEW ENGLISH SCHOOL SHIRUR",
"PNA SALES PRIVATE LIMITED",
"PNB CARDS & SERVICES LIMITED",
"PNB GILTS LIMITED",
"PNB HOUSING FINANCE LIMITED",
"PNB INVESTMENT SERVICES LIMITED",
"PNB METLIFE INDIA INSURANCE COMPANY LIMITED",
"PNC ALIGARH HIGHWAYS PRIVATE LIMITED",
"PNC BAREILLY NAINITAL HIGHWAYS PRIVATE LIMITED",
"PNC BITHUR KANPUR HIGHWAYS PRIVATE LIMITED",
"PNC BUNDELKHAND HIGHWAYS PRIVATE LIMITED",
"PNC CAPITAL TRUST LTD",
"PNC CHALLAKERE (KARNATAKA) HIGHWAYS PRIVATE LIMITED",
"PNC CHITRADURGA HIGHWAYS PRIVATE LIMITED",
"PNC COLD STORAGE PRIVATE LIMITED",
"PNC DELHI INDUSTRIALINFRA PRIVATE LIMITED",
"PNC GOMTI HIGHWAYS PRIVATE LIMITED",
"PNC INFRATECH LIMITED",
"PNC KANPUR AYODHYA TOLLWAYS PRIVATE LIMITED",
"PNC KANPUR HIGHWAYS LIMITED",
"PNC KHAJURAHO HIGHWAYS PRIVATE LIMITED",
"PNC MEERUT HARIDWAR HIGHWAYS PRIVATE LIMITED",
"PNC RAEBARELI HIGHWAYS PRIVATE LIMITED",
"PNC RAJASTHAN HIGHWAYS PRIVATE LIMITED",
"PNC TRIVENI SANGAM HIGHWAYS PRIVATE LIMITED",
"PNC UNNAO HIGHWAYS PRIVATE LIMITED",
"PND TRANSFORMER PRIVATE LIMITED",
"PNEU MECH MARKETING PVT LTD",
"PNEUCON AUTOMATION PRIVATE LIMITED",
"PNEUCON HEAVY PROJECTS PRIVATE LIMITED",
"PNEUCON VALVES PRIVATE LIMITED",
"PNEUMAT SYSTEMS (INDIA) PRIVATE LIMITED",
"PNEUMATIC ENGINEERS PRIVATE LIMITED",
"PNEUMATIC SERVICES PRIVATE LIMITED",
"PNEUMATIC VACUUM ELEVATORS AND LIFTS-INDIA PRIVATE LIMITED",
"PNEUMATICS AUTOMATION E.MC INDIA PRIVATE LIMITED",
"PNEUMAX PNEUMATIC INDIA PRIVATE LIMITED",
"PNEUMEC KONTROLLS PRIVATE LIMITED",
"PNEUMO CARE HEALTH PRIVATE LIMITED",
"PNEUTECH ENGINEERS PRIVATE LIMITED",
"PNG",
"PNG FURNISHINGS PRIVATE LIMITED",
"PNG SECURITY & FACILITY PRIVATE LIMITED",
"PNG TEXTILES PRIVATE LIMITED",
"PNG TOLLWAY LIMITED",
"PNGS GARGI FASHION JEWELLERY LIMITED",
"PNI VAAREGEN INDIA PRIVATE LIMITED",
"PNJ COMMERCE ENTERPRISES PRIVATE LIMITED",
"PNK LOGISTICS PRIVATE LIMITED",
"PNK NAIR AND COMPANY",
"PNM KATYANI PACKAGINGS PRIVATE LIMITED",
"PNMR PROJECTS & SERVICES PRIVATE LIMITED",
"PNN STEEL PRIVATE LIMITED",
"PN-NJ INDUSTRIES PRIVATE LIMITED",
"PNP & ASSOCIATES PRIVATE LIMITED",
"PNP ENGINEERING WORKS PRIVATE LIMITED",
"PNP HOTELS&RESORTS PRIVATE LIMITED",
"PNP INFRAPROJECTS PRIVATE LIMITED",
"PNP MARITIME SERVICE PRIVATE LIMITED",
"PNP POLYMERS PRIVATE LIMITED",
"PNP POLYTEX PRIVATE. LIMITED.",
"PNP PROBUILD PRIVATE LIMITED",
"PNQ TECHNOLOGIES PRIVATE LIMITED",
"PNR APPARELS PRIVATE LIMITED",
"PNR AUTOMOBILES PRIVATE LIMITED",
"PNR CAPITAL SERVICES LIMITED",
"PNR COMMERCE SERVICES PRIVATE LIMITED",
"PNR COMMERCIAL AGENCIES PRIVATE LIMITED",
"PNR INDUSTRIES LIMITED",
"PNR INFOTECH PRIVATE LIMITED",
"PNR INFRACON PRIVATE LIMITED",
"PNR INTERIOR SOLUTIONS PRIVATE LIMITED",
"PNR MAHALAKSHMI JEWELLERY PRIVATE LIMITED",
"PNR MOTORS PRIVATE LIMITED",
"PNR PROJECTS PRIVATE LIMITED",
"PNR REALTORS PRIVATE LIMITED",
"PNR SECURITIES LIMITED",
"PNR SYSTEMS PRIVATE LIMITED",
"PNS CABS PRIVATE LIMITED",
"PNS ELECTRIC SOLUTION PRIVATE LIMITED",
"PNS EXPRESS PRIVATE LIMITED",
"PNS INDUSTRIES PRIVATE LIMITED",
"PNS MARKETING PRIVATE LIMITED",
"PNS SYSTEMS PRIVATE LIMITED",
"PNS UPKEEP SERVICES PRIVATE LIMITED",
"PNSC INFRASTRUCTURE PRIVATE LIMITED",
"PNT DESIGNS PRIVATE LIMITED",
"PNV TECHNO CONSULTING SERVICES LLP",
"PNY FOREX & TRAVELS PRIVATE LIMITED",
"PNY SABHA FINANCE LIMITED",
"POA ARCHEOLIGICAL SURVEY OF INDIA",
"POA INDIAN BUEARU OF MINES NAGPUR",
"POA O/O THE AG A AND E 2",
"POABS BIOTECH PRIVATE LIMITED",
"POABS ENTERPRISES PRIVATE LIMITED",
"POABS GRANITE PRODUCTS PRIVATE LIMITED",
"POABS GRANITES PVT LTD",
"POABS ROCK PRODUCTS PVT LTD",
"POABSON GRANITE PRODUCTS PRIVATE LIMITED",
"POBARU MARKETING & AGENCIES PRIVATE LIMITED",
"POBI INFRASTRUCTURE PRIVATE LIMITED",
"POBI TECHNOLOGIES & CONSTRUCTIONS PRIVATE LIMITED",
"POBON DPC AND CABLES PRIVATE LIMITED",
"POCHAMPAD CONSTRUCTION COMPANY PRIVATE. LIMITED.",
"POCHEMUCHKA KIDS PRIVATE LIMITED",
"POCHI MOBILE PRIVATE LIMITED",
"POCHIMA REDDY RESORT AND ESTATES PVT LTD",
"POCIENT ENGINEERING PRIVATE LIMITED",
"POCKETAPP SOFTWARE PRIVATE LIMITED",
"POCKETLY INFOTECH PRIVATE LIMITED",
"POCKETMART PRIVATE LIMITED",
"POCL ENTERPRISES LIMITED.",
"POCLAIN HYDRAULICS PRIVATE LIMITED",
"POCT SCIENCE HOUSE PRIVATE LIMITED",
"PODAR ADMISSION ORNAMENTUM LLP",
"PODAR CHARITY TRUST",
"PODAR EDUCATION & SPORTS TRUST",
"PODAR EDUCATION GROUP COMPANY",
"PODAR EDUCATION NETWORK PRIVATE LIMITED",
"PODAR EDUCATION SYSTEMS PRIVATE LIMITED",
"PODAR EDUCATION TRUST",
"PODAR INTERNATIONAL SCHOOL",
"PODAR LITERACY & EDUCATION TRUST",
"PODARAN FOODS INDIA PRIVATE LIMITED",
"PODD POWER SOLUTIONS PRIVATE LIMITED",
"PODDAR AMALGAMATED HOLDINGS PRIVATE LIMITED",
"PODDAR AUTOCORP PRIVATE LIMITED",
"PODDAR BATTERY COMPANY PRIVATE LIMITED",
"PODDAR BIO - DIESEL PRIVATE LIMITED",
"PODDAR BUSINESS PRIVATE LIMITED",
"PODDAR CAR WORLD PRIVATE LIMITED",
"PODDAR CARDS PVT LTD",
"PODDAR COTTON DEALERS PVT LTD",
"PODDAR DIAMOND PRIVATE LIMITED",
"PODDAR FABRICATORS PRIVATE LIMITED",
"PODDAR FOODS PRIVATE LIMITED",
"PODDAR GEMS PRIVATE LIMITED",
"PODDAR GLOBAL LIMITED",
"PODDAR HOUSING AND DEVELOPMENT LIMITED",
"PODDAR INFRACON PRIVATE LIMITED",
"PODDAR ISPAT PRIVATE LIMITED",
"PODDAR MARBLES PRIVATE LIMITED",
"PODDAR MERCANTILE PRIVATE LIMITED",
"PODDAR OILS PRIVATE LIMITED",
"PODDAR PHARMACEUTICALS PRIVATE LIMITED",
"PODDAR PIGMENTS LIMITED",
"PODDAR POLYESTER PRIVATE LIMITED",
"PODDAR POLYFAB PRIVATE LIMITED",
"PODDAR POLYKRAFT PRIVATE LIMITED",
"PODDAR PROJECTS LTD",
"PODDAR SALES PVT LTD",
"PODDAR SHIKSHAN SANSTHA",
"PODDAR SOLUTIONS PRIVATE LIMITED",
"PODDAR TOOLS AND ABRASIVES PRIVATE LIMITED",
"PODDAR TRADELINKS PRIVATE LIMITED",
"PODDAR TYRES LIMITED",
"PODDAR YARNS PVT.LTD.",
"PODDER & PODDER EQUIPMENT AND PROJECT PRIVATE LIMITED",
"PODDER AUTO INDIA PRIVATE LIMITED",
"PODDER SONS EXL PVT LTD",
"PODGE CREATIONS PRIVATE LIMITED",
"PODHIGAI ADS PRIVATE LIMITED",
"PODHIGAI RETAIL INDIA PRIVATE LIMITED",
"PODIUM SYSTEMS PRIVATE LIMITED",
"PODO LITE FOOTCARE PRIVATE LIMITED",
"PODRAIN ELECTRONICS PRIVATE LIMITED",
"POET CONSULTANTS PRIVATE LIMITED",
"POG ENGINEERING CONSULTANTS PRIVATE LIMITED",
"POGEYAN TECHNOLOGIES PRIVATE LIMITED",
"POHANG IRON & STEEL CO. LIMITED",
"POHIEER DAIRRY PRIVATE LIMITED",
"POHOOMAL WORLDWIDE EXPORTS PRIVATE LIMITED",
"POHOOMALS EXPORTS PRIVATE LIMITED",
"POINT BLANK ADVERTISING PRIVATE LIMITED",
"POINT FABRICS INDIA PRIVATE LIMITED",
"POINT FOOT WEAR PRIVATE LIMITED",
"POINT OF CARE BIO MEDICAL PRIVATE LIMITED",
"POINT OF VIEW BRANDCOM (INDIA) PRIVATE LIMITED",
"POINT PERFECT TECHNOLOGY SOLUTIONS INDIA PRIVATE LIMITED",
"POINT R TECHNOLOGIES PRIVATE LIMITED",
"POINT TECHNOVATION PRIVATE LIMITED",
"POINT TEXTILES PRIVATE LIMITED",
"POINTCROSS .COM PRIVATE LIMITED",
"POINTEC PENS AND ENERGY PRIVATE LIMITED",
"POINTEL SOLUTIONS INDIA PRIVATE LIMITED",
"POINTER FASHION PRIVATE LIMITED",
"POINTER SWITCHES (INDIA) PRIVATE LIMITED",
"POINTER TELOCATION INDIA PRIVATE LIMITED",
"POINTHAI INDIA PRIVATE LIMITED",
"POINTORGN TECHNOLOGIES INDIA PRIVATE LIMITED",
"POISED INDIA ADVISORY PRIVATE LIMITED",
"POISED MEDIA PRIVATE LIMITED",
"POJ HOTELS PRIVATE LIMITED",
"POKAR SEEDS PRIVATE LIMITED",
"POKARAN SOLAIRE ENERGY PRIVATE LIMITED",
"POKARNA ENGINEERED STONE LIMITED",
"POKARNA FASHIONS PRIVATE LIMITED",
"POKARNA LIMITED",
"POKARNA MARKETING PRIVATE LIMITED",
"POKHARKAR ENGINEERING PRODUCTS PRIVATE LIMITED",
"POKHARNA REFOIL PRIVATE LIMITED",
"POKMA AUTOMOBILES",
"POLA CAR RENTALS PRIVATE LIMITED",
"POLAKY CARRIERS EXIM PRIVATE LIMITED",
"POLAR AUTO AND ENGINEERING INDUSTRIES PRIVATE LIMITED",
"POLAR BIOSCIENCES PRIVATE LIMITED",
"POLAR COLD STORAGE PRIVATE LIMITED",
"POLAR ELECTRONICS PRIVATE LIMITED",
"POLAR ELEKTRIC LIMITED",
"POLAR ELEVATORS PRIVATE LIMITED",
"POLAR GASES PRIVATE LIMITED",
"POLAR GENETICS INDIA PRIVATE LIMITED",
"POLAR INTERNATIONAL LIMITED",
"POLAR POWER SQUARE PRIVATE LIMITED",
"POLARIS BANYAN HOLDING PRIVATE LIMITED",
"POLARIS CABLES AND WIRES PVT LTD",
"POLARIS CONSULTING AND SERVICES LIMITED",
"POLARIS ENTERPRISE SOLUTION LIMITED",
"POLARIS EQUIPMENT PRIVATE LIMITED",
"POLARIS HOSPITAL",
"POLARIS HR CONSULTING PRIVATE LIMITED",
"POLARIS INDIA PRIVATE LIMITED",
"POLARIS LIQUOR PRIVATE LIMITED",
"POLARIS RENEWABLE SOLUTIONS PRIVATE LIMITED",
"POLARIS TALENT MANAGEMENT PRIVATE LIMITED",
"POLCO CREATIONS PRIVATE LIMITED",
"POLE STAR CARGO INDIA PRIVATE LIMITED",
"POLE STAR COILS PRIVATE LIMITED",
"POLE STAR FURNITURE PRIVATE LIMITED",
"POLE STAR INDUSTRIES PRIVATE LIMITED",
"POLECAT INFRASTRUCTURES PRIVATE LIMITED",
"POLEPALLY SOLAR PARKS PRIVATE LIMITED",
"POLESTAR CAPITAL ADVISORY & INVESTMENT HOLDINGS PRIVATE LIMITED",
"POLESTAR CONSULTING PRIVATE LIMITED",
"POLESTAR CORRUGATER PVT LTD",
"POLESTAR ENGINEERING CO",
"POLESTAR ENGINEERING PRIVATE LIMITED",
"POLESTAR MARITIME LIMITED",
"POLESTAR PLASTECH PRIVATE LIMITED",
"POLFROST AIR CON PRIVATE LIMITED",
"POLICE DAV PUBLIC SCHOOL",
"POLICE DEPTT",
"POLICE MODERN PUBLIC SCHOOL",
"POLICY PARIVAAR INSURANCE BROKERS PRIVATE LIMITED",
"POLICYBAZAAR INSURANCE WEB AGGREGATOR PRIVATE LIMITED",
"POLICYBAZAR INSURANCE WEB AGGREGATOR PRIVATE LIMITED",
"POLICYWOW INSURANCE BROKING PRIVATE LIMITED",
"POLICYX.COM INSURANCE WEB AGGREGATOR PRIVATE LIMITED",
"POLIGOF - MICRO HYGIENE (INDIA) PRIVATE LIMITED",
"POLIMER MEDIA PRIVATE LIMITED",
"POLIMERAAS LIMITED",
"POLINSYS IMMIGRATION CONSULTANTS PRIVATE LIMITED",
"POLISETTY SOMASUNDARAM TOBACCO PRODUCTS INDIA PRIVATE LIMITED",
"POLISETTY SOMASUNDARAM TOBACCO THRESHERS PRIVATE LIMITED",
"POLITE IT PRIVATE LIMITED",
"POLITRICKS PRIVATE LIMITED",
"POLIXEL SECURITY SYSTEMS PRIVATE LIMITED",
"POLJO 777 UDYOG PRIVATE LIMITED",
"POLJO VYAPAR KENDRA PRIVATE LIMITED",
"POLLACHI COCONUT PRODUCER COMPANY LIMITED",
"POLLEN AGRO MINERALS PRIVATE LIMITED",
"POLLEN HEALTHCURE PRIVATE LIMITED",
"POLLEN SEEDS PRIVATE LIMITED",
"POLLENT MINERALS AND INFRA PRIVATE LIMITED",
"POLLINATE ENERGY INDIA PRIVATE LIMITED",
"POLLINATION WORLD DECORATIVES PRIVATE LIMITED",
"POLLOCKS INTELLI SCHOOL",
"POLLTECH INSTRUMENTS PRIVATE LIMITED",
"POLLUCARE BIOMEDICAL MANAGEMENT PRIVATE LIMITED",
"POLLUCARE ENGINEERS INDIA PRIVATE LIMITED",
"POLLUCON ENVIRO ENGINEERS PRIVATE LIMITED",
"POLLUCON LABORATORIES PRIVATE LIMITED",
"POLLUCON TECHNOLOGIES LIMITED",
"POLLUTECH ENGINEERING",
"POLLUTION PROTECTION SYSTEMS MUMBAI PRIVATE LIMITED",
"POLLUX BUSINESS SOLUTIONS PRIVATE LIMITED",
"POLLUX LOGISTICS PRIVATE LIMITED",
"POLLY COOL APPLIANCES PRIVATE LIMITED",
"POLMANN INDIA LIMITED",
"POLMON INSTRUMENTS PRIVATE LIMITED",
"POLMON VESNFER PRIVATE LIMITED",
"POLMOR STEEL PRIVATE LIMITED",
"POLO AMUSEMENT (NAGPUR) PRIVATE LIMITED",
"POLO CEILING AND CONSTRUCTION PRIVATE LIMITED",
"POLO ELEVATORS INDIA PRIVATE LIMITED",
"POLO ENTERPRISES PRIVATE LIMITED",
"POLO FOREX PRIVATE LIMITED",
"POLO GIFTS CREATIONS PRIVATE LIMITED",
"POLO INDUSTRIES PRIVATE LIMITED",
"POLO LABS PRIVATE LIMITED",
"POLO PHARMACEUTICALS PRIVATE LIMITED",
"POLO PROMOTERS LIMITED",
"POLO PVC PRIVATE LIMITED",
"POLO QUEEN INDUSTRIAL AND FINTECH LIMITED",
"POLOLIGHT INDUSTRIES LIMITED",
"POLOTEL PRIVATE LIMITED",
"POLPIT FINANCIAL CONSULTANTS PVT LTD",
"POLSON LTD",
"POLSTAR BUILDING SYSTEMS PRIVATE LIMITED",
"POLSTRAT COMMUNICATION PRIVATE LIMITED",
"POLTRONA FRAU INDIA PRIVATE LIMITED",
"POLU ASSOCIATES ARCHITECTS & INTERIOR DESIGNERS",
"POLUS EPOTHANE INDIA PRIVATE LIMITED",
"POLUS SOLUTIONS PRIVATE LIMITED",
"POLWELL AGENCIES PVT LTD",
"POLWELL REAL ESTATES PRIVATE LIMITED",
"POLY CARE LABS (GUJARAT) PRIVATE LIMITED",
"POLY COLOURAID INDIA PRIVATE LIMITED",
"POLY DIST INDIA PRIVATE LIMITED",
"POLY DRILL ENGINEERS PVT LTD",
"POLY ELASTIC PRIVATE LIMITED",
"POLY GRAN INDIA PRIVATE LIMITED",
"POLY INFOCOM CABLES PRIVATE LIMITED",
"POLY LAMINATIONS PRIVATE LIMITED",
"POLY MARKETING PVT LTD",
"POLY MEDICURE LIMITED",
"POLY PIPES INDIA P LIMITED",
"POLY PIPES INDIA PRIVATE LIMITED",
"POLY PLAST CHEMI-PLANTS(INDIA) PRIVATE LIMITED",
"POLY PLASTICS EXIM PRIVATE LIMITED",
"POLY PLASTICS PRIVATE LIMITED",
"POLY PRODUCTS",
"POLY PROTON TECHNOPLAST",
"POLY REFRACTORIES PRIVATE LIMITED",
"POLY SOLAR PARKS PRIVATE LIMITED",
"POLY TECH INTERNATIONAL PRIVATE LIMITED",
"POLY TOUGH TUBES LIMITED",
"POLYBOND COATING PRIVATE LIMITED",
"POLYBOND INDIA PRIVATE LIMITED",
"POLYBOND INSULATION PRIVATE LIMITED",
"POLYBOND PROJECTS PRIVATE LIMITED",
"POLYBOND ROCK FIBRE PRIVATE LIMITED",
"POLYCAB INDIA LIMITED",
"POLYCAB PREMIERS PRIVATE LIMITED",
"POLYCAN EXTRUSION PRIVATE LIMITED",
"POLYCARB ADVANCE SCIENCE PRIVATE LIMITED",
"POLYCHEM LIMITED",
"POLYCHEMICAL FIBROPLAST PRIVATE LIMITED",
"POLYCLINIC PVT LTD",
"POLYCOAT FLOWCHEM PRIVATE LIMITED",
"POLYCOM TECHNOLOGIES R & D PRIVATE LIMITED",
"POLYCOM UNIFIED COMMUNICATIONS SOLUTION PRIVATE LIMITED",
"POLYCON INTERNATIONAL LIMITED",
"POLYCRAFT PUF MACHINE PRIVATE LIMITED",
"POLYCRETE RESTORATIONS INDIA PRIVATE LIMITED",
"POLYCRUST EXTRUSIONS INDIA PRIVATE LIMITED",
"POLYDRAPE",
"POLYDRUG LABORATORIES PRIVATE LIMITED",
"POLYENE GENERAL INDUSTRIES PRIVATE LIMITED",
"POLYFAB FOAMS INDIA PVT LTD",
"POLYFIBRE INDUSTRIES PRIVATE LIMITED",
"POLYFINES INDIA LIMITED",
"POLYFIRM PACKAGING PRIVATE LIMITED",
"POLYFIT FABRICATORS PRIVATE LIMITED",
"POLYFLEXINDIA PRIVATE LIMITED",
"POLYFLOR IDIA PRIVATE LIMITED",
"POLY-FLUORO PRIVATE LIMITED",
"POLYFORMALIN PRIVATE LIMITED",
"POLYGLASS ACRYLIC MFG CO P LIMITED",
"POLYGOLD PRE-CURED SYSTEMS PRIVATE LIMITED",
"POLYGOMMA INDUSTRIES PRIVATE LIMITED",
"POLYGON ADHESIVES AND RESINS PRIVATE LIMITED",
"POLYGON CHEMICALS PRIVATE LIMITED",
"POLYGON STUDIOS INDIA PRIVATE LIMITED",
"POLYGRAPH PRINTING TECHNOLOGIES LIMITED",
"POLYGUARD CHEMICALS PRIVATE LIMITED",
"POLYGUARDS EQUIPMENTS AND TOOLS PRIVATE LIMITED",
"POLYHERO ELECTRICALS PRIVATE LIMITED",
"POLYHOSE INDIA PRIVATE LIMITED",
"POLYHOSE INDIA RUBBER PRIVATE LIMITED",
"POLYHOSE KOHYEI INDIA PRIVATE LIMITED",
"POLYHOSE PROPERTIES PRIVATE LIMITED",
"POLYHOSE TOFLE PRIVATE LIMITED",
"POLYHUB AGRO TECH PRIVATE LIMITED",
"POLYHYDRON PRIVATE LIMITED",
"POLYHYDRON SYSTEMS PRIVATE LIMITED",
"POLYKORP PRIVATE LIMITED",
"POLYLACE INDIA PRIVATE LIMTIED",
"POLYLINE EXTRUSION PRIVATE LIMITED",
"POLYLON FABRICS PRIVATE. LIMITED.",
"POLYLON TEXTILE",
"POLYMAC THERMOFORMERS LIMITED",
"POLYMAGE LABS PRIVATE LIMITED",
"POLYMAK TOOLS INDIA PRIVATE LIMITED",
"POLYMATECH ELECTRONICS LIMITED.",
"POLYMATECH ELECTRONICS PRIVATE LIMITED.",
"POLYMATIC PNEUMATIC INDIA PRIVATE LIMITED",
"POLYMATIX INSTRUMENTATION PRIVATE LIMITED",
"POLYMAX ELASTOMERS PRIVATE LIMITED",
"POLYMECH COMPONENTS PRIVATE LIMITED",
"POLYMECHPLAST MACHINES LIMITED",
"POLYMER COATINGS AND INKS PRIVATE LIMITED",
"POLYMER ENTERPRISES (INDIA) PRIVATE LIMITED",
"POLYMER IMPEX PRIVATE LIMITED",
"POLYMER INDUSTRIES INDIA LIMITED",
"POLYMER KERALA PRIVATE LIMITED",
"POLYMER PAPERS LIMITED",
"POLYMER ROTO INKS PRIVATE LIMITED",
"POLYMER TECHNOLOGIES INDIA PRIVATE LIMITED",
"POLYMERLINK INDIA PRIVATE LIMITED",
"POLYMERMANN (ASIA) PVT LTD",
"POLYMET TECHNO PRODUCTS PRIVATE LIMITED",
"POLYMOON INDUSTRIES PRIVATE LIMITED",
"POLYMORPHIC SYSTEMS PRIVATE LIMITED",
"POLYNATE FOAMS PRIVATE LIMITED",
"POLYNET INFRASTRUCTURE PRIVATE LIMITED",
"POLYNOMIAL AI INDIA PRIVATE LIMITED",
"POLYNOMOUS INDUSTRIES PRIVATE LIMITED",
"POLYNOVA INDUSTRIES LIMITED",
"POLYOLS & POLYMERS PRIVATE LIMITED",
"POLYOLS TECHNOLOGIES PRIVATE LIMITED",
"POLYON TEXTILES PRIVATE LIMITED",
"POLYONE POLYMERS INDIA PRIVATE LIMITED",
"POLYPACK INDUSTRIES",
"POLYPEPTIDE LABORATORIES PRIVATE LIMITED",
"POLYPET FLEXIBLE PACKAGING PRIVATE LIMITED",
"POLYPHASE ELECTRICAL INDIA PRIVATE LIMITED",
"POLYPHASE ENGINEERING PRIVATE LIMITED",
"POLYPICK ENGINEERS PRIVATE LIMITED",
"POLYPICK THREADS PRIVATE LIMITED",
"POLYPLAST PACK PRIVATE LIMITED",
"POLYPLAST PRIVATE LIMITED",
"POLYPLASTICS AUTO COMPONENTS PRIVATE LIMITED",
"POLYPLASTICS DECORATIVE PRIVATE LIMITED",
"POLYPLASTICS INDUSTRIES INDIA PRIVATE LIMITED",
"POLYPLASTICS MARKETING (INDIA) PRIVATE LIMITED",
"POLYPLASTICS UTTAR BHARAT PRIVATE LIMITED",
"POLYPLEX CORPORATION LIMITED",
"POLYRAJ FABRICS PRIVATE LIMITED",
"POLYREC PROCESSORS PVT LTD",
"POLYRUB COOPERSTANDARD FTS PRIVATE LIMITED",
"POLYRUB EXTRUSIONS INDIA PRIVATE LIMITED",
"POLYRUB PLASTIC PRIVATE LIMITED",
"POLYSEAL ENGINEERS PRIVATE LIMITED",
"POLYSET PLASTICS PRIVATE LIMITED",
"POLYSHELLS AND TOOLS PRIVATE LIMITED",
"POLYSIL IRRIGATION SYSTEMS LIMITED",
"POLYSIL IRRIGATION SYSTEMS PRIVATE LIMITED",
"POLYSOL INDUSTRIES",
"POLYSPIN EXPORTS LIMITED",
"POLYSPIN FILTERATION (INDIA) PRIVATE LIMITED",
"POLYSPIN PRIVATE LIMITED",
"POLYSTEEL INDIA PRIVATE LIMITED",
"POLYTEC PACKINS INDIA PRIVATE LIMITED",
"POLYTECH INSTRUMENTS PRIVATE LIMITED",
"POLYTECH MILLENNIUM (INDIA) PRIVATE LIMITED",
"POLYTECH RUBBER PVT. LTD.",
"POLYTECH WIRE AND CABLES PRIVATE LIMITED",
"POLYTECHNIC COLLEGE JAORA",
"POLYTEK FOOTWEAR COMPANY PRIVATE LIMITED",
"POLYTRANS LAMICOATS PRIVATE LIMITED",
"POLYTRON INDUSTRIES PRIVATE LIMITED",
"POLYVALENT DIGITAL SERVICES PRIVATE LIMITED",
"POLYVION CABLES PRIVATE LIMITED",
"POLYWOOD PROFILES PRIVATE LIMITED",
"POLYWORKS SOFTWARE INDIA PRIVATE LIMITED",
"POM HYDRO ENERGY LIMITED",
"POM SYSTEMS & SERVICES PRIVATE LIMITED",
"POMAC HYPERMARKET PRIVATE LIMITED",
"POMERA AND CO LIMITED",
"POMETON INDIA PRIVATE LIMITED",
"POMIGA EXIM PRIVATE LIMITED",
"POMMI SHIPPING AND LOGISTICS PRIVATE LIMITED",
"POMMYS GARMENTS INDIA PRIVATE LIMITED",
"POMONA EXPORTS PRIVATE LIMITED",
"POMONA TRADING COMPANY PRIVATE LIMITED",
"POMYGRANATE TECHNOLOGIES PRIVATE LIMITED",
"PON ENGINEERS PRIVATE LIMITED",
"PON PURE CHEMICAL INDIA PRIVATE LIMITED",
"PON PURE LOGISTICS PRIVATE LIMITED",
"PON VIDYASHRAM",
"PONA LAB BIOGROWTH PRIVATE LIMITED",
"PONDA EDUCATION SOCIETYS",
"PONDHAN SCAFFOLDING PRIVATE LIMITED",
"PONDICHERRY AGRO FOODS PRIVATE LIMITED",
"PONDICHERRY ASHOK HOTEL CORPORATION LIMITED",
"PONDICHERRY INSTITUTE OF MEDICAL SCIENCES",
"PONDICHERRY -TINDIVANAM TOLLWAY PRIVATE LIMITED",
"PONDS EXPORTS LIMITED",
"PONDY AGRO CHEMICALS PRIVATE LIMITED",
"PONDY DIE CASTING PRIVATE LIMITED.",
"PONDY HITECH PLASTICS PVT. LTD",
"PONDY OXIDES AND CHEMICALS LIMITED.",
"PONDY POLYPACK PRIVATE LIMITED",
"PONDY ROLLER FLOUR MILLS PRIVATE LIMITED",
"PONDY TECHNOLOGIES LTD",
"PONDYBIZ TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"PONE ENGINEERING INDIA PRIVATE LIMITED",
"P-ONE INFRASTRUCTURE PRIVATE LIMITED",
"PONECT HERBS PRIVATE LIMITED",
"PONGALUR PIONEER TEXTILES PRIVATE LIMITED",
"PONGALUR SPINNING MILLS PRIVATE LIMITED",
"PONGOKULAM GRANITES PRIVATE LIMITED",
"PONIKA MULTITRADE PRIVATE LIMITED",
"PONMUDI PACKARTS PVT LTD",
"PONMUDI RUBBERS LIMITED",
"PONNAIYAH RAMAJAYAM INSTITUTE OF SCIENCE & TECHNOLOGY(PRIST)",
"PONNAM POLYPACKS PRIVATE LIMITED",
"PONNANI GOLD PRIVATE LIMITED",
"PONNI HATCHERIES PRIVATE LIMITED",
"PONNI SUGARS ERODE LIMITED",
"PONNI TECH PARK PRIVATE LIMITED",
"PONNORE ENTERPRISES LLP",
"PONNU FOOD PRODUCTS",
"PONNUR FARMERS PRODUCER COMPANY LIMITED",
"PONRAM BIRIYANI HOTEL PRIVATE LIMITED",
"PONTIKA AEROTECH LIMITED",
"PONTOS LABCARE PRIVATE LIMITED",
"PONTUS FREIGHT INDIA PRIVATE LIMITED",
"PONTUS PACK PRIVATE LIMITED",
"PONTUS PAPER PRODUCTS PRIVATE LIMITED",
"PONY INFRASTRUCTURE & CONTRACTORS LIMITED",
"POOBONG PLANTATIONS PRIVATE LIMITED",
"POOCH IT SOLUTIONS PRIVATE LIMITED",
"POOJA AIRCONS LLP",
"POOJA ARCHITECTURAL SYSTEM PRIVATE LIMITED",
"POOJA AUXYCHEM PRIVATE LIMITED",
"POOJA BEAUTIFULLY YOURS PRIVATE LIMITED",
"POOJA BEVERAGES AND FOOD PRIVATE LIMITED",
"POOJA BHOLA CONSULTANCY SERVICES",
"POOJA CABLES PVT LTD",
"POOJA CARBONIC PRIVATE LIMITED",
"POOJA CARTONS & CONTAINERS PRIVATE LIMITED",
"POOJA CASTINGS PVT LTD",
"POOJA CERACON PRIVATE LIMITED",
"POOJA CERATECH PRIVATE LIMITED",
"POOJA CLOTHING PRIVATE LIMITED",
"POOJA COLOUR-CHEM PRIVATE LIMITED",
"POOJA COMPUTER INSITITUTE",
"POOJA COTSPIN LIMITED",
"POOJA COTSPIN PRIVATE LIMITED",
"POOJA CRAFTED HOMES PRIVATE LIMITED",
"POOJA DEHY. FOODS PVT. LTD",
"POOJA DESIGNERS PRIVATE LIMITED",
"POOJA DIAGNOSTIC CENTRE PRIVATE LIMITED",
"POOJA ELECTROTECH PRIVATE LIMITED",
"POOJA ENTERTAINMENT AND FILMS LIMITED",
"POOJA ENTERTAINMENT LIMITED",
"POOJA EXPORTS",
"POOJA FABMART PRIVATE LIMITED",
"POOJA FABRICS PRIVATE LIMITED",
"POOJA FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"POOJA FLEXIBLE PACKAGING PRIVATE LIMITED",
"POOJA FLOOR AND FURNISHING PRIVATE LIMITED",
"POOJA FOOD COMMODITY PRIVATE LIMITED",
"POOJA FORGE LIMITED",
"POOJA GLASS WORKS PRIVATE LIMITED",
"POOJA GREEN HOUSE INDUSTRIES PRIVATE LIMITED",
"POOJA HARDWARE PRIVATE LIMITED",
"POOJA HOSPITALITY & MGMT SER",
"POOJA INDUSTRIES PRIVATE LIMITED",
"POOJA JEWELLERS",
"POOJA LIFESTYLES PRIVATE LIMITED",
"POOJA LOGISTICS PRIVATE LIMITED",
"POOJA MACHINES MANUFACTURING PRIVATE LIMITED",
"POOJA MACHINES PRIVATE LIMITED",
"POOJA METAL PROCESSORS PRIVATE LIMITED",
"POOJA MINES & STONES PRIVATE LIMITED",
"POOJA MINING AND MARBLES PRIVATE LIMITED",
"POOJA MOUNTVIEW RESORTS PRIVATE LIMITED",
"POOJA NURSING HOME PRIVATE LIMITED",
"POOJA ORNAMENTS PRIVATE LIMITED",
"POOJA PACKAGERS PRIVATE LIMITED",
"POOJA PHARMAMACETICALS",
"POOJA PLAST PRIVATE LIMITED",
"POOJA PLASTO COLOUR PRIVATE LIMITED",
"POOJA PRECISION SCREWS PRIVATE LIMITED",
"POOJA PRODUCTS PRIVATE LIMITED",
"POOJA REALCON PRIVATE LIMITED",
"POOJA ROTOMAKE PRIVATE LIMITED",
"POOJA SHRI MARMO PRIVATE LIMITED",
"POOJA SOLVENT PRIVATE LIMITED",
"POOJA SPONGE PRIVATE LIMITED",
"POOJA STAMPINGS PRIVATE LIMITED",
"POOJA TANNOFIX TANNER PRIVATE LIMITED",
"POOJA TILES AND SANITARY PRIVATE. LIMITED.",
"POOJA TOOLS & EQUIPMENTS PRIVATE LIMITED",
"POOJA TOURIST SERVICE PRIVATE LIMITED",
"POOJA TRENDZ PRIVATE LIMITED",
"POOJA WHEAT PRODUCTS PRIVATE LIMITED",
"POOJAA FOUNDATION PRIVATE LIMITED",
"POOJAA SREE GINNING MILL PRIVATE LIMITED",
"POOJAN DECOR PRIVATE LIMITED",
"POOJARA TELECOM PRIVATE LIMITED",
"POOJASHI ENTERPRISES (OPC) PRIVATE LIMITED",
"POOJASINGLA BUILDERS AND ENGINEERS PRIVATE LIMITED",
"POOJAWESTERN METALIKS LIMITED",
"POOJIT COMMERCIAL PVT LTD",
"POOJITHA AGRO INDUSTRIES PRIVATE LIMITED",
"POOJYAYA SECURITY AND MAN POWER SERVICES PRIVATE LIMITED",
"POOL AND WATER CONCEPTS PRIVATE LIMITED",
"POOLAVADI WINDFARM LIMITED",
"POOMALAI HOUSING PRIVATE LIMITED",
"POOMKUDY AGENCIES PRIVATE LIMITED",
"POOMKUDY MOTORS PRIVATE LIMITED",
"POOMKUDY ZAAN PRIVATE LIMITED",
"POOMPUHAR REAL ESTATE PRIVATE LIMITED",
"POOMPUHAR SHIPPING CORPORATION LIMITED",
"POONA AUTO ANCILLARIES PVT LTD",
"POONA BOTTLING COMPANY PRIVATE LIMITED",
"POONA CATHOLIC EDUCATIONAL ASSOCIATION PRIVATE LIMITED",
"POONA COLLEGE OF ARTS SCIENCE AND COMMERCE",
"POONA COUPLINGS PVT LTD",
"POONA DAL AND BESAN MILLS PRIVATE LIMITED",
"POONA DAL AND OIL INDUSTRIES LIMITED",
"POONA DIAGNOSTIC SERVICES PRIVATE LIMITED",
"POONA EYE CARE PRIVATE LIMITED",
"POONA FINE CHEM PRIVATE LIMITED",
"POONA FORGE PRIVATE LIMITED",
"POONA HEALTH SERVICES PRIVATE LIMITED",
"POONA HOSPITAL",
"POONA HOSPITAL AND RESEARCH CENTER",
"POONA INSTITUTE OF MANAGEMENT SCIENCES AND ENTREPRENEURSHIP",
"POONA MOTORS PRIVATE LIMITED",
"POONA PETROLEUM COMPANY PRIVATE LIMITED",
"POONA PNEUMATIC PRIVATE LIMITED",
"POONA PRESSINGS PVT LTD",
"POONA PULSES PRIVATE LIMITED",
"POONA RADIATORS AND OILCOOLERS PRIVATE LIMITED",
"POONA RANCHI CARGO MOVERS PRIVATE LIMITED",
"POONA RANCHI ROADWAYS LOGISTICS PRIVATE LIMITED",
"POONA RENT A CAB INDIA PRIVATE LIMITED",
"POONA ROLLER FLOUR MILLS LTD",
"POONA SECURITY INVESTIGATION AND CONSULTANCY SERVICES PRIVATE LIMITED",
"POONA SHIMS PRIVATE LIMITED",
"POONA WAREHOUSING PVT LTD",
"POONAM AUNDH LAND DEVELOPERS PRIVATE LIMITED",
"POONAM BAZAR PRIVATE LIMITED",
"POONAM EXPRESS CARGO PRIVATE LIMITED",
"POONAM GRAH NIRMAN PRIVATE LIMITED",
"POONAM HOUSECON PRIVATE LIMITED",
"POONAM IT CONSULTING SERVICES PRIVATE LIMITED",
"POONAM LOGISTICS PRIVATE LIMITED",
"POONAM MARBLE PRIVATE LIMITED",
"POONAM MUNNAPRASAD CHOURASIYA ( KASANA)",
"POONAM PAPER IMPEX (INDIA) PRIVATE LIMITED",
"POONAM PETROCHAM PRIVATE LIMITED",
"POONAM PHARMA PVT LTD",
"POONAM PIPES & TUBES PRIVATE LIMITED",
"POONAM POLYMERS PRIVATE LIMITED",
"POONAM PROCESSORS PRIVATE LIMITED",
"POONAM ROLLER FLOUR PRIVATE LIMITED",
"POONAM STORAGE SOLUTIONS PRIVATE LIMITED",
"POONAM STRIPS PRIVATE LIMITED",
"POONAM TEXTILES PRIVATE LIMITED",
"POONAM WOOD PACKING PRIVATE LIMITED",
"POONAWALA JET FINTECH PRIVATE LIMITED",
"POONAWALLA ASTONISH STUD PRIVATE LIMITED",
"POONAWALLA AVIATION PRIVATE LIMITED",
"POONAWALLA CREDIT PRIVATE LIMITED",
"POONAWALLA DEVELOPERS PRIVATE LIMITED",
"POONAWALLA ESTATES STUD AND AGRI FARM PRIVAE LIMITED",
"POONAWALLA FINANCE PRIVATE LIMITED",
"POONAWALLA FINANCIALS PRIVATE LIMITED",
"POONAWALLA FINCORP LIMITED",
"POONAWALLA INVESTMENTS AND INDUSTRIES PRIVATE LIMITED",
"POONAWALLA JET FINTECH PRIVATE LIMITED",
"POONAWALLA MANAGEMENT CONSULTANCY PRIVATE LIMITED",
"POONAWALLA MYSTICAL STUD PRIVATE LIMITED",
"POONAWALLA PROPERTIES PRIVATE LIMITED",
"POONAWALLA RACING AND BREEDING PRIVATE LIMITED",
"POONAWALLA SHARES AND SECURITIES PVT LTD",
"POONAWALLA STUD FARM PRIVATE LIMITED",
"POONGULAZHI JEWELLERS PRIVATE LIMITED",
"POONIA ASSOCIATES PRIVATE LIMITED",
"POONYA STEEL PROCESSORS PRIVATE LIMITED",
"POORAM RESIDENCY HOTEL INDIA PRIVATE LIMITED",
"POORAN CHAND FLOUR MILL PRIVATE LIMITED",
"POORANI ANIMAL AGROMED CENTRE PRIVATE LIMITED",
"POORANMAL JEWELLERS SONS PRIVATE LIMITED",
"POORNA APP SYSTEMS PRIVATE LIMITED",
"POORNA BUILD-TECH PRIVATE LIMITED",
"POORNA POSHAKH BHANDAR PRIVATE LIMITED",
"POORNA TRENDZ PRIVATE LIMITED",
"POORNAM INFO VISION PRIVATE LIMITED",
"POORNAM PROCESS ENGINEERS PRIVATE LIMITED",
"POORNAM TECHNOLOGIES PRIVATE LIMITED",
"POORNAPRAGNA COLLEGE",
"POORNAPRAJNA EDUCATION CENTRE",
"POORNATHA INFRASTRUCTURE PRIVATE LIMITED",
"POORNIMA CARBON PRIVATE LIMITED",
"POORNIMA DAIRY PRODUCTS",
"POORNIMA ENTREPRENEUR PRIVATE LIMITED",
"POORNIMA GROUP OF COLLEGES",
"POORNIMA HANDICRAFTS PRIVATE LIMITED",
"POORNIMAA INDUSTRIES AND AGENCIES PRIVATE LIMITED",
"POORVA CHEMTECH PRIVATE LIMITED",
"POORVA ENGINEERING AND TOOLS PRIVATE LIMITED",
"POORVAN CHAL COLD STORAGE AND ICE INDUSTRIES PRIVATE LIMITED",
"POORVANCHAL ACID PRIVATE LIMITED",
"POORVI INFINITE PRIVATE LIMITED",
"POORVI SALES AND SERVICES PRIVATE LIMITED",
"POORVIK ENGINEERS PRIVATE LIMITED",
"POORVIKA MOBILES PRIVATE LIMITED",
"POOVAI CONSTRUCTIONS PRIVATE LIMITED",
"POOVARASI TEXTILE MILLS PRIVATE LIMITED",
"POOVATHINGAL ASSAY AND HALMARKING CENTRE PRIVATE LIMITED",
"POP ONLINE SERVICES PRIVATE LIMITED",
"POPAWALA CHEMICALS PRIVATE LIMITED",
"POPCORN FURNITURE AND LIFESTYLE PRIVATE LIMITED",
"POPCORN INFOTECH PRIVATE LIMITED",
"POPE JOHN PAUL II COLLEGE OF EDUCATION",
"POPEES BABY CARE PRODUCTS PRIVATE LIMITED",
"POPKORN PR PLUS COMMUNICATION PRIVATE LIMITED",
"POPLAY KNITFAB PVT LTD",
"POPLEY & SONS JEWELLERS PRIVATE LIMITED",
"POPLEY DIAMOND AND GOLD PLAZA PRIVATE LIMITED",
"POPLI GRAPHICS PRIVATE LIMITED",
"POPNETIC FASHIONS PRIVATE LIMITED",
"POPPY MATTRESS PRIVATE LIMITED",
"POPPY REALTORS PRIVATE LIMITED",
"POPPYS HOTEL PRIVATE LIMITED",
"POPPYS KNITWEAR PRIVATE LIMITED",
"POPREACH TECHNOLOGIES PRIVATE LIMITED",
"POPULACE ESTATES PRIVATE LIMITED",
"POPULAR (AUTOTECH) BATTERIES PRIVATE LIMITED",
"POPULAR AGENCIES PRIVATE LIMITED",
"POPULAR AUTO DEALERS PRIVATE LIMITED",
"POPULAR AUTOWORKS PRIVATE LIMITED",
"POPULAR BAKERY PRODUCTS PRIVATE LIMITED",
"POPULAR BUILDESTATE PRIVATE LIMITED",
"POPULAR CARD TECHNOLOGY PRIVATE LIMITED",
"POPULAR COLD STORAGE PRIVATE LIMITED",
"POPULAR CONCRETE PRIVATE LIMITED",
"POPULAR DISTRIBUTORS PRIVATE LIMITED",
"POPULAR ENTERTAINMENT NETWORK PRIVATE LIMITED",
"POPULAR FASHION PRIVATE LIMITED",
"POPULAR FOOTWEARS INDIA PRIVATE LIMITED",
"POPULAR FORGE (MADRAS) PRIVATE LIMITED",
"POPULAR FOUNDATIONS LIMITED",
"POPULAR FOUNDATIONS PRIVATE LIMITED",
"POPULAR FREIGHT CARGO PRIVATE LIMITED",
"POPULAR GARMENTS & KNIT FEB PVT LTD",
"POPULAR INDIA VACATIONS PRIVATE LIMITED",
"POPULAR INSTITUTE OF MEDICAL FOUNDATION",
"POPULAR MEDICARE LIMITED",
"POPULAR MEGA MOTORS (INDIA) PRIVATE LIMITED",
"POPULAR MOTOR WORLD PRIVATE LIMITED",
"POPULAR MOTORCYCLE COMPANY",
"POPULAR PAINTS & CHEMICALS",
"POPULAR PALACE GEM PRIVATE LIMITED",
"POPULAR PUBLICITY & ADVERTISING INDIA PRIVATE LIMITED",
"POPULAR PUBLISHERS AND DISTRIBUTORS PRIVATE LIMITED",
"POPULAR PULSE PRODUCTS PRIVATE LIMITED",
"POPULAR RICH BREAD INDIA PRIVATE LIMITED",
"POPULAR RUBBER WORKS PVT LTD",
"POPULAR SCOOTERS PRIVATE LIMITED",
"POPULAR SHOE MART INDIA PRIVATE LIMITED",
"POPULAR SUPPLIERS PVT LTD",
"POPULAR SWITCH GEARS PVT LTD",
"POPULAR TECH MEDIA (INDIA) PRIVATE LIMITED",
"POPULAR UDYOG PRIVATE LIMITED",
"POPULAR VEHICLES AND SERVICES LIMITED",
"POPULAR VEHICLES AND SERVICES PRIVATE LIMITED",
"POPULAR WHEELERS INDIA PRIVATE LIMITED",
"POPULATION COUNCIL",
"POPULATION COUNCIL INSTITUTE",
"POPULATION FOUNDATION OF INDIA",
"POPULATION HEALTH SERVICES INDIA",
"POPULATIONCOUNCIL CONSULTING PRIVATE LIMITED",
"POPURI ENGINEERING TECHNOLOGIES PRIVATE LIMITED",
"POPURI INDUSTRIES LIMITED",
"POPURI STEELS LIMITED",
"PORBANDAR COAL AGENCIES PRIVATE LIMITED",
"PORBANDAR DWARKA EXPRESSWAY PRIVATE LIMITED",
"PORBANDAR JETPUR TOLLWAY PRIVATE LIMITED",
"PORBANDAR SOLAR POWER LIMITED",
"PORCELAIN CRAFTS & COMPONENTS EXIM PVT LTD",
"PORE SEALS INDIA PRIVATE LIMITED",
"PORECHA GLOBAL SECURITIES PRIVATE LIMITED",
"PORIMA TECHNOLOGY PRIVATE LIMITED",
"PORITE INDIA PRIVATE LIMITED",
"PORNIMA AGRO FARMER PRODUCER COMPANY LIMITED",
"POROSIL INSULATIONS PRIVATE LIMITED",
"PORS & RAO STUDIO PRIVATE LIMITED",
"PORT CITY NIDHI LIMITED",
"PORT ENGINEERS CONSTRUCTION PRIVATE LIMITED",
"PORT ENTERPRISES PRIVATE LIMITED",
"PORT IND SHOE ACCESSORIES PRIVATE LIMITED",
"PORT LOGISTICS MANAGEMENT PRIVATE LIMITED",
"PORT PAIR LOGISTICS INDIA PRIVATE LIMITED",
"PORTA FINESTRA DESIGN INDIA PRIVATE LIMITED",
"PORTACABIN ENGINEERS PRIVATE LIMITED",
"PORTAGE GLOBAL LOGISTICS INDIA PRIVATE LIMITED",
"PORTAL ENGINEERING PRIVATE LIMITED",
"PORTAL VINIMAY PRIVATE LIMITED",
"PORTALL INFOSYSTEMS PRIVATE LIMITED",
"PORTCULLIS DIGITAL INDIA PRIVATE LIMITED OPC",
"PORTDEV INDIA PRIVATE LIMITED",
"PORTECH ENGINEERING PRIVATE LIMITED",
"PORTESCAP INDIA PRIVATE LIMITED",
"PORTFOLIO CONSULTANTS PRIVATE LIMITED",
"PORTFOLIO FASHIONS PRIVATE LIMITED",
"PORTFOLIO FINANCIAL SERVICES LIMITED",
"PORTFORE FINANCIAL CONSULTANTS PRIVATE LIMITED",
"PORTIM CONSUMER PRODUCT PRIVATE LIMITED",
"PORTIQUE HUB TECHNOLOGY PRIVATE LIMITED",
"PORTLAND STORES (WINE) PRIVATE LIMITED",
"PORTMAIN CONNECT PRIVATE LIMITED",
"PORTRAITFLIP ECOMMERCE PRIVATE LIMITED",
"PORTRAVE SOLUTIONS PRIVATE LIMITED",
"PORTRONICS DIGITAL PRIVATE LIMITED",
"PORTRUCKS EQUIPMENTS PRIVATE LIMITED",
"PORTTRADE SHIPPING AGENCIES PRIVATE LIMITED",
"PORTWAY SOLUTIONS INDIA PRIVATE LIMITED",
"PORTWELL INDIA TECHNOLOGY PRIVATE LIMITED",
"PORUS KNITS PRIVATE LIMITED",
"PORUS LABORATORIES PRIVATE LIMITED",
"PORVAIR FILTRATION INDIA PRIVATE LIMITED",
"PORVOO HOME HEALTHCARE PRIVATE LIMITED",
"PORWAL BUILDCON PRIVATE LIMITED",
"PORWAL DIAGNOSTIC & MEDICAL RESEARCH CENTRE PRIVATE LIMITED",
"PORWAL DIESELS PRIVATE. LIMITED",
"PORWAL GINNING AND PRESSING PRIVATE LIMITED",
"PORWAL HOSPITAL PRIVATE LIMITED",
"PORWAL POLYCOT PRIVATE LIMITED",
"PORWAL RETAIL PRIVATE LIMITED",
"PORWAL SHARES AND STOCKS PRIVATE LIMITED",
"PORWAL TAR PRODUCTS PVT LTD",
"POS NIRVANA PRIVATE LIMITED",
"POS SOLUTIONS PRIVATE LIMITED",
"POS WORLD TECHNOLOGIES PRIVATE LIMITED",
"POSANA ENERGY PRIVATE LIMITED",
"POSANI FARM CHEMICALS PVT LTD.",
"POSCO DAEWOO INDIA PRIVATE LIMITED",
"POSCO ELECTRICAL STELL INDIA",
"POSCO ENGINEERING AND CONSTRUCTION INDIA PRIVATE LIMITED",
"POSCO INDIA DELHI STEEL PROCESSING CENTRE PRIVATE LIMITED",
"POSCO INDIA PRIVATE LIMITED",
"POSCO INDIA PROCESSING CENTER PRIVATE LIMITED",
"POSCO INDIA PUNE PROCESSING CENTER PRIVATE LIMITED",
"POSCO INTERNATIONAL INDIA PRIVATE LIMITED",
"POSCO MAHARASHTRA STEEL PRIVATE LIMITED",
"POSCO TMC INDIA PRIVATE LIMITED",
"POSCO-INDIA STEEL DISTRIBUTION CENTER PRIVATE LIMITED",
"POSCO-POGGENAMP ELECTRICAL STEEL PRIVATE LIMITED",
"POSE INTERNATIONAL FOOTWEAR PRIVATE LIMITED",
"POSEDGE TECHNOLOGIES INDIA PRIVATE LIMITED",
"POSEIDON DISTRIBUTORS INDIA PRIVATE LIMITED",
"POSEIDON FOODS PRIVATE LIMITED",
"POSEIDON SHIP STORES",
"POSEIDON SHIPPING AGENCY PRIVATE LIMITED",
"POSH BOUTIQUE PRIVATE LIMITED",
"POSH CHEMICALS PRIVATE LIMITED",
"POSH FRAGRANCES PRIVATE LIMITED",
"POSH HOSPITALITY PRIVATE LIMITED",
"POSH INDIA OFFSHORE PRIVATE LIMITED",
"POSHAK FEEDS PRIVATE LIMITED",
"POSHAK POULTRY AND CATTLE FEED PRIVATE LIMITED",
"POSHKNIT TEX PRIVATE LIMITED",
"POSHMARK INDIA PRIVATE LIMITED",
"POSHOP SYSTEMS PRIVATE LIMITED",
"POSHS CINOTI PRIVATE LIMITED",
"POSHS METAL INDUSTRIES PRIVATE LIMITED",
"POSHTIK AAHAR PRODUCER COMPANY LIMITED",
"POSHTIK MILK PRODUCTS PRIVATE LIMITED",
"POS-HYUNDAI STEEL MANUFACTURING INDIA PRIVATE LIMITED",
"POSIBOLT SOLUTIONS PRIVATE LIMITED",
"POSIDEX TECHONOLOGIES PRIVATE LIMITED",
"POSIDON INFRASTRUCTURE PRIVATE LIMITED",
"POSIFLEX TECHNOLOGY INDIA PRIVATE LIMITED",
"POSIST TECHNOLOGIES PRIVATE LIMITED",
"POSIT SOURCE TECHNOLOGIES PRIVATE LIMITED",
"POSITEX PRIVATE LIMITED",
"POSITION2 MARKETING PRIVATE LIMITED",
"POSITIVE ASSOCIATE PRIVATE LIMITED",
"POSITIVE BIOSCIENCE LIMITED",
"POSITIVE CHEMICALS PRIVATE LIMITED",
"POSITIVE CHIP BOARD INDIA PRIVATE LIMITED",
"POSITIVE FLEXO PACK PRIVATE LIMITED",
"POSITIVE FOOD VENTURES PRIVATE LIMITED",
"POSITIVE FORCE FACILITY MANAGEMENT PRIVATE LIMITED",
"POSITIVE HOUSINGS PRIVATE LIMITED",
"POSITIVE IMAGES PRIVATE LIMITED",
"POSITIVE INTEGERS PRIVATE LIMITED",
"POSITIVE LIFE SCIENCES PRIVATE LIMITED",
"POSITIVE MEDICARE PRIVATE LIMITED",
"POSITIVE METERING PUMPS INDIA PRIVATE LIMITED",
"POSITIVE MOVES INDIA CONSULTING PRIVATE LIMITED",
"POSITIVE PACKAGING INDUSTRIES LIMITED",
"POSITIVE PLASTICS PRIVATE LIMITED",
"POSITIVE THERMOPLASTICS PRIVATE LIMITED",
"POSITIVE VIBEZ BRAND SOLUTION PRIVATE LIMITED",
"POSITIVE WATERPROOFING AND INSULATIONS PRIVATE LIMITED",
"POSITIVEEDGE TECHNOLOGY PRIVATE LIMITED",
"POSITIVEVIEW IMPEX PRIVATE LIMITED",
"POSITIVITY BUSINESSES PRIVATE LIMITED",
"POSITIWISE SOFTWARE PRIVATE LIMITED",
"POSITRA PACKAGING PRIVATE LIMITED",
"POSITRON BIOGENICS PRIVATE LIMITED",
"POSITRON CONSULTING SERVICES PRIVATE LIMITED",
"POSITRON ENERGY LIMITED",
"POSITRON ENERGY PRIVATE LIMITED",
"POSITRON MULTI SPECIALTY AND CANCER HOSPITAL",
"POSITRONIC INTERCONNECTS PRIVATE LIMITED",
"POSITRONICS PVT LTD",
"POSITRUS HEALTHCARE INDIA PRIVATE LIMITED",
"POSO SERVICES PRIVATE LIMITED",
"POSS MULTITRADE PRIVATE LIMITED",
"POSSE INVESTMENTS PRIVATE LIMITED",
"POSSE TRADE PRIVATE LIMITED",
"POSSIBLE EDUCATION PRIVATE LIMITED",
"POSSIT SKILL ORGANISATION",
"POST & TELEGRAPH DEPT , GOI",
"POST BUSTERS MEDIA LABS PRIVATE LIMITED",
"POST GRAD INSTI OF MEDICAL EDUC&RESEARCH",
"POST GRADUATE GOVERNMENT COLLEGE",
"POST GRADUATE INSTITUTE OF MEDICAL EDUCATION & RESEARCH CHANDIGARH",
"POST GRADUATE INSTITUTE OF VETERINARY EDUCATION AND RESEARCH PGIVER",
"POSTCARD MEDIA LLP",
"POSTDOT TECHNOLOGIES PRIVATE LIMITED",
"POSTERITY CONSULTING PRIVATE LIMITED",
"POSTLOR INTERACTIVE INDIA PRIVATE LIMITED",
"POSTRANSACT SERVICES PRIVATE LIMITED",
"POSTRONIX SOLUTIONS PRIVATE LIMITED",
"POT FUL INDIA PRIVATE LIMITED",
"POTA GLOBAL LOGISTICS INDIA PRIVATE LIMITED",
"POTAFO PRIVATE LIMITED",
"POTAIN INDIA PRIVATE LIMITED",
"POTALIA ENTERPRISES PRIVATE LIMITED",
"POTALIYA INFRA PRIVATE LIMITED",
"POTALIYA PETROCHEMICALS PRIVATE LIMITED",
"POTALIYA POWER PRIVATE LIMITED",
"POTATO KING FOODS LIMITED",
"POTDAR CHEMICAL INDUSTRIES PRIVATE LIMITED",
"POTE SPICES PRIVATE LIMITED",
"POTENCE CONTROLS PRIVATE LIMITED",
"POTENS TALENTIAL SOLUTIONS PRIVATE LIMITED",
"POTENT INFOTECH PRIVATE LIMITED",
"POTENT PRODUCTS PRIVATE LIMITED",
"POTENT WATER CARE PRIVATE LIMITED",
"POTENTIAL BUILDERS PVT LTD",
"POTENTIAL INFRA PROJECTS LIMITED",
"POTENTIAL INFRA VENTURES PRIVATE LIMITED",
"POTENTIAL PROJECT MANAGERS PRIVATE LIMITED",
"POTENTIAM OFFSHORE SERVICES PRIVATE LIMITED",
"POTENZ INFRATECH PRIVATE LIMITED",
"POTHEN MOTORS PRIVATE LIMITED",
"POTHIGAI PHARMA PRIVATE LIMITED",
"POTHIGAI POWER SOLUTIONS PRIVATE LIMITED",
"POTHYS PRIVATE LIMITED",
"POTION INFOSYSTEMS PRIVATE LIMITED",
"POTION REALCON PRIVATE LIMITED",
"POTISSIMUS ARROW SHOES PRIVATE LIMITED",
"POTLAM RETAIL CONCEPTS PRIVATE LIMITED",
"POTLI BABA MEDIAHOUSE PRIVATE LIMITED",
"POTLURI AGROFOOD PRODUCTS PRIVATE LIMITED",
"POTTEKKATTU RUBBERS PVT LTD",
"POTTI SREERAMULU TELUGU UNIVERSITY",
"POTUS INDIA PRIVATE LIMITED",
"POU CHONG BROTHERS PVT LTD",
"POU CHONG FOOD PRODUCTS PRIVATE LIMITED",
"POULOMI ESTATES PRIVATE LIMITED",
"POULOMI HOSPITALS PRIVATE LIMITED",
"POULOMI INFRA PRIVATE LIMITED",
"POULTECH AGRO FOODS PRIVATE LIMITED",
"POULTRY SPECIALITIES LIMITED",
"POUNDWIZE FOREX PRIVATE LIMITED",
"POURE INOX PRIVATE LIMITED",
"POURING POUNDS INDIA PRIVATE LIMITED",
"POURNIMA WATER TECHNOLOGY PRIVATE LIMITED",
"POUSSE MANAGEMENT SERVICES PRIVATE LIMITED",
"POWAI LABS TECHNOLOGY PRIVATE LIMITED",
"POWDER SPRAY INDUSTRIES PRIVATE LIMITED",
"POWER AGRO FARMS PRIVATE LIMITED",
"POWER AND ENERGY CONSULTANTS INDIA PRIVATE LIMITED",
"POWER AUTOCOMP PRIVATE LIMITED",
"POWER BEST ELECTRICALS PRIVATE LIMITED",
"POWER BIKES PRIVATE LIMITED",
"POWER BREAK SERVICES PRIVATE LIMITED",
"POWER BRIDGE SYSTEMS PRIVATE LIMITED",
"POWER BRIDGE TECHNOLOGIES PRIVATE LIMITED",
"POWER BUILD BATTERIES PRIVATE LIMITED",
"POWER BUILD PRIVATE LIMITED",
"POWER BULLS CAPITAL SERVICES PRIVATE LIMITED",
"POWER CABLE INDUSTRIES",
"POWER CAR INDIA PRIVATE LIMITED",
"POWER CARBONS PVT LTD",
"POWER CENTRE PRIVATE LIMITED",
"POWER CHEM PLAST LIMITED",
"POWER CITY COAL PRIVATE LIMITED",
"POWER CONCEPT INDIA PRIVATE LIMITED",
"POWER CONTROL ELECTRO SYSTEMS PRIVATE LIMITED",
"POWER DISTRIBUTION SERVICES LIMITED",
"POWER DRIVES ENTERPRISES INDIA PRIVATE LIMITED",
"POWER ELECTROMECHANICS PRIVATE LIMITED",
"POWER ENGINEERING INDIA PRIVATE. LIMITED.",
"POWER EQUIPMENTS SYSTEM PRIVATE LIMITED",
"POWER ERECTORS PRIVATE LIMITED",
"POWER EXCHANGE INDIA LIMITED",
"POWER FABRICATORS INDIA PRIVATE LIMITED",
"POWER FINANCE CORPORATION LIMITED",
"POWER FORMERS ENGRS P LIMITED",
"POWER GENESYS PRIVATE LIMITED",
"POWER GRID CORPORATION OF INDIA LIMITED",
"POWER HIGH ENGINEERS PRIVATE LIMITED",
"POWER INTEGRATIONS INDIA PRIVATE LIMITED",
"POWER INTELLECTUAL ENGINEERING AND MANAGEMENT SERVICES PRIVATE LIMITED",
"POWER IT SERVICES PRIVATE LIMITED",
"POWER LINK GENSETS PRIVATE LIMITED",
"POWER LINK SYSTEM PRIVATE LIMITED",
"POWER LITE BLOCKS PRIVATE LIMITED",
"POWER MACHINES INDIA LIMITED",
"POWER MATRIX SOLUTIONS PRIVATE LIMITED",
"POWER MECH INDUSTRI PRIVATE LIMITED",
"POWER MECH INFRA LIMITED",
"POWER MECH INFRA PRIVATE LIMITED",
"POWER MECH PROJECTS LIMITED",
"POWER MEDIA P LIMITED",
"POWER MOBILITY PRIVATE LIMITED",
"POWER NET SYSTEMS PRIVATE LIMITED",
"POWER NETWORK ENGINEERS PRIVATE LIMITED",
"POWER OF ONE LOGISTICS PARK PRIVATE LIMITED",
"POWER ONE MICRO SYSTEMS PRIVATE LIMITED",
"POWER PACK STEEL INDUSTRIES PRIVATE LIMITED",
"POWER PACKARD PRIVATE LIMITED",
"POWER PALAZZO PRIVATE LIMITED",
"POWER PHARMACEUTICALS PRIVATE LIMITED",
"POWER PLANET LIGHTING SOLUTION PRIVATE LIMITED",
"POWER PLANNERS & ENGINEERS PRIVATE LIMITED",
"POWER PLANT INDUSTRIES ( INDIA ) PRIVATE LIMITED",
"POWER PLASTECH PRIVATE LIMITED",
"POWER PLAY RETAIL PRIVATE LIMITED",
"POWER POINT CARTRIDGES PRIVATE LIMITED",
"POWER POINT ENGINEERING PRIVATE LIMITED",
"POWER PRINT CARTRIDGES PRIVATE LIMITED",
"POWER PUMP PRIVATE LIMITED",
"POWER RESEARCH AND DEVELOPMENT CONSULTANTS PRIVATE LIMITED",
"POWER RUBBER INDUSTRIES PRIVATE LIMITED",
"POWER SOURCE ENGINE PARTS PRIVATE LIMITED",
"POWER SPECIALITY LABS PRIVATE LIMITED",
"POWER STORES E-COMMERCE PRIVATE LIMITED",
"POWER TEAM INDIA LIMITED",
"POWER TECH CONSTRUCTIONS P LTD",
"POWER TECH GLOBAL PRIVATE LIMITED",
"POWER TECH METAL TRADES AND CONSULTANCY PRIVATE LIMITED",
"POWER TECH MINING PRIVATE LIMITED",
"POWER TECHNICS INDIA PRIVATE LIMITED",
"POWER TECHNICS INFOSOLUTIONS PRIVATE LIMITED",
"POWER TECHNOLOGY COMPUTERS PRIVATE LIMITED",
"POWER TO EMPOWER SKILLS PRIVATE.LIMITED.",
"POWER TOOLS & APPLIANCES COMPANY PRIVATE LIMITED",
"POWER TRACK ANALYSERS PRIVATE LIMITED",
"POWER TRADEWINGS PRIVATE LIMITED",
"POWER TRADING COORPERATION",
"POWER TRANSMISSION CORPORATION OF UTTARAKHAND LIMITED",
"POWER UP INFRA PROJECTS PRIVATE LIMITED",
"POWER VISION INFOSERVICES PRIVATE LIMITED (OPC)",
"POWER WATER TECH PRIVATE LIMITED",
"POWER WEAVE SOFTWARE SERVICES PRIVATE LIMITED",
"POWER WELD EQUIPMENTS INDIA PRIVATE LIMITED",
"POWER WIND CONSTRUCTION & INFRASTRUCTURE (JAORA) PRIVATE LIMITED",
"POWER2SME PRIVATE LIMITED",
"POWERADE SERVICES PRIVATE LIMITED",
"POWERAUTO DEALERS PRIVATE LIMITED",
"POWERBLUE INTERNATIONAL ECOTECH PRIVATE LIMITED",
"POWERBRAND MARKETING PRIVATE LIMITED",
"POWERCAM ELECTRICALS PRIVATE LIMITED",
"POWERCAP TRANSFORMER TECHNOLOGIES PRIVATE LIMITED",
"POWERCARE SOLUTIONS PRIVATE LIMITED",
"POWERCOM SMART GRID SOLUTIONS INDIA PRIVATE LIMITED",
"POWERCON CEMENT PRIVATE LIMITED",
"POWERCON ELECTRONICS PRIVATE LIMITED",
"POWERCON VENTURES INDIA PRIVATE LIMITED'",
"POWERCORE INDUSTRIES INDIA PRIVATE LIMITED",
"POWERCRAFT ELECTRONICS PRIVATE LIMITED",
"POWERDRIFT STUDIOS PRIVATE LIMITED",
"POWERDRIVE BEARINGS PRIVATE LIMITED",
"POWERED BOOKKEEPING SOLUTIONS PRIVATE LIMITED",
"POWERED EPC SERVICES LIMITED",
"POWEREDGE ENERGIE PRIVATE LIMITED",
"POWEREQUIP MARKETING PRIVATE LIMITED",
"POWEREX INDUSTRIES PRIVATE LIMITED",
"POWERFABRICA PRIVATE LIMITED",
"POWERFLOW VINIMAY PVT.LTD.",
"POWERFLY AVIATION SERVICES PRIVATE LIMITED",
"POWERFORCE ENERGY SOLUTION PRIVATE LIMITED",
"POWERFULL PRINTERS PRIVATE LIMITED",
"POWERGEAR LIMITED",
"POWERGOLD PETROCHEM PRIVATE LIMITED",
"POWERGRACE INDUSTRIES LIMITED",
"POWERGRID AJMER PHAGI TRANSMISSION LIMITED",
"POWERGRID ALIGARH SIKAR TRANSMISSION LIMITED",
"POWERGRID ANANTHPURAM KURNOOL TRANSMISSION LIMITED",
"POWERGRID BHADLA SIKAR TRANSMISSION LIMITED",
"POWERGRID BHADLA TRANSMISSION LIMITED",
"POWERGRID BHIND GUNA TRANSMISSION LIMITED",
"POWERGRID BHUJ TRANSMISSION LIMITED",
"POWERGRID BIKANER TRANSMISSION SYSTEM LIMITED",
"POWERGRID ENGINEERING PRIVATE LIMITED",
"POWERGRID ER NER TRANSMISSION LIMITED",
"POWERGRID FATEHGARH TRANSMISSION LIMITED",
"POWERGRID GOMTI YAMUNA TRANSMISSION LIMITED",
"POWERGRID JABALPUR TRANSMISSION LIMITED",
"POWERGRID JAWAHARPUR FIROZABAD TRANSMISSION LIMITED",
"POWERGRID KALA AMB TRANSMISSION LIMITED",
"POWERGRID KHETRI TRANSMISSION SYSTEM LIMITED",
"POWERGRID MEDINIPUR JEERAT TRANSMISSION LIMITED",
"POWERGRID MEERUT SIMBHAVALI TRANSMISSION LIMITED",
"POWERGRID MITHILANCHAL TRANSMISSION LIMITED",
"POWERGRID NARELA TRANSMISSION LIMITED",
"POWERGRID NM TRANSMISSION LIMITED",
"POWERGRID PARLI TRANSMISSION LIMITED",
"POWERGRID RAMGARH TRANSMISSION LIMITED",
"POWERGRID RAMPUR SAMBHAL TRANSMISSION LIMITED",
"POWERGRID SIKAR TRANSMISSION LIMITED",
"POWERGRID SOUTHERN INTERCONNECTOR TRANSMISSION SYSTEM LIMITED",
"POWERGRID TELESERVICES LIMITED",
"POWERGRID UNCHAHAR TRANSMISSION LIMITED",
"POWERGRID VARANASI TRANSMISSION SYSTEM LIMITED",
"POWERGRID VEMAGIRI TRANSMISSION LIMITED",
"POWERGRID VIZAG TRANSMISSION LIMITED",
"POWERGRID WARORA TRANSMISSION LIMITED",
"POWERGURU INFRATECH PRIVATE LIMITED",
"POWERH2O WATER TECHNOLOGIES PRIVATE LIMITED",
"POWERHF INDIA PRIVATE LIMITED",
"POWERICA LIMITED",
"POWERICA SALES AND SERVICES LIMITED",
"POWERIND PRIVATE LIMITED",
"POWERINST ELECTROMAGNETS PRIVATE LIMITED",
"POWERJAC SYSTEMS PRIVATE LIMITED",
"POWERKIDS ENTERTAINMENT PRIVATE LIMITED",
"POWERLAND AGRO TRACTOR VEHICLES PRIVATE LIMITED",
"POWERLINE INFRA PRIVATE LIMITED",
"POWERLINERS CORPORATION PRIVATE LIMITED",
"POWERLINK OIL REFINERY LIMITED",
"POWERLINK SOLAR PRIVATE LIMITED",
"POWERLINKS TRANSMISSION LIMITED",
"POWERLITE ELECTRICALS INDIA PRIVATE LIMITED",
"POWERLITE GENERATOR SYSTEMS PRIVATE LIMITED",
"POWERLITE MANUFACTURING COMPANY PRIVATE LIMITED",
"POWERLOOK APPARELS PRIVATE LIMITED",
"POWERLOOM DEVELOPMENT AND EXPORT PROMOTION COUNCIL",
"POWERMAG CONTROL SYSTEMS PRIVATE LIMITED",
"POWERMASTER ENGINEERS PRIVATE LIMITED",
"POWERMASTER TOOLS PVT LTD",
"POWERMASTER TORQUE SYSTEMS PVT LTD",
"POWERMAX",
"POWERMAX FITNESS INDIA PRIVATE LIMITED",
"POWERMAXX LUBE INDIA",
"POWERMECH (INDIA) PRIVATE LIMITED",
"POWERMECH SERVICES PRIVATE LIMITED",
"POWERMET INDIA PRIVATE LIMITED",
"POWERNET COMMUNICATIONS PRIVATE LIMITED",
"POWERNET SOLUTIONS PRIVATE LIMITED",
"POWERNETICS EQUIPMENT (INDIA) PRIVATE LIMITED",
"POWERONEDATA SOFTWARE RESEARCH PRIVATE LIMITED",
"POWERPACK COMMUTATORS (INDIA) PVT LTD",
"POWERPACK ELECTRICALS (INDIA) PRIVATE LIMITED",
"POWERPOINT MARKETING SERVICES PRIVATE LIMITED",
"POWERRICH ENGINEERING ERECTORS INDIA PRIVATE LIMITED",
"POWERSEM SEMICONDUCTORS PRIVATE LIMITED",
"POWERSERV TECHNOLOGIES PRIVATE LIMITED",
"POWERSHELL TECHNOLOGIES PRIVATE LIMITED",
"POWERSOFT IT PRIVATE LIMITED",
"POWERSOL ENGINEERS AND CONSULTANTS PRIVATE LIMITED",
"POWERSOL INFRA SERVICES PRIVATE LIMITED",
"POWERSPACK AUTOMATION PRIVATE LIMITED",
"POWERSPACK INDUSTRIES PRIVATE LIMITED",
"POWERSUN INDIA PRIVATE LIMITED",
"POWERSUN INFRA PRIVATE LIMITED",
"POWERTEC ENGINEERING PRIVATE LIMITED",
"POWERTEC SUPPLIES INDIA PRIVATE LIMITED",
"POWERTECH CONSULTANTS INDIA PRIVATE LIMITED",
"POWERTECH DISTRIBUTORS PRIVATE LIMITED",
"POWERTECH ELECTROINFRA PRIVATE LIMITED",
"POWERTECH ENGINEERS",
"POWERTECH EQUIPMENT PRIVATE LIMITED",
"POWERTECH INDUSTRIAL SERVICES PRIVATE LIMITED",
"POWERTECH INFRAENERGY PRIVATE LIMITED",
"POWERTECH MECH PRIVATE. LIMITED",
"POWERTECH PERIPHERALS PRIVATE LIMITED",
"POWERTECH POLLUTION CONTROLS PRIVATE LIMITED",
"POWERTECH SWITCHGEARS INDIA PVT LTD",
"POWERTECH TRANSFORMERS & CONTROLS PRIVATE LIMITED",
"POWERTECK PRODUCTS INDIA PRIVATE LIMITED",
"POWERTEK IDEAS PRIVATE LIMITED",
"POWERTEL ENGINEERING PRIVATE LIMITED",
"POWERTEST GLOBAL PRIVATE LIMITED",
"POWERTEX TOOLS COMPANY PRIVATE LIMITED",
"POWERTHERM SYSTEMS PRIVATE LIMITED",
"POWERTOOLS MARKETING LIMITED",
"POWERTRAC INDUSTRIES LIMITED",
"POWERTRAC METERS PRIVATE LIMITED",
"POWERTRAC SOLAR PROJECTS LIMITED",
"POWERTRANS ELECTRIC CO. PRIVATE LIMITED",
"POWERTRON INDIA PRIVATE LIMITED",
"POWERTRON PRODUCTS PRIVATE LIMITED",
"POWERTRONICS CONTROL SYSTEM PRIVATE LIMITED",
"POWERTRONIKS SOLAR PRIVATE LIMITED",
"POWERTRONIX ELECTRICALS PRIVATE LIMITED",
"POWERTRONIX ENGINEERING PRIVATE LIMITED",
"POWERWINGS BIKES PRIVATE LIMITED",
"POWERXP CONSULTANTS PRIVATE LIMITED",
"POWERZONE OIL REFINERY PRIVATE LIMITED",
"POWMEX STEELS LIMITED",
"POWRZ DIGITAL INDIA PRIVATE LIMITED",
"POYILAKADA FISHERIES PRIVATE LIMITED",
"POYSHA OXYGEN PRIVATE LIMITED",
"POYSHA PACKAGING PRIVATE LIMITED",
"POYSHA POWER GENERATION PRIVATE LIMITED",
"POZIBILITY TECHNOLOGIES PRIVATE LIMITED",
"POZIOM VENTURES PRIVATE LIMITED",
"POZITIVE ELECTRICITY & GAS PRIVATE LIMITED",
"PP AOTU INNOVATORS UNIT3",
"PP DIGITALS INDIA PRIVATE LIMITED",
"PP SOFTTECH PRIVATE LIMITED",
"PPA DISTRIBUTION PRIVATE LIMITED",
"PPA MARKETING PRIVATE LIMITED",
"PPA OVERSEAS PRIVATE LIMITED",
"PPAP AUTOMOTIVE LIMITED",
"PPAP TECHNOLOGY LIMITED",
"PPAP TOKAI INDIA RUBBER PRIVATE LIMITED",
"PPC BROADBAND INDIA PRIVATE LIMITED",
"PPC TECHNOLOGIES INDIA PRIVATE LIMITED",
"PPD PHARMACEUTICAL DEVELOPMENT INDIA PRIVATE LIMITED",
"PPF GRAPES GROWER FAIR FARMERS PRODUCER COMPANY LIMITED",
"PPFAS ASSET MANAGEMENT PRIVATE LIMITED",
"PPG ASIAN PAINTS PRIVATE LIMITED",
"PPG INDUSTRIES INC.",
"PPG INNOVATIONS (OPC) PRIVATE LIMITED",
"PPI ENGINEERING AND CONSTRUCTION PRIVATE LIMITED",
"PPIC SOFTWARE SOLUTIONS PRIVATE LIMITED",
"PPK GRANITE AND CRUSHER PRODUCTS PRIVATE LIMITED",
"PPK NEWSCLICK STUDIO PRIVATE LIMITED",
"PPL CORPORATION",
"PPL ENTERPRISES PRIVATE LIMITED",
"PPLUS FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"PPMC PRIVATE LIMITED",
"PPMS FIELD MARKETING PRIVATE LIMITED",
"PPMS JEWELLERS PRIVATE LIMITED",
"PPMS RESOURCES PRIVATE LIMITED",
"PPN POWER GENERATING COMPANY PRIVATE LIMITED",
"PPP GLOBAL PRIVATE LIMITED",
"PPPASSCHIP TECHNOLOGIES PRIVATE LIMITED",
"PPR HOTELIERS PRIVATE LIMITED",
"PPR HOUSING AND CONSTRUCTION LIMITED",
"PPR INFRASTRUCTURE LIMITED",
"PPR M SAND LLP",
"PPR SOUTH ASIA PRIVATE LIMITED",
"PPS BUILDERS PRIVATE LIMITED",
"PPS BUSINESS SOLUTIONS PRIVATE LIMITED",
"PPS ENERGY SOLUTIONS PRIVATE LIMITED",
"PPS INFRASTRUCTURE LIMITED",
"PPS MOTORS PRIVATE LIMITED",
"PPS TEA PRIVATE LIMITED",
"PPTL PRIVATE LIMITED",
"PPYRUS INDIA PRIVATE LIMITED",
"PQE INDIA PRIVATE LIMITED",
"PQUBE BUSINESS SOLUTIONS PRIVATE LIMITED",
"PR & EM CANDID COMMUNICATION PRIVATE LIMITED",
"PR AGRO NUTRI PRIVATE LIMITED",
"PR ASSOCIATES",
"PR BUSINESS DEVELOPMENT PRIVATE LIMITED",
"PR DIRECTOR OF COMMERCIAL AUDIT CENTRAL AND EX OFFICIO MEMBER AUDIT BOARD 1 KOLKATA",
"PR ENERGY AND MINCHEM PRIVATE LIMITED",
"PR ENGINEERING AND CONSULTANCY PRIVATE LIMITED",
"PR EXPRESS LOGISTICS (OPC) PRIVATE LIMITED",
"PR FLEXMAKE PRIVATE LIMITED",
"PR FLOUR MILLS PRIVATE LIMITED",
"PR GLOBAL RESOURCES INDIA PRIVATE LIMITED",
"PR GOVT ADERSH H S S TAWANAGAR",
"PR GOVT HOME SCIENCE COLLEGE HOSHANGABAD",
"PR GOVT MGM COLLEGE ITARSI",
"PR MOULDS PRIVATE LIMITED",
"PR PUNDIT PUBLIC RELATIONS PVT LTD",
"PR READYMIX INDIA PRIVATE LIMITED",
"PR SARKAR CHARITABLE FOUNDATION",
"PR SERVER SOLUTIONS PRIVATE LIMITED",
"PR WATER TREATMENTS PRIVATE LIMITED",
"PRA COMPUTER FORMS PRIVATE LIMITED",
"PRA INDIA PRIVATE LIMITED",
"PRA REALTY INDIA PRIVATE LIMITED.",
"PRA SWAMI FOODS PRIVATE LIMITED",
"PRA VENTURES PRIVATE LIMITED",
"PRAADIS LUXURY DIVISION PRIVATE LIMITED",
"PRAADIS STRATEGY DEVELOPMENT AND TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"PRAAKH ELECTRICALS PRIVATE LIMITED",
"PRAANA ENERGY INDIA PRIVATE LIMITED",
"PRAANATH TRADERS PRIVATE LIMITED",
"PRAARTHANA MED PRIVATE LIMITED",
"PRAAVY STERLING PRIVATE LIMITED",
"PRABAL ETHNICS PRIVATE LIMITED",
"PRABAL MERCANTILE PRIVATE LIMITED",
"PRABAL MOTORS PRIVATE LIMITED",
"PRABAL TRADERS AND ADVISORS PRIVATE LIMITED",
"PRABARTAK JUTE MILLS LTD",
"PRABA'S VCARE HEALTH CLINIC PRIVATE LIMITED",
"PRABATH SPINNER INDIA PRIVATE LIMITED",
"PRABCO SURGIMED PRIVATE LIMITED",
"PRABH DAYAL OM PARKASH INFRASTRUCTURE PRIVATE LIMITED",
"PRABHA AUTO PRODUCTS PRIVATE LIMITED",
"PRABHA AUTOMOTIVE ENGINEERS PRIVATE LIMITED",
"PRABHA CARS PRIVATE LIMITED",
"PRABHA CHEM INDUSTRIES PRIVATE LIMITED",
"PRABHA ELECTRONICS PRIVATE LIMITED",
"PRABHA ENERGY PRIVATE LIMITED",
"PRABHA ENGINEERING PRIVATE LIMITED",
"PRABHA EXIM PRIVATE LIMITED",
"PRABHA FASHIONS PRIVATE LIMITED",
"PRABHA INDUSTRIES",
"PRABHA INFRASTRUCTURE PRIVATE LIMITED",
"PRABHA LOGISTICS PRIVATE LIMITED",
"PRABHA PUBLICITY PRIVATE LIMITED",
"PRABHA SILK TEXTILES (BANGALORE) PRIVATE LIMITED",
"PRABHA SOFTWARE & TECHNOLOGIES PRIVATE LIMITED",
"PRABHA TRADE IMPEX PVT LTD",
"PRABHA TRADERS SILK SAREES PRIVATE LIMITED",
"PRABHAA GRAND INN",
"PRABHAA WHEELS PRIVATE LIMITED",
"PRABHA-DEVI METALS PRIVATE LIMITED",
"PRABHADEVI PROPERTIES AND TRADING COMPANY LIMITED",
"PRABHAGIYA NIDESHAK SAMAJIK VANIKI PRABHAG SAHARANPUR",
"PRABHAKAR ASSOCIATES PRIVATE LIMITED",
"PRABHAKAR DJEWELS PRIVATE LIMITED",
"PRABHAKAR HYBRID SEEDS PRIVATE LIMITED",
"PRABHAKAR IRON STORE PRIVATE LIMITED",
"PRABHAKAR PAPER MILLS PVT LTD",
"PRABHAKAR PROCESSORS PRIVATE LIMITED",
"PRABHAKAR RAO ASHA PRIYA PROPERTIES PRIVATE LIMITED",
"PRABHANJAN AUTOMOBILES PRIVATE LIMITED",
"PRABHANJAN INDUSTRIES LIMITED",
"PRABHANJAN MULTITRADE PRIVATE LIMITED",
"PRABHAS AUTOMOTIVE PRIVATE LIMITED",
"PRABHAT AGRI BIOTECH LIMITED",
"PRABHAT AUTOWHEELZ PRIVATE LIMITED",
"PRABHAT BOOK DISTRIBUTOR PRIVATE LIMITED",
"PRABHAT CABLES PRIVATE LIMITED",
"PRABHAT CHEMIORGANICS LIMITED",
"PRABHAT COMMODITY BROKERS PRIVATE LIMITED",
"PRABHAT ELASTOMERS PRIVATE LIMITED",
"PRABHAT ELECTROSTEEL PRIVATE LIMITED",
"PRABHAT FERTILIZERS AND CHEMICAL WORKS",
"PRABHAT FERTILIZERS PRIVATE LIMITED",
"PRABHAT FINANCIAL SERVICES LIMITED",
"PRABHAT GINNING AND PRESSING PRIVATE LIMITED",
"PRABHAT GLOBAL COLOURCOATED PRIVATE LIMITED",
"PRABHAT GRAHAK BAZAR PRIVATE LIMITED",
"PRABHAT HERBALS PRIVATE LIMITED",
"PRABHAT HOSPITALITY PRIVATE LIMITED",
"PRABHAT HYBRID SEEDS PRIVATE LIMITED",
"PRABHAT INDUSTRIES",
"PRABHAT KRISHI YANTRA PRIVATE LIMITED",
"PRABHAT MARITIME SERVICES PRIVATE LIMITED",
"PRABHAT MARKETING CO LTD",
"PRABHAT NATURAL ENERGY PRIVATE LIMITED",
"PRABHAT OBRA PRIVATE LIMITED",
"PRABHAT PACKAGING PRIVATE LIMITED",
"PRABHAT PLAZA PRIVATE LIMITED",
"PRABHAT POULTRYBREEDING FARMS PRIVATE LIMITED",
"PRABHAT POWERTECH PRIVATE LIMITED",
"PRABHAT PRAKASHAN PRIVATE LIMITED",
"PRABHAT RENEWABLE ENERGY AND AGRO LIMITED",
"PRABHAT ROTOPACK PRIVATE LIMITED",
"PRABHAT SANDAL PRIVATE LIMITED",
"PRABHAT SAW MILL",
"PRABHAT SILICON PRIVATE LIMITED",
"PRABHAT SOLVENT EXTRACTION INDUSTIRES PRIVATE LIMITED",
"PRABHAT STEEL TRADERS PRIVATE LIMITED",
"PRABHAT STOCK SHARE BROKERS PRIVATE LIMITED",
"PRABHAT SURGICAL COTTON PRIVATE LIMITED",
"PRABHAT SYNTEX PRIVATE LIMITED",
"PRABHAT TEA AND TEXTILES COMPANY PRIVATE LIMITED",
"PRABHAT TEA CO PVT LTD",
"PRABHAT TEA ESTATE (ASSAM) PRIVATE LIMITED",
"PRABHAT TECHNICAL SERVICES PRIVATE LIMITED",
"PRABHAT UDYOG LIMITED",
"PRABHAT WAREHOUSE AND COLD STORAGE PRIVATE LIMITED",
"PRABHAT ZARDA FACTORY (INDIA) PRIVATE LIMITED",
"PRABHATAM ADVERTISING PRIVATE LIMITED",
"PRABHATAM BUILDWELL LIMITED",
"PRABHATAM INFRASTRUCTURES LIMITED",
"PRABHATH I.T.SOLUTIONS PRIVATE LIMITED",
"PRABHATI FOODS PRIVATE LIMITED",
"PRABHAV CONSTRUCTION COMPANY PRIVATE LIMITED",
"PRABHAV REALTY AND INFRASTRUCTURE PRIVATE LIMITED",
"PRABHAVA ORGANICS PRIVATE LIMITED",
"PRABHAVATI MULTISPECIALITY HOSPITAL & RESEARCH CENTER LATUR",
"PRABHHANS INDUSTRIES LIMITED",
"PRABHJOT TRADERS PRIVATE LIMITED",
"PRABHODHANKAR THAKRE JR COLLEGE SHAHAGAD TA AMBAD DIST JALNA",
"PRABHODITA SERVICES INDIA PRIVATE LIMITED",
"PRABHOO LAL RAM RATAN DAS PRIVATE LIMITED",
"PRABHSIFAT ROAD LINES PRIVATE LIMITED",
"PRABHU AASTHA ENTERPRISE PRIVATE LIMITED",
"PRABHU AGARWALLA CONSTRUCTION PRIVATE LIMITED",
"PRABHU ALLOYS PRIVATE LIMITED",
"PRABHU ASSOCIATES CONSULTANTS PRIVATE LIMITED",
"PRABHU BANK LIMITED",
"PRABHU COAL SALES (INDIA) PVT LTD",
"PRABHU ENVIROTEC PRIVATE LIMITED",
"PRABHU FABRICS PRIVATE LIMITED",
"PRABHU FARMS PRIVATE LIMITED",
"PRABHU HOTELS PRIVATE LIMITED",
"PRABHU INDUSTRIAL UDYOG PVT LTD",
"PRABHU INTERIORS PVT LTD",
"PRABHU JAGAT BANDHU COLLEGE",
"PRABHU JEWELLERS PRIVATE LIMITED",
"PRABHU KRIPA AGRO & COLD STORAGE PRIVATE LIMITED",
"PRABHU LASER COMPONENTS PRIVATE LIMITED",
"PRABHU LOGISTICS PRIVATE LIMITED",
"PRABHU MAHAVEER EXPORTS PRIVATE LIMITED",
"PRABHU MONEY TRANSFER PRIVATE LIMITED",
"PRABHU MOTORS PRIVATE LIMITED",
"PRABHU NAIDU PRIVATE LIMITED",
"PRABHU POLY COLOR LIMITED",
"PRABHU POLY PIPES LIMITED",
"PRABHU PROJECTS PRIVATE LIMITED",
"PRABHU RAM STEELS PRIVATE LIMITED",
"PRABHU RESIDENCY PRIVATE LIMITED",
"PRABHU ROCKSHAPE MACHINERY LIMITED",
"PRABHU SHIPPING LINES PRIVATE LIMITED",
"PRABHU SPINNING MILLS PRIVATE LIMITED",
"PRABHU SPONGE PRIVATE LIMITED",
"PRABHU STEEL INDUSTRIES LIMITED",
"PRABHU STONES PRIVATE LIMITED",
"PRABHU WHEEL & AXEL INDIA PRIVATE LIMITED",
"PRABHUDAS LILLADHER ADVISORY SERVICES PRIVATE LIMITED",
"PRABHUDAS LILLADHER FINANCIAL SERVICES PRIVATE LIMITED",
"PRABHUDAS LILLADHER PRIVATE LIMITED",
"PRABHUDAYAL MOHANLAL PRIVATE LIMITED",
"PRABHUDAYAL POLYSTER PRIVATE LIMITED",
"PRABHUDDH AYURVEDIC MEDICAL COLLEGE",
"PRABHUDESSAI HOSPITALS PRIVATE LIMITED",
"PRABHUGOPAL AGRI PRODUCT PRIVATE LIMITED",
"PRABHUJEE ENGLISH MEDIUM SCHOOL",
"PRABHUJEE PROJECTS PRIVATE LIMITED",
"PRABHUKRUPA ESTATES PRIVATE LIMITED",
"PRABHUKRUPA REALTIES PRIVATE LIMITED",
"PRABHUKRUPA SYNTHETICS PRIVATE LIMITED",
"PRABHUNE ENGINEERS AND FABRICATORS PRIVATE LIMITED",
"PRABHURAM PAPERS PRIVATE LIMITED",
"PRABHUSHILA ENGINEERING PRIVATE LIMITED",
"PRABHUSHRE ENTERPRISES PRIVATE LIMITED",
"PRABHUSHREE DUTT TEXTILES PRIVATE LIMITED",
"PRABHUSURAT BUILDWARES PRIVATE LIMITED",
"PRABKIRAT SALES PRIVATE LIMITED",
"PRABODH AND COMPANY PRIVATE LIMITED",
"PRABODH ARTHA WARDHINI PRIVATE LIMITED",
"PRABODH ARTHA-SANCHAY PRIVATE LIMITED",
"PRABODH FOUNDATION",
"PRABODH STEEL PRIVATE LIMITED",
"PRABODHAN GOREGAON",
"PRABODHAN PRAKASHAN PRIVATE LIMITED",
"PRABODHANANDA PRASHANTI NIKETAN",
"PRABODHANKAR VIDYALAY",
"PRABU ENGINEERING ENTERPRISES PRIVATE LIMITED",
"PRABUDDH AYURVEDIC MEDICAL COLLEGE",
"PRABUDH SECURITIES PRIVATE LIMITED",
"PRAC PATIL VENTURE PRIVATE LIMITED",
"PRACHAR ADVERTISERS PRIVATE LIMITED",
"PRACHAR COMMUNICATIONS PRIVATE LIMITED",
"PRACHAR INFRA & OUTDOOR PRIVATE LIMITED",
"PRACHARNAMA MEDIA PRIVATE LIMITED",
"PRACHAY AUTO PARTS PRIVATE LIMITED",
"PRACHAY CAPITAL PRIVATE LIMITED",
"PRACHEE INSTITUTE FOR MOTHER & CHILD CARE PRIVATE LIMITED",
"PRACHEE POLYFILMS PRIVATE LIMITED",
"PRACHEER INFRASTRUCTURES PRIVATE LIMITED",
"PRACHEM LABORATORIES PRIVATE LIMITED",
"PRACHI AGRICULTURE & PROPERTIES PVT LTD",
"PRACHI AQUA MINERAL PRIVATE LIMITED",
"PRACHI ENTERPRISES PVT LTD",
"PRACHI FIXTURES PRIVATE LIMITED",
"PRACHI GREEN ENERGY PRIVATE LIMITED",
"PRACHI HOSPITAL PRIVATE LIMITED",
"PRACHI INDIA PRIVATE LIMITED",
"PRACHI INFRA AND ROADS PRIVATE LIMITED",
"PRACHI INFRASTRUCTURE PRIVATE LIMITED",
"PRACHI INVESTMENTS PRIVATE LIMITED",
"PRACHI LEATHERS PRIVATE LIMITED",
"PRACHI MITTAL CREATIONS PRIVATE LIMITED",
"PRACHI PHARMACEUTICALS PRIVATE LIMITED",
"PRACHI POLYCHEM PRIVATE LIMITED",
"PRACHI RESORTS PRIVATE LIMITED",
"PRACHI WORKS PVT LTD",
"PRACHIDHI SPINNERS PRIVATE LIMITED",
"PRACHIN BHARAT TOURISM TECHNOLOGIES PRIVATE LIMITED",
"PRACHIT FOODS (INDIA) PRIVATE LIMITED",
"PRACHIT TECHNOLOGY SERVICES PRIVATE LIMITED",
"PRACO HOMEWARE PRIVATE LIMITED",
"PRACTICAL ACTION CONSULTING INDIA PRIVATE LIMITED",
"PRACTICAL FINANCIAL SERVICES PRIVATE LIMITED",
"PRACTICAL FISH SOFTWARE PRIVATE LIMITED",
"PRACTICE DESIGN PRIVATE LIMITED",
"PRACTICE MOCK EDTECH PRIVATE LIMITED",
"PRACTICE STRATEGIC COMMUNICATIONS INDIA PRIVATE LIMITED",
"PRACTICELEAGUE LEGALTECH PRIVATE LIMITED",
"PRACTICESUITE INDIA PRIVATE LIMITED",
"PRACTICO INTERIOR SOLUTIONS PRIVATE LIMITED",
"PRACTION NETWORKS PRIVATE LIMITED",
"PRACTIVE HEALTH INDIA PRIVATE LIMITED",
"PRACTOVA TECHNOLOGY LLP",
"PRACTUS ADVISORS PRIVATE LIMITED",
"PRACTUS BUSINESS TRANSFORMATION PRIVATE LIMITED",
"PRAD MULTITRADE PRIVATE LIMITED",
"PRADAKSHANA FINTECH PRIVATE LIMITED",
"PRADEEP AUTOMOTIVE PRIVATE LIMITED",
"PRADEEP BANDHU LOGISTICS PRIVATE LIMITED",
"PRADEEP CARGO SERVICES PRIVATE LIMITED",
"PRADEEP COLONISERS AND SUPPLIERS PRIVATE LIMITED",
"PRADEEP COTTON PRIVATE LIMITED",
"PRADEEP DEVIAH AND ASSOCIATES PRIVATE LIMITED",
"PRADEEP FIBERS PRIVATE LIMITED",
"PRADEEP INDSUTRIAL PACKERS PRIVATE LIMITED",
"PRADEEP INSECTICIDES AND FERTILESERS COMPANY PRIVATE LIMITED",
"PRADEEP JEWELLERS PRIVATE LIMITED",
"PRADEEP KUMAR SINGH INFRATECH COMPANY PRIVATE LIMITED",
"PRADEEP LAMINATORS PRIVATE LIMITED",
"PRADEEP MANAJ FARMS PRIVATE LIMITED",
"PRADEEP METALS LIMITED",
"PRADEEP MINING AND CONSTRUCTIONS PRIVATE LIMITED",
"PRADEEP MULTIPLEX PRIVATE LIMITED",
"PRADEEP POLYFLEX PRIVATE LIMITED",
"PRADEEP POLYMERS PRIVATE LIMITED",
"PRADEEP POWER SOLUTION PRIVATE LIMITED",
"PRADEEP SALES & SERVICE PRIVATE LIMITED",
"PRADEEP SANKAR ENTERPRISES PRIVATE LIMITED",
"PRADEEP SHETYE PRIVATE LIMITED",
"PRADEEP SONS PRIVATE LIMITED",
"PRADEEP STAINLESS INDIA PRIVATE LIMITED",
"PRADEEP SWEETS PRIVATE LIMITED",
"PRADEEP TRANSCORE PRIVATE LIMITED",
"PRADEEPIT CONSULTING SERVICES PRIVATE LIMITED",
"PRADEEQUEEN HOLIDAY RESORTS PRIVATE LIMITED",
"PRADHA INDUSTRIES PRIVATE LIMITED",
"PRADHAMA MULTI SPECIALITY HOSPITALS & RESEARCH INSTITUTE LIMITED",
"PRADHAN ASSOCIATES PVT. LTD",
"PRADHAN MERCANTILE PRIVATE LIMITED",
"PRADHAN MUKHYA VANSAURAKSHAK SAMAJIK VANIKARAN MAHARASHTRA RAJYA PUNE",
"PRADHI AGRO PRIVATE LIMITED",
"PRADHYOT PROJECTS PRIVATE LIMITED",
"PRADI BUSINESS VENTURES PRIVATE LIMITED",
"PRADIP C DOSHI STOCK BROKERS PRIVATE LIMITED",
"PRADIP HEALTH CARE PRIVATE LIMITED",
"PRADIP OVERSEAS LIMITED",
"PRADIP POLYFILS PRIVATE LIMITED",
"PRADIPAK DRILLING SOLUTIONS PRIVATE LIMITED",
"PRADIPKUMAR PHARMA PRIVATE LIMITED",
"PRADITI PRESS PARTS PRIVATE LIMITED",
"PRADMAN ENGINEERING PRIVATE LIMITED",
"PRADMAN ENGINEERING SERVICES PRIVATE LIMITED",
"PRADNIL BUILDMARQUE PRIVATE LIMITED",
"PRADNYA CREATION",
"PRADO PRECLINICAL RESEARCH AND DEVELOPMENT ORGANIZATION PRIVATE LIMITED",
"PRADUMN RETAILS PRIVATE LIMITED",
"PRADYUMAN OVERSEAS LIMITED",
"PRADYUMNA ICE AND COLD STORAGE PRIVATE LIMITED",
"PRADYUMNA IMPEX PRIVATE LIMITED",
"PRAECELLO TECHNOLOGY CONSULTANTS PRIVATE LIMITED",
"PRAENDEX MANAGEMENT RESOURCES PRIVATE LIMITED",
"PRAESIDIUM IT SOLUTIONS PRIVATE LIMITED",
"PRAESTANS PRIVATE LIMITED",
"PRAETORIAN TECHNOLOGIES PRIVATE LIMITED",
"PRAFFUL INDUSTRIES PRIVATE. LIMITED.",
"PRAFFUL OVERSEAS PRIVATE. LIMITED.",
"PRAFICH AGROS PRIVATE LIMITED",
"PRAFUL ENTERPRISES PVT LTD",
"PRAFUL LOGISTICS PRIVATE LIMITED",
"PRAFUL METAL WORKS PRIVATE LIMITED",
"PRAFUL VENTURE PRIVATE LIMITED",
"PRAFULLA CHANDRA COLLEGE",
"PRAFULLA PROJECTS PRIVATE LIMITED",
"PRAG BOSIMI SYNTHETICS LTD",
"PRAG INDIA CEMENT PRIVATE LIMITED",
"PRAG INDUSTRIES (INDIA) PRIVATE LIMITED",
"PRAG JYOTI SYNTEX LIMITED",
"PRAG OIL MILLS LIMITED",
"PRAG RUBBER INDUSTRIES PRIVATE LIMITED",
"PRAGA MARINE PRIVATE LIMITED",
"PRAGATHI CARTONS PRIVATE LIMITED",
"PRAGATHI ENGLISH MEDIUM SCHOOL",
"PRAGATHI IIT/JEE NEET ACADEMY",
"PRAGATHI JR DEGREE COLLEGE",
"PRAGATHI TOBACCO TRADERS INDIA PRIVATE LIMITED",
"PRAGATHI YUVA KENDRAM FARMERS PRODUCER COMPANY LIMITED",
"PRAGATI ACCESSORIES PRIVATE LIMITED",
"PRAGATI AGRI PRODUCTS PRIVATE LIMITED",
"PRAGATI AGRO ENTERPRISES PRIVATE LIMITED",
"PRAGATI ANDH VIDYALAYA",
"PRAGATI AROMA OIL DISTILLERS P LTD",
"PRAGATI ASSOCIATE PRIVATE LIMITED",
"PRAGATI AUTO UDYOG SAMOOH PRIVATE LIMITED",
"PRAGATI AUTOMATION PRIVATE LIMITED",
"PRAGATI AUTOTECH PRIVATE LIMITED",
"PRAGATI BIOCARE PRIVATE LIMITED",
"PRAGATI CATERERS PRIVATE LIMITED",
"PRAGATI CEMEX PRIVATE LIMITED",
"PRAGATI CHEMICALS LIMITED",
"PRAGATI COATINGS PRIVATE LIMITED.",
"PRAGATI CONSTRUCTION",
"PRAGATI CONTAINER SERVICES PRIVATE LIMITED",
"PRAGATI COTTON INDUSTRIES",
"PRAGATI EDIBLE PROCESSING PRIVATE LIMITED",
"PRAGATI EDUCATIONAL SOCIETY",
"PRAGATI ELECTRICALS PRIVATE LIMITED",
"PRAGATI ELECTROCOM PRIVATE LIMITED",
"PRAGATI ENGINEERING BELGAUM PRIVATE LIMITED",
"PRAGATI ENGINEERING COLLEGE",
"PRAGATI ENTERPRISES",
"PRAGATI EXTRUSION INDIA PRIVATE LIMITED",
"PRAGATI FABRICS PRIVATE LIMITED",
"PRAGATI FASHIONS PRIVATE LIMITED",
"PRAGATI FLOWTECH PRIVATE LIMITED",
"PRAGATI FOODS",
"PRAGATI FORGE PVT LTD",
"PRAGATI FOUNDERS PRIVATE LIMITED",
"PRAGATI GLASS PRIVATE LIMITED",
"PRAGATI GLYOXAL PRIVATE LIMITED",
"PRAGATI GOLD PRIVATE LIMITED",
"PRAGATI GRANITO (INDIA) PRIVATE LIMITED",
"PRAGATI INFRA SERVICES PRIVATE LIMITED",
"PRAGATI INFRA SOLUTIONS PRIVATE LIMITED",
"PRAGATI INFRAINTERIORS PRIVATE LIMITED",
"PRAGATI INFRAPROMOTERS PRIVATE LIMITED",
"PRAGATI INGOTS & POWER PRIVATE LIMITED",
"PRAGATI INSTRUMENTATION PRIVATE LIMITED",
"PRAGATI LASER & ENGINEERING WORKS PRIVATE LIMITED",
"PRAGATI LEADERSHIP INSTITUTE PRIVATE LIMITED",
"PRAGATI LEATHER CRAFT PRIVATE LIMITED",
"PRAGATI LOGISTICS PRIVATE LIMITED",
"PRAGATI LUBES PRIVATE LIMITED",
"PRAGATI MICRO INSTRUMENTS PRIVATE LIMITED",
"PRAGATI MILK PRODUCTS PRIVATE. LIMITED",
"PRAGATI MULTI SERVICES PRIVATE LIMITED",
"PRAGATI MULTISPECIALITY HOSPITAL",
"PRAGATI OFFSET PRIVATE LIMITED",
"PRAGATI PACK INDIA PRIVATE LIMITED",
"PRAGATI PAPER INDUSTRIES LIMITED",
"PRAGATI PAPER INDUSTRIES PRIVATE LIMITED",
"PRAGATI PIPE INDUSTRIES PRIVATE LIMITED",
"PRAGATI PLYWOOD INDUSTRIES PVT LTD",
"PRAGATI POLYPLAST INDIA PRIVATE LIMITED",
"PRAGATI POWER CORPORATION LIMITED",
"PRAGATI PRAKASHAN PVT LTD",
"PRAGATI PRE FAB (INDIA) PRIVATE LIMITED",
"PRAGATI PRESS PRIVATE LIMITED",
"PRAGATI PRINT PACK PRIVATE LIMITED",
"PRAGATI PRINTARTS PRIVATE LIMITED",
"PRAGATI RAW PHARMA PRIVATE LIMITED",
"PRAGATI SAHU LAND DEVELOPERS PRIVATE LIMITED",
"PRAGATI SALT (INDIA) PRIVATE LIMITED",
"PRAGATI SHIKSHA BHAWAN PRIVATE LIMITED",
"PRAGATI SOFTWARE PRIVATE LIMITED",
"PRAGATI SPICES COMPANY PRIVATE LIMITED",
"PRAGATI SPINNERS PRIVATE LIMITED",
"PRAGATI STEEL UDYOG PRIVATE LIMITED",
"PRAGATI STOCKCOM PRIVATE LIMITED",
"PRAGATI SYNTHETICS PRIVATE LIMITED",
"PRAGATI TECHNO CAST PRIVATE LIMITED",
"PRAGATI TOWNSHIPS PRIVATE LIMITED",
"PRAGATI TRADING COMPANY PRIVATE LIMITED",
"PRAGATI TRANSMISSION PRIVATE LIMITED",
"PRAGATI TRANSPORTS AND MINING PRIVATE LIMITED",
"PRAGATI UDYOG PRIVATE LIMITED",
"PRAGATI UNIVERSAL PRIVATE LIMITED",
"PRAGATI VANIJAYA LIMITED",
"PRAGATI VIDYA MANDIR INDURI MAVAL",
"PRAGATI VIDYAMANDIR JALGAON",
"PRAGATI VINIMAY PVT LTD",
"PRAGATI VYAPAAR PRIVATE LIMITED",
"PRAGATI WAREHOUSING PRIVATE LIMITED",
"PRAGATI WIRES PRIVATE LIMITED",
"PRAGATI WOOD SPECIALITIES PRIVATE LIMITED",
"PRAGATIPACK NOIDA PRIVATE LIMITED",
"PRAGATIPATH FOODS PRIVATE LIMITED",
"PRAGATIVADI PUBLICATION PRIVATE LIMITED",
"PRAGAU TOOLS PRIVATE LIMITED",
"PRAGDEV INTERNATIONAL FARMER PRODUCER COMPANY LIMITED",
"PRAGEMA TRAVELS PRIVATE LIMITED",
"PRAGER METIS GLOBAL SERVICES LLP",
"PRAGEU EVENTS & MARKETING SERVICES PRIVATE LIMITED",
"PRAGITI INTERNET TECHNOLOGIES PRIVATE LIMITED",
"PRAGJOYTI EYE CARE AND RESEARCH CENTRE PVT LTD",
"PRAGJYOTIS BUILDERS AND CONSULTANT PRIVATE LIMITED",
"PRAGJYOTISH COLLEGE",
"PRAGJYOTISH HOTELS AND LEASING CO PVT LTD",
"PRAGJYOTISH HOUSING PRIVATE LIMITED",
"PRAGMA APPS AND TECHNOLOGIES PRIVATE LIMITED",
"PRAGMA EDGE SOFTWARE SERVICES PRIVATE LIMITED",
"PRAGMAEDGE",
"PRAGMASYS CONSULTING LLP",
"PRAGMATIC CONSULTANTS AND SERVICES PRIVATE LIMITED",
"PRAGMATIC EDUCATIONAL SOCIETY",
"PRAGMATIC GRANITE PRIVATE LIMITED",
"PRAGMATIC HVAC ENGINEERS PRIVATE LIMITED",
"PRAGMATIC INDUSTRIAL AUTOMATION SOLUTIONS PRIVATE LIMITED",
"PRAGMATIC INSURANCE BROKING SERVICES PRIVATE LIMITED",
"PRAGMATIC LABS PRIVATE LIMITED",
"PRAGMATIC MACHINES PRIVATE LIMITED",
"PRAGMATIC WORLDWIDE PRIVATE LIMITED",
"PRAGMATICH TECHNICAL SERVICES PRIVATE LIMITED",
"ARRISE SOLUTIONS (INDIA) PRIVATE LIMITED",
"PRAGMATIX SERVICES PRIVATE LIMITED",
"PRAGNA DYECHEM PRIVATE LIMITED",
"PRAGNA LIFE SCIENCE PRIVATE LIMITED",
"PRAGNA PHARMA PRIVATE LIMITED",
"PRAGNA SPECIALITY PRIVATE LIMITED",
"PRAGNA TECHNOLOGIES PRIVATE LIMITED",
"PRAGNA TEST HOUSE AND ENGINEERING SERVICES PRIVATE LIMITED",
"PRAGNAA SHREE VENTURE INDIA PRIVATE LIMITED",
"PRAGNAPUR DEVELOPERS PRIVATE LIMITED",
"PRAGNASHREE HEALTHCARE PRIVATE LIMITED",
"PRAGNYA PRIYA FOUNDATION",
"PRAGNYA RIVERBRIDGE DEVELOPERS LIMTED",
"PRAGNYA SOUTH CITY PROJECTS PRIVATE LIMITED",
"PRAGO CHEM PRIVATE LIMITED",
"PRAGRATI ENGINEERING AND CONSTRUCTION PRIVATE LIMITED",
"PRAGUN SERVICES PRIVATE LIMITED",
"PRAGUN WEALTH ADVISORS PRIVATE LIMITED",
"PRAGYA COLLAGE OF EDUCATION",
"PRAGYA COMMODITY BROKERS PRIVATE LIMITED",
"PRAGYA COMPONENTS PRIVATE LIMITED",
"PRAGYA ELECTRONICS PVT. LTD.",
"PRAGYA EQUITIES PRIVATE LIMITED",
"PRAGYA GLOBAL PRIVATE LIMITED",
"PRAGYA HEALTH TECHNOLOGIES LLP",
"PRAGYA JEWELS PRIVATE LIMITED",
"PRAGYA MERCANTILE PRIVATE LIMITED",
"PRAGYA METALLIZERS PRIVATE LIMITED",
"PRAGYA MOTHER & CHILD CARE PRIVATE LIMITED",
"PRAGYA MULTI SPECIALITY HOSPITAL AND RESEARCH CENTER PRIVATE LIMITED",
"PRAGYA PRODUCTS PRIVATE LIMITED",
"PRAGYA REALTY DEVELOPERS PRIVATE LIMITED",
"PRAGYA RESEARCH LABORATORIES PRIVATE LIMITED",
"PRAGYA SECURITIES P LTD",
"PRAGYA TEXTILE PRIVATE LIMITED",
"PRAGYA TRADELINK PRIVATE LIMITED",
"PRAGYA VISION PRIVATE LIMITED",
"PRAGYAAM DATA TECHNOLOGIES PRIVATE LIMITED",
"PRAGYAAN PACKAGING PRIVATE LIMITED",
"PRAGYAN METALS PRIVATE LIMITED",
"PRAGYAN PUBLIC SCHOOL",
"PRAGYAN TECH SERVICES PRIVATE LIMITED",
"PRAGYASHEEL PRINT AND PACK PRIVATE LIMITED",
"PRAGYASUN BUSINESS PRIVATE LIMITED",
"PRAGYAWAN INDIA PRIVATE LIMITED",
"PRAGYAWAN TECHNOLOGIES PRIVATE LIMITED",
"PRAGYAWARE INFORMATICS PRIVATE LIMITED",
"PRAHANS INFRA - PROJECTS PRIVATE LIMITED",
"PRAHAR ENGINEERING PRIVATE LIMITED",
"PRAHARI ORCAD PRIVATE LIMITED",
"PRAHARI SAFE-GUARDS PRIVATE LIMITED",
"PRAHARSH CORPORATION PRIVATE LIMITED",
"PRAHARSHITA BUILDING SERVICES PRIVATE LIMITED",
"PRAHASH FIN-STOCK PRIVATE LIMITED",
"PRAHITHA CONSTRUCTIONS PRIVATE LIMITED",
"PRAHLAD FLOUR MILLS PRIVATE LIMITED",
"PRAHLAD OILS PRIVATE LIMITED",
"PRAHLADKA MULTIVENTURES PRIVATE LIMITED",
"PRAHLADRAI DALMIA LIONS COLLEGE OF COMMERCE & ECONOMICS",
"PRAISTMA TECHNOLOGIES OPC PRIVATE LIMITED",
"PRAJ COMPANIES LOGISTICS SERVICES PRIVATE LIMITED",
"PRAJ ENGINEERING & INFRA LIMITED",
"PRAJ FOREX PRIVATE LIMITED",
"PRAJ HIPURITY SYSTEMS LIMITED",
"PRAJ INDUSTRIES LIMITED",
"PRAJ WIRE MANUFACTURING PRIVATE LIMITED",
"PRAJA HOSPITAL",
"PRAJA MECHANICALS PRIVATE LIMITED",
"PRAJAKT LIFE SCIENCE PRIVATE LIMITED",
"PRAJAKTA ENGINEERING AND CONSTRUCTION PVT LTD",
"PRAJAKTA ENTERTAINMENT PRIVATE LIMITED",
"PRAJAKTA FORGING PRIVATE LIMITED",
"PRAJAKTA TECHNOLOGY PRIVATE LIMITED",
"PRAJAL INFRA PROJECTS PRIVATE LIMITED",
"PRAJAPATHYSAV BLUE METAILS PRIVATE LIMITED",
"PRAJAPATI BUILDCON PRIVATE LIMITED",
"PRAJAPATI CASTING FOUNDRY PRIVATE LIMITED",
"PRAJAPATI COMMODITIES PRIVATE LIMITED",
"PRAJAPATI CONSTRUCTIONS LIMITED",
"PRAJAPATI DEVELOPERS",
"PRAJAPATI EXIM",
"PRAJAPATI FOUNDRY PRIVATE LIMITED",
"PRAJAPATI INDUSTRIES PRIVATE LIMITED",
"PRAJAPATI IRON AND STEEL PRIVATE LIMITED",
"PRAJAPATI TUBES PRIVATE LIMITED",
"PRAJAS AUTOMOBILES PRIVATE LIMITED",
"PRAJASAKTI PRINTERS & PUBLISHERS PRIVATE LIMITED",
"PRAJAY ENGINEERS SYNDICATE LTD",
"PRAJAY PROPERTIES PRIVATE LIMITED",
"PRAJESH INFRASTRUCTURE DEVELOPERS PRIVATE LIMITED",
"PRAJHA PROPERTIES AND PROJECTS PRIVATE LIMITED",
"PRAJKTA ESTATES PRIVATE LIMITED",
"PRAJNA GENERICS PRIVATE LIMITED",
"PRAJNEEL WAREHOUSING MANAGEMENT PRIVATE LIMITED",
"PRAJUKTI CONSULTANTS PRIVATE LIMITED",
"PRAJWAL PROMOTERS PRIVATE LIMITED",
"PRAJYOT ENTERPRISES PRIVATE LIMITED",
"PRAKAASH EYEWEAR PRIVATE LIMITED",
"PRAKALA WEALTH PRIVATE LIMITED",
"PRAKALP INFRABUILD AND DEVELOPERS PRIVATE LIMITED",
"PRAKALPA AUTOMOTIVES PRIVATE LIMITED",
"PRAKALPA CONTRACTS PRIVATE. LIMITED",
"PRAKALPA PROJECTS PRIVATE LIMITED",
"PRAKALPA PROPERTIES PRIVATE LIMITED",
"PRAKAR INFRA LLP",
"PRAKAS PHARMACY PRIVATE LIMITED",
"PRAKASA SPECTRO CAST PRIVATE LIMITED",
"PRAKASAM DIE CASTINGS PRIVATE LIMITED",
"PRAKASAM HEAVY ENGINEERING PRIVATE LIMITED",
"PRAKASH ACRYLICS PRIVATE LIMITED",
"PRAKASH AGRICULTURAL INDUSTRIES PRIVATE LIMITED",
"PRAKASH AGRILINK PRIVATE LIMITED",
"PRAKASH AIR FREIGHT INDIA PRIVATE LIMITED",
"PRAKASH AIR SERVICES PRIVATE LIMITED",
"PRAKASH ALLOYS & FORGE PRIVATE LIMITED",
"PRAKASH ALUMINIUM PRIVATE LIMITED",
"PRAKASH ARTS PRIVATE LIMITED",
"PRAKASH ASPHALTINGS AND TOLL HIGHWAYS (INDIA) LIMITED",
"PRAKASH AUTO PVT LTD",
"PRAKASH AUTOMOTIVES",
"PRAKASH BAL BHARTI PUBLIC SCHOOL",
"PRAKASH BOOKS INDIA PRIVATE LIMITED",
"PRAKASH BOTTLES CO. PRIVATE LIMITED",
"PRAKASH BULB INDUSTRIES PRIVATE LIMITED",
"PRAKASH CAP DEPOT PRIVATE LIMITED",
"PRAKASH CHEMICAL AGENCIES PRIVATE LIMITED",
"PRAKASH CHEMICAL INTERNATIONAL PRIVATE LIMITED",
"PRAKASH CHEMICALS PRIVATE LIMITED",
"PRAKASH COACH BUILDERS PRIVATE LIMITED",
"PRAKASH COATINGS PRIVATE LIMITED",
"PRAKASH CORRUGATED PRODUCTS",
"PRAKASH CORRUGATED PUNE PRIVATE LIMITED",
"PRAKASH COTTON MILLS PRIVATE LIMITED",
"PRAKASH DEEP FINANCE COMPANY LIMITED",
"PRAKASH DEEP TEXTILES MILLS PRIVATE LIMITED",
"PRAKASH DEGREE COLLEGE OF COMMERCE AND SCIENCE",
"PRAKASH DEPARTMENTAL STORES PRIVATE LIMITED",
"PRAKASH DIESELS PRIVATE LIMITED",
"PRAKASH DISTILLERY & CHEMICAL CO PRIVATE LIMITED",
"PRAKASH DYEING AND MANUFACTURING COMPANY LIMITED",
"PRAKASH EGG CENTRE",
"PRAKASH ELECTRICALS PRIVATE LIMITED",
"PRAKASH ELECTRODES PRIVATE LIMITED",
"PRAKASH ENGINEERS AND INFRAPROJECTS PRIVATE. LIMITED.",
"PRAKASH ESOLUTIONS PRIVATE LIMITED",
"PRAKASH ESTATES PVT LTD",
"PRAKASH FABCON AND ENGINEERING PRIVATE LIMITED",
"PRAKASH FABRICS PVT LTD",
"PRAKASH FERROUS INDUSTRIES PRIVATE LIMITED",
"PRAKASH FLEXIBLES PRIVATE LIMITED",
"PRAKASH FREIGHT MOVERS LIMITED",
"PRAKASH GOLD PALACE PRIVATE LIMITED",
"PRAKASH GOODS CARRIERS PVT LTD",
"PRAKASH HIGHER SECONDARY SCHOOL",
"PRAKASH HI-TECH DEVELOPERS AND CONSTRUCTION PRIVATE LIMITED",
"PRAKASH HOSPITAL PRIVATE LIMITED",
"PRAKASH IMPEX PRIVATE LIMITED",
"PRAKASH INDUSTRIAL CORPORATION",
"PRAKASH INDUSTRIAL INFRASTRUCTURE PRIVATE LIMITED",
"PRAKASH INDUSTRIAL SERVICES PVT LTD",
"PRAKASH INDUSTRIES LIMITED",
"PRAKASH IRON AND STEEL PRIVATE LIMITED",
"PRAKASH JAYANTILAL CHAUHAN FOUNDATION",
"PRAKASH JEWELLERS",
"PRAKASH JEWELLERY MART PRIVATE LIMITED",
"PRAKASH K.SHAH SHARES AND SECURITIES PRIVATE LIMITED",
"PRAKASH KUMAR PASARI & CO. PRIVATE LIMITED",
"PRAKASH LABELS PRIVATE LIMITED",
"PRAKASH LUBRIQUIPMENT PVT LTD",
"PRAKASH MASALA CO PRIVATE LIMITED",
"PRAKASH MEDICAL STORE PRIVATE LIMITED",
"PRAKASH METAL AND MACHINES PRIVATE LIMITED",
"PRAKASH METALLIC PRIVATE LIMITED",
"PRAKASH MICA EXPORTS PRIVATE LIMITED",
"PRAKASH OFFSET PRINTERS",
"PRAKASH OILS LIMITED",
"PRAKASH OILS LIMITED.",
"PRAKASH PARCEL SERVICES LIMITED PPS",
"PRAKASH PATHOLOGY AND RADIOLOGY PRIVATE LIMITED",
"PRAKASH PIPES LIMITED",
"PRAKASH PLASTIC INDUSTRIES",
"PRAKASH PODDAR HIMGHAR PVT LTD",
"PRAKASH POLYFLEX PRIVATE LIMITED",
"PRAKASH POLYTUBE PRIVATE LIMITED",
"PRAKASH POWER PLANNING PRIVATE LIMITED",
"PRAKASH POWERS PRIVATE LIMITED",
"PRAKASH PROJECTS PRIVATE LIMITED.",
"PRAKASH PROTIENS AND FATS PVT LTD",
"PRAKASH PUBLIC SCHOOL",
"PRAKASH QUARRY WORKS PRIVATE LIMITED",
"PRAKASH RADIOLOGY INDIA PRIVATE LIMITED",
"PRAKASH RE-ROLLERS PRIVATE LIMITED",
"PRAKASH RETAIL PRIVATE LIMITED",
"PRAKASH ROADLINES CORPORATION LIMITED.",
"PRAKASH ROADLINES LIMITED",
"PRAKASH ROADLINK PRIVATE LIMITED",
"PRAKASH SEEDS PRIVATE LIMITED",
"PRAKASH SILKS & SAREES PRIVATE LIMITED",
"PRAKASH SNACKS PRIVATE LIMITED",
"PRAKASH SOFTWARE SOLUTIONS PRIVATE LIMITED",
"PRAKASH SOLAR INDUSTRIES PRIVATE LIMITED",
"PRAKASH SOLVENT EXTRACTIONS LIMITED",
"PRAKASH SOYA LIMITED",
"PRAKASH SPICES PRIVATE LIMITED",
"PRAKASH SPINNING & TEXTILES MILLS PRIVATE LIMITED",
"PRAKASH SPONGE IRON AND POWER PRIVATE LIMITED",
"PRAKASH STAINLESS PRIVATE LIMITED",
"PRAKASH STEEL PRODUCTS PVT LTD",
"PRAKASH SUPPLY CHAIN SOLUTIONS LLP",
"PRAKASH TECHNO PLAST INDIA PRIVATE LIMITED",
"PRAKASH TELESERVICES PRIVATE LIMITED",
"PRAKASH TEXFAB PRIVATE LIMITED",
"PRAKASH TEXTILES",
"PRAKASH TRADEMART (I) PRIVATE LIMITED",
"PRAKASH TRADING COMPANY",
"PRAKASH TRANSFORMERS AND SWITCHGEARS PRIVATE LIMITED",
"PRAKASH UDYOG",
"PRAKASH VEHICLES PRIVATE LIMITED",
"PRAKASH VIDYALAY BILIYA",
"PRAKASH WEB OFFSET PRIVATE LIMITED",
"PRAKASH WEB TECH PRIVATE LIMITED",
"PRAKASH WOOLLEN & SYNTHETIC MILLS LIMITED",
"PRAKASH WOVEN PRIVATE LIMITED",
"PRAKASH YANTRA UDYOG PRIVATE LIMITED",
"PRAKASHMANI COTTAN INDUSTRIES",
"PRAKAT SOLUTIONS PRIVATE LIMITED",
"PRAKFIN CORPORATE ADVISORY SERVICES PRIVATE LIMITED",
"PRAKHAR ENGINEERING PRIVATE LIMITED",
"PRAKHAR ESTATES PRIVATE LIMITED",
"PRAKHAR HOSPITAL PRIVATE LIMITED",
"PRAKHAR SOFTWARE SOLUTIONS PRIVATE LIMITED",
"PRAKHHYAT LAND DEVELOPERS PRIVATE LIMITED",
"PRAKHYATH MACHINES & MACHINE TOOLS PRIVATE LIMITED",
"PRAKRAM GLOBAL ENGINEERING SOLUTIONS PRIVATE LIMITED",
"PRAKRATEE AKSHAY ENTERPRISE PRIVATE LIMITED",
"PRAKREETEE SOLAR ENERGY GODAWARI PRIVATE LIMITED",
"PRAKRIA MARKETING SERVICES PRIVATE LIMITED",
"PRAKRITI E-MOBILITY PRIVATE LIMITED",
"PRAKRITI HANDICRAFTS (OPC) PRIVATE LIMITED",
"PRAKRITI ORGANICS INDIA PRIVATE LIMITED",
"PRAKRITI SCHOOL",
"PRAKRITI TECNICS INDIA PRIVATE LIMITED",
"PRAKRITIK LOGISTICS PRIVATE LIMITED",
"PRAKRUTEES INFRA IMPEX INDIA PRIVATE LIMITED",
"PRAKRUTEES ORGANICS PRIVATE LIMITED",
"PRAKRUTHI ENERGY SOLUTIONS PRIVATE LIMITED",
"PRAKRUTHI INFRA & SHELTERS (INDIA) PRIVATE LIMITED",
"PRAKRUTHI PROTEIN FOODS INDIA PRIVATE LIMITED",
"PRAKRUTHI RECYCLING PRIVATE LIMITED",
"PRAKRUTHI SOLVEX PRIVATE LIMITED",
"PRAKRUTI AVENUES PRIVATE LIMITED",
"PRAKRUTI GRAPHICS PRIVATE LIMITED",
"PRAKRUTI LIFE SCIENCE PRIVATE LIMITED",
"PRAKRUTI PRODUCTS PRIVATE LIMITED",
"PRAKRUTI RESORTS PRIVATE LIMITED",
"PRAKRUTI TEXTILES PRIVATE LIMITED",
"PRAKSIS CONSULTANTS & VALUERS PRIVATE LIMITED",
"PRAKUN EQUIPMENTS PRIVATE LIMITED",
"PRAKVI TECHNO SOLUTIONS PRIVATE LIMITED",
"PRAKYATH APPLICATIONS PRIVATE LIMITED",
"PRALAKSH AUTOMOBILES PRIVATE LIMITED",
"PRALAKSHA HEALTHCARE PRIVATE LIMITED",
"PRALCKA MACHINERY MANUFACTURING PRIVATE LIMITED",
"PRALSHAR BIO-PRODUCTS PRIVATE LIMITED",
"PRALSONS AGRI-TECH PRIVATE LIMITED",
"PRAMA HIKVISION INDIA PRIVATE LIMITED",
"PRAMA INSTRUMENTS PRIVATE LIMITED",
"PRAMA JEWELS PRIVATE LIMITED",
"PRAMA MANUFACTURING PVT LTD",
"PRAMA RESEARCH LAB PRIVATE LIMITED",
"PRAMADHA FOOD PRODUCTS PRIVATE LIMITED",
"PRAMADHA OILS AND FATS INDIA PRIVATE LIMITED",
"PRAMAH CREATIONS PRIVATE LIMITED",
"PRAMALIK ENTERPRISES PRIVATE LIMITED",
"PRAMAN CONSTRUCTIONS PRIVATE LIMITED",
"PRAMANYA PLYWOOD PRIVATE LIMITED",
"PRAMARA PROMOTIONS LIMITED",
"PRAMARA PROMOTIONS PRIVATE LIMITED",
"PRAMATA KNOWLEDGE SOLUTIONS PRIVATE LIMITED",
"PRAMATHA POWER PRIVATE LIMITED",
"PRAMATHODAYA MULTI SPECIALITY HOSPITALS PRIVATE LIMITED",
"PRAMATI TECHNOLOGIES PRIVATE LIMITED",
"PRAMEGA DEVELOPERS PRIVATE LIMITED",
"PRAMERICA LIFE INSURANCE LIMITED",
"PRAMEX INTERNATIONAL CONSULTING PRIVATE LIMITED",
"PRAMILA CONSTRUCTION AND BUILDERS PRIVATE LIMITED",
"PRAMILA MEMORIAL INSTITUTE",
"PRAMILA PRODUCTS PRIVATE LIMITED",
"PRAMILA STEEL PRIVATE LIMITED",
"PRAMILA TILES PRIVATE LIMITED",
"PRAMIRA TECHNOLOGIES PRIVATE LIMITED",
"PRAMITEE ENGINEERING AND SURVEYS PRIVATE LIMITED",
"PRAMOD BUILD-TECH PRIVATE LIMITED",
"PRAMOD CONSTRUCTIONS PRIVATE LIMITED",
"PRAMOD FIBRE PLAST PRIVATE LIMITED",
"PRAMOD KUMAR MAURYA",
"PRAMOD MULTI FOOD PRIVATE LIMITED",
"PRAMOD RAM UJAGAR TIWARI SAGAR INSTITUTE OF MANAGEMENT",
"PRAMOD TELECOM PRIVATE. LIMITED.",
"PRAMOD WOOLLEN AND SILK INDUSTRIES PRIVATE LIMITED",
"PRAMOD ZARI INDUSTRIES PRIVATE LIMITED",
"PRAMODINI MEDICARE PRIVATE LIMITED",
"PRAMOKASH OUTSOURCING SERVICES PRIVATE LIMITED",
"PRAMOL TRADERS HOLDINGS PRIVATE LIMITED",
"PRAMUK HEALTH SERVICES PRIVATE LIMITED",
"PRAMUK HEALTHCARE",
"PRAMUKH ABHIYANTA P W D LKO",
"PRAMUKH ALLOYS PRIVATE LIMITED",
"PRAMUKH AUTOMOBILES PRIVATE LIMITED",
"PRAMUKH AUTOMOTIVE PRIVATE LIMITED",
"PRAMUKH COT PRESS (INDIA) PRIVATE LIMITED",
"PRAMUKH COTEX PRIVATE LIMITED",
"PRAMUKH FORGE PRIVATE LIMITED",
"PRAMUKH IMAGING & DIAGNOSTICS",
"PRAMUKH OVERSEAS PRIVATE LIMITED",
"PRAMUKH PAPER PRODUCTS PRIVATE LIMITED",
"PRAMUKH REAL ESTATE LLP",
"PRAMUKH REALTY",
"PRAMUKH SERVICES PRIVATE LIMITED",
"PRAMUKH SWAMI HOSPITAL",
"PRAMUKH SWAMI MEDICAL COLLEGE",
"PRAMUKHRAJ STEEL INDUSTRIES",
"PRAMUR CONSTRUCTIONS PRIVATE. LIMITED.",
"PRAMURA SOFTWARE PRIVATE LIMITED",
"PRAMYA INTERNATIONAL",
"PRAN BEVERAGE INDIA PRIVATE LIMITED",
"PRAN FERTILITY & WELL WOMAN CENTRE PRIVATE LIMITED",
"PRANA FOREX PRIVATE LIMITED",
"PRANA GASES PRIVATE LIMITED",
"PRANA PR PRIVATE LIMITED",
"PRANA RENEWABLE ENERGY PRIVATE LIMITED",
"PRANA STUDIOS PRIVATE LIMITED",
"PRANAAM HOSPITALS PRIVATE LIMITED",
"PRANAAMAM GOLD AND DIAMONDS PRIVATE LIMITED",
"PRANAB CONTRACTING ENGINEERS PRIVATE LIMITED",
"PRANABNAMAN MINERALS PRIVATE LIMITED",
"PRANADA BIOPHARMA PRIVATE LIMITED",
"PRANADHARA HEALTH CARE PRIVATE LIMITED",
"PRANAGRAF MATERIALS & TECHNOLOGIES PRIVATE LIMITED",
"PRANALI CEMENT PIPES PRIVATE LIMITED",
"PRANAM AGROCHEM PRIVATE LIMITED",
"PRANAM HEALTH PRIVATE LIMITED",
"PRANAM HOSPITALITIES AND SERVICES PRIVATE LIMITED",
"PRANAMI BUILDERS PRIVATE LIMITED",
"PRANAMI COMMERCIAL PVT LTD",
"PRANAMI DRUGS PRIVATE LIMITED",
"PRANAMI ESTATES PVT. LTD",
"PRANAMI SECONDARY SCHOOL",
"PRANAMYA COUNSULTANCY SERVICES PRIVATE LIMITED",
"PRANAMYA LOGISTICS PRIVATE LIMITED",
"PRANANDA BIOPHARMA PRIVATE LIMITED",
"PRANAT ENGINEERS PRIVATE LIMITED",
"PRANATHI FERTILIZERS PRIVATE LIMITED",
"PRANATHI HR SOLUTIONS (OPC) PRIVATE LIMITED",
"PRANATHI SOFTWARE SERVICES PRIVATE LIMITED",
"PRANAV ANODIZER PRIVATE LIMITED",
"PRANAV BHAVAN",
"PRANAV BITEK AGROTECH PRIVATE LIMITED",
"PRANAV BRIGHT BARS PRIVATE LIMITED",
"PRANAV BUILDCON PRIVATE LIMITED",
"PRANAV CONSTRUCTIONS PRIVATE LIMITED",
"PRANAV CONSUMER SOLUTIONS PRIVATE LIMITED",
"PRANAV CREATIONS PRIVATE LIMITED",
"PRANAV DOORS AND WINDOWS PRIVATE LIMITED",
"PRANAV ENTERPRISES PRIVATE LIMITED",
"PRANAV FINANCIAL SERVICES PRIVATE LIMITED",
"PRANAV HOSPITALS PRIVATE LIMITED",
"PRANAV MEDIATECH SOLUTIONS (INDIA) PRIVATE LIMITED",
"PRANAV MOTORS PRIVATE LIMITED",
"PRANAV RAJ PAPER MILLS PRIVATE LIMITED",
"PRANAV SALES AND PROJECTS IND PRIVATE LIMITED",
"PRANAV SECURITIES PRIVATE LIMITED",
"PRANAV TECHONE PRIVATE LIMITED",
"PRANAV TEXTILE ENGINEERS PRIVATE LIMITED",
"PRANAV VIKAS INDIA PRIVATE LIMITED",
"PRANAVA ELECTRICAL INDUSTRIES PRIVATE LIMITED",
"PRANAVA ELECTRONICS PRIVATE LIMITED",
"PRANAVAM AEROSPACE PRIVATE LIMITED",
"PRANAVAM INFOTECH PRIVATE LIMITED",
"PRANAVEE SECURE INDIA PRIVATE LIMITED",
"PRANAVI ENTERPRISES CHENNAI PRIVATE LIMITED",
"PRANAVII RICE MILLS PRIVATE LIMITED",
"PRANAWA LEAFIN PRIVATE LIMITED",
"PRANAY CARE PRIVATE LIMITED",
"PRANAY CONES AND TUBES PVT LTD",
"PRANAY HOSPITALITY PRIVATE LIMITED",
"PRANAY MINERALS PRIVATE LIMITED",
"PRANCE ENTERPRISES LIMITED",
"PRANCH RESOURCES PRIVATE LIMITED",
"PRANDA JEWELRY PRIVATE LIMITED",
"PRANEET ENVIROQUIPS PVT LTD",
"PRANEET PROMOTERS PRIVATE LIMITED",
"PRANEET WTR INDIA PVT LTD",
"PRANEETHA VENTURES PRIVATE LIMITED",
"PRANERA SERVICES AND SOLUTIONS PRIVATE LIMITED",
"PRANESH DEALMARK PRIVATE LIMITED",
"PRANESH ESERVICES PRIVATE LIMITED",
"PRANESH PACKAGING PRIVATE LIMITED",
"PRANESH PROPERTIES PRIVATE LIMITED",
"PRANESH TRADERS PRIVATE LIMITED",
"PRANETICS BUSINESS CONSULTING PRIVATE LIMITED",
"PRANETRA MANPOWER SOLUTIONS PRIVATE LIMITED",
"PRANI AUTO PLAZA PRIVATE LIMITED",
"PRANIDHI CONSTRUCTIONS PRIVATE LIMITED",
"PRANIJ HEIGHTS INDIA PRIVATE LIMITED",
"PRANIK LIFE SCIENCE PRIVATE LIMITED",
"PRANIK LOGISTICS PRIVATE LIMITED",
"PRANIL POLYMERS LIMITED",
"PRANION TECHNOLOGY VENTURES PRIVATE LIMITED",
"PRANIR INFRACON PRIVATE LIMITED",
"PRANISKOM SOLUTIONS PRIVATE LIMITED",
"PRANIT PACKAGING PRIVATE LIMITED",
"PRANITA ELECTRICALS PRIVATE LIMITED",
"PRANJAL BIO (OPC) PRIVATE LIMITED",
"PRANJAL CHEM PRIVATE LIMITED",
"PRANJAL CORPORATE SERVICES PRIVATE LIMITED",
"PRANJAL INTERNATIONAL RESOLUTIONS PRIVATE LIMITED",
"PRANJAL PROJECTS PRIVATE LIMITED",
"PRANJAL VINAY BUILDERS & PROMOTERS PRIVATE LIMITED",
"PRANJAL VINAY INFRAESTATE PRIVATE LIMITED",
"PRANJALI GARMENTS PRIVATE LIMITED",
"PRANJEE PROPERTIES PRIVATE LIMITED",
"PRANJUL FASHION PRIVATE LIMITED",
"PRANKSTERS INN PRIVATE LIMITED",
"PRANNATH FOOTWEARS PRIVATE LIMITED",
"PRANNATH KAPUR & SONS PRIVATE LIMITED",
"PRANO FLAX (INDIA) PRIVATE LIMITED",
"PRANSA INTERNATIONAL PRIVATE LIMITED",
"PRANSHI BUILDTECH PRIVATE LIMITED",
"PRANSHI SEEDS AND PESTICIDES PRIVATE LIMITED",
"PRANSHU ALUMINIUM PRIVATE LIMITED",
"PRANSHU ELECTRICALS PVT LTD",
"PRANSHU FOODS PRIVATE LIMITED",
"PRANSHU PACKAGING PRIVATE LIMITED",
"PRANSHU RAVI CLOTHS MERCHANTS PRIVATE LIMITED",
"PRANSHUL LIFESCIENCES PRIVATE LIMITED",
"PRANSIV CONCRET PRIVATE LIMITED",
"PRANSS HEALTHCARE INDIA PRIVATE LIMITED",
"PRANSU CHEMICALS PVT LTD",
"PRANSUKHKA PULSES INDUSTRIES PRIVATE LIMITED",
"PRANTECH COMPONENTS PRIVATE LIMITED",
"PRANUKA PULSES INDUSTRIES PRIVATE LIMITED",
"PRANZIL MINCHEM (INDIA) PRIVATE LIMITED",
"PRAPALSHA AGROS LIMITED",
"PRAPTHAM TECH SOLUTIONS PRIVATE LIMITED",
"PRARA LEATHERS PRIVATE LIMITED",
"PRARAMBH BUILDCON AHMEDABAD LLP",
"PRARAMBH SECURITIES PRIVATE LIMITED",
"PRARAS BIO - SCIENCES PRIVATE LIMITED",
"PRARIT ADVISORY & ENTERTAINMENT PRIVATE LIMITED",
"PRAROCHAN MEDIA PRIVATE LIMITED",
"PRARTHANA ENGINEERING PRIVATE LIMITED",
"PRARTHANA ENTERPRISES",
"PRARTHANA ENTERPRISES PRIVATE LIMITED",
"PRARTHANA ESTATES PRIVATE LIMITED",
"PRARTHANA HOSPITAL AND ICU",
"PRARTHANA SALES PRIVATE LIMITED",
"PRARTHANA VIDYALAYA",
"PRARTHANA WOOLTEX PRIVATE LIMITED",
"PRARTHNA MANUFACTURING PRIVATE LIMITED",
"PRARUH PRIVATE LIMITED",
"PRARUP SHARES AND STOCK BROKERS PRIVATE LIMITED",
"PRAS FILAMENTS PRIVATE LIMITED",
"PRAS INSURANCE SURVEYORS & LOSS ASSESSORS PRIVATE LIMITED",
"PRAS PHARMA",
"PRASA INFOCOM & POWER SOLUTIONS PRIVATE LIMITED",
"PRASA TOOLS PRIVATE LIMITED",
"PRASAD & COMPANY (PROJECT WORKS) PRIVATE LIMITED",
"PRASAD AGRICO INDUSTRIES PRIVATE LIMITED",
"PRASAD AND COMPANY PROJECT WORKS LIMITED",
"PRASAD BEEJ FARMS PRIVATE LIMITED",
"PRASAD CORPORATION PRIVATE LIMITED",
"PRASAD COTTON INDUSTRIES PRIVATE LIMITED",
"PRASAD CRILEC AUTOMATION PRIVATE LIMITED",
"PRASAD ENVIRO LABS PRIVATE LIMITED",
"PRASAD EXIM PVT LTD",
"PRASAD EXTREME DIGITAL CINEMA NETWORK PRIVATE LIMITED",
"PRASAD FEEDS PRIVATE LIMITED",
"PRASAD FIBERS PRIVATE LIMITED",
"PRASAD FILM LABORATORIES PRIVATE LIMITED",
"PRASAD FILM LABS MUMBAI PRIVATE LIMITED",
"PRASAD FOOD PRODUCTS PRIVATE LIMITED",
"PRASAD GWK COOL TECH PRIVATE LIMITED",
"PRASAD HERITAGE PROJECTS PRIVATE LIMITED",
"PRASAD HOSPITAL",
"PRASAD HOSPITALS INDIA PRIVATE LIMITED",
"PRASAD IDEAL HEALTHCARE PRIVATE LIMITED",
"PRASAD INFRA-STRUCTURALS PRIVATE LIMITED",
"PRASAD INTERNATIONAL PRIVATE LIMITED",
"PRASAD IVF CLINIC PRIVATE LIMITED",
"PRASAD KOCH TECHNIK PRIVATE LIMITED",
"PRASAD MACHINERY PRIVATE LIMITED",
"PRASAD MEDIA CORPORATION PRIVATE LIMITED",
"PRASAD MULTI SERVICES PRIVATE LIMITED",
"PRASAD NUTRIMENTS PRIVATE LIMITED",
"PRASAD ORGANICS PRIVATE LIMITED",
"PRASAD PILE PROJECTS PRIVATE LIMITED",
"PRASAD PLYWOOD INDUSTRIES PRIVATE LIMITED",
"PRASAD PNEUCON SOLUTION PRIVATE LIMITED",
"PRASAD POLYCHEM PRIVATE LIMITED",
"PRASAD ROADS AND INFRA PRIVATE LIMITED",
"PRASAD SEEDS PRIVATE LIMITED",
"PRASAD SUGAR & ALLIED AGRO PRODUCTS LIMITED",
"PRASAD TECHNOLOGY PARK PRIVATE LIMITED",
"PRASAD V POTLURI SIDDHARTHA INSTITUTE OF TECHNOLOGY",
"PRASAD WINDMILLS PRIVATE LIMITED",
"PRASADINI OIL MILLS PRIVATE LIMITED",
"PRASAM EXPORTS",
"PRASANAM FOODS PRIVATE LIMITED",
"PRASANDI INFOTECH PARK PRIVATE LIMITED",
"PRASANG POLYTEX PRIVATE LIMITED",
"PRASANG PRESIDENCY",
"PRASANNA LIFESCIENCES PRIVATE LIMITED",
"PRASANNA PACKAGING MACHINERY PRIVATE LIMITED",
"PRASANNA PRECISION PRIVATE LIMITED",
"PRASANNA PROPERTIES AND TRADERS PRIVATE LIMITED",
"PRASANNA PURPLE MOBILITY SOLUTIONS PRIVATE LIMITED",
"PRASANNA TECHNOLOGIES PRIVATE LIMITED",
"PRASANNA TRANSPORT NETWORK PRIVATE LIMITED",
"PRASANNABIOMOLECULES PRIVATE LIMITED",
"PRASANNAKSHI HEALTH CARE PRIVATE LIMITED",
"PRASANNALAKSHMI NAVNIRMAN PRIVATE LIMITED",
"PRASANNOSTU PROJECTS PRIVATE LIMITED",
"PRASANT PACKAGING PVT LTD",
"PRASANTA MOTORS PRIVATE LIMITED",
"PRASANTH PANACHIKKAL ENTERPRISES PRIVATE LIMITED",
"PRASANTHI AGRITECH PRIVATE LIMITED",
"PRASANTHI BREEDERS PRIVATE LIMITED",
"PRASANTHI BREEDING FARMS PRIVATE LIMITED",
"PRASANTHI CASHEW COMPANY PRIVATE LIMITED",
"PRASANTHI HATCHERIES PRIVATE LIMITED",
"PRASANTHI LEATHER CHEM PRIVATE LIMITED",
"PRASANTHI SAI IMPEX PRIVATE LIMITED",
"PRASANTI CONCRETE SOLUTIONS PRIVATE LIMITED",
"PRASAR BHARATI",
"PRASAR BHARATI INDIA'S PUBLIC SERVICE BROADCASTER",
"PRASAR BHARTI",
"PRASARA INNOTECH PRIVATE LIMITED",
"PRASARNET CONSULTING SERVICES PRIVATE LIMITED",
"PRASAV RETAIL SOLUTIONS PRIVATE LIMITED",
"PRASAYANK TECH CAD CAM PRIVATE LIMITED",
"PRASH RAJ ENTERPRISES PRIVATE LIMITED",
"PRASHA CHEMICALS PRIVATE LIMITED",
"PRASHA CONSULTANCY SERVICES PRIVATE LIMITED",
"PRASHA TECHNOLOGIES LIMITED",
"PRASHAD KNITFAB PRIVATE LIMITED",
"PRASHAKTI SERVICES PRIVATE LIMITED",
"PRASHAM CONSTRUCTION AND ENGINEERING PRIVATE LIMITED",
"PRASHAM FINSTOCK PRIVATE LIMITED",
"PRASHANT AUTO PARTS PRIVATE LIMITED",
"PRASHANT AUTOMOBILES PRIVATE LIMITED",
"PRASHANT BUILDING TECH PRIVATE LIMITED",
"PRASHANT CASTECH PRIVATE LIMITED",
"PRASHANT ENGICHEM PRIVATE LIMITED",
"PRASHANT ENTERPRISES",
"PRASHANT ENTERPRISES GROUP",
"PRASHANT FERBER LOGISTICS AUTOMATION PRIVATE LIMITED",
"PRASHANT GAMATEX PRIVATE LIMITED",
"PRASHANT HOSPITAL",
"PRASHANT INDIA LIMITED",
"PRASHANT JEWELLERS PRIVATE LIMITED",
"PRASHANT KARIYA AND ASSOCIATES",
"PRASHANT MEMORIAL CHARITABLE HOSPITAL",
"PRASHANT MILAN PVT LTD",
"PRASHANT MOTORS PRIVATE LIMITED PMPL",
"PRASHANT SAGAR BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"PRASHANT SOFTWARES PRIVATE LIMITED",
"PRASHANT THERMO PLASTICS PVT LTD",
"PRASHANT WEAVING INDUSTRIES PRIVATE LIMITED",
"PRASHANT WEST POINT MACHINERY PRIVATE LIMITED",
"PRASHANTH DYECHEM PRIVATE LIMITED",
"PRASHANTH EDUCATIONAL SOCIETY",
"PRASHANTH FERTILITY RESEARCH CENTRE PRIVATE LIMITED",
"PRASHANTH HOSPITAL",
"PRASHANTH MULTI SPECIALITY HOSPITAL",
"PRASHANTH POULTRY PRIVATE LIMITED",
"PRASHANTH PROPERTIES PRIVATE LIMITED",
"PRASHANTHI BALAMANDIRA TRUST",
"PRASHANTHI HOSPITAL",
"PRASHANTHI MEDIA PRIVATE LIMITED",
"PRASHANTHI NIKETAN PROPERTY HOLDINGS PRIVATE LIMITED",
"PRASHANTHI POLYMERS (INDIA) PRIVATE LIMITED",
"PRASHANTI ENGINEERING WORKS PRIVATE LIMITED",
"PRASHANTI ENGINEERS PRIVATE LIMITED",
"PRASHANTI ENTERPRISES PRIVATE LIMITED",
"PRASHANTI FORMULATIONS LIMITED",
"PRASHANTI SURYA CONSTRUCTION CO.PRIVATE LIMITED",
"PRASHANT-MARBLES PRIVATE LIMITED",
"PRASHAR ASSOCIATES",
"PRASHAR ROAD CARRIERS PRIVATE LIMITED",
"PRASHAST FOOD PRODUCTS PRIVATE LIMITED",
"PRASHASTE EDUCATION AND MANAGEMENT CONSULTANCY PRIVATE LIMITED",
"PRASHASTI DEVELOPERS PRIVATE LIMITED",
"PRASHEETAN INFRAPROJECTS PRIVATE LIMITED",
"PRASHI INFRASTRUCTURE PRIVATE LIMITED",
"PRASHI MANAGEMENT CONSULTING PRIVATE LIMITED",
"PRASHI PHARMA PRIVATE LIMITED",
"PRASHTECH ENGINEERS PRIVATE LIMITED",
"PRASHTEK EPARTS SOLUTIONS PRIVATE LIMITED",
"PRASHU AGROCOM PRIVATE LIMITED",
"PRASHVVITA FASHION PRIVATE LIMITED",
"PRASIDDH CONTAINERS PRIVATE LIMITED",
"PRASIDDHI PROPERTIES PRIVATE LIMITED",
"PRASIDDHI SOLAR PRIVATE LIMITED",
"PRASIDH FINCAP LIMITED",
"PRASIDH HOSPITALS",
"PRASIDHA AGRI SCIENCES PRIVATE LIMITED",
"PRASOFT IT SERVICES PRIVATE LIMITED",
"PRASOL CHEMICALS LIMITED",
"PRASOM FACILITIES MANAGEMENT (INDIA) PRIVATE LIMITED",
"PRASOON DESIGN STUDIO",
"PRASPACK INDUSTRIES PRIVATE LIMITED",
"PRASSANA TEXTILE MILLS INDIA PRIVATE LIMITED",
"PRASSANNA SPINNING MILLS PRIVATE LIMITED",
"PRASTHANA SOFTWARE SOLUTIONS PRIVATE LIMITED",
"PRASU INFRABUILD PRIVATE LIMITED",
"PRASU TRADING AND INVESTMENT COMPANY PRIVATE LIMITED",
"PRASUM METALS PRIVATE LIMITED",
"PRASUN AGENCIES PRIVATE LIMITED",
"PRASUNA VAMSIKRISHNA SPINNING MILLS PRIVATE LIMITED",
"PRASUNCO TRADERS PRIVATE LIMITED",
"PRASUR ELECTRICALS & ENGINEERING CO",
"PRASUS PROJECTS PRIVATE LIMITED",
"PRATA IT SOLUTIONS INDIA PRIVATE LIMITED",
"PRATAAP SNACKS LIMITED",
"PRATAHKAL MULTIMEDIA LIMITED",
"PRATAP AUTOCOM PRIVATE LIMITED",
"PRATAP BUILDTECH PRIVATE LIMITED",
"PRATAP CARS PRIVATE LIMITED",
"PRATAP DEPARTMENTAL STORE PRIVATE LIMITED",
"PRATAP DEVELOPERS PRIVATE LIMITED",
"PRATAP DIESELS PRIVATE LIMITED",
"PRATAP DIGITAL COMMUNICATIONS PRIVATE LIMITED",
"PRATAP ELECTRICALS PRIVATE LIMITED",
"PRATAP ENERGY SOLUTIONS PRIVATE LIMITED",
"PRATAP GLOBEZONE TECHNOLOGIES PRIVATE LIMITED",
"PRATAP GRANITES PVT LTD",
"PRATAP HEALTH & FOODS INDIA PRIVATE LIMITED",
"PRATAP HEIGHTS PRIVATE LIMITED",
"PRATAP HOMES PRIVATE LIMITED",
"PRATAP HOSPITAL",
"PRATAP INFRABUILD PRIVATE LIMITED",
"PRATAP INFRACREATIONS PRIVATE LIMITED",
"PRATAP ISPAT PRIVATE LIMITED",
"PRATAP MADHYAMIC VIDYA KALMESHWAR",
"PRATAP MOTORRAD PRIVATE LIMITED",
"PRATAP NAGAR RAILWAY HOSPITAL",
"PRATAP ORGANICS PRIVATE LIMITED",
"PRATAP PETRO PRODUCTS PVT. LTD.",
"PRATAP POLYSACKS LIMITED",
"PRATAP RE-ROLLERS PRIVATE LIMITED",
"PRATAP SYNTHETICS LIMITED",
"PRATAP TECHNOCRATS PRIVATE LIMITED",
"PRATAP TECHNOPLAST PRIVATE LIMITED",
"PRATAP TEXCHEM PRIVATE LIMITED",
"PRATAPGARH AUTO SERVICES PRIVATE LIMITED",
"PRATAPRAISONS TEXTILES PRIVATE LIMITED",
"PRATEEK ALLOYS PRIVATE LIMITED",
"PRATEEK BUILDTECH INDIA PRIVATE LIMITED",
"PRATEEK ENETERPRISES",
"PRATEEK EXPLOSIONPROOF PRIVATE LIMITED",
"PRATEEK INFRAPROJECTS INDIA PRIVATE LIMITED",
"PRATEEK INFRATECH INDIA PRIVATE LIMITED",
"PRATEEK LIGHTING PRIVATE LIMITED",
"PRATEEK PAINTS AND PLY PRIVATE LIMITED",
"PRATEEK PET PRIVATE LIMITED",
"PRATEEK PLANT SERVICES PRIVATE LIMITED",
"PRATEEK POLYPACK PRIVATE LIMITED",
"PRATEEK RAJA CONTEMPORARY ARTS PRIVATE LIMITED",
"PRATEEK REALTORS INDIA PRIVATE LIMITED",
"PRATEEK RESORTS AND BUILDERS PRIVATE LIMITED",
"PRATEEK RUBBERS PRIVATE LIMITED",
"PRATEEK SPUNFAB PRIVATE LIMITED",
"PRATEEK TECHNOSOFT INDIA PRIVATE LIMITED",
"PRATEEK WIRES PRIVATE LIMITED",
"PRATEETI INFOTECH PRIVATE LIMITED",
"PRATH TEXTILES PRIVATE LIMITED",
"PRATHA AUTOMOBILES PRIVATE LIMITED",
"PRATHA TRADITIONAL HANDICRAFTS PRIVATE LIMITED",
"PRATHAM ADVISORS PRIVATE LIMITED",
"PRATHAM BUILDCON PRIVATE LIMITED",
"PRATHAM CARS PRIVATE LIMITED",
"PRATHAM CATERING SERVICES PRIVATE LIMITED",
"PRATHAM COTSPIN PRIVATE LIMITED",
"PRATHAM EDUCATION FOUNDATION",
"PRATHAM ENDOCRINE & DIABETES CENTER",
"PRATHAM ENERGY SYSTEMS PRIVATE LIMITED",
"PRATHAM EPC PROJECTS LIMITED",
"PRATHAM EPC PROJECTS PRIVATE LIMITED",
"PRATHAM HOSPITALITY SERVICES PRIVATE LIMITED",
"PRATHAM INFOTECH FOUNDATION",
"PRATHAM INTEGRATED ENGINEERING SOLUTIONS (INDIA) PRIVATE LIMITED",
"PRATHAM LOGISTICS PRIVATE LIMITED",
"PRATHAM MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"PRATHAM MULTITECH PRIVATE LIMITED",
"PRATHAM PHARMACHEM PRIVATE LIMITED",
"PRATHAM PRAKASH COMMERCIAL PRIVATE LIMITED",
"PRATHAM PUBLICITY PRIVATE LIMITED",
"PRATHAM REALTORS PRIVATE LIMITED",
"PRATHAM REALTY PRIVATE LIMITED",
"PRATHAM SHIPPING & LOGISTICS PRIVATE LIMITED",
"PRATHAM SOFTWARE PRIVATE LIMITED",
"PRATHAM SOLUTIONS PRIVATE LIMITED",
"PRATHAM TECHNOLOGIES PRIVATE LIMITED",
"PRATHAM TRANSOLUTIONS INDIA PRIVATE LIMITED",
"PRATHAMA BLOOD CENTRE",
"PRATHAMA SOLARCONNECT ENERGY PRIVATE LIMITED",
"PRATHAMA TRADING PRIVATE LIMITED",
"PRATHAMA UP GRAMIN BANK",
"PRATHAMESH DREAM PROPERTIES PRIVATE LIMITED",
"PRATHAMESH ISPAT ENGINEERS PRIVATE LIMITED",
"PRATHAMESH KRUPA BUILDCON PRIVATE LIMITED",
"PRATHAMESH MILK TRANSPORT PRIVATE LIMITED",
"PRATHAMESH SOLARFARMS LIMITED",
"PRATHAMESH TECHNO-WORKFORCE PRIVATE LIMITED",
"PRATHAMESH WELDING SOLUTIONS (I) PRIVATE LIMITED",
"PRATHAMESHWARA CONSULTING PRIVATE LIMITED",
"PRATHAMESHWARA RETAIL PRIVATE LIMITED",
"PRATHAM-HEERA SALES PRIVATE LIMITED",
"PRATHAMIK AAROGYA KENDRA BRITISH ANKUSH VIHIR",
"PRATHAMIK AAROGYA KENDRA SHAKSHALPIMPRI",
"PRATHAMIK AASHRAM SHALA BILBARA",
"PRATHAMIK MADYAMIK ASHRAM SHALA",
"PRATHANA VIDHAYLAY",
"PRATHANA VINIMAY PRIVATE LIMITED",
"PRATHAYANI WIND FARMS PRIVATE LIMITED",
"PRATHEEK ELEVATORS PRIVATE LIMITED",
"PRATHEMESH MULTICOM PRIVATE LIMITED",
"PRATHIBA DEVELOPERS PRIVATE LIMITED",
"PRATHIBHA BIOTECH PRIVATE LIMITED",
"PRATHIBHA INSTITUTES",
"PRATHIBHA JUNIOR COLLEGE",
"PRATHIGNA.COM HR SOLUTIONS PRIVATE LIMITED",
"PRATHIJNA SUSTAINABLE SOLUTIONS PRIVATE LIMITED",
"PRATHIMA INDUSTRIES PRIVATE LIMITED",
"PRATHIMA INFRASTRUCTURE LIMITED",
"PRATHIMA MULTIPLEX PRIVATE LIMITED",
"PRATHIN FOODS PRIVATE LIMITED",
"PRATHIPADU AGRITECH PRIVATE LIMITED",
"PRATHIPATI ESTATES PRIVATE LIMITED",
"PRATHIRAJ METAL MASTERS PRIVATE LIMITED",
"PRATHISHTA BUSINESS SOLUTIONS PRIVATE LIMITED",
"PRATHISHTA WEAVING AND KNITTING COMPANY PRIVATE LIMITED",
"PRATHISTA INDUSTRIES LIMITED",
"PRATHISTA PROPACK PRIVATE LIMITED",
"PRATHIT AUTOMATION TECHNOLOGIES PRIVATE LIMITED",
"PRATHMESH DYECHEM PRIVATE LIMITED",
"PRATHMIK AROGYA KENDRA NALWANDI BEED",
"PRATHMIK ASHRAM SHALA KOLAMBI",
"PRATHMIK ASHRAM SHALA PETH VADGAON",
"PRATHMIK SHIKSHAK BHADVASA",
"PRATHMIK VIDYALAYA",
"PRATHNA BUILDCON PRIVATE LIMITED",
"PRATHNA ENTERPRISE",
"PRATHU GINNING MILL PRIVATE LIMITED",
"PRATHUL AUTOMOBILES PRIVATE LIMITED",
"PRATHVI AGROTECH PRIVATE LIMITED",
"PRATHVI TEXTILES (INDIA) PRIVATE LIMITED",
"PRATHYAK SERVICES PRIVATE LIMITED",
"PRATHYUN SHIPPING INDIA PRIVATE LIMITED",
"PRATHYUSHA ENGINEERING COLLEGE",
"PRATHYUSHA GLOBAL TRADE PRIVATE LIMITED",
"PRATIAN LEARNING AND CONSULTING PRIVATE LIMITED",
"PRATIAN TECHNOLOGIES INDIA PRIVATE LIMITED",
"PRATIBHA AND GANGA PRIVATE LIMITED",
"PRATIBHA COLLEGE OF COMMERCE AND COMPUTER STUDIES",
"PRATIBHA ELECTRICAL CONTRACTOR LLP",
"PRATIBHA ELECTRONICS PRIVATE LIMITED",
"PRATIBHA ENDEAVOR PRIVATE LIMITED",
"PRATIBHA ERECTORS LIMITED",
"PRATIBHA FABRICS LIMITED",
"PRATIBHA GLOBAL PRIVATE LIMITED",
"PRATIBHA HOLDINGS PVT LTD",
"PRATIBHA HORIZON SOLUTIONS PRIVATE LIMITED",
"PRATIBHA MANPOWER SOLUTIONS PRIVATE LIMITED",
"PRATIBHA METFAB PRIVATE LIMITED",
"PRATIBHA OFFSET PRINTING PRIVATE LIMITED",
"PRATIBHA PACKAGING AND POLYMERS PRIVATE LIMITED",
"PRATIBHA PACKWELL PRIVATE LIMITED",
"PRATIBHA PRESS AND MULTI MEDIA PRIVATE LIMITED",
"PRATIBHA REALTORS PRIVATE LIMITED",
"PRATIBHA SYNTEX LIMITED",
"PRATIBHANIKETAN MADHYAMIK V UCHHAMADHYAMIK ASHRAM SHALA",
"PRATIBHUTI VINIHIT LIMITED",
"PRATIBHUTI VINIYOG LIMITED",
"PRATIBIMB FLEX PACK PRIVATE LIMITED",
"PRATICHHAYA PVT LTD",
"PRATIDIN PRAKASHANI PRIVATE LIMITED",
"PRATIGRHAM SPORTS FOR ALL (OPC) PRIVATE LIMITED",
"PRATIK ALLOYS PRIVATE LIMITED",
"PRATIK ART INTERIORS PRIVATE LIMITED",
"PRATIK CONDUCTORS PRIVATE LIMITED",
"PRATIK DEALERS PRIVATE LIMITED",
"PRATIK FINSTOCK PRIVATE LIMITED",
"PRATIK FOREX PRIVATE LIMITED",
"PRATIK GOODS CARRIER PRIVATE LIMITED",
"PRATIK HEAT PRODUCTS PRIVATE LIMITED",
"PRATIK HOSIERY PRIVATE LIMITED",
"PRATIK HYTECH WORKS PRIVATE LIMITED",
"PRATIK MACHINERIES PRIVATE LIMITED",
"PRATIK MARBLES PRIVATE LIMITED",
"PRATIK METALS PRIVATE LIMITED",
"PRATIK POLYFOAMS PRIVATE LIMITED",
"PRATIK PROCESSORS PRIVATE LIMITED",
"PRATIK SILK MILLS PRIVATE LIMITED",
"PRATIK SURVEYORS (INDIA) PRIVATE LIMITED",
"PRATIK TRADING ZONE PRIVATE LIMITED",
"PRATIK TRANSPOWER PRIVATE LIMITED",
"PRATIKAR FIN-LEASE PRIVATE LIMITED",
"PRATIKSHA CHEMICALS LIMITED",
"PRATIKSHA ENTERPRISE PRIVATE LIMITED",
"PRATIKSHA HOTELS AND MOTELS PRIVATE LIMITED",
"PRATIKSHA INDUSTRIES PRIVATE LIMITED",
"PRATIKSHA INFRACON PRIVATE LIMITED",
"PRATIKSHAT SOLUTIONS LLP",
"PRATIMA AGRO AND PAPER PRIVATE LIMITED",
"PRATIMA DEVELOPERS (INDIA) PRIVATE LIMITED",
"PRATIMA SHANKAR FLOUR MILL PRIVATE LIMITED",
"PRATIMAN TEXTILES PRIVATE LIMITED",
"PRATISAAD COMMUNICATIONS PRIVATE LIMITED",
"PRATISH PACKAGING PRIVATE LIMITED",
"PRATISHTHA COMMERCIAL PRIVATE LIMITED",
"PRATISHTHA PLASTICS PRIVATE LIMITED",
"PRATISHTHA POLYPACK PRIVATE LIMITED",
"PRATISHTHA PRESSING WORKS PRIVATE LIMITED",
"PRATISHTHAN MAHAVIDYALAYA",
"PRATISHTHAN SOFTWARE VENTURES PRIVATE LIMITED",
"PRATISTHA CHEM TRADE PRIVATE LIMITED",
"PRATISTHA DISTRIBUTORS PRIVATE LIMITED",
"PRATISTHA ENERGY PRIVATE LIMITED",
"PRATISTHA ENGINEERING LIMITED",
"PRATITHI ORGANIC FOODS PRIVATE LIMITED",
"PRATITI HEALTH EDUCATIONAL INSTITUTES PRIVATE LIMITED",
"PRATITI INDUSTRIES",
"PRATITI TECHNOLOGIES PRIVATE LIMITED",
"PRATRAY PRINTMAT PRIVATE LIMITED",
"PRATT MEMORIAL SCHOOL",
"PRATT MULLER DISTRIBUTORS LTD",
"PRATTAY AQUA PRIVATE LIMITED",
"PRATUL CHEMICALS PRIVATE LIMITED",
"PRATUL ENTERPRISES PRIVATE LIMITED",
"PRATYAKSHA AGROTECH PRIVATE LIMITED",
"PRATYAKSHA TRACTORS PRIVATE LIMITED",
"PRATYAM TECHNOLOGIES PRIVATE LIMITED",
"PRATYANCHA FINANCIAL SERVICES LIMITED",
"PRATYANCHA INDUSTRIES PRIVATE LIMITED",
"PRATYARPANA SERVICES PRIVATE LIMITED",
"PRATYASH INFOSOLUTIONS PRIVATE LIMITED",
"PRATYASH RENEWABLE PRIVATE LIMITED",
"PRATYAYA E-COMMERCE PRIVATE LIMITED",
"PRATYAYA SERVICES PRIVATE LIMITED",
"PRATYIN INFOTECH CONSULTING PRIVATE LIMITED",
"PRATYUSH FOODS PRIVATE LIMITED",
"PRATYUSH HEALTHCARE PRIVATE LIMITED",
"PRATYUSH INDUSTRIES PRIVATE LIMITED",
"PRATYUSH INFRASTRUCTURE PRIVATE LIMITED",
"PRATYUSH NISHA VENTURES PRIVATE LIMITED",
"PRAUDHA TECH SOLUTIONS PRIVATE LIMITED",
"PRAUME LIFESTYLE PRIVATE LIMITED",
"PRAVAA INFOSYSTEMS PRIVATE LIMITED",
"PRAVAHI MANUFACTURING PRIVATE LIMITED",
"PRAVALLIKA PROJECTS PRIVATE LIMITED",
"PRAVANYA SOLAR INDIA PRIVATE LIMITED",
"PRAVARA OOS TOD VA-VAAHATUK MAJOOR SANSTHA PVT LTD",
"PRAVARDHAN SEEDS PRIVATE LIMITED",
"PRAVARSHA AGRO INDUSTRIES PRIVATE LIMITED",
"PRAVARSHA MART PRIVATE LIMITED",
"PRAVARTEE SALES PRIVATE LIMITED",
"PRAVASHA PIPELINES PRIVATE LIMITED",
"PRAVASHAM BUILDWELL PRIVATE LIMITED",
"PRAVASI CABS PRIVATE LIMITED",
"PRAVED NEO TECH PRIVATE LIMITED",
"PRAVEEDH DECOR PRIVATE LIMITED",
"PRAVEEN AROMA PRIVATE LIMITED",
"PRAVEEN CAPITAL PRIVATE LIMITED",
"PRAVEEN ELECTRICAL WORKS",
"PRAVEEN ENGINEERING PRODUCTS INDIA PRIVATE LIMITED",
"PRAVEEN JEWELS PRIVATE LIMITED",
"PRAVEEN LABORATORIES PRIVATE LIMITED",
"PRAVEEN POLYMERS PRIVATE LIMITED",
"PRAVEEN ROADLINES PRIVATE LIMITED",
"PRAVEEN TRAVELS PRIVATE LIMITED",
"PRAVEENS FAB CREATION INDIA PRIVATE LIMITED",
"PRAVEG LIMITED",
"PRAVEK KALP PRIVATE LIMITED",
"PRAVERGO INDUSTRIES PRIVATE LIMITED",
"PRAVESA HOLDING PRIVATE LIMITED",
"PRAVESH CREDIT AND SECURITIES LIMITED",
"PRAVESH EXPORTS PRIVATE LIMITED",
"PRAVESH PAPER PRIVATE LIMITED",
"PRAVESH SEAFOOD PRIVATE LIMITED",
"PRAVESHA INDUSTRIES PRIVATE LIMITED",
"PRAVHA CHILLI PRIVATE LIMITED",
"PRAVI AUTO SWING PVT LTD",
"PRAVI PLASTICS PRIVATE LIMITED",
"PRAVIDHI INDIA CONSULTANCY PRIVATE LIMITED",
"PRAVIN AUTO ENGINEERING PRIVATE LIMITED",
"PRAVIN BUILDTECH PRIVATE LIMITED",
"PRAVIN DYECHEM PRIVATE LIMITED",
"PRAVIN ELECTRICALS PRIVATE LIMITED",
"PRAVIN GALA CONSULTANTS PRIVATE LIMITED",
"PRAVIN ORNAMENTS PRIVATE LIMITED",
"PRAVIN PAPERS PRIVATE LIMITED",
"PRAVIN PATIL COLLEGE OF DIPLOMA ENGINEERING & TECHNOLOGY",
"PRAVIN TECHNO TRAC ENGINEERING (INDIA) PRIVATE LIMITED",
"PRAVINKUMAR AND BROTHERS PRIVATE LIMITED",
"PRAVIR SEEDS PRIVATE LIMITED",
"PRAVIT REALTORS PRIVATE LIMITED",
"PRAVIZ DEVELOPERS PRIVATE LIMITED",
"PRAVRITTI CONSULTING SERVICES PRIVATE LIMITED",
"PRAVUJAGDISH REALTORS PRIVATE LIMITED",
"PRAWAH ELECTRONICS PRIVATE LIMITED",
"PRAWAL MEDIA PRIVATE LIMITED",
"PRAWEEN GULATI INFRASTRUCTURE PRIVATE LIMITED",
"PRAXAIR INDIA PRIVATE LIMITED",
"PRAXEVA INDIA SERVICES PRIVATE LIMITED",
"PRAXIAN GLOBAL PRIVATE LIMITED",
"PRAXIEN TECH PRIVATE LIMITED",
"PRAXIS BUSINESS SCHOOL FOUNDATION",
"PRAXIS CONSULTING AND INFORMATION SERVICES PRIVATE LIMITED.",
"PRAXIS DESIGN & BUILDING SOLUTIONS PRIVATE LIMITED",
"PRAXIS HOME RETAIL LIMITED",
"PRAXIS INFO SOLUTIONS PRIVATE LIMITED",
"PRAXIS INSTITUTE FOR PARTICIPATORY PRACTICES",
"PRAXIS INTERACTIVE SERVICES PRIVATE LIMITED",
"PRAXIS SERVICES PRIVATE LIMITED",
"PRAXVI SOLUTIONS & SERVICES",
"PRAXYS PROJECT ENGINEERS LIMITED",
"PRAY SAI INDUSTRIES PRIVATE LIMITED",
"PRAYAAG FORGE PRIVATE LIMITED",
"PRAYAAG INTERNATIONAL SCHOOL",
"PRAYAAN CAPITAL PRIVATE LIMITED",
"PRAYAAS AUTOMATION PRIVATE LIMITED",
"PRAYAG ACADEMY",
"PRAYAG CHEMICALS PRIVATE LIMITED",
"PRAYAG CLAY PRODUCTS LIMITED",
"PRAYAG COAL COMPANY PRIVATE LIMITED",
"PRAYAG CONSULTING PRIVATE LIMITED",
"PRAYAG HEALTH CARE & RESEARCH CENTRE PRIVATE LIMITED",
"PRAYAG POLYMERS PRIVATE LIMITED",
"PRAYAG POLYTECH PRIVATE LIMITED (TRANSFER FROM DELHI TO RAJASTHAN)",
"PRAYAG POLYVINYL PRIVATE LIMITED",
"PRAYAG PUBLIC SCHOOL",
"PRAYAG SOLUTIONS",
"PRAYAG TEXPRINT PRIVATE LIMITED",
"PRAYAG TRAVEL SERVICES PRIVATE LIMITED",
"PRAYAG TUBES PRIVATE LIMITED",
"PRAYAG UDYOG PRIVATE LIMITED",
"PRAYAGH NUTRI PRODUCTS PRIVATE LIMITED",
"PRAYAGH PRODUCTS PRIVATE LIMITED",
"PRAYAGRAJ DYEING AND PRINTING MILLS PRIVATE LIMITED",
"PRAYAGRAJ INFRA VENTURES PRIVATE LIMITED",
"PRAYAGRAJ KRISHI PRODUCER COMPANY LIMITED",
"PRAYAGRAJ POWER GENERATION COMPANY LIMITED",
"PRAYAGRAJ SMART CITY LIMITED",
"PRAYAGRAJ WATER PRIVATE LIMITED",
"PRAYAN ANIMATION STUDIO PRIVATE LIMITED",
"PRAYANK EYEWARE & HEALTCARE PRIVATE LIMITED",
"PRAYANK HOUSING PRIVATE LIMITED",
"PRAYAS BEVERAGES & FOODS (OPC) PRIVATE LIMITED",
"PRAYAS ELECTRO-SYSTEMS (THANE) PRIVATE LIMITED",
"PRAYAS ENGINEERING LIMITED",
"PRAYAS FINANCIAL SERVICES PRIVATE LIMITED",
"PRAYAS MANAGEMENT SERVICES PRIVATE LIMITED",
"PRAYAS METAL (INDIA) PRIVATE LIMITED",
"PRAYAS SECURITIES PRIVATE LIMITED",
"PRAYAS STEELS PRIVATE LIMITED",
"PRAYAS VISHESH SCHOOL¬†AMRAVATI",
"PRAYAS WOOLLENS PRIVATE LIMITED",
"PRAYASH HEALTH CARE PRIVATE LIMITED",
"PRAYASH IRON AND MINERALS PRIVATE LIMITED",
"PRAYASH TRADEWELL PRIVATE LIMITED",
"PRAYASH VINIMAY PRIVATE LIMITED",
"PRAYATI SHIPPING PRIVATE LIMITED",
"PRAYATI TRUCKING PRIVATE LIMITED",
"PRAYATNA DEVELOPERS PRIVATE LIMITED",
"PRAYATNA MICROFINANCE LIMITED",
"PRAYEJA REALTY PRIVATE LIMITED",
"PRAYER ENSEMBLE PRIVATE LIMITED",
"PRAYOG ELECTRICALS PRIVATE LIMITED",
"PRAYOG VENTURES PRIVATE LIMITED",
"PRAYOGIK TECHNOLOGIES PRIVATE LIMITED",
"PRAYOSA BUILDMAT PRIVATE LIMITED",
"PRAYOSHA AUTOMATION PRIVATE LIMITED",
"PRAYOSHA EXPO PRIVATE LIMITED",
"PRAYOSHA HEALTH CARE PRIVATE LIMITED",
"PRAYOSHA STAINLESS PRIVATE LIMITED",
"PRAYOSHA TEXTILE PRIVATE LIMITED",
"PRAYUSHAN VENTURES PRIVATE LIMITED",
"PRAZAS LEARNING INDIA PRIVATE LIMITED",
"PRAZIM TRADING AND INVESTMENT COMPANY PRIVATE LIMITED.",
"PRAZISION DEEP DRAW PRIVATE LIMITED",
"PRAZNA SOFTWARE SOLUTIONS PRIVATE LIMITED",
"PRAZNIK INDIA PRIVATE LIMITED",
"PRB SPORTS GALLERY PRIVATE LIMITED",
"PRBS CONSTRUCTIONS PRIVATE LIMITED",
"PRC COLLEGE OF ARTS",
"PRC COLLEGE OF ENGINEERING",
"PRC INSTITUTE OF CATERING & HOTEL MANAGE",
"PRC INSTITUTE OF MANAGEMENT",
"PRC INTERNATIONAL HOTELS PRIVATE LIMITED",
"PRC TEACHER TRAINING INSTITUTE",
"PRCM METAL LIMITED",
"PRD CARGO AND LOGISTIC PRIVATE LIMITED",
"PRD CORPORATE SOLUTION PRIVATE LIMITED",
"PRDR INTERNATIONAL PRIVATE LIMITED",
"PRE PROMO GOKARTING PRIVATE LIMITED",
"PRE STEEL LLP",
"PRE UNIQUE INDIA PRIVATE LIMITED",
"PREACT CONSULTING SERVICES PRIVATE LIMITED",
"PREACTOR SOFTWARE INDIA PRIVATE LIMITED",
"PREAMPLE REMOTE STAFFING PRIVATE LIMITED",
"PREBO AUTOMOTIVE PRIVATE LIMITED",
"PRECA SOLUTIONS INDIA PRIVATE LIMITED",
"PRECAMA HEALTHCARE PRIVATE LIMITED",
"PRECARMART PRIVATE LIMITED",
"PRECAST INDIA INFRASTRUCTURES PRIVATE LIMITED",
"PRECASTERS INDIA PRIVATE LIMITED",
"PRECAUTION PROPERTIES PRIVATE LIMITED",
"PRECE GRIP PRIVATE LIMITED",
"PRECEL SOLUTIONS PRIVATE LIMITED",
"PRECEPT PHARMA LIMITED",
"PRECEPTOR MANAGEMENT SERVICES",
"PRECEPTOR MARKETING SERVICES PRIVATE LIMITED",
"PRECI CAST (INDIA) PRIVATE LIMITED",
"PRECI FAB ENGINEERS PRIVATE LIMITED",
"PRECI PACK PRIVATE LIMITED",
"PRECI TURN PRIVATE LIMITED",
"PRECIA FINE JEWELLERY PRIVATE LIMITED",
"PRECIA MOLEN INDIA PRIVATE LIMITED",
"PRECIA PHARMA PRIVATE LIMITED",
"PRECICON ENGINEERING PRIVATE LIMITED",
"PRECICON TECHNOLOGIES INDIA PRIVATE LIMITED",
"PRECICRAFT COMPONENTS INDIA PRIVATE LIMITED",
"PRECICRAFT VACCUM PUMPS PRIVATE LIMITED",
"PRECICUT ENGINEERING PRIVATE LIMITED",
"PRECIEA BEAUTY EXPERTS PRIVATE LIMITED",
"PRECIFAST PRIVATE LIMITED",
"PRECIFINE PRODUCTS PRIVATE LIMITED",
"PRECIFLAT PRODUCTS PRIVATE LIMITED",
"PRECIHOLE MACHINE TOOLS PRIVATE LIMITED",
"PRECIHOLE SPORTS PRIVATE LIMITED",
"PRECIMAX BEARING PVT LTD",
"PRECIMAX ENGINEERS LIMITED",
"PRECIMEASURE CONTROLS PRIVATE LIMITED",
"PRECIMETAL CAST PRIVATE LIMITED",
"PRECIOUS ALLOYS PRIVATE LIMITED",
"PRECIOUS COMMERCIAL PRIVATE LIMITED",
"PRECIOUS ELECTRO CHEM INDIA PRIVATE LIMITED",
"PRECIOUS ELECTRO TRADE PRIVATE LIMITED",
"PRECIOUS ENERGY SERVICES PRIVATE LIMITED",
"PRECIOUS INTELLIGENCE INDIA PRIVATE LIMITED",
"PRECIOUS LIFECARE PRIVATE LIMITED",
"PRECIOUS LIFESCIENCES PRIVATE LIMITED",
"PRECIOUS METALS REFINERS PRIVATE LIMITED",
"PRECIOUS MICROTECH PRIVATE LIMITED",
"PRECIOUS MINERALS AND SMELTING LIMITED",
"PRECIOUS NETCOM PRIVATE LIMITED",
"PRECIOUS PET SERVICES PRIVATE LIMITED",
"PRECIOUS TRADELINK PRIVATE LIMITED",
"PRECIOUS WEALTH INDIA PRIVATE LIMITED",
"PRECIPART INDIA PRIVATE LIMITED",
"PRECISE ALLOYS P LIMITED",
"PRECISE AUTOMATION & CONTROL PRIVATE LIMITED",
"PRECISE BIO PHARMA PRIVATE LIMITED",
"PRECISE CASTINGS PRIVATE LIMITED",
"PRECISE CHEMIPHARMA PRIVATE LIMITED",
"PRECISE CONCHEM PRIVATE LIMITED",
"PRECISE CONSULTANCY SERVICES LLP",
"PRECISE CUTS INDIA PRIVATE LIMITED",
"PRECISE ENGINEERS",
"PRECISE EQUIPMENTS PRIVATE LIMITED",
"PRECISE FASTENERS PRIVATE LIMITED",
"PRECISE FOREX PRIVATE LIMITED",
"PRECISE HITECH CERAMICS PRIVATE LIMITED",
"PRECISE INDUSTRIAL SOLUTIONS PRIVATE LIMITED",
"PRECISE LOGISTICS PRIVATE LIMITED",
"PRECISE PHARMACEUTICALS PRIVATE LIMITED",
"PRECISE REALTY PRIVATE LIMITED",
"PRECISE RESEARCH SOLUTIONS PRIVATE LIMITED",
"PRECISE SEAMLESS APPARELS PRIVATE LIMITED",
"PRECISE SMALL MOTORS PRIVATE LIMITED",
"PRECISE SOFTECH INDIA PRIVATE LIMITED",
"PRECISE TECHNOCAST PRIVATE LIMITED",
"PRECISE TECHNOFAB INDIA PRIVATE LIMITED",
"PRECISE VACCUM SYSTEMS PRIVATE LIMITED",
"PRECISELY SOFTWARE AND DATA INDIA PRIVATE LIMITED",
"PRECISEVISION MANAGEMENT CONSULTANCY SERVICES PRIVATE LIMITED",
"PRECISION ABRASIVES PRIVATE LIMITED",
"PRECISION ADHESIVE TAPES PRIVATE LIMITED",
"PRECISION AUTO COMPONENTS PRIVATE LIMITED",
"PRECISION AUTO ENGINEERS",
"PRECISION AUTO INDUSTRIES PRIVATE LIMITED",
"PRECISION AUTOCASTINGS PRIVATE LIMITED",
"PRECISION AUTOMATION AND ROBOTICS INDIA LIMITED",
"PRECISION AUTOMOTIVE PRIVATE LIMITED",
"PRECISION AUTOWARES PRIVATE LIMITED",
"PRECISION BEARINGS PRIVATE LIMITED",
"PRECISION BIOMED PRIVATE LIMITED",
"PRECISION BIOMETRIC INDIA PRIVATE LIMITED",
"PRECISION BRASS WORKS PRIVATE LIMITED",
"PRECISION CAMSHAFTS LIMITED",
"PRECISION COATINGS PVT LTD",
"PRECISION COMPAID MOULDINGS PRIVATE LIMITED",
"PRECISION CULTIVATION AIDS PRIVATE LIMITED",
"PRECISION CUPS PRIVATE LIMITED",
"PRECISION DENTAL STUDIO LIMITED",
"PRECISION DESIGN AND ENGINEERING PRIVATE LIMITED",
"PRECISION ELECTRICALS",
"PRECISION ELECTRONIC COMPONENTS MFG CO",
"PRECISION ELECTRONIC COMPONENTS PRIVATE LIMITED",
"PRECISION ELECTRONICS LIMITED",
"PRECISION ENGINEERING COMPONENTS",
"PRECISION ENGINEERING PRODUCTS PRIVATE LIMITED",
"PRECISION EQUIPMENTS CHENNAI PRIVATE LIMITED",
"PRECISION ERECTORS & SERVICES PRIVATE LIMITED",
"PRECISION FABTECH PRIVATE LIMITED",
"PRECISION FAST TECH INDIA",
"PRECISION FOILS PRIVATE LIMITED",
"PRECISION GLOBAL SPRINGS PRIVATE LIMITED",
"PRECISION GRANITE AND MARBLE PRIVATE LIMITED",
"PRECISION HEALTH CARE INSTRUMENTS PRIVATE LIMITED",
"PRECISION HEAT TREATERS AND ENGINEERS INDIA PRIVATE LIMITED",
"PRECISION HOSPITALS PRIVATE LIMITED",
"PRECISION HYDRAULICS PRIVATE LIMITED",
"PRECISION INDUSTRIES PRIVATE LIMITED",
"PRECISION INFOMATIC (MADRAS ) PRIVATE LIMITED",
"PRECISION INFRATECH LIMITED",
"PRECISION INSTRUMENTATION AND SERVICES PRIVATE LIMITED",
"PRECISION INSTRUMENTS PRIVATE LIMITED",
"PRECISION KALPURJA UDYOG PRIVATE LIMITED",
"PRECISION KPO SOLUTIONS PRIVATE LIMITED",
"PRECISION LASERMORE PRIVATE LIMITED",
"PRECISION MACHINE & AUTO COMPONENTS PRIVATE LIMITED",
"PRECISION MACHINEKRAFT PRIVATE LIMITED",
"PRECISION MACHINES AND EQUIPMENTS PRIVATE. LIMITED.",
"PRECISION MASS PRODUCTS PRIVATE LIMITED",
"PRECISION METAL PRODUCTS PRIVATE LIMITED",
"PRECISION METALIKS LIMITED",
"PRECISION MOULDS AND COMPONENTS PRIVATE LIMITED",
"PRECISION MOULDS AND DIES PRIVATE LIMITED",
"PRECISION MULTI ALLOYS PRIVATE LIMITED",
"PRECISION OPERATIONS SYSTEM (INDIA) PRIVATE LIMITED",
"PRECISION OXIDES PRIVATE LIMITED",
"PRECISION PINS PRIVATE LIMITED",
"PRECISION PIPES & TUBES PVT LTD",
"PRECISION PLASTIC ENGINEERING PRIVATE LIMITED",
"PRECISION PLASTIC INDUSTRIES PRIVATE LIMITED",
"PRECISION POLYPLAST PRIVATE LIMITED",
"PRECISION POWER PRODUCTS INDIA PRIVATE LIMITED",
"PRECISION PRECAST SOLUTIONS PRIVATE LIMITED",
"PRECISION PRESSTOOLS PRIVATE LIMITED",
"PRECISION PYRAMID PRIVATE LIMITED",
"PRECISION RUBBER INDUSTRIES PRIVATE LIMITED",
"PRECISION SAFETY CONTROLS PRIVATE LIMITED",
"PRECISION SAFETY EQUIPMENTS LIMITED",
"PRECISION SANITARY PRODUCTS PRIVATE LIMITED",
"PRECISION SCAN AND RESEARCH CENTRE PRIVATE LIMITED",
"PRECISION SEALS MANUFACTURING LIMITED",
"PRECISION SEALS MANUFACTURING PRIVATE LIMITED",
"PRECISION SHEET METAL WORKS PRIVATE. LIMITED.",
"PRECISION STORAGE VESSELS PRIVATE LIMITED",
"PRECISION SURVEYS (INDIA) PRIVATE LIMITED",
"PRECISION TECHCONET PRIVATE LIMITED",
"PRECISION TECHNICAL ANALYSIS PRIVATE LIMITED",
"PRECISION TECHNOENGINEERING PRIVATE LIMITED",
"PRECISION TECHNOSERVICES PRIVATE LIMITED",
"PRECISION TECHSERVE PRIVATE LIMITED",
"PRECISION TESTING MACHINES PRIVATE LIMITED",
"PRECISION TRENCHLESS LAYING PRIVATE LIMITED",
"PRECISION TURNCOMPONENTS PRIVATE LIMITED",
"PRECISION WELDARC LIMITED",
"PRECISION WIRES INDIA LIMITED",
"PRECISION YARNS PRIVATE LIMITED",
"PRECISPHARMA CONTAINERS PRIVATE LIMITED",
"PRECISSION FABRICS INDIA PRIVATE LIMITED",
"PRECISTAT IT SOLUTIONS PRIVATE LIMITED",
"PRECITEC PRECISION MACHINERIES PRIVATE LIMITED",
"PRECITECH EQUIPMENTS INDIA PRIVATE LIMITED",
"PRECITECH FORGINGS & ENGINEERING PRIVATE LIMITED",
"PRECITECH LABORATORIES PRIVATE LIMITED",
"PRECITECH TURNINGS PRIVATE LIMITED",
"PRECITECHPARTUNE INDUSTRIES PRIVATE LIMITED",
"PRECITEK COMPONENTS PRIVATE LIMITED",
"PRECITEX EQUIPMENTS PRIVATE LIMITED",
"PRECITOR METAL COMPOSITES PRODUCTS PRIVATE LIMITED",
"PRECITURN ENGINEERING PRIVATE LIMITED",
"PRECOG INNOVATION PARTNERS PRIVATE LIMITED",
"PRECOMP GEARS P LIMITED",
"PRECOMP TOOLS PRIVATE LIMITED",
"PRECON SERVICES PRIVATE LIMITED",
"PRECON TECHNOLOGY AND CASTINGS LIMITED",
"PRECOT LIMITED",
"PRECYZ POLYMERS PRIVATE LIMITED",
"PREDEL BUSINESS SERVICES PRIVATE LIMITED",
"PREDERA TECHNOLOGIES PRIVATE LIMITED",
"PREDICT TECHNOLOGIES INDIA PRIVATE LIMITED",
"PREDICTIVE & PROACTIVE TECHNOLOGIES PRIVATE LIMITED",
"PREDICTIVE TECHNOLOGIES PRIVATE LIMITED",
"PREDIKLY TECHNOLOGIES PRIVATE LIMITED",
"PREDIQT BUSINESS SOLUTIONS PRIVATE LIMITED",
"PREDLABS PRIVATE LIMITED",
"PREDNALYTICS HEALTH PRIVATE LIMITED",
"PREDOOLE ANALYTICS PRIVATE LIMITED",
"PREDUSK TECHNOLOGY PRIVATE LIMITED",
"PREEGUS HEALTHCARE PRIVATE LIMITED",
"PREEMEE FOODS PRIVATE LIMITED",
"PREEMINENT TECHNOLOGY INDIA PRIVATE LIMITED",
"PREEMPTIVE TECHNOFIELD PRIVATE LIMITED",
"PREES2 DRYCLEANING AND LAUNDRY PRIVATE LIMITED",
"PREESHA INDUSTRIES PRIVATE LIMITED",
"PREET AGRO INDUSTRIES PRIVATE. LIMITED.",
"PREET INDUSTRIES PRIVATE LIMITED",
"PREET JNC",
"PREET BROTHERS LIMITED",
"PREET REMEDIES LIMITED",
"PREET TRACTORS PRIVATE LIMITED",
"PREETAM FOREX PRIVATE LIMITED",
"PREETAM HI-TECH PRIVATE LIMITED",
"PREETHA PHARMACY AND LABS PRIVATE LIMITED",
"PREETHI CAD CONSULTING ENGINEERS PRIVATE LIMITED",
"PREETHI HOSPITALS PRIVATE LIMITED",
"PREETI DEVELOPERS PRIVATE LIMITED",
"PREETI HOSIERY PRIVATE LIMITED",
"PREETI PETROCHEM PRIVATE LIMITED",
"PREETI SHIPPING AND LOGISTICS PRIVATE LIMITED",
"PREETI TRADELINK PRIVATE LIMITED",
"PREETI UROLOGY & KIDNEY HOSPITAL PRIVATE LIMITED",
"PREETIKA SHIPPING AGENCY P LTD",
"PREEVISH INTERNATIONAL PRIVATE LIMITED",
"PREFAB HOSPITALITY PRIVATE LIMITED",
"PREFECT HYDRAULICS PRIVATE LIMITED",
"PREFECT MARKETING & ADVERTISEMENT PRIVATE LIMITED",
"PREFECT PACKAGING PRIVATE LIMITED",
"PREFERENCE LIFE SCIENCES PRIVATE LIMITED",
"PREFERENTIAL BUSINESS ADVISORY PRIVATE LIMITED",
"PREFERRED CONSULTANTS & ADVISORS PRIVATE LIMITED",
"PREFERRED CONSUMER PRODUCTS PRIVATE LIMITED",
"PREFERRED PARTNERS INSURANCE BROKERS PRIVATE LIMITED",
"PREFERRED SQUARE ANALYTICS PRIVATE LIMITED",
"PREFIX TECHNOLAB PRIVATE LIMITED",
"PREFLEX SOLUTIONS PRIVATE LIMITED",
"PREGIO PHARMA PRIVATE LIMITED",
"PREGNA INTERNATIONAL LIMITED",
"PREHAB WELLNESS AND SPORTS PRIVATE LIMITED",
"PREHARI CYBER SECURITY & FACILITIES PRIVATE LIMITED",
"PREHARI PROTECTION SYSTEMS PRIVATE LIMITED",
"PREHENCE ENGINEERS PRIVATE LIMITED",
"PREIMAGE PRIVATE LIMITED",
"PREITY PINK STYLEWEAR PRIVATE LIMITED",
"PREKARI LABS INDIA PRIVATE LIMITED",
"PREKSHA COMMERCIALS PRIVATE LIMITED",
"PREKSHA FINANCE PRIVATE LIMITED",
"PREKSHA INTERIORS PRIVATE LIMITED",
"PREKSHA PLAST PRIVATE LIMITED",
"PREKSHA SALES PRIVATE LIMITED",
"PRELATION BUSINESS SERVICES OPC PRIVATE LIMITED",
"PRELUDE MEDIA AND COMMUNICATION PRIVATE LIMITED",
"PRELUDE NOVEL VENTURES PRIVATE LIMITED",
"PRELUDE PUBLIC SCHOOL",
"PRELUDESYS INDIA LIMITED",
"PRELUDESYS INDIA PRIVATE LIMITED",
"PREM AGRO PRODUCTS PRIVATE LIMITED",
"PREM AUTO LINKS PRIVATE. LIMITED.",
"PREM AUTOMOBILES PRIVATE LIMITED",
"PREM BIOTECH PRIVATE LIMITED",
"PREM BUILDERS INDIA PVT LTD",
"PREM CABLES PVT LTD",
"PREM CARGO MOVERS PRIVATE LIMITED",
"PREM CARS PRIVATE LIMITED",
"PREM CHAND RAJKIYA SARVODAYA BAL VIDHALYA",
"PREM CHITRA ENERGY INDIA PRIVATE LIMITED",
"PREM COLOR CHEM PRIVATE LIMITED",
"PREM COLOUR LAB PRIVATE LIMITED",
"PREM DEALERS PVT LTD",
"PREM DHARAM HOSPITAL PRIVATE LIMITED",
"PREM DOHIL SADAN MANAGEMENT COMPANY PRIVATE LIMITED",
"PREM DYECHEM INDUSTRIES PRIVATE LIMITED",
"PREM ENGINEERING",
"PREM ENGINEERING PVT LTD",
"PREM EXIM PRIVATE LIMITED",
"PREM EXTRUSIONS PRIVATE LIMITED",
"PREM FABRICS PRIVATE LIMITED",
"PREM FEED MILLS PRIVATE LIMITED",
"PREM FOODS PVT. LTD.",
"PREM FORGE & ALLOYS PRIVATE LIMITED",
"PREM GANGA ENGINEERING WORKS PRIVATE LIMITED",
"PREM GARAGES PRIVATE LIMITED",
"PREM GARMENTS PRIVATE LIMITED",
"PREM GOLD PRIVATE LIMITED",
"PREM GRAIN INDUSTRIES PVT LTD",
"PREM GREEN PRIVATE LIMITED",
"PREM HENNA MARKETING PRIVATE LIMITED",
"PREM HENNA PRIVATE LIMITED",
"PREM IKA INDIA PRIVATE LIMITED",
"PREM INDUSTRIES PRIVATE LIMITED",
"PREM INFRACITY PRIVATE LIMITED",
"PREM JAIN ISPAT UDYOG PRIVATE LIMITED",
"PREM KRIPA UDYOG PRIVATE LIMITED",
"PREM KUMAR & SONS JEWELLERS PRIVATE LIMITED",
"PREM LOGISTICS PRIVATE LIMITED",
"PREM MARBLES PRIVATE LIMITED",
"PREM MERCANTILES PRIVATE LIMITED",
"PREM MOTORS PRIVATE LIMITED",
"PREM NARANG OXYGEN PRIVATE LIMITED",
"PREM NATH RAM SARUP EXPORTS PRIVATE LIMITED",
"PREM PARADISE STEELS PRIVATE LIMITED",
"PREM PHARMACEUTICALS PRIVATE LIMITED",
"PREM PLUMBINGS PRIVATE LIMITED",
"PREM REFRACTORIES PRIVATE LIMITED",
"PREM ROAD SERVICE PRIVATE LIMITED",
"PREM ROADLINES PRIVATE LIMITED",
"PREM SAFETY WORKS",
"PREM SAKHI FERTILIZER LIMITED",
"PREM SHANTI PAINTS PRIVATE LIMITED",
"PREM SHARDA GOODS PRIVATE LIMITED",
"PREM SHARDA MINERALS PRIVATE LIMITED",
"PREM STEEL AND METALS PRIVATE LIMITED",
"PREM STRIPS PRIVATE LIMITED",
"PREM TEXTILES PRIVATE LIMITED",
"PREM TEXTILES INTERNATIONAL PRIVATE. LIMITED.",
"PREM TRADEX PRIVATE LIMITED",
"PREM TUBE COMPANY PRIVATE LIMITED",
"PREM VEHICLES PRIVATE LIMITED",
"PREM VERSHA NIKETAN PVT LTD",
"PREM WHEELS PRIVATE LIMITED",
"PREMA AUTOMOBILES PRIVATE LIMITED",
"PREMA MOTORS PRIVATE LIMITED",
"PREMAKANTHI EDUCATION AND CHARITABLE TRUST",
"PREMAS BIOTECH PRIVATE LIMITED",
"PREMAS LIFE SCIENCES PRIVATE LIMITED",
"PREMATIX SOFTWARE SOLUTION PRIVATE LIMITED",
"PREMBANSAL REAL ESTATES PRIVATE LIMITED",
"PREMCEM GUMS PRIVATE LIMITED",
"PREMCHAND BUSINESS MANAGEMENT PRIVATE LIMITED",
"PREMCHAND JUTE & INDUSTRIES PRIVATE LIMITED",
"PREMCHAND NANULAL AJMERA INFRA PRIVATE LIMITED",
"PREMCO GLOBAL LIMITED",
"PREMCO INDIA EXIM PRIVATE LIMITED",
"PREMCO RAIL ENGINEERS LIMITED",
"PREMDAS JALARAM HOSPITAL",
"PREMDEEP AGRO PRODUCTS PRIVATE LIMITED",
"PREMDEEP GOLDSTAR PRIVATE LIMITED",
"PREMEDIUM PHARMACEUTICALS PRIVATE LIMITED",
"PREMHARI STEELS PRIVATE LIMITED",
"PREMI MEDICAL AGENCIES PRIVATE LIMITED",
"PREMIA FOOD ADDITIVES (I) PRIVATE LIMITED",
"PREMIA SOLUTIONZ PRIVATE LIMITED",
"PREMIA WOODTECH PRIVATE LIMITED",
"PREMIER ADHESIVES PRIVATE LIMITED",
"PREMIER AGRI FOODS PRIVATE. LIMITED.",
"PREMIER AGRO PRODUCTS PRIVATE LIMITED",
"PREMIER AIRWAYS LIMITED",
"PREMIER ALCOBEV PRIVATE LIMITED",
"PREMIER ALLIED SERVICES PRIVATE LIMITED",
"PREMIER ALLOYS & CHEMICALS PRIVATE LIMITED",
"PREMIER AMARAVATI VENTURES INDIA PRIVATE LIMITED",
"PREMIER AUTO FINANCE LTD",
"PREMIER AUTO GLASS PRIVATE LIMITED",
"PREMIER BARS LIMITED",
"PREMIER BIOMED SERVICES PRIVATE LIMITED",
"PREMIER BUILDERS GOA PRIVATE LIMITED",
"PREMIER CABLES AND CONDUCTORS PRIVATE LIMITED",
"PREMIER CAPITAL & SECURITIES PRIVATE LIMITED",
"PREMIER CAR SALES LIMITED",
"PREMIER CARBONIC PVT LTD",
"PREMIER CARWORLD PRIVATE LIMITED",
"PREMIER CENTER COMPETENCY TRAINING PRIVATE LIMITED",
"PREMIER CHENNAI PROPERTIES LIMITED",
"PREMIER CIVIL CONTRACTS PRIVATE LIMITED",
"PREMIER CLEARING AGENCY PRIVATE LIMITED",
"PREMIER CLIMATE CONTROLS PRIVATE LIMITED",
"PREMIER CNC PRESS SHOP PRIVATE LIMITED",
"PREMIER COACH & SYNTHETIC PRODUCTS PRIVATE",
"PREMIER COLORSCAN INSTRUMENTS PRIVATE LIMITED",
"PREMIER CONDOMINIUMS PRIVATE LIMITED",
"PREMIER CONDUCTORS PRIVATE LIMITED",
"PREMIER CONSULTANCY & INVESTIGATION PRIVATE LIMITED",
"PREMIER CONSULTANT AND TRADERS LIMITED",
"PREMIER CONVEYORS PRIVATE LIMITED",
"PREMIER COSMETICS LIMITED",
"PREMIER COTSPIN LIMITED PCL",
"PREMIER COTSPIN PRIVATE LIMITED",
"PREMIER CREDIT CAPITAL LTD.",
"PREMIER CROPS PRIVATE LIMITED",
"PREMIER CRYOGENICS LIMITED",
"PREMIER ELECTRIC MARKETING PRIVATE LIMITED",
"PREMIER ELMECH SYSTEMS PRIVATE LIMITED",
"PREMIER ENERGIES LIMITED",
"PREMIER ENERGIES PHOTOVOLTAIC PRIVATE LIMITED",
"PREMIER ENERGY AND INFRASTRUCTURE LIMITED",
"PREMIER ENGINEERING INDUSTRIES PRIVATE LIMITED",
"PREMIER ENGINEERING TECHNICS PRIVATE LIMITED",
"PREMIER ENGINEERS",
"PREMIER EQUIPMENT ENGINEERING PRIVATE LIMITED",
"PREMIER ESTATES AND EQUIPMENTS PRIVATE LIMITED",
"PREMIER EVOLVICS PRIVATE LIMITED",
"PREMIER EXPLOSIVES LIMITED",
"PREMIER FABRIC SOURCING LLP",
"PREMIER FASHIONS INTERNATIONAL PRIVATE LIMITED",
"PREMIER FERRO ALLOYS & SECURITIES LIMITED",
"PREMIER FERROCAST AND ENGINEERS PRIVATE LIMITED",
"PREMIER FINANCIAL SERVICES PRIVATE LIMITED",
"PREMIER FINE LINENS PRIVATE LIMITED",
"PREMIER FURNISHING AND DECORATING PRIVATELIMITED",
"PREMIER GLOBAL LOGISTICS LIMITED",
"PREMIER HOSPITALS PRIVATE. LIMITED",
"PREMIER INDIA BEARINGS LIMITED",
"PREMIER INDOPLAST PRIVATE LIMITED",
"PREMIER INFO CITY PRIVATE LIMITED",
"PREMIER INFOASSISTS PRIVATE LIMITED",
"PREMIER INFRA SERVICES PRIVATE LIMITED",
"PREMIER INFRACON PRIVATE LIMITED",
"PREMIER INGOTS AND METALS PRIVATE LIMITED",
"PREMIER INTERMEDIATES PRIVATE LIMITED",
"PREMIER INVESTMENT CONSULTANTS PRIVATE LIMITED",
"PREMIER IRON & STEEL WORKS PVT LTD",
"PREMIER IRRIGATION ADRITEC PRIVATE LIMITED",
"PREMIER IT SOLUTIONS INDIA PRIVATE LIMITED",
"PREMIER KNITS APPAREL (INDIA) PRIVATE LIMITED",
"PREMIER LAXMI AGRO FOODS INDIA PRIVATE LIMITED",
"PREMIER LIFESTYLE HOUSING PRIVATE LIMITED",
"PREMIER LINERS PRIVATE LIMITED",
"PREMIER LIQUOR (INDIA) PRIVATE LIMITED",
"PREMIER LOOMS MANUFACTURERS PRIVATE LIMITED",
"PREMIER LPG LIMITED",
"PREMIER LUBRICANTS PRIVATE LIMITED",
"PREMIER MARINE PRODUCTS PRIVATE LIMITED",
"PREMIER MARKET INVENTORS PRIVATE LIMITED",
"PREMIER MATCH COMPANY PRIVATE LIMITED",
"PREMIER MAX SUPERMARKETS PRIVATE LIMITED",
"PREMIER MEASUREMENT SOLUTIONS PRIVATE LIMITED",
"PREMIER MEDICAL CORPORATION PRIVATE LIMITED",
"PREMIER MEDICAL SYSTEMS AND DEVICES PRIVATE LIMITED",
"PREMIER MERCHANDISING AGENCY PRIVATE LIMITED",
"PREMIER MERCHANTS PVT LTD",
"PREMIER MILL STORES COMPANY PRIVATE LIMITED",
"PREMIER MILLS PRIVATE LIMITED",
"PREMIER MOBILES PRIVATE LIMITED",
"PREMIER NIRMAN PRIVATE LIMITED",
"PREMIER NUTRACEUTICALS PRIVATE LIMITED",
"PREMIER OPTICALS PVT LTD",
"PREMIER ORGOCHEM INDUSTRIES PRIVATE LIMITED",
"PREMIER PACKAGINGS PRIVATE LIMITED",
"PREMIER PAPER PACKAGING PRIVATE LIMITED",
"PREMIER PEOPLE LOGISTIC SOLUTIONS PRIVATE LIMITED",
"PREMIER PEST CONTROL PRIVATE LIMITED",
"PREMIER PHARMACEUTICALS PRIVATE LIMITED",
"PREMIER PHASETRACK PRIVATE LIMITED",
"PREMIER PHOTOVOLTAIC MEDAK PRIVATE LIMITED",
"PREMIER PIGMENT PRIVATE LIMITED",
"PREMIER PLASMOTEC PRIVATE LIMITED",
"PREMIER POLYFILM LIMITED",
"PREMIER POLYMERS & PIPES PRIVATE LIMITED",
"PREMIER POLYPLAST AND PROCESSORS LIMITED",
"PREMIER POLYSACKS PRIVATE LIMITED",
"PREMIER POULTRY PRODUCTS PRIVATE LIMITED",
"PREMIER PRESS PARTS PRIVATE LIMITED",
"PREMIER PUBLIC SCHOOL",
"PREMIER PULSES LIMITED",
"PREMIER PUMPS PVT LTD",
"PREMIER RADIOLOGICAL CANCER HOSPITAL",
"PREMIER REFRACTORIES OF INDIA PVT LTD",
"PREMIER RESTAURANTS PRIVATE LIMITED",
"PREMIER ROAD CARRIERS LIMITED",
"PREMIER ROAD SERVICE LIMITED",
"PREMIER ROADLINES LIMITED",
"PREMIER ROCK PRODUCTS PRIVATE LIMITED",
"PREMIER ROLLING AND FORGING WORKS PRIVATE LIMITED",
"PREMIER RUBBER MILLS PRIVATE LIMITED",
"PREMIER SALES PRIVATE LIMITED",
"PREMIER SALES PROMOTIONS PRIVATE LIMITED",
"PREMIER SEAFOODS EXIM PRIVATE LIMITED",
"PREMIER SEALS INDIA PRIVATE LIMITED",
"PREMIER SERVICES LIMITED",
"PREMIER SHIELD PRIVATE LIMITED",
"PREMIER SOLAR POWERTECH PRIVATE LIMITED",
"PREMIER SOLVENTS PVT LTD",
"PREMIER SOYA OIL LIMITED",
"PREMIER SPARES PRIVATE LIMITED",
"PREMIER SPG AND WVG MILLS PRIVATE LIMITED",
"PREMIER SPINNING MILLS PVT LTD",
"PREMIER SPINTEX PRIVATE LIMITED",
"PREMIER STARCH PRODUCTS PRIVATE LIMITED",
"PREMIER STEEL & GALVANIZERS PRIVATE LIMITED",
"PREMIER STEEL COMPLEX PRIVATE LIMITED",
"PREMIER STEEL COMPONENTS PRIVATE LIMITED",
"PREMIER SUPPLIERS PRIVATE. LIMITED",
"PREMIER SUPPLIES AND SERVICES PRIVATE LIMITED",
"PREMIER SYNTHETICS",
"PREMIER SYNTHETICS LIMITED",
"PREMIER SYNTHOCHEM INDUSTRIES PRIVATE LIMITED",
"PREMIER TECH AQUA SYSTEMS INDIA PRIVATE LIMITED",
"PREMIER TECHNO TRADES PVT LTD",
"PREMIER TECHNOLOGY GROUP PRIVATE LIMITED",
"PREMIER TELECONNECT INDIA PRIVATE LIMITED",
"PREMIER TEX PRODUCTS PRIVATE LIMITED",
"PREMIER TIMBER AND TRADING PRIVATE LIMITED",
"PREMIER TISSUES INDIA LIMITED",
"PREMIER TOBACCO PACKERS PRIVATE LIMITED",
"PREMIER TRANSPORT LIMITED",
"PREMIER UDYOG LIMITED",
"PREMIER UNITED PRIVATE LIMITED",
"PREMIER VALVES AND FITTINGS PRIVATE LIMITED",
"PREMIER VIGILANCE & SECURITY PRIVATE LIMITED",
"PREMIER VIGILANCE SECURITY PRIVATE LIMITED",
"PREMIER WHOLESALER PRIVATE LIMITED",
"PREMIERE ORNAMENTS PRIVATE LIMITED",
"PREMIERE RETAIL TRADING PRIVATE LIMITED",
"PREMIERE TRADING AND SERVICES INDIA PRIVATE LIMITED",
"PREMIER'S TEA LIMITED",
"PREMIERWORLD TECHNOLOGY LIMITED",
"PREMIUM AUTOMATION PRIVATE LIMITED",
"PREMIUM BUILDING MANAGEMENT LLP",
"PREMIUM CHICK FEEDS PRIVATE LIMITED",
"PREMIUM COATINGS AND CHEMICALS P LIMITED",
"PREMIUM COMPOSTOS INDIA PRIVATE LIMITED",
"PREMIUM COOLING AND INTERIOR SOLUTIONS PRIVATE LIMITED",
"PREMIUM COUSTOMER IT SERVICES PRIVATE LIMITED",
"PREMIUM CREATIONS PRIVATE LIMITED",
"PREMIUM CUSTOMER IT SERVICES LIMITED",
"PREMIUM ESTATES PRIVATE LIMITED",
"PREMIUM EXCHANGE & FINANCE LTD.",
"PREMIUM EXPORTS",
"PREMIUM FACILITY MANAGEMENT PRIVATE LIMITED",
"PREMIUM FARM FRESH PRODUCE LIMITED",
"PREMIUM FATS PRIVATE LIMITED",
"PREMIUM FERRO ALLOYS LTD",
"PREMIUM FERROMET PVT LTD",
"PREMIUM FINANCE PRIVATE LIMITED",
"PREMIUM FOODS",
"PREMIUM FORTUNES PRIVATE LIMITED",
"PREMIUM GRANULES PRIVATE LIMITED",
"PREMIUM GRAPHITE PRIVATE LIMITED",
"PREMIUM HARVEST LIMITED",
"PREMIUM HEALTH CARE DISPOSABLE PVT LTD",
"PREMIUM INFRA LOGISTICS PRIVATE LIMITED",
"PREMIUM LABELS PRIVATE LIMITED",
"PREMIUM LAMINATORS PRIVATE LIMITED",
"PREMIUM LIFESTYLE AND FASHION INDIA PRIVATE LIMITED",
"PREMIUM MANPOWER SERVICES LLP",
"PREMIUM MEDICAL AND HEALTH CARE PROVIDERS PRIVATE LIMITED",
"PREMIUM METALS AND COMPONENTS PRIVATE LIMITED",
"PREMIUM MOTOCORP INDIA PRIVATE LIMITED",
"PREMIUM PLAST LIMITED",
"PREMIUM POLYALLOYS PRIVATE LIMITED",
"PREMIUM POLYCOT PVT LTD",
"PREMIUM POLYFILM PRIVATE LIMITED",
"PREMIUM POLYMERS LIMITED",
"PREMIUM PORT LOUNGE MANAGEMENT COMPANY PRIVATE LIMITED",
"PREMIUM PRESSURE VESSELS PRIVATE LIMITED",
"PREMIUM PULMAN PVT LTD",
"PREMIUM RETAIL PRIVATE LIMITED",
"PREMIUM SERUMS AND VACCINES PRIVATE LIMITED",
"PREMIUM SOUND SOLUTIONS PRIVATE LIMITED",
"PREMIUM SPECIALITY PAINTS PRIVATE LIMITED",
"PREMIUM STEERINGS PRIVATE LIMITED",
"PREMIUM STONE INDIA PRIVATE LIMITED",
"PREMIUM SUITINGS PRIVATE LIMITED",
"PREMIUM TRANSMISSION LIMITED",
"PREMIUM WATERS OF INDIA PRIVATE LIMITED",
"PREMIX CONCRETE SOLUTIONS PRIVATE LIMITED",
"PREMJAYANTI ENTERPRISES PRIVATE LIMITED",
"PREMJEET MANAGEMENT SERVICES PRIVATE LIMITED",
"PREMJI KANJI MASANI PRIVATE LIMITED",
"PREMJI MOTORS PRIVATE LIMITED",
"PREMJI SALES COMPANY PRIVATE LTD",
"PREMJI VALJI AND SONS JEWELLERS PRIVATE LIMITED",
"PREMJYOT FABRICS LIMITED",
"PREMON ASIA INDIA PRIVATE LIMITED",
"PREMPOOJA TEXTILE PROCESSORS PRIVATE LIMITED",
"PREMRAAJ CONSTRUCTION",
"PREMRATAN CONCAST PRIVATE LIMITED",
"PREMSAGAR INFRA REALTY PRIVATE LIMITED",
"PREMSHREE VEHICLES PRIVATE LIMITED",
"PREMSONS DIVERSEY PRIVATE LIMITED",
"PREMSONS EMBROIDERY PRIVATE LIMITED",
"PREMSONS ENTERPRISES (INDIA) PRIVATE LIMITED",
"PREMSONS FASHION PRIVATE LIMITED",
"PREMSONS MOTOR UDYOG PRIVATE LIMITED",
"PREMSONS PLASTICS PRIVATE LIMITED",
"PREMSONS PROMOTERS PRIVATE LIMITED",
"PREMUR IMPEX LTD.",
"PREMUR MACHINERIES PRIVATE LIMITED",
"PREMWARE SERVICES INDIA LLP",
"PRENDA CREATIONS PRIVATE LIMITED",
"PRENETICS INNOVATION LABS PRIVATE LIMITED",
"PRENIX FURNITURE SYSTEMS PRIVATE LIMITED",
"PRENSIL TECHNOLOGIES PRIVATE LIMITED",
"PREPAY NATION INDIA PRIVATE LIMITED",
"PREPAY PAYMENT SERVICES PRIVATE LIMITED",
"PREPAYNATION INDIA PRIVATE LIMITED",
"PREPBYTES TECHNOLOGIES PRIVATE LIMITED",
"PREPINSTA TECHNOLOGIES PRIVATE LIMITED",
"PREPMYSKILLS SERVICES PRIVATE LIMITED",
"PREQIN INDIA PRIVATE LIMITED",
"PRERA INDUSTRIES PRIVATE LIMITED",
"PRERANA AGROCHEM PRIVATE LIMITED",
"PRERANA ENGINEERS & CONSULTANTS PRIVATE LIMITED",
"PRERANA HOSPITAL LIMITED",
"PRERANA IMAGING PRIVATE LIMITED",
"PRERANA MEDICAL SCIENCES PRIVATE LIMITED",
"PRERANA MOTERS PRIVATE LIMITED",
"PRERANA MOTORS PRIVATE LIMITED",
"PRERANA PROCESSORS PRIVATE LIMITED",
"PRERNA AGENCY PRIVATE LIMITED",
"PRERNA BEVERAGES PRIVATE LIMITED",
"PRERNA CHEMICALS",
"PRERNA ENGINEERING EDUCATION GROUP PRIVATE LIMITED",
"PRERNA FOUNDATION",
"PRERNA INDIA MARBLES PRIVATE LIMITED",
"PRERNA INFRABUILD LIMITED",
"PRERNA INNOVATIVE SOLUTIONS PRIVATE LIMITED",
"PRERNA INTERNATIONAL SCHOOL",
"PRERNA MARBLES PRIVATE LIMITED",
"PRERNA MARKETING PRIVATE LIMITED",
"PRERNA REALTECH PRIVATE LIMITED",
"PRERNA REX PVT LTD",
"PRERNADIP PLASTCS PRIVATE LIMITED",
"PRERONA INFRASTRUCTURE PRIVATE LIMITED",
"PRES CLEAN & GREEN ENERGY PRIVATE LIMITED",
"PRES OORJA PRIVATE LIMITED",
"PRES RENEWABLE POWER PRIVATE LIMITED",
"PRESCIENCE DECISION SOLUTIONS PRIVATE LIMITED",
"PRESCIENT & STRATEGIC INTELLIGENCE PRIVATE LIMITED",
"PRESCIENT COLOR LIMITED",
"PRESCIENT FLOW CONTROL INDIA PRIVATE LIMITED",
"PRESCIENT HEALTHCARE GROUP PRIVATE LIMITED",
"PRESCIENT TECHNOLOGIES PRIVATE LIMITED",
"PRESCIENT WEALTH MANAGEMENT PRIVATE LIMITED",
"PRESCINTO TECHNOLOGIES PRIVATE LIMITED",
"PRESCOMEC AUTOCOMP PRIVATE LIMITED",
"PRESCON ELECTRICALS PRIVATE LIMITED",
"PRESCON REALTORS AND INFRASTRUCTURES PRIVATE LIMITED",
"PRESCOTT INFOSYS",
"PRESCRIPTION MEDICINES PRIVATE LIMITED",
"PRESCRIPTION PHARMA SUPPORT PRIVATE LIMITED",
"PRESENOVA MANAGEMENT SOLUTION LLP",
"PRESENT FOOD AND BEVERAGES PRIVATE LIMITED",
"PRESENT INFRA PRIVATE LIMITED",
"PRESENT MEDIA PRIVATE LIMITED",
"PRESENT PRODUCT INDIA PRIVATE LIMITED",
"PRESENTATION CONVENT SENIOR SECONDARY SCHOOL",
"PRESENTATION PEOPLE INDIA PRIVATE LIMITED",
"PRESERVE FACILITEEZ PRIVATE LIMITED",
"PRESERVE TELE INDIA PRIVATE LIMITED",
"PRESET IMPEX PVT LTD",
"PRESIDENCY BARTER PRIVATE LIMITED",
"PRESIDENCY CARS PRIVATE LIMITED",
"PRESIDENCY COLLEGE",
"PRESIDENCY COLLEGE BANGALORE",
"PRESIDENCY COLLEGE CALCUTTA",
"PRESIDENCY EXPORTS & INDUSTRIES LTD",
"PRESIDENCY FINANCE LIMITED",
"PRESIDENCY IMPEX PRIVATE LIMITED",
"PRESIDENCY INFRAHEIGHTS PRIVATE LIMITED",
"PRESIDENCY MEDICAL CENTRE PVT LTD",
"PRESIDENCY PRE UNIVERSITY COLLEGE",
"PRESIDENCY RUBBER MILLS PVT.LTD.",
"PRESIDENCY SCHOOL BANGALORE SOUTH",
"PRESIDENCY SCHOOL MANGALORE",
"PRESIDENCY SCHOOL R.T.NAGAR",
"PRESIDENCY UNIVERSITY",
"PRESIDENT CLOTHING COMPANY",
"PRESIDENT CONSUMER FORUM INDORE",
"PRESIDENTS BODYGUARDS",
"PRESIDING OFFICER LABOUR COURT INDORE",
"PRESIDIO ENGINEERING CONSULTANTS PRIVATE LIMITED",
"PRESIDIO SOLUTIONS PRIVATE LIMITED",
"PRESIDIUM JUNIOR EDUCATION PRIVATE LIMITED",
"PRESIDIUM SCHOOL INDIRAPURAM",
"PRESITO TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"PRESIWARE POLYMERS PRIVATE LIMITED",
"PRESMECH ENGINEERING PRIVATE LIMITED",
"PRESS COUNCIL OF INDIA",
"PRESS GEL INSULATIONS PVT LTD",
"PRESS INFORMATION BUREAU",
"PRESS ROOM AUTOMATION AND FEED FIXTURES (INDIA) PRIVATE LIMITEDPRES",
"PRESS TOOL INDUSTRIES PVT. LTD",
"PRESS TOOLS AND ELEMENTS PRIVATE LIMITED",
"PRESSANA AUTOMOBILES PRIVATE LIMITED",
"PRESSANA FLOUR MILLS PRIVATE LIMITED",
"PRESS-COMP INTERNATIONAL PRIVATE LIMITED",
"PRESSCOTECH ENGINEERING PRIVATE LIMITED",
"PRESSELS PVT LTD",
"PRESSFAB ENGINEERING INDIA PRIVATE LIMITED",
"PRESSLETTER SOLUTIONS PRIVATE LIMITED",
"PRESSLINE INDIA PRIVATE LIMITED",
"PRESSMACH INFRASTRUCTURE PRIVATE. LIMITED.",
"PRESSMAN REALTY PRIVATE LIMITED",
"PRESSMATIC ENGINEERS INDIA PRIVATE LIMITED",
"PRESSPART ANDHERI INDIA PRIVATE LIMITED",
"PRESSTECH (INDIA) PRIVATE LIMITED",
"PRESSTECH PRODUCTS & ENGINEERING SERVICES PRIVATE LIMITED",
"PRESSTO FORMS PRIVATE LIMITED",
"PRESSTONIC ENGINEERING LIMITED",
"PRESSURE AND PROCESS BOILERS PRIVATE LIMITED",
"PRESSURE PARTS ENGG CO",
"PRESSURE VESSELS INDIA",
"PRESSUREJET SYSTEMS PRIVATE LIMITED",
"PRESSWELL COMPONENTS PRIVATE LIMITED",
"PRESSWELL FILTERS PVT LTD",
"PRESSWELL STEELS PRIVATE LIMITED",
"PRESSWELL TOOLS & COMPONETS",
"PRESTAR CARTONS PRIVATE LIMITED",
"PRESTAR MARKETING PRIVATE LIMITED",
"PRESTELS",
"PRESTIGE (BKC) REALTORS PRIVATE LIMITED",
"PRESTIGE AGRO-TECH LIMITED",
"PRESTIGE ALCO BEV PRIVATE LIMITED",
"PRESTIGE AMUSEMENTS PRIVATE LIMITED",
"PRESTIGE AUTOWORLD PRIVATE LIMITED",
"PRESTIGE BUYING HOUSE INDIA LLP",
"PRESTIGE CASTINGS PRIVATE LIMITED",
"PRESTIGE COATING LIMITED",
"PRESTIGE CONSTRUCTION VENTURES PRIVATE LIMITED",
"PRESTIGE DEVENAHALLI DEVELOPERS LLP",
"PRESTIGE DIAMONDS PRIVATE LIMITED",
"PRESTIGE EQUIPMENTS PVT LTD",
"PRESTIGE ESTATES PROJECTS LIMITED",
"PRESTIGE FABRICATORS PVT LTD",
"PRESTIGE FALCON REALTY VENTURES PRIVATE LIMITED",
"PRESTIGE FASHIONS PRIVATE LIMITED",
"PRESTIGE FEED MILLS LIMITED",
"PRESTIGE GARDEN CONSTRUCTIONS PRIVATE LIMITED",
"PRESTIGE GARDEN ESTATES PRIVATE LIMITED",
"PRESTIGE GARDEN RESORTS PRIVATE LIMITED",
"PRESTIGE HOLIDAY RESORTS PRIVATE LIMITED",
"PRESTIGE HOSPITALITYVENTURES LIMITED",
"PRESTIGE ICE CREAMS PRIVATE LIMITED",
"PRESTIGE IDENTITY",
"PRESTIGE INSTITUTE OF MANAGEMENT AND RESEARCH INDORE",
"PRESTIGE INTERNATIONAL SCHOOL",
"PRESTIGE LEISURE RESORTS PRIVATE LIMITED",
"PRESTIGE LIVING PRESTIGE GROUP",
"PRESTIGE MALL MANAGEMENT PRIVATE LIMITED",
"PRESTIGE MEDICAL CENTRE",
"PRESTIGE METALLICS PRIVATE LIMITED",
"PRESTIGE MULTI PRODUCTS PRIVATE LIMITED",
"PRESTIGE OFFICE SYSTEMS PRIVATE LIMITED",
"PRESTIGE ONIDA LIMITED",
"PRESTIGE PLYWOOD INDUSTRIES PVT LTD",
"PRESTIGE PROPERTIES PVT LTD",
"PRESTIGE PROPERTY",
"PRESTIGE PROPERTY MANAGEMENT AND SERVICES",
"PRESTIGE PUBLIC SCHOOL",
"PRESTIGE PURSUITS PRIVATE LIMITED",
"PRESTIGE RETAIL VENTURES LIMITED",
"PRESTIGE SCHOOL BANGALORE",
"NEXUS SHANTINIKETAN RETAIL PRIVATE LIMITED",
"PRESTIGE SHATINIKETAN",
"PRESTIGE SPINNERS PVT LTD",
"PRESTIGE STERLING INFRAPROJECTS PRIVATE LIMITED",
"PRESTIGE STONES (INDIA) PRIVATE LIMITED",
"PRESTIGE SWITCHGEARS PRIVATE LIMITED",
"PRESTIGE TISSUES PRIVATE LIMITED",
"PRESTIGE VACATIONS PRIVATE LIMITED",
"PRESTIGE VEHICLES PRIVATE LIMITED",
"PRESTIGE VINCOM PRIVATE LIMITED",
"PRESTIGE WINES & SPIRITS PRIVATE LIMITED",
"PRESTIGEBULK HANDLING CORPORATION PRIVATE LIMITED",
"PRESTIGIOUS FACILITY MANAGEMENT PRIVATE LIMITED",
"PRESTIGIOUS SCORS PRIVATE LIMITED",
"PRESTIGIOUS TECHNOLOGIES PRIVATE LIMITED",
"PRESTINE TECHNOLOGIES PRIVATE LIMITED",
"PRESTINE TECHSYSTEMS PRIVATE LIMITED",
"PRESTINE VENTURES PRIVATE LIMITED",
"PRESTINEX ENGINEERING PRIVATE LIMITED",
"PRESTO INFO SOLUTIONS PRIVATE LIMITED",
"PRESTO STANTEST PRIVATE LIMITED",
"PRESTO SWITCHGEAR PRIVATE LIMITED",
"PRESTO TYRESOLES RETREADING PRIVATE LIMITED",
"PRESTON COLLEGE",
"PRESTON DEVELOPERS LLP",
"PRESTON ENGINEERING COMPANY DELHI PRIVATE LIMITED",
"PRESTON HYDRAULICS PRIVATE LIMITED",
"PRESTON IMAGE TECH PRIVATE LIMITED",
"PRESTRESS STEEL LLP",
"PRESTRESS WIRE INDUSTRIES",
"PRE-STRESSED UDYOG (INDIA)PVT LTD",
"PRESUDE LIFESCIENCES PRIVATE LIMITED",
"PRESVELS PRIVATE LIMITED",
"PRESYDA WELLNESS PRIVATE LIMITED",
"PRET INTERPRET CLOTHING PRIVATE LIMITED",
"PRETEC UNDERGROUND PRIVATE LIMITED",
"PRETECH PLAST PRIVATE LIMITED",
"PRETIUM ENTERPRISE OPERATIONS INDIA PRIVATE LIMITED",
"PRETLIST INDIA PRIVATE LIMITED",
"PRETON ENERGY PRIVATE LIMITED",
"PRETORIUS STAFFING SOLUTIONS PRIVATE LIMITED",
"PRETTL ELECTRONICS INDIA PRIVATE LIMITED",
"PRETTY BUILD TECH PRIVATE LIMITED",
"PRETTY HOME WINE COMPANY PRIVATE LIMITED",
"PRETTY PETALS PRIVATE LIMITED",
"PRETTYCOSMO & BEAUTY PRIVATE LIMITED",
"PREVAIL CASTING PRIVATE LIMITED",
"PREVAJ CONSULTANTS PRIVATE LIMITED",
"PREVALENCE GREEN SOLUTIONS PRIVATE LIMITED",
"PREVALENT AI INDIA PRIVATE LIMITED",
"PREVEEN AIR TRAVELS PRIVATE LIMITED",
"PREVEGO HEALTHCARE & RESEARCH PRIVATE LIMITED",
"PREVENCURE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"PREVENTION HEALTH CARE PRIVATE LIMITED",
"PREVENTIS CHEM INDIAP LIMITED",
"PREVEST DENPRO LIMITED",
"PREVIEW PRINT ZONE PRIVATE LIMITED",
"PREVIEW TECHNOLOGIES PRIVATE LIMITED",
"PREVILEGE ADVISORY SERVICES PRIVATE LIMITED",
"PREVISE IT PRIVATE LIMITED",
"PREVISE SECURITY AND LEGAL CONSULTANTS PRIVATE LIMITED",
"PREVISION WORLD (INDIA) PRIVATE LIMITED",
"PREVISTER PRIVATE LIMITED",
"PREXEL PRIVATE LIMITED",
"PREXUS GLOBAL SOLUTIONS PRIVATE LIMITED",
"PREXUS HEALTH INDIA PRIVATE LIMITED",
"PREYANSH ENTERPRISES",
"PREZENS ADVERTISING PRIVATE LIMITED",
"PREZENT AI PRIVATE LIMITED",
"PREZENTIUM INDIA PRIVATE LIMITED",
"PREZOTECH SOLUTIONS PRIVATE LIMITED",
"PRG AGITATORS PRIVATE LIMITED",
"PRG BUILDCON INDIA PRIVATE LIMITED",
"PRG CUISINES PRIVATE LIMITED",
"PRG INTERNATIONAL ELECTRICALS PRIVATE LIMITED",
"PRG MEDICARES AND RESEARCHES PRIVATE LIMITED",
"PRG PHARMA PRIVATE LIMITED",
"PRG TRADING PRIVATE LIMITED",
"PRGX INDIA PRIVATE LIMITED",
"PRHUB INTEGRATED MARKETING COMMUNICATION PRIVATE LIMITED",
"PRI GOVT ARTS COLLEGE",
"PRI INDIA IT SERVICES PRIVATE LIMITED",
"PRI OIL AND GAS PRIVATE LIMITED",
"PRI PRECISION AUTOMOTIVE PRIVATE LIMITED",
"PRIANKA GRAPHICS PVT. LTD.",
"PRIAPUS DEVELOPERS PRIVATE LIMITED",
"PRIAPUS INFRASTRUCTURE LIMITED",
"PRICE AND BUCKLAND (INDIA ) PRIVATE LIMITED",
"PRICE PUMPS PRIVATE LIMITED",
"PRICE WATERHOUSE & CO LLP",
"PRICE WATERHOUSE CHARTERED ACCOUNTANTS LLP",
"PRICEWATERHOUSE COOPERS PRIVATE LIMITED",
"PRICEWATERHOUSECOOPERS ACCELERATION CENTRE INDIA PRIVATE LIMITED",
"PRICEWATERHOUSECOOPERS AIMS SUPPORT SERVICES INDIA PRIVATE LIMITED",
"PRICEWATERHOUSECOOPERS DIGITAL SERVICES PRIVATE LIMITED",
"PRICEWATERHOUSECOOPERS PRIVATE LIMITED",
"PRICEWATERHOUSECOOPERS PROFESSIONAL SERVICES LLP",
"PRICEWATERHOUSECOOPERS SERVICE DELIVERY CENTER (BANGALORE) PRIVATE LIMITED",
"PRICEWATERHOUSECOOPERS SERVICE DELIVERY CENTER (KOLKATA) PRIVATE LIMITED",
"PRICEWATERHOUSECOOPERS SERVICES LLP",
"PRICING INNOVATIONS SOLUTIONS PRIVATE LIMITED",
"PRICISION ENGINEERING",
"PRICOL CORPORATE SERVICES LIMITED",
"PRICOL ENGINEERING INDUSTRIES LIMITED",
"PRICOL ENGINEERING INDUSTRIES PRIVATE LIMITED",
"PRICOL GOURMET PRIVATE LIMITED",
"PRICOL HOLDINGS LIMITED",
"PRICOL LIMITED",
"PRICOL LOGISTICS PRIVATE LIMITED",
"PRICOL PROPERTIES LIMITED",
"PRICOL TECHNOLOGIES LIMITED",
"PRICOL TRAVEL LIMITED",
"PRIDE & EXPERT PROPERTIES PRIVATE LIMITED",
"PRIDE AIR SYSTEMS PRIVATE LIMITED",
"PRIDE BAKERS PRIVATE LIMITED",
"PRIDE BUILDERS LLP",
"PRIDE BUILDHOME PRIVATE LIMITED",
"PRIDE COAL & MINERALS PRIVATE LIMITED",
"PRIDE COKE PRIVATE LIMITED",
"PRIDE CREATORS & PLANNERS PRIVATE LIMITED",
"PRIDE DISTRIBUTORS PRIVATE LIMITED",
"PRIDE DRUGS AND PHARMA PRIVATE LIMITED",
"PRIDE EAST ENTERTAINMENTS PRIVATE LIMITED",
"PRIDE ELECTRICALS AND ENGINEERS PRIVATE LIMITED",
"PRIDE FINANCIAL SERVICES PRIVATE LIMITED",
"PRIDE HOSPITALITY LIMITED",
"PRIDE HOTELS LIMITED",
"PRIDE HOUSING AND CONSTRUCTIONS PRIVATE LIMITED",
"PRIDE HUB SECURITY SERVICES",
"PRIDE INDIA AGRO FOODS PRIVATE LIMITED",
"PRIDE INDIA ENGINEERING SOLUTIONS PRIVATE LIMITED",
"PRIDE INDIA MANSIONS PRIVATE LIMITED",
"PRIDE INDUSTRIAL EQUIPMENTS INDIA PRIVATE LIMITED",
"PRIDE INDUSTRIAL PARK PVT LTD",
"PRIDE LIFESTYLES LIMITED",
"PRIDE LIGHTING PRIVATE LIMITED",
"PRIDE MACHINE TOOLS PRIVATE LIMITED",
"PRIDE MEDITECH SERVICES PRIVATE LIMITED",
"PRIDE METAL INDUSTRIES",
"PRIDE MULTITECH PRIVATE LIMITED",
"PRIDE PACK PRIVATE LIMITED",
"PRIDE PLAZA INDIA PRIVATE LIMITED",
"PRIDE PROJECTS PRIVATE LIMITED",
"PRIDE PURPLE BUILDERS PRIVATE. LIMITED.",
"PRIDE PURPLE IT PARK PRIVATE LIMITED",
"PRIDE ROCK PROPERTIES PRIVATE LIMITED",
"PRIDE SHIPPING AGENCIES PRIVATE LIMITED",
"PRIDE TECHNOLOGIES CONSULTING INDIA PRIVATE LIMITED",
"PRIDE TOURS & TRAVELS PRIVATE LIMITED",
"PRIDE TRAVELS PRIVATE LIMITED",
"PRIDE VENTURES INDIA PRIVATE LIMITED",
"PRIDE WIRES PRIVATE LIMITED",
"PRIDECONTROLS & SYSTEMS PRIVATE LIMITED",
"PRIDEOCEAN SHIPPING SERVICE PRIVATE LIMITED",
"PRIDETECH ENGINEERING SERVICES PRIVATE LIMITED",
"PRIDEVEL TECHNOLOGIES LIMITED",
"PRIDHVI ASSET RECONSTRUCTION AND SECURITISATION COMPANY LIMITED.",
"PRIDHVI ENVIROTECH PRIVATE LIMITED",
"PRIESKA REAL ESTATES PVT LTD",
"PRIGO ENGINEERS AND CONSULTANTS P LTD",
"PRIIS GLOBAL PRIVATE LIMITED",
"PRIJAI COOLTECH PRIVATE LIMITED",
"PRIJAI HEAT EXCHANGERS PRIVATE LIMITED",
"PRIKAN MACHINERY PRIVATE LIMITED",
"PRILIENT INFORMATION TECHNOLOGIES (OPC) PRIVATE LIMITED",
"PRILIKA ENTERPRISES PRIVATE LIMITED",
"PRILITIES TECHNOLOGIES PRIVATE LIMITED",
"PRIM DRUGS & PHARMACEUTICALS (INDIA) PRIVATE LIMITED",
"PRIMA AGRO LIMITED",
"PRIMA AUTOMATION PRIVATE LIMITED",
"PRIMA AUTOMOTIVE PRIVATE LIMITED",
"PRIMA BAY PRIVATE LIMITED",
"PRIMA COMMUNICATIONS LTD",
"PRIMA COMPETENCIES PRIVATE LIMITED",
"PRIMA CYCLES PVT LTD",
"PRIMA DENTAL INDIA PRIVATE LIMITED",
"PRIMA FINANCIAL SERVICES LTD",
"PRIMA FOODTECH PRIVATE LIMITED",
"PRIMA INDUSTRIES LIMITED",
"PRIMA INFRATECH PRIVATE LIMITED",
"PRIMA IT SOLUTIONS PRIVATE LIMITED",
"PRIMA KLEENSEED PROCESSORS PRIVATE LIMITED",
"PRIMA LUBRICATIONS PRIVATE LIMITED",
"PRIMA MINERAL HANDLING PRIVATE LIMITED",
"PRIMA PLASTICS LIMITED",
"PRIMA POWER INDIA PRIVATE LIMITED",
"PRIMA PRODUCTS PRIVATE LIMITED",
"PRIMA PUMPS PVT LTD",
"PRIMA TECHNOLOGIES PRIVATE LIMITED",
"PRIMA TELECOM LIMITED",
"PRIMA TERRA BUILDTECH PRIVATE LIMITED",
"PRIMA TERRA LANDMARK PRIVATE LIMITED",
"PRIMA TRANSFORMERS PRIVATE LIMITED",
"PRIMA URBANSCAPES PRIVATE LIMITED",
"PRIMA VETCARE PRIVATE LIMITED",
"PRIMA WELDSAFE PRIVATE LIMITED",
"PRIMACARE RECONCILE HEALTH REMEDIES PRIVATE LIMITED",
"PRIMACY GLOBAL ENTERPRISES",
"PRIMACY INDUSTRIES LIMITED",
"PRIMACY INDUSTRIES PRIVATE LIMITED",
"PRIMAGE SIGNS INDIA PRIVATE LIMITED",
"PRIMAL LIFE SCIENCES PRIVATE LIMITED",
"PRIMAL PROJECTS PRIVATE LIMITED",
"PRIMAN INSTRUMENTS PRIVATE LIMITED",
"PRIMARC PECAN RETAIL PRIVATE LIMITED",
"PRIMARC PROJECTS PRIVATE LIMITED",
"PRIMARC PROJECTS REALTY PRIVATE LIMITED",
"PRIMARC RETAIL STORES PRIVATE LIMITED",
"PRIMARC STORY VENTURE PRIVATE LIMITED",
"PRIMARIUS CUSTOM SYNTHESIS PRIVATE LIMITED",
"PRIMARK LABELS PRIVATE LIMITED",
"PRIMARK PROJECTS PRIVATE LIMITED",
"PRIMARK TRAVEL HOUSE PRIVATE LIMITED",
"PRIMARY ASHRAM SCHOOL ADGAONDEVLA",
"PRIMARY ASHRAM SCHOOL GEORAI",
"PRIMARY ASHRAM SCHOOL SONGIRPADA",
"PRIMARY ASHRAM SHALA PETH VADGAON",
"PRIMARY ASHRAM SHALA TERWAD",
"PRIMARY ASHRAMSHALA SONGIRPADA",
"PRIMARY CASTINGS PRIVATE LIMITED",
"PRIMARY CO-OP AGRI & RURAL DEV BANK LTD",
"PRIMARY EDUCATION DEPARTMENT",
"PRIMARY HEALTH CENTER",
"PRIMARY HEALTH CENTER (PHC) ADIWARE",
"PRIMARY HEALTH CENTER (PHC) MALHARPETH",
"PRIMARY HEALTH CENTER AADGAO",
"PRIMARY HEALTH CENTER DHAMAK TAL NANGAON KHANDESHWAR",
"PRIMARY HEALTH CENTER KADHOLI PS RAJURA",
"PRIMARY HEALTH CENTER KALSADI",
"PRIMARY HEALTH CENTER POHOREGAON TQ RENAPUR",
"PRIMARY HEALTH CENTER SAKSHAL PIMPRI BEED",
"PRIMARY HEALTH CENTER SARANGKHEDA",
"PRIMARY HEALTH CENTRE",
"PRIMARY HEALTH CENTRE ONI TAL RAJAPUR DIST RATN",
"PRIMARY HEALTH CENTRE SAWALAJ",
"PRIMARY PLUS MEDIA PRIVATE LIMITED",
"PRIMARY SCHOOL NAVAUDHAPURA",
"PRIMARY STEEL PRIVATE LIMITED",
"PRIMASONIC SPECTRUM P LIMITED",
"PRIMASONIC SPECTRUM PRIVATE LIMITED",
"PRIMASOURCE PRODUCTS AND SERVICES PRIVATE LIMITED",
"PRIMASTIR SOLUTIONS PRIVATE LIMITED",
"PRIMATHON TECHNOLOGY VENTURES PRIVATE LIMITED",
"PRIMAX ENGINEERS PRIVATE LIMITED",
"PRIMAX EQUIPMENT PRIVATE LIMITED",
"PRIMAX FISCAL SERVICES LTD",
"PRIMCOAT PVD TECHNOLOGY INDIA PRIVATE LIMITED",
"PRIME ABGB PRIVATE LIMITED",
"PRIME ACOUSTIC SOLUTIONS PRIVATE LIMITED",
"PRIME ADHESIVES PRIVATE LIMITED",
"PRIME AGRO FOOD PROCESSING PRIVATE LIMITED",
"PRIME AGRO INDUSTRIES PVT LTD",
"PRIME AIR GLOBAL LIMITED",
"PRIME ART ARCHITECTS PRIVATE LIMITED",
"PRIME ASIA LOGISTIC PRIVATE LIMITED",
"PRIME ASSETSOURCE PRIVATE LIMITED",
"PRIME AUDIO VISUAL PRIVATE LIMITED",
"PRIME AUTO CARS LIMITED",
"PRIME AUTOKRAFT PRIVATE LIMITED",
"PRIME AVIAN FEED INDIA PRIVATE LIMITED",
"PRIME AVIAN INTEGRATION LLP",
"PRIME CABLE INDUSTRIES PRIVATE LIMITED",
"PRIME CAGE PRIVATE LIMITED",
"PRIME CALIBRE PRIVATE LIMITED",
"PRIME CAPITAL SERVICES PRIVATE LIMITED",
"PRIME CARDIAC CARE PRIVATE LIMITED",
"PRIME CARE HOSPITAL PRIVATE LIMITED",
"PRIME CARE TECHNOLOGY PRIVATE LIMITED",
"PRIME CARGO MOVERS AND LOGISTICS PRIVATE LIMITED",
"PRIME CEMENTS PRIVATE LTD.",
"PRIME CENTRE AND DEVELOPERS PRIVATE LIMITED",
"PRIME CERAMICS PVT LTD",
"PRIME CERTIFICATION & INSPECTION INDIA PRIVATE LIMITED",
"PRIME CHEMARTS PRIVATE LIMITED",
"PRIME CIVIL INFRASTRUCTURES PRIVATE LIMITED",
"PRIME CO OP BANK LTD",
"PRIME COLD STORES PRIVATE LIMITED",
"PRIME COMFORT PRODUCTS PRIVATE LIMITED",
"PRIME COMMERCIAL PRIVATE LIMITED",
"PRIME COMPRESSOR SERVICES PRIVATE LIMITED",
"PRIME CONNECT TECHNOLOGY",
"PRIME CORPORATION",
"PRIME CURRENCY CORNER FOREX PRIVATE LIMITED",
"PRIME DENTAL PRODUCTS PRIVATE LIMITED",
"PRIME DINE BANQUET PRIVATE LIMITED",
"PRIME EATERIES PRIVATE LIMITED",
"PRIME EDGE INFRA TECHNOLOGIES PRIVATE LIMITED",
"PRIME EDVENTURES PRIVATE LIMITED",
"PRIME ELASTOMERS PRIVATE LIMITED",
"PRIME ENERGY PRIVATE LIMITED",
"PRIME ENTERPRISES",
"PRIME ENTRADE PRIVATE LIMITED",
"PRIME EQUIPMENTS AND SUPPLIES (INDIA) PRIVATE LIMITED",
"PRIME EXPRESS COURIER AND CARGO PRIVATE LIMITED",
"PRIME FABTECH PRIVATE LIMITED",
"PRIME FACILITY SOLUTIONS PRIVATE LIMITED",
"PRIME FLIX PRIVATE LIMITED",
"PRIME FOCUS ACADEMY OF MEDIA AND ENTERTAINMENT STUDIES PRIVATE LIMITED",
"PRIME FOCUS WORLD CREATIVE SERVICES PRIVATE LIMITED",
"PRIME FORGINGS & MACHINING PRIVATE LIMITED",
"PRIME FORKLIFTERS PRIVATE LIMITED",
"PRIME FRESH LIMITED",
"PRIME GARMENTS PRIVATE LIMITED",
"PRIME GEMS",
"PRIME GEOSTRUCTURES PRIVATE LIMITED",
"PRIME GLOBAL ACCOMMODATION SERVICES PRIVATE LIMITED",
"PRIME GLOBAL INDUSTRIES PRIVATE LIMITED",
"PRIME GOAN RESORTS PRIVATE LIMITED",
"PRIME GOLD CABLES PRIVATE LIMITED",
"PRIME GOLD INDIA LIMITED",
"PRIME GOLD MUTUAL FUND DISTRIBUTORS PRIVATE LIMITED",
"PRIME GOLD SAIL JVC LIMITED",
"PRIME GRAPHITE PRIVATE LIMITED",
"PRIME GREENCITY INFRACARE PRIVATE LIMITED",
"PRIME GUARD SECURITY SERVICES PRIVATE LIMITED",
"PRIME HITECH INFRASTRUCTURE LIMITED",
"PRIME HOLDINGS PVT LTD",
"PRIME HORTIAGRO PROJECTS LIMITED",
"PRIME HOSPITAL",
"PRIME HYDRAULICS AND PNEUMATICS PRIVATE LIMITED",
"PRIME IMAGING AND DIAGNOSTICS CENTRE PRIVATE LIMITED",
"PRIME INDIA ASSOCIATES PRIVATE LIMITED",
"PRIME INDIA AUTOLINKS PRIVATE LIMITED",
"PRIME INDIA INSURANCE BROKERS PRIVATE LIMITED",
"PRIME INDIA POLYMIX PRIVATE LIMITED",
"PRIME INDIAN HOSPITALS PRIVATE LIMITED",
"PRIME INDUSTRIES LIMITED",
"PRIME INFO SOLUTIONS PRIVATE LIMITED",
"PRIME INFRADEVELOPERS MAINTENANCE SERVICES PRIVATE LIMITED",
"PRIME INFRADEVELOPERS PRIVATE LIMITED",
"PRIME INPUTS (INDIA) PRIVATE LIMITED.",
"PRIME INSULATORS PRIVATE LIMITED",
"PRIME INTERIORS PRIVATE LIMITED",
"PRIME INTERNATIONAL INDIA PRIVATE LIMITED",
"PRIME INVESTORS PROTECTION ASSOCIATION & LEAGUE",
"PRIME ISPAT LIMITED",
"PRIME KITCHEN EQUIPMENTS INDIA PRIVATE LIMITED",
"PRIME LABELS PRIVATE LIMITED",
"PRIME LAND HOLDINGS PRIVATE LIMITED",
"PRIME LENSES PRIVATE LIMITED",
"PRIME LIFE SCIENCE PRIVATE LIMITED",
"PRIME LIFE SPACE CONSULTANCY PRIVATE LIMITED",
"PRIME LIFTS PRIVATE LIMITED",
"PRIME LOGISTICS MUMBAI PRIVATE LIMITED",
"PRIME LUMBERS PRIVATE LIMITED",
"PRIME MAG SUBSCRIPTION SERVICES PRIVATE LIMITED",
"PRIME MAN GLASS PRIVATE LIMITED",
"PRIME MAN TOOLS PRIVATE LIMITED",
"PRIME MANAGEMENT SERVICES",
"PRIME MANFORCE SOLUTIONS PRIVATE LIMITED",
"PRIME MARBLES PVT. LTD",
"PRIME MAXI PROMOTION SERVICES PRIVATE LIMITED",
"PRIME MEDICA PROMOTION PRIVATE LIMITED",
"PRIME MEDICALS PRIVATE LIMITED",
"PRIME MERCANTILE PRIVATE LIMITED",
"PRIME MERIDIAN SURVEYS PRIVATE LIMITED",
"PRIME METALLOYS PRIVATE LIMITED",
"PRIME METALS",
"PRIME MILK SPECIALITIES PRIVATE LIMITED",
"PRIME MINING (INDIA) PRIVATE LIMITED",
"PRIME MOVER ENGINEERING COMPANY PRIVATE LIMITED",
"PRIME MOVERS AUTO AGENCY PRIVATE LIMITED",
"PRIME MOVERS AUTO ASSOCIATES PRIVATE LIMITED",
"PRIME NINE MANAGEMENT PRIVATE LIMITED",
"PRIME OCEANIC SHIPPING PRIVATE LIMITED",
"PRIME ONE WORKFORCE PRIVATE.LIMITED",
"PRIME OPINION ANALYSIS INDIA PRIVATE LIMITED",
"PRIME OUTDOORS",
"PRIME OVERSEAS GARMENTS PRIVATE LIMITED",
"PRIME PACK CONTAINERS PRIVATE LIMITED",
"PRIME PAPYRUS PRODUCTS PRIVATE LIMITED",
"PRIME PEOPLES ENGINEERING PRIVATE LIMITED",
"PRIME PERFECT BUILDCON PRIVATE LIMITED",
"PRIME PHARMACEUTICALS PRIVATE LIMITED",
"PRIME PIPES & FITTINGS PRIVATE LIMITED",
"PRIME PLAZA HOTELS PRIVATE LIMITED",
"PRIME PLY INDUSTRIES LIMITED",
"PRIME POLYCHEM PRIVATE LIMITED",
"PRIME POLYMART PVT LTD",
"PRIME POLYRUBS PRIVATE LTD.",
"PRIME POLYTRADE PRIVATE LIMITED",
"PRIME POWER GENERATORS PRIVATE LIMITED",
"PRIME PRECISIONS PRIVATE LIMITED",
"PRIME PROCESS CONSULTANTS INDIA PRIVATE LIMITED",
"PRIME PRODUCTS LIMITED",
"PRIME PROGRESSION EXPORT AND SERVICES PRIVATE LIMITED",
"PRIME PROGRESSION GLOBAL COMMERCE PRIVATE LIMITED",
"PRIME PROGRESSION ICOMINDIA PRIVATE LIMITED",
"PRIME PROPERTIES PVT LTD",
"PRIME PROPERTY DEVELOPMENT CORPORATION LIMITED",
"PRIME RACKS PRIVATE LIMITED",
"PRIME REBAR CONSULTING & ENGINEERING PRIVATE LIMITED",
"PRIME RESEARCH AND ADVISORY LIMITED",
"PRIME RIGS LIMITED",
"PRIME ROLLING MILLS PRIVATE LIMITED",
"PRIME ROOFING INFRASTRUCTURES & PROJECTS PRIVATE LIMITED",
"PRIME ROUGHSTONE PRIVATE LIMITED",
"PRIME SECURE & HOSPITALITY SERVICES PRIVATE LIMITED",
"PRIME SECURITIES LIMITED",
"PRIME SEEDS PRIVATE LIMITED",
"PRIME SERVICES PRIVATE LIMITED",
"PRIME SHIPPING SERVICES (INDIA) PRIVATE LIMITED",
"PRIME SHOES",
"PRIME SMS LOGISTICS PRIVATE LIMITED",
"PRIME SOURCE HOSPITALITY PRIVATE LIMITED",
"PRIME SOURCE TECHNOLOGIES PRIVATE LIMITED",
"PRIME STEEL INDUSTRIES PRIVATE LIMITED",
"PRIME STEEL-TECH INDIA PRIVATE LIMITED",
"PRIME SUITINGS PVT LTD",
"PRIME SURGICAL DAMLE PATH LLP",
"PRIME SURVEILLANCE AGENCY PRIVATE LIMITED",
"PRIME TECH ACCUMULATORS PRIVATE LIMITED",
"PRIME- TECH CAST PRIVATE LIMITED",
"PRIME TELE-EXTRUSIONS LIMITED",
"PRIME TELELINK PRIVATE LIMITED",
"PRIME TELESERVICES PRIVATE LIMITED",
"PRIME TEX TRADING PRIVATE LIMITED",
"PRIME TIME CARGO MOVERS PRIVATE LIMITED",
"PRIME TIME DEVELOPERS PRIVATE LIMITED",
"PRIME TIME INTERNATIONAL SERVICES PRIVATE. LIMITED",
"PRIME TIME WATCHES PRIVATE LIMITED",
"PRIME TOLL AND METAL RECOVERIES PRIVATE LIMITED",
"PRIME TOOLS & EQUIPMENTS PRIVATE LIMITED",
"PRIME TOYS INDIA PRIVATE LIMITED",
"PRIME TRANS EXPRESS PRIVATE LIMITED",
"PRIME TRUST MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"PRIME TUTORIALS PRIVATE LIMITED",
"PRIME URBAN DEVELOPMENT INDIA LIMITED",
"PRIME VISION INDUSTRIES PRIVATE LIMITED",
"PRIME WEAVE-TEX PRIVATE LIMITED",
"PRIME WELLNESS PRIVATE LIMITED",
"PRIME WIRES PRIVATED LIMITED",
"PRIME WOVENS LIMITED",
"PRIME3SG IT SOLUTION PRIVATE LIMITED",
"PRIMEA SYSTEMS PRIVATE LIMITED",
"PRIMEAIR PARTS AND COMPRESSORS PRIVATE LIMITED",
"PRIMEASURE BROADCAST SOLUTIONS PRIVATE LIMITED",
"PRIMEASURE TECHNOLOGIES PRIVATE LIMITED",
"PRIMECARE RECONCILE HEALTH REMEDIES PRIVATE LIMITED",
"PRIMED CHAIN MULTI SOLUTIONS PRIVATE LIMITED",
"PRIMEDEQ INDIA PRIVATE LIMITED",
"PRIMEDSERV TECH PRIVATE LIMITED",
"PRIMEE SILICONES (CHENNAI) PRIVATE LIMITED",
"PRIMEESTATE DEVELOPERS & BUILDERS PRIVATE LIMITED",
"PRIMEGEN HEALTHCARE LABORATORIES PRIVATE LIMITED",
"PRIMELINE LOGISTICS PRIVATE LIMITED",
"PRIMEMAZDA POLYMERS PRIVATE LIMITED",
"PRIMEMOVE TECHNOLOGIES PRIVATE LIMITED",
"PRIMEMOVER MOBILITY TECHNOLOGIES PRIVATE",
"PRIMENET GLOBAL LIMITED",
"PRIMENET GLOBAL PRIVATE LIMITED",
"PRIMENUMBERS TECHNOLOGIES PRIVATE LIMITED",
"PRIMEONE WORKFORCE PRIVATE LIMITED",
"PRIMEONICS MANUFACTURING PRIVATE LIMITED",
"PRIMEPRESSING TOOLS PRIVATE LIMITED",
"PRIMERA MEDICAL TECHNOLOGIES PRIVATE LIMITED",
"PRIMERA SULZ PRIVATE LIMITED",
"PRIMERO DEAL FOREX PRIVATE LIMITED",
"PRIMERO MEDIA PRIVATE LIMITED",
"PRIMEROLL INTERNATIONAL PRIVATE LIMITED",
"PRIMERY HEALTH CENTER CENTER PALASKHED",
"PRIMESCAN LOGISTICS PRIVATE LIMITED",
"PRIMESEAL PRECISION CAST PRIVATE LIMITED",
"PRIMESEAL STRAPS PRIVATE LIMITED",
"PRIMESEAL WOODPLAST PRIVATE LIMITED",
"PRIMESHOW ENTERTAINMENT PRIVATE LIMITED",
"PRIMESIDE JEWELS PRIVATE LIMITED",
"PRIMESOFT ENTERPRISE SYSTEM INTEGRATORS PRIVATE LIMITED",
"PRIMESOFT IP SOLUTIONS PRIVATE LIMITED",
"PRIMESONS TECHTRADE PRIVATE LIMITED",
"PRIMESOPHIC TECHNOLOGIES LLP",
"PRIMESOURCE GLOBAL SERVICES PRIVATE LIMITED",
"PRIMESTAR BUILDTECH PRIVATE LIMITED",
"PRIMESTAR I.T. SERVICES PRIVATE LIMITED",
"PRIMESTEEL MANUFACTURE PRIVATE LIMITED",
"PRIMETALS TECHNOLOGIES INDIA PRIVATE LIMITED",
"PRIMETEC AUTOMOTIVE PARTS PRIVATE LIMITED",
"PRIMETECH COMMUNICATIONS PRIVATE LIMITED",
"PRIMETECH PROJECTS PRIVATE LIMITED",
"PRIMETEX INDUSTRIES PRIVATE LIMITED",
"PRIMETIME LOGI SERVICES PRIVATE LIMITED",
"PRIMETIME REALTORS PRIVATE LIMITED",
"PRIMEVAL RENEWABLE PROJECTS PRIVATE LIMITED",
"PRIMEVINE INDUSTRIES PRIVATE LIMITED",
"PRIMEWAY CARGO PRIVATE LIMITED",
"PRIMEWEAR HYGINE INDIA PRODUCT LIMITED",
"PRIMEWEST MARKETING PRIVATE LIMITED",
"PRIMEX ESTATES PRIVATE LIMITED",
"PRIMEX GLOBAL EXPRESS PRIVATE LIMITED",
"PRIMEX HEALTHCARE AND RESEARCH PRIVATE LIMITED",
"PRIMEX INFRASTRUCTURE PRIVATE LIMITED",
"PRIMEX PLASTICS PRIVATE LIMITED",
"PRIMEX PRESSCOMP PRIVATE LIMITED",
"PRIMIS BPO PRIVATE LIMITED",
"PRIMISH INFOTECH PRIVATE LIMITED",
"PRIMO AUTOMATION SYSTEMS PRIVATE LIMITED",
"PRIMO FASHIONS",
"PRIMO FOODS PRIVATE LIMITED",
"PRIMO GIFTS PRIVATE LIMITED",
"PRIMO IMPEX PRIVATE LIMITED",
"PRIMO PICK N PACK LIMITED",
"PRIMO WHOLE DAIRY MILK PRIVATE LIMITED",
"PRIMODIA CHEMICALS AND PHARMACEUTICALS PRIVATE LIMITED",
"PRIMOKNOT BRAND HOLDINGS PRIVATE LIMITED",
"PRIMOKO SOFTWARE PRIVATE LIMITED",
"PRIMORDIAL SYSTEMS PRIVATE LIMITED",
"PRIMORE SOLUTIONS PRIVATE LIMITED",
"PRIMORIS HOSPITALITY PRIVATE LIMITED",
"PRIMORIS SYSTEMS INDIA PRIVATE LIMITED",
"PRIMOVE ENGINEERING PRIVATE LIMITED",
"PRIMOZ INFO TECH PRIVATE LIMITED",
"PRIMROSE INTERNATIONAL PRIVATE LIMITED",
"PRIMROSE OVERSEAS PRIVATE LIMITED",
"PRIMUS COMMERCIALS PRIVATE LIMITED",
"PRIMUS DIAGNOSTICS & RESEARCH CENTRE PRIVATE LIMITED",
"PRIMUS ENERGY SOLUTIONS PRIVATE LIMITED",
"PRIMUS FINVEST PRIVATE LIMITED",
"PRIMUS GLOBAL SOLUTIONS PRIVATE LIMITED",
"PRIMUS GLOBAL TECHNOLOGIES PRIVATE LIMITED",
"PRIMUS GLOVES PRIVATE LIMITED",
"PRIMUS HATCHERY PRIVATE LIMITED",
"PRIMUS HEALTH CARE PRIVATE LIMITED",
"PRIMUS IMAGING PRIVATE LIMITED",
"PRIMUS INFOTECH PRIVATE LIMITED",
"PRIMUS IT SOLUTIONS PRIVATE LIMITED",
"PRIMUS KNS LIFESTYLE PRIVATE LIMITED",
"PRIMUS LIFESPACES PRIVATE LIMITED",
"PRIMUS LIVING SPACE PRIVATE LIMITED",
"PRIMUS OVERSEAS PRIVATE LIMITED",
"PRIMUS PUBLIC SCHOOL",
"PRIMUS REAL ESTATES PRIVATE LIMITED",
"PRIMUS REMEDIES PRIVATE LIMITED",
"PRIMUS SALES PRIVATE LIMITED",
"PRIMUS SOFTWARE DEVELOPMENT INDIA PRIVATE LIMITED",
"PRIMUS SUPER SPECIALITY HOSPITAL",
"PRIMUS TECHSYSTEMS PRIVATE LIMITED",
"PRIN DIET DEWAS",
"PRIN GOVT COLLEGE OF EDUCATION DEWAS",
"PRIN GOVT DIVISIONAL ITI BHOPAL",
"PRIN GOVT DIVISIONAL ITI INDORE MADHYA PRADESH",
"PRIN GOVT DIVISIONAL ITI JABALPUR",
"PRIN GOVT DIVISIONAL ITI UJJAIN",
"PRIN GOVT ENGG COLLEGE¬†JABALPUR",
"PRIN L N WELINGKAR INSTITUTE OF MANAGEMENT DEVELOPMENT & RESEARCH",
"PRINAV GIS TECHNOLOGIES PRIVATE LIMITED",
"PRINC PT KHUSILAL SHARMA AYURVED COLLEGE AND INSITT BHOPAL",
"PRINCE ALLOYS PRIVATE LIMITED",
"PRINCE ALY KHAN HOSPITAL",
"PRINCE ART EXPORTER JODHPUR",
"PRINCE ART FASHION",
"PRINCE AUTOMOBILES PRIVATE LIMITED",
"PRINCE AUTOMOVERS PRIVATE LIMITED",
"PRINCE BUS AND TRANSPORT CO LTD",
"PRINCE CARE PHARMA PRIVATE LIMITED",
"PRINCE CAREER PIONEER",
"PRINCE CONCRETES MANUFACTURING PRIVATE LIMITED",
"PRINCE CONTAINERS PRIVATE LIMITED",
"PRINCE CORP PRIVATE LIMITED",
"PRINCE CREAMERY PRIVATE LIMITED",
"PRINCE CUISINES PRIVATE LIMITED",
"PRINCE DEALTRADE PRIVATE LIMITED",
"PRINCE DENIMS LIMITED",
"PRINCE DIAMOND JEWELLERS PRIVATE LIMITED",
"PRINCE EDUCATION HUB",
"PRINCE ENGEETECH TECHNICAL SERVICES PRIVATE LIMITED",
"PRINCE FOREX SERVICES PRIVATE LIMITED",
"PRINCE FURNITURE",
"PRINCE GINNING AND PRESSING PRIVATE LIMITED",
"PRINCE GOLD AND DIAMONDS INDIA PRIVATE LIMITED",
"PRINCE GOLDEN VENTURES PRIVATE LIMITED",
"PRINCE GRAPHICS PRIVATE LIMITED",
"PRINCE HANDLOOM PRIVATE LIMITED",
"PRINCE HOME FURNISHINGS PRIVATE LIMITED",
"PRINCE INTERNATIONAL HEALTH CARE (P) LTD",
"PRINCE INTERNATIONAL SCHOOL",
"PRINCE MACHINES PRIVATE LIMITED",
"PRINCE MARINE TRANSPORT SERVICES PRIVATE LIMITED",
"PRINCE MARKETING",
"PRINCE MATRICULATION HIGHER SECONDARY SCHOOL MADIPAKKAM",
"PRINCE MEN POWER SERVICES",
"PRINCE MOTOR LINKS PRIVATE LIMITED",
"PRINCE MULTIPLAST PRIVATE LIMITED",
"PRINCE PIPES AND FITTINGS LIMITED",
"PRINCE PIPING SYSTEMS PRIVATE LIMITED",
"PRINCE PLASTICS",
"PRINCE PLY AGENCY PRIVATE LIMITED",
"PRINCE POLY PLAST PRIVATE LIMITED",
"PRINCE PROPCON (INDIA) PRIVATE LIMITED",
"PRINCE RAINWEAR PRIVATE LIMITED",
"PRINCE ROLLER FLOUR MILLS PVT LTD",
"PRINCE ROLLINGS PRIVATE LIMITED",
"PRINCE SAGAR KUTIR PRIVATE LIMITED",
"PRINCE SHRI VENKATESHWARA PADMAVATHY ENGINEERING COLLEGE",
"PRINCE SPINNERS PRIVATE LIMITED",
"PRINCE SPINTEX PRIVATE LIMITED",
"PRINCE STEEL INDUSTRIES PVT LTD",
"PRINCE STORES (TRADING) PRIVATE LIMITED",
"PRINCE SYSTEM PRIVATE LIMITED",
"PRINCE SYSTEMS (HYDERABAD) PRIVATE LIMITED",
"PRINCE T M T STEELS PRIVATE LIMITED",
"PRINCE TEA PRIVATE LIMITED",
"PRINCE THERMAL INDIA PRIVATE LIMITED",
"PRINCE TRANS SOLUTIONS PRIVATE LIMITED",
"PRINCE VANIJYA PVT LTD",
"PRINCE YARNN INDIA LIMITED",
"PRINCELY CARS PRIVATE LIMITED",
"PRINCELY MOTORS PRIVATE LIMITED",
"PRINCEM ORNAMENTS PRIVATE LIMITED",
"PRINCEMAHINDRA PLAST PRIVATE LIMITED",
"PRINCEP TRADE AND FINANCE PVT LTD",
"PRINCEPS PHARMACEUTICALS PRIVATE LIMITED",
"PRINCES APOLLO REALTY PRIVATE LIMITED",
"PRINCESS CRUISE LINES LIMITED",
"PRINCESS DURRU SHEHVAR COLLEGE OF NURSING",
"PRINCESS PLAZA SAFE DEPOSIT VAULT PRIVATE LIMITED",
"PRINCETON ACADEMY MUMBAI II PRIVATE LIMITED",
"PRINCETON BLUE BPM SOLUTIONS PRIVATE LIMITED",
"PRINCETON DIGITAL GROUP (INDIA) MANAGEMENT PRIVATE LIMITED",
"PRINCETON INFRASTRUCTURE PRIVATE LIMITED",
"PRINCETON INSTITUTE OF ENGINEERING AND TECHNOLOGY FOR WOMEN",
"PRINCETON IT SERVICES PRIVATE LIMITED",
"PRINCETON JR DEGREE PG COLLEGES",
"PRINCETON NIKETAN PRIVATE LIMITED",
"PRINCIPAL & CONTROLLER R N T MEDICAL COLLEGE UDAIPUR",
"PRINCIPAL ACCOUNTANT GENERAL (A&E) I MADHYA PRADESH GWALIOR",
"PRINCIPAL ACCOUNTANT GENERAL A AND E, WEST BENGAL, KOLKATA",
"PRINCIPAL ADARAS H S S",
"PRINCIPAL ARTS AND COMM COLLEGE INDORE",
"PRINCIPAL ASSET MANAGEMENT PRIVATE LIMITED",
"PRINCIPAL BANKI COLLEGE BANKI",
"PRINCIPAL BENCH",
"PRINCIPAL CHIEF CONSERVATOR OF FORESTS",
"PRINCIPAL CHOUDWAR COLLEGE CHOUDWAR",
"PRINCIPAL CIVIL COURT MEHSANA",
"PRINCIPAL CIVIL COURT SATLASANA",
"PRINCIPAL CIVIL COURT VADNAGAR",
"PRINCIPAL COLLEGE OF NURSING",
"PRINCIPAL CONSULTING (INDIA) PRIVATE LIMITED",
"PRINCIPAL CONTAINER LINE PRIVATE LIMITED",
"PRINCIPAL CONTROLLER OF COMMUNICATION ACCOUNTS",
"PRINCIPAL CONTROLLER OF DEFENCE ACCOUNTANTS",
"PRINCIPAL D I E T INDORE",
"PRINCIPAL DHANWANTARI AYURVED COLLEGE",
"PRINCIPAL DISTRICT & SESSIONS JUDGE SOUTH DISTRICT",
"PRINCIPAL DISTRICT COURT MEHSANA",
"PRINCIPAL DISTT INSTT OF EDUCATION AND TRAINING JABALPUR",
"PRINCIPAL FIN-SEC PRIVATE LIMITED",
"PRINCIPAL GLOBAL SERVICES PRIVATE LIMITED",
"PRINCIPAL GOVERNMENT COLLEGE PRITHVIPUR",
"PRINCIPAL GOVERNMENT HIGHER SECONDAY SCHOOL",
"PRINCIPAL GOVT ASHTANG AYURVED COLLEGE INDORE",
"PRINCIPAL GOVT AYURVEDIC COLLEGE AND HOS JABALPUR",
"PRINCIPAL GOVT BOYS H S SCHOOL HATPIPLYA",
"PRINCIPAL GOVT COLLEGE HATPIPLIYA",
"PRINCIPAL GOVT COLLEGE MAHIDPUR",
"PRINCIPAL GOVT COLLEGE MHOW",
"PRINCIPAL GOVT COLLEGE TARANA",
"PRINCIPAL GOVT DEGREE COLLAGE",
"PRINCIPAL GOVT DISTT INSTITUTE OF EDUCATION AND TRAINING KHAR MADHYA PRADESH",
"PRINCIPAL GOVT GIRLS COLLEGE KHANDWA",
"PRINCIPAL GOVT H S SCHOOL CHICHOLA",
"PRINCIPAL GOVT HIGHER SECANDARY SCHOOL PADUMTRA",
"PRINCIPAL GOVT HOMEOPATHIC COLLEGE BHOPAL",
"PRINCIPAL GOVT HR SEC SCHOOL GURSIYADIST KORBA",
"PRINCIPAL GOVT M H COLLEGE HOME SCIENCE FOR WOMEN JABALPUR",
"PRINCIPAL GOVT MADHAV SCIENCE COLLEGE UJJAIN",
"PRINCIPAL GOVT MODEL SCIENCE COLLEGE",
"PRINCIPAL GOVT PG COLLEGE SATNA MADHYA PRADESH",
"PRINCIPAL GOVT POLYTECHNIC COLLEGE",
"PRINCIPAL GOVT SR S SCL DHIKALI 18977 UDAIPUR",
"PRINCIPAL GOVT SUBHASH H S SCHOOL1464 SHIVAJI NAGAR BPL",
"PRINCIPAL GOVT SV POLYTECHNIC BPL",
"PRINCIPAL HOLKAR SC COLLEGE INDORE",
"PRINCIPAL I T I CHANDRAPUR",
"PRINCIPAL I T I HBAD HOSHANGABAD",
"PRINCIPAL I T I RATLAM MADHYA PRADESH",
"PRINCIPAL INDUSTRIAL TRAINING INSTITUTE",
"PRINCIPAL INDUSTRIAL TRAINING INSTITUTE RADHANAGARI",
"PRINCIPAL INSTITUTE OF ADVANCE STUDY IN EDUCATION BHOPAL",
"PRINCIPAL ITI CHHINDWARA",
"PRINCIPAL ITI JHANSI",
"PRINCIPAL ITI KHANDWA",
"PRINCIPAL JIJABAI P G GIRLS COLLEGE MOTITABELA INDORE",
"PRINCIPAL JUDGE FAMILY COURT FIROZABAD",
"PRINCIPAL LAXMI NARAYAN COLLEGE JHARSUGUDA",
"PRINCIPAL MAA SARADADEVI MAHAVIDYALAYA KOTHAR",
"PRINCIPAL MEDICAL OFFICE",
"PRINCIPAL P G COLLEGE CHHINDWARA",
"PRINCIPAL PNB ASSET MANAGEMENT COMPANY PRIVATE LIMITED",
"PRINCIPAL RETIREMENT ADVISORS PRIVATE LIMITED",
"PRINCIPAL S C AND NAVBAUDH BOYS AND GIRLS GOVT HIGHER GRADE ITI",
"PRINCIPAL SENIOR CIVIL COURT",
"PRINCIPAL SG COLLEGE KANIKAPADA",
"PRINCIPAL SR CIVIL COURT JUNAGADH",
"PRINCIPAL SWAMI VIVEKANAND GOVT COLLEGE",
"PRINCIPAL V S COLLEGE DABRA MADHYA PRADESH",
"PRINCIPAL WOMENS COLLEGE JHARSUGUDA",
"PRINCIPIA TRANSFORMATICA PRIVATE LIMITED",
"PRINCIPLE ACS ENGINEERING INDIA PRIVATE LIMITED",
"PRINCIPLE HEALTHCARE & WELLNESS PRIVATE LIMITED",
"PRINCIPLE INDIA PRIVATE LIMITED",
"PRINCIPLE SECURITY AND ALLIED SERVICES PRIVATE LIMITED",
"PRING FASHIONS PRIVATE LIMITED",
"PRINGLE HOMEWARE PRIVATE LIMITED",
"PRINI SOFTWARE SOLUTIONS PRIVATE LIMITED",
"PRINITE HOSPITALITY PRIVATE LIMITED",
"PRINITI FOODS PRIVATE LIMITED",
"PRINIX POWER (OPC) PRIVATE LIMITED",
"PRINK FASHIONS PRIVATE LIMITED",
"PRINSEPS AUCTIONS PRIVATE LIMITED",
"PRINT AID ENTERPRISES PRIVATE LIMITED",
"PRINT CASUAL BRANDS PRIVATE LIMITED",
"PRINT ELECTRONICS EQUIPMENTS PRIVATE LIMITED",
"PRINT IMPRESSION INDIA PRIVATE LIMITED",
"PRINT ON DEMAND SERVICES PRIVATE LIMITED",
"PRINT POINT INDIA PRIVATE. LIMITED.",
"PRINT QUICK PRIVATE LIMITED",
"PRINT SALES PRIVATE LIMITED",
"PRINT SOLUTIONS PRIVATE LIMITED",
"PRINT STUDIO (INDIA) PRIVATE LIMITED",
"PRINT TEX INDIA",
"PRINT VISION PRIVATE LIMITED",
"PRINTANIA OFFSET PRIVATE LIMITED",
"PRINTCARE INDIA PRIVATE LIMITED",
"PRINTEC SIGNS & DISPLAYS PRIVATE LIMITED",
"PRINTECH DIGITAL IMAGING PRIVATE LIMITED",
"PRINTECH INFOTECH SERVICES PRIVATE LIMITED",
"PRINTECH SOLUTIONS INDIA PRIVATE LIMITED",
"PRINTED ELECTRONICS PVT LTD",
"PRINTEL PRINTERS PRIVATE LIMITED",
"PRINTEMPORIO CORPORATION PRIVATE LIMITED",
"PRINTERS CLUB OF INDIA LIMITED",
"PRINTGUARD SECURITY PRESS PRIVATE LIMITED",
"PRINTILE INDUSTRIES PRIVATE LIMITED",
"PRINTING STATIONARY DEPTT",
"PRINTLINE MEDIA PRIVATE LIMITED",
"PRINTLINK COMPUTER AND COMMUNICATION PRIVATE LIMITED",
"PRINTMAN ASSOCIATES P LIMITED",
"PRINTMANN OFFSET PRIVATE LIMITED CN",
"PRINTO DOCUMENT SERVICES PRIVATE LIMITED",
"PRINTOGRAFIK PACKAGING INDIA PRIVATE LIMITED",
"PRINTOGRAFIK PRINTERS AND DESIGNERS PRIVATE LIMITED",
"PRINTOGRAPHY SYSTEMS (INDIA ) PRIVATE LIMITED",
"PRINTOL ENTERPRISE PRIVATE LIMITED",
"PRINTOTECH GLOBAL LIMITED",
"PRINT-PACKAGING.COM PRIVATE LIMITED",
"PRINTPANDA INDIA PRIVATE LIMITED",
"PRINTPOINT PHARMA PACKAGING PRIVATE LIMITED",
"PRINTQ DIGITAL IMAGING PRIVATE LIMITED (OPC)",
"PRINTRADE ISSUES (INDIA) PRIVATE LIMITED",
"PRINTREE CUSTOM CREATIONS PRIVATE LIMITED",
"PRINTRIDE INDUSTRIES PRIVATE LIMITED",
"PRINTRONIX INDIA PRIVATE LIMITED",
"PRINTS PUBLICATIONS PRIVATE LIMITED",
"PRINTSTOP INDIA PRIVATE LIMITED",
"PRINT-TECH OFFSET PRIVATE LIMITED",
"PRINTVELL PRINTERS PRIVATE LIMITED",
"PRINTWELL INTERNATIONAL PRIVATE LIMITED",
"PRIOM EXIM PRIVATE LIMITED",
"PRIORA WATER SOLUTIONS PRIVATE LIMITED",
"PRIORITY AUTOMOBILES (INDIA) PRIVATE LIMITED",
"PRIORITY AUTORIDERS PRIVATE LIMITED",
"PRIORITY AUTOVENTURES PRIVATE LIMITED",
"PRIORITY HEARING CARE PRIVATE LIMITED",
"PRIORITY IDC PRIVATE LIMITED",
"PRIORITY INSURANCE SURVEYORS & LOSS ASSESSORS PRIVATE LIMITED",
"PRIORITY JEWELS PRIVATE LIMITED",
"PRIORITY MARKETING PRIVATE LIMITED",
"PRIORITY MEDIA PRIVATE LIMITED",
"PRIORITY PHARMACEUTICALS PRIVATE LIMITED",
"PRIORITY PROFILES PRIVATE LIMITED",
"PRIORITY VENDOR TECHNOLOGIES PRIVATE LIMITED",
"PRIORITYAUTO LINCS PRIVATE LIMITED",
"PRIORITYONE CONSULTING PRIVATE LIMITED",
"PRIPAN INVESTMENT PRIVATE LIMITED",
"PRISAC AVIATION TECHNOLOGIES PRIVATE LIMITED",
"PRISAM ENGITECH PRIVATE LIMITED",
"PRISAM INFOTECH PRIVATE LIMITED",
"PRISERVE INFRASTRUCTURE PRIVATE LIMITED",
"PRISH STORAGE PRIVATE LIMITED",
"PRISHA ADVISORY PRIVATE LIMITED",
"PRISHA EXIM PRIVATE LIMITED",
"PRISHA FERTILITY CENTRE PRIVATE LIMITED",
"PRISHA FOODS AND DAIRY PRODUCTS PRIVATE LIMITED",
"PRISHA GEMS PRIVATE LIMITED",
"PRISHA INFRASTRUCTURE DEVELOPERS PRIVATE LIMITED",
"PRISHA INSURANCE BROKERS PRIVATE LIMITED",
"PRISHA INTERLINKED MARKETING PRIVATE LIMITED",
"PRISHA STEELS PRIVATE LIMITED",
"PRISHA SYSTEMS AND NETWORKS PRIVATE LIMITED",
"PRISHA TUBES PRIVATE LIMITED",
"PRISHA WIRES PRIVATE LIMITED",
"PRISHAM BIOTECH PRIVATE LIMITED",
"PRISHATECH INDIA (OPC) PRIVATE LIMITED",
"PRISIO TECHNOLOGIES PRIVATE LIMITED",
"PRISKA INFOSOLUTIONS PRIVATE LIMITED",
"PRISKA INFRATECH PRIVATE LIMITED",
"PRISKA PHARMA PRIVATE LIMITED",
"PRISM & PIXELS VFX STUDIO PRIVATE LIMITED",
"PRISM AUTOMATION PRIVATE LIMITED",
"PRISM BIO-MEDICALS PRIVATE LIMITED",
"PRISM BIO-PHARMA PRIVATE LIMITED",
"PRISM BOOKS PRIVATE LIMITED",
"PRISM CIRCUTRONICS PRIVATE LIMITED",
"PRISM CONSTRUCTIONS PRIVATE LIMITED",
"PRISM CORPORATION PRIVATE LIMITED",
"PRISM CROP SCIENCE LIMITED",
"PRISM CYBERSOFT PRIVATE LIMITED",
"PRISM DIGITAL",
"PRISM ENGINEERING PVT LTD",
"PRISM ENTERPRISES PRIVATE LIMITED",
"PRISM FINANCE LIMITED",
"PRISM FLUIDS LLP",
"PRISM GAS DETECTION PRIVATE LIMITED",
"PRISM HOSPITALITY SERVICES PRIVATE LIMITED",
"PRISM HYDRAULICS PRIVATE LIMITED",
"PRISM INDUSTRIES PRIVATE LIMITED",
"PRISM INTERNATIONAL PRIVATE LIMITED",
"PRISM IT SOLUTIONS PRIVATE LIMITED",
"PRISM JOHNSON LIMITED",
"PRISM KITCHENWARE PRIVATE LIMITED",
"PRISM KNIT-FAB PRIVATE LIMITED",
"PRISM LAMINATES PRIVATE LIMITED",
"PRISM LOGISTIC PRIVATE LIMITED",
"PRISM LOGISTIC SOLUTIONS PRIVATE LIMITED",
"PRISM MEDICAL AND PHARMACY PRIVATE LIMITED",
"PRISM MEDICO AND PHARMACY LIMITED",
"PRISM MILLS LIMITED",
"PRISM OFFSET PRIVATE LIMITED",
"PRISM PRINT PVT LTD",
"PRISM SERVICES PROPERTY SOLUTIONS PRIVATE LIMITED",
"PRISM SOFTWARE LIMITED",
"PRISM SURFACE COATINGS PRIVATE LIMITED",
"PRISM THREAD PRIVATE LIMITED",
"PRISM TUBOTECH PRIVATE LIMITED",
"PRISM WOODWORKS INDIA PRIVATE LIMITED",
"PRISMA GARMENTS PRIVATE LIMITED",
"PRISMA GLOBAL LIMITED",
"PRISMANE CONSULTING PRIVATE LIMITED",
"PRISMATIC COATED PRIVATE LIMITED",
"PRISMATIC CONSTRUCTION PRIVATE LIMITED",
"PRISMATIC DECOR PRIVATE LIMITED",
"PRISMATIC ENGINEERING PRIVATE LIMITED",
"PRISMATIC IT SOLUTIONS PRIVATE LIMITED",
"PRISMATIC SOFTWARES PRIVATE LIMITED",
"PRISMBERRY TECHNOLOGIES PRIVATE LIMITED",
"PRISMBIZ SOL PRIVATE LIMITED",
"PRISMETRIC TECHNOLOGIES PRIVATE LIMITED",
"PRISMI CONSTRUCTION PRIVATE LIMITED",
"PRISMIQ INDUSTRIES PRIVATE LIMITED",
"PRISMS INDIA PVT.LTD.",
"PRISMTECH PACKAGING SOLUTIONS PRIVATE LIMITED",
"PRISONS DEPTT",
"PRISONS HEAD QUARTERS",
"PRISOURCE GLOBAL PRIVATE LIMITED",
"PRIST LEATHER PRIVATE LIMITED",
"PRISTINE AEROSOLS PRIVATE LIMITED",
"PRISTINE AGRO LIMITED",
"PRISTINE AYUR INDIA PRIVATE LIMITED",
"PRISTINE BUILDCON PRIVATE LIMITED",
"PRISTINE CAPITAL CONSULTANTS PRIVATE LIMITED",
"PRISTINE CARE PRODUCT PRIVATE LIMITED",
"PRISTINE COMMERCIALS PRIVATE LIMITED",
"PRISTINE COUNCILORS PRIVATE LIMITED",
"PRISTINE CRUSHERS PRIVATE LIMITED",
"PRISTINE DEVELOPERS PRIVATE LIMITED",
"PRISTINE EDUCATION PRIVATE LIMITED",
"PRISTINE ENGICON PRIVATE LIMITED",
"PRISTINE ENGINEERING SERVICES PRIVATE LIMITED",
"PRISTINE ENVIRONMENTAL ASSOCIATES PRIVATE LIMITED",
"PRISTINE FLUIDS PRIVATE LIMITED",
"PRISTINE HINDUSTAN INFRAPROJECTS PRIVATE LIMITED",
"PRISTINE HOSPITALS AND RESEARCH CENTRE PRIVATE LIMITED",
"PRISTINE IDEAS PRIVATE LIMITED",
"PRISTINE INDUSTRIES LIMITED",
"PRISTINE INFORMATION SERVICES PRIVATE LIMITED",
"PRISTINE INFOSOLUTIONS PRIVATE LIMITED",
"PRISTINE INFRACON PRIVATE LIMITED",
"PRISTINE INGREDIENTS PRIVATE LIMITED",
"PRISTINE LIFE SCIENCES PRIVATE LIMITED",
"PRISTINE LOGISTICS & INFRAPROJECTS LIMITED",
"PRISTINE MAGADH INFRASTRUCTURE PRIVATE LIMITED",
"PRISTINE MEDICAL EQUIPMENTS PRIVATE LIMITED",
"PRISTINE MEGA FOOD PARK PRIVATE LIMITED",
"PRISTINE ORGANICS PRIVATE LIMITED",
"PRISTINE PAPER PRODUCTS PRIVATE LIMITED",
"PRISTINE PEARL PHARMA PRIVATE LIMITED",
"PRISTINE PROJECTS PRIVATE LIMITED",
"PRISTINE PROPERTIES",
"PRISTINE RETAIL SOLUTIONS PRIVATE LIMITED",
"PRISTINE ROBOWELD PRIVATE LIMITED",
"PRISTINE STEELS PRIVATE LIMITED",
"PRISTINE TECHNOLOGIES & INDUSTRIES",
"PRISTINE TEXTILES INDIA PRIVATE LIMITED",
"PRISTINE TITLE SERVICES (INDIA) PRIVATE LIMITED",
"PRISTINE UTILITIES PRIVATE LIMITED",
"PRISTYN GLOBAL SERVICES PRIVATE LIMITED",
"PRISYS INFOTECH PRIVATE LIMITED",
"PRITA DESIGNS PRIVATE LIMITED",
"PRITAM AGRO PRIVATE LIMITED",
"PRITAM AUTOMECH PRIVATE LIMITED",
"PRITAM BULLION PRIVATE LIMITED",
"PRITAM CONSTRUCTIONS PRIVATE LIMITED",
"PRITAM ELECTRICALS & ELECTRONICS PRIVATE LIMITED",
"PRITAM GANJEWAR INFRASTRUCTURE PRIVATE LIMITED",
"PRITAM HOTELS PRIVATE LIMITED",
"PRITAM INDUSTRIES PRIVATE LIMITED",
"PRITAM INTERNATIONAL PRIVATE LIMITED",
"PRITAM KHANNA RUGS PRIVATE LIMITED",
"PRITAM MUSIC PRIVATE LIMITED",
"PRITAM PARAMOUNT ENTERTAINMENT PRIVATE LIMITED",
"PRITAM ROADLINES (OPC) PRIVATE LIMITED",
"PRITAM STEEL PRIVATE LIMITED",
"PRITDIP IMPEX (INDIA) PRIVATE LIMITED",
"PRITECH AUTOMATION PRIVATE LIMITED",
"PRITEE RURAL INSTITUTE FOR TECHNOLOGY & EDUCATION BAREILLY",
"PRITHA HEALTH CARE PRIVATE LIMITED",
"PRITHAM & PRATHIK HOSPITALS PRIVATE LIMITED",
"PRITHASAVI HOSPITALS PRIVATE LIMITED",
"PRITHRAJI DEVI HEALTH CARE SYSTEM PRIVATE LIMITED",
"PRITHU PROPERTIES PRIVATE LIMITED",
"PRITHVEE PROPMART PRIVATE LIMITED",
"PRITHVEELINK BUILDWELL PRIVATE LIMITED",
"PRITHVI BROKING PRIVATE LIMITED",
"PRITHVI DEVELOPERS",
"PRITHVI DHAN AGRO PRIVATE LIMITED",
"PRITHVI DIGITECH PRIVATE LIMITED",
"PRITHVI EDIFICE PRIVATE LIMITED",
"PRITHVI FABRICATIONS PRIVATE LIMITED",
"PRITHVI FINLEASE INDIA LIMITED",
"PRITHVI FINMART PRIVATE LIMITED",
"PRITHVI HEALTHCARE PRIVATE LIMITED",
"PRITHVI HITEX CREATIONS PRIVATE LIMITED",
"PRITHVI HOTELS (GUJARAT) PVT LTD",
"PRITHVI INDUSTRIES",
"PRITHVI INDUSTRIES PRIVATE LIMITED",
"PRITHVI INFRABUILD PRIVATE LIMITED",
"PRITHVI IT PRODUCTS PRIVATE LIMITED",
"PRITHVI LANDCRAFT PRIVATE LIMITED",
"PRITHVI METALS PRIVATE LIMITED",
"PRITHVI MONEY IMF PRIVATE LIMITED",
"PRITHVI NIRMAAN PRIVATE LIMITED",
"PRITHVI PLASTO INDIA PRIVATE LIMITED",
"PRITHVI POLYMERS INDUSTRIES PRIVATE LIMITED",
"PRITHVI POWER ENGINEERS PRIVATE LIMITED",
"PRITHVI PRECISION ENGINEERING PRIVATE LIMITED",
"PRITHVI PROTECTIVE SERVICES PRIVATE LIMITED",
"PRITHVI REALCON & TRANSPORTATION PRIVATE LIMITED",
"PRITHVI SALES PVT LTD",
"PRITHVI SOFTECH LIMITED",
"PRITHVI SOUND PRODUCTS COMPANY PRIVATE LIMITED",
"PRITHVI STEEL ROLLING MILLS PRIVATE LIMITED",
"PRITHVI STRUCTURAL DEVELOPERS BUILDERS PRIVATE LIMITED",
"PRITHVI SURVEYS PVT LT D",
"PRITHVI TEA CO. PRIVATE LIMITED",
"PRITHVI YANTRA PRIVATE LIMITED",
"PRITHVIRAJ HOSPITALITY LIMITED",
"PRITHVIRAJ PLASTICS PRIVATE LIMITED",
"PRITHVIRAJ REAL QUALITY MILK AND MILK PRODUCTS PRIVATE LIMITED",
"PRITI CARS PRIVATE LIMITED",
"PRITI CONSTRUCTION",
"PRITI INTERNATIONAL LIMITED",
"PRITI MARINE PRIVATE LIMITED",
"PRITI OIL LIMITED",
"PRITIKA ENGINEERING COMPONENTS LIMITED",
"PRITIKA INDUSTRIES LIMITED",
"PRITIKA INFOTAINMENT INDUSTRIES LIMITED",
"PRITIKA INFRASTRUCTURE PRIVATE LIMITED",
"PRITIRAJ STOCK BROKING PRIVATE LIMITED",
"PRITNA GLOBAL SERVICES PRIVATE LIMITED",
"PRITPAL SILK MILLS PRIVATE LIMITED",
"PRITS LEATHER ART PRIVATE LIMITED",
"PRITS LEATHER EXPORTS PRIVATE LIMITED",
"PRIUS LOGISTICS PRIVATE LIMITED",
"PRIVAFY TECHNOLOGIES INDIA PRIVATE LIMITED",
"PRIVANSA ENGINEERING PRIVATE LIMITED",
"PRIVAT HOSPITALS DR SACHDEV PRIVATE LTD.",
"PRIVATE EYE PRIVATE LIMITED",
"PRIVE LUXURY LIMITED",
"PRIVE PROPERTY MANAGEMENT PRIVATE LIMITED",
"PRIVELEDGE REAL ESTATE PVT LTD",
"PRIVI BIOTECHNOLOGIES PRIVATE LIMITED",
"PRIVI EXPORTS PRIVATE LIMITED",
"PRIVI LIFE SCIENCES PRIVATE LIMITED",
"PRIVI ORGANICS INDIA LIMITED",
"PRIVI ORGANICS LIMITED",
"PRIVI SPECIALITY CHEMICALS LIMITED",
"PRIVIDGE INFRAPROJECTS PRIVATE LIMITED",
"PRIVIL SOLUTIONS PRIVATE LIMITED",
"PRIVILEGE BIKSONS BOILERS PRIVATE LIMITED",
"PRIVILEGE INDUSTRIES LIMITED",
"PRIVO TECHCORP PRIVATE LIMITED",
"PRIVY CAPITAL LIMITED",
"PRIYA BLUE INDUSTRIES PRIVATE LIMITED",
"PRIYA CAPACITORS PRIVATE LIMITED",
"PRIYA DARSHINI COLLEGE OF COMPUTER SCIEN",
"PRIYA DIAGNOSTIC AND ULTRASOUND CENTRE PRIVATE LIMITED",
"PRIYA DYEING AND PRINTING MILLS PRIVATE LIMITED",
"PRIYA EDIBLES PRIVATE LIMITED",
"PRIYA ENCASE PRIVATE LIMITED",
"PRIYA ENGINEERING PROJECTS PRIVATE LIMITED",
"PRIYA ENTERPRENEURS (INDIA) PRIVATE LIMITED",
"PRIYA ENTERPRISES",
"PRIYA ENTERTAINMENT PRIVATE LIMITED",
"PRIYA FELT PRIVATE LIMITED",
"PRIYA GOPAL BISHOYI MARKETING PRIVATE LIMITED",
"PRIYA GOPAL BISHOYI SAREES PRIVATE LIMITED",
"PRIYA HOLDINGS PRIVATE LIMITED",
"PRIYA HOSPITALS AND RESEARCH CENTRE PRIVATE LIMITED",
"PRIYA JEET FOODS & BEVERAGES PRIVATE LIMITED",
"PRIYA LALL COLOR LAB PRIVATE LIMITED",
"PRIYA LIMITED",
"PRIYA MACHINES PRIVATE LIMITED",
"PRIYA MOULDERS PRIVATE LIMITED",
"PRIYA OFFSHORE PRIVATE LIMITED",
"PRIYA PAPERS PRIVATE LIMITED",
"PRIYA POLYMERS PRIVATE LIMITED",
"PRIYA PRECI-COMP PRIVATE LIMITED",
"PRIYA PURNIMA CREDITS PVT LTD",
"PRIYA REALTY & INFRA PRIVATE LIMITED",
"PRIYA SOFTWEB SOLUTIONS PRIVATE LIMITED",
"PRIYA TOOLS PRIVATE LTD",
"PRIYA TRADE LINKS PRIVATE LIMITED",
"PRIYA TRADING COMPANY",
"PRIYA YARNS PRIVATE LIMITED",
"PRIYAA GARMENTS",
"PRIYABHAVANA HOSPITALS PRIVATE LIMITED",
"PRIYABLUE SHIPPING PRIVATE LIMITED",
"PRIYADARSHANI ENGINEERING COLLEGE",
"PRIYADARSHANI MILK PROCESSING PRIVATE LIMITED",
"PRIYADARSHANI NAGARI SAHAKARI BANK LTD",
"PRIYADARSHANI URDU HIGH SCHOOL",
"PRIYADARSHI HOSPITALS & RESEARCH CENTRE PRIVATE LIMITED",
"PRIYADARSHI PRINT-O-PACK",
"PRIYADARSHINI ADVERTISING PRIVATE LIMITED",
"PRIYADARSHINI COLLEGE OF ENGINEERING",
"PRIYADARSHINI FARMS PRIVATE LIMITED",
"PRIYADARSHINI FILAMENTS PRIVATE LIMITED",
"PRIYADARSHINI FORWARDERS PRIVATE LIMITED",
"PRIYADARSHINI INSTITUTE OF SCIENCE AND TECHNOLOGY FOR WOMEN",
"PRIYADARSHINI J L COLLEGE OF ENGINEERING",
"PRIYADARSHINI MICROTECH PRIVATE LIMITED",
"PRIYADARSHINI POLYSACKS LIMITED",
"PRIYADARSHINI VIDYA MANDIR",
"PRIYADARSHNI FASHIONS PRIVATE LIMITED",
"PRIYADARSHNI WEAVES PRIVATE LIMITED",
"PRIYADHAR GREEN ENVIRON PRIVATE LIMITED",
"PRIYADHARSHANI POLYTECHNICS COLLEGE",
"PRIYAL EQUIPMENTS PRIVATE LIMITED",
"PRIYAL MARKETING PRIVATE LIMITED",
"PRIYALAXMI TEXTILE MILLS PRIVATE LIMITED",
"PRIYAM AGENCIES PVT LTD",
"PRIYAM INDUSTRIES AND CONSULTANCY SERVICES (I) PRIVATE LIMITED",
"PRIYAM INFOSYSTEMS PRIVATE LIMITED",
"PRIYAM KNIT PRIVATE LIMITED",
"PRIYAM PACKEGING PRIVATE LIMITED",
"PRIYAM WOOD UDYOG PRIVATE LIMITED",
"PRIYAMBADA INDUSTRIES PRIVATE LIMITED",
"PRIYAMVAD TRADEINVEST PRIVATE LIMITED",
"PRIYAMVADA FINVEST PVT LTD",
"PRIYANJALI EDUCATION PRIVATE LIMITED",
"PRIYANK SHIP BREAKING COMPANY PRIVATE LIMITED TFR, FROM GUJARAT T DELHI",
"PRIYANK SUKHIJA CAFE CONCEPT PRIVATE LIMITED",
"PRIYANKA (INDIA) PRIVATE LIMITED",
"PRIYANKA BULLION PRIVATE LIMITED",
"PRIYANKA CHEMICALS PVT LTD",
"PRIYANKA CONSTRUCTIONS BARODA PRIVATE LIMITED",
"PRIYANKA CONTRACTORS PRIVATE LIMITED",
"PRIYANKA ELECTRODES PRIVATE LIMITED",
"PRIYANKA ENERGYTECH PRIVATE LIMITED",
"PRIYANKA FINANCE PRIVATE LIMITED",
"PRIYANKA IMPEX PRIVATE LIMITED",
"PRIYANKA INDIA PRIVATE LIMITED",
"PRIYANKA INFRA PRIVATE LIMITED",
"PRIYANKA MEDICAL PRIVATE LIMITED",
"PRIYANKA MOTORS PRIVATE LIMITED",
"PRIYANKA REFINERIES PRIVATE LIMITED",
"PRIYANKA SCRAP & IRON PRIVATE LIMITED",
"PRIYANKA TEXPRINT PRIVATE LIMITED",
"PRIYANKAS HOUSING CONSULTANTS PRIVATE LIMITED",
"PRIYANKSHI FASHIONS PRIVATE LIMITED",
"PRIYANSHI COAL FEEDER PRIVATE LIMITED",
"PRIYANSHI CREATIONS PRIVATE LIMITED",
"PRIYANSHI INDUSTRIES PRIVATE LIMITED",
"PRIYANSHI MERCHANDISE PRIVATE LIMITED",
"PRIYANSHU TRADELINKS PRIVATE LIMITED",
"PRIYARAJA ELECTRONICS LIMITED",
"PRIYARTH VENTURES PRIVATE LIMITED",
"PRIYASHARMA SOFTWARE PRIVATE LIMITED",
"PRIYASHI AASHI DEVELOPERS PRIVATE LIMITED",
"PRIYASHI CONSTRUCTION PRIVATE LIMITED",
"PRIYASHREE PROCESSORS PRIVATE LIMITED",
"PRIYATHAM ENTERPRISES PRIVATE LIMITED",
"PRIYDARSHANI LOGISTICS PRIVATE LIMITED",
"PRIYHEER INFRASTRUCTURES PRIVATE LIMITED",
"PRIYOJON HOSPITAL & RESEARCH CENTRE PRIVATE LIMITED",
"PRIZAM PRINTERS AND PUBLISHERS LIMITED",
"PRIZE PETROLEUM COMPANY LIMITED",
"PRIZM HOLOGRAPHY AND SECURITY FILMS PRIVATE LIMITED",
"PRIZMA WINSOL PRIVATE LIMITED",
"PRIZMAA DISTRIBUTORS PRIVATE LIMITED",
"PRIZOR SNACKS PRIVATE LIMITED",
"PRIZOR VIZTECH LIMITED",
"PRJ ELECTRONICS PRIVATE LIMITED",
"PRJ ENTERPRISES PRIVATE LIMITED",
"PRJ POLYMERS PRIVATE LIMITED",
"PRJ SANITARY APPLIANCES PRIVATE LIMITED",
"PRK FABRICATORS PRIVATE LIMITED",
"PRK HOSPITALS",
"PRK HOSPITALS PRIVATE LIMITED",
"PRK INFOTECH PRIVATE LIMITED",
"PRK LOGISTIC PRIVATE LIMITED",
"PRK RAINBOW IMAGING AND DIAGNOSTICS PRIVATE LIMITED",
"PRK RAINBOW MRI CENTRE PRIVATE LIMITED",
"PRL AGASTYA PRIVATE LIMITED",
"PRL DEVELOPERS LIMITED PIRAMAL GROUP",
"PRL FOODS PRIVATE LIMITED",
"PRL PROJECTS & INFRASTRUCTURE LIMITED",
"PRL STOCK & SHARE BROKERS PRIVATE LIMITED",
"PRL SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED",
"PRM & COMPANY",
"PRM CAPITAL ADVISORS PRIVATE LIMITED",
"PRM FINCON SERVICES PRIVATE LIMITED",
"PRM HOSPITALITY PRIVATE LIMITED",
"PRM REAL ESTATE PRIVATE LIMITED",
"PRM ROADWAYS PRIVATE LIMITED",
"PRNAM STARTUP CONSULTING (INDIA) PRIVATE LIMITED",
"PRNT SOURCE GLAZERS PRIVATE LIMITED",
"PRO ALLIANCE HOSPITALITY PRIVATE LIMITED",
"PRO ASSIGN SERVICES PRIVATE LIMITED",
"PRO BODY BALANCE PRIVATE LIMITED",
"PRO CYCLE & SPORTS INDIA PRIVATE LIMITED",
"PRO ELITE PROTECTION FACILITY MANAGEMENT SERVICES INDIA PRIVATE LIMITED",
"PRO FACILITIES SERVICES PRIVATE LIMITED",
"PRO FIN CAPITAL SERVICES LIMITED",
"PRO FINCARE PRIVATE LIMITED",
"PRO FITNESS INDIA PRIVATE LIMITED",
"PRO FX TECH PRIVATE LIMITED",
"PRO HEALTHCARE SCIENTIFIC PRIVATE LIMITED",
"PRO IDEAS INTEGRATED MARKETING PRIVATE LIMITED",
"PRO INFRAREAL PRIVATE LIMITED",
"PRO INNOVATIVE TECHNOLOGIES PRIVATE LIMITED",
"PRO INTEGRATED SERVICES LIMITED",
"PRO INTERACTIVE SERVICES INDIA PRIVATE LIMITED",
"PRO KARGO (INDIA) PRIVATE LIMITED",
"PRO LABELS PRIVATE LIMITED",
"PRO LABORATORIES PRIVATE LIMITED",
"PRO MEDIA",
"PRO MIND SOLUTIONS PRIVATE LIMITED",
"PRO MOULDS PRIVATE LIMITED",
"PRO MOVING SOLUTIONS PRIVATE LIMITED",
"PRO NATURE ORGANIC FOODS PRIVATE LIMITED",
"PRO OMEGA ENGINEERS INDIA PRIVATE LIMITED",
"PRO PHYSIO HEALTHCARE PRIVATE LIMITED",
"PRO POWER SWEEPING COMPANY PRIVATE LIMITED",
"PRO SCREEN TECHNOLOGIES PRIVATE LIMITED",
"PRO SECURITY SERVICES PRIVATE LIMITED",
"PRO SEEDS GENETICS PRIVATE LIMITED",
"PRO TEAM SOLUTIONS PRIVATE LIMITED",
"PRO TEX SECURITY SERVICES PRIVATE LIMITED",
"PROACSCENT BUSINESS SOLUTIONS PRIVATE LIMITED",
"PROACTIVE CONSTRUCTION PRIVATE LIMITED",
"PROACTIVE CONSULTANTS PRIVATE LIMITED",
"PROACTIVE DATA SYSTEMS PRIVATE LIMITED",
"PROACTIVE HEALTH INC",
"PROACTIVE HEALTHCARE PRIVATE LIMITED",
"PROACTIVE IN & OUT ADVERTISING PRIVATE LIMITED",
"PROACTIVE PROFESSIONAL SERVICES PRIVATE LIMITED",
"PROACTIVE SHIP MANAGEMENT PRIVATE LIMITED",
"PROADCAT INDIA LIMITED",
"PROADWISE COMMUNICATIONS PRIVATE LIMITED",
"PROAFFLUENCE ADVISORY SERVICES PRIVATE LIMITED",
"PROAIR MACHINES PRIVATE LIMITED",
"PROALGEN BIOTECH LIMITED",
"PRO-ALIGN SECURITY INDIA PRIVATE LIMITED",
"PROAM INFRA PRIVATE LIMITED",
"PROAPPARTUS COVER PRIVATE LIMITED",
"PRO-ARC WELDING AND CUTTING SYSTEMS PRIVATE LIMITED",
"PROARCH CONSULTING SERVICES PRIVATE LIMITED",
"PROARCH ENGINEERING PRIVATE LIMITED",
"PROARCH IT SOLUTIONS PRIVATE LIMITED",
"PROASSERT CONSULTANCY SERVICES (INDIA) PRIVATE LIMITED",
"PROBAT INDIA PRIVATE LIMITED",
"PROBE DIAGNOSTIC PRIVATE LIMITED",
"PROBE INFORMATION SERVICES PRIVATE LIMITED",
"PROBE RESEARCH & SOCIAL DEVELOPMENT PRIVATE LIMITED",
"PROBE SERVICES PRIVATE LIMITED",
"PROBENCHMARK OUTSOURCING SOLUTIONS INDIA PRIVATE LIMITED",
"PROBEPLUS INNOVATIVE SOLUTIONS PRIVATE LIMITED",
"PROBHAKOR TEA PRIVATE LIMITED",
"PROBING EYE DIAGNOSTICS PRIVATE LIMITED",
"PROBIT PLUS PRIVATE LIMITED",
"PROBITAS INSURANCE BROKERS PRIVATE LIMITED",
"PROBITY CONSTRUCTIONS PRIVATE LIMITED",
"PROBITY SOFT PRIVATE LIMITED",
"PROBITY SOLUTIONS PRIVATE LIMITED",
"PROBIZ PR7 INFOTECH PRIVATE LIMITED",
"PROBO MEDIA TECHNOLOGIES PRIVATE LIMITED",
"PROBOTIQ SOLUTIONS PRIVATE LIMITED",
"PROBOTIX CONTROL SYSTEM INDIA PRIVATE LIMITED",
"PROBOX INFOTECH PRIVATE LIMITED",
"PROBUDDY SOFTWARE SOLUTIONS PRIVATE LIMITED",
"PROBUDS STRATEGY CONSULTING PRIVATE LIMITED",
"PROBUILD TREXIM PVT LTD",
"PROBUS INSURANCE BROKER PRIVATE LIMITED",
"PROBUS SMART THINGS PRIVATE LIMITED",
"PROCAIN CONSULTING & SERVICES PRIVATE LIMITED",
"PROCALL PRIVATE LIMITED",
"PROCAM FLEXOPRINTS PRIVATE LIMITED",
"PROCAM INTERNATIONAL PRIVATE LIMITED",
"PROCAM LOGISTICS PRIVATE LIMITED",
"PROCAM WORLDWIDE LOGISTICS PRIVATE LIMITED",
"PROCANDOUR AUTOMOTIVE SYSTEMS PRIVATE LIMITED",
"PROCANDOUR ENGINEERING TECHNOLOGIES PRIVATE LIMITED",
"PROCAPATUS TECHINDIA PRIVATE LIMITED",
"PROCAPITUS BUSINESS PARK PRIVATE LIMITED",
"PROCARE HEALTH ADVISORS PRIVATE LIMITED",
"PRO-CARE KIDZ INDIA PRIVATE LIMITED",
"PROCARE PHARMA PRIVATE LIMITED",
"PROCAREER EDUCARE PRIVATE LIMITED",
"PROCDNA ANALYTICS PRIVATE LIMITED",
"PROCECA ENGINEERS AND AUTOMATION PRIVATE LIMITED",
"PROCEDURE TECHNOLOGIES PRIVATE LIMITED",
"PROCENSOL TECHNOLOGY INDIA PRIVATE LIMITED",
"PROCENTRIS (INDIA) PRIVATE LIMITED",
"PROCESS AGROCHEM INDUSTRIES PRIVATE LIMITED",
"PROCESS AND PRODUCT DEVELOPEMENT CENTRE",
"PROCESS CARE SYSTEMS (INDIA) PRIVATE LIMITED",
"PROCESS COLOR HOLOGRAM PRIVATE LIMITED",
"PROCESS ENGINEERING RETENTION TECHNIQUE PRIVATE LIMITED",
"PROCESS ENGINEERING SPECIALISTS PRIVATE LIMITED",
"PROCESS FUSION PRIVATE LIMITED",
"PROCESS LEAP INFORMATICS PRIVATE LIMITED",
"PROCESS MASTERS EQUIPMENT INDIA PRIVATE LIMITED",
"PROCESS NINE TECHNOLOGIES PRIVATE LIMITED",
"PROCESS PUMPS ( INDIA ) PRIVATE LIMITED",
"PROCESS SYSTEM ENGINEERS (INDIA) PRIVATE LIMITED",
"PROCESS TECH MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"PROCESS TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"PROCESS VALVE & CONTROL AUTOMATION",
"PROCESS WARE SYSTEMS PRIVATE LIMITED",
"PROCESS360 PRIVATE LIMITED.",
"PROCESSIA PLM PRIVATE LIMITED",
"PROCESSLOGIX CONSULTING PRIVATE LIMITED",
"PROCESSMAP INDIA PRIVATE LIMITED",
"PROCESSMAP INFOTECH PRIVATE LIMITED",
"PROCESSO PLAST ENTERPRISE PRIVATE LIMITED",
"PROCESSWEAVER SOFTWARE SOLUTIONS PRIVATE LIMITED",
"PROCETECH AUTOMATION PRIVATE LIMITED",
"PROCEUM PRIVATE LIMITED",
"PROCHANT INDIA PRIVATE LIMITED",
"PROCHARTING PRIVATE LIMITED",
"PROCHEF FOOD SOLUTIONS PRIVATE LIMITED",
"PROCHEM PHARMACEUTICALS PRIVATE LIMITED",
"PROCHEM TURNKEY PROJECTS PRIVATE LIMITED",
"PROCLAIM INSURANCE SURVEYORS AND LOSS ASSESSORS P LIMITED",
"PROCLINK CONSULTING SERVICES LLP",
"PROCLOZ SERVICES PRIVATE LIMITED",
"PROCOAT SPECIALITIES PRIVATE LIMITED",
"PROCOM LOGISTICS PRIVATE LIMITED",
"PROCON INDIA PRIVATE LIMITED",
"PROCON RMC PLANTS PRIVATE LIMITED",
"PROCON SYSTEMS PRIVATE LIMITED",
"PROCON TECHNOLOGIES PRIVATE LIMITED",
"PROCONEX PRIVATE LIMITED",
"PROCONNECT SUPPLY CHAIN SOLUTIONS LIMITED",
"PROCONVIS CONSULTANTS PRIVATE LIMITED",
"PROCORP ENERTECH PRIVATE LIMITED",
"PROCOS MECHATRONICS PRIVATE LIMITED",
"PROCREATOR SOLUTIONS PRIVATE LIMITED",
"PROCSYS HOSPITALITY PRIVATE LIMITED",
"PROCTECH SOLUTIONS PRIVATE LIMITED",
"PROCTER & GAMBLE HEALTH LIMITED",
"PROCTER & GAMBLE HOME PRODUCTS PRIVATE LIMITED",
"PROCTER & GAMBLE HYGIENE AND HEALTH CARE LIMITED",
"PROCTOR ORGANICS PVT LTD",
"PROCURABL SOLUTIONS PRIVATE LIMITED",
"PROCURANT IT INDIA PRIVATE LIMITED",
"PROCURE LOGISTICS SERVICES PRIVATE LIMITED",
"PROCURRI INDIA PRIVATE LIMITED",
"PROCYON ADVISORS PRIVATE LIMITED",
"PROCYON LIFE SCIENCES PRIVATE LIMITED",
"PROCYON TECHNOSTRUCTURE PRIVATE LIMITED",
"PROCYON TECHSOLUTIONS PRIVATE LIMITED",
"PROD SOFTWARE INDIA PRIVATE LIMITED",
"PRODAIR AIR PRODUCTS INDIA PRIVATE LIMITED",
"PRODAPT INFRASTRUCTURE HOLDINGS PRIVATE LIMITED",
"PRODAPT NMS INDIA PRIVATE LIMITED",
"PRODAPT SOLUTIONS PRIVATE LIMITED",
"PRODAPT TECHNOLOGY HOLDINGS PRIVATE LIMITED",
"PRODAT IT SOLUTIONS (INDIA) PRIVATE LIMITED",
"PRODATA MANAGEMENT SERVICES PRIVATE LIMITED",
"PRODCON TECH SERVICES PRIVATE LIMITED",
"PRODCONTROL (INDIA) PRIVATE LIMITED",
"PRODEC COATINGS PRIVATE LIMITED",
"PRODEGE INDIA PRIVATE LIMITED",
"PRODELIN INDIA PRIVATE LIMITED",
"PRODES CONSULTING ENGINEERS PRIVATE LIMITED",
"PRODESIGN ENGINEERING SERVICES PRIVATE LIMITED",
"PRODESIGN TECHNOLOGIES INDIA PRIVATE LIMITED",
"PRODEVANS TECHNOLOGIES PRIVATE LIMITED",
"PRODEVBASE TECHNOLOGIES PRIVATE LIMITED",
"PRODEX TECHNOLOGIES PRIVATE LIMITED",
"PRODIAN INFOTECH PRIVATE LIMITED",
"PRODIAN SOLUTIONS PRIVATE LIMITED",
"PRODIGAL SOFTTECH INDIA PRIVATE LIMITED",
"PRODIGAL TECHNOLOGIES PRIVATE LIMITED",
"PRODIGAN SOFTWARE SOLUTIONS PRIVATE LIMITED",
"PRODIGEE FINANCE LIMITED",
"PRODIGIOUS INDIA INFOTECH PRIVATE LIMITED",
"PRODIGIOUS INDUSTRIES PRIVATE LIMITED",
"PRODIGITAS IT SERVICES PRIVATE LIMITED",
"PRODIGITZ MEDIA PRIVATE LIMITED",
"PRODIGY AUTOMOBILE TECHNOLOGIES PRIVATE LIMITED",
"PRODIGY COMMUNICATIONS AND MARKETING PRIVATE LIMITED",
"PRODIGY COMPUTERS AND LAPTOPS PRIVATE LIMITED",
"PRODIGY DEVELOPMENT INSTITUTION",
"PRODIGY ELECTRONICS PRIVATE LIMITED",
"PRODIGY ENTERPRISES PRIVATE LIMITED",
"PRODIGY HYDRO POWER PRIVATE LIMITED",
"PRODIGY INFOMATICS PRIVATE LIMITED",
"PRODIGY LUXE AND CRAFT PRIVATE LIMITED",
"PRODIGY MATH GAME INDIA PRIVATE LIMITED",
"PRODIGY SOFTWARE LIMITED",
"PRODIGY SYSTEMS AND SERVICES PRIVATE LIMITED",
"PRODIGY TECHNOVATIONS PRIVATE LIMITED",
"PRODIN SPORTING PRIVATE LIMITED",
"PRODOC FOODS PRIVATE LIMITED",
"PRODOCS SOLUTIONS PRIVATE LIMITED",
"PRODOT MARKETING PRIVATE LIMITED",
"PRODT CONSULTING SERVICES PRIVATE LIMITED",
"PRODUCT ARMOR PACKAGING PRIVATE LIMITED",
"PRODUCT OF THE YEAR INDIA PRIVATE LIMTED",
"PRODUCTDOSSIER SOLUTIONS INDIA PRIVATE LIMITED",
"PRODUCTION AIDS AND CONSULTANTS PRIVATE LIMITED",
"PRODUCTION MODELING INDIA PRIVATE LIMITED",
"PRODUCTION NEEDS GASES PRIVATE LIMITED",
"PRODUCTIONCREW ENTERTAINMENT PRIVATE LIMITED",
"PRODUCTIV SYSTEMS INDIA PRIVATE LIMITED",
"PRODUCTIVA IT SOLUTIONS PRIVATE LIMITED",
"PRODUCTIVE TECHNOLOGIES PRIVATE LIMITED",
"PRODUCTIVITY AIDS PRIVATE LIMITED",
"PRODUCTIVITY ELEMENTS PRIVATE LIMITED",
"PRODUCTIVITY SOLUTIONS PRIVATE LIMITED",
"PRODUCTS AND IDEAS (INDIA) PRIVATE LIMITED",
"PRODWARE SOLUTIONS PRIVATE LIMITED",
"PROEARTH AYURVEDA PRIVATE LIMITED",
"PROEC ENERGY LIMITED",
"PROEC PRIVATE LIMITED",
"PROECO STOCKCOM PRIVATE LIMITED",
"PROEDGE SKILL DEVELOPMENT AND EDUTECH PRIVATE LIMITED",
"PROEDGE TECHNOLOGIES PRIVATE LIMITED",
"PROELECTRIC PROJECTS PRIVATE LIMITED",
"PROELIO TECHNOLOGIES PRIVATE LIMITED",
"PROEVENTS AND PROMOTIONS PRIVATE LIMITED",
"PROEX FASHION PRIVATE LIMITED",
"PROEXCEL TECHNOLOGIES PRIVATE LIMITED",
"PROEXIM MARKETING PRIVATE LIMITED",
"PRO-EYE SECURITY SOLUTIONS (I) PRIVATE LIMITED",
"PROEZA CORP PRIVATE LIMITED",
"PROF.DHANAPALAN COLLEGE OF ARTS & SCIENCE",
"PROFAB ENGINEERS PRIVATE LIMITED",
"PROFAB STEEL PVT LTD",
"PROFAC MANAGEMENT SERVICES PRIVATE LIMITED",
"PROFECIA LINKS CONSULTING PRIVATE LIMITED",
"PROFECTUS CAPITAL PRIVATE LIMITED",
"PROFECTUS ELECTRONICS PRIVATE LIMITED",
"PROFEED AND PREMIX PRIVATE LIMITED",
"PROFERO PRINT PACK & PROMOTIONS PRIVATE LIMITED",
"PROFES HOSPITALITY AND MEDIA PRIVATE LIMITED",
"PROFESIONAL HR SERVICES PRIVATE LIMITED",
"PROFESS HEALTH PRODUCTS PRIVATE LIMITED",
"PROFESSIONAL ACCESS SOFTWARE DEVELOPMENT PRIVATE LIMITED",
"PROFESSIONAL ALLOYS AND CHEMICALS PRIVATE LIMITED",
"PROFESSIONAL ARBITRAGE CONCEPTS PRIVATE LIMITED",
"PROFESSIONAL ASSISTANCE FOR DEVELOPMENT ACTION ( PRADAN )",
"PROFESSIONAL AUTOMOTIVES PRIVATE LIMITED",
"PROFESSIONAL BIOTECH PRIVATE LIMITED",
"PROFESSIONAL COMPOSITES (BANGALORE) PRIVATE LIMITED",
"PROFESSIONAL CONSULTANCY",
"PROFESSIONAL CONSULTANTS",
"PROFESSIONAL COPIER SERVICES INDIA PRIVATE LIMITED",
"PROFESSIONAL COURIERS NETWORK LIMITED",
"PROFESSIONAL DIAGNOSTIC PRIVATE LIMITED",
"PROFESSIONAL DIGISIGN E-SERVICES PRIVATE LIMITED",
"PROFESSIONAL ELEVATORS PRIVATE LIMITED",
"PROFESSIONAL ENGINEERING SERVICES PRIVATE LIMITED",
"PROFESSIONAL ESOLUTIONS (INDIA) PRIVATE LIMITED",
"PROFESSIONAL FIRE AND SAFETY SERVICES",
"PROFESSIONAL GLOBAL INFRASTRUCTURES PRIVATE. LIMITED.",
"PROFESSIONAL HRM SERVICES PRIVATE LIMITED",
"PROFESSIONAL IMPEX PRIVATE LIMITED",
"PROFESSIONAL INSURANCE SURVEYORS AND LOSS ASSESSORS PRIVATE LIMITED",
"PROFESSIONAL INTERNATIONAL COURIERS PRIVATE LIMITED",
"PROFESSIONAL LINK SERVICES PRIVATE LIMITED",
"PROFESSIONAL LOGISTICS PRIVATE LIMITED",
"PROFESSIONAL MANAGEMENT GROUP PRIVATE LIMITED",
"PROFESSIONAL MEDICAL TRANSCRIPTION SOLUTIONS PRIVATE LIMITED",
"PROFESSIONAL PACKERS AND MOVERS PRIVATE LIMITED",
"PROFESSIONAL PEST MANAGEMENT AND ALLIED SERVICES PRIVATE LIMITED",
"PROFESSIONAL SHIP MANAGEMENT PRIVATE LIMITED",
"PROFESSIONAL SKILL TRAINING AND CONSULTANCY P LIMITED",
"PROFESSIONAL SOFTEC PRIVATE LIMITED",
"PROFESSIONAL TECHNICAL SERVICES PRIVATE LIMITED",
"PROFESSIONAL TECHSYS PRIVATE LIMITED",
"PROFESSIONAL TOUCH",
"PROFESSOR JAYASHANKAR TELANGANA STATE AGRICULTURAL UNIVERSITY",
"PROFESYST CONSULTING PRIVATE LIMITED",
"PROFEX CATERING AND HOSPITALITY SERVICES PRIVATE LIMITED",
"PROFEX RESOURCES LIMITED",
"PROFFER IT CONSULTANCY PRIVATE LIMITED",
"PROFFORMANCE TECHNOLOGIES PRIVATE LIMITED",
"PROFIC ORGANIC LIMITED",
"PROFICIENT AUTOMATION AND CONTROLS LIMITED",
"PROFICIENT COMMODITIES PRIVATE LIMITED",
"PROFICIENT ENERGY PRIVATE LIMITED",
"PROFICIENT EQUITIES PRIVATE LIMITED",
"PROFICIENT FOOD PRODUCTS LIMITED",
"PROFICIENT INDUSTRIES INDIA PRIVATE LIMITED",
"PROFICIENT MERCHANDISE LIMITED",
"PROFICIENT MOULDER PRIVATE LIMITED",
"PROFICIENT PARTNERS CONSULTANCY PRIVATE LIMITED",
"PROFICIENT TECH PRIVATE LIMITED",
"PROFICIENT TUBES (OPC) PRIVATE LIMITED",
"PROFICIO ADVISORS PRIVATE LIMITED",
"PROFICIO BUSINESS SOLUTIONS PRIVATE LIMITED",
"PROFICIO ENGINEERING & CONSTRUCTION PRIVATE LIMITED",
"PROFICON INFRA PRIVATE LIMITED",
"PROFICON MEDISOL PRIVATE LIMITED",
"PROFICUOUS OUTSOURCING SOLUTIONS PRIVATE LIMITED",
"PROFIK PUMPS PRIVATE LIMITED",
"PROFILE DATA CENTER SOLUTIONS PRIVATE LIMITED",
"PROFILE INTERNATIONAL SALONS LLP",
"PROFILE LIFESTYLE MANAGEMENT PRIVATE LIMITED",
"PROFIN MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"PROFINCH SOLUTIONS PRIVATE LIMITED",
"PROFINE INDIA WINDOW TECHNOLOGY PRIVATE LIMITED",
"PROFINS INSURANCE BROKING PRIVATE LIMITED",
"PROFISOLUTIONS PRIVATE LIMITED",
"PROFIT APPS INDIA PRIVATE LIMITED",
"PROFIT DIGITAL SERVICES PRIVATE LIMITED",
"PROFIT SHOE COMPANY PRIVATE LIMITED",
"PROFITEX SHARES & SECURITIES PRIVATE LIMITED",
"PROFITMART SECURITIES PRIVATE LIMITED",
"PROFITPLUS INFRA PRIVATE LIMITED",
"PROFIVE ENGINEERING PRIVATE LIMITED",
"PROFIX MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"PROFLO SYSTEMS PRIVATE LIMITED",
"PROFLUJO TECHNOLOGY PRIVATE LIMITED",
"PROFMAX ENTERPRISES PRIVATE LIMITED",
"PROFORM INTERIORS PRIVATE LIMITED",
"PROFORMICS DIGITECH PRIVATE LIMITED",
"PROFORTE GLOBAL CONSULTING PRIVATE LIMITED",
"PROFOUND BUSINESS SERVICES PRIVATE LIMITED",
"PROFTO HOME AND KITCHEN PRIVATE LIMITED",
"PROFUSE AGROCOM SUPPLIERS PRIVATE LIMITED",
"PROFUSE ENGINEERING EXCELLENCE PRIVATE LIMITED",
"PRO-G AGRO PRIVATE LIMITED",
"PROGAS SYSTEMS PRIVATE LIMITED",
"PROGBUY MEDIA PRIVATE LIMITED",
"PROGEN ERP SYSTEMS PRIVATE LIMITED",
"PROGEN RENEWABLES PRIVATE LIMITED",
"PROGEN SYSTEMS AND TECHNOLOGIES LIMITED",
"PROGENBIOLAB TECHNOLOGIES PRIVATE LIMITED",
"PROGENE PHARMA PRIVATE LIMITED",
"PROGENERICS PHARMA PRIVATE LIMITED",
"PROGENESIS IVF PRIVATE LIMITED",
"PROGENOUS TECH SOLUTION PRIVATE LIMITED",
"PROGEON GLOBAL FORWARDING P LIMITED",
"PROGFIN PRIVATE LIMITED",
"PROGIENCE TECHNOLOGIES PRIVATE LIMITED",
"PROGILITY CONSULTING PRIVATE LIMITED",
"PROGILITY TECHNOLOGIES PRIVATE LIMITED",
"PROGLEN GLOBAL VENTURES PRIVATE LIMITED",
"PROGLOBIZ SERVICES PRIVATE LIMITED",
"PROGLOGIX INTERNATIONAL SERVICES PRIVATE LIMITED",
"PROGNEUR TECHNOLOGIES PRIVATE LIMITED",
"PROGNO FINANCIAL PLANNING SYSTEMS PRIVATE LIMITED",
"PROGNO HEALTH SOLUTIONS INDIA PRIVATE LIMITED",
"PROGNOS INDIA HEALTH PRIVATE LIMITED",
"PROGNOSIS LABORATORIES",
"PROGNOSIS SECURITIES PVT LTD",
"PROGNOSYS ELECTRO MECHANICAL SERVICES PRIVATE LIMITED",
"PROGNOSYS MEDICAL SYSTEMS PRIVATE LIMITED",
"PROGO INTERIORS PRIVATE LIMITED",
"PROGRACE TECHNOLOGIES PRIVATE LIMITED",
"PROGRAM FOR APPROPRIATE TECHNOLOGY IN HEALTH",
"PROGRAMIC ASIA PRIVATE LIMITED",
"PROGRAMMERS IO INDIA PRIVATE LIMITED",
"PROGRESIVE LIFESCIENCES PRIVATE LIMITED",
"PROGRESS PRECAST INDIA PRIVATE LIMITED",
"PROGRESS RAIL INNOVATIONS PRIVATE LIMITED",
"PROGRESS SOFTWARE DEVELOPMENT PRIVATE LIMITED",
"PROGRESS TRADERS",
"PROGRESSION INDUSTRIES PRIVATE LIMITED",
"PROGRESSION INFONET PRIVATE LIMITED",
"PROGRESSIVE AGRIVENTURES PRIVATE LIMITED",
"PROGRESSIVE ALCOBEV DISTRIBUTORS PRIVATE LIMITED",
"PROGRESSIVE ALLOYS (INDIA) PRIVATE LIMITED",
"PROGRESSIVE AUTOMOBILES PRIVATE LIMITED",
"PROGRESSIVE AUTOSERVE PRIVATE LIMITED",
"PROGRESSIVE BUILDCON PRIVATE LIMITED",
"PROGRESSIVE CARS PRIVATE LIMITED",
"PROGRESSIVE COMPONENTS PRIVATE LIMITED",
"PROGRESSIVE CONSTRUCTIONS LIMITED",
"PROGRESSIVE CORPORATE SERVICES PRIVATE LIMITED",
"PROGRESSIVE CORRUGATED FIBERBOARD PRIVATE LIMITED",
"PROGRESSIVE COURIER SERVICEES PRIVATE LIMITED",
"PROGRESSIVE CREATIONS PRIVATE LIMITED",
"PROGRESSIVE CUISINE CONCEPTS PRIVATE LIMITED",
"PROGRESSIVE CURRICULUM MANAGEMENT P LIMITED",
"PROGRESSIVE DAIRY SOLUTIONS LIMITED",
"PROGRESSIVE DIGITAL MEDIA PRIVATE LIMITED",
"PROGRESSIVE EARTHMOVERS PRIVATE LIMITED",
"PROGRESSIVE EDUCATIONAL SOCIETY",
"PROGRESSIVE ENDEAVOURS PRIVATE LIMITED",
"PROGRESSIVE ENGICON PRIVATE LIMITED",
"PROGRESSIVE FERTICHEM PRIVATE LIMITED",
"PROGRESSIVE FIBRE CONTAINERZ PRIVATE LIMITED",
"PROGRESSIVE GEAR INDUSTRIES PRIVATE LIMITED",
"PROGRESSIVE GLOBAL FINANCE PRIVATE LIMITED",
"PROGRESSIVE INDEXING SYSTEMS PRIVATE LIMITED",
"PROGRESSIVE INFOTECH PRIVATE LIMITED",
"PROGRESSIVE INFOVISION PRIVATE LIMITED",
"PROGRESSIVE LIFESTYLES PRIVATE LIMITED",
"PROGRESSIVE MACHINE TOOLS",
"PROGRESSIVE MEDICAL CARE AND RESEARCH CENTRE PRIVATE LIMITED",
"PROGRESSIVE MERCANTILE CO-OP BANK LTD",
"PROGRESSIVE METALS PRIVATE LIMITED",
"PROGRESSIVE METERS PRIVATE LIMITED",
"PROGRESSIVE MOTORS PRIVATE LIMITED",
"PROGRESSIVE OUTSOURCING PRIVATE LIMITED",
"PROGRESSIVE POLYCOT PRIVATE LIMITED",
"PROGRESSIVE POLYTEX PRIVATE LIMITED",
"PROGRESSIVE POWERCON PRIVATE LIMITED",
"PROGRESSIVE PRODEVELOPERS PRIVATE LIMITED",
"PROGRESSIVE REFRACTORY AND MONOLITHICS PRIVATE LIMITED",
"PROGRESSIVE SALES PVT LTD",
"PROGRESSIVE SHARE BROKERS PRIVATE LIMITED",
"PROGRESSIVE SHELTERS PRIVATE LIMITED",
"PROGRESSIVE STAMPING PRIVATE LIMITED",
"PROGRESSIVE STAR FINANCE PRIVATE LIMITED",
"PROGRESSIVE STEEL AUTOMOTIVE SOLUTION PRIVATE LIMITED",
"PROGRESSIVE STEEL PROCESSORS PRIVATE LIMITED",
"PROGRESSIVE SURFACE SYSTEMS PRIVATE LIMITED",
"PROGRESSIVE TECHNO SOLUTIONS PRIVATE LIMITED",
"PROGRESSIVE TELE INFRA PRIVATE LIMITED",
"PROGRESSIVE TIMBER PRIVATE LIMITED",
"PROGRESSIVE TOOLS AND COMPONENTS PRIVATE LIMITED",
"PROGRESSIVE TRENDZ PRIVATE LIMITED",
"PROGRESSIVERX PHARMA OPERATIONS PRIVATE LIMITED",
"PROGRESSIVES-CARGO HOUSE (INDIA) PRIVATE LIMITED",
"PROGULF SHELVING SYSTEMS PRIVATE LIMITED",
"PROHED DIGITAL SOLUTIONS PRIVATE LIMITED",
"PROIASYS IT SERVICES PRIVATE LIMITED",
"PROIND BUSINESS SOLUTIONS PRIVATE LIMITED",
"PROINDIA HEALTHCARE LLP",
"PROINF NETWORKS PRIVATE LIMITED",
"PROINFOCUS INDIA PRIVATE LIMITED",
"PROINFY TECHNOLOGIES PRIVATE LIMITED",
"PROINTEGRATE WORLD IT CONSULTING PRIVATE LIMITED",
"PROINVEST WEALTH PRIVATE LIMITED",
"PROJAK INFOTECH PRIVATE LIMITED",
"PROJECT BUILDERS PRIVATE LIMITED",
"PROJECT ELECTRICAL INDUSTRIES (INDIA) PRIVATE LIMITED",
"PROJECT GARMENTS PVT LTD",
"PROJECT MANAGEMENT ENGINEERING SERVICES INDIA PRIVATE LIMITED",
"PROJECT OBJECTS INFOCOM INDIA PRIVATE LIMITED",
"PROJECT OFFICE L T D P TALODA",
"PROJECT PEOPLE SERVICES PRIVATE LIMITED",
"PROJECT VM NUTRITION PRIVATE LIMITED",
"PROJECTCATALYST INTERNET PRIVATE LIMITED",
"PROJECTION FINANCIAL & MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"PROJECTS AND DEVELOPEMENT INDIA LIMITED",
"PROJECTS AND DEVELOPMENT INDIA LIMITED",
"PROJEKT INDIGO STUDIO PRIVATE LIMITED",
"PROJEX ENGINEERS PRIVATE LIMITED",
"PROJEXCEL REALTY INDIA PRIVATE LIMITED",
"PROJEXEL INDUSTRIAL SOLUTIONS PRIVATE LIMITED",
"PROJEXIS INFRASTRUCTURE PRIVATE LIMITED",
"PROJEXON ENGINEERING AND PROJECT SERVICES PRIVATE LIMITED",
"PROJIVA WELLNESS PRIVATE LIMITED",
"PROK DEVICES PRIVATELIMITED",
"PROKATCHERS INDIA PRIVATE LIMITED",
"PROKEM TRADE AND INVESTMENT PRIVATE LIMITED",
"PROKENS OPESMETRICS PRIVATE LIMITED",
"PROKLEAN TECHNOLOGIES PRIVATE LIMITED",
"PROLEASE STAFFING SERVICES PRIVATE LIMITED",
"PROLECT SOLUTIONS PRIVATE LIMITED",
"PROLIANT INFOTECH PRIVATE LIMITED",
"PROLIFE BIO CHEMICAL INDUSTRIES PRIVATE LIMITED",
"PROLIFE CHEMOPHARMA PRIVATE LIMITED",
"PROLIFE INDUSTRIES LIMITED",
"PROLIFE MULTI SPECIALTY HOSPITALS PRIVATE LIMITED",
"PROLIFE MULTISPECIALITY HOSPITAL",
"PROLIFIC EXIM PRIVATE LIMITED",
"PROLIFIC FINVEST PRIVATE LIMITED",
"PROLIFIC GLASSES PRIVATE LIMITED",
"PROLIFIC HR CONSULTANTS (INDIA) LIMITED",
"PROLIFIC INFRA PRIVATE LIMITED",
"PROLIFIC PAPERS PRIVATE. LIMITED.",
"PROLIFIC PICTURE WORKS PRIVATE LIMITED",
"PROLIFIC POWER SOLUTIONS PRIVATE LIMITED",
"PROLIFIC PURE SPECIALITY CHEMICALS PRIVATE LIMITED",
"PROLIFIC RESEARCH PRIVATE LIMITED",
"PROLIFIC RESOLUTION PRIVATE LIMITED",
"PROLIFIC RETAIL SOLUTIONS PRIVATE LIMITED",
"PROLIFIC SYSTEMS & TECHNOLOGIES PRIVATE LIMITED",
"PROLIFIC VENTURES PRIVATE LIMITED",
"PROLIFICS CORPORATION LIMITED",
"PROLIFICS CORPORATION PRIVATE LIMITED",
"PROLIFY TECH INDIA PRIVATE LIMITED",
"PROLIJUNE LIFESCIENCES PRIVATE LIMITED",
"PROLIM INFOSYSTEMS PRIVATE LIMITED",
"PROLIM SOLUTIONS INDIA PRIVATE LIMITED",
"PROLINE DATATECH SERVICES PRIVATE LIMITED",
"PROLINE INDIA LIMITED",
"PROLINE NUTRITION PRIVATE LIMITED",
"PROLINE SEEDS COMPANY INDIA PVT LTD",
"PROLINK COMMUNICATIONS AND SECURITY SOLUTIONS PRIVATE LIMITED",
"PROLINK COMPUTERS PRIVATE LIMITED",
"PROLITE AUTOGLO LIMITED",
"PROLITUS TECHNOLOGIES PRIVATE LIMITED",
"PROLOGGING IN IT PRIVATE LIMITED",
"PROLOGIC CONSULTING PRIVATE LIMITED",
"PROLOGIC FIRST INDIA PRIVATE LIMITED",
"PROLOGIC MECHATRONICS PRIVATE LIMITED",
"PROLOGIC WEB SOLUTIONS PRIVATE LIMITED",
"PROLOGICS DIGITAL SERVICES PRIVATE LIMITED",
"PROLOGIS FREIGHT INDIA PRIVATE LIMITED",
"PROLONG COMPOSITES INDIA PRIVATE LIMITED",
"PROLONG PROFESSIONAL COSMETICS PRIVATE LIMITED",
"PROLUX ELECTROMECH INDIA PRIVATE LIMITED",
"PROLYFIS CONSULTING WORKS PRIVATE LIMITED",
"PROLYNK NETWORK PRIVATE LIMITED",
"PRO-LYTE LIGHTING SOLUTIONS PRIVATE LIMITED",
"PROLYX MICROELECTRONICS PRIVATE LIMITED",
"PROM MACHINING SOLUTIONS INDIA PRIVATE LIMITED",
"PROMA INDUSTRIES LIMITED",
"PROMAC ADVISORS PRIVATE LIMITED",
"PROMAC ENGINEERING INDUSTRIES LIMITED.",
"PROMAC REALTECH PRIVATE LIMITED",
"PROMACH AUTOMATION PRIVATE LIMITED",
"PROMACT IMPEX LIMITED",
"PROMACT INFOTECH PRIVATE LIMITED",
"PROMAG FOUNDATIONS AND STRUCTURES PRIVATE LIMITED",
"PROMAG PROGRESSERS FACILITY SERVICES PRIVATE LIMITED",
"PROMAIN LIMITED",
"PROMAN CRUSHING SYSTEMS PRIVATE LIMITED",
"PROMAN INFRASTRUCTURE SERVICES PRIVATE LIMITED",
"PROMAN SECURITECH PRIVATE LIMITED",
"PROMANADA REALITY PRIVATE LIMITED",
"PROMANTEC CONSULTANTS PRIVATE LIMITED",
"PROMANTIA BUSINESS SOLUTIONS PRIVATE LIMITED",
"PROMANTRA PROJECTS PRIVATE LIMITED",
"PROMANTRA SYNEGY SOLUTIONS LIMITED",
"PROMANTUS INDIA PRIVATE LIMITED",
"PROMARK FUSION LIMITED",
"PROMARK TECHNOLOGIES PRIVATE LIMITED",
"PROMARK TECHSOLUTIONS PRIVATE LIMITED",
"PROMARK TRAVEL SERVICES PRIVATE LIMITED",
"PROMAS ENGINEERS PRIVATE LIMITED",
"PROMAS RESEARCH LABORATORIES PRIVATE LIMITED",
"PROMAT FIRE & INSULATION PRIVATE LIMITED",
"PROMAT TECHNICAL SERVICES PRIVATE LIMITED",
"PROMATICS TECHNOLOGIES PRIVATE LIMITED",
"PROMAX CARBONTIER PRIVATE LIMITED",
"PROMAX HOME STYLE TRADE PRIVATE LIMITED",
"PROMAX MINERAL INDUSTRIES PRIVATE LIMITED",
"PROMAX POWER LIMITED",
"PROMEA THERAPEUTICS PRIVATE LIMITED",
"PROMECH INDUSTRIES PRIVATE LIMITED",
"PRO-MED INSTRUMENTS PRIVATE LIMITED",
"PROMED INTELSOFT PRIVATE LIMITED",
"PROMEDA CHEMOTRADE PRIVATE LIMITED",
"PROMEDIA TRADING PRIVATE LIMITED",
"PROMEDICA HEALTH COMMUNICATION PRIVATE LIMITED",
"PROMEGA BIOTECH INDIA PRIVATE LIMITED",
"PROMELECTRONICA TRADING PRIVATE LIMITED",
"PROMENADE HOSPITALITY PRIVATE LIMITED",
"PROMETHEA TECHSYNTH PRIVATE LIMITED",
"PROMETHEAN ENERGY PRIVATE LIMITED",
"PROMETHEAN SPENTA TECHNOLOGIES PRIVATE LIMITED",
"PROMETHEUS HEALTHCARE PRIVATE LIMITED",
"PROMETHEUS PATENT SERVICES PRIVATE LIMITED",
"PROMETHEUS SCHOOL GAURI SHIKSHA FOUNDATION",
"PROMETHEUS SOLUTIONS PRIVATE LIMITED",
"PROMETO CONSULTING PRIVATE LIMITED",
"PROMETRIC TECHNOLOGIES PRIVATE LIMITED",
"PROMETRIC TESTING PRIVATE LIMITED",
"PROMETRIC TESTING PRIVATE LIMITED TFR FROM DELHI TO HARYANA",
"PROMETTEUR SOLUTIONS PRIVATE LIMITED",
"PROMHEX PLUS HEALTHCARE PRIVATE LIMITED",
"PROMHO ENGINEERING SOLUTIONS PRIVATE LIMITED",
"PROMILA HOTELS PRIVATE LIMITED",
"PROMILA RICE MILL PRIVATE LIMITED",
"PROMILA ROLLER FLOUR MILLS PRIVATE LIMITED",
"PROMINE INDUSTRIES PRIVATE LIMITED",
"PROMINENCE HEALTHCARE PRIVATE LIMITED",
"PROMINENT AGRO INDUSTRIES PRIVATE LIMITED",
"PROMINENT BUILDERS AND AGENCIES PRIVATE LTD",
"PROMINENT BUILDWELL PRIVATE LIMITED",
"PROMINENT CARGO MOVERS PRIVATE LIMITED",
"PROMINENT COMMUNICATIONS PRIVATE LIMITED",
"PROMINENT DATAMATICS MARKETING PRIVATE LIMITED",
"PROMINENT DEVELOPERS PRIVATE LIMITED",
"PROMINENT ENGINEERS CONSULTANTS & CONTRACTORS LLP",
"PROMINENT FORGINGS PRIVATE LIMITED",
"PROMINENT HOTELS LIMITED",
"PROMINENT HYGIENE CHEMICAL PRODUCTS PRIVATE LIMITED",
"PROMINENT JEWEL ARCADE PRIVATE LIMITED",
"PROMINENT POLYMERS PRIVATE LIMITED.",
"PROMINENT POWDER PRIVATE LIMITED",
"PROMINENT SPINNERS PRIVATE LIMITED",
"PROMINENT STAFFING PRIVATE LIMITED",
"PROMINENT SUPPLIERS PRIVATE LIMITED",
"PROMINENT TRADERS",
"PROMINENT VANIJYA PVT LTD",
"PROMISE ECONOMICS PRIVATE LIMITED",
"PROMISE INDIA EXIM PRIVATE LIMITED",
"PROMISE MANPOWER SRVICES PRIVATE LIMITED",
"PROMISE TECHNOLOGY INC",
"PROMISING EMPIRE PRIVATE LIMITED",
"PROMISING EXPORTS PRIVATE LTD",
"PROMISING HORTICULTURE AND CONSULTANCY PRIVATE LIMITED",
"PROMITTO SOLUTIONS PRIVATE LIMITED",
"PROMKRAFT INDIA PRIVATE LIMITED",
"PROMMADA HINDUSTAN PRIVATE LIMITED",
"PROMOBI TECHNOLOGIES PRIVATE LIMITED",
"PROMOCON MEDIA PRIVATE LIMITED",
"PROMOD INDIA PRIVATE LIMITED",
"PROMODA SWITCH GEARS PRIVATE LIMITED",
"PROMODOME COMMUNICATIONS PRIVATE LIMITED",
"PROMOIS INTERNATIONAL LIMITED",
"PROMOLTA IT SOLUTIONS PRIVATE LIMITED",
"PROMON INDIA PRIVATE LIMITED",
"PROMON SOFTWARE SOLUTIONS PRIVATE LIMITED",
"PROMONANT EXPORT (OPC) PRIVATE LIMITED",
"PROMONT HILLSIDE PRIVATE LIMITED",
"PROMONT HILLTOP PRIVATE LIMITED",
"PROMOTECH FABRICATION MACHINES PRIVATE LIMITED",
"PROMOTER'S POWER PRIVATE LIMITED",
"PROMOTION BAZAAR PRIVATE LIMITED",
"PROMOTIONS INDIA PRIVATE LIMITED",
"PROMOTO SOFTWARE PRIVATE LIMITED",
"PROMOVE LOGISTICS PRIVATE LIMITED",
"PROMOVEO CONSULTING PRIVATE LIMITED",
"PROMOZ PRODUCTS PRIVATE LIMITED",
"PROMPT & SMART SECURITY BANGALORE PRIVATE LIMITED",
"PROMPT BARRIER FILMS PRIVATE LIMITED",
"PROMPT BUILDING SOLUTION PRIVATE LIMITED",
"PROMPT CASTINGS PRIVATE LIMITED",
"PROMPT CAST-MECH PRIVATE LIMITED",
"PROMPT CLOTHING COMPANY PRIVATE LIMITED",
"PROMPT COMPUSOLUTIONS PRIVATE LIMITED",
"PROMPT CORPORATE SERVICES LTD",
"PROMPT DATA PRODUCTS PVT LTD",
"PROMPT ENGINEERING PRIVATE LIMITED",
"PROMPT ENTERPRISES PRIVATE LIMITED",
"PROMPT EQUIPMENTS PRIVATE LIMITED",
"PROMPT ERP LIMITED",
"PROMPT INDIA LOGISOLUTIONS PRIVATE LIMITED",
"PROMPT INDUSTRIAL SERVICES PRIVATE LIMITED",
"PROMPT INDUSTRIES PRIVATE LIMITED",
"PROMPT LEASING LIMITED",
"PROMPT PACKAGING PVT.LTD.",
"PROMPT PERSONNEL PRIVATE LIMITED",
"PROMPT PULP AND FIBERS PRIVATE LIMITED",
"PROMPT SERVICES AND TOURISM PRIVATE LIMITED",
"PROMPT SOLUTIONS PRIVATE LIMITED",
"PROMPT TERMINALS PRIVATE LIMITED",
"PROMPT TOOLINGS INDIA PRIVATE LIMITED",
"PROMPT TOYS PRIVATE LIMITED",
"PROMPT TRADE FAIRS INDIA PRIVATE LIMITED",
"PROMPT UPS SALES AND SERVICES PRIVATE LIMITED",
"PROMPTCLOUD TECHNOLOGIES PRIVATE LIMITED",
"PROMPTITUDE ACCOUNTING SERVICES PRIVATE LIMITED",
"PROMS INTERNATIONAL TRADE PRIVATE LIMITED",
"PROMTECH ALLOYS PRIVATE LIMITED",
"PROMTECH IMPEX PVT. LTD.",
"PROMTO E-VENTURES PRIVATE LIMITED",
"PRONANCE INDUSTRIES PRIVATE LIMITED",
"PRONEEL TECHNOLOGIES PVT LTD",
"PRONERZY PRODUCTS PRIVATE LIMITED",
"PRONESIS TECHNOLOGIES PRIVATE LIMITED",
"PRONET TECHNOLOGIES PRIVATE LIMITED",
"PRONGHORN PACKING AND LOGISTICS PRIVATE LIMITED",
"PRONIT AUTO PRIVATE LIMITED",
"PRONIX TECHNOLOGIES PRIVATE LIMITED",
"PRONK MULTISERVICE INDIA PRIVATE LIMITED",
"PRONOB & CO. PVT. LTD.",
"PRONTEFF IT SOLUTIONS PRIVATE LIMITED",
"PRONTO ENTERTAINMENT PRIVATE LIMITED",
"PRONTO FABRIL PRIVATE LIMITED",
"PRONTO FRANCHISING PRIVATE LIMITED",
"PRONTO TECHNOTEX PRIVATE LIMITED",
"PRONTOCURE PHARMA PRIVATE LIMITED",
"PRONTON PLASTPACK PRIVATE LIMITED",
"PRONTUS TECHNOLOGIES PRIVATE LIMITED",
"PROODLE HOSPITALITY SERVICES PRIVATE LIMITED",
"PROODLE INTEGRATED SERVICE SOLUTIONS PRIVATE LIMITED",
"PROOF OF PERFORMANCE DATA SERVICES PRIVATE LIMITED",
"PROP TIGER MARKETING SERVICES PRIVATE LIMITED",
"PROP VESTORS PRIVATE LIMITED",
"PROP. SITA REAL ESTATE DEVELOPERS PRIVATE. LIMITED.",
"PROPACK ELECTRONICS PRIVATE LIMITED",
"PRO-PACK MATERIALS INDIA PRIVATE LIMITED",
"PRO-PACK PRIVATE LIMITED",
"PROPACK SHREINER PRIVATE LIMITED",
"PROPACK TECHNOLOGIES PRIVATE LIMITED",
"PROPALMS NETWORK PRIVATE LIMITED",
"PROPARENT SOLUTIONS PRIVATE LIMITED",
"PROPASSETS MANAGEMENT PRIVATE LIMITED",
"PROPBRICK BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"PROPCAP PROPERTY MANAGEMENT PRIVATE LIMITED",
"PROPCARE MALL MANAGEMENT INDIA PRIVATE LIMITED",
"PROPCARE REAL ESTATE MANAGEMENT PRIVATE LIMITED",
"PROPEL APPS PRIVATE LIMITED",
"PROPEL ENSOL PRIVATE LIMITED",
"PROPEL GURU MARKETING AND SALES AGENCY PRIVATE LIMITED",
"PROPEL INDENERGY SOLUTIONS PRIVATE LIMITED",
"PROPEL INDUSTRIES PRIVATE LIMITED",
"PROPELLENCE CONSULTING PRIVATE LIMITED",
"PROPELLO INNOVATIONS PRIVATE LIMITED",
"PROPELLUM INFOTECH PRIVATE LIMITED",
"PROPELOR INDIA PRIVATE LIMITED",
"PROPER PRODUCTS PRIVATE LIMITED",
"PROPERTY CLINIC",
"PROPERTY CO PVT LTD",
"PROPERTY GURU",
"PROPERTY INFRA TECH INDIA PRIVATE LIMITED",
"PROPERTY JUNCTION REALTORS PRIVATE LIMITED",
"PROPERTY JUNCTIONS AND INFRASTRUCTURE PRIVATE LIMITED",
"PROPERTY MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"PROPERTY MASTER PRIVATE LIMITED",
"PROPERTY POINT (INDIA) PRIVATE LIMITED",
"PROPERTY SOLUTIONS INDIA PRIVATE LIMITED",
"PROPERTY VENTURES (INDIA) PRIVATE LIMITED",
"PROPERTYANGEL MANAGEMENT PRIVATE LIMITED",
"PROPERTYCLOUD REALTY SPECIFIER PRIVATE LIMITED",
"PROPERTYLOOP INDIA PRIVATE LIMITED",
"PROPERTYPISTOL REALTY PRIVATE LIMITED",
"PROPERTYSHARE ONLINE PLATFORM PRIVATE LIMITED",
"PROPFINDER INDIA PRIVATE LIMITED",
"PROPHANDY TECHNOLOGIES PRIVATE LIMITED",
"PRO-PHARMA CARE PRIVATE LIMITED",
"PROPHARMEX INDIA PRIVATE LIMITED",
"PROPHECY SENSORLYTICS INDIA PRIVATE LIMITED",
"PROPHOENIX CONSULTANCY SERVICES PRIVATE LIMITED",
"PROPHONIX TECHNOLOGIES PRIVATE LIMITED",
"PROPITIA SOFTWARE SOLUTIONS PRIVATE LIMITED",
"PROPIX TECHNOLOGIES PRIVATE LIMITED",
"PROPLADDER REALTY PRIVATE LIMITED",
"PROPMART TECHNOLOGIES LIMITED",
"PROPMAX DEVELOPERS AND HOLDERS PRIVATE LIMITED",
"PROPMIX.IO INDIA PRIVATE LIMITED",
"PROPNIVESH PRIVATE LIMITED",
"PROPOFF MANAGEMENT PRIVATE LIMITED",
"PRO-POOR DEVELOPMENT FORUM",
"PROPOWER SYSTEMS PRIVATE LIMITED",
"PROPPICK SOLUTIONS PRIVATE LIMITED",
"PROPRENZ BIOTECH PRIVATE LIMITED",
"PROPSHARE CAPITAL ADVISORS PRIVATE LIMITED",
"PROPSHARE COMMERCIAL ASSETS PRIVATE LIMITED",
"PROPSHARE COMMERCIAL PARKS PRIVATE LIMITED",
"PROPSHARE OFFICE ASSETS PRIVATE LIMITED",
"PROPSHINE REALTORS PRIVATE LIMITED",
"PROPSHOP EVENTS AND EXHIBITIONS PRIVATE LIMITED",
"PROPSHOP EXPERTS PRIVATE LIMITED",
"PROPSPACE SQUARE PRIVATE LIMITED",
"PROPSQUARE LIFESPACES MANAGEMENT PRIVATE LIMITED",
"PROPSTACK SERVICES PRIVATE LIMITED",
"PROPTIGER MARKETING SERVICES PRIVATE LIMITED",
"PROPTIGER REALTY PRIVATE LIMITED",
"PROPULSION AVIATION PRIVATE LIMITED",
"PROPUS ENTERPRISES PRIVATE LIMITED",
"PROPVILLA REALTY PRIVATE LIMITED",
"PROPWEB REALTY SERVICES PRIVATE LIMITED",
"PROPZILLA INFRATECH PRIVATE LIMITED",
"PROQOL HEALTH CARE PRIVATE LIMITED",
"PROQUEST NUTRITION PRIVATE LIMITED",
"PRO-QUIP SOLUTIONS PRIVATE LIMITED",
"PROQUIP TECHNOLOGIES PRIVATE LIMITED",
"PROQUO TECHNOLOGIES INDIA PRIVATE LIMITED",
"PROREMAX IT SOFTWARE SERVICES OPC PRIVATE LIMITED",
"PRORICH AGRO PRIVATE LIMITED",
"PRORIGO SOFTWARE PRIVATE LIMITED",
"PRORITES EQUIPMENTS PRIVATE LIMITED",
"PROSAFE ELEKTROTEKNIKS PRIVATE LIMITED",
"PROSAFE INTERNATIONAL PRIVATE LIMITED",
"PROSAFE PROCESS ENGINEERING PRIVATE LIMITED",
"PROSAFE SAFETY EQUIPMENTS PRIVATE LIMITED",
"PROSAIC PHARMACEUTICALS PRIVATE LIMITED",
"PROSARES SOLUTIONS PRIVATE LIMITED",
"PROSAVA PRIVATE LIMITED",
"PROSCEND COMMUNICATIONS INDIA PRIVATE LIMITED",
"PROSCIZEN RESEARCH SERVICES PRIVATE LIMITED",
"PROSCUBA MARINE TECHNOLOGY PRIVATE LIMITED",
"PROSDEK ENGINEERING SOLUTIONS PRIVATE LIMITED",
"PROSE TECHNOLOGIES INDIA PRIVATE LIMITED",
"PROSEAL CLOSURES LIMITED",
"PROSECUTION DEPTT",
"PRO-SEED FOUNDATION OF INDIA",
"PROSEGUR CIT INTEGRAL SYSTEMS INDIA PRIVATE LIMITED",
"PROSEM TECHNOLOGY INDIA PRIVATE LIMITED",
"PROSEON TECHNOLOGIES PRIVATE LIMITED",
"PROSERA ANALYTICS PRIVATE LIMITED",
"PROSERV DATA PROCESSING PRIVATE LIMITED",
"PROSERVE SOLUTIONS INDIA PRIVATE LIMITED",
"PROSERVE SUPPORT SERVICE PRIVATE LIMITED",
"PROSERVZ DIGITECH PRIVATE LIMITED",
"PROSES WEB TECHNOLOGIES PRIVATE LIMITED",
"PROSFORA TECHNOLOGIES PRIVATE LIMITED",
"PROSILIO PHARMACEUTICALS PRIVATE LIMITED",
"PROSIM RESEARCH AND DEVELOPMENT PRIVATE LIMITED",
"PROSIT HEALTH CARE PRIVATE LIMITED",
"PROSIT INFOTECH PRIVATE LIMITED",
"PROSK SERVICES INDIA PRIVATE LIMITED",
"PROSO AI TECHNOLOGIES PRIVATE LIMITED",
"PROSOFT CYBERWORLD PRIVATE LIMITED",
"PROSOFT TECHNOSOLUTIONS PRIVATE LIMITED",
"PROSOHM PROJECTS (OPC) PRIVATE LIMITED",
"PROSOL CHEMICALS PRIVATE LIMITED",
"PROSOURCE ADVISORY PRIVATE LIMITED",
"PROSOURCE CONSULTING PRIVATE LIMITED",
"PROSOURCE INDUSTRIES PRIVATE LIMITED",
"PROSPANCE INFOTECH PRIVATE LIMITED",
"PROSPECT PHARMACEUTICALS PRIVATE LIMITED",
"PROSPECTA SOFT PRIVATE LIMITED.",
"PROSPECTA SOFTWARE SOLUTIONS PRIVATE LIMITED",
"PROSPECTA TECHNOLOGIES INDIA PRIVATE LIMITED",
"PROSPECTS INFRA PRIVATE LIMITED",
"PROSPER EDUCATION PRIVATE LIMITED",
"PROSPER GROWTH PRIVATE LIMITED",
"PROSPER JEWEL ARCADE LIMITED LIABILITY PARTNERSHIP",
"PROSPER OVERSEAS PRIVATE LIMITED",
"PROSPER TECH AND DEVELOPERS PRIVATE LIMITED",
"PROSPER UNIVERSAL PRIVATE LIMITED",
"PROSPERITA HOTEL VENTURES LIMITED",
"PROSPERITY 6 PHARMACEUTICS",
"PROSPERITY COMMOTRADE PRIVATE LIMITED",
"PROSPERITY ORGANICS PRIVATE LIMITED",
"PROSPERITY VANIJYA PRIVATE LIMITED",
"PROSPERO FINVEST LIMITED",
"PROSPERO HOSPITALITY PRIVATE LIMITED",
"PROSPEROUS MOTORS PRIVATE LIMITED",
"PROSPEROUS MULTIBUSINESS PRIVATE LIMITED",
"PROSPEROUS OUTLET VISION PRIVATE LIMITED",
"PROSPIRA INDIA AUTOMOTIVE PRODUCTS PRIVATE LIMITED",
"PROSPIRE EDUCATIONAL SERVICES LLP",
"PROSPUN TEXTILE INDIA PRIVATE LIMITED",
"PROSTAR FINSERVE PRIVATE LIMITED",
"PROSTAR MICRONOVA POWER SYSTEMS PRIVATE LIMITED",
"PROSTARM ENERGY SYSTEMS PRIVATE LIMITED",
"PROSTARM INFO SYSTEMS LIMITED",
"PROSTART - ME TECHNOLOGY PRIVATE LIMITED",
"PROSTEEL DETAILING SERVICES PRIVATE LIMITED",
"PROSTHETIC SUPPLIERS PRIVATE LIMITED",
"PROSUN ENERGY PRIVATE LIMITED",
"PROSUPPLYR GLOBAL PRIVATE LIMITED",
"PROSYS BUILDCARE TECHNOLOGIES PRIVATE LIMITED",
"PROSYS BUSINESS SOLUTIONS PRIVATE LIMITED",
"PROSYS INFOTECH PRIVATE LIMITED",
"PROSYSSOLS PRIVATE LIMITED",
"PROTAC FOODS INTERNATIONAL PRIVATE LIMITED",
"PROTAGONISTS E. SOLUTIONS PRIVATE LIMITED",
"PROTAIGA GLOBAL SOLUTIONS PRIVATE LIMITED",
"PROTANTRIX INFRASTRUCTURE PRIVATE LIMITED",
"PROTAQ BIOMEDICAL PRIVATE LIMITED",
"PROTATECH INDIA SOLUTIONS PRIVATE LIMITED",
"PROTATECH INTELLIGENCE MANPOWER PRIVATE LIMITED",
"PROTEA RETAILS PRIVATE LIMITED",
"PROTEAM ADVISORY SOLUTIONS LLP",
"PRO-TEAM BUILDING SYSTEMS (INDIA) PRIVATE LIMITED",
"PROTEAM COMPUTER INDUSTIRES PRIVATE LIMITED",
"PROTEAM SOFTWARES INDIA PRIVATE LIMITED",
"PROTEAM WEB SERVICES PRIVATE LIMITED",
"PROTEAN EGOV TECHNOLOGIES LIMITED",
"PROTECH BIO SYSTEMS PRIVATE LIMITED",
"PROTECH BIOPHARMA PRIVATE LIMITED",
"PROTECH BUILDCON PRIVATE LIMITED",
"PROTECH CONSULTANTS PRIVATE LIMITED",
"PROTECH EARTHING PRIVATE LIMITED",
"PROTECH ENGINEERING INDUSTRIES PVT LTD",
"PROTECH ENGINEERING PRIVATE LIMITED",
"PRO-TECH ENGINEERS & FABRICATORS PRIVATE LIMITED",
"PROTECH ENGINEERS BANGALORE PRIVATE LIMITED",
"PROTECH HYDRO MOVERS PRIVATE LIMITED",
"PROTECH IMPEX PRIVATE LIMITED",
"PROTECH INDIA LIMITED",
"PROTECH MICROSYSTEMS INDIA PRIVATE LIMITED",
"PROTECH ONLINE SOFTWARES INDIA PRIVATE LIMITED",
"PROTECH ORGANO FOODS PRIVATE LIMITED",
"PROTECH SHINE & CARE LLP",
"PRO-TECH SPORTS AND SAFETY PRODUCTS PRIVATE LIMITED",
"PROTECH STAMPINGS PRIVATE LIMITED",
"PROTECH STRUCTURES PRIVATE LIMITED",
"PROTECH TURNKEY PROJECTS PRIVATE LIMITED",
"PRO-TECHKT HEALTH AND SAFETY PRIVATE LIMITED",
"PROTECHMANIZE SOLUTIONS PRIVATE LIMITED",
"PROTECHMIND SOLUTIONS PRIVATE LIMITED",
"PROTECHNVIL SYSTEMS PRIVATE LIMITED",
"PROTECHSOFT SYSTEMS PRIVATE LIMITED",
"PROTECHSOFT TECHNOLOGIES PRIVATE LIMITED",
"PROTECK MACHINERY PRIVATE LIMITED",
"PROTECK PRECISION PRIVATE LIMITED",
"PROTECON BTG PRIVATE LIMITED",
"PROTECT MARKETING PVT LTD",
"PROTECT NATURE PRIVATE LIMITED",
"PROTECT SECURITY & HOUSEKEEPING PRIVATE LIMITED",
"PROTECTIVE COATINGS PRIVATE LIMITED",
"PROTECTIVE GENERAL ENGINEERING PRIVATE LIMITED",
"PROTECTIVE LEATHER GLOVES PRIVATE LIMITED",
"PROTECTO ENGINEERING PRIVATE LIMITED",
"PROTECTOR FIRESAFETY INDIA PRIVATE LIMITED",
"PROTECTRON ELECTROMECH PRIVATE LIMITED",
"PROTECTT.AI LABS PRIVATE LIMITED",
"PROTEGO INDIA PRIVATE LIMITED",
"PROTEGO SERVICES LLP",
"PROTEGRITY INDIA PRIVATE LIMITED",
"PROTEIN TECHNOLOGIES INDIA",
"PROTEK AIR SOLUTIONS PRIVATE LIMITED",
"PROTEK LOGISTICS (INDIA) PRIVATE LIMITED",
"PROTEK SYSTEM INDIA PRIVATE LIMITED",
"PROTEK TRADE PRIVATE LIMITED",
"PROTEL INFOSERVE PRIVATE LIMITED",
"PROTEL LABS PRIVATE LIMITED",
"PROTEL TELEPOWER INFRASTRUCTURE PRIVATE LIMITED",
"PROTEOGEN BIOSCIENCES INDIA PRIVATE LIMITED",
"PROTEOGEN HEALTH SCIENCES INDIA PRIVATE LIMITED",
"PROTEON PHARMACEUTICALS INDIA PRIVATE LIMITED",
"PROTERA TECHNOLOGIES INDIA PRIVATE LIMITED",
"PROTERIAL (INDIA) PRIVATE LIMITED\n",
"PROTEUS ENTERPRISE PRIVATE LIMITED",
"PROTEUS MEDICAL TECHNOLOGIES PRIVATE LIMITED",
"PROTEUS TECHNOLOGIES PRIVATE LIMITED",
"PROTEVISTA BUSINESS ADVISORS LIMITED",
"PROTEX CERAMIC PRIVATE LIMITED",
"PROTEX COMPUTER PVT LTD",
"PROTEX SECURITIES PRIVATE LIMITED",
"PROTHERM ENGINEERING PVT LTD",
"PROTHIOUS ENGINEERING SERVICES PRIVATE LIMITED",
"PROTINEX ADVANCED FEED INDUSTRIES PRIVATE LIMITED",
"PROTIUM BUSINESS SERVICES PRIVATE LIMITED",
"PROTIUM FINANCE LIMITED",
"PROTIVA ANIMAL NUTRITION PRIVATE LIMITED",
"PROTIVITI CONSULTING PRIVATE LIMITED",
"PROTIVITI INDIA MEMBER PRIVATE LIMITED",
"PROTO D ENGINEERING PRIVATE LIMITED",
"PROTO LUBE PRIVATE LIMITED",
"PROTOACT DIGITAL NETWORK PRIVATE LIMITED",
"PROTOCHEM INDUSTRIES PRIVATE LIMITED",
"PROTOCOL 7 SUPPORT AND SERVICES PRIVATE LIMITED",
"PROTOCOL AUTOMATION TECHNOLOGIES PRIVATE LIMITED",
"PROTOCOL INFORMATICS PRIVATE LIMITED",
"PROTOCOL INSURANCE SURVEYORS & LOSS ASSESSORS PRIVATE LIMITED",
"PROTOCOL INTEGRATED MANAGEMENT SERVICES PRIVATE LIMITED",
"PROTOCOL LABELS INDIA PRIVATE LIMITED",
"PROTOCOL LOGISTICS PRIVATE LIMITED",
"PROTOCOL MARINE SERVICES PRIVATE LIMITED",
"PROTOCOL SALES PRIVATE LIMITED",
"PROTOCOL SOLUTIONS PRIVATE LIMITED",
"PROTOCOL TEN DIGITAL MARCOM PRIVATE LIMITED",
"PROTOCOL VALUERS PRIVATE LIMITED",
"PROTOCOLS AND TOKENS PRIVATE LIMITED",
"PROTOCONTROL INSTRUMENT INDIA PRIVATE LIMITED",
"PROTOG BUSINESS SOLUTIONS PRIVATE LIMITED",
"PROTOGREEN RETAIL SOLUTIONS PRIVATE LIMITED",
"PROTOMAC EXTRUSION PRIVATE LIMITED",
"PROTOMINDS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"PROTON BIOLOGICALS INDIA PRIVATE LIMITED",
"PROTON CLOUD TECHOLOGIES PRIVATE LIMITED",
"PROTON DRUGS AND CHEMICALS PVT LTD",
"PROTON ENVIRO SOLUTIONS PRIVATE LIMITED",
"PROTON FACILITY SOLUTIONS PRIVATE LIMITED",
"PROTON GASES INDIA PRIVATE LIMITED",
"PROTON GRANITO PRIVATE LIMITED",
"PROTON INDIA PRIVATE LIMITED",
"PROTON INFOSYS PRIVATE LIMITED",
"PROTON METALCRAFTS PRIVATE LIMITED",
"PROTON POLYMERS PRIVATE LIMITED",
"PROTON POWER CONTROL PRIVATE LIMITED",
"PROTON REMEDIES PRIVATE LIMITED",
"PROTON STEELS LIMITED",
"PROTON TOOLINGS PRIVATE LIMITED",
"PROTONCLOUD TECHNOLOGIES PRIVATE LIMITED",
"PROTONE ENERGY SYSTEMS PRIVATE LIMITED",
"PROTONIC MEDICAL SYSTEMS PRIVATE LIMITED.",
"PROTONIX FORTUNER INDIA PRIVATE LIMITED",
"PROTONS CABLE PRIVATE LIMITED",
"PROTONSHUB TECHNOLOGIES PRIVATE LIMITED",
"PROTOPACK FOOD PACKAGING PRIVATE LIMITED",
"PROTOPOWER SPRINGS PRIVATE LIMITED",
"PROTOREXXZ INDIA PRIVATE LIMITED",
"PROTOS ENGINEERING COMPANY PRIVATE LIMITED",
"PROTOTECH SOLUTIONS AND SERVICES PRIVATE LIMITED",
"PROTOTYZE SERVICES PRIVATE LIMITED",
"PROTOVEC TECHNOLOGIES PRIVATE LIMITED",
"PROTOXL DESIGN PRIVATE LIMITED",
"PROTRADE APPLIED MATERIALS PRIVATE LIMITED",
"PROTRANS EXIM SOLUTIONS PRIVATE LIMITED",
"PROTRANS SUPPLY CHAIN MANAGEMENT PRIVATE LIMITED",
"PROTTON SYNERGY PRIVATE LIMITED",
"PROTUNE KSA CONSULTANTS PRIVATE LIMITED",
"PROTXUM SECURITY SERVICES PRIVATE LIMITED",
"PROUD TRADING PRIVATE LIMITED",
"PROV FOODS PRIVATE LIMITED",
"PROV INFOTECH SYSTEMS PRIVATE LIMITED",
"PROV LABS INDIA PRIVATE LIMITED",
"PROVA CHEM (INDIA) PRIVATE LIMITED",
"PROVA FLAVOURS INDIA PRIVATE LIMITED",
"PROVA PAINTS & POLYMERS PRIVATE LIMITED",
"PROVA TECHNOTRADE PRIVATE LIMITED",
"PROVAASYS NUTRIENTS INDIA PRIVATE LIMITED",
"PROVAB TECHNOSOFT PRIVATE LIMITED",
"PROVAL TECHNOLOGIES PRIVATE LIMITED",
"PROVANA INDIA PRIVATE LIMITED",
"PROVARTESTING INDIA PRIVATE LIMITED",
"PROVATICAL INDIA PRIVATE LIMITED",
"PROVATOSOFT PRIVATE LIMITED",
"PROVEDA MARKETING INDIA PRIVATE LIMITED",
"PROVEG ENGINEERING & FOOD PROCESSING PRIVATE LIMITED",
"PROVEN HEALTH SOLUTIONS PRIVATE LIMITED",
"PROVEN MARKETING PRIVATE LIMITED",
"PROVEN WATER INDUSTRIES PRIVATE LIMITED",
"PROVENANCE LAND PRIVATE LIMITED",
"PROVENCE DEVELOPERS PRIVATE LIMITED",
"PROVENTECH CONSULTING PRIVATE LIMITED",
"PROVENTEQ INDIA PRIVATE LIMITED",
"PROVENTUS AGER INDIA PRIVATE LIMITED",
"PROVENTUS AGROCOM LIMITED",
"PROVENTUS LIFE SCIENCES PRIVATE LIMITED",
"PROVENTUS RETAIL PRIVATE LIMITED",
"PROVERNE SOLUTIONS PRIVATE LIMITED",
"PROVERTEX ENTERPRISES PRIVATE LIMITED",
"PROVERVE RETAIL PRIVATE LIMITED",
"PROVESTMENT SERVICES LIMITED.",
"PROVET PHARMA PRIVATE LIMITED",
"PROVIDENCE GLOBAL CENTER LLP",
"PROVIDENCE INDIA INSURANCE BROKING PRIVATE LIMITED",
"PROVIDENCE SHIP MANAGEMENT (INDIA) PRIVATE LIMITED",
"PROVIDENCE TEXTILES",
"PROVIDENT CONSULTANT PRIVATE LIMITED",
"PROVIDENT EXPORTS PRIVATE LIMITED",
"PROVIDENT HOUSING LIMITED",
"PROVIDENTIAL PROPERTIES PRIVATE LIMITED",
"PROVIDIAN GLOBAL SOLUTION PRIVATE LIMITED",
"PROVIGIL SURVEILLANCE LIMITED",
"PROVILITY SOFTWARE SOLUTIONS PRIVATE LIMITED",
"PROVILLE SPICES PRIVATE LIMITED",
"PROVIMI ANIMAL NUTRITION INDIA PRIVATE LIMITED",
"PROVIMI PRODUCTS PRIVATE LIMITED",
"PROVIN TECHNOS PRIVATE LIMITED",
"PROVINCE DEVELOPERS PRIVATE LIMITED",
"PROVINCE INFOTECH PRIVATE LIMITED",
"PROVINCIAL AUTOMOBILE COMPANY PRIVATE LIMITED",
"ALPHA ALTERNATIVES FINANCIAL SERVICES PRIVATE LIMITED",
"PROVINCIAL INSURANCE BROKING PRIVATE LIMITED",
"PROVINCIAL TRUCKING PRIVATE LIMITED",
"PROVIS BIOLABS PRIVATE LIMITED",
"PROVISE GLOBAL SERVICES PRIVATE LIMITED",
"PROVISION INFRATECH PRIVATE LIMITED",
"PROVISION TREE SOLUTIONS PRIVATE LIMITED",
"PROVISO INFRASTRUCTURES PRIVATE LIMITED",
"PROVISO SERVICES INDIA PRIVATE LIMITED",
"PROVISSAR INDIA PRIVATE LIMITED",
"PROVIT FOODS PRIVATE LIMITED",
"PROV-NOVA BIO TECHNOLOGIES PRIVATE LIMITED",
"PROVOCATRO APPARELS PRIVATE LIMITED",
"PROVYOO INDIA PRIVATE LIMITED",
"PROWARENESS SOFTWARE SERVICES PRIVATE LIMITED",
"PROWELL HOTELS PRIVATE LIMITED",
"PROWESS ADVISORS PRIVATE LIMITED",
"PROWESS ENTERPRISE I PRIVATE LIMITED",
"PROWESS HEALTHCARE SERVICES INDIA PRIVATE LIMITED",
"PROWESS INFOSYSTEMS PRIVATE LIMITED",
"PROWESS INFOTECH PRIVATE LIMITED",
"PROWESS INFRASTRUCTURE PRIVATE LIMITED",
"PROWESS PUBLISHING & SOFTWARE SOLUTIONS PRIVATE LIMITED",
"PROWESS SOFTWARE SERVICES PRIVATE LIMITED",
"PROWESSTICS IT SERVICES PRIVATE LIMITED",
"PROWILL PHARMACEUTICALS PRIVATE LIMITED",
"PROWIN MANAGEMENT SERVICES",
"PROWIS CORPORATE SERVICES PRIVATE LIMITED",
"PROWIZ MANSYSTEMS PRIVATE LIMITED",
"PROWIZ SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED",
"PROWL CREDIT MANAGEMENT PRIVATE LIMITED",
"PROWON VENTURES PRIVATE LIMITED",
"PROWORK SPACES PRIVATE LIMITED",
"PROWORKS ENGINEERING AND TECHNICAL SERVICES PRIVATE LIMITED",
"PROWRIGHT PROJECTS PRIVATE LIMITED",
"PROXECTO ENGINEERING SERVICES LLP",
"PROXEDGE SOLUTIONS LLP",
"PROXELA PROJECTS PRIVATE LIMITED",
"PROXENIA HOSPITALITY PRIVATE LIMITED",
"PROXIMA STEEL FORGE PRIVATE LIMITED",
"PROXIMA SYSTEMS PRIVATE LIMITED",
"PROXIMITY LABS PRIVATE LIMITED",
"PROXIMON CONTROLS PRIVATE LIMITED",
"PROXINET TECHNOLOGIES PRIVATE LIMITED",
"PROYUGA ADVANCED TECHNOLOGIES LIMITED",
"PROZEAL INFRA ENGINEERING PRIVATE LIMITED",
"PROZIOD ANALYTICS PRIVATE LIMITED",
"PROZONE ADVISORS PRIVATE LIMITED",
"PROZONE DEVELOPERS & REALTORS PRIVATE LIMITED",
"PROZONE INTU PROPERTIES LIMITED",
"PROZOR TECH PRIVATE LIMITED",
"PROZURA CONSTRUCTION CHEMICALS PRIVATE LIMITED",
"PROZUS PRIVATE LIMITED",
"PRP BUILDMART TRADERS PRIVATE LIMITED",
"PRP CORPORATE SOLUTIONS PRIVATE LIMITED",
"PRP PROFESSIONAL EDGE ASSOCIATES PRIVATE LIMITED",
"PRP PROJECTS PVT LTD",
"PRP SERVICES PRIVATE LIMITED",
"PRPL GARMENTS PRIVATE LIMITED",
"PRR CARGO EXPRESS PRIVATE LIMITED",
"PRR HOTELS PRIVATE LIMITED",
"PRRAGATHI STEEL CASTINGS PRIVATE LIMITED",
"PRRET FUSION (I) PRIVATE LIMITED",
"PRRSAAR COMMODITIES PRIVATE LIMITED",
"PRS BUILD INDIA PRIVATE LIMITED",
"PRS ENVIRO PRIVATE LIMITED",
"PRS HOSPITAL PRIVATE LIMITED",
"PRS HOSPITALITY & INFRASTUCTURE DEVELOPEMENT (INDIA) PRIVATE LIMITED",
"PRS MEDISURG PRIVATE LIMITED",
"PRS MILK PRODUCTS PRIVATE LIMITED",
"PRS PERMACEL PRIVATE LIMITED",
"PRS TOLLS PRIVATE LIMITED",
"PRS TYRES PRIVATE LIMITED",
"PRSSB SERVICES LIMITED",
"PRT PETROCHEMICALS PRIVATE LIMITED",
"PRUDENCE ANALYTICS AND SOFTWARE SOLUTIONS PRIVATE LIMITED",
"PRUDENCE EDUVISION PRIVATE LIMITED",
"PRUDENCE INFRASTRUCTURES PRIVATE LIMITED",
"PRUDENCE MARINE SERVICES PRIVATE LIMITED",
"PRUDENCE SCHOOL",
"PRUDENCE TECHNOLOGY PRIVATE LIMITED",
"PRUDENS DERMACEUTICALS PRIVATE LIMITED",
"PRUDENT ADS PRIVATE LIMITED",
"PRUDENT AGRI-COMMODITIES INDIA PRIVATE LIMITED",
"PRUDENT ARC LIMITED",
"PRUDENT ARTS AND FAB PRIVATE LIMITED",
"PRUDENT BREWERIES AND DISTILLERIES PRIVATE LIMITED",
"PRUDENT BROKING SERVICES PRIVATE LIMITED",
"PRUDENT COMMUNICATION SYSTEMS PRIVATE LIMITED",
"PRUDENT CONTRACTS PRIVATE LIMITED",
"PRUDENT CONTROLS PRIVATE LIMITED",
"PRUDENT CORPORATE ADVISORY SERVICES LIMITED",
"PRUDENT DIGITAL PRIVATE LIMITED",
"PRUDENT ECO SYSTEMS PRIVATE LIMITED",
"PRUDENT EPC PRIVATE LIMITED",
"PRUDENT GLOBALTECH SOLUTIONS PRIVATE LIMITED",
"PRUDENT INFRATECH PRIVATE LIMITED",
"PRUDENT INSURANCE BROKERS PRIVATE LIMITED",
"PRUDENT LOGISTICS SOLUTIONS PRIVATE LIMITED",
"PRUDENT MEDIA GOA PRIVATE LIMITED",
"PRUDENT SERVICES & SOLUTIONS",
"PRUDENT STAINLESS PRIVATE LIMITED",
"PRUDENT TECHNOLOGIES PRIVATE LIMITED",
"PRUDENT TEQTIS PRIVATE LIMITED",
"PRUDENT TIE-UP PRIVATE LIMITED",
"PRUDENT TRANSPORT COMPANY LIMITED",
"PRUDENT UMBRELLA INDUSTRIES PRIVATE LIMITED",
"PRUDENTIA CONSULTING INDIA PRIVATE LIMITED",
"PRUDENTIA MANAGEMENT AND TECHNOLOGY CONSULTING LLP",
"PRUDENTIA TECHNOLOGY SOLUTIONS INDIA PRIVATE LIMITED",
"PRUDENTIAL AMMANA SUGARS LIMITED",
"PRUDENTIAL GLOBAL LOGISTICS PRIVATE LIMITED",
"PRUDENTIAL GLOBAL SERVICES PRIVATE LIMITED",
"PRUDENTIAL INFOTECH LTD",
"PRUDENTIAL MANAGEMENT AND SERVICES PVT LTD",
"PRUDENTIAL RUBBER PRIVATE LIMITED",
"PRUDENTIAL SYSTEMS TECHNOLOGIES PRIVATE LIMITED",
"PRUDENTIAL TECHNOLOGY AND SERVICES INDIA PRIVATE LIMITED",
"PRUDENTIAL TRAVELS PRIVATE LIMITED",
"PRUDHVI CONSTRUCTIONS PRIVATE LIMITED",
"PRUDOUR PRIVATE LIMITED",
"PRUFTECHNIK AIMIL CONDITION MONITORING PRIVATE LIMITED",
"PRUKSA INDIA HOUSING PRIVATE LIMITED",
"PRUMATECH INFOSYSTEMS PRIVATE LIMITED",
"PRUMATECH SERVICES PRIVATE LIMITED",
"PRUNAMA STEELS PRIVATE LIMITED",
"PRUSCO TRADE & SUPPLY PRIVATE LIMITED",
"PRUTECH SOLUTIONS INDIA PRIVATE LIMITED",
"PRUTHA PACKAGING PRIVATE LIMITED",
"PRUTHASHAKTI FARMER PRODUCER COMPANY LIMITED",
"PRUTHI TRANSLOGISTICS PRIVATE LIMITED",
"PRUTHVI ADITHYA INFRATECH PRIVATE. LIMITED.",
"PRUTHVI AVENUES PRIVATE LIMITED",
"PRUTHVI BROADCASTING SERVICES PRIVATE LIMITED",
"PRUTHVI E-RECYCLE PRIVATE LIMITED",
"PRUTHVI HYBRID SEEDS PRIVATE LIMITED",
"PRUTHVIRAJ MULTY SERVICES",
"PRV INFRACON PRIVATE LIMITED",
"PRVS INFRASTRUCTURE PRIVATE LIMITED",
"PRY LIVE STYLE PRIVATE LIMITED",
"PRYADARSHINI COLLEGE OF ENGINEERING",
"PRYM FASHION INDIA PRIVATE LIMITED",
"PRYM STEEL TRADING PRIVATE LIMITED",
"PRYSM DISPLAYS INDIA PRIVATE LIMITED",
"PRYSTAL TECH MANAGEMENT PRIVATE LIMITED",
"PRYSTINE FOOD & BEVERAGES PRIVATE LIMITED",
"PRYTO PRIVATE LIMITED",
"PS AQUA PRIVATE LIMITED",
"PS AUTOMATION (INDIA) PRIVATE LIMITED",
"PS CAMSHAFTS PRIVATE LIMITED",
"PS COMPONENTS INDIA PRIVATE LIMITED",
"PS CORPORATE SERVICES PRIVATE LIMITED",
"PS DIGITECH-HR INDIA PRIVATE LIMITED",
"PS EXPORTS & CONSOLIDATES PRIVATE LIMITED",
"PS FOUNDRY PRIVATE LIMITED",
"PS GAJANAN VIDYALAY SHIVNA",
"PS GLOBAL CONSUMER HEALTHCARE PRIVATE LIMITED",
"PS GROUP REALITY PRIVATE LIMITED",
"PS INTELEGENCIA ANALYSTICS PRIVATE LIMITED",
"PS MAGNUM OWNERS ASSOCIATION",
"PS MATRICULATION HIGHER SECONDARY SCHOOL",
"PS MEDICAL SYSTEMS PRIVATE LIMITED",
"PS PC PRESS PRIVATE LIMITED",
"PS PRIMARC PROJECTS LLP",
"PS QUICK IT PRIVATE LIMITED",
"PS SMARTVISION ENTERPRISES PRIVATE LIMITED",
"PS STAFFING SOLUTIONS PRIVATE LIMITED",
"PS STAMPING MANUFACTURERS PRIVATE LIMITED",
"PS STEEL TUBES LIMITED",
"PS TOLL ROAD PRIVATE LIMITED",
"PS UNIVERSAL PRIVATE LIMITED",
"PS VENTURES PRIVATE LIMITED",
"PS VISION PROVISION PRIVATE LIMITED",
"PS WEAVERS PRIVATE LIMITED",
"PSA AVTEC POWERTRAIN PRIVATE LIMITED",
"PSA CHEMICALS AND PHARMACEUTICALS PVT LTD",
"PSA NITROGEN LIMITED",
"PSA POLYMERS PRIVATE LIMITED",
"PSAA CONSTRUCTIONS PRIVATE LIMITED",
"PSAFL SPEEDMARK FORWARDING PRIVATE LIMITED",
"PSAG IT INDIA PRIVATE LIMITED",
"PSALM AGRO PRIVATE LIMITED",
"PSAMIRCO TRADING PRIVATE LIMITED",
"PSAN ADVISORS PRIVATE LIMITED",
"PSAV MARKETING LIMITED",
"PSB ALLIANCE PRIVATE LIMITED",
"PSB AUTOSALES PRIVATE LIMITED",
"PSB COMMODITIES LIMITED",
"PSB LOGISTICS PRIVATE LIMITED",
"PSB PAPERS PRIVATE LIMITED",
"PSB SECURITIES LIMITED",
"PSBEDI ARCHIVE PRIVATE LIMITED",
"PSBEDI SECURECOM PRIVATE LIMITED",
"PSBS INDUSTRIES PRIVATE LIMITED",
"PSC BIOTECH INDIA LLP",
"PSC INDUSTRIES PRIVATE LIMITED",
"PSC INFRACON PRIVATE LIMITED",
"PSC PLASTIC PRIVATE LIMITED",
"PSC PROPERTIES PRIVATE LIMITED",
"PSCMR COLLEGE OF ENGINEERING & TECHNOLOGY",
"PSCMR COLLEGE OF ENGINEERING AND TECHNOLOGY",
"PSCOPE TECHNOLOGIES PRIVATE LIMITED",
"PSE ADVISORY PRIVATE LIMITED",
"PSE INTERNATIONAL PRIVATE LIMITED",
"PSEARTH INFRASTRUCTURE PRIVATE LIMITED",
"PSEC POWER SYSTEM ENGINEERS & CONSULTANTS PRIVATE LIMITED",
"PSETALKS PRIVATE LIMITED",
"PSF MANAGEMENT SERVICES PRIVATE LIMITED",
"PSFW (STEELS) PRIVATE LIMITED",
"PSG COLLEGE OF ARTS &SCIENCE",
"PSG COLLEGE OF TECHNOLOGY",
"PSG ELECTRICALS PRIVATE LIMITED",
"PSG HOSPITALS",
"PSG INSTITUTE OF MANAGEMENT",
"PSG SARVAJANA HIGHER SECONDARY SCHOOL",
"PSG STONES LLP",
"PSGRK COLLEGE FOR WOMEN",
"PSH AIR PRIVATE LIMITED",
"PSH TECHNO ENGINEERING PRIVATE LIMITED",
"PSI CRO PHARMA INDIA PRIVATE LIMITED",
"PSI HEALTHCARE PRIVATE LIMITED",
"PSI METALS INDIA PRIVATE LIMITED",
"PSI STONES PRIVATE LIMITED",
"PSIBERTECH SOLUTIONS PRIVATE LIMITED",
"PSIL INDIA PRIVATE LIMITED",
"PSIOG DIGITAL P LIMITED",
"PSIS SECURITY & MANAGEMENT SERVICES PRIVATE LIMITED",
"PSIT COLLEGE OF ENGINEERING",
"PSJ BIOCHEM DIAGNOSTIC PRIVATE LIMITED",
"PSK COROFRAC LININGS PVT.LTD.",
"PSK ENGINEERING PRIVATE LIMITED",
"PSK INFRAPOWER PRIVATE LIMITED",
"PSK INFRASTRUCTURES AND PROJECTS PRIVATE LIMITED",
"PSK MINERAL DEVELOPEMENT PRIVATE LIMITED",
"PSK PHARMA PRIVATE LIMITED",
"PSK TEXTILES INDIA PRIVATE LIMITED",
"PSKARUN TEX PRIVATE LIMITED",
"PSKM SPINNING MILLS PRIVATE LIMITED",
"PSL ENGINEERING PRIVATE LTD",
"PSL INFRATECH PRIVATE LIMITED",
"PSL RETAIL PRIVATE LIMITED",
"PSL TEX-STYLES PRIVATE LIMITED",
"PSM ENTERPRISE PRIVATE LIMITED",
"PSM POLYTECH PRIVATE LIMITED",
"PSM SCIENTIFIC INSTRUMENTS PRIVATE LIMITED",
"PSMI MANAGEMENT INDIA PRIVATE LIMITED",
"PSN AUTOMOBILES PRIVATE LIMITED",
"PSN AUTOMOTIVE MARKETING PRIVATE LIMITED",
"PSN CONSTRUCTION EQUIPMENT PRIVATE LIMITED",
"PSN CONTAINER LINE PRIVATE LIMITED",
"PSN GREENS PRIVATE LIMITED",
"PSN INSTITUTE OF TECHNOLOGY AND SCIENCE",
"PSN MEDICARE PRIVATE LIMITED",
"PSN MOTORS PRIVATE LIMITED",
"PSN SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED",
"PSNA INVESTMENTS AND HOLDINGS PRIVATE LIMITED",
"PSP APPLIANCES PRIVATE LIMITED",
"PSP DYNAMIC LIMITED",
"PSP FINTECH CONSULTANTS PRIVATE LIMITED",
"PSP GLOBAL SERVICES PRIVATE LIMITED",
"PSP HI-TECH SERVICES PRIVATE LIMITED",
"PSP HOSPITALITY PRIVATE LIMITED",
"PSP INDUSTRIAL SOLUTIONS PRIVATE LIMITED",
"PSP INNOVATORS PRIVATE LIMITED",
"PSP PROJECTS & PROACTIVE CONSTRUCTIONS PRIVATE LIMITED",
"PSP PROJECTS LIMITED",
"PSP PUMPS PRIVATE LIMITED",
"PSP TECHNO ENGINEERS PRIVATE LIMITED",
"PSP TECHNOCADD ANCILLARY PRIVATE LIMITED",
"PSP TRADING PRIVATE LIMITED",
"PSPAPERS ( INDIA ) PRIVATE LIMITED",
"PSPL ADVERTISING PRIVATE LIMITED",
"PSPL INFOSYSTEMS PRIVATE LIMITED",
"PSPL STEEL PROCESSORS PRIVATE LIMITED",
"PSPN SYNERGY PRIVATE LIMITED",
"PSPR ENTERPRISES PRIVATE LIMITED",
"PSPRESS SERVICES PRIVATE LIMITED",
"PSR AND SONS",
"PSR AUTO COMPONENTS PRIVATE LIMITED",
"PSR CONSULTANCY SERVICES PRIVATE LIMITED",
"PSR DIAGNOSTIC PRIVATE LIMITED",
"PSR INFRA DEVELOPERS PRIVATE LIMITED",
"PSR IT SERVICES PRIVATE LIMITED",
"PSR METALS PRIVATE LIMITED",
"PSR POWER CONTROLS PRIVATE LIMITED",
"PSR POWER SYSTEMS RESEARCH INDIA PRIVATE LIMITED",
"PSR SILK SAREES INDIA PRIVATE LIMITED",
"PSR SOFT LABS PRIVATE LIMITED",
"PSR TOOLINGS AND STAMPINGS PRIVATE LIMITED",
"PSRI HOSPITAL",
"PSS LOGISTICS INDIA PRIVATE LIMITED",
"PSSATYAM STEEL INDUSTRIES PRIVATE LIMITED",
"PSSM MEDIA LIMITED",
"PSSVN AGRO CORPORATION PRIVATE LIMITED",
"PSTS LOGISTICS PRIVATE. LIMITED.",
"PSV AGRO PRODUCTS PRIVATE LIMITED",
"PSV COLLEGE OF ARTS AND SCIENCE",
"PSV MINES & MINERALS PRIVATE LIMITED",
"PSV PLASTICS PRIVATE LIMITED",
"PSV PROJECTS PRIVATE LIMITED",
"PSY AGRO FOOD INDUSTRY PRIVATE LIMITED",
"PSY INFRASTRUCTURE PRIVATE LIMITED",
"PSY METAL AND ALLOY PRIVATE LIMITED",
"PSYCHOCARE HEALTH PRIVATE LIMITED",
"PSYCHOLOGIST VOCATIONAL REHABILITATION CENTRE VRC FOR HANDICAPPED KOLKATA",
"PSYCHOTROPICS INDIA LIMITED",
"PSYCHROMETRIC SOLUTIONS & SYSTEMS PRIVATE LIMITED",
"PSYCO REMEDIES LIMITED",
"PSYNCOPATE TECHNOLOGIES PRIVATE LIMITED",
"PSYTECH INFOSOLUTIONS (INDIA) PRIVATE LIMITED",
"PT AGRO PRODUCTS PRIVATE LIMITED",
"PT BANK MAYBANK INDONESIA TBK INDIA",
"PT COMMUNICATION SYSTEMS PRIVATE LIMITED",
"PT DEENDAYAL UPADDHAYA SANATAN DHERM VIDYALAYA",
"PT DEENDAYAL UPADHYAY GOVT MODEL INTER COLLEGE TUKSAN HATHRAS",
"PT DEO KRISHNA INTER COLELGE",
"PT DR SHIVSHAKTILAL SHARMA AYURVEDIC COLLEGE &HOSPITAL",
"PT ECOLOGICAL SERVICES PRIVATE LIMITED",
"PT EXPRESS LINES P LIMITED",
"PT INDO LIBERTY TEXTILES",
"PT INVENT INDIA PRIVATE LIMITED",
"PT JAWAHAR LAL NEHRU INTER COLLEGE",
"PT KHUSHILAL SHARMA ARYUVEDIC COLLEGE AN",
"PT MADAN MOHAN MALVIYA HOSPITAL",
"PT MATERIALS TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"PT WORKS PRIVATE LIMITED",
"PT. BARA DAYA ENERGI INDIA PRIVATE LIMITED",
"PT. DEEN DAYAL UPADHYAY SHIKSHAN TRUST",
"PT. GARUDA SPINTEX PRIVATE LIMITED",
"PT. INFOTECH SOLUTIONS PRIVATE LIMITED",
"PTA DESIGNS PRIVATE LIMITED",
"PTC AVIATION ACADEMY",
"PTC CABLES PVT LTD",
"PTC COMTRADE (INDIA) PRIVATE LIMITED",
"PTC ELECTRIC PRIVATE LIMITED",
"PTC ENERGY LIMITED",
"PTC HOLIDAYS PRIVATE LIMITED",
"PTC INDIA FINANCIAL SERVICES LIMITED",
"PTC INDIA LIMITED",
"PTC INDUSTRIES LIMITED",
"PTC SOFTWARE INDIA PRIVATE LIMITED",
"PTCG INDIA PRIVATE LIMITED",
"PTCL INFRASTRUCTURE LIMITED",
"PTD CLEANTECH SOLUTIONS PRIVATE LIMITED",
"PTERIS GLOBAL INTEGRATED SOLUTION INDIA PRIVATE LIMITED",
"PTG TECHNOPAK PRIVATE LIMITED",
"PTHRUP SOLUTIONS PRIVATE LIMITED",
"PTI ENGINEERING TECHNOLOGIES PRIVATE LIMITED",
"PTIC CORPORATE SERVICES PRIVATE LIMITED",
"PTK AGRO FOODS PRIVATE LIMITED",
"PTK PROJECT CONSULTANTS LLP",
"PTL ENTERPRISES LIMITED",
"PTL GOOD SHEPHERD SCHOOL",
"PTL INDIA PRIVATE LIMITED",
"PTL SOLAR ENERGY PRIVATE LIMITED",
"PTLD BROADCASTING PRIVATE LIMITED",
"PTM PROJECTS PRIVATE LIMITED",
"PTP CNC TOOLINGS PRIVATE LIMITED",
"PTPL TUBING & PRODUCTS PRIVATE LIMITED",
"PTRONICS ATM SERVICES PRIVATE LIMITED",
"PTS AUTOMATION PRIVATE LIMITED",
"PTS CONSULTING SERVICES PRIVATE LIMITED",
"PTS DIAGNOSTICS INDIA PRIVATE LIMITED",
"PTS HITECH PROJECTS INDIA PRIVATE LIMITED",
"PTS SYSTEMS & SOLUTIONS PRIVATE LIMITED",
"PTSAPAC LOGISTICS PRIVATE LIMITED",
"PTVA INSTITUTE OF MANAGEMENT",
"PTW DOSIMETRY INDIA PRIVATE LIMITED",
"PTWI INDIA PRIVATE LIMITED",
"PTWOD SMART SOLUTIONS PRIVATE LIMITED",
"PU DONGAREJI MAHARAJ PRI SCHOOL MORNING",
"PU QUALITY WALK PRIVATE LIMITED",
"PU RESINS PRIVATE LIMITED",
"PU SWAMI GANGAPURIJI ADARSH VIDHYALAY NUGAR",
"PUB HOUSING WELFARE DEPT GOVT OF MAH",
"PUBER KALOM PUBLICATIONS PRIVATE LIMITED",
"PUBERT INDIA PRIVATE LIMITED",
"PUBERUN REAL ESTATE PRIVATE LIMITED",
"PUBLIC CLOTHINGS PRIVATE LIMITED",
"PUBLIC ENGLISH HIGH SCHOOL & JR COLLEGE",
"PUBLIC FINANCIAL MANAGEMENT SYSTEM",
"PUBLIC HEALTH & FAMILY WELFARE DEPARTMENT BLOCK MEDICAL OFFICER KARTALA",
"PUBLIC HEALTH & FAMILY WELFARE DEPARTMENT HOSPITAL SUPERINTENDENT GOVT MEDIACL COLLEGE RELETED HOSPITAL KORBA",
"PUBLIC HEALTH & FAMILY WELFARE DEPARTMENT PRINCIPAL SUPDT GOVT AYURVEDIC COLLEGE",
"PUBLIC HEALTH AND FAMILY WELFARE DEPARTEMNT GOVERNMENT MALE HEALTH WORKER TRAINING CENTER",
"PUBLIC HEALTH AND FAMILY WELFARE DEPARTMENT BLOCK MEDICAL OFFICE ODGI",
"PUBLIC HEALTH DEPARTMENT GOVRMENT OF MAHARASTRA",
"PUBLIC HEALTH DEPT GOVT OF MAHARASHTRA",
"PUBLIC HEALTH ENGINEERING DEPARTMENT",
"PUBLIC HEALTH FOUNDATION OF INDIA",
"PUBLIC INTER COLLEGE SADHOLI KADEEM SAHARANPUR",
"PUBLIC TRUSTS REGISTRATION OFFICE",
"PUBLIC WORKS DEPARTMENT",
"PUBLIC WORKS DEPARTMENT ( MANTRALAYA)",
"PUBLIC WORKS DEPARTMENT JALNA",
"PUBLICIS COMMUNICATION PRIVATE LIMITED",
"PUBLICIS GROUPE",
"PUBLICIS SAPIENT A DIVISION OF TLG INDIA PRIVATE LIMITED",
"PUBLICITY AND CONSULTANT PRIVATE LIMITED",
"PUBLISH-INDUSTRY INDIA PRIVATE LIMITED",
"PUBLIX REALTORS AND FACILITATORS PRIVATE LIMITED",
"PUBLIX SUPER MARKETS INC.",
"PUBMATIC INDIA PRIVATE LIMITED",
"PUCCHU MILK FOODS PRIVATE LIMITED",
"PUDAMI CHIT FUNDS PRIVATE LIMITED",
"PUDDING AND PIE INDIA PRIVATE LIMITED",
"PUDHARI PRESS",
"PUDHARI PUBLICATIONS PRIVATE LIMITED",
"PUDUCHERRY ST WEAVER COOP SOC LIMITED",
"PUDUGAI STAR HOSPITALS PRIVATE LIMITED",
"PUDUKKOTTAI ORGANIC FARMERS PRODUCER COMPANY LIMITED",
"PUDUKOTTAI DIST CO-OP UNION LIMITED",
"PUDUMJEE INDUSTRIES LIMITED",
"PUDUMJEE PAPER PRODUCTS LIMITED",
"PUDUMJEE PULP AND PAPER MILLS LIMITED",
"PUG SECURITIES",
"PUGALUR RENEWABLE PRIVATE LIMITED",
"PUGAZH CHEMICAL PLANT AND EQUIPMENTS PRIVATE LIMITED",
"PUGMARK FILMS PRIVATE LIMITED",
"PUGMARKS INDUSTRIES PRIVATE LIMITED",
"PUGMARKS INTERWEB PRIVATE LIMITED",
"PUGOS PRODUCTS PRIVATE LIMITED",
"PUINTOLA TOLLWAY PRIVATE LIMITED",
"PUISSANT GLOBAL PRIVATE LIMITED",
"PUJA AGENCIES PVT LTD",
"PUJA AGRO FOOD PRIVATE LIMITED",
"PUJA ARTI PLY PRODUCTS PRIVATE LIMITED",
"PUJA ENTERPRISES PRIVATE LIMITED",
"PUJA ENTERTAINMENT (INDIA) LIMITED",
"PUJA FLUID SEALS PRIVATE LIMITED",
"PUJA FOOD PRODUCTS PRIVATE LIMITED",
"PUJA INDUSTRIES",
"PUJA JEWELCRAFTS PRIVATE LIMITED",
"PUJA MINERALS PVT. LTD",
"PUJA PRINTECH PRIVATE LIMITED",
"PUJA SPINTEX PRIVATE LIMITED",
"PUJA SYNTHETICS PRIVATE LIMITED",
"PUJA VANIJYA VINIYOG LTD",
"PUJAA SHREE GREEN POWER PRIVATE LIMITED",
"PUJAN INVESTMENT & FINANCE PRIVATE LIMITED",
"PUJARA AND SONS PRIVATE LIMITED",
"PUJARA ENTERPRISE PRIVATE LIMITED",
"PUJARA FOODS LLP",
"PUJARA GLOBAL EXPORTS PRIVATE LIMITED",
"PUJAYITA SANI TRADING PRIVATE LIMITED",
"PUKHRAJ ADDITIVES LLP",
"PUKHRAJ CAPITAL AND SHARE BROKING PRIVATE LIMITED",
"PUKHRAJ ENGINEERING AND CHEMICALS PRIVATE LIMITED",
"PUKHRAJ GEMS EXPORTS PRIVATE LIMITED",
"PUKHRAJ HEALTHCARE PRIVATE LIMITED",
"PUKHRAJ HOMES PRIVATE LIMITED",
"PUKHRAJ RAICHAND GENERAL HOSPITAL",
"PUKHRAJ TELECOM PRIVATE LIMITED",
"PUKHRAYAN RICE MILL PRIVATE LIMITED",
"PUKHYA PRIVATE LIMITED",
"PULAKESHIN PRIVATE LIMITED",
"PULCRA CHEMICALS INDIA PRIVATE LIMITED",
"PULHANT MARKETING PRIVATE LIMITED",
"PULIBOR TEA PRIVATE LIMITED",
"PULIKEEZHU METALS PRIVATE LIMITED",
"PULIKKAL MEDICAL FOUNDATION",
"PULIKKOTTIL DEVICES DISTRIBUTORS PRIVATE LIMITED",
"PULIKKOTTIL LAZAR & SONS JEWELLERY PRIVATE LIMITED",
"PULIMOOTTIL BUSINESS COMBINES PRIVATE LIMITED",
"PULIMOOTTIL SILKS AND APPAREL PRIVATE LIMITED",
"PULIMOOTTIL SILKS AND SAREES PRIVATE LIMITED",
"PULIMOOTTIL SILKS KOTTAYAM",
"PULIN INVESTMENTS PRIVATE LIMITED",
"PULIN PHARMACEUTICALS PRIVATE LIMITED",
"PULINDI TRADING PRIVATE LIMITED",
"PULISI TECHNOLOGY PRIVATE LIMITED",
"PULIVARTHI CONSULTING INDIA PRIVATE. LIMITED.",
"PULIYANMALA PLANTERS CHEMICALS AND AGRO INPUTS PRIVATE LIMITED",
"PULIZIA FM SERVICES PRIVATE LIMITED",
"PULKIT DEALTRADE PRIVATE LIMITED",
"PULKIT ENERGY PRIVATE LIMITED",
"PULKIT ENGINEERING PRIVATE LIMITED",
"PULKIT HOLDINGS PVT.LTD.",
"PULKIT INDUSTRIES PRIVATE LIMITED",
"PULKIT MADHYAMIK SHALA",
"PULKIT MEDIA PRIVATE LIMITED",
"PULKIT METALS PRIVATE. LIMITED.",
"PULKIT PROJECTS PRIVATE LIMITED",
"PULKIT REALBUILD PRIVATE LIMITED",
"PULKIT SCHOOL",
"PULKIT VENEER MILLS PVT LTD",
"PULLA REDDY COLLEGE OF PHARMACY",
"PULLANI AUTO INDUSTRIES PRIVATE LIMITED",
"PULLANI ENGINEERS PRIVATE LIMITED",
"PULLAREDDY DEGREE & P G COLLEGE",
"PULLEN PUMP INDUSTRIES PVT LTD",
"PULL-MAC MACHINES PRIVATE LIMITED",
"PULLMAN ENGINEERING CO PVT LTD",
"PULLURI MINING & LOGISTICS PRIVATE LIMITED",
"PULMOCARE RESEARCH AND EDUCATION FOUNDATION",
"PULMONIX HEALTHCARE PRIVATE LIMITED",
"PULP N.PACK PVT LTD",
"PULP STRATEGY COMMUNICATIONS PRIVATE LIMITED",
"PULRAJ ELECTRONICS PVT LTD",
"PULSAR CERAMIC",
"PULSAR COATING EQUIPMENTS PRIVATE LIMITED",
"PULSAR COMMERCE PRIVATE LIMITED",
"PULSAR ELECTRONICS PRIVATE LIMITED",
"PULSAR ENTERPRISES PRIVATE LIMITED",
"PULSAR KNOWLEDGE CENTRE PRIVATE LIMITED",
"PULSAR RUBBER MANUFACTURING COMPANY PVT LTD",
"PULSATOM HEALTH CARE PRIVATE LIMITED",
"PULSE COMMS INDIA PRIVATE LIMITED",
"PULSE COMMUNICATION SYSTEMS PRIVATE LIMITED",
"PULSE DIAGNOSTIC CENTER",
"PULSE DIAGNOSTICS PRIVATE LIMITED",
"PULSE E TECHNOLOGIES PRIVATE LIMITED",
"PULSE ENGINEERING PRIVATE LIMITED",
"PULSE HITECH HEALTH SERVICES PRIVATE LIMITED",
"PULSE HITECH MEDICAL CENTER PRIVATE LIMITED",
"PULSE HOSPITAL AND TRUMA CENTER",
"PULSE HOSPITALITY PRIVATE LIMITED",
"PULSE HOSPITALS",
"PULSE IMAGING PRIVATE LIMITED",
"PULSE MAGNETIC AND POWER ELECTRONICS PRIVATE LIMITED",
"PULSE MEDIA PRIVATE LIMITED",
"PULSE POWER TECHNOLOGIES PVT LTD",
"PULSE SANJEEVANI HEALTHCARE PRIVATE LIMITED",
"PULSE SECURE TECHNOLOGIES INDIA PRIVATE LIMITED",
"PULSE SOLAR SYSTEMS PRIVATE LIMITED",
"PULSE SPORTS PRIVATE LIMITED",
"PULSE SUPER SPECIALITY HOSPITAL",
"PULSE TELESYSTEMS PRIVATE LIMITED",
"PULSE VOICE INDIA PRIVATE LIMITED",
"PULSE WEDDING PLANNER PRIVATE LIMITED",
"PULSECHO SYSTEMS (BOMBAY) PRIVATE LIMITED",
"PULSUS HEALTHCARE PRIVATE LIMITED",
"PULWIN PHARMA PRIVATE LIMITED",
"PUMA CROP CARE",
"PUMA ENERGY INDIA PRIVATE LIMITED",
"PUMA ENERGY PROCESSING SERVICES LLP",
"PUMA EXPORTS PVT LTD",
"PUMA INDIA RETAIL PRIVATE LIMITED",
"PUMA LIFT TRUCKS PRIVATE LIMITED",
"PUMA SPORTS INDIA PRIVATE LIMITED",
"PUMA TOOLS PRIVATE LIMITED",
"PUMARTH CREDIT AND CAPITAL LIMITED",
"PUMARTH INFRASTRUCTURE PRIVATE LIMITED",
"PUMARTH MEADOWS PRIVATE LIMITED",
"PUMAX CHEMICALS PRIVATE LIMITED",
"PUMEX INFOTECH PRIVATE LIMITED",
"PUMP HOUSE PRIVATE LIMITED",
"PUMPKIN PATCH DAYCARE PRIVATE LIMITED",
"PUMPKIN PATCH PRIVATE LIMITED",
"PUMPKIN PRODUCTIONS PRIVATE LIMITED",
"PUMPMYFUNNEL MARKETING PRIVATE LIMITED",
"PUMPSENSE FLUID ENGINEERING PRIVATE LIMITED",
"PUN INFONET PRIVATE LIMITED",
"PUNAGRI ORGANICS AND LIFESCIENCES PRIVATE LIMITED",
"PUNAM ENERGY PRIVATE LIMITED",
"PUNAM SYNTEX PRIVATE LIMITED",
"PUNAM TUBES PRIVATE. LIMITED.",
"PUNAMCHAND JEWELLERS AND SONS PRIVATE LIMITED",
"PUNAMCHAND JEWELLERS PRIVATE LIMITED",
"PUNAMIA OVERSEAS PRIVATE LIMITED",
"PUNAMIYA & SONS JEWELLERS PRIVATE LIMITED",
"PUNAMIYA MEDICARE PRIVATE LIMITED",
"PUNARNAVA AYURVEDA LIMITED",
"PUNARVASU AUSHADHSHALA PRIVATE LIMITED",
"PUNARVASU CONSTRUCTIONS PRIVATE LIMITED",
"PUNARVASU FINANCIAL SERVICES PRIVATE LIMITED",
"PUNARVASU GRAPHICS PRIVATE LIMITED",
"PUNARVI PROJECTS PRIVATE LIMITED",
"PUNCH & PACK BOARDS PRIVATE LIMITED",
"PUNCH INDUSTRY INDIA PRIVATE LIMITED",
"PUNCH IT TECHNOLOGIES PRIVATE LIMITED",
"PUNCH RATNA FASTENERS PRIVATE LIMITED",
"PUNCH RATNA STEELS PRIVATE LIMITED",
"PUNCHH TECH INDIA PRIVATE LIMITED",
"PUNCHLINE PAPER CONVERTERS PRIVATE LIMITED",
"PUNCHMURTI INFRA PRIVATE LIMITED",
"PUNCTUAL PROPERTIES PRIVATE LIMITED",
"PUNCTUAL TRADING LIMITED",
"PUNCTUATIONS SOLUTIONS PRIVATE LIMITED",
"PUNDRIK TEXTILE MILLS PRIVATE LIMITED",
"PUNDRIKAKSH DEVELOPERS PRIVATE LIMITED",
"PUNDRIKAKSH GRANITES PRIVATE LIMITED",
"PUNE (PURANDAR) INTERNATIONAL AIRPORT LIMITED",
"PUNE ABRASIVES PRIVATE LIMITED",
"PUNE ACADEMY OF DESIGN AND COMMUNICATION PRIVATE LIMITED",
"PUNE ANAESTHESIA AND CRITI-CARE PRIVATE LIMITED",
"PUNE AUPAC PRIVATE LIMITED",
"PUNE BIO-ENERGY SYSTEMS PRIVATE LIMITED",
"PUNE BP DEVELOPMENT PRIVATE LIMITED",
"PUNE BUSINESS SCHOOL",
"PUNE BUSINESS SPACES PRIVATE LIMITED",
"PUNE CANTONMENT BOARD",
"PUNE CARBONS PRIVATE LIMITED",
"PUNE CHEST GENERAL HOSPITAL",
"PUNE DISTRICT CENTRAL COOPERATIVE BANK LTD",
"PUNE DISTRICT EDUCATION ASSOCIATION",
"PUNE E - STOCK BROKING LIMITED",
"PUNE ENERGY CONTROL DEVICES PVT LTD",
"PUNE ENGINEERING AND TESTING SERVICES PRIVATE LIMITED",
"PUNE EXPRESS INFRASTRUCTURE PRIVATE LIMITED",
"PUNE FIN TUBE PVT LTD",
"PUNE FINVEST LIMITED",
"PUNE GAS PROJECTS PRIVATE LIMITED",
"PUNE GAS SYSTEMS PRIVATE LIMITED",
"PUNE HANGUG HOSPITALITY PRIVATE LIMITED",
"PUNE HEAT TREAT PRIVATE LIMITED",
"PUNE HI-TECH GAS PRIVATE LIMITED",
"PUNE HYDRAULICS SYSTEMS PRIVATE LIMITED",
"PUNE IDEA FACTORY FOUNDATION",
"PUNE INSTITUTE OF AVIATION TECHNOLOGY",
"PUNE INSTITUTE OF BUSINESS MANAGEMENT",
"PUNE INSTITUTE OF COMPUTER TECHNOLOGY",
"PUNE INSTITUTE OF NEUROLOGY",
"PUNE INTELLIGENT SECURITY PRIVATE LIMITED",
"PUNE INTERNATIONAL SCHOOL & JR. COLLEGE",
"PUNE IT CITY METRO RAIL LIMITED",
"PUNE IT SHOP PRIVATE LIMITED",
"PUNE IT SPACE SOLUTIONS PRIVATE LIMITED",
"PUNE JILHA SHIKSHAN MANDAL SHANKARRAO BHELKE COLLEGE",
"PUNE KONDHWA REALTY PRIVATE LIMITED",
"PUNE MAHANAGAR PALIKA",
"PUNE MAHANAGAR PARIVAHAN MAHAMANDAL LIMITED",
"PUNE MARKETING PRIVATE LIMITED",
"PUNE MATHADI HAMAL AND ITAR SHRAMJIVI KAMGAR MANDAL",
"PUNE METROPOLITAN REGION DEVELOPMENT AUTHORITY",
"PUNE MUNICIPAL CORPORATION",
"PUNE MUNICIPAL CORPORATION PMC",
"PUNE MUNICIPAL CORPORATION SERVANTS CO OP URBAN BANK LTD",
"PUNE POLICE PUBLIC SCHOOL",
"PUNE POLYMERS P LIMITED",
"PUNE POLYMERS P LTD",
"PUNE POLYTECH PRIVATE LIMITED",
"PUNE POLYTRONICS PRIVATE LIMITED",
"PUNE PROJECTS LLP",
"PUNE PUMPS SALES AND SERVICES PRIVATE LIMITED",
"PUNE REALTY MAINTENANCE SERVICES PRIVATE LIMITED",
"PUNE RURAL MARKETING",
"PUNE SHOLAPUR ROAD DEVELOPMENT COMPANY LIMITED",
"PUNE SMART CITY DEVELOPMENT CORPORATION LIMITED",
"PUNE SOLAPUR EXPRESSWAYS PRIVATE LIMITED",
"PUNE TECHTROL PRIVATE LIMITED",
"PUNE TEXTILE MARKET PRIVATE LIMITED",
"PUNE URBAN CO OPERATIVE BANK",
"PUNE VIDYARTHI GRIHA S COLLEGE OF ENGG",
"PUNEET AGENCY PRIVATE LIMITED",
"PUNEET AUTOMOBILES PRIVATE LIMITED",
"PUNEET CARS SALES PRIVATE LIMITED",
"PUNEET COTTON PRIVATE LIMITED",
"PUNEET EDIFICE PRIVATE LIMITED",
"PUNEET ELECTRICALS PRIVATE LIMITED",
"PUNEET ENTERPRISES",
"PUNEET INDIA PRIVATE LIMITED",
"PUNEET INDUSTRIES PRIVATE LIMITED",
"PUNEET IRON AND STEEL PRIVATE LIMITED",
"PUNEET LABORATORIES PRIVATE LIMITED",
"PUNEET SECURITIES PRIVATE LIMITED",
"PUNEET STEELS AND ALLOYS PRIVATE LIMITED",
"PUNEET SYNTEX PRIVATE LIMITED",
"PUNEETH RAJKUMAR P U COLLGE",
"PUNEKAR JEWELLERS PRIVATE LIMITED",
"PUNGLIA MARBLES PRIVATE LIMITED",
"PUNHANI GROUP HOLDING PRIVATE LIMITED",
"PUNIA POULTRIES PRIVATE LIMITED",
"PUNIHANI INTERNATIONAL",
"PUNIKIM TEXTILES PRIVATE LIMITED",
"PUNIRGAURAV DEVELOPERS PRIVATE LIMITED",
"PUNISKA INDUSTRIES PRIVATE LIMITED",
"PUNIT BALAN STUDIOS PRIVATE LIMITED",
"PUNIT CREATIONS",
"PUNIT FINTRADE PRIVATE LIMITED",
"PUNIT INFRACON PRIVATE LIMITED",
"PUNIT POLYFAB PRIVATE LIMITED",
"PUNIT PROTEINS PRIVATE LIMITED",
"PUNIYA RUMALI H S S RANHERA MATHURA",
"PUNJ AUTOS PRIVATE LIMITED",
"PUNJ LLOYD INDUSTRIES LIMITED",
"PUNJ LLOYD SOLAR POWER LIMITED",
"PUNJ MOTORS PRIVATE LIMITED",
"PUNJ SOFTECH PRIVATE LIMITED",
"PUNJA PETROKEM ENGINEERING PRIVATE LIMITED",
"PUNJAB & SIND BANK",
"PUNJAB ABRASIVES LTD",
"PUNJAB ACIDS CHEM PRIVATE LIMITED",
"PUNJAB AGRI EXPORT CORPORATION LIMITED",
"PUNJAB AGRO FOODGRAINS CORPORATION LIMITED",
"PUNJAB AGRO SOLUTIONS PRIVATE LIMITED",
"PUNJAB ASHOK HOTEL COMPANY LIMITED",
"PUNJAB AUTO MOBILE AGENCIES PRIVATE LIMITED",
"PUNJAB AUTOMOBILES INDIA PRIVATE LIMITED",
"PUNJAB BEVEL GEARS LTD",
"PUNJAB CARBONIC PRIVATE LIMITED",
"PUNJAB CARS PRIVATE LIMITED",
"PUNJAB CHEMICALS & CROP PROTECTION LIMITED",
"PUNJAB CHEMICALS AND CROP PROTECTION LIMITED",
"PUNJAB COMMUNICATIONS LIMITED",
"PUNJAB DIESELS PRIVATE LIMITED",
"PUNJAB DISTRIBUTORS PRIVATE LIMITED",
"PUNJAB DYERS ASSOCIATION",
"PUNJAB ENGINEERING COLLEGE CHANDIGARH",
"PUNJAB EYE HOSPITAL",
"PUNJAB FARM EQUIPMENTS PRIVATE LIMITED",
"PUNJAB FASHION PRIVATE LIMITED",
"PUNJAB FC PRIVATE LIMITED",
"PUNJAB FINANCIAL CORPORATION CHANDIGARH",
"PUNJAB FUSION PRIVATE LIMITED",
"PUNJAB GAS CYLINDERS LIMITED",
"PUNJAB GENERAL INDUSTRIES PRIVATE LIMITED",
"PUNJAB GOODSMOVERS PRIVATE LIMITED",
"PUNJAB GOVT COOPERATIVE DEPARTMENT",
"PUNJAB GOVT DEPARTMENT",
"PUNJAB GRAMIN BANK",
"PUNJAB HAMMERS PRIVATE LIMITED",
"PUNJAB HYDRAULICS PVT. LTD.",
"PUNJAB HYDRO POWER PRIVATE LIMITED",
"PUNJAB INFRASTRUCTURE DEVELOPMENT BOARD",
"PUNJAB JEWELLERS PRIVATE LIMITED",
"PUNJAB KASHMIR FINANCE LIMITED",
"PUNJAB KESARI PUBLISHERS PRIVATE LIMITED",
"PUNJAB LAMINATES PVT LTD",
"PUNJAB LOGISTICS INFRASTRUCTURE LIMITED",
"PUNJAB MACHINERY WORKS PVT LTD",
"PUNJAB MANDI BOARD",
"PUNJAB METAL WORKS PRIVATE LIMITED",
"PUNJAB MILK FOOD CO. PRIVATE LIMITED",
"PUNJAB MOTOR WORKS LCV DIVN",
"PUNJAB NATIONAL BANK",
"PUNJAB OIL MILLS PVT LTD",
"PUNJAB PAINT COLOUR & VARNISH WORKS PVT LTD",
"PUNJAB PAPER MILLS PRIVATE LIMITED",
"PUNJAB PESTICIDE IND. COOP SOCIETY LTD",
"PUNJAB PESTICIDES INDUSTERIES PRIVATE LIMITED",
"PUNJAB PLASTOFAB PVT LTD",
"PUNJAB POLICE HOUSING CORPORATION LTD",
"PUNJAB POLLUTION CONTROL BOARD",
"PUNJAB PRODUCE HOLDINGS LIMITED",
"PUNJAB PUBLIC SCHOOL",
"PUNJAB PUBLIC SENIOR SECONDARY SCHOOL",
"PUNJAB RELIABLE INVESTMENTS PVT LTD",
"PUNJAB RENEWABLE ENERGY SYSTEMS PRIVATE LIMITED",
"PUNJAB RETAIL PRIVATE LIMITED",
"PUNJAB RICELAND AGRO FOODS PRIVATE LIMITED",
"PUNJAB RICELAND PRIVATE LIMITED",
"PUNJAB SAMAGRA SHIKSHA ABHIYAN SOCIETY PUNJAB SCHOOL EDUCATION BOARD",
"PUNJAB SAW MILLS PRIVATE LIMITED",
"PUNJAB SILAGE PRIVATE LIMITED",
"PUNJAB SILK STORE PRIVATE LIMITED",
"PUNJAB SIND DAIRY PRODUCTS PRIVATE LIMITED",
"PUNJAB SIND FOODS (INDIA) PRIVATE LIMITED",
"PUNJAB SINDH BANK",
"PUNJAB SMALL INDUSTRIES AND EXPORT CORPORATION LIMITED",
"PUNJAB STATE AGRICULTURAL MARKETING BOARD",
"PUNJAB STATE CIVIL SUPPLIES CORPORATION LIMITED",
"PUNJAB STATE FOREST DEVELOPMENT CORPORATION LIMITED",
"PUNJAB STATE POWER CORPORATION LIMITED",
"PUNJAB STATE TRANSMISSION CORPORATION LIMITED",
"PUNJAB STATE WAREHOUSING CORPORATION",
"PUNJAB STEEL ROLLING MILLS (BARODA) PRIVATE LIMITED",
"PUNJAB TRANSFORMERS AND ELECTRONICS LIMITED",
"PUNJAB UNIVERSITY",
"PUNJAB VELOCITY PRIVATE LIMITED",
"PUNJAB WASTE PLANT CO PRIVATE LIMITED",
"PUNJAB WATER RESOURCES MANAGEMENT & DEVELOPMENT CO",
"PUNJABBULLS TECHNOLOGY PRIVATE LIMITED",
"PUNJABEXPO BREWERIES PRIVATE LIMITED",
"PUNJABI ACADEMY",
"PUNJABI ACCESSORIEZZ PRIVATE LIMITED",
"PUNJABI GHASITARAM HALWAI PRIVATE LIMITED",
"PUNJABI UNIVERSITY PATIALA",
"PUNJABI-CHAAP CORNER PRIVATE LIMITED",
"PUNJAB'S AGROTECH INDIA PRIVATE LIMITED",
"PUNJABSIND FARMER PRODUCER COMPANY LIMITED",
"PUNJANI GRAPHICS PRIVATE LIMITED",
"PUNJANI MERCANTILES PRIVATE LIMITED",
"PUNJI FINANCIAL AND HIRE PURCHASE SERVICES PRIVATE LIMITED",
"PUNJIBOX TECHNOLOGIES PRIVATE LIMITED",
"PUNJLAND BEVERAGES PRIVATE LIMITED",
"PUNJNAD AUTO AND RUBBER INDUSTRIES PVT LTD",
"PUNLAND TINT INDUSTRIES PRIVATE LIMITED",
"PUNNAMADA RESORTS PRIVATE LIMITED",
"PUNRASAR MARKETING PRIVATE LIMITED",
"PUNTA INDIA PRIVATE. LIMITED-IT",
"PUNYA AUTOMOBILES PRIVATE LIMITED",
"PUNYA AUTOMOTIVES PRIVATE LIMITED",
"PUNYA BUILDEVENT PRIVATE LIMITED",
"PUNYA COAL ROADLINES",
"PUNYA HERBALS PRIVATE LIMITED",
"PUNYA LAKSHMI HOTEL PRIVATE LIMITED",
"PUNYA MOTORS PRIVATE LIMITED",
"PUNYASHILA MOTORS PRIVATE LIMITED",
"PUNYASHLOK AGRO PRODUCER COMPANY LIMITED",
"PUP EXPORTS PRIVATE LIMITED",
"PUP SCHOOL-GOVT OF TAMILNADU",
"PUPA HOME CARE PRIVATE LIMITED",
"PUPIL ABROAD EDUCATIONAL CONSULTANTS",
"PUPILSHARE PRIVATE LIMITED",
"PUPNEJA RICE MILLS",
"PUPSCRIBE ENTERPRISES PRIVATE LIMITED",
"PUR ENERGY PRIVATE LIMITED",
"PURABHI HOSPITALITY PRIVATE LIMITED",
"PURAFIL ENGINEERS (INDIA) PRIVATE LIMITED",
"PURAK TRADING PVT LTD",
"PURAMATE INDIA PRIVATE LIMITED",
"PURAN ASSOCIATES PRIVATE LIMITED",
"PURAN CHAND RICE MILLS PRIVATE LIMITED",
"PURAN MURTI EDUCATIONAL SOCIETY",
"PURAN STORE PRIVATE LIMITED",
"PURANCHANDRA VIDYAANIKTAN",
"PURANDAR CONSTRUCTION PRIVATE LIMITED",
"PURANDAR HIGHLANDS FARMERS PRODUCER COMPANY LIMITED",
"PURANDAR INVESTMENT PVT LTD",
"PURANDAR MEDICAL FOUNDATION PRIVATE LIMITED",
"PURANDARA LASER TECHNOLOGIES PRIVATE LIMITED",
"PURANDARPUR HHD HIGH SCHOOL HS",
"PURANDHAR PUBLICITY PRIVATE LIMITED",
"PURANI HOSPITAL SUPPLIES LIMITED",
"PURANI HOSPITAL SUPPLIES PRIVATE LIMITED",
"PURANI TEXTILES PRIVATE LIMITED",
"PURANIK BUILDCON PRIVATE LIMITED",
"PURANIK BUILDERS LIMITED",
"PURANMAL FOODS INDIA PRIVATE LIMITED",
"PURANMAL PHOOLA DEVI MEMORIAL TRUST",
"PURATAN METAL BOX PRIVATE LIMITED",
"PURATAN QILA PRIVATE LIMITED",
"PURATAN RAMGARH FP SCHOOL",
"PURATECH SOLUTIONS INDIA PRIVATE LIMITED",
"PURATOS FOOD INGREDIENTS INDIA PRIVATE LIMITED",
"PURAV COTTON INDUSTRIES",
"PURAV POLYMERS PRIVATE LIMITED",
"PURAVALAN FREIGHT FORWARDERS PRIVATE LIMITED",
"PURAVANKARA LIMITED",
"PURBA BHARATI GAS PRIVATE LIMITED",
"PURBA KALIKATA ADARSHA VIDYAMANDIR",
"PURBA PROJECTS PRIVATE LIMITED",
"PURBA TEA EXPORTS PRIVATE LIMITED",
"PURBABARDHAMAN AGRO PRIVATE LIMITED",
"PURBAJYOTI HEALTH CARE PRIVATE LIMITED",
"PURBANCHAL CEMENT LTD",
"PURBANCHAL COMPOSITE PANEL (INDIA) PRIVATE LIMITED",
"PURBANCHAL CONCAST PRIVATE LIMITED",
"PURBANCHAL KRISHI VIKAS PVT LTD",
"PURBANCHAL LAMINATES PRIVATE LIMITED",
"PURBANCHAL LUMBERS PRIVATE LIMITED",
"PURBASHA FOODS PRIVATE LIMITED",
"PURBASHA PLANTATIONS & TEA INDUSTRIES PVT LTD",
"PURCHASING POWER IT & BUSINESS SOLUTIONS INDIA LLP",
"PURDROP BIOCHEM PRIVATE LIMITED",
"PURE - SOURCE CLOTHING PRIVATE LIMITED",
"PURE & CURE HEALTHCARE PRIVATE LIMITED",
"PURE ALUMINIUM WORKS PRIVATE LIMITED",
"PURE AND HEALTHY INDOORS PRIVATE LIMITED",
"PURE BLEND WEAVING INDUSTRIES PRIVATE LIMITED",
"PURE BOTANICAL CARE PRIVATE LIMITED",
"PURE BROKING PRIVATE LIMITED",
"PURE CARS PRIVATE LIMITED",
"PURE CHEMICALS CO",
"PURE CHEMICALS LABORATORIES PRIVATE LIMITED",
"PURE CLEAN & CLEAR SOLUTIONS INDIA PRIVATE LIMITED",
"PURE COTTON PRIVATE LIMITED",
"PURE CROP SCIENCES PRIVATE LIMITED",
"PURE DAIRY SOLUTIONS PRIVATE LIMITED",
"PURE DIA-JEWEL PRIVATE LIMITED",
"PURE DIAMOND TEXTILES PRIVATE LIMITED",
"PURE DIETS INDIA LIMITED",
"PURE EARTH RECYCLERS PRIVATE LIMITED",
"PURE EAT INDIA PRIVATE LIMITED",
"PURE EM LIFE SCIENCE INDIA PRIVATE LIMITED",
"PURE FEEDS AND FOODS PRIVATE LIMITED",
"PURE FLAMES APPLIANCES PRIVATE LIMITED",
"PURE FURNISHING PRIVATE LIMITED",
"PURE GOLD JEWELLERS AND DIAMONDS INDIA PRIVATE LIMITED",
"PURE ID PRIVATE LIMITED",
"PURE IMPRESSIONS PRINTECH PRIVATE LIMITED",
"PURE INCENSE PRIVATE LIMITED",
"PURE INDUSTRIAL GASES PRIVATE LIMITED",
"PURE LEATHER PRIVATE LIMITED",
"PURE LIFE OFFICE SYSTEMS PRIVATE LIMITED",
"PURE LIVING LIFESTYLES PRIVATE LIMITED",
"PURE N SAFE PRIVATE LIMITED",
"PURE N SAFE WATER TECHNOLOGIES PRIVATE LIMITED",
"PURE NATURAL PRODUCTS PRIVATE LIMITED",
"PURE PETROCHEM INDIA PRIVATE LIMITED",
"PURE PLATINUM JEWELLERY PRIVATE LIMITED",
"PURE PLAY MEDIA PRIVATE LIMITED",
"PURE RESEARCH PRIVATE LIMITED",
"PURE SHIPPING AND FORWARDING INDIA PRIVATE LIMITED",
"PURE SNACKS PRIVATE LIMITED",
"PURE SOLAR PRIVATE LIMITED",
"PURE SWABS PRIVATE LIMITED",
"PURE TEMPTATION PRIVATE LIMITED",
"PURE TONERS AND DEVELOPERS PRIVATE LIMITED",
"PURE TRADE LINKS PRIVATE LIMITED",
"PURE TRUHERB PRIVATE LIMITED",
"PURE VEDIC GEMS PRIVATE LIMITED",
"PURE WATER ENTERPRISES PRIVATE LIMITED",
"PURE WATERTECH PRIVATE LIMITED",
"PUREARTH INFRASTRUCTURE LIMITED",
"PUREBITE PET FOODS PRIVATE LIMITED",
"PUREBLUE AUTOMOTIVE SOLUTIONS PRIVATE LIMITED",
"PURECA LABORATORIES PRIVATE LIMITED",
"PURECIRCLE NATURAL INGREDIENT INDIA PRIVATE LIMITED",
"PURECON LENSES PRIVATE LIMITED",
"PURECOTZ ECO LIFESTYLES PRIVATE LIMITED",
"PURECRETE RMC INDIA PRIVATE LIMITED",
"PURECROP AGRO PRIVATE LIMITED",
"PURECURE AYURVEDA PRIVATE LIMITED",
"PUREEARTH BEVERAGES PRIVATE LIMITED",
"PUREFLOW SOLUTIONS PRIVATE LIMITED",
"PUREGENE AGRITECH SEEDS PRIVATE LIMITED",
"PURELAND HONEY PRIVATE LIMITED",
"PURELEARN EDUINFRA BANGALORE PRIVATE LIMITED",
"PURELEARN EDUINFRA KANAKAPURA PRIVATE LIMITED",
"PURELEARN EDUINFRA RAMANAGARA SH PRIVATE LIMITED",
"PURELOGIC LABS INDIA PRIVATE LIMITED",
"PURELUBRICANTS CHENNAI PRIVATE LIMITED",
"PUREMAX FOOTWEARS PRIVATE LIMITED",
"PURENCE INTERNATIONAL PRIVATE LIMITED",
"PUREPLAY SKIN SCIENCES INDIA PRIVATE LIMITED",
"PUREPROFILE TECHNOLOGIES INDIA PRIVATE LIMITED",
"PUREPURE NATURAL FOODS PRIVATE LIMITED",
"PURESAIENS INDIA PRIVATE LIMITED",
"PURESOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"PURESOUTH HOSPITALITY PRIVATE LIMITED",
"PURESPECTRUM INDIA PRIVATE LIMITED",
"PURETECH COMPUTER SYSTEMS PRIVATE LIMITED",
"PURETECH INTERNET PRIVATE LIMITED",
"PUREVOLT PRODUCTS PRIVATE LIMITED",
"PUREWALL VENTURES PRIVATE LIMITED",
"PUREWAY ESOLUTIONS PRIVATE LIMITED",
"PUREWAYS INFRA PRIVATE LIMITED",
"PUREWELL INDIA EXTUROTO PRIVATE LIMITED",
"PUREX LABORATORIES (INDIA) PRIVATE LIMITED",
"PURI AGRO CHEMICALS LIMITED",
"PURI BAKERS PRIVATE LIMITED",
"PURI BEACH RESORT PRIVATE LIMITED",
"PURI BUILDWELL PRIVATE LIMITED",
"PURI CRAWFORD INSURANCE SURVEYORS & LOSS ASSESSORS INDIA PRIVATE LIMITED",
"PURI CRAWFORD INSURANCE SURVEYORS AND LOSS ASSESSORS INDIA PRIVATE LIMITED",
"PURI DEVELOPERS AND PROMOTERS PRIVATE LIMITED",
"PURI ELECTRONICS PRIVATE LIMITED",
"PURI EMPORIUM PRIVATE LIMITED",
"PURI HOTEL PVT LTD",
"PURI INFRABUILD INDIA PRIVATE LIMITED",
"PURI OIL MILLS LIMITED",
"PURI POWER PRIVATE LIMITED",
"PURICA HEALTHCARE LIMITED",
"PURIDO FOODS PRIVATE LIMITED",
"PURIFIC JEWELS PRIVATE LIMITED",
"PURIFO CHEMIE PRIVATE LIMITED",
"PURINA PETCARE INDIA PRIVATE LIMITED",
"PURION SOLUTIONS PRIVATE LIMITED",
"PURIS INVESTMENT PRIVATE LIMITED",
"PURISONS AGROTECH & FOODS PRIVATE LIMITED",
"PURITA ENVIROMENTAL MANAGEMENT PRIVATE LIMITED",
"PURITA WATER SOLUTIONS PRIVATE LIMITED",
"PURITHA EXIM PRIVATE LIMITED",
"PURITY FLEXPACK LIMITED",
"PURITY POLYTUBES PRIVATE LIMITED",
"PURITZ CHEM PRIVATE LIMITED",
"PURIZON FOOD SOLUTIONS PRIVATE LIMITED",
"PURNA CHANDRA INSTITUTION",
"PURNA COLD STORAGE PVT LTD",
"PURNA DESIGN ENGINEERS PRIVATE LIMITED",
"PURNA ELEVATOR & ESCALATOR SOLUTIONS PRIVATE LIMITED",
"PURNA FISHERIES PRIVATE LIMITED",
"PURNA MAHILA AGRO PRODUCER COMPANY LIMITED",
"PURNA PROJECTS PRIVATE LIMITED",
"PURNAA REAL ESTATE (OPC) PRIVATE LIMITED",
"PURNACHANDRA PACKAGING PRIVATE LIMITED",
"PURNACHANDRA PROPERTIES PRIVATE LIMITED",
"PURNADISHA TRADING PRIVATE LIMITED",
"PURNAGIRI FOOD SERVICES PRIVATE LIMITED",
"PURNAM",
"PURNARTHA INVESTMENT ADVISERS PRIVATE LIMITED",
"PURNASONS HOLDING PVT LTD",
"PURNAYU BIO SCIENCE PRIVATE LIMITED",
"PURNEA MOTORS PRIVATE LIMITED",
"PURNI INFRA (INDIA) PRIVATE LIMITED",
"PURNIMA ADVERTISING AGENCY PRIVATE LIMITED",
"PURNIMA BALIKA VIDYALAYA",
"PURNIMA BUILDERS PRIVATE LIMITED",
"PURNIMA CHEMICAL INDUSTRIES PRIVATE LIMITED",
"PURNIMA DISTRIBUTORS PRIVATE LIMITED",
"PURNIMA ISPAT PRIVATE LIMITED",
"PURNIMA SOLAR TECHNOLOGIES PRIVATE LIMITED",
"PURNIYA CONSTRUCTION PRIVATE LIMITED",
"PURNO-GOURI COLD STORAGE PRIVATE LIMITED",
"PURO APPLIANCES PVT LTD",
"PURO WELLNESS PRIVATE LIMITED",
"PUROBIEN LIFESCIENCES PRIVATE LIMITED",
"PUROBIN LIFESCINCES",
"PUROFIL AUTO (INDIA) PRIVATE LIMITED",
"PUROGENE LABS PRIVATE LIMITED",
"PUROHIT & ASHAR MARINE SERVICES PRIVATE LIMITED",
"PUROHIT AND COMPANY",
"PUROHIT CONSTRUCTION LIMITED",
"PUROHIT CONVEYOR BELTINGS PRIVATE LIMITED",
"PUROHIT GENERAL HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED",
"PUROHIT LUXURY HOMES PRIVATE LIMITED",
"PUROHIT STEEL INDIA PRIVATE LIMITED",
"PUROMATIC FILTERS PRIVATE LIMITED",
"PUROOS ENTERPRISE PRIVATE LIMITED",
"PUROSTEEL INDIA PRIVATE LIMITED",
"PUROVENT SYSTEM ENGINEERS PRIVATE LIMITED",
"PURPLE AUDACITY RESEARCH & INNOVATION PRIVATE LIMITED",
"PURPLE BAY HOME DECORS PRIVATE LIMITED",
"PURPLE BRIDGE INNOVATIONS PRIVATE LIMITED",
"PURPLE BULL ENTERTAINMENT PRIVATE LIMITED",
"PURPLE COMMOSALES PRIVATE LIMITED",
"PURPLE CREATIONS PRIVATE LIMITED",
"PURPLE DISTRIBUTORS PRIVATE LIMITED",
"PURPLE ENGINEERING PRIVATE LIMITED",
"PURPLE FARMS PRIVATE LIMITED",
"PURPLE FINANCE LTD",
"PURPLE FOCUS PRIVATE LIMITED",
"PURPLE GROVE TRADING PRIVATE LIMITED",
"PURPLE IN HOTELS PRIVATE LIMITED",
"PURPLE INDIA TRADEX PRIVATE LIMITED",
"PURPLE LILLIES RETAIL PRIVATE LIMITED",
"PURPLE MARTINI ENTERTAINMENT PRIVATE LIMITED",
"PURPLE MICROPORT CARDIOVASCULAR PRIVATE LIMITED",
"PURPLE OPTICS PRIVATE LIMITED",
"PURPLE PANDA EDUCATION PRIVATE LIMITED",
"PURPLE PANDA FASHIONS LIMITED",
"PURPLE PARROTS ENTERTAINMENT AND HOSPITALITY PRIVATE LIMITED",
"PURPLE PATCH FARMS INTERNATIONAL PRIVATE LIMITED",
"PURPLE PEBBLE ENTERTAINMENT CO PRIVATE LIMITED",
"PURPLE PEBBLE PICTURES PRIVATE LIMITED",
"PURPLE SOIL TECHNOLOGY VENTURES PRIVATE LIMITED",
"PURPLE SQUIRREL EDUVENTURES PRIVATE LIMITED",
"PURPLE STYLE LABS LIMITED",
"PURPLE STYLE LABS PRIVATE LIMITED",
"PURPLE TALK INDIA PRIVATE LIMITED",
"PURPLE THOUGHTS INDIA PRIVATE LIMITED",
"PURPLE TUCHE BRAND SOLUTIONS PRIVATE LIMITED",
"PURPLE TURTLES LIGHTING IDEAS PRIVATE LIMITED",
"PURPLE UNITED SALES PRIVATE LIMITED",
"PURPLE WAVE INFOCOM PRIVATE LIMITED",
"PURPLEBITS INFOSYSTEMS PRIVATE LIMITED",
"PURPLECOW FOODS PRIVATE LIMITED",
"PURPLEFIRST TECHNOLOGIES PRIVATE LIMITED",
"PURPLELABS SEARCH PRIVATE LIMITED",
"PURPLEMAGIC INTERNATIONAL ENTERPRISE LIMITED",
"PURPLEMONKS TECHNOLOGY PRIVATE LIMITED",
"PURPLEPATCH SERVICES PRIVATE LIMITED",
"PURPLEPINK FILMS & MEDIA PRIVATE LIMITED",
"PURPLEPLUM DIGITAL SOLUTIONS PRIVATE LIMITED",
"PURPLERADIANCE TECHNOLOGIES PRIVATE LIMITED",
"PURPLERAIN TECHNOLOGIES PRIVATE LIMITED",
"PURPLESENSE DIGITAL SOLUTIONS PRIVATE. LIMITED",
"PURPLESES ENERGY PRIVATE LIMITED",
"PURPLESLATE PRIVATE LIMITED",
"PURPLETALK INDIA PRIVATE LIMITED",
"PURPLETEAL TECHNOLOGIES INDIA PRIVATE LIMITED",
"PURPLEWAVE INDIA PRIVATE LIMITED",
"PURPOSE NETWORK PRIVATE LIMITED",
"PURSHOTAM COMPANY PRIVATE LIMITED",
"PURSHOTAM INDUSTRIES LTD",
"PURSHOTAM PROFILES PRIVATE LIMITED",
"PURSHOTAM RAYS POWER PRIVATE LIMITED",
"PURSHOTAM SUNRISE PRIVATE LIMITED",
"PURSHOTAM SURYA PRIVATE LIMITED",
"PURSHOTTAM BROTHERS STEELS PRIVATE LIMITED",
"PURSHOTTAM GLOBAL PRIVATE LIMITED",
"PURSHOTTAM INVESTOFIN LIMITED",
"PURSHOTTAM RAM FOOD INDUSTRIES PRIVATE LIMITED",
"PURSHOTTAMDAS COTTON SEEDS INDUSTRIES PVT LTD",
"PURSUIT INDUSTRIES PRIVATE LIMITED",
"PURSUIT SOFTWARE DEVELOPMENT PRIVATE LIMITED",
"PURSUIT TECHNOLOGIES PRIVATE LIMITED",
"PURTI CONTRACT FARMING PRIVATE LIMITED",
"PURTI MARKETING PRIVATE LIMITED",
"PURTI VANASPATI PRIVATE LIMITED",
"PURULIA & KHARAGPUR TRANSMISSION COMPANY LIMITED",
"PURULIA BOTTLING PRIVATE LIMITED",
"PURULIA CHEMICALS PVT LTD",
"PURULIA METAL CASTING PRIVATE LIMITED",
"PURUS MARKETING PRIVATE LIMITED",
"PURUSHAM GARMENTS PRIVATE LIMITED",
"PURUSHOTHAM MOULDS & PLASTICS PRIVATE LIMITED",
"PURUSHOTHAM PLASTICS & TECHNOLOGIES PRIVATE LIMITED",
"PURUSHOTTAM EXPORTS PRIVATE LIMITED",
"PURUSHOTTAM HIGH SCHOOL",
"PURUSHOTTAM NAGAR CO OP HSG SOCIETY LTD",
"PURUSHOTTAM SALES PRIVATE LIMITED",
"PURUSITA INDUSTRIES PRIVATE LIMITED",
"PURV ECOPLAST PRIVATE LIMITED",
"PURV FILMS PRIVATE LIMITED",
"PURV FLEXIPACK LIMITED",
"PURV PACKAGING PRIVATE LIMITED",
"PURVA (INDIA) FOREX SERVICES PRIVATE LIMITED",
"PURVA ALLOYS LIMITED",
"PURVA BREEDERS PRIVATE LIMITED",
"PURVA INORGANICS PRIVATE LIMITED",
"PURVA METAL SECTIONS PRIVATE LIMITED",
"PURVA STAR PROPERTIES PRIVATE LIMITED",
"PURVA STEEL PRIVATE LIMITED",
"PURVA VASHI ELECTRICALS & SERVICES PRIVATE LIMITED",
"PURVADEEP MADHYAMIK SHALA AMRAIWADI",
"PURVAG COMMODITIES & DERIVATIVES PRIVATE LIMITED",
"PURVAG COMMODITIES AND DERIVATIVES PRIVATE LIMITED",
"PURVANCHAL AGRICO PRIVATE LIMITED",
"PURVANCHAL COLLECTION PRIVATE LIMITED",
"PURVANCHAL CONSTRUCTION WORKS PRIVATE LIMITED",
"PURVANCHAL ENTERPRISES PRIVATE LIMITED",
"PURVANCHAL FLOUR MILL PRIVATE LIMITED",
"PURVANCHAL FREIGHT CARRIERS PRIVATE LIMITED",
"PURVANCHAL HEALTH CARE CENTRE",
"PURVANCHAL INFRA AND INDUSTRIES PRIVATE LIMITED",
"PURVANCHAL INFRATECH PRIVATE LIMITED",
"PURVANCHAL METROCITY HOSPITAL PRIVATE LIMITED",
"PURVANCHAL SOLAR POWER PRIVATE LIMITED",
"PURVANCHAL VIDYUT VITARAN NIGAM LIMITED",
"PURVANCHAL VINTRADE PRIVATE LIMITED",
"PURVI AGGREGATE SOLUTION PRIVATE LIMITED",
"PURVI BHARAT STEEL LTD",
"PURVI ENGINEERS (INDIA) PRIVATE LIMITED",
"PURVI GEMS & JEWELLERY (INDIA) PRIVATE LIMITED",
"PURVI IRON LIMITED",
"PURVI VANIJYA NIYOJAN LTD",
"PURVIEW INDIA CONSULTING AND SERVICES LLP",
"PURVODAY PUBLICATIONS PRIVATE LIMITED",
"PURVYAKRUTI SALES & SERVICES PRIVATE LIMITED",
"PUSA HOTELS PRIVATE LIMITED",
"PUSALKAR SU-RAK-SHA COMPONENTS PRIVATE LIMITED",
"PUSAT ENGINEERS PRIVATE LIMITED",
"PUSB ENGINEERING PRIVATE LIMITED",
"PUSH ENGINEERING PRIVATE LIMITED",
"PUSH LOGISTICS AND WAREHOUSING PRIVATE LIMITED",
"PUSHAAN TRADELINK PRIVATE LIMITED",
"PUSHAPALATA PATIL INTERNATIONAL SCHOOL PATNA",
"PUSHAPDHAM HEIGHTS PRIVATE LIMITED",
"PUSHBRITE ELECTRONICS PRIVATE LIMITED",
"PUSHKAR APPARELS",
"PUSHKAR BANIJYA LTD",
"PUSHKAR CERAMICS PRIVATE LIMITED",
"PUSHKAR CONTROLS PRIVATE LIMITED",
"PUSHKAR ENTERPRISES PRIVATE LIMITED",
"PUSHKAR GANESH COTTON CLUB EXPORT PRIVATE LIMITED",
"PUSHKAR INFRASTRUCTURE PRIVATE LIMITED",
"PUSHKAR INSULATIONS AND PACKING P LIMITED",
"PUSHKAR MINERAL AND ALLOYS PRIVATE LIMITED",
"PUSHKAR PLYWOOD (I) PRIVATE LIMITED",
"PUSHKAR PREMIUM PAUSHTIK FOOD PRIVATE LIMITED",
"PUSHKAR PULSES PRIVATE LIMITED",
"PUSHKAR RURAL AGRICULTURAL YOUTH & EMPLOYMENT PRODUCER COMPANY LIMITED",
"PUSHKAR SAREES PRIVATE LIMITED",
"PUSHKAR SHIPPING SERVICES PRIVATE LIMITED",
"PUSHKAR STEELS PRIVATE LIMITED",
"PUSHKAR TECHNO PRIVATE LIMITED",
"PUSHKAR TRADELINKS PRIVATE LIMITED",
"PUSHKAR VILLAGE RESORTS PRIVATE LIMITED",
"PUSHKARAJ ENGINEERING ENTERPRISES PRIVATE LIMITED",
"PUSHKARAJ INDUSTRIES PRIVATE LIMITED",
"PUSHKARNA SALES PRIVATE LIMITED",
"PUSHKARRAJ CONSTRUCTION PRIVATE LIMITED",
"PUSHLOGICS SOLUTIONS PRIVATE LIMITED",
"PUSHP (INDIA) LIMITED",
"PUSHP BRAND (INDIA) PRIVATE LIMITED",
"PUSHP FORGINGS PRIVATE LIMITED",
"PUSHP HENNA PRIVATE LIMITED",
"PUSHP RINGS PRIVATE LIMITED",
"PUSHP STEELS AND MINING PRIVATE LIMITED",
"PUSHP VENTURES INDIA PRIVATE LIMITED",
"PUSHPA AUTOOMOBILES PRIVATE LIMITED",
"PUSHPA EDUMED PRIVATE LIMITED",
"PUSHPA ENTERPRISES PRIVATE LIMITED",
"PUSHPA FASHION PRIVATE LIMITED",
"PUSHPA FLAVOUR & FRAGRANCE PVT LTD",
"PUSHPA FOODS AND PROCESSING PRIVATE LIMITED",
"PUSHPA GOLD PRIVATE. LIMITED.",
"PUSHPA GUJRAL SCIENCE CITY",
"PUSHPA ISPAT PRIVATE LIMITED",
"PUSHPA JEWELLERS PRIVATE LIMITED",
"PUSHPA MULTI TEXFAB PRIVATE LIMITED",
"PUSHPA PIPES PRIVATE LIMITED",
"PUSHPA REAL ESTATE DEVELOPERS PRIVATE LIMITED",
"PUSHPA SALES PRIVATE. LIMITED.",
"PUSHPA YARNS PRIVATE LIMITED",
"PUSHPAGIRI ENGINEERS INFRA PRIVATE LIMITED",
"PUSHPAGIRI MEDICAL COLLEGE HOSPITAL",
"PUSHPAK AGROFERT PRIVATE LIMITED",
"PUSHPAK CAR RENTALS PRIVATE LIMITED",
"PUSHPAK COLOUR ROOF I PRIVATE LIMITED",
"PUSHPAK COMMODEAL PRIVATE LIMITED",
"PUSHPAK ESTATES AND TRADERS PRIVATE LIMITED",
"PUSHPAK FINANCIAL SERVICES PRIVATE LIMITED",
"PUSHPAK FREIGHT & CARGO PRIVATE LIMITED",
"PUSHPAK HOLIDAYS PRIVATE LIMITED",
"PUSHPAK INFRA STEEL PRIVATE LIMITED",
"PUSHPAK MARKTRADE INDIA PRIVATE LIMITED",
"PUSHPAK NETWORK INDIA PRIVATE LIMITED",
"PUSHPAK ORGANICS INDIA PRIVATE LIMITED",
"PUSHPAK PRECISION INDUSTRIES PRIVATE LIMITED",
"PUSHPAK PRODUCTS INDIA PRIVATE LIMITED",
"PUSHPAK RAIL CONSTRUCTION PRIVATE LIMITED",
"PUSHPAK STEEL INDUSTRIES PRIVATE LIMITED",
"PUSHPAK STRUCTURES AND ENGINEERS PRIVATE LIMITED",
"PUSHPAK TELENET PRIVATE LIMITED",
"PUSHPAK TRADEMECH LIMITED.",
"PUSHPALATA INVESTMENTS LTD",
"PUSHPALATHA EDUCATIONAL CENTRE",
"PUSHPAM CARE AND CURE PRIVATE LIMITED",
"PUSHPAM COMPUTERS & SOFTWARE PRIVATE LIMITED",
"PUSHPAM CONSULTANCY & SOLUTIONS PRIVATE LIMITED",
"PUSHPAM CONTAINERS PRIVATE LIMITED",
"PUSHPAM FOODS AND BEVERAGES PRIVATE LIMITED",
"PUSHPAM HORTITECH PRIVATE LIMITED",
"PUSHPAM HYGIENE PRIVATE LIMITED",
"PUSHPAM LOGISTICS PRIVATE LIMITED",
"PUSHPAM TRADELINK PRIVATE LIMITED",
"PUSHPANJALI COMMERCIAL PRIVATE LIMITED",
"PUSHPANJALI CONSTRUCTIONS PRIVATE LIMITED",
"PUSHPANJALI CONSUMER PRODUCTS PRIVATE LIMITED",
"PUSHPANJALI CROSSLAY HOSPITAL",
"PUSHPANJALI DRUMS PRIVATE LIMITED",
"PUSHPANJALI DYEING AND PRINTING MILLS PRIVATE LIMITED",
"PUSHPANJALI ENTERPRISES PRIVATE LIMITED",
"PUSHPANJALI ENTRADE PRIVATE LIMITED",
"PUSHPANJALI ESTATES PRIVATE LIMITED",
"PUSHPANJALI FAIRTRADE PRIVATE LIMITED",
"PUSHPANJALI HOMES PRIVATE LIMITED",
"PUSHPANJALI HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED",
"PUSHPANJALI HOSPITALITY PRIVATE LIMITED",
"PUSHPANJALI INVESTRADE PRIVATE LIMITED",
"PUSHPANJALI MEDI INDIA PRIVATE LIMITED",
"PUSHPANJALI MEDICARE PRIVATE LIMITED",
"PUSHPANJALI REALMS AND INFRATECH LIMITED",
"PUSHPANJALI REALTORS PRIVATE LIMITED",
"PUSHPANJALI SAREES PRIVATE LIMITED",
"PUSHPANJALI STEEL ALLOYS PVT LTD",
"PUSHPANJALI TREXIM PRIVATE LIMITED",
"PUSHPANJALI VANIJYA PRIVATE LIMITED",
"PUSHPANJLI STRIPS",
"PUSHPANSH INFRATECH PRIVATE LIMITED",
"PUSHPARAJ STAMPINGS AND ELECTRICALS PVT LTD",
"PUSHPARTH RENEWABLES PRIVATE LIMITED",
"PUSHPAVATHI COLD STORAGE PRIVATE LIMITED",
"PUSHPAWATI SINGHANIA HOSPITAL & RESEARCH INSTITUTE",
"PUSHPAWATI SINGHANIA HOSPITAL AND RESEARCH INSTITUTE",
"PUSHPAWATI SINGHANIA RESEARCH INSTITUTE",
"PUSHPDANT BUILDERS PRIVATE LIMITED",
"PUSHPDEEP COTEX PRIVATE LIMITED",
"PUSHPDEEP INFRASTRUCTURE PRIVATE LIMITED",
"PUSHPENDRA REAL CONSTRUCTION PRIVATE LIMITED",
"PUSHPGANGA MINERALS LLP",
"PUSHPIT GREEN POWER PRIVATE LIMITED",
"PUSHPITA HEALTHCARE PRIVATE LIMITED",
"PUSHPMAN CONSULTANTS PRIVATE LIMITED",
"PUSHPNATH OVERSEAS PRIVATE LIMITED",
"PUSHPRAJ LOGISTICS PRIVATE LIMITED",
"PUSHPSONS FIBROL PRIVATE LIMITED",
"PUSHPSONS INDUSTRIES LIMITED",
"PUSHPVILLA HOTEL PRIVATE LIMITED",
"PUSHTI DEVELOPERS PRIVATE LIMITED",
"PUSHTI ELECTRICALS PVT LTD",
"PUSHTI METAL INDUSTRIES LLP",
"PUSHTIK LOGISTEK PRIVATE LIMITED",
"PUSHTIKAR BUILDERS & PROMOTERS LIMITED",
"PUSH-UP TOOLS UDYOG PVT LTD",
"PUSHYAMI INFRA INDIA PRIVATE LIMITED",
"PUSHYARAGAM JEWELLERS (KOYILANDY) PRIVATE LIMITED",
"PUSILIN BIOTECHNOLOGY PRIVATE LIMITED",
"PUSKAR TRADECOM PRIVATE LIMITED",
"PUSPA AGENCIES PRIVATE LIMITED",
"PUSPA FURNITURE PRIVATE LIMITED",
"PUSPA LEISURE PRIVATE LIMITED",
"PUSPA TEA ESTATE PVT LTD",
"PUSPADEEP CONSULTANCY & SERVICES PRIVATE LIMITED",
"PUSPANJALI REALTORS PRIVATE LIMITED",
"PUSPANJANA ALLOYS PRIVATE LIMITED",
"PUSPC ENVIRO DEVELOPERS PRIVATE LIMITED",
"PUSPHAS CONSTRUCTION PRIVATE LIMITED",
"PUSSIANT SOLUTIONS PRIVATE LIMITED",
"PUSSIMBING TEA COMPANY LIMITED",
"PUSTAK MANDIR PVT LTD",
"PUSTAKA DIGITAL MEDIA PRIVATE LIMITED",
"PUTAK APPARELS PRIVATE LIMITED",
"PUTHALATH HABITAT PRIVATE LIMITED",
"PUTHARJHORA TEA GARDEN PRIVATE LIMITED",
"PUTHETTU DEVELOPERS PRIVATE LIMITED",
"PUTHUR INFOTECH PRIVATE LIMITED",
"PUTIARY BRAJAMOHAN TEWARY INS",
"PUTMAN TRAVELS PRIVATE LIMITED",
"PUTPEX COMMERCIAL TRADE PRIVATE LIMITED",
"PUTTUR CITY HOSPITAL PRIVATE LIMITED",
"PUTTUR PETRO PRODUCTS PRIVATE LIMITED",
"PUTTUR TALUK PARISHISTA VARGAGALA DODDAPRAMANADA VIVIDHODDESHA SAHAKARI SANGHA PUTTUR",
"PUTU INFRA PRIVATE LIMITED",
"PUTUS FOODS (INDIA) PRIVATE LIMITED",
"PUTZMEISTER CONCRETE MACHINES PRIVATE LIMITED",
"PUTZMEISTER INDIA PRIVATE LIMITED",
"PUVANESWARI ENTERPRISES WIND FARMS PRIVATE LIMITED",
"PUYANG REFRACTORIES GROUP COMPANY INDIA PRIVATE LIMITED",
"PUYVAST MARITIME INDIA PRIVATE LIMITED",
"PUZZLES TECHNOLOGIES INDIA PRIVATE LIMITED",
"PUZZOLANA MACHINERY FABRICATORS",
"PV CLEAN MOBILITY TECHNOLOGIES PRIVATE LIMITED",
"PV COMPU PATTERNS PRIVATE LIMITED",
"PV COTTON PRIVATE LIMITED",
"PV EDUCATION PRIVATE LIMITED",
"PV LINE POWER ONE PRIVATE LIMITED",
"PV LUMENS LLP",
"PV MEDIA VISION PRIVATE. LIMITED.",
"PV POWER TECHNOLOGIES PRIVATE LIMITED",
"PV RENEWABLES INDIA PRIVATE LIMITED",
"PV SECURITIES PRIVATE LIMITED",
"PV SONS CORN MILLING COMPANY PRIVATE LIMITED",
"PVA INDUSTRIES PRIVATE LIMITED",
"PVA METALS PRIVATE LIMITED",
"PVA TEXTILES PRIVATE LIMITED",
"PVALUE ANALYTICS PRIVATE LIMITED",
"PVB TRADE EXPORT PRIVATE LIMITED",
"PVC BUILDCON PRIVATE LIMITED",
"PVC CONVERTERS INDIA PRIVATE LIMITED",
"PVC PUMPS PRIVATE LIMITED",
"PVD CREATIONS PRIVATE LIMITED",
"PVG AUTOMOTIVE PRIVATE LIMITED",
"PVG IT INFRASTRUCTURE SERVICES PRIVATE LIMITED",
"PVG REALTORS PRIVATE LIMITED",
"PVH INDIA LIMITED",
"PVJ PROJECTS PRIVATE LIMITED",
"PVK INFO SOLUTIONS PRIVATE LIMITED",
"PVK KORAMANGALA DEVELOPMENT PRIVATE LIMITED",
"PVK MINERALS & CHEMICALS PRIVATE LIMITED",
"PVK PROJECTS PRIVATE LIMITED",
"PVKK INSTITUTE OF TECHNOLOGY",
"PVKL TECH SERVICES PRIVATE LIMITED",
"PVKS CORPORATION PRIVATE LIMITED",
"PVL PRODUCTS PRIVATE LIMITED",
"PVL TAG FACTORY (INDIA) PRIVATE LIMITED",
"PVLBASE SPORTS PRIVATE LIMITED",
"PVM AUTO (NASIK) LLP",
"PVM AUTO NASIK PRIVATE LIMITED",
"PVM ENTERPRISES PRIVATE LIMITED",
"PVM LOGISTICS PRIVATE LIMITED",
"PVM PROPERTIES PRIVATE LIMITED",
"PVN ASSOCIATES PRIVATE LIMITED",
"PVN CONSTRUCTIONS PRIVATE LIMITED",
"PVP CAPITAL LIMITED",
"PVP VENTURES LIMITED",
"PVPHARMA HEALTHCARE PRIVATE LIMITED",
"PVR BLUO ENTERTAINMENT LIMITED",
"PVR CONSULTING ENGINEERS PRIVATE LIMITED",
"PVR DEVELOPERS INDIA PRIVATE LIMITED",
"PVR INFRATECH INDIA PRIVATE LIMITED",
"PVR INOX LIMITED",
"PVR INSHIELD BITUMINOUS PVT. LTD.",
"PVR MEMORIAL EDUCATIONAL SOCIETY",
"PVR METALLURGICALS PRIVATE LIMITED",
"PVR PICTURE LIMITED",
"PVR POWER ENERGY PRIVATE LIMITED",
"PVR PROJECTS LIMITED",
"PVR SPINNING AND WEAVING LIMITED",
"PVR SYSTEMS PRIVATE LIMITED",
"PVRSM BROILERS AND HATCHERIES PRIVATE LIMITED",
"PVS GLOBAL TRADE PRIVATE LIMITED",
"PVS LABORATORIES LIMITED",
"PVSS POULTRY LIMITED",
"PVTI CARBON BLACK PRIVATE LIMITED",
"PVV INFRA LIMITED",
"PVY CONSULTING PRIVATE LIMITED",
"PWC",
"PWC STRATEGY& INDIA PRIVATE LIMITED",
"PWD ALL INDIA",
"PWD CIVIL ENGINEER & CONTRACTORS",
"PWD CONSTRUCTION DIV-1 BARA KANPUR DEHAT",
"PWD SACHIWALAYA LKO",
"PWG IT SEVICE PRIVATE LIMITED",
"PWIP FOODTECH PRIVATE LIMITED",
"PWR247 4U TECHSOL PRIVATE LIMITED",
"PWS COLLEGE OF ARTS COMMERCE",
"PWS LOGISTICS PRIVATE LIMITED",
"PWTI MEDIA SERVICES PRIVATE LIMITED",
"PWW DISTRIBUTION INDIA PRIVATE LIMITED",
"PXC PACIFIC GLOBAL PRIVATE LIMITED",
"PXP SERVICES PRIVATE LIMITED",
"PXS SIGNS PRIVATE LIMITED",
"PY TECHNOLOGY PRIVATE LIMITED",
"PYARABAI SOMANI ADHYAPIKA VIDYALAYA",
"PYARE LAL COIR PRODUCTS PRIVATE LIMITED",
"PYARELAL AGRO AND EXPORTS PRIVATE LIMITED",
"PYARELAL FOAMS PRIVATE LIMITED",
"PYATOZ ONLINE SERVICES PRIVATE LIMITED",
"PYC LOGISTICS PRIVATE LIMITED",
"PYDAH COLLEGE OF ENGINEERING TECHNOLOG",
"PYDAH DEGREE COLLEGE",
"PYE TOOLS PRIVATE LIMITED",
"PYKARA TECHNOLOGIES PRIVATE LIMITED",
"PYLON MANAGEMENT CONSULTING PRIVATE LIMITED",
"PYLON PROJECTS PRIVATE LIMITED",
"PYLON TRADERS PRIVATE LIMITED",
"PYMNTS TECH SOLUTION PRIVATE LIMITED",
"PYN AUTOCOMP PRIVATE LIMITED",
"PYNADATH ROCK PRODUCTS PRIVATE LIMITED",
"PYNAT CORPORATION INDIA PRIVATE LIMITED",
"PYOGINAM APPAREL PRIVATE LIMITED",
"PYOME INFRA SOLUTIONS PRIVATE LIMITED",
"PYRAMID ABRASIVES PRIVATE LIMITED",
"PYRAMID BUILDTECH PRIVATE. LIMITED.",
"PYRAMID COLLECTION PRIVATE LIMITED",
"PYRAMID COLLEGE OF BUSINESS & TECHNOLOGY",
"PYRAMID COLONIZERS PRIVATE LIMITED",
"PYRAMID CONSULTING ENGINEERS PRIVATE LIMITED",
"PYRAMID CYBER SECURITY & FORENSIC PRIVATE LIMITED",
"PYRAMID DIAGNOSTICS PRIVATE LIMITED",
"PYRAMID FACILITY MANAGEMENT SERVICES IND PRIVATE LIMITED",
"PYRAMID FINANCE PRIVATE LIMITED",
"PYRAMID GRANITES PRIVATE LIMITED",
"PYRAMID HOMES PRIVATE LIMITED",
"PYRAMID INFRAPROJECTS (INDIA) PRIVATE LIMITED",
"PYRAMID INFRATECH PRIVATE LIMITED",
"PYRAMID INTERIORS PRIVATE LIMITED",
"PYRAMID IT CONSULTING PRIVATE LIMITED",
"PYRAMID IT SOLUTIONS PRIVATE LIMITED",
"PYRAMID POLYMERS PRIVATE LIMITED",
"PYRAMID RETAIL SERVICES PRIVATE LIMITED",
"PYRAMID ROTO PRINT PRIVATE LIMITED",
"PYRAMID SOFTSOL PRIVATE LIMITED",
"PYRAMID TECHNICAL SERVICES PRIVATE LIMITED",
"PYRAMID TECHNOLOGY",
"PYRAMID TECHNOPLAST LIMITED",
"PYRAMID TIMBER ASSOCIATES PRIVATE LIMITED",
"PYRAMID TIMBER INDUSTRIES PRIVATE LIMITED",
"PYRAMID TOURS AND ALLIED SERVICES P LTD",
"PYRAMID VENTURES INDIA PRIVATE LIMITED",
"PYRAMID WATERPROOFING SERVICES LLP",
"PYRAMIDS SKILLTECH PRIVATE LIMITED",
"PYRAMIS CARGO MANAGEMENT PRIVATE LIMITED",
"PYREON SOFTWARE CONSULTANTS PRIVATE LIMITED",
"PYRITE MARKETING PRIVATE LIMITED",
"PYRITE TECHNOLOGIES PRIVATE LIMITED",
"PYRO BKP TELECOM CONSULTANTS PRIVATE LIMITED",
"PYRO CLARK RELIANCE LEVEL SOLUTIONS INDIA PRIVATE LIMITED",
"PYRO ELECTRIC AND ALLIED INSTRUMENTS PVT LTD",
"PYRO ELECTRIC CABLES AND SENSORS PRIVATE LIMITED",
"PYRO ELECTRIC INSTRUMENTS GOA PRIVATE LIMITED",
"PYRO HOLDINGS PRIVATE LIMITED",
"PYRO INFRA PRIVATE LIMITED",
"PYRO NETWORKS PRIVATE LIMITED",
"PYRO SAFE PRIVATE LIMITED",
"PYRO TELECOM ENGINEERING SERVICES PRIVATE LIMITED",
"PYRO TELECOM SOLUTIONS PRIVATE LIMITED",
"PYROCAST INDIA PRIVATE LIMITED",
"PYROGENIC ENGINEERINGS (I) PRIVATE LIMITED",
"PYROGREEN ENERGY PRIVATE LIMITED",
"PYROGUARD ENGINEERS PRIVATE LIMITED",
"PYROL FUEL INDUSTRIES PRIVATE LIMITED",
"PYRON ENGINEERS PRIVATE LIMITED",
"PYROTECH CONTROL INDIA PRIVATE. LIMITED",
"PYROTECH ELECTRONICS PVT LTD",
"PYROTECH WORKSPACE SOLUTIONS PRIVATE LIMITED",
"PYROTEK INDIA PRIVATE LIMITED",
"PYROTRONICS INDIA PRIVATE LIMITED",
"PYRRA SUTURES PRIVATE LIMITED",
"PYTEX IMPEX PRIVATE LIMITED",
"PYTHEOS HEALTH SYSTEMS PRIVATE LIMITED",
"PYTHER INNOVATIONS PRIVATE LIMITED",
"PYTHHOS TECHNOLOGY PRIVATE LIMITED",
"PYTHIAN INDIA PRIVATE LIMITED",
"PYTHTECH PRIVATE LIMITED",
"PYUNG HWA INDIA PRIVATE LIMITED",
"PYX TECH PRIVATE LIMITED",
"PYXERA GLOBAL INDIA PRIVATE LIMITED",
"PYXIS FINVEST LIMITED",
"PYXIS PROJECTS AND CONSULTANTS PRIVATE LIMITED",
"PYXUS PHARMACEUTICALS PRIVATE LIMITED",
"PZ MEDICAL INDIA PRIVATE LIMITED",
"PZONE ELECTRONICS PRIVATE LIMITED",
"PZONE INFRATECH PRIVATE LIMITED",
"Q AND Q RESEARCH INSIGHTS PRIVATE LIMITED",
"Q E D PACKERS PRIVATE LIMITED",
"Q GREEN TECHCON PRIVATE LIMITED",
"Q HESTIA TECHNOLOGIES PRIVATE LIMITED",
"Q LINE BIOTECH PRIVATE LIMITED",
"Q MANAGEMENT SOLUTIONS INDIA PRIVATE LIMITED",
"Q MAX TEST EQUIPMENTS PRIVATE LIMITED",
"Q P PHARMACHEM LIMITED",
"Q PLUS TECHNOLOGIES PRIVATE LIMITED",
"Q SQUARE INFRA MANAGEMENT PRIVATE LIMITED",
"Q VENTURES PRIVATE LIMITED",
"Q&T FOODS PRIVATE LIMITED",
"Q1 TECHNOLOGIES INDIA PRIVATE LIMITED",
"Q2A MEDIA",
"Q2AMEDIA SERVICES PRIVATE LIMITED",
"Q2Q SOLUTIONS PRIVATE LIMITED",
"Q3 INFOTECH PRIVATE LIMITED",
"Q3 SERVICES INDIA PRIVATE LIMITED",
"Q3EDGE CONSULTING PRIVATE LIMITED",
"Q4 HEALTH AND WELLNESS PRIVATE LIMITED",
"Q-7 CERAMIC LLP",
"QA BANGALORE PRIVATE LIMITED",
"QA BIM PRIVATE LIMITED",
"QA INFOTECH PRIVATE LIMITED",
"QA INFOTECH SOFTWARE SERVICES PRIVATE LIMITED",
"QA INTERNATIONAL CERTIFICATION INDIA PRIVATE LIMITED",
"QA MENTOR TESTING SERVICES PRIVATE LIMITED",
"QA TESTING LABORATORIES PRIVATE LIMITED",
"QAAGILITY TECHNOLOGIES PRIVATE LIMITED",
"QABLE TESTLAB PRIVATE LIMITED",
"QAD INDIA PRIVATE LIMITED",
"QADAR AHMAD KHAN COLLEGE OF PHARMACY",
"QAE CONSULTING PRIVATE LIMITED",
"QAEXPLORE EQUIPMENT PRIVATE LIMITED",
"QAFF TECHNOLOGIES PRIVATE LIMITED",
"QAI INDIA LIMITED",
"QAIPL PRIVATE LIMITED",
"QAIS CONSULTING INDIAPRIVATE LIMITED",
"QAMAR HIGH SCHOOL NAGPUR",
"QANALYSTS SERVICES INDIA PRIVATE LIMITED",
"QANS CONSUMER PRODUCTS PRIVATE LIMITED",
"QANTAS AIRWAYS LIMITED",
"QANTLER TECHNOLOGIES PRIVATE LIMITED",
"QANTUR TECHNOLOGIES PRIVATE LIMITED",
"QAPITA FINTECH INDIA PRIVATE LIMITED",
"QAPITOL QA SERVICES PRIVATE LIMITED",
"QARISHMA MARKETING PRIVATE LIMITED",
"QARMATEK SERVICES PRIVATE LIMITED",
"QASAB KUTCH CRAFTSWOMEN PRODUCER COMPANY LIMITED",
"QASHERPAS PRIVATE LIMITED",
"QASOLVE.AI (INDIA) PRIVATE LIMITED",
"QASSURE TECHNOLOGIES INDIA PRIVATE LIMITED",
"QASWA ENGINEERING PRIVATE LIMITED",
"QASWA STEEL PRIVATE LIMITED",
"QATALYS SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"QATAR AIRWAYS",
"QATAR AVIATION SERVICES INDIA PRIVATE LIMITED",
"QATAR INVESTMENT AUTHORITY ADVISORY PRIVATE LIMITED",
"QATAR NATIONAL BANK",
"QATAR NATIONAL BANK SAQ",
"QAULITY DISC MANUFACTURERS P LIMITED",
"QAUMI SENIOR SECONDARY SCHOOL",
"QAUMI TANZEEM PUBLICATION PRIVATE LIMITED",
"QAVI CONSTRUCTION PRIVATE LIMITED",
"QAZI ENGINEERING PRIVATE LIMITED",
"QB HEALTH TECHNOLOGIES PRIVATE LIMITED",
"QBAR TECHNOLOGIES PRIVATE LIMITED",
"QBARA FOODS PRIVATE LIMITED",
"QBD BIOSCIENCES PRIVATE LIMITED",
"QBD RESEARCH & DEVELOPMENT LAB PRIVATE LIMITED",
"QBIOME RESEARCH PRIVATE LIMITED",
"QBIT LABS PRIVATE LIMITED",
"QBIX INTEGRATED SERVICES PRIVATE LIMITED",
"QBLER TECHNOLABS PRIVATE LIMITED",
"QBLUE FLUID PRIVATE LIMITED",
"QBOOKS ACCOUNTING & CONSULTING PRIVATE LIMITED",
"QBRAINX INDIA PRIVATE LIMITED",
"QBRIK INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"QBURST SYSTEMS PRIVATE LIMITED",
"QBURST TECHNOLOGIES PRIVATE LIMITED",
"QC VERIFY PRIVATE LIMITED",
"QCAP SECURITIES PRIVATE LIMITED",
"QCD ENGINEERING INDIA PRIVATE LIMITED",
"QCD GLOBAL SERVICES PRIVATE LIMITED",
"QCIAD SOLUTIONS PRIVATE LIMITED",
"QCID TECHNOLOGIES PRIVATE LIMITED",
"QCON BLOCKS PRIVATE LIMITED",
"QCON INFRA PRIVATE LIMITED",
"QCRETE READYMIX INDIA PRIVATE LIMITED",
"Q-DAT IT SOLUTIONS PRIVATE LIMITED",
"QDC INDIA CONSULTING PRIVATE LIMITED",
"QDEGREES SERVICES PRIVATE LIMITED",
"QDESQ REALTECH PRIVATE LIMITED",
"QDIGI SERVICES LIMITED",
"QDIS TEXOFAB PRIVATE LIMITED",
"QDNET TECHNOLOGIES PRIVATE LIMITED",
"QE SECURITIES LLP",
"QED AGRO SYSTEMS PRIVATE LIMITED.",
"QED CLINICAL SERVICES INDIA PRIVATE LIMITED",
"QED KARES PACKERS PRIVATE LIMITED",
"QED PRODUCTIONS PRIVATE LIMITED",
"QED42 ENGINEERING PRIVATE LIMITED",
"QEM PROCESSING PRIVATE LIMITED",
"QENCH STUDIOZ PRIVATE LIMITED",
"QENOMY DIGITAL LLP",
"QENTELLI SOLUTIONS PRIVATE LIMITED",
"QEROS SOFTWARE CONSULTING PRIVATE LIMITED",
"QEVENTS LIMITED",
"QFE INFRASTRUCTURE PRIVATE LIMITED",
"QFIX INFOCOMM PRIVATE LIMITED",
"QFOCUS ENGINEERING INDIA PRIVATE LIMITED",
"QFROZ TRADES PRIVATE LIMITED",
"QFS CONSULTANCY PRIVATE LIMITED",
"QGI WORK FORCE DEVELOPMENT SOLUTIONS PRIVATE LIMITED",
"QGO FINANCE LIMITED",
"QH TALBROS PRIVATE LIMITED",
"QI LIFECARE PRIVATE LIMITED",
"QI NETWORK ENTERPRISE PRIVATE LIMITED",
"QIAGEN INDIA PRIVATE LIMITED",
"QIBLATAIN TRAVELS PRIVATE LIMITED",
"QIDWAI H S ASHINAGAR NAGPUR",
"QIFT SOLUTECH PRIVATE LIMITED",
"QIKWELL TECHNOLOGIES INDIA PRIVATE LIMITED",
"QILIN GLOBAL PRIVATE LIMITED",
"QIMA QUALITY INSPECTION INDIA PRIVATE LIMITED",
"QINECSA SOLUTIONS INDIA PRIVATE LIMITED",
"QING AMBAY CITY DEVELOPERS CORPORATION LIMITED",
"QIO TECHNOLOGIES INDIA PRIVATE LIMITED",
"QIS COLLEGE OF ENGINEERING AND TECHNOLOGY",
"QIS INNOVATION PRIVATE LIMITED",
"QIS TECHNO SERVICES PRIVATE LIMITED",
"QISCET",
"QISON SOFTWARE PRIVATE LIMITED",
"QIWORKS CREATIONS PRIVATE LIMITED",
"QIXING TECHNOLOGIES PRIVATE LIMITED",
"QIZAR SOLUTIONS PRIVATE LIMITED",
"QIZIL21 SOFTWARES PRIVATE LIMITED",
"QJ MOTORS PRIVATE LIMITED",
"QK MARINE SERVICES PRIVATE LIMITED",
"QL2 SOFTWARE INDIA PRIVATE LIMITED",
"QLICKET INDIA PRIVATE LIMITED",
"QLIFE LOGISTICS AND FREIGHT PRIVATE LIMITED",
"QLIK TECH INDIA PRIVATE LIMITED",
"QLIKMATRIX SEM AND ANALYTICS PRIVATE LIMITED",
"QLIKTAG SOFTWARE PRIVATE LIMITED",
"QLITE ELECTRONICS CONTROLS PRIVATE LIMITED",
"QLOGIC INDIA PRIVATE LIMITED",
"QLOGY MANAGEMENT SERVICES PRIVATE LIMITED",
"QLONI INDUSTRIES LIMITED",
"QLUNKAR INNOVATION PRIVATE LIMITED",
"QLYTIX SOLUTIONS PRIVATE LIMITED",
"Q-MART RETAIL LIMITED",
"Q-MART RETAIL PRIVATE LIMITED",
"QMAX ASSOCIATES PRIVATE LIMITED",
"QMAX CERAMICS PRIVATE LIMITED",
"QMAX FASHIONS PRIVATE LIMITED",
"QMAX ION PRIVATE LIMITED",
"QMAX SOLUTIONS INC",
"QMAX SYNTHETICS PRIVATE LIMITED",
"QMAX SYSTEMS (INDIA) PRIVATE LIMITED",
"QMAX TECHNO CONSULTANTS PRIVATE LIMITED",
"QMAX TEST TECNOLOGIES PRIVATE LIMITED",
"QMAX WORLD LLP",
"QMEASURE TECHNOLOGIES PRIVATE LIMITED",
"QMETRY INDIA PRIVATE LIMITED",
"QMI ENGINEERS OPC PRIVATE LIMITED",
"QMIN INDUSTRIES LIMITED",
"QMINDS CONSULTING GLOBAL PRIVATE LIMITED",
"QMS INDIA LIMITED",
"QMS MEDICAL ALLIED SERVICES LIMITED",
"QMS MEDICAL ALLIED SERVICES PRIVATE LIMITED",
"QNAP CORPORATION INDIA PRIVATE LIMITED",
"QNESS SOFTWARE PRIVATE LIMITED",
"QNEURO INDIA PRIVATE LIMITED",
"QNEXT STONE PRODUCTS PRIVATE LIMITED",
"QNOV SYSTEMS PRIVATE LIMITED",
"QNQ DESIGN AND DEVELOPMENT PRIVATE LIMITED",
"QOBALT SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"QODE QUAY TECHNOLOGIES PRIVATE LIMITED",
"QODENEXT INDIA PRIVATE LIMITED",
"QOGNIFY SECURITY TECHNOLOGIES PRIVATE LIMITED",
"QOLARIS DATA INDIA PRIVATE LIMITED",
"QONQESTS TECHNICAL SOLUTIONS PRIVATE LIMITED",
"QONTRACK SERVICES PRIVATE LIMITED",
"QOOT FOOD LIMITED",
"QOS TECHNOLOGY PRIVATE LIMITED",
"QOT PACKAGING PRIVATE LIMITED",
"QP HEALTH SERVICES LIMITED",
"QPAVE SOLUTIONS PRIVATE LIMITED",
"QPHARM HEALTH CARE LIMITED",
"QPIAI INDIA PRIVATE LIMITED",
"QPLEXUS PRIVATE LIMITED",
"QPLUS LEARNING PRIVATE LIMITED",
"QPOINT ENGINEERING SOLUTIONS PRIVATE LIMITED",
"QPR LOGISTICS PRIVATE LIMITED",
"QPRO DESIGN CONSULTANTS PRIVATE LIMITED",
"QPS SOLUTIONS PRIVATE LIMITED",
"QR SOLUTIONS (INDIA) PRIVATE LIMITED",
"Q-RAILING INDIA PRIVATE LIMITED",
"QRAL INDIA PRIVATE LIMITED",
"QRC ASSURANCE AND SOLUTIONS PRIVATE LIMITED",
"QREGO FABTECH LLP",
"QREO CONSULTANCY INDIA PRIVATE LIMITED",
"QREX FLEX PRIVATE LIMITED",
"QRG CENTRAL HOSPITAL AND RESEARCH CENTRE LIMITED",
"QRG ENTERPRISES LIMITED.",
"QRG INVESTMENTS AND HOLDINGS LIMITED",
"QRG MEDICARE LIMITED",
"QRISTOL HEALTHCARE PRIVATE LIMITED",
"QRS IMPEX PRIVATE LIMITED",
"QRS RETAIL LIMITED",
"QRT 24X7 SECURITY PRIVATE LIMITED",
"QRT FACILITIES LLP",
"QRUIZE TECHNOLOGIES PRIVATE LIMITED",
"QS METROLOGY PRIVATE LIMITED",
"QS QUACQUARELLI SYMONDS INDIA PRIVATE LIMITED",
"QSA INDUSTRIES PRIVATE LIMITED",
"QSA POULTRY INDIA PRIVATE LIMITED",
"QSC INDIA PRIVATE LIMITED",
"QSC LLC",
"QSD FORMULATIONS PRIVATE LIMITED",
"QSEAL AGRITECH PRIVATE LIMITED",
"QSEAP INFOTECH PRIVATE LIMITED",
"QS-ERA INDIA PRIVATE LIMITED",
"QSFT INDIA PRIVATE LIMITED",
"QSG TECHNOLOGIES PRIVATE LIMITED",
"QSHE VISION TECHNOLOGIES PRIVATE LIMITED",
"Q-SHIELD DIESEL & GAS TECHNOLOGIES PRIVATE LIMITED",
"QSHIP MARITIME MANAGEMENT PRIVATE LIMITED",
"QSIX INDIA PRIVATE LIMITED",
"QSOURCE GLOBAL CONSULTING PRIVATE LIMITED",
"QSPIDERS SOFTWARE TRAINING INSTITUTE",
"QSR BRANDS INDIA PRIVATE LIMITED",
"QSR FOOD CONCEPTS PRIVATE LIMITED",
"QSR MEDICAL AGENCIES PRIVATE LIMITED",
"QSS ENTERPRISES PRIVATE LIMITED",
"QSS TECHNOSOFT PRIVATE LIMITED",
"QST FABRICS AND ACCESSORIES INDIA PRIVATE LIMITED",
"QT INDIA TECHNOLOGY PRIVATE LIMITED",
"QTECH ANALYTICS PRIVATE LIMITED",
"QTECH INFRASTRUCTURE PRIVATE LIMITED",
"Q-TECH MOBILE PRIVATE LIMITED",
"QTECH SOFTWARE PRIVATE LIMITED",
"QTEK LABELS PRIVATE LIMITED",
"QTLOADS TECH & TRANSIT PRIVATE LIMITED",
"QTONIX SOFTWARE PRIVATE LIMITED",
"QTONOMY TECHNOLOGIES PRIVATE LIMITED",
"QTONZ INFOSOFT PRIVATE LIMITED",
"QTORK AUTOMATION PRIVATE LIMITED",
"QTP ENTERTAINMENT PRIVATE LIMITED",
"QTROVEVISTA EXCLUSIVE SERVICES PRIVATE LIMITED",
"QTS SOLUTIONS PRIVATE LIMITED",
"QTTL LAB PRIVATE LIMITED",
"QUA WATER TECHNOLOGIES PRIVATE LIMITED",
"QUAD LIFESCIENCES PRIVATE LIMITED",
"QUAD ONE TECHNOLOGIES",
"QUAD TOOLING TECHNOLOGIES PRIVATE LIMITED",
"QUADEYE SECURITIES PRIVATE LIMITED",
"QUADGEN WIRELESS SOLUTIONS PRIVATE LIMTED",
"QUADIO LABS PRIVATE LIMITED",
"QUADIS SERVICES PRIVATE LIMITED",
"QUADLABS TECHNOLOGIES PRIVATE LIMITED",
"QUADLEX ELECTRIC PRIVATE LIMITED",
"QUADLOGIX TECHNOLOGIES PRIVATE LIMITED",
"QUADLY VENTURES PRIVATE LIMITED",
"QUADOMETRY ENGINEERING (OPC) PRIVATE LIMITED",
"QUADPRO E SERVICES PRIVATE LIMITED",
"QUADPRO ITES LIMITED",
"QUADRA ARCHITECTS PRIVATE LIMITED",
"QUADRA INFRATEL SYNERGIES PRIVATE LIMITED",
"QUADRA INSTITUTE OF AYURVEDA",
"QUADRA INTERSOL PRIVATE LIMITED",
"QUADRA MEDICAL SERVICES PRIVATE LIMITED",
"QUADRA ORTHOSURGE PRIVATE LIMITED",
"QUADRA PRESS INDIA LIMITED",
"QUADRA SYSTEMS NET INDIA PRIVATE LIMITED",
"QUADRAFORT TECHNOLOGIES PRIVATE LIMITED",
"QUADRAGEN VETHEALTH PRIVATE LIMITED",
"QUADRAGUARD SECURITY I P LIMITED",
"QUADRALUMEN PRIVATE LIMITED",
"QUADRANT 4 SOFTWARE SOLUTIONS PRIVATE LIMITED",
"QUADRANT CABLES PRIVATE LIMITED",
"QUADRANT CONSUMER PRODUCTS LLP",
"QUADRANT EPP SURLON INDIA LIMITED",
"QUADRANT FUTURE TEK LIMITED",
"QUADRANT IT SERVICES PRIVATE LIMITED",
"QUADRANT KNOWLEDGE SOLUTIONS PRIVATE LIMITED",
"QUADRANT LIFESTYLES PRIVATE LIMITED",
"QUADRANT LOGISTICS PRIVATE LIMITED",
"QUADRANT MEASUREMENTS PRIVATE LIMITED",
"QUADRANT METALS (INDIA) PRIVATE LIMITED",
"QUADRANT RESOURCES PRIVATE LIMITED",
"QUADRANT TELEVENTURES LIMITED",
"QUADRATE FINANCIAL ADVISORS PRIVATE LIMITED",
"QUADRATECH AUTOCOMP PRIVATE LIMITED",
"QUADRATIC FINANCIAL SERVICES PRIVATE LIMITED",
"QUADRATIC INSIGHTS PRIVATE LIMITED",
"QUADRATIC SOFTWARE SYSTEMS PRIVATE LIMITED",
"QUADRIA CAPITAL ADVISORS PRIVATE LIMITED",
"QUADRIC INFORMATION TECHNOLOGY PRIVATE LIMITED",
"QUADRILLION CAPITAL PRIVATE LIMITED",
"QUADRILLION FINANCE PRIVATE LIMITED",
"QUADRIM TECH PRIVATE LIMITED",
"QUADRO FOREX PRIVATE LIMITED",
"QUADRO INFO TECHNOLOGIES PRIVATE LIMITED",
"QUADROBAY TECHNOLOGIES LLP",
"QUADROBAY TECHNOLOGIES PRIVATE LIMITED",
"QUADROGEN INDIA PRIVATE LIMITED",
"QUADRON BUSINESS PARK PRIVATE LIMITED",
"QUADROS AUTOTECH LIMITED",
"QUADRUM SOLUTIONS PRIVATE LIMITED",
"QUADRUPLE AUTOMATION SERVICES PRIVATE LIMITED",
"QUADS PREPRESS PRIVATE LIMITED",
"QUADSEL SYSTEMS PRIVATE LIMITED",
"QUADSUN TECHNOLOGY INDIA PRIVATE LIMITED",
"QUADWAVE CONSULTING PRIVATE LIMITED",
"QUAERE ETECHNOLOGIES PRIVATE LIMITED",
"QUAFF MEDIA PRIVATE LIMITED",
"QUAGGA TECH PRIVATE LIMITED",
"QUAGNITIA SYSTEMS PRIVATE LIMITED",
"QUAID-E-MILLAT GOVT COLLEGE FOR WOMEN",
"QUAISAR MEDISOFT PRIVATE LIMITED",
"QUAKER CHEMICAL INDIA PRIVATE LIMITED",
"QUAL COMMERCE PRIVATE LIMITED",
"QUAL MOBILE SOLUTIONS PRIVATE LIMITED",
"QUALBRAIN TECHNOLOGIES PRIVATE LIMITED",
"QUALCHEM HEALTHCARE PRIVATE LIMITED",
"QUALCOMM INCORPORATED",
"QUALCON DREAMS LLP",
"QUALCON ENGINEERING SOLUTIONS (PUNE) PRIVATE LIMITED",
"QUALE INFOTECH PRIVATE LIMITED",
"QUALESCE INDIA PRIVATE LIMITED",
"QUALEX CONSULTING INDIA PRIVATE LIMITED",
"QUALEX SYSTEMS PRIVATE LIMITED",
"QUALFIS FOODZ PRIVATE LIMTIED",
"QUALFON ADVANCE TECHNOLOGY CENTRE PRIVATE LIMITED",
"QUALFON TECHNOLOGY SUPPORT SERVICES LLP",
"QUALHON INFORMATICS PRIVATE LIMITED",
"QUALI5CARE AND CONSULTING PRIVATE LIMITED",
"QUALIAN TECHNOLOGIES PRIVATE LIMITED",
"QUALIANCE INTERNATIONAL PRIVATE LIMITED",
"QUALIBRE CREATIVES PRIVATE LIMITED",
"QUALICENTRIC ITES PRIVATE LIMITED",
"QUALICHEM INDUSTRIES PRIVATE LIMITED",
"QUALICOM NETWORK TECHNOLOGIES PRIVATE LIMITED",
"QUALICOM SOLUTIONS PRIVATE LIMITED",
"QUALICY INDUSTRIES PRIVATE LIMITED",
"QUALIFIED RECRUITER PRIVATE LIMITED",
"QUALIFOUR AUTO PRODUCTS INDIA PRIVATE LIMITED",
"QUALIGENS PHARMA PRIVATE LIMITED",
"QUALIKEMS LIFESCIENCES PRIVATE LIMITED",
"QUALIMARK MACHINES PRIVATE LIMITED",
"QUALIMOUNT ENGINEERING PRIVATE LIMITED",
"QUALIPACK PACKAGINGS PRIVATE LIMITED",
"QUALISPACE WEB SERVICES PRIVATE LIMITED",
"QUALISURGE SURGICALS PRIVATE LIMITED",
"QUALITAS AE SERVICES PRIVATE LIMITED",
"QUALITAS EXPORTS PRIVATE LIMITED",
"QUALITAS FOODS INDIA PRIVATE LIMITED",
"QUALITAS GOLDEN ENCLAVE PRIVATE LIMITED",
"QUALITAS IT PRIVATE LIMITED",
"QUALITAS TECHNOLOGIES PRIVATE LIMITED",
"QUALITECH SHEET TURNED COMPONENT PRIVATE LIMITED",
"QUALITECH SOLUTIONS AND SERVICES PRIVATE LIMITED",
"QUALITEK LABS LIMITED",
"QUALITEK LABS PRIVATE LIMITED",
"QUALITEST INDIA PRIVATE LIMITED",
"QUALITIA SOFTWARE PRIVATE LIMITED",
"QUALITIME SOFTWARE PRIVATE LIMITED",
"QUALITRIX TECHNOLOGIES PRIVATE LIMITED",
"QUALITRON BIO MEDICA PRIVATE LIMITED",
"QUALITRONICS (MADRAS) PRIVATE LIMITED",
"QUALITUS PHARMA SOLUTIONS",
"QUALITY ADVERTISING PVT LTD",
"QUALITY AGENCIES PRIVATE LIMITED",
"QUALITY AIRPORT HOTELS AND FLIGHT SERVICES PRIVATE LIMITED",
"QUALITY ANALYST AND LABS PRIVATE LIMITED",
"QUALITY AND ACCREDITATION INSTITUTE PRIVATE LIMITED",
"QUALITY APPLICATION SOLUTIONS PRIVATE LIMITED",
"QUALITY ASSAY & HALLMARKING CENTRE PRIVATE LIMITED",
"QUALITY AUSTRIA CENTRAL ASIA PRIVATE LIMITED",
"QUALITY AUTO COMPONENTS PRIVATE LIMITED",
"QUALITY AUTOMATS PRIVATE LIMITED",
"QUALITY BAG EXPORTERS PVT LTD",
"QUALITY BITUMEN PRIVATE LIMITED",
"QUALITY BIZ CHEM INDIA PRIVATE LIMITED",
"QUALITY BUILDCON PRIVATE LIMITED",
"QUALITY CARE DIALYSIS PRIVATE LIMITED",
"QUALITY CARE INDIA LIMITED",
"QUALITY CARE INDIA PRIVATE LIMITED",
"QUALITY CARS PRIVATE LIMITED",
"QUALITY CHROME PRIVATE LIMITED",
"QUALITY CINE LABS PRIVATE LIMITED",
"QUALITY COKE INDUSTRIES PRIVATE LIMITED",
"QUALITY COMFORTS PRIVATE LIMITED",
"QUALITY CONSTRUCTION DEVELOPERS",
"QUALITY COTTON AND SPICES PRIVATE LIMITED",
"QUALITY COUNCIL OF INDIA",
"QUALITY CREATIONS PRIVATE LIMITED",
"QUALITY DECOR DZINES PRIVATE LIMITED",
"QUALITY DIALYSIS BT LLP",
"QUALITY EARTH MINERALS PRIVATE LIMITED",
"QUALITY EDUCATION SUPPORT TRUST",
"QUALITY EMPHASIS STEEL SOLUTIONS PRIVATE LIMITED",
"QUALITY ENGINEERING AND SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"QUALITY ENGINEERING RECLAIMERS PRIVATE LIMITED",
"QUALITY ENTERPRISES",
"QUALITY ENVIRO ENGINEERS PRIVATE LIMITED",
"QUALITY EVALUATION AND SYSTEMS TEAM PRIVATE LIMITED",
"QUALITY EXIM PRIVATE LIMITED",
"QUALITY FASHION ACCESSORIES PRIVATE LIMITED",
"QUALITY FIRST AGRO PACKAGINGS PRIVATE LIMITED",
"QUALITY FOILS (INDIA) LIMITED",
"QUALITY FOILS INDIA PRIVATE LIMITED",
"QUALITY FUMIGATION SOLUTIONS PRIVATE LIMITED",
"QUALITY FURNITURES AND PROJECTS PRIVATE LIMITED",
"QUALITY GLASS INDUSTRIES PRIVATE LIMITED",
"QUALITY GROWTH SERVICES PRIVATE LIMITED",
"QUALITY HEALTHCARE ACCESS PRIVATE LIMITED",
"QUALITY HEALTHGUARDS PRIVATE LIMITED",
"QUALITY HEARING CARE INDIA PRIVATE LIMITED",
"QUALITY HEIGHTCON PRIVATE LIMITED",
"QUALITY HOLIDAYS AND CARS PRIVATE LIMITED",
"QUALITY HOME APPLIANCES PRIVATE LIMITED",
"QUALITY HOME PRODUCTS PVT LTD",
"QUALITY HYGIENE SOLUTIONS PRIVATE LIMITED",
"QUALITY INDUSTRIAL X-RAY COMPANY PRIVATE LIMITED",
"QUALITY INFRASTRUCTURE PRIVATE LIMITED",
"QUALITY INTEXT PRIVATE LIMITED",
"QUALITY KIDNEY CARE PRIVATE LIMITED",
"QUALITY KIOSK TECHNOLOGIES PRIVATE LIMITED",
"QUALITY KNIT WEARS PRIVATE LIMITED",
"QUALITY LIFESCIENCES PRIVATE LIMITED",
"QUALITY LUBE PRODUCTS PRIVATE LIMITED",
"QUALITY MAINTENANCE VENUTE LIMITED",
"QUALITY MARBLES P LTD",
"QUALITY MARINE SERVICES PRIVATE LIMITED",
"QUALITY MATRIX TEST SOLUTIONS PRIVATE LIMITED",
"QUALITY MATTRESSES PRIVATE LIMITED",
"QUALITY MEALS PRIVATE LIMITED",
"QUALITY MINT & ALLIED CHEMICALS",
"QUALITY MODULARS SYSTEMS PRIVATE LIMITED",
"QUALITY MULTIMETALS PRIVATE LIMITED",
"QUALITY NEEDLES PRIVATE LIMITED",
"QUALITY NEEDS AUTOMOTIVES PRIVATE LIMITED",
"QUALITY NEXGEN PHARMACEUTICALS PRIVATE LIMITED",
"QUALITY NICKEL WIRES PRIVATE LIMITED",
"QUALITY NURSING SERVICES PRIVATE LIMITED",
"QUALITY NZ IMPORTS PRIVATE LIMITED",
"QUALITY OUTSIDE THE BOX QOBOX PRIVATE LIMITED",
"QUALITY OVERSEAS PRIVATE LIMITED",
"QUALITY PATTERN WORKS PRIVATE LIMITED",
"QUALITY PHARMA PRODUCTS PRIVATE LIMITED",
"QUALITY POLYCHEM PRIVATE LIMITED",
"QUALITY POULTRY PRODUCTS PRIVATE LIMITED",
"QUALITY POWER ELCTRICAL EQUIPMENT PRIVATE LIMITED",
"QUALITY POWER ENGINEERING PROJECTS PRIVATE LIMITED",
"QUALITY POWER TOOLS PRIVATE LIMITED",
"QUALITY PREPRESS PRIVATE LIMITED",
"QUALITY PRINTING & STATIONERY CONCERN(1997)PRIVATE LIMITED",
"QUALITY PROPERTY MANAGEMENT SERVICES PRIVATE LIMITED",
"QUALITY RUBBER PRODUCTS PRIVATE LIMITED",
"QUALITY SAND PROCESSING PRIVATE LIMITED",
"QUALITY SANITARY ENGINEERS PRIVATE LIMITED",
"QUALITY SCANS CENTRE PRIVATE LIMITED",
"QUALITY SERVICES AND SOLUTIONS PRIVATE LIMITED",
"QUALITY SPICES & FOOD EXPORTS PRIVATE LIMITED",
"QUALITY SPRING & ENGINEERING CO. PRIVATE LIMITED",
"QUALITY STAINLESS PRIVATE LIMITED",
"QUALITY STEEL SHOPPE PRIVATE LIMITED",
"QUALITY STOCKISTS PVT LTD",
"QUALITY STORES PRIVATE LIMITED",
"QUALITY SUITINGS PRIVATE LIMITED",
"QUALITY SYNTHETICS INDUSTRIES LTD.",
"QUALITY SYSTEMS AND EQUIPMENTS PRIVATE LIMITED",
"QUALITY TEA PLANTATIONS PRIVATE LIMITED QTPPL",
"QUALITY TECHNOLOGIES PRIVATE LIMITED",
"QUALITY TEST LAB PRIVATE LIMITED",
"QUALITY THOUGHT INFOSYSTEMS (INDIA) PRIVATE LIMITED",
"QUALITY TISSUE CONVERTING COMPANY PRIVATE LIMITED",
"QUALITY TRADERS S.A. PRIVATE LIMITED",
"QUALITY TRAVEL WORLD PRIVATE LIMITED",
"QUALITY TUTORIALS PRIVATE LIMITED",
"QUALITY VECTOR TECHNOLOGIES PRIVATE LIMITED",
"QUALITY WATER MANAGEMENT SYSTEMS PRIVATE LIMITED",
"QUALITY WAVES PRIVATE LIMITED",
"QUALITY WOVENSACKS PRIVATE LIMITED",
"QUALITY ZINC PRIVATE LIMITED",
"QUALITYKIOSK TECHNOLOGIES PRIVATE LIMITED",
"QUALITYRISE OVERSEAS PRIVATE LIMITED",
"QUALIX AUXICHEM PRIVATE LIMITED",
"QUALIXA TURNKEY PROJECTS PRIVATE LIMITED",
"QUALMED HEALTH SCIENCES LIMITED",
"QUALMINDS TECHNOLOGIES PRIVATE LIMITED",
"QUALSIGHTS INDIA PRIVATE LIMITED",
"QUALSQUAD INFOTECH PRIVATE LIMITED",
"QUALSTRUCT ENGINEERING SOLUTIONS PRIVATE LIMITED",
"QUALSYS CONSULTANTS (INDIA) PRIVATE LIMITED",
"QUALSYS TECHNOLOGIES PRIVATE LIMITED",
"QUALTECH CONSULTANTS PRIVATE LIMITED",
"QUALTECH ENGINEERS PRIVATE LIMITED",
"QUALTECH RPO PRIVATE LIMITED",
"QUALTECH TELESYS PRIVATE LIMITED",
"QUALTOUCH BPO SOLUTIONS PRIVATE LIMITED",
"QUALYS SECURITY TECHSERVICES PRIVATE LIMITED",
"QUANSYS INDIA PROJECT MANAGEMENT CONSULTANT PRIVATE LIMITED",
"QUANT ART MARKET SOLUTIONS PRIVATE LIMITED",
"QUANT CAPITAL ADVISORS PRIVATE LIMITED",
"QUANT CAPITAL HOLDINGS PRIVATE LIMITED",
"QUANT CAPITAL PRIVATE LIMITED",
"QUANT CAPITAL SECURITIES PRIVATE LIMITED",
"QUANT CLOUD SOLUTIONS PRIVATE LIMITED",
"QUANT COMMODITIES PRIVATE LIMITED",
"QUANT MONEY MANAGERS LIMITED",
"QUANT SYSTEMS INDIA PVT LTD",
"QUANTA PROCESS SOLUTIONS PRIVATE LIMITED",
"QUANTA SERVICES INC.",
"QUANTAM HATCHERIES PRIVATE LIMITED",
"QUANTAM VENTURES PRIVATE LIMITED",
"QUANTANA PRIVATE LIMITED",
"QUANTAPLAST POLYMER PRIVATE LIMITED",
"QUANTAS GLASS AND CERAMIC PRIVATE LIMITED",
"QUANTASIS PRIVATE LIMITED",
"QUANTASOUL AIROLOGIX PRIVATE LIMITED",
"QUANTDUO TECHNOLOGIES PRIVATE LIMITED",
"QUANTECH CAPITAL INVESTMENT ADVISORS PRIVATE LIMITED",
"QUANTEL ELECTRONICS INDIA PRIVATE LIMITED",
"QUANTEL TECHNOLOGIES INDIA PRIVATE LIMITED",
"QUANTIC AUTO PARTS PRIVATE LIMITED",
"QUANTIC SOLUTIONS PRIVATE LIMITED",
"QUANTICAL CUSTOMER SERVICES PRIVATE LIMITED",
"QUANTICATE INDIA PRIVATE LIMITED",
"QUANTICO GLOBAL INDIA PRIVATE LIMITED",
"QUANTIFIED HR PRIVATE LIMITED",
"QUANTIKA INFRA PRIVATE LIMITED",
"QUANTILE ANALYTICS PRIVATE LIMITED",
"QUANTILUS SYSTEMS PRIVATE LIMITED",
"QUANTILYA CAPITAL PRIVATE LIMITED",
"QUANTIME WORLD PRIVATE LIMITED",
"QUANTINOX TECHNOLOGY PRIVATE LIMITED",
"QUANTIPHI ANALYTICS SOLUTIONS PRIVATE LIMITED",
"QUANTIQUE METADATA PRIVATE LIMITED",
"QUANTISER TELECOM SERVICES PRIVATE LIMITED",
"QUANTITATIVE BROKERS SOFTWARE INDIA PRIVATE LIMITED",
"QUANTIUM ANALYTICS PRIVATE LIMITED",
"QUANTIUM MAIL LOGISTICS SOLUTIONS INDIA PRIVATE LIMITED",
"QUANTIVE TECHNOLOGIES LLC",
"QUANTIZER RESEARCH PRIVATE LIMITED",
"QUANTMAC CAPITAL SOLUTIONS PRIVATE LIMITED",
"QUANTMAGNUM TECHNOLOGIES PRIVATE LIMITED",
"QUANTO AGROWORLD LIMITED",
"QUANTRA TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"QUANTRIUM TECH PRIVATE LIMITED",
"QUANTRIX HEALTHCARE PRIVATE LIMITED",
"QUANTRIX SOLUTIONS PRIVATE LIMITED",
"QUANTRON BUSINESS TECH SOLUTIONS PRIVATE LIMITED",
"QUANTRONIX BPO PRIVATE LIMITED",
"QUANTRUST TECHNOLOGIES PRIVATE LIMITED",
"QUANTSAPP PRIVATE LIMITED",
"QUANTSOFT ENGINEERING SOLUTIONS PRIVATE LIMITED",
"QUANTSOLAR TECHNOLOGIES PRIVATE LIMITED",
"QUANTSWIFT PRIVATE LIMITED",
"QUANTUM ADVISORS PRIVATE LIMITED",
"QUANTUM ASIA PRIVATE LIMITED",
"QUANTUM ASSET MANAGEMENT COMPANY PRIVATE LIMITED",
"QUANTUM BIOLOGICALS PRIVATE LIMITED",
"QUANTUM BSO AND TECH PRIVATE LIMITED",
"QUANTUM CLOTHING INDIA PRIVATE LIMITED",
"QUANTUM CODERS LIMITED",
"QUANTUM CONSUMER SOLUTIONS PRIVATE LIMITED",
"QUANTUM CORPHEALTH PRIVATE LIMITED",
"QUANTUM DATA ENGINES INDIA PRIVATE LIMITED",
"QUANTUM DESIGN INDIA PRIVATE LIMITED",
"QUANTUM ENGINEERING PRIVATE LIMITED",
"QUANTUM EQUIPMENT COMPANY PRIVATE LIMITED",
"QUANTUM EXPOTRADE PRIVATE LIMITED",
"QUANTUM FILMS LIMITED",
"QUANTUM GLOBAL INFRATECH LIMITED",
"QUANTUM GLOBAL SECURITIES LIMITED",
"QUANTUM HITECH MERCHANDISING PRIVATE LIMITED",
"QUANTUM INDIA DEVELOPMENT CENTER PRIVATE. LIMITED",
"QUANTUM INDUSTRIES AND SERVICES PRIVATE LIMITED",
"QUANTUM INFORMATION SERVICES PRIVATE LIMITED",
"QUANTUM INTERNATIONAL PRIVATE LIMITED",
"QUANTUM KNITS PRIVATE LIMITED",
"QUANTUM LEAP CONSULTING PRIVATE LIMITED",
"QUANTUM LINK COMMUNICATIONS PRIVATE LIMITED",
"QUANTUM MOBISERVICES PRIVATE LIMITED",
"QUANTUM NATURALS INDIA PRIVATE LIMITED",
"QUANTUM PAGE PRIVATE LIMITED",
"QUANTUM PHINANCE CONSULTING PRIVATE LIMITED",
"QUANTUM POWER SYSTEMS",
"QUANTUM PROJECTINFRA PRIVATE LIMITED",
"QUANTUM SECURITIES PRIVATE LIMITED",
"QUANTUM SMT TECHNOLOGIES PRIVATE LIMITED",
"NV5 CONSULTANTS INDIA PRIVATE LIMITED",
"QUANTUM STORAGE INDIA PRIVATE LIMITED",
"QUANTUM SURGICALS PRIVATE LIMITED",
"QUANTUM SWITCHGEARS AND CONTROLS PRIVATE LIMITED",
"QUANTUM TRAVELS PRIVATE LIMITED",
"QUANTUM WORLD TELE SERVICES PRIVATE LIMITED",
"QUANTUM4U LAB PRIVATE LIMITED",
"QUANTUMBIT TECHNOLOGIES PRIVATE LIMITED",
"QUANTUMID TECHNOLOGIES INDIA PRIVATE LIMITED",
"QUANTUMPOINT PRIVATE LIMITED",
"QUANTUMSOFTECH R&D PRIVATE LIMITED",
"QUANTUMYUG PRIVATE LIMITED",
"QUANTX TECHNOLOGY PRIVATE LIMITED",
"QUANTYS CLINICAL PRIVATE LIMITED",
"QUAQUA EXPERIENCES PRIVATE LIMITED",
"QUARK AUTOMATION PRIVATE LIMITED",
"QUARK MEDIA TECH PRIVATE LIMITED",
"QUARKCITY ENERGY PRIVATE LIMITED",
"QUARKCITY INDIA PRIVATE LIMITED",
"QUARKIFI TECHNOLOGIES PRIVATE LIMITED",
"QUARKS TECHNOSOFT PRIVATE LIMITED",
"QUARKXPRESS PUBLISHING R&D (INDIA) PRIVATE LIMITED",
"QUARKXPRESS PUBLISHING R&D INDIA PRIVATE LIMITED",
"QUARKXPRESS PUBLISHING SOFTWARE (INDIA) PRIVATE LIMITED",
"QUARRY CONSTRUCTION PRIVATE LIMITED",
"QUARRY LUXURY STONES PRIVATE LIMITED",
"QUARTER LANE PRIVATE LIMITED",
"QUARTERFOLD PRINTABILITIES PRIVATE LIMITED",
"QUARTESIAN CLINICAL RESEARCH PRIVATE LIMITED",
"QUARTET INDUSTRIAL SOLUTIONS PRIVATE LIMITED",
"QUARTET THERMAL ENGINEERING PVT LTD",
"QUARTRR INCH PATTERN PRIVATE LIMITED",
"QUARTZ HOME CARE (INDIA) PRIVATE LIMITED",
"QUARTZ INFRAHOLD PRIVATE LIMITED",
"QUARTZ STONE (INDIA) PRIVATE LIMITED",
"QUARTZITE INFRASTRUCTURE PRIVATE LIMITED",
"QUARTZKRAFT LLP",
"QUASAR CONSOLIDATED SERVICES PRIVATE LIMITED",
"QUASAR CONSULTANCY PRIVATE LIMITED",
"QUASAR LABS PRIVATE LIMITED",
"QUASAR MEDIA PRIVATE LIMITED",
"QUASAR TELECOM CONSULTANTS PRIVATE LIMITED",
"QUASCO CONSULTING INDIA PRIVATE LIMITED",
"QUASER MEDIA PRIVATE LIMITED",
"QUASITUM INTELISOFT (INDIA) PRIVATE LIMITED",
"QUATRE AGRO ENTERPRISES PRIVATE LIMITED",
"QUATREO INFOCERT ENTERPRISES PRIVATE LIMITED",
"QUATRO RAIL TECH SOLUTIONS LIMITED",
"QUATRO YASHIMA PRIVATE LIMITED",
"QUATRRO BUSINESS SUPPORT SERVICES PRIVATE LIMITED",
"QUATRRO BUSINESS SUPPORT SOLUTIONS PRIVATE LIMITED",
"QUATRRO GLOBAL SERVICES PRIVATE LIMITED",
"QUATRRO PROCESSING SERVICES PRIVATE LIMITED",
"QUATTRO ENGINEERING INDIA LIMITED",
"QUATTRO ENGINEERING INDIA LIMITED.",
"QUATTRO ENGINEERING INDIA PRIVATE LIMITED",
"QUATTRO MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"QUAVAC INDIA PRIVATE LIMITED",
"QUAX ENGINEERING CONSULTANT LLP",
"QUAXIGMA IT SOLUTIONS PRIVATE LIMITED",
"QUAZAR INFRASTRUCTURE PRIVATE LIMITED",
"QUAZIGUND EXPRESSWAY PRIVATE LIMITED",
"QUBA ARCHITECTURAL PRODUCTS PRIVATE LIMITED",
"QUBA KITCHENS PRIVATE LIMITED",
"QUBATIC ENGINEERS PRIVATE LIMITED",
"QUBE 6 BUILDING SYSTEMS PRIVATE LIMITED",
"QUBE AUTOMATION TECHNOLOGIES PRIVATE LIMITED",
"QUBE CINEMA TECHNOLOGIES PRIVATE LIMITED",
"QUBE COMMERCIAL PRIVATE LIMITED",
"QUBE HEALTH & WELLNESS PRIVATE LIMITED",
"QUBE SERVICES PRIVATE LIMITED",
"QUBEROOT ANALYTICS LLP",
"QUBEX TECHNETS PRIVATE LIMITED",
"QUBIC SUNTRACK ENERGY SYSTEM PRIVATE LIMITED",
"QUBIK INFRA PRIVATE LIMITED",
"QUBITED",
"QUBIX BUSINESS PARK PRIVATE LIMITED",
"QUBIX CONSULTING PRIVATE LIMITED",
"QUBIX INTEGRATED MEDIA SERVICES PRIVATE LIMITED",
"QUBOLE SOFTWARE INDIA PRIVATE LIMITED",
"QUBORA TECHNOLOGIES PRIVATE LIMITED",
"QUCON BOILERS PRIVATE LIMITED",
"QUE PHARMA PRIVATE LIMITED",
"QUE PROCESSING SERVICES PRIVATE LIMITED",
"QUEBEC COMMUNICATIONS PRIVATE LIMITED",
"QUEBEC INFORMATION SERVICES INDIA LIMITED",
"QUEBEC PETROLEUM RESOURCES LIMITED",
"QUEEN DECORS PRIVATE LIMITED",
"QUEEN DISTILLERS AND BOTTLERS PRIVATE LIMITED",
"QUEEN FOREX PRIVATE LIMITED",
"QUEEN MARYS COLLEGE",
"QUEEN MEDIA PRIVATE LIMITED",
"QUEEN MERCHANDISE PRIVATE LIMITED",
"QUEEN MIRA INTERNATIONAL SCHOOL",
"QUEEN VICTORIA GIRLS INTER COLLEGE",
"QUEENBEE FOODS PRIVATE LIMITED",
"QUEENS AS INTER COLLEGE",
"QUEENS CARE HOSPITAL",
"QUEENS COLLEGE OF FOOD TECHNOLOGY",
"QUEEN'S CONVENT SCHOOL",
"QUEENS ELEVATOR & ESCALATOR PRIVATE LIMITED",
"QUEENS NRI HOSPITAL",
"QUEENS QUINOA PRIVATE LIMITED",
"QUEENS VILLA DEVELOPERS PRIVATE LIMITED",
"QUEENTIA SKILLS & ALLIED SERVICES PRIVATE LIMITED",
"QUENBY TRANSFERS INDIA PRIVATE LIMITED",
"QUENCY CONSULTANCY PVT LTD",
"QUEPPELIN TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"QUEPREON BIOLOGICALS PRIVATE LIMITED",
"QUEREQ EXPORTS PRIVATE LIMITED",
"QUESS CORP LIMITED",
"QUESS EAST BENGAL FC PRIVATE LIMITED",
"QUESS INTERNATIONAL SERVICES PRIVATE LIMITED",
"QUESSENTIALS PRIVATE LIMITED",
"QUEST 2 TRAVEL COM INDIA PRIVATE LIMITED",
"QUEST AGROVET SERVICES PRIVATE LIMITED",
"QUEST ALLIANCE",
"QUEST AND QUENCH (INDIA) PRIVATE LIMITED",
"QUEST BIOTECH INDIA PRIVATE LIMITED",
"QUEST CAPITAL MARKETS LIMITED",
"QUEST CARGO PRIVATE LIMITED",
"QUEST CONSULTANCY PVT LTD",
"QUEST COWORKS PRIVATE LIMITED",
"QUEST DIAGNOSTIC SERVICES PRIVATE LIMITED",
"QUEST DIAGNOSTICS HTAS INDIA PRIVATE LIMITED",
"QUEST DIAGNOSTICS INDIA PRIVATE LIMITED",
"QUEST DIGITAL SERVICES PRIVATE LIMITED",
"QUEST EMS PRIVATE LIMITED",
"QUEST ENGINEERS AND CONSULTANTS PRIVATE LIMITED",
"QUEST ENTERPRISES PRIVATE LIMITED",
"QUEST GLOBAL DEFENCE ENGINEERING SERVICES PRIVATE LIMITED",
"QUEST GLOBAL ENGINEERING PRIVATE LIMITED",
"QUEST GLOBAL ENGINEERING SERVICES PRIVATE LIMITED",
"QUEST GLOBAL TECHNOLOGIES LIMITED",
"QUEST IMPEX PRIVATE LIMITED",
"QUEST INFORMATICS PRIVATE LIMITED",
"QUEST INFOSOFT PRIVATE LIMITED",
"QUEST INNOVATIVE SOLUTIONS PRIVATE LIMITED",
"QUEST INVESTMENT ADVISORS PRIVATE LIMITED",
"QUEST LABORATORIES LIMITED",
"QUEST LABORATORIES PRIVATE LIMITED",
"QUEST LIFE SCIENCES PRIVATE LIMITED",
"QUEST MEDIA PRODUCTIONS PRIVATE LIMITED",
"QUEST MEDICAL ACADEMY PRIVATE LIMITED",
"QUEST OFFICES PRIVATE LIMITED",
"QUEST PERFORMANCE ADDITIVES INDIA PRIVATE LIMITED",
"QUEST PORTFOLIO SERVICES PRIVATE LIMITED",
"QUEST PROFIN ADVISOR PRIVATE LIMITED",
"QUEST PROPERTIES INDIA LIMITED",
"QUEST RETAIL PRIVATE LIMITED",
"QUEST SAMPLING PRIVATE LIMITED",
"QUEST SOLUTIONS PRIVATE LIMITED",
"QUEST TELERADIOLOGY SOLUTIONS PRIVATE LIMITED",
"QUESTA GLOBAL PRIVATE LIMITED",
"QUESTA SOFTWARE SYSTEMS PRIVATE LIMITED",
"QUESTEL IP SERVICES INDIA PRIVATE LIMITED",
"QUESTIONPRO PRIVATE LIMITED",
"QUESTIT PRIVATE LIMITED",
"QUESTPRO CONSULTANCY SERVICES PRIVATE LIMITED",
"QUESTS CREATIVE PRIVATE LIMITED",
"QUEXST SOLUTIONS PRIVATE LIMITED",
"QUGEN PATHLABS PRIVATE LIMITED",
"QUIBUS RESOURCES INDIA PRIVATE LIMITED",
"QUICK ACT LIGHT SYSTEMS AND CABLES PRIVATE LIMITED",
"QUICK AVIATION SERVICES PRIVATE LIMITED",
"QUICK BPO SERVICES PRIVATE LIMITED",
"QUICK BUILDERS",
"QUICK CABS PRIVATE LIMITED",
"QUICK CLEAN HEALTHCARE PRIVATE LIMITED",
"QUICK CLEAN HOSPITALITY SOLUTIONS PRIVATE LIMITED",
"QUICK COURIERS & LOGISTICS PRIVATE LIMITED",
"QUICK DATA IT SERVICES PRIVATE LIMITED",
"QUICK DEALER PVT LTD",
"QUICK DESIGNERS AND BUILDERS PRIVATE LTD.",
"QUICK DIGITAL TECHNOLOGIES PRIVATE LIMITED",
"QUICK EATS PRIVATE LIMITED",
"QUICK FOODS CO.",
"QUICK FOREX LIMITED",
"QUICK HEAL TECHNOLOGIES LIMITED",
"QUICK HEAL TECHOLOGIES LIMITED",
"QUICK HI-TECH ENGINEERING INDIA PRIVATE. LIMITED.",
"QUICK INDIA LOGISTICS PRIVATE LIMITED",
"QUICK INFRASTRUCTURE AND DEVELOPERS PRIVATE LIMITED",
"QUICK INVESTMENT (INDIA) LTD.",
"QUICK JOURNEYS & DISCOVERIES PRIVATE LIMITED",
"QUICK MOBILE LLP",
"QUICK MOVERS (LOGISTICS) PRIVATE LIMITED",
"QUICK PARKING SERVICES PRIVATE LIMITED",
"QUICK PAY PRIVATE LIMITED",
"QUICK PROJECTS PRIVATE LIMITED",
"QUICK SMART WASH PRIVATE LIMITED",
"QUICK SORT INDIA PRIVATE LIMITED",
"QUICK SOURCE HIRING INDIA PRIVATE LIMITED",
"QUICK STAFFING SERVICES INDIA PRIVATE LIMITED",
"QUICK TAXPERTS PRIVATE LIMITED",
"QUICK2SHELF FOOD SOLUTIONS PRIVATE LIMITED",
"QUICK2SHELF PRIVATE LIMITED",
"QUICKCALLS PRIVATE LIMITED",
"QUICKCOMM TECHNOLOGIES PRIVATE LIMITED",
"QUICKEN SOFTWARE DEVELOPMENT PRIVATE LIMITED",
"QUICKER P.S.F. PRIVATE LIMITED",
"QUICKFAB METALS PRIVATE LIMITED",
"QUICKGROW PACKAGING INDUSTRIES PRIVATE LIMITED",
"QUICKIFY SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED",
"QUICKINSURE INSURANCE BROKERS PRIVATE LIMITED",
"QUICKLEAP SOLUTIONS LIMITED",
"QUICKLINK CONSULTANCY PRIVATE LIMITED",
"QUICKLOGIC SOFTWARE INDIA PRIVATE LIMITED",
"QUICKMAN SECURITY SERVICES PRIVATE LIMITED",
"QUICKMAN SOLUTIONS PRIVATE LIMITED",
"QUICKMIND TECHNOLOGIES INDIA PRIVATE LIMITED",
"QUICKMOVE TECHNOLOGIES PRIVATE LIMITED",
"QUICKO INFOSOFT PRIVATE LIMITED",
"QUICKPLAY MEDIA PRIVATE LIMITED",
"QUICKSAND DESIGN STUDIO PRIVATE LIMITED",
"QUICKSHIP GLOBAL EXPRESS PRIVATE LIMITED",
"QUICKSPACE INDIA PRIVATE LIMITED",
"QUICKSPACE TECHNOLOGIES F1 WORKS PRIVATE LIMITED",
"QUICKSUN TECHNOLOGIES PRIVATE LIMITED",
"QUICKTOUCH TECHNOLOGIES LIMITED",
"QUICKVIZ STUDIOS PRIVATE LIMITED",
"QUICKWIN MANAGEMENT SOLUTIONS AND SERVICES PRIVATE LIMITED",
"QUICON BUILDTECH INDIA PRIVATE LIMITED",
"QUID TECHNO SERVICES (OPC) PRIVATE LIMITED",
"QUIDDITY SOFTWARE SOLUTIONS PRIVATE LIMITED",
"QUIDEL DIAGNOSTICS INDIA PRIVATE LIMITED",
"QUIDICH INNOVATION LABS PRIVATE LIMITED",
"QUIET COOL ELECTRONICS PRIVATE LIMITED",
"QUIK BEVERAGES AND FOODS PRIVATE LIMITED",
"QUIK SILVER ADVERTISING & MARKETING PRIVATE LIMITED",
"QUIKJET CARGO AIRLINES PRIVATE LIMITED",
"QUIKPARSE PRIVATE LIMITED",
"QUIKPIKK INDIA PRIVATE LIMITED",
"QUIKR INDIA PRIVATE LIMITED",
"QUIKR REALTY LIMITED ZAUBA",
"QUIKR REALTY PRIVATE LIMITED",
"QUIKRELATIONS PRIVATE LIMITED",
"QUILABAN PHARMA TRADING PRIVATE LIMITED",
"QUILIN ADVISORS LLP",
"QUILL STATIONERY AND OFFICE SUPPLIES PVT LTD",
"QUILON FOODS PRIVATE LIMITED",
"QUILON HOTELS AND RESORTS PRIVATE LIMITED",
"QUILON SUPER SPECIALITY HOSPITAL AND INSTITUTE PRIVATE LIMITED",
"QUILON WIRES PRIVATE LIMITED",
"QUILTEX (INDIA) PRIVATE LIMITED",
"QUIMICO CHEMICALS INDIA PRIVATE LIMITED",
"QUIN BAY TECHNOLOGIES PRIVATE LIMITED",
"QUIN CHEM PRIVATE LTD",
"QUINCE GREEN ESTATE PRIVATE LIMITED",
"QUINCE INFOTECH AND LEASING PRIVATE LIMITED",
"QUINCE LIFESCIENCES PRIVATE LIMITED",
"QUINCUS INDIA PRIVATE LIMITED",
"QUINE ZONE PRIVATE LIMITED",
"QUINNOX CONSULTANCY SERVICES LIMITED",
"QUINPRO INFO SERVICES PRIVATE LIMITED",
"QUINSTINCT ADVISORY PRIVATE LIMITED",
"QUINSTREET SOFTWARE INDIA PRIVATE LIMITED",
"QUINT CONSULTING SERVICES PRIVATE LIMITED",
"QUINT DIGITAL LIMITED",
"QUINTA SYSTEMS PRIVATE LIMITED",
"QUINTE FINANCIAL TECHNOLOGIES PRIVATE LIMITED",
"QUINTES ANALYTICS PRIVATE LIMITED",
"QUINTES GLOBAL PRIVATE LIMITED",
"QUINTESSENCE BUSINESS SOLUTIONS & SERVICES PRIVATE LIMITED",
"QUINTESSENCE DESIGNS PRIVATE LIMITED",
"QUINTESSENCE FRAGRANCES PRIVATE LIMITED",
"QUINTESSENTIALLY LIFESTYLE SERVICES INDIA PRIVATE LIMITED",
"QUINTET SOLUTIONS PRIVATE LIMITED",
"QUINTEZE FACILITY MANAGEMENT INDIA PRIVATE LIMITED",
"QUINTICS MANAGEMENT CONSULTANCIES PRIVATE LIMITED",
"QUINTILES RESEARCH INDIA PRIVATE LIMITED",
"QUINTILLION BUSINESS MEDIA PRIVATE LIMITED",
"QUINTILLION MEDIA LIMITED",
"QUINTILLION MEDIA PRIVATE LIMITED",
"QUINTUS LIFE SCIENCES PRIVATE LIMITED",
"QUINTYPE TECHNOLOGIES INDIA LIMITED",
"QUIOSCO RETAIL INDIA PRIVATE LIMITED",
"QUIP SERVE PRIVATE LIMITED",
"QUIPPO CONSTRUCTION EQUIPMENT LIMITED",
"QUIPPO OIL AND GAS INFRASTRUCTURE LIMITED",
"QUIPPO TELECOM INFRASTRUCTURE PRIVATE LIMITED",
"QUIPPO VALUERS AND AUCTIONEERS PRIVATE LIMITED",
"QUIQUP INNOVATIONS PRIVATE LIMITED",
"QUIRKY FOODS PRIVATE LIMITED",
"QUIRKY TECHNOLOGY PRIVATE LIMITED",
"QUISITIVE TECHNOLOGY SOLUTIONS INDIA PRIVATE LIMITED",
"QUISLEX LEGAL SERVICES PRIVATE LIMITED",
"QUIVAN SKILL EMPOWERMENT PRIVATE LIMITED",
"QUIVER BIOTECH PRIVATE LIMITED",
"QUIVER CARE PRIVATE LIMITED",
"QUIVER DIGITAL SOLUTIONS INDIA PRIVATE LIMITED",
"QUIX INTERNATIONAL PRIVATE LIMITED",
"QUIX SOLUTION PRIVATE LIMITED",
"QUIXOT MULTIMEDIA PRIVATE LIMITED",
"QUIXOTE AUTOMOTIVE TECHNOLOGIES PRIVATE LIMITED",
"QUIXOTIC OPTIONS PRIVATE LIMITED",
"QUIXOTIC PHARMA PRIVATE LIMITED",
"QUL FRUIT WALL FARM INSTALLATIONS PRIVATE LIMITED",
"QULOI PRIVATE LIMITED",
"QUMU CORPORATION",
"QUNTROL LABORATORIES PRIVATE LIMITED",
"QUNU LABS PRIVATE LIMITED",
"QUOCENT PRIVATE LIMITED",
"QUODECK TECHNOLOGIES PRIVATE LIMITED",
"QUOINX TECHNOLOGIES PRIVATE LIMITED",
"QUOLAM BUSINESS SOLUTIONS PRIVATE LIMITED",
"QUOMATIC SOLUTIONS PRIVATE LIMITED",
"QUORA INFORMATION TECHNOLOGY PRIVATE LIMITED",
"QUORA PHARMACEUTICALS PRIVATE LIMITED",
"QUORE B2B PRIVATE LIMITED",
"QUOS FOODS PRIVATE LIMITED",
"QUOSPHERE INFOSOLUTIONS PRIVATE LIMITED",
"QUOTIENT COMMUNICATIONS PRIVATE LIMITED",
"QUOTIENT DIGITAL SOLUTIONS PRIVATE LIMITED",
"QUOTIENT FOUR TECHNOLOGIES PRIVATE LIMITED",
"QUOTIENT TECHNOLOGY INDIA PRIVATE LIMITED",
"QUOVADIS TRAVELS PRIVATE LIMITED",
"QUOVANTIS TECHNOLOGIES PRIVATE LIMITED",
"QUOWORKS TECHNOLOGIES PRIVATE LIMITED",
"QUREWELL HEALTH SCIENCE PRIVATE LIMITED",
"QURHEALTH SOLUTIONS INDIA PRIVATE LIMITED",
"QURIOUS DESIGN PRIVATE LIMITED",
"QURO TECH PRIVATE LIMITED",
"QURO VITRIFIED PRIVATE LIMITED",
"QUSCIENT TECHNOLOGIES PRIVATE LIMITED",
"QUSONIC TECHNOLOGIES LLP",
"QUTAB AUTO PRIVATE LIMITED",
"QUTAB ENTERTAINMENT PRIVATE LIMITED",
"QUTE EXTRUSIONS PRIVATE LIMITED",
"QUTE GRAPHICS PRIVATE LIMITED",
"QUTONE CERAMIC PRIVATE LIMITED",
"QUTUB IMPEX PRIVATE LIMITED",
"QUY TECHNOLOGY PRIVATE LIMITED",
"QV LABS PRIVATE LIMITED",
"QVANTEL SOFTWARE SOLUTIONS LIMITED",
"QVC EXPORTS LIMITED",
"QVC INTERNATIONAL PRIVATE LIMITED",
"QVC REALITY CO. LIMITED",
"QVC REALTY DEVELOPERS PRIVATE LIMITED",
"QVI INDIA PRIVATE LIMITED",
"QVT ADVISORS PRIVATE LIMITED",
"QWAY TECHNOLOGIES PRIVATE LIMITED",
"QWAZENT TALENT SOLUTIONS PRIVATE LIMITED",
"QWIK BRICK INFRA TECH PRIVATE LIMITED",
"QWIK FUELS TECHNOLOGIES INDIA PRIVATE LIMITED",
"QWIK SUPPLY CHAIN PRIVATE LIMITED",
"QWIKPIK TECHNOLOGY PRIVATE LIMITED",
"QWR INTERACTIVE SOLUTIONS PRIVATE LIMITED",
"QX CORPORATE ADVISORS INDIA PRIVATE LIMITED",
"QX GLOBAL SERVICES LLP",
"QX GLOBAL SERVICES PRIVATE LIMITED",
"QX KPO SERVICES PRIVATE LIMITED",
"QX RECRUITMENT SERVICES LLP",
"QXPRESS INDIA PRIVIATE LIMITED",
"QYOU MEDIA INDIA PRIVATE LIMITED",
"QZENSE LABS PRIVATE LIMITED",
"R & B INFRA PROJECT LIMITED",
"R & C INFRAENGINEERS PRIVATE LIMITED",
"R & D AUTOMATION ELECTRICALS (I) PRIVATE LIMITED",
"R & D GLOBAL CONSULTANTS PRIVATE LIMITED",
"R & G AUTOMOTIVES PRIVATE LIMITED",
"R & G ENGINEERS & FABRICATORS PRIVATE LIMITED",
"R & M INDUSTRIES PRIVATE LIMITED",
"R & R JAJODIA TRADING PRIVATE LIMITED",
"R & V TUBE SALES PRIVATE LIMITED",
"R . B. JEWELLERS PRIVATE LIMITED",
"R A AGENCIES PRIVATE LIMITED",
"R A C S PHARMACHEM (INDIA) PRIVATE LIMITED",
"R A D CONSULTANCY PRIVATE LIMITED",
"R A DEALCOM PRIVATE LIMITED",
"R A DYESTUFFS INDIA PRIVATE LIMITED",
"R A KAPOOR TRANSPORTERS LIMITED",
"R A KRAFT PAPER PRIVATE LIMITED",
"R A METAL FINISHERS PRIVATE LIMITED",
"R A N PUBLIC SCHOOL",
"R A NARIMAN AND COMPANY PRIVATE LIMITED",
"R A NET (INDIA) PRIVATE LIMITED",
"R A PERFUMERY WORKS PRIVATE LIMITED",
"R A PLASTOFAB PRIVATE LIMITED",
"R A S INFOTECH LIMITED",
"R A STEEL PRIVATE LIMITED",
"R A V ENTERPRISES PRIVATE LIMITED",
"R AHMED DENTAL COLLEGE AND HOSPITAL",
"R AND B INFRA PROJECT PRIVATE LIMITED",
"R AND D MULTIPLES METAL-CAST PRIVATE LIMITED",
"R AND D THERM INDIA PRIVATE LIMITED",
"R AND N TECHAUTO INDUSTRIES PRIVATE LIMITED",
"R AND N TV PRODUCTIONS PRIVATE LIMITED",
"R AND R IMPEX PRIVATE LIMITED",
"R AND S JEWELLERY AND ACCESSORIES PRIVATE LIMITED",
"R AND S TURNKEY CONTRACTORS PRIVATE LIMITED",
"R AND Y LOGISTICS PRIVATE LIMITED",
"R ARUNACHALAM PROPERTY CONSULTANTS AND PROMOTERS PRIVATE LIMITED",
"R B A EXPORTS PRIVATE LIMITED",
"R B AGARWALLA & COMPANY PRIVATE LIMITED",
"R B AGRO MILLING PRIVATE LIMITED",
"R B ATTAL ARTS SCIENCE & COMMERCE COLLEGE GEORAI",
"R B CARS PRIVATE LIMITED",
"R B COMMODITIES PRIVATE LIMITED",
"R B CUTTERS PRIVATE LIMITED",
"R B DIAGNOSTIC PRIVATE LIMITED",
"R B ELECTRONIC AND ENGINEERING PRIVATE LIMITED",
"R B ENTERPRISES INTERNATIONAL PRIVATE LIMITED",
"R B GHODKE",
"R B GOTHI JAIN COLLEGE FOR WOMEN ARTS SCIENCE",
"R B HING COMPANY PRIVATE LIMITED",
"R B KISSAN KENDRA PRIVATE LIMITED",
"R B METASTEEL PRIVATE LIMITED",
"R B N S SUGAR MILLS LTD",
"R B PATIL INFRASTRUCTURE PRIVATE LIMITED.",
"R B PLASTICIZERS PRIVATE LIMITED",
"R B RAMNATH LAMBAH AND SONS PRIVATE LIMITED",
"R B RESORTS PRIVATE LIMITED",
"R B RESOURCES PRIVATE LIMITED",
"R B SOFTWARE PRIVATE LIMITED",
"R B STONE PRODUCTS PRIVATE LIMITED",
"R B TRADE WINGS PRIVATE LIMITED",
"R B VELHAL INFRASTRUCTURES PRIVATE LIMITED",
"R B WOVENS PRIVATE LIMITED",
"R C A GIRLS P G COLLEGE",
"R C ENERGY METERING PRIVATE LIMITED",
"R C FERTILISERS PRIVATE LIMITED",
"R C FOODS INDIA PRIVATE LIMITED",
"R C G ENTERPRISES PRIVATE LIMITED",
"R C K TECHIEES PRIVATE LIMITED",
"R C MISSION SCHOOL",
"R C PATEL HIGH SCHOOL",
"R C PATEL INSTITUTE OF MANAGEMENT RESEARCH AND DEVELOPMENT",
"R C PATEL INSTITUTE OF PHARMACEUTICAL EDUCATION AND RESEARCH",
"R C PLASTO TANKS & PIPES PRIVATE LIMITED",
"R C S ROLLER FLOUR MILLS LIMITED",
"R C SOOD AND COMPANY PRIVATE LIMITED",
"R CARE HEALTH SERVICES",
"R CHEM ORGANICS BANGALORE PRIVATE. LIMITED.",
"R CHEMINE PRODUCTS PRIVATE LIMITED",
"R CONSULTANTS PRIVATE LIMITED",
"R D A CIVIL ENGINEERING SYSTEMS PRIVATE LIMITED",
"R D ASHAR PVT LTD",
"R D AUTOLIGHTS PRIVATE LIMITED",
"R D D H& M S GANDHINAGAR",
"R D DUTTA AND CO PRIVATE LIMITED",
"R D DYEING AND PRINTING MILLS PRIVATE LIMITED",
"R D ENGINEER ASSOCIATES PRIVATE LIMITED",
"R D ENGINEERS INDIA PRIVATE LIMITED",
"R D ENTERPRISE",
"R D EXCELLENT SERVICES PRIVATE LIMITED",
"R D FASHIONS PRIVATE LIMITED",
"R D MARTIN OVERSEAS PRIVATE LIMITED",
"R D MERCANTILES PRIVATE LIMITED",
"R D MINING EQUIPMENTS PRIVATE LIMITED",
"R D MOTORS PRIVATE LIMITED",
"R D NETWORKS PVT LTD",
"R D PALACE PVT LTD",
"R D PATEL & SONS AGRO & FOOD PROCESSING",
"R D PATEL SARVAJANIK VIDHYALAYA",
"R D PLAST PRIVATE LIMITED",
"R D POLYPLAST PRIVATE LIMITED",
"R D PRATHAM AND CO PRIVATE LIMITED",
"R D RETAIL INDIA PRIVATE LIMITED",
"R D SPECIALITY YARN PRIVATE LIMITED",
"R D VERMA AND COMPANY PRIVATE LIMITED",
"R D WIRELESS SOLUTIONS INDIA PRIVATE LIMITED",
"R D WOMEN COLLEGE",
"R DEEPURAJ RD LATEX PRIVATE LIMITED",
"R E INFRA PRIVATE LIMITED",
"R E ROGERS INDIA PRIVATE LIMITED",
"R E S UP LKO",
"R EH CE BE ENTERPRISES PRIVATE LIMITED",
"R ESS IRON AND STEEL PRIVATE LIMITED",
"R F AGRAWAL CONSTRUCTION PRIVATE LIMITED",
"R F B LATEX LIMITED",
"R F MOTORS PRIVATE LIMITED",
"R FOR RABBIT BABY PRODUCTS PRIVATE LIMITED",
"R G A EXPORTS PRIVATE LIMITED",
"R G ATUL COMTRADE LIMITED",
"R G B BROADCASTING EQUIPMENTS PRIVATE LIMITED",
"R G BIOCOSMETIC PRIVATE LIMITED",
"R G BRONZE MFG COMPANY PRIVATE LIMITED",
"R G BUILDWELL ENGINEERS LIMITED",
"R G CELLULARS PRIVATE LIMITED",
"R G EXPORTS PRIVATE LIMITED",
"R G FAITH CREATIONS PRIVATE LIMITED",
"R G INFOCOMP PRIVATE LIMITED",
"R G INFRACITY PRIVATE LIMITED",
"R G P COLD STORAGE PRIVATE LIMITED",
"R G S HEALTHCARE LIMITED",
"R G SCIENTIFIC ENTERPRISES PRIVATE LIMITED",
"R G SHAH SCIENCE COLLEGE",
"R G SPINNING MILLS PRIVATE LIMITED",
"R G STEELS PVT LTD",
"R G TECHNOLOGIES PRIVATE LIMITED",
"R G TECHNOSOLUTIONS PRIVATE LIMITED",
"R GUPTA & ASSOCIATES",
"R H AGRO OVERSEAS PRIVATE LIMITED",
"R H D MEDICAL PRIVATE LIMITED",
"R H IDEA JR COLLEGE",
"R H INTERNATIONAL LIMITED",
"R H KNITWEAR PRIVATE LIMITED",
"R H L PROFILES LIMITED",
"R H MECHATRONICS PVT LTD",
"R H PATEL ENGLISH MEDIUM B ED COLLEGE",
"R H PETROLEUM PRIVATE LIMITED",
"R H POWER UTILITIES PRIVATE LIMITED",
"R H SAMANT AND SONS PRIVATE LIMITED",
"R H SAPAT COLLEGE OFF ENGINEERING MANAGEMENT STUDIES AND RESEARCH",
"R H SPECIAL COATINGS PRIVATE LIMITED",
"R H SURYARAO & CO",
"R J BUILDCON PRIVATE LIMITED",
"R J COLD STORAGE PRIVATE LIMITED",
"R J FEEDS PRIVATE LIMITED",
"R J INTERNATIONAL PUBLIC SCHOOL",
"R J PACKWELLS PRIVATE LIMITED",
"R J SHAH AND COMPANY LIMITED",
"R J SUPER SPECIALITY HOSPITAL",
"R J WOOLLENS PRIVATE LIMITED",
"R JUGAL KISHORE JEWELS PRIVATE LIMITED",
"R K AGARWAL AGRO SEEDS PRIVATE LIMITED",
"R K AGARWAL TRADING COMPANY PRIVATE LIMITED",
"R K AND COMPANY MANPOWER PRIVATE LIMITED",
"R K AND COMPANY PRIVATE LIMITED",
"R K ASSOCIATES VALUERS & TECHNO ENGINEERING CONSULTANTS PRIVATE LIMITED",
"R K B AGRO INDUSTRIES LIMITED",
"R K B FOOD PRODUCTS PRIVATE LIMITED",
"R K BANSAL FINANCE PRIVATE LIMITED",
"R K BROTHERS INFRAPROP PROVENTURES PRIVATE LIMITED",
"R K BUILDCARE PRIVATE LIMITED",
"R K C HOSPITALITY AND VENTURES PRIVATE LIMITED",
"R K CEMENT SERVICES (INDIA) PRIVATE LIMITED",
"R K CHAVAN INFRASTRUCTURE PRIVATE LIMITED",
"R K CLEARING PRIVATE LIMITED",
"R K COMMERCIAL LTD",
"R K COMMOTRADE PRIVATE LIMITED",
"R K CONSTRUCTION & EARTH MOVERS",
"R K CONSTRUCTIONS",
"R K CONSTRUCTIONS (INDIA) PRIVATE LIMITED",
"R K CONTROL INSTRUMENTS PRIVATE LIMITED",
"R K CREATIVE DESIGNERS PRIVATE LIMITED",
"R K D INFRASTRUCTURE PRIVATE LIMITED",
"R K DHAMIJA FABRICS PRIVATE LIMITED",
"R K EDUCATION FOUNDATION",
"R K ELECTRIC AUTOMATION LIMITED",
"R K ELECTRICAL INDUSTRIES (INDIA) PRIVATE LIMITED",
"R K ENGINEERING PRIVATE LIMITED",
"R K ENGINEERS SALES LIMITED",
"R K EXPORTS",
"R K FABRICS INDIA PRIVATE. LIMITED",
"R K FACADE PRIVATE LIMITED",
"R K FILAMENTS PRIVATE LIMITED",
"R K FITNESS PRIVATE LIMITED",
"R K FOAM HOUSE PRIVATE LIMITED",
"R K FRACTURE HOSPITAL AND TRAUMA CENTRE",
"R K FRAMING UPVC PRIVATE LIMITED",
"R K G PHARMA PVT LTD",
"R K G TIMBERS PRIVATE LIMITED",
"R K GARMENTS PRIVATE LIMITED",
"R K GLOBAL COMMODITY BROKING LIMITED",
"R K GLOBAL FINANCE PRIVATE LIMITED",
"R K GOYAL PAPER PRODUCTS PRIVATE LIMITED",
"R K GOYAL STEELS PRIVATE LIMITED",
"R K H HANDICRAFTS PRIVATE LIMITED",
"R K HEAVY ENGINEERING PRIVATE LIMITED",
"R K HIV AIDS RESEARCH & CARE CENTRE",
"R K HOSPITAL & RESEARCH CENTRE",
"R K HOTLIERS AND DEVELOPERS PRIVATE LIMITED",
"R K IMPEX PVT LTD",
"R K INFRACORP PRIVATE LIMITED",
"R K INFRAINDIA PRIVATE LIMITED",
"R K INVESTRADE PRIVATE LIMITED",
"R K JAIN ASSOCIATES PRIVATE LIMITED",
"R K JAIN INFRA PROJECTS PRIVATE LIMITED",
"R K JEWELS (VISNAGAR) PRIVATE LIMITED",
"R K LAXMI GENERAL SALES LIMITED",
"R K LIFE SERVICES PRIVATE LIMITED",
"R K LIGHTING PRIVATE LIMITED",
"R K LOGISTICS PRIVATE LIMITED",
"R K LUMBERS PRIVATE LIMITED",
"R K M POWERGEN PRIVATE LIMITED",
"R K MACHINE TOOLS LTD",
"R K MARBLE & GRANITE PRIVATE LIMITED",
"R K MARBLE PRIVATE LIMITED",
"R K MASTER NET-COM SERVICES PRIVATE LIMITED",
"R K MEDICINES PRIVATE LTD",
"R K MULTIMEDIA ADVERTISING PRIVATE LIMITED",
"R K OIL INDUSTRIES PRIVATE LIMITED",
"R K P POLYBAGS PRIVATE LIMITED",
"R K P TRADING COMPANY PRIVATE LIMITED",
"R K PANELS AND BOARDS PRIVATE LIMITED",
"R K PATEL TOBACCO PRIVATE LIMITED",
"R K PHOSPHATES PRIVATE LIMITED",
"R K POLYMER INDUSTRIES PRIVATE LIMITED",
"R K POLYTEX PRIVATE LIMITED",
"R K POWERGEN PRIVATE LIMITED",
"R K PROFILES PRIVATE LIMITED",
"R K PROJECTS PRIVATE LIMITED",
"R K R GOLD BULLION PRIVATE LIMITED",
"R K R LOGISTICS (INDIA) PRIVATE LIMITED",
"R K R SOFTWARE SOLUTIONS PRIVATE LIMITED",
"R K RAYON PRIVATE LIMITED",
"R K RECLAIM AND RUBBER PRODUCTS PRIVATE LIMITED",
"R K SALEMPUR CONSTRUCTION PRIVATE LIMITED",
"R K SERVICES",
"R K SETHIA AGRO PRIVATE LIMITED",
"R K SHIPPING PRIVATE LIMITED",
"R K SPINTEX PRIVATE LIMITED",
"R K STEEL MANUFACTURING & CO PRIVATE LIMITED",
"R K STEEL UDYOG PRIVATE LIMITED",
"R K SWAMY LIMITED",
"R K SWAMY PRIVATE LIMITED",
"R K SWARN PRIVATE LIMITED",
"R K SWEET MARS PRIVATE LIMITED",
"R K SYNTHESIS LIMITED",
"R K TELESERVICES PRIVATE LIMITED",
"R K TOOLING AND PRESSING PRIVATE LIMITED",
"R K TRADING CO.",
"R K TRANSPORT AND CONSTRUCTIONS LIMITED",
"R K TRANSPORT CO",
"R K WIND FARMS ( KARUR) PRIVATE LIMITED",
"R KANDD INVESTMENT PVT LTD",
"R KARUNANIDHE CONSTRUCTIONS PRIVATE LIMITED",
"R KOTHARI & CO LLP",
"R L AVIATION SERVICES PRIVATE LIMITED",
"R L CORP INDIA",
"R L FINE CHEM PRIVATE LIMITED",
"R L G METALS PRIVATE LIMITED",
"R L J INFRACEMENT PRIVATE LIMITED",
"R L JAIN EARTHMOVERS LLP",
"R L JAIN INDUSTRIES PRIVATE LIMITED",
"R L K L JEWELS PRIVATE LIMITED",
"R L KALTHIA SHIP BREAKING PRIVATE LIMITED",
"R L N IMPEX PRIVATE LIMITED",
"R L P SECURITIES PRIVATE LIMITED",
"R L POLY FABS PRIVATE LIMITED",
"R L RAY JEWELLERS PRIVATE LIMITED",
"R L STEELS & ENERGY LIMITED",
"R LOGIC TECHNOLOGY SERVICES INDIA PRIVATE LIMITED",
"R M BHUTHER AND COMPANY LIMITED",
"R M COMPONENTS PRIVATE LIMITED",
"R M D ENGINEERING COLLEGE",
"R M DASA INFRASTRUCTURE PRIVATE LIMITED",
"R M DRIP AND SPRINKLERS SYSTEMS LIMITED",
"R M G ISPAT AND ALLOYS PRIVATE LIMITED",
"R M JEWELLERS PRIVATE LIMITED",
"R M LALWANI AND CO",
"R M N INFRASTRUCTURES LIMITED",
"R M NATURAL RESOURCES PRIVATE LIMITED",
"R M PHOSPHATES & CHEMICALS PRIVATE LIMITED",
"R M TECHNOCORP PRIVATE LIMITED",
"R M V IMPEX",
"R M X JOSS FASHIONS PRIVATE LIMITED",
"R M X JOSS MERCHANTS PRIVATE LIMITED",
"R MAHADEOLAL SYNTHETICS LIMITED",
"R MALL DEVELOPERS PRIVATE LIMITED",
"R MANISH JEWELLARY PRIVATE LIMITED",
"R MISRILAL JEWELLERS PRIVATE LIMITED",
"R N B CARBIDES & FERRO ALLOYS PRIVATE LIMITED",
"R N BIRLA COTSGIN PRIVATE LIMITED",
"R N BROTHERS FOREX PRIVATE LIMITED",
"R N CABS PRIVATE LIMITED",
"R N DUTT & SON PRIVATE LIMITED",
"R N ESTATE AND PROPERTIES PVT LTD",
"R N FINANCE",
"R N FREIGHT FORWARDERS PRIVATE LIMITED",
"R N G PACKAGINGS PRIVATE LIMITED",
"R N IMPEX PRIVATE LIMITED",
"R N JEWELLERS PRIVATE LIMITED",
"R N KAPOOR TEXTILES PRIVATE LIMITED",
"R N KHEMKA ENTERPRISES PRIVATE LIMITED",
"R N LABORATORIES PRIVATE LIMITED",
"R N METALS",
"R N PATWA SHARES AND STOCK BROKERS PRIVATE LIMITED",
"R N PHOTO COATINGS PRIVATE LIMITED",
"R N POLY CONTAINER PRIVATE LIMITED",
"R N PULVARISERS PRIVATE LIMITED",
"R N R AUTOMATE PRIVATE LIMITED",
"R N R PROCESSOR PRIVATE LIMITED",
"R N SWAMY INFRASTRUCTURE PRIVATE LIMITED",
"R N TRANSLOGISTIX PRIVATE LIMITED",
"R N V TRADING ENTERPRISES PRIVATE LIMITED",
"R NARAYANA REDDY & SONS CONSTRUCTIONS PRIVATE. LIMITED.",
"R NATVARLAL PAREKH TRADING AND FINANCE LIMITED",
"R OPTICAL",
"R P AGRO-TECH PRIVATE LIMITED",
"R P BIOTECH PRIVATE LIMITED",
"R P BUILDCON PRIVATE LIMITED",
"R P BUILDCREAT PRIVATE LIMITED",
"R P COATINGS PRIVATE LIMITED",
"R P COMTRADE PRIVATE LIMITED",
"R P CREATION",
"R P DALMIA SAREES PRIVATE LIMITED",
"R P ENGINEERING PVT LTD",
"R P FINCAP COMPANY LIMITED",
"R P FOAM HOME PRIVATE LIMITED",
"R P FOUNDRY PRIVATE LIMITED",
"R P G ENTERPRISES LIMITED",
"R P GOGATE COLLEGE OF ARTS AND SCIENCE AND R V JOGALEKAR COLLEGE OF COMMERCE",
"R P GUPTA TRANSPORT PRIVATE LIMITED",
"R P INDIA OILS PRIVATE LIMITED",
"R P INDUSTRIES",
"R P INFRAVENTURE PRIVATE LIMITED",
"R P INTERIOR PROJECT PRIVATE LIMITED",
"R P J TEXTILES LIMITED",
"R P K AGROTECH EXPORTS PRIVATE LIMITED",
"R P L (INDIA) PHARMACEUTICALS PRIVATE LIMITED",
"R P LASER TECH PRIVATE LIMITED",
"R P LOCKS COMPANY",
"R P M EXIM PRIVATE LIMITED",
"R P M IMPEX PRIVATE LIMITED",
"R P MOONDRA TEXTURISERS PRIVATE LIMITED",
"R P REALBUILD PRIVATE LIMITED",
"R P RESORTS PRIVATE LIMITED",
"R P SPICES (INDIA) PRIVATE LIMITED",
"R P STONE CLINIC PRIVATE LIMITED",
"R P TECHSOFT INTERNATIONAL PRIVATE LIMITED",
"R P TIMBERS PRIVATE LIMITED",
"R P WIRES & CABLES PRIVATE LIMITED",
"R PAC INDIA PRIVATE LIMITED",
"R PS SPINNER INDIA PRIVATE LIMITED",
"R PURE AGRO PRODUCTS PRIVATE LIMITED",
"R R AGRO FOODS PRIVATE LIMITED",
"R R AND COMPANY PRIVATE LIMITED",
"R R AUTOTECH PRIVATE LIMITED",
"R R B MASTER SECURITIES DELHI LIMITED",
"R R BULLION PRIVATE LIMITED",
"R R C O CONSULTING PRIVATE LIMITED",
"R R CHANAWALA PRIVATE LIMITED",
"R R CHICKEN PRIVATE LIMITED",
"R R CHOKHANI STOCK BROKERS PRIVATE LIMITED",
"R R CIVILTECH PRIVATE LIMITED",
"R R COMMANDER ELECTRONICS INDIA PRIVATE LIMITED",
"R R CONSTRUCTION",
"R R CRANES PRIVATE LIMITED",
"R R DECOR PRIVATE LIMITED",
"R R EQUICONS PRIVATE LIMITED",
"R R EXPRESS PRIVATE LIMITED",
"R R FACILITIES PRIVATE LIMITED",
"R R FINANCIAL CONSULTANTS LIMITED",
"R R FLEXIPACK PRIVATE LIMITED",
"R R FLUID ENGINEERING PRIVATE LIMITED",
"R R FOREVER JEWELLERY PRIVATE LIMITED",
"R R HASTKALA UDYOG PRIVATE LIMITED",
"R R HOLIDAY HOMES PRIVATE LIMITED",
"R R HOSPITALS PRIVATE LIMITED",
"R R INDUSTRIAL PACKAGING PRIVATE LIMITED",
"R R INFRAPROJECTS PRIVATE LIMITED",
"R R INNOVATIVE PRIVATE LIMITED",
"R R INVESTMENTS AND ESTATES PRIVATE LIMITED",
"R R ISPATA UNIT OF GPIL GALVA DIVISION",
"R R K COTTON'S INDIA PRIVATE LIMITED",
"R R KABEL LIMITED",
"R R LANDMARKS PRIVATE LIMITED",
"R R LUMINAIRES PRIVATE LIMITED",
"R R MADHOGARHIA IRON & STEEL WORKS PRIVATE LIMITED",
"R R MINERALS EXPORT PRIVATE LIMITED",
"R R MOHATA POLYTEX PRIVATE LIMITED",
"R R NABAR AND COMPANY SHARE BROKERS PRIVATE LIMITED",
"R R OOMERBHOY PVT LTD",
"R R PAINT PRIVATE LIMITED",
"R R PARKON PRIVATE LIMITED",
"R R PATEL INDUSTRIAL GASES PRIVATE LIMITED",
"R R PIGMENTS PRIVATE LIMITED",
"R R PLAST EXTRUSIONS PRIVATE LIMITED",
"R R POLYPLAST PRIVATE LIMITED",
"R R PRESTRESS INDUSTRIES",
"R R PROTEINS AND AGRO PRIVATE LIMITED",
"R R R CONSTRUCTIONS & PROJECTS PRIVATE LIMITED",
"R R R FOREX PRIVATE LIMITED",
"R R R SPINNING MILLS INDIA PRIVATE LIMITED",
"R R ROADWAYS PRIVATE LIMITED",
"R R S INDIA SECURITY SERVICES PRIVATE LIMITED",
"R R SANITATIONS PRIVATE LIMITED",
"R R SEN & BROS PRIVATE LIMITED",
"R R SHAH TRADING PRIVATE LIMITED",
"R R STEEL AND ENGINEERING PRIVATE LIMITED",
"R R TECHNO MECHANICALS PRIVATE LIMITED",
"R R THULASI BUILDERS (INDIA) PRIVATE LIMITED",
"R R TRADERS PRIVATE LIMITED",
"R R TRENDS PRIVATE LIMITED",
"R R UNIVERSAL PRIVATE LIMITED",
"R RAHEJA INVESTMENTS PRIVATE LIMITED",
"R RAJESH EXPORTS",
"R RETAILS AND EATERY PRIVATE LIMITED",
"R S & COMPANY",
"R S AGRO CHEMICALS PRIVATE LIMITED",
"R S AGRO INDUSTRIES",
"R S AIRFILTEC PRIVATE LIMITED",
"R S ARD PRIVATE LIMITED",
"R S BALAJI CONSTRUCTION PRIVATE LIMITED",
"R S BOKARO METAL PRIVATE LIMITED",
"R S BONDED WAREHOUSE PRIVATE LIMITED",
"R S BROTHERS RETAIL INDIA PRIVATE LIMITED",
"R S BUSINESS SOLUTIONS PRIVATE LIMITED",
"R S CARRIERS AND TRADERS PVT LTD",
"R S COMPONENTS AND CONTROLS (INDIA) LIMITED",
"R S CONTAINERS PRIVATE LIMITED",
"R S CONTRACTOR",
"R S DELTA FORCE SECURITIES AND SERVICES PRIVATE LIMITED",
"R S DIAMONDS PRIVATE LIMITED",
"R S DRUGS AND MEDICALS PRIVATE LIMITED",
"R S ENTERPRISES PVT LTD",
"R S ENTERTAINMENT PRIVATE LIMITED",
"R S ENVIROLINK TECHNOLOGIES PRIVATE LIMITED",
"R S EXPOFABS PRIVATE LIMITED",
"R S FABRICATORS PRIVATE LIMITED",
"R S FOILS PRIVATE LIMITED",
"R S FUEL PRIVATE LIMITED",
"R S G PACKAGINGS PRIVATE LIMITED",
"R S G REALTORS PRIVATE LIMITED",
"R S G SALES & SERVICES PRIVATE LIMITED",
"R S G STONES (100%EOU)",
"R S GOSAVI KALANIKETAN MAHAVIDYALAYA",
"R S GOSAVI KALANIKETAN MAHAVIDYALAYA KOLHAPUR",
"R S GOYAL MEDICAL CENTRE PRIVATE LIMITED",
"R S GROUP",
"R S HIGHTECH SOLUTION",
"R S INFOMEDIA AND FILMS PRIVATE LIMITED",
"R S INFRA- STEEL PRIVATE LIMITED",
"R S INFRAPROJECTS PRIVATE LIMITED",
"R S INFRASOLUTIONS PRIVATE LIMITED",
"R S JAIN AND SONS PRIVATE LIMITED",
"R S JHAVERI STEELS PRIVATE LIMITED",
"R S K FASTNERS PRIVATE LIMITED",
"R S KAMTHE INFRASTRUCTURE DEVELOPERS PRIVATE LIMITED",
"R S LABELS PRIVATE LIMITED",
"R S LEDER-WAREN PRIVATE LIMITED",
"R S LOGISTICS INDIA PRIVATE LIMITED",
"R S M P HOSPITALITY PRIVATE LIMITED",
"R S M PHARMA PRIVATE LIMITED",
"R S MAN POWER",
"R S MARKETING AND LOGISTICS PRIVATE LIMITED",
"R S METALS PRIVATE LIMITED",
"R S METSCRAPS PRIVATE LIMITED",
"R S MINERALS PRIVATE LIMITED",
"R S N TEX PVT. LTD.",
"R S ORGANICS PRIVATE LIMITED",
"R S P M V SERVA VIDHYALAYA HIGH SCHOOL KADI",
"R S PAPER",
"R S PATEL VEGETABLES PRIVATE LIMITED",
"R S PLASFAB PRIVATE LIMITED",
"R S POWER CONTROLS PRIVATE LIMITED",
"R S PROCESS SYSTEMS PRIVATE LIMITED",
"R S PRODUCTS PRIVATE LIMITED",
"R S R ELITE DEVELOPERS PRIVATE LIMITED",
"R S R MERCHANTS (INDIA) PRIVATE LIMITED",
"R S R RESOURCE ENTERPRISES PRIVATE LIMITED",
"R S RETAIL STORES PRIVATE LIMITED",
"R S RICE MILLS PRIVATE LIMITED",
"R S S ENTERPRISES PRIVATE LIMITED",
"R S SAMANT ENGINEERS PRIVATE LIMITED",
"R S SANITATION PRIVATE LIMITED",
"R S SERVICES PRIVATE LIMITED",
"R S SOFTWARE INDIA LIMITED",
"R S SOLVENT EXTRACTIONS LIMITED",
"R S SPUNTEX PRIVATE LIMITED",
"R S STEELAGE PRIVATE LIMITED",
"R S SURGICALS PRIVATE LIMITED",
"R S T CANCER HOSPITAL",
"R S T HOTELS PRIVATE LIMITED",
"R S TECHNOLOGIES PRIVATE LIMITED",
"R S TOOL AND DESIGN CENTRE PRIVATE LIMITED",
"R S TRADE & AGENCY PRIVATE LIMITED",
"R S TRAVEL & TOURS INDIA PRIVATE LIMITED",
"R S TRIMS POINT PRIVATE LIMITED",
"R S V INDUSTRIES PRIVATE LIMITED",
"R S V OFFSET PRINTERS PRIVATE LIMITED",
"R S VEHICLES PRIVATE LIMITED",
"R S WOODS PRIVATE LIMITED",
"R S YADAV SMART BUS PRIVATE LIMITED",
"R SAI LOGISTICS INDIA PRIVATE LIMITED",
"R SANDESH INFRASTRUCTURES PRIVATE LIMITED",
"R SHANKARLAL SALES PRIVATE LIMITED",
"R SINGH AND ASSOCIATES PRIVATE LIMITED",
"R SOGANI & ASSOCIATES",
"R SQUARE CONSULTING SERVICES PRIVATE LIMITED",
"R SQUARE HYUNDAI",
"R SQUARE MLG LOGISTICS PRIVATE LIMITED",
"R STAHL PRIVATE LIMITED",
"R SUBBARAMAN & CO PRIVATE LIMITED",
"R SYSTEMS INTERNATIONAL LIMITED",
"R T & ASSOCIATES PRIVATE LIMITED",
"R T AGRO PRIVATE LIMITED",
"R T EXPORTS PVT LTD",
"R T NAGAR EDUCATIONAL TRUST",
"R T PACKAGING LTD",
"R TAEC ENGINEERING INDIA PRIVATE LIMITED",
"R THOMAS EXPORTS PRIVATE LIMITED",
"R TULSIDAS EXPORTS PVT LTD",
"R V CASTING AND ENGINEERING PRIVATE LIMITED",
"R V COLLEGE OF ARCHITECTURE",
"R V COLLEGE OF ENGINERING",
"R V CONSTRUCTION",
"R V CONSULTING SERVICES PRIVATE LIMITED",
"R V DIAGNOSTICS PRIVATE LIMITED",
"R V DIAMOND JEWELLERS PRIVATE LIMITED",
"R V GLOBAL PRIVATE LIMITED",
"R V HOMES",
"R V INFRASTRUCTURAL PRIVATE LIMITED",
"R V INTERIORS PRIVATE LIMITED",
"R V J INFRA PRIVATE LIMITED",
"R V PLASTIC LIMITED",
"R V PRE-UNIVERSITY COLLEGE",
"R V S AGROTECH INDUSTRIES PRIVATE LIMITED",
"R V S FABRICATORS PRIVATE LIMITED TRS CO DELHI TO HARY",
"R V TRANSPORT SERVICES PRIVATE LIMITED",
"R VERMASONS JEWELLERS PRIVATE LIMITED",
"R VISHAL FABRICS PRIVATE LIMITED",
"R VISION PLASTIC INDUSTRIES PRIVATE LIMITED",
"R WADIWALA SECURITIES PRIVATE LIMITED",
"R WORLD LEISURE LIMITED",
"R Z INTERNATIONAL PRIVATE LIMITED",
"R Z P SCHOOL KOMBAD BHUJE",
"R&B DENIMS LIMITED",
"R&D ENTERPRISES",
"R&DEENGRS SCHOOL",
"R&H SPACES PRIVATE LIMITED",
"R&M HEALING BUDDHA PRIVATE LIMITED",
"R&M INDIA PRIVATE LIMITED",
"R&M LUXURY PRIVATE LIMITED",
"R&M MARINE ENGINEERING SERVICES INDIA PRIVATE LIMITED",
"R&M RASAYANA PRIVATE LIMITED",
"R&R INFRATECH (INDIA) PRIVATE LIMITED",
"R&R UDYOG PRIVATE LIMITED",
"R&S ELECTRONICS SYSTEMS INDIA PRIVATE LIMITED",
"R. A. AGGARWAL SUPERMARKET PRIVATE LIMITED",
"R. A. METALS PRIVATE LIMITED",
"R. B. AGENCIES PRIVATE LIMITED",
"R. B. ENGINEERING AND INFRASTRUCTURE PRIVATE LIMITED",
"R. B. K. SHARE BROKING LIMITED",
"R. B. MEHTA AND COMPANY",
"R. B. TECHNOCRATS & RECLAIMERS PRIVATE. LIMITED.",
"R. BERIWALA TEXFAB PRIVATE LIMITED",
"R. C. INDUSTRIES",
"R. D. CASTING PRIVATE. LIMITED.",
"R. D. CRUSHING & SCREENING PROJECTS PRIVATE LIMITED",
"R. D. KAREL & SONS JEWELLERS PRIVATE LIMITED",
"R. D. KAREL JEWELLERS PRIVATE LIMITED",
"R. D. PADDY PRODUCTS PRIVATE LIMITED",
"R. D. ROADLINES (I) PRIVATE LIMITED",
"R. D. SAMANT CONTRACTORS PRIVATE LIMITED",
"R. D. TRADERS PRIVATE LIMITED.",
"R. E. COMPONENTS PRIVATE LIMITED",
"R. G. BUILDIMPEX PRIVATE LIMITED",
"R. G. FURNISHINGS PRIVATE LIMITED",
"R. G. HOLDINGS INFRATECH PRIVATE LIMITED",
"R. G. KASAT INDUSTRIES PRIVATE LIMITED",
"R. G. PAUL PRIVATE LIMITED",
"R. G. PIGMENTS PRIVATE LIMITED",
"R. GOPAL IMPEX PRIVATE LIMITED",
"R. H. ASSOCIATES PRIVATE LIMITED",
"R. I. COTTON PRIVATE LIMITED",
"R. J. & SONS MARKETING PRIVATE LIMITED",
"R. J. ENGINEERS PRIVATE LIMITED",
"R. J. KNITWEARS LIMITED",
"R. J. REAL ESTATES PRIVATE LIMITED",
"R. J. S. ENTERPRISES PRIVATE LIMITED",
"R. K. AUTOMOBILES PRIVATE LIMITED",
"R. K. BABU CEMENT PRIVATE LIMITED",
"R. K. BAKEWELL MARS PRIVATE LIMITED",
"R. K. CARRIERS INDIA PRIVATE LIMITED",
"R. K. CONVERTORS PRIVATE LIMITED",
"R. K. DALL AND FOOD PRODUCTS (KATNI) PRIVATE LIMITED",
"R. K. DYES PRIVATE LIMITED",
"R. K. ENGINEERING AND GALVANIZERS PRIVATE LIMITED",
"R. K. G. S. AGRO INDUSTRIES PRIVATE LIMITED",
"R. K. GEARS PRIVATE LIMITED",
"R. K. GUPTA AND COMPANY INDIA PRIVATE LIMITED",
"R. K. IRRIGATION SYSTEMS LIMITED",
"R. K. JEWELLERS",
"R. K. LAXMI AGRITECH PRIVATE LIMITED",
"R. K. MEGA STRUCTURES PRIVATE LIMITED",
"R. K. METAL & PLASTIC PRIVATE LIMITED",
"R. K. MOBITEL PRIVATE LIMITED",
"R. K. NATURAL FIBRE PRIVATE LIMITED",
"R. K. POLYCLINIC & DIAGNOSTIC CENTRE PRIVATE LIMITED",
"R. K. R POLYMERS PRIVATE LIMITED",
"R. K. RESIN PLAST PRIVATE LIMITED",
"R. K. SACHDEVA AND SONS PRIVATE LIMITED",
"R. K. VACATIONS PRIVATE LIMITED",
"R. K. YARNS & TWINES PRIVATE LIMITED",
"R. K.ABHUSHAN PALACE PRIVATE LIMITED",
"R. KOTHARI TEXOFAB PRIVATE LIMITED",
"R. L. CHLORO SALES PRIVATE LIMITED",
"R. L. F. INDUSTRIES LIMITED",
"R. L. INDUSTRIES",
"R. L. JEWELS PRIVATE LIMITED",
"R. M. AHUJA COTTEX PRIVATE LIMITED",
"R. M. ALLOYS PRIVATE LIMITED",
"R. M. CYLINDERS PRIVATE LIMITED",
"R. M. CYLINDERS UNIT II PRIVATE LIMITED",
"R. M. D.WEAVING MILLS PRIVATE LIMITED",
"R. M. FASHION JEWELLERY PRIVATE LIMITED",
"R. M. FOREX PRIVATE LIMITED",
"R. M. KNITTERS PRIVATE LIMITED",
"R. M. METALLICS PRIVATE LIMITED",
"R. M. POLY PACK PRIVATE LIMITED",
"R. M. SHAHANI (KOL) PRIVATE LIMITED",
"R. MAHAJAN HOSPITALS PRIVATE LIMITED",
"R. N. INDUSTRIAL ELECTRICALS PRIVATE LIMITED",
"R. N. INTEGRITY SOLUTIONS PRIVATE LIMITED",
"R. NARAN PRIVATE LIMITED",
"R. P. CHEMICALS",
"R. P. GOURMET FOODS PRIVATE LIMITED",
"R. P. INTERMEDIATES PRIVATE LIMITED",
"R. P. J. JEWELLERS PRIVATE LIMITED",
"R. P. MEDICAL FOUNDATION PRIVATE LIMITED",
"R. P. METAL SECTIONS PRIVATE LIMITED",
"R. P. SALES PRIVATE LIMITED",
"R. P. TEK INDIA PRIVATE LIMITED",
"R. R. JEWELWORLD PRIVATE LIMITED",
"R. R. ORNAMENTS PRIVATE LIMITED",
"R. RATILAL & BROTHERS PRIVATE LIMITED",
"R. S PROFILLING PRIVATE LIMITED",
"R. S. AGRAWAL INFRATECH PRIVATE LIMITED",
"R. S. EXPO FABS PRIVATE LIMITED",
"R. S. FOOD PROCESSES INDIA PRIVATE LIMITED",
"R. S. INDIA WIND ENERGY PRIVATE LIMITED",
"R. S. ISPAT (RAIGARH) PRIVATE LIMITED",
"R. S. LOGISTICS & WAREHOUSE SERVICES PRIVATE LIMITED",
"R. S. MEDICARE PRIVATE LIMITED",
"R. S. P. FOREX PRIVATE LIMITED",
"R. S. PLASTISIZERS PRIVATE LIMITED",
"R. S. PRINT SOLUTIONS PRIVATE LIMITED",
"R. S. TELESOLUTIONS PRIVATE LIMITED",
"R. S. TOOLS & ENGINEERS PRIVATE LIMITED",
"R. SAI TRANS LOGISTICS PRIVATE LIMITED",
"R. SHILPA DRESSES PRIVATE LIMITED",
"R. SHRI MOTORS LIMITED",
"R. SS INVESTMENTS PRIVATE LIMITED",
"R. UMEDBHAI JEWELLERS PRIVATE LIMITED",
"R. V. PACKAGING PRIVATE LIMITED",
"R. V. RAIL PRODUCTS PVT. LTD.",
"R. Y. EXTRUSION PRIVATE LIMITED",
"R. Z. P. PRIMARY SCHOOL",
"R.A. KNITWEAR PRIVATE LIMITED",
"R.A. POWER SOLUTIONS PRIVATE LIMITED",
"R.A.J. KRISHNA CONSTRUCTION COMPANY PRIVATE LIMITED",
"R.A.MOTORS PRIVATE LIMITED",
"R.A.P. BIOLIPS PRIVATE LIMITED",
"R.A.SHAIKH PAPER MILLS PRIVATE LIMITED",
"R.A.SONS PVT. LTD",
"R.ASWATHA GREENS PRIVATE LIMITED",
"R.B. CHOPRA FREIGHTERS PRIVATE LIMITED",
"R.B. CRUSHING PRIVATE LIMITED",
"R.B. DYECHEM PRIVATE LIMITED",
"R.B. FITNESS AND TRADING PRIVATE LIMITED",
"R.B. GEARS PRIVATE. LIMITED.",
"R.B. GLOBAL ENTERPRISES PRIVATE LIMITED",
"R.B. PHARMA PRIVATE LIMITED",
"R.B. RICE INDUSTRIES",
"R.B. SHAH ENTERPRISES (INDIA) PRIVATE LIMITED",
"R.B. STRIPS PRIVATE LIMITED",
"R.B.C. BEARINGS PRIVATE LIMITED",
"R.B.CONSTRUCTION & PROMOTERS PRIVATE LIMITED",
"R.B.CREATORS GLASS SYSTEMS PRIVATE LIMITED",
"R.B.ENENEERING WORKS",
"R.B.FINANCIAL SERVICES PRIVATE LIMITED",
"R.B.FINVEST AND BUILDERS PRIVATE LIMITED",
"R.B.HOME APPLIANCES INDIA PRIVATE LIMITED",
"R.B.LAMINATION INDUSTRIES PVT. LTD.",
"R.B.PULSES PRIVATE LIMITED",
"R.B.REMEDIES PRIVATE LIMITED",
"R.B.RUNGTA STEELS & FOOD PRODUCTS PRIVATE LIMITED",
"R.B.SHIRKE HIGH SCHOOL",
"R.BCC EXPORTERS PRIVATE LIMITED",
"R.C. DAS ENGINEERING PRIVATE LIMITED",
"R.C. ENGINEERING WORKS PRIVATE LIMITED",
"R.C. FOAMS PRIVATE LIMITED",
"R.C. LIQUOR TRADING AND COMPANY PRIVATE LIMITED",
"R.C.ADVERTISING CO PRIVATE LIMITED",
"R.C.F. MULTIVENTURE PRIVATE LIMITED",
"R.C.H. MARKETING PRIVATE LIMITED",
"R.C.I. ELECTRICAL WIRES PRIVATE LIMITED",
"R.C.JAIN INVEST. AND FIN. PRIVATE LIMITED",
"R.C.P. INFRATECH PRIVATE LIMITED",
"R.C.P.L. TRADERS PRIVATE LIMITED",
"R.D GREENFIELDS PUBLIC SCHOOL",
"R.D UDYOG PRIVATE LIMITED",
"R.D. CEMENT INDUSTRIES PRIVATE LIMITED",
"R.D. COMPUTECH AND AGENCIES PRIVATE LIMITED",
"R.D. DESHPANDAY DEVELOPERS PRIVATE LIMITED",
"R.D. ENGINEERING SOLUTIONS PRIVATE LIMITED",
"R.D. ICE AND COLD STORAGE PRIVATE LIMITED",
"R.D. STEEL FORGING PRIVATE LIMITED",
"R.D. TEA LIMITED",
"R.D. WELD PRODUCTS PRIVATE LIMITED",
"R.D.ADVERTISING PRIVATE LIMITED",
"R.D.AUTOMOTIVE PRIVATE LIMITED",
"R.D.ELECTROCIRCUITS PRIVATE LIMITED",
"R.D.ENGINEERING COLLEGE",
"R.D.FERTICHEM PRIVATE LIMITED",
"R.D.GASES PRIVATE LIMITED",
"R.D.GOEL AND COMPANY PRIVATE LIMITED",
"R.D.INFRAPROJECTS PRIVATE LIMITED",
"R.D.VIDYAVIHAR",
"R.E POLYTECHNOLOGIES PRIVATE LIMITED",
"R.E.F.C.O.N. AIRCONDITIONING PRIVATE LIMITED",
"R.F. OVERSEAS PRIVATE LIMITED",
"R.G KAR MEDICAL COLLEGE & HOSPITAL",
"R.G. ELECTRICAL PRIVATE LIMITED",
"R.G. FABTEX PRIVATE LIMITED",
"R.G. HOUSING & INFRA PRIVATE LIMITED",
"R.G. LOHA PRIVATE LIMITED",
"R.G. NIRMAN PRIVATE LIMITED",
"R.G. PLASTO-PACKS PRIVATE LIMITED",
"R.G. STAINLESS ENGINEERS LTD.",
"R.G.R0LLING INDIA LIMITED",
"R.G.SHIPPING AND LOGISTICS PRIVATE LIMITED",
"R.H. AUTOMOBILES PRIVATE LIMITED",
"R.H. SOLVEX PRIVATE. LIMITED.",
"R.H. SORTEX RICE MILLS PRIVATE LIMITED",
"R.H.IDEA JR. COLLEGE",
"R.H.IDEAL HIGH SCHOOL",
"R.I. EXPORTS PRIVATE LIMITED",
"R.J. AGRO INDUSTRIES",
"R.J. DISTRIBUTORS PRIVATE LIMITED",
"R.J. INDUSTRIES",
"R.J. MARKETING PRIVATE LIMITED",
"R.J. WAREHOUSING PRIVATE LIMITED",
"R.J.INNOVATIVE FABRIC PRIVATE LIMITED",
"R.J.P. ENGINEERING CONSTRUCTION PRIVATE LIMITED",
"R.J.S STEELS PRIVATE LIMITED",
"R.J.S. INFOTECH PRIVATE LIMITED",
"R.K & SONS",
"R.K. AGARWAL INDUSTRIES LIMITED",
"R.K. AGGARWAL MOTORS PRIVATE LIMITED",
"R.K. APPAREL PRIVATE LIMITED",
"R.K. BIO TECHNOLOGIES PRIVATE LIMITED",
"R.K. CEILINGS PRIVATE LIMITED",
"R.K. CONTAINER LINE PRIVATE LIMITED",
"R.K. DHABHAI MINERALS AND CHEMICALS PRIVATE LIMITED",
"R.K. FURNISHINGS PRIVATE LIMITED",
"R.K. GLOBAL SHARES AND SECURITIES LIMITED",
"R.K. GRANITES AND MINING PRIVATE LIMITED",
"R.K. HANDLOOM ACCESSORIES PRIVATE LIMITED",
"R.K. HOTELIERS & DEVELOPERS PRIVATE LIMITED",
"R.K. INDUSTRIES TAMILNADU PRIVATE LIMITED",
"R.K. INFRACORP PRIVATE LIMITED",
"R.K. JOINERY PRIVATE LIMITED",
"R.K. LABORATORIES PRIVATE LIMITED",
"R.K. LIFECARE & HOSPITALS PRIVATE LIMITED",
"R.K. MARBLE PRIVATE LIMITED",
"R.K. PALACE AND COMPLEX PVT LTD",
"R.K. POLYCREATIONS PRIVATE LIMITED",
"R.K. PUMPS PRIVATE LIMITED",
"R.K. RICE AND GENERAL MILLS",
"R.K. RICETECH PRIVATE LIMITED",
"R.K. ROADWAYS PRIVATE LIMITED",
"R.K. SPRAYER EQUIPMENTS PRIVATE LIMITED",
"R.K. STEEL MANUFACTURING COMPANY LIMITED",
"R.K. STEELS",
"R.K. STONE MINING & CRUSHING PRIVATE LIMITED",
"R.K. TELESHOW PRIVATE LIMITED",
"R.K. TIMBER PRIVATE LIMITED",
"R.K. TOWNSHIP DEVELOPERS PRIVATE LIMITED",
"R.K. TOWNSHIP PROPERTIES PRIVATE LIMITED",
"R.K. TRADERS AND DISTRIBUTOR PRIVATE LIMITED",
"R.K. TRANSPORT PRIVATE LIMITED",
"R.K.AGRO OILS PRIVATE LIMITED",
"R.K.C INFRACON PRIVATE LIMITED",
"R.K.C MANAGEMENT PRIVATE LIMITED",
"R.K.ECOCARE PRIVATE LIMITED",
"R.K.ENGG. WORKS PRIVATE LIMITED",
"R.K.EXPORTS (KARUR) PRIVATE LIMITED",
"R.K.FASHION ACCESSORIES PRIVATE LIMITED",
"R.K.FORGED BLANKS PRIVATE LIMITED",
"R.K.FORTUNE DEVELOPERS PRIVATE LIMITED",
"R.K.INTERIORS PRIVATE LIMITED",
"R.K.INTERNATIONAL SERVICES PRIVATE LIMITED",
"R.K.KAYANI SHIPPING SERVICES PRIVATE LIMITED",
"R.K.M TRANSPORT PRIVATE LIMITED",
"R.K.MITTAL MACHINERY MART PRIVATE LIMITED",
"R.K.P. MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"R.K.PULSES PRIVATE LIMITED",
"R.K.R. HOUSING PRIVATE LIMITED",
"R.K.R. INVESTMENTS SERVICES PRIVATE LIMITED",
"R.K.RASAYAN PRIVATE LIMITED",
"R.K.SCAN PRIVATE LIMITED",
"R.K.SOHINEE MACHINERIES PRIVATE LIMITED",
"R.K.STRUCTURES PRIVATE LIMITED",
"R.K.T.CUTTING TOOLS PRIVATE LIMITED",
"R.K.TOWNSHIP PROMOTERS PRIVATE LIMITED",
"R.K.TRANSONIC ENGINEERS PRIVATE LIMITED",
"R.K.V. CARGO MOVERS PRIVATE LIMITED",
"R.K.VICTUALS PRIVATE LIMITED",
"R.K.WIRE PRODUCTS LTD",
"R.KOTHARI MARKETING PRIVATE LIMITED",
"R.L. AUTOMOBILES PRIVATE LIMITED",
"R.L. CHOUDHARY INFRATECH PRIVATE LIMITED",
"R.L. COMMERCIAL PRIVATE LIMITED",
"R.L. INVESTMENT AND FINANCE COMPANY LIMITED",
"R.L. JAIN EQUIPMENTS PRIVATE LIMITED",
"R.L. MASALA AND FOODS PRIVATE LIMITED",
"R.L. SALES PRIVATE LIMITED",
"R.L. SINGH ENGINEERS & BUILDERS PVT. LTD.",
"R.L. SPICES & GRAINS (IND) PRIVATE LIMITED",
"R.L.D HOTELS PRIVATE LIMITED",
"R.L.ISPAT PRIVATE LIMITED",
"R.M. EQUIPMENTS PRIVATE LIMITED",
"R.M. FUTURETECH PRIVATE LIMITED",
"R.M. ROLLER FLOUR MILLS PRIVATE LIMITED",
"R.M. SALES & SERVICES PRIVATE LIMITED",
"R.M.BHUTHER & CO DEVELOPER PRIVATE LIMITED",
"R.M.BROS PVT. LTD",
"R.M.CHEMICALS PRIVATE LIMITED",
"R.M.ENTERPRISES",
"R.M.G ELECTROMECH PRIVATE LIMITED",
"R.M.G FINSERV PRIVATE LIMITED",
"R.M.HERITAGE AND HOTELS PRIVATE LIMITED",
"R.M.K. INFOTECH PRIVATE LIMITED.",
"R.M.MOTORS PRIVATE LIMITED",
"R.M.P DEVELOPERS (I) PRIVATE LIMITED",
"R.M.POLYPETS PRIVATE LIMITED",
"R.M.V. SAFETY GLASS PRIVATE LIMITED",
"R.M.Y. CONSTRUCTIONS PRIVATE LIMITED",
"R.MADHU IMPEX PRIVATE LIMITED",
"R.MARBLE PALACE PRIVATE LIMITED",
"R.N. COMPOSITES PRIVATE LIMITED",
"R.N. GOEL AND SONS PRIVATE LIMITED",
"R.N. MARBLES PVT. LTD.",
"R.N. RICE MILL",
"R.N. STONE PRIVATE LIMITED",
"R.N.FILTERS PVT LTD",
"R.N.FORGING PRIVATE LIMITED",
"R.N.GUPTA AND COMPANY LIMITED",
"R.N.KAPOOR JEWELLERS PRIVATE LIMITED",
"R.N.P. STEELS PRIVATE LIMITED",
"R.P WORLD TELECOM PRIVATE LIMITED",
"R.P. ALLOYS AND STEEL FORGINGS PRIVATE LIMITED",
"R.P. ASSOCIATES",
"R.P. BUILDTECH CONSULTANTS PRIVATE LIMITED",
"R.P. COLD STORAGE PVT. LTD.",
"R.P. GOYAL & SONS PRIVATE LIMITED",
"R.P. GUMS & CHEMICAL LIMITED",
"R.P. PATEL SHIPPING & LOGISTICS PRIVATE LIMITED",
"R.P. PLASTOMERS PRIVATE LIMITED",
"R.P. POLY PACKS PRIVATE LIMITED",
"R.P. TECHVISION (INDIA) PRIVATE LIMITED",
"R.P. WOOD PRODUCTS PRIVATE LIMITED",
"R.P.INFO SYSTEMS LIMITED",
"R.P.S. POULTRY FARM PRIVATE LIMITED",
"R.P.S.S. HOTELS PRIVATE LIMITED",
"R.PRAKASH & SONS PRIVATE LIMITED",
"R.R. AGARWAL JEWELLERS PRIVATE LIMITED",
"R.R. BUSINESS PRIVATE LIMITED",
"R.R. EARTHMOVERS AND INFRASTRUCTURE (OPC) PRIVATE LIMITED",
"R.R. ENTERPRISES",
"R.R. FORGINGS PRIVATE LIMITED",
"R.R. GEMS PRIVATE LIMITED",
"R.R. INDUSTRIAL CORPORATION (INDIA) PRIVATE LIMITED",
"R.R. INDUSTRIES",
"R.R. MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"R.R. PACKAGERS PRIVATE LIMITED",
"R.R. SHETH & CO. PRIVATE LIMITED",
"R.R. SPORTS WEAR PRIVATE LIMITED",
"R.R. TECHNOMECH (INDIA) PRIVATE LIMITED",
"R.R. TUBES PRIVATE LIMITED",
"R.R. TYREAGE PVT. LTD.",
"R.R.APPARELS PVT LTD",
"R.R.E. FOODS AND SOFT DRINKS PRIVATE LIMITED",
"R.R.FABRICS PVT LTD",
"R.R.INDUSTRIES LIMITED",
"R.R.IRON AND STEEL PRIVATE LIMITED",
"R.R.LOGIC SYSTEMS PRIVATE LIMITED",
"R.R.P.RAJ INFRATECH PRIVATE LIMITED",
"R.R.PATEL GASES PRIVATE LIMITED",
"R.R.R. PHARMA PRIVATE LIMITED",
"R.R.S TEAM WORKS INDIA PRIVATE LIMITED",
"R.R.S. PEOPLE WORKS PRIVATE LIMITED",
"R.R.STONES PRIVATE LIMITED",
"R.R.VIBRANT POLYMERS LIMITED",
"R.S. AEROTECH PRIVATE LIMITED",
"R.S. AVENUES PRIVATE LIMITED",
"R.S. COMPUTER ENTERPRISES PRIVATE LIMITED.",
"R.S. CONCAST LIMITED",
"R.S. COOKWARE PRIVATE LIMITED",
"R.S. DREAM LAND PRIVATE LIMITED",
"R.S. ELECTROALLOYS PRIVATE LIMITED",
"R.S. ELECTROTECH PRIVATE LIMITED",
"R.S. ENGINEERING SOLUTIONS PRIVATE LIMITED",
"R.S. ENTERPRISES (BANGALORE) PRIVATE LIMITED",
"R.S. FACILITY SERVICE PRIVATE LIMITED",
"R.S. GRANITE MACHINE TOOLS PRIVATE LIMITED",
"R.S. INFRATECH LIMITED",
"R.S. IRON INDUSTRIES PRIVATE LIMITED",
"R.S. MANI SUPERMARKETS PRIVATE LIMITED",
"R.S. MILLS PRIVATE LIMITED",
"R.S. OVERSEAS PRIVATE LIMITED",
"R.S. PAPER TRADERS PRIVATE LIMITED",
"R.S. POLYFILMS PRIVATE LIMITED",
"R.S. RAM PROPERTIES PRIVATE LIMITED",
"R.S. ROLLER & FLOUR MILL PRIVATE LIMITED",
"R.S. SALES PRIVATE LIMITED",
"R.S. SERVICE SOLUTIONS PRIVATE LIMITED",
"R.S. SHARMA CONTRACTORS PRIVATE LTD.",
"R.S. SURGIPHARM PRIVATE LIMITED",
"R.S. TECHSPACE PRIVATE LIMITED.",
"R.S. TRANSPORT PRIVATE LIMITED",
"R.S. YARNS AND POWER PRIVATE LIMITED",
"R.S.AGARWALLA AND BROS. PRIVATE LIMITED",
"R.S.AGROTECH PRIVATE LIMITED",
"R.S.B. PHARMA PRIVATE LIMITED",
"R.S.BROTHERS JEWELLERS PRIVATE LIMITED",
"R.S.CAR WORLD PRIVATE LIMITED",
"R.S.ELECTRICALS PVT LTD",
"R.S.ELECTRONICS PRIVATE LIMITED",
"R.S.EXTRUSION PRIVATE LIMITED",
"R.S.G. EXPORTS PRIVATE LIMITED",
"R.S.INFOSYSTEMS PRIVATE LIMITED",
"R S INFRA TRANSMISSION LIMITED",
"R.S.ISPAT LIMITED",
"R.S.ISPAT LTD",
"R.S.KRAFT PAPERS PRIVATE LIMITED",
"R.S.SHARMA AND COMPANY (DELHI) PRIVATE LIMITED",
"R.S.STEELS PRIVATE LIMITED",
"R.S.TRIVENI FOODS PRIVATE LIMITED",
"R.S.V. CONSTRUCTIONS PRIVATE LIMITED",
"R.SHRI AUTO DEALERS PRIVATE LIMITED",
"R.SOLUTIONS PRIVATE LIMITED",
"R.T. SYNTEX PVT LTD",
"R.T.C. ENTERPRISES PRIVATE LIMITED",
"R.T.C. OVERSEAS PRIVATE LIMITED",
"R.T.FOODS INDIA LIMITED",
"R.T.ROLLER FLOUR MILLS PRIVATE LIMITED",
"R.U. PLYWOOD PRIVATE LIMITED",
"R.V. AUTOMOBILE DEALERS PRIVATE LIMITED",
"R.V. BRIGGS & CO PVT LTD",
"R.V. INVESTMENT AND DEALERS LTD",
"R.V. SPINNERS PRIVATE LIMITED",
"R.V. TEX PRIVATE LIMITED",
"R.V. UDYOG PRIVATE LIMITED",
"R.V.AGRAWAL IMPEX PRIVATE LIMITED",
"R.V.I. CHEMICALS PRIVATE LIMITED",
"R.V.M EDUCATION PRIVATE LIMITED",
"R.V.NIRMAAN PRIVATE LIMITED",
"R.V.S. TOURS AND TRAVELS PRIVATE LIMITED",
"R+B FILTER MANUFACTURING ENTERPRISES PRIVATE LIMITED",
"R1 INTERNATIONAL (INDIA) PRIVATE LIMITED",
"R1 RCM GLOBAL PRIVATE LIMITED",
"R1 RCM INDIA PRIVATE LIMITED",
"R11 TEK PRIVATE LIMITED",
"R1-RADIANCE LIGHTS PRIVATE LIMITED",
"R2 PRO PRIVATE LIMITED",
"R2A AUTOMATION PRIVATE LIMITED",
"R2H EDUCATION PRIVATE LIMITED",
"R2K SOFTWARE INDIA PRIVATE LIMITED",
"R2M SOLUTIONS PRIVATE LIMITED",
"R3 CARRIERS PRIVATE LIMITED",
"R3 CROP CARE PRIVATE LIMITED",
"R3 FLEXO INDIA PRIVATE LIMITED",
"R3 INTERNATIONAL GOLF PRIVATE LIMITED",
"R3 NATURALS PRIVATE LIMITED",
"R-3 ORGANICS LIMITED",
"R4 RAYS PRIVATE LIMITED",
"R-5 FABB PRIVATE LIMITED",
"RA BACK OFFICE SERVICE INDIA PRIVATE LIMITED",
"RA CHEM ENTERPRISES PRIVATE LIMITED",
"RA CHEM PHARMA LIMITED",
"RA CHEMICALS PRIVATE LIMITED",
"RA CHEMTECH PRIVATE LIMITED",
"RA CREATIVES PRIVATE LIMITED",
"RA HOSPITALITY SERVICES INDIA PRIVATE LIMITED",
"RA HOUSING & INFRA PRIVATE LIMITED",
"RA INDUSTRIAL SYSTEM PRIVATE LIMITED",
"RA MASALE PRIVATE LIMITED",
"RA MINING PRIVATE LIMITED",
"RA PODAR MEDICAL COLLEGE",
"RA SPECTRUM ENGINEERING SERVICES PRIVATE LIMITED",
"RA TAX CONSULTANTS PRIVATE LIMITED",
"RA TRADERS AND ENGINEERS PRIVATE LIMITED",
"RA4MI B2B PRIVATE LIMITED",
"RAAA INFRASTRUCTURES PRIVATE LIMITED",
"RAAB GRAND PRIVATE LIMITED",
"RAAB INVESTMENT PRIVATE LIMITED",
"RAAD SYSTEMS PRIVATE LIMITED",
"RAADA INFRACON PRIVATE LIMITED",
"RAADHA EDUCATION PRIVATE LIMITED",
"RAADHA RAJENDRAN HOSPITAL PRIVATE LIMITED",
"RAADHA RANI NIRMAAN PRIVATE LIMITED",
"RAADHEY NAMKEEN PRIVATE LIMITED",
"RAADHEY SILVERS PRIVATE LIMITED",
"RAADHIKA SHOECRAFTS PRIVATE LIMITED",
"RAAG AGENCIES PRIVATE LIMITED",
"RAAG EXPORTS PRIVATE LIMITED",
"RAAG VATIKA APARTMENTS PRIVATE LIMITED",
"RAAG VIHAR APARTMENTS PRIVATE LIMITED",
"RAAGA BLOCKPRINTED TEXTILES PRIVATE LIMITED",
"RAAGA MAYURI BUILDERS PRIVATE LIMITED",
"RAAGASHREE IMPEX PRIVATE LIMITED",
"RAAGHAV RAMS INFRA PRIVATE LIMITED",
"RAAGHAVENDRA SPIN COT MILLS",
"RAAGNI EQUIPMENT PRIVATE LIMITED",
"RAAHAT FINANCIAL & CONSULTANCY SERVICES PRIVATE LIMITED",
"RAAHEE MULTI PACK PRIVATE LIMITED",
"RAAHEN CREATIONS PRIVATE LIMITED",
"RAAHI BLENDERS & DISTILLERS PRIVATE LIMITED",
"RAAHITYA CONSTRUCTIONS PRIVATE LIMITED",
"RAAISHA IMPEX PRIVATE LIMITED",
"RAAISHA METALS INDIA PRIVATE LIMITED",
"RAAJ KHOSLA AND CO PRIVATE LIMITED",
"RAAJ MEDISAFE INDIA LIMITED",
"RAAJ UNOCAL LUBRICANTS LIMITED",
"RAAJ WOODTEK PRIVATE LIMITED",
"RAAJ WOOLEN INDUSTRIES",
"RAAJA MAGNETICS LIMITED",
"RAAJAS TECHNOLOGIES PRIVATE LIMITED",
"RAAJCO SPINNERS PRIVATE LIMITED",
"RAAJGAD TECHNO SERVICES PRIVATE LIMITED",
"RAAJHANS SOLAR PRIVATE LIMITED",
"RAAJITHA CONSTRUCTIONS PRIVATE LIMITED",
"RAAJRATNA ELECTRODES PRIVATE LIMITED",
"RAAJRATNA ENERGY HOLDINGS PRIVATE LIMITED",
"RAAJRATNA METAL INDUSTRIES LIMITED",
"RAAJRATNA STAINLESS PRIVATE LIMITED",
"RAAJRATNA STOCKHOLDING PRIVATE LIMITED",
"RAAJRATNA VENTURES LIMITED",
"RAAJVI AUTOWORLD PRIVATE LIMITED",
"RAAK ARTS & SCIENCE COLLEGE",
"RAAK COLLEGE OF ENGINEERING & TECHNOLOGY",
"RAAM AUTOBAHN INDIA PRIVATE LIMITED",
"RAAM FOUR WHEELERS INDIA PRIVATE LIMITED",
"RAAM INFRATECH INDIA PRIVATE LIMITED",
"RAAM MULTISOLVEX INDIA LIMITED",
"RAAM TWO WHEELERS INDIA PRIVATE LIMITED",
"RAAM4WHEELERS LLP",
"RAAMA PAPER MILLS LIMITED",
"RAAMESHTH ELECTRO PLASTA PRIVATE LIMITED",
"RAAMKAY CROP SCIENCE SOLUTIONS PRIVATE LIMITED",
"RAAMS MOVING TECHNOLOGIES PRIVATE LIMITED",
"RAAMTEL SOLUTIONS PRIVATE LIMITED",
"RAAMTON ENGINEERING PRIVATE LIMITED",
"RAAMU SEEDS PRIVATE LIMITED",
"RAANA SEMICONDUCTORS PRIVATE LIMITED",
"RAANCOM INFRATECC PRIVATE LIMITED",
"RAAS CREATIONS PRIVATE LIMITED",
"RAAS ENTERPRISES PRIVATE LIMITED",
"RAAS EQUIPMENT PRIVATE LIMITED",
"RAAS HOSPITALITY &IT PRIVATE LIMITED",
"RAAS INFO SOLUTIONS PRIVATE LIMITED",
"RAAS INTRATECH PRIVATE LIMITED",
"RAAS TECHNOLOGY INDIA PRIVATE LIMITED",
"RAASA AYURVEDA PRIVATE LIMITED",
"RAASAA RETAIL PRIVATE LIMITED",
"RAASHIKA INDUSTRIES PRIVATE LIMITED",
"RAASI CEMENT LIMITED",
"RAASI COMPUTER LIMITED",
"RAASI FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"RAASI GROWTH FUND LTD",
"RAASI INTERNATIONAL PRIVATE LIMITED",
"RAASI REFRACTORIES LTD.",
"RAASS INDUSTRIES PRIVATE LIMITED",
"RAASVIN RUBBERS PRIVATE LIMITED",
"RAATHI PLASTIC PRIVATE LIMITED",
"RAAVELA INTERIORS PRIVATE LIMITED",
"RAAVI AGRO OILS PRIVATE LIMITED",
"RAAY GLOBAL INVESTMENTS PRIVATE LIMITED",
"RAAYAN CULINARY ART LLP",
"RAAYNA ENTERPRISES PRIVATE LIMITED",
"RAB DESIGNS LLP",
"RAB ORNAMENTS PRIVATE LIMITED",
"RAB TEXTILES PRIVATE LIMITED",
"RABA KRR AUTOS PRIVATE LIMITED",
"RABAA COAL CARRIER PRIVATE LIMITED",
"RABAB MUSIC PRODUCTIONS PRIVATE LIMITED",
"RABATEX INDUSTRIES PRIVATE LIMITED",
"RABBANI CONSTRUCTION PRIVATE LIMITED",
"RABBIT AND TORTOISE TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"RABBIT HOLE ENTERTAINMENT PRIVATE LIMITED",
"RABBIT MOVIES PRIVATE LIMITED",
"RABBIT STATIONERY PRIVATE LIMITED",
"RABBITWOOD RETAILS PRIVATE LIMITED",
"RABBIXEL STUDIO PRIVATE LIMITED",
"RABBLE ALLIED SERVICES PRIVATE LIMITED",
"RABBON METAL-TEC PRIVATE LIMITED",
"RABCO SERVICES PRIVATE LIMITED",
"RABEA GIRLS' PUBLIC SCHOOL",
"RABELA TRADERS & FINANCE PVT LTD",
"RABHAV LIMITED",
"RABI BINOD BUSINESS PRIVATE LIMITED",
"RABI ENGINEERING WORKS PRIVATE LIMITED",
"RABIA LOGISTICS PRIVATE LIMITED",
"RABIA TE XTILES PRIVATE LIMITED",
"RABIBHAG DEHIPARA PRIMARY SCHOOL",
"RABIKO LIFESTYLE PRIVATE LIMITED",
"RABINA ENTERPRISES PRIVATE LIMITED",
"RABINDRA BHARATI UNIVERSITY",
"RABINDRA ENTERPRISES PRIVATE LIMITED",
"RABINDRA HEALTH CARE PRIVATE LIMITED",
"RABINDRA LIFELINE PRIVATE LIMITED",
"RABINDRA NARAYAN ENTERPRISES PRIVATE LIMITED",
"RABINDRA SURGICALS PRIVATE LIMITED",
"RABINDRANATH TAGORE SCHOOL OF EXCELLENCE",
"RABJYOT AIRTECH PRIVATE LIMITED",
"RABO SHARED SERVICES PRIVATE LIMITED",
"RABRO SPECIALITY CHEMICALS PRIVATE LIMITED",
"RABRO SPORTS INDIA PRIVATE LIMITED",
"RABS FASHIONS PRIVATE LIMITED",
"RABSAN DRIVES PRIVATE LIMITED",
"RABWIN INDUSTRIES PRIVATE LIMITED",
"RABYTE ELECTRONICS PRIVATE LIMITED",
"RABYTE TECHNOLOGIES LLP",
"RAC COOLING SOLUTIONS PRIVATE LIMITED",
"RAC EXTRUSIONS LIMITED",
"RAC IT SOLUTIONS PRIVATE LIMITED",
"RAC PAPERS LIMITED",
"RACANAA INNOVATIVE SOLUTIONS ENERGY PRIVATE LIMITED",
"RACCA INFOTECH PRIVATE LIMITED",
"RACCOLTO AGRITECH INDIA PRIVATE LIMITED",
"RACE AHEAD REAL ESTATES PRIVATE LIMITED",
"RACE AUTOMOBILES PRIVATE LIMITED",
"RACE CABLES PRIVATE LIMITED",
"RACE COACHING INSTITUTE PRIVATE LIMITED",
"RACE DYNAMICS INDIA PRIVATE LIMITED",
"RACE KNEE CLINIC PRIVATE LIMITED",
"RACE PHARMACEUTICALS PRIVATE LIMITED",
"RACE2CLOUD TECHNOLOGIES PRIVATE LIMITED",
"RACEMIC LABS PRIVATE LIMITED",
"RACEMOSA ENERGY (INDIA) PRIVATE LIMITED",
"RACER VALVES PRIVATE LIMITED",
"RACFLEX PACK PVT LTD",
"RACHAITA INFOSOFT PRIVATE LIMITED",
"RACHAMALLU FORGINGS PRIVATE LIMITED",
"RACHANA BUILDART PRIVATE LIMITED",
"RACHANA CONSTRUCTION COMPANY (NAGPUR) PRIVATE LIMITED",
"RACHANA ELECTROMECH & ENGINEERING WORKS PRIVATE LIMITED",
"RACHANA FENESTRAA PRIVATE LIMITED",
"RACHANA HOME APPLIANCES PVT LTD",
"RACHANA INFOTECH PRIVATE LIMITED",
"RACHANA INFRASTRUCTURE LIMITED",
"RACHANA LOGISTICS PRIVATE LIMITED",
"RACHANA ORGANICS PRIVATE LIMITED",
"RACHANA POLYMERS PVT LTD",
"RACHANA RAJ TRANSPORT ASSOCIATES PRIVATE LIMITED",
"RACHANA RESOURCES (INDIA) PRIVATE LIMITED",
"RACHANA SPEED LOGISTIC PRIVATE LIMITED",
"RACHANA TELEVISION PRIVATE LIMITED",
"RACHANA TRADING CORPORATION",
"RACHANA TRANSLOGISTICS PRIVATE LIMITED",
"RACHANA UDYOG (EXPORTS) PVT LTD",
"RACHANA VIDYALAYA",
"RACHANAA REALTORS PRIVATE LIMITED",
"RACHAYITA FASHIONS PRIVATE LIMITED",
"RACHCON INFRAPROJECTS PRIVATE LIMITED",
"RACHEL AND PARMAR FOODS PRIVATE LIMITED",
"RACHERLA GARMENTS PRIVATE LIMITED",
"RACHESHWAR INDUSTRIES LIMITED",
"RACHHPAL AUTO ALLIANCE PRIVATE LIMITED",
"RACHIKA TRADING PRIVATE LIMITED",
"RACHIL REMEDIES PVT LTD",
"RACHILU INDUSTRIES PRIVATE LIMITED",
"RACHIT CREATIONS PRIVATE LIMITED",
"RACHIT FASHION PRIVATE LIMITED",
"RACHIT HEALTH CARE PRIVATE LIMITED",
"RACHIT INDUSTRIES PRIVATE LIMITED",
"RACHIT IRON AND STEELS PRIVATE LIMITED",
"RACHIT NIRMAN PRIVATE LIMITED",
"RACHIT PACKEGING PRIVATE LIMITED",
"RACHIT PRINTS PRIVATE LIMITED",
"RACHIT SAREES PRIVATE LIMITED",
"RACHITA CONSTRUCTIONS PRIVATE LIMITED",
"RACHITECH ENGINEERING PRIVATE LIMITED",
"RACHNA AIR COMPONENTS PRIVATE LIMITED",
"RACHNA ART PRINTS PRIVATE LIMITED",
"RACHNA FIRE ENGINEERING PRIVATE LIMITED",
"RACHNA HOSPITAL PRIVATE LIMITED",
"RACHNA MANN DESIGN PRIVATE LIMITED",
"RACHNA METAL INDUSTRIES PRIVATE LIMITED",
"RACHNA MOTORS PRIVATE LIMITED",
"RACHNA OVERSEAS PRIVATE LIMITED",
"RACHNA PLASTICIZERS",
"RACHNA SAGAR PRIVATE LIMITED",
"RACHNOUTSAV EVENTS PRIVATE LIMITED",
"RACHTR PROJECTS PRIVATE LIMITED",
"RACK N SPACE STORAGE SOLUTIONS PRIVATE LIMITED",
"RACKBANK DATACENTERS PRIVATE LIMITED",
"RACKNSELL ONLINE SERVICES PRIVATE LIMITED",
"RACKSPACE INDIA PRIVATE LIMITED",
"RACOLD THERMO PRIVATE LIMITED",
"RACOMM ENGINEERS PRIVATE LIMITED",
"RACON MARINE PRIVATE LIMITED",
"RACONTEUR GRANITE LIMITED",
"RACQUETHUB INDIA PRIVATE LIMITED",
"RACSANN TECHNOLOGIES PRIVATE LIMITED",
"RACTO KARMA IMPEX PRIVATE LIMITED",
"RACV TEXTILE PRIVATE LIMITED",
"RAD DATA COMMUNICATIONS MARKETING INDIA PRIVATE LIMITED",
"RAD DATA COMMUNICATIONS PRIVATE LIMITED",
"RAD ELAN DISTRIBUTORS PRIVATE LIMITED",
"RAD GLOBAL PRIVATE LIMITED",
"RAD LOGISTICS INDIA PRIVATE LIMITED",
"RAD PROCESS SYSTEMS PRIVATE LIMITED",
"RAD TECH BUILDCON PRIVATE LIMITED",
"RAD365 SOLUTIONS PRIVATE LIMITED",
"RADAAN MEDIA WORKS INDIA LIMITED",
"RADADIA ENGINEERING PRIVATE LIMITED",
"RADADIA FASTENERS PRIVATE LIMITED",
"RADAKRISHNA HOSPITAL",
"RADAMATIC SOLUTIONS PRIVATE LIMITED",
"RADAR TECHNOSOFT INDIA PRIVATE LIMITED",
"RADAR VENTURES PRIVATE LIMITED",
"RADAR VISION LIMITED",
"RADBOUND INFRASTRUCTURE PRIVATE LIMITED",
"RADBOUND WRAPPERS PRIVATE LIMITED",
"RADCLIFFE EDUCATION (NORTH) PRIVATE LIMITED",
"RADCO BUILDTECH PRIVATE LIMITED",
"RADCO FLEX INDIA PRIVATE LIMITED",
"RADCO MARKETING PRIVATE LIMITED",
"RADCOM PACKAGING PRIVATE LIMITED",
"RADCOM TRADING INDIA PRIVATE LIMITED",
"R-ADDA RESTAURANTS PRIVATE LIMITED",
"RADDEF PRIVATE LIMITED",
"RADDHE IMPEX",
"RADDISON HEALTHCARE PRIVATE LIMITED",
"RADDISUN PHARMACHEM INDUSTRIES PRIVATE LIMITED",
"RADDOC LIVE TELESOLUTIONS PRIVATE LIMITED",
"RADDOP ENTERPRISES PRIVATE LIMITED",
"RADEL ADVANCED TECHNOLOGY PRIVATE LIMITED",
"RADEL ELECTRONICS PRIVATE LIMITED",
"RADEUS TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"RADEX STATIONERY INDIA PRIVATE LIMITED",
"RADGO CONSULTING PRIVATE LIMITED",
"RADHA BUILDTECH (INDIA) PRIVATE LIMITED",
"RADHA CARGO CARE PRIVATE LIMITED",
"RADHA CASTING AND METALIK PRIVATE LIMITED",
"RADHA CHAIN CO. PRIVATE LIMITED",
"RADHA COKE PRODUCTS PRIVATE LIMITED",
"RADHA ELECTRONICS PRIVATE LIMITED",
"RADHA EMPORIUM FASHION PRIVATE LIMITED",
"RADHA ENTRADE PRIVATE LIMITED",
"RADHA FABTAX PRIVATE LIMITED",
"RADHA FINCOM LTD",
"RADHA GOBINDA HEEMGHAR PRIVATE LIMITED",
"RADHA GOBINDA JUTE MILL PRIVATE LIMITED",
"RADHA GOBINDA SAHA AND SONS PRIVATE LIMITED",
"RADHA GOVIND AUTOMOBILES PRIVATE LIMITED",
"RADHA GOVIND COLLEGE OF EDUCATION",
"RADHA GOVIND FACILITIES INDIA PRIVATE LIMITED",
"RADHA HARDWARE PRIVATE LIMITED",
"RADHA HARI ISPAT AND ALLOYS PRIVATE LIMITED",
"RADHA HARI JWELLS & GEMS PRIVATE LIMITED",
"RADHA HARI WHEELS PRIVATE LIMITED",
"RADHA INTERIOR PRIVATE LIMITED",
"RADHA KESHAV RICE MILL PVT.LTD.",
"RADHA KISHAN BISHAN DASS RANG RASAYAN PRIVATE LIMITED",
"RADHA KISHAN GOBIND RAM LTD",
"RADHA KISHUN METALS PRIVATE LIMITED",
"RADHA KRISHAN AND SONS PRIVATE LIMITED",
"RADHA KRISHAN CREATION PRIVATE LIMITED",
"RADHA KRISHAN FASHIONS PRIVATE LIMITED",
"RADHA KRISHAN PLANNING & COLONIZERS PRIVATE LIMITED",
"RADHA KRISHAN YARN PRIVATE LIMITED",
"RADHA KRISHNA AQUA TRADERS PRIVATE LIMITED",
"RADHA KRISHNA AUTOMOBILES PRIVATE LIMITED",
"RADHA KRISHNA BUILDTECH PRIVATE LIMITED",
"RADHA KRISHNA COAL PRIVATE LIMITED",
"RADHA KRISHNA DRESSES PVT LTD",
"RADHA KRISHNA FIRAYALAL & CO.",
"RADHA KRISHNA FLOUR MILL",
"RADHA KRISHNA IMPEX PRIVATE LIMITED",
"RADHA KRISHNA INTER COLLEGE",
"RADHA KRISHNA JUTE PRODUCTS PRIVATE LIMITED",
"RADHA KRISHNA KITCHEN N BATH PRIVATE LIMITED",
"RADHA KRISHNA PRAKSHAN PRIVATE LIMITED",
"RADHA KRISHNA REALCON PRIVATE LIMITED",
"RADHA KRISHNA SURFACTANTS PRIVATE LIMITED",
"RADHA KRISNA STEEL COMPANY PRIVATE LIMITED",
"RADHA KRUSHNA AGRO MARKETING PRIVATE LIMITED",
"RADHA MADHABA FILLING STATION PVT LTD",
"RADHA MADHAV CONSTRUCTION COMPANY PRIVATE LIMITED",
"RADHA MADHAV FABRICS PRIVATE LIMITED",
"RADHA MADHAV FOOTWEAR PRIVATE LIMITED",
"RADHA MADHAV INVESTMENTS PRIVATE LIMITED",
"RADHA MADHAV SILK MILLS PRIVATE LIMITED",
"RADHA MADHAV SURFACTANTS PRIVATE LIMITED",
"RADHA MANASA BIKES PRIVATE LIMITED",
"RADHA MARBLE & GRANITE PRIVATE LIMITED",
"RADHA MARKETING",
"RADHA MOHAN PURSHOTTAM DAS JEWELS PRIVATE LIMITED",
"RADHA PRECISION PRIVATE LIMITED",
"RADHA RAJ LOGISTICS PRIVATE LIMITED",
"RADHA RAJALAKSHMI HOTELS PRIVATE LIMITED",
"RADHA RAMAN METAL PRIVATE LIMITED",
"RADHA RAMAN SPICES",
"RADHA RAMANA POLYMERS PRIVATE LIMITED",
"RADHA RANI AGRO CROPS PRIVATE LIMITED",
"RADHA RANI AGRO IMPEX PRIVATE LIMITED",
"RADHA RANI COLD STORAGE PRIVATE LIMITED",
"RADHA RANI CREATIONS PRIVATE LIMITED",
"RADHA RANI FAB PRIVATE LIMITED",
"RADHA RANI FOODS PRIVATE LIMITED",
"RADHA RANI FOOTWEAR PRIVATE LIMITED",
"RADHA REGENT HOTELS P LIMITED",
"RADHA ROAD MAINTAINANCE PRIVATE LIMITED",
"RADHA SARVESHWAR EMPORIUM PRIVATE LIMITED",
"RADHA SMELTERS PRIVATE LIMITED",
"RADHA SOAMI FOOD PRODUCTS PRIVATE LIMITED",
"RADHA SPACES (I) PRIVATE LIMITED",
"RADHA STEEL",
"RADHA SWAMI KRISHAK ORGANISATION",
"RADHA SWAMI PLAST PRODUCTS PRIVATE LIMITED",
"RADHA SWAMY POLYFAB PRIVATE LIMITED",
"RADHA TRADELINKS PRIVATE LIMITED",
"RADHABA SHAMLAL PATEL VIDHYALAYA DHAMARMPUR",
"RADHABALLABH SILK MILLS PRIVATE LIMITED",
"RADHABARI TEA CO PVT LTD",
"RADHABLOCKS AND MEDIA PRIVATE LIMITED",
"RADHADAMODAR MULTIPURPOSE COLDSTORAGE PRIVATE LIMITED",
"RADHAGOBINDA FOODS AND BEVERAGES PRIVATE LIMITED",
"RADHAGOBINDA RICE MILLS PRIVATE LIMITED",
"RADHAGOBINDA STEEL & ALLOYS PRIVATE LIMITED",
"RADHAGOVIND FERTILISERS AND CHEMICALS PRIVATE LIMITED",
"RADHAGOVIND SEEDS & ALLIED PRODUCTS PRIVATE LIMITED",
"RADHAGOVIND WHEELS INDIA PRIVATE LIMITED",
"RADHAHARI VENTURE PRIVATE LIMITED",
"RADHAKANT AGRO FOODS PRIVATE LIMITED",
"RADHAKANTA HIMGHAR PRIVATE LIMITED",
"RADHAKISAN KALYANMAL AND COMPANY",
"RADHAKISHAN AGROTECH PRIVATE LIMITED",
"RADHAKISHAN INFRA DEVELOPERS PRIVATE LIMITED",
"RADHAKRISHNA ACUA PRIVATE LIMITED",
"RADHAKRISHNA AGRO INDUSTRIES PRIVATE LIMITED",
"RADHAKRISHNA BIMALKUMAR PRIVATE LIMITED",
"RADHAKRISHNA BUSINESS SOLUTIONS PRIVATE LIMITED",
"RADHAKRISHNA EGG EXPORTS LIMITED",
"RADHAKRISHNA ENTERPRISES RATLAM",
"RADHAKRISHNA FINANCE PRIVATE LIMITED",
"RADHAKRISHNA FOOD SERVICES PRIVATE LIMITED",
"RADHAKRISHNA FOODLAND PRIVATE LIMITED",
"RADHAKRISHNA FOREX PRIVATE LIMITED",
"RADHAKRISHNA GOLD JEWELLERY PRIVATE LIMITED",
"RADHAKRISHNA MANUFACTURING & INDUSTRIES PRIVATE LIMITED",
"RADHAKRISHNA RAMNARAIN PRIVATE LIMITED",
"RADHAKRUSHNA PUBLICATIONS PRIVATE LIMITED",
"RADHALAXMI SPINTEX PRIVATE LIMITED",
"RADHAMADHAB AGROTECH PRIVATE LIMITED",
"RADHAMADHAB COLD STORAGE PVT LTD",
"RADHAMADHAV MARBLES PRIVATE LIMITED",
"RADHAMADHAV PULSES PRIVATE LIMITED",
"RADHAMANI APPARELS PRIVATE LIMITED",
"RADHAMANI EXPORTS PRIVATE LIMITED",
"RADHAMANI INDIA LTD",
"RADHAMANI TEXTILES PRIVATE LIMITED",
"RADHAMOHAN BUILDERS PRIVATE LIMITED",
"RADHAMOHAN DEVELOPERS PRIVATE LIMITED",
"RADHAMOHAN DYEING & PRINTING MILLS PRIVATE LIMITED",
"RADHAMOHAN FABTEX PRIVATE LIMITED",
"RADHAMOHAN MARKETING PRIVATE LIMITED",
"RADHAN GREENTECH PRIVATE LIMITED",
"RADHANATH INST OF ADVANCED STUDIES",
"RADHANI TOUR & TRAVELS PRIVATE LIMITED",
"RADHARAMAN AGRO OILS PVT LTD",
"RADHARAMAN COLLEGE OF PHARMACY",
"RADHARAMAN CONSTRUCTIONS AND MARKETING PRIVATE LIMITED",
"RADHARAMAN FIBRES PRIVATE LIMITED",
"RADHARAMAN GROUP OF INSTITUTION BHOPAL",
"RADHA-RAMAN HOSPITALITY PRIVATE LIMITED",
"RADHARAMAN INFRASTRUCTURE PRIVATE LIMITED",
"RADHARAMAN SKYLINEINFRATECH PRIVATE LIMITED",
"RADHARAMAN STAINLESS STEEL PRIVATE LIMITED",
"RADHARAMAN SYNTHETICS PRIVATE LIMITED",
"RADHARAMANI JEWELLERS & BULLION PRIVATE LIMITED",
"RADHARANI COMMERCIAL PRIVATE LIMITED",
"RADHARANI GOLD PRIVATE LIMITED",
"RADHARANI HIMGHAR PRIVATE LIMITED",
"RADHARANI INTERNATIONALS PRIVATE LIMITED",
"RADHARANI JEWELLERS LIMITED",
"RADHARANI MARBLE GRANITE PRIVATE LIMITED",
"RADHARANI NATURAL MARBLE PRIVATE LIMITED",
"RADHARANI PROCESSORS PRIVATE LIMITED",
"RADHARANI SALES PRIVATE LIMITED",
"RADHARANI STEELS PRIVATE LIMITED",
"RADHARANNI BUILDCON PRIVATE LIMITED",
"RADHASHOK PHARMACHEM PRIVATE LIMITED",
"RADHASHYAM INDUSTRIES PRIVATE LIMITED",
"RADHASWAMI AUTO PRIVATE LIMITED",
"RADHASWAMI TRADERS PRIVATE LIMITED",
"RADHASWAMI TRANSPORT PRIVATE LIMITED",
"RADHAVALLABH DIAMOND PRIVATE LIMITED",
"RADHE AGRO INDUSTRIES INDIA PRIVATE LIMITED",
"RADHE CIVICON PRIVATE LIMITED",
"RADHE CONSTRUCTION",
"RADHE COTTON COMPANY",
"RADHE CREATIONS PRIVATE LIMITED",
"RADHE DEVELOPERSINDIALIMITED",
"RADHE ENDOSCOPY CENTRE AND INFERTILITY HOSPITAL PRIVATE LIMITED",
"RADHE EXIM PRIVATE LIMITED",
"RADHE FABRICS PRIVATE LIMITED",
"RADHE GIRDHARI COLD STORAGE PRIVATE LIMITED",
"RADHE GOVIND ESTATES PRIVATE LIMITED",
"RADHE GOVIND PROMOTERS PRIVATE LIMITED",
"RADHE HOSPITAL",
"RADHE HURKAT ISPAT PRIVATE LIMITED",
"RADHE INFRASTRUCTURE AND PROJECTS(INDIA)LIMITED",
"RADHE INSTRUMENTATION PRIVATE LIMITED",
"RADHE KRISHNA AUTOS PRIVATE LIMITED",
"RADHE KRISHNA CLOTHINGS PRIVATE LIMITED",
"RADHE KRISHNA CONTRACTORS PRIVATE LIMITED",
"RADHE KRISHNA DESIGNER",
"RADHE KRISHNA ENTERPRISE",
"RADHE KRISHNA INFRACON PRIVATE LIMITED",
"RADHE KRISHNA LOGISTIC PRIVATE LIMITED",
"RADHE KRISHNA TEMPLE ELEPHANT WELFARE TRUST",
"RADHE MEDTECH PRIVATE LIMITED",
"RADHE PROMOTERS PRIVATE LIMITED",
"RADHE SHAM JAIN DIAMOND JEWELLERS PRIVATE LIMITED",
"RADHE SHAM RAVI PRAKASH TIMBERS PRIVATE LIMITED",
"RADHE SHYAM AUTOMOTIVES PRIVATE LIMITED",
"RADHE SHYAM DIAMONDS LLP",
"RADHEE FOODS PRIVATE LIMITED",
"RADHEGOVIND INFRACARE PRIVATE LIMITED",
"RADHEGOVINDKRIPA DEVELOPERS PRIVATE LIMITED",
"RADHEKRISHNA COTTON PRIVATE LIMITED",
"RADHEKRISHNA EXTRACTIONS PRIVATE LIMITED",
"RADHEKRISHNA PACKAGING PRIVATE LIMITED",
"RADHE-RADHE SYNTHETICS PRIVATE LIMITED",
"RADHESH FABRICS PRIVATE LIMITED",
"RADHESH PLASTICS INDIA PRIVATE LIMITED",
"RADHESHAM WELLPACK PRIVATE LIMITED",
"RADHESHREE WIRES AND COILS PRIVATE LIMITED",
"RADHESHYAM COTTON PRIVATE LIMITED",
"RADHESHYAM GARMENTS PRIVATE LIMITED",
"RADHESHYAM GINNING PRESSING PRIVATE LIMITED",
"RADHESHYAM GREEN LAM PRIVATE LIMITED",
"RADHESHYAM INFRABUILD PRIVATE LIMITED",
"RADHESHYAM LAMINATES AND DECORS PRIVATE LIMITED",
"RADHESHYAM MISHRILAL SARAF PRIVATE LIMITED",
"RADHESHYAM MOTORS PRIVATE LIMITED",
"RADHESHYAM PAPER MILLS PRIVATE LIMITED",
"RADHESHYAM PROTEINS PRIVATE LIMITED",
"RADHESHYAM SPINNING MILL PRIVATE LIMITED",
"RADHESHYAM STEEL INDUSTRIES PRIVATE LIMITED",
"RADHESHYAM TRENDZ PRIVATE LIMITED",
"RADHEY BUILDHOME PRIVATE LIMITED",
"RADHEY COLLECTION SERVICES PRIVATE LIMITED",
"RADHEY FOAM PRIVATE LIMITED",
"RADHEY GOVIND COMMUNICATION PRIVATE LIMITED",
"RADHEY GOVIND LIFESTYLES PRIVATE LIMITED",
"RADHEY GOVIND STEEL AND ALLOYS PRIVATE LIMITED",
"RADHEY KNIT FAB PRIVATE LIMITED",
"RADHEY KRISHNA RENEWABLE PRIVATE LIMITED",
"RADHEY KRISHNA STEEL PRIVATE LIMITED",
"RADHEY KRISHNA TERENE PRIVATE LIMITED",
"RADHEY LAL & SONS JEWELLERS PRIVATE LIMITED",
"RADHEY LAL SUGAR MILLS PRIVATE LIMITED",
"RADHEY METAALLOYS INDIA PRIVATE LIMITED",
"RADHEY RADHEY STONE CRUSHER PRIVATE LIMITED",
"RADHEY RADHEY YARNS PRIVATE LIMITED",
"RADHEY SALES PRIVATE LIMITED",
"RADHEY SHREE FASHION PRIVATE LIMITED",
"RADHEY SHYAM AGARWAL FABRIC PRIVATE LIMITED",
"RADHEY SHYAM GUPTA MARKETING PRIVATE LIMITED",
"RADHEY SHYAM JEWELLERS PRIVATE LIMITED",
"RADHEY SHYAM PROVISIONS PRIVATE LIMITED",
"RADHEY TESTING & CONSULTANTS PRIVATE LIMITED",
"RADHEYA MACHINING LIMITED",
"RADHEYKESHAV TEXTECH PRIVATE LIMITED",
"RADHEYKRISHNA TECHNOBUILD PRIVATE LIMITED",
"RADHEYSHYAM RAKESH KUMAR JEWELLERS PRIVATE LIMITED",
"RADHIKA ABASAN PRIVATE LIMITED",
"RADHIKA ADVERTISING PRIVATE LIMITED",
"RADHIKA AGENCIES PRIVATE LIMITED",
"RADHIKA AGRONOMIST LIMITED",
"RADHIKA BAI ADHYAPAK COLLEGE",
"RADHIKA BIO TECHNOLOGIES PRIVATE LIMITED",
"RADHIKA BUILDERS PRIVATE LIMITED",
"RADHIKA BUILDPROP PRIVATE LIMITED",
"RADHIKA CASTING PRIVATE LIMITED",
"RADHIKA CHAINS PRIVATE LIMITED",
"RADHIKA CHEMTECH (INDIA) PRIVATE LIMITED",
"RADHIKA COLLECTION PRIVATE LIMITED",
"RADHIKA CONSTRUCTION COMPANY PRIVATE LIMITED",
"RADHIKA COTEX",
"RADHIKA DEVCON PRIVATE LIMITED",
"RADHIKA DIAMONDS MANUFACTURING LLP",
"RADHIKA EDUCARE SCHOOL",
"RADHIKA ELECTROTECH PRIVATE LIMITED",
"RADHIKA EMPORIUM PRIVATE LIMITED",
"RADHIKA ENTERPRISES",
"RADHIKA EXPORTS LIMITED",
"RADHIKA EXPRESS PRIVATE LIMITED",
"RADHIKA GARMENTS & SAREES PRIVATE LIMITED",
"RADHIKA GASES PRIVATE LIMITED",
"RADHIKA GEMS PRIVATE LIMITED",
"RADHIKA HEIGHTS LIMITED",
"RADHIKA INTERNATIONAL PRIVATE LIMITED",
"RADHIKA JEWELLERS PRIVATE LIMITED",
"RADHIKA JEWELSCRAFT PRIVATE LIMITED",
"RADHIKA JEWELTECH LIMITED",
"RADHIKA MAHILA AGRO FARMERS PRODUCER COMPANY LIMITED",
"RADHIKA MILK AND MILK PRODUCTS PRIVATE LIMITED",
"RADHIKA MOVIEPLEX PRIVATE LIMITED",
"RADHIKA OPTO ELECTRONICS LIMITED",
"RADHIKA OPTO ELECTRONICS PRIVATE LIMITED",
"RADHIKA ORE METALCASTING PRIVATE LIMITED",
"RADHIKA ORGOCHEM (INDIA)PVT LTD",
"RADHIKA OVERSEAS",
"RADHIKA PETROCHEM PRIVATE LIMITED",
"RADHIKA PIPES PRIVATE LIMITED",
"RADHIKA POLYPACK PRIVATE LIMITED",
"RADHIKA PRINTS PVT LTD",
"RADHIKA PROFILES PRIVATE LIMITED",
"RADHIKA PROPCON PRIVATE LIMITED",
"RADHIKA RAMAN FOODS PRIVATE LIMITED",
"RADHIKA RAYON PRIVATE LIMITED",
"RADHIKA RETAILS PRIVATE LIMITED",
"RADHIKA ROADLINES",
"RADHIKA SOMANA DESIGNERS PRIVATE LIMITED",
"RADHIKA SWEETS AND MILK PRODUCTS PRIVATE LIMITED",
"RADHIKA SYNTEX PRIVATE LIMITED",
"RADHIKA TECHNOLOGIES PRIVATE LIMITED",
"RADHIKA TRANSMISSION PRIVATE LIMITED",
"RADHIKA VEGETABLE OILS PVT LTD",
"RADHIKAPUR (WEST) COAL MINING PRIVATE LIMITED",
"RADHIKESH INTERNATIONAL PRIVATE LIMITED",
"RADHIM BIOTECH PRIVATE LIMITED",
"RADHINI TEMPLES PRIVATE LIMITED",
"RADHKA LEASING PVT LTD",
"RADHU DEVELOPERS PRIVATE LIMITED",
"RADHU PRODUCTS PRIVATE LIMITED",
"RADHYA DECOR PRIVATE LIMITED",
"RADIAANT CAPTIVE INDIA PRIVATE LIMITED",
"RADIAANT EXPOVISION PRIVATE LIMITED",
"RADIAANT UNIFY LIMITED",
"RADIAL DIAGNOSTICS PRIVATE LIMITED",
"RADIAL ELECTRIC PRIVATE LIMITED",
"RADIAL MERCANTILE PRIVATE LIMITED",
"RADIAL NATURAL AROMATICS PRIVATE LIMITED",
"RADIAL SOLAR SYSTEMS PRIVATE LIMITED",
"RADIALL INDIA PRIVATE LIMITED",
"RADIALS INTERNATIONAL MINING SERVICES PRIVATE LIMITED",
"RADIAN CHEMICAL PRODUCTS PRIVATE LIMITED",
"RADIAN TECHNOLOGIES PRIVATE LIMITED",
"RADIANCE ALLOY & ELECTRICALS PRIVATE LIMITED",
"RADIANCE AREO HOSPITALITY SERVICES PRIVATE LIMITED",
"RADIANCE BIO-SYNTHETICS PRIVATE LIMITED",
"RADIANCE CHEMSOL PRIVATE LIMITED",
"RADIANCE COSMETICS PRIVATE LIMITED",
"RADIANCE DIGI INFRA SOLUTIONS PRIVATE LIMITED",
"RADIANCE DIGISOFT INDIA PRIVATE LIMITED",
"RADIANCE FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"RADIANCE FLEX IMAGES PRIVATE LIMITED",
"RADIANCE GLOBAL TRADERS PRIVATE LIMITED",
"RADIANCE HOSPITAL PRIVATE LIMITED",
"RADIANCE INFRACON AND DEVELOPERS PRIVATE LIMITED",
"RADIANCE IT WORLD PRIVATE LIMITED",
"RADIANCE KA SUNRISE ONE PRIVATE LIMITED",
"RADIANCE KA SUNRISE TWO PRIVATE LIMITED",
"RADIANCE MARKETING",
"RADIANCE MH SOLAR POWER PRIVATE LIMITED",
"RADIANCE PAPERS PRIVATE LIMITED",
"RADIANCE PRINTPACK PRIVATE LIMITED",
"RADIANCE PROPMART PRIVATE LIMITED",
"RADIANCE PUBLIC RELATIONS PRIVATE LIMITED",
"RADIANCE REALTY DEVELOPERS INDIA LIMITED",
"RADIANCE RENEWABLES PRIVATE LIMITED",
"RADIANCE SOLAR PRIVATE LIMITED",
"RADIANCE SPACE SOLUTION PRIVATE LIMITED",
"RADIANCELPG PETROCHEM PRIVATE LIMITED",
"RADIANT - RSCC SPECIALTY CABLE PRIVATE LIMITED",
"RADIANT 3PL SOLUTIONS INDIA PRIVATE LIMITED",
"RADIANT ADVERTISING & MARKETING (I) PVT. LTD.",
"RADIANT AGROWOOD PRODUCTS PVT LTD",
"RADIANT AIR SYSTEMS PRIVATE LIMITED",
"RADIANT AIRWAYS INDIA PRIVATE LIMITED",
"RADIANT ANODISERS PRIVATE LIMITED",
"RADIANT APPARELS PRIVATE LIMITED",
"RADIANT APPLIANCES AND ELECTRONICS PRIVATE LIMITED",
"RADIANT BAR PRIVATE LIMITED",
"RADIANT BIOMED PRIVATE LIMITED",
"RADIANT BUSINESS SOLUTIONS PRIVATE LIMITED",
"RADIANT CABLE NETWORKS PRIVATE LIMITED",
"RADIANT CASH MANAGEMENT SERVICES LIMITED",
"RADIANT CASH MANAGEMENT SERVICES PRIVATE LIMITED",
"RADIANT CASTINGS PRIVATE LIMITED",
"RADIANT CEMENT CO PVT LTD",
"RADIANT CHEMTECH PRIVATE LIMITED",
"RADIANT CHEMZYMES PRIVATE LIMITED",
"RADIANT COAL BENEFICATION PRIVATE LIMITED",
"RADIANT COMPONENTS PRIVATE LIMITED",
"RADIANT COMPUTECH PRIVATE LIMITED",
"RADIANT CONSUMER APPLIANCES PRIVATE LIMITED",
"RADIANT CONTAINERS PRIVATE LIMITED",
"RADIANT CORPORATION PRIVATE LIMITED",
"RADIANT CROPSCIENCE PRIVATE LIMITED",
"RADIANT DIGITAL SOLUTIONS PRIVATE LIMITED",
"RADIANT DIGITEK NETWORK LIMITED",
"RADIANT E QUEST LIMITED",
"RADIANT ELASTOMERS PRIVATE LIMITED",
"RADIANT ELECTRIC AGENCY PRIVATE LIMITED",
"RADIANT ENERGY SOLUTIONS PRIVATE LIMITED",
"RADIANT ENGLISH ACADEMY",
"RADIANT ENTERPRISE PRIVATE LIMITED",
"RADIANT EQUITY MANAGEMENT PVT LTD",
"RADIANT EXPO GLOBAL PRIVATE LIMITED",
"RADIANT EXPORTS",
"RADIANT FASHIONS PRIVATE LIMITED",
"RADIANT FIBERTECH PRIVATE LIMITED",
"RADIANT FIRE PROTECTION ENGINEERS PRIVATE LIMITED",
"RADIANT GLOBAL CHEMICALS",
"RADIANT GLOBUS HOTELS AND ENTERTAINMENT PRIVATE LIMITED",
"RADIANT GUARD SERVICES PRIVATE LIMITED",
"RADIANT HAROTI INDUSTRIES INDIA LIMITED",
"RADIANT HEALTHCARE PRIVATE LIMITED",
"RADIANT HEAT EXCHANGER PRIVATE LIMITED",
"RADIANT HEATING SYSTEMS PRIVATE LIMITED",
"RADIANT HITECH ENG. PRIVATE LIMITED",
"RADIANT HOSPITAL SERVICES PRIVATE LIMITED",
"RADIANT HVAC PRIVATE LIMITED",
"RADIANT IMAGING CENTRE PRIVATE LIMITED",
"RADIANT INDUS CHEM PRIVATE LIMITED",
"RADIANT INFO SOLUTIONS PRIVATE LIMITED",
"RADIANT INFO SYSTEMS PRIVATE LIMITED",
"RADIANT INFONET PRIVATE.LIMITED",
"RADIANT INSTITUTE OF FINANCE & TECHNOLOGY PRIVATE LIMITED",
"RADIANT INSURANCE BROKING PRIVATE LIMITED",
"RADIANT INTERNATIONAL SCHOOL",
"RADIANT KAILASH AGENCIES PRIVATE LIMITED",
"RADIANT LEATHERS PVT.LTD.",
"RADIANT LIFE CARE MUMBAI PRIVATE LIMITED",
"RADIANT LUBES PRIVATE LIMITED",
"RADIANT MANUFACTURERS PRIVATE LIMITED",
"RADIANT MARITIME INDIA PRIVATE LIMITED",
"RADIANT MEDICAL SERVICES PRIVATE LIMITED",
"RADIANT METALS AND ALLOYS PRIVATE LIMITED",
"RADIANT MINING TECHNOLOGIES LIMITED",
"RADIANT MOULDS AND COMPOUNDS PVT LTD",
"RADIANT MRI CENTRE PRIVATE LIMITED",
"RADIANT NEST PRIVATE LIMITED",
"RADIANT NIRMAN PRIVATE LIMITED",
"RADIANT ORGANICS PRIVATE LIMITED",
"RADIANT PARENTERALS LIMITED",
"RADIANT PETROLEUM PRODUCTS PRIVATE LIMITED",
"RADIANT PLACEMENT SERVICES PRIVATE LIMITED",
"RADIANT PLASTRUDERS I PRIVATE LIMITED",
"RADIANT POLYCHEM PRIVATE LIMITED",
"RADIANT POLYMERS PRIVATE LIMITED",
"RADIANT PRECICOM INDUSTRIES PRIVATE LIMITED",
"RADIANT PROFILES AND STEEL PRIVATE LIMITED",
"RADIANT PROTECTION FORCE PRIVATE LIMITED",
"RADIANT REAL PROPERTIES INDIA PRIVATE LIMITED",
"RADIANT RESEARCH SERVICES PRIVATE LIMITED",
"RADIANT ROCKS PRIVATE LIMITED",
"RADIANT SAFEDOORS PRIVATE LIMITED",
"RADIANT SATELLITE INDIA PRIVATE LIMITED",
"RADIANT SECURITY",
"RADIANT SOFT SOLUTIONS PRIVATE LIMITED",
"RADIANT SOLAR ENERGIES PRIVATE LIMITED",
"RADIANT SOLAR PRIVATE LIMITED",
"RADIANT STAR HOSPITALITIES PRIVATE LIMITED",
"RADIANT STRUCTURES PRIVATE LIMITED",
"RADIANT SUPERSPECIALITY HOSPITAL",
"RADIANT SYNAGE PRIVATE LIMITED",
"RADIANT SYSTEMS INDIA PRIVATE LIMITED",
"RADIANT TECHNO BUILDERS PRIVATE LIMITED",
"RADIANT TECHNOCAST PRIVATE LIMITED",
"RADIANT TEXFAB PRIVATE LIMITED",
"RADIANT TEXTILES LIMITED",
"RADIANT TEXTILES PRIVATE LIMITED",
"RADIANT TRAFIN PRIVATE LIMITED",
"RADIANT TRAVELS (I) PRIVATE LIMITED",
"RADIANT UROLOGY HOSPITAL",
"RADIANT WEB TECHNOLOGY PRIVATE LIMITED",
"RADIANT WOVENPLAST PRIVATE LIMITED",
"RADIANT X-WAYS LOGISTIC PRIVATE LIMITED",
"RADIANTS CIVILETRIC PRIVATE LIMITED",
"RADIARE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"RADIATE DIGITAL SERVICES PRIVATE LIMITED",
"RADIATE E-SERVICES PRIVATE LIMITED",
"RADIATE TRADEMART PRIVATE LIMITED",
"RADIAUNT CLINICAL CARE SOLUTION PRIVATE LIMITED",
"RADICAB CABLES AND LIGHTING INDUSTRIES PRIVATE LIMITED",
"RADICAL ADVISORS INDIA PRIVATE LIMITED",
"RADICAL BIO-ORGANICS LIMITED",
"RADICAL CIRCUS DIGITAL STUDIO PRIVATE LIMITED",
"RADICAL CROP SCIENCE PRIVATE LIMITED",
"RADICAL EDUTECH PRIVATE LIMITED",
"RADICAL FREIGHT SERVICES PRIVATE LIMITED",
"RADICAL MANAGEMENT SERVICES PRIVATE LIMITED",
"RADICAL MINDS TECHNOLOGIES PRIVATE LIMITED",
"RADICAL PLASTPACK PRIVATE LIMITED",
"RADICAL SCIENTIFIC EQUIPMENTS PRIVATE LIMITED",
"RADICAL SOLAR PRIVATE LIMITED",
"RADICAL TECHART SOLUTION PRIVATE LIMITED",
"RADICAL TECHNO PRODUCTS PRIVATE LIMITED",
"RADICAL WORKS PRIVATE LIMITED",
"RADICI PLASTICS INDIA PRIVATE LIMITED",
"RADICLE SOFTWARE PRIVATE LIMITED",
"RADICO KHAITAN FINANCE LIMITED",
"RADICO KHAITAN LIMITED",
"RADICO NV DISTILLERIES MAHARASHTRA LIMITED",
"RADICON INDUSTRIES PRIVATE LIMITED",
"RADICON INFRASTRUCTURE & HOUSING PRIVATE LIMITED",
"RADICON LABORATORIES LIMITED.",
"RADICOOL PHARMACEUTICAL PRIVATE LIMITED",
"RADICURA INFRA LIMITED",
"RADICURA PHARMACEUTICALS PRIVATE LIMITED",
"RADIEANT IMPEX PRIVATE LIMITED",
"RADII REWARDS PRIVATE LIMITED",
"RADIK CHEMICALS PRIVATE LIMITED",
"RADIKON ENTERPRISES PRIVATE LIMITED",
"RADIMAGE TECHNOLOGIES PRIVATE LIMITED.",
"RADIN ITALIA FURNITURES PRIVATE LIMITED",
"RADINET INFO SOLUTIONS PRIVATE LIMITED",
"RADINTON TRADEX PRIVATE LIMITED",
"RADIO DESIGN INDIA PRIVATE LIMITED",
"RADIO ELECTRIC PRIVATE LIMITED",
"RADIO PATH DIAGNOSTIC CENTRE PRIVATE LIMITED",
"RADIO TODAY BROADCASTING LIMITED",
"RADIOHEAD BRANDS PRIVATE LIMITED",
"RADIOLOGICAL PRECISION LABS INDIA PRIVATE LIMITED",
"RADION EQUIPMENTS PRIVATE LIMITED",
"RADIOSHACK TECHNOLOGIES PRIVATE LIMITED",
"RADIOWALLA NETWORK LIMITED",
"RADIOWALLA NETWORK PRIVATE LIMITED",
"RADIQ IMAGE INFORMATION SYSTEMS PRIVATE LIMITED",
"RADISCAN IMAGING PRIVATE LIMITED",
"RADISCAN IMAGING SHAHIBAUG PRIVATE LIMITED",
"RADISCAN PATHOLOGY PRIVATE LIMITED",
"RADISE INDIA PRIVATE LIMITED",
"RADISON ESTATES PRIVATE LIMITED",
"RADISON LABS PRIVATE LIMITED",
"RADISSON BLU COIMBATORE",
"RADISSON BLU GORAKHPUR",
"RADISSON BLU HOTEL AHMEDABAD",
"RADISSON BLU HOTEL CHENNAI CITY CENTRE",
"RADISSON BLU HOTEL INDORE",
"RADISSON BLU PLAZA HOTEL HYDERABAD BANJARAHILLS",
"RADISSON BLU RESORT & SPA KARJAT",
"RADISSON BLU RESORT GOA CAVELOSSIM BEACH",
"RADISSON GOA CONDOLIM",
"RADISSON HOTEL",
"RADISSON HYERABAD HITEC CITY",
"RADISSON JAIPUR CITY CENTER",
"RADISSON MUMBAI ANDHERI MIDC",
"RADISYS INDIA LIMITED",
"RADISYS INDIA PRIVATE LIMITED",
"RADITRON MECHATRON PRIVATE LIMITED",
"RADIUM CREATION LIMITED",
"RADIUM CREATION PRIVATE LIMITED",
"RADIUM ELEMENTS PRIVATE LIMITED",
"RADIUM INDIA",
"RADIUM MANAGEMENT SERVICES PRIVATE LIMITED",
"RADIUM MERCHANDISE PRIVATE LIMITED",
"RADIUM OUTSOURCING INDIA PRIVATE LIMITED",
"RADIUS CORPORATE SOLUTIONSINDIA PRIVATE LIMITED",
"RADIUS DEVELOPERS RAGHULEELA BUILDERS PRIVATE LIMITED",
"RADIUS ENGINEERING SOLUTIONS PRIVATE LIMITED",
"RADIUS EQUIPMENT PRIVATE LIMITED",
"RADIUS ESTATE PROJECTS PRIVATE LIMITED",
"RADIUS GLOBAL SOLUTIONS INDIA BPO PRIVATE LIMITED",
"RADIUS HEALTHCARE PRIVATE LIMITED",
"RADIUS INFOTECH PRIVATE LIMITED",
"RADIUS LOGISTICS PRIVATE LIMITED",
"RADIUS SYNERGIES INTERNATIONAL PRIVATE LIMITED",
"RADIUS SYSTEMS PRIVATE LIMITED",
"RADIUS VALUE CHAIN PRIVATE LIMITED",
"RADIUS WATER LIMITED",
"RADIVI ELECTRICALS PRIVATE LIMITED",
"RADIX ANALYTICS PRIVATE LIMITED",
"RADIX ARC PRIVATE LIMITED",
"RADIX CHEMICALS PRIVATE LIMITED",
"RADIX DIES AND MOULDS PRIVATE LIMITED",
"RADIX ELECTROSYSTEMS PRIVATE LIMITED",
"RADIX ENGINEERING PRIVATE LIMITED",
"RADIX EXIM PRIVATE LIMITED",
"RADIX HR SOLUTIONS PRIVATE LIMITED",
"RADIX INDUSTRIES INDIA LIMITED",
"RADIX INFO SOLUTIONS PRIVATE LIMITED",
"RADIX INFRA PROJECTS PRIVATE LIMITED",
"RADIX INFRACON PRIVATE LIMITED",
"RADIX INNOVATIONS PRIVATE LIMITED",
"RADIX LEARNING PRIVATE LIMITED",
"RADIX PROJECTS PRIVATE LIMITED",
"RADIX SENSORS PRIVATE LIMITED",
"RADIX SOFTWARE SERVICES PRIVATE LIMITED",
"RADIX WEB SERVICES PRIVATE LIMITED",
"RADIX WEB SOLUTIONS PRIVATE LIMITED",
"RADIXWEB TECHNOSOFT LLP",
"RADLAY METAL PRODUCTS PRIVATE LIMITED",
"RADMAX COMMUNICATION PRIVATE LIMITED",
"RADMED HEALTHCARE PRIVATE LIMITED",
"RADNIK AUTO EXPORTS",
"RADNIK KNITS PVT LTD",
"RADO INDUSTRIES LIMITED",
"RADO INFRASTRUCTURALS LIMITED",
"RADO POLYTEX PRIVATE LIMITED",
"RADO SHIPPING AGENCIES PRIVATE LIMITED",
"RADOCS ASSOCIATES IMAGING PRIVATE LIMITED",
"RADOLABS PRIVATE LIMITED",
"RADON AGRO PRIVATE LIMITED",
"RADON INDIA PRIVATE LIMITED",
"RADON MEDIA PRIVATE LIMITED",
"RADON ONCOLOGY PRIVATE LIMITED",
"RADOSS LABCARE PRIVATE LIMITED",
"RADOX ENGINEERING PRIVATE LIMITED",
"RADRAM QUALITY SERVICES PRIVATE LIMITED",
"RADSCAN SYSTEMS PRIVATE LIMITED",
"RADSOL DESIGN PRIVATE LIMITED",
"RADTECH SYSTEMS PRIVATE LIMITED",
"RADUS INFOTEK SYSTEMS PRIVATE LIMITED",
"RADVIN MEDIA PRIVATE LIMITED",
"RADVISION ENGINEERING PRIVATE LIMITED",
"RADWARE INDIA PRIVATE LIMITED",
"RADWIN WIRELESS SOLUTIONS INDIA PRIVATE LIMITED",
"RADYNE INFOTECH PRIVATE LIMITED",
"RAE BARELI FLOUR MILLS PRIVATE LIMITED",
"RAE BARELI INFRASTRUCTURE PRIVATE LIMITED",
"RAE REAL ESTATE PRIVATE LIMITED",
"RAEBAREILLY ALLAHABAD HIGHWAY PRIVATE LIMITED",
"RAEKS ESTATES DEVELOPERS PRIVATE LIMITED",
"RAENCO MILLS PRIVATE LIMITED",
"RAF STATIONERS PRIVATE LIMITED",
"RAFAEL ADVANCED DEFENSE SYSTEMS LIMITED",
"RAFAGA INFOKNOWLEDGE PRIVATE LIMITED",
"RAFAI TECHNOLOGIES PRIVATE LIMITED",
"RAFAJA BUILDERS PRIVATE LIMITED",
"RAFAT LOGISTICS PRIVATE LIMITED",
"RAFATECH ENGINEERING PRIVATE LIMITED",
"RAFAY SYSTEMS PRIVATE LIMITED",
"RAFBRIX PRIVATE LIMITED",
"RAFFELS HOSPITALS PRIVATE LIMITED",
"RAFFLES DESIGN INTERNATIONAL (INDIA) PRIVATE LIMITED",
"RAFFLES RESIDENCY PRIVATE. LIMITED.",
"RAFFLES SQUARE DEVELOPMENT PRIVATE LIMITED",
"RAFFLESIA TRADING PRIVATE LIMITED",
"RAFIA POLYMERS PRIVATE LIMITED",
"RAFIQ CONSTRUCTIONS PRIVATE LIMITED",
"RAFIQ NAIK EXPORTS PRIVATE LIMITED",
"RAFIQ ZAKARIA COLLEGE OF WOMEN",
"RAFT CONSULTING SERVICES PRIVATE LIMITED",
"RAFT MEDIA SYSTEMS PRIVATE LIMITED",
"RAFT MOTORS PRIVATE LIMITED",
"RAFTAAR LOGISTICS INDIA PRIVATE LIMITED",
"RAFTAAR TERMINALS PRIVATE LIMITED",
"RAFTAR DS AUTOMOBILE PRIVATE LIMITED",
"RAFTAR EXPRESS INDIA PRIVATE LIMITED",
"RAG AMRIT CONSTRUCTION PRIVATE LIMITED",
"RAG HOSPITAL",
"RAG INTERNATIONAL PRIVATE LIMITED",
"RAG SHIPPING PRIVATE LIMITED",
"RAG TRADE (INDIA) PRIVATE LIMITED",
"RAGA DIAMOND JEWELS PRIVATE LIMITED",
"RAGA GLOBAL PAYMENTS PRIVATE LIMITED",
"RAGA MOTORS PRIVATE LIMITED",
"RAGA PLAST PRIVATE LIMITED",
"RAGA SVARA",
"RAGA TEX INDIA PRIVATE LIMITED",
"RAGA TRADECON PRIVATE LIMITED.",
"RAGAM METAL PRODUCTS PRIVATE LIMITED",
"RAGAM POLYMOULDS PRIVATE LIMITED",
"RAGAS DENTAL COLLEGE",
"RAGASWAROOPA TECHNOLOGIES PRIVATE LIMITED",
"RAGAVS DIAGNOSTIC & RESEARCH CENTRE PRIVATE. LIMITED.",
"RAGAWOOD VENEERS PRIVATE LIMITED",
"RAGE COMMUNICATIONS PRIVATE LIMITED",
"RAGE FRAMEWORKS INDIA PRIVATE LIMITED",
"RAGGEDY EASEL PRIVATE LIMITED",
"RAGHANI TRADELINK PRIVATE LIMITED",
"RAGHANI TRADELINK TEX SERVICES",
"RAGHAV AEROSPACE MANUFACTURING TECHNOLOGIES PRIVATE LIMITED",
"RAGHAV AGRICULTURAL INDUSTRIES PRIVATE LIMITED",
"RAGHAV BOOKS PRIVATE LIMITED",
"RAGHAV BUILDWELL LIMITED",
"RAGHAV CABLES PRIVATE LIMITED",
"RAGHAV COLD STORAGE PRIVATE LIMITED",
"RAGHAV COMMERCIAL LTD",
"RAGHAV COTEX PVT LTD",
"RAGHAV COTSPIN PRIVATE LIMITED",
"RAGHAV EDUCATION FOUNDATION",
"RAGHAV FARMS AND RESORTS PRIVATE LIMITED",
"RAGHAV FASHIONS PRIVATE LIMITED",
"RAGHAV FORGE PRIVATE LIMITED",
"RAGHAV GRIHA NIRMAN PRIVATE LIMITED",
"RAGHAV HERBAL MARKETING PRIVATE LIMITED",
"RAGHAV HOME FASHIONS PRIVATE LIMITED",
"RAGHAV INDUSTRIES LIMITED",
"RAGHAV INFRADEVELOPERS AND BUILDERS PRIVATE LIMITED",
"RAGHAV INTERNATIONAL PRIVATE LIMITED",
"RAGHAV INVESTMENT PRIVATE LIMITED",
"RAGHAV ISPAT PRIVATE LIMITED",
"RAGHAV METALS PRIVATE LIMITED",
"RAGHAV POLYCHEM PRIVATE LIMITED",
"RAGHAV PRODUCTIVITY ENHANCERS LIMITED",
"RAGHAV RAMMING MASS PRIVATE LIMITED",
"RAGHAV SANITARY WARES PRIVATE LIMITED",
"RAGHAV SULZCON PRIVATE LIMITED",
"RAGHAV SURFACTANTS PRIVATE LIMITED",
"RAGHAV TEX FAB PRIVATE LIMITED",
"RAGHAV TRADELINK PRIVATE LIMITED",
"RAGHAV TRADERS",
"RAGHAV TRADING COMPANY",
"RAGHAV VANIJYA PRIVATE LIMITED",
"RAGHAV WEAVES PRIVATE LIMITED",
"RAGHAV WOOLLEN MILLS",
"RAGHAV WOOLLEN MILLS PVT LIMITED",
"RAGHAVA AGRO FARMS PRIVATE LIMITED",
"RAGHAVA BIO-MEDICALS PRIVATE LIMITED",
"RAGHAVA COIRS PRIVATE LIMITED",
"RAGHAVA CONSTRUCTIONS",
"RAGHAVA CONSTRUCTIONS INDIA PRIVATE LIMITED",
"RAGHAVA FOUNDATIONS PRIVATE LIMITED",
"RAGHAVA LIFE SCIENCES PRIVATE LIMITED",
"RAGHAVA PROJECT CONSTRUCTIONS PRIVATE LIMITED",
"RAGHAVA RAJU SECURITY SERVICES PRIVATE LIMITED",
"RAGHAVA WAREHOUSING AND LOGISTIC SERVICES PRIVATE LIMITED",
"RAGHAVAM LOGISTICS PRIVATE LIMITED",
"RAGHAVENDAR TECH EXCELLENCE PRIVATE LIMITED",
"RAGHAVENDRA AUTOMATION PRIVATE LIMITED",
"RAGHAVENDRA FERTILIZERS PRIVATE LIMITED",
"RAGHAVENDRA HI-TECH PRE UNIVERSITY COLLEGE",
"RAGHAVENDRA HITECH PU COLLEGE DAVANAGERE",
"RAGHAVENDRA MOTORS PRIVATE LIMITED",
"RAGHAVENDRA PRESTRESS PRODUCTS PRIVATE LIMITED",
"RAGHAVENDRA RAIL INFRASTRUCTURE PRIVATE LIMITED",
"RAGHAVENDRA RAIL LINES PRIVATE LIMITED",
"RAGHAVESH IT INFRASTRUCTURE AND SERVICES PRIVATE LIMITED",
"RAGHAVI HOSPITAL",
"RAGHAVRAJ WATER TREATMENT PRIVATE LIMITED",
"RAGHAW CREATIONS PRIVATE LIMITED",
"RAGHAW FASHIONS PRIVATE LIMITED",
"RAGHBEER MACHINERY PVT LTD",
"RAGHBIR INTERIORS PVT LTD",
"RAGHIB CONSTRUCTION PRIVATE LIMITED",
"RAGHNALL INSURANCE BROKING AND RISK MANAGEMENT PRIVATE LIMITED",
"RAGHU CREATIONS PRIVATE LIMITED",
"RAGHU ENGINEERING COLLEGE",
"RAGHU EXPORTS INDIA PRIVATE LIMITED",
"RAGHU INSTITUTE OF TECHNOLOGY",
"RAGHU LEELA COLONIZERS PRIVATE LIMITED",
"RAGHU MAHAL HOTELS PRIVATE LIMITED",
"RAGHU PROMOTORS PRIVATE LIMITED",
"RAGHU RAMA RICE INDUSTRY",
"RAGHU VAMSI MACHINE TOOLS PRIVATE LIMITED",
"RAGHUBANSH METAL CRAFT PRIVATE LIMITED",
"RAGHUBIR RETAILERS PRIVATE LIMITED",
"RAGHUBIR SINGH JUNIOR MODERN SCHOOL",
"RAGHUDEEP EYE CLINIC LLP",
"RAGHUDEVBATI SADHARANER VIDYALAYA",
"RAGHUKAUSHAL TEXTILE PRIVATE LIMITED",
"RAGHUKUL CONSTRUCTIONS PRIVATE LIMITED",
"RAGHULEELA BUILDERS PRIVATE. LIMITED.",
"RAGHULEELA ESTATES PRIVATE LIMITED",
"RAGHULEELA INFRA ENERGY PRIVATE LIMITED",
"RAGHULEELA INNOVATIVE TECHNOLOGY ( R & D ) CENTER PRIVATE LIMITED",
"RAGHULILA AGRO PRODUCTS PRIVATE LIMITED",
"RAGHUNANDAN CAPITAL (IFSC) PRIVATE LIMITED",
"RAGHUNANDAN CAPITAL PRIVATE LIMITED",
"RAGHUNANDAN DYEING AND PRINTING MILLS PRIVATE LIMITED",
"RAGHUNANDAN INDUSTRIES PRIVATE LIMITED",
"RAGHUNANDAN INFRATECH PRIVATE LIMITED",
"RAGHUNANDAN INTER COLLEGE CHHARA",
"RAGHUNANDAN JEWELLERS DELHI PRIVATE LIMITED",
"RAGHUNANDAN JEWELLERS PRIVATE LIMITED",
"RAGHUNANDAN PRASAD SARRAF PRIVATE LIMITED",
"RAGHUNANDAN SECURITY SERVICES PRIVATE LIMITED",
"RAGHUNANDAN SYNTHETICS PRIVATE LIMITED",
"RAGHUNATH (AGENCIES) PRIVATE LIMITED",
"RAGHUNATH AGRO INDUSTRIES",
"RAGHUNATH AGRO TECH PRIVATE LIMITED",
"RAGHUNATH BANERJEE HIMGHAR PRIVATE LIMITED",
"RAGHUNATH BUILDERS PRIVATE LIMITED",
"RAGHUNATH DYECHEM PRIVATE LIMITED",
"RAGHUNATH EDIBLE PRIVATE LIMITED",
"RAGHUNATH EQUIPMENTS PRIVATE LIMITED",
"RAGHUNATH EXPORTS PRIVATE LIMITED",
"RAGHUNATH FERTILISERS PVT LTD",
"RAGHUNATH FOODS PRIVATE LIMITED",
"RAGHUNATH HINDI HIGHER SECONDARY",
"RAGHUNATH HOLDINGS AND FINLEASE PRIVATE LIMITED",
"RAGHUNATH INTERNATIONAL LIMITED.",
"RAGHUNATH PANDA & SONS PRIVATE LIMITED",
"RAGHUNATH PROJECTS PRIVATE LIMITED",
"RAGHUNATH SAHAI SHRI RAM SARRAF PRIVATE LIMITED",
"RAGHUNATH VINIMAY PRIVATE LIMITED",
"RAGHUPATEE ESTATE & HOLDING PRIVATE LIMITED",
"RAGHUPATHY SPINNERS PRIVATE LIMITED",
"RAGHUPATI COLD STORAGE PRIVATE LIMITED",
"RAGHUPATI POLYCOTS(INDIA) PRIVATE LIMITED",
"RAGHUPATI SYNERGY PRIVATE. LIMITED.",
"RAGHUPATI WIRES INDIA PRIVATE LIMITED",
"RAGHUPREET HYDRO PROJECTS PRIVATE LIMITED",
"RAGHURAJ EXPORTS PRIVATE LIMITED",
"RAGHURAJ INDUSTRIES PRIVATE LIMITED",
"RAGHURAJ TEXTILES PRIVATE LIMITED",
"RAGHURAM HUME PIPES PRIVATE. LIMITED.",
"RAGHURAM INFRASTRUCTURE INDIA PRIVATE LIMITED",
"RAGHURAM PALACES AND RESORTS PRIVATE LIMITED",
"RAGHURAM PRADEEP CONSTRUCTIONS INDIA LLP",
"RAGHURAM SYNTHETICS PRIVATE LIMITED",
"RAGHUSHA AGROTECH PRIVATE LIMITED",
"RAGHUSONS INFRA ENGINEERING PRIVATE LIMITED",
"RAGHUVAMSA HOLDINGS PRIVATE LIMITED",
"RAGHUVANSH AGROFARMS LIMITED",
"RAGHUVANSH AGROTECH FARMER PRODUCER COMPANY LIMITED",
"RAGHUVANSH PACKAGING PVT LTD",
"RAGHUVANSHI MOTORS PRIVATE LIMITED",
"RAGHUVANSHI PHARMA PRIVATE LIMITED",
"RAGHUVANSHI REALTORS PRIVATE LIMITED",
"RAGHUVAR INDIA LIMITED",
"RAGHUVEER ISPAT PRIVATE LIMITED",
"RAGHUVEER METAL INDUSTRIES LIMITED TFR. FROM RAJASTHAN TO DELHI",
"RAGHUVESH AGRI FOODS PRIVATE LIMITED",
"RAGHUVESH INFRASTRUCTURE PRIVATE LIMITED",
"RAGHUVESH WAREHOUSING PRIVATE LIMITED",
"RAGHUVIR BDNS METALCAST PRIVATE LIMITED",
"RAGHUVIR BUILDCON PRIVATE LIMITED",
"RAGHUVIR COMMERCIAL PVT LTD",
"RAGHUVIR COTTON GINNING AND PRESSING PRIVATE LIMITED",
"RAGHUVIR DEVELOPERS AND BUILDERS",
"RAGHUVIR DIAMOND",
"RAGHUVIR EXIM LIMITED",
"RAGHUVIR LIFESTYLE PRIVATE LIMITED",
"RAGHUVIR STAINLESS STEEL PRIVATE LIMITED",
"RAGHUVIR SYNTHETICS LIMITED",
"RAGHUVIR VIDHYAMANDIR",
"RAGHVANI TEXTILES PRIVATE LIMITED",
"RAGHVENDRA CABLES AND WIRES PRIVATE LIMITED",
"RAGHVENDRA COLLEGE",
"RAGHVENDRA CONSTRUCTION COMPANY PRIVATE LIMITED",
"RAGHVENDRA SUPPLIERS PRIVATE LIMITED",
"RAGHVIR AGRO ENTERPRISES PVT LTD",
"RAGI IMPEX PRIVATE LIMITED",
"RAGI MERCANTILE PRIVATE LIMITED",
"RAGING RIVER MINES & MINERALS PRIVATE LIMITED",
"RAGINI FINANCE PRIVATE LIMITED",
"RAGLO PRIVATE LIMITED",
"RAGNIK EXPORTS PRIVATE LIMITED",
"RAGNOR BUILDTECH INDIA PRIVATE LIMITED",
"RAGONE FAMILY TRUST",
"RAGOVA DEVELOPERS & AUTO SERVICES PRIVATE LIMITED",
"RAGSYS COFFEE AND SPICES PRIVATE LIMITED",
"RAGU PROPBUILD PRIVATE LIMITED",
"RAGVENDRA GRANIMARMO PRIVATE LIMITED",
"RAH INFOTECH P LIMITED",
"RAH LEGAL KNOWLEDGE PROCESS PRIVATE LIMITED",
"RAH POLYMERS PRIVATE LIMITED",
"RAHA COOLING PRIVATE LIMITED",
"RAHA HOSPITALITY PRIVATE LIMITED",
"RAHAMAN TELECOM AND GIFT HOUSE",
"RAHAMATH CITY DEVELOPERS PRIVATE LIMITED",
"RAHAT CONTINENTAL PRIVATE LIMITED",
"RAHEBAR FARMS PRIVATE LIMITED",
"RAHEE INFRATECH LIMITED",
"RAHEE TRACK TECHNOLOGIES PRIVATE LIMITED",
"RAHEEM INDUSTRIES",
"RAHEJA BUILDERS",
"RAHEJA CHEMICALS PRIVATE LIMITED",
"RAHEJA CITY CENTER PALAMPUR PRIVATE LIMITED",
"RAHEJA DESIGN AND CONTRACT LIMITED",
"RAHEJA HOSPITALITY PRIVATE LIMITED",
"RAHEJA HYDEL POWER PRIVATE LIMITED",
"RAHEJA ODYSSEY CHS LTD",
"RAHEJA QBE GENERAL INSURANCE COMPANY LIMITED",
"RAHEJA STOCK BROKERS PRIVATE LIMITED",
"RAHEJA TEXFAB PRIVATE LIMITED",
"RAHEJA UNIVERSAL PRIVATE LIMITED",
"RAHEMANIYA URDU HIGH SCHOOL NILANGA",
"RAHI CARE DAKSA PRIVATE LIMITED",
"RAHI CARE PRIVATE LIMITED",
"RAHI ELECTRICALS PRIVATE LIMITED",
"RAHI ENGENIUS SOLUTIONS LLP",
"RAHI MEDICAL CENTER PRIVATE LIMITED",
"RAHI SYSTEMS PRIVATE LIMITED",
"RAHIJEET BUILDERS & DEVELOPERS PRIVATE LIMITED",
"RAHIL (CPP) FILMS PRIVATE LIMITED",
"RAHIL FOAM PRIVATE LIMITED",
"RAHIL PACK PRIVATE LIMITED",
"RAHIM MOTORS PRIVATE LIMITED",
"RAHIMA DEVELOPERS PRIVATE LIMITED",
"RAHIMAFROOZ BATTERIES LIMITED",
"RAHIMIA LANDS & TEA CO PVT LTD",
"RAHIMPUR TEA CO. LTD.",
"RAHIS COLD STORAGE PRIVATE LIMITED",
"RAHIS PAL CONSTRUCTIONS PRIVATE LIMITED",
"RAHMAN HOSPITALS PRIVATE LIMITED",
"RAHMAN INDUSTRIES LIMITED",
"RAHMAN INNOVATION PRIVATE LIMITED",
"RAHMAN PROPERTIES LTD",
"RAHMANIA HIGH MADRASAH",
"RAHMANIA MEDICAL CENTRE PRIVATE LIMITED",
"RAHMANIYA ENGLISH MEDIUM SCHOOL",
"RAHU HEALTH AND MEDICAL TOURISM PRIVATE LIMITED",
"RAHUL AGRI UDYOG PRIVATE LIMITED",
"RAHUL ALLOYS PRIVATE LIMITED",
"RAHUL AUTO AGENCY PRIVATE LIMITED",
"RAHUL AUTOMOTIVES LLP",
"RAHUL BIZMART PRIVATE LIMITED",
"RAHUL BROTHERS ELECTRICALS PRIVATE LIMITED",
"RAHUL CARBON COMMERCIALS PRIVATE LIMITED",
"RAHUL CARS INDIA PRIVATE LIMITED",
"RAHUL CHAINS PRIVATE LIMITED",
"RAHUL COAL (INDIA) PRIVATE LIMITED",
"RAHUL COMPUTEX PRIVATE LIMITED",
"RAHUL COTTEX PRIVATE LIMITED",
"RAHUL COTTON FACTORY PRIVATE. LIMITED.",
"RAHUL DIAMONDS PRIVATE LIMITED",
"RAHUL DISTRIBUTORS PRIVATE LIMITED",
"RAHUL EDUCATION",
"RAHUL ELECTRONIC PRIVATE LIMITED",
"RAHUL ENGINEERING WORKS",
"RAHUL EXIM SERVICES PRIVATE LIMITED",
"RAHUL FASHIONS PRIVATE LIMITED",
"RAHUL FASHIONTEX (INDIA) PRIVATE LIMITED",
"RAHUL FERROMET AND ENGINEERING PRIVATE LIMITED",
"RAHUL FERROMETAL LLP",
"RAHUL FINANCIAL SERVICES PVT LTD",
"RAHUL FLAT DEVELOPERS PRIVATE LIMITED",
"RAHUL GASES PRIVATE LIMITED",
"RAHUL GRIH NIRMAN PVT LTD",
"RAHUL INDUCTION PRIVATE LIMITED",
"RAHUL INDUSTRIAL ENTERPRISES PVT. LTD",
"RAHUL INTERNATIONAL PRIVATE LIMITED",
"RAHUL KAUSHIK DEVELOPERS PRIVATE LIMITED",
"RAHUL MAGNESIA PRIVATE LIMITED",
"RAHUL MISHRA DESIGNS PRIVATE LIMITED",
"RAHUL NATURAL STYLES PRIVATE LIMITED",
"RAHUL ORTHOTICS INSTRUMENTS PRIVATE LIMITED",
"RAHUL PAM PRIVATE LIMITED",
"RAHUL PAPERS INDIA PRIVATE LIMITED",
"RAHUL PETRONET PRIVATE LIMITED",
"RAHUL PHOTOGRAPHIC COMPANY PRIVATE LIMITED",
"RAHUL PRECISION WORKS PRIVATE LIMITED",
"RAHUL PREMIER INDIA AGENCY PRIVATE LIMITED",
"RAHUL RUBBER PRODUCTS PRIVATE LIMITED",
"RAHUL SALES LIMITED",
"RAHUL SALES PRIVATE LIMITED",
"RAHUL SECURITIES PVT LTD",
"RAHUL SILK MILLS PRIVATE LIMITED",
"RAHUL SPARES PRIVATE LIMITED",
"RAHUL SPRINGS PRIVATE LIMITED",
"RAHUL SYNTEX PRIVATE LIMITED",
"RAHUL TEXFAB PRIVATE LIMITED",
"RAHUL TEXO PRINT",
"RAHUL TRADEWING PRIVATE LIMITED",
"RAHUL TRADING COMPANY",
"RAHULTEX INDIA PRIVATE LIMITED",
"RAHURI KRUSHI FARMERS PRODUCER COMPANY LIMITED",
"RAHURI NAGAR PARISHAD RAHURI",
"RAHYALS SECURI VESTA INDIA PRIVATE LIMITED",
"RAI AND SONS PVT LTD",
"RAI BAHADUR NARAIN SINGH SUGAR MILLS LIMITED",
"RAI BAHADUR SETH SHREERAM NARASINGDAS PRIVATE LIMITED",
"RAI COKE INDUSTRIES PRIVATE LIMITED",
"RAI DEVELOPERS PRIVATE LIMITED",
"RAI ESTATES AND BUILDERS PRIVATE LIMITED",
"RAI FOUNDATION COLLEGES",
"RAI INDUSTRIAL POWER PRIVATE LIMITED",
"RAI INFRABUILD PRIVATE LIMITED",
"RAI INNOTECH POLYMERS PRIVATE LIMITED",
"RAI INVESTMENTS LIMITED",
"RAI METAL WORKS PRIVATE. LIMITED.",
"RAI MOHAN TEA & PLANTATIONS PVT LTD",
"RAI PREXIM INDIA PRIVATE LIMITED",
"RAI RADIOLOGY CENTRE PRIVATE LIMITED",
"RAI RAJ CONSTRUCTION PRIVATE LIMITED",
"RAI RESIDENCY PRIVATE LIMITED",
"RAI SAHEB REKHCHAND MOHOTA SPG. & WVG. MILLS LIMITED.",
"RAI UDYOG LIMITED",
"RAIBAGHINI HIGH SCHOOL",
"RAIBAREILLY FLOUR MILLS PRIVATE LIMITED",
"RAIBEX SECURITY SEALS PRIVATE LIMITED",
"RAIC INTEGRATED SPONGE & POWER PRIVATE LIMITED",
"RAICAM AUTOMOTIVE PRIVATE LIMITED",
"RAICHANDANI CONSTRUCTIONS PRIVATE LIMITED",
"RAICHEM MEDICARE PRIVATE LIMITED",
"RAICHUR BIO-ENERGIES PRIVATE LIMITED",
"RAICHUR CHEMICALS AND FERTILIZERS INDIA PRIVATE LIMITED",
"RAICHUR COLD STORAGE PRIVATE LIMITED",
"RAICHUR LABORATORIES PRIVATE LIMITED",
"RAICHUR LABORATORIES PRIVATE. LIMITED.",
"RAICHUR MEDICAL SERVICES PRIVATE LIMITED",
"RAICHUR POWER CORPORATION LIMITED",
"RAICHUR SHOLAPUR TRANSMISSION COMPANY PRIVATE LIMITED",
"RAICHUR SOLVENTS PRIVATE LIMITED",
"RAICHUR SOUHARDA PATTINA SAHAKARI NI",
"RAICON LABS PRIVATE LIMITED",
"RAIDA FASHIONS PRIVATE LIMITED",
"RAIDEEP INDUSTRIES LIMITED",
"RAIDER SECURITY SERVICES PRIVATE LIMITED",
"RAIDURGAM DEVELOPERS LIMITED",
"RAIEN FRESH PRODUCE PRIVATE LIMITED",
"RAIFFEISEN BANK INTERNATIONAL AG",
"RAIGAD CHEMICALS PRIVATEO LIMITED",
"RAIGAD DISTRICT CENTRAL CO OP BANK LIMITED",
"RAIGAD FOODS PRIVATE LIMITED",
"RAIGAD GAS (INDIA) PRIVATE LIMITED",
"RAIGAD JILHA PARISHAD",
"RAIGAD OXYGEN PRIVATE LIMITED",
"RAIGAD REALTERS & DEVELOPERS LIMITED",
"RAIGAD STEEL AND ROLL FORMS PRIVATE LIMITED",
"RAIGAD ZILLA PARISHAD PRATHMIK SCHOOL",
"RAIGANJ AGRO INDUSTRIES PRIVATE LIMITED",
"RAIGANJ AGRO TECH PRIVATE LIMITED",
"RAIGANJ JEEVAN REKHA DIAGNOSTIC PRIVATE LIMITED",
"RAIGANJ-DALKHOLA HIGHWAYS LIMITED",
"RAIGARH ELECTRO-MECH INDUSTRIES PVT LTD",
"RAIGARH ENERGY GENERATION LIMITED",
"RAIGARH FOODS & HOTEL BUSINESS PRIVATE LIMITED",
"RAIGARH INSTITUTE OF MEDICAL SCIENCE PRIVATE LIMITED",
"RAIGARH IRON INDUSTRIES LIMITED",
"RAIGARH MINERALS PRIVATE LIMITED",
"RAIGARH MINING AND BENEFICIATION PRIVATE LIMITED",
"RAIGARH PLASTICS PRIVATE LIMITED",
"RAIGARH SOLVENT EXTRACTION PRIVATE LIMITED",
"RAIGUNJ FLOUR MILLS PVT LTD",
"RAIKA ISPAT UDHYOG PRIVATE LIMITED",
"RAIKAR AND SONS JEWELLERS",
"RAIL ANCHOR INDIA PRIVATE LIMITED",
"RAIL COACH FACTORY",
"RAIL EUROPE INDIA PRIVATE LIMITED",
"RAIL INFRASTRUCTURE DEVELOPMENT COMPANY KARNATAKA LIMITED",
"RAIL VIKAS NIGAM LIMITED",
"RAILA ENTERPRISES PRIVATE LIMITED",
"RAILBIT ENGINEERS PRIVATE LIMITED",
"RAILFAB",
"RAILPATH INDIA PRIVATE LIMITED",
"RAILROAD LOGISTICS (INDIA) PRIVATE LIMITED",
"RAILSDATA SOFTWARE PRIVATE LIMITED",
"RAILTECH INFRAVENTURE PRIVATE LIMITED",
"RAILTECH TECHNOLOGIES PRIVATE LIMITED",
"RAILTEL CORPORATION OF INDIA LIMITED",
"RAILTRACK CONCRETE PRODUCTS PRIVATE LIMITED",
"RAILTRANZ CONSULTANCY PRIVATE LIMITED",
"RAILWAY BALABHAVAN MATRICULATION HIGHER SECONDARY SCHOOL",
"RAILWAY CHILDREN LAISON OFFICE",
"RAILWAY DEGREE COLLEGE",
"RAILWAY JAN MANDAL HIGH SCHOOL",
"RAILWAY SPORTS PROMOTION BOARD",
"RAIMA EQUITIES PRIVATE LIMITED",
"RAIMATANG TEA ESTATE PRIVATE LIMITED",
"RAIMEE PHARMA",
"RAIMOTI COLD STORAGE PRIVATE LIMITED",
"RAIN BOW FINANCE INDIA LTD",
"RAIN CEMENTS LIMITED",
"RAIN CII CARBON VIZAG LIMITED",
"RAIN ENTERPRISES PRIVATE LIMITED",
"RAIN ENTERTAINMENTS PRIVATE LIMITED",
"RAINA COMMODITIES PVT.LTD.",
"RAINA ENGINEERS",
"RAINA HOMEWARES PRIVATE LIMITED",
"RAINA INDUSTRIES PRIVATE LIMITED",
"RAINA METALTECH PRIVATE LIMITED",
"RAINBIRD HEALTHCARE BUSINESS SERVICES PRIVATE LIMITED",
"RAINBOW AGRI COMMODITIES PRIVATE LIMITED",
"RAINBOW AGRI INDUSTRIES LIMITED",
"RAINBOW AGROSCIENCES PRIVATE LIMITED",
"RAINBOW AVIATION PRIVATE LIMITED",
"RAINBOW CAPITAL PVT LTD",
"RAINBOW CHILDREN'S MEDICARE LIMITED",
"RAINBOW COMMODITY & DERIVATIVES PRIVATE LIMITED",
"RAINBOW COMPONENTS LIMITED",
"RAINBOW CONTAINERS BANGALORE PRIVATE LIMITED",
"RAINBOW CONTAINERS PRIVATE LIMITED",
"RAINBOW CROP HEALTH LIMITED",
"RAINBOW DECO PLAS PRIVATE LIMITED",
"RAINBOW DIAMONDS PRIVATE LIMITED",
"RAINBOW DIGITAL SERVICES PVT LTD",
"RAINBOW DYEING AND PRINTING MILLS PRIVATE LIMITED",
"RAINBOW EDUTAINMENT SOLUTIONS PRIVATE LIMITED",
"RAINBOW ENVIRONMENTS PRIVATE LIMITED",
"RAINBOW FABART PRIVATE LIMITED",
"RAINBOW FOOD PRODUCTS PRIVATE LIMITED",
"RAINBOW FOUNDATIONS LIMITED",
"RAINBOW GARNISHERS PRIVATE LIMITED",
"RAINBOW GRAINS PRIVATE LIMITED",
"RAINBOW HIGH TECH AGRI SOLUTIONS PRIVATE LIMITED",
"RAINBOW HOLIDAY-INN PVT.LTD.",
"RAINBOW HOME FAB PRIVATE LIMITED",
"RAINBOW HOSPITALITY AND TRAVELS PRIVATE LIMITED",
"RAINBOW INFOTECH (INDIA) PRIVATE LIMITED",
"RAINBOW INFRA HOUSING PRIVATE LIMITED",
"RAINBOW INFRACON PRIVATE LIMITED",
"RAINBOW INFRASTRUCTURE PVT LTD",
"RAINBOW INK & VARNISH",
"RAINBOW INTEGRATED MULTITECH PRIVATE LIMITED",
"RAINBOW INTERNATIONAL SCHOOL",
"RAINBOW INVESTMENTS LIMITED",
"RAINBOW LANDSCAPE INNOVATIONS INDIA PRIVATE LIMITED",
"RAINBOW LIFE SCIENCES PRIVATE LIMITED",
"RAINBOW MECHANICAL ENGINEERING PRIVATE LIMITED",
"RAINBOW PACKAGING PRIVATE LIMITED",
"RAINBOW PAPER INDUSTRIES PRIVATE LIMITED",
"RAINBOW PETROCHEM INDUSTRIES PRIVATE LIMITED",
"RAINBOW PIGMENTS PRIVATE LIMITED",
"RAINBOW PLASTICS INDIA LIMITED",
"RAINBOW POLYPLAST MANUFACTURING CO PRIVATE LIMITED",
"RAINBOW POLYTECH PRIVATE LIMITED",
"RAINBOW POLYVALVE PRIVATE LIMITED",
"RAINBOW PRINTADS PRIVATE LIMITED",
"RAINBOW PRINT-O-PACK PRIVATE LIMITED",
"RAINBOW PRINTS PRIVATE LIMITED",
"RAINBOW PRODUCTS PRIVATE LIMITED",
"RAINBOW RETAIL CHAIN PRIVATE LIMITED",
"RAINBOW RICE PRIVATE LIMITED",
"RAINBOW SCHOOL",
"RAINBOW SECURITIES PRIVATE LIMITED",
"RAINBOW SEEDS & SPICES PRIVATE LIMITED",
"RAINBOW SILKS",
"RAINBOW SPECIALITY HOSPITALS PRIVATE LIMITED",
"RAINBOW STONES PRIVATE LIMITED",
"RAINBOW TECHNOCAST PRIVATE LIMITED",
"RAINBOW TEXFABPRIVATE LIMITED",
"RAINBOW TEXTILE PROCESSORS PRIVATE LIMITED",
"RAINBOW TRACTOR NANDED",
"RAINBOW TRADE FAIR TOURS PRIVATE LIMITED",
"RAINBOW TRADEFIN SOLUTIONS PRIVATE LIMITED",
"RAINBOW TRAVEL EXPLORERS",
"RAINBOW VACATIONS PRIVATE LIMITED",
"RAINBOW VALLEY INFRADEV PRIVATE LIMITED",
"RAINBOW VANIJYA PVT LTD",
"RAINBOW VSK WIRES INDIA PRIVATE LIMITED",
"RAINBOW WATERPROOF PVT LTD",
"RAINBOWHILLS IRCON PRIVATE LIMITED",
"RAINBOWSTAR AGRO INDIA PRIVATE LIMITED",
"RAINBOX MEDIA PRIVATE LIMITED",
"RAINCHECK NETWORKS PRIVATE LIMITED",
"RAINCODE LABS INDIA PRIVATE LIMITED",
"RAINCONCERT TECHNOLOGIES PRIVATE LIMITED",
"RAINDROP FAASHIONS PRIVATE LIMITED",
"RAINDROP MEDIA PRIVATE LIMITED",
"RAINE ALUMINIUM PRIVATE LIMITED",
"RAINEO HOSPITALITY PRIVATE LIMITED",
"RAINEY TRADING PVT LTD",
"RAINFIRE MANAGEMENT SERVICES PRIVATE LIMITED",
"RAINFOREST COMMUNICATIONS INDIA PRIVATE LIMITED",
"RAINFOREST LOGISTICS PRIVATE LIMITED",
"RAINFOREST RETREATS PRIVATE LIMITED",
"RAINGROW EDIBLES PRIVATE LIMITED",
"RAINI INDUSTRIES INDIA PRIVATE LIMITED",
"RAINIER CREST PRIVATE LIMITED",
"RAINIER SOFTECH SOLUTIONS PRIVATE LIMITED",
"RAINLAND AUTOCORP PRIVATE LIMITED",
"RAINMAKER FOOD & AGRO PRIVATE LIMITED",
"RAINMAKERSWORKSPACE INDIA PRIVATE LIMITED",
"RAINMAN CONSULTING PRIVATE LIMITED",
"RAINMATTER FOUNDATION",
"RAINOX WIREMESH PRIVATE LIMITED",
"RAINPROOF EXPORTS PRIVATE LIMITED",
"RAINSHINE ENTERTAINMENT PRIVATE LIMITED",
"RAINTREE FAMILY OFFICE LLP",
"RAINTREE FOUNDATION (INDIA)",
"RAINTREE INSURANCE BROKING PRIVATE LIMITED",
"RAINTREE SYSTEMS PRIVATE LIMITED",
"RAINVIS PHARMACEUTICALS PRIVATE LIMITED",
"RAINWAX POLYMER PRIVATE LIMITED",
"RAINY ENTERPRISES PRIVATE LIMITED",
"RAIO INTERIO FASHION PRIVATE LIMITED",
"RAIPAR RENEWABLE ENERGY PRIVATE LIMITED",
"RAIPUR AGRIGENETICS PRIVATE LIMITED",
"RAIPUR BOTTLING CO.",
"RAIPUR CARBONICS PRIVATE LIMITED",
"RAIPUR COAL FEEDER PRIVATE LIMITED",
"RAIPUR CONSTRUCTION PRIVATE LIMITED",
"RAIPUR DEVCON PRIVATE LIMITED",
"RAIPUR DEVELOPMENT AUTHORITY",
"RAIPUR ELECTRONICS PRIVATE LIMITED",
"RAIPUR ENERGEN LIMITED",
"RAIPUR FLANGES PRIVATE LIMITED",
"RAIPUR FORGINGS PVT LTD",
"RAIPUR HANDLING INFRASTRUCTURE PRIVATE LIMITED",
"RAIPUR HORTICULTURAL FARM PRIVATE LIMITED",
"RAIPUR MINERALS PRIVATE LIMITED",
"RAIPUR POWER AND STEEL LIMITED",
"RAIPUR REFRATHERM PRIVATE LIMITED",
"RAIPUR ROUND ROLLING MILLS PRIVATE LIMITED",
"RAIPUR STEELCASTING INDIA PRIVATE LIMITED",
"RAIPURIYA FARMER PRODUCER COMPANY LIMITED",
"RAIPUR-RAJNANDGAON-WARORA TRANSMISSION LIMITED",
"RAIS ART PRIVATE LIMITED",
"RAIS INSTITUTE OF MANAGEMENT STUDIES PRIVATE LIMITED",
"RAIS INTERNATIONAL MODEL STUDIES PRIVATE LIMITED",
"RAISE FINTECH VENTURES PRIVATE LIMITED",
"RAISE INFRABUILD PRIVATE LIMITED",
"RAISE MACHINE TOOLS PRIVATE LIMITED",
"RAISEN MARKETING PRIVATE LIMITED",
"RAISEON AUTOMATION & CONTROL ENGINEERING PRIVATE LIMITED",
"RAISER PASUMAI DEVELOPMENT LIMITED",
"RAISHAHIB GANGARAM CHOWDHURY & SONS CO PVT LTD",
"RAISHRI ENGINEERING & CONSTRUCTION PRIVATE LIMITED",
"RAISING GROUP INSURANCE MARKETING LLP",
"RAISING SUN HOTELS PRIVATE LIMITED",
"RAISON TECHNOLOGIES INDIA PRIVATE LIMITED",
"RAISON UDYOG PRIVATE LIMITED",
"RAISONI VENTURES PRIVATE LIMITED",
"RAISPAISA ENTERPRISES PRIVATE LIMITED",
"RAISUN LOGISTICS PRIVATE LIMITED",
"RAISUN METAL ZONE PRIVATE LIMITED",
"RAITABANDHU AHARODYAM PRIVATE LIMITED",
"RAITAN PRIVATE LIMITED",
"RAITANI ENGINEERING WORKS PRIVATE LIMITED",
"RAITECHS PRIVATE LIMITED",
"RAITH INDIA PRIVATE LIMITED",
"RAITO ELECTRICALS PRIVATE LIMITED",
"RAITON SEMICONDUCTOR PRIVATE LIMITED",
"RAIVAT IMPEX PRIVATE LIMITED",
"RAIZADA BROTHERS PVT LTD",
"RAJ & RAJ FREIGHT CARRIERS PRIVATE LIMITED",
"RAJ & RAJ PVT. LTD.",
"RAJ AD ZONE PRIVATE LIMITED",
"RAJ AGRO EQUIPMENTS PRIVATE LIMITED",
"RAJ AGROCHEM PRODUCTS PRIVATE LIMITED",
"RAJ AGROTECH PRIVATE LIMITED",
"RAJ AIR EXPRESS CARGO PRIVATE LIMITED",
"RAJ ALCO BREW PRIVATE LIMITED",
"RAJ ALUMINIUM PRIVATE LIMITED",
"RAJ AMAR FORGINGS PRIVATE LIMITED",
"RAJ AMAR SUGAR CHAINS PRIVATE LIMITED",
"RAJ AND NAV DURGA GARMENTS PRIVATE LIMITED",
"RAJ APIARIES EXIM PRIVATE LIMITED",
"RAJ APPARELS & CLOTHING PRIVATE LIMITED",
"RAJ ARYAN EXPORT PRIVATE LIMITED",
"RAJ ASHRAM PADHATI BALIKA I COLLEGE MOHAN RAOD LUCKNOW",
"RAJ ASSOBUILD PRIVATE LIMITED",
"RAJ ASSOCIATES",
"RAJ AUTO SPARES",
"RAJ AUTO TRADERS PRIVATE LIMITED",
"RAJ BAHADUR CONSTRUCTIONS PRIVATE LIMITED",
"RAJ BHARTI TEXTILES PRIVATE LIMITED",
"RAJ BIOSIS PRIVATE LIMITED",
"RAJ BORAX PRIVATE LIMITED",
"RAJ BREEDERS AND HATCHERIES PRIVATE LIMITED",
"RAJ BULLION (INDIA) PRIVATE LIMITED",
"RAJ CALCINERS PRIVATE LIMITED",
"RAJ CAPSULES PRIVATE LIMITED",
"RAJ CARRIER PRIVATE LIMITED",
"RAJ CARRYING CARGO PRIVATE LIMITED",
"RAJ CHAMUNDA BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"RAJ CHATON INDUSTRIES PRIVATE LIMITED",
"RAJ CHEM PLAST",
"RAJ CHICK FARMS PRIVATE LIMITED",
"RAJ CHOPRA AND COMPANY PRIVATE LIMITED",
"RAJ CLASSIC FOODS LIMITED",
"RAJ CLEANWEL EXIM PRIVATE LIMITED",
"RAJ CLEARING AGENCY",
"RAJ CONBUILD LIMITED",
"RAJ CONSTRUCTION",
"RAJ COOLING SYSTEMS PRIVATE LIMITED",
"RAJ COOLING WORLD PRIVATE LIMITED",
"RAJ CORPORATION LIMITED",
"RAJ COTTONS PVT. LTD",
"RAJ COUTURE PRIVATE LIMITED",
"RAJ CYCLES INDIA PVT LTD",
"RAJ DARSH METAL CRAFTS PRIVATE LIMITED",
"RAJ DARSHAN HOTELS PRIVATE LIMITED",
"RAJ DECOMATS PRIVATE LIMITED",
"RAJ DUPLEX PRIVATE LIMITED",
"RAJ EDUCATIONAL TRUST",
"RAJ ELECTRICALS",
"RAJ ENGINEERS",
"RAJ EQUIPMENT (INDIA) PRIVATE LIMITED",
"RAJ EYE HOSPITAL PRIVATE LIMITED",
"RAJ FABCON INTERIORS PRIVATE LIMITED",
"RAJ FILTERS AND WIRE MESH PRIVATE LIMITED",
"RAJ FINOXIDES PVT LTD",
"RAJ FISHMEAL AND OIL COMPANY",
"RAJ FLAVOURS (INDIA) PRIVATE LIMITED",
"RAJ FOOD INDUSTRIES PRIVATE LIMITED",
"RAJ FURNISHINGS PRIVATE LIMITED",
"RAJ GANGA PROJECTS PRIVATE LIMITED",
"RAJ GLAZING & CLADDING PRIVATE LIMITED",
"RAJ GRIND TECH PRIVATE LIMITED",
"RAJ GRINDTECH PRIVATE LIMITED",
"RAJ HAIR INTERNATIONAL PRIVATE LIMITED",
"RAJ HANDLERS PRIVATE LIMITED",
"RAJ HATCHERIES (BENGAL) PRIVATE LIMITED",
"RAJ HATCHERIES MADRAS PRIVATE LIMITED",
"RAJ HEIGHT THE GLOBAL SCHOOL",
"RAJ HERBALS PRIVATE LIMITED",
"RAJ HIGH SCHOOL MARATHI MEDIUM",
"RAJ HIGH TECH VENTURES PVT LTD",
"RAJ HOMES PRIVATE LIMITED",
"RAJ HOSPITALITY PRIVATE LIMITED",
"RAJ HOUSING DEVELOPMENT PRIVATE LIMITED",
"RAJ HYDROFLEX PRIVATE LIMITED",
"RAJ INDIA AUTO PRIVATE LIMITED",
"RAJ INDIA BREEDER FARM PRIVATE LIMITED",
"RAJ INDUSTRIES",
"RAJ INFO ENTERPRISE PRIVATE LIMITED",
"RAJ INFRACITY PRIVATE LIMITED",
"RAJ INFRADEVELOPERS PRIVATE LIMITED",
"RAJ INFRAPROPERTIES PRIVATE LIMITED",
"RAJ INFRASTRUCTURE DEVELOPMENT INDIA PRIVATE LIMITED.RAJ GROUP",
"RAJ INFRASTRUCTURE PRIVATE LIMITED RAJ GROUP",
"RAJ INNOTECH PRIVATE LIMITED",
"RAJ INTELLIGENT BUILDING MANAGEMENT SERVICES PRIVATE LIMITED",
"RAJ IT SOLUTIONS PRIVATE LIMITED",
"RAJ JEWELLERS (ORISSA) PRIVATE LIMITED",
"RAJ JEWELS",
"RAJ JINDAL HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED",
"RAJ KAMAL FIBRES PRIVATE LIMITED",
"RAJ KAMAL POULTRIES PRIVATE LIMITED",
"RAJ KAMAL PRAKASHAN PVT LTD",
"RAJ KATTHA PRODUCTS PRIVATE LIMITED",
"RAJ KESARI ELECTRODES PRIVATE LIMITED",
"RAJ KESARI METALS PVT. LTD.",
"RAJ KIRANA PRIVATE LIMITED",
"RAJ KISHORE DEVELOPERS PRIVATE LIMITED",
"RAJ KISHORE ENGINEERING CONSTRUCTIONS PRIVATE LIMITED",
"RAJ KNITFAB PRIVATE LIMITED",
"RAJ KRISHNA BUILDSTATE PROJECTS PRIVATE LIMITED",
"RAJ KUMAR",
"RAJ KUMAR APPARELS PRIVATE LIMITED",
"RAJ KUMAR COLLEGE RAIPUR",
"RAJ KUMAR ENTERPRISES PRIVATE LIMITED",
"RAJ KUMAR GOEL INSTITUTE OF TECHNOLOGY",
"RAJ KUMAR SINGH RAJA CONSTRUCTION PRIVATE LIMITED",
"RAJ KUMARI AND RAM GOBIND MEMORIAL EDUCATION SOCIETY",
"RAJ KUMARS SHREE NATH DIAMONDS PRIVATE LIMITED",
"RAJ LAXMI ENERGY PRIVATE LIMITED",
"RAJ LAXMI FABTEX PRIVATE LIMITED",
"RAJ LAXMI MARKETING PRIVATE.LIMITED",
"RAJ LAXMI STORES PRIVATE LIMITED",
"RAJ LIFTERS PRIVATE LIMITED",
"RAJ LUXMI STEEL AND WIRES PRIVATE LIMITED",
"RAJ MAHAL MARBLES PRIVATE LIMITED",
"RAJ MARG PRIVATE LIMITED",
"RAJ MEDITECH INSTRUMENTS PRIVATE LIMITED",
"RAJ MEGACON PRIVATE LIMITED",
"RAJ METRO CERAMICS PRIVATE LIMITED",
"RAJ MILK AND COLD STORAGE PRIVATE LIMITED",
"RAJ MOHINDRA CONSULTANTS PRIVATE LIMITED",
"RAJ MOTORS",
"RAJ MOTORZONE PRIVATE LIMITED",
"RAJ MUSICALS PRIVATE LIMITED",
"RAJ MUSICO PRIVATE LIMITED",
"RAJ NARAIN PRATAP NARAIN ROLLING ENTERPRISES PRIVATE LIMITED",
"RAJ NATURAL FOOD PRIVATE LIMITED",
"RAJ OFFICE SOLUTIONS PRIVATE LIMITED",
"RAJ OFFSET PRIVATE LIMITED",
"RAJ ORGANIC SEEDS PRIVATE LIMITED",
"RAJ ORGOCHEM PRIVATE LIMITED",
"RAJ OUTDOOR ADVERTISING PRIVATE LIMITED",
"RAJ OVERSEAS",
"RAJ PACKAGING INDUSTRIES LIMITED",
"RAJ PACKWELL LIMITED",
"RAJ PAL SINGH COLD STORAGE PRIVATE LIMITED",
"RAJ PALMLAND HOSPITAL PRIVATE LIMITED",
"RAJ PARK",
"RAJ PATH CONTRACTORS AND ENGINEERS LIMITED",
"RAJ PATH INFRACON NH-6 PKG-I PRIVATE LIMITED",
"RAJ PATH INFRACON PN 42 PRIVATE LIMITED",
"RAJ PATH INFRACON PRIVATE LIMITED",
"RAJ PATTERN MAKERS AND FOUNDERS PRIVATE LIMITED",
"RAJ PESTISIDES PRIVATE LIMITED",
"RAJ PETRO SPECIALITIES PRIVATE LIMITED",
"RAJ PLASTICBLENDS PRIVATE LIMITED",
"RAJ PLASTOCOLOURS PRIVATE LIMITED",
"RAJ PLY PRIVATE LIMITED",
"RAJ POLYBAGS PRIVATE LIMITED",
"RAJ POLYFABRICS PRIVATE LIMITED",
"RAJ POLYMERS PRIVATE LTD",
"RAJ PROCESS EQUIPMENTS AND SYSTEMS PRIVATE LIMITED",
"RAJ PROMOTERS & CIVIL ENGINEERS PRIVATE LIMITED RAJ GROUP",
"RAJ PULSES PRIVATE LIMITED",
"RAJ RAJENDRA INDUSTRIES LIMITED.",
"RAJ RAJESHWAR ENTERPRISES PRIVATE LIMITED",
"RAJ RAJESHWARI SUGAR PRIVATE LIMITED",
"RAJ RAJESHWARI TECCHNO-FAB PRIVATE LIMITED",
"RAJ RANGA TEXTILES PRIVATE LIMITED",
"RAJ RATAN COMMODITIES PRIVATE LIMITED",
"RAJ RATAN INFOSOLUTIONS LIMITED",
"RAJ RATAN SMELTERS LIMITED",
"RAJ READY CONCRETE WORKS PRIVATE LIMITED",
"RAJ REFRACTORIES PRIVATE LIMITED",
"RAJ RESTAURANT PVT.LTD.",
"RAJ RISHIK HOSPITAL PRIVATE LIMITED",
"RAJ ROCKS EXPORTS PRIVATE LIMITED",
"RAJ SALT & CHEMICALS PVT LTD",
"RAJ SAREES PVT LTD",
"RAJ SCANNING LIMITED",
"RAJ SECURITY AND FACILITY MANAGEMENT PRIVATE LIMITED",
"RAJ SECURITY FORCE LS PRIVATE LIMITED",
"RAJ SHAKTI WELD PRODUCTS PRIVATE LIMITED",
"RAJ SHEETALAYA PRIVATE LIMITED",
"RAJ SHIPPING AGENCIES LIMITED",
"RAJ SHOPPY PRIVATE LIMITED",
"RAJ SHREE PULP AND BOARD MILLS PRIVATE LIMITED",
"RAJ SHREY TEXT PRIVATE LIMITED",
"RAJ SHYAMA CONSTRUCTIONS PRIVATE LIMITED",
"RAJ SKYLINE & KCD BUILDERS PRIVATE LIMITED",
"RAJ SNEH AGRO FOODS PRIVATE LIMITED",
"RAJ SOFTWARE TECHNOLOGY (INDIA) LIMITED",
"RAJ SOLUTIONS (INDIA) PRIVATE LIMITED",
"RAJ SOLVENT PRIVATE LIMITED",
"RAJ SOLVEX PRIVATE LIMITED",
"RAJ SONS AUTO PRIVATE LIMITED",
"RAJ SONS POLYMERS PVT LTD",
"RAJ SPECIALITY ADDITIVES PRIVATE LIMITED",
"RAJ SPECIALITY CHEMICALS PRIVATE LIMITED",
"RAJ STOCK BROKING PRIVATE LIMITED",
"RAJ SULZ ENTERPRISES PRIVATE LIMITED",
"RAJ SUNMICA AND PLY",
"RAJ SYNTHETICS PRIVATE LIMITED",
"RAJ TANWAR SECURITY PRIVATE LIMITED",
"RAJ TECHNOPACK PRIVATE LIMITED",
"RAJ TELEVISION NETWORK LIMITED",
"RAJ TEX MACHINARY PRIVATE LIMITED",
"RAJ TILAK MARBLES PRIVATE LIMITED",
"RAJ TILAKS TECHNOLOGY PRIVATE LIMITED",
"RAJ TRADERS",
"RAJ TRANS STAMPINGS PRIVATE LIMITED",
"RAJ TRIMURTI INFRAPROJECTS PRIVATE LIMITED",
"RAJ TUBE CO. PRIVATE LIMITED",
"RAJ VEHICLES PRIVATE LIMITED",
"RAJ VFX PRIVATE LIMITED",
"RAJ VIDHYUT PRIVATE LIMITED",
"RAJ VIHAR HOTELS PVT LTD",
"RAJ VIHAR INFRA & CONSULTANTS LIMITED",
"RAJ VIJTECH PRIVATE LIMITED",
"RAJ VILAS PALACE (HOTEL) PRIVATE LIMITED",
"RAJ WASTE TREAT PRIVATE LIMITED",
"RAJ WATERSCAPE PROPERTIES PRIVATE LIMITED",
"RAJ WESTPOWER T LIMITED",
"RAJ WOODART INTERIOR LIMITED",
"RAJ YATAYAT PVT LTD",
"RAJA & CO OVERSEAS PRIVATE LIMITED",
"RAJA & RAJAS SAWMILL AND TIMBERS PRIVATE LIMITED",
"RAJA AEDERI CONSULTANTS PRIVATE LIMITED",
"RAJA BAHADUR INTERNATIONAL LIMITED",
"RAJA BALWANT SINGH COLLEGE",
"RAJA BALWANT SINGH ENGINEERING TECHNICAL CAMPUS",
"RAJA BHRATHARI HEALTHCARE PRIVATE LIMITED",
"RAJA BIRI PRIVATE LIMITED",
"RAJA CROWNS AND CANS PRIVATE LIMITED",
"RAJA DHANRAJGIRJI HIGH SCHOOL",
"RAJA DIAGNOSTIC CENTRE & HOSPITAL",
"RAJA ENTERPRISES",
"RAJA EXPLOSIVES PRIVATE LIMITED",
"RAJA FARMS PRIVATE LIMITED",
"RAJA FAT AND FEEDS PVT LTD",
"RAJA GANAPATHY BOARD MILLS PVT LTD",
"RAJA GANESH MOTORS LLP",
"RAJA GEMS PRIVATE LIMITED",
"RAJA HARPAL SINGH INTER COLLEGE",
"RAJA HOSPITAL PRIVATE LIMITED",
"RAJA HOUSING LIMITED",
"RAJA IMPEX PRIVATE LIMITED",
"RAJA INDIA PRIVATE LIMITED",
"RAJA INFRACONSTRUCTION PRIVATE LIMITED",
"RAJA INTERIORS PRIVATE LIMITED",
"RAJA JEWELLERY MART PRIVATE LIMITED",
"RAJA MADHUSADAN DEB COLLEGE OF SCIENCE",
"RAJA MONEYEXCHANGERS & HOLIDAYS PRIVATE LIMITED",
"RAJA MOTELS AND HOTELS INDIA PVT LTD",
"RAJA NARAYAN LAHOTI ENGLISH SCHOOL LATUR",
"RAJA PAINTS INDIA PRIVATE LIMITED",
"RAJA PEARY MOHAN COLLEGE",
"RAJA RAJESHWARA BREEDERS PRIVATE LIMITED",
"RAJA RAJESHWARI INTERNATIONAL POLYMERS PRIVATE LIMITED",
"RAJA RAJESWARI ENGINEERING COLLEGE",
"RAJA RAJESWARI KRAFTS PRIVATE LIMITED",
"RAJA RAJESWARI MEDICAL COLLEGE",
"RAJA RAM MOHAN RAI SARVODYA KAVYA VIDHALAYA",
"RAJA RAMANNA CENTRE FOR ADVANC TECH",
"RAJA RAMMOHUN ROY LIBRARY FOUNDATION",
"RAJA SAAB TEA ESTATES PRIVATE LIMITED",
"RAJA SECURITY INDIA OPC PRIVATE LIMITED",
"RAJA SHELTERS PRIVATE LIMITED",
"RAJA SLATES PRIVATE LIMITED",
"RAJA SOFTWARE LABS PRIVATE LIMITED",
"RAJA SRIRAM PRIVATE LIMITED",
"RAJA TEXTILES PRIVATE LIMITED",
"RAJA TRADELINKS PRIVATE LIMITED",
"RAJA TRANSPORT PRIVATE LIMITED",
"RAJA UDYOG PRIVATE LIMITED",
"RAJA VIGYAPAN AGENCY PRIVATE LIMITED",
"RAJAARYA HOUSING DEVELOPERS PRIVATE LIMITED",
"RAJADHANI HOTELS PRIVATE LIMITED",
"RAJADHANIGOLD AND DIAMONDS PRIVATE LIMITED",
"RAJADHEEPAM SPINNING MILLS PRIVATE LIMITED",
"RAJADHIRAJ COMMOTRADE PVT LTD",
"RAJADHIRAJ CORPORATE MANAGEMENT PVT LTD",
"RAJADHIRAJ TIRUPANI VINAYAK NATRAJ PRIVATE LIMITED",
"RAJADITYA INDUSTRIES PRIVATE LIMITED",
"RAJAGIRI COLLEGE OF SOCIAL SCIENCES RAJ",
"RAJAGIRI HEALTHCARE & EDUCATION TRUST",
"RAJAGOPAL CONSTRUCTIONS PRIVATE LIMITED",
"RAJAGURU SPINNING MILLS PRIVATE LIMITED",
"RAJAH CHARITABLE MEDICAL TRUST",
"RAJAH HEALTHY ACRES PRIVATE LIMITED",
"RAJAHAMSA AVENUES PRIVATE LIMITED",
"RAJAHMUNDRY EXPRESSWAY PRIVATE LIMITED",
"RAJAHMUNDRY GODAVARI BRIDGE LIMITED",
"RAJAHMUNDRY PAPER MILLS PRIVATE LIMITED",
"RAJAHMUNDRY PHARMACEUTICALS PRIVATE LIMITED",
"RAJAHRANI IMPEX PRIVATE LIMITED",
"RAJAJI AVS MOTORS PRIVATE LIMITED",
"RAJAJI JD ENTERTAINMENT PRIVATE LIMITED",
"RAJAJI NATIONAL PARK",
"RAJAJI PRINT-PACK PRIVATE LIMITED",
"RAJAKRISHNA WEAVE PRIVATE LIMITED",
"RAJAKUMARI SHOPPING LIMITED",
"RAJAL LAMINATE PRIVATE LIMITED",
"RAJALAKSHMI CARS PRIVATE LIMITED",
"RAJALAKSHMI ENGG COLLEGE",
"RAJALAKSHMI HOSTELS PRIVATE LIMITED",
"RAJALAKSHMI INSTITUTE OF TECHNOLOGY",
"RAJALAKSHMI MARKETING PRIVATE LIMITED",
"RAJALAKSHMI POLYPACKS PRIVATE LIMITED",
"RAJALAKSHMI SPINNERS PRIVATE LIMITED",
"RAJALAKSHMI TEXTILE PROCESSORS PRIVATE LIMITED",
"RAJALAKSHMI UNIVERSAL EDUCATION PRIVATE LIMITED",
"RAJALAXMI EDUCATION TRUST",
"RAJALLE CONTAINER MOVERS PRIVATE LIMITED",
"RAJAM INDUSTRIES PRIVATE LIMITED",
"RAJAM RESORTS PRIVATE LIMITED",
"RAJAMAHAL INTERNATIONAL PRIVATE LIMITED",
"RAJAMAHENDRI HEALTHCARE PRIVATE LIMITED",
"RAJAMANE AND HEGDE SERVICES PRIVATE LIMITED",
"RAJAMANE INDUSTRIES PRIVATE LIMITED",
"RAJAMANI TECHNOLOGY PRIVATE LIMITED",
"RAJAMI BARTER PVT. LTD.",
"RAJAMI RETAIL PRIVATE LIMITED",
"RAJAN BABU TB HOSPITAL",
"RAJAN BABU TB HOSPITAL DELHI",
"RAJAN BANQUET PRIVATE LIMITED",
"RAJAN DENTAL INSTITUTE PRIVATE LIMITED",
"RAJAN DS BUILDTECH PRIVATE LIMITED",
"RAJAN ELECTRICALS PRIVATE LIMITED",
"RAJAN EYE CARE HOSPITAL PRIVATE LIMITED",
"RAJAN HOTELS PRIVATE LIMITED",
"RAJAN KNITFAB PRIVATE LIMITED",
"RAJAN LOGISTICS PRIVATE LIMITED",
"RAJAN LOONA",
"RAJAN MACHINES (INDIA) PRIVATE LIMITED",
"RAJAN MANUFACTURING PRIVATE LIMITED",
"RAJAN PLYWOOD PRIVATE LIMITED",
"RAJAN PROPCON PRIVATE LIMITED",
"RAJAN RAHUL ASSOCIATES PRIVATE LIMITED",
"RAJAN STORES PRIVATE LIMITED",
"RAJAN TECHNOCAST PVT LTD",
"RAJANARAYAN TEXTILES PRIVATE LIMITED",
"RAJANI DISTRIBUTORS PRIVATE LIMITED",
"RAJANI PERFUMARY WORKS PRIVATE LIMITED",
"RAJANI POLYPACK PRIVATE LIMITED",
"RAJANI SPICES PRIVATE LIMITED",
"RAJANI TRADING AND INVESTMENTS PRIVATE LIMITED",
"RAJANIKLAL SALES PVT LTD",
"RAJANITAI DESHMUKH FARMERS PRODUCER COMPANY LIMITED",
"RAJANYA INFRASTRUCTURE PRIVATE. LIMITED.",
"RAJANYAS ECOMMERCE PRIVATE LIMITED",
"RAJAPALAYAM MILLS LIMITED.",
"RAJAPALAYAM TEXTILE LIMITED",
"RAJAPRARA PRIMARY SCHOOL",
"RAJAPURA HOMES PRIVATE LIMITED",
"RAJAPUSHPA CORPORATE PRIVATE LIMITED",
"RAJARAJESHWARE BUILDDCON PRIVATE LIMITED",
"RAJARAJESWARI HOSPITALS PRIVATE LIMITED",
"RAJARAM CHAVAN REAL ESTATE PRIVATE LIMITED",
"RAJARAM COLLEGE",
"RAJARAM FASHIONS PRIVATE LIMITED",
"RAJARAM FLOUR MILLS PRIVATE LIMITED",
"RAJARAM MANAGEMENT SERVICES PRIVATE LIMITED",
"RAJARAM MARMO PRIVATE LIMITED",
"RAJARAM SOLVEX LIMITED",
"RAJARAM STEEL INDUSTRIES PRIVATE LIMITED",
"RAJARAMAN CONSTRUCTIONS PRIVATE LIMITED",
"RAJARAMBAPU PATIL MILITARY SCHOOL & SPORT ACADEMY RAJEBAGESWAR NAGAR ISLAMPUR",
"RAJARAMBAPU PATIL SAHAKARI SAKHAR KARKHANA LTD",
"RAJARATHNAM CONSTRUCTION PRIVATE LIMITED",
"RAJARATNAM FIREWORKS PRIVATE LIMITED",
"RAJARHAT IT PARK LIMITED",
"RAJARHAT SIKHANIKETAN",
"RAJARHAT SIKSHANIKETAN",
"RAJARMATH R K A HIGH SCHOOL",
"RAJARSHEE INFRA CON PRIVATE LIMITED",
"RAJARSHI AUTO DEALS PRIVATE LIMITED",
"RAJARSHI MILES PRIVATE LIMITED",
"RAJARSHI MODI PRIVATE LIMITED",
"RAJARSHI SHAHU ART'S COMMERCE AND SCIENCE COLLEGE",
"RAJARSHI SHAHU COLLEGE OF ARTS & SCIENCE",
"RAJARSHI SHAHU COLLEGE OF ENGINEERING",
"RAJARSHI SHAHU MAHARAJ POLYTECHNIC",
"RAJARSHI SHAHU MAHARAJ PRATHAMIC VIDHYALAY - PUNE MUNICIPLE CORPORATON",
"RAJARSHI SHAHU MAHARAJ SECONDARY SCHOOL THANE",
"RAJARSHI SHAHU MAHAVIDYALAYA LATUR",
"RAJARSHI SHAHU SAHAKARI BANK",
"RAJAS ENGINEERS PRIVATE LIMITED",
"RAJASEKAR SPINTEX PRIVATE LIMITED",
"RAJASHREE ELECTRICALS & ASSOCIATES PRIVATE LIMITED",
"RAJASHREE PUBLIC SCHOOL LATUR ROAD NANDED",
"RAJASHREE SPINTEX PRIVATE LIMITED",
"RAJASHRI CHH SHAHU HIGHSCHOOL",
"RAJASHRI FOODS PRIVATE LIMITED",
"RAJASHRI SHAHU COLLEGE OF ENGINEERING",
"RAJASRI INFRASTRUCTURES PRIVATE LIMITED",
"RAJASRI SYSTEMS PRIVATE LIMITED",
"RAJASS TECHNOLOGIES PRIVATE LIMITED",
"RAJASTHALI LEGAL NETWORK OPC PRIVATE LIMITED",
"RAJASTHALI RESORTS AND STUDIOS LTD",
"RAJASTHAN AIR PRODUCTS PRIVATE LIMITED",
"RAJASTHAN ALLIED AND SECURITY SERVICES PRIVATE LIMITED",
"RAJASTHAN ALUMINIUM HOUSE PRIVATE LIMITED",
"RAJASTHAN ASSET MANAGEMENT COMPANY PRIVATE LIMITED",
"RAJASTHAN AUSHDHALAYA PRIVATE LIMITED",
"RAJASTHAN BARYTES LIMITED",
"RAJASTHAN CABLES AND CONDUCTORS PVT LTD",
"RAJASTHAN CENTRAL STORES PVT LTD",
"RAJASTHAN COACH BUILDERS PVT LTD",
"RAJASTHAN COLLIERIES LIMITED",
"RAJASTHAN CONSTRUCTION PRIVATE LIMITED",
"RAJASTHAN CO-OPERETIVE DAIRY FEDERATION LTD",
"RAJASTHAN CYLINDERS AND CONTAINERS LTD",
"RAJASTHAN DENTAL COLLEGE & HOSPITAL",
"RAJASTHAN DIGITAL TILES PRIVATE LIMITED",
"RAJASTHAN DISTILLERIES PRIVATE LIMITED",
"RAJASTHAN ELECHEM PRIVATE LIMITED",
"RAJASTHAN ELECTRONICS INSTRUMENTS",
"RAJASTHAN EXPLOSIVES AND CHEMICALS LIMITED",
"RAJASTHAN EX-SERVICEMEN CORPORATION LIMITED",
"RAJASTHAN FASTENERS PRIVATE. LIMITED.",
"RAJASTHAN FLEXIBLE PACKAGING LIMITED",
"RAJASTHAN GLOBAL SECURITIES PRIVATE LIMITED",
"RAJASTHAN GUM PRIVATE LIMITED",
"RAJASTHAN HERITAGE HANDICRAFTS PRIVATE LIMITED",
"RAJASTHAN HIGH COURT",
"RAJASTHAN HOSPITAL GRC",
"RAJASTHAN HOUSING BOARD",
"RAJASTHAN HYBRIDS PRIVATE LIMITED",
"RAJASTHAN INDUSTRIES LIMITED.",
"RAJASTHAN INSUTECH REFRACTORIES PRIVATE LIMITED",
"RAJASTHAN INTERNATIONAL",
"RAJASTHAN IRON COMPANY",
"RAJASTHAN JAL VIKAS NIGAM LTD",
"RAJASTHAN JEWELLERS PRIVATE LIMITED.",
"RAJASTHAN KHADI & VILLAGE INDUSTRIES BOARD",
"RAJASTHAN KNOWLEDGE CORPORATION LIMITED",
"RAJASTHAN L S A TRAINING INSTITUTE",
"RAJASTHAN LIQUORS LIMITED",
"RAJASTHAN LOGISTICS PRIVATE LIMITED",
"RAJASTHAN MACHINERY MART PVT LTD",
"RAJASTHAN MECHANICAL WORKS LIMITED",
"RAJASTHAN MEDICAL SERVICES CORPORATION LIMITED",
"RAJASTHAN METROCHEM PRIVATE LIMITED",
"RAJASTHAN OLIVE CULTIVATION LIMITED",
"RAJASTHAN P G COLLEGE",
"RAJASTHAN PACKING CO PVT LTD",
"RAJASTHAN PAINTS PRIVATE LIMITED",
"RAJASTHAN PATRIKA PRIVATE LIMITED",
"RAJASTHAN PEST CONTROL SERVICES PRIVATE LIMITED",
"RAJASTHAN PHARMACY COUNCIL",
"RAJASTHAN POLYTEX PRIVATE LIMITED",
"RAJASTHAN POWERGEN TRANSFORMER PRIVATE LIMITED",
"RAJASTHAN PRIME STEEL PROCESSING CENTER PRIVATE LIMITED",
"RAJASTHAN PULSES",
"RAJASTHAN RAJYA VIDYUT PRASARAN NIGAM LIMITED",
"RAJASTHAN RENEWABLE ENERGY CORPORATION LIMITED",
"RAJASTHAN ROADWAYS",
"RAJASTHAN ROUTES TRAILS PRIVATE LIMITED",
"RAJASTHAN SALES PRIVATE LIMITED",
"RAJASTHAN SANDS AND CLAYS PVT LTD",
"RAJASTHAN SKILL AND LIVELIHOODS DEVELOPMENT CORPORATION",
"RAJASTHAN SMALL INDUSTRIES COR LIMITED",
"RAJASTHAN SOLARPARK DEVELOPMENT COMPANY LIMITED",
"RAJASTHAN STATE AIDS CONTROL SOCIETY",
"RAJASTHAN STATE BEVERAGES CORPORATION LIMITED",
"RAJASTHAN STATE GANGANAGAR SUGAR MILL LIMITED",
"RAJASTHAN STATE GAS LIMITED",
"RAJASTHAN STATE INDUSTRIAL DEVELOPMENT AND INVESTMENT CORPORATION LTD",
"RAJASTHAN STATE MINES AND MINERALS LIMITED",
"RAJASTHAN STATE POWER FINANCE AND FINANCIAL SERVICES CORPORATION LIMITED",
"RAJASTHAN STATE ROAD DEVELOPMENT AND CONSTRUCTION CORPORATION LIMITED",
"RAJASTHAN STATE SEEDS CORPORATION LIMITED",
"RAJASTHAN SUN TECHNIQUE ENERGY PRIVATE LIMITED",
"RAJASTHAN SUPER FILLERS PRIVATE LIMITED",
"RAJASTHAN SURGICO PRIVATE LIMITED",
"RAJASTHAN TIN & CORRUGATION PRIVATE LIMITED",
"RAJASTHAN TOURISM DEVELOPMENT CORPORATION LIMITED",
"RAJASTHAN TOURS P LTD",
"RAJASTHAN TRANSMAT PRIVATE LIMITED",
"RAJASTHAN TRANSMISSION WIRES PVT LTD",
"RAJASTHAN TRIBAL AREA DEVELOPMENT CO OPERATIVE FEDERATION LTD",
"RAJASTHAN TUBE MANUFACTURING COMPANY LIMITED",
"RAJASTHAN UDYOG AND TOOLS PRIVATE LIMITED",
"RAJASTHAN UNIVERSITY- GOVT RAJ",
"RAJASTHAN URJA VIKAS AND IT SERVICES LIMITED",
"RAJASTHAN VIKAS SANSTHAN",
"RAJASTHANI NAMKEEN PRIVATE LIMITED",
"RAJASTHANI SAMMELAN",
"RAJASTHAN RAJYA VIDYUT UTPADAN NIGAM LIMITED",
"RAJASWI CHEMICAL MANUFACTURING INDUSTRIES PRIVATE LIMITED",
"RAJAT & COMPANY COMMODITIES PRIVATE LIMITED",
"RAJAT AGRO COMMODITIES PRIVATE LIMITED",
"RAJAT BUILDTECH PRIVATE LIMITED",
"RAJAT DEVBUILD PRIVATE LIMITED",
"RAJAT EQUIPMENTS PRIVATE LIMITED",
"RAJAT INFRA DEVELOPERS PRIVATE LIMITED",
"RAJAT INTERMEDIARY PRIVATE LIMITED",
"RAJAT POWER & STEEL PRIVATE LIMITED",
"RAJAT PRODUCTS PRIVATE LIMITED",
"RAJAT PULSES PRIVATE LIMITED",
"RAJAT REAL ESTATE PRIVATE LIMITED",
"RAJAT RENEWABLES LIMITED",
"RAJAT SONS PRIVATE LIMITED",
"RAJAT SUITINGS PRIVATE LIMITED",
"RAJAT TIE-UP PRIVATE LIMITED",
"RAJAT TUBES PRIVATE LIMITED",
"RAJAT VINYLS PRIVATE LIMITED",
"RAJAT WORLD TRADE PRIVATE LIMITED",
"RAJATDEEP OVERSEAS PRIVATE LIMITED",
"RAJATHADRI JEWELLERS PRIVATE LIMITED",
"RAJAVEER FASHIONS PRIVATE LIMITED",
"RAJAVI ENTERPRISE",
"RAJBALLAVI HIMGHAR PVT LTD",
"RAJBHARATH FOUNDATIONS P LIMITED",
"RAJBIR CONSTRUCTION PRIVATE LIMITED",
"RAJCHANDRA AGENCIES",
"RAJCO METAL INDUSTRIES PVT LTD",
"RAJCOMP INFO SERVICES LIMITED",
"RAJCON ENGINEERS PRIVATE. LIMITED.",
"RAJDA CHEM PRIVATE LIMITED",
"RAJDA INDUSTRIES & EXPORTS PRIVATE LIMITED",
"RAJDA REALITIES PRIVATE LIMITED",
"RAJDA SALES CALCUTTA PRIVATE LIMITED",
"RAJDARBAR ASHVAMEDH PRIVATE LIMITED",
"RAJDARBAR ASSETS PRIVATE LIMITED",
"RAJDARBAR BUILDCON PRIVATE LIMITED",
"RAJDARBAR BUILDERS PRIVATE LIMITED",
"RAJDARBAR COMMODITIES PRIVATE LIMITED",
"RAJDARBAR NINE VENTURES PRIVATE LIMITED",
"RAJDARBAR REALTY CREATIONS PRIVATE LIMITED",
"RAJDARBAR SPACES PRIVATE LIMITED",
"RAJDARBAR SQUARE PRIVATE LIMITED",
"RAJDARBAR TRANSPAY SOLUTIONS PRIVATE LIMITED",
"RAJDARSHAN INDUSTRIES LIMITED",
"RAJDEEP & CO. INFRASTRUCTURE PRIVATE LIMITED",
"RAJDEEP AGRI PRODUCTS PRIVATE LIMITED",
"RAJDEEP AUTOMATION PRIVATE LIMITED",
"RAJDEEP BOILER PRIVATE LIMITED",
"RAJDEEP CANS PRIVATE LIMITED",
"RAJDEEP CONSTRUCTION PRIVATE LIMITED",
"RAJDEEP ELECTRICALS PRIVATE LIMITED",
"RAJDEEP ENGINEERING SYSTEMS PUNE PRIVATE LIMITED",
"RAJDEEP ENGINEERING SYSTEMS PUNE PVT LTD",
"RAJDEEP ENTERPRISE",
"RAJDEEP FABRICS PRIVATE LIMITED",
"RAJDEEP HOSPITAL PRIVATE LIMITED",
"RAJDEEP INFO TECHNO PRIVATE LIMITED",
"RAJDEEP LEASING AND FINANCE DELHI PRIVATE LIMITED",
"RAJDEEP OIL REFINERIES PVT LTD",
"RAJDEEP OVERSEAS PRIVATE LIMITED",
"RAJDEEP PACKAGING PRIVATE LIMITED",
"RAJDEEP PLASTIC CONTAINERS (INDIA) PRIVATE LIMITED",
"RAJDEEP PLAST-TEC PRIVATE LIMITED",
"RAJDEEP PROJECTS FORCE PRIVATE LIMITED",
"RAJDEEP PUBLICITY PRIVATE LIMITED",
"RAJDEEP ROADWAYS PRIVATE LIMITED",
"RAJDEEP STEEL PRODUCTS PRIVATE LIMITED",
"RAJDEV STEELS & ALLOYS PRIVATE LIMITED",
"RAJDHAANI OFFICE & HOME SOLUTIONS PRIVATE LIMITED",
"RAJDHAN TISSUES PRIVATE LIMITED",
"RAJDHANE DISPOSABLE PRODUCTS PRIVATE LIMITED",
"RAJDHANI AIR EXPRESS PRIVATE LIMITED",
"RAJDHANI AUTOMOBILES INDIA PRIVATE LIMITED",
"RAJDHANI AUTOMOTIVES PVT LTD",
"RAJDHANI BOOK AND PAPER PRODUCTS PRIVATE LIMITED",
"RAJDHANI BUILDWELL PRIVATE LIMITED",
"RAJDHANI CASTINGS PRIVATE LIMITED",
"RAJDHANI COLLECTIONS PRIVATE LIMITED",
"RAJDHANI COLLEGE",
"RAJDHANI COMPONENTS PRIVATE LIMITED",
"RAJDHANI CRAFTS EXPORTS PRIVATE LIMITED",
"RAJDHANI CRAFTS INDUSTRIES PRIVATE LIMITED",
"RAJDHANI CRAFTS INTERNATIONAL PRIVATE LIMITED",
"RAJDHANI DEALERS PRIVATE LIMITED",
"RAJDHANI ELECTROCHEM PRIVATE LIMITED",
"RAJDHANI FERROS PRIVATE LIMITED",
"RAJDHANI FLOUR MILLS LIMITED",
"RAJDHANI FURNISHING PRIVATE LIMITED",
"RAJDHANI FURNITURES PRIVATE LIMITED",
"RAJDHANI HORTICULTURE AND SEEDS PRIVATE LIMITED",
"RAJDHANI IMPEX PRIVATE LIMITED",
"RAJDHANI INFOTAINMENT PRIVATE LIMITED",
"RAJDHANI INFRAHOUSING PRIVATE LIMITED",
"RAJDHANI IRON PRODUCTS PRIVATE LIMITED",
"RAJDHANI JEWELLERS AND GEMS PRIVATE LIMITED",
"RAJDHANI NAGAR SAHKARI BANK LIMITED",
"RAJDHANI PAINTS PRIVATE LIMITED",
"RAJDHANI PAPER BOARD PRIVATE LIMITED",
"RAJDHANI PAPER DISTRIBUTORS PRIVATE LIMITED",
"RAJDHANI PETROCHEMICALS PRIVATE LIMITED",
"RAJDHANI POLYMERS (INDIA) PRIVATE LIMITED",
"RAJDHANI PRINTERS LTD",
"RAJDHANI PRIVATE LIMITED",
"RAJDHANI RECYCLING PRIVATE LIMITED",
"RAJDHANI REFINARY PRIVATE LIMITED",
"RAJDHANI RETAIL",
"RAJDHANI ROLLER FLOUR MILLS PRIVATE LIMITED",
"RAJDHANI SALES PRIVATE LIMITED",
"RAJDHANI STONE CRUSHERS PVT LTD",
"RAJDHANI SYNTEX PRIVATE LIMITED",
"RAJDHANI SYSTEMS AND ESTATES PRIVATE LIMITED",
"RAJDHANI TEXTILES PRIVATE LIMITED",
"RAJDHANI TUBES PRIVATE LIMITED",
"RAJDHANIAIR TECHNOLOGIES PRIVATE LIMITED",
"RAJDHYAN VENTURES",
"RAJDIN RESTAURANT PVT LTD",
"RAJDISLE PRIVATE LIMITED",
"RAJDOOT CABLES PRIVATE LIMITED",
"RAJDOOT ORGANICS PRIVATE LIMITED",
"RAJDOOT PARIVAHAN PRIVATE LIMITED",
"RAJDOOT SPECIALITIES PRIVATE LIMITED",
"RAJDULARI STORAGE SYSTEMS PRIVATE LIMITED",
"RAJE MALHARRAO HOLKER AGRO PRODUCER COMPANY LIMITED",
"RAJE SHIVRAY PRATISHTHAN EDUCATIONAL TRUST GENIUS KIDS INTERNATIONAL PRE PRIMARY SCHOOL",
"RAJEEV AGRO INDUSTRIES PRIVATE LIMITED",
"RAJEEV BROTHERS PVT LTD",
"RAJEEV CHLORIDES AND CARBONICS PRIVATE LIMITED",
"RAJEEV DRESSES PRIVATE LIMITED",
"RAJEEV ENTERPRISES",
"RAJEEV FOOTCARE PRIVATE LIMITED",
"RAJEEV GANDHI COLLEGE OF MANAGEMENT STUDIES",
"RAJEEV GANDHI NAVODAYA VIDYALAYA",
"RAJEEV GANDHI PRIMARY SCHOOL",
"RAJEEV KORE BRIGHT FUTURE PUBLIC SCHOOL SANGLI",
"RAJEEV KUMAR CONTRACTOR P LIMITED.",
"RAJEEV METAL INDUSTRIES",
"RAJEEV SETHI SCENOGRAPHERS PRIVATE LIMITED",
"RAJEEV TOURIST SERVICES PRIVATE LIMITED",
"RAJEEV TRADECOMM PRIVATE LIMITED",
"RAJEEVI CONTAINER SERVICES PRIVATE LIMITED",
"RAJENDRA AND URSULA JOSHI FOOD INDUSTRIES PRIVATE LIMITED",
"RAJENDRA AND URSULA JOSHI GROUP HOLDING PRIVATE LIMITED",
"RAJENDRA AND URSULA JOSHI HOLDINGS PRIVATE LIMITED",
"RAJENDRA AND URSULA JOSHI SKILL DEVELOPMENT PRIVATE LIMITED",
"RAJENDRA AUTO WHEELS PRIVATE LIMITED",
"RAJENDRA BHAI DAHYABHAI PATE TOBACCO BIDI WORKS PRIVATE LIMITED",
"RAJENDRA CARGO MOVERS PRIVATE LIMITED",
"RAJENDRA ENGINEERING (AHMEDABAD) PRIVATE LIMITED",
"RAJENDRA FASHION PRIVATE LIMITED",
"RAJENDRA FERROMET PRIVATE LIMITED REJEN",
"RAJENDRA INFRACONS (INDIA) PRIVATE LIMITED",
"RAJENDRA INSTITUTE OF MEDICAL SCIENCES",
"RAJENDRA ISPAT PRIVATE LIMITED",
"RAJENDRA JEWELLERS PRIVATE LIMITED",
"RAJENDRA KUMAR KALAL",
"RAJENDRA MANAGEMENT PRIVATE LIMITED",
"RAJENDRA MANE COLLEGE OF ENGINEERING AND TECHNOLOGY",
"RAJENDRA MECHANICAL PRIVATE LIMITED",
"RAJENDRA MITTAL CONSTRUCTION COMPANY PRIVATE LIMITED",
"RAJENDRA MODI SHARE BROKERS PRIVATE LIMITED",
"RAJENDRA PLYWOOD",
"RAJENDRA PODDAR ENGICON PRIVATE LIMITED",
"RAJENDRA PRASAD SAHU CONSTRUCTION PRIVATE LIMITED",
"RAJENDRA RICE & GENERAL MILLS",
"RAJENDRA SHIPBREAKERS PVT LTD",
"RAJENDRA SINGH BHAMBOO TOLLWAYS PRIVATE LIMITED",
"RAJENDRA SINGH KILEDAR CONSTRUCTIONS PRIVATE LIMITED",
"RAJENDRA TRANSPORT SERVICES PRIVATE LIMITED",
"RAJENDRA TRUCKING PRIVATE LIMITED",
"RAJENDRA VIDYALAYA",
"RAJENDRAN MATRIC HR SEC SCHOOL",
"RAJESH AUTO MERCHANDISE PRIVATE LIMITED",
"RAJESH BEARING PRIVATE LIMITED",
"RAJESH BUILDHOMES PRIVATE LIMITED",
"RAJESH CARGO MOVERS INDIA PRIVATE LIMITED",
"RAJESH CHEMICALS PRIVATE LIMITED",
"RAJESH CRAFTJEWEL (INDIA) PRIVATE LIMITED",
"RAJESH CREATIONS PRIVATE LIMITED",
"RAJESH DIGITAL & DATACOM PRIVATE LIMITED",
"RAJESH EXPORTS LIMITED",
"RAJESH FERROTECH PRIVATE LIMITED",
"RAJESH FILAMENTS PRIVATE LIMITED",
"RAJESH GOLD PALACE PRIVATE LIMITED",
"RAJESH INDUSTRIES",
"RAJESH INFRASTRUCTURE PRIVATE LIMITED",
"RAJESH KHANNA MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"RAJESH KUMAR CONSTRUCTIONS PRIVATE LIMITED",
"RAJESH KUMAR CONTRACTORS PRIVATE LIMITED",
"RAJESH MACHINE TOOLS PRIVATE LIMITED",
"RAJESH MASALA UDYOG PRIVATE LIMITED",
"RAJESH MILK AND EDIBLE PRODUCTS PRIVATE LIMITED",
"RAJESH MOTORCARS PRIVATE LIMITED",
"RAJESH MOTORS (AGENCIES) PRIVATE LIMITED",
"RAJESH MOTORS (AUTO) PRIVATE LIMITED",
"RAJESH MOTORS (MAHARASHTRA) PRIVATE LIMITED",
"RAJESH MOTORS CARS PRIVATE LIMITED",
"RAJESH MOTORS LAKECITY PRIVATE LIMITED",
"RAJESH MOTORS MOTOCORP PRIVATE LIMITED",
"RAJESH MOTORS RAJASTHAN PRIVATE LIMITED",
"RAJESH MULTITRADE PRIVATE LIMITED",
"RAJESH MUNDRA COMMODITIES PRIVATE LIMITED",
"RAJESH OIL INDUSTRIES PRIVATE LIMITED",
"RAJESH PHARMA PRIVATE LIMITED",
"RAJESH POWER SERVICES PRIVATE LIMITED",
"RAJESH PRODUCTS PRIVATE LIMITED",
"RAJESH RAYON SILK MILLS LIMITED",
"RAJESH REAL ESTATE DEVELOPERS PRIVATE LIMITED",
"RAJESH ROADLINES PRIVATE LIMITED",
"RAJESH SALES AND TOOLS PRIVATE LIMITED",
"RAJESH SILVER PRIVATE LIMITED",
"RAJESH SOLVEX LIMITED",
"RAJESH STEEL (INDIA) PRIVATE LIMITED",
"RAJESH TEXTILES PRIVATE LIMITED",
"RAJESH TRAVELS PRIVATE LIMITED",
"RAJESHAHI FOODS AND HOSPITALITY PRIVATE LIMITED",
"RAJESHRAJ TRADERS PRIVATE LIMITED",
"RAJESHREE ROPES PRIVATE LIMITED",
"RAJESHRI SHAHU MAHARAJ MADHYAMIK VIDHYALAY",
"RAJESHWAR LAND DEVELOPERS PRIVATE LIMITED",
"RAJESHWARA FORGINGS PRIVATE LIMITED RFPL",
"RAJESHWARI AASHIRVAD INFRA PROJECTS PRIVATE LIMITED",
"RAJESHWARI AGRO EXTRACTS INDIA PRIVATE LIMITED",
"RAJESHWARI CANS LIMITED",
"RAJESHWARI COTSPIN LIMITED",
"RAJESHWARI DYE-CHEM PRIVATE LIMITED",
"RAJESHWARI INDUSTRIES PRIVATE LIMITED",
"RAJESHWARI INFOTEL PRIVATE LIMITED",
"RAJESHWARI PETROCHEM PRIVATE LIMITED",
"RAJESHWARI ROLLER FLOUR MILLS PRIVATE LIMITED",
"RAJESHWARI STEELS PRIVATE LIMITED",
"RAJESWARI PLASTICS PVT LTD",
"RAJESWARI VINTRADE PRIVATE LIMITED",
"RAJGAD TRADING CO PVT LTD",
"RAJGADHIA INDUSTRIES PRIVATE LIMITED",
"RAJGANGA AGRO PRODUCT PRIVATE LIMITED",
"RAJGANGA BIOREFINERIES PRIVATE LIMITED",
"RAJGANJ COKE PRODUCTS PRIVATE LIMITED",
"RAJGARH INDUSTRIES PRIVATE LIMITED",
"RAJGARH STEEL PRIVATE LIMITED",
"RAJGARH TRANSMISSION LIMITED",
"RAJGARHIA FOOD PRODUCTS PRIVATE LIMITED",
"RAJGARHIA LEASING AND FINANCIAL SERVICES PVT. LTD.",
"RAJGARIA BROTHERS PRIVATE LIMITED",
"RAJGARIA JEWELLERS PRIVATE LIMITED",
"RAJGARIA TIMBER PRIVATE. LIMITED.",
"RAJGAUR STEELS PRIVATE LIMITED",
"RAJGIAN AESTHIUS LLP",
"RAJGIRIJA INDUSTRIES PRIVATE LIMITED",
"KANSAL MEDICO",
"RAJGOBIND NURSING HOME",
"RAJGOPAL FABS PRIVATE LIMITED",
"RAJGOR CASTOR DERIVATIVES LIMITED",
"RAJGOR PROTEINS LIMITED",
"RAJGRAHI BUILDCON PRIVATE LIMITED",
"RAJGREEN AMUSEMENT PARK PRIVATE LIMITED",
"RAJGREEN HOSPITALITY LIMITED",
"RAJGRIHI SINGH CONSTRUCTIONS PRIVATE LIMITED",
"RAJGUL SECURITIES PRIVATE LIMITED",
"RAJGURU ADHESIVE TAPE COMPANY PRIVATE LIMITED",
"RAJGURU CREATIONS PRIVATE LIMITED",
"RAJGURU DEVELOPERS PRIVATE LIMITED",
"RAJGURU ELECTRONICS (I) PRIVATE LIMITED",
"RAJGURU ENTERPRISES PRIVATE LIMITED",
"RAJGURU PACKINGS PRIVATE LIMITED",
"RAJGURU SOLUTIONS PRIVATE LIMITED",
"RAJGURU'S DELIGHT NUTS FOODS PRIVATE LIMITED",
"RAJHANS AGRO CHEMICAL INDUSTRIES PRIVATE LIMITED",
"RAJHANS AGROTECH PRIVATE LIMITED",
"RAJHANS AUTOMOBILES PRIVATE LIMITED",
"RAJHANS CINE WORLD PRIVATE LIMITED",
"RAJHANS COLD STORAGE PRIVATE LIMITED",
"RAJHANS CONSULTANTS AND TECHNOCRATS PRIVATE LIMITED",
"RAJHANS ENTERPRISE",
"RAJHANS FABRICATION PRIVATE LIMITED",
"RAJHANS FERROUS SCRAP TRADE PRIVATE LIMITED",
"RAJHANS FERTILIZERS LIMITED",
"RAJHANS IMPEX PRIVATE LIMITED",
"RAJHANS INFRACON INDIA PRIVATE LIMITED",
"RAJHANS INFRATECH PRIVATE LIMITED",
"RAJHANS MARMO AND MINES PVT LTD",
"RAJHANS METALS PVT LTD",
"RAJHANS NUTRIMENTS PRIVATE LIMITED",
"RAJHANS PARIVAHAN PRIVATE LIMITED",
"RAJHANS PLASTIC MACHINERY PRIVATE LIMITED",
"RAJHANS POLY-PRINTS PRIVATE LIMITED",
"RAJHANS PRAKASHAN PRIVATE LIMITED",
"RAJHANS PRESSINGS PRIVATE LIMITED",
"RAJHANS PRIME CINEMA",
"RAJHANS ROADLINES PVT LTD",
"RAJHANS SILK MILLS PRIVATE LIMITED",
"RAJHANS TILES PRIVATE LIMITED",
"RAJHARI CARRIERS AND FINANCE PRIVATE LIMITED",
"RAJHARI FOODS PRIVATE LIMITED",
"RAJHARSH ARIHAANT FINDINGS PRIVATE LIMITED",
"RAJHARSH CONSTRUCTION",
"RAJINDER INFRASTRUCTURE PRIVATE LIMITED",
"RAJINDER PAUL SOOD AND SONS PRIVATE LIMITED",
"RAJINDERA CASTING PRIVATE LIMITED",
"RAJINDRA BUS SERVICE PRIVATE LIMITED",
"RAJINDRA CERAMICS PRIVATE LIMITED",
"RAJINDRA FORGE PVT LTD",
"RAJINDRA HANDLOOM PRIVATE LIMITED",
"RAJINDRA SERVICES PRIVATE LTD",
"RAJINDRA TWO WHEELERS PRIVATE LIMITED",
"RAJIRAJ MINERALS PRIVATE LIMITED",
"RAJITA CLEARING AGENCIES PRIVATE LIMITED",
"RAJIV ACADEMY FOR TECHNOLOGY & MANAGEMENT",
"RAJIV AUTOMOBILES PRIVATE LIMITED",
"RAJIV CHOWK-SOHNA HIGHWAY PRIVATE LIMITED",
"RAJIV COMMERCIAL PRIVATE LIMITED",
"RAJIV CREATION PRIVATE LIMITED",
"RAJIV DUBEY DEVELOPERS PRIVATE LIMITED",
"RAJIV GANDHI CANCER HOSPITAL",
"RAJIV GANDHI CANCER INSTITUTE AND RESEARCH CENTRE",
"RAJIV GANDHI COLLEGE OF ENGINEERING",
"RAJIV GANDHI COLLEGE OF PHARMACY",
"RAJIV GANDHI GOVT HOSPITAL",
"RAJIV GANDHI MISSION FOR WATERSHED",
"RAJIV GANDHI NATIONAL INSTITUTE OF INTELLECTUAL PROPERTY MANAGEMENT",
"RAJIV GANDHI PROUDYOGIKI VISHWA VIDYALAYA",
"RAJIV GANDHI UNIVERSITY OF KNOWLEDGE TECHNOLOGIES",
"RAJIV GANDHI VIDYALAY",
"RAJIV INTERNATIONAL SCHOOL",
"RAJIV LOCHAN RICE MILLS PVT LTD",
"RAJIV MACHINES PRIVATE LIMITED",
"RAJIV MOTORS PRIVATE LIMITED",
"RAJIV PETROCHEMICALS PVT LTD",
"RAJIV PHYLON PRIVATE LIMITED",
"RAJIV PLASTIC INDUSTRIES",
"RAJIV PLASTICS PRIVATE LIMITED",
"RAJIV SYNDICATE AUTOZONE PRIVATE LIMITED",
"RAJIV TECHNO-ENGINEERING PRIVATE LIMITED",
"RAJKA REALTY PRIVATE LIMITED",
"RAJKAJ SERVICES PRIVATE LIMITED",
"RAJKALA INDUSTRIES PRIVATE LIMITED",
"RAJKALI INDUSTRIES LIMITED",
"RAJKALP MUDRANALAYA PRIVATE LIMITED",
"RAJKALPANA TRAVELS PRIVATE LIMITED",
"RAJKAMAL BAR-SCAN SYSTEMS PRIVATE LIMITED",
"RAJKAMAL BUILDERS INFRASTRUCTURE PRIVATE LIMITED",
"RAJKAMAL CLOTHING & PROCESSING (INDIA) PRIVATE LIMITED",
"RAJKAMAL INDUSTRIAL PRIVATE LIMITED",
"RAJKAMAL KALAMANDIR PRIVATE LIMITED",
"RAJKAMAL LIQUORS PRIVATE LIMITED",
"RAJKAMAL MARBLES PRIVATE LIMITED",
"RAJKAMAL NAMKEENS PRIVATE LIMITED",
"RAJKAMAL PLYWOOD INDIA PVT. LTD.",
"RAJKAMAL POLY PRINT PRIVATE LIMITED",
"RAJKAMAL SHAH AND COMPANY",
"RAJKARAN AGRO PRIVATE LIMITED",
"RAJKESARI PAPERS PRIVATE LIMITED",
"RAJKESHARIPROJECTS LIMITED",
"RAJKIRAN FASHIONS PRIVATE LIMITED",
"RAJKIRAN PRINCE RESTAURANT PRIVATE LIMITED",
"RAJKIYA AASHRAM PADHAYATI VIDYALAYA JHANSI",
"RAJKIYA ASHRAM PADATTI VIDHYALYA",
"RAJKIYA AUDYOGIK PRASHIKSHAN SANSTHAN UNNAO",
"RAJKIYA BALIKA INTER COLLEGE",
"RAJKIYA HIGH SCHOOL SEER JAILAL SAMRER BUDAUN BAREILLY",
"RAJKIYA INTER COLLEGE SCHOOL",
"RAJKIYA MAHILLA MAHAVIDYALAYA KOTA SAHARANPUR",
"RAJKIYA UDOYOGIC TRANNING CENTER ALIGARH",
"RAJKOT (GUJARAT) SOLAR ENERGY PRIVATE LIMITED",
"RAJKOT BUILDWELL PRIVATE LIMITED",
"RAJKOT COKE SUPPLIES PRIVATE LIMITED",
"RAJKOT DISTRICT CO OPERATIVE MILK PRODUCERS UNION LIMITED",
"RAJKOT GOLDEN LOGISTICS PRIVATE LIMITED",
"RAJKOT IRRIGATION CIRCLE",
"RAJKOT MUNCIPAL COPORATION",
"RAJKOT NAGARIK SAHAKARI BANK LTD",
"RAJKOT OILCAKE PRIVATE LIMITED",
"RAJKOT PEOPLES CO-OPERATIVE BANK LTD",
"RAJKOT POWERTRANS PRIVATE LIMITED",
"RAJKOT RAJPATH LIMITED",
"RAJKOT SMART CITY DEVELOPMENT LIMITED",
"RAJKOTIA MEDICARE PRIVATE LIMITED",
"RAJKRIPAL LUMBERS LIMITED",
"RAJKRIPAL TIMBER INDUSTRIES PRIVATE LIMITED",
"RAJKRISHNA ADITYA AUTO STORE PRIVATE LIMITED",
"RAJKRISHNA INSURANCE BROKER PRIVATE LIMITED",
"RAJKRUPA TEXTILES (INDIA) PRIVATE LIMITED",
"RAJKUAMAR KEWALRAMANI GIRLS -WOMENS COLL",
"RAJKUL CHIKITSA PRIVATE LIMITED",
"RAJKUMAR AUTOMOBILES SALES PRIVATE LIMITED",
"RAJKUMAR DYEING AND PRINTING WORKS PRIVATE LIMITED",
"RAJKUMAR HIRANI FILMS PRIVATE LIMITED",
"RAJKUMAR JEWELLERS PRIVATE LIMITED",
"RAJKUMAR KEWALRAMANI KANYA MAHAVIDYALAYA",
"RAJKUMAR METAL ROLLING MILL PVT LTD",
"RAJKUMAR OFFSET PRINTERS PRIVATE LIMITED",
"RAJKUMAR THEATRES PRIVATE LIMITED",
"RAJLAKSHMI BUILDCON LIMITED",
"RAJLAKSHMI ISPAT PVT. LTD.",
"RAJLAKSHMI JEWELLERS GOLD PRIVATE LIMITED",
"RAJLAKSHMI MARKETING PRIVATE LIMITED",
"RAJLAKSHMI MINERALS",
"RAJLAKSHMI PAPER & BOARDS PRIVATE LIMITED",
"RAJLAKSHMI SAREE PVT LTD",
"RAJLAXAMI DEVBUILD INDIA PRIVATE LIMITED",
"RAJLAXMI AGRO FOOD PRODUCT PRIVATE LIMITED",
"RAJLAXMI AGRO PROCESSOR PRIVATE LIMITED",
"RAJLAXMI AGROTECH INDIA PRIVATE LIMITED",
"RAJLAXMI CHEMTECH (INDIA) PRIVATE LIMITED",
"RAJLAXMI CONSTRUCTIONS LIMITED",
"RAJLAXMI GRIHA NIRMAN PRIVATE LIMITED",
"RAJLAXMI HOME PRODUCTS PRIVATE LIMITED",
"RAJLAXMI HYDRAULICS & ENGINEERING PRIVATE LIMITED",
"RAJLAXMI JEWELLERS PRIVATE LIMITED",
"RAJLAXMI METALS PRIVATE LIMITED",
"RAJLAXMI OVERSEAS PRIVATE LIMITED",
"RAJLAXMI PLYWOOD PRIVATE LIMITED",
"RAJLAXMI ROADLINES PRIVATE LIMITED",
"RAJLAXMI SOLUTION PRIVATE LIMITED",
"RAJLAXMI SOLUTIONS PRIVATE LIMITED",
"RAJLAXMI SYNCOTEX PRIVATE LIMITED",
"RAJLAXMI TEXTILES (INDIA) PRIVATE LIMITED",
"RAJLAXMI URBAN CO OP BANK LTD",
"RAJLAXMI WHITE MARBLES PRIVATE LIMITED",
"RAJMAHAL COAL MINING LIMITED",
"RAJMAHAL SILKS AND TEXTILES PRIVATE LIMITED",
"RAJMAITHILI MILK AND MILK PRODUCT LLP",
"RAJMAN OVERSEAS PRIVATE LIMITED",
"RAJMANDIR ELECTRONICS PRIVATE LIMITED",
"RAJMANDIR JEWELS PRIVATE LIMITED",
"RAJMANI CASTINGS PRIVATE LIMITED",
"RAJMANI JEWELS PRIVATE LIMITED",
"RAJMATA DEALERS PRIVATE LIMITED",
"RAJMATA ENGINEERING PRIVATE LIMITED",
"RAJMATA GULABKUNVERBA EDUCATION FOUNDATION TRUST",
"RAJMATA JIJAAU ROAD NIRMITI PRIVATE LIMITED",
"RAJMATA JIJAMATA VIDYALAYA LATUR",
"RAJMATA JIJAU SHIKSHAN PRASARAK MANDAL",
"RAJMATA KRISHNA KUMARI GIRLS PUBLIC SCHOOL",
"RAJMATA NURSING SCHOOL",
"RAJMATA REALTORS PRIVATE LIMITED",
"RAJMEEN PHOTO GALLERY PRIVATE LIMITED",
"RAJMERU MINERALS PRIVATE LIMITED",
"RAJMITA CORPORATE SERVICES PRIVATE LIMITED",
"RAJMOTI METALS PRIVATE LIMITED",
"RAJMUDRA GOLD AND FOREX PRIVATE LIMITED",
"RAJMUDRA INDUSTRIAL SERVICES PRIVATE LIMITED",
"RAJMUDRA PRAKASHAN PVT LTD",
"RAJMUDRA REAL ESTATE PRIVATE LIMITED",
"RAJNANDINI METAL LIMITED",
"RAJNANDITA MILK & FOODS PRIVATE LIMITED",
"RAJNAP TECHNOSOFT PRIVATE LIMITED",
"RAJNAR FACILITIES PRIVATE LIMITED",
"RAJNEE AGROILS LTD.",
"RAJNEER ENVITECH PRIVATE LIMITED",
"RAJNEESH BROTHERS VENTURES & BUILDERS PRIVATE LIMITED",
"RAJNI CHEMICAL INDUSTRIES PRIVATE LIMITED",
"RAJNI ENGINEERS AND SERVICES PRIVATE LIMITED",
"RAJNI HOSPITALS PRIVATE LIMITED",
"RAJNI INNOCHEM PRIVATE LIMITED",
"RAJNI PRINTS PRIVATE LIMITED",
"RAJNI SILK MILLS PRIVATE LIMITED",
"RAJNIGANDHA CABLES PRIVATE. LIMITED",
"RAJNIGANDHA MARBLES PRIVATE LIMITED",
"RAJNIGANDHA PROPERTIES LIMITED",
"RAJNIGANDHA VINIMAY PRIVATE LIMITED",
"RAJNIR ENTERPRISES PRIVATE LIMITED",
"RAJNISH CONSULTANCY PRIVATE LIMITED",
"RAJNISH INDUSTRIES PRIVATE LIMITED",
"RAJNISH INFRATECH (OPC) PRIVATE LIMITED",
"RAJNISH STEELS",
"RAJNISH WELLNESS LIMITED",
"RAJO MOTORS PRIVATE LIMITED",
"RAJOKRI INVESTMENT AND TRADING COMPANY PRIVATE LIMITED",
"RAJOO BAUSANO EXTRUSION PRIVATE LIMITED",
"RAJOO ENGINEERS LIMITED",
"RAJPAL ABHIKARAN (BHOPAL) PRIVATE LIMITED",
"RAJPAL AGENCIES PRIVATE LIMITED",
"RAJPAL AGRICULTURAL MACHINERY PRIVATE LIMITED",
"RAJPAL BROTHERS ELECTRONICS PRIVATE LIMITED",
"RAJPAL LIQUID CARGO MOVERS PRIVATE LIMITED",
"RAJPAL MARKETING PRIVATE LIMITED",
"RAJPAL PEB STRUCTURE PRIVATE LIMITED",
"RAJPARA PRIMARY SCHOOL",
"RAJPARIS CIVIL CONSTRUCTIONS PRIVATE LIMITED",
"RAJPATH CLUB LIMITED",
"RAJPOOT BEST DEALS PRIVATE LIMITED",
"RAJPRABHA DEVELOPERS PRIVITE LIMITED",
"RAJPRABHU TRADERS PRIVATE LIMITED",
"RAJPROTIM LOGISTICS PRIVATE LIMITED",
"RAJPROTIM SUPPLY CHAIN SOLUTIONS LIMITED",
"RAJPUR HIRPUR GEN HOSPITAL E S I SCHEME",
"RAJPUR HIRPUR GENERAL HOSPITAL",
"RAJPUR SONARPUR MUNICIPALITY",
"RAJPUR VIDYANIDHI HIGH SCHOOL",
"RAJPUROHIT INDUSTRIES PRIVATE LIMITED",
"RAJPUROHIT PROFILES PRIVATE LIMITED",
"RAJPUROHIT SYSTEMATIX PRIVATE LIMITED",
"RAJPUROHIT TECHNOSOLUTIONS PRIVATE LIMITED",
"RAJPUT ENTERPRISES PRIVATE LIMITED",
"RAJPUT HOTEL AND RESORTS PRIVATE LIMITED",
"RAJPUT LEASING AND FINANCE LIMITED",
"RAJPUT NETWORK",
"RAJPUT PROTECTION SERVICE PRIVATE LIMITED",
"RAJPUT ROLLER FLOUR MILLS LIMITED",
"RAJPUT ROLLING MILLS PRIVATE LIMITED",
"RAJPUTANA BIODIESEL PRIVATE LIMITED",
"RAJPUTANA CABLES AND CONDUCTORS PRIVATE LIMITED",
"RAJPUTANA CERAMICS (INDIA) PRIVATE LIMITED",
"RAJPUTANA CONSTRUCTIONS PRIVATE LIMITED",
"RAJPUTANA DEVELOPERS LIMITED",
"RAJPUTANA FABRICS PVT LTD",
"RAJPUTANA FERTILIZERS LIMITED",
"RAJPUTANA HOSPITAL AND RESEARCH CENTRE PVT. LTD",
"RAJPUTANA INDUSTRIES LIMITED",
"RAJPUTANA INDUSTRIES PRIVATE LIMITED",
"RAJPUTANA INVESTMENT & FINANCE LTD",
"RAJPUTANA LEISURE TOURS OPC PRIVATE LIMITED",
"RAJPUTANA P G COLLEGE",
"RAJPUTANA SMART SOLUTIONS LIMITED",
"RAJPUTANA STAINLESS LIMITED",
"RAJPUTANA VEHICLES PRIVATE LIMITED",
"RAJPUTANA WORKFORCE MANAGEMENT PRIVATE LIMITED",
"RAJRA INTERNATIONAL PRIVATE LIMITED",
"RAJRADHE FINANCE LIMITED",
"RAJRAJESHWAR COTEX PRIVATE LIMITED",
"RAJRAJESHWARI SPICE FOODS LIMITED",
"RAJRAJESWAR COLD STORAGE PVT LTD",
"RAJRAJESWAR RICE MILLS PVT LTD",
"RAJRANI COLD STORAGE AND ICE PLANT PRIVATE LIMITED",
"RAJRANI CONSULTANTS PRIVATE LIMITED",
"RAJRANI STEEL CASTING PRIVATE LIMITED",
"RAJRATAN AROMATICS PRIVATE LIMITED",
"RAJRATAN GLOBAL WIRE LIMITED",
"RAJRATAN INDUSTRIES PRIVATE LIMITED",
"RAJRATAN INVESTMENTS PRIVATE LIMITED",
"RAJRATAN TRADE-LINK PRIVATE LIMITED",
"RAJRATNA CHIT FUND PRIVATE LIMITED",
"RAJRATNA HOLDINGS PRIVATE LIMITED",
"RAJRATNA POLYMERS PRIVATE LIMITED",
"RAJREVATHI TEXTILES INDIA PRIVATE LIMITED",
"RAJRISHI FREIGHT LINES PRIVATE LIMITED",
"RAJRISHI METALS PRIVATE LIMITED",
"RAJRUDRA ENTERPRISES PRIVATE LIMITED",
"RAJRUSHI WEALTH CREATORS LIMITED",
"RAJSADAN OVERSEAS SALES PRIVATE LIMITED",
"RAJSAGAR STEEL PRIVATE LIMITED",
"RAJSAHI MASALA PRIVATE LIMITED",
"RAJSAHI SPICES PRIVATE LIMITED",
"RAJSAMADHIYALA SPINTEX PRIVATE LIMITED",
"RAJSATI INDUSTRIES PRIVATE LIMITED",
"RAJSAV INDIA PRIVATE LIMITED",
"RAJSCAPE HOTELS PRIVATE LIMITED",
"RAJSCAPE RESORTS PRIVATE LIMITED",
"RAJSEE INTERNATIONAL PVT LTD",
"RAJSEVA ENTERPRISES PRIVATE LIMITED",
"RAJSHA CHEMICALS PRIVATE LIMITED",
"RAJSHA ORGANICS PRIVATE LIMITED",
"RAJSHAAHI FOODS PRIVATE LIMITED",
"RAJSHAHI BANIJYA PRIVATE LIMITED",
"RAJSHANTI METALS PRIVATE LIMITED",
"RAJSHEKAR MULTI SPECIALITY HOSPITAL PRIVATE LIMITED",
"RAJSHEKHAR CONSTRUCTIONS PRIVATE LIMITED",
"RAJSHI CONSTRUCTIONS PRIVATE LIMITED",
"RAJSHI FARMA PRIVATE LIMITED",
"RAJSHI TECHNOLOGIES INDIA PRIVATE LIMITED",
"RAJSHIL PAPERS PRIVATE LIMITED",
"RAJSHILA SYNTHETICS PRIVATE LIMITED",
"RAJSHREE AGRO FOODS PRIVATE LIMITED",
"RAJSHREE BIOWARES PRIVATE LIMITED",
"RAJSHREE BUSSINNESS PRIVATE LIMITED",
"RAJSHREE COMMERCIAL & INDUSTRIAL CO. PRIVATE. LIMITED.",
"RAJSHREE COTTON WORLD PRIVATE LIMITED",
"RAJSHREE CREATIONS PRIVATE LIMITED",
"RAJSHREE DESIGNER FABRIC PRIVATE LIMITED",
"RAJSHREE DEVELOPER ENTERPRENURES PVT. LTD.",
"RAJSHREE DISTRIBUTION AGENCIES PRIVATE LIMITED",
"RAJSHREE DYEING AND PRINTING MILLS PRIVATE LIMITED",
"RAJSHREE EDUCATIONAL TRUST",
"RAJSHREE ENGINEERING PRIVATE LIMITED",
"RAJSHREE ENTERPRISES PVT LTD",
"RAJSHREE FAB TEX PRIVATE LIMITED",
"RAJSHREE FINE CHEMICAL INDUSTRIES INDIA PRIVATE LIMITED",
"RAJSHREE FMCG DISTRIBUTORS PRIVATE LIMITED",
"RAJSHREE FOUNDATIONS LIMITED",
"RAJSHREE GEMS & JEWELS PRIVATE LIMITED",
"RAJSHREE GLOBAL PRIVATE LIMITED",
"RAJSHREE HATCHERY FEEDS PRIVATE LIMITED",
"RAJSHREE HOSPITALS PRIVATE LIMITED",
"RAJSHREE INEXIM PRIVATE LIMITED",
"RAJSHREE INNOVATIONS PRIVATE LIMITED",
"RAJSHREE ISPAT INDIA PVT LTD",
"RAJSHREE MECHANICAL UDYOG PVT LTD",
"RAJSHREE MINING PRIVATE LIMITED",
"RAJSHREE NARSINGH HOME",
"RAJSHREE OVERSEAS PVT LTD",
"RAJSHREE POLYPACK LIMITED",
"RAJSHREE REFICHEM PRIVATE LIMITED",
"RAJSHREE ROLLER FLOUR MILL PRIVATE LIMITED",
"RAJSHREE SILK MILLS PRIVATE LIMITED",
"RAJSHREE SUGARS & CHEMICALS LIMITED",
"RAJSHREE TECHNOPLAST PRIVATE LIMITED",
"RAJSHRI ENTERTAINMENT PRIVATE LIMITED",
"RAJSHRI IRON INDUSTRIES PRIVATE LIMITED",
"RAJSHRI MEDIA PRIVATE LIMITED",
"RAJSHRI PICTURES PVT LTD",
"RAJSHRI RMC INFRABUILD PRIVATE LIMITED",
"RAJSHRUSTI INFRA PRIVATE LIMITED",
"RAJSHURI SAND SUPPLIERS PRIVATE LIMITED",
"RAJSON ENGINEERING SERVICES PRIVATE LIMITED",
"RAJSON HOTELS PRIVATE LIMITED",
"RAJSONIA CONSULTANCY SERVICES PRIVATE LIMITED",
"RAJSONS MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"RAJSONS PHARMA PRIVATE LIMITED",
"RAJSRIYA AUTOMOTIVE INDUSTRIES PRIVATE LIMITED",
"RAJSUBH STONES PRIVATE LIMITED",
"RAJTARU STUDIOS LIMITED",
"RAJTHARUN TEXTILES INDIA PRIVATE LIMITED",
"RAJTILAK IMPEX PRIVATE LIMITED",
"RAJTILAK MERCANTILE PRIVATE LIMITED",
"RAJTRISHUL CONSTRUCTION COMPANY PRIVATE LIMITED",
"RAJU BUSINESS ADVISORS PRIVATE LIMITED",
"RAJU CONTRACTORS PRIVATE LIMITED.",
"RAJU ENGINEERING WORKS PRIVATE LIMITED",
"RAJU GANDHIDENTAL COLLEGE",
"RAJU NEURO AND MULTI SPECIALITY HOSPITALS PRIVATE LIMITED",
"RAJU POOBATHY MEDICARE PRIVATE LIMITED",
"RAJU RETAILS PRIVATE LIMITED",
"RAJU SPINNING MILLS PRIVATE LIMITED",
"RAJU VEGESNA DEVELOPERS PRIVATE LIMITED",
"RAJU VEGESNA INFOTECH AND INDUSTRIES PRIVATE LIMITED",
"RAJUL BUILDERS",
"RAJUL GASES PRIVATE LIMITED",
"RAJUL LEASING PRIVATE LIMITED",
"RAJUL PROPERTIES PRIVATE LIMITED",
"RAJURESHWAR COTTEX PRIVATE LIMITED",
"RAJURESHWAR INFRASTRUCTURE PRIVATE LIMITED",
"RAJURESHWAR VIDYALAY AALAMGAON BADNAPUR JALNA",
"RAJURI STEELS & TMT BARS PRIVATE LIMITED",
"RAJURI STEELS AND ALLOYS INDIA PRIVATE LIMITED",
"RAJURI STEELS PRIVATE LIMITED",
"RAJVAIBHAV ENTERPRISES PRIVATE LIMITED",
"RAJVANSH AUTO WHEELS PRIVATE LIMITED",
"RAJVANSH ELECTRICALS PRIVATE LIMITED",
"RAJVANSH ESTATES PRIVATE LIMITED",
"RAJVANSH STEELS PRIVATE LIMITED",
"RAJVARDHAN AGENCIES PRIVATE LIMITED",
"RAJVEE ASSOCIATES",
"RAJVEE TRACTORS PRIVATE LIMITED",
"RAJVEEN BUILDERS PRIVATE LIMITED",
"RAJVEER FOOD MARKETING (INDIA) PRIVATE LIMITED",
"RAJVEER HEALTH SERVICES PRIVATE LIMITED",
"RAJVEER INFRACON PRIVATE LIMITED",
"RAJVEER INFRAMIN PRIVATE LIMITED",
"RAJVEER KNOWLEDGE FOUNDATION",
"RAJVEER LIFESTYLES PRIVATE LIMITED",
"RAJVEER LOGISTICS PRIVATE LIMITED",
"RAJVEER PAPER MILL PRIVATE LIMITED",
"RAJVI BIOTECH PRIVATE LIMITED",
"RAJVI CARGO MOVERS PRIVATE LIMITED",
"RAJVI CHEMICAL CORPORATION LLP",
"RAJVI ENTERPRISE PRIVATE LIMITED",
"RAJVI ESTATE LLP",
"RAJVI EXTRUSION PRIVATE LIMITED",
"RAJVI HOLDINGS PVT LTD",
"RAJVI INFRASTRUCTURE PRIVATE LIMITED",
"RAJVI LOGISTICS PRIVATE LIMITED",
"RAJVI LOGITRADE LIMITED",
"RAJVI RESORTS & HOTELS PRIVATE LIMITED",
"RAJVI STOCK BROKING PRIVATE LIMITED",
"RAJVIJAY ASSOCIATE PRIVATE LIMITED",
"RAJVIR & CO.",
"RAJVIR INFRADEVELOPERS PRIVATE LIMITED",
"RAJVIRAJ ENGINEERS AND CONTRACTORS PRIVATE LIMITED",
"RAJWADA BREWERIES AND BOTTLINGS PRIVATE LIMITED",
"RAJWADA MULTITRADE PRIVATE LIMITED",
"RAJWADI EMPORIUM INDIA PRIVATE LIMITED",
"RAJWADI FASHIONS CLOTHING PRIVATE LIMITED",
"RAJWADI MENS WEAR PRIVATE LIMITED",
"RAJWANI EXPORTS PRIVATE LIMITED",
"RAJWARDHAN HITECH CONSTRUCTION PRIVATE LIMITED",
"RAJWATI PAURUSH SHEETGRAH PRIVATE LIMITED",
"RAJYA KRISHI UTPADAN MANDI PARISHAD UTTAR PRADESH",
"RAJYA SABHA SECTT",
"RAJYA SIKSHA KENDRA M P",
"RAJYACOSH TREXIM PVT LTD",
"RAJYALAKSHMI COATED WIRES PRIVATE. LIMITED.",
"RAJYALAKSHMI HEALTHCARE PRIVATE LIMITED",
"RAJYAREKHA TRADE PVT. LTD.",
"RAJYASH JEWELLERS PRIVATE LIMITED",
"RAJYAVARDHAN VANIJYA PVT LTD",
"RAJYOG AUTO PRIVATE LIMITED",
"RAJYOG FOREX PRIVATE LIMITED",
"RAJYOG GRANITE IMPORT AND EXPORT PRIVATE LIMITED",
"RAJYOG INTERNATIONAL PRIVATE LIMITED",
"RAJYOG MINERALS PRIVATE LIMITED",
"RAJYOG POLYTECH PRIVATE LIMITED",
"RAK APPLIANCES PRIVATE LIMITED",
"RAK BUILDTECH SOLUTION PRIVATE LIMITED",
"RAK INTERNATIONAL PRIVATE LIMITED",
"RAK PROJECTS PRIVATE LIMITED",
"RAKA OIL COMPANY",
"RAKA REPUTATION MANAGEMENT SERVICES PRIVATE LIMITED",
"RAKE SEMICONDUCTORS PRIVATE LIMITED",
"RAKESH ADVERTISING PRIVATE LIMITED",
"RAKESH CHAPPAL STORE PRIVATE LIMITED",
"RAKESH CHEMICALS PRIVATE LIMITED",
"RAKESH CONSTRUCTION PRIVATE LIMITED",
"RAKESH CREDITS LIMITED",
"RAKESH EATABLES AND GENERAL PRODUCTS PRIVATE LIMITED",
"RAKESH FOOTWEARS PRIVATE LIMITED",
"RAKESH FUEL PVT. LTD.",
"RAKESH HEALTHCARE (INDIA) LIMITED",
"RAKESH KUMAR CHOUDHARY PRIVATE LIMITED",
"RAKESH KUMAR RAMESH CHANDRA CHEMICALS PRIVATE LIMITED",
"RAKESH LAMPS & COMPONENTS PRIVATE LIMITED",
"RAKESH LOGISTICS PRIVATE LIMITED",
"RAKESH MARKETING PRIVATE LIMITED",
"RAKESH MASALA PRIVATE LIMITED",
"RAKESH MINERALS PRIVATE LIMITED",
"RAKESH NANDAN CONSUMER PRODUCTS PRIVATE LIMITED",
"RAKESH OSWAL HOSIERY MILLS PRIVATE LIMITED",
"RAKESH PAPERS PRIVATE LIMITED",
"RAKESH SINGLA",
"RAKESH STEEL INDUSTRIES PVT.LTD.",
"RAKESH TECHNO PRIVATE LIMITED",
"RAKESH TRANSFORMER INDUSTRIES PVT LTD",
"RAKESH YADAV READERS PUBLICATION PRIVATE LIMITED",
"RAKESHRAJ TRADING PRIVATE LIMITED",
"RAKEZ RAS AL KHAIMAH ECONOMIC ZONE",
"RAKHECHA HOLDINGS PVT LTD",
"RAKHECHA SECURITIES LIMITED",
"RAKHEJA ENGINEERS PRIVATE LIMITED",
"RAKHI AGENCIES LIMITED",
"RAKHI FASHION PRIVATE LIMITED",
"RAKHI HOTELS PRIVATE LIMITED",
"RAKHI PRAKASHAN PRIVATE LIMITED",
"RAKHI TRANSPORTS PRIVATE LIMITED",
"RAKHOH INDUSTRIES PRIVATE. LIMITED.",
"RAKHRAJ FINVEST COMPANY PRIVATE LIMITED",
"RAKHUVA PUMPS PRIVATE LIMITED",
"RAKI AVENUES PRIVATE LIMITED",
"RAKIDEV ACCUTECH PRIVATE LIMITED",
"RAKINDO DEVELOPERS PRIVATE LIMITED",
"RAKINDO KOVAI TOWNSHIP LIMITED",
"RAKIRO BIOTECH SYSTEMS PRIVATE LIMITED",
"RAKO AGROCHEM PRIVATE LIMITED",
"RAKON INDIA PRIVATE LIMITED",
"RAK'S ACADEMY PRIVATE LIMITED",
"RAKS FOODS PRIVATE LIMITED",
"RAKS PALLIKKOODAM",
"RAKS PHARMA PRIVATE LIMITED",
"RAKSAN TRANSFORMERS PRIVATE LIMITED",
"RAKSH MINE CHEM PRIVATE LIMITED",
"RAKSHA CEMENTS PRIVATE LIMITED",
"RAKSHA ENTERTAINMENT PRIVATE LIMITED",
"RAKSHA FIRE AND SECURE SYSTEMS PRIVATE LIMITED",
"RAKSHA HEALTH INSURANCE TPA PRIVATE LIMITED",
"RAKSHA HOSPITAL",
"RAKSHA ISPAT PRIVATE LIMITED",
"RAKSHA KABACH DIAGNOSTICS PRIVATE LIMITED",
"RAKSHA MANAGEMENT AND PROTECTION SERVICES PRIVATE LIMITED",
"RAKSHA MULTISPECIALITY HOSPITAL PRIVATE LIMITED",
"RAKSHA PIPES PRIVATE LIMITED",
"RAKSHA POLYCOATS PRIVATE LIMITED",
"RAKSHA SALES PVT LTD",
"RAKSHA TECHNOLOGIES PRIVATE LIMITED",
"RAKSHAAM SEEDS PRIVATE LIMITED",
"RAKSHAK SECURITAS PRIVATE LIMITED",
"RAKSHAK SECURITY SERVICES AND SYSTEMS PRIVATE LIMITED",
"RAKSHAK SUBIDHA PRIVATE LIMITED",
"RAKSHAKSQUAD INDIA PRIVATE LIMITED",
"RAKSHI DEVELOPERS PRIVATE LIMITED",
"RAKSHIT BUILDCON PRIVATE LIMITED",
"RAKSHIT DRUGS PRIVATE LIMITED",
"RAKSHIT ENGINEERING WORKS PRIVATE. LIMITED",
"RAKSHIT INFRASTRUCTURE PROJECT PRIVATE LIMITED",
"RAKSHIT PACKAGING PRIVATE LIMITED",
"RAKSHIT PHARMACEUTICALS LIMITED",
"RAKSHITH HOSPITAL PRIVATE LIMITED",
"RAKSUL INDIA PRIVATE LIMITED",
"RAKSYS INDIA LLP",
"RAKUPA TECHNOLOGIES INDIA PRIVATE LIMITED",
"RAKUSHKA INTERNATIONAL PRIVATE LIMITED",
"RAKUTEN INDIA ENTERPRISE PRIVATE LIMITED",
"RAKUTEN INSIGHT INDIA PRIVATE LIMITED",
"RAKUTEN SYMPHONY INDIA PRIVATE LIMITED",
"RAL CONSUMER PRODUCTS LIMITED",
"RAL FOODS PRIVATE LIMITED",
"RAL IMPEX PRIVATE LIMITED",
"RAL NUTRALIFE PRIVATE LIMITED",
"RALAGO ENGINEERING PRIVATE LIMITED",
"RALCO EXTRUSION PRIVATE LIMITED",
"RALCO SYNERGY PRIVATE LIMITED",
"RALECON IT CONSULTING SERVICES PRIVATE LIMITED",
"RALF JEMS PRIVATE LIMITED",
"RALHAN CONSTRUCTION PRIVATE LIMITED",
"RALIN POLYMERS PRIVATE LIMITED",
"RALLI AGROTECH LIMITED",
"RALLIFAN LIMITED",
"RALLIS INDIA LIMITED",
"RALLI'S THERAPEUTICS PRIVATE LIMITED",
"RALLITH MEDISYSTEMS PRIVATE LIMITED",
"RALLIWOLF INDUSTRIES LIMITED",
"RALLY INFRA PRIVATE LIMITED",
"RALPH AGRI SCIENCE PRIVATE LIMITED",
"RALPH AGRO RASAYAN PRIVATE LIMITED",
"RALPH LAUREN CORPORATION",
"RALPH LAUREN SOURCING INDIA LLP",
"RALPH ROSE CATTLE FEEDS PRIVATE LIMITED",
"RALPH&DAS ADVERTISING PRIVATE LIMITED",
"RALPHS POLYMERS PRIVATE LIMITED",
"RALPRO INDUSTRIES PRIVATE LIMITED",
"RALSON (INDIA) LIMITED",
"RALSON INDIA LIMITED",
"RALSON PETROCHEMICALS LIMITED",
"RALSON REMEDIES PVT LTD",
"RALSON TYRES LIMITED",
"RALSONICS RESEARCH PRIVATE LIMITED",
"RALTECH PRECISION ENGINEERING PRIVATE LIMITED",
"RALTOR METAL TECHNIK INDIA PRIVATE LIMITED",
"RALTRONICS INDIA PRIVATE. LIMITED.",
"RAM AABHOSHAN",
"RAM BABU FOREX AND TRAVELS PRIVATE LIMITED",
"RAM BAN JEWELLERS PRIVATE LIMITED",
"RAM BHAWAN ESTATES PRIVATE LIMITED",
"RAM BUILDEV PRIVATE LIMITED",
"RAM CHAND AND SON COMPONENTS PRIVATE LIMITED",
"RAM CHANDER BUILDERS PRIVATE LIMITED",
"RAM CHANDRA COLD STORAGE PRIVATE LIMITED",
"RAM CHANDRA DAS & SON JEWELLERS PRIVATE LIMITED",
"RAM CHANDRA KRISHAN CHANDR SAREE STORES PRIVATE LIMITED",
"RAM CHARAN BANSAL CONSTRUCTION PRIVATE LIMITED",
"RAM CHARAN COMPANY PRIVATE LIMITED",
"RAM COOLERS PRIVATE LIMITED",
"RAM CORRUGATED BOXES PRIVATE LIMITED",
"RAM DARSHAN JEWELS LLP",
"RAM DARSHANI COLD STORAGE PRIVATE LIMITED",
"RAM DHAN MOHAN LAL AND COMPANY PRIVATE LIMITED",
"RAM DIGI MEDIAS PRIVATE LIMITED",
"RAM E AND I SYSTEMS P LTD",
"RAM EARTHMOVERS PRIVATE LIMITED",
"RAM EESH INTERNATIONAL SCHOOL",
"RAM ENGINEERS AND CONTRACTORS",
"RAM FABRICATORS PRIVATE LIMITED",
"RAM FASHION EXPORTS PRIVATE LIMITED",
"RAM FOODS PRODUCTS PRIVATE LIMITED",
"RAM GANGA TRANSPORT AGENCY PRIVATE LIMITED",
"RAM GENERAL STORE",
"RAM HANS EMBROIDERY PRIVATE LIMITED",
"RAM INFOSYS PRIVATE LIMITED",
"RAM IT SOLUTIONS PRIVATE LIMITED",
"RAM KARAN FLOUR MILL PRIVATE LIMITED",
"RAM KAY ENGINEERING COMPANY PRIVATE LIMITED",
"RAM KISHAN SHANKAR DASS AGRO PVT LTD",
"RAM KISHORE NAGARMAL MARKETING PRIVATE LIMITED",
"RAM KRIPAL SINGH CONSTRUCTION PRIVATE LIMITED",
"RAM KRISHNA HARI INFRAPROJECTS PRIVATE LIMITED",
"RAM KRISHNA NIKETAN PVT LTD",
"RAM KUMAR AGARWAL BUILDERS PRIVATE LIMITED",
"RAM KUMAR AGRAWAL ENGINEERS PRIVATE LIMITED",
"RAM KUMAR CONTRACTOR PRIVATE LIMITED",
"RAM KUMAR INDUSTRIES PRIVATE LIMITED",
"RAM KUMAR JEWELLERS PRIVATE LIMITED",
"RAM KUMAR NARWANI",
"RAM LAKHAN AGRI-FOODS PRIVATE LIMITED",
"RAM LAKHAN STEEL PRIVATE LIMITED",
"RAM LAKSHAN SS AUTO PRIVATE LIMITED",
"RAM LAL BOTHRA & SONS PRIVATE LIMITED",
"RAM LAL KUNDAN LAL ORTHOPEDIC HOSPITAL",
"RAM LAL RAM CHANDRA (INDIA) LIMITED",
"RAM MANOHAR LOHIA INSTITUTE OF MEDICAL SCIENCES",
"RAM MEHER INFRADEVELOPERS PRIVATE LIMITED",
"RAM METACOP PRIVATE LIMITED",
"RAM NARAYAN GARG SAFAWALA PRIVATE LIMITED",
"RAM NATH & COMPANY PRIVATE LIMITED",
"RAM NATH AGGARWAL BUILDERS PRIVATE LIMITED",
"RAM NIWAS BARS PRIVATE LIMITED",
"RAM NIWAS FLOUR MILLS PRIVATE LIMITED",
"RAM NIWAS SARAF PRIVATE LIMITED",
"RAM PAPER TUBES PRIVATE LIMITED",
"RAM PARKASH CONSTRUCTIONS PRIVATE LIMITED",
"RAM PARTAP LEHARI MAL PRIVATE LIMITED",
"RAM POTASH PRIVATE LIMITED",
"RAM PRAKASH SINGH BUILDERS PRIVATE LIMITED",
"RAM PRATAP DEVELOPERS PRIVATE LIMITED",
"RAM PRAVESH SINGH CONSTRUCTION PRIVATE LIMITED",
"RAM PROTINE OIL PRIVATE LIMITED",
"RAM RAGHU HEALTHCARE PRIVATE LIMITED",
"RAM RAJ SCIENCE INSTITUTE",
"RAM RATAN KASHI RAM PRIVATE LIMITED",
"RAM RATAN REAL ESTATE PRIVATE LIMITED",
"RAM RATNA ELECTRICALS LIMITED",
"RAM RATNA INFRASTRUCTURE PRIVATE LIMITED",
"RAM RATNA PRATHAMA PRESCHOOL",
"RAM RATNA VIDYA MANDIR",
"RAM RATNA WIRES LIMITED",
"RAM REFRIGERATION AND ELECTRONICS PRIVATE LIMITED",
"RAM RESORTS AND INDUSTRIES PRIVATE LIMITED",
"RAM SARAN FOOD PRODUCTS PRIVATE LIMITED",
"RAM SAROOP DEEPAK KUMAR RSDK",
"RAM SEWAK KANKANE HOSPITAL PRIVATE LIMITED",
"RAM SHYAM ENTERPRISES PRIVATE LIMITED",
"RAM SHYAM IRON PRIVATE LIMITED",
"RAM SHYAM TEX FAB PRIVATE LIMITED",
"RAM SUTAR ART CREATIONS PRIVATE LIMITED",
"RAM SUTAR FINE ARTS PRIVATE LIMITED",
"RAM SWAROOP ARUN KUMAR PRIVATE LIMITED",
"RAM TAHAL CHOURASIYA INFRASTRUCTURE PRIVATE LIMITED",
"RAM TECHROBOTS IT SERVICES PRIVATE LIMITED",
"RAM TEERATH COLLEGE OF PHARMACY",
"RAMA AUTO DEALERS PRIVATE LIMITED",
"RAMA BULLION PRIVATE LIMITED",
"RAMA CHEMICALS INDIA PRIVATE LIMITED",
"RAMA COAL WASHERIES PRIVATE LIMITED",
"RAMA COLLEGE OF NURSING",
"RAMA CONSTRUCTIONS COMPANY RCC",
"RAMA COTSPIN PRIVATE LIMITED",
"RAMA CYLINDERS PRIVATE LIMITED",
"RAMA DIGITAL SOLUTIONS (OPC) PRIVATE LIMITED",
"RAMA DISTRIBUTORS & TRADERS PRIVATE LIMITED",
"RAMA EDIBLE PRIVATE LIMITED",
"RAMA ENTERPRISES",
"RAMA EYE CARE CENTRE PRIVATE LIMITED",
"RAMA FERRO ALLOYS & FINANCE PVT LTD",
"RAMA FERTI-CHEM LIMITED",
"RAMA GROUP",
"RAMA GUM INDUSTRIES (INDIA) LIMITED",
"RAMA HITEK ENGINEERS PRIVATE LIMITED",
"RAMA HOSPITAL",
"RAMA IMPEX PRIVATE LIMITED",
"RAMA INDUSTRIES LIMITED",
"RAMA INFRAPROJECTS PRIVATE LIMITED",
"RAMA INVESTMENT CO PRIVATE LTD",
"RAMA KRISHNA BAKERS PRIVATE LIMITED",
"RAMA KRISHNA BUILDWELL PRIVATE LIMITED",
"RAMA KRISHNA CERAMICS PRIVATE LIMITED",
"RAMA KRISHNA OVERSEAS PRIVATE LIMITED",
"RAMA KRISHNA PACKAGING PRIVATE LIMITED",
"RAMA KRISHNA RICE MILL PRIVATE LIMITED.",
"RAMA KRISHNA RUBTECH PRIVATE LIMITED",
"RAMA LAXMI SHIRTING PRIVATE LIMITED",
"RAMA LIFE CARE",
"RAMA MARKETING ENTERPRISES",
"RAMA MEDICAL CARE CENTRE PRIVATE LIMITED",
"RAMA MEDICAL COLLEGE HOSPITAL & RESEARCH CENTRE",
"RAMA MEDICARES LIMITED.",
"RAMA MICRONS PRIVATE LIMITED",
"RAMA MOTOCORP PRIVATE LIMITED",
"RAMA MOTOR SALES & SERVICES PRIVATE LIMITED",
"RAMA MOTOR SERVICES PRIVATE.LIMITED",
"RAMA MOTORS PRIVATE LIMITED",
"RAMA NAND RADHEY SHYAM PRIVATE LIMITED",
"RAMA OVERSEAS LTD",
"RAMA PANELS PRIVATE LIMITED",
"RAMA PASHU AAHAR PRIVATE LIMITED",
"RAMA PHOSPHATES LIMITED",
"RAMA PLYWOOD PRIVATE LIMITED",
"RAMA POLYCON LIMITED",
"RAMA POLYMERS PRIVATE LIMITED",
"RAMA POLYTEX PRIVATE LIMITED",
"RAMA POLYTHREAD PRIVATE LIMITED",
"RAMA POWER AND STEEL PRIVATE LIMITED",
"RAMA PROPERTIES AND CAPITAL SERVICES PRIVATE LIMITED",
"RAMA PULSES PRIVATE LIMITED",
"RAMA REAL ESTATE PRIVATE LIMITED",
"RAMA RETROMARKS PRIVATE LIMITED",
"RAMA RHODIUM VICKY‚ÄôS",
"RAMA RICE & GEN. MILLS",
"RAMA SACKS N BAGS PRIVATE LIMITED",
"RAMA SANDESH DEVELOPERS PVT LTD",
"RAMA SHANKAR LAXMI NARAYAN EXPORTS PRIVATE LIMITED",
"RAMA SILK MILLS PVT LTD",
"RAMA SPACES",
"RAMA SPINNERS PRIVATE. LIMITED.",
"RAMA STEEL TUBES LIMITED",
"RAMA STEELTRADE PRIVATE LIMITED",
"RAMA STORES PRIVATE LIMITED",
"RAMA SUPER SPECIALTY HOSPITAL",
"RAMA TALENT SERVICES OPC PRIVATE LIMITED",
"RAMA TEA TECH PVT LTD",
"RAMA TECH INDIA PRIVATE LIMITED",
"RAMA TECH METALFAB PRIVATE LIMITED",
"RAMA TENT HOUSE PRIVATE LIMITED",
"RAMA TEX N TWIST PRIVATE LIMITED",
"RAMA TOURS AND TRAVELS PRIVATE LIMITED",
"RAMA UDYOG PRIVATE LIMITED",
"RAMA UNIVERSITY UTTAR PRADESH KANUR",
"RAMA VESSEL HANDLERS PRIVATE LIMITED",
"RAMA VINIMAY COAL PRIVATE LIMITED",
"RAMA VISION LIMITED",
"RAMA VYAPAAR PVT LTD",
"RAMA WINES",
"RAMA WOOD CRAFTS PRIVATE LIMITED",
"RAMAA INCUBATORS PRIVATE LIMITED",
"RAMAA SHYAMA PAPERS PRIVATE LIMITED",
"RAMABAI AMBEDKAR HIGH SCHOOL",
"RAMABAI AMBEDKAR KANYA VIDYALAYA NASHIK",
"RAMABANAM IIT JEE & NEET ACCADEMY",
"RAMABHADRA INDUSTRIES PRIVATE LIMITED",
"RAMAC TOOLS AND INSTRUMENTS PRIVATE LIMITED",
"RAMACHANDRA COLLEGE OF ENGINEERING",
"RAMACHANDRA CONSTRUCTIONS PRIVATE LIMITED",
"RAMACHANDRA HOSPITAL PRIVATE LIMITED",
"RAMACHANDRA MARKETING PRIVATE LIMITED",
"RAMACHANDRA PESTICIDES LIMITED",
"RAMACHANDRA POLYMERS PRIVATE LIMITED",
"RAMACHANDRA PROJECTS PRIVATE LIMITED",
"RAMACHANDRAN INTERNATIONAL INSTITUTE OF MANAGEMENT",
"RAMACHANDRAN RETAIL PRIVATE LIMITED",
"RAMACIVIL INDIA CONSTRUCTION PRIVATE LIMITED",
"RAMADA BY WYNDHAM GANDHIDHAM SHINAY",
"RAMADA CHENNAI EGMORE",
"RAMADA JALANDHAR CITY CENTRE",
"RAMADA POWAI",
"RAMADAN DATES PRIVATE LIMITED",
"RAMADAS MINERALS PRIVATE LIMITED",
"RAMADEVI CONSTRUCTION COMPANY PRIVATE LIMITED",
"RAMADEVI FOODS PRIVATE LIMITED",
"RAMADEVI MEDICAL CENTRE PRIVATE LIMITED",
"RAMADEVI READYMADE GARMENTS PRIVATE LIMITED",
"RAMADHANI AGRO PRODUCTS PRIVATE LIMITED",
"RAMAESIS REALTY PRIVATE LIMITED",
"RAMAGA TRADING PRIVATE LIMITED",
"RAMAGUNDAM FERTILIZERS AND CHEMICALS LIMITED",
"RAMAGYA SCHOOL NOIDA",
"RAMAI HIGH SCHOOL",
"RAMAIAH CAPITAL PRIVATE LIMITED",
"RAMAIAH UNIVERSITY OF APPLIED SCIENCES",
"RAMAJEE ISPAT PRIVATE LIMITED",
"RAMAJI MAHAJAN N P VIDALAYA",
"RAMAKANTH BRAND & MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"RAMAKRISHNA ¬†CARE HOSPITAL",
"RAMAKRISHNA AYURVEDIC COLLEGE",
"RAMAKRISHNA COMPONENTS MANUFACTURING PRIVATE LIMITED",
"RAMAKRISHNA CROP GENIC FARMS PRIVATE LIMITED",
"RAMAKRISHNA ELECTRO COMPONENTS PRIVATE LIMITED",
"RAMAKRISHNA HOSPITAL PRIVATE LIMITED",
"RAMAKRISHNA IMAGING AND PATHLABS PRIVATE LIMITED",
"RAMAKRISHNA INDUSTRIES",
"RAMAKRISHNA MISSION VIDYALAYA MATRIC HR SEC SCHOOL",
"RAMAKRISHNA MISSION VIVEKANANDA EDUCATIONAL AND RESEARCH INSTITUTE",
"RAMAKRISHNA PAPERS PRIVATE LIMITED",
"RAMAKRISHNA PHARMA PRIVATE LIMITED",
"RAMAKRISHNA POULTRY PRIVATE LIMITED",
"RAMAKRISHNA RESORTS PRIVATE LIMITED",
"RAMAKRISHNA SENIOR SECONDARY SCHOOL",
"RAMAKRISHNA TRAVELS AND TOURS PRIVATE LIMITED",
"RAMAL INDUSTRIES PRIVATE LIMITED",
"RAMALAYAM HOSPITAL",
"RAMALINGAM AGROPRODUCTS PRIVATE LIMITED",
"RAMALINGAM CONSTRUCTION COMPANY PRIVATE LIMITED",
"RAMAMANTRA INFRA AND AGROTECH PRIVATE LIMITED",
"RAMAMAR JEWELS PRIVATE LIMITED",
"RAMAMARUTHI MINCHEM INDUSTRIES PRIVATE LIMITED",
"RAMAN AGRO EXPORTS PRIVATE LIMITED",
"RAMAN AND WEIL PRIVATE LIMITED",
"RAMAN ANIL AND ASSOCIATES PRIVATE LIMITED",
"RAMAN CASTING PRIVATE LIMITED",
"RAMAN EDUCATION SOCIETY",
"RAMAN IMAGING AND DIAGNOSTIC PRIVATE LIMITED",
"RAMAN IMPEX PRIVATE LIMITED",
"RAMAN INSTRUMENTS PRIVATE LIMITED",
"RAMAN ROADWAYS PRIVATE LIMITED",
"RAMAN SAHA BUSINESS PRIVATE LIMITED",
"RAMAN SINGH CONSTRUCTION PRIVATE LIMITED",
"RAMAN SYSTEMS PRIVATE LIMITED",
"RAMAN TEX FAB PRIVATE LIMITED",
"RAMAN THERMOSETS PRIVATE LIMITED",
"RAMANA HOSPITAL PRIVATE LIMITED",
"RAMANA SAFETY AND SYSTEMS INDIA LIMITED",
"RAMANAGARAM ENTERPRISES PRIVATE LIMITED",
"RAMANAND ARYA D A V COLLAGE",
"RAMANAND ENTERPRISES INDIA PRIVATE LIMITED",
"RAMANAND HEALTH CARE PRIVATE LIMITED",
"RAMANAND POWER SYSTEMS PRIVATE LIMITED",
"RAMANARAYANA EDUCATION TRUST",
"RAMANCHI FOODS PRIVATE LIMITED",
"RAMANEEYA INFRA PROJECTS PRIVATE LIMITED",
"RAMANI AUTOMOBILE PRIVATE LIMITED",
"RAMANI CARS PRIVATE LIMITED",
"RAMANI ICE CREAM CO.LIMITED",
"RAMANI MOTORS PRIVATE LIMITED",
"RAMANI PRECISION MACHINES PRIVATE LIMITED",
"RAMANIYAM REAL ESTATES P LIMITED",
"RAMANJANEYA MODERN RICE MILL",
"RAMANJANEYA PROPERTIES PRIVATE LIMITED",
"RAMANLAL KUNVARJI COLLEGE OF COMMERCE AND MANAGEMENT",
"RAMANS HEALTHCARE AND DIAGNOSTICS PRIVATE LIMITED",
"RAMANUJ MARKETING AND WAREHOUSING PRIVATE LIMITED",
"RAMANUJ POWER CONTROLS PRIVATE LIMITED",
"RAMANUJ SYNTHETICS PRIVATE LIMITED",
"RAMANUJAM SUPPLY AND MARKETING PRIVATE LIMITED",
"RAMANUJAN PUBLIC SCHOOL",
"RAMAPATI SAREES PRIVATE LIMITED",
"RAMAPURA VEERA BHADRAIAH POOJA LOKA PRIVATE LIMITED",
"RAMARAJU CONVENTION CENTRE",
"RAMARANI HIGHER SECONDARY SCHOOL OF SCIENCE & TECHNOLOGY",
"RAMARANJAN DEVELOPERS PRIVATE LIMITED",
"RAMARAO CARGO LINES PRIVATE LIMITED",
"RAMARAPU MARKETING PRIVATE LIMITED",
"RAMASA CRANES PRIVATE LIMITED",
"RAMASETU BRIX",
"RAMASHARY PHARMA MACHINERY PRIVATE LIMITED",
"RAMASHRAYA INDUSTRIES PRIVATE LIMITED",
"RAMASHREE WAFERS PRIVATE LIMITED",
"RAMASIGNS INDUSTRIES LIMITED",
"RAMASS INTERNATIONAL PRIVATE LIMITED",
"RAMASTHA FUTURE INDIA PRIVATE LIMITED",
"RAMATIRTH POLYPACKS PRODUCTS PRIVATE LIMITED",
"RAMAVARI POWER PRIVATE LIMITED",
"RAMAWAT CONSTRUCTION PRIVATE LIMITED",
"RAMAWAT INFRAPROJECTS PRIVATE LIMITED",
"RAMAWATAR AGRAWAL ROAD CONSTRUCTION PRIVATE. LIMITED.",
"RAMAWATAR BANSAL STEELS PRIVATE LIMITED",
"RAMAYA HERBALS AND COSMETICS PRIVATE LIMITED",
"RAMAYAN INFRACONSTRUCTION PRIVATE LIMITED",
"RAMAYANA REALTORS PRIVATE LIMITED",
"RAMAYNA ISPAT PRIVATE LIMITED",
"RAMBAGH PALACE HOTAL PRIVATE. LIMITED",
"RAMBAL LIMITED",
"RAMBAL MOULDERS P LTD",
"RAMBAL PRIVATE LIMITED",
"RAMBALRAAM CHAINSS PRIVATE LIMITED",
"RAMBARA TRADING PRIVATE LIMITED",
"RAMBARAN SINGH APEX PRIVATE LIMITED",
"RAMBERT SYSTEM ENGINEERS PRIVATE LIMITED",
"RAMBHA CONSTRUCTION PRIVATE LIMITED",
"RAMBHABEN DAMODAR FOOD GRAINS PRIVATE LIMITED",
"RAMBHADEEP BUILDCON PRIVATE LIMITED",
"RAMBHAGAT LAXMINARAYAN JEWELLERS PRIVATE LIMITED",
"RAMBHANU RICE MILL PRIVATE LIMITED",
"RAMBHAU AGRO FARMERS PRODUCER COMPANY LIMITED",
"RAMBHIA HOTELS LIMITED",
"RAMBHIAS SUPER STORE LIMITED",
"RAMBLE INDIA TOUR & TRAVEL PRIVATE LIMITED",
"RAMBO CEMENT PRIVATE LIMITED",
"RAMBO EQUIPMENTS",
"RAMBOLL INDIA PRIVATE LIMITED",
"RAMBRAT SHARMA ELECTRIC WORKS PRIVATE LIMITED",
"RAMBUS CHIP TECHNOLOGIES INDIA PRIVATE LIMITED",
"RAMCHAM PACKAGING PRIVATE LIMITED",
"RAMCHANDRA CHHOTEL AND COMPANY",
"RAMCHANDRA DAHYABHAI NARROW FAB PRIVATE LIMITED",
"RAMCHANDRA MERCHANDISE PRIVATE LIMITED",
"RAMCHANDRA PLASTICS AND THERMOFORMING PRIVATE LIMITED",
"RAMCHARAN CHITS PRIVATE LIMITED",
"RAMCHARAN COMPANY PRIVATE LIMITED",
"RAMCHARAN FOOD INDUSTRIES PRIVATE LIMITED",
"RAMCIDES CROPSCIENCE PRIVATE LIMITED",
"RAMCO AGRI INDIA PRIVATE LIMITED",
"RAMCO CERAMIC PRIVATE LIMITED",
"RAMCO EXTRUSION PRIVATE LIMITED",
"RAMCO HERBALS PRIVATE LIMITED",
"RAMCO INDUSTRIAL AND TECHNOLOGY SERVICES LIMITED",
"RAMCO INDUSTRIES LIMITED",
"RAMCO PLAST PRODUCT PRIVATE LIMITED",
"RAMCO SERVICES PVT. LTD",
"RAMCO STEELS PRIVATE LIMITED",
"RAMCO SYSTEMS LIMITED",
"RAMCO WINDFARMS LIMITED",
"RAMCONS FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"RAMCOR ENTERPRISES PRIVATE LIMITED",
"RAMCOR MARKETING PRIVATE LIMITED",
"RAMCOR MOTORS PRIVATE LIMITED",
"RAMDA UDAIPUR RESORT & SPA",
"RAMDAS PHARMA DISTRIBUTORS PRIVATE LIMITED",
"RAMDEBPUR JUNIOR HIGH SCHOOL",
"RAMDEEP BUILDTECH (INDIA) PRIVATE LIMITED",
"RAMDEO AGENCY HOUSE PRIVATE LIMITED",
"RAMDEO WAREHOUSE PRIVATE LIMITED",
"RAMDEV AIR CONDITION",
"RAMDEV ALLOYS AND STEELS PRIVATE LIMITED",
"RAMDEV AUTOMATION PRIVATE LIMITED",
"RAMDEV CASTINGS PRIVATE LIMITED",
"RAMDEV CHEMI PHARMA PRIVATE LIMITED",
"RAMDEV CHEMICAL PRIVATE LIMITED",
"RAMDEV EXPORTS LIMITED",
"RAMDEV FOOD PRODUCTS PRIVATE LIMITED",
"RAMDEV FOODS PRIVATE LIMITED",
"RAMDEV HOTELS PRIVATE LIMITED",
"RAMDEV MASALA PRIVATE LIMITED",
"RAMDEV MOBILE",
"RAMDEV RAYON PRIVATE LIMITED",
"RAMDEV REFINERIES PRIVATE LIMITED",
"RAMDEV STAINLESS STRIPS PRIVATE LIMITED",
"RAMDEV SUGARS PRIVATE LIMITED",
"RAMDEV SYNTHETICS PRIVATE LIMITED",
"RAMDEV TEXTILES PRIVATE LIMITED",
"RAMDEVBABA SOLVENT LIMITED",
"RAMDEVBABA SOLVENT PRIVATE LIMITED",
"RAMDHAN INFRATECH PRIVATE LIMITED",
"RAMDOOT FIBRES PVT LTD",
"RAMDOOT ICE AND COLD STORAGE PRIVATE LIMITED",
"RAMDOOT REALTORS PRIVATE LIMITED",
"RAMDURLABHPUR TEA CO LTD",
"RAMDUT ALLOYS PRIVATE LIMITED",
"RAMDUTA MULTI SERVICES PRIVATE LIMITED",
"RAMDUTT AUTOMOBILES PRIVATE LIMITED",
"RAMDUTT VALUE PRODUCTS ( INDIA ) PRIVATE LIMITED",
"RAMEE CONSTRUCTIONS PRIVATE LIMITED",
"RAMEE DEVELOPERS PRIVATE LIMITED",
"RAMEE HOTELS PRIVATE LIMITED",
"RAMEE TOUR & TRAVELS PRIVATE LIMITED",
"RAMELEX PRIVATE LIMITED",
"RAMER INDIA PRIVATE LIMITED",
"RAMESH AGGARWAL AND ASSOCIATES PRIVATE L IMITED",
"RAMESH AND SHARDA AGRAWAL FOUNDATION",
"RAMESH BARREL SUPPLYING CO",
"RAMESH CHAND RAI",
"RAMESH CHANDER CONTRACTOR COMPANY PRIVATE LIMITED",
"RAMESH DEO PRODUCTION PRIVATE LIMITED",
"RAMESH EXPORTS PRIVATE LIMITED",
"RAMESH FLOWERS PRIVATE LIMITED",
"RAMESH FOREX PRIVATE LIMITED",
"RAMESH HITECHK PUMPS PRIVATE LIMITED",
"RAMESH HOTELS & RESORTS PRIVATE LIMITED",
"RAMESH IMPEX PRIVATE LIMITED",
"RAMESH IRON AND STEEL COMPANY INDIA PRIVATE LIMITED",
"RAMESH KAPOOR & SONS JEWELLERS PRIVATE LIMITED",
"RAMESH KRISHNA ENGINEERS PRIVATE LIMITED",
"RAMESH LALWANI",
"RAMESH RAJANN CONSTRUCTIONS PRIVATE LIMITED",
"RAMESH SUNWIRE PRIVATE LIMITED",
"RAMESH TEXTILES INDIA PRIVATE LIMITED",
"RAMESH TOURS AND TRAVELS PRIVATE LIMITED",
"RAMESH TRADING COMPANY (BOMBAY) PVT. LTD.",
"RAMESH YARN PRIVATE LIMITED",
"RAMESH YARRNS INDIA PRIVATE LIMITED",
"RAMESHKUMAR ALOKKUMAR INVESTMENTS PRIVATE LIMITED",
"RAMESH'S AEROSPACE PRODUCTS & SERVICES PRIVATE LIMITED",
"RAMESHT SECURITY SERVICES PRIVATE LIMITED",
"RAMESHWAR COTTON PRIVATE LIMITED",
"RAMESHWAR DASS DWARKA DASS PRIVATE LIMITED",
"RAMESHWAR DEVELOPERS PRIVATE LIMITED",
"RAMESHWAR INDUSTRIES",
"RAMESHWAR INFRA CREATION LLP",
"RAMESHWAR MACHINERY PRIVATE LIMITED",
"RAMESHWAR PRASAD SHARMA CONTRACTOR",
"RAMESHWAR SWARNA MANDIR PRIVATE LIMITED",
"RAMESHWAR TRANSPORT CO PRIVATE LIMITED",
"RAMESHWAR VIDYALAYA SINDKHED GEORAI",
"RAMESHWARA ENGINEERING CO PVT LTD",
"RAMESHWARAM ENGINEERING INDIA PRIVATE LIMITED",
"RAMESHWARAM HOSPITALITIES PRIVATE LIMITED",
"RAMESHWARAM LIFE CARE PRIVATE LIMITED",
"RAMESHWARAM RICE MILLS PRIVATE LIMITED",
"RAMESHWARAM STEEL AND POWER PRIVATE LIMITED",
"RAMESHWARAM STRONG GLASS PRIVATE LIMITED",
"RAMESHWARI BUILDCON PRIVATE LIMITED",
"RAMESHWARI FIBRES PRIVATE LIMITED",
"RAMESHWARI OVERSEAS PRIVATE LIMITED",
"RAMESHWARI PRINTS PRIVATE LIMITED",
"RAMESHWARI WIRES PRIVATE LIMITED",
"RAMESHWRA EMPORIUM PRIVATE LIMITED",
"RAMESTH CONSTRUCTION",
"RAMESTH DIAMONDS PRIVATE LIMITED",
"RAMESWAR AGRO INDUSTRIES PRIVATE LIMITED",
"RAMESWAR APEX PRIVATE LIMITED",
"RAMESWAR AUTO ELECTRICAL PRIVATE LIMITED",
"RAMESWAR UDYOG PRIVATE LIMITED",
"RAMESWARA MANSION PROPERTY MANAGEMENT PRIVATE LIMITED",
"RAMESWARA NURSING HOME PRIVATE LIMITED",
"RAMESWARA RICE MILL PRIVATE LIMITED",
"RAMESWARPUR COLD STORAGE PVT LTD",
"RAMESWARPUR NEHRU VIDYANIKETAN",
"RAMEX SOLTECH PRIVATE LIMITED",
"RAMGAD MINERALS AND MINING LIMITED",
"RAMGANGA HOSPITAL PRIVATE LIMITED",
"RAMGANGA ROLLER FLOUR MILLS PRIVATE LIMITED",
"RAMGARH SPONGE IRON PRIVATE LIMITED",
"RAMGOPAL BIRLA TEXTILES PRIVATE LIMITED",
"RAMGOPAL INVESTMENT AND TRADING COMPANY PRIVATE LIMITED",
"RAMGOPAL POLYTEX LIMITED",
"RAMHANS INDUSTRIES PRIVATE LIMITED",
"RAMHANS WOOD INDIA PRIVATE LIMITED",
"RAMI CHANDIDAS RICE MILL PRIVATE LIMITED",
"RAMI REDDY AGRO INDUSTRY",
"RAMILA DIAM PRIVATE LIMITED",
"RAMILA ESTATE PRIVATE LIMITED",
"RAMINCO PLASTECHNIC PRIVATE LIMITED",
"RAMIND COLD FORGE PRIVATE LIMITED",
"RAMINENI AGRO INDUSTRIES PRIVATE LIMITED",
"RAMINFO LIMITED",
"RAMITECH LABS PRIVATE LIMITED",
"RAMIYA CONSTRUCTIONS PRIVATE LIMITED",
"RAMJAN MOBIKES PRIVATE LIMITED",
"RAMJANKI AGRITRADE PRIVATE LIMITED",
"RAMJAS PUBLIC SCHOOL",
"RAMJAS SCHOOL",
"RAMJAY HOMES REAL ESTATE PRIVATE LIMITED",
"RAMJEE CONCRETES PRIVATE LIMITED",
"RAMJEE LEATHERS AND SUPPLIES",
"RAMJEE PRASAD JEWELLERS PRIVATE LIMITED",
"RAMJEE SINGH CONSTRUCTION PRIVATE LIMITED",
"RAMJI ACRO LIMITED",
"RAMJI BOARD AND PAPER MILL PRIVATE LIMITED",
"RAMJI DAS DHAL CONSTRUCTION PRIVATE. LIMITED.",
"RAMJI DASS DARSHAN KUMAR ICE AND COLD STORE PRIVATE LIMITED",
"RAMJI DASS KHANIJOW AND SONS PVT LTD",
"RAMJI INDUSTRIES PRIVATE LIMITED",
"RAMJI LAL AND SONS",
"RAMJI LAL RAM SAROOP PVT LTD",
"RAMJI SANITECH PRIVATE LIMITED",
"RAMJIDAS CONSTRUCTION PRIVATE LIMITED",
"RAMJIWAN MITTAL PRODUCTS (INDIA) PRIVATE LIMITED",
"RAMJIYANI CONSTRUCTION PRIVATE LIMITED",
"RAMJYOTI SHITALAYA PVT LTD",
"RAMKALI DEVI SARASWATI VIDYA MANDIR SENIOR SECONDARY SCHOOL",
"RAMKAMAL CHEMICALS PRIVATE LIMITED",
"RAMKAY AGENCIES",
"RAMKIRTI PRIVATE LIMITED",
"RAMKISHAN PACKAGING PRIVATE LIMITED",
"RAMKORP STEEL TECH PRIVATE LIMITED",
"RAMKRIPA AGRO FOODS PRIVATE LIMITED",
"RAMKRIPAL STEELS PRIVATE LIMITED",
"RAMKRISHNA CARE MEDICAL SCIENCES PRIVATE LIMITED",
"RAMKRISHNA COTSPIN PRIVATE LIMITED",
"RAMKRISHNA COTTEX PRIVATE LIMITED",
"RAMKRISHNA DIAMOND PRIVATE LIMITED",
"RAMKRISHNA ENGINEERING PRIVATE LIMITED",
"RAMKRISHNA FORGINGS LIMITED",
"RAMKRISHNA FOUNDRY PRIVATE LIMITED",
"RAMKRISHNA FREIGHT CARRIERS PRIVATE LIMITED",
"RAMKRISHNA GOLDI PRIVATE LIMITED",
"RAMKRISHNA MISSION BOYS HOME",
"RAMKRISHNA MOTORS PRIVATE LIMITED",
"RAMKRISHNA RAIL AND INFRASTRUCTURE PRIVATE LIMITED",
"RAM-KRISHNA TRAVELS PRIVATE LIMITED",
"RAMKRISHNA TUBES PRIVATE LIMITED",
"RAMKRISHNA VIDHYABHAVAN",
"RAMKRISHNA VIDYALAYA",
"RAMKRISHY INFRASTRUCTURE PRIVATE LIMITED",
"RAMKRUPA COTEX PRIVATE LIMITED",
"RAMKRUPA GINNING AND PRESSING PRIVATE LIMITED",
"RAMKRUPA INDUSTRIES PRIVATE LIMITED",
"RAMKRUPA RAYON PRIVATE LIMITED",
"RAMKRUSHNA SPINNING MILLS PRIVATE LIMITED",
"RAMKRUSHNA VIDHYA BHAVAN",
"RAMKRUSNA KRIDA AASHRAM SHALA V K M V AMRAVATI",
"RAMKUMAR AGRO PRODUCTS PRIVATE LIMITED",
"RAMKUMAR MILLS PRIVATE LIMITED",
"RAMKUMAR MORARKA AND SONS PRIVATE LIMITED",
"RAMKUMAR TEXTILE PRIVATE LIMITED",
"RAMKY ATALIAN PRIVATE LIMITED",
"RAMKY ELSAMEX HYDERABAD RING ROAD LIMITED",
"RAMKY ENCLAVE LIMITED",
"RAMKY ENERGY AND ENVIRONMENT LIMITED",
"RAMKY ESTATES AND FARMS LIMITED",
"RAMKY INFRASTRUCTURE LIMITED",
"RAMKY INTEGRATED TOWNSHIP LIMITED",
"RAMKY RECLAMATION AND RECYCLING LIMITED",
"RAMKY SRISAIRAM PROPERTIES PRIVATE LIMITED",
"RAMKY VIHA PROPERTIES PRIVATE LIMITED",
"RAMKY WAVOO DEVELOPERS PRIVATE LIMITED",
"RAMLAL AUTOMOBILES PRIVATE LIMITED",
"RAMLAL DURGADUTT AUTOZONE PRIVATE LIMITED",
"RAMLAL DURGADUTT MOTORS PRIVATE LIMITED",
"RAMLAL INFRAPROJECTS PRIVATE LIMITED",
"RAMLAXMAN INDUSTRIES PRIVATE LIMITED",
"RAMLAXMAN SYNTHETICS PRIVATE LIMITED",
"RAMLING FARMERS PRODUCER COMPANY LIMITED",
"RAMLORD APPARELS",
"RAMMANGAL HEART FOUNDATION PRIVATE LIMITED",
"RAMMOHAN COLLEGE",
"RAMMOHAN POLY-PACK PRIVATE LIMITED",
"RAMMS INDIA PRIVATE LIMITED",
"RAMMY TRADE SOLUTIONS PRIVATE LIMITED",
"RAMNAD RENEWABLE ENERGY LIMITED",
"RAMNAD SOLAR POWER LIMITED",
"RAMNAGAR AGRO VISION PRIVATE LIMITED",
"RAMNAGAR SEED FARM PRIVATE LIMITED",
"RAMNARAIN RUIA AUTONOMOUS COLLEGE",
"RAMNAS EXIM ENTERPRISES PRIVATE LIMITED",
"RAMNATH EXPORTS PRIVATE LIMITED",
"RAMNATH HOTELS PRIVATE LIMITED",
"RAMNEEK INTERNATIONAL PRIVATE LIMITED",
"RAMNIK MARKETING PVT LTD",
"RAMNIK PAPTRADE PRIVATE LIMITED",
"RAMNIK POWER AND ALLOYS PRIVATE LIMITED",
"RAMNIKLAL S. GOSALIA AND CO.",
"RAMNIKLAL ZAVERBHAI SHAH TRUST",
"RAMNIRANJAN KEDIA RENT A CAR PRIVATE LIMITED",
"RAMNIVAS RUIA JUNIOR COLLAGE",
"RAMNIVASH ISPAT PRIVATE LIMITED",
"RAMNIWAS HASTKALA NIRYAT PRIVATE LIMITED",
"RAMNIWAS MINING PRIVATE LIMITED",
"RAMNORD RESEARCH LABORATORIES PRIVATE LIMITED",
"RAMO AD CREATION PRIVATE LIMITED",
"RAMO AGRITECH (INDIA) PVT. LTD.",
"RAMODI FOODS PRIVATE LIMITED",
"RAMOGNEE TECHNOLOGIES PRIVATE LIMITED",
"RAMOJI GRANITE PRIVATE LIMITED",
"RAMOJI WAFER AND NAMKEEN PRIVATE LIMITED",
"RAMOLA BACHCHAN CONCEPTS PRIVATE LIMITED",
"RAMOLE EYE HOSPITAL",
"RAMOM HEALTH CARE PRIVATE LIMITED",
"RAMON HYDRAULICS PRIVATE LIMITED",
"RAMON PUBLICATIONS PRIVATE LIMITED",
"RAMP DISPLAY SOLUTIONS PRIVATE LIMITED",
"RAMP IMPEX PRIVATE LIMITED",
"RAMP INDIA BUILDCON PRIVATE LIMITED",
"RAMP POLYMERS PRIVATE LIMITED",
"RAMP TECHNOMATION PRIVATE LIMITED",
"RAMPA MOTOR NAWANSHAHR",
"RAMPAL STEEL PRIVATE LIMITED",
"RAMPARA M S NANDI PRIMARY SCHOOL",
"RAMPARI AGRO PRODUCTS PRIVATE LIMITED",
"RAMPD FABRICS PRIVATE LIMITED",
"RAMPEX LABS PRIVATE LIMITED",
"RAMPINFRA DEVELOPERS PRIVATE LIMITED",
"RAMPO EXPORT IMPORT PVT. LTD.",
"RAMPRASAD TUBES AND BARS PRIVATE LIMITED",
"RAMPRASTHA BUILDTECH PRIVATE LIMITED.",
"RAMPRASTHA BUILDWELL PRIVATE LIMITED.",
"RAMPRASTHA ESTATES PRIVATE LIMITED",
"RAMPRASTHA HOUSING PRIVATE LIMITED",
"RAMPRASTHA PROMOTERS AND DEVELOPERS PRIV ATE LIMITED",
"RAMPRASTHA REALTORS PRIVATE LIMITED.",
"RAMPRASTHA REALTY PRIVATE LIMITED",
"RAMPRASTHA URBAN DEVELOPMENT PRIVATE LIMITED",
"RAMPRAVESH RAI ESTATE PRIVATE LIMITED",
"RAMPUR AGRI FRESH PRIVATE. LIMITED.",
"RAMPUR FERTILIZERS LIMITED",
"RAMPUR HASTKALA PRIVATE LIMITED.",
"RAMPUR INTERNATIONAL LTD",
"RAMPURAASEDA PRIMARY SCHOOL",
"RAMPURHAT PSC SLEEPERS LIMITED",
"RAMPURIA BUILDERS LIMITED",
"RAMRAGHAV FASHIONAVENUE PRIVATE LIMITED",
"RAMRAIKA MARKETING PRIVATE LIMITED",
"RAMRAJ COLD STORAGE PRIVATE LIMITED",
"RAMRAJ ENGINEERING PRIVATE LIMITED",
"RAMRAJ FOODS LIMITED",
"RAMRAJ HITECH BUILDCON PRIVATE LIMITED",
"RAMRAJ HOSPITALS PRIVATE LIMITED",
"RAMRAJ WELLNESS PRIVATE LIMITED",
"RAMRAJA MULTISPECIALITY HOSPITAL & TRAUMA CENTRE PRIVATE LIMITED",
"RAMRAJYA ENGINEERS PRIVATE LIMITED",
"RAMRAO ADIK INSTITUTE OF TECHNOLOGY",
"RAMRAODADA PATIL AADIVASI BOYS & GIRLS ASHRAM SCHOOL",
"RAMRATAN MULTIFOODS INDIA PRIVATE LIMITED",
"RAMRATAN REAL ESTATE PRIVATE LIMITED",
"RAMRATI JAGDISH PRIVATE LIMITED",
"RAMRICHHPAL BHURAMULL PVT LTD",
"RAMRICK INSTITUTION",
"RAMRUP CREDIT AND LEASING PRIVATE LIMITED",
"RAMRUP PIPES PRIVATE LIMITED",
"RAMS ASSORTED COLD STORAGE LIMITED",
"RAMS CREATIVE TECHNOLOGIES PRIVATE LIMITED",
"RAMS FITTINGS AND ACCESSORIES PRIVATE LIMITED",
"RAMSADAY COLLEGE",
"RAMSAI TEA ESTATES PRIVATE LIMITED",
"RAMSANGAM PROJECTS PRIVATE LIMITED",
"RAMSAYS CORPORATION PRIVATE LIMITED",
"RAMSE ENGINEERING WORKS PVT LTD",
"RAMSEVAK & SONS PRIVATE LIMITED",
"RAMSEY PHARMA PVT LTD",
"RAMSHA FASHION PRIVATE LIMITED",
"RAMSHARANKRIPA SALES PRIVATE LIMITED",
"RAMSHETH THAKUR PUBLIC SCHOOL KHARGHAR",
"RAMSHREE GLOBAL CONSTRUCTIONS PRIVATE LIMITED",
"RAMSIVA TRADERS PRIVATE LIMITED",
"RAMSIVE TOOLS PRIVATE LIMITED",
"RAMSKAR AGENCIES PRIVATE LIMITED",
"RAMSNEHI VINIYOG PRIVATE LIMITED",
"RAMSOFT TECHNOLOGIES PRIVATE LIMITED",
"RAMSON AND GRANDSON JEWELLERS PRIVATE LIMITED",
"RAMSON GRAPHICS PRIVATE LIMITED",
"RAMSON HEALTH CARE PRIVATE LIMITED",
"RAMSON LOGISTICS PRIVATE LIMITED",
"RAMSON MEDICAL DISTRIBUTORS PRIVATE LIMITED",
"RAMSON POLYPACK PRIVATE LIMITED",
"RAMSON SOFTECH PRIVATE LIMITED",
"RAMSONS APPAREL ACCESSORIES PRIVATE LIMITED",
"RAMSONS AQUA LIMITED",
"RAMSONS ASSOCIATES PRIVATE LIMITED",
"RAMSONS CASTING PRIVATE LIMITED",
"RAMSONS CYCLES PRIVATE LIMITED",
"RAMSONS DAIRY LIMITED",
"RAMSONS FOOD LIMITED",
"RAMSONS GARMENT FINISHING EQUIPMENTS PRIVATE LIMITED",
"RAMSONS INDUSTRIES LIMITED",
"RAMSONS MARKETING PRIVATE LIMITED",
"RAMSONS MERCHANTS PRIVATE LIMITED",
"RAMSONS ORGANICS LIMITED",
"RAMSONS PERFUMES PRIVATE LIMITED",
"RAMSONS PROPERTIES PRIVATE LIMITED",
"RAMSONS VEIT PRIVATE LIMITED",
"RAMSONS VENTURES PRIVATE LIMITED",
"RAMSUKH DEVELOPERS PRIVATE LIMITED",
"RAMTEC CONSTRUCTION COVERS AND BLOCKS PRIVATE LIMITED",
"RAMTECH SOFTWARE SOLUTIONS PRIVATE LIMITED",
"RAMTILAK ROLLER FLOUR MILLS PVT LTD",
"RAMTIRTH LEASING AND FINANCE COMPANY PRIVATE LIMITED",
"RAMTON TECHNOLOGIES PRIVATE LIMITED",
"RAMUKA GLOBAL ISPAT & METALS PRIVATE LIMITED",
"RAMVANSH FIBROLOGY PRIVATE LIMITED",
"RAMVIJAY CLOTHING COMPANY PRIVATE LIMITED",
"RAMVIJAY COTTON MILLS PRIVATE LIMITED",
"RAMWAY FOODS LIMITED",
"RAMY INFOTECH PRIVATE LIMITED",
"RAMYA BALAJI ALLOY PRIVATE LIMITED",
"RAMYA BUILDCON PRIVATE LIMITED",
"RAMYA BUILDTECH (OPC) PRIVATE LIMITED",
"RAMYA COLD STORAGE PRIVATE LIMITED",
"RAMYA CONSTRUCTIONS LIMITED",
"RAMYA IMPEX PRIVATE LIMITED",
"RAMYA INFRASTRUCTURE PRIVATE LIMITED",
"RAMYA REPROGRAPHIC PRIVATE LIMITED",
"RAMYA SPINNING MILLS PRIVATE LIMITED",
"RAMYAA ELECTRO GEAR PRIVATE LIMITED",
"RAMYAM INTELLIGENCE LAB PRIVATE LIMITED",
"RAMYAS HOTELS PRIVATE LIMITED",
"RAMYSHAA COMMERCIAL PRIVATE LIMITED",
"RAN CHEMICALS PRIVATE LIMITED",
"RAN IDEAS PRIVATE LIMITED",
"RAN INDIA STEELS PRIVATE LIMITED",
"RAN RESOURCES PVT LTD",
"RAN ZEAL FITNESS PRIVATE LIMITED",
"RANA & JOSHI BUILDTECH PRIVATE LIMITED",
"RANA & SONI ENTERPRISES PRIVATE LIMITED",
"RANA ARCHITECTURAL SOLUTIONS PRIVATE LIMITED",
"RANA BAI GRANITE MARBLE (INDIA) PRIVATE LIMITED",
"RANA BAI MARBLE",
"RANA BROADCASTING PRIVATE LIMITED",
"RANA CHENGAPPA HEALTH VENTURES PRIVATE LIMITED",
"RANA DENIM PRIVATE LIMITED",
"RANA ENGINEERING CO.(INDIA) PRIVATE LIMITED",
"RANA FARMS & FOODS PRIVATE. LIMITED.",
"RANA HEALTH CARE PRIVATE LIMITED",
"RANA HOSPITALS PRIVATE LIMITED",
"RANA INFORMATICS PRIVATE LIMITED",
"RANA INFRACON INDIA PRIVATE LIMITED",
"RANA JI BIOTECH (INDIA) PRIVATE LIMITED",
"RANA LOGISTICS & TRANSPORT PRIVATE LIMITED",
"RANA MACHINES INDIA PRIVATE LIMITED",
"RANA MATERIAL HANDLING EQUIPMENTS PRIVATE LIMITED",
"RANA MILK FOODS PRIVATE LIMITED",
"RANA MINCHEM INDIA PRIVATE LIMITED",
"RANA MOTORS PRIVATE LIMITED",
"RANA OVO CABS PRIVATE LIMITED",
"RANA POLYCOT LIMITED",
"RANA POWER LIMITED",
"RANA PRATAP SARVODAYA VIDHYALAYA",
"RANA RAMDEV MEDICO PRIVATE LIMITED",
"RANA REALTECH PRIVATE LIMITED",
"RANA ROLLING MILLS PRIVATE LIMITED",
"RANA SALES AND SERVICES PRIVATE LIMITED",
"RANA SOLAR POWER PRIVATE LIMITED",
"RANA STEELS INDIA PRIVATE LIMITED",
"RANA SUGARS LIMITED",
"RANA UDYOG PRIVATE LIMITED",
"RANADE'S SR SYSTEMS PRIVATE LIMITED",
"RANAG INFRASTRUCTURE LIMITED",
"RANAGHAT AGRO PRODUCER COMPANY LIMITED",
"RANAJI CROP SCIENCE PRIVATE LIMITED",
"RANAK MOVERS PRIVATE LIMITED",
"RANAKPUR ENTERPRISES PRIVATE LIMITED",
"RANAKPUR ISPAT LIMITED",
"RANAKPUR MARBLES PRIVATE LIMITED",
"RANAKPUR OIL AND SOLVENTS PRIVATE LIMITED",
"RANAL ENGINEERING SERVICES PRIVATE LIMITED",
"RANAPAY INDIA PRIVATE LIMITED",
"RANAPUR TRIBAL MAHILA FARMER PRODUCER COMPANY LIMITED",
"RANAR AGROCHEM LIMITED",
"RANASARIA POLY PACK PRIVATE LIMITED",
"RANASONS PRIVATE LIMITED",
"RANAWAT ENERGY PRIVATE LIMITED",
"RANBAN EXIM PRIVATE LIMITED",
"RANBANKA HERITAGE RESORTS PRIVATE LIMITED",
"RANBANKA JODHA HOTELS PRIVATE LIMITED",
"RANBANKA SECURITY ALLIED SERVICES PRIVATE. LIMITED",
"RANBAXY LABORATORIES LIMITED",
"RANBAXY MERCHANDISE PVT LTD",
"RANCARE INDUSTRIES LIMITED",
"RANCE COMPUTER PRIVATE LIMITED",
"RANCH CUISINE CONCEPTS PRIVATE LIMITED",
"RANCHHILL SOFTWARE SOLUTIONS PRIVATE LIMITED",
"RANCHI ASHOK BIHAR HOTEL CORPORATION LIMITED",
"RANCHI CANCER CARE FOUNDATION",
"RANCHI CLUB LIMITED",
"RANCHI DESIGN AND CONSULTANCY SERVICES PRIVATE LIMITED",
"RANCHI ENTERPRISES AND PROPERTIES LTD.",
"RANCHI HANDLOOM PRIVATE LIMITED",
"RANCHI REFRACTORIES (INDIA) PRIVATE LIMITED",
"RANCHI TECHNO SOLUTIONS PRIVATE LIMITED",
"RANCHI UNIVERSITY",
"RANCHOR INFRA DEVELOPERS PRIVATE LIMITED",
"RANCHPRIDE AGROCOMM PRIVATE LIMITED",
"RANCO REALTY PRIVATE LIMITED",
"RANCON PROJECTS PRIVATE LIMITED",
"RANCORP MEDIA PRIVATE LIMITED",
"RAND POLYPRODUCTS PRIVATE LIMITED",
"RANDACK FASTENERS INDIA PRIVATE LIMITED",
"RANDALL MEDICAL TECHNOLOGIES PRIVATE LIMITED",
"RANDER CORPORATION LIMITED",
"RANDEVA ADVISORY SERVICES PRIVATE LIMITED",
"RANDHAWA AUTOMOBILE ENGINEERING PRIVATE LIMITED",
"RANDHAWA CONSTRUCTION PRIVATE LIMITED",
"RANDHAWA MOTORS",
"RANDHIR BUILDERS PRIVATE LIMITED",
"RANDHIR METAL AND ALLOYS PRIVATE LIMITED",
"RANDHONI A KITCHEN PHYLOSOPHY",
"RANDIL TRADING COMPANY PRIVATE LIMITED",
"RANDOMTREES PRIVATE LIMITED",
"RANDOX LABORATORIES INDIA PRIVATE LIMITED",
"RANDSTAD INDIA PRIVATE LIMITED",
"RANDSTAD GLOBAL CAPABILITY CENTER PRIVATE LIMITED",
"RANDSTAD DIGITAL PRIVATE LIMITED",
"RANDWIN EXIM PRIVATE LIMITED",
"RANE AUTOMOTIVE LIMITED",
"RANE AXLE AND PRESSING PRIVATE LIMITED",
"RANE BRAKE LINING LIMITED",
"RANE ENGINE VALVE LIMITED",
"RANE ENGINE VALVES LIMITED",
"RANE HOLDINGS LIMITED",
"RANE HOSPITAL PRIVATE LIMITED",
"RANE INDUSTRIES PRIVATE.LIMITED",
"RANE MADRAS LIMITED",
"RANE MANAGEMENT CONSULTANT PRIVATE LIMITED",
"RANE NSK STEERING SYSTEMS PRIVATE LIMITED",
"RANE PLASTICS PRIVATE LIMITED",
"RANE PRAKASHAN PRIVATE LIMITED",
"RANE PVT LTD",
"RANE RAO RESHAMIA LABORATORIES PRIVATE LIMITED",
"RANEBENNUR SPINTEX PRIVATE LIMITED",
"RANEKA FINCOM PRIVATE LIMITED",
"RANEKA INDUSTRIES LIMITED",
"RANEMARG FLAVOURS & FRAGRANCES PRIVATE LIMITED",
"RANERGY SOLUTIONS PRIVATE LIMITED",
"RANEW ENGINEERING INDIA PRIVATE LIMITED",
"RANG BANDHEJ PRIVATE LIMITED",
"RANG DE P2P FINANCIAL SERVICES PRIVATE LIMITED",
"RANG INFOSOFT PRIVATE LIMITED",
"RANG MANCH FASHION PRIVATE LIMITED",
"RANG PRIVATE LIMITED",
"RANG SHARDA HOTELS PRIVATE LIMITED",
"RANG STUDIO PRIVATE LIMITED",
"RANG SUTRA CRAFT DUNIYA PRODUCER COMPANY LIMITED (PRODUCER COMPANY)",
"RANG TARANG UDYOG LIMITED",
"RANGA ELECTRICALS PRIVATE LIMITED",
"RANGA OVERSEAS PRIVATE LIMITED",
"RANGA PARTICLE BOARD INDUSTRIES PRIVATE LIMITED",
"RANGA RAO AND ASSOCOATES",
"RANGA WEAVES INDIA PRIVATE LIMITED",
"RANGAA YARNS PRIVATE LIMITED",
"RANG-AANGANA SAREES PRIVATE LIMITED",
"RANGACHARI TEXTILES PRIVATE LIMITED",
"RANGADORE MEMORIAL HOSPITAL",
"RANGAM CREATION PRIVATE LIMITED",
"RANGAM INFOTECH PRIVATE LIMITED",
"RANGAMATI MULTI PURPOSE COLD STORAGE EXPORT UNIT PRIVATE LTD",
"RANGAN MANUFACTURING SERVICES PRIVATE LIMITED",
"RANGANAYAKA SPINNING MILLS PRIVATE LIMITED",
"RANGANI TIMBERS",
"RANGAPPA KAMAT GROUP OF HOTELS LIMITED",
"RANGARAYA CONSTRUCTIONS LIMITED",
"RANGCHALI TEA COMPANY PRIVATE LIMITED",
"RANGDHANU CONSTRUCTION INDIA PRIVATE LIMITED",
"RANGE CERAMIC PRIVATE LIMITED",
"RANGE EXPORTS PRIVATE LIMITED",
"RANGE FOREST OFFICE",
"RANGE FOREST OFFICE KUHI",
"RANGE FOREST OFFICE TORNAMAL",
"RANGE FOREST OFFICER DHULE",
"RANGE OVERSEAS PRIVATE LIMITED",
"RANGE POLYMERS PRIVATE LIMITED",
"RANGEELA FASHIONS PRIVATE LIMITED",
"RANGEELA INDUSTRIES (INDIA) PRIVATE LIMITED",
"RANGEELA PICTURES PRIVATE LIMITED",
"RANGEET AUTO PRIVATE LIMITED",
"RANGELLII FAASHIION PRIVATE LIMITED",
"RANGER APPAREL EXPORT PRIVATE LIMITED",
"RANGER COTTON MILLS INDIA PRIVATE LIMITED",
"RANGER STORK PRIVATE LIMITED",
"RANGERS AUTOWORLD PRIVATE LIMITED",
"RANGI LAL GIRISH KUMAR JEWELLERS PRIVATE LIMITED",
"RANGILA VANIJYA PRIVATE LIMITED",
"RANGINENI STEEL PRIVATE LIMITED",
"RANGIRAMANI INFRA PRIVATE LIMITED",
"RANGISTAN CELEBRATIONS PRIVATE LIMITED",
"RANGJEE BUILDWELL PRIVATE LIMITED",
"RANGLAL TEA AND INDUSTRIES PVT LTD",
"RANGNATH PATIL VIDYALAYA JAMWADI",
"RANGODADHI CHEMICALS PRIVATE LIMITED",
"RANGOLI (NAGPUR) FASHION FABRICS PRIVATE LIMITED",
"RANGOLI BUILDTECH PRIVATE LIMITED",
"RANGOLI FURNISHING PRIVATE LIMITED",
"RANGOLI INDUSTRIES - BANASKANTHA",
"RANGOLI LAMINATE PRIVATE LIMITED",
"RANGOLI PAPER PRODUCTS PRIVATE LIMITED",
"RANGOLI PARTICLE BOARDS PRIVATE LIMITED",
"RANGOLI PLASTICS PRIVATE LIMITED",
"RANGOLI POLYPACK PRIVATE LIMITED",
"RANGOLI RESORTS PRIVATE LIMITED",
"RANGOLI SAREE",
"RANGOLI SYNTEX PRIVATE LIMITED",
"RANGOLI TECHTRADERS PRIVATE LIMITED",
"RANGOLI WOOD PRIVATE LIMITED",
"RANGOON CHEMICAL WORKS PVT LTD",
"RANGPUR TEA ASSOCIATION LTD",
"RANGRACHNA ATTIRES PRIVATE LIMITED",
"RANGRAJ ELECTRO PRODUCTS PVT LTD",
"RANGRAO VITHOBA PAWAR VIDYALAYA",
"RANGREZA RETAIL SERVICES PRIVATE LIMITED",
"RANGRUCHI FASHION PRIVATE LIMITED",
"RANGSHOBHA IMPEX PRIVATE LIMITED",
"RANGSONS AEROSPACE PRIVATE LIMITED",
"RANGSONS DEFENCE SOLUTIONS PRIVATE LIMITED",
"RANGSONS ELECTRONICS PRIVATE LIMITED",
"RANGSONS HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"RANGSONS SCHUSTER TECHNOLOGIES PRIVATE LIMITED",
"RANGSUTRA CRAFTS INDIA LIMITED",
"RANI AGRO PVT LTD",
"RANI AQUA FEEDS PRIVATE LIMITED",
"RANI BIRLA GIRLS COLLEGE",
"RANI DURGAWATI VISHWAVIDALAYA JABALPUR",
"RANI ELECTRODES LTD",
"RANI HANDICRAFTS PRIVATE LIMITED",
"RANI INDIRABAI BHONSALE MAHAVIDYALAYA KUHI",
"RANI KOTHI BANQUETS PRIVATE LIMITED",
"RANI LAXMI BAI MEMORIAL SCHOOL LUCKNOW",
"RANI LAXMIBAI PUBLIC SCHOOL",
"RANI LAXMIBAI VIDYALAYA YAVATMAL",
"RANI LEASINGS & FINANCE PRIVATE LIMITED",
"RANI PADMAVATI TARA YOGTANTRA ADARSH SANSKRIT MAHAVIDYALAYA",
"RANI PRESS PRIVATE LIMITED",
"RANI PROMOTER PVT LTD",
"RANI PUBLIC SCHOOL",
"RANI RUDRAMADEVI JR DEGREE COLLEGE",
"RANI RUPMATI COLLEGE OF MANAGEMENT",
"RANI SARALA DEVI EDUCATIONAL INST",
"RANI SATI AGRO OIL PRIVATE LIMITED",
"RANI SATI ALUMINIUM WORKS PRIVATE LIMITED",
"RANI SATI COKE PRIVATE LIMITED",
"RANI SATI FOODS PRIVATE LIMITED",
"RANI SATI MARKETING COMPANY PRIVATE LIMITED",
"RANI SATI RICE MILL PRIVATE LIMITED",
"RANI SATI SMELTERS PRIVATE LIMITED",
"RANI SYNDICATE PRIVATE LIMITED",
"RANIA KULTUKARI HIGH SCHOOL",
"RANICHERRA TEA CO LTD",
"RANIGANJ MUNICIPAL CORPORATION",
"RANIHATI CONSTRUCTION PRIVATE LIMITED",
"RANIKA EXPORTS DESIGN",
"RANIKA EXPORTS DESIGN PRIVATE LIMITED",
"RANIL INFRATECH PRIVATE LIMITED",
"RANIL PROJECTS PRIVATE LIMITED",
"RANINGA PAPER MILLS PRIVATE LIMITED",
"RANIPET INDUCTION HARDENING PRIVATE LIMITED",
"RANIPET TANNERY EFFLUENT TREATMENT COMPANY",
"RANIPET TANNERY EFFLUENT TREATMENT COMPANY LIMITED",
"RANISAL METALS PRIVATE LIMITED",
"RANISATI COAL CARRIERS PRIVATE LIMITED",
"RANISATI FABRIC MILLS PVT LTD",
"RANISATI GRAINS INDIA PRIVATE LIMITED",
"RANISATI INDUSTRIES LTD",
"RANISATI MANAGEMENT PRIVATE LIMITED",
"RANISATI MFG PRIVATE LIMITED",
"RANISATI PADDY PROCESSING PRIVATE LIMITED",
"RANISATI ROLLER FLOUR MILLS PRIVATE LIMITED",
"RANISATI TRADE & FINANCE PVT LTD",
"RANISATI TRANSPORT COMPANY PRIVATE LIMITED",
"RANISATI WIRE PRIVATE LIMITED",
"RANISH HUMAN CAPITAL PRIVATE LIMITED",
"RANISH IMPEX PRIVATE. LIMITED.",
"RANIWALA JEWELLERS PRIVATE. LIMITED.",
"RANIWALA PACKAGING PRIVATE LIMITED",
"RANIYA MANUFACTURING PRIVATE LIMITED",
"RANJAN ENGICON PRIVATE LIMITED",
"RANJAN FABRICS PRIVATE LIMITED",
"RANJAN KHOSLA AND SONS PRIVATE LIMITED",
"RANJAN PLASTICS PRIVATE LIMITED",
"RANJAN POLYSTERS LIMITED.",
"RANJAN SOLAR DUNIYA PRIVATE LIMITED",
"RANJANA COSMO CHEM PRIVATE LIMITED",
"RANJANA ELECTRO ENGINEERS PRIVATE LIMITED",
"RANJANAS GARMENTS PRIVATE LIMITED",
"RANJANS PRIDE PRIVATE LIMITED",
"RANJEET KUMAR CONSTRUCTION PRIVATE LIMITED",
"RANJEET MECHATRONICS LIMITED",
"RANJEET POULTRY PRIVATE LIMITED",
"RANJIT BUILDCON LIMITED",
"RANJIT EXPORTS PVT LTD",
"RANJIT PROJECTS PRIVATE LIMITED",
"RANJIT SINGH AND CO.",
"RANJIT TOLL ROAD PRIVATE LIMITED",
"RANJITGARH FINANCE COMPANY PRIVATE LIMITED",
"RANJITH HOSPITAL",
"RANJITHA HOTELS PRIVATE LIMITED",
"RANJU AUTOMOBILES PRIVATE LIMITED",
"RANK ADDITIVES PRIVATE LIMITED",
"RANK COMPUTERS PRIVATE LIMITED",
"RANK CRANES PRIVATE LIMITED",
"RANK FINWORLD LLP",
"RANK GLOBAL SERVICES PRIVATE LIMITED",
"RANK INFRATEL PRIVATE LIMITED",
"RANK INSURANCE SURVEYORS AND LOSS ASSESSORS PRIVATE LIMITED",
"RANK INTERNATIONAL",
"RANK LOGISTICS PRIVATE LIMITED",
"RANK MATE PRIVATE LIMITED",
"RANK OFFICE AUTOMATION PRIVATE LIMITED",
"RANK ORGANICS CHEMICAL PRIVATE LIMITED",
"RANK PROJECTS AND DEVELOPMENT PRIVATE LIMITED",
"RANK RETAILS PRIVATE LIMITED",
"RANK ROBOTICS PRIVATE LIMITED",
"RANK SILICON AND INDUSTRIES PRIVATE LIMITED",
"RANK TRAVEL AND TOUR",
"RANKA DEVELOPERS PRIVATE LIMITED",
"RANKA GRIHA NIRMAN PRIVATE LIMITED",
"RANKA JEWELLERS",
"RANKA ORGANIC PRIVATE LIMITED",
"RANKA PULSES PVT LTD",
"RANKA STEEL RE-ROLLING MILLS PVT. LTD",
"RANKA SYNTHETICS PRIVATE LIMITED",
"RANKAS TEXFAB PRIVATE LIMITED",
"RANKE ATHARVA ENTERPRISE PRIVATE LIMITED",
"RANKER SECURITY SERVICES PRIVATE LIMITED",
"RANKERS GROUP AND PRIVATE TUTION",
"RANKERS HERBAL PRIVATE LIMITED",
"RANKERS HOSPITAL",
"RANKERS INTERNATIONAL PRIVATE LIMITED",
"RANKERS INTERNATIONAL SCHOOL",
"RANKERS LINKS PRIVATE LIMITED",
"RANKGURU TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"RANKO METALS PRIVATE LIMITED",
"RANKS FISCALS PVT LTD",
"RANKSURGE LEARNING PRIVATE LIMITED",
"RANKUNO INTERACTIVE TECHNOLOGIES PRIVATE LIMITED",
"RANM CHIT FUNDS PRIVATE LIMITED",
"RANMAK WORKS PRIVATE LIMITED",
"RANOL LUBRICANTS PRIVATE LIMITED",
"RANOSON PRODUCTS PRIVATE LIMITED",
"RANOSON SPRINGS PRIVATE LIMITED",
"RANOSYS TECHNOLOGIES PRIVATE LIMITED",
"RANQ REMEDIES PRIVATE LIMITED",
"RANS ENGINEERING & CHEMICALS PRIVATE LIMITED",
"RANS TECHNOCRATS INDIA PRIVATE LIMITED",
"RANSAL INDIA PVT. LTD.",
"RANSAN PACKAGING PRIVATE LIMITED",
"RANSH CARS PRIVATE LIMITED",
"RANSH PHARMA PRIVATE LIMITED",
"RANSHA REALTY PRIVATE LIMITED",
"RANSISAR PROJECTS PRIVATE LIMITED",
"RANSOL PRIVATE LIMITED",
"RANSOM FILMS PRIVATE LIMITED",
"RANSON EXPORTS",
"RANTHAMBHORE WILDLIFE ALLIANCE PRIVATE LIMITED",
"RANTHAMBORE AUTOWORLD PRIVATE LIMITED",
"RANTHAMBORE FOREST RESORTS PRIVATE LIMITED",
"RANTHAMBORE MOUNT VALLEY RESORT PRIVATE LIMITED",
"RANU FOODS PRIVATE. LIMITED.",
"RANU HIGHER PRIMARY SCHOOL MANKAPUR",
"RANUTROL INDUSTRIES PRIVATE LIMITED",
"RAN-VAC TECHNOLOGIES PRIVATE LIMITED",
"RANVEER ALLOYS PRIVATE LIMITED",
"RANVIJAY AND GAURAAV SINGHH INFRACON PRIVATE LIMITED",
"RANVIK AUTOCOMPONENTS PRIVATE LIMITED",
"RANVIK EXPORTS PRIVATE LIMITED",
"RANVIR NIRMAN PRIVATE LIMITED",
"RANZ INFRA PROJECTS PRIVATE LIMITED",
"RANZ VISION PRIVATE LIMITED",
"RAO AND KHAN MOTORS PRIVATE LIMITED",
"RAO AND SAPRU FILMS PRIVATE LIMITED",
"RAO BAHADUR ALATHUR NATHAMUNI CHETTY HIGHER SECONDARY SCHOOL",
"RAO BROTHERS CHIT-FUND PVT LTD",
"RAO COMPUTER CONSULTANTS PRIVATE LIMITED",
"RAO CONSTRUCTION PRIVATE LIMITED",
"RAO CONSTRUCTIONS",
"RAO CONSULTANTS PRIVATE LIMITED",
"RAO CORPORATE SERVICES PRIVATE LIMITED",
"RAO EDUSOLUTIONS PRIVATE LIMITED",
"RAO ELECTROMECHANICAL RELAYS PRIVATE LIMITED",
"RAO ENGINEERING INDIA PRIVATE LIMITED",
"RAO GUGAN RAM SIKSHA SAMITI",
"RAO HEALTH CARE PRIVATE LIMITED",
"RAO HOSPITAL",
"RAO IDEAL SERVICES PRIVATE LIMITED",
"RAO INFORMATION TECHNOLOGY PRIVATE LIMITED",
"RAO INSULATING CO. (P) LIMITED",
"RAO NURSING HOME",
"RAO OVERSEAS CONSULTANCY PRIVATE LIMITED",
"RAO PAHLAD SINGH DEGREE COLLEGE",
"RAO RAMCHANDER MEMORIAL PUBLIC SCHOOL",
"RAO SMART ACADEMY PRIVATE LIMITED",
"RAO TESLA RELAYS PRIVATE LIMITED",
"RAO TOURIST SERVICES PRIVATE LIMITED",
"RAO TRAVELS",
"RAO TRAVELS INDIA PRIVATE LIMITED",
"RAO TULA RAM MEMORIAL HOSPITAL",
"RAO'S GROUP OF SCHOOLS",
"RAOS INFOSOFT JOIN PRIVATE LIMITED",
"RAOTRANS MOVERS PRIVATE LIMITED",
"RAP INFOSOLUTIONS PRIVATE LIMITED",
"RAP INFOSYSYTEMS AND INSURANCE PRIVATE LIMITED",
"RAPANZAL FAB-TEX PRIVATE LIMITED",
"RAPAPORT DIAMOND SERVICES INDIA LLP",
"RAPAPORT INDIA PRIVATE LIMITED",
"RAPAR & DHRANGADHRA FARMERS PRODUCER COMPANY LIMITED",
"RAPAWALK FASHION TECHNOLOGIES PRIVATE LIMITED",
"RAPCO PACKERS",
"RAPHA DIAGNOSTICS PRIVATE LIMITED",
"RAPICUT CARBIDES LIMITED",
"RAPID (INDIA) LOGISTICS PRIVATE LIMITED",
"RAPID BEVTECH PRIVATE LIMITED",
"RAPID BIOPHARMA PRIVATE LIMITED",
"RAPID BIZ APPS PRIVATE LIMITED",
"RAPID CABS INDIA PRIVATE LIMITED",
"RAPID CARE TRANSCRIPTION PRIVATE LIMITED",
"RAPID CARRIERS P.LTD.",
"RAPID COAT DIVISION",
"RAPID CREATIONS PRIVATE LIMITED",
"RAPID CREDIT & HOLDINGS PRIVATE LIMITED",
"RAPID CUTTING TECHNOLOGIES INDIA PRIVATE LIMITED",
"RAPID DIAGNOSTIC PRIVATE LIMITED",
"RAPID ENGINEERING CO.PRIVATE.LIMITED",
"RAPID ENTERPRISES PRIVATE LIMITED",
"RAPID FLEET MANAGEMENT SERVICES LIMITED",
"RAPID FLOW INDIA PRIVATE LIMITED",
"RAPID GLOBAL BUSINESS SOLUTIONS INDIA PRIVATE LIMITED",
"RAPID GLOBEX PRIVATE LIMITED",
"RAPID GROW TECHNOLOGIES PRIVATE LIMITED",
"RAPID HEIGHTS PRIVATE LIMITED",
"RAPID INDIA FOOTWEAR PRIVATE LIMITED",
"RAPID INFRASTRUCTURE PRIVATE LIMITED",
"RAPID INFRASYSTEMS PRIVATE LIMITED",
"RAPID INVESTMENTS LIMITED",
"RAPID LIVE ENTERTAINMENT PRIVATE LIMITED",
"RAPID MACHINING TECHNOLOGIES PVT LTD",
"RAPID MANPOWERS & SOLUTION PRIVATE LIMITED",
"RAPID METRORAIL GURGAON LIMITED",
"RAPID METRORAIL GURGAON SOUTH LIMITED",
"RAPID MOULDERS PRIVATE LIMITED",
"RAPID MULTIMODAL LOGISTICS LIMITED",
"RAPID ORGANIC PRIVATE LIMITED",
"RAPID PACK ENGINEERING PRIVATE LIMITED",
"RAPID PUNCHING SOLUTIONS PRIVATE LIMITED",
"RAPID ROCK TOOLS PRIVATE LIMITED",
"RAPID SAFE SERVICES PRIVATE LIMITED",
"RAPID SOFTWARE CONSULTANCY SERVICES INDIA PRIVATE LIMITED",
"RAPID SOLUTIONS (I) PRIVATE LIMITED",
"RAPID TRANSPAY PRIVATE LIMITED",
"RAPID TRANSPORT CORPORATION PRIVATE LIMITED.",
"RAPID WOVENFAB PRIVATE LIMITED",
"RAPIDELO LOGISTICS PRIVATE LIMITED",
"RAPIDERA TECHNOLOGIES PRIVATE LIMITED",
"RAPIDEX STEELS PRIVATE LIMITED",
"RAPIDFIRE AND SAFETY ENGINEERS PRIVATE LIMITED",
"RAPIDFLOW APPS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"RAPIDION WATER PRIVATE LIMITED",
"RAPIDIT CLOUDBERA PRIVATE LIMITED",
"RAPIDLOOPS LOGISTICS PRIVATE LIMITED",
"RAPIDO BAZAAR PRIVATE LIMITED",
"RAPIDOPS SOLUTIONS PRIVATE LIMITED",
"RAPIDQUBE DIGITAL SOLUTIONS PRIVATE LIMITED",
"RAPIDRADIO SOLUTION PRIVATE LIMITED",
"RAPIDROP INDIA PRIVATE LIMITED",
"RAPIDSOFT TECHNOLOGIES PRIVATE LIMITED",
"RAPIDTHINK SOFTWARE INDIA PRIVATE LIMITED",
"RAPIDTRON ELECTRONIKA PRIVATE LIMITED",
"RAPIDUE TECHNOLOGIES PRIVATE LIMITED",
"RAPIER MACHINERY MANUFACTURING COMPANY INDIA PVT LTD",
"RAPINNO TECH SOLUTIONS PRIVATE LIMITED",
"RAPIPAY FINTECH PRIVATE LIMITED",
"RAPISCAN SYSTEMS PRIVATE LIMITED",
"RAPISCAN SYSTEMS PTE LTD",
"RAPL PROJECTS PRIVATE LIMITED",
"RAPOL SANIPLAST PRIVATE LIMITED",
"RAPP TRANSMISSION COMPANY LIMITED",
"RAPPID VALVES (INDIA) PRIVATE LIMITED",
"RAPPORT OUTDOOR ADVERTISING PRIVATE LIMITED",
"RAPPORTECH SOLUTIONS PRIVATE LIMITED",
"RAPPORTSOFT CONSULTING AND TECHNOLOGY PRIVATE LIMITED",
"RAPRA SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"RAPROSS PHARMACEUTICALS PRIVATE LIMITED",
"RAPS INFRATECH PRIVATE LIMITED",
"RAPS PROFESSIONAL SERVICES PRIVATE LIMITED",
"RAPSRI ENGINEERING PRODUCTS COMPANY LIMITED",
"RAPSRI ENGINEERING PRODUCTS COMPANY PRIVATE LIMITED",
"RAPT COMMERCIAL PRIVATE LIMITED",
"RAPT INFRA PRIVATE LIMITED",
"RAPTAKOS BRETT AND COMPANY LIMITED",
"RAPTAKOS BRETT TEST LABORATORIES LIMITED",
"RAPTBOT TECHNOLOGIES PRIVATE LIMITED",
"RAPTECH ENGINEERING PRIVATE.LIMITED",
"RAPTECH LABORATORIES PRIVATE LIMITED",
"RAPTI DEVELOPERS & PROMOTERS (INDIA) PRIVATE LIMITED",
"RAPTI GANGASAGAR INFRASTRUCTURE PRIVATE LIMITED",
"RAPTI INTERNATIONAL PRIVATE LIMITED",
"RAPTIM RESEARCH PRIVATE LIMITED",
"RAPTOR IT SOLUTIONS PRIVATE LIMITED",
"RAPTOR RESEARCH AND CONSERVATION FOUNDATION",
"RAPTOR TECHNOLOGIES INDIA PRIVATE LIMITED",
"RAPTURE HEALTH CARE PRIVATE LIMITED",
"RAPTURE INDIA FOOTCARE COMPANY PRIVATE LIMITED",
"RAPTURE LOGISTICS PRIVATE LIMITED",
"RAPURIA AGRO FOODS PRIVATE LIMITED",
"RAPYDER CLOUD SOLUTIONS PRIVATE LIMITED",
"RAPYUTA ROBOTICS PRIVATE LIMITED",
"RAQMIYAT INFORMATION TECHNOLOGY PRIVATE LIMITED",
"RAR ENTERPRISES PRIVATE LIMITED",
"RAR EXIM PRIVATE LIMITED",
"RAR FINCARE LIMITED",
"RAR HOTELS PRIVATE LIMITED",
"RAR SONS REALTORS INDIA PRIVATE LIMITED",
"RARA BROTHERS ENTERPRISES PRIVATE LIMITED",
"RARA CRAFTS PRIVATE LIMITED",
"RARA MERCANTILE PRIVATE LIMITED",
"RARAMURI CONSULTANCY SERVICES LLP",
"RARE ASSET RECONSTRUCTION LIMITED",
"RARE EARTH CONVEYORS PRIVATE LIMITED",
"RARE ENTERPRISES",
"RARE EQUITY PRIVATE LIMITED",
"RARE GARMENTS PVT LTD",
"RARE GEMS AND JEWELLERY COMPANY PVT LTD",
"RARE HOSPITALITY AND SERVICES PRIVATE LIMITED",
"RARE INFRA DEVELOPERS PRIVATE LIMITED",
"RARE LOGISTICS PRIVATE LIMITED",
"RARE MEDIA COMPANY PRIVATE LIMITED",
"RARE METABOLICS LIFE-SCIENCES PRIVATE LIMITED",
"RARE MINING PRIVATE LIMITED",
"RARE PLANET HANDICRAFTS PRIVATE LIMITED",
"RARE SREE BRANDS PRIVATE LIMITED",
"RARE SS PROPERTIES INDIA PRIVATE LIMITED",
"RARE TOWNSHIPS PRIAVTE LIMITED",
"RARE VECTORS PRIVATE LIMITED",
"RARECHAMP BUSINESS MANAGEMENT PRIVATE LIMITED",
"RAREFIELD ENGINEERS PRIVATE LIMITED",
"RAREPROB SOLUTIONS PRIVATE LIMITED",
"RARESPINE METALS & PROCESSORS PRIVATE LIMITED",
"RAREWALA STEELS & ALLOYS PRIVATE LIMITED",
"RAREX GLOBAL LLP",
"RARITAN INTERNATIONAL INDIA PRIVATE LIMITED",
"RARO STILE INTERIORS PRIVATE LIMITED",
"RAS ASSOCIATES",
"RAS BEARINGS PRIVATE LIMITED",
"RAS BIHARI BOSE SUBHARTI UNIVERISTY",
"RAS CITIES AND TOWNSHIPS PRIVATE LIMITED",
"RAS CONSTRUCTION CHEMICALS PRIVATE LIMITED",
"RAS DEVELOPMENTS PRIVATE. LIMITED.",
"RAS ENERGIA GAS SUPPLY PRIVATE LIMITED",
"RAS LIFE SCIENCES PRIVATE LIMITED",
"RAS LUXURIES PRIVATE LIMITED",
"RAS POLYPACK PRIVATE LIMITED",
"RAS POLYTEX PRIVATE LIMITED",
"RAS PUMPS PRIVATE LIMITED",
"RAS RESORT PRIVATE LIMITED",
"RAS RESORTS AND APART HOTELS LTD",
"RAS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"RAS TEK PRIVATE LIMITED",
"RASA AUTOCOM LIMITED",
"RASA MINE MACHINERY PRIVATE LIMITED",
"RASA SRI DEVELOPERS PRIVATE LIMITED",
"RASAAL INFRA PROJECTS PRIVATE LIMITED",
"RASAH EXIM PRIVATE LIMITED",
"RA-SAI PROPERTIES PRIVATE LIMITED",
"RASAII FLOW LINES PRIVATE LIMITED",
"RASAIR ENGINEERS PRIVATE LIMITED",
"RASALAS SENTINALS PRIVATE LIMITED",
"RASAM ENGINEERS PRIVATE LIMITED",
"RASANDIK AUTO COMPONENTS PRIVATE LIMITED",
"RASANDIK ENGINEERING INDUSTRIES INDIA LIMITED",
"RASAPOORNA FOODS PRIVATE LIMITED",
"RASASHRAM PHARMA LABORATRIES PRIVATE LIMITED",
"RASATANTRA FOODS PRIVATE LIMITED",
"RASAYAN AGRO PRIVATE LIMITED",
"RASAYAN DRUGS PRIVATE LIMITED",
"RASAYAN LIFESTYLES PRIVATE LIMITED",
"RASAYAN MARKETING PRIVATE LIMITED",
"RASBRO CLOTHING PRIVATE LIMITED",
"RASCHIG PMC INDIA PRIVATE LIMITED",
"RASCO AUTOMOTIVE SYSTEMS PRIVATE LIMITED",
"RASE FEEDS PRIVATE LIMITED",
"RASESH JEWELS LLP",
"RASESHWARI HOTELS PRIVATE LIMITED",
"RASESHWARI METALLICS PRIVATE LIMITED",
"RASESWAR RICE MILL PRIVATE LIMITED",
"RASH BEHARI CONSTRUCTION PRIVATE LIMITED",
"RASH BUILDERS INDIA PRIVATE LIMITED",
"RASHA COSMETICS PRIVATE LIMITED",
"RASHA IND. PVT LTD",
"RASHA PETROLEUM PRIVATE LIMITED",
"RASHEE CONTROL EQUIPMENTS PRIVATE LIMITED",
"RASHEEDIA URDU HIGH SCHOOL",
"RASHI AGRO INDUSTRIES PRIVATE LIMITED",
"RASHI BIOTECH PRIVATE LIMITED",
"RASHI BUILDCON PRIVATE LIMITED",
"RASHI CABLES PRIVATE LIMITED",
"RASHI COOLING TOWERS PRIVATE LIMITED",
"RASHI DESIGN SOLUTIONS PRIVATE LIMITED",
"RASHI DUDH SAGAR PRIVATE LIMITED",
"RASHI EATABLES PRIVATE LIMITED",
"RASHI ECO TOURISM LIMITED",
"RASHI ENTERTAINMENT PRIVATE LIMITED",
"RASHI EQUISEARCH PRIVATE LIMITED",
"RASHI FINCORP LIMITED",
"RASHI GLOBAL PRIVATE LIMITED",
"RASHI GRANITE EXPORTS INDIA LIMITED",
"RASHI PACKS PRIVATE LIMITED",
"RASHI PAPER HOUSE PRIVATE LIMITED",
"RASHI PERIPHERALS LIMITED",
"RASHI PHARMA CARE PRIVATE LIMITED",
"RASHI PHARMACEUTICALS PRIVATE LIMITED",
"RASHI SALES PRIVATE LIMITED",
"RASHI SHIPPING SERVICES PRIVATE LIMITED",
"RASHI STEEL AND POWER LIMITED",
"RASHID AND SONS COLD STORAGE PRIVATE LIMITED",
"RASHID REFREGERATION PRIVATE LIMITED",
"RASHIDHAN SALES PRIVATE LIMITED",
"RASHIK BIHARI FOOD PRODUCT PRIVATE LIMITED",
"RASHIKA MINERALS PRIVATE LIMITED",
"RASHLEELA ENTERPRISES PRIVATE LIMITED",
"RASHMI AMEYA DEVELOPERS HOUSING AND ESTATE REALTORS PRIVATE LIMITED",
"RASHMI CEMENT LIMITED",
"RASHMI COMMERCIAL CO LTD",
"RASHMI ENGICON PRIVATE LIMITED",
"RASHMI ENTERPRISES",
"RASHMI EXPORTS PRIVATE LIMITED",
"RASHMI FASHIONS PVT LTD",
"RASHMI FOODS PRIVATE LIMITED",
"RASHMI GROUP",
"RASHMI HEATERS PRIVATE LIMITED",
"RASHMI HOSPITALITY SERVICES PRIVATE LIMITED",
"RASHMI HOUSING SPV PRIVATE LIMITED",
"RASHMI INDUSTRIES",
"RASHMI IRON INDUSTRIES PRIVATE LIMITED",
"RASHMI ISPAT LIMITED",
"RASHMI ISPAT PRIVATE LIMITED",
"RASHMI MEDICAL CENTRE PRIVATE LIMITED",
"RASHMI METALIKS LIMITED",
"RASHMI PHARMA PRIVATE LIMITED",
"RASHMI POLYFAB PRIVATE LIMITED",
"RASHMI RARE EARTH LIMITED",
"RASHMI REALTY BUILDERS PRIVATE LIMITED",
"RASHMI RICE MILLS PRIVATE LIMITED",
"RASHMI SALES PRIVATE LIMITED",
"RASHMI SHARMA TELEFILMS PRIVATE LIMITED",
"RASHMI SPONGE IRON AND POWER INDUSTRIES LIMITED.",
"RASHMI STEELS",
"RASHMI TRANSPORT PRIVATE LIMITED",
"RASHMI UMBRELLA PRIVATE LIMITED",
"RASHMINBHAI SHANTILAL ZINZUWADIA PRIVATE LIMITED",
"RASHMITHA INFORMATION SYSTEMS PRIVATE LIMITED",
"RASHPAL SINGH AND CO",
"RASHTRA DEEPIKA LTD",
"RASHTRA UDHYOG LTD",
"RASHTRABHASHA PRACHAR SAMITI",
"RASHTRAKAVI MAITHILI SHARAN GROUP PUBLIC SCHOOL CHIRGAON",
"RASHTRAMATA INDIRA PRIMARY SCHOOL",
"RASHTRAMATA LNDIRA GANDHI COLLEGE JALNA",
"RASHTRAPITA SMARAK INTER COLLEGE",
"RASHTRASANT TUKADOJI MAHARAJ NAGPUR UNIVERSITY",
"RASHTRIYA AYURVEDIC SANSTHAN HOSPITAL",
"RASHTRIYA CHEMICALS & FERTLIZERS LIMITED",
"RASHTRIYA E MARKET SERVICES PRIVATE LIMITED",
"RASHTRIYA HIGH SCHOOL AND JUNIOR COLLEGE OF SCIENCE ACHALPUR",
"RASHTRIYA INDIAN MILITARY COLLEGE GARHI CANTT",
"RASHTRIYA INTER COLLEGE",
"RASHTRIYA INTER COLLEGE AKRABAD ALIGARH",
"RASHTRIYA ISPAT NIGAM LIMITED",
"RASHTRIYA METAL INDUSTRIES LIMITED",
"RASHTRIYA NAVODAYA VIDYA KENDRA",
"RASHTRIYA RAKSHA UNIVERSITY",
"RASHTRIYA SANSKRIT SANSTHAN",
"RASHTRIYA SANSKRIT SNATAKOTTAR MAHAVIDYALAYA, DOBHI, CHANDAVAK",
"RASHTRIYA SHRAMIK HIGH SCHOOL FIROZABAD",
"RASHTRIYA UDYOG ASHRAM INTER COLLEGE",
"RASHTROTTHANA PARISHAT",
"RASHUL METAL RECYCLING PRIVATE LIMITED",
"RASI ELECTRODES LIMITED",
"RASI G-ENERGY PRIVATE LIMITED",
"RASI GRAPHICS PRIVATE LIMITED",
"RASI HYGIENE CARE PRIVATE LIMITED",
"RASI INNOVATION PRIVATE LIMITED",
"RASI NUTRI FOODS INDIA PRIVATE LIMITED",
"RASI SEEDS PRIVATE LIMITED",
"RASI TEX INDIA PRIVATE LIMITED",
"RASI TRAVELS & CARGO PRIVATE LIMITED",
"RASIF INFRATECH PRIVATE LIMITED",
"RASIIM VENTURES LLP",
"RASIK EXTERIOR PRIVATE LIMITED",
"RASIK INFRACON PRIVATE LIMITED",
"RASIK PRODUCTS PRIVATE LIMITED",
"RASIK REMEDIES PRIVATE LIMITED",
"RASIK SOFTWARE PRIVATE LIMITED",
"RASIK VATIKA CLOTHING PRIVATE LIMITED",
"RASIK VATIKA SILK MILLS PRIVATE LIMITED",
"RASIK VATIKA WEAVES PRIVATE LIMITED",
"RASIKA AGRO PROCESSING FARMER PRODUCER COMPANY LIMITED",
"RASIKA MERCHANDISE PRIVATE LIMITED",
"RASIKA TRAVELS PRIVATE LIMITED",
"RASIKLAL & BROTHERS ENTERPRISE PRIVATE LIMITED",
"RASIKLAL AND CO PVT LTD",
"RASILA BUILDCON PRIVATE LIMITED",
"RASILA PROJECTS & SERVICES PRIVATE LIMITED",
"RASIM EXPORTS PRIVATE. LIMITED.",
"RASINO DRUGS PRIVATE LIMITED",
"RASINO HERBES PRIVATE LIMITED",
"RASITOL BEVERAGES PRIVATE LIMITED",
"RASMAN TECHNOLOGIES PRIVATE LIMITED",
"RASMI ASSOCIATES PRIVATE LIMITED",
"RASMI DRINKS PRIVATE LIMITED",
"RASMI FOIL AND CONVERTERS PRIVATE LIMITED",
"RASMITA PLY AND HARDWARE TRADERS PRIVATE LIMITED",
"RASM-O-RIWAZ COLLECTIONS PRIVATE LIMITED",
"RASNA NATURALS PRIVATE LIMITED",
"RASNA PRIVATE LIMITED",
"RASNA PROCESSORS PRIVATE LIMITED",
"RASNAM FOODS PRIVATE LIMITED",
"RASOI LIMITED",
"RASOI MAGIC FOODS INDIA PRIVATE LIMITED",
"RASOISHOP VENTURES PRIVATE LIMITED",
"RASONAMOYEE JEWELLERS PRIVATE LIMITED",
"RA-SOURCE PRIVATE LIMITED",
"RASP INDIA PRIVATE LIMITED",
"RASPBERRY RHODOLITE PRIVATE LIMITED",
"RASPL INDUSTRIES PRIVATE LIMITED",
"RASPN SHIPPING SERVICES PRIVATE LIMITED",
"RASRAJ REALTORS PRIVATE LIMITED",
"RASRANJAN FOOD PRODUCTS PVT LTD",
"RASRASNA FOODS PRIVATE LIMITED",
"RASS PROJECT CONSULTANTS PRIVATE LIMITED",
"RASS SALES SYSTEMS INDIA PRIVATE LIMITED",
"RASSAA CREATIONS AND INNOVATIONS PRIVATE LIMITED",
"RASSAZ INFRASTRUCTURE PRIVATE LIMITED",
"RASSCO STEELS LIMITED",
"RASSHI LUXURY PRIVATE LIMITED",
"RASSI IRON & STEEL PRIVATE LIMITED",
"RASTA PETH EDN.SOCIETY PRA.VIDYA.SOMWAR PETH PUNE",
"RASTA VENTURES PRIVATE LIMITED",
"RASTER ENGINEERS PRIVATE LIMITED",
"RASTER IMAGES PRIVATE LIMITED",
"RASTEY COMMUTING SERVICES PRIVATE LIMITED",
"RASTOGI APPARELS (INDIA) PRIVATE LIMITED",
"RASTOGI BROTHERS PAPER CONVERTOR PRIVATE LIMITED",
"RASTOGI BUILDERS PRIVATE LIMITED",
"RASTOGI FASHIONS PRIVATE LIMITED",
"RASTOGI FURNISHERS AND DECORATORS PVT. LTD",
"RASTOGI GLASSES PRIVATE LIMITED",
"RASTOGI INDUSTRIES LIMITED",
"RASTRASANT TUKADOJI MAHARAJ NAGPUR UNIVERSITY",
"RASTRIYA ADARSH VIDYALAYA MANSAR",
"RASTRIYA INTER COLLEGE KAMALPUR",
"RASTRIYA MARKETING PRIVATE LIMITED",
"RASTRIYE INTER COLLEGE TURKAULIYA SIDDHARTH NAGAR",
"RASU INDUSTRIES INDIA PRIVATE LIMITED",
"RASUN ACE INFRA PRIVATE LIMITED",
"RASUN EXPORTS PRIVATE LIMITED",
"RASVICK APPARELS PRIVATE LIMITED",
"RASVIN MOBILES PRIVATE LIMITED",
"RATAAN FAB TEX PRIVATE LIMITED",
"RATABHE RENEWABLE ENERGY PRIVATE LIMITED",
"RATAK INDUSTRIAL PRODUCTS PRIVATE LIMITED",
"RATAL ADVANCED TECHNOLOGIES PRIVATE LIMITED",
"RATAN AGRI FOODS PRIVATE LIMITED",
"RATAN ALUMINUM RECYCLING PRIVATE LIMITED",
"RATAN BANDHU FABRICS PVT LTD",
"RATAN BARJATIYA SPINNERS PRIVATE LIMITED",
"RATAN BATRA PRIVATE LIMITED",
"RATAN BUILDTECH PRIVATE LIMITED",
"RATAN COAL SUPPLIERS PRIVATE LIMITED",
"RATAN COAL TRADING PRIVATE LIMITED",
"RATAN COLD STORAGE LTD",
"RATAN CORPORATION PRIVATE LIMITED",
"RATAN DEEP JEWELLERS PRIVATE LIMITED",
"RATAN ELECTRONICS INDIA PRIVATE LIMITED",
"RATAN ENGINEERING COMPANY PRIVATE LIMITED",
"RATAN GIRI CONSULTANCY PVT.LTD.",
"RATAN GRAMODYOG SANSTHAN",
"RATAN HOLDINGS PVT LTD",
"RATAN HOMES PRIVATE LIMITED",
"RATAN HOUSING DEVELOPMENT LIMITED",
"RATAN IMPEX",
"RATAN IMPEX PRIVATE LIMITED",
"RATAN INDUSTRIES LIMITED",
"RATAN J BATLIBOI CONSULTANTS PRIVATE LIMITED",
"RATAN JYOTI NETRALAYA PRIVATE LIMITED",
"RATAN MEDICOS PRIVATE LIMITED",
"RATAN MICA EXPORTS PRIVATE LIMITED",
"RATAN PAPERS PRIVATE LIMITED",
"RATAN PLANTATIONS LIMITED",
"RATAN POWER-TECH PRIVATE LIMITED",
"RATAN PREM DAV GIRLS INTER COLLEGE",
"RATAN PROJECTS & ENGINEERING CO. PRIVATE LIMITED",
"RATAN SAMAJ JUNIOR HIGH SCHOOL",
"RATAN TEXPROCESS PRIVATE LIMITED",
"RATAN TEXTILES PRIVATE LIMITED",
"RATAN WOOD PRIVATE LIMITED",
"RATANAKAR WIRE PRIVATE LIMITED",
"RATANCHAND HIRACHAND FOUNDATION",
"RATANCHAND INVESTMENT PRIVATE LIMITED",
"RATANDEEP AUTOMOBILES PRIVATE LIMITED",
"RATANDEEP HOSPITAL",
"RATANGIRI INNOVATIONS PRIVATE LIMITED",
"RATANHIRA TEXTILES PRIVATE. LIMITED.",
"RATANJYOT CORPORATION",
"RATANLAL SARAF JWELLERS (DATIAWALE) PRIVATE LIMITED",
"RATANMOTI TEXFAB INDIA PRIVATE LIMITED",
"RATANPUR COLD STORAGE PRIVATE LIMITED",
"RATANPURI GRAINS AND FOODS PRIVATE LIMITED",
"RATAN-SEVA AUTOMOBILES PRIVATE LIMITED",
"RATANSHI KHERAJ SAREES PRIVATE LIMITED",
"RATANSHREE APPARELS PRIVATE LIMITED",
"RATCHET PHARMA PRIVATE LIMITED",
"RA-TECH ENGINEERING LLP",
"RATED JEWELLERY PRIVATE LIMITED",
"RATEDI WIND POWER PRIVATE LIMITED",
"RATEGAIN TRAVEL TECHNOLOGIES PRIVATE. LIMITED",
"RATEK PHEON FRICTION TECHNOLOGIES PRIVATE LIMITED",
"RATEON TECHNOLOGIES PRIVATE LIMITED",
"RATERIA EXIM PRIVATE LIMITED",
"RATERIA LAMINATORS PRIVATE LIMITED",
"RATH INFOTECH & WEB SOLUTIONS PRIVATE LIMITED",
"RATHAN DIA JEWELS INDIA PRIVATE LIMITED",
"RATHAT SOLUTIONS PRIVATE LIMITED",
"RATHEE BUILDWAY PRIVATE LIMITED",
"RATHI & RATHI HOSIERY TRADERS PRIVATE LIMITED",
"RATHI ADHESIVE TAPE PRIVATE LIMITED",
"RATHI AUTO PRIVATE LIMITED",
"RATHI BARS LIMITED",
"RATHI BROTHERS (TEXTILES) PVT LTD",
"RATHI BROTHERS POONA LIMITED",
"RATHI CREATIONS PRIVATE LIMITED",
"RATHI DECOR (INDIA) PRIVATE LIMITED",
"RATHI DYE CHEM PRIVATE LIMITED",
"RATHI ENGINEERING SOLUTIONS PRIVATE LIMITED",
"RATHI FASHIONS PRIVATE LIMITED",
"RATHI FEEDS INDIA PRIVATE LIMITED",
"RATHI FINANCIAL SERVICES LIMITED",
"RATHI FINLEASE PRIVATE LIMITED",
"RATHI FINVEST PVT LTD",
"RATHI GDR BROTHERS PRIVATE LIMITED",
"RATHI GOLD COVERING WORKS",
"RATHI HATCHERIES PRIVATE LIMITED",
"RATHI HYDRO PROJECTS PRIVATE LIMITED",
"RATHI INDUSTRIAL CORPORATION PRIVATE LIMITED",
"RATHI INDUSTRIES LIMITED",
"RATHI IRON STEEL PRIVATE LIMITED",
"RATHI LABORATORIES (HINDUSTAN ) PVT LTD",
"RATHI LOHA IMPEX PRIVATE LIMITED",
"RATHI MANUFACTURING COMPANY PRIVATE LIMITED",
"RATHI MOTORS (SHUJALPUR) PRIVATE LIMITED",
"RATHI OXYGEN PRIVATE LIMITED",
"RATHI PACKAGING PRIVATE LIMITED",
"RATHI POLY INFRA PRIVATE LIMITED",
"RATHI POLY PLAST PRIVATE LIMITED",
"RATHI POWERTECH GLOBAL PRIVATE LIMITED",
"RATHI PUMPS PRIVATE LIMITED",
"RATHI SALT AND GRAINS PRIVATE LIMITED",
"RATHI SONS ALGLAZE PRIVATE LIMITED",
"RATHI SPECIAL STEELS LIMITED",
"RATHI STEEL AND POWER LIMITED",
"RATHI STEEL INDUSTRIES PRIVATE LIMITED",
"RATHI TECHSERVICES PRIVATE LIMITED",
"RATHI TEXFAB PRIVATE LIMITED",
"RATHI TEXTILES PRIVATE LIMITED",
"RATHI TILES PRIVATE LIMITED",
"RATHI TRADELINK PRIVATE LIMITED",
"RATHI TRANSPOWER PRIVATE LIMITED",
"RATHI TURBOFLEX PRIVATE LIMITED",
"RATHI VYAPAR & VINIMAY PRIVATE LIMITED",
"RATHI WOOLLENS LIMITED",
"RATHICKAL KOOTAIMA TRADING LIMITED",
"RATHIESH AGRO SERVICES PRIVATE LIMITED",
"RATHINAM ARUMUGAM RESEARCH AND EDUCATIONAL FOUNDATION",
"RATHINAM COLD STORAGE PRIVATE LIMITED",
"RATHINAM COLLEGE ARTS AND SCIENCE",
"RATHINAM GOLD AND DIAMOND PRIVATE LIMITED",
"RATHINAM GROUP OF INSTITUTION",
"RATHINAM SHELTERS PRIVATE LIMITED",
"RATHNA BIOLIFE PRIVATE LIMITED",
"RATHNA COOLS PRIVATE LIMITED",
"RATHNA FAN HOUSE PRIVATE LIMITED",
"RATHNA FERTILITY CENTRE INDIA PRIVATE LIMITED",
"RATHNA NETWORK & COMMUNICATIONS PRIVATE LIMITED",
"RATHNA OFFSET PRINTERS",
"RATHNA PACKAGING INDIA PRIVATE LIMITED",
"RATHNA RESORTS PRIVATE LIMITED",
"RATHNA STEELS PRIVATE LIMITED",
"RATHNAIAH ENGINEERING INDUSTRIES PRIVATE LIMITED",
"RATHNAM GROUP OF INSTITUTION",
"RATHNAMMA INFRATECH PRIVATE LIMITED",
"RATHNASWAMI SPINNERS PRIVATE LIMITED",
"RATHNAVEL SUBRAMANIAM EDUCATIONAL TRUST",
"RATHOD AUTOLINK PRIVATE LIMITED",
"RATHOD BUILD MART PRIVATE LIMITED",
"RATHOD CARS PRIVATE LIMITED",
"RATHOD INDUSTRIES",
"RATHOD JEWELLERY MANUFACTURING PRIVATE LIMITED",
"RATHORE INFRA PROJECT PRIVATE LIMITED",
"RATHORE ORGANIC FARMING PRODUCER COMPANY LIMITED",
"RATHORE POOJA PRODUCTS PRIVATE LIMITED",
"RATHORE RETAIL (INDIA) PRIVATE LIMITED",
"RATI DIAMONDS PRIVATE LIMITED",
"RATI GREENTECH PRIVATE LIMITED",
"RATI INFRASTRUCTURE PRIVATE LIMITED",
"RATI LOGISTICS PRIVATE LIMITED",
"RATI PUSHP INTERMEDIATES PRIVATE LIMITED",
"RATI RAM RAM VINOD DESIGNER SAREES PRIVATE LIMITED",
"RATI RAM RAM VINOD SAREES STUDIO PRIVATE LIMITED",
"RATILAL BHAGWANDAS CONSTRUCTION COMPANY PRIVATE LIMITED",
"RATIO 3 EXHIBITS PRIVATE LIMITED",
"RATIO TRADING PRIVATE LIMITED",
"RATIONAL ART AND PRESS PRIVATE LIMITED",
"RATIONAL BUSINESS CORPORATION PRIVATE LIMITED",
"RATIONAL CONSTRUCTIONS PRIVATE LIMITED",
"RATIONAL ENGINEERS LIMITED",
"RATIONAL HANDLOOM COMPANY PRIVATE LIMITED",
"RATIONAL INTERNATIONAL INDIA PRIVATE LIMITED",
"RATIONAL LABS PRIVATE LIMITED",
"RATIONAL OFFSHORE ENTERPRISES PRIVATE LIMITED",
"RATIONAL SERVICES INDIA LLP",
"RATIONALS INFRASTRUCTURE ENGINEERING CONSULTANTS PRIVATE LIMITED",
"RATKAL SPECIALITY HOSPITALS PRIVATE LIMITED",
"RATLAM ABHUSHAN PRIVATE LIMITED",
"RATLAM ADIWASI KISAN PRODUCER COMPANY LIMITED",
"RATLAM DIVISION",
"RATLAM WIRES PRIVATE LIMITED",
"RATLE HYDROELECTRIC POWER CORPORATION LIMITED",
"RATNA COMMERCIAL ENTERPRISES PRIVATE LTD.",
"RATNA DEEP JEWELLERS PRIVATE LIMITED",
"RATNA EXTRUSIONS PRIVATE LIMITED",
"RATNA GEARS PRIVATE LIMITED",
"RATNA GLOBAL TECHNOLOGIES PRIVATE LIMITED",
"RATNA HOME PRODUCTS PRIVATE LIMITED",
"RATNA HOUSING AND ESTATES PRIVATE LIMITED",
"RATNA INDIA LIMITED",
"RATNA INFRACON PRIVATE LIMITED",
"RATNA INFRAESTATES PRIVATE LIMITED",
"RATNA INFRASTRUCTURE PROJECTS PRIVATE LIMITED",
"RATNA JR COLLEGE",
"RATNA MACHINES PRIVATE LIMITED",
"RATNA MANDIR JEWELLERS PRIVATE LIMITED",
"RATNA MEMORIAL HOSPITAL",
"RATNA NANDAN COMMERCIALS PVT LTD",
"RATNA NICO CHEM PVT LTD",
"RATNA NURSING HOME PRIVATE LIMITED",
"RATNA PLASTICS LIMITED",
"RATNA SAGAR JEWELS PRIVATE LIMITED",
"RATNA SAGAR PRIVATE LIMITED",
"RATNA WEAVE TECH PRIVATE LIMITED",
"RATNAA SHREE ANANDHAAS HOTELS PRIVATE LIMITED",
"RATNAAFIN CAPITAL PRIVATE LIMITED",
"RATNAAFIN ENTERPRISE PRIVATE LIMITED",
"RATNAAFIN INSURANCE BROKING PRIVATE LIMITED",
"RATNAAKAR INFRATECH PRIVATE LIMITED",
"RATNABALI EQUITY PRIVATE LIMITED",
"RATNABALI INVESTMENT PRIVATE LIMITED",
"RATNABALI SECURITIES PRIVATE LIMITED",
"RATNABHUMI STEELTECH PRIVATE LIMITED",
"RATNACHINTAMANI METALLOYS PRIVATE LIMITED",
"RATNADEEP INFRASTRUCTURE PRIVATE LIMITED",
"RATNADEEP METAL AND TUBES LIMITED",
"RATNADEEP RETAIL PRIVATE LIMITED",
"RATNADHAR INFRA PRIVATE LIMITED",
"RATNAFLEX ENGINEERING PRIVATE LIMITED",
"RATNAGIRI CERAMICS PRIVATE LIMITED",
"RATNAGIRI DISTRICT SECURITY GUARD BOARD",
"RATNAGIRI GAS AND POWER PRIVATE LIMITED",
"RATNAGIRI IMPEX PRIVATE LIMITED",
"RATNAGIRI INTERNATIONAL",
"RATNAGIRI NAGAR PARISHAD",
"RATNAGIRI REFINERY AND PETROCHEMICALS LIMITED",
"RATNAGIRI STAINLESS PRIVATE LIMITED",
"RATNAGIRI WIND POWER PROJECTS PRIVATE LIMITED",
"RATNAJEET POLYCORP PVT.LTD.",
"RATNAJYOT STEEL AND PIPES PRIVATE LIMITED",
"RATNAKA RESINS PRIVATE LIMITED",
"RATNAKALA EXPORTS PRIVATE LIMITED",
"RATNAKALA POWER GENERATION PRIVATE LIMITED",
"RATNAKAR BARTER PRIVATE LIMITED",
"RATNAKAR INDIA LIMITED",
"RATNAKAR ISPAT INDIA PRIVATE LIMITED",
"RATNAKAR REALTIES PRIVATE LIMITED",
"RATNAKAR SECURITIES PRIVATE LIMITED",
"RATNAKAR STEEL WORKS PRIVATE LIMITED",
"RATNALEKSSHMI PRECISION TOOLS PRIVATE LIMITED",
"RATNAM AQUA PRIVATE LIMITED",
"RATNAM ENERGY PRIVATE LIMITED",
"RATNAM ENTERPRISE",
"RATNAM INFRA INDUSTRIES PRIVATE LIMITED",
"RATNAM LAMINATES PRIVATE LIMITED",
"RATNAM LUBRICANTS PVT. LTD.",
"RATNAM POULTRY PRIVATE LIMITED",
"RATNAM VINIMAY PVT. LTD.",
"RATNAMAHAL PROPERTIES PRIVATE LIMITED",
"RATNAMALA SALES AND DISTRIBUTIONS PRIVATE LIMITED",
"RATNAMANI BIO-CHEMICALS AND PHARMACEUTICLAS PRIVATE LTD",
"RATNAMANI IMPEX PRIVATE LIMITED",
"RATNAMANI MARKETING PRIVATE LIMITED",
"RATNAMANI METALS AND TUBES LIMITED",
"RATNAMANI TECHNO CASTS PRIVATE LIMITED",
"RATNANGI JEWELLERS PRIVATE LIMITED",
"RATNAPARKHI ELECTRONIC INDUSTRIES PRIVATE LIMITED",
"RATNAPPRABBHA CARS PRIVATE LIMITED",
"RATNAPPRABBHA MOTORS",
"RATNAPRABHA NURSING INSTITUTE",
"RATNAPRIYA DEVELOPERS PRIVATE LIMITED",
"RATNAPRIYA DYEING AND PRINTING MILLS PRIVATE LIMITED",
"RATNAPRIYA IMPEX PRIVATE LIMITED",
"RATNAPRIYA INFRASTRUCTURE PRIVATE LIMITED",
"RATNASHEETAL PANELS PRIVATE LIMITED",
"RATNASHIL ONLINE SERVICES PRIVATE LIMITED",
"RATNASHRI ALUMINIUM PRIVATE LIMITED",
"RATNASWARNA JEWELLERS INDIA PRIVATE LIMITED",
"RATNATECH STAHL PRIVATE LIMITED",
"RATNATRIS PHARMACEUTICALS PRIVATE LIMITED",
"RATNAURJA PRIVATE LIMITED",
"RATNAVEER PRECISION ENGINEERING LIMITED",
"RATNESH CONSTRUCTION PRIVATE LIMITED",
"RATNESH ENGINEERING PRIVATE LIMITED",
"RATNESH ISPAT SERVICES PRIVATE LIMITED",
"RATNESH METAL INDUSTRIES PRIVATE. LIMITED.",
"RATNESH MULTI PRODUCTS PRIVATE LIMITED",
"RATNIDEVI MURLIDHAR BAWRI SOCIAL WELFARE FOUNDATION",
"RATO COMMUNICATIONS AND ELECTRONICS PRIVATE LIMITED",
"RATRA HEALTHCARE PRIVATE LIMITED",
"RATTAN BUILDERS PRIVATE LIMITED",
"RATTAN ENTERPRISES",
"RATTAN HOSE AND ENGINEERING WORKS PVT LTD",
"RATTAN INDUSTRIAL (INDIA) PRIVATE LIMITED",
"RATTAN ISPAT PRIVATE LIMITED",
"RATTAN LAL DIAMOND JEWELLERS PRIVATE LIMITED",
"RATTAN LALL AUTO PVT. LTD",
"RATTAN MILK SPECIALITIES PRIVATE LIMITED",
"RATTAN ORGANIC FOODS PRIVATE LIMITED",
"RATTAN POLYCHEM PRIVATE LIMITED",
"RATTAN POWER PRESSES PRIVATE LIMITED",
"RATTAN PROPERTIES AND PROJECTS PRIVATE LIMITED",
"RATTAN S. GROVER PRIVATE LIMITED",
"RATTAN SINGH BUILDERS PRIVATE LIMITED",
"RATTAN SPIRIT PRIVATE LIMITED",
"RATTANINDIA APNA SOLAR LIMITED",
"RATTANINDIA NASIK POWER LIMITED",
"RATTANINDIA POWER LIMITED",
"RATTANSARAF AND SONS PRIVATE LIMITED",
"RATTHA HOLDING COMPANY PRIVATE LIMITED",
"RATTHA SOMERSET GREENWAYS CHENNAI PRIVATE LIMITED",
"RATTIRAMS OVERSEAS PRIVATE LIMITED",
"RATTNANJALEE JEWEL INDIA PRIVATE LIMITED",
"RATUSARIA INDUSTRIES PRIVATE LIMITED",
"RATUSARIA STEELS PRIVATE LIMITED",
"RATUSARIA UDYOG PRIVATE LIMITED",
"RATYAL CONSTRUCTIONS PRIVATE LIMITED",
"RAU AND CO PHARMA PRIVATE LIMITED",
"RAU PITHAMPUR INFRASTRUCTURE PRIVATE LIMITED",
"RAUDRA EDUSERVICES PRIVATE LIMITED",
"RAUDRA TECHNOCRATS PRIVATE LIMITED",
"RAULIMEX INDUSTRIES PRIVATE LIMITED",
"RAUNAK CERAMICS PRIVATE LIMITED",
"RAUNAK COIRS LIMITED",
"RAUNAK DREAM DEVELOPERS PRIVATE LIMITED",
"RAUNAK HANDLOOMS PRIVATE LIMITED",
"RAUNAK KITCHEN EQUIPMENTS PRIVATE LIMITED",
"RAUNAK PROPERTIES PRIVATE LIMITED",
"RACL GEARTECH LIMITED",
"RAUNAQ ENGINEERING PRIVATE LIMITED",
"RAUNAQ ENTERPRISES LTD",
"RAUNAQ EPC INTERNATIONAL LIMITED",
"RAUNAQ FABRICS PRIVATE LIMITED",
"RAUNAQ INTERNATIONAL LIMITED",
"RAUNAQ LABORATORIES LTD",
"RAUNAQ PLASTICS LIMITED",
"RAUNAQ STEELS TRADING PRIVATE LIMITED",
"RAUNIT ELECTRICALS PRIVATE LIMITED",
"RAUS I A S STUDY CIRCLE PRIVATE LIMITED",
"RAUSCHERT INDIA PRIVATE LIMITED",
"RAUSHAN ENGINEERS PRIVATE LIMITED",
"RAUSHAN INFRABUILD PRIVATE LIMITED",
"RAUSHEENA UDYOG LIMITED",
"RAUT ENGINEERING PRIVATE LIMITED",
"RAUT INDUSTRIES PRIVATE LIMITED",
"RAUT SERUMS INDIA PRIVATE. LIMITED.",
"RAUT UNI-TECH PRIVATE LIMITED",
"RAUT VENTURES PRIVATE LIMITED",
"RAV BEST FOODS PRIVATE LIMITED",
"RAV CHEM SPECIALTIES PRIVATE LIMITED",
"RAV GLOBAL SOLUTIONS PRIVATE LIMITED",
"RAV INDUSTRIES PRIVATE LIMITED",
"RAV RESEARCH PRIVATE LIMITED",
"RAV SAN VIK FOUNDATION",
"RAV SECURITIES PRIVATE LIMITED",
"RAVA AGRI CHEMICALS PRIVATE LIMITED",
"RAVA HI TECH RUDRAPUR PRIVATE LIMITED",
"RAVAGO MANUFACTURING INDIA PRIVATE LIMITED",
"RAVAL INTERNATIONAL SCHOOL",
"RAVALGAON SUGAR FARM LIMITED",
"RAVALI SPINNERS PRIVATE LIMITED",
"RAVALNATH FOREX PRIVATE LIMITED",
"RAVALSON FRP INDUSTRIES PRIVATE LIMITED",
"RAVANDE FARMERS PRODUCER COMPANY LIMITED",
"RAVANO SOLAR INDIA PRIVATE LIMITED",
"RAVAPA GLOBAL ENTERPRISES PRIVATE LIMITED",
"RAVAR TECH (OPC) PRIVATE LIMITED",
"RAVASCO TRANSMISSION AND PACKING PRIVATE LIMITED",
"RAVASIYA PRIMARY SCHOOL",
"RAVE COMTEK SOLUTIONS PRIVATE LIMITED",
"RAVE ENTERTAINMENT NETWORKS",
"RAVE INFOSYS PRIVATE LIMITED",
"RAVE MAXPRO IT SOLUTIONS LIMITED",
"RAVE MOTI ENTERTAINMENT PRIVATE LIMITED",
"RAVE REAL ESTATE PRIVATE LIMITED",
"RAVECHI ENTERPRISES PRIVATE LIMITED",
"RAVECHI STEEL PRIVATE LIMITED",
"RAVED TECHNOLGIES PRIVATE LIMITED",
"RAVEENDRA ROCK PRODUCTS PRIVATE LIMITED",
"RAVEL ELECTRONICS PRIVATE LIMITED",
"RAVEL HITEKS P LIMITED",
"RAVEL MOVEMENT CONTROL PRIVATE LIMITED",
"RAVELS APPARELS PRIVATE LIMITED",
"RAVEN LOGISTICS PRIVATE LIMITED",
"RAVEN360 INDIA PRIVATE LIMITED",
"RAVENBECK SECURITY INDIA LIMITED",
"RAVENBECK TELECOMMUNICATIONS INDIA PRIVATE LIMITED",
"RAVENBHEL HEALTH CARE PRIVATE LIMITED",
"RAVENBHEL PHARMACEUTICALS PRIVATE LIMITED",
"RAVENMAC PHARMACEUTICALS PRIVATE LIMITED",
"RAVENN PROMOLIINKS PRIVATE LIMITED",
"RAVENS FILM PRIVATE LIMITED",
"RAVENSHAW COLLEGE",
"RAVERS INDIA PRIVATE LIMITED",
"RAVESHIA COLOURS PRIVATE LIMITED",
"RAVESHIA ORGANICS LLP",
"RAVESHIA PIGMENTS LIMITED",
"RAVETAARA DIABETICS PRIVATE LIMITED",
"RAVGINS INTERNATIONAL PRIVATE LIMITED",
"RAVI AGRO SERVICES PVT LTD",
"RAVI AIRCON PRIVATE LIMITED",
"RAVI ART STUDIO PRIVATE LIMITED",
"RAVI AUTOMOBILES PRIVATE LIMITED",
"RAVI B. JANTE INFRAPROJECTS PRIVATE LIMITED",
"RAVI BAJAJ DESIGN PRIVATE LIMITED",
"RAVI BUSINESS SERVICES PVT LTD",
"RAVI CAM MANUFACTURING PRIVATE LIMITED",
"RAVI CEMENT AGENCY",
"RAVI CHAND BOTHRA SONS PRIVATE LIMITED",
"RAVI COMMODITIES PRIVATE LIMITED",
"RAVI COMMUNICATIONS PRIVATE LIMITED",
"RAVI CONSTRUCTION",
"RAVI CONSTRUCTION PRIVATE LIMITED",
"RAVI DEVELOPMENT",
"RAVI DIESEL PRIVATE LIMITED",
"RAVI DYEWARE COMPANY LIMITED",
"RAVI EDIBLES PRIVATE LIMITED",
"RAVI ELECTRICALS PRIVATE LIMITED",
"RAVI ELECTROVISION PRIVATE LIMITED",
"RAVI EXPORTS LIMITED",
"RAVI FIBER PRIVATE LIMITED",
"RAVI FINCORP LIMITED",
"RAVI FIRETECH SAFETY ENGINEERS PRIVATE LIMITED",
"RAVI FOODS PRIVATE LIMITED",
"RAVI FURNISHINGS PRIVATE LIMITED",
"RAVI GASES PRIVATE LIMITED",
"RAVI HYBRIDSEEDS PRIVATE LIMITED",
"RAVI IMAGING PRIVATE LIMITED",
"RAVI INDUSTRIES - HARIJ",
"RAVI INFRABUILD PROJECTS LIMITED",
"RAVI INFRABUILD PROJECTS PRIVATE LIMITED",
"RAVI INSTITUTE OF CHILD HEALTH PRIVATE LIMITED",
"RAVI INTEGRATED LOGISTICS INDIA PRIVATE LIMITED",
"RAVI JEWELLERS PRIVATE LIMITED",
"RAVI KISHORE ENTERPRISES PRIVATE LIMITED",
"RAVI KUMAR DISTILLERIES LIMITED",
"RAVI MAHAJAN BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"RAVI MATERIAL HOUSE PRIVATE LIMITED",
"RAVI METALLICS LIMITED",
"RAVI NAIR HOSPITALS PRIVATE LIMITED",
"RAVI OFFSET PRINTERS AND PUBLISHERS PRIVATE LIMITED",
"RAVI ORGANICS LIMITED",
"RAVI PANKHA (INDIA) PRIVATE LIMITED",
"RAVI PICKLES AND SPICES INDIA PRIVATE LIMITED",
"RAVI PLANT BIOTECHNOLOGIES LIMITED",
"RAVI PLAST MOLD PRIVATE LIMITED",
"RAVI POLYESTER PRIVATE LIMITED",
"RAVI PRINT PACK PRIVATE LIMITED",
"RAVI PRINTERS AND PUBLISHERS PVT LTD",
"RAVI REALCON PRIVATE LIMITED",
"RAVI RENEWABLE ENERGY & LIGHTING INDIA PRIVATE LIMITED",
"RAVI ROADLINES (INDIA) PRIVATE LIMITED",
"RAVI RUGS PRIVATE LIMITED",
"RAVI SARIN MOTION PICTURES PRIVATE LIMITED",
"RAVI SEAMLESS PIPES INDIA PRIVATE LIMITED",
"RAVI SECURITY ORGANISATION PVT LTD",
"RAVI SECURITY SERVICE PRIVATE LIMITED",
"RAVI SEEDS AND RESEARCH PRIVATE LIMITED",
"RAVI SHEET PROCESSOR PRIVATE. LIMITED.",
"RAVI SONS PRIVATE LIMITED",
"RAVI STEEL AND RENEWABLES PRIVATE LIMITED",
"RAVI STEELS PVT LTD",
"RAVI SUPER SHOPPE PRIVATE LIMITED",
"RAVI SURYA DEVELOPERS PRIVATE LIMITED",
"RAVI SYNCOYARN PRIVATE LIMITED",
"RAVI TECHNOFORGE PRIVATE LIMITED",
"RAVI VINYLS (INDIA) LIMITED",
"RAVI WHEELS PRIVATE LIMITED",
"RAVI WOOLLEN MILLS PVT LTD",
"RAVIAN ENGINEERS INDIA PRIVATE LIMITED",
"RAVIAN LIFE SCIENCE PRIVATE LIMITED",
"RAVIAN PHARMACEUTICALS LIMITED",
"RAVICAB CABLES PRIVATE LIMITED",
"RAVICHANDRA CONCEPT SCHOOL",
"RAVIK ENGINEERS PRIVATE LIMITED",
"RAVIKAMAL ROLLER FLOUR MILLS PRIVATE LIMITED",
"RAVIKAS AUTOMOTIVE SYSTEMS PRIVATE LIMITED",
"RAVIKIRAN CERAMICS PRIVATE LIMITED",
"RAVIKIRAN CHEMICALS PVT LTD",
"RAVIKON ENTERPRISES PRIVATE LIMITED",
"RAVILEELA GRANITES LIMITED",
"RAVILLA AEROSPACE INDUSTRIES PRIVATE LIMITED",
"RAVIM POLYPLAST INDIA PRIVATE LIMITED",
"RAVIN CABLES LIMITED",
"RAVIN INFRAPROJECT PRIVATE LIMITED",
"RAVIN TECHNOLOGIES PRIVATE LIMITED",
"RAVINANDANA CONSTRUCTION PRIVATE LIMITED",
"RAVINDER BISLA PRIVATE LIMITED",
"RAVINDER HEIGHTS LIMITED",
"RAVINDERA ROAD CARRIER PRIVATE LIMITED",
"RAVINDRA AGGARWAL AND COMPANY",
"RAVINDRA AIRPRODUCTS PRIVATE LIMITED",
"RAVINDRA AND COMPANY LIMITED",
"RAVINDRA AUTO DISTRIBUTORS PRIVATE LIMITED",
"RAVINDRA AUTOMOTIVE PRIVATE LIMITED",
"RAVINDRA BHARATHI EDUCATIONAL SOCIETY",
"RAVINDRA BHARATHI GLOBAL SCHOOL",
"RAVINDRA BHARATHI SCHOOL",
"RAVINDRA BHARTI EDUCATION INSTITUTE PRIVATE LIMITED",
"RAVINDRA DEVELOPERS PRIVATE LIMITED",
"RAVINDRA ENERGY LIMITED",
"RAVINDRA FERROMET PRIVATE LIMITED",
"RAVINDRA FOODS PRIVATE LIMITED",
"RAVINDRA HATCHERIES",
"RAVINDRA HERAEUS PRIVATE LIMITED",
"RAVINDRA INFRAESTATE PRIVATE LIMITED",
"RAVINDRA INTERIORS PRIVATE LIMITED",
"RAVINDRA OXYGEN COMPANY PRIVATE LIMITED",
"RAVINDRA RICE & GENERAL MILLS",
"RAVINDRA SERVICES PRIVATE LIMITED",
"RAVINDRA SOLVENT OILS PRIVATE LIMITED",
"RAVINDRA SPINNERS LIMITED",
"RAVINDRA TUBES PRIVATE LIMITED",
"RAVINDRANATH CONSTRUCTIONS PRIVATE LIMITED",
"RAVINDRANATH GE MEDICAL ASSOCIATES PRIVATE LIMITED",
"RAVINDRANATH MEDICAL FOUNDATION",
"RAVINDU MOTORS PRIVATE LIMITED",
"RAVINUM IMPEX PRIVATE LIMITED",
"RAVIR IMPORT EXPORT PRIVATE LIMITED",
"RAVIRA EVERGREEN ULTRASONIC SYSTEMS PVT LTD",
"RAVIRAJ AGRO BARAMATI",
"RAVIRAJ CHEMICALS INDIA PRIVATE LIMITED",
"RAVIRAJ DEVELOPERS LIMITED",
"RAVIRAJ ENTERPRISES PRIVATE LIMITED",
"RAVIRAJ FOILS LIMITED",
"RAVIRAJ HI-TECH PRIVATE LIMITED",
"RAVIRAJ HOTEL",
"RAVIRAJ INFRAPROJECT PRIVATE LIMITED",
"RAVIRAJ INTERNATIONAL PRIVATE LIMITED",
"RAVIRAJ MOTORS PRIVATE LIMITED",
"RAVIRAJ PACKAGINGS PRIVATE LIMITED",
"RAVIRAJ PLASTICS PVT LTD",
"RAVIRAJ PUBLICITY PRIVATE LIMITED",
"RAVIRAJ SAREES PRIVATE LIMITED",
"RAVIRAJ TRADELINK PRIVATE LIMITED",
"RAVIRAM TECH PRIVATE LIMITED",
"RAVIRATNA MOTORS PRIVATE LIMITED",
"RAVIS RETAIL PRIVATE LIMITED",
"RAVISH PRINT PACK PRIVATE LIMITED",
"RAVISH STEEL ROLLING AND FORGING PRIVATE LIMITED",
"RAVISSANCE EDUCARE PRIVATE LIMITED",
"RAVISSANT PVT LTD",
"RAVITECH GLOBAL PVT. LTD.",
"RAVITEJ PROJECTS PRIVATE. LIMITED.",
"RAVITEX TEXTILES PRIVATE LIMITED",
"RAVIX BIOSCIENCE PRIVATE LIMITED",
"RAVJEET ENGINEERING SPECIALITIES PVT LTD",
"RAVJIBHAI B PATEL MEDICAL CENTRE PRIVATE LIMITED",
"RAVNIT BUILDCON PRIVATE LIMITED",
"RAVOO'S LABORATORIES LIMITED",
"RAVOQ SPORTS TECHNOLOGY PRIVATE LIMITED",
"RAVP INFRA DEVELOPERS PRIVATE LIMITED",
"RAV'S STEELS PRIVATE LIMITED",
"RAVSAHEB RUPCHAND VIDHYA JALGAON",
"RAVSOFT SOLUTIONS INDIA PRIVATE LIMITED",
"RAVVS INTERNATIONAL PRIVATE LIMITED",
"RAW EDGE EXPORTS PRIVATE LIMITED",
"RAW EDGE INDUSTRIAL SOLUTIONS LIMITED",
"RAW ENGINEERING INDIA PRIVATE LIMITED",
"RAW HOUSE VENTURES PRIVATE LIMITED",
"RAW JUTE TRADING & INDUSTRIES LIMITED.",
"RAWAL ACIDS PRIVATE LIMITED",
"RAWAL AUTOMOBILES PRIVATE LIMITED",
"RAWAL HOSPITAL",
"RAWALPINDI JEWELLERS PRIVATE LIMITED",
"RAWALWAS PRODUCER COMPANY LIMITED",
"RAWALWASIA ISPAT UDYOG PRIVATE LIMITED",
"RAWALWASIA OIL INDUSTRIES PRIVATE LIMITED",
"RAWALWASIA STEEL PLANT PRIVATE LIMITED",
"RAWALWASIA TEXTILE INDUSTRIES PRIVATE LIMITED",
"RAWALWASIA YARN DYEING PRIVATE LIMITED",
"RAWAR PROJECTS & INFRASTRUCTURE PRIVATE LIMITED",
"RAWAT BREEDING FARMS PRIVATE LIMITED",
"RAWAT BROTHERS FURNITURE PRIVATE LIMITED",
"RAWAT BROTHERS MALL PRIVATE LIMITED",
"RAWAT ENGG. TECH PRIVATE LIMITED",
"RAWAT HOSPITALITY SERVICES PRIVATE LIMITED",
"RAWAT MEDICARE LIMITED",
"RAWAT SENIOR SECONDARY SCHOOL",
"RAWAT TEXTILES PRIVATE LIMITED",
"RAWAT TILES PRIVATE LIMITED",
"RAWATKHEDIA PROCESSORS PRIVATE LIMITED",
"RAWBONG RETAIL PRIVATE LIMITED",
"RAWCUBES INDIA PRIVATE LIMITED",
"RAWDATA TECHNOLOGIES PRIVATE LIMITED",
"RAWIA INTERNATIONAL HEALTHCARE PRIVATE LIMITED",
"RAWIDEAS OFFICESPACE INDIA PRIVATE LIMITED",
"RAWJI FINE FRAGRANCES PRIVATE LIMITED",
"RAWMART MATERIAL SOLUTIONS PRIVATE LIMITED",
"RAWMATT INDUSTRIES PRIVATE LIMITED",
"RAWMET RESOURCES PRIVATE LIMITED",
"RAWMIN MINING AND INDUSTRIES PRIVATE LIMITED",
"RAWMINDS RECRUITMENT AND MARKETING INDIA PRIVATE LIMITED",
"RAWNEST PRIVATE LIMITED",
"RAWOOLNATH INFRASTRUCTURE PRIVATE LIMITED",
"RAWSOME TRADING PRIVATE LIMITED",
"RAX UNIQUE TECHNOLOGIES (OPC) PRIVATE LIMITED",
"RAXA SECURITY SERVICES LIMITED",
"RAXAK SECURITY PROTECTION PRIVATE LIMITED",
"RAXAUL MOTORS PRIVATE LIMITED",
"RAXAUL RETAIL PRIVATE LIMITED",
"RAXON MOTOR FINANCE PRIVATE LIMITED",
"RAY ADCOMM PRIVATE LIMITED",
"RAY ALLEN INDIA PRIVATE LIMITED",
"RAY AND RAJ ENGINEERING PRIVATE LIMITED",
"RAY BANQUET AND HOTELS PRIVATE LIMITED",
"RAY BUSINESS TECHNOLOGIES PRIVATE LIMITED",
"RAY CHEM MEDICA PRIVATE LIMITED",
"RAY CONSTRUCTIONS LIMITED",
"RAY ENGINEERING LIMITED",
"RAY ENGINEERING PRIVATE LIMITED",
"RAY FINE JEWELLERY PRIVATE LIMITED",
"RAY HANS PRECISION TOOLS PRIVATE LIMITED",
"RAY HEALTH PRODUCT PRIVATE LIMITED",
"RAY INFRAPROJECTS PRIVATE LIMITED",
"RAY INFRASTRUCTURES PRIVATE LIMITED",
"RAY INTERIORS AND ADVERTISING (INDIA) PRIVATE LIMITED",
"RAY INTERNATIONAL",
"RAY POLYTECH PRIVATE LIMITED",
"RAY TRADING PRIVATE LIMITED",
"RAYA MEDIA PRIVATE LIMITED",
"RAYAGADA MINERALS AND CHEMICALS PRIVATE LIMITED",
"RAYAH IMPEX PRIVATE LIMITED",
"RAYALASEEMA INDUSTRIES INDIA PRIVATE LIMITED",
"RAYALASEEMA STEEL RE-ROLLING MILLS PRIVATE LIMITED",
"RAYALASEEMA WIND ENERGY COMPANY PRIVATE LIMITED",
"RAYALSEEMA BULLION & COMMTRADE PRIVATE LIMITED",
"RAYALSEEMA CONCRETE SLEEPERS PVT LTD",
"RAYAN AGENCY & TRADE",
"RAYAN ALLOYS PRIVATE LIMITED",
"RAYANA PAPER BOARD INDUSTRIES LIMITED",
"RAYANI SPINTEX PRIVATE LIMITED",
"RAYANI TRADELINKS PRIVATE LIMITED",
"RAYAPURAM COMMON EFFLUENT TREATMENT PLANT PRIVATE LIMITED",
"RAYAQUATIC CENTER PRIVATE LIMITED",
"RAYAT SHIKSHAN SANSTHA'S S.M.JOSHI COLLEGE",
"RAYBAN FEEDS AND HATCHERIES PRIVATE LIMITED",
"RAYBAN FOODS PRIVATE LIMITED",
"RAYBAN FROZEN FOODS PRIVATE LIMITED",
"RAYBAN SUN OPTICS INDIA PRIVATE LIMITED",
"RAYBON METALS PRIVATE LIMITED",
"RAYBOTIX TECHNOLOGIES PRIVATE LIMITED",
"RAYBROS MEDICAMENTS PRIVATE LIMITED",
"RAYCAL POWER INFRA PRIVATE LIMITED",
"RAYCHEM RPG PRIVATE LIMITED",
"RAYCON INFRASTRUCTURE PRIVATE LIMITED",
"RAYCON INFRASTRUCTURE PRIVATE. LIMITED.",
"RAYDANS SUPPLIES PRIVATE LIMITED",
"RAYDEAN INDUSTRIES",
"RAYDEN DESIGN STUDIO PRIVATE LIMITED",
"RAYDEN INTERACTIVE",
"RAYDEON PRECAST AND INFRA PRIVATE LIMITED",
"RAYDIALL AUTOMOTIVE INDIA PRIVATE LIMITED",
"RAYDIOM FURNITURE PRIVATE LIMITED",
"RAYELECTRICA ENVIRO PROJECTS PRIVATE LIMITED",
"RAYEN STEELS PRIVATE LIMITED",
"RAYFUEL ENERCON PRIVATE LIMITED",
"RAYGAIN TECHNOLOGIES PRIVATE LIMITED",
"RAYGEN POWER PRIVATE LIMITED",
"RAYH HEALTH CARE PRIVATE LIMITED",
"RAYHAN TRAVEL HOUSE PRIVATE LIMITED",
"RAYI SYSTEMS PRIVATE LIMITED",
"RAYIRTH HOLDING AND TRADING COMPANY PRIVATE LIMITED",
"RAYKOR TECHNOLOGIES PRIVATE LIMITED",
"RAYLAND DIAGNOSTIC CENTRE PRIVATE LIMITED",
"RAYLATION CRM SOLUTIONS PRIVATE LIMITED",
"RAYLINE CONNECTIVITY PRIVATE LIMITED",
"RAYLINE LOGISTICS PRIVATE LIMITED",
"RAYLOGIC CONTROL SYSTEMS PRIVATE LIMITED",
"RAYM ETECH PRIVATE LIMITED",
"RAYMAN ARTEFACTS PRIVATE LIMITED",
"RAYMECHATRONICS AND MACHINERY PRIVATE LIMITED",
"RAYMED OPHTHALMIC PRIVATE LIMITED",
"RAYMED PHARMACEUTICALS LIMITED",
"RAYMED TRADING GROUP PRIVATE LIMITED",
"RAYMIX CONCRETE INDIA PRIVATE LIMITED",
"RAYMON PATEL GELATINE PRIVATE LIMITED",
"RAYMOND CONSUMER CARE LIMITED",
"RAYMOND CONSUMER CARE PRIVATE LIMITED",
"RAYMOND LIMITED",
"RAYMOND LUXURY COTTONS LIMITED",
"RAYMOND UCO DENIM PRIVATE LIMITED",
"RAYMOND WEIL INDIA DISTRIBUTION PRIVATE LIMITED",
"RAYMONS YARNS PRIVATE LIMITED",
"RAYMOTOS PRIVATE LIMITED",
"RAYNAS INFRA AND GEOMATICS SERVICES PRIVATE LIMITED",
"RAYNINE MEDIAWORKS PRIVATE LIMITED",
"RAYON ENERGY PRIVATE LIMITED",
"RAYON ILLUMINATIONS AND ENERGY SOLUTIONS PRIVATE LIMITED",
"RAYON IVD PRIVATE LIMITED",
"RAYON PROTECTIONS PRIVATE LIMITED",
"RAYON REALTY PRIVATE LIMITED",
"RAYON TEXTILE INDIA PRIVATE LIMITED",
"RAYONNANT NATURAL CARE EXCELLENCE PRIVATE LIMITED",
"RAYONTEX YARN TRADERS PRIVATE LIMITED",
"RAY-Q INTERCONNECTION TECHNOLOGIES INDIA PRIVATE LIMITED",
"RAYREACH TECHNOLOGIES PRIVATE LIMITED",
"RAYRHYTHMS INDUSTRIES PRIVATE LIMITED",
"RAYS AUTOHAVEN PRIVATE LIMITED",
"RAYS BOOKS OF INDIA PRIVATE LIMITED",
"RAYS CULINARY DELIGHTS PRIVATE LIMITED",
"RAYS DIAGNO INTERVENTIONS PRIVATE LIMITED",
"RAY'S FOODS PRODUCTS PRIVATE LIMITED",
"RAYS GEMS PRIVATE LIMITED",
"RAYS OF BELIEF PRIVATE LIMITED",
"RAYS POLYMERS PRIVATE LIMITED",
"RAYS POWER EXPERTS PRIVATE LIMITED",
"RAYS POWER INFRA LIMITED",
"RAYS POWER PRIVATE LIMITED",
"RAYS PRIME LOGISTICS PRIVATE LIMITED",
"RAYS TECHSERV PRIVATE LIMITED",
"RAYSS MEDIA SOLUTIONS PRIVATE LIMITED",
"RAYSTAL INFRA PRIVATE LIMITED",
"RAYSUN ENERGY PRIVATE LIMITED",
"RAYTEX IT SERVICES LLP",
"RAYTHEON COMPANY",
"RAYVEN BROADNET ENTERPRISE PRIVATE LIMITED",
"RAYVEN IT SOLUTIONS PRIVATE LIMITED",
"RAYVISION TECH PRIVATE LIMITED",
"RAYYI DHOOT TECHNOLOGIES PRIVATE LIMITED",
"RAZA PAPER PRIVATE LIMITED",
"RAZA TEXTILE",
"RAZBAN SEAFOOD PVT LTD",
"RAZI SOLUTIONS PRIVATE LIMITED",
"RAZK INDUSTRIAL AUTOMATION PRIVATE LIMITED",
"RAZON ENGINEERING CO PRIVATE LIMITED",
"RAZOR GAMING PRIVATE LIMITED",
"RAZOR INFOTECH PRIVATE LIMITED",
"RAZORBILL PRIVATE LIMITED",
"RAZORPAY SERVICES PRIVATE LIMITED",
"RAZORPAY SOFTWARE PRIVATE LIMITED",
"RAZORPOD TECHNOLOGIES PRIVATE LIMITED",
"RAZORSHARP TECHNOLOGIES PRIVATE LIMITED",
"RAZORTHINK SOFTWARE PRIVATE LIMITED",
"RAZORTHINK TECHNOLOGIES PRIVATE LIMITED",
"RAZWADA JEWELES PRIVATE LIMITED",
"RAZZMATAZZ FILMS PRIVATE LIMITED",
"RB AND SONS COTTON TRADERS",
"RB ASSETS & DEVELOPERS PRIVATE LIMITED",
"RB AUTOMATION",
"RB AYURVEDIC MEDICAL COLLEGE AND HOSPITAL",
"RB BRITISH MARINE INDIA PRIVATE LIMITED",
"RB DISTRIBUTION INC -INDIA LIMISON OFFICE",
"RB DIVERSIFIED PRIVATE LIMITED",
"RB ECO POWER LLP",
"RB GLOBAL SHIPPING & LOGISTICS PRIVATE LIMITED",
"RB INFRACON PRIVATE LIMITED",
"RB INFRAESTATE PRIVATE LIMITED",
"RB ISPAT PRIVATE LIMITED",
"RB MONEY FINANCIAL SERVICES PRIVATE LIMITED",
"RB ONE SOURCE PRIVATE LIMITED",
"RB ONLINE INDIA PRIVATE LIMITED",
"RB PHAMACEUTICALS",
"RB POLYMERS LTD",
"RB TEXTILE PRIVATE LIMITED",
"RB WEALTH INSIGHT PRIVATE LIMITED",
"RBA CONSTRUCTIONS PRIVATE LIMITED",
"RBA FERRO INDUSTRIES PRIVATE LIMITED",
"RBA FINANCE PRIVATE LIMITED",
"RBA HOSPITALITY AND HOTELS PRIVATE LIMITED",
"RBA POWER PRIVATE LIMITED",
"RBA PROPERTIES LIMITED",
"RBA TEXTILES PRIVATE LIMITED",
"RBAK AGRO INDIA PRIVATE LIMITED",
"RBAM GLOBAL PRIVATE LIMITED",
"RBANM'S EDUCATIONAL CHARITIES",
"RBANMS FIRST GRADE COLLEGE",
"RBAS GLOBAL TRADING PRIVATE LIMITED",
"RBB LOGISTICS SOLUTION PRIVATE LIMITED",
"RBBR INFRASTRUCTURE PRIVATE LIMITED",
"RBC FINANCIAL SERVICES PRIVATE LIMITED",
"RBC INDUSTRIES PRIVATE LIMITED",
"RBD ENGINEERS PRIVATE LIMITED",
"RBD MACHINE TOOLS PRIVATE LIMITED",
"RBD SHELTERS LLP",
"RBEAUTY FASHION INDIA PRIVATE LIMITED",
"RBG COMMODITIES LIMITED",
"RBG CONSTRUCTIONS AND DEVELOPERS PRIVATE LIMITED",
"RBG FINANCIAL SERVICES PRIVATE LIMITED",
"RBG INDIA PRIVATE LIMITED",
"RBG JSC INFRASTRUCTURE PRIVATE LIMITED",
"RBG LOGISTICS PRIVATE LIMITED",
"RBG TRADING AND ECOMMERCE PRIVATE LIMITED",
"RBH ELECTRONICS SECURITY PRODUCTS INDIA PRIVATE LIMITED",
"RBH E-WASTE RECYCLE HUB PRIVATE LIMITED",
"RBH SOLUTIONS PRIVATE LIMITED",
"R-BIOPHARM NEUGEN PRIVATE LIMITED",
"RBJ ENGINEERING WORKS PRIVATE LIMITED",
"RBJ STEEL PRIVATE LIMITED",
"RBJ TECHNOLOGIES PRIVATE LIMITED",
"RBJC PROPERTIES PRIVATE LIMITED",
"RBK EDUCATION SOLUTIONS PRIVATE LIMITED",
"RBK GLOBAL SCHOOL",
"RBK INTERNATIONAL ACADEMY",
"RBK SECURITY AND MANPOWER SERVICES PRIVATE LIMITED",
"RBL BANK LIMITED",
"RBL FINSERVE LIMITED",
"RBL HOTELS PRIVATE LIMITED",
"RBL LOGISTICS PRIVATE LIMITED",
"RBL SHEETGRAH PRIVATE LIMITED",
"RBM HOSPITALS",
"RBM INDUSTRIES",
"RBM INFRACON LIMITED",
"RBM INTERNATIONAL PRIVATE LIMITED",
"RBM STEELS PRIVATE LIMITED",
"RBMAGRO PRIVATE LIMITED",
"RBMI GROUP OF INSTITUTIONS BAREILLY",
"RBML SOLUTIONS INDIA LIMITED",
"RBN FOODS PRIVATE LIMITED.",
"RBN GLOBAL SCHOOL",
"RBOOMERANG RETAIL COMMERCE TECHNOLOGIES INDIA PRIVATE LIMITED",
"RBP ENERGY (INDIA) PRIVATE LIMITED",
"RBP ENGINEERS AND CONTRACTS PRIVATE LIMITED",
"RBP TECHNOLOGY (INDIA) PRIVATE LIMITED",
"RBR EXPORTS PRIVATE LIMITED",
"RBR GARMENTS PRIVATE LIMITED",
"RBR GOLD PRIVATE LIMITED",
"R-BRANDS LIFESTYLE PRIVATE LIMITED",
"RBRL AGRO COMMODITIES LIMITED.",
"RBS CONSTRUCTIONS PRIVATE LIMITED",
"RBS CONTRACTS PRIVATE LIMITED",
"RBS CREDIT AND FINANCIAL DEVELOPMENTS PVT. LTD.",
"RBS DEVELOPERS",
"RBS FINANCIAL SERVICES INDIA PRIVATE LIMITED",
"RBS GARMENTS PRIVATE LIMITED",
"RBS MARITIME SERVICES",
"RBS POLY ADDITIVES AND STABILIZERS PRIVATE LIMITED",
"RBSA CAPITAL ADVISORS LLP",
"RBSA VALUATION ADVISORS LLP",
"RBSG CAPITAL PRIVATE LIMITED",
"RBSM CONSULTING PRIVATE LIMITED",
"RBSTRAVEL SOLUTION PRIVATE LIMITED",
"RBT PROJECTS INDIA PRIVATE LIMITED",
"RBTC PRIVATE LIMITED",
"RBTECH ELECTRONICS PRIVATE LIMITED",
"RBW SOLUTIONS PRIVATE LIMITED",
"RBZ JEWELLERS LIMITED",
"RC ADVISORS PRIVATE LIMITED",
"RC ALL-TECH SYSTEMS PRIVATE LIMITED",
"RC ASSOCIATES PRIVATE LIMITED",
"RC AUTOMOTIVE PRIVATE LIMITED",
"RC AVIATION PRIVATE LIMITED",
"RC CORROCARE INDUSTRIES PRIVATE LIMITED",
"RC DESIGN PRIVATE LIMITED",
"RC EVENTS INDIA PRIVATE LIMITED",
"RC GANDHI DENTAL HOSPITAL",
"RC GOLDEN GRANITES PRIVATE LIMITED",
"RC GOYAL DALL UDYOG PRIVATE LIMITED",
"RC LEISURE PRIVATE. LIMITED.",
"RC MEMORIAL NURSHING HOME PRIVATE LIMITED",
"RCA EXIM PRIVATE LIMITED",
"RCA STUDIO PRIVATE LIMITED",
"RCA TECHMART PRIVATE LIMITED",
"RCAS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"RCBROS IMPEX PRIVATE LIMITED",
"RCC (INFRASTRUCTURE) CONSULTANTS PRIVATE LIMITED",
"RCC DEVELOPERS LIMITED. RCC",
"RCC ENGINEERING PRIVATE LIMITED",
"RCC INSTITUTE OF TECHNOLOGY",
"RCC LABORATORIES INDIA PRIVATE LIMITED",
"RCC LOGISTICS PRIVATE LIMITED",
"RCC NUTRA FILL PRIVATE LIMITED",
"RCC TRANSPORT COMPANY PRIVATE LIMITED",
"RCCF OFFICE RANCHI",
"RCCL EXPRESSWAY PRIVATE LIMITED",
"RCCPL PRIVATE LIMITED",
"RCDD TECHNOLOGIES PRIVATE LIMITED",
"RCF FINANCE PRIVATE LIMITED",
"RCG GLOBAL SERVICES (INDIA) PRIVATE LIMITED",
"RCGC FABRICS PRIVATE LIMITED",
"RCGR AGRO PRIVATE LIMITED",
"RCHOBBYTECH SOLUTIONS PRIVATE LIMITED",
"RCI INDIA PRIVATE LIMITED",
"RCI SPECIALITIES PRIVATE LIMITED",
"RCJ AUTO FORGE PRIVATE LIMITED",
"RCJ INVESTMENT TRUST PRIVATE LIMITED",
"RCK ACADEMY PRIVATE LIMITED",
"RCK CONSTRUCTIONS PRIVATE LIMITED",
"RCK ENTERPRISE PRIVATE LIMITED",
"RCK IMPEX PRIVATE LIMITED",
"RCKR SOFTWARE PRIVATE LIMITED",
"RCL AGENCIES (INDIA) PRIVATE LIMITED",
"RCL AGENCIES EAST INDIA PRIVATE LIMITED",
"RCL CEMENTS LIMITED",
"RCL INDUSTRIES PRIVATE LIMITED",
"RCL PORSA HIGHWAYS PRIVATE LIMITED",
"RCLR COMMERCIAL PRIVATE LIMITED",
"RCM APPARELS PRIVATE LIMITED",
"RCM FERTILIZERS PRIVATE LIMITED",
"RCM FINANCE AND LEASING PRIVATE LIMITED",
"RCM HI TECH MULTI SPECIALTY HOSPITAL",
"RCM IMPERIALS PRIVATE LIMITED",
"RCM TECHNO TEXTILES PRIVATE LIMITED",
"RCMC SHARE REGISTRY PRIVATE LIMITED",
"RCMPA POLISHING TECHNOLOGIES PRIVATE LIMITED",
"RCN CONSTRUCTIONS PRIVATE LIMITED",
"RCNP BUILDERS & DEVELOPERS PRIVATE LIMITED",
"RCON BUILDCON PRIVATE LIMITED",
"RCON PUNE PRIVATE LIMITED",
"RCPL LOGISTICS PRIVATE LIMITED",
"RCR BRIGHT FABTECH PRIVATE LIMITED",
"RCRS INNOVATIONS LIMITED",
"RCS ADVISORS (INDIA) PRIVATE LIMITED",
"RCS CARE PRIVATE LIMITED",
"RCS FACILITY MANAGEMENT PRIVATE LIMITED",
"RCS GLOBAL LIMITED",
"RCS IMPEX PRIVATE LIMITED",
"RCS LOGISTICS PRIVATE LIMITED",
"RCS REALTORS PRIVATE LIMITED",
"RCS STEEL & AUTO PRIVATE LIMITED",
"RCS TECH LLP",
"RCS TECHNOLOGY",
"RCS TRUE FACILITIES PRIVATE LIMITED",
"RCUBE ELECTRIC PRIVATE LIMITED",
"RCUBE HOSPITALITY LLP",
"RCUBE PLANET PRIVATE LIMITED",
"RCUBE PROJECTS PRIVATE LIMITED",
"RCV INNOVATIONS PRIVATE LIMITED",
"RD AIR AND MARINE CARGO SERVICES PRIVATE LIMITED",
"RD AND SH NATIONAL COLLEGE AND SWA SCIENCE COLLEGE",
"RD BROWN BOX PACKAGING PRIVATE LIMITED",
"RD BUILDTECH AND DEVELOPERS KARNATAKA PRIVATE LIMITED",
"RD CLEANTECH PRIVATE. LIMITED",
"RD CUSTOM AWARDS PRIVATE LIMITED",
"RD DYNAMECH INFRA PRIVATE LIMITED",
"RD EQUIPMENT PRIVATE LIMITED",
"RD FACILITY & OUTSOURCING PRIVATE LIMITED",
"RD FORGE PRIVATE LIMITED",
"RD GOLDEN JEWELS PRIVATE. LIMITED.",
"RD INFRA EQUIPMENTS PRIVATE LIMITED",
"RD INFRATEL PRIVATE LIMITED",
"RD IRON ROLLS PRIVATE LIMITED",
"RD MULTI-TECH PRIVATE LIMITED",
"RD NATIONAL COLLEGE OF ARTS AND SCIENCE",
"RD NUTRITION PRIVATE LIMITED",
"RD OUTDOOR MEDIA PRIVATE LIMITED",
"RD POLLUTION CONTROLS PRIVATE LIMITED",
"RD PRINTERS & PUBLISHERS PRIVATE LIMITED",
"RD STEELFAB PRIVATE LIMITED",
"RD STRATEGIC ESALES PRIVATE LIMITED",
"RD TELINET PRIVATE LIMITED",
"RD WEAVETEX PRIVATE LIMITED",
"RDA ELECTRICALS PRIVATE LIMITED",
"RDA ENERGY PRIVATE LIMITED",
"RDA GLOBAL LOGISTICS (I) PRIVATE LIMITED",
"RDA HOLDINGS PRIVATE LIMITED",
"RDA LABS INDIA PRIVATE LIMITED",
"RDB AUTO SERVICES PRIVATE LIMITED",
"RDB AUTOMOTIVE PRIVATE LIMITED",
"RDB ENCON PRIVATE LIMITED",
"RDB HIGHWAY SERVICES PRIVATE LIMITED",
"RDB HYD INFRASTRUCTURE PRIVATE LIMITED",
"RDB KNIT FABB PRIVATE LIMITED",
"RDB RASAYANS LTD.",
"RDB REALTY & INFRASTRUCTURE LIMITED",
"RDB TEXTILES LIMITED",
"RDB TWO THOUSAND PLUS LTD",
"RDBL ENTERPRISES PRIVATE LIMITED",
"RDBP HOSPITAL",
"RDBPJ HOSPITAL",
"RDC CONCRETE INDIA PRIVATE LIMITED",
"RDC MEDIA PRIVATE LIMITED",
"RDC STEELS AND ALLIED SERVICE PVT LTD",
"RDCA INFRA PRIVATE LIMITED",
"RDDHI GOLD PRIVATE LIMITED",
"RDDHI ORGANICS AND FERTILIZERS PRIVATE LIMITED",
"RDEVIS ENGINEERS PRIVATE LIMITED",
"RDG ENTERPRISE PRIVATE LIMITED",
"RDG SOLVENT LIMITED",
"R-DGTL",
"RDH ENGINEERS PRIVATE LIMITED",
"RDH TRAVELS INDIA PRIVATE LIMITED",
"RDHL APPLIANCES PRIVATE LIMITED",
"RDK CONSTRUCTIONS PRIVATE LIMITED",
"RDK TECH SOLUTIONS INDIA PRIVATE LIMITED",
"RDL TECHNOLOGIES PRIVATE LIMITED",
"RDM ENTERPRISES PRIVATE LIMITED",
"RDM INDIA VISION PRIVATE LIMITED",
"RDM.CAREINDIA PRIVATE.LIMITED",
"RDO INDIA PRIVATE LIMITED",
"RDP INFRACON PRIVATE LIMITED",
"RDP WORKSTATIONS PRIVATE LIMITED",
"RDPLROYAL DIAGNOSTICS PRIVATE LIMITED",
"RDP-MERA GHAR LUXURIA PRIVATE LIMITED",
"RDQ TRADINGSWALA TECHNOLOGIES LIMITED",
"RDR HOSPITALITY SOLUTIONS PRIVATE LIMITED",
"RDR IMPEX PRIVATE LIMITED",
"RDR LEBENSMITTEL PRIVATE LIMITED",
"RDR TAICHI PRIVATE LIMITED",
"RDS & SONS PRIVATE LIMITED",
"RDS AGRI PRIVATE LIMITED",
"RDS ELECTRICAL AND ELECTRONIC SERVICES",
"RDS ENTERPRISES PRIVATE LIMITED",
"RDS FREIGHT INTERNATIONAL PRIVATE LIMITED",
"RDS GROUP",
"RDS HOSPITALITY PRIVATE LIMITED",
"RDS INDUSTRIES PRIVATE LIMITED",
"RDS INFOTECH PRIVATE LIMITED",
"RDS LOGISTICS AND AGENCIES PRIVATE LIMITED",
"RDS MANAGEMENT SERVICES PRIVATE LIMITED",
"RDS PROJECT LIMITED",
"RDS SUPER MARKET PRIVATE LIMITED",
"RDS TECHSERV PRIVATE LIMITED",
"RDSS FAB PRIVATE LIMITED",
"RDSS HOTELS PRIVATE LIMITED",
"RDTMT STEELS INDIA PRIVATE LIMITED",
"RDV DESIGN TECHNOLOGIES PRIVATE LIMITED",
"RDV LAXMI INDUSTRIES PRIVATE LIMITED",
"RE- BAR COUPLERS INDIA (PVT) LIMITED",
"RE DECORATORS AND EXHIBITORS PRIVATE LIMITED",
"RE EQUIPMENTS (INDIA) PRIVATE LIMITED",
"RE HAB ARTIFACT PRIVATE LIMITED",
"RE INDIA PROPERTY MANAGEMENT PRIVATE LIMITED",
"RE JEWELS PRIVATE LIMITED",
"RE NAO CONSULTANTS AND ADVISORS PRIVATE LIMITED",
"RE SUSTAINABILITY AND RECYCLING PRIVATE LIMITED",
"RE SUSTAINABILITY HEALTHCARE SOLUTIONS LIMITED",
"RE SUSTAINABILITY IWM SOLUTIONS LIMITED",
"RE SUSTAINABILITY LIMITED",
"RE SUSTAINABILITY SOLUTIONS PRIVATE LIMITED",
"REABOW TECHNO INDUSTRIES PRIVATE LIMITED",
"REACH AJCON TECHNOLOGIES PRIVATE LIMITED",
"REACH CARGO MOVERS PRIVATE LIMITED",
"REACH DISTRIBUTORS (INDIA) PRIVATE LIMITED",
"REACH DREDGING LIMITED",
"REACH EASTERN PERSONNEL SERVICES PRIVATE LIMITED",
"REACH EDUCATION PRIVATE LIMITED",
"REACH EQUIPMENT HIRING PRIVATE LIMITED",
"REACH GLOBAL INDIA PRIVATE LIMITED",
"REACH INFOCOM TECHNOLOGY PRIVATE LIMITED",
"REACH INFRATECH CONSULTANTS PRIVATE LIMITED",
"REACH LOGISTICS PRIVATE LIMITED",
"REACH MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"REACH MEDICAL SYSTEMS PRIVATE LIMITED",
"REACH NVY PRIVATE LIMITED",
"REACH PROCESS OUTSOURCING PRIVATE LIMITED",
"REACH PROMOTERS PRIVATE LIMITED",
"REACH SOLAR SOLUTIONS PRIVATE LIMITED",
"REACH TO TEACH PRIVATE LIMITED",
"REACHALL INDIA PRIVATE LIMITED",
"REACHASIA CARGO EXPRESS SERVICES PRIVATE LIMITED",
"REACHC ONMARK PRIVATE LIMITED OPC",
"REACHLOCAL SERVICES PRIVATE LIMITED",
"REACHOUT INFOTECH PRIVATE LIMITED",
"REACHWELL SOFTWARE SERVICES PRIVATE LIMITED",
"REACKON CONCRETES PRIVATE LIMITED",
"REACT INDIA PRIVATE LIMITED",
"REACTIVE METALS OF INDIA PRIVATE LIMITED",
"REACTIVE POLYMERS LIMITED",
"REACTIVEWORKS IT SOLUTIONS PRIVATE LIMITED",
"REACTORE INDIA PRIVATE LIMITED",
"REACTRA ENGINEERING PRIVATE LIMITED",
"READ SMART PUBLISHERS PRIVATE LIMITED",
"READ WELL EDUCATION SOCITY",
"READERS STORES INDIA PRIVATE LIMITED",
"READ-INK TECHNOLOGIES PRIVATE LIMITED",
"READY BYTES SOFTWARE LABS PRIVATE LIMITED",
"READY MADE PLAZA INDIA PRIVATE LIMITED",
"READY MECHATRONIC SYSTEMS AND DEVICES PRIVATE LIMITED",
"READY MIX CONCRETE LIMITED",
"READY NETWORK MARKETING PRIVATE LIMITED",
"READY NETWORKS INDIA PRIVATE LIMITED",
"READY ROTI INDIA PRIVATE LIMITED",
"READY SOFT PRIVATE LIMITED",
"READYLINK INTERNET SERVICES LIMITED",
"READYMIX CONSTRUCTION MACHINERY PRIVATE LIMITED",
"READYWEAR CASUALS PRIVATE LIMITED",
"REAGENS INDIA POLYMER ADDITIVES PRIVATE LIMITED",
"REAGENT IVD RESOURCES PRIVATE LIMITED",
"REAGHAN FASHIONS PRIVATE LIMITED",
"REAL ADVERTISING PRIVATE LIMITED",
"REAL AGRO FOODS",
"REAL AGRO INDUSTRIES PRIVATE LIMITED",
"REAL APPLIANCES PRIVATE LIMITED",
"REAL BOILERS PRIVATE LIMITED",
"REAL CAPITAL TOWERS PRIVATE LIMITED",
"REAL CARE PEOPLE PRIVATE LIMITED",
"REAL CAST FOUNDRY PRIVATE LIMITED",
"REAL CHAMPS PUBLICATIONS (INDIA) PRIVATE LIMITED",
"REAL CHEMSYS PRODUCTS PRIVATE LIMITED",
"REAL CHOICE COMMERCIALS PRIVATE LIMITED",
"REAL CONNECT LLP",
"REAL CONSTRO PROJECTS PRIVATE LIMITED",
"REAL COTEX PRIVATE LIMITED",
"REAL COTTON INDUSTRIES",
"REAL DRINKS PRIVATE LIMITED",
"REAL DYNAMICS (PUNE) PRIVATE LIMITED",
"REAL ECO-ENERGY LIMITED",
"REAL ESTATE DEVELOPMENT & CONSTRUCTION CORPORATION OF RAJASTHAN LIMITED",
"REAL EVENT AND HOSPITALITY PRIVATE LIMITED",
"REAL FAST BUILDTECH PRIVATE LIMITED",
"REAL FERRO-PROJECTS PRIVATE LIMITED",
"REAL FOOD AGENCY PRIVATE LIMITED",
"REAL FRAGRANCES (PUNE) PRIVATE LIMITED",
"REAL FUEL TECH PRIVATE LIMITED",
"REAL GAS AND CHEMICALS PRIVATE LIMITED",
"REAL GRAIN ROLLER FLOUR MILLS PRIVATE LIMITED",
"REAL GRANITES PRIVATE LIMITED",
"REAL GRANITO PRIVATE LIMITED",
"REAL GREEN ENGINEERS PRIVATE LIMITED",
"REAL GROWTH INFRA PRIVATE LIMITED",
"REAL GROWTH SECURITIES PRIVATE LIMITED",
"REAL HEIGHT DEVELOPERS PRIVATE LIMITED",
"REAL HOUSEKEEPING SERVICES PRIVATE LIMITED",
"REAL HYGIENE PRIVATE LIMITED",
"REAL IMPACT PRIVATE LIMITED",
"REAL INFINITY MULTIVENTURE PRIVATE LIMITED",
"REAL INNERSPRING TECHNOLOGIES PRIVATE LIMITED",
"REAL ISPAT & POWER LIMITED",
"REAL ISPAT AND ENERGY PRIVATE LIMITED",
"REAL LOGISTICS PRIVATE LIMITED",
"REAL MANPOWER SOLUTION PRIVATE LIMITED",
"REAL MAZON INDIA LIMITED",
"REAL MERCANTILE SERVICES (MUMBAI) PRIVATE LIMITED",
"REAL METALCHEM PRIVATE LIMITED",
"REAL OILS & FATS PRIVATE LIMITED",
"REAL ONE HOMESTATES PRIVATE LIMITED",
"REAL PAPRIKA FOODS PRIVATE LIMITED",
"REAL PERSONAL CARE",
"REAL PLASMATECH PRIVATE LIMITED",
"REAL PLASTOCHEM PRIVATE LIMITED",
"REAL PRINCE SPINTEX PRIVATE LIMITED",
"REAL PRO ENGINEERING PRODUCTS PRIVATE LIMITED",
"REAL RAINWEAR PRIVATE LIMITED",
"REAL RATNA FASHIONS PRIVATE LIMITED",
"REAL REVOLUTION DEVELOPERS PRIVATE LIMITED",
"REAL ROAD LINES PRIVATE LIMITED",
"REAL SECURITY SERVICES I PRIVATE LIMITED",
"REAL SOYA PRODUCTS PVT LTD",
"REAL SPINTEX PRIVATE LIMITED",
"REAL SURFACE FINISH PRIVATE LIMITED",
"REAL SWITCHGEARS & CABLES PRIVATE LIMITED",
"REAL TALENT ENGINEERING PRIVATE LIMITED",
"REAL TEAM SYSTEMS PRIVATE LIMITED",
"REAL TECH ENGINEERING",
"REAL TECHNICAL SOLUTIONS PRIVATE LIMITED",
"REAL TECHNO ENERGY & GAS PRIVATE LIMITED",
"REAL TIME DATA SERVICES PRIVATE LIMITED",
"REAL TIME ENTERPRISES",
"REAL TIME INTERACTIVE MEDIA PRIVATE LIMITED",
"REAL TIME MANAGEMENT CONSULTANCY SERVICES PRIVATE LIMITED",
"REAL TIME NETWORKS PRIVATE LIMITED",
"REAL TOUCH FINANCE LIMITED",
"REAL TOUCH STUDIO PRIVATE LIMITED",
"REAL VALUE EQUITIES (INDIA) PRIVATE LIMITED",
"REAL VALUE EXPORT PRIVATE LIMITED",
"REAL VALUE LEASING PRIVATE LIMITED",
"REAL VALUE PROMOTERS PRIVATE LIMITED",
"REAL VARIABLE DIGITAL ASSETSERVICES PRIVATE LIMITED",
"REAL VISTA CONSULTING PRIVATE LIMITED",
"REALANCHORS DEVELOPERS PRIVATE LIMITED",
"REALATION PROPERTY CONSULTANTS LLP",
"REALATTE VENTURES LLP",
"REALBOX DATA ANALYTICS PRIVATE LIMITED",
"REALBRIDGE E-MARKETING SOLUTIONS PRIVATE LIMITED",
"REALCADE LIFESCIENCE PRIVATE LIMITED",
"REALCARE HYGIENIC PRODUCTS PRIVATE LIMITED",
"REALCON RESIDENCY LLP",
"REALE HI RISERS INDIA PRIVATE LIMITED",
"REALEASE FACILITY MANAGEMENT PRIVATE LIMITED",
"REALFINITY REALTY PRIVATE LIMITED",
"REALGREEN HOMES PRIVATE LIMITED",
"REALISTELECTRO CONTROLS PRIVATE LIMITED",
"REALISTIC REALTORS PRIVATE LIMITED",
"REALISTIC SOFTECH PRIVATE LIMITED",
"REALITY BUILDWELL (INDIA) PRIVATE LIMITED",
"REALITY INFORMATION SYSTEMS PRIVATE LIMITED",
"REALITY PREMEDIA SERVICES",
"REALITY TEX YARN INDIA PRIVATE LIMITED",
"REALITY TOURS AND TRAVEL PRIVATE LIMITED",
"REALITY WAREHOUSING PRIVATE LIMITED",
"REALIX INDUSTRIES PRIVATE LIMITED",
"REALIZATION TECHNOLOGIES INDIA PRIVATE LIMITED",
"REALLAB BIOTECH PRIVATE LIMITED",
"REALLY AGRITECH PRIVATE LIMITED",
"REALM CONSULTING SERVICES PRIVATE LIMITED",
"REALM INTERMEDIATES PRIVATE LIMITED",
"REALM MEDIA SOLUTIONS PRIVATE LIMITED",
"REALM PROPERTIES PRIVATE LIMITED",
"REALMART PROPERTY SOLUTIONS PRIVATE LIMITED",
"REALME MOBILE TELECOMMUNICATIONS INDIA PRIVATE LIMITED",
"REALMONEY ADVISORY SOLUTION PRIVATE LIMITED",
"REALNETWORKS INDIA PRIVATE LIMITED",
"REALOGY HOLDINGS CORP.",
"REALPAGE INDIA PRIVATE LIMITED",
"REALPLY INDUSTRIES PRIVATE LIMITED",
"REALPLY VENTURES PRIVATE LIMITED",
"REALPRIX INFRACON PRIVATE LIMITED",
"REALPRO REALTY SOLUTIONS PRIVATE LIMITED",
"REALRAJ REAL ESTATE PRIVATE LIMITED",
"REALSCAN SYSTEMS PRIVATE LIMITED",
"REALSTONE ENTERTAINMENT PRIVATE LIMITED",
"REALSTONE TRADING COMPANY PRIVATE LIMITED",
"REAL-T PRIVATE LIMITED",
"REALTA HOSPITALITY LIMITED",
"REALTECH DEVELOPMENTS AND INFRASTRUCTURE INDIA PRIVATE LIMITED",
"REALTECH INFOSOLUTIONS PRIVATE LIMITED",
"REALTEKH SOFTWARE SERVICES PRIVATE LIMITED",
"REALTEL COMMUNICATION PRIVATE LIMITED",
"REALTIME BIOMETRICS INDIA PRIVATE LIMITED",
"REALTIME ENCLAVE PRIVATE LIMITED",
"REALTIME HR RESOURCING PRIVATE LIMITED",
"REALTIME INFRATEL PRIVATE LIMITED",
"REALTIME INTEGRATED INFRATECH PRIVATE LIMITED",
"REALTIME IT CONCEPTS PRIVATE LIMITED",
"REALTIME TAXSUTRA SERVICES PRIVATE LIMITED",
"REALTIME TECHSOLUTIONS PRIVATE LIMITED",
"REALTY ADVANCE STRUCTURE ENTERPRISES PRIVATE LIMITED",
"REALTY ASSISTANT PRIVATE LIMITED",
"REALTYSHIELD SERVICES PRIVATE LIMITED",
"REALVALUE FINLOAN SERVICES PRIVATE LIMITED",
"REALWEAR TECHNOLOGIES INDIA PRIVATE LIMITED",
"REALWORLD ONE STUDIO INDIA PRIVATE LIMITED",
"REAMETRIX INDIA PRIVATE LIMITED",
"REAN WATERTECH PRIVATE LIMITED",
"REANIN RESEARCH AND CONSULTING PRIVATE LIMITED",
"REANTIS PHARMACUTICALS PRIVATE LIMITED",
"REAP BENEFIT ECO SOLUTIONS PRIVATE LIMITED",
"REAPA CHEMICALS PRIVATE LIMITED",
"REAPRICH AGRI SOLUTIONS PRIVATE LIMITED",
"REARING EDUCATIONAL SERVICES",
"REASERCH OFFI H IRRI REARCH W R D BHOPAL",
"REASON COSMETICS PRIVATE LIMITED",
"REASON SOLUTIONS PRIVATE LIMITED",
"REASONABLE ENTERPRISES PRIVATE LIMITED",
"REASONING GLOBAL EAPPLICATIONS PRIVATE LIMITED",
"REASSURANZ TECHNOLOGY INDIA PRIVATE LIMITED",
"REAY ROAD IRON AND METAL WAREHOUSING PRIVATE LIMITED",
"REBACA TECHNOLOGIES PRIVATE LIMITED",
"REBALA NUTRI FOODEE PRIVATE LIMITED",
"REBAR DESIGN AND DETAIL PRIVATE LIMITED",
"REBATESOFT SERVICES PRIVATE LIMITED",
"REBBON ISOSYSTEMS PRIVATE LIMITED",
"REBECCA BUSINESS SERVICES PRIVATE LIMITED",
"REBECCA INTERNATIONAL PRIVATE LIMITED",
"REBEL MARKETPLACE INDIA PRIVATE LIMITED",
"REBELL THE FITNESS LOUNGE",
"REBELS FOOTWEARS PRIVATE LIMITED",
"REBLON FILMS PVT LTD",
"REBO SOLUTIONS PRIVATE LIMITED",
"REBOOT SYSTEMS INDIA PRIVATE LIMITED",
"REBORN CASTLECLEANING PRIVATE LIMITED",
"REBOUNCE ENTERTAINMENT PRIVATE LIMITED",
"REBOUND ACE INDIA PRIVATE LIMITED",
"REBOUND ENVIRO TECH PRIVATE LIMITED",
"REBRIGHT PARTNERS INDIA PRIVATE LIMITED",
"REBS LUBRICATION INDIA PRIVATE LIMITED",
"REBUILD TECHNOLOGIES SERVICES PRIVATE LIMITED",
"REBUS LOGISTICS PRIVATE LIMITED",
"REBUSCODE INFORMATION SOLUTIONS PRIVATE LIMITED",
"REBUTOR ELECTRONICS PRIVATE LIMITED",
"REBY CASTINGS PRIVATE LIMITED",
"REC ENGINEERING PRODUCTS PRIVATE LIMITED",
"REC MARITIME PRIVATE LIMITED",
"REC POWER DEVELOPMENT AND CONSULTANCY LIMITED",
"REC TRANSMISSION PROJECTS COMPANY LIMITED",
"RECAERO INDIA PRIVATE LIMITED",
"RECALL INDIA INFORMATION MANAGEMENT PRIVATE LIMITED",
"RECAPITA FINANCE PRIVATE LIMITED",
"RECARE PLASTIC MOULDERS PRIVATE LIMITED",
"RECAUTO INDIA PRIVATE LIMITED",
"RECAZ CHEMICALS INDIA PRIVATE LIMITED",
"RECEIVABLES EXCHANGE OF INDIA LIMITED",
"RECETA PHARMACEUTICALS INDIA PRIVATE LIMITED",
"RECFLY RECYCLERS PRIVATE LIMITED",
"RECHAPI PRIVATE LIMITED",
"RECHARGE FASHIONS ( INDIA ) PRIVATE LIMITED",
"RECHARGE INDIA PRIVATE LIMITED",
"RECHARGEKIT FINTECH PRIVATE LIMITED",
"RECHNER INFOSYSTEMS PRIVATE LIMITED",
"RECI ENGINEERING",
"RECIBO TECHNOLOGIES PRIVATE LIMITED",
"RECICLAR TECHNOLOGIES PRIVATE LIMITED",
"RECIPHARM HOLDING INDIA PRIVATE LIMITED",
"RECIPHARM PHARMASERVICES PRIVATE LIMITED",
"RECIPROCAL INFRASTRUCTURES PRIVATE LIMITED",
"RECIQ ENGINEERING PRIVATE LIMITED",
"RECITY NETWORK PRIVATE LIMITED",
"RECKERS AUTOMATION INDIA PVT LTD",
"RECKERS MECHATRONICS PRIVATE LIMITED",
"RECKITT BENCKISER HEALTHCARE INDIA PRIVATE LIMITED",
"RECKITT BENCKISER INDIA PRIVATE LIMITED",
"HFL HEALTHCARE AND WELLNESS PRIVATE LIMITED",
"RECKITT PIRAMAL LIMITED",
"RECKLABS SERVICES PRIVATE LIMITED",
"RECKON AGENCIES PRIVATE LIMITED",
"RECKON BIRETTA PRIVATE LIMITED",
"RECKON FURNITURE PRIVATE LIMITED",
"RECKON INDUSTRIES LIMITED",
"RECKON INFOSYSTEM PRIVATE LIMITED",
"RECKON ORGANICS PRIVATE LIMITED",
"RECKON RESISTORS PRIVATE LIMITED",
"RECKON SALES PRIVATE LIMITED",
"RECKONSYS TECH LABS PRIVATE LIMITED",
"RECKTRONIC DEVIICES AND SYSTEMS PRIVATE LIMITED",
"RECLA INTERNATIONALS PRIVATE LIMITED",
"RECLAIM METALS PRIVATE LIMITED",
"RECLAMATION REAL ESTATE COMPANY (INDIA) PRIVATE LIMITED",
"RECLINERS INDIA PRIVATE LIMITED",
"RECLIX INDIA PRIVATE LIMITED",
"RECLOUD CONSULTING PRIVATE LIMITED",
"RECMET ALLOYS PRIVATE LIMITED",
"RECNAC ONCOLOGY PRIVATE LIMITED",
"RECO SAFETY AND AUTOMATION PRIVATE LIMITED",
"RECO STORAGE SYSTEMS PRIVATE LIMITED",
"RECOCHEM (INDIA) PRIVATE LIMITED",
"RECOLOGY RECYCLING INDIA PRIVATE LIMITED",
"RECOMBIGEN LABORATORIES PRIVATE LIMITED",
"RECON AGENCIES LIMITED",
"RECON ASSET PORTFOLIO MANAGEMENT PRIVATE LIMITED",
"RECON BUILDERS PRIVATE LIMITED",
"RECON DIES & TOOLS PRIVATE LIMITED",
"RECON ENERGY INDIA PRIVATE LIMITED",
"RECON ENGICONS PRIVATE LIMITED",
"RECON ENGINEERING CO PVT LTD",
"RECON MACHINE TOOLS PRIVATE LIMITED",
"RECON OIL INDUSTRIES PRIVATE LIMITED",
"RECON TECHNOLOGIES PRIVATE LIMITED",
"RECONNECT ENERGY SOLUTIONS LIMITED",
"RECONNOITER TECHNOLOGIES & RESEARCH PRIVATE LIMITED",
"RECONS BUILDING PRODUCTS PRIVATE LIMITED",
"RECONS DISTRIBUTION PRIVATE LIMITED",
"RECONS POWER EQUIPMENTS PRIVATE LIMITED",
"RECORD MACHINERIES PVT LTD.",
"RECORDED MUSIC PERFORMANCE LIMITED",
"RECORDERS & MEDICARE SYSTEMS PRIVATE LIMITED",
"RECORDERS & MEDICARE SYSTEMS PRIVATELIMITED",
"RECORN FOODS PRIVATE LIMITED",
"RECORP GLOBAL SERVICES PRIVATE LIMITED",
"RECOS SENSORS & CONTROL PRIVATE LIMITED",
"RECOS SOIL SUBSTRATES PRIVATE LIMITED",
"RECOSENSE INFOSOLUTIONS PRIVATE LIMITED",
"RECOURSE GOURMET GROCERIES PRIVATE LIMITED",
"RECOVA PHARMA EXPO PRIVATE LIMITED",
"RECRAFT PROCESSING PRIVATE LIMITED",
"RECREATE ENGINEERING PRODUCTS PRIVATE LIMITED",
"RECREATION DYNAMICS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"RECROSOFT TECHNOLOGIES PRIVATE LIMITED",
"RECRUISE INDIA CONSULTING PRIVATE LIMITED",
"RECRUITMENT SMART TECHNOLOGIES INDIA PRIVATE LIMITED",
"RECRUITSMART STAFFING PRIVATE LIMITED",
"RECSTECH TECHNOLOGY PRIVATE LIMITED",
"RECTICEL INDIA PRIVATE LIMITED",
"RECTIFIER HOUSE (INDIA) PRIVATE LIMITED",
"RECTIFIERS & ELECTRONICS PRIVATE LIMITED",
"RECTOR LOGISTICS PRIVATE LIMITED",
"RECTRIX TECHNOLOGIES PRIVATE LIMITED",
"RECUBE CIRCULAR SOLUTIONS PRIVATE LIMITED",
"RECULTA SOLUTIONS PRIVATE LIMITED",
"RECURSIVE GLOBAL INFOTECH PRIVATE LIMITED",
"RECURSO WELLNESS PRIVATE LIMITED",
"RECUVA TECHNOLOGIES PRIVATE LIMITED",
"RECVUE INDIA PRIVATE LIMITED.",
"RECYCLE METAL AND COMMODITIES PRIVATE LIMITED",
"RECYCLE TRACK INDUSTRIAL ENTERPRISE PRIVATE LIMITED",
"RECYCLING & ENVIRONMENT INDUSTRY ASSOCIATION OF INDIA",
"RECYCLING SOLUTIONS PRIVATE LIMITED",
"RED ALPHA MECHATRONICS SERVICE PRIVATE LIMITED",
"RED ALUPANEL INDIA PRIVATE LIMITED",
"RED AND WHITE MULTIMEDIA EDUCATION",
"RED AND WINE DECOR PRIVATE LIMITED",
"RED APPLE KITCHEN CONSULTANCY PRIVATE LIMITED",
"RED APPLE TECHNOLOGIES PRIVATE LIMITED",
"RED APRICOT TECHNOLOGY PRIVATE LIMITED",
"RED APRON PRIVATE LIMITED",
"RED BARON INTEGRATED SERVICES PRIVATE LIMITED",
"RED BEAN HOSPITALITY PRIVATE LIMITED",
"RED BOX REWARDS INDIA PRIVATE LIMITED",
"RED BRICK LANE MARKETING SOLUTIONS PRIVATE LIMITED",
"RED BULL INDIA PRIVATE LIMITED",
"RED BURRY TEX PRIVATE LIMITED",
"RED CAMELS ISLAMIC SCHOOL",
"RED CARPET TRAVEL SERVICES PRIVATE LIMITED",
"RED CAT TECHNOLOGY INDIA PRIVATE LIMITED",
"RED CHARIOTS EVENT MANAGEMENT AND MARKETING PRIVATE LIMITED",
"RED CHILLI MANAGEMENT SERVICES PRIATE LIMITED",
"RED CHILLIES ENTERTAINMENTS PRIVATE LIMITED",
"RED CHILLY FOODS PRIVATE LIMITED",
"RED CLOUD COMPUTING PRIVATE LIMITED",
"RED CORAL MERCHANDISING PRIVATE LIMITED",
"RED COW DAIRY PRIVATE LIMITED",
"RED CRAFT MANAGEMENT CONSULTANCY PRIVATE LIMITED",
"RED CUBE DIGITAL MEDIA PRIVATE LIMITED",
"RED DOT ENTERTAINMENT PRIVATE LIMITED",
"RED EARTH GOOD LIVING AND HOSPITALITY PRIVATE LIMITED",
"RED EARTH INFRAPROJECTS PRIVATE LIMITED",
"RED EARTH MACHINES PRIVATE LIMITED",
"RED EARTH STEELS PRIVATE LIMITED",
"RED ESTATE DESTINATION PRIVATE LIMITED",
"RED EVENTS INDIA PRIVATE LIMITED",
"RED EXPRESS TRANSPORT SERVICES LIMITED",
"RED EYE MEDIA PRIVATE LIMITED",
"RED FORT CAPITAL FINANCE COMPANY PRIVATE LIMITED",
"RED FORT PPE INDUSTRIES PRIVATE LIMITED",
"RED FORT SHAHJAHAN PROPERTIES PRIVATE LIMITED",
"RED GINGER HOSPITALITY (INDIA) PRIVATE LIMITED",
"RED HAT INDIA PRIVATE LIMITED",
"RED HORSE CAPITAL PRIVATE LIMITED",
"RED INDIAN WINE AND BEER PRIVATE LIMITED",
"RED LIFESTYLE PRIVATE LIMITED",
"RED LINE INDUSTRIES LIMITED",
"RED LINE LOGISTICS PRIVATE LIMITED",
"RED LOGISTICS LIMITED",
"RED LOTUS METAL WORKS FACILITIES AND SERVICES PRIVATE LIMITED",
"RED LOUNGE CAPITAL PRIVATE LIMITED",
"RED MANGO ANALYTICS PRIVATE LIMITED",
"RED MATTER SOFTWARE TECHNOLOGY PRIVATE LIMITED",
"RED MOMENTS GIFTINGS PRIVATE LIMITED",
"RED MONKEY DESIGN GROUP PRIVATE LIMITED",
"RED OCEAN SHIPPING ACADEMY PRIVATE LIMITED",
"RED ORGANISERS PRIVATE LIMITED",
"RED PACKING SOLUTIONS PRIVATE LIMITED",
"RED PEACH INNOVATIONS INDIA PRIVATE LIMITED",
"RED PHASE INDIA PRIVATE LIMITED",
"RED PHOENIX HOSPITALITY SERVICES PRIVATE LIMITED",
"RED PIXELS VENTURES LIMITED",
"RED PLANET TRAVELS & SPORTS PRIVATE LIMITED",
"RED PRINTS PRIVATE LIMITED",
"RED QUBE IDEAS PRIVATE LIMITED",
"RED RABBIT GAMES PRIVATE LIMITED",
"RED ROAD HEALTH SOLUTIONS PRIVATE LIMITED",
"RED ROOSTER PERFORMANCE (INTERNATIONAL) PRIVATE LIMITED",
"RED ROSE ESTATES PRIVATE LIMITED",
"RED ROSE MARKETING LIMITED",
"RED SHORE INTERNATIONAL PRIVATE LIMITED",
"RED SOIL FOOD PRODUCTS PRIVATE LIMITED",
"RED STAR DIGITAL NETWORKS PRIVATE LIMITED",
"RED STAR PLASTICK PRIVATE LIMITED",
"RED STAR SAFETY PRIVATE LIMITED",
"RED STREAM MARKET TECHNOLOGIES PRIVATE LIMITED",
"RED SUN & BLACK ROCK BEVERAGES PRIVATE LIMITED",
"RED SUN SOLAR ENERGY PRIVATE LIMITED",
"RED TELEWORLD LLP",
"RED TORTOISE DIGITAL MEDIA PRIVATE LIMITED",
"RED TREE DESIGN STUDIO PRIVATE LIMITED",
"RED TULLIP HOTELS PRIVATE LIMITED",
"RED VISION COMPUTER TECHNOLOGIES PRIVATE LIMITED",
"RED WALL MEDIAWORKS PRIVATE LIMITED",
"RED7 ECOMMERCE PRIVATE LIMITED",
"REDA ASSOCIATES PRIVATE LIMITED",
"REDA CHEMICALS INDIA PRIVATE LIMITED",
"REDANDBLUE APPLIED INNOVATIONS PRIVATE LIMITED",
"REDAPPLE FOODS PRIVATE LIMITED",
"REDBERRY SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"REDBIRD AIRWAYS PRIVATE LIMITED",
"REDBLACK SOFTWARE PRIVATE LIMITED",
"REDBLACKTREE TECHNOLOGIES PRIVATE LIMITED",
"REDBLINK PRIVATE LIMITED",
"REDBOYS SECURITY & PROTECTION PRIVATE LIMITED",
"REDBRICK AI PRIVATE LIMITED",
"REDBRICK INFRABUILD PRIVATE LIMITED",
"REDBRICK IT SUPPORT LIMITED",
"REDBRICK OFFICES LIMITED",
"REDBRICK RETAIL PRIVATE LIMITED",
"REDBRICKS EDUCATION FOUNDATION",
"REDBRICS ITES INDIA PRIVATE LIMITED",
"REDBRIDGE VALVES PRIVATE LIMITED",
"REDBUS INDIA PRIVATE LIMITED",
"REDCAP TECHNOLOGIES PRIVATE LIMITED",
"REDCARPET TECH PRIVATE LIMITED",
"REDCARRY TECHNOLOGIES PRIVATE LIMITED",
"REDCEE CONSTRUCTIONS PRIVATE LIMITED",
"REDCELL TECHNOCARE PRIVATE LIMITED",
"REDCELLS DIAGNOSTICS PRIVATE LIMITED",
"REDCENTRIC SOLUTIONS PRIVATE LIMITED",
"REDCENTRIC SUPPORT SERVICES PRIVATE LIMITED",
"REDCHILLI HOLIDAYS PRIVATE LIMITED",
"REDCLIFFE HYGIENE PRIVATE LIMITED",
"REDCLIFFE LIFESCIENCE PRIVATE LIMITED",
"REDCLOUD VENTURES PRIVATE LIMITED",
"REDCO HOTELS PRIVATE LIMITED",
"REDCUBE MARKETING SOLUTIONS PRIVATE LIMITED",
"REDCURE INDIAN PHARMA PRIVATE LIMITED",
"REDD COMMUNICATION INDIA PRIVATE LIMITED",
"REDD MICA PRIVATE LIMITED",
"REDDITO CAPITAL INVESTMENT ADVISORS PRIVATE LIMITED",
"REDDITO CAPITAL RESEARCH PRIVATE LIMITED",
"REDDVISE REALTY ADVISORS PRIVATE LIMITED",
"REDDY & NEUMANN INDIA PRIVATE LIMITED",
"REDDY AND REDDY IMPEX PRIVATE LIMITED",
"REDDY BUILDERS AND DEVELOPERS",
"REDDY FOREX PRIVATE LIMITED",
"REDDY HEALTHCARE PRIVATE LIMITED",
"REDDY LOGISTICS",
"REDDY PHOTO STUDIO",
"REDDY STRUCTURES PRIVATE LIMITED",
"REDDY VEERANNA CONSTRUCTIONS PRIVATE. LIMITED.",
"REDDYS DIGITAL PRIVATE LIMITED",
"REDE SCALABLE ENERGY MANAGEMENT PRIVATE LIMITED",
"REDECON (INDIA) PRIVATE LTD",
"REDEEM SOFTWARE PRIVATE LIMITED",
"REDEFINE ENTERPRISES PRIVATE LIMITED",
"REDEFINE FOODS PRIVATE LIMITED",
"REDEFINE MARCOM PRIVATE LIMITED",
"REDEFINE ONLINE EXPRESS OPC PRIVATE LIMITED",
"REDEX ENTERPRISE",
"REDEX ENTERPRISE PRIVATE LIMITED",
"REDEX INDIA PRIVATE LIMITED",
"REDFORD FOOTWEAR (INDIA) PRIVATE LIMITED",
"REDGIRRAFFE ECOMMERCE (INDIA) PRIVATE LIMITED",
"REDGRAPE BUSINESS SERVICES PRIVATE LIMITED",
"REDGROVE PHARMACEUTICALS INDIA PRIVATE LIMITED",
"REDHERRING PLAST INDIA PRIVATE LIMITED",
"REDHILL HERBALS PRIVATE LIMITED",
"REDHUNT LABS INDIA PRIVATE LIMITED",
"REDI INDIA QUALITY SERVICES PRIVATE LIMITED",
"REDI PORT LIMITED",
"REDIAL INDIA SOLUTIONS PRIVATE LIMITED",
"REDIAN SOFTWARE PRIVATE LIMITED",
"REDICHEM PIGMENTS PVT LTD",
"REDICO VANIJYA PVT LTD",
"REDIFF.COM INDIA LIMITED",
"REDIFFUSION BRAND SOLUTIONS PRIVATE LIMITED",
"REDIFICE DEVELOPERS INDIA PRIVATE LIMITED",
"REDILENS OPTICS PRIVATE LIMITED",
"REDIM INFORMATION SYSTEMS PRIVATE LIMITED",
"REDIM TECHNOLOGIES PRIVATE LIMITED",
"REDINEX LIFE SCIENCES PRIVATE LIMITED",
"REDINGTON CONSORTIUM PRIVATE LIMITED",
"REDINGTON GULF FZE",
"REDINGTON LIMITED",
"REDIONS TECHNOLOGIES PRIVATE LIMITED",
"REDISCOVER CLINIC PRIVATE LIMITED",
"REDISOLVE SOFTWARE PRIVATE LIMITED",
"REDISSON METALS & ALLOYS PRIVATE LIMITED",
"REDIZEN LIFESCIENCES PRIVATE LIMITED",
"REDKIWI VEHICLES PRIVATE LIMITED",
"REDKNEE INDIA TECHNOLOGIES PRIVATE LIMITED",
"REDKNOT MARKETING SOLUTIONS PRIVATE LIMITED",
"REDLANDS ASHLYN MOTORS PLC.",
"REDLANDS MACHINERY PRIVATE LIMITED",
"REDLEAF HERBALS PRIVATE LIMITED",
"REDLEAF PLASTICS INDIA PRIVATE LIMITED",
"REDLEAF TECHNOLOGIES PRIVATE LIMITED",
"REDLEO SOFTWARE SOLUTIONS PRIVATE LIMITED",
"REDMAPLE BUILDIKO PRIVATE LIMITED",
"REDMIL BUSINESS MALL PRIVATE LIMITED",
"REDMOND MERCHANTS PRIVATE LIMITED",
"REDNILE INNOVATIONS PRIVATE LIMITED",
"REDON INFRA POWER PRIVATE LIMITED",
"REDOX INDUSTRIES LIMITED",
"REDOX LABORATORIES (INDIA) PRIVATE LIMITED",
"REDOX PHARMACHEM PRIVATE LIMITED",
"REDPAY PAYMENTS PRIVATE LIMITED",
"REDPEAK FACILITIES MANAGEMENT PRIVATE LIMITED",
"RED-PEARL COMMUNICATIONS PRIVATE LIMITED",
"REDPEPPER CUISINE PRIVATE LIMITED",
"REDPINE SIGNALS INC",
"REDPINE SIGNALS INDIA PRIVATE LIMITED",
"REDPRAIRIE TECHNOLOGIES INDIA PRIVATE LIMITED",
"REDPRO CONSTRUCTIONS PRIVATE LIMITED",
"REDPRO DEVELOPERS PRIVATE LIMITED",
"REDPRO FACILITIES PRIVATE LIMITED",
"REDREEF FINANCE AND INVESTMENTS PRIVATE LIMITED",
"REDREN ENERGY PRIVATE LIMITED",
"REDRIDGE INDIA PRIVATE LIMITED",
"REDROCK IT SOLUTIONS INDIA PRIVATE LIMITED",
"REDROOMTECHNOLOGY PRIVATE LIMITED",
"REDROSE SYNTHETICS PRIVATE LIMITED",
"REDSEA ECO SOLUTIONS AND INSTRUMENTS PRIVATE LIMITED",
"REDSEAL LABS INDIA PRIVATE LIMITED",
"REDSEAL NETWORKS INDIA PRIVATE LIMITED",
"REDSEER MANAGEMENT CONSULTING PRIVATE LIMITED",
"REDSHELL ENGINEERS PRIVATE LIMITED",
"REDSHIFT INNOVATIONS PRIVATE LIMITED",
"REDSKIN HOME DECOR PRIVATE LIMITED",
"REDSKY TECHNOLOGIES PRIVATE LIMITED",
"REDSOFT BUSINESS SOLUTIONS PRIVATE LIMITED",
"REDSOIL CONSTRUCTIONS PRIVATE LIMITED",
"REDSOL ENERGY PRIVATE LIMITED",
"REDSON CYLINDERS PRIVATE LIMITED",
"REDSON RETAIL AND REALITY PRIVATE LIMITED",
"REDSPACE",
"REDSPOT JUPITER TECHSALES PRIVATE LIMITED",
"REDSTART LABS (INDIA) LIMITED",
"REDSTER COMMERCE PRIVATE LIMITED",
"REDSTONE GRANITO PRIVATE LIMITED",
"REDSTONE LEARNING SOLUTIONS PRIVATE LIMITED",
"REDSUN SOLAR INDUSTRIES",
"REDTEAMFACTORY SOLUTIONS PRIVATE LIMITED",
"REDTECH ENERGY PRIVATE LIMITED",
"REDTECH NETWORK INDIA PRIVATE LIMITED",
"REDVISION GLOBAL TECHNOLOGIES PRIVATE LIMITED",
"REDWING PHARMA PRIVATE LIMITED",
"REDWING SOLUTIONS PRIVATE LIMITED",
"REDWOOD ASSOCIATES BUSINESS SOLUTIONS PRIVATE LIMITED",
"REDWOOD IT SERVICES PRIVATE LIMITED",
"REDWOODS HOSPITALITY PRIVATE LIMITED",
"REDWOP CHEMICALS PRIVATE LIMITED",
"REDZONE LABS PRIVATE LIMITED",
"REE ATHARVA LIFE SCIENCE PRIVATE LIMITED",
"REEBE EXPORTS PRIVATE LIMITED",
"REEBLE PLATFORM INDIA PRIVATE LIMITED",
"REECA INFRASTRUCTURE PRIVATE LIMITED",
"REECO TOYS INDIA PRIVATE LIMITED",
"REECOMPS TELESERVICES PRIVATE LIMITED",
"REED & MACKAY TRAVEL INDIA PRIVATE LIMITED",
"REED AND PICK IMPEX PRIVATE LIMITED",
"REED EXHIBITIONS INDIA",
"REED MANCH EXHIBITIONS PRIVATE LIMITED",
"REED RELAYS",
"REED SI EXHIBITIONS PRIVATE LIMITED",
"REEDS WORLD SCHOOL",
"REEFIN SOLUTIONS INDIA PRIVATE LIMITED",
"REEFLEX PACKAGING PRIVATE LIMITED",
"REEFORD VENTURES PRIVATE LIMITED",
"REEGRAAJ ALBANIL PRIVATE LIMITED",
"REEHEL PHARMACEUTICALS PRIVATE LIMITED",
"REEL INDIA SERVICES PRIVATE LIMITED",
"REEL LIFE PRODUCTION PRIVATE LIMITED",
"REELABS PRIVATE LIMITED",
"REELAM GARMENTS PRIVATE LIMITED",
"REELAND MULTITRADE PRIVATE LIMITED",
"REELAY ECOMMERCE INDIA PRIVATE LIMITED",
"REELIABLE COURIER & CARGO PRIVATE LIMITED",
"REELICON RED HOMES PRIVATE LIMITED",
"REELIENCE SHIPPING SERVICES PRIVATE LIMITED",
"REELOM INDIA PRIVATE LIMITED",
"REEM TANNERS PRIVATE LIMITED",
"REEMA TRANSPORT PRIVATE LIMITED",
"REEMZ MANUFACTURING LLP",
"REENA DECOR PRIVATE LIMITED",
"REENA DEVELOPERS PRIVATE LIMITED",
"REENA ENTERPRISES PVT LTD",
"REENA FASHION PRIVATE LIMITED",
"REENA LIGHTNINGS PRIVATE LIMITED",
"REENA MECHANICALS PRIVATE LIMITED",
"REENA ORGANICS PRIVATE LIMITED",
"REENA PHARMA INDIA PRIVATE LIMITED",
"REENA SILICATE INDUSTRIES PRIVATE LIMITED",
"REENAM FABRICS PVT LTD",
"REENAV PHARMA PRIVATE LIMITED",
"REENGUS SIKAR EXPRESSWAY LIMITED",
"REENGUS WIRES PRIVATE LIMITED",
"REENOLDS RUBBER PRIVATE LIMITED",
"REEP INDUSTRIES PRIVATE LIMITED",
"RE'EQUIL INDIA PRIVATE LIMITED",
"REES HOSPITAL",
"REESHAV AUTOMOBILES PRIVATE LIMITED",
"REET RETAILS ADVERTISING PRIVATE LIMITED",
"REETA BUILD-CON PRIVATE LIMITED",
"REETA MOTORS PRIVATE LIMITED",
"REETA MULTI SPECIALITY HOSPITAL & TRAUMA CENTRE",
"REETECH INTERNATIONAL CARGO AND COURIER LIMITED",
"REETEK DEVELOPERS PRIVATE LIMITED",
"REETI EXIM AND APPLICATION PRIVATE LIMITED",
"REETIKA SEED PRODUCTS PRIVATE LIMITED",
"REETU ROADLINES PRIVATE LIMITED",
"REETU SYNTHETICS PRIVATE LIMITED",
"REEVA BUILDCON PRIVATE LIMITED",
"REEVON TEXTILES PRIVATE LIMITED",
"REEWAA ENERGIES AND INFRA PRIVATE LIMITED",
"REEYA SAFELOGISTICS PRIVATE LIMITED",
"REEYO MOTEL THE VILLAGE RESORT PVT LTD",
"REFAB CONSTRUCTION (INDIA) PRIVATE LIMITED",
"REFAIR INDIA PRIVATE LIMITED",
"REFARMED CHEMICALS INDIA PRIVATE LIMITED",
"REFCOAT CHEMICALS PRIVATE LIMITED",
"REFCOM (INDIA) PVT LTD",
"REFCON CARRIERS PRIVATE LIMITED",
"REFCON COLD CHAIN PRIVATE LIMITED",
"REFCON REFRIGERATION PRIVATE LIMITED",
"REFCON TECHNOLOGIES AND SYSTEMS PRIVATE LIMITED",
"REFEEL CARTRIDGE ENGINEERING PRIVATE LIMITED",
"REFERENCE BIO SOLUTIONS PRIVATE LIMITED",
"REFERRAL HOSPITAL AND COMMUNITY HEALTH CENTER",
"REFERRAL HOSPITAL AND COMMUNITY HEALTH CENTRE",
"REFERRALYOGI TECHNOLOGIES PRIVATE LIMITED",
"REFEX ENERGY (RAJASTHAN) PRIVATE LIMITED",
"REFEX GREEN POWER LIMITED",
"REFEX INDUSTRIES LIMITED",
"REFFCO AH PRIVATE LIMITED",
"REFFERAL HOSPITAL & C H C MANAVADAR DIST JUNAGADH",
"REFFLOW ENTERPRISES PRIVATE LIMITED",
"REFINE ALLOY PRIVATE LIMITED",
"REFINED IT SOLUTIONS AND MARKETING PRIVATE LIMITED",
"REFINERY HOSPITAL",
"REFINITIV INDIA PRIVATE LIMITED",
"REFINITIV INDIA SHARED SERVICES PRIVATE LIMITED",
"REFINITIV INDIA TRANSACTION SERVICES PRIVATE LIMITED",
"REFIT GLOBAL PRIVATE LIMITED",
"REFKINGS COTTSOYA PRIVATE LIMITED",
"REFLECT SCULPT PRIVATE LIMITED",
"REFLECTIONS ELECTRICALS PRIVATE LIMITED",
"REFLECTIONS INFO SYSTEMS PRIVATE LIMITED",
"REFLECTIONS INTERIOR PRODUCTS PRIVATE LIMITED",
"REFLEKTION MEDIA SOFTWARE (INDIA) PRIVATE LIMITED",
"REFLEKTIVE LABS PRIVATE LIMITED",
"REFLEX COMMUNICATIONS PRIVATE LIMITED",
"REFLEXALLEN INDIA PRIVATE LIMITED",
"REFLEXALLEN INDIA TUBING PRIVATE LIMITED",
"REFLEXIONS (INDIA) PRIVATE LIMITED",
"REFLEXIONS NARAYANI IMPEX PRIVATE LIMITED",
"REFLEXIS SYSTEMS INDIA PRIVATE LIMITED",
"REFLION TECH PRIVATE LIMITED",
"REFLUX PHARMACEUTICALS PRIVATE LIMITED",
"REFOC TRADING COMPANY PRIVATE LIMITED",
"REFOIL EARTH PVT LTD",
"REFORM CLUB (GUJARAT) LIMITED",
"REFORM FLOUR MILLS PVT LTD",
"REFORM PACKAGING PRIVATE LIMITED",
"REFPAY MEDIA PRIVATE LIMITED",
"REFRA MINING AND POWER LIMITED",
"REFRAC CONSULTANCY & SERVICES PRIVATE LIMITED",
"REFRACARE ENGINEERS PRIVATE LIMITED",
"REFRACAST METALLURGICALS PRIVATE LIMITED",
"REFRACT CONSULTING PRIVATE LIMITED",
"REFRACTORY ENGINEERING AND CONSTRUCTION PRIVATE LIMITED",
"REFRACTORY SHAPES LIMITED",
"REFRAHOLD INDUSTRIES PRIVATE LIMITED",
"REFRAME SOFT TECH PRIVATE LIMITED",
"REFRATECHNIK INDIA PRIVATE LIMITED",
"REFRATEX INDIA PRIVATE LIMITED",
"REFRATHERM INTERNATIONAL PRIVATE LIMITED",
"REFRESH WELLNESS PRIVATE LIMITED",
"REFRESHMENT PRODUCT SERVICE INDIA PRIVATE LIMITED",
"REFRIGERATION CENTRE PRIVATE LIMITED",
"REFRIGERATION CONTROLS (INDIA) PVT LTD",
"REFRIGERATORS & HOME APPLIANCES PRIVATE LIMITED",
"REFRON VALVES PRIVATE LIMITED",
"REFROTECH SYNERGY PRIVATE LIMITED",
"REFTECK SOLUTION PRIVATE LIMITED",
"REFTRON INDIA (OPC) PRIVATE LIMITED",
"REFU DRIVE INDIA PRIVATE LIMITED",
"REFULGENCEINC PRIVATE LIMITED",
"REFULGENT ISPAT PRIVATE LIMITED",
"REFULGENT MINERAL PRIVATE LIMITED",
"REFURBMED SOLUTIONS PRIVATE LIMITED",
"REG DY DIRECTOR HPCL NAGPUR",
"REGAAL RESOURCES LIMITED",
"REGAIN LIFECARE LIMITED",
"REGAL AGRO FOODS PRIVATE LIMITED",
"REGAL ALLOYS PRIVATE LIMITED",
"REGAL ARIAL COM",
"REGAL BATHROOM FITTINGS PRIVATE LIMITED",
"REGAL CAD SERVICES PRIVATE LIMITED",
"REGAL CARBIDE DIES PRIVATE LIMITED",
"REGAL CARS PRIVATE LIMITED",
"REGAL CASTORS PRIVATE LIMITED",
"REGAL COLONISERS PRIVATE LIMITED",
"REGAL COMMODITIES PRIVATE LIMITED",
"REGAL CONTAINER LINE PRIVATE LIMITED",
"REGAL EMPORIA INFRATECH PRIVATE LIMITED",
"REGAL ENGINEERS & CONTRACTORS PRIVATE LIMITED",
"REGAL FARM INDUSTRIES PRIVATE LIMITED",
"REGAL FARMFRESH PRIVATE LIMITED",
"REGAL FOREX PRIVATE LIMITED",
"REGAL FORGINGS PRIVATE LIMITED",
"REGAL HEALTHCARE LIMITED",
"REGAL HOLIDAY HOMES PRIVATE LIMITED",
"REGAL INDIA LOGISTICS PRIVATE LIMITED",
"REGAL INFORMATION TECHNOLOGY PRIVATE LIMITED",
"REGAL INSURANCE BROKERS & RISK MANAGEMENT SERVICE PRIVATE LIMITED.",
"REGAL INTERIORS PRIVATE LIMITED",
"REGAL JEWELLERS LLP",
"REGAL KITCHEN FOODS LIMITED",
"REGAL LEATHER PVT LTD",
"REGAL MINES AND MINERALS PRIVATE LIMITED",
"REGAL OUTSOURCE (INDIA) PRIVATE LIMITED",
"REGAL PACK BOXES (INDIA) PRIVATE LIMITED",
"REGAL PAINTS & BRUSH PRIVATE LIMITED",
"REGAL PLYWOOD INDUSTRIES PRIVATE LIMITED",
"REGAL POLYTECH PRIVATE LIMITED",
"REGAL REMEDIES LIMITED",
"REGAL SHIPPING AND MARINE SERVICES PRIVATE LIMITED",
"REGAL SHIPPING PRIVATE. LIMITED.",
"REGAL SHOES INIDIA PRIVATE LIMITED",
"REGAL SOLUTIONS PRIVATE LIMITED",
"REGAL SPECIALITY FOODS PRIVATE LIMITED",
"REGAL SYNTHETICS PVT LTD",
"REGAL TRADECON PRIVATE LIMITED",
"REGAL TRADING PVT. LTD.",
"REGAL TRANSCORE LAMINATIONS PRIVATE LIMITED",
"REGAL UDYOG PRIVATE LIMITED",
"REGAL WAREHOUSING & PROCESSING PRIVATE LIMITED",
"REGAL WOVEN SACKS PRIVATE LIMITED",
"REGALIA PHARMACEUTICALS I PRIVATE LIMITED",
"REGALIAA BUILDTECH & SERVICES PRIVATE LIMITED",
"REGALINDIA TOURS AND TRAVELS PRIVATE LIMITED",
"REGALIX INDIA PRIVATE LIMITED",
"REGALIZ MEDICARE LIMITED",
"REGALO KITCHENS PRIVATE LIMITED",
"REGALO MART PRIVATE LIMITED",
"REGARD NETWORK SOLUTION PRIVATE LIMITED",
"REGARD SOLUTIONS PRIVATE LIMITED",
"REGARDIA PHARMACEUTICALS",
"REGARDS MARKETING PRIVATE LIMITED",
"REGARDS SAREES PVT. LTD.",
"REGAS VENTURE INDIA ONE PRIVATE LIMITED",
"REGATTA STONE EXPORTS PRIVATE LIMITED",
"REGBEX LIFE SCIENCES PRIVATE LIMITED",
"REGE IMAGING AND CINE FILMS PRIVATE LIMITED",
"REGEN BIOCORPS AHI PRIVATE LIMITED",
"REGEN NUTRIPHARM PRIVATE LIMITED",
"REGENCY CAR RENTALS PRIVATE LIMITED",
"REGENCY CARBIDE PVT LTD",
"REGENCY CARGO SERVICES PRIVATE LIMITED",
"REGENCY CERAMICS LTD",
"REGENCY CREATIONS LIMITED",
"REGENCY ELECTRICALS PRIVATE LIMITED.",
"REGENCY EXPORTS PRIVATE LIMITED",
"REGENCY FINCORP LIMITED",
"REGENCY GANGANI ENERGY PRIVATE LIMITED",
"REGENCY HOLIDAYZ PRIVATE LIMITED",
"REGENCY HOSPITAL LIMITED",
"REGENCY HOTELS AND INVESTMENTS (INDIA) PRIVATE LIMITED",
"REGENCY INFOTECH PRIVATE LIMITED",
"REGENCY INSTITUTE OF NURSING",
"REGENCY ISPAT PRIVATE LIMITED",
"REGENCY LIFESCIENCES (INDIA) PRIVATE LIMITED",
"REGENCY NEPHROCARE PRIVATE LIMITED",
"REGENCY NIRMAN LIMITED",
"REGENCY PROPERTY INVESTMENTS PRIVATE LIMITED",
"REGENCY RENT-A-CAB PRIVATE LIMITED",
"REGENCY RETAIL PRIVATE LIMITED",
"REGENCY SEMI-CONDUCTORS PRIVATE LIMITED",
"REGENCY SURAJ HOSPITALITY PRIVATE LIMITED",
"REGENCY TEXTRADE PRIVATE LIMITED",
"REGENCY TOURS PRIVATE LIMITED",
"REGENCY TRUST LTD",
"REGENCY WOOD PANEL PRIVATE LIMITED",
"REGENCY YAMUNA ENERGY LIMITED",
"REGENCY-INN PRIVATE LIMITED",
"REGENERSIS INDIA PRIVATE LIMITED",
"REGENESIS FACILITY MANAGEMENT COMPANY PRIVATE LIMITED",
"REGENESIS INDUSTRIES PRIVATE LIMITED",
"REGENESYS INSTITUTE OF MANAGEMENT PRIVATE LIMITED",
"REGENIX BIOSCIENCES LIMITED",
"REGENIX DRUGS LIMITED",
"REGENIX SUPER SPECIALITY LABORATORIES PRIVATE LIMITED",
"REGENO VENTURES PRIVATE LIMITED",
"REGENT AUTOLINKS PRIVATE. LIMITED.",
"REGENT AUTOMOBILES PRIVATE LIMITED",
"REGENT AUTOPOINTS PRIVATE LIMITED",
"REGENT BATHZ PRIVATE LIMITED",
"REGENT BEERS AND WINES LIMITED",
"REGENT BIOCHEM INDIA PRIVATE LIMITED",
"REGENT CLIMATE CONNECT KNOWLEDGE SOLUTIONS PRIVATE LIMITED",
"REGENT COMPUTRONICS PRIVATE LIMITED",
"REGENT CREATION PRIVATE LIMITED",
"REGENT DIGITECH PRIVATE LIMITED",
"REGENT DISTILLERS PRIVATE LIMITED",
"REGENT EDUCATION & RESEARCH FOUNDATION",
"REGENT ELECTRO-MECH PRIVATE LIMITED",
"REGENT ENERGY LIMITED",
"REGENT ENTERPRISES LIMITED",
"REGENT EXCHANGE (INDIA) PRIVATE LIMITED",
"REGENT FIRST PRIVATE LIMITED",
"REGENT FLOWCHEM EQUIPMENTS PRIVATE LIMITED",
"REGENT GARAGE PRIVATE LIMITED",
"REGENT HIRISE PRIVATE LIMITED",
"REGENT HITECH PRIVATE LIMITED",
"REGENT HONDA PROP TEJPAL MOTORS PRIVATE. LIMITED",
"REGENT INDIA TRANSWAY PRIVATE LIMITED",
"REGENT LAND HOLDINGS PRIVATE LIMITED",
"REGENT LIFELINE PRIVATE LIMITED",
"REGENT LIGHTING ASIA PRIVATE LIMITED",
"REGENT LOGICARE PRIVATE LIMITED",
"REGENT MINERALS & CLAY PRIVATE LIMITED",
"REGENT PARK BROADBAND & ALLIED SERVICES PRIVATE LIMITED",
"REGENT PLAST PRIVATE LIMITED",
"REGENT RESEARCH WRITING PRIVATE LIMITED",
"REGENT RESORTS & PROPERTIES PRIVATE LIMITED",
"REGENT RICH CAPACITORS PRIVATE LIMITED",
"REGENT STANDARD PRIVATE LIMITED",
"REGENT STRIPS PRIVATE LIMITED",
"REGENT SYSTMENGG PRIVATE LIMITED",
"REGENT TEXTILE PRIVATE LIMITED",
"REGENT THEATRE PRIVATE LIMITED",
"REGENT TOURS & TRAVELS PRIVATE LIMITED",
"REGENTA CREATION",
"REGENTA ORKOS KOLKATA",
"REGENTA PLACE BANGALORE",
"REGENTI MEDIA PRIVATE LIMITED",
"REGENVO MOBILE PRIVATE LIMITED",
"REGGIANA RIDUTTORI INDIA PRIVATE LIMITED",
"REGI INDIA COSMETICS PRIVATE LIMITED",
"REGIME TAX SOLUTIONS PRIVATE LIMITED",
"REGIMENTAL CHILDREN SCHOOL",
"REGIN IMPORTS AND EXPORTS PRIVATE LIMITED",
"REGINE EXPORT PRIVATE LIMITED",
"REGIONAL AYURVEDA RESEARCH INSTITUTE AHMEDABAD",
"REGIONAL AYURVEDIC EVAM UNANI OFFICE",
"REGIONAL AYURVEDIC EVAM UNANI OFFICER UNNAO",
"REGIONAL CENTRE FOR BIOTECHNOLOGY",
"REGIONAL CENTRE FOR MILITARY AIRWORTHINESS",
"REGIONAL CONSTRUCTION PRIVATE LIMITED",
"REGIONAL DY COMMISSIONER OF FISHERIES",
"REGIONAL ENGINEERING COLLEGE",
"REGIONAL FOOD CONTROLLER",
"REGIONAL FORENSIC SCIENCE LABORATORS",
"REGIONAL FORENSIC SCIENCE LABORATORY NASHIK",
"REGIONAL INSTITUTE OF EDUCATION",
"REGIONAL INSTITUTE OF OPHTHALMOLOGY AND GOVERNMENT OPHTHALMIC HOSPITAL",
"REGIONAL JOINT COMMISSIONER OF ANIMAL HUSBANDRY MUMBAI",
"REGIONAL LABOUR COMMISSIONER",
"REGIONAL LABOUR INSTITUTE",
"REGIONAL LAND SQUARE DEVELOPERS PRIVATE LIMITED",
"REGIONAL LEPROSY TRAINING AND RESEARCH INSTITUTE",
"REGIONAL LOGISTICS PRIVATE LIMITED",
"REGIONAL MANAGER M.P. FISH FEDERATION CO LIMITED",
"REGIONAL MEDICAL RESERCH CENTRE",
"REGIONAL MENTAL HOSPITAL YERAWADA PUNE",
"REGIONAL METEOROLOGICAL CENTRE",
"REGIONAL PAY AND ACCOUNTS OFFICE MINISTRY OF TEXTILES MUMBAI",
"REGIONAL REFERRAL SERVICES HOSPITAL AMRAVATI",
"REGIONAL RESEARCH INSTITUTE OF UNANI MEDICINE",
"REGIONAL SOCIETY FOR EDUCATION WELFARE & RESEARCH",
"REGIONAL TOURIST OFFICE CUM TOURIST BUREAU",
"REGIONAL TRANSPORT OFFICE",
"REGIONAL WORKSKOP HEALTH TRANSPORT",
"REGIS AND SAVOY PRIVATE LIMITED",
"REGIS INDUSTRIES LIMITED",
"REGISTER FOR EXERCISE PROFESSIONALS INDIA FOUNDATION",
"REGISTHAN PRIVATE LIMITED",
"REGISTRAR GENERAL HIGH COURT OF MADHYA PRADESH JABALPUR",
"REGISTRAR INDUSTRIAL COURT M P INDORE",
"REGISTRAR,CIVIL COURTS,BARGARH",
"REGISTRARCLASSIFICATIONRAJ HIGH COURTJODHPUR",
"REGIUS TAX CONSULTANCY PRIVATE LIMITED",
"REGMA CERAMICS PRIVATE LIMITED",
"REGNANT EXIM PRIVATE LIMITED",
"REGNANT FINANCIAL PROCESS & TAX ADVISORS PRIVATE LIMITED",
"REGNANT PHARMACEUTICALS PRIVATE LIMITED",
"REGNUM CONTECH PRIVATE LIMITED",
"REGOLA BIO - CHEMICAL PRIVATE LIMITED",
"REGREEN EXCEL EPC INDIA LIMITED",
"REGROW BIOSCIENCES PRIVATE LIMITED",
"REGROW INDUSTRIES INDIA PRIVATE LIMITED",
"REGSUS CONSULTING PRIVATE LIMITED",
"REGULAR RETAIL PRIVATE LIMITED",
"REGULUS INFRASTRUCTURE MANAGEMENT CONSULTANCY PRIVATE LIMITED",
"REGULUS MARKETING PVT LTD",
"REGUS BUSINESS CENTRE (BANGALORE) PRIVATE LIMITED",
"REGUS BUSINESS CENTRE (DELHI) PRIVATE LIMITED",
"REGUS BUSINESS CENTRE (MUMBAI) PRIVATE LIMITED",
"REGUS BUSINESS CENTRE (NAGPUR) PRIVATE LIMITED",
"REGUS BUSINESS CENTRE HYDERABAD PRIVATE LIMITED",
"REGUS BUSINESS CENTRE INDORE PRIVATE LIMITED",
"REGUS BUSINESS CENTRE MANAGEMENT PRIVATE LIMITED",
"REGUS BUSINESS CENTRE PLAZA PRIVATE LIMITED",
"REGUS BUSINESS CENTRE PRIVATE LIMITED",
"REGUS BUSINESS CENTRE PUNE PRIVATE LIMITED",
"REGUS BUSINESS POINT PRIVATE LIMITED",
"REGUS CENTRAL POINT BUSINESS CENTRE PRIVATE LIMITED",
"REGUS CENTRE MIDTOWN (HYDERABAD) PRIVATE LIMITED",
"REGUS CENTRE PRIVATE LIMITED",
"REGUS CENTRE SAKET PRIVATE LIMITED",
"REGUS CENTRE SERVICES (BANGALORE) PRIVATE LIMITED",
"REGUS CITYGOLD BUSINESS CENTRE PRIVATE LIMITED",
"REGUS CLASSIC CENTRES PRIVATE LIMITED",
"REGUS ENIGMATIC SPACES PRIVATE LIMITED",
"REGUS EVERSUN BUSINESS CENTRE PRIVATE LIMITED",
"REGUS GRANDEUR OFFICES PRIVATE LIMITED",
"REGUS IMPERIAL BUSINESS PARK PRIVATE LIMITED",
"REGUS INFINITY BUSINESS HUBS PRIVATE LIMITED",
"REGUS INTERNATIONAL LLP",
"REGUS ITECH BUSINESS CENTRE PRIVATE LIMITED",
"REGUS MAGNUM BUSINESS CENTRES PRIVATE LIMITED",
"REGUS MID-TOWN BUSINESS CENTRE PRIVATE LIMITED",
"REGUS MUMBAI METROPOLITAN BUSINESS CENTRE PRIVATE LIMITED",
"REGUS OFFICE CENTRE SERVICES (CHENNAI) PRIVATE LIMITED",
"REGUS OFFICE CENTRE SERVICES PRIVATE LIMITED",
"REGUS OFFICE LINKS PRIVATE LIMITED",
"REGUS PRIDE BUSINESS CENTRES PRIVATE LIMITED",
"REGUS PUNE METROPOLITAN BUSINESS CENTRE PRIVATE LIMITED",
"REGUS PUNE OFFICE CENTRES SERVICES PRIVATE LIMITED",
"REGUS RADIANT CENTRES PRIVATE LIMITED",
"REGUS SOLITAIRE BUSINESS CENTRE PRIVATE LIMITED",
"REGUS SUBURB CENTRES PRIVATE LIMITED",
"REHAB CONSULTANTS PRIVATE LIMITED",
"REHAB HOUSING PRIVATE LIMITED",
"REHABILITATION COUNCIL OF INDIA",
"REHABILITION COUNCIL OF INDIA",
"REHAISH DEVELOPERS PRIVATE LIMITED",
"REHAN CERAMICS PRIVATE LIMITED",
"REHANAM CONSTRUCTION PRIVATE LIMITED",
"REHASH INDUSTRIAL AND RESINS CHEMICALS PRIVATE LIMITED",
"REHAU POLYMERS PRIVATE LIMITED",
"REHBAR EQUIPMENT RENTAL PRIVATE LIMITED",
"REHLA - GARHWA HIGHWAYS PRIVATE LIMITED",
"REHLAT ONLINE SERVICES PRIVATE LIMITED",
"REHMAT AUTO PRIVATE LIMITED",
"REHOBOTH ENVIRO SYSTEMS PRIVATE LIMITED",
"REHOBOTH NATURE FINE FOODS PRIVATE LIMITED",
"REHVAR INFRASTRUCTURE PRIVATE LIMITED",
"REI INTERMEDIATE COLLEGE, DAYALBAGH, AGRA",
"REI SYSTEMS INDIA PRIVATE LIMITED",
"REIANSHI HOME LUXE ENTERPRISE PRIVATE LIMITED",
"REICH INDIA PRIVATE LIMITED",
"REICHHOLD INDIA PRIVATE LIMITED",
"REICHINDIA PHARMA LIMITED",
"REIDEL (INDIA) CHEMICALS PRIVATE LIMITED",
"REIDIUS ENGITECH PRIVATE LIMITED",
"REIFENHAUSER INDIA MARKETING LIMITED",
"REIFENHAUSER INDIA MARKETING PRIVATE LIMITED",
"REIGATE BUILDERS PRIVATE LIMITED",
"REIGN ENGINEERS PRIVATE LIMITED",
"REIGN FOODS BEVERAGES PRIVATE LIMITED",
"REIGN O SPACE OFFICE SYSTEMS PRIVATE LIMITED",
"REIGNITECH INDIA ENERGY PRIVATE LIMITED",
"REIJIRO NETWORKS PRIVATE LIMITED",
"REIL ELECTRICALS INDIA LIMITED",
"REIMAGINING HIGHER EDUCATION FOUNDATION",
"REIMAGINING INDIA EDUINNOVATIONS PRIVATE LIMITED",
"REIN GAMES PRIVATE LIMITED",
"REIN LABS LLP",
"REINDHAN ENERGY PRIVATE LIMITED",
"REINFORCED EARTH INDIA PRIVATE LIMITED",
"REINHART INDIA PRIVATE LIMITED",
"REINIGEN LUFT TECHNOLOGY INDIA PRIVATE LIMITED",
"REINMEKA GLOBAL PRIVATE LIMITED",
"REINO INFRA-DEVELOPERS PRIVATE LIMITED",
"REINO TECHNOLOGIES PRIVATE LIMITED",
"REINSURANCE GROUP OF AMERICA INCORPORATED",
"REINVENT MEDICAL PRIVATE LIMITED",
"REINVISION LABS PRIVATE LIMITED",
"REIRA CONSTRUCTIONS PRIVATE LIMITED",
"REIRA PETRO SERVICES PRIVATE LIMITED",
"REIS STAFFING AND HR SERVICES PRIVATE LIMITED",
"REISEN TOURS INDIA PRIVATE LIMITED",
"REITINDIA CONSULTANTS PRIVATE LIMITED",
"REITSPORT INTERNATIONAL PRIVATE LIMITED",
"REITZ INDIA LIMITED",
"REITZEL INDIA PRIVATE LIMITED",
"REIWANCE ENGINEERING PRIVATE LIMITED",
"REIZ ELECTROCONTROLS PRIVATE LIMITED",
"REIZEND PRIVATE LIMITED",
"REJA TARAPADA SOLVENT EXTRACTION CO. PVT LTD",
"REJOICE EXPORTS PRIVATE LIMITED",
"REJOLUT TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"REJUVENATE HOLIDAYS & TOURS PRIVATE LIMITED",
"REJUVENATE SOLUTIONS PRIVATE LIMITED",
"REKAN INDUSTRIES LIMITED",
"REKART INNOVATIONS PRIVATE LIMITED",
"REKHA AGRIPLAS LIMITED",
"REKHA BRIGHT STEELS PRIVATE LIMITED",
"REKHA CORPORATION PRIVATE LIMITED",
"REKHA CROP PROTECTION PRIVATE LIMITED",
"REKHA LOGISTICS PRIVATE LIMITED",
"REKHA SILK MILLS PVT LTD",
"REKHA TECHNOLOGIES PRIVATE LIMITED",
"REKHAS HOUSE OF COTTON PRIVATE LIMITED",
"REKHI HAULAGE PRIVATE LIMITED",
"REKHI HOLDINGS PRIVATE LIMITED",
"REKHI PRODUCTS PRIVATE LIMITED",
"REKHI ROADWAYS PRIVATE LIMITED",
"REKHUM BUSINESS SOLUTIONS PRIVATE LIMITED",
"REKIN PHARMA PRIVATE LIMITED",
"REKNOWN MANAGEMENT SERVICES PRIVATE LIMITED",
"REKOFA SMALL TOOLS PVT LTD",
"REKRUT INDIA PRIVATE LIMITED",
"REKVINA PHARMACEUTICAL",
"REL CLEANTECH PRIVATE LIMITED",
"REL CONSTRO TECH LLP",
"REL VISION",
"RELA HOSPITALS PRIVATE LIMITED",
"RELA MARKETING PRIVATE LIMITED",
"RELA MULTISPECIALITY HOSPITAL",
"RELACS INVESTMENT AND FINANCIAL SERVICES PRIVATE LIMITED",
"RELAN INFRACON PRIVATE LIMITED",
"RELAN MOTORS PRIVATE LIMITED",
"RELANTO GLOBAL PRIVATE LIMITED",
"RELATE INFOTECH PRIVATE LIMITED",
"RELATIENT INDIA PRIVATE LIMITED",
"RELATIONSHIP SCIENCE INDIA P LIMITED",
"RELATIVE SPACE PRIVATE LIMITED",
"RELATIVITY MANAGEMENT SOLUTIONS INDIA PRIVATE LIMITED",
"RELAX BIOTECH PRIVATE LIMITED",
"RELAX COMMERCIAL PVT LTD",
"RELAX KNITTING PRIVATE LIMITED",
"RELAX PHARMACEUTICALS PRIVATE LIMITED",
"RELAXD IMPORT EXPORT PRIVATE LIMITED",
"RELAXO FOOTWEARS LIMITED",
"RELAXO HOME APPLIANCES PRIVATE LIMITED",
"RELAY EXPRESS PRIVATE LIMITED",
"RELAY SHIPPING AGENCY LIMITED",
"RELAY STRATEGY PRIVATE LIMITED",
"RELAY2 INDIA PRIVATE LIMITED",
"RELAYHUMANCLOUD INDIA PRIVATE LIMITED",
"RELAYKART PRIVATE LIMITED",
"RELCO ELECTRICALS (INDIA) PRIVATE LIMITED",
"RELCOM ENGINEERING PRIVATE LIMITED",
"RELCOM TECHNOLOGY PRIVATE LIMITED",
"RELCON INDIA BUILDERS PRIVATE LIMITED",
"RELCON INFRA PROJECT LIMITED",
"RELCUBE INDIA PRIVATE LIMITED",
"RELEAK AGRIVENTURES LIMITED",
"RELEASEIQ.IO INDIA PRIVATE LIMITED",
"RELEASEMYAD MEDIA PRIVATE LIMITED",
"RELECURA TECHNOLOGIES PRIVATE LIMITED",
"RELEGARE AGRO LIFE BIO SCIENCE PRIVATE LIMITED",
"RELEGARE AGROCHEM INDUSTRIES PRIVATE LIMITED",
"RELEMAC TECHNOLOGIES PRIVATE LIMITED",
"RELENTLESS SPORTS RETAIL PRIVATE LIMITED",
"RELEVANCE LAB PRIVATE LIMITED",
"RELEVANT COURIERS PRIVATE LIMITED",
"RELEVANTZ TECHNOLOGY SERVICES INDIA PRIVATE LIMITED",
"RELEX HEALTHCARE SERVICES INDIA PRIVATE LIMITED",
"RELFOR LABS PRIVATE LIMITED",
"RELGO NETWORKS PRIVATE LIMITED",
"RELIABILITY HEALTHCARE PRIVATE LIMITED",
"RELIABLE ACCESSORIES PRIVATE LIMITED",
"RELIABLE AGENCIES",
"RELIABLE ANALYTICAL LABORATORIES PRIVATE LIMITED",
"RELIABLE AND PERFECT LOGISTICS PRIVATE LIMITED",
"RELIABLE ART PRINTERY AHMEDABAD PRIVATE LIMITED",
"RELIABLE AUTOMATION PRIVATE LIMITED",
"RELIABLE AUTOMOBILES PRIVATE LIMITED",
"RELIABLE AUTOMOTIVE PRIVATE LIMITED",
"RELIABLE AUTOTECH PRIVATE LIMITED",
"RELIABLE BARRELS PRIVATE LIMITED",
"RELIABLE BUSINESS SOLUTIONS AND SERVICES PRIVATE LIMITED",
"RELIABLE CABS SERVICES PRIVATE LIMITED",
"RELIABLE CARRIERS PRIVATE LIMITED",
"RELIABLE CASHEW COMPANY PRIVATE LIMITED",
"RELIABLE CHEMICALS",
"RELIABLE CLOTHING PRIVATE LIMITED",
"RELIABLE COMNET PRIVATE LIMITED.",
"RELIABLE CONSULTANCY",
"RELIABLE CONTROL SYSTEMS PRIVATE LIMITED",
"RELIABLE DATA SERVICES LIMITED",
"RELIABLE DIAGNOSTIC CENTRE PRIVATE LIMITED",
"RELIABLE DIESEL ENGINEERS PRIVATE LIMITED",
"RELIABLE DYE-CHEM PRIVATE LIMITED",
"RELIABLE E SOLUTIONS PRIVATE LIMITED",
"RELIABLE ENGINEERING PRODUCTS INDIA PRIVATE LIMITED",
"RELIABLE ESTIMATING SERVICES LLP",
"RELIABLE EXPORTS INDIA PRIVATE LIMITED",
"RELIABLE FASHIONS INDIA PRIVATE LIMITED",
"RELIABLE FASTENERS PVT LTD",
"RELIABLE FINHOLD LIMITED",
"RELIABLE FIRST ADCON PRIVATE LIMITED",
"RELIABLE FLORA PRIVATE LIMITED",
"RELIABLE FOREX PRIVATE LIMITED",
"RELIABLE GLOBAL EXIM PRIVATE LIMITED",
"RELIABLE GRAVURES PRIVATE LIMITED",
"RELIABLE GREEN POWER SOLUTION PRIVATE LIMITED",
"RELIABLE HEALTH CARE PRIVATE LIMITED",
"RELIABLE HEAVY ENGINEERING NASIK PRIVATE LIMITED",
"RELIABLE HITECH INFRASTRUCTURE PRIVATE LIMITED",
"RELIABLE HITECH PVT LTD",
"RELIABLE HOME APPLIANCES PRIVATE LIMITED",
"RELIABLE HUB'S ENGINEERING INDIA PRIVATE LIMITED",
"RELIABLE INFORMATIONS PRIVATE LIMITED",
"RELIABLE INFRA SERVICES PRIVATE LIMITED",
"RELIABLE LASER WORKS PRIVATE LIMITED",
"RELIABLE LIFTS INDIA PRIVATE LIMITED",
"RELIABLE LOGISTICS SOLUTIONS PRIVATE LIMITED",
"RELIABLE MARINE AND LOGISTIC SERVICES PRIVATE LIMITED",
"RELIABLE MECHATRONICS PRIVATE LIMITED",
"RELIABLE MOVERS & LOGISTICS PRIVATE LIMITED",
"RELIABLE PAPER AND BOARD MILLS PVT LTD",
"RELIABLE PIPES AND TUBES LIMITED",
"RELIABLE PLANNERS PRIVATE LIMITED",
"RELIABLE PLYWOOD INDUSTRIES (I) PRIVATE LIMITED",
"RELIABLE POLY COMPOUNDS PVT LTD",
"RELIABLE POLYPACK INDIA PRIVATE LIMITED",
"RELIABLE PRECITECH ENGINEERS PRIVATE LIMITED",
"RELIABLE PROJECTS & FACILITIES MANAGEMENT PRIVATE LIMITED",
"RELIABLE RAYON PRIVATE LIMITED",
"RELIABLE REALTECH PRIVATE LIMITED",
"RELIABLE REFRACTORIES PVT LTD",
"RELIABLE ROAD WINGS PRIVATE LIMITED",
"RELIABLE ROADWINGS (LOGISTICS) PRIVATE LIMITED",
"RELIABLE RYDES PRIVATE LIMITED",
"RELIABLE SECURITIES PRIVATE LIMITED",
"RELIABLE SHIPTRANS PRIVATE LIMITED",
"RELIABLE SHOES PRIVATE LTD",
"RELIABLE SOFT TECHNOLOGIES PRIVATE LIMITED",
"RELIABLE SOFTWARE SYSTEMS PRIVATE LIMITED",
"RELIABLE SPACES PRIVATE LIMITED",
"RELIABLE SPONGE PRIVATE LIMITED",
"RELIABLE TEAM CONSULTANTS PRIVATE LIMITED",
"RELIABLE TECHNOSYSTEMS INDIA PRIVATE LIMITED",
"RELIABLE TRANS AND IMPEX SERVICES PRIVATE LIMITED",
"RELIABLE TRAVELS",
"RELIABLE TRAVELS AND CARGO PRIVATE LIMITED",
"RELIABLE UDYOG PRIVATE LIMITED",
"RELIABLE VACATION PRIVATE LIMITED",
"RELIABLE VENTURES INDIA LIMITED",
"RELIABLE VYAPAR PRIVATE LIMITED",
"RELIABLE WIRES & ENGINEERS PRIVATE LIMITED",
"RELIABLESOFT TECHNOLOGIES PRIVATE LIMITED",
"RELIABULL FINANCIAL SERVICES PRIVATE LIMITED",
"RELIANCE 4IR REALTY DEVELOPMENT LIMITED",
"RELIANCE AEROSTRUCTURE LIMITED",
"RELIANCE AIMS",
"RELIANCE ALPHA SERVICES PRIVATE LIMITED",
"RELIANCE AMBIT TRADE PRIVATE LIMITED",
"RELIANCE ARTWARES PRIVATE LIMITED",
"RELIANCE ASSET RECONSTRUCTION COMPANY LIMITED.",
"RELIANCE BALLY INDIA PRIVATE LIMITED",
"RELIANCE BIG BROADCASTING PRIVATE LIMITED",
"RELIANCE BIOTECH PRIVATE LIMITED",
"RELIANCE BP MOBILITY LIMITED",
"RELIANCE BRANDS EYEWEAR PRIVATE LIMITED",
"RELIANCE BRANDS LIMITED",
"RELIANCE BRANDS LUXURY FASHION PRIVATE LIMITED",
"RELIANCE CAPITAL PENSION FUND LIMITED",
"RELIANCE CHEMOTEX INDUSTRIES LTD",
"RELIANCE CLOTHING INDIA LIMITED",
"RELIANCE COAL RESOURCES PRIVATE. LIMITED",
"RELIANCE COMM DEALERS LIMITED",
"RELIANCE COMMODITIES LIMITED",
"RELIANCE COMMUNICATIONS INFRASTRUCTURE LIMITED",
"RELIANCE CONSUMER FINANCE PRIVATE LIMITED",
"RELIANCE CORP IT PARK LIMITED",
"RELIANCE CORPORATE IT PARK LIMITED",
"RELIANCE DIAMOND TOOLS",
"RELIANCE DIGITAL WORLD LIMITED",
"RELIANCE ELECTRICAL & METALS PVT LTD",
"RELIANCE ETHANE PIPELINE LIMITED",
"RELIANCE FABRICATIONS PRIVATE LIMITED",
"RELIANCE FINANCIAL ADVISORY SERVICES PRIVATE LIMITED",
"RELIANCE FINANCIAL LIMITED",
"RELIANCE FIRE BRIGADE SERVICES PRIVATE LIMITED",
"RELIANCE FOOD AND PROTEINS PRIVATE LIMITED",
"RELIANCE FOOTWEARS PRIVATE LIMITED",
"RELIANCE FORMULATION PVT LTD",
"RELIANCE FOUNDATION",
"RELIANCE FOUNDATION INSTITUTION OF EDUCATION AND RESEARCH",
"RELIANCE FOUNDATION SCHOOL",
"RELIANCE FOUNDATION YOUTH SPORTS",
"RELIANCE FRESH PRIVATE LIMITED",
"RELIANCE GAS LIFESTYLE INDIA PRIVATE LIMITED",
"RELIANCE GAS PIPELINES LIMITED",
"RELIANCE GAS TRANSPORTATION INFRASTRUCTURE LIMITED",
"RELIANCE GENERAL INSURANCE COMPANY LIMITED",
"RELIANCE GLOBALCOM MANAGEMENT PRIVATE LIMITED",
"RELIANCE GRANDOPTICAL PRIVATE LIMITED",
"RELIANCE GROUP SUPPORT SERVICE PRIVATE LIMITED",
"RELIANCE HEALTH CARE PVT LTD",
"RELIANCE HEALTH SOLUTIONS PRIVATE LIMITED",
"RELIANCE HOME FINANCE LIMITED",
"RELIANCE HOSPITAL MANAGEMENT SERVICES PRIVATE LIMITED",
"RELIANCE HR SERVICES PRIVATE LIMITED",
"RELIANCE IDC LIMITED",
"RELIANCE IND INFRAS LIMITED",
"RELIANCE INDUSTRIAL CONSORTIUM LIMITED",
"RELIANCE INDUSTRIAL INFRASTRUCTURE LIMITED",
"RELIANCE INDUSTRIAL INVESTMENTS AND HOLDINGS LIMITED",
"RELIANCE INDUSTRIES HOLDING PRIVATE LIMITED",
"RELIANCE INDUSTRIES LIMITED",
"RELIANCE INFOCOMM INFRASTRUCTURE PRIVATE LIMITED",
"RELIANCE INFRASTRUCTURE LIMITED",
"RELIANCE INFRASTRUCTURE MANAGEMENT",
"RELIANCE INNOVENTURES PRIVATE. LIMITED.",
"RELIANCE INSTRUMENTATION PRIVATE LIMITED",
"RELIANCE INT SER PRIVATE LIMITED",
"RELIANCE INTEGRATED SERVICES PRIVATE LIMITED",
"RELIANCE JEWELS",
"RELIANCE JIO INFOCOMM LIMITED",
"RELIANCE JIO INFRATEL PRIVATE LIMITED",
"RELIANCE JUTE MILLS INTERNATIONAL LIMITED",
"RELIANCE LIFE SCIENCES PRIVATE LIMITED",
"RELIANCE LIFESTYLE HOLDINGS LIMITED",
"RELIANCE LIFESTYLE PRODUCTS PRIVATE LIMITED",
"RELIANCE LUXE BEAUTY LIMITED",
"RELIANCE MAPPEDU MULTI MODAL LOGISTICS PARK LIMITED",
"RELIANCE MARTS PRIVATE LIMITED",
"RELIANCE MEDIA",
"RELIANCE MEDIAWORKS FINANCIAL SERVICES PRIVATE LIMITED",
"RELIANCE MONEY SOLUTIONS PRIVATE LIMITED",
"RELIANCE NATURAL RESOURCE LIMITED",
"RELIANCE NEW ENERGY LIMITED",
"RELIANCE NEW SOLAR ENERGY LIMITED",
"RELIANCE NIPPON LIFE INSURANCE COMPANY LIMITED",
"RELIANCE PAUL & SHARK FASHIONS PRIVATE LIMITED",
"RELIANCE PAYMENT SOLUTION LIMITED",
"RELIANCE PETRO MARKETING",
"RELIANCE POLYESTER LIMITED",
"RELIANCE PORTS AND TERMINALS LIMITED",
"RELIANCE PRIMA LIMITED",
"RELIANCE PROGRESSIVE TRADERS PRIVATE LIMITED",
"RELIANCE PROJECT VENTURES AND MANAGEMENT PRIVATE LIMITED",
"RELIANCE PROJECTS & PROPERTY MANAGEMENT SERVICES LIMITED",
"RELIANCE PROLIFIC COMMERCIAL PRIVATE LIMITED",
"RELIANCE PROLIFIC TRADERS PRIVATE LIMITED",
"RELIANCE RASAYAN PRIVATE LIMITED",
"RELIANCE RETAIL AND FASHION LIFESTYLE LIMITED",
"RELIANCE RETAIL LIMITED",
"RELIANCE RETAIL VENTURES LIMITED",
"RELIANCE RITU KUMAR PRIVATE LIMITED",
"RELIANCE SECURITIES LIMITED",
"RELIANCE SERVICES AND HOLDINGS LIMITED",
"RELIANCE SIBUR ELASTOMERS PRIVATE LIMITED",
"RELIANCE SMSL LIMITED",
"RELIANCE STEEL & ALUMINUM CO.",
"RELIANCE STEEL TUBES PRIVATE LIMITED",
"RELIANCE STRATEGIC BUSINESS VENTURES LIMITED",
"RELIANCE STRUCTURES PRIVATE LIMITED",
"RELIANCE SYNGAS LIMITED",
"RELIANCE SYNTEX PRIVATE LIMITED",
"RELIANCE TRANSPORT & TRAVELS PRIVATE LIMITED",
"RELIANCE UNIVERSAL TRADERS PRIVATE LIMITED",
"RELIANCE VALUE SERVICES PRIVATE LIMITED",
"RELIANCE VANTAGE RETAIL LIMITED",
"RELIANCE VENTURES LIMITED",
"RELIANCE VISION EXPRESS PRIVATE LIMITED",
"RELIANCE WEALTH MGMT LIMITED",
"RELIANCE WEBSTORE LIMITED",
"RELIANT CREDITS (INDIA) LIMITED",
"RELIANT DRILLING PRIVATE LIMITED",
"RELIANT ELECTRONIC DESIGN SERVICES PRIVATE LIMITED",
"RELIANT INFRASTRUCTURE PRIVATE LIMITED",
"RELIANT MACHINES PRIVATE LIMITED",
"RELIANT PACKAGING FILMS PRIVATE LIMITED",
"RELIANT TRADELINKS PRIVATE LIMITED",
"RELIANTVISION TECHNOLOGIES INDIA PRIVATE LIMITED",
"RELIASON TECHNOLOGIES PRIVATE LIMITED",
"RELIASYS TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"RELIC BIOTECHNOLOGY PRIVATE LIMITED",
"RELIC IT SOLUTIONS PRIVATE LIMITED",
"RELIC PROPERTY DEVELOPMENT PRIVATE LIMITED",
"RELIC TECHNOLOGIES LIMITED",
"RELICAB CABLE MANUFACTURING PRIVATE LIMITED",
"RELICARE TECH SERVICES PRIVATE LIMITED",
"RELICOMP ELEVATORS PRIVATE LIMITED",
"RELICORP LOGISTICS LLP",
"RELIEF BIOTECH PRIVATE LIMITED",
"RELIEF HOSPITALS",
"RELIEF LOGISTICS PRIVATE LIMITED",
"RELIEF PUMPS PRIVATE LIMITED",
"RELIEF STEEL AND CEMENT PRIVATE LIMITED",
"RELIEFLINE GLOBAL PRIVATE LIMITED",
"RELIFE PHARMACEUTICALS OPC PRIVATE LIMITED",
"RELIFIN TECHNOLOGIES INDIA PRIVATE LIMITED",
"RELIG GLOBAL PRIVATE LIMITED",
"RELIGARE BROKING LIMITED",
"RELIGARE COMMODITIES LIMITED",
"RELIGARE ENTERPRISES LIMITED REL",
"RELIGARE HOUSING DEVELOPMENT FINANCE CORPORATION LIMITED",
"RELIGARE INVESCO MUTUAL FUND",
"RELIGARE SECURITIES LIMITED",
"RELIGATE TECHNOLOGIES PRIVATE LIMITED",
"RELIGENT SYSTEMS PRIVATE LIMITED",
"RELINFINITE PROJEXIVE PRIVATE LIMITED",
"RELINQUO AUTOMATION PRIVATE LIMITED",
"RELIOBRIX CONSULTING PRIVATE LIMITED",
"RELIO-QUICK INDIA PRIVATE LIMITED",
"RELISEC CONSULTANCY SERVICES PRIVATE LIMITED",
"RELISH AGROFOOD INDIA PRIVATE LIMITED",
"RELISH BAKERS PRIVATE LIMITED",
"RELISH ENTERPRISES PRIVATE LIMITED",
"RELISYS MEDICAL DEVICES LIMITED",
"RELISYS TECHNOLOGIES PRIVATE.LIMITED",
"RELITECH INDUSTRIES PRIVATE LIMITED",
"RELITRADE INSURANCE BROKING PRIVATE LIMITED",
"RELITRADE STOCK BROKING PRIVATE LIMITED",
"RELIV HEALTHY INDIA PRIVATE LIMITED",
"RELIVE SOLUTIONS PRIVATE LIMITED",
"RELIXIR PHARMACEUTICALS PRIVATE LIMITED",
"RELLEK METAL SERVICE CENTRE PRIVATE LIMITED",
"RELLENO INSURANCE BROKING SERVICES PRIVATE LIMITED.",
"RELNET OPERATIONS PRIVATE LIMITED",
"RELOGISTICS INDIA PRIVATE LIMITED",
"RELOGIX DISTRIBUTION PRIVATE LIMITED",
"RELOPS SERVICES PRIVATE LIMITED",
"RELOTO MECHATRONICS PRIVATE LIMITED",
"RELOX DIAGNOSTICS PRIVATE LIMITED",
"RELOY SHIELD PRIVATE LIMITED",
"RELPOL PLASTICS PRODUCTS PRIVATE LIMITED",
"RELPRO HOUSING PRIVATE LIMITED",
"RELSAFE PRA CONSULTING PRIVATE LIMITED",
"RELSON FOREX PRIVATE LIMITED",
"RELTEC CALIBRATION PRIVATE LIMITED",
"RELTIO INDIA PRIVATE LIMITED",
"RELWARD PHARMA PRIVATE LIMITED",
"RELX INDIA PRIVATE LIMITED",
"RELY FINSERV PRIVATE LIMITED",
"RELY PAINTS PRIVATE LIMITED",
"RELYON FACILITY SERVICES PRIVATE LIMITED",
"RELYON RESOURCES PRIVATE LIMITED",
"RELYON SOFTECH LIMITED",
"RELYON SOLAR PRIVATE LIMITED",
"RELYSYS TECHNOLOGIES INDIA PRIVATE LIMITED",
"REM ELECTROMACH PRIVATE LIMITED",
"REM42 TECHNOLOGIES PRIVATE LIMITED",
"REMA ENTERPRISES PRIVATE LIMITED",
"REMAC TOWERS PRIVATE LIMITED",
"REMAG ELECTROS PRIVATE LIMITED",
"REMAN LIFECARE PRIVATE LIMITED",
"REMARK ELECTRIC VEHICLES PRIVATE LIMITED",
"REMARK ELECTROCON PRIVATE LIMITED",
"REMARKABLE PRODUCTIONS PRIVATE LIMITED",
"REMAUT3D ENGINEERING AND SOFTWARE SERVICES PRIVATE LIMITED",
"REMBAL AGRO AND FOODS PRIVATE LIMITED",
"REMBRANDT LEATHERWORKS PRIVATE LIMITED",
"REMC LIMITED",
"REMCO PAPER AND BOARD INDUSTRIES PRIVATE LIMITED",
"REMCO SILK MILLS PRIVATE LIMITED",
"REMEDEX PHARMA PRIVATE LIMITED",
"REMEDIES AGRI SCIENCE PRIVATE LIMITED",
"REMEDIUM ENTERPRISES PRIVATE LIMITED",
"REMEDIUM LIFECARE LIMITED",
"REMEDIUM PLACEMENTS PRIVATE LIMITED",
"REMEDO CLINITECH PRIVATE LIMITED",
"REMEDY HEALTH PRODUCTS PRIVATE LIMITED",
"REMEDY HOSPITAL",
"REMEDY MEDICAL SERVICES PRIVATE. LIMITED.",
"REMEDY PUBLICATIONS PRIVATE LIMITED",
"REMEDY SUPER SPECIALITIES HOSPITALS",
"REMEI INDIA LIMITED",
"REMEMBER INDIA MEDICOS PRIVATE LIMITED",
"REMEMBER SUPPLY CHAIN INDIA PRIVATE LIMITED",
"REMET TECHNOCAST MATERIALS INDIA PRIVATE LIMITED",
"REMEX EXIM INTERNATIONAL PRIVATE LIMITED",
"REMEX INVESTMENT PVT.LTD.",
"REMFRY AND SAGAR CONSULTANTS PRIVATE.LIMITED",
"REMI CHEM (INDIA) PVT LTD",
"REMI EDELSTAHL TUBULARS LIMITED",
"REMI ELEKTROTECHNIK LIMITED",
"REMI PROCESS PLANT AND MACHINERY LIMITED",
"REMI SALES AND ENGINEERING LIMITED",
"REMICA INDUSTRIES PRIVATE LIMITED",
"REMIDEX PHARMA PRIVATE LIMITED",
"REMIDIO INNOVATIVE SOLUTIONS PRIVATE LIMITED",
"REMIEL SOFTECH SOLUTIONS PRIVATE LIMITED",
"REMIK AGRI SEEDS PRIVATE LIMITED",
"REMIK CHEMICALS PRIVATE LIMITED",
"REMIK TRADING COMPANY PRIVATE LIMITED",
"REMINGTON LIFE SCIENCES LIMITED LIABILITY PARTNERSHIP",
"REMINISCENCE LIFE SPACES PRIVATE LIMITED",
"REMIRA MOTORS PRIVATE LIMITED",
"REMISTAR ELECTRIC PRIVATE LIMITED",
"REMIT INFOSYSTEMS PRIVATE LIMITED",
"REMITOUT SERVICE PRIVATE LIMITED",
"REMKO WIRE INDUSTRIES PRIVATE LIMITED",
"REMMERS INDIA PRIVATE LIMITED",
"REMMY TEXTILES PRIVATE LIMITED",
"REMO D'SOUZA ENTERTAINMENT PRIVATE LIMITED",
"REMO SOFTWARE PRIVATE LIMITED",
"REMO WIND ENERGY PRIVATE LIMITED",
"REMON SOLUTIONS PRIVATE LIMITED",
"REMONDIS AQUA INDIA PRIVATE LIMITED",
"REMOTE INFOSYSTEM PRIVATE LIMITED",
"REMOTE PROGRAMMER PRIVATE LIMITED",
"REMOTE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"REMOTECH VENTURES PRIVATE LIMITED",
"REMPLACER BIOLOGIQUE PRIVATE LIMITED",
"REMSO CONTROL TECHNOLOGIES PRIVATE LIMITED",
"REMSON ELECTRICALS PRIVATE LIMITED",
"REMSON EXCEL APPLIANCES PRIVATE LIMITED",
"REMSON EXCEL HOMES PRIVATE LIMITED",
"REMSON PRIME TECHNOLOGIES PRIVATE LIMITED",
"REMSONS INDUSTRIES LIMITED",
"REMSWEGS MARKETING PRIVATE LIMITED",
"REMUNANCE SERVICES PRIVATE LIMITED",
"REMUNANCE SYSTEMS PRIVATE LIMITED",
"REMUS INDIA PRIVATE LIMITED",
"REMUS PHARMACEUTICALS LIMITED",
"REMY DIAMONDS PRIVATE LIMITED",
"REMY RETAIL PRIVATE LIMITED",
"REN JETTING SYSTEMS LLP",
"REN LIFESTYLE SOLUTIONS PRIVATE LIMITED",
"REN TECHNOLOGIES INDIA LIMITED CN",
"RENA ENTERPRISE LLP",
"RENA EXPORTS PRIVATE LIMITED",
"RENA FILMS PRIVATE LIMITED",
"RENA KUTZ KITCHENWARES PRIVATE LIMITED",
"RENA SAHAKARI SAKHAR KARKHANA LTD",
"RENAAISSANCE POWER PRODUCTS PRIVATE LIMITED",
"RENAATUS PROCON PRIVATE LIMITED",
"RENAATUS PROJECTS PRIVATE LIMITED",
"RENACARE CENTER FOR KIDNEY DISEASE AND RESEARCH PRIVATE LIMITED",
"RENAI MEDICITY",
"RENAI SEEDS PRIVATE LIMITED",
"RENAISSANCE ADVISORY SERVICES PRIVATE LIMITED",
"RENAISSANCE AQUA SPORTS PRIVATE LIMITED",
"RENAISSANCE ASSET MANAGEMENT COMPANY PRIVATE LIMITED",
"RENAISSANCE BUILDHOME PRIVATE LIMITED",
"RENAISSANCE COMMUNICATIONS PRIVATE LIMITED",
"RENAISSANCE CORPORATE SOLUTIONS PRIVATE LIMITED",
"RENAISSANCE CREATIONS PRIVATE LIMITED",
"RENAISSANCE DIGITAL SYSTEMS PRIVATE LIMITED",
"RENAISSANCE FINANCIAL SERVICES PRIVATE LIMITED",
"RENAISSANCE FISCAL SERVICES PRIVATE LIMITED",
"RENAISSANCE GAS PRIVATE LIMITED",
"RENAISSANCE GLOBAL LIMITED",
"RENAISSANCE HOLDINGS & DEVELOPER PRIVATE LIMITED",
"RENAISSANCE HOSPITAL PRIVATE LIMITED",
"RENAISSANCE INFRATECH PRIVATE LIMITED",
"RENAISSANCE INVESTMENT MANAGERS PRIVATE LIMITED",
"RENAISSANCE ITES PRIVATE LIMITED",
"RENAISSANCE JEWELLERY LIMITED",
"RENAISSANCE LAW COLLEGE",
"RENAISSANCE LIFESCIENCES INDIA LLP",
"RENAISSANCE LIFESTYLE PRIVATE LIMITED",
"RENAISSANCE MAINTENANCE PRIVATE LIMITED",
"RENAISSANCE MANAGEMENT CONSULTANTS LIMITED",
"RENAISSANCE METAL CRAFT PRIVATE LIMITED",
"RENAISSANCE REALCON PRIVATE LIMITED",
"RENAISSANCE RECYCLING PRIVATE LIMITED",
"RENAISSANCE SECURITIES LIMITED",
"RENAISSANCE TECHNOLOGIES PRIVATE LIMITED",
"RENAISSANCE UNIVERSITY",
"RENALYSIS CONSULTANTS PRIVATE LIMITED",
"RENAM RETAIL PRIVATE LIMITED",
"RENASCENCE INSOLVENCY RESOLUTION PROFESSIONALS PRIVATE LIMITED",
"RENASCENT CONSULTANTS PRIVATE LIMITED",
"RENATA PRECISION COMPONENTS PRIVATE LIMITED",
"RENATUS WELLNESS PRIVATE LIMITED",
"RENAUD BIO PRIVATE LIMITED",
"RENAULT INDIA PRIVATE LIMITED",
"RENAULT NISSAN AUTOMOTIVE INDIA PRIVATE LIMITED",
"RENAULT NISSAN TECHNOLOGY & BUSINESS CENTRE INDIA PRIVATE LIMITED",
"RENAULT PAPER PRODUCTS PRIVATE LIMITED",
"RENAUXE PHARMA INDIA PRIVATE LIMITED",
"RENCAL CHEMICALS (INDIA) LIMITED",
"RENCO DIAM PRIVATE LIMITED",
"RENCOMM TELE SERVICES LLP",
"RENCORD LIFE SCIENCES PRIVATE LIMITED",
"RENDER 5 TECHNOLOGY PRIVATE LIMITED",
"RENDER WISE SOLUTIONS PRIVATE LIMITED",
"RENDERCON CHEM PRIVATE LIMITED",
"RENDERED IDEAS SOFTGAME PRIVATE LIMITED",
"RENDERSOFT SYSTEMS INDIA PRIVATE LIMITED",
"RENDITION ENGINEERS PRIVATE LIMITED",
"RENDITION SYSTEMS PRIVATE LIMITED",
"RENE IMPEX PRIVATE LIMITED",
"RENE PHARMACEUTICALS PRIVATE LIMITED",
"RENEE COSMETICS PRIVATE LIMITED",
"RENEE ENTERPRISES PRIVATE LIMITED",
"RENEE MEDICAL CENTER PRIVATE LIMITED",
"RENEE SYSTEMS IND PRIVATE LIMITED",
"RENEES HOLIDAYS PRIVATE LIMITED",
"RENEN SOLAR PRIVATE LIMITED",
"RENENTECH LABORATORIES PRIVATE LIMITED",
"RENERGO DEVELOPERS PRIVATE LIMITED",
"RENERGY SOLUTIONS PRIVATE LIMITED",
"RENESA EXPORTS PRIVATE LIMITED",
"RENESAS ELECTRONICS INDIA PRIVATE LIMITED",
"RENESCO INDIA PRIVATE LIMITED",
"RENESOLA INDIA PRIVATE LIMITED",
"RENESYS POWER SYSTEMS PRIVATE LIMITED",
"RENEW AGNI POWER PRIVATE LIMITED",
"RENEW AKSHAY URJA LIMITED",
"RENEW BUY",
"RENEW CLEAN ENERGY PRIVATE LIMITED",
"RENEW ENERGY MARKETS PRIVATE LIMITED",
"RENEW FAZILKA SOLAR POWER PRIVATE LIMITED",
"RENEW JAL URJA PRIVATE LIMITED",
"RENEW KARIMNAGAR POWER PRIVATE LIMITED",
"RENEW MEDAK POWER PRIVATE LIMITED",
"RENEW MEGA SOLAR POWER PRIVATE LIMITED",
"RENEW NARWANA POWER PRIVATE LIMITED",
"RENEW NIZAMABAD POWER PRIVATE LIMITED",
"RENEW PAWAN SHAKTI PRIVATE LIMITED",
"RENEW POWER LIMITED",
"RENEW PRIVATE LIMITED",
"RENEW RANGA REDDY SOLAR POWER PRIVATE LIMITED",
"RENEW RAVI TEJAS PRIVATE LIMITED",
"RENEW SAUR SHAKTI PRIVATE LIMITED",
"RENEW SAUR URJA PRIVATE LIMITED",
"RENEW SERVICES PRIVATE LIMITED",
"RENEW SILICON TEKNOLOGY PRIVATE LIMITED",
"RENEW SOLAR ENERGY (JHARKHAND FIVE) PRIVATE LIMITED",
"RENEW SOLAR ENERGY (JHARKHAND FOUR) PRIVATE LIMITED",
"RENEW SOLAR ENERGY (JHARKHAND ONE) PRIVATE LIMITED",
"RENEW SOLAR ENERGY (JHARKHAND THREE) PRIVATE LIMITED",
"RENEW SOLAR ENERGY (KARNATAKA TWO) PRIVATE LIMITED",
"RENEW SOLAR ENERGY (KARNATAKA) PRIVATE LIMITED",
"RENEW SOLAR ENERGY (RAJASTHAN) PRIVATE LIMITED",
"RENEW SOLAR ENERGY (TELANGANA) PRIVATE LIMITED",
"RENEW SOLAR ENERGY (TN) PRIVATE LIMITED",
"RENEW SOLAR ENERGY PRIVATE LIMITED RSEPL",
"RENEW SOLAR POWER PRIVATE LIMITED",
"RENEW SOLAR SERVICES PRIVATE LIMITED",
"RENEW SOLAR URJA PRIVATE LIMITED",
"RENEW SUN BRIGHT PRIVATE LIMITED",
"RENEW SUN ENERGY PRIVATE LIMITED",
"RENEW SUN RENEWABLES PRIVATE LIMITED",
"RENEW SUN SHAKTI PRIVATE LIMITED",
"RENEW SUN WAVES PRIVATE LIMITED",
"RENEW SUNLIGHT ENERGY PRIVATE LIMITED",
"RENEW SURYA AAYAN PRIVATE LIMITED",
"RENEW SURYA ALOK PRIVATE LIMITED",
"RENEW SURYA JYOTI PRIVATE LIMITED",
"RENEW SURYA KIRAN PRIVATE LIMITED",
"RENEW SURYA OJAS PRIVATE LIMITED",
"RENEW SURYA PRATAP PRIVATE LIMITED",
"RENEW SURYA ROSHNI PRIVATE LIMITED",
"RENEW SURYA UDAY PRIVATE LIMITED",
"RENEW SURYA VIHAAN PRIVATE LIMITED",
"RENEW VAYU URJA PRIVATE LIMITED",
"RENEW WARANGAL POWER PRIVATE LIMITED",
"RENEW WIND ENERGY (AP 2) PRIVATE LIMITED",
"RENEW WIND ENERGY (AP 3) PRIVATE LIMITED",
"RENEW WIND ENERGY (AP) PRIVATE LIMITED",
"RENEW WIND ENERGY (BUDH 3) PRIVATE LIMITED",
"RENEW WIND ENERGY (DEVGARH) PRIVATE LIMITED",
"RENEW WIND ENERGY (JADESWAR) PRIVATE LIMITED",
"RENEW WIND ENERGY (JAMB) PRIVATE LIMITED",
"RENEW WIND ENERGY (KARNATAKA 3) PRIVATE LIMITED",
"RENEW WIND ENERGY (KARNATAKA 4) PRIVATE LIMITED",
"RENEW WIND ENERGY (MP FOUR) PRIVATE LIMITED",
"RENEW WIND ENERGY (MP THREE) PRIVATE LIMITED",
"RENEW WIND ENERGY (MP) PRIVATE LIMITED",
"RENEW WIND ENERGY (RAJASTHAN 3) PRIVATE LIMITED",
"RENEW WIND ENERGY (RAJASTHAN FOUR) PRIVATE LIMITED",
"RENEW WIND ENERGY (RAJASTHAN ONE) PRIVATE LIMITED",
"RENEW WIND ENERGY (RAJASTHAN) PRIVATE LIMITED",
"RENEW WIND ENERGY (SIPLA) PRIVATE LIMITED",
"RENEW WIND ENERGY (TN 2) PRIVATE LIMITED",
"RENEW WIND ENERGY DELHI PRIVATE LIMITED",
"RENEW WIND ENERGY JATH PRIVATE LIMITED",
"RENEW WIND ENERGY KARNATAKA PRIVATE LIMITED",
"RENEW WIND ENERGY RAJKOT PRIVATE LIMITED",
"RENEW WIND ENERGY SHIVPUR PRIVATE LIMITED",
"RENEW WIND ENERGY VAREKARWADI PRIVATE LIMITED",
"RENEWABLE ENERGY SYSTEMS LIMITED",
"RENEWABLE POWER CORPORATION OF KERALA LIMITED",
"RENEWABLES TRINETHRA PRIVATE LIMITED",
"RENEWATE INFRASTRUCTURE TECHNOLOGIES PRIVATE LIMITED",
"RENEWCELL COSMEDICA LLP",
"RENEWMAX ENERGY PRIVATE LIMITED",
"RENEWSYS INDIA PRIVATE LIMITED",
"RENFRA ENERGY INDIA PRIVATE LIMITED",
"RENFRO INDIA PRIVATE LIMITED",
"RENGA ENGINEERING WORKS (INDIA) PRIVATE LIMITED",
"RENGANAYAKI PAPERS PRIVATE LIMITED",
"RENGE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"RENIES TELE SERVICES INDIA PRIVATE LIMITED",
"RENIS ELECTRONICS PRIVATE LIMITED",
"RENISE PRODUCTS PRIVATE LIMITED",
"RENISHAW METROLOGY SYSTEMS LIMITED",
"RENIT FOODS PRIVATE LIMITED",
"RENIWAL CONSTRUCTIONS PRIVATE LIMITED",
"RENJAL SOLAR PRIVATE LIMITED",
"RENK GEARS PRIVATE LIMITED",
"RENMAKCH INDIA PRIVATE LIMITED",
"RENNEN SOFTWARE PRIVATE LIMITED",
"RENNER COATINGS INDIA LLP",
"RENNOVATE HOME SOLUTIONS PRIVATE LIMITED",
"RENNY STEELS",
"RENNY STRIPS PRIVATE LIMITED",
"RENO AGRIGENETICS PRIVATE LIMITED",
"RENO MERCANTILE PRIVATE LIMITED",
"RENOCARE PHARMACEUTICALS PRIVATE LIMITED",
"RENOHTRA CONSTRUCTION PRIVATE LIMITED",
"RENOIR MANAGEMENT CONSULTING INDIA PRIVATE LIMITED",
"RENOLD CHAIN INDIA PRIVATE LIMITED",
"RENOLIFE PHARMA (INDIA) PRIVATE LIMITED",
"RENOM ENERGY SERVICES PRIVATE LIMITED",
"RENON INDIA PRIVATE LIMITED",
"RENOSEN PHARMACEUTICALS PRIVATE LIMITED",
"RENOUS EXTENSERVE PRIVATE LIMITED",
"RENOVA HOSPITALS",
"RENOVA LIFESCIENCES PRIVATE LIMITED",
"RENOVATE BIOLOGICALS PRIVATE LIMITED",
"RENOVATOR APPLIANCES LIMITED",
"RENOVISION AUTOMATION SERVICES PRIVATE LIMITED",
"RENOVISION EXPORTS PRIVATE LIMITED",
"RENOVITE PAYMENT SOLUTIONS PRIVATE LIMITED",
"RENOVO ASSETS PRIVATE LIMITED",
"RENOWN CLINICAL SERVICES PRIVATE LIMITED",
"RENOWN CONTAINER LINES PRIVATE LIMITED",
"RENOWN ENERGY AND EQUIPMENT PRIVATE LIMITED",
"RENOWN FORWARDERS PRIVATE LIMITED",
"RENOWN HOTELS AND RESORTS PRIVATE LIMITED",
"RENOWN PHARMACEUTICALS PRIVATE LIMITED",
"RENOWN WEB",
"RENOWNED BUILDTECH PRIVATE LIMITED",
"RENOWNED ENGINEERS PRIVATE LIMITED",
"RENOWNED ENTERTAINMENT & FOODS PRIVATE LIMITED",
"RENPHA SYSCON PRIVATE LIMITED",
"RENQ POWER SOLUTIONS INDIA PRIVATE LIMITED",
"RENRAM FASHIONS INDIA PRIVATE LIMITED",
"RENSOL TECHNOLOGIES PRIVATE LIMITED",
"RENSOLVE INDIA PRIVATE LIMITED",
"RENSPUR HEALTH CARE PRIVATE LIMITED",
"RENT ALPHA PRIVATE LIMITED",
"RENTASSET INITIATIVES PRIVATE LIMITED",
"RENTECH DESIGNS INDIA PRIVATE LIMITED",
"RENTECH DIGITAL PRIVATE LIMITED",
"RENTEX POLYMERS PRIVATE LIMITED",
"RENTLY SOFTWARE DEVELOPMENT PRIVATE LIMITED",
"RENTOKIL INITIAL HYGIENE INDIA PRIVATE LIMITED",
"RENTOMED PRIVATE LIMITED",
"RENTON NEED SERVICES PRIVATE LIMITED",
"RENU DEVELOPERS PRIVATE LIMITED",
"RENU ELECTRONICS PRIVATE LIMITED",
"RENU FARMS PRIVATE LIMITED",
"RENU INFRASTRUCTURE PRIVATE LIMITED",
"RENU POLYCHEM PRIVATE LIMITED",
"RENU TREXIM PRIVATE LIMITED",
"RENUCORP PRIVATE LIMITED",
"RENUKA ADVANCED SYSTEMS PRIVATE LIMITED",
"RENUKA AUTO COMPONENTS INDIA PRIVATE LIMITED",
"RENUKA BUSINESS HOLDING AND DEVELOPMENT PRIVATE LIMITED",
"RENUKA EXPORTS PRIVATE LIMITED",
"RENUKA FORWARDING PRIVATE LIMITED",
"RENUKA INVESTMENTS AND FINANCE LIMITED",
"RENUKA ISPAT PRIVATE LIMITED",
"RENUKA MIN CHEM PRIVATE LIMITED",
"RENUKA OUTSOURCING PRIVATE LIMITED",
"RENUKA PLASTI CRAFTS PRIVATE LIMITED",
"RENUKA POLYPLAST PRIVATE LIMITED",
"RENUKA POWERTECH PRIVATE LIMITED",
"RENUKA SILKS",
"RENUKA TRADERS PRIVATE LIMITED",
"RENUKA VASTUSHILP PRIVATE LIMITED",
"RENUKA VIDYALAYA BHOKARAMBA",
"RENUKESHWAR INVESTMENTS AND FINANCE LIMITED",
"RENUPRIYA ENTERPRISES PRIVATE LIMITED",
"RENURE CREATIONS PRIVATE LIMITED",
"RENUSHA PLUMBING PRIVATE LIMITED",
"RENUTRON POWER SOLUTIONS (INDIA) PRIVATE LIMITED",
"RENWAL PET PRIVATE LIMITED",
"RENXSOL ECOTECH PRIVATE LIMITED",
"RENZGLOBAL MARKETING PRIVATE LIMITED",
"REO-GPD INDUCTIVE COMPONENTS PRIVATE LIMITED",
"REOLAXE LAMINATE PRIVATE LIMITED",
"REOPIK ENVIRONMENT PRIVATE LIMITED",
"REP MACHINES MANUFACTURING PRIVATE LIMITED",
"REPAIR & RETURN TECHNOLOGY (INDIA) PRIVATE LIMITED",
"REPAL GREEN POWER PRIVATE LIMITED",
"REPAL RENEWABLES PRIVATE LIMITED",
"REPALLEWADA HIGHWAYS LIMITED",
"REPARAR WORKS PRIVATE LIMITED",
"REPARO PRIVATE LIMITED",
"REPBIN PRIVATE LIMITED",
"REPCO BANK",
"REPCO HOME FINANCE LIMITED",
"REPCO IMPEX PRIVATE LIMITED",
"REPCO MICRO FINANCE LIMITED",
"REPCOM AGENCIES PRIVATE LIMITED",
"REPENS HEALTHCARE INDIA PRIVATE LIMITED",
"REPERIO INFORMATICS PRIVATE LIMITED",
"REPHCONS ESTATES AND DEVELOPERS PRIVATE LIMITED",
"REPHINE CONSULTING INDIA PRIVATE LIMITED",
"REPHRASE TECHNOLOGIES PRIVATE LIMITED",
"REPLAY INTERNATIONAL PRIVATE LIMITED",
"REPLICA PACKARTS PVT LTD",
"REPLICA TECHNOLOGIES INDIA PRIVATE LIMITED",
"REPLICA XEROGRAPHY PRIVATE LIMITED",
"DELTEK REPLICON SOFTWARE (INDIA) PRIVATE LIMITED",
"REPLIGEN INDIA PRIVATE LIMITED",
"REPLIKA PACKAGING PRIVATE LIMITED",
"REPLIKA PRESS PRIVATE LIMITED",
"REPLISOFT TECHNOLOGIES PRIVATE LIMITED",
"REPLUS ENGITECH PRIVATE LIMITED",
"REPLXICON ENGINEERS PRIVATE LIMITED",
"REPONO PRIVATE LIMITED",
"REPORT OCEAN PRIVATE LIMITED",
"REPORTER LOGISTICS INDIA PRIVATE LIMITED",
"REPORTING AND DATA SOLUTIONS PRIVATE LIMITED",
"REPORTSINSIGHTS CONSULTING PRIVATE LIMITED",
"REPOS IOT INDIA PRIVATE LIMITED",
"REPOSE CLINIC AND RESEARCH CENTRE PRIVATE LIMITED",
"REPOSE FOODS PRIVATE LIMITED",
"REPOSE FOREX AND TRAVELS PRIVATE LIMITED",
"REPOSE HIGHWAY RESORT PRIVATE LIMITED",
"REPOSE MATTRESS PRIVATE LIMITED",
"REPOWER INFRASTRUCTURE PRIVATE LIMITED",
"REPOWERINGINDIA (OPC) PRIVATE LIMITED",
"REPOZITORY TECHNOLOGIES PRIVATE LIMITED",
"REPRISE MEDIA INDIA PRIVATE LIMITED",
"REPRO BOOKS LIMITED",
"REPRO ENTERPRISES PRIVATE LIMITED",
"REPRO GRAPHICS PRIVATE LIMITED",
"REPRO HEALTH CARE MANGALORE PRIVATE LIMITED",
"REPRO INDIA LIMITED",
"REPRO LABS INDIA PRIVATE LIMITED",
"REPRO RESINS PRIVATE LIMITED",
"REPROMEN OFFSET PRINTERS PRIVATE LIMITED",
"REPROSCAN TECH PARK LLP",
"REPROSCIENTIFIC MEDIA PRIVATE LIMITED",
"REPS COMMUNICATIONS PRIVATE LIMITED",
"REPS EN-TECH PRIVATE LIMITED",
"REPS PACK PRIVATE LIMITED",
"REPUBLIC SERVICES INC.",
"REPUBLIC TRACTOR MOTOR PRIVATE LIMITED",
"REPURPOSE (INDIA) PRIVATE LIMITED",
"REPUTATION COM INDIA PRIVATE LIMITED",
"REPUTE CARE PRIVATE LIMITED",
"REPUTE ENGINEERS PRIVATE LIMITED",
"REPUTE EXPRESS INDIA PRIVATE LIMITED",
"REPUTE FOODS PRIVATE LIMITED",
"REPUTE INFOTECH & ENTERPRISES LIMITED",
"REPUTE LOGISTICS PRIVATE LIMITED",
"REPUTE LOGITECH PRIVATE LIMITED",
"REQELFORD INTERNATIONAL SCHOOL",
"REQROUTE TALENT SOLUTIONS PRIVATE LIMITED",
"REQS TECHNOLOGIES INDIA PRIVATE LIMITED",
"REQUIS INFORMATION TECHNOLOGY PRIVATE LIMITED",
"REQUITY APPLIED SCIENCES PRIVATE LIMITED",
"REROUT PRIVATE LIMITED",
"RES ENTERTAINMENT LLP",
"RESAN OFFSET PRIVATE LIMITED",
"RESBIRD TECHNOLOGIES PRIVATE LIMITED",
"RESCARE MEDISYS INDIA PRIVATE LIMITED",
"RESCON MANUFACTURING COMPANY PRIVATE LIMITED.",
"RESCUE HOSPITALS INDIA PRIVATE LIMITED",
"RESEAPRO SCIENTIFIC SERVICES PRIVATE LIMITED",
"RESEARCH & DEVELOPMENT CENTRE FOR BICYCLE AND SEWING MACHINE",
"RESEARCH AND DEVELOPMENT INITIATIVE PRIVATE LIMITED",
"RESEARCH AND INFORMATION SYSTEM FOR DEV COUNTRIES",
"RESEARCH AT GLANCE (OPC) PRIVATE LIMITED",
"RESEARCH CENTRE IMARAT",
"RESEARCH DESIGNS AND STANDARD ORGAN",
"RESEARCH INNOVATION INCUBATION DESIGN LABORATORY FOUNDATION",
"RESEARCH MATE LIFESCIENCES PRIVATE LIMITED",
"RESEARCH MEDICINE PRIVATE LIMITED",
"RESEARCH NESTER PRIVATE LIMITED",
"RESEARCH NOW INDIA PRIVATE LIMITED",
"RESEARCH OFFI H IRRI RESEARCH W R D BHOPAL MADHYA PRADESH",
"RESEARCH PACIFIC INDIA PRIVATE LIMITED",
"RESEARCH TRIANGLE INSTITUTE GLOBAL INDIA PRIVATE LIMITED",
"RESEARCH WALLET SERVICES PRIVATE LIMITED",
"RESEARCHCO BOOKS AND PERIODICALS PRIVATE LIMITED",
"RESEARCHCO INTERNATIONAL PRIVATE LIMITED",
"RESEARCHFOX CONSULTING PRIVATE LIMITED",
"RESEARCHMOZ GLOBAL PRIVATE LIMITED",
"RESEARCHWIRE KNOWLEDGE SOLUTIONS PRIVATE LIMITED",
"RESEDA LIFESCIENCES PRIVATE LIMITED",
"RESEMBLE SYSTEMS INDIA PRIVATE LIMITED",
"RESERCA HEALTH CARE PRIVATE LIMITED",
"RESERVATION DATA MAINTENANCE INDIA PRIVATE LIMITED",
"RESERVE BANK INFORMATION TECHNOLOGY PRIVATE LIMITED",
"RESERVE BANK INNOVATION HUB",
"RESERVE BANK OF INDIA",
"RESFEBER LABS PRIVATE LIMITED",
"RESGEN LIMITED",
"RESGUARDO INDUSTRIES PRIVATE LIMITED",
"RESH AND THOSH TECHNOLOGIES PRIVATE LIMITED",
"RESHAM CONSTRUCTION PVT LTD",
"RESHAM PETROTECH LIMITED",
"RESHAM ROOSEN INDIA PRIVATE LIMITED",
"RESHAM SUTRA PRIVATE LIMITED",
"RESHAMI FLEXIPACK PRIVATE LIMITED",
"RESHAMSINGH AND COMPANY PRIVATE LIMITED",
"RESHAMWALA PRIVATE LIMITED",
"RESHAMWALA SHIP BROKERS PRIVATE LIMITED",
"RESHIM COMMERCIAL PRIVATE LIMITED",
"RESHMA FABRICS LIMITED",
"RESHMA FOOTWEARS PRIVATE LIMITED",
"RESHMA ORGANIC CHEMICALS PVT LTD",
"RESHMI INDUSTRIES INDIA PRIVATE LIMITED",
"RESHMI TREXIM PRIVATE LIMITED",
"RESHMIKA MINERALS AND CHEMICALS PRIVATE LIMITED",
"RESHU ADVERTISING PRIVATE LIMITED",
"RESHU TRADING PRIVATE LIMITED",
"RESICO (INDIA) PRIVATE LIMITED",
"RESIDENCIAL HIGH SCHOOL SHEWGAON AHMADNAGAR",
"RESIDENCY BUILDERS PRIVATE LIMITED",
"RESIDENCY RESORTS PRIVATE LIMITED",
"RESIDENT DOCTORS OF CIVIL HOSPITALS",
"RESIDEO INTERNATIONAL INDIA PRIVATE LIMITED",
"RESIDEO SMART HOME TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"RESIL CHEMICALS PRIVATE LIMITED",
"RESILEO LABS",
"RESILIENCE HEALTH PRIVATE LIMITED",
"RESILIENCE INNOVATION KNOWLEDGE ACADEMY INDIA PRIVATE LIMITED",
"RESILIENCEWORKS CONSULTATION SERVICES PRIVATE LIMITED",
"RESILIENT APPARELS PRIVATE LIMITED",
"RESILIENT COSME-CEUTICALS PRIVATE LIMITED",
"RESILIENT ENGINEERING PRIVATE LIMITED",
"RESILIENT EXPORTS PRIVATE LIMITED",
"RESILIENT MERCHANDISE LLP",
"RESILIENT PLASTICS PRIVATE LIMITED",
"RESILIENT SOFTECH PRIVATE LIMITED",
"RESILINC SOLUTIONS PRIVATE LIMITED",
"RESIN MASTERS PRIVATE LIMITED",
"RESINDIA WATER TREATMENT PVT LTD",
"RESINOUS CHEMICALS (INDIA) PRIVATE LIMITED",
"RESINOVA CHEMIE LIMITED",
"RESINS AND ALLIED CHEMICAL INDUSTRIES (BOMBAY) PRIVATE LIMITED",
"RESINS AND PLASTICS LIMITED",
"RESIPOL ADHESIVES PRIVATE LIMITED",
"RESISTANCE ALLOYS INDIA PRIVATE LIMITED",
"RESISTOFLEX DYNAMICS PRIVATE LIMITED",
"RESISTOFLEX PRIVATE LIMITED",
"RESISTOTECH INDIA PRIVATE LIMITED",
"RESMAN IMAGING PRIVATE LIMITED",
"RESMED INDIA PRIVATE LIMITED",
"RESNET SERVICES INDIA PRIVATE LIMITED",
"RESOHM INDIA PRIVATE LIMITED",
"RESOL VINYLS AND CHLORIDES LIMITED",
"RESOLUTE AI SOFTWARE PRIVATE LIMITED",
"RESOLUTE CORPORATE FACILITIES PRIVATE LIMITED",
"RESOLUTE ENTERPRISES PRIVATE LIMITED",
"RESOLUTE LOGISTICS PRIVATE LIMITED",
"RESOLUTE MEDICAL MANAGEMENT PRIVATE LIMITED",
"RESOLUTE NOBILITY ADVISORY PRIVATE LIMITED",
"RESOLUTE RESTAURANTS PRIVATE LIMITED",
"RESOLUTE STAR PRIVATE LIMITED",
"RESOLUTE VALUERS & CONSULTANTS PRIVATE LIMITED",
"RESOLUTION FETAL MEDICINE CENTRE AND RESEARCH INSTITUTE PRIVATE LIMITED",
"RESOLVE BUSINESS SERVICES INDIA PRIVATE LIMITED",
"RESOLVE EVENTS AND PROMOTIONS PRIVATE LIMITED",
"RESOLVE SALVAGE AND FIRE INDIA PRIVATE LIMITED",
"RESOLVEBIZ SERVICES AND APPS PRIVATE LIMITED",
"RESOLVETECH SOLUTIONS INDIA PRIVATE LIMITED",
"RESONAC MATERIALS INDIA PRIVATE LIMITED",
"RESONANCE",
"RESONANCE DIGITAL LLP",
"RESONANCE EDUCATING FOR BETTER TOMORROW",
"RESONANCE EDUVENTURES LIMITED",
"RESONANCE ENERGY PRIVATE LIMITED",
"RESONANCE INDIA PRIVATE LIMITED",
"RESONANCE LABORATORIES PRIVATE LIMITED",
"RESONANCE PAPER MILL PRIVATE LIMITED",
"RESONANCE SCHOOL AND JR COLLEGES",
"RESONANCE SPECIALITIES LIMITED",
"RESONANT PACKAGING PRIVATE LIMITED",
"RESONANT PLAST PRIVATE LIMITED",
"RESONANT WEALTH CONSULTANCY PRIVATE LIMITED",
"RESONATE SYSTEMS PRIVATE LIMITED",
"RESONATING THERMFORM PACKAGING PRIVATE LIMITED",
"RESONOUS TECHNOLOGIES PRIVATE LIMITED",
"RESORT DE CROSSROADS PRIVATE LIMITED",
"RESORTS WORLD TRAVEL SERVICES PRIVATE LIMITED",
"RESOURCE ACCESS MANAGEMENT SOLUTIONS PRIVATE. LIMITED",
"RESOURCE CARE SERVICES PRIVATE LIMITED",
"RESOURCE COMBINE SOLUTIONS PRIVATE LIMITED",
"RESOURCE DEVELOPMENT INTERNATIONAL INDIA PRIVATE LIMITED",
"RESOURCE E WASTE SOLUTIONS PRIVATE LIMITED",
"RESOURCE ENGIMECH (INDIA) PRIVATE LIMITED",
"RESOURCE HUNTERS HR PRIVATE LIMITED",
"RESOURCE INTEGRATION SOLUTIONS ENTERPRISE PRIVATE LIMITED",
"RESOURCE ONE IT SOULUTIONS INDIA PRIVATE LIMITED",
"RESOURCE POWER PRIVATE LIMITED",
"RESOURCE PRO OPERATIONAL SOLUTIONS PRIVATE LIMITED",
"RESOURCE RUBBER PRIVATE LIMITED",
"RESOURCE SHIPPING PRIVATE LIMITED",
"RESOURCE SOLUTIONS INDIA PRIVATE LIMITED",
"RESOURCE SQUARE SOLUTIONS PRIVATE LIMITED",
"RESOURCE VINCOM PRIVATE LIMITED",
"RESOURCEFUL AUTOMOBILE LIMITED",
"RESOURCES GLOBAL PROFESSIONALS INDIA PRIVATE LIMITED",
"RESOURCES INTERNATIONAL PRIVATE LIMITED",
"RESPA TEXTILES PRIVATE LIMITED",
"RESPI MEDICAL SYSTEMS PRIVATE LIMITED",
"RESPIRER LIVING SCIENCES PRIVATE LIMITED",
"RESPITE HOTELS PRIVATE LIMITED",
"RESPO PRODUCTS",
"RESPOINT SHOES PRIVATE LIMITED",
"RESPONCE INVESTMENTS LIMITED",
"RESPONCE RENEWABLE ENERGY LIMITED",
"RESPONCE SECURITIES PRIVATE LIMITED",
"RESPONSABILITY INDIA BUSINESS ADVISORS PRIVATE LIMITED",
"RESPONSE ENGINEERS PRIVATE LIMITED",
"RESPONSE FABRICS INDIA PRIVATE LIMITED",
"RESPONSE INFORMATICS LIMITED",
"RESPONSE XPRESS PRIVATE LIMITED",
"RESPONSENET DEVELOPMENT SERVICES",
"RESPONSIBLE DIAMOND INDUSTRIES PRIVATE LIMITED",
"RESPONSIVE INDUSTRIES LIMITED",
"RESPONSIVE SUTIP LIMITED",
"RESPONSYS BUSINESS SOLUTIONS INDIA PRIVATE LIMITED",
"RESPRO MEDICARE LLP",
"RESQ TECHNOLOGIES PRIVATE LIMITED",
"RESQTECH INDIA PRIVATE LIMITED",
"RESSEAUX TECH PRIVATE LIMITED",
"RESTAURANT BRANDS ASIA LIMITED",
"RESTIGO COMFORT PRODUCTS PRIVATE LIMITED",
"RESTLESS DEVELOPMENT",
"RESTO MART INDIA PRIVATE LIMITED",
"RESTOLEX COIR PRODUCTS PRIVATE LIMITED",
"RESTOMATT INDUSTRY PRIVATE LIMITED",
"RESTON COIR (INDIA) PRIVATE LIMITED",
"RESTORATION ENGINEERS",
"RESULT ADVERTISING PRIVATE LIMITED",
"RESULT RIX MEDIA PRIVATE LIMITED",
"RESULT SERVICES PRIVATE LIMITED",
"RESULT SOFTWARE DEVELOPMENT PRIVATE LIMITED",
"RESULTICKS DIGITALS INDIA PRIVATE LIMITED",
"RESULTS INVESTMENTS PRIVATE LIMITED",
"RESULTS MARINE PRIVATE LIMITED",
"RESURGENCE FINCAP ADVISORS PRIVATE LIMITED",
"RESURGENT AV INTEGRATORS PRIVATE LIMITED",
"RESURGENT BUILDER PRIVATE LIMITED",
"RESURGENT ENTERPRISE SOLUTIONS PRIVATE LIMITED",
"RESURGENT FACILITIES MANAGEMENT PRIVATE LIMITED",
"RESURGENT INDIA LTD",
"RESURGENT MINING SOLUTIONS PRIVATE LIMITED",
"RESURGENT PROPERTY VENTURES PRIVATE LIMITED",
"RESURGENT RESOLUTION PROFESSIONALS LLP",
"RESVERA WINES LIMITED",
"RETAIL DETAILZ INDIA PRIVATE LIMITED",
"RETAIL DIRECT PRIVATE LIMITED",
"RETAIL HUB SOLUTIONS LIMITED",
"RETAIL IMPACT PRIVATE LIMITED",
"RETAIL INTERFACE PRIVATE LIMITED",
"RETAIL IT SOLS PRIVATE LIMITED",
"RETAIL JUNCTION PRIVATE LIMITED",
"RETAIL KLOUD9 TECHNOLOGIES INDIA PRIVATE LIMITED",
"RETAIL QUOTIENT RESEARCH PRIVATE LIMITED",
"RETAIL REALM LIMITED",
"RETAIL SCAN MANAGEMENT SERVICES PRIVATE LIMITED",
"RETAIL SOLUTIONS INDIA PRIVATE LIMITED",
"RETAIL SOLUTIONS PRIVATE LIMITED",
"RETAIL VIEW IT SOLUTIONS PRIVATE LIMITED",
"RETAILER SHAKTI SUPPLY CHAIN PRIVATE LIMITED",
"RETAILERS ASSOCIATION OF INDIA",
"RETAILERS ASSOCIATION'S SKILL COUNCIL OF INDIA",
"RETAILINSIGHTS CONSULTANCY SERVICES PRIVATE LIMITED",
"RETAILINSIGHTS NEWGEN CONSULTANCY SERVICES PRIVATE LIMITED",
"RETAILMART TECHNOLOGIES PRIVATE LIMITED",
"RETAILSCAPE MANAGEMENT SERVICES PRIVATE LIMITED",
"RETAILWARE SOFTECH PRIVATE LIMITED",
"RETAILWHIZZ SOLUTIONS PRIVATE LIMITED",
"RETAILWORX INDIA PRIVATE LIMITED",
"RETAS ENVIRO SOLUTIONS PRIVATE LIMITED",
"RE-TAX ELECTRICALS PRIVATE LIMITED",
"RETCHAKAR CHEMICALS PRIVATE LIMITED",
"RETCHAKAR TANNINS PRIVATE LIMITED",
"RETE MEDIA PRIVATE LIMITED",
"RETEC HEALTHCARE PRIVATE LIMITED",
"RETECK ENVIROTECH PRIVATE LIMITED",
"RETERO LIFE SCIENCES PRIVATE LIMITED",
"RETEX-BOUVEUR INDIA TEXTILE MACHINERY PRIVATE LIMITED",
"RETHINK EDUCATIONAL SYSTEMS PRIVATE LIMITED",
"RETHIUM POWER TECH LLP",
"RETICULE INFOTECH PRIVATE LIMITED",
"RETINA FOUNDATION HOSPITALS PRIVATE LIMITED",
"RETINA INSTITUTE OF BENGAL",
"RETINA PAINTS LIMITED",
"RETINA PAINTS PRIVATE LIMITED",
"RETINA SOFTWARE PRIVATE LIMITED",
"RETINA SPECIALITY HOSPITAL",
"RETNEXT TECHNOLOGIES PRIVATE LIMITED",
"RETOLIA ISPAT PRIVATE LIMITED",
"RETORT CHEMICALS PRIVATE LIMITED",
"RETORT PHARMACEUTICALS PRIVATE LIMITED",
"RETRA LIFE SCIENCES PRIVATE LIMITED",
"RETRA VENTURES PRIVATE LIMITED",
"RETRANZ INFOLABS PRIVATE LIMITED",
"RETRIEVE EXIM PRIVATE LIMITED",
"RETRO AGRI SOLUTIONS PRIVATE LIMITED",
"RETRO CLOTHING PRIVATE LIMITED",
"RETRO DESIGNS AND DIMENSIONS PRIVATE LIMITED",
"RETRO FOODS PRIVATE LIMITED",
"RETRO FOOTWEARS PRIVATE LIMITED",
"RETRO GREEN REVOLUTION LIMITED",
"RETRO MARKETING SOLUTIONS PRIVATE LIMITED",
"RETRO PACKAGING CONTAINERS PRIVATE LIMITED",
"RETROFIT TECHNOLOGY PRIVATE LIMITED",
"RETROGEEK CREATIVE PRIVATE LIMITED",
"RETTENMAIER INDIA PRIVATE LIMITED",
"RETTERI SRI KUMARAN HEALTH CENTRE PRIVATE LIMITED",
"RETZEN RETAIL PRIVATE LIMITED",
"REUBENS HOSPITECH PRIVATE LIMITED",
"REUDAN SHIPPING & LOGISTICS SERVICES PRIVATE LIMITED",
"REURJA SOLUTIONS PRIVATE LIMITED",
"REUTECH INDIA PRIVATE LIMITED",
"REUTTER INNOVATIVE CLOSURE TECHNOLOGIES PRIVATE LIMITED",
"REV SNACKS PRIVATE LIMITED",
"REVA ENVIRO SYSTEMS PVT LTD",
"REVA INDUSTRIES INDIA PRIVATE LIMITED",
"REVA INFRA ESTATE AND DEVELOPERS PRIVATE LIMITED",
"REVA JOURNEYS GLOBE PRIVATE LIMITED",
"REVA KRIPA SUGARS PRIVATE. LIMITED.",
"REVA MEDICAL INSTITUTE PRIVATE LIMITED",
"REVA MEDICARE PRIVATE LIMITED",
"REVA SUGAR INDUSTRIES PRIVATE LIMITED",
"REVA UNIVERSITY",
"REVAAN IT SOLUTIONS PRIVATE LIMITED",
"REVABA INFERTILITY CLINICS PRIVATE LIMITED",
"REVACHEMICAL PRIVATE LIMITED",
"REVACURE LIFESCIENCES LLP",
"REVAL ANALYTICAL SERVICES PRIVATE LIMITED",
"REVAL INDIA PRIVATE LIMITED",
"REVALSYS TECHNOLOGIES INDIA PRIVATE LIMITED",
"REVALYU RECYCLING (INDIA) LIMITED",
"REVAMP CONSULTING PRIVATE LIMITED",
"REVANKAR MOTORS PRIVATE. LIMITED.",
"REVANS CHEM INDIA PRIVATE LIMITED",
"REVANT FOODS PRIVATE LIMITED",
"REVANTA CLUB AND RESORTS PRIVATE LIMITED",
"REVANTA HOMETEX INDIA PRIVATE LIMITED",
"REVANTA SOLAR PRIVATE LIMITED",
"REVANTH INFRA TECH PRIVATE LIMITED",
"REVANTH REAL ESTATES PVT.LTD.",
"REVANTHA SERVICES PRIVATE LIMITED",
"REVAPOLY BLISTERS PRIVATE LIMITED",
"REVASHANKAR GEMS LIMITED",
"REVASSURE BUSINESS MANAGEMENT SERVICES (OPC) PRIVATE LIMITED",
"REVAT LABORATORIES PRIVATE LIMITED",
"REVATA DOWNHOLE TOOLS PRIVATE LIMITED",
"REVATA ENGINEERING PRIVATE LIMITED",
"REVATHI ELECTRONICS PRIVATE LIMITED",
"REVATHI ENGINEERING PRIVATE LIMITED",
"REVATHI EQUIPMENT LIMITED",
"REVATHI FINANCES AND LEASING PRIVATE LIMITED",
"REVATHI HOLDINGS PRIVATE LIMITED",
"REVATHI MEDICAL CENTER TIRUPUR INDIA PRIVATE LIMITED",
"REVATHI MODERN RICE MILL",
"REVATHI PAPER PRODUCTS PRIVATE LIMITED",
"REVATHI STORES PRIVATE LIMITED",
"REVATHY XSARA PRIVATE LIMITED",
"REVATI PAR BOILED RICE MILLS PRIVATE LIMITED",
"REVATI TEXWINKA PRIVATE LIMITED",
"REVATURE CONSULTANCY SERVICES PRIVATE LIMITED",
"REVAYU SYSTEMS PRIVATE LIMITED",
"REVCLERX PRIVATE LIMITED",
"REVE SYSTEMS INDIA PRIVATE LIMITED",
"REVEATION LABS PRIVATE LIMITED",
"REVEILLE STEEL INDUSTRIES PRIVATE LIMITED",
"REVEILLE TECHNOLOGY P LIMITED",
"REVEL INDUSTRIES PRIVATE LIMITED",
"REVELATION PORTFOLIO MANAGEMENT PRIVATE LIMITED",
"REVELATION SOFTWARE LABS PRIVATE LIMITED",
"REVELATIONS BIOTECH PRIVATE LIMITED",
"REVELE INDIA PRIVATE LIMITED",
"REVELIN7 TECHNOLOGY PRIVATE LIMITED",
"REVELL CREATIONS PRIVATE LIMITED",
"REVELO BUSINESS SOLUTIONS PRIVATE LIMITED",
"REVENT PRECISION ENGINEERING LIMITED",
"REVENTICS PRIVATE LIMITED",
"REVENUE DEPARTMENT - GOVT",
"REVENUE DIVISIONAL COMMISSIONER NORTHERN DIVISION SAMBALPUR",
"REVENUECLICK MEDIA PRIVATE LIMITED",
"REVENUESTACK TECHNOLOGIES PRIVATE LIMITED",
"REVENUP AI TECHNOLOGIES PRIVATE LIMITED",
"REVER HOMES PRIVATE LIMITED",
"REVERA ENTERPRISE PRIVATE LIMITED",
"REVERATE TECH PRIVATE LIMITED",
"REVEREND JEWERLS PRIVATE LIMITED",
"REVEREND TECHNOLOGIES PRIVATE LIMITED",
"REVERIE LANGUAGE TECHNOLOGIES LIMITED",
"REVERPRO SERVICES (INDIA) PRIVATE LIMITED",
"REVERSELOGIX MANAGEMENT INDIA PRIVATE LIMITED",
"REVESOLV LLP",
"REVESTA HEALTH CARE LIMITED",
"REVETHI DEALERS PVT LTD",
"REVEX INDUSTRIES PRIVATE LIMITED",
"REVEX PLASTICISERS PRIVATE LIMITED",
"REVGURUS INFO INDIA PRIVATE LIMITED",
"REVI ENERGIES PRIVATE LIMITED",
"REVIERA COSMECEUTICALS PRIVATE LIMITED",
"REVIEW COMMOTRADE PRIVATE LIMITED",
"REVIEW INSURANCE BROKERS PRIVATE LIMITED",
"REVIEW SHIPPING & LOGISTICS PRIVATE LIMITED",
"REVIN LABS PRIVATE LIMITED",
"REVINE TECHNOLOGIES PRIVATE LIMITED",
"REVINTO LIFE SCIENCE PRIVATE LIMITED",
"REVITAS TECHNOLOGIES PRIVATE LIMITED",
"REVITSONE SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"REVIVA PHARMACEUTICALS INDIA PRIVATE LIMITED",
"REVIVAL BONENJOINT PRIVATE LIMITED",
"REVIVAL CLOTTHING TIRUPUR PRIVATE LIMITED",
"REVIVAL PAPERS MILL PRIVATE LIMITED",
"REVIVAL SYNTHETICS LIMITED",
"REVIVE FOODS PRIVATE LIMITED",
"REVIVE FORMULATIONS INDIA PRIVATE LIMITED",
"REVIVE LIFE SCIENCE PRIVATE LIMITED",
"REVIVE MYSORE HEALTHCARE PRIVATE LIMITED",
"REVIVE REALTY PRIVATE LIMITED",
"REVIVECLOUD PRIVATE LIMITED",
"REVIVING GREEN REVOLUTION CELL",
"REVMAKX TECHNOLOGIES PRIVATE LIMITED",
"REVMAX TELECOM INFRASTRUCTURES PRIVATE LIMITED",
"REVMEDI HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"REVOCOAT INDIA PRIVATE LIMITED",
"REVOKARMAHUB SOFTWARE & SERVICES PRIVATE LIMITED",
"REVOL PROCESS SOLUTIONS PRIVATE LIMITED",
"REVOLITE INFOTECH PRIVATE LIMITED",
"REVOLT GLOBAL INFRA FACILITY AND SECURITY SERVICES PRIVATE LIMITED.",
"REVOLT INTELLICORP PRIVATE LIMITED",
"REVOLUCION TEX CREATIONS PRIVATE LIMITED",
"REVOLUCION TEXTIL PRIVATE LIMITED",
"REVOLUTION GAMES PRIVATE LIMITED",
"REVOLUTION INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"REVOLUTION REALCON PRIVATE LIMITED",
"REVOLVE ENGINEERS PRIVATE LIMITED",
"REVOOR PADMANABHA CHETTY'S MATRICULATION HIGHER SECONDARY SCHOOL",
"REVOS AQUA SYSTEMS PRIVATE LIMITED",
"REVPOWER PRIVATE LIMITED",
"REVTI INDUSTRIES PRIVATE LIMITED",
"REVUPSIDE BUSINESS SOLUTIONS PRIVATE LIMITED",
"REVVITY HEALTHCARE (INDIA) PRIVATE LIMITED",
"REVVKNEW TECHNOLOGIES PRIVATE LIMITED",
"REVYRIEGLOBAL TECH SOLUTIONS PRIVATE LIMITED",
"REVZOOM INDIA PRIVATE LIMITED",
"REW CONSTRUCTIONS PRIVATE LIMITED",
"REW CONTRACTS PRIVATE LIMITED",
"REWA AGROTECH",
"REWA CHEMICALS PRIVATE LIMITED",
"REWA GASES PVT LTD",
"REWA GOLD PRIVATE LIMITED",
"REWA HOSPITAL & RESEARCH CENTER PRIVATE LIMITED",
"REWA MSW ENERGY SOLUTIONS PRIVATE LIMITED",
"REWA MSW MANAGEMENT SOLUTIONS LIMITED",
"REWA PATHWAYS PRIVATE LIMITED",
"REWA PRESERVATIONS PRIVATE LIMITED",
"REWA STABILIZERS AND LUBRICANTS PRIVATE LIMITED",
"REWA ULTRA MEGA SOLAR LIMITED",
"REWA WASTE 2 ENERGY PROJECT LIMITED",
"REWA YASH INDUSTRIES PRIVATE LIMITED",
"REWABEN MANIHARBHAI PATEL MAHILA KALA MAHAVIDYALAYA BHANDARA",
"REWANCHAL SOLAR POWER PRIVATE LIMITED",
"REWANT ENGINEERS CONSTRUCTION CO. PRIVATE LIMITED",
"REWANT HOSPITALITY PRIVATE LIMITED",
"REWARD ADVISORY SERVICES PRIVATE LIMITED",
"REWARD CONSTRUCTIONS PRIVATE LIMITED",
"REWARD REAL ESTATE COMPANY LIMITED",
"REWARD360 GLOBAL SERVICES PRIVATE LIMITED",
"REWARDBIG LOYALTY SOLUTIONS PRIVATE LIMITED",
"REWARDPAY SERVICES PRIVATE LIMITED",
"REWARDPORT CORPORATE SOLUTIONS PRIVATE LIMITED",
"REWARI ATELI HIGHWAY PRIVATE LIMITED",
"REWDALE PRECISION TOOLS PRIVATE LIMITED",
"REWELL FOOD PRODUCTS PRIVATE LIMITED",
"REWISE ANALYTICS & TECHNOLOGIES PRIVATE LIMITED",
"REWISER EDUCATIONAL SERVICES PRIVATE LIMITED",
"REX CERAMIC PRIVATE LIMITED",
"REX ENVIRONMENT SCIENCE PRIVATE LIMITED",
"REX FUELS MANAGEMENT PRIVATE LIMITED",
"REX GENIA LIFE SCIENCES PRIVATE LIMITED",
"REX HERBAL TRADERS PRIVATE LIMITED",
"REX INDUSTRIES INDIA PRIVATE LIMITED",
"REX INTERNATIONAL DEHRADUN",
"REX MEDICARE PRIVATE LIMITED",
"REX NEWS NETWORK PRIVATE LIMITED",
"REX PIPES AND CABLES INDUSTRIES LIMITED",
"REX REMEDIES LIMITED",
"REX SEALING AND PACKING INDUSTRIES LIMITED",
"REX STEAM PRODUCTS PRIVATE LIMITED",
"REX TONE INDUSTRIES LIMITED",
"REXAN APPLIANCES PRIVATE LIMITED",
"REXAW RECYCLING PRIVATE LIMITED",
"REXAWARE SOLUTIONS PRIVATE LIMITED",
"REXCIN PHARMACEUTICALS PRIVATE LIMITED",
"REXEGS FARMS PRIVATE LIMITED",
"REXEL INDIA PRIVATE LIMITED",
"REXELLO CASTORS PRIVATE LIMITED",
"REXELLO ENGINEERING PRODUCTS PRIVATE LIMITED",
"REXHAM TOOLS & EQUIPMENTS PRIVATE LIMITED",
"REXION HEALTHCARE PRIVATE LIMITED",
"REXIT PHARMACEUTICAL PRIVATE LIMITED",
"REXNDOX OUTSOURCE SOLUTIONS LLP",
"REXNORD ELECTRONICS AND CONTROLS LIMITED",
"REXNORD INDIA PRIVATE LIMITED",
"REXO FLEX PRIVATE LIMITED",
"REXOLENE INDIA MANUFACTURING PRIVATE LIMITED",
"REXON HYDRAULICS PRIVATE LIMITED",
"REXON LABORATORIES LIMITED",
"REXOZA ENTERPRISES PRIVATE LIMITED",
"REXPRO ENTERPRISES PRIVATE LIMITED",
"REXSONA TILES PRIVATE LIMITED",
"REXTILE LEATHER PRIVATE LIMITED",
"REXTON IT SOLUTIONS PRIVATE LIMITED",
"REXTRON CERAMICS PRIVATE LIMITED",
"REY CERA CREATION PRIVATE LIMITED",
"REYA CONSULTANCY SERVICES PRIVATE LIMITED",
"REYANK TECHNOLOGY PRIVATE LIMITED",
"REYANSH BUILDCON PRIVATE LIMITED",
"REYANSH INTERNATIONAL PRIVATE LIMITED",
"REYANSH TRADE PRIVATE LIMITED",
"REYBHAV TECHNOLOGIES PRIVATE LIMITED",
"REYDEL AUTOMOTIVE INDIA PRIVATE LIMITED",
"REYESS IMPEX PRIVATE LIMITED",
"REYMAN TEXTILES PRIVATE LIMITED",
"REYMECH ENGINEERING PRIVATE LIMITED",
"REYNA SOLUTIONS LLP",
"REYNA STEELS LIMITED",
"REYNAERS ALUMINIUM PRIVATE LIMITED",
"REYNAV CAPITAL PRIVATE LIMITED",
"REYNDERS LABEL PRINTING INDIA PRIVATE LIMITED",
"REYNOLD GRAPHICS PRIVATE LIMITED",
"REYNOLD TRADERS PRIVATE LIMITED",
"REYNOLD VALVES LTD",
"REYNOLDS AMERICAN INC.",
"REYNOLDS PENS INDIA PRIVATE LIMITED",
"REYNOLDS SOUND AND LIGHTING SERVICES PRIVATE LIMITED",
"REZA KABUL ARCHITECTS PRIVATE LIMITED",
"REZA METALS PRIVATE LIMITED",
"REZEN INDUSTRIES PRIVATE LIMITED",
"REZENT POWER ELECTRONICS PRIVATE LIMITED",
"REZLYTIX TECHNOLOGIES PRIVATE LIMITED",
"REZNO LAMINATES INDIA PRIVATE LIMITED",
"REZONANT DESIGN SERVICES PRIVATE LIMITED",
"REZORCE MANAGED SOLUTIONS PRIVATE LIMITED",
"REZOVO TRADING PRIVATE LIMITED",
"RF GENIE ENTERPRISES PRIVATE LIMITED",
"RF MANAGED SERVICES INDIA PRIVATE LIMITED",
"RF PLUS COMMUNICATIONS PRIVATE LIMITED",
"RFBL FLEXI PACK LIMITED",
"RFCOMM SOLUTIONS & SERVICES PRIVATE LIMITED",
"RFE BELGAUM SOLAR PRIVATE LIMITED",
"RFH SOLUTIONS PRIVATE LIMITED",
"RFIC TRADING PRIVATE LIMITED",
"RFL INSURANCE BROKING PRIVATE LIMITED",
"RFLY INNOVATIONS PRIVATE LIMITED",
"RFM AUTOMOTIVES PRIVATE LIMITED",
"RFPIO INDIA PRIVATE LIMITED",
"RFS INDIA TELECOM PRIVATE LIMITED",
"RFTECH MOBILE PRIVATE LIMITED",
"RFZONE AUTOMATIONS PRIVATE LIMITED",
"RG & SONS INFRASTRUCTURE PRIVATE LIMITED",
"RG BUILDCON PRIVATE LIMITED",
"RG BUILDMART (INDIA) PRIVATE LIMITED",
"RG CARGO SERVICES PRIVATE LIMITED",
"RG CLOUD SOLUTIONS (OPC) PRIVATE LIMITED",
"RG COLONIZERS PRIVATE LIMITED",
"RG FIBERS PRIVATE LIMITED",
"RG GOLD PRIVATE LIMITED",
"RG HOME FURNISHINGS PRIVATE LIMITED",
"RG INDUSTRIES PRIVATE LIMITED",
"RG INFRACITY PRIVATE LIMITED RGIPL",
"RG INSURANCE PROCESSING SERVICES PRIVATE LIMITED",
"RG JEWELLS PRIVATE LIMITED",
"RG KAR MEDICAL COLLEGE AND HOSPITAL",
"RG KEDIA COLLEGE OF COMMERCE",
"RG LIFE STYLE PRIVATE LIMITED",
"RG LITE INDIA PRIVATE LIMITED",
"RG MERCHANDISERS PRIVATE LIMITED",
"RG REFINERIES PRIVATE LIMITED",
"RG REGAL TECHNOLOGIES PRIVATE LIMITED",
"RG RESIDENCY PRIVATE LIMITED",
"RG SECURITY SOLUTIONS PRIVATE LIMITED",
"RG SHAH INFRATECH PRIVATE LIMITED",
"RG TECHNO INDUSTRIAL PRODUCTS PRIVATE LIMITED",
"RG TEXTILE INDUSTRIES PRIVATE LIMITED",
"RG THERMAL SOLUTION PRIVATE LIMITED",
"RG TRADELINK PRIVATE LIMITED",
"RG WIRES PRIVATE LIMITED",
"RGA FRESH FRUITS PRIVATE LIMITED",
"RGA INFRASTRUCTURE",
"RGA LIFE REINSURANCE COMPANY OF CANADA",
"RGA SOFTWARE SYSTEMS PRIVATE LIMITED",
"RGB FILMS PRIVATE LIMITED",
"RGB HEALTHCARE PRIVATE LIMITED",
"RGB NIRMAN PRIVATE. LIMITED.",
"RGC HOSPITALITY PRIVATE LIMITED",
"RGC INDUSTRIES LIMITED",
"RGD CONSTRUCTIONS PRIVATE LIMITED",
"RGE CONSTRUCTIONS AND DEVELOPMENT PRIVATE LIMITED",
"RGF SELECT INDIA PRIVATE LIMITED",
"RGF SELECT INDIA PRIVATE.LIMITED",
"RGG COSMETICS PRIVATE LIMITED",
"RGGROCERY CHAINSTORES PRIVATE LIMITED",
"RGH ENTREPRENEURS PRIVATE LIMITED.",
"RGJ AUTOMOBILES PRIVATE LIMITED",
"RGK ENGINEERING ENTERPRISES PRIVATE LIMITED",
"RGK PLASTICS UDYOG PRIVATE LIMITED",
"RGK POLYCHEM INDIA PRIVATE LIMITED",
"RGL ECOPAK LIMITED",
"RGL FASHION PRIVATE LIMITED",
"RGM BUSINESS PLUS PRIVATE LIMITED",
"RGM INTERNATIONAL INDIA PRIVATE LIMITED",
"RGM INVESTMENTS & PROPERTIES PRIVATE LIMITED",
"RGM TEXTILE PRIVATE LIMITED",
"RGNIA DERMACEUTICALS PRIVATE LIMITED",
"RGP ELECTRONICS INDIA PRIVATE LIMITED",
"RGP IMPEX PRIVATE LIMITED",
"RGP MOULDS PRIVATE LIMITED",
"RGPL COMMODITIES PRIVATE LIMITED",
"RGR NIRMAN PRIVATE LIMITED",
"RGR STEELS PRIVATE LIMITED",
"RGS CAD",
"RGS CREATIONS PRIVATE LIMITED",
"RG'S FASHIONS PRIVATE LIMITED",
"RGS FORMULATIONS",
"RGS INTERNATIONAL PRIVATE LIMITED",
"RGS SOLAR POWER INFRA PRIVATE LIMITED",
"RGS SOLAR POWER PRIVATE LIMITED",
"RGSB ESTATES PRIVATE LIMITED",
"RGSK EASY PACK PRIVATE LIMITED",
"RGT FASHION PRIVATE LIMITED",
"RGV HOUSING PRIVATE LIMITED",
"RH SCIENTIFIC INDIA PRIVATE LIMITED",
"RH YADAV INFRA PRIVATE LIMITED",
"RHA TECHNOLOGIES PRIVATE LIMITED",
"RHA TEXTILE PRIVATE LIMITED",
"RHAPSODY ACCOUNTING AND ADVISORY SERVICES PRIVATE LIMITED",
"RHCGLOBAL EXPORTS PRIVATE LIMITED",
"RHEA EQUISOLUTION PRIVATE LIMITED",
"RHEA HEALTHCARE PRIVATE LIMITED",
"RHEA MANAGMENT CONSULTANTS",
"RHEA RETAIL PRIVATE LIMITED",
"RHEAL SOFTWARE PRIVATE LIMITED",
"RHEAO AIRCON INDIA PRIVATE LIMITED",
"RHEIN CARGO CARE PRIVATE LIMITED",
"RHEIN CHEMICALS PRIVATE LIMITED",
"RHEIN INDIA TECHNOLOGIES PRIVATE LIMITED",
"RHEINBRUCKE IT CONSULTING PRIVATE LIMITED",
"RHEMA DAIRY PRODUCTS INDIA PRIVATE LIMITED",
"RHEMA KISAN PRODUCER COMPANY LIMITED",
"RHENUS CONTRACT LOGISTICS INDIA PRIVATE LIMITED",
"RHENUS LOGISTICS INDIA PRIVATE LIMITED",
"RHENUS ROAD FREIGHT INDIA PRIVATE LIMITED",
"RHEO AI SOLUTIONS PRIVATE LIMITED",
"RHEO PHARMA PRIVATE LIMITED",
"RHEOMOLD ENGINEERING SOLUTIONS LLP",
"RHEOPLAST TECHNOLOGY PRIVATE LIMITED",
"RHETAN ESTATE PRIVATE LIMITED",
"RHETAN TMT LIMITED",
"RHETORIC TECHNOLOGIES PRIVATE LIMITED",
"RHETORIC TRANSWAYS PRIVATE LIMITED",
"RHG CONSTRUCTIONS PRIVATE LIMITED",
"RHG TELECOMMUNICATIONS PRIVATE LIMITED",
"RHI CLASIL PRIVATE LIMITED",
"RHI MAGNESITA INDIA LIMITED",
"RHI MAGNESITA INDIA REFRACTORIES LIMITED",
"RHIBHU ROOFTOP SOLAR SOLUTIONS LIMITED",
"RHINE AND RAAVI HOLDINGS LIMITED",
"RHINE BIOGENICS PRIVATE LIMITED",
"RHINE ENGINEERING PRIVATE LIMITED",
"RHINE EXPORTS PRIVATE LIMITED",
"RHINE LIFE SCIENCES PRIVATE LIMITED",
"RHINE RETAILS PRIVATE LIMITED",
"RHINE SOLAR LIMITED",
"RHINESTONE CRYSTALS PRIVATE LIMITED",
"RHINEXA INDIA PRIVATE LIMITED",
"RHINO AGENCIES LIMITED",
"RHINO ENERGY RESOURCES PRIVATE LIMITED",
"RHINO FINANCE PRIVATE LIMITED",
"RHINO FOAM PRODUCT PRIVATE LIMITED",
"RHINO FORCE SERVICES INDIA PRIVATE LIMITED",
"RHINO MACHINES PRIVATE LIMITED",
"RHINO ROAD EQUIPMENTS PRIVATE LIMITED",
"RHINO SERVICES PRIVATE LIMTIED",
"RHISHIKESH ENGINEERS PVT LTD",
"RHITI SPORTS MANAGEMENT PRIVATE LIMITED",
"RHITI TALENT MANAGEMENT PRIVATE LIMITED",
"RHIZOME HOSPITALITY SOLUTIONS PRIVATE LIMITED",
"RHJ INDUSTRIES PRIVATE LIMITED",
"RHJ METALS PRIVATE LIMITED",
"RHJ TUBES PRIVATE LIMITED",
"RHK LOGISTICS PRIVATE LIMITED",
"RHMB INDIA PRIVATE LIMITED",
"RHN COMMERCIALS PRIVATE LIMITED",
"RHODA COGNAX PRIVATE LIMITED",
"RHODA TEXTILES PRIVATE LIMITED",
"RHODIA SPEC CHEM IN",
"RHODIA SPECIALTY CHEMICALS INDIA PRIVATELIMITED",
"RHODIUM FERRO ALLOYS PRIVATE LIMITED",
"RHODIUM INFOTECH PRIVATE LIMITED",
"RHODIUM INFRA PRIVATE LIMITED",
"RHODIUM PROPERTIES PRIVATE LIMITED",
"RHODIUM STEELS AND ALLOYS PRIVATE LIMITED",
"RHODODEN SILKMILLS PRIVATE LIMITED",
"RHOMBIC DESIGNS PRIVATE LIMITED",
"RHOMBOID ENGINEERING PRIVATE LIMITED",
"RHOMBUS INFRASTRUCTURES PRIVATE LIMITED",
"RHOMBUS PHARMA PRIVATE LIMITED",
"RHOMBUS TECHNOLOGIES PRIVATE LIMITED",
"RHONIUM METALS AND MARKETING PRIVATE LIMITED",
"RHP HEALTH CARE PRIVATE LIMITED¬†",
"RHP LOGISTICS PRIVATE LIMITED",
"RHR MEDICARE PRIVATE LIMITED",
"RHS FILTERS PRIVATE LIMITED",
"RHS HEALTHCARE PRIVATE LIMITED",
"RHS TOURSGURU PRIVATE LIMITED",
"RHT HOSPITALITY PRIVATE LIMITED",
"RHT PHARMACEUTICALS PRIVATE LIMITED",
"RHT STEELS (INDIA) PRIVATE LIMITED",
"RHUBARB FOODS PRIVATE LIMITED",
"RHV ENTERPRISE PRIVATE LIMITED",
"RHYDBURG PHARMACEUTICALS LIMITED",
"RHYME ORGANICS AND CHEMICALS LIMITED",
"RHYME ORGANICS AND CHEMICALS PRIVATE LIMITED",
"RHYSLEY PRIVATE LIMITED",
"RHYTEK OVERSEAS PRIVATE LIMITED",
"RHYTHM AND HUES STUDIO INDIA PRIVATE LIMITED",
"RHYTHM AUTOMATIONCONTROL PRIVATE LIMITED",
"RHYTHM BIOTECH PRIVATE LIMITED",
"RHYTHM CHEMICALS PRIVATE LIMITED",
"RHYTHM CLOTHING PRIVATE LIMITED",
"RHYTHM FASHIONS PRIVATE LIMITED",
"RHYTHM FORMULATIONS PRIVATE LIMITED",
"RHYTHM HEART & MULTI SPECIALITY HOSPITALS PRIVATE LIMITED",
"RHYTHM HEART AND CRITICAL CARE",
"RHYTHM INFRASTRUCTURE LIMITED",
"RHYTHM KNIT INDIA PRIVATE LIMITED",
"RHYTHM MEDICAL DEVICES PRIVATE LIMITED",
"RHYTHM POLYMERS PRIVATE LIMITED",
"RHYTHM REALTY PRIVATE LIMITED",
"RHYTHMFLOWS SOLUTIONS PRIVATE LIMITED",
"RHYTHMS INDUSTRIES PRIVATE LIMITED",
"RHYTHMSOFT ROBOTICS AND AUTOMATIONS PRIVATE LIMITED",
"RHYTHMUS TECHNOLOGIES PRIVATE LIMITED",
"RI ELECTROTECH PRIVATE LIMITED",
"RI EQUATION LLP",
"RI INFOTECH PRIVATE LIMITED",
"RI NETWORKS PRIVATE LIMITED",
"RI SUITS PRIVATE LIMITED",
"RI TEXSOLUTIONS PRIVATE LIMITED",
"RIA ADVISORY LLP",
"RIA DECO-RANGE PRIVATE LIMITED",
"RIA HOSPITALITY PRIVATE LIMITED",
"RIA HOTEL PRIVATE LIMITED",
"RIA INTERNATIONAL INDIA PRIVATE LIMITED",
"RIA JEWELLERS PRIVATE LIMITED",
"RIA MONEY TRANSFER SERVICES PRIVATE LIMITED",
"RIA SHIPPING (OPC) PRIVATE LIMITED",
"RIA SUITS PRIVATE LIMITED",
"RIAAN DIAGNOSTIC PRIVATE LIMITED",
"RIAAN METALS PRIVATE LIMITED",
"RIAAN WELLNESS PRIVATE LIMITED",
"RIAFY TECHNOLOGIES PRIVATE LIMITED",
"RIALTES TECHNOLOGIES AND SOLUTION LLP",
"RIALTO CABLES PRIVATE LIMITED",
"RIALTO ENGINEERING PRIVATE LIMITED",
"RIALTO ENTERPRISES PRIVATE LIMITED",
"RIAMIN INFOTECH PRIVATE LIMITED",
"RIAMNA AGRO PRIVATE LIMITED",
"RIAN ENVIRO PRIVATE LIMITED",
"RIAN STEEL & PROFILE INDUSTRIES PRIVATE LIMITED",
"RIANA ADVISORY SERVICES PRIVATE LIMITED",
"RIANA INVESTMENTS PRIVATE LIMITED",
"RIANGDO VENEERS PRIVATE LIMITED",
"RIANSH CORPORATE PRIVATE LIMITED",
"RIANSHI DEVELOPERS PRIVATE LIMITED",
"RIAS ENTERPRISES PRIVATE LIMITED",
"RIASH RENEWABLE MATERIALS PRIVATE LIMITED",
"RIAT AUTO PVT LTD",
"RIATA LIFE SCIENCES PRIVATE LIMITED",
"RIATA ORGANICS PRIVATE LIMITED",
"RIB ITWO SOFTWARE PRIVATE LIMITED",
"RIBA BUSINESS SOLUTIONS PRIVATE LIMITED",
"RIBA MARKETING PRIVATE LIMITED",
"RIBA TEXTILES LIMITED",
"RIBAL METFAB INDIA PRIVATE LIMITED",
"RIBAND ELECTRIC PRIVATE LIMITED",
"RIBBEL INTERNATIONAL LIMITED",
"RIBBON COMMUNICATION PRIVATE LIMITED",
"RIBBON LOGISTICS (INDIA) PRIVATE LIMITED",
"RIBBSTYLE INDIA PRIVATE LIMITED",
"RIBBUN SOFTWARE PRIVATE LIMITED",
"RIBCO CONSTRUCTIONS PRIVATE LIMITED",
"RIBCON ENGINEERS PRIVATE LIMITED",
"RIBCON INDUSTRIES PRIVATE LIMITED",
"RIBEST RIBBONS AND BOWS (INDIA) PRIVATE LIMITED",
"RIBHAV EXIM PRIVATE LIMITED",
"RI-BHOI ENTERPRISE PRIVATE. LIMITED.",
"RIBIS HEALTH CARE PRIVATE LIMITED",
"RIBO INDUSTRIES PRIVATE LIMITED",
"RIBOSOME INSTITUTE PRIVATE LIMITED",
"RIC PROJECTS PRIVATE LIMITED",
"RIC STEEL PRIVATE LIMITED",
"RICAPTOS BIOCARE PRIVATE LIMITED",
"RICARDO INDIA PRIVATE LIMITED",
"RICARDO STONE PRIVATE LIMITED",
"RICAVI FINANCE LIMITED",
"RICE - LAND AGRO FOODS PRIVATE LIMITED",
"RICE INDIA EXPORTS PRIVATE LIMITED",
"RICE LAKE WEIGHING SYSTEMS INDIA LIMITED",
"RICE MILLERS GRAINS WAREHOUSE PRIVATE LIMITED",
"RICE TECH AGRO MILLS PRIVATE LIMITED",
"RICEBEE AGRO FOODS PRIVATE LIMITED",
"RICELA CHEM OILS PRIVATE LIMITED",
"RICELA HEALTH FOODS LIMITED",
"RICEMAN INDIA PRIVATE LIMITED",
"RICETEC MACHINERY PRIVATE LIMITED",
"RICH BITE HOSPITALITY PRIVATE LIMITED",
"RICH COLORS PRIVATE LIMITED",
"RICH CROP PROTECTION PRIVATE LIMITED",
"RICH CROP SCIENCE PRIVATE LIMITED",
"RICH EARTH GASTRANS PRIVATE LIMITED",
"RICH FINE ADDITIVES PRIVATE LIMITED",
"RICH HAIR AND SKIN CARE PRODUCTS PRIVATE LIMITED",
"RICH INFRA INDIA LIMITED",
"RICH INFRA REALITIES PRIVATE LIMITED",
"RICH MARK SHIPPING & LOGISTICS PRIVATE LIMITED",
"RICH MICRO-TECH PRIVATE LIMITED",
"RICH OFFSET I PRIVATE LIMITED",
"RICH PHYTOCARE PRIVATE LIMITED",
"RICH PRINTS PRIVATE LIMITED",
"RICH PRODUCTS & SOLUTIONS PRIVATE LIMITED",
"RICH SMILE DESIGN LLP",
"RICH SOYA PRODUCTS PRIVATE LIMITED",
"RICH TIMBER PRODUCTS PRIVATE LIMITED",
"RICH VALLEY DRYFRUIT PRIVATE LIMITED",
"RICH VITRIFIED PRIVATE LIMITED",
"RICHA & COMPANY",
"RICHA APPLIANCES INDIA PRIVATE LIMITED",
"RICHA CABLES PRIVATE LIMITED",
"RICHA EMBROIDERY",
"RICHA EQUIPMENTS PRIVATE LIMITED",
"RICHA FASHION PRIVATE LIMITED",
"RICHA GLOBAL EXPORTS PRIVATE LIMITED",
"RICHA HOLDINGS LIMITED",
"RICHA HOUSING PROJECTS PRIVATE LIMITED",
"RICHA INFO SYSTEMS LIMITED",
"RICHA INTERMEDIATES PRIVATE LIMITED",
"RICHA INTERNATIONAL EXPORTS PRIVATE LIMITED",
"RICHA LOOMTEX PRIVATE LIMITED",
"RICHA PARTICLE BOARD PRIVATE LIMITED",
"RICHA PROCESSING MILL PRIVATE LIMITED",
"RICHA REALTORS PRIVATE LIMITED",
"RICHA ROADLINES PRIVATE LIMITED",
"RICHA SHIPPING PRIVATE LIMITED",
"RICHACO EXPORTS PRIVATE LIMITED",
"RICHARD DESIGN SERVICES INDIA PRIVATE LIMITED",
"RICHARD ELLIS LIMITED",
"RICHARD ELLIS S.A.",
"RICHARD ENGINEERING (BOMBAY) PRIVATE LIMITED",
"RICHARD WOLF INDIA PRIVATE LIMITED",
"RICHARDS CHEMICALS AND ELECTRICALS PRIVATE LIMITED",
"RICHARDSON AND CRUDDAS (1972) LIMITED",
"RICHARDSON ELECTRONICS INDA PRIVATE LIMITED",
"RICHBIRDS ENGINEERINGS PRIVATE LIMITED",
"RICHBOND CAPITAL PRIVATE LIMITED",
"RICHCAM AUTO ENGINEERING INDIA PRIVATE LIMITED",
"RICHCOM STUDIO PRIVATE LIMITED",
"RICHCREDIT FINANCE PRIVATE LIMITED",
"RICHEMONT INDIA PRIVATE LIMITED",
"RICHENG OPTICAL ELECTRONICS PRIVATE LIMITED",
"RICHER AND BECKNER MARKETING LIMITED",
"RICHES JEWEL ARCADE LIMITED LIABILITY PARTNERSHIP",
"RICHESM HEALTHCARE LIMITED",
"RICHFEEL HEALTH AND BEAUTY PRIVATE LIMITED",
"RICHFIELD (INDIA) PHARMACEUITICALS PRIVATE LIMITED",
"RICHFIELD AUTOMATION LIMITED",
"RICHFIELD FERTILISERS PRIVATE LIMITED",
"RICHFIELD GLOBAL PRIVATE LIMITED",
"RICHFIELD IMPEXX PRIVATE LIMITED",
"RICHFIELD SEEDS PRIVATE LIMITED",
"RICHFORD ALLIANZ PRIVATE LIMITED",
"RICHI CIRCUITRONIX PRIVATE LIMITED",
"RICHIE BAGS & FASHIONS PRIVATE LIMITED",
"RICHIE'S CARGO LOGISTICS PRIVATE LIMITED",
"RICHIFIELD PACKAGING PRIVATE LIMITED",
"RICHIMEN BARTER PRIVATE LIMITED",
"RICHI-RICH BUILDPRO PRIVATE LIMITED",
"RICHIRICH FOREX PRIVATE LIMITED",
"RICHIUM INDIA PRIVATE LIMITED",
"RICHLADY CLOTHING PRIVATE LIMITED",
"RICHLIFE INTERNATIONAL PRIVATE LIMITED",
"RICHLINE FINANCE LIMITED",
"RICHLOOK COSMO PRIVATE LIMITED",
"RICHLOOK CREATIONS PRIVATE LIMITED",
"RICHLOOK FASHION PRIVATE LIMITED",
"RICHLOOK INDIA PRIVATE LIMITED",
"RICHMAN TECHNOCRATS INDIA PRIVATE LIMITED",
"RICHMAX GOLD AND JEWELLERY PRIVATE LIMITED",
"RICHMEN FOREX PRIVATE LIMITED",
"RICHMINDS DIGITAL PRIVATE LIMITED",
"RICHMOND CONCLAVE PRIVATE LIMITED",
"RICHMOND HOSPITALS PRIVATE LIMITED",
"RICHMOND INDUSTRIAL PROMOTERS PRIVATE LIMITED",
"RICHMOND LIFE SCIENCES PRIVATE LIMITED (OPC)",
"RICHMOND STUDIOS PRIVATE LIMITED",
"RICHMOND TRADERS PRIVATE LIMITED",
"RICHMOND VIVEK LABORATORIES PRIVATE LIMITED",
"RICHTER THEMIS MEDICARE INDIA PRIVATE LIMITED",
"RICHTIG TECHNOLOGY PRIVATE LIMITED",
"RICHVIB EXIM PRIVATE LIMITED",
"RICHWELL ENTERPRISES PRIVATE LIMITED",
"RICHWORLD INDUSTRIES PRIVATE LIMITED",
"RICINASH OIL MILL LIMITED",
"RICINASH RENEWABLE MATERIALS PRIVATE LIMITED",
"RICKER PHARMACEUTICALS PVT LTD",
"RICKSHAW COMMUNIQUE SERVICES PRIVATE LIMITED",
"RICKUL INDIA PRIVATE LIMITED",
"RICKY INFRACON PRIVATE LIMITED",
"RICO ALUMINIUM AND FERROUS AUTO COMPONENTS LIMITED",
"RICO APPLIANCES PRIVATE LIMITED",
"RICO AUTO INDUSTRIES LIMITED",
"RICO CASTINGS LIMITED",
"RICO FLUIDTRONICS LIMITED",
"RICO FRICTION TECHNOLOGIES LIMITED",
"RICO JINFEI WHEELS LIMITED",
"RICO WINERY PRIVATE LIMITED",
"RICOH THERMAL MEDIA ASIA PACIFIC PRIVATE LIMITED",
"RICOLENE SYNTEX P LTD",
"RICOLEX POLYMERS PRIVATE LIMITED",
"RICON AGRO CHEMICALS",
"RICON BATTERIES PRIVATE LIMITED",
"RICON TRADE COM PRIVATE LIMITED",
"RICONEX LIFECARE PRIVATE LIMITED",
"RICONPHARMA INDIA PRIVATE LIMITED",
"RICRON PANELS PRIVATE LIMITED",
"RICS INDIA PRIVATE LIMITED",
"RICT INDIA PRIVATE LIMITED",
"RIDA FRUITS PRIVATE LIMITED",
"RIDA MOTORS PRIVATE LIMITED",
"RIDAAN AND RUHAN BUILDWELL PRIVATE LIMITED",
"RIDAM IMPEX PRIVATE LIMITED",
"RIDAM JEWELLERS PRIVATE LIMITED",
"RIDC INFRA PRIVATE LIMITED",
"RIDCOR INFRA PROJECTS LIMITED",
"RIDDH PROJECTS PRIVATE LIMITED",
"RIDDHESH CORPORATION MANAWAR PRIVATE LIMITED",
"RIDDHESIDDHE RICE INDUSTRIES PRIVATE LIMITED",
"RIDDHI AGRO INDUSTRIES",
"RIDDHI AUTOWHEELS PRIVATE LIMITED",
"RIDDHI AUTOWORLD PRIVATE LIMITED",
"RIDDHI BUILDCON PRIVATE LIMITED",
"RIDDHI CASTING PRIVATE LIMITED",
"RIDDHI CORPORATE SERVICES LIMITED",
"RIDDHI CORPORATION LLP",
"RIDDHI DISPLAY EQUIPMENTS PRIVATE LIMITED",
"RIDDHI FASHION",
"RIDDHI FINTRADE PRIVATE LIMITED",
"RIDDHI INFOSYSTEM INDIA PRIVATE LIMITED",
"RIDDHI PACKAGES PRIVATE LIMITED",
"RIDDHI PHARMA MACHINERY LIMITED",
"RIDDHI PIPES & SUPPORTS PRIVATE LIMITED",
"RIDDHI PORTFOLIO PRIVATE LIMITED",
"RIDDHI PRINT AND PACK PRIVATE LIMITED",
"RIDDHI PROCESSORS PRIVATE LIMITED",
"RIDDHI SECURITIES LIMITED",
"RIDDHI SIDDHI ALUMINIUM PRIVATE LIMITED",
"RIDDHI SIDDHI ASSOCIATES",
"RIDDHI SIDDHI COTFIBER PRIVATE LIMITED",
"RIDDHI SIDDHI DEVELOPERS PVT LTD",
"RIDDHI SIDDHI ECOLOGISTICS PRIVATE LIMITED",
"RIDDHI SIDDHI EXPORTS PRIVATE LIMITED",
"RIDDHI SIDDHI FASHION PRIVATE LIMITED",
"RIDDHI SIDDHI FOOD PRODUCTS PVT.LTD.",
"RIDDHI SIDDHI FUELS PRIVATE LIMITED",
"RIDDHI SIDDHI GEMS PRIVATE LIMITED",
"RIDDHI SIDDHI HOSPITALS PRIVATE LIMITED",
"RIDDHI SIDDHI IMPORTS PRIVATE LIMITED",
"RIDDHI SIDDHI INFRAPROJECTS PRIVATE LIMITED",
"RIDDHI SIDDHI JEWELLERS PRIVATE. LIMITED.",
"RIDDHI SIDDHI MALL MANAGEMENT PRIVATE LIMITED",
"RIDDHI SIDDHI MARMO PRIVATE LIMITED",
"RIDDHI SIDDHI METALS PRIVATE LIMITED",
"RIDDHI SIDDHI NATURAL STONES PRIVATE LIMITED",
"RIDDHI SIDDHI OFFSETS PRIVATE LIMITED",
"RIDDHI SIDDHI PRINTS PRIVATE LIMITED",
"RIDDHI SIDDHI RICE MILLS PRIVATE LIMITED",
"RIDDHI SIDDHI SERVICES LIMITED",
"RIDDHI SIDDHI TEXFAB PRIVATE LIMITED",
"RIDDHI SIDDHI TEXTILE MILLS PRIVATE LIMITED",
"RIDDHI SIDDHI TILES PRIVATE LIMITED",
"RIDDHI SIDDHI WEAVING MILLS PRIVATE LIMITED",
"RIDDHI STEEL AND TUBE LIMITED",
"RIDDHI TECHAUTO INDUSTRIES PRIVATE LIMITED",
"RIDDHI TECHNOLOGIES PRIVATE LIMITED",
"RIDDHI TOYS",
"RIDDHI TRADE SOLUTIONS PRIVATE LIMITED",
"RIDDHI VINAYAK CRITICAL CARE AND MEDICAL RESEARCH CENTRE PVT LTD",
"RIDDHI VINAYAK MULTISPECIALITY HOSPITAL",
"RIDDHII VENTURE PRIVATE LIMITED",
"RIDDHIISIDDHII GRANITECH PRIVATE LIMITED",
"RIDDHIKA CREATIONS PRIVATE LIMITED",
"RIDDHIM SIDDHIM STEEL INDIA PRIVATE LIMITED",
"RIDDHIMA CONTRACTS PRIVATE LIMITED",
"RIDDHIMA STEELS PRIVATE LIMITED",
"RIDDHIMA WEAVTEX PRIVATE LIMITED",
"RIDDHI-SIDDHI COTEX PRIVATE LIMITED",
"RIDDHISIDDHI METALS B'LORE PRIVATE LIMITED",
"RIDDHYMIC TECHNOLOGIES PRIVATE LIMITED",
"RIDDISIDDHI BULLIONS LIMITED",
"RIDE AUTOMOBILES PRIVATE LIMITED",
"RIDEAU TECHNOLOGY SERVICES INDIA PRIVATE LIMITED",
"RIDEEMA TOLL BRIDGE PRIVATE LIMITED",
"RIDELANE SERVICES PRIVATE LIMITED",
"RIDENEXT SOFTWARE SOLUTIONS PRIVATE LIMITED",
"RIDEONRENT TECHNOLOGIES PRIVATE LIMITED",
"RIDEPARTNER TRAVELS INDIA PRIVATE LIMITED",
"RIDER BIKES PRIVATE LIMITED",
"RIDER FININVEST PRIVATE LIMITED",
"RIDER GLASS INDUSTRIES PRIVATE LIMITED",
"RIDER HARDWARE INDUSTRIES PRIAVTE LIMITED",
"RIDER LOGISTIC LIMITED",
"RIDER MARKETING PRIVATE LIMITED",
"RIDERS RUBBER RECLAIM PRODUCTS PRIVATE LIMITED",
"RIDGE FORMULATIONS PRIVATE LIMITED",
"RIDGE VIEW DEVELOPERS PRIVATE LIMITED",
"RIDGE WELL PROJECTS PRIVATE LIMITED",
"RIDGEANT TECHNOLOGIES PRIVATE LIMITED",
"RIDGEBACK NETWORK DEFENSE PRIVATE LIMITED",
"RIDGECRAFT HOMES PRIVATE LIMITED",
"RIDGEGAP SOLUTIONS PRIVATE LIMITED (OPC)",
"RIDGETOP DENTAL INTERNATIONAL PRIVATE LIMITED",
"RIDGE-WOOD CONSTRUCTIONS LIMITED",
"RIDGID TOOLS PRIVATE LIMITED",
"RIDHA FASHIONS",
"RIDHA METAL PRIVATE LIMITED",
"RIDHA PRINTS PRIVATE LIMITED",
"RIDHAAN HEART CARE CLINIC",
"RIDHAAN RETAIL PRIVATE LIMITED",
"RIDHAM FASHIONS PRIVATE LIMITED",
"RIDHAM SYNTHETICS PRIVATE LIMITED",
"RIDHAM TEXPORT PRIVATE LIMITED",
"RIDHDHI POLES PRIVATE LIMITED",
"RIDHI FAB DESIGNS PRIVATE LIMITED",
"RIDHI SIDHI EMPIRES PRIVATE LIMITED",
"RIDHI SIDHI ENTERPRISES PRIVATE LIMITED",
"RIDHI SIDHI GLASSES INDIA PRIVATE LIMITED",
"RIDHI SIDHI GRAIN PRODUCTS PRIVATE LIMITED",
"RIDHI SIDHI HOME DEVELOPERS PRIVATE LIMITED",
"RIDHI SIDHI HOUSING PRIVATE LIMITED",
"RIDHI SIDHI IRON PRIVATE LIMITED",
"RIDHI SIDHI MALLS AND MULTIPLEXES PRIVATE LIMITED",
"RIDHI SIDHI MANAGEMENT PRIVATE LIMITED.",
"RIDHI SIDHI MEDICARE (INDIA) PRIVATE LIMITED",
"RIDHI SIDHI MEDICOS PRIVATE LIMITED",
"RIDHI SIDHI MILLS (INDIA) PRIVATE LIMITED",
"RIDHI SIDHI PROVISIONS PRIVATE LIMITED",
"RIDHI SIDHI SHARES PRIVATE LIMITED",
"RIDHI SIDHI STEEL AND STRIPS MANUFACTURING PVT LTD",
"RIDHI SIDHI TOBACCO PRIVATE LIMITED",
"RIDHI TEA COMPANY PRIVATE LIMITED",
"RIDHIMA FUELS PRIVATE LIMITED",
"RIDHIMA MINING PRIVATE LIMITED",
"RIDHIRAJ BUILDESTATE PRIVATE LIMITED",
"RIDHIRAJ BUILDMART PRIVATE LIMITED",
"RIDHISIDHI FINCON PRIVATE LIMITED.",
"RIDHISIDHI LOGISTICS PRIVATE LIMITED",
"RIDHISIDHI NIRMAN INDIA PRIVATE LIMITED",
"RIDHISIDHI TECHNO SOLUTION PRIVATE LIMITED",
"RIDHISIDHI TRADE AND SERVICES PRIVATE LIMITED",
"RIDIK CONSULTING PRIVATE LIMITED",
"RIDIK GRAD PRIVATE LIMITED",
"RIDING HOUSE INFOTECH PRIVATE LIMITED",
"RIDINGS CONSULTING ENGINEERS INDIA LIMITED",
"RIDINGS CONSULTING ENGINEERS INDIA PRIVATE LIMITED",
"RIDIT FOREX PRIVATE LIMITED",
"RIDON ENGINEERING PRIVATE LIMITED",
"RIDRA EXPORT PRIVATE LIMITED",
"RIDVIL AUTO INDIA PRIVATE LIMITED",
"RIECH HOSPITALITY SERVICES PRIVATE LIMITED",
"RIECO INDUSTRIES LIMITED",
"RIEDE TECHNOLOGY PRIVATE LIMITED",
"RIEET TECHNO SOLUTIONS PRIVATE LIMITED",
"RIEKE GLOBAL INNOVATION CENTER INDIA P LIMITED",
"RIEKE PACKAGING INDIA PRIVATE LIMITED",
"RIELLO POWER INDIA PRIVATE LIMITED",
"RIEMANN LABS PRIVATE LIMITED",
"RIEMEN SOLUTION PRIVATE LIMITED",
"RIETER INDIA PRIVATE LIMITED",
"RIF & RYAN (OPC) PRIVATE LIMITED",
"RIFA FOREX AND TRAVELS PRIVATE LIMITED",
"RIFA SAFETY PRIVATE LIMITED",
"RIFLE FACTORY ISHAPORE",
"RIFLEX INDUSTRIES PRIVATE LIMITED",
"RIFLUXYSS SOFTWARES PRIVATE LIMITED",
"RIFT INDUSTRIES & ENGINEERING PRIVATE LIMITED",
"RIG CONSULTANTS PRIVATE LIMITED",
"RIG EDUCATION FOUNDATION",
"RIG ENTERPRISE APPLICATIONS PRIVATE LIMITED",
"RIG INFORMATICS PRIVATE LIMITED",
"RIGA CERAMICA PRIVATE LIMITED",
"RIGA FOODS LLP",
"RIGAA CLOTHINGS PRIVATE LIMITED",
"RIGBOT SOLUTIONS PRIVATE LIMITED",
"RIGEL INDIA PRIVATE LIMITED",
"RIGEL INFORMATION SYSTEMS PRIVATE LIMITED",
"RIGEL MARINE SERVICES PRIVATE LIMITED",
"RIGEL NETWORKS PRIVATE LIMITED",
"RIGEL TRADING PRIVATE LIMITED",
"RIGEN PACKAGING PRIVATE LIMITED",
"RIGHILL ELECTRICS PRIVATE. LIMITED.",
"RIGHT ADVISORS PRIVATE LIMITED",
"RIGHT ALIGNED SOLUTIONS PRIVATE LIMITED",
"RIGHT ANGLE MANAGEMENT SERVICES PRIVATE LIMITED",
"RIGHT AVENUE INFOTECH PRIVATE LIMITED",
"RIGHT AXIS EYE HOSPITAL PRIVATE LIMITED",
"RIGHT CHANNEL CONSTRUCTIONS PRIVATE LIMITED",
"RIGHT CHOICE ENGINEERING SERVICES",
"RIGHT CHOICE FINANCIAL SERVICES LIMITED",
"RIGHT CHOICE TEXTILES PVT. LTD.",
"RIGHT CONCEPTS ADVERTISING PRIVATE LIMITED",
"RIGHT CORRUPACK PRIVATE LIMITED",
"RIGHT CURVE CONSULTING PRIVATE LIMITED",
"RIGHT DEBT MANAGEMENT SERVICES PRIVATE LIMITED",
"RIGHT ELITE RETAIL PRIVATE LIMITED",
"RIGHT FABRICATORS PRIVATE LIMITED",
"RIGHT FLORIST PRIVATE LIMITED",
"RIGHT GLASS AND PLY PRIVATE LIMITED",
"RIGHT GUARD RUBBUR PRIVATE LIMITED",
"RIGHT HEALTH PLATTER PRIVATE LIMITED",
"RIGHT HERBAL PRIVATE LIMITED",
"RIGHT HORIZONS FINANCIAL SERVICES PRIVATE LIMITED",
"RIGHT HORIZONS PORTFOLIO MANAGEMENT PRIVATE LIMITED",
"RIGHT HOSPITALS PRIVATE LIMITED",
"RIGHT INTERIOR SOLUTIONS PRIVATE. LIMITED",
"RIGHT LOGISTICS PRIVATE LIMITED",
"RIGHT MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"RIGHT MANAGEMENT INDIA PRIVATE LIMITED",
"RIGHT MERIDIAN PACIFIC CAPITAL LIMITED",
"RIGHT MF INVESTMENT PRIVATE LIMITED",
"RIGHT MOVE SECURITY SERVICES PRIVATE LIMITED",
"RIGHT MOVE STAFFING SOLUTIONS PRIVATE LIMITED",
"RIGHT PACE TECHMEDIA PRIVATE LIMITED",
"RIGHT POINT INFRASTRUCTURE PRIVATE LIMITED",
"RIGHT POWER SOLUTIONS PRIVATE LIMITED",
"RIGHT REACH TRAINING PRIVATE LIMITED",
"RIGHT REFRACTORIES PRIVATE LIMITED",
"RIGHT SELECTION MARBLE INDIA PRIVATE LIMITED",
"RIGHT SHOPPING PRIVATE LIMITED",
"RIGHT SOLDIER SECURITY SOLUTIONS PRIVATE LIMITED",
"RIGHT SOURCING SOLUTIONS INDIA PRIVATE LIMITED",
"RIGHT SPOT MEDIA SOLUTIONS PRIVATE LIMITED",
"RIGHT STEPS BUSINESS SOLUTIONS PRIVATE LIMITED",
"RIGHT TIGHT FASTNERS PRIVATE LIMITED",
"RIGHT TIME CONSULTANCY SERVICES PRIVATE LIMITED",
"RIGHT WAY LOGISTICS PRIVATE LIMITED",
"RIGHT2VOTE INFOTECH PRIVATE LIMITED",
"RIGHTADS COMMUNICATIONS PRIVATE LIMITED",
"RIGHTALIGNED RETAIL PRIVATE LIMITED",
"RIGHTAVENUE INFOTECH PRIVATE LIMITED",
"RIGHTDATA LABS PRIVATE LIMITED",
"RIGHTECH ENGINEERING PRIVATE LIMITED",
"RIGHTEX COMMERCE PVT. LTD.",
"RIGHT-FIT FASTNERS PVT LTD",
"RIGHTFOCUS INVESTMENTS PRIVATE LIMITED",
"RIGHTFUL LABS PRIVATE LIMITED",
"RIGHTKEY SOLUTIONS PRIVATE LIMITED",
"RIGHTMATCH HR SERVICES PRIVATE LIMITED",
"RIGHTMOVE TECHNOLOGIES PRIVATE LIMITED",
"RIGHTPOINT INDIA DIGITAL PRIVATE LIMITED",
"RIGHTSOL PRIVATE LIMITED",
"RIGHTSOURCE TECHNOLOGIES PRIVATE LIMITED",
"RIGHTSQUAD OUTSOURCE SOLUTIONS (OPC) PRIVATE LIMITED",
"RIGHTTAXMATE INDIA PRIVATE LIMITED",
"RIGHTVISION ASSOCIATES PRIVATE LIMITED",
"RIGHTVISION MULTITRADE PRIVATE LIMITED",
"RIGHTWALK FOUNDATION",
"RIGHTWATTS SOLUTIONS PRIVATE LIMITED",
"RIGHTWAVE INFOSOLUTIONS PRIVATE LIMITED",
"RIGHTWAY FEEDS PRIVATE LIMITED",
"RIGHTWAY LOGISTIC SOLUTION PRIVATE LIMITED",
"RIGHTWAYS AIR LOGISTICS PRIVATE LIMITED",
"RIGHTWAYS CONTAINER TRANSPORT PRIVATE LIMITED",
"RIGHTWAYS CORPORATION PRIVATE LIMITED",
"RIGHTWAYS EXIM PRIVATE LIMITED",
"RIGI CUT TOOLS PRIVATE LIMITED",
"RIGIBORE INDIA PRIVATE LIMITED",
"RIGID CONTROLS PRIVATE LIMITED",
"LIFELINE MULTI SPECIALITY HOSPITALS PRIVATE LIMITED",
"RIGIDFAB ENGINEERS INDIA PRIVATE LIMITED",
"RIGIL BIOTECH PRIVATE LIMITED",
"RIGIL TECHNO INDIA PRIVATE LIMITED",
"RIGIL-GENY INDIA PRIVATE LIMITED",
"RIGITEC PRIVATE LIMITED",
"RIGTCOM GEO SERVICES LLP",
"RIGVED TECHNOLOGIES PRIVATE LIMITED",
"RIHAAN PACKAGING PRIVATE LIMITED",
"RIHITA CARGO FORWARDERS PRIVATE LIMITED",
"RIHTING COATING TECHNOLOGY (INDIA) PRIVATE LIMITED",
"RIHU SOFTWARE CONSULTING PRIVATE LIMITED",
"RIICH AIR COOLING PRIVATE LIMITED",
"RIIS INDIA IT SOLUTIONS PRIVATE LIMITED",
"RIJ ENGINEERING PRIVATE LIMITED",
"RIJK ZWAAN INDIA SEEDS PRIVATE LIMITED",
"RIK RUK ASSOCIATES",
"RIK TECHNOLOGIES INDIA PRIVATE LIMITED",
"RIKA GLOBAL IMPEX LIMITED",
"RIKAIAN TECHNOLOGY PRIVATE LIMITED",
"RIKAS TELECOM & DISTRIBUTION PRIVATE LIMITED",
"RIKAYAA ENTERPRISES PRIVATE LIMITED",
"RIKEN TECHNOS INDIA PRIVATE LIMITED",
"RIKEVITA (INDIA) PRIVATE LIMITED",
"RIKHABCHAND SOHANLALL LTD",
"RIKHABDAS GULABCHAND FABRICS PRIVATE LIMITED",
"RIKHAV BPO & SOFTWARE SERVICES PRIVATE LIMITED",
"RIKHAV SECURITIES LIMITED",
"RIKI GLOBAL TRADING PRIVATE LIMITED",
"RIKILON ENGINEERING PRIVATE LIMITED",
"RIKKI PLASTIC PRIVATE LIMITED",
"RIKKI RONIE DEVELOPER",
"RIKON MARKETING PRIVATE LIMITED",
"RIKOOUU HEALTHCARE PRIVATE LIMITED",
"RIKROLL INDIA PRIVATE LIMITED",
"RIKTA HOTEL AND RESTAURANT PRIVATE LIMITED",
"RIKTAM TECHNOLOGY CONSULTING PRIVATE LIMITED",
"RIKUN MANUFACTURING PRIVATE LIMITED",
"RIKVIN BIOTECH PRIVATE LIMITED",
"RIKZEN CONTRA PVT LTD",
"RILIEVI INDIA PRIVATE LIMITED",
"RILISONS IMPEX PRIVATE LIMITED",
"RIM PROJECTS PRIVATE LIMITED",
"RIMA BEACH WORLD PRIVATE LIMITED",
"RIMA MACHINES PRIVATE LIMITED",
"RIMARI INDIA PRIVATE LIMITED",
"RIMART INTERNATIONAL PRIVATE LIMITED",
"RIME HEALTHCARE LIMITED",
"RIME RICH FOODS PRIVATE LIMITED",
"RIMEDO ADVISOR PRIVATE LIMITED",
"RIMHA HOSPITALITY PRIVATE LIMITED",
"RIMHUB INDIA PRIVATE LIMITED",
"RIMINI STREET INDIA OPERATIONS PRIVATE LIMITED",
"RIMJHIM COLONIZERS PRIVATE LIMITED",
"RIMJHIM ISPAT LIMITED",
"RIMJHIM PROPERTIES PVT LTD",
"RIMJHIM STAINLESS LIMITED",
"RIMMI TRAVELS PRIVATE LIMITED",
"RIMMY STEELS PRIVATE LIMITED",
"RIMO STEEL REFORMS PRIVATE LIMITED",
"RIMS BIZZSERVE PRIVATE LIMITED",
"RIMS INDIA PRIVATE LIMITED",
"RIMS MANPOWER SOLUTIONS INDIA PRIVATE LIMITED",
"RIMSHA BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"RIMTEL TELECOM EQUIPMENTS PRIVATE LIMITED",
"RIMTEX ENGINEERING PRIVATE LIMITED",
"RIMUS TECHNOLOGIES PRIVATE LIMITED",
"RINA CONSULTING PRIVATE LIMITED",
"RINA CONSULTING SPA",
"RINA INDIA PRIVATE LIMITED",
"RINAC INDIA LIMITED",
"RINAC INSULATIONS PRIVATE LIMITED",
"RINCO ULTRASONICS INDIA PRIVATE LIMITED",
"RINCON REALTY PRIVATE LIMITED",
"RINDER AGROTECH PRIVATE LIMITED",
"RINDEX MEDIA PRIVATE LIMITED",
"RINDZ PHARMA PRIVATE LIMITED",
"RINE ENGINEERING PRIVATE LIMITED",
"RINEILE MICRO FABRICS PRIVATE LIMITED",
"RINESH ENTERPRISE PRIVATE LIMITED",
"RINEUS HEALTH CARE COMPANY PRIVATE LIMITED",
"RING FORGINGS PRIVATE LIMITED",
"RING PLUS AQUA LIMITED",
"RING ROAD MOTORS PRIVATE LIMITED",
"RINGCENTRAL INDIA PRIVATE LIMITED",
"RINGFEDER POWER TRANSMISSION INDIA PRIVATE LIMITED",
"RINGLUS ELECTRO CONTROLS AND AUTOMATION PRIVATE LIMITED",
"RINGMEN INVESTMENTANDFINANCE COMPANY PVT LTD",
"RINGO FOODS & BEVERAGES PVT. LTD.",
"RINGSPANN POWER TRANSMISSION INDIA PRIVATE LIMITED",
"RINGTONG TEA CO PVT LTD",
"RINI LIFE SCIENCE PRIVATE LIMITED",
"RINIRA TECHNOLOGIES PRIVATE LIMITED",
"RINITA METALIKS PRIVATE LIMITED",
"RINIVA MARKETING PRIVATE LIMITED",
"RINJAPAR VADI PRIMARY SCHOOL 3",
"RINKI FOOD PRODUCTS PVT. LTD",
"RINKIE EYE HOSPITAL",
"RINKOO APPAREL PRIVATE LIMITED",
"RINKU COMMERCIAL CARRIER PRIVATE LIMITED",
"RINKY FASHIONS PVT LTD",
"RINL STEELS PRIVATE LIMITED",
"RINOX KAUFMANN LIMITED",
"RINSE N.PURE SURFACTANTS PRIVATE LIMITED",
"RINSETOP TEX PRIVATE LIMITED",
"RINSOFT PRIVATE LIMITED",
"RINU SYNTEX PRIVATE LIMITED",
"RINZAI ENGINEERING PRIVATE LIMITED",
"RIO AARMAN HARDWARE PRIVATE LIMITED",
"RIO CERAMIC PRIVATE LIMITED",
"RIO CHILDREN'S HOSPITAL PRIVATE LIMITED",
"RIO CLAYS PRIVATE LIMITED",
"RIO DATA TECH PRIVATE LIMITED",
"RIO DIGITAL LENSES PRIVATE LIMITED",
"RIO ENGINEERING INDIA PRIVATE LIMITED",
"RIO GLASS PRIVATE LIMITED",
"RIO HEIGHTS PRIVATE LIMITED",
"RIO INNOBEV PRIVATE LIMITED",
"RIO LUXURY HOMES PRIVATE LIMITED",
"RIO MACHINE TOOLS PRIVATE LIMITED",
"RIO MERIDIAN HOTELS PRIVATE LIMITED",
"RIO SALES ENTERPRISES PRIVATE LIMITED",
"RIO SIGNAGES PRIVATE LIMITED",
"RIO TINTO INDIA PRIVATE LIMITED",
"RIOCARE INDIA PRIVATE LIMITED",
"RIOCONN INTERACTIVE PRIVATE LIMITED",
"RIOGRAND TRADING PRIVATE LIMITED",
"RIOMED TECHNOLOGIES INDIA PRIVATE LIMITED",
"RIOMEDICA HEALTHCARE PRIVATE LIMITED",
"RION INFRASOLUTIONS PRIVATE LIMITED",
"RION LIFESCIENCES PRIVATE LIMITED",
"RION REFOIL PRIVATE LIMITED",
"RIONA LAMINATES PRIVATE LIMITED",
"RIONS INDIA BIOTECH SOLUTIONS PRIVATE LIMITED",
"RIOT LABZ PRIVATE LIMITED",
"RIOTA PRIVATE LIMITED",
"RIP ENTERPRISE PRIVATE LIMITED",
"RIPCA PRIVATE LIMITED",
"RIPCO TRADERS PRIVATE LIMITED",
"RIPE ACCOUNTANCY SERVICES PRIVATE LIMITED",
"RIPENAPPS TECHNOLOGIES PRIVATE LIMITED",
"RIPHARMA LABORATORIES LIMITED",
"RIP-IT SOLUTIONS PRIVATE LIMITED",
"RIPL TECHNOLOGIES PRIVATE LIMITED",
"RIPLEY & COMPANY LIMITED",
"RIPLEY & COMPANY STEVEDORING & HANDLING PVT LTD",
"RIPLEY NORTHERN DREDGING PRIVATE LIMITED",
"RIPON ESTATES LTD.",
"RIPPING IT SERVICES OPC PRIVATE LIMITED",
"RIPPLE FRAGRANCES PRIVATE LIMITED",
"RIPPLE INFRA SYSTEMS PRIVATE LIMITED",
"RIPPLE TECHCNOLOGIES LIMITED",
"RIPPLELINKS MEDIA PRIVATE LIMITED",
"RIPPLES ENGINEERING PRIVATE LIMITED",
"RIPPLEWAVE SOLUTIONS PRIVATE LIMITED",
"RIPSIL DIGITAL SERVICES PRIVATE LIMITED",
"RIPUHARA AGRO PRIVATE LIMITED",
"RIPUL INTERNATIONAL LIMITED",
"RIPURAJ AGRO PRIVATE LIMITED",
"RIQO FOODS PRIVATE LIMITED",
"RIQUEZA CAPITAL ADVISORY SERVICES PRIVATE LIMITED",
"RIQUEZA ESTATES PRIVATE LIMITED",
"RIQUEZA TRADE INDIA PRIVATE LIMITED",
"RIR CERTIFICATION PRIVATE LIMITED",
"RIRA E-VEHICLES PRIVATE LIMITED",
"RIRANSA INC. HEALTHCARE LIMITED",
"RISA HOSPITALITY PRIVATE LIMITED",
"RISA SECURITIES PRIVATE LIMITED",
"RISALI INSTITUTE OF MANAGEMENT",
"RISANSI INDUSTRIES LIMITED",
"RISE ADVERTISING PRIVATE LIMITED",
"RISE AGRO INFRA PRIVATE LIMITED",
"RISE AND SHINE TECH SOLUTIONS PRIVATE LIMITED",
"RISE AND SHINE TRADE LINKS PRIVATE LIMITED",
"RISE APPLIANCES PRIVATE LIMITED",
"RISE AUTO PRIVATE LIMITED",
"RISE DEVELOPMENT ACADEMY PRIVATE LIMITED",
"RISE EARN SERVICES PRIVATE LIMITED",
"RISE ELEVEN CONCRETE PRODUCTS PRIVATE LIMITED",
"RISE ELEVEN CONCRETE SOLUTIONS PRIVATE LIMITED",
"RISE ELEVEN READYMIX PRIVATE LIMITED",
"RISE HOSPITALS PRIVATE LIMITED",
"RISE INDIA LOGISTICS PRIVATE LIMITED",
"RISE INDIA SOLUTIONS PRIVATE LIMITED",
"RISE INFRAVENTURES LIMITED",
"RISE KRISHNA SAI PRAKASAM GROUP OF INSTITUTIONS",
"RISE N SHINE BIOTECH PRIVATE IMITED",
"RISE N SHINE LALITHA AGRI UDYOG LLP",
"RISE ON GROUP",
"RISE PACKERS PRIVATE. LIMITED.",
"RISE PROJECTS PRIVATE LIMITED",
"RISE RENEWABLES PRIVATE LIMITED",
"RISE SPARES PRIVATE LIMITED",
"RISE STAFFING GROUP",
"RISE TECH SOFTWARE PRIVATE LIMITED",
"RISEE INFINITY PRIVATE LIMITED",
"RISEIN TECH PRIVATE LIMITED",
"RISELANCE SALES & SERVICES PRIVATE LIMITED",
"RISEOM SOLUTIONS PRIVATE LIMITED",
"RISEPRO LOGISTICS PRIVATE LIMITED",
"RISER MAINTENANCE SOLUTIONS PRIVATE LIMITED",
"RISESMART HR SERVICES PRIVATE LIMITED",
"RISETIME SEMICONDUCTOR OPC PRIVATE LIMITED",
"RISEUP ACADEMY",
"RISHA CONTROL ENGINEERS PRIVATE LIMITED",
"RISHAAN HOSPITAL",
"RISHAB APPAREL PRIVATE LIMITED",
"RISHAB COTSPIN PRIVATE LIMITED",
"RISHAB EMBROIDERIES PRIVATE LIMITED",
"RISHAB EXPORTS LIMITED",
"RISHAB FARMS AND INDUSTRIES PRIVATE LIMITED TFR. FROM HARYANA TO DELHI",
"RISHAB GLOBAL INDUSTRIES PRIVATE LIMITED",
"RISHAB HOSPITAL",
"RISHAB HOTEL AND RESTAURANT SERVICE PRIVATE LIMITED",
"RISHAB MOTOR SALES PRIVATE LIMITED",
"RISHAB OIL RECLAIMATION PRIVATE LIMITED",
"RISHAB STAR LOGISTIC PRIVATE LIMITED",
"RISHAB THREADS PRIVATE LIMITED",
"RISHAB WORLD PRIVATE LIMITED",
"RISHABDEO CREATIONS PRIVATE LIMITED",
"RISHABDEV STONEX INDIA PRIVATE LIMITED",
"RISHABGLOBAL INDUSTRIES PRIVATE LIMITED",
"RISHABH ABUSHAN PRIVATE LIMITED",
"RISHABH AGROTECH (INDIA) PRIVATE LIMITED",
"RISHABH ASSOCIATES",
"RISHABH BOX INDUSTRIES PRIVATE LIMITED",
"RISHABH BUILDTECH INDIA PRIVATE LIMITED",
"RISHABH BUILDWELL PRIVATE LIMITED",
"RISHABH CABLES AND ELECTRICALS PRIVATE LIMITED",
"RISHABH CARS INDIA PRIVATE LIMITED",
"RISHABH COLOURS PRIVATE LIMITED",
"RISHABH CONSTRUCTIONS PRIVATE LIMITED",
"RISHABH COTTEX PRIVATE LIMITED",
"RISHABH DIAMOND PRIVATE LIMITED",
"RISHABH ELECTRICALS PRIVATE LIMITED",
"RISHABH ENTERPRISES HVAC&R PRIVATE LIMITED",
"RISHABH FOAM PRIVATE LIMITED",
"RISHABH FOURWHEELS PVT LTD",
"RISHABH GEMS & JEWELLERS PRIVATE LIMITED",
"RISHABH GOLD JEWELS INDIA PRIVATE LIMITED",
"RISHABH HOUSEWARE PRIVATE LIMITED",
"RISHABH INFOPARK PRIVATE LIMITED",
"RISHABH INFRASTRUCTURE PRIVATE LIMITED",
"RISHABH INSTRUMENTS LIMITED",
"RISHABH INSTRUMENTS PRIVATE LIMITED",
"RISHABH INSURANCE BROKERS PRIVATE LIMITED",
"RISHABH INTEGRATED LOGISTICS PRIVATE LIMITED",
"RISHABH JUTEX PVT LTD",
"RISHABH MAVERICK IMPEX PRIVATE LIMITED",
"RISHABH METALS & CHEMICALS PRIVATE LIMITED",
"RISHABH MICRO PRECISION COMPONENTS PRIVATE LIMITED",
"RISHABH NATURAL STONE PRIVATE LIMITED",
"RISHABH ORNAMENTS PRIVATE LIMITED",
"RISHABH PHARMACEUTICALS PRIVATE LIMITED",
"RISHABH PLASTIC PRODUCTS LLP",
"RISHABH RENERGY PRIVATE LIMITED",
"RISHABH RENEWABLE RENERGY PRIVATE LIMITED",
"RISHABH SERVICES PRIVATE LIMITED",
"RISHABH SOFTWARE PRIVATE LIMITED",
"RISHABH SPONGE LIMITED",
"RISHABH TECHNOCAST PRIVATE LIMITED",
"RISHABH TELELINK INFRACON PRIVATE LIMITED",
"RISHABH TEXCO PRIVATE LIMITED",
"RISHABHRAJ GOLD & FOREX PRIVATE LIMITED",
"RISHABHSAGAR TEXTILE EQUIPMENTS PRIVATE LIMITED",
"RISHABRAJ ESTATE DEVELOPERS PRIVATE LIMITED",
"RISHABRAJ TOUGHCONS CITY HOMES PRIVATE LIMITED",
"RISHACON CONSTRUCTION PRIVATE LIMITED",
"RISHAN ENTERPRISES PRIVATE LIMITED",
"RISHAN SECURITIES PRIVATE LIMITED",
"RISHAV COMMERCIAL COMPANY PVT LTD",
"RISHAV EMBROIDERY PRIVATE LIMITED",
"RISHAV IRON & STEEL PRIVATE LIMITED",
"RISHAV UTILITIES SERVICES PRIVATE LIMITED",
"RISHAV VYAPAAR PRIVATE LIMITED",
"RISHI AND SOUJIT COUTURE PRIVATE LIMITED",
"RISHI AUTO SALES PRIVATE LIMITED",
"RISHI BAKERS PRIVATE LIMITED",
"RISHI BANKIM CHANDRA EVENING COLLEGE",
"RISHI BUILDERS (INDIA) PRIVATE LIMITED",
"RISHI CARBONICS PRIVATE LIMITED",
"RISHI CAST PRIVATE LIMITED",
"RISHI CHEMICAL WORKS PVT LTD",
"RISHI COLONISERS PRIVATE LIMITED",
"RISHI CONSFAB PRIVATE LIMITED",
"RISHI CROP SCIENCE PRIVATE LIMITED",
"RISHI DAYARAM & SETH HASSARAM NATIONAL COLLEGE & SETH W A SCIENCE COLLEGE",
"RISHI ELEVATORS",
"RISHI ENGINEERING COMPANY PRIVATE LIMITED",
"RISHI FABRICS LIMITED",
"RISHI FIBC SOLUTIONS PRIVATE LIMITED",
"RISHI FIBERS PRIVATE LIMITED",
"RISHI GANGA NIDHI LIMITED",
"RISHI GLOBAL EXIM PRIVATE LIMITED",
"RISHI GOLD AND DIAMOND JEWELS (INDIA) PRIVATE LIMITED",
"RISHI GRAPHICS PVT LTD",
"RISHI HOSPITAL & DIAGNOSTIC CENTRES PRIVATE LIMITED",
"RISHI HYBRID SEEDS PRIVATE LIMITED",
"RISHI ICE AND COLD STORAGE PRIVATE LIMITED",
"RISHI INFRATECH PRIVATE LIMITED",
"RISHI KESHAV TECH PRIVATE LIMITED",
"RISHI KIRAN LOGISTICS PRIVATE LIMITED",
"RISHI KIRAN TERMINALS PRIVATE LIMITED",
"RISHI LOTTERY AGENCY PRIVATE LIMITED",
"RISHI MANSUKHANI PORT AND INFRASTRUCTURE PRIVATE LIMITED",
"RISHI MOHAN REALTY PRIVATE LIMITED",
"RISHI NARAIN GOLF MANAGEMENT PRIVATE LIMITED",
"RISHI POLY MACH PRIVATE LIMITED",
"RISHI POLYMERS PRIVATE LIMITED",
"RISHI PRINTING PRIVATE LIMITED",
"RISHI RAJ CONSTRUCTION",
"RISHI RAJ MANAGEMENT SERVICES PRIVATE LIMITED",
"RISHI SAFETEX PRIVATE LIMITED",
"RISHI SEALS PRIVATE LIMITED",
"RISHI SHIPPING INDIA PRIVATE LIMITED",
"RISHI SRI VIDYANIKETHANA SCHOOL",
"RISHI TECHTEX LIMITED",
"RISHI TRACTORS PRIVATE LIMITED",
"RISHI VASTRA VYAPAR PRIVATE LIMITED",
"RISHI VIDYA EDUCATIONAL FOUNDATION",
"RISHI VIDYA EDUCATIONAL SCHOOL",
"RISHICHEM DISTRIBUTORS PRIVATE LIMITED",
"RISHIGA ENGINEERING TECHNOLOGIES PRIVATE LIMITED",
"RISHIGANGA FINANCE LIMITED",
"RISHIHOOD UNIVERSITY",
"RISHIINDIA INFRAENGINEERING PRIVATE LIMITED",
"RISHIK COMMODEAL PRIVATE LIMITED",
"RISHIK SPINNING PRIVATE LIMITED",
"RISHIKA FASHIONS PRIVATE LIMITED",
"RISHIKA INDUSTRIES LIMITED",
"RISHIKA INTERIOR AND DEVELOPER PRIVATE LIMITED",
"RISHIKA TRADING PRIVATE LIMITED",
"RISHIKESH FILAMENTS PRIVATE LIMITED",
"RISHIKESH METALS INDIA PRIVATE LIMITED",
"RISHIKESH MOTORS PRIVATE LIMITED",
"RISHIKESH WASTE MANAGEMENT LIMITED",
"RISHIKIRTI TECHNOLOGIES PRIVATE LIMITED",
"RISHIKRISHNA BUILDERS PRIVATE LIMITED",
"RISHIKUL MAHAVIDYALAYA",
"RISHIRAJ DEVELOPERS PRIVATE LIMITED",
"RISHIRAJ EDUCATION FOUNDATION",
"RISHIRAJ MEDIA PRIVATE LIMITED",
"RISHIROOP CHEMICAL CO PVT LTD",
"RISHIROOP HOLDING PVT LTD",
"RISHIROOP INVESTMENTS AND TRADING COMPANY PRIVATE LIMITED",
"RISHIROOP LIMITED",
"RISHIROOP POLYMERS PRIVATE LIMITED",
"RISHISHWAR LOGISTICS PRIVATE LIMITED",
"RISHIT BUNK MAKERS PRIVATE LIMITED",
"RISHIT ENTERPRISES PRIVATE LIMITED",
"RISHITA BHAWAN NIRMAN PRIVATE LIMITED",
"RISHITA DEVELOPERS PRIVATE LIMITED",
"RISHITADITYA EXIM PRIVATE LIMITED",
"RISHITATVA CERAMICS PRIVATE LIMITED",
"RISHITEX ENGINEERING INDIA PRIVATE LIMITED",
"RISHLEN HEALTHCARE PRIVATE LIMITED",
"RISHON COMMUNICATION TECHNOLOGIES PRIVATE LIMITED",
"RISHON VENTURES PRIVATE LIMITED",
"RISHONN & REYANSH PRIVATE LIMITED",
"RISHRA INVESTMENTS LTD",
"RISHRIT ADVISORY PRIVATE LIMITED",
"RISHS EDUCATIONAL FOUNDATION",
"RISHS INTERNATIONAL SCHOOL",
"RISHTA APPARELS PRIVATE LIMITED",
"RISHTA CAPITAL PRIVATE LIMITED",
"RISHTA FOOD PRODUCTS EAST LLP",
"RISHTA POLYMER INDUSTRIES PRIVATE LIMITED",
"RISHU CONSTRUCTION INFRATECH INDIA PRIVATE LIMITED",
"RISHU KICHU INDUSTRIES PRIVATE LIMITED",
"RISHU TEXTILES PRIVATE LIMITED",
"RISHVANTHI TECHNOLOGIES PRIVATE LIMITED",
"RISHWA ENGINEERING AND RENTALS PRIVATE LIMITED",
"RISI FINSTOCK PRIVATE LIMITED",
"RISI SPICE INDUSTRIES PRIVATE LIMITED",
"RISIGA AGRO (INDIA) PRIVATE LIMITED",
"RISIN EXIM PRIVATE LIMITED",
"RISING ADVISORY SERVICES PRIVATE LIMITED",
"RISING ASSOCIATES",
"RISING BHADLA 1 PRIVATE LIMITED",
"RISING BHADLA 2 PRIVATE LIMITED",
"RISING BIOGENETICS PRIVATE LIMITED",
"RISING BUILDTECH PRIVATE LIMITED",
"RISING CASTECH PRIVATE LIMITED",
"RISING DAWN INDIA PRIVATE LIMITED",
"RISING EASTERN GLOBAL MERCHANDISING PRIVATE LIMITED",
"RISING EDGE AUTOMATION PRIVATE LIMITED",
"RISING GENSET INDIA PRIVATE LIMITED",
"RISING MARKETING PRIVATE LIMITED",
"RISING NORTHSTAR TECHNOLOGIES AND SOLUTIONS PRIVATE LIMITED",
"RISING PROJECTS INDIA PRIVATE LIMITED",
"RISING STAR AGRO PVT.LTD.",
"RISING STAR COSMETICS PRIVATE LIMITED",
"RISING STAR EXIM PRIVATE LIMITED",
"RISING STAR OUTREACH OF INDIA",
"RISING STAR PUBLIC SCHOOL",
"RISING STARS MOBILE INDIA PRIVATE LIMITED",
"RISING SUN CHEMICAL SOLUTIONS PRIVATE LIMITED",
"RISING SUN DIE CASTINGS PRIVATE LIMITED",
"RISING SUN ENERGY PRIVATE LIMITED",
"RISING SUN EXPORTS PRIVATE LIMITED",
"RISING SUN FILMS PRIVATE LIMITED",
"RISING SUN HOLDINGS PVT LTD",
"RISING SUN PACKAGING INDIA PRIVATE LIMITED",
"RISING SUN POWER PRIVATE LIMITED",
"RISING SUN PROPERTIES LLP",
"RISING SUN SEEDS PRIVATE LIMITED",
"RISING SUN WORLD SCHOOL",
"RISING TECHNOSOFT PRIVATE LIMITED",
"RISING TECHSERV INDIA PRIVATE LIMITED",
"RISING TIDE EDUCATION INDIA PRIVATE LIMITED",
"RISING TRACOM PRIVATE LIMITED",
"RISINGSTAR MULTISOLUTION PRIVATE LIMITED",
"RISIVEDA HERBAL PRODUCTS PRIVATE LIMITED",
"RISK CARE INSURANCE BROKING SERVICES PRIVATE LIMITED",
"RISK EDUCATORS PRIVATE LIMITED",
"RISK QUOTIENT CONSULTANCY PRIVATE LIMITED",
"RISKBERG CONSULTING PRIVATE LIMITED",
"RISKILLA SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"RISKINSIGHT CONSULTING PRIVATE LIMITED",
"RISKONNECT SERVICES PRIVATE LIMITED",
"RISKSPAN INDIA PRIVATE LIMITED",
"RISMEN POLYMERS PRIVATE LIMITED",
"RISO INDIA PRIVATE LIMITED",
"RISORSA EXIM PRIVATE LIMITED",
"RISOSU TECHNOLOGY PRIVATE LIMITED",
"RISSALA DECOR PRIVATE LIMITED",
"RISSALA ELECTRIC MOTORS LIMITED",
"RISSHTA FOODS PRIVATE LIMITED",
"RISTAR SURVEYORS AND ASSESSORS PRIVATE LIMITED",
"RISTO INTERNATIONAL PRIVATE LIMITED",
"RISUS VENTURES (OPC) PRIVATE LIMITED",
"RISVA INDUSTRIES PRIVATE LIMITED",
"RISVA TECHNOLOGIES OPC PRIVATE LIMITED",
"RIT LEARNINGFIELDS PRIVATE LIMITED",
"RITA AUTOMOBILES PRIVATE LIMITED",
"RITA DYEING AND PRINTING MILLS PRIVATE LIMITED",
"RITA FASHION PRIVATE LIMITED",
"RITA FINANCE AND LEASING LIMITED",
"RITA INDUSTRIES PRIVATE LIMITED",
"RITA INTERNATIONAL RITA",
"RITA MACHINES INDIA PRIVATE LIMITED",
"RITA PAD PRINTING SYSTEMS LIMITED",
"RITAM ROADLINES PRIVATE LIMITED",
"RITAM STEELS PRIVATE LIMITED",
"RITAMBARA JEWELLERY PRIVATE LIMITED",
"RITA'S CREATION PRIVATE LIMITED",
"RITAWARI HEALTHCARE SERVICES PRIVATE LIMITED",
"RITCO LOGISTICS PRIVATE LIMITED",
"RITCO TRAVELS AND TOURS PRIVATE LIMITED",
"RITE CONCEPT JEWELS PRIVATE LIMITED",
"RITE DRUG MART HEALTH SERVICES PRIVATE LIMITED",
"RITE EQUIPMENT PRIVATE LIMITED",
"RITE INFOTECH PRIVATE LIMITED",
"RITE INFOTECH PRIVATE LIMITED.",
"RITE KNOWLEDGE LABS (I) PRIVATE LIMITED",
"RITE MOULD PLAST PRIVATE LIMITED",
"RITE ROOF AND ALLIED PRODUCTS PRIVATE LIMITED",
"RITE SOFTWARE SOLUTIONS AND SERVICES LLP",
"RITE STEEL INDUSTRIES PRIVATE LIMITED",
"RITE STRIDE PRIVATE LIMITED",
"RITE WATER SOLUTIONS (INDIA) PRIVATE LIMITED",
"RITE WATER SOLUTIONS INDIA PRIVATE LIMITED",
"RITE ZONE CHEMCON INDIA LIMITED",
"RITECH HYDRAULICS PRIVATE LIMITED",
"RITECURE HEALTHCARE PRIVATE LIMITED",
"RITEDGER BIZ PRIVATE LIMITED",
"RITEFIX SERVICES PRIVATE LIMITED",
"RITELTH MEDIPHARMA PRIVATE LIMITED",
"RITEMAN PROTECTION FORCE PRIVATE LIMITED",
"RITEMED PHARMA RETAIL PRIVATE LIMITED",
"RITES & JONES PETROCHEMICALS PRIVATE LIMITED",
"RITES LIMITED",
"RITESH EXPORT",
"RITESH EXPORTS LIMITED",
"RITESH INFRATECH PRIVATE LIMITED",
"RITESH INTERNATIONAL LIMITED",
"RITESH JEWELLERS",
"RITESH PROJECTS PRIVATE LIMITED",
"RITESH RENTAL PRIVATE LIMITED",
"RITESH TRADEFIN LTD",
"RITEWAY PROJECTS PRIVATE LIMITED",
"RITEX OVERSEAS PRIVATE LIMITED",
"RITHIK GOLD PRIVATE LIMITED",
"RITHIK SIZING MILLS INDIA PRIVATE LIMITED",
"RITHIKA SUITS PRIVATE LIMITED",
"RITHISE EXPORT IMPORT PRIVATE LIMITED",
"RITHVIK ELECTRIK PRIVATE LIMITED",
"RITHVIKA GOLD PRIVATE LIMITED",
"RITHVIKAA CARS PRIVATE LIMITED",
"RITHWIK AUTOMOBILES PRIVATE LIMITED",
"RITHWIK ENERGY GENERATION PRIVATE LIMITED",
"RITHWIK FACILITY MANAGEMENT SERVICES LIMITED",
"RITHWIK POWER PROJECTS LIMITED",
"RITHWIK PROJECTS PRIVATE LIMITED",
"RITHYA CONSTRUCTIONS INDIA PRIVATE LIMITED",
"RITI REALTY PRIVATE LIMITED",
"RITIK CERAMICS PRIVATE LIMITED",
"RITIK CHEM PRIVATE LIMITED",
"RITIK ENTERPRISES PRIVATE LIMITED",
"RITIKA AGENCIES PRIVATE LIMITED",
"RITIKA CAPITALS LIMITED (TRANSFERRED FROM WEST BENGAL)",
"RITIKA ENGINEERING PRIVATE LIMITED",
"RITIKA ENTERPRISES PRIVATE LIMITED",
"RITIKA EXIMP PRIVATE LIMITED",
"RITIKA INFRACON PRIVATE LIMITED",
"RITIKA PACKAGING PRIVATE LIMITED",
"RITIKA STEEL AND SCRAPS PRIVATE LIMITED",
"RITIKA SYSTEMS PRIVATE LIMITED",
"RITIKA VEGETABLE OIL PRIVATE LIMITED",
"RITIKAA ENTERPRISE PRIVATE LIMITED",
"RITIKA'S DIAGNOSTIC SOLUTIONS PRIVATE LIMITED",
"RITISH AGRO PRIVATE LIMITED",
"RITISHA FRAGRANCES PRIVATE LIMITED",
"RITMAN INFRA LIMITED",
"RITMAN TECHNOLOGIES PRIVATE LIMITED",
"RITNAND BALVED EDUCATION FOUNDATION",
"RITRISHI MULTIPAP PRIVATE LIMITED",
"RITS CONSULTING & TECHNOLOGIES PRIVATE LIMITED",
"RITSIKA BUSINESS VENTURES PRIVATE. LIMITED.",
"RITTAL INDIA PRIVATE LIMITED",
"RITTER IDENTIFICATION TECHNOLOGIES PRIVATE LIMITED",
"RITTERS AUTOMATION PRIVATE LIMITED",
"RITU BRICKS PRIVATE LIMITED",
"RITU CARGO PRIVATE LIMITED",
"RITU COLLECTIONS PRIVATE LIMITED",
"RITU DEORA'S DESIGN STUDIO PRIVATE LIMITED",
"RITU GARMENTS PRIVATE LIMITED",
"RITU HOSPITALITY SERVICES PRIVATE LIMITED",
"RITU HOUSING LIMITED",
"RITU INTERNATIONAL PRIVATE LIMITED",
"RITU INVESTMENTS PRIVATE LIMITED",
"RITU MEMORIAL HOSPITAL",
"RITU MULTIPRO MARKETING PRIVATE LIMITED",
"RITU MULTITRADE SERVICES PRIVATE LIMITED",
"RITU NANDA INSURANCE SERVICE PRIVATE LIMITED",
"RITU RAJ AGENCIES PRIVATE LIMITED",
"RITU SHIPPING PRIVATE LIMITED",
"RITU STONES PRIVATE LIMITED",
"RITUAL FOODS PRIVATE LIMITED",
"RITUAL HOLIDAYS PRIVATE LIMITED",
"RITUBESPOKE FASHIONS PRIVATE LIMITED",
"RITUDHAN SUPPLIERS PRIVATE LIMITED",
"RITUL JEWELS PRIVATE LIMITED",
"RITURAJ FOODS INDIA PRIVATE LIMITED",
"RITURAJ HOLDINGS PVT LTD",
"RITURAJ STEEL PRIVATE LIMITED",
"RITURAJ TAPES PRIVATE LIMITED",
"RITURAJ TEXTILE AND GENERAL INDUSTRIES PRIVATE LIMITED",
"RITUROSH CREATIVE WORKS PRIVATE LIMITED",
"RITU'S DESIGN STUDIO PRIVATE LIMITED",
"RITUSHA CONSULTANTS PRIVATE LIMITED",
"RITUSHREE VANIJYA PRIVATE LIMITED",
"RITVI GEMS AND JEWELS PRIVATE LIMITED",
"RITVIJ PLASTICS PVT LTD",
"RITVIK DIGITECH PRIVATE LIMITED",
"RITVIK STEEL PRIVATE LIMITED",
"RITVIN SOFTWARE SOLUTIONS PRIVATE LIMITED",
"RITWIK FINANCE ENTERPRISES PRIVATE LIMITED",
"RITWIK SOFWARE TECHNOLOGIES PRIVATE LIMITED",
"RITWIKA CREATIONS PRIVATE LIMITED",
"RITWIZ BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"RITZ AGRO CHEMICALS PRIVATE LIMITED",
"RITZ CERA PRIVATE LIMITED",
"RITZ ENTERPRISES PRIVATE LIMITED",
"RITZ FASHION PRIVATE LIMITED",
"RITZ INDIA SNACKS -N- FOODS PRIVATE LIMITED",
"RITZ INN PRIVATE LIMITED",
"RITZ PRIVATE LIMITED",
"RITZ SPINNING MILLS PRIVATE LIMITED",
"RITZ TRADE LINKS PRIVATE LIMITED",
"RITZ TRAVELZ PRIVATE LIMITED",
"RITZEBEN TRADERS PRIVATE LIMITED",
"RITZY CHEMICALS PRIVATE LIMITED",
"RIU DE HYLL PRIVATE LIMITED",
"RIUDE CLOUDS PRIVATE LIMITED",
"RIVA ELEGANCE PRIVATE LIMITED",
"RIVA RESORTS PRIVATE LIMITED",
"RIVAA EXPORTS LIMITED",
"RIVAAN PHARMACHEM PRIVATE LIMITED",
"RIVAAN PLASTCHEM PRIVATE LIMITED",
"RIVAAN TECHNOLOGIES PRIVATE LIMITED",
"RIVAANSH INFRATECH PRIVATE LIMITED",
"RIVAL COMMERCE PVT LTD",
"RIVALDO FASHIONS PRIVATE LIMITED",
"RIVAN ALUMINIUM PRIVATE LIMITED",
"RIVAN PHARMACEUTICALS PRIVATE LIMITED",
"RIVANSHI HOSPITALITY PRIVATE LIMITED",
"RIVARA FASHION",
"RIVARP MEDICAL PRIVATE LIMITED",
"RIVER ADVERTISING PRIVATE LIMITED",
"RIVER BUSINESS SOLUTIONS PRIVATE LIMITED",
"RIVER DALE ESTATES PRIVATE LIMITED",
"RIVER DELTA INDIA",
"RIVER DIAMONDS AND JEWELS COMPANY LIMITED",
"RIVER ENGINEERING PRIVATE LIMITED",
"RIVER FINANCIAL CONSULTANTS PRIVATE LIMITED",
"RIVER OF DESIGN PRIVATE LIMITED",
"RIVER ROSE VENTURE LLP",
"RIVER ROUTE CREATIVE GROUP LLP",
"RIVER VALLEY FLOUR MILLS PRIVATE LIMITED",
"RIVER VALLEY TEA CO PVT LTD",
"RIVER VIEW MOTEL'S PRIVATE LIMITED",
"RIVER WATERLINK PRIVATE LIMITED",
"RIVERA DIGITEC (INDIA) PRIVATE LIMITED",
"RIVERA HOTELS PVT LTD",
"RIVERA LIFESCIENCE PRIVATE LIMITED",
"RIVERARCH FARM HOLIDAYS PRIVATE LIMITED",
"RIVERBANK DEVELOPERS PRIVATE LIMITED",
"RIVERBED TECHNOLOGY INDIA PRIVATE LIMITED",
"RIVERBRIDGE TECH VENTURES PRIVATE LIMITED",
"RIVERDALE BUILDERS PRIVATE LIMITED",
"RIVERDALE COMMODITIES INDIA PRIVATE LIMITED",
"RIVERDALE FOUNDATION",
"RIVERDALE INTERNATIONAL SCHOOL",
"RIVERFOREST CONNECTIONS PRIVATE LIMITED",
"RIVERGATE FASHION PRIVATE LIMITED",
"RIVERGATE RESORT (INDIA) LIMITED",
"RIVERGROW FINANCE LIMITED",
"RIVERIA COMMERCIAL DEVELOPERS LIMITED",
"RIVERINE DREDGING (INDIA) LIMITED",
"RIVERLAND BUILDCON PRIVATE LIMITED",
"RIVERPOINT FOODS PRIVATE LIMITED",
"RIVERROCK STRUCTURAL ENGINEERING PRIVATE LIMITED",
"RIVERSAND GLOBAL TECHNOLOGIES PRIVATE LIMITED",
"RIVERSAND TECHNOLOGIES INDIA PRIVATE LIMITED",
"RIVERSIDE CLINICS AND DIAGNOSTICS PRIVATE LIMITED",
"RIVERSIDE INDUSTRIES LIMITED",
"RIVERSIDE INTERNATIONAL SCHOOL KHOKHADDAD",
"RIVERSIDE RESORTS AND HOLIDAY HOMES PRIVATE LIMITED",
"RIVERSILICA TECHNOLOGIES PRIVATE LIMITED",
"RIVERSONG TECHNOLOGY PRIVATE LIMITED",
"RIVERSTONE INFOTECH PRIVATE LIMITED",
"RIVERSTONE JEWELS LLP",
"RIVERTAIL MEDIA AND TOURISM PRIVATE LIMITED",
"RIVERVIEW JUTE PRODUCTS PRIVATE LIMITED",
"RIVERVIEW VANIJYA PRIVATE LIMITED",
"RIVET COMMUNICATIONS PRIVATE LIMITED",
"RIVEX CLOTHING PRIVATE LIMITED",
"RIVI CONSULTANCY SERVICES PRIVATE LIMITED",
"RIVIANA FOODS PRIVATE LIMITED",
"RIVIERA APARTMENTS PRIVATE LIMITED",
"RIVIERA CONSTRUCTIONS PRIVATE LIMITED",
"RIVIERA DE GOA RESORTS AND HOTELS PRIVATE LIMITED",
"RIVIERA FINANCE (INDIA) LIMITED",
"RIVIERA FINVESTRADE LIMITED",
"RIVIERA FREIGHT SYSTEMS PRIVATE LIMITED",
"RIVIERA GLASS PRIVATE LIMITED",
"RIVIERA HOME FURNISHINGS PRIVATE LIMITED",
"RIVIERA INFRAPROJECTS PRIVATE LIMITED",
"RIVIERA INVESTORS PRIVATE LIMITED",
"RIVIERA OVERSEAS PVT LTD",
"RIVIERA POLYMERS PRIVATE LIMITED",
"RIVIEREA DIAMONDS PRIVATE LIMITED",
"RIVIGO FREIGHT PRIVATE LIMITED",
"RIVIGO SERVICES PRIVATE LIMITED",
"RIVIPAC POLYMERS PRIVATE LIMITED",
"RIVIRA TECHNOLOGIES PRIVATE LIMITED",
"RIVIT INDIA FASTENERS PRIVATE LIMITED",
"RIVL INTERIORS PRIVATE LIMITED",
"RIVOLI STAR FASHIONS PRIVATE LIMITED",
"RIVOLTECH AUTO ENGINEERING PRIVATE LIMITED",
"RIVOMAX INDUSTRIES PRIVATE LIMITED",
"RIVOTTA PRIVATE LIMITED",
"RIVPRA FORMULATION PRIVATE LIMITED",
"RIVULET DIGITAL PRIVATE LIMITED",
"RIVULIS IRRIGATION INDIA PRIVATE LIMITED",
"RIVYA BUILDCON PRIVATE LIMITED",
"RIWAAZ FIN-LEASE PRIVATE LIMITED",
"RIWAAZ GARMENTS PRIVATE LIMITED",
"RIWAAZ INVESTMENTS PRIVATE LIMITED",
"RIWASA TILES LIMITED",
"RIWOO MODULAR OFFICE SYSTEMS PRIVATE LIMITED",
"RIX INDIA TRADING & SERVICE PRIVATE LIMITED",
"RIYA AGRO RESOURCES PRIVATE LIMITED",
"RIYA CAPLEASE INDIA LIMITED",
"RIYA COMMODITIES INDIA PRIVATE LIMITED",
"RIYA EDUCATION PRIVATE LIMITED",
"RIYA ELECTRODES PRIVATE LIMITED",
"RIYA ENCLAVE PRIVATE LIMITED",
"RIYA HOLIDAYS PRIVATE LIMITED",
"RIYA IMPEX",
"RIYA INTERIOR PRIVATE LIMITED",
"RIYA IRON INTERNATIONAL PRIVATE LIMITED",
"RIYA MOTORS PRIVATE LIMITED",
"RIYA PACKERS PRIVATE LIMITED",
"RIYA TRADE INTERNATIONAL PRIVATE LIMITED",
"RIYA TRENDZ PRIVATE LIMITED",
"RIYAN GEMS JEWELLERY PRIVATE LIMITED",
"RIYAN GLOBAL SOLUTIONS PRIVATE LIMITED",
"RIYAN STEEL PRIVATE LIMITED",
"RIYANSH INDUSTRIES PRIVATE LIMITED",
"RIYANSH MULTI TRADE PRIVATE LIMITED",
"RIYANSH POLYTECH PRIVATE LIMITED",
"RIYARCHITA AGRO FARMING PRIVATE LIMITED",
"RIYARCHITA AGRO VENTURES PRIVATE LIMITED",
"RIYAZ FARMERS PRODUCER COMPANY LIMITED",
"RIYBRO ELECTRONICS PRIVATE LIMITED",
"RIYO PARAPACK PRIVATE LIMITED",
"RIYOTEX PRIVATE LIMITED",
"RIZA STEEL PRIVATE LIMITED",
"RIZAB PRODUCTS PRIVATE LIMITED",
"RIZAG ASSOCIATES PRIVATE LIMITED",
"RIZE @ PEOPLE KONNECT PRIVATE LIMITED",
"RIZE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"RIZHAM STEEL & ESTATES PRIVATE LIMITED",
"RIZILIANT TECHNOLOGIES PRIVATE LIMITED",
"RIZITEK INDIA PRIVATE LIMITED",
"RIZMAX SOFTWARE PRIVATE LIMITED",
"RIZOL PETRO PRODUCTS PRIVATE LIMITED",
"RIZON FOODS PRIVATE LIMITED",
"RIZON LAMINATES PRIVATE LIMITED",
"RIZORT TECHNOLOGIES PRIVATE LIMITED",
"RIZVI ARTISTRY PRIVATE LIMITED",
"RIZVI COLLEGE OF ARCHITECTURE",
"RIZVI COLLEGE OF ARTS SCIENCE & COMMERCE",
"RIZVI COLLEGE OF ENGINEERING",
"RIZVI ESTATES & HOTELS PRIVATE LIMITED",
"RIZVI INSTITUTE OF MANAGEMENT STUDIES R",
"RIZWAN ADATIA FOUNDATION",
"RIZZ DISPLAY SOLUTIONS (INDIA) PRIVATE LIMITED",
"RJ AGRIGENETICS PRIVATE LIMITED",
"RJ ARCHITECTS PRIVATE LIMITED",
"RJ ASSOCIATES",
"RJ BIOTECH LIMITED",
"RJ BUSINESS SOLUTIONS PRIVATE LIMITED",
"RJ CORP LIMITED",
"RJ ENTERPRISES INDIA PRIVATE LIMITED",
"RJ GUEST WORLD",
"RJ HEALTH AFFAIRS PRIVATE LIMITED",
"RJ HOTMAX REALTY PRIVATE LIMITED",
"RJ INFRA INTERIOR PRIVATE LIMITED",
"RJ LOGISTIC PRIVATE LIMITED",
"RJ MERCHANTS PRIVATE LIMITED",
"RJ PAWAR AND COMPANY",
"RJ PETROCHEM PRIVATE LIMITED",
"RJ TALENTS OPC PRIVATE LIMITED",
"RJ TRADERS",
"RJ TRINITY CIVIL ENGINEERING PROJECTS PRIVATE LIMITED",
"RJD BUILDCON LIMITED",
"RJD SOFTWARE SERVICES PRIVATE LIMITED",
"RJH HEALTH CARE CONSULTING & SOLUTIONS PRIVATE LIMITED",
"RJHV HELMETS PRIVATE LIMITED",
"RJI INFRA PRIVATE LIMITED",
"RJI TUNNELING AND CONCRETE SOLUTIONS PRIVATE LIMITED",
"RJJ MINERALS PRIVATE LIMITED",
"RJMD DYNAMIC BUSINESS SOLUTIONS PRIVATE LIMITED",
"RJMS LAB PRIVATE LIMITED",
"RJN APOLLO SPECTRA HOSPITALS",
"RJP INFOTEK PRIVATE LIMITED",
"RJP INFRASTRUCTURE PRIVATE LIMITED",
"RJP TECHNOLOGIES PRIVATE LIMITED",
"RJR HOSPITAL PRIVATE LIMITED",
"RJR SOLAR POWER PROJECT PRIVATE LIMITED",
"RJS RECRUITMENT & CONSULTING PRIVATE LIMITED",
"RJSITAAL PROJECTS PRIVATE LIMITED",
"RJSP LOGISTICS PRIVATE LIMITED",
"RJT COMPUSOLUTIONS PRIVATE LIMITED",
"RJV INFRAPROJECT PRIVATE LIMITED",
"RJY HI TECH INFRA PRIVATE LIMITED",
"RK ADITYA SNACKS & BEVERAGE PRIVATE LIMITED",
"RK AGENCY",
"RK AGRI-FOOD PROCESSING PRIVATE LIMITED",
"RK BABU TRADING PRIVATE LIMITED",
"RK BAGS ACCESSORIES PRIVATE LIMITED",
"RK CITY BUS OPERATIONS (NAGPUR) PRIVATE LIMITED",
"RK COLLEGE OF ENGINEERING",
"RK CONSTRUCTION AND BUILDERS PRIVATE LIMITED",
"RK COSMETICS PRIVATE LIMITED",
"RK DEHYDRATION PRIVATE LIMITED",
"RK DUGGAL STUDIOS PRIVATE LIMITED",
"RK DYECHEM PRIVATE LIMITED",
"RK FORKLIFTER PRIVATE LIMITED",
"RK FX SERVICES PRIVATE LIMITED",
"RK GUPTA AGENCIES PRIVATE LIMITED",
"RK HAIR PRODUCTS PRIVATE LIMITED",
"RK HOSPITAL",
"RK HOST SERVICES PRIVATE LIMITED",
"RK HOUSEKEEPING SERVICES PRIVATE LIMITED",
"RK IND EXPORT PRO LIMITED",
"RK INFORMATICS PRIVATE LIMITED",
"RK INFRA ELECTRICALS PRIVATE LIMITED",
"RK INFRABUILT PRIVATE LIMITED",
"RK INFRACONSTRO PRIVATE LIMITED",
"RK INSTITUTE OF MEDICAL SCIENCES BAREILLY",
"RK INTERIORS PRIVATE LIMITED",
"RK INTERNATIONAL EXIM PRIVATE LIMITED",
"RK LABEL PRINTING MACHINERY PRIVATE LIMITED",
"RK METAL ROOFINGS PRIVATE LIMITED",
"RK MISSION VIVEKANANDA CENTENARY COLLEG",
"RK NETRALAYA EYE HOSPITAL PRIVATE LIMITED",
"RK NIHON PROJECTS PRIVATE LIMITED",
"RK PATEL AUTOMOBILES PRIVATE LIMITED",
"RK RETAIL AND COMMODITIES PRIVATE LIMITED",
"RK SECU PRINT PRIVATE LIMITED",
"RK SILK ARTS PRIVATE LIMITED",
"RK TEXMACHINES INDIA PRIVATE LIMITED",
"RK TRANSTEK PRIVATE LIMITED",
"RK VISION MEDIA PRIVATE LIMITED",
"RK VOYAGERS INDIA PRIVATE LIMITED",
"RK WORLDINFOCOM PRIVATE LIMITED",
"RKA CORPORATE ADVISORY PRIVATE LIMITED",
"RKA ENGINEERING PRIVATE LIMITED",
"RKA SYNTHETICS PRIVATE LIMITED",
"RKB GLOBAL FLUX PRIVATE LIMITED",
"RKB GLOBAL LIMITED",
"RKB INTERNATIONAL PRIVATE LIMITED",
"RKB TRADING PRIVATE LIMITED",
"RKBK LIMITED",
"RKC CONSTRUCTIONS PRIVATE LIMITED",
"RKC INFRABUILT (GANJAD-TALASARI) ROAD PROJECT PRIVATE LIMITED",
"RKC INFRABUILT (MEHSANA-HIMATNAGAR) ROAD PROJECT PRIVATE LIMITED",
"RKC INFRABUILT (TARAPUR-VASAD) ROAD PROJECT PRIVATE LIMITED",
"RKC INFRABUILT PRIVATE LIMITED",
"RKC INFRABUILT SAVLI HALOL ROAD PROJECTS PRIVATE LIMITED",
"RKC INFRABUILT TARAPUR KHAMBHAT ROAD PROJECTS PRIVATE LIMITED",
"RKCI PRIVATE LIMITED",
"RKD CONSTRUCTION PRIVATE LIMITED",
"RKD ENGINEERING PRIVATE LIMITED",
"RKD FINANCIAL SERVICES LIMITED",
"RKD FURNISHINGS PRIVATE LIMITED",
"RKD HOTELS PRIVATE LIMITED",
"RKD JEWELS PRIVATE LIMITED",
"RKD MEDIA PRIVATE LIMITED",
"RKDF COLLEGE ENGG COLLEGE",
"RKDF MEDICAL COLLEGE AND RESEARCH CENTRE",
"RKDF UNIVERSITY BHOPAL",
"RKDF UNIVERSITY RANCHI",
"RKE AUTO INDIA PRIVATE LIMITED",
"RKEC PROJECTS LIMITED",
"RKF INFOSERVICES PRIVATE LIMITED",
"RKG AUTOTECH PRIVATE LIMITED",
"RKG BUILDWELL PRIVATE LIMITED",
"RKG ELECTRICALS & ELECTRONICS PRIVATE LIMITED",
"RKG GRAIN SORTING SOLUTIONS PRIVATE LIMITED",
"RKG HOSPITALITIES PRIVATE LIMITED",
"RKG INSULATIONS ENGINEERS & CONTRACTORS PRIVATE LIMITED",
"RKG LAMINATES PRIVATE LIMITED",
"RKG LOGISTICS PRIVATE LIMITED",
"RKG POLYMERS PRIVATE LIMITED",
"RKG POLYPLAST PRIVATE LIMITED",
"RKG RETAIL VENTURES PRIVATE LIMITED",
"RKG SHARE BROKERS PRIVATE LIMITED",
"RKGA CONSULTANTS PRIVATE LIMITED",
"RKGD CLOTHING PRIVATE LIMITED",
"RKGL CONSORTIUM AND REALTY PRIVATE LIMITED",
"RKH AUTOMOBILES PRIVATE LIMITED",
"RKH CONSTRUCTIONS PRIVATE LIMITED",
"RKI BUILDERS PRIVTAE LIMITED",
"RKIT SOFTWARE PRIVATE LIMITED",
"RKJ LOGISTTICS PRIVATE LIMITED",
"RKJAIN & SONS HOSPITALITY SERVICES PRIVATE LIMITED",
"RKL GALAXY INTERNATIONAL SCHOOL FOUNDATION",
"RKLICK SOLUTIONS PRIVATE LIMITED",
"RKM AGRO FRESH PRIVATE LIMITED",
"RKM ASSOCIATES PRIVATE LIMITED",
"RKM IT SERVICES PRIVATE LIMITED",
"RKM REALTORS LIMITED",
"RKMT BUILDCON PRIVATE LIMITED",
"RKN PROJECTS PRIVATE LIMITED",
"RKON INFRA DEVELOPERS PRIVATE LIMITED",
"RKP FINANCE PRIVATE LIMITED",
"RKP HOSPITALS PRIVATE LIMITED",
"RKPEB AND INFRA PRIVATE LIMITED",
"RKPP GURUKUL CONVERTER PRIVATE LIMITED",
"RKPR VINIMAY PRIVATE LIMITED",
"RKPS IMPEX PRIVATE LIMITED",
"RKR AGRO FOODS PRIVATE LIMITED",
"RKR DAIRY PRODUCTS PRIVATE LIMITED",
"RKR GRAPHITE PRIVATE LIMITED",
"RKR HOTELS PRIVATE LIMITED",
"RKR REALTY PRIVATE LIMITED",
"RKS AGRO-TECH LTD",
"RKS CONTRACTS PRIVATE LIMITED",
"RKS COTTON PRIVATE LIMITED",
"RKS DISTRIBUTORS PRIVATE LIMITED",
"RKS ENGICON PRIVATE LIMITED",
"RKS FUTURE FOODS AND COLD CHAIN PRIVATE. LIMITED.",
"RKS INFRACON PRIVATE LIMITED",
"RKS INFRATECH PRIVATE LIMITED",
"RKS MOTOR PRIVATE LIMITED",
"RKS NIRMAN PRIVATE LIMITED",
"RKS PROPERTIES LIMITED",
"RKS STEEL INDUSTRIES PRIVATE LIMITED",
"RKS TEXTILE PRIVATE LIMITED",
"RKS WEALTH INDIA PRIVATE LIMITED",
"RKSA CORPORATE SOLUTIONS PRIVATE LIMITED",
"RKSCPL INFRA PRIVATE LIMITED",
"RKSD PUBLIC SCHOOL",
"RKSK STEEL INDIA PRIVATE LIMITED",
"RKSM DEVELOPERS PRIVATE LIMITED",
"RKSV COMMODITIES INDIA PRIVATE LIMITED",
"RKSV SECURITIES INDIA PRIVATE LIMITED",
"RKT DEVELOPERS",
"RKT PLAST PRIVATE LIMITED",
"RKTC LOGISTICS PRIVATE LIMITED",
"RKV INFRAPROJECTS PRIVATE LIMITED",
"RKVK FASHIONS PRIVATE LIMITED",
"RKVK TRADERS PRIVATE LIMITED",
"RKW DEVELOPERS PRIVATE LIMITED",
"RKY INFRACOM PRIVATE LIMITED",
"RKZ HOTELS AND RESORTS PRIVATE LIMITED",
"RL AGARWALA CAPITAL MARKESTS LIMITED",
"RL BUILDWELL PRIVATE LIMITED",
"RL CLEAN POWER PRIVATE LIMITED",
"RL GEO SEWA PRIVATE LIMITED",
"RL LOGISTICS AND WAREHOUSING PRIVATE LIMITED",
"RL SERVICES PRIVATE LIMITED",
"RLABS ENTERPRISE SERVICES LIMITED",
"RLB KRAFTS PRIVATE LIMITED",
"RLC ENGINEERS PRIVATE LIMITED",
"RLC LOGISTICS",
"RLE INDIA PRIVATE LIMITED",
"RLF HOTELS & RESORTS PRIVATE LIMITED",
"RLG SYSTEMS INDIA PRIVATE LIMITED",
"RLJ CONCAST PRIVATE LIMITED",
"RLJ EXPORTS PRIVATE LIMITED",
"RLJ MULTIGRAIN PRIVATE LIMITED",
"RLJ POLYFAB LIMITED",
"RLJ WOVEN SACKS PRIVATE LIMITED",
"RLK SHRIRAM PLASTICS PRIVATE LIMITED",
"RLM SERVICES PRIVATE LIMITED",
"RLNS BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"RLOGICAL TECHSOFT PRIVATE LIMITED",
"RLR INFRAVISION PRIVATE LIMITED",
"RLRS TOOLS AND ABRASIVES PRIVATE LIMITED",
"RLS SOLUTIONS INDIA PRIVATE LIMITED",
"RLSG TRAVELS PRIVATE LIMITED",
"RLTS INFRA PRIVATE LIMITED",
"RLV COLD STORAGE PRIVATE LIMITED",
"RLV SYSTEMS PRIVATE LIMITED",
"RM AGRO INDUS PRIVATE LIMITED",
"RM APPLIED ENGINEERS PRIVATE LIMITED",
"RM AUTOLINK PRIVATE LIMITED",
"RM CHEMICALS PRIVATE LIMITED",
"RM CONVERTERS PRIVATE LIMITED",
"RM DEBT NIRVANA CONSULTING PRIVATE LIMITED",
"RM EDUCATION SOLUTIONS INDIA PRIVATE LIMITED",
"RM HYPERMARKET PRIVATE LIMITED",
"RM MEDIA PEOPLE COMMUNICATION PRIVATE LIMITED",
"RM ORGANICS PRIVATE LIMITED",
"RM REMEDIES PRIVATE LIMITED",
"RM ROCKS AND SAND PRIVATE LIMITED",
"RM SOLAAR PRIVATE LIMITED",
"RM SQUARE INFRACON PRIVATE LIMITED",
"RM SUPER BAZAAR PRIVATE LIMITED",
"RM SUPERMARKET PRIVATE LIMITED",
"RM SWELLCURE THERAPIES PRIVATE LIMITED",
"RM TRIPATHI PRIVATE LIMITED",
"RM360 RESEARCH AND PUBLICATION PRIVATE LIMITED",
"RMA ALUMINIUM PRIVATE LIMITED",
"RMA ARCHITECTS PRIVATE LIMITED",
"RMA CONSULTANTS",
"RMA ESTATES AND INDUSTRIES PRIVATE LIMITED",
"RMAG ENGINEERING PRIVATE LIMITED",
"RMB CHEMICALS PRIVATE LIMITED",
"RMB EVENT MANAGEMENT PRIVATE LIMITED",
"RMB KNOVATECH PRIVATE LIMITED",
"RMBAY",
"RMC ELECTRONICS PRIVATE LIMITED",
"RMC FOODS AND FATS (INDIA) PRIVATE LIMITED",
"RMC GEMS INDIA LIMITED",
"RMC INDIA PRIVATE LIMITED",
"RMC MED LIMITED",
"RMC MEDICAL SERVICES PRIVATE LIMITED",
"RMC PACKAGING SYSTEMS PVT LTD",
"RMC POWER RECOVERY (INDIA) PRIVATE LIMITED",
"RMC READYMIX PORSELANO INDIA LIMITED",
"RMC SWITCHGEARS LIMITED",
"RMD FOODS AND BEVERAGES PRIVATE LIMITED",
"RMD HOSPITAL & JAYA REHAB CENTER PALITANA",
"RMD KWIFORM INDIA PRIVATE LIMITED",
"RMD KWIKFORM INDIA PRIVATE LIMITED",
"RMD MEDIAIDS LIMITED",
"RMD NURSING HOME",
"RMD SPECIALITIES HOSPITAL",
"RMDMS FOOD SUPPLIERS PRIVATE LIMITED",
"RMEC PROJECTS LIMITED",
"RMG ISPAT PRIVATE LIMITED",
"RMG POLYVINYL INDIA LIMITED",
"RMG STATION TECHNOLOGY PRIVATE LIMITED",
"RMG STEELS PRIVATE LIMITED",
"RMGX TECNOLOGIES LLP",
"RMI CLEAN ENERGY INNOVATIONS PRIVATE LIMITED",
"RMINDS DEVELOPMENT CENTER LLP",
"RMJ AGENCIES PRIVATE LIMITED",
"RMJ MOTORS PRIVATE LIMITED",
"RMJ TECHNOLOGIES PRIVATE LIMITED",
"RMK CERAMICS PRIVATE LIMITED",
"RMK COLLEGE OF ENGINEERING AND TECHNOLOGY",
"RMK DIGITAL PRIVATE LIMITED",
"RMK ENGINEERING COLLEGE",
"RMK FINCORP PRIVATE LIMITED",
"RMK INFRASTRUCTURE PRIVATE LIMITED",
"RMK RESIDENTIAL SENIOR SECONDARY SCHOOL",
"RMK SANDS PRIVATE LIMITED",
"RMK SENIOR SECONDARY SCHOOL",
"RMKV FABRICS PRIVATE LIMITED",
"RMKV FASHION GARMENT PRIVATE LIMITED",
"RMKV SILKS PRIVATE LIMITED",
"RML HOSPITAL",
"RML INFRACON PRIVATE LIMITED",
"RML MEHROTRA PATHOLOGY PRIVATE LIMITED",
"RML METALS AND ALLOYS PRIVATE LIMITED",
"RMM AGRO EXPORTS PRIVATE LIMITED",
"RMM FOOD PRODUCTS",
"RMM HEALTHCARE INDIA PRIVATE LIMITED",
"RMN INDIA PRIVATE LIMITED",
"RMP BEARINGS LIMITED",
"RMP FAB SOURCING PRIVATE LIMITED",
"RMP JEWELLERS PRIVATE LIMITED",
"RMP LIMITED",
"RMP REAL ESTATES PRIVATE LIMITED",
"RMP TOUR AND FOREX SERVICES PRIVATE LIMITED",
"RMPC CONSTRUCTION PRIVATE LIMITED",
"RMR ENGINEERING CONTRACTORS PRIVATE LIMITED",
"RMR INFRASTRUCTURE PRIVATE LIMITED",
"RMR MICRO MINERALS PRIVATE LIMITED",
"RMS ARC INSURANCE BROKERS PRIVATE LIMITED",
"RMS BEVERAGES PRIVATE LIMITED",
"RMS CLUB AND RESORTS PRIVATE LIMITED",
"RMS CONSTRUCTION PRIVATE LIMITED",
"RMS COURIERS PRIVATE LIMITED",
"RMS CREDIT SOLUTIONS PRIVATE LIMITED",
"RMS DIVERSIFIED PRIVATE LIMITED",
"RMS ENERGY PRIVATE LIMITED",
"RMS ENTERPRISES",
"RMS FABRICS PRIVATE LIMITED",
"RMS HOTELS AND RESORTS INDIA PRIVATE LIMITED",
"RMS INFRASPACE PRIVATE LIMITED",
"RMS INTERNATIONAL PRIVATE LIMITED",
"RMS MULTISPECIALITY HOSPITAL & ICU/ICCU",
"RMS POWER SOLUTIONS PRIVATE LIMITED",
"RMS RISK MANAGEMENT SOLUTIONS INDIA PRIVATE LIMITED",
"RMS SALES PRIVATE LIMITED",
"RMS TECHNOLOGIES PRIVATE LIMITED",
"RMS TECHNOSOLUTIONS INDIA PRIVATE LIMITED",
"RMSCLOUD SOFTWARE PRIVATE LIMITED",
"RMSI CROPALYTICS PRIVATE LIMITED",
"RMSI PRIVATE LIMITED",
"RMT INDUSTRIES PRIVATE LIMITED",
"RMT MARBLES PRIVATE LIMITED",
"RMT TOOLS INDIA PRIVATE LIMITED",
"RMTREE INFRA PRIVATE LIMITED",
"RMV FASHIONS PRIVATE LIMITED",
"RMV IMPEX LLP",
"RMV IT SERVICES PRIVATE LIMITED",
"RMV RESORT & HOTELS PRIVATE LIMITED",
"RMV WORKFORCE LLP",
"RMVM SOLUTIONS PRIVATE LIMITED",
"RMW MOTORS PRIVATE LIMITED",
"RMX RUBBER PRIVATE LIMITED",
"RMZ CORP HOLDINGS PRIVATE LIMITED",
"RMZ ECOWORLD INFRASTRUCTURE PRIVATE LIMITED",
"RMZ ESTATES PRIVATE LIMITED",
"RMZ GALLERIA INDIA PRIVATE LIMITED",
"RMZ HOTELS PRIVATE LIMITED",
"RMZ INFINITY (CHENNAI) PRIVATE LIMITED",
"RMZ INFOTECH PRIVATE LIMITED",
"RMZ OILFIELD ENGINEERING PRIVATE LIMITED",
"RMZ ONE PARAMOUNT PRIVATE LIMITED",
"RN AUTOHUB PRIVATE LIMITED",
"RN BULLIONS PRIVATE LIMITED",
"RN CHEMICALS & PHARMACEUTICAL PRIVATE LIMITED",
"RN CHEMICEUTICS PRIVATE LIMITED",
"RN CHIDAKASHI TECHNOLOGIES PRIVATE LIMITED",
"RN ELECTRO POWER PRIVATE LIMITED",
"RN INDUSTRIES PRIVATE LIMITED",
"RN INFRASTRUCTURE LIMITED",
"RN IT INFOSOL PRIVATE LIMITED",
"RN LOGISTICS AND SUPPLY CHAIN PRIVATE LIMITED",
"RN MULTISPECIALITY HOSPITAL PRIVATE LIMITED",
"RN TAGORE HEART RESEARCH INSTITUTE",
"RNA BUILD TRADE PRIVATE LIMITED",
"RNA CREATION PRIVATE LIMITED",
"RNAWEP INVESTMENTS PRIVATE LIMITED",
"RNAYAK CONSTRUCTION PRIVATE LIMITED",
"RNB CEMENTS (P) LTD",
"RNB CORPORATE SERVICES PRIVATE LIMITED",
"RNB DURGA DEVELOPERS PRIVATE LIMITED",
"RNB INFRATECH PRIVATE LIMITED",
"RNB MUSIC PRIVATE LIMITED",
"RNC ARTS JDB COMM NSC SCIENCE COLL",
"RNC DESIGNS PRIVATE LIMITED",
"RNC FINTECH CONSULTANTS PRIVATE LIMITED",
"RNC INFRASTRUCTURES PRIVATE LIMITED",
"RNC POLYMERS PRIVATE LIMITED",
"RNCOS E-SERVICES PRIVATE LIMITED",
"RND AUTOMATION PRIVATE LIMITED",
"RND LABORATORIES PRIVATE LIMITED",
"RND OPTIMIZAR PRIVATE LIMITED",
"RNF TECHNOLOGIES PRIVATE LIMITED",
"RNFI MONEY PRIVATE LIMITED",
"RNFI SERVICES LIMITED",
"RNFI SERVICES PRIVATE LIMITED",
"RNG DEVELOPERS PRIVATE LIMITED",
"RNG EXPORTS PRIVATE LIMITED",
"RNG IMPEX PRIVATE LIMITED",
"RNG INFRASTRUCTURE PRIVATE LIMITED",
"RNG ISPAT UDYOG PVT.LTD.",
"RNG VIVO PRIVATE LIMITED",
"RNGALLA FAMILY PRIVATE LIMITED",
"RNH HOSPITAL PRIVATE LIMITED",
"RNH TRADING PRIVATE LIMITED",
"RNHK INDIA FOOD PRIVATE LIMITED",
"RNINE TECHNOLOGIES PRIVATE LIMITED",
"RNIT SOLUTIONS AND SERVICES LIMITED",
"RNIT SOLUTIONS AND SERVICES PRIVATE LIMITED",
"RNJ METAL PRIVATE LIMITED",
"RNJ TRAVEL SOLUTIONS PRIVATE LIMITED",
"RNK AGRO AND CHEMICALS PRIVATE. LIMITED.",
"RNK INFRA PRIVATE LIMITED",
"RNK PACKAGING PRIVATE LIMITED",
"RNM MOVING PICTURES PRIVATE LIMITED",
"RNMN TECHNO STEELS TRADING PRIVATE LIMITED",
"RNOVA BIOLOGICALS PRIVATE LIMITED",
"RNP INFRACON PRIVATE LIMITED",
"RNP MARKETING & CARGO PRIVATE. LIMITED.",
"RNP SCAFFOLDING & FORMWORK PRIVATE. LIMITED.",
"RNP STUDIOS ENTERTAINMENT PRIVATE LIMITED",
"RNR AGRI HOLDINGS PRIVATE LIMITED",
"RNR CAB SOLUTIONS PRIVATE LIMITED",
"RNR CONSULTING PRIVATE LIMITED",
"RNR FACILITIES PRIVATE LIMITED",
"RNR POWER SOLUTIONS PRIVATE LIMITED",
"RNR TEXTILE MILLS PRIVATE LIMITED",
"RNRL TRADE HUB PRIVATE LIMITED",
"RNS CONSTRUCTION PRIVATE LIMITED",
"RNS EARTHMOVERS PRIVATE LIMITED",
"RNS FACILITIES SERVICES PRIVATE LIMITED",
"RNS FIRST GRADE COLLEGE",
"RNS FOOTWEAR PRIVATE LIMITED",
"RNS INFRASTRUCTURE LIMITED",
"RNS INSTITUTE OF TECHNOLOGY",
"RNS MOTORS LIMITED",
"RNS MOTORS PRIVATE LIMITED",
"RNS POWER LIMITED",
"RNS PRE UNIVERSITY COLLEGE",
"RNS SURGICALS PRIVATE LIMITED",
"RNS WORLDWIDE MSSP PRIVATE LIMITED",
"RNSE-TRONICS PRIVATE LIMITED",
"RNSS NIRMAN (OPC) PRIVATE LIMITED",
"RNT ASSOCIATES PRIVATE LIMITED",
"RNT DISTRIBUTORS PRIVATE LIMITED",
"RNT METALS PRIVATE LIMITED",
"RNT PLANTATIONS LIMITED",
"RNV INDUSTRIES PRIVATE LIMITED",
"RNVK IRON AND STEELS PRIVATE LIMITED",
"RNVP TECHNOLOGY PRIVATE LIMITED",
"RO JEWELS LIMITED",
"ROAD ADS PRIVATE LIMITED",
"ROAD BUILDING INTERNATIONAL INDIA PRIVATE LIMITED",
"ROAD CARGO MOVERS PVT LTD",
"ROAD INFRASTRUCTURE DEVELOPMENT COMPANY OF RAJASTHAN LIMITED",
"ROAD KINGS PVT LTD",
"ROAD MASTER AUTOTECH PRIVATE LIMITED",
"ROAD SHIELD PRIVATE LIMITED",
"ROAD STAR LOGISTICS PRIVATE LIMITED",
"ROADAIR GLOBAL FREIGHT MANAGEMENT PRIVATE LIMITED",
"ROADCAST TECH SOLUTIONS PRIVATE LIMITED",
"ROADCHEM INFRASTRUCTURES PVT.LTD.",
"ROADE LABS PRIVATE LIMITED",
"ROADEST LOGISTIC PRIVATE LIMITED",
"ROADEXPRESS TECHNOLOGY PRIVATE LIMITED",
"ROADIES SURVEYS AND DATA SERVICES PRIVATE LIMITED",
"ROADLAND CONSTRUCTION PRIVATE LIMITED",
"ROADLINK INFRATECH PRIVATE LIMITED",
"ROADLINKS LOGISTICS PRIVATE LIMITED",
"ROADMAN LOGISTICS PRIVATE LIMITED",
"ROADMAP IT SOLUTIONS PRIVATE LIMITED",
"ROADPIN TECHNOLOGIES PRIVATE LIMITED",
"ROADPIPER TECHNOLOGIES PRIVATE LIMITED",
"ROADPOINT LIMITED",
"ROADRIDGE DEVELOPERS PRIVATE LIMITED",
"ROADROCK INTERNATIONAL PRIVATE LIMITED",
"ROADS & BUILDINGS DEPARTMENT",
"ROADSHOW FILMS PRIVATE LIMITED",
"ROADSIDE AWARENESS PRIVATE LIMITED",
"ROADSTAB TECHNOLOGIES PRIVATE LIMITED",
"ROADSTAR INFRA PRIVATE LIMITED",
"ROADTECH ASPHALT TECHNOLOGIES PRIVATE LIMITED",
"ROADWAY SOLUTION HINJAWADI HIGHWAY PROJECT PRIVATE LIMITED",
"ROADWAY SOLUTION MAHABALESHWAR ROADS PROJECT PRIVATE LIMITED",
"ROADWAY SOLUTIONS INDIA INFRA LIMITED",
"ROADWAY SOLUTIONS INDIA PRIVATE LIMITED",
"ROADWAY SOLUTIONS LONAVALA HIGHWAY PROJECT PRIVATE LIMITED",
"ROADWAY SOLUTIONS NARAYANPUR ROADS PROJECT PRIVATE LIMITED",
"ROADWAY SOLUTIONS PRECAST CONCRETE PRIVATE LIMITED",
"ROADWAYS INDIA LTD.",
"ROADWINGS INTERNATIONAL PRIVATE LIMITED",
"ROADWINGS WESTERN PRIVATE LIMITED",
"ROADZEN ASSISTANCE INDIA PRIVATE LIMITED",
"ROADZEN TECHNOLOGIES PRIVATE LIMITED",
"ROAK BUILDCON PRIVATE LIMITED",
"ROAM MEGA SERVICES PRIVATE LIMITED",
"ROAM1 TELECOM LIMITED",
"ROAMBEE SERVICES INDIA PRIVATE LIMITED",
"ROAMER WOOLLEN MILLS PRIVATE LIMITED",
"ROAMSOFT TECHNOLOGIES PRIVATE LIMITED",
"ROANUZ SOFTWARES PRIVATE LIMITED",
"ROAQ CHEMICALS PVT. LTD.",
"ROAR GLOBAL LOGISTICS PRIVATE LIMITED",
"ROBAM APPLIANCES PRIVATE LIMITED",
"ROBARANT ENGINEERING WORKS PRIVATE LIMITED",
"ROBAS RESEARCH PRIVATE LIMITED",
"ROBATECH INDIA PRIVATE LIMITED",
"ROBEMALL APPARELS PRIVATE LIMITED",
"ROBERT BOSCH AUTOMOTIVE STEERING PRIVATE LIMITED",
"ROBERT INSTITUTE OF NURSING",
"ROBERTET FLAVOURS AND FRAGRANCES INDIA PRIVATE LIMITED",
"ROBERTET GOLDFIELD INDIA PRIVATE LIMITED",
"ROBERTS DESIGN SERVICES PRIVATE LIMITED",
"ROBERTSHAW CONTROLS PRIVATE LIMITED",
"ROBIN CHEMICALS PRIVATE LIMITED",
"ROBIN DYES AND INTERMEDIATES PRIVATE LIMITED",
"ROBIN KNITS (INDIA) PRIVATE LIMITED",
"ROBIN PRECISION PRODUCTS PRIVATE LIMITED",
"ROBIN SHOP PRIVATE LIMITED",
"ROBIN SOFTWARE DEVELOPMENT CENTER INDIA PRIVATE LIMITED",
"ROBINHOOD CAPITAL SERVICES PRIVATE LIMITED",
"ROBINHOOD INSURANCE BROKER PRIVATE LIMITED",
"ROBINS REMEDIES PRIVATE LIMITED",
"ROBINSON INTERNATIONAL PRIVATE LIMITED",
"ROBINSON PROPERTIES INTERNATIONAL PRIVATE LIMITED",
"ROBINSON REFRIGERATION PRIVATE LIMITED",
"ROBINSON SPORTS PRIVATE LIMITED",
"ROBINSONS GLOBAL LOGISTICS SOLUTIONS",
"ROBLAND VEBIM MACHINERY PRIVATE LIMITED",
"ROBLOGIX SYSTEMS PRIVATE LIMITED",
"ROBLOX INDIA SERVICES PRIVATE LIMITED",
"ROBO EQUIPMENTS AND FORGINGS PRIVATE LIMITED",
"ROBO SILICON LIMITED",
"ROBO SILICON PRIVATE LIMITED",
"ROBOBAI TECHNOLOGIES PRIVATE LIMITED",
"ROBOCON CNC PRIVATE LIMITED",
"ROBOGENIUS LEARNING SOLUTIONS LIMITED",
"ROBOKIDZ EDUVENTURES PRIVATE LIMITED",
"ROBOKOPS PRIVATE LIMITED",
"ROBOMATIC PRECON PRIVATE LIMITED",
"ROBOMQ PRIVATE LIMITED",
"ROBON AUTOMATION PRIVATE LIMITED",
"ROBONIK INDIA PRIVATE LIMITED",
"ROBOSOFT SOLUTION PRIVATE LIMITED",
"ROBOSOFT TECHNOLOGIES PRIVATE LIMITED",
"ROBOSOL SYSTEMS PRIVATE LIMITED",
"ROBOSPECIES TECHNOLOGIES PRIVATE LIMITED",
"ROBOSURG MED-TECH PRIVATE LIMITED",
"ROBOT COMPONENTS PRIVATE LIMITED",
"ROBOTECH AUTOMATION PRIVATE LIMITED",
"ROBOTECH PRIVATE LIMITED",
"ROBOTICS EMBEDDED EDUCATION SERVICES PRIVATE LIMITED",
"ROBOTIX LEARNING SOLUTIONS PRIVATE LIMITED",
"ROBOYO AUTOMATION INDIA PRIVATE LIMITED",
"ROBSPRAY TECHNOLOGY SYSTEMS PRIVATE LIMITED",
"ROBUS INDIA INDUSTRIES PRIVATE LIMITED",
"ROBUS LANDCORP PRIVATE LIMITED",
"ROBUST AEROTECH PRIVATE LIMITED",
"ROBUST AUTOCOMP PRIVATE LIMITED",
"ROBUST BULK MOVERS PRIVATE LIMITED",
"ROBUST FINVEST PRIVATE LIMITED",
"ROBUST HOTELS LIMITED",
"ROBUST HOTELS PRIVATE LIMITED",
"ROBUST INFOCOM PRIVATE LIMITED",
"ROBUST INFRA",
"ROBUST MANAGEMENT AND CONSULTING PRIVATE LIMITED",
"ROBUST MARKETING SERVICES PRIVATE LIMITED",
"ROBUST MATERIALS TECHNOLOGY PRIVATE LIMITED",
"ROBUST RESULTS PRIVATE LIMITED",
"ROBUSTHIRE FACILITIES AND SERVICES PRIVATE LIMITED",
"ROBUSTWARE IT SOLUTIONS INDIA PRIVATE LIMITED",
"ROCA BATHROOM PRODUCTS PRIVATE LIMITED",
"ROCCIA FOODS PRIVATE LIMITED",
"ROCCIA TILES AND SANITARY PRIVATE LIMITED",
"ROCHAK AGRO FOOD PRODUCTS PRIVATE LIMITED",
"ROCHAK SOYA PRIVATE LIMITED",
"ROCHBECK ESTATE PRIVATE LIMITED",
"ROCHE DIABETES CARE INDIA P LIMITED",
"ROCHE DIAGNOSTICS INDIA PRIVATE LIMITED",
"ROCHE INFORMATION SOLUTIONS INDIA PRIVATE LIMITED",
"ROCHE PRODUCTS INDIA PRIVATE LIMITED",
"ROCHELLE INFRASTRUCTURE PRIVATE LIMITED",
"ROCHELLES TECHNOMATICS INDIA PRIVATE LIMITED",
"ROCHEM (INDIA) PRIVATE LIMITED",
"ROCHEM GREEN ENERGY PRIVATE LIMITED",
"ROCHEM SEPARATION SYSTEMS I PRIVATE LIMITED",
"ROCHEM SERVICES PRIVATE LIMITED",
"ROCHESTON PRESS PRIVATE LIMITED",
"ROCHI ENGINEERS PRIVATE LIMITED",
"ROCHISHMATI HEALTHCARE PRIVATE LIMITED",
"ROCHISHMATI INFRA-PROJECTS PRIVATE LIMITED",
"ROCHITA CONSTRUCTION PRIVATE LIMITED",
"ROCIEO INDUSTRIES PRIVATE LIMITED",
"ROCK & REEF DREDGING PRIVATE LIMITED",
"ROCK AND ARCH CONSTRUCTIONS INDIA PRIVATE LIMITED",
"ROCK AND STORM BOTTLERS PRIVATE LIMITED",
"ROCK AND STORM DISTILLARIES PRIVATE LIMITED RSDPL",
"ROCK BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"ROCK CASTLE CONSTRUCTION PRIVATE LIMITED",
"ROCK CASTLE ENTERTAINMENT PRIVATE LIMITED",
"ROCK CORNER DEVELOPERS PRIVATE LIMITED",
"ROCK CRUSHING INDIA PRIVATE LIMITED",
"ROCK EDGES (INDIA) PRIVATE LIMITED",
"ROCK HARD ENGINEERING PRIVATE LIMITED",
"ROCK MARK DESIGNS PRIVATE LIMITED",
"ROCK N ROLL ENTERTAINMENT PRIVATE LIMITED",
"ROCK REALTY PRIVATE LIMITED",
"ROCK REGENCY HOTELS PRIVATE LIMITED",
"ROCK STAR HOTELS PRIVATE LIMITED",
"ROCK SUGAR INDUSTRIES PRIVATE LIMITED",
"ROCK TECHNOLABS",
"ROCKBED RENOVATORS LIMITED",
"ROCKBOND BUILDCHEM INDIA PRIVATE LIMITED",
"ROCKCHIP TECHNOLOGY PRIVATE LIMITED",
"ROCKCREATORS DREAM HOMES PRIVATE LIMITED",
"ROCKCUT INFRA PRIVATE LIMITED",
"ROCKDRIL (INDIA) PVT LTD",
"ROCKDRILL INFRASTRUCTURE PRIVATE LIMITED",
"ROCKDRILL PROJECTS PRIVATE. LIMITED.",
"ROCKDUDE IMPEX PRIVATE LIMITED",
"ROCKET BATTERIES INDIA PRIVATE LIMITED",
"ROCKET DIGITAL PRIVATE LIMITED",
"ROCKET ENGINEERING CORPORATION PRIVATE LIMITED",
"ROCKET SOFTWARE DEVELOPMENT INDIA PRIVATE LIMITED",
"ROCKET STEEL PRIVATE LIMITED",
"ROCKETIUM.COM TECHNOLOGIES PRIVATE LIMITED",
"ROCKETLANE TECHNOLOGIES PRIVATE LIMITED",
"ROCKFIELD ESTATES PRIVATE LIMITED",
"ROCKFIELD MINING AND MINERALS PRIVATE LIMITED",
"ROCKFIRST REAL ESTATE LIMITED",
"ROCKFORD INFOTECH PRIVATE LIMITED",
"ROCKFORD STRUCTURE PRIVATE LIMITED",
"ROCKFOREST COMPONENTS INDIA PRIVATE LIMITED",
"ROCKFORT DEVELOPERS PRIVATE LIMITED",
"ROCKFORT ESTATE DEVELOPERS PRIVATE LIMITED",
"ROCKFORT MOTOHUB PRIVATE LIMITED",
"ROCKHILL HI-TECH CEMENT PRIVATE LIMITED",
"ROCKHOPPER RENEWABLES (INDIA) PRIVATE LIMITED",
"ROCKING CHAIR MANAGEMENT SERVICES PRIVATE LIMITED",
"ROCKINGDEALS CIRCULAR ECONOMY LIMITED",
"ROCKINGDEALS PRIVATE LIMITED",
"ROCKJAAM BUILDING SOLUTION PRIVATE LIMITED",
"ROCKLAND BUILD CARE PRIVATE LIMITED",
"ROCKLAND HOSPITAL",
"ROCKLAND HOTELS RUDRAPUR PRIVATE LIMITED",
"ROCKLIKE INFRASTRUCTURE PRIVATE LIMITED",
"ROCKLINE DEVELOPERS PRIVATE LIMITED",
"ROCKLINE TECH CHAMP IND PRIVATE LIMITED",
"ROCKMAN ADVANCED COMPOSITES PRIVATE LIMITED",
"ROCKMAN INDUSTRIES CHENNAI PRIVATE LIMITED",
"ROCKMAN INDUSTRIES LIMITED",
"ROCKMAN SECURITY PRIVATE LIMITED",
"ROCKMED PHARMA PRIVATE LIMITED",
"ROCKMETRIC INNOVATIONS PRIVATE LIMITED",
"ROCKMINING CONSTRUCTION SERVICES PRIVATE LIMITED",
"ROCKMOUNT ENTERPRISES PRIVATE LIMITED",
"ROCKPROCESS EQUIPMENT PRIVATE LIMITED",
"ROCKS AND LOGS INDIA PRIVATE LIMITED",
"ROCKS GALLERY PRIVATE LIMITED",
"ROCKSALT INTERACTIVE GAMES PRIVATE LIMITED",
"ROCKSAND MINERALS PRIVATE LIMITED",
"ROCKSCHOOL (INDIA) AWARDING PRIVATE LIMITED",
"ROCKSOIL AND ASSOCIATES CONSTRUCTION COMPANY PRIVATE LIMITED",
"ROCKSTAR FASHIONS INDIA PRIVATE LIMITED",
"ROCKSTAR INTERACTIVE INDIA LLP",
"ROCKSTONE TRAVEL EXPRESS PRIVATE LIMITED",
"ROCKSTUFF INDIA PRIVATE LIMITED",
"ROCKTEC INFRA AND MINING PRIVATE LIMITED",
"ROCKTECH METALS PRIVATE LIMITED",
"ROCKTEK INFRA SERVICES PRIVATE LIMITED",
"ROCK-TENN COMPANY",
"ROCKVALLEY ROCKS AND MINES PRIVATE LIMITED",
"ROCKWATER DECOR PRIVATE LIMITED",
"ROCKWELL AUTOMATION INDIA PRIVATE LIMITED",
"ROCKWELL COLLINS (INDIA) ENTERPRISES PRIVATE LIMITED",
"ROCKWELL COLLINS INDIA PRIVATE LIMITED",
"ROCKWELL EDUCATIONAL INSTITUTIONS PRIVATE LIMITED",
"ROCKWELL HOISTOCRANES PRIVATE LIMITED",
"ROCKWELL INDUSTRIAL PLANTS LIMITED",
"ROCKWELL INDUSTRIES LIMITED",
"ROCKWELL INTERNATIONAL SCHOOLS",
"ROCKWIN FLOWMETER INDIA PRIVATE LIMITED",
"ROCKWOOD HOTELS AND RESORTS LIMITED",
"ROCKWOOD INDUSTRIES PRIVATE LIMITED",
"ROCKWOOL INDIA PRIVATE LIMITED",
"ROCKWORTH INFRA EQUIPMENTS PRIVATE LIMITED",
"ROCKWORTH SYSTEMS FURNITURE INDIA PRIVATE LIMITED",
"ROCKY DHAR",
"ROCKY MARKETING CHENNAI PRIVATE LIMITED",
"ROCKY MARKETING PVT LTD",
"ROCKY STAR FASHIONS LIMITED",
"ROCKYM OPTIMOR PRIVATE LIMITED",
"ROCKYOU INDIA PRIVATE LIMITED",
"ROCLAND PRIVATE LIMITED",
"ROCOCO MINING TECHNOLOGIES PRIVATE LIMITED",
"ROCSEARCH INDIA PRIVATE LIMITED",
"ROCTEX TRADERS PRIVATE LIMITED",
"ROCTOOL ENGINEERS PRIVATE LIMITED",
"ROD FIX SYSTEMS PRIVATE LIMITED",
"ROD RETAIL PRIVATE LIMITED",
"ROD WHEEL TECHNOLOGIES PRIVATE LIMITED",
"RODA HOMES PRIVATE LIMITED",
"RODAS IMPEX PRIVATE LIMITED",
"RODEC HEALTHCARE PRIVATE LIMITED",
"RODEC PHARMACEUTICALS PRIVATE LIMITED",
"RODEE MEDIA PRIVATE LIMITED",
"RODEM HOTEL PRIVATE LIMITED",
"RODEO DIGITAL PRIVATE LIMITED",
"RODI PROJECTS PRIVATE LIMITED",
"RODIC COFFEE ESTATES PRIVATE LIMITED",
"RODIC CONSULTANTS PRIVATE LIMITED",
"RODOVIA INDIA PRIVATE LIMITED",
"ROECHLING AUTOMOTIVE INDIA PRIVATE LIMITED",
"ROECHLING INDUSTRIAL INDIA PRIVATE LIMITED",
"ROEDL & PARTNER CONSULTING PRIVATE LIMITED",
"ROEDL & PARTNER INDIA PRIVATE LIMITED",
"ROENTGEN DIAGNOSTICS PRIVATE LIMITED",
"ROENTGEN ONCOLOGIC SOLUTIONS PRIVATE LIMITED",
"ROENTGEN SCANS WORLD PRIVATE LIMITED",
"ROERICH HEALTH CARE PRIVATE LIMITED",
"ROFIN BAASEL LASER INDIA PRIVATE LIMITED",
"ROGER BRAVO ADVISORS PRIVATE LIMITED",
"ROGER COTYARN CORPORATION INDIA PRIVATE LIMITED",
"ROGER INDUSTRIES LIMITED",
"ROGER INTERNATIONAL PRIVATE LIMITED",
"ROGER MOTORS",
"ROGER POWER TECHNOLOGIES PRIVATE. LIMITED.",
"ROGER STRONSTAND HIGH SCHOOL GOREWADA",
"ROGERS DESIGN & BUILD PRIVATE LIMITED",
"ROGERTHAT PRODUCTION PRIVATE LIMITED",
"ROGRESS TECHNO PRIVATE LIMITED",
"ROHA DYE CHEM PRIVATE LIMITED",
"ROHA DYECHEM SEZ PRIVATE LIMITED",
"ROHA ECO ENERGY PRIVATE LIMITED",
"ROHA HOUSING FINANCE PRIVATE LIMITED",
"ROHA INFOSYSTEMS PRIVATE LIMITED",
"ROHAAN CONSTRUCTIONS PRIVATE LIMITED",
"ROHAN ABASAN PRIVATE LIMITYED",
"ROHAN AUTORIDERS PRIVATE LIMITED",
"ROHAN BOOK COMPANY PRIVATE LIMITED",
"ROHAN BRC GAS EQUIPMENT PRIVATE LIMITED",
"ROHAN BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"ROHAN BUILDERS INDIA PRIVATE LIMITED",
"ROHAN CONSORTIUM PRIVATE LIMITED",
"ROHAN CONSTRUCTION PRIVATE LIMITED",
"ROHAN CORRUPACK PRIVATE LIMITED",
"ROHAN DEVELOPERS PRIVATE LIMITED",
"ROHAN ENERGY SOLUTIONS PRIVATE LIMITED",
"ROHAN ENTERPRISES AND MAINTENANCE SERVICES PRIVATE LIMITED",
"ROHAN FABRICAST PRIVATE LIMITED",
"ROHAN FABRICS PRIVATE LIMITED",
"ROHAN GLOVES MANUFACTURING PRIVATE LIMITED",
"ROHAN HOUSING PRIVATE LIMITED",
"ROHAN INFOCOM PRIVATE LIMITED.",
"ROHAN ISTATION PRIVATE LIMITED",
"ROHAN LANDSCAPE PRIVATE LIMITED",
"ROHAN MEDIA PRIVATE LIMITED",
"ROHAN METALS PRIVATE LIMITED",
"ROHAN MOTORS LTD",
"ROHAN ORGANICS PRIVATE LIMITED",
"ROHAN PAPER PRIVATE LIMITED",
"ROHAN PERIPHERALS PRIVATE LIMITED",
"ROHAN PHARMA PRIVATE LIMITED",
"ROHAN RAJDEEP HIGHWAYS LIMITED",
"ROHAN RAJDEEP KERALA ROAD PROJECTS LIMITED",
"ROHAN RAJDEEP RAJASTHAN INFRA PROJECTS LIMITED",
"ROHAN RAJDEEP TOLL ROADS LIMITED",
"ROHAN RAJDEEP TOLLWAYS LIMITED",
"ROHAN SOLAR POWER PRIVATE LIMITED",
"ROHAN TOOLING SOLUTIONS PRIVATE LIMITED",
"ROHANDEEP DEVELOPERS PRIVATE LIMITED",
"ROHANNA AGRI LIMITED.",
"ROHANNA AGRI PRIVATE LIMITED",
"ROHARSH MOTORS PRIVATE LIMITED",
"ROHAS VENTURES PRIVATE LIMITED",
"ROHDE & SCHWARZ INDIA PRIVATE LIMITED",
"ROHEL CHEMICALS & COMPOUNDS PRIVATE LIMITED",
"ROHEM INSTRUMENTS PRIVATE LIMITED",
"ROHERA MINERALS PRIVATE LIMITED",
"ROHI GLOBAL SERVICES PRIVATE LIMITED",
"ROHIDESHWAR GOODS TRANSPORT SERVICES PRIVATE LIMITED",
"ROHIL FABRICS PRIVATE LIMITED",
"ROHIL FOODS PRIVATE LIMITED",
"ROHIL INDUSTRIES PRIVATE LIMITED",
"ROHILAS INTERNATIONAL SR SEC SCHOOL BAREILLY",
"ROHILKHAND EDUCATIONAL CHARITABLE TRUST",
"ROHILKHAND LABORATORY & RESEARCH CENTRE PRIVATE LIMITED",
"ROHILKHAND MERCHANTS PRIVATE LIMITED",
"ROHILKHAND PROJECTS PRIVATE LIMITED",
"ROHIMA BASTRALAYA",
"ROHINI AGRO PRODUCTS PRIVATE LIMITED",
"ROHINI AUTO ELECTRICALS PRIVATE LIMITED",
"ROHINI BIO-CHEM MICROINPUTS PRIVATE LIMITED",
"ROHINI BUILDTECH PRIVATE LIMITED",
"ROHINI CAPITAL SERVICES LIMITED",
"ROHINI CHEMICALS PRIVATE LIMITED",
"ROHINI EDU SERVICES PRIVATE LIMITED",
"ROHINI FLANGE INDUSTRIES PRIVATE LIMITED",
"ROHINI FLEXO PACK PRIVATE LTD",
"ROHINI GLOBAL MARKETING PRIVATE LIMITED",
"ROHINI GLOBAL MERCHANDISE PRIVATE LIMITED",
"ROHINI HATCHERIES PRIVATE LIMITED",
"ROHINI HELIPORT LIMITED",
"ROHINI HOLDINGS PRIVATE LIMITED",
"ROHINI IMPEX PRIVATE LIMITED",
"ROHINI INTERNATIONAL SCHOOL",
"ROHINI MEDICARE PVT LTD",
"ROHINI METAL AND ALLOYS PRIVATE LIMITED",
"ROHINI OIL FIELD CHEMICALS PRIVATE LIMITED",
"ROHINI PROFIN PRIVATE LIMITED",
"ROHINI SIGNS PRIVATE LIMITED",
"ROHINI SOLARES PRIVATE LIMITED",
"ROHIT AUTO AND FARM EQUIPMENTS PRIVATE LIMITED",
"ROHIT AUTOWHEELS PRIVATE LIMITED",
"ROHIT BAL DESIGNS PRIVATE LIMITED",
"ROHIT BAL PRIVATE LIMITED",
"ROHIT BUILDTECH PRIVATE LIMITED",
"ROHIT CARGO MOVERS PRIVATE LIMITED",
"ROHIT CHEMWORLD PRIVATE LIMITED",
"ROHIT CORPORATION PRIVATE LIMITED",
"ROHIT DIAGEM PRIVATE LIMITED",
"ROHIT ENTERPRISES",
"ROHIT EXTRACTIONS PRIVATE LIMITED",
"ROHIT EYE HOSPITAL AND CHILD CARE CENTRE",
"ROHIT FABTEX",
"ROHIT FEEDS PVT LTD",
"ROHIT HANDLOOM PRIVATE LIMITED",
"ROHIT ICE AND COLD STORAGE PRIVATE LIMITED",
"ROHIT INDUSTRIAL ROPES PRIVATE LIMITED",
"ROHIT INFRABUILD PRIVATE LIMITED",
"ROHIT IRON AND STEEL INDIA PRIVATE. LIMITED.",
"ROHIT JAFA VENTURES (INDIA) PRIVATE LIMITED",
"ROHIT JEWELLERS PVT LTD",
"ROHIT LOGISTICS PRIVATE LIMITED",
"ROHIT NURSING HOME PRIVATE LIMITED",
"ROHIT OFFSET PVT LTD",
"ROHIT OVERSEAS PRIVATE LIMITED",
"ROHIT PIGMENTS INDUSTRIES PRIVATE LIMITED",
"ROHIT PRECISION TECHNOLOGIES PRIVATE LIMITED",
"ROHIT PRESS COMP PRIVATE LIMITED",
"ROHIT PROJECTS PRIVATE LIMITED",
"ROHIT RAJ NOURISH PRIVATE LIMITED",
"ROHIT REAL ESTATE PRIVATE LIMITED",
"ROHIT REFRIGERATION PRIVATE LIMITED",
"ROHIT SERVICES PRIVATE LTD",
"ROHIT SIGNADS PRIVATE LIMITED",
"ROHIT SPRING FORMS PRIVATE LIMITED",
"ROHIT STEELS",
"ROHIT SUPER FORGE PRIVATE LIMITED",
"ROHIT SURGICAL PRIVATE. LIMITED.",
"ROHIT TYPESETTERS",
"ROHITAS SAFTY PRIVATE LIMITED",
"ROHITKRISHI INDUSTRIES PRIVATE LIMITED",
"ROHITRA INDIA PRIVATE LIMITED",
"ROHITWADEWALE PRIVATE LIMITED",
"ROHLIG BLUE SRVICES INDIA PRIVATE LIMITED",
"ROHLIG INDIA PRIVATE LIMITED",
"ROHM CLAMPING TECHNOLOGIES PRIVATE LIMITED",
"ROHM INDIA PRIVATE LIMITED",
"ROHM SEMICONDUCTOR INDIA PRIVATE LIMITED",
"ROHNI DEVELOPERS PRIVATE LIMITED",
"ROHNISH STOICHEM PRIVATE LIMITED",
"ROHRA COMPUTER PRODUCTS PRIVATE LIMITED",
"ROHRA DEVELOPERS PVT LTD",
"ROHSTOFFE INTERNATIONAL PRIVATE LIMITED",
"ROHTAK CHAIN & JEWELLERY PRIVATE LIMITED",
"ROHTAK MANPOWER SERVICES",
"ROHTAK PANIPAT TOLLWAY PRIVATE LIMITED",
"ROHTAS FASTNERS PRIVATE LIMITED",
"ROHTAS ORGANICS INDIA PRIVATE LIMITED",
"ROHTAS STY PACK INDIA PRIVATE LIMITED",
"ROHTO PHARMA INDIA PRIVATE LIMITED",
"ROHUMA INDIA INFO SOLUTIONS PRIVATE LIMITED",
"ROHYL CONSULTANCY PRIVATE LIMITED",
"ROI HOTELS INDIA PRIVATE LIMITED",
"ROI MANTRA PRIVATE LIMITED",
"ROI MINDS PRIVATE LIMITED",
"ROI NET SOLUTION PRIVATE LIMITED",
"ROI TRADELINK PRIVATE LIMITED",
"ROIDEC INDIA CHEMICALS PRIVATE LIMITED",
"ROISTER PROPERTIES PRIVATE LIMITED",
"ROITECH CONSULTING PRIVATE LIMITED",
"ROJ LEATHER EXPORTS PRIVATE LIMITED",
"ROJA NOTE BOOK COMPANY PRIVATE LIMITED",
"ROJIDHAR VADI SHALA 3 PATELKA",
"ROJUCO PRECISION ACCESSORIES INDIA PRIVATE LIMITED",
"ROK INNOVATION PRIVATE LIMITED",
"ROKA MINING AND INFRA SOLUTIONS PRIVATE LIMITED",
"ROKANE INFRACON PRIVATE LIMITED",
"ROKDESHWAR SANSKAR VIDYALYA",
"ROKDOBA MAHARAJ NIDHI LIMITED",
"ROKI R&D INDIA PRIVATE LIMITED",
"ROKI UNO MINDA CO PRIVATE LIMITED",
"ROKIN GRANITES INDIA PRIVATE LIMITED",
"ROKKS ENTERPRISES PRIVATE LIMITED",
"ROKP DYEING AND PRINTING PRIVATE LIMITED",
"ROKSO INDIA PRIVATE LIMITED",
"ROL AGRICHEM PRIVATE LIMITED",
"ROLAND BERGER PRIVATE LIMITED",
"ROLAND CERAMIC",
"ROLASTAR PRIVATE LIMITED",
"ROLAX AUTO PVT LTD",
"ROLCON TECHNOLOGIES PRIVATE LIMITED",
"ROLEX CABLES LIMITED",
"ROLEX ELEVATORS PRIVATE LIMITED",
"ROLEX FITTINGS INDIA PRIVATE LIMITED",
"ROLEX FOAM PRIVATE LIMITED",
"ROLEX HOSIERY PRIVATE LIMITED",
"ROLEX LANOLIN PRODUCTS LIMITED",
"ROLEX LOGISTICS PRIVATE LIMITED",
"ROLEX METALS PRIVATE LIMITED",
"ROLEX METERS PRIVATE LIMITED",
"ROLEX NETWORK SYSTEM PRIVATE LIMITED",
"ROLEX OPTICAL CLINIC",
"ROLEX PAINTS PRIVATE LIMITED",
"ROLEX PROCESSORS PRIVATE LIMITED",
"ROLEX RECLAIM PRIVATE LIMITED",
"ROLEX RINGS LIMITED",
"ROLEX WATCH COMPANY PRIVATE LIMITED",
"ROLI BOOKS PRIVATE LIMITED",
"ROLIGT FOODS PRIVATE LIMITED",
"ROLJACK ASIA LIMITED",
"ROLJOBS TECHNOLOGY SERVICES PRIVATE LIMITED",
"ROLL AND CAST TECHNOLOGIES PRIVATE LIMITED",
"ROLL PACK INDUSTRIES PRIVATE LIMITED",
"ROLL TUBES LIMITED. RTL",
"ROLL TUBES PRIVATE LIMITED",
"ROLLAND TEXTILES PRIVATE LIMITED",
"ROLLATAINERS LIMITED",
"ROLLATAINERS NIRYAT PVT LTD",
"ROLLCE MANUFACTURING PRIVATE LIMITED",
"ROLLCON TECHNOFAB (INDIA) PRIVATE LIMITED",
"ROLLECATE ENGINEERING SERVICES PRIVATE LIMITED",
"ROLLEX MACHINERY PRIVATE LIMITED",
"ROLLFORM EQUIPMENTS PRIVATE LIMITED",
"ROLLICK HEALTHCARE PRIVATE LIMITED",
"ROLLICK OUTDOOR INDIA PRIVATE LIMITED",
"ROLLIFLEX CABLES PRIVATE LIMITED",
"ROLLINE (INDIA) PRIVATE LIMITED",
"ROLLING ARRAYS CONSULTING PRIVATE LIMITED",
"ROLLING CONSTRUCTION PRIVATE LIMITED",
"ROLLING ELEMENTS PRIVATE LIMITED",
"ROLLING ENTERPRISES PRIVATE LIMITED",
"ROLLING FILTERS (OPC) PRIVATE LIMITED",
"ROLLING INSIGHTS PRIVATE LIMITED",
"ROLLING ROCK SOFTWARE PRIVATE LIMITED",
"ROLLING STONE HOTELS PRIVATE LIMITED",
"ROLLING WHEELZ AUTOMOBILES PRIVATE LIMITED",
"ROLLINS INTERNATIONAL PRIVATE LIMITED",
"ROLLMANS ALUMINIUM PVT LTD",
"ROLL-MAX BEARINGS PRIVATE LIMITED",
"ROLLON BEARINGS PRIVATE LIMITED",
"ROLLON HYDRAULICS PRIVATE LIMITED",
"ROLLON INDIA PRIVATE LIMITED",
"ROLLON INVESTMENTS PRIVATE LIMITED",
"ROLLS MAKERS EQUIPMENT PRIVATE LIMITED",
"ROLLS PACK PRIVATE LIMITED",
"ROLLS-ROYCE INDIA PRIVATE LIMITED",
"ROLLS-ROYCE MARINE INDIA PRIVATE LIMITED",
"ROLLTECH ENGINEERING PRIVATE LIMITED",
"ROLLWELL CONVEYOR COMPONENTS PRIVATE LIMITED",
"ROLLWELL FORGE PRIVATE LIMITED",
"ROLLY JEWELLERY",
"ROLLZ INDIA WASTE MANAGEMENT PRIVATE LIMITED",
"ROLMER ENTERPRISES PRIVATE LIMITED",
"ROLTA BI & BIG DATA ANALYTICS PRIVATE",
"ROLTA CREDIT PRIVATE LIMITED",
"ROLTA POWER PRIVATE LIMITED",
"ROLTA SHARES AND STOCKS PRIVATE LIMITED",
"ROLTECH CONVEYORS PRIVATE LIMITED",
"ROM AGROTECH PRIVATE LIMITED",
"ROMA BDS EDTECH PRIVATE LIMITED",
"ROMA BDS EDUCOMP PRIVATE LIMITED",
"ROMA BUILDERS AND PROMOTERS PRIVATE LIMITED",
"ROMA BUILDERS PRIVATE LIMITED",
"ROMA CHEMICAL PRIVATE LIMITED",
"ROMA FLEXIPACK PRIVATE LIMITED",
"ROMA HENNY SECURITY SERVICE PRIVATE LIMITED",
"ROMA HOSPITAL",
"ROMA PHARMA PRIVATE LIMITED",
"ROMAA HOUSING PRIVATE LIMITED",
"ROMACO INDIA PRIVATE LIMITED",
"ROMAH CONCRETE (OPC) PRIVATE LIMITED",
"ROMAKK CHEMICALS PRIVATE LIMITED",
"ROMAN CATHOLIC DIOCESE OF ALLAHABAD PRIVATE LIMITED",
"ROMAN MANAGEMENT SERVICES PRIVATE LIMITED",
"ROMAN NETWORKS PRIVATE LIMITED",
"ROMAN PRINTERS PVT LTD",
"ROMANA HERBALCARE PRIVATE LIMITED",
"ROMANO APPARELS PRIVATE LIMITED",
"ROMANO ESTATE MANAGEMENT SERVICES LIMITED",
"ROMANO INFRASTRUCTURE PRIVATE LIMITED",
"ROMANOVIA INDUSTRIAL PARK PRIVATE LIMITED",
"ROMAX SOLUTIONS PRIVATE LIMITED",
"ROMCO ALUMINATES PRIVATE LIMITED",
"ROMELL PROPERTIES PRIVATE. LIMITED.",
"ROMELL REAL ESTATE PRIVATE LIMITED",
"ROMERO HOME PRIVATE LIMITED",
"ROMEX TILES PRIVATE LIMITED",
"ROMIL IMPEX PRIVATE LIMITED",
"ROMINA ENTERPRISES PRIVATE LIMITED",
"ROMIO IT ENABLED SERVICES PRIVATE LIMITED",
"ROMIO TECHNOLOGIES PRIVATE LIMITED",
"ROMIT BUILDERS PRIVATE LIMITED",
"ROMIT RESINS PRIVATE LIMITED",
"ROMMELAG ENGINEERING PRIVATE LIMITED",
"ROMOFY AGRO INDIA PRIVATE LIMITED",
"ROMSONS GROUP PRIVATE LIMITED",
"RONAK ALKALIES AND CHEMICALS PRIVATE LIMITED",
"RONAK APPAREL PRIVATE LIMITED",
"RONAK BUILDWELL PRIVATE LIMITED",
"RONAK COTTON PRIVATE LIMITED",
"RONAK DIAMONDS PRIVATE LIMITED",
"RONAK DYEING LIMITED",
"RONAK ENTERPRISE",
"RONAK ENTERPRISES PRIVATE LIMITED",
"RONAK FABRICS PRIVATE LIMITED",
"RONAK FIRE INDIA PRIVATE LIMITED",
"RONAK FLOOR MILLS PRIVATE LIMITED",
"RONAK GEMS PVT.LTD",
"RONAK HEALTHCARE PRIVATE LIMITED",
"RONAK INSULATIONS PRIVATE LIMITED",
"RONAK LAMINEX PRIVATE LIMITED",
"RONAK LIFE CARE PRIVATE LIMITED",
"RONAK MONEY SOLUTIONS PRIVATE LIMITED",
"RONAK OPTIK INDIA PRIVATE LIMITED",
"RONAK OVERSEAS PRIVATE LIMITED",
"RONAK PROCESSORS PRIVATE LIMITED",
"RONAK PUMPS AND VALVES PRIVATE LIMITED",
"RONAK RADIATORS PRIVATE LIMITED",
"RONAK ROCKS PRIVATE LIMITED",
"RONAK TRADELINK PRIVATE LIMITED",
"RONAK VYAPAAR PVT.LTD.",
"RONALD COLACO",
"RONALD INFRASTRUCTURE PRIVATE LIMITED",
"RONALD PHARMACEUTICALS PRIVATE LIMITED",
"RONALD WEB OFFSET PRIVATE LIMITED",
"RONALDO RESTAURANT & HOTEL PRIVATE LIMITED",
"RONCH ABSOLUTE TOOLS PRIVATE LIMITED",
"RONCH POLYMERS PRIVATE LIMITED",
"RONCH VENTURES PRIVATE LIMITED",
"RONGPUR CONSTRUCTORS PRIVATE LIMITED",
"RONGS ENTERPRISES INDIA PRIVATE LIMITED",
"RONGSHENG MOBILE INDIA PRIVATE LIMITED",
"RONI HOUSEHOLDS LIMITED",
"RONIKA ENTERPRISE PRIVATE LIMITED",
"RONIKA PACKERS PRIVATE LIMITED",
"RONIL HOTELS AND RESORTS PRIVATE LIMITED",
"RONIN EXPORTS PRIVATE LIMITED",
"RONIN WINES PRIVATE LIMITED",
"RONIT CAPITAL MANAGEMENT LIMITED",
"RONIX POLYMER PVT LTD",
"RONMAS (INDIA) PRIVATE LIMITED",
"RONNIE FINANCE LIMITED.",
"RONSA ENGINEERING SOLUTIONS PRIVATE LIMITED",
"RONSON PIGMENTS PRIVATE LIMITED",
"RONTGEN METALWORKING SOLUTIONS PRIVATE LIMITED",
"RONUK CHEMICALS PRIVATE LIMITED",
"RONUK INDUSTRIES PRIVATE LIMITED",
"RONUK METAFIN PRIVATE LIMITED",
"RONUPLATE PRIVATE LIMITED",
"RONYD HEALTHCARE PRIVATE LIMITED",
"ROOBAROO CONSULTING LLP",
"ROOBY SPIRITS PRIVATE LIMITED",
"ROOCHIR CONTRACTORS PRIVATE LIMITED",
"ROODRAKSH PROBUILDER & INFRACON PRIVATE LIMITED",
"ROOF TECH ENGINEERING PRIVATE LIMITED",
"ROOF TOP HOTELS & RESTAURANTS PRIVATE. LIMITED",
"ROOFCLAD INFRA PRIVATE LIMITED",
"ROOFCO TRADING COMPANY PRIVATE LIMITED",
"ROOFERS COMBINE INDIA PRIVATE LIMITED",
"ROOFS AND CEILINGS INDIA PRIVATE LIMITED",
"ROOFSOL ENERGY PRIVATE LIMITED",
"ROOFTEC INFRASTRUCTURE PRIVATE LIMITED",
"ROOFTECH COLOUR SHIELD PRIVATE LIMITED",
"ROOFTOP URJA PRIVATE LIMITED",
"ROOFVEST REALESTATE LLP",
"ROOHANI INFRAPROJECT PRIVATE LIMITED",
"ROOKO DEVI CONSTRUCTIONS PRIVATE LIMITED",
"ROOM SOOM TECHNOLOGIES PRIVATE LIMITED",
"ROOM TO READ GLOBAL SERVICES PRIVATE LIMITED",
"ROOMAN TECHNOLOGIES PRIVATE LIMITED",
"ROOMITO ONLINE PRIVATE LIMITED",
"ROOMSXML SOLUTIONS LIMITED",
"ROONGTA BUILDCON LIMITED",
"ROONGTA CORPORATE SERVICES PRIVATE LIMITED",
"ROONGTA INDUSTRIAL PARK CORPORATION",
"ROOP AGENCY PRIVATE LIMITED",
"ROOP ARINNA FABRICATORS PRIVATE LIMITED",
"ROOP AUTO FORGE PRIVATE LIMITED",
"ROOP AUTOMOTIVES LIMITED",
"ROOP CABS PRIVATE LIMITED",
"ROOP CATERERS",
"ROOP CHAND AND SONS PRIVATE LIMITED",
"ROOP DIAMOND HOUSE PRIVATE LIMITED",
"ROOP JEWELLERY HOUSE PRIVATE LIMITED",
"ROOP JEWELS PRIVATE LIMITED",
"ROOP JWELFIN PRIVATE LIMITED",
"ROOP KOEPP FOAM TECHNOLOGIES PRIVATE LIMITED",
"ROOP KUNDAN HOUSE PRIVATE LIMITED",
"ROOP LEASING & FINANCE PRIVATE LIMITED",
"ROOP METALS PRIVATE LIMITED",
"ROOP MOHINI SUITS & SAREES PRIVATE LIMITED",
"ROOP ORNAMENTS PRIVATE LIMITED",
"ROOP POLYMERS LIMITED",
"ROOP RAM EDUCARE PRIVATE LIMITED",
"ROOP RASAYAN INDUSTRIES PRIVATE LIMITED",
"ROOP RUBBER MILLS PRIVATE LIMITED",
"ROOP SAMRAT SAREES PRIVATE LIMITED",
"ROOP SIGN AND GRAPHICS PRIVATE LIMITED",
"ROOP SINGH JAGAT SINGH ESTATE PRIVATE LIMITED",
"ROOP SQUARE PRIVATE LIMITED",
"ROOP TEKNO POLYMERS PRIVATE LIMITED",
"ROOP TRADERS PRIVATE LIMITED",
"ROOP ULTRASONIX LIMITED",
"ROOP VATIKA DESIGN PRIVATE LIMITED",
"ROOPA ELECTRICALS PRIVATE LIMITED",
"ROOPA INDUSTRIES LIMITED",
"ROOPAK CREATIONS PRIVATE LIMITED",
"ROOPAK OVERSEAS PRIVATE LIMITED",
"ROOPAK PLASTICS PRIVATE LIMITED",
"ROOPAK STORES PRIVATE LIMITED",
"ROOPALI APPARELS PRIVATE LIMITED",
"ROOPALI CREATION PRIVATE LIMITED",
"ROOPAM DESIGNER SAREES PRIVATE LIMITED",
"ROOPAM INTERNATIONAL PRIVATE LIMITED",
"ROOPFAB INDUSTRIES PRIVATE LIMITED",
"ROOPHAKAVI POWER PRIVATE LIMITED",
"ROOPJI APPERALS PRIVATE LIMITED",
"ROOPLAXMI ENGINEERING PRIVATE LIMITED",
"ROOPLAXMI INDUSTRIES INDIA PRIVATE LIMITED",
"ROOPLAXMI SAREES PRIVATE LIMITED",
"ROOPSAMIR",
"ROOPSHREE JEWELLERS PVT. LTD.",
"ROOPSHRINGAR SAREES PVT. LTD.",
"ROOPSI SAREES PRIVATE LIMITED",
"ROOPSINGAAR APPARELS PRIVATE LIMITED",
"ROOPYAA FINBIZZ LIMITED",
"ROORKEE COLD STORAGE PRIVATE LIMITED",
"ROORKEE COLLEGE OF ENGINEERING",
"ROORKEE EQUIPMENT & MODELS PRIVATE LIMITED",
"ROORKEE INSTITUTE OF TECHNOLOGY",
"ROOS TEMPKOOL LIMITED",
"ROOSH INTERACTIVE PRIVATE LIMITED",
"ROOSTERS LANDBASE PRIVATE LIMITED",
"ROOT FINSERVE PRIVATE LIMITED",
"ROOT LOGISTICS AND FORWARDING PRIVATE LIMITED",
"ROOT VFX PRIVATE LIMITED",
"ROOT2FRUIT FARMS PRIVATE LIMITED",
"ROOTBRIDGE SERVICES PRIVATE LIMITED",
"ROOTCROPS TRADING PRIVATE LIMITED",
"ROOTDESIGN ENGINEERS & TECHNOCRATS PRIVATE LIMITED",
"ROOTLY PLANT DECOR PRIVATE LIMITED",
"ROOTPURE MARKETING PRIVATE LIMITED",
"ROOTQUOTIENT TECHNOLOGIES PRIVATE LIMITED",
"ROOTS ADVERTISING SERVICES PRIVATE LIMITED",
"ROOTS AGROTECH PRIVATE LIMITED",
"ROOTS AIR SYSTEMS PRIVATE LIMITED",
"ROOTS ANALYSIS PRIVATE LIMITED",
"ROOTS APPARELS PRIVATE LIMITED",
"ROOTS AUTO PRODUCTS PRIVATE LIMITED",
"ROOTS BIOTECH PRIVATE LIMITED",
"ROOTS CAST PRIVATE LIMITED",
"ROOTS CONSTRUCTION PRIVATE LIMITED",
"ROOTS COOLING SYSTEMS PRIVATE LIMITED",
"ROOTS CORPORATION LIMITED",
"ROOT'S DECOR INDIA PRIVATE LIMITED",
"ROOTS DESIGN INDIA PRIVATE LIMITED",
"ROOTS DEVELOPERS PRIVATE LIMITED",
"ROOTS EDUCATION PRIVATE LIMITED",
"ROOTS EMBALLAGE PRIVATE LIMITED",
"ROOTS FORMULATIONS PRIVATE LIMITED",
"ROOTS GLOBAL PRIVATE LIMITED",
"ROOTS HAIR & BEAUTY PRIVATE LIMITED",
"ROOTS INDUSTRIES INDIA PRIVATE",
"ROOTS INDUSTRIES INDIA PRIVATE LIMITED",
"ROOTS INSTITUTE",
"ROOTS IRRIGATION PRIVATE LIMITED",
"ROOTS MATRICULATION SCHOOL",
"ROOTS MULTI CLEAN LIMITED",
"ROOTS MULTICLEAN LIMITED",
"ROOTS PRECISION PRODUCTS PRIVATE LIMITED",
"ROOTSENSE SOLUTIONS PRIVATE LIMITED",
"ROOTSTOCK IMPEX PRIVATE LIMITED",
"ROOTZ EVENT AND BRAND ACTIVATION PRIVATE LIMITED",
"ROPALSOFT TECHNOLOGIES PRIVATE LIMITED",
"ROPAR PROPERTIES AND BUILDERS PRIVATE LIMITED",
"ROPAR RUBBCHEM PRODUCTS PRIVATE LIMITED",
"ROPAS LOGISTICS PRIVATE LIMITED",
"ROPE ENTERPRISES PRIVATE LIMITED",
"ROPEWAY AND RESORTS PRIVATE LIMITED",
"ROPLAS DEALCOMM PVT LTD",
"ROPPEN TRANSPORTATION SERVICES PRIVATE LIMITED",
"ROQUETTE INDIA PRIVATE LIMITED",
"ROQUETTE RIDDHI SIDDHI PRIVATE LIMITED",
"ROQUETTE RIDDHI SIDDHI PRIVATE.LIMITED.",
"ROR BUSINESS SOLUTIONS PRIVATE LIMITED",
"RORIS PHARMACEUTICALS PRIVATE LIMITED",
"RORITO INTERNATIONAL PRIVATE LIMITED",
"RORS FINANCE PRIVATE LIMITED",
"ROS ENGINEERING PRIVATE LIMITED",
"ROSA HERBALCARE (INDIA) PRIVATE LIMITED",
"ROSA LUXEMBURG STIFTUNG",
"ROSA POWER SUPPLY COMPANY LIMITED",
"ROSA REALITY PRIVATE.LIMITED.",
"ROSALEE COLOURS PRIVATE LIMITED",
"ROSAN SEA AIR SERVICES PRIVATE LIMITED",
"ROSARAHOME FURNISHINGS PRIVATE LIMITED",
"ROSARIO COSMETICS PRIVATE LIMITED",
"ROSARY CONVENT HIGH SCHOOL",
"ROSARY MATRICULATION HIGHER SECONDARY SCHOOL",
"ROSARY SENIOR SECONDARY SCHOOL",
"ROSAVA ENGINEERING PRIVATE LIMITED",
"ROSAVA WORKSPACE PRIVATE LIMITED",
"ROSE ADVERTISING PRIVATE LIMITED",
"ROSE AGENCIES PRIVATE LIMITED",
"ROSE AND LILLY FARMS PRIVATE LIMITED",
"ROSE APARTMENT PRIVATE LIMITED",
"ROSE AUDIO VISUALS PRIVATE LIMITED",
"ROSE BUILDING SOLUTIONS PRIVATE LIMITED",
"ROSE CORPORATE SERVICES PRIVATE LIMITED",
"ROSE ENGINEERED PRODUCTS INDIA PRIVATE LIMITED",
"ROSE ENTERPRISES PRIVATE LIMITED",
"ROSE FINANCIERS AND COMMERCIALS PVT LTD",
"ROSE FLOWER COMPANY (PAPERS) PRIVATE LIMITED",
"ROSE GRACE APPARELS PRIVATE LIMITED",
"ROSE I T SOLUTIONS PRIVATE LIMITED",
"ROSE IMPORT INDIA PRIVATE LIMITED",
"ROSE INDIA TOUR MANAGERS PRIVATE LIMITED",
"ROSE INTERNATIONAL PRIVATE LIMITED",
"ROSE IT SOLUTIOS PRIVATE LIMITED",
"ROSE JEWELS INDIA PRIVATE LIMITED",
"ROSE MANOR GARDEN SCHOOL",
"ROSE MANOR INTERNATIONAL SCHOOL",
"ROSE MARBLES PRIVATE LIMITED",
"ROSE MARIE KNITWEARS PRIVATE LIMITED",
"ROSE MARY IDEAL PUBLIC SCHOOL",
"ROSE MEDICARE PRIVATE LIMITED",
"ROSE MERC LIMITED",
"ROSE METALS",
"ROSE OPTICALS PRIVATE LIMITED",
"ROSE PLACEMENT SERVICES PRIVATE LIMITED",
"ROSE PREMISES PRIVATE LIMITED",
"ROSE SURGICALS AND PHARMA PRIVATE LIMITED",
"ROSE WATER SOLUTIONS PRIVATE LIMITED",
"ROSEBERRY COMMERCIAL PRIVATE LIMITED",
"ROSECURE PHARMA PRIVATE LIMITED",
"ROSEFINCH MARKETING PRIVATE LIMITED",
"ROSEGARDEN HOTELS PRIVATE LIMITED",
"ROSELIN LEATHERS PRIVATE LIMITED",
"ROSEMAN ENGINEERING LIMITED",
"ROSEMARY & THYME INTERNATIONAL",
"ROSEMARY PUBLIC SCHOOL",
"ROSEMARY SPONGE AND ISPAT PRIVATE LIMITED",
"ROSEMERRY SOLVENT PRIVATE LIMITED",
"ROSEMOUNT INDIA LIMITED",
"ROSEMOUNT SHIPPING INDIA PRIVATE LIMITED",
"ROSEMOUNT TANK GAUGING INDIA PRIVATE LIMITED",
"ROSEMOUNT TRADERS PRIVATE LIMITED",
"ROSEN INDIA PRIVATE LIMITED",
"ROSENBLUTH CONSTRUCTION PRIVATE LIMITED",
"ROSENDAHL NEXTROM INDIA PRIVATE LIMITED",
"ROSERVE ENVIRO PRIVATE LIMITED",
"ROSETTA DIAMOND JEWELLERY PRIVATE LIMITED",
"ROSETTA EXIM PRIVATE LIMITED",
"ROSETTA LIFE CARE PRIVATE LIMITED",
"ROSETTE LEASING AND INFOTECH PRIVATE LIMITED",
"ROSEVIEW PROMOTERS PRIVATE LIMITED",
"ROSEWALK HEALTHCARE PRIVATE LIMITED",
"ROSEWAY SYNTHETICS PVT LTD",
"ROSEWOOD LAMINATES PRIVATE LIMITED",
"ROSEWOOD PROJECTS PRIVATE LIMITED",
"ROSH ELEVATORS PRIVATE LIMITED",
"ROSHA ALLOYS PRIVATE LIMITED",
"ROSHAN CARS PRIVATE LIMITED",
"ROSHAN ENTERPRISES",
"ROSHAN FOODS PRIVATE LIMITED",
"ROSHAN FRUITS INDIA PRIVATE LIMITED",
"ROSHAN IMPEX PRIVATE LIMITED",
"ROSHAN INDUSTRIES PRIVATE LIMITED",
"ROSHAN INFRATECH INDIA PRIVATE LIMITED",
"ROSHAN LAL GARG STEEL PRIVATE LIMITED",
"ROSHAN LAL JAIN & CO. PRIVATE LIMITED",
"ROSHAN METAL INDUSTRIES PRIVATE LIMITED",
"ROSHAN MOTORS (JAIPUR) PRIVATE LIMITED",
"ROSHAN MOTORS PRIVATE LIMITED",
"ROSHAN PHARMACEUTICALS PRIVATE LIMITED",
"ROSHAN PLYWOODS PRIVATE LIMITED",
"ROSHAN REAL ESTATES PRIVATE LIMITED",
"ROSHAN RESORTS PRIVATE LIMITED",
"ROSHAN SINGH BHAG SINGH PRIVATE LIMITED",
"ROSHAN SPACE BRAND COM PRIVATE LIMITED",
"ROSHAN TIN PRINTERS PRIVATE. LIMITED",
"ROSHANA INDIA PRIVATE LIMITED",
"ROSHANI JAINSONS MEGA MART PRIVATE LIMITED",
"ROSHANLAL GRANDSONS PVT LTD",
"ROSHANLAL JAIN MOTORS PRIVATE LIMITED",
"ROSHANLAL RAVI DECORATORS PRIVATE LIMITED",
"ROSHANRANA AGRO (OPC) PRIVATE LIMITED",
"ROSHNI BUILDERS PRIVATE LIMITED",
"ROSHNI CONSTRUCTIONS & SERVICES PRIVATE LIMITED",
"ROSHNI CONSTRUCTIONS AND ENGINEERS PRIVATE LIMITED",
"ROSHNI CREATIONS PRIVATE LIMITED",
"ROSHNI HOTELS PRIVATE LIMITED",
"ROSHNI INDUSTRIES PRIVATE LIMITED",
"ROSIAT TRADEX PRIVATE LIMITED",
"ROSIN JEWELS PRIVATE LIMITED",
"ROSINKA WORLDWIDE PRIVATE LIMITED",
"ROSKA FASHION PRIVATE LIMITED",
"ROSMERTA AUTOTECH LIMITED",
"ROSMERTA AUTOTECH PRIVATE LIMITED",
"ROSMERTA REGISTRATION PLATES PRIVATE LIMITED",
"ROSMERTA SAFETY SYSTEMS PRIVATE LIMITED",
"ROSMERTA TECHNOLOGIES LIMITED",
"ROSO MULTI TRADING PRIVATE LIMITED",
"ROSOL ENERGY PRIVATE LIMITED",
"ROSS CONTROLS INDIA PRIVATE LIMITED",
"ROSS LIFESCIENCE PRIVATE LIMITED",
"ROSS PROCESS EQUIPMENT PRIVATE LIMITED",
"ROSS STORES, INC.",
"ROSSA TILES PRIVATE LIMITED",
"ROSSARI BIOTECH INDIA PRIVATE LIMITED",
"ROSSARI BIOTECH LIMITED",
"ROSSELL INDIA LIMITED",
"ROSSELLE LIFESTYLE PRIVATE LIMITED",
"ROSSI GEARMOTORS INDIA PRIVATE LIMITED",
"ROSSINI INDIA PRINTING ROLLERS PRIVATE LIMITED",
"ROSSLARE ELECTRONICS INDIA PRIVATE LIMITED",
"ROSSMANN INDIA GALVANO TECHNOLOGY PRIVATE LIMITED",
"ROSSMAX MANUFACTURING COMPANY PRIVATE LIMITED",
"ROSSMED LIFESCIENCES PRIVATE LIMITED",
"ROSSO BRUNELLO LEATHERS PRIVATE LIMITED",
"ROSSO CERAMICS PRIVATE LIMITED",
"ROSSPETALS ENTERTAINMENT PRIVATE LIMITED",
"ROSTFREI STEELS PRIVATE LIMITED",
"ROSUN NATURAL PRODUCTS PRIVATE LIMITED",
"ROSVENGER PHARMA PRIVATE LIMITED",
"ROSY BLUE FOUNDATION",
"ROSY BLUE INDIA PRIVATE LIMITED",
"ROSY BLUE SECURITIES PRIVATE LIMITED",
"ROSY BLUE TRADESERVE PRIVATE LIMITED",
"ROSY COILS INDIA PRIVATE LIMITED",
"ROSY ELECTRONICS PRIVATE LIMITED",
"ROSY ENTERPRISES PRIVATE LIMITED",
"ROSY JEWELLERY EXPORTS PRIVATE LIMITED",
"ROSY SPINNING MILLS PRIVATE LIMITED",
"ROSY WOOLLEN MILLS PVT LTD",
"ROSYFORTUNE LOGISTICS PRIVATE LIMITED",
"ROTAM AGROCHEMICAL COMPANY PRIVATE LIMITED",
"ROTAM CROP PROTECTION PRIVATE LIMITED",
"ROTAMECH CONSULTANTS & ENGINEERS PVT LTD",
"ROTANA HOTELS PRIVATE LIMITED",
"ROTANA INNS PRIVATE LIMITED",
"ROTANA MOTOR PRIVATE LIMITED",
"ROTAREX ENGINEERING PRIVATE LIMITED",
"ROTARY CLUB OF RAJKOT MIDTOWN CHARITABLE TRUST",
"ROTARY CONNECTORS PRIVATE LIMITED",
"ROTARY ELECTRONICS PRIVATE LIMITED",
"ROTARY EQUIP PRIVATE LIMITED",
"ROTARY FOUNDATION FOR EDUCATION & LEARNING",
"ROTARY INTERNATIONAL INFOTECH PRIVATE LIMITED",
"ROTARY INTERNATIONAL SOUTH ASIA OFFICE",
"ROTARY MEC ENGINEERING INDIA PRIVATE LIMITED",
"ROTARY PUBLIC SCHOOL",
"ROTARY ROYALES FOUNDATION",
"ROTARYMASTER MANUFACTURING PRIVATE LIMITED",
"ROTAX ELECTRONICS PVT LTD",
"ROTEC TRANSMISSIONS PRIVATE LIMITED",
"ROTECK EQUIPMENT LIMITED",
"ROTEK PHARMA TECHNOLOGIES PRIVATE LIMITED",
"ROTER LEHMANNPARTNER INDIA PRIVATE LIMITED",
"ROTER PRECISION INSTRUMENTS PRIVATE LIMITED",
"ROTEX AUTO PARTS PRIVATE LIMITED",
"ROTEX AUTOMATION LIMITED",
"ROTEX FABRIC PRIVATE LIMITED",
"ROTEX MANUFACTURERS AND ENGINEERS PRIVATE LIMITED",
"ROTEX PETROCHEM PRIVATE LIMITED",
"ROTHE ERDE INDIA PRIVATE LIMITED",
"ROTHE PACKTECH PRIVATE LIMITED",
"ROTHENBERGER INDIA PRIVATE LIMITED",
"ROTHMAN CYCLES PVT LTD",
"ROTHSCHILD INDIA PRIVATE LIMITED",
"ROTHSHIELD HEALTHCARE TPA SERVICES LIMITED",
"ROTKNOPF EXPORT PRIVATE LIMITED",
"ROTO CAST GROUP",
"ROTO LEANER TECHNOLOGY PRIVATE LIMITED",
"ROTO MASTER INDIA",
"ROTO PIXEL PRIVATE LIMITED",
"ROTO POWER ENGINEERS PRIVATE LIMITED",
"ROTO POWER PROJECTS PRIVATE LIMITED",
"ROTO PUMPS LIMITED",
"ROTO SCREENTECH PRIVATE LIMITED",
"ROTOAUTO ENGINEERING SOLUTIONS PRIVATE LIMITED",
"ROTODYNE ENGINEERING SERVICES PRIVATE LIMITED",
"ROTOFAB MACHINERY PRIVATE LIMITED",
"ROTOFILT ENGINEERS LLIMITED",
"ROTOFLUX ROTARY JOINTS INDIA PRIVATE LIMITED",
"ROTOLOCK ENGINEERING PRIVATE LIMITED",
"ROTOLOK VALVES PRIVATE LIMITED",
"ROTOMAAN AUTOMATIONS PRIVATE LIMITED",
"ROTOMAC ELECTRICALS PVT LTD",
"ROTOMAC INDUSTRIES PRIVATE LIMITED",
"ROTOMAC SYNTHETICS PRIVATE LIMITED",
"ROTOMAC VINIMAY PVT LTD",
"ROTOMAG MOTORS AND CONTROLS PRIVATE LIMITED",
"ROTOMAKER INDIA PRIVATE LIMITED",
"ROTOMAN ENGINEERS (INDIA) PVT LTD",
"ROTOMATIC CONTAINERS PRIVATE LIMITED",
"ROTOMEK SEALS PRIVATE LIMITED",
"ROTOMETRICS INDIA PRIVATE LIMITED",
"ROTON CONSULTANCIES PRIVATE LIMITED",
"ROTON VITRIFIED PRIVATE LIMITED",
"ROTOPLAST CONTAINERS PRIVATE LIMITED",
"ROTOPOWER PUMPS & MOTORS PRIVATE LIMITED",
"ROTORTECH ENERGY SOLUTIONS PRIVATE LIMITED",
"ROTOSTAT SERVICES PRIVATE LIMITED",
"ROTOTON POLY PACK PVT LTD",
"ROTTA PRINT INDIA PRIVATE LIMITED",
"ROTTEX MERCANTILE PRIVATE LIMITED",
"ROTTOGEN CROP SCIENCE PRIVATE LIMITED",
"ROTTWEILER SECURITY & FACILITY SERVICES PRIVATE LIMITED",
"ROTUNDA CENTER FOR HUMAN REPRODUCTION PRIVATE LIMITED",
"ROTYCAN TURBOTECH PRIVATE LIMITED",
"ROTZLER SERVICES PRIVATE LIMITED",
"ROUCHER BIOSCIENCES PRIVATE LIMITED",
"ROUGE CAFE PRIVATE LIMITED",
"ROUGH TURTLE PRIVATE LIMITED",
"ROULUNDS BRAKING INDIA PRIVATE LIMITED",
"ROUNAK INDIA PROJECTS PRIVATE LIMITED",
"ROUNAK MANUFACTURING COMPANY PRIVATE LIMITED",
"ROUNAK POLYCHEM PRIVATE LIMITED",
"ROUND D CLOCK ENTERTAINMENT MEDIAHUB PRIVATE LIMITED",
"ROUND DEE CLOCK HAWK EYE SECURITIES PRIVATE LIMITED",
"ROUND O CLOCK CABLE NETWORK PRIVATE LIMITED",
"ROUND O'CLOCK RETAILS PRIVATE LIMITED",
"ROUND ONE NETWORK PRIVATE LIMITED",
"ROUND PLATE REVOLVING HOTELS PRIVATE LIMITED",
"ROUND POINT CONSULTANCY SERVICES LLP",
"ROUND SQUARE EXIM PRIVATE LIMITED",
"ROUND THE CLOCK LOGISTIC PRIVATE LIMITED",
"ROUND THE WORLD TRAVEL",
"ROUNDARK TECHNOLOGIES PRIVATE LIMITED",
"ROUNDGLASS H2O PRIVATE LIMITED",
"ROUNDGLASS SPORTS PRIVATE LIMITED",
"ROUNDGLASS WELLBEING PRIVATE LIMITED",
"ROUNDPAY TECHNOMEDIA PRIVATE LIMITED",
"ROUNDROBIN TECH SERVICES PRIVATE LIMITED",
"ROUNDTHECOAST PRIVATE LIMITED",
"ROUNDTRIP.IN LLP",
"ROURKELA CHEMICALS AND ALLIED INDUSTRIES PVT LTD",
"ROURKELA CONSTRUCTION PVT LTD",
"ROURKELA FABRICATIONS PVT.LTD.",
"ROURKELA ISPAT PRIVATE LIMITED",
"ROURKELA SMART CITY LIMITED",
"ROURKELA STEEL CORPORATION",
"ROURKELA STEEL PLANT",
"ROUT INFRASTRUCTURE PRIVATE LIMITED",
"ROUT SANITECH PRIVATE LIMITED",
"ROUTE LOGISTICS INDIA PRIVATE LIMITED",
"ROUTE MOBILE LIMITED",
"ROUTECORP INDIA PRIVATE LIMITED",
"ROUTEFOREX SOLUTIONS PRIVATE LIMITED",
"ROUTEVISOR LOGISTICS PRIVATE LIMITED",
"ROUTIER OPERATIONS CONSULTING PRIVATE LIMITED",
"ROUTING SWITCHING TIGERS PRIVATE LIMITED",
"ROUZEL PHARMA PRIVATE LIMITED",
"ROV TUNGSTON ALLOYS PRIVATE LIMITED",
"ROVE ELECTRIC PRIVATE LIMITED",
"ROVERCO APPAREL COMPANY PRIVATE LIMITED",
"ROVERS DIGITAL PRIVATE LIMITED",
"ROVI91 INNOVATIONS PRIVATE LIMITED",
"ROVO MARKETING PRIVATE LIMITED",
"ROW2 TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"ROWAN BIOCEUTICALS PRIVATE LIMITED",
"ROWDY PICTURES PRIVATE LIMITED",
"ROWDYWEAR PRIVATE LIMITED",
"ROWENTA NETWORKS PRIVATE LIMITED",
"ROWEZ LIFE SCIENCES PRIVATE LIMITED",
"ROWFIN REALESTATES PRIVATE LIMITED",
"ROWIN EQUIPMENTS PRIVATE LIMITED",
"ROWTEX EXPORTS INDIA PRIVATE LIMITED",
"ROWTH TECH LIMITED",
"ROWTH TECHNOLOGY PRIVATE LIMITED",
"ROX SILICON PRIVATE LIMITED",
"ROX TECHNOLOGY AND SOLUTION PRIVATE LIMITED",
"ROX TRADING AND SYSTEMS PRIVATE LIMITED",
"ROXFORD HEALTHCARE PRIVATE LIMITED",
"ROXILER SYSTEMS PRIVATE LIMITED",
"ROXINA REAL ESTATE PRIVATE LIMITED",
"ROXTEC INDIA PRIVATE LIMITED",
"ROXTER LABORATORIES",
"ROXUL ROCKWOOL INSULATION INDIA PRIVATE LIMITED",
"ROXUL ROCKWOOL TECHNICAL INSULATION INDIA PRIVATE LIMITED",
"ROXY ROLLER FLOUR MILLS PRIVATE LIMITED",
"ROY & SON MEDICAL STORES PRIVATE LIMITED",
"ROY AGROVETS PRIVATE LIMITED",
"ROY APPARELS PRIVATE LIMITED",
"ROY BARI TEA COMPANY PRIVATE LIMITED",
"ROY CEMENT SUPPLIER PRIVATE LIMITED",
"ROY CONSTRUCTIONS PRIVATE LIMITED",
"ROY HATCHERIES PRIVATE LIMITED",
"ROY JOB ASSOCIATES MANAGEMENTS PRIVATE LIMITED",
"ROY KAPUR PRODUCTIONS PRIVATE LIMITED",
"ROY PAINTS PRIVATE LIMITED",
"ROY PELLET FEEDS PRIVATE LIMITED",
"ROYAL AGRI LIFE SCIENCES",
"ROYAL AGRO FARM PRIVATE LIMITED",
"ROYAL AGRO FRESH LLP",
"ROYAL AGRO ORGANIC PRIVATE LIMITED",
"ROYAL AGROFOODS PRIVATE LIMITED",
"ROYAL AIR PRODUCTS INDIA PRIVATE LIMITED",
"ROYAL AIRCON PRIVATE LIMITED",
"ROYAL ALUMIGRILL PRIVATE LIMITED",
"ROYAL APPLIANCES",
"ROYAL AQUA EXPORTS PRIVATE LIMITED",
"ROYAL ARC ELECTODES LIMITED",
"ROYAL ART IMPEX (INDIA) PRIVATE LIMITED",
"ROYAL AUTODEAL PRIVATE LIMITED",
"ROYAL AUTOMOBILES PRIVATE LIMITED",
"ROYAL AUTOTECH PRIVATE LIMITED",
"ROYAL BALAJI ENGINEERING PRIVATE LIMITED",
"ROYAL BANK OF CANADA",
"ROYAL BANK OF SCOTLAND",
"ROYAL BANQUETS PRIVATE LIMITED",
"ROYAL BEAUTY EQUIPMENTS PRIVATE LIMITED",
"ROYAL BEE NATURAL PRODUCTS PRIVATE LIMITED",
"ROYAL BENGAL SEEDS PRIVATE LIMITED",
"ROYAL BEVERAGES PRIVATE. LIMITED.",
"ROYAL BIDI WORKS PRIVATE LIMITED",
"ROYAL BITUMEN PRIVATE LIMITED",
"ROYAL BLUE CITY DEVELOPERS PRIVATE LIMITED",
"ROYAL BLUE HOTELS PRIVATE LIMITED",
"ROYAL BUILDSQUARE PRIVATE LIMITED",
"ROYAL CANIN INDIA PRIVATE LIMITED",
"ROYAL CARBON BLACK PRIVATE LIMITED",
"ROYAL CARGO LOGISTICS PRIVATE LIMITED",
"ROYAL CARRIER AND COURIER PVT LTD",
"ROYAL CARS PRIVATE LIMITED",
"ROYAL CASTOR PRODUCTS LIMITED",
"ROYAL CHAINS PRIVATE LIMITED",
"ROYAL CHALLENGERS SPORTS PRIVATE LIMITED",
"ROYAL CHEMISTRY INDIA FOUNDATION",
"ROYAL CHEMISTRY INDIA PRIVATE LIMITED",
"ROYAL CITY DEVELOPER PRIVATE LIMITED",
"ROYAL CITY LANDMARK PRIVATE LIMITED",
"ROYAL CLASSIC MILLS PRIVATE LIMITED",
"ROYAL COLLEGE",
"ROYAL COLLEGE OF ENGINEERING AND TECHNOLOGY",
"ROYAL COLLEGE OF SCIENCE & TECHNOLOGY",
"ROYAL COMMONWEALTH SOCIETY FOR THE BLIND",
"ROYAL COMPOSITES PRIVATE LIMITED",
"ROYAL CONSTRUCTION",
"ROYAL CRAFT & CREATIONS PRIVATE LIMITED",
"ROYAL CROP SCIENCE AND TECHNOLOGY PRIVATE LIMITED",
"ROYAL CRUISERS PRIVATE LIMITED",
"ROYAL CUSHION VINYL PRODUCTS LIMITED",
"ROYAL CYBER PRIVATE LIMITED",
"ROYAL DATAMATICS PRIVATE LIMITED",
"ROYAL DEEP CONSTRUCTION PRIVATE LIMITED",
"ROYAL DRINKS PVT LTD",
"ROYAL DRY FRUITS PRIVATE LIMITED",
"ROYAL DRYFRUIT PRIVATE LIMITED",
"ROYAL DURGA LOGISTICS PRIVATE LIMITED",
"ROYAL EASTERN HOSPITALITIES PRIVATE LIMITED",
"ROYAL ECOMMERCE SOLUTIONS PRIVATE LIMITED",
"ROYAL ELASTOMERS PRIVATE LIMITED",
"ROYAL ELECTRICAL CONTRACTOR PRIVATE LIMITED",
"ROYAL EMBASSY OF SAUDI ARABIA",
"ROYAL EMBROIDERY THREADS PRIVATE. LIMITED.",
"ROYAL ENFIELD",
"ROYAL ENGINEERING CONSULTANCY PRIVATE LIMITED",
"ROYAL ENGINEERS",
"ROYAL ENGINEERS AND CONTRACTORS PRIVATE LIMITED",
"ROYAL ENGITECH PRIVATE LIMITED",
"ROYAL ENSIGN REALTECH PRIVATE LIMITED",
"ROYAL ENTERPRISES INFRA PRIVATE LIMITED",
"ROYAL EVA PRODUCTS PRIVATE LIMITED",
"ROYAL FANTASY CONSTRUCTIONS PRIVATE LIMITED",
"ROYAL FASTENERS (NE) PRIVATE LIMITED",
"ROYAL FERTICHEM PRIVATE LIMITED",
"ROYAL FINCOMM PRIVATE LIMITED",
"ROYAL FINSERV CONSULTANTS PRIVATE LIMITED",
"ROYAL FOODSTUFFS PRIVATE LIMITED",
"ROYAL FORWARDERS P LIMITED",
"ROYAL GEMS AND JEWELLERY PRIVATE LIMITED",
"ROYAL GLOBAL UNIVERSITY",
"ROYAL GOAN BEACH RESORTS LLP",
"ROYAL GOLD ASSETS AND PROPERTIES PRIVATE LIMITED",
"ROYAL GOLD FOOD STUFF PRIVATE LIMITED",
"ROYAL GRAINS OVERSEAS PRIVATE LIMITED",
"ROYAL GRAINS PRIVATE LIMITED",
"ROYAL GRAVO LTD",
"ROYAL GREEN OIL REFINERIES PRIVATE LIMITED",
"ROYAL GULF TOURISM LLC",
"ROYAL HANDICRAFTS INDIA PRIVATE LIMITED",
"ROYAL HAVARD MARKETING SOLUTION PRIVATE LIMITED",
"ROYAL HEIGHTS BUILDWELL PRIVATE LIMITED",
"ROYAL HERBAL LAND PRIVATE LIMITED",
"ROYAL HIRING PRIVATE LIMITED",
"ROYAL HOLIDAY PLANNERS PRIVATE LIMITED",
"ROYAL HOME COLLECTIONS PRIVATE LIMITED",
"ROYAL HOMETOWN PLANNERS PRIVATE LIMITED",
"ROYAL HOSPITAL ENT & MULTISPECIALTY",
"ROYAL HOSPITAL PRIVATE LIMITED",
"ROYAL HOSPITALITY AND MANAGEMENT SERVICES PRIVATE LIMITED",
"ROYAL HOUSE AGENCY PRIVATE LIMITED",
"ROYAL IMAGES CATALOGUE CO PRIVATE LIMITED",
"ROYAL IMPACT CERTIFICATION LIMITED",
"ROYAL IMPEX INDIA",
"ROYAL INDIA CLOTHING COMPANY PRIVATE LIMITED",
"ROYAL INDIA CORPORATION LIMITED",
"ROYAL INDIAN RESTAURANT PRIVATE LIMITED",
"ROYAL INDUSTRIALS COIMBATORE PRIVATE LIMITED",
"ROYAL INFRACONSTRU LIMITED",
"ROYAL INFRAENGINEERING PRIVATE LIMITED",
"ROYAL INFRAPROJECTS LIMITED",
"ROYAL INKS & EQUIPMENTS PRIVATE LIMITED",
"ROYAL INSTRUMENT INDIA PRIVATE LIMITED",
"ROYAL INTERNATIONAL SCHOOL",
"ROYAL JARDIN HOTELS (OPC) PRIVATE LIMITED",
"ROYAL KAPSONS REALTORS PRIVATE LIMITED",
"ROYAL KASHMIR HERITAGE RESORTS PRIVATE LIMITED",
"ROYAL KHAZIR HOTELS & RESORTS PRIVATE LIMITED",
"ROYAL LACES LIMITED",
"ROYAL LAND & DEVELOPERS PRIVATE LIMITED",
"ROYAL LATEX PRIVATE LIMITED",
"ROYAL LEAGUE APPARELS PRIVATE LIMITED",
"ROYAL LIFESTYLE JEWELLERS PRIVATE LIMITED",
"ROYAL LIFESTYLE PRIVATE LIMITED",
"ROYAL LOGISTICS",
"ROYAL MARSHAL SECURITY SERVICES PRIVATE LIMITED",
"ROYAL MARWAR HOSPITALITY PRIVATE LIMITED",
"ROYAL MEDICAL PRIVATE LIMITED",
"ROYAL MEGATECH PRIVATE LIMITED",
"ROYAL MENS WEAR",
"ROYAL METAL PRINTERS PRIVATE LIMITED",
"ROYAL MICRO IRRIGATION SYSTEM",
"ROYAL MILLS (PALANI) PRIVATE LIMITED",
"ROYAL MINDZ INFRA PRIVATE. LIMITED.",
"ROYAL MIRAGE TRADE CONSULTANTS PRIVATE LIMITED",
"ROYAL MISSION CONSTRUCTION PRIVATE LIMITED",
"ROYAL MOTORS GWALIOR PRIVATE LIMITED",
"ROYAL MULTISPORT PRIVATE LIMITED",
"ROYAL NORWEGIAN EMBASSY",
"ROYAL ORBIT",
"ROYAL ORCHID ASSOCIATED HOTELS PRIVATE LIMITED",
"ROYAL ORCHID CENTRAL BANGALORE",
"ROYAL ORCHID HOTELS LIMITED",
"ROYAL ORCHID JEWELLERY INDIA PRIVATE LIMITED",
"ROYAL PARA MEDICAL & VOCATIONAL JUNIOR COLLEGE",
"ROYAL PARK HOSPITALITY PRIVATE LIMITED",
"ROYAL PENTA TRADERS AND DISTRIBUTORS INDIA PRIVATE LIMITED",
"ROYAL PETRO OIL REFINERY LLP",
"ROYAL PETRO PARK PRIVATE LIMITED",
"ROYAL PETRO SPECIALITIES PRIVATE LIMITED",
"ROYAL PG PRIVATE LIMITED",
"ROYAL PLASTOCRAFT PRIVATE LIMITED",
"ROYAL PLAZA INN",
"ROYAL PLYWOOD INDUSTRIES",
"ROYAL POLYFILM PRIVATE LIMITED",
"ROYAL POLYMERS PRIVATE LIMITED",
"ROYAL POWER TURNKEY IMPLEMENTS PRIVATE LIMITED",
"ROYAL QUEST RESORTS PRIVATE LIMITED",
"ROYAL RAJ SECURITY AND SERVICES PRIVATE LIMITED",
"ROYAL RAJASTHAN FOUNDATION",
"ROYAL RANGER SECURITY SERVICES PRIVATE LIMITED",
"ROYAL RATAN INDUSTRIES PRIVATE LIMITED",
"ROYAL REALTY PROJECTS MANAGEMENT PRIVATE LIMITED",
"ROYAL RESARCH LAB PRIVATE LIMITED",
"ROYAL RESIDENCY",
"ROYAL RESTAURANTS AND HOTELS PROJECTS PRIVATE LIMITED",
"ROYAL RETREAT HOMES PRIVATE LIMITED",
"ROYAL RETREAT HOTELS PRIVATE LIMITED",
"ROYAL RIBBONS & SHELLS PRIVATE LIMITED",
"ROYAL RICH CONDIMENTS PRIVATE LIMITED",
"ROYAL RICH EXTRACTIONS INDIA PRIVATE LIMITED",
"ROYAL SALT PRIVATE LIMITED",
"ROYAL SAND AND GRAVELS PRIVATE LIMITED",
"ROYAL SEABRINE PRIVATE LIMITED",
"ROYAL SEALS PRIVATE LIMITED",
"ROYAL SEAS MERCHANTS PRIVATE LIMITED",
"ROYAL SECURITIES LTD.",
"ROYAL SECURITY SERVICES PVT LTD",
"ROYAL SEEDS PRIVATE LIMITED",
"ROYAL SHREE BALAJI TEXNIT PRIVATE LIMITED",
"ROYAL SILK SPLENDOUR PRIVATE LIMITED",
"ROYAL SOFTECH INDIA PRIVATE LIMITED",
"ROYAL SOJOURAN PRIVATE LIMITED",
"ROYAL SPARES & ACCESSORIES PRIVATE LIMITED",
"ROYAL SPECTRUM PRIVATE LIMITED",
"ROYAL SQUARE PROPERTIES & DEVELOPERS PRIVATE LIMITED",
"ROYAL STAR AGROTECH PRIVATE LIMITED",
"ROYAL STAR JEWELLERY PRIVATE LIMITED",
"ROYAL STEEL PIPES PRIVATE LIMITED",
"ROYAL STERLING INDIA PRIVATE LIMITED",
"ROYAL STRIPS PRIVATE LIMITED",
"ROYAL SUITINGS PRIVATE LIMITED",
"ROYAL SUNDARAM GENERAL INSURANCE CO LIMITED",
"ROYAL SURGICARE PRIVATE LIMITED",
"ROYAL SYMPHONY HOTELS PRIVATE LIMITED",
"ROYAL SYNTHETICS",
"ROYAL TECHNOSOFT PRIVATE LIMITED",
"ROYAL TENSILE STRUCTURE PRIVATE LIMITED",
"ROYAL TEX FAB PRIVATE LIMITED",
"ROYAL THERMOSET PRIVATE LIMITED",
"ROYAL TOUCH ALUMINIUM PRIVATE LIMITED",
"ROYAL TOUCH CLEANERS PRIVATE LIMITED",
"ROYAL TOUCH FABLON PRIVATE LIMITED",
"ROYAL TOUCH FASHIONS PRIVATE LIMITED",
"ROYAL TOUCH INTERIORS PRIVATE LIMITED",
"ROYAL TOUCH LAMINATES PRIVATE LIMITED",
"ROYAL TOUCH OVERSEAS PRIVATE LIMITED",
"ROYAL TRADELINKS PRIVATE LIMITED",
"ROYAL TRADERS LIMITED",
"ROYAL TRADING PRIVATE LIMITED",
"ROYAL TRAILS PRIVATE LIMITED",
"ROYAL TRANSLINES PRIVATE.LIMITED",
"ROYAL TRAVELS & TRANSPORT PRIVATE LIMITED",
"ROYAL TV PRIVATE.LIMITED",
"ROYAL TYRES PRIVATE LIMITED",
"ROYAL UNIFORCE ROOFINGS PRIVATE LIMITED",
"ROYAL UNIVERSYS WEBNET PRIVATE LIMITED",
"ROYAL VACATIONS RESORTS PRIVATE LIMITED",
"ROYAL VALTRANS INDIA PRIVATE LIMITED",
"ROYAL VERMA JEWELLERS PRIVATE LIMITED",
"ROYAL WATERPROOFING PRIVATE LIMITED",
"ROYAL WEAVERS PRIVATE LIMITED",
"ROYAL WELDING WIRES PRIVATE LIMITED",
"ROYAL WESTERN (INDIA) HOTELS PRIVATE LIMITED",
"ROYAL WESTERN INDIA TURF CLUB LIMITED",
"ROYAL WHITE MARMO STONE PRIVATE LIMITED",
"ROYAL WHITE MINING PRIVATE LIMITED",
"ROYAL WINGS AUTO PRIVATE LIMITED",
"ROYAL YARNS COIMBATORE PRIVATE LIMITED",
"ROYAL ZENITH PRINTS PRIVATE LIMITED",
"ROYALARC ELECTRODES LIMITED",
"ROYALBISON AUTORENTALS INDIA PRIVATE LIMITED",
"ROYALCABS MOTOR TRANSPORT PRIVATE LIMITED",
"ROYALCARE SUPER SPECIALITY HOSPITAL LIMITED",
"ROYALCARE TECHNOLOGIES PRIVATE LIMITED",
"ROYALCARIBBEAN MANNING INDIA PRIVATE LIMITED",
"ROYALCORP TECHNOLOGIES PRIVATE LIMITED",
"ROYALCORPORATE CONSULTANCY SERVICES PRIVATE LIMITED",
"ROYALE 7 COMPLETE SECURITAS & SERVICES PRIVATE LIMITED",
"ROYALE BLUE CLUB PRIVATE LIMITED",
"ROYALE CLUBS OF INDIA PRIVATE LIMITED",
"ROYALE CONCORDE INTERNATINAL SCHOOL",
"ROYALE HOTELS PRIVATE LIMITED",
"ROYALE IMPEX PRIVATE LIMITED",
"ROYALE INDIA PVT LTD",
"ROYALE INTERNATIONAL COURIERS PRIVATE LIMITED",
"ROYALE LEATHER EXPORTS PRIVATE LIMITED",
"ROYALE MARINE IMPEX PRIVATE. LIMITED.",
"ROYALE MERIDIAN (INDIA) PRIVATE LIMITED",
"ROYALE MOTELS AND RETREATS PRIVATE LIMITED",
"ROYALE PIXELS LLP",
"ROYALE RECREATION PRIVATE LIMITED",
"ROYALE RESINEX PRIVATE LIMITED",
"ROYALEBLUE RESORTS (INDIA) PRIVATE LIMITED",
"ROYALEGLOBTECH INDIA PRIVATE LIMITED",
"ROYALENE SULZ PRIVATE LIMITED",
"ROYALEX FASHIONS INDIA PRIVATE LIMITED",
"ROYALGLOBELIA MARITIME SOLUTIONS PRIVATE LIMITED",
"ROYALGOLF HOTELS INDIA PRIVATE LIMITED",
"ROYALGOLF LINK CITY PROJECTS PRIVATE LIMITED",
"ROYALINDIA FOREX PRIVATE LIMITED",
"ROYALLINE RESOURCES LIMITED",
"ROYALMARINE LOGISTICS PRIVATE LIMITED",
"ROYALMATE DISTRIBUTORS PRIVATE LIMITED",
"ROYALMOBI MEDIA PRIVATE LIMITED",
"ROYALOAK INCORPORATION PRIVATE LIMITED",
"ROYALOCEAN INDIA INFRATECH PRIVATE LIMITED",
"ROYALONE LOGISTIC PRIVATE LIMITED",
"ROYALREALTORS SKY HEIGHT PRIVATE LIMITED",
"ROYALS MARINE FOOD PRIVATE LIMITED",
"ROYALS TEXTILE MILL PRIVATE LIMITED",
"ROYALS TIMESHARE INDIA LIMITED",
"ROYALSAVERA FOODS PRIVATE LIMITED",
"ROYALSHINE PLASTIC COMPONENTS PRIVATE LIMITED",
"ROYALSKY HOTELS PRIVATE LIMITED",
"ROYALSVOLGO GRANITE PRIVATE LIMITED",
"ROYALTAJ INDIA RESORTS PRIVATE LIMITED",
"ROYALTI PAINT INDUSTRIES PRIVATE LIMITED",
"ROYALTI REAL ESTATE PRIVATE LIMITED",
"ROYALTY BUILDERS LIMITED",
"ROYALTY SILICON STEEL INDIA PRIVATE LIMITED",
"ROYALUX PRODUCTS PRIVATE LIMITED",
"ROYALWAVE SHIPPING AND LOGISTICS PRIVATE LIMITED",
"ROYALWAVE TELECOM PRIVATE LIMITED",
"ROYALWORLD FACILITATORS PRIVATE LIMITED",
"ROYAUME ESTATES PRIVATE LIMITED",
"ROYCCO ENGINEERING PRIVATE LIMITED",
"ROYCE BUILDCON PRIVATE LIMITED",
"ROYCE PACK PRIVATE LIMITED",
"ROYCE VENTURES PRIVATE LIMITED",
"ROYD NURSING HOME & HEALTH CARE LIMITED",
"ROYEL KRISHI RASAYAN PRIVATE LIMITED",
"ROYER INDIA PRIVATE LIMITED",
"ROYES INDUSTRIES PRIVATE LIMITED",
"ROYLE EXTRUSION SYSTEMS PRIVATE LIMITED",
"ROYM INDUSTRIES PRIVATE LIMITED",
"ROYOTA ENGINEERING SOLUTIONS PRIVATE LIMITED",
"ROYS INSTITUTE OF COMPETITIVE EXAMINATION PRIVATE LIMITED",
"ROYSONS ENGINEERS PVT LTD",
"ROYZ ARCHCON PRIVATE LIMITED",
"ROZ DESIGN LAB PRIVATE LIMITED",
"ROZEUS AIRPORT RETAIL LIMITED",
"ROZGAR VIKAS EDUCATION PRIVATE LIMITED",
"ROZZANO LUXURY FASHION PRIVATE LIMITED",
"RP AWANTIKA INFRACON PRIVATE LIMITED",
"RP CARGO AND LOGISTICS PRIVATE LIMITED",
"RP CUBE PRIVATE LIMITED",
"RP CYLINDERS PRIVATE LIMITED",
"RP INFOTECH PRIVATE LIMITED",
"RP INFRAPOWER PRIVATE. LIMITED.",
"RP JHUNTHRA MOTORS PRIVATE LIMITED",
"RP METALIKS PRIVATE LIMITED",
"RP MULTIMETALS PRIVATE LIMITED",
"RP NEXUS WORLDWIDE PRIVATE LIMITED",
"RP OFFICE AUTOMATION PRIVATE LIMITED",
"RP PAPER IMPEX PRIVATE LIMITED",
"RP PLASTIC TRADERS PRIVATE LIMITED",
"RP PROJECTS PRIVATE LIMITED",
"RP RAILTECH PRIVATE LIMITED",
"RP SOLDERS PRIVATE LIMITED",
"RP TILES AND TUBES LIMITED",
"RPA FOODS PRIVATE. LIMITED.",
"RPA UNIBAKES PRIVATE LIMITED",
"RPAO SURVEY OF INDIA KOLKATA",
"RPASOFT PRIVATE LIMITED",
"RPB AUTOMOTIVES PRIVATE LIMITED",
"RPC EXPORTS PRIVATE LIMITED",
"RPC FOODS PRIVATE LIMITED",
"RPC INTEGR8 (OPC) PRIVATE LIMITED",
"RPCC BUILDING SOLUTIONS PRIVATE LIMITED",
"RPD DENTAL ART PRIVATE LIMITED",
"RPD HEALTHCARE PRIVATE LIMITED",
"RPD INFRATECH PRIVATE LIMITED",
"RPG CONTRACTORS AND BUILDERS PRIVATE LIMITED",
"RPG ELECTRADE PRIVATE LIMITED",
"RPG FOUNDATION",
"RPG INDUSTRIAL PRODUCT PRIVATE. LIMITED.",
"RPG LIFE SCIENCES LIMITED",
"RPG MARBLE PRIVATE LIMITED",
"RPG NIRMAN PRIVATE LIMITED",
"RPG POWER TRADING COMPANY LIMITED",
"RPG SECURITY AND MANAGEMENT SERVICES PRIVATE LIMITED",
"RPGS MARKETING PRIVATE LIMITED",
"RPGV INDIA PRIVATE LIMITED",
"RPJ OVERSEAS & EXIM PRIVATE LIMITED",
"RPK INDIA PRIVATE LIMITED",
"RPK STEELS ROLLING MILLS PRIVATE LIMITED",
"RPK WAREHOUSING PRIVATE LIMITED",
"RPL AUTOMATION PRIVATE LIMITED",
"RPL CAPITAL FINANCE LIMITED",
"RPL INDUSTRIES LIMITED",
"RPL PROJECTS LIMITED",
"RPLANET INTEGRATED SOLUTION PRIVATE LIMITED",
"RPM ACADEMY",
"RPM CLEAN CARE MANAGEMENT PRIVATE LIMITED",
"RPM CORP AIDS PRIVATE LIMITED",
"RPM ENGINEERS (INDIA) LIMITED",
"RPM HYDRAULICS PRIVATE LIMITED",
"RPM INFOTECH CONSULTING PRIVATE LIMITED",
"RPM LOGISTICS PRIVATE LIMITED",
"RPM PACKERS PRIVATE LIMITED",
"RPM VFX STUDIOS PRIVATE LIMITED",
"RPML INDUSTRIES PRIVATE LIMITED",
"RPN ENGINEERS CHENNAI PRIVATE LIMITED",
"RPN FINTRALEASE AND SECURITIES PRIVATE LIMITED",
"RPN ORGANICS PRIVATE LIMITED",
"RPNM INDUSTRIES PRIVATE LIMITED",
"RPOST LABS PRIVATE LIMITED",
"RPP ENGINEERING & CONSULTING PRIVATE LIMITED",
"RPP INFRA PROJECTS LIMITED",
"RPP-ANNAI (JV) PRIVATE LIMITED",
"RPR SONS ADVISORS PRIVATE LIMITED",
"RPROCESS OUTSOURCING SERVICES PRIVATE LIMITED",
"RPS CONSULTING PRIVATE LIMITED",
"RPS FARMS AND EXPORTS PRIVATE LIMITED",
"RPS GLOBAL CARGO INDIA PRIVATE LIMITED",
"RPS HOSPITALS PRIVATE LIMITED",
"RPS HOTELS PRIVATE LIMITED",
"RPS INFOCOM PRIVATE LIMITED",
"RPS INFRA PROJECTS PRIVATE LIMITED",
"RPS INFRASTRUCTURE LTD",
"RPS INTERNATIONAL SCHOOL",
"RPS MANAGEMENT AND CONSULTANCY PRIVATE LIMITED",
"RPS RESEARCH INDIA PRIVATE LIMITED",
"RPS SCHOLAR FOUNDATION",
"RPS SCHOOL",
"RPS SR SEC SCHOOL",
"RPS TEA CO PVT LTD",
"RPSG RESOURCES PRIVATE LIMITED",
"RPSG VENTURES LIMITED",
"RPSK STEELS PRIVATE LIMITED",
"RPSS TIMBERS PRIVATE LIMITED",
"RPV EXPORTS PRIVATE LIMITED",
"RPWEB APPS PRIVATE LIMITED",
"RQS ENGINEER PRIVATE LIMITED",
"RQS MINING PRIVATE LIMITED",
"RR & SONS VEHICLES PRIVATE. LIMITED.",
"RR ACADEMY PRIVATE LIMITED",
"RR ANIMAL HEALTH CARE LIMITED",
"RR COALS PRIVATE LIMITED",
"RR CONSTRUCTION AND INFRASTRUCTURE INDIA PRIVATE LIMITED",
"RR DONNELLEY INDIA OUTSOURCE PRIVATE LIMITED",
"RR DURA FABS PRIVATE LIMITED",
"RR DWELLINGS PRIVATE LIMITED",
"RR ENGINEERING & CONSTRUCTIONS INDIA PRIVATE LIMITED",
"RR EQUITY BROKERS PRIVATE LIMITED",
"RR FASHION CLOTHING PRIVATE LIMITED",
"RR GOLD PALACE PRIVATE LIMITED",
"RR HIGH ENERGETICS LIMITED",
"RR HOUSING(INDIA) PRIVATE LIMITED",
"RR INDUSTRIAL CORPORATION I PRIVATE. LIMITED.",
"RR INVESTORS RETAIL SERVICES PRIVATE LIMITED",
"RR LOGISTICS AND SHIPPING SERVICES PRIVATE LIMITED",
"RR LOGISTICS PRIVATE LIMITED",
"RR MEGA CITY BUILDERS LIMITED",
"RR METALMAKERS INDIA LIMITED",
"RR NANDURBAR ROAD PRIVATE LIMITED",
"RR OIL AND FATS PRIVATE LIMITED",
"RR OPTINET PRIVATE LIMITED",
"RR PHARMACEUTICALS PRIVATE LIMITED",
"RR PRECISION INDIA PRIVATE LIMITED",
"RR RECYCLERS PRIVATE LIMITED",
"RR SHIPPING PRIVATE LIMITED",
"RR SUDHA AGENCIES PRIVATE LIMITED",
"RR TRADEX PRIVATE LIMITED",
"RR VETERINARY HEALTH CARE PRIVATE LIMITED",
"RRA CORPORATE SERVICES PRIVATE LIMITED",
"RRA PROJECT MANAGEMENT PRIVATE LIMITED",
"RRAG AUTOMOTIVE PRIVATE LIMITED",
"RRAIFLIGHT RESERVATION PRIVATE LIMITED",
"RRAP SOFTWARE PRIVATE LIMITED",
"RRAS TECHNOLOGIES PRIVATE LIMITED",
"RRB CAPITAL TRADING AND CONSULTANCY SERVICES",
"RRB CHEMICALS PRIVATE LIMITED.",
"RRB ENERGY LIMITED",
"RRB GROUP INDIA PRIVATE LIMITED",
"RRB REALTORS PRIVATE LIMITED",
"RRC AGRO INDUSTRIES PRIVATE LIMITED",
"RRC FRESH VENTILATION PRODUCTS PRIVATE LIMITED",
"RRC LOGISTIC PRIVATE LIMITED",
"RRC PRAKASHA ROAD PRIVATE LIMITED",
"RRC VENTURES PRIVATE LIMITED",
"RRD APPARELS PRIVATE LIMITED",
"RRD BUILDCON PRIVATE LIMITED",
"RRD CORPORATION PRIVATE LIMITED",
"RRD IMPEX PRIVATE LIMITED",
"RRD OIL AND FATS PRIVATE LIMITED",
"RRD TEX PRIVATE LIMITED",
"RREDIFICE PRIVATE LIMITED",
"RREFCAST PRIVATE LIMITED",
"RREN CONSULTANTS & CONTRACTORS PRIVATE LIMITED",
"RRG BUILDWELL PRIVATE LIMITED",
"RRG ENERGIES PRIVATE LIMITED",
"RRG ENGINEERING TECHNOLOGIES PRIVATE LIMITED",
"RRHL REALTY LIMITED",
"RRIBADA FILMS PRIVATE LIMITED",
"RRIL LIMITED",
"RRINVESTORS CAPITAL SERVICES PRIVATE LIMITED",
"RRJ INFRA INDUSTRIES PRIVATE LIMITED",
"RRK POLYMERS PRIVATE LIMITED",
"RRL BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"RRL FREIGHT CARRIERS PRIVATE LIMITED",
"RRL LOGISTICS PRIVATE LIMITED",
"RRL STEELS LIMITED",
"RRL STEELS PRIVATE LTD",
"RRM ENTERPRISES PRIVATE LIMITED",
"RRM INFRASTRUCTURE PRIVATE LIMITED",
"RRM TRADING INTERNATIONAL PRIVATE LIMITED",
"RRMEL INDIA PRIVATE LIMITED",
"RROOT SHELL TECHNOLOGIISS PRIVATE LIMITED",
"RRP EXPORTS PRIVATE LIMITED",
"RRP GLOBAL CHEMICALS PRIVATE LIMITED",
"RRP S4E INNOVATION PRIVATE LIMITED",
"RRPK INDUSTRIES PRIVATE LIMITED",
"RRPL FOODS PRIVATE LIMITED",
"RRR EXIM CONSULTANTS PRIVATE LIMITED",
"RRR GUESTLINE PRIVATE LIMITED",
"RRS INDUSTRIES PRIVATE LIMITED",
"RRS MANAGEMENT PRIVATE LIMITED",
"RRS PHARMA & SURGICAL TWIN PRIVATE LIMITED",
"RRSA LOGISTICS PRIVATE LIMITED",
"RRSM INFRA PRIVATE LIMITED",
"RRT TECH INDUSTRIES PRIVATE LIMITED",
"RRUCHI FOOD PLAZA PRIVATE LIMITED",
"RRV FOOD PRIVATE LIMITED",
"RRV INFRA PRIVATE LIMITED",
"RRW LOGISTICS PRIVATE LIMITED",
"RS - MICROTECH PRIVATE LIMITED",
"RS BAJAJ ORGANO CHEM PRIVATE LIMITED",
"RS BARCODERS PRIVATE LIMITED",
"RS COMFOSYS PRIVATE LIMITED",
"RS DYAL AGRO PRIVATE LIMITED",
"RS FABRICS PRIVATE LIMITED",
"RS FABRITECH ENGINEERS PRIVATE LIMITED",
"RS GOLD SHOPPEE (INDIA) PRIVATE LIMITED",
"RS GREEN INFRA (INDIA) PRIVATE LIMITED",
"RS INTEGRATORS PRIVATE LIMITED",
"RS JAIN IMPEX PRIVATE LIMITED",
"RS LAXMI JOUEL PRIVATE LIMITED",
"RS LOOMS",
"RS MISRA MEDICARE PRIVATE LIMITED",
"RS PACKAGING INDUSTRIES (INDIA) PRIVATE LIMITED",
"RS PHARMACY",
"RS POWER SYSTEMS PRIVATE LIMITED",
"RS RUBBER LIMITED",
"RS SEMICONDUCTORS PRIVATE LIMITED",
"RS SEVEN LIFESTYLE PRIVATE LIMITED",
"RS SHIPPING AGENCY INDIA PRIVATE LIMITED",
"RS SPECTRA TECHNICAL SOLUTIONS PRIVATE LIMITED",
"RS STAFFING SOLUTIONS INDIA PRIVATE LIMITED",
"RS TUBE AND TANKS PRIVATE LIMITED",
"RS URJA PRIVATE LIMITED",
"RS WEALTH MANAGEMENT PRIVATE LIMITED",
"RS WINDTECH ENGINEERS PRIVATE LIMITED",
"RSA ACTUARIAL SERVICES INDIA PRIVATE LIMITED",
"RSA APPLIANCES PRIVATE LIMITED",
"RSA AUTOCARE PRIVATE LIMITED",
"RSA AUTOMOTIVES PRIVATE LIMITED",
"RSA BUILDERS AND CONTRACTORS PRIVATE LIMITED",
"RSA CONTAINER LINE PRIVATE LIMITED",
"RSA COTTEX PRIVATE LIMITED",
"RSA EXIM PRIVATE LIMITED",
"RSA INDUSTRIES PRIVATE LIMITED",
"RSA INSTRUMENTS PRIVATE LIMITED",
"RSA MOTORS PRIVATE LIMITED",
"RSA SECURITY APPLICATIONS INDIA PRIVATE LIMITED",
"RSA TURBOTECH PRIVATE LIMITED",
"RSAB IT INDIA PRIVATE LIMITED",
"RSAC TECHNOLOGY PRIVATE LIMITED",
"RSAINFRABUILD PRIVATE LIMITED",
"RSALESARM IT SERVICESPRIVATE LIMITED",
"DILIGENT GOVERNANCE PRIVATE LIMITED",
"RSB ARCH PROJECT CONSULTANTS PRIVATE LIMITED",
"RSB CASTINGS LIMITED",
"RSB COTTEX LIMITED",
"RSB INDUSTRIES PRIVATE LIMITED",
"RSB INFRASTRUCTURE LIMITED.",
"RSB INFRASTRUCTURE PRIVATE LIMITED.",
"RSB INSIGHTS AND ANALYTICS PRIVATE LIMITED",
"RSB PROJECTS LIMITED",
"RSB PROJECTS PRIVATE LIMITED",
"RSB SECURITIES LIMITED",
"RSB SYSTEMS PRIVATE LIMITED",
"RSB TEXTILES PRIVATE LIMITED",
"RSB TRANSMISSIONS I LIMITED",
"RSB WEALTH PRIVATE LIMITED",
"RSC PROJECTS PRIVATE LIMITED",
"RSC SYSTEMS PRIVATE LIMITED",
"RSD ASPHALTS PRIVATE LIMITED",
"RSD FINANCE LTD",
"RSD IMPEX TRADERS PRIVATE LIMITED",
"RSD NATURAL RESOURCES PRIVATE LIMITED",
"RSD OVERSEAS",
"RSD POLYMERS PRIVATE LIMITED",
"RSD TRAINING INSTITUTE PRIVATE LIMITED.",
"RSD WELSTAND PRIVATE LIMITED",
"RSDC INDUSTRIES PRIVATE LIMITED",
"RSDR BUILDERS PRIVATE LIMITED",
"RSDR REALTY PRIVATE LIMITED",
"RSE LEGALDOCS PRIVATE LIMITED",
"RSE SUPPORTS PRIVATE LIMITED",
"RSECURED FINANCE & CAPITAL PRIVATE LIMITED",
"RSEWA LAND DEVELOPERS PRIVATE LIMITED",
"RSF HYTEK PRIVATE LIMITED",
"RSG AGRO INDIA PRIVATE LIMITED",
"RSG BUILDERS PRIVATE LIMITED",
"RSG BUILDTECH PRIVATE LIMITED",
"RSG DEVELOPERS PRIVATE LIMITED",
"RSG FOODS PRIVATE LIMITED",
"RSG IMA BLOOD CENTER BAREILLY",
"RSG INFRATECH PRIVATE LIMITED",
"RSG MEDIA SYSTEMS PRIVATE LIMITED",
"RSG SOLUTIONS PRIVATE LIMITED",
"RSG SUPPLYCHAIN SOLUTIONS PRIVATE LIMITED",
"RSGAUR GLOBAL MULTISPECIALITY HOSPITAL PRIVATE LIMITED",
"RSGM TECHNO SERVICES PRIVATE LIMITED",
"RSGP CONSULTING PRIVATE LIMITED",
"RSH ENTERTAINMENT PRIVATE LIMITED",
"RSH GLOBAL PRIVATE LIMITED",
"RSHAH SOLUTIONS PRIVATE LIMITED",
"RSHREE ENTERPRISES PRIVATE LIMITED",
"RSI CONTENT SOLUTIONS INDIA PRIVATE LIMITED",
"CIRCANA INDIA PRIVATE LIMITED",
"RSI STONE WORLD PRIVATE LIMITED",
"RSIIL-NP INFRA JV PRIVATE LIMITED",
"RSIN FLEXIRENTALS PRIVATE LIMITED",
"RSINGH CONSTRUCTIONS PRIVATE LIMITED",
"RSJ CARRIERS PRIVATE LIMITED",
"RSJ INSPECTION SERVICE LIMITED",
"RSJ INSPECTION SERVICE PRIVATE LIMITED",
"RSJC FITTINGS PRIVATE LIMITED",
"RSK BUSINESS SOLUTIONS PRIVATE LIMITED",
"RSK ENGINEERING INDIA PRIVATE LIMITED",
"RSK GLASS PRIVATE LIMITED",
"RSK HIGHER SECONDARY SCHOOL",
"RSK INDUSTRIES PRIVATE LIMITED",
"RSK PROMOTERS PRIVATE LIMITED",
"RSK WEAVES PRIVATE LIMITED",
"RSKISSAN FOODS (INDIA) PRIVATE LIMITED",
"RSKRISH TECHNOLOGY & SERVICES PRIVATE LIMITED",
"RSKS AUTOMOTIVES PRIVATE LIMITED",
"RSL ALLOY COATING PRIVATE LIMITED",
"RSL CONTAINER LINES PRIVATE LIMITED",
"RSL CRYO CYLINDERS PRIVATE LIMITED",
"RSL DISTILLERIES PRIVATE LIMITED",
"RSL DYECOT PRIVATE LIMITED",
"RSL FREIGHT INDIA PRIVATE LIMITED",
"RSL LOGISTICS PRIVATE LIMITED",
"RSLH AUTO SEAT TRIMS PRIVATE LIMITED",
"RSLH SEAT TRIMS PRIVATE LIMITED",
"RSLOGISTICS & CARGO PRIVATE LIMITED",
"RSM ASTUTE CONSULTECH PRIVATE LIMITED",
"RSM ASTUTE CONSULTING (CHENNAI) PRIVATE LIMITED",
"RSM ASTUTE CONSULTING PRIVATE LIMITED",
"RSM AUTOKAST PRIVATE LIMITED",
"RSM BUILDERS & SECURITIES PRIVATE LIMITED",
"RSM CONSULTING INDIA PRIVATE LIMITED",
"RSM DELIVERY CENTER (INDIA) PRIVATE LIMITED",
"RSM ESTATES LIMITED",
"RSM FINSERV LIMITED",
"RSM FOODS PRIVATE LIMITED",
"RSM GC ADVISORY SERVICES PRIVATE LIMITED",
"RSM MOMORLAL SCHOOL",
"RSM PHARMA PRIVATE LIMITED",
"RSM PROJECTS AND ENGINEERS PRIVATE LIMITED",
"RSM RHV ENGLISH MEDIUM SCHOOL",
"RSM SAPTHAGIRI FINANCE LIMITED",
"RSMART AVIATION SOFTWARE PRIVATE LIMITED",
"RSMART RESOURCES AND ADVERTISEMENT NETWORK LIMITED",
"RSMN B2B SOLUTIONS PRIVATE LIMITED",
"RSMS ARCHITECTS PRIVATE LIMITED",
"RSN BALAJI REALTORS PRIVATE LIMITED",
"RSN ENGINEERING & CONSTRUCTION COMPANY PRIVATE LIMITED",
"RSN GINFO SOLUTIONS PRIVATE LIMITED",
"RSN TRAVELS PRIVATE LIMITED",
"RS-NAVYA POLYMERS INDIA PRIVATE LIMITED",
"RSND ENVIROCARE PRIVATE LIMITED",
"RSONS AGRO FOOD INDIA PRIVATE LIMITED",
"RSONS PLUMBING SOLUTION PRIVATE LIMITED",
"RSP AIR PRODUCTS PRIVATE LIMITED",
"RSP BUILD PROJECTS PRIVATE LIMITED",
"RSP BUILDINFRA PRIVATE LIMITED",
"RSP CONTRACTORS INDIA PRIVATE LIMITED",
"RSP CONTROL PROJECTS PRIVATE LIMITED",
"RSP DESIGN CONSULTANTS (INDIA) PRIVATE LIMITED",
"RSP ELECTRICALS (BHARAT) PRIVATE LIMITED",
"RSP EXPORT AND TRADING PRIVATE LIMITED",
"RSP GOURMET FOODS PRIVATE LIMITED",
"RSP HEIGHTS PRIVATE LIMITED",
"RSP INFINITE BUSINESS SOLUTIONS (INDIA) PRIVATE LIMITED",
"RSP JEWELLERS PRIVATE LIMITED",
"RSP METALIKS PRIVATE LIMITED",
"RSP SPIRAL DUCTS PRIVATE LIMITED",
"RSP TECHNOLOGIES PRIVATE LIMITED",
"RSP UNITED INFRA CONSTRUCTIONS PRIVATE LIMITED",
"RSPC SERVICES PRIVATE LIMITED",
"RSPJ FIRST ASSIST PRIVATE LIMITED",
"RSPK CONSULTING SERVICES PRIVATE LIMITED",
"RSPL GLOBAL SERVICES PRIVATE LIMITED",
"RSPL HEALTH PRIVATE LIMITED",
"RSPL LIMITED",
"RSPS SIPRA PRIVATE LIMITED",
"RSQUARE MOTELS RESORTS AND INFRA PRIVATE LIMITED",
"RSR FREIGHT LINES PRIVATE LIMITED",
"RSR INFORMATICS PRIVATE LIMITED",
"RSR INFRA WORKS (INDIA) PRIVATE LIMITED",
"RSR PETRO CHEMICALS PRIVATE LIMITED",
"RSR RETAIL PRIVATE LIMITED",
"RSRC RADIOLOGY SOLUTIONS AND RESEARCH CENTER PRIVATE LIMITED",
"RSRM LYING IN HOSPITAL",
"RSRTC",
"RSS ARTS SCI COMM COLLEGE",
"RSSB TEXTILE MILLS PRIVATE LIMITED",
"RSSG CONSORTIUM PRIVATE LIMITED",
"RSSOM POWER SOLUTION (OPC) PRIVATE LIMITED",
"RSSP INFRAZONE INDIA PRIVATE LIMITED",
"RSSS CORPORATE SERVICES PRIVATE LIMITED",
"RST AIR CONDITIONING SYSTEMS PRIVATE LIMITED",
"RST DAIRY PRIVATE LIMITED",
"RST FUEL DELIVERY PRIVATE LIMITED",
"RST HEALTHCARE PRIVATE LIMITED",
"RST INDIA PRIVATE LIMITED",
"RST INFOCOM PRIVATE LIMITED",
"RST INFRASTRUCTURE PRIVATE LIMITED",
"RST LOGISTICS & CARRIERS PRIVATE LIMITED",
"RST POWER PROJECTS PRIVATE LIMITED",
"RST SEMICONDUCTORS PRIVATE LIMITED",
"RST TECHNOLOGIES PRIVATE LIMITED",
"RST WEB SOLUTIONS PRIVATE LIMITED",
"RSTAR TECHNOLOGIES PRIVATE LIMITED",
"RSTD INFRA PROJECTS PRIVATE LIMITED",
"RSUCESS LADDER EVENT PRIVATE LIMITED",
"RSV BUILDERS PRIVATE LIMITED",
"RSV COMMODITIES PRIVATE LIMITED",
"RSV FACILITY SERVICES PRIVATE LIMITED",
"RSV GLOBAL EXPRESS PRIVATE LIMITED",
"RSV HOSPITAL PRIVATE LIMITED",
"RSV IDEES DESIGN INDIA PRIVATE LIMITED",
"RSV INDUSTRIES INDIA PRIVATE LIMITED",
"RSV RICE INDUSTRIES",
"RSVK RESTAURANT PRIVATE LIMITED",
"RSVP CLOTHING PRIVATE LIMITED",
"RSVR TECHNOLOGIES PRIVATE LIMITED",
"RSVS IMPEX PRIVATE LIMITED",
"RSW STEEL PRIVATE LIMITED",
"RSWASTIK INDUSTRIES PRIVATE LIMITED",
"RSWM LIMITED",
"RSY INFRATECH PRIVATE LIMITED",
"RSYA DHANBAD AUTO PRIVATE LIMITED",
"RT CARPETS INDIA 2017 PRIVATE LIMITED",
"RT CREATION PRIVATE LIMITED",
"RT FASHION PRIVATE LIMITED",
"RT GLOBAL INFOSOLUTIONS PRIVATE LIMITED",
"RT JARI GOTA CENTRE",
"RT NETWORK SOLUTIONS PRIVATE LIMITED",
"RT PRINT TECHNOLOGY PRIVATE LIMITED",
"RT RENEWABLE ENERGY INDIA PRIVATE LIMITED",
"RT TRICONE DESIGN AND BUILD CONTRACTORS PRIVATE.LIMITED.",
"RT VILLA PRIVATE LIMITED",
"RT VISION TECHNOLOGIES PRIVATE LIMITED",
"RT WOVENSACK MACHINERY SOLUTIONS",
"RTB TECHNOLOGIES PRIVATE LIMITED",
"RTBRICK INDIA PRIVATE LIMITED",
"RTC GARMENTEX INDIA PRIVATE LIMITED",
"RTC HOSPITAL TARNAKA",
"RTC HOTELS & SERVICES PRIVATE LIMITED",
"RTC INTERNATIONAL BUSINESS PRIVATE LIMITED",
"RTC KNOWLEDGE SERVICES PRIVATE LIMITED",
"RTC PULP & PAPER PRIVATE LIMITED",
"RTC RESTAURANTS INDIA LIMITED",
"RTCAMP SOLUTIONS PRIVATE LIMITED",
"RTCL LIMITED",
"RTCS HOSPITALITY PRIVATE LIMITED",
"RTD EXPRESS COURIER & CARGO LIMITED",
"R-TECH CONSTRUCTIONS PRIVATE LIMITED",
"R-TECH DEVELOPERS PRIVATE LIMITED.",
"R-TECH FACILITIES MANAGEMENT PRIVATE LIMITED",
"R-TECH INFRA CAPITAL GALLERIA LLP",
"R-TECH PRODUCTS & PACKAGING (INDIA) PRIVATE LIMITED",
"R-TECH RETAILS PRIVATE LIMITED",
"RTEC-INSTRUMENTS INDIA PRIVATE LIMITED",
"R-TEK MOULD PRIVATE LIMITED",
"RTF AUTOMATION SYSTEMS PRIVATE LIMITED",
"RTF INFRA PRIVATE LIMITED",
"RTG LOGISTICS PRIVATE LIMITED",
"RTG SHARE BROKING LIMITED",
"RTI REALITY PRIVATE LIMITED",
"RTL TECHNOLOGIES PRIVATE LIMITED",
"RTM AGRO INDUSTRIES PRIVATE LIMITED",
"RTM INVESTMENT & TRADING CO. LTD.",
"RT-MEDIBUS TECHNOLOGIES PRIVATE LIMITED",
"RTPL MARKETING PRIVATE LIMITED",
"RTS & DEPOT",
"RTS CARS RENTAL (INDIA) PRIVATE LIMITED",
"RTS FOODS INDIA PRIVATE LIMITED",
"RTS LOGISTICS PRIVATE LIMITED",
"RTS POWER CORPORATION LIMITED",
"RTS SYSTEMS PRIVATE LIMITED",
"RTSHAH JEWELLERS PRIVATE LIMITED",
"RTSTAR EXPORTS PRIVATE LIMITED",
"RTTNEWS INDIA PRIVATE LIMITED",
"RTW GLOBAL LOGISTICS",
"RU NIROGDHAM KAMAL HOSPITAL PRIVATE LIMITED",
"RUA EXPORT PRIVATE LIMITED",
"RUAAB SEWA ARTISANS PRODUCER COMPANY LIMITED",
"RUAALEO LLP",
"RUAN CONSTRUCTIONS PRIVATE LIMITED",
"RUAN LIFE SCIENCES PRIVATE LIMITED",
"R-UAV INDIA PRIVATE LIMITED",
"RUBA PACKAGERS PVT LTD",
"RUBAIR BALLOONS INDIA PRIVATE LIMITED",
"RUBAL LOGISTICS PRIVATE LIMITED",
"RUBAMIN PRIVATE LIMITED",
"RUBAN PATLIPUTRA HOSPITAL PRIVATE LIMITED",
"RUBANBRIDGE PRIVATE LIMITED",
"RUBBER GENERAL INDUSTRIES INDIA PRIVATE LIMITED",
"RUBBER KING TYRE PRIVATE LIMITED",
"RUBBER MATTERS PRIVATE LIMITED",
"RUBBER O MALABAR PRODUCTS PRIVATE LIMITED",
"RUBBER POWER INDUSTRIES PRIVATE LIMITED",
"RUBBER TRADERS INDIA PRIVATE LIMITED",
"RUBBER, CHEMICAL & PETROCHEMICAL SKILL DEVELOPMENT COUNCIL",
"RUBBERKING TYRES INDIA PRIVATE LIMITED",
"RUBBERMAC PRIVATE LIMITED",
"RUBBERMAN ENTERPRISES PRIVATE LIMITED",
"RUBBERMAN INDUSTRIAL CENTRE PRIVATE LIMITED",
"RUBBERSINDIA POLYMER PRODUCTS PRIVATE LIMITED",
"RUBBERWALA HOUSING & INFRASTRUCTURE LIMITED",
"RUBBERWALA HOUSING & INFRASTRUCTURE PRIVATE LIMITED",
"RUBBO QUEEN HEALTH CARE PRODUCTS PRIVATE LIMITED",
"RUBCHEM INDIA PVT.LTD.",
"RUBCO COCONUTS INDIA PRIVATE LIMITED",
"RUBCO HUAT WOODS PRIVATE LIMITED",
"RUBCO SALES INTERNATIONAL PRIVATE LIMITED",
"RUBECON COMMUNICATIONS PRIVATE LIMITED",
"RUBEK BALLOONS PRIVATE LIMITED",
"RUBEL FLORIST PVT LTD",
"RUBEXCO PRIVATE LIMITED",
"RUBHA MEDICAL CENTRE & HOSPITAL PRIVATE LIMITED",
"RUBI LIFE SCIENCES PRIVATE LIMITED",
"RUBICAN RUBBER WORKS PRIVATE LIMITED",
"RUBICO IT PRIVATE LIMITED",
"RUBICON BEVERAGES PRIAVTE LIMITED",
"RUBICON CONSUMER HEALTHCARE PRIVATE LIMITED",
"RUBICON ENGINEERS PRIVATE LIMITED",
"RUBICON EQUIPMENT INDIA PRIVATE LIMITED",
"RUBICON EXIM PRIVATE LIMITED",
"RUBICON FORMULATIONS PRIVATE LIMITED",
"RUBICON HEALTHCARE PRIVATE LIMITED",
"RUBICON INSPECTION SYSTEMS PRIVATE LIMITED",
"RUBICON PROJECT MANAGEMENT PRIVATE LIMITED",
"RUBICON RESEARCH PRIVATE LIMITED",
"RUBICON SKILL DEVELOPMENT PRIVATE LIMITED",
"RUBIK CUBE TECHNOLOGY INDIA PRIVATE LIMITED",
"RUBIK INFOTECH PRIVATE LIMITED",
"RUBIKA INDIA PRIVATE LIMITED",
"RUBIKS AGENCIES & RESORTS PRIVATE LIMITED",
"RUBIKZ CUBE PRIVATE LIMITED",
"RUBINO INDUSTRIES PRIVATE. LIMITED.",
"RUBINSHA EXPORTS PRIVATE LIMITED",
"RUBIQUE TECHNOLOGIES INDIA PRIVATE LIMITED",
"RUBIS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"RUBISCAPE PRIVATE LIMITED",
"RUBIX ANALYTICS PRIVATE LIMITED",
"RUBIX AUTOMATION PRIVATE LIMITED",
"RUBIX DATA SCIENCES PRIVATE LIMITED",
"RUBIX ENTERPRISES PRIVATE LIMITED",
"RUBIX TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"RUBIX108 TECHNOLOGIES PRIVATE LIMITED",
"RUBIXIS TECHNOLOGIES PRIVATE LIMITED",
"RUBIX-TECH SERVICES PRIVATE LIMITED",
"RUBIYAN FOOD FACTORIES PRIVATE LIMITED",
"RUBRICK CONSTRUCTIONS PRIVATE LIMITED",
"RUBRICS HEALTHCARE PRIVATE LIMITED",
"RUBRIK INDIA PRIVATE LIMITED",
"RUBRIK INFRASTRUCTURE PRIVATE LIMITED",
"RUBY AGENCIES (DELHI) PRIVATE LIMITED",
"RUBY AILCARE SERVICES PRIVATE LIMITED",
"RUBY BIOPHARMA PRIVATE LIMITED",
"RUBY BUS PRIVATE LIMITED",
"RUBY CERAMICS PRIVATE LIMITED",
"RUBY CONFECTIONERY PRIVATE LIMITED",
"RUBY COTEX PRIVATE LIMITED",
"RUBY DEVELOPERS & CONSTRUCTORS PRIVATE LIMITED",
"RUBY ENGLISH HIGH SCHOOL",
"RUBY FASHIONS PRIVATE LIMITED",
"RUBY FOOD PRODUCTS PRIVATE LIMITED",
"RUBY FOREX PRIVATE LIMITED",
"RUBY GENERAL HOSPITAL PRIVATE LIMITED",
"RUBY GROWTH ADVISORY PRIVATE LIMITED",
"RUBY HALL CLINIC",
"RUBY HALL CLINIC SERVICES PRIVATE LIMITED",
"RUBY HOME HOLDINGS PRIVATE LIMITED",
"RUBY HOSPITAL",
"RUBY MICA COMPANY LIMITED",
"RUBY ORGANICS PRIVATE LIMITED",
"RUBY PAINTS PRIVATE LIMITED",
"RUBY RAHUL RICE MILLS PRIVATE LIMITED",
"RUBY SAND AND AGGREGATES PRIVATE LIMITED",
"RUBY STONES PRIVATE LIMITED",
"RUBY STRIPS PRIVATE LIMITED",
"RUBY SURGICAL AND ALLIED PRODUCTS PRIVATE LIMITED",
"RUBY TOUR & SERVICES PRIVATE LIMITED",
"RUBY TRADELINK PRIVATE LIMITED",
"RUBYIANS PRIVATE LIMITED",
"RUBYPRIME DEVELOPERS PRIVATE LIMITED",
"RUC INDUSTRIAL SOLUTIONS PRIVATE LIMITED",
"RUCERU COUTURE PRIVATE LIMITED",
"RUCHA ENGINEERS PRIVATE LIMITED",
"RUCHA MEDITECH PRIVATE LIMITED",
"RUCHAK AGRIVENTURES PRIVATE LIMITED",
"RUCHEE INTERLINING PRIVATE LIMITED",
"RUCHI AGRI FRESH PRIVATE LIMITED",
"RUCHI AGRI INPUTS PRIVATE LIMITED",
"RUCHI AGRICOM INDIA PRIVATE LIMITED",
"RUCHI AGRO PRODUCTS PVT LTD",
"RUCHI BAKERS PRIVATE LIMITED",
"RUCHI ENERGY SOLUTION PRIVATE LIMITED",
"RUCHI FABRICS PRIVATE LIMITED",
"RUCHI FORGING & FABRICATION PRIVATE LIMITED",
"RUCHI GAS AND INFRATECH PRIVATE LIMITED",
"RUCHI GLOBAL LIMITED",
"RUCHI HI RICH SEEDS PRIVATE LIMITED",
"RUCHI HOSPITALITY PRIVATE LIMITED",
"RUCHI INFOTECH",
"RUCHI INFRASTRUCTURE LIMITED",
"RUCHI MALLS PRIVATE LIMITED",
"RUCHI MEDICAL PRIVATE LIMITED",
"RUCHI MENTHOL PRIVATE LIMITED",
"RUCHI ORGANICS LIMITED",
"RUCHI PACKAGING PRIVATE LIMITED",
"RUCHI PRIYA DEVELOPERS PRIVATE LIMITED",
"RUCHI REALTY PRIVATE LIMITED",
"RUCHI RENEWABLE ENERGY PRIVATE LIMITED",
"RUCHI RESTAURANTS PRIVATE LIMITED",
"RUCHI RISHI HOSPITALITY PRIVATE LIMITED",
"RUCHI SECURITY PRINTERS PRIVATE. LIMITED.",
"RUCHI STEELS PRIVATE LIMITED",
"RUCHI SYNTHETICS PVT LTD",
"RUCHI TELECOM PRIVATE LIMITED",
"RUCHI TWISTERS PVT LTD",
"RUCHI WORLDWIDE LIMITED",
"RUCHIKA BUILDCON",
"RUCHIKA CHEMICAL INDUSTRIES PRIVATE LIMITED",
"RUCHIKA FINVEST PVT LTD",
"RUCHIKA PRINTS PRIVATE LIMITED",
"RUCHIKA TRADES PVT LTD",
"RUCHIKA VINIMAY PRIVATE LIMITED",
"RUCHILI FOODS PRIVATE LIMITED",
"RUCHIPACK INDUSTRIES PRIVATE LIMITED",
"RUCHIRA EXPORT PRIVATE LIMITED",
"RUCHIRA GREEN EARTH PRIVATE LIMITED",
"RUCHIRA JEWELLERS PRIVATE LIMITED",
"RUCHIRA PAPERS LIMITED",
"RUCHIRA PRINTING AND PACKAGING",
"RUCHIRAJ TRADELINKS PRIVATE LIMITED",
"RUCHIT REALTY PRIVATE LIMITED",
"RUCHIT TRADING PRIVATE LIMITED",
"RUCHITA OVERSEAS PRIVATE LIMITED",
"RUCKMANI AMMAL COTSPIN PRIVATE LIMITED",
"RUCKUS WIRELESS PRIVATE LIMITED",
"RUD INDIA CHAIN PRIVATE LIMITED",
"RUD INFRA BUILDER PRIVATE LIMITED",
"RUDAI LIGHTING PRIVATE LIMITED",
"RUDANI & RUDANI PRIVATE LIMITED",
"RUDANI DECORS PRIVATE LIMITED",
"RUDANI ENTERPRISES PRIVATE LIMITED",
"RUDAWAL CAPITAL TRUST LIMITED",
"RUDAYA POWERS PRIVATE LIMITED",
"RUDDER ANALYTICS PRIVATE LIMITED",
"RUDDER LABS INDIA PRIVATE LIMITED",
"RUDER FINN PR INDIA PRIVATE LIMITED",
"RUDHOLM & HAAK INDIA PRIVATE LIMITED",
"RUDHRA CONSTRUCTIONS PRIVATE LIMITED",
"RUDHRA FOOD PRODUCTS PRIVATE LIMITED",
"RUDHRAKSHA AGRO INDIA PRIVATE LIMITED",
"RUDI MULTI TRADING COMPANY LIMITED",
"RUDI ROLLERS FLOUR MILL PRIVATE LIMITED",
"RUDIMENT EDUCATIONAL SERVICES PRIVATE LIMITED",
"RUDINLIFE HEALTH CARE SERVICES PRIVATE LIMITED",
"RUDNAV INFRA PRIVATE LIMITED",
"RUDOLF ATUL CHEMICALS LIMITED",
"RUDRA ALLOYS PRIVATE LIMITED",
"RUDRA ARCHITECTURAL SOLUTIONS PRIVATE LIMITED",
"RUDRA AUTO DISTRIBUTOR PRIVATE LIMITED",
"RUDRA AUTOMART PRIVATE LIMITED",
"RUDRA AUTOMOTIVES PRIVATE LIMITED",
"RUDRA AUTOMOVERS PRIVATE LIMITED",
"RUDRA BIOVENTURES PRIVATE LIMITED",
"RUDRA BLADES & EDGES PRIVATE LIMITED",
"RUDRA BUILDWELL INFRA PRIVATE LIMITED",
"RUDRA BUILDWELL PROJECTS PRIVATE.LIMITED.",
"RUDRA CASTING PRIVATE LIMITED",
"RUDRA CENTRE SERVICES PRIVATE LIMITED",
"RUDRA CIVICONS PRIVATE LIMITED",
"RUDRA COMMERCIAL PRIVATE LIMITED",
"RUDRA COTTEX PRIVATE LIMITED",
"RUDRA COTTON HOUSE PRIVATE LIMITED",
"RUDRA ECOSPIN RECYCLERS LIMITED",
"RUDRA FACILITY SERVICES",
"RUDRA FARMS AGROTECH PRIVATE LIMITED",
"RUDRA FARMS AND PROCESSING PRIVATE LIMITED",
"RUDRA FOREX PRIVATE LIMITED",
"RUDRA GAS ENTERPRISE LIMITED",
"RUDRA GAS ENTERPRISE PRIVATE LIMITED",
"RUDRA GLOBAL INFRA PRODUCTS LIMITED",
"RUDRA GREEN SHIP RECYCLING PRIVATE LIMITED",
"RUDRA HERBALS PRIVATE LIMITED",
"RUDRA IMPLEMENTS PRIVATE LIMITED",
"RUDRA INFORMATICS PRIVATE LIMITED",
"RUDRA INFRACITY PRIVATE LIMITED",
"RUDRA INFRADEVELOPERS PRIVATE LIMITED",
"RUDRA INFRAPROJECTS PRIVATE LIMITED",
"RUDRA INFRATECH PRIVATE LIMITED",
"RUDRA INTERNATIONAL PUBLIC SCHOOL",
"RUDRA INVESTMENTS PRIVATE LIMITED",
"RUDRA KNITTINGS PRIVATE LIMITED",
"RUDRA KRAFT CARTONS PRIVATE LIMITED",
"RUDRA LABOUR SERVICES",
"RUDRA MARINE SERVICES",
"RUDRA MARKETING AGENCY PRIVATE LIMITED",
"RUDRA MERCANTILE PRIVATE LIMITED",
"RUDRA MERCHANTS PRIVATE LIMITED",
"RUDRA METALS",
"RUDRA MINERALS PRIVATE LIMITED",
"RUDRA NAVNIRMAN PRIVATE LIMITED",
"RUDRA PACK SOLUTIONS PRIVATE LIMITED",
"RUDRA PACKERS AND MOVERS PRIVATE LIMITED",
"RUDRA PAILS INDIA PRIVATE LIMITED",
"RUDRA PET PACK INDIA PRIVATE LIMITED",
"RUDRA PRIYA TRADERS PRIVATE LIMITED",
"RUDRA PROFESSIONAL SERVICES PRIVATE LIMITED",
"RUDRA PUBLIC SCHOOL",
"RUDRA REAL ESTATE PRIVATE LIMITED",
"RUDRA REALTECH PRIVATE LIMITED",
"RUDRA SECURITY GUARDS PRIVATE LIMITED",
"RUDRA SHAKTI AGROVET PRIVATE LIMITED",
"RUDRA SHARES & STOCK BROKERS LIMITED",
"RUDRA SHREE AUTOWHEELS PRIVATE LIMITED",
"RUDRA SOLARFARMS PRIVATE LIMITED",
"RUDRA STEEL ROLLING MILL",
"RUDRA STONES EXPORTS PRIVATE LIMITED",
"RUDRA TECHNO FEEDS",
"RUDRA URJA PRIVATE LIMITED",
"RUDRA WAREHOUSING PRIVATE LIMITED",
"RUDRA WOODPACK PRIVATE LIMITED",
"RUDRAA WOODENBOX INDUSTRIES PRIVATE LIMITED",
"RUDRABHISHEK ENTERPRISES LIMITED",
"RUDRABHISHEK INFOSYSTEM PRIVATE LIMITED",
"RUDRAFERT AGRO TECH PRIVATE LIMITED",
"RUDRAINFRA ENGINEERING PRIVATE LIMITED",
"RUDRAJEET SHIPPING SERVICES PRIVATE LIMITED",
"RUDRAKASH VYAPAAR PRIVATE LIMITED",
"RUDRAKSH ACADEMY PRIVATE LIMITED",
"RUDRAKSH CATERERS PRIVATE LIMITED",
"RUDRAKSH CHEMICALS PRIVATE LIMITED",
"RUDRAKSH CLUB & RESORT",
"RUDRAKSH DETERGENT AND CHEMICALS PRIVATE LIMITED",
"RUDRAKSH ENGITECH PRIVATE LIMITED",
"RUDRAKSH ENVIROCARE PRIVATE LIMITED",
"RUDRAKSH INFRANIRMAN PRIVATE LIMITED",
"RUDRAKSH IRON PRODUCTS PRIVATE LIMITED",
"RUDRAKSH LAMINATES PRIVATE LIMITED",
"RUDRAKSH LOGISTICS PRIVATE LIMITED",
"RUDRAKSH MEGACORP PRIVATE LIMITED",
"RUDRAKSH MICRONS PRIVATE LIMITED",
"RUDRAKSH MINECHEM PRIVATE LIMITED",
"RUDRAKSH OVERSEAS PRIVATE LIMITED",
"RUDRAKSH PAPERS PRIVATE LIMITED",
"RUDRAKSH PHARMA AND SURGICO PRIVATE LIMITED",
"RUDRAKSH PLASTICS PRIVATE LIMITED",
"RUDRAKSH PSYLLIUM PRIVATE LIMITED",
"RUDRAKSH SOLVENT PRIVATE LIMITED",
"RUDRAKSH SYNTHETIC PRIVATE LIMITED",
"RUDRAKSH TECHNOCAST PRIVATE LIMITED",
"RUDRAKSH TRADELINKS LIMITED",
"RUDRAKSHA ALLIED CHEMICAL PRIVATE LIMITED",
"RUDRAKSHA CERAMARKETING PRIVATE LIMITED",
"RUDRAKSHA CERAMIC PRIVATE LIMITED",
"RUDRAKSHA CREATION PRIVATE LIMITED",
"RUDRAKSHA ENGINEERS AND CONTRACTORS PRIVATE LIMITED",
"RUDRAKSHA ENVIROTECH PRIVATE LIMITED",
"RUDRAKSHA HOSPITAL",
"RUDRAKSHA HOTELS PVT LTD",
"RUDRAKSHA MULTISPECIALITY HOSPITALS",
"RUDRAKSHA TECH LABS PRIVATE LIMITED",
"RUDRAKSHA VEHICLE PRIVATE LIMITED",
"RUDRALCO EXTRUSION LIMITED",
"RUDRALCO EXTRUSION PRIVATE LIMITED",
"RUDRALI HI TECH TOOLS PRIVATE LIMITED",
"RUDRALI JEWELS PRIVATE LIMITED",
"RUDRAM MARKET DEVELOPMENT SERVICES PRIVATE LIMITED",
"RUDRAM PHRONESIS INFRAZ PRIVATE LIMITED",
"RUDRAMAHADEV CHEMICALS PRIVATE LIMITED",
"RUDRAMAHADEVA SPACES PRIVATE LIMITED",
"RUDRAMBI INITIATORS PRIVATE LIMITED",
"RUDRANI COLD STORAGE PRIVATE LIMITED",
"RUDRANI ELECTRO ENGRAVING PRIVATE LIMITED",
"RUDRANI FABRICS PRIVATE LIMITED",
"RUDRANI GLOBAL AUTOSPRING PRIVATE LIMITED",
"RUDRANI INFRASOLUTIONS PRIVATE LIMITED",
"RUDRANSH INDUSTRIES PRIVATE LIMITED",
"RUDRANSH INFRA-TRADE PRIVATE LIMITED",
"RUDRAPPASAMY SCHOOL",
"RUDRAPRATAP INDIAN LOGISTIC PUNE PRIVATE LIMITED",
"RUDRAPRATAP INDIAN LOGISTICS (AHMEDABAD) PRIVATE LIMITED",
"RUDRAPRAYAG FOODS PRIVATE LIMITED",
"RUDRAPRAYAG INFRA DEVELOPERS PRIVATE LIMITED",
"RUDRAPRIYA PACKAGING PRIVATE LIMITED",
"RUDRAPRIYA RETAILERS PRIVATE LIMITED",
"RUDRAPRIYAM IMPEX PRIVATE LIMITED",
"RUDRAPUR MRI & DIAGNOSTICS PRIVATE LIMITED",
"RUDRAPUR SOLVENTS PRIVATE LIMITED",
"RUDRASHAKTI INFRASTRUCTURE PRIVATE LIMITED",
"RUDRASHTAK CONSULTANTS LLP",
"RUDRASOL ENERGY PRIVATE LIMITED",
"RUDRASREE HOUSING PRIVATE LIMITED",
"RUDRATARA INTERNATIONAL PRIVATE LIMITED",
"RUDRAVEERYA DEVELOPERS LIMITED",
"RUDRAVEERYA INFRAPROJECTS PRIVATE LIMITED",
"RUDRAX LOGICARE PRIVATE LIMITED",
"RUDRAX POLYMERS PRIVATE LIMITED",
"RUDRAYA ROAD PATCHERS PRIVATE LIMITED",
"RUDVEDA INTERNATIONAL TRADING PRIVATE LIMITED",
"RUEI INDUSTRIES PRIVATE LIMITED",
"RUETEX TEXTILE PRIVATE LIMITED",
"RUFOUZ HITEK ENGINEERS PRIVATE LIMITED",
"RUFUTECH SYSTEMS PRIVATE LIMITED",
"RUGBY PHARMA PRIVATE LIMITED",
"RUGBY RENERGY PRIVATE LIMITED",
"RUGGED SOLAR PRODUCTS PRIVATE LIMITED",
"RUGLAS MEDIA PRIVATE LIMITED",
"RUGS CREATION COMPANY",
"RUGS IN STYLE INCORPORATION",
"RUGSOTIC PRIVATE LIMITED",
"RUGVED HOTELS PRIVATE LIMITED",
"RUHA TEK PACK PRIVATE LIMITED",
"RUHAAN SKYSCRAPERS INDIA PRIVATE LIMITED",
"RUHAANII MILK PRODUCER COMPANY LIMITED",
"RUHANI INDUSTRIES PRIVATE LIMITED",
"RUHATIYA COTTON AND METAL PRIVATE LIMITED",
"RUHATIYA SPINNERS PRIVATE LIMITED",
"RUHE SOLUTIONS PRIVATE LIMITED",
"RUHELA CONSTRUCTION COMPANY PRIVATE LIMITED",
"RUHI FOREX PRIVATE LIMITED",
"RUHI LODGING PRIVATE LIMITED",
"RUHI TOOLING PRIVATE LIMITED",
"RUHIL INFRAPROJECTS PRIVATE LIMITED",
"RUHLAMAT AUTOMATION TECHNOLOGIES INDIA PRIVATE LIMITED",
"RUHR ISPAT PRIVATE LIMITED",
"RUHRPUMPEN INDIA PRIVATE LIMITED",
"RUI CHUANG TECHNOLOGIES PRIVATE LIMITED",
"RUI LABORATORIES PRIVATE LIMITED",
"RUI STEEL INDIA PRIVATE LIMITED",
"RUIA ALLOY TRADE PRIVATE LIMITED",
"RUIA CARS PRIVATE LIMITED",
"RUIA CHEMICALS PRIVATE LIMITED",
"RUIA FABRICS PRIVATE LIMITED",
"RUIA GARMENTS PRIVATE LIMITED",
"RUIA GASES PRIVATE LIMITED",
"RUIA INTERNATIONAL HOLDING COMPANY PRIVATE LIMITED",
"RUIA MARKETING LTD.",
"RUIA RESISTANCE WIRES PRIVATE LIMITED",
"RUIA SILK AND SYNTHETICS PVT LTD",
"RUIAN ZHENJING MACHINERY PRIVATE LIMITED",
"RUJA IMPEX PRIVATE LIMITED",
"RUJAL FOODS PRIVATE LIMITED",
"RUJHAAN CREATIONS PRIVATE LIMITED",
"RUJUVALIKA INVESTMENTS LIMITED",
"RUKARE ROADLINES LLP",
"RUKE RETAIL PRIVATE LIMITED",
"RUKHMAI GOVIND NIWASI VIDYALAYA PANGRI ROAD BEED",
"RUKHMAI INFRASTRUCTURES PRIVATE LIMITED",
"RUKMAN FABRICS PRIVATE LIMITED",
"RUKMANI AMUSEMENTS LIMITED",
"RUKMANI BEVERAGES PRIVATE LIMITED",
"RUKMANI BIRLA MODERN HIGH SCHOOL",
"RUKMANI BUILDTECH LIMITED",
"RUKMANI ELECTRICAL & COMPONENTS PVT LTD",
"RUKMANI ENGINEERING & TECHNICAL SOLUTION",
"RUKMANI FORGINGS PRIVATE LIMITED",
"RUKMANI IMPEX PRIVATE LIMITED",
"RUKMANI ISPAT PRIVATE LIMITED",
"RUKMANI JEWELLERS PRIVATE LIMITED",
"RUKMANI METALS AND GASEOUS PRIVATE LIMITED",
"RUKMANI MOTORS PRIVATE. LIMITED.",
"RUKMANI PARASMANI FLAT HOLDERS ASSOCIATION",
"RUKMANI POLYMERS PRIVATE LIMITED",
"RUKMANI POWER AND STEEL LIMITED",
"RUKMANI PROPERTY PROJECT PRIVATE LIMITED",
"RUKMANI PROTEINS PRIVATE LIMITED",
"RUKMANI RETAILS PRIVATE LIMITED",
"RUKMANI STEEL AND INFRA PRIVATE LIMITED",
"RUKMARANI CARS INDORE PRIVATE LIMITED",
"RUKMI FOOD PRODUCTS PRIVATE LIMITED",
"RUKMINI COLD STORAGE PRIVATE LIMITED",
"RUKMINI DEVI PUBLIC SCHOOL",
"RUKMINI EDUCATIONAL CHARITABLE TRUST",
"RUKMINI ENERGY PRIVATE LIMITED",
"RUKMINI IRON PRIVATE LIMITED",
"RUKMINI PACK PRINT PRIVATE LIMITED",
"RUKMINI POLYTUBES PRIVATE LIMITED",
"RUKMINI PROPERTIES PVT LTD",
"RUKMINI TRADEFIN PVT LTD",
"RUKMINIRAMA STEEL ROLLINGS PRIVATE LIMITED",
"RUKSH ENTERPRISES",
"RUKSH GARMENTS PRIVATE LIMITED",
"RUKSHMANI SYNTEX PRIVATE LIMITED",
"RUKSON HOTELS PRIVATE LIMITED",
"RUKSON PACKAGING PRIVATE LIMITED",
"RUKY PROJECTS PRIVATE LIMITED",
"RULE 14 INDIA PRIVATE LIMITED",
"RULEX SECURITY GROUP PRIVATE LIMITED",
"RULEZERO TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"RULING LPES INTERNATIONAL PRIVATE LIMITED",
"RULKA ELECTRICALS LIMITED",
"RULKA ELECTRICALS PRIVATE LIMITED",
"RULOANS DISTRIBUTION SERVICES PRIVATE LIMITED",
"RULZ DIAMONDS PRIVATE LIMITED",
"RUMA MOBILE ANDELECTRONICS",
"RUMA STEELS PRIVATE LIMITED",
"RUMANA TRANSPORT PRIVATE LIMITED",
"RUMARK CONSULTANTS AND MERCHANTS PRIVATE LIMITED",
"RUMAX INTERNATIONAL PRIVATE LIMITED",
"RUMBUM SOFTWARE SERVICE PRIVATE LIMITED",
"RUMI EDUCATION PRIVATE LIMITED",
"RUMI HERBALS P LTD",
"RUMIT CHEMISYNTH PRIVATE LIMITED",
"RUMITECH NUTRITION (INDIA) PRIVATE LIMITED",
"RUMMYTIME TECHNOLOGIES PRIVATE LIMITED",
"RUMOR AVENUE TECHNOLOGIES PRIVATE LIMITED",
"RUN ADAM SPORTS PRIVATE LIMITED",
"RUN SECURITY SERVICES PRIVATE LIMITED",
"RUN SERVICE INFOCARE PRIVATE LIMITED",
"RUN TIME SOLUTIONS PRIVATE LIMITED",
"RUN TOTO PRIVATE LIMITED",
"RUN WELL INDIA PRIVATE LIMITED",
"RUNA CHEMICALS PRIVATE LIMITED",
"RUNAWARE SOFTWARE PRIVATE LIMITED",
"RUNCODE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"RUNGAJAUN TEA & PLANTATION INDUSTRIES PVT LTD",
"RUNGAMATTEE TEA & INDUSTRIES LTD",
"RUNGATA COLLEGE OF ENGINEERING AND TECHNOLOGY",
"RUNGTA AGENCIES PVT LTD",
"RUNGTA ART PROCESSORS INDIA PRIVATE LIMITED",
"RUNGTA BUILDWELL PRIVATE LIMITED",
"RUNGTA COLLEGE OF ENGINEERING & TECHNOL",
"RUNGTA COLLEGE OF PHARMACEUTICAL SCIENCE & RESEARCH",
"RUNGTA DENTAL COLLEGE",
"RUNGTA GLOBAL FOOD AND BEVERAGES PRIVATE LIMITED",
"RUNGTA GREENTECH LIMITED",
"RUNGTA HOSPITAL",
"RUNGTA INDUSTRIES PRIVATE LIMITED",
"RUNGTA INSTITUTE OF PHARMACEUTICAL SCIENCE",
"RUNGTA IRON & STEEL PRIVATE LIMITED",
"RUNGTA IRRIGATION LIMITED",
"RUNGTA MINES LIMITED",
"RUNGTA RAYON TEX PRIVATE. LIMITED.",
"RUNGTA SONS PRIVATE. LIMITED RUNGTA GROUP ENTITY",
"RUNGTA TEA PRIVATE LIMITED",
"RUNGTA YARN PRIVATE LIMITED",
"RUNH POWER INDIA PRIVATE LIMITED",
"RUNNER FOOTCARE PRIVATE LIMITED",
"RUNNER MARKETING PRIVATE LIMITED",
"RUNTHROUGH SECURE SOLUTIONS PRIVATE LIMITED",
"RUNWAL AGRI-TECH PRIVATE LIMITED",
"RUNWAL BUILDERS PRIVATE LIMITED",
"RUNWAL DEVELOPERS PRIVATE LIMITED",
"RUNWAL FABRICS PRIVATE LIMITED",
"RUNWAL FARMS PRIVATE LIMITED",
"RUNWAL HOMES PRIVATE LIMITED",
"RUNWAL HOUSING & TOWNSHIPS PRIVATE LIMITED",
"RUNWAL PROJECTS PRIVATE LIMITED",
"RUNWAL REALTY PRIVATE LIMITED",
"RUNWAL RESIDENCY PRIVATE LIMITED",
"RUNWAY LIFESTYLE EVENTS PRIVATE LIMITED",
"RUNWAY RISING PRIVATE LIMITED",
"RUNWELL INDUSTRIES (INDIA) PRIVATE LIMITED",
"RUNZZIT TECHNOLOGIES PRIVATE LIMITED",
"RUP DARSHI SAREES PRIVATE LIMITED",
"RUP NAGAR FOOD PRODUCTS PRIVATE LIMITED",
"RUP SHAREE FASHION PRIVATE LIMITED",
"RUPA & COMPANY LIMITED",
"RUPA BUILDCON PRIVATE LIMITED",
"RUPA CONFECTIONERY PRIVATE LIMITED",
"RUPA DAIRY FARMS PRIVATE LIMITED",
"RUPA ENTERPRISES PRIVATE LIMITED",
"RUPA EQUITIES PRIVATE LIMITED",
"RUPA EXPORTS PVT LTD",
"RUPA INFOTECH AND INFRASTRUCTURE PRIVATE LIMITED",
"RUPA INVESTMENTS LIMITED",
"RUPA ORGANICS PRIVATE LIMITED",
"RUPA PUBLICATIONS INDIA PRIVATE LIMITED",
"RUPA RENAISSANCE LIMITED",
"RUPA TEXTILES PRIVATE LIMITED",
"RUPACARGO GLOBAL LOGISTICS PRIVATE LIMITED",
"RUPAHALI SAREES PVT LTD",
"RUPAK TRADING PVT LTD",
"RUPAKAR REAL ESTATE PRIVATE LIMITED",
"RUPAL INFRASTRUCTURE PVT LTD",
"RUPAL PLASTICS PRIVATE LIMITED",
"RUPALI AGRO PRIVATE LIMITED",
"RUPALI CONFECTIONERY INDIA PRIVATE LIMITED",
"RUPALI LOGISTICS CLEARING & FORWARDING PRIVATE LIMITED",
"RUPALI MARBLES PRIVATE LIMITED",
"RUPAM ENTERTAINMENT PRIVATE LIMITED",
"RUPAM MANUFACTURING AND TRADING PRIVATE LIMITED",
"RUPAM STEEL PVT LTD",
"RUPAMATA AGROTECH PRIVATE LIMITED",
"RUPAN RAJ CATERERS PRIVATE LIMITED",
"RUPAREL DEVELOPERS INDIA PRIVATE LIMITED",
"RUPAREL ESTATES INDIA PRIVATE LIMITED",
"RUPAREL FOODS PRIVATE LIMITED",
"RUPAREL INFRA & REALTY PRIVATE LIMITED",
"RUPAREL NETS PVT LTD",
"RUPAREL PLASTICS PVT LTD",
"RUPASHREE HEALTHCARE PRIVATE LIMITED",
"RUPASI RUPNARAYAN KUTHI PRIVATE LIMITED",
"RUPAYAN REALTY PRIVATE LIMITED",
"RUPCHAND B. ELECTRICALS PRIVATE LIMITED",
"RUPDARSHI DESIGNS PRIVATE LIMITED",
"RUPDARSHI HERITAGE PRIVATE LIMITED",
"RUPEE CO-OP BANK LTD",
"RUPEEBOSS FINANCIAL SERVICES PRIVATE LIMITED",
"RUPEEK CAPITAL PRIVATE LIMITED",
"RUPEESEED TECHNOLOGY VENTURES PRIVATE LIMITED",
"RUPEN INVESTMENT AND INDUSTRIES PRIVATE LIMITED",
"RUPESH & COMPANY",
"RUPESH KUMAR AND SONS",
"RUPH STRIPS PRIVATE LIMITED",
"RUPITOL FINANCE PRIVATE LIMITED",
"RUPKALA ENGINEERS PRIVATE LIMITED",
"RUPMAYA SHOE LAST INDUSTRIES PRIVATE LIMITED",
"RUPNARAYAN AGENCIES PRIVATE LIMITED",
"RUPNARAYAN CABLE & BROADBAND SERVICES PRIVATE LIMITED",
"RUPRI CONSULTANCY PRIVATE LIMITED",
"RUPRIT AGENCY PRIVATE LIMITED",
"RUPS MEDIPACK PRIVATE LIMITED",
"RUPSHA FISH PRIVATE LIMITED",
"RUPSHA VALLEY ENGINEERING PRIVATE LIMITED",
"RUPSHEE COMMUNICATION PRIVATE LIMITED",
"RUPSING REALTORS PRIVATE LIMITED",
"RUPSTECH PRIVATE LIMITED",
"RUPTECH EDUCATIONAL INDIA",
"RUPTECH ENGINEERS PRIVATE LIMITED",
"RUPTECH THERMOPACK PRIVATE LIMITED",
"RUPTEX MINERAL WATER PRIVATE LIMITED",
"TREEBO HOSPITALITY VENTURES PRIVATE LIMITED",
"RUPVAKULA PROPERTIES PRIVATE LIMITED",
"RUR GREENLIFE PRIVATE LIMITED",
"RURAL BROADBAND PRIVATE LIMITED",
"RURAL COMMUNICATION AND MARKETING PRIVATE LIMITED",
"RURAL CRAFT AND CREATION PRIVATE LIMITED",
"RURAL DEV PANCHAYATI RAJ DEPTT",
"RURAL DEVELOPMENT & PANCHAYAT RAJ DEPARTMENT GOVERNMENT OF MAHARASHTRA",
"RURAL DEVELOPMENT & PANCHAYAT RAJ DEPT",
"RURAL DEVELOPMENT PANCHAYATRAJ DEPT",
"RURAL DEVELPMENT TRUST",
"RURAL ELECTRIFICATION CORPORATION LIMITED",
"RURAL ENGINEERING DEPARTMENT",
"RURAL HOSPITAL",
"RURAL HOSPITAL KOPARGAON",
"RURAL HOSPITAL NER",
"RURAL INFRATEL INTERNATIONAL LIMITED",
"RURAL INTERACTIVE INFOTECH (OPC) PRIVATE LIMITED",
"RURAL MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"RURAL URBAN PRODUCT DEVELOPMENT LIMITED",
"RURAL WATER SUPPLY DISTRICT HQ",
"RURAL WATER SUPPLY DIVISION ZP AMRAVATI",
"RURAL WATER SUPPLY NANDURBAR",
"RURAL WATER SUPPLY SANITATIN DIVN",
"RURALSHORES BUSINESS SERVICES PRIVATE LIMITED",
"RURASH FINANCIALS PRIVATE LIMITED",
"RURASH FINTECH PRIVATE LIMITED",
"RURBAN AGRI VENTURES INDIA PRIVATE LIMITED",
"RURBAN CLEANTECH PRIVATE LIMITED",
"RURBAN DEVELOPMENT CORPORATION PRIVATE LIMITED",
"RURIS TECNAL EXTRACTION SYSTEMS PRIVATE LIMITED",
"RURU TEK PRIVATE LIMITED",
"RUS EDUCATION INDIA PRIVATE LIMITED",
"RUS EXIM PRIVATE LIMITED",
"RUS TOURISM INDIA PRIVATE LIMITED",
"RUSA MEDICAL SERVICES PRIVATE. LIMITED.",
"RUSADA AVIATION PRIVATE LIMITED",
"RUSAN HEALTHCARE PRIVATE.LIMITED",
"RUSAN MEDISYS PRIVATE LIMITED",
"RUSAN PHARMA LIMITED",
"RUSANAV DESIGNS PRIVATE LIMITED",
"RUSECO CHEMICALS INDIA PRIVATE LIMITED",
"RUSH ENTERPRISES PRIVATE LIMITED",
"RUSH TECHMART SOLUTIONS PRIVATE LIMITED",
"RUSHABH AUTOMOBILE PRIVATE LIMITED",
"RUSHABH BLEACH CHEM PRIVATE LIMITED",
"RUSHABH DIGI INFOTECH PRIVATE LIMITED",
"RUSHABH ENGINEERING PRIVATE LIMITED",
"RUSHABH EYE HOSPITAL & LASER CENTER PRIVATE LIMITED",
"RUSHABH FLOUR MILLS PRIVATE LIMITED",
"RUSHABH GADGETS PRIVATE LIMITED",
"RUSHABH INVESTMENT PRIVATE LIMITED",
"RUSHABH INVESTMENTS PRIVATE LIMITED",
"RUSHABH JEWELLERS PRIVATE LIMITED",
"RUSHABH MARKETING SOLUTIONS PRIVATE LIMITED",
"RUSHABH MOTORS PRIVATE LIMITED",
"RUSHABH PRINTERS PRIVATE LIMITED",
"RUSHABH RESINS AND PAINTS PVT LTD",
"RUSHABH SEALINK AND LOGISTIC PRIVATE LIMITED",
"RUSHABH TECHNOCAST PRIVATE LIMITED",
"RUSHABH TRADING CO.",
"RUSHABH VINIT LABDHI JEWELS PRIVATE LIMITED",
"RUSHABHDEV INFRAPROJECTS PRIVATE LIMITED",
"RUSHABHDEV PIPES PRIVATE LIMITED",
"RUSHABHDEV TRADING PRIVATE LIMITED",
"RUSHAD WADIA HOSPITALITY PRIVATE LIMITED",
"RUSHAIL PHARMADIN PRIVATE LIMITED",
"RUSHAS ENGINEERING COMPANY PRIVATE LIMITED",
"RUSHAY COMMODITIES PRIVATE LIMITED",
"RUSHI EXIM PRIVATE LIMITED",
"RUSHI GENETICS PRIVATE LIMITED",
"RUSHIHARSH INDUSTRIES PRIVATE LIMITED",
"RUSHIKA FOOD PRODUCTS PRIVATE LIMITED",
"RUSHIKESH ELECTRICALS",
"RUSHIKESH REALITY PRIVATE LIMITED",
"RUSHIKULYA AGROTECH PRIVATE LIMITED",
"RUSHIL DECOR LIMITED",
"RUSHIL INDUSTRIES LIMITED",
"RUSHIL MICRO IT SOLUTIONS PRIVATE LIMITED.",
"RUSHIPRABHA ENGINEERS PRIVATE LIMITED",
"RUSHLANDS PRIVATE LIMITED",
"RUSHMI LOGISTICS PRIVATE LIMITED",
"RUSHMORE CONSULTANCY SERVICES PRIVATE LIMITED",
"RUSHVI FINECHEM PRIVATE LIMITED",
"RUSIA ENGINEERING PVT.LTD.",
"RUSIYA HEALTHCARE PRIVATE LIMITED",
"RUSO AGRO PROJECTS PRIVATE LIMITED",
"RUSOMA LABORATORIES PRIVATE LIMITED",
"RUSSAKA PLY INDIA LIMITED",
"RUSSELL AIRFLOW SYSEMS PRIVATE LIMITED",
"RUSSELL CREDIT LTD",
"RUSSELL FINEX SIEVES AND FILTERS PRIVATE LIMITED",
"RUSSELL INVESTMENTS LTD",
"RUSSELL REYNOLDS ASSOCIATES INDIA PRIVATE LIMITED",
"RUSSELL SQUARE INTERNATIONAL COLLEGE",
"RUSSELL TECHNOLOGIES INDIA PRIVATE LIMITED",
"RUSSELL TOBIN ASSOCIATES STAFFING SOLUTIONS INDIA PRIVATE LIMITED",
"RUSSELZ GREENPOWER LIMITED",
"RUSSH HOSPITALS PRIVATE LIMITED",
"RUSSH MEDICALS PRIVATE LIMITED",
"RUSSULA AUTOMATION AND ENGINEERING SOLUTIONS INDIA PRIVATE LIMITED",
"RUST AND RUSTED PRIVATE LIMITED",
"RUST EXIM PRIVATE LIMITED",
"RUSTAGI CHEMICALS PRIVATE LIMITED",
"RUSTAGI ESTATES PRIVATE LIMITED",
"RUSTAGI IMPEX PRIVATE LIMITED",
"RUSTAGI PLYWOOD EMPORIUM",
"RUSTAGI SURGICAL PRIVATE LIMITED",
"RUSTAM AGRIFRESH INDUSTRIES PRIVATE LIMITED",
"RUSTAM FOODS PRIVATE LIMITED",
"RUSTAMJI INSTITUTE OF TECHNOLOGY GWALIOR",
"RUSTIC CRAFTS PRIVATE LIMITED",
"RUSTIC-URBAN FOOD PARK PRIVATE LIMITED",
"RUSTOM HOSPITALITY PRIVATE LIMITED",
"RUSTOM KERAWALLA",
"RUSTOMJEE ACADEMY FOR GLOBAL CAREERS PRIVATE LIMITED",
"RUSTOMJEE CAMBRIDGE INTERNATIONAL SCHOOL",
"RUSTOMJEE KERAWALLA FOUNDATION",
"RUSTOMJEE KNOWLEDGE CITY PRIVATE LIMITED",
"RUSTOMJEE REALTY PRIVATE. LIMITED.",
"RUSTOMJIE INTERNATIONAL SCHOOL",
"RUSTOPPERS PACKTECH PRIVATE LIMITED",
"RUSUN VISION PRIVATE LIMITED",
"RUTBA PRODUCTS PRIVATE LIMITED",
"RUTH SHIPPING AGENCIES PRIVATE LIMITED",
"RUTHINIUM DENTAL PRODUCTS PRIVATE LIMITED",
"RUTHKARR IMPEX & FLUID SYSTEMS PRIVATE LIMITED",
"RUTHVI ENGG SOLUTIONS PRIVATE LIMITED",
"RUTIKA DEALMARK PRIVATE LIMITED",
"RUTMARG COMMERCIALS PRIVATE LIMITED",
"RUTSARYA WATER MANAGEMENT PRIVATE LIMITED",
"RUTTONPORE PLANTATIONS PRIVATE LIMITED",
"RUTTONSHA INTERNATIONAL RECTIFIER LIMITED",
"RUTU BIOSYS PRIVATE LIMITED",
"RUTU FINANCIAL INTERMEDIARIES PRIVATE LIMITED",
"RUTUJA COMMUNICATIONS PRIVATE LIMITED",
"RUTUJA TEXTILES PRIVATE LIMITED",
"RUTVIC INDUSTRIES PRIVATE LIMITED",
"RUTVIJ PRINTERS PRIVATE LIMITED",
"RUTVIK ENGINEERING PRIVATE LIMITED",
"RUVAAN AGRI SERVE PRIVATE LIMITED",
"RUVI INDUSTRIES PRIVATE LIMITED",
"RUVIR IMPEX PRIVATE LIMITED",
"RUX AUTOMATION PRIVATE LIMITED",
"RUYA CLOTHING PRIVATE LIMITED",
"RV CAFE PRIVATE LIMITED",
"RV COLLEGE OF ENGINEERING",
"RV COLOR TECH PRIVATE LIMITED",
"RV DESIGN COUTURE PRIVATE LIMITED",
"RV DISTRIBUTION PRIVATE LIMITED",
"RV EXHAUST SYSTEMS PRIVATE LIMITED",
"RV EXPORTS PRIVATE LIMITED",
"RV FLUIDAIR FILTRATION TECHNOLOGIES PRIVATE LIMITED",
"RV FORMS & GEARS LLP",
"RV INFOTAINMENT PRIVATE LIMITED",
"RV INFRASTRUCTURE ENGINEERS PRIVATE LIMITED",
"RV INFRATECH & STRUCTURES PRIVATE LIMITED",
"RV INSTITUTE OF TECHNOLOGY AND MANAGEMENT",
"RV LIFESCIENCES LIMITED",
"RV LIFESTYLE LIMITED",
"RV MATRIX SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"RV MEDIA SOLUTIONS PRIVATE LIMITED",
"RV NIRMATA PRIVATE LIMITED",
"RV PUBLIC SCHOOL",
"RV SKILL & ENTREPRENEUR PRIVATE LIMITED",
"RV SOLUTIONS PRIVATE LIMITED",
"RV UNIVERSITY",
"RVA ETRONICS PRIVATE. LIMITED. RVA",
"RVALUE CONSULTING PRIVATE LIMITED",
"RVAN VENTURES PRIVATE LIMITED",
"RVB IMPEX PRIVATE LIMITED",
"RVB SHORLUBE INDUSTRY PRIVATE LIMITED",
"RVC CENTRE AND COLLEGE",
"RVC SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED",
"RVCARE CHALLENGERS ELECTRONICS PRIVATE LIMITED",
"RVCJ DIGITAL MEDIA PRIVATE LIMITED",
"RVD IMPEX PRIVATE LIMITED",
"RVD INFRA SOLUTION PRIVATE LIMITED",
"RVDASA ENTERPRISE & SECURITY SERVICES PRIVATE LIMITED",
"RVDK LABOURHOME PRIVATE LIMITED",
"RVG AUTOTECH PRIVATE LIMITED",
"RVG EARTH & MINERALS PRIVATE LIMITED",
"RVI REALTY LLP",
"RVJ JEWELLERS PRIVATE LIMITED",
"RVJ OVERSEAS PRIVATE LIMITED",
"RVK FOREX PRIVATE LIMITED",
"RVK HOSPITALITY PRIVATE LIMITED",
"RVK INDUSTRIAL PARK PRIVATE LIMITED",
"RVK TRANS LOGISTICS PRIVATE LIMITED",
"RVKRISHNA AND SON PRIVATE LIMITED",
"RVL EXIM LIMITED",
"RVL FOODS PRIVATE LIMITED",
"RVL POLY INDUSTRIES PRIVATE LIMITED",
"RVM INFRATECH PRIVATE LIMITED",
"RVM INSTITUTE OF MEDICAL SCIENCES AND RESEARCH CENTRE",
"RVN IMPEX PRIVATE LIMITED",
"RVN INFRA PRIVATE LIMITED",
"RVN PAINTPRO INDIA PRIVATE LIMITED",
"RVN RESTAURANT AND HOTEL PRIVATE LIMITED",
"RVP STARCH PRODUCTS PRIVATE LIMITED",
"RVPR CONSTRUCTIONS PRIVATE LIMITED",
"RVPR ENGINEERING SERVICES PRIVATE LIMITED",
"RVR AND JC COLLEGE OF ENGINEERING",
"RVR DIGITAL INFRASTRUCTURES LIMITED",
"RVR LABS PRIVATE LIMITED",
"RVR PRESENTS EVENT SERVICES PRIVATE LIMITED",
"RVR PROJECTS PRIVATE LIMITED",
"RVS AUTO PRODUCTS PRIVATE LIMITED",
"RVS COLLEGE OF ARTS AND SCIENCE",
"RVS COLLEGE OF NURSING",
"RVS FINANCIAL SERVICES LIMITED",
"RVS HOMEOPATHIC MEDICAL COLLEGE",
"RVS HOSPITALITY & DEVELOPMENT PRIVATE LIMITED",
"RVS INFO SERVICES LIMITED",
"RVS INFORMATICS IT PRIVATE LIMITED",
"RVS INFRAPROJECTS PRIVATE LIMITED",
"RVS PETRO CHEMICALS LIMITED",
"RVS SANRCHNA PRIVATE LIMITED",
"RVSA CONSULTANTS PRIVATE LIMITED",
"RVTECHNOLOGIES SOFTWARE PRIVATE LIMITED",
"RVV AGRI FEEDS PRIVATE LIMITED",
"RVV INTERNATIONAL PRIVATE LIMITED",
"RW INFOTECH PRIVATE LIMITED",
"RW PROMOTIONS PRIVATE LIMITED",
"RWALTZ SOFTWARE PRIVATE LIMITED",
"RWAYCAB SERVICES PRIVATE LIMITED",
"RWE SUPPLY & TRADING (INDIA) PRIVATE LIMITED",
"RWL HEALTHWORLD LIMITED",
"RWORLD XPS LOGISTICS PRIVATE LIMITED",
"RWS MORAVIA INDIA PRIVATE LIMITED",
"RWT INDIA PRIVATE LIMITED",
"RX AUSHADHI PRIVATE LIMITED",
"RX FOODS (OPC) PRIVATE LIMITED",
"RX HEALTHCARE LIMITED",
"RX INFOTECH PRIVATE LIMITED",
"RX LOGIX CORPORATION INDIA PRIVATE LIMITED",
"RX PROPELLANT PRIVATE LIMITED",
"RX SOFTWARE SOLUTIONS PRIVATE LIMITED",
"RX SURGIPHARMA PRIVATE LIMITED",
"RXADVANCE PBM INDIA PRIVATE LIMITED",
"RXCUES LIFECARE PRIVATE LIMITED",
"RXDATASCIENCE INDIA PRIVATE LIMITED",
"RXM AUTOMATION PRIVATE LIMITED",
"RXN CHEMICALS PRIVATE LIMITED",
"RXPONT INDIA PRIVATE LIMITED",
"RXPRISM HEALTH SYSTEMS PRIVATE LIMITED",
"RXR SOLUTIONS PRIVATE LIMITED",
"RY EASY SHOP PRIVATE LIMITED",
"RY MIDAS ALLUMINIUMS PRIVATE LIMITED",
"RY MIDAS METACAST PRIVATE LIMITED",
"RYAGO HOMES PRIVATE LIMITED",
"RYAL LOGISTICS PRIVATE LIMITED",
"RYAL VUITTON PRIVATE LIMITED",
"RYAN ALLOYS PRIVATE LIMITED",
"RYAN AUTOMATION PRIVATE LIMITED",
"RYAN INDIA TAX SERVICES PRIVATE LIMITED",
"RYAN INTERNATIONAL ACADEMY",
"RYAN INTERNATIONAL SCHOOL",
"RYAN LOGITECH PRIVATE LIMITED",
"RYAN SHALOM MONTESSORI",
"RYAN SHALOM PRE SCHOOL",
"RYAN SHIP MANAGEMENT PRIVATE LIMITED",
"RYAN WORLDWIDE PRIVATE LIMITED",
"RYB ELECTRICAL SERVICES PRIVATE LIMITED",
"RYB FROZEN FOODS PRIVATE LIMITED",
"RYB POWER ELECTRICALS PRIVATE LIMITED",
"RYB SWITCHGEARS PRIVATE LIMITED",
"RYBBON DIGITAL REWARDS INDIA PRIVATE LIMITED",
"RYBCAL INDIA PRIVATE LIMITED",
"RYBLUE LOGISTICS PRIVATE LIMITED",
"RYDAK SYNDICATE LIMITED",
"RYDBERG ENGINEERING PRIVATE LIMITED",
"RYDDX PHARMETRY PRIVATE LIMITED",
"RYDER BUSINESS SOLUTIONS PRIVATE LIMITED",
"RYDER FACILITY MANAGEMENT GROUP PRIVATE LIMITED",
"RYDER PROPACK PRIVATE LIMITED",
"RYDER SHIPPING LINES PRIVATE LIMITED",
"RYDER TRANS INTERNATIONAL PRIVATE LIMITED",
"RYDERS EQUESTRIAN PRODUCTS PRIVATE LIMITED",
"RYDON INDUSTRIES PRIVATE LIMITED",
"RYDOT INFOTECH PRIVATE LIMITED",
"RYESINO PHARMACEUTICALS PRIVATE LIMITED",
"RYGGRAD TRAINING & CONSULTING PRIVATE LIMITED",
"RYK FREIGHT FORWARDERS PRIVATE LIMITED",
"RYKKA CORPORATION PRIVATE LIMITED",
"RYM TELECOMMUNICATION PRIVATE LIMITED",
"RYM VENTURES PRIVATE LIMITED",
"RYME TRADING PRIVATE LIMITED",
"RYNA IT SOLUTIONS PRIVATE LIMITED",
"RYNAN TECHNOLOGIES INDIA PRIVATE LIMITED",
"RYNAS INFOTECH PRIVATE LIMITED",
"RYOHIN KEIKAKU RELIANCE INDIA PRIVATE LIMITED",
"RYON INFOTECH PRIVATE LIMITED",
"RYONAN ELECTRIC INDIA PRIVATE LIMITED",
"RYOSAN INDIA PRIVATE LIMITED",
"RYOYO ELECTRO INDIA PRIVATE LIMITED",
"RYPE ONLINE SERVICES PRIVATE LIMITED",
"RYPS INFRATECH PRIVATE LIMITED",
"RYSA INFRA PROJECTS PRIVATE LIMITED",
"RYSA INFRATECH PRIVATE LIMITED",
"RYSN INFRA LLP",
"RYSTAD ENERGY INDIA PRIVATE LIMITED",
"RYSUN LABS PRIVATE LIMITED",
"RYTHAM ALLOYS PRIVATE LIMITED",
"RYTHARA SEVA SAHAKARA BANK",
"RYTHIKS FARM PRIVATE LIMITED",
"RYTHMOS INDIA PRIVATE LIMITED",
"RYTHU DAIRY PRODUCTS PRIVATE LIMITED",
"RYTHU MITRA FERTILIZERS PRIVATE LIMITED",
"RYTHU SADHIKARA SAMSTHA",
"RYTHUMITRA COLD STORAGE PRIVATE LIMITED",
"RYTIKS AUTO PRIVATE LIMITED",
"RYTOIL RESOURCES PRIVATE LIMITED",
"RYTRAK IT SERVICES PRIVATE LIMITED",
"RYTUS THERAPEUTICS LIMITED",
"RYVIS PHARMA PRIVATE LIMITED",
"RYYTY APPAREL RESOURCES INDIA PRIVATE LIMITED",
"RYZ SYSTEMS PRIVATE LIMITED",
"RYZKLYTIX CONSULTING SOLUTIONS PRIVATE LIMITED",
"RZA TECHNOLOGIES PRIVATE LIMITED",
"RZENINFO SOLUTIONS PRIVATE LIMITED",
"RZONE BUILDTECH PRIVATE LIMITED",
"RZP SCHOOL HARIGRAM",
"RZRG TECHNOLOGY SERVICES INDIA PRIVATE LIMITED",
"S & D MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"S & D TEXTILL INDIA PRIVATE LIMITED",
"S & F FINANCIAL SERVICES PRIVATE LIMITED",
"S & H MANUFACTURING & TRADING PRIVATE LIMITED",
"S & I ENGINEERING SOLUTIONS PRIVATE LIMITED",
"S & J BUILDCON PRIVATE LIMITED",
"S & J GRANULATE SOLUTIONS PRIVATE LIMITED",
"S & M INDUSTRIAL VALVES LIMITED",
"S & P FEEDS PRIVATE LIMITED",
"S & P FOUNDATION PRIVATE LIMITED",
"S & P KITCHEN AND HOME APPLIANCES PRIVATE LIMITED",
"S & P THREADS PRIVATE LIMITED",
"S & R EXPORT",
"S & R GEOTECHNIQUES PRIVATE LIMITED",
"S & R INSURANCE BROKERS PRIVATE LIMITED",
"S & S CONSTRUCTION COMPANY",
"S & S FOUNDATIONS PRIVATE LIMITED",
"S & S FURNISHERS PRIVATE LIMITED",
"S & S INFRALOGISTICS PRIVATE LIMITED",
"S & S INPUTS PRIVATE LIMITED",
"S & S PACKAGING SOLUTION PRIVATE LIMITED",
"S & S POWER SWITCHGEAR LIMITED",
"S & S WATER AND POWER PROJECTS PRIVATE LIMITED",
"S & T MINING COMPANY PRIVATE LIMITED",
"S & Y ADVISORY SERVICES PRIVATE LIMITED",
"S 3 M TRADE PRIVATE LIMITED",
"S A AANANDAN SPINNING MILLS PRIVATE LIMITED",
"S A AGRO PRODUCTS PRIVATE LIMITED",
"S A ALLOYS PRIVATE LIMITED",
"S A ASSOCIATES & CONTRACTS PRIVATE LIMITED",
"S A AUTOMATION PRIVATE LIMITED",
"S A D ACCOUNT UP GOVT LUCKNOW",
"S A DESIGN & ART PRIVATE LIMITED",
"S A DIAGNOSTICS PRIVATE LIMITED",
"S A DIGITAL FILMS PRIVATE LIMITED",
"S A EDITORIAL PRIVATE LIMITED",
"S A ENCON PRIVATE LIMITED",
"S A ENGINEERING COLLEGE",
"S A EXPORTS",
"S A HEMNANI DISTRIBUTORS PRIVATE LIMITED",
"S A L STEEL LIMITED",
"S A M PROPERTIES PRIVATE LIMITED",
"S A MANPOWER SERVICES PRIVATE LIMITED",
"S A N GARMENT MANUFACTURING PRIVATE LIMITED",
"S A NETWORK PRIVATE LIMITED",
"S A PAPER PRIVATE LIMITED",
"S A PHARMACHEM PRIVATE LIMITED",
"S A PORTFOLIO LIMITED",
"S A PROPBUILD PRIVATE LIMITED",
"S A R TRAVEL SOLUTION PRIVATE LIMITED",
"S A R VENTURE PRIVATE LIMITED",
"S A S AAGRO OILS REFINERY PRIVATE LIMITED",
"S A S ASSOCIATES PRIVATE LIMITED",
"S A S SERVIZIO PRIVATE LIMITED",
"S A SOUTHEND TRAVELS PRIVATE LIMITED",
"S A TECH SOFTWARE INDIA LIMITED",
"S A TECH SOFTWARE INDIA PRIVATE LIMITED",
"S A TEXTILESS PRIVATE LIMITED",
"S A TRAFIN PVT LTD",
"S ADITYA IMPEX PRIVATE LIMITED",
"S AENGINEERING COLLEGE",
"S AND A FINMAN LIMITED.",
"S AND A SPACE CARE PVT. LTD.",
"S AND B ENGINEERS AND CONSTRUCTORS LLP",
"S AND C MULTI COMMERCIALS PRIVATE LIMITED",
"S AND G AGRICOM PRIVATE LIMITED",
"S AND N FINANCIAL SERVICES PRIVATE LIMITED",
"S AND S AROMA ASSOCIATES PRIVATE LIMITED",
"S AND S GHOSH TRADING CO PRIVATE LIMITED",
"S AND S MED LOGISTICS PRIVATE LIMITED",
"S AND S PAINTS PRIVATE LIMITED",
"S AND T ENGINEERS PRIVATE LIMITED",
"S AND T ENTERPRISE",
"S AND T HEALTHCARE TECHNOLOGIES PRIVATE LIMITED",
"S AND T MACHINE TOOLS PRIVATE LIMITED",
"S AND T MACHINERY PRIVATE LIMITED",
"S AND T WELCARE EQUIPMENTS PRIVATE LIMITED",
"S AND V STUDIO PRIVATE LIMITED",
"S B B A INTER COLLEGE SAHARANPUR",
"S B C POLYPIPES PRIVATE LIMITED",
"S B COTGIN PRIVATE LIMITED",
"S B DATA SYSTEMS PRIVATE LIMITED",
"S B DRIVE POWER LIMITED",
"S B E S CENTENARY SCHOOL",
"S B ELECTRICAL SWITCHGEAR PRIVATE LIMITED",
"S B ESTATE PRIVATE LIMITED",
"S B FAB PVT. LTD",
"S B FLAVOURS PRIVATE LIMITED",
"S B G BUILDCON PRIVATE LIMITED",
"S B GARG AGRO PVT LTD",
"S B H TRADING COMPANY PRIVATE LIMITED",
"S B HIGHSEAS TRADE (INDIA) PRIVATE LIMITED",
"S B I O A MATRIC AND HR SEC SCHOOL",
"S B INFOWAVES PRIVATE LIMITED",
"S B INSURANCE BROKERS PRIVATE LIMITED",
"S B JAIN INSTITUTE OF TECHNOLOGY, MANAGEMENT & RESEARCH",
"S B KWALITY CHAINS PRIVATE LIMITED",
"S B M AND COMPANY PRIVATE LIMITED",
"S B M HEALTHCARE (INDIA) PRIVATE LIMITED",
"S B M MILK PRODUCTS PRIVATE LIMITED",
"S B M PADWAL VIDYALAYA MARATHI",
"S B MOVERS AND LIFTERS PRIVATE LIMITED",
"S B OIL INDUSTRIES PVT LTD",
"S B ORGANICS LIMITED",
"S B ORNAMENTS PRIVATE LIMITED",
"S B P COMMERCIAL PVT LTD",
"S B PACKAGING LIMITED",
"S B PACKAGINGS PRIVATE LIMITED",
"S B PATIL COLLEGE OF ARCHITECTURE & DESIGN",
"S B PATIL INSTITUTE OF MANAGEMENT",
"S B PATIL PUBLIC SCHOOL",
"S B RESHELLERS PRIVATE LIMITED",
"S B S HOSPITAL PRIVATE LIMITED",
"S B S INTERNATIONAL PRIVATE LIMITED",
"S B SAINI BROS ELECTRICALS PVT LTD",
"S B SHAH AND COMPANY PRIVATE LIMITED",
"S B T APPARELS PRIVATE LIMITED",
"S B TEA PRIVATE LIMITED",
"S B VIDHYALAYA",
"S B WAREHOUSING & LOGISTICS PRIVATE LIMITED",
"S B WOOLLEN MILLS",
"S BANDI INFRA PRIVATE LIMITED",
"S BANJAN AND COMPANY INDIA PRIVATE LIMITED",
"S BHAVYA GEMS PRIVATE LIMITED",
"S BRIJLAL PROPERTIES PRIVATE LIMITED",
"S C A HEAVY EQUIPMENT PRIVATE LIMITED",
"S C D B HIGH SCHOOL",
"S C D GOVT COLLEGE",
"S C I INDIA LIMITED",
"S C JOHNSON PRODUCTS PRIVATE LIMITED",
"S C MACHINERY AND SERVICE COMPANY LIMITE D",
"S C MOTORS",
"S C PACKAGING PRIVATE LIMITED",
"S C R NIRMAN PRIVATE LIMITED",
"S C RAGHAV OIL PRIVATE LIMITED",
"S C SARKAR & SONS PVT LTD",
"S C T LIMITED",
"S CCI INDIA PRIVATE LIMITED",
"S CHANCHALA COMBINES PRIVATE LIMITED",
"S CHAND AND COMPANY LIMITED",
"S CHAND AND COMPANY PRIVATE LIMITED",
"S CHAND PROPERTIES PRIVATE LIMITED",
"S CHATTERJEE & SONS (INDIA) PVT LTD",
"S CHEMS AND ALLIED PRODUCERS PRIVATE LIMITED",
"S CUBE ERGONOMICS PRIVATE LIMITED",
"S CUBE INTERNATIONAL PRIVATE LIMITED",
"S CUBE STORAGE SYSTEMS PRIVATE LIMITED",
"S CUBE TECHNOLOGY SERVICES PRIVATE LIMITED",
"S D ADARSH VIDYALAYA",
"S D AGRO CHEMICALS LIMITED",
"S D AND COMPANY",
"S D AUTO ENGG WORK PRIVATE LIMITED",
"S D AXLES PRIVATE LIMITED",
"S D B INDUSTRIES LIMITED",
"S D BEVERAGES PRIVATE LIMITED",
"S D CHEM PRIVATE LIMITED",
"S D CONSTRUCTION PVT LTD",
"S D CORPORATION PRIVATE LIMITED",
"S D COTSYN PRIVATE LIMITED",
"S D ENGINEERING SERVICES PRIVATE LIMITED",
"S D ENGINEERSTECH PRIVATE LIMITED",
"S D FINE CHEM LIMITED",
"S D FOOTWEAR PRIVATE LIMITED",
"S D HERITAGE IMPEX PRIVATE LIMITED",
"S D I W D XXIV PWD BICHOLIM",
"S D JAIN MODERN SCHOOL",
"S D LIFE SCIENCES INDIA PRIVATE LIMITED",
"S D MARKER AND CO PRIVATE LIMITED",
"S D N B VAISHNAV COLLEGE",
"S D POLYFILMS PRIVATE LIMITED",
"S D POLYTECH PRIVATE LIMITED",
"S D PROMO MEDIA PRIVATE LIMITED",
"S D R COMMERCIALS PRIVATE LIMITED",
"S D RETAIL PRIVATE LIMITED",
"S D RICE MILLS",
"S D S OVERSEAS PRIVATE LIMITED",
"S D S PROPERTIES PVT LTD",
"S D S STATIONERS PRIVATE LIMITED",
"S D SAJJAN INFRASTRUCTURE PRIVATE LIMITED",
"S D SERVICES PVT LTD",
"S D SINGH CONSTRUCTION COMPANY PVT LTD",
"S D SOLVEX PRIVATE LIMITED",
"S D TRADERS PRIVATE LIMITED",
"S D VIDYA MANDIR SCHOOL",
"S DECOR IMPEX PRIVATE LIMITED",
"S DEV FASHIONS PVT LTD",
"S DIP CONSTRUCTIONS PRIVATE LIMITED",
"S E AGRO PRIVATE LIMITED",
"S E BEVERAGES PRIVATE LIMITED",
"S E BIZ INFOTECH PRIVATE LIMITED",
"S E BUILDERS & REALTORS LIMITED",
"S E C DAY SHCOOL ANTOP HILL",
"S E INDUSTIRAL SYNDICATE PVT LTD",
"S E INTERNATIONAL SCHOOL",
"S E P D W CIRCLE UJJAIN",
"S E T P U COLLEGE",
"S E TEXTILES PRIVATE LIMITED",
"S F ENTERPRISES PRIVATE LIMITED",
"S F FOREX PRIVATE LIMITED",
"S F S ALLIANZ PRIVATE LIMITED",
"S F S INFRA HOUSING PROJECTS PRIVATE LIMITED",
"S F S MATRICULATION HIGHER SECONDARY SCHOOL PUDUKKOTTAI",
"S F TUBES PRIVATE LIMITED",
"S FOAM INDIA PVT LTD",
"S G ACOUSTICS ENGINEERING & SERVICES PRIVATE LIMITED",
"S G CONTROL & SWITCHGEAR PRIVATE LIMITED.",
"S G ENCON PRIVATE LIMITED",
"S G F INFRA PRIVATE LIMITED",
"S G FABRICS PRIVATE LIMITED",
"S G FABTEX PRIVATE LIMITED",
"S G FREIGHT PRIVATE LIMITED",
"S G HIGH SCHOOL AND D N PATEL HIGHER SECONDARY VALOD",
"S G HOMES PRIVATE LIMITED",
"S G INFRAVENTURES PRIVATE LIMITED",
"S G KAREL & SONS JEWELLERS PRIVATE LIMITED",
"S G MARKETING PRIVATE LIMITED",
"S G MERCHANTS PRIVATE LIMITED",
"S G MULTICAST PVT LTD",
"S G N INTERNATIONAL SCHOOL",
"S G PHYTO PHARMA PRIVATE LIMITED",
"S G PLANET MODEL COM PRIVATE LIMITED",
"S G PRINT PACKS PRIVATE LIMITED",
"S G PROCESSORS PRIVATE LIMITED",
"S G PROJECTS PRIVATE LIMITED",
"S G RAM BOOKS PRIVATE LIMITED",
"S G S MOTORS PRIVATE LIMITED",
"S G S SILK MILLS PRIVATE LIMITED",
"S G SNACKS INDIA PRIVATE LIMITED",
"S G STAR DRINKS PRIVATE LIMITED",
"S G STRIPS LIMITED",
"S G SYNTHETICS PRIVATE LIMITED",
"S G VET CARE PRIVATE LIMITED",
"S GHOSH AND ASSOCIATES PVT LTD",
"S GOYAL AND COMPANY PRIVATE LIMITED",
"S GRAPHIX (INDIA) PRIVATE LIMITED",
"S GUPTA CONTRACTS INDIA PRIVATE LIMITED",
"S GUPTA TRADELINKS PRIVATE LIMITED",
"S H A ENTERPRISES PRIVATE LIMITED",
"S H B SANGHAVI HIGH SCHOOL KHEDGAON",
"S H CARMALL PRIVATE LIMITED",
"S H ENGINEERING PRIVATE LIMITED",
"S H G VIDYUT UPBOGTA SEWA SAMITI",
"S H KELKAR AND COMPANY LIMITED",
"S H PITKAR ORTHOTOOLS PRIVATE LIMITED",
"S H RETAIL PRIVATE LIMITED",
"S H S INVESTMENT CONSULTANTS PRIVATE LIMITED",
"S I A MANUFACTURING PRIVATE LIMITED",
"S I C LALA LAJPAT RAI ASSO HOSPITALS KANPUR",
"S I E S HIGH SCHOOL",
"S I ENERGY VENTURES PRIVATE LIMITED",
"S I ENGINEERING PRODUCTS PRIVATE LIMITED",
"S I HOSIERY MERCHANDISE PRIVATE LIMITED",
"S I LOGISTICS PRIVATE LIMITED",
"S I M CONSULTANCY SERVICES PRIVATE LIMITED",
"S I PRECISION MOULD PRIVATE LIMITED",
"S I R DESIGN HOUSE PRIVATE LIMITED",
"S I S R B TECHNOLOGIES PRIVATE LIMITED",
"S I V E T COLLEGE",
"S J A SHIPPING PRIVATE LIMITED",
"S J C INSTITUTE OF TECHNOLOGY",
"S J CHEMICALS PVT LTD",
"S J COKE INDUSTRIES PRIVATE LIMITED",
"S J CONTRACTS PRIVATE LIMITED",
"S J D SURGICOT PRIVATE LIMITED",
"S J DEVELOPERS AND HOUSING PRIVATE LIMITED",
"S J FISCAL SERVICES PVT LTD",
"S J HEALTHCARE PRIVATE LIMITED",
"S J INVESTMENT AGENCIES PRIVATE LIMITED",
"S J IRON AND STEELS PVT LTD",
"S J LOGISTICS INDIA PRIVATE LIMITED",
"S J MINERAL PRIVATE LIMITED",
"S J OUTSOURCE SOLUTIONS PRIVATE LIMITED",
"S J P RESIDENCY CONSORTIUM LIMITED",
"S J PACKAGING PRIVATE LIMITED",
"S J PLASTIC UDYOG PRIVATE LIMITED",
"S J PLAZA PRIVATE LIMITED",
"S J RUBBER INDUSTRIES LIMITED",
"S J S ENTERPRISES LIMITED",
"S J SERVICES PRIVATE LIMITED",
"S J STUDIO AND ENTERTAINMENT LIMITED",
"S JET TECHNOLOGIES PRIVATE LIMITED",
"S JOGANI EXPORTS PRIVATE LIMITED",
"S K & S BUILD TECH PRIVATE LIMITED",
"S K AGRI EXPORTS PRIVATE LIMITED",
"S K AGROFOOD TECH PRIVATE LIMITED",
"S K ALUMINIUM INDUSTRIES PRIVATE LIMITED",
"S K AND COMPANY PRIVATE LIMITED",
"S K ASHIANA PRIVATE LIMITED",
"S K B BUILDERS INDIA LIMITED",
"S K B PROJECT (INDIA) PRIVATE LIMITED",
"S K BIOBIZ PRIVATE LIMITED",
"S K C FABRIC IMPEX PRIVATE LIMITED",
"S K CEREALS PRIVATE LIMITED",
"S K CHAIN PRIVATE LIMITED",
"S K COLLEGE OF SCIENCE & COMMERCE",
"S K CONSTRUCTION COMPANY",
"S K CORPORATION",
"S K D C CONSULTANTS LIMITED",
"S K D INSURANCE BROKING & SERVICES PRIVATE LIMITED",
"S K DIESEL SALES AND SERVICES PRIVATE LIMITED",
"S K EDUCATIONS PRIVATE LIMITED",
"S K ELECTRODS PRIVATE LIMITED",
"S K ENGIMECH PRIVATE LIMITED",
"S K FASHIONS PRIVATE LIMITED",
"S K FINCAP ADVISORS PRIVATE LIMITED",
"S K G ESTATE PRIVATE LIMITED",
"S K GHOSH PVT LTD",
"S K GLAZING PRIVATE LIMITED",
"S K GROWTH FUND PVT LTD",
"S K GUPTA & SONS RETAIL PRIVATE LIMITED",
"S K GUPTA PRIVATE LIMITED",
"S K GUPTA VALVES PRIVATE LIMITED",
"S K HEALTH CARE FORMULATIONS PRIVATE LIMITED",
"S K HOTELS PRIVATE LIMITED",
"S K INDUSTRIES PVT LTD",
"S K INFRA ENGINEERS PRIVATE LIMITED",
"S K INK PRIVATE LIMITED",
"S K INTERNATIONAL STONES PRIVATE LIMITED",
"S K JAIN CONSTRUCTIONS PRIVATE LIMITED",
"S K KHETAN INFRAPROJECTS PRIVATE LIMITED",
"S K KNITFAB PRIVATE LIMITED",
"S K LOGISTICS INDIA PRIVATE LIMITED",
"S K M ANIMAL FEEDS AND FOODS (INDIA) PRIVATE LIMITED",
"S K M SAREES MART PRIVATE LIMITED",
"S K MANDORA JEWELLERS PRIVATE LIMITED",
"S K MANFIELD SERVICES PRIVATE LIMITED",
"S K MEDITECH PRIVATE LIMITED",
"S K MINERALS AGENCIES PRIVATE LIMITED",
"S K OFFICE SOLUTIONS PRIVATE LIMITED",
"S K OIL TERMINALS PRIVATE LIMITED",
"S K PANDE VIDYALAYA & JR COLLEGE",
"S K PATEL INSTITUTE OF MANAGEMENT AND COMPUTER STUDIES",
"S K PHARMA MACHINERY PRIVATE LIMITED",
"S K PRADHAN CONSTRUCTION COMPANY PRIVATE LIMITED",
"S K PRODUCT AND CO",
"S K S INDUSTRIAL SERVICE PRIVATE LIMITED",
"S K S TEXTILES LIMITED",
"S K SAFETY WINGS PRIVATE LIMITED",
"S K SAMANTA & CO PRIVATE LIMITED",
"S K SOLVOCHEM PRIVATE LIMITED",
"S K STEEL PROCESSORS PRIVATE LIMITED",
"S K TILES & MARBLE TRADERS PRIVATE LIMITED",
"S K TIMBER PRODUCTS PRIVATE LIMITED",
"S K TIME INDUSTRIES",
"S K TUFF PRIVATE LIMITED",
"S K UNI PRINT PRIVATE LIMITED",
"S K V INFOTECH PRIVATE LIMITED",
"S K WEAVING PRIVATE LIMITED",
"S KANT HEALTHCARE LIMITED.",
"S KUMAR ASSOCIATES PVT LTD",
"S KUMAR CONCRETE PRIVATE LIMITED",
"S KUMAR INFRACONS (INDIA) PRIVATE LIMITED",
"S L BAJORIA FOUNDATION HIGH SCHOOL",
"S L CHOKHANY TRADERS COMPANY PRIVATE LIMITED",
"S L FASTENERS PRIVATE LIMITED",
"S L GOLDEN PAPTECH PRIVATE LIMITED",
"S L INFRA",
"S L MECHANICAL ENGINEERING EQUIPMENTS PRIVATE LIMITED",
"S L N TECHNOLOGIES PRIVATE LIMITED",
"S L RAHEJA HOSPITAL",
"S L SARAF IMPEX PRIVATE LIMITED",
"S L SURI DAV PUBLIC SCHOOL",
"S L V ENGINEERS PRIVATE LIMITED",
"S LAL TRADERS PRIVATE LIMITED",
"S LOGISTICS SPACE PRIVATE LIMITED",
"S LUNAWAT FINANCE PRIVATE LIMITED",
"S M AGROTECH PRIVATE LIMITED",
"S M AKOLAWALA SALES PRIVATE LIMITED",
"S M ASSOCIATES RISK MANAGEMENT PRIVATE LIMITED",
"S M AUTO ENGINEERING PVT LTD",
"S M AUTO SALES PRIVATE LIMITED",
"S M BAGLEY AND ASSOCIATES PRIVATE LIMITED",
"S M BEJOY & CO PVT LTD",
"S M COMPUTER",
"S M CONSULTANCY PVT LTD",
"S M CONSUMERS PRIVATE LIMITED",
"S M ECOINFRA PRIVATE LIMITED",
"S M EDIBLES PRIVATE LIMITED",
"S M ELECTRIC TRADING CO PRIVATE LIMITED",
"S M FAB",
"S M FLUID ENGINEERING PRIVATE LIMITED",
"S M FOOD ENGINEERING PRIVATE LIMITED",
"S M FRUITS & BEVERAGES PRIVATE LIMITED",
"S M H S NURSERY & PRIMARY SCHOOL",
"S M HARDWARE TRADING CO PRIVATE LIMITED",
"S M HITECH CITY PRIVATE LIMITED",
"S M IMAGING INSTITUTE PRIVATE LIMITED",
"S M INDUSTRIAL CONSULTANTS PRIVATE LIMITED",
"S M INFRA HIEGHTS PRIVATE LIMITED",
"S M K CREATIONS PRIVATE LIMITED",
"S M KANNAPPA AUTOMOBILES PRIVATE LIMITED",
"S M L FINANCE LIMITED",
"S M LOGISTICS & WAREHOUSING CO. PRIVATE LIMITED",
"S M LOGISTICS PRIVATE LIMITED",
"S M M EXPORTS PRIVATE LIMITED",
"S M MANPOWER SERVICES PRIVATE LIMITED",
"S M MARINE PRODUCTS",
"S M NIRYAT PRIVATE LIMITED",
"S M PATEL IRON TRADERS PRIVATE LIMITED",
"S M PROCESS PLANT PVT LTD",
"S M RAO DEVELOPERS PRIVATE LIMITED",
"S M REFRIGERATION PRIVATE LIMITED",
"S M REFRIGWRATION",
"S M RICE LAND PRIVATE LIMITED",
"S M S ASSOCIATES PRIVATE LIMITED",
"S M S N CONTINENTAL PRIVATE LIMITED",
"S M SAHA & SONS PVT LTD",
"S M SCIENTIFIC INSTRUMENTS PRIVATE LIMITED",
"S M SILK INDUSTRIES PRIVATE LIMITED",
"S M STRUCTURAL STEEL PRIVATE LIMITED",
"S M TECHNOCRATS PRIVATE LIMITED",
"S M TECHNOMINE PRIVATE LIMITED",
"S M TECHNOSALES PRIVATE LIMITED",
"S M TEXTILE LIMITED",
"S M Y SEAMEN WELFARE FOUNDATION LADY KHATUN MARIUM SCHOOL",
"S MAC SECURITY SERVICES PRIVATE LIMITED",
"S MALHOTRA AND CO PRIVATE LIMITED",
"S MANSUKHLAL & COMPANY",
"S MECH ENGINEERING SERVICES PRIVATE LIMITED",
"S MOBILE DEVICES PRIVATE LIMITED",
"S N A INFOTECH PRIVATE LIMITED",
"S N AVIATORS PRIVATE LIMITED",
"S N B FASHIONS PRIVATE LIMITED",
"S N BHOBE AND ASSOCIATES PRIVATE LIMITED",
"S N COLD STORAGE PVT LTD",
"S N D T WOMEN UNIVERSITY",
"S N DAMANI INFRA PRIVATE LIMITED",
"S N DAS FREIGHT FORWARDERS PRIVATE LIMITED",
"S N DHAWAN & CO LLP",
"S N DOORS INDIA PRIVATE LIMITED",
"S N DREAM HOMES PRIVATE LIMITED",
"S N ELECTEL PRIVATE LIMITED",
"S N ELECTRONICS PRIVATE LIMITED",
"S N ENGINEERING SERVICES",
"S N FABRICS PRIVATE LIMITED",
"S N JOSHI CONSULTANTS PRIVATE LIMITED",
"S N KANSAGRA SCHOOL RAJKOT",
"S N LOGISTICS PRIVATE LIMITED",
"S N M BUSINESS PRIVATE LIMITED",
"S N MERCANTILE INDIA PRIVATE LIMITED",
"S N MURARKA OVERSEAS PVT LTD",
"S N PAINTS AND CHEMICALS PRIVATE LIMITED",
"S N PAPER MILLS PVT LTD",
"S N R FOODS INDIA PRIVATE LIMITED",
"S N RAJ MANPOWER SERVICES PRIVATE LIMITED",
"S N REALTY INFRASTRUCTURER PRIVATE LIMITED",
"S N S CONSTRUCTION PRIVATE LIMITED",
"S N S CONTAINERS PVT. LTD",
"S N S PRODUCTS PRIVATE LIMITED",
"S N SECURITYGUARDS SERVICES PRIVATE LIMITED",
"S N SEN B V P G COLLEGE",
"S N SUPER SPECIALITY HOSPITAL PRIVATE LIMITED",
"S N T AGRO INDUSTRIES PRIVATE LIMITED",
"S N TRADELINK PRIVATE LIMITED",
"S N TRANSLOGISTICS PRIVATE LIMITED",
"S NAGARDAS MOHANLAL STOCK BROKING PRIVATE LIMITED",
"S NARENDRA KUMAR AND CO",
"S NIJALINGAPPA COLLEGE",
"S O GAS PRODUCTS PVT LTD",
"S O IMPEX PRIVATE LIMITED",
"S O INFOTECH PRIVATE LIMITED",
"S O S PRIVATE LIMITED",
"S OSWAL AROMA PRIVATE LIMITED",
"S P A ENTERPRISE INFO SERVICES INDIA PRIVATE LIMITED",
"S P A EXIM PRIVATE LIMITED",
"S P A INFRAPOWER PRIVATE LIMITED",
"S P A MARKETING PRIVATE LIMITED",
"S P APPARELS LIMITED",
"S P ARCHITECTURAL COATINGS PRIVATE LIMITED",
"S P B ENGLISH MEDIUM COMMERCE COLG",
"S P B P TEA PLANTATION LIMITED",
"S P BHAVE",
"S P BUILDERS AND RESORTS PRIVATE LIMITED",
"S P CAPITAL FINANCING LTD",
"S P CARGO AGENCY PRIVATE LIMITED",
"S P CHIPS POTATO PRIVATE LIMITED",
"S P CLASSES PRIVATE LIMITED",
"S P COMMUNICATIONS PRIVATE LIMITED",
"S P CONSULTING ENGINEERS PRIVATE LIMITED",
"S P DEVELOPERS AND DECORATORS",
"S P DIES PRIVATE LIMITED",
"S P ENGINEERING",
"S P G C METAL INDUSTRIES PRIVATE LIMITED",
"S P GARMENTS PRIVATE LIMITED",
"S P GOLDEN TRANSPORT PRIVATE LIMITED",
"S P HEGSHETYE ARTS COMMERCE AND SCIENCE COLLEGE",
"S P I EQUIPMENTS INDIA PRIVATE LIMITED",
"S P I N AQM TECHNOLOGIES INDIA PRIVATE LIMITED",
"S P IRON PRIVATE LIMITED",
"S P J SADHANA SCHOOL",
"S P JAIN INSTITURE OF MANAGEMENT AND RESEARCH",
"S P JAIN SECURITIES PRIVATE LIMITED",
"S P M SALES PRIVATE LIMITED",
"S P MADAN LOGISTICS PRIVATE LIMITED",
"S P MEDITECH PRIVATE LIMITED",
"S P METALLICS PRIVATE LIMITED",
"S P P L PROPERTY MANAGEMENT PRIVATE LIMITED",
"S P P S SYSTEMS PRIVATE LIMITED",
"S P R JEWELS PRIVATE LIMITED",
"S P REAL ESTATE DEVELOPERS PRIVATE LIMITED",
"S P RETAIL VENTURES LIMITED",
"S P S AGRI GENETICS",
"S P S CORPORATION PRIVATE LIMITED",
"S P S INFRA DESIGN CONSULTANTS PRIVATE LIMITED",
"S P S METAL CAST & ALLOYS LIMITED",
"S P S ORGANICS INDIA PRIVATE LIMITED",
"S P SANGHI AIRCONDITIONING PRIVATE LIMITED",
"S P SINGLA CONSTRUCTIONS PRIVATE LIMITED",
"S P SOFTWARE TECHNOLOGIES INDIA PRIVATE LIMITED",
"S P SOLUTIONS POINT PRIVATE LIMITED",
"S P SPRINGS AND WIRES PRIVATE LIMITED",
"S P SYSNET PRIVATE LIMITED",
"S P TECHNO SOLUTION PRIVATE LIMITED",
"S P TEXTILE MILLS LLP",
"S P TEXTILE PROCESSORS PRIVATE LIMITED",
"S P THAKUR CONSTRUCTION PRIVATE LIMITED",
"S P TRADE-LINK PRIVATE LIMITED",
"S P TRANSPORT COMPANY PRIVATE LIMITED",
"S P ULTRAFLEX SYSTEMS PRIVATE LIMITED",
"S PAL ENTERPRISES PRIVATE LIMITED",
"S PODDAR INTERNATIONAL INDIA PRIVATE LIMITED",
"S PREETHI WAREHOUSING PRIVATE LIMITED",
"S PRINCE HIGHTECH PRIVATE LIMITED",
"S PURI GARMENTS PRIVATE LIMITED",
"S QUBE ENERGY PROJECTS PRIVATE LIMITED",
"S R A EQUIPMENTS PRIVATE LIMITED",
"S R ADVANTECH SYSTEMS PRIVATE LIMITED",
"S R AUTOMATION PVT LTD",
"S R B C & CO LLP",
"S R B C AND ASSOCIATES LLP",
"S R B CONSORTIUM (REALCON) PRIVATE LIMITED",
"S R B EXPORTS PRIVATE LIMITED",
"S R BANSAL AND ASSOCIATES PRIVATE LIMITED",
"S R BATLIBOI & ASSOCIATES LLP",
"S R BATLIBOI & CO LLP",
"S R BELTING PRIVATE LIMITED",
"S R BRISTLE PRODUCTS PRIVATE LIMITED",
"S R BUILDERS CHENNAI LLP",
"S R C AVIATION PRIVATE LIMITED",
"S R C EXPRESS CARGO PRIVATE LIMITED",
"S R C ROLL FORMING PRIVATE LIMITED",
"S R CAKE PRIVATE LIMITED",
"S R CATERERS & EVENT MANAGEMENT PRIVATE LIMITED",
"S R COLLEGE OF EDUCATION",
"S R CONFECTIONERS PRIVATE LIMITED",
"S R CORPORATE SERVICES PRIVATE LIMITED",
"S R CREDITS PRIVATE LIMITED",
"S R D JEWELS PRIVATE LIMITED",
"S R DRUGS PVT LTD",
"S R EXPOTRIM PRIVATE LIMITED",
"S R FASTENERS PRIVATE LIMITED",
"S R G BUILDTECH INDIA PRIVATE LIMITED",
"S R G POULTRIES PRIVATE LIMITED",
"S R G S K I C KATHWATIA SAWNDEEH BASTI",
"S R G SECURITIES FINANCE LTD.",
"S R GANATRA VIDHYALAYA PRIMARY¬† SCHOOL",
"S R GLOBAL IMPORTS PRIVATE LIMITED",
"S R GROUP OF INSTITUTIONS",
"S R HANDLOOM PRIVATE LIMITED",
"S R I GOTEC INDIA PRIVATE LIMITED",
"S R I IMPEX PRIVATE LIMITED",
"S R IMPEX PRIVATE LIMITED",
"S R INFO SOLUTION PRIVATE LIMITED",
"S R INFOTECH PRIVATE LIMITED",
"S R J PEETY STEELS PRIVATE LIMITED",
"S R JAIN CHEMICALS PRIVATE LIMITED",
"S R JINDAL METALS PVT LTD",
"S R JUTE TRADERS PVT LTD",
"S R K PRODUCTS PRIVATE LIMITED",
"S R K SILKS INDIA PRIVATE LIMITED",
"S R K TEA PROCESSING INDUSTRIES LTD",
"S R K TELE ENERGY INDIA PRIVATE LIMITED",
"S R KALLA HOSPITAL PRIVATE LIMITED",
"S R LABORATORIES PRIVATE LIMITED",
"S R LAMIFAB PRIVATE LIMITED",
"S R M (INDIA) LIMITED",
"S R M FACILITY MANAGEMENT PRIVATE LIMITED",
"S R MCB ENIGNEERS PRIVATE LIMITED",
"S R MULTITECH PRIVATE LIMITED",
"S R NARKHEDE ENGINEERING PVT LTD",
"S R NATIVE PRODUCTS INDIA PRIVATE LIMITED",
"S R NOVA COMMERCIAL PRIVATE LIMITED",
"S R P FORCE",
"S R P OIL PVT LTD",
"S R PACKAGING & INDUSTRIES PVT LTD",
"S R PAPERS PRIVATE LIMITED",
"S R PARYAVARAN ENGINEERS PRIVATE LIMITED",
"S R POLYTEX PRIVATE LIMITED",
"S R PUBLIC SR SEC SCHOOL KOTA",
"S R RAMSONS PRIVATE LIMITED",
"S R REMEDIES PRIVATE LIMITED",
"S R S GUARDING & FACILITY MANAGEMENT PRIVATE LIMITED",
"S R S SPONGE PRIVATE LIMITED",
"S R SANKARAN HR SERVICES PRIVATE LIMITED",
"S R SEATIING PRIVATE LIMITED",
"S R SECURITY PRIVATE LIMITED",
"S R SHARMA FURNITURES & DECORATORS PRIVATE LIMITED",
"S R SOLUTIONS PRIVATE LIMITED",
"S R STOCK BROKING PRIVATE LIMITED",
"S R SUN POWER INDIA PRIVATE LIMITED",
"S R T DISTRIBUTORS PRIVATE LIMITED",
"S R TECHNOMED PRIVATE LIMITED",
"S R TEXTILE & YARN SALES PVT LTD",
"S R TEXTRADE PRIVATE LIMITED",
"S R THERMOCOLE (EPS) PACKAGING PRIVATE LIMITED",
"S R TRANZCARS PRIVATE LIMITED",
"S R VARGANTE CLEANERS PRIVATE LIMITED",
"S R VESSELS PRIVATE LIMITED",
"S R VIDHYALAYA MATRIC HR SEC SCHOOL",
"S R WIRE INDUSTRIES PRIVATE LIMITED",
"S R YARN PRIVATE LIMITED",
"S RAJA EXPORT PRIVATE LIMITED",
"S RAJAMOULI PRIVATE LIMITED",
"S RAJEEV GLASS WORKS PRIVATE LIMITED",
"S RAM MANPOWER SERVICES PRIVATE LIMITED",
"S RAMDAS PRAGJI FORWARDERS PRIVATE LIMITED",
"S RATANKUMAR PRIVATE LIMITED",
"S ROUT ENGINEERING SERVICES PRIVATE LIMITED",
"S S AGRAWAL COLLEGE OF COMMERCE AND MANAGEMENT NAVSARI",
"S S AGROZONE PRIVATE LIMITED",
"S S APPLIANCES PRIVATE LIMITED",
"S S AUTOLINKS PRIVATE LIMITED",
"S S AUTOMART PRIVATE LIMITED",
"S S B GRACE IMPEX PRIVATE LIMITED",
"S S B I EXPORTS PRIVATE LIMITED",
"S S B METAL WORKS",
"S S BIOCHEM INDIA PRIVATE LIMITED",
"S S BOTTMAC ENGINEERS PRIVATE LIMITED",
"S S BREWERIES PRIVATE LIMITED",
"S S BUILDCON PRIVATE LIMITED",
"S S CHAINS JEWELLERY PRIVATE LIMITED",
"S S CLUTCH MANUFACTURING COMPANY PRIVATE LIMITED",
"S S COLOUR IMPRESSION PRIVATE LIMITED",
"S S CONSTRUCTION CO",
"S S CONVENT INTER COLLEGE BARABANKI",
"S S CORPORATE PRINT HOUSE PRIVATE LIMITED",
"S S D AGRO INDUSTRIES PRIVATE LIMITED",
"S S D GASES PRIVATE LIMITED",
"S S D KANYA DEGREE COLLEGE",
"S S D REFINERY PRIVATE LIMITED",
"S S DAIRY FARM",
"S S DATA CODE INDIA PRIVATE LIMITED",
"S S DEVELOPERS",
"S S DIAMONDS PRIVATE LIMITED",
"S S E FOOTWEAR PRIVATE LIMITED",
"S S E I CRUSHERS PRIVATE LIMITED",
"S S EKBOTE CONSTRUCTIONS",
"S S ELECTRO MECH ENGINEERS PVT LTD",
"S S ELECTROWORKS PRIVATE LIMITED",
"S S ENGINEERING",
"S S ENTERPRISE",
"S S F INDUSTRIES LIMITED",
"S S FINE MOTORS AND APPLIANCES PRIVATE LIMITED",
"S S FLAXI PRINT PRIVATE LIMITED",
"S S FOOD PRODUCTS PRIVATE. LIMITED.",
"S S FORWARDERS PRIVATE LIMITED",
"S S FUND DISTRIBUTORS PRIVATE LIMITED",
"S S G HOSPITAL VADODARA",
"S S G PAREEK PG COLLEGE",
"S S G TECHNO SERVICES PRIVATE LIMITED",
"S S GAS LAB ASIA PRIVATE LIMITED",
"S S GOVINDA INFRASPACE PRIVATE LIMITED",
"S S GROUP",
"S S HEATERS MFG. CO PRIVATE LIMITED",
"S S HYDERABAD BIRYANI PRIVATE LIMITED",
"S S INDIA FOODS PRIVATE LIMITED",
"S S INDIA PRIVATE LIMITED",
"S S INDUSTRY",
"S S INFRACREATION PRIVATE LIMITED",
"S S INFRASTRUCTURE DEVELOPMENT CONSULTANTS LIMITED",
"S S INFRASTRUCTURE PROJECT CONSULTANTS PRIVATE LIMITED",
"S S INSTITUTE OF MEDICAL SCIENCE - RESEARCH",
"S S INTERNATIONAL SR SEC SCHOOL",
"S S JAIN SUBODH GIRLS COLLAGE",
"S S JAIN SUBODH PG COLLEGE",
"S S KALLAN MIYAN ANSARI HIGH SCHOOL",
"S S KHARDEKAR INDIA PRIVATE LIMITED",
"S S L MEDIA TECHNOLOGY & SOLUTIONS PRIVATE LIMITED",
"S S LANDMARK PRIVATE LIMITED",
"S S LOGISTICS PRIVATE LIMITED",
"S S LOOMTEX PRIVATE LIMITED",
"S S M INFOTECH SOLUTIONS PRIVATE LIMITED",
"S S M PROCESSING MILLS LIMITED",
"S S M PUBLIC SCHOOL",
"S S MANPOWER SERVICES PRIVATE LIMITED",
"S S MARKFIN PRIVATE LIMITED",
"S S MEDICAL SYSTEMS ( INDIA) PRIVATE LIMITED",
"S S MICRO ELECTRONICS TECHNOLOGY PRIVATE LIMITED",
"S S MOTA SINGH MODEL SR SEC SCHOOL",
"S S NAIR COMMUNICATIONS PRIVATE LIMITED.",
"S S NATU PLASTICS AND METALS PRIVATE LIMITED",
"S S NATURAL RESOURCES PRIVATE LIMITED",
"S S OFFSHORE PRIVATE LIMITED",
"S S P PACKAGING INDUSTRIES PRIVATE LIMITED",
"S S PATIL CONSTRUCTION PRIVATE LIMITED",
"S S PATIL SEC SCH CHAHARDI",
"S S POLY CHEMICALS PRIVATE LIMITED",
"S S POLYFILMS PRIVATE LIMITED",
"S S PRANAV STEELS PRIVATE LIMITED",
"S S PROCESSORS PRIVATE LIMITED",
"S S PUBLIC SCHOOL",
"S S PUBLISHERS & DISTRIBUTORS PRIVATE LIMITED",
"S S R WEIGHING SOLUTIONS PRIVATE LIMITED",
"S S RUBBERS PRIVATE LIMITED",
"S S S FIBRE PRIVATE LIMITED",
"S S S MULTIPURPOSE TECH H S",
"S S S TECHNICAL SERVICES PRIVATE LIMITED",
"S S SAIB CONSTRUCTIONS PRIVATE LIMITED",
"S S SALESCORP PRIVATE LIMITED",
"S S SERVICES PROVIDERS",
"S S SOLVEX PRIVATE LIMITED",
"S S SUGAR ENGINEERS PVT LTD",
"S S SUVARNA ABHUSHAN PRIVATE LIMITED",
"S S T INDIA PRIVATE LIMITED",
"S S TECHNOMED PRIVATE LIMITED",
"S S TELE OVERSEAS PRIVATE LIMITED",
"S S TEXTILE MEDIA PRIVATE LIMITED",
"S S TINS PRIVATE LIMITED",
"S S TIRUPATI ENTERPRISE PRIVATE LIMITED",
"S S TRADERS",
"S S UNITED TECHNOLOGIES PRIVATE LIMITED",
"S S V COLLEGE HAPUR",
"S S WHITE TECHNOLOGIES INDIA PRIVATE LIMITED",
"S SERUM ANALYSIS CENTRE PRIVATE LIMITED",
"S SONY AND CO PRIVATE LIMITED",
"S SOOD BUSINESS SUPPORT SERVICES PRIVATE LIMITED",
"S SQUARE CARGO MOVERS PRIVATE LIMITED",
"S SQUARE MARKETING PRIVATE LIMITED",
"S SQUARED ARCHITECTS PRIVATE LIMITED",
"S SUBRAHMANYAN CONSTRUCTION COMPANY PRIVATE LIMITED",
"S SVETCO HEALTHCARE PRIVATE LIMITED",
"S T BIRADAR ENGINEERS AND CONTRACTORS PRIVATE LIMITED",
"S T CENTRAL WORKSHOP",
"S T COTTEX EXPORTS PRIVATE LIMITED",
"S T D SAREES PRIVATE LIMITED",
"S T I POWER INDIA PRIVATE LIMITED",
"S T P LTD",
"S T S MANUFACTURING PRIVATE LIMITED",
"S T UNICOM PRIVATE LIMITED",
"S TECH INFO PRIVATE LIMITED",
"S THAKUR INFRASTRUCTURE (I) PRIVATE LIMITED",
"S U B AGRO PRIVATE LIMITED",
"S V C S JUNIOR COLLEGE SOLAPUR",
"S V CREDIT LINE PRIVATE LIMITED",
"S V CREDITLINE PRIVATE LIMITED",
"S V E ENERGY PRIVATE LIMITED",
"S V EDM & WIRECUTTING SERVICES",
"S V ENGINEERING CONSTRUCTIONS (INDIA) PRIVATE LIMITED",
"S V EQUIPMENTS PRIVATE LIMITED",
"S V FABRICATORS PVT LTD",
"S V FABRICS PRIVATE LIMITED",
"S V GLOBAL MILL LIMITED",
"S V HOUSING PRIVATE LIMITED",
"S V INFRATECH ENGINEERS PRIVATE LIMITED",
"S V ISPAT PRIVATE LIMITED",
"S V K COOL CHAINS PRIVATE LIMITED",
"S V L MANPOWER SOLUTIONS PRIVATE LIMITED",
"S V LABS PRIVATE LIMITED",
"S V LIQUOR INDIA LIMITED",
"S V LOGISTICS AND SERVICES PRIVATE LIMITED",
"S V M A AGRO PRODUCTS PRIVATE LIMITED",
"S V M CARS PRIVATE LIMITED",
"S V MEGA LIMITED",
"S V METALLOYS PRIVATE LIMITED",
"S V N D & ASSOCIATES LLP",
"S V N HOTELS & RESORTS PRIVATE LIMITED",
"S V N MATRIC HIGHER SECONDARY SCHOOL",
"S V P PG INSTITUTE OF PAEDIATRICS",
"S V PATEL VIVIDHLAXMI VIDYALAYA",
"S V PLAZA PVT LTD",
"S V R AUTO PRIVATE LIMITED",
"S V RANGASWAMY AND COMPANY PRIVATE LIMITED",
"S V S BUILTSYSTEMS PRIVATE LIMITED",
"S V S FILTRATION ENGINEERS AND CONSULTANTS PRIVATE LIMITED",
"S V S HEALTH CARE PRIVATE LIMITED",
"S V S HOSPITALS PRIVATE LIMITED",
"S V S PROJECTS INDIA PRIVATE LIMITED",
"S V SACKS PRIVATE LIMITED",
"S V SILVARY TEXTILES PRIVATE LIMITED",
"S V SPIRITS PRIVATE LIMITED",
"S V TECHNOSOLUTIONS PRIVATE LIMITED",
"S V TRADING AND AGENCIES LIMITED",
"S V WINES PRIVATE LIMITED",
"S VINODKUMAR DIAMONDS PRIVATE LIMITED",
"S W FOODS & BEVERAGES PRIVATE LIMITED",
"S ZHAVERI PHARMAKEM PRIVATE LIMITED",
"S&A PROTECTION SOLUTIONS PRIVATE LIMITED",
"S&C ENTERPRISES PRIVATE LIMITED",
"S&C FOOTWEAR INDIA PRIVATE LIMITED",
"S&D SHARE & STOCK PRIVATE LIMITED",
"S&G INFRABUILDERS PRIVATE LIMITED",
"S&G METAL BUILDING SOLUTIONS INDIA PRIVATE LIMITED",
"S&IB SERVICES PRIVATE LIMITED",
"S&N SHREEFAL CONFECTIONERS PRIVATE LIMITED",
"S&O REALTORS PRIVATE LIMITED",
"S&P CAPITAL IQ (INDIA) PRIVATE LIMITED",
"S&P ELECINFRA PRIVATE LIMITED",
"S&P GLOBAL",
"S&P GLOBAL TECHNOLOGY RESOURCES (INDIA) LLP",
"S&P INFRASTRUCTURE DEVELOPERS PRIVATE LIMITED",
"S&P SAFETY PRODUCTS PRIVATE LIMITED",
"S&P STRUCTURALS PRIVATE LIMITED",
"S&R TECHNOLOGIES",
"S&S COMPUTERTECH PRIVATE LIMITED",
"S&S ENERGY SYSTEMS PRIVATE LIMITED",
"S&S GREEN PROJECTS PRIVATE LIMITED",
"S&S HORECA PRODUCTS PRIVATE LIMITED",
"S&S POWER SWITCHGEAR EQUIPMENT LIMITED",
"S. A. BIOTECH PRIVATE LIMITED",
"S. A. CONSULTANTS & FORWARDERS PRIVATE LIMITED",
"S. A. ELECTRICAL (OPC) PRIVATE LIMITED",
"S. A. INFRA PROJECTS (INDIA) PRIVATE LIMITED",
"S. A. INFRABUILD PRIVATE LIMITED",
"S. A. PLYWOOD INDUSTRY PRIVATE LIMITED",
"S. ABBAS & COMPANY PRIVATE LIMITED",
"S. B. AGRITECH (INDIA) PRIVATE LIMITED",
"S. B. B. MOULDINGS PRIVATE LIMITED",
"S. B. CREATIONS PRIVATE LIMITED",
"S. B. MULTIMEDIA PRIVATE LIMITED",
"S. BANO COLD STORAGE AND ICE FACTORY LIMITED",
"S. BUDDHI INVESTMENT PVT. LTD.",
"S. C. JAIN SAREES PRIVATE LIMITED",
"S. CHAND EDUTECH PRIVATE LIMITED",
"S. D. COLD STORAGE PRIVATE LIMITED",
"S. D. DOUNDE INFRA PRIVATE LIMITED",
"S. D. HEAVY SEA FOOD PRIVATE LIMITED",
"S. D. INFRAVENTURE PRIVATE LIMITED",
"S. D. INTERNATIONAL PRIVATE LIMITED",
"S. D. MATERIAL HANDLERS PRIVATE LIMITED",
"S. D. PLASTOWARE PRIVATE LIMITED",
"S. D. STEELCO PRIVATE LIMITED",
"S. D. TRADELINKS PRIVATE LIMITED",
"S. DAYAL CONSTRUCTION PRIVATE LIMITED",
"S. E. POWER LIMITED",
"S. G. & SONS JEWELLERS PRIVATE LIMITED",
"S. G. AGRICROP PRIVATE LIMITED",
"S. G. BAFNA JEWELLERS PRIVATE LIMITED",
"S. G. EDIBLE OILS (INDIA) PRIVATE LIMITED",
"S. G. FINEPUNCH PRIVATE LIMITED",
"S. G. INFORMATICS INDIA PRIVATE. LIMITED",
"S. GAMBHIR BUILDTECH PRIVATE LIMITED",
"S. GANDHI JEWELLERY PRIVATE LIMITED",
"S. GOENKA LIME AND CHEMICALS LIMITED",
"S. GOVIND ALLOY AND CEMENT PRIVATE LIMITED",
"S. H. ENGITECH PRIVATE LIMITED",
"S. I. SURGICAL PRIVATE LIMITED",
"S. J. CONSULTANT & CONTRACTOR PRIVATE LIMITED",
"S. J. GREEN PARK ENERGY PRIVATE LIMITED",
"S. J. LOGISTICS INDIA PRIVATE LIMITED",
"S. J. S. AUTO SERVICES PRIVATE LIMITED",
"S. K .GLASS MACHINES (INDIA) PRIVATE LIMITED",
"S. K. AGROTECH INDUSTRIES LIMITED",
"S. K. CARBON LIMITED",
"S. K. CEREMONIES PRIVATE LIMITED",
"S. K. FOREX (INDIA) PRIVATE LIMITED",
"S. K. INFINITETRADE PRIVATE LIMITED",
"S. K. JAIN RUBBERS PRIVATE LIMITED",
"S. K. MEHTA AND CO.",
"S. K. OFFSET PRIVATE LIMITED",
"S. K. POLY FOAMS PRIVATE LIMITED",
"S. K. SOLVENT (I) PRIVATE LIMITED",
"S. K. TRIVENI CONSTRUCTION PRIVATE LIMITED",
"S. KUMAR COTTON PRIVATE LIMITED",
"S. KUMAR CREATION PRIVATE LIMITED",
"S. KUMAR MULTIPRODUCTS PRIVATE LIMITED",
"S. L. BANTHIA TEXTILES INDUSTRIES PRIVATE LIMITED",
"S. L. FABTECH PRIVATE LIMITED",
"S. L. HITECH INFRAPARK PRIVATE LIMITED",
"S. L. ISPAT PRIVATE LIMITED",
"S. L. PACKAGING PRIVATE LIMITED",
"S. M. AUTOMART PRIVATE LIMITED",
"S. M. CONTAINER LINES PRIVATE LIMITED",
"S. M. DISTRIBUTORS PRIVATE LIMITED",
"S. M. GOLD LIMITED",
"S. M. NIRMAN INFRASTRUCTURE & DEVELOPMENT PRIVATE LIMITED",
"S. M. STEEL PRIVATE LIMITED",
"S. M. STEELS",
"S. M. TELEDIRECT PRIVATE LIMITED",
"S. M. WHEELS PRIVATE LIMITED",
"S. MOHINDER SINGH & SONS PRIVATE LIMITED",
"S. N. ELECTRIC & MAINTENANCE PRIVATE LIMITED",
"S. N. J. AUTOMOBILES PRIVATE LIMITED",
"S. N. KUNDEN TEXTILES PRIVATE LIMITED",
"S. N. MOTORS PRIVATE LIMITED",
"S. N. PERFUMERS PRIVATE LIMITED",
"S. N. S. (MINERALS) PRIVATE LIMITED",
"S. N. V. G. LOGISTICS PRIVATE LIMITED",
"S. NAND KUMAR AND COMPANY PVT LTD",
"S. O. GOLD PRIVATE LIMITED",
"S. P. BAGWE CONSULTANTS PRIVATE LIMITED",
"S. P. BUILDCON PRIVATE LIMITED",
"S. P. BULLION MERCHANTS PRIVATE LIMITED",
"S. P. JAISWAL ESTATES PRIVATE LIMITED",
"S. P. VEHICLES PRIVATE LIMITED",
"S. PARIKH PHARMA PRIVATE LIMITED",
"S. PYARELAL ISPAT PRIVATE LIMITED",
"S. R. ASHOK AND ASSOCIATES PRIVATE LIMITED",
"S. R. BALLARY",
"S. R. BIOSYSTEM PRIVATE LIMITED",
"S. R. COTTON",
"S. R. DATA SERVICES PRIVATE LIMITED",
"S. R. DEVELOPERS GREENCITY INDIA PRIVATE LIMITED",
"S. R. O. OVERSEAS PRIVATE LIMITED",
"S. R. RAVI",
"S. R. S. SPINTEX PRIVATE LIMITED",
"S. R. SAREE EMPORIUM PRIVATE LIMITED",
"S. R. SHIPPING CO.",
"S. R. SILVER PRIVATE LIMITED",
"S. R. TECHNOSOFT PRIVATE LIMITED",
"S. R. TEXTILE SUPPLIERS",
"S. R. WOOLLEN MILLS PVT LTD",
"S. R. WORTH LIMITED",
"S. RAHAMAN RICE AND FLOUR MILL MANUFACTURING PRIVATE LIMITED",
"S. RAHEJA INFRASTRUCTURE PRIVATE LIMITED",
"S. RAHEJA REALTY PRIVATE LIMITED",
"S. RAJIV AND CO.",
"S. RASIKLAL AND CO.",
"S. S. BEVERAGES PRIVATE LIMITED",
"S. S. BLISTER PACK PRIVATE LIMITED",
"S. S. CONSTRUCTION - KARAD",
"S. S. E. CONTRACTS PRIVATE LIMITED",
"S. S. GARMENTS PRIVATE LIMITED",
"S. S. GHORPADE CONSTRUCTIONS PRIVATE LIMITED",
"S. S. INDUSTRIES",
"S. S. INFRACONSTRUCTIONS PRIVATE LIMITED",
"S. S. INSTRUMENTS PRIVATE LIMITED",
"S. S. MASTERS PRIVATE LIMITED",
"S. S. POLYMERS",
"S. S. SALWAR SUITS PRIVATE LIMITED",
"S. S. T. PACKAGING PRIVATE LIMITED",
"S. S. V. AGENCIES PRIVATE LIMITED",
"S. S. V. CABLE PRIVATE LIMITED",
"S. SELLADURAI NADAR HOTEL & CATERING WORLD PRIVATE LIMITED",
"S. V. COOLING TOWERS PRIVATE LIMITED",
"S. V. G. PHARMACEUTICALS PRIVATE LIMITED",
"S. V. J. ENTERPRISES LIMITED",
"S. V. JADHAV CONTRACTORS PRIVATE LIMITED",
"S. V. M. WRAPPINGS PRIVATE LIMITED",
"S. V. TECHNOCRATS PRIVATE LIMITED",
"S.A ELECTRONIC PRIVATE LIMITED",
"S.A INTERNATIONAL PROJECTS PRIVATE LIMITED",
"S.A OXYNITRO PLANT PRIVATE LIMITED",
"S.A. COMPUTERS SOLUTION INDIA PRIVATE LIMITED",
"S.A. COTTEX PRIVATE LIMITED",
"S.A. EQUIPMENTS PRIVATE LIMITED",
"S.A. IRON & ALLOYS PRIVATE LIMITED",
"S.A. SAWANT CONSTRUCTIONS PRIVATE LIMITED",
"S.A. SERVICES LIMITED.",
"S.A. SNACKS PRIVATE LIMITED",
"S.A.AANANDAN MILL LIMITED",
"S.A.COLD STORAGE PVT LTD",
"S.A.F.ENGINEERING LINCS SYSTEMS PRIVATE LIMITED",
"S.A.G. LOGISTICS PRIVATE LIMITED",
"S.A.N. INTERNATIONAL PRIVATE LIMITED",
"S.A.S. INFOTECH PRIVATE LIMITED",
"S.A.S. LEASING PRIVATE LIMITED",
"S.A.S. QUALITY GLOBAL EXIM PRIVATE LIMITED",
"S.A.S.TELESHOP PRIVATE LIMITED",
"S.A.V. BLUEMETALS PRIVATE LIMITED",
"S.A.V.E. OPTICS PRIVATE LIMITED",
"S.A.Z OVERSEAS PRIVATE LIMITED",
"S.AMIT SPECIALITY CHEMICALS PRIVATE LIMITED",
"S.ANAND PACKAGING PRIVATE LIMITED",
"S.B EDUCATIONAL FOUNDATION",
"S.B PATIL SPACES AND INFRA LIMITED",
"S.B. AIR CONTROLLS PRIVATE LIMITED",
"S.B. COLD STORAGE INDUSTRIES PRIVATE LIMITED GP SINHA GROUP ENTITY",
"S.B. DESHMUKH INFRA PRIVATE LIMITED",
"S.B. GRANITES LIMITED",
"S.B. MARKPLUS PRIVATE LIMITED",
"S.B. PATIL MINERALS PRIVATE LIMITED",
"S.B. PLYWOOD PRIVATE LIMITED",
"S.B. PRAKASHAN PRIVATE LIMITED",
"S.B. PROPERTIES AND HOLDING PRIVATE LIMITED",
"S.B. PROTECT CHEMICALS PRIVATE LIMITED",
"S.B. SYSCON PRIVATE LIMITED",
"S.B. TELELINK PRIVATE LIMITED",
"S.B. ZIRCON PRIVATE LIMITED",
"S.B.A REALTORS & DEVELOPERS PRIVATE LIMITED",
"S.B.CARS PRIVATE LIMITED",
"S.B.CONSULTANCY AND CONSTRUCTION PRIVATE LIMITED",
"S.B.E. ENGINEERING AND INFRASTRUCTURE PRIVATE LIMITED",
"S.B.G. SOFTWARE PRIVATE LIMITED",
"S.B.HOTELS PVT.LTD.",
"S.B.P.A.PAPER LINK PRIVATE LIMITED",
"S.B.POULTRIES PRIVATE LIMITED",
"S.B.S. PETRO AND AGRO PRIVATE LIMITED",
"S.B.SAHOO & CO PRIVATE LIMITED",
"S.BALAJI MECH-TECH PRIVATE LIMITED",
"S.BIOTEX PRIVATE LIMITED",
"S.C. JAIN CONSTRUCTION PRIVATE LIMITED",
"S.C.C. BUILDERS PRIVATE LIMITED",
"S.C.INDUSTRIES PRIVATE LIMITED",
"S.C.P. INFRACON PRIVATE LIMITED",
"S.D MODEL SR SEC SCHOOL",
"S.D. AGARWAL TELECOM PRIVATE LIMITED",
"S.D. AUTO ENGINEERING WORKS PRIVATE LIMITED",
"S.D. ECOTECH PRIVATE LIMITED",
"S.D. ELECTRICAL CONTRACTOR PRIVATE LIMITED",
"S.D. INFRASTRACTURE & REAL ESTATE PRIVATE LIMITED",
"S.D. MOTORS PRIVATE LIMITED",
"S.D. POLYMER PRIVATE LIMITED.",
"S.D. SPINNING PRIVATE LIMITED",
"S.D. TRADE IMPEX PRIVATE LIMITED",
"S.D.L. COMMODITIES LIMITED",
"S.D.M. COT SPIN (INDIA) PRIVATE LIMITED",
"S.D.S. SALES PRIVATE LIMITED",
"S.D.S.N. AGROTECH PRIVATE LIMITED",
"S.D.S.SHIPPING PVT LTD",
"S.DALIP SINGH CREDIT PRIVATE LIMITED",
"S.DOSHI PAPERS INDUSTRIES PVT LTD",
"S.E. EXIM INDIA PRIVATE LIMITED",
"S.E. GRAPHITES PRIVATE LIMITED",
"S.E. MARKETING PRIVATE LTD",
"S.E. SALES PRIVATE LIMITED",
"S.E.S. PROJECTS PRIVATE LIMITED",
"S.E.T PU COLLEGE",
"S.E.W. COMMERCIAL COMPANY PRIVATE LIMITED",
"S.F INFRA PRIVATE LIMITED",
"S.F. RECYCLING PRIVATE LIMITED",
"S.G. CORPORATE MOBILITY PRIVATE LIMITD",
"S.G. DESIGNS PRIVATE LIMITED",
"S.G. ESTATES PRIVATE LIMITED",
"S.G. FACILITY MANAGEMENT PRIVATE LIMITED",
"S.G. INFRACARE PRIVATE LIMITED",
"S.G. INSTRUMENTS PRIVATE LIMITED",
"S.G. PRINT-N-PACK INDUSTRIES PRIVATE LIMITED",
"S.G. TELECARE PRIVATE LIMITED",
"S.G. VAYU EQUIPMENTS PRIVATE LIMITED",
"S.G.ASSOCIATES PRIVATE LIMITED",
"S.G.BIOPHARM PRIVATE LIMITED",
"S.G.FIBRES PRIVATE LIMITED",
"S.G.G. CEMENT PRODUCT PRIVATE LIMITED",
"S.G.KNITFAB PRIVATE LIMITED",
"S.G.M. TEXTILES PRIVATE LIMITED",
"S.G.MISTRY CONSTRUCTION PRIVATE LIMITED",
"S.G.P.EXIM PRIVATE LIMITED",
"S.G.POLYTEX INDIA PRIVATE LIMITED",
"S.G.R.S ACADEMIC PRIVATE LIMITED",
"S.G.S MOTORS PRIVATE. LIMITED.",
"S.G.S.COMMODITY PRIVATE LIMITED",
"S.GAMBHIR EXPORTS PRIVATE LIMITED",
"S.GOPAL KAMATH COCHIN PRIVATE LIMITED",
"S.H. HOME FURNISHINGS PRIVATE LIMITED",
"S.H. LAWCHEM SOLUTIONS PRIVATE LIMITED",
"S.H.A.M.K. MERCANTILE PRIVATE LIMITED",
"S.H.MUMTAZUDDIN TIMES PRIVATE LIMITED",
"S.H.PANDYA ENGINEERING PRIVATE LIMITED",
"S.H.S. TRANSPORT PRIVATE LIMITED",
"S.I GLOBAL PRIVATE LIMITED",
"S.I. FINANCIAL SERVICES LIMITED",
"S.I. IT CONSULTANCY SERVICES INDIA PRIVATE LIMITED",
"S.I.CAPITAL & FINANCIAL SERVICES LIMITED",
"S.I.V. STEELS PRIVATE LIMITED",
"S.J. EXPORTS",
"S.J. SOFTECH PRIVATE LIMITED",
"S.J.INVESTMENT SERVICES PRIVATE LIMITED",
"S.J.R. INFRASTRUCTURE PRIVATE LIMITED",
"S.J.S. ENTERPRISES LIMITED",
"S.J.THACKER FREIGHT FORWARDERS PRIVATE LIMITED",
"S.J.V. TOOLS PRIVATE LIMITED",
"S.JAGANNATHAM&SONS HANDLOOM SILK SAREES PRIVATE LIMITED",
"S.K MINING & LOGISTICS PRIVATE LIMITED",
"S.K PAPER MILLS PRIVATE LIMITED",
"S.K. 17 INTERNATIONAL PRIVATE LIMITED",
"S.K. ADHESIVES PRIVATE LIMITED",
"S.K. DISTRIBUTORS & INFRAHEIGHTS (INDIA) PRIVATE LIMITED",
"S.K. EMBROIDERY PRIVATE LIMITED",
"S.K. FAB COROGATION TECH PRIVATE LIMITED",
"S.K. FIBRE SOLUTION PRIVATE LIMITED",
"S.K. FOOD EQUIPMENTS PRIVATE LIMITED",
"S.K. GREENTEX PRIVATE LIMITED",
"S.K. HEIGHTS PRIVATE LIMITED",
"S.K. METAIMPEX PRIVATE LIMITED",
"S.K. PETRO SERVICES PRIVATE LIMITED",
"S.K. RICE INDUSTRIES",
"S.K. ROLLER FLOUR MILLS PRIVATE LIMITED",
"S.K. SOLVEX PRIVATE LIMITED",
"S.K. SORTEX PRIVATE LIMITED",
"S.K. STEELS TRANSCORE PRIVATE LIMITED",
"S.K. SULZ FAB PRIVATE LIMITED",
"S.K. VASTU BUILDERS PRIVATE LIMITED",
"S.K. WELDEDMESH PRIVATE LIMITED",
"S.K. WHEAT PRODUCTS PRIVATE LIMITED",
"S.K. YARNS PRIVATE LIMITED",
"S.K.A. DAIRY FOODS INDIA PRIVATE LIMITED",
"S.K.C.IRON & STEELS PRIVATE LIMITED",
"S.K.D. SHIPPING AND FORWARDING PRIVATE LIMITED",
"S.K.DAS FOREX & TRAVELS PRIVATE LIMITED",
"S.K.FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"S.K.FLORESCENCES PRIVATE LIMITED",
"S.K.HETAMSARIA & COMPANY PVT LTD",
"S.K.J.S.ENTERPRISES",
"S.K.JAIN CONSTUCTIONS PRIVATE LIMITED",
"S.K.L ENTERPRISES PRIVATE LIMITED",
"S.K.M JEWELLERS PRIVATE LIMITED",
"S.K.M TIMBER PRIVATE LIMITED",
"S.K.M.K. ISPAT UDYOG PRIVATE LIMITED",
"S.K.M.S. MOTORS PRIVATE LIMITED",
"S.K.MEDICAL FOUNDATION PRIVATE LIMITED",
"S.K.P. EXIM PRIVATE LIMITED",
"S.K.S. ENTERPRISES PRIVATE LIMITED",
"S.K.S. INDUSTRIES PRIVATE LIMITED",
"S.K.S. INFRASTRUCTURES PRIVATE LIMITED",
"S.K.SHOES AND BOOTS PRIVATE LIMITED",
"S.K.TOTLA INFRACONSTRUCTION PRIVATE LIMITED",
"S.KAJAL KOLKATA PRIVATE LIMITED",
"S.KAMLESH FASHION PRIVATE LIMITED",
"S.L BAJORIA FOUNDATION HIGH SCHOOL",
"S.L ELECTRICAL INDUSTRIES P. LTD.",
"S.L. DEV AND COMPANY PRIVATE LIMITED",
"S.L. DIAGNOSTICS PRIVATE LIMITED",
"S.L. EDIBLE OILS PRIVATE LIMITED",
"S.L. ELECTTRICALS",
"S.L. FABS PRIVATE LIMITED",
"S.L. INFRAESTATE PRIVATE LIMITED",
"S.L. MITTAL STEELS PRIVATE LIMITED",
"S.L. OBERAI MINERALS PRIVATE LIMITED",
"S.L. SEALING SYSTEMS PRIVATE LIMITED",
"S.L.AIR PRODUCTS PRIVATE LIMITED",
"S.L.ARORA ELECTRONICS PRIVATE LIMITED",
"S.L.B. FAB PRIVATE LIMITED",
"S.L.G METAL INDUSTRIES PRIVATE LIMITED",
"S.L.K.M.D. SAREES PRIVATE LIMITED",
"S.L.KULKARNI CYRIL GRAPHICS PRIVATE LIMITED",
"S.L.N. FINANCE & LEASING PRIVATE LIMITED",
"S.L.N. FOREX SERVICES PRIVATE LIMITED",
"S.L.V TILES PRIVATE LIMITED",
"S.L.V. SHELTERS PRIVATE LIMITED",
"S.L.V. STEELS AND ALLOYS PRIVATE LIMITED",
"S.M. AGRI EXPORTS PRIVATE LIMITED",
"S.M. APPLIANCES PRIVATE LIMITED",
"S.M. COLD STORAGE PRIVATE LIMITED",
"S.M. ENVIRONMENTAL TECHNOLOGIES PRIVATE LIMITED",
"S.M. EYE INSTITUTE PRIVATE LIMITED",
"S.M. INFRACON PRIVATE LIMITED.",
"S.M. INFRA-STRUCTURES PRIVATE LIMITED",
"S.M. MOHAMED IBRAHIM & COMPANY PRIVATE LIMITED",
"S.M. PRESERVERS PRIVATE LIMITED",
"S.M. PROPCON PRIVATE LIMITED",
"S.M. SPUN TEX PRIVATE LIMITED",
"S.M. WOOLTEX PRIVATE LIMITED",
"S.M.AUTOPARTS PRIVATE LIMITED",
"S.M.CREATIVE ELECTRONICS LIMITED",
"S.M.FILAMENTS PRIVATE LIMITED",
"S.M.GARAGES PRIVATE LIMITED",
"S.M.INTELLISOFT TECHNOLOGIES PRIVATE LIMITED",
"S.M.K. POLYMERS INDUSTRIES PRIVATE LIMITED",
"S.M.S PROPERTIES PRIVATE LIMITED",
"S.M.SYSTEMS PRIVATE LIMITED",
"S.M.T.PROPERTY DEVELOPERS PRIVATE LIMITED",
"S.MARK OIL FIELD ENGINEERING PRIVATE LIMITED",
"S.MUNJAL INFOSOLUTIONS PRIVATE LIMITED",
"S.N HUMAN RESOURCE CONSULTING PRIVATE LIMITED",
"S.N. BIRI FACTORY PRIVATE LIMITED",
"S.N. CASHEW INTERNATIONAL PRIVATE LIMITED",
"S.N. CASTINGS LIMITED",
"S.N. CHEMICALS PRIVATE LIMITED",
"S.N. COLD STORAGE PRIVATE LIMITED",
"S.N. DYECHEM PRIVATE LIMITED",
"S.N. INFORMATICS PRIVATE LIMITED",
"S.N. MILK PRODUCTS PRIVATE LIMITED",
"S.N. PANDEY CONSTRUCTION (INDIA) PRIVATE LIMITED",
"S.N. POLI MOULDS PRIVATE LIMITED",
"S.N.C FISH EXPORTS PRIVATE LIMITED",
"S.N.FORESTRY LIMITED",
"S.N.HOTELS & RESORTS PRIVATE LIMITED",
"S.N.I. INFRATECH PRIVATE LIMITED",
"S.N.J. TRADE LINK PRIVATE LIMITED",
"S.N.N. TEXTILES PRIVATE LIMITED",
"S.N.POLYPLAST PRIVATE LIMITED",
"S.N.Q.S. INTERNATIONALS",
"S.O.T.GARMENTS INDIA PRIVATE LIMITED",
"S.OLIVER FASHION INDIA PRIVATE LIMITED",
"S.P TRAVELS",
"S.P. AIR TOOLS PRIVATE LIMITED",
"S.P. ASSOCIATES",
"S.P. MALIK & CO PVT LTD",
"S.P. MEDICINES PRIVATE LIMITED",
"S.P. METALTECH INDIA PRIVATE LIMITED",
"S.P. POLY PACKS PRIVATE LIMITED",
"S.P. RICE EXPORTS PRIVATE LIMITED",
"S.P. SORTEX RICE EXPORTS INDIA PRIVATE LIMITED",
"S.P. TEXTWORLD PRIVATE LIMITED",
"S.P.A. AGRIFOODS PRIVATE LIMITED",
"S.P.A. DRUGS PRIVATE LIMITED",
"S.P.A.CANS PRIVATE LIMITED",
"S.P.C.INFRASTRUCTURE PRIVATE LIMITED",
"S.P.G. OIL & CHEMICALS PRIVATE LIMITED",
"S.P.ICE AND COLD STORAGE PRIVATE LIMITED",
"S.P.K. FIBERS PRIVATE LIMITED",
"S.P.M. FOREX AND TOURS PRIVATE LIMITED",
"S.P.M.POWER AND TELECOM PRIVATE LIMITED",
"S.P.MANI AND MOHAN DAIRY",
"S.P.MENTHA AND ALLIED PRODUCTS PRIVATE LIMITED",
"S.P.P FOOD PRODUCTS PRIVATE LIMITED",
"S.P.R. JAIN KANYA SCHOOL",
"S.P.R.L. FOODS LIMITED",
"S.P.R.U INFRATECH PRIVATE LIMITED",
"S.P.S.A. SILKS PRIVATE LIMITED",
"S.P.SOLVENT PRIVATE LIMITED",
"S.P.STEEL MARITECH PRIVATE LIMITED",
"S.P.Y. AGRO INDUSTRIES LIMITED",
"S.Q.L SURGICALS (INDIA) PRIVATE LIMITED",
"S.R AND SONS INFRATECH PRIVATE LIMITED",
"S.R PRECISION COMPONENTS PRIVATE LIMITED",
"S.R. BATTERIES PRIVATE LIMITED",
"S.R. COLLECTION PRIVATE LIMITED",
"S.R. CONSTRUCTIONS PRIVATE LIMITED",
"S.R. DRUGS AND INTERMEDIATES PVT.LTD.",
"S.R. INDIA VOYAGES PRIVATE LIMITED",
"S.R. INTERNATIONAL PAPER MILLS PRIVATE LIMITED",
"S.R. JUTE PACKAGERS PRIVATE LIMITED",
"S.R. KATHA INDUSTRIES PRIVATE LIMITED",
"S.R. METCAST INDIA PRIVATE LIMITED",
"S.R. MITTAL PAPER MILLS LIMITED",
"S.R. MOTEL AND RESORT",
"S.R. PATEL ORNAMENTS PRIVATE LIMITED",
"S.R. PROTEINS PRIVATE LIMITED",
"S.R. RAJA JEWELLERY PRIVATE LIMITED",
"S.R. TEXFAB PRIVATE LIMITED",
"S.R. TEXWASH PRIVATE LIMITED",
"S.R. TRADELINK PRIVATE LIMITED",
"S.R. TURBO ENERGY PRIVATE LIMITED",
"S.R. WHEELS PRIVATE LIMITED",
"S.R.A MANUFACTURING PRIVATE LIMITED",
"S.R.A. GREEN HEIGHTS PRIVATE LIMITED",
"S.R.A. RETAILS PRIVATE LIMITED",
"S.R.C FULFILLMENT LOGISTICS & WAREHOUSING PRIVATE LIMITED",
"S.R.D. STEELS PRIVATE LIMITED",
"S.R.DIAGNOSTICS PRIVATE LIMITED",
"S.R.G. NARROW FAB PRIVATE LIMITED",
"S.R.K. BIKERLABS PRIVATE LIMITED",
"S.R.K. PAPERS PRIVATE LIMITED",
"S.R.M. ALLOYS PVT. LTD",
"S.R.M. BUILDERS & ENGINEERS PRIVATE LIMITED",
"S.R.N.FEEDS PRIVATE LIMITED",
"S.R.OIL SPECIALITY PRIVATE LIMITED",
"S.R.P. PROJECTS PRIVATE LIMITED",
"S.R.R.A. HOSPITAL AND RESEARCH INSTITUTE PRIVATE LIMITED",
"S.R.S. ALLOYS PRIVATE LIMITED",
"S.R.S. DEVCON PRIVATE LIMITED",
"S.R.S. EXPORTS PRIVATE LIMITED",
"S.R.S. INFRA PROJECTS PRIVATE LIMITED.",
"S.R.S. TRAVELS AND LOGISTICS PRIVATE LIMITED",
"S.R.S. VIZCON PRIVATE LIMITED",
"S.R.S.SYNTEX LIMITED",
"S.R.T.AGRO SCIENCE PRIVATE LIMITED",
"S.R.T.INVESTMENTS PRIVATE LIMITED",
"S.R.THORAT MILK PRODUCTS PRIVATE LIMITED",
"S.R.TOWERS (INDIA) PRIVATE LIMITED",
"S.R.V. HOME APPLIANCES PRIVATE LIMITED",
"S.S JAIN SUBODH LAW COLLEGE",
"S.S. AGRI BUSINESS PRIVATE LIMITED",
"S.S. AUTOMOTIVE INDUSTRIES PRIVATE LIMITED",
"S.S. AUTOMOTIVE PRIVATE LIMITED",
"S.S. CHHATWAL & COMPANY CONTRACTORS PRIVATE. LIMITED.",
"S.S. CIVIL CONSTRUCTION PRIVATE LIMITED",
"S.S. COTTON INDUSTRIES PRIVATE LIMITED",
"S.S. DESIGNEX INDIA PRIVATE LIMITED",
"S.S. ELECTRONICS PRIVATE LIMITED",
"S.S. ENGINEERING CONSULTANT PRIVATE LIMITED",
"S.S. FLOUR MILLS (KHOPOLI) PRIVATE LIMITED",
"S.S. FRUITS INTERNATIONAL PRIVATE LIMITED",
"S.S. INFRAZONE PRIVATE LIMITED",
"S.S. JARIA JEWEL PRIVATE LIMITED",
"S.S. LIFECARE PRIVATE LIMITED",
"S.S. LIGHTS INNOVATIVE PRIVATE LIMITED",
"S.S. MECHANICAL ENGINEERS PRIVATE LIMITED",
"S.S. MERCHANTS & VENDORS PRIVATE LIMITED",
"S.S. MULTIGRAIN INDIA PRIVATE LIMITED",
"S.S. NIYO AUTOMOTIVES PRIVATE LIMITED",
"S.S. ORNAMENTS & JEWELS PRIVATE LIMITED",
"S.S. RESINS PRIVATE LIMITED",
"S.S. SAREES PRIVATE LIMITED",
"S.S. SCIENTIFIC INDUSTRIES PRIVATE LIMITED",
"S.S. SPARES WORLD PRIVATE LIMITED",
"S.S. TECHSOURCE PRIVATE LIMITED",
"S.S. TOOLS (INDIA) PRIVATE LIMITED",
"S.S. WINDING WORKS PRIVATE LIMITED",
"S.S.A. HATCHERIES PVT LTD",
"S.S.B. MEDICARE PRIVATE LIMITED",
"S.S.BAHETI (I) PRIVATE LIMITED",
"S.S.BLOW CHEM PRIVATE LIMITED",
"S.S.C STEELS PRIVATE LIMITED",
"S.S.CARGO & LOGISTICS PRIVATE LIMITED",
"S.S.CERAMICA ARCH(INDORE)PVT LTD",
"S.S.CONTROLS SYSTEMS PRIVATE LIMITED",
"S.S.CROP CARE PRIVATE LIMITED",
"S.S.FLEXIPACK PVT LTD",
"S.S.HEAT RECOVER ENGINEERS INDIA PRIVATE LIMITED",
"S.S.INFRACON SUPPLIES PRIVATE LIMITED",
"S.S.J. SHEET METAL COMPONENTS PRIVATE LIMITED",
"S.S.K. TRANSPORTS PRIVATE LIMITED",
"S.S.P. PACKAGING SOLUTIONS PRIVATE LIMITED",
"S.S.PROPERTIES PRIVATE LIMITED",
"S.S.R.K.PLASTICS PRIVATE LIMITED",
"S.S.R.TRADING PRIVATE LIMITED",
"S.S.S FROZEN FOODS PRIVATE LIMITED",
"S.S.SEA FOOD PRIVATE LIMITED",
"S.S.V. TEXTILES EXIM PRIVATE LIMITED",
"S.S.V.DISTRIBUTORS INDIA PRIVATE LIMITED",
"S.SATYAM AVIATIONS PRIVATE LIMITED",
"S.SHALU CONSTRUCTIONS PRIVATE LIMITED",
"S.T. CONSTRUCTIONS PRIVATE LIMITED",
"S.T. ELECTRICALS PRIVATE LIMITED STEPL",
"S.T. NARAYAN ESTATE DEVELOPERS PRIVATE LIMITED",
"S.T. REDDIAR & SONS",
"S.T. RETAIL INDIA PRIVATE LIMITED",
"S.T. WOOLLEN MILLS PRIVATE LIMITED",
"S.V. AVIKA AKSH IMPEX PRIVATE LIMITED",
"S.V. ELECTRONICS LIMITED",
"S.V. FORGINGS PRIVATE LIMITED",
"S.V. GHATALIA & ASSOCIATES LLP",
"S.V. HYGIENE IMPORTS PRIVATE LIMITED",
"S.V. INFRA HOLDINGS LIMITED",
"S.V. LABS PRIVATE LIMITED",
"S.V. RUBBER INDUSTRIES PRIVATE LIMITED",
"S V A RIKKON LUBES PRIVATE LIMITED",
"S.V.C .PROJECTS PRIVATE LIMITED",
"S.V.CHEM INTERMEDIATES PRIVATE LIMITED",
"S.V.D FARM SCIENCE & RESEARCH PRIVATE LIMITED",
"S.V.E.C. CONSTRUCTIONS LIMITED",
"S.V.ERECTOR PRIVATE LIMITED",
"S.V.GEMS PRIVATE LIMITED",
"S.V.HI-TECH BEARING (INDIA) PRIVATE LIMITED",
"S.V.INSTITUTE OF MANAGEMENT",
"S.V.K. PROFILES PRIVATE LIMITED",
"S.V.M. OIL MILLS PRIVATE LIMITED",
"S.V.MODULAR CONVEYORS PRIVATE LIMITED",
"S.V.O. FOOTWEAR EXPORTS PRIVATE LIMITED",
"S.V.P. CHEMICALS PRIVATE LIMITED",
"S.V.POLYMERS PRIVATE LIMITED",
"S.V.PRINTERS AND PACKAGERS PRIVATE LIMITED",
"S.V.R. ELECTRICALS PVT. LTD.",
"S.V.SCIENTIFIC PRIVATE LIMITED",
"S.V.TECH ENGINEERING CONSULTANTS PRIVATE LIMITED",
"S.V.V. ELECTRO ENGINEERING PRIVATE LIMITED",
"S.VIMAL COLLECTIONS PRIVATE LIMITED",
"S.Y.N. AGRO PRODUCTS PRIVATE LIMITED",
"S.Y.S INVESTMENTS AND REALTY LIMITED",
"S10 HEALTH SAFECARE PRIVATE LIMITED",
"S10 HEALTHCARE SOLUTION LIMITED",
"S10 HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"S2 ANALYTICS PRIVATE LIMITED",
"S2 INFOTECH INTERNATIONAL LIMITED",
"S2 INTEGRATORS PRIVATE LIMITED",
"S2 REALTY & DEVELOPERS PRIVATE. LIMITED.",
"S2 RESOURCES PRIVATE LIMITED",
"S2A CONSULTANCY SERVICES PRIVATE LIMITED",
"S2B LOGICARE PRIVATE LIMITED",
"S2C CONSULTING PRIVATE LIMITED",
"S2D PROCESS SOLUTIONS PRIVATE LIMITED",
"S2G ELECTROVENTURES PRIVATE LIMITED",
"S2K ZIP FASTENER INDUSTRIES PRIVATE LIMITED",
"S2M HEALTH PRIVATE LIMITED",
"S2M LIFESCIENCE PRIVATE LIMITED",
"S2S EXPERT SOLUTIONS PRIVATE LIMITED",
"S2S IT SOLUTIONS PRIVATE LIMITED",
"S2TECH.COM INDIA PRIVATE LIMITED",
"S2V HOSPITALITY PRIVATE LIMITED",
"S3 AGRO VISION PRIVATE LIMITED",
"S3 ENERGY PRIVATE LIMITED",
"S3 FINANCIAL SOLUTIONS PRIVATE LIMITED",
"S3 FUEL PRIVATE LIMITED",
"S3 INFOMEDIA PRIVATE LIMITED",
"S3 INFOTECH PRIVATE LIMITED",
"S3 INFRAREALITY PRIVATE LIMITED",
"S3 SMART SPACES PRIVATE LIMITED",
"S3 SOLUTIONS PRIVATE LIMITED",
"S3BGLOBAL TECHNOLOGIES LLP",
"S3M DESIGN CONSULTANTS LLP",
"S3P TRADE LINK PRIVATE LIMITED",
"S3V VASCULAR TECHNOLOGIES LIMITED",
"S3VISION SOFTWARE PRIVATE LIMITED",
"S4 CARLISLE PUBLISHING SERVICES PRIVATE LIMITED",
"S4 FACILITIES MANAGEMENT PRIVATE LIMITED",
"S4 FRANCHISEES PRIVATE LIMITED",
"S4 HEALTHCARE PRIVATE LIMITED",
"S5 AGENCY WORLD INDIA PRIVATE LIMITED",
"S7 CARS INDIA P LIMITED",
"S9 MIND-TECH KNOWLEDGE PRIVATE LIMITED",
"SA AIR WORKS INDIA PRIVATE LIMITED",
"SA ALUMINIUM WIRES PRIVATE LIMITED",
"SA GLOBAL ADVISORS LLP",
"SA INFRASTRUCTURE CONSULTANTS PRIVATE LIMITED",
"SA INFRASTRUCTURE PRIVATE LIMITED",
"SA POWER UTILITIES PRIVATE LIMITED",
"SA SEKAR AUDIO PRIVATE LIMITED",
"SA SYNCON INFRASTRUCTURE SERVICES INDIA PRIVATE LIMITED",
"SAA VISHNU BAKERS PRIVATE LIMITED",
"SAAA INFRA-SPACE PRIVATE LIMITED",
"SAAB ENGINEERING",
"SAAB FAB",
"SAAB FOOTWEAR PRIVATE LIMITED",
"SAAB INDIA TECHNOLOGIES PRIVATE LIMITED",
"SAAB JEE FASHIONS PRIVATE LIMITED",
"SAABARI LOGISTICS PRIVATE LIMITED",
"SAACH PHARMACEUTICALS PRIVATE LIMITED",
"SAACHI INFORMATICS PRIVATE LIMITED",
"SAACHI PROCESSORS PRIVATE LIMITED",
"SAACHI VENUS INDIA PRIVATE LIMITED",
"SAAD COMMUNICATIONS PRIVATE LIMITED",
"SAAD INFRASTRUCTURE INDIA PRIVATE LIMITED",
"SAADAA SUSTAINABLE DESIGNS AND TECHNOLOGIES PRIVATE LIMITED",
"SAADH INFRATECH PRIVATE LIMITED",
"SAADRUSO TECHNOLOGY VENTURES PRIVATE LIMITED",
"SAAGAR ECO PROJECTS PRIVATE LIMITED",
"SAAGAR FURNICO PRIVATE LIMITED",
"SAAGAR MOTORCOMP PRIVATE LIMITED",
"SAAGHAR INFRA PRIVATE LIMITED",
"SAAHAJ MILK PRODUCER COMPANY LIMITED",
"SAAHAS WASTE MANAGEMENT PRIVATE LIMITED",
"SAAHIL IMPEX LLP",
"SAAHIL ORGANICS PRIVATE LIMITED",
"SAAISH METALLIKS PRIVATE LIMITED",
"SAAISHA EXPORT PRIVATE LIMITED",
"SAAJ AGRO FOODS PRIVATE LIMITED",
"SAAJ FOODS AND HOSPITALITY PRIVATE LIMITED",
"SAAJ RESTAURANTS PRIVATE LIMITED",
"SAAKAAR APPLIANCES PRIVATE LIMITED",
"SAAKAAR CONSTRUCTIONS PRIVATE LIMITED",
"SAAKAR CO OPERATIVE CREDIT SOCIETY",
"SAAKAR EXIM PRIVATE LIMITED",
"SAAKAR INFRA NIRMAN PRIVATE LIMITED",
"SAAKAR INFRA PROJECTS PRIVATE LIMITED",
"SAAKAR MARMO IMPEX PRIVATE LIMITED",
"SAAKET TEXTILES PRIVATE LIMITED",
"SAAKETA INVESTMENT SERVICES LIMITED",
"SAAKETH IRON INDUSTRIES PRIVATE LIMITED",
"SAAKI LIFESTYLE PRIVATE LIMITED",
"SAAKI POWER PROJECT LIMITED",
"SAAKSH DEGITECH SERVICES PRIVATE LIMITED",
"SAAKSHI MACHINE AND TOOLS PRIVATE LIMITED",
"SAAKSHI MEDTECH AND PANELS LIMITED",
"SAAKSHI UDYOG PRIVATE LIMITED",
"SAALASAR LOGISTICS PRIVATE LIMITED",
"SAAM INDUSTRIES PRIVATE LIMITED",
"SAAM TEXTILES PRIVATE LIMITED",
"SAAM TOURIST PRIVATE LIMITED",
"SAAMA INFRATECH PRIVATE LIMITED",
"SAAMA TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"SAAMAG INDUSTRIES PRIVATE LIMITED",
"SAAMARTH GROUP",
"SAAMI TRADESTAR LOGISTICS LIMITED",
"SAAMIPYA HOME HEALTH PRIVATE LIMITED",
"SAAMS INFOLOGY PRIVATE LIMITED",
"SAAMYUKTA DEVELOPMENT AND INFRASTRUCTURE PRIVATE LIMITED",
"SAAN BOARDS PRIVATE LIMITED",
"SAAN ENGINEERS PRIVATE LIMITED",
"SAAN GLOBAL LIMITED",
"SAAN LABS LLP",
"SAAN PROTOCOL EXPERTS PRIVATE LIMITED",
"SAANCH CREATIONS PRIVATE LIMITED",
"SAANCHI GOLD PRIVATE LIMITED",
"SAANCHIT TRANSPORT SERVICE PRIVATE LIMITED",
"SAANDIPANI EDUCATIONAL TRUST",
"SAANIKA INDUSTRIES PRIVATE LIMITED",
"SAANIKA POLYTEX PRIVATE LIMITED",
"SAANIKA TEXTILES PRIVATE LIMITED",
"SAANKAK SOLUTIONS PRIVATE LIMITED",
"SAANKHYA LABS PRIVATE LIMITED",
"SAANKHYA STRATEGIC ELECTRONICS PRIVATE LIMITED",
"SAANKHYA TECHNOSYSTEMS PRIVATE LIMITED",
"SAANTRADE INTERNATIONAL PRIVATE LIMITED",
"SAANUAI HEALTHCARE PRIVATE LIMITED",
"SAANVAD VENTURES PRIVATE LIMITED",
"SAANVEE STAR HOSPITALITY PRIVATE LIMITED",
"SAANVI AGRICULTURAL PRODUCTS PRIVATE LIMITED",
"SAANVI AGRO FOODS PRIVATE LIMITED",
"SAANVI CLOTHING PRIVATE LIMITED",
"SAANVI DRYMIX PRODUCTS PRIVATE LIMITED",
"SAANVI ELECTRICALS PRIVATE LIMITED",
"SAANVI FOREX PRIVATE LIMITED",
"SAANVI HITECH PRIVATE LIMITED",
"SAANVI INFRA BUILDCON PRIVATE LIMITED",
"SAANVI INTERIORS INDIA PRIVATE LIMITED",
"SAANVI INTERNATIONAL PRIVATE LIMITED",
"SAANVI NARROW FAB INDIA PRIVATE LIMITED",
"SAANVI RESIDENCY PRIVATE LIMITED",
"SAANVI VITRIFIED PRIVATE LIMITED",
"SAANWARIA POLYESTER PRIVATE LIMITED",
"SAAOL HEARTCARE PRIVATE LIMITED",
"SAAOL PHARMA PRIVATE LIMITED",
"SAAP LOGISTICS PRIVATE LIMITED",
"SAAR COMMODITIES PRIVATE LIMITED",
"SAAR EDUCATION (I) PRIVATE LIMITED",
"SAAR INTEGRATED SERVICES PRIVATE LIMITED",
"SAAR IT RESOURCES PRIVATE LIMITED",
"SAAR SECURITIES (INDIA) PRIVATE LIMITED",
"SAARA APPARELS",
"SAARA DESIGNERS PRIVATE LIMITED",
"SAARA FASHION PRIVATE LIMITED",
"SAARA MEDIATECH PRIVATE LIMITED",
"SAARA NUTRITION PRIVATE LIMITED",
"SAARAL LAMINATE CENTER",
"SAARANG INTERNATIONAL FOOD & BEVERAGES PRIVATE LIMITED",
"SAARANSH BIOTECH PRIVATE LIMITED",
"SAARANYA HOSPITALITY TECHNOLOGIES PRIVATE LIMITED",
"SAARAS BREEDING FARM PRIVATE LIMITED",
"SAARAS POULTRY PRIVATE LIMITED",
"SAARATHEE CRM PRIVATE LIMITED",
"SAARATHI HEALTH CARE PRIVATE LIMITED",
"SAARC TOOL TECH PRIVATE LIMITED",
"SAARIGA CONSTRUCTIONS PRIVATE LIMITED",
"SAARLOHA ADVANCED MATERIALS PRIVATE LIMITED",
"SAARTH DEVELOPERS PRIVATE LIMITED",
"SAARTHAK COLONIZERS PRIVATE LIMITED",
"SAARTHAK MENTAL HEALTH SERVICES PRIVATE LIMITED",
"SAARTHAK VANIJYA INDIA LIMITED",
"SAARTHAK VANIJYA INDIA PRIVATE LIMITED",
"SAARTHI AIRWAYS PRIVATE LIMITED",
"SAARTHI BUSINESS & KNOWLEDGE SOLUTIONS PRIVATE LIMITED",
"SAARTHI DREAMESTATES PRIVATE LIMITED",
"SAARUS INNOVATIONS PRIVATE LIMITED",
"SAARVASRI HERBS PRIVATE LIMITED",
"SAAS LABS SOFTWARE PRIVATE LIMITED",
"SAAS SOFTPRO LEADERS PRIVATE LIMITED",
"SAASANT INFOTECH PRIVATE LIMITED",
"SAASFOCUS CONSULTING PRIVATE LIMITED",
"SAASFORCE CONSULTING PRIVATE LIMITED",
"SAASFORCE CONSULTING PRIVATE. LIMITED",
"SAASHI OVERSEAS PRIVATE LIMITED",
"SAASIFY SOLUTIONS PRIVATE LIMITED",
"SAASIN ELECTRO PRIVATE LIMITED",
"SAASKIN CORPORATION PRIVATE LIMITED",
"SAASSPOT TECHNOLOGIES PRIVATE LIMITED",
"SAASTHA WARE HOUSING LIMITED",
"SAASTHAA TECHNICAL TEXTILES PRIVATE LIMITED",
"SAASWAD HEAT TRANSFER AND ENGINEERING PRIVATE LIMITED",
"SAATAREM ALTERNATIVE FUEL AND ENERGY PRIVATE LIMITED",
"SAATCHI AND SAATCHI PRIVATE LIMITED",
"SAATH MERCHANTS PRIVATE LIMITED",
"SAATHI ECO INNOVATIONS INDIA PRIVATE LIMITED",
"SAATHI SOLIDARITY AND ACTION AGAINST THE HIV INFECTION IN INDIA",
"SAATHI TEXTILES PRIVATE LIMITED",
"SAATHIVA ENTERPRISE PRIVATE LIMITED",
"SAATHWIK ENTERPRISES (INDIA) PRIVATE LIMITED",
"SAATVIC ORGANIC FOODS LLP",
"SAATVIK FERRO LIMITED",
"SAATVIK GREEN ENERGY PRIVATE LIMITED",
"SAATVIK HOLIDAYS INDIA PRIVATE LIMITED",
"SAATVIK MARBLES PRIVATE LIMITED",
"SAATVIK SOLUTIONS LLP",
"SAATVIKA TEXTILES PRIVATE LIMITED",
"SAAVA SURGICALS PRIVATE LIMITED",
"SAAVAN DREAMZ PRIVATE LIMITED",
"SAAVN MEDIA LIMITED",
"SAAVN MEDIA PRIVATE LIMITED",
"SAAVY AGRO FRESH PRIVATE LIMITED",
"SAAWARIYA IMPEX PRIVATE LIMITED",
"SAAWARIYA POLYPACK PRIVATE LIMITED",
"SAAYEIN TREXIM PRIVATE LIMITED",
"SAAZ CHAINS PRIVATE LIMITED",
"SAB COMPUTECH PRIVATE LIMITED",
"SAB CREATIONS PRIVATE LIMITED",
"SAB EVENTS & GOVERNANCE NOW MEDIA LIMITE D",
"SAB FITNESS & TRAINING CENTRE PRIVATE LIMITED",
"SAB GENCIES PRIVATE LIMITED",
"SAB MEDIA AND PUBLICATION SERVICES PRIVATE LIMITED",
"SAB MILLER BREWERIES PRIVATE LIMITED",
"SAB MOTORS PRIVATE LIMITED",
"SAB SHIPPING & LOGISTICS PRIVATE LIMITED",
"SABA DEVELOPERS AND BUILDERS PRIVATE LIMITED",
"SABA SOFTWARE INDIA PRIVATE LIMITED",
"SABADO TECHNOLOGIES PRIVATE LIMITED",
"SABALA SURANDHAN UDYOG PRIVATE LIMITED",
"SABAND SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"SABAR CABLES PRIVATE LIMITED",
"SABAR CONDUCTORS PRIVATE LIMITED",
"SABAR COTTON PRIVATE LIMITED",
"SABAR FLEX INDIA LIMITED",
"SABAR METALS AND ALLOYS LIMITED",
"SABAR PUMPS PRIVATE LIMITED",
"SABAR ROLLER FLOUR MILLS PRIVATE LIMITED",
"SABARI AROMATICS PRIVATE LIMITED",
"SABARI AYYAPPA DAIRY FARMS PRIVATE LIMITED",
"SABARI CHEMICALS PRIVATE LIMITED",
"SABARI CONSTRUCTIONS TECHNOLOGIES PRIVATE LIMITED",
"SABARI CONTAINER TERMINALS PRIVATE LIMITED",
"SABARI CROP CARE SCIENCES PRIVATE LIMITED",
"SABARI DISTRIBUTION PRIVATE LIMITED",
"SABARI ENTERPRISES",
"SABARI FOUNDATIONS AND CONSTRUCTION (INDIA) PRIVATE LIMITED",
"SABARI JANI ASSOCIATES",
"SABARI KITCHEN SERVICES PRIVATE LIMITED",
"SABARI MATTRESS PRIVATE LIMITED",
"SABARI MILLENNIUM IMPEX PRIVATE LIMITED",
"SABARI OVERSEAS PRIVATE LIMITED",
"SABARI RETAIL INDIA PRIVATE LIMITED",
"SABARI STEELS PRIVATE LIMITED",
"SABARI TEXTILES PRIVATE LIMITED",
"SABARI TMT KING PRIVATE LIMITED",
"SABARISASTHA TRADERS PRIVATE LIMITED",
"SABARKANTA DISTRICT CO-OP MILK PRODUCER'S UNION LTD",
"SABARKANTHA DISTRICT CO OPERATIVE MILK PRODUCERS LIMITED",
"SABARKANTHA DISTRICT EDUCATION COMMITTEE MANAGED PRIMARY SCHOOL",
"SABARMATI ASHRAM GAUSHALA",
"SABARMATI CAPITAL ONE LIMITED",
"SABARMATI CAPITAL TWO LIMITED",
"SABARMATI EXPRESS INDIA PRIVATE LIMITED",
"SABARMATI FERTILIZER AND CHEMICALS INDUSTRIES PRIVATE LIMITED",
"SABARMATI GAS LIMITED",
"ADANI AVIATION FUEL SERVICES LIMITED",
"SABARMATI PAPERS PRIVATE LIMITED",
"SABARMATI RIVER FRONT DEVELOPMENT CORPORATION LIMITED",
"SABARMATI THE GLOBAL SCHOOL",
"SABARMATI UNIVERSITY",
"SABARWAL ICE AND COLD STORAGE PRIVATE LIMITED",
"SABASH MARKETING PRIVATE LIMITED",
"SABAT EXPORTS PRIVATE LIMITED",
"SABBS INFRA AND SECURITY PRIVATE LIMITED",
"SABCO MOTORS",
"SABCO TRAVELS & FOREX PRIVATE LIMITED",
"SABEE FINANZ PRIVATE LIMITED",
"SABEENA FABRICS PRIVATE LIMITED",
"SABER TECHNOLOGIES PRIVATE LIMITED",
"SABERPOINT E-SERVICES PRIVATE LIMITED",
"SABHARWAL AUTOMOBILES",
"SABHARWAL FOOD INDUSTRIES PVT LTD",
"SABHARWAL TRADING INDIA PRIVATE LIMITED",
"SABHAYA SOFTWARE",
"SABHYATA FOUNDATION",
"SABI VINIYOG PVT LTD",
"SABIC INDIA PRIVATE LIMITED",
"SABIC INNOVATIVE PLASTICS INDIA PRIVATE LIMITED",
"SABIC RESEARCH & TECHNOLOGY PRIVATE LIMITED",
"SABIHA CONSTRUCTION COMPANY PRIVATE LIMITED",
"SABIN LOGISTICS PRIVATE LIMITED",
"SABIND VENTURES PRIVATE LIMITED",
"SABINE HOSPITAL & RESEARCH CENTRE PRIVATE LIMITED",
"SABINE WOOD SOLUTIONS PRIVATE LIMITED",
"SABIO HR CONSULTANT LLP",
"SABIO MOBILE INDIA PRIVATE LIMITED",
"SABIR KHAN FILMS PRIVATE LIMITED",
"SABITA DEVI EDUCATION TRUST",
"SABITHA VENKATESAN WIND FARMS PRIVATE LIMITED",
"SABITRI FABRICS PRIVATE LIMITED",
"SABITRI GIRLS COLLEGE",
"SABITRI NIRMAN PRIVATE LIMITED",
"SABKA TRANSFORMERS PRIVATE LIMITED",
"SABLAWAAT JUTE INDUSTRIES PRIVATE LIMITED",
"SABLE ENTERPRISES PRIVATE LIMITED",
"SABLE WAGHIRE AND CO PRIVATE LIMITED",
"SABMA SPINTEX PRIVATE LIMITED",
"SABNAM SYNTHETICS PVT LTD",
"SABO HEMA AUTOMOTIVE PRIVATE LIMITED",
"SABO SYSTEMS PRIVATE LIMITED",
"SABOLI STEELS PRIVATE LIMITED",
"SABOLS FOODS INDIA PRIVATE LIMITED",
"SABOO AUTOMOTIVE PVT LTD",
"SABOO AUTOZONE",
"SABOO COLLECTIONS PRIVATE LIMITED",
"SABOO COMPUTERS PRIVATE LIMITED",
"SABOO COTSPIN PRIVATE LIMITED",
"SABOO CYLINDERS PRIVATE LIMITED",
"SABOO DALL MILL PRIVATE LIMITED",
"SABOO FOOD PROCESSING PRIVATE LIMITED",
"SABOO HESSE WOOD COATINGS PRIVATE LIMITED",
"SABOO KIDNEY CARE HOSPITAL",
"SABOO LPG EQUIPMENT PRIVATE LIMITED",
"SABOO MARKETING AND SERVICES PRIVATE LIMITED",
"SABOO PACKAGING PVT LTD",
"SABOO PLASTICS PRIVATE LIMITED",
"SABOO SAREES PRIVATE LIMITED",
"SABOO SILKS PRIVATE LIMITED",
"SABOO TOR PRIVATE. LIMITED.",
"SABOO VEHICLES PRIVATE LIMITED",
"SABOORI COLLEZIONE INTERNATIONAL P LIMITED",
"SABOORI DEVELOPERS & PROMOTERS PRIVATE LIMITED",
"SABOOS PRIVATE LIMITED",
"SABR HOSPITALITY PRIVATE LIMITED",
"SABRANG ARTS PVT LTD",
"SABRANG PRINTS PRIVATE LIMITED",
"SABRE TRAVEL NETWORK INDIA PRIVATE LIMITED",
"SABRE TRAVEL TECHNOLOGIES PRIVATE LIMITED",
"SABREEMALAI DESIGNS PRIVATE LIMITED",
"SABRI FOOD PRODUCTS PRIVATE LIMITED",
"SABRIMALA INDUSTRIES INDIA LIMITED",
"SABROS DECOR SYSTEMS PRIVATE LIMITED",
"SABS ARCHITECTS AND ENGINEERS PRIVATE LIMITED",
"SABS EXPORTS",
"SABSANG FINANCE LIMITED",
"SABSE TECHNOLOGIES PRIVATE LIMITED",
"SABSONS AGENCIES PRIVATE LIMITED",
"SABSONS FASTNERS PVT LTD",
"SABSONS INTERNATIONAL PVT. LTD.",
"SABSUN CLAY STORES PRIVATE LIMITED",
"SABU TRADE PRIVATE LIMITED",
"SABUJ SOLAR UDYOG PRIVATE LIMITED",
"SABUJAYAN COLD STORAGE PRIVATE LIMITED",
"SABURA IMPEX PRIVATE LIMITED",
"SABURI GLOBAL SERVICES PRIVATE LIMITED",
"SABURI PACKAGING PRIVATE LIMITED",
"SABURI PANELS PRIVATE LIMITED",
"SABURI PROPERTIES PRIVATE LIMITED",
"SABURI SAI RAM BUILDTECH PRIVATE LIMITED",
"SABURI TLC WORLDWIDE SERVICES PRIVATE LIMITED",
"SABYASACHI CALCUTTA LLP",
"SABYASACHI COUTURE",
"SABYASACHI INC USA",
"SABZ INFRA SOLUTION PRIVATE LIMITED",
"SAC ENGINE COMPONENTS PRIVATE LIMITED",
"SAC HOSPIMAT PRIVATE LIMITED",
"SAC IRON & STEEL PRIVATE LIMITED",
"SACAP INDIA PRIVATE LIMITED",
"SACCHIDANAND REALITIES PRIVATE LIMITED",
"SACH ADVISORS PRIVATE LIMITED",
"SACH ELECTRO MECH PRIVATE LIMITED",
"SACH GORWANI REAL PROJECTS PRIVATE LIMITED",
"SACH PHARMATECH PRIVATE LIMITED",
"SACH PROMOTERS PRIVATE LIMITED",
"SACH SERVICES PRIVATE LIMITED",
"SACH TISSUES INDIA PRIVATE LIMITED",
"SACH TRAVEL CONSULTANTS PRIVATE LIMITED",
"SACHA ENGINEERING PRIVATE LIMITED",
"SACHAM HIGHWAY REAL ESTATES PRIVATE LIMITED",
"SACHAR GAMING PRIVATE LIMITED",
"SACHCHA SAUDA SERVICES STATION PRIVATE LIMITED",
"SACHCHADE FOOD PRIVATE. LIMITED.",
"SACHCHIDANAND TRAVELS PRIVATE LIMITED",
"SACHCHIYAY MATA BULLION PRIVATE LIMITED",
"SACHCHIYAY STEEL PRIVATE LIMITED",
"SACHDE FOOD AND BEVERAGES PRIVATE LIMITED",
"SACHDEV AUTOMOBILES PRIVATE LIMITED",
"SACHDEV ENGINERING WORKS PVT LTD",
"SACHDEV FOOD PRODUCTS PRIVATE LIMITED",
"SACHDEV GATEWAYS AND GETAWAYS PRIVATE LIMITED",
"SACHDEV RETAIL PRIVATE LIMITED",
"SACHDEV SCIENTIFIC EQUIPMENTS PRIVATE LIMITED",
"SACHDEV SPORTS COMPANY PRIVATE LIMITED",
"SACHDEV STEEL WORKS PVT LTD",
"SACHDEV TRADERS PVT LTD",
"SACHDEVA COLLEGES LIMITED",
"SACHDEVA DEVELPRO & INFRAPROJECTS PRIVATE LIMITED",
"SACHDEVA DIAGNOSTICS PRIVATE LIMITED",
"SACHDEVA ELECTRONICS PRIVATE LIMITED",
"SACHDEVA FABRIC WORLD PRIVATE LIMITED",
"SACHDEVA FABTEX PRIVATE LIMITED.",
"SACHDEVA GLOBAL SCHOOL",
"SACHDEVA HANDLOOM TRADERS PRIVATE LIMITED",
"SACHDEVA HITECH PRIVATE LIMITED",
"SACHDEVA HOME FURNISHING PRIVATE LIMITED",
"SACHDEVA INDUSTRIES PRIVATE LIMITED",
"SACHDEVA ISPAT PRIVATE LIMITED",
"SACHDEVA LAND AND FINANCE PRIVATE LIMITED",
"SACHDEVA LIGHTING & ELECTRICALS PRIVATE LIMITED",
"SACHDEVA LIGHTING PRIVATE LIMITED",
"SACHDEVA MEDICARE PRIVATE LIMITED",
"SACHDEVA METAL WORKS",
"SACHDEVA PACKAGING PRIVATE LIMITED",
"SACHDEVA POLYCOLOR PRIVATE LIMITED",
"SACHDEVA ROAD LINES PRIVATE LIMITED",
"SACHDEVA STEEL PRODUCTS SHIP BREAKERS",
"SACHDEVA STOCKS PRIVATE LIMITED",
"SACHEE FRAGRANCES AND CHEMICALS LIMITED",
"SACHEEROME PRIVATE LIMITED",
"SACHETA METALS LIMITED",
"SACHETAN KNOWLEDGE COMPANIONS PRIVATE LIMITED",
"SACHETNA FINANCE PRIVATE LIMITED",
"SACHI AUTONET PRIVATE LIMITED",
"SACHI GEOSYNTHETICS PRIVATE LIMITED",
"SACHI HOSPITALITY PRIVATE LIMITED",
"SACHI JEWELLERY CO",
"SACHI PRECAST PRIVATE LIMITED",
"SACHI STEEL SOLUTIONS PRIVATE LIMITED",
"SACHIDANAND ENGINEERING PRIVATE LIMITED",
"SACHIKA HOTELS",
"SACHIKO GAMING PRIVATE LIMITED",
"SACHIN AGRO AND FEEDS PRIVATE LIMITED",
"SACHIN CORRUGATORS AND PRINTERS PRIVATE LIMITED",
"SACHIN DYEING AND PRINTING MILLS PRIVATE LIMITED",
"SACHIN ELECTRICALS PRIVATE LIMITED",
"SACHIN FOODS PVT LTD",
"SACHIN GHAYAL SUGAR PRIVATE LIMITED",
"SACHIN GUPTA BUILDCON PRIVATE LIMITED",
"SACHIN HITECH INDUSTRIES PRIVATE LIMITED",
"SACHIN INDUSTRIES LIMITED",
"SACHIN INFRA ENVIRONMENT LIMITED",
"SACHIN KHIMJI NUVO INVESTORS & REALTORS PRIVATE LIMITED",
"SACHIN MEDICOS",
"SACHIN MOTORS PRIVATE LIMITED",
"SACHIN PACKERS PRIVATE LIMITED",
"SACHIN PAPER MILLS PRIVATE LIMITED",
"SACHIN PARENTERAL PRIVATE LIMITED",
"SACHIN PIPES PRIVATE LIMITED",
"SACHIN POLYMERS PRIVATE LIMITED",
"SACHIN TENDULKAR FOUNDATION",
"SACHIN TEXFAB PRIVATE LIMITED",
"SACHIN WATER SUPPLY COMPANY PRIVATE LIMITED",
"SACHINA ENGINEERING PRIVATE LIMITED",
"SACHINAM FABRICS PRIVATE LIMITED",
"SACHIT TEXTILES PRIVATE LIMITED",
"SACHITRA ROLLING MILLS PVT LTD",
"SACHITRA STEEL INDUSTRIES PRIVATE LIMITED",
"SACHIVALAYAM",
"SACHIYA TRAVELS PRIVATE LIMITED",
"SACHIYAI CONSULTANTS AND PROPERTIES PRIVATE LIMITED",
"SACHKHAND BUS SERVICE PRIVATE LIMITED",
"SACHKHAND TRANSPORT COMPANY PRIVATE LIMITED",
"SACHMI ENTERPRISES PRIVATE LIMITED",
"SACHTECH SOLUTION PRIVATE LIMITED",
"SACK INTERNATIONAL PRIVATE LIMITED",
"SACMI ENGINEERING INDIA PRIVATE LIMITED",
"SACOM MEDIAWORKS PRIVATE LIMITED",
"SACP COMPOSITES PRIVATE LIMITED",
"SACRED COMMUNICATIONS PRIVATE LIMITED",
"SACRED HEART CENTRAL SCHOOL",
"SACRED HEART CONVENT HIGH SCHOOL AHMEDNAGAR",
"SACRED HEART CONVENT SCHOOL",
"SACRED HEART EDUCATIONAL SOCIETY SCHOOL",
"SACRED HEART GIRLS HIGHER SECONDARY SCHOOL",
"SACRED HEART HOSPITAL",
"SACRED HEART MATRICULATION HR SEC SCHOOL",
"SACRED HEART SCHOOL",
"SACRED HEART SCHOOL VARAP",
"SACRED HOMES PRIVATE LIMITED",
"SACRED LEAVES PRIVATE LIMITED",
"SACRED PRODUCTS INDIA PRIVATE LIMITED",
"SACRED RIVER AGRI TECHNOLOGIES PRIVATE LIMITED",
"SACRED SOURCING SOLUTIONS PRIVATE LIMITED",
"SACRED STANFORD SCHOOL DAGHAM",
"SACRIA ENGINEERING PRIVATE LIMITED",
"SACS ENTERPRISES PRIVATE LIMITED",
"SACTECH AUTOMATION INDIA PRIVATE LIMITED",
"SADA SHARADA TUMOR AND RESEARCH INSTITUTE",
"SADA SHIVAM WEAVETEX PRIVATE LIMITED",
"SADA SYSTEMS INDIA PRIVATE LIMITED",
"SADABAD COLD STORAGE AND ICE FACTORY PRIVATE LIMITED",
"SADAF ENTERPRISES PRIVATE LIMITED",
"SADAKATHULLAH APPA COLLEGE",
"SADAN CORPORATE SERVICES PRIVATE LIMITED",
"SADAN HOSIERY PRIVATE LIMITED",
"SADANA AGENCIES PRIVATE LIMITED",
"SADANAM PERSONAL PRODUCTS LIMITED",
"SADANAND ALLOY STEEL PRIVATE LIMITED",
"SADANAND PVC PRIVATE LIMITED",
"SADANI APPARELS (INDIA) PRIVATE LIMITED",
"SADANI STEELS PRIVATE LIMITED",
"SADANLAL SANWALDAS KHANNA GIRLS‚Äô DEGREE COLLEGE",
"SADAR BIOTECH PRIVATE LIMITED",
"SADAR LABORATOOIES PRIVATE LIMITED",
"SADAR PATEL AVAR MADHAMIK VIDALAYA",
"SADASAT CORN PRODUCTS PRIVATE LIMITED",
"SADASHAKTI SUITS PRIVATE LIMITED",
"SADASHIB COLD STORAGE PRIVATE LIMITED",
"SADASHIV CASTINGS LIMITED",
"SADASHIV ENGINEERS PRIVATE LIMITED",
"SADASHIV HYGIENE PRIVATE LIMITED",
"SADASHIV ISPAT PRIVATE LIMITED",
"SADASHIV PLYSALES PRIVATE LIMITED",
"SADASHIV REAL ESTATE PRIVATE LIMITED",
"SADASHIVA FINANCIAL SERVICES HOLDINGS PRIVATE LIMITED",
"SADASHIVA INFRASTEEL PRIVATE LIMITED",
"SADASUKH TIEUP PRIVATE LIMITED",
"SADAY CONSTRUCTIONS PRIVATE LIMITED",
"SADBHAV CERAMICS",
"SADBHAV ENGINEERING LIMITED",
"SADBHAV FUTURETECH PRIVATE LIMITED",
"SADBHAV GADAG HIGHWAY PRIVATE LIMITED",
"SADBHAV HOSPITAL PATAN",
"SADBHAV INFRASTRUCTURE PROJECT LIMITED",
"SADBHAV JODHPUR RING ROAD PRIVATE LIMITED",
"SADBHAV KIM EXPRESSWAY PRIVATE LIMITED",
"SADBHAV NAINITAL HIGHWAY LIMITED",
"SADBHAV PET CT CENTRE",
"SADBHAV QUARRY WORKS PRIVATE LIMITED",
"SADBHAV RUDRAPUR HIGHWAY LIMITED",
"SADBHAV UDAIPUR HIGHWAY LIMITED",
"SADBHAV VIDARBHA HIGHWAY LIMITED",
"SADBHAVA FABRICATORS PRIVATE LIMITED",
"SADBHAVANA ASSURANCE PRIVATE LIMITED",
"SADBHAVANA CHEMICALS PRIVATE LIMITED",
"SADDHARMA PUNDARIKA FILMS PRIVATE LIMITED",
"SADDLES INTERNATIONAL AUTOMOTIVE &AVIATION INTERIORS PRIVATE LIMITED",
"SADEKAR ENVIRO ENGINEERS PRIVATE LIMITED",
"SADEM INDIA LIMITED",
"SADGATI INVESTMENTS AND TRADING COMPANY PRIVATE LIMITED",
"SADGUNA MARKETING PRIVATE LIMITED",
"SADGURU ADVERTISING PRIVATE LIMITED",
"SADGURU AGRO OIL PRODUCT LIMITED",
"SADGURU AUTOCOMPONENTS PRIVATE LIMITED",
"SADGURU COTTON PRIVATE LIMITED",
"SADGURU DYNAMICS PRIVATE LIMITED",
"SADGURU ENGINEERING",
"SADGURU ENGINEERS AND ALLIED SERVICES PRIVATE LIMITED",
"SADGURU GINNING & PRESSING PRIVATE. LIMITED.",
"SADGURU HEALTHCARE SERVICE PRIVATE LIMITED",
"SADGURU HOLDINGS PRIVATE LIMITED",
"SADGURU HOSPITAL",
"SADGURU INFRASPACES PRIVATE LIMITED",
"SADGURU INFRATECH PRIVATE. LIMITED.",
"SADGURU INVESTMENT AND TRADING CO PVT LTD",
"SADGURU ISPAT PRIVATE LIMITED",
"SADGURU KRUPA TRADER",
"SADGURU MEDIA AND NEWS PRIVATE LIMITED",
"SADGURU MEDICAL & RESEARCH CENTRE PRIVATE. LIMITED.",
"SADGURU PEB WORKS PRIVATE LIMITED",
"SADGURU POLYMERS PRIVATE LIMITED",
"SADGURU PROCESSORS PRIVATE LIMITED",
"SADGURU SCREENS PRIVATE LIMITED",
"SADGURU SEVA PARIDHAN PRIVATE LIMITED",
"SADGURU SPINNERS PRIVATE LIMITED",
"SADGURU SRI SRI AGRO FARMERS PRODUCER COMPANY LIMITED",
"SADGURU SRI SRI SAKHAR KARKHANA LIMITED",
"SADGURU TECHNO FAB PRIVATE LIMITED",
"SADGURU TEXFAB INDIA PRIVATE LIMITED",
"SADGURUPRO SOLUTIONS PRIVATE LIMITED",
"SADGURUSAAI ENERGIES PRIVATE LIMITED",
"SADGURUVIJAYA HOSPITALS PRIVATE LIMITED",
"SADHA RAMPROSAD BSCS INSTITUTION",
"SADHAN COLLEGE FOR WOMEN AND BOYS",
"SADHAN LIFE SCIENCES PRIVATE LIMITED",
"SADHAN TOOL ROOM PRIVATE LIMITED",
"SADHANA BUILDERS PVT LTD",
"SADHANA EDUCATION SOCIETY'S",
"SADHANA ENGICON PRIVATE LIMITED",
"SADHANA ENGLISH HIGH SCHOOL",
"SADHANA HINDI HIGH SCHOOL & JUNIOR COLLEGE ARTS COMMERCE & SCIENCE",
"SADHANA NITRO CHEM LIMITED",
"SADHANA PACKAGING PRIVATE. LIMITED.",
"SADHANA SUITINGS PRIVATE LIMITED",
"SADHANA SULZ FAB PRIVATE LIMITED",
"SADHANA SYNTHETICS PRIVATE LIMITED",
"SADHANA TECHNICAL WORKS PRIVATE LIMITED",
"SADHANA VIDYALAYA ENGLISH PRIMARY",
"SADHANASOFT OVERSEAS",
"SADHAV OFFSHORE ENGG. CO.",
"SADHAV SHIPPING LIMITED",
"SADHAVI AUTO LIMITED",
"SADHNA AUTO AGENCIES PRIVATE LIMITED",
"SADHNA BROADCAST LIMITED",
"SADHNA BUILDCON PRIVATE LIMITED",
"SADHNA HOSPITALS PRIVATE LIMITED",
"SADHNA JEWELS PRIVATE LIMITED",
"SADHNA LAMINATORS PRIVATE LIMITED",
"SADHNA MEDIA NETWORK PRIVATE LIMITED",
"SADHNA MEDIA PRIVATE LIMITED",
"SADHNA SECURITY SERVICES PRIVATE LIMITED",
"SADHOBA SAUDAGAR FISHING IMPLEMENTS PRIVATE LIMITED",
"SADHOK REAL ESTATE PRIVATE LIMITED",
"SADHU AUTO PRIVATE LIMITED",
"SADHU FORGING LIMITED",
"SADHU RAM PRODUCTS PRIVATE LIMITED",
"SADHU SINGH HAMDARD TRUST",
"SADHU VASWANI AUTONOMOUS COLLEGE",
"SADHU VASWANI COLLEGE OF NURSING",
"SADHU VASWANI INSTITUTEOF MANAGEMENT STUDIES FOR GIRLS",
"SADHU VASWANI INTERNATIONAL SCHOOL",
"SADHU VASWANI INTERNATIONAL SCHOOL-MOSHI",
"SADHU VASWANI MISSION MEDICAL COMPLEX",
"SADHYA PRODUCTS PRIVATE LIMITED",
"SADIPALI SOLAR PRIVATE LIMITED",
"SADIQ MOTORS PRIVATE LIMITED",
"SADIRAM TEXTURISING PVT LTD",
"SADRAVYA RESEARCH PRIVATE LIMITED",
"SADUN OVERSEAS PRIVATE LIMITED",
"SADUP SOFTECH PRIVATE LIMITED",
"SADVICHAR GENERAL HOSPITAL AND NURSING HOME",
"SAE HYDRAULICS PRIVATE LIMITED",
"SAE IMPEX INTERNATIONAL PRIVATE LIMITED",
"SAE INDIA PRIVATE LIMITED",
"SAE TRANS LOGISTIC PRIVATE LIMITED",
"SAECO STRIPS PRIVATE LIMITED",
"SAEE MESS",
"SAEE SOFTWARE PRIVATE LIMITED",
"SAEHAN STAMPING PRIVATE LIMITED",
"SAEL ENGINEERING PRIVATE LIMITED",
"SAEL OVERSEAS LIMITED",
"SAE-LASO INDIA PRIVATE LIMITED",
"SAELOUN TECHNOLOGIES PRIVATE LIMITED",
"SAEMTECH ELECTRONICS INDIA PRIVATE LIMITED",
"SAENT INDIA ENGINEERING CONSULTANTS PRIVATE LIMITED",
"SAERA ELECTRIC AUTO LIMITED",
"SAERA ELECTRIC AUTO PRIVATE LIMITED",
"SAERTEX INDIA PRIVATE LIMITED",
"SAEV PRIVATE LIMITED",
"SAF DESIGNERS PRIVATE LIMITED",
"SAF FERMION LIMITED",
"SAF SCIENTIFIC CHEMICALS PRIVATE LIMITED",
"SAFA CONSTRUCTIONS PRIVATE LIMITED",
"SAFA FOOD PRODUCTS PRIVATE LIMITED",
"SAFA PLYWOODS PRIVATE LIMITED",
"SAFA POLYCHEMS PRIVATE LIMITED",
"SAFAH MULTITRADE PRIVATE LIMITED",
"SAFAL AGRO INDUSTRIES PRIVATE LIMITED",
"SAFAL BUILDERS PRIVATE LIMITED",
"SAFAL CAPITAL (INDIA) LIMITED",
"SAFAL CAPITAL SERVICES PRIVATE LIMITED",
"SAFAL CHEM INDIA PRIVATE LIMITED",
"SAFAL CIRCUITS PRIVATE LIMITED",
"SAFAL CONSTRUCTIONS PRIVATE. LIMITED.",
"SAFAL CONSTRUCTIONS(INDIA) PRIVATE LIMITED",
"SAFAL DEVELOPERS PVT.LTD",
"SAFAL ENTERPRISE PRIVATE LIMITED",
"SAFAL FABRICS PRIVATE LIMITED",
"SAFAL FEEDS PRIVATE LIMITED",
"SAFAL FINSTOCK PRIVATE LIMITED",
"SAFAL FOOD PRODUCTS PRIVATE LIMITED",
"SAFAL HOSPITALITY AND MAINTANCE SERVICES",
"SAFAL LOGISTICS LLP",
"SAFAL NETCARDS PRIVATE LIMITED",
"SAFAL REALTY PRIVATE LIMITED",
"SAFAL RETREAT",
"SAFAL SEEDS AND BIOTECH LIMITED",
"SAFALTA CAREER INSTITUTE PRIVATE LIMITED",
"SAFALTA EDUCATION PRIVATE LIMITED",
"SAFALTEK SOFTWARE PRIVATE LIMITED",
"SAFALYA HOSPITAL",
"SAFALYA INFRA PROJECTS PRIVATE LIMITED",
"SAFAR EXPRESS PRIVATE LIMITED",
"SAFAR POLYFIBRE PRIVATE LIMITED",
"SAFAR POLYFURNITURE PRIVATE LIMITED",
"SAFARI BIOTECH PRIVATE LIMITED",
"SAFARI CHEMICALS PRIVATE LIMITED",
"SAFARI COLD STORAGE & ICE FACTORY PRIVATE LIMITED",
"SAFARI CONSTRUCTION EQUIPMENTS PRIVATE LIMITED",
"SAFARI CYCLES PRIVATE LIMITED",
"SAFARI DIGITAL EDUCATION INITIATIVES PRIVATE LIMITED",
"SAFARI FINE CLOTHINGS PRIVATE LIMITED",
"SAFARI INDUSTRIES INDIA LIMITED",
"SAFARI LIFESTYLES LIMITED",
"SAFARI MANUFACTURING LIMITED",
"SAFARI MULTIMEDIA PRIVATE LIMITED",
"SAFARI PLAYMATES PRIVATE LIMITED",
"SAFARI RETREATS PVT LTD",
"SAFARR LOGISTICS PRIVATE LIMITED",
"SAFASANA TRADING & MARKETING INDIA PRIVATE LIMITED",
"SAFAYAR CERAMICS PRIVATE LIMITED",
"SAFCON SEALS PRIVATE LIMITED",
"SAFDARGANJ COLD STORAGE PRIVATE LIMITED",
"SAFDARI COAL PRIVATE LIMITED",
"SAFDARI DEHYDRATION PRIVATE LIMITED",
"SAFDARJANG HOSPITAL AND VMMC",
"SAFDARJANG MOTORS PRIVATE LIMITED",
"SAFDARJUNG HOSPITAL",
"SAFDURJUNG HOSPITAL",
"SAFE & SECURE LOGISTIC PVT LTD",
"SAFE A&T TECHNOLOGY PRIVATE LIMITED",
"SAFE ACT ENGINEERING PRIVATE LIMITED",
"SAFE AGRITRADE PRIVATE LIMITED",
"SAFE AGRO PRODUCER COMPANY LIMITED",
"SAFE AIR ENGINEERS PRIVATE LIMITED",
"SAFE AND CURE SUPERSPECIALITIES HOSPITAL PRIVATE LIMITED",
"SAFE AND SECURE ONLINE MARKETING PRIVATE LIMITED",
"SAFE AND STRONG BUSINESS CONSULTANTS PRIVATE LIMITED",
"SAFE AUTO INDIA PRIVATE LIMITED",
"SAFE CERAMIC PRIVATE LIMITED",
"SAFE CLEARING AND FORWARDING PRIVATE LIMITED",
"SAFE COILS INDIA PRIVATE LIMITED.",
"SAFE CORRUGATED CONTAINERS PRIVATE LIMITED",
"SAFE DECOR PRIVATE LIMITED (TRANSFER FROM BIHAR TO RAJASTHAN)",
"SAFE ELECTRONICS INDIA PRIVATE LIMITED",
"SAFE ENGINEERING SERVICES AND TECHNOLOGIES INDIA PRIVATE LIMITED",
"SAFE ENTERPRISES RETAIL TECHNOLOGIES PRIVATE LIMITED",
"SAFE ENVIRO PRIVATE LIMITED",
"SAFE EXPRESS",
"SAFE FORMULATIONS PRIVATE LIMITED",
"SAFE GREEN MINING TECHNOLOGY PRIVATE LIMITED",
"SAFE HANDS ANESTHETIST PRIVATE LIMITED (OPC)",
"SAFE HANDS PRODUCTS PRIVATE LIMITED",
"SAFE HARVEST PRIVATE LIMITED",
"SAFE HEALTH LABS PRIVATE LIMITED",
"SAFE INFRAPROJECTS PRIVATE LIMITED",
"SAFE INFRATECH PRIVATE LIMITED",
"SAFE KIDS HOSPITALS PRIVATE LIMITED",
"SAFE LANCET ENGINEERING PRIVATE LIMITED",
"SAFE LIFE ENTERPRISES PRIVATE LIMITED",
"SAFE LIFTERS PRIVATE LIMITED",
"SAFE MANAGEMENT SERVICES PRIVATE LIMITED",
"SAFE N BOUND LOGISTIC SERVICES PRIVATE LIMITED",
"SAFE NAVIGATION SOFTWARE PRIVATE LIMITED",
"SAFE POWER ENGINEERING PRIVATE LIMITED",
"SAFE PRIVATE LIMITED",
"SAFE PRO FIRE SERVICES PRIVATE LIMITED",
"SAFE REFRIGERATIONS PRIVATE LIMITED",
"SAFE RIDER LOGISTICS INDIA PRIVATE LIMITED",
"SAFE SEA LOGISTICS PRIVATE LIMITED",
"SAFE SHIPPING AND AIR TRANSPORT PRIVATE LIMITED",
"SAFE SOFTWARE AND INTEGRATED SOLUTIONS PRIVATE LIMITED",
"SAFE SPEED CARRIERS PRIVATE LIMITED",
"SAFE SUPER SPECIALITY HOSPITALS",
"SAFE SYSTEM INDIA PRIVATE LIMITED",
"SAFE TECH LOCKING SOLUTIONS",
"SAFE TECHNOLOGY INDIA PRIVATE LIMITED",
"SAFE TOWERS PRIVATE LIMITED",
"SAFE TRANSLINE PRIVATE LIMITED",
"SAFE TREAT ENGINEERS AND CONTRACTORS PRIVATE LIMITED",
"SAFEAGE SECURITY PRODUCTS PRIVATE LIMITED",
"SAFEAKT SOLUTION PRIVATE LIMITED",
"SAFEART INDUSTRIES PRIVATE LIMITED",
"SAFEARTH CLEAN TECHNOLOGIES PRIVATE LIMITED",
"SAFEBARRIER INTERNATIONAL PRIVATE LIMITED",
"SAFEBHARAT ENTERPRISES PRIVATE LIMITED",
"SAFEBUILD CONSTRUCTIONS PRIVATE LIMITED",
"SAFECAP FINANCE PRIVATE LIMITED",
"SAFECARE RUBBER PRODUCTS PRIVATE LIMITED",
"SAFECHEM ENTERPRISES PRIVATE LIMITED",
"SAFECHEM INDUSTRIES",
"SAFECO HYGIENE FILMS PRIVATE LIMITED",
"SAFECO LOGISTICS PRIVATE LIMITED",
"SAFECON INDIA TECHNOLOGIES PRIVATE LIMITED",
"SAFECON LIFESCIENCES PRIVATE LIMITED",
"SAFECURE SERVICES LIMITED",
"SAFECURE SERVICES PRIVATE LIMITED",
"SAFEDABAD COLD STORAGE & ALLIED INDUSTRIES PVT LTD",
"SAFEDEAL MARKETING PRIVATE LIMITED",
"SAFEDOT E SOLUTION PRIVATE LIMITED",
"SAFEDUCATE LEARNING PRIVATE LIMITED",
"SAFEENDO DENTAL INDIA PRIVATE LIMITED",
"SAFEFLEX INTERNATIONAL LIMITED",
"SAFEGUARD FIRE PROTECTIONS PRIVATE LIMITED",
"SAFEGUARD LIFESCIENCES PRIVATE LIMITED",
"SAFEGUARD LIGHTINGS INDIA PRIVATE LIMITED",
"SAFEGUARD MANPOWER SOLUTIONS PRIVATE LIMITED",
"SAFEGUARD PACKAGING SYSTEMS PRIVATE LIMITED",
"SAFEGUARD SECURITY AND INTELLIGENCE SOLUTIONS PRIVATE LIMITED",
"SAFEGUARD SERVICES PRIVATE LIMITED",
"SAFEGUARD WORLD PAYROLL SERVICES PRIVATE LIMITED",
"SAFEGUARDS HUMAN RESOURCING PRIVATE LIMITED",
"SAFEHAND CARGO PRIVATE LIMITED",
"SAFEJET TECHNO PRODUCTS PRIVATE LIMITED",
"SAFELIFE PHARMA SPECIALITY PRIVATE LIMITED",
"SAFELIFT CRANE HIRING PRIVATE LIMITED",
"SAFELOCK INDUSTRIAL SECURITY SERVICES",
"SAFEMART INNOVATIVE PRODUCTS PRIVATE LIMITED",
"SAFEMECH TECHNICAL PRIVATE LIMITED",
"SAFENAMES SOLUTIONS PRIVATE LIMITED",
"SAFENESS QUOTIENT LIMITED",
"SAFENET INDIA PRIVATE LIMITED",
"SAFENET INFOTECH PRIVATE LIMITED",
"SAFENVIRON PRIVATE LIMITED",
"SAFEOCEAN E-LOGISTICS PRIVATE LIMITED",
"SAFEOPS SURGICAL CARE PRIVATE LIMITED",
"SAFEPACK INDUSTRIES LIMITED",
"SAFERICH [INDIA] SECURITIES PRIVATE LIMITED",
"SAFERISK INSURANCE BROKERS PRIVATE LIMITED",
"SAFESEA STEAMSHIP PRIVATE LIMITED",
"SAFESEND TECHNOLOGIES PRIVATE LIMITED",
"SAFESENSE TECH SERVICES PRIVATE LIMITED",
"SAFESHIELD INDIA RUBBER PRODUCTS PRIVATE LIMITED",
"SAFESHIFT LOGISTICS PRIVATE LIMITED",
"SAFESPACE WAREHOUSING INDIA PRIVATE LIMITED",
"SAFESS QUALITY MANAGEMENT PRIVATE LIMITED",
"SAFEST WORLD FACILITATORS PRIVATE LIMITED",
"SAFESTART INDIA PRIVATE LIMITED",
"SAFESTORAGE TECHNOLOGIES AND SERVICES PRIVATE LIMITED",
"SAFESURGE INSPECTION TECHNOLOGIES PRIVATE LIMITED",
"SAFETAB LIFE SCIENCE",
"SAFETECH PRODUCTS & SERVICES PRIVATE LIMITED",
"SAFETECH RELIABLE ASSOCIATES (OPC) PRIVATE LIMITED",
"SAFETECHNICAL SUPPLY PRIVATE LIMITED",
"SAFETEK ENGINEERING SOLUTIONS PRIVATE LIMITED",
"SAFETIX PROTECTIVE EQUIPMENTS PRIVATE LIMITED",
"SAFETRANS FREIGHT SOLUTIONS PRIVATE LIMITED",
"SAFE-TRONICS AUTOMATION PRIVATE LIMITED",
"SAFETY CIRCLE PRIVATE LIMITED",
"SAFETY CONTROLS & DEVICES LIMITED",
"SAFETY CONTROLS & DEVICES PRIVATE LIMITED",
"SAFETY ENGINEERS AND CONSULTANTS PVT LTD",
"SAFETY FIRST TRADEX PRIVATE LIMITED",
"SAFETY KNIT INDIA PRIVATE LIMITED",
"SAFETY PLUS POWER LIMITED",
"SAFETY PROJECTS PRIVATE LIMITED",
"SAFETYLAND ESTATE PRIVATE LIMITED",
"SAFETYPLUS PROTECTION PRIVATE LIMITED",
"SAFEVIEW MEDIA PRIVATE LIMITED",
"SAFEWATER LINES INDIA PRIVATE LIMITED",
"SAFEWAY DISTRIBUTORS PRIVATE LIMITED",
"SAFEWAY DREDGING ENTERPRISES",
"SAFEWAY INC.",
"SAFEWAY INCOTERMS PRIVATE LIMITED",
"SAFEWAY INSURANCE TPA PRIVATE LIMITED",
"SAFEWORLD SYSTEMS PRIVATE LIMITED",
"SAFEX CHEMICALS ( INDIA) LIMITED",
"SAFEX COMMERCIAL PVT. LTD.",
"SAFEX COURIER AND CARGO PRIVATE LIMITED",
"SAFEX ELECTROMECH PRIVATE LIMITED",
"SAFEX ENERGY PRIVATE LIMITED",
"SAFEX FIRE SERVICES LIMITED",
"SAFEX INDUSTRIES LIMITED",
"SAFEXPRESS B2C PRIVATE LIMITED",
"SAFEXPRESS PRIVATE LIMITED",
"SAFEXSURE INDIA",
"SAFEZONE SECURE SOLUTIONS PRIVATE LIMITED",
"SAFF BIOTICS PRIVATE LIMITED",
"SAFFAIRE INDUSTRIAL SAWS (I) PRIVATE LIMITED",
"SAFFE PANEL INDUSTRY PRIVATE LIMITED",
"SAFFIRE CROP SCIENCE PRIVATE LIMITED",
"SAFFIRE ISPAT PRIVATE LIMITED",
"SAFFIRE MARKETING PRIVATE LIMITED",
"SAFFO SOLUTION TECHNOLOGY LLP",
"SAFFRON",
"SAFFRON ART PRIVATE LIMITED",
"SAFFRON BROADCAST AND MEDIA LIMITED",
"SAFFRON CAPITAL ADVISORS PRIVATE LIMITED",
"SAFFRON CHEEW INDIA PRIVATE LIMITED",
"SAFFRON CONCEPTS INDIA PRIVATE LIMITED",
"SAFFRON CONSTRUCTIONS PRIVATE LIMITED",
"SAFFRON CONTAINER LINES INDIA PRIVATE LIMITED",
"SAFFRON CORPORATION PRIVATE LIMITED",
"SAFFRON DECORATIVES PRIVATE LIMITED",
"SAFFRON EARTH PRIVATE LIMITED",
"SAFFRON EDU NOTEBOOKS PRIVATE LIMITED",
"SAFFRON ENCLAVE PRIVATE LIMITED",
"SAFFRON FABRICS PRIVATE LIMITED",
"SAFFRON FASTENERS PRIVATE LIMITED",
"SAFFRON FORMULATIONS PRIVATE LIMITED",
"SAFFRON GEMS PRIVATE LIMITED",
"SAFFRON HOLISTIC HEALTHCARE PRIVATE LIMITED",
"SAFFRON HOME DEVELOPERS PRIVATE LIMITED",
"SAFFRON INDUSTRIES LIMITED",
"SAFFRON INFRADEVELOPERS PRIVATE LIMITED",
"SAFFRON INFRAPROJECTS INDIA LIMITED",
"SAFFRON JARI INDUSTRIES PRIVATE LIMITED",
"SAFFRON JEWELS PRIVATE LIMITED",
"SAFFRON LABORATORIES PRIVATE LIMITED",
"SAFFRON LIFESTYLE TRADERS PRIVATE LIMITED",
"SAFFRON MANPOWER & HR SERVICES PRIVATE LIMITED",
"SAFFRON MEDIA PRIVATE LIMITED",
"SAFFRON MET-YARNS LIMITED",
"SAFFRON NETWORKS PRIVATE LIMITED",
"SAFFRON PARK PROJECTS PRIVATE LIMITED",
"SAFFRON POLY-THREADS PRIVATE LIMITED",
"SAFFRON POWER INNOVATIONS PRIVATE LIMITED",
"SAFFRON RESOURCES PRIVATE LIMITED",
"SAFFRON SPECIALITY PAPERS PRIVATE LIMITED",
"SAFFRON STROKES PRIVATE LIMITED",
"SAFFRON SUITINGS PRIVATE LIMITED",
"SAFFRON SUPPLYCHAIN SOLUTIONS PRIVATE LIMITED",
"SAFFRON TECH PRIVATE LIMITED",
"SAFFRON THERAPEUTICS PRIVATE LIMITED",
"SAFFRON TRADEX PRIVATE LIMITED",
"SAFFRONCOIN SOLUTIONS PRIVATE LIMITED",
"SAFFRONGRID PRIVATE LIMITED",
"SAFFRONSKY HYBRID ENERGY PRIVATE LIMITED",
"SAFFROSHINE ORGANICS PRIVATE LIMITED",
"SAFILO INDIA PRIVATE LIMITED",
"SAFIM BRAKES INDIA PRIVATE LIMITED",
"SAFINA TOWERS PRIVATE LIMITED",
"SAFIRE CEMENT MARKETING PRIVATE LIMITED",
"SAFIRE PRINTING AND PACKAGING PRIVATE LIMITED",
"SAFIYA TRAVELS PVT LTD",
"SAFJEWEL DESIGNERS PRIVATE LIMITED",
"SAFLOW PRODUCTS PRIVATE LIMITED",
"SAFON INDIA PRIVATE LIMITED",
"SAFPURE LIFESCIENCES PRIVATE LIMITED",
"SAFRAC PHARMA PRIVATE LIMITED",
"SAFRAN AIRCRAFT ENGINES HYDERABAD PRIVATE LIMITED",
"SAFRAN ELECTRICAL & POWER INDIA PRIVATE LIMITED",
"SAFRAN ELECTRONICS & DEFENSE SERVICES INDIA PRIVATE LIMITED",
"SAFRAN ENGINEERING SERVICES INDIA PRIVATE LIMITED",
"SAFRAN HAL AIRCRAFT ENGINES PRIVATE LIMITED",
"SAFRAN INDIA PRIVATE LIMITED",
"SAFRON PHARMACEUTICALS PRIVATE LIMITED",
"SAFRONE BUILDTECH PRIVATE LIMITED",
"SAFRROYS MACHINES PVT LTD",
"SAFSET AGENCIES PRIVATE LIMITED",
"SAFT INDIA PRIVATE LIMITED",
"SAFVOLT SWITCHGEARS PRIVATE LIMITED",
"SAG AAROGYA PRIVATE LIMITED",
"SAG HEALTH SCIENCE PRIVATE LIMITED",
"SAG INFOTECH PRIVATE LIMITED",
"SAG INFRASOLUTION PRIVATE LIMITED",
"SAG POLYMERS PRIVATE LIMITED",
"SAG POWER ELECTRONICS PRIVATE LIMITED",
"SAG PROJECTS PRIVATE LIMITED",
"SAGA AGROCHEM PRIVATE LIMITED",
"SAGA CHEMIE PRIVATE LIMITED",
"SAGA CLOTHING COMPANY PRIVATE LIMITED",
"SAGA ELASTOMER PRIVATE LIMITED",
"SAGA LABORATORIES",
"SAGA LIFESCIENCES LIMITED",
"SAGA MERCHANDISING COMPANY PRIVATE LIMITED",
"SAGA PESTICIDE PRIVATE LIMITED",
"SAGA RESEARCH LABORATORIES PRIVATE LIMITED",
"SAGA STUDIES PRIVATE LIMITED",
"SAGA WINDEL PUMPS PRIVATE LIMITED",
"SAGACIOUS CAPITAL PRIVATE LIMITED",
"SAGACIOUS INFOSYSTEMS PRIVATE LIMITED",
"SAGACIOUS PROGRAMING AND DEVELOPMENT PRIVATE LIMITED",
"SAGACIOUS RESEARCH PRIVATE LIMITED",
"SAGACITY SOFTWARES PRIVATE LIMITED",
"SAGAR AGENCIES",
"SAGAR AGRISCIENCES PRIVATE LIMITED",
"SAGAR AIRCON PRIVATE LIMITED",
"SAGAR AND VIVAAN CONSTRUCTIONS PRIVATE LIMITED",
"SAGAR ANGEL PUBLIC SCHOOL",
"SAGAR APOLLO HOSPITAL",
"SAGAR AQUA CULTURE PRIVATE LIMITED",
"SAGAR ASIA PRIVATE LIMITED",
"SAGAR AUTO PARTS PRIVATE LIMITED",
"SAGAR AUTOMOBILES PRIVATE LIMITED",
"SAGAR AUTOTECH MYSORE PRIVATE LIMITED",
"SAGAR AUTOTECH PRIVATE. LIMITED.",
"SAGAR AUTOWHEELS PRIVATE LIMITED",
"SAGAR BIO TECH PRIVATE LIMITED",
"SAGAR BUSINESS PRIVATE LIMITED",
"SAGAR CEMENTS (M) PRIVATE LIMITED",
"SAGAR CEMENTS LIMITED",
"SAGAR CHEMICALS PRIVATE LIMITED",
"SAGAR COLOR PAC PRIVATE LIMITED",
"SAGAR COMPLEX PRIVATE LIMITED",
"SAGAR CORRUGATED BOXES PRIVATE LIMITED",
"SAGAR CYCLE MART",
"SAGAR DECORATORS PRIVATE LIMITED",
"SAGAR DEFENCE ENGINEERING PRIVATE LIMITED",
"SAGAR DEPOSITS AND ADVANCES LIMITED",
"SAGAR DESIGNFAB PRIVATE LIMITED",
"SAGAR DIAMONDS LIMITED",
"SAGAR DIGIPRINTS PRIVATE LIMITED",
"SAGAR DISTILLERIES LTD",
"SAGAR DRUGS AND PHARMACEUTICALS PRIVATE LIMITED",
"SAGAR DWELLINGS PRIVATE LIMITED",
"SAGAR EMBROIDERY WORKS PRIVATE LIMITED",
"SAGAR EXPRESS LOGISTICS PRIVATE LIMITED",
"SAGAR FASTENERS PRIVATE LIMITED",
"SAGAR FIBERS PRIVATE LIMITED",
"SAGAR FINSTOCKS PVT LTD",
"SAGAR FOODS",
"SAGAR FOUNDRY PRIVATE LIMITED",
"SAGAR FRESHNERS PRIVATE LIMITED",
"SAGAR GAIRE FOOD AND RESTAURANT PRIVATE LIMITED",
"SAGAR GASES PRIVATE LIMITED",
"SAGAR GOODS PRIVATE LIMITED",
"SAGAR GRANDHI CONSTRUCTIONS PRIVATE LIMITED",
"SAGAR GRANDHI EXPORTS PRIVATE LIMITED",
"SAGAR HEALTH CARE AND DIAGNOSTIC SERVICES PRIVATE LIMITED",
"SAGAR HEAVY ENGINEERING PVT LTD",
"SAGAR HI-TECH SERVICES PRIVATE LIMITED",
"SAGAR HOSPITALS",
"SAGAR ICE AND COLD STORAGE PRIVATE LIMITED",
"SAGAR INDUSTRIES AND DISTILLERIES PRIVATE LIMITED",
"SAGAR INFORMATICS PRIVATE LIMITED",
"SAGAR INFRALOGISTICS PRIVATE LIMITED",
"SAGAR INSTITUTE OF SCIENCE TECHNOLOGY & ENGINEERING",
"SAGAR INTERNATIONAL LTD",
"SAGAR INTERNATIONAL PRIVATE LIMITED",
"SAGAR INTERNATIONAL SCHOOL",
"SAGAR ISPAT INDIA PRIVATE LIMITED",
"SAGAR KALA CHEMICALS PVT.LTD.",
"SAGAR LEASEFIN LIMITED",
"SAGAR LENTILS PRIVATE LIMITED",
"SAGAR LIFE SCIENCES PRIVATE LIMITED",
"SAGAR MACHINE TOOLS PVT LTD",
"SAGAR MAJOOR SANSTHA MARYADIT",
"SAGAR MAL SHIMBHOONATH FINANCE AND INVESTMENT COMPANY PRIVATE LIMITED",
"SAGAR MANUFACTURERS PRIVATE LIMITED",
"SAGAR METALLICS PRIVATE LIMITED SM",
"SAGAR MICRONICS PRIVATE LIMITED",
"SAGAR MINING AND METALS INDUSTRIES PRIVATE LIMITED",
"SAGAR MODULAR PRIVATE LIMITED",
"SAGAR MULTIPURPOSE STORAGE PRIVATE LIMITED",
"SAGAR MULTISPECIALITY HOSPITAL",
"SAGAR NUTRIMENTS PRIVATE LIMITED",
"SAGAR PAPER MILLS PRIVATE LIMITED",
"SAGAR PARIDHAAN PRIVATE LIMITED",
"SAGAR PETROLEUMS PRIVATE LIMITED",
"SAGAR PLASTICS PVT LTD",
"SAGAR POLYCHEM PRIVATE LIMITED",
"SAGAR POLYTECHNIK LIMITED",
"SAGAR POWER (DANDELA) LIMITED",
"SAGAR POWER LIMITED",
"SAGAR PREMI BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"SAGAR PUBLIC SCHOOL",
"SAGAR PULP AND PAPER MILLS LIMITED",
"SAGAR PULSES PRIVATE. LIMITED.",
"SAGAR RATNA RESTAURANT PRIVATE LIMITED",
"SAGAR REALTECH PRIVATE LIMITED",
"SAGAR RICE MILL PRIVATE LIMITED",
"SAGAR ROLLING MILLS PVT LTD",
"SAGAR ROOFINGS PRIVATE LIMITED",
"SAGAR RUBBER PRODUCTS PRIVATE LIMITED",
"SAGAR SAMRAT PRIVATE LIMITED",
"SAGAR SAMRAT SEAWAYS PRIVATE LIMITED",
"SAGAR SANAND INFRABUILD PRIVATE LIMITED",
"SAGAR SANGAM TEXTILE PRIVATE LIMITED",
"SAGAR SCIENTIFIC WORKS INDIA PRIVATE LIMITED",
"SAGAR SHIPPING AGENCIES INDIA PRIVATE LIMITED",
"SAGAR SMART CITY LIMITED",
"SAGAR SPECIALITY CHEMICALS PRIVATE LIMITED",
"SAGAR SPRINGS PRIVATE LIMITED",
"SAGAR STAR ENGINEERING PRIVATE LIMITED",
"SAGAR STEEL PRIVATE LIMITED",
"SAGAR STONE CRUSHER PRIVATE LIMITED",
"SAGAR SUITINGS PRIVATE LIMITED",
"SAGAR SURGICALS PRIVATE LIMITED",
"SAGAR SYNTHETICS PRIVATE LIMITED",
"SAGAR TECHNOCHEM",
"SAGAR TEXPRINT PRIVATE LIMITED",
"SAGAR TILES PRIVATE LIMITED",
"SAGAR TRAVEL AND TRANSPORT PRIVATE LIMITED",
"SAGAR VALVE PRIVATE LIMITED",
"SAGAR VYAPAAR PRIVATE LIMITED",
"SAGAR WINES MARKETEERS PRIVATE LIMITED",
"SAGAR WIRES PRIVATE LIMITED",
"SAGAR WOOD PRODUCTS PRIVATE LIMITED",
"SAGARASIA UNIVERSAL PRIVATE LIMITED",
"SAGARDEEP ALLOYS LIMITED",
"SAGARDUTT BUILDERS & DEVELOPERS PRIVATE LIMITED",
"SAGARI LEATHERS PRIVATE LIMITED",
"SAGARIKA EXIM PRIVATE LIMITED.",
"SAGARIKA MULTIPURPOSE COLD STORAGE AND FOOD PROCESSING PRIVATE LIMITED",
"SAGARLAXMI AGRISEEDS PRIVATE LIMITED",
"SAGARMAL MODI PRATHMIK SHIKSHAN MANDIR",
"SAGARMAL RAMESH KUMAR PVT LTD",
"SAGARMALA DEVELOPMENT COMPANY LIMITED",
"SAGARPEARL SEAFOOD PRODUCTS PRIVATE LIMITED",
"SAGARSHIP LOGISTICS PRIVATE LIMITED",
"SAGARSHREE HOSPITAL & RESEARCH INSTITUTE PRIVATE LIMITED",
"SAGARSHRI LUBRICANTS PRIVATE LIMITED",
"SAGARSOFT INDIA LIMITED",
"SAGARSRISHTI CIVILTECH PRIVATE LIMITED",
"SAGAS SYNTHETICS PRIVATE LIMITED",
"SAGAT INTERIORS PRIVATE LIMITED",
"SAGATIANZ IT SOLUTIONS PRIVATE LIMITED",
"SAGAYA MATHA HIGH SCHOOL",
"SAGE AUTOMATION GROUP INDIA PRIVATE LIMITED",
"SAGE COSMETIC LLP",
"SAGE DESIGNS PRIVATE LIMITED",
"SAGE HERBALS PRIVATE LIMITED",
"SAGE INFRASTRUCTURE PVT LTD",
"SAGE INNOVATION SERVICES PRIVATE LIMITED",
"SAGE INTERNATIONAL SCHOOL",
"SAGE IT PRIVATE LIMITED",
"SAGE MEDIA",
"SAGE MEDIHYGIENE PRIVATE LIMITED",
"SAGE METALS LIMITED",
"SAGE ORGANICS PRIVATE LIMITED",
"SAGE OUTSOURCING PRIVATE LIMITED",
"SAGE PUBLICATIONS INDIA PRIVATE LIMITED",
"SAGE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"SAGE TECHNOLOGIES PRIVATE LIMITED",
"SAGE UNIVERSITY",
"SAGEABLE TECHNOLOGIES PRIVATE LIMITED",
"SAGEBEANS IT AND CONSULTING PRIVATE LIMITED",
"SAGED RETAIL SOLUTIONS PRIVATE LIMITED",
"SAGENEXT INFOTECH PRIVATE LIMITED",
"SAGEPATH LABS PRIVATE LIMITED",
"SAGESTICS INDIA BRAKES PRIVATE LIMITED",
"SAGESTREET ADVISORY PRIVATE LIMITED",
"SAGGEZZA INDIA PRIVATE LIMITED",
"SAGGI KNITS PRIVATE LIMITED",
"SAGGRAHA MANAGEMENT SERVICES PRIVATE LIMITED",
"SAGHIR FATIMA MOHAMMADIA GIRL‚ÄôS INTER COLLEGE",
"SAGHIR FATIMA MOHAMMADIA GIRLS INTER COLLEGE",
"SAGI RAMAKRISHNAM RAJU ENGINEERING COLLEGE",
"SAGI SEEDS PRIVATE LIMITED",
"SAGILITY INDIA PRIVATE LIMITED",
"SAGINELA MAHESH NAIDU CONSTRUCTIONS PRIVATE LIMITED",
"SAGIR INFRACON PRIVATE LIMITED",
"SAGIS SERVICES (INDIA) PRIVATE LIMITED",
"SAGITARIUS ECOSPACES LLP",
"SAGITAUR SOLAR PARKS INDIA PRIVATE LIMITED",
"SAGITAUR VENTURES INDIA PRIVATE LIMITED",
"SAGITEC SOLUTIONS PRIVATE LIMITED",
"SAGITTA PRINTECH PRIVATE LIMITED",
"SAGITTARIANS CREDIT CAPITAL PRIVATE LIMITED",
"SAGITTARIANS INTERNATIONAL LIMITED",
"SAGITTARIANS LEATHER PRODUCTS PRIVATE LIMITED",
"SAGITTARIUS METALS PRIVATE LIMITED",
"SAGITTARIUS PROFILES PRIVATE. LIMITED.",
"SAGIUS LIFESCIENCES LIMITED",
"SAGMETIC INFOTECH PRIVATE LIMITED",
"SAGO TRADING LIMITED",
"SAGOMA IMPEX PRIVATE LIMITED",
"SAGONARA INFRAASTRUCTURES INDIA PRIVATE LIMITED",
"SAGOON INDIA PRIVATE LIMITED",
"SAGOON SECURITY SERVICES PRIVATE LIMITED",
"SAGORIKA UDYOG PRIVATE LIMITED",
"SAGRA HVAC PRIVATE LIMITED",
"SAGRI AGRO PRODUCT PRIVATE LIMITED",
"SAGRY HEALTH CARE PRIVATE LIMITED",
"SAGS APPARELS",
"SAGTAUR SYSTEMS PRIVATE LIMITED",
"SAGU DREAM LAND PRIVATE LIMITED",
"SAGUN COMMERCIALS PRIVATE LTD",
"SAGUN COPPER CONDUCTORS PRIVATE LIMITED",
"SAGUN ENTERPRISES PRIVATE LIMITED",
"SAGUN GEMS PRIVATE LIMITED",
"SAGUN LEATHER AND PRODUCTS PRIVATE LIMITED",
"SAGUN LOGISTICS PRIVATE LIMITED",
"SAGUN PROTEINS PRIVATE LIMITED",
"SAGUNA SOFT TECHNOLOGIES PRIVATE LIMITED",
"SAGUNAMATA CONSTRUCTIONS PRIVATE LIMITED",
"SAGUNAMATA READYMIX CONCRETE SOLUTION PRIVATE LIMITED",
"SAH AND SANGHI AUTO AGENCIES PRIVATE LIMITED",
"SAH BUILDERS PRIVATE LIMITED",
"SAH HEALTHCARE PRIVATE LIMITED",
"SAH POLYMERS LIMITED",
"SAHA & DUTTA TOUR & TRAVELS PRIVATE LIMITED",
"SAHA AGRO FOOD PRODUCTS PRIVATE LIMITED",
"SAHA BROTHERS BIRI WORKS PVT LTD",
"SAHA BUILDING CENTRE PRIVATE LIMITED",
"SAHA CIVIL CONSTRUCTION PRIVATE LIMITED",
"SAHA DISTRIBUTORS PRIVATE LIMITED",
"SAHA HYTECH PAPERS PRIVATE LIMITED",
"SAHA KNOWLEDGE AND SKILLS PARK PRIVATE LIMITED",
"SAHA ROADLINES PRIVATE LIMITED",
"SAHA STEEL PRIVATE LIMITED",
"SAHAB SINGH METAL & ALLOY PRIVATE LIMITED",
"SAHADEO INFRATECH PRIVATE LIMITED",
"SAHADEVAN SONS PVT LTD",
"SAHAGANJ DUNLOP HIGH SCHOOL",
"SAHAI EXCLUSIVE CONTRACTS PRIVATE LIMITED",
"SAHAJ AI SOFTWARE PRIVATE LIMITED",
"SAHAJ CERCHEM PRIVATE LIMITED",
"SAHAJ COOLING AND ELECTROINC SYSTEMS PRIVATE LIMITED",
"SAHAJ ENTERPRISES",
"SAHAJ E-VILLAGE LIMITED",
"SAHAJ FASHIONS LIMITED",
"SAHAJ FINVEST PRIVATE LIMITED.",
"SAHAJ HOSPITALS PRIVATE LIMITED",
"SAHAJ INCLUSIVE OPPORTUNITIES (INDIA) PRIVATE LIMITED",
"SAHAJ INFOTECH PRIVATE LIMITED",
"SAHAJ INFRACON PRIVATE LIMITED",
"SAHAJ KALYAN GRUHA PRIVATE LIMITED",
"SAHAJ PROJECT PRIVATE LIMITED",
"SAHAJ RETAIL LIMITED",
"SAHAJ SOFTWARE SOLUTIONS PRIVATE LIMITED",
"SAHAJ SOLAR LIMITED",
"SAHAJ VISHWAS URJA PRIVATE LIMITED",
"SAHAJA CROP SCIENCES PRIVATE LIMITED",
"SAHAJA GRANITES PRIVATE LIMITED",
"SAHAJA SAMRUDHA ORGANIC PRODUCER COMPANY LIMITED",
"SAHAJANAND IMPEX PRIVATE LIMITED",
"SAHAJANAND LASER TECHNOLOGY LIMITED",
"SAHAJANAND LIFE SCIENCES PRIVATE LIMITED",
"SAHAJANAND MEDICAL TECHNOLOGIES LIMITED",
"SAHAJANAND MEDICAL TECHNOLOGIES PRIVATE LIMITED",
"SAHAJANAND TECHNOLOGIES PRIVATE LIMITED",
"SAHAJANAND VALVES PRIVATE LIMITED",
"SAHAJANAND VIDHYALAYA",
"SAHAJANAND WORLD TRAVELS",
"SAHAJANUND CLEARING AND FREIGHT FORWARDING PRIVATE LIMITED",
"SAHAJI TRADING AND INVESTMENT PRIVATE LIMITED",
"SAHAKAR AGRI PRODUCER COMPANY LIMITED",
"SAHAKAR CROP SCIENCE PRIVATE LIMITED",
"SAHAKAR GLOBAL LIMITED",
"SAHAKAR GLOBAL SDMC JV LLP",
"SAHAKAR INFRACON PROJECTS PRIVATE LIMITED",
"SAHAKAR SOLUTIONS AND TECHNOLOGIES LLP",
"SAHAL BUSINESS PVT LTD",
"SAHAL PROCESS PACK PRIVATE LIMITED",
"SAHALAL RICE MILL PRIVATE LIMITED",
"SAHANA CLOTHING COMPANY PRIVATE LIMITED",
"SAHANA FASHIONS PRIVATE LIMITED",
"SAHANA FILMS PRIVATE LIMITED",
"SAHANA FOOD PRODUCTS PRIVATE LIMITED",
"SAHANA INDIA TRANSPORT COMPANY PRIVATE LIMITED",
"SAHANA JEWELLERY EXPORTS PRIVATE LIMITED",
"SAHANA LOGISTICS PRIVATE LIMITED",
"SAHANA OVERSEAS PRIVATE LIMITED",
"SAHANA SYSTEM LIMITED",
"SAHANARATNABH PRIVATE LIMITED",
"SAHANBHUTI DISTRIBUTORS PRIVATE LIMITED",
"SAHANU SPONGE AND POWER PRIVATE LIMITED",
"SAHAR INDUSTRIES",
"SAHARA AGRI PRODUCTS PRIVATE LIMITED",
"SAHARA AGRO PRIVATE LIMITED",
"SAHARA AIRCON PRIVATE LIMITED",
"SAHARA ASSET MANAGEMENT COMPANY PRIVATE LIMITED",
"SAHARA BAKERS PRIVATE LIMITED",
"SAHARA CREDIT COOPERATIVE SOCIETY LIMITED",
"SAHARA DOMESTIC & INTERNATIONAL PACKERS & MOVERS PRIVATE LIMITED",
"SAHARA DREDGING LIMITED",
"SAHARA EXPRESS COURIER PRIVATE LIMITED",
"SAHARA FERRO ALLOYS PRIVATE LIMITED",
"SAHARA FOAMS PRIVATE LIMITED",
"SAHARA HOUSINGFINA CORPORATION LIMITED",
"SAHARA INDIA GOODS MOVERS PRIVATE LIMITED",
"SAHARA INDIA MASS COMMUNICATION",
"SAHARA INDIA MEDICAL INSTITUTE LIMITED",
"SAHARA INDUSTRIES",
"SAHARA LABELS PRIVATE LIMITED",
"SAHARA MARITIME LIMITED",
"SAHARA RISE CONSTRUCTIONS LIMITED",
"SAHARA ROAD LINES PRIVATE LIMITED",
"SAHARA TRANSFORMERS PRIVATE LIMITED",
"SAHARANPUR ENGINEERING WORKS PRIVATE LIMITED",
"SAHARANPUR INSTITUTE OF MEDICAL SCIENCES PRIVATE LIMITED",
"SAHARANPUR PAPER AND BOARD PRIVATE LIMITED",
"SAHARANPUR TESTING INSTRUMENTS PRIVATE LIMITED",
"SAHARIA TEA COMPANY PRIVATE LIMITED",
"SAHARSA SATYAM HOSPITAL PRIVATE LIMITED",
"SAHARSA WOMEN JEEVIKA PRODUCER COMPANY LIMITED",
"SAHARSH FASHIONS PRIVATE LIMITED",
"SAHARSH PACKAGING PRIVATE LIMITED",
"SAHARSH REALTORS PRIVATE LIMITED",
"SAHARSH VINCOM PRIVATE LIMITED",
"SAHARSH YARN PVT LTD",
"SAHAS MANAGEMENT CONSULTING PRIVATE LIMITED",
"SAHAS SCIENTIFIC PRIVATE LIMITED",
"SAHAS TECHNOLOGIES PRIVATE LIMITED",
"SAHASANKHA ADVISORY AND CONSULTING SERVICES PRIVATE LIMITED",
"SAHASRA BUILDING SOLUTIONS PRIVATE LIMITED",
"SAHASRA CROP SCIENCE PRIVATE LIMITED",
"SAHASRA ELECTRONICS PRIVATE LIMITED",
"SAHASRA GASTROENTEROLOGY AND OBESITY CLINIC PRIVATE LIMITED",
"SAHASRA IMAGING & HOSPITALS PRIVATE LIMITED",
"SAHASRA OVERSEAS PRIVATE LIMITED",
"SAHASRA PHARMA CHEM PRIVATE LIMITED",
"SAHASRA TELEVISION PRIVATE LIMITED",
"SAHASRADHARA ENERGY PRIVATE LIMITED",
"SAHASRALINGESHWARA POWER PRIVATE LIMITED",
"SAHASTRA CHEMICALS PRIVATE LIMITED",
"SAHASTRA ENTERPRISES PRIVATE LIMITED",
"SAHASTRA FOODS AND SERVICES PRIVATE LIMITED",
"SAHASTRA SALES PRIVATE LIMITED",
"SAHASTRAA EXPORTS PRIVATE LIMITED",
"SAHASTRARJUN TEXTILES PRIVATE LIMITED",
"SAHASYA GLOBAL SOLUTIONS PRIVATE LIMITED",
"SAHAY INVESTMENT SERVICES PRIVATE LIMITED",
"SAHAY RACKS PRIVATE LIMITED",
"SAHAYA PRINT SERVICES PRIVATE LIMITED",
"SAHAYA PROPERTIES AND INVESTMENT PRIVATE LIMITED",
"SAHAYAK NIBADHAK SAHAKARI SANSTHA JAMNER",
"SAHAYAK SAMBHAGIYA PARIVAHAN ADHIKARI PRASHASAN",
"SAHAYAK UTILITY SERVICE PROVIDER PRIVATE LIMITED",
"SAHAYAMATHA SALTERNS PRIVATE LIMITED",
"SAHAYOG HOSPITAL AND RESEARCH CENTRE PVT LTD",
"SAHAYOG MULTISTATE CREDIT CO-OPERATIVE SOCIETY LTD",
"SAHAYOG TOOLS PRIVATE LIMITED",
"SAHAYTA SECURITY SERVICES PRIVATE LIMITED",
"SAHDEV TRADERS PRIVATE LIMITED",
"SAHEBRAO PATIL VIDYALAYA TANDALA BEED",
"SAHEBRAO SHANKARRAO DHAMDHERE ARTS & COMMERCE COLLEGE",
"SAHEJ BUSINESS PRIVATE LIMITED",
"SAHEJ FABTEX PRIVATE LIMITED",
"SAHEJ REALCON PRIVATE LIMITED",
"SAHEJDAYA FASHIONS PRIVATE LIMITED",
"SAHELI EXPORTS PRIVATE LIMITED",
"SAHELI FASHIONS PRIVATE LIMITED",
"SAHELI GEMS & JEWELLERS PRIVATE LIMITED",
"SAHELI JEWELLERS PRIVATE LIMITED",
"SAHELI TEXPORTS PRIVATE LIMITED",
"SAHELI TRADING PRIVATE LIMITED",
"SAHI RESIDENCY PRIVATE LIMITED",
"SAHI WAREHOUSING PRIVATE LIMITED",
"SAHIB AUTO PRIVATE LIMITED",
"SAHIB AUTOMOTIVE PRIVATE LIMITED",
"SAHIB FERTILIZERS PRIVATE LIMITED",
"SAHIB NOVELTIES PRIVATE LIMITED",
"SAHIB PESTICIDES PRIVATE LIMITED",
"SAHIB RICE AND FLOUR MILLS PRIVATE LIMITED",
"SAHIB SEEDS LIMITED",
"SAHIB SONS FOODS PRIVATE LIMITED",
"SAHIB TEXTILES PRIVATE LIMITED",
"SAHIB TRADELINKS PRIVATE LIMITED",
"SAHIBA CONSTRUCTIONS PRIVATE LIMITED",
"SAHIBA CREATIONS INDIA PRIVATE LIMITED",
"SAHIBA IMPEX PVT LTD",
"SAHIBA LIMITED",
"SAHIBGANJ AAKANKSHA WASTE MANAGEMENT PRIVATE LIMITED",
"SAHIBJI TRAVELS & TOURS PRIVATE LIMITED",
"SAHIBZADA AJIT SINGH INSTITUTE OF INFORM",
"SAHIBZADA TIMBERS & PLY PRIVATE LIMITED",
"SAHID KHUDIRAM BOSE HOSPITAL",
"SAHIDA ENGICON PRIVATE LIMITED",
"SAHIL AUTO COMPONENTS PRIVATE LIMITED",
"SAHIL AUTO TECHNOLOGIES PRIVATE LIMITED",
"SAHIL AUTOMOBILE PRIVATE LIMITED",
"SAHIL AUTOMOTIVES PRIVATE LIMITED",
"SAHIL AUTOWHEELS PRIVATE LIMITED",
"SAHIL BHARAT MOTORS PRIVATE LIMITED",
"SAHIL COUTURE PRIVATE LIMITED",
"SAHIL FASHION PRIVATE LIMITED",
"SAHIL FREIGHT EXPRESS PRIVATE LIMITED",
"SAHIL HANDLOOM PRIVATE LIMITED",
"SAHIL HERBALS PRIVATE LIMITED",
"SAHIL LOGISTICS PRIVATE LIMITED",
"SAHIL PHARMA CHEMICALS PRIVATE LIMITED",
"SAHIL PLASTIC PRIVATE LIMITED",
"SAHIL POWER SYSTEMS PRIVATE LIMITED",
"SAHIL PROJECTS & PLANNING PRIVATE LIMITED",
"SAHIRA HOUSEKEEPING PRODUCTS PRIVATE LIMITED",
"SAHISU MAPOTRANS PRIVATE LIMITED",
"SAHITHI SEA FOODS & MARINE EXPORTS PRIVATE LIMITED",
"SAHITHI SYSTEMS PRIVATE LIMITED",
"SAHITI INFRATEC VENTURES INDIA PRIVATE LIMITED",
"SAHITI POULTRY BREEDING FARMS",
"SAHITYA AKADEMI",
"SAHITYA BHARATI PUBLICATIONS PVT LTD",
"SAHITYA BHAWAN PUBLICATIONS",
"SAHITYA MUDRANALAYA PVT LTD",
"SAHIWAL INVESTMENT AND TRADING COMPANY",
"SAHJANAND ENGINEERING PRIVATE LIMITED",
"SAHJANAND FLYASH BRICKS PLANT PRIVATE LIMITED",
"SAHJANAND JEWELLERS PRIVATE LIMITED",
"SAHJANAND ORTHOPEDIC HOSPITAL",
"SAHJANAND TRANSWORLD EXIM PRIVATE LIMITED",
"SAHJANAND VIDHYALAYA",
"SAHKAR PHARMACEUTICALS PRIVATE LIMITED",
"SAHKAR SEEDS PRIVATE LIMITED",
"SAHKAR SYNTHETICS PRIVATE LIMITED",
"SAHKARI GANNA VIKASH SAMITI LIMITED",
"SAHKARI INTER COLLEGE",
"SAHKARI SAMITI LIMITED",
"SAHNEY COMMUTATORS PRIVATE LIMITED",
"SAHNEY KIRKWOOD PRIVATE LIMITED",
"SAHNI CHEMPLANT PRIVATE LIMITED",
"SAHNI DISTRIBUTORS PRIVATE LMITED",
"SAHNI FASHIONS PRIVATE LIMITED",
"SAHNI KRISHNA PROMOTERS AND DEVELOPERS PRIVATE LIMITED",
"SAHNI MOTORS PRIVATE LIMITED",
"SAHNI SPORTS PRIVATE LIMITED",
"SAHODAY SR. SECONDARY SCHOOL",
"SAHOO BROTHERS STEVEDORS PRIVATE LIMITED",
"SAHOO DISTRIBUTERS PRIVATE LIMITED",
"SAHOO TRADELINK PRIVATE LIMITED",
"SAHOTA HEALTHCARE PRIVATE LIMITED",
"SAHOTA PAPERS LIMITED",
"SAHRDAYA COLLEGE OF ENGINEERING AND TECHNOLOGY",
"SAHREE KANHA INDUSTRIES PRIVATE LIMITED",
"SAHRI-KAHRI INVESTMENTS PRIVATE LIMITED",
"SAHRISH CONSTRUCTIONS PRIVATE LIMITED",
"SAHRUDAYA HEALTH CARE (SRIKAKULAM) PRIVATE LIMITED",
"SAHRUDAYA HEALTH CARE PRIVATE LIMITED",
"SAHS FOODS PRIVATE LIMITED",
"SAHS LIFESCIENCES PRIVATE LIMITED",
"SAHSAI TECHCLUB BUSINESS SOLUTIONS PRIVATE LIMITED",
"SAHU AGENCIES PRIVATE LIMITED",
"SAHU AGRO BUSINESS PRIVATE LIMITED",
"SAHU BROTHERS ELECTRIC AND WINDIN WORKSHOP",
"SAHU ENTERPRISES PRIVATE LIMITED",
"SAHU ESTATE PRIVATE LIMITED",
"SAHU EXPORTS",
"SAHU GLOBAL PRIVATE LIMITED",
"SAHU HOUSING AND LAND IMPROVERS PRIVATE LIMITED",
"SAHU HYDRO POWER PRIVATE LIMITED",
"SAHU INVESTMENT MUTUAL BENEFIT COMPANY LIMTED",
"SAHU JAIN SERVICES LIMITED",
"SAHU JEWELLERS PRIVATE LIMITED",
"SAHU LANDMARK PRIVATE LIMITED",
"SAHU REFRIGERATION INDUSTRIES LIMITED",
"SAHU REFRIGERATION INDUSTRIES PRIVATE LIMITED",
"SAHU SURGICAL EMPORIUM PRIVATE LIMITED",
"SAHUJI GLOBAL EXIM PRIVATE LIMITED",
"SAHUSONS INTERIORS AND BUILDERS PRIVATE LIMITED",
"SAHUWALA ALUMINIUMS PRIVATE LIMITED",
"SAHUWALA CEREALS PRIVATE LIMITED",
"SAHUWALA CYLINDERS PRIVATE LIMITED",
"SAHUWALA EXPORTS PRIVATE LIMITED",
"SAHUWALA GRAINS PRIVATE LIMITED",
"SAHUWALA PIGMENTS PRIVATE LIMITED",
"SAHUWALA ROLLER FLOUR MILLS PRIVATE LIMITED",
"SAHYADHRI LOGISTICS PRIVATE LIMITED",
"SAHYADREE BUILDER PRIVATE LIMITED",
"SAHYADRI ACCIDENT AND NEURO CARE CENTER PRIVATE LIMITED",
"SAHYADRI AGENCIES LIMITED",
"SAHYADRI AGRO AND DAIRY PRIVATE LIMITED",
"SAHYADRI AGRO RETAILS LIMITED",
"SAHYADRI AYURVEDIC LIFE PRIVATE LIMITED",
"SAHYADRI BAGLAN ZONE FARMERS PRODUCER COMPANY LIMITED",
"SAHYADRI COLLEGE OF ENGINEERING AND MANAGEMENT",
"SAHYADRI CONSTRUCTION COMPANY",
"SAHYADRI ELECTRO CONTROLS INDIA PRIVATE LIMITED",
"SAHYADRI ELECTROMECHANICAL PRIVATE LIMITED",
"SAHYADRI ENGI-PACK PRIVATE LIMITED",
"SAHYADRI ENTERPRISES",
"SAHYADRI FARMERS PRODUCER COMPANY LIMITED",
"SAHYADRI FARMS POST HARVEST CARE LIMITED",
"SAHYADRI FARMS SUPPLY CHAIN LIMITED",
"SAHYADRI FLEET SOLUTIONS PRIVATE LIMITED",
"SAHYADRI FRUITS PRODUCER COMPANY LIMITED",
"SAHYADRI GRAPES PRODUCER COMPANY LIMITED",
"SAHYADRI HEALTHCARE & DIAGNOSTICS PRIVATE LIMITED",
"SAHYADRI HIGH SCHOOL JR COLLEGE",
"SAHYADRI HOSPITAL KARAD",
"SAHYADRI HOSPITALS LIMITED",
"SAHYADRI HOSPITALS PRIVATE LIMITED",
"SAHYADRI IMAGING PRIVATE LIMITED",
"SAHYADRI INDUSTRIES LIMITED",
"SAHYADRI INFRA SPACES PRIVATE LIMITED",
"SAHYADRI KARAD HOSPITALS PRIVATE LIMITED",
"SAHYADRI MOTELS PRIVATE LIMITED",
"SAHYADRI MOTORS PRIVATE LIMITED",
"SAHYADRI POMEGRANATE PRODUCER COMPANY LIMITED",
"SAHYADRI RENEWABLE ENERGY PRIVATE LIMITED",
"SAHYADRI RUBBERS PVT LTD",
"SAHYADRI RURAL DEVELOPMENT FOUNDATION",
"SAHYADRI SCHOOL",
"SAHYADRI STARCH & INDUSTRIES PRIVATE LIMITED",
"SAHYADRI SUGAR AND DISTILLARIES PRIVATE LIMITED",
"SAHYADRI TECHNOFAB PRIVATE LIMITED",
"SAHYADRI TOMATO PRODUCER COMPANY LIMITED",
"SAHYADRI VIDYANIKETAN MALE TAL HATKANANGALE DIST KOLHAPUR",
"SAHYOG AUTO COMPONENTS PRIVATE LIMITED",
"SAHYOG BUSINESS SERVICES PRIVATE LIMITED",
"SAHYOG COLLEGE OF MANAGEMENT STUDIES",
"SAHYOG COTTON AND OIL PRIVATE LIMITED",
"SAHYOG DEVELOPMENT SERVICES",
"SAHYOG EXPORTS PRIVATE LIMITED",
"SAHYOG GASES PRIVATE LIMITED",
"SAHYOG GINNING AND PRESSING PRIVATE LIMITED",
"SAHYOG HOLDINGS PRIVATE LIMITED",
"SAHYOG HOMES LIMITED",
"SAHYOG IMPEX INDIA PRIVATE LIMITED",
"SAHYOG LOGISTICS SOLUTIONS PRIVATE LIMITED",
"SAHYOG MULTIBASE LIMITED",
"SAHYOG PHARMACHEM INDUSTRIES PRIVATE LIMITED",
"SAHYOG REALCON LIMITED",
"SAHYOG SILK MILLS PRIVATE LIMITED",
"SAHYOG TAX & FINANCE ADVISORY LIMITED",
"SAHYOJIT FREIGHT FORWARDING (OPC) PRIVATE LIMITED",
"SAI AADHAR SERVICES PRIVATE LIMITED",
"SAI AAINA FARMS PRIVATE LIMITED",
"SAI AARADHANA DEVELOPERS PRIVATE LIMITED",
"SAI AARAV MOTORS",
"SAI AASTHA DEVELOPERS",
"SAI ACCOUNTS SYSTEMS PRIVATE LIMITED",
"SAI ACHYUTH ENERGY PRIVATE LIMITED",
"SAI ADHIRAAJ LAND & PROMOTERS PRIVATE LIMITED",
"SAI AGRO EXIM PRIVATE LIMITED",
"SAI AGRO INDUSTRIES",
"SAI AIRCON AND VENTILATION SYSTEMS PRIVATE LIMITED",
"SAI ALLWYN PLAST PRIVATE LIMITED",
"SAI AMRIT DIAGNOSTIC PRIVATE LIMITED",
"SAI ANAND PROPERTIES AND INFRASTRUCTURE PRIVATE LIMITED",
"SAI ANANTA AUTOMOBILES PRIVATE LIMITED",
"SAI APPLIED TECHNOLOGIES PRIVATE LIMITED",
"SAI ARC INDIA PRIVATE LIMITED",
"SAI ASHRAY DEVELOPERS PRIVATE LIMITED",
"SAI ASHRIBAD TRADING PRIVATE LIMITED",
"SAI ASTITA GOLD PRIVATE LIMITED",
"SAI AUTO COMPONENTS PRIVATE LIMITED",
"SAI AUTORIDERS PRIVATE LIMITED",
"SAI AYURVED COLLEGE & RESEARCH CENTERSASURE VAIRAG",
"SAI BABA ANU ADIVASI PRATHAMIK ASHRAM SHALA",
"SAI BABA AUTOWHEELS PRIVATE LIMITED",
"SAI BABA BUSINESS MACHINES PRIVATE LIMITED",
"SAI BABA BUSINESS SOLUTIONS PRIVATE LIMITED",
"SAI BABA ENTERPRISES PRIVATE LIMITED",
"SAI BABA HI-TECH FENCING PRIVATE LIMITED",
"SAI BABA IRON ORE SALES PRIVATE LIMITED",
"SAI BABA MEDIA HOUSE PRIVATE LIMITED",
"SAI BABA OILS & CHEM PRIVATE LIMITED",
"SAI BABA POLYMER TECHNOLOGIES PRIVATE. LIMITED.",
"SAI BABA SALES PRIVATE LIMITED",
"SAI BABA WAT BHANDAR",
"SAI BABUJI PROJECTS PRIVATE LIMITED",
"SAI BALAJI CONSTRUCTIONS",
"SAI BALAJI DIGITALS PRIVATE LIMITED",
"SAI BALAJI EXTRACTION AND ALLOYS PRIVATE LIMITED",
"SAI BALAJI GLOBAL ENTERPRISES PRIVATE LIMITED",
"SAI BALAJI INFRA INDIA PRIVATE LIMITED",
"SAI BALAJI INTERNATIONAL INSTITUTE OF MANAGEMENT SCIENCE",
"SAI BALAJI MEDICAL INSTITUTE",
"SAI BALAJI WAREHOUSING AND LOGISTICS PRIVATE LIMITED",
"SAI BANDHAN INFINIUM PRIVATE LIMITED",
"SAI BHAGABATI FOODS AND BEVERAGES PRIVATE LIMITED",
"SAI BHAVANI INFRABUILD PRIVATE LIMITED",
"SAI BHAVYA SEEDS PRIVATE LIMITED",
"SAI BIOCARE PRIVATE LIMITED",
"SAI BOOK SUPPLIERS PRIVATE LIMITED",
"SAI BUILDCON PRIVATE LIMITED",
"SAI CABTECH PRIVATE LIMITED",
"SAI CARGO LOGISTICS PRIVATE LIMITED",
"SAI CARTON MANUFACTURING COMPANY PRIVATE LIMITED",
"SAI CENTECH SOLUTIONS PRIVATE LIMITED",
"SAI CERAMIC ENGINEERS PRIVATE LIMITED",
"SAI CHAKRA HOTELS PRIVATE LIMITED",
"SAI CHEMPARTNERS INDIA PRIVATE LIMITED",
"SAI CHEMTECH PRIVATE LIMITED",
"SAI CHHAYA AUTOLINK PRIVATE LIMITED",
"SAI CHIRAG INFRA PROJECT PRIVATE LIMITED",
"SAI CHIRAG PROPERTIES PRIVATE LIMITED",
"SAI CIBO INDIA PRIVATE LIMITED",
"SAI COCOPEAT EXPORT PRIVATE LIMITED",
"SAI COLLEGE OF NURSING",
"SAI COM CODES FLEXOPRINT PRIVATE LIMITED",
"SAI COMPUTERS LIMITED",
"SAI CONDUCTORS PRIVATE LIMITED",
"SAI CONSTRUCTION PRIVATE.. LIMITED",
"SAI CONSULTANCY AND SERVICES PRIVATE LIMITED",
"SAI CONSULTING ENGINEERS PRIVATE LIMITED",
"SAI CORP CREATIONS PRIVATE LIMITED",
"SAI COTEX PRIVATE LIMITED",
"SAI CRAFT LIMITED",
"SAI CROP-SCIENCE PRIVATE LIMITED",
"SAI CUISINE HOSPITALITY SERVICES PRIVATE LIMITED",
"SAI CYLINDERS PRIVATE LIMITED",
"SAI DARSHAN ELECTRICAL PRIVATE LIMITED",
"SAI DARSHAN INDUSTRIES PRIVATE LIMITED",
"SAI DATA SOFT SERVICES PRIVATE LIMITED",
"SAI DEEKSHITA TECH SERVICES PRIVATE LIMITED",
"SAI DEEP EXPORTS PRIVATE LIMITED",
"SAI DEEPA ROCK DRILLS PRIVATE LIMITED",
"SAI DEVELOPZONE PRIVATE LIMITED",
"SAI DHAM INDUSTRIAL SERVICES PRIVATE LIMITED",
"SAI DHAM JEWELLERS PRIVATE LIMITED",
"SAI DIESELS PRIVATE LIMITED",
"SAI DIGISTIK PRIVATE LIMITED",
"SAI DRISHTI TRAVELS PRIVATE LIMITED",
"SAI DURGA AGRI MECHANISATION PRIVATE LIMITED",
"SAI DURGA AUTOCRAFT PRIVATE LIMITED",
"SAI DURGA FERRO ALLOYS PRIVATE LIMITED",
"SAI DUTT REAL INFRA PRIVATE LIMITED",
"SAI DUTTA CLEARING AGENCY PRIVATE LIMITED",
"SAI EARLY LEARNERS PRIVATE LIMITED",
"SAI EDUCARE PRIVATE LIMITED",
"SAI ELECTRIC AND TRADING COMPANY PRIVATE LIMITED",
"SAI ELECTROCASTING PRIVATE LIMITED",
"SAI ENFORCEMENT AND SECURITY PRIVATE LIMITED",
"SAI ENGICON AND CONSTRUCTION PRIVATE LIMITED",
"SAI ENGINEERING & TECHNICAL SERVICES",
"SAI ENGINEERS AND MACHINERIES PRIVATE LIMITED",
"SAI ENTERPRISES PRIVATE LIMITED",
"SAI EQUIPMENTS PRIVATE LIMITED",
"SAI ESHAN ENTERPRISES PRIVATE LIMITED",
"SAI ESSEN DEVELOPERS",
"SAI EVEREST BUILDERS & DEVELOPERS PRIVATE LIMITED",
"SAI EXPO FAB PRIVATE LIMITED",
"SAI EXTRUMECH PRIVATE LIMITED",
"SAI FAB CONSTRUCTION AND INDUSTRIES PRIVATE LIMITED",
"SAI FABRICS TRADING INDIA PRIVATE LIMITED",
"SAI FARMICULTURE PRIVATE LIMITED",
"SAI FERTILITY CENTRE & HOSPITAL",
"SAI FERTILIZERS AND PHOSPHATES PRIVATE LIMITED",
"SAI FERTILIZERS PRIVATE LIMITED",
"SAI FINANCIAL& BPO SOLUTIONS",
"SAI FINENT ADVISORY PRIVATE LIMITED",
"SAI FIRE APPLIANCES PRIVATE LIMITED",
"SAI FLIPPED COIL LIMITED",
"SAI FOILS PRIVATE LIMITED",
"SAI FOODHOUSE PRIVATE LIMITED",
"SAI FOOTWEARS PRIVATE LIMITED",
"SAI FOREX PRIVATE LIMITED",
"SAI FORGE PRIVATE LIMITED",
"SAI FREIGHT PVT LTD",
"SAI G TRAVEL N FOREX PRIVATE LIMITED",
"SAI GADGETS SHOP PRIVATE LIMITED",
"SAI GAJANAN AQUA PRIVATE LIMITED",
"SAI GANESH EXPORTS PRIVATE LIMITED",
"SAI GANESH MULTI STATE COOPERATIVE DAIRY LIMITED",
"SAI GANESH PROPERTIES PRIVATE LIMITED",
"SAI GANESH TOURS AND TRAVELS",
"SAI GANGA PANAKEIA PRIVATE LIMITED",
"SAI GENERATORS PRIVATE LIMITED",
"SAI GENSETS PRIVATE LIMITED",
"SAI GEOTECHNICAL ENGINEERS PRIVATE LIMITED",
"SAI GLOBAL LIMITED",
"SAI GLOBAL YARNTEX INDIA PRIVATE LIMITED",
"SAI GR IMPEX PRIVATE LIMITED",
"SAI GREEN METAFIN COATING TECHNOLOGY PRIVATE LIMITED",
"SAI GT PRIVATE LIMITED",
"SAI HERBAL WORLD SCIENCE PRIVATE LIMITED",
"SAI HIGHWAY & BUILDERS PRIVATE LIMITED",
"SAI HOSPITAL",
"SAI IGES POWER PRIVATE LIMITED",
"SAI IMAGING HEALTHCARE PRIVATE LIMITED",
"SAI INDIA ASSOCIATES",
"SAI INDIA CONSTRUCTIONS PRIVATE LIMITED",
"SAI INDIA GYPSUM PRODUCTS PRIVATE LIMITED",
"SAI INDIA LIMITED",
"SAI INDIA LOGISOLUTIONS PRIVATE LIMITED",
"SAI INDO METAL RESOURCES PRIVATE LIMITED",
"SAI INDUSTRIAL ALLIANCES PRIVATE LIMITED",
"SAI INDUSTRIES PRIVATE LIMITED",
"SAI INERNATIONAL",
"SAI INFINIUM PRIVATE LIMITED",
"SAI INFOCARE PRIVATE LIMITED",
"SAI INFORMATION SYSTEMS PRIVATE LIMITED",
"SAI INFOSERV PRIVATE LIMITED",
"SAI INFOTECH SYSTEMS LIMITED",
"SAI INFOTEL SOLUTIONS PRIVATE LIMITED",
"SAI INFRA HOME CONSORTIUM PRIVATE LIMITED",
"SAI INFRAAEQUIPMENTS PRIVATE LIMITED",
"SAI INFRACONSTRUCTION PRIVATE LIMITED",
"SAI INFRATEL PRIVATE LIMITED",
"SAI INSTITUTE OF PARAMEDICAL & ALLIED SCIENCE",
"SAI INTERNATIONAL",
"SAI INTERNATIONAL PET PRODUCTS PRIVATE LIMITED",
"SAI INTERNATIONAL RESIDENTIAL SCHOOL",
"SAI INTERNATIONAL SECURITY PRIVATE LIMITED",
"SAI JAGANNATH COTSPIN PRIVATE LIMITED",
"SAI JASUN INTERNATIONALS PRIVATE LIMITED",
"SAI JYOTHI ALLOY CASTINGS PRIVATE LIMITED",
"SAI JYOTI CHEMICAL PVT. LTD",
"SAI JYOTI FASHIONS PRIVATE LIMITED",
"SAI KALP CONSULTANCY PRIVATE LIMITED",
"SAI KAMAL AGRO PRIVATE LIMITED",
"SAI KANGA PLAST PRIVATE LIMITED",
"SAI KIRAN CLEARING COMPANY PRIVATE LIMITED",
"SAI KIRPA FACILITY MANAGEMENT PRIVATE LIMITED",
"SAI KISHAN MACHINERY (OPC) PRIVATE LIMITED",
"SAI KLENZER CONSULTANCY SERVICES PRIVATE LIMITED",
"SAI KRIPA CONSTRUCTION PRIVATE LIMITED",
"SAI KRIPA FITNESS ZONE PRIVATE LIMITED",
"SAI KRIPA REAL ESTATE PRIVATE LIMITED",
"SAI KRIPA TELCOM AND CONSTRUCTION PRIVATE LIMITED",
"SAI KRIPAA MEDICAL SYSTEMS PRIVATE LIMITED",
"SAI KRISHNA ENGG. & CONSTRUCTION PRIVATE LIMITED",
"SAI KRISHNA SUPER SPECIALITY NEURO HOSPI",
"SAI KRISHNA WAREHOUSING PRIVATE LIMITED",
"SAI KRUPA CONSTRUCTION",
"SAI KRUPA DAIRY & FOOD PRODUCTS PRIVATE LIMITED",
"SAI KRUPA HATCHERIES PRIVATE LIMITED",
"SAI KRUPA PLY AND HARDWARE",
"SAI KUNJ MARKETING & TRADING PRIVATE LIMITED",
"SAI LABORATORIES PRIVATE LIMITED",
"SAI LAKSHMI INDUSTRIES PRIVATE LIMITED",
"SAI LAKSHMI STEELS",
"SAI LEELA CATERERS PRIVATE LIMITED",
"SAI LEELA FARMERS PRODUCER COMPANY LIMITED",
"SAI LEELA HOSPITALITY PRIVATE LIMITED",
"SAI LEELA HOTEL PRIVATE LIMITED",
"SAI LEELA SYNTHETICS PRIVATE LIMITED",
"SAI LIFE SCIENCES LIMITED",
"SAI LILAGAR POWER GENERATION LIMITED",
"SAI LINKS (INDIA) PRIVATE LIMITED",
"SAI MAA BUSINESS CONCEPTS PRIVATE LIMITED",
"SAI MACHINE TOOLS PVT LTD",
"SAI MADHRE AGRO PRIVATE LIMITED",
"SAI MADHUBAN HOSPITALITY PRIVATE LIMITED",
"SAI MAHA FOUNDATION PRIVATE LIMITED",
"SAI MAITHILI POWER COMPANY PRIVATE LIMITED",
"SAI MANFORCE TRAINING FOUNDATION",
"SAI MANPOWER SERVICES PRIVATE LIMITED",
"SAI MANPOWER SUPPLIER",
"SAI MARINE EXPORTS PRIVATE LIMITED",
"SAI MARITIME AND MANAGEMENT PRIVATE LIMITED",
"SAI MATRICULATION HIGHER SECONDARY SCHOOL",
"SAI MAX ENGINEERS PRIVATE LIMITED",
"SAI MED PHARMA SYSTEMS PRIVATE LIMITED",
"SAI MEDICALS CENTER",
"SAI MEDICINE AGENCIES PRIVATE LIMITED",
"SAI MEDICURE SERVICES PRIVATE LIMITED",
"SAI MEGA BUILDERS PRIVATE LIMITED",
"SAI MODULAR BUILDINGS PRIVATE LIMITED",
"SAI MOKSHITH CONSTRUCTIONS PRIVATE LIMITED",
"SAI NANDINI DAIRY PRIVATE LIMITED",
"SAI NARA ESTATE PRIVATE LIMITED",
"SAI NATH POLYMERS AND CONTAINERS PRIVATE LIMITED",
"SAI NATH RENEWABLE ENERGY PRIVATE LIMITED",
"SAI NAVYUGA CARGO & LOGISTICS PRIVATE LIMITED",
"SAI NET SERVICES PRIVATE LIMITED",
"SAI NISHTHA TRANSFORMER PRIVATE LIMITED",
"SAI NITHYA CONSTRUCTIONS PRIVATE LIMITED",
"SAI OM PETRO SPECIALITIES LIMITED",
"SAI OM TEXFAB PRIVATE LIMITED",
"SAI ORTHOCARE HOSPITALS PRIVATE LIMITED",
"SAI PALACE HOTELS",
"SAI PAPER CORP PRIVATE LIMITED",
"SAI PARADISE MACHINE TOOLS (INDIA) PRIVATE LIMITED",
"SAI PARENTERAL'S LIMITED",
"SAI PARYAVARAN CONSTRUCTIONS PRIVATE LIMITED",
"SAI PATRONAGE COMMERCE PRIVATE LIMITED",
"SAI PETROLEUM PRIVATE LIMITED",
"SAI PHARMA DISTRIBUTORS PRIVATE LIMITED",
"SAI PHYTOCEUTICAL PRIVATE LIMITED",
"SAI PLY PRIVATE LIMITED",
"SAI POINT AUTO MOBILES PRIVATE LIMITED",
"SAI POINT CARS PRIVATE LIMITED",
"SAI POINT FINANCE CORPORATION LIMITED",
"SAI POLYCOATS PRIVATE LIMITED",
"SAI POOJA METAL INDUSTRIES PRIVATE LIMITED",
"SAI POOJA TRAVEL WINGS PRIVATE LIMITED",
"SAI POWER AIR & REFRIGERATION COMPANY PRIVATE LIMITED",
"SAI PRAKASH SUDARSHANAM INDUSTRIES LIMIT",
"SAI PRANEET IMPEX PRIVATE. LIMITED",
"SAI PRASAD INTERNET SERVICES PRIVATE LIMITED",
"SAI PRASHANT CONSTRUCTIONS AND HOTELS PRIVATE LIMITED",
"SAI PRAVARA SHETKARI PRODUCER COMPANY LIMITED",
"SAI PRESS METAL COMPONENTS PRIVATE LIMITED",
"SAI PRIMUS LIFEBIOTECH PRIVATE LIMITED",
"SAI PRINCE INFRABUILD PRIVATE LIMITED",
"SAI PRINTO PACK PRIVATE LIMITED",
"SAI PRIYA CONSTRUCTIONS LIMITED",
"SAI PRODUCTS & GRAFIQ PRIVATE LIMITED",
"SAI PROJECTS AND ENGINEERS PRIVATE LIMITED",
"SAI PROJECTS AND SYSTEMS PRIVATE LIMITED",
"SAI PROJECTS MUMBAI PRIVATE LIMITED",
"SAI PROTEINS PVT LTD",
"SAI PVC DECOR PRIVATE LIMITED",
"SAI RADHA PHARMA INDIA PRIVATE LIMITED",
"SAI RAGHAVENDRA RICE INDUSTRIES",
"SAI RAJ EMBROIDERIES PRIVATE LIMITED",
"SAI RAJ ENTERPRISES PRIVATE LIMITED",
"SAI RAJENDRA GOLD PALACE PRIVATE LIMITED",
"SAI RAM AGRO INDUSTRIES",
"SAI RAM CHEMICALS",
"SAI RAM CONSTRUCTIONS",
"SAI RAM EDUCATIONAL CONSULTANT",
"SAI RAM FACILITY MANAGEMENT PRIVATE LIMITED",
"SAI RAM FOREX PRIVATE LIMITED",
"SAI RAM INTERNATIONAL PRIVATE LIMITED",
"SAI RAM KRISHNA CARS PRIVATE LIMITED",
"SAI RAM MATRICULATION HR SEC SCHOOL",
"SAI RAM METALS PRIVATE LIMITED",
"SAI RAM PROPERTIES PRIVATE LIMITED",
"SAI RAM STEEL PRIVATE LIMITED",
"SAI RANGA ENTERPRISES PRIVATE LIMITED",
"SAI RENIIT PROJECTS PRIVATE LIMITED",
"SAI RESOURCES PRIVATE LIMITED",
"SAI RETAIL INDIA LIMITED",
"SAI RETAIL PRIVATE LIMITED",
"SAI RISHABH BP SERVICES PRIVATE LIMITED",
"SAI RITHVIK INFRA PRIVATE LIMITED",
"SAI ROLL FORMS INDIA PRIVATE LIMITED",
"SAI ROSHNI CAPITAL PRIVATE LIMITED",
"SAI RUBBER ENGG. PRIVATE LIMITED",
"SAI RYDAM REALTORS PRIVATE LIMITED",
"SAI SADHANA SEVA FOUNDATION",
"SAI SAFETY CONSORTIUM PRIVATE LIMITED",
"SAI SAGAR RESTURANT PRIVATE LIMITED",
"SAI SAHIBA PRIVATE LIMITED",
"SAI SAMANTA SECURITY SERVICES PRIVATE LIMITED",
"SAI SAMARPAN REALTORS PRIVATE LIMITED",
"SAI SAMARTH FLEET SOLUTION PRIVATE LIMITED",
"SAI SAMARTH FOODS PRIVATE LIMITED",
"SAI SAMARTH HEALTH SOLUTIONS PRIVATE LIMITED",
"SAI SAMARTH TRADING PRIVATE LIMITED",
"SAI SAMARTH VIDHYA VIKAS SANSTHA",
"SAI SAMARTHA COSMETICS PRIVATE LIMITED",
"SAI SAMBHU AUTOMOBILES PRIVATE LIMITED",
"SAI SAMBHU INFRASTRUCTURE PRIVATE LIMITED",
"SAI SAMPADA LIFESPACES PRIVATE LIMITED",
"SAI SAMPATH PROFILES PRIVATE LIMITED",
"SAI SANNIDHI AGRO TECH",
"SAI SAROJ EQUIPMENTS PRIVATE LIMITED",
"SAI SARVA POLYMERS",
"SAI SARVAA BIOTECH PRIVATE LIMITED",
"SAI SATHYA SAI SANJEEVANI HOSPITAL",
"SAI SAWANT CONSTRUCTION AND ENGINEERS PRIVATE LIMITED",
"SAI SEAIR LOGISTICS PRIVATE LIMITED",
"SAI SECURITIES & CONSULTANTS PRIVATE LIMITED",
"SAI SECURITY PRINTERS PRIVATE LIMITED",
"SAI SECURITY SERVICES",
"SAI SEEYA COMPOSITE PRIVATE LIMITED",
"SAI SERVICE PRIVATE LIMITED",
"SAI SERVICE SPARES & ACCESSORIES PRIVATE LIMITED",
"SAI SERVICES AGENCY BOMBAY PRIVATE LIMITED",
"SAI SEVA BUSINESS SOLUTIONS PRIVATE LIMITED",
"SAI SEVA SHIPPING AGENCY PRIVATE LIMITED",
"SAI SEVAKAS MARKETING SOLUTIONS OPC PRIVATE LIMITED",
"SAI SGS ROOFINGS PRIVATE LIMITED",
"SAI SHAKTHI INFRATECH PRIVATE LIMITED",
"SAI SHAKTI DEVELOPERS AND BUILDERS PRIVATE LIMITED",
"SAI SHAKTI MAHILA TECHNICAL AND DEVELOPMENT SERVICES",
"SAI SHANKAR MANAGEMENT SERVICES PRIVATE LIMITED",
"SAI SHEET STAMPINGS PRIVATE LIMITED",
"SAI SHIPPING COMPANY PRIVATE LIMITED",
"SAI SHIV CONSTRUCTION PRIVATE LIMITED",
"SAI SHIVAM JEWELLERS PRIVATE LIMITED",
"SAI SHRADHA STEEL PROCESSORS PRIVATE LIMITED",
"SAI SHREE BALAJEE CONSTRUCTIONS & DEVELOPERS PRIVATE LIMITED",
"SAI SHREE BALAJEE HOMES PRIVATE LIMITED",
"SAI SHREEJA AUTOSALES PRIVATE LIMITED",
"SAI SHREEJA CARS PRIVATE LIMITED",
"SAI SIDDARTH RICE MILL PRIVATE LIMITED",
"SAI SIDDH TAR PRODUCTS PRIVATE LIMITED",
"SAI SIDDHARTHA HOSPITALS",
"SAI SIDDHI ASSOCIATE CONSULTANTS PRIVATE LIMITED",
"SAI SIDDHI HOSPITALITY PRIVATE LIMITED",
"SAI SIDHI SWAGAT HEALTH SERVICES PRIVATE LIMITED",
"SAI SIENA METALS PRIVATE LIMITED",
"SAI SILKS (KALAMANDIR) LIMITED",
"SAI SILVER STEEL PRIVATE LIMITED",
"SAI SIMRUN DESIGNERS PRIVATE LIMITED",
"SAI SMARAN FOODS LIMITED",
"SAI SMRUTI CONSTRUCTIONS PRIVATE LIMITED",
"SAI SNEHDEEP MEDICAL PRIVATE LIMITED",
"SAI SOLVEX PRIVATE LIMITED",
"SAI SONIA HOSPITALITY PRIVATE LIMITED",
"SAI SOUND CONTROL SYSTEMS PRIVATE LIMITED",
"SAI SPACECON INDIA PRIVATE LIMITED",
"SAI SPEED MEDICAL INSTITUTE PRIVATE LIMITED",
"SAI SPEED PUBLICATION & MEDICAL BOOKS PRIVATE LIMITED",
"SAI SPONGE INDIA LIMITED",
"SAI SPURTHI POWER PRIVATE LIMITED",
"SAI SRADHA CHEMICALS PRIVATE LIMITED",
"SAI SRADHA TRADELINK PRIVATE LIMITED",
"SAI SRAVANTHI INFRA PROJECTS PRIVATE LIMITED",
"SAI SREE WOVEN SACKS PRIVATE LIMITED",
"SAI SRI DURGA INFOTECH PRIVATE LIMITED",
"SAI SRIDHAR PHARMA PRIVATE LIMITED",
"SAI SRINIVASA BOTTLES PRIVATE LIMITED",
"SAI SRUSHTI DEVELOPERS PRIVATE LIMITED",
"SAI SRUSHTI INFRASTRUCTURE PRIVATE. LIMITED.",
"SAI STAR TELECOMMUNICATION PRIVATE LIMITED",
"SAI STEEL TREATMENT PRIVATE LIMITED",
"SAI SUBSTRATES PRIVATE LIMITED",
"SAI SUDHA INDUSTRIES",
"SAI SUDHA MOTORS PRIVATE LIMITED",
"SAI SULPHONATES PRIVATE LIMITED",
"SAI SUMANTH INFRASTRUCTURE PRIVATE LIMITED",
"SAI SUMUKHAYA PROFILES PRIVATE LIMITED",
"SAI SUPERSAND MINERALS PRIVATE LIMITED",
"SAI SUPERTEK GLOBAL PRIVATE LIMITED",
"SAI SUPREME HOLDING COMPANY PRIVATE LIMITED",
"SAI SUPREME MANUFACTURING PRIVATE LIMITED",
"SAI SURAJ INTERNATIONAL HOTELS PRIVATE LIMITED",
"SAI SURFACTANTS PRIVATE LIMITED",
"SAI SWADHIN COMMERCIALS PRIVATE LIMITED",
"SAI SWARAJYA ENTERPRISES",
"SAI SYNERGY HOSPITALS PRIVATE LIMITED",
"SAI TECH INFRA CONTRACTORS PRIVATE LIMITED",
"SAI TECH MEDICARE PRIVATE LIMITED",
"SAI TECH PHARMACEUTICALS PRIVATE LIMITED",
"SAI TECHNOLOGY PRIVATE LIMITED",
"SAI TEJA DRUGS AND INTERMIDIATES PRIVATE LIMITED",
"SAI TEJASWINI RICE INDUSTRIES PRIVATE LIMITED",
"SAI TOOLS PRIVATE LIMITED",
"SAI TRADELINK (GUJARAT) PRIVATE LIMITED",
"SAI TRANCE MARINE RESOURCES PRIVATE LIMITED",
"SAI TRIPURA TECHNO PROJECTS PRIVATE LIMITED",
"SAI TRUSTS GANESH VIDYALAY DOMBIVLI",
"SAI TUBES PRIVATE LIMITED",
"SAI URJA INDO VENTURES PRIVATE LIMITED",
"SAI UTILITY & FIRE SYSTEMS INDIA PRIVATE LIMITED",
"SAI VARDHAN ASSOCIATES PRIVATE LIMITED",
"SAI VARDHAN JUTE PRIVATE LIMITED",
"SAI VASAN SHAH FOODS PRIVATE LIMITED",
"SAI VASUDEV LOGISTICS PRIVATE LIMITED",
"SAI VEERAN AGENCIES PRIVATE LIMITED",
"SAI VEGETABLES PRIVATE LIMITED",
"SAI VENDING SERVICES PRIVATE LIMITED",
"SAI VIDEO BROADCAST PRIVATE LIMITED",
"SAI VIDHYA NIKETHAN MATRIC HR .SEC SCHOOL",
"SAI VIDYA INSTITUTE OF TECHNOLOGY",
"SAI VIKAS COATINGS PRIVATE LIMITED",
"SAI VIKASH JUNIOR COLLEGE",
"SAI WARDHA POWER GENERATION PRIVATE LIMITED",
"SAI WEBTEL TECHNOLOGIES PRIVATE LIMITED",
"SAI WORKING SOLUTIONS PRIVATE LIMITED",
"SAI WORLD TRADE LINK PRIVATE LIMITED",
"SAI YADNESH HR SOLUTIONS PRIVATE LIMITED",
"SAIAMRUT MILK PRIVATE LIMITED",
"SAIASTHA EXIM CARGO PRIVATE LIMITED",
"SAIB BRAKES PRIVATE LIMITED",
"SAIBA APPARELS LIMITED",
"SAIBA HOTELS AND PROPERTIES PRIVATE LIMITED",
"SAIBABA AGRILINK PRIVATE LIMITED",
"SAIBABA AGRO TECH PRIVATE LIMITED",
"SAIBABA CAR SALES PRIVATE LIMITED",
"SAIBABA COLLEGE",
"SAIBABA EDUCATION FOR MENTALLY CHALLENGED CHILDREN",
"SAIBABA EDUDEVELOPERS PRIVATE LIMITED",
"SAIBABA FLAME PROOF SWITCH GEARS PRIVATE LIMITED",
"SAIBABA HOSPITAL",
"SAIBABA INDUSTRIAL SERVICES PRIVATE LIMITED",
"SAIBABA INFOCOM PRIVATE LIMITED",
"SAIBABA INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"SAIBABA INFRASTRUCTURE PRIVATE LIMITED",
"SAIBABA MACHINE TOOLS (INDIA) PRIVATE LIMITED",
"SAIBABA MACHINE TOOLS PVT LTD",
"SAIBABA PIPES PRIVATE LIMITED",
"SAIBABA POLYMER TECHNOLOGIES PRIVATE LIMITED",
"SAIBABA SPAREPART AND ENGINEERS PRIVATE LIMITED",
"SAIBABA SURFACTANTS PRIVATE LIMITED",
"SAIBABA WOOD PRODUCTS P LTD",
"SAIBABA-SABOORI MOTOCORP PRIVATE LIMITED",
"SAIBALA BPO SOLUTIONS PRIVATE LIMITED",
"SAIBALAJI ENTERPRISES PRIVATE LIMITED",
"SAIBBER TECH PRIVATE LIMITED",
"SAI-BLESS HOLIDAY SERVICES PRIVATE LIMITED",
"SAIBYA STRUCTURES PRIVATE LIMITED",
"SAICHAND ELEVATORS PRIVATE LIMITED",
"SAICHARAN PROPERTIES LIMITED",
"SAICHEM COATINGS PRIVATE LIMITED",
"SAI-CHEM KRUSHI FERTILIZERS PRIVATE LIMITED",
"SAICHEM ORGANICS PRIVATE LIMITED",
"SAICO CRANES PRIVATE LIMITED",
"SAICOM INFOTECH PRIVATE LIMITED",
"SAICON SYSTEMS PRIVATE LIMITED",
"SAICON TECHNOLOGIES INDIA PRIVATE LIMITED",
"SAICON TILES PRIVATE LIMITED",
"SAICORIAN INFRASTRUCTURE PRIVATE LIMITED",
"SAICORP HEALTH TECHNOLOGIES PRIVATE LIMITED",
"SAID TECHNOLOGIES PRIVATE LIMITED",
"SAIDARSHAN MULTITRADE PRIVATE LIMITED",
"SAIDATTA BUILDCON SPECIALITIES PRIVATE LIMITED",
"SAIDATTA LOGISTICS PRIVATE LIMITED",
"SAIDATTA VIKAS HERBAL PRIVATE LIMITED",
"SAIDAX ENGINEERS AND INFRASTRUCTURES PRIVATE LIMITED",
"SAIDEEP ALLOYS EXTRUSION PRIVATE LIMITED",
"SAIDEEP AUTOMOBILES PRIVATE LIMITED",
"SAIDEEP CARS PRIVATE LIMITED",
"SAIDEEP FEEDS PRIVATE LIMITED",
"SAIDEEP FOAM PRIVATE LIMITED",
"SAIDEEP HEALTHCARE AND RESEARCH PRIVATE LIMITED",
"SAIDEEP PLASTICS PRIVATE LIMITED",
"SAIDHAM MERCANTILE PVT LTD",
"SAIDHAM OVERSEAS PRIVATE LIMITED",
"SAIDI VALUE SOURCING PRIVATE LIMITED",
"SAIDIGITAL AGENCY PRIVATE LIMITED",
"SAIDRISTI SUITINGS PRIVATE LIMITED",
"SAIDUTT REAL INFRA PRIVATE LIMITED",
"SAIEASH ENGINEERING WORKS PRIVATE LIMITED",
"SAIEESH DATA SYSTEMS PRIVATE LIMITED",
"SAIEKNAAM INFRATECH PRIVATE LIMITED",
"SAIEN WELDS PRIVATE LIMITED",
"SAIESHA DEVELOPMENTS PRIVATE LIMITED",
"SAIEX FLAMEPROOF EQUIPMENTS PRIVATE LIMITED",
"SAIF CARPETS PRIVATE LIMITED",
"SAIF CHEMICALS PRIVATE LIMITED",
"SAIF HEALTH REMEDIES PRIVATE LIMITED",
"SAIF STEEL ENGINEERING WORKS PRIVATE LIMITED",
"SAIF SUPPLIERS PRIVATE LIMITED",
"SAIFCO CEMENTS PRIVATE LIMITED",
"SAIFCO HILLCREST HOTELS PRIVATE LIMITED",
"SAIFE VETMED PRIVATE LIMITED",
"SAIFEE BURHANI UPLIFTMENT TRUST",
"SAIFEE HOSPITAL",
"SAIFI BUILDING SOLUTIONS PRIVATE LIMITED",
"SAIFI BUILDWELL INDIA PRIVATE LIMITED",
"SAIFI CON-FAB SYSTEM PRIVATE LIMITED",
"SAIFI INTERIORS PRIVATE LIMITED",
"SAIFIN IMPEX PRIVATE LIMITED",
"SAIGAL SEA TRADE P LIMITED",
"SAIGAL SEATRADE ADVISORY LLP",
"SAIGOLD INDUSTRIES INDIA PRIVATE LIMITED",
"SAIGON IMPORT & EXPORT PRIVATE LIMITED",
"SAIGON INFRATECH PRIVATE LIMITED",
"SAIGON SHIPPING PRIVATE LIMITED",
"SAIGRACE LOGISTICS PRIVATE LIMITED",
"SAIGUN TECHNOLOGIES PRIVATE LIMITED",
"SAIGURU REALTORS PRIVATE LIMITED",
"SAIGURU STONE INDUSTRIES PRIVATE LIMITED",
"SAIHER SUPPLY CHAIN CONSULTING PRIVATE LIMITED",
"SAIHYANDRI ENERGY SERVICES PRIVATE LIMITED",
"SAII INFO-ACT PRIVATE LIMITED",
"SAIIRON ENGINEERING PRIVATE LIMITED",
"SAIJA FINANCE PRIVATE LIMITED",
"SAIJET FLUIDS & MACHINERY PRIVATE LIMITED",
"SAIJYOTI DYEING AND PRINTING MILLS PRIVATE LIMITED",
"SAIJYOTI PLANTATIONS PRIVATE LIMITED",
"SAIKA MARITIME PRIVATE LIMITED",
"SAIKARAN PLAST PRIVATE LIMITED",
"SAIKAWACH INFRATECH PRIVATE LIMITED",
"SAIKIA AUTO PRIVATE LIMITED",
"SAIKIA DEVELOPERS PRIVATE LIMITED",
"SAIKIRPA ICE AND COLD STORAGE PRIVATE LIMITED",
"SAIKRIPA FOODS SERVICES MUMBAI PRIVATE LIMITED",
"SAIKRIPA FOODS SERVICES PRIVATE LIMITED",
"SAIKRIPA IMPEX PRIVATE LIMITED",
"SAIKRISHANA INFRA PRODUCTS PRIVATE LIMITED",
"SAIKRISHNA AND ASSOCIATES",
"SAIKRISHNA DELICACIES PRIVATE LIMITED",
"SAIKRISHNA HOMES PRIVATE LIMITED",
"SAIKRISHNA INFRABUILD PRIVATE LIMITED",
"SAIKRUPA AGRO PROCESSORS PRIVATE LIMITED",
"SAIKRUPA COTGIN LIMITED",
"SAIKRUPA COTTONS PRIVATE. LIMITED.",
"SAIKRUPA FABRICS PRIVATE LIMITED",
"SAIKRUPA FIBRES PRIVATE LIMITED",
"SAIKRUPA PHOTO OFFSET PRIVATE LIMITED",
"SAIKRUPA PROJECTS PRIVATE LIMITED",
"SAIKRUPA SUPER MARKET PRIVATE LIMITED",
"SAIKRUTHI MINMET (INDIA) PRIVATE LIMITED",
"SAIKUMAR VALVES & COCKS PRIVATE LIMITED",
"SAIL ANALYTICS LLP",
"SAIL BANSAL SERVICE CENTRE LIMITED",
"SAIL INTERLINK XPRESS PRIVATE LIMITED",
"SAIL REFRACTORY COMPANY LIMITED",
"SAILABALA INFRASTRUCTURE PRIVATE LIMITED",
"SAILAJA COMMERCIAL CONSTRUCTION PRIVATE LIMITED",
"SAILANI TOURS N TRAVELS LIMITED",
"SAI-LEE ELECTROTEKNIKS PRIVATE LIMITED",
"SAILEELA AMMONIA AND CHEMICALS PVT LTD",
"SAILEELA PROCESSORS PRIVATE LIMITED",
"SAILEELA SYNTHETICS PRIVATE. LIMITED.",
"SAILEEN TECHNOCRATS PRIVATE LIMITED",
"SAILESH CEMENT UDYOG PRIVATE LIMITED",
"SAILESH GUNNY TRADERS",
"SAILESH INFORMATION TECHNOLOGY PRIVATE LIMITED",
"SAILOR AGRO PRIVATE LIMITED",
"SAILOR EXPORTS LIMITED",
"SAILORDS FREIGHT PRIVATE LIMITED",
"SAILOTECH PRIVATE LIMITED",
"SAILPOINT TECHNOLOGIES INDIA PRIVATE LIMITED",
"SAIL-RITES BENGAL WAGON INDUSTRY PRIVATE LIMITED",
"SAILS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"SAIMA AUTOMOBILES",
"SAIMA IMPEX PVT LTD",
"SAIMA INVESTMENTS PRIVATE LIMITED",
"SAIMA MEDI SERVICES PRIVATE LIMITED",
"SAIMAA TECHNOLOGIES",
"SAIMACH PHARMATECH PRIVATE LIMITED",
"SAIMAN HEALTHCARE PRIVATE LIMITED",
"SAIMAR CONTAINERS PRIVATE LIMITED",
"SAIMAX CERAMIC PRIVATE LIMITED",
"SAIMCO INFRATECH PRIVATE LIMITED",
"SAIMEX EXIM PRIVATE LIMITED",
"SAIMIRRA INNOPHARM PRIVATE LIMITED",
"SAIMONA COMPRESSOR LIMITED",
"SAIN BROS & ASSOCIATES PRIVATE LIMITED",
"SAIN MEDICAMENTS PRIVATE LIMITED",
"SAIN PACKAGING PRIVATE LIMITED",
"SAINA LIFESTYLES LIMITED",
"SAINATH AGENCIES (PHARMA) PRIVATE LIMITED",
"SAINATH AGRICULTURE PRIVATE LIMITED",
"SAINATH AGRIEZONE TRADING CENTER PRIVATE LIMITED",
"SAINATH AUTOHUB PRIVATE LIMITED",
"SAINATH AUTOLINKS PRIVATE LIMITED",
"SAINATH AVIOTECHNICS PRIVATE LIMITED",
"SAINATH COLLEGE OF PHARMACY",
"SAINATH EARTH MOVERS PRIVATE LIMITED",
"SAINATH EXPRESS SERVICE PRIVATE LIMITED",
"SAINATH GRAIN TRADERS PRIVATE LIMITED",
"SAINATH HIGH SCHOOL ADEGAON",
"SAINATH IN ENTERTAINMENT PRIVATE LIMITED",
"SAINATH INDUSTRIAL FUELS PRIVATE LIMITED",
"SAINATH INTERNATIONAL PRIVATE LIMITED",
"SAINATH KNITEX PRIVATE LIMITED",
"SAINATH LOGISTICS PRIVATE LIMITED",
"SAINATH METALS & ALLOYS PRIVATE LIMITED",
"SAINATH MINES AND MINERALS PRIVATE LIMITED",
"SAINATH MULTYSTATE CO OPERATIVE CREDIT SOCIETY LTD",
"SAINATH PLASTOCHEM PRIVATE LIMITED",
"SAINATH PRINTPACK PRIVATE LIMITED",
"SAINATH SALES AND SERVICES PRIVATE LIMITED",
"SAINATH SOLAR ENERGY PRIVATE LIMITED",
"SAINATH STRUCTURES PRIVATE LIMITED",
"SAINATH TRADING COMPANY PRIVATE LIMITED",
"SAINATH WIRES PRIVATE LIMITED",
"SAINCE HEALTHTECH PRIVATE LIMITED",
"SAINCE TECHNOLOGY SERVICES PRIVATE LIMITED",
"SAINDIA RESOURCES PRIVATE LIMITED",
"SAINEE COTFAB PRIVATE LIMITED",
"SAINEE SYNTHETICS PRIVATE LIMITED",
"SAINEERAJ CONSTRUCTIONS (INDIA) PRIVATE LIMITED",
"SAINERGIE CONSULTANTS PRIVATE LIMITED",
"SAINERGY FUEL CELL INDIA PRIVATE LIMITED",
"SAINEST TUBES PRIVATE LIMITED",
"SAINI AGRO AND INFRA PRIVATE LIMITED",
"SAINI ALLOYS LIMITED",
"SAINI BRAKE SYSTEM PRIVATE LIMITED",
"SAINI COLD STORAGE PRIVATE LIMITED",
"SAINI COMMUNICATIONS PRIVATE LIMITED",
"SAINI CONCRETE SYSTEMS PRIVATE LIMITED",
"SAINI CRANE SERVICE PRIVATE LIMITED",
"SAINI DEVELOPERS AND PROMOTERS PRIVATE LIMITED",
"SAINI DIESAL POWER SERVICE PRIVATE LIMITED",
"SAINI EARTHMOVER PRIVATE LIMITED",
"SAINI ELECTRICAL & ENGINEERING WORKS",
"SAINI ESTATES AND DEVELOPERS PRIVATE LIMITED",
"SAINI FLANGE PRIVATE LIMITED.",
"SAINI HEALTHCARE PRIVATE LIMITED",
"SAINI HEAVY ELECTRICAL AND ENGINEERING CO PRIVATE PTD",
"SAINI INDIA LIMITED",
"SAINI INDIA PRIVATE LIMITED",
"SAINI KANGRA AUTOMOBILES PRIVATE LIMITED",
"SAINI MULTI EQUIPMENT PRIVATE LIMITED",
"SAINI POLYMERS PVT LTD",
"SAINI RETAIL PRIVATE LIMITED",
"SAINI SEMI CONDUCTORS PRIVATE LIMITED",
"SAINI TECHNO CONSTRUCTS PRIVATE LIMITED",
"SAINI TRAVELS PRIVATE LIMITED",
"SAINI UDYOG PRIVATE LIMITED",
"SAINIK FINANCE & INDUSTRIES LIMITED",
"SAINIK INDUSTRIES PRIVATE LIMITED",
"SAINIK INFRATEC PRIVATE LIMITED",
"SAINIK INTELLIGENCE AND SECURITY PRIVATE LIMITED",
"SAINIK LIFESTYLE PRIVATE LIMITED",
"SAINIK MINING (INDIA) PRIVATE LIMITED",
"SAINIK MINING AND ALLIED SERVICES LIMITED",
"SAINIK SCHOOL SATARA",
"SAINIK SCHOOL BALACHADI",
"SAINIK SCHOOL CHANDRAPUR",
"SAINIK SCHOOL KAPURTHALA",
"SAINIK TEXTILE MILLS PRIVATE LIMITED",
"SAINIK WELFARE CO-OPERATIVE SOCIETY KARNATAKA LTD",
"SAINIK WELFARE OFFCE SATARA",
"SAINIMADHUR VYANJAN PRIVATE LIMITED",
"SAINI'S HOTELS & DEVELOPERS PRIVATE LIMITED",
"SAINIT INFRATEL PRIVATE LIMITED",
"SAINKA CONSTRUCTIONS PRIVATE LIMITED",
"SAINMARKS INDUSTRIES (INDIA) PRIVATE LIMITED",
"SAINO FIRST NETWORK PRIVATE LIMITED",
"SAINO PEN & PLASTIC PRIVATE LIMITED",
"SAINOOR AUTOMOBILES PRIVATE LIMITED",
"SAINOR LABORATORIES PRIVATE LIMITED",
"SAINOR LIFE SCIENCES PRIVATE LIMITED",
"SAINOR PHARMA PRIVATE LIMITED",
"SAINSBURY'S ARGOS ASIA LIMITED",
"SAINSONS PAPER INDUSTRIES PRIVATE LIMITE D",
"SAINT FRANCIS DE SALES COLLEGE",
"SAINT G LEATHER STUDIO PRIVATE LIMITED",
"SAINT GOBAIN GYPROC INDIA LIMITED",
"SAINT GOBAIN INDIA FOUNDATION",
"SAINT GOBAIN INDIA PRIVATE LIMITED",
"SAINT GOBAIN SEKURIT INDIA LIMITED",
"SAINT KABIR CONSTECH PRIVATE LIMITED",
"SAINT SAINT SOLDIER ENGINEERS AND CONTRACTORS PRIVATE LIMITED",
"SAINT SOLDIER EDUCATIONAL SOCIETY",
"SAINT VIVEKANAND SR SEC PUBLIC SCHOOL",
"SAINT-GOBAIN INDUSTRIES INDIA PRIVATE LIMITED",
"SAINTLIFE PHARMACEUTICALS LIMITED",
"SAINUM MEDISCIENCES PRIVATE LIMITED",
"SAINYA CITY PRIVATE LIMITED",
"SAINYODIGI OVERSEAS PRIVATE LIMITED",
"SAIOM SANITATORS AND PLASTICS PRIVATE LIMITED",
"SAION MULTISPECIALITY HOSPITAL & ICU",
"SAIPATH EDUCATION & FILM SERVICES PRIVATE LIMITED",
"SAIPAVANI CONSTRUCTIONS INDIA PVT LTD",
"SAIPEM INDIA PROJECTS PRIVATE LIMITED",
"SAIPER CHEMICALS PRIVATE LIMITED",
"SAIPRABHA STRATEGIC MANAGEMENT PRIVATE LIMITED",
"SAIPRASAD ENGINEERS P LTD",
"SAIPRASHANTH ENGINEERING & INFRASTRUCTURE PRIVATE LIMITED",
"SAIPREM AIRCONDITIONING PRIVATE LIMITED",
"SAIPRIYA BANGALORE AGENCIES PRIVATE LIMITED",
"SAIPRIYA INFOSOLUTION PRIVATE LIMITED",
"SAIPRIYAAYA FOODS PRODUCTS PRIVATE LIMITED",
"SAIPRO BIOTECH PRIVATE LIMITED",
"SAIPRO INDUSTRIES PRIVATE LIMITED",
"SAIPURAM WIND ENERGIES PRIVATE LIMITED",
"SAIRA ASIA INTERIORS PRIVATE LIMITED",
"SAIRADHA HOTEL PRIVATE LIMITED",
"SAIRAJ LOGISTICS PRIVATE LIMITED",
"SAIRAJ LUMIZON PRIVATE LIMITED",
"SAIRAJ PAPER PRODUCTS PRIVATE LIMITED",
"SAIRAJ PATIL",
"SAIRAJ TECHINFRA PRIVATE LIMITED",
"SAIRAJ TRADES PRIVATE LIMITED",
"SAIRAJA FRUIT AND FOOD PROCESSINGS PRIVATE LIMITED",
"SAIRAKSHA DAIRY PRODUCTS PRIVATE LIMITED",
"SAIRAM AUTOMOBILES & SERVICES PRIVATE LIMITED",
"SAIRAM BOILER ENGINEERS PRIVATE LIMITED",
"SAIRAM ENGINEERING SERVICES INDIA PRIVATE LIMITED",
"SAIRAM GROUP OF COMPANY",
"SAIRAM KRIPA EDUCATIONAL SERVICES PRIVATE LIMITED",
"SAIRAM SEEDS PRIVATE LIMITED",
"SAIRAM TECHNO MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"SAIRAM WHEELS PRIVATE LIMITED",
"SAIRUDRAM INFRACON PRIVATE LIMITED",
"SAIRUNG DEVELOPERS AND PROMOTERS PRIVATE LIMITED",
"SAIS IT SERVICES INDIA PRIVATE LIMITED",
"SAIS STAFFING SOLUTIONS PRIVATE LIMITED",
"SAISAHARA INFRA & FACILITY PRIVATE LIMITED",
"SAISAMADHAN MARK VENTURES LIMITED",
"SAISAMARTH POLYTECH PRIVATE LIMITED",
"SAISAMAYAPURA INFRASTRUCTURE PRIVATE LIMITED",
"SAISANATAN AUTOMOBILES PRIVATE LIMITED",
"SAISANJ RETAIL PRIVATE LIMITED",
"SAISANKET AUTOMATION PRIVATE LIMITED",
"SAISANKET INDUSTRIES PRIVATE LIMITED",
"SAISATYAM RESOURCE MANAGEMENT PRIVATE LIMITED",
"SAISEVA BIOTECH PRIVATE LIMITED",
"SAISH HEALTH & FITNESS PRIVATE LIMITED",
"SAISH METAFLOW PRIVATE LIMITED",
"SAISHA APPARRELS PRIVATE LIMITED",
"SAISHA AUTO PRIVATE LIMITED",
"SAISHA CHEM PRIVATE LIMITED",
"SAISHA ENTERPRISES PRIVATE LIMITED",
"SAISHA FOODS PRIVATE LIMITED",
"SAISHA HOMES PRIVATE LIMITED",
"SAISHA INFOTECH PRIVATE LIMITED",
"SAISHA INFRA PROJECTS LIMITED",
"SAISHA INFRA PROJECTS PRIVATE LIMITED",
"SAISHA MOTORS PRIVATE LIMITED",
"SAISHAKTI INFRASTRUCTURE PVT LTD",
"SAISHAKTI KRAFT PAPERS PRIVATE LIMITED",
"SAISHAKTI POLYSACKS PRIVATE LIMITED",
"SAISHANKAR SEA FOODS PRIVATE LIMITED",
"SAISHIRAJ ENTERPRISES PRIVATE LIMITED",
"SAISHIV BOARDS AND TOPS PRIVATE LIMITED",
"SAISHIVAY AUTOCOMP SYSTEMS PRIVATE LIMITED",
"SAISHRADHA INFRACON (INDIA) PRIVATE LIMITED",
"SAISHRAVAN GLOBAL EDUCATION",
"SAISHRUTI INDUSTRIES PRIVATE LIMITED",
"SAISIDDHI CLEARING AND FORWARDING PRIVATE LIMITED",
"SAISIDDI ENGINEERING TEK PRIVATE LIMITED",
"SAISIDHA FACILITIES PRIVATE LIMITED",
"SAISIDHA SUGAR EQUIPMENTS AND ENGINEERING COMPANY PRIVATE LIMITED",
"SAISON OMNI INDIA PRIVATE LIMITED",
"SAISRISTI ENDEAVOURS PRIVATE LIMITED",
"SAISRUSHTI (KENGERI) PROJECTS PRIVATE LIMITED",
"SAISRUSHTI BUILDERS PRIVATE LIMITED",
"SAISRUSHTI LAKSHMIPURA-1 DEVELOPMENTS PRIVATE LIMITED",
"SAISUBHASHREE SCAFFOLDING PRIVATE LIMITED",
"SAISUMAN AUTO COMPONENTS PRIVATE LIMITED",
"SAISUN OUTSOURCING SERVICES PRIVATE LIMITED",
"SAISUN PHARMA PRIVATE LIMITED",
"SAISURYA EYE CARE PRIVATE LIMITED",
"SAISURYA PARABOILED (INDIA) PRIVATE LIMITED",
"SAISURYA PROFESSIONAL SERVICES PRIVATE LIMITED",
"SAISWARAM TRADELINKS PRIVATE LIMITED",
"SAISWARNA AUTOMOBILES PRIVATE LIMITED",
"SAISYSTEMS HEALTH TECH PRIVATE LIMITED",
"SAISYSTEMS TECHNOLOGY PRIVATE LIMITED",
"SAIT NAGJEE PURUSHOTHAM AND COMPANY PRIVATE LIMITED",
"SAIT TEKNIK PRIVATE LIMITED",
"SAITECH ELECTRICAL PRIVATE LIMITED",
"SAITECH FIRE SYSTEMS PRIVATE LIMITED",
"SAITECH INSTRUMENTS PRIVATE LIMITED",
"SAITECH MANPOWER SERVICES PRIVATE LIMITED",
"SAITECH MEDICARE PRIVATE. LIMITED.",
"SAITEJA SOLVENT AND FOOD PRODUCTS INDUSTRIES PRIVATE LIMITED",
"SAITEJASWINI CHIT FUNDS (VIZAG) PRIVATE LIMITED",
"SAITEK PAINTS PRIVATE LIMITED",
"SAI-TRAYS HEALTHCARE PRIVATE LIMITED",
"SAITRISHA INFRAENGINEERS PRIVATE LIMITED",
"SAITRON ENGINEERS PRIVATE LIMITED",
"SAITRONIC INFOTECH PRIVATE LIMITED",
"SAITRONICS SYSTEMS PRIVATE LIMITED",
"SAITRONIX ELECTRO DRIVES PRIVATE LIMITED",
"SAIVA SYSTEM INDIA PRIVATE LIMITED",
"SAIVANA EXPORTS PRIVATE LIMITED",
"SAIVANI RMC PRIVATE LIMITED",
"SAIVED PHARMA PRIVATE LIMITED",
"SAIVEK TECNIQ PRIVATE LIMITED",
"SAIVEN DEVELOPERS AND CONSTRUCTIONS PRIVATE LIMITED",
"SAIVENKATARANGA AGRO PRIVATE LIMITED",
"SAIVI FINANCE PRIVATE LIMITED",
"SAIVI SEEDS PRIVATE LIMITED",
"SAIVILLA DREAMHOUSE PRIVATE LIMITED",
"SAIVION OUTSOURCING SERVICES PRIVATE LIMITED",
"SAIVISION CHEM INDIA PRIVATE LIMITED",
"SAIVYA ENGINEERING PRIVATE LIMITED (OPC)",
"SAIWIN CERAMIC PRIVATE LIMITED",
"SAIYA SOFTWARE PRIVATE LIMITED",
"SAIYED PAPER MILLS LIMITED",
"SAIYOG IMPEX PRIVATE LIMITED",
"SAIYOG PHARMA SURGICAL PRIVATE LIMITED",
"SAIYU INDIA PRIVATE LIMITED",
"SAIZ ENGINEERS PRIVATE LIMITED",
"SAIZAR ENTERPRISE PRIVATE LIMITED",
"SAJ ALUMINIUM PRIVATE LIMITED",
"SAJ ELECTRONICS PRIVATE LIMITED",
"SAJ FOOD PRODUCTS PRIVATE LIMITED",
"SAJ HOTELS LIMITED",
"SAJ INDUSTRIES PRIVATE LIMITED",
"SAJ INFRACON PROJECT INDIA LIMITED",
"SAJ JEWELLERY PRIVATE LIMITED",
"SAJ MARKETING PVT LTD",
"SAJ PROPACK PRIVATE LIMITED",
"SAJ TEST PLANT PRIVATE LIMITED",
"SAJA IMPEX PRIVATE LIMITED",
"SAJAA CHEMICALS PRIVATE LIMITED",
"SAJAAWAT APPLIANCES AND ENGINEERING PRIVATE LIMITED",
"SAJAG SECURITIES PRIVATE LIMITED",
"SAJAN ENGINEERING WORKS PRIVATE LIMITED",
"SAJAN INTERNATIONAL PVT LTD",
"SAJAN OVERSEAS PRIVATE LIMITED",
"SAJAN TELEMATICS PVT LTD",
"SAJAWAT BUSINESS PRIVATE LIMITED",
"SAJAWAT MODULAR FURNITURE PRIVATE LIMITED",
"SAJAY SHIPPING AND CLEARING PRIVATE LIMITED",
"SAJBEN PLAST FILMS PRIVATE LIMITED",
"SAJDHAJ MARRIAGE DECORATORS PRIVATE LIMITED",
"SAJEELEE CREATION PRIVATE LIMITED",
"SAJITH AND SUJITH SALON PRIVATE LIMITED",
"SAJJALA BIO LABS PRIVATE LIMITED",
"SAJJALA WOVEN SACKS PRIVATE LIMITED",
"SAJJAN APPARELS PRIVATE LIMITED",
"SAJJAN CREATIONS PRIVATE LIMITED",
"COHIZON LIFE SCIENCES LIMITED",
"SAJJAN LAW COLLEGE PALI",
"SAJJAN MARBLES PRIVATE LIMITED",
"SAJJAN SALES PRIVATE LIMITED",
"SAJM BRAND HUB PRIVATE LIMITED",
"SAJM INDUSTRIES PRIVATE LIMITED",
"SAJNEE PRINTS PRIVATE LIMITED",
"SAJO JEWELS PRIVATE LIMITED",
"SAJO POLYTEK PRIVATE LIMITED",
"SAK BUILDTECH PRIVATE LIMITED",
"SAK FOREX MARKETS PRIVATE LIMITED",
"SAK INDUSTRIES PRIVATE LIMITED",
"SAK WEBSOLUTION PRIVATE LIMITED",
"SAKA COATERS PRIVATE LIMITED",
"SAKA EMBROIDERY PRIVATE LIMITED",
"SAKA ENGINEERING SYSTEMS PRIVATE LIMITED",
"SAKAAR CORPORATE SERVICES PRIVATE LIMITED",
"SAKAE RIKEN POLYPLASTICS INDIA PRIVATE LIMITED",
"SAKAL MEDIA PRIVATE LIMITED",
"SAKAL MONEY ADVISORY PRIVATE LIMITED",
"SAKAL PAPER PRIVATE LIMITED",
"SAKALA MEDIA PRIVATE LIMITED",
"SAKAM TRADING PRIVATE LIMITED",
"SAKAMBARI AGENCIES PRIVATE LIMITED",
"SAKAMBARI CORDAGE CO PRIVATE LIMITED",
"SAKAMBARI FLOUR MILLS PRIVATE LIMITED",
"SAKAMBARI PACKAGING PRODUCTS PVT LTD",
"SAKAMBARI PROCESSORS PRIVATE LIMITED",
"SAKAMBARI SILK MILLS PRIVATE LIMITED",
"SAKAMBARI SOLVEX PRIVATE LIMITED",
"SAKAMBHARI MARKETING PRIVATE LIMITED",
"SAKAMBHARI PROCESSORS PRIVATE LIMITED",
"SAKAMOTO HOSPITALITY PRIVATE LIMITED",
"SAKANA BHARAT TOY CANDY PRIVATE LIMITED",
"SAKAR AGRISCIENCE PRIVATE LIMITED",
"SAKAR BUSINESS MANAGEMENT PRIVATE LIMITED",
"SAKAR ELECTRICALS & ELECTRONICS PRIVATE LIMITED",
"SAKAR ENGITECH PRIVATE LIMITED",
"SAKAR ENGLISH SCHOOL",
"SAKAR GLAZETECH PRIVATE LIMITED",
"SAKAR GRANITO INDIA PRIVATE LIMITED",
"SAKAR HEALTHCARE LIMITED",
"SAKAR INDIA PRIVATE LIMITED",
"SAKAR INDUSTRIES LIMITED.",
"SAKAR INNOVATIONS PRIVATE LIMITED",
"SAKAR INTERNATIONAL PRIVATE LIMITED",
"SAKAR MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"SAKAR METAL AND TOOLS PRIVATE LIMITED",
"SAKAR PACKS PRIVATE LIMITED",
"SAKAR PLAZA PVT LTD",
"SAKAR RUB-TECH PRIVATE LIMITED",
"SAKARA AGRO FOOD PRIVATE LIMITED",
"SAKARDA SYNTHETICS PRIVATE LIMITED",
"SAKARIA FASHION INDIA PRIVATE LIMITED",
"SAKARIA TEX-INDIA PRIVATE LIMITED",
"SAKARIYA DEVELOPERS PRIVATE LIMITED",
"SAKARIYA SYNTHETICS PRIVATE LIMITED",
"SAKARNI PLASTER (INDIA) PRIVATE LIMITED",
"SAKART COMMERCIALS PRIVATE LIMITED",
"SAKASH APPLIANCES PRIVATE LIMITED",
"SAKASH FINANCIAL SERVICES PRIVATE LIMITED",
"SAKASH INFOTECH PRIVATE LIMITED",
"SAKASH RESOURCES MANAGEMENT PRIVATE LIMITED",
"SAKASH TRADEMART MARKETING PRIVATE LIMITED",
"SAKATA INX INDIA PRIVATE LIMITED",
"SAKATA SEED INDIA PRIVATE LIMITED",
"SAKAYE INFOTECH PRIVATE LIMITED",
"SAKAZAKI ENGRAVING INDIA PRIVATE LIMITED",
"SAKCHAM INFRAVENTURES PRIVATE LIMITED",
"SAKEE SOFT PRIVATE LIMITED",
"SAKET ADVERTISING PRIVATE LIMITED",
"SAKET APARTMENTS PVT LTD",
"SAKET AUTOWHEELS PRIVATE LIMITED",
"SAKET CITY HOSPITALS PRIVATE LIMITED",
"SAKET COLLEGE OF ARTS SCIENCE AND COMMERCE",
"SAKET COMMUNICATIONS PRIVATE LIMITED",
"SAKET ENGINEERING SOLUTIONS PRIVATE LIMITED",
"SAKET ENGINEERS PRIVATE LIMITED",
"SAKET FABS PRIVATE LIMITED",
"SAKET FOODS PRIVATE LIMITED",
"SAKET HOSPITAL",
"SAKET HOTELS PRIVATE LIMITED",
"SAKET INDUSTRIAL GASES LTD",
"SAKET INFRADEVELOPERS PRIVATE LIMITED",
"SAKET INFRAPORJECTS LIMITED",
"SAKET INFRAPROJECTS PRIVATE LIMITED",
"SAKET INTERIORS PRIVATE LIMITED",
"SAKET MEDICARE AND RESEARCH CENTRE PRIVATE LIMITED",
"SAKET METAL TECHNOCRAFT PRIVATE LIMITED",
"SAKET MOTORS PRIVATE LIMITED",
"SAKET OFFICE STATIONERY MFG CO PVT LTD",
"SAKET OVERSEAS PRIVATE LIMITED",
"SAKET PRAKASHAN PRIVATE LIMITED",
"SAKET PROJECTS LIMITED",
"SAKET PROJECTS LTD",
"SAKET PROMOTERS LIMITED",
"SAKET ROAD CARRIERS PRIVATE LIMITED",
"SAKET TEX-DYE PRIVATE.LIMITED",
"SAKET TREXIM PRIVATE LIMITED",
"SAKET VINCOM PRIVATE LIMITED",
"SAKETA PACKAGING INDUSTRIES PRIVATE LIMITED",
"SAKETH SEVEN STAR INDUSTRIES LIMITED",
"SAKHA CONSULTING WINGS PRIVATE LIMITED",
"SAKHA ENGINEERS PRIVATE LIMITED",
"SAKHA MINERALS LIMITED",
"SAKHARAM SHETH VIDYALAY",
"SAKHATECH INFORMATION SYSTEMS PRIVATE LIMITED",
"SAKHI BARTER PVT LTD",
"SAKHI ENGINEERS PRIVATE LIMITED",
"SAKHI FASHION PRIVATE LIMITED",
"SAKHI MAHILA MILK PRODUCER COMPANY LIMITED",
"SAKHI4LIFE HEALTHCARE PRIVATE LIMITED",
"SAKHIDAMODAR COLD STORAGE PRIVATE LIMITED",
"SAKHIGOPAL INTEGRATED POWER COMPANY LIMITED",
"SAKHILAL LAMINATES PRIVATE LIMITED",
"SAKHIYA SKIN CLINIC LIMITED",
"SAKHIYA SKIN CLINIC PRIVATE LIMITED",
"SAKHYATHA POLYMERS PRIVATE LIMITED",
"SAKI AUTO PRODUCTS PRIVATE LIMITED",
"SAKIMAH FOOD INDUSTRIES PRIVATE LIMITED",
"SAKKARDARA MULTI SPECIALITY HOSPITAL",
"SAKKARDARA P S SKD NAGPUR",
"SAKKARGIS METRO PRIVATE LIMITED",
"SAKLECHA SOLVENTEX PRIVATE. LIMITED.",
"SAKORE CONSTRUCTIONS PVT LTD",
"SAKRA POWER CONTROLS PRIVATE LIMITED",
"SAKRAIMATA COMMERCIAL PRIVATE LIMITED",
"SAKRAT TEXFAB PRIVATE LIMITED",
"SAKRIYA TECHNOLOGIES PRIVATE LIMITED",
"SAKS ANCILLARIES LIMITED",
"SAKS EQUIPMENTS PRIVATE LIMITED",
"SAKS FASHION PRIVATE LIMITED",
"SAKS HOSPITALITY PRIVATE LIMITED",
"SAKSHALPIMPRI HIGHSCHOOL SAKSHAL PIMPRI BEED",
"SAKSHAM ANALYTICAL INSTRUMENTS PRIVATE LIMITED",
"SAKSHAM BRANDING SERVICES PRIVATE LIMITED",
"SAKSHAM CONNECT PRIVATE LIMITED",
"SAKSHAM CONTAINERS PRIVATE LIMITED",
"SAKSHAM CORPORATE SERVICES PRIVATE LIMITED",
"SAKSHAM DIAGNOSTIC PRIVATE. LIMITED",
"SAKSHAM EMARKET PRIVATE LIMITED",
"SAKSHAM FACILITY SERVICES PRIVATE LIMITED",
"SAKSHAM GRAM CREDIT PRIVATE LIMITED",
"SAKSHAM IMPEX PRIVATE LIMITED",
"SAKSHAM INFRA SOLUTION PRIVATE LIMITED",
"SAKSHAM INFRABUILDTECH PRIVATE LIMITED",
"SAKSHAM OFFICE AUTOMATION PRIVATE LIMITED",
"SAKSHAM PROMOTERS INDIA PRIVATE LIMITED",
"SAKSHAM SCHOOL WARDHA",
"SAKSHAM SCIENTIFIC INSTRUMENTS PRIVATE LIMITED",
"SAKSHAM SECURITY SOLUTIONS PRIVATE LIMITED",
"SAKSHAM SIGNS PRIVATE LIMITED",
"SAKSHAM SOCIETY",
"SAKSHAM TECHNOLOGIES PRIVATE LIMITED",
"SAKSHAM WEALTH PRIVATE LIMITED",
"SAKSHATH TECHNOLOGIES PRIVATE LIMITED",
"SAKSHEM EXIM PRIVATE LIMITED",
"SAKSHEM IT SOLUTION PRIVATE LIMITED",
"SAKSHI AUTO PARTS PVT LTD",
"SAKSHI AUTOMATION SOLUTION PRIVATE LIMITED",
"SAKSHI CABS INDIA PRIVATE LIMITED",
"SAKSHI CHEM SCIENCES PRIVATE LIMITED",
"SAKSHI COMMERCIAL PVT.LTD.",
"SAKSHI DESHMUKH INSTITUTE OF NURSING LOHARA YAVATMAL",
"SAKSHI EDUCATION CONSULTING AND TRAINING PRIVATE LIMITED",
"SAKSHI ENTERPRISES",
"SAKSHI ENTERPRISES PRIVATE LIMITED",
"SAKSHI FINCAP PRIVATE LIMITED",
"SAKSHI FOOTWEAR PRIVATE LIMITED",
"SAKSHI HEIGHTS PRIVATE LIMITED",
"SAKSHI INFOWAY PRIVATE LIMITED",
"SAKSHI INFRATECH PRIVATE LIMITED",
"SAKSHI INNOVATIONS PRIVATE LIMITED",
"SAKSHI INSTITUTE OF MARITIME FOUNDATION",
"SAKSHI INTERNATIONAL PRIVATE LIMITED",
"SAKSHI LINGERIES PRIVATE LIMITED",
"SAKSHI MANGLAM BUSINESSES PRIVATE LIMITED",
"SAKSHI MARKFIN PRIVATE LIMITED",
"SAKSHI PACKERS PRIVATE LIMITED",
"SAKSHI PHARMACEUTICALS PRIVATE LIMITED",
"SAKSHI PROPERTY CONSULTANTS PRIVATE LIMITED",
"SAKSHI RESOURCES PRIVATE LIMITED",
"SAKSHI ROADLINES PRIVATE LIMITED",
"SAKSHI SECURITY AND INFRA SERVICES PRIVATE LIMITED",
"SAKSHI TRADING PRIVATE LIMITED",
"SAKSHI TRANSPORT PRIVATE LIMITED",
"SAKSHI VOGUE INDIA PRIVATE LIMITED",
"SAKSHI YARNS PRIVATE LIMITED",
"SAKSOFT LIMITED",
"SAKTEK FOUNDATION",
"SAKTHAN STEELS & ROOFS PRIVATE LIMITED",
"SAKTHI ACCUMULATORS PRIVATE LIMITED",
"SAKTHI AGRO TRADERS PRIVATE LIMITED",
"SAKTHI AROMATIC MASALAS PRIVATE LIMITED",
"SAKTHI AUTO ANCILLARY PRIVATE LIMITED",
"SAKTHI AUTO MOTORS LIMITED",
"SAKTHI COFFEE ESTATES PRIVATE LIMITED",
"SAKTHI ELEGANT TOWERS INDIA PRIVATE LIMITED",
"SAKTHI ENTERPRISERS PRIVATE LIMITED",
"SAKTHI FERRO ALLOYS INDIA PRIVATE LIMITED",
"SAKTHI FINANCE LIMITED",
"SAKTHI FINANCIAL SERVICES LIMITED",
"SAKTHI FOUNDATIONS PRIVATE LIMITED",
"SAKTHI GANESH TEXTILES PRIVATE LIMITED",
"SAKTHI HARDWARES PRIVATE LIMITED",
"SAKTHI HI-TECH FABRICATIONS PRIVATE LIMITED",
"SAKTHI INFRA TEX PRIVATE LIMITED",
"SAKTHI KANNA CONSTRUCTIONS PRIVATE LIMITED",
"SAKTHI MAHINDRA BREEDING FARM PRIVATE LIMITED",
"SAKTHI MARIAMMAN COLLEGE",
"SAKTHI MASALA PRIVATE LIMITED",
"SAKTHI MURUGAN AGRO FOODS PRIVATE LIMITED",
"SAKTHI MURUGAN ROLLER FLOUR MILLS PRIVATE LIMITED",
"SAKTHI PELICAN INSURANCE BROKING PRIVATE LIMITED",
"SAKTHI POULTRY PRIVATE LIMITED",
"SAKTHI SECURITY & FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"SAKTHI SHIPPING LOGISTICS PRIVATE LIMITED",
"SAKTHI SPIN TEX PRIVATE LIMITED",
"SAKTHI SPINTEX PRIVATE. LIMITED.",
"SAKTHI SPRING FORMS PRIVATE LIMITED",
"SAKTHI STEEL INDUSTRIES LIMITED",
"SAKTHI SUGARS LIMITED",
"SAKTHI SUPER MARKET INDIA PRIVATE LIMITED",
"SAKTHI VINAYAGA SPINNINGS MILLS PRIVATE LIMITED",
"SAKTHI WOOD TREATS PRIVATE LIMITED",
"SAKTHIDARAN SPINTEX MILLS PRIVATE LIMITED",
"SAKTHIS KITCHEN PRIVATE LIMITED",
"SAKTI DAL MILLING CENTER PRIVATE LIMITED",
"SAKTI NATURALS PRIVATE LIMITED",
"SAKTI STEEL ENTERPRISES PVT LTD",
"SAKTINAGAR SAMABAYA KRISHI UNNAYAN SAMITY LTD",
"SAKU PRINTING HOUSE PRIVATE LIMITED",
"SAKUMA EXPORTS LIMITED",
"SAKUN TEXTILE EXPORTS PRIVATE LIMITED",
"SAKUN TEXTILES INDUSTRIES PRIVATE LIMITED",
"SAKURA AUTOPARTS INDIA PRIVATE LIMITED",
"SAKURA FILTERS INDIA PRIVATE LIMITED",
"SAKURA SEED CORPORATION",
"SAL AUTOMOTIVE LIMITED",
"SAL CARE PRIVATE LIMITED",
"SAL COLLEGE OF ENGINEERING",
"SAL CORPORATION PRIVATE LIMITED",
"SAL HOSPITAL",
"SAL INFRACON PRIVATE LIMITED",
"SAL LOGISTICS PRIVATE LIMITED",
"SAL PAPERS PRIVATE LIMITED",
"SAL SECURITIES PRIVATE LIMITED",
"SAL TECHNOLOGIES & SOLUTIONS LIMITED",
"SALAAM BOMBAY FOUNDATION",
"SALAGRAM POWER AND STEEL PRIVATE LIMITED",
"SALAHUDDIN AYYUBI MEMORIAL URDU PRI SCHOOL BHIWANDI",
"SALAIPUDHUR-MADURAI TOLLWAY PRIVATE LIMITED",
"SALAM PLASTICS",
"SALAMANDER WINDOW & DOOR SYSTEMS PRIVATELIMITED",
"SALAMATI SECURITY AND PERSONNEL FORCE PRIVATE LIMITED",
"SALANPUR SINTERS PRIVATE LIMITED",
"SALAP VIVEKANANDA INSTITUTION",
"SALARPUR COLD STORAGE PRIVATE LIMITED",
"SALARPURIA DEVELOPERS PVT. LTD.",
"SALARPURIA GRIHA NIRMAN PRIVATE LIMITED",
"SALARPURIA HOUSING PRIVATE LIMITED",
"SALARPURIA INVESTMENT PVT LTD",
"SALARPURIA PROPERTIES PVT LTD",
"SALARPURIA REAL ESTATES PRIVATE LIMITED",
"SALARPURIA SATTVA REALTY LLP",
"SALARPURIA SIMPLEX BUILDCON LLP",
"SALARPURIA SIMPLEX DWELLINGS LLP",
"SALARY POWER GOVERNEMNT EMPLOYEE",
"SALAS PHARMACEUTICALS PRIVATE LIMITED",
"SALASAAR IRON AND STEELS PRIVATE. LIMITED. SISPL",
"SALASAR AGRO FOOD COLDSTORE PRIVATE LIMITED",
"SALASAR AGROPANEL PRIVATE LIMITED",
"SALASAR AGROTECH PRIVATE LIMITED",
"SALASAR ALLOY AND STEEL INDUSTRIES PRIVATE LIMITED",
"SALASAR AUTOCRAFTS PRIVATE LIMITED",
"SALASAR BAKERS PRIVATE LIMITED",
"SALASAR BALAJI COLD STORAGE PRIVATE LIMITED",
"SALASAR BALAJI INDUSTRIES",
"SALASAR BALAJI LOGISTIC PRIVATE LIMITED",
"SALASAR BALAJI OVERSEAS PRIVATE LIMITED",
"SALASAR BALAJI SEATING SYSTEMS PRIVATE LIMITED",
"SALASAR BALAJI SHIP BREAKERS PRIVATE LIMITED",
"SALASAR BALAJI STEELS PRIVATE LIMITED",
"SALASAR BALAJI TRADECOM PRIVATE LIMITED",
"SALASAR BOARD & PAPER LAMINATORS PRIVATE LIMITED",
"SALASAR BRIGHT BAR PRIVATE LIMITED",
"SALASAR CARBONICS PRIVATE LIMITED",
"SALASAR CARPETS PRIVATE LIMITED",
"SALASAR COTSPINS PRIVATE LIMITED",
"SALASAR CYBER SOLUTIONS PRIVATE LIMITED",
"SALASAR DERIVATIVES PRIVATE LIMITED",
"SALASAR DIAM PRIVATE LIMITED",
"SALASAR DINESHCHANDRA INFRAPROJECTS PRIVATE LIMITED",
"SALASAR DYEING AND PRINTING MILLS PRIVATE LIMITED",
"SALASAR EXTERIORS AND CONTOUR LIMITED",
"SALASAR FAN FABRIKEN PRIVATE LIMITED",
"SALASAR FILAMENTS PRIVATE LIMITED",
"SALASAR FOODS PRIVATE LIMITED",
"SALASAR GEOTEX PRIVATE LIMITED",
"SALASAR GINNING & PRESSING",
"SALASAR GREEN ENERGY PRIVATE LIMITED",
"SALASAR HANUMAN FASHIONS PRIVATE LIMITED",
"SALASAR HIGHWAYS PRIVATE LIMITED",
"SALASAR HOLDINGS PRIVATE LIMITED",
"SALASAR HYDRO URJA PRIVATE LIMITED",
"SALASAR INFRATECH ENGINEERING PRIVATE LIMITED",
"SALASAR KRISHI PRODUCTS PRIVATE LIMITED",
"SALASAR LAMINATES LIMITED",
"SALASAR LIFESTYLE PRIVATE LIMITED",
"SALASAR LOGISTIC PRIVATE LIMITED",
"SALASAR METALLURGICALS PRIVATE LIMITED",
"SALASAR MULTICOM ( INDIA) PRIVATE LIMITED",
"SALASAR MULTITRADE PRIVATE LIMITED",
"SALASAR ORGANICS PRIVATE LIMITED",
"SALASAR OXIDES PRIVATE LIMITED",
"SALASAR PIPES PRIVATE LIMITED",
"SALASAR PLASTOFAB PRIVATE LIMITED",
"SALASAR PLYWOOD PRIVATE LIMITED",
"SALASAR POLYTEX PRIVATE LIMITED",
"SALASAR PROCESSORS PRIVATE LIMITED",
"SALASAR PROMOTERS PVT LTD",
"SALASAR REALTECH PRIVATE LIMITED",
"SALASAR RETAILS PRIVATE LIMITED",
"SALASAR ROLLING MILLS PRIVATE LIMITED",
"SALASAR RUBBERS PRIVATE LIMITED",
"SALASAR SECURITIES PRIVATE LIMITED",
"SALASAR SERVICES (INSURANCE BROKERS) PRIVATE LIMITED",
"SALASAR STEEL AND POWER LIMITED",
"SALASAR STOCK BROKING LIMITED",
"SALASAR TECHNO ENGINEERING LIMITED",
"SALASAR TECHNOTEX PRIVATE LIMITED",
"SALASAR TERMINALS PRIVATE LIMITED",
"SALASAR TEXTILES PRIVATE LIMITED",
"SALASAR TILES PRIVATE LIMITED",
"SALASAR WAREHOUSING PRIVATE LIMITED.",
"SALASAR WASTE MANAGEMENT PRIVATE LIMITED",
"SALASAR WIRES MANUFACTURING PRIVATE LIMITED",
"SALASAR YARNS PRIVATE LIMITED",
"SALASARHANUMAN AGROTECH FOODS PRIVATE LIMITED",
"SALASARLENE DRESS FAB PRIVATE LIMITED",
"SALASHAR FLOUR MILL PRIVATE LIMITED",
"SALAWAS METALS PRIVATE LIMITED",
"SALAYA BULK TERMINALS LIMITED",
"SALCO EXTRUSIONS PRIVATE LIMITED",
"SALCOM AUTO COMPONENTS PRIVATE LIMITED",
"SALCOMP MANUFACTURING INDIA PRIVATE LIMITED",
"SALCOMP TECHNOLOGIES INDIA PRIVATE LIMITED",
"SALCON MEP SERVICES PRIVATE LIMITED",
"SALDANHA DEVELOPERS PRIVATE LIMITED",
"SALDAR INFRASTRUCTURE & CONTRACTS PRIVATE LIMITED",
"SALE TAX OFFICE NASHIK",
"SALEADERS SOLUTIONS PRIVATE LIMITED",
"SALEBHAI INTERNET LIMITED",
"SALECHA POLYWEAVE PRIVATE LIMITED",
"SALECTO INDIA PRIVATE LIMITED",
"SALEEM JAVED KEBABS PRIVATE LIMITED",
"SALEEMS ENERGY PRIVATE LIMITED",
"SALEM AUTOMECH INDIA PRIVATE LIMITED",
"SALEM CITY MUNICIPAL CORPORATION",
"SALEM COTTONS PRIVATE LIMITED",
"SALEM ERODE INVESTMENTS LIMITED",
"SALEM FOOD PRODUCTS PRIVATE LIMITED",
"SALEM GOPI HOSPITALS PRIVATE LIMITED",
"SALEM HOTEL SRI SARAVANA BHAVAN PRIVATE LIMITED",
"SALEM HUMAN RESOURCES SOLUTIONS PRIVATE LIMITED",
"SALEM INSTITUTE OF MEDICAL SCIENCES AND HOSPITALS PRIVATE LIMITED",
"SALEM IVF CENTRE PRIVATE LIMITED",
"SALEM LOGISTICS PRIVATE LIMITED",
"SALEM MAIZE PRODUCER COMPANY LIMITED",
"SALEM MICROBES PRIVATE LIMITED",
"SALEM MPK FABS PRIVATE LIMITED",
"SALEM POLY PACKS PRIVATE LIMITED",
"SALEM POLYCLINIC PRIVATE LIMITED",
"SALEM SPICES PRIVATE LIMITED",
"SALEM STAINLESS STEEL SUPPLIERS PRIVATE LIMITED",
"SALEM STORES JEWELLERS PRIVATE LIMITED",
"SALEM TECHNOLOGIES PRIVATE LIMITED",
"SALEM TOLLWAYS LIMITED",
"SALEM TOURS AND TRAVELS PRIVATE LIMITED",
"SALEON CONSULTING PRIVATE LIMITED",
"SALEPUSH OVERSEAS PRIVATE LIMITED",
"SALES & SERVICE AUTOMOTIVE PRIVATE LIMITED",
"SALES CORNER (BARODA) PRIVATE LIMITED",
"SALES INDIA PRIVATE LIMITED",
"SALES MEDIA LIMITED",
"SALES TAX DEPARTMENT",
"SALESBABU BUSINESS SOLUTIONS PRIVATE LIMITED",
"SALESFORCE.COM INDIA PRIVATE LIMITED",
"SALESFUSE TECHNOLOGIES PRIVATE LIMITED",
"SALESLIFT TECHNOLOGIES PRIVATE LIMITED",
"SALESWORTH SYNERGIES LLP",
"SALESZIP MARKETING PRIVATE LIMITED",
"SALET SEA FOODS PRIVATE LIMITED",
"SALETIFY MARKETING PRIVATE LIMITED",
"SALFORD PHARMACEUTICAL PRIVATE LIMITED",
"SALGAOCAR ENGINEERS PRIVATE LIMITED",
"SALGAOCAR MINING INDUSTRIES PRIVATE LIMITED",
"SALGUTI INDUSTRIES LIMITED",
"SALHYDRAU INDUSTRIES PRIVATE LIMITED",
"SALIAN'S HOTEL AND RESORTS PRIVATE LIMITED",
"SALIANS INDUSTRIES PRIVATE LIMITED",
"SALICE INDIA PRIVATE LIMITED",
"SALICO TRADING CO. PRIVATE LIMITED",
"SALICON NANO TECHNOLOGY PRIVATE LIMITED",
"SALICYLATES & CHEMICALS PRIVATE LIMITED",
"SALIENT IMPEX PRIVATE LIMITED",
"SALIENT SECURITY SERVICES PRIVATE LIMITED",
"SALIF ISPAT PRIVATE LIMITED",
"SALIG RAM SHIV PARSHAD",
"SALIGRAM PRODUCTS PRIVATE LIMITED",
"SALIGRAM TECHNOLOGIES PRIVATE LIMITED",
"SALIK STEELS PRIVATE LIMITED",
"SALIM ASSOCIATES BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"SALIMS PAPER PRIVATE LIMITED",
"SALINE AREA VITALISATION ENTERPRISE PRIVATE LIMITED",
"SALINI BOUTIQUE PRIVATE LIMITED",
"SALINI INDIA PRIVATE LIMITED",
"SALINI NDT SERVICES PRIVATE LIMITED",
"SALISBURY INVESTMENTS PRIVATE LIMITED",
"SALISBURY PROJECTS PRIVATE LIMITED",
"SALISTA NETWORK PRIVATE LIMITED",
"SALITHO ORES PRIVATE LIMITED",
"SALIUS PHARMA PRIVATE LIMITED",
"SALIX CERAMIC PRIVATE LIMITED",
"SALKA GLOBAL TECHNOLOGIES PRIVATE LIMITED",
"SALMA CONSTRUCTIONS PRIVATE LIMITED",
"SALMAN KHAN VENTURES PRIVATE LIMITED",
"SALOC TECHNOLOGIES PRIVATE LIMITED",
"SALOKH CYBERSERVICES PRIVATE LIMITED",
"SALOM CORPORATE PRIVATE LIMITED",
"SALON CERAMIC PRIVATE LIMITED",
"SALONA BICHONA FABTEX INDIA PRIVATE LIMITED",
"SALONA COTSPIN LIMITED",
"SALONAH TEA PRIVATE LIMITED",
"SALONI COIR PRIVATE LIMITED.",
"SALONI FOREST PRODUCTS PRIVATE LIMITED",
"SALONI PAPER MACHINES PRIVATE LIMITED",
"SALONLABS EXPORTS INDIA PRIVATE LIMITED",
"SALOOJA BROTHERS PRIVATE LIMITED",
"SALOONI ESTATES PRIVATE LIMITED",
"SALORA AUDIO VIDEO SERVICES PRIVATE LIMITED",
"SALORA COMPONENTS LIMITED",
"SALORA INTERNATIONAL LIMITED",
"SALORA RETAIL VENTURES LIMITED",
"SALORI E-COMMERCE PRIVATE LIMITED",
"SALPAI V KA SEVA SAHAKARI SOCIETY LTD",
"SALSAN STEELS PRIVATE LIMITED",
"SALSE YAVALI ROADWAYS PRIVATE LIMITED",
"SALSETTE DEVELOPERS PRIVATE LIMITED",
"SALSIFY DEALMARK PRIVATE LIMITED",
"SALSONS IMPEX PRIVATE LIMITED",
"SALT BRAND SOLUTIONS PRIVATE LIMITED",
"SALT BROOK MIRZA",
"SALT EXPERIENCES & MANAGEMENT PRIVATE LIMITED",
"SALT LAKE CITY MEDICAL CENTRE",
"SALT LAKE ESTATE & CREDIT PVT. LTD.",
"SALT LAKE PROJECTS PRIVATE LIMITED",
"SALT LAKE WINE PVT LTD",
"SALT 'N' PEPPER HOSPITALITY PRIVATE LIMITED",
"SALT RIVER INFO SYSTEMS PRIVATE LIMITED",
"SALT STUDIOS PRIVATE LIMITED",
"SALT WATER RESTAURENTS PRIVATE LIMITED",
"SALTEE BUILDCON PRIVATE LIMITED",
"SALTEE INFOTEX (INDIA) PRIVATE LIMITED",
"SALTEE INFRASTRUCTURE LIMITED",
"SALTILLO INVESTMENTS PRIVATE LIMITED",
"SALTMARCH MEDIA INDIA PRIVATE LIMITED",
"SALTO DEE FE CONSULTING SERVICE PRIVATE LIMITED",
"SALTON DEVELOPERS PRIVATE LIMITED",
"SALTROCK ADVISORS PRIVATE LIMITED",
"SALTS AND CHEMICALS PVT LTD",
"SALTSIDE TECHNOLOGIES INDIA PRIVATE LIMITED",
"SALTWOODS SHIPPING SOLUTIONS PRIVATE LIMITED",
"SALUBRE HEALTHWAYS PRIVATE LIMITED",
"SALUBRIA PHARMAVENTURES PRIVATE LIMITED",
"SALUBRIS INNS PRIVATE LIMITED",
"SALUBRIS SURGICAL PRIVATE LIMITED",
"SALUBRITY BIOTECH LIMITED",
"SALUD CARE (INDIA) PRIVATE LIMITED",
"SALUD CARE INDIA PRIVATE LIMITED",
"SALUDAR HEALTHCARE PRIVATE LIMITED",
"SALUJA AUTO RETAILS PRIVATE LIMITED",
"SALUJA CONSULTANCY SERVICES PRIVATE LIMITED",
"SALUJA DISTRIBUTORS PRIVATE LIMITED",
"SALUJA LOGISTIC INDIA PRIVATE LIMITED",
"SALUJA MOTORS PRIVATE LIMITED",
"SALUJA OVERSEAS PRIVATE LIMITED",
"SALUNKE AUTOMATION PRIVATE LIMITED",
"SALUNKI TUBES AND PIPES PRIVATE LIMITED",
"SALURA ASSOCIATES PRIVATE LIMITED",
"SALUS LABORATORIES PRIVATE LIMITED",
"SALUS MEDICAL DIAGNOSTIC CENTER PRIVATE LIMITED.",
"SALUS PRODUCTS PRIVATE LIMITED",
"SALUS SERVICES LLP",
"SALUS TECHNOLOGIES PRIVATE LIMITED",
"SALUTE BESTOCHEM PRIVATE LIMITED",
"SALUTE WATER HOUSE PRIVATE LIMITED",
"SALUTEM PHARMACEUTICALS PRIVATE LIMITED",
"SALUTO WELLNESS PRIVATE LIMITED",
"SALVA AGRO HATCHERIES PRIVATE LIMITED",
"SALVAGE SETTLERS PRIVATE LIMITED",
"SALVAGE SOLUTION PRIVATE LIMITED",
"SALVAGERS ENVIRON PRIVATE LIMITED",
"SALVAGNINI MACHINERY INDIA PRIVATE LIMITED",
"SALVATION AGENCY",
"SALVATION DEVELOPERS LIMITED",
"SALVATION MEDIA LIMITED",
"SALVATION OUTSOURCING SOLUTION PRIVATE LIMITED",
"SALVATION SECURITY SERVICE PRIVATE LIMITED",
"SALVAVIDAS PHARMACEUTICAL PRIVATE LIMITED",
"SALVE PHARMACEUTICALS PRIVATE LIMITED",
"SALVEO INTERNATIONAL DEVELOPMENT INDIA PRIVATE LIMITED",
"SALVEO LIFE SCIENCES LIMITED",
"SALVI FASHION PRIVATE LIMITED",
"SALVIA COSMECEUTICALS PRIVATE LIMITED",
"SALVIA TRAVELS PRIVATE LIMITED",
"SALVIFIC SAFETY SOLUTIONS PRIVATE LIMITED",
"SALVIN INSTRUMENTS PRIVATE LIMITED",
"SALVIS PROJECTS PRIVATE LIMITED",
"SALVO INDUSTRIES PRIVATE LIMITED",
"SALVOR SETTLERS",
"SALVUS SHIPPING AGENCIES PRIVATE LIMITED",
"SALVUS SHIPPING SERVICES PRIVATE LIMITED",
"SALWAN INTERNATIONAL PAPER PRIVATE LIMITED",
"SALWAN LOGISTIC AND WAREHOUSING PRIVATE LIMITED",
"SALWAN PAPERS PRIVATE LIMITED",
"SALWAN PUBLIC SCHOOL",
"SALZER ELECTRONICS LIMITED",
"SALZER EXPORTS LIMITED",
"SALZER SPINNERS LIMITED",
"SALZER TECHNOLOGIE LIMITED",
"SALZGITTER HYDRAULICS PRIVATE LIMITED",
"SALZGITTER LIFTS PRIVATE LIMITED",
"SAM (INDIA) HYDROPOWER PRIVATE LIMITED",
"SAM AGRI FRESH PRIVATE LIMITED",
"SAM AGRI TECH LIMITED",
"SAM AGRI VENTURES LIMITED",
"SAM APPARELS PRIVATE LIMITED",
"SAM AUTOMATION TECHNOLOGIES PRIVATE LIMITED",
"SAM CONSULTANCY SERVICES PRIVATE LIMITED",
"SAM EDUCOM PRIVATE LIMITED",
"SAM EQUIPMENT & TRADERS PRIVATE LIMITED",
"SAM FARMPRO INDUSTRIES PRIVATE LIMITED",
"SAM FARMS AND FOODS PVT LTD",
"SAM FINE O CHEM LIMITED",
"SAM GAS PROJECTS PRIVATE LIMITED",
"SAM GEARS (INDIA) PRIVATE LIMITED",
"SAM GLOBAL UNIVERSITY",
"SAM GYPSUM PRIVATE LIMITED",
"SAM HOUSING AND INFRA PRIVATE LIMITED",
"SAM HR SOLUTIONS LLP",
"SAM HYDROMACS PRIVATE LIMITED",
"SAM INDIA BUILTWELL PRIVATE LIMITED",
"SAM INDUSTRIAL ENTERPRISES LIMITED",
"SAM INDUSTRIES LIMITED",
"SAM INN RESORTS PVT LTD",
"SAM INSTRUMENTS PRIVATE LIMITED",
"SAM INTEGRATIONS PRIVATE LIMITED",
"SAM INTERNATIONAL PVT LTD",
"SAM JIN CONVEYOR INDIA PRIVATE LIMITED",
"SAM LIFE SCIENCES PRIVATE LIMITED",
"SAM MACHINERY INDIA PRIVATE LIMITED",
"SAM MANAGEMENT SERVICES PRIVATE LIMITED",
"SAM MANPOWER AND CAREER SERVICES LLP",
"SAM MANUFACTURING LIMITED",
"SAM MONEY CHANGERS PRIVATE LIMITED",
"SAM MOVIES ENTERTAINMENT PRIVATE LIMITED",
"SAM OIL ENERGY",
"SAM OVERSEAS TRADING PRIVATE LIMITED",
"SAM PACKAGING INNOVATIONS PRIVATE LIMITED",
"SAM PLASTOTECH PRIVATE LIMITED",
"SAM REALTOWN PRIVATE LIMITED",
"SAM SERVICES PVT LTD",
"SAM SKILLS DEVELOPMENT AND IT SOLUTIONS PRIVATE LIMITED",
"SAM SOLAR PRIVATE LIMITED",
"SAM SON POLYMERS PRIVATE LIMITED",
"SAM STITCH",
"SAM TOOLS PRIVATE LIMITED",
"SAM TOURS AND TRAVELS PRIVATE LIMITED",
"SAM TRANSPORT PRIVATE LIMITED",
"SAM TURBO INDUSTRY PRIVATE LIMITED",
"SAM TWISTERS PRIVATE LIMITED",
"SAMA AUDIT SYSTEMS & SOFTWARE PRIVATE.LIMITED",
"SAMA HOSPITAL",
"SAMA INTERNATIONAL PRIVATE LIMITED",
"SAMA JEWELLERY PRIVATE LIMITED",
"SAMA NEXTGEN INDIA PRIVATE LIMITED",
"SAMA TRAVEL PRIVATE LIMITED",
"SAMADAN MARATHI PRATHMIK VIDHYALAY,SAMADHAN NAGAR,SOLAPUR",
"SAMADHAAN CORPORATE SERVICES PRIVATE LIMITED",
"SAMADHAAN INTELLIGENCE SECURITY SERVICES PRIVATE LIMITED",
"SAMADHAN ASSOCIATES LIMITED",
"SAMADHAN ENGINEERING PRIVATE LIMITED",
"SAMADHAN ENTERPRISES PRIVATE LIMITED",
"SAMADHAN MILK AND MILK PRODUCTS PRIVATE LIMITED",
"SAMADHAN TECHNOLOGIES (OPC) PRIVATE LIMITED",
"SAMADHIYA FINANCIAL SERVICES PVT LTD",
"SAMADHIYA INFRATECH PRIVATE LIMITED",
"SAMAG TRUE ENTERPRISES LIMITED",
"SAMAGAMA HOLDINGS AND COMMERCIAL PRIVATE LIMITED",
"SAMAGRA DEVELOPMENT ASSOCIATES PRIVATE LIMITED",
"SAMAGRA SHIKSHA",
"SAMAGRA SHIKSHA ABHIYAN",
"SAMAGRA SHIKSHA DANG",
"SAMAGRA SHIKSHA KHEDA",
"SAMAGRA SIKSHANA SAMITHI TRUST",
"SAMAGRH ENGINEERING PRIVATE LIMITED",
"SAMAIKYA EDUCATIONS PRIVATE LIMITED",
"SAMAIRA AGRIFOODS PRIVATE LIMITED",
"SAMAIRA ENGINEERING WORKS PRIVATE LIMITED",
"SAMAIRA INVESTMENT ADVISORS PRIVATE LIMITED",
"SAMAIRA JEWELS PRIVATE LIMITED",
"SAMAJ CONSULTANCY",
"SAMAJ JAGRUTI VIDYALAY MURUD",
"SAMAJ PRAGATI SAHAYOG",
"SAMAL AUTO (INDIA) PRIVATE LIMITED",
"SAMAL BUILDERS PRIVATE LIMITED",
"SAMAL CARE PRIVATE LIMITED",
"SAMAL HARAND OF INDIA PVT LTD",
"SAMAL INFRA PROJECTS PRIVATE LIMITED",
"SAMAL MOTORS PRIVATE LIMITED",
"SAMALAKA TEXFAB PRIVATE LIMITED",
"SAMALESHWARI FERROMETALS PRIVATE LIMITED",
"SAMALI HOSPITALITY PRIVATE LIMITED",
"SAMALIA REALTECH PRIVATE LIMITED",
"SAMALKOT POWER LIMITED",
"SAMALPATTI POWER COMPANY PRIVATE LIMITED",
"SAMAN POS INDIA PRIVATE LIMITED",
"SAMAN TEA PRIVATE LIMITED",
"SAMAN TECHNOSYS PRIVATE.LIMITED",
"SAMANA ISPAT PRIVATE LIMITED",
"SAMANA PLASTIC PRIVATE LIMITED",
"SAMANATA PRIVATE LIMITED",
"SAMANI DECORATORS PRIVATE LIMITED",
"SAMANJAS UDYOG PRIVATE LIMITED",
"SAMANNOY INTERNATIONAL PRIVATE LIMITED",
"SAMANTA FURNITURE PRIVATE LIMITED",
"SAMANTA MOVIES PRIVATE LIMITED",
"SAMANTA ORGANICS PRIVATE LIMITED",
"SAMANTA POULTRIES PRIVATE LIMITED",
"SAMANTA SECURITY & INTELLIGENCE SERVICES PRIVATE LIMITED",
"SAMANTHU BUSINESS FORMS PRIVATE LIMITED",
"SAMANVAY BUILDMART PRIVATE LIMITED",
"SAMANVAY MULTI SPECIALITY HOSPITAL",
"SAMANVAY PARK",
"SAMANVAY RESEARCH AND DEVELOPMENT FOUNDATION",
"SAMANVAY UDUPI PRIVATE LIMITED",
"SAMANVAYA HEALTHCARE PRIVATE LIMITED",
"SAMANVAYA HOLDINGS PRIVATE LIMITED",
"SAMANVII DIGIMEDIA ART AND SOLUTIONS PRIVATE LIMITED",
"SAMANVYA INFRASTRUCTURE PRIVATE LIMITED",
"SAMANVYA LOGISTICS PRIVATE LIMITED",
"SAMAR GREEN HOMES PRIVATE LIMITED",
"SAMAR HOSPITAL",
"SAMAR INFRA PRIVATE LIMITED",
"SAMAR SINGH JAYASWAL PRIVATE LIMITED",
"SAMAR SOLUTIONS INDIA PRIVATE LIMITED",
"SAMAR TOURS & TRAVELS PRIVATE LIMITED",
"SAMARA AUTOMAX PRIVATE LIMITED",
"SAMARA CARPETS PRIVATE LIMITED",
"SAMARA INDIA ADVISORS PRIVATE LIMITED",
"SAMARA INDIA PRIVATE LIMITED",
"SAMARA POWER SOLUTIONS PRIVATE LIMITED",
"SAMARA RETAIL INDIA PRIVATE LIMITED",
"SAMARATH AIR-TECH PRIVATE LIMITED",
"SAMARATH MULTIBIZ INDIA PRIVATE LIMITED",
"SAMARIA ENTERPRISES PRIVATE LIMITED",
"SAMARIA FASHION PRIVATE LIMITED",
"SAMARITAN CLINIC PRIVATE LIMITED",
"SAMARITAN EXIM PRIVATE LIMITED",
"SAMARPAN CHARITABLE TRAUMA HOSPITAL AND RESEARCH CENTER",
"SAMARPAN ENGINEERING AND MARKETING PVT LTD",
"SAMARPAN FABRICATORS PRIVATE LIMITED",
"SAMARPAN IMAGING SOLUTIONS INDORE",
"SAMARPAN LOGISTICS PRIVATE LIMITED",
"SAMARPAN MULTISERVICES PRIVATE LIMITED",
"SAMARPAN PHARMACEUTICALS PRIVATE LIMITED",
"SAMARPAN SYNTHETICS PRIVATE LIMITED",
"SAMARPIT BUILDTECH PRIVATE LIMITED",
"SAMARPIT INDUSTRIES PRIVATE LIMITED",
"SAMARPIT SURAKSHA PRIVATE LIMITED",
"SAMARTH AD PROTEX PVT.LTD.",
"SAMARTH AGRI EARTH PRIVATE LIMITED",
"SAMARTH AGRICULTURE PRIVATE LIMITED",
"SAMARTH AIRCON PRIVATE LIMITED",
"SAMARTH APPARELS PRIVATE LIMITED",
"SAMARTH ART STUDIO PRIVATE LIMITED",
"SAMARTH BUILDTECH PRIVATE LIMITED",
"SAMARTH CARS PRIVATE LIMITED",
"SAMARTH CHEMICAL PRODUCTS PRIVATE LIMITED",
"SAMARTH CITYHOMES PRIVATE LIMITED",
"SAMARTH COMMODITIES MERCHANTS PRIVATE LIMITED",
"SAMARTH CREATIONS PRIVATE LIMITED",
"SAMARTH DAIRY AND AGRO PRODUCTS PRIVATE LIMITED",
"SAMARTH DEVCON PRIVATE LIMITED",
"SAMARTH DIAMOND SD",
"SAMARTH ENGINEERING COMPANY PRIVATE LIMITED",
"SAMARTH ENTERPRISES",
"SAMARTH FABLON PRIVATE LIMITED",
"SAMARTH FOAM PRIVATE LIMITED",
"SAMARTH GOLD CHAINS PRIVATE LIMITED",
"SAMARTH HOSPITALITY PRIVATE LIMITED",
"SAMARTH HYDRAULICS AND POWER SYSTEMS",
"SAMARTH HYPERMARKET PRIVATE LIMITED",
"SAMARTH IMPEX PRIVATE LIMITED",
"SAMARTH INFRAENGG TECHNOCRATS PRIVATE LIMITED",
"SAMARTH INFRAHEIGHTS PRIVATE LIMITED",
"SAMARTH INFRA-TECH SERVICES PRIVATE LIMITED",
"SAMARTH INSTITUTE OF CAREER DEVELOPMENT",
"SAMARTH JEWELLERY LIMITED",
"SAMARTH KISAN PRODUCER COMPANY PRIVATE LIMITED",
"SAMARTH KRUPA ENTERPRISES",
"SAMARTH LABELING SOLUTIONS",
"SAMARTH LIFE MANAGEMENT PRIVATE LIMITED",
"SAMARTH LIFE SCIENCES PRIVATE LIMITED",
"SAMARTH LIFESTYLE RETAILING PRIVATE LIMITED",
"SAMARTH LIFTERS PRIVATE LIMITED",
"SAMARTH MERCANTILE PRIVATE LIMITED",
"SAMARTH PACKAGING",
"SAMARTH PAPER MACHINES PRIVATE LIMITED",
"SAMARTH PHARMA PRIVATE LIMITED",
"SAMARTH POLYPRINTS PRIVATE LIMITED",
"SAMARTH PUBLICATIONS & SUBSCRIPTIONS PRIVATE LIMITED",
"SAMARTH REALTY DEVELOPERS PRIVATE LIMITED",
"SAMARTH REXINES PRIVATE LIMITED",
"SAMARTH ROLL CARE PRIVATE LIMITED",
"SAMARTH SAHAKARI BANK LTD SOLAPUR",
"SAMARTH SAI LOGISTICS PRIVATE LIMITED",
"SAMARTH SALES AGENCIES PRIVATE LIMITED",
"SAMARTH SECURITY SYSTEMS (INDIA) PRIVATE LIMITED",
"SAMARTH TRADENT PRIVATE LIMITED",
"SAMARTH TURNKEY SOLUTIONS PRIVATE LIMITED",
"SAMARTH UDYOG TECHNOLOGY FORUM",
"SAMARTH VIDYA MANDIR PRASHALA",
"SAMARTH VIDYALAY NANDGAON",
"SAMARTHA AUTOMATIONS PRIVATE LIMITED",
"SAMARTHA BALVIKAS VIDYALAY ,AMBERNATH",
"SAMARTHA HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED",
"SAMARTHA INFOSOLUTIONS PRIVATE LIMITED",
"SAMARTHA LEISURES AND RESTAURANTS PRIVATE LIMITED",
"SAMARTHA NIDHI LIMITED",
"SAMARTHAIR PNEUMATICS PRIVATE LIMITED",
"SAMARTHAKRUPA LIFESCIENCES PRIVATE LIMITED",
"SAMARTHANA CORPORATE SERVICES PRIVATE LIMITED",
"SAMARTHANS ENGINEERING SERVICES PRIVATE LIMITED",
"SAMARTHKRUPA ENGINEERING INDIA PRIVATE LIMITED",
"SAMARTHYA ENGINEERING PRIVATE LIMITED",
"SAMASHTI FOODS PRIVATE LIMITED",
"SAMASHTI INFRASTRUCTURE PRIVATE LIMITED",
"SAMASHTI INTERNATIONAL SCHOOL",
"SAMAST TECHNOLOGIES PRIVATE LIMITED",
"SAMASTA FOODS PRIVATE LIMITED",
"SAMASTA PHARMA PRIVATE LIMITED",
"SAMASTI INFRASTRUCTURES PRIVATE LIMITED",
"SAMASTIPUR FROZEN FOODS PRIVATE LIMITED",
"SAMATA DEGREE COLLEGE",
"SAMATA HOSPITAL PRIVATE LIMITED",
"SAMATA SAHAKARI BANK LIMITED",
"SAMATHA TECHNOLOGIES PRIVATE LIMITED",
"SAMATMA ESTATES PRIVATE LIMITED",
"SAMATRIX CONSULTING PRIVATE LIMITED",
"SAMAVESH FINANCE INDIA PRIVATE LIMITED",
"SAMAVESH FINSERVE PRIVATE LIMITED",
"SAMAVESH MARKETING INDIA PRIVATE LIMITED",
"SAMAVIST ENERGY SOLUTIONS PRIVATE LIMITED",
"SAMAX TELECOM PRIVATE LIMITED",
"SAMAY (INDIA) PRIVATE LIMITED",
"SAMAY AGROTECH PRIVATE LIMITED",
"SAMAY ALLOYS (INDIA) PRIVATE LIMITED",
"SAMAY BUILDERS PRIVATE LIMITED",
"SAMAY CONSTRUCTION PRIVATE LIMITED",
"SAMAY IMPEX PRIVATE LIMITED",
"SAMAY INDUSTRIES LIMITED",
"SAMAY JAGAT MEDIA PRIVATE LIMITED",
"SAMAY PARIVAHAN PRIVATE LIMITED",
"SAMAY PHARMA INDIA PRIVATE LIMITED",
"SAMAY PRINT SOLUTIONS PRIVATE LIMITED",
"SAMAY PROJECT SERVICES PRIVATE LIMITED",
"SAMAY TRANS LOGISTICS PRIVATE LIMITED",
"SAMAYA STUCTURES",
"SAMAYRAA KNITTERS PRIVATE LIMITED",
"SAMAYSHATABDI TRAVELS PRIVATE LIMITED",
"SAMBALPUR ROLLER FLOUR MILLS PVT LTD",
"SAMBALPUR STEELS PRIVATE LIMITED",
"SAMBANDAM SIVA TEXTILES PRIVATE LIMITED",
"SAMBANDAM SPINNING MILLS LIMITED SSML",
"SAMBANDH FINSERVE PRIVATE LIMITED",
"SAMBASHIVA PARABOILED RICE MILLS PRIVATE LIMITED (PART IX)",
"SAMBASIVA ENTERPRISES PRIVATE LIMITED",
"SAMBATUR CONSULTANCY PRIVATE LIMITED",
"SAMBE ELECTRONICS PRIVATE LIMITED",
"SAMBERRY EXOTICS PRIVATE LIMITED",
"SAMBHAAV MEDIA LIMITED",
"SAMBHABAMI SERVICE STATION PRIVATE LIMITED",
"SAMBHAJIRAO SHINDE PRIMARY SCHOOL SOLAPUR",
"SAMBHAJIRAO SHINDE VIDYA MANDIR,SOLAPUR",
"SAMBHAR SALTS LIMITED",
"SAMBHAV ACADEMY PRIVATE LIMITED",
"SAMBHAV ALLOYS PRIVATE LIMITED",
"SAMBHAV COTTON COMPANY PRIVATE LIMITED",
"SAMBHAV DETERGENTS PRIVATE LIMITED",
"SAMBHAV FOREX PRIVATE LIMITED",
"SAMBHAV GEMS LIMITED",
"SAMBHAV HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"SAMBHAV LOGISTICS PRIVATE LIMITED",
"SAMBHAV MACHINERY MANUFACTURES PRIVATE LIMITED",
"SAMBHAV POLYMERS PRIVATE LIMITED",
"SAMBHAV ROCKS INDIA PRIVATE LIMITED",
"SAMBHAV STARCH PRODUCTS PVT LTD",
"SAMBHAV SYNTHETICS PRIVATE LIMITED",
"SAMBHAV TIMBER & HANDICRAFTS PRIVATE LIMITED",
"SAMBHAV TRADE TOURS PRIVATE LIMITED",
"SAMBHAVI COLD STORAGE PRIVATE LIMITED",
"SAMBHAVI ENERGY & COAL BENEFICIATION PRIVATE. LIMITED.",
"SAMBHAVI ENTERTAINMENT PRIVATE LIMITED",
"SAMBHAVNA SECURITIES PRIVATE LIMITED",
"SAMBHAVNATH AGRO PRIVATE LIMITED",
"SAMBHAVNATH COMPLEX LIMITED",
"SAMBHAVNATH INFRABUILD AND FARMS PRIVATE LIMITED",
"SAMBHAVNATH PVC PIPE INDIA PRIVATE LIMITED",
"SAMBHV SPONGE POWER PRIVATE LIMITED",
"SAMBIT DEVELOPERS PRIVATE LIMITED",
"SAMBIT RESORTS PRIVATE LIMITED",
"SAMBODHAN DISTRIBUTORS PRIVATE LIMITED",
"SAMBODHI INSTITUTE",
"SAMBODHI RESEARCH AND COMMUNICATIONS PRIVATE LIMITED",
"SAMBODHI SYNTHETICS PRIVATE LIMITED",
"SAMBRIK MEDISCIENCES PRIVATE LIMITED",
"SAMBROS TEX GLOBAL LIMITED",
"SAMBTEK FOREX LIMITED",
"SAMCAL CUTTING SOLUTIONS (INDIA) PRIVATE LIMITED",
"SAMCHEM INDIA PRIVATE LIMITED",
"SAMCO ALLOYS (INDIA )PRIVATE LIMITED",
"SAMCO AUTO (INDIA) PRIVATE LIMITED",
"SAMCO FLEX DUCTS PRIVATE LIMITED",
"SAMCO MACHINERY INDIA PRIVATE LIMITED",
"SAMCO METALS AND ALLOYS PRIVATE LIMITED",
"SAMCO SECURITIES LIMITED",
"SAMCO VENTURES PRIVATE LIMITED",
"SAMCOM TECHNOBRAINS PRIVATE LIMITED",
"SAMCON INDUSTRIAL CONTROLS PRIVATE LIMITED",
"SAMCON RESORT & HOTEL PVT LTD",
"SAMDANI BUILDERS PRIVATE LIMITED",
"SAMDANI COAL PRIVATE LIMITED",
"SAMDANI GRANITES PRIVATE LIMITED",
"SAMDAREEYA HOTEL & MULTIPLEX PRIVATE LIMITED",
"SAMDARI STRIPS PRIVATE LIMITED",
"SAMDARIYA ABHUSHAN PRIVATE LIMITED",
"SAMDARIYA BUILDERS PRIVATE LIMITED",
"SAMDARIYA HOTELS PVT LTD",
"SAMDE AROMATIC PRIVATE LIMITED",
"SAMDEV ELECTRO ENGINEERS PRIVATE LIMITED",
"SAMDHYAN COMMODITIES BROKERS PRIVATE LIMITED",
"SAMDHYAN SECURITIES BROKERS PRIVATE LIMITED",
"SAME DEUTZ-FAHR INDIA PRIVATE LIMITED",
"SAMEDAY INFRATECH LIMITED",
"SAMEDAY MEDNEEDS PRIVATE LIMITED",
"SAMEDAY RETAILS LIMITED",
"SAMEEKSHA CAPITAL PRIVATE LIMITED",
"SAMEEKSHA LIFE SAFETY EQUIPMENTS INDIA PRIVATE LIMITED",
"SAMEENA MULTITRADE PRIVATE LIMITED",
"SAMEEP ENGINEERING (INDIA) PRIVATE LIMITED",
"SAMEEP FABRICS PRIVATE LIMITED",
"SAMEEPTA INDUSTRIES PRIVATE LIMITED",
"SAMEER AUTO PVT LTD",
"SAMEER AUTOMOBILES PRIVATE LIMITED",
"SAMEER BUILTAID PRIVATE LIMITED",
"SAMEER CENTRE FOR ELECTROMAGNETICS",
"SAMEER CHEMCON ENGINEERS PRIVATE LIMITED",
"SAMEER ELECTRO SYSTEMS PRIVATE LIMITED",
"SAMEER GLAZING SYSTEM PRIVATE LIMITED",
"SAMEER LAUNDROMATS LLP",
"SAMEER MEHTA & ASSOCIATES MEHTA CONSULTANCY",
"SAMEER PUMPS PRIVATE LIMITED",
"SAMEER SALES PRIVATE LIMITED",
"SAMEER STEEL IMPEX PRIVATE LIMITED",
"SAMEERA AGRO AND INFRA LIMITED",
"SAMEERA HOTELS (CHENNAI) PRIVATE LIMITED",
"SAMEERA PAPERS LIMITED",
"SAMEERA TRAVELS AND TOURS PRIVATE LIMITED",
"SAMEERAA FOUNDATIONS PRIVATE LIMITED",
"SAMEJA HOUSING PRIVATE LIMITED",
"SAMEK PARQUET PRIVATE LIMITED",
"SAMEKIT INFRA SOLUTION PRIVATE LIMITED",
"SAMEO DISTRIBUTION (INDIA) PRIVATE LIMITED",
"SAMESKY CONFECTIONERIES INDIA PRIVATE LIMITED",
"SAMESPACE INDIA PRIVATE LIMITED",
"SAMET PLAST",
"SAMETA METAL PRO PRIVATE LIMITED",
"SAMEX INDIA PRIVATE LIMITED",
"SAMFAR FLOORS AND DECOR PRIVATE LIMITED",
"SAMFORD HOSPITAL PRIVATE LIMITED",
"SAMGO ENGINEERING PRIVATE LIMITED",
"SAMGOORAS FARM PRIVATE LIMITED",
"SAMGOR GRID CONSTRUCTION PRIVATE LIMITED",
"SAMGRAHAH COMMERCIAL PRIVATE LIMITED",
"SAMHAN BUILDING SOLUTIONS PRIVATE LIMITED",
"SAMHAN CONSTRUCTIONS & ELECTRIC COMPANY INDIA PRIVATE LIMITED",
"SAMHATI FORGE (INDIA) PRIVATE LIMITED",
"SAMHI HOTELS (AHMEDABAD) PRIVATE LIMITED",
"SAMHI HOTELS GURGAON PRIVATE LIMITED",
"SAMHI HOTELS LIMITED",
"SAMHI HOTELS PRIVATE LIMITED",
"SAMHI JV BUSINESS HOTELS PRIVATE LIMITED",
"SAMHITA COMMUNITY DEVELOPMENT SERVICES",
"SAMHITA SOCIAL VENTURES PRIVATE LIMITED",
"SAMHITA TECHNOLOGIES PRIVATE LIMITED",
"SAMHITHA BROADCASTING PRIVATE LIMITED",
"SAMHITHA MARINE PRIVATE LIMITED",
"SAMHITHA MOTORS PRIVATE LIMITED",
"SAMHO GUNYOUNG CONSTRUCTION PRIVATE LIMITED.",
"SAMHRUTHA HABITAT INFRASTRUCTURE PRIVATE LIMITED",
"SAMHUT JEEVIKA AGRI PRODUCER COMPANY LIMITED",
"SAMI DIRECT MARKETING PRIVATE LIMITED",
"SAMI NUTRACEUTICALS PRIVATE LIMITED",
"SAMI SPICES AND HERBS PRIVATE LIMITED.",
"SAMICKSHA AUTOMOTIVES INDIA PRIVATE LIMITED",
"SAMIK EXPORTS (INDIA) PRIVATE LIMITED",
"SAMIK EXPORTSINDIA PRIVATE LIMITED",
"SAMIKA DESIGN SOLUTIONS PRIVATE LIMITED",
"SAMIKSHA CORPORATION PRIVATE LIMITED",
"SAMIKSHA ELECTRONICS PRIVATE LIMITED",
"SAMIKSHA RESOURCES PVT.LTD.",
"SAMIKSHA WATERTECH PRIVATE LIMITED",
"SAMIN TEKMINDZ INDIA PRIVATE LIMITED",
"SAMIP CHEMICALS PVT LTD",
"SAMIR CERAMICS PRIVATE LIMITED",
"SAMIR COTTON INDUSTRIES PRIVATE LIMITED",
"SAMIR DIAMONDS EXPORTS PRIVATE LIMITED",
"SAMIR EPC PRIVATE LIMITED",
"SAMIR TECH-CHEM PRIVATE LIMITED",
"SAMIRA CHEMICALS PRIVATE LIMITED",
"SAMIRA CONSTRUCTIONS LIMITED",
"SAMIRA LIFESTYLES PRIVATE LIMITED",
"SAMIRAN INFRASTRUCTURE PRIVATE LIMITED",
"SAMIRI EQUIPMENTS AND ENGINEERS PRIVATE LIMITED",
"SAMIRI FORGE PRIVATE LIMITED",
"SAMI-SABINSA GROUP LIMITED",
"SAMISHTI INFOTECH PRIVATE LIMITED",
"SAMISTHI CONSTRUCTIONS PRIVATE LIMITED",
"SAMIT ENTERPRISES PRIVATE LIMITED",
"SAMIT SALES PRIVATE LIMITED",
"SAMIT SPECTRUM EIT PRIVATE LIMITED",
"SAMIT TECHNORUBBER PRIVATE LIMITED",
"SAMIT WRITING AIDS P.LTD.",
"SAMITAN ELECTROPOWERS PRIVATE LIMITED",
"SAMITECH ELECTRONICS PRIVATE LIMITED",
"SAMJACK FOOD INDUSTRIES PRIVATE LIMITED",
"SAMKALPA SYSTEMS PRIVATE LIMITED",
"SAMKAN PRODUCTS PRIVATE LIMITED",
"SAMKARATHIL TRADING COMPANY PRIVATE LIMITED",
"SAMKEET ELECTRONICS",
"SAMKIT AGRO PRIVATE LIMITED",
"SAMKIT DIAMOND EXPORT PRIVATE LIMITED",
"SAMKIT ENGINEERS PRIVATE LIMITED",
"SAMKIT IMAGING SYSTEMS PRIVATE LIMITED",
"SAMKIT INFRASTRUCTURE & EARTHMOVERS PRIVATE LIMITED",
"SAMKIT TEXTILE MILLS PRIVATE LIMITED",
"SAMKO SWITCHGEARS PRIVATE LIMITED",
"SAMKRG PISTONS AND RINGS LIMITED",
"SAMKWANG INDIA ELECTRONIC PRIVATE LIMITED",
"SAMLITE INDIA PRIVATE LIMITED",
"SAMMAAN FABRICS PRIVATE LIMITED",
"SAMMAAN FOUNDATION",
"SAMMAN AUTOMOBILES PRIVATE LIMITED",
"SAMMAN BUILDCON PRIVATE LIMITED",
"SAMMAN LAL SHER SINGH PAPERS PRIVATE LIMITED",
"SAMMANITA FASHIONS PRIVATE LIMITED",
"SAMMARTH OVERSEAS AND CREDITS PRIVATE LIMITED",
"SAMMED GRANIMARMO PRIVATE LIMITED",
"SAMMELAN TEA & BEVERAGES PRIVATE LIMITED",
"SAMMON INFRACORP",
"SAMNAN INTERNATIONAL PRIVATE LIMITED",
"SAMNEE AUTO (OPC) PRIVATE LIMITED",
"SAMODE PALACE",
"SAMOLA SYSTEMS PRIVATE LIMITED",
"SAMOO DESIGNERS & ENGINEERS INDIA PRIVATE LIMITED",
"SAMOO ENGINEERING INDIA PRIVATE LIMITED",
"SAMOOHA PROJECTS PRIVATE LIMITED",
"SAMOR CLADDING SYSTEMS PRIVATE LIMITED",
"SAMOR REALITY LIMITED",
"SAMOSA HUB",
"SAMOSA LABS SOFTWARE AND INTERIOR DESIGN SOLUTIONS SERVICES PRIVATE LIMITED",
"SAMOSAPARTY FOODS PRIVATE LIMITED",
"SAMOSARAN SYNTEX PRIVATE LIMITED",
"SAMOSARAN YARNS PRIVATE LIMITED",
"SAMP FURNITURE PRIVATE LIMITED",
"SAMPAD SWAROOP JEWELS PRIVATE LIMITED",
"SAMPADA BUSINESS SOLUTIONS LIMITED",
"SAMPADA ENTREPRENEURSHIP AND LIVELIHOODS FOUNDATION",
"SAMPADA LABORATORIES PRIVATE LIMITED",
"SAMPADA LOGISTIC PRIVATE LIMITED",
"SAMPADA PAPER INDUSTRIES PRIVATE LIMITED",
"SAMPADA SAHAKARI BANK LTD",
"SAMPAN TECHNOSOFT PRIVATE LIMITED",
"SAMPANN TRADING CO PVT LTD",
"SAMPANN UTPADAN INDIA LIMITED",
"SAMPANNA CORPORATE SERVICE PRIVATE LIMITED",
"SAMPANNA ENGINEERS PRIVATE LIMITED",
"SAMPANYA MINERALS PRIVATE LIMITED",
"SAMPARK ADVERTISING & MEDIA PRIVATE LIMITED",
"SAMPARK AUTOMOBILES OPC PRIVATE LIMITED",
"SAMPARK BPO PRIVATE LIMITED",
"SAMPARK FIN SERVICES PRIVATE LIMITED",
"SAMPARK INDIA LOGISTICS PRIVATE LIMITED",
"SAMPARK INDUSTRIES LIMITED",
"SAMPARK INFOTAINMENT PRIVATE LIMITED",
"SAMPARK LAMINATORS PRIVATE LIMITED",
"SAMPARK LOGISTICS PRIVATE LIMITED",
"SAMPARK PLYWOOD & VENEERS PRIVATE LIMITED",
"SAMPARK SOFTWARES PRIVATE LIMITED",
"SAMPARNA BUSINESS CORRESPONDENCE PRIVATE LIMITED",
"SAMPAT ALUMINIUM PRIVATE LIMITED",
"SAMPAT CERAMICS PVT LTD",
"SAMPAT HEAVY ENGINEERING LIMITED",
"SAMPAT MACHINE TOOLS COMPANY PRIVATE LIMITED",
"SAMPAT RIBBONS PRIVATE LIMITED",
"SAMPATH CONSTRUCTIONS AND ESTATES PRIVATE LIMITED",
"SAMPATH KUMAR ASSOCIATES PRIVATE LIMITED",
"SAMPATH VENKATESWARA COMMUNICATIONS PRIVATE LIMITED",
"SAMPATH VINAYAK STEELS PRIVATE LIMITED",
"SAMPATI SECURITIES LIMITED",
"SAMPATI SONS JEWELLERS PRIVATE LIMITED",
"SAMPATTI LABORATORIES PRIVATE LIMITED",
"SAMPATTI NEW LIFE PRIVATE LIMITED",
"SAMPATTIKA MEDICAL SOLUTIONS PRIVATE LIMITED",
"SAMPEK ENGINEERING PRIVATE LIMITED",
"SAMPER ENGINEERING PRIVATE LIMITED",
"SAMPHARM LABS PRIVATE LIMITED",
"SAMPIGE HUTTY ESTATES PRIVATE. LIMITED.",
"SAMPIGEHUTTY ESTATE PRIVATE LIMITED",
"SAMPING POLYMERS PRIVATE LIMITED",
"SAMPL COMMUNICATIONS PRIVATE LIMITED",
"SAMPLAST PAINTS LIMITED",
"SAMPLE ZONE RESEARCH & ANALY PRIVATE LIMITED",
"SAMPLYTICS TECHNOLOGIES PRIVATE LIMITED",
"SAMPOORNA CONSULTANTS PRIVATE LIMITED",
"SAMPOORNA FEEDS PRIVATE LIMITED",
"SAMPOORNA HOTELS PRIVATE LIMITED",
"SAMPOORNA RETAIL (INDIA) PRIVATE LIMITED",
"SAMPOORNA YOGA SHALA PRIVATE LIMITED",
"SAMPOORNAM MANAGEMENT SERVICES PRIVATE LIMITED",
"SAMPROJ PHARMA PRIVATE LIMITED",
"SAMPTEL ENERGY PRIVATE LIMITED",
"SAMPURAN PACKAGING PRIVATE LIMITED",
"SAMPURN HARIYALI AGROZONE PRIVATE LIMITED",
"SAMPURN ORGANIC PRIVATE LIMITED",
"SAMPURN VYAPAAR PRIVATE LIMITED",
"SAMPURN(E)ARTH ENVIRONMENT SOLUTIONS PRIVATE LIMITED",
"SAMPURNA PLANT NUTRITION & FERTILIZERS PRIVATE LIMITED",
"SAMPURNA SHREE SPINNING MILLS PRIVATE LIMITED",
"SAMPURNA WOMEN CROP PRODUCER COMPANY LIMITED",
"SAMPURNAM HOSIERIES IMPEX PRIVATE LIMITED",
"SAMPURNANAND SANSKRIT VISHWAVIDYALAYA",
"SAMR FILTRATION PRIVATE LIMITED",
"SAMR TECHNOLOGY PRIVATE LIMITED",
"SAMRA APPARELS PRIVATE LIMITED",
"SAMRA INFRA PRIVATE LIMITED",
"SAMRA INTERNATIONAL PVT LTD",
"SAMRAAT HOTELS AND BANQUET PRIVATE LIMITED",
"SAMRAAT JOBS & MANPOWER INDIA PRIVATE LIMITED",
"SAMRAAT SYNPACKS PRIVATE LIMITED",
"SAMRADDH BESTWIN MICRO FINANCE ASSOCIATION",
"SAMRADDHI COT FIBERS PRIVATE LIMITED",
"SAMRADDHI FACILITIES MANAGEMENT PRIVATE LIMITED",
"SAMRADDHI POWER AND INFRA PRIVATE LIMITED",
"SAMRADH AGRO FOOD INDUSTRIES PRIVATE LIMITED",
"SAMRADHA KISAN PRODUCER COMPANY LIMITED",
"SAMRADHI INFRAPROMOTERS PRIVATE LIMITED",
"SAMRADITYA TEXTILES",
"SAMRAGI INFO TECH PRIVATE LIMITED",
"SAMRAJ ENGINEERING CONTROLS PRIVATE LIMITED",
"SAMRAJ MARKETING AND SERVICES PRIVATE LIMITED",
"SAMRAJ PHARMACEUTICALS PRIVATE LIMITED",
"SAMRAJ POLYTEX LIMITED",
"SAMRAJ TEXTILES PRIVATE LIMITED",
"SAMRAJ WHOLESOMELIVING PRIVATE LIMITED",
"SAMRAJYA AROMATICS PRIVATE LIMITED",
"SAMRAKSHA HEALTH CARE PRIVATE LIMITED",
"SAMRAKSHA SUPER SPECIALITY HOSPITAL",
"SAMRAKSHANA ELECTRICALS LIMITED",
"SAMRAKSHANA PROPERTY SERVICES PRIVATE LIMITED",
"SAMRAN MEDIA CONSULTANTS PRIVATE LIMITED",
"SAMRAN TECH PRIVATE LIMITED",
"SAMRASA APPAREL PRIVATE LIMITED",
"SAMRAT BUILDTECH (INDIA) PRIVATE LIMITED",
"SAMRAT BUSINESS INDIA PRIVATE LIMITED",
"SAMRAT CARS PRIVATE LIMITED",
"SAMRAT FASHIONS AND INFRA PRIVATE LIMITED",
"SAMRAT FERRO ALLOYS PRIVATE LIMITED",
"SAMRAT FORGINGS LIMITED",
"SAMRAT FURNACES PRIVATE LIMITED",
"SAMRAT GEMS IMPEX PRIVATE LIMITED",
"SAMRAT HOUSEWARE PRIVATE LIMITED",
"SAMRAT HYDRAULICS PVT LTD",
"SAMRAT INFRA ESTATE PRIVATE LIMITED",
"SAMRAT INTERIORS PRIVATE LIMITED",
"SAMRAT IRONS PRIVATE LIMITED",
"SAMRAT LAMINATES PRIVATE LIMITED",
"SAMRAT MOVIES PRIVATE LIMITED",
"SAMRAT NAMKEEN PRIVATE LIMITED",
"SAMRAT OFFSET PRIVATE LIMITED",
"SAMRAT PHARMACHEM LIMITED",
"SAMRAT PLYWOOD INDUSTRIES",
"SAMRAT PLYWOOD LIMITED",
"SAMRAT REMEDIES LIMITED",
"SAMRAT RICE MILL PRIVATE. LIMITED.",
"SAMRAT SEA BRINES PRIVATE LIMITED",
"SAMRAT SHIPPING COMPANY PRIVATE LIMITED",
"SAMRAT SUBMERSIBLE (GUJARAT) PRIVATE LIMITED",
"SAMRAT WIRES PRIVATE LIMITED",
"SAMRATH SUN FAB PVT LTD",
"SAMRDHHI FOODS PRIVATE LIMITED",
"SAMRICK INDIA PRIVATE LIMITED",
"SAMRIDDH CABLES AND CORDS PRIVATE LIMITED",
"SAMRIDDH WIRE PRODUCTS PRIVATE LIMITED",
"SAMRIDDHI AGRO FOODS PRIVATE LIMITED",
"SAMRIDDHI AUTO PRIVATE LIMITED",
"SAMRIDDHI AUTOMATIONS PRIVATE LIMITED",
"SAMRIDDHI CIVILTECH PRIVATE LIMITED",
"SAMRIDDHI COMMODITY & DERIVATIVES PRIVATE LIMITED",
"SAMRIDDHI CONTECH PRIVATE LIMITED",
"SAMRIDDHI DEALMARK PRIVATE LIMITED",
"SAMRIDDHI DIAMONDS PRIVATE LIMITED",
"SAMRIDDHI ELECTROMART PRIVATE LIMITED",
"SAMRIDDHI ENTERPRISES PRIVATE LIMITED",
"SAMRIDDHI FINSERVE INDIA PRIVATE LIMITED",
"SAMRIDDHI HARD COKE INDUSTRIES PRIVATE LIMITED",
"SAMRIDDHI INN HOLIDAYS PRIVATE LIMITED",
"SAMRIDDHI JEWELS PRIVATE LIMITED",
"SAMRIDDHI MEGA STRUCTURES LIMITED",
"SAMRIDDHI METALS PRIVATE LIMITED",
"SAMRIDDHI MULTITRADE PRIVATE LIMITED",
"SAMRIDDHI PACKAGING PRIVATE LIMITED",
"SAMRIDDHI PETROPRODUCTS PRIVATE LIMITED",
"SAMRIDDHI PROCESSORS INDIA PRIVATE. LIMITED.",
"SAMRIDDHI RICE MILL PRIVATE LIMITED",
"SAMRIDDHI TRADETECH PRIVATE LIMITED",
"SAMRIDDHI VENTURES PRIVATE LIMITED",
"SAMRIDH HEALTHY COWS DAIRY FARMS PRIVATE LIMITED",
"SAMRIDH OVERSEAS TRADING PRIVATE LIMITED",
"SAMRIDHI ASSOCIATES PRIVATE LIMITED",
"SAMRIDHI BUILD ESTATE PRIVATE LIMITED",
"SAMRIDHI BUILDDEV PRIVATE LIMITED",
"SAMRIDHI CAR RENTAL PRIVATE LIMITED",
"SAMRIDHI COMPLIANCE CERTIFICATION PRIVATE LIMITED",
"SAMRIDHI DEALERS PRIVATE LIMITED",
"SAMRIDHI EXPORTS PRIVATE LIMITED",
"SAMRIDHI HIGHWAY SOLUTIONS PRIVATE LIMITED",
"SAMRIDHI INDUSTRIAL SERVICES PRIVATE LIMITED",
"SAMRIDHI INFOSYS PRIVATE LIMITED",
"SAMRIDHI INFRA SQUARE PRIVATE LIMITED",
"SAMRIDHI LOGISTICS PRIVATE LIMITED",
"SAMRIDHI MAHILA CROP PRODUCER COMPANY LIMITED",
"SAMRIDHI OILS PRIVATE LIMITED",
"SAMRIDHI PACKAGING FILM PRIVATE LIMITED",
"SAMRIDHI PETROCHEM",
"SAMRIDHI PLYBOARDS PRIVATE LIMITED",
"SAMRIDHI REALTY HOMES PRIVATE LIMITED",
"SAMRIDHI SHARE ANDSTOCK BROKER LIMITED",
"SAMRIDHI STOCKS PRIVATE LIMITED",
"SAMRIDHI VENTURES PRIVATE LIMITED",
"SAMRIN INFRA PRIVATE LIMITED",
"SAMRIN SERVICES PRIVATE LIMITED",
"SAMRITHI MOTORS PRIVATE LIMITED",
"SAMRITHI WHEELS PRIVATE LIMITED",
"SAMROCK CHEMICALS (I) LIMITED",
"SAMRON INFOTECH",
"SAMRRADHI INVESTMENTS CO. PRIVATE LIMITED",
"SAMRUDDH DAIRY PRODUCTS PVT LTD",
"SAMRUDDHA MINECHEM PRIVATE LIMITED",
"SAMRUDDHA SUGAR ENGINEERS PRIVATE LIMITED",
"SAMRUDDHI AGRO PRODUCER COMPANY LIMITED",
"SAMRUDDHI AUTOWORLD PRIVATE LIMITED",
"SAMRUDDHI BUILDING SYSTEM PRIVATE LIMITED",
"SAMRUDDHI CHEMCIALS PVT LTD",
"SAMRUDDHI CREDIT CO-OPERATIVE SOCIETY LTD",
"SAMRUDDHI GLOBAL INFRA PRIVATE LIMITED",
"SAMRUDDHI INDUSTRIES LIMITED",
"SAMRUDDHI KNITLINE PRIVATE LIMITED",
"SAMRUDDHI NURSING INSTITUTE NASHIK",
"SAMRUDDHI NUTRIENTS INDIA PRIVATE LIMITED",
"SAMRUDDHI ORGANIC FARM (INDIA) PRIVATE LIMITED",
"SAMRUDDHI POWER EQUIPMENT SALES PRIVATE LIMITED",
"SAMRUDDHI PUBLICATION",
"SAMRUDDHI SWASTIK TRADING AND INVESTMENTS LIMITED",
"SAMRUDDHI VALUE MARKETING LIMITED",
"SAMRUDDHI WATERWORKS PRIVATE LIMITED",
"SAMRUDDHI WEAVING MILLS PRIVATE LIMITED",
"SAMRUDDHIGREEN CROP CARE PRIVATE LIMITED",
"SAMRUDDHIGREEN FERTILIZERS PRIVATE LIMITED",
"SAMRUDDHIGREEN INFRATECH PRIVATE LIMITED",
"SAMRUDDHII LIQUORS PRIVATE LIMITED",
"SAMRUDH PHARMACARE PRIVATE LIMITED",
"SAMRUDH PHARMACEUTICALS PRIVATE LIMITED",
"SAMRUDH SABAL SHETKARI PRODUCER COMPANY LIMITED",
"SAMRUDH SEEDS PRIVATE LIMITED",
"SAMRUDHDI HEALTH EQUIPMENTS PRIVATE LIMITED",
"SAMRUDHI CREATION (INDIA) PRIVATE LIMITED",
"SAMRUDHI FAB TECH ENGINEERING PRIVATE LIMITED",
"SAMRUDHI INNOVATION PRIVATE LIMITED",
"SAMRUDHI SERICULTUR AGRO PRODUCER COMPANY LIMITED",
"SAMRUDHI SUGARS LIMITED",
"SAMRUDHINI POWER AND ENERGY SOLUTIONS PRIVATE LIMITED",
"SAMRUP TRADING PRIVATE LIMITED",
"SAMRUTHI FINCREDIT PRIVATE LIMITED",
"SAMRVIR BIOTECH PRIVATE LIMITED",
"SAMS ADVANCED CLIMATIC TECHNOLOGIES PRIVATE LIMITED",
"SAMS FACILITIES MANAGEMENT PRIVATE LIMITED",
"SAMS FRUIT PRODUCTS PRIVATE LIMITED",
"SAMS INNOVATIVE SERVICES PRIVATE LIMITED",
"SAMS MARITIME EDUCATION PRIVATE LIMITED",
"SAMS PROPERTY DEVELOPERS AND HOTELS PRIVATE LIMITED",
"SAMS STRATEGY PRIVATE LIMITED",
"SAMS TECHNO MECH PRIVATE LIMITED",
"SAMSAI INFRA PRIVATE LIMITED",
"SAMSARA BUILDTECH PRIVATE LIMITED",
"SAMSARA CLOTHING PRIVATE LIMITED",
"SAMSARA FACILITY MANAGEMENT PRIVATE LIMITED",
"SAMSARA FASHIONS PRIVATE LIMITED",
"SAMSARA FINANCE PRIVATE LIMITED",
"SAMSARA FUND ADVISORS PRIVATE LIMITED",
"SAMSARA SHIPPING PRIVATE LIMITED",
"SAMSARA STUDIO PRIVATE LIMITED",
"SAMSDEGOREC SOFTWARE SERVICES PRIVATE LIMITED",
"SAMSHEK FASHION PRIVATE LIMITED",
"SAMSI REAL ESTATE DEVELOPMENT PRIVATE LIMITED",
"SAMSI RICE MILL PVT LTD",
"SAMSIDH GROUP OF SCHOOLS",
"SAMSIDH TULI PUBLIC SCHOOL",
"SAMSIKA MARKETING CONSULTANTS PRIVATE LIMITED",
"SAMSKAR FINANCIAL SERVICES PRIVATE LIMITED",
"SAMSKARA IAS ACADEMY",
"SAMSKRITI BUSINESS SOLUTIONS PRIVATE LIMITED",
"SAMSKRUTHI SCHOOL",
"SAMSKRUTHY PHARMA PRIVATE LIMITED",
"SAM-SMOKELESS FUEL PRIVATE LIMITED",
"SAMSOIL PETROLEUM INDIA LIMITED",
"SAMSON AGRI POWER EQUIPMENTS PRIVATE LIMITED",
"SAMSON CONTROLS PRIVATE LIMITED",
"SAMSON EXTRUSIONS INDUSTRIES PRIVATE LIMITED",
"SAMSON FREIGHT PVT LTD",
"SAMSON HEALTHCARE PRIVATE LIMITED",
"SAMSON LABORATORIES PRIVATE LIMITED",
"SAMSON LIGHTING PRIVATE LIMITED",
"SAMSON MARITIME LIMITED",
"SAMSON SECURITAS PRIVATE LIMITED",
"SAMSON SOFTWARE SOLUTION PRIVATE LIMITED",
"SAMSON SOLAR POWER PRIVATE LIMITED",
"SAMSONITE SOUTH ASIA PRIVATE LIMITED",
"SAMSONS RUBBER INDUSTRIES PRIVATE LIMITED",
"SAMSOR BANN TRADERS PRIVATE LIMITED",
"SAMSTHITHI IRON PRIVATE LIMITED",
"SAMSUN CERAMIC PRIVATE LIMITED",
"SAMSUNG C & T CORPORATION INDIA PRIVATE LIMITED",
"SAMSUNG C & T INDIA PRIVATE LIMITED",
"SAMSUNG C&T CORPORATION INDIA PRIVATE LIMITED",
"SAMSUNG DATA SYSTEMS INDIA PRIVATE LIMITED",
"SAMSUNG DISPLAY NOIDA PRIVATE LIMITED",
"SAMSUNG ELECTRO MECHANICS CO LIMITED",
"SAMSUNG ELECTRO MECHANICS SOFTWARE INDIA BANGALORE PRIVATE LIMITED",
"SAMSUNG E&A INDIA PRIVATE LIMITED",
"SAMSUNG HEAVY INDUSTRIES INDIA PRIVATE LIMITED",
"SAMSUNG HOSPITALITY INDIA PRIVATE LIMITED",
"SAMSUNG INDIA ELECTRONICS PRIVATE LIMITED",
"SAMSUNG IREX INDIA LLP",
"SAMSUNG OVERSEAS LIMITED",
"SAMSUNG R&D INSTITUTE INDIA BANGALORE PRIVATE LIMITED",
"SAMSUNG SDI INDIA PRIVATE LIMITED",
"SAMSUNG SUITINGS PRIVATE LIMITED",
"SAMSURYA CONSTRUCTIONS PRIVATE LIMITED",
"SAMT FOODS PRIVATE LIMITED",
"SAMTA CREATION PRIVATE LIMITED",
"SAMTA ENERGY PRIVATE LIMITED",
"SAMTA IMPEX PRIVATE LIMITED",
"SAMTA PLASTICS PVT LTD",
"SAMTA SILK MILLS PRIVATE LIMITED",
"SAMTA TEXTILE PRIVATE LIMITED",
"SAMTA YARNS PRIVATE LIMITED",
"SAMTEC TOOLS & ACCESSORIES PRIVATE LIMITED",
"SAMTEC TRADING INDIA PRIVATE LIMITED",
"SAMTECH AUTOMOTIVES INDIA PRIVATE LIMITED",
"SAMTECH DATASYS PRIVATE LIMITED",
"SAMTECH DEVICES INDIA PRIVATE LIMITED",
"SAMTECH INFONET LIMITED",
"SAMTECH MACHINERY",
"SAMTEL AVIONICS LIMITED",
"SAMTEL HAL DISPLAY SYSTEM",
"SAMTEL THALES AVIONICS",
"SAMTEX EXPORTS PRIVATE LIMITED",
"SAMTRON OVERSEAS PRIVATE LIMITED",
"SAMTRON POWER PROJECTS PRIVATE LIMITED",
"SAMTUSTHA FACILITY SERVICES INDIA PRIVATE LIMITED",
"SAMTUSTHA SERVICES INDIA PRIVATE LIMITED",
"SAMUCHIT CONSULTANCY SERVICE INDIA PRIVATE LIMITED",
"SAMUDAYIK SWASTHYA KENDRA",
"SAMUDERA ALLIANCE LINE PRIVATE LIMITED",
"SAMUDERA SHIPPING LINE INDIA PRIVATE LIMITED",
"SAMUDGATE LOGISTICS PRIVATE LIMITED",
"SAMUDHRA MARINE ENGINEERING PRIVATE LIMITED",
"SAMUDRA ALLOYS PRIVATE LIMITED",
"SAMUDRA CARGO HANDLING PRIVATE LIMITED",
"SAMUDRA DARSHAN GRUHPRAVESH LLP",
"SAMUDRA DREDGING PRIVATE LIMITED",
"SAMUDRA DYE CHEM PRIVATE LIMITED",
"SAMUDRA ELECTRONIC SYSTEM PRIVATE LIMITED",
"SAMUDRA ENTERPRISE PRIVATE LIMITED",
"SAMUDRA HEALTH CARE ENTERPRISES LIMITED",
"SAMUDRA LOGISTICS & SHIPPING PRIVATE LIMITED",
"SAMUDRA MARINE SERVICES PRIVATE LIMITED",
"SAMUDRA PUMPS INDIA PRIVATE LIMITED",
"SAMUDRA SHIPYARD PRIVATE LIMITED",
"SAMUDRA VEHICLES PRIVATE LIMITED",
"SAMUDYAM PROJECTS PRIVATE LIMITED",
"SAMUEL & JOSEPH HOTEL PRIVATE LIMITED",
"SAMUHA ENGINEERING INDUSTRIES PRIVATE LIMITED",
"SAMUH-LAXMI CHEMICALS (BOMBAY) PRIVATE LIMITED",
"SAMUNDAR FABRICS PVT LTD",
"SAMUNDRA INSTITUTE OF MARITIME STUDIES TRUST",
"SAMUNNATI AGRI INNOVATIONS LAB PRIVATE LIMITED",
"SAMUNNATI AGRO SOLUTIONS PRIVATE LIMITED",
"SAMUNNATI FINANCIAL INTERMEDIATION & SERVICES PRIVATE LIMITED",
"SAMUNNATI PROJECTS PRIVATE LIMITED",
"SAMURAI ELECTRICALS PRIVATE LIMITED",
"SAMURAI EXPORTS PRIVATE LIMITED",
"SAMURAI IT SERVICES PRIVATE LIMITED",
"SAMURAI SECURITIES PRIVATE LIMITED",
"SAMUTHRA INFRASTRUCTURE PRIVATE LIMITED",
"SAMUTSAHA TECH PRIVATE LIMITED",
"SAMUX PRECISION TECHNOLOGY PRIVATE LIMITED",
"SAMVAAD E-SOLUTIONS PRIVATE LIMITED",
"SAMVAAD REAL ESTATE LLP",
"SAMVAAD VIDEO PRIVATE LIMITED",
"SAMVADA",
"SAMVARA BUILDTECH PRIVATE. LIMITED.",
"SAMVARDHAN MARKETING PRIVATE LIMITED",
"SAMVARDHANA MOTHERSON AUTO COMPONENT PRIVATE LIMITED",
"SAMVARDHANA MOTHERSON AUTO SYSTEM PRIVATE LIMITED",
"SAMVARDHANA MOTHERSON GLOBAL CARRIERS LIMITED",
"SAMVARDHANA MOTHERSON HEALTH SOLUTION LIMITED",
"SAMVARDHANA MOTHERSON INNOVATIVE SOLUTIONS LIMITED",
"SAMVARDHANA MOTHERSON INTERNATIONAL LIMITED",
"SAMVARDHANE TECHNOLOGIES PRIVATE LIMITED",
"SAMVED MEDICARE PRIVATE LIMITED",
"SAMVED SCHOOL",
"SAMVEDA LOGISTICS INFRARESOURCES PRIVATE LIMITED",
"SAMVEDANA HEALTH SERVICES PRIVATE LIMITED",
"SAMVEDNA BUILDERS PRIVATE LIMITED",
"SAMVEDNA SENIOR CARE PRIVATE LIMITED",
"SAMVEEL POWER AND INFRASTRUCTURE PRIVATE LIMITED",
"SAMVIC SERVICES PRIVATE LIMITED",
"SAMVIK ENGINEERING PRIVATE LIMITED",
"SAMVIK MARKETING PRIVATE",
"SAMVIT BUILD CARES PRIVATE LIMITED",
"SAMVIT ENTERPRISES PRIVATELIMITED",
"SAMVITTI CAPITAL PRIVATE LIMITED",
"SAMVRIDDHI INCLUSIVE GROWTH NETWORK PRIVATE LIMITED",
"SAMVRIDDHI INFOTECH PRIVATE LIMITED",
"SAMVRITI SCREEN ARMOUR PRIVATE LIMITED",
"SAMWHA ELECTRA PRIVATE LIMITED",
"SAMWHA INDIA REFRACTORIES PRIVATE LIMITED",
"SAMWON MOULD INDIA PRIVATE LIMITED",
"SAMWOO PACKING SYSTEM INDIA PRIVATE LIMITED",
"SAMY EXTRACTS PRIVATE LIMITED",
"SAMY INFORMATICS PRIVATE LIMITED",
"SAMY ORGANICS PRIVATE LIMITED",
"SAMYAAN SERVICES PRIVATE LIMITED",
"SAMYAG BROKING PRIVATE LIMITED",
"SAMYAGYA ENGINEERS PRIVATE LIMITED",
"SAMYAK (INDIA) PRIVATE LIMITED",
"SAMYAK AGENCIES PRIVATE LIMITED",
"SAMYAK AUTO ENGINEERS PRIVATE LIMITED",
"SAMYAK C2 INFRA PRIVATE LIMITED",
"SAMYAK CREATIONS PRIVATE LIMITED",
"SAMYAK DAIGNOSTIC PRIVATE LIMITED",
"SAMYAK DEPARTMENTAL STORES PRIVATE LIMITED",
"SAMYAK ECO-FUEL PRIVATE LIMITED",
"SAMYAK EDUTECH",
"SAMYAK ENTREPRENEURS PRIVATE LIMITED",
"SAMYAK EXIM PRIVATE LIMITED",
"SAMYAK FABRICS PRIVATE LIMITED",
"SAMYAK GRUHNIRMAN PRIVATE LIMITED",
"SAMYAK INFOTECH PRIVATE LIMITED",
"SAMYAK INFRA ESTATE PRIVATE LIMITED",
"SAMYAK INSTRUMENTATION PRIVATE LIMITED",
"SAMYAK INTERNATIONAL LIMITED",
"SAMYAK IRRIGATION PRIVATE LIMITED",
"SAMYAK LIFESTYLES PRIVATE LIMITED",
"SAMYAK METALS PRIVATE LIMITED",
"SAMYAK MOTORS PRIVATE LIMITED",
"SAMYAK PAPERS PRIVATE LIMITED",
"SAMYAK REALTIES PRIVATE LIMITED",
"SAMYAK RETAIL SERVICE PRIVATE. LIMITED",
"SAMYAK SECURITY AND LABOUR SUPPLIERS",
"SAMYAK STEELS PRIVATE LIMITED",
"SAMYAK SYNTHETICS PRIVATE LIMITED",
"SAMYAMA JYOTHI SOLAR ENERGY PRIVATE LIMITED",
"SAMYOGA VAIDYA ASSOCIATES PRIVATE LIMITE D",
"SAMYOTECH SOFTWARE SOLUTIONS PRIVATE LIMITED",
"SAMYUG INFRACON PRIVATE LIMITED",
"SAMYUKTA AGRITECH PRIVATE. LIMITED.",
"SAMYUKTA KARNATAKA",
"SAMYUKTHA ELECTRO CONTROLS PRIVATE LIMITED",
"SAMYUKTHAS SCOPE PRIVATE LIMITED",
"SAN ACADEMY PALLIKARANAI",
"SAN AND SAN AUTO PRIVATE LIMITED",
"SAN AUTOMOTIVE INDUSTRIES PRIVATE LIMITED",
"SAN BEVERAGES PRIVATE LIMITED",
"SAN DYNAMICS TECHNOVA PRIVATE LIMITED",
"SAN ENGINEERING AND LOCOMOTIVE COMPANY LIMITED",
"SAN ENVIROTECH PRIVATE LIMITED",
"SAN FAB COMPANY",
"SAN GLOBAL HOSPITALITY PRIVATE LIMITED",
"SAN GREENS LIMITED",
"SAN HEALTHSOFT SOLUTIONS PRIVATE LIMITED",
"SAN INFOSOLUTIONS PRIVATE LIMITED",
"SAN INTERNATIONAL A DIVISON OF S.G.M PRIVATE LIMITED",
"SAN IT SOLUTIONS PRIVATE LIMITED",
"SAN JOSE INDIA INFRASTRUCTURE & CONSTRUCTION PRIVATE LIMITED",
"SAN LANDMARK PRIVATE LIMITED",
"SAN MAHU MOTELS PVT LTD",
"SAN MARINE",
"SAN MEDIA PRIVATE LIMITED",
"SAN MOTORS LIMITED",
"SAN POWER GENERATION TRANSMISSION PRIVATE LIMITED",
"SAN PRINTECH PRIVATE LIMITED",
"SAN PRINTS PRIVATE LIMITED",
"SAN PROPERTIES PRIVATE LIMITED",
"SAN ROLLING STOCK SERVICES LIMITED",
"SAN SHIPPING AND LOGISTICS (INDIA) PRIVATE LIMITED",
"SAN STAMPINGS PVT LTD",
"SAN SYSTEMS & CONTROLS PRIVATE LIMITED",
"SAN TECHNOLOGIES PRIVATE LIMITED",
"SAN TELEQUIP PRIVATE LIMITED",
"SAN TRICA REALTORS LIMITED",
"SAN TUBES LIMITED",
"SAN TURNKEY PROJECTS PRIVATE LIMITED",
"SAN WOOD INDIA PRIVATE LIMITED",
"SANA BUILD TECH PRIVATE LIMITED",
"SANA ENTERPRISES PRIVATE LIMITED",
"SANA HERBALS PVT. LTD.",
"SANA HOMES PRIVATE LIMITED",
"SANA HOSPITALITY SERVICES PRIVATE LIMITED",
"SANA IMPEX PRIVATE LIMITED",
"SANA LIFESTYLES LIMITED",
"SANA MILK & VEGETABLE PRIVATE LIMITED",
"SANA SOFTWARE SERVICES (OPC) PRIVATE LIMITED",
"SANA TELENETWORKS PRIVATE LIMITED",
"SANA TOYS INDIA PRIVATE LIMITED",
"SANA'A DISTRIBUTORS INDIA PRIVATE LIMITED",
"SANAARA SOLUTIONS PRIVATE LIMITED",
"SANAC INDIA PRIVATE LIMITED",
"SANAH FOREX AND TRAVELS PRIVATE LIMITED",
"SANAKA EDUCATIONAL TRUST‚ÄôS GROUP OF INSTITUTIONS",
"SANAKA MATA POULTRIES PRIVATE LIMITED",
"SANAKA MEDICAL PRIVATE LIMITED",
"SANAKO ENGINEERS & DEVELOPERS PRIVATE LIMITED",
"SANALI POWER PRIVATE LIMITED",
"SANAMS SHERATON RESORTS AND HOTELS PRIVATE LIMITED",
"SANAND NAGAR PALIKA",
"SANANDA FASHIONS PRIVATE LIMITED",
"SANASUNU HOSPITALITY PRIVATE LIMITED",
"SANAT PRINTERS",
"SANAT PRODUCTS LIMITED",
"SANAT VILLA PRIVATE LIMITED",
"SANATAN AUTOPLAST PRIVATE LIMITED",
"SANATAN BAZAAR PRIVATE LIMITED",
"SANATAN BUS BODY BUILDERS PRIVATE LIMITED",
"SANATAN CO OP CREDIT SOCIETY LIMITED",
"SANATAN DHARAM INTER COLLEGE",
"SANATAN FINANCIAL ADVISORY SERVICES PRIVATE LIMITED",
"SANATAN JEWELS PRIVATE LIMITED",
"SANATAN MERCHANTS PRIVATE LIMITED SMPL",
"SANATANAYA WAREHOUSING PRIVATE LIMITED",
"SANATHAN BIOMEDICS PRIVATE LIMITED",
"SANATHAN POLYCOT PRIVATE LIMITED",
"SANATHAN TEXTILES LIMITED",
"SANATHANA DHARMA COLLEGE S D COLLEGE",
"SANATHANA FOODS PRIVATE LIMITED",
"SANATHNAGAR ENTERPRISES LIMITED",
"SANATIO PHARMACEUTICALS PRIVATE LIMITED",
"SANATRA HEALTH CARE",
"SANAUTO ENGINEERS (INDIA) PRIVATE LIMITED",
"SANAVI INFRABUILDCON PRIVATE LIMITED",
"SANAVI NETWORK PRIVATE LIMITED",
"SANAYA REALTIES PRIVATE LIMITED",
"SANAYA TEA PRIVATE LIMITED",
"SANBAY NETWORKS PRIVATE LIMITED",
"SANBEE'S HOTEL PRIVATE LIMITED",
"SANBHAV PROJECTS PRIVATE LIMITED",
"SANBLUE CORPORATION LIMITED",
"SANBRAINS ERA TECHNOLOGIES PRIVATE LIMITED",
"SANBROS SPARES PRIVATE LIMITED",
"SANCARA MD PRIVATE LIMITED",
"SANCARA SHAMPAD PRIVATE LIMITED",
"SANCHAITI HOSPITAL PRIVATE LIMITED",
"SANCHALANA CHITS PRIVATE LIMITED",
"SANCHAN INFO SOLUTIONS PRIVATE LIMITED",
"SANCHAR ELECTRONICS PVT LTD",
"SANCHAR ENGINEERS PRIVATE LIMITED",
"SANCHAR INFRATECH PRIVATE LIMITED",
"SANCHAR NEST SAHKARI AWAS SAMITI LIMITED.",
"SANCHAR TEKNIKS PRIVATE LIMITED",
"SANCHAR TELENETWORK PRIVATE LIMITED",
"SANCHAR TELESYSTEMS LIMITED",
"SANCHARY MARINE PRODUCTS AND TRANSPORTERS PRIVATE LIMITED",
"SANCHAY GREENTECH PRIVATE LIMITED",
"SANCHAY HOLDINGS PRIVATE LIMITED",
"SANCHAY VANIJYA RASAYAN PRIVATE LIMITED",
"SANCHAY WEALTH PRIVATE LIMITED",
"SANCHAYA STAFFING SERVICES PRIVATE LIMITED",
"SANCHEETA INFRA PROJECTS SOLUTION PRIVATE LIMITED",
"SANCHEM FABRICS LIMITED",
"SANCHEM SOPHIN PRIVATE LIMITED",
"SANCHET SOFTECH PRIVATE LIMITED",
"SANCHETI FAMILY FOODS (INDIA) PRIVATE LIMITED.",
"SANCHETI GAS BOTTLING PRIVATE LTD",
"SANCHETI GRAPHITECH SERVICES PVT.LTD.",
"SANCHETI HOSPITAL",
"SANCHETI INST FOR ORTHOPAEDICS REHABI",
"SANCHETI INSTITUTE FOR ORTHOPAEDICS AND REHABILITATION",
"SANCHETI ONIONS PRIVATE LIMITED",
"SANCHETI PACKAGING PRIVATE LIMITED",
"SANCHETI POLYTEX PRIVATE LIMITED",
"SANCHETNA FINANCIAL SERVICES PRIVATE LIMITED",
"SANCHEZ CAPITAL SERVICES PRIVATE LIMITED",
"SANCHHAYA CLASSES PRIVATE LIMITED",
"SANCHHAYA EDUCATION PRIVATE LIMITED",
"SANCHI CEREALS PRIVATE LIMITED",
"SANCHI CHEMICALS PVT LTD",
"SANCHI MEDIAIDS PRIVATE LIMITED",
"SANCHI ORGANICS PVT LTD",
"SANCHI UNIVERSITY OF BUDDHIST",
"SANCHIT CREDIT & CONSTRUCTIONS PRIVATE LIMITED",
"SANCHIT EXPORTS PRIVATE LIMITED",
"SANCHIT METALS PRIVATE LIMITED",
"SANCHIT OPTIC",
"SANCHIT SALES PRIVATE LIMITED",
"SANCHIT VYAPAAR PVT LTD",
"SANCHITA ESTATES AND HOLDING PRIVATE LIMITED",
"SANCHITA FROZEN FOODS PRIVATE LIMITED",
"SANCHITA MARINE PRODUCTS PRIVATE LIMITED",
"SANCHIYAN TECHNO AND EQUIPMENT PRIVATE LIMITED",
"SANCHOLI SILK MILLS PRIVATE LIMITED",
"SANCHORE RENEWABLE PRIVATE LIMITED",
"SANCHYA MINERALS PRIVATE LIMITED",
"SANCINOVA ANIMAL HEALTH PRIVATE LIMITED",
"SANCO INDIA EDU SOLUTIONS PRIVATE LIMITED",
"SANCO TRANS LIMITED",
"SANCON BUILDCON PRIVATE LIMITED",
"SANCRAFT INDUSTRIES PRIVATE LIMITED",
"SANCTA MARIA INTERNATIONAL SCHOOL",
"SANCTOR DIGITAL PRIVATE LIMITED (OPC)",
"SANCTUARY DEVELOPERS PRIVATE LIMITED",
"SANCTUARY INFRATECH PRIVATE LIMITED",
"SANCTUM INFOSOLUTIONS PRIVATE LIMITED",
"SANCTUM TECHNOLOGIES PRIVATE LIMITED",
"SANCTUM TRADING CORPORATION PRIVATE LIMITED",
"SANCTUM WEALTH PRIVATE LIMITED",
"SANCTUM WORK WEAR PRIVATE LIMITED",
"SANCTUS BIO PRIVATE LIMITED",
"SANCTUS DRUGS & PHARMACEUTICALS PVT LTD",
"SANCTUS GLOBAL FORMULATIONS LIMITED",
"SANCUBE INFRA PROJECTS PRIVATE LIMITED",
"SANCUS NETWORKS PRIVATE LIMITED",
"SAND CHEM INDIA LIMITED",
"SAND DUNE BUILDCON PRIVATE LIMITED",
"SAND DUNES ACADEMY",
"SAND DUNES LEISURE HOMES PRIVATE LIMITED",
"SAND IMPEX PRIVATE LIMITED",
"SAND LAND REAL ESTATES PRIVATE LIMITED",
"SAND MARTIN CONSULTANTS PRIVATE LIMITED",
"SAND PEBBLES TOUR 'N' TRAVELS (INDIA) PRIVATE LIMITED",
"SANDA OFFICE MANAGEMENT SERVICES PRIVATE LIMITED",
"SANDAAR AGRO PRIVATE LIMITED",
"SANDAL BUILDCON PRIVATE LIMITED",
"SANDAL ENTERPRISES PRIVATE LIMITED",
"SANDAL SUITES PRIVATE LIMITED",
"SANDALWOOD MALL MANAGEMENT PRIVATE LIMITED",
"SANDALWOOD RESORTS PRIVATE LIMITED",
"SANDARBH FOODS PRIVATE LIMITED",
"SANDAW PRINTS PRIVATE LIMITED",
"SANDBERRY FOAMTECH",
"SANDCITY AUTOTEC PRIVATE LIMITED",
"SANDCUBE INFRASTRUCTURE PRIVATE LIMITED",
"SANDEEP AGRI SCIENCE PRIVATE. LIMITED.",
"SANDEEP AGRO FOODS",
"SANDEEP CARRIERS PRIVATE LIMITED",
"SANDEEP CARS PRIVATE LIMITED",
"SANDEEP CASTINGS PVT LTD",
"SANDEEP COMMERCIAL PRIVATE LIMITED",
"SANDEEP CREATIONS AND FASHIONS PRIVATE LIMITED",
"SANDEEP DWELLERS PRIVATE LIMITED",
"SANDEEP GEETA AND ASSOCIATES PRIVATE LIMITED",
"SANDEEP IMPEX PVT LTD",
"SANDEEP INFRA STEEL PRIVATE LIMITED",
"SANDEEP LEAD ALLOYS INDIA PRIVATE LIMITED",
"SANDEEP MECH. ENGINEERS LIMITED",
"SANDEEP METALCRAFT PRIVATE. LIMITED.",
"SANDEEP MOTORS PRIVATE. LIMITED.",
"SANDEEP OPTICAL COMPANY PRIVATE LIMITED",
"SANDEEP ORGANICS PRIVATE LIMITED",
"SANDEEP PAPER MILLS PRIVATE LIMITED",
"SANDEEP RICE MILL",
"SANDEEP SHIKRE & ASSOCIATES",
"SANDEEP TRADEX PVT LTD",
"SANDEEP TRANSPORT PRIVATE LIMITED",
"SANDEEP TRUCKS PRIVATE LIMITED",
"SANDEEP WEAVERS PRIVATE LIMITED",
"SANDEEPNI DISTRIBUTORS PRIVATE LIMITED",
"SANDEEPS ENERGY PRIVATE LIMITED",
"SANDEEPTI SCANDATA SOLUTIONS PRIVATE LIMITED",
"SANDEN VIKAS INDIA PRIVATE LIMITED",
"SANDEN VIKAS PRECISION PARTS PRIVATE LIMITED",
"SANDERSON GROUP INDIA PRIVATE LIMITED",
"SANDERSON SOLUTIONS INTERNATIONAL INDIA PRIVATE LIMITED",
"SANDESH DIGITAL PRIVATE LIMITED",
"SANDESH DISTRIBUTOR PRIVATE LIMITED",
"SANDESH GASES PRIVATE LIMITED",
"SANDESH VIDYALAYA",
"SANDESH YARN TRADING COMPNAY PRIVATE LIMITED",
"SANDEV STEEL COMPONENTS PRIVATE LIMITED",
"SANDFIELD ENGINEERING COMPANY PRIVATE LIMITED",
"SANDFITS FOUNDRIES PRIVATE LIMITED",
"SANDHA AND ASSOCIATES PRIVATE LIMITED",
"SANDHA AND COMPANY",
"SANDHA HEEMGHAR PRIVATE LIMITED",
"SANDHAR AMKIN INDUSTRIES PRIVATE LIMITED",
"SANDHAR AUTOMACH ATTIBELE A UNIT OF SANDHAR TECHNOLOGIES LTD",
"SANDHAR AUTOMMOTIVES HARIDWAR",
"SANDHAR AUTOMOTIVE SYSTEMS PRIVATE LIMITED",
"SANDHAR COMPONENTS",
"SANDHAR ESTATES PRIVATE LIMITED",
"SANDHAR HAN SHIN AUTO TECHNOLOGIES PRIVATE LIMITED",
"SANDHAR HAN SUNG TECHNOLOGIES PRIVATE LIMITED",
"SANDHAR TECHNOLOGIES LIMITED",
"SANDHAR TOOLING PRIVATE LIMITED",
"SANDHAR WHETRON ELECTRONICS PRIVATE LIMITED",
"SANDHATA TECHNOLOGIES PRIVATE LIMITED",
"SANDHEERA INFRATECH PRIVATE LIMITED",
"SANDHILLS HOLDINGS LIMITED",
"SANDHINI CREATIONS",
"SANDHOUSE HOSPITALITY PRIVATE LIMITED",
"SANDHU CARGO MOVER PRIVATE LIMITED",
"SANDHU CONTRACTORS PRIVATE LIMITED",
"SANDHU GLASS PVT LTD",
"SANDHU MOTO PRIVATE LIMITED",
"SANDHU ROADLINES PRIVATE LIMITED",
"SANDHU TECHNOCRATS PRIVATE LIMITED",
"SANDHU TRANSLOGISTICS INDIA PRIVATE LIMITED",
"SANDHU TUBES PRIVATE LIMITED",
"SANDHU WHEELS AND ALLOYS PRIVATE LIMITED",
"SANDHYA AQUA EXPORTS PRIVATE LIMITED",
"SANDHYA CHEMPLAST PRIVATE LIMITED",
"SANDHYA CONSTRUCTIONS & ESTATES PRIVATE LIMITED",
"SANDHYA CONSULTANCY SERVICES PRIVATE LIMITED",
"SANDHYA DIAM PRIVATE LIMITED",
"SANDHYA HEALTHCARE REMEDY IMPEL PRIVATE LIMITED",
"SANDHYA HOTELS PRIVATE LIMITED",
"SANDHYA HYDRO POWER PROJECTS BALARGHA PRIVATE. LIMITED.",
"SANDHYA INFOPRINT PRIVATE LIMITED",
"SANDHYA KSHITIJ BUILDERS PRIVATE LIMITED",
"SANDHYA MARINES LIMITED",
"SANDHYA ORGANIC CHEMICALS PVT LTD",
"SANDHYA PROTECTORS LIMITED",
"SANDHYA SARAN POLYNULES PRIVATE LIMITED",
"SANDHYA SHANKAR HOSPITALITY SERVICES PRIVATE LIMITED",
"SANDHYA SPINNING MILL LIMITED",
"SANDHYAMANI ASSOCIATES PRIVATE LIMITED",
"SANDHYASAMRAT CONSTRUCTION AND SERVICES PRIVATE LIMITED",
"SANDILA DAIRY UDYOG PRIVATE LIMITED",
"SANDILYAM AUTOMATION SYSTEMS PRIVATE LIMITED",
"SANDIP BIND ENTERPRISES PRIVATE LIMITED",
"SANDIP FOUNDATIONS",
"SANDIPAN PRAMANIK INFRA PRIVATE LIMITED",
"SANDIPANI CBSE HP",
"SANDIPANI ENGLISH SCHOOL HALVAD",
"SANDIPANI SCHOOL",
"SANDISH ADDITIVES PRIVATE LIMITED OPC",
"SANDISK CORPORATION",
"SANDISK INDIA DEVICE DESIGN CENTRE PRIVATE LIMITED",
"SANDIYA EXPORTS PRIVATE LIMITED",
"SANDLA WIND PROJECT PRIVATE LIMITED",
"SANDLER & TRAVIS TRADE ADVISORY INDIA PRIVATE LIMITED",
"SANDLEY CHEM (INDIA) PRIVATE LIMITED",
"SANDMARTIN GLOBAL OUTSOURCING LLP",
"SANDO ROTARY EQUIPMENTS PRIVATE LIMITED",
"SANDO RUBBER PRIVATE LIMITED",
"SANDOOK LOGISTICS PRIVATE LIMITED",
"SANDOR ANIMAL BIOGENICS PRIVATE LIMITED",
"SANDOR LIFE SCIENCES PRIVATE LIMITED",
"SANDOR ORTHOPEDICS PRIVATE LIMITED",
"SANDOR SPECIALITY DIAGNOSTICS PRIVATE LIMITED",
"SANDOR TESCON AQUA PRIVATE LIMITED",
"SANDORI CASTINGS PRIVATE. LIMITED",
"SANDOZ HOSPITALITY PRIVATE LIMITED",
"SANDOZ MERCHANTS PVT. LTD.",
"SANDOZ PRIVATE LIMITED",
"SANDOZ RESTAURANTS PRIVATE LIMITED",
"SANDOZE CHEMICAL & PESTICIDE PRIVATE LIMITED",
"SANDRA SHROFF ROFEL COLLEGE OF NURSING",
"SANDREE HOME SERVICES PRIVATE LIMITED",
"SANDS BEAUTY HOTEL PRIVATE LIMITED",
"SANDS PRECISION PRIVATE LIMITED",
"SANDS SYNERGY PRIVATE LIMITED",
"SANDS TEXTILES CONSULTANTS PRIVATE LIMITED",
"SANDSQUARE GLOBAL SOLUTIONS PRIVATE LIMITED",
"SANDU BROTHERS PRIVATE LIMITED",
"SANDU DEVELOPERS",
"SANDU PHARMACEUTICALS LIMITED",
"SANDUNE PROPERTIES PRIVATE LIMITED",
"SANDUR BYPASS PROJECT LIMITED",
"SANDUR FLUID CONTROLS PRIVATE LIMITED",
"SANDUR LAMINATES LIMITED",
"SANDUR POWER COMPANY PRIVATE LIMITED",
"SANDVIK COROMANT INDIA PRIVATE LIMITED",
"SANDVIK MINING AND ROCK TECHNOLOGY INDIA PRIVATE LIMITED",
"SANDVINE TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"SANDWEDGES FOOD SERVICES PRIVATE LIMITED",
"SANDWICH SQUARE PRIVATE LIMITED",
"SANDWIZZAA FOODS PRIVATE LIMITED",
"SANDWOODS INFRATECH PROJECTS PRIVATE. LIMITED",
"SANDY BAY SEAFOODS INDIA PRIVATE LIMITED",
"SANDY PLASTMOULD PRIVATE LIMITED",
"SANDY RESORT PRIVATE LIMITED",
"SANDYS HOSPITALITY PRIVATE LIMITED",
"SANE EQUIPMENTS PRIVATE LIMITED",
"SANE GREEN INFORMATIC PRIVATE LIMITED",
"SANE GURUJI PRATHAMIK VIDYALAY LATUR",
"SANE GURUJI VIDYALAY KANNAD",
"SANE OVERSEAS PRIVATE LIMITED",
"SANE RESIDENCY PRIVATE LIMITED",
"SANE RETAILS PRIVATE LIMITED",
"SANEAR EXIM INTERNATIONAL PRIVATE LIMITED",
"SANEI MOTORS PRIVATE LIMITED",
"SANELAC CONSULTANTS PRIVATE LIMITED",
"SANELEC EXCITATION SYSTEMS PRIVATE LIMITED",
"SANELITE SOLAR PRIVATE LIMITED",
"SANEWAL AUTO ENGINEERS PVT LTD",
"SANEX PACKAGING CONNECTIONS PRIVATE LIMITED",
"SANFAB ROLLFORMS PRIVATE LIMITED",
"SANFEGAN BIOTECH PRIVATE LIMITED",
"SANFIELD INDIA LIMITED",
"SANFIVE TECHNOLOGIES PRIVATE LIMITED",
"SANFOODS COLD STORAGE PRIVATE LIMITED",
"SANFORD MARKETING PRIVATE LIMITED",
"SANFORD SYNTHETICS (INDIA) PRIVATE LIMITED",
"SANFORD VITRIFIED PRIVATE LIMITED",
"SANFRAN BUILDWELL PRIVATE LIMITED",
"SANFRAN DEVELOPER PRIVATE LIMITED",
"SANFREIGHT LOGISTICS PRIVATE LIMITED",
"SANG INFOTECH PRIVATE LIMITED",
"SANG INFRATECH PRIVATE LIMITED",
"SANGAI CREATION PRIVATE LIMITED",
"SANGAI HEALTHCARE PRIVATE LIMITED",
"SANGAM ALMIRAH PRIVATE LIMITED",
"SANGAM APPLIANCES AND ELECTRICALS PRIVATE LIMITED",
"SANGAM BUILDWAY INDIA PRIVATE LIMITED",
"SANGAM BUILDWELL PRIVATE LIMITED",
"SANGAM BUSINESS CREDIT LIMITED",
"SANGAM CATERERS PRIVATE LIMITED",
"SANGAM COMMODITIES PRIVATE LIMITED",
"SANGAM DEVCON PRIVATE LIMITED",
"SANGAM DRESSES PRIVATE LIMITED",
"SANGAM DYEING AND PRINTING PVT LTD",
"SANGAM E-COM LIMITED",
"SANGAM ENGINEERING ENTERPRISES PRIVATE LIMITED",
"SANGAM FARMERS PRIVATE LIMITED",
"SANGAM FASHIONS PRIVATE LIMITED",
"SANGAM FASHIONS PRIVATE. LIMITED",
"SANGAM FASTENERS PRIVATE LIMITED",
"SANGAM FINSERV LIMITED",
"SANGAM FORGINGS PRIVATE LIMITED",
"SANGAM INDIA LIMITED",
"SANGAM INDIA SALES PRIVATE LIMITED",
"SANGAM INFRATECH LIMITED",
"SANGAM ISPAT (INDIA) PRIVATE LIMITED",
"SANGAM MILK PRODUCER COMPANY LIMITED",
"SANGAM MOTELS PRIVATE LIMITED",
"SANGAM MOULDERS PRIVATE LIMITED",
"SANGAM PLASTIC INDUSTRIES PRIVATE LIMITED",
"SANGAM PREFAB CONCRETE PRODUCTS PRIVATE LIMITED",
"SANGAM PRESS PVT LTD",
"SANGAM PUMPS PRIVATE LIMITED",
"SANGAM REFRIGERATION AND AIR-CONDITIONING SERVICES PRIVATE LIMITE",
"SANGAM RESORTS PVT LTD",
"SANGAM RICE PRIVATE LIMITED",
"SANGAM ROOFTOP SOLAR PRIVATE LIMITED",
"SANGAM SCHOOL OF EXCELLENCE INTERNATIONAL",
"SANGAM SHREE COLLECTIONS PRIVATE LIMITED",
"SANGAM SPINFAB PRIVATE LIMITED",
"SANGAM SPIRITS PRIVATE LIMITED",
"SANGAM STRUCTURALS LIMITED.",
"SANGAM WARPER AND SIZER PRIVATE LIMITED",
"SANGAM WEAVERS APPARELS PRIVATE LIMITED",
"SANGAM WEAVERS PRIVATE LIMITED",
"SANGAM YARN PRIVATE LIMITED",
"SANGAMESHWAR COFFEE ESTATES LIMITED",
"SANGAMESHWAR COLLEGE SOLAPUR",
"SANGAMESHWAR VIDYALAYA NALWANDI BEED",
"SANGAMESHWAR VIDYALAYA NALWANDI TAL & DIST BEED",
"SANGAMITRA EDUCATIONAL SOCIETY",
"SANGAMNATH SUGARS LIMITED",
"SANGAMNER AGRICULTURE PRODUCE TRANSPORT COMPANY PRIVATE LIMITED",
"SANGAMNER -LONI INFRASTRUCTURE PRIVATE LIMITED",
"SANGAMNER MUNICIPAL COUNCIL",
"SANGANER CLOTHING PRIVATE LIMITED",
"SANGANERIYA SPINNING MILLS LIMITED",
"SANGANI INFRASTRUCTURE INDIA PRIVATE LIMITED",
"SANGAR OVERSEAS",
"SANGAT MONEY-EXCHANGE PRIVATE LIMITED",
"SANGAT PRINTERS PRIVATE LIMITED",
"SANGATH",
"SANGATH INFRASTRUCTURES PRIVATE LIMITED",
"SANGAZ CYLINDERS PRIVATE LIMITED",
"SANGEE COMMUNICATIONS PRIVATE LIMITED",
"SANGEET AUDIO INDIA PRIVATE LIMITED",
"SANGEET FASHION TEXTILES PRIVATE LIMITED",
"SANGEET SYNTEX LIMITED",
"SANGEETA ASHOK YADAV",
"SANGEETA ELECTRICALS PRIVATE LIMITED",
"SANGEETA HEALTHCARE PRIVATE LIMITED",
"SANGEETA INDUSTRIES",
"SANGEETA LOGISTICS PRIVATE LIMITED",
"SANGEETA ORNAMENTS AND FOREX PRIVATE LIMITED",
"SANGEETA POLY PACK PRIVATE LIMITED",
"SANGEETA TEXTILE",
"SANGEETA TEXTILE INDUSTRIES PRIVATE LIMITED",
"SANGEETA TOOLS PRIVATE LIMITED",
"SANGEETA TRADERS CHENNAI PRIVATE LIMITED",
"SANGEETH NIDHI LIMITED",
"SANGEETH TEXTILES PRIVATE. LIMITED.",
"SANGEETHA CASTINGS PRIVATE LIMITED",
"SANGEETHA MOBILES PRIVATE LIMITED",
"SANGEETHA TYRE SOLUTIONS PRIVATE LIMITED",
"SANGEETHRAJA WEAVING MILLS PRIVATE LIMITED",
"SANG-FROID CHEMICAL PRIVATE LIMITED",
"SANGHA ERECTORS PRIVATE LIMITED",
"SANGHA HOSPITAL",
"SANGHAI COMMERCIAL & CREDITS PVT LTD",
"SANGHAMITHRA RURAL FINANCIAL SERVICES",
"SANGHAMITRA HOSPITALS PRIVATE LIMITED",
"SANGHAR EXPORTS",
"SANGHARSH COMMERCIALS PRIVATE LIMITED",
"SANGHARSH LIFECARE PRIVATE LIMITED",
"SANGHAVI AGRICULTURE MARKETING AND PROCESSING PRIVATE LIMITED",
"SANGHAVI BOTHRA ENGINEERING COMPANY PRIVATE LIMITED",
"SANGHAVI BULLION PRIVATE LIMITED",
"SANGHAVI COMPUTER CENTRE PRIVATE LIMITED",
"SANGHAVI ENGINEERING PRIVATE LIMITED",
"SANGHAVI FAB TEX PRIVATE LIMITED",
"SANGHAVI FOODS PRIVATE LIMITED",
"SANGHAVI FREIGHT FORWARDERS PRIVATE LIMITED",
"SANGHAVI INDUSTRIES PRIVATE LIMITED",
"SANGHAVI SAVLA STOCK BROKER LIMITED",
"SANGHAVI SHOE ACCESSORIES PRIVATE LIMITED",
"SANGHEI INFRASTRUCTURE PRIVATE LIMITED",
"SANGHI (MTB) TRUCKING PRIVATE LIMITED",
"SANGHI AUTOMOTIVE PRIVATE LIMITED",
"SANGHI BROTHERS INDORE PRIVATE LIMITED",
"SANGHI CARS (INDIA) PRIVATE LIMITED",
"SANGHI COLLEGE",
"SANGHI FOUR WHEELS PRIVATE LIMITED",
"SANGHI HIRE PURCHASE LIMITED",
"SANGHI INDUSTRIES LIMITED",
"SANGHI JEWELLERS PRIVATE LIMITED",
"SANGHI MEDICAL CENTRE PRIVATE LIMITED",
"SANGHI MOTORS (BOMBAY) PRIVATE LIMITED",
"SANGHI OXYGEN (BOMBAY) PVT LTD",
"SANGHI POLYMERS LIMITED",
"SANGHI SPINNERS INDIA LIMITED",
"SANGHI THREADS PRIVATE LIMITED",
"SANGHI TUBES PRIVATE LIMITED",
"SANGHI UDYOG INDIA PRIVATE LIMITED",
"SANGHU ENERGY SAVING SYSTEMS PRIVATE LIMITED",
"SANGHVI & CHANDAN ALLOYS PRIVATE LIMITED",
"SANGHVI AEROSPACE PVT LTD",
"SANGHVI BEAUTY AND SALON PRIVATE LIMITED",
"SANGHVI BRANDS LIMITED",
"SANGHVI BROTHERS TRADING PVT. LTD.",
"SANGHVI CONSUMER APPLIANCES PRIVATE LIMITED",
"SANGHVI CYLINDERS PRIVATE LIMITED",
"SANGHVI CYLINDERS UNIT II PRIVATE LIMITED",
"SANGHVI DENIM JUNCTION PRIVATE LIMITED",
"SANGHVI DHANRUP JI DEVAJI & CO",
"SANGHVI ERECTORS PRIVATE LIMITED",
"SANGHVI EXPORTS PVT LTD",
"SANGHVI FITNESS PRIVATE LIMITED",
"SANGHVI FOODS PRIVATE LIMITED",
"SANGHVI INFOTECH PRIVATE LIMITED",
"SANGHVI INTERNATIONAL EDUCATIONAL SOCIETY",
"SANGHVI KANTABEN KANTILAL KASTURCHAND KOTHARI HIGH SCHOOL VAKTAPUR",
"SANGHVI LAND DEVELOPERS PRIVATE LIMITED",
"SANGHVI MOVERS LIMITED",
"SANGHVI OFFICE EQUIPMENTS PVT LTD",
"SANGHVI ORGANICS PRIVATE LIMITED",
"SANGHVI PHARMACHEM PVT LTD",
"SANGHVI POLYFIL PRIVATE LIMITED",
"SANGHVI PREMISES PRIVATE LIMITED",
"SANGHVI QUALITY PRODUCTS PRIVATE LIMITED",
"SANGHVI REALTY PRIVATE LIMITED",
"SANGHVI SECURITIES PRIVATE LIMITED",
"SANGHVI SHANTIDEVI PUKHRAJ JAIN CHARITABLE FOUNDATION",
"SANGHVI WOODS PRIVATE LIMITED",
"SANGHVI YARN PRIVATE LIMITED",
"SANGHVI'S FUTURISTIC INSUPACK PRIVATE LIMITED",
"SANGI HEALTHCARE PRIVATE LIMITED",
"SANGILI TEXTILES PRIVATE LIMITED",
"SANGINI DESIGNER WEARS LIMITED",
"SANGINI INFRA LLP",
"SANGINI PROPERTIES PRIVATE LIMITED",
"SANGINITA CHEMICALS LIMITED",
"SANGIR PLASTICS PRIVATE LIMITED",
"SANGITA ESTATES PVT LTD",
"SANGITA SALES PRIVATE LIMITED",
"SANGKAJ AUTO COMPONENTS PRIVATE LIMITED",
"SANGKAJ AUTO PARTS PRIVATE LIMITED",
"SANGKAJ BRIGHT WIRES PRIVATE LIMITED",
"SANGKAJ DISTRIBUTORS PRIVATE LIMITED",
"SANGKAJ ENGINEERING PRIVATE LIMITED",
"SANGKAJ INDUSTRIES PRIVATE LIMITED",
"SANGKAJ LOGISYS PRIVATE LIMITED",
"SANGKAJ STEEL LIMITED",
"SANGKAJ STEEL PRIVATE LIMITED",
"SANGLE AGRO EXPORT PRIVATE LIMITED",
"SANGLE AGRO PROCESSING PRIVATE LIMITED",
"SANGLE ENTERPRISES PRIVATE LIMITED",
"SANGLI ALUMINIUM EXTRUSIONS PVT LTD",
"SANGLI BANK",
"SANGLI DISTRICT AGRO FARMER PRODUCER COMPANY LIMITED",
"SANGLI DISTRICT CENTRAL CO OP BANK LTD",
"SANGLI ICAP LIQUORS PRIVATE LIMITED",
"SANGLI MEDICARES PRIVATE LIMITED",
"SANGLI MIRAJ & KUPWAD MUNICIPAL CORPORATION",
"SANGLI MIRAJ AND KUPWAD MUNICIPAL CORPORATION",
"SANGLI SIDHI VINAYAK TRADING PRIVATE LIMITED",
"SANGMESHWAR INTERNATIONAL PRIVATE LIMITED",
"SANGMESHWAR PRATHAMIK VIDYAMANDIR LATUR",
"SANGNA TEXTILES PRIVATE LIMITED",
"SANGNI INTERNATIONAL EXIM PRIVATE LIMITED",
"SANGO AUTO FORGE PRIVATE LIMITED",
"SANGO INDIA AUTOMOTIVE PARTS PRIVATE LIMITED",
"SANGOD TRANSMISSION SERVICE LIMITED",
"SANGOLA AGRO PRIVATE LIMITED",
"SANGOMA TECHNOLOGIES PRIVATE LIMITED",
"SANGOTRA FASHIONS PRIVATE LIMITED",
"SANGRA RICEMILL PRIVATE LIMITED",
"SANGRAM AUTO COMPONENTS PRIVATE LIMITED",
"SANGRAM INFRASTRUCTURE PRIVATE LIMITED",
"SANGRAM TYRES PRIVATE LIMITED",
"SANGRAM WHEELS PRIVATE LIMITED",
"SANGRAMPUR AGRO FOOD PRODUCT PRIVATE LIMITED",
"SANGRIA HOSPITALITY PRIVATE LIMITED",
"SANGRILA INFRADEVELOPERS PRIVATE LIMITED",
"SANGRILA LIFESTYLE PRIVATE LIMITED",
"SANGROSE LABORATORIES PRIVATE LIMITED",
"SANGRUL HIGH SCHOOL",
"SANGRUR AGRO LIMITED",
"SANGRUR INDUSTRIAL CORPORATION PRIVATE LIMITED",
"SANGRUR PULP PACKAGING PVT LTD",
"SANGSHARMANN PLAST PRIVATE LIMITED",
"SANGSHRI ELECTRICALSS PRIVATE LIMITED",
"SANGSIN BRAKE INDIA PRIVATE LIMITED",
"SANGU CHAKRA HOTELS PRIVATE LIMITED",
"SANGUINE ENTERPRISES PRIVATE LIMITED",
"SANGUINE INFRA TECH PRIVATE LIMITED",
"SANGUINE INSURANCE BROKERS PRIVATE LIMITED",
"SANGUINE LOGISTICS PRIVATE LIMITED",
"SANGUINE MANAGEMENT SERVICES PRIVATE LIMITED",
"SANGUINE SPORTS PRIVATE LIMITED",
"SANGUINE SUPPLY CHAIN SOLUTIONS LLP",
"SANGWAN HEIGHTS PRIVATE LIMITED",
"SANGWAN INFRA PROJECT PRIVATE LIMITED",
"SANGWAN LANDCO PRIVATE LIMITED",
"SANGWAN LOGISTICS INDIA PRIVATE LIMITED",
"SANGWAN POULTRY FARM PRIVATE LIMITED",
"SANGYA ASSOCIATES PRIVATE LIMITED",
"SANHARABS INDIA PRIVATE LIMITED",
"SANHIT AUTOMATION TECHNOLOGIES PRIVATE LIMITED",
"SANHIT BIOSOLUTIONS PRIVATE LIMITED",
"SANHIT POLYMER PRIVATE LIMITED",
"SANHOC LABS LIMITED",
"SANHUA INDIA PRIVATE LIMITED",
"SANI CLEAN PRIVATE LIMITED",
"SANI ENTERPRISE",
"SANI MULTITRADES PRIVATE LIMITED",
"SANI STEELS PVT LTD",
"SANI TUBES PRIVATE LIMITED",
"SANICERA SHIPPING AND EXPORTS PRIVATE LIMITED",
"SANICO (INDIA) DISTRIBUTORS PRIVATE LIMITED",
"SANICO ENTERPRISE PRIVATE LIMITED",
"SANIDHYA ENGINEERS PRIVATE LIMITED",
"SANIDHYA INFRASTRUCTURE PRIVATE LIMITED",
"SANIDHYA POLYTECH PRIVATE LIMITED",
"SANIFY HEALTHCARE PRIVATE LIMITED",
"SANIJA HOTELS PRIVATE LIMITED",
"SANIKA CHEMICALS PRIVATE LIMITED",
"SANIKA ENGINEERING & CONSULTANCY PRIVATE LIMITED",
"SANIKA PLAST PRIVATE LIMITED",
"SANIKO (PLY) INDUSTRIES PRIVATE LIMITED",
"SANIL CREATIONS PRIVATE LIMITED",
"SANIL TEX PRIVATE LIMITED",
"SANIMART INDIA PRIVATE LIMITED",
"SANIMO POLYMERS PRIVATE LIMITED",
"SANITA GRANITES PRIVATE LIMITED",
"SANITARY EMPORIUM PVT LTD",
"SANITARY SYNDICATE PVT LTD",
"SANITECH ENGINEERING & COMPANY",
"SANITECH ENGINEERS AND CONSULTANTS PRIVATE LIMITED",
"SANITEX CHEMICALS LIMITED",
"SANITIZED PRESERVATION INDIA PRIVATE LIMITED",
"SANITT EQUIPMENT AND MACHINES PRIVATE LIMITED",
"SANIYA URDU P S LATUR",
"SANIYA WEDDINGS AND EVENTS PRIVATE LIMITED",
"SANIYO ELECTROFAB PRIVATE LIMITED",
"SANJ FABRICS PRIVATE LIMITED",
"SANJ FEED TECHNOLOGIES PRIVATE LIMITED",
"SANJ HEALTHCARE PRIVATE LIMITED",
"SANJ TEXTILES PRIVATE LIMITED",
"SANJADHI HEALTHCARE PRIVATE LIMITED",
"SANJANA COLD STORAGE PRIVATE LIMITED",
"SANJANA CRYOGENIC STORAGES LIMITED",
"SANJANA FLEXIPACK PRIVATE LIMITED",
"SANJANA METALWARE INDIA PRIVATE LIMITED",
"SANJAR BUILDERS AND CONSTRUCTIONS PRIVATE LIMITED",
"SANJARI FOREX AND HOLIDAYS PRIVATE LIMITED",
"SANJARI MULTI SERVICES PRIVATE LIMITED",
"SANJAY AGARWAL INDUSTRIES PRIVATE LIMITED",
"SANJAY AUTOMOBILE ENGINEERS PRIVATE. LIMITED.",
"SANJAY BAIRATHI GEMS LIMITED",
"SANJAY BALJIWAN AYURVEDIC PHARMACY PRIVATE LIMITED",
"SANJAY BONNY FORGE PRIVATE LIMITED",
"SANJAY BUILDSQUARE PRIVATE LIMITED",
"SANJAY CASTINGS (INDIA) PRIVATE LIMITED",
"SANJAY CHEMICALS INDIA PRIVATE LIMITED",
"SANJAY COMMERCIAL COMPANY PRIVATE LIMITED",
"SANJAY COMMUNICATIONS PRIVATE LIMITED",
"SANJAY DABHOLE INFRASTRUCTURE PRIVATE LIMITED",
"SANJAY ECO GREEN POWER PRIVATE LIMITED",
"SANJAY FERRO METAL PRIVATE LIMITED",
"SANJAY FOODS INDIA PRIVATE LIMITED",
"SANJAY FORGE PVT LTD",
"SANJAY FORWARDERS PRIVATE LIMITED",
"SANJAY GANDHI MEMORIAL HOSPITAL",
"SANJAY GANDHI PG COLLEGE SARURPUR KHURD MEERUT",
"SANJAY GANDHI PG INSTITUTE OF MEDICAL SC",
"SANJAY GANDHI POST GRADUATE INSTITUTE OF MEDICAL SCIENCES",
"SANJAY GANDHI VIDYA VIHAR",
"SANJAY GHODAWAT FOUNDATION",
"SANJAY GHODAWAT INTERNATIONAL SCHOOL",
"SANJAY GHODAWAT POLYTECHNIC",
"SANJAY GHODAWAT UNIVERSITY",
"SANJAY GRAIN PRODUCTS PRIVATE LIMITED",
"SANJAY HYDRAULIK PRIVATE LIMITED",
"SANJAY ICE & PRESERVATION INDIA PRIVATE LIMITED",
"SANJAY INDUSTRIAL STEELS (BHOPAL) PRIVATE LIMITED",
"SANJAY INDUSTRIAL STEELS BHOPAL PRIVATE. LIMITED",
"SANJAY INFRAMECH PRIVATE LIMITED",
"SANJAY INFRASTRUCTURE DEVELOPMENT PRIVATE LIMITED",
"SANJAY JEWELLERS PRIVATE LIMITED",
"SANJAY KAPOOR ENTERTAINMENT PRIVATE LIMITED",
"SANJAY KNIT PRIVATE LIMITED",
"SANJAY KUMAR AND COMPANY EXIM PRIVATE LIMITED",
"SANJAY KUMAR SHANKARLAL EXPORT PRIVATE LIMITED",
"SANJAY KUMAR SHARMA ENGICON PRIVATE LIMITED",
"SANJAY KUMAR TECHNOCRATE PRIVATE LIMITED",
"SANJAY LOGISTICS PRIVATE LIMITED",
"SANJAY METALLIKS INDIA PRIVATE LIMITED",
"SANJAY MILK PRODUCTS P LTD",
"SANJAY MOTORS PRIVATE LIMITED",
"SANJAY NAGAR HINDI MADHYAMIK SHALA",
"SANJAY OILCAKE INDUSTRIES PRIVATE LIMITED",
"SANJAY PATIL MILK AND DAIRY PRODUCTS PRIVATE LIMITED",
"SANJAY POWER PROJECTS PRIVATE LIMITED",
"SANJAY PRINTERS AND PUBLISHERS PRIVATE LIMITED",
"SANJAY PULSE PROCESSORS PRIVATE LIMITED",
"SANJAY PURI ARCHITECTS PRIVATE LIMITED",
"SANJAY RAZDAN AND ASSOCIATES PRIVATE LIMITED",
"SANJAY RICE MILLS PRIVATE LIMITED",
"SANJAY SALES PRIVATE LIMITED",
"SANJAY SARAF EDUCATIONAL INSTITUTE PRIVATE LIMITED",
"SANJAY SAREES P LTD",
"SANJAY SHAWLS PRIVATE LIMITED",
"SANJAY SHIPPING & LOGISTICS (INDIA) PRIVATE LIMITED",
"SANJAY SOLVEX PVT LTD",
"SANJAY SOURCING PRIVATE LIMITED",
"SANJAY SOYA INTERNATIONAL PRIVATE LIMITED",
"SANJAY SOYA PRIVATE LIMITED",
"SANJAY STEELSANGAM ENTERPRISES PRIVATE LIMITED",
"SANJAY TECHNICAL SERVICES PRIVATE LIMITED",
"SANJAY TECHNO PLAST PRIVATE LIMITED",
"SANJAY TECHNO PRODUCTS PRIVATE LIMITED",
"SANJAY TELECOM PRIVATE LIMITED",
"SANJAY TERINE PRIVATE LIMITED",
"SANJAY TOOLS AND ACCESSORIES PRIVATE LIMITED",
"SANJAY UDYOG PRIVATE LIMITED",
"SANJAY WARE WORKS PRIVATE LIMITED",
"SANJAY WOOD PACKERS PRIVATE LIMITED",
"SANJAYRAJ AUTOLINK PRIVATE LIMITED",
"SANJEEBANI CLINIC PRIVATE LIMITED",
"SANJEELA FASHIONS PRIVATE LIMITED",
"SANJEERA RESTAURANT AND RECRUITMENT SERVICES PRIVATE LIMITED",
"SANJEET MOTOR FINANCE PRIVATE LIMITED",
"SANJEEV AGRO-VET PRIVATE LIMITED",
"SANJEEV AUTO PARTS MANUFACTURERS PRIVATE LIMITED",
"SANJEEV BROTHERS CONSTRUCTION PRIVATE LIMITED",
"SANJEEV FLEXI PACK PRIVATE LIMITED",
"SANJEEV KUMAR CONTRACTORS PRIVATE LIMITED",
"SANJEEVA SONS HOLIDAY RESORTS AND RESTAURANTS PRIVATE LIMITED",
"SANJEEVA TOWN WELFARE ASSOCIATION",
"SANJEEVAN DRUGS PRIVATE LIMITED",
"SANJEEVAN INTENSIVE CARE UNIT PRIVATE LIMITED",
"SANJEEVAN MEDICAL RESEARCH CENTRE PRIVATE LIMITED",
"SANJEEVAN RESEARCH CENTRE AND HEART HOSPITAL PRIVATE LIMITED",
"SANJEEVANI AGROFOODS PRIVATE LIMITED",
"SANJEEVANI BIO SERVICES PRIVATE LIMITED",
"SANJEEVANI BIO-TECH EXIM PRIVATE LIMITED",
"SANJEEVANI CBCC USA CANCER HOSPITAL",
"SANJEEVANI CRITI-CARE AND RESEARCH CENTRE PRIVATE LIMITED",
"SANJEEVANI DAIRY FARMS PRIVATE LIMITED",
"SANJEEVANI DWARKA PATH LABS PRIVATE LIMITED",
"SANJEEVANI FERTILIZERS AND CHEMICALS PRIVATE LIMITED",
"SANJEEVANI FOODS PRIVATE LIMITED",
"SANJEEVANI GRAINS PRIVATE LIMITED",
"SANJEEVANI HEALTH AND EDUCATION WELFARE SOCIETY",
"SANJEEVANI HOMOEO CARE PRIVATE LIMITED",
"SANJEEVANI HOSPITAL",
"SANJEEVANI ICU HOSPITAL",
"SANJEEVANI INFRABUILD PRIVATE LIMITED",
"SANJEEVANI INTEGRATED MEDICAL SERVICES PRIVATE LIMITED",
"SANJEEVANI LOGISTIVS INDIA PRIVALIMITED",
"SANJEEVANI MULTI SPECIALTY HOSPITAL",
"SANJEEVANI MULTISPECIALTY HOSPITAL",
"SANJEEVANI NUTRITECH SOLVENTS PRIVATE LIMITED",
"SANJEEVANI PACKAGING PRIVATE LIMITED",
"SANJEEVANI PAPERS PRIVATE LIMITED",
"SANJEEVANI PHARMA DISTRIBUTORS PRIVATE LIMITED",
"SANJEEVANI RICH JAIVIK INDIA PRIVATE LIMITED",
"SANJEEVANI SUPER SPECIALITY HEALTHCARE (BHOPAL) PRIVATE LIMITED",
"SANJEEVANI VYAPAAR LLP",
"SANJEEVANI VYAS HOSPITAL ANUSANDHAN KENDRA PRIVATE LIMITED",
"SANJEEVI HEALTH CARE INDIA PRIVATE LIMITED",
"SANJEEVINI MEDLIFE HOSPITALS INDIA PRIVATE LIMITED",
"SANJHI EXIM PRIVATE LIMITED",
"SANJHI SIKHIYA FOUNDATION",
"SANJIB ZENAT ISPAT PRIVATE LIMITED",
"SANJIBANI MEDISALES PRIVATE LIMITED",
"SANJIBANI MOTORS PRIVATE LIMITED",
"SANJIBON DIAGNOSTIC & HEALTH CARE PRIVATE LIMITED",
"SANJIT INSTRUMENTS PRIVATE LIMITED",
"SANJIV TEA INDUSTRY PRIVATE LIMITED",
"SANJIVAN ANUSANDHAN PRIVATE LIMITED",
"SANJIVANI BIOCHEM PRIVATE LIMITED",
"SANJIVANI CASTING PRIVATE LIMITED",
"SANJIVANI CORPORATE PARK DEVELOPERS LIMITED",
"SANJIVANI FAMILY HOSPITAL PRIVATE LIMITED",
"SANJIVANI HOSPITAL YAVATMAL",
"SANJIVANI JUNIOR COLLEGE",
"SANJIVANI MEDICINES PRIVATE LIMITED",
"SANJIVANI METAL TRADING PRIVATE LIMITED",
"SANJIVANI MULTY SPECIALITY HOPSPITAL",
"SANJIVANI NUTRACEUTICAL AND HEALTH PRODUCTS PRIVATE LIMITED",
"SANJIVANI OVERSEAS PRIVATE LIMITED",
"SANJIVANI PARANTERAL LIMITED",
"SANJIVANI REMEDIES PRIVATE LIMITED",
"SANJIVANI SUPER SPECIALITY HOSPITALS PRIVATE LIMITED",
"SANJIVANI TEA PRIVATE LIMITED",
"SANJIVINI PIPES AND FITTINGS PRIVATE LIMITED",
"SANJIVINI SCANNING SOLUTIONS PRIVATE LIMITED",
"SANJIVINI TEA CO. PRIVATE LIMITED",
"SANJNA PHARMA PRIVATE LIMITED",
"SANJO FORGE INDIA PRIVATE LIMITED",
"SANJO POULTRY FARM INDIA PRIVATE LIMITED",
"SANJOE SADAN CONVENT HIGH SCHOOL",
"SANJOG COMMUNICATION PRIVATE LIMITED",
"SANJOG HOSPITAL PRIVATE LIMITED",
"SANJOG REALTY PRIVATE LIMITED",
"SANJOG STEELS PRIVATE LIMITED",
"SANJOG SUGARS AND ECO-POWER PRIVATE LIMITED",
"SANJOO DYEING & PRINTING MILLS PRIVATE LIMITED",
"SANJOO PRINTS PRIVATE LIMITED",
"SANJU RATHORE INFRAPROJECTS PRIVATE LIMITED",
"SANJUBA ENGLISH PRIMARY SCHOOL",
"SANJUM CONSTRUCTIONS PRIVATE LIMITED",
"SANJVIK TERMINALS PRIVATE LIMITED",
"SANJYOT CORPORATE SERVICES PRIVATE LIMITED",
"SANJYOT ENGINEERING WORKS",
"SANKAAM TECHNOLOGIES PRIVATE LIMITED",
"SANKAGIRI SPINTEX PRIVATE LIMITED",
"SANKALCHAND PATEL COLLEGE OF ENGINEERING",
"SANKALP & KPIT SEMICONDUCTOR PRIVATE LIMITED",
"SANKALP ADVISORY SERVICES PRIVATE LIMITED",
"SANKALP AGENCIES PRIVATE LIMITED",
"SANKALP BIOTECH PRIVATE LIMITED",
"SANKALP BUILDMART PRIVATE LIMITED",
"SANKALP CAPITAL PRIVATE LIMITED",
"SANKALP COMPUTER AND SYSTEMS PRIVATE LIMITED",
"SANKALP CONSTRUCTIONS PRIVATE LIMITED",
"SANKALP COTTON & OIL INDUSTRIES",
"SANKALP DIGITAL CABLE NETWORK PRIVATE LIMITED",
"SANKALP DYEING AND PRINTING MILLS PRIVATE LIMITED",
"SANKALP ENGINEERING & SERVICES PRIVATE LIMITED",
"SANKALP EQUIPMENTS PRIVATE LIMITED",
"SANKALP FACILITIES & MANAGEMENT SERVICES PRIVATE LIMITED",
"SANKALP GOLDS PRIVATE LIMITED",
"SANKALP HEALTHCARE AND ALLIED PRODUCTS PRIVATE LIMITED",
"SANKALP HEIGHTS PRIVATE LIMITED",
"SANKALP HOSPITAL PRIVATE LIMITED",
"SANKALP HYDRAULIK PRIVATE LIMITED",
"SANKALP INTERNATIONAL",
"SANKALP INTERNATIONAL SCHOOL",
"SANKALP ISPAT (INDIA) PRIVATE LIMITED",
"SANKALP MANPOWER & FACILITY SERVICES PRIVATE LIMITED",
"SANKALP MILK PRIVATE LIMITED",
"SANKALP ORGANISERS PRIVATE LIMITED",
"SANKALP PAPER INDUSTRIES PRIVATE LIMITED",
"SANKALP PREFORMED SYSTEMS PRIVATE LIMITED",
"SANKALP REALMART PRIVATE LIMITED",
"SANKALP REALTY PRIVATE LIMITED",
"SANKALP RECREATION PRIVATE LIMITED",
"SANKALP SAAKAAR ENTERPRISES PVT LTD",
"SANKALP SCHOOL OF NURSING DABHA",
"SANKALP SEMICONDUCTOR PRIVATE LIMITED",
"SANKALP SHARE BROKERS PRIVATE LIMITED",
"SANKALP SIDDHI DEVELOPERS PRIVATE LIMITED",
"SANKALP SPECIALITY HEALTHCARE PRIVATE LIMITED",
"SANKALP SUPPLY CHAIN PRIVATE LIMITED",
"SANKALP TUTORIALS PRIVATE LIMITED",
"SANKALPA HUMAN RESOURCE DEVELOPMENT CORPORATION LIMITED",
"SANKALPA SUPER SPECIALITY HOSPITAL",
"SANKALPAN INFRASTRUCTURE PRIVATE LIMITED",
"SANKALPANA BUSINESS CENTRE AND RESORTS PRIVATE LIMITED",
"SANKALPO CLINIC PRIVATE LIMITED",
"SANKAP INFRA PRIVATE LIMITED",
"SANKAR ELASTOMERS PRIVATE LIMITED",
"SANKAR FOUNDATION EYE HOSPITAL AND INSTITUTE",
"SANKAR INFRAPROJECTS PRIVATE LIMITED",
"SANKAR JP SEALING TECHNOLOGIES",
"SANKAR NP JAPAN PRIVATE LIMITED",
"SANKAR SEALING SYSTMES PRIVATE LIMITED",
"SANKAR TEA CO PVT LTD",
"SANKAR TEXTILES PRIVATE LIMITED",
"SANKARA COLLEGE OF ARTS COMM-641035",
"SANKARA DESIGNS PRIVATE LIMITED",
"SANKARA EYE FOUNDATION",
"SANKARA MULTISPECIALITY HOSPITAL",
"SANKARA NETHRALAYA",
"SANKARA NETHRALAYA MEDICAL RESEARCH FOUNDATION",
"SANKARA SOFTWARE SERVICES PRIVATE LIMITED",
"SANKARBATI PRY SCHOOL",
"SANKATMOCHAN MARKETING PVT LTD",
"SANKEERTHANA HOSPITALS PRIVATE LIMITED",
"SANKEI GIKEN INDIA PRIVATE LIMITED",
"SANKEI PRAGATI INDIA PRIVATE LIMITED",
"SANKEN PRECISION ENGINEERING INDIA PRIVATE LIMITED",
"SANKESHWAR INDUSTRIES PRIVATE LIMITED",
"SANKESHWAR SYNTHETICS PVT LTD",
"SANKESHWAR VENTURES (INDIA) PRIVATE LIMITED",
"SANKET COMMUNICATIONS PRIVATE LIMITED",
"SANKET DEVELOPERS PRIVATE LIMITED",
"SANKET FACILITY MANAGEMENT SERVICES",
"SANKET GYANSAGAR VIDHYALAYA",
"SANKET INNOVATIONS PRIVATE LIMITED",
"SANKET MULTI BIZ PRIVATE LIMITED",
"SANKET PACKSEAL MACHINES PRIVATE LIMITED",
"SANKET PHARMACEUTICALS PVT LTD",
"SANKET POLYPACK PRIVATE LIMITED",
"SANKETHI NUTRIMENTS PRIVATE LIMITED",
"SANKETIK TELNET PRIVATE LIMITED",
"SANKETIKA POLYTECHNIC COLLEGE",
"SANKEY BUSINESS SOLUTIONS PRIVATE LIMITED",
"SANKEY CONTROLS PRIVATE LIMITED",
"SANKHESHWAR HOLDING COMPANY LIMITED",
"SANKHLA FOODS PRIVATE LIMITED",
"SANKHLA VINYL PRIVATE LIMITED",
"SANKHYA & SRINIDHI HOSPITALS PRIVATE LIMITED",
"SANKHYA CONSULTANTS PRIVATE LIMITED",
"SANKHYA FINANCIAL SERVICES PRIVATE LIMITED",
"SANKHYA HOSPITALS",
"SANKHYA SHAFTS AND SPINDLES PRIVATE LIMITED",
"SANKHYAA LEARNING PRIVATE LIMITED",
"SANKHYASUTRA LABS LIMITED",
"SANKI MACHINE TOOLS (INDIA) PRIVATE LIMITED",
"SANKLECHA BROTHERS PRIVATE LIMITED",
"SANKLECHA CONSTRUCTIONS PRIVATE LIMITED",
"SANKLECHA ELECTROTECH PRIVATE LIMITED",
"SANKO FINVEST PVT. LTD.",
"SANKO GOSEI JRG AUTOMOTIVE INDIA PRIVATE LIMITED",
"SANKO GOSEI TECHNOLOGY INDIA PRIVATE LIMITED",
"SANKO SHOJI INDIA PRIVATE LIMITED",
"SANKO SVANCE JRG TOOLING INDIA PRIVATE LIMITED",
"SANKON TECHNOLOGIES INDIA PRIVATE LIMITED",
"SANKRAIL AGRO POULTRIES PVT LTD",
"SANKRITI SCHOOL WAGHOLI",
"SANKUR PHARMACEUTICALS PRIVATE LIMITED",
"SANKY TECHNICAL CONSULTING PRIVATE LIMITED",
"SANKYU INDIA LOGISTICS & ENGINEERING PRIVATE LIMITED",
"SANMA MEDINEERS VISION PRIVATE LIMITED",
"SANMAAN AGRO INDUSTRIES",
"SANMAAN EXPORTS PRIVATE LIMITED",
"SANMAH INFOTECH PRIVATE LIMITED",
"SANMAN TRADE IMPEX PRIVATE LIMITED",
"SANMAR ENGINEERING SERVICES LIMITED",
"SANMAR HOLDINGS LIMITED",
"SANMAR MATRIX METALS LIMITED",
"SANMAR SHIPPING LIMITED",
"SANMAR SPECIALITY CHEMICALS LIMITED",
"SANMARG PRIVATE LIMITED",
"SANMARG PROJECTS PRIVATE LIMITED",
"SANMARGA SHELTERS PRIVATE LIMITED",
"SANMARGG AGROFRESH PRIVATE LIMITED",
"SANMARGG AGROTRADE INDIA PRIVATE LIMITED",
"SANMATI COAL & COKES PRIVATE LIMITED",
"SANMATI COMPONENTS PRIVATE LIMITED",
"SANMATI CONSULTANTS PVT. LTD.",
"SANMATI CREDIT CAPITAL PRIVATE LIMITED",
"SANMATI EDIBLE OILS PRIVATE LIMITED",
"SANMATI ENTERPRISES PRIVATE LIMITED",
"SANMATI EXIM PRIVATE LIMITED",
"SANMATI JEWELLERS",
"SANMATI NUTRITOUS GRAINS PRIVATE LIMITED",
"SANMATI ORNAMENTS PRIVATE LIMITED",
"SANMATI PACKAGING PRIVATE LIMITED",
"SANMATI PRINTERS PRIVATE LIMITED",
"SANMATI PROPERTIES LIMITED",
"SANMATI SUITINGS PVT LTD",
"SANMATI SYNTEX PVT. LTD",
"SANMATI TRADING AND INVESTMENT LTD",
"SANMATI VYAPAAR PRIVATE LIMITED",
"SANMAY DECOR PRIVATE LIMITED",
"SANMED HEALTHCARE PRIVATE LIMITED",
"SANMED SPECIALITIES PRIVATE LIMITED",
"SANMEET RUBY ANGAD PRIVATE LIMITED",
"SANMINA SCI INDIA PRIVATE LIMITED",
"SANMINA SCI TECHNOLOGY INDIA PRIVATE LIMITED",
"SANMINA TECH SERVICES INDIA PRIVATE LIMITED",
"SANMIT CARD CLOTHING INDIA PRIVATE LIMITED",
"SANMIT INFRA LIMITED",
"SANMITA REALTY PRIVATE LIMITED",
"SANMUGA TRANSPORT PRIVATE LIMITED",
"SANMUKH LEASING FINANCE(INDIA)LIMITED",
"SANMUL CONSTRUCTION PRIVATE LIMITED",
"SANNAM S4 CONSULTING PRIVATE LIMITED",
"SANNAM S4 MANAGEMENT SERVICES INDIA PRIVATE LIMITED",
"SANNER OF INDIA PRIVATE LIMITED",
"SANNI CAD CAM PRIVATE LIMITED",
"SANNIDHI ELEVATORS PRIVATE LIMITED",
"SANNITHA EDUCATIONAL INSTITUTIONS PRIVATE LIMITED",
"SANNVERSE RAILTECH PRIVATE LIMITED",
"SANO HIGH GRADE SPECTRO CASTINGS PRIVATE LIMITED",
"SANOBAR HOTELS PRIVATE LIMITED",
"SANOFI INDIA LIMITED",
"SANOFI-SYNTHELABO INDIA PRIVATE LIMITED",
"SANOH INDIA PRIVATE LIMITED",
"SANOOR CASHEWS",
"SANOR RETAIL TRADING PRIVATE LIMITED",
"SANORA PHARMACEUTICALS PRIVATE LIMITED",
"SANOSIL BIOTECH PRIVATE LIMITED",
"SANOVI PHARMACEUTICALS PRIVATE LIMITED",
"SANOVI TECHNOLOGIES PRIVATE LIMITED",
"SANOVIS LIFE SCIENCES PRIVATE LIMITED",
"SANPAR MICROFILTER PRIVATE LIMITED",
"SANPRA AEROSOL PRIVATE LIMITED",
"SANPRA FOODS PRIVATE LIMITED",
"SANPRA HOTELS & RESORTS PRIVATE LIMITED",
"SANPRA INFOTECH LLP",
"SANPRA INFOTECH PRIVATE LIMITED",
"SANPRA SYNTHESIS PRIVATE LIMITED",
"SANPRAS HEALTHCARE PRIVATE LIMITED",
"SANPREET CASTINGS PRIVATE LIMITED",
"SANPURE SYSTEMS PRIVATE LIMITED",
"SANRA HOSPITALITY PRIVATE LIMITED",
"SANRAAJ HOSES PRIVATE LIMITED",
"SANRACHANA STRUCTURAL STRENGTHENING PRIVATE LIMITED",
"SANRACHNA HOMES PRIVATE LIMITED",
"SANRACHNA INFRAPROJECTS PRIVATE LIMITED",
"SANRACHNA INFRATECH PRIVATE LIMITED",
"SANRAD CHEMICALS AND ESSENTIAL OILS PRIVATE LIMITED",
"SANRAD MEDICAL SYSTEMS PRIVATE LIMITED",
"SANRAI MED INDIA PRIVATE LIMITED",
"SANRAI RETAIL",
"SANRAJ HOSPITALITY PRIVATE LIMITED",
"SANRAJ IMPEX PRIVATE LIMITED",
"SANRAJ METALS PRIVATE LIMITED",
"SANRAJ NAYAN INVESTMENTS PRIVATE LIMITED",
"SANRAJ PROJECTS PRIVATE LIMITED",
"SANRAL PHARMA PRIVATE LIMITED",
"SANRAN INTERNATIONAL PRIVATE LIMITED",
"SANRAY LABORATORIES PRIVATE LIMITED",
"SANREA HEALTHCARE PRODUCTS PRIVATE LIMITED",
"SANRHEA TECHNICAL TEXTILES LIMITED",
"SANRIA ENGINEERING AND CONSULTING PRIVATE LIMITED",
"SANRIAN INTERNATIONAL PRIVATE LIMITED",
"SANRIYA ENGINEERING PRIVATE LIMITED",
"SANRON KLC BIOFUEL PRIVATE LIMITED",
"SANS CASHEW INDIA PRIVATE LIMITED",
"SANS KEY TECHNOLOGIES (I) PRIVATE LIMITED",
"SANSA INDUSTRIES PRIVATE LIMITED",
"SANSAAR PRIME REAL ESTATE PRIVATE LIMITED",
"SANSAAR VENTURES PRIVATE LIMITED",
"SANSAARA WEAVES & FILAMENTS PRIVATE LIMITED",
"SANSAI AUTO SERVICES PRIVATE LIMITED",
"SANSAI MOBIKES PRIVATE LIMITED",
"SANSAI MOTORS PRIVATE LIMITED",
"SANSAI PROPERTIES & HOTELS PRIVATE LIMITED",
"SANSAJ HOME CARE PRODUCTS PRIVATE LIMITED",
"SANSAM POLYMERS PRIVATE LIMITED",
"SANSAP TECHNOLOGY PRIVATE LIMITED",
"SANSAR AGROPOL PRIVATE LIMITED",
"SANSAR BUILDCON PRIVATE LIMITED",
"SANSAR MOTORS PRIVATE LIMITED",
"SANSAR TEXTURISERS PRIVATE LIMITED",
"SANSCO TECHNOLOGIES (KERALA) PRIVATE LIMITED",
"SANSCUBICLE PRIVATE LIMITED",
"SANSEGA INDUSTRIES LLP",
"SANSERA ENGINEERING LIMITED",
"SANSHAWN FREIGHT SYSTEMS INDIA PRIVATE LIMITED",
"SANSHEL ENGINEERING PRIVATE LIMITED",
"SANSHI INSURANCE BROKERS PRIVATE LIMITED",
"SANSHIV TRAVELS PRIVATE LIMITED",
"SANSHOK HEALTHCARE PRIVATE LIMITED",
"SANSIDDHI TECHNOCAST PRIVATE LIMITED",
"SANSKAAR INTERNATIONAL SCHOOL",
"SANSKAAR MOTORS PRIVATE LIMITED",
"SANSKAR ACADEMICS PRIVATE LIMITED",
"SANSKAR AGRO PROCESSORS PRIVATE LIMITED",
"SANSKAR AYUSH MEDICARE PRIVATE LIMITED",
"SANSKAR BHARTI FOUNDATION",
"SANSKAR BHARTI VIDHYALAYA",
"SANSKAR CERAMICS PRIVATE LIMITED",
"SANSKAR CHEMICALS AND DRUGS PRIVATE LIMITED",
"SANSKAR EDUCATIONS PRIVATE LIMITED",
"SANSKAR ENGINEERING INDIA PRIVATE LIMITED",
"SANSKAR GENSET PRIVATE LIMITED",
"SANSKAR GOLD PRIVATE LIMITED",
"SANSKAR HOMES PRIVATE LIMITED",
"SANSKAR HOSPITAL AND RESEARCH CENTRE PVT.LTD.",
"SANSKAR INFO TV PRIVATE LIMITED",
"SANSKAR INTERNATIONAL SCHOOL",
"SANSKAR PRATISHTHANCHI MATIMAND MULANCHI NIWASI SHALA",
"SANSKAR PROCESSORS PRIVATE LIMITED",
"SANSKAR PROJECTS AND HOUSING LIMITED",
"SANSKAR SCHOOL",
"SANSKAR SYNTHETICS PRIVATE LIMITED",
"SANSKAR TECHNOLAB PRIVATE LIMITED",
"SANSKAR TEX PRINTS PRIVATE LIMITED",
"SANSKAR TRADEX PRIVATE LIMITED",
"SANSKAR VIKAS SOCIETY S PRAGNYA BODHINI HIGH SCHOOL",
"SANSKARA CONBUILD PRIVATE LIMITED",
"SANSKARAM PUBLIC SCHOOL",
"SANSKARDHAM",
"SANSKARDHAM KANYA VIDYALAYA MADHYAMIK SHALA - RAJKOT",
"SANSKARDHAM VIDYALAYA",
"SANSKARTIRTH GYANPEETH",
"SANSKRIT COLLEGE",
"SANSKRIT E SOLUTIONS & SERVICES PRIVATE LIMITED",
"SANSKRITAM NATURALS PRIVATE LIMITED",
"SANSKRITECH SMART SOLUTIONS PRIVATE LIMITED",
"SANSKRITEE PAPERS PRIVATE LIMITED",
"SANSKRITGANGA EDUCATION PRIVATE LIMITED",
"SANSKRITHI SCHOOL OF ENGINEERING",
"SANSKRITI ARTS PRIVATE LIMITED",
"SANSKRITI BUILDERS AND COLONIZER PRIVATE LIMITED",
"SANSKRITI BUILDMART PRIVATE LIMITED",
"SANSKRITI EMBROIDERY PRIVATE LIMITED",
"SANSKRITI ENVIRO PRIVATE LIMITED",
"SANSKRITI FINANCE PRIVATE LIMITED",
"SANSKRITI FOOD EQUIPMENTS EXIM PRIVATE LIMITED",
"SANSKRITI FOUNDATION",
"SANSKRITI INFRASTRUCTURE SOLUTIONS PRIVATE LIMITED",
"SANSKRITI MOBITECH PRIVATE LIMITED",
"SANSKRITI PACKAGING PRIVATE LIMITED",
"SANSKRITI PROCESSORS PRIVATE LIMITED",
"SANSKRITI PUBLIC SCHOOL GORAKHPUR",
"SANSKRITI PUBLIC SCHOOL MATHURA",
"SANSKRITI RETAILS PRIVATE LIMITED",
"SANSKRITI SCHOOL PUNE",
"SANSKRITI SOCIETY FOR EDUCATION RESEARCH & DEVELOPMENT",
"SANSKRITI STAINLESS STEEL",
"SANSKRITI SYNTHETICS PRIVATE LIMITED",
"SANSKRITI UNIVERSITY",
"SANSKRITI VILLAS PRIVATE LIMITED",
"SANSKRITIK MANTRA PRIVATE LIMITED",
"SANSKRUT TRADECOM PRIVATE LIMITED",
"SANSKRUTI ASSOCIATES PRIVATE LIMITED",
"SANSKRUTI NIRMAN PRIVATE LIMITED",
"SANSKRUTI RECREATION AND BUILDERS PRIVATE LIMITED",
"SANSKRUTI SCHOOL",
"SANSKRUTI SCHOOL OF THOUGHTS",
"SANSO MANAGEMENT AND SAFETY SOLUTIONS PRIVATE LIMITED",
"SANSON CERAMICS PRIVATE LIMITED",
"SANSON COMMUNICATION PRIVATE LIMITED",
"SANSONS POLYMER PRIVATE LIMITED",
"SANSPAREILS GREENLANDS PRIVATE LIMITED",
"SANSPRITO INDIA PRIVATE LIMITED",
"SANSQUARE AUTOMATION PRIVATE LIMITED",
"SANSREE AUTOMATION PRIVATE LIMITED",
"SANSTAR BIOPOLYMERS LIMITED",
"SANSTAR GEMS & JEWELS PRIVATE LIMITED",
"SANSTAR LIMITED",
"SANSTAR MICROSYSTEMS P LIMITED",
"SANSTUTI PHARMACEUTICALS PRIVATE LIMITED",
"SANSU AQUATEK INDIA PRIVATE LIMITED",
"SANSU AUTOMOTIVES PRIVATE. LIMITED.",
"SANSUI ELECTRONICS PRIVATE LIMITED",
"SANSUI STEELS PRIVATE LIMITED",
"SANSUM COMPUTECH PRIVATE LIMITED",
"SANSUN INDUSTRIES PRIVATE.LIMITED.",
"SANSUN STAFFING SOLUTIONS PRIVATE LIMITED",
"SANSYS INFORMATICS PRIVATE LIMITED",
"SANT AGRO TECH PRIVATE LIMITED",
"SANT ALUMINIUM PRIVATE LIMITED",
"SANT ANAND INDUSTRIES PRIVATE LIMITED",
"SANT ATULANAND CONVENT SCHOOL",
"SANT ATULANAND RESIDENTIAL ACADEMY",
"SANT AUTOCRAFT PRIVATE LIMITED",
"SANT AUTOLINKS PRIVATE LIMITED",
"SANT AUTOS",
"SANT AUTOWAYS PRIVATE LIMITED",
"SANT AUTOWHEELS PRIVATE LIMITED",
"SANT AUTOWINGS PRIVATE LIMITED",
"SANT BHAGWAN BABA ARTS COLLEGE SINDKHED RAJA DIST BULDHANA",
"SANT CARRIERS PRIVATE LIMITED",
"SANT CHAVRA NATIONAL ACADEMY",
"SANT DNYANESHWAR ENGLISH SCHOOL SHIRALA",
"SANT DNYANESHWAR HOSPITAL PRIVATE LIMITED",
"SANT DNYANESHWAR MADHYAMIK & UCCHA MADHYAMMIK VIDYALAY KARLA TA.DIST. JALNA",
"SANT EKNATH VIDYALAYA",
"SANT ELECTRONICS PRIVATE LIMITED",
"SANT FOODS PRIVATE LIMITED",
"SANT FOOTWEAR PRIVATE LIMITED",
"SANT GOROBA KAKA PRI MAHADEVNAGAR",
"SANT GYANESHWAR STEELS PRIVATE LIMITED",
"SANT HIRDARAM GIRLS COLLEGE",
"SANT JANARDHAN SWAMI VIDHYALAYA",
"SANT KRIPA INFRA TEC PRIVATE LIMITED",
"SANT LONGOWAL INSTITUTE OF ENGINEERING & TECHNOLOGY LONGOWAL",
"SANT MUKTAI SUGAR & ENERGY LIMITED",
"SANT NIRANKARI PUBLIC SCHOOL",
"SANT PARMANAND HOSPITAL",
"SANT RAGHBIR SINGH AIMS SENIOR SECONDARY SCHOOL JALANDHAR",
"SANT RAM MANGAT RAM JEWELLERS PRIVATE LIMITED",
"SANT RAM RICE & GENERAL MILLS",
"SANT RAM SEWA RAM PRIVATE LIMITED",
"SANT RAMKRISHNA KANYA MAHAVIDYALAYA",
"SANT RAVIDAS MADHYA PRADESH HASTASHILP EVAM HATHKARGHA VIKAS NIGAM LIMITED",
"SANT ROADLINES PRIVATE LIMITED",
"SANT ROSHAN LAL VIDYA MANDIR",
"SANT RUBBERS LIMITED",
"SANT SANDESH MEDIA & COMMUNICATIONS PRIVATE LIMITED",
"SANT SATRAMDAS INFRASTRUCTURE PRIVATE LI MITED",
"SANT SHAHI FOOD PRODUCTS PRIVATE LIMITED",
"SANT SHIROMANI SAWATA MAHARAJ STEEL & SAKHAR UDYOG LIMITED",
"SANT SHREE KHETABAPA HIGHER SECONDRY SCHOOL",
"SANT SOPANKAKA SAHAKARI BANK LIMITED",
"SANT TUKARAM NATIONAL MODEL SCHOOL LATUR",
"SANT VALVES PRIVATE LIMITED",
"SANT WIRES LIMITED",
"SANTA CRUZ TELEMARKETING SERVICES PRIVATE LIMITED",
"SANTA EVENTZ AND EXHIBITIONS PVT LTD",
"SANTA FE INDIA PRIVATE LIMITED",
"SANTA FE MOVING SERVICES PRIVATE LIMITED",
"SANTA FE REALTY PRIVATE LIMITED",
"SANTA FREIGHT LOGISTICS PRIVATE LIMITED",
"SANTA MARIA INTERNATIONAL PRIVATE LIMITED",
"SANTA SUDHA RICE INDUSTRIES PRIVATE LIMITED",
"SANTAAN FERTILITY CENTER & RESEARCH INSTITUTE PRIVATE LIMITED",
"SANTAJI COLLEGE",
"SANTAMONICA STUDY ABROAD PRIVATE LIMITED",
"SANTAPET POLYMERS LIMITED",
"SANTARUN INFRA PRIVATE LIMITED",
"SANTASBOX PRIVATE LIMITED",
"SANTAUR BUILDTECH PRIVATE LIMITED",
"SANTCA LOGISTICS PRIVATE LIMITED",
"SANTE MERNAUD PHARMACEUTICALS PRIVATE LIMITED",
"SANTEC EXIM PRIVATE LIMITED",
"SANTECH ENGINEERS PRIVATE LIMITED",
"SANTECH LED PRIVATE LIMITED",
"SANTECH SAFETY ENGINEERS PRIVATE LIMITED",
"SANTECH TECHNOSOFT PRIVATE LIMITED",
"SANTEIN ENGINEERING & EQUIPMENT PRIVATE LIMITED",
"SANTEK CONSULTANTS PRIVATE LIMITED",
"SANTEK EQUIPMENTS PRIVATE LIMITED",
"SANTEN INDIA PRIVATE LIMITED",
"SANTEWARE HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"SANTEX ENGINEERING INDIA PRIVATE LIMITED",
"SANTHA BUILD-TECH INDIA PRIVATE LIMITED",
"SANTHA SPINNING MILLS PRIVATE LIMITED",
"SANTHAGARIK AGRO PRIVATE LIMITED",
"SANTHAL PARGANA BUILDERS PRIVATE LIMITED",
"SANTHALAKSHMI RSM ENGINEERING SOLUTIONS PRIVATE LIMITED",
"SANTHANA LAKSHMI RENEWABLE ENERGY PRIVATE LIMITED",
"SANTHANAM PACKAGINGS PRIVATE LIMITED",
"SANTHI CASTING WORKS",
"SANTHI CHEMICALS PRIVATE LIMITED",
"SANTHI FISHERIES",
"SANTHI PROCESSING UNIT PRIVATE LIMITED",
"SANTHIRAM MEDICAL COLLEGE AND GENERAL HOSPITAL",
"SANTHIRAM WIND POWER PRIVATE LIMITED",
"SANTHMESH FREIGHT AND FORWARDING SERVICES PRIVATE LIMITED",
"SANTHOM METACAST PRIVATE LIMITED",
"SANTHOME SCHOOL SANGLI",
"SANTHOSAM CHEST HOSPITAL",
"SANTHOSH BUILDWEL INFRA PRIVATE LIMITED",
"SANTHOSH FABRICATORS PRIVATE LIMITED",
"SANTHOSH RICE MILLS PRIVATE LIMITED",
"SANTHOSHIMATHA CORRUGATORS PRIVATE LIMITED",
"SANTHOSHIMATHAA EDIBLE OIL REFINERY PRIVATE LIMITED",
"SANTHOSHIMATHAA OILS AND FATS PRIVATE LIMITED",
"SANTI HOMOEO PRIVATE LIMITED",
"SANTI RICE MILLS PVT LTD",
"SANTIAGO LIFE SCIENCES PRIVATE LIMITED",
"SANTIGO TEXTILE MILLS LIMITED",
"SANTIMA COLD STORAGE PRIVATE LIMITED",
"SANTIMOYEE COLD STORAGE PRIVATE LIMITED",
"SANTIMOYEE HIMGHAR PRIVATE LIMITED",
"SANTINIKETAN INSTITUTE OF POLYTECHNIC",
"SANTINT INDIA TECHNOLOGY PRIVATE LIMITED",
"SANTIRUP DISTRIBUTORS PRIVATE LIMITED",
"SANTIS PHARMACEUTICALS PRIVATE LIMITED",
"SANTKRIPA EQUIPMENTS PRIVATE LIMITED",
"SANTKRUPA¬†ENTERPRISES¬†",
"SANTLAL INDUSTRIES LIMITED",
"SANTO ENGINEERING COMPANY PRIVATE LIMITED",
"SANTO MEDI SCIENCES PRIVATE LIMITED",
"SANTO PROTECTORS PRIVATE LIMITED",
"SANTO RIGHELLO PRIVATE LIMITED",
"SANTOKBA DURLABHJI MEMORIAL HOSPITAL",
"SANTOKBA DURLABJI HOSPITAL",
"SANTOM HOSPITAL",
"SANTOM HOSPITAL PRIVATE LIMITED",
"SANTOM INDUSTRIAL LINERS PRIVATE LIMITED",
"SANTOSH AGRO EQUIPMENTS PRIVATE LIMITED",
"SANTOSH AGRO FOOD PRIVATE LIMITED",
"SANTOSH AUTOMOTORS PRIVATE LIMITED",
"SANTOSH BUILDERS PRIVATE LIMITED",
"SANTOSH BUILDWELL PRIVATE LIMITED",
"SANTOSH CAREWELL SERVICES PRIVATE LIMITED",
"SANTOSH COLLEGE OF OCCUPATIONAL THERAPY",
"SANTOSH COTTON GINNING AND PRESSING PRIVATE LIMITED",
"SANTOSH DIESEL & TURBO PRIVATE LIMITED",
"SANTOSH EDUCATION SOCIETY",
"SANTOSH ELECTRONICS & APPLIANCES (INDIA) PRIVATE LIMITED",
"SANTOSH ENTERPRISES PRIVATE LIMITED",
"SANTOSH FINE FAB LIMITED",
"SANTOSH FINLEASE PRIVATE LIMITED",
"SANTOSH FLOUR MILLS PRIVATE LIMITED",
"SANTOSH GENERAL STORES PRIVATE LIMITED",
"SANTOSH GILL EARTH MOVERS PRIVATE LIMITED",
"SANTOSH GREEN TOWN PRIVATE LIMITED",
"SANTOSH HOSPITAL",
"SANTOSH HYBRID SEEDS COMPANY PRIVATE LIMITED",
"SANTOSH IMITATION PRIVATE LIMITED",
"SANTOSH INDUSTRIES LTD",
"SANTOSH INFRA POWER PRIVATE LIMITED",
"SANTOSH KUMAR SINGH PRIVATE LIMITED",
"SANTOSH LIMITED",
"SANTOSH LOGISTICS PRIVATE LIMITED",
"SANTOSH MEMORIAL HOSPITAL",
"SANTOSH MILK AND MILK PRODUCTS PRIVATE LIMITED",
"SANTOSH MOVERS",
"SANTOSH MUKESH TRADING PRIVATE LIMITED",
"SANTOSH NAIR'S KNOWLEDGE PRODUCTS & MERCHANDISE PRIVATE LIMITED",
"SANTOSH NIROG DHAM PRIVATE LIMITED",
"SANTOSH PACKAGING PRIVATE LIMITED",
"SANTOSH PIGMENT AND CHEMICAL INDUSTRIES PRIVATE LIMITED",
"SANTOSH POLYFAB PRIVATE LIMITED",
"SANTOSH PRESERVATION PRIVATE LIMITED",
"SANTOSH PUJA TRADERS PRIVATE LIMITED",
"SANTOSH RUBBER MACHINERY PRIVATE LIMITED",
"SANTOSH SALES PVT LTD",
"SANTOSH SERVICE STATION",
"SANTOSH SPECIALTY HOSPITALS PRIVATE LIMITED",
"SANTOSH STARCH PRODUCTS LIMITED",
"SANTOSH STATIONERY PRIVATE LIMITED",
"SANTOSH STEEL AND PIPES INDIA PRIVATE LIMITED",
"SANTOSH TEA INDUSTRIES PRIVATE LIMITED",
"SANTOSH TIMBER TRADING COMPANY LIMITED",
"SANTOSH TRUST",
"SANTOSH TYRES PRIVATE LIMITED",
"SANTOSH UNIVERSITY",
"SANTOSH WAREHOUSING LIMITED",
"SANTOSH WOOLLENS PVT LTD",
"SANTOSHI FINLEASE PRIVATE LIMITED",
"SANTOSHI GOLD PRIVATE LIMITED",
"SANTOSHI HOSIERY CO. PRIVATE LIMITED",
"SANTOSHI HYVOLT ELECTRICALS PRIVATE LIMITED",
"SANTOSHI MAA IRON FOUNDRY PVT LTD",
"SANTOSHI PACKAGING PRIVATE LIMITED",
"SANTOSHI POLYMERS",
"SANTOSHI TEXTILES PRIVATE LIMITED",
"SANTOSHIMA HOTELS PRIVATE LIMITED",
"SANTOSHIMATA SCHOOL OF NURSING NANDURBAR",
"SANTOSHPUR B.U.B. VIDYAMANDIR",
"SANTOSHPUR DINANATH VIDYAMANDIR",
"SANTRA POTATO TRADING COMPANY PRIVATE LIMITED",
"SANTRA PUBLICATION PRIVATE LIMITED",
"SANTRAM ENGINEERS PVT LTD",
"SANTRO TILES LIMITED",
"SANTRON ELECTRONICS PRIVATE LIMITED",
"SANTRUCK LOGISTICS PRIVATE LIMITED",
"SANTUKA ASSOCIATES PRIVATE LIMITED",
"SANTUKA FOODS PRIVATE LIMITED",
"SANTULAN AYURVEDA PRIVATE LIMITED",
"SANTULAN IMPEX PRIVATE LIMITED",
"SANTUNU VANIJYA PRIVATE LIMITED",
"SANTURA ENGINEERING PRIVATE LIMITED",
"SANTUSHTHI ENTERPRISES PRIVATE LIMITED",
"SANTUSHTI HOSPITAL PRIVATE LIMITED",
"SANTUSHTI SAREES PRIVATE LIMITED",
"SANTUSHTI SHAKES PRIVATE LIMITED",
"SANTWANI BROTHERS PRIVATE LIMITED",
"SANU AUTOMATION PRIVATE LIMITED",
"SANU BUILDERS PRIVATE LIMITED",
"SANU POLYMERS PRIVATE LIMITED",
"SANUM SANGUINEAS SOLUTIONS PRIVATE LIMITED",
"SANVA MOTORS PRIVATE LIMITED",
"SANVARDHINI AGRO PVT LTD",
"SANVARIYA RICE GRAINS PRIVATE LIMITED",
"SANVARU TECHNOLOGY LIMITED",
"SANVEER HEALTHCARE PRIVATE LIMITED",
"SANVEER INFOTECH PRIVATE LIMITED",
"SANVEI OVERSEAS PRIVATE LIMITED",
"SANVER E-SOLUTIONS PRIVATE LIMITED",
"SANVI ALLIANCE PRIVATE LIMITED",
"SANVI INFRA SOLUTIONS PRIVATE LIMITED",
"SANVI POWER PRIVATE LIMITED",
"SANVI PROPERTIES (INDIA) PRIVATE LIMITED",
"SANVI SERVICES PRIVATE LIMITED",
"SANVI SPINNING MILL PRIVATE LIMITED",
"SANVIE RETAIL PRIVATE LIMITED",
"SANVIH FINANCIAL HOLDINGS PRIVATE LIMITED",
"SANVIHI LANDSCAPE PRIVATE LIMITED",
"SANVIJAY INFRASTRUCTURES PRIVATE LIMITED",
"SANVIJAY ROLLING AND ENGINEERING LIMITED",
"SANVIK COMPUTER CONSULTANTS PRIVATE LIMITED",
"SANVIK ENGINEERS INDIA PRIVATE LIMITED",
"SANVIK LABORATORIES PRIVATE LIMITED",
"SANVIRA BIOSCIENCES PRIVATE LIMITED",
"SANVIRA INDUSTRIAL SERVICES PRIVATE LIMITED",
"SANVIRA INDUSTRIES LIMITED",
"SANVIS CERAMIC PRIVATE LIMITED",
"SANVITA BIOTECHNOLOGIES PRIVATE LIMITED",
"SANVIV SERVICES PRIVATE LIMITED",
"SANVO RESORTS PRIVATE LIMITED",
"SANVY RESINS AND COATINGS PRIVATE LIMITED",
"SANVYS INDIA PRIVATE LIMITED",
"SANWA DIAMOND TOOLS PRIVATE LIMITED",
"SANWA SYNERGY HOLDINGS INDIA PRIVATE LIMITED",
"SANWALIYA SETH GARDENS PRIVATE LIMITED",
"SANWALIYA SETH TRADING COMPANY PRIVATE LIMITED",
"SANWARASETH SUPPLIERS PRIVATE LIMITED",
"SANWARASETH TEXTILE PRIVATE LIMITED",
"SANWARASETH TRADING PRIVATE LIMITED",
"SANWARE BUILDTEK PRIVATE LIMITED",
"SANWARIA AGRO PRODUCTS PRIVATE LIMITED",
"SANWARIA AUTOMOBILE PRIVATE LIMITED",
"SANWARIA FOODS LIMITED",
"SANWARIA POLYMER INDUSTRIES PRIVATE LIMITED",
"SANWARIA STEEL PRIVATE LIMITED",
"SANWARIA SWEETS PRIVATE LIMITED",
"SANWARIA TILES PRIVATE LIMITED",
"SANWARIYA IMPEX PRIVATE LIMITED",
"SANWARIYA MINTECH PRIVATE LIMITED",
"SANWARIYA PACKAGING PRIVATE LIMITED",
"SANWARIYA PACKERS PRIVATE LIMITED",
"SANWARIYA PROCESSORS PRIVATE LIMITED",
"SANWARIYA TRAVELS PRIVATE LIMITED",
"SANWARIYA YARN PROCESSORS PRIVATE LIMITED",
"SANWARIYAJI TEXFAB INDUSTRIES LIMITED",
"SANX FERTILISERS PRIVATE LIMITED",
"SANY CAPITAL INDIA PRIVATE LIMITED",
"SANY CONS PVT LTD",
"SANY HEAVY INDUSTRY INDIA PRIVATE LIMITED",
"SANYA BUILDERS PRIVATE LIMITED",
"SANYA DYE CHEM PRIVATE LIMITED",
"SANYA EXIM PRIVATE LIMITED",
"SANYA FIBRE PRIVATE LIMITED",
"SANYA GIC IMAGING PRIVATE LIMITED",
"SANYA HOSPITAL AND DIAGNOSTICS PRIVATE LIMITED",
"SANYA HOSPITALITY PRIVATE LIMITED",
"SANYA IMAGING AND CO",
"SANYA MOTORS PRIVATE LIMITED",
"SANYA PHARMA PRIVATE LIMITED",
"SANYA RENT A CAB PRIVATE LIMITED",
"SANYA RESORTS AND HOSPITALITY PRIVATE LIMITED",
"SANYAM IMPEX PRIVATE LIMITED",
"SANYAM MARKETING PRIVATE LIMITED",
"SANYAM ORGANIZERS PRIVATE LIMITED",
"SANYAM TIE-UP PVT.LTD.",
"SANYANG EXIM INDIA PRIVATE LIMITED",
"SANYASI AYURVEDA PRIVATE LIMITED",
"SANYASIHAT TEA PROCESSING PRIVATE LIMITED",
"SANYO DENKI INDIA PRIVATE LIMITED",
"SANYO LSL TECHNOLOGY I PRIVATE LIMITED",
"SANYOG CHEMICALS PRIVATE LIMITED",
"SANYOG ENTERPRISES PRIVATE. LIMITED.",
"SANYU INFRA PROJECTS PRIVATE LIMITED",
"SANYU REC CO. LIMITED",
"SANYUKT INFRATECH PRIVATE LIMITED",
"SANYUKTA ENGINEERING PRIVATE LIMITED",
"SANZYME BIOLOGICS PRIVATE LIMITED",
"SANZYME PRIVATE LIMITED",
"SAO FINANCE AND PROPERTIES PVT. LTD.",
"SAOJI SPICES PRIVATE LIMITED",
"SAOMYA AGENCIES PRIVATE LIMITED",
"SAONER PUBLIC SCHOOL",
"SAP APPARELS PRIVATE LIMITED",
"SAP BPO SERVICES PRIVATE LIMITED",
"SAP ELECTROCONTRACTS PRIVATE LIMITED",
"SAP ENPROCON PRIVATE LIMITED",
"SAP ENTERPRISE PRIVATE LIMITED",
"SAP FASHIONS PRIVATE LIMITED",
"SAP FILTER PRIVATE LIMITED",
"SAP FINECHEM PRIVATE LIMITED",
"SAP HOLDINGS AND LEASING PRIVATE LIMITED",
"SAP INDUSTRIES",
"SAP INFRALOGISTICS PRIVATE LIMITED",
"SAP KITCHEN PRIVATE LIMITED",
"SAP MEDIA WORLDWIDE LIMITED",
"SAP MEDICALS PRIVATE LIMITED",
"SAP OLEOCHEMICALS PRIVATE LIMITED",
"SAP PARTS PRIVATE LIMITED",
"SAP PORT EQUIPMENTS PRIVATE LIMITED",
"SAP PRINT SOLUTIONS PRIVATE LIMITED",
"SAP STEELS PRIVATE LIMITED",
"SAP SWISS SOLUTIONS PRIVATE LIMITED",
"SAP VARDHMAN MACHINERY PRIVATE LIMITED",
"SAPA BS INDIA PRIVATE LIMITED",
"SAPA BUILDING SYSTEM PRIVATE LIMITED",
"SAPA EXTRUSION INDIA PRIVATE LIMITED",
"SAPA HEAT TRANSFER TUBES INDIA PRIVATE LIMITED",
"SAPA PRECISION TUBING PUNE PRIVATE LIMITED",
"SAPALA LIFE SCIENCES PRIVATE LIMITED",
"SAPALA ORGANICS PRIVATE LIMITED",
"SAPALE AUTO SERVICE PRIVATE LIMITED",
"SAPAN CATTLE FEED (INDIA) PRIVATE LIMITED",
"SAPANA CERAMICS PRIVATE LIMITED",
"SAPANA COOL PRODUCTS PRIVATE LIMITED",
"SAPANA HOME PRODUCTS PVT LTD",
"SAPANA OVERSEAS PRIVATE LIMITED",
"SAPANA POLYWEAVE PRIVATE LIMITED",
"SAPAS SOLUTIONS PRIVATE LIMITED",
"SAPAT AND COMPANY BOMBAY PRIVATE LIMITED",
"SAPAT INTERNATIONAL PRIVATE LIMITED",
"SAPCO BITUMEN COMPANY LIMITED",
"SAPCON INFRA PRIVATE LIMITED",
"SAPCON INSTRUMENTS PRIVATE LIMITED",
"SAPCON STEELS PRIVATE LIMITED",
"SAPE ROADTECH INDIA PRIVATE LIMITED",
"SAPGLOBAL CLEARING & FORWARDING AGENCY PRIVATE LIMITED",
"SAPHALYA HOSPITALS PRIVATE LIMITED",
"SAPHIRE BIOTECH PRIVATE LIMITED",
"SAPHIRE BLUE INDUSTRIES PRIVATE LIMITED",
"SAPHIRE CORPORATE CONSULTANTS PRIVATE LIMITED",
"SAPHIRE GEMS (INDIA) PRIVATE LIMITED",
"SAPHIRE MAINTENANCE SERVICES PRIVATE LIMITED",
"SAPHIRE MOTORS PRIVATE LIMITED",
"SAPID DESIGNS PRIVATE LIMITED",
"SAPIDITY SERVICES AND TECHNOLOGY PRIVATE LIMITED",
"SAPIEN BIOSCIENCES PRIVATE LIMITED",
"SAPIENCE AGRIBUSINESS CONSULTING LLP",
"SAPIENCE ANALYTICS PRIVATE LIMITED",
"SAPIENCE ENGINEERS PRIVATE LIMITED",
"SAPIENCE TECHSYSTEMS PRIVATE LIMITED",
"SAPIENS BIOTEC PRIVATE LIMITED",
"SAPIENS INFOTECH PRIVATE LIMITED",
"SAPIENS TECHNOLOGIES 1982 INDIA PRIVATE LIMITED",
"SAPIENT CONSULTING PRIVATE LIMITED",
"SAPIENT INSURANCE SURVEYORS AND LOSS ASSESSORS PRIVATE LIMITED",
"SAPIENT LABORATORIES PRIVATE LIMITED",
"SAPIENT SERVICES PRIVATE LIMITED",
"SAPIENT TOURS AND TRAVELS PRIVATE LIMITED",
"SAPIENT WEALTH ADVISORS AND BROKERS PRIVATE LIMITED",
"SAPIEO SOFTWARE INDIA PRIVATE LIMITED.",
"SAPINFRA TECHNOLOGIES PRIVATE LIMITED",
"SAPINS FARM PRODUCTS PRIVATE LIMITED",
"SAPIO ANALYTICA PRIVATE LIMITED",
"SAPIZON TECHNOLOGIES LLP",
"SAPL INDUSTRIES PRIVATE LIMITED",
"SAPL INFRASTRUCTURES PRIVATE LIMITED",
"SAPLING CREATIONS PRIVATE LIMITED",
"SAPLING MARKETING PRIVATE LIMITED",
"SAPLING RETAIL (INDIA) PRIVATE LIMITED",
"SAPN INFRA PROJECTS PRIVATE LIMITED",
"SAPNA BHADAWAR ROAD LINES PRIVATE LIMITED",
"SAPNA BOOK HOUSE PRIVATE LIMITED",
"SAPNA DETERGENTS AND CHEMICALS PRIVATE LIMITED",
"SAPNA DISTRIBUTORS PVT LTD.",
"SAPNA ENGINEERING SOLUTIONS PRIVATE LIMITED",
"SAPNA FLOUR MILLS PRIVATE LIMITED",
"SAPNA HEALTH CARE CENTRE PRIVATE LIMITED PART IX",
"SAPNA INFOWAY PRIVATE LIMITED",
"SAPNA PHARMACEUTICALS PRIVATE LIMITED",
"SAPNESWAR CONSTRUCTION PRIVATE LIMITED",
"SAPO VENTURES PRIVATE LIMITED",
"SAPOCOM TECHNOLOGIES PRIVATE LIMITED",
"SAPOTECH SOLUTIONS PRIVATE LIMITED",
"SAPOURS TECHNOLOGIES PRIVATE LIMITED",
"SAPPER LIFESTYLE PRIVATE LIMITED",
"SAPPER SOFTWARE PRIVATE LIMITED",
"SAPPER'S BROKING SERVICES PRIVATE LIMITED",
"SAPPERS INFOTECH PRIVATE LIMITED",
"SAPPHIRA HOSPITALITY SERVICES PRIVATE LIMITED",
"SAPPHIRE BLUE INDUSTRIES PRIVATE LIMITED",
"SAPPHIRE BLUE PRODUCTION (OPC) PRIVATE LIMITED",
"SAPPHIRE CABLE & SERVICES PRIVATE LIMITED",
"SAPPHIRE CLOTHING COMPANY INDIA PRIVATE LIMITED",
"SAPPHIRE COLD CHAIN PRIVATE LIMITED",
"SAPPHIRE COMPUTECH PRIVATE LIMITED",
"SAPPHIRE DIGITAL PRINTERS PRIVATE LIMITED",
"SAPPHIRE ERP SYSTEMS PRIVATE LIMITED",
"SAPPHIRE EXIM SERVICES PRIVATE LIMITED",
"SAPPHIRE EXTRUPACK PRIVATE LIMITED",
"SAPPHIRE FIRE PROTECTION PROJECTS PRIVATE LIMITED",
"SAPPHIRE FOODS INDIA LIMITED",
"SAPPHIRE FOREX PRIVATE LIMITED",
"SAPPHIRE FURNITURE & FURNISHINGS PRIVATE LIMITED",
"SAPPHIRE GLASS SOLUTIONS PRIVATE LIMITED",
"SAPPHIRE HOUSE OF FASHION PRIVATE LIMITED",
"SAPPHIRE HOUSEKEEPING SERVICES PRIVATE LIMITED",
"SAPPHIRE HUMAN SOLUTIONS PRIVATE LIMITED",
"SAPPHIRE INDIA PRIVATE LIMITED",
"SAPPHIRE INDUSTRIAL INFRASTRUCTURES PRIVATE. LIMITED.",
"SAPPHIRE INFO SOLUTIONS PRIVATE LIMITED",
"SAPPHIRE INFOSYSTEM PRIVATE LIMITED",
"SAPPHIRE INFRAVENTURES PRIVATE LIMITED",
"SAPPHIRE INTERIOR SOLUTIONS PRIVATE LIMITED",
"SAPPHIRE INTERNATIONAL SCHOOL",
"SAPPHIRE INTREX LIMITED",
"SAPPHIRE LIFESCIENCES PRIVATE LIMITED",
"SAPPHIRE MOBILE PHONES AND ACCESSORIES PRIVATE LIMITED",
"SAPPHIRE OVERSEAS",
"SAPPHIRE PAPERS MILL PRIVATE LIMITED",
"SAPPHIRE PLASTOCHEM PRIVATE LIMITED",
"SAPPHIRE PREMIUM REALTY PRIVATE LIMITED",
"SAPPHIRE PROJECTS PRIVATE LIMITED",
"SAPPHIRE PROVENTURES PRIVATE LIMITED",
"SAPPHIRE RECLAIM RUBBER PRIVATE LIMITED",
"SAPPHIRE SALES AND SERVICES PRIVATE LIMITED",
"SAPPHIRE SALES CORPORATION PRIVATE LIMITED",
"SAPPHIRE SOFTWARE SOLUTIONS",
"SAPPHIRE SURGICAL SUPPLIERS PRIVATE LIMITED",
"SAPPHIRE TECHNOCRATS PRIVATE LIMITED",
"SAPPHIRE TRADE ASSOCIATES PRIVATE LIMITED",
"SAPPHIRE TRADESERVE PRIVATE LIMITED",
"SAPPHIRE WELD & WIRE PRIVATE LIMITED",
"SAPPHIREINFOTECH VENTURES PRIVATE LIMITED",
"SAPPHIRUS SYSTEMS PRIVATE LIMITED",
"SAPPLE SYSTEMS PRIVATE LIMITED",
"SAPRA MEDICARE PRIVATE LIMITED",
"SAPRA PAINTS PRIVATE LIMITED",
"SAPRA TRANSPORT PRIVATE LIMITED",
"SAPRAS ARCHITECTS AND ENGINEERS PRIVATE LIMITED",
"SAPRASA CAPITAL MANAGEMENT PRIVATE LIMITED",
"SAPRE AUTO ANCILLARIES",
"SAPRE PRECISION TECHNOLOGIES",
"SAPRECISION PRIVATE LIMITED",
"SAPROSE TEXTILES PRIVATE LIMITED",
"SAPRU MACHINES PVT LTD",
"SAPRY MARKETING PVT LTD",
"SAPS POWER EQUIPMENTS PRIVATE LIMITED",
"SAPSON SOLAR PRIVATE LIMITED",
"SAPTA GRAIN AGRO PRIVATE LIMITED",
"SAPTAGIR CAMPHOR PRIVATE LIMITED",
"SAPTAGIRI AUTO PRIVATE LIMITED",
"SAPTAGIRI ENGINEERING PRIVATE LIMITED",
"SAPTAGIRI GRAMEENA BANK",
"SAPTAGIRI HOSPITAL",
"SAPTAGIRI INTERNATIONAL PRIVATE LIMITED",
"SAPTAGIRI MARBLES PRIVATE LIMITED",
"SAPTAGIRI PACKAGINGS PRIVATE LIMITED",
"SAPTAGIRI PU COLLEGE",
"SAPTAGIRI RESTAURANT PRIVATE LIMITED",
"SAPTAM DECOR PRIVATE LIMITED",
"SAPTAM POLYFILMS PRIVATE LIMITED",
"SAPTARISHI AGRO INDUSTRIES LIMITED",
"SAPTARISHI CEMENT & INDUSTRIES LTD",
"SAPTARISHI EXIM PRIVATE LIMITED",
"SAPTARISHI STONEX PRIVATE LIMITED",
"SAPTASATIJ INDUSTRIES PRIVATE LIMITED",
"SAPTASATIJ METATECH PRIVATE LIMITED",
"SAPTASHREE GYM AND FITNESS PRIVATE LIMITED",
"SAPTASHREE REALITY PRIVATE LIMITED",
"SAPTASHRUNGI FARMER PRODUCER COMPANY LIMITED",
"SAPTATI BUILD ESTATE LIMITED",
"SAPTHA GIRI FINANCIAL MARKETING SERVICES PRIVATE LIMITED",
"SAPTHA INNOVATIONS PRIVATE LIMITED",
"SAPTHA ZEAL PRIVATE LIMITED",
"SAPTHAGIRI BUILDWELL PRIVTE LIMITED",
"SAPTHAGIRI CIRCULAR PRIVATE LIMITED",
"SAPTHAGIRI HOSPITAL",
"SAPTHAGIRI INDUSTRIES PRIVATE LIMITED",
"SAPTHAGIRI INSTITUTE OF MANAGEMENT",
"SAPTHAGIRI INSTITUTE OF MEDICAL SCIENCES AND RESEARCH CENTRE",
"SAPTHAM FOOD AND BEVERAGES PRIVATE LIMITED",
"SAPTHAVARNA BUILDERS PRIVATE LIMITED",
"SAPTHRISHI BUILDCON LLP",
"SAPTRISHI BUILDERS PRIVATE LIMITED",
"SAPTRISHI HERBALS PRIVATE LIMITED",
"SAPTRISHI INFRATRADE PRIVATE LIMITED",
"SAPURA ENGINEERING & CONSTRUCTION INDIA PRIVATE LIMITED",
"SAPWOOD VENTURES PRIVATE LIMITED",
"SAR ADVERTISING PRIVATE LIMITED",
"SAR AGROCHEMICALS AND FERTILIZERS PRIVATE LIMITED",
"SAR AGROTECH PRIVATE LIMITED",
"SAR APPARELS INDIA PRIVATE LIMITED",
"SAR AUTO PRODUCTS LIMITEED",
"SAR AVIATION SERVICES PRIVATE LIMITED",
"SAR CLOTHING (INDIA) PRIVATE LIMITED",
"SAR COATINGS LLP",
"SAR COMPONENTS PRIVATE LIMITED",
"SAR DENIM PRIVATE LIMITED",
"SAR DISTRIBUTION HOUSE PRIVATE LIMITED",
"SAR EDUTECH LIMITED",
"SAR ENTRADE PRIVATE LIMITED",
"SAR FOREX AND LEISURE PRIVATE LIMITED",
"SAR GLOBAL PRIVATE LIMITED",
"SAR HEALTH LINE PRIVATE LIMITED",
"SAR INDIA DIGITAL PRIVATE LIMITED",
"SAR INFRACON",
"SAR INTECH PRIVATE LIMITED",
"SAR PARIVAHAN PRIVATE LIMITED",
"SAR PIONEER INFRASTRUCTURE PRIVATE LIMITED",
"SAR RETAIL PRIVATE LIMITED",
"SAR SALES PRIVATE LIMITED",
"SAR SENAPATI SANTAJI GHORPADE SUGAR FACTORY LIMITED",
"SAR STEEL BALLS PRIVATE LTD",
"SAR STUDIO PRIVATE LIMITED",
"SAR TECH SOLUTIONS PRIVATE LIMITED",
"SAR TELEVENTURE LIMITED",
"SAR TRANSPORT SYSTEMS PRIVATE LIMITED",
"SAR WORLDWIDE LOGISTICS PRIVATE LIMITED",
"SARA AGRO INDUSTRIES",
"SARA ANALYTICS PRIVATE LIMITED",
"SARA AUTOMOBILES PRIVATE LIMITED",
"SARA CHEM (INDIA) PRIVATE LIMITED",
"SARA COLLECTIONS PRIVATE LIMITED",
"SARA DIAMONDS PRIVATE LIMITED",
"SARA ELECTRICA PRIVATE LIMITED",
"SARA ELGI INDUSTRIES LIMITED",
"SARA ELITE ELEVATORS PRIVATE LIMITED",
"SARA ESTATES PRIVATE LIMITED",
"SARA EXPOFABS PRIVATE LIMITED",
"SARA EXPORTS LIMITED",
"SARA GANDEVIKAR JEWELLERS PRIVATE LIMITED",
"SARA HEALTHCARE PRIVATE LIMITED",
"SARA HOSPITALITY PRIVATE LIMITED",
"SARA HR CONSULTANTS PRIVATE LIMITED",
"SARA INTERIORS PRIVATE LIMITED",
"SARA JEWELS PRIVATE LIMITED",
"SARA LEATHER INDUSTRIES",
"SARA LIFESTYLE",
"SARA LOGISTICS SERVICES PRIVATE LIMITED",
"SARA MANAGEMENT SOLUTION PRIVATE LIMITED",
"SARA METSTEEL PRIVATE LIMITED",
"SARA MOTION PICTURES PRIVATE LIMITED",
"SARA MULTISPECIALITY HOSPITAL PRIVATE LIMITED",
"SARA PACKING SOLUTION",
"SARA PLAST PRIVATE LIMITED",
"SARA REMEDIES LIMITED",
"SARA RESEARCH & DEVELOPMENT CENTRE PRIVATE LIMITED",
"SARA SAE PRIVATE LIMITED",
"SARA SALES PRIVATE LIMITED",
"SARA SECURITIES PRIVATE LIMITED",
"SARA SECURITY & FACILITY SERVICE PRIVATE LIMITED",
"SARA SHREY INDUSTRIES AND TRADERS PRIVATE LIMITED",
"SARA SOLUTIONS LIMITED",
"SARA SPICES PRIVATE LIMITED",
"SARA SPINTEX INDIA PRIVATE LIMITED",
"SARA SUOLE PRIVATE LIMITED",
"SARA TEXTILES LIMITED.",
"SARAANSH SUITINGS PRIVATE LIMITED",
"SARABAI ENTERPRISES PRIVATE LIMITED",
"SARABHAI CHEMICALS INDIA PRIVATE LIMITED",
"SARABHAI HOLDINGS PRIVATE LIMITED",
"SARABHAI M. CHEMICALS LIMITED",
"SARABHAI PROWHEELS",
"SARABJEET ASSOCIATES PRIVATE LIMITED",
"SARABJIT COLD STORAGE PRIVATE LIMITED",
"SARACA LABORATORIES LIMITED",
"SARACA SOLUTIONS PRIVATE LIMITED",
"SARADA EDUCATIONAL INSTITUTIONS",
"SARADA INFRATECH PRIVATE LIMITED",
"SARADA JUTE MILLS PRIVATE LIMITED",
"SARADA MA GIRLS COLLEGE",
"SARADA NIVAS PRIVATE LIMITED",
"SARADA PRASAD INSTITUTION",
"SARADA PROJECTS LIMITED",
"SARADA RANI PRIVATE LIMITED",
"SARADAMBIKA POWER PLANT PRIVATE LIMITED",
"SARADEUZ INFRASTRUCTURES PRIVATE LIMITED",
"SARADHAMBIKA PAPER & BOARD MILLS PRIVATE LIMITED",
"SARADHANA SULZTEX PRIVATE LIMITED",
"SARADHI PROJECTS PRIVATE LIMITED",
"SARAF AGENCIES PRIVATE LIMITED",
"SARAF BUILDERS",
"SARAF CORPORATION INDIA PRIVATE LIMITED",
"SARAF CREDIT AND PORTFOLIO PRIVATE LIMITED",
"SARAF ELECTRICALS PRIVATE. LIMITED.",
"SARAF EXIM PVT LTD",
"SARAF FAB TRADE PRIVATE LIMITED",
"SARAF FINCOM PRIVATE LIMITED",
"SARAF FOODS LIMITED",
"SARAF GARTEX LIMITED",
"SARAF GLASS AGENCY PRIVATE LIMITED",
"SARAF HOUSING DEVELOPMENT PRIVATE LIMITED",
"SARAF JEWELLERS ASSOCIATES PRIVATE LIMITED",
"SARAF LUMBERS PRIVATE LIMITED",
"SARAF MERCHANDISE (INDIA) PRIVATE LIMITED",
"SARAF METASTEEL LIMITED",
"SARAF OFFSET PRIVATE LIMITED",
"SARAF ORGANICS PRIVATE.LIMITED",
"SARAF POLY SYNTHETICS PRIVATE LIMITED",
"SARAF REAL INFRA PRIVATE LIMITED",
"SARAF REALTECH DEVELOPERS PRIVATE LIMITED",
"SARAF RESIN & CHEMICALS PVT LTD",
"SARAF STARCH PRODUCTS PRIVATE LTD",
"SARAF TEXTILE MILLS PVT LTD",
"SARAF TRADING CORPORATION (INTERNATIONAL) PRIVATE LIMITED",
"SARAF TRADING CORPORATION PVT LTD",
"SARAF TREXIM LIMITED",
"SARAFF CREATION PRIVATE LIMITED",
"SARAGRIS FASHIONS PRIVATE LIMITED",
"SARAH AGRO INPUTS PRIVATE LIMITED",
"SARAH EXIM PRIVATE LIMITED",
"SARAH FOODS",
"SARAIMX LOGISTICS PRIVATE LIMITED",
"SARAINFOWAY ITES INDIA PRIVATE LIMITED",
"SARAIYA ISPAT PRIVATE LIMITED",
"SARAJU AGRIWAYS EXPORTS PRIVATE LIMITED",
"SARAL ADVANCED DIAGNOSTIC PRIVATE LIMITED",
"SARAL AGRO CHEMICALS LLP",
"SARAL COMMUNICATIONS PRIVATE LIMITED",
"SARAL DESIGN SOLUTIONS PRIVATE LIMITED",
"SARAL DIAGNOSTICS CLASSIC PRIVATE LIMITED",
"SARAL E COMMERCE PRIVATE LIMITED",
"SARAL FERTILIZERS PRIVATE LIMITED",
"SARAL FOREX & MONEY SERVICES PRIVATE LIMITED",
"SARAL HEALTHCARE & DIAGNOSTICS PRIVATE LIMITED",
"SARAL HOME EASY LIVING PRIVATE LIMITED",
"SARAL HOME FINANCE LIMITED",
"SARAL HOUSEWARE PRIVATE LIMITED",
"SARAL HYGIENE PRODUCT PRIVATE LIMITED",
"SARAL INDIA FINSERV PRIVATE LIMITED",
"SARAL INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"SARAL INSURANCE BROKING PRIVATE LIMITED",
"SARAL METALCRAFT PRIVATE LIMITED",
"SARAL MINING LIMITED",
"SARAL PATHLAB PRIVATE LIMITED",
"SARAL PLASTICS PRIVATE LIMITED",
"SARAL PRINTS PRIVATE LIMITED",
"SARAL SOFTWARE SOLUTION PRIVATE LIMITED",
"SARALA BIRLA PUBLIC SCHOOL",
"SARALA BIRLA UNIVERSITY",
"SARALA DEVELOPMENT & MICROFINANCE PRIVATE LIMITED",
"SARALA FOODS PRIVATE LIMITED",
"SARALA PROJECT WORKS PRIVATE LIMITED",
"SARALA PROJECT WORKS PRIVATE LIMITED.",
"SARALA TEA COMPANY PRIVATE LIMITED",
"SARALAGRO PRIVATE LIMITED",
"SARALAYA HOSPITALS PRIVATE LIMITED",
"SARALIA STEEL INDUSTRIES PRIVATE LIMITED",
"SARALOAN TECHNOLOGIES PRIVATE LIMITED",
"SARAM ENVIRO SERVICES PRIVATE LIMITED",
"SARAN AIRCON PRIVATE LIMITED",
"SARAN ALLOYS PRIVATE LIMITED",
"SARAN BUILDWELL PRIVATE LIMITED",
"SARAN EQUIPMENTS AND ENGINEERS PRIVATE LIMITED",
"SARAN FERROS PRIVATE LIMITED",
"SARAN IMPEX PRIVATE LIMITED",
"SARAN MOTORS PRIVATE LIMITED",
"SARAN ROLLER FLOUR MILLS PRIVATE LIMITED",
"SARANATHAN COLLEGE OF ENGINEERING",
"SARANG AUTO AERONAUTICS PRIVATE LIMITED",
"SARANG AUTOPARTS PRIVATE LIMITED",
"SARANG EXPORTS PRIVATE LIMITED",
"SARANG SILK PRIVATE LIMITED",
"SARANGA BROADBAND COMMUNICATIONS PRIVATE LIMITED",
"SARANGA GEOSOFTWARE AND ENGINEERING SERVICES PRIVATE LIMITED",
"SARANGDEEP PROPERTIES PRIVATE LIMITED",
"SARANGDEEP REALTORS PRIVATE LIMITED",
"SARANSH ALLOYS LIMITED",
"SARANSH INFRARENTALS PRIVATE LIMITED",
"SARANSH TRADE AND COMMERCE PRIVATE LIMITED",
"SARANYA ELECTRICAL & MARINE SERVICES",
"SARANYA GARMENTS PRIVATE LIMITED",
"SARANYA HEALTH SERVICES PRIVATE LIMITED",
"SARANYA PRECISION TOOLS PRIVATE LIMITED",
"SARANYA PROPERTIES PRIVATE LIMITED",
"ASHOK TEXTILE MILLS PRIVATE LIMITED",
"SARANYA TEXTILES PRIVATE LIMITED",
"SARANYU POWER TRADING PRIVATE LIMITED",
"SARANYU TECHNOLOGIES PRIVATE LIMITED",
"SARAO DISTILLERY (OPC) PRIVATE LIMITED",
"SARAOGI AUTOMOBILES PRIVATE LIMITED",
"SARAOGI BUILDERS LIMITED",
"SARAOGI E-VENTURES PRIVATE LIMITED",
"SARAOGI MANSION ESTATE PRIVATE LIMITED",
"SARAOGI SHELLAC & AROMATICS PRIVATE LIMITED",
"SARAOGI SUPER SALES PRIVATE LIMITED",
"SARAOGI UNIFORM PRIVATE LIMITED",
"SARAOGI VINIYOG PVT.LTD.",
"SARAS CLASSES",
"SARAS FASHION CLOTHING PRIVATE LIMITED",
"SARAS GLOBAL ISPAT PRIVATE LIMITED",
"SARAS INDIA SYSTEMS PRIVATE LIMITED",
"SARAS INFRA BUILDTECH PRIVATE LIMITED",
"SARAS INFRABUILDCON PRIVATE LIMITED",
"SARAS PLASTICS PRIVATE LTD",
"SARAS PLYWOOD PRODUCTS PRIVATE LIMITED",
"SARAS POWER PROJECTS COMPANY PRIVATE LIMITED",
"SARAS SOLUTIONS INDIA PRIVATE LIMITED",
"SARAS TECHNO R VISION PRIVATE LIMITED",
"SARAS TRAVEL SERVICES PRIVATE LIMITED",
"SARAS VEG OIL PVT. LTD.",
"SARAS WIRES PRIVATE LIMITED",
"SARASH IMPEX PRIVATE LIMITED",
"SARASIJA HORTICULTURAL FARMS PRIVATE LIMITED",
"SARASIYA AGRITECH LIMITED",
"SARASVATHI CORRUGATED (INDIA) PRIVATE LIMITED",
"SARASWAT AGROCOM PRIVATE LIMITED",
"SARASWAT CO-OP BANK LIMITED",
"SARASWAT ENGINEERS PRIVATE LIMITED",
"SARASWAT GARMENTS PRIVATE LIMITED",
"SARASWAT HOSPITAL",
"SARASWAT INFOTECH LIMITED",
"SARASWAT INFOTECH PRIVATE LIMITED",
"SARASWATHI AMMAL EDUCATIONAL & CHARITABLE TRUST",
"SARASWATHI BROILERS PRIVATE LIMITED",
"SARASWATHI EDUCATION SOCIETY",
"SARASWATHI EDUCATION TRUST",
"SARASWATHI ENGINEERING CONSTRUCTION PRIVATE LIMITED",
"SARASWATHI INSTITUTE OF MEDICAL SCIENCES",
"SARASWATHY ENGINEERING",
"SARASWATHY MULTISPECIALITY HOSPITAL",
"SARASWATI ACCOUNTANTS SOFTWARE PRIVATE LIMITED",
"SARASWATI AGRO CHEMICALS INDIA PRIVATE LIMITED",
"SARASWATI AGRO LIFE SCIENCE (INDIA) PRIVATE LIMITED",
"SARASWATI ALLOYS PRIVATE LIMITED",
"SARASWATI B ED COLLEGE",
"SARASWATI BALIKA VIDYALAYA INTER COLLEGE",
"SARASWATI BUILDERS",
"SARASWATI CHEMICALS PRIVATE LIMITED",
"SARASWATI COMMERCIAL INDIA LTD",
"SARASWATI CONSTRUCTION AND DEVELOPERS PRIVATE LIMITED",
"SARASWATI COTTON GINNING & AGRO INDUSTRIES PRIVATE LIMITED",
"SARASWATI DAIRY PRODUCTS INDIA PRIVATE LIMITED",
"SARASWATI DENTAL COLLEGE",
"SARASWATI DOT COM PRIVATE LIMITED",
"SARASWATI DYERS PRIVATE LIMITED",
"SARASWATI DYNAMICS PRIVATE LIMITED",
"SARASWATI EDUCATION SOCIETY",
"SARASWATI ENGINEERING LIMITED",
"SARASWATI ENTERTAINMENT PRIVATE LIMITED",
"SARASWATI EXIM PRIVATE LIMITED",
"SARASWATI FABRIC PRIVATE LIMITED",
"SARASWATI FINEART OFFSET PRIVATE LIMITED",
"SARASWATI GYAN MANDIR",
"SARASWATI HEART CARE AND RESEARCH CENTRE PRIVATE LIMITED",
"SARASWATI HIGH SCHOOL",
"SARASWATI HIGH SCHOOL VADAD",
"SARASWATI HOSPITAL",
"SARASWATI INFOSOFT TECHNOLOGY PRIVATE LIMITED",
"SARASWATI INT COLL HATHRAS",
"SARASWATI INTERNATIONAL SCHOOL",
"SARASWATI LOGISTICS PRIVATE LIMITED",
"SARASWATI MADHYAMIK VIDYALAYA VIKHRAN",
"SARASWATI MADHYAMIK VIDYAMANDIR NAGPUR",
"SARASWATI MANPOWER PRIVATE LIMITED",
"SARASWATI MEDICAL COLLEGE",
"SARASWATI MOTORS LLP",
"SARASWATI NURSING SCHOOL",
"SARASWATI OFFSET PRINTERS PRIVATE LIMITED",
"SARASWATI ONLINE.COM INDIA LIMITED",
"SARASWATI ORA VIDYA URLIKANCHAN HAVELI",
"SARASWATI ORGANIC FOODS PRIVATE LIMITED",
"SARASWATI PACKAGING INDUSTRIES PRIVATE LIMITED",
"SARASWATI PIGMENTS PRIVATE. LIMITED.",
"SARASWATI PLASTO TECH INDIA PRIVATE LIMITED",
"SARASWATI PLYWOOD PRIVATE LIMITED",
"SARASWATI POLYCHEM (INDIA) PRIVATE LIMITED",
"SARASWATI PRIMARY SCHOOL",
"SARASWATI PRINT FACTORY PRIVATE LIMITED",
"SARASWATI PRINTERS AND PUBLISHERS PRIVATE LIMITED",
"SARASWATI PUBLISHING COMPANY PRIVATE LIMITED",
"SARASWATI RE ROLLERS (INDIA) PRIVATE LIMITED",
"SARASWATI RECYCLERS PRIVATE LIMITED",
"SARASWATI RICE & GENERAL MILLS",
"SARASWATI SANGEET KALA MAHAVIDYALAYA LATUR",
"SARASWATI SAREE DEPOT LIMITED",
"SARASWATI SECURITIES PRIVATE LIMITED",
"SARASWATI SHIKSHANIKETAN HIGH SCHOOL",
"SARASWATI SHISHU MANDIR SENIOR SECONDARY SCHOOL",
"SARASWATI SHISHU VIDYA MANDIR",
"SARASWATI SHISHU/VIDHYA MANDIR HIGHER SECONDARY SCHOOL MAHIDPUR ROAD",
"SARASWATI SUGAR MILLS LIMITED",
"SARASWATI TRADING COMPANY",
"SARASWATI UTPADAN PVT LTD",
"SARASWATI VIDHYA MANDIR INTERMEDIATE COLLEGE",
"SARASWATI VIDHYALAYA H S SCHOOL",
"SARASWATI VIDHYALAYA VINZOL",
"SARASWATI VIDYA MANDIR ARTS COLLEGE KINWAT",
"SARASWATI VIDYA MANDIR PRIMARY SCHOOL",
"SARASWATI VIDYALAYA & JR COLLEGE THANE",
"SARASWATI VIDYALAYA DAHEGAON YAVATMAL",
"SARASWATI VIDYALAYA UNION PRE PRIMARY SCHOOL PRIMARY SCHOOL",
"SARASWATI VIDYALYA",
"SARASWATI WHEELS PRIVATE LIMITED",
"SARASWATI WOOD PRIVATE LIMITED",
"SARASWATII GLOBAL PRIVATE LIMITED",
"SARASWATIORIZON INFRAPROJECTS PRIVATE LIMITED",
"SARASWATIPUR TEA & INDUSTRIES LIMITED",
"SARASWATY PRESS LIMITED",
"SARASWATYI GLASSES & PLY PRIVATE LIMITED",
"SARAT CHANDRA IAS ACADEMY",
"SARAT CHANDRA SUR INSTITUTION",
"SARAT CHATTERJEE & CO VISAKHAPATNAM PRIVATE LIMITED",
"SARAT INDUSTRIES LIMITED",
"SARAT SHRADHA INFRASTRUCTURE PRIVATE LIMITED",
"SARATH JUNIOR COLLEGE",
"SARATH STORAGES PRIVATE LIMITED",
"SARATHI EXIM PRIVATE LIMITED",
"SARATHI FINANCE CONSULTANCY LLP",
"SARATHI PIPES INDIA PRIVATE LIMITED",
"SARATHI REALTORS PRIVATE LIMITED",
"SARATHI SOFTECH PRIVATE LIMITED",
"SARATHI SUPER STRUCTURE PRIVATE LIMITED",
"SARATHY BIKES PRIVATE LIMITED",
"SARATHY CARS PRIVATE LIMITED",
"SARATHY GEO-TECH AND ENGINEERING SERVICES PRIVATE LIMITED",
"SARAV SHIKSHA ABHIYAN MISSION JILLA PANCHYAT SHIKSHAN SAMITI",
"SARAVAN AGRITECH PRIVATE LIMITED",
"SARAVAN FAB INDIA EXPORTS PRIVATE LIMITED",
"SARAVANA BHAVAN PRIVATE LIMITED",
"SARAVANA ECO POWER INDIA PRIVATE LIMITED",
"SARAVANA GARMENTS PRIVATE LIMITED",
"SARAVANA HOSPITAL PRIVATE LIMITED",
"SARAVANA MULTI SPECIALITY HOSPITAL PRIVATE LIMITED",
"SARAVANA POLY THREADS PRIVATE LIMITED",
"SARAVANA SCAN PRIVATE LIMITED",
"SARAVANA SELVARATHNAM (TRADING & MANUFACTURING) PRIVATE LIMITED",
"SARAVANA SELVARATHNAM RETAIL PRIVATE LIMITED",
"SARAVANA SPINNERS LIMITED",
"SARAVANA STOCKS INVESTMENTS PRIVATE LIMITED",
"SARAVANA STORES CELEBRITY PRIVATE LIMITED",
"SARAVANA STORES ELITE PRIVATE LIMITED",
"SARAVANA STORES FOODS PRIVATE LIMITED",
"SARAVANA TEXTILES PRIVATE. LIMITED.",
"SARAVANA VEL ENTERPRICES",
"SARAVANAGIRI SPINNING MILL LIMITED.",
"SARAVANAN ELECTRICALS & ENGINEERING PRIVATE LIMITED",
"SARAVI HOME CARE PRODUCTS PRIVATE LIMITED",
"SARAVI INDUSTRIES PRIVATE LIMITED",
"SARAWAGI AGROVET PRIVATE LIMITED",
"SARAWAGI AUTOMOBILES PRIVATE LIMITED",
"SARAWAGI RICE & OIL MILL (P) LTD",
"SARAWAGI ROLLER FLOUR MILLS PRIVATE LIMITED",
"SARAWAGIE AGRO FOODS PRIVATE LIMITED",
"SARAYA AVIATION PRIVATE LIMITED",
"SARAYA MYSTAIR HYGIENE PRIVATE LIMITED",
"SARAYU BRANDING & PRINTING PRIVATE LIMITED",
"SARAYU CLEANGEN PRIVATE LIMITED",
"SARAYU INFOTECH SOLUTIONS PRIVATE LIMITED",
"SARAYU INVESTMENTS PRIVATE LIMITED",
"SARAYU MARITIME PRIVATE LIMITED",
"SARAYU STRUCTURALS PRIVATE LIMITED",
"SARB MULTIPLEX PRIVATE LIMITED",
"SARBA PURTA (CONSTRUCTION ) PVT LTD",
"SARBAMANGALA AGRO PRODUCTS PRIVATE LIMITED",
"SARBANI FOODS PRIVATE LIMITED",
"SARBANI SAREES PRIVATE LIMITED",
"SARBATI INFRAPROJECTS PRIVATE LIMITED",
"SARBESTOS AUTO SPARES PRIVATE LIMITED",
"SARBI APPAREL PRIVATE LIMITED",
"SARBI PETROLEUM AND CHEMICALS PRIVATE LIMITED",
"SARC AVIATION PRIVATE LIMITED",
"SARC PROJECTS PRIVATE LIMITED",
"SARCHEM KIMYA SANAYI VE TICARET AS",
"SARCO EQUIPMENTS PVT. LTD",
"SARCO ROADLINES PRIVATE LIMITED",
"SARCOMA REMEDIES PRIVATE LIMITED",
"SARCON PROJECTS PRIVATE LIMITED",
"SARD METALS PRIVATE LIMITED",
"SARDA & SEMEC ELECTROMECH PVT LTD",
"SARDA AGRICULTURE AND PROPERTIES PRIVATE LIMITED",
"SARDA ALLOY STEEL PRIVATE. LIMITED.",
"SARDA BIO POLYMERS PRIVATE LIMITED",
"SARDA BUILDCON LIMITED",
"SARDA CONSTRUCTIONS",
"SARDA DAIRY AND FOOD PRODUCTS LIMITED",
"SARDA DESIGNER P LTD",
"SARDA DISTRIBUTORS PRIVATE LIMITED",
"SARDA ECO POWER LIMITED",
"SARDA ENERGY AND MINERALS LIMITED",
"SARDA ENERGY LIMITED",
"SARDA HOUSING DEVELOPMENT LIMITED TFR. FROM KOLKATA TO DELHI",
"SARDA JEWELLERS INDIA PRIVATE LIMITED",
"SARDA MAGNETICS PRIVATE LIMITED",
"SARDA METALS & ALLOYS LIMITED",
"SARDA PIPES AND FITTINGS PRIVATE LIMITED",
"SARDA PROTEINS LTD",
"SARDA STARCH PRIVATE LIMITED",
"SARDAR AUTOMOBILE PRIVATE LIMITED",
"SARDAR CASTINGS PRIVATE LIMITED",
"SARDAR COTTON",
"SARDAR DASTUR HORMAZDIAR HIGH SCHOOL",
"SARDAR EXHIBITORS PVT LTD",
"SARDAR FROZEN PRODUCTS PRIVATE LIMITED",
"SARDAR GAS AND PETRO CO PRIVATE LIMITED",
"SARDAR H P HOSPITAL",
"SARDAR HANDLOOM FACTORY PVT LTD",
"SARDAR INDUSTRIES",
"SARDAR IRRIGATION SYSTEMS PRIVATE LIMITED",
"SARDAR ISPAT PVT LTD",
"SARDAR JI DI HATTI DEPARTMENTAL STORE PRIVATE LIMITED",
"SARDAR LAMICHEMS PVT LTD",
"SARDAR MOTORS (AUTOWHEEL) PRIVATE LIMITED",
"SARDAR PATEL COLLEGE",
"SARDAR PATEL COLLEGE OF PHARMACY",
"SARDAR PATEL HOSPITAL & HEART INSTITUTE",
"SARDAR PATEL INTER COLLEGE CHIRGAON",
"SARDAR PATEL RENEWABLE ENERGY RESEARCH INSTITUTE",
"SARDAR PATEL UNIVERSITY",
"SARDAR POWER PRIVATE LIMITED",
"SARDAR PROJECTS PRIVATE LIMITED",
"SARDAR SAROVAR NARMADA NIGAM LIMITED",
"SARDAR SEEDS PRIVATE LIMITED",
"SARDAR SOLVEX PRIVATE LIMITED",
"SARDAR STEEL INDUSTRIES",
"SARDAR STEELS PRIVATE LIMITED",
"SARDAR TV PRIVATE LIMITED",
"SARDAR VALLABH BHAI ARTS COLLEGE",
"SARDAR VALLABH BHAI PATEL HOSPITAL",
"SARDAR VALLABHBHAI NATIONAL INSTITUTE OF TECHNOLOGY",
"SARDAR VALLABHBHAI PATEL HIGH SCHOOL",
"SARDAR VALLABHBHAI PATEL INSTITUTE OF TECHNOLOGY",
"SARDAR VALLABHBHAI PATEL INTERNATIONAL SCHOOL OF TEXTILES & MANAGEMENT",
"SARDAR VALLABHBHAI PATEL UNIVERSITY OF AGRICULTURE & TECHNOLOGY",
"SARDAR VALLABHBHAI PATEL VIVIDHLAXI VIDHYALAYA",
"SARDAR VALLABHBHAI VANIJYA VIDYALYA",
"SARDAR VALLABHBHAI VIDYALAY NIZAR",
"SARDARGROW SEEDS COMPANY PRIVATE LIMITED",
"SARDARI LAL FOREX PRIVATE LIMITED",
"SARDARJI SAREE WALA PRIVATE LIMITED",
"SARDESAI AUTOPARTS PRIVATE LIMITED",
"SARDESAI IRRIGATION PRIVATE LIMITED",
"SARDHANA SPINNING MILLS PRIVATE. LIMITED.",
"SARDINERO AGRO AND INFRA DEVELOPERS PRIVATE LIMITED",
"SARDONYX TECHNOLOGIES PRIVATE LIMITED",
"SARDUL AUTO WORKS PRIVATE LIMITED",
"SARE HOMES PROJECT SERVICES PRIVATE LIMITED",
"SARE JUBILEE SHELTERS PRIVATE. LIMITED.",
"SARE SAAMAG REALTY PRIVATE LIMITED",
"SAREE HOUSE PRIVATE LIMITED",
"SAREEN ESTATES PRIVATE LIMITED",
"SAREEN IMPEX PRIVATE LIMITED",
"SAREENA CREATION PRIVATE LIMITED",
"SAREGAMA INDIA LIMITED",
"SAREGAMAPADHANISAA PRODUCTIONS PRIVATE LIMITED",
"SARENS HEAVY LIFT INDIA PRIVATE LIMITED",
"SAREX OVERSEAS PRIVATE LIMITED",
"SARFA INDUSTRIES PRIVATE LIMITED",
"SARFAM BUILDCON PRIVATE LIMITED",
"SARFARAZ SEAFOODS PRIVATE LIMITED",
"SARFFIN FINANCIAL ADVISORS PRIVATE LIMITED",
"SARG GLOBAL DIGITAL PRIVATE LIMITED",
"SARGA ADDITIVE MANUFACTURING PRIVATE LIMITED",
"SARGAM CATHODIC PROTECTION LLP",
"SARGAM COATERS PRIVATE LIMITED",
"SARGAM CONSULTANTS PRIVATE LIMITED",
"SARGAM CREATIONS PRIVATE LIMITED",
"SARGAM ELECTROPLATERS PRIVATE LIMITED",
"SARGAM EXPORTS LIMITED",
"SARGAM EYE HOSPITALS PRIVATE LIMITED",
"SARGAM FOOD PRIVATE LIMITED",
"SARGAM FOOT ARTS PRIVATE LIMITED",
"SARGAM INDIA ELECTRONIC PRIVATE LIMITED",
"SARGAM INSURANCE BROKERS PRIVATE LIMITED",
"SARGAM MOTORS PRIVATE LIMITED",
"SARGAM MULTISPECIALITY HOSPITAL PRIVATE LIMITED",
"SARGAM MUSICAL INSTRUMENTS LIMITED",
"SARGAM PROJECTS PRIVATE LIMITED",
"SARGAM RETAILS PRIVATE LIMITED",
"SARGAM SPICES PRIVATE LIMITED",
"SARGAM VENTURES PRIVATE LIMITED",
"SARGO TOOLS PRIVATE LIMITED",
"SARGODHA MOULDERS INDIA PRIVATE LIMITED",
"SARGODHA PLASTS INDIA PRIVATE LIMITED",
"SARGUN POWER PRIVATE LIMITED",
"SARHAD COLLEGE OF ARTS COMMERCE AND SCIENCE KATRAJ PUNE",
"SARI BARI PRIVATE LIMITED",
"SARIA AGROTECH PRIVATE LIMITED",
"SARIA INDUSTRIES",
"SARIGAM CONTAINERS PRIVATE LIMITED",
"SARIGRAM OXYTRADE PRIVATE LIMITED",
"SARIKA CIVCON PRIVATE LIMITED",
"SARIKA COLOR LAB PVT LTD",
"SARIKA INDUSTRIES PRIVATE LIMITED",
"SARIKA LIFE SCIENCES PRIVATE LIMITED",
"SARIKA TEX (INDIA) PRIVATE LIMITED",
"SARIN HATCHERIES PRIVATE LIMITED",
"SARIN INDUSTRIES PRIVATE LIMITED",
"SARIN PIPES PRIVATE LIMITED",
"SARIN TECHNOLOGIES INDIA PRIVATE LIMITED",
"SARINE ELECTRONICS PRIVATE LIMITED",
"SARIPUDI AUTO MOTIVES PRIVATE LIMITED",
"SARIPUDI AUTOMOBILES PRIVATE LIMITED",
"SARISONS SHOE TECH PRIVATE LIMITED",
"SARITA AGRO PRODUCTS PRIVATE LIMITED",
"SARITA DIAGNOSTIC CENTRE PRIVATE LIMITED",
"SARITA DIE WORKS PRIVATE LIMITED",
"SARITA FORGINGS LIMITED",
"SARITA HANDA EXPORTS PRIVATE LIMITED",
"SARITA HATCHERIES PRIVATE LIMITED",
"SARITA MULTIPLEXES PRIVATE LIMITED",
"SARITA NUPUR VYAPAR PRIVATE LIMITED",
"SARITA POLY TEX PRIVATE LIMITED",
"SARITA SULZ PRIVATE LIMITED",
"SARITA TRAVELS PRIVATE LIMITED",
"SARITHA COTTON INDUSTRIES",
"SARITHA FACILITY MANAGEMENT",
"SARITVAT TECHNOLOGIES PRIVATE LIMITED",
"SARJAK CONTAINER LINES PRIVATE LIMITED",
"SARJAN BIO-TECH PRIVATE LIMITED",
"SARJAN CONSTRUCTION PRIVATE LIMITED",
"SARJAN GAS COMPANY PRIVATE LIMITED",
"SARJAN INFRACON PRIVATE LIMITED",
"SARJAN MULTITECH PRIVATE LIMITED",
"SARJAN REALITIES PRIVATE LIMITED",
"SARJAN WATERTECH INDIA PRIVATE LIMITED",
"SARJANI CORETECH PRIVATE LIMITED",
"SARJANWAL STEELS AND INDUSTRIES PRIVATE LIMITED",
"SARJEN SYSTEMS PRIVATE LIMITED",
"SARJENA FOODS PRIVATE LIMITED",
"SARJI HOSPITAL",
"SARJU IMPEX LIMITED",
"SARK CABLES PRIVATE LIMITED",
"SARK EPC PROJECTS PRIVATE LIMITED",
"SARK HEALTHCARE PRIVATE LIMITED",
"SARK INDUSTRIES PRIVATE LIMITED",
"SARK INFRASTRUCTURES PRIVATE LIMITED",
"SARK PIPELINE TECHNOLOGIES PRIVATE LIMITED",
"SARK PROJECTS INDIA PRIVATE LIMITED",
"SARK RETAIL SERVICES PRIVATE LIMITED",
"SARK SANITECH INDIA PRIVATE LIMITED",
"SARK SPICE PRODUCTS PVT LTD",
"SARK WORKPLACE SOLUTIONS PRIVATE LIMITED",
"SARKAR AGRO POULTRIES PRIVATE. LIMITED.",
"SARKAR INDUSTRIES PRIVATE LIMITED",
"SARKAR INFRASOLUTIONS PRIVATE LIMITED",
"SARKAR MEDICAL DIAGNOSTIC CENTRE PRIVATE LIMITED",
"SARKAR POWER ENGINEERING PRIVATE LIMITED",
"SARKARI MADHYAMIK SHADA KHOPI",
"SARKHEJ SHALA NO 2",
"SARLA ADVANTECH PRIVATE LIMITED",
"SARLA ALUMINIUM STRUCTURE PRIVATE LIMITED",
"SARLA EXPORTS PVT LTD",
"SARLA HANDICRAFTS PRIVATE LIMITED",
"SARLA HOLDINGS PRIVATE LIMITED",
"SARLA INFRASTRUCTURE PRIVATE LIMITED",
"SARLA MEDICAL CENTRE PRIVATE LIMITED",
"SARLA MILLS PRIVATE LIMITED",
"SARLA MULTIPLAST PRIVATE LIMITED",
"SARLA PERFORMANCE FIBERS LIMITED",
"SARLA S BEAUTY SOLUTIONS PRIVATE LIMITED",
"SARLACHEM INDIA PRIVATE LIMITED",
"SARLAHANS BEVERAGES PRIVATE LIMITED",
"SARLAL ENGINEERING LIMITED",
"SARMA PAINTS MANUFACTURING PRIVATE LIMITED",
"SARMAN ENGINEERING PRIVATE LIMITED",
"SARMANGAL SYNTHETICS PRIVATE LIMITED",
"SARMAR INFOTECH PRIVATE LIMITED",
"SARN SWITCHGEAR CONTROL PANEL PRIVATE LIMITED",
"SARNA CHEMICALS PRIVATE LIMITED",
"SARNA INFOCOM PRIVATE LIMITED",
"SARNA MARBLES PVT LTD",
"SARNA STONEX PRIVATE LIMITED",
"SARNAM HEIGHTS PRIVATE LIMITED",
"SARNAR BUILDTECH PRIVATE LIMITED",
"SARNATH AUTOZONE PRIVATE LIMITED",
"SARNIKA TRADE EXIM PRIVATE LIMITED",
"SARO MANAGEMENT SERVICES PRIVATE LIMITED",
"SARO RUBBER & ALLIED PRODUCTS LIMITED",
"SARO TECH SOLUTIONS PRIVATE LIMITED",
"SARODAMONI TEA COMPANY PRIVATE LIMITED",
"SAROHA CONSTRUCTION PRIVATE LIMITED",
"SAROJ AGRO FIBRES PRIVATE LIMITED",
"SAROJ BUILDCON PRIVATE LIMITED",
"SAROJ BUILDSOL PRIVATE LIMITED",
"SAROJ CASTINGS PRIVATE LIMITED",
"SAROJ COMMODITIES PRIVATE LIMITED",
"SAROJ DESIGNS PRIVATE LIMITED",
"SAROJ ENGINEERING UDYOG PRIVATE LIMITED",
"SAROJ ENTERPRISES PRIVATE LIMITED",
"SAROJ FOUNDRY PRIVATE LIMITED",
"SAROJ GANESH PODAR TRUST",
"SAROJ GUPTA CANCER CENTRE AND RESEARCH INSTITUTE",
"SAROJ HOSPITAL",
"SAROJ HOSPITAL & HEART INSTITUTE",
"SAROJ INTERNATIONAL LEATHERS PRIVATE LIMITED",
"SAROJ LEATHERS (INDIA) PRIVATE LIMITED",
"SAROJ MINERALS AND STONE CRUSHING PRIVATE LIMITED",
"SAROJ OILS PRIVATE LIMITED",
"SAROJ OVERSEAS PRIVATE LIMITED",
"SAROJ PACKAGING PRIVATE LIMITED",
"SAROJ PLANTATIONS PRIVATE LIMITED",
"SAROJ PRESS PRIVATE LIMITED",
"SAROJ PRINTS CHENNAI PRIVATE LIMITED",
"SAROJ REALTORS AND DEVELOPERS PRIVATE LIMITED",
"SAROJ ROOFING PRIVATE LIMITED",
"SAROJ SUPER SPECIALITY HOSPITAL",
"SAROJ SWEETS PRIVATE LIMITED",
"SAROJ SYNTEX PRIVATE LIMITED",
"SAROJ TAPARIA CONSTRUCTION & HOUSING PRIVATE LIMITED",
"SAROJ TINY TECH INDIA PRIVATE LIMITED",
"SAROJ TRADECOM PRIVATE LIMITED",
"SAROJ WEAVERS PRIVATE LIMITED",
"SAROJA MULTI-SPECIALITY HOSPITAL",
"SAROJA PHARMA INDUSTRIES INDIA LIMITED",
"SAROJA RENEWABLES PRIVATE LIMITED",
"SAROJINI COLLEGE OF PHARMACY",
"SAROJINI MULTISERVICES PRIVATE LIMITED",
"SAROJINI NAIDU COLLEGE FOR WOMEN",
"SAROJINI NAIDU JR DEGREE COLLEGES FOR W",
"SAROJINI NAIDU MEDICAL COLLEGE AGRA",
"SAROJINI NAIDU VANITA PHARMACY MAHA VIDYALAYA",
"SAROJINI TEA CO PVT LTD",
"SAROJINI VIDHYALAYA MATRIC HIGHER SECONDARY SCHOOL",
"SAROJINIDEVI EYE HOSPITAL",
"SAROM FAB PRIVATE LIMITED",
"SARON MECHANICAL WORKS",
"SAROOPSONS INDUSTRIES LIMITED",
"SAROSH URDU HIGH SCHOOL",
"SAROTAM INDUSTRIAL GOODS RETAIL DISTRIBUTION PRIVATE LIMITED",
"SAROVAR AGRO FARMS AND BIOGAS PRIVATE LIMITED",
"SAROVAR DEVELOPERS PRIVATE LIMITED",
"SAROVAR HOTELS PRIVATE LIMITED",
"SAROVAR INSULATION PRIVATE LIMITED",
"SAROVAR SAREES PVT.LTD.",
"SAROVEN MACHINE TOOLS PRIVATE LIMITED",
"SARPAL BUILDERS PRIVATE LIMITED",
"SARPAN HYBRID SEEDS COMPANY PRIVATE LIMITED",
"SARPANCH DEVELOPERS INDIA PRIVATE LIMITED",
"SARPET PACKAGING",
"SARR LOGISTIC PRIVATE LIMITED",
"SARR REALTORS PRIVATE LIMITED",
"SARRA FAB INTERNATIONAL PRIVATE LIMITED",
"SARRA MOTORS PRIVATE LIMITED",
"SARRAF HOTELS PRIVATE LIMITED",
"SARRALLE EQUIPMENT INDIA PRIVATE LIMITED",
"SARRVAD SOLUTIONS PRIVATE LIMITED",
"SARRWA BANK",
"SARS NUTRITION INDIA PRIVATE LIMITED",
"SARSAN SECURITIES P LIMITED",
"SARSWATI CONTAINERS PRIVATE LIMITED",
"SARSWATI EDUCATION SOCIETY",
"SARSWATI MADHYAMIC VIDYA MANDIR BINAKI",
"SARTAJ HOTELS APARTMENTS AND VILAS PRIVATE LIMITED",
"SARTECH DISPLAY INDIA PRIVATE LIMITED",
"SARTH MARKETING",
"SARTH STAMPINGS PRIVATE LIMITED",
"SARTH SYSTEMS",
"SARTH WEALTH PRIVATE LIMITED",
"SARTHA ADVISORS PRIVATE LIMITED",
"SARTHAK ADVERTISING PRIVATE LIMITED",
"SARTHAK COLLECTION",
"SARTHAK COMMOTRADE PRIVATE LIMITED",
"SARTHAK COMPONENTS PRIVATE LIMITED",
"SARTHAK CONTRACTS PRIVATE LIMITED",
"SARTHAK DATA SOLUTIONS PRIVATE LIMITED",
"SARTHAK DEVELOPERS",
"SARTHAK DISPLAYS PRIVATE LIMITED",
"SARTHAK EDUCATIONAL TRUST",
"SARTHAK ELECTROMECH PRIVATE LIMITED",
"SARTHAK ENERGY PRIVATE LIMITED",
"SARTHAK ENGINEERING PRIVATE LIMITED",
"SARTHAK ENTERPRISE",
"SARTHAK GLOBAL LIMITED",
"SARTHAK HOSPITALS PRIVATE LIMITED",
"SARTHAK INDUSTRIES LIMITED",
"SARTHAK INFOTECH SOLUTIONS PRIVATE LIMITED",
"SARTHAK INFRAVENTURES PRIVATE LIMITED",
"SARTHAK ISPAT PRIVATE LIMITED",
"SARTHAK METALS MARKETING PRIVATE LIMITED",
"SARTHAK MUSIC PRIVATE LIMITED",
"SARTHAK PACKAGING PRIVATE LIMITED",
"SARTHAK PET INDUSTRIES (INDIA) PRIVATE LIMITED",
"SARTHAK PRECISION PRIVATE LIMITED",
"SARTHAK PVC WORLD PRIVATE LIMITED",
"SARTHAK REAL BUILT PRIVATE LIMITED",
"SARTHAK WEALTH MANAGEMENT OPC PRIVATE LIMITED",
"SARTHAM MARKETING PRIVATE LIMITED",
"SARTHAV INFRASTRUCTURE PVT.LTD",
"SARTHI ADVISORS PRIVATE LIMITED",
"SARTHI BUILDER AND DEVELOPERS PRIVATE LIMITED",
"SARTHI CAPITAL ADVISORS PRIVATE LIMITED",
"SARTHI CHEM - TECH PRIVATE LIMITED",
"SARTHI CHEM PRIVATE LIMITED",
"SARTHI CONSTRUCTION PRIVATE LIMITED",
"SARTHI DIGITAL SOFTWARE SOLUTIONS PRIVATE LIMITED",
"SARTHI INDIA NIRMAN LIMITED",
"SARTHI INFRAHOMES PRIVATE LIMITED",
"SARTHI MOTORS",
"SARTHI PROCESSORS PRIVATE LIMITED",
"SARTHIK BUILDCON PRIVATE LIMITED",
"SARTIME HOROLOGICAL PRIVATE LIMITED",
"SARTO ELECTRO EQUIPMENTS PRIVATE LIMITED",
"SARTORIUS INDIA PRIVATE LIMITED",
"SARTORIUS STEDIM INDIA PRIVATE LIMITED",
"SARU AIKOH CHEMICALS LIMITED",
"SARU AIKOH CHEMICALS PRIVATE LIMITED",
"SARU CONCAST ALLOYS PRIVATE LIMITED",
"SARU COPPER ALLOY SEMIS PRIVATE LIMITED",
"SARU ENTERPRISES PRIVATE LTD",
"SARU INFRA & JEWEL PRIVATE LIMITED",
"SARU INTERNATIONAL PRIVATE LIMITED",
"SARU MATRIC HIGHER SECONDARY SCHOOL",
"SARU SILVER ALLOYS PRIVATE LIMITED",
"SARU SMELTING PRIVATE LIMITED",
"SARU SYNDICATE PRIVATE LIMITED",
"SARUNA MEDICARE PRIVATE LIMITED",
"SARUNDA LAMPS PRIVATE LIMITED",
"SARUP INDUSTRIES LIMITED",
"SARUS GLOBAL SOLUTIONS PRIVATE LIMITED",
"SARUS INFRASTRUCTURES PRIVATE LIMITED",
"SARV BIO PHARMACEUTICAL RESEARCH PRIVATE LIMITED",
"SARV BIOLABS PRIVATE LIMITED",
"SARV HEALTHCARE PRIVATE LIMITED",
"SARV HR SOLUTIONS PRIVATE LIMITED",
"SARV INFRAHEIGHTS PRIVATE LIMITED",
"SARV PROJECTS PRIVATE LIMITED",
"SARV SIDDHI MINERALS PRIVATE LIMITED",
"SARV STEELS PRIVATE LIMITED",
"SARV WEBS PRIVATE LIMITED",
"SARV WIRES AND CABLES PRIVATE LIMITED",
"SARVA COMMERCIAL PRIVATE LIMITED",
"SARVA FOAM INDUSTRIES PRIVATE LIMITED",
"SARVA FOOD CHAIN PRIVATE LIMITED",
"SARVA HARYANA GRAMIN BANK",
"SARVA JANA SEVA KOSH LIMITED",
"SARVA MANGALAM GAJANAN STEEL PRIVATE LIMITED",
"SARVA MANGALAM IMPEX PRIVATE LIMITED",
"SARVA PHARMACEUTICALS PRIVATE LIMITED",
"SARVA PRIYA EXPORTS PRIVATE LIMITED",
"SARVA SATHVA COIR TECH PRIVATE LIMITED",
"SARVA SEVA DAIRY FEDERATION LIMITED",
"SARVA SEVA SAMITY SANSTHA",
"SARVA SHIKSHA ABHIYAN",
"SARVA SIKSHYA ABHIYAN",
"SARVAA FASHION OVERSEAS PRIVATE LIMITED",
"SARVABHISHTA E-WASTE MANAGEMENT PRIVATE LIMITED",
"SARVADEVA TRADING PRIVATE LIMITED",
"SARVADI INFRASTRUCTURE PRIVATE LIMITED",
"SARVADNYA ELECTROTECH PRIVATE LIMITED",
"SARVADNYA SHREE INFRA PRIVATE LIMITED",
"SARVADNYA UDYOG PRIVATE LIMITED",
"SARVAGNA SKIN CLINIC",
"SARVAGRAM FINCARE PRIVATE LIMITED",
"SARVAGRAM SOLUTIONS PRIVATE LIMITED",
"SARVAGUNAUSHDHI PRIVATE LIMITED",
"SARVAGYA COMMERCE INDIA PVT LTD",
"SARVAGYA INFRASTRUCTURE PRIVATE LIMITED",
"SARVAGYA TOOL TECHNOLOGIES PRIVATE LIMITED",
"SARVAGYA VEHICLES PRIVATE LIMITED",
"SARVAHA SYSTEMS PRIVATE LIMITED",
"SARVAHITHA EDUCATIONAL SOCIETY",
"SARVAJANIK COLLEGE OF ENGINEERING & TECHNOLOGY",
"SARVAJANIK MADHYAMIK SHALA",
"SARVAJANIK VIDYALAYA ASODA TAL DIST JALGAON",
"SARVAJANIN H S VALIKA VIDYALAYA TINSUKIA",
"SARVALAKSHMI FOUNDRIES PRIVATE LIMITED",
"SARVAM INFRASTRUCTURE PRIVATE LIMITED",
"SARVAM LOGISTICS INDIA PRIVATE LIMITED",
"SARVAM SAFETY EQUIPMENT P LIMITED",
"SARVAMANGAL INFRASTRUCTURE PRIVATE LIMITED",
"SARVAMANGALA ENGINEERS PRIVATE LIMITED",
"SARVAMANGLA GASES AND CONSTRU. PVT.LTD.",
"SARVAMANGLA INFRABUILD PRIVATE LIMITED",
"SARVANG INFOTECH INDIA LIMITED",
"SARVANI INDUSTRIES PRIVATE LIMITED",
"SARVANI READYMIX CONCRETE INDUSTRY",
"SARVANI TRADELINK PRIVATE LIMITED",
"SARVANKASH VIDYA MANDIR",
"SARVAP SOLUTIONS PRIVATE LIMITED",
"SARVAPRIYA CASTINGS PRIVATE LIMITED",
"SARVAPRIYA LEASING PRIVATE LIMITED",
"SARVAR HOTELS AND INFRA PRIVATE LIMITED",
"SARVARA BUILDERS PRIVATE LIMITED",
"SARVARA TECHNOLOGIES PRIVATE LIMITED",
"SARVARAYA TEXTILES LTD",
"SARVASHIV EXIM LLP",
"SARVASHIV MINES AND MINERALS PRIVATE LIMITED",
"SARVASHIVA RICE MILL PRIVATE LIMITED",
"SARVASIDDHI AGROTECH PRIVATE LIMITED",
"SARVASIDHI DEALER PRIVATE LIMITED",
"SARVASV MACHINERY AND EQUIPMENTS PRIVATE LIMITED",
"SARVASWAM WELLNESS SERVICES PRIVATE LIMITED",
"SARVASYA MERCHANDISERS PRIVATE LIMITED",
"SARVASYA PRIVATE LIMITED",
"SARVATMA IMPEX PRIVATE LIMITED",
"SARVATMAN ROAD EQUIPMENTS PRIVATE LIMITED",
"SARVATRA INTEGRATED MANAGEMENT SERVICE PRIVATE LIMITED",
"SARVATRA TECHNOLOGIES PRIVATE LIMITED",
"SARVAVA AGRITEK PRIVATE LIMITED",
"SARVAYUG FARMING PRIVATE LIMITED",
"SARVDRISHTI EYE HOSPITAL PRIVATE LIMITED",
"SARVEISHVAR COMMODITIES PRIVATE LIMITED",
"SARVEJANA HEALTHCARE PRIVATE LIMITED",
"SARVESH ANALYTICS PRIVATE LIMITED",
"SARVESH BLISS HEALTHCARE PRIVATE LIMITED",
"SARVESH BUILDERS INDIA PRIVATE LIMITED",
"SARVESH CARS AND MOTORS PRIVATE LIMITED",
"SARVESH ELECTRICAL INDIA PRIVATE LIMITED",
"SARVESH EXPORTS PRIVATE LIMITED",
"SARVESH HOUSING PROJECTS PVT LTD",
"SARVESH INGENIEUR PRIVATE LIMITED",
"SARVESH MULTI PLAST INDIA PRIVATE LIMITED",
"SARVESH POLYCHEM PRIVATE LIMITED",
"SARVESH REFRACTORIES LIMITED.",
"SARVESH SALT AND CHEMICALS PRIVATE LIMITED",
"SARVESH SECURITY SERVICES PRIVATE LIMITED",
"SARVESH TRUCKS AND MOTORS PRIVATE LIMITED",
"SARVESHVAR COMMODITIES INDIA PRIVATE LIMITED",
"SARVESHWAR COMMODITIES INDIA PRIVATE. LIMITED.",
"SARVESHWAR CONSTRUCTIONS PRIVATE LIMITED",
"SARVESHWAR ENTERPRISES PVT.LTD.",
"SARVESHWAR FOODS LIMITED",
"SARVESHWAR GRANITES PRIVATE LIMITED",
"SARVESHWAR LOGISTICS SERVICES PRIVATE LIMITED",
"SARVESHWAR METALS PRIVATE LIMITED",
"SARVESHWAR OVERSEAS LIMITED",
"SARVESHWAR SPUNTEX PRIVATE LIMITED",
"SARVESHWARI BUILDCON PRIVATE LIMITED",
"SARVESHWARI EXPORTS PRIVATE LIMITED",
"SARVESHWARI GASES PRIVATE LTD",
"SARVESHWARI ICE & COLD STORAGE PVT. LTD.",
"SARVESWARA MILLS INDIA PRIVATE LIMITED",
"SARVHIT BUILDWELL PRIVATE LIMITED",
"SARVHIT SCANS PRIVATE LIMITED",
"SARVHIT TRUST",
"SARVI AUTOMOBILE PRIVATE LIMITED",
"SARVIJAY LOGISTICS PRIVATE LIMITED",
"SARVIKA TECHNOLOGIES PRIVATE LIMITED",
"SARVIN TYRES PRIVATE LIMITED",
"SARVJAN INDIA FINTECH PRIVATE LIMITED",
"SARVJANIK HIGH SCHOOL",
"SARVMANGAL VIDYALAYA",
"SARVO TECHNOLOGIES LIMITED",
"SARVODAY AQUACULTURE PRIVATE LIMITED",
"SARVODAY BUILDING MATERIALS PRIVATE LIMITED",
"SARVODAY HIGH SCHOOL",
"SARVODAY INTER COLLEGE PILKHUWA HAPUR",
"SARVODAY PIPES PRIVATE LIMITED",
"SARVODAY TEXTILE INDUSTRIES PRIVATE LIMITED",
"SARVODAY VIDYAMANDIR JINDVA",
"SARVODAY VINAY MANDIR AJARPURA",
"SARVODAYA AGROTECH INDIA LIMITED",
"SARVODAYA BAL VIDYALAYA",
"SARVODAYA COMMERCIAL CO-OP BANK LTD",
"SARVODAYA CO-OP. BANK LTD",
"SARVODAYA EDUCATIONAL NETWORK",
"SARVODAYA HIGH SCHOOL KINHI",
"SARVODAYA HOLIDAY PRIVATE LIMITED",
"SARVODAYA HOSPITAL AND RESEARCH CENTRE",
"SARVODAYA INDIA LIMITED",
"SARVODAYA IRON & STEEL CO. PRIVATE LIMITED",
"SARVODAYA MANPOWER AND SECURITAS SOLUTIONS PRIVATE LIMITED",
"SARVODAYA MARKETING PRIVATE LIMITED",
"SARVODAYA NANO FINANCE LIMITED",
"SARVODAYA POLYMERS PRIVATE LIMITED",
"SARVODAYA PUMPS PRIVATE LIMITED",
"SARVODAYA REFINERY PRIVATE LIMITED",
"SARVODAYA SAHKARI SHRAM SAMVIDA SAMITI LIMITED",
"SARVODAYA SOLVENTS PRIVATE LIMITED",
"SARVODAYA SPECIALTIES LIMITED",
"SARVODAYA STEEL ROLLING MILLS PRIVATE LIMITED",
"SARVODAYA STORES PRIVATE LIMITED",
"SARVODAYA SUITINGS PRIVATE LIMITED",
"SARVODAYA TEXCOM PRIVATE LIMITED",
"SARVODAYA VIDYA MANDIR INTER COLLEGE PINAHAT AGRA",
"SARVODHYA VIDYALAYA INA COLONY",
"SARVODYA BAL VIDYALAYA",
"SARVODYA COMPUTER & MANAGMENT INSTITUTE",
"SARVODYA GLOBAL STONEX PRIVATE LIMITED",
"SARVODYA HOSPITAL & RESEARCH CENTRE",
"SARVODYA INFRACON PRIVATE LIMITED",
"SARVODYA KANYA VIDYALAYA",
"SARVODYA VIDYALAY NILAJE SEC SCHOOL KHONI KALYAN DIST THANE",
"SARVOPARI CONSTRUCTION PRIVATE LIMITED",
"SARVOPARI INVESTMENTS PVT LTD",
"SARVOTAM ELECTRO SQUARE PRIVATE LIMITED",
"SARVOTHAM CARE LIMITED",
"SARVOTHAM REMEDIES LIMITED",
"SARVOTHAM URJA PRIVATE LIMITED",
"SARVOTTAM AGRO FOOD MILL PRIVATE LIMITED",
"SARVOTTAM ALLOYS PRIVATE LTD.",
"SARVOTTAM ALUMINATES PRIVATE LIMITED",
"SARVOTTAM APPLIANCES PRIVATE LIMITED",
"SARVOTTAM ASBESTOS CEMENT PVT LTD",
"SARVOTTAM CARRIERS PRIVATE LIMITED",
"SARVOTTAM CEMENT PRIVATE LIMITED",
"SARVOTTAM CHEMICALS PRIVATE LIMITED",
"SARVOTTAM DECOR PRIVATE LIMITED",
"SARVOTTAM FEEDS PRODUCTS PRIVATE LIMITED",
"SARVOTTAM HEALTH CARE PRIVATE LIMITED",
"SARVOTTAM INTERNATIONAL SCHOOL",
"SARVOTTAM POLYMERS PRIVATE LIMITED",
"SARVOTTAM POLYPLAST PRIVATE LIMITED",
"SARVOTTAM POULTRY FEED SUPPLY CENTRE PRIVATE LIMITED",
"SARVOTTAM RICE MILL PRIVATE LIMITED",
"SARVOTTAM ROLLING MILLS PRIVATE LIMITED",
"SARVOTTAM SAREES PVT LTD",
"SARVOTTAM SECURITIES PRIVATE LIMITED",
"SARVOTTAM TELECARE PRIVATE LIMITED",
"SARVP FINANCIAL SERVICES PRIVATE LIMITED",
"SARVPPRATHAM DEVELOPERS PRIVATE LIMITED",
"SARVPRIYA AUTOS PRIVATE LIMITED",
"SARVPRIYA EXPORTS PRIVATE. LIMITED.",
"SARVPRIYA PREFAB PRIVATE LIMITED",
"SARVRAJ BUILDTECH PRIVATE LIMITED",
"SARVSANJHI CONSTRUCTIONS PRIVATE LIMITED",
"SARVUDAY MACHINERY & TOOLS PRIVATE LIMITED",
"SARWADI FINANCE PRIVATE LIMITED",
"SARWAMANGAL KRAFT TECH PRIVATE LIMITED",
"SARWAMANGAL SCHOOL",
"SARWAMANGALA WIRE PRODUCTS PRIVATE LIMITED",
"SARWATI POLYMERS PRIVATE LIMITED",
"SARWATI SPINNERS PRIVATE LIMITED",
"SARWESH INFRASTRUCTURE PRIVATE LIMITED",
"SARWOTTAM ISPAT LIMITED.",
"SARYAM ENGINEERING PRIVATE LIMITED",
"SARYU PROPERTIES & HOTELS PRIVATE LIMITED",
"SARYU SYNTEX PRIVATE LIMITED",
"SARYUG GAUTAM CONSTRUCTION PRIVATE LIMITED",
"SAS AUTOMATION PRIVATE LIMITED",
"SAS AUTOMOTIVES PRIVATE LIMITED",
"SAS AVIATION PRIVATE LIMITED",
"SAS CARD BOARD PRIVATE LIMITED",
"SAS CASHMERE PRIVATE LIMITED",
"SAS ENGINEERING LIMITED",
"SAS EPC SOLUTION PRIVATE LIMITED",
"SAS EXPORTS PRIVATE LIMITED",
"SAS FASHIONS PRIVATE LIMITED",
"SAS FREIGHT FORWARDERS PRIVATE LIMITED",
"SAS GAS EQUIPMENTS PRIVATE LIMITED",
"SAS GLOBAL PRIVATE LIMITED",
"SAS HEALTH CARE PRIVATE LIMITED",
"SAS HOLDING PRIVATE LIMITED",
"SAS HOTELS & ENTERPRISES LIMITED",
"SAS HOUSING AND INFRASTRUCTURE LIMITED",
"SAS HYDEL PROJECTS PRIVATE LIMITED",
"SAS INFOSOFT PRIVATE LIMITED",
"SAS INFRA PROJECTS (INDIA) PRIVATE LIMITED",
"SAS INSTITUTE INDIA PRIVATE LIMITED",
"SAS INTERNATIONAL",
"SAS MEDIA PRIVATE LIMITED",
"SAS PARTNERS CORPORATE ADVISORS PRIVATE LIMITED",
"SAS POLYMERS PRIVATE LIMITED",
"SAS POWERTECH PRIVATE LIMITED",
"SAS PRECISION ENGINEERING PRIVATE LIMITED",
"SAS REALTORS PRIVATE LIMITED",
"SAS RESEARCH AND DEVELOPMENT (INDIA) PRIVATE LIMITED",
"SAS TECHNOLOGIES",
"SAS WEALTH MANAGEMENT PRIVATE LIMITED",
"SASA SEVEN SEAS PRIVATE LIMITED",
"SASA STONE PRIVATE LIMITED",
"SASAA VENTURE PRIVATE LIMITED",
"SASAN POWER LIMITED",
"SASCMA ENGLISH MEDIUM COMMERCE COLLEGE",
"SASCO ENGINEERING (INDIA) PRIVATE LIMITED",
"SASCO GLOBAL SHIPPING INDIA PRIVATE LIMITED",
"SASCO MARKETING PRIVATE LIMITED",
"SASCO STEEL PRIVATE LIMITED",
"SASCON INFRASTRUCTURE INDIA PRIVATE LIMITED",
"SASCOR INDIA INVESTMENTS PRIVATE LIMITED",
"SASDAL ENTERPRISES PRIVATE LIMITED",
"SASEVEN RETAIL AND HOSPITALITY PRIVATE LIMITED",
"SASG UV SOLUTIONS PRIVATE LIMITED",
"SASH AUTOTECH PRIVATE LIMITED",
"SASH GLOBAL LOGISTICS PRIVATE LIMITED",
"SASH LOGISTICS AND TRAVELS PRIVATE LIMITED",
"SASH REFKART SOLUTIONS PRIVATE LIMITED",
"SASHA IMPEX PRIVATE LIMITED",
"SASHA INTEGRATED SERVICES PRIVATE LIMITED",
"SASHA TRAVELS ONLINE LLP",
"SASHAA AUTOMOTIVE PRIVATE LIMITED",
"SASHAKTA TECHNOLOGIES PRIVATE LIMITED",
"SASHANKA AGRO TECH PRIVATE LIMITED",
"SASHASTRA SEEMA BAL",
"SASHI BHUSAN MEMORIAL HOSPITAL PRIVATE LIMITED",
"SASHI KUMAR TEA COMPANY PRIVATE LIMITED",
"SASHIMI FOODS PRIVATE LIMITED",
"SASHIS INVESTMENTS AND CONSULTING LIMITED",
"SASHME DIAMONDS PRIVATE LIMITED",
"SASHWAT CONSTRUWELL PRIVATE LIMITED",
"SASI ANAND BREEDING FARMS PRIVATE LIMITED",
"SASI EARTH MOVING EQUIPMENT PRIVATE LIMITED",
"SASI EDUCATIONAL INSTITUTES",
"SASI EM HIGH SCHOOL",
"SASI FOUNDATION",
"SASI INSTITUTE OF TECHNOLOGY AND ENGINEERING",
"SASI RETREADING ENTERPRISES PRIVATE LIMITED",
"SASIDHAR POULTRIES PRIVATE LIMITED",
"SASIL TECHNOLOGIES PRIVATE LIMITED",
"SASISRI EXTRACTIONS LIMITED",
"SASKEN TECHNOLOGIES LIMITED",
"SASMA ETHANOL INDIA PRIVATE LIMITED",
"SASMIRA S INSTITUTE OF MAN-MADE TEXTILES",
"SASMITA RICEMILLS PRIVATE LIMITED",
"SASMOS HET TECHNOLOGIES LIMITED",
"SASNEE TECHNOLOGIES PRIVATE LIMITED",
"SASOL INDIA PRIVATE LIMITED",
"SASOON GENERAL HOSPITAL",
"SASOON GENERAL HOSPITAL PUNE",
"SASPACK VENTURES PRIVATE LIMITED",
"SASR INFRASTRUCTURE PRIVATE LIMITED",
"SASS ONLINE COMMODITIES PRIVATE LIMITED",
"SASSIST IO INDIA PRIVATE LIMITED",
"SASSON HOSPITAL",
"SASSOON FAB INTERNATIONAL PRIVATE LIMITED",
"SASSY INFOTECH PRIVATE LIMITED",
"SASTASUNDAR HEALTHBUDDY LIMITED",
"SASTASUNDAR VENTURES LIMITED",
"SASTEC ELITE VENTURES LLP",
"SASTHA CONTAINERS & PACKAGING PRIVATE LIMITED",
"SASTHA ELECTRICAL TECH PRIVATE LIMITED",
"SASTHA NATHAN CARGO PRIVATE LIMITED",
"SASTHA PACKAGINGS PRIVATE LIMITED",
"SASTHA PAPER MILLS PRIVATE LIMITED",
"SASTHA SILVER MALIGAI PRIVATE LIMITED",
"SASTHA SPICES AND OLEORESIN PRIVATE LIMITED",
"SASTHI ENTERPRISES PRIVATE LIMITED",
"SASTRA DEEMED UNIVERSITY",
"SASUMOROV ENTERPRISES PRIVATE LIMITED",
"SASURAL TEX PRIVATE LIMITED",
"SASVAT OMNICARE PRIVATE LIMITED",
"SASVITHA HOME FINANCE LIMITED",
"SASWAD FINANCE PRIVATE LIMITED",
"SASWAD TOURS AND TRAVELS PRIVATE LIMITED",
"SASWAT INFRASTRUCTURE PRIVATE LIMITED",
"SASYA MOTORS PRIVATE LIMITED",
"SASYAKRANTHI AGRO AND FOOD PRODUCTS PRIVATE LIMITED",
"SAT ACCSOFT PRIVATE LIMITED",
"SAT AGROTECH OVERSEAS PRIVATE LIMITED",
"SAT HOSPITAL",
"SAT INDER CONSTRUCTIONS PRIVATE LIMITED",
"SAT INDUSTRIES LIMITED",
"SAT INFOTECH PRIVATE LIMITED",
"SAT INVEST PRIVATE LIMITED",
"SAT KABIR LOGISTICS PRIVATE LIMITED",
"SAT KAIVAL HOSPITAL PRIVATE LIMITED",
"SAT KARTAR MINING & ALLIED SERVICES PRIVATE LIMITED",
"SAT KARTAR SHOPPING LIMITED",
"SAT KARTAR TOUR N TARVELS",
"SAT LIFESCIENCES PRIVATE LIMITED",
"SAT SAHEB INDUSTRIAL SERVICES",
"SAT SAHIB STEELS",
"SAT SRI SAI CROP PROTECTION SCIENCE PRIVATE LIMITED",
"SAT TEX AGENCIES PRIVATE LIMITED",
"SAT3TEL INFRASTRUCTURES PRIVATE LIMITED",
"SATA VIKAS INDIA PRIVATE LIMITED",
"SATABDI MONOLITHICS INDUSTRIES PRIVATE LIMITED",
"SATABDI TEA PROCESSING PRIVATE LIMITED",
"SATACHI GLOBAL PRIVATE LIMITED",
"SATAKARNI ESTATES PRIVATE LIMITED",
"SATAKE INDIA ENGINEERING PRIVATE LIMITED.",
"SATAKSHI CONTRACTORS PRIVATE LIMITED",
"SATAKSHI SALES AND MARKETING PRIVATE LIMITED",
"SATANAN AGRO PROCESSING PRIVATE LIMITED",
"SATARA CATTLE FEED INDUSTRIES PVT LTD",
"SATARA HOSPITAL AND RESEARCH CENTER PRIVATE LIMITED",
"SATARA NAGARPARISHAD",
"SATARA POLYMERS PVT LTD",
"SATARA ROLLER FLOUR MILLS PRIVATE LIMITED",
"SATARUPA JEWELLERS PRIVATE LIMITED",
"SATAT SAMPADA PRIVATE LIMITED",
"SATATAGA PRIVATE LIMITED",
"SATAV PATIL FOODS AND BEVERAGES PRIVATE LIMITED",
"SATAV STONE COMPANY PRIVATE LIMITED",
"SATAVAHANA HEALTH CARE PRIVATE LIMITED",
"SATAYTEJ COMMERCIAL CO PRIVATE LIMITED",
"SATAYU HOSPITAL",
"SATBIK POULTRY PRIVATE LIMITED",
"SATBIONS FOOD AND ADDITIVES PRIVATE LIMITED",
"SATC MARKETING INDIA PRIVATE LIMITED",
"SATCAP INDIA PRIVATE LIMITED",
"SATCHA TEXTILE PRIVATE LIMITED",
"SATCHIDANANDA AGROTECH PRIVATE LIMITED",
"SATCHITANAND STENCILS PRIVATE LIMITED",
"SATCO CAPITAL MARKETS LIMITED",
"SATCO LIGHTING PRIVATE LIMITED",
"SATCO TRADERS (INDIA) PRIVATE LIMITED",
"SATCO WEALTH PRIVATE LIMITED",
"SATCOM & DIGITAL SOLUTIONS PRIVATE LIMITED",
"SATCOM GROUND SYSTEMS PRIVATE LIMITED",
"SATCOM INFOTECH PRIVATE LIMITED",
"SATDEEP ENGINEERING PRIVATE LIMITED",
"SATE LITE TECHNOLOGIES PRIVATE LIMITED",
"SATEJ DEVLOPERS PRIVATE LIMITED",
"SATELITE ENTERPRISES PRIVATE LIMITED",
"SATELITE TRADE IMPEX PRIVATE LIMITED",
"SATELLITE AEDIFEX PRIVATE LIMITED",
"SATELLITE CARGO CONNEXION PRIVATE LIMITED",
"SATELLITE CHANNELS PRIVATE LIMITED",
"SATELLITE CITY HOMES PRIVATE LIMITED",
"SATELLITE CNG SERVICES PRIVATE LIMITED",
"SATELLITE CONVEYORS PRIVATE LIMITED",
"SATELLITE CORPORATE SERVICES P LTD",
"SATELLITE DEVELOPERS PRIVATE LIMITED",
"SATELLITE EXIM PVT LTD",
"SATELLITE INDUSTRIES PRIVATE LIMITED",
"SATELLITE INFRA-CONSULTANTS PRIVATE LIMITED",
"SATELLITE INFRASERVICES PRIVATE LIMITED",
"SATELLITE METALS AND TUBES LIMITED",
"SATELLITE PHARMACEUTICALS PRIVATE LIMITED",
"SATELLITE PRECISION BALLS PRIVATE LIMITED",
"SATERN GRIHA NIRMAN PRIVATE LIMITED",
"SATEZ AGRO PRODUCTS PRIVATE LIMITED",
"SATGURU AGRO INDUSTRIES LIMITED",
"SATGURU AGRO RESOURCES PRIVATE LIMITED",
"SATGURU ALUMINIUM PRODUCTS PRIVATE LIMITED",
"SATGURU APOLLO HOSPITAL",
"SATGURU ARCADE PRIVATE LIMITED",
"SATGURU AUTOMOBILES PRIVATE LIMITED",
"SATGURU BIOFUEL LIMITED",
"SATGURU CLEARING AND FORWARDING SERVICES PRIVATE LIMITED",
"SATGURU DISTRIBUTORS PRIVATE LIMITED",
"SATGURU ENGITECH PRIVATE LIMITED",
"SATGURU ENTERPRISES PRIVATE LIMITED",
"SATGURU FLEETS PRIVATE LIMITED",
"SATGURU HOLIDAYS (INDIA) PRIVATE LIMITED",
"SATGURU INFRAPROJECTS PRIVATE LIMITED",
"SATGURU KITCHENS AND SERVICES PRIVATE LIMITED",
"SATGURU LOGITECH INDIA PRIVATE LIMITED",
"SATGURU METALS & POWER PRIVATE LIMITED",
"SATGURU NAMKEEN INDUSTRIES PRIVATE LIMITED",
"SATGURU OILS PVT LTD",
"SATGURU ORGANICS PRIVATE LIMITED",
"SATGURU OVERSEAS",
"SATGURU PAINTS AND CHEMICALS PRIVATE LIMITED",
"SATGURU PARTP SINGH HOSPITALS",
"SATGURU POLYFAB PRIVATE LIMITED",
"SATGURU SAI MINES PRIVATE LIMITED",
"SATGURU SEEDS PRIVATE LIMITED",
"SATGURU TRADELINKS",
"SATGURU`S ARTS AND CRAFTS PVT LTD",
"SATH SATH TELECOM PRIVATE LIMITED",
"SATHAAR ENGINEERING AND SOURCING SERVICES PRIVATE LIMITED",
"SATHABISHAA ENGINEERING INDUSTRIES PRIVATE LIMITED",
"SATHAVAHANA BREEDING & HATCHERIES PRIVATE. LIMITED.",
"SATHAVAHANA INSTITUTE OF ONCOLOGY PRIVATE LIMITED",
"SATHAVAHANA PACKAGING PVT LTD,",
"SATHAYE COLLEGE",
"SATHAYE JR COLLEGE",
"SATHE AND COMPANY PRIVATE LIMITED",
"SATHE ENGINEERING COMPANY PRIVATE LIMITED",
"SATHE LIGHTING PRIVATE LIMITED",
"SATHEESH BALAJI MATRICULATION HIGHER SECONDARY SCHOOL",
"SATHGURU CATALYSER ADVISORS PRIVATE LIMITED",
"SATHGURU MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"SATHI BUILDERS PRIVATE LIMITED",
"SATHI MOTORS ELECTRIC VEHICLE PRIVATE LIMITED",
"SATHIYAM MEDIA VISION PRIVATE LIMITED",
"SATHLOKHAR SYNERGYS E&C GLOBAL LIMITED",
"SATHLOKHAR SYNERGYS PRIVATE LIMITED",
"SATHURAGIRI SOFTEX INDIA PRIVATE LIMITED",
"SATHVARO COATINGS PRIVATE LIMITED",
"SATHVIK AGRO-FOOD INDUSTRIES PRIVATE LIMITED",
"SATHVIK EDUCATIONAL SOCIETY",
"SATHY SILKS PRIVATE LIMITED",
"SATHY SUPERMARKET PRIVATE LIMITED",
"SATHYA AGENCIES PRIVATE LIMITED",
"SATHYA AUTO PRIVATE LIMITED",
"SATHYA LIFESTYLES PRIVATE LIMITED",
"SATHYA MOBILES INDIA PRIVATE LIMITED",
"SATHYA SAI ORTHOPAEDIC & MULTISPECIALITY HOSPITAL",
"SATHYA SHANMUKHA TRADERS",
"SATHYA SHYAM SPINNERS PRIVATE LIMITED",
"SATHYA SUPERSPECIALITY HEALTH VILLAGE PRIVATE LIMITED",
"SATHYA TECHNOSOFT INDIA PRIVATE LIMITED",
"SATHYABAMA ENGINEERING COLLEGE",
"SATHYABAMA INSTITUTE OF SCIENCE AND TECHNOLOGY",
"SATHYABAMA UNIVERSITY",
"SATHYADEEP ENGINEERING COMPANY LIMITED",
"SATHYADEEP RIGHT FIX ENGINEERING PRIVATE LIMITED",
"SATHYAJEET CONSTRUCTIONS PRIVATE LIMITED",
"SATHYAM AUTO ENGINEERING PRIVATE LIMITED",
"SATHYAM FASTENERS PRIVATE LIMITED",
"SATHYAM GREEN POWER PRIVATE LIMITED",
"SATHYAM HOMES PRIVATE LIMITED",
"SATHYAM INTERNATIONAL SCHOOL",
"SATHYAM MATRICULATION HIGHER SECONDARY SCHOOL",
"SATHYAM PROCON PRIVATE LIMITED",
"SATHYAM ROAD CONSRUTIONS P LIMITED",
"SATHYAM ROLLER FLOUR MILLS PRIVATE. LIMITED.",
"SATHYAM STEEL ROOF STRUCTURES LIMITED",
"SATHYANARAYANA JEWELLERS PRIVATE LIMITED",
"SATHYASAI WOMENS COLLEGE",
"SATHYASRI PRINTERS PRIVATE LIMITED",
"SATI AUTO COMPONENTS PRIVATE LIMITED",
"SATI EXPORTS INDIA PRIVATE LIMITED",
"SATI FERRO TECH PRIVATE LIMITED",
"SATI GRANITES INDIA PRIVATE LIMITED",
"SATI OVERSEAS PRIVATE LIMITED",
"SATI POLY PLAST LIMITED",
"SATI POLYPLAST PRIVATE LIMITED",
"SATI ROCKS STONES PRIVATE LIMITED",
"SATI STONES STUDIO PRIVATE LIMITED",
"SATIA INDUSTRIES LIMITED",
"SATIA SYNTHETICS LIMITED",
"SATIATE AGRI LIMITED",
"SATIATE RESEARCH AND ANATECH PRIVATE LIMITED",
"SATIDADI AGRO MANUFACTURERS PRIVATE LIMITED",
"SATIJA MOTORS PVT LTD",
"SATIJA PROMOTERS AND DEVELOPERS PRIVATE LIMITED",
"SATIMATA TIN CONTAINERS PRIVATE LIMITED",
"SATIMATA TRADING INDIA PRIVATE LIMITED",
"SATIN CREDITCARE NETWORK LIMITED",
"SATIN FINSERV LIMITED",
"SATIN HOUSING FINANCE LIMITED",
"SATIN INDIA LIMITED",
"SATIN MEDIA SOLUTIONS LIMITED",
"SATIN NEO DIMENSIONS PRIVATE LIMITED",
"SATIN TOUCH COMFORTS PRIVATE LIMITED",
"SATIN WEAVES PVT LTD",
"SATINDAR PAL RUBBER PRODUCTS PRIVATE LIMITED",
"SATINOOD PRIVATE LIMITED",
"SATISABITRI MATA AGRO PRODUCTS PRIVATE LIMITED",
"SATISFACTION ELECTRONICS PVT LTD",
"SATISFACTION PRODUCTS PRIVATE LIMITED",
"SATISH AGROVET PRIVATE LIMITED",
"SATISH BUILDERS",
"SATISH CHAND RAJESH KUMAR PRIVATE LIMITED",
"SATISH CHANDRA MEMORIAL SCHOOL",
"SATISH CHANDRA PANDEY MEMORIAL HOSPITAL PRIVATE LIMITED",
"SATISH CHEMICAL INDIA PRIVATE LIMITED",
"SATISH ENGINEERING COMPANY PRIVATE LIMITED",
"SATISH ENTERPRISE PRIVATE LIMITED",
"SATISH HYDRAULIC COMPANY PRIVATE LIMITED",
"SATISH ICE AND COLD STORAGE PRIVATE LIMITED",
"SATISH INJECTO-PLAST PRIVATE LIMITED",
"SATISH JAIN CONSULTING ENGINEERS PRIVATE LIMITED",
"SATISH MARINE EXIM PRIVATE LIMITED",
"SATISH MOTORS PRIVATE LIMITED",
"SATISH NAIKAREPATIL INFRASTRUCTURE PRIVATE LIMITED",
"SATISH OIL PRODUCTS PVT. LTD.",
"SATISH PRADHAN DNYANASADHANA COLLEGE",
"SATISH SALUJA POWER SOLUTIONS PRIVATE LIMITED",
"SATISH SUGARS LIMITED",
"SATISLOH AG",
"SATIYA NUTRACEUTICALS PRIVATE LIMITED",
"SATJOT HUMAN REPRODUCTION & RESEARCH CENTRE PRIVATE LIMITED",
"SATJUG FOODS PRIVATE LIMITED",
"SATKAAR FASHIONS PRIVATE LIMITED",
"SATKAARIKA ENTERPRISES PRIVATE LIMITED",
"SATKAR INDUSTRIES PRIVATE LIMITED",
"SATKAR MOTORS PRIVATE LIMITED",
"SATKAR ORNAMENTS PRIVATE LIMITED",
"SATKAR PAPER MILLS PRIVATE LIMITED",
"SATKAR POULTRY PRIVATE LIMITED",
"SATKAR STORES",
"SATKAR SUPERWARE PRIVATE LIMITED",
"SATKAR SYNTHETICS PRIVATE LIMITED",
"SATKAR TRAVELS PRIVATE LIMITED",
"SATKAR VIDYA MANDIR ATRAWAL",
"SATKARTAR BUILDCON PRIVATE LIMITED",
"SATKARTAR ELECTRONICS",
"SATKARTAR GLOBAL FASHIONS PRIVATE LIMITED",
"SATKIRTI CHEMICALS PRIVATE LIMITED",
"SATKRIYA HEALTHCARE INNOVATIONS PRIVATE LIMITED",
"SATKRUTI EDUCATION MANAGEMENT PRIVATE LIMITED",
"SATKUL ENTERPRISES LIMITED",
"SATLINK ADVERTISING PRIVATE LIMITED",
"SATLOG SOLUTIONS PRIVATE LIMITED",
"SATLUJ PUBLIC SCHOOL",
"SATLUJ SPINTEX LIMITED",
"SATLUZ ENGINEERING PRIVATE LIMITED",
"SATMAX SOLUTIONS PRIVATE LIMITED",
"SATMED CLAIM SERVICES PRIVATE LIMITED",
"SATMETRIX SOFTWARE AND SYSTEMS INDIA PRIVATE LIMITED",
"SATNA ABRASIVES PRIVATE LIMITED",
"SATNA MUNICIPAL CORPORATION",
"SATNA RESORT (INDIA) PRIVATE LIMITED",
"SATNA SOLVENT PRIVATE LIMITED",
"SATNAAM STONE CRUSHERS PRIVATE LIMITED",
"SATNAM ADHESIVES AND SEALANTS PRIVATE LIMITED",
"SATNAM APARTMEMNTS LIMITED",
"SATNAM FORGE PRIVATE LIMITED",
"SATNAM FREIGHT MOVERS PRIVATE LIMITED",
"SATNAM GLOBAL INFRAPROJECTS LIMITED",
"SATNAM MART PRIVATE LIMITED",
"SATNAM MOTOCORP PRIVATE LIMITED",
"SATNAM MOTORS PVT.LTD",
"SATNAM OILS PRIVATE LIMITED",
"SATNAM OVERSEAS LIMITED",
"SATNAM SAKSHI COLD STORAGE PRIVATE LIMITED",
"SATNAM SEWING MACHINES PRIVATE LIMITED",
"SATNAM TRADELINKS PRIVATE LIMITED",
"SATNAM WOOLLEN MILLS PVT LTD",
"SATNAV PRESCHOOLS PRIVATE LIMITED",
"SATO ARGOX INDIA PRIVATE LIMITED",
"SATO POOJA FASTENERS PRIVATE LIMITED",
"SATOGUNI SWADESHI UTPAAD PRIVATE LIMITED",
"SATOL CHEMICALS PRIVATE LIMITED",
"SATORI BUSINESS SERVICES PRIVATE LIMITED",
"SATO-SHOJI INDIA PRIVATE LIMITED",
"SATPAL METALS PRIVATE LIMITED",
"SATPAL STRIPS PRIVATE LIMITED",
"SATPALDA TRADING PRIVATE LIMITED",
"SATPRE CHEMICALS PRIVATE LIMITED",
"SATPUDA ENGINEERING P LTD",
"SATPUDA JAIVIK PRODUCER COMPANY LIMITED",
"SATPURA FOODS PRIVATE LIMITED",
"SATPURA INFRACON PRIVATE LIMITED",
"SATPURA MAHILA KISAN PRODUCER COMPANY LIMITED",
"SATPURA TRANSCO PRIVATE LIMITED",
"SATRA DEVELOPMENT FINANCE PRIVATE LIMITED",
"SATRA FOOD-PARKS PRIVATE LIMITED",
"SATRA SERVICES AND SOLUTIONS PRIVATE LIMITED",
"SATRAC ENGINEERING PRIVATE LIMITED",
"SATRAJ INDUSTRIES INDIA PRIVATE LIMITED",
"SATRAMDAS & CO.",
"SATRANG GRAIN FARMER PRODUCER COMPANY LIMITED",
"SATRANG STEELS AND ALLOY PRIVATE LIMITED",
"SATRANG TECHNOLOGIES PRIVATE LIMITED",
"SATRANGI TEXTILES PRIVATE LIMITED",
"SATRE INFRASTRUCTURE PRIVATE LIMITED",
"SATRE ONLINE & MARKETING PRIVATE LIMITED",
"SATS (INDIA) CO. PRIVATE LIMITED",
"SATS AUTOMATION PRIVATE LIMITED",
"SATSAI FINLEASE PRIVATE LIMITED",
"SATSAI INFRAREALTY PRIVATE LIMITED",
"SATSAI SHIPPING SERVICES PRIVATE LIMITED",
"SATSAN EMINENCE PRIVATE LIMITED",
"SATSANGAM WOODS PRIVATE LIMITED",
"SATSANGI VIDHYALAY",
"SATSPACE TEL PRIVATE LIMITED",
"SATSU SILICONES PRIVATE LIMITED",
"SATSUDHA MEDICARE PRIVATE LIMITED",
"SATSURE ANALYTICS INDIA PRIVATE LIMITED",
"SATTI BABU MOTORS PRIVATE LIMITED",
"SATTIBABU VENTURES&PROJECTS PRIVATE LIMITED",
"SATTIK EXPORTS PRIVATE LIMITED",
"SATTIK PACKAGING PRIVATE LIMITED",
"SATTOOR HOSPITALITIES PRIVATE LIMITED",
"SATTRIX INFORMATION SECURITY LIMITED",
"SATTRIX INFORMATION SECURITY PRIVATE LIMITED",
"SATTRIX SOFTWARE SOLUTIONS PRIVATE LIMITED",
"SATTS OVERSEAS LIMITED",
"SATTUR HINDU NADARS ETHEL HARVEY GIRLS SCHOOL COMMITEE",
"SATTUR SRI VENKATESHWARA DUPLEX BOARDS PRIVATE LIMITED",
"SATTUR VENKATESHWARA PAPER MILLS PRIVATE LIMITED",
"SATTVA AUTOMATION PRIVATE LIMITED",
"SATTVA BUILDCON PRIVATE LIMITED",
"SATTVA BUILDERS PRIVATE LIMITED",
"SATTVA CFS AND LOGISTICS PRIVATE LIMITED",
"SATTVA DEVELOPERS PRIVATE. LIMITED.",
"SATTVA ENGINEERING CONSTRUCTION PRIVATE LIMITED",
"SATTVA ENGITECH PRIVATE LIMITED",
"SATTVA ETECH INDIA PRIVATE LIMITED.",
"SATTVA FELIX REALCON PRIVATE LIMITED",
"SATTVA GLOBAL SERVICES PRIVATE LIMITED",
"SATTVA HI-TECH AND CONWARE PRIVATE LIMITED",
"SATTVA HOUSING PRIVATE LIMITED",
"SATTVA INFRA MANAGEMENT PRIVATE LIMITED",
"SATTVA INFRASTRUCTURE INDIA PRIVATE LIMITED",
"SATTVA INTERNATIONAL SCHOOL",
"SATTVA LOGISTICS PRIVATE LIMITED",
"SATTVA MEDIA AND CONSULTING PRIVATE LIMITED",
"SATTVA PROPERTIES MANAGEMENT PRIVATE LIMITED",
"SATTVA REAL ESTATE PRIVATE LIMITED",
"SATTVA REALTORS PRIVATE LIMITED",
"SATTVA VIKAS SCHOOL",
"SATTVATEX FASHION PRIVATE LIMITED",
"SATTVIC MEDICAL PRIVATE LIMITED",
"SATURAM TECHNOLOGIES PRIVATE LIMITED",
"SATURN ADVERTISING PRIVATE LIMITED",
"SATURN AUTO LINKS PRIVATE LIMITED",
"SATURN E-SOLUTIONS PRIVATE LIMITED",
"SATURN ESTATE MANAGEMENT PRIVATE LIMITED",
"SATURN FACILITY SERVICES PRIVATE LIMITED",
"SATURN FERRO ALLOYS PVT LTD",
"SATURN JEWELL PRIVATE LIMITED",
"SATURN LEEISURE TOURS AND TRAVELS PRIVATE LIMITED",
"SATURN PAPER PRIVATE LIMITED",
"SATURN PREFAB INDIA PRIVATE LIMITED",
"SATURN REALCON PRIVATE LIMITED",
"SATURN REFRACTORIES PRIVATE LIMITED",
"SATURN RINGS & FORGINGS PRIVATE LIMITED",
"SATURN STEELS PRIVATE LIMITED",
"SATURN TAMPON DRUCK INDIA PRIVATE LIMITED",
"SATURO TECHNOLOGIES PRIVATE LIMITED",
"SATU'S FOOD PRODUCTS PRIVATE LIMITED",
"SATVA INFRATECH PRIVATE LIMITED",
"SATVAM MARKETING PRIVATE LIMITED",
"SATVAM NUTRIFOODS LIMITED",
"SATVAT INFOSOL PRIVATE LIMITED",
"SATVIC FOODS PRIVATE LIMITED",
"SATVIK AGROTECH PRIVATE LIMITED",
"SATVIK ENTERPRISES LIMITED",
"SATVIK HOMES PRIVATE LIMITED",
"SATVIK KITCHEN ART PRIVATE LIMITED",
"SATVIK MOULDS AND ENGINEERING PRIVATE LIMITED",
"SATVIK POLYCHEM PRIVATE LIMITED",
"SATVIK SALON AND SPA PRIVATE LIMITED",
"SATVIK SECURITIES PRIVATE LIMITED",
"SATVIK TECHZONE PRIVATE LIMITED",
"SATVIKA BIO-FOODS INDIA PRIVATE LIMITED",
"SATVIKK SPECIALITY FOODS PRIVATE LIMITED",
"SATVIX INFORMATICS PRIVATE LIMITED",
"SATWIC SOFTWARE SOLUTIONS PRIVATE LIMITED",
"SATWIK CEMCAST PRIVATE LIMITED",
"SATWIK MEDIEQUIP GLOBAL PRIVATE LIMITED",
"SATWIK MINI INDIA EDUCATION SOCIETY",
"SATWIK PROJECTS PRIVATE LIMITED",
"SATWIK STEEL PRIVATE LIMITED",
"SATYA AIRCON & ENG. SERVICES PRIVATE LIMITED",
"SATYA APPLIANCES PRIVATE LIMITED",
"SATYA ASHOKA REAL ESTATE PRIVATE LIMITED",
"SATYA AUTO PRIVATE LIMITED",
"SATYA BHAMA SEA FOODS PRIVATE LIMITED",
"SATYA BIZCON INDIA PRIVATE LIMITED",
"SATYA CABS PRIVATE LIMITED",
"SATYA CASHEW CHEMICALS PRIVATE LIMITED",
"SATYA CHANDRA FLOUR MILLS PRIVATE LIMITED",
"SATYA COLLEGE OF ENGINEERING & TECHNOLOGY",
"SATYA CONCRETE PAVERS PRIVATE LIMITED",
"SATYA DEPARTMENTAL STORES PRIVATE LIMITED",
"SATYA DEPOSITS AND ADVANCES PRIVATE LIMITED",
"SATYA DESIGNS PRIVATE LIMITED",
"SATYA DEVELOPERS PRIVATE LIMITED",
"SATYA DHARAM AGROVISION PRIVATE LIMITED",
"SATYA EDUCATION STREET PRIVATE LIMITED",
"SATYA FABRICATORS PRIVATE LIMITED",
"SATYA FORKLIFT ENGINEERING & EQUIPMENTS PRIVATE LIMITED",
"SATYA FUELS PRIVATE LIMITED",
"SATYA GREEN ENERGY SOLUTIONS PRIVATE LIMITED",
"SATYA HEALTHCARE PRIVATE LIMITED",
"SATYA INFOTECH PVT LTD",
"SATYA INFRA PROMOTERS PRIVATE. LIMITED.",
"SATYA INTL PRIVATE LIMITED",
"SATYA IRON & STEELS PRIVATE LIMITED",
"SATYA KALYAN CONSTRUCTIONS PRIVATE LIMITED",
"SATYA KNITS PRIVATE LIMITED",
"SATYA KRAFT PRIVATE LIMITED",
"SATYA LAXMI MUD-CHEM PRIVATE LIMITED",
"SATYA LAXMI PRESERVERS PRIVATE LIMITED",
"SATYA MAHARSHI POWER CORPORATION LIMITED",
"SATYA MANAGEMENT SERVICES PRIVATE LIMITED",
"SATYA MEDICAL SERVICES PRIVATE LIMITED",
"SATYA METAL INDUSTRIES PRIVATE LIMITED",
"SATYA MICROCAPITAL LIMITED",
"SATYA MITRA SALES AND TRADING COMPANY LIMITED",
"SATYA MRI CENTRE",
"SATYA NARAIAN SINGH CONSTRUCTION PRIVATE LIMITED",
"SATYA NARAIN INFRATECH PRIVATE LIMITED",
"SATYA NARAIN KESHO RAM MILLERS PRIVATE LIMITED",
"SATYA OM IMPEX PRIVATE LIMITED",
"SATYA OM SECURITY SERVICES PRIVATE LIMITED",
"SATYA PACKAGING SOLUTIONS PRIVATE LIMITED",
"SATYA PAPER PRODUCTS PVT LTD",
"SATYA PARKASH AND BROS PRIVATE. LIMITED.",
"SATYA POLYALLOYS LLP",
"SATYA POWER AND ISPAT LIMITED",
"SATYA PRAKASH BUILDERS LIMITED",
"SATYA PRAKASH COLONIZERS PRIVATE LIMITED",
"SATYA PRAKASH RESORTS AND HOTELS PRIVATE LIMITED",
"SATYA PROINVEST AND TRADING PRIVATE LIMITED",
"SATYA ROSHAN MEDICARE PRIVATE LIMITED",
"SATYA SAI HIGH SCHOOL",
"SATYA SAI HOSPITALITY PRIVATE LIMITED",
"SATYA SAI MANAGEMENT SERVICES PRIVATE LI MITED",
"SATYA SAI MULTIMEDIA PRIVATE LIMITED",
"SATYA SEA FOODS PVT LTD",
"SATYA SERVICE STATION PRIVATE LIMITED",
"SATYA SHAKTI FOUNDATION",
"SATYA SHARAN INFRATECH PRIVATE LIMITED",
"SATYA SHIVA MEDICALS PRIVATE LIMITED",
"SATYA SHYAM TRADING LIMITED",
"SATYA SOLAR SYSTEMS PRIVATE LIMITED",
"SATYA SPACES PRIVATE LIMITED",
"SATYA SUBAL HIMGHAR PRIVATE LIMITED",
"SATYA SURYA ALUMINIUM INDUSTRIES LIMITED",
"SATYA SURYA TOWERS PRIVATE LIMITED",
"SATYA TOWNSHIPS PRIVATE LIMITED",
"SATYA TRUCKING PRIVATE LIMITED",
"SATYA VENTURES PRIVATE LIMITED",
"SATYA VYAPAR NIRYAT PVT LTD.",
"SATYA WEALTH AND MANAGEMENT CONSULTANCY SERVICES PRIVATE LIMITED",
"SATYA WINE TINSUKIA PRIVATE LIMITED",
"SATYAAYAN GENESIS PRIVATE LIMITED",
"SATYABADI CONSTRUCTION PRIVATE LIMITED",
"SATYABHAMA BUILDERS PRIVATE LIMITED",
"SATYABHAMA ENGLISH MEDIUM SCHOOL",
"SATYABHAMA HOSPITALS PRIVATE LIMITED",
"SATYABHAMADEVI BULCHAND MEMORIAL HOSPITAL PRIVATE LIMITED",
"SATYACARE SOLUTIONS LIMITED",
"SATYADEEP OFFSET PRINTERS PRIVATE LIMITED",
"SATYADEEPTHA PHARMACEUTICALS LIMITED",
"SATYADEV AGROTRADERS PRIVATE LIMITED",
"SATYADEV HOSPITALS PRIVATE LIMITED",
"SATYADEVA PHARMACEUTICALS PRIVATE LIMITED",
"SATYADHARMA INVESTMENTS AND TRADING COMPANY PRIVATE LIMITED",
"SATYADIVIS PHARMACEUTICALS PRIVATE LIMITED",
"SATYAIMPEX INDIA PRIVATE LIMITED",
"SATYAJAY WELLNESS PRIVATE LIMITED",
"SATYAJEET INDIA ENTERPRISES PRIVATE LIMITED",
"SATYAJEET MECHANISMS PRIVATE LIMITED",
"SATYAJEET TRADERS",
"SATYAJIT RAY FILM & TELEVISION INSTITUTE",
"SATYAKALA AGRO OIL PRODUCTS LIMITED",
"SATYAKALA RESOURCES MANAGEMENT & SERVICES PRIVATE LIMITED",
"SATYAKIRAN ENGINEERS PRIVATE LIMITED",
"SATYAKIRAN EXPORTS PRIVATE LIMITED",
"SATYAKIRAN HEALTHCARE PRIVATE LIMITED",
"SATYAKRITI SAREES PRIVATE LIMITED",
"SATYAM ACRYLIC PLASTICS PRIVATE LIMITED",
"SATYAM AGROTECH PRIVATE LIMITED",
"SATYAM APPLIANCES DISTRIBUTORS PRIVATE LIMITED",
"SATYAM AUTO COMPONENTS PRIVATE LIMITED",
"SATYAM AUTOSERVE PRIVATE LIMITED",
"SATYAM BALAJEE AUTOMOTIVES PRIVATE LIMITED",
"SATYAM BALAJEE EXIM PRIVATE LIMITED",
"SATYAM BALAJEE RICE INDUSTRIES PRIVATE LIMITED",
"SATYAM BOOKS PRIVATE LIMITED",
"SATYAM BUILDCON PRIVATE LIMITED",
"SATYAM CARDS N GIFTS PRIVATE LIMITED",
"SATYAM CASTINGS PRIVATE LIMITED",
"SATYAM CATERERS PRIVATE. LIMITED.",
"SATYAM COMPOSITES PRIVATE LIMITED",
"SATYAM CONSTRUCTION PRIVATE LIMITED",
"SATYAM CONTRACTORS PRIVATE LIMITED",
"SATYAM COOKWARES PRIVATE LIMITED",
"SATYAM COTEX PRIVATE LIMITED",
"SATYAM COTSPIN PRIVATE LIMITED",
"SATYAM COTTON PROCESSORS PRIVATE LIMITED",
"SATYAM CREATIONS PRIVATE LIMITED",
"SATYAM CREDIT PVT LTD",
"SATYAM DESIGNERS PRIVATE LIMITED",
"SATYAM DEVELOPERS LIMITED",
"SATYAM DISTILLERIES & INDUSTRIES PRIVATE LIMITED",
"SATYAM DRUGS PRIVATE LIMITED",
"SATYAM EDUCATION SOCIETY",
"SATYAM FIBRES(INDIA)PVT LTD",
"SATYAM GEMS AND JEWELLERY PRIVATE LIMITED",
"SATYAM GENERIC PHARMA PRIVATE LIMITED",
"SATYAM HOSPITAL",
"SATYAM IRON & STEEL COMPANY PRIVATE LIMITED",
"SATYAM IRRIGATIONS (INDIA) PRIVATE LIMITED",
"SATYAM ISPAT (NORTH EAST) LIMITED",
"SATYAM JEWELLERS PRIVATE LIMITED",
"SATYAM MANPOWER SERVICES PRIVATE LIMITED",
"SATYAM MEDICHEM PRIVATE LIMITED",
"SATYAM MINCHEM PRIVATE LIMITED",
"SATYAM MOTOR PRIVATE LIMITED",
"SATYAM NXTGEN INDUSTRIES PRIVATE LIMITED",
"SATYAM OPHTHALMICS PRIVATE LIMITED",
"SATYAM PACKERS & PROCESSORS PRIVATE LIMITED",
"SATYAM PHARMA-CHEM PRIVATE LIMITED",
"SATYAM PLASTFAB PRIVATE LIMITED",
"SATYAM PLASTIC GRANULES PRIVATE LIMITED",
"SATYAM POLYMATS PRIVATE LIMITED",
"SATYAM POULTRY INDIA PRIVATE LIMITED",
"SATYAM PRINTING PRESS PRIVATE LIMITED",
"SATYAM ROLLER FLOUR MILLS PRIVATE LIMITED",
"SATYAM SHAKUNTALAM ENGINEERING PRIVATE LIMITED",
"SATYAM SHIVAM BUILDVISION PRIVATE LIMITED",
"SATYAM SHIVAM HIRE PURCHASE COMPANY PRIVATE LIMITED",
"SATYAM SHIVAM PACKAGING PRIVATE LIMITED",
"SATYAM SHIVAM PAPERS PRIVATE LIMITED",
"SATYAM SHIVAM SUNDARAM INFRACITY PRIVATE LIMITED",
"SATYAM SKILL DEVELOPMENT PRIVATE LIMITED",
"SATYAM SMELTERS PRIVATE LIMITED",
"SATYAM SOFTWARE SOLUTIONS PRIVATE LIMITED",
"SATYAM SOLUTIONS LIMITED",
"SATYAM SPIRITS PRIVATE LIMITED",
"SATYAM STRIPS PRIVATE LIMITED",
"SATYAM SUITINGS PRIVATE LIMITED",
"SATYAM SYNCOTEX PRIVATE LIMITED",
"SATYAM SYNERGY INDIA PRIVATE LIMITED",
"SATYAM TRADE INDUSTRIES PRIVATE LIMITED",
"SATYAM TYRE RETREAD PVT LTD",
"SATYAM VENTURE ENGINEERING SERVICES PRIVATE LIMITED",
"SATYAM WEAVETECH PRIVATE LIMITED",
"SATYAM WOVENSACK PRIVATE LIMITED",
"SATYAMEV COT FIBERS PRIVATE LIMITED",
"SATYAMEV HOSPITAL PRIVATE LIMITED",
"SATYAMITRA INFRASTRUCTURE PRIVATE LIMITED",
"SATYAMITRA STOCK CONSULTANTS PRIVATE LIMITED",
"SATYAMS POLY TRADELINK PRIVATE LIMITED",
"SATYAN PHARMACEUTICALS PRIVATE LIMITED",
"SATYANAM INFO SOLUTIONS PRIVATE LIMITED",
"SATYANAM TRADING PVT LTD",
"SATYANAND HOSPITAL PRIVATE LIMITED",
"SATYANAND PUBLIC SCHOOL",
"SATYANAND TEX PVT LTD",
"SATYANARAYAN COLD STORAGE PRIVATE LIMITED",
"SATYANARAYAN DRESSES PRIVATE LIMITED",
"SATYANARAYAN J. JADIA & SONS JEWELLERS PRIVATE LIMITED",
"SATYANARAYAN RAJ KAMAL SYNTHETICS PVT LTD",
"SATYANARAYAN RICE MILL PRIVATE LIMITED",
"SATYANARAYAN SEKHSARIA PRIVATE LIMITED",
"SATYANARAYAN TEA CO PVT LTD",
"SATYANARAYANA STONE CRUSHERS AND CONTRACTORS PRIVATE LIMITED",
"SATYANARAYANA UNITED SOFTWARE PRIVATE LIMITED",
"SATYANI'S THE JEWELLERY STORE PRIVATE LIMITED",
"SATYAPRAKASH RECREATION PRIVATE LIMITED",
"SATYARATH REALTORS PRIVATE LIMITED",
"SATYARUP MULTI TRADE LINKS INDIA PRIVATE LIMITED",
"SATYASAI COLDCHAIN AND INFRACON PRIVATE LIMITED",
"SATYASAI INFORMATION TECHNOLOGY PRIVATE LIMITED",
"SATYASAI PRESSURE VESSELS PRIVATE LIMITED",
"SATYASHOBHA TRADING & SUPPLIES PRIVATE LIMITED",
"SATYASHREE BALAJI WIRES & CABLES PRIVATE LIMITED",
"SATYATECH MANAGEMENT PRIVATE LIMITED",
"SATYATEJ VYAPAAR PVT. LTD.",
"SATYAUSHA HOMES PRIVATE LIMITED",
"SATYAVAN SALES PROMOTION PRIVATE LIMITED",
"SATYAVANI EDUCATIONAL SOCIETY",
"SATYAVANI PROJECTS AND CONSULTANTS PRIVATE LIMITED",
"SATYAVATHI BIO-LIFE SCIENCES LIMITED",
"SATYAWADI RAJA HARISH CHANDRA HOSPITAL",
"SATYAWADI RAJA HARISHCHANDRA HOSPITAL",
"SATYAWALI GLOBAL INDIA PRIVATE LIMITED",
"SATYAWATI PACKAGING PRIVATE LIMITED",
"SATYAY TECHNOCAST PRIVATE LIMITED",
"SATYEN POLYMERS PRIVATE LIMITED",
"SATYENDRA AGRO-FOODS PRIVATE LIMITED",
"SATYENDRA COMMODITIES PRIVATE LIMITED",
"SATYENDRA FIBC PRIVATE LIMITED",
"SATYENDRA FOOD PRODUCTS PRIVATE LIMITED",
"SATYENDRA KUMAR AND CO CONSTRUCTIONS PRIVATE LIMITED",
"SATYENDRA KUMAR CONSTRUCTION PRIVATE LIMITED",
"SATYENDRA NATH BOSE NATIONAL CENTRE FOR BASIC SCIENCES",
"SATYENDRA PACKAGING LIMITED",
"SATYENDRA RUBBERS PVT. LTD.",
"SATYESH BRINECHEM PRIVATE LIMITED",
"SATYESHWAR HIMGHAR PRIVATE LIMITED",
"SATYESWARI POWER AND CONSTRUCTION PRIVATE LIMITED",
"SATYOM ENTERPRISES PRIVATE LIMITED",
"SATYSHIV SHARES & SECURITIES PRIVATE LIMITED",
"SATYUG DARSHAN SANGEET KALA KENDRA",
"SATYUG TRADE PRIVATE LIMITED",
"SATYUKT ANALYTICS PRIVATE LIMITED",
"SATZ INDIA PRIVATE LIMITED",
"SAU LAXMIBAI ENG MED SCHOOL & JUNIOR COLLEGE",
"SAU PHARMA PRIVATE LIMITED",
"SAU VASUDHATAI DESHMUKH COLLEGE OF AGRICULTURE",
"SAUBER ENVIRONMENTAL SOLUTIONS PRIVATE LIMITED",
"SAUBHAGYA ESTATES PVT LTD",
"SAUBHAGYA INN PRIVATE LIMITED",
"SAUBHAGYA-TILAK HOTELS PRIVATE LIMITED",
"SAUC MINIMAL SYSTEMS PRIVATE LIMITED",
"SAUCERY FOODS PRIVATE LIMITED",
"SAUDAGAR MAL MAMMAN LAL PRIVATE LIMITED",
"SAUDAMINI & CO. CONSTRUCTIONS PRIVATE LIMITED",
"SAUDI ARABIAN AIRLINES",
"SAUDIA",
"SAUJANNAYA MANPOWER SYSTEM PRIVATE. LIMITED",
"SAUKCON INFRA PRIVATE LIMITED",
"SAUMAN CHEMAUX PRIVATE LIMITED",
"SAUMAS MERCANTILES PVT LTD",
"SAUMIL IMPEX PRIVATE LIMITED",
"SAUMIT INTERGLOBE PRIVATE LIMITED",
"SAUMITA CONTROLS INDIA PRIVATE LIMITED",
"SAUMITRA INVESTMENTS & FINANCE PVT. LTD.",
"SAUMYA CONSTRUCTION PRIVATE LIMITED",
"SAUMYA CONSULTANTS LTD",
"SAUMYA ENERGY PRIVATE LIMITED",
"SAUMYA INDUSTRIAL SERVICES PRIVATE LIMITED",
"SAUMYA MEDICAL CARE AND MEDIA LIMITED",
"SAUMYA REAL ESTATES PRIVATE LIMITED",
"SAUMYAA PROCESSORS PRIVATE LIMITED",
"SAUNAY JEWELS PRIVATE LIMITED",
"SAUNDARYA FOODS PRIVATE LIMITED",
"SAUPIN EDUCATIONAL FOUNDATION",
"SAURABH AND SAVINAY PROPERTIES PRIVATE LIMITED",
"SAURABH AUTOSALES PRIVATE LIMITED",
"SAURABH BUILDCON PRIVATE LIMITED",
"SAURABH CLEAN TECH PRIVATE LIMITED",
"SAURABH CONSTRUCTION",
"SAURABH FINSERV PRIVATE LIMITED",
"SAURABH FLANGES PRIVATE LIMITED",
"SAURABH FLEXIPACK SYSTEMS PRIVATE LIMITED",
"SAURABH IRRIGATION PRIVATE LIMITED",
"SAURABH MASON PRIVATE LIMITED",
"SAURABH MECHATECH (INDIA) PRIVATE LIMITED",
"SAURABH METALS PRIVATE LIMITED",
"SAURABH NIDAN KENDRA PRIVATE LIMITED",
"SAURABH PLASTO PRODUCTS PRIVATE LIMITED",
"SAURABH POLYPIPES PRIVATE LIMITED",
"SAURABH POULTRY RESEARCH & BREEDING FARM PRIVATE LIMITED",
"SAURABH PRINTERS PRIVATE LIMITED",
"SAURABH SALES PRIVATE LIMITED",
"SAURABH SANSKAR VIDHYALAYA HIMMATNAGAR",
"SAURABH TUBES PVT LTD",
"SAURABHI MEDIA PRIVATE LIMITED",
"SAURADIP CHEMICAL INDUSTRIES PRIVATE LIMITED",
"SAURAS EXPORTS PVT LTD",
"SAURASHTRA ACETYLENE PVT LTD",
"SAURASHTRA CALCINE BAUXITE AND ALLIED INDUSTRIES LIMITED",
"SAURASHTRA CAPITAL SERVICES P LTD",
"SAURASHTRA CEMENT LIMITED",
"SAURASHTRA CHILDREN HOSPITAL PRIVATE LIMITED",
"SAURASHTRA COLOR TONES PRIVATE LIMITED",
"SAURASHTRA COTTON AND AGRO PRODUCTS PRIVATE LIMITED",
"SAURASHTRA CRICKET ASSOCIATION",
"SAURASHTRA ENVIRO PROJECTS PRIVATE LIMITED",
"SAURASHTRA FINSTOCK PRIVATE LIMITED",
"SAURASHTRA FOOD PROTIN PRIVATE LIMITED",
"SAURASHTRA FREIGHT PRIVATE LIMITED",
"SAURASHTRA FUELS PRIVATE LIMITED",
"SAURASHTRA GRAMIN BANK",
"SAURASHTRA IMPEX LIMITED",
"SAURASHTRA JINNING PRIVATE LIMITED",
"SAURASHTRA MARINE VENTURES PRIVATE LIMITED",
"SAURASHTRA MEDICAL & EDUCATIONAL CHARITABLE TRUST",
"SAURASHTRA PAPER AND BOARD MILLS LTD",
"SAURASHTRA SALT WORKS PRIVATE LIMITED",
"SAURASHTRA SOLID INDUSTRIES PRIVATE LIMITED",
"SAURASHTRA SYSTOPACK PRIVATE LIMITED",
"SAURASHTRA TRUST",
"SAURASHTRA WATER PROJECT (JAMNAGAR) PRIVATE LIMITED",
"SAURAT AUTO TECH PRIVATE LIMITED",
"SAURAV CHEMICALS LIMITED",
"SAURAV FOOTWEAR PRIVATE LIMITED",
"SAURAV SUMAN FINVEST PRIVATE LIMITED",
"SAUREN INDUSTRIES PRIVATE LIMITED",
"SAURER TEXTILE SOLUTIONS PRIVATE LIMITED",
"SAURI BREEDING FARMS PRIVATE LIMITED",
"SAURIN FINANCIAL SERVICES PRIVATE LIMITED",
"SAURIN GEMS PRIVATE LIMITED",
"SAURIN TEXTILE MILLS PRIVATE LIMITED",
"SAURYA EDUNEXT GEN PRIVATE LIMITED",
"SAURYA HSE PRIVATE LIMITED",
"SAURYA PLASTICS INDUSTRIES PRIVATE LIMITED",
"SAURYA URJA COMPANY OF RAJASTHAN LIMITED",
"SAUSAR COTTON PROCESSING PRIVATE LIMITED",
"SAUSS HOME PRODUCTS PRIVATE LIMITED",
"SAUTHRIKA TECHNOLOGIES & INFRA PRIVATE LIMITED",
"SAV CHEMICALS PRIVATE LIMITED",
"SAV CREFINLEASE PRIVATE LIMITED",
"SAV INDIAN MEDICINES PRIVATE LIMITED",
"SAV LOGISTICS LIMITED",
"SAV LOGISTICS PRIVATE LIMITED",
"SAVA HEALTHCARE LIMITED",
"SAVA INTERNATIONAL PRIVATE LIMITED",
"SAVAARI CAR RENTALS PRIVATE LIMITED",
"SAVADIKA RETAIL PRIVATE LIMITED",
"SAVAI PRINTERS PRIVATE LIMITED",
"SAVAIR ENERGY LIMITED",
"SAVAJ COTTON PRIVATE LIMITED",
"SAVAJ DAIRY SS JUNAGADH DISTRICT COOP MILK PRODUCERS UNION LTD",
"SAVALI MANAGEMENT CONSULTANCY PRIVATE LIMITED",
"SAVALIA DEVELOPERS PRIVATE LIMITED",
"SAVALIA TEXTURISERS PVT LTD",
"SAVALIYA AGRI COMMODITY EXPORT PRIVATE LIMITED",
"SAVALIYA INDUSTRIES PRIVATE LIMITED",
"SAVALIYA TEA PACKERS PRIVATE LIMITED",
"SAVAN ELECTRONICS",
"SAVAN GREEN ENERGY SOLUTIONS LIMITED",
"SAVAN IB AUTOMOTIVE PRIVATE LIMITED",
"SAVAN IB AUTOWINGS PRIVATE LIMITED",
"SAVAN PACKAGING PRIVATE LIMITED",
"SAVANI CARRYING PRIVATE LIMITED",
"SAVANI EXPORTS",
"SAVANI HERITAGE CONSERVATION PRIVATE LIMITED",
"SAVANI TRANSPORTS PRIVATE LIMITED",
"SAVANNA FOODS HOLDINGS PRIVATE LIMITED",
"SAVANNAAH HOTELS AND RESORTS PRIVATE LIMITED",
"SAVANNAH REAL ESTATE PRIVATE LIMITED",
"SAVANNAH SEEDS PRIVATE LIMITED",
"SAVANNAH SURFACTANTS LIMITED",
"SAVANS SUPERSPECIALITY HEALTH CARE PRIVATE LIMITED",
"SAVANT AUTOMATION PRIVATE LIMITED",
"SAVANT DAIRY PRIVATE LIMITED",
"SAVANT INSTRUMENTS PRIVATE LIMITED",
"SAVANT TECHNOLOGIES PRIVATE LIMITED",
"SAVANTA ANALYTICS PRIVATE LIMITED",
"SAVANTIKA VANIJYA PRIVATE LIMITED",
"SAVANTIS SOLUTIONS INDIA PRIVATE LIMITED",
"SAVANTURE SOFTECH PRIVATE LIMITED",
"SAVAR TEX INDIA PRIVATE LIMITED",
"SAVARI SYSTEMS PRIVATE LIMITED",
"SAVARIA INDUSTRIES PRIVATE LIMITED",
"SAVAS ENGINEERING COMPANY PRIVATE LIMITED",
"SAVATA MALI PRATHAMIK SHALA DHULE",
"SAVAYAVA KRUSHI SUDHA PRIVATE LIMITED",
"SAVBRI INTERNATIONAL PRIVATE LIMITED",
"SAVCON THERMAL ENGINEERS (INDIA) PRIVATE LIMITED",
"SAVDA NAGAR PARISHAD",
"SAVE CLINICAL AND HEALTH CARE SERVICES PRIVATE LIMITED",
"SAVE ECO ORGANIC PRIVATE LIMITED",
"SAVE ENGINEERING WORKS PRIVATE LIMITED",
"SAVE FINANCIAL SERVICES PRIVATE LIMITED",
"SAVE HOSPITALS",
"SAVE HOUSING FINANCE LIMITED",
"SAVE MICROFINANCE PRIVATE LIMITED",
"SAVE SEAFOOD EXPORTS INDIA PRIVATE LIMITED",
"SAVE SOLUTIONS PRIVATE LIMITED",
"SAVE THE CHILDREN",
"SAVEAIR TECHNOLOGIES PRIVATE LIMITED",
"SAVEBYSWITCHING GLOBAL SOLUTIONS PRIVATE LIMITED",
"SAVEECO ENERGY INDIA PRIVATE LIMITED",
"SAVEER BIOTECH LIMITED",
"SAVEERA HOSPITAL PRIVATE LIMITED",
"SAVEERA INSTITUTE OF MEDICAL SCIENCES PRIVATE LIMITED",
"SAVEETHA COLLEGE OF PHYSIOTHERARPY",
"SAVEETHA DENTAL COLLEGE AND HOSPITALS",
"SAVEETHA ENGINEERING COLLEGE",
"SAVEETHA INSTITUTE OF MEDICAL AND TECHNICAL SCIENCES",
"SAVEETHA MEDICAL COLLEGE AND HOSPITAL",
"SAVEETHA SCHOOL OF ENGINEERING",
"SAVEETHA SCHOOL OF LAW",
"SAVELLI MACHINERY INDIA PRIVATE LIMITED",
"SAVEMAX SOLAR SYSTEMS PRIVATE LIMITED",
"SAVEN GLOBAL SERVICES PRIVATE LIMITED",
"SAVEN NOVA TECHNOLOGIES PRIVATE LIMITED",
"SAVEN TECHNOLOGIES LIMITED",
"SAVENCIA FROMAGE & DAIRY INDIA PRIVATE LIMITED",
"SAVENSA BUSINESS SOLUTIONS PRIVATE LIMITED",
"SAVERA AUTO COMPS PRIVATE LIMITED",
"SAVERA CANCER & MULTI SPECIALITY HOSPITAL",
"SAVERA CARRIERS AND CONTRACTORS PRIVATE LIMITED",
"SAVERA CONCRETECH PRIVATE LIMITED",
"SAVERA DIGITAL INDIA PRIVATE LIMITED",
"SAVERA DISPOSABLES PRIVATE LIMITED",
"SAVERA FARMS",
"SAVERA FARMS PRIVATE LIMITED",
"SAVERA IMPEX PRIVATE LIMITED",
"SAVERA INDIA RIDING SYSTEMS COMPANY PRIVATE LIMITED",
"SAVERA INDUSTRIES LIMITED",
"SAVERA KOTHARI INDIA PRIVATE LIMITED",
"SAVERA MAHILA MANCH",
"SAVERA MOULDINGS PRIVATE LIMITED",
"SAVERA PHARMACEUTICALS PRIVATE LIMITED",
"SAVERA PIPES PRIVATE LIMITED",
"SAVERA PRECISION ENGINEERING PRIVATE LIMITED",
"SAVERA PRESS COMPS PRIVATE LIMITED",
"SAVERA PRINTS PRIVATE LIMITED",
"SAVERA PROMOTERS & DEVELOPERS PRIVATE LIMITED",
"SAVERA REALTY PRIVATE LIMITED",
"SAVERA RICE INDIA PRIVATE LIMITED",
"SAVERA TUBES PRIVATE LIMITED",
"SAVERLY TECHNOLOGIES PRIVATE LIMITED",
"SAVERS RETAILS STORES LIMITED",
"SAVERY TRANSPORT FINANCE LIMITED",
"SAVESOL HEALTHCARE PRIVATE LIMITED",
"SAVETA ENGINEERING CO PVT LTD",
"SAVEX ELECTRICALS (INDIA) PRIVATE LIMITED",
"SAVEX TECHNOLOGIES PRIVATE LIMITED",
"SAVFAB BUILDTECH PRIVATE LIMITED",
"SAVFAB DEVELOPERS PRIVATE. LIMITED.",
"SAVGEN INDIA PRIVATE LIMITED",
"SAVGRP AGRI FOODS PRIVATE LIMITED",
"SAVI GEMS AND JEWELLERY PRIVATE LIMITED",
"SAVI INFOSERVICES INDIA PRIVATE LIMITED",
"SAVI INFRASTRUCTURES & PROPERTIES PRIVATE LIMITED",
"SAVI JANA SEA FOODS PVT LTD",
"SAVI LEATHERS",
"SAVI TREXIM PRIVATE LIMITED",
"SAVI VISION PRIVATE LIMITED",
"SAVIA FELT PRIVATE LIMITED",
"SAVIA PACKAGING",
"SAVIANCE TECHNOLOGIES PRIVATE LIMITED",
"SAVIANT TECHNOLOGY CONSULTING & SOFTWARE DEVELOPMENT PRIVATE LIMITED",
"SAVIC TECHNOLOGIES PRIVATE LIMITED",
"SAVIKALPA HOSPITALITY PRIVATE LIMITED",
"SAVILLE ESTATES PRIVATE LIMITED",
"SAVILLE HOSPITAL RESEARCH CENTRE",
"SAVILLS PROPERTY SERVICES (INDIA) PRIVATE LIMITED",
"SAVIM TECHNOLOGIES PRIVATE LIMITED",
"SAVIN COMMUNICATION PRIVATE LIMITED",
"SAVINAN ENTERPRISES PRIVATE LIMITED",
"SAVINAS EXPORT PRIVATE LIMITED",
"SAVINIRS ELECTRONICS PRIVATE LIMITED",
"SAVINO CERAMIC PRIVATE LIMITED",
"SAVINO DEL BENE FREIGHT FORWARDERS INDIA PRIVATE LIMITED",
"SAVINO GRANITO PRIVATE LIMITED",
"SAVINO MICRON (INDIA) LIMITED",
"SAVIO BIO ORGANIC AND FERTILIZERS PRIVATE LIMITED",
"SAVIO CERAMICA PRIVATE LIMITED",
"SAVIO INDIA LIMITED",
"SAVIOUR AGENCIES PRIVATE LIMITED",
"SAVIOUR BOILERS PRIVATE LIMITED",
"SAVIOUR BUILDERS PRIVATE LIMITED",
"SAVIOUR CAPS PRIVATE LIMITED",
"SAVIOUR CORE CONSULTANT PRIVATE LIMITED",
"SAVIOUR FAIRE MANUFACTURING CO. PRIVATE. LIMITED.",
"SAVIOUR HOSPITAL",
"SAVIOUR INTELLIGENT GUARD FORCE PRIVATE LIMITED",
"SAVIOUR WELLNESS PRIVATE LIMITED",
"SAVIR CONSULTANTS PRIVATE LIMITED",
"SAVIR LOGISTICS PRIVATE LIMITED",
"SAVIRAM ENGINEERING CONSULTANTS PRIVATE LIMITED",
"SAVISO PACKAGING PRIVATE LIMITED",
"SAVISTA GLOBAL SOLUTIONS PRIVATE LIMITED",
"SAVIT INTERACTIVE SERVICES PRIVATE. LIMITED",
"SAVIT POLYMER SOLUTIONS PRIVATE LIMITED",
"SAVITA HOMEMAKERS LLP",
"SAVITA INFRASTRUCTURE PRIVATE LIMITED",
"SAVITA INTERMEDIATES PRIVATE LIMITED",
"SAVITA INVESTMENT COMPANY LIMITED",
"SAVITA OIL TECHNOLOGIES LIMITED",
"SAVITA PAINTS PRIVATE LIMITED",
"SAVITA PLASTICS PRIVATE LIMITED",
"SAVITA RETAIL STORES PRIVATE LIMITED",
"SAVITA SUPERSPECIALITY HOSPITAL",
"SAVITAR AUTO COMPONENTS PRIVATE LIMITED",
"SAVITAR SERVICES PRIVATE LIMITED",
"SAVITHA DENTAL COLLEGE HOSPITAL",
"SAVITHREE INFRASTRUCTURE PRIVATE LIMITED",
"SAVITHRI DIGITAL PRINT PRESS PRIVATE LIMITED",
"SAVITHRI GOPINATH",
"SAVITHRI ROLLER FLOUR MILLS PRIVATE LIMITED",
"SAVITON METPLAST PRIVATE. LIMITED.",
"SAVITR SOFTWARE SERVICES PRIVATE LIMITED",
"SAVITRA TILES PRIVATE LIMITED",
"SAVITRI APPARELS PRIVATE LIMITED",
"SAVITRI ASHIRVAAD BUILDTECH LIMITED",
"SAVITRI BAJAJ COOK PRODUCT PRIVATE LIMITED",
"SAVITRI BAKERS PRIVATE LIMITED",
"SAVITRI COLD STORAGE PRIVATE LIMITED",
"SAVITRI CON-CAST LIMITED",
"SAVITRI CONSULTANCY SERVICES PRIVATE LIMITED",
"SAVITRI DEVI HEALTH CARE PVT LTD",
"SAVITRI ELECTRO-IT PRIVATE LIMITED",
"SAVITRI FOODS PRIVATE LIMITED",
"SAVITRI GEMS & JEWELLERY PRIVATE LIMITED",
"SAVITRI ISPAT INDIA PRIVATE LIMITED",
"SAVITRI LEASING AND FINANCE LIMITED",
"SAVITRI MAHILA SWAYAMROJGAR SEVA SAHKARI SANSTHA",
"SAVITRI PLYBOARD INDIA PRIVATE LIMITED",
"SAVITRI POLYMERS PRIVATE LIMITED",
"SAVITRI SALES PRIVATE LIMITED",
"SAVITRI SPONGE IRON PRIVATE LIMITED",
"SAVITRI STAINLESS PRIVATE LIMITED",
"SAVITRI STEELS AND REROLLINGS PRIVATE LIMITED",
"SAVITRI SURENDRA SECURITY PRIVATE LIMITED",
"SAVITRI TECHNO INDUSTRIES LIMITED",
"SAVITRI TELECOM PRIVATE LIMITED",
"SAVITRI VENTURE PROJECTS (OPC) PRIVATE LIMITED",
"SAVITRI WELLNESS PRIVATE LIMITED",
"SAVITRI WOODS",
"SAVITRIBAI MANSIK VIKLANG VIDYALAYA",
"SAVITRIBAI PHULE PRIMARY SCHOOL AMBAD",
"SAVITRIBAI PHULE PUNE UNIVERSITY",
"SAVITRIBAI PHULE UNIVERSITY",
"SAVITRIDEVI HARIRAM AGARWAL INTERNATIONAL SCHOOL",
"SAVITRIDEVI POLYFABRICS (INDIA) PRIVATE LIMITED",
"SAVITRIDEVI STAINLESS TUBES INDIA PRIVATE LIMITED",
"SAVITRIYA TECHNOLOGIES PRIVATE LIMITED",
"SAVITRU AIRCON PRIVATE LIMITED",
"SAVITRU ENGINEERING ENTERPRISES PRIVATE LIMITED",
"SAVITT UNIVERSAL LIMITED",
"SAVIWIZARD CONSULTANTS PRIVATE LIMITED",
"SAVIYNT INDIA PRIVATE LIMITED",
"SAVLA AGRO FOODS PRIVATE LIMITED",
"SAVLA CERAMICS PRIVATE LIMITED",
"SAVLA CHEMICALS LIMITED",
"SAVLA CREATIONS PRIVATE LIMITED",
"SAVLA DWARKA OKHA ROAD PROJECT PRIVATE LIMITED",
"SAVLA FOODS AND COLD STORAGE PRIVATE LIMITED",
"SAVLA INTERNATIONAL PRIVATE LIMITED",
"SAVLA LAMINATES LIMITED",
"SAVLA OIL AND GAS PRIVATE LIMITED",
"SAVLA PAPTRADE PRIVATE LIMITED",
"SAVLA POLYCOTT PRIVATE LIMITED",
"SAVLA TWISTERS PVT LTD",
"SAVLI COPPER PRODUCTS PRIVATE LIMITED",
"SAVLON SULZ PRIVATE LIMITED",
"SAVM PRIVATE LIMITED",
"SAVOIR ENGINEERING PRIVATE LIMITED",
"SAVOIR FAIRE MANUFACTURING COMPANY PRIVATE LIMITED",
"SAVOIR FAIRE MARKETING CO. PRIVATE LIMITED",
"SAVORIT LIMITED",
"SAVORITE PHARMACEUTICALS",
"SAVORLIFE PRODUCTS PRIVATE LIMITED",
"SAVORY CATERERS AND SERVICES PRIVATE LIMITED",
"SAVORY ENTERTAINMENT PRIVATE LIMITED",
"SAVOUR INDIA PPRIVATE LIMITED",
"SAVOURITES HOSPITALITY PRIVATE LIMITED",
"SAVOY INTERNATIONAL PRIVATE LIMITED",
"SAVSHANTI ANANDAM (CLUB) PVT LTD",
"SAVSHANTI HOTELS PVT LTD",
"SAVTECHNO INFRACON AND ENGINEER LIMITED",
"SAVVAK ENGINEERING INNOVATIONS PRIVATE LIMITED",
"SAVVAK SYSTEMS PRIVATE LIMITED",
"SAVVY BUSINESS SOLUTIONS PRIVATE LIMITED",
"SAVVY CARE & COSMETICS PRIVATE LIMITED",
"SAVVY CORPORATE SERVICES PRIVATE LIMITED",
"SAVVY GRAND HOTELS PRIVATE LIMITED",
"SAVVY INFRASTRUCTURE PRIVATE LIMITED",
"SAVVY LOGISTIC ASIA PRIVATE LIMITED",
"SAVVY SHARES TRADERS PRIVATE LIMITED",
"SAVVYMOB TRAVEL SOLUTIONS PRIVATE LIMITED",
"SAVVYSOFT TECHNOLOGIES PRIVATE LIMITED",
"SAVVYSOULS SOFT LAB PRIVATE LIMITED",
"SAVY ELECTRIC VEHICLES PRIVATE LIMITED",
"SAVY INFRA AND LOGISTICS PRIVATE LIMITED",
"SAVY SOFTWARE PRIVATE LIMITED",
"SAVY TRADE AND RENEWABLES PRIVATE LIMITED",
"SAVYA ENGINEERING SERVICES PRIVATE LIMITED",
"SAVYA SAACHIN MULTITRADE PRIVATE LIMITED",
"SAVYA SALES CORPORATION PRIVATE LIMITED",
"SAVYASACHI CONSTRUCTIONS PRIVATE LIMITED",
"SAW MILL OWNERS SERVICE ENTERPRISES LIMITED",
"SAW TECH PRIVATE LIMITED",
"SAWA SERVICES PRIVATE LIMITED",
"SAWA WORLD APPLIED SOLUTIONS PRIVATE LIMITED",
"SAWACA BUSINESS MACHINES LIMITED",
"SAWACH LIGHTING PRIVATE LIMITED",
"SAWADIKAP HOSPITALITY PRIVATE LIMITED",
"SAWAI FRAGRANCES PRIVATE LIMITED",
"SAWAKA SURFACE COATING SYSTEMS PRIVATE LIMITED",
"SAWALI HEALTHCARE PRIVATE LIMITED",
"SAWALIYA FOOD PRODUCTS PRIVATE LIMITED",
"SAWALKA AUTOTECH PRIVATE LIMITED",
"SAWALKA KEL PVT. LTD.",
"SAWALKA TEXFAB PRIVATE LIMITED",
"SAWALKA TOOLS AND MACHINES PRIVATE LIMITED",
"SAWAN BUILDCON PVT.LTD",
"SAWAN CORPORATION",
"SAWAN ENGINEERS PRIVATE LIMITED",
"SAWAN GANDHI STUDIO PRIVATE LIMITED",
"SAWAN INFRA PROJECTS PRIVATE LIMITED",
"SAWAN K MOTORS PRIVATE LIMITED",
"SAWAN OIL TOOLS PRIVATE LIMITED",
"SAWAN RAJ CONSTRUCTION PRIVATE LIMITED",
"SAWAN SHAH SARAF ORNAMENTS PRIVATE LIMITED",
"SAWAN VISIONS",
"SAWANT AGRO MACHINERIES PRIVATE LIMITED",
"SAWANT FILTECH PRIVATE LIMITED",
"SAWANT INDUSTRIAL SERVICE S PRIVATE LIMITED",
"SAWANT LIFE CARE HOSPITAL PRIVATE LIMITED",
"SAWANT PROCESS SOLUTIONS PRIVATE LIMITED",
"SAWANT VINITA AND ASSOCIATES",
"SAWARIA DEVELOPERS PRIVATE LIMITED",
"SAWARIA HOTELS PVT LTD",
"SAWARIA ISPAT PRIVATE LIMITED",
"SAWARIA PIPES PRIVATE. LIMITED.",
"SAWARIA SETH INFRATECH PRIVATE LIMITED",
"SAWARIYA AGRITECH PRIVATE LIMITED",
"SAWARIYA CONSUMER CARE PRIVATE LIMITED",
"SAWARIYA JEWELLERS PRIVATE LIMITED",
"SAWARIYA PAPER PRIVATE LIMITED",
"SAWARIYA TRANSMOVERS PRIVATE LIMITED",
"SAWARKAR MULTISPECIALITY HOSPITAL",
"SAWARRAM GOODS PRIVATE LIMITED",
"SAWASDEE INFRAPROJECTS PRIVATE LIMITED",
"SAWAYAJPUR COLD STORAGE PRIVATE LIMITED",
"SAWBROS INDUSTRIES PRIVATE LIMITED",
"SAWEN PROJECTS & LABORATORIES PRIVATE LIMITED",
"SAWERA TRAVELS PRIVATE LIMITED",
"SAWERI URJA PRIVATE LIMITED",
"SAWHNEY BROTHERS ROAD LINES LIMITED",
"SAWHNEY DIAMOND PASSION PRIVATE LIMITED",
"SAWHNEY TOURS AND TRAVELS PRIVATE LIMITED",
"SAWINI FINVEST PRIVATE LIMITED",
"SAWKAR HOMOEPATHIC MEDICAL COLLAGE",
"SAWLANI SYNTHETICS PRIVATE LIMITED",
"SAXENA MARINE-TECH PRIVATE LIMITED",
"SAXENA MULTISPECIALITY HOSPITAL PRIVATE LIMITED",
"SAXENA TECHNOLOGIES INDIA PRIVATE LIMITED",
"SAXO AS",
"SAXO GROUP INDIA PRIVATE LIMITED",
"SAXON GLOBAL INDIA PRIVATE LIMITED",
"SAXSONS BIOTECH PRIVATE LIMITED",
"SAY IT LOUD MEDIA PRIVATE LIMITED",
"SAYA AUTOMOBILES LIMITED",
"SAYA BUILDCON CONSORTIUM PRIVATE LIMITED",
"SAYA HOMES PRIVATE LIMITED",
"SAYA LEADERSHIP INSTITUTE PRIVATE LIMITED",
"SAYA PAPER PRINT PRIVATE LIMITED",
"SAYA SALES PRIVATE LIMITED",
"SAYA SECURITY AND ALLIED SERVICES PRIVATE LIMITED",
"SAYA STATIONERIES PRIVATE LIMITED",
"SAYA TOURSOLUTIONS PRIVATE LIMITED",
"SAYAAN VENTURES PRIVATE LIMITED",
"SAYAJI EXTRUSION PRIVATE LIMITED",
"SAYAJI FOODS PRIVATE. LIMITED.",
"SAYAJI HOTELS (INDORE) LIMITED",
"SAYAJI HOTELS LIMITED",
"SAYAJI INDUSTRIES LIMITED",
"SAYAJI PACKAGING PRIVATE LIMITED",
"SAYAJI PAPER PRIVATE LIMITED",
"SAYAJI REAL ESTATE SERVICES PRIVATE LIMITED",
"SAYAJI SEEDS LLP",
"SAYAL IMPEX PVT LTD",
"SAYALI CHARITABLE TRUSTS COLLEGE OF PHARMACY",
"SAYAN GREENOCHEM PRIVATE LIMITED",
"SAYAN INTERNATIONAL PRIVATE LIMITED",
"SAYANI & SONS",
"SAYANI STEEL PRIVATE LIMITED",
"SAYAR AAUTOMOTIVE PRIVATE LIMITED",
"SAYARMAL STEELS PRIVATE LIMITED",
"SAYBOLT INSPECTION SERVICES INDIA PRIVATE LIMITED",
"SAYEDABAD TEA CO LTD",
"SAYEGH PAINT FACTORIES INDIA PRIVATE LIMITED",
"SAYIN CARE PRIVATE LIMITED",
"SAYO TRADERS PRIVATE LIMITED",
"SAYONA ENGINEERING PRIVATE LIMITED",
"SAYONA PLASTWOOD PRIVATE LIMITED",
"SAYONA POLY-TARP PRIVATE LIMITED",
"SAYONE TECHNOLOGIES PRIVATE LIMITED",
"SAYONI TEA ESTATE PRIVATE LIMITED",
"SAYORA PHARMA PRIVATE LIMITED",
"SAYRE THERAPEUTICS PRIVATE LIMITED",
"SAYRO EXIM INDIA PRIVATE LIMITED",
"SAYSOFT TECH SERVICES PRIVATE LIMITED",
"SAYTREES ENVIRONMENTAL TRUST",
"SAYUJ FINANCIAL ADVISORS PRIVATE LIMITED",
"SAYURI PACKAGINGS PRIVATE LIMITED",
"SAYYED ENTERPRISES",
"SAYYESHAA FINSERV PRIVATE LIMITED",
"SAYYOMITA DISTRIBUTION PRIVATE LIMITED",
"SAZPIN SOFTWARE PRIVATE LIMITED",
"SB BAGS PRIVATE LIMITED",
"SB BUILDING SOLUTIONS PRIVATE LIMITED",
"SB CIVIL STRUCTURAL ENGINEERING PRIVATE LIMITED",
"SB DREAMBAKERS PRIVATE LIMITED",
"SB DYESPRINGS (INDIA) PRIVATE LIMITED",
"SB ECOMMERCE SOLUTIONS PRIVATE LIMITED",
"SB ENERGY PRIVATE LIMITED",
"SB ENGICON PRIVATE LIMITED",
"SB FABCARE PRIVATE LIMITED",
"SB FELTS INDIA PRIVATE LIMITED",
"SB HARD ENTERPRISES PRIVATE LIMITED",
"SB HOSPITAL & HEALTHCARE PRIVATE LIMITED",
"SB JAIN INTERNATIONAL SCHOOL",
"SB LIFESCIENCES PRIVATE LIMITED",
"SB LIFESPACES PRIVATE LIMITED",
"SB METALS PRIVATE. LIMITED.",
"SB ONLINE SOLUTIONS PRIVATE LIMITED",
"SB PACKAGINGS PRIVATE LIMITED",
"SB PHOTO LAB NEEDS PRIVATE LIMITED",
"SB PROTECH PRIVATE LIMITED",
"SB SAFEGUARD SERVICES PRIVATE LIMITED",
"SB SCAFFOLDING INDIA PRIVATE LIMITED",
"SB TELECOM INDIA PRIVATE LIMITED",
"SB TRADE IN PRIVATE LIMITED",
"SB TVS INDUSTRIAL VENTURES PRIVATE LIMITED",
"SB WIND ENERGY PRIVATE LIMITED",
"SBA ARCHITECTS & DESIGNERS PRIVATE LIMITED",
"SBA BAKERY PRIVATE LIMITED",
"SBA DISTRIBUTORS PRIVATE LIMITED",
"SBA ENTERPRISES PRIVATE LIMITED",
"SBA ENVIRO SYSTEMS PRIVATE LIMITED",
"SBA FOREX SERVICES PRIVATE LIMITED",
"SBA INFO SOLUTIONS PRIVATE LIMITED",
"SBA INFRATECH SERVICES PRIVATE LIMITED",
"SBA MATRIC HR SEC SCHOOL",
"SBA METALS AND STEEL PRIVATE LIMITED",
"SBA RECYCLING PRIVATE LIMITED",
"SBA STONE PRIVATE LIMITED",
"SBA TRADELAW PRIVATE LIMITED",
"SBACCHUS DISTILLERY PRIVATE LIMITED",
"SBAG METAL AND IRON PRIVATE LIMITED",
"SBATECH SOLUTIONS PRIVATE LIMITED",
"SBB CONSTRUCTIONS PRIVATE LIMITED",
"SBBA INTER COLLEGE",
"SBBE ENTERPRISES PRIVATE LIMITED",
"SBBS MARKETING PRIVATE LIMITED",
"SBC COOLING PRIVATE LIMITED",
"SBC EXPORTS LIMITED",
"SBC INDIA LIMITED",
"SBC INFRACON PRIVATE LIMITED",
"SBC MINERALS PRIVATE LIMITED",
"SBCC INFRA PRIVATE LIMITED",
"SBCC PROJECTS (OPC) PRIVATE LIMITED",
"SBD GREEN ENERGY AND INFRA INDIA PRIVATE LIMITED",
"SBD INDIA PRIVATE LIMITED",
"SBDNSK165 BUILDCON PRIVATE LIMITED",
"SBDWIBEDY CONSTRUCTIONS PRIVATE LIMITED",
"SBE UNIQUE RETAILS PRIVATE LIMITED",
"SBEC BIOENERGY LIMITED",
"SBEC STOCKHOLDING AND INVESTMENT LIMITED",
"SBEC SUGAR LIMITED",
"SBEC SYSTEMS (INDIA) LIMITED",
"SBEE CABLES INDIA LIMITED",
"SBEG CONSULTANTS PRIVATE LIMITED",
"SBEM PRIVATE LIMITED",
"SBES COLLEGE OF SCIENCE",
"SBF HEALTHCARE AND RESEARCH CENTER PRIVATE LIMITED",
"SBF INFRA PRIVATE LIMITED",
"SBF ISPAT PRIVATE LIMITED",
"SBF PHARMA PRIVATE LIMITED",
"SBFC FINANCE LIMITED",
"SBFC FINANCE PRIVATE LIMITED",
"SBFM SERVICES INDIA PRIVATE LIMITED",
"SBG DESIGNS PRIVATE LIMITED",
"SBG DISTRIBUTORS PRIVATE LIMITED",
"SBG ENGINEERING PVT LTD",
"SBG INFRACON PRIVATE LIMITED",
"SBGV TECHMAGNATE DIGITAL PRIVATE LIMITED",
"SBH FOODS PRIVATE LIMITED",
"SBH WOMEN HOSPITAL PRIVATE LIMITED",
"SBHARD ENTERPRISES PRIVATE LIMITED",
"SBI BUSINESS PROCESS MANAGEMENT SERVICES PRIVATE LIMITED",
"SBI CAPITAL MARKETS LIMITED",
"SBI CAPITAL MKTS",
"SBI CARDS AND PAYMENT SERVICES LIMITED",
"SBI DFHI LIMITED",
"SBI FACTORS & COMMERCIAL SERVICES PRIVATE LIMITED",
"SBI FOUNDATION",
"SBI FUNDS MANAGEMENT LIMITED",
"SBI FUNDS MANAGEMENT PRIVATE LIMITED",
"SBI GENERAL INSURANCE COMPANY LIMITED",
"SBI LIFE INSURANCE COMPANY LIMITED",
"SBI MACQUARIE INFRASTRUCTURE MANAGEMENT PRIVATE LIMITED",
"SBI MUTUAL FUND",
"SBI MUTUAL FUNDS PRIVATE. LIMITED",
"SBI PAYMENT SERVICES PRIVATE LIMITED",
"SBI PENSION FUNDS PRIVATE LIMITED",
"SBI SEWA LHO BHOPAL",
"SBI SG GLOBAL SECURITIES SERVICES PRIVATE LIMITED",
"SBICAP SECURITIES LIMITED",
"SBICAP TRUSTEE COMPANY LIMITED",
"SBICAP VENTURES LIMITED",
"SBIW STEELS PRIVATE LIMITED",
"SBJ BPO SERVICES LIMITED",
"SBJ BUSINESS SOLUTIONS PRIVATE LIMITED",
"SBJ CONCRETE SOLUTION PRIVATE LIMITED",
"SBJ IMPEX OVERSEAS PRIVATE LIMITED",
"SBJ INFRATECH PRIVATE LIMITED",
"SBJ PACKAGING INDUSTRIES PRIVATE LIMITED",
"SBK GRANITE PRIVATE LIMITED",
"SBK PROPERTIES PRIVATE LIMITED",
"SBK TRADE AND INFRASTRUCTURE PRIVATE LIMITED",
"SBL COLORTECH P LTD",
"SBL CONSTRUCTION PRIVATE LIMITED",
"SBL ENERGY LIMITED",
"SBL EXPRESS INDIA PRIVATE LIMITED",
"SBL KNOWLEDGE SERVICES LIMITED",
"SBL KNOWLEDGE SERVICES PRIVATE LIMITED",
"SBL PLASTICS PRIVATE LIMITED",
"SBL PRIVATE LIMITED",
"SBL SPECIALTY COATINGS PRIVATE LIMITED",
"SBL TEXTILE PRIVATE LIMITED",
"SBLUIS BUSINESS FORTUNE PRIVATE LIMITED",
"SBM AERINAUTIKA PRIVATE LIMITED",
"SBM BANK (INDIA) LIMITED",
"SBM BANK MAURITIUS LIMITED",
"SBM CHAIR PRIVATE LIMITED",
"SBM CHEMICALS AND INSTRUMENTS PRIVATE LIMITED",
"SBM DIGITAL CHENNAI PRIVATE LIMITED",
"SBM ELECTRIC TECHNO PRIVATE LIMITED",
"SBM GREENWORLD PRIVATE LIMITED",
"SBM INDUSTRIES PRIVATE LIMITED",
"SBM MOTORS PRIVATE LIMITED",
"SBM NIRMAAN CONSTRUCTION PRIVATE LIMITED",
"SBM OFFSHORE INDIA PRIVATE LIMITED",
"SBM PIPE INDUSTRIES PRIVATE LIMITED",
"SBM TRAANSPORT APPLICATIONS PRIVATE LIMITED",
"SBMP TECHNOFORGE LLP",
"SBN CONTAINERS PRIVATE LIMITED",
"SBN GAMING NETWORK PRIVATE LIMITED",
"SBN TECHNOLOGIECS PRIVATE LIMITED",
"SBNA SOFTWARE SOLUTIONS PRIVATE LIMITED",
"SBO INFOTECH PRIVATE LIMITED",
"SBOA MATRICULATION HIGHER SECONDARY SCHOOL",
"SBOA SCHOOL AND JUNIOR COLLEGE",
"SBP (FOOD & HYGIENE) PRIVATE LIMITED",
"SBP CONSULTING PRIVATE LIMITED",
"SBP DREAM CITY PRIVATE LIMITED",
"SBPOWERDEV (OPC) PRIVATE LIMITED",
"SBR DIAGNOSTICS PRIVATE LIMITED",
"SBR HEALTHCARE PRIVATE LIMITED",
"SBR POWER ADVANTAGE INDIA PRIVATE LIMITED",
"SBR RADIOLOGY PRIVATE LIMITED",
"SBR STEELS PRIVATE LIMITED",
"SBRL LOGISTICS PRIVATE LIMITED",
"SBRO TAPES PRIVATE LIMITED",
"SBRS MACHINES PRIVATE LIMITED",
"SBS BEAUTECH LLP",
"SBS CHEMICALS & FERTILIZERS PRIVATE LIMITED",
"SBS CONTRACTS PRIVATE LIMITED",
"SBS HEALTHCARE SERVICES PRIVATE LIMITED",
"SBS HERBAL LIMITED",
"SBS LIFE SCIENCES PRIVATE LIMITED",
"SBS PAPER BOARDS PRIVATE LIMITED",
"SBS POLYCHEM PRIVATE LIMITED",
"SBS RECHARGE PRIVATE LIMITED",
"SBS RECYCLING PRIVATE LIMITED",
"SBS RICELAND PRIVATE LIMITED",
"SBS TRADE INTERNATIONAL PRIVATE LIMITED",
"SBS TRANSWORLD PRIVATE LIMITED",
"SBSENVIRO AQUA CONCEPTS PRIVATE LIMITED",
"SBSOL DIGITAL PRIVATE LIMITED",
"SBSS CONSTRUCTION PRIVATE LIMITED",
"SBSS LOGISTICS PRIVATE LIMITED",
"SBT COMMERCIAL PRIVATE LIMITED",
"SBT DESIGNER PRIVATE LIMITED",
"SBT NIRMAN PRIVATE LIMITED",
"SBT PROPERTIES AND INFRASTRUCTURE PRIVATE LIMITED",
"SBT RESEARCH PRIVATE LIMITED",
"SBT SPINTEX PRIVATE LIMITED",
"SBT TECHNOTEX PRIVATE LIMITED",
"SBT TEXTILES PRIVATE LIMITED",
"SBT TRANSPORT PRIVATE LIMITED",
"SBT UNIFORM",
"SBTC INFRASOLUTIONS PRIVATE LIMITED",
"SBTELE INFRA SOLUTIONS PRIVATE LIMITED",
"SBTSMS PRIVATE LIMITED",
"SBUYS E-COMMERCE LIMITED",
"SBW INTERIORS PRIVATE LIMITED",
"SBW UDYOG LIMITED",
"SC AGROTECH LIMITED",
"SC AUTO AGENCIES PRIVATE LIMITED",
"SC HOTEL TOURIST DELUXE PRIVATE LIMITED",
"SC INDIA MANAGER PRIVATE LIMITED",
"SC INFOTECH PRIVATE LIMITED",
"SC INFRASTRUCTURE (OPC) PRIVATE LIMITED",
"SC ST DEV DEPTT",
"SC ST RESEARCH AND TRAINING INSTITUTE",
"SCA ECODE SOLUTIONS PRIVATE LIMITED",
"SCA INTERNATIONAL ISPAT PRIVATE LIMITED",
"SCA IT INFRASTRUCTURE PRIVATE LIMITED",
"SCA LOGISTICS PRIVATE LIMITED",
"SCA PROJECTS PRIVATE LIMITED",
"SCA SOUTHASIA PETROCHEMICALS PRIVATE LIMITED",
"SCA TECHNOLOGIES INDIA PRIVATE LIMITED",
"SCADS HR NETWORKS PRIVATE LIMITED",
"SCAFFOLD PROPERTIES PRIVATE LIMITED",
"SCALABILITY ENGINEERS PRIVATE LIMITED",
"SCALABLE CONSULTING AND SOLUTIONS PRIVATE LIMITED",
"SCALABLE SYSTEMS PRIVATE LIMITED",
"SCALD ENERGY PRIVATE LIMITED",
"SCALE AWAY INDIA PRIVATE LIMITED",
"SCALEBAN EQUIPMENTS PRIVATE LIMITED",
"SCALEDESK WEB STUDIO PRIVATE LIMITED",
"SCALEDGE INDIA PRIVATE LIMITED",
"SCALEFACTOR CONSULTING LABS PRIVATE LIMITED",
"SCALEIOS PRIVATE LIMITED",
"SCALENE CYBERNETICS LIMITED",
"SCALENE ENERGY - WATER CORPORATION LIMITED",
"SCALENE LIVPROTEC PRIVATE LIMITED",
"SCALENEWORKS PEOPLE SOLUTIONS LLP",
"SCALENUT TECHNOLOGIES PRIVATE LIMITED",
"SCALEPHASE WEIGHT MANAGEMENT PRIVATE LIMITED",
"SCALER CONSULTING PRIVATE LIMITED",
"SCALETEC MECHATRONICS PRIVATE LIMITED",
"SCALETEK ENGINEERING PRIVATE LIMITED",
"SCALEUP STREET TECHNOLOGIES PRIVATE LIMITED",
"SCALEUP SYSTEMS INDIA PRIVATE LIMITED",
"SCALEX BUSINESS PRIVATE LIMITED",
"SCALIUM DIGITAL MEDIA PRIVATE LIMITED",
"SCALLOPS LOGISTICS PRIVATE LIMITED",
"SCALYBEE DIGITAL PRIVATE LIMITED",
"SCAME INDIA PRIVATE LIMITED",
"SCAN BIOTECH LIMITED",
"SCAN ELEVATOR LIMITED",
"SCAN ENERGY & POWER LIMITED",
"SCAN FORWARDERS PRIVATE LIMITED",
"SCAN GUARD PROTECTION SERVICES PRIVATE LIMITED",
"SCAN HOLDINGS PRIVATE LIMITED",
"SCAN MACHINERIES PRIVATE LIMITED",
"SCAN PLASTICS PRIVATE LIMITED",
"SCAN STEELS LIMITED",
"SCANCAFE DIGITAL SOLUTIONS PRIVATE LIMITED",
"SCANDIA MOTORCARS PRIVATE LIMITED",
"SCANET TRADING PRIVATE LIMITED",
"SCANIA COMMERCIAL VEHICLES INDIA PRIVATE LIMITED",
"SCANIA STEELS & POWERS LIMITED",
"SCANID SYSTEMS PRIVATE LIMITED",
"SCAN-IT SOLUTION INDIA PRIVATE LIMITED",
"SCANLINE PRINTS PRIVATE LIMITED",
"SCANLYTICS TECHNOLOGY PRIVATE LIMITED",
"SCANNING PENS INDIA PRIVATE LIMITED",
"SCANTECH INDIA MEASURING EQUIPMENTS PRIVATE LIMITED",
"SCANTECH INFRATECH PRIVATE LIMITED",
"SCANTECH LASER PRIVATE LIMITED",
"SCANTRANS INDIA PRIVATE LIMITED",
"SCANWELL LOGISTICS INDIA PRIVATE LIMITED",
"SCAP TECHNO FAB LIMITED",
"SCAP TEX COAT PRIVATE LIMITED",
"SCAPA TAPES INDIA PRIVATE LIMITED",
"SCAPES REALTY INDIA PRIVATE LIMITED",
"SCAPETREE TECHNOLOGIES INDIA PRIVATE LIMITED",
"SCARAMANGA BOATS PRIVATE LIMITED",
"SCARCO SHOES PRIVATE LIMITED",
"SCARECROW M&C SAATCHI LIMITED",
"SCARLET FORMULATION PRIVATE LIMITED",
"SCARLET INFRASTRUCTURE PRIVATE LIMITED",
"SCARLET MULTI PRODUCTS PRIVATE LIMITED",
"SCARLET WIRELESS INDIA PRIVATE LIMITED",
"SCARLETT SUITINGS PRIVATE LIMITED",
"SCARNOSE INTERNATIONAL LIMITED",
"SCATTER SHADE CRAFTS PRIVATE LIMITED",
"SCATTERPIE ANALYTICS PRIVATE LIMITED",
"SCAVIN INTERNATIONAL EXIM PRIVATE LIMITED",
"SCB CPAFIRST LLP",
"SCB INTERCONNECTION SOLUTIONS PRIVATE LIMITED",
"SCB MEDICAL COLLEGE",
"SCC INFRASTRUCTURE PRIVATE LIMITED",
"SCD ELECTRONICS PRIVATE LIMITED",
"SCENARIO CONSULTING PRIVATE LIMITED",
"SCENARIO MARKETING PRIVATE LIMITED",
"SCENARIO POWERTECH PRIVATE LIMITED",
"SCENIC COMMUNICATION PRIVATE LIMITED",
"SCENIC DEVELOPERS PRIVATE LIMITED",
"SCENICBEAUTY HOMES PRIVATE LIMITED",
"SCENTIALS BEAUTYCARE AND WELLNESS PRIVATE LIMITED",
"SCEPTER IT SOLUTIONS PRIVATE LIMITED",
"SCEPTER LIFESCIENCES PRIVATE LIMITED",
"SCEPTRE MEDICAL INDIA PRIVATE LIMITED",
"SCF SERVICES PRIVATE LIMITED",
"SCG CONTRACTS INDIA PRIVATE LIMITED",
"SCG DESIGN SOLUTIONS PRIVATE LIMITED",
"SCG ENTERPRISES PRIVATE LIMITED",
"SCG INDUSTRIES PRIVATE LIMITED",
"SCG INDUSTRIES PVT LTD",
"SCG INTERNATIONAL INDIA PRIVATE LIMITED",
"SCH RADIANCE PRIVATE LIMITED",
"SCHABLONA INDIA LIMITED",
"SCHACH ENGINEERS PRIVATE LIMITED",
"SCHAEFER SYSTEMS INTERNATIONAL PRIVATE LIMITED",
"SCHAEFFLER INDIA LIMITED",
"SCHAKE INDIA METAL WORK PRIVATE LIMITED",
"SCHALTBAU INDIA PRIVATE LIMITED",
"SCHAWK INDIA PRIVATE LIMITED",
"SCHBANG DIGITAL SOLUTIONS PRIVATE LIMITED",
"SCHEDULERS LOGISTICS INDIA PRIVATE LD",
"SCHEDULERS LOGISTICS PRIVATE LIMITED",
"SCHELL INDIA PRIVATE LIMITED",
"SCHEMATIC ENGINEERING INDUSTRIES",
"SCHEMATIC PROJECTS PRIVATE LIMITED",
"SCHEMATIC SYSTEMS PRIVATE LIMITED",
"SCHEMAX EXPERT TECHNO CRAFTS PRIVATE LIMITED",
"SCHEME-ART REAL ESTATE PRIVATE LIMITED",
"SCHENCK PROCESS INDIA LIMITED",
"SCHENCK PROCESS SOLUTIONS INDIA PRIVATE LIMITED",
"SCHENCK ROTEC INDIA LIMITED",
"SCHENKER INDIA PRIVATE LIMITED",
"SCHEPPER ENTERPRISE PRIVATE LIMITED",
"SCHERDEL INDIA PRIVATE LIMITED",
"SCHEVARAN LABORATORIES PRIVATE LIMITED",
"SCHIFFER AND MENEZES INDIA PRIVATE. LIMITED.",
"SCHIFLER WERKZEUGE & COMPANY PRIVATE LIMITED",
"SCHILLER HEALTHCARE INDIA PRIVATE LIMITED",
"SCHILTHORN PRECISION ENGINEERING PRIVATE LIMITED",
"SCHIMMER ENERGY PRIVATE LIMITED",
"SCHINDLER INDIA PRIVATE LIMITED",
"SCHIV INNOVATIVE PRODUCTS PRIVATE LIMITED",
"SCHLEMMER TECHNOLOGY INDIA PRIVATE LIMITED",
"SCHLOSS BANGALORE PRIVATE LIMITED",
"SCHLOSS CHANAKYA PRIVATE LIMITED",
"SCHLOSS CHENNAI PRIVATE LIMITED",
"SCHLOSS GANDHINAGAR PRIVATE LIMITED",
"SCHLOSS UDAIPUR PRIVATE LIMITED",
"SCHLUMBERGER",
"SCHLUMBERGER ASIA SERVICES LIMITED",
"SCHLUMBERGER GLOBAL SUPPORT CENTRE LIMITED",
"SCHLUMBERGER INDIA TECHNOLOGY CENTRE PRIVATE LIMITED",
"SCHMALZ INDIA PRIVATE LIMITED",
"SCHMERSAL INDIA PRIVATE LIMITED",
"SCHMETZ INDIA PRIVATE LIMITED",
"SCHMIEDE AND MASCHINEN PRIVATE LIMITED",
"SCHMITZ INDIA PRIVATE LIMITED",
"SCHNABEL DC CONSULTANTS INDIA PRIVATE LIMITED",
"SCHNEEBERGER INDIA PRIVATE LIMITED",
"SCHNEIDE SOLUTIONS PRIVATE LIMITED",
"SCHNEIDER ELECTRIC CONZERV INDIA PRIVATE LIMITED",
"SCHNEIDER ELECTRIC INDIA PRIVATE LIMITED",
"SCHNEIDER ELECTRIC INFRASTRUCTURE LIMITED",
"SCHNEIDER ELECTRIC IT BUSINESS INDIA PRIVATE LIMITED",
"SCHNEIDER ELECTRIC PRESIDENT SYSTEMS LIMITED",
"SCHNEIDER ELECTRIC PRIVATE LIMITED",
"SCHNEIDER ELECTRIC SOFTWARE INDIA PRIVATE LIMITED",
"SCHNEIDER ELECTRIC SOLAR INDIA PRIVATE LIMITED",
"SCHNEIDER ELECTRIC SYSTEMS INDIA PRIVATE LIMITED",
"SCHNEIDER PROTOTYPING INDIA PRIVATE LIMITED",
"SCHNELL BUILDERS PRIVATE LIMITED",
"SCHNELL ENERGY EQUIPMENTS PRIVATE LIMITED",
"SCHNELL INDIA MACHINERY PRIVATE LIMITED",
"SCHNELL INFORMATICS PRIVATE LIMITED",
"SCHNELL SOFTWARE SOLUTIONS PRIVATE LIMITED",
"SCHNELLECKE - JEENA LOGISTICS INDIA PRIVATE LIMITED",
"SCHOCH REEDS INDIA PRIVATE LIMITED",
"SCHOELLER ALLIBERT TIME MATERIALS HANDLING SOLUTIONS LIMITED",
"SCHOELLER INDIA INDUSTRIES PRIVATE LIMITED",
"SCHOELLER TECHNOLOGIES INDIA PRIVATE LIMITED",
"SCHOLAR ALLEY PRIVATE LIMITED",
"SCHOLAR MISSION SCHOOL",
"SCHOLAR YARNS PRIVATE LIMITED",
"SCHOLARLY ONLINE EDUTECH INDIA PRIVATE LIMITED",
"SCHOLARS ACADEMY EDUCATION TRUST",
"SCHOLARS EDEN SCHOOL",
"SCHOLARS GLOBAL SCHOOL",
"SCHOLARS INTERNATIONAL SCHOOL",
"SCHOLARS ROSARY SENIOR SECONDARY SCHOOL",
"SCHOLASTIC INTERNATIONAL IT SUPPORT CENTRE PRIVATE LIMITED",
"SCHOLLE IPN INDIA PACKAGING PRIVATE LIMITED",
"SCHON COMMUNICATIONS PRIVATE LIMITED",
"SCHON PHARMACEUTICALS LIMITED",
"SCHONESHAUS INDIA PRIVATE LIMITED",
"SCHOOL DIGITAL MEDIA AND MARKETING",
"SCHOOL EDUCATION DEPARTMENT",
"SCHOOL EDUCATION DEPARTMENT BLOCK EDUCATION OFFICER ABHANPUR",
"SCHOOL EDUCATION DEPARTMENT BLOCK EDUCATION OFFICER DABHARA",
"SCHOOL EDUCATION DEPARTMENT BLOCK EDUCATION OFFICER RAJNANDGAON",
"SCHOOL EDUCATION DEPARTMENT MP",
"SCHOOL EDUCATION DEPARTMENT OF EDUCATION PUNJAB",
"SCHOOL FOR E EDUCATION RESEARCH AND INNOVATION PRIVATE LIMITED",
"SCHOOL GURU EDUSERVE PRIVATE LIMITED",
"SCHOOL HEALTH ANNUAL REPORT PROGRAMME",
"SCHOOL OF ARTILLERY",
"SCHOOL OF ARTILLERY DEOLALI",
"SCHOOL OF AYURVEDIC AND MAHA YOGA PRIVATE LIMITED",
"SCHOOL OF COMPUTING SCIENCE & ENGINEERING",
"SCHOOL OF EDUCATION",
"SCHOOL OF HOSPITALITY INDIA PRIVATE LIMITED",
"SCHOOL OF INNOVATION AND MANAGEMENT",
"SCHOOL OF SCHOLARS",
"SCHOOL OF ULTIMATE LEADERSHIP FOUNDATION",
"SCHOOL SHOP PRIVATE LIMITED",
"SCHOOL TAGORE PUBLIC SCHOOL",
"SCHOOLAY TECHNOLOGIES PRIVATE LIMITED",
"SCHOOLNET INDIA LIMITED",
"SCHOOLPAD TECHNOLOGIES PRIVATE LIMITED",
"SCHOOLS INDIA SERVICES PRIVATE LIMITED",
"SCHOOLSLENS SOLUTIONS PRIVATE LIMITED",
"SCHOTT GLASS INDIA PRIVATE LIMITED",
"SCHOTT POONAWALLA PRIVATE LIMITED",
"SCHREIBER DYNAMIX DAIRIES PRIVATE LIMITED",
"SCHRILL TECHNOLOGIES",
"SCHROCKEN INDIA PRIVATE LIMITED",
"SCHRODINGER GMBH",
"SCHUCK INDIA PRIVATE LIMITED",
"SCHUECO INDIA PRIVATE LIMITED",
"SCHUERMATT JEWELLERY PRIVATE LIMITED",
"SCHUF SPECIALITY VALVES INDIA PRIVATE LIMITED",
"SCHULER INDIA PRIVATE LIMITED",
"SCHULKE INDIA PRIVATE LIMITED",
"SCHUMAK EQUIPMENT INDIA PRIVATE LIMITED",
"SCHUNK CARBON TECHNOLOGY INDIA PRIVATE LIMITED",
"SCHUNK INTEC INDIA PRIVATE LIMITED",
"SCHURTER ELECTRONICS (INDIA) PRIVATE LIMITED",
"SCHUTTE MEYER ASHWATH ALLOYS PRIVATE LIMITED",
"SCHUTZ CARBON ELECTRODES PRIVATE LIMITED",
"SCHUTZ DISHMAN BIOTECH LIMITED",
"SCHUTZEN CARE PRIVATE LIMITED",
"SCHWARTZ TURBOTECH PRIVATE LIMITED",
"SCHWEICKERT INDIA PRIVATE LIMITED",
"SCHWEITZER ENG LABORATORIES PRIVATE LIMITED",
"SCHWING STETTER INDIA PRIVATE LIMITED",
"SCI COMPANIES INDIA SERVICES PRIVATE LIMITED",
"SCI EXPORT PRIVATE LIMITED",
"SCI HEALTHCARE PRIVATE LIMITED",
"SCI INDIA LIMITED",
"SCI INTERNATIONAL HOSPITAL",
"SCI IT SOLUTIONS PRIVATE LIMITED",
"SCI SEARCH AND SELECTION SERVICES PRIVATE LIMITED",
"SCI SECURITIES SERVICES PRIVATE LIMITED",
"SCICOM CONTACT CENTRE SERVICES PRIVATE LIMITED",
"SCI-COM SOFTWARE INDIA PRIVATE LIMITED",
"SCIDEAS SOLUTIONS PRIVATE LIMITED",
"SCIEGEN PHARMACEUTICALS INDIA PRIVATE LIMITED",
"SCIEMED HEALTHCARE PRIVATE LIMITED",
"SCIEMETRIC TECHNOLOGIES INDIA PRIVATE LIMITED",
"SCIENAPTIC SYSTEMS PRIVATE LIMITED",
"SCIENCE ACADEMY P U COLLEGE",
"SCIENCE COLLEGE",
"SCIENCE FOR SOCIETY TECHNO SERVICES PRIVATE LIMITED",
"SCIENCE HOUSE MEDICALS PRIVATE LIMITED",
"SCIENCE PLUS COACHING INSTITUTE PRIVATE LIMITED",
"SCIENCE2HOME PRIVATE LIMITED",
"SCIENCEBYDESIGN LABSYSTEMS (INDIA) PRIVATE LIMITED",
"SCIENCEFOX TECHNOLOGIES PRIVATE LIMITED",
"SCIENT CAPITAL PRIVATE LIMITED",
"SCIENT CHEMICALS PRIVATE LIMITED",
"SCIENTE CONSULTING PRIVATE LIMITED",
"SCIENTECH CROPCARE PRIVATE LIMITED",
"SCIENTECH TECHNOLOGIES PRIVATE LIMITED",
"SCIENTIA INFOCOM INDIA PRIVATE LIMITED",
"SCIENTIFIC & CHEMICAL PRODUCTS PVT LTD",
"SCIENTIFIC AGE RESEARCH AND TESTING LAB PRIVATE LIMITED",
"SCIENTIFIC AGENCIES PRIVATE LIMITED",
"SCIENTIFIC AGRICULTURE LABORATORY PRIVATE LIMITED",
"SCIENTIFIC ANIMATIONS AND GRAPHICS PRIVATE LIMITED",
"SCIENTIFIC BRAIN NUTRACEUTICAL PRIVATE LIMITED",
"SCIENTIFIC CERTIFICATION SYSTEMS INDIA PRIVATE LIMITED",
"SCIENTIFIC CLINICAL LABORATORY PRIVATE LIMITED",
"SCIENTIFIC CONTROLS PRIVATE LIMITED",
"SCIENTIFIC DEVICES BOMBAYPRIVATE LIMITED",
"SCIENTIFIC DIAGNOSTIC CENTRE PRIVATE LIMITED",
"SCIENTIFIC EREVNA PRIVATE LIMITED",
"SCIENTIFIC FOOD TESTING SERVICES PRIVATE LIMITED",
"SCIENTIFIC HEAT TREATMENT SERVICES INDIA PRIVATE LIMITED",
"SCIENTIFIC INTERNATIONAL PRIVATE LIMITED",
"SCIENTIFIC KNITS PROCESSORS PRIVATE LIMITED",
"SCIENTIFIC MES-TECHNIK PRIVATE.LIMITED",
"SCIENTIFIC PRECISION PRIVATE LIMITED",
"SCIENTIFIC PUBLISHING SERVICES PRIVATE LIMITED",
"SCIENTIFIC REMEDIES AND HEALTH CARE PRIVATE LIMITED",
"SCIENTIFIC REMEDIES PRIVATE LIMITED",
"SCIENTIFIC RESEARCH INSTRUMENTS COMPANY PRIVATE LIMITED",
"SCIENTIFIC RESEARCH SOLUTION PRIVATE LIMITED",
"SCIENTIFIC SALES RESEARCH CHEMICALS PRIVATE LIMITED",
"SCIENTIFIC SCHOLAR PRIVATE LIMITED",
"SCIENTIFIC SECURITY MANAGEMENT SERVICES PRIVATE LIMITED",
"SCIENTIFIC SYSTEMS & CHEMICALS PRIVATE LIMITED",
"SCIENTIFIC VISION PRIVATE LIMITED",
"SCIENTIMED SOLUTIONS PRIVATE LIMITED",
"SCIERA SOLUTIONS PRIVATE LIMITED",
"SCIFED PRIVATE LIMITED",
"SCIFFER ANALYTICS PRIVATE LIMITED",
"SCIGENICS BIOTECH PRIVATE LIMITED",
"SCIGENICS INDIA PRIVATE LIMITED",
"SCIGENOM LABS PRIVATE LIMITED",
"SCIIENTIFIC-CONTROLS TECHKNO PRIVATE LIMITED",
"SCIKEM PHARMACEUTICALS PRIVATE LIMITED",
"SCIKNOW TECHNO SOLUTIONS LIMITED",
"SCIL CAPITAL INDIA LIMITED",
"SCILIFE PRIVATE LIMITED",
"SCILLZ MANAGEMENT CONSULTING PRIVATE LIMITED",
"SCINDIA INVESTMENTS PVT LTD",
"SCINDIA KANYA VIDYALAYA",
"SCINNOVA INTERNATIONAL PRIVATE LIMITED",
"SCINNOVATION CONSULTANTS PRIVATE LIMITED",
"SCINNTC SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED",
"SCINTAN INDIA PRIVATE LIMITED",
"SCINTEL TECHNOLOGIES PRIVATE LIMITED",
"SCINTILLA KREATIONS PRIVATE LIMITED",
"SCINTILLATE RCM HEALTHCARE PRIVATE LIMITED",
"SCINTILLATING JEWELLERY",
"SCINTILLATION TRUCKING INDIA PRIVATE LIMITED",
"SCIOINSPIRE CONSULTING SERVICES (INDIA) PRIVATE LIMITED",
"SCION FORGE PRIVATE LIMITED",
"SCION INDUSTRIAL ENGINEERING PRIVATE LIMITED",
"SCION PHARMA PRIVATE LIMITED",
"SCION VIGILANT SERVICES PRIVATE LIMITED",
"SCISPHERE ANALYTICS INDIA PRIVATE LIMITED",
"SCISSORS ENRICH BEAUTY & FITNESS PRIVATE LIMITED",
"SCITARA TECHNOLOGIES PRIVATE LIMITED",
"SCITECH LABORATORIES PRIVATE LIMITED",
"SCITECH PATENT ART SERVICES PRIVATE LIMITED",
"SCITECH SPECIALITIES PRIVATE LIMITED",
"SCITRON NUTRITION (INDIA) PRIVATE LIMITED",
"SCITUS PHARMA SERVICES PRIVATE LIMITED",
"SCIVIC ENGINEERING INDIA PRIVATE LIMITED",
"SCJ PLASTICS LIMITED",
"SCJ PLASTICS PRIVATE LIMITED",
"SCKETCH DIGITAL SOLUTIONS LLP",
"SCL ELECTRIC INDIA PRIVATE LIMITED",
"SCL INDIA PRIVATE LIMITED",
"SCL IT TECHNOLOGIES PRIVATE LIMITED",
"SCL NETWORKS PRIVATE LIMITED",
"SCL PROPERTY HOLDINGS LIMITED",
"SCL TRADELINK AND SERVICES LIMITED",
"SCLIN SOFT TECHNOLOGIES PRIVATE LIMITED",
"SCLINES SHIPPING & LOGISTICS PRIVATE LIMITED",
"SCLOUDIN SOFTWARE SOLUTIONS PRIVATE LIMITED",
"SCLOWY (EMP) PRIVATE LIMITED",
"SCM AGROTECH ENTERPRISES PRIVATE LIMITED",
"SCM CLOTHES PRIVATE LIMITED",
"SCM CONNEXIONS PRIVATE LIMITED",
"SCM ESTATES PRIVATE LIMITED",
"SCM FERTICHEM LIMITED",
"SCM GARMENTS PRIVATE LIMITED",
"SCM INTERNATIONAL IMPEX PKA INDIA PRIVATE LIMITED",
"SCM INVESTMENT & TRADING CO LTD",
"SCM MICROSYSTEMS INDIA PRIVATE LIMITED",
"SCM PLASTIC ENGINEERING PRIVATE LIMITED",
"SCM PROTECTION PRIVATE LIMITED",
"SCM SILKS PRIVATE LIMITED",
"SCM SOLAR ENERGY (OPC) PRIVATE LIMITED",
"SCM SOLUTIONS PRIVATE LIMITED",
"SCM XPRESS PRIVATE LIMITED",
"SCME PROJECTS PRIVATE LIMITED",
"SCMWORX BUSINESS SOLUTIONS PRIVATE LIMITED",
"SCMYUGA TECHNOLOGIES PRIVATE LIMITED",
"SCO TECH DISTRIBUTION INDIA PRIVATE LIMITED",
"SCOAT PHARMA PRIVATE LIMITED",
"SCOCRE RATING AGENCY AND CONSULTING PRIVATE LIMITED",
"SCOD18 NETWORKING PRIVATE LIMITED",
"SCODA TUBES LIMITED",
"SCOI LOGISTICS PRIVATE LIMITED",
"S-COM INFOVISION INTERNATIONAL LIMITED",
"SCOM TECHNOLOGIES PRIVATE LIMITED",
"SCON PROJECTS PRIVATE LIMITED",
"SCONCE GLOBAL PRIVATE LIMITED",
"S-CONVECRANES PRIVATE LIMITED",
"SCOOBEE DAY GARMENTS (INDIA) LIMITED",
"SCOOBEE PET CAGES PRIVATE LIMITED",
"SCOOBEE PET FOODS PRIVATE LIMITED",
"SCOOLA FOODS PRIVATE LIMITED",
"SCOOP BRAND HOLDINGS PRIVATE LIMITED",
"SCOOP ENERGY SOLUTIONS PRIVATE LIMITED",
"SCOOP HAPPINESS PRIVATE LIMITED",
"SCOOP INDUSTRIES PRIVATE LIMITED",
"SCOOP TECHNOLOGIES PRIVATE LIMITED",
"SCOOP WHOOP MEDIA PRIVATE LIMITED",
"SCOOPWHOOP MEDIA PRIVATE LIMITED",
"SCOOTERS INDIA LIMITED",
"SCOPE AMRA LOGISTICS INDIA PRIVATE LIMITED",
"SCOPE APPARELS PRIVATE LIMITED",
"SCOPE CHEMICALS PRIVATE LIMITED",
"SCOPE LOGISTIC SERVICES INDIA PRIVATE LIMITED",
"SCOPE MARITIME PRIVATE LIMITED",
"SCOPE MEDICAL DEVICES PRIVATE LIMITED",
"SCOPE MEDICARE PRIVATE LIMITED",
"SCOPE PROMOTERS PRIVATE LIMITED",
"SCOPE SPECIALITIES LLP",
"SCOPE T AND M PRIVATE LIMITED",
"SCOPE TESTING SERVICES PRIVATE LIMITED",
"SCORCH SOLAR ENERGY PRIVATE LIMITED",
"SCORCO HR SERVICES PRIVATE LIMITED",
"SCORE INFORMATION TECHNOLOGIES LIMITED",
"SCORE LIVELIHOOD FOUNDATION",
"SCORELINE SPORTS PRIVATE LIMITED",
"SCOREMARKS TECHNOLOGIES PRIVATE LIMITED",
"SCOREME SOLUTIONS PRIVATE LIMITED",
"SCOREPLUS ACADEMY PRIVATE LIMITED",
"SCORG INTERNATIONAL CONSULTING PRIVATE LIMITED",
"SCORIA PHARMACEUTICALS PRIVATE LIMITED",
"SCORLIB LOGISTICS PRIVATE LIMITED",
"SCORODITE STAINLESS INDIA PRIVATE LIMITED.",
"SCORP ENERGY PRIVATE LIMITED",
"SCORPIO APPLIANCES PRIVATE LIMITED",
"SCORPIO BIOSOLUTIONS PRIVATE LIMITED",
"SCORPIO CLUBS PRIVATE LIMITED",
"SCORPIO ENGINEERING BMH PRIVATE LIMITED",
"SCORPIO EVENTS MANAGEMENT PRIVATE LIMITED",
"SCORPIO FREIGHT PRIVATE LIMITED",
"SCORPIO MARINE MANAGEMENT INDIA PRIVATE LIMITED",
"SCORPIO MARITIME INDIA PRIVATE LIMITED",
"SCORPIO SHIPPING AGENCIES PRIVATE LIMITED",
"SCORPION BUILDTECH PRIVATE LIMITED",
"SCORPION CONTAINERS PRIVATE LIMITED",
"SCORPION EXPRESS PRIVATE LIMITED",
"SCORPION FASHION PRIVATE LIMITED",
"SCORPION INDUSTRIAL POLYMERS PRIVATE LIMITED",
"SCORPION INTELLECT SOLUTIONS PRIVATE LIMITED",
"SCORPION SECURITY LIMITED",
"SCORPION SUPPLY CHAIN LOGISTICS PRIVATE LIMITED",
"SCORPION WAREHOUSING PRIVATE LIMITED",
"SCORPIOS APPARELS PRIVATE. LIMITED",
"SCORPIUS TRACKERS PRIVATE LIMITED",
"SCOT DERMA PRIVATE LIMITED",
"SCOT INNOVATION WIRES AND CABLES PRIVATE. LIMITED.",
"SCOT TOTAL SECURITY SOLUTIONS PRIVATE LIMITED",
"SCOTCH 'N' WATER INNOVATIONS PRIVATE LIMITED",
"SCOTIC DESIGNS PRIVATE LIMITED",
"SCOTT EDIL ADVANCE RESEARCH LABORATORIES & EDUCATION LIMITED",
"SCOTT EDIL INFORTECH PRIVATE LIMITED",
"SCOTT EDIL PHARMACIA LIMITED",
"SCOTT ENGINEERS PRIVATE LIMITED",
"SCOTT LUMIN PRIVATE LIMITED",
"SCOTT SPORTS INDIA PRIVATE LIMITED",
"SCOTTISH HIGH INTERNATIONAL SCHOO;",
"SCOTTISH HIGH INTERNATIONAL SCHOOL",
"SCOUTERS PRIVATE LIMITED",
"SCOWARE CERAMIC PRIVATE LIMITED",
"SCR ELEKTRONIKS PRIVATE LIMITED",
"SCRABBLE DIGITAL LIMITED",
"SCRABBLE ENTERTAINMENT LIMITED",
"SCRAFT PRODUCTS PRIVATE LIMITED",
"SCRAPQ HUB PRIVATE LIMITED",
"SCRBLUE AFTERTREATMENT SOLUTIONS PRIVATE LIMITED",
"SCREATIVES SOFTWARE SERVICES PRIVATE LIMITED",
"SCREEN CHECK INDIA PRIVATE LIMITED",
"SCREEN COMMUNICATION PRIVATE LIMITED",
"SCREEN FACTS SERVICES PVT LTD",
"SCREEN FACTS SERVICES PVT. LTD.",
"SCREEN LAND PRINT (INDIA) PRIVATE LIMITED",
"SCREEN MAGIC MOBILE MEDIA PRIVATE LIMITED",
"SCREEN SCENE MEDIA ENTERTAINMENT PRIVATE LIMITED",
"SCREENAGE CONSULTANCY SERVICES PRIVATE LIMITED",
"SCREEN-MAGIC MOBILE MEDIA PRIVATE LIMITED.",
"SCREENMAX MEDIA PRIVATE LIMITED",
"SCREENOTEX ENGINEERS PRIVATE LIMITED",
"SCREEN-O-TEX INDIA PRIVATE LIMITED",
"SCREENROOT TECHNOLOGIES LIMITED",
"SCREWTECH ENGINEERING P LTD",
"SCRIBBLE DATA PRIVATE LIMITED",
"SCRIBE EMR SYSTEMS PRIVATE LIMITED",
"SCRIBETECH INDIA HEALTHCARE PRIVATE LIMITED",
"SCRIM PRODUCTS PRIVATE LIMITED",
"SCRIPBOX ADVISORS PRIVATE LIMITED",
"SCRIPBOX COM INDIA PRIVATE LIMITED",
"SCRIPS N SCROLL INDIA PRIVATE LIMITED",
"SCRIPT TO SCREEN FILMS PRIVATE LIMITED",
"SCRIPTBEES IT PRIVATE LIMITED",
"SCRIPTBYTES TECHNOLOGY SERVICES PRIVATE LIMITED",
"SCROLL MERCHANTS PVT.LTD.",
"SCRUM DIGITAL PRIVATE LIMITED",
"SCRUM SYSTEMS PRIVATE LIMITED",
"SCRY ANALYTICS INDIA PRIVATE LIMITED",
"SCS AGRO IMPEX PRIVATE LIMITED",
"SCS CONSTRUCTIONS INDIA PRIVATE LIMITED",
"SCS EDUCATION FOUNDATION",
"SCS INDUSTRIAL PRODUCT MANUFACTURING COMPANY PRIVATE LIMITED",
"SCS INFRASTRUCTURES PRIVATE LIMITED",
"SCS STEAM & CONTROL SYSTEMS PRIVATE LIMITED",
"SCS TECH INDIA PRIVATE LIMITED",
"SCSHAH & COMPANY PRIVATE LIMITED",
"SCT SMART HOME CREATORS PRIVATE LIMITED",
"SCTR'S PUNE INSTITUTE OF COMPUTER TECHNOLOGY",
"SCUBE AUTO WHEELS PRIVATE LIMITED",
"S-CUBE MASS TRANSFER PRIVATE LIMITED",
"SCUBE SCIENTIFIC SOFTWARE SOLUTIONS PRIVATE LIMITED",
"SCUBE SOFTWARE SQUARE SYSTEMS PRIVATE LIMITED",
"SCUBEELATE TECHNOLOGIES PRIVATE LIMITED",
"SCUBIC ENGINEERING PRIVATE LIMITED",
"SCUD FINLEASE LIMITED",
"SCUDDER MEMORIAL HOSPITAL",
"SCUDDS INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"SCULLY SYSTEMS INDIA PRIVATE LIMITED",
"SCULPT ENGINEERING PRIVATE LIMITED",
"SCULPTURED MINDS SOFTCOM PRIVATE LIMITED",
"SCUTONIX LIFESCIENCES PRIVATE LIMITED",
"SCV & CO LLP",
"SCYMES SERVICES PRIVATE LIMITED",
"SCYO DECISION SERVICES PRIVATE LIMITED",
"SCYTALE ALPHA PRIVATE LIMITED",
"SD BANSAL IRON & STEEL PRIVATE. LIMITED.",
"SD BIOMED INDIA PRIVATE LIMITED",
"SD BIOSENSOR HEALTHCARE PRIVATE LIMITED",
"SD CARGO PRIVATE LIMITED",
"SD DEVELOPMENT MANAGEMENT PRIVATE LIMITED",
"SD EXPRESS LOGISTICS PRIVATE LIMITED",
"SD GARMENTS PRIVATE LIMITED",
"SD GLOBAL IMPEX PRIVATE LIMITED",
"SD GLOBAL LOGISTICS INDIA PRIVATE LIMITED",
"SD GLOBAL SERVICES INDIA PRIVATE LIMITED",
"SD INFRA & MEP SERVICES PRIVATE LIMITED",
"SD INTRABUILD PRIVATE LIMITED",
"SD LIFTING EQUIPMENTS PRIVATE LIMITED",
"SD LOGITRADE INDIA PRIVATE LIMITED",
"SD MILKPRO PRIVATE LIMITED",
"SD PET PREFORMS & CAPS PRIVATE LIMITED",
"SD SIGNODIA COLLEGE OF COMMERCE AND ARTS",
"SD SOFTECH INDIA PRIVATE LIMITED",
"SD SQUARE PRIVATE LIMITED",
"SD TRADEXIM PRIVATE LIMITED",
"SD UTILITY PRIVATE LIMITED",
"SD VIEWTRIP HOLIDAY PRIVATE LIMITED",
"SDA COLLEGE OF BUSINESS STUDIES",
"SDAD TECHNOLOGY PRIVATE LIMITED",
"SDAL MART PRIVATE LIMITED",
"SDATA PLUS PLUS TECHNOLOGIES PRIVATE LIMITED",
"SDB ELECTRICALS PRIVATE LIMITED",
"SDB INFRASTRUCTURE PRIVATE LIMITED",
"SDB PACKAGING PRIVATE LIMITED",
"SDB SECURITY SERVICES PRIVATE LIMITED",
"SDB WORLDWIDE LOGISTICS PRIVATE LIMITED",
"SDC AGRO FEEDS PRIVATE LIMITED",
"SDC AGRO-VET INDIA PRIVATE LIMITED",
"SDC CLINICAL (INDIA) PRIVATE LIMITED",
"SDC MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"SDC PROPERTIES PRIVATE LIMITED",
"SDC TECHMEDIA LIMITED",
"SDCCL LOGISTICS LIMITED",
"SDCE PROJECTS PRIVATE LIMITED",
"SDDRM COMMERCIAL PRIVATE LIMITED",
"SDE ENGINEERS PRIVATE LIMITED",
"SDF BOTANICALS INDIA LLP",
"SDF CHEMICALS INDIA PRIVATE LIMITED",
"SDFC ADVISORS PRIVATE LIMITED",
"SDG LOGISTICS PARK LIMITED",
"SDG SOFTWARE INDIA PRIVATE LIMITED",
"SDG TECHNOPRINTS PRIVATE LIMITED",
"SDGM TECHNOLOGIES PRIVATE LIMITED",
"SDH SECURITY GUARDS PRIVATE LIMITED",
"SDHOLE PHARMA PRIVATE LIMITED",
"SDHR DEGREE AND PG COLLEGE",
"SDI BUSINESS SERVICES INDIA PRIVATE LIMITED",
"SDI TECHSERVICES INDIA PRIVATE LIMITED",
"SDJ AGRO FOOD PRIVATE LIMITED",
"SDJ ISPAT PRIVATE LIMITED",
"SDKP DESIGN TECHNOLOGIES PRIVATE LIMITED",
"SDL & LRO SERAMPORE GOVERNMENT OF WEST BENGAL",
"SDL MULTILINGUAL SOLUTIONS PRIVATE LIMITED",
"SDL REAL ESTATES PRIVATE LIMITED",
"SDL TECHNOLOGIES INDIA PRIVATE LIMITED",
"SDLG RADIANT PRIVATE LIMITED",
"SDLS LOGISTICS PRIVATE LIMITED",
"SDM COLLEGE OF AYURVEDA AND HOSPITAL",
"SDM COLLEGE OF MEDICAL SCIENCE AND HOSPITAL",
"SDM DENTAL COLLEGE & HOSPITAL",
"SDM ELECTRIC PRODUCTS PRIVATE LIMITED",
"SDM ENGEENERING COLLEGE",
"SDM MANGALAJYOTHI ITI",
"SDM MEDICAL COLLEGE & HOSPITAL",
"SDM PROCESS SOLUTIONS PRIVATE LIMITED",
"SDM PROJECTS PRIVATE LIMITED",
"SDM STEELS PRIVATE LIMITED",
"SDM VENTURES PRIVATE LIMITED",
"SDMC PRIMARY SCHOOL - SOUTH DELHI MUNICIPAL CORP",
"SDMVMS COLLEGE OF AGRICULTURE",
"SDNA GLOBAL",
"SDNB VAISHNAV COLLEGE FOR WOMEN",
"SDNMKJ REALTY PRIVATE LIMITED",
"SDOD TECHNOLOGIES PRIVATE LIMITED",
"SDP BIOPHARMA PRIVATE LIMITED",
"SDP INDUSTRIES PRIVATE LIMITED",
"SDP SCHOOL FOUNDATION",
"SDPC WOMEN S WELFARE SOCIETY",
"SDPS WOMEN‚ÄôS WELFARE SOCIETY",
"SDPT FIRST GRADE COLLEGE KATEEL",
"SDR AUTO PRIVATE LIMITED",
"SDR CLOTHING COMPANY PRIVATE LIMITED",
"SDR MANAGEMENT FACILITY AND SERVICES PRIVATE LIMITED",
"SDR PACKAGING INNOVATIONS PRIVATE LIMITED",
"SDR POLYMERS PRIVATE LIMITED",
"SDR SECURITIES PRIVATE LIMITED",
"SDRA FOODS AND SPICES PRIVATE LIMITED",
"SDRSA APPLIANCES PRIVATE LIMITED",
"SDS AGRO FARMS PRIVATE LIMITED",
"SDS AUTOTECH INDIA PRIVATE LIMITED",
"SDS CARGO SOLUTIONS PRIVATE LIMITED",
"SDS CLOTHING INDIA PRIVATE LIMITED",
"SDS ELECTROINICS PVT LTD",
"SDS FABRIQUES GALORE PRIVATE LIMITED",
"SDS FOREX SERVICES PRIVATE LIMITED",
"SDS FRAGRANCE PRIVATE LIMITED",
"SDS FREIGHT MANAGEMENT PRIVATE LIMITED",
"SDS HEALTHCARE & IMAGING PRIVATE.LIMITED",
"SDS INFRATECH PRIVATE LIMITED",
"SDS IT SOLUTIONS PRIVATE LIMITED",
"SDS LIFE SCIENCES PRIVATE LIMITED",
"SDS REALTORS PRIVATE LIMITED",
"SDS SECURITY PRIVATE LIMITED",
"SDS SOLAR PRIVATE. LIMITED.",
"SDS TUBERCULOSIS RESEARCH CENTER & RAJIV GANDHI INSTITUTE OF CHEST DISEASES",
"SDSS STAFFING SOLUTIONS PRIVATE LIMITED",
"SDT ULTRASOUND SOLUTIONS INDIA PRIVATE LIMITED",
"SDTC LOGISTICS PRIVATE LIMITED",
"SDTRONICS PRIVATE LIMITED",
"SDU BEVERAGES PRIVATE LIMITED",
"SDU TRAVELS PRIVATE LIMITED",
"SDU WINERY PRIVATE LIMITED",
"SDVS INDIA PRIVATE LIMITED",
"SE AEROSPACE-ONE PRIVATE LIMITED",
"SE CONTROLS INDIA PRIVATE LIMITED",
"SE COOPERMATICS FILTRATION SYSTEMS INDIA PRIVATE LIMITED",
"SE ENERGY AND ENVIRO PRIVATE LIMITED",
"SE ENTERPRISES PRIVATE LIMITED",
"SE FINVEST PRIVATE LIMITED",
"SE FORGE LIMITED",
"SE FREIGHT AND LOGISTICS INDIA PRIVATE LIMITED",
"SE MENTOR SOLUTIONS PRIVATE LIMITED",
"SE WAREHOUSING AND LOGISTICS PRIVATE LIMITED",
"ZINNIA DIGITAL SERVICE LLP",
"SEA AIR CLEARING PRIVATE LIMITED",
"SEA BIRD MEDICARE PRIVATE LIMITED",
"SEA BIRD REFRIGERATION PRIVATE LIMITED",
"SEA BIZZ LOGISTICS PRIVATE LIMITED",
"SEA BLUE SHIPYARD LIMITED",
"SEA BREEZE MARINE ENGINEERS AND CONSULATANTS PRIVATE LIMITED",
"SEA CARGO INTERNATIONAL PRIVATE LIMITED",
"SEA CARGO LOGISTICS (INDIA) PRIVATE LIMITED",
"SEA CONSORTIUM SHIPPING (INDIA) PRIVATE LIMITED",
"SEA CUBE LOGISTICS PRIVATE LIMITED",
"SEA DOGS PRIVATE LIMITED",
"SEA FABRICS PRIVATE LIMITED",
"SEA FOOD EXPORTERS ASSOCIATION OF INDIA",
"SEA FOODS PVT. LTD.",
"SEA FREIGHT SHIPPING AND LOGISTICS PRIVATE LIMITED",
"SEA FUNDS MANAGEMENT INDIA PRIVATE LIMITED",
"SEA GATE FACILITY MANAGEMENT PRIVATE LIMITED",
"SEA GEO SURVEYS PRIVATE LIMITED",
"SEA GLIDER CONTAINER LINES PRIVATE LIMITED",
"SEA HAWK ENTERPRISES PRIVATE LIMITED",
"SEA HAWK LINES PRIVATE LIMITED",
"SEA HAWK RESORTS PRIVATE LIMITED",
"SEA HAWK TOUR AND TRAVELS PRIVATE LIMITED",
"SEA HAWK TRAVELS PRIVATE LIMITED",
"SEA HORSE MARINE LLP",
"SEA HYDROPOWER MANUFACTURIING PRIVATE LIMITED",
"SEA HYDROSYSTEMS INDIA PRIVATE LIMITED",
"SEA LAGOON HOTELS PRIVATE LIMITED",
"SEA LAND MARINES PVT LTD",
"SEA LAND SUPPLY CHAIN SERVICES PRIVATE LIMITED",
"SEA LINKERS PRIVATE LIMITED",
"SEA LLOYD SHIPPING LINES PRIVATE LIMITED",
"SEA LORD CONTAINERS LIMITED",
"SEA LORD LOGISTICS PRIVATE LIMITED",
"SEA MARINE SURVEYORS AND ASSESSORS I PRIVATE LIMITED",
"SEA MERIDIAN SHIPPING AGENCY PRIVATE LIMITED",
"SEA PARK HATCHERIES PRIVATE LIMITED",
"SEA PORT SERVICES PRIVATE LIMITED",
"SEA PRINT MEDIA AND PUBLICATION LIMITED",
"SEA PRODUCTS INDIA PRIVATE LIMITED",
"SEA QUEEN LOGISTICS PRIVATE LIMITED",
"SEA RANGE COMPONENTS PRIVATE LIMITED",
"SEA ROYAL SHIP MANAGEMENT PRIVATE LIMITED",
"SEA SHELTER CARRIERS PRIVATE LIMITED",
"SEA SHELTER WAREHOUSE PRIVATE LIMITED",
"SEA SHINE LOGISTICS PRIVATE LIMITED",
"SEA SHINE SHIPPING SERVICES PRIVATE LIMITED",
"SEA SILVER HEALTHCARE PRIVATE LIMITED",
"SEA SKY EXPORTS PRIVATE LIMITED",
"SEA SOM CARBON PRIVATE LIMITED",
"SEA SPARKLE HARBOUR SERVICES LIMITED",
"SEA SPECIAL PRIVATE LIMITED",
"SEA SPEED CHA SERVICES PRIVATE LIMITED",
"SEA SQUARE PRIVATE LIMITED",
"SEA STARS CONSULTING",
"SEA SYST ENGINEERING (INDIA ) PRIVATE LIMITED",
"SEA TRADE SHIPPING (INDIA ) PRIVATE LIMITED",
"SEA TV NETWORK LIMITED",
"SEA WAGON SERVICES PRIVATE LIMITED",
"SEA WIND REALTORS INDIA PRIVATE LIMITED",
"SEAA PACKAGING PRIVATE LIMITED",
"SEA-AIR LOGISTICS INDIA PRIVATE LIMITED",
"SEAANT WEB TECHNOLOGIES PRIVATE LIMITED",
"SEAARA UNIVERSAL PRIVATE LIMITED",
"SEABASE TRADING PRIVATE LIMITED",
"SEABERRY FOODS PRIVATE LIMITED",
"SEABERT CHEMICALS PRIVATE LIMITED",
"SEABERT LIFE SCIENCE",
"SEABIRD DISTRIPARKS (KRISHNAPATNAM) LIMITED",
"SEABIRD LOGISOLUTIONS LIMITED",
"SEABIRD MARINE SERVICES GUJARAT PRIVATE LIMITED",
"SEABIRD MARINE SERVICES PRIVATE LIMITED",
"SEABIRD PLY DECOR PVT LTD",
"SEABIRD RESORTS PRIVATE LIMITED",
"SEABOARD CORPORATION",
"SEABORNE MARITIME INDIA PRIVATE LIMITED",
"SEABOURNE GLOBAL LOGISTICS PRIVATE LIMITED",
"SEABOY FISHERIES PRIVATE LIMITED",
"SEABREEZE SPIRITS PRIVATE LIMITED",
"SEABRIDGE MARINE AGENCIES PRIVATE LIMITED",
"SEABRIDGE STEVEDORES PRIVATE LIMITED",
"SEABRIDGE TERMINALS PRIVATE LIMITED",
"SEABRIN LOGISTICS PRIVATE LIMITED",
"SEACAMP SHIPPING AGENCY PRIVATE LIMITED",
"SEACHANGE INDIA PRIVATE LIMITED",
"SEACHEM LABORATORIES (I) PRIVATE LIMITED",
"SEACO OPERATIONS INDIA PRIVATE LIMITED",
"SEACOAST SHIPPING SERVICES LIMITED",
"SEACON ENERGY & BIOTECH LIMITED",
"SEACONVERT PRIVATE LIMITED",
"SEACREST MARINE SERVICES PRIVATE LIMITED",
"SEAD ADVERTISING PRIVATE LIMITED",
"SEADRILL INTERNATIONAL RESOURCING DMCC",
"SEAFARER STEVEDORING PRIVATE LIMITED",
"SEAFOLK DIVING CONTRACTORS & ENGINEERING SERVICES PRIVATE LIMITED",
"SEAFOOD JOY PRIVATE LIMITED",
"SEAFOOD PARK INDIA LIMITED",
"SEAFRESH EXPORTS LIMITED",
"SEAGA INDIA PRIVATE LIMITED",
"SEAGATE LOGISTICS TRANSPORTATION PRIVATE LIMITED",
"SEAGATE SPECIALITY PRODUCTS PRIVATE LIMITED",
"SEAGATE TECHNOLOGY HDD (INDIA) PRIVATE LIMITED",
"SEAGEAR MARINE SUPPLIES PRIVATE LIMITED",
"SEAGLOBE LOGISTICS PRIVATE LIMITED",
"SEAGLOBE SHIPPING AGENCY PRIVATE LIMITED",
"SEAGOLD OVERSEAS PRIVATE LIMITED",
"SEAGREEN STEVEDORING AND LOGISTICS PRIVATE LIMITED",
"SEAGRO EXPORTS PRIVATE LIMITED",
"SEAGULL CHEMICALS PRIVATE LIMITED",
"SEAGULL CLEARING & FORWARDING AGENCIES PRIVATE LIMITED",
"SEAGULL COOLING PRIVATE LIMITED",
"SEAGULL INDUSTRIAL ADHESIVES PRIVATE LIMITED",
"SEAGULL INFRACON PRIVATE LIMITED",
"SEAGULL INTERNATIONAL",
"SEAGULL LABORATORIES INDIA PRIVATE LIMITED",
"SEAGULL MARITIME AGENCIES PRIVATE LIMITED",
"SEAGULL PHARMACEUTICALS PRIVATE LIMITED",
"SEAGULL PUBLISHERS PRIVATE. LIMITED",
"SEAGULL PYROTECHNICS PRIVATE LIMITED",
"SEAGULL SANITARYWARES PRIVATE LIMITED",
"SEAGULL SYNTHETICS PVT. LTD",
"SEAH GLOBAL INDIA PRIVATE LIMITED",
"SEAHAUL LINES (INDIA) PRIVATE LIMITED",
"SEAHAWK AGRO PRIVATE LIMITED",
"SEAHAWK LOGISTICS PRIVATE LIMITED",
"SEAHAWK WEB SERVICES PRIVATE LIMITED",
"SEAHORSE PHARMA PRIVATE LIMITED",
"SEAHORSE SHIP AGENCIES PRIVATE LIMITED",
"SEAHORSE SHIPPING AND LOGISTICS PRIVATE LIMITED",
"SEAIKON SHIPPING AGENCY PRIVATE LIMITED",
"SEAIMPEX LOGISTICS PRIVATE LIMITED",
"SEAIR GLOBAL PRIVATE LIMITED",
"SEAJULI DEVELOPERS & FINANCE LTD.",
"SEAKING CATERERS PRIVATE LIMITED",
"SEAKING LOGISTICS & SHIPPING AGENCIES PRIVATE LIMITED",
"SEAKING SHIPPING AND CONTAINER TRANSPORT CO P LTD",
"SEAL FOR LIFE INDIA PRIVATE LIMITED",
"SEAL FREIGHT FORWARDERS PRIVATE LIMITED",
"SEAL INDUSTRIES INDIA PRIVATE LIMITED",
"SEAL INFOTECH PRIVATE LIMITED",
"SEAL NETS PRIVATE LIMITED",
"SEAL TEA EXPORTS PRIVATE LIMITED",
"SEAL X TECHNOLOGIES PRIVATE LIMITED",
"SEALAIR FREIGHTERS INTERNATIONAL PRIVATE LIMITED",
"SEALAND CRANE PRIVATE LIMITED",
"SEALAND DIESEL PRIVATE LIMITED",
"SEALAND INFRASTRUCTURE PRIVATE LIMITED",
"SEALAND LOGISTICS & SHIPPING SERVICES PRIVATE LIMITED",
"SEALAND LOGISTICS INDIA SERVICES PRIVATE LIMITED",
"SEALAND PROJECTS PRIVATE LIMITED",
"SEALANT AND GASKET (INDIA) PRIVATE LIMITED",
"SEALCRAFT SEALING SOLUTIONS INDIA PRIVATE LIMITED",
"SEALDAH FOREX PRIVATE LIMITED",
"SEALED AIR PACKAGING MATERLAS INDIA LLP",
"SEALEXCEL INDIA PVT LTD",
"SEALINE FORWARDERS PRIVATE LIMITED",
"SEALINE SHIPPING AND LOGISTICS PRIVATE LIMITED",
"SEALINK ADVENTURES INDIA PRIVATE LIMITED",
"SEALINK CLEARING FORWARDING PRIVATE LIMITED",
"SEALINK FASHION PRIVATE LIMITED",
"SEALION AUTOMOBILES PRIVATE LIMITED",
"SEALMATIC INDIA LIMITED",
"SEALTITE DICHTUNGS PRIVATE LIMITED",
"SEALWEL CORPORATION PRIVATE. LIMITED.",
"SEALWELL ENGINEERING PRIVATE LIMITED",
"SEAL-WELL PRIVATE LIMITED",
"SEALWELL SYSTEMS PRIVATE LIMITED",
"SEALY INDIA TRADING PRIVATE LIMITED",
"SEAMAC INDIA PHARMACEUTICALS PRIVATE LIMITED",
"SEAMAN LOGISTICS SOLUTIONS PRIVATE LIMITED",
"SEAMAN MULTI TRADING PRIVATE LIMITED",
"SEAMARINE LOGISTICS PRIVATE LIMITED",
"SEAMARK BIO-ORGANIC PRIVATE LIMITED",
"SEAMAX GLOBAL FORWARDING PRIVATE LIMITED",
"SEAMAX LOGISTICS LIMITED",
"SEAMAX SHIPPING INDIA PRIVATE LIMITED",
"SEAMEC LIMITED",
"SEAMEX",
"SEAMLESS AUTOTECH PRIVATE LIMITED",
"SEAMLESS COMMUNICATION SYSTEMS PRIVATE LIMITED",
"SEAMLESS CONCRETE PRIVATE LIMITED",
"SEAMLESS EDUCATION ACADEMY PRIVATE LIMITED",
"SEAMLESS EDUCATION AND SERVICES PRIVATE LIMITED",
"SEAMLESS FABRICS PRIVATE LIMITED",
"SEAMLESS INFOTECH PRIVATE LIMITED",
"SEAMLESS PRIVATE LIMITED",
"SEAMORAT SHIPPING PRIVATE LIMITED",
"SEAMOVATION LABS PRIVATE LIMITED",
"SEAMTEK INTERNATIONAL PRIVATE LIMITED",
"SEANS MEDIA PRIVATE LIMITED",
"SEANTO MINERALS AND ENERGY LIMITED",
"SEAON ADHESIVE TAPES PRIVATE LIMITED",
"SEAP SOLUTIONS PRIVATE LIMITED",
"SEAPEARL FACILITIES MANAGEMENT SERVICES PRIVATE LIMITED",
"SEAPLAST (INDIA) PRIVATE LIMITED",
"SEAPOL PORT PRIVATE LIMITED",
"SEAPORT CARGO LOGISTICS PRIVATE LIMITED",
"SEAPORT LINES (INDIA) PRIVATE LIMITED",
"SEAPORT LOGISTICS PRIVATE LIMITED",
"SEAPORT SHIPPING PRIVATE LIMITED",
"SEAPRIDE MANAGEMENT AND CONSULTING SERVICES PRIVATE LIMITED",
"SEAPRINCESS HOTELS AND PROPERTIES PRIVATE LIMITED",
"SEAPRO SHIPPING PRIVATE LIMITED",
"SEARCE COSOURCING SERVICE PRIVATE LIMITED",
"SEARCE LOGISTICS ANALYTICS LLP",
"SEARCH & SELL INDIA PRIVATE LIMITED",
"SEARCH AGENCY PERFORMANCE MARKETING INDIA PRIVATE LIMITED",
"SEARCH AND CORDON SECURITY PRIVATE LIMITED",
"SEARCH ENGINE TRADE LINKS PRIVATE LIMITED",
"SEARCH HOMES INDIA PRIVATE LIMITED",
"SEARCH N SCORE SOLUTIONS PRIVATE LIMITED",
"SEARCH PHARMA PRIVATE LIMITED",
"SEARCH PLUS",
"SEARCH QUEST CONSULTANTS PRIVATE LIMITED",
"SEARCH RESULTS IT SOLUTIONS PRIVATE LIMITED",
"SEARCH VALUE CONSULTANTS PRIVATE LIMITED",
"SEARCH VALUE ITES PRIVATE. LIMITED",
"SEARCHBOURNE CONSULTING PRIVATE LIMITED",
"SEARCHLIGHT HEALTH PRIVATE LIMITED",
"SEARCHNATIVE INDIA PRIVATE LIMITED",
"SEARCHSTAX INDIA PRIVATE LIMITED",
"SEAREX MARINE INDIA PRIVATE LIMITED",
"SEAROCK DEVELOPERS PRIVATE LIMITED",
"SEAROCK GRANITES PRIVATE LIMITED",
"SEAROCK METAL & ALLOY PRIVATE LIMITED",
"SEAROCK PRECISION PRODUCTS PRIVATE LIMITED",
"SEAROCK RESORTS PVT LTD",
"SEAROCK SALT PRIVATE LIMITED",
"SEAROUTE LOGISTICS PRIVATE LIMITED",
"SEAROUTERS SHIPPING PRIVATE LIMITED",
"SEARS GLOBAL TECHNOLOGIES INDIA PRIVATE LIMITED",
"SEARS IT AND MANAGEMENT SERVICES INDIA PRIVATE LIMITED",
"SEARS SOURCING INDIA PRIVATE LIMITED",
"SEASAGA ENTERPRISES PRIVATE LIMITED",
"SEASCAPE SHIPPING AGENCY INDIA PRIVATE LIMITED",
"SEASCAPE SHIPPING LOGISTICS PRIVATE LIMITED",
"SEASCOPE IMPEX PRIVATE LIMITED",
"SEASCOPE PULP AND PAPERS PRIVATE LIMITED",
"SEASHELL BIOSCIENCES PRIVATE LIMITED",
"SEA-SHELL CHEMICALS PRIVATE LIMITED",
"SEASHELL HOLDINGS PRIVATE LIMITED",
"SEASHELL LOGISTICS PRIVATE LIMITED",
"SEASHELL NETWORKING PRIVATE LIMITED",
"SEASHIP LOGISTICS PRIVATE LIMITED",
"SEASHORE MARITIME ACADEMY PRIVATE LIMITED",
"SEASHORE REALTORS PRIVATE LIMITED",
"SEASIA INFOTECH PRIVATE LIMITED",
"SEASKILLS MARITIME ACADEMY",
"SEASKY EXIM PRIVATE LIMITED",
"SEA-SKY MARINE PRIVATE LIMITED",
"SEASKY SHIPPING INDIA PRIVATE LIMITED",
"SEASKY WORLDWIDE LOGISTICS PRIVATE LIMITED",
"SEASON CONTROL PRIVATE LIMITED",
"SEASON CROP CARE PRIVATE LIMITED",
"SEASON RUBBERS PRIVATE LIMITED",
"SEASONS APPARELS PRIVATE LIMITED",
"SEASONS CATERING SERVICES PRIVATE LIMITED",
"SEASONS ENERGY PRIVATE LIMITED",
"SEASONS ENTERPRISES PRIVATE LIMITED",
"SEASONS FURNISHINGS LIMITED",
"SEASONS GOURMET HOSPITALITY SERVICES",
"SEASONS HEALTHCARE LIMITED",
"SEASONS HOTELS PRIVATE LIMITED",
"SEASONS INTERNATIONAL PRIVATE LIMITED",
"SEASONS MEDICARE PRIVATE LIMITED",
"SEASONS TEXTILES LIMITED",
"SEASONS TEXTILES LIMITED.",
"SEASOUL COSMECEUTICALS PRIVATE LIMITED",
"SEASPAN CREW MANAGEMENT INDIA PRIVATE LIMITED",
"SEASSPEED CONTAINER LINES PRIVATE LIMITED",
"SEASTAR & AMBA SHIPPING PRIVATE LIMITED",
"SEASTAR GLOBAL LOGISTICS PRIVATE LIMITED",
"SEASURE SHIPPING AND LOGISTICS PRIVATE LIMITED",
"SEASWAN MARINE SERVICES PRIVATE LIMITED",
"SEATAAL PROPERTIES PRIVATE LIMITED",
"SEATECH INTEGRATED TECHNOLOGY PRIVATE LIMITED",
"SEATECH MARINE SURVEYORS AND CONSULTANTS PRIVATE LIMITED",
"SEATECH SHIPPING & PROJECTS (I) PRIVATE LIMITED",
"SEATING SOLUTIONS INDIA PRIVATE LIMITED",
"SEATING WORLD INDIA PRIVATE LIMITED",
"SEATOMAN HOLDINGS LIMITED",
"SEATRACK INTERNATIONAL TRADEX PRIVATE LIMITED",
"SEATRACK LOGISTICS SOLUTIONS PRIVATE LIMITED",
"SEATRADE MARITIME PRIVATE LIMITED",
"SEATRANS AGENCIES PRIVATE LIMITED",
"SEATRANS FREIGHT CARRIERS PRIVATE LIMITED",
"SEATRANS MARINE PRIVATE LIMITED",
"SEATRANS MOVERS PRIVATE LIMITED",
"SEATRANS SHIPMANAGEMENT SERVICES PRIVATE LIMITED",
"SEATRANS SHIPPING LIMITED",
"SEAVANTEK SHIPPING SERVICES PRIVATE LIMITED",
"SEAVIEW DEVELOPERS PRIVATE LIMITED",
"SEAVIEW SUPPORT SYSTEMS PRIVATE LIMITED",
"SEAVISION MARITIME PRIVATE LIMITED",
"SEAWARD EXPORTS PRIVATE LIMITED",
"SEAWARD PACKAGING LIMITED",
"SEAWAVE FORWARDING AND LOGISTICS PRIVATE LIMITED",
"SEAWAVES LOGISTICS PRIVATE LIMITED",
"SEAWAYS CONTAINER LINE PRIVATE LIMITED",
"SEAWAYS LINER AGENCIES PRIVATE LIMITED",
"SEAWAYS SHIPPING AND LOGISTICS LIMITED",
"SEAWAYS SUPPLY CHAIN PRIVATE LIMITED",
"SEAWEG ENTERPRISES I PRIVATE LIMITED",
"SEAWELL ENTERPRISES PRIVATE LIMITED",
"SEAWEST SHIPPING PRIVATE LIMITED",
"SEAWOODS ESTATES LIMITED",
"SEAWORLD SHIPPING AND LOGISTICS PRIVATE LIMITED",
"SEAWORTH AQUA PRODUCTS PVT LTD",
"SEAWORTHY PACK-TECH PRIVATE LIMITED",
"SEAWORTHY PROTECTIVE PACKAGING PRIVATE LIMITED",
"SEAXPERT LINES LIMITED LIABILITY PARTNERSHIP",
"SEAZONE FROZEN FOODS PRIVATE LIMITED",
"SEAZONE GRANITO PRIVATE LIMITED",
"SEBA ENGINEERS PRIVATE LIMITED",
"SEBA HOSPITAL SALTLAKE",
"SEBABRATA SUPER SPECIALIST HOSPITAL & DIAGNOSTIC CENTRE PRIVATE LIMITED",
"SEBACIC INDIA LIMITED",
"SEBAYAN NURSING SERVICES PRIVATE LIMITED",
"SEBCO PROPERTY PRIVATE LIMITED",
"SEBEINGS FACILITY MANAGEMENT PRIVATE LIMITED",
"SEBI",
"SEBIA DIAGNOSTICS INDIA PRIVATE LIMITED",
"SEBLE TOOLS AND ALLIED INDUSTRIES PRIVATE LTD",
"SEBROF INTERNATIONAL PRIVATE LIMITED",
"SEBROS AUTO PRIVATE LIMITED",
"SEBROS ENGINEERING SOLUTIONS PRIVATE LIMITED",
"SEBROS INDUSTRIES PRIVATE LIMITED",
"SEBROS STEELS PRIVATE LIMITED",
"SEC BUILDTECH PRIVATE LIMITED",
"SEC COMMUNICATIONS PRIVATE LIMITED",
"SEC INDUSTRIES PRIVATE LIMITED",
"SEC INFORMATION INDIA PRIVATE LIMITED",
"SECALT INDIA PRIVATE LIMITED",
"SECAN INVESCAST INDIA PRIVATE LIMITED",
"SECANT CONSTRUCTION PRIVATE LIMITED",
"SECANT INFRASTRUCTURE PRIVATE LIMITED",
"SECHERON HASLER (INDIA) PRIVATE LIMITED",
"SECURITYHQ INDIA PRIVATE LIMITED",
"SECLIVIC PRIVATE LIMITED",
"SECLORE TECHNOLOGY PRIVATE LIMITED",
"SECLOTHTEX IMPEX (OPC) PRIVATE LIMITED",
"SECMARK CONSULTANCY LIMITED",
"SECMEC CONSULTANTS PRIVATE LIMITED",
"SECO CONTROLS PRIVATE LIMITED",
"SECO MACHINES PRIVATE LIMITED",
"SECO TOOLS INDIA PRIVATE LIMITED",
"SECO WARWICK ALLIED PRIVATE LIMITED",
"SECO WARWICK SYSTEMS & SERVICES (INDIA) PRIVATE LIMITED",
"SECOM SERVICES INDIA PRIVATE LIMITED",
"SECON PRIVATE LIMITED",
"SECONCLOUD IT SERVICES PRIVATE LIMITED",
"SECOND MACHINE AGE CONSULTANCY SERVICES PRIVATE LIMITED",
"SECOND OPINION SUPPORT SERVICES PRIVATE LIMITED",
"SECOND VIVEKANANDA BRIDGE TOLLWAY COMPANY PRIVATE LIMITED",
"SECONDARY LOAN MARKET ASSOCIATION",
"SECONDARY SCHOOL & JR COLLEGE BHILAWADI",
"SEC-ONE SALES & MARKETING PRIVATE LIMITED",
"SECOTE PRIVATE LIMITED",
"SECOVA ESERVICES PRIVATE LIMITED",
"SECPOD TECHNOLOGIES PRIVATE LIMITED",
"SECR BILASPUR DIVISION",
"SECRETARIAT ADMINISTRATION ASSAM SECRETARIAT GOVT OF ASSAM",
"SECRETARY CHHATTISGARH RAJBHASHA COMMISSION SHAHID SMARAK PARISHAR",
"SECRETARY PUBLIC SERVICE COMMISSION",
"SECRETARY STATE ELECTION COMMISION LKO",
"SECRETARY,F.A.& CAO KHADI BOARD",
"SEC-RJMT ENGINEERING PRIVATE LIMITED",
"SECTECH PRIVATE LIMITED",
"SECTION OFFICER D G FACTORY ADVICE SERVICE AND LABOUR INSTITUTE CTI BUILDING BOMBAY",
"SECTONA TECHNOLOGIES PRIVATE LIMITED",
"SECTOR 113 GATEVIDA DEVELOPERS PRIVATE LIMITED",
"SECTORSEVEN E4E TECHNOLOGIES PRIVATE LIMITED",
"SECUDE SOLUTIONS INDIA PRIVATE LIMITED",
"SECUERA TECHNO SOLUTIONS INDIA PRIVATE LIMITED",
"SECUGEN INDIA PRIVATE LIMITED",
"SECUMART INDIA PRIVATE LIMITED",
"SECUNDERABAD CANTONMENT BOARD",
"SECUNDERABAD FOOD PRODUCTS PRIVATE LIMITED",
"SECUNDERABAD GST COMMISSIONERATE",
"SECUNDERABAD HOTELS PRIVATE. LIMITED.",
"SECUNDERABAD NETWORK PRIVATE LIMITED",
"SECUNDERABAD PRINTED CARTONS LIMITED",
"SECUR CREDENTIALS LIMITED",
"SECURA FACILITY MANAGEMENT PRIVATE LIMITED",
"SECURA INFRASERVICES PRIVATE LIMITED",
"SECURAFENCE SECURITY PRIVATE LIMITED",
"SECURAMAX VALVES AND CONTROL SYSTEMS PRIVATE LIMITED",
"SECURAPLUS SAFETY PRIVATE LIMITED",
"SECURASHIELD INDIA PRIVATE LIMITED",
"SECURAX TECH SOLUTIONS INDIA PRIVATE LIMITED",
"SECURE 24 IT SERVICES PRIVATE LIMITED",
"SECURE CONNECTION PRIVATE LIMITED",
"SECURE DEBT MANAGEMENT CONSULTANTS LLP",
"SECURE DEBT MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"SECURE DIAGNOSTICS PRIVATE LIMITED",
"SECURE ELECTRICAL TRADING COMPANY PRIVATE LIMITED",
"SECURE FOREX PRIVATE LIMITED",
"SECURE HOSPITAL",
"SECURE INDUSTRIES PRIVATE LIMITED",
"SECURE INFO PRIVATE LIMITED",
"SECURE INFRATECH FINSERV AND SECURITIES LIMITED",
"SECURE INGRESS PRIVATE LIMITED",
"SECURE INTELLIGENCE PRIVATE SERVICES",
"SECURE- IT FACILITY MANAGEMENT PRIVATE LIMITED",
"SECURE LEARNING PRIVATE LIMITED",
"SECURE LOGISTICS SOLUTIONS PRIVATE LIMITED",
"SECURE MEDIA & ENTERTAINMENT CONSULTANCY MANAGEMENT PRIVATE LIMITED",
"SECURE MEDICAL DEVICES PRIVATE LIMITED",
"SECURE METERING & SERVICES (BHILWARA) PRIVATE LIMITED",
"SECURE METERS LIMITED",
"SECURE NETWORK SOLUTIONS INDIA PRIVATE LIMITED",
"SECURE OFFSET PRIVATE LIMITED",
"SECURE ONE PROPERTY MANAGEMENT PRIVATE LIMITED",
"SECURE PACKAGING PRIVATE LIMITED",
"SECURE PARKING SOLUTIONS PRIVATE LIMITED",
"SECURE PC SOLUTIONS ONLINE PRIVATE LIMITED",
"SECURE POLYMERS PRIVATE LIMITED",
"SECURE POWER INDIA PRIVATE LIMITED",
"SECURE PRINT SOLUTIONS PRIVATE LIMITED",
"SECURE QUICK FINANCIAL SERVICES PRIVATE LIMITED",
"SECURE SEALS (INDIA) PRIVATE LIMITED",
"SECURE SECURITY SERVICES",
"SECURE SECURITY SOLUTIONS SERVICES",
"SECURE SOLUTIONS PRIVATE LIMITED",
"SECURE SOURCE TECHNOLOGIES PRIVATE LIMITED",
"SECURE TECHNOPACK PRIVATE LIMITED",
"SECURE VALUE INDIA LIMITED",
"SECURE WRAP INDIA PRIVATE LIMITED",
"SECURE-24 IT SERVICES PRIVATE LIMITED",
"SECURED ENGINEERS PRIVATE LIMITED",
"SECURED PRIME ESTATES PRIVATE LIMITED",
"SECURED SECURITY SOLUTIONS PRIVATE LIMITED",
"SECURED SERVICE AGENCY PRIVATE LIMITED",
"SECUREFIN SERVICES PRIVATE LIMITED",
"SECUREINTELI TECHNOLOGIES PRIVATE LIMITED",
"SECUREKLOUD TECHNOLOGIES LIMITED",
"SECURELAYER7 TECHNOLOGIES PRIVATE LIMITED",
"SECURELYNKX RFID NETWORK PRIVATE LIMITED",
"SECURELYSHARE SOFTWARE PRIVATE LIMITED",
"SECUREMATE SURVEILLANCE SYSTEMS PRIVATE LIMITED",
"SECUREMENT PACKAGING PRIVATE LIMITED",
"SECURENDS SOFTWARE PRIVATE LIMITED",
"SECURENET CABLES & CONNECTORS PRIVATE LIMITED",
"SECURENEXT SOFTWARES PRIVATE LIMITED",
"SECURENOW INSURANCE BROKER PRIVATE LIMITED",
"SECURENOW TECHSERVICES PRIVATE LIMITED",
"SECURENS SYSTEMS PRIVATE LIMITED",
"SECURESEARCH SCREENING SERVICES PRIVATE LIMITED",
"SECURESHIELD SECURITY SERVICES PRIVATE LIMITED",
"SECURETRANS IMPEX PRIVATE LIMITED",
"SECUREVALUE INDIA LIMITED",
"SECUREW2 INDIA PRIVATE LIMITED",
"SECUREWAYS LOGISTICS PRIVATE LIMITED",
"SECUREWORKS INDIA PRIVATE LIMITED",
"SECUREX LOGISTICS PRIVATE LIMITED",
"SECUREYES TECHNO SERVICES PRIVATE LIMITED",
"SECUREZAPP INDIA PRIVATE LIMITED",
"SECUREZONE INDIA PRIVATE LIMITED",
"SECURIAN SERVICES INDIA PRIVATE LIMITED",
"SECURICO ELECTRONICS INDIA LIMITED",
"SECURICO SYSTEMS PRIVATE LIMITED",
"SECURIFI EMBEDDED SYSTEMS INDIA PRIVATE LIMITED",
"SECURIPAX PACKAGING PRIVATE LIMITED",
"SECURISK INSURANCE BROKERS PRIVATE LIMITED",
"SECURITECH SEVEN PRIVATE LIMITED",
"SECURITI SCIENCES PRIVATE LIMITED",
"SECURITIES & EXCHANGE BOARD OF INDIA",
"SECURITIES AND EXCHANGE BOARD OF INDIA",
"SECURITIES INVESTMENT MANAGEMENT PRIVATE LIMITED",
"SECURITIES TRADING CORPN OF INDIA",
"SECURITOUCH INTELLIGENCE PRIVATE LIMITED",
"SECURITRANS INDIA PRIVATE LIMITED",
"SECURITY AND DETECTIVE SERVICES PRIVATE LIMITED",
"SECURITY AND PERSONNEL SERVICES PRIVATE LIMITED",
"SECURITY BRIGADE INFOSEC PRIVATE LIMITED",
"SECURITY CO LTD",
"SECURITY ENGINEERS PRIVATE LIMITED",
"SECURITY GAURDS BOARDS FOR BRIHAN MUMBAI & THANE DISTRICT",
"SECURITY GUARDS BOARD FOR BRIHAN MUMBAI AND THANE DISTRICT",
"SECURITY HI TECH GRAPHICS PVT LTD",
"SECURITY INNOVATION INDIA PRIVATE LIMITED",
"SECURITY INSURANCE BROKERS INDIA PRIVATE LIMITED",
"SECURITY INVESTMENTS LIMITED",
"SECURITY PRINTERS OF BOMBAY PRIVATE LIMITED",
"SECURITY PRINTERS OF INDIA PRIVATE LIMITED",
"SECURITY PRINTING AND MINTING CORPORATION OF INDIA LIMITED",
"SECURITY PRODUCTS PRIVATE LIMITED",
"SECURITY SHELLS INFOTECH PRIVATE LIMITED",
"SECURITY SHOPPE (INDIA) PRIVATE LIMITED",
"SECURITY SURVEYORS & SEALING YARDS PRIVATE LIMITED",
"SECURITY WAREHOUSE INDIA PRIVATE LIMITED",
"SECURITY WEAVER SOFTWARE PRIVATE LIMITED",
"SECURIUM SOLUTIONS PRIVATE LIMITED",
"SECURIZEN SYSTEMS PRIVATE LIMITED",
"SECURLY SOFTWARE INDIA PRIVATE LIMITED",
"SECURO FACILITY MANAGEMENT PRIVATE LIMITED",
"SECUROCROP SECURITIES INDIA PRIVATE LIMITED",
"SECURONIX INDIA PRIVATE LIMITED",
"SECURUS FIRST INDIA PRIVATE LIMITED",
"SECURUS INSURANCE BROKERS (INDIA) PRIVATE LIMITED",
"SECURUS RECORDS MANAGEMENT PRIVATE LIMITED",
"SECURVIEW SYSTEMS PRIVATE LIMITED",
"SECUSAFE INDUSTRIAL SECURITY SERVICES PRIVATE LIMITED",
"SECUSAFE INVESTIGATION SERVICES PRIVATE LIMITED",
"SECUTECH AUTOMATION INDIA PRIVATE LIMITED",
"SECUTELNET TECHNOLOGIES PRIVATE LIMITED",
"SECUTRON FIRE & SECURITY SYSTEMS PRIVATE LIMITED",
"SECY RK MISSION SKN MANDIR",
"SEDAN SPECIALITY CHEM PRIVATE LIMITED",
"SEDAN TRADING PRIVATE LIMITED",
"SEDAR HIMALAYAN PARADISE PRIVATE LIMITED",
"SEDAXIS ADVANCED MATERIALS PRIVATE LIMITED",
"SEDEMAC MECHATRONICS PRIVATE LIMITED",
"SEDER HOUSING PRIVATE LIMITED",
"SEDI BOTANICALS PRIVATE LIMITED",
"SEDIN TECHNOLOGIES P LIMITED",
"SEDOTS INFO TECHNOLOGIES PRIVATE LIMITED",
"SEDULOUS TECH SOLUTIONS LLP",
"SEDUNDERABAD PRINTED CARTONS PRIVATE LI",
"SEE LINKAGES PRIVATE LIMITED",
"SEE LUBE TECHNOLOGIES PRIVATE LIMITED",
"SEEBA INDUSTRIES PRIVATE LIMITED",
"SEEC TECHNOLOGIES ASIA PRIVATE LIMITED",
"SEECO ENTERPRISES PRIVATE. LIMITED.",
"SEED AGRITECH PRIVATE LIMITED",
"SEED ART FERTILITY SERVICES PRIVATE LIMI TED",
"SEED CAPITAL PRIVATE LIMITED",
"SEED ENGINEERING CONSULTANTS PRIVATE LIMITED",
"SEED FOR SAFETY",
"SEED INFOTECH LIMITED",
"SEED MANAGEMENT SERVICES PRIVATE LIMITED",
"SEED REALTY PRIVATE LIMITED",
"SEED TESTING LABORATORY BHOPAL",
"SEEDIFF SOFTSOLUTIONS (INDIA) PRIVATE LIMITED",
"SEEDKING INDIA PRIVATE LIMITED",
"SEEDLINGS INDIA PRIVATE LIMITED",
"SEEDLINGS SOLUTIONS INDIA PRIVATE LIMITED",
"SEEDLOGIC TRADING PRIVATE LIMITED",
"SEEDOLABS PRIVATE LIMITED",
"SEEDPLASTICO PRIVATE LIMITED",
"SEEDS & SOIL IVF PRIVATE LIMITED",
"SEEDS AGRO PRODUCTS AND SERVICES PRIVATE LIMITED",
"SEEDS FARMERS PRODUCER COMPANY LIMITED",
"SEEDS FINCAP PRIVATE LIMITED",
"SEEDS OF INNOCENCE INFERTILITY & MATERNITY CLINIC PRIVATE LIMITED",
"SEEDS TECHNICAL SERVICES PRIVATE LIMITED",
"SEEDWILL CONSULTING PRIVATE LIMITED",
"SEEDWORKS INTERNATIONAL PRIVATE LIMITED",
"SEEFAR SHIPPING PRIVATE LIMITED",
"SEEGAKULA PHARMACEUTICALS PRIVATE LIMITED",
"SEEGATE SOLUTIONS PRIVATE LIMITED",
"SEEKERS TECH PRIVATE LIMITED",
"SEELA INFRATECH PRIVATE LIMITED",
"SEELUFT INDIA PRIVATE LIMITED",
"SEEMA AGRO PRODUCTS PRIVATE LIMITED",
"SEEMA ANAND AUTO SALES PRIVATE LIMITED",
"SEEMA CONSTRUCTION",
"SEEMA DHARMAVIR GUPTA",
"SEEMA KRAFT BOARD PVT LTD",
"SEEMA MEDICARE PRIVATE LIMITED",
"SEEMA OXYGEN AND ACETYLENE GASES PRIVATE LIMITED",
"SEEMA PAPER INDUSTRIES PRIVATE LIMITED",
"SEEMA REALCON PRIVATE LIMITED",
"SEEMA SULZ PRIVATE LIMITED",
"SEEMA TANNING INDUSTRIES PRIVATE LIMITED",
"SEEMA TILES AND CEMENT COMPANY PRIVATE LIMITED",
"SEEMANCHAL AGROCHEM PRIVATE LIMITED",
"SEEMANCHAL INFRATECH PRIVATE LIMITED",
"SEEMANCHAL MOTORS PRIVATE LIMITED",
"SEEMAX BIOTECH PRIVATE LIMITED",
"SEEMAX INTERNATIONAL SCHOOL",
"SEEMAX RESOURCES PRIVATE LIMITED",
"SEEMRAN VINIYOG PRIVATE LIMITED",
"SEEMSAN IMPEX PRIVATE LIMITED",
"SEEMSAN OVERSEAS PRIVATE LIMITED",
"SEENU TRANSPORTS PRIVATE LIMITED",
"SEEPEX INDIA PRIVATE LIMITED",
"SEEPOSSIBLE INNOVATIVE SOLUTIONS LLP",
"SEEPRA ELECTRICALS PRIVATE LIMITED",
"SEERAJ INDUSTIRES PRIVATE LIMITED",
"SEEROO IT SOLUTIONS PRIVATE LIMITED",
"SEERS FUND MANAGEMENT PRIVATE LIMITED",
"SEERTREE GLOBAL SERVICES PRIVATE LIMITED",
"SEE-SAW IRON AND STEEL PRIVATE LIMITED",
"SEET KAMAL PRIVATE LIMITED",
"SEETA ENERGEN PRIVATE LIMITED",
"SEETA FILMS & TV PRODUCTION PRIVATE LIMITED",
"SEETA FOODS PRIVATE LIMITED",
"SEETA NURSING HOME",
"SEETAL BIO INDUSTRIES LIMITED",
"SEETECH SOLUTIONS PRIVATE LIMITED",
"SEETEX GARMENTS PRIVATE LIMITED",
"SEETHA ICE CREAMS PRIVATE LIMITED",
"SEETHA MAHALAKSHMI POULTRY AND FARMS PRIVATE LIMITED",
"SEETHALAKSHMI HALL FLOUR MILLS PRIVATE LIMITED",
"SEETHALAKSHMI RAMASAMY COLL",
"SEETHAPATHY CLINIC",
"SEETHARAM MECHATRONICS PRIVATE LIMITED",
"SEETHARAMA OIL INDUSTRIES PRIVATE LIMITED",
"SEETLANI BUSINESS ERA PRIVATE LIMITED",
"SEETU KOHLI CONCEPTS PRIVATE LIMITED",
"SEETU ORBIT CABLE INDIA PRIVATE LIMITED",
"SEEYEN TECHNICAL SERVICES PRIVATE LIMITED",
"SEFALI COMMERCIAL PVT. LTD.",
"SEFAR INDIA PRIVATE LIMITED",
"SEFCO INNOVATIONS PRIVATE LIMITED",
"SEFTECH INDIA PRIVATE LIMITED",
"SEG AUTOMOTIVE INDIA PRIVATE LIMITED",
"SEGA CERAMICS PRIVATE LIMITED.",
"SEGA GRANITO LLP",
"SEGAL CERAMIC PRIVATE. LIMITED.",
"SEGAL SHIPPING SERVICES PRIVATE LIMITED",
"SEGAM TILES PRIVATE LIMITED",
"SEGASTAR IMPACT PRIVATE LIMITED",
"SEGEL INDIA PRIVATE LIMITED",
"SEGMENTAL CONSULTING & INFRASTRUCTURE ADVISORY PRIVATE LIMITED",
"SEGMENTAL CONSULTING & INFRASTRUCTURE ADVISORYP LIMITED",
"SEGOMA IMAGING TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"SEGOO INFRA PRIVATE LIMITED",
"SEGRETO SKILLS FINDER PRIVATE LIMITED",
"SEGUE COMMUNICATIONS PRIVATE LIMITED",
"SEGUE ENGINEERING PRIVATE LIMITED",
"SEGUE ENTERPRISE PRIVATE LIMITED",
"SEGULA TECHNOLOGIES INDIA PRIVATE LIMITED",
"SEGUNBARI TEA CO.LTD.",
"SEGURA SERVICES PRIVATE LIMITED",
"SEGURO FINANCIAL SERVICES PRIVATE LIMITED",
"SEHA TECHNOLOGIES PRIVATE LIMITED",
"SEHAJ HOSPITAL NAKODAR",
"SEHAJ SYNERGY TECHNOLOGIES PRIVATE LIMITED",
"SEHAMITHA AGRI PRODUCER COMPANY LIMITED",
"SEHAN GLOBAL SERVICES PRIVATE LIMITED",
"SEHAR INDUSTRIES RETAIL PRIVATE LIMITED",
"SEHAT PHARMA PVT LTD",
"SEHEJ ENTERPRISES PRIVATE LIMITED",
"SEHEJ MULTITRADE PRIVATE LIMITED",
"SEHGAL AUTORIDERS PRIVATE LIMITED",
"SEHGAL GOLD ORNAMENTS PRIVATE LIMITED",
"SEHGAL JEWELS PRIVATE LIMITED",
"SEHGAL NEO HOSPITAL",
"SEHGAL PROCESSORS PRIVATE LIMITED",
"SEHGAL SAREES PRIVATE LIMITED",
"SEHGAL SONS MARKETING PRIVATE LIMITED",
"SEHGAL STORES PRIVATE LIMITED",
"SEHGAL TOURIST & HOLIDAYS PRIVATE LIMITED",
"SEHGAL WIRE SALES PVT.LTD.",
"SEHORE AGRI SERVICES PRIVATE LIMITED",
"SEHORE KOSMI TOLLWAYS LIMITED",
"SEHRAWAT HOSPITAL",
"SEHRAWAT TRANSPORT SERVICE & LOGISTICS PRIVATE LIMITED",
"SEHRI INDUSTRIES PRIVATE LIMITED",
"SEHSHADRIPURAM EVENING COLLEGE",
"SEHSHADRIPURAM LAW COLLEGE",
"SEHSHADRIPURAM P U C COLLEGE",
"SEI ADHAVAN POWER PRIVATE LIMITED",
"SEI ADITI POWER PRIVATE LIMITED",
"SEI ADITYASHAKTI PRIVATE LIMITED",
"SEI ARJUN POWER PRIVATE LIMITED",
"SEI ARUSHI PRIVATE LIMITED",
"SEI BASKARA POWER PRIVATE LIMITED",
"SEI BHEEM PRIVATE LIMITED",
"SEI DIAMOND PRIVATE LIMITED",
"SEI ENERSTAR RENEWABLE ENERGY PRIVATE LIMITED",
"SEI GREEN FLASH PRIVATE LIMITED",
"SEI JYOTISWAROOP POWER PRIVATE LIMITED",
"SEI KATHIRAVAN POWER PRIVATE LIMITED",
"SEI L'VOLTA PRIVATE LIMITED",
"SEI MIHIR ENERGY PRIVATE LIMITED",
"SEI PHOEBUS PRIVATE LIMITED",
"SEI RAVIKIRAN ENERGY PRIVATE LIMITED",
"SEI RENEWABLE ENERGY PRIVATE LIMITED",
"SEI SITARA PRIVATE LIMITED",
"SEI SOLAR ENERGY PRIVATE LIMITED",
"SEI SOLAR POWER GUJARAT PRIVATE LIMITED",
"SEI SOLAR POWER PRIVATE LIMITED",
"SEI SOLARVANA POWER PRIVATE LIMITED",
"SEI SOORAJ RENEWABLE ENERGY PRIVATE LIMITED",
"SEI SRIRAM POWER PRIVATE LIMITED",
"SEI SUNSHINE POWER PRIVATE LIMITED",
"SEI SURYALABH PRIVATE LIMITED",
"SEI SURYASHAKTI POWER PRIVATE LIMITED",
"SEI TEJAS PRIVATE LIMITED",
"SEI TRADING INDIA PRIVATE LIMITED",
"SEI VENUS PRIVATE LIMITED",
"SEICON NAVIGATION PRIVATE LIMITED",
"SEIDO TECHNOLOGIES PRIVATE LIMITED",
"SEIGHT LPGAS BOTTLERS PRIVATE LIMITED",
"SEIKAKU ENGINEERS PRIVATE LIMITED",
"SEIKEN PROPERTY DEVELOPERS PRIVATE LIMITED",
"SEIKO ADVANCE INDIA PRIVATE LIMITED",
"SEIKO PLAST MACHINES PRIVATE LIMITED",
"SEIKO TEXTILES PRIVATE LIMITED",
"SEIKO WATCH INDIA PRIVATE LIMITED",
"SEIKODENKI INDIA PRIVATE LIMITED",
"SEIKO-MARAICA ELECTRICAL MANUFACTURING (INDIA) PRIVATE LIMITED",
"SEIL ENERGY INDIA LIMITED",
"SEILAX SOFTWARE SYSTEMS PRIVATE LIMITED",
"SEILER GAREPA INDIA PRIVATE LIMITED",
"SEIMITSU FACTORY AUTOMATION PRIVATE LIMITED",
"SEIMITSU PATTERNS AND DIES PRIVATE LIMITED",
"SEINSA AUTOFREN INDIA PRIVATE LIMITED",
"SEINUMERO NIRMAN PRIVATE LIMITED",
"SEION ELECTRICALS PRIVATE LIMITED",
"SEIREN INDIA PRIVATE LIMITED",
"SEIRRA INFRAVENTURE PRIVATE LIMITED",
"SEIZO AUTOMOTIVE PRIVATE LIMITED",
"SEIZO CNC PRIVATE LIMITED",
"SEJ FURNISHINGS PRIVATE LIMITED",
"SEJAL & SEJAL RESIDENCY PRIVATE LIMITED",
"SEJAL CREATION PRIVATE LIMITED",
"SEJAL DIAMOND PRIVATE LIMITED",
"SEJAL INTELLIGENT FACADE SOLUTIONS PRIVATE LIMITED",
"SEJAL SHAKTI REALTORS LLP",
"SEJAL UNEXO PRIVATE LIMITED",
"SEJASMI INDUSTRIES ( INDIA ) PVT. LTD.",
"SEJGAON HIGHSCHOOL SEJGAON",
"SEJONG TESK VIKAS PRIVATE LIMITED",
"SEJPAL CAPITAL AND FINANCE PRIVATE LIMITED",
"SEJPAL PLASTICS PRIVATE LIMITED",
"SEK TECHNOSOFT PRIVATE LIMITED",
"SEKAI SOLUTIONS PRIVATE LIMITED",
"SEKAR EMPORIUM (TEXTILES) PRIVATE LIMITED",
"SEKEL TECHNOLOGIES PRIVATE LIMITED",
"SEKEN INFORMATION SYSTEMS INDIA PRIVATE LIMITED",
"SEKHANI FABRICS MILLS PRIVATE LIMITED",
"SEKHANI INDUSTRIES PRIVATE LIMITED",
"SEKHAR BUILDERS AND PROMOTERS PRIVATE LIMITED",
"SEKHAWATI ORGANIC PRIVATE LIMITED",
"SEKHMET PHARMAVENTURES PRIVATE LIMITED",
"SEKHON BIOTECH PRIVATE LIMITED",
"SEKHRI ACADEMY AND IMMIGRATION LIMITED",
"SEKHWELL TRADING AND FINANCE PVT LTD",
"SEKISUI CHEMICAL",
"SEKISUI DLJM MOLDING PRIVATE LIMITED",
"SEKKEI SOLUTIONS",
"SEKO BEC PRIVATE LIMITED",
"SEKSARIA FOUNDRIES LTD.",
"SEKSARIA INDUSTRIES PRIVATE LIMITED",
"SEKSARIA MARBELS AND MINERALS LIMITED",
"SEKSARIA TRADING CO PRIVATE LIMITED",
"SEKTRA MARKETING SERVICES PRIVATE LIMITED",
"SEKURA ENERGY LIMITED",
"SEKURA ENERGY PRIVATE LIMITED",
"SEKURA ROADS PRIVATE LIMITED",
"SEKYO INNOVATIONS PRIVATE LIMITED",
"SEL AVIATION PRIVATE LIMITED",
"SEL JEGAT PRINTERS PRIVATE LIMITED",
"SEL MANUFACTURING COMPANY LIMITED",
"SELA INDUSTRIES PRIVATE LIMITED",
"SELA PAPERS PRIVATE LIMITED",
"SELA TECHNOLOGY SOLUTIONS INDIA PRIVATE LIMITED",
"SELAN EXPLORATION TECHNOLOGY LIMITED",
"SELAN PROJECT CONSULTANT PRIVATE LIMITED",
"SELANDIA CREW MANAGEMENT INDIA PRIVATE LIMITED",
"SELANDIA SHIP MANAGEMENT INDIA PRIVATE LIMITED",
"SELANGIA HOSPITAL PRIVATE LIMITED",
"SELAQUI INTERNATIONAL SCHOOL",
"SELCO SOLAR LIGHT PRIVATE LIMITED",
"SELCOUTH CONSULTANCY PRIVATE LIMITED",
"SELDOM INFRASTRUCTURE INDIA PRIVATE LIMITED",
"SELDOM PHARMA PRIVATE LIMITED",
"SELEC CONTROLS PRIVATE LIMITED",
"SELECT BRANDS INTERNATIONAL PRIVATE LIMITED",
"SELECT CABS PEOPLE LOGISTICS PRIVATE LIMITED",
"SELECT CARS PRIVATE LIMITED",
"SELECT COMMODITIES PRIVATE LIMITED",
"SELECT CRAFTS PRIVATE LIMITED",
"SELECT DIRECT MARKETING COMMUNICATION PRIVATE LIMITED",
"SELECT EQUITY ADVISORY SERVICES PRIVATE LIMITED",
"SELECT GRANITE INDIA PRIVATE LIMITED",
"SELECT HOLIDAY RESORTS PRIVATE LIMITED",
"SELECT HOME INTERIOR DESIGNERS PRIVATE LIMITED",
"SELECT INFRASTRUCTURE PRIVATE LIMITED",
"SELECT LEATHER CRAFT",
"SELECT MARKETING PVT LTD",
"SELECT MOTORS",
"SELECT MOTORS PRIVATE LIMITED",
"SELECT POLY PRODUCTS PRIVATE LIMITED",
"SELECT PRODUCTS PVT LTD",
"SELECT RETREADING PRIVATE LIMITED",
"SELECT SHIPPING PRIVATE LIMITED",
"SELECT SOFTWARES (INDIA) PRIVATE LIMITED",
"SELECT SOURCE INTERNATIONAL PRIVATE LIMITED",
"SELECT SYNERGIES AND SERVICES PRIVATE LIMITED",
"SELECT TECHNOLOGIES PRIVATE LIMITED",
"SELECT WORLD TOURS (INDIA) PRIVATE LIMITED",
"SELECTED RETAIL PRIVATE LIMITED",
"SELECTION CENTRE CENTRAL SULTANIA INFANTRY LINES BHOPAL",
"SELECTION CENTRE SPORTS PRIVATE LIMITED",
"SELECTION FAB (INDIA) PRIVATE LIMITED",
"SELECTION TEXTILE PRIVATE LIMITED",
"SELECTIVE CONSULTANTS PRIVATE LIMITED",
"SELECTIVE GLOBAL SEARCH PRIVATE LIMITED",
"SELECTIVE MINERALS AND COLOR INDUSTRIES PRIVATE LIMITED",
"SELECTIVE PLATING TECHNOLOGY PRIVATE LIMITED",
"SELECTSYS INDIA PRIVATE LIMITED",
"SELEGANCE MARKETING CO PRIVATE LIMITED",
"SELEKT MART PRIVATE LIMITED",
"SELENE CONSTRUCTIONS LIMITED",
"SELENE ESTATE LIMITED",
"SELENG TEA ESTATE PRIVATE LIMITED",
"SELENIUM INFRASTRUCTURE PRIVATE LIMITED",
"SELENO STEELS LIMITED",
"SELENS ELEVATORS PRIVATE LIMITED",
"SELEO CERAMIC PRIVATE LIMITED",
"SELF GROWTH NIDHI LIMITED",
"SELF HEAL LIFESCIENCES PRIVATE LIMITED",
"SELF RELIANT INDUSTRIES PRIVATE LIMITED",
"SELFDRVN ENTERPRISE PRIVATE LIMITED",
"SELFIN INDIA FINANCIAL SERVICES PRIVATE LIMITED",
"SELFMADE SOFTWARE PRIVATE LIMITED",
"SELFRIDGES PRIVATE LIMITED",
"SELFSERVIT SOLUTIONS PRIVATE LIMITED",
"SELFSHINE POLYMERS INDIA PRIVATE LIMITED",
"SELFSTORAGE WAREHOUSE PRIVATE LIMITED",
"SELFWING DIGITAL MEDIA PRIVATE LIMITED",
"SELGA STEEL INDUSTRIES PRIVATE LIMITED",
"SELIGENT CONSULTING PRIVATE LIMITED",
"SELIK PROJECTS PRIVATE LIMITED",
"SELINA PUBLISHERS PRIVATE LIMITED",
"SELL2WORLD ITES PRIVATE LIMITED",
"SELLAM CHEMICALS PRIVATE LIMITED",
"SELLAMMAL SPINNERS PRIVATE LIMITED",
"SELLBYTEL MARKETING SERVICES INDIA PRIVATE LIMITED",
"SELLCRAFT GLOBAL SOLUTIONS PRIVATE LIMITED",
"SELLCRAFT SOFTECH PRIVATE LIMITED",
"SELLECTRON UTILITIES PRIVATE LIMITED",
"SELLER APP BIL IGENITER TECHNOLOGIES PRIVATE LIMITED",
"SELLERCAFE",
"SELLERGIZE WEB TECHNOLOGY SERVICES PRIVATE LIMITED",
"SELLERMANIA SERVICES PRIVATE LIMITED",
"SELLERWORX ONLINE SERVICES PRIVATE LIMITED",
"SELLIAMMAN CONSTRUCTIONS PRIVATE. LIMITED.",
"SELLIAMMAN SPINNING MILLS PRIVATE LIMITED",
"SELLINALL PRIVATE LIMITED",
"SELLING SIMPLIFIED INDIA PRIVATE LIMITED",
"SELLMORE AGENCIES PRIVATE LIMITED",
"SELLMORE LOGISTICS PRIVATE LIMITED",
"SELLMORE MARKETING PRIVATE LIMITED",
"SELLNSHIP SOLUTIONS PRIVATE LIMITED",
"SELLOSPHERE PRIVATE LIMITED",
"SELLOWRAP EPP INDIA PRIVATE LIMITED",
"SELLOWRAP INDUSTRIES PRIVATE LIMITED",
"SELLRYT EBUSINESS PRIVATE LIMITED",
"SELLWELL FOODS AND BEVERAGES PRIVATE LIMITED",
"SELLWELL PHARMACEUTICALS LIMITED",
"SELLWIN ELECTRICALS PVT LTD",
"SELLWIN TRADERS LTD",
"SELMA LABORATORIES PRIVATE LIMITED",
"SELMAX EXPORTS PRIVATE LIMITED",
"SELMEC ENGINEERING CONSTRUCTION",
"SELMORE ADVERTISERS PRIVATE LIMITED",
"SELMOUNT POWER SYSTEMS PRIVATE LIMITED",
"SELOVA LIFESCIENCES PRIVATE LIMITED",
"SELP INDIA PRIVATE LIMITED",
"SELPLAST EXPORTS PRIVATE LIMITED",
"SELSIL SEALANTS INDIA PRIVATE LIMITED",
"SELSOFT TECH PRIVATE LIMITED",
"SELSYN INFRA PROJECTS PRIVATE LIMITED",
"SELTOS TECHNOLOGIES (OPC) PRIVATE LIMITED",
"SELUX INJOPLAST PRIVATE LIMITED",
"SELVA GANESH CONSTRUCTIONS PRIVATE LIMITED",
"SELVA GOLD COVERING PRIVATE LIMITED",
"SELVA STONE EXPORT LIMITED",
"SELVA STONE EXPORT PRIVATE LIMITED",
"SELVAGANAPATHY COTTON MILLS PRIVATE LIMITED",
"SELVAGANPATHY LEASING AND FINANCE LIMITED",
"SELVAKUMAR SPINNERS PRIVATE LIMITED",
"SELVALAKSHMI SPINTEX INDIA PRIVATE LIMITED",
"SELVAM BROILERS PRIVATE LIMITED",
"SELVAM RAVI MOTORS PRIVATE LIMITED",
"SELVAM SEEDS PRIVATE LIMITED",
"SELVAMADHU INFRAS PRIVATE LIMITED",
"SELVARAJA MILLS PRIVATE LIMITED",
"SELVAS KIDS WEARS INDIA PRIVATE LIMITED",
"SELVE INDIA PRIVATE LIMITED",
"SELVEE INDIGENOUS FOOD FACTORY INDIA PRIVATE LIMITED",
"SELVEL CONVEYORS PRIVATE LIMITED",
"SELVEL MEDIA SERVICES PRIVATE LIMITED",
"SELVEL PUBLICITY AND CONSULTANTS PRIVATE LIMITED",
"SELVI FABRICS PRIVATE LIMITED",
"SELVO ELECTRICALS INDIA PRIVATE LIMITED",
"SELVOC ENGINEERING COMPANY PRIVATE LIMITED",
"SELVON INSTRUMENTS PRIVATE LIMITED",
"SELWAY LIFESCIENCES PRIVATE LIMITED",
"SELWEL ENTERPRISES PRIVATE LIMITED",
"SELZER INNOVEX PRIVATE LIMITED",
"SEM ENERGYINFRA PRIVATE LIMITED",
"SEM ENTERPRISES PRIVATE LIMITED",
"SEM WEB SERVICES PRIVATE LIMITED",
"SEMAC CONSTRUCTION TECHNOLOGIES INDIA LLP",
"SEMAC CONSULTANTS LIMITED",
"SEMAC CONSULTANTS PRIVATE LIMITED",
"SEMACONNECT SYSTEMS INDIA PRIVATE LIMITED",
"SEMAK INNOVATION & PROJECTS PRIVATE LIMITED",
"SEMANTICS SMART SOLUTIONS PRIVATE LIMITED",
"SEMANTICS TRANS PRIVATE LIMITED",
"SEMANTIFY PRIVATE LIMITED",
"SEMANTIQ FUTURETECH PRIVATE LIMITED",
"SEMAX IMPEX PRIVATE LIMITED",
"SEMAYA LIMITED",
"SEMBARUTHI PHARMACIES PRIVATE LIMITED",
"SEMBAWANG INFRASTRUCTUREINDIA PRIVATE LIMITED",
"SEMBCORP GREEN INFRA LIMITED",
"SEMCO FORGE PRIVATE LIMITED",
"SEMCO INFRATECH PRIVATE LIMITED",
"SEMCO VIBRATORS PRIVATE LIMITED",
"SEMCOM COLLEGE",
"SEMICON MEDIA PRIVATE LIMITED",
"SEMICON PARK PRIVATE LIMITED",
"SEMICON TECHNOLABS PRIVATE LIMITED",
"SEMICONIC DEVICES PRIVATE LIMITED",
"SEMIDIGIT TECHNOLOGY (OPC) PRIVATE LIMITED",
"SEMIDOT INFOTECH PRIVATE LIMITED",
"SEMIKRON ELECTRONICS PRIVATE LIMITED",
"SEMILA CROP CARE PRIVATE LIMITED",
"SEMILLAS FITO INDIA PRIVATE LIMITED",
"SEMINA AGRO PRIVATE LIMITED",
"SEMINAL RESEARCH SERVICES PRIVATE LIMITED",
"SEMINAL SOFTWARE PRIVATE LIMITED",
"SEMINARY TIE-UP PVT LTD",
"SEMINOLE ELECTRONICS PRIVATE LIMITED",
"SEMIOTIC PHARMACEUTICAL PRIVATE LIMITED",
"SEMITA TECHNOLOGIES PRIVATE LIMITED",
"SEMITEC ELECTRONICS INDIA PRIVATE LIMITED",
"SEMITECH OPTO SOLUTIONS PRIVATE LIMITED",
"SEMITRONE CONCHEM LIMITED",
"SEMITRONE CONCHEM PRIVATE LIMITED",
"SEMLER RESEARCH CENTER PRIVATE LIMITED",
"SEMNOX SOLUTIONS PRIVATE LIMITED",
"SEMPERTRANS INDIA PRIVATE LIMITED",
"SEMPON PERMANENT NIDHI LIMITED",
"SEMPRA ELECTRIC PRIVATE LIMITED",
"SEMPRA ENERGY",
"SEMPULAM SUSTAINABLE SOLUTIONS PRIVATE LIMITED",
"SEMSYS PRIVATE LIMITED",
"SEMTECH ADVANCED SYSTEMS INDIA PRIVATE LIMITED",
"SEMTECH ELECTROMECH PRIVATE LIMITED",
"SEMTITANS DIGITAL PRIVATE LIMITED",
"SEMTRONS IT SOLUTIONS PRIVATE LIMITED",
"SEMYUNG INDIA ENTERPRISES PRIVATE LIMITED",
"SEN & LALL CONSULTANTS PRIVATE LIMITED",
"SEN & PANDIT DIGITAL TECHNOLOGY PRIVATE LIMITED",
"SEN & PANDIT POLYTUBES PRIVATE LIMITED",
"SEN BROTHERS CONSTRUCTION PRIVATE LIMITED",
"SEN BROTHERS ENTERPRISES PVT LTD",
"SEN BROTHERS FOREX PRIVATE LIMITED",
"SEN BROTHERS PVT LTD",
"SEN FERRO ALLOYS PRIVATE LIMITED",
"SEN HON LEE TECHNOLOGIES PRIVATE LIMITED",
"SEN SEC RESIDENTIAL SCHOOL FOR MERITORIOUS STUDENTS",
"SENA SYSTEMS PRIVATE LIMITED",
"SENABLE LIFE SCIENCES PRIVATE LIMITED",
"SENAPATHY SYMONS INSULATIONS",
"SENAPATHY WHITELEY PRIVATE LIMITED",
"SENAS NET PRIVATE LIMITED",
"SENATE MARKETING PRIVATE LIMITED",
"SENATE SOLUTION PRIVATE LIMITED",
"SENATE TECHNOLOGIES INDIA PRIVATE LIMITED",
"SENATECH INDIA PRIVATE LIMITED",
"SENATLA EV PRODUCTS PRIVATE LIMITED",
"SENATOR INNS PRIVATE LIMITED",
"SENATOR LOGISTICS INDIA PRIVATE LIMITED",
"SENATOR TRAVELS PRIVATE LIMITED",
"SENATOR WOOD PRIVATE LIMITED",
"SENBIAN PHARMA PRIVATE LIMITED",
"SENBONZAKURA CONSULTANCY PRIVATE LIMITED",
"SENCHAL AGRO PRIVATE LIMITED",
"SENCILLATEC SOLUTIONS PRIVATE LIMITED",
"SENCO ALANKAR PRIVATE LIMITED",
"SENCO GOLD ARTISANSHIP PRIVATE LIMITED",
"SENCO GOLD LIMITED",
"SENCO INDIA PROJECTS PVT LTD",
"SENCO INFRASTRUCTURE PRIVATE LIMITED",
"SENCO JEWELLERS PVT LTD",
"SENCO JEWELLERY ENTERPRISE PRIVATE LIMITED",
"SEND CLEAN PRIVATE LIMITED",
"SENDECOM SOLUTIONS PRIVATE LIMITED",
"SENDHAMARAI ENGINEERING PRIVATE LIMITED",
"SENDHAMARAI TOOLS PRIVATE LIMITED",
"SENDHUR MURUGAN INVESTMENTS PRIVATE LIMITED",
"SENDOZ COMMERCIALS PRIVATE LIMITED",
"SENDOZ IMPEX LIMITED.",
"SENDURA FORGE PRIVATE LIMITED",
"SENECA GLOBAL IT SERVICES PRIVATE LIMITED",
"SENECA TRADELINK PRIVATE LIMITED",
"SENECHIO PHARMA PRIVATE LIMITED",
"SENER INDIA ENGINEERING AND SYSTEMS PRIVATE LIMITED",
"SENERGY INTELLUTION PRIVATE LIMITED",
"SENGAJAN TEA CO PVT LTD",
"SENGAMALA THAYAAR EDUCATIONAL TRUST WOMENS COLLEGE",
"SENGAR SECURITY AND LABOUR SERVICES PRIVATE LIMITED",
"SENGEE BIOCHEM EXIM PRIVATE LIMITED",
"SENGEN SOFTWARE PRIVATE LIMITED",
"SENGHANI AND SENGHANI EXIM PRIVATE LIMITED",
"SENGHANI CREATORS PRIVATE LIMITED",
"SENGOL ENGINEERS PRIVATE LIMITED",
"SENGUNTHAR MILLS PRIVATE LIMITED",
"SENGUPTA & SENGUPTA PRIVATE LIMITED",
"SEN-HARVIC WINDOWS PRIVATE LIMITED",
"SENIOR ADVISORY SERVICES PRIVATE LIMITED",
"SENIOR ARCHITECT",
"SENIOR GEO HYDROLOGIST GROUND WATER SERVICES JBP MADHYA PRADESH",
"SENIOR GEOLOGIST G S D A NAGPUR",
"SENIOR INDIA PRIVATE LIMITED",
"SENIOR QUALITY ASSURANCE ESTT ARMTS. KANPUR",
"SENIOR QUALITY ASSUSRANCE ESTABLISHMENT ARMTS & LPR KHAMARIA",
"SENIOR RUBBERS PRIVATE LIMITED",
"SENIORITY PRIVATE LIMITED",
"SENIS CERAMIC PRIVATE LIMITED",
"SENKA DREAMS INDIA PRIVATE LIMITED",
"SENKAR TECHNOLOGIES INDIA PRIVATE LIMITED",
"SENKAY TOURS AND TRAVELS PRIVATE LIMITED",
"SENKAY TRAVEL WITH DIFFERENCE PRIVATE LIMITED",
"SENKUSH TRADERS PRIVATE LIMITED",
"SENMAR BUILDERS PRIVATE LIMITED",
"SENNAAR LOGISTICS PRIVATE LIMITED",
"SENNARI STONE(INDO)PRIVATE LIMITED",
"SENNETTA HOTEL PRIVATE LIMITED",
"SENNHEISER ELECTRONICS INDIA PRIVATE LIMITED",
"SENNOVATE INFOTECH INDIA PRIVATE LIMITED",
"SENOGET TECHNOLOGIES PRIVATE LIMITED",
"SENOR METALS PRIVATE LIMITED",
"SENORA BEACH RESORTS PRIVATE LIMITED",
"SENORES PHARMACEUTICALS LIMITED",
"SENORITA CREATIONS PRIVATE LIMITED",
"SENORITA SALES PRIVATE LIMITED",
"SENOS TECH INDIA PRIVATE LIMITED",
"SENP DESIGN CIRCLE GANDHINAGAR",
"SENQUIRE ANALYTICS PRIVATE LIMITED",
"SENRYAKU MANAGEMENT PRIVATE LIMITED",
"SENRYSA E-SERVICES PRIVATE LIMITED",
"SENRYSA TECHNOLOGIES PRIVATE LIMITED",
"SENRYSA TRCHNOLOGIES PRIVATE LIMITED",
"SENS HOTELS PRIVATE LIMITED",
"SENS UDYOG PRIVATE LIMITED",
"SENSA CORE MEDICAL INSTRUMENTATION PRIVATE LIMITED",
"SENSAAS INDIA SOLUTIONS PRIVATE LIMITED",
"SENSARA TECHNOLOGIES INDIA PRIVATE LIMITED",
"SENSAROM FOODS PRIVATE LIMITED",
"SENSATA TECHNOLOGIES INDIA PRIVATE LIMITED",
"SENSATION INFRACON PRIVATE LIMITED",
"SENSATION SOFTWARE SOLUTIONS PRIVATE LIMITED",
"SENSATIONAL AGRI INPUTS PRIVATE LIMITED",
"SENSATIONAL IMPEX PRIVATE LIMITED",
"SENSATIONS MARCOM PRIVATE LIMITED",
"SENSATIONZ MEDIA & ARTS PRIVATE LIMITED",
"SENSE DIGITAL MEDIA PRIVATE LIMITED",
"SENSE INTERNATIONAL INDIA",
"SENSE PROJECTS PRIVATE LIMITED",
"SENSE TALENT LABS INDIA PRIVATE LIMITED",
"SENSE7AI DATA SOLUTIONS PRIVATE LIMITED",
"SENSECURE INTEGRATED SOLUTIONS PRIVATE LIMITED",
"SENSEDGE TRANSPORTATION SYSTEMS AND SOLUTIONS PRIVATE LIMITED",
"SENSEFORTH AI RESEARCH PRIVATE LIMITED",
"SENSEGROW TECHNOLOGIES PRIVATE LIMITED",
"SENSEHAWK INDIA PRIVATE LIMITED",
"SENSEHAWK TECHNOLOGIES PRIVATE LIMITED",
"SENSEI GOURMET PRIVATE LIMITED",
"SENSEL TELEMATICS PRIVATE LIMITED",
"SENSEN VIDEO BUSINESS INTELLIGENCE PRIVATE LIMITED",
"SENSEOPS TECH SOLUTIONS PRIVATE LIMITED",
"SENSES AKUSTIK PRIVATE LIMITED",
"SENSES ELECTRONICS PRIVATE LIMITED",
"SENSES PHARMACEUTICALS LIMITED",
"SENSES PHARMACEUTICALS PRIVATE LIMITED",
"SENSETEK OPTICAL PRIVATE LIMITED",
"SENSEWARE INFOMEDIA PRIVATE LIMITED",
"SENSEWELL INSTRUMENTS PRIVATE LIMITED",
"SENSEX CONSULTANTS PRIVATE LIMITED",
"SENSIA ENERGY PRIVATE LIMITED",
"SENSIENT INDIA PRIVATE LIMITED",
"SENSIGHT TECHNOLOGIES PRIVATE LIMITED",
"SENSILE INDIA TECHNOLOGIES PRIVATE LIMITED",
"SENSING TECHNOLOGIES PRIVATE LIMITED",
"SENSIPLE SOFTWARE SOLUTION PRIVATE LIMITED",
"SENSIPLE TECHNOLOGIES INDIA PRIVATE LIMITED",
"SENSITIVE ENGITECH PRIVATE LIMITED",
"SENSITIVE VANIJYA PRIVATE LIMITED",
"SENSO AGROTECH PRIVATE LIMITED",
"SENSO E BIZ SOLUTIONS LIMITED",
"SENSO FOODS PRIVATE LIMITED",
"SENSO GRANITO PRIVATE LIMITED",
"SENSOFT SOLUTIONS PRIVATE LIMITED",
"SENSOGRAPH PACKAGING TECHNOLOGY PRIVATE LIMITED",
"SENSOHEAT ENGINEERING EQUIPMENTS INDIA PRIVATE LIMITED",
"SENSOL TECHNOLOGIES PRIVATE LIMITED",
"SENSONICS TECHNOLOGIES INDIA PRIVATE LIMITED",
"SENSORICA SECURITY SOLUTIONS PRIVATE LIMITED",
"SENSORISE DIGITAL SERVICES PRIVATE LIMITED",
"SENSORISE SMART SOLUTIONS PRIVATE LIMITED",
"SENSORS & SYSTEMS INDUSTRIAL SOLUTIONS PRIVATE LIMITED",
"SENSORTEC INNOVATION INDIA PRIVATE LIMITED",
"SENSYS TECHNOLOGIES PRIVATE LIMITED",
"SENTEC INDIA COMPANY PRIVATE LIMITED",
"SENTECH INDUSTRIES PRIVATE LIMITED",
"SENTHAMARAI LOGISTICS SERVICES PRIVATE LIMITED",
"SENTHAMARAI MARBLES & GRANITES PRIVATE LIMITED",
"SENTHAMILAN PRIVATE LIMITED",
"SENTHIL AGENCIES",
"SENTHIL ANDAVAR PROTEINS PRIVATE LIMITED",
"SENTHIL CONSTRUCTION CORPORATION PRIVATE. LIMITED.",
"SENTHIL ENERGY PRIVATE LIMITED",
"SENTHIL JDM PHARMACOSEPT PRIVATE LIMITED",
"SENTHIL MATRIC HIGHER SECONDARY SCHOOL",
"SENTHIL MURUGAN JEWELLERS PRIVATE LIMITED",
"SENTHIL PACKAGINGS PRIVATE LIMITED",
"SENTHIL PUBLIC SCHOOL",
"SENTHIL SAFETY SOLUTIONS PRIVATE LIMITED",
"SENTHIL SEEDS PRIVATE LIMITED",
"SENTHIL SPINNERS PRIVATE LIMITED",
"SENTHIL SPINNERS PRIVATE. LIMITED.",
"SENTHIL TIMBER TRADERS",
"SENTHILANDAVAR POULTRY FARMS PRIVATE LIMITED",
"SENTHILANDAVAR TRANSPORT PRIVATE LIMITED",
"SENTHILKUMAR TEXTILE MILLS PRIVATE LIMITED",
"SENTHIYA MULTIVENTURES PRIVATE LIMITED",
"SENTHURAN ENGINEERING AND CONSTRUCTIONS PRIVATE LIMITED",
"SENTIA THE GLOBAL SCHOOL MIYAPUR",
"SENTIENT INFOTECH PRIVATE LIMITED",
"SENTIENT SCRIPTS PRIVATE LIMITED",
"SENTIENT SOLUTIONS FOR ACCOUNTING PRIVATE LIMITED",
"SENTIENT SYSTEMS PRIVATE LIMITED",
"SENTIENTGEEKS SOFTWARE AND CONSULTANCY PRIVATE LIMITED",
"SENTIENZ SOLUTIONS PRIVATE LIMITED",
"SENTIEO INDIA PRIVATE LIMITED",
"SENTIER CONSULTING AND HEALTHCARE PRIVATE LIMITED",
"SENTIL GRANITES LIMITED",
"SENTIMENT FURNITURE SYSTEMS INDIA PRIVATE LIMITED",
"SENTIMENTS ENTERPRISE PRIVATE LIMITED",
"SENTINEL CONSULTANTS PRIVATE LIMITED",
"SENTINEL MANUFACTURING INDIA PRIVATE LIMITED",
"SENTINEL TECHNOLOGIES PRIVATE LIMITED",
"SENTINELS SECURITY PRIVATE LIMITED",
"SENTINELS SECURITY SYSTEMS PRIVATE LIMITED",
"SENTINI BEVERAGES PRIVATE LIMITED",
"SENTINI BIOPRODUCTS P LIMITED",
"SENTINI CERAMICA P LIMITED",
"SENTINI FLOPIPES INDIA PRIVATE LIMITED",
"SENTINI GEOSOL PRIVATE LIMITED",
"SENTINI HOSPITALS PRIVATE LIMITED",
"SENTINI INFRAS PRIVATE LIMITED",
"SENTIRE AND EXPERIMENTUM INDIA PRIVATE LIMITED",
"SENTISS PHARMA PRIVATE LIMITED",
"SENTO PLAST PRIVATE LIMITED",
"SENTOSA GEIGY (INDIA) LABS LIMITED",
"SENTOSA GRANITO PRIVATE LIMITED",
"SENTOSA RESORTS PRIVATE LIMITED",
"SENTRIGO SAFEGUARDS PRIVATE LIMITED",
"SENTRO PHARMA & HEALTH CARE LLP",
"SENTRYFORCE SECURITAS PRIVATE LIMITED",
"SENVAC EXTRACTION SYSTEM PRIVATE LIMITED",
"SENVION INDIA PRIVATE LIMITED",
"SENVION INDIA WIND POWER SERVICES LLP",
"SENVION WIND TECHNOLOGY PRIVATE LIMITED",
"SENZO ENGINEERING PRIVATE LIMITED",
"SEO BIRDS MARKETING PRIVATE LIMITED",
"SEO BRIDAL STUDIO PRIVATE LIMITED",
"SEO LOGISTICS PRIVATE LIMITED",
"SEO YEONG DIETECH PRIVATE LIMITED",
"SEOCZAR IT SERVICES PRIVATE LIMITED",
"SEOFIED IT SERVICES PRIVATE LIMITED",
"SEOK CONSULTANCY SERVICES PRIVATE LIMITED",
"SEOTONIC WEB SOLUTIONS PRIVATE LIMITED",
"SEOUL SEMICONDUCTOR CO. LIMITED",
"SEOUL STORE TRADING PRIVATE LIMITED",
"SEOVALLEY SOLUTIONS PRIVATE LIMITED",
"SEOYON E-HWA AUTOMOTIVE CHENNAI PRIVATE LIMITED",
"SEOYON E-HWA SUMMIT AUTOMOTIVE ANANTAPUR PRIVATE LIMITED",
"SEOYON E-HWA SUMMIT AUTOMOTIVE INDIA PRIVATE LIMITED",
"SEOYON ELECTRONICS INDIA PRIVATE LIMITED",
"SEP ENERGY PRIVATE LIMITED",
"SEP INDIA PRIVATE LIMITED",
"SEPA JEWELS PRIVATE LIMITED",
"SEPACK INDIA PRIVATE LIMITED",
"SEPADU TECH PRIVATE LIMITED",
"SEPAL CERAMIC",
"SEPAL HOTEL PRIVATE LIMITED",
"SEPAL TILES PRIVATE LIMITED",
"SEPCON ENGINEERING (INDIA) PRIVATE LIMITED",
"SEPCON SYSTEMS PRIVATE LIMITED",
"SEPHORA COSMETICS PRIVATE LIMITED",
"SEPHORA INFO SOLUTIONS PRIVATE LIMITED",
"SEPIO PRODUCTS PRIVATE LIMITED",
"SEPL CONSULTANCY SERVICES PRIVATE LIMITED",
"SEPL INDIA LIMITED",
"SEPOY BEVERAGES LLP",
"SEPPIC SPECIALITY INGREDIENTS PRIVATE LIMITED",
"SEPRA TRADERS PVT LTD",
"SEPRATECH SOLUTIONS PRIVATE LIMITED",
"SEPSET CONSTRUCTIONS LIMITED",
"SEPSET PROPERTIES PRIVATE LIMITED",
"SEPSON INDIA PRIVATE LIMITED",
"SEPTA CONCEPTS PRIVATE LIMITED",
"SEPTA HEALTH SOLUTIONS PRIVATE LIMITED",
"SEPTA MILLES PRIVATE LIMITED",
"SEPTATHLON SERVICES PRIVATE LIMITED",
"SEPTECH MARKETING LLP",
"SEPTEM DIGISOLUTIONS PRIVATE LIMITED",
"SEPTET HEALTHCARE PRIVATE LIMITED",
"SEPTODONT HEALTHCARE INDIA PRIVATE LIMITED",
"SEPULCHRE BROTHERS INDIA PRIVATE LIMITED",
"SEQATO SOFTWARE SERVICES PRIVATE LIMITED",
"SEQATO SOFTWARE SOLUTIONS PRIVATE LIMITED",
"SEQRONICS (INDIA)PRIVATE LIMITED",
"SEQUEL ENGINEERING PRIVATE LIMITED",
"SEQUEL IMPEX PRIVATE LIMITED",
"SEQUEL INTEGRATED SOLUTIONS PRIVATE LIMITED",
"SEQUEL LOGISTICS PRIVATE LIMITED",
"SEQUEL MOTORS PRIVATE LIMITED",
"SEQUEL OUTSOURCING PRIVATE LIMITED",
"SEQUEL RESORTS LIMITED",
"SEQUELONE SOLUTIONS PRIVATE LIMITED",
"SEQUELSTRING AI PRIVATE LIMITED",
"SEQUENCE BIOTECH PRIVATE LIMITED",
"SEQUENCE COMMUNICATIONS PRIVATE LIMITED",
"SEQUENCE FERRO PRIVATE LIMITED",
"SEQUENT RESEARCH LIMITED",
"SEQUENT SCIENTIFIC LIMITED",
"SEQUENTIAL TECHNOLOGY INTERNATIONAL (INDIA) PRIVATE LIMITED",
"SEQUENTUM INDIA PRIVATE LIMITED",
"SEQUNCE GROUP",
"SEQUOIA ENERGY AND ENVIRONMENT PRIVATE LIMITED",
"SEQUOIA HEALTHCARE PRIVATE LIMITED",
"SEQUOIA SAFETY PRODUCTS PRIVATE LIMITED.",
"SEQUOIAAT INDIA PRIVATE LIMITED",
"SEQURETEK IT SOLUTIONS PRIVATE LIMITED",
"SER (TRANSPORT) PVT LTD",
"SERA COM PRIVATE LIMITED",
"SERA INVESTMENTS & FINANCE INDIA LIMITED",
"SERAC PACKAGING SOLUTION PRIVATE LIMITED",
"SERACHEM DIAGNOSTIC INDIA PRIVATE LIMITED",
"SERAGEN BIOTHERAPEUTICS PRIVATE LIMITED",
"SERAI EXPORTS PRIVATE LIMITED",
"SERAI PHARMA HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"SERAMA LOGISTICS PRIVATE LIMITED",
"SERAMPORE BIO VISION AGRO PVT. LTD.",
"SERAMPORE COLLEGE",
"SERAMPORE INDUSTRIES PVT LTD",
"SERAP INDIA PRIVATE LIMITED",
"SERAPH LIFE SCIENCES PRIVATE LIMITED",
"SERAPHIC ADVERTISING AND MARKETING PRIVATE LIMITED",
"SERAPHIC INFOSOLUTIONS PRIVATE LIMITED",
"SERAPHIC MANAGEMENT & ADVISORY PRIVATE LIMITED",
"SERAPHIM VENTURES PRIVATE LIMITED",
"SERARO SOLUTIONS LIMITED",
"SERBIA MOLECULES PRIVATE LIMITED",
"SERCO INDIA PRIVATE LIMITED",
"SERCON ELECTRO SYSTEMS PRIVATE LIMITED",
"SERCON INDIA PRIVATE LIMITED",
"SERDHA UTILITIES PRIVATE LIMITED",
"SEREIN SOFTWARE SOLUTIONS PRIVATE LIMITED",
"SERENDEBYTE TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"SERENDIP ADVISORS PRIVATE LIMITED",
"SERENDIP SOURCING PRIVATE LIMITED",
"SERENDIPITY ARTS PRIVATE LIMITED",
"SERENDIPITY BUILDTECH PRIVATE LIMITED",
"SERENDIPITY HOLIDAYS PRIVATE LIMITED",
"SERENDIPITY MOVERS PRIVATE LIMITED",
"SERENDIPITY TECHNOLOGIES PRIVATE LIMITED",
"SERENE CHARITABLE FOUNDATION",
"SERENE ESTATES PRIVATE LIMITED",
"SERENE HOSPITAL PRIVATE LIMITED",
"SERENE LIFEWORLD PRIVATE LIMITED",
"SERENE SENIOR LIVING PRIVATE LIMITED",
"SERENE VENTURES PRIVATE LIMITED",
"SERENESYS INFORMATION SOLUTIONS PRIVATE LIMITED",
"SERENGETI VENTURES PRIVATE LIMITED",
"SERENITAS INFRA PRIVATE LIMITED",
"SERENITY JEWELS PRIVATE LIMITED",
"SERENITY TRADES PRIVATE LIMITED",
"SERENTE ELECTRONICS PRIVATE LIMITED",
"SERENTICA RENEWABLES INDIA PRIVATE LIMITED",
"SERFIL PUMPS AND FILTERS PRIVATE LIMITED",
"SERGE FERRARI INDIA PRIVATE LIMITED",
"SERGE PHARMA PRIVATE LIMITED",
"SERGI TRANSFORMER EXPLOSION PREVENTION TEHCNOLOGIES PRIVATE LIMITED",
"SERGIO JOSH APPARELS PRIVATE LIMITED",
"SERGIO LEATHERS PRIVATE LIMITED",
"SERGUSA SOLUTIONS PRIVATE LIMITED",
"SERIA APPLIED RESEARCH PRIVATE LIMITED",
"SERIAL MICROELECTRONICS INDIA LLP",
"SERIATE MANIFOLD SOLUTIONS PRIVATE LIMITED",
"SERIES AUDIO SYSTEMS PVT LTD",
"SERITEC ELCTRONICS PRIVATE LIMITED",
"SERMAN INDIA ROAD MAKERS PVT LTD",
"SERO CORPORATE SOLUTIONS PRIVATE LIMITED",
"SEROJET FREIGHT ( I ) PRIVATE LIMITED",
"SEROLE INFO TECHNOLOGIES INDIA PRIVATE LIMITED",
"SERON CERAMICS PRIVATE LIMITED",
"SERON GRANITO PRIVATE LIMITED",
"SEROO MILLS PRIVATE LIMITED",
"SEROPLASMA BIOTECH PRIVATE LIMITED",
"SEROS DRILLING PRIVATE LIMITED",
"SEROS SHIPPING PRIVATE LIMITED",
"SEROSOFT SOLUTIONS PRIVATE LIMITED",
"SEROTONIN LABS INDIA PRIVATE LIMITED",
"SERPENT CONSULTING SERVICES PRIVATE LIMITED",
"SERPLEX TRADING PRIVATE LIMITED",
"SERRA FINE CHEMICALS PRIVATE LIMITED",
"SERTEL ELECTRONICS PRIVATE LIMITED",
"SERTINA TRADELINK PRIVATE LIMITED",
"SERTURNER LABS PRIVATE LIMITED",
"SERUM BIOTEC LIMITED",
"SERUM EDUCATIONAL SOCIETY",
"SERUM INSTITUTE LIFE SCIENCES PRIVATE LIMITED",
"SERUM INSTITUTE OF INDIA PRIVATE LIMITED",
"SERUSUARINA PRIVATE LIMITED",
"SERVASHANTI PROPERTIES PRIVATE LIMITED",
"SERVE FACILITY MANAGEMENT PRIVATE LIMITED",
"SERVE GOPESHWAR PULSES PRIVATE LIMITED",
"SERVE SMART SERVICES PRIVATE LIMITED",
"SERVE UTTAM VENTURES PRIVATE LIMITED",
"SERVEALL LAND DEVELOPERS PRIVATE LIMITED",
"SERVEL EXPRESS SERVICE PRIVATE LIMITED",
"SERVEL INDIA PRIVATE. LIMITED.",
"SERVEL SECURITY SERVICE",
"SERVELL BIO ENGINEERS PRIVATE LIMITED",
"SERVERCOM (INDIA) PRIVATE LIMITED",
"SERVESHWAR FOOD PRODUCTS PRIVATE LIMITED",
"SERVET FEEDS AND MINERALS PVT LTD",
"SERVEWELL FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"SERVEWELL HOUSE HOLD APPLIANCES",
"SERVEWELL INSTRUMENTS PRIVATE LIMITED",
"SERVICE 1ST BPM PRIVATE LIMITED",
"SERVICE CARE LIMITED",
"SERVICE CARE PRIVATE LIMITED",
"SERVICE EQUIPMENT INDIA PRIVATE LIMITED",
"SMC INTEGRATED FACILITY MANAGEMENT SOLUTIONS LIMITED",
"SERVICEAIDE SERVICE MANAGEMENT PRIVATE LIMITED",
"SERVICEBELL SOLUTIONS PRIVATE LIMITED",
"SERVICEBERRY TECHNOLOGIES PRIVATE LIMITED",
"SERVICEIO CONSULTANCY SERVICES LLP",
"SERVICELEE TECHSYSTEM SOLUTIONS PRIVATE LIMITED",
"SERVICEMAX FACILITY MANAGEMENT PRIVATE LIMITED",
"SERVICEMAX TECHNOLOGIES INDIA PRIVATE LIMITED",
"SERVICENOW SOFTWARE DEVELOPMENT INDIA PRIVATE LIMITED",
"SERVICEROCKET (INDIA) PRIVATE LIMITED",
"SERVICES LABS SOFTWARE PRIVATE LIMITED",
"SERVICOMATIC SERVICES PRIVATE LIMITED",
"SERVIER INDIA PRIVATE LIMITED",
"SERVILE RELOCATIONS PRIVATE LIMITED",
"SERVILINK ENGINEERS PRIVATE LIMITED",
"SERVILINK SYSTEMS LIMITED",
"SERVIMOS TECHNOLOGIES PRIVATE LIMITED",
"SERVIN HEALTHCARE PRIVATE LIMITED",
"SERVIO DIALYSIS CLINIX PRIVATE LIMITED",
"SERVION GLOBAL SOLUTIONS PRIVATE LIMITED",
"SERVION T GLOBAL SOLUTIONS LIMITED",
"SERVITIUM IT SOLUTIONS PRIVATE LIMITED",
"SERVITIUM MICRO FINANCE PRIVATE LIMITED",
"SERVITUS CORPORATE SERVICES PRIVATE LIMITED",
"SERVIUS INFOTECH PRIVATE LIMITED",
"SERVIZ4U NETWORKS INDIA PRIVATE LIMITED",
"SERVM ADVANCE SYSTEMS PRIVATE LIMITED",
"SERVO HYDRAULICS PRIVATE LIMITED",
"SERVO PACKAGING LIMITED",
"SERVO PLASTICHEM PRIVATE LIMITED",
"SERVO PLASTICS PRIVATE LIMITED",
"SERVO POLYTECH COIMBATORE PRIVATE LIMITED",
"SERVO TECHNO SALES",
"SERVOCARE LIFESCIENCES PRIVATE LIMITED",
"SERVOCONTROLS & HYDRAULICS I PRIVATE LIMITED",
"SERVOCONTROLS AEROSPACE INDIA PRIVATE LIMITED",
"SERVOCRAFT HR SOLUTIONS PRIVATE LIMITED",
"SERVODAY PLANTS & EQUIPMENTS LIMITED",
"SERVOKON SYSTEMS PRIVATE. LIMITED",
"SERVOLUTION SERVICES PRIVATE LIMITED",
"SERVOLUTION SYSTEMS PRIVATE LIMITED",
"SERVOMAX LIMITED",
"SERVOSTAR INDIA PRIVATE LIMITED",
"SERVOTECH ELECTRICALS PRIVATE LIMITED",
"SERVOTECH INDIA LIMITED",
"SERVOTECH INDIA PRIVATE LIMITED",
"SERVOTECH POWER SYSTEMS LIMITED",
"SERVPRO TECHNOLOGIES PRIVATE.LIMITED",
"SERVSOFT TECHNOLOGIES PRIVATE LIMITED",
"SERVSTAFFING INDIA PRIVATE LIMITED",
"SERVSYS TECHNOLOGY SERVICES INDIA PRIVATE LIMITED",
"SERVTECH SYSTEMS INDIA PRIVATE LIMITED",
"SERVTEK IT PRIVATE LIMITED",
"SERVVEL LUBRICANTS AND CHEMICALS PRIVATE LIMITED",
"SERVWHIZ INDIA PRIVATE LIMITED",
"SERWELL CARGO INDIA PRIVATE LIMITED",
"SERWELL MEDI EQUIP PRIVATE LIMITED",
"SES ENGINEERING PRIVATE LIMITED",
"SES ENVIRONMENTAL SERVICES PRIVATE LIMITED",
"SES FACILITY MANAGEMENT PRIVATE LIMITED",
"SESA CARE PRIVATE LIMITED",
"SESA CHEM INDIA PRIVATE LIMITED",
"SESA INDIA PRIVATE LIMITED",
"SESA MINING CORPORATION LIMITED",
"SESA RESOURCES LIMITED",
"SESAGOA PRIVATE LIMITED",
"SESAME GROUP INDIA PRIVATE LIMITED",
"SESAME SOFTWARE SOLUTIONS PRIVATE LIMITED",
"SESAME TECHNOLOGIES PRIVATE LIMITED",
"SESAME WORKSHOP INITIATIVES INDIA PRIVATE LIMITED",
"SESAT SOLUTIONS PRIVATE LIMITED",
"SESCON BUILDERS PRIVATE LIMITED",
"SESDERMA INDIA PRIVATE LIMITED",
"SESHA BALAJEE MEDISOLUTIONS PRIVATE LIMITED",
"SESHA SAI CHEMICALS PRIVATE LIMITED",
"SESHA SAI COTTON COMPANY",
"SESHA TOOLS PRIVATE LIMITED",
"SESHAASAI BUSINESS FORMS PRIVATE LIMITED",
"SESHAASAI E-FORMS PRIVATE LIMITED",
"SESHADRI RAO GUDLAVALLERU ENGINEERING COLLEGE",
"SESHADRIPURAM COLLEGE",
"SESHADRIPURAM COMPOSITE COLLEGE",
"SESHADRIPURAM DEGREE COLLEGE",
"SESHADRIPURAM EVENING COLLEGE",
"SESHASAI QUARTZITE PRIVATE LIMITED",
"SESHASAYANA MINERALS PRIVATE LIMITED",
"SESHASAYEE INSTITUTE OF TECHNOLOGY",
"SESHASAYEE KNITTINGS PVT LTD",
"SESHASAYEE PAPER AND BOARDS LIMITED",
"SESHU NUTRITION PRIVATE LIMITED",
"SESLONG TRADERS PRIVATE LIMITED",
"SESOLA POWER PROJECTS PRIVATE LIMITED",
"SESOTEC INDIA PRIVATE LIMITED",
"SESTA DEVELOPMENT SERVICES",
"SET CLASSES (OPC) PRIVATE LIMITED",
"SET INFOTECH PRIVATE LIMITED",
"SET IT UP TECHNOLOGIES INDIA PRIVATE LIMITED",
"SET ON SITE ELECTRICALS PVT LTD",
"SET PU COLLEGE",
"SETA ENGINEERS PRIVATE LIMITED",
"SETCO AUTOMOTIVE LIMITED",
"SETCO CHEMICALS INDIA PRIVATE LIMTED",
"SETCO ENGINEERING PRIVATE LIMITED",
"SETCO SPINDLES INDIA PRIVATE LIMITED",
"SETCOM ENGINEERS INDIA PRIVATE LIMITED",
"SE-TEST LAB INSTRUMENTS INDIA PRIVATE LIMITED",
"SETH ANANDRAM JAIPURIA SCHOOL",
"SETH BANSHIDHAR KEDIA CHAWAL PRIVATE LIMITED",
"SETH BROTHERS (PERFUMERS ) PRIVATE LTD",
"SETH C K HIGH SCHOOL",
"SETH C L HINDI HIGH SCHOOL",
"SETH GOVIND RAGHUNATH SABLE COLLEGE OF PHARMACY",
"SETH GS MEDICAL COLLEGE MULTIDISCIPLINARY RESEARCH UNIT",
"SETH INDIA CHEMPEST PRIVATE LIMITED",
"SETH INDUSTRIAL CORPORATION",
"SETH IRON AND STEEL PRIVATE LIMITED",
"SETH LIFTERS PRIVATE LIMITED",
"SETH M R JAIPURIA SCHOOL LUCKNOW",
"SETH NANDLAL DHOOT CHARITABLE HOSPITAL",
"SETH PARASRAM PARUMAL NEW ENGLISH HIGH SCHOOL & JR COLLEGE",
"SETH PEST CONTROL PRIVATE LIMITED",
"SETH PRASAD AGRO PRIVATE LIMITED",
"SETH RATAN LAL ENTERTAINMENTS PRIVATE LIMITED",
"SETH SHRI STRIPS PRIVATE LIMITED",
"SETH STEELAGE PRIVATE LIMITED",
"SETH SURAJMAL JALAN GIRLS COLLEGE",
"SETH TARACHAND RAMNATH CHARITABLE AYURVEDIC HOSPITAL",
"SETH TEXFAB PRIVATE LIMITED",
"SETH THAKURDAS KHINVRAJ PVT LTD",
"SETH TRADING CO. LTD.",
"SETHI & SETHI COMFORT PRODUCTS PRIVATE LIMITED",
"SETHI AGRITECH PRIVATE LIMITED",
"SETHI BROTHERS PRIVATE LIMITED",
"SETHI BUILDCON PRIVATE LIMITED",
"SETHI DIAGNOSTIC & MEDICARE PRIVATE LIMITED",
"SETHI FILASPUN PRIVATE LIMITED",
"SETHI FLOUR MILLS PRIVATE LIMITED",
"SETHI FOREX PRIVATE LIMITED",
"SETHI GLASSES PRIVATE LIMITED",
"SETHI HOSPITAL PRIVATE LIMITED",
"SETHI HOTELS PRIVATE LIMITED",
"SETHI INFRATECH PRIVATE LIMITED",
"SETHI JEWELS PRIVATE LIMITED",
"SETHI PACKERS PRIVATE LIMITED",
"SETHI PHARMA DISTRIBUTORS PRIVATE LIMITED",
"SETHI SEEDS INDIA PRIVATE LIMITED",
"SETHI SILK AND SAREES PRIVATE LIMITED",
"SETHIA AGRO INDUSTRIES PRIVATE LIMITED",
"SETHIA AGROTECK LIMITED",
"SETHIA FOODS PRIVATE LIMITED",
"SETHIA HANDICRAFTS PRIVATE LIMITED",
"SETHIA INFRASTRUCTURE PRIVATE LIMITED",
"SETHIA JAIN & CO LTD",
"SETHIA KNIT FAB PVT LTD",
"SETHIA OIL INDUSTRIES LIMITED",
"SETHIA OILS LTD",
"SETHIA POLYMERS PRIVATE LIMITED",
"SETHIA SAREES PRIVATE LIMITED",
"SETHIYA CHEMICALS PRIVATE LIMITED",
"SETHIYA EXPORTS PRIVATE LIMITED",
"SETHIYA WEAVES INDIA PRIVATE LIMITED",
"SETHNA CONSTRUCTIONS PVT LTD",
"SETHNESS-ROQUETTE INDIA LIMITED",
"SETHU EDUCATIONAL TRUST",
"SETHU HEALTHCARE LLP",
"SETHU INSTITUTE OF TECHNOLOGY",
"SETHUSAMUDRAM CORPORATION LIMITED",
"SETHWALA FOODS LIMITED",
"SETIA AUTO FINANCE PRIVATE LIMITED",
"SETIA ELECTRICALS (INDIA) PRIVATE LIMITED",
"SETIA WOOLLENS PRIVATE LIMITED",
"SETLITE ENGINEERS LIMITED",
"SETRAWA STEELS PRIVATE LIMITED",
"SETRON INDIA PRIVATE LIMITED",
"SETS",
"SETT IRON FOUNDRY PRIVATE LIMITED",
"SETTLEMENT COMMI OF LAND RECD",
"SETTLEMENT DEPTT",
"SETTLEMENT OFFICER CONSOLIDATION",
"SETTLEMENT OFFICER JOBRA CUTTACK",
"SETTLEMINT INDIA SERVICES PRIVATE LIMITED",
"SETTLRS VENTURE PRIVATE LIMITED",
"SETTY MECH ENGINEERS PRIVATE LIMITED",
"SETU ADVERTISING PRIVATE LIMITED",
"SETU BUILDCON PRIVATE LIMITED",
"SETU E-TAIL PRIVATE LIMITED",
"SETU INFRA CONSULTING ENGINEERS PRIVATE LIMITED",
"SETU JOY PRIVATE LIMITED",
"SETU NEONATAL CARE PRIVATE LIMITED",
"SETU PAPERS PRIVATE LIMITED",
"SETU PRAKASHAN PRIVATE LIMITED",
"SETU SECURITIES PRIVATE LIMITED",
"SETUZ SALES PRIVATE LIMITED",
"SEUNDO ENERGY PRIVATE LIMITED",
"SEUTIC LABS PRIVATE LIMITED",
"SEUTIC PHARMA PRIVATE LIMITED",
"SEVA AT HOME INDIA PRIVATE LIMITED",
"SEVA AUTOMOTIVE PRIVATE LIMITED",
"SEVA CHIKAN LUCKNOW PRIVATE LIMITED",
"SEVA CHIKAN PRIVATE LIMITED",
"SEVA ENGINEERING WORKS PVT LTD ,",
"SEVA FACILITY SERVICES PRIVATE LIMITED",
"SEVA GASES INDIA PRIVATE LIMITED",
"SEVA GLOBAL LOGISTICS SOLUTIONS PRIVATE LIMITED",
"SEVA HOSPITAL",
"SEVA MANDAL EDUCATION SOCIETY",
"SEVA MOBILE & MULTISERVICES PRIVATE LIMITED",
"SEVA PRIME ENERGY PRIVATE LIMITED",
"SEVA RESORTS AND ESTATES PRIVATE LIMITED",
"SEVA SAHAKARI SANSTHA MARYADIT",
"SEVA SAHAYOG FOUNDATION",
"SEVAARTH CRITICARE SERVICES PRIVATE LIMITED",
"SEVADAL WOMEN COLLEGE",
"SEVAEL TECHNOLOGIES PRIVATE LIMITED",
"SEVAGRAM WARDHA ROADWAYS PRIVATE LIMITED",
"SEVAK PUBLICATIONS PRIVATE LIMITED",
"SEVAKUNJ HOSPITAL AND RESEARCH CENTER",
"SEVALAL FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"SEVALAYA PHARMACY PRIVATE LIMITED",
"SEVAMOB VENTURES PRIVATE LIMITED",
"SEVANA ELECTRICAL APPLIANCES PVT LTD",
"SEVANA HYGIENE PRODUCTS PRIVATE LIMITED",
"SEVANA MEDINEEDS PRIVATE LIMITED",
"SEVARTH SEVA UDYOG",
"SEVARTH SEVA UDYOG LLP",
"SEVASADAN LIFELINE PRIVATE LIMITED",
"SEVASADAN NIRAMAY PRIVATE LIMITED",
"SEVASADAN PRATHMIK SHALA",
"SEVASUPREME DETECTIVE AND SECURITY SERVICES PRIVATE LIMITED",
"SEVAYATAN MATERNITY AND GENERAL HOSPITAL",
"SEVCON INDIA PRIVATE LIMITED",
"SEVEILLAR CLINICAL SUPPLIES SERVICES PRIVATE LIMITED",
"SEVEN ALPHA INVESTORS PRIVATE LIMITED",
"SEVEN ARTS INTERNATIONAL LIMITED",
"SEVEN BANKING MANAGEMENT",
"SEVEN BEANS COFFEE COMPANY PRIVATE LIMITED",
"SEVEN DAWN SOLUTIONS PRIVATE LIMITED",
"SEVEN DAYS FOODS PVT.LTD.",
"SEVEN ELEVEN CONSTRUCTION PRIVATE LIMITED",
"SEVEN ELEVEN HOTELS PRIVATE LIMITED",
"SEVEN ELIFE ENERGIES SYSTEM PRIVATE LIMITED",
"SEVEN ENERGIES LIMITED",
"SEVEN FOLD CROP SCIENCE PRIVATE LIMITED",
"SEVEN GREENS SOLAR SYSTEMS PRIVATE LIMITED",
"SEVEN HILL INDUSTRIES LIMITED",
"SEVEN HILLS AUTOMOBILE PRIVATE LIMITED",
"SEVEN HILLS BEVERAGES LIMITED",
"SEVEN HILLS DIGITAL PARK PRIVATE LIMITED",
"SEVEN HILLS FACILITY SERVICES PRIVATE LIMITED",
"SEVEN HILLS INFOTECH PRIVATE LIMITED",
"SEVEN HILLS MATRIMONY",
"SEVEN HILLS MINERALS PRIVATE LIMITED",
"SEVEN HILLS OPTICOMMUNICATION PRIVATE LIMITED",
"SEVEN HILLS PAPER PRIVATE LIMITED",
"SEVEN HILLS PEB SYSTEMS PRIVATE LIMITED",
"SEVEN HILLS SOLVENTS PRIVATE LIMITED",
"SEVEN HILLS TELECOM SUPPORT LLP",
"SEVEN INKS BUSINESS SOLUTIONS PRIVATE LIMITED",
"SEVEN ISLANDS LOGISTICS PRIVATE LIMITED",
"SEVEN ISLANDS MARITIME TRAINING INSTITUTE",
"SEVEN ISLANDS SHIPPING LIMITED",
"SEVEN ISLANDS VENTURES PRIVATE LIMITED",
"SEVEN ISLES CAMBRIDGE INTERNATIONAL SCHOOL",
"SEVEN ISLES INTERNATIONAL SCHOOL",
"SEVEN LEAF INDIA BUILDERS PRIVATE LIMITED",
"SEVEN LEISURE PRIVATE LIMITED",
"SEVEN N CONSULTING PRIVATE LIMITED",
"SEVEN OAKS DISTILLERIES PRIVATE LIMITED",
"SEVEN OCEAN SYNTEX PRIVATE LIMITED",
"SEVEN OCEANS LEASING & INFRASTRUCTURE DEVELOPMENT PRIVATE LIMITED",
"SEVEN OCEANS TELESERVICES PRIVATE LIMITED",
"SEVEN PEAKS WINERY PRIVATE LIMITED",
"SEVEN POINT MOTORS PRIVATE LIMITED",
"SEVEN RANGERS HEALTHCARE PRIVATE LIMITED",
"SEVEN S BANKING MANAGEMENT CONSULTANCY SERVICES PRIVATE LIMITED",
"SEVEN SEAS COLOR PRIVATE LIMITED",
"SEVEN SEAS DISTILLERY PRIVATE LIMITED",
"SEVEN SEAS GLOBAL PRIVATE LIMITED",
"SEVEN SEAS HOSPITALITY PRIVATE LIMITED",
"SEVEN SEAS HUMAN RESOURCE SERVICES PRIVATE LIMITED",
"SEVEN SEAS INDCHEM LIMITED",
"SEVEN SEAS INTERNATIONAL PVT LTD",
"SEVEN SEAS KITCHENS PRIVATE LIMITED",
"SEVEN SEAS MARITIME AGENCIES",
"SEVEN SEAS PAINTS PRIVATE LIMITED",
"SEVEN SEAS PETROLEUM PRIVATE LIMITED",
"SEVEN SEAS POLYMERS PRIVATE LIMITED",
"SEVEN SEAS RESORTS PRIVATE LIMITED",
"SEVEN SEAS STEELS PRIVATE LIMITED",
"SEVEN SEAZ VACATIONS LIMITED",
"SEVEN SEAZ VACATIONS PRIVATE LIMITED",
"SEVEN SEVEN CONSULTING SOLUTIONS LLP",
"SEVEN SISTERS PLASTICS PRIVATE LIMITED",
"SEVEN SKY ENTERTAINMENT PRIVATE LIMITED",
"SEVEN SKY EXIM PRIVATE LIMITED",
"SEVEN SQUARE ACADEMY",
"SEVEN STAR AIRCON ANCILLARIES PRIVATE LIMITED",
"SEVEN STAR DHALL INDUSTRIES",
"SEVEN STAR DIGICOMM PRIVATE LIMITED",
"SEVEN STAR DIGITAL NETWORKS",
"SEVEN STAR DIGITAL NETWORKS PRIVATE LIMITED",
"SEVEN STAR DOT COM PRIVATE LIMITED",
"SEVEN STAR FOILS PRIVATE LIMITED",
"SEVEN STAR FORWARDING AND LOGISTICS PRIVATE LIMITED",
"SEVEN STAR FRUITS PRIVATE LIMITED",
"SEVEN STAR HOTEL AND RESORTS PRIVATE LIMITED",
"SEVEN STAR MULTISPECIALITY HOSPITAL AND RESERCH CENTRE",
"SEVEN STAR POLYMERS PRIVATE LIMITED",
"SEVEN STAR PROJECTS PRIVATE LIMITED",
"SEVEN STAR PROPERTIES PRIVATE LIMITED",
"SEVEN STAR STEELS LIMITED",
"SEVEN STAR WEDDING STUDIO PRIVATE LIMITED",
"SEVEN STARS INTELLIGENT SECURITY (I) PRIVATE LIMITED",
"SEVEN STARS WEDDING GALLERY PRIVATE LIMITED",
"SEVEN TREES INFRATECH PRIVATE LIMITED",
"SEVEN WAREHOUSING AND INFRASTRUCTURE PRIVATE LIMITED",
"SEVEN WONDERS VACATIONS PRIVATE LIMITED",
"SEVENAIRE INDIA PRIVATE LIMITED",
"SEVENBRO WATER TREATMENT COMPONENTS INDIA PRIVATE LIMITED",
"SEVENEDGE REALTECH PRIVATE LIMITED",
"SEVENHILLS HOSPITALITY PRIVATE LIMITED",
"SEVENHILLS INTERNATIONAL LLP",
"SEVENHILLS MINING & CONSTRUCTION COMPANY INDIA PVT LTD",
"SEVENLAKES TECHNOLOGIES PRIVATE LIMITED",
"SEVENS HOTELS PRIVATE LIMITED",
"SEVENSEAS GLOBAL EXPRESS LOGISTICS PRIVATE LIMITED",
"SEVENSEAS GLOBAL FREIGHT SYSTEMS PRIVATE LIMITED",
"SEVENSEAS PROMOTERS PRIVATE LIMITED",
"SEVENSEAS SHANTI EDUTECH PRIVATE LIMITED",
"SEVENSEAS SUPPLYCHAIN SOLUTIONS PRIVATE LIMITED",
"SEVENSKYZ GLOBAL LOGISTICS PRIVATE LIMITED",
"SEVENSTAR AGRO PRODUCTS PRIVATE LIMITED",
"SEVENSTAR HOSPITAL",
"SEVENSTAR POLYTEX PRIVATE LIMITED",
"SEVENSTAR REALTEK PRIVATE LIMITED",
"SEVENTAURUS ENTERTAINMENT STUDIO PRIVATE LIMITED",
"SEVENTEEN DEGREES HOTEL CO PVT LTD",
"SEVENTH DAY ADVENTIST HIGHER SECONDARY SCHOOL",
"SEVENTH DAY ADVENTIST PUBLISHING ASSOCIATION",
"SEVENTH PLANE NETWORKS PRIVATE LIMITED",
"SEVENTH SENSE MEDIA PRIVATE LIMITED",
"SEVENTH SENSE PEOPLE DEVELOPMENT SOLUTIONS PRIVATE LIMITED",
"SEVENTH SENSE REALITY DEVELOPERS PRIVATE LIMITED",
"SEVENTH TRIANGLE CONSULTING PRIVATE LIMITED",
"SEVENTH-DAY ADVENTIST MEDICAL CENTRE",
"SEVENTY SEVEN ENTERTAINMENT PRIVATE LIMITED",
"SEVENTY2 HOSPITALITY SERVICES PRIVATE LIMITED",
"SEVENTYTHREE LINES DEVELOPMENT PRIVATE LIMITED",
"SEVERN GLOCON INDIA PRIVATE LIMITED",
"SEVERN GLOCON VALVES PRIVATE LIMITED",
"SEVI INFOTECH PRIVATE LIMITED",
"SEVITAM DEVCON PRIVATE LIMITED",
"SEVITECH SYSTEMS PRIVATE LIMITED",
"SEVO SYSTEM HUB PRIVATE LIMITED",
"SEVOKE MOTORS PRIVATE LIMITED",
"SEVRIN CHEMICALS PRIVATE LIMITED",
"SEVYA MULTIMEDIA TECHNOLOGIES PRIVATE LIMITED",
"SEVYAM TRADEXIM PRIVATE LIMITED",
"SEW BELLARY HIGHWAYS LIMITED",
"SEW ENGINEERING INDIA PRIVATE LIMITED.",
"SEW ENGINEERING WORKS PRIVATE LTD",
"SEW EURODRIVE INDIA PRIVATE LIMITED",
"SEW FACILITY MANAGEMENT PRIVATE LIMITED",
"SEW INFOTECH PRIVATE LIMITED",
"SEW KRISHNAGAR BAHARAMPORE HIGHWAYS LIMITED",
"SEW PRIVATE LIMITED",
"SEW SERVICES PRIVATE LIMITED",
"SEW SURFACE COATING PRIVATE LIMITED",
"SEW WATER TREATMENT PRIVATE LIMITED",
"SEWA BHARATI UTTAR BUNIYADI VIDYALAYA SEWAPURI",
"SEWA ELECTRICAL INDUSTRIES PRIVATE LIMITED",
"SEWA GRIH RIN LIMITED",
"SEWA INTERNATIONAL FASHIONS LIMITED",
"SEWA PRESERVATORS PRIVATE LIMITED",
"SEWA RAM OVERSEAS (INDIA) PRIVATE LIMITED",
"SEWA TRADE FACILITATION CENTRE",
"SEWAK FORGING PRIVATE LIMITED",
"SEWAK ICE AND COLD STORAGE PRIVATE LIMITED",
"SEWAK INFRABUILD PRIVATE LIMITED",
"SEWASONS ENTERPRISES LIMITED",
"SEWERAGE & INFRASTRUCTURAL DEVELOPMENT CORPORATION OF GOA LIMITED",
"SEW-EURODRIVE INDIA PRIVATE LIMITED",
"SEWING SYSTEMS PRIVATE LIMITED",
"SEWLI HIGH SCHOOL HS",
"SEWRI ENGINEERING COMPANY PRIVATE LIMITED",
"SEWTECH INDUSTRIES PRIVATE LIMITED",
"SEWUJPUR TEA CO. (P) LTD",
"SEYAD AGRO INDUSTRIES PRIVATE LIMITED",
"SEYAD COTTON MILLS PRIVATE LIMITED",
"SEYAD HOME INDUSTRIES PRIVATE LIMITED",
"SEYAD SHARIAT FINANCE LIMITED",
"SEYAL TECHNOLOGIES PRIVATE LIMITED",
"SEYFERTSOFT PRIVATE LIMITED",
"SEYGEN TECHNOLOGIES INDIA PRIVATE LIMITED",
"SEYMORE PRINT PRIVATE LIMITED",
"SEYON INNOVATIVE ENGINEERING INDIA PRIVATE LIMITED",
"SEYON LOGISTICS PRIVATE LIMITED",
"SEYOON TEKNOLOGIES PRIVATE LIMITED",
"SEZ BIOTECH SERVICES PRIVATE LIMITED",
"SEZ SERVICES PRIVATE LIMITED",
"SEZ VITRIFIED PRIVATE LIMITED",
"SEZON PAPERS PRIVATE LIMITED",
"SF CREATION PRIVATE LIMITED",
"SF DYES",
"SF ENGINEERING SYSTEMS (INDIA) PRIVATE LIMITED",
"SF LOGISTICS PRIVATE LIMITED",
"SF OIL SOLUTIONS PRIVATE LIMITED",
"SF SLEEVINGS PRIVATE LIMITED",
"SFA FOOD AND PHARMA INGREDIENTS PRIVATE LIMITED",
"SFA LOGISTICS PARK PRIVATE LIMITED",
"SFA PRINT PRIVATE LIMITED",
"SFA TECHNOLOGIES PRIVATE LIMITED",
"SFABRICS INDIA PRIVATE LIMITED",
"SFAKIA AGROTECH (OPC) PRIVATE LIMITED",
"SFC COLD CHAIN LOGISTICS PRIVATE LIMITED",
"SFC ENVIRONMENTAL TECHNOLOGIES PRIVATE LIMITED",
"SFC FOODS PRIVATE LIMITED",
"SFC GLOBAL COMMODITY PRIVATE LIMITED",
"SFC INFRACON PRIVATE LIMITED",
"SFC LIFESTYLES PRIVATE LIMITED",
"SFC SOLUTIONS INDIA FLUID PRIVATE LIMITED",
"SFC SOLUTIONS INDIA SEALING PRIVATE LIMITED",
"SFC TRANSPORT PRIVATE LIMITED",
"SFC TURBO VENTILATOR PRIVATE LIMITED",
"SFG EXPORTS (INDIA) PRIVATE LIMITED",
"SFI FINANCIAL SERVICES PRIVATE LIMITED",
"SFIC FISCAL SERVICES PVT LTD",
"SFJ BUSINESS SOLUTIONS PRIVATE LIMITED",
"SFJ TECHNOLOGIES PRIVATE LIMITED",
"SFK INDUSTRIES PRIVATE LIMITED",
"SFL HEARING SOLUTIONS PRIVATE LIMITED",
"SFLHUB TECHNOLOGIES PRIVATE LIMITED",
"SFO TECHNOLOGIES PRIVATE LIMITED",
"SFO TECHNOLOGIES SOLUTIONS PRIVATE LIMITED",
"S FORM INDIA PRIVATE LIMITED",
"SFP FOODS PRIVATE LIMITED",
"SFP SONS INDIA PRIVATE LIMITED",
"SFPL GLOBAL TRADEWINGS PRIVATE LIMITED",
"SFR FOOTWEAR PRIVATE LIMITED",
"SFS ACADEMY",
"SFS BUSINESS SOLUTIONS PRIVATE LIMITED",
"SFS EQUIPMENTS PRIVATE. LIMITED.",
"SFS FIRE PROTECTION INDIA PRIVATE LIMITED",
"SFS GLOBAL LIMITED.",
"SFS GROUP INDIA PRIVATE LIMITED",
"SFS PHARMA LOGISTICS PRIVATE LIMITED",
"SFT TECHNOLOGIES PRIVATE LIMITED",
"SFX ENTERTAINMENT TECHNOLOGIES PRIVATE LIMITED",
"SG ACADEMIC ESTABLISHMENTS PRIVATE LIMITED",
"SG AEROSPACE (INDIA) PRIVATE LIMITED",
"SG AIR TRAVEL PRIVATE LIMITED",
"SG ANALYTICS PRIVATE LIMITED",
"SG AND COMPANY PRIVATE LIMITED",
"SG ASIA HOLDINGS INDIA PRIVATE LIMITED",
"SG BULLION IMPEX PRIVATE LIMITED",
"SG CLEARING PRIVATE LIMITED",
"SG CORPORATE MOBILITY PRIVATE LIMITED",
"SG DEGREE BED PRASHIKSHAN KENDRA",
"SG DIET CAFE PRIVATE LIMITED",
"SG ENTERPRISES",
"SG EXIM",
"SG EXOTIC DESTINATION PLANNERS PRIVATE LIMITED",
"SG EXPORTS",
"SG FINSERVE LIMITED",
"SG FOODS PRIVATE LIMITED",
"SG GREEN PROJECTS PRIVATE LIMITED",
"SG GROUP AGRISCIENCE PRIVATE LIMITED",
"SG HEALTHCARE PRIVATE LIMITED",
"SG HEALTHCARE SYSTEM",
"SG HEAVY ENGINEERING LIMITED",
"SG HEAVY ENGINEERING PRIVATE LIMITED",
"SG INSTITUTE OF MANAGEMENT STUDIES PRIVATE LIMITED",
"SG INTERNATIONAL",
"SG LEGALS PRIVATE LIMITED",
"SG LIFECARE PRIVATE LIMITED",
"SG MANUFACTURING COMPANY DELHI PVT LTD",
"SG MART LIMITED",
"SG METALS AND STEELS INDIA PRIVATE LIMITED",
"SG PACKAGING SOLUTION PRIVATE LIMITED",
"SG PILING AND CONSTRUCTION PRIVATE LIMITED",
"SG PNEUMATICS PRIVATE LIMITED",
"SG POWER PRODUCTS PRIVATE LIMITED",
"SG PROBUILD PRIVATE LIMITED",
"SG REALTOR PRIVATE LIMITED",
"SG RENEWABLE ENERGY PRIVATE LIMITED",
"SG SALONS PRIVATE LIMITED",
"SG SHINAGAWA REFRACTORIES INDIA PRIVATE LIMITED",
"SG SNACK FOOD PRIVATE LIMITED",
"SG UDYOG PRIVATE LIMITED",
"SGA ALLOYS PRIVATE LIMITED",
"SGA CARS INDIA PRIVATE LIMITED",
"SGA INFRAPROJECT PRIVATE LIMITED",
"SGA POLYCHEM PRIVATE LIMITED",
"SGA POWER SYSTEMS PRIVATE LIMITED",
"SGA PROJECTS PRIVATE LIMITED",
"SGB BRANDSAFWAY PRIVATE LIMITED",
"SGB FOOD PRODUCTS PRIVATE LIMITED",
"SGB INFRA LIMITED",
"SGB TRANSFORMERS INDIA PRIVATE LIMITED",
"SGBIOMED INDIA PRIVATE LIMITED",
"SGBL AUTOMOBILES PRIVATE LIMITED",
"SGBL RETAILS PRIVATE LIMITED",
"SGBLINDIALIMITED",
"SGBS UNNATI FOUNDATION",
"SGC LOGISTIC SOLUTIONS LIMITED",
"SGC MAGICRETE LLP",
"SGC MANAGEMENT SERVICES PRIVATE LIMITED",
"SGC SERVICES P LIMITED",
"SGCA GROUP",
"SGD FOREX PRIVATE LIMITED",
"SGD PHARMA INDIA PRIVATE LIMITED",
"SGDC INDIA PRIVATE LIMITED",
"SGE CONTROLS AND SWITCHGEAR PRIVATE LIMITED",
"SGE MART INDIA PRIVATE LIMITED",
"S-GEN CONSORTIUM INFRA PRIVATE LIMITED",
"SGEPL INFRASTRUCTURE PRIVATE LIMITED",
"SGES LAND AND MARINE CONSTRUCTIONS PRIVATE LIMITED",
"SGF CONSULTANCY SERVICES PRIVATE LIMITED",
"SGF INDUSTRIES PRIVATE LIMITED",
"SGG INDIA OVERSEAS PRIVATE LIMITED",
"SGGG INDIA PRIVATE LIMITED",
"SGGN EXPORTS PRIVATE LIMITED",
"SGGS INSTITUTE OF ENGINEERING AND TECHNOLOGY VISHNUPURI NANDED",
"SGI AUTOMATION PRIVATE LIMITED",
"SGI AUTOMOTIVE PRIVATE LIMITED",
"SGI ENGINEERS PRIVATE LIMITED",
"SGI ISPAT PRIVATE LIMITED",
"SGI STUDIO GALLI INGEGNERIA INDIA PRIVATE LIMITED",
"SGIC CLOUD TECHNOLOGIES INDIA PRIVATE LIMITED",
"SGIPL STUDY GROUP INDIA PRIVATE LIMITED",
"SGJ AUTOCARE P LIMITED",
"SGJ DENIMS PRIVATE LIMITED",
"SGK FINVEST PRIVATE LIMITED",
"SGK INDIA ENGINEERING PRIVATE LIMITED",
"SGK INTERNATIONAL PRIVATE LIMITED",
"SGK PROJECTS PRIVATE LIMITED",
"SGL CARBON INDIA PRIVATE LIMITED",
"SGL CHARITABLE HOSPITAL",
"SGL CONTAINER LINE PRIVATE LIMITED",
"SGL LABS (INTERNATIONAL) PRIVATE LIMITED",
"SGL LABS PRIVATE LIMITED",
"SGL LINE INDIA PRIVATE LIMITED",
"SGLOBAL ACUMEN PRIVATE LIMITED",
"SGM BUILDERS PVT LTD",
"SGM ENERGY PRIVATE LIMITED",
"SGM ENVIRO (INDIA) PRIVATE LIMITED",
"SGM HOSPITALITIES PRIVATE LIMITED",
"SGM INDIA PRIVATE LIMITED",
"SGM INFRATECH PRIVATE LIMITED",
"SGM MAGNETICS INDIA PRIVATE LIMITED",
"SGM PACKAGING INDUSTRIES",
"SGM SOFTWARE PRIVATE LIMITED",
"SGMD EXPORT PRIVATE LIMITED",
"SGMG CONSTRUCTION PRIVATE LIMITED",
"SGMLAB SOLUTIONS PRIVATE LIMITED",
"SGMM ORES PRIVATE LIMITED",
"SGN ELECTRONICS PRIVATE LIMITED",
"SGN ENTERPRISES PRIVATE LIMITED",
"SGN GLOBAL LOGISTICS PRIVATE LIMITED",
"SGN PACKAGING PRIVATE LIMITED",
"SGN SOFTWARE PRIVATE LIMITED",
"SGN UNIVERSAL CONSTRUCTION CO. PRIVATE. LIMITED.",
"SGN VENTURES PRIVATE LIMITED",
"SGP PRODUCTS PRIVATE LIMITED",
"SGP R&D INDIA PRIVATE LIMITED",
"SGPHARMA PRIVATE LIMITED",
"SGPIPL CHANDRAPUR POMBHURNA PROJECTS PRIVATE LIMITED",
"SGPV ESTATES PRIVATE LIMITED",
"SGR 777 FOODS PRIVATE LIMITED",
"SGR EXIM PRIVATE. LIMITED.",
"SGR LOGISTICS PRIVATE LIMITED",
"SGR VENTURES PRIVATE LIMITED",
"SGRD HEALTHCARE PRIVATE LIMITED",
"SGS AUTOWHEELS PRIVATE LIMITED",
"SGS CHEMICALS PRIVATE LIMITED",
"SGS ENVIROTECH PRIVATE LIMITED",
"SGS FOOD PRODUCTS PRIVATE LIMITED",
"SGS FOREX PRIVATE LIMITED",
"SGS GLOBAL SERVICES PRIVATE LIMITED",
"SGS INDUSTRIAL CONTROLS AND SOLUTIONS PRIVATE LIMITED",
"SGS INFO SOLUTIONS PRIVATE LIMITED",
"SGS INFRASERVICES PRIVATE LIMITED",
"SGS INFRATECH LIMITED",
"SGS IRON AND STEELS PRIVATE LIMITED",
"SGS MARINE HABITABILITY PRIVATE LIMITED",
"SGS MEDTRANS SOLUTIONS PRIVATE LIMITED",
"SGS MULTISPECIALITY HOSPITAL",
"SGS PRIVATE LIMITED",
"SGS STOCKINVEST PRIVATE LIMITED",
"SGS TECHNICAL SERVICES PRIVATE LIMITED",
"SGS TECHNOLOGIE PRIVATE LIMITED",
"SGS TEKNIKS MANUFACTURING PRIVATE LIMITED",
"SGS TEKNIKS MANUFACTURING PRIVATE. LIMITED.",
"SGS UDYOG PRIVATE LIMITED",
"SGS WEATHER & ENVIRONMENTAL SYSTEMS PRIVATE LIMITED",
"SGS WEATHER AND ENVIRONMENTAL SYSTEMS PRIVATE LIMITED",
"SGSC TEXTILES PRIVATE LIMITED",
"SGSL SHIPPING & LOGISTICS PRIVATE LIMITED",
"SGSR INFRA PRIVATE LIMITED",
"SGT HOTELS PRIVATE LIMITED",
"SGT SOFTWARE PRIVATE LIMITED",
"SGT UNIVERSITY",
"SGTRS SOLAR POWER PRIVATE LIMITED",
"SGURRENERGY INDIA PRIVATE LIMITED",
"SGV COTYARNS PVT LTD",
"SGV FOILS PRIVATE LIMITED",
"SGV IMPEX PRIVATE LIMITED",
"SGV SUPER SECURITY SERVICES PRIVATE LIMITED",
"SGVP HOLISTIC HOSPITAL",
"SGVP INTERNTIONAL SCHOOL",
"SGX INDIA CONNECT IFSC PRIVATE LIMITED",
"SGX MINERALS PRIVATE LIMITED",
"SGY PROPERTIES PRIVATE LIMITED",
"SGZ & SGA SUGARS (JV) LIMITED",
"SH DECO CREATIONS PRIVATE LIMITED",
"SH ELECTRONICS INDIA PRIVATE LIMITED",
"SH HARYANA WIRES LIMITED",
"SH JMD BUILDERS PRIVATE LIMITED",
"SH LUGGAGE INDUSTRIES PRIVATE LIMITED",
"SH PHARMACEUTICALS LIMITED",
"SH TECH PARK DEVELOPERS PRIVATE LIMITED",
"SHA DEVJI KESHAVJI GINNING TRADING COMPANY PRIVATE LIMITED",
"SHA KANJI DEVJI REFINERIES PRIVATE LIMITED",
"SHA POLYCHEM PVT LTD",
"SHA SHA LIFESTYLE IMPEX PRIVATE LIMITED",
"SHAADI BAZAR INDIA PRIVATE LIMITED",
"SHAADIONLINE PRIVATE LIMITED",
"SHAADIVIVAAH FASHION PRIVATE LIMITED",
"SHAALE PRIVATE LIMITED",
"SHAALI ESTATES PRIVATE LIMITED",
"SHAAM CLOTHING PRIVATE LIMITED",
"SHAAMBHAVI MANUFACTURERS PRIVATE LIMITED",
"SHAAN ADMARK CONSULTANT PRIVATE LIMITED",
"SHAAN AGRO OILS & EXTRACTIONS PRIVATE LIMITED",
"SHAAN AUTOCARE PRIVATE LIMITED",
"SHAAN CARS PRIVATE LIMITED",
"SHAAN INFRAPROJECTS PRIVATE LIMITED",
"SHAAN INTEGRATED SERVICES PRIVATE LIMITED",
"SHAAN LUBE EQUIPMENT PRIVATE LIMITED",
"SHAAN MARINE SERVICES PRIVATE LIMITED",
"SHAAN REALTORS PRIVATE LIMITED",
"SHAANGI MINERALS PRIVATE LIMITED",
"SHAANGU POWER (INDIA) PRIVATE LIMITED",
"SHAAN'S CARGO PRIVATE LIMITED",
"SHAANT INFOSYSTEMS PRIVATE LIMITED",
"SHAANTAM RESORTS PRIVATE LIMITED",
"SHAARANGA ARTS INDIA PRIVATE LIMITED",
"SHAARC PROJECTS LIMITED",
"SHAASA WELLNESS PRIVATE LIMITED",
"SHAAYARI SERVICES PRIVATE LIMITED",
"SHAAYASH IMPEX PRIVATE LIMITED",
"SHAB INFRACON PRIVATE LIMITED",
"SHABA CYLINDER PRIVATE LIMITED",
"SHABAD CREATIONS PRIVATE LIMITED",
"SHABAD INDIA FASHIONS PRIVATE LIMITED",
"SHABARI COTTONS PRIVATE LIMITED",
"SHABARI FARMS",
"SHABARI INTERNATIONAL",
"SHABARI JUICE & SNACKS CENTER",
"SHABARI PACKAGING INDUSTRIES PVT.LTD.",
"SHABARI TELECABLE NETWORK PRIVATE LIMITED",
"SHABARIMALA AGRO INDUSTRIES PRIVATE LIMITED",
"SHABBIR AND SONS ECO EXIM PRIVATE LIMITED",
"SHABD FACILITY AND CRISIS MANAGEMENT PRIVATE LIMITED",
"SHABD OFFSET PRIVATE LIMITED",
"SHABDA BRAHMA PRIVATE LIMITED",
"SHABEEL CONSTRUCTIONS PRIVATE LIMITED",
"SHABEEL MOTORS PRIVATE LIMITED",
"SHABENDERI REAL ESTATES LTD",
"SHABNAM PETROFILS PRIVATE LIMITED",
"SHABRI INDUSTRIAL CATERING PRIVATE LIMITED",
"SHABRI INVESTMENTS PRIVATE LIMITED",
"SHABRO METALLIC PRIVATE. LIMITED",
"SHAB-SHIB RICE MILL PVT. LTD.",
"SHACHA TECHNOFORGE PRIVATE LIMITED",
"SHACHI ENGINEERING PRIVATE LIMITED",
"SHACHI IMPORTS AND EXPORTS PRIVATE LIMITED",
"SHACHIHATA INDIA PRIVATE LIMITED",
"SHADAN COLLEGE OF ENGINEERING & TECHNOLOGY",
"SHADAN INSTITUTE OF MEDICAL SCIENCES",
"SHADANI INDIA PRIVATE LIMITED",
"SHADE CAPITAL PRIVATE LIMITED",
"SHADE FASHIONS PRIVATE LIMITED",
"SHADE FLEX INDIA PRIVATE LIMITED",
"SHADE N SHELTER INTERIORS PRIVATE LIMITED",
"SHADED FEATHER PRODUCTIONS PRIVATE LIMITED",
"SHADES",
"SHADES DYEING MILLS PRIVATE LIMITED",
"SHADES OF INDIA CRAFTS PRIVATE LIMITED",
"SHADEZ HOME INTERIORS PRIVATE LIMITED",
"SHADI RAM & SONS PRIVATE LIMITED",
"SHADI RAM JAGAN NATH FOREX PRIVATE LIMITED",
"SHADITHYA HOSPITAL",
"SHADOW COVER SECURITY SERVICES PRIVATE LIMITED",
"SHADOWFAX TECHNOLOGIES PRIVATE LIMITED",
"SHADRIK RETAIL SOLUTIONS PRIVATE LIMITED",
"SHA-EN-SHA TRAVEL AND TOUR PRIVATE LIMITED",
"SHAF BROADCAST PRIVATE LIMITED",
"SHAF SUNRISE LINE MARK PRIVATE LIMITED",
"SHAFFER ENERGY PRIVATE LIMITED",
"SHAFI DEGREE COLLEGE",
"SHAFT SINKERS MAURITIUS",
"SHAGAI LOGISTIQUES PRIVATE LIMITED",
"SHAGOON PACKAGING PVT LTD",
"SHAGUFTA GARMENTS PRIVATE LIMITED",
"SHAGUN AUTOMOBILES PRIVATE LIMITED",
"SHAGUN CASTINGS PRIVATE LIMITED",
"SHAGUN CLOTHING PRIVATE LIMITED",
"SHAGUN CONSULTANCY SERVICES PRIVATE LIMITED",
"SHAGUN DRESS MATERIALS PRIVATE LIMITED",
"SHAGUN DRUGS PRIVATE LIMITED",
"SHAGUN HEALTH PRODUCTS PRIVATE LIMITED",
"SHAGUN INFRAPROJECTS PRIVATE LIMITED",
"SHAGUN INTERNATIONAL PRIVATE LIMITED",
"SHAGUN JEWELLERS PRIVATE LIMITED",
"SHAGUN MARBLES PRIVATE LIMITED",
"SHAGUN MARCOM PRIVATE LIMITED",
"SHAGUN MARKETING SERVICES PRIVATE LIMITED",
"SHAGUN POLYTECH PRIVATE LIMITED",
"SHAGUN SHREE EMBRO ARTS PRIVATE LIMITED",
"SHAGUN¬†NEW¬†BOARN¬†BABY¬†AND¬†CHILDREN¬†WEAR",
"SHAGWAY INDUSTRIAL SOLUTIONS PRIVATE LIMITED",
"SHAH AGRI IMPEX PRIVATE LIMITED",
"SHAH AGROGREEN PRIVATE LIMITED",
"SHAH ALLOYS LIMITED",
"SHAH AND ANCHOR KUTCHHI ENGINEERING COLLEGE",
"SHAH AND COMPANY DISTRIBUTORS PVT LTD",
"SHAH ANJAMAN URDU HIGH SCHOOL LONI (TA)",
"SHAH ANJUMAN URDU HIGH SCHOOL",
"SHAH AUDIO INFO TECH PRIVATE LIMITED",
"SHAH AUTO COMPONENTS PRIVATE LIMITED",
"SHAH AUTOMOTIVES MYSORE PRIVATE LIMITED",
"SHAH BOOK HOUSE PRIVATE LIMITED",
"SHAH BROTHERS DIAMONDS PRIVATE LIMITED",
"SHAH BROTHERS ISPAT PRIVATE. LIMITED.",
"SHAH BROTHERS SHIPPING PRIVATE LIMITED",
"SHAH BUSINESS VENTURES PRIVATE LIMITED",
"SHAH C K MUNICIPAL COMMERCE COLLEGE KALOL",
"SHAH CHUNILAL KUNDANMAL YARN PRIVATE LIMITED",
"SHAH COAL PRIVATE LIMITED",
"SHAH CONCAST PRIVATE LIMITED",
"SHAH CONSTRUCTION",
"SHAH CONSTRUCTION COMPANY LIMITED",
"SHAH CONTAINERS PRIVATE LIMITED",
"SHAH CORIANDERS PRIVATE LIMITED",
"SHAH D.M. TEXTILE PVT. LTD.",
"SHAH DEEP INTERNATIONAL BUSINESS SOLUTIONS LIMITED",
"SHAH DEEPCHAND DHARAMCHAND FURNISHINGS PRIVATE LIMITED",
"SHAH DEPARTMENTAL STORES PRIVATE LIMITED",
"SHAH DEVCHAND & CO",
"SHAH DWARKADAS BATATAWALA PRIVATE LIMITED",
"SHAH ENGINEERS AND CONSULTANTS PRIVATE LIMITED",
"SHAH EYE CARE PRIVATE LIMITED",
"SHAH FABRICATORS PVT LTD",
"SHAH FILES AND DRILLS PRIVATE LIMITED",
"SHAH FOILS LIMITED",
"SHAH FORGED ROLLS PRIVATE LIMITED",
"SHAH G M D SARVAJANIK HIGH SCHOOL MOTA PONDHA",
"SHAH GLOBAL AND HAZARD CONTROL PRIVATE LIMITED",
"SHAH HIMATLAL MANILAL AND COMPANY TOBACCO PRODUCTS PVT LTD",
"SHAH HI-TECH AUTO ALCAST COMPANY PVT. LTD.",
"SHAH HOMEWARE PRIVATE LIMITED",
"SHAH HYUNDAI CHANDRASHILP AUTOMOTIVE LLP",
"SHAH INFRA TOWERS PRIVATE LIMITED",
"SHAH INTERNATIONAL PAPER PRIVATE LIMITED",
"SHAH INVESTOR'S HOME LIMITED",
"SHAH LAXMI NARAYAN SATISH CHANDRA EXIM PRIVATE LIMITED",
"SHAH LEAFIN COMPANY PRIVATE LIMITED",
"SHAH LEKHRAJ RDB PETRO PRIVATE LIMITED",
"SHAH LIFELINE HOSPITAL AND HEART INSTITUTE PRIVATE LIMITED",
"SHAH MACHINES PRIVATE LIMITED",
"SHAH MARMO PVT LTD",
"SHAH MEDICO PRIVATE LIMITED",
"SHAH MEHTA HOLDING PRIVATE LIMITED",
"SHAH METACORP LIMITED",
"SHAH MOBIKES PRIVATE LIMITED",
"SHAH MOTILAL FOODS LIMITED",
"SHAH MULTILAYER PRIVATE LIMITED",
"SHAH N B SARVAJANIK HIGH SCHOOL",
"SHAH N B SARVJANIK HIGH SCHOOL",
"SHAH NANJI NAGSI EXPORTS PRIVATE LIMITED",
"SHAH PACKAGING",
"SHAH PACKAGING PRIVATE LIMITED",
"SHAH PAPER MILLS LIMITED",
"SHAH PAPERPLAST INDUSTRIES LIMITED",
"SHAH PAREKH ENGINEERING PRIVATE LIMITED",
"SHAH PIPES PRIVATE LIMITED",
"SHAH PLASTO MOULDERS PRIVATE LIMITED",
"SHAH PRECICAST PRIVATE LIMITED",
"SHAH PRODUCTS LIMITED",
"SHAH REALTY",
"SHAH S D HIGHSCHOOL AND SHREE B B PATEL HIGHER SECONDARY SCHOOL KUKARWADA",
"SHAH SAMRATBEN M VIDYALAY",
"SHAH STONE MACHINES PRIVATE LIMITED",
"SHAH STRUCTURALS PRIVATE LIMITED",
"SHAH TC INTERNATIONAL LLP",
"SHAH TC OVERSEAS PRIVATE LIMITED",
"SHAH TECHNICAL CONSULTANTS PRIVATE LIMITED",
"SHAH TILES PRIVATE LIMITED",
"SHAH TRADERS PRIVATE LIMITED",
"SHAH URJA UDYOG PRIVATE LIMITED",
"SHAH VEGITABLES PRIVATE LIMITED",
"SHAH VIRCHAND GOVANJI JEWELLERS PRIVATE LIMITED",
"SHAH WAYS PRIVATE LIMITED",
"SHAH YARNTEX PRIVATE LIMITED",
"SHAHA FINLEASE PRIVATE LIMITED",
"SHAHABAD INFRA PROJECTS PRIVATE LIMITED",
"SHAHADA MUNICIPAL COUNCIL",
"SHAHANE SOLAR POWER PRIVATE LIMITED",
"SHAHANI ACADEMIC AND GLOBAL EMPOWERMENT FOUNDATION",
"SHAHAPUR INFRASTRUCTURE DEVELOPMENT CO. PRIVATE LIMITED",
"SHAHBAZ PROJECTS PRIVATE LIMITED",
"SHAHBAZKER'S DIAGNOSTICS PRIVATE LIMITED",
"SHAHEED DR. ANIL BAGHI CHARITABLE SOCIETY",
"SHAHEED HAMDEEN JUNIOR HIGH SCHOOL",
"SHAHEED POULTRY CENTER PRIVATE LIMITED",
"SHAHEED RAJGURU COLLEGE OF APPLIED SCIENCES",
"SHAHEED UDHAM SINGH COLLEGE OF ENGINEERI",
"SHAHEEN",
"SHAHEEN AGRO FRESH PRIVATE LIMITED",
"SHAHEEN INDEPENDENT PU COLLEGE BIJAPUR",
"SHAHEEN PU COLLEGE",
"SHAHEEN'S FALCON PU COLLEGE",
"SHAHEM DESIGNERS PRIVATE LIMITED",
"SHAHI APPAREL PRIVATE LIMITED",
"SHAHI CONSTRUCTIONS PRIVATE LIMITED",
"SHAHI DYEING PRIVATE LIMITED",
"SHAHI EXPORTS PRIVATE LIMITED",
"SHAHI MONEY CHANGER PRIVATE LIMITED",
"SHAHI PRODUCTION PRIVATE LIMITED",
"SHAHI SHIPPING LIMITED",
"SHAHI SPICES INDIA PRIVATE LIMITED",
"SHAHIL PULSE MILL PRIVATE LIMITED",
"SHAHIN MANNAN PRIVATE LIMITED",
"SHAHJADA EXPORTS LIMITED",
"SHAHJI FOODS & ALLIED PRODUCTS PRIVATE LIMITED",
"SHAHLON SILK INDUSTRIES LIMITED",
"SHAHLON SILK INDUSTRIES PRIVATE LIMITED",
"SHAHLON TEXTILE PARK PRIVATE LIMITED",
"SHAHNAI EXIM PRIVATE LIMITED",
"SHAHNAZ AYURVEDA PRIVATE LIMITED",
"SHAHNAZ BRIGHT STEEL INDUSTRIES PRIVATE LIMITED",
"SHAHPUR KANYA INTER COLLEGE",
"SHAHPUR ROAD PROJECT PRIVATE LIMITED",
"SHAHPURA EXIM PRIVATE LIMITED",
"SHAHPURA HOSPITALITY PRIVATE LIMITED",
"SHAHPURA THERMAL POWER COMPANY LIMITED",
"SHAHPUTRA TRADING PRIVATE LIMITED",
"SHAHSON COMMERCIALS PRIVATE LIMITED",
"SHAHU MADHYAMIK VIDYALAY PATRUD BEED",
"SHAHWAR MOTIVES PRIVATE LIMITED",
"SHAHZADI EXPORT PRIVATE LIMITED",
"SHAIFALI ROLLS LIMITED",
"SHAIFALI STEELS LIMITED",
"SHAIKH GROUP OF INSTITUTIONS",
"SHAIL AUTO WHEELS AGENCY PRIVATE LIMITED",
"SHAIL HEALTHCARE PRIVATE LIMITED",
"SHAIL IMPORTS PRIVATE LIMITED",
"SHAIL INFRATECH LIMITED.",
"SHAIL VASTRALAY",
"SHAILA PROJECTS (INDIA) PRIVATE LIMITED",
"SHAILAJ TECHNOLOGIES PRIVATE LIMITED",
"SHAILAKE NOCARB PRIVATE LIMITED",
"SHAILANDRA ENTERPRISES PRIVATE LIMITED",
"SHAILAUM MACHINE MANUFACTURERS PRIVATE LIMITED",
"SHAILCHEM DISTILLATE PRIVATE LIMITED",
"SHAILDHAR TELECOM SERVICES PRIVATE LIMITED",
"SHAILEE PROJECTS PRIVATE LIMITED",
"SHAILENDRA BAHADUR SINGH INFRA PRIVATE LIMITED",
"SHAILENDRA PULSES PRIVATE LIMITED",
"SHAILENDRA RISHI RAJ INDUSTRIES INDIA PRIVATE LIMITED",
"SHAILENDRA TECHNO PARK PRIVATE LIMITED",
"SHAILENDRA TRADERS PRIVATE LIMITED",
"SHAILESH FORGING WORKS",
"SHAILESH IMPEX PRIVATE LIMITED",
"SHAILESH INDUSTRIES PRIVATE LIMITED",
"SHAILESH INFRSTRUCTURE PRIVATE LIMITED",
"SHAILESH MACHINE TOOLS PRIVATE LIMITED",
"SHAILESH SHAH SECURITIES PRIVATE LIMITED",
"SHAILESH SHRIHARI KUTE HOTELS & RESORTS PRIVATE LIMITED",
"SHAILJA EXPORTS PVT LTD",
"SHAILJA INFRATECH PRIVATE LIMITED",
"SHAILJA PAPERS LIMITED",
"SHAILJA PARK PRIVATE LIMITED",
"SHAILJA POLYSTERS PVT LTD",
"SHAILJA PRINTS PRIVATE LIMITED",
"SHAILJA SHOPPERS PRIVATE LIMITED",
"SHAILJA TEXPRINTS PRIVATE LIMITED",
"SHAILPUTRI IRON AND STEELS PRIVATE LIMITED",
"SHAILSUTA LOGISTICS PRIVATE LIMITED",
"SHAILTEX LUBRICANTS PRIVATE LIMITED",
"SHAILY ENGINEERING PLASTICS LIMITED",
"SHAILY LIFE SCIENCES PRIVATE LIMITED",
"SHAIMAA NETWORKS PRIVATE LIMITED",
"SHAIP.AI DATA (INDIA) LLP",
"SHAIRU GEMS DIAMONDS PRIVATE LIMITED",
"SHAISHAV CHILDREN'S HOSPITAL & RESEARCH CENTER PRIVATE LIMITED",
"SHAIV DISTILLERIES PRIVATE LIMITED",
"SHAIV PROJECTS AND SERVICES PRIVATE LIMITED",
"SHAIVAL REALITY LIMITED",
"SHAIVEE SALES",
"SHAIVIK INFRATECH INDIA PRIVATE LIMITED",
"SHAJAL ENGINEERING PRIVATE LIMITED",
"SHAJAY FABRICATORS & ENGINEERS PRIVATE LIMITED",
"SHAJBAS CONSTRUCTIONS PRIVATE LIMITED",
"SHAKAMBAREE TRADERS PVT LTD",
"SHAKAMBARI AGRO TECH PRIVATE LIMITED",
"SHAKAMBARI AROMATICS PRIVATE LIMITED",
"SHAKAMBARI ENTERPRISES (INDIA) PRIVATE LIMITED",
"SHAKAMBARI IMPEX PRIVATE LIMITED",
"SHAKAMBARI INTRA & FINANCE PVT LTD",
"SHAKAMBARI KNITTING PRIVATE. LIMITED.",
"SHAKAMBARI OVERSEAS TRADE PRIVATE. LIMITED.",
"SHAKAMBARI POLYMERS PRIVATE LIMITED",
"SHAKAMBARI RICE MILL PRIVATE LIMITED",
"SHAKAMBARI SHAKTI (INDIA) PRIVATE LIMITED",
"SHAKAMBHARI AGROTECH PRIVATE LIMITED",
"SHAKAMBHARI ENTERPRISES PRIVATE LIMITED",
"SHAKAMBHARI ISPAT & POWER LIMITED",
"SHAKAMBHARI KNITTING PRIVATE LIMITED",
"SHAKAMBHARI MEDICAL PRIVATE LIMITED",
"SHAKAMBHARI PITAMBRA PRIVATE LIMITED",
"SHAKAMBHARI SYNTHETICS PRIVATE LIMITED",
"SHAKAMBRI FABRICS PRIVATE LIMITED",
"SHAKAMBRI KHADYA BHANDAR",
"SHAKAMBRI STONE CRASHING PRIVATE LIMITED",
"SHAKAS FOODS PRIVATE LIMITED",
"SHAKE HAND PAYMENT NETWORK PRIVATE LIMITED",
"SHAKHAMBARI HEALTHCARE SERVICES PRIVATE LIMITED",
"SHAKHAMBHARI REALCAPSERVE CONSULTING PRIVATE LIMITED",
"SHAKO FLEXI PACK PRIVATE LIMITED",
"SHAKSHAM AGRO PRIVATE LIMITED",
"SHAKSHAM GRAINS PRIVATE LIMITED",
"SHAKSHAM HOSPITAL",
"SHAKSHI COIR PRODUCTS PRIVATE LIMITED",
"SHAKSHI COMMERCIAL CO PRIVATE LIMITED",
"SHAKSHI SYNTHETICS PVT LTD",
"SHAKSHI TRANSFORMERS PRIVATE LIMITED",
"SHAKTHI ASSOCIATES FINANCIAL SERVICES PRIVATE LIMITED",
"SHAKTHI EDUCATION TRUST",
"SHAKTHI ELECTRICALS CHENNAI PRIVATE LIMITED",
"SHAKTHI HEALTHY FRESH MEATS PRIVATE LIMITED",
"SHAKTHI HILL RESORTS PRIVATE LIMITED",
"SHAKTHI IMAGING AND DIAGNOSTICS PRIVATE LIMITED",
"SHAKTHI INNOVATIVE SOLUTIONS PRIVATE LIMITED.",
"SHAKTHI KNITTING LIMITED",
"SHAKTHI KNITTING PRIVATE LIMITED",
"SHAKTHI MEDICALS INDIA PRIVATE LIMITED",
"SHAKTHI MONOFILAMENTS PRIVATE LIMITED",
"SHAKTHI MURUGAN TEXTILES",
"SHAKTHI RESIDENTIAL SCHOOL",
"SHAKTHI SEEDS PRIVATE LIMITED",
"SHAKTHI TECH MANUFACTURING INDIA PRIVATE LIMITED",
"SHAKTHIGANESH INFRASTRUCTURE PRIVATE LIMITED",
"SHAKTHIMAN EXTRUSIONS PRIVATE LIMITED",
"SHAKTI AGENCIES PRIVATE LIMITED",
"SHAKTI AGRIC FOODS(INDIA) PRIVATE LIMITED",
"SHAKTI AGROFOOD PRIVATE LIMITED",
"SHAKTI AGROTECH PRIVATE LIMITED",
"SHAKTI ALUMINIUM PRODUCTS PRIVATE LIMITED",
"SHAKTI APIFOODS PRIVATE LIMITED",
"SHAKTI APPARELS PRIVATE LIMITED",
"SHAKTI ARCHITECTURAL PRODUCTS PRIVATE LIMITED",
"SHAKTI AUTO CARS PRIVATE LIMITED",
"SHAKTI AUTO INDUSTRIES PRIVATE LIMITED",
"SHAKTI AUTO VALVES & ENGINEERING COMPANY PRIVATE LIMITED",
"SHAKTI AUTOMOTIVE COMPONENTS PRIVATE LIMITED",
"SHAKTI BOARDS PRIVATE LIMITED",
"SHAKTI BORAX PRIVATE LIMITED",
"SHAKTI BRASS INDUSTRIES",
"SHAKTI BREEDING INDIA PRIVATE LIMITED",
"SHAKTI BROADBAND PRIVATE LIMITED",
"SHAKTI BUILDMART PRIVATE LIMITED",
"SHAKTI BUILDTECH PRIVATE LIMITED",
"SHAKTI BULK CARRIERS PRIVATE LIMITED",
"SHAKTI CABLES PRIVATE LIMITED",
"SHAKTI CARRIERS LTD",
"SHAKTI CARS PRIVATE LIMITED",
"SHAKTI CHEMICOAT PRIVATE LIMITED",
"SHAKTI CLEARING AGENCY PRIVATE LIMITED",
"SHAKTI COMMODITIES PRIVATE LIMITED",
"SHAKTI CONSULTING & SOLUTIONS PRIVATE LIMITED",
"SHAKTI CONTAINERS PRIVATE LIMITED",
"SHAKTI CORPORATION",
"SHAKTI DEALTRADE PRIVATE LIMITED",
"SHAKTI DETERGENTS PVT LTD",
"SHAKTI DISTILLERIES PRIVATE LIMITED",
"SHAKTI ENERGY SOLUTIONS PRIVATE LIMITED",
"SHAKTI ENGINEERS AND ELEVATOR PRIVATE LIMITED",
"SHAKTI ENTERPRISE",
"SHAKTI ENVELOPES INDIA PRIVATE LIMITED",
"SHAKTI EQUIPMENTS PRIVATE LIMITED",
"SHAKTI EXIM & TRADERS LIMITED",
"SHAKTI EY PADS PRIVATE LIMITED",
"SHAKTI E-ZONE PRIVATE LIMITED",
"SHAKTI FINVEST PVT LTD",
"SHAKTI FIXTURES PRIVATE LIMITED",
"SHAKTI FOAMS PRIVATE LIMITED",
"SHAKTI FOOD OIL PRIVATE LIMITED",
"SHAKTI FORGE INDUSTRIES PRIVATE LIMITED",
"SHAKTI FORWARDERS PRIVATE LIMITED",
"SHAKTI FRUITS & VEGETABLE SUPPLIERS PRIVATE LIMITED",
"SHAKTI GEMS & JEWELS PRIVATE LIMITED",
"SHAKTI GREENS PROJECTS PRIVATE LIMITED",
"SHAKTI HITECH COMPONENTS PRIVATE LIMITED",
"SHAKTI HORMANN PRIVATE LIMITED",
"SHAKTI HYDRO ELECTRIC COMPANY PRIVATE LIMITED",
"SHAKTI INDUSTRIAL EQUIPMENTS PRIVATE LIMITED",
"SHAKTI INDUSTRIES",
"SHAKTI INDUSTRIES PVT LTD",
"SHAKTI INFOSOLUTIONS PRIVATE. LIMITED",
"SHAKTI INFOTECH PRIVATE LIMITED",
"SHAKTI INFRAMINES DEVELOPERS PRIVATE LIMITED",
"SHAKTI INFRANIRMAN PRIVATE LIMITED",
"SHAKTI INFRATECH PRIVATE LIMITED",
"SHAKTI INFRAVISION PRIVATE LIMITED",
"SHAKTI IRRIGATION INDIA LIMITED",
"SHAKTI IRRIGATION PRIVATE LIMITED",
"SHAKTI IT SERVICES PRIVATE LIMITED",
"SHAKTI JEWELLERS PRIVATE LIMITED",
"SHAKTI LIVE STOCK FEEDS PRIVATE LIMITED",
"SHAKTI LOGISTICS AND ALLIED SERVICES PRIVATE LIMITED",
"SHAKTI LOGISTICS PRIVATE LIMITED",
"SHAKTI MACHINERIES PRIVATE LIMITED",
"SHAKTI MAHIMA ENTERPRISES PRIVATE LIMITED",
"SHAKTI MALTARE AND LEMONADE PRIVATE LIMITED",
"SHAKTI MANPOWER SUPPLY",
"SHAKTI MATTRESSES AND GEARS PRIVATE LIMITED",
"SHAKTI METALLICS PRIVATE LIMITED",
"SHAKTI MINES AND MINERALS PRIVATE LIMITED",
"SHAKTI MINING EQUIPMENTS PRIVATE LIMITED",
"SHAKTI MOTORS PRIVATE LIMITED",
"SHAKTI MURGAN TRAILOR CARGO PRIVATE LIMITED",
"SHAKTI OLEVIN COMPOUNDS LLP",
"SHAKTI ORGANIC CHEMICAL INDUSTRIES PVT LTD",
"SHAKTI ORTHOPAEDIC INDUSTRIES PRIVATE LIMITED",
"SHAKTI PACK PVT LTD",
"SHAKTI PLYWOOD PRIVATE LIMITED",
"SHAKTI PNEUMATIC AND INDUSTRIAL STORES PRIVATE LIMITED",
"SHAKTI POLYFAB PRIVATE LIMITED",
"SHAKTI POLYMETALS MANUFACTURING PRIVATE LIMITED.",
"SHAKTI POLYTARP LIMITED",
"SHAKTI POLYWEAVE PRIVATE LIMITED",
"SHAKTI PRECISION COMPONENTS INDIA PRIVATE LIMITED",
"SHAKTI PROJECTS & IMPEX PRIVATE LIMITED",
"SHAKTI PROTECTION FORCE LIMITED",
"SHAKTI PROTEIN PVT LTD",
"SHAKTI PUMPS INDIA LIMITED",
"SHAKTI RAILTEK (INDIA) PRIVATE LIMITED",
"SHAKTI RESIDENCY PRIVATE LIMITED",
"SHAKTI RESIN PRIVATE LIMITED",
"SHAKTI SAI TYRES PRIVATE LIMITED",
"SHAKTI SECURITY AND MAINTENANCE SERVICES PRIVATE LIMITED",
"SHAKTI SHASWATI PRIVATE LIMITED",
"SHAKTI SHIVA MAGNETS PRIVATE LIMITED",
"SHAKTI SHREE FEEDS PRIVATE LIMITED",
"SHAKTI SUDHA AGROVENTURES PRIVATE LIMITED",
"SHAKTI SUGAR MILL PRIVATE LIMITED",
"SHAKTI SUPERCARE PRIVATE LIMITED",
"SHAKTI SUSTAINABLE ENERGY FOUNDATION",
"SHAKTI SYNERGETICS PRIVATE LIMITED",
"SHAKTI TEA PROCESSORS & MANUFACTURERS PRIVATE LIMITED",
"SHAKTI TEXTILE ENGINEERS PRIVATE LIMITED",
"SHAKTI TOOLS (INDIA) LIMITED.",
"SHAKTI TOURISM (INDIA) PRIVATE LIMITED",
"SHAKTI TRANSMISSION PRODUCTS PRIVATE LIMITED",
"SHAKTI TRENDZ PRIVATE LIMITED",
"SHAKTI VARDAK HYBIRD SEEDS PVT LTD",
"SHAKTI VARDHAK MILK PRODUCER COMPANY LIMITED",
"SHAKTI VYAPAR PRIVATE LIMITED",
"SHAKTI YARN PRIVATE LIMITED",
"SHAKTICANTEEN STORE PRIVATE LIMITED",
"SHAKTICAST PRIVATE LIMITED",
"SHAKTIFOAM LAMINATOR PRIVATE LIMITED",
"SHAKTIGARH TEXTILE & INDUSTRIES LTD",
"SHAKTIKIRAN GRANITES PVT LTD",
"SHAKTIMAAN CONSUMER PRODUCTS LIMITED",
"SHAKTIMAN AGRO LIMITED",
"SHAKTIMAN BIO AGRO INDUSTRIES PRIVATE LIMITED",
"SHAKTIMAN EQUIPMENTS PRIVATE LIMITED",
"SHAKTIMAN GRANITES PRIVATE LIMITED",
"SHAKTIMAN GRIMME ROOT CROP SOLUTIONS PRIVATE LIMITED",
"SHAKTIMAN PACKAGING PRIVATE LIMITED",
"SHAKTIMAN RICE AND FLOUR MILLS PRIVATE LIMITED",
"SHAKTIMAN RUB-ROLLS PRIVATE LIMITED",
"SHAKTIOLEVIN GRANULES PRIVATE LIMITED",
"SHAKTIRAJ METALS PRIVATE LIMITED",
"SHAKTISHALI CEMENT PRIVATE LIMITED",
"SHAKTISTELLER ENERGY SOLUTIONS PRIVATE LIMITED",
"SHAKTTI CONSTRUCTIONS EQUIPMENT PRIVATE LIMITED",
"SHAKUMBARI AUTOMOBILES PRIVATE LIMITED",
"SHAKUMBARI AUTOWHEELS PRIVATE LIMITED",
"SHAKUMBARI SUGAR AND ALLIED INDUSTRIES LIMITED",
"SHAKUMBHARI ALLOYS STEEL PRIVATE LIMITED",
"SHAKUMBHARI EXPO-IMPO LIMITED",
"SHAKUMBHARI INFRACON PRIVATE LIMITED",
"SHAKUMBHARI SOLAR POWER PROJECTS PRIVATE LIMITED",
"SHAKUMBHRI CRAFT & TISSUE PRIVATE LIMITED",
"SHAKUMBHRI HERBALS PRIVATE LIMITED",
"SHAKUMBHRI PUBLIC SCHOOL",
"SHAKUMBHRI PULP & PAPER MILLS LIMITED",
"SHAKUMBHRI PULP AND PAPER MILLS LIMITED.",
"SHAKUN ADVERTISING PRIVATE LIMITED",
"SHAKUN AUTOPARTS PRIVATE LIMITED",
"SHAKUN AYURVED PRIVATE LIMITED",
"SHAKUN CONSUMER PRODUCTS PRIVATE LIMITED",
"SHAKUN DISTRIBUTION PRIVATE LIMITED",
"SHAKUN ENTERPRISES PRIVATE LIMITED",
"SHAKUN GASES PRIVATE LIMITED",
"SHAKUN HANDIFABS PRIVATE LIMITED",
"SHAKUN HOTELS AND RESORTS PRIVATE LIMITED",
"SHAKUN IMPEX PVT LTD",
"SHAKUN INFRASTRUCTURE DEVELOPMENT LIMITED",
"SHAKUN MARBLES PRIVATE LIMITED",
"SHAKUN MOTORS PRIVATE LIMITED",
"SHAKUN POLYMERS LIMITED",
"SHAKUN PROPERTIES PRIVATE LIMITED",
"SHAKUN SALES PRIVATE LIMITED",
"SHAKUNT ELECTRO SYSTEMS PRIVATE LIMITED",
"SHAKUNT ENTERPRISES PRIVATE LIMITED",
"SHAKUNTA EDU COM PRIVATE LIMITED",
"SHAKUNTALA AUTO PRIVATE LIMITED",
"SHAKUNTALA DEVI HOSPITAL LIMITED",
"SHAKUNTALA ENTERPRISES",
"SHAKUNTALA GADGET ZONE PRIVATE LIMITED",
"SHAKUNTALA HEALTHCARE PRIVATE LIMITED",
"SHAKUNTALA J MAHAJAN MADHYAMIK VIDYALAYA FAIZPUR",
"SHAKUNTALA J PRATHAMIK VIDYALAY JALGAON",
"SHAKUNTALA MEDI DIAGNOSTIC PRIVATE LIMITED",
"SHAKUNTALA POLY INDUSTRIES PRIVATE LIMITED",
"SHAKUNTALA POLYFOAM PRIVATE LIMITED",
"SHAKUNTALA WARE HOUSE",
"SHAKUNTALAM IMPEX PRIVATE LIMITED",
"SHAKUNTALAM INFRADEVELOPERS LIMITED",
"SHAKUNTALAM INTERIORS PRIVATE LIMITED",
"SHAKUNTALAM REALBUILD PRIVATE LIMITED",
"SHAKUNTALAM STEELS PRIVATE LIMITED",
"SHAKUNTALAM TELEFILMS PRIVATE LIMITED",
"SHAKUNTLA FABRICS PRIVATE LIMITED",
"SHAKUNTLA JEWELLERS PRIVATE LIMITED",
"SHAKUNTLA MULTISPECIALITY HOSPITAL",
"SHAKUNTLA SAREES PRIVATE LIMITED",
"SHAKUNTLADEVI NANDKISHOR GUPTA LOKBHARTI VIDYALAYA",
"SHAKUNTLAM APPARELS PRIVATE LIMITED",
"SHAKUNTLAM LEGACY CLOTHING PRIVATE LIMITED",
"SHAKUNTLAM LOGISTICS PRIVATE LIMITED",
"SHAKUNTLAM SECURITIES PRIVATE LIMITED",
"SHAKYA SUPER CONSTRUCTION PRIVATE LIMITED",
"SHALAK EATABLE PRODUCTS PRIVATE LIMITED",
"SHALAK VENTURE PRIVATE LIMITED",
"SHALAKA AGRO FOOD PRODUCTS PRIVATE LIMITED",
"SHALAKA ELECTRONICS PVT.LTD.",
"SHALAKA FOUNDATION",
"SHALAKA INFRA-TECH INDIA PRIVATE. LIMITED.",
"SHALAKA SHAFTS PRIVATE LIMITED",
"SHALAKS PHARMACEUTICALS PRIVATE LIMITED",
"SHALBY LIMITED",
"SHALBY MULTI SPECIALTY HOSPITALS",
"SHALCO INDUSTRIES PRIVATE LIMITED",
"SHALCON INSTRUMENTS PRIVATE LIMITED",
"SHALEEN ENTERTAINMENT PRIVATE LIMITED",
"SHALEEN HEALTHCARE PRIVATE LIMITED",
"SHALEEN OVERSEAS PRIVATE LIMITED",
"SHALEEN TRADECOM (INDORE) PRIVATE LIMITED",
"SHALIBHADRA CAPITAL MARKET LIMITED",
"SHALIBHADRA CREATIONS PRIVATE LIMITED",
"SHALIBHADRA DYE-CHEM PRIVATE LIMITED",
"SHALIBHADRA FINANCE LIMITED.",
"SHALIBHADRA INTERMEDIATES PVT LTD",
"SHALIBHADRA TRADERS",
"SHALIBHADRACHEMICALS PVT LTD",
"SHALIGRAM BUILDCON PRIVATE LIMITED",
"SHALIGRAM INFOTECH LLP",
"SHALIGRAM LAMINATES PRIVATE LIMITED",
"SHALIGRAM PLASTOCRAFT AND TOOLS PRIVATE LIMITED",
"SHALIKA ENTERPRISES PRIVATE LIMITED",
"SHALIMAR AGARBATTI COMPANY",
"SHALIMAR AUTOMOBILES PVT LTD",
"SHALIMAR BUILDCON PRIVATE LIMITED",
"SHALIMAR CATTLE FEEDS PRIVATE LIMITED.",
"SHALIMAR CHEM INDIA PRIVATE LIMITED",
"SHALIMAR CHEMICAL WORKS PRIVATE LIMITED",
"SHALIMAR CITY CARE PRIVATE LIMITED",
"SHALIMAR CORP LIMITED",
"SHALIMAR CT SCAN CENTRE PRIVATE LIMITED",
"SHALIMAR ENVIRO PRIVATE LIMITED",
"SHALIMAR EXTRUSION PRIVATE LIMITED",
"SHALIMAR FABRICATORS PRIVATE LIMITED",
"SHALIMAR FLOORINGS PRIVATE LIMITED",
"SHALIMAR HATCHERIES LIMITED",
"SHALIMAR HOSPITALITY PRIVATE LIMITED",
"SHALIMAR HOTEL PRIVATE LIMITED",
"SHALIMAR HOUSING AND FINANCE LIMITED",
"SHALIMAR INCENSE PRIVATE LIMITED",
"SHALIMAR INDUSTRIES LIMITED",
"SHALIMAR INFOTECH PRIVATE LIMITED",
"SHALIMAR MAINTENANCE SERVICES PRIVATE LIMITED",
"SHALIMAR NUTRIENTS PRIVATE LIMITED",
"SHALIMAR OVERSEAS PRIVATE LIMITED",
"SHALIMAR PAINTS LIMITED",
"SHALIMAR PAINTS LTD",
"SHALIMAR PELLET FEEDS LIMITED",
"SHALIMAR PETRO PRODUCTS PRIVATE LIMITED",
"SHALIMAR PRODUCTIONS LIMITED",
"SHALIMAR SALES PVT LTD",
"SHALIMAR SEAL AND TAR PRODUCTS PRIVATE LIMITED",
"SHALIMAR TANNING COMPANY",
"SHALIMAR THERMOFORMING PRIVATE LIMITED",
"SHALIMAR TOWN PLANNERS PVT LTD",
"SHALIMAR VALVES PRIVATE LIMITED",
"SHALIMAR WIRES INDUSTRIES LIMITED",
"SHALIN COMPOSITES INDIA PRIVATE LIMITED",
"SHALIN INTERMEDIATES PRIVATE LIMITED",
"SHALINI ASSOCIATES",
"SHALINI FAB TECH INDIA PRIVATE LIMITED",
"SHALINI FASHIONS PRIVATE LIMITED",
"SHALINI HOSPITAL PRIVATE LIMITED",
"SHALINI INFOTECH PRIVATE LIMITED",
"SHALINI OFFSET PRESS PRIVATE LIMITED",
"SHALINI PLASTICS PVT LTD",
"SHALINI ROOFING PRIVATE LIMITED",
"SHALINI STEELS PRIVATE LIMITED",
"SHALINIS SUNRISE SUPER SPECIALITY CHILDREN'S HOSPITAL",
"SHALIREX POLYVINYL PRIVATE LIMITED",
"SHALIVAHANA GREEN ENERGY LIMITED",
"SHALIWAHAN VIDYALAYA PAITHAN",
"SHALLOW CERAMIC PRIVATE LIMITED",
"SHALLU ENTERPRISES PVT LTD",
"SHALMAN PHARMACEUTICALS PRIVATE LIMITED",
"SHALOK STRECHLON CREATIONS PRIVATE LIMITED",
"SHALOM GARMENTS PRIVATE LIMITED",
"SHALOM HILLS INTERNATIONAL SCHOOL",
"SHALOM LIFECARE",
"SHALOM MEDICARE PRIVATE LIMITED",
"SHALOM PRESIDENCY SCHOOL",
"SHALOM VOYAGERS PRIVATE LIMITED",
"SHALU DYEING AND PRINTING MILLS PRIVATE LIMITED",
"SHALU TRADERS PRIVATE LIMITED",
"SHALVIYA REALTORS PRIVATE LIMITED",
"SHAM COLOURCHEM PRIVATE LIMITED",
"SHAM ELECTROPOWER PRIVATE LIMITED",
"SHAM EMPORIUM PRIVATE LIMITED",
"SHAM FASHIONS ERA PRIVATE LIMITED",
"SHAM FOAM PRIVATE LIMITED",
"SHAM JEWELLERS",
"SHAM SONS INDUSTRIES",
"SHAMA & SHIVA HOTELS PRIVATE LIMITED",
"SHAMA ESTATES PRIVATE LIMITED",
"SHAMA RUB-CHEM CO PVT LTD",
"SHAMAL AND SHAMAL PRIVATE LIMITED",
"SHAMAMATRIX CARS PRIVATE LIMITED",
"SHAMAN CARS INDIA PRIVATE LIMITED",
"SHAMAN CARS PRIVATE LIMITED",
"SHAMAN MOTORS PRIVATE LIMITED",
"SHAMAN USED CARS PRIVATE LIMITED",
"SHAMAN WHEELS PRIVATE LIMITED",
"SHAMANI MANAGEMENT SERVICES PRIVATE LIMITED",
"SHAMANJWALI METALS PVT LTD",
"SHAMANUR SUGARS LIMITED",
"SHAMARA CONSTRUCTION PRIVATE LIMITED",
"SHAMBAVI AAGRI SEEDS PRIVATE LIMITED",
"SHAMBHALA HOTELS PRIVATE LIMITED",
"SHAMBHAVI CENTRE FOR CANCER AND GYNAECOLOGY PRIVATE LIMITED",
"SHAMBHAVI FORMS PVT. LTD.",
"SHAMBHAVI MOVERS PRIVATE LIMITED",
"SHAMBHAVI MULTIENGINEERS DEVELOPERS INDIA PRIVATE LIMITED",
"SHAMBHAVI RENEWABLE ENERGY PRIVATE LIMITED",
"SHAMBHAVI TELECOM PRIVATE LIMITED",
"SHAMBHO LIFE SOLUTIONS PRIVATE LIMITED",
"SHAMBHOO DETERGENT PRIVATE LIMITED",
"SHAMBHOO ENTERPRISES",
"SHAMBHOO OILS AND PETROLEUMS PRIVATE LIMITED",
"SHAMBHU DAYAL AGRO FOOD PRIVATE LIMITED",
"SHAMBHU DAYALGLOBAL SCHOOL",
"SHAMBHU INDUSTRIES PRIVATE LIMITED",
"SHAMBHU KHAINI PRIVATE LIMITED.",
"SHAMBHU MERCANTILE LIMITED",
"SHAMBHU SINGH ENGINEERS PRIVATE LIMITED",
"SHAMBHU SYNTHETICS PRIVATE LIMITED",
"SHAMBHU TECHNOLOGY SERVICES PRIVATE LIMITED",
"SHAMBHU TEXTILE MILLS PRIVATE LIMITED",
"SHAMBHU TRADERS PRIVATE LIMITED",
"SHAMBHU VENGU YARN MILLS PRIVATE LIMITED",
"SHAMBHUNATH PANDIT HOSPITAL",
"SHAMBHURESHWAR VINCOM PRIVATE LIMITED",
"SHAMBHU'S FOOD & BEVERAGES PRIVATE LIMITED",
"SHAMBHVI ENTERPRISES PRIVATE LIMITED",
"SHAMIK ENTERPRISES PRIVATE LIMITED",
"SHAMIM AZAD URDU GIRLS HIGH SCHOOL",
"SHAMIR OPTICAL INDIA PRIVATE LIMITED",
"SHAMIYANA INFRASTRUCTURE PRIVATE LIMITED",
"SHAMJI OPTIMA PRIVATE LIMITED",
"SHAMKO EXIM PRIVATE. LIMITED.",
"SHAMKRIS MARKETING SERVICES PRIVATE LIMITED",
"SHAMLA TECH SOLUTIONS PRIVATE LIMITED",
"SHAMLAJI EXPRESSWAY PRIVATE LIMITED",
"SHAMLI MOTORS PRIVATE LIMITED",
"SHAMLI SCIENTIPIC INSTRUMENTS PRIVATE LIMITED",
"SHAMLI STEELS PRIVATE LIMITED",
"SHAMNAGAR BALIKA VIDYALAYA",
"SHAMROCK INTERNATIONAL LIMITED",
"SHAMROCK INTERNATIONAL SCHOOL",
"SHAMROCK MEDICAMENTS (INDIA) LIMITED",
"SHAMROCK PHARMACHEMI PRIVATE LIMITED",
"SHAMROCKS HOTELS PRIVATE LIMITED",
"SHAMROSE MANPOWER SERVICES PRIVATE LIMITED",
"SHAMS EXPORTS PRIVATE LIMITED",
"SHAMS HEALTHCARE SOFTWARE PRIVATE LIMITED",
"SHAMS INDUSTRIES PRIVATE LIMITED",
"SHAMSHER SINGH TOMAR FOUNDATION",
"SHAMSHREE LIFESCIENCES LIMITED",
"SHAMSI TEACOMPANY PRIVATE LIMITED",
"SHAMSONS POLYMERS PRIVATE. LIMITED.",
"SHAMSUDDIN GHAWTE IDEAL PRI SCHOOL 2ND RABODI",
"SHAMUGPRIYA INTERNATIONAL PRIVATE LIMITED",
"SHAMYAK INVESTMENT PRIVATE LIMITED",
"SHAN CASTINGS PRIVATE LIMITED",
"SHAN GLOBAL MANUFACTURING AND TRADING PRIVATE LIMITED",
"SHAN SHAI S DISTRIBUTIONS PRIVATE LIMITED",
"SHAN SHIP MANAGEMENT PRIVATE LIMITED INDIA",
"SHAN TABLEWARES PRIVATE LIMITED",
"SHAN TEXTILES PRIVATE LIMITED",
"SHANADZZAR LOGISTICS (INDIA) PRIVATE LIMITED",
"SHANAISCHARA INDUSTRIES PRIVATE LIMITED",
"SHANARK INDUSTRIALS PRIVATE LIMITED",
"SHANAY RENEWABLES PRIVATE LIMITED",
"SHANAYA PROMOTIONS PRIVATE LIMITED",
"SHANAYAA INDUSTRIES PRIVATE LIMITED",
"SHANAZ AYURVEDICS",
"SHANBALAJI PHARMA PRIVATE LIMITED",
"SHANBHAG TOWERS INTERNATIONAL PRIVATE LIMITED",
"SHANC INFRATECH PRIVATE LIMITED",
"SHAND PIPE INDUSTRY PRIVATE LIMITED",
"SHANDAAR FOODS PRIVATE LIMITED",
"SHANDAR INTERIOR PRIVATE LIMITED",
"SHANDAR MODULAR SYSTEMS PRIVATE LIMITED",
"SHANDEAL INDIA PRIVATE LIMITED",
"SHANDERS PROPERTIES PRIVATE. LIMITED.",
"SHANDONG CHUNLONG GROUP INDIA PRIVATE LIMITED",
"SHANDONG HEAVY INDUSTRY INDIA PRIVATE LIMITED",
"SHANDONG TIEJUN ELECTRIC POWER ENGINEERING CO. LIMITED",
"SHANDONG YUAN FIRE ENGINEERING PRIVATE LIMITED",
"SHANE AVADH HOTEL PRIVATE LIMITED",
"SHANE EXIM PRIVATE LIMITED",
"SHANE MARINE SERVICES PRIVATE LIMITED",
"SHANE PUNJAB FOODS PRIVATE LIMITED",
"SHANETHA TECHNOLOGIES PRIVATE LIMITED",
"SHANGAR DECOR LIMITED",
"SHANGARI GLOBAL PRIVATE LIMITED",
"SHANGHAI ELECTRIC INDIA PRIVATE LIMITED",
"SHANGHAI HUAXING CREW MANAGEMENT CO LIMITED",
"SHANGHAI SHIPPING PRIVATE LIMITED",
"SHANGHAI TUNNEL ENGINEERING CO LIMITED",
"SHANGHVI & ASSOCIATES CONSULTANTS PRIVATE LIMITED",
"SHANGHVI FINANCE PRIVATE LIMITED",
"SHANGHVI FOUNDERS & ENGINEERS PRIVATE LIMITED",
"SHANGLOO TRAVELS PRIVATE LIMITED",
"SHANGOLD INDIA LIMITED",
"SHANGOV TUBE PROFILES PRIVATE LIMITED",
"SHANGRI LA HOTEL PRIVATE LIMITED",
"SHANGRI-LA CATERERS & SERVICES PRIVATE LIMITED",
"SHANGRILA COLOUR & COATING PRIVATE LIMITED",
"SHANGRILA CORPORATE SERVICES PRIVATE LIMITED",
"SHANGRILA EXPORTS PRIVATE LIMITED",
"SHANGRILA FINANCIAL SERVICES LIMITED",
"SHANGRILA FOOD PRODUCTS LIMITED",
"SHANGRI-LA HOTEL",
"SHANGRILA INDIA PRIVATE LIMITED",
"SHANGRILA INFRACON INDIA PRIVATE LIMITED",
"SHANGRI-LA INTERNATIONAL HOTEL CONSULTANCY SERVICES (INDIA) PRIVATE LIMITED",
"SHANGRILA RESTAURANTS AND INNS PRIVATE LIMITED",
"SHANGRILA TECHNOLOGIES PRIVATE LIMITED",
"SHANI AUTO PRIVATE LIMITED",
"SHANI CORPORATION LIMITED",
"SHANI MOULD PLAST PRIVATE LIMITED",
"SHANI TECHNET PRIVATE LIMITED",
"SHANIDEV OIL MILL LIMITED",
"SHANIRAJESHWAR DIE CASTING PRIVATE LIMITED",
"SHANISHCHARAY DEVELOPERS & BUILDERS PRIVATE LIMITED",
"SHANIVI CONSTRUCTION PRIVATE LIMITED",
"SHANK MARINE SERVICES PRIVATE LIMITED",
"SHANKAESHWAR FABRICS PRIVATE LIMITED",
"SHANKAR ABODES SOLAR PRIVATE LIMITED",
"SHANKAR AVHAD GROUP LIMITED",
"SHANKAR CONDUCTORS PVT LTD",
"SHANKAR CONFECTIONERS PRIVATE LIMITED",
"SHANKAR CYLINDERS PRIVATE LIMITED",
"SHANKAR DIE CASTINGS PRIVATE LIMITED",
"SHANKAR ELECTRICALS SERVICES I PRIVATE LIMITED",
"SHANKAR EMBROIDERY PRIVATE LIMITED",
"SHANKAR EQUIPMENTS LIMITED",
"SHANKAR FENESTRATIONS & GLASSES INDIA PRIVATE LIMITED",
"SHANKAR FLOUR MILL",
"SHANKAR FOOTWEAR PRIVATE LIMITED",
"SHANKAR FREIGHT LOGISTICS PRIVATE LIMITED",
"SHANKAR GEMS AND JEWELLERY PRIVATE LIMITED",
"SHANKAR GIR OLIA SILK MILLS PRIVATE LIMITED",
"SHANKAR GROWTH FUND PRIVATE LIMITED",
"SHANKAR JEWELS LIMITED",
"SHANKAR LAL RAMPAL DYE-CHEM LIMITED",
"SHANKAR LIFECARE PRIVATE LIMITED",
"SHANKAR MALL PRIVATE LIMITED",
"SHANKAR MERCANTILE AGENCY PRIVATE LIMITED",
"SHANKAR MOTORS LIMITED",
"SHANKAR MOULDING LIMITED",
"SHANKAR NAMKINS PVT.LTD",
"SHANKAR NUTRICON PRIVATE LIMITED",
"SHANKAR PACKAGINGS LIMITED.",
"SHANKAR PARVATI INDUSTRIES",
"SHANKAR PLYWOOD PRIVATE LIMITED",
"SHANKAR POLYMER PRIVATE LIMITED",
"SHANKAR RAGS PRIVATE LIMITED",
"SHANKAR RAMCHANDRA EARTHMOVERS PRIVATE LIMITED",
"SHANKAR RICE & GENERAL MILLS",
"SHANKAR RICE INDUSTRIES",
"SHANKAR RICE MILL",
"SHANKAR ROADWAYS PRIVATE LIMITED",
"SHANKAR SAREE STORE PRIVATE LIMITED",
"SHANKAR SHAMBHU BUILDERS PRIVATE LIMITED",
"SHANKAR STEELS PVT.LTD.",
"SHANKAR SUWAN COLD STORAGE PRIVATE LIMITED",
"SHANKAR TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"SHANKAR THREADS PRIVATE LIMITED",
"SHANKAR TRADING COMPANY PRIVATE. LIMITED.",
"SHANKAR TREXIM PRIVATE LIMITED",
"SHANKAR VITAL MOTOR COMPANY LIMITED",
"SHANKAR WELDMESH PRIVATE LIMITED",
"SHANKAR6 COTTON FIBERS PRIVATE LIMITED",
"SHANKARA BIOCHEM PRIVATE LIMITED",
"SHANKARA BUILDING PRODUCTS LIMITED",
"SHANKARA INFRASTRUCTURE MATERIALS LIMITED",
"SHANKARA MEDICINES PRIVATE LIMITED",
"SHANKARA MOTORS",
"SHANKARA SAI RICE INDUSTRIES",
"SHANKARA VEHICLES PRIVATE LIMITED",
"SHANKARANARAYANA CONSTRUCTIONS PRIVATE LIMITED",
"SHANKARANARAYANA INDUSTRIES AND PLANTATIONS PRIVATE LIMITED",
"SHANKARBARDANI COLD STORAGE PRIVATE LIMITED",
"SHANKARDEVI EXPORTS PRIVATE LIMITED",
"SHANKARDORI UDYOG PRIVATE LIMITED",
"SHANKARLAL GILADA & SONS PRIVATE LIMITED",
"SHANKARLAL JAIN AND ASSOCIATES LLP",
"SHANKARLAL RAMARATAN FINANCE PRIVATE LIMITED",
"SHANKARPUR CHIMUR HIGHWAY PRIVATE LIMITED",
"SHANKARRAJ IMPEX PRIVATE LIMITED",
"SHANKAR'S BOOK AGENCY PRIVATE LIMITED",
"SHANKER CLOTHEX PRIVATE LIMITED",
"SHANKER COILS PRIVATE LIMITED",
"SHANKER FORGE PRIVATE. LIMITED.",
"SHANKER FUELS PRIVATE LIMITED",
"SHANKER INTERNATIONAL PRIVATE LIMITED",
"SHANKER LOGISTICS PRIVATE LIMITED",
"SHANKER MERCANTILE PRIVATE LIMITED",
"SHANKER POLYTUBES PRIVATE LIMITED",
"SHANKER PRINTING MILLS",
"SHANKER TANKS AND PIPES PRIVATE LIMITED",
"SHANKER TRADERS",
"SHANKER WOOD PRIVATE LIMITED",
"SHANKERSINH VAGHELA BAPU INSTITUTE OF TECHNOLOGY",
"SHANKESH JEWELLERS PRIVATE LIMITED",
"SHANKESH TRADE IMPEX PRIVATE LIMITED",
"SHANKESHWAR LANDMARKS LLP",
"SHANKESHWAR TOWERS PRIVATE LIMITED",
"SHANKESHWARA FOOD PRODUCT PRIVATE LIMITED",
"SHANKHA DEEP EXPORTS PRIVATE LIMITED",
"SHANKHANIL REALTORS PRIVATE LIMITED",
"SHANKHESHWAR DESIGNER PRIVATE LIMITED",
"SHANKHESHWAR GOLD PRIVATE LIMITED",
"SHANKHESHWAR IMPEX PRIVATE LIMITED",
"SHANKHESHWAR MATERIAL SUPPLIERS",
"SHANKHESHWAR PROPERTIES PRIVATE LIMITED",
"SHANKHESHWARA JEWELS PRIVATE LIMITED",
"SHANKHESVER ENTERPRISES PRIVATE LIMITED",
"SHANKUS ACME PHARMA PRIVATE LIMITED",
"SHANKU'S BIOSCIENCES PRIVATE LIMITED",
"SHANMUGA TEX PRIVATE LIMITED",
"SHANMUGAPPRIYA TEXTILES PRIVATE LIMITED",
"SHANMUGAR SALTERNS PRIVATE LIMITED",
"SHANMUGHA ARTS SCIENCE TECHNOLOGY & RESEARCH ACADEMY",
"SHANMUGHA SALT AND CHEMICALS PRIVATE LIMITED",
"SHANMUKHA AERO ENGINEERING PRIVATE LIMITED",
"SHANMUKHA AGRITEC LIMITED",
"SHANMUKHA INDUSTRIES LLP",
"SHANMUKHA SALE PRIVATE LIMITED",
"SHANNO BUSINESS INDIA PRIVATE LIMITED",
"SHANNON & SHANNON",
"SHANPAR INDUSTRIES PRIVATE LIMITED",
"SHANPAR PHARMACHEM PRIVATE LIMITED",
"SHANRO KEY CHEM INDUSTRIES PRIVATE LIMITED",
"SHANSCO PACKAGING PRIVATE LIMITED",
"SHANT HANDLOOM INDUSTRIES PVT. LTD.",
"SHANT TRANSMISSIONS PRIVATE LIMITED",
"SHANTA COLIBRI (INDIA) PRIVATE LIMITED",
"SHANTA COTTON INDUSTRIES PRIVATE LIMITED",
"SHANTA ENTERPRISES PVT LTD",
"SHANTA G FOODS PRIVATE LIMITED",
"SHANTA HOSIERY PRIVATE LIMITED",
"SHANTA INNERWEARS PRIVATE LIMITED",
"SHANTA MANGESH DEVELOPERS PRIVATE LIMITED",
"SHANTA METAL AND MINERALS PRIVATE LIMITED",
"SHANTA SRIRAM CONSTRUCTIONS PRIVATE. LIMITED",
"SHANTA TECHNO PRIVATE LIMITED",
"SHANTA TRADEXIM PRIVATE LIMITED",
"SHANTAI INDUSTRIES LIMITED",
"SHANTAKARAM JEWELS PRIVATE LIMITED",
"SHANTAM HOLDINGS INDIA PRIVATE LIMITED",
"SHANTAM PHARMACEUTICALS PVT LTD",
"SHANTAM TRADELINK PRIVATE LIMITED",
"SHANTANI PROTEOME ANALYTICS PRIVATE LIMITED",
"SHANTANU INVESTMENTS PRIVATE LIMITED",
"SHANTANU MARKETING PRIVATE LIMITED",
"SHANTANU VIDYALAY",
"SHANTDEEP METALS PRIVATE LIMITED",
"SHANTECH INTERNATIONAL PRIVATE LIMITED",
"SHANTERI INVESTMENT PRIVATE LIMITED",
"SHANTESHA AUTO PRIVATE LIMITED",
"SHANTESHA MOTORS PRIVATE LIMITED",
"SHANTHA BIOTECHNICS PRIVATE LIMITED",
"SHANTHA ELECTRICALS AND ENGINEERS PRIVATE LIMITED",
"SHANTHA TRUST",
"SHANTHALA FMCG PRODUCTS LIMITED",
"SHANTHALA MACHINING TECHNOLOGIES PRIVATE LIMITED",
"SHANTHALA POWER LIMITED",
"SHANTHALA SPHEROCAST PRIVATE LIMITED",
"SHANTHARI EXPORTS PRIVATE LIMITED",
"SHANTHI FEEDS PRIVATE LIMITED",
"SHANTHI GEARS LIMITED",
"SHANTHI HATCHERIES PRIVATE LIMITED",
"SHANTHI HOSPITAL & RESEARCH CENTRE PRIVATE. LIMITED",
"SHANTHIGRAM DAIRY PROMOTION",
"SHANTHIGRAM MILK PRODUCER COMPANY LIMITED",
"SHANTHINIKETAN POLYTECHNIC COLLEGE",
"SHANTHU EMPLOYMENT PRIVATE LIMITED",
"SHANTI & RAJ INFRACON PRIVATE LIMITED",
"SHANTI ADVENTURE TOURS PRIVATE LIMITED",
"SHANTI ARMS-TECH PRIVATE LIMITED",
"SHANTI ASIATIC SCHOOL (BOPAL)",
"SHANTI ASIATIC SCHOOL JAIPUR",
"SHANTI ASSOCIATES",
"SHANTI ATITHI HOME PRIVATE LIMITED",
"SHANTI AUTOMART PRIVATE LIMITED",
"SHANTI BUILDCON PRIVATE LIMITED",
"SHANTI BUSINESS SCHOOL",
"SHANTI CAPINVEST PRIVATE LIMITED",
"SHANTI CEMENTS PRIVATE LIMITED",
"SHANTI CHEMICAL WORKS",
"SHANTI CHEMTRADE PRIVATE LIMITED",
"SHANTI CLEARING AGENCY PRIVATE LIMITED",
"SHANTI COILS & REFRIGERATION EQUIPMENTS PRIVATE. LIMITED.",
"SHANTI COLLECTIONS PRIVATE LIMITED",
"SHANTI COMBINE PRIVATE LIMITED",
"SHANTI CONST GUJ AND YASHNAND ENG AND CONST JV PRIVATE LIMITED",
"SHANTI CONSTRUCTION GUJ PRIVATE LIMITED",
"SHANTI CONSTRUCTION SAMBALPUR PRIVATE LIMITED",
"SHANTI CORPORATION LIMITED",
"SHANTI COTS YARN PRIVATE LIMITED",
"SHANTI DEVI CHARITABLE TRUST",
"SHANTI DRIVES AND AUTOMATION PRIVATE LIMITED",
"SHANTI EDUCATIONAL INITIATIVES LIMITED",
"SHANTI EDUCATIONAL TRUST",
"SHANTI ENGGICON PRIVATE LIMITED",
"SHANTI ENGLISH MEDIUM SCHOOL",
"SHANTI ENTERPRISES",
"SHANTI EXIM INTERNATIONAL PRIVATE LIMITED",
"SHANTI EXPORTS PRIVATE LIMITED",
"SHANTI FABRICS PRIVATE LIMITED",
"SHANTI FINTRADE PRIVATE LIMITED",
"SHANTI FLATS AND FOUNDATIONS PRIVATE LIMITED",
"SHANTI FOODCHEM PRIVATE LIMITED",
"SHANTI FOREX PRIVATE LIMITED",
"SHANTI FOUMACH PRIVATE LIMITED",
"SHANTI FOUNDERS PRIVATE LIMITED",
"SHANTI G.D. ISPAT & POWER PRIVATE. LIMITED.",
"SHANTI GANGA PLASTO PACKS PRIVATE LIMITED",
"SHANTI GOLD INTERNATIONAL LIMITED",
"SHANTI GOLD PRIVATE LIMITED",
"SHANTI GOPAL CONCAST LIMITED",
"SHANTI GOPAL HOSPITAL",
"SHANTI GRIHA PRIVATE LIMITED",
"SHANTI HARI REALTY PRIVATE LIMITED",
"SHANTI HEALTH SERVICES PRIVATE LIMITED",
"SHANTI HOSPITALITY MANAGEMENT SERVICES PRIVATE LIMITED",
"SHANTI HOSPITALITY PRIVATE LIMITED",
"SHANTI ICE AND PRESERVATIONS PRIVATE LIMITED",
"SHANTI INDIA PVT LTD",
"SHANTI INFRAENGINEERING PRIVATE LIMITED",
"SHANTI INNOVATION AND RESEARCH FOUNDATION",
"SHANTI INORGO CHEM (GUJ) PRIVATE LIMITED",
"SHANTI INSTRUMENTS PRIVATE LIMITED",
"SHANTI INTEGRATED TEXTILE PARK PRIVATE LIMITED",
"SHANTI INTERMEDIATES PRIVATE LIMITED",
"SHANTI ISPAT LIMITED",
"SHANTI LAL NIRMAN PRIVATE LIMITED",
"SHANTI MACHINERY WORKS PRIVATE LIMITED",
"SHANTI MEDICAL DEVICE PRIVATE LIMITED",
"SHANTI METALFAB PRIVATE LIMITED",
"SHANTI MOHAN AND SONS ROLLER FLOUR MILL PRIVATE LIMITED",
"SHANTI MOTORS",
"SHANTI MUKAND HOSPITAL",
"SHANTI MULTILINK PRIVATE LIMITED",
"SHANTI NATH INFRASTRUCTURE AND ESTATES PRIVATE LIMITED",
"SHANTI NIKETAN COMPUTER AND COMMUNICATION PRIVATE LIMITED",
"SHANTI NIKETAN HOSPITALITY PRIVATE LIMITED",
"SHANTI NIKETAN JHS SHALL REC",
"SHANTI NIKETAN PUBLIC SCHOOL",
"SHANTI OILPALM IND. PRIVATE LIMITED",
"SHANTI OVERSEAS (INDIA) LIMITED",
"SHANTI OVERSEAS INDIA LIMITED",
"SHANTI PATRA PLASTICS PVT LTD",
"SHANTI PICKLES PRIVATE LIMITED",
"SHANTI PRAKASH POWER PRIVATE LIMITED",
"SHANTI PRECISION MACHINES PRIVATE LIMITED",
"SHANTI RATTAN CONSTRUCTION PRIVATE LIMITED",
"SHANTI RAYONS INDIA PRIVATE LIMITED",
"SHANTI REALTY PVT LTD",
"SHANTI REFRIGERATION INDUSTRIES PRIVATE. LIMITED.",
"SHANTI RESIDENCES PRIVATE LIMITED",
"SHANTI ROAD AND CONSTRUCTION PRIVATE LIMITED",
"SHANTI ROAD SERVICES PRIVATE LIMITED",
"SHANTI ROLLER FLOUR MILLS LIMITED",
"SHANTI ROLLER FLOUR MILLS PRIVATE LIMITED",
"SHANTI SAGAR INTERNATIONAL DREDGING LIMITED",
"SHANTI SCOOTERS PRIVATE LIMITED",
"SHANTI SHEET GRAH PRIVATE LIMITED",
"SHANTI SHIP BREAKERS PRIVATE LIMITED",
"SHANTI SHIPPING SERVICES PRIVATE LIMITED",
"SHANTI SHIRTING PRIVATE LIMITED",
"SHANTI SMELTING PRIVATE LIMITED",
"SHANTI SNACKS PRIVATE LIMITED",
"SHANTI SPICES PRIVATE LIMITED",
"SHANTI SPINCOT PRIVATE LIMITED",
"SHANTI SPINTEX LIMITED",
"SHANTI SPINTEX PRIVATE LIMITED",
"SHANTI STRUCTURE PRIVATE LIMITED",
"SHANTI SUGAR INDUSTRIES",
"SHANTI SURGICALS PRIVATE LIMITED",
"SHANTI SURI SECURITIES PVT LTD",
"SHANTI SWAROOP KRISHI INTER COLLEGE",
"SHANTI TECHSOLUTIONS PRIVATE LIMITED",
"SHANTI TRADE-LINK PRIVATE LIMITED",
"SHANTI UDYOG WELDSAFE PRIVATE LIMITED",
"SHANTI VANIJYA PRIVATE LIMITED",
"SHANTI VIJAY INVESTMENT PRIVATE LIMITED",
"SHANTI VRAT AND SONS PRIVATE LIMITED",
"SHANTI WHEAT PRODUCTS PRIVATE LIMITED",
"SHANTI WHEELS PRIVATE LIMITED",
"SHANTIBARI TEA PRODUCER COMPANY LIMITED",
"SHANTICHANDRA COLD LOGISTICS PRIVATE LIMITED",
"SHANTIDEVI GLOBAL EXIM PRIVATE LIMITED",
"SHANTIDHAM MARKETING PRIVATE LIMITED",
"SHANTIDHAN STONE & MINERALS PRIVATE LIMITED",
"SHANTIDOOT INFRA SERVICES LIMITED",
"SHANTIGRAM UTILITY SERVICES PRIVATE LIMITED",
"SHANTIJANAK ESTATES PRIVATE LIMITED",
"SHANTIKRUPA ESTATES PRIVATE LIMITED",
"SHANTILAL C. MEHTA",
"SHANTILAL ENTERPRISES (DURGAPUR) PRIVATE LIMITED",
"SHANTILAL GLASS INDUSTRIES PRIVATE LIMITED",
"SHANTILAL OILS PRIVATE LIMITED",
"SHANTILAL SHIPPING AND CHARTERING PRIVATE LIMITED",
"SHANTINATH AGRI COMMODITIES PRIVATE LIMITED",
"SHANTINATH COLONISERS PRIVATE LIMITED",
"SHANTINATH DETERGENTS PRIVATE LIMITED",
"SHANTINATH MOTORS PRIVATE LIMITED",
"SHANTINATH SYNTHETICS PRIVATE LIMITED",
"SHANTINIKETAN PROPERTIES PRIVATE LIMITED",
"SHANTINIKETAN PU COLLEGE",
"SHANTINIKETAN SILKS PRIVATE LIMITED",
"SHANTINIKETAN VIDHYA VIHAR",
"SHANTINIKTAN VIDYALAYA",
"SHANTIPRAKASH DYEING AND PRINTING MILLS PRIVATE LIMITED",
"SHANTIRAJ FOODS PRIVATE LIMITED",
"SHANTIRAJ HOSPITAL PRIVATE LIMITED",
"SHANTIVIJAY ADORNMENTS PRIVATE LIMITED",
"SHANTIVIJAY JEWELS LIMITED",
"SHANTIVILAS MEDICARE PRIVATE LIMITED",
"SHANTOL GREEN INDIA PRIVATE LIMITED",
"SHANU PATEL HIGH SCHOOL",
"SHANU SILK MILLS INDIA PRIVATE. LIMITED.",
"SHANU SILK MILLS PRIVATE LIMITED",
"SHANUGA SPICES PRIVATE LIMITED",
"SHANVATS FOODS PRIVATE LIMITED",
"SHANVI ESTATE MANAGEMENT SERVICES PRIVATE LIMITED",
"SHANVISHAILJA COTEX PRIVATE LIMITED",
"SHANZ POWERTECHS PRIVATE LIMITED",
"SHAPARIA DOCK AND STEEL COMPANY PRIVATE LIMITED",
"SHAPE ENGINEERING COMPANY PRIVATE LIMITED",
"SHAPE MACHINE TOOLS PRIVATE LIMITED",
"SHAPE OF YOU PRIVATE LIMITED",
"SHAPE WATERJET PRIVATE LIMITED",
"SHAPEARTH INFRA VENTURES PRIVATE LIMITED",
"SHAPERS CONSTRUCTIONS LIMITED",
"SHAPERS INDIA PRIVATE LIMITED",
"SHAPERZ INDIA GRAIN PRIVATE LIMITED",
"SHAPES APPARELS PRIVATE LIMITED",
"SHAPES CLOTHING COMPANY PRIVATE LIMITED",
"SHAPES COMMUNICATIONS PRIVATE LIMITED",
"SHAPES PRODUCTS PRIVATE LIMITED",
"SHAPEWELL TECHNOLOGIES PRIVATE LIMITED",
"SHAPING DREAM PROJECTS PRIVATE LIMITED",
"SHAPING MINES & MINERALS PRIVATE LIMITED",
"SHAPOORJI PALLONJI (GWALIOR) PRIVATE LIMITED",
"SHAPOORJI PALLONJI AND COMPANY PRIVATE LIMITED",
"SHAPOORJI PALLONJI ARMADA OIL AND GAS SERVICES PRIVATE LIMITED",
"SHAPOORJI PALLONJI BUMI ARMADA OFFSHORE PRIVATE LIMITED",
"SHAPOORJI PALLONJI CEMENT (GUJARAT) PRIVATE LIMITED",
"SHAPOORJI PALLONJI DEVELOPMENT MANAGERS PRIVATE LIMITED",
"SHAPOORJI PALLONJI ENERGY GUJARAT PRIVATE LIMITED",
"SHAPOORJI PALLONJI ENERGY PRIVATE LIMITED",
"SHAPOORJI PALLONJI FORBES SHIPPING PRIVATE LIMITED",
"SHAPOORJI PALLONJI GHANA LIMITED",
"SHAPOORJI PALLONJI INFRASTRUCTURE CAPITAL COMPANY LIMITED",
"SHAPOORJI PALLONJI INVESTMENT ADVISORS PRIVATE LIMITED",
"SHAPOORJI PALLONJI LOGISPACE & INVESTMENT ADVISORS PRIVATE LIMITED",
"SHAPOORJI PALLONJI PANDOH TAKOLI HIGHWAY PRIVATE LIMITED",
"SHAPOORJI PALLONJI ROADS PRIVATE LIMITED",
"SHAPOORJI PALLONJI RURAL SOLUTIONS PRIVATE LIMITED",
"SHAPOORJI PALLONJI TECHNICAL SERVICES PRIVATE LIMITED",
"SHAPORA OVERSEAS PRIVATE LIMITED",
"SHAPOTOOLS",
"SHAPPHIRE BUILDHEIGHTS INDIA PRIVATE LIMITED",
"SHAPPHIRE CERAMIC PRIVATE LIMITED",
"SHARA VET PHARMA PRIVATE LIMITED",
"SHARABHESWARA COLLEGE OF EDUCATION",
"SHARAD ADVERTISING PVT LTD",
"SHARAD COLLEGE OF NURSING",
"SHARAD CONSTRUCTIONS PRIVATE. LIMITED.",
"SHARAD CONSTRUCTIONS SEZ PRIVATE LIMITED",
"SHARAD COTTON PRIVATE LIMITED",
"SHARAD FINLEASE PRIVATE LIMITED",
"SHARAD FOOD SOLUTION PRIVATE LIMITED",
"SHARAD INDUSTRIAL PRODUCTS PRIVATE LIMITED",
"SHARAD INSULATIONS & INTERIORS PRIVATE LIMITED",
"SHARAD PACKAGING PRIVATE LIMITED",
"SHARAD PROJECTS INDIA LIMITED",
"SHARAD QUENCH PRIVATE LIMITED",
"SHARAD SAHAKARI BANK LTD MANCHAR",
"SHARAD SYNTEX PRIVATE LIMITED",
"SHARAD TEXTILES PRIVATE LIMITED",
"SHARAD TRADING FOOD GRAINS PRIVATE LIMITED",
"SHARAD TRAFIN PVT LTD",
"SHARADA BUSINESS SOLUTIONS PRIVATE LIMITED",
"SHARADA DESIGNS PRIVATE LIMITED",
"SHARADA INSTRUMENTATION PRIVATE LIMITED",
"SHARADA INTERNATIONAL HOTELS PVT LTD",
"SHARADA REROLLERS PRIVATE LIMITED",
"SHARADA SILVERLINE PRIVATE LIMITED",
"SHARADA TECHNO SPECIALTIES PRIVATE LIMITED",
"SHARADA VIDYALAYA",
"SHARADA WELDING PRIVATE LIMITED",
"SHARADAA CERAMICS PRIVATE LIMITED",
"SHARADAKRUPA COLD STORAGE PRIVATE LIMITED",
"SHARADASHRAM VIDYAMANDIR INDUSTRIAL TRAINING CENTRE",
"SHARADAYANE LAKSHMI HOTELS PRIVATE LIMITED",
"SHARADCHANDRA ARTS-COMMERCE COLLEGE",
"SHARADCHANDRA P SHAH AGENCY PRIVATE LIMITED",
"SHARADCHANDRA PAWAR ARTS & COMMERCE COLLEGE",
"SHARADHA TERRY PRODUCTS LIMITED",
"SHARAF CARGO PRIVATE LIMITED",
"SHARAF PROCESSING SERVICES PRIVATE LIMITED",
"SHARAF TRAVELS PRIVATE LIMITED",
"SHARAN ELECMECH PRIVATE LIMITED",
"SHARAN ENTERPRISES PVT LTD",
"SHARAN OVERSEAS PRIVATE LIMITED",
"SHARAN SHELTERS PRIVATE LIMITED",
"SHARANAM HOTELS & RESORTS PRIVATE LIMITED",
"SHARANGDHAR PHARMACEUTICALS PVT LTD",
"SHARANYA MARKETING PRIVATE LIMITED",
"SHARAT INDUSTRIES LIMITED",
"SHARATH TECHNOLOGIES PRIVATE LIMITED",
"SHARAVATHI HOSPITALS PRIVATE LIMITED",
"SHARAVATHY CONDUCTORS PRIVATE LIMITED",
"SHARAVATI AGROTECH PRIVATE LIMITED",
"SHARAVI LOGISTICS PRIVATE LIMITED",
"SHARAYA COSMOCARE PRIVATE LIMITED",
"SHARAYU 2 WHEELERS PRIVATE LIMITED",
"SHARAYU AGRO INDUSTRIES LIMITED",
"SHARAYU AUTOLINKS PRIVATE LIMITED",
"SHARAYU AUTOMOBILES PRIVATE LIMITED",
"SHARAYU INFRA DEVELOPMENT PRIVATE LIMITED",
"SHARDA AGRI FOODS PRIVATE LIMITED",
"SHARDA ALLOYS PVT LTD",
"SHARDA AUTO INDUSTRIES LIMITED",
"SHARDA BAKERY PVT LTD",
"SHARDA BHAWANI FOODS PRIVATE LIMITED",
"SHARDA BRICKS & BLOCKS PRIVATE LIMITED",
"SHARDA BUILDERS AND PROMOTERS PVT LTD",
"SHARDA BUILDWELL PRIVATE LIMITED",
"SHARDA CABLE TRAYS PRIVATE LIMITED",
"SHARDA CAPITAL PRIVATE LIMITED",
"SHARDA CARDS PRIVATE LIMITED",
"SHARDA CERAMICS PRIVATE LIMITED",
"SHARDA CHEM INTERNATIONAL PRIVATE LIMITED",
"SHARDA COMMODITIES PRIVATE LIMITED",
"SHARDA COMTRADE PRIVATE LIMITED",
"SHARDA CONSTRUCTION AND CORPORATION PRIVATE LIMITED",
"SHARDA CONTAINERS PRIVATE LIMITED",
"SHARDA CROPCHEM LIMITED",
"SHARDA DEVI VIDYAPEETH.",
"SHARDA DIESELS PRIVATE LIMITED",
"SHARDA ELECTROTECH PRIVATE LIMITED",
"SHARDA EXCEL PRIVATE LIMITED",
"SHARDA EXPORTS PRIVATE LIMITED",
"SHARDA FLOUR PRIVATE LIMITED",
"SHARDA FOOD & BEVERAGE PRIVATE LIMITED",
"SHARDA FORGING AND STAMPING PVT LTD",
"SHARDA GLOBAL SCHOOL",
"SHARDA GRANITE AND MARBLES PVT LTD",
"SHARDA HEALTH CARE PRIVATE LIMITED",
"SHARDA HOSPITAL",
"SHARDA INFRA CONSTRUCTION PRIVATE LIMITED",
"SHARDA INFRABUILD PRIVATE LIMITED",
"SHARDA INFRAENGINEERS PRIVATE LIMITED",
"SHARDA INFRASOLUTIONS PRIVATE LIMITED",
"SHARDA INTEGRATED SYSTEMS PRIVATE LIMITED",
"SHARDA INTERNATIONAL SCHOOL",
"SHARDA ISPAT LIMITED",
"SHARDA LIFE CARE HOSPITAL MUNGELI",
"SHARDA MA LOGISTICS PRIVATE LIMITED",
"SHARDA MALL AND CABLE AGENCY PRIVATE LIMITED",
"SHARDA MANDIR HIGH SCHOOL KALYAN",
"SHARDA MERCANDISE PVT LTD",
"SHARDA MINERALS AND CHEMICALS PRIVATE LIMITED",
"SHARDA MOTOR INDUSTRIES LIMITED",
"SHARDA NARAYAN HEALTH CARE PRIVATE LIMITED",
"SHARDA NARAYAN PHARMACY PRIVATE LIMITED",
"SHARDA OFFSET PRINTERS PRIVATE LIMITED",
"SHARDA OIL INDUSTRIES PRIVATE LIMITED",
"SHARDA PACKAGING PRIVATE LIMITED",
"SHARDA PIPES PRIVATE LIMITED",
"SHARDA PRECISION PRIVATE LIMITED",
"SHARDA PRESS PRIVATE LIMITED",
"SHARDA PROJECTS PRIVATE LIMITED",
"SHARDA PROPERTIES PRIVATE LIMITED",
"SHARDA PROPLENE PRIVATE LIMITED",
"SHARDA REFRACTORIES PRIVATE LIMITED",
"SHARDA RESOURCES LIMITED",
"SHARDA SALES PVT LTD",
"SHARDA SHELTERS PRIVATE LIMITED",
"SHARDA SOLVENT LIMITED",
"SHARDA SONS RESOURCES PRIVATE LIMITED",
"SHARDA SPUNTEX PRIVATE LIMITED",
"SHARDA SUPER BAZAR PRIVATE LIMITED",
"SHARDA SYNCOTEX PRIVATE LIMITED",
"SHARDA TEXFEB PRIVATE LIMITED",
"SHARDA TIMBER PRIVATE LIMITED",
"SHARDA TOOLS COMPANY PRIVATE LIMITED",
"SHARDA UNIVERSITY",
"SHARDA VASTU NIRMITEE PRIVATE LIMITED",
"SHARDA VENTURES PRIVATE LIMITED",
"SHARDABADAI PAWAR MAHILA ARTS COMMERSE & SCIENCE COLLEGE",
"SHARDALOHA KHANAPUR HIGHWAY PRIVATE LIMITED",
"SHARDA-MA TRADEMART PRIVATE LIMITED",
"SHARDAMUDKHED CHINCHOLI HIGHWAY PRIVATE LIMITED",
"SHARDAPUNJ FUEL COKE PRIVATE LIMITED",
"SHARDASHRAM VIDYAMANDIR",
"SHARDASHREE ISPAT LIMITED",
"SHARDEIN SCHOOL",
"SHARDIYA AGRITECH PRIVATE LIMITED",
"SHARDUL AMARCHAND MANGALDAS & CO",
"SHARDUL SECURITIES LIMITED",
"SHARE INDIA ALGOPLUS PRIVATE LIMITED",
"SHARE INDIA CAPITAL SERVICES PRIVATE LIMITED",
"SHARE INDIA FINCAP PRIVATE LIMITED",
"SHARE INDIA INSURANCE BROKERS PRIVATE LIMITED",
"SHARE INDIA SECURITIES LIMITED",
"SHARE MICROFIN LIMITED",
"SHARE SAMADHAN LIMITED",
"SHARE WISE EQUITY BROKERS PRIVATE LIMITED",
"SHARED SERVICES INTERNATIONAL INDIA PRIVATE LIMITED",
"SHAREDESK COWORKING PRIVATE LIMITED",
"SHAREDPRO TECHNOLOGIES PRIVATE LIMITED",
"SHAREEN AUTO PRIVATE LIMITED",
"SHAREKHAN BNP PARIBAS FINANCIAL SERVICE P LIMITED",
"SHAREKHAN COMMODITIES PRIVATE LIMITED",
"SHAREKHAN FINANCIAL SERVICES PRIVATE LIMITED",
"SHAREKHAN LIMITED",
"SHAREKHANCOM INDIA PRIVATE LIMITED",
"SHAREPOINT SHOP INDIA PRIVATE LIMITED",
"SHAREWEALTH SECURITIES LIMITED",
"SHAREX DYNAMIC INDIA PRIVATE LIMITED",
"SHARGEE F N B PRIVATE LIMITED",
"SHARIDEN PRIVATE LIMITED",
"SHARIEF MARINE PRODUCTS PRIVATE LIMITED",
"SHARIFA AGROTECH AND FOOD PROCESSING PRIVATE LIMITED",
"SHARIFY SERVICES PRIVATE LIMITED",
"SHARIKA ENTERPRISES PRIVATE LIMITED",
"SHARIKA LIFE SCIENCE LIMITED",
"SHARING FORMULATIONS PRIVATE LIMITED",
"SHARING INDUSTRIAL DEVELOPMENT POWER PRIVATE LIMITED",
"S-HARIOM DISH DELIGHT PRIVATE LIMITED",
"SHARK ADVERTISING PRIVATE LIMITED",
"SHARK AND INK ENTERTAINMENT PRIVATE LIMITED",
"SHARK BUSINESS SOLUTIONS PRIVATE LIMITED",
"SHARK MINES & MINERALS PRIVATE LIMITED",
"SHARK NETWORKS PRIVATE LIMITED",
"SHARK ROADWAYS PRIVATE LIMITED",
"SHARK SHOPFITS PRIVATE LIMITED",
"SHARKNET CABLE NETWORK PRIVATE LIMITED",
"SHARKSTRIKER PRIVATE LIMITED",
"SHARLA COMPUTER TECHNOLOGY PRIVATE LIMITED",
"SHARMA AND ASSOCIATES FIRETECH PRIVATE LIMITED",
"SHARMA AND GANGAHAR BUILDERS AND COLONISERS PRIVATE LIMITED",
"SHARMA ART PRODUCTIONS PRIVATE LIMITED",
"SHARMA BROTHERS",
"SHARMA BUILDTECH PRIVATE LIMITED",
"SHARMA CARS PRIVATE LIMITED",
"SHARMA CHEMINDUS PRIVATE LIMITED",
"SHARMA CONSTRUCTION COMPANY",
"SHARMA DRUGS PRIVATE LIMITED",
"SHARMA ENGINEERING CORPORATION PVT LTD",
"SHARMA FABRICATORS AND ERECTORS PRIVATE LIMITED",
"SHARMA FRIEGHT CARRIERS PRIVATE LIMITED",
"SHARMA HOMETEX PRIVATE LIMITED",
"SHARMA INDIA PRIVATE LIMITED",
"SHARMA INTERNATIONAL (INDIA) LIMITED",
"SHARMA INTERNATIONAL PRIVATE LIMITED",
"SHARMA MARMO ASSOCIATES PVT LTD",
"SHARMA MEDICARE PRIVATE LIMITED",
"SHARMA METALLOYS PRIVATE LIMITED",
"SHARMA ORTHOPEDIC INDIA PRIVATE LIMITED",
"SHARMA PUBLICATIONS PRIVATE LIMITED",
"SHARMA SECURITY AND FIRE SERVICES PRIVATE LIMITED",
"SHARMA SERVICE SECURITY AGENCY PRIVATE LIMITED",
"SHARMA TRANSPORT ENGINEERING EQUIPMENTS AND RENTALS PRIVATE LIMITED",
"SHARMA VIDEOS PRIVATE. LIMITED.",
"SHARMA YARN PRIVATE LIMITED",
"SHARMAA HEALTHCARE PRIVATE LIMITED",
"SHARMAGROW EXPORTS PRIVATE LIMITED",
"SHARMAN SPINNING MILLS PRIVATE LIMITED",
"SHARMAN UDYOG PRIVATE LIMITED",
"SHARMAN WOOLLEN MILLS PRIVATE LIMITED",
"SHARMANJI YARNS PRIVATE LIMITED",
"SHARMILA BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"SHARMILA FINVEST PRIVATE LIMITED",
"SHARMILI SPICES PRIVATE LIMITED",
"SHARMITA INFRA PRIVATE LIMITED",
"SHARNAM MOTOR SERVICES PRIVATE LIMITED",
"SHARNAM TEX-INDIA PRIVATE LIMITED",
"SHARNBASVA UNIVERSITY",
"SHARNESHVAR ALLOYS PRIVATE LIMITED",
"SHARNYA INFRA PRIVATE LIMITED",
"SHAROBI TECHNOLOGIES INDIA PRIVATE LIMITED",
"SHARON BIO-MEDICINE LIMITED",
"SHARON CONTROLS INDIA PRIVATE LIMITED",
"SHARON MINES TECH PRIVATE LIMITED",
"SHARON NAYAK DESIGN STUDIO PRIVATE LIMITED",
"SHARON TOURS & TRAVELS PRIVATE LIMITED",
"SHARP (MADURAI) SECURITY MANAGEMENT SERVICES PRIVATE LIMITED",
"SHARP AGRICOM LIMITED",
"SHARP AND TANNAN ASSOCIATES ADVISORS PRIVATE LIMITED",
"SHARP AUTO PRIVATE LIMITED",
"SHARP BIOTECH SPECIALITY INDIA PRIVATE LIMITED",
"SHARP BUSINESS SYSTEMS INDIA PRIVATE LIMITED",
"SHARP CALCHEM PRIVATE LIMITED",
"SHARP CHUCKS AND MACHINES LIMITED",
"SHARP CHUCKS AND MACHINES PRIVATE LIMITED",
"SHARP COATING PRIVATE LIMITED.",
"SHARP CONSULTANTS PRIVATE LIMITED",
"SHARP DESIGNERS AND ENGINEERS INDIA PRIVATE LIMITED",
"SHARP DIAGNOSTIC PRIVATE LIMITED",
"SHARP DIAMOND TOOLS PRIVATE LIMITED",
"SHARP DIGITAL PRINTS PRIVATE LIMITED",
"SHARP DIGITALS PRIVATE LIMITED",
"SHARP EAGLE INVESTIGATION LIMITED",
"SHARP ELECTRODES PRIVATE LIMITED",
"SHARP EYE ADVERTISING PRIVATE LIMITED",
"SHARP FERRO ALLOYS LIMITED",
"SHARP GARUDA FARM EQUIPMENTS PRIVATE LIMITED",
"SHARP GAZE TECH SERVICES PRIVATE LIMITED",
"SHARP GLOBAL AIR SEA LOGISTICS PRIVATE LIMITED",
"SHARP GLOBAL FREIGHT PRIVATE LIMITED",
"SHARP HRD SERVICES PRIVATE LIMITED",
"SHARP INDIA LIMITED",
"SHARP INSURANCE SURVEYORS AND LOSS ASSESSORS PRIVATE LIMITED",
"SHARP INTERNATIONAL PRODUCTS PRIVATE LIMITED",
"SHARP KING TRADING COMPANY PRIVATE LIMITED",
"SHARP LOGISTIC PRIVATE LIMITED",
"SHARP MARKET RESEARCH PRIVATE LIMITED",
"SHARP MEDICAL SOLUTIONS PRIVATE LIMITED",
"SHARP MINCHEM PVT LTD",
"SHARP NDT SERVICES PRIVATE LIMITED",
"SHARP PLASTICS PRIVATE LIMITED",
"SHARP PLY INDIA PRIVATE LIMITED",
"SHARP POWER AND COMMUNICATION EQUIPMENTS INDIA PRIVATE LIMITED",
"SHARP PROTECTIVE SERVICES PRIVATE LIMITED",
"SHARP PUBLICATIONS PRIVATE LIMITED",
"SHARP PUMPS PRIVATE LIMITED",
"SHARP SIGHT CENTRE PRIVATE LIMITED",
"SHARP SIGHT FACILITY MANAGEMENT PRIVATE LIMITED",
"SHARP SIGHT LASER CENTRE PRIVATE LIMITED",
"SHARP SOFTWARE DEVELOPMENT INDIA PRIVATE LIMITED",
"SHARP TANKS AND STRUCTURALS PRIVATE LIMITED",
"SHARP TECHNOENGINEERS PRIVATE LIMITED",
"SHARP THERMAL ENGINEERS PRIVATE LIMITED",
"SHARP THRILL INVESTIGATION & FLINT FORCE PRIVATE LIMITED",
"SHARP TRAVELS INDIA LIMITED",
"SHARP VENTURES PRIVATE LIMITED",
"SHARPCROP PRIVATE LIMITED",
"SHARPEDGE TOOLS TECHNOLOGY PRIVATE LIMITED",
"SHARPEN PUBLIC SCHOOL",
"SHARPER IMAGE FLOORS PRIVATE LIMITED",
"SHARPLEX FILTERS INDIA PRIVATE LIMITED",
"SHARPLINE AUTOMATION PRIVATE LIMITED",
"SHARPLINE BROADCAST LIMITED",
"SHARPLINE MEDIA & SERVICE PRIVATE LIMITED",
"SHARPLINE MERCANTILE COMPANY PRIVATE LIMITED",
"SHARPLINE NETWORK PRIVATE LIMITED",
"SHARPMIND CONSULTANCY SERVICES PRIVATE LIMITED",
"SHARPMIND PRINT N DESIGN PRIVATE LIMITED",
"SHARPSELL TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"SHARPTECH AV DESIGNS PRIVATE LIMITED",
"SHARPWATCH INVESTIGATION SECURITY SERVICES PRIVATE LIMITED",
"SHARPWIRE INDUSTRIES INDIA PRIVATE LIMITED",
"SHARRP VENTURES CAPITAL PRIVATE LIMITED",
"SHARSH FINANCE AND INVESTMENT COMPANY PRIVATE LIMITED",
"SHARSID OVERSEAS PRIVATE LIMITED",
"SHARTH ENGINEERS PRIVATE LIMITED",
"SHARTHI COTTGIN CORPORATION",
"SHARTHI PROFILES & ENGINEERING PRIVATE LIMITED",
"SHARTHI TECKMA",
"SHARU HI TECH ALLOYS PRIVATE LIMITED",
"SHARU INDUSTRIES PRIVATE LIMITED",
"SHARU SPECIAL ALLOYS PRIVATE LIMITED",
"SHARU STEELS P LIMITED.",
"SHARUN PHARMACEUTICALS PRIVATE LIMITED",
"SHARUS STEEL PRODUCTS PRIVATE LIMITED",
"SHARV POLYPLAST PRIVATE LIMITED",
"SHARVANI ALCO BREW PRIVATE LIMITED",
"SHARVARI ELECTRICALS PRIVATE LIMITED",
"SHARVARI PRODUCTS PRIVATE LIMITED",
"SHARVARI STEEL LIMITED",
"SHARVAYA INFOTECH",
"SHARVAYA METALS LIMITED",
"SHARVI AGRO MILLS PRIVATE LIMITED",
"SHARVI PACKAGING SOLUTIONS PRIVATE LIMITED",
"SHARVI TECHNOLOGIES (OPC) PRIVATE LIMITED",
"SHARVIK IMPEX (INDIA) PRIVATE LIMITED",
"SHARVILL GT ENGINEERSPRIVATE LIMITED",
"SHARWAL ENTERPRISE",
"SHARWAN AND SUNNY CONSTRUCTION PRIVATE LIMITED",
"SHARWAN MILK & PRODUCTS (OPC) PRIVATE LIMITED",
"SHASA FINANCE & INVESTMENT PRIVATE LIMITED",
"SHASA MEDITECH PRIVATE LIMITED",
"SHASAKIYA TANTRIK VIDYALAYA",
"SHASAN ENGINEERING PRIVATE LIMITED",
"SHASH INDUSTRIE PRIVATE LIMITED",
"SHASHA SOLAR POWER PRIVATE LIMITED",
"SHASHADHAR COLD STORAGE PRIVATE LIMITED",
"SHASHANK AUTO PRIVATE. LIMITED.",
"SHASHANK BULLION PRIVATE LIMITED",
"SHASHANK FERTILIZERS PRIVATE LIMITED",
"SHASHANK FIELD TECH SERVICES PRIVATE LIMITED",
"SHASHANK PETROLEUM & FUELS PRIVATE LIMITED",
"SHASHANK STEEL INDUSTRIES PRIVATE LIMITED",
"SHASHI ALLOYS PRIVATE LIMITED",
"SHASHI BERIWAL AND COMPANY PRIVATE LIMITED",
"SHASHI BHARATH INDUSTRIES",
"SHASHI CABLES LIMITED",
"SHASHI CATERING SERVICES",
"SHASHI CATERING SERVICES PRIVATE LIMITED",
"SHASHI DETECTIVE SERVICES PRIVATE LIMITED",
"SHASHI DHAWAL HYDRAULICS PRIVATE LIMITED",
"SHASHI DISTILLERIES PRIVATE LIMITED",
"SHASHI INFRACONSTRUCTIONS PRIVATE LIMITED",
"SHASHI METALS PRIVATE LIMITED",
"SHASHI NATURAL & ORGANICS PRIVATE LIMITED",
"SHASHI PRABHA INFRASTRUCTURE PRIVATE LIMITED",
"SHASHI PRABHU AND ASSOCIATES",
"SHASHI RANJAN ENTERPRISES PRIVATE LIMITED",
"SHASHI SERVICES PRIVATE LIMITED",
"SHASHI SIDNAL FOODS PRIVATE LIMITED",
"SHASHI SUMEET PRODUCTIONS PRIVATE LIMITED",
"SHASHI TIMBER & PLYWOOD INDUSTRIES PVT LTD",
"SHA-SHIB ACADEMY PRIVATE LIMITED",
"SHASHIJIT INFRAPROJECTS LIMITED",
"SHASHIKALA HATCHERIES PRIVATE LIMITED",
"SHASHILA HEALTHY MASTER PRIVATE LIMITED",
"SHASHIRADHA COLD STORAGE PRIVATE LIMITED",
"SHASHKIYA MADHYAMIK AASHRAM SHALA KHOKRALE",
"SHASHTI CAR PRIVATE LIMITED",
"SHASHVAT INFRAVENTURE PRIVATE LIMITED",
"SHASHVAT POLYMERS PRIVATE LIMITED",
"SHASHWAT ECO WASTE TRADING PRIVATE LIMITED",
"SHASHWAT FURNISHING SOLUTIONS LIMITED",
"SHASHWAT HEALTH CARE (AUNDH) PRIVATE LIMITED",
"SHASHWAT HEALTH SERVICES PRIVATE LIMITED",
"SHASHWAT HOSPITALS PRIVATE LIMITED",
"SHASHWAT INFRAESTATE PRIVATE LIMITED",
"SHASHWAT IVF CENTRE PRIVATE LIMITED",
"SHASHWAT MARKETING PRIVATE LIMITED",
"SHASHWAT ORNAMENTS PRIVATE LIMITED",
"SHASHWAT POWER INDIA LLP",
"SHASHWAT REALTY DEVELOPERS PRIVATE LIMITED",
"SHASHWAT ROLLING MILL PRIVATE LIMITED",
"SHASHWAT SOAPS PRIVATE LIMITED",
"SHASHWATHA NIDHI LIMITED",
"SHASHWATI PLASTICS",
"SHASHWATI REALTY PRIVATE LIMITED",
"SHASHWATMASS MEDIA SERVICES PRIVATE LIMITED",
"SHASKIY UCHH PRATHMIK ASHRAMSCHOOL ICCHAGAVAN",
"SHASKIYA EKIKRAT HIGH SCHOOL",
"SHASS INFORMATION AND QUALITY ENGINEERING SERVICES",
"SHASTA BIO FUELS PRIVATE LIMITED",
"SHASTA CNC INDIA PRIVATE LIMITED",
"SHASTA FREIGHT SERVICES PRIVATE LIMITED",
"SHASTA TEK SOLUTIONS PRIVATE LIMITED",
"SHASTER TECHNOLOGIES PRIVATE LIMITED",
"SHASTHA ENGINEERING COLLEGE",
"SHASTHA INFOTECH PRIVATE LIMITED",
"SHASTHAA STEELS PRIVATE LIMITED",
"SHASTRA EDUCATIONAL INSTITUTIONS",
"SHASTRA MEDI SERVICES PRIVATE LIMITED",
"SHASTRI BHAVAN CENTRAL GOVERNMENT.",
"SHASVAT FOREX PRIVATE LIMITED",
"SHASWAT CABLES PRIVATE. LIMITED.",
"SHASWAT DEVELOPERS PRIVATE LIMITED",
"SHASWAT STEEL WORKS PRIVATE LIMITED",
"SHASWAT STOCK BROKERS PRIVATE LIMITED",
"SHASWAT TEXTILES PRIVATE LIMITED",
"SHATABDI CEMENTS PRIVATE LIMITED",
"SHATABDI CHEMICALS PRIVATE LIMITED",
"SHATABDI DIAGNOSTICS PRIVATE LIMITED",
"SHATABDI EXPORTS PRIVATE LIMITED",
"SHATABDI HOSPITALS & RESEARCH CENTRE PRIVATE LIMITED",
"SHATABDI SEEDS PRIVATE LIMITED",
"SHATABDI SYNTHETICS PRIVATE LIMITED",
"SHATAKSHI AUTO INDIA PRIVATE LIMITED",
"SHATAL ENGINEERING INDIA PRIVATE LIMITED",
"SHATAPATHRAM EXIM (OPC) PRIVATE LIMITED",
"SHATAVAHAN BIO SCIENCESS PRIVATE LIMITED",
"SHATAYUSHI ORGANIC FARMERS PRODUCER COMPANY LIMITED",
"SHATAYUSHI ORGANIC PRIVATE LIMITED",
"SHATHAYU AYURVEDA PRIVATE LIMITED",
"SHATRANJ TRADING PRIVATE LIMITED",
"SHATRUNJAYA MANPOWER SOLUTIONS PRIVATE LIMITED",
"SHAURANSH PRODUCTS PRIVATE LIMITED",
"SHAURAYA INFRATECH PRIVATE LIMITED",
"SHAURI SOLAR INDIA PRIVATE LIMITED",
"SHAURYA AERONAUTICS PRIVATE LIMITED",
"SHAURYA AGRI TECH",
"SHAURYA ALLOYS PRIVATE LIMITED",
"SHAURYA AUTOLINK PRIVATE LIMITED",
"SHAURYA BUSINESS SOLUTION PRIVATE LIMITED",
"SHAURYA CONSTRUCTIONS PRIVATE LIMITED",
"SHAURYA EXIM INTERNATIONAL PRIVATE LIMITED",
"SHAURYA GREENTECH PRIVATE LIMITED",
"SHAURYA INDUSTRIES PRIVATE LIMITED",
"SHAURYA MEET INFOCOM PRIVATE LIMITED",
"SHAURYA ORGANICS PRIVATE LIMITED",
"SHAURYA RAJ FREIGHT CARRIER PRIVATE LIMITED",
"SHAURYA SOFTWARE PRIVATE LIMITED",
"SHAURYA TECHNOSOFT PRIVATE LIMITED",
"SHAURYA TRADEMART(INDIA) PRIVATE LIMITED",
"SHAURYA TRENDS PRIVATE LIMITED",
"SHAURYAM LIFETECH PRIVATE LIMITED",
"SHAURYAM SOLUTIONS PRIVATE LIMITED",
"SHAURYANSHI ENTERPRISES PRIVATE LIMITED",
"SHAVANTHGIRI CHITS BANGALORE PRIVATE LIMITED",
"SHAVISON ELECTRONICS PRIVATE LIMITED",
"SHAVLAJI ENGINEERING PRIVATE LIMITED",
"SHAVO NORGREN INDIA PRIVATE LIMITED",
"SHAVO TECHNOLOGIES PRIVATE LIMITED",
"SHAVRON AUTOMATIONS PRIVATE LIMITED",
"SHAW & SONS ENGINEERS & DEVELOPERS PRIVATE LIMITED",
"SHAW ACADEMY EDUCATION PRIVATE LIMITED",
"SHAW ALMEX INDIA PRIVATE LIMITED",
"SHAW BUILDERS PRIVATE LIMITED",
"SHAW FLOORS INDIA PRIVATE LIMITED",
"SHAW HOTELS AND CONSULTANCY SERVICES PRIVATE LIMITED",
"SHAW MACHINES INDIA PRIVATE LIMITED",
"SHAW PRITAM LOGISTICS PRIVATE LIMITED",
"SHAWA TECHNOCRAFTS PRIVATE LIMITED",
"SHAWARIA MANUFACTURING PRIVATE LIMITED",
"SHAWELLS GLOBAL ROOFING PRIVATE LIMITED",
"SHAWINIGAN ENGINEERING INDIA PRIVATE LIMITED",
"SHAWJEE POLYTECH PRIVATE LIMITED",
"SHAWMAN SOFTWARE PRIVATE LIMITED",
"SHAWNOTEL INDIA PRIVATE LIMITED",
"SHAY RETAIL PRIVATE LIMITED",
"SHAYA ADHESIVES PRIVATE LIMITED",
"SHAYA POLYMERS PRIVATE LIMITED",
"SHAYA POLYURETHANES PRIVATE LIMITED",
"SHAYBURG VALVES PRIVATE LIMITED",
"SHAYONA ENGINEERING PRIVATE LIMITED",
"SHAYONA ENTERPRISE PRIVATE LIMITED",
"SHAYONA GLASS DECOR PRIVATE LIMITED",
"SHAYONA INDUSTRIES PRIVATE LIMITED",
"SHAYONA TIMES PRIVATE LIMITED",
"SHAYONA VIDHYAVIHAR SECONDARY SCHOOL",
"SHAYZER INTERNATIONAL PRIVATE LIMITED",
"SHAZ PACKAGING LLP",
"SHB AGROPOWER INDIA PRIVATE LIMITED",
"SHE COSMETIC STORE PRIVATE LIMITED",
"SHEARES INDIA HEALTHCARE MANAGEMENT PRIVATE LIMITED",
"SHEARLINE PROCESS PRIVATE LIMITED",
"SHEARVAN PURCHASING INDIA PRIVATE LIMITED",
"SHEARWATER VENTURES PRIVATE LIMITED",
"SHEBA LOGISTICS PRIVATE LIMITED",
"SHEBOSS PRIVATE LIMITED",
"SHED SOLUTIONS PRIVATE LIMITED",
"SHEE CHITRA THIRUNAL INSTITUTE",
"SHEE SEN LEATHER PVT LTD",
"SHEEBA FABRICATION PRIVATE LIMITED",
"SHEEBA INDIA PRIVATE LIMITED",
"SHEEBA TEL PRIVATE LIMITED",
"SHEEL ALLOYS PRIVATE LIMITED",
"SHEEL BIOTECH LIMITED",
"SHEEL CHAND AGROILS PRIVATE LIMITED",
"SHEEL CHAND FLOUR MILLS PRIVATE LIMITED",
"SHEEL COTFAB PRIVATE LIMITED",
"SHEEL DIAMOND EXPORTS PRIVATE LIMITED",
"SHEEL DIAMONDS EXPORTS LIMITED",
"SHEEL GEMS",
"SHEEL HARDWARE PRIVATE LIMITED",
"SHEEL IMPEX",
"SHEEL KISHAN MOTORS PRIVATE LIMITED",
"SHEEL NURSING HOME PRIVATE LIMITED",
"SHEEL OIL & FATS PRIVATE LIMITED",
"SHEEL PROCON PRIVATE LIMITED",
"SHEELA AGRO PRIVATE. LIMITED.",
"SHEELA AVENUES PRIVATE LIMITED",
"SHEELA CONSTRUCTIONS LIMITED",
"SHEELA EQUIPMENTS PRIVATE LIMITED",
"SHEELA FOAM LIMITED",
"SHEELA STAINLESS PRIVATE LIMITED",
"SHEELPE ENTERPRISES PRIVATE LIMITED",
"SHEELTRANS CONTAINER LINE PRIVATE LIMITED",
"SHEELTRON DIGITAL SYSTEMS PRIVATE LIMITED",
"SHEELU HAIR INTERNATIONAL PRIVATE LIMITED",
"SHEELVANT & SONS JEWELS PRIVATE LIMITED",
"SHEEN AUTOMOBILES PRIVATE LIMITED",
"SHEEN ELECTROPLATERS PRIVATE LIMITED",
"SHEEN GOLDEN JEWELS (INDIA) PRIVATE LIMITED",
"SHEEN PETROCHEMICALS PVT LTD",
"SHEENA BIOTECH PRIVATE LIMITED",
"SHEENA CONSTRUCTIONS PVT.LTD.",
"SHEENA GREEN CHEMS PRIVATE LIMITED",
"SHEENLAC NOROO COATINGS INDIA PRIVATE LIMITED",
"SHEENLAC PAINTS LIMITED",
"SHEER COCO INDIA PRIVATE LIMITED",
"SHEER EVENT MANAGEMENT PRIVATE LIMITED",
"SHEERAJ PROJECTS PRIVATE LIMITED",
"SHEERAZ TOURS PRIVATE LIMITED",
"SHEERDRIVE PRIVATE LIMITED",
"SHEESH MAHAL DEVELOPERS LIMITED",
"SHEESH MAHAL PROPERTIES PRIVATE LIMITED",
"SHEESH SECURITY SERVICES PRIVATE LIMITED",
"SHEET METAL INDUSTRIES P LIMITED",
"SHEET SHAPERS INDIA PRIVATE LIMITED",
"SHEET SHAPERS TECHNOLOGIES PRIVATE LIMITED",
"SHEETAL AGRIFRESH PRODUCTS PRIVATE LIMITED",
"SHEETAL AIRCON SALES AND SERVICES PRIVATE LIMITED",
"SHEETAL ARCH RESTAURANTS PRIVATE LIMITED",
"SHEETAL ASHISH HOTEL PRIVATE LIMITED",
"SHEETAL AUTOMOBILES PRIVATE LIMITED",
"SHEETAL AYURVED BHANDAR PRIVATE LIMITED",
"SHEETAL COOL PRODUCTS LIMITED",
"SHEETAL DIAMONDS LIMITED",
"SHEETAL DIES AND TOOLS PRIVATE LIMITED",
"SHEETAL ELECTROTECH PRIVATE LIMITED",
"SHEETAL FERROALLOYS AND CEREMICS (INDIA) PRIVATE LIMITED",
"SHEETAL FOREIGN EXCHANGE SERVICES PRIVATE LIMITED",
"SHEETAL HEALING ENTERPRISES LIMITED",
"SHEETAL INDUSTRIES",
"SHEETAL INFRASTRUCTURE PRIVATE LIMITED",
"SHEETAL ISPAT PRIVATE LIMITED",
"SHEETAL JEWELLARY CREATIONS PRIVATE. LIMITED.",
"SHEETAL JEWELLERYHOUSE LLP",
"SHEETAL MANUFACTURING COMPANY PRIVATE LIMITED",
"SHEETAL MEDICARE PRODUCTS PRIVATE LIMITED",
"SHEETAL MERCANTILE PRIVATE LIMITED",
"SHEETAL MINSERVE PRIVATE LIMITED",
"SHEETAL ORGANIC FOODS PRIVATE LIMITED",
"SHEETAL PHARMACEUTICALS PRIVATE LIMITED",
"SHEETAL PUBLIC SENIOR SECONDARY SCHOOL",
"SHEETAL RUBBER PRODUCTS PRIVATE LIMITED",
"SHEETAL SAGAR BUILDERS & DEVELOPERS PRIVATE LIMITED",
"SHEETAL SAURABH HINDI HIGHER SECONDARY SCHOOL",
"SHEETAL STEELS PRIVATE LIMITED",
"SHEETAL STRIPS PRIVATE LIMITED",
"SHEETAL STRUCTURALS PRIVATE LIMITED",
"SHEETAL SULZ FAB PRIVATE LIMITED",
"SHEETAL TEXFAB PRIVATE LIMITED",
"SHEETAL UNIVERSAL LIMITED",
"SHEETAL WIRELESS TECHNOLOGIES PRIVATE LIMITED",
"SHEETALA INFRASTRUCTURE CONSULTANCY PRIVATE LIMITED.",
"SHEETALNATH BUILDERS PRIVATE LIMITED",
"SHEETHAL ENGINEERS PRIVATE LIMITED",
"SHEETKRAFT INDIA PRIVATE LIMITED",
"SHEETLA HOSPITAL AND EYE INSTITUTE PRIVATE LIMITED",
"SHEETLA OVERSEAS LTD",
"SHEEVAM COMFORT HOTELS PRIVATE LIMITED",
"SHEEVAM TRANSOLUTIONS PRIVATE LIMITED",
"SHEFA AGRICARE TECHNOLOGIES PRIVATE LIMITED",
"SHEFA ENGINEERS PRIVATE LIMITED",
"SHEFA HEALTH CARE PRIVATE LIMITED",
"SHEFALI AUTOMOTIVES LLP",
"SHEFALI CREDITS PRIVATE LIMITED",
"SHEFALI FARMS PRIVATE LIMITED",
"SHEFALI GOODS PVT LTD",
"SHEFALI SILK MILLS PRIVATE LIMITED",
"SHEFALI TEXTILE MILLS PRIVATE LIMITED",
"SHEFFIELD AND VERMARK CONSULTANTS PRIVATE LIMITED",
"SHEFFIELD DEVELOPERS PRIVATE LIMITED",
"SHEFFIELD ENERGY INDIA PRIVATE LIMITED",
"SHEFIELD TECHNOPLAST PRIVATE LIMITED",
"SHEGAON INFRASTRUCTURE PRIVATE LIMITED",
"SHEHJAR INDUSTRIES PRIVATE LIMITED",
"SHEHNAI CLUB AND RESORTS PRIVATE LIMITED",
"SHEHNAZ TRADERS AND EXPORTERS PRIVATE LIMITED",
"SHEIK FATHIMA MATRICULATION HR SEC SCHOOL",
"SHEIKH FARID AUTOMOBILES LIMITED",
"SHEIKH FARID FINVEST LIMITED",
"SHEIKH MOTORCYCLES PRIVATE LIMITED",
"SHEILA RAHEJA INSTITUTE OF HOTEL MANAGEMENT",
"SHEKAR ENGINEERING WORKS PRIVATE LIMITED",
"SHEKAR LOGISTICS PRIVATE LIMITED",
"SHEKASA ENGINEERING CO PRIVATE LIMITED",
"SHEKHADA COT-GIN PRIVATE LIMITED",
"SHEKHAR HARDWARE TRADERS PRIVATE LIMITED",
"SHEKHAR HOSPITAL PRIVATE LIMITED",
"SHEKHAR OPTOELECTRONICS AND POLYMER PRIVATE LIMITED",
"SHEKHAVATI INVESTMENT CORPORATION LIMITED",
"SHEKHAVATI INVESTMENTS AND TRADERS LTD.",
"SHEKHAWATI BUILDCON PRIVATE LIMITED",
"SHEKHAWATI DUARS ROADWAYS (INDIA) PRIVATE LIMITED",
"SHEKHAWATI ELECTRONICS PRIVATE LIMITED",
"SHEKHAWATI ENTREPRENEUR PRIVATE LIMITED",
"SHEKHAWATI GEOTECH PRIVATE LIMITED",
"SHEKHAWATI HERITAGE HERBAL PRIVATE LIMITED",
"SHEKHAWATI MARKETING PRIVATE LIMITED",
"SHEKHAWATI POLY-YARN LIMITED",
"SHEKHAWATI SHIPPING & LOGISTICS PRIVATE LIMITED",
"SHEKHAWATI SYNTEX PVT LTD",
"SHEKHER PHARMACEUTICALS PRIVATE LIMITED",
"SHEL BUILDING DREAMS PRIVATE LIMITED",
"SHEL TUBING PRIVATE LIMITED",
"SHELADIA ASSOCIATES INC",
"SHELADIA CONSTRUCTION",
"SHELAR PROPERTIES PRIVATE LIMITED",
"SHELAR SALES AND SERVICE PRIVATE LIMITED",
"SHELAVI PULP AND PAPER MILLS PVT LTD",
"SHELCON PROPERTIES PVT LTD",
"SHELDON MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"SHELF DRILLING CENTRAL EUROPE LTD",
"SHELF DRILLING F G MCCLINTOCK LIMITED",
"SHELF DRILLING INTERNATIONAL INC",
"SHELF DRILLING J T ANGEL LIMITED",
"SHELF DRILLING OFFSHORE RESOURCES LIMITED II",
"SHELF DRILLING OFFSHORE SERVICES (INDIA) PRIVATE LIMITED",
"SHELF DRILLING RON TAPPMEYER LIMITED",
"SHELF DRILLING TRIDENT XII LIMITED",
"SHELF ENTERPRISES PRIVATE LIMITED",
"SHELKE BEVARAGES PRIVATE LIMITED",
"SHELKE ROADLINES PRIVATE LIMITED",
"SHELL APPARELS PRIVATE LIMITED",
"SHELL CORRUGATING INDUSTRIES PRIVATE LIMITED",
"SHELL ENERGY INDIA PRIVATE LIMITED",
"SHELL ENERGY MARKETING AND TRADING INDIA PRIVATE LIMITED",
"SHELL GRAPHICS PVT. LTD.",
"SHELL INDIA MARKETS PRIVATE LIMITED",
"SHELL INDIA MP LIMITED",
"SHELL INFO TECHNOLOGIES PRIVATE LIMITED",
"SHELL INN (INTERNATIONAL) PRIVATE LIMITED",
"SHELL LAMINATES PRIVATE LIMITED",
"SHELL LIFESCIENCES PRIVATE LIMITED",
"SHELL MRPL AVIATION FUELS AND SERVICES PRIVATE LIMITED",
"SHELL N TUBE PRIVATE LIMITED",
"SHELL NETWORKS & SOLUTIONS LIMITED",
"SHELL ORGANICS PRIVATE LIMITED",
"SHELL PACK INDUSTRIES PRIVATE LIMITED",
"SHELL PAHAL SOCIAL WELFARE ASSOCIATION",
"SHELL PRINTPACK PRIVATE LIMITED",
"SHELLAC AND FOREST PRODUCTS EXPORT PROMOTION COUNCIL",
"SHELLCO PETRO TRADING PRIVATE LIMITED",
"SHELLEX SERVICES PRIVATE LIMITED",
"SHELLINFOSG GOLBAL DIGITAL TECHNOLOGIES PRIVATE LIMITED",
"SHELLMECH PRECISION CAST PRIVATE LIMITED",
"SHELLO TRADECOM PRIVATE LIMITED",
"SHELLTEC ENGG. ANCILARIES INDIA PRIVATE LIMITED",
"SHELLYS MEDIA TRACK PRIVATE LIMITED",
"SHELLZ INDIA PRIVATE LIMITED",
"SHELLZ OVERSEAS PRIVATE LIMITED",
"SHELLZ TECHNO PACK PRIVATE LIMITED",
"SHELTER FINANCE LIMITED",
"SHELTER INFRA PROJECTS LIMITED",
"SHELTER PHARMA LIMITED",
"SHELTER PHARMACY PRIVATE LIMITED",
"SHELTER SALES PRIVATE LIMITED",
"SHELTERA CONSTRUCTION INTL LIMITED",
"SHELTERA CONSULTANTS PRIVATE LIMITED",
"SHELTER'S PLYWOOD PRIVATE LIMITED",
"SHELTER'S SAFFIN INDIA LIMITED",
"SHELTERTECH INDIA PRIVATE LIMITED",
"SHELTON HOSPITALITY PRIVATE LIMITED",
"SHELTREX KARJAT PRIVATE LIMITED",
"SHELTRONICS CONTROL SYSTEMS PRIVATE LIMITED",
"SHELVIN SNACKS PRIVATE LIMITED",
"SHEMA E-VEHICLE & SOLAR PRIVATE LIMITED",
"SHEMAROO ENTERTAINMENT LIMITED",
"SHEMBEKAR HOSPITALS PRIVATE LIMITED",
"SHEMESH ENERGY PRIVATE LIMITED",
"SHEMROCK GLOBAL PRIVATE LIMITED",
"SHENAYAH RETAIL STORES PRIVATE LIMITED",
"SHENBA CAB",
"SHENBAGAM MATRICULATION HR SEC SCHOOL",
"SHENBAKA CARS PRIVATE LIMITED",
"SHENBAKARAJAN AND SONS CARS PRIVATE LIMITED",
"SHENCO VALVES PRIVATE LIMITED",
"SHENDRA GREEN ENERGY LIMITED",
"SHENG LI TELECOM INDIA PRIVATE LIMITED",
"SHENLL TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"SHENME SALON & SPA PRIVATE LIMITED",
"SHENOY ENGINEERING PRIVATE LIMITED",
"SHENOY NAGAR SASWATHA NIDHI LTD",
"SHENWA INFRASTRUCTURE PRIVATE LIMITED",
"SHENZHEN ZHOUJI HOMTOM TECHNOLOGY INDIA PRIVATE LIMITED",
"SHEO DEALCOM PRIVATE LIMITED",
"SHEO INDUSTRIES PRIVATE LIMITED",
"SHEOM RUBBER INDUSTRIES PRIVATE LIMITED",
"SHEOPALS PRIVATE LIMITED",
"SHEORAN BUILDCON PRIVATE LIMITED",
"SHEORAN INTERNATIONAL SCHOOL",
"SHEP HERTZ TECHNOLOGIES PRIVATE LIMITED",
"SHEPARDS SHIPPING SERVICES ( INDIA ) PRIVATE LIMITED",
"SHEPHERD CRUSHERS & MINING PRIVATE LIMITED",
"SHEPHERTZ TECHNOLOGIES PRIVATE LIMITED",
"SHER BENGAL HOTELS PRIVATE LIMITED",
"SHERA BUILDING SOLUTIONS INDIA PRIVATE LIMITED",
"SHERA ENERGY LIMITED",
"SHERA HOSIERY PRIVATE LIMITED",
"SHERA METAL PRIVATE LIMITED",
"SHERA TUBE FORGE PVT LTD",
"SHERAM HEALTH CARE PRODUCTS PRIVATE LIMITED",
"SHERAN WALI STEELS PRIVATE LIMITED",
"SHERANWALI INFRASTRUCTURE PRIVATE LIMITED",
"SHERATON GRAND BANGALORE HOTEL",
"SHERATON GRAND CHENNAI RESORT AND SPA",
"SHERATON GRAND PALACE INDORE",
"SHERATON GRAND PUNE",
"SHERATON REALTORS LLP",
"SHERATON RESORTS LIMITED",
"SHERATON TRADERS PRIVATE LIMITED",
"SHERATON TRAVELS PRIVATE LIMITED",
"SHERATRON CONDUCTORS PRIVATE LIMITED",
"SHERAWALI COAL CARRIERS PRIVATE LIMITED",
"SHERE BENGAL FOOD PRIVATE LIMITED",
"SHERE PUNJAB INN PRIVATE LIMITED",
"SHEREPUNJAB BANQUETS PRIVATE LIMITED",
"SHER-E-PUNJAB HOTELS PRIVATE LIMITED",
"SHERGILL TRAVELS PRIVATE LIMITED",
"SHERIE PLEXUS ISP PRIVATE LIMITED",
"SHERIF EXPRESS TRAVELS AND CARGO PRIVATE LIMITED",
"SHERIF HOLIDAYS PRIVATE LIMITED",
"SHERIF TRAVEL AND CARGO SERVICE PRIVATE LIMITED",
"SHERIFF FASHIONS PRIVATE LIMITED",
"SHERIL EXPORT PRIVATE LIMITED",
"SHERIM SQUIBSS PHARMA PRIVATE LIMITED",
"SHERIN ADVISORS AND TRADERS PRIVATE LIMITED",
"SHERIN HIFAB CONTRACTS INDIA PRIVATE LIMITED",
"SHERISHA POWERTECH PRIVATE LIMITED",
"SHERISHA SOLAR SPV TWO PRIVATE LIMITED",
"SHERISHA TECHNOLOGIES PRIVATE LIMITED",
"SHERLAK INDIA PRIVATE LIMITED",
"SHERLEKAR AIRCARE PRIVATE LIMITED",
"SHERLOCK INSTITUTE OF FORENSIC SCIENCE INDIA PRIVATE LIMITED",
"SHERLOCKS HOSPITALITY PRIVATE LIMITED",
"SHERLOCKS PUBS PRIVATE LIMITED",
"SHERLY JEWELS PRIVATE LIMITED",
"SHERMAN ENERGY LIMITED",
"SHERMAN INTERNATIONAL PVT LTD",
"SHERMAN SALES AND SERVICES PRIVATE LIMITED",
"SHERNI LOCKS MANUFACTURERS PRIVATE LIMITED",
"SHERRAINE GLOBAL PRIVATE LIMITED",
"SHERRINGWOOD WORLD SCHOOL",
"SHERRY APPARELS PRIVATE LIMITED",
"SHERRY CLOTHING AND DESIGNS PRIVATE LIMITED",
"SHERRY NETWORK PRIVATE LIMITED",
"SHERUL INSULATIONS PRIVATE LIMITED",
"SHERVAN ELECTRONICS & CABLES PRIVATE LIMITED",
"SHERVANI HOSPITALITIES LIMITED",
"SHERVANI INDUSTRIAL SYNDICATE LIMITED",
"SHERVANI SUGAR SYNDICATE LTD",
"SHERVANI TECH HUB PRIVATE LIMITED",
"SHERWA MINERALS PRIVATE LIMITED",
"SHERWINWILLIAMS COATINGS INDIA PRIVATE LIMITED",
"SHERWOOD COLLEGE OF MANAGEMENT",
"SHERWOOD LONGSTAY PRIVATE LIMITED",
"SHERWOOD RESORTS PRIVATE LIMITED",
"SHERYA PORTFOLIO PRIVATE LIMITED",
"SHERYL STRATEGIC SOLUTIONS PRIVATE LIMITED",
"SHESHA SAI ENTERPRISES PRIVATE LIMITED",
"SHESHAA ENTERPRISE",
"SHESHADRI INDUSTRIES LIMITED",
"SHESHMADHAV BIOTECH PRIVATE LIMITED",
"SHET BHUMI FARMER PRODUCER COMPANY LIMITED",
"SHET DASS ENGINEERS PRIVATE LIMITED",
"SHETALA AGENCIES PRIVATE LIMITED",
"SHETE'S INSTITUTE OF ACADEMICS PRIVATE LIMITED",
"SHETH & SURA ENGINEERS PRIVATE. LIMITED",
"SHETH A H SARASVATI VIDHYALAYA",
"SHETH BHIKHABHAI HIGH SCHOOL",
"SHETH BUILDERS PVT LTD",
"SHETH BUILDWELL PRIVATE LIMITED",
"SHETH C L HINDI HIGH SCHOOL",
"SHETH C N COLLEGE OF FINE ARTS",
"SHETH C. N. VIDYALAYA",
"SHETH CORP PRIVATE LIMITED",
"SHETH CORROSION & COATINGS PRIVATE LIMITED",
"SHETH CREATORS & SUN-VISION PRIVATE LIMITED",
"SHETH CREATORS AND HOMEMAKERS PRIVATE LIMITED",
"SHETH CREATORS AND PROMOTERS PRIVATE LIMITED",
"SHETH CREATORS PRIVATE LIMITED",
"SHETH DEVELOPERS & REALTORS INDIA LIMITED.",
"SHETH DEVELOPERS PRIVATE LIMITED",
"SHETH FABRICATORS PVT LTD",
"SHETH FINCAP SERVICES PRIVATE LIMITED",
"SHETH G S HIGH SCHOOL",
"SHETH GOPALJI HEMRAJ HIGH SCHOOL & JUNIOR COLLEGE",
"SHETH GOVINDRAM SHOBHARAM HIGHSCHOOL VASAI DABHLA",
"SHETH IMPEX VIVO SOLUTIONS PRIVATE LIMITED",
"SHETH IMPRESSION LLP",
"SHETH INFOCON PRIVATE LIMITED",
"SHETH INFRAWORLD PRIVATE LIMITED",
"SHETH INSULATIONS PRIVATE LIMITED",
"SHETH JOTIPRASAD VIDYALAYA & JUNIOR COLLEGE",
"SHETH KANTILAL C PARIKH GENERAL HOSPITAL",
"SHETH M K ORAN GROUP HIGH SCHOOL",
"SHETH M S BHANAWALA HIGH SCHOOL VALAD",
"SHETH MALLS PRIVATE LIMITED",
"SHETH MOTILAL NILCHAND HIGH SCHOOL & LATE SMT NATHIBEN CHANDULAL LALLUBHAI SANDESASRA HIGHER SECONDARY SCHOOL PATAN",
"SHETH N K T T JUNIOR COLLEGE",
"SHETH N N SARVAJANIK HOSPITAL & C G MATERNITY HOME RANDHEJA",
"SHETH P.T SURAT GENERAL HOSPITAL",
"SHETH PET POLYMERS PRIVATE LIMITED",
"SHETH PRINTOGRAPH PRIVATE LIMITED",
"SHETH PUBLISHERS PVT LTD",
"SHETH SHIP BREAKING CORPORATION",
"SHETH SHREE M.P HIGHER SECONDERY SCHOOL, SIDDHPUR",
"SHETH SHRI B. R. SOMANI VIDYA VIHAR",
"SHETH SHRI MANILAL DHARAM CHAND ABHINAV BHARTI VIDYALAYA KHIMANA",
"SHETH SHRI MANILAL DHARAMCHAND ABHINAV BHARTI VIDHAYALAY KHIMANA",
"SHETH SR M A KADWALVALA HIGHSCHOOL KADWAL",
"SHETH TJ EDUCATION SOCIETY'S SHETH N K T T COLLEGE OF COMMERCE AND SETH J TT COLLEGE OF ARTS",
"SHETH V K SHAH VIDYA MANDIR SHAHADA",
"SHETH VADILAL SARABHAI GENERAL HOSPITAL",
"SHETHIA ERECTOR'S AND MATERIAL HANDLERS LTD",
"SHETIYA SOAPS PRIVATE LIMITED",
"SHETKARI SAHAKARI SANGH LTD",
"SHETKARI SHIKSHAN SANSTHA HIGH SCHOOL",
"SHETKARI SHIKSHAN SANSTHA VIDYALAY AND JR. COLLEGE",
"SHETRON LIMITED",
"SHETRUNJAY DYEING & WEAVING MILLS LIMITED",
"SHETTY ASSOCIATES",
"SHETTY INFRASERVICES PRIVATE LIMITED",
"SHETTY PLAST PRIVATE LIMITED",
"SHETTY PROJECTS AND SERVICES PRIVATE LIMITED",
"SHETTY SYNTHETIC PVT LTD",
"SHETYE SALES SYNDICATE PRIVATE LIMITED",
"SHEVAR METALO PRIVATE LIMITED",
"SHEVIE EMBROIDERIES LLP",
"SHEVIE EXPORTS LLP",
"SHEWRATAN COMPANY PRIVATE LIMITED",
"SHEZA ELECTRO WORLD PRIVATE LIMITED",
"SHEZAR WEB TECHNOLOGIES PRIVATE LIMITED",
"SHF DESIGN ENGINEERING PRIVATE LIMITED",
"SHHA RESTAURANTS PRIVATE LIMITED",
"SHHIVTEK INDUSTRIES PRIVATE LIMITED",
"SHHY INDIA PRIVATE LIMITED",
"SHI INSTRUMENTS PRIVATE LIMITED",
"SHI MEDIWEAR PRIVATE LIMITED",
"SHI PLASTICS MACHINERY INDIA PRIVATE LIMITED",
"SHIA INTERMEDIATE COLLEGE",
"SHIA P G COLLEGE",
"SHIAMAK DAVAR INTERNATIONAL INDIA PRIVATE LIMITED",
"SHIASH INFO SOLUTIONS PRIVATE LIMITED",
"SHIB DASS AND SONS PRIVATE LIMITED",
"SHIBA COMP PRIVATE LIMITED",
"SHIBA CONTAINERS PRIVATE LIMITED",
"SHIBA KALI AGRO PRODUCTS PRIVATE LIMITED",
"SHIBALLOY MULTIFLEX PVT LTD",
"SHIBAM VENTURES AND BUILDING MATERIALS PRIVATE LIMITED",
"SHIBANI FOOD PRODUCTS PRIVATE LIMITED",
"SHIBAURA MACHINE INDIA PRIVATE LIMITED",
"SHIBDASPUR F P SCHOOL",
"SHIBDOOT TREXIM PRIVATE LIMITED",
"SHIBHANSH FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"SHIBIR INDIA LTD",
"SHIBPUR ENGR COLLEGE",
"SHIBPUR JASODA MOYEE VIDYALAYA",
"SHIBSATI COLD STORAGE PRIVATE LIMITED",
"SHIDDHARTH JEWELLERY INDIA",
"SHIDHESHWAR VIDYALAY BASMATH",
"SHIDHI VINAYAK POLYPACK PRIVATE LIMITED",
"SHIEL AUTOS PRIVATE LIMITED",
"SHIELD AUTOGLASS LIMITED",
"SHIELD ENGINEERING PRIVATE LIMITED",
"SHIELD FINANCE PRIVATE LIMITED",
"SHIELD HEALTH CARE PRIVATE LIMITED",
"SHIELD INDIA PEST SOLUTIONS (OPC) PRIVATE LIMITED",
"SHIELD LUBRICANTS & SPECIALITIES PRIVATE LIMITED",
"SHIELD NUTRIENTS PRIVATE LIMITED",
"SHIELDARC EQUIPMENT PVT LTD",
"SHIELDBYTE INFOSEC PRIVATE LIMITED",
"SHIELDPULSE HEALTH AND HYGIENE PRIVATE LIMITED",
"SHIELDWATCH INFOTECH PRIVATE LIMITED",
"SHIFA INFOTECH PRIVATE LIMITED",
"SHIFA REMEDIES PRIVATE LIMITED",
"SHIFALI PUBLIC SENIOR SECONDARY SCHOOL",
"SHIFT FREIGHT SOLUTIONS AND TECHNOLOGY PRIVATE LIMITED",
"SHIFT MOBILITY PRIVATE LIMITED",
"SHIFT RISK INSURANCE BROKERS LIMITED",
"SHIFTASK INTERNATIONAL PRIVATE LIMITED",
"SHIFTAUTO POWER CONTROL PRIVATE LIMITED",
"SHIFTCO SHIPPING & LOGISTICS INDIA PRIVATE LIMITED",
"SHIGA ENERGY PRIVATE LIMITED",
"SHIGAN EVOLTZ LIMITED",
"SHIGAN FUEL SYSTEMS SOLUTIONS PRIVATE LIMITED",
"SHIGAN QUANTUM TECHNOLOGIES LIMITED",
"SHIGAN TELEMATICS PRIVATE LIMITED",
"SHIGLO TECH PRIVATE LIMITED",
"SHIIBUII GREEN ACRES PRIVATE LIMITED",
"SHIJA COMMUNICATIONS PRIVATE LIMITED",
"SHIJA HOSPITALS AND RESEARCH INSTITUTE PRIVATE LIMITED",
"SHIJAY PROJECTS INDIA PRIVATE LIMITED",
"SHIJI (INDIA) LLP",
"SHIKAG'S ENGINEERING LABS PRIVATE LIMITED",
"SHIKAR MANPOWER SERVICES PRIVATE LIMITED",
"SHIKARPUR & BHANDAPUR TEA ESTATES PRIVATE LIMITED",
"SHIKHA DISTRIBUTORS PRIVATE LIMITED",
"SHIKHA ELECTRICAL INDUSTRIES PRIVATE LIMITED",
"SHIKHA HOLDINGS PVT LTD",
"SHIKHA PACKAGING (INDIA) PRIVATE LIMITED",
"SHIKHA TEXTILES PRIVATE LIMITED",
"SHIKHAR AMUSEMENTS PRIVATE LIMITED",
"SHIKHAR AUTOMATION SOLUTIONS PRIVATE LIMITED",
"SHIKHAR CHAND PRADEEP KUMAR LUMBERS PRIVATE LIMITED",
"SHIKHAR COACHING CLASSES PRIVATE LIMITED",
"SHIKHAR COMMODITIES PRIVATE LIMITED",
"SHIKHAR ENGINEERING PRIVATE LIMITED",
"SHIKHAR FOODS PRIVATE LIMITED",
"SHIKHAR HOUSING DEVELOPMENT PRIVATE LIMITED",
"SHIKHAR LOGISTICS PRIVATE LIMITED",
"SHIKHAR MICROFINANCE PRIVATE LIMITED",
"SHIKHAR PRINTS PRIVATE LIMITED",
"SHIKHAR REAL ESTATES PRIVATE LIMITED",
"SHIKHAR REALTERS & DEVELOPERS PRIVATE LIMITED",
"SHIKHAR REALTY SERVICES PRIVATE LIMITED",
"SHIKHARA STEELS PRIVATE LIMITED",
"SHIKHER IMPEX PRIVATE LIMITED",
"SHIKIN HOTELS PRIVATE LIMITED",
"SHIKOVI HEATGEN TECHNOLOGIES PRIVATE LIMITED",
"SHIKSHA",
"SHIKSHA FINANCIAL SERVICES PRIVATE LIMITED",
"SHIKSHA INFOTECH PRIVATE LIMITED",
"SHIKSHA NIKETAN SCHOOL",
"SHIKSHA VALLEY SCHOOL",
"SHIKSHA VIKASH SAMITI ODISHA",
"SHIKSHAA EDUTECH LIMITED",
"SHIKSHAN BOOKS & STATIONERY PRIVATE LIMITED",
"SHIKSHAN KIT PRIVATE LIMITED",
"SHIKSHAN MAHARSHI DADASAHEB LIMAYE ARTS COMMERCE & SCIENCE COLLEGE",
"SHIKSHAN MAHARSHI DADASAHEB RAUL PRATHAMIK SHALA DONDAICHA",
"SHIKSHAN MAHARSHI DNYANDEO MOHEKAR AGRO INDUSTRIES LIMITED",
"SHIKSHAN MAHARSHI DR Y PATIL SHIKSHAN SANSTHA",
"SHIKSHAN PRASARAK MANDAL VIDYALAY BORGAON",
"SHIKSHANDA LIFESTYLES PRIVATE LIMITED",
"SHIKSHANMAHARSHI GURUVARAYA R G SHINDE MAHAVIDYALAY PARANDA",
"SHIKSHANMAHARSHI GURUVARAYA R G SHINDE MAHAVIDYALAYA PARANDA",
"SHIKSHANTAR EDUCATIONAL ACADEMY PRIVATE LIMITED",
"SHIKSHANTAR KNOWLEDGE FOUNDATION",
"SHIKSHANTAR SCHOOL",
"SHIL KANYA SHALA MANGROL",
"SHIL TECHNOLOGIES PRIVATE LIMITED",
"SHILA SILICATE PVT LTD",
"SHILAAYANTRA UDYOG PRIVATE LIMITED",
"SHILABS PRIVATE LIMITED",
"SHILAKA FABRICATION PRIVATE LIMITED",
"SHILANYAS INFRACON ASSOCIATES AND BUILDERS PRIVATE LIMITED",
"SHILASINGH AGROTECH PRIVATE LIMITED",
"SHILCHAR TECHNOLOGIES LIMITED",
"SHILEX CHEMICALS PRIVATE LIMITED",
"SHILLA SMART SERVICES PRIVATE LIMITED",
"SHILLOI ENERGY SERVICES PRIVATE LIMITED",
"SHILLONG EXPRESSWAY PRIVATE LIMITED",
"SHILLONG TIMES PRIVATE LIMITED",
"SHILOH INDUSTRIES PRIVATE LIMITED",
"SHILP CERAMICS PVT LTD",
"SHILP DYE-CHEM PRIVATE LIMITED",
"SHILP GRAVURES LIMITED",
"SHILP INDYA DESIGNS AND DEVELOPERS PRIVATE LIMITED",
"SHILP INFRA-TECHNOLOGIES PRIVATE LIMITED",
"SHILP REALTY PRIVATE LIMITED",
"SHILP REFRACTORIES PRIVATE LIMITED",
"SHILP TINY STORES PRIVATE LIMITED",
"SHILPA AGARBATTI COMPANY PRIVATE LIMITED",
"SHILPA ALLOYS PRIVATE LIMITED",
"SHILPA ARCHITECTS PLANNERS DESIGNERS PRIVATE LIMITED",
"SHILPA ASSOCIATES PRIVATE LIMITED",
"SHILPA CATERERS PRIVATE LIMITED",
"SHILPA CHEMSPEC INTERNATIONAL PRIVATE LIMITED",
"SHILPA CONSTRUCTION PRIVATE LIMITED",
"SHILPA COOLER AND FURNITURE PRIVATE LIMITED",
"SHILPA DIAMONDS PRIVATE LIMITED",
"SHILPA DYEING AND PRINTING MILLS PRIVATE LIMITED",
"SHILPA ELECTRICAL INFRA TECH INDIA PRIVATE LIMITED",
"SHILPA HOSPITALITY SERVICES",
"SHILPA MACHINERY TECHNOLOGIES PRIVATE LIMITED",
"SHILPA MEDICARE LIMITED",
"SHILPA OVERSEAS PVT LTD",
"SHILPA PHARMA LIFESCIENCES LIMITED",
"SHILPA POLYPACK PRIVATE LIMITED",
"SHILPA ROAD SAFETY PRIVATE LIMITED",
"SHILPA SAND PRIVATE LIMITED",
"SHILPA STEEL & POWER LIMITED",
"SHILPA STOCK BROKERS PRIVATE LIMITED",
"SHILPA SUSHIL TELEFILMS PRIVATE LIMITED",
"SHILPA THERAPEUTICS PRIVATE LIMITED",
"SHILPA TRADE LINK PRIVATE LIMITED",
"SHILPAKRUTI MARKETINGS PRIVATE LIMITED",
"SHILPAN BUILDERS PRIVATE LIMITED",
"SHILPAN DEVELOPERS PRIVATE LIMITED",
"SHILPAN STEELCAST PRIVATE LIMITED",
"SHILPHY STEELS PVT LTD",
"SHILPI COMPUTERS LIMITED",
"SHILPI CONSTRUCTION AND ENGINEERING PRIVATE LIMITED",
"SHILPI ENGINEERING PRIVATE LIMITED",
"SHILPI FLOCKING CO. PRIVATE LIMITED",
"SHILPI MOBILE AND ELECTRONICS PRIVATE LIMITED",
"SHILPI REALITIES PRIVATE LIMITED",
"SHILPI WIRE ROPE PRIVATE LIMITED",
"SHILPIN CONSULTING PRIVATE LIMITED",
"SHILPIN MACHINE TOOLS PRIVATE LIMITED",
"SHILPIRAJ CLOTHINGS PRIVATE LIMITED",
"SHILPKAAR ARCHITECTS PRIVATE LIMITED",
"SHILPKALA FASHIONS PRIVATE LIMITED",
"SHILPKAR CONSTRUCTION PRIVATE LIMITED",
"SHILPKAR INDIA PRIVATE LIMITED",
"SHILPMIS TECHNOLOGIES PRIVATE LIMITED",
"SHILPY FINLEASE PRIVATE LIMITED",
"SHILTEX PVT LTD",
"SHILTON HOSPITALITY LLP",
"SHIMADZU ANALYTICAL INDIA PRIVATE LIMITED",
"SHIMADZU MEDICAL (INDIA) PRIVATE LIMITED",
"SHIMADZU MEDICAL INDIA PRIVATE LIMITED",
"SHIMANO HEALTHCARE PRIVATE LIMITED",
"SHIMANO SOUTH ASIA PRIVATE LIMITED",
"SHIMATO ENTERPRISES PRIVATE LIMITED",
"SHIMERA PROJECT LIGHTING PRIVATE LIMITED",
"SHIMI DESIGNS AND CONSULTING ENGINEERS PRIVATE LIMITED",
"SHIMI RESEARCH CENTER PRIVATE LIMITED",
"SHIMIZU CORPORATION INDIA PRIVATE LIMITED",
"SHIMLA AGRO EQUIPMENTS PRIVATE LIMITED",
"SHIMLA BROADBAND PRIVATE LIMITED",
"SHIMLA HAVENS HOTELS & RESORTS PRIVATE LIMITED",
"SHIMLA RESTAURANT PRIVATE LIMITED",
"SHIMLA SATELLITE CABLE PRIVATE LIMITED",
"SHIMLA THREADS PRIVATE LIMITED",
"SHIMLA TOLLS AND PROJECTS PRIVATE. LIMITED.",
"SHIMLAFRUITS PRIVATE LIMITED",
"SHIMMBA FOREX & TRAVELS PRIVATE LIMITED",
"SHIMMER CHEMICALS PRIVATE LIMITED",
"SHIMMER GEMS PRIVATE LIMITED",
"SHIMMER INVESTMENTS PVT LTD",
"SHIMMER LAMPS AND SHADES PRIVATE LIMITED",
"SHIMMERS COSMETIC PRIVATE LIMITED",
"SHIMMERS JEWELS PRIVATE LIMITED",
"SHIMMY SERVICES & TECHNOLOGY PRIVATE LIMITED",
"SHIMNIT INDIA PRIVATE LIMITED",
"SHIMNIT INTEGRATED SOLUTIONS PRIVATE LIMITED",
"SHIMNIT KIWALITE INDUSTRIES PRIVATE LIMITED",
"SHIMOGA HEALTH CARE AND RESEARCH CENTRE PRIVATE LIMITED",
"SHIMOGA PRECISION CASTINGS PRIVATE LIMITED",
"SHIMOGA ROLLER FLOUR MILLS PRIVATE LIMITED",
"SHIMONA HOTELS PRIVATE LIMITED",
"SHIMPUKADE ENGINEERING PRIVATE LIMITED",
"SHIMPUKADE GLOBAL TECH PRIVATE LIMITED",
"SHIMPUKADE METALS PRIVATE LIMITED",
"SHIMPUKADE QUALITY COMPONENTS PRIVATE LIMITED",
"SHIMSHON ADVISORY PRIVATE LIMITED",
"SHIMUK ENTERPRISES PRIVATE LIMITED",
"SHIN THERMO DYNAMIC ENGINEERING PRIVATE LIMITED",
"SHIN TRADERS PRIVATE LIMITED",
"SHIN WOO ENGINEERING PRIVATE LIMITED",
"SHINAG ALLIED ENTERPREISES",
"SHINAGO EXIM PRIVATE. LIMITED.",
"SHINANO INDUSTRIES PRIVATE LIMITED",
"SHINCE PHARMACEUTICALS PRIVATE LIMITED",
"SHINDE DEVELOPERS PRIVATE LIMITED",
"SHINDE ENGINEERS PRIVATE LIMITED",
"SHINDE MANPOWER SERVICES PRIVATE LIMITED",
"SHINDENGEN INDIA PRIVATE LIMITED",
"SHINDE'S MEDICARE HOSPITAL PRIVATE LIMITED",
"SHINE & SIND SECURITY SOLUTIONS PRIVATE LIMITED",
"SHINE AGROTECHNOLOGY PRIVATE LIMITED",
"SHINE AND STANDARD SERVICES PRIVATE LIMITED",
"SHINE ART SERVICES PRIVATE LIMITED",
"SHINE AUTO PRIVATE LIMITED",
"SHINE CAPITAL AND SECURITIES PRIVATE LIMITED.",
"SHINE CARBON AND CHEMICALS PRIVATE LIMITED",
"SHINE CARE SOLUTIONS PRIVATE LIMITED",
"SHINE CHEMTECH PRIVATE LIMITED",
"SHINE CLEANING",
"SHINE COLLECTIONS PRIVATE LIMITED",
"SHINE COLOURS (INDIA)PRIVATE LIMITED",
"SHINE COMBINE PRIVATE LIMITED",
"SHINE CONCEPTS PRIVATE LIMITED",
"SHINE COT-SPIN PRIVATE LIMITED",
"SHINE DEZIGN INFONET PRIVATE LIMITED",
"SHINE EDUCATIONAL & MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"SHINE FASHIONS (INDIA) LIMITED",
"SHINE FLEXIBLE PRINT AND PACKS PRIVATE LIMITED",
"SHINE FOREX SERVICES PRIVATE LIMITED",
"SHINE GLOVE ENTERPRISES",
"SHINE GUARD (INDIA) PRIVATE LIMITED",
"SHINE HIGH SCHOOL",
"SHINE HOME STYLE TRADE PRIVATE LIMITED",
"SHINE INDIA DEGREE COLLEGE",
"SHINE INDIA TRENDSETTERS PRIVATE LIMITED",
"SHINE IT SOLUTION PRIVATE LIMITED",
"SHINE JEWEL PRIVATE LIMITED",
"SHINE LAUNDRY SERVICES PRIVATE LIMITED",
"SHINE MAINTENANCE SERVICES PRIVATE LIMITED",
"SHINE MECH TECHNOLOGY PRIVATE LIMITED",
"SHINE MEDI VILLAGE PRIVATE LIMITED",
"SHINE MEDICINE CENTRE",
"SHINE METAL UDYOG PRIVATE LIMITED",
"SHINE METALTECH PRIVATE LIMITED",
"SHINE N D T SERVICES",
"SHINE OUTDOOR ADVERTISING PRIVATE LIMITED",
"SHINE PACK PVT LTD",
"SHINE PHARMACEUTICALS LIMITED",
"SHINE RESEARCH & SERVICES PRIVATE LIMITED",
"SHINE STAR",
"SHINE STAR BUILD-CAP PRIVATE LIMITED",
"SHINE STAR SPECIALITY COATERS PRIVATE LIMITED",
"SHINE SURGICALS PRIVATE LIMITED",
"SHINE TECH SOLUTIONS PRIVATE LIMITED",
"SHINE TEXTILES PRIVATE LIMITED",
"SHINE TOUCH SERVICES PRIVATE LIMITED",
"SHINE TRAVELS AND CARGO PRIVATE LIMITED",
"SHINE WEB SOLUTIONS PRIVATE LIMITED",
"SHINE YOUR CARRIER SERVICES PRIVATE LIMITED",
"SHINECITY HOSPITALS PRIVATE LIMITED",
"SHINEMAX PHARMA (INDIA) PRIVATE LIMITED",
"SHINEMAX ROOFING (INDIA) PRIVATE LIMITED",
"SHINEMICA LAMINATE PRIVATE LIMITED",
"SHINEPLAST AUTO PRIVATE LIMITED",
"SHINEPRO LIFE SCIENCES PRIVATE LIMITED",
"SHINER SACKS PRIVATE LIMITED",
"SHINEROAD FOODS (INDIA) PRIVATE LIMITED",
"SHINERRA PARTICLEBOARDS PRIVATE LIMITED",
"SHINESHILPI JEWELLERS PRIVATE LIMITED",
"SHINESOLAR ENERGY SOLUTIONS PRIVATE LIMITED",
"SHIN-ETSU CHEMICAL TYLOSE INDIA PRIVATE LIMITED",
"SHIN-ETSU POLYMER INDIA PRIVATE LIMITED",
"SHIN-ETSU SILICONES INDIA PRIVATE LIMITED",
"SHINEWELL GLOBAL LOGISTICS PRIVATE LIMITED",
"SHINEY E-PARK PRIVATE LIMITED",
"SHINFIELD ENGINEERING PRIVATE LIMITED",
"SHINGAR LIMITED",
"SHINGARE INDUSTRIES PRIVATE LIMITED",
"SHINGHAL AGRI INDUSTRIES PRIVATE LIMITED",
"SHINGORA TEXTILES LIMITED",
"SHINGORA TEXTILES PRIVATE LIMITED",
"SHINHAN BANK",
"SHINI PLASTICS TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"SHINING CONSULTING PRIVATE LIMITED",
"SHINING ENGINEERS AND FOUNDERS PRIVATE LIMITED",
"SHINING SCHOLARS EDUCATION SOCIETY",
"SHINING STAR OUTSOURCE SERVICES PRIVATE LIMITED",
"SHINING STAR SOLUTIONS PRIVATE LIMITED",
"SHINING STARS EDUCATION & RESEARCH FOUNDATION",
"SHINING SUN POWER (TELANGANA) PRIVATE LIMITED",
"SHINING SUN POWER JAIPUR PRIVATE LIMITED",
"SHINING SUN POWER PRIVATE LIMITED",
"SHINING TOOLS LIMITED",
"SHINING WEALTH INVESTMENTS PRIVATE LIMITED",
"SHININGINDIA ASSOCIATES PRIVATE LIMITED",
"SHININGSTARS INSTITUTIONS AND TRAVELS PRIVATE LIMITED",
"SHINKA TECHNOLOGIES PRIVATE LIMITED",
"SHINKWANG ELECTRONICS PRIVATE LIMITED",
"SHINME ELECTRICAL VEHICLE PRIVATE LIMITED",
"JEWELLERY FOREST PRIVATE LIMITED",
"SHINO PAINTS AND CHEMICALS PRIVATE LIMITED",
"SHINON COLLABORATIVE CONSULTANCY PRIVATE LIMITED",
"SHINRAI AUTO SERVICES LIMITED",
"SHINRAI INSURANCE BROKING SERVICES PRIVATE LIMITED",
"SHINRAI SOFTRADE PRIVATE LIMITED",
"SHINRAI TEXTILE PRIVATE LIMITED",
"SHINRYO SUVIDHA ENGINEERS INDIA PRIVATE LIMITED",
"SHINSHIVA AYURVEDA HOSPITAL PRIVATE LIMITED",
"SHINSUNG LS INDIA PRIVATE LIMITED",
"SHINSUNG PETROCHEMICAL PRIVATE LIMITED",
"SHINTEC ENGINEERING INDIA PRIVATE LIMITED",
"SHINTO CREATIVE ELEMENTS PRIVATE LIMITED",
"SHINTO ORGANICS PRIVATE LIMITED",
"SHINWA MOULDS INDIA PRIVATE LIMITED",
"SHINY CLOTHING COMPANY PRIVATE LIMITED",
"SHINY KNITWEAR PRIVATE LIMITED",
"SHINY PHARMACEUTICALS PRIVATE LIMITED",
"SHINY PROCESSING MILLS PRIVATE LIMITED",
"SHINY REALTY PRIVATE LIMITED",
"SHINY SHIPPING & LOGISTICS PRIVATE. LIMITED.",
"SHIO BUILDCON PRIVATE LIMITED",
"SHIP AIR FORWARDERS PRIVATE LIMITED",
"SHIPAL LINE INDIA PRIVATE LIMITED",
"SHIPARA ENTERPRISES PRIVATE LIMITED",
"SHIPBOLT INDUSTRIES PRIVATE LIMITED",
"SHIPCO IT PRIVATE LIMITED",
"SHIPCON LOGISTICS AND SUPPLY CHAIN PRIVATE LIMITED",
"SHIPCONSOLE PRIVATE LIMITED",
"SHIPDELIGHT LOGISTICS TECHNOLOGIES PRIVATE LIMITED",
"SHIPLEY BUSINESS DEVELOPMENT SERVICES INDIA PRIVATE LIMITED",
"SHIPLIFT TECHNO SOLUTIONS PRIVATE LIMITED",
"SHIPLINKS TANKERS PRIVATE LIMITED",
"SHIP-LOCAL LOGISTICS PRIVATE LIMITED",
"SHIPLYST SYSTEMS PRIVATE LIMITED",
"SHIPMENT SOLUTIONS PRIVATE LIMITED",
"SHIPNET SOFTWARE INDIA PRIVATE LIMITED",
"SHIPNET SOFTWARE SOLUTIONS INDIA PRIVATE LIMITED",
"SHIPNEXT SOLUTIONS PRIVATE LIMITED",
"SHIPOARS SHIPPING PRIVATE LIMITED",
"SHIPPING CORPORATION OF INDIA LAND AND ASSETS LIMITED",
"SHIPPING TIMES INDIA PRIVATE LIMITED",
"SHIPPR TECHNOLOGIES PRIVATE LIMITED",
"SHI-PRA BUILDERS PRIVATE LIMITED",
"SHIPRA COMMERCIAL PRIVATE LIMITED",
"SHIPRA CONSTRUCTIONS PRIVATE LIMITED",
"SHIPRA ESTATE LIMITED",
"SHIPRA INFRATECH PRIVATE LIMITED",
"SHIPRA TRAVELS PRIVATE LIMITED",
"SHIPRA VEGETABLES & GRAINS PRIVATE LIMITED",
"SHIPRAA DISTRIBUTOR",
"SHIPROCKET OMUNI LIMITED",
"SHIPSECURE LOGISTICS PRIVATE LIMITED",
"SHIPSHAPE FACILITIES PRIVATE LIMITED",
"SHIPSKART MARINE PRIVATE LIMITED",
"SHIPTECH",
"SHIPTECK MARINE SOLUTIONS PRIVATE LIMITED",
"SHIPWAVES ONLINE LIMITED",
"SHIPWAVES ONLINE PRIVATE LIMITED",
"SHIPWAY TECHNOLOGY PRIVATE LIMITED",
"SHIR ANAND PARSHWA GURUKUL SCHOOL",
"SHIR JAWAHAR INTER COLLEGE BAMNAULI",
"SHIRAA GLOBAL PROJECTS PRIVATE LIMITED",
"SHIRAGUPPI SUGAR WORKS LIMITED",
"SHIRAISHI CALCIUM INDIA PRIVATE LIMITED",
"SHIRAJ MARKETING PRIVATE LIMITED",
"SHIRALA CARBONDIOXIDE PRIVATE LIMITED",
"SHIRALEE ELECTRICALS PRIVATE LIMITED",
"SHIRAN ENGINEERING SERVICE PRIVATE LIMITED",
"SHIRAS CONSULTING PRIVATE LIMITED",
"SHIRAZ C LALKAKA ENTERPRISES PRIVATE LIMITED",
"SHIRDI CHEMICALS PRIVATE LIMITED",
"SHIRDI CLOTHING COMPANY PRIVATE LIMITED",
"SHIRDI COMMOTRADE PRIVATE LIMITED",
"SHIRDI COUNTRY-INNS PRIVATE LIMITED",
"SHIRDI ORGANICS PRIVATE LIMITED",
"SHIRDI PLYWOOD PRIVATE LIMITED",
"SHIRDI SAI ELECTRICALS LIMITED",
"SHIRDI SAI HOSPITAL PRIVATE LIMITED",
"SHIRDI SAI MINES & MINERALS PRIVATE LIMITED",
"SHIRDI SAI NUTRACEUTICALS PRIVATE LIMITED",
"SHIRDI SAI SHIPPING PRIVATE LIMITED",
"SHIRDI SAI STEELS PRIVATE LIMITED",
"SHIRDI SAI TRANSFORMERS PRIVATE LIMITED",
"SHIRDI SALES PRIVATE LIMITED",
"SHIRDI SHELTERS WHITEFIELD PRIVATE LIMITED",
"SHIRDI STEEL RE-ROLLERS PRIVATE LIMITED",
"SHIRDISAI TECHNOLOGIES AND CONSTRUCTION PRIVATE LIMITED",
"SHIRIMAHESWARA AGROTECH PRIVATE LIMITED",
"SHIRIN AUTOMOBILES PRIVATE LIMITED",
"SHIRISH CARGO SERVICES PRIVATE LIMITED",
"SHIRISH ENGINEERINGS PRIVATE LIMITED",
"SHIRISH HOTELS PRIVATE LIMITED",
"SHIRISH PATEL AND ASSOCIATES CONSULTANTS PRIVATE LIMITED",
"SHIRJA REAL ESTATE SOLUTIONS PRIVATE LIMITED",
"SHIRKE CONSTRUCTIONS PRIVATE LIMITED",
"SHIRKE CONSULTANTS PRIVATE LIMITED",
"SHIRKE DECORATORS PRIVATE LIMITED",
"SHIRKE ELECTRO PRIVATE LIMITED",
"SHIRKE ENGINEERING AND FABRICATION COMPANY PRIVATE LIMITED",
"SHIRKE ENGINEERING SERVICES PVT LTD",
"SHIRKES KITCHEN INTERIORS PRIVATE LIMITED",
"SHIRLEY TECHNOLOGIES PRIVATE LIMITED",
"SHIRO WALL PRODUCTS PRIVATE LIMITED",
"SHIRODE AUTOMOBILES PRIVATE LIMITED",
"SHIRODE CARS PRIVATE LIMITED",
"SHIRODKAR INFRASTRUCTURE PRIVATE LIMITED",
"SHIRODKAR PRECI COMP PRIVATE LIMITED",
"TOYOTA BOSHOKU DEVICE INDIA PRIVATE LIMITED",
"SHIROMANI COLD STORAGE PRIVATE LIMITED",
"SHIROMANI FLAT OWNERS ASSOCIATION",
"SHIROMANI INDUSTRIES PRIVATE LIMITED",
"SHIROO POLYMERS PRIVATE LIMITED",
"SHIRPUR-WARVADE MUNICIPAL COUNCIL",
"SHIRSA LABS PRIVATE LIMITED",
"SHIRVANTHE TECHNOLOGIES PRIVATE LIMITED",
"SHISH INDUSTRIES LIMITED",
"SHISH JEWELS PRIVATE LIMITED",
"SHISHAM DIGITAL MEDIA PRIVATE LIMITED",
"SHISHANMAHARSHI DR.BAPUJI SALUNKHE MAHAVIDYALAYA AND COLLEGE",
"SHISHTA DIGITAL SOLUTIONS PRIVATE LIMITED",
"SHISHU EXPORTS PRIVATE LIMITED",
"SHISHU NIKETAN PUBLIC SCHOOL",
"SHISHU SADAN CHILDREN HOSPITAL PRIVATE LIMITED",
"SHISHU SAHITYA SAMSAD PVT LTD",
"SHISHUKA HEALTHCARE PRIVATE LIMITED",
"SHISHUKUNJ THE PRE SCHOOL",
"SHISHUVIHAR PRI SCHOOL ERANDAWANE PUNE",
"SHISHYA BEML PUBLIC SCHOOL",
"SHITAL BUILDTECH PRIVATE LIMITED",
"SHITAL CHHAYA HOSPITAL PRIVATE LIMITED",
"SHITAL ENGINEERS PVT LTD",
"SHITAL FIBRES LIMITED",
"SHITAL INDIA PRESERVATION PRIVATE LIMITED",
"SHITAL INDUSTRIES PRIVATE LIMITED",
"SHITAL ISPAT PRIVATE LIMITED",
"SHITAL METALLOYS (INDIA) PRIVATE LIMITED",
"SHITAL METALS PRIVATE LIMITED",
"SHITAL MOTORS PRIVATE LIMITED0",
"SHITAL PRASAD CONSTRUCTION PRIVATE LIMITED",
"SHITAL SIGNS PRIVATE LIMITED",
"SHITAL TEXT PRIVATE LIMITED",
"SHITAL TRADING AND INTERIORS PRIVATE LIMITED",
"SHITAL TRANSPORT COMPANY PRIVATE LIMITED",
"SHITAL VACCUM TREAT PVT LTD",
"SHITALNATH IRON PRIVATE LIMITED",
"SHITALPUR MOHINDER KALIMATA HIMGHAR PRIVATE LIMITED",
"SHITARAM INDUSTRIES",
"SHITHALA DEALERS LIMITED",
"SHITIJ INVESTMENTS PRIVATE LIMITED",
"SHITLA KATIYAR COLD STORAGE PRIVATE LIMITED",
"SHITLA PAPERS PRIVATE LIMITED",
"SHITLA SAHAI INSTITUTE OF MEDICAL SCIENCES & HOSPITAL",
"SHITOLE ENGINEERING PRIVATE LIMITED",
"SHIUMA PROCESS EQUIPMENTS PRIVATE LIMITED",
"SHIUR SAKHAR KARKHANA LIMITED",
"SHIV AASHIRWAD REFRIGERATION (INDIA) PRIVATE LIMITED",
"SHIV ADARSH INTER COLLEGE",
"SHIV AGREVO LTD",
"SHIV AGRO PRODUCTS PRIVATE LIMITED",
"SHIV ASHISH BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"SHIV AUM STEELS LIMITED",
"SHIV AUTOMOBILE PRIVATE LIMITED",
"SHIV AUTORIDERS PRIVATE LIMITED",
"SHIV AUTOWHEELS PRIVATE LIMITED",
"SHIV BALAJI COLD STORAGE PRIVATE LIMITED",
"SHIV BHANDAR CONSTRUCTION CO.",
"SHIV BHOLA FILAMENTS PRIVATE LIMITED",
"SHIV BIRI MANUFACTURING CO PRIVATE LIMITED",
"SHIV CERAMIC",
"SHIV COLD STORAGE (BADAUN) PRIVATE LIMITED",
"SHIV COTEX INDIA PRIVATE LIMITED",
"SHIV COTTON INDUSTRIES- TANKARA",
"SHIV CRAFTEX LLP",
"SHIV DASS AND SONS PRIVATE LIMITED",
"SHIV DAYAL GUPTA AGENCIES PRIVATE LIMITED",
"SHIV DHARANI MARKETING PRIVATE LIMITED",
"SHIV DURGA CATERERS PVT LTD",
"SHIV DURGA COMMERCIAL PRIVATE LIMITED",
"SHIV DURGA CONSTRUCTIONS AND ENGINEERINGS PRIVATE LIMITED",
"SHIV EDIBLES LIMITED",
"SHIV ELECTRONICS & ELECTRICAL PRIVATE LIMITED",
"SHIV ENGINEERING AND PORT SERVICES PRIVATE LIMITED",
"SHIV ENTERPRISE",
"SHIV EQUIPMENTS PRIVATE LIMITED",
"SHIV FIBRES PRIVATE LIMITED",
"SHIV FIBRETEX INTERNATIONAL PRIVATE LIMITED",
"SHIV GANES SPINNING MILLS PRIVATE LIMITED",
"SHIV GANESH EXIM PRIVATE LIMITED",
"SHIV GANESH METALLOYS PRIVATE LIMITED",
"SHIV GANGA CATERERS PRIVATE LIMITED",
"SHIV GANGA HYBRID SEEDS PRIVATE LIMITED",
"SHIV GANGA SUPER MARKET 3D PRIVATE LIMITED",
"SHIV GEMS",
"SHIV HARI PLYWOOD PRIVATE LIMITED",
"SHIV IB MOTORS PRIVATE LIMITED",
"SHIV INDUSTRIES",
"SHIV INDUSTRIES (FOOD) PRIVATE LIMITED",
"SHIV INTERNATIONAL LIMITED",
"SHIV ISPAT UDYOG PVT LTD",
"SHIV JYOTI CREATORS PRIVATE LIMITED",
"SHIV JYOTI FURNACE PRIVATE LIMITED",
"SHIV JYOTI SCAFFOLDING PRIVATE LIMITED",
"SHIV KHORI SALES PRIVATE LIMITED",
"SHIV KIRPA GASES & METALS PRIVATE LIMITED",
"SHIV KISAN PRODUCER COMPANY LIMITED",
"SHIV KRAFTPAPER PRIVATE LIMITED",
"SHIV KRIPA BUILD ESTATE PRIVATE LIMITED",
"SHIV KRUPA INDUSTRIES",
"SHIV KRUPA STEEL & ALLOYS PRIVATE LIMITED",
"SHIV KUMAR SUSHIL KUMAR PRIVATE LIMITED",
"SHIV KUMAR SUSHIL KUMAR TEA ENTERPRISES PRIVATE LIMITED",
"SHIV LAL KANSHI RAM PRIVATE LIMITED",
"SHIV MACHINE TOOLS PRIVATE LIMITED",
"SHIV MAHESHWARI OIL AND CHEM PRIVATE LIMITED",
"SHIV MAHIMA INDUSTRIES PRIVATE LIMITED",
"SHIV MAHIMA MILK PRODUCTS PRIVATE LIMITED",
"SHIV MARINE INDUSTRIES PRIVATE LIMITED",
"SHIV MERCHANTS INDIA PRIVATE LIMITED",
"SHIV METTALICKS PRIVATE LIMITED",
"SHIV MICRO CREDIT SERVICES FOR RURAL DEVELOPMENT",
"SHIV MOHAN LOGISTICS PRIVATE LIMITED",
"SHIV NADAR SCHOOL",
"SHIV NADAR TRUST SHIV NADAR SCHOOLS",
"SHIV NADAR UNIVERSITY",
"SHIV NANDAN INTER COLLEGE",
"SHIV NARAYAN HOTEL PRIVATE LIMITED",
"SHIV NARESH SPORTS PRIVATE LIMITED",
"SHIV NARIAN PERIWAL & SONS PRIVATE LIMITED",
"SHIV NIDHI AQUA PRIVATE LIMITED",
"SHIV NIKETAN LIMITED",
"SHIV OFFSET INDIA PRIVATE LIMITED",
"SHIV OM BRASS INDUSTRIES",
"SHIV ONKAR PLASTO PRIVATE LIMITED",
"SHIV PARVATI LEASING PRIVATE LIMITED",
"SHIV PARVATI SERVICES",
"SHIV PHARMA PRIVATE LIMITED",
"SHIV POLYCOATERS PRIVATE LIMITED",
"SHIV POLYTECH PRIVATE LIMITED",
"SHIV PRASAD ECO TOUCHWOOD PRIVATE LIMITED",
"SHIV PRASAD RASHTRIYA INTER COLLEGE",
"SHIV PREM AROMAZ PRIVATE LIMITED",
"SHIV PROBUILD PRIVATE LIMITED",
"SHIV PRODUCTS PVT LTD",
"SHIV RAM JINDAL INDUSTRIES PRIVATE LIMITED",
"SHIV RATAN FOOD INDUSTRY PRIVATE LIMITED",
"SHIV RATNA PAPER PRIVATE LIMITED",
"SHIV REAL ISPAT PRIVATE LIMITED",
"SHIV REALMART PRIVATE LIMITED",
"SHIV RENT-A-CAR PRIVATE LIMITED",
"SHIV RICE MILL",
"SHIV ROLLER FLOUR MILL PVT LTD",
"SHIV RUDRAKSH ANUSANDHAN KENDRA PRIVATE LIMITED",
"SHIV SABARI DEVELOPERS",
"SHIV SAGAR COMMOTRADE PRIVATE LIMITED",
"SHIV SAGAR FOODS & RESORTS PRIVATE LIMITED",
"SHIV SAGAR REALMART PRIVATE LIMITED",
"SHIV SAGAR RESTAURANT PRIVATE LIMITED",
"SHIV SAGAR WOOD PRODUCTS PRIVATE LIMITED",
"SHIV SAHAI & SONS (INDIA) PRIVATE LIMITED",
"SHIV SAHAI BHAGWAN DAS SAREES PRIVATE LIMITED",
"SHIV SAI CONSTRUCTIONS PRIVATE LIMITED",
"SHIV SAINATH RUBBER INDUSTRIES PRIVATE LIMITED",
"SHIV SAMARTH MOTORS INDIA PRIVATE LIMITED",
"SHIV SAMARTH VIDYALAYA",
"SHIV SANCHI SAREES PRIVATE LIMITED",
"SHIV SANKALP BUILDERS PRIVATE LIMITED",
"SHIV SANKALP ESTATE DEVELOPERS PRIVATE LIMITED",
"SHIV SAREES PRIVATE LIMITED",
"SHIV SARTHAK ENTERPRISES PRIVATE LIMITED",
"SHIV SHAKTI AUTO CENTRE PRIVATE LIMITED",
"SHIV SHAKTI AUTOWHEELS PRIVATE LIMITED",
"SHIV SHAKTI AWAS PRIVATE LIMITED",
"SHIV SHAKTI BUILDHOME PRIVATE LIMITED",
"SHIV SHAKTI CASTINGS PRIVATE LIMITED",
"SHIV SHAKTI CHEMO TRAD",
"SHIV SHAKTI COLD STORAGE PRIVATE LIMITED",
"SHIV SHAKTI CORPORATE SERVICES PRIVATE LIMITED",
"SHIV SHAKTI DHAGA PRIVATE LIMITED",
"SHIV SHAKTI EMBROIDERIES PRIVATE LIMITED",
"SHIV SHAKTI ENTERPRISE",
"SHIV SHAKTI EXTRACTIONS PRIVATE LIMITED",
"SHIV SHAKTI FLOAT GLASSES PRIVATE LIMITED",
"SHIV SHAKTI FREIGHT MOVERS PVT LTD",
"SHIV SHAKTI GINNING AND PRESSING PRIVATE LIMITED",
"SHIV SHAKTI HUMAN RESOURCES DEPARTMENT",
"SHIV SHAKTI INDUSTRIES",
"SHIV SHAKTI INDUSTRIES PRIVATE LIMITED",
"SHIV SHAKTI INFRAVISION PRIVATE LIMITED",
"SHIV SHAKTI INTER GLOBE EXPORTS PRIVATE LIMITED",
"SHIV SHAKTI INTERNATIONAL",
"SHIV SHAKTI INTERNATIONAL PRIVATE LIMITED",
"SHIV SHAKTI LAMINATES PRIVATE LIMITED",
"SHIV SHAKTI LOGISTICS PRIVATE LIMITED",
"SHIV SHAKTI LOOMTEX PRIVATE LIMITED",
"SHIV SHAKTI METABRASS PRIVATE LIMITED",
"SHIV SHAKTI MODERN FLOUR MILLS PRIVATE LIMITED",
"SHIV SHAKTI MODERN RICE MILLS PRIVATE LIMITED",
"SHIV SHAKTI PACKMAT PRIVATE LIMITED",
"SHIV SHAKTI PHARMA CARE PRIVATE LIMITED",
"SHIV SHAKTI PRAKASHAN PRIVATE LIMITED",
"SHIV SHAKTI PROCESS EQUIPMENT PVT LTD",
"SHIV SHAKTI PROCESSED FOODS PRIVATE LIMITED",
"SHIV SHAKTI PRODUCTS LIMITED",
"SHIV SHAKTI RICE MILLS",
"SHIV SHAKTI ROAD EQUIPMENTS PRIVATE LIMITED",
"SHIV SHAKTI STEEL PRIVATE LIMITED",
"SHIV SHAKTI SUGAR MILLS (INDIA) PRIVATE LIMITED",
"SHIV SHAKTI SUPPLY CHAIN PRIVATE LIMITED",
"SHIV SHAKTI TEXOLENE PRIVATE LIMITED",
"SHIV SHAKTI TEXTILE INDUSTRIES PRIVATE LIMITED",
"SHIV SHAKTI THERMO PRIVATE LIMITED",
"SHIV SHAKTI TRADEMART PRIVATE LIMITED",
"SHIV SHAKTI TRANSPORT AND STHAPATYA PRIVATE LIMITED",
"SHIV SHAKTI WAHAN PRIVATE LIMITED",
"SHIV SHAL FOOD PRODUCTS PRIVATE LIMITED",
"SHIV SHAMBHU AGROTECH PRIVATE LIMITED",
"SHIV SHAMBHU COMMERCIAL PRIVATE LIMITED",
"SHIV SHAMBHU IRON & STEEL PRIVATE LIMITED SSISPL",
"SHIV SHANKAR EDIBLE PRIVATE LIMITED",
"SHIV SHANKAR FAB YARNS PRIVATE LIMITED",
"SHIV SHANKAR MINING PRIVATE LIMITED",
"SHIV SHANKAR SECURITIES PVT LTD",
"SHIV SHANKAR SINGH CONTRACT PRIVATE LIMITED",
"SHIV SHANKAR SPONGE IRON PRIVATE LIMITED",
"SHIV SHANKAR STEEL PVT LTD.",
"SHIV SHANKAR TEXTILE PROCESSORS PRIVATE LIMITED",
"SHIV SHANKAR TOBACCO PRIVATE LIMITED",
"SHIV SHANKER INDIA PVT LTD",
"SHIV SHANKER RICE MILLS",
"SHIV SHANTI ENGICON PRIVATE LIMITED",
"SHIV SHARAN TRADING PRIVATE LIMITED",
"SHIV SHARDA AUTO LINES PRIVATE LIMITED",
"SHIV SHIVAM DEVELOPERS PRIVATE LIMITED",
"SHIV SHUBHAM JEWELLERS PRIVATE LIMITED",
"SHIV SILICA PVT LTD",
"SHIV SNAX PRIVATE LIMITED",
"SHIV STEEL INDUSTRIES",
"SHIV SULPHURIC SOLUTIONS (OPC) PRIVATE LIMITED",
"SHIV SUNDER CONSTRUCTIONS AND CONSULTANTS PRIVATE LIMITED",
"SHIV SURGICAL NURSING HOME PRIVATE LIMITED",
"SHIV TALC PRIVATE LIMITED",
"SHIV TECHFABS PRIVATE LIMITED",
"SHIV TECHNET PRIVATE LIMITED",
"SHIV TECHNOLABS PRIVATE LIMITED",
"SHIV TEX CREATION PRIVATE LIMITED",
"SHIV TEXCHEM PRIVATE LIMITED",
"SHIV TOOLS ENGINEERING PRIVATE LIMITED",
"SHIV TOUR AND FOREX PRIVATE LIMITED",
"SHIV TRADEMART PRIVATE LIMITED",
"SHIV TRADERS INSTRUMENTS PRIVATE LIMITED",
"SHIV UTILITIES PRIVATE LIMITED",
"SHIV VALLEY HIGHWAYS PRIVATE LIMITED",
"SHIV VANASPATI PVT LTD",
"SHIV VEGPRO PRIVATE LIMITED",
"SHIV VIJAY ENGICON PRIVATE LIMITED",
"SHIV VIJAY ENGINEERS PRIVATE LIMITED",
"SHIV VILAS RESORTS PRIVATE LIMITED",
"SHIV VRAT MEGA MART PRIVATE LIMITED",
"SHIVA ADS INDIA PRIVATE LIMITED",
"SHIVA AGRIGENETICS PRIVATE LIMITED",
"SHIVA AGRO SEEDS PRIVATE LIMITED",
"SHIVA ANALYTICALS INDIA PRIVATE LIMITED",
"SHIVA AND SHIVA ORTHOPAEDIC HOSPITAL PRIVATE LIMITED",
"SHIVA ASPHALTIC PRODUCTS PRIVATE LIMITED",
"SHIVA AUTO CAR INDIA PRIVATE LIMITED",
"SHIVA AUTOMOBILES PRIVATE LIMITED",
"SHIVA AUTOMOVERS PRIVATE LIMITED",
"SHIVA AUTOWHEELS PRIVATE LIMITED",
"SHIVA BATTERY COMPONENTS PRIVATE LIMITED",
"SHIVA BIOGENETIC LABORATORIES PRIVATE LIMITED",
"SHIVA BIOGENETIC PHARMACEUTICALS PRIVATE LIMITED",
"SHIVA BUILDTECH PRIVATE LIMITED",
"SHIVA CARGO MOVERS PRIVATE LIMITED",
"SHIVA CASTINGS PRIVATE LIMITED",
"SHIVA CATERERS",
"SHIVA CEMENT LTD",
"SHIVA CHEMICAL & FLAVOURS PRIVATE LIMITED",
"SHIVA CHETANA ELECTRICALS",
"SHIVA CONSTECH PRIVATE LIMITED",
"SHIVA CONSULTANCY",
"SHIVA CONSULTANCY SERVICES PRIVATE LIMITED",
"SHIVA CONSULTANTS PRIVATE. LIMITED.",
"SHIVA CONTINENTAL PRIVATE LIMITED",
"SHIVA CORPORATION (INDIA) LIMITED",
"SHIVA DAIRY",
"SHIVA DISTILLERIES LIMITED",
"SHIVA DISTILLERIES PRIVATE LIMITED",
"SHIVA DYESTUFF PRIVATE LIMITED",
"SHIVA ENERGY RESOURCES PVT LTD",
"SHIVA ENGINEERING COMPANY PRIVATE LIMITED",
"SHIVA ENTERPRISES LLP",
"SHIVA ENTERPRISES RUBBER & TEFLON I PRIVATE LIMITED",
"SHIVA ERECTORS PROJECTS PRIVATE LIMITED",
"SHIVA EXIM PRIVATE LIMITED",
"SHIVA FABTEX PRIVATE LIMITED",
"SHIVA FERROUS PRIVATE LIMITED",
"SHIVA FIBRES PRIVATE LIMITED",
"SHIVA FOREX PRIVATE LIMITED",
"SHIVA FORMATION INDIA PRIVATE LIMITED",
"SHIVA FROZEN FOOD EXPORTS PRIVATE LIMITED",
"SHIVA GANGA POLYMERS PRIVATE LIMITED",
"SHIVA GENSETS PRIVATE LIMITED",
"SHIVA GLASS INDUSTRIES PRIVATE LIMITED",
"SHIVA GLOBAL AGRO INDUSTRIES LIMITED",
"SHIVA GLOBAL ENVIRONMENTAL PRIVATE LIMITED",
"SHIVA GOODS CARRIER PRIVATE LIMITED",
"SHIVA GRANITO EXPORT LIMITED",
"SHIVA GRAPHITE RESOURCES PRIVATE LIMITED",
"SHIVA HI-TECH SERVICES PRIVATE LIMITED",
"SHIVA HOSPITALITY SERVICES PRIVATE LIMITED",
"SHIVA HR SOLUTIONS PRIVATE LIMITED",
"SHIVA IMPO EXPO PRIVATE LIMITED",
"SHIVA INDUSTRIAL SECURITY AGENCYGUJARAT LIMITED",
"SHIVA INFOTECH SERVICES PRIVATE LIMITED",
"SHIVA INFRA SOLUTIONS PRIVATE LIMITED",
"SHIVA INFRATECH PRIVATE LIMITED",
"SHIVA INFRA-TECH PRIVATE LIMITED",
"SHIVA INTERNATIONAL RESINS PRIVATE LIMITED",
"SHIVA IRRIGATION NEEDS",
"SHIVA KATTHA PRIVATE LIMITED",
"SHIVA KITCHEN EQUIPMENTS PRIVATE LIMITED",
"SHIVA KRITI FASHION PRIVATE LIMITED",
"SHIVA LABORATORIES PRIVATE LIMITED",
"SHIVA MEDI SERVICES PRIVATE LIMITED",
"SHIVA MEDIA NETWORK & PRODUCTION SOLUTION LLP",
"SHIVA METALLOYS INTERNATIONAL PRIVATE LIMITED",
"SHIVA MILLS LIMITED",
"SHIVA MONOLITHICS PRIVATE LIMITED",
"SHIVA MULTIBIZ PRIVATE LIMITED",
"SHIVA OPTICALS PRIVATE LIMITED",
"SHIVA ORCHIDS PRIVATE LIMITED",
"SHIVA OUTFITS PRIVATE LIMITED",
"SHIVA PAINTS PRIVATE LIMITED",
"SHIVA PARVATI POULTRY FEEDS PRIVATE LIMITED",
"SHIVA PERFORMANCE MATERIALS PRIVATE LIMITED",
"SHIVA PERFORMANCE SOLUTIONS PRIVATE LIMITED",
"SHIVA PETRO CHEM PRIVATE LIMITED",
"SHIVA PETRO PRODUCTS PRIVATE LIMITED",
"SHIVA PETRO-SYNTH SPECIALITIES LTD",
"SHIVA PHARMACHEM LIMITED",
"SHIVA PIGMENTS PRIVATE LIMITED",
"SHIVA POLYMERS PRIVATE LIMITED",
"SHIVA POLYPLAST PRIVATE LIMITED",
"SHIVA POLYTUBES PRIVATE LIMITED",
"SHIVA PRINTECH PRIVATE LIMITED",
"SHIVA PROFILES PRIVATE LIMITED",
"SHIVA PROJECTS AND MARKETING PRIVATE LIMITED",
"SHIVA PROTECTION FORCE PRIVATE LIMITED",
"SHIVA PROTEIN PRODUCTS PRIVATE LIMITED",
"SHIVA PULP AND PAPER PRIVATE LIMITED",
"SHIVA RAMA KRISHNA RICE INDUSTRIES PRIVATE LIMITED",
"SHIVA REFRATECH (INDIA) PRIVATE LIMITED",
"SHIVA RICE ENTERPRISES PVT LTD",
"SHIVA SANCHAR (INDIA) PRIVATE LIMITED",
"SHIVA SATYA HOTELS PRIVATE LIMITED",
"SHIVA SCIENTIFIC GLASS PRIVATE LIMITED",
"SHIVA SCIENTIFIC LIFESCIENCES PRIVATE LIMITED",
"SHIVA SCOOTER AGENCIES PRIVATE LIMITED",
"SHIVA SHAKTI CAPITAL PRIVATE LIMITED",
"SHIVA SHAKTI DETERGENT PRIVATE LIMITED",
"SHIVA SHANKAR MINERALS PRIVATE LIMITED",
"SHIVA SHANKAR PALACE PRIVATE LIMITED",
"SHIVA SHIKSHA SADAN SR SEC SCHOOL",
"SHIVA SHREE BUILDERS",
"SHIVA SIDDHA TOOLS PRIVATE LIMITED",
"SHIVA SOLTRONICS PRIVATE LIMITED",
"SHIVA STAINLESS STEEL PRIVATE LIMITED",
"SHIVA STEEL INDUSTRIES (NAGPUR) PRIVATE LIMITED",
"SHIVA STEELAGE PRIVATE LIMITED",
"SHIVA STRUCTURES PRIVATE LIMITED",
"SHIVA SUITINGS LTD",
"SHIVA SUPPLY PRIVATE LIMITED",
"SHIVA TECHNIQUES SURFACES PRIVATE LIMITE",
"SHIVA TELECONNECTS PRIVATE LIMITED",
"SHIVA TEX COLLECTIONS PRIVATE LIMITED",
"SHIVA TEXFABS LIMITED",
"SHIVA TEXTILE AND SPINNING MILLS PVT LTD",
"SHIVA TEXYARN LIMITED",
"SHIVA TRADING COMPANY",
"SHIVA TYRES PRIVATE LIMITED",
"SHIVA UNIVERSAL MANUFACTURING AND SERVICES PRIVATE LIMITED",
"SHIVA UTENSILS INDUSTRIES PRIVATE LIMITED",
"SHIVA VEENER INDIA PRIVATE LIMITED",
"SHIVA WEAVERS PRIVATE LIMITED",
"SHIVA WHEELS PRIVATE LIMITED",
"SHIVAAMI CLOUD SERVICES PRIVATE LIMITED",
"SHIVAANYA DHATU PRIVATE LIMITED",
"SHIVAARNA TECHNOFOAMS PRIVATE LIMITED",
"SHIVAASHISH CONSTRUCTIONS PRIVATE LIMITED",
"SHIVAAY ASSOCIATES",
"SHIVAAY AUTOTRADE PRIVATE LIMITED",
"SHIVAAY ENTERPRISE",
"SHIVAAY MARKETING PRIVATE LIMITED",
"SHIVAAYAMBIKA INFRACON PRIVATE LIMITED",
"SHIVABHARATHI SYYNTEX INDIA PRIVATE LIMITED",
"SHIVACO SALES PRIVATE LIMITED",
"SHIVADITYA INDUSTRIES PRIVATE LIMITED",
"SHIVAGAN DEVELOPERS PRIVATE LIMITED",
"SHIVAGANPATHY LOGISTICS PRIVATE LIMITED",
"SHIVAGIRI BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"SHIVAGNA ENGINEERING SERVICES PRIVATE LIMITED",
"SHIVAGRICO IMPLEMENTS LIMITED",
"SHIVAHARDWELL INDUSTRIES (INDIA) PRIVATE LIMITED",
"SHIVAI BALAK MANDIR VIDHAYLAYA",
"SHIVAI ENTERPRISES PRIVATE LIMITED",
"SHIVAJI ARTS COMMERCE AND SCIENCE COLLEGE",
"SHIVAJI FOODS PRIVATE LIMITED",
"SHIVAJI HIGH SCHOOL",
"SHIVAJI NAGARI SAHAKARI BANK LTD",
"SHIVAJI PRATHAMIK ASHRAM SHALA",
"SHIVAJI RAMCHANDRA PAWAR (JEWELERS) PRIVATE LIMITED",
"SHIVAJI ROLLER FLOUR MILLS PRIVATE LIMITED",
"SHIVAJI SCIENCE COLLEGE",
"SHIVAJI UNIVERSITY KOLHAPUR",
"SHIVAJI VIDYALAYA",
"SHIVAJIRAO KADAM INSTITUTE OF TECHNOLOGY AND MANAGEMENT",
"SHIVAJYOTI CONPRO PRIVATE LIMITED",
"SHIVAKAR DEVELOPERS PRIVATE LIMITED",
"SHIVAKAR INFRA PRIVATE LIMITED",
"SHIVAKARI ENGINEERING PRIVATE LIMITED",
"SHIVAKARI FINANCE PRIVATE LIMITED",
"SHIVAKASHI DEVICES PRIVATE LIMITED",
"SHIVAKASHI HITECH AGRO PVT LTD",
"SHIVAKRITI AGRO PRIVATE LIMITED",
"SHIVAKRITI INTERNATIONAL LIMITED",
"SHIVAKUMARAN SPINNING MILLS PRIVATE. LIMITED.",
"SHIVALAY COLD STORAGE PRIVATE LIMITED",
"SHIVALAY INFRACON PRIVATE LIMITED",
"SHIVALAY ISPAT AND POWER PRIVATE LIMITED",
"SHIVALAY STAMPING PRIVATE LIMITED",
"SHIVALAY VYAPAAR PRIVATE LIMITED",
"SHIVALAYA AMGAON HIGHWAYS PRIVATE LIMITED",
"SHIVALAYA BHANDARA HIGHWAYS PRIVATE LIMITED",
"SHIVALAYA COLD STORE PRIVATE LIMITED",
"SHIVALAYA COLONISERS PRIVATE LIMITED",
"SHIVALAYA CONSTRUCTION CO PRIVATE LIMITED",
"SHIVALAYA GOREGAON HIGHWAYS PRIVATE LIMITED",
"SHIVALAYA HEALTHCARE",
"SHIVALAYA NAGPUR HIGHWAYS PRIVATE LIMITED",
"SHIVALE INFRAPRODUCTS PRIVATE LIMITED",
"SHIVALI BOUTIQUE PRIVATE LIMITED",
"SHIVALI CEMENT PRIVATE LIMITED",
"SHIVALI FASHION PRIVATE LIMITED",
"SHIVALI IMPEX PRIVATE LIMITED",
"SHIVALI UDYOG (I) PRIVATE LIMITED",
"SHIVALI UDYOG INDIA LIMITED",
"SHIVALIC POWER CONTROL LIMITED",
"SHIVALIC POWER CONTROL PRIVATE LIMITED",
"SHIVALIK AGRO CHEMICALS",
"SHIVALIK AGRO POLYPRODUCTS LIMITED",
"SHIVALIK AUTO ENGINEERING PRIVATE LIMITED",
"SHIVALIK BIMETAL CONTROLS LTD",
"SHIVALIK BIMETAL ENGINEERS PRIVATE LIMITED",
"SHIVALIK BUILDTECH PRIVATE LIMITED",
"SHIVALIK CAMBRIDGE COLLEGE",
"SHIVALIK COLLEGE DEHRADUN",
"SHIVALIK COLLEGE OF ENGINEERING",
"SHIVALIK COMMUNICATIONS PRIVATE LIMITED",
"SHIVALIK CONTAINERS PRIVATE. LIMITED.",
"SHIVALIK CROP SCIENCES PRIVATE LIMITED",
"SHIVALIK DESIGN PRIVATE LIMITED",
"SHIVALIK DEVELOPERS PRIVATE LIMITED",
"SHIVALIK DISTRIBUTION PRIVATE LIMITED",
"SHIVALIK ELECON PRIVATE LIMITED",
"SHIVALIK ELECTRIC EQUIPMENT COMPANY PRIVATE LIMITED",
"SHIVALIK ENCLAVE LLP",
"SHIVALIK ENGINEERED PRODUCTS PRIVATE LIMITED",
"SHIVALIK ENGINEERING INDUSTRIES LIMITED",
"SHIVALIK ERECTION PRIVATE LIMITED",
"SHIVALIK EXIM PRIVATE LIMITED",
"SHIVALIK FABRICS PRIVATE LIMITED",
"SHIVALIK FASTENERS PRIVATE LIMITED",
"SHIVALIK GREEN ENERGY PRIVATE LIMITED",
"SHIVALIK HYDRO PRIVATE LIMITED",
"SHIVALIK HYUNDAI",
"SHIVALIK I B AUTOMARK PRIVATE LIMITED",
"SHIVALIK I B AUTOWORLD PRIVATE LIMITED",
"SHIVALIK IB AUTOGEM PRIVATE LIMITED",
"SHIVALIK INDIA ALCO PRIVATE LIMITED",
"SHIVALIK INFRAVENTURES PRIVATE LIMITED",
"SHIVALIK INTERNATIONAL SCHOOL",
"SHIVALIK JHANVI INFRASPACE LLP",
"SHIVALIK LAMINATES (INDIA) PRIVATE LIMITED",
"SHIVALIK MEDICAL CENTRE PRIVATE LIMITED",
"SHIVALIK MERCANTILE CO OP BANK LIMITED",
"SHIVALIK OFFSET PRIVATE LIMITED",
"SHIVALIK POWER AND STEEL PRIVATE LIMITED",
"SHIVALIK PRINTS LIMITED",
"SHIVALIK RASAYAN LIMITED",
"SHIVALIK RECLAMATION PVT LTD",
"SHIVALIK REMEDIES PRIVATE LIMITED",
"SHIVALIK RICE AND GENERAL MILLS PRIVATE LIMITED",
"SHIVALIK SHIPPING SERVICES PRIVATE LIMITED",
"SHIVALIK SMALL FINANCE BANK LIMITED",
"SHIVALIK SOLID WASTE MANAGEMENT LIMITED",
"SHIVALIK TELECOM LIMITED",
"SHIVALIK VYAPAAR PRIVATE LIMITED",
"SHIVALIK WIRES PRIVATE LIMITED",
"SHIVALIKVIEW STEEL TRADING PRIVATE LIMITED",
"SHIVALINE PLASTOTECH PRIVATE LIMITED",
"SHIVALINGAM TRANSPORTS PRIVATE LIMITED",
"SHIVAM & COMPNY",
"SHIVAM ACRYLICS PRIVATE LIMITED",
"SHIVAM ADDITIVES PRIVATE LIMITED",
"SHIVAM AGGREGATES PRIVATE LIMITED",
"SHIVAM AGRIOILS PRIVATE LIMITED",
"SHIVAM AGRO PRODUCTS PRIVATE LIMITED",
"SHIVAM AGROPROCESS PRIVATE LIMITED",
"SHIVAM ANESTHESIA LIMITED",
"SHIVAM AUTO COMP PRIVATE LIMITED",
"SHIVAM AUTOMALL PRIVATE LIMITED",
"SHIVAM AUTOMOVERS PRIVATE LIMITED",
"SHIVAM AUTOTECH LIMITED",
"SHIVAM AUTOZONE INDIA PRIVATE. LIMITED.",
"SHIVAM BETELNUT PRIVATE LIMITED",
"SHIVAM BIZCOM PRIVATE LIMITED",
"SHIVAM BRANDWRAPPER INDIA PRIVATE LIMITED",
"SHIVAM BUILDERS PRIVATE LIMITED",
"SHIVAM CABLE & BROADBAND PRIVATE LIMITED",
"SHIVAM CARTONS PRIVATE LIMITED",
"SHIVAM CASTOR PRODUCTS PRIVATE LIMITED",
"SHIVAM CHEMICALS LIMITED",
"SHIVAM CHEMICALS PRIVATE LIMITED",
"SHIVAM COAL CARRIERS PRIVATE LIMITED",
"SHIVAM COKE PVT. LTD.",
"SHIVAM COLONISERS PRIVATE LIMITED",
"SHIVAM CONCRETE TECHNOLOGY AND CONSULTANCY PRIVATE LIMITED",
"SHIVAM CONDEV PRIVATE LIMITED",
"SHIVAM CONSULTANTS & LOGISTICS PRIVATE LIMITED",
"SHIVAM COOLDRINKS PRIVATE LIMITED",
"SHIVAM COT FIBRES PRIVATE LIMITED",
"SHIVAM COTTEX",
"SHIVAM DEV INFRACON PRIVATE LIMITED",
"SHIVAM DEVANSH FAB PRIVATE LIMITED",
"SHIVAM DEVELOPERS PRIVATE LIMITED",
"SHIVAM DYED HOUSE PRIVATE LIMITED",
"SHIVAM ELECTRICALS INDIA PRIVATE LIMITED",
"SHIVAM ELECTRICALS PRIVATE LIMITED",
"SHIVAM ELECTRONICS INDIA PRIVATE LIMITED",
"SHIVAM ENERFUEL PRIVATE LIMITED",
"SHIVAM ENERGY CONTROL SYSTEMS PRIVATE LIMITED",
"SHIVAM ENERGYTECH PRIVATE LIMITED",
"SHIVAM ENGINEERING",
"SHIVAM ENGINEERING PROJECTS PRIVATE LIMITED",
"SHIVAM ENTERPRISES",
"SHIVAM ENTERPRISES AND PERSONNEL SERVICES PRIVATE LIMITED",
"SHIVAM ESTATES",
"SHIVAM FABRICS",
"SHIVAM FERRO ALLOYS PRIVATE LIMITED",
"SHIVAM FLOUR INDUSTRIES PRIVATE LIMITED",
"SHIVAM GINNING AND PRESSING PRIVATE LIMITED",
"SHIVAM GREENTECH PRIVATE LIMITED",
"SHIVAM HI TECH STEELS PRIVATE. LIMITED",
"SHIVAM HIGHRISE PRIVATE LIMITED",
"SHIVAM HOLO PACK PRIVATE LIMITED",
"SHIVAM HOSPITAL",
"SHIVAM HOSPITAL AND RESEARCH INSTITUTE PRIVATE.LIMITED",
"SHIVAM HYDRAULIC PRIVATE LIMITED",
"SHIVAM INDUSTRIAL PRODUCTS PRIVATE LIMITED",
"SHIVAM INFOCOM PRIVATE LIMITED.",
"SHIVAM INFRAREALTY PRIVATE LIMITED",
"SHIVAM INFRA-TECH PRIVATE LIMITED",
"SHIVAM INSTRUMENTS AND CONTROLS PRIVATE LIMITED",
"SHIVAM INTERNATIONAL",
"SHIVAM IRON & STEEL COMPANY LIMITED",
"SHIVAM IRRIGATION WORKS PRIVATE LIMITED",
"SHIVAM ISPAT PRIVATE LIMITED",
"SHIVAM JEWELS",
"SHIVAM LABOUR SUPPLIERS",
"SHIVAM LAKE SIDE INN & HOLIDAY HOMES PRIVATE LIMITED",
"SHIVAM LIFTERS PRIVATE LIMITED",
"SHIVAM MARMO PRIVATE LIMITED",
"SHIVAM MEDICOS PRIVATE LIMITED",
"SHIVAM MEDISOFT SERVICES PRIVATE LIMITED",
"SHIVAM MEGASTRUCTURES PRIVATE LIMITED",
"SHIVAM METACAST (GUJARAT) PRIVATE LIMITED",
"SHIVAM METALLURGICALS PRIVATE LIMITED",
"SHIVAM MOBILE SERVICES PRIVATE LIMITED",
"SHIVAM MODERN RICE INDUSTRIES PRIVATE LIMITED",
"SHIVAM MOTORS PRIVATE LIMITED",
"SHIVAM NITRATE PRIVATE LIMITED",
"SHIVAM OIL MILLS PRIVATE LIMITED",
"SHIVAM ORNAMENTS PRIVATE LIMITED",
"SHIVAM OXYGEN P LTD",
"SHIVAM PACKAGING INDUSTRIES PRIVATE LIMITED",
"SHIVAM PARIVAR DEVELOPERS PRIVATE LIMITED",
"SHIVAM PFT PRIVATE LIMITED",
"SHIVAM PHOTOVOLTAICS PRIVATE LIMITED",
"SHIVAM PLYWOOD PVT LTD",
"SHIVAM POLYTUBES PRIVATE LIMITED",
"SHIVAM PRECITECH TOOLROOMS PRIVATE LIMITED",
"SHIVAM PRINTOGRAPHICS PRIVATE LIMITED",
"SHIVAM PROTECO PRIVATE LIMITED",
"SHIVAM PROTEIN PRODUCTS PRIVATE LIMITED",
"SHIVAM PULSES LIMITED",
"SHIVAM READYMIX PRIVATE LIMITED",
"SHIVAM RICE MILLS",
"SHIVAM RICE MILLS PRIVATE LIMITED",
"SHIVAM ROADLINES PRIVATE LIMITED",
"SHIVAM ROLLER FLOUR MILLS PVT LTD",
"SHIVAM SALES & SERVICES",
"SHIVAM SALES PRIVATE LIMITED",
"SHIVAM SEATRANS PRIVATE LIMITED",
"SHIVAM SECURITIES PRIVATE LIMITED",
"SHIVAM SHAPES PRIVATE LIMITED",
"SHIVAM SHIPPING AND LOGISTICS PRIVATE LIMITED",
"SHIVAM SHIPPING INDIA PRIVATE LIMITED",
"SHIVAM SHUBHAM FASHIONS PRIVATE LIMITED",
"SHIVAM SILKFAB PRIVATE LIMITED",
"SHIVAM SOYA PRIVATE LIMITED",
"SHIVAM SPRINGS PRIVATE LIMITED",
"SHIVAM STEEL CORPORATION",
"SHIVAM STEELCAST PRIVATE LIMITED",
"SHIVAM STEELS AND TUBES PRIVATE LIMITED",
"SHIVAM STOCK BROKING COMPANY",
"SHIVAM STRUCTURAL AND STEEL PRIVATE LIMITED",
"SHIVAM SULZ PRIVATE LIMITED",
"SHIVAM SUNDARAM DEVELOPERS AND REALTORS PRIVATE LIMITED",
"SHIVAM SUNDARAM ENGITECH PRIVATE LIMITED",
"SHIVAM SYNCOTEX PRIVATE LIMITED",
"SHIVAM SYNTHETICS",
"SHIVAM TERINE PRIVATE LIMITED",
"SHIVAM TEXOFAB PRIVATE LIMITED",
"SHIVAM TEXTILE PROCESSORS PRIVATE LIMITED",
"SHIVAM TRACK IMPEX PRIVATE LIMITED",
"SHIVAM TRADERS",
"SHIVAM TRADERS AND HIRE PURCHASE PRIVATE LIMITED",
"SHIVAM TWISTEX PRIVATE LIMITED",
"SHIVAM UDYOG PRIVATE LIMITED",
"SHIVAM VALLEY WOODENS PRIVATE LIMITED",
"SHIVAM VIDHYALAY",
"SHIVAM VIDYA MANDIR HIGH SCHOOL",
"SHIVAM WELLNESS PRIVATE LIMITED",
"SHIVAMANI AND COMPANY PRIVATE LIMITED",
"SHIVAMANI PHARMA PACK PRIVATE LIMITED",
"SHIVAMBE CORPORATION PRIVATE LIMITED",
"SHIVAMOGGA SMART CITY LIMITED",
"SHIVAMPRIME STEELS PRIVATE LIMITED",
"SHIVAMSHAHIL CONSTRUCTION PRIVATE LIMITED",
"SHIVAMTECH ENGINEERING DESIGN PRIVATE LIMITED",
"SHIVAMY TECHNOLOGIES PRIVATE LIMITED",
"SHIVAMY TRADEXIM PRIVATE LIMITED",
"SHIVANAND INFRACON PRIVATE LIMITED",
"SHIVANANDA MARKETING PRIVATE LIMITED",
"SHIVANCHAL ALLOYS PRIVATE LIMITED",
"SHIVANE CAPITAL PRIVATE LIMITED",
"SHIVANG COLD STORAGE PRIVATE LIMITED",
"SHIVANG EDIBLES OILS PRIVATE LIMITED",
"SHIVANG FURNACES AND OVENS INDUSTRIES PRIVATE LIMITED",
"SHIVANG INFRATECH PRIVATE LIMITED",
"SHIVANG ISPAT PRIVATE LIMITED",
"SHIVANG MOTOTECH PRIVATE LIMITED",
"SHIVANG SHEET GRAH PRIVATE LIMITED.",
"SHIVANG TECHNOCRATS PRIVATE LIMITED",
"SHIVANG TRADING COMPANY (INDIA) PRIVATE LIMITED",
"SHIVANGAN FOOD & PHARMA PRODUCTS PRIVATE LIMITED",
"SHIVANGANI SKILL DEVELOPMENT & SERVICES PRIVATE LIMITED",
"SHIVANGI AGRO INDIA PRIVATE LIMITED",
"SHIVANGI BAKERS PRIVATE LIMITED",
"SHIVANGI FLOWERS PRIVATE LIMITED",
"SHIVANGI METAL INDUSTRIES PRIVATE LIMITED",
"SHIVANGI MOTELS PRIVATE LIMITED",
"SHIVANGI OILS PRIVATE LIMITED",
"SHIVANGI POLYSACK PRIVATE LIMITED",
"SHIVANGI ROLLING MILLS PRIVATE. LIMITED.",
"SHIVANGI TRADERS",
"SHIVANGINI PROPERTIES PRIVATE LIMITED",
"SHIVANI AGENCIES PRIVATE LIMITED",
"SHIVANI AGROFOODS PRIVATE LIMITED",
"SHIVANI AVIATES PRIVATE LIMITED",
"SHIVANI BUILDWELL PRIVATE LIMITED",
"SHIVANI CARRIERS PVT LTD",
"SHIVANI COTEX PRIVATE LIMITED",
"SHIVANI COTTON PRIVATE LIMITED",
"SHIVANI CREATION PRIVATE LIMITED",
"SHIVANI DEGREE COLLEGE",
"SHIVANI DETERGENTS PVT LTD",
"SHIVANI ENCLAVES PVT LTD",
"SHIVANI GARMENTS",
"SHIVANI GEMS & JEWELS PRIVATE LIMITED",
"SHIVANI HOSPITAL PRIVATE LIMITED",
"SHIVANI IMPEX PRIVATE LIMITED",
"SHIVANI INFRATECH PRIVATE LIMITED",
"SHIVANI INTERIOR SOLUTIONS PRIVATE LIMITED",
"SHIVANI LOCKS PRIVATE LIMITED",
"SHIVANI MACHING CENTER",
"SHIVANI MEDIPRO PRIVATE LIMITED",
"SHIVANI PIPE INDUSTRIES PRIVATE LIMITED",
"SHIVANI PROCESSORS PRIVATE LIMITED",
"SHIVANI SCIENTIFIC INDUSTRIES PRIVATE LIMITED",
"SHIVANI SHREYA LOGISTIC PRIVATE LIMITED",
"SHIVANI TEXTILES LIMITED",
"SHIVANI TOOLS PRIVATE LIMITED",
"SHIVANI WOOLTEX PRIVATE LIMITED",
"SHIVANIL TEXFAB PRIVATE LIMITED",
"SHIVANJALI CREATION PRIVATE LIMITED",
"SHIVANJALI ELECTRICALS PVT LTD",
"SHIVANJALI PRINTS PRIVATE LIMITED",
"SHIVANK GASES PRIVATE LIMITED",
"SHIVANK LOGISTICS PRIVATE LIMITED",
"SHIVANK OVERSEAS PRIVATE LIMITED",
"SHIVANK UDYOG LIMITED",
"SHIVANO ORGANICS PRIVATE LIMITED",
"SHIVANS POWER AND IRRIGATION PRIVATE LIMITED",
"SHIVANS STEEL PVT LTD",
"SHIVANSH BUILDCON PRIVATE LIMITED",
"SHIVANSH ENGITECH PRIVATE LIMITED",
"SHIVANSH GREEN ENERGY SOLUTION PRIVATE LIMITED",
"SHIVANSH INFOTECH PRIVATE LIMITED",
"SHIVANSH KHETI AN INITIATIVE OF THE HANS FOUNDATION",
"SHIVANSH MARBLE & TILES PRIVATE LIMITED",
"SHIVANSH OFFSHORE AND MARINE SERVICES PRIVATE LIMITED",
"SHIVANSH OUTSOURCING PRIVATE LIMITED",
"SHIVANSH SOLUTIONS PRIVATE LIMITED",
"SHIVANSH TEXTILES PRIVATE LIMITED",
"SHIVANSH VENTURE PRIVATE LIMITED",
"SHIVANSHU SINTERED PRODUCTS PVT LTD",
"SHIVANSHU VEHICLES LLP",
"SHIVANTA JD TALC INDIA PRIVATE LIMITED",
"SHIVANTA MULTISPECIALITY HOSPITAL",
"SHIVANUJA EYE CARE PRIVATE LIMITED",
"SHIVAPRIYA COMMODITIES PRIVATE LIMITED",
"SHIVARAJA IMPEX COMPANY",
"SHIVAS ARCHITECTS AND PLANNERS PRIVATE LIMITED",
"SHIVAS AUTO COMPONENTS PRIVATE LIMITED",
"SHIVAS CATRING",
"SHIVAS DEPARTMENTAL STORES PRIVATE LIMITED",
"SHIVAS FARMA CASA PRIVATE LIMITED",
"SHIVAS HAIR DESIGNERS PRIVATE LIMITED",
"SHIVAS PROJECTS (INDIA) PRIVATE LIMITED",
"SHIVASAA APPARELS PRIVATE LIMITED",
"SHIVASAKTHI FASHIONS PRIVATE LIMITED",
"SHIVASAKTHI TEXTILE PROCESSING MILLS PRIVATE LIMITED",
"SHIVASATYA ENGINEERING SERVICES PRIVATE LIMITED",
"SHIVASHAKTHI DAIRY PRIVATE LIMITED",
"SHIVASHAKTHI XYLEM CROP SCIENCE PRIVATE LIMITED",
"SHIVASHAKTI ART PVT LTD",
"SHIVASHAKTI AGRITEC LIMITED",
"SHIVASHAKTI ELMECH PRIVATE LIMITED",
"SHIVASHAKTI SUGARS LIMITED",
"SHIVASHISH HOTEL & RESORTS PRIVATE LIMITED",
"SHIVASHISH MOTORS INDIA PRIVATE LIMITED",
"SHIVASHISH PRIMARY SCHOOL",
"SHIVASHISH TRADE LINKS PRIVATE LIMITED",
"SHIVASHREE INFRABUILD PRIVATE LIMITED",
"SHIVASHRI MEDIA PRIVATE LIMITED",
"SHIVASHRIT FOODS PRIVATE LIMITED",
"SHIVATE INFRAPROJECTS PRIVATE LIMITED",
"SHIVATEJA GODAVARI ENTERPRISES PRIVATE LIMITED",
"SHIVAY CREATIONS PRIVATE LIMITED",
"SHIVAY EDIBLES PRIVATE LIMITED",
"SHIVAY EXPORTS PRIVATE LIMITED",
"SHIVAY SOLAR ENERGY PRIVATE LIMITED",
"SHIVAY UNITY AURUM DEVELOPERS PRIVATE LIMITED",
"SHIVAYAA CARS PRIVATE LIMITED",
"SHIVAYAH SALT PRIVATE LIMITED",
"SHIVBHOOMI INFRALOGISTICS PRIVATE LIMITED",
"SHIVBROS MECHFAB PRIVATE LIMITED",
"SHIVCO INFINITE PRIVATE LIMITED",
"SHIVCO INTERNATIONAL PRIVATE LIMITED",
"SHIVDANI VYAPAAR PRIVATE LIMITED",
"SHIVDHAM FROZEN FOODS PRIVATE. LIMITED.",
"SHIVDHAM INDUSTRIES PVT LTD",
"SHIVDHAN BOARDS PRIVATE LIMITED",
"SHIVDHAN DECOR LIMITED",
"SHIVDHARA COTTON PRIVATE LIMITED",
"SHIVDHARA MERCHANDISE PRIVATE LIMITED.",
"SHIVDHARA SPINNERS & SPINNERS PRIVATE LIMITED",
"SHIVDHU MONDE CREATIF PRIVATE LIMITED",
"SHIVDOOTI CARGO MOVERS PRIVATE LIMITED",
"SHIVDOOTI PEARLS AND INVESTMENTS LIMITED",
"SHIVDURGA RICEMILL PRIVATE LIMITED",
"SHIVEN IMPEX PRIVATE LIMITED",
"SHIVEN YARN PRIVATE LIMITED",
"SHIVENDRA JEWELLERS PRIVATE LIMITED",
"SHIVENDU PACKAGING PRIVATE LIMITED",
"SHIVERA LIFESTYLE PRIVATE LIMITED",
"SHIVERA TRADING COMPANY",
"SHIVESH MEDICAL SERVICES PRIVATE LIMITED",
"SHIVESH TRADECOM PRIVATE LIMITED",
"SHIVEX COURIER AND CARGO PRIVATE LIMITED",
"SHIVGANESHA ICE & MILK CHILLING PLANT PRIVATE LIMITED",
"SHIVGANGA COLD STORAGE PRIVATE LIMITED",
"SHIVGANGA DRILLERS PRIVATE LIMITED",
"SHIVGANGA EXPORTS PRIVATE LIMITED",
"SHIVGANGA PRESTRESSED PIPES PRIVATE LIMITED",
"SHIVGANGE SAREES PRIVATE LIMITED",
"SHIVGREEN SOLAR SYSTEM PRIVATE LIMITED",
"SHIVGYAN DEVELOPERS PRIVATE LIMITED",
"SHIVHARE ASSOCIATES",
"SHIVHARE RETAIL PRIVATE LIMITED",
"SHIVHARI PROCESSORS PRIVATE LIMITED",
"SHIVI ENTERPRISES",
"SHIVI ENTERPRISES PRIVATE LIMITED",
"SHIVI MINERALS PRIVATE LIMITED",
"SHIVI MULTITECH PRIVATE LIMITED",
"SHIVI TEXTILES PRIVATE LIMITED",
"SHIVIN LIQLIBRARY PRIVATE LIMITED",
"SHIVIN MULTITRADE LIMITED",
"SHIVINI FINE CHEMICALS PRIVATE LIMITED",
"SHIVJEE INDUSTRIES AND MARKETING PRIVATE LIMITED",
"SHIVJI VALJI SHEDS PRIVATE LIMITED",
"SHIVJYOTI BUILDWELL PRIVATE LIMITED",
"SHIVKAAL BHAIRAV PRIVATE LIMITED",
"SHIVKAILASH ADOBES PRIVATE LIMITED",
"SHIV-KAMAL HAND LOOMS PRIVATE LIMITED",
"SHIVKAMAL RUBBERS PRIVATE LIMITED",
"SHIVKAMAL STEEL ENTERPRISES PRIVATE LIMITED",
"SHIVKANTA SANITATION PRIVATE LIMITED",
"SHIVKRIPA APPARELS PRIVATE LIMITED",
"SHIVKRIPA CABLES PRIVATE LIMITED",
"SHIVKRIPA SHOPPERS PRIVATE LIMITED",
"SHIVKRISHNA POLYTEX PRIVATE LIMITED",
"SHIVKRUPA CONSTRUCTION AND DEVELOPERS PRIVATE LIMITED",
"SHIVKRUPA COTSPIN PRIVATE LIMITED",
"SHIVKRUPA FABRICON LIMITED",
"SHIVKRUPA GRUHPRAVESH LLP",
"SHIVKRUPA MEDICAL SERVICES PRIVATE LIMITED",
"SHIVKRUPA METAL PRIVATE LIMITED",
"SHIVKRUPA SAHAKARI PATPEDHI LTD",
"SHIVKUMAR NIRANJANLAL DALMIA EDUCATIONAL FOUNDATION",
"SHIVLABHI GLOBAL LOGISTICS INDIA PRIVATE LIMITED",
"SHIVLEELA URBAN NIDHI LIMITED",
"SHIVLING IMPEX PRIVATE LIMITED",
"SHIVLINGESHWAR COLLEGE OF PHARMACY",
"SHIVMAAY FOODS PRIVATE LIMITED",
"SHIVMAHAL TEXTILES PRIVATE LIMITED",
"SHIVMANGAL ENGICON PRIVATE LIMITED",
"SHIVMANGAL MERCHANDISE PRIVATE LIMITED",
"SHIVMANI AGROTECH PRIVATE LIMITED",
"SHIVMANI EXPORTS PRIVATE LIMITED",
"SHIVMANNGAL INDUSTRIES PRIVATE LIMITED",
"SHIVMAY CONSTRUCTION EQUIPMENTS PRIVATE LIMITED",
"SHIVMAY ENGINEERING PRIVATE LIMITED",
"SHIVMAYA INFRA & ENERGY PRIVATE LIMITED",
"SHIVMIITH POLYMER PRIVATE LIMITED",
"SHIVMOHAN GRAPHICS INNOVATION PRIVATE LIMITED",
"SHIVNANDANI AGRO PRIVATE LIMITED",
"SHIVNARAYAN JEWELLERS PRIVATE LIMITED",
"SHIVNARAYAN NEMANI SHARE AND STOCK BROKERS PRIVATE LIMITED",
"SHIVNATH AUTOMOBILES PRIVATE LIMITED",
"SHIVNATH AUTOMOTIVE PRIVATE LIMITED",
"SHIVNATH CAPITAL PRIVATE LIMITED",
"SHIVNATH DEVELOPERS (INDIA) PRIVATE LIMITED",
"SHIVNATH LAND MASS PRIVATE LIMITED",
"SHIVNATH MOTORS (INDIA) PRIVATE LIMITED",
"SHIVNATH TRACTORS",
"SHIVNERI FOUNDATION",
"SHIVNERI FROZEN FOODS PRIVATE LIMITED",
"SHIVOHAM ALLOYS PRIVATE LIMITED",
"SHIVOHAM BUNDELKHAND SECURITY AND LABOUR SERVICES PRIVATE LIMITED",
"SHIVOHAM ENTERTAINMENT PRIVATE LIMITED",
"SHIVOHAM FOODS PRIVATE LIMITED",
"SHIVOHAM TECHNOSERVICES PRIVATE LIMITED",
"SHIVOM CONSTRUCTION PRIVATE LIMITED",
"SHIVOM COTSPIN LIMITED",
"SHIVOM ENGINEERS ASSOCIATES PRIVATE LIMITED",
"SHIVOM GROUP OF COMPANIES JHANSI",
"SHIVOM INDUSTRIES PRIVATE LIMITED",
"SHIVOM INVESTMENT & CONSULTANCY LIMITED",
"SHIVOM LOGISTICS PRIVATE LIMITED",
"SHIVOM MINERALS LIMITED",
"SHIVOM PACKAGING PRIVATE LIMITED",
"SHIVOM RUBBER PRODUCTS PRIVATE LIMITED",
"SHIV-OM SULZ FAB PRIVATE LIMITED",
"SHIVOM TRANSLINES PRIVATE LIMITED",
"SHIVOM TREXIM PRIVATE LIMITED",
"SHIVOMANI SALES PRIVATE LIMITED",
"SHIVORA APPARELS PRIVATE LIMITED",
"SHIVOTTAM ENGITECH PRIVATE LIMITED",
"SHIVOTTAM STEELS PRIVATE LIMITED",
"SHIVOY FACILITIES SERVICES PRIVATE LIMITED",
"SHIVOYS NEURO HOSPITAL PRIVATE LIMITED",
"SHIVPAD ENGINEERS PRIVATE LIMITED",
"SHIVPARAMOUNT ORGANICS AND FERTILIZERS PRIVATE LIMITED",
"SHIVPARAS ALLOY & STEEL PRIVATE LIMITED",
"SHIV-PARVATI CONSTRUCTION",
"SHIVPARVATI FOODS AND BEVERAGES PRIVATE LIMITED",
"SHIVPARVATI INFRA PRIVATE LIMITED",
"SHIVPRA CRANES PVT LTD",
"SHIVPRABHA AUTOTECH PRIVATE LIMITED",
"SHIVPRASAD DAIRY FOODS PRIVATE LIMITED",
"SHIVPRASAD LOGISTICS PRIVATE LIMITED",
"SHIVPRASAD MILLS PRIVATE LIMITED",
"SHIVPRASAD REALTY PRIVATE LIMITED",
"SHIVPRIYA ALLOYS PRIVATE LIMITED",
"SHIVPRIYA CABLES PRIVATE LIMITED",
"SHIVPRIYA ISPAT (INDIA) PRIVATE LIMITED",
"SHIVPRIYA TEXCHEM PRIVATE LIMITED",
"SHIVPRIYA TRADINGAND FINANCE CO. PRIVATE LIMITED",
"SHIVPUJA CONSTRUCTIONS PRIVATE LIMITED",
"SHIVPURI GOVT ORGANISATION",
"SHIVRAI TECHNOLOGIES PRIVATE LIMITED",
"SHIVRAJ DRUMS AND CONTAINERS PRIVATE LIMITED",
"SHIVRAJ HEAVY ENGINEERING PRIVATE LIMITED",
"SHIVRAJ INDUSTRIES AHMEDABAD",
"SHIV-RAJ PLASTICS PRIVATE LIMITED",
"SHIVRAJ VIDYAMANDIR MADHYAMIK",
"SHIVRAJYA KRUSHI MITRA PRODUCER COMPANY LIMITED",
"SHIVRAM CONSULTANTS PRIVATE LIMITED",
"SHIVRAM FOODS PRIVATE LIMITED",
"SHIVRAM INFRAPROJECTS & DEVELOPERS PRIVATE LIMITED",
"SHIVRAM MOTORS PRIVATE LIMITED",
"SHIVRAMKA FABRICS PRIVATE LIMITED",
"SHIVRAMKA STEELS PRIVATE LIMITED",
"SHIVRANJANI SECURITIES COMPANY PRIVATE LIMITED",
"SHIVRANYANI PROPERTIES LLP",
"SHIVRAT BUILDERS & FABRICATORS PRIVATE LIMITED",
"SHIVRATH AUTOMOBILE PRIVATE LIMITED",
"SHIVRATNA STEEL PRIVATE LIMITED",
"SHIVRUDRA ENTERPRISES PRIVATE LIMITED",
"SHIVRUDRA TOOLING SERVICES PRIVATE LIMITED",
"SHIVSAGAR BIDI WORKS PVT LTD",
"SHIVSAGAR LOGISTICS CORPORATION PRIVATE LIMITED",
"SHIVSAHAJ ENGINEERING & PLASTICS PRIVATE LIMITED",
"SHIVSAI INTERNATIONAL PRIVATE LIMITED",
"SHIVSAI SALES PRIVATE LIMITED",
"SHIVSAKTI FLOUR MILLS PRIVATE LIMITED",
"SHIVSAMARTH BUILDERS & DEVELOPERS PRIVATE LIMITED",
"SHIVSAMARTH MOTORIDERS PRIVATE LIMITED",
"SHIVSHAKTI AGRO INDIA PRIVATE LIMITED",
"SHIVSHAKTI AGROOILS PRIVATE LIMITED",
"SHIVSHAKTI DRUGS PRIVATE LIMITED",
"SHIVSHAKTI ENTERPRISES PRIVATE LIMITED",
"SHIVSHAKTI FAB PRIVATE LIMITED",
"SHIVSHAKTI OILS PRIVATE LIMITED",
"SHIV-SHAKTI OXALATE PRIVATE LIMITED",
"SHIVSHAKTI POLYFILMS PRIVATE LIMITED",
"SHIVSHAKTI POLYMERS PVT LTD",
"SHIVSHAKTI PRESS PRIVATE LIMITED",
"SHIVSHAKTI PRINTS PRIVATE LIMITED",
"SHIVSHAKTI REALHOME PRIVATE LIMITED",
"SHIVSHAKTI RESOURCES PRIVATE LIMITED",
"SHIVSHAKTI SEALINK PRIVATE LIMITED",
"SHIVSHAKTI SPACELINKS PRIVATE LIMITED",
"SHIVSHAKTI STORES PRIVATE LIMITED",
"SHIVSHAKTI TIMBER TRADING (BETUL) PRIVATE LIMITED",
"SHIVSHAKTI TRADELINK PRIVATE LIMITED",
"SHIVSHAKTI TWO WHEELERS PRIVATE LIMITED",
"SHIVSHAKTI URJA PRIVATE LIMITED",
"SHIVSHAMBHU COAL CARRIERS PRIVATE LIMITED",
"SHIVSHANKAR KAUSHIK INFRASTRUCTURE PRIVATE LIMITED",
"SHIVSHANKAR MARBLES PRIVATE LIMITED",
"SHIVSHANKAR POLES PRIVATE LIMITED",
"SHIVSHANKAR SMELTERS PRIVATE LIMITED",
"SHIVSHANKAR VIDYALAY AND CHINTAMANRAO MORMORE KANISHTH MAHAVIDYALAY",
"SHIVSHANKER MARTS CO PRIVATE LIMITED",
"SHIVSHANTI DEVELOPERS PRIVATE LIMITED",
"SHIVSHANTI EXIM PVT. LTD.",
"SHIVSHANTI GAS AGENCY",
"SHIVSHARAN INFRAESTATE PRIVATE LIMITED",
"SHIVSHIVA STEEL PRIVATE LIMITED",
"SHIVSHIVAM PHARMA PRIVATE LIMITED",
"SHIVSON IMMITATION JEWELLERY PRIVATE LIMITED",
"SHIVSUBH MERCANTILE PRIVATE LIMITED",
"SHIVSWARAJYA AGROTECH PRIVATE LIMITED",
"SHIVSWARAJYA FARMER PRODUCER COMPANY LIMITED",
"SHIVSWATI ENTERPRISES PRIVATE LIMITED",
"SHIVTARA GRAIN MILLING PRIVATE LIMITED",
"SHIVTARA GRAINS PRIVATE LIMITED",
"SHIVTARA RICE MILL PRIVATE LIMITED",
"SHIVTECH MARINE CONTROL SYSTEMS AND SERVICES PRIVATE LIMITED",
"SHIVTEJ FARMER PRODUCER COMPANY LIMITED",
"SHIVTEL COMMUNICATIONS PRIVATE LIMITED",
"SHIVTEX SPINNING PRIVATE LIMITED",
"SHIVVANI MARKCOM PRIVATE LIMITED",
"SHIVVIDIT MERCHANT PRIVATE LIMITED",
"SHIVVILAS REALHOME PRIVATE LIMITED",
"SHIVYAA AUTOPACK PRIVATE LIMITED",
"SHIVYANK ENTERPRISES PRIVATE LIMITED",
"SHIVYOG INFRATECH PRIVATE LIMITED",
"SHIVZ AUTOTECH PRIVATE LIMITED",
"SHIWALAY ENTERPRISE",
"SHIWALYA SPINNING & WEAVING MILLS PRIVATE LIMITED",
"SHIWKON DIGITEK PRIVATE LIMITED",
"SHIZA BUILDERS PRIVATE LIMITED",
"SHIZA FRESH INDIA PRIVATE LIMITED",
"SHJ INTERNATIONAL TECHNOLOGIES PRIVATE LIMITED",
"SHJ TRADERS PRIVATE LIMITED",
"SHK ENTERPRISES PRIVATE LIMITED",
"SHKAVI LOGISTIC SOLUTIONS PRIVATE LIMITED",
"SHKUBO CMO SERVICES PRIVATE LIMITED",
"SHL (INDIA) PRIVATE LIMITED",
"SHLAAGHY SAHLAN ELECTRO INFRA PRIVATE LIMITED",
"SHLOK BIOFUELS PRIVATE LIMITED",
"SHLOK BUILDERS PRIVATE LIMITED",
"SHLOK CHEMICALS",
"SHLOK ENTERPRISES PRIVATE LIMITED",
"SHLOK EXIM PRIVATE LIMITED",
"SHLOK FLOUR MILLS PRIVATE LIMITED",
"SHLOK INFORMATION SYSTEMS INDIA PRIVATE LIMITED",
"SHLOK INNOVATIONS",
"SHLOK LOGISTICS PRIVATE LIMITED",
"SHLOK POLYMERS PRIVATE LIMITED",
"SHLOK SECURITY PRINTERS PRIVATE LIMITED",
"SHLOKA DESIGNS PRIVATE LIMITED",
"SHLOKA ENGINEERING PRIVATE LIMITED",
"SHLOKAM ENTERPRISE PRIVATE LIMITED",
"SHLOKAZ RETAIL PRIVATE LIMITED",
"SHM DATA SERVICES (OPC) PRIVATE LIMITED",
"SHM FIRE SAFETY PRIVATE LIMITED",
"SHM PRODUCTS PRIVATE LIMITED",
"SHM SHIPCARE",
"SHM SHIPYARD LIMITED",
"SHM SHIPYARD PRIVATE LIMITED",
"SHMAYITA CONVENT SCHOOL",
"SHMEET CHEM IMPEX PRIVATE LIMITED",
"SHNAYA INDUSTRIES PRIVATE LIMITED",
"SHOB CONSTRUCTION PRIVATE LIMITED",
"SHOB SHEDGAON PHATA-MANGRUL PROJECT PRIVATE LIMITED",
"SHOBANAAKSHAYA ASSOCIATES PRIVATE LIMITED",
"SHOBHA AGROCARE INFRA PRIVATE LIMITED",
"SHOBHA ANO PRINTS PRIVATE LIMITED",
"SHOBHA BI-WHEELERS PRIVATE LIMITED",
"SHOBHA CHEMICAL INDUSTRIES PRIVATE LIMITED",
"SHOBHA DESIGNS PRIVATE LIMITED",
"SHOBHA DIAGNOSTIC CENTRE PRIVATE LIMITED",
"SHOBHA EXIM PRIVATE LIMITED",
"SHOBHA FABRICATORS PRIVATE LIMITED CN",
"SHOBHA HOSPITAL",
"SHOBHA INDUSTRIES",
"SHOBHA INDUSTRIES PRIVATE LIMITED",
"SHOBHA MACHINES PRIVATE LIMITED",
"SHOBHA NURSING HOME PRIVATE LIMITED",
"SHOBHA PROMPT SERVICES PRIVATE LIMITED",
"SHOBHA WOOLLENS PRIVATE LIMITED",
"SHOBHAGLOBS ENGINEERS HUB PRIVATE LIMITED",
"SHOBHANI COMMERCIAL PRIVATE LIMITED",
"SHOBHAWAT INDUSTRIES",
"SHOBHAWAT TEXTILE MILLS LIMITED",
"SHOBHIKA MEDIA PRIVATE LIMITED",
"SHOBHIT CHEMICALS PRIVATE LIMITED",
"SHOBHNA ISPAT PRIVATE LIMITED",
"SHOBIKAA IMPEX PRIVATE. LIMITED.",
"SHOBITHA ELECTRONICS MANUFACTURERS PRIVATE LIMITED",
"SHOBIZ EXPERIENTIAL COMMUNICATIONS PRIVATE LIMITED",
"SHOBUL JEWELLERS PRIVATE LIMITED",
"SHOCKLEY HALL ELECTRONICS PVT LTD",
"SHODHA CONSTRUCTIONS PRIVATE LIMITED",
"SHODHA MOTORS PRIVATE. LIMITED.",
"SHODHAN TEXTILES PRIVATE LIMITED",
"SHODHANA LABORATORIES LIMITED",
"SHODHANA LABORATORIES PRIVATE LIMITED",
"SHOE CLUB INDIA PRIVATE LIMITED",
"SHOE GAME PRIVATE LIMITED",
"SHOE TECNIK INTERNATIONAL CORPORATION LI MITED",
"SHOE TECNIK INTERNATIONAL CORPORATION LIMITED.",
"SHOE VARIANTS PRIVATE LIMITED",
"SHOEGARO FASHIONS PRIVATE LIMITED",
"SHOEI-EXECUTIVE CREW MANAGEMENT PRIVATE LIMITED",
"SHOELINE",
"SHOES WORLD INDIA PRIVATE LIMITED",
"SHOFT INDUSTRIES PRIVATE LIMITED",
"SHOFT SHIPYARD PRIVATE LIMITED",
"SHOFU DENTAL INDIA PRIVATE LIMITED",
"SHOGEO POWER TECHNIQUE PRIVATE LIMITED",
"SHOGHI AGRO TECH PRIVATE LIMITED",
"SHOGHI COMMUNICATIONS LIMITED",
"SHOGINI TECHNOARTS PRIVATE LIMITED",
"SHOGUN ORGANICS LIMITED",
"SHOKEEN EXIM PRIVATE LIMITED",
"SHOKEEN HOTELS AND RESORTS PRIVATE LIMITED",
"SHOKEEN JEWELLERS PRIVATE LIMITED",
"SHOLAPUR SOCIAL ASSOCIATION'S ARTS & COMMERCE COLLEGE SOLAPUR",
"SHOM DISTRIBUTORS PRIVATE LIMITED",
"SHOMAN MARKETING SOLUTIONS PRIVATE LIMITED",
"SHOMED REMEDIES LLP",
"SHOMI LIBATT PRIVATE LIMITED",
"SHOMUK CONSULTANCY SERVICES PRIVATE LIMITED",
"SHON CERAMICS PVT LTD",
"SHONA CORPORATE SERVICES PRIVATE LIMITED",
"SHONAN ENGINEERING WORKS PRIVATE LIMITED",
"SHONTAE INDIA PRIVATE LIMITED",
"SHOOLIN SHIP MANAGEMENT PRIVATE LIMITED",
"SHOOLIN SHIPPING AND LOGISTICS PRIVATE LIMITED",
"SHOOLIN SHIPPING SERVICES INDIA PRIVATE LIMITED",
"SHOOLIN WOOD VENTURES PRIVATE LIMITED",
"SHOONYA CONNECTIONS PRIVATE LIMITED",
"SHOONYA ENVIRONMENTAL SOLUTIONS PRIVATE LIMITED",
"SHOONYA GAME TECHNOLOGIES PRIVATE LIMITED",
"SHOORA TRACTORS INDIA LIMITED",
"SHOORJI VALLABHDAS SWADESHI BAZAR PVT LTD",
"SHOOTUP TECHNOLOGIES PRIVATE LIMITED",
"SHOP CJ NETWORK PRIVATE LIMITED",
"SHOP ELECT PRIVATE LIMITED",
"SHOP KIRANA E TRADING PRIVATE LIMITED",
"SHOPAAREL ENTERPRISES PRIVATE LIMITED",
"SHOPCLIENTS CONSULTANCY SERVICES PRIVATE LIMITED",
"SHOPEASY FASHION & RETAIL PRIVATE LIMITED",
"SHOPIAN AGRO FRESH COLD CHAIN PRIVATE LIMITED",
"SHOPINSYNC ONLINE PRIVATE LIMITED",
"SHOPNET MARKETING PRIVATE LIMITED",
"SHOPNIK E-SERVICE PRIVATE LIMITED",
"SHOPOLO DIGITAL PRIVATE LIMITED",
"SHOPOYE INDIA PRIVATE LIMITED",
"SHOPPER STOP LIMITED",
"SHOPPERS STOP LIMITED",
"SHOPPERS' STOP.COM (INDIA) LIMITED",
"SHOPPERS-INTERNATIONAL MALLS PRIVATE LIMITED",
"SHOPPING BAZAAR PRIVATE LIMITED",
"SHOPPING ZONE INDIA TV PRIVATE LIMITED",
"SHOPPRIX INDIA PRIVATE LIMITED",
"SHOPRITE TRADE PRIVATE LIMITED",
"SHOPSENSE RETAIL TECHNOLOGIES LIMITED",
"SHOPTIMIZE INDIA PRIVATE LIMITED",
"SHOPTION PRIVATE LIMITED",
"SHOPTRADE TECHNOLOGIES PRIVATE LIMITED",
"SHOPTREE TECHNOLOGIES PRIVATE LIMITED",
"SHOPZO BRAND PRIVATE LIMITED",
"SHOR SHOT I PRIVATE LIMITED",
"SHORAPUR SOLAR POWER LIMITED",
"SHORE AUTO-RUBBER EXPORTS PVT LTD",
"SHORE DWELLINGS PRIVATE LIMITED",
"SHORE INFOTECH INDIA PRIVATE LIMITED",
"SHORE VIEW HOSPITALITY PRIVATE LIMITED",
"SHORELIGHT EDUCATION INDIA PRIVATE LIMITED",
"SHORELINE BUILDERS PRIVATE LIMITED",
"SHORELINE DEVELOPMENT LIMITED",
"SHORELINE HEALTHCARE TECHNOLOGIES PRIVATE LIMITED",
"SHORELINE HOTEL PRIVATE LIMITED",
"SHORETEL COMMUNICATIONS PRIVATE LIMITED",
"SHOREWALA PAPER INDUSTRIES PRIVATE LIMITED",
"SHOREWALA TRADERS PRIVATE LIMITED",
"SHORI TRENDS PRIVATE LIMITED",
"SHORTEST PATH PRIVATE LIMITED",
"SHORTHILLS TECH PRIVATE LIMITED",
"SHORTLIST PROFESSIONAL SERVICES PRIVATE LIMITED",
"SHORYA BUSINESS (INDIA) LIMITED",
"SHOT FORMATS DIGITAL PRODUCTIONS PRIVATE LIMITED",
"SHOTAM CONSULTANTS PRIVATE LIMITED",
"SHOU HOSPITALITIES PRIVATE LIMITED",
"SHOU RESTAURANT PRIVATE LIMITED",
"SHOUBII CONSULTING PRIVATE LIMITED",
"SHOURY MOTORS",
"SHOURYA MINERALS PRIVATE LIMITED",
"SHOURYA RECYCLING PRIVATE LIMITED",
"SHOURYA TOWERS PRIVATE LIMITED",
"SHOURYASHUBHAM INFRASTRUCTURES PRIVATE LIMITED",
"SHOW GENESIS INDIA PRIVATE LIMITED",
"SHOW MAN ENTERTAINMENT PRIVATE LIMITED",
"SHOW N SHINE PRIVATE LIMITED",
"SHOWA ARCH METAL PRIVATE LIMITED",
"SHOWCRAFT PRODUCTIONS PRIVATE LIMITED",
"SHOWELL APPLIANCES INDIA PRIVATE LIMITED",
"SHOWHOUSE EVENT MANAGEMENT PRIVATE LIMITED",
"SHOWHOUSE EVENT MARKETING PRIVATE.LIMITED",
"SHOWMEDAMANI PRIVATE LIMITED",
"SHOWMEDIA SOLUTION PRIVATE LIMITED",
"SHOWRAM HOTELS PRIVATE LIMITED",
"SHOWROOM 79 CLOTHING PRIVATE LIMITED",
"SHOWSPACE EVENT SOLUTIONS LLP",
"SHOWTIME ENTERTAINMENT PRIVATE LIMITED",
"SHOWTIME EVENTS INDIA",
"SHOWTIME SYNDICATORS PRIVATE LIMITED",
"SHOWWORKS EVENTZ PRIVATE LIMITED",
"SHP PROPERTIES PRIVATE LIMITED",
"SHQ SOLUTIONS INDIA PRIVATE LIMITED",
"SHR GENDA SINGH KISHAN I C NAYABAS",
"SHR HOLDINGS PRIVATE LIMITED",
"SHR INFRASTRUCTURE PRIVATE LIMITED",
"SHR POWERS PRIVATE LIMITED",
"SHR TRADECORP PRIVATE LIMITED",
"SHRACHI BURDWAN DEVELOPERS PRIVATE LIMITED",
"SHRACHI DEVELOPERS PRIVATE LIMITED",
"SHRACHI REALTY PRIVATE LIMITED",
"SHRACOM PRIVATE LIMITED",
"SHRADDHA AGRO PRIVATE LIMITED",
"SHRADDHA ASSOCIATES (GUJ) PRIVATE LIMITED",
"SHRADDHA AUTOCARE PRIVATE LIMITED",
"SHRADDHA CORPORATION",
"SHRADDHA CORPORATION PRIVATE LIMITED",
"SHRADDHA CREATIONS PRIVATE LIMITED",
"SHRADDHA CRITICAL CARE CENTRE PRIVATE LIMITED",
"SHRADDHA DIAGNOSTIC CENTRE (I) PRIVATE LIMITED",
"SHRADDHA ELECTRIX PRIVATE LIMITED",
"SHRADDHA ENERGY & AGRO PRODUCTS PRIVATE LIMITED",
"SHRADDHA ENERGY AND INFRAPROJECTS PRIVATE LIMITED",
"SHRADDHA FABRICS PRIVATE LIMITED",
"SHRADDHA FASHION PRIVATE LIMITED",
"SHRADDHA FINECHEM PRIVATE LIMITED",
"SHRADDHA FIRE PROTECTION SYSTEMS PRIVATE LIMITED",
"SHRADDHA FOREX PRIVATE LIMITED",
"SHRADDHA INFRA PROJECTS NIRMAN PRIVATE LIMITED",
"SHRADDHA INNOVATIONS OPC PRIVATE LIMITED",
"SHRADDHA ISPAT PRIVATE LIMITED",
"SHRADDHA JEWELS PRIVATE LIMITED",
"SHRADDHA JUNIOR COLLEGE OF SCIENCE AND COMMERCE",
"SHRADDHA KNOWLEDGE ACADEMY PRIVATE LIMITED",
"SHRADDHA LANDMARK PRIVATE LIMITED",
"SHRADDHA MARITIME SERVICES PRIVATE LIMITED",
"SHRADDHA MARMOGRANI PRIVATE LIMITED",
"SHRADDHA MODULAR FURNITURE PRIVATE LIMITED",
"SHRADDHA MULTISPECIALITY HOSPITALS PRIVATE LIMITED",
"SHRADDHA OVERSEAS PRIVATE LIMITED",
"SHRADDHA ROLLERS PRIVATE LIMITED",
"SHRADDHA SABURI PRINTERS PRIVATE LIMITED",
"SHRADDHA SABURI SERVICES ENTERPRISES PRIVATE LIMITED",
"SHRADDHA SHELTERS PRIVATE LIMITED",
"SHRADDHA SYNTHETICS PRIVATE LIMITED",
"SHRADDHA UTILITIES PRIVATE LIMITED",
"SHRADDHA VIDYALAYA",
"SHRADDHA VIDYANMANDIR",
"SHRADDHASABURI FARMER PRODUCER COMPANY LIMITED",
"SHRADHA AI TECHNOLOGIES LIMITED",
"SHRADHA BUILDCON PRIVATE LIMITED",
"SHRADHA CHEMICALS PRIVATE LIMITED",
"SHRADHA DESIGNTECH PRIVATE LIMITED",
"SHRADHA ENGINEERING PRIVATE LIMITED",
"SHRADHA FORGE PVT LTD",
"SHRADHA HRD PRIVATE LIMITED",
"SHRADHA INFRAPROJECTS LIMITED",
"SHRADHA NIRMAN PRIVATE LIMITED",
"SHRADHA PROJECTS LIMITED",
"SHRADHA SABOORI PROJECTS (INDIA) PRIVATE LIMITED",
"SHRADHA SABURI HOSPITALITIES P LIMITED",
"SHRADHA SALES",
"SHRADHA TRADELINKS PRIVATE LIMITED",
"SHRADHASABURI ENGINEERS PRIVATE LIMITED",
"SHRADHASAI PRINT PRIVATE LIMITED",
"SHRAI FASHION STUDIOS LIMTIED",
"SHRAJ PHARMATECH PRIVATE LIMITED",
"SHRAJAS ENGINEERS PVT LTD",
"SHRAMAN JI FABRICS PRIVATE LIMITED",
"SHRAMBAL DISTRIBUTORS PRIVATE LIMITED",
"SHRAMIK KRISHI UDYOG LIMITED",
"SHRAMIK MECHANICAL CONTRACTORS PRIVATE LIMITED",
"SHRAMIK POWER JOB PRIVATE LIMITED",
"SHRAMIK VIDYALYA",
"SHRAMP ENGINEERS PRIVATE LIMITED",
"SHRANTA FORWARDERS PRIVATE LIMITED",
"SHRAS IT SOLUTIONS PRIVATE LIMITED",
"SHRASTA DECOR PRIVATE LIMITED",
"SHRATHI PRINTERS AND PUBLISHERS PRIVATE LIMITED",
"SHRAVAK OVERSEAS PRIVATE LIMITED",
"SHRAVAN FINANCE AND ESTATES PRIVATE LIMITED",
"SHRAVAN HOSPITAL PRIVATE LIMITED",
"SHRAVAN RAJ CONSTRUCTIONS PRIVATE LIMITED (PART IX)",
"SHRAVAN REF AIR PRIVATE LIMITED",
"SHRAVANI ENGINEERS PRIVATE LIMITED (OPC)",
"SHRAVANI HITECH PRIVATE LIMITED",
"SHRAVANTHI HOTELS AND RESORTS PRIVATE LIMITED",
"SHRAVAS TECHNOLOGIES INDIA PRIVATE LIMITED",
"SHRAVNI MULTI SOLUTIONS PRIVATE LIMITED",
"SHRAVYA GRANITO PRIVATE LIMITED",
"SHRAVYA PLASTO PRIVATE LIMITED",
"SHRAVYAS INFRASTRUCTURE PRIVATE LIMITED",
"SHRAWASTHI AGROTECH PRIVATE LIMITED",
"SHRAY LOGISTICS & FORWARDERS PRIVATE LIMITED",
"SHRAY OFFSET PRIVATE LIMITED",
"SHRAYANS COATINGS LIMITED",
"SHRE BHAGAVATHY YARN PRIVATE LIMITED",
"SHRE GO UMAP HIGH SCHOOL JU COLLEAGE M C V C YENVA",
"SHRE JOGINDER MEMORIAL CHARITABLE (SJMC) BLOOD CENTRE",
"SHREAS INDUSTRIES LIMITED",
"SHREBEL INDUSTRIES PRIVATE LIMITED",
"SHRED CREATIVE LAB PRIVATE LIMITED",
"SHREE AADESHWAR FOREX PRIVATE LIMITED",
"SHREE AADITYA SYNERGY PRIVATE LIMITED",
"SHREE AAGARSEN STEEL INDUSTRIES PRIVATE LIMITED",
"SHREE AARGH (INDIA) LIMITED",
"SHREE AARTI ENTERPRISES",
"SHREE ABEE CONSTRUCTIONS PRIVATE LIMITED",
"SHREE ABHAY CRANES PRIVATE LIMITED",
"SHREE ABHAY HOISTS AND ENGINEERING PRIVATE LIMITED",
"SHREE ACADEMY OF PROFESSIONAL EDUCATION AND RESEARCH SAPER",
"SHREE ADARSH VIDHYA MANDIR SANATHALI",
"SHREE ADDITIVES (PHARMA AND FOODS) PRIVATE LIMITED",
"SHREE ADHI PARA SAKTHI SPINNERS PRIVATE LIMITED",
"SHREE ADIGA HOTEL PRIVATE LIMITED",
"SHREE ADINATH ALCO CHEM PRIVATE LIMITED",
"SHREE ADINATH EMBROIDERY PRIVATE LIMITED",
"SHREE ADINATH SHIPPING & LOGISTICS",
"SHREE ADINATH TRADING PRIVATE LIMITED",
"SHREE ADIRAJ LAXMI BUILDERS PRIVATE LIMITED",
"SHREE ADITYA SYNTEX PVT LTD",
"SHREE ADVERTISING AND MARKETING PRIVATE LIMITED",
"SHREE AGARWAL FABRICS PVT LTD",
"SHREE AGENCIES PRIVATE LIMITED",
"SHREE AGGARSAIN INTERNATIONAL HOSPITAL",
"SHREE AGGARWAL INFRASTRUCTURE DEVELOPMENT PRIVATE LIMITED",
"SHREE AGRASEN PROTIENS PRIVATE LIMITED",
"SHREE AGRICO AND RICE PRIVATE LIMITED",
"SHREE AGRO CROP SCIENCES PRIVATE LIMITED",
"SHREE AGRO SERVICES PVT LTD",
"SHREE AHUJA PROPERTIES PRIVATE LIMITED",
"SHREE AJAY INTERNATIONAL PRIVATE LIMITED",
"SHREE AJIT PULP AND PAPER LIMITED",
"SHREE AKSHAR PHARMACEUTICALS PRIVATE LIMITED",
"SHREE AKSHAY INN PRIVATE LIMITED",
"SHREE ALAMPATA",
"SHREE ALLOYS INDUSTRIES PVT LTD",
"SHREE AMANTRAN HOSPITALITY PRIVATE LIMITED",
"SHREE AMBA INDUSTRIES",
"SHREE AMBA JEWELLERS PRIVATE LIMITED",
"SHREE AMBAJI FIBRES PRIVATE LIMITED",
"SHREE AMBALIKA POLYTEX PRIVATE LIMITED",
"SHREE AMBE FOOD PRODUCTS PRIVATE LIMITED",
"SHREE AMBEY ISPAT PRIVATE. LIMITED.",
"SHREE AMBEY METAL INDUSTRIES LIMITED",
"SHREE AMBICA AGRO INDUSTRIES PVT LTD",
"SHREE AMBICA AUTO SALES & SERVICE",
"SHREE AMBICA CEREALS PVT LTD",
"SHREE AMBICA DECOPRINTS PRIVATE LIMITED",
"SHREE AMBICA EXIM PRIVATE LIMITED",
"SHREE AMBICA FURNISHINGS (INDIA) PRIVATE LIMITED",
"SHREE AMBICA PLASTOMAC PRIVATE LIMITED",
"SHREE AMBIKA GRAMIN BIGARSHETI SAHAKARI PATSANSTHA MARYADIT KHODAD",
"SHREE AMBIKA TEXTILE",
"SHREE AMBIKA WOOD CREATION PRIVATE LIMITED",
"SHREE AMBUJA CASTINGS PRIVATE LIMITED",
"SHREE AMBUJA SILK MILLS PRIVATE LIMITED",
"SHREE AMEE CONSTRUCTION EQUIPMENTS PRIVATE LIMITED",
"SHREE AMEYA PUBLIC CHARITABLE TRUST",
"SHREE AMMAN PHARMA PRIVATE LIMITED",
"SHREE AMRUT SAI DEVELOPER PRIVATE LIMITED",
"SHREE ANAND LIFE SCIENCES LIMITED",
"SHREE ANANDESHWAR BUILDCON PRIVATE LIMITED",
"SHREE ANANDESWAR PAPER MILLS PRIVATE LIMITED",
"SHREE ANANDHAAS BISTRO & CO",
"SHREE ANEKANT TUBE SALES PRIVATE LIMITED",
"SHREE ANJANI CERAMICS MANUFACTURING PVT LTD",
"SHREE ANJANI COURIER SERVICES PRIVATE LIMITED",
"SHREE ANJAR GINNING AND PRESSING CO PRIVATE LIMITED",
"SHREE ANK FINHOLD PRIVATE LIMITED",
"SHREE ANMOL ROADWAYS PRIVATE LIMITED",
"SHREE ANNAPURNA SUGAR & JAGGERY WORKS LIMITED",
"SHREE ANNAPURNESHWARI ALLIED SERVICES PRIVATE LIMITED",
"SHREE ANU MILK PRODUCTS LIMITED",
"SHREE ANUKUL INDUSTRIES PRIVATE LIMITED",
"SHREE ANURAG TAILONG ABRASIVES PRIVATE LIMITED",
"SHREE APARAJITA MARBLES PRIVATE LIMITED",
"SHREE ARBUDA LOGISTICS PRIVATE LIMITED",
"SHREE ARBUDA MOTORS PRIVATE LIMITED",
"SHREE ARDHNARISHWARE HOSPITAL & RESEARCH CENTRE PRIVATE LIMITED",
"SHREE ARIHANT PEB ENGINEERING PRIVATE LIMITED",
"SHREE ARIHANT SUBMERSIBLE PUMPS PRIVATE LIMITED",
"SHREE ARIHANT TRADE LINKS INDIA PRIVATE LIMITED",
"SHREE ARIKA FOODS PRIVATE LIMITED",
"SHREE ARNAV JEWELLARY PRIVATE LIMITED",
"SHREE ARUN PACKAGING COMPANY PRIVATE LIMITED",
"SHREE ASHAPURA CLEARING HOUSE PRIVATE LIMITED",
"SHREE ASHAPURA METAL AND ALLOYS PRIVATE LIMITED",
"SHREE ASHOKA SOLAR AND ENERGY PRIVATE LIMITED",
"SHREE ASHTAVINAYAK FERROUS PRIVATE LIMITED",
"SHREE ASHTAVINAYAK GLASS PRIVATE LIMITED",
"SHREE ASHTAVINAYAK IMPEX PRIVATE LIMITED",
"SHREE ASHTAVINAYAK PAPERS PRIVATE LIMITED",
"SHREE ASHTAVINAYAK THEATRE VENTURES PRIVATE LIMITED",
"SHREE ASHTECH PRIVATE LIMITED",
"SHREE ASHTVINAYAK ROLLER FLOUR MILLS PRIVATE LIMITED",
"SHREE ASR MOTOCORP PRIVATE LIMITED",
"SHREE AUM ENTERPRISE",
"SHREE AURO BUILDTECH PRIVATE LIMITED",
"SHREE AURO EDUCATION ZONE",
"SHREE AURO IRON LIMITED",
"SHREE AUTOMOTIVE PRIVATE. LIMITED.",
"SHREE AUTUMOBILES PRIVATE LIMITED",
"SHREE AVTARA FINTECH SERVICES PRIVATE LIMITED",
"SHREE AWADH MITHILA CONSTRUCTION PRIVATE LIMITED",
"SHREE AZAD FLEET SOLUTIONS PRIVATE LIMITED",
"SHREE AZAD TRANSPORT COMPANY PRIVATE LIMITED",
"SHREE B L AGRI PRODUCTS PRIVATE LIMITED",
"SHREE B P DAWDA SARASWATI VIDHYALAY",
"SHREE B.K. GLASS I PRIVATE LIMITED",
"SHREE B.S. COTTON PRIVATE LIMITED",
"SHREE BABA SATGURU STEELS PRIVATE LIMITED",
"SHREE BABOSA PAPER PRIVATE LIMITED",
"SHREE BADAL CHAND SAYAR CHAND CHUDIR JAIN VIDAYALA MAT.SCHOOL",
"SHREE BADRI KEDAR PAPERS PRIVATE. LIMITED.",
"SHREE BADRINARAYAN TEXTILES MILLS PVT LTD",
"SHREE BAHORA INFRATECH PRIVATE LIMITED",
"SHREE BAHUBALI COAL & COKE PRIVATE LIMITED",
"SHREE BAHUBALI COMMODITIES PRIVATE LIMITED",
"SHREE BAHUBALI CORPORATION LIMITED",
"SHREE BAHUBALI MERCANTILE PVT LTD",
"SHREE BAHUBALI STOCK BROKING LIMITED",
"SHREE BAHUCHARAJI SALES",
"SHREE BAIDYANATH AYURVED BHAWAN PRIVATE LIMITED",
"SHREE BAIDYARAJ AYURVED BHAWAN PRIVATE LIMITED",
"SHREE BAJAJ SUITINGS PRIVATE LIMITED",
"SHREE BAJRANG EDIBLES PRIVATE LIMITED",
"SHREE BAJRANG FOOD PRODUCTS PRIVATE LIMITED",
"SHREE BAJRANG MOTORS PRIVATE LIMITED",
"SHREE BAJRANG SALES PRIVATE LIMITED",
"SHREE BAJRANGBALI AGRO INDUSTRIES PRIVATE LIMITED",
"SHREE BAJRANGBALI ENTERPRISES PRIVATE LIMITED",
"SHREE BAKE BIHARI FOOD PRODUCTS PRIVATE LIMITED",
"SHREE BALA HANUMAN POLYCOAT PRIVATE LIMITED",
"SHREE BALA JI PIGMENTS LIMITED",
"SHREE BALA URBAN CO OPERATIVE BANK LTD",
"SHREE BALAJEE AGRO MILLS PRIVATE LIMITED",
"SHREE BALAJEE CORPORATION",
"SHREE BALAJEE DYECHEM PRIVATE LIMITED",
"SHREE BALAJEE HOME PRODUCTS PRIVATE LIMITED",
"SHREE BALAJEE INFRAEQUIPMENT PRIVATE LIMITED",
"SHREE BALAJEE LANDMARK HOTELS PRIVATE LIMITED",
"SHREE BALAJEE MAGNESITE PRIVATE LIMITED",
"SHREE BALAJEE MULTI BUILDERS PRIVATE LIMITED",
"SHREE BALAJI AGRO FARM INDUSTRIES PRIVATE LIMITED",
"SHREE BALAJI ALLOYS PRIVATE LIMITED",
"SHREE BALAJI ALUMNICAST PRIVATE. LIMITED.",
"SHREE BALAJI AROMATICS PRIVATE LIMITED",
"SHREE BALAJI AUTO DISTRIBUTORS PRIVATE LIMITED",
"SHREE BALAJI AUTOWHEELS (INDIA) PRIVATE LIMITED",
"SHREE BALAJI AUXICHEM PRIVATE LIMITED",
"SHREE BALAJI BABAJI AGROFOODS PRIVATE LIMITED",
"SHREE BALAJI BAKERIES PRIVATE LIMITED",
"SHREE BALAJI CHAITANYA ENTERPRISES",
"SHREE BALAJI COAL TRADERS LIMITED",
"SHREE BALAJI COTGIN PRIVATE LIMITED",
"SHREE BALAJI CREATION",
"SHREE BALAJI DISPOSABLE & PACKAGING PRIVATE LIMITED",
"SHREE BALAJI DISTRIBUTORS",
"SHREE BALAJI DREAM DEVELOPERS PRIVATE LIMITED",
"SHREE BALAJI ENGICONS PRIVATE LIMITED",
"SHREE BALAJI ENGINEERING",
"SHREE BALAJI ENTERPRISE PRIVATE LIMITED",
"SHREE BALAJI EQUIPMENTS PRIVATE LIMITED",
"SHREE BALAJI EXTERIORS PRIVATE LIMITED",
"SHREE BALAJI FOOD INDUSTRIES PRIVATE LIMITED",
"SHREE BALAJI FURNACES PRIVATE LIMITED",
"SHREE BALAJI GLASS MANUFACTURING PVT LTD",
"SHREE BALAJI GUMS AND SPICE STUFF PRIVATE LIMITED",
"SHREE BALAJI IRON PRIVATE LIMITED",
"SHREE BALAJI KRIPA HEALTH SOLUTIONS PRIVATE LIMITED",
"SHREE BALAJI LUMBERS PRIVATE LIMITED",
"SHREE BALAJI MALA TEXTILES PRIVATE LIMITED",
"SHREE BALAJI MARKPLUS PRIVATE LIMITED",
"SHREE BALAJI METALFAB PRIVATE LIMITED",
"SHREE BALAJI METASTEELS PRIVATE LIMITED",
"SHREE BALAJI MINETECH RESOURCES PRIVATE LIMITED",
"SHREE BALAJI MULTI SPECIALITY CARE PRIVATE LIMITED",
"SHREE BALAJI MULTICOMMODITIES PRIVATE LIMITED",
"SHREE BALAJI PACKAGING INDUSTRIES PRIVATE LIMITED",
"SHREE BALAJI PLASTOCHEM PRIVATE LIMITED",
"SHREE BALAJI POLYTECH PRODUCTS PRIVATE LIMITED",
"SHREE BALAJI PRINTING & PACKAGING PRIVATE LIMITED",
"SHREE BALAJI ROADLINES",
"SHREE BALAJI SANITARY PRIVATE LIMITED",
"SHREE BALAJI SAREE UDYOG PRIVATE LIMITED",
"SHREE BALAJI SAREES PRIVATE LIMITED",
"SHREE BALAJI SECURITY SERVICES",
"SHREE BALAJI SELANGOR RETAIL PRIVATE LIMITED",
"SHREE BALAJI SHIPPING & PROJECTS PRIVATE LIMITED",
"SHREE BALAJI SUPER SPECIALITY HEALTHCARE PRIVATE LIMITED",
"SHREE BALAJI SURGICAL PRIVATE LIMITED",
"SHREE BALAJI SYNTHETICS PRIVATE LIMITED",
"SHREE BALAJI TEFLO INSULATORS PRIVATE LIMITED",
"SHREE BALAJI TEST HOUSE PRIVATE LIMITED",
"SHREE BALAJI TEST LAB PRIVATE LIMITED",
"SHREE BALAJI TEX PRINTS PRIVATE LIMITED",
"SHREE BALAJI TRANSLINES COMPANY PRIVATE LIMITED",
"SHREE BALAJI TRANSOLUTIONS PRIVATE LIMITED",
"SHREE BALAJI TRANSPORT & ROADWAYS PRIVATE LIMITED",
"SHREE BALAJI TRUCKING PRIVATE LIMITED",
"SHREE BALAJI WEAVES PRIVATE LIMITED",
"SHREE BALAJI WIRENETTING INDUSTRIES INDIA PRIVATE LIMITED",
"SHREE BALASARIA CONSTRUCTION PVT.LTD.",
"SHREE BALBIR FOOD PRODUCT PRIVATE LIMITED",
"SHREE BALDAUJI COLD STORAGE PRIVATE LIMITED",
"SHREE BALDEVDAS KIKANI VIDYAMANDIR MATRIC HR SEC SCHOOL",
"SHREE BALKISHAN DYEING AND PRINTING MILLS PRIVATE LIMITED",
"SHREE BALRAM PLYWOOD PRIVATE LIMITED",
"SHREE BALRAM ROLLING MILLS PRIVATE LIMITED",
"SHREE BALRAM STEEL ALLOYS PRIVATE LIMITED",
"SHREE BALSANA CONTRACTORS PRIVATE LIMITED",
"SHREE BANARAS JEWELS PRIVATE LIMITED",
"SHREE BANARSI MARBLE STONE PVT LTD",
"SHREE BANDHU SAMAJ HIGH SCHOOL",
"SHREE BANKE BIHARI INTERNATIONAL PRIVATE LIMITED",
"SHREE BANKE BIHARI ISPAT PRIVATE LIMITED",
"SHREE BANKEY BEHARI FABRICS PRIVATE LIMITED",
"SHREE BANKEY BEHARI RCC PRODUCTS PRIVATE LIMITED",
"SHREE BANKEY BIHARI CLOTHING PRIVATE LIMITED",
"SHREE BANKEY BIHARI CONCAST PRIVATE LIMITED",
"SHREE BANKEY BIHARI EDUCATIONAL SOCIETY",
"SHREE BANKEY BIHARI METTALLOYS PRIVATE LIMITED",
"SHREE BANKEY BIHARI RECYCLER LIMITED",
"SHREE BANSI METAL AND ALLOYS PRIVATE LIMITED",
"SHREE BECHU LAL VINOD KUMAR JEWELLERS PRIVATE LIMITED",
"SHREE BEERA BARJEE TEXTILE PRIVATE LIMITED",
"SHREE BELHEKAR INFRA PRIVATE LIMITED",
"SHREE BELHEKAR PATIL INFRA PROJECTS PRIVATE LIMITED",
"SHREE BHAARATHI COTTON MILLS PRIVATE LIMITED",
"SHREE BHAGESHWARI PAPERS LIMITED",
"SHREE BHAGWATI AGROTECH PRIVATE LIMITED",
"SHREE BHAGWATI BALAJI FASHIONS PRIVATE LIMITED",
"SHREE BHAGWATI FLOUR AND FOODS PRIVATE LIMITED",
"SHREE BHAGWATI MACHTECH (INDIA) PRIVATE LIMITED",
"SHREE BHAGWATI MARKETING PRIVATE LIMITED",
"SHREE BHAGWATI RICE MILLS PRIVATE LIMITED",
"SHREE BHAGWATI SAREE HOUSE PVT LTD",
"SHREE BHAGYALAXMI INDUSTRIES",
"SHREE BHAIRAV KARNBADHIR VIDYALAY",
"SHREE BHAKTI CORPORATION PRIVATE LIMITED",
"SHREE BHANDARI PLASTIC PRIVATE LIMITED",
"SHREE BHARAT INTERNATIONAL PRIVATE LIMITED",
"SHREE BHARAT MOTORS LIMITED",
"SHREE BHARATH VIDYAASHRAM CBSE",
"SHREE BHARKA INDIA LIMITED",
"SHREE BHARKA SYNTHETICS LIMITED",
"SHREE BHARTARI TEA HOUSE PRIVATE LIMITED",
"SHREE BHARTIYA VIDHYA MANDIR",
"SHREE BHATHIJI FILAMENTS PVT LTD",
"SHREE BHATHIJI HIGH SCHOOL",
"SHREE BHATTER SILVER PRIVATE LIMITED",
"SHREE BHAVANI HIGH SCHOOL, AMBARELI",
"SHREE BHAVNAGAR NAGRIK SAHAKARI BANK LTD",
"SHREE BHAVYA FABRICS LIMITED",
"SHREE BHAWANI CONSULTANCY SERVICES PRIVATE LIMITED",
"SHREE BHAWANI PLYWOOD INDUSTRY",
"SHREE BHAWANI PRINTS AND LAMINATES PRIVATE LIMITED",
"SHREE BHIKSHU COMPONENTS PRIVATE LIMITED",
"SHREE BHIKSHU INDIA PRIVATE LIMITED",
"SHREE BHIKSHU PACKAGINGS PRIVATE LIMITED",
"SHREE BHIKSU ROLLER FLOUR MILL PRIVATE LIMITED",
"SHREE BHOLEY ALLOYS PRIVATE. LIMITED.",
"SHREE BHOMIA JI PAPERS PRIVATE LIMITED",
"SHREE BHUPATI ISPAT PRIVATE LIMITED",
"SHREE BIDADA SARVODAYA TRUST BOMBAY",
"SHREE BIHARI JI RUBBER INDUSTRIES PRIVATE LIMITED",
"SHREE BIHARIJI DISTRIBUTORS PRIVATE LIMITED",
"SHREE BIHARIJI EXPORTS PRIVATE LIMITED",
"SHREE BIMAL OXYGEN AND MINERALS PRIVATE LIMITED",
"SHREE BIO-CHEM PRIVATE LIMITED",
"SHREE BIRADEV FINANCE PRIVATE LIMITED",
"SHREE BISHNU POTATO STORAGE PVT LTD",
"SHREE CABLES AND CONDUCTORS PRIVATE. LIMITED.",
"SHREE CAPITAL SERVICES LTD.",
"SHREE CARPET AND TEXTILE MAHAL INDIA PRIVATE LIMITED",
"SHREE CARRIERS PRIVATE LIMITED",
"SHREE CARS PRIVATE LIMITED",
"SHREE CEMENT EAST BENGAL FOUNDATION",
"SHREE CEMENT LIMITED",
"SHREE CERAMIC FIBERS LIMITED",
"SHREE CERAMIC FIBERS PRIVATE LIMITED",
"SHREE CHAITAINYA MAHAPRABHU HOSPITALS PRIVATE LIMITED",
"SHREE CHAITANYA INDUSTRIES",
"SHREE CHAKRA ORGANICS PRIVATE. LIMITED.",
"SHREE CHAKRA SALES PRIVATE LIMITED",
"SHREE CHAKRADHAR INDUSTRIES",
"SHREE CHAKRADHAR SWAMI VIDYALAYA",
"SHREE CHAKURWALE PRIVATE LIMITED",
"SHREE CHALTHAN VIBHAG KHAND UDYOG SAHAKARI MANDLI LTD",
"SHREE CHAMUNDA COAL PRIVATE LIMITED",
"SHREE CHAMUNDA ELECTRICALS PRIVATE LIMITED",
"SHREE CHAMUNDA STEELS LIMITED",
"SHREE CHAMUNDA VALVES PRIVATE LIMITED",
"SHREE CHANAKYA EDUCATION SOCIETY",
"SHREE CHANCHAL INDUSTRIES PRIVATE LIMITED",
"SHREE CHANDEL FOOD PRODUCTS PRIVATE LIMITED",
"SHREE CHANDEL PETROLEUM PRIVATE LIMITED",
"SHREE CHANDEL ROLLER FLOUR MILLS PRIVATE LIMITED",
"SHREE CHANDRAMANGAL SUNCITY MARKETING PRIVATE LIMITED",
"SHREE CHANDRAPRABHU EXPORT PRIVATE LIMITED",
"SHREE CHARBHUJA TEXFAB PRIVATE LIMITED",
"SHREE CHARBHUJA TILES PRIVATE LIMITED",
"SHREE CHARBHUJA TRADELINK PRIVATE LIMITED",
"SHREE CHATRAPATI SHIVAJI MARATHI MADHYAMIK AND UCHH MADHYA SHALA",
"SHREE CHATRAPATI SHIVAJI VIDHYALAY",
"SHREE CHATRAPATIL SHIVAJI MARKET YARD T P N SAHKARI PATSANTHA LTD",
"SHREE CHATURBHUJ INTERNATIONAL PRIVATE LIMITED",
"SHREE CHATURBHUJ SYNTHETICS PRIVATE LIMITED",
"SHREE CHEMFOOD PRIVATE LIMITED",
"SHREE CHEMICALS INDUSTRIES PRIVATE LIMITED",
"SHREE CHEMOPHARMA ANKLESHWAR PRIVATE LIMITED",
"SHREE CHHATRAPATI RAJSHREE SHAHU URBAN CO BANK LTD BEED",
"SHREE CHHATRAPATI SHAHU MILK & AGRO PRODUCER COMPANY LIMITED",
"SHREE CHHATRAPATI SHAHU SAHAKARI SAKHAR KARKHANA LIMITED",
"SHREE CHINTAMANI KNITTING PRIVATE LIMITED",
"SHREE CHITHRA THIRUNAL INSTITUTE OF MEDI",
"SHREE CHLORATES PRIVATE LIMITED",
"SHREE CNC ENGINEERS PRIVATE LIMITED",
"SHREE COAL CARRIER",
"SHREE COAL ENTERPRISES (INDIA) PRIVATE LIMITED",
"SHREE COAL IMPEX PRIVATE LIMITED",
"SHREE COLOSPERSE PVT LTD",
"SHREE COMBINES PRIVATE LIMITED",
"SHREE COMMERCIAL INTERIOR PRIVATE. LIMITED",
"SHREE COMPUTER FORMS PRIVATE LIMITED",
"SHREE COMPUTERS SALES PRIVATE LIMITED",
"SHREE CONCRETES PRIVATE LIMITED",
"SHREE CONMIX ENGINEERS PRIVATE LIMITED",
"SHREE CONSTRUCTIONS AND LEISURE PRIVATE LIMITED",
"SHREE CONSTRUCTIONS CHENNAI PRIVATE LIMITED",
"SHREE CONSULTANCY SERVICES",
"SHREE CONSULTANTS PRIVATE LIMITED",
"SHREE COSMETICS LIMITED",
"SHREE COTEX",
"SHREE CREATIONS PRIVATE LIMITED",
"SHREE CV LOGISTIX PRIVATE LIMITED",
"SHREE D D P BUILDERS & REAL ESTATE PRIVATE LIMITED",
"SHREE DAADU RAM FARMER PRODUCER COMPANY LIMITED",
"SHREE DADI KRIPA ISPAT AND POWER PRIVATE LIMITED",
"SHREE DADISAH METALS PRIVATE LIMITED",
"SHREE DADU AUTOS PRIVATE LIMITED",
"SHREE DADU DAYAL AUTOMOBILES PRIVATE LIMITED",
"SHREE DADU DAYAL ELECTRONICS PRIVATE LIMITED",
"SHREE DAGA LEASING AND INVESTMENT PRIVATE LIMITED",
"SHREE DAIRY PRODUCTS PRIVATE LIMITED",
"SHREE DAKSHA ACADEMY",
"SHREE DALCHANDRA INTER COLLAGE LUKHRIHA KANNAUJ",
"SHREE DAMODAR COACH CRAFTS PRIVATE LIMITED",
"SHREE DARIYAV GLASSTECH PRIVATE LIMITED",
"SHREE DATT AQUACULTURE FARMS PRIVATE LIMITED",
"SHREE DATTA ENGINEERS PRIVATE LIMITED",
"SHREE DATTA SHETKARI SAHAKARI SAKHAR KARKHANA LIMITED",
"SHREE DATTA TEXTILES",
"SHREE DAYAL TIMBER PRIVATE LIMITED",
"SHREE DAYAL TOURS AND TRAVELS PRIVATE LIMITED",
"SHREE DEEP HOSPITAL",
"SHREE DEV BUILDERS & CONSTRUCTION PRIVATE LIMITED",
"SHREE DEV NEER PRIVATE LIMITED",
"SHREE DEV WHEELS PRIVATE LIMITED",
"SHREE DEVATA FOODS PRIVATE LIMITED",
"SHREE DEVI EDUCATION TRUST",
"SHREE DEVI TEXTILE",
"SHREE DEVKI KAILASH HIGH SCHOOL",
"SHREE DHAIN AUTO LOGISTICS PRIVATE LIMITED",
"SHREE DHAIRIYA LAKSHMI POLYSACKS PRIVATE LIMITED",
"SHREE DHANLAXMI FOODS PRIVATE LIMITED",
"SHREE DHANUKA AGRO PRIVATE LIMITED",
"SHREE DHANVANTARY PHARMACY COLLEGE",
"SHREE DHANVARSHA STEELS PRIVATE LIMITED",
"SHREE DHANVEE GRANITES PRIVATE LIMITED",
"SHREE DHANWANTRI HERBALS",
"SHREE DHOLI SATI ENTERPRISES PRIVATE LIMITED",
"SHREE DHOLI SATI TEXTILES PRIVATE LIMITED",
"SHREE DHOOTAPAPESHWAR LIMITED",
"SHREE DHUVA PRIMARY SCHOOL",
"SHREE DIAGNOSTICS PRIVATE LIMITED",
"SHREE DIAMOND SILICATE COMPANY PVT LTD",
"SHREE DIDOO MAHESHWARI PANCHAYAT VIDYALAYA",
"SHREE DIGVIJAY CEMENT CO LIMITED",
"SHREE DIGVIJAY PRATHMIC SHALA",
"SHREE DNYANESHWAR VIDYA MANDIR",
"SHREE DPS PROJECT AND SERVICES PRIVATE LIMITED",
"SHREE DURGA AGENCIES LTD",
"SHREE DURGA CAPITAL LIMITED",
"SHREE DURGA FARMS & RICE MILLS PRIVATE LIMITED",
"SHREE DURGA IRON & STEEL COMPANY LIMITED",
"SHREE DURGA JEWELLERS PRIVATE LIMITED",
"SHREE DURGA PARAMESHWARI MOTORS PRIVATE LIMITED",
"SHREE DURGA ROLLER FLOUR MILLS PRIVATE LIMITED",
"SHREE DURGA STEELS PRIVATE LIMITED",
"SHREE DURGA SYNTEX PRIVATE LIMITED",
"SHREE DURGA VIDHYALAY",
"SHREE DURGA WHEAT PRODUCTS PVT LTD",
"SHREE DURGESH DARINGS PVT LTD",
"SHREE DURGVINAYAK INDUSTRIES PRIVATE LIMITED",
"SHREE DURVA LOGISTICS PRIVATE LIMITED",
"SHREE DWARAKA ENGI-CONS PRIVATE LIMITED",
"SHREE DWARIKANATH HINDI HIGHER SECO",
"SHREE DWARIKESH ECOTEX PRIVATE LIMITED",
"SHREE DWARKA BEE-HIVE PLANT PVT LTD",
"SHREE EKLINGJI GUMS PRIVATE LIMITED",
"SHREE ELECTRICALS AND ENGINEERS INDIA PRIVATE LIMITED",
"SHREE ELECTRICALS AND TECHNICAL SERVICES PRIVATE LIMITED",
"SHREE ELECTROMELTS LIMITED",
"SHREE ENERMECH PRIVATE LIMITED",
"SHREE ENGINEERING",
"SHREE ENGINEERS & CONTRACTORS PRIVATE LIMITED",
"SHREE ENTERPRISE",
"SHREE ENTERPRISES",
"SHREE ENTERPRISES ( COAL SALES ) PVT LTD",
"SHREE ENTERPRISES INDIA PRIVATE LIMITED",
"SHREE EVENT MANAGEMENT PRIVATE LIMITED",
"SHREE EXPRESS TRANSCO LIMITED",
"SHREE EXTRUSIONS LIMITED",
"SHREE FAB FILAMENT PRIVATE LIMITED",
"SHREE FABRICATION INDUSTRIES",
"SHREE FATS AND PROTEINS PRIVATE LIMITED",
"SHREE FEED INDUSTRIES PRIVATE LIMITED",
"SHREE FEEDSTUFFS PRIVATE LIMITED",
"SHREE FINANCIAL SERVICE",
"SHREE FINE JEWELS PRIVATE LIMITED",
"SHREE FIRE & SAFETY ENGINEERS PRIVATE LIMITED",
"SHREE FLAVOURS LLP",
"SHREE FLEX PRINT PRIVATE LIMITED",
"SHREE FORWARDING AND CLEARING AGENTS PRIVATE LIMITED",
"SHREE FOUNDATIONS PRIVATE LIMITED",
"SHREE G K DHOLAKIYA SCHOOL",
"SHREE G PINGAKSH FINSOL PRIVATE LIMITED",
"SHREE G S AGRO PRIVATE LIMITED",
"SHREE G. M. THAOKAR (TOBACCO) PRIVATE LIMITED",
"SHREE GAJADHAR SILK MILLS PRIVATE LIMITED",
"SHREE GAJANAN CORPORATION INDIA PRIVATE LIMITED",
"SHREE GAJANAN FACILITIES PRIVATE LIMITED",
"SHREE GAJANAN FIBER PRIVATE LIMITED",
"SHREE GAJANAN HEART & EYE HOSPITALS PRIVATE LIMITED",
"SHREE GAJANAN MAHARAJ BAL VIDYAMANDIR",
"SHREE GAJANAN PAPER AND BOARDS PVT LTD",
"SHREE GAJANAN PRASAD WORKSHOP",
"SHREE GAJANAN WAREHOUSE PRIVATE LIMITED",
"SHREE GAJANAND FINTRADE PRIVATE LIMITED",
"SHREE GAJANAND PLASTICS PRIVATE LIMITED",
"SHREE GAJRAJ FINLEASE PVT LTD",
"SHREE GANAPATI BOXMAKER PRIVATE LIMITED",
"SHREE GANAPATI DAIRY & POLYMERS PRIVATE LIMITED",
"SHREE GANAPATI JEM & JEWELLERS PRIVATE LIMITED",
"SHREE GANAPATI RICE INDUSTRIES PRIVATE LIMITED",
"SHREE GANAPATI TEA PVT LTD",
"SHREE GANESH ACRO YARNS PRIVATE LIMITED",
"SHREE GANESH AGENCIE",
"SHREE GANESH AGROVET PRIVATE LIMITED",
"SHREE GANESH ALLOYS PRIVATE LIMITED",
"SHREE GANESH ANSH MANUFACTURING PRIVATE LIMITED",
"SHREE GANESH BAKERY NANDANI PRIVATE LIMITED",
"SHREE GANESH BHANDAR PRIVATE LIMITED",
"SHREE GANESH BIO-TECH (INDIA) LIMITED",
"SHREE GANESH BUILDCON PRIVATE LIMITED",
"SHREE GANESH BUILDTECH CONSTRUCTION PRIVATE LIMITED",
"SHREE GANESH COLLETS PRIVATE LIMITED",
"SHREE GANESH CONCERN",
"SHREE GANESH CONCRETE PRIVATE LIMITED",
"SHREE GANESH CONSTRUCTION",
"SHREE GANESH CONTROL PANELS PRIVATE LIMITED",
"SHREE GANESH CORPORATION",
"SHREE GANESH COTEX PRIVATE LIMITED",
"SHREE GANESH COTSPIN PRIVATE LIMITED",
"SHREE GANESH COURIER SERVICES PRIVATE LIMITED",
"SHREE GANESH EDIBLES PRIVATE LIMITED",
"SHREE GANESH ELASTOPLAST LIMITED",
"SHREE GANESH FATS PVT LTD",
"SHREE GANESH FIBC PRIVATE LIMITED",
"SHREE GANESH FROZEN FOODS PRIVATE LIMITED",
"SHREE GANESH GRAPHICS PRIVATE LIMITED",
"SHREE GANESH HOME APPLIANCES PRIVATE LIMITED",
"SHREE GANESH INFRAHEIGHTS PRIVATE LIMITED",
"SHREE GANESH JEWELLERS LIMITED",
"SHREE GANESH KRIPA GRANITES PRIVATE LIMITED",
"SHREE GANESH KRUPA POLY CREATIONS PRIVATE LIMITED",
"SHREE GANESH LABOUR LAWS ADVISORS PRIVATE LIMITED",
"SHREE GANESH LOGISTIC PRIVATE LIMITED",
"SHREE GANESH MASALA FOODS PRIVATE LIMITED",
"SHREE GANESH METALIKS LIMITED",
"SHREE GANESH ORNAMENTS PRIVATE LIMITED",
"SHREE GANESH PACKAGING PVT LTD",
"SHREE GANESH PIGMENTS PRIVATE LIMITED",
"SHREE GANESH PRESS N COAT INDUSTRIES PRIVATE LIMITED",
"SHREE GANESH PRINT-FAB PRIVATE LIMITED",
"SHREE GANESH PROCESS EQUIPMENTS PRIVATE LIMITED",
"SHREE GANESH REMEDIES LIMITED",
"SHREE GANESH RETAILS PRIVATE LIMITED",
"SHREE GANESH ROLLER FLOUR MILLS PRIVATE LIMITED",
"SHREE GANESH ROLLING MILLS (INDIA) LIMITED",
"SHREE GANESH ROLLING MILLS PRIVATE LIMITED",
"SHREE GANESH SAHAKARI BANK MARYADIT",
"SHREE GANESH SERVICES",
"SHREE GANESH SOLVEX PRIVATE LIMITED",
"SHREE GANESH SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED",
"SHREE GANESH TECHNO PLAST (I) PRIVATE LIMITED",
"SHREE GANESH TELECOM PRIVATE LIMITED",
"SHREE GANESH TRADING & COMMODITY PRIVATE LIMITED",
"SHREE GANESH VIDHYALAYA HIGHER SECONDARY SCHOOL",
"SHREE GANESH VIDYAMANDIR DATIVALI",
"SHREE GANESHAA CHEMICALS PRIVATE LIMITED",
"SHREE GANESHJI GUMS PRIVATE LIMITED",
"SHREE GANGA FINANCE PRIVATE LIMITED",
"SHREE GANGA JI STONE MILLS PRIVATE LIMITED",
"SHREE GANGA POLYTECH PRIVATE LIMITED",
"SHREE GANGA VENEERS AND PLYBOARD PRIVATE LIMITED",
"SHREE GANGAMAIYA SILK MILLS PRIVATE LIMITED",
"SHREE GANGOUR FOODS INTERNATIONAL LLP",
"SHREE GANIK PAPERS PRIVATE LIMITED",
"SHREE GANPATI AGROTECH PRIVATE LIMITED",
"SHREE GANPATI AUTOWHEELS PRIVATE LIMITED",
"SHREE GANPATI CHARITABLE AND WELFARE TRUST",
"SHREE GANPATI CONDUCTORS PRIVATE LIMITED",
"SHREE GANPATI EMBROIDERY PRIVATE LIMITED",
"SHREE GANPATI ENGLISH SCHOOL",
"SHREE GANPATI GREENCITY DEVELOPERS PRIVATE LIMITED",
"SHREE GANPATI PIPES TRADING PVT LTD",
"SHREE GANPATI PLYCHEM PRIVATE LIMITED",
"SHREE GANPATI RIDHI SIDHI AGRO INDUSTRIES PRIVATE LIMITED",
"SHREE GANPATI SECONDARY SCHOOL",
"SHREE GANPATI SYNTHETICS PRIVATE LIMITED",
"SHREE GARUDA PLANT PRODUCTS PRIVATE LIMITED",
"SHREE GAURI RICE MILL PRIVATE LIMITED",
"SHREE GAUTAM CONSTRUCTION COMPANY LIMITED",
"SHREE GAUTAM LOGISTICS PRIVATE LIMITED",
"SHREE GAYATRI COTTEX ENGINEERS LIMITED",
"SHREE GAYATRI SATYAMEV REALTY PRIVATE LIMITED",
"SHREE GEETA TEXTILE MILLS PRIVATE. LIMITED",
"SHREE GHANSHYAM ALLOYS PRIVATE LIMITED",
"SHREE GHANSHYAM SAREES PRIVATE LIMITED",
"SHREE GHANSHYAMDAS PODDAR VIDYALAYA",
"SHREE GHODEMUKH INFRA PROJECTS PRIVATE LIMITED",
"SHREE GIRAJ SUITINGS PRIVATE LIMITED",
"SHREE GIRDHAR GOPAL ROLLER FLOUR MILLS PRIVATE LIMITED",
"SHREE GIRIRAJ COTSPIN PRIVATE LIMITED",
"SHREE GIRIRAJ EXIM PRIVATE LIMITED",
"SHREE GIRIRAJ INDUSTRIES LIMITED",
"SHREE GIRIRAJ LIFECARE PRIVATE LIMITED",
"SHREE GIRIRAJ METALS PRIVATE LIMITED",
"SHREE GIRIRAJ SULZ FAB PRIVATE LIMITED",
"SHREE GIRIRAJJI AGENCIES PRIVATE LIMITED",
"SHREE GIRISH ASSOCIATES PRIVATE LIMITED",
"SHREE GIRRAJJEE INFRA HEIGHTS PRIVATE LIMITED",
"SHREE GLOBAL TRADEFIN LIMITED",
"SHREE GLOBAL TRADING PRIVATE LIMITED",
"SHREE GNANGANGA SCHOOL",
"SHREE GOBIND PHARMACEUTICALS PRIVATE LIMITED",
"SHREE GOKUL ANAND HOTELS PRIVATE LIMITED",
"SHREE GOLD ART PRIVATE LIMITED",
"SHREE GOLD JEWELS PRIVATE LIMITED",
"SHREE GOPAL KRISHNA CRAFT MILL PRIVATE LIMITED",
"SHREE GOPAL PROTEINS INDIA PRIVATE LIMITED",
"SHREE GOPI ISPAT PRIVATE LIMITED",
"SHREE GOPINATH PAPER MILLS PRIVATE LIMITED",
"SHREE GOPINATH PAPER PRODUCTS PRIVATE LIMITED",
"SHREE GOPINATHJI AGENCIES",
"SHREE GOPINATHJI CARS PRIVATE LIMITED",
"SHREE GOPINATHJI MOTORS PRIVATE LIMITED",
"SHREE GOURI SHANKAR JUTE MILLS LTD",
"SHREE GOVARDHAN METCAST PRIVATE LIMITED",
"SHREE GOVARDHAN STEELS PRIVATE LIMITED",
"SHREE GOVIND ALLOYS PRIVATE LIMITED",
"SHREE GOVIND BUILDNEED PRIVATE LIMITED",
"SHREE GOVIND FOOD PRODUCTS PRIVATE LIMITED",
"SHREE GOVIND RAJ CONSTRUCTIONS PRIVATE LIMITED",
"SHREE GOVIND SHEETGRAH PRIVATE LIMITED",
"SHREE GOVIND TOWN PLANNERS PRIVATE LIMITED",
"SHREE GOVINDA MODERN REALTY",
"SHREE GOVINDA ROADWAYS PRIVATE LIMITED",
"SHREE GOWTHAMEE RICE INDUSTRIES PRIVATE LIMITED",
"SHREE GR EXPORTS PVT LTD",
"SHREE GRAMSEVAK SAHAKARI PATAPEDHI MARYADIT ZIHLA BEED",
"SHREE GRAND AUTOMOTIVES PRIVATE LIMITED",
"SHREE GREEN DEVELOPMENT PRIVATE LIMITED",
"SHREE GRG OILS PRIVATE LIMITED",
"SHREE GUGANS SECONDARY SCHOOL CBSE",
"SHREE GUHAN ENGINEERING PROJECTS PRIVATE LIMITED",
"SHREE GURU AGROTECH PRIVATE LIMITED",
"SHREE GURU INFRACON PRIVATE LIMITED",
"SHREE GURU KRIPA ALLOYS PRIVATE LIMITED",
"SHREE GURU KRIPA CEMENT PRIVATE LIMITED",
"SHREE GURU KRUPA BUILDING SERVICES PRIVATE LIMITED",
"SHREE GURU REALTORS PRIVATE LIMITED",
"SHREE GURUDATTA INDUSTRIES PRIVATE LIMITED",
"SHREE GURUKRUPA SHRADDHA REALITIES PRIVATE LIMITED",
"SHREE GURUKRUPA TRADELINK PRIVATE LIMITED",
"SHREE GURUKRUPA VIDHYA SANKUL",
"SHREE GURUKUL VIDHYAMANDIR SCHOOL",
"SHREE GURUNANAK DEV RICE MILL",
"SHREE GURUPRASAD JEWELLERS PRIVATE LIMITED",
"SHREE H J GAJERA PRIMARY SECONDARY & H SECONDARY ENGLISH SCHOOL",
"SHREE H J HIGHSCHOOL LILAKHA",
"SHREE H N SHUKLA NURSING SCHOOL",
"SHREE HAJARIMAL DYEING AND PRINTING MILLS PRIVATE LIMITED",
"SHREE HALDARDHAR RRATHMIK SHALA",
"SHREE HANS ALLOYS LIMITED",
"SHREE HANS RICE AND GENERAL MILLS",
"SHREE HANSMUKTI VIDHYABHAVAN",
"SHREE HANUMAN ATTA MILLS PRIVATE LIMITED",
"SHREE HANUMAN JUTE MILLS PRIVATE LIMITED",
"SHREE HANUMAN LOHA PRIVATE LIMITED",
"SHREE HANUMAN MOULDERS PRIVATE LIMITED",
"SHREE HANUMAN OIL MILLS LTD",
"SHREE HANUMAN STEEL PRIVATE LIMITED",
"SHREE HANUMAN STEELS & STRUCTURES PRIVATE LIMITED",
"SHREE HANUMAN TRUST",
"SHREE HANUMAN TUBES PVT LTD",
"SHREE HANUMAN WIND-INFRA PRIVATE LIMITED",
"SHREE HANUMANJEE MODERN RICE MILL PRIVATE LIMITED",
"SHREE HARDIK PLATING TECHNOLOGY",
"SHREE HARDOI BABA ROLLER FLOUR MILLS PRIVATE LIMITED",
"SHREE HAREKRISHNA COTTON INDUSTRIES - JAMNAGAR",
"SHREE HARI CHEMICALS EXPORT LIMITED",
"SHREE HARI CORPORATION",
"SHREE HARI DEVELOPERS PRIVATE LIMITED",
"SHREE HARI DIAGNDSTICS PRIVATE LIMITED",
"SHREE HARI EXPORTS",
"SHREE HARI FOOD PRODUCTS PRIVATE LIMITED",
"SHREE HARI GASES PRIVATE LIMITED",
"SHREE HARI IMMIGRATION AND TRAVELS P LIMITED",
"SHREE HARI IMPEX",
"SHREE HARI INFRAPROJECTS PRIVATE LIMITED",
"SHREE HARI JEWELLERS/SEVIKA DIAMOND JEWELLERY",
"SHREE HARI MANUFACTURING PRIVATE LIMITED",
"SHREE HARI PRECISION PRODUCTS PRIVATE LIMITED",
"SHREE HARI RESOURCES PRIVATE LIMITED",
"SHREE HARI SALES PROMOTERS PRIVATE LIMITED",
"SHREE HARI SPINTEX LIMITED",
"SHREE HARI SPONGE PRIVATE LIMITED",
"SHREE HARI TRADELINK PRIVATE LIMITED",
"SHREE HARI VISHNU JEE FOODS PRIVATE LIMITED",
"SHREE HARI YARNS PRIVATE LIMITED",
"SHREE HARIDAS AGRO PRODUCTS LIMITED",
"SHREE HARIDHANA ENERGY PRIVATE LIMITED",
"SHREE HARIKRISHNA HARDWARE PRIVATE LIMITED",
"SHREE HARIOM ENGINEERING COMPANY PRIVATE LIMITED",
"SHREE HARISAR INDUSTRIES PRIVATE LIMITED",
"SHREE HARIVANSH SECURITIES PRIVATE LIMITED",
"SHREE HARSH PERIPHERALS PRIVATE LIMITED",
"SHREE HARSIDDHA PLASTECH PRIVATE LIMITED",
"SHREE HATKESHWARA MOTORS PRIVATE LIMITED",
"SHREE HATKESHWARA TRANSLINES PRIVATE LIMITED",
"SHREE HAYAGREEVAA OIL & GAS PRIVATE LIMITED",
"SHREE HAZARILAL COLD STORAGE PRIVATE LIMITED",
"SHREE HEERA SWEETS PRIVATE LIMITED",
"SHREE HIMALAY CANCER HOSPITAL",
"SHREE HIRA EXIM LIMITED",
"SHREE HOME APPLIANCES & SERVICES PRIVATE LIMITED",
"SHREE HOSPITALITY PRIVATE LIMITED",
"SHREE HOSPITAL'S CRITICARE & TRAUMA CENTER PRIVATE LIMITED",
"SHREE IMAGING PRIVATE LIMITED",
"SHREE IMAGING TECHNOLOGIE PRIVATE LIMITED",
"SHREE INDIA SINO GUMS PRIVATE LIMITED",
"SHREE INDO GUJARAT FERTILIZERS",
"SHREE INDUSTRIAL ADSORBENTS PRIVATE LIMITED",
"SHREE INFO SYSTEM SOLUTIONS PRIVATE LIMITED",
"SHREE INFOSOFT PRIVATE LIMITED",
"SHREE INFRA",
"SHREE INFRACON PRIVATE LIMITED",
"SHREE INFRAGROWTH CONSULTANT PRIVATE LIMITED",
"SHREE INSULATIONS INDIA PRIVATE LIMITED",
"SHREE INTENSIVE CARE UNIT & MEDICAL RESEARCH CENTER PRIVATE LIMITED",
"SHREE INTERNATIONAL VYAPAR PRIVATE LIMITED",
"SHREE IRRIGATION SYSTEMS PRIVATE LIMITED",
"SHREE ISHITA PHARMACEUTICALS PRIVATE LIMITED",
"SHREE IT MANAGEMENT AND SERVICES OPC PRIVATE LIMITED",
"SHREE IT SOLUTIONS PRIVATE LIMITED",
"SHREE J B DHARUKAWALA MAHILA ARTS COLLEGE",
"SHREE J C SHAH PRAKASH HIGH SCHOOL",
"SHREE J K FOODS PVT LTD",
"SHREE J M PATEL SARVAJANIK HIGH SCHOOL DIGENDRANAGAR",
"SHREE J PRINTERS PRIVATE LIMITED",
"SHREE JAGANNATH CARRIERS PRIVATE LIMITED",
"SHREE JAGANNATH ENCLAVE PRIVATE LIMITED",
"SHREE JAGANNATH ENGINEERS PRIVATE LIMITED",
"SHREE JAGANNATH EXPRESSWAYS PRIVATE LIMITED",
"SHREE JAGANNATH FABRICS PRIVATE LIMITED",
"SHREE JAGANNATH IRON FOUNDRY PVT LTD",
"SHREE JAGANNATH LIME & CHEMICALS PRIVATE LIMITED",
"SHREE JAGANNATH PROMOTERS AND DEVELOPERS PRIVATE LIMITED",
"SHREE JAGANNATH SHILPODYOG LTD",
"SHREE JAGANNATH TECHNO-SOLUTIONS PRIVATE LIMITED",
"SHREE JAGANNATH TEMPLE OFFICE PURI",
"SHREE JAGANNATH UDYOG PRIVATE LIMITED",
"SHREE JAGANNATHJI STERLING PRODUCTS PRIVATE LIMITED",
"SHREE JAGDAMBA AGRICO EXPORTS PRIVATE LIMITED",
"SHREE JAGDAMBA COKE INDUSTRIES PRIVATE LIMITED",
"SHREE JAGDAMBA COTTON GINNING AND PRESSING FACTORY",
"SHREE JAGDAMBA DYEING AND PRINTING MILLS PRIVATE LIMITED",
"SHREE JAGDAMBA FLOUR MILLS PRIVATE LIMITED",
"SHREE JAGDAMBA GRAVERS PRIVATE LIMITED",
"SHREE JAGDAMBA KNITS PRIVATE LIMITED",
"SHREE JAGDAMBA RICE MILLS PRIVATE LIMITED",
"SHREE JAGDAMBA TEXTILES PRIVATE LIMITED",
"SHREE JAGDAMBE PAPER MILLS LTD",
"SHREE JAGDISH GEMS & JEWELLERS PRIVATE LIMITED",
"SHREE JAGDISH IMPEX PRIVATE LIMITED",
"SHREE JAGDISH SAREES PRIVATE LIMITED",
"SHREE JAIN HOSPITAL AND RESERCH CENTRE",
"SHREE JAIN TRANSWAYS PRIVATE LIMITED",
"SHREE JAIN YUVAK MANDAL ENGLISH SCHOOL",
"SHREE JAINA RICE AND ESTATES PRIVATE LIMITED",
"SHREE JAINAM EXPORTS PRIVATE LIMITED",
"SHREE JAISAL ELECTRONICS AND INDUSTRIES LIMITED",
"SHREE JALARAM FRAGRANCES PRIVATE LIMITED",
"SHREE JALARAM KRUPA GENERAL AND MATERNITY HOSPITALS PRIVATE LIMITED",
"SHREE JALARAM METALS PRIVATE LIMITED",
"SHREE JALARAM RAGHUKUL SARVAJANIK HOSPITAL",
"SHREE JALARAM SUVARNA MAHAL ORNAMENTS PRIVATE LIMITED",
"SHREE JALARAM TIMBER DEPOT PRIVATE LIMITED",
"SHREE JALARAM WOOD AND PETRO PRODUCTS",
"SHREE JAM HOSIERY WORKS PRIVATE LIMITED",
"SHREE JAY AMBE ENERGY PRIVATE LIMITED",
"SHREE JAY AMBE QUARRY PRIVATE LIMITED",
"SHREE JAY AMBE STEEL YARD PRIVATE LIMITED",
"SHREE JAY DWARKADHISH ENTERPRISE",
"SHREE JAY JAGDAMBA FLANGES PRIVATE LIMITED",
"SHREE JAY JAGDAMBA STAINLESS STEEL LIMITED",
"SHREE JAYA LABORATORIES PRIVATE LIMITED",
"SHREE JAYALAKSHMI POWERCORP LIMITED",
"SHREE JAYAMBE MINECHEM PRIVATE LIMITED",
"SHREE JAYANAND TEXTILES PVT LTD",
"SHREE JAYENDRAPURI ARTS AND SCIENCE COLLEGE, BHARUCH",
"SHREE JAYMATAJI AASHRAMSHADA",
"SHREE JAYSURYA STEELS PRIVATE LIMITED",
"SHREE JEE ASSOCIATES",
"SHREE JEE CELEBRATIONS PRIVATE LIMITED",
"SHREE JEE ELEVATORS INDIA PRIVATE LIMITED",
"SHREE JEE FASHIONLINE PRIVATE LIMITED",
"SHREE JEE FLOUR MILLS PRIVATE LIMITED",
"SHREE JEE GLOBAL PRIVATE LIMITED",
"SHREE JEE JEE GRAIN PRODUCTS PRIVATE LIMITED",
"SHREE JEE LABORATORY PRIVATE LIMITED",
"SHREE JEE MANPOWER CONTRACTORS PRIVATE LIMITED",
"SHREE JEE MANUFACTURING CO. PRIVATE LIMITED",
"SHREE JEE POLYMER",
"SHREE JEEN MATA TRADECOM SERVICES PRIVATE LIMITED",
"SHREE JEEN TRADERS PRIVATE LIMITED",
"SHREE JEENMATA DYEING AND PRINTING MILLS PRIVATE LIMITED",
"SHREE JEWELLERS EXIMP PRIVATE LIMITED",
"SHREE JHANWAR YARNS PVT LTD",
"SHREE JI COIR & FOAM PRIVATE LIMITED",
"SHREE JI COTFAB LIMITED",
"SHREE JINDAL PROTEINS LIMITED",
"SHREE JPM ENTERPRISES PRIVATE LIMITED",
"SHREE KAILA DEVI JI INDUSTRIES (INDIA) PRIVATE LIMITED",
"SHREE KAILAJI ALLOYS PRIVATE LIMITED",
"SHREE KAILASH AGROPRODUCTS PRIVATE LIMITED",
"SHREE KAILASH GRAIN MILLS PRIVATE LIMITED",
"SHREE KAILASH MERCHANTS PRIVATE LIMITED",
"SHREE KALIKUND PARSHWANATHGENERAL HOSPITAL",
"SHREE KALKA AATA CHAKI MILLS PRIVATE LIMITED",
"SHREE KALKA FIBERS PRIVATE LIMITED",
"SHREE KALPANA PERFUMERY WORKS PRIVATE LIMITED",
"SHREE KALPTARU JEWELLERS (I) PRIVATE LIMITED",
"SHREE KALPTARU JEWELS (INDIA) PRIVATE LIMITED",
"SHREE KALYANPURUSH ENGINEERING PRIVATE LIMITED",
"SHREE KAMADGIRI ENTERPRISES PRIVATE LIMITED",
"SHREE KAMAKHYA ROADLINES PRIVATE LIMITED",
"SHREE KAMDHENU AGROBASED INDUSTRIES PRIVATE LIMITED",
"SHREE KAMDHENU ELECTRONICS PRIVATE LIMITED",
"SHREE KAMREJ VIBHAG NAGRIK BACHAT ANE DHIRAN KARNARI SAHAKARI MANDALI LTD",
"SHREE KAMTANATH OILS PRIVATE LIMITED",
"SHREE KANHA STOCK BROKING PRIVATE LIMITED",
"SHREE KANHAIYA JI CONCAST PRIVATE LIMITED",
"SHREE KARANGAR TEXTILES PRIVATE LIMITED",
"SHREE KARNI INDER FABRICS PRIVATE LIMITED",
"SHREE KARNI INFRA PROJECTS AND SOLUTIONS PRIVATE LIMITED",
"SHREE KARNI PVT LTD",
"SHREE KARNI TRADECOM PRIVATE LIMITED",
"SHREE KARTHIK PAPERS LIMITED",
"SHREE KASHI VISHWANATH INFRA PROJECTS PRIVATE LIMITED",
"SHREE KATYAYANI INDUSTRIES PRIVATE LIMITED",
"SHREE KAUSHALYA FIBERS",
"SHREE KAYTEX PROCESSORS PVT LTD",
"SHREE KEDARNATH SUGAR AND AGRO PRODUCTS LIMITED",
"SHREE KESHAV AGRO PRIVATE LIMITED",
"SHREE KESHAV KRUPA IMPEX PRIVATE LIMITED",
"SHREE KESHAV TOWNSHIP PRIVATE LIMITED",
"SHREE KESHOTE INDUSTRIES PRIVATE LIMITED",
"SHREE KHAIRNAR CONSTRUCTION PRIVATE LIMITED",
"SHREE KHANDAL MATAJI MARBLES PRIVATE LIMITED",
"SHREE KHATHU SHYAMJI CEMENT MANUFACTURING PRIVATE LIMITED",
"SHREE KHATU SHYAM COLONIZERS PRIVATE LIMITED",
"SHREE KHATU SHYAMJI METAL INDUSTRIES PRIVATE LIMITED",
"SHREE KHATUSHYAM COTEX PRIVATE LIMITED",
"SHREE KHATUSHYAMJI INFRABUILD PRIVATE LIMITED",
"SHREE KHATUWALA RE ROLLING MILLS PVT LTD",
"SHREE KHETIVAADI UTPANN BAJAR SAMITI KALOL",
"SHREE KHIWAJ TRADERS",
"SHREE KHODAL ELECTRONICS PRIVATE LIMITED",
"SHREE KHODAL STEELS LTD",
"SHREE KHODIYAR ENGINEERS INDIA PRIVATE.LIMITED",
"SHREE KHODIYAR HOSPITAL",
"SHREE KISAN TEXSTYLE MILLS PRIVATE LIMITED",
"SHREE KISANLALJI BORA ENGLISH MEDIUM SCHOOL",
"SHREE KNOWLEDGE SYSTEMS PRIVATE LIMITED",
"SHREE KOTHARI HOSIERY PVT LTD",
"SHREE KREESHNA DETERGENTS PRIVATE LIMITED",
"SHREE KRISHAN CO (MANUFACTURERS) PRIVATE LIMITED",
"SHREE KRISHANA RECYCLING INDIA PRIVATE LIMITED",
"SHREE KRISHNA AGENCY LIMITED",
"SHREE KRISHNA ANALYTICAL SERVICES PRIVATE LIMITED",
"SHREE KRISHNA AND COMPANY",
"SHREE KRISHNA BAKERY HOUSE",
"SHREE KRISHNA BUILDCON PRIVATE LIMITED",
"SHREE KRISHNA CLOD STORAGE PVT LTD",
"SHREE KRISHNA COMPUSOFT PRIVATE LIMITED",
"SHREE KRISHNA CONTROLS PRIVATE LIMITED",
"SHREE KRISHNA COTTON INDUSTRIES",
"SHREE KRISHNA DIAGNOSTICS",
"SHREE KRISHNA ENGINEERS",
"SHREE KRISHNA ENTERPRISES",
"SHREE KRISHNA ENVIRO VENTURE PRIVATE LIMITED",
"SHREE KRISHNA EXPORTS PRIVATE LIMITED",
"SHREE KRISHNA FABRICATORS PVT LTD",
"SHREE KRISHNA FABSPIN PRIVATE LIMITED",
"SHREE KRISHNA HOMES PRIVATE LIMITED",
"SHREE KRISHNA HOSIERY PRIVATE LIMITED",
"SHREE KRISHNA HOSPITAL AGRA PRIVATE LIMITED",
"SHREE KRISHNA INDUCTION PRIVATE LIMITED",
"SHREE KRISHNA INDUSTRIAL RECRUITMENT PRIVATE LIMITED",
"SHREE KRISHNA IRON & STEEL CO. PRIVATE LIMITED",
"SHREE KRISHNA MATERNITY AND CHILD CARE",
"SHREE KRISHNA PACKAGING CO PVT LTD",
"SHREE KRISHNA PAPER MILLS & INDUSTRIES LTD",
"SHREE KRISHNA POLY STRAP PRIVATE LIMITED",
"SHREE KRISHNA POLYMERS PRIVATE LIMITED",
"SHREE KRISHNA PULSES UDHYOG PRIVATE LIMITED",
"SHREE KRISHNA QUARRY PRIVATE LIMITED",
"SHREE KRISHNA RICE MILLS",
"SHREE KRISHNA ROLLER FLOOR MILLS PRIVATE LIMITED",
"SHREE KRISHNA ROLLING MILLS JAIPUR LIMITED",
"SHREE KRISHNA SECAUTO PRIVATE LIMITED",
"SHREE KRISHNA SILK INDUSTRIES PVT LTD",
"SHREE KRISHNA STEELS",
"SHREE KRISHNA STEVEDORES PRIVATE LIMITED",
"SHREE KRISHNA STRUCTURES PVT LTD",
"SHREE KRISHNA SUDHA TRADERS PRIVATE LIMITED",
"SHREE KRISHNA SULPHITE PRIVATE LIMITED",
"SHREE KRISHNA SULZ PRIVATE LIMITED",
"SHREE KRISHNA TECHMECH PRIVATE LIMITED",
"SHREE KRISHNA TIMBER CO PRIVATE LIMITED",
"SHREE KRISHNA TOURISM PRIVATE LIMITED",
"SHREE KRISHNA ULTRAMARINE PIGMENTS PRIVATE LIMITED",
"SHREE KRISHNA WOOLLEN MILLS PRIVATE LIMITED",
"SHREE KRISHNAKESHAV LABORATORIES LIMITED",
"SHREE KRISHNAM SAREES",
"SHREE KRISHNAM YRV BUILDCON PRIVATE LIMITED",
"SHREE KRISHNANAND INFRASTRUCTURE AND DEVELOPERS PRIVATE LIMITED",
"SHREE KRUPA AUTOMATION SYSTEMS PRIVATE LIMITED",
"SHREE KRUPA SYSTEMS PRIVATE LIMITED",
"SHREE KSHETRAPAL AGRO RESOURCES PRIVATE LIMITED",
"SHREE KUBER VENTURES PRIVATE LIMITED",
"SHREE KULSWAMI CO-OP. CREDIT SOCIETY LTD",
"SHREE KUNDAN COTTONS PRIVATE LIMITED",
"SHREE KUNJ BIHARIJI INFRATECH PRIVATE LIMITED",
"SHREE KUTCHHI BHANUSHALI SEVA SAMAJ TRUST",
"SHREE KUTCHI LEVA PATEL SAMAJ FARMER PRODUCER COMPANY LIMITED",
"SHREE L L A MEHTA KANYA VIDHYALAYA LALPUR",
"SHREE L R TIWARI DEGREE COLLEGE OF ARTS COMMERCE & SCIENCE",
"SHREE LABH DHATU TRADERS PRIVATE LIMITED",
"SHREE LADDU GOPALAN INFRASTRUCTURE PRIVATE LIMITED",
"SHREE LAKHI METALS AND STEELS PRIVATE LIMITED",
"SHREE LAKSHMI AGRI-FOODS PRIVATE LIMITED",
"SHREE LAKSHMI NARAYAN SUGAR INDUSTRIES PRIVATE LIMITED",
"SHREE LALATESHWARI BUILDWELL PRIVATE LIMITED",
"SHREE LALITA MULTISERVICES PRIVATE LIMITED",
"SHREE LAM CRAFT PRIVATE LIMITED",
"SHREE LAMIPACK PRIVATE LIMITED",
"SHREE LAP MULTIVERSE PRIVATE LIMITED",
"SHREE LAVKUSH PROCESSORS PRIVATE LIMITED",
"SHREE LAXMI ASSOCIATES PRIVATE LIMITED",
"SHREE LAXMI AYAT & NIRYAT PVT LTD",
"SHREE LAXMI FASHIONS PRIVATE LIMITED",
"SHREE LAXMI GLOBAL LOGISTICS PRIVATE LIMITED",
"SHREE LAXMI HABITAT PRIVATE LIMITED",
"SHREE LAXMI IRON & STEEL WORKS PVT LTD",
"SHREE LAXMI POLYSTOCK PRIVATE LIMITED",
"SHREE LAXMI PUJA FASHION PRIVATE LIMITED",
"SHREE LAXMI REFRIGERATION PRIVATE LIMITED",
"SHREE LAXMI VENTURE PRIVATE LIMITED",
"SHREE LAXMI WOOD INDUSTRIES",
"SHREE LAXMI WOODEN FURNISHERS AND INTERIORS PRIVATE LIMITED",
"SHREE LAXMIKRUPA TEXTILES PRIVATE LIMITED",
"SHREE LAXMINARAYAN AUTOMOTIVE PRIVATE LIMITED",
"SHREE LAXMINARAYAN SYNTHETICS PRIVATE LIMITED",
"SHREE LEASING AND FINANCE LTD",
"SHREE LIFE SCIENCES PRIVATE LIMITED",
"SHREE LIFE-CARE PRIVATE LIMITED",
"SHREE LINGRAJ FEEDS LIMITED.",
"SHREE LOGISTIC SERVICES",
"SHREE LOGISTICS PRIVATE LIMITED",
"SHREE LOKENATH LOGISTICS PRIVATE LIMITED",
"SHREE LTC AGRO SALES LIMITED",
"SHREE LTC EXPORT INDIA PRIVATE LIMITED",
"SHREE M B TIN CONTAINERS PRIVATE LIMITED",
"SHREE M.L. CASTINGS PRIVATE LIMITED",
"SHREE M.T.K.TEXTILES PRIVATE LIMITED",
"SHREE MAA BAMLESHWARI INFRASTRUCTURE PRIVATE LIMITED",
"SHREE MAA BHAGWATI DWELLINGS PRIVATE LIMITED",
"SHREE MAA DURGA FOOD PRODUCTS PRIVATE LIMITED",
"SHREE MAA GAYATRI CONSTRUCTION PRIVATE LIMITED",
"SHREE MAA KALI ENTERPRISES PRIVATE LIMITED",
"SHREE MAA MULTICHEM PRIVATE LIMITED",
"SHREE MAA ROLL WRAP PRIVATE LIMITED",
"SHREE MAATA HOTEL PRIVATE LIMITED",
"SHREE MADHAV AGENCIES PRIVATE LIMITED",
"SHREE MADHAV SOLVEXTRACTS PVT LTD",
"SHREE MADHAVRAO BHAGWAT HIGH SCHOOL & JUNIOR COLLEGE",
"SHREE MAGNETS PRIVATE LIMITED",
"SHREE MAHABALI EXPRESS PRIVATE LIMITED",
"SHREE MAHABIR FOODS LTD",
"SHREE MAHABIR INDUSTRIES PRIVATE LIMITED",
"SHREE MAHABIR MODERN AGRO MILLS PRIVATE LIMITED",
"SHREE MAHABIR UDYOG TIMBER & PLY PRIVATE LIMITED",
"SHREE MAHADEO COTTON MILLS LIMITED",
"SHREE MAHADEV TEXFAB PRIVATE LIMITED",
"SHREE MAHADEV TRADERS PRIVATE LIMITED",
"SHREE MAHADEVJI RICE MILLS PRIVATE LIMITED",
"SHREE MAHAKALI ENTERPRISES PRIVATE LIMITED",
"SHREE MAHAKALI SAREES PRIVATE LIMITED",
"SHREE MAHALAKSHMI INVESTMENT AND PROPERTY CO PVT LTD",
"SHREE MAHALAXMI ENTERPRISES",
"SHREE MAHALAXMI HIMGHAR PRIVATE LIMITED",
"SHREE MAHALAXMI KRUPA SERVICES PRIVATE LIMITED",
"SHREE MAHALAXMI MOVERS PRIVATE LIMITED",
"SHREE MAHALAXMI PSYLLIUM PRIVATE LIMITED",
"SHREE MAHAMAYA JEWELLERS PRIVATE LIMITED",
"SHREE MAHARANI PLASTECH INDIA PRIVATE LIMITED",
"SHREE MAHASAGAR IMPEX PRIVATE LIMITED",
"SHREE MAHAVEER CONSULTANCY",
"SHREE MAHAVEER PHARMA-TECH AND DRUGS PRIVATE LIMITED",
"SHREE MAHAVEERJI POLYFAB PRIVATE LIMITED",
"SHREE MAHAVIR EDUCATION TRUST",
"SHREE MAHAVIR EXPRESS SERVICES PRIVATE LIMITED",
"SHREE MAHAVIR HEALTH AND MEDICAL RELIEF SOCIETY",
"SHREE MAHAVIR JAIN HOSPITAL & SHREE PRATAP J ASHAR CARDIAC CENTRE",
"SHREE MAHAVIR METALCRAFT PRIVATE LIMITED",
"SHREE MAHAVIR ROLL-TECH LIMITED",
"SHREE MAHAVIR SAHAKARI BANK LTD JALGAON",
"SHREE MAHAVIR SECURE LOGISTICS PRIVATE LIMITED",
"SHREE MAHAVIR UDYOG PRIVATE LIMITED",
"SHREE MAHAVIR WIRE AND METALS (GUJARAT) PRIVATE LIMITED",
"SHREE MAHAVIRA BUILDWELL PRIVATE LIMITED",
"SHREE MAHAVIRSINH DAIRY PRIVATE LIMITED",
"SHREE MAHESH INDUSTRIES LIMITED",
"SHREE MAHESH SAREES PRIVATE LIMITED",
"SHREE MAIRDH KSHATRIYA SABHA SWARNKAR BHAWAN",
"SHREE MAITREY PRINTECH PRIVATE LIMITED",
"SHREE MAKAR ENGINEERING PRIVATE LIMITED",
"SHREE MALAIAMMAN ENERGY INDIA PRIVATE LIMITED",
"SHREE MALANI FOAMS PRIVATE LIMITED",
"SHREE MALLA BABA EXIM PRIVATE LIMITED",
"SHREE MAMTA MILKDAIRY PRIVATE LIMITED",
"SHREE MANGAL ABHUSHAN PRIVATE LIMITED",
"SHREE MANGAL JEWELS PRIVATE LIMITED",
"SHREE MANGAL MURTEE TRADEX PRIVATE. LIMITED.",
"SHREE MANGAL PROTEINS LIMITED",
"SHREE MANGALAM CORPORATION PRIVATE LIMITED",
"SHREE MANGALAM SALES & AGENCIES PRIVATE LIMITED",
"SHREE MANGLAM BUILDCON (I) PRIVATE LIMITED",
"SHREE MANIPUR ROLLER FLOUR MILLS PVT LTD",
"SHREE MANJU KRIPA HOTELS PRIVATE LIMITED",
"SHREE MANSA LIVESTOCK AND AGRO DEVELOPMENT SERVICES PRIVATE LIMITED",
"SHREE MANSINGKA PROJECTS LIMITED",
"SHREE MARBLE IMPEX PVT LTD",
"SHREE MARIKAMBA MICRO FINANCE PRIVATE LIMITED",
"SHREE MARKETING PVT LTD",
"SHREE MARU FABRICS PRIVATE LIMITED",
"SHREE MARU TRADELINK LIMITED",
"SHREE MARUDHAR KESHRI SAREES PRIVATE LIMITED",
"SHREE MARUTI ASSOCIATES PVT. LTD",
"SHREE MARUTI COURIER SERVICES PRIVATE LIMITED",
"SHREE MARUTI INTEGRATED LOGISTICS LIMITED",
"SHREE MARUTI NANDAN PHARMACEUTICALS PRIVATE LIMITED",
"SHREE MARUTINANDAN LOGISTICS PRIVATE LIMITED",
"SHREE MARUTINANDAN TUBES LIMITED",
"SHREE MASTER FOODS PRIVATE LIMITED",
"SHREE MATANGI COOLING TOWERS PRIVATE LIMITED",
"SHREE MATANGI TRANSPORT PRIVATE LIMITED",
"SHREE MATANGI WOVEN SACK PRIVATE LIMITED",
"SHREE MATHA MARINE PRIVATE LIMITED",
"SHREE MEDICAL AGENCIES PRIVATE LIMITED",
"SHREE MEENA CREATION PRIVATE LIMITED",
"SHREE MEHTA CHEMICALS (INDORE) PRIVATE LIMITED",
"SHREE MEHTA PAPERS PRIVATE LIMITED",
"SHREE METALLOYS LIMITED",
"SHREE METALS (MUJBI ) PRIVATE LIMITED",
"SHREE MITHAI PRIVATE LIMITED",
"SHREE MODI'S NAVNIRMAN PRIVATE LIMITED",
"SHREE MOHAN POLYPLAST PRIVATE LIMITED",
"SHREE MOHINEE PULSES AND AGROTECH PRIVATE LIMITED",
"SHREE MOMAI ELECTRICALS INDIA PRIVATE LIMITED",
"SHREE MOMAI ENGINEERING WORKS",
"SHREE MONOLITHICS PRIVATE LIMITED",
"SHREE MORBI NAGRIK SAHAKARI BANK LTD",
"SHREE MORYA INFRASOLUTIONS & VENTURES PRIVATE LIMITED",
"SHREE MORYA NIRMITI PRIVATE LIMITED",
"SHREE MOTHER CAPFIN AND SECURITIES PRIVATE LIMITED",
"SHREE MOTHER PLAST INDIA PRIVATE LIMITED",
"SHREE MOTILAL NEHRU INTER COLLEGE",
"SHREE MOTOCORP INDIA PRIVATE LIMITED",
"SHREE MOTORS AGENCIES PRIVATE LIMITED",
"SHREE MOTORS PRIVATE LIMITED",
"SHREE MULTISPECIALIST HOSPITAL AND ICU",
"SHREE MULTISPECIALITY HOSPITAL",
"SHREE MUMBADEVI TEXTILE MILLS PRIVATE LIMITED",
"SHREE MURAGAN EDUCATIONAL TRUST",
"SHREE MURUGAN EDUCATIONAL TRUST",
"SHREE MUSHKAN POLYPLAST PRIVATE LIMITED",
"SHREE NAGAI DEVI SUGAR PRIVATE LIMITED",
"SHREE NAGANI MERCANTILE PRIVATE LIMITED",
"SHREE NAGANI SILK MILLS PRIVATE LIMITED",
"SHREE NAGESHWAR PAPERS LIMITED",
"SHREE NAGNECHA TEXTILE PRIVATE LIMITED",
"SHREE NAIVEDYA FINCOM PRIVATE LIMITED",
"SHREE NAKODA GLOBAL LIMITED",
"SHREE NAKODA GLOBAL PRIVATE LIMITED",
"SHREE NAKODA INDUSTRIES PRIVATE LIMITED",
"SHREE NAKODA INFRASTEEL PRIVATE LIMITED",
"SHREE NAKODA INTERIORS",
"SHREE NAKODA ISPAT AND POWER PRIVATE LIMITED",
"SHREE NAKODA ISPAT LIMITED.",
"SHREE NAKODA KARNA BADHIR VIDYALAYA",
"SHREE NAKODA PIPE IMPEX PRIVATE LIMITED",
"SHREE NAKODA SPINNERS PRIVATE LIMITED",
"SHREE NAKODA SYNTHETICS PRIVATE LIMITED",
"SHREE NAKODA TEXFAB PRIVATE LIMITED",
"SHREE NAKODAJI FURNITURES PRIVATE LIMITED",
"SHREE NAMAN BUILDERS PRIVATE LIMITED",
"SHREE NAMAN DEVELOPERS PRIVATE LIMITED",
"SHREE NAMAN HEALTHCARE PRIVATE LIMITED",
"SHREE NAMAN SECURITIES AND FINANCE PRIVATE. LIMITED.",
"SHREE NAMOKAR INTERNATIONAL PRIVATE LIMITED",
"SHREE NANAK FERRO ALLOYS PRIVATE LIMITED",
"SHREE NANDAN COURIER LIMITED",
"SHREE NANDAN KANAN AGRO PRODUCT PRIVATE LIMITED",
"SHREE NANDESHWAR PROCESSORS PRIVATE LIMITED",
"SHREE NANDHI SILKS PRIVATE LIMITED",
"SHREE NANDINEE FIBRE GLASS ENGINEERS PRIVATE LIMITED",
"SHREE NARADSWAMI VIDYAMANDIR BEED",
"SHREE NARAYAN CORPORATION",
"SHREE NARAYAN COTFAB PRIVATE LIMITED",
"SHREE NARAYAN DYEING & PRINTING MILLS",
"SHREE NARAYAN GLOBAL SCHOOL",
"SHREE NARAYAN SILK HOUSE PRIVATE LIMITED",
"SHREE NARAYAN STORE PRIVATE LIMITED",
"SHREE NARAYAN TIMBER COMPANY PRIVATE LIMITED",
"SHREE NARAYAN YARNS INDUSTRIES PRIVATE LIMITED",
"SHREE NARAYANA CULTURAL MISSION",
"SHREE NARAYANI ENCLAVE PRIVATE LIMITED",
"SHREE NARAYANI HEALTHCARE PRIVATE LIMITED",
"SHREE NARHARI PARIKH ASHRAMSHALA",
"SHREE NARSHINGHA COLD STORAGE PVT LTD",
"SHREE NASIK GOODS TRANSPORT COMPANY PRIVATE LIMITED",
"SHREE NATH CARD BOARD PRIVATE LIMITED",
"SHREE NATH DECOR (OPC) PRIVATE LIMITED",
"SHREE NATH FABCARE PRIVATE LIMITED",
"SHREE NATH JEE BAKERS PRIVATE LIMITED",
"SHREE NATH JI AGRO PRODUCTS PRIVATE LIMITED",
"SHREE NATH JI ENTERPRISES",
"SHREE NATH LIFE SCIENCE PRIVATE LIMITED",
"SHREE NATH LUMBER PRODUCTS PRIVATE LIMITED",
"SHREE NATH SHARES PRIVATE LIMITED",
"SHREE NATH SYNCOT (INDIA) PRIVATE LIMITED",
"SHREE NATHJI PLYWOOD PRIVATE LIMITED",
"SHREE NATHKRIPA FOODS PRIVATE LIMITED",
"SHREE NAVEEN SILK MILLS PRIVATE LIMITED",
"SHREE NAVKAR REALINFRA PRIVATE LIMITED",
"SHREE NAVKAR TEX CREATIONS",
"SHREE NAVRANG TELELINK PRIVATE LIMITED",
"SHREE NAVSHARJAN VIKAS TRUST",
"SHREE NEEL KAMAL DECO HOME INDIA PRIVATE LIMITED",
"SHREE NEELACHALA MINING AND MINERALS PRIVATE LIMITED",
"SHREE NEELKANTH BIRI WORKS PRIVATE LIMITED",
"SHREE NEELKANTH STONE SUPPLIERS PRIVATE LIMITED",
"SHREE NEELKANTHESHWAR INFRA PRIVATE LIMITED",
"SHREE NIDHI CONCEPT REALTORS PRIVATE LIMITED",
"SHREE NIDHI SECURE PRINT PRIVATE LIMITED",
"SHREE NIDHI TEXLENE PRIVATE LIMITED",
"SHREE NIDHIMAN BUSINESS PRIVATE LIMITED",
"SHREE NIKETAN APPARELS LIMITED",
"SHREE NIKETAN CREATION PRIVATE LIMITED",
"SHREE NIKETAN PATASALA",
"SHREE NIKETAN SAREES PRIVATE LIMITED",
"SHREE NIKETAN SCHOOLS",
"SHREE NILKANTH ALLOYS PRIVATE LIMITED",
"SHREE NILPARNA ASHAR SHALA KHANDA",
"SHREE NIRMAL COMMERCIAL LIMITED",
"SHREE NIRMAL FABRICS PVT LTD",
"SHREE NIRMAL TRADELINK PRIVATE LIMITED",
"SHREE NIRMAL VENTURES PRIVATE LIMITED",
"SHREE NIRMAN LTD",
"SHREE NIWAS TEXTILES PRIVATE LIMITED",
"SHREE NM ELECTRICALS LIMITED",
"SHREE NURSING HOME JANJGIR",
"SHREE NURSINGSAHAY MUDUNGOPAL ELECTRIC CO PVT LTD",
"SHREE NURSINGSAHAY MUDUNGOPAL ENGINEERS PRIVATE LIMITED",
"SHREE O V SHETH & M O SHETH VIDHYALAYA",
"SHREE OFFICE AUTOMATION SOLUTIONS LLP",
"SHREE OFFICE SOLUTIONS PRIVATE LIMITED",
"SHREE OILS AND FATS (I) PRIVATE LIMITED",
"SHREE OJAS SYSTEM & TECHINFRA PRIVATE LIMITED",
"SHREE OM METALS PRIVATE LIMITED",
"SHREE OM MILK FOODS PRIVATE LIMITED",
"SHREE OM RICETECH PRIVATE LIMITED",
"SHREE OM ROLLING MILLS PRIVATE LIMITED",
"SHREE OM SAI VETERINARY SALES SERVICES PRIVATE LIMITED",
"SHREE OM SHIRTINGS PRIVATE LIMITED",
"SHREE OMKAR CONSTRUCTION COMPANY",
"SHREE OMKAR INFOCOM PRIVATE LIMITED",
"SHREE OMKAR JEWELLERS PRIVATE LIMITED",
"SHREE ORGANIC CHEM INDUSTRIES PVT. LTD.",
"SHREE ORGANO CHEMICALS (AHD) PRIVATE LIMITED",
"SHREE OSFM E-MOBILITY LIMITED",
"SHREE OSTWAL BUILDERS LIMITED",
"SHREE OZONE ENGINEERING PRIVATE LIMITED",
"SHREE P V MODI PRIMARY SCHOOL",
"SHREE P V MODI SCHOOL",
"SHREE PACETRONIX LIMITED",
"SHREE PACK CONTAINERS PRIVATE LIMITED",
"SHREE PACKERS (MP) PRIVATE LIMITED",
"SHREE PADMA MERCHANTS PVT LTD",
"SHREE PADMANABHAM JEWELS & INFRA PRIVATE LIMITED",
"SHREE PADMAVATI ENGINEERS (INDIA) PRIVATE LIMITED",
"SHREE PADMAVATI MARBLES PRIVATE LIMITED",
"SHREE PADMAVATI METIM INDIA PRIVATE LIMITED",
"SHREE PAHARIMATA CREATIONS PRIVATE LIMITED",
"SHREE PAHARIMATA ENTERPRISES PRIVATE LIMITED",
"SHREE PAHARIMATA EXPORTS PRIVATE LIMITED",
"SHREE PAL CLUTCH PRIVATE LIMITED",
"SHREE PANCHA RATNA HOTELS PVT LTD",
"SHREE PANDHARI INFRASTRUCTURES PRIVATE LIMITED",
"SHREE PAPER COMPANY PRIVATE LIMITED",
"SHREE PAR FRAGRANCE PRIVATE LIMITED",
"SHREE PARAM HANS CREATIONS PRIVATE LIMITED",
"SHREE PARAMHANS GASES PVT LTD",
"SHREE PARAS STEELFAB PRIVATE LIMITED",
"SHREE PARASHNATH RE-ROOLLING MILLS LIMITED",
"SHREE PARASNATH MARKETIERS PRIVATE LIMITED",
"SHREE PARASNATH TIMBER PRIVATE LIMITED",
"SHREE PARINDA CHAIN PRIVATE LIMITED",
"SHREE PARIVAHAN LIMITED",
"SHREE PARIYOJNA NIRMAN PRIVATE LIMITED",
"SHREE PARMATAMA CHAND BHANDARI HOSPITAL AND RESEARCH CENTRE",
"SHREE PARMESHWAR STEELS PRIVATE LIMITED",
"SHREE PARSHWA ASSOCIATES PRIVATE LIMITED",
"SHREE PARSHWA STONE PVT. LTD.",
"SHREE PARSHWANATH CASHEW INDUSTRIES PRIVATE LIMITED",
"SHREE PARSHWANATH TRADING (INDIA) PRIVATE LIMITED",
"SHREE PARTH INFRACORP LIMITED",
"SHREE PARVATHI TEX (INDIA) PRIVATE LIMITED",
"SHREE PASHUPATI ACCESSORIES PRIVATE LIMITED",
"SHREE PATEL DAIRY MILK & FOOD PRODUCT PRIVATE LIMITED",
"SHREE PATEL K J PARIVAR ADARSH VIDHYALAYA",
"SHREE PATESHWARI ELECTRICAL AND ASSOCIATED INDUSTRIES PRIVATE LIMITED",
"SHREE PATNI LOGISTICS PRIVATE LIMITED",
"SHREE PAUL & PAUL MARKETING PRIVATE LIMITED",
"SHREE PAWAN PUTRA ROLLER FLOUR MILLS PRIVATE LIMITED",
"SHREE PEETAMBRA COLD STORAGE PRIVATE LIMITED",
"SHREE PESTICIDES PVT. LTD",
"SHREE PHARMA",
"SHREE PHATECHAND KEWANI SINDHI HINDI GIRLS HIGH SCHOOL AND JR COLLEGE",
"SHREE PITAMBRA INFRAZONE PRIVATE LIMITED",
"SHREE PLA PRIVATE LIMITED",
"SHREE PLAN YOUR JOURNEY PRIVATE LIMITED",
"SHREE PLAST INDUSTRY",
"SHREE PLASTICS PRIVATE LIMITED",
"SHREE PODDAR TEXPORT PRIVATE LIMITED",
"SHREE POLY FILMS PRIVATE LIMITED",
"SHREE POLYESTER INDUSTRIES PRIVATE LIMITED",
"SHREE POLYMERS",
"SHREE PONNI LEAD ALLOY PRIVATE LIMITED",
"SHREE PORCELLANO PRIVATE LIMITED",
"SHREE PORTA BUILDERS PRIVATE LIMITED",
"SHREE PORWAL & SONS PRIVATE LIMITED",
"SHREE POWER ENTERPRISES PRIVATE LIMITED",
"SHREE PRAGATI FOUNDATION HIRA MONGI NAVNEET HOSPITAL",
"SHREE PRAGYA TECHPACK PRIVATE LIMITED",
"SHREE PRAKASH IMPEX PRIVATE LIMITED",
"SHREE PRAKASH PRASHAD RE-ROLLING PRIVATE LIMITED",
"SHREE PRAKASH TEXTILES GUJ. PRIVATE LIMITED",
"SHREE PRATHMESH JEWELLERS PRIVATE LIMITED",
"SHREE PRAYAG AIR CONTROLS PRIVATE LIMITED",
"SHREE PRE-FAB STEELS PRIVATE LIMITED",
"SHREE PRESSING PRIVATE LIMITED",
"SHREE PRESTRESS CONCRETE PRODUCTS PRIVATE LIMITED",
"SHREE PRINTWELL OFFSET PRIVATE LIMITED",
"SHRI PRITHVI ALLOYS PRIVATE LIMITED",
"SHREE PRITHVI IRON MILLS PRIVATE LIMITED",
"SHREE PROTEINS PRIVATE LIMITED",
"SHREE PS HR CONSULTANTS PRIVATE LIMITED",
"SHREE PSP FERRO ALLOYS PRIVATE LIMITED",
"SHREE PUJA OVERSEAS PRIVATE LIMITED",
"SHREE PUSHKAR CHEMICAL FERTILIZER LIMITED",
"SHREE PUSHKAR CHEMICALS AND FERTILISERS LIMITED",
"SHREE PUSHP MOTORS PRIVATE LIMITED",
"SHREE R N PATEL HIGH SCHOOL TAKHTAGADH",
"SHREE R R LAHOTI SCIENCE COLLEGE MORSHI AMRAVATI",
"SHREE R.N. METALS INDIA PRIVATE LIMITED",
"SHREE RADHA GOVIND AGRO INDUSTRIES",
"SHREE RADHA KRISHNA COTSYAN (P) LTD",
"SHREE RADHA KRISHNA VINIMAY PRIVATE LIMITED",
"SHREE RADHA RAMAN PROCESSORS PRIVATE LIMITED",
"SHREE RADHA SERVICES PRIVATE LIMITED",
"SHREE RADHA TRADEX PRIVATE LIMITED",
"SHREE RADHA VALLABH EXIM PRIVATE LIMITED",
"SHREE RADHA VALLABH VELVETS PRIVATE LIMITED",
"SHREE RADHAKRISHNA ALLOYS PRIVATE LIMITED",
"SHREE RADHAKRISHNA ORNAMENTS PRIVATE LIMITED",
"SHREE RADHAKRISHNA SALTS PRIVATE LIMITED",
"SHREE RADHAKRISHNA WHEAT PRODUCTS PRIVATE LIMITED",
"SHREE RADHALAKSHMI COTTON PRIVATE LIMITED",
"SHREE RADHALAKSHMI GREEN ENERGY PRIVATE LIMITED",
"SHREE RADHAMOHAN FABRICS PRIVATE LIMITED",
"SHREE RADHARAMAN STONE CRUSHER PRIVATE LIMITED",
"SHREE RADHAY MOULDING INDUSTRIES PRIVATE LIMITED",
"SHREE RADHE DAIRY FARM & FOODS LIMITED",
"SHREE RADHE HYGIENE PRODUCTS PRIVATE LIMITED",
"SHREE RADHE JEWELLERS PRIVATE LIMITED",
"SHREE RADHE KRUPA SAREES PRIVATE LIMITED",
"SHREE RADHE WORLDWIDE PRIVATE LIMITED",
"SHREE RADHEKRISHNA DIAMOND PRIVATE LIMITED",
"SHREE RADHEKRISHNA EXTRUSIONS PRIVATE LIMITED",
"SHREE RADHEKRUSHNA GINNING AND PRESSING PRIVATE LIMITED.",
"SHREE RADHEY ENTERPRISES",
"SHREE RADHEY FURNITURES PRIVATE LIMITED",
"SHREE RADHEY GOBIND INDUSTRIES PRIVATE LIMITED",
"SHREE RADHEY GOBIND INTERNATIONAL PHARMACEUTICALS PRIVATE LIMITED",
"SHREE RADHEY GOVIND FELTS PRIVATE LIMITED",
"SHREE RADHEY INFRALOGISTICS INDIA PRIVATE LIMITED",
"SHREE RADHEY KRISHAN DHAM ESTATE PRIVATE LIMITED",
"SHREE RADHEY KRISHNA SPICES PRIVATE LIMITED",
"SHREE RADHEY METACAST PRIVATE LIMITED",
"SHREE RADHEY RADHEY ISPAT PRIVATE LIMITED",
"SHREE RADHEYSHYAM SYN- FAB PRIVATE LIMITED",
"SHREE RADHIKA RESINS PRIVATE LIMITED",
"SHREE RADHIKA TRADEIMPEX PRIVATE LIMITED",
"SHREE RAGAVENTHIRA ELECTRO EQUIPMENTS PRIVATE LIMITED",
"SHREE RAGHANI TRADELINK SERVICES PRIVATE LIMITED",
"SHREE RAGHUKUL TEXPRINTS PRIVATE LIMITED",
"SHREE RAGHUNATH ROLLER FLOUR MILLS PRIVATE LIMITED",
"SHREE RAGHUPATI STONEX PRIVATE LIMITED",
"SHREE RAGHUPATI TRADING PRIVATE LIMITED",
"SHREE RAGHUVEER SPINNING MILL PRIVATE LIMITED",
"SHREE RAGHUVIR AGRO PRODUCT PRIVATE LIMITED",
"SHREE RAHUL FLOUR MILLS PVT LTD",
"SHREE RAJ BIOFUELS PRIVATE LIMITED",
"SHREE RAJ CASTECH PRIVATE LIMITED",
"SHREE RAJ GURU FOILS",
"SHREE RAJ INTERNATIONAL PVT. LTD.",
"SHREE RAJ LAMICOAT PRIVATE LIMITED",
"SHREE RAJ METALLOYS PVT LTD",
"SHREE RAJ NIDHI ADARSH ENTERPRISES PRIVATE LIMITED",
"SHREE RAJ SALT AND CHEMICAL WORKS PRIVATE LIMITED",
"SHREE RAJA RAJESHWARI CATERING PRIVATE LIMITED",
"SHREE RAJARAM PRINTS PRIVATE LIMITED",
"SHREE RAJESHWARANAND PAPER MILLS LIMITED",
"SHREE RAJESHWARI SPECIALTY CHEM PRIVATE LIMITED",
"SHREE RAM ASHIANA PRIVATE LIMITED",
"SHREE RAM AUTOMOBILE",
"SHREE RAM AVTAR FRUIT COMPANY(INDIA) PRIVATE LIMITED",
"SHREE RAM BIO STARCH POLYMERS PRIVATE LIMITED",
"SHREE RAM BRINE CHEM PRIVATE LIMITED",
"SHREE RAM CARGO PRIVATE LIMITED",
"SHREE RAM CATERING & ALLIED SERVICES PRIVATE LIMITED",
"SHREE RAM CHANDRA (INDIA) FOODS PRIVATE LIMITED",
"SHREE RAM CHEMICALS INDUSTRIES",
"SHREE RAM COLLOIDS PRIVATE LIMITED",
"SHREE RAM CONCRETE PRIVATE LIMITED",
"SHREE RAM COTTEX INDUSTRIES PRIVATE LIMITED",
"SHREE RAM COTTON INDUSTRIES",
"SHREE RAM DESIGNS PRIVATE LIMITED",
"SHREE RAM ELECTROCAST (JHARKHAND) PRIVATE LIMITED",
"SHREE RAM ENTERPRISES PRIVATE LIMITED",
"SHREE RAM EQUITECH PRIVATE LIMITED",
"SHREE RAM GUM CHEMICALS PRIVATE LIMITED",
"SHREE RAM GUMS PRIVATE LIMITED",
"SHREE RAM HYDROCOLLOIDS PRIVATE LIMITED",
"SHREE RAM INDIA GUMS LIMITED",
"SHREE RAM INDUSTRIES",
"SHREE RAM INFOSYSTEMS PRIVATE LIMITED",
"SHREE RAM INFRA CARE PRIVATE LIMITED",
"SHREE RAM INFRA NIRMAN PRIVATE LIMITED",
"SHREE RAM INTERNATIONAL SCHOOL",
"SHREE RAM IRON AND STEELS PRIVATE LIMITED",
"SHREE RAM ISPAT & POWER PRIVATE LIMITED",
"SHREE RAM JANKI CORRUGATORS PRIVATE LIMITED",
"SHREE RAM KRISHNA TEXTILE PRIVATE LIMITED",
"SHREE RAM LIME PRODUCTS PRIVATE LIMITED",
"SHREE RAM MACHINO-FABRIK PRIVATE LIMITED",
"SHREE RAM MEASUREMENT TECHNOLOGIES PRIVATE LIMITED",
"SHREE RAM MINERALS PRIVATE LIMITED",
"SHREE RAM MINTECH PRIVATE LIMITED",
"SHREE RAM MURTI ICE AND COLD STORAGE PRIVATE LIMITED",
"SHREE RAM NATURAL POLYMERS PRIVATE LIMITED",
"SHREE RAM NEURO CENTRE",
"SHREE RAM OXY-GAS PRIVATE LIMITED",
"SHREE RAM PLASTOMOULDING PRIVATE LIMITED",
"SHREE RAM POLYSACKS PRIVATE LIMITED",
"SHREE RAM PRODUCTS PRIVATE LIMITED",
"SHREE RAM PULSE MILLS",
"SHREE RAM RESINS PRIVATE LIMITED",
"SHREE RAM ROYAL PARADISE",
"SHREE RAM SPONGE AND STEELS PRIVATE LIMITED",
"SHREE RAM TEXO FAB PRIVATE LIMITED",
"SHREE RAM TEXTILE MILLS PRIVATE LIMITED",
"SHREE RAM TRAVELS PRIVATE LIMITED",
"SHREE RAM TWISTEX PRIVATE LIMITED",
"SHREE RAM TWITEX PRIVATE. LIMITED.",
"SHREE RAM VESSEL SCRAP PRIVATE LIMITED",
"SHREE RAM WOODEN INDUSTRIES PRIVATE LIMITED",
"SHREE RAM WOODS TRADING CO PRIVATE LIMITED",
"SHREE RAMA MULTI-TECH LIMITED",
"SHREE RAMA NEWSPRINT LIMITED",
"SHREE RAMAN BIHARI DEVELOPERS PRIVATE LIMITED",
"SHREE RAMANUJ DYEING AND PRINTING MILLS",
"SHREE RAMANUJ FINANCE PVT LTD",
"SHREE RAMANUJ MERCANTILE PRIVATE LIMITED",
"SHREE RAMCHANDRA INGOT INDIA PRIVATE LIMITED",
"SHREE RAMDEV COTSYN PRIVATE LIMITED",
"SHREE RAMDEV LOGISTICS PRIVATE LIMITED",
"SHREE RAMDEV METALEX LLP",
"SHREE RAMDEV STEELS PRIVATE LIMITED",
"SHREE RAMDOOT FERRO PRIVATE LIMITED",
"SHREE RAMDOOT GEMS LLP",
"SHREE RAMDOOT IMPORT EXPORT PRIVATE LIMITED",
"SHREE RAMDOOT ROLLERS PRIVATE LIMITED",
"SHREE RAMESHWAR LAL FOODS PRIVATE. LIMITED.",
"SHREE RAMESHWAR PIPE INDUSTRIES PRIVATE LIMITED",
"SHREE RAMKRISHANA HIGH SCHOOL ( MANDVI KUTCH )",
"SHREE RAMKRISHNA (JHANWAR) TEXFAB PRIVATE LIMITED",
"SHREE RAMKRISHNA COOLTECH PRIVATE LIMITED",
"SHREE RAMKRISHNA COTSYN PRIVATE LIMITED",
"SHREE RAMKRISHNA EXPORTS PRIVATE LIMITED",
"SHREE RAMKRISHNA MILLS PVT LTD",
"SHREE RAMKRISHNA NETRALAYA",
"SHREE RAMKRUSHNA KRIDA ASHRAM SHALA AMRAVATI",
"SHREE RAMLAKHAN GUPTA HOSPITAL AND RESEARCH PVT. LTD.",
"SHREE RAMRAJA CARS PRIVATE LIMITED",
"SHREE RANG CONSULTANCY SERVICES PRIVATE LIMITED",
"SHREE RANI SATI FOODS PRIVATE LIMITED",
"SHREE RANI SATI INVESTMENT AND FINANCE PRIVATE LIMITED",
"SHREE RANI SATI OVERSEAS PRIVATE LIMITED",
"SHREE RANI SATI SALES PRIVATE LIMITED",
"SHREE RANI SATI TRADECORP PRIVATE LIMITED",
"SHREE RANIE GUM AND CHEMICALS PRIVATE LIMITED",
"SHREE RANISATI DISTRIBUTORS PRIVATE LIMITED",
"SHREE RANISATI INGOTS PRIVATE LIMITED",
"SHREE RANISATI IRRIGATION PRIVATE LIMITED",
"SHREE RANISATI PROCESSORS PRIVATE LIMITED",
"SHREE RANISATI TELETECH PRIVATE LIMITED",
"SHREE RATAN COTTON MILLS PVT LTD",
"SHREE RATANBAI KANYA VIDHYALAY JAMNAGAR",
"SHREE RATHNAM RESTAURANTS PRIVATE LIMITED",
"SHREE RATNA MANGAL JEWELS PRIVATE LIMITED",
"SHREE RAVI HOMES PRIVATE LIMITED",
"SHREE RAVI TRADING & MANUFACTURING PRIVATE LIMITED",
"SHREE RAVIDAS MANDIR SHIKSHA SAMITI JUNIOR HIGH SCHOOL",
"SHREE RAYON PRIVATE LIMITED",
"SHREE REAL WIRE PRIVATE LIMITED",
"SHREE REFRIGERATIONS LIMITED",
"SHREE REFRIGERATIONS PRIVATE LIMITED",
"SHREE RENUKA AUTOMOBILES PRIVATE LIMITED",
"SHREE RENUKA SUGARS LIMITED",
"SHREE RESHAM VASTRA UDYOG PRIVATE LIMITED",
"SHREE RIDDHI ENGINEER",
"SHREE RIDDHI HEALTH FOODS PRIVATE LIMITED",
"SHREE RIDDHI SIDDHI AGRIPRODUCTS PRIVATE LIMITED",
"SHREE RIDDHI SIDDHI BUILDWELL LIMITED",
"SHREE RIDDHI SIDDHI REALTECH PRIVATE LIMITED",
"SHREE RIDDHIVINAYAK BUILDHEIGHTS PRIVATE LIMITED",
"SHREE RIDHI SIDHI INFOTECH PRIVATE LIMITED",
"SHREE RISHABH BUILDSPACE PRIVATE LIMITED",
"SHREE RISHABH GOLD PRIVATE LIMITED",
"SHREE RISHABH MARMO PVT LTD",
"SHREE RISHABH VERDIA MARBLES PRIVATE LIMITED",
"SHREE RISHABHDEV MARBLE AND MINERALS PRIVATE LIMITED",
"SHREE RMD AYURVED COLLEGE & HOSPITAL",
"SHREE ROADWAYS LIMITED (DEEMED PUB TR CO )",
"SHREE ROHIT SYN-FAB PRIVATE LIMITED",
"SHREE ROOPSUKAN SAREES PRIVATE LIMITED",
"SHREE ROSHAN WIRES PRIVATE LIMITED",
"SHREE ROYAL TRANSPORT COMPANY",
"SHREE RSH PROJECTS PRIVATE LIMITED",
"SHREE RUBBER PRODUCTS PVT LTD",
"SHREE RUBBERPLAST COMPANY PRIVATE LIMITED",
"SHREE RUPANADHAM STEEL PRIVATE LIMITED",
"SHREE S V P SANSTHAS HIGH SCHOOL CHILANE",
"SHREE S.B.G. STEELS PRIVATE LIMITED",
"SHREE SACHIDANAND INDUSTRIES PRIVATE LIMITED",
"SHREE SADAFAL COLD STORAGE PRIVATE LIMITED",
"SHREE SADASHIV VINIMAY PRIVATE LIMITED",
"SHREE SADGURU HIGH SCHOOL BHINAR",
"SHREE SADGURU KRUPA FIRE SERVICES PRIVATE LIMITED",
"SHREE SADGURU MASALA AND SPICES INDUSTRIES PVT LTD.",
"SHREE SAFARI HOTELS AND RESORT PRIVATE LIMITED",
"SHREE SAFFRON FABRICS PRIVATE LIMITED",
"SHREE SAGAR DRESSES PRIVATE LIMITED",
"SHREE SAGAR FASHION PRIVATE LIMITED",
"SHREE SAGAR POLY PRODUCTS PRIVATE LIMITED",
"SHREE SAGAR STEVEDORES PRIVATE LIMITED",
"SHREE SAHAJAN VANIJYA MAHAVIDYALAYA",
"SHREE SAHAJANAND VIDHYAMANDIR",
"SHREE SAHAJANANDS AUTOMECK PRIVATE LIMITED",
"SHREE SAI BABA JEEVAN DHARA HOSPITAL INDIA PRIVATE LIMITED",
"SHREE SAI BABA SHIP BREAKING COMPANY",
"SHREE SAI BALAJEE UDYOG PRIVATE LIMITED",
"SHREE SAI CALNATES INDIAPRIVATE LIMITED",
"SHREE SAI DAMAGE FOOD RECYCLER PRIVATE LIMITED",
"SHREE SAI DEALERS PRIVATE LIMITED",
"SHREE SAI DEEP STAINLESS TUBES PRIVATE LIMITED",
"SHREE SAI DISTRIBUTION HUB (I) PRIVATE LIMITED",
"SHREE SAI EARTHMOVERS PRIVATE LIMITED",
"SHREE SAI ELECTRO COATING & POLISHING PRIVATE LIMITED",
"SHREE SAI ERECTORS PRIVATE LIMITED",
"SHREE SAI EXTRUSION TECHNIK PRIVATE LIMITED",
"SHREE SAI HERBS AND SPICES PRIVATE LIMITED",
"SHREE SAI HOSPITAL",
"SHREE SAI INFRA (INDIA) PRIVATE LIMITED",
"SHREE SAI INFRAENGINEERS PRIVATE LIMITED",
"SHREE SAI KNITTINGS PRIVATE LIMITED",
"SHREE SAI KRUPA AQUACULTURE PRIVATE LIMITED",
"SHREE SAI NARAYAN PRODUCTS PRIVATE LIMITED",
"SHREE SAI NATH DOCUMENTATION INDIA PRIVATE LIMITED",
"SHREE SAI OIL FIELD SERVICES PRIVATE LIMITED",
"SHREE SAI ORGANIC FOODS PRIVATE LIMITED",
"SHREE SAI PAERALSS",
"SHREE SAI PLAST PRIVATE LIMITED",
"SHREE SAI POWER CONTROL PRIVATE LIMITED",
"SHREE SAI RAM PAINTS PRIVATE LIMITED",
"SHREE SAI RENT-A-CAR PRIVATE LIMITED",
"SHREE SAI SANT SILK MILLS",
"SHREE SAI SIDDHI VYAPAR PRIVATE LIMITED",
"SHREE SAI SIDHHI CREATIONS PRIVATE LIMITED",
"SHREE SAI TWO WHEELERS PRIVATE LIMITED",
"SHREE SAI URJA LIMITED",
"SHREE SAIBABA GREEN POWER PRIVATE LIMITED",
"SHREE SAIBABA GRIHANIRMITI PRIVATE LIMITED",
"SHREE SAIBABA PLASTO PRODUCTS PRIVATE LIMITED",
"SHREE SAIBALAJI SECURITIES PRIVATE LIMITED",
"SHREE SAIKRUSHNA WAREHOUSING & LOGISTICS PRIVATE LIMITED",
"SHREE SAINATH CONVENT & JR COLLEGE",
"SHREE SAINATH CONVENT AND JUNOIOR COLLEGE NAGPUR",
"SHREE SAINATH DYEING AND PRINTING PVT LTD",
"SHREE SAINATH ELECTROCOTE PRIVATE LIMITED",
"SHREE SAINATH ENTERPRISES CONSTR & DEVELOPERS PRIVATE. LIMITED.",
"SHREE SAINATH INDUSTRIES",
"SHREE SAINATH LAND & DEVELOPMENT (INDIA) PRIVATE LIMITED",
"SHREE SAINATH POLYPLAST PRIVATE LIMITED",
"SHREE SAINATH SHIKSHAN SANSTHA MADHYAMIK VIDYALAYA",
"SHREE SAINATH TEXTILES PRIVATE LIMITED",
"SHREE SAINATH TRADELINK PRIVATE LIMITED",
"SHREE SAINATH WAREHOUSING PRIVATE LIMITED",
"SHREE SAIRAM COMMUNICATIONS INDIA PRIVATE LIMITED",
"SHREE SAISANG ASSOCIATES PRIVATE LIMITED",
"SHREE SAISHRADDHA CEMENTS PRIVATE LIMITED",
"SHREE SAISTAR DIGITAL CABLE NETWORK PRIVATE LIMITED",
"SHREE SAKHA DEVELOPERS PRIVATE LIMITED",
"SHREE SAKSHI INDUSTRIES PRIVATE LIMITED",
"SHREE SAKTHI NARAYAN STEEL LIMITED",
"SHREE SAKTHI VINAYAGAR WEAVES PRIVATE LIMITED",
"SHREE SALASAR AUTOWHEELS PRIVATE LIMITED",
"SHREE SALASAR BALAJEE IMPEX PRIVATE LIMITED",
"SHREE SALASAR BALAJI CARBONS PRIVATE LIMITED",
"SHREE SALASAR BALAJI JEWELLERS PRIVATE LIMITED",
"SHREE SALASAR BALAJI POLYSACK PRIVATE LIMITED",
"SHREE SALASAR CASTINGS PRIVATE LIMITED",
"SHREE SALASAR CREATIONS PRIVATE LIMITED",
"SHREE SALASAR DECOR PRIVATE LIMITED",
"SHREE SALASAR DEVELOPERS PRIVATE LIMITED",
"SHREE SALASAR ENERGY & FERRO ALLOYS PRIVATE LIMITED",
"SHREE SALASAR INDUSTRIES PRIVATE LIMITED",
"SHREE SALASAR INVESTMENTS LIMITED",
"SHREE SALASAR LOGISTIC & SHIPPING PRIVATE LIMITED",
"SHREE SALASAR MARBLES IMPEX PRIVATE LIMI TED",
"SHREE SALASAR OIL AND FATS PRIVATE LIMITED",
"SHREE SALASAR OVERSEAS PVT LTD",
"SHREE SALASAR PROPERTIES & FINANCE PVT. LTD.",
"SHREE SALASAR SNACKS PRIVATE LIMITED",
"SHREE SALASARHANUMANJI GRAINS PRIVATE LIMITED",
"SHREE SALES CORPORATION PRIVATE LIMITED",
"SHREE SALESPACK PRIVATE LIMITED",
"SHREE SAMART TECH PROCESS ENGINEERING PRIVATE LIMITED",
"SHREE SAMARTH DISTRIBUTOR",
"SHREE SAMARTH INFRA BUILDCON PRIVATE LIMITED",
"SHREE SAMARTH SAHAKARI BANK LIMITED NASHIK",
"SHREE SAMARTH SWITCHGEAR & TRANSMISSION PRIVATE LIMITED",
"SHREE SAMARTH WAREHOUSING & LOGISTICS PRIVATE LIMITED",
"SHREE SAMIRINANDAN PROJECTS PRIVATE LIMITED",
"SHREE SAMRAT PULP AND PAPER PRIVATE LIMITED",
"SHREE SAMRIDDHI VINAYAK PRIVATE LIMITED",
"SHREE SAMRIDHI TRANSPORT PRIVATE LIMITED",
"SHREE SAMTAINATH ENTERPRISES PRIVATE LIMITED",
"SHREE SANATAN DHARAM VIDYALAYA & JR COLLEGE",
"SHREE SANATAN DHARM EDUCATION CENTER",
"SHREE SANGAM REALBUILDS PRIVATE LIMITED",
"SHREE SANGHVI MILLS PRIVATE LIMITED",
"SHREE SANGMESHWAR MADYAMIK SHALA CHADCHAN",
"SHREE SANMATI EXIM INDIA PRIVATE LIMITED",
"SHREE SANMATI FAB PRIVATE LIMITED",
"SHREE SANSKAR DREAM DEVELOPERS PRIVATE LIMITED",
"SHREE SANT KRIPA APPLIANCES PRIVATE LIMITED",
"SHREE SANT KRUPA SILK MILLS PRIVATE LIMITED",
"SHREE SANTHANAKRISHNA SILK PRIVATE LIMITED",
"SHREE SANTKRUPA COLLEGE OF PHARMACY",
"SHREE SANTKRUPA INSTITUTE OF ENGINEERING AND TECHNOLOGY",
"SHREE SANTOK BAA MOHANBHAI CHAUDHAT PRATHMIK SHALA MANEKPUR",
"SHREE SANTOSH MARKETING PVT LTD",
"SHREE SANVAARIYA MODULAR SYSTEMS PRIVATE LIMITED",
"SHREE SANWARIYAJI SULZ PRIVATE LIMITED",
"SHREE SAPTASHREE BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"SHREE SARASWASTI SEN SEC VIDHIYA MANDIR",
"SHREE SARASWATHI EDUCATIONAL TRUST",
"SHREE SARASWATI GRAM VIDHYAPEETH SAMODA GANWADA",
"SHREE SARASWATI VIDHYALAYA PALIYAD",
"SHREE SARASWATI VIDYALAYA SIYAWADA",
"SHREE SARDAR PATEL COLLEGE OF EDUCATION",
"SHREE SARDAR SMARAK HOSPITAL",
"SHREE SAREE KUNJ PRIVATE LIMITED",
"SHREE SAREE SAGAR PRIVATE LIMITED",
"SHREE SAREES CREATION PRIVATE LIMITED",
"SHREE SAREES PRIVATE LIMITED",
"SHREE SARGAM TRADERS(INDIA) PRIVATE LIMITED",
"SHREE SARVALOKA TEXTILES PRIVATE LIMITED",
"SHREE SARVAMAYEE PRODUCTS PRIVATE LIMITED",
"SHREE SARVODAY VIDYA MANDIR JINDVA",
"SHREE SARWESHWAR MILK DAIRY PRIVATE LIMITED",
"SHREE SATGURU AGRO AND OIL PRODUCTS PRIVATE LIMITED",
"SHREE SATGURU INFOCOM PRIVATE LIMITED",
"SHREE SATI PAPER PRIVATE LIMITED",
"SHREE SATI PLASTIC AND CHEMICALS PRIVATE",
"SHREE SATI TEXPRINTS PRIVATE LIMITED",
"SHREE SATYAM STEEL INDIA PRIVATE LIMITED",
"SHREE SATYANARAYAN INDUSTRIAL SUPPLIERS PRIVATE LIMITED",
"SHREE SATYANARAYAN INVESTMENTS COMPANY LIMITED",
"SHREE SAVARIYA AGRO PRODUCTS LIMITED",
"SHREE SAWAN BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"SHREE SAWARIYA FOODS PRIVATE. LIMITED.",
"SHREE SEA AIR SERVICES PRIVATE LIMITED",
"SHREE SECO PRIVATE LIMITED",
"SHREE SEDATA PRIMARY SCHOOL",
"SHREE SELAMBA HIGHSCHOOL",
"SHREE SELENE BUSINESS PRIVATE LIMITED",
"SHREE SERVICES & TRADING CO LTD",
"SHREE SGR AGRO FOODS PRIVATE LIMITED",
"SHREE SHAILJA IRON AND STEELS PRIVATE LIMITED",
"SHREE SHAILYA AGROTECH PRIVATE LIMITED",
"SHREE SHAKAMBARI AGRI MILLS PRIVATE LIMITED",
"SHREE SHAKAMBARI FERRO ALLOYS PRIVATE LIMITED",
"SHREE SHAKAMBARI INDUSTRIES PVT LTD",
"SHREE SHAKAMBARI MERCHANTS PRIVATE LIMITED",
"SHREE SHAKAMBARI RICE MILL PRIVATE LIMITED",
"SHREE SHAKAMBHARI DEVELOPERS PRIVATE LIMITED",
"SHREE SHAKAMBHARI EXIMS PRIVATE LIMITED",
"SHREE SHAKAMBHARI PRINTS PRIVATE LIMITED",
"SHREE SHAKTHI AIR CARGO PRIVATE LIMITED",
"SHREE SHAKTI CERAMICS",
"SHREE SHAKTI CONSTRUCTION",
"SHREE SHAKTI ENTERPRISES PRIVATE LIMITED",
"SHREE SHAKTI IRON & ALLOYS PRIVATE LIMITED",
"SHREE SHAKTI POLYFILMS PRIVATE LIMITED",
"SHREE SHAKTI PROTEINS PVT LTD.",
"SHREE SHAKTI REALTY PRIVATE LIMITED",
"SHREE SHAKTI WELD PRODUCTS PRIVATE LIMITED",
"SHREE SHAKTISHOL ENVIRONMENT PRIVATE LIMITED",
"SHREE SHAKUN REALTY PRIVATE LIMITED",
"SHREE SHAM AGENCIES PRIVATE LIMITED",
"SHREE SHANKAR ENGICON PRIVATE LIMITED",
"SHREE SHANKAR INTER COLLEGE",
"SHREE SHANKAR NARAYAN EDUCATION TRUST",
"SHREE SHANKAR PLASTICS LIMITED",
"SHREE SHANKAR VIJAY TIMBER EXPORTS PRIVATE LIMITED",
"SHREE SHANKESHWAR METALS AND WAREHOUSE PRIVATE LIMITED",
"SHREE SHANTI METAL RECYCLING PRIVATE LIMITED",
"SHREE SHANTI POLYSACKS PVT LTD",
"SHREE SHANTI SYNTEX PRIVATE LIMITED",
"SHREE SHANTI TRADES PVT.LTD.",
"SHREE SHARADDHA MOTORS PRIVATE LIMITED",
"SHREE SHARAN ASSOCIATES PRIVATE LIMITED",
"SHREE SHARANAM REAL ESTATE PRIVATE LIMITED",
"SHREE SHARDA ASSOCIATES PRIVATE LIMITED",
"SHREE SHARDA CHAINS PRIVATE LIMITED",
"SHREE SHARDA VIDHYAMANDIR",
"SHREE SHASHTRISWAMI NARAYANSEVADASJI VIDHYALAYA",
"SHREE SHASHWATRAJ AGRO PRIVATE LIMITED",
"SHREE SHEELE PRIVATE LIMITED",
"SHREE SHEETTAL MINES AND MINERALS PRIVATE LIMITED",
"SHREE SHETH SECURITIES & SERVICES PRIVATE LIMITED",
"SHREE SHIDDHANATH COTEX PRIVATE LIMITED",
"SHREE SHIPPING AND TRANSPORT SERVICES PRIVATE LIMITED",
"SHREE SHIPPING SERVICES PRIVATE LIMITED",
"SHREE SHIV SHAKTI AASHRAM SCHOOL",
"SHREE SHIVA PLAST ENGINEERS PRIVATE LIMITED",
"SHREE SHIVAM ATTIRES PRIVATE LIMITED",
"SHREE SHIVAM COTTON INDUSTRIES",
"SHREE SHIVAM PRIMARY SCHOOL",
"SHREE SHIVKRUPANAND SWAMI FOUNDATION",
"SHREE SHIVSHAKTI BAKERS PRIVATE LIMITED",
"SHREE SHIVSHAKTI FILING STATION PRIVATE LIMITED",
"SHREE SHIVSHANKAR DRUGS AND PHARMACEUTICALS PVT LTD",
"SHREE SHOPPERS LIMITED",
"SHREE SHOT EQUIPMENT PRIVATE LIMITED",
"SHREE SHRADDHA COLONISERS PRIVATE LIMITED",
"SHREE SHRADHHA CHEMICALS PRIVATE LIMITED",
"SHREE SHREE JEE AUTOMOBILES PRIVATE LIMITED",
"SHREE SHREE SALASAR HANUMAN AGRI PRODUCTS PRIVATE LIMITED",
"SHREE SHREE VIDYA SAGAR JI MAHARAJ EDUCATION TRUST LAKHMI CHAND INSTITUTE OF TECHNOLOGY BODRI",
"SHREE SHREENATH SYNTHETICS PRIVATE LIMITED",
"SHREE SHRUTI RAYONS PVT LTD",
"SHREE SHUBH LAXMI POLYMERS PRIVATE LIMITED",
"SHREE SHUBHAM FAB PRIVATE LIMITED",
"SHREE SHUBHAM LOGISTICS LIMITED",
"SHREE SHUBHLAXMI DAL AND OIL MILL LIMITED",
"SHREE SHYAM AIR SERVICES PRIVATE LIMITED",
"SHREE SHYAM BABA FABRICS PRIVATE LIMITED",
"SHREE SHYAM BABA REROLLERS PRIVATE LIMITED",
"SHREE SHYAM BAKERS PRIVATE LIMITED",
"SHREE SHYAM BOX MANUFACTURING PRIVATE LIMITED",
"SHREE SHYAM BULLION PRIVATE LIMITED",
"SHREE SHYAM CERAMICS PRIVATE LIMITED",
"SHREE SHYAM CORPORATE SERVICES PRIVATE LIMITED",
"SHREE SHYAM CORPORATION",
"SHREE SHYAM DEALCOM PRIVATE LIMITED",
"SHREE SHYAM DESIGNS PRIVATE LIMITED",
"SHREE SHYAM DWELLERS INDIA LTD.",
"SHREE SHYAM ENTERPRISES MANAGEMENT PRIVATE LIMITED",
"SHREE SHYAM GLASS ENTERPRISES PRIVATE LIMITED",
"SHREE SHYAM INFRALOGISTICS PRIVATE LIMITED",
"SHREE SHYAM INORGANICS PRIVATE LIMITED",
"SHREE SHYAM ISPAT",
"SHREE SHYAM JI TRADING PRIVATE LIMITED",
"SHREE SHYAM KAMAL INDUSTRIES PRIVATE LIMITED",
"SHREE SHYAM KAMAL STEEL INDUSTRIES PRIVATE LIMITED",
"SHREE SHYAM LAMINATORS PRIVATE LIMITED",
"SHREE SHYAM MEDIWAYS PRIVATE LIMITED",
"SHREE SHYAM MODULAR FURNITURE PRIVATE LIMITED",
"SHREE SHYAM NAMKEEN PRIVATE LIMITED",
"SHREE SHYAM ORES PRIVATE LIMITED",
"SHREE SHYAM PAN PRODUCTS PRIVATE LIMITED",
"SHREE SHYAM PETRO INFRASTRUCTURES PRIVATE LIMITED",
"SHREE SHYAM POLYTHENE PRIVATE LIMITED",
"SHREE SHYAM PROCESSORS PRIVATE LIMITED",
"SHREE SHYAM ROADLINK PRIVATE LIMITED",
"SHREE SHYAM SALES PRIVATE LIMITED",
"SHREE SHYAM SANITATION PRIVATE LIMITED",
"SHREE SHYAM SAREE HOUSE (INDIA) PRIVATE LIMITED",
"SHREE SHYAM SARITA CREATIONS PRIVATE LIMITED",
"SHREE SHYAM SECURITY CONSULTANTS PRIVATE LIMITED",
"SHREE SHYAM SNACKS FOOD PRIVATE LIMITED",
"SHREE SHYAM SPICES PRIVATE LIMITED",
"SHREE SHYAM SPONGE AND POWER LIMITED",
"SHREE SHYAM TOURIST SERVICES PRIVATE LIMITED",
"SHREE SHYAM TRANSCORE PRIVATE LIMITED",
"SHREE SHYAM TRANSPORT PRIVATE LIMITED",
"SHREE SHYAM TRAVELS PRIVATE LIMITED",
"SHREE SHYAM YARN TRADING CO. PRIVATE LIMITED",
"SHREE SHYAMBABA CASTINGS PRIVATE LIMITED",
"SHREE SHYAMJI PADDY PROCESSING PRIVATE LIMITED",
"SHREE SHYAMSUNDER ALLOYS PRIVATE LIMITED",
"SHREE SIDDH INFRASTRUCTURE PRIVATE LIMITED",
"SHREE SIDDHESHWAR HANUMANJI SEVA SANSTHA MANDAL",
"SHREE SIDDHI CHEMODYES PRIVATE LIMITED",
"SHREE SIDDHI IMITATION PRIVATE LIMITED",
"SHREE SIDDHI INFRABUILD PRIVATE LIMITED",
"SHREE SIDDHI VINAYAK CARDIAC CENTER PRIVATE LIMITED",
"SHREE SIDDHI VINAYAK CONCAST PRIVATE LIMITED",
"SHREE SIDDHI VINAYAK HOSPICARE PRIVATE LIMITED",
"SHREE SIDDHIVINAYAK AGRITECH INDUSTRIES LIMITED",
"SHREE SIDDHIVINAYAK AUTOMOBILES",
"SHREE SIDDHIVINAYAK COTFAB PRIVATE LIMITED",
"SHREE SIDDHIVINAYAK COTSPIN PRIVATE LIMITED",
"SHREE SIDDHIVINAYAK SALT WORKS PRIVATE LIMITED",
"SHREE SIDDHIVINAYAK TRAVELS AND TOURS PRIVATE LIMITED",
"SHREE SIDDHIVINAYAKA AGRO EXTRACTIONS PRIVATE LIMITED",
"SHREE SIDDHIVINAYAKA COTTON CORPORATION",
"SHREE SIDDI VINAYAK FORGINGS PRIVATE LIMITED",
"SHREE SIDH STONES PRIVATE LIMITED",
"SHREE SIDHARAJ ENGINEERING PRIVATE LIMITED",
"SHREE SIDHBALI IMPEX PRIVATE LIMITED",
"SHREE SIDHBALI INDUSTRIES LIMITED",
"SHREE SIDHBALI PAPER MILLS PRIVATE LIMITED",
"SHREE SIDHBALI STEELS PRIVATE LIMITED",
"SHREE SIDHDATA ENTERPRISE",
"SHREE SIDHI VINAYAK ENTERPRISES",
"SHREE SIDHIVINAYAK BUILDCON PRIVATE LIMITED",
"SHREE SIDVIN FINANCIAL SERVICESANDINVESTMENTS PRIVATE LIMITED",
"SHREE SIGNIFY EXIM PRIVATE LIMITED",
"SHREE SIMANDHAR IMPORTS PRIVATE LIMITED",
"SHREE SINGHAL SPINNERS PRIVATE LIMITED",
"SHREE SITA AGRO FOODS PRIVATE. LIMITED.",
"SHREE SITA CHEMICALS PRIVATE LIMITED",
"SHREE SITA EDIBLES LIMITED.",
"SHREE SITA ISPAT AND POWER PRIVATE LIMITED",
"SHREE SITA PULSES PRIVATE LIMITED",
"SHREE SITA RAM APPLIANCES PRIVATE LIMITED",
"SHREE SITA RAM INDUSTRIES PRIVATE LIMITED",
"SHREE SITA RAM PAPER MILLS LIMITED",
"SHREE SITA REFINERS PRIVATE. LIMITED.",
"SHREE SITA RICE MILL",
"SHREE SITABA J V PATEL KANYA VIDHYALAY AND MENABA KA CH UCHHATAR MADHYAMIK SHALA",
"SHREE SITANATH RETAILERS PRIVATE LIMITED",
"SHREE SIVA BUILDERS PRIVATE LIMITED",
"SHREE SIVABALAAJI STEELS PRIVATE LIMITED",
"SHREE SIYARAM DISTRIBUTORS PRIVATE LIMITED",
"SHREE SIYARAM SALES PRIVATE LIMITED",
"SHREE SIYARAM SWITCHGEARS PRIVATE LIMITED",
"SHREE SKYCRAPERS PRIVATE LIMITED",
"SHREE SKYJET TRAVELS & TOURS PRIVATE LIMITED",
"SHREE SM AND MM CHAUDHARI MADHYAMIK AND UCHCHATAR MADHYAMIK SHALA",
"SHREE SOAPS & CHEMICAL INDUSTRIES PACKING DIVISION",
"SHREE SOMESHWAR EDUCATION TRUST",
"SHREE SOMNATH ALLOYS PRIVATE LIMITED",
"SHREE SOMNATH IRON AND POWER PRIVATE LIMITED",
"SHREE SOMNATH PAPER MILLS PRIVATE LIMITED",
"SHREE SONAL ENTERPRISE",
"SHREE SONIGARA REALCON",
"SHREE SPHEROTECH PRIVATE LIMITED",
"SHREE SSA BUILDERS PRIVATE LIMITED",
"SHREE SSD PHARMA PRIVATE LIMITED",
"SHREE STEEL CASTING (PRIVATE) LIMITED",
"SHREE STEEL WIRE ROPES LIMITED",
"SHREE STEVEDORS PRIVATE LIMITED",
"SHREE SUBH LOGISTICS PRIVATE LIMITED",
"SHREE SUBH SYNTHETICS PRIVATE LIMITED",
"SHREE SUBHLAXMI DYEING PRIVATE LIMITED",
"SHREE SUBHLAXMI FOODS LIMITED",
"SHREE SUDARSHAN FOODS PRIVATE LIMITED",
"SHREE SUDARSHAN STRIPS PVT. LTD.",
"SHREE SUDERSHAN ASSOCIATES INDIA PRIVATE LIMITED",
"SHREE SUKHAKARTA DEVELOPERS PRIVATE LIMITED",
"SHREE SULAJ ENVIROTECH PRIVATE LIMITED",
"SHREE SULPHURICS PRIVATE LIMITED",
"SHREE SULZTEX SPARES PRIVATE LIMITED",
"SHREE SUMAN PLASTICS PRIVATE LIMITED",
"SHREE SUMANGAL INDIA PRIVATE LIMITED",
"SHREE SUMATI SUGAR PRIVATE. LIMITED.",
"SHREE SUMEDH TREXIM PRIVATE LIMITED",
"SHREE SUMTINATH SILK MILLS PRIVATE LIMITED",
"SHREE SUNT TUKARAM VIDYALAY KANDARI BK",
"SHREE SURABHI FLOUR MILLS PRIVATE LIMITED",
"SHREE SURABHI WHEAT PRODUCTS PRIVATE LIMITED",
"SHREE SURYA GRANI MARMO PRIVATE LIMITED",
"SHREE SURYA SURGI PHARMA PRIVATE LIMITED",
"SHREE SWAKASH FOOD AGRO PRIVATE LIMITED",
"SHREE SWAMI DAYANANDA SPINNERS PRIVATE LIMITED",
"SHREE SWAMI ENTERPRISE PRIVATE LIMITED",
"SHREE SWAMI SAMARTH ENERGY AND SUGAR PRIVATE LIMITED",
"SHREE SWAMI SAMARTH GROUP",
"SHREE SWAMI SAMARTH PAPER CONVERTORS PRIVATE LIMITED",
"SHREE SWAMI SAMARTH POWER ELECTRICAL PRIVATE LIMITED",
"SHREE SWAMI SAMARTH PROJECTS PRIVATE LIMITED",
"SHREE SWAMI VIVEKANAND ASHRAMSALA",
"SHREE SWAMI VIVEKANAND COLLEGE",
"SHREE SWAMINARAYAN ACADEMY",
"SHREE SWAMINARAYAN ARTS COLLEGE",
"SHREE SWAMINARAYAN B ED COLLEGE VIJAPUR",
"SHREE SWAMINARAYAN DIVYADHAM GURUKUL VELANJA",
"SHREE SWAMINARAYAN FOODS PRIVATE LIMITED",
"SHREE SWAMINARAYAN GURUKUL",
"SHREE SWAMINARAYAN GURUKUL INTERNATIONAL SCHOOL RAJKOT",
"SHREE SWAMINARAYAN HOMEOPATHIC COLLEGE",
"SHREE SWAMINARAYAN INSTITUTE OF TECHNOLOGY",
"SHREE SWAMINARAYAN INTERNATIONAL SCHOOL",
"SHREE SWAMINARAYAN POLYTECHNIC",
"SHREE SWATI SPINTEX PRIVATE LIMITED",
"SHREE SWATI TEXDYES PRIVATE LIMITED",
"SHREE SWMINARAYAN INFRASTRUCTURE PRIVATE LIMITED",
"SHREE SYSTEMS PRIVATE LIMITED",
"SHREE TEA ASSAM MANUFACTURING INDUSTRIES LIMITED",
"SHREE TECHNO READYMIX PRIVATE LIMITED",
"SHREE TECHNOCRAT COMMUNICATION SYSTEMS PRIVATE LIMITED",
"SHREE TEFCON (INDIA) PRIVATE LIMITED",
"SHREE TEJAL COTTEX",
"SHREE TELLINKS PRIVATE LIMITED",
"SHREE TEX MARKETING PRIVATE LIMITED",
"SHREE TEXCREATION PRIVATE LIMITED",
"SHREE THAKUR ENTERPRISES LIMITED",
"SHREE THAKURDWARA BALIKA VIDYALAYA",
"SHREE THAKURJEE IRON AND STEEL WORKS LIMITED",
"SHREE THERMOCARE PRIVATE LIMITED",
"SHREE THIRUMALAI MARKETING AND INVESTMENTS LIMITED",
"SHREE TIRUPATI AUTO",
"SHREE TIRUPATI BALAJEE AGRO TRADING COMPANY LIMITED",
"SHREE TIRUPATI BALAJEE AGRO TRADING COMPANY PRIVATE LIMITED",
"SHREE TIRUPATI BALAJEE FIBC LIMITED",
"SHREE TIRUPATI BALAJEE INDUSTRIES PRIVATE LIMITED",
"SHREE TIRUPATI COURIER SERVICES PRIVATE LIMITED",
"SHREE TIRUPATI EMBROTEX PRIVATE LIMITED",
"SHREE TIRUPATI HOSIERY PRIVATE LIMITED",
"SHREE TIRUPATI MINERALS PRIVATE LIMITED",
"SHREE TIRUPATTI DISTRIBUTORS PRIVATE LIMITED",
"SHREE TISAI SECURITIES PRIVATE LIMITED",
"SHREE TITWALA CHEMICALS PRIVATE LIMITED",
"SHREE TNB POLYMERS LIMITED",
"SHREE TOOLS",
"SHREE TRADEZONE PRIVATE LIMITED",
"SHREE TRANSLINK INDIA PRIVATE LIMITED",
"SHREE TRIBHUVAN ISPAT PRIVATE LIMITED",
"SHREE TRIVENI DEVELOPERS PRIVATE LIMITED",
"SHREE TUBE MANUFACTURING COMPANY PRIVATE LIMITED",
"SHREE TUKARAM TANAJI KHALANE MAHAJAN HIGH SCHOOL DEOPUR & JR COLLAGE",
"SHREE TULJA BHAVANI AUTOMOBILES PRIVATE LIMITED",
"SHREE TULJA BHAVANI JEWELLERS PRIVATE LIMITED",
"SHREE TULJABHAVANI LOGISTICS PRIVATE LIMITED",
"SHREE TULSI DETERGENTS PRIVATE LIMITED",
"SHREE TULSI KRUPA AGRO TECH PRIVATE LIMITED",
"SHREE TULSI REALTY PRIVATE LIMITED",
"SHREE TULSI TEA COMPANY PRIVATE LIMITED",
"SHREE ULKA LLP",
"SHREE ULTRA INKS PRIVATE LIMITED",
"SHREE UMA AGRI COTTON PRIVATE LIMITED",
"SHREE UMA FOUNDRIES PVT LTD",
"SHREE UMA GINNING PRESSING PRIVATE LIMITED",
"SHREE UMA MAHESHWAR TEXTILES",
"SHREE UMESH GUPTA ENTERPRISES LIMITED",
"SHREE UMIYA AGRO SOLVEX PRIVATE LIMITED",
"SHREE UMIYA COTSPIN PRIVATE LIMITED",
"SHREE UMIYA CUTTERS PRIVATE LIMITED",
"SHREE UMIYA ELECTRIC PRIVATE LIMITED",
"SHREE UMIYA STRUCTURE PRIVATE LIMITED",
"SHREE UMIYA SURGICALS PVT LTD",
"SHREE UMIYA YARN PRIVATE LIMITED",
"SHREE UNICON ORGANICS PRIVATE LIMITED",
"SHREE UNION INK & GRAPHIC INDIA PRIVATE LIMITED",
"SHREE UNIONN SURGICALS PRIVATE LIMITED",
"SHREE UPASINI CONSTRUCTIONS (JBP) PRIVATE LIMITED",
"SHREE UTHRADAM THIRUNAL SUT HOSPITAL",
"SHREE UTSAV COLLECTION PRIVATE LIMITED",
"SHREE UTTAM FOOD PRODUCTS (INDIA) PRIVATE LIMITED",
"SHREE UTTAM STEEL AND POWER LIMITED",
"SHREE V J MODI PRIMARY SCHOOL",
"SHREE VADECHI INFRASOFT PRIVATE LIMITED",
"SHREE VAGAD BE CHOVISI STHANAK VASI JAIN YUVAK MANDAL",
"SHREE VAGHESHWARI CARBON PRIVATE LIMITED",
"SHREE VAGHESHWARI ROADWAYS",
"SHREE VAIBHAV LAKSHMI STEELS PRIVATE LIMITED",
"SHREE VAISHNAV ACADEMY",
"SHREE VAISHNAVI AGRO INDUSTRIES PRIVATE LIMITED",
"SHREE VAISHNO ABRASIVES PRIVATE LIMITED",
"SHREE VAISHNO RICE MILL PRIVATE LIMITED",
"SHREE VALI METALS PRIVATE LIMITED",
"SHREE VALLABH ASHRAM ENGLISH MEDIUM HIGH SCHOOL",
"SHREE VALLABH ASHRAM ENGLISH MEDIUM SCHOOL",
"SHREE VALLABH ENTERPRISES",
"SHREE VALLABH VIDYALAYA",
"SHREE VANASPATI PRODUCTS INDIA LIMITED",
"SHREE VANRAJ BESAN MILL PRIVATE LIMITED",
"SHREE VARDA LASER TECH PRIVATE LIMITED",
"SHREE VARDARIA INVESTMENTS PVT LTD",
"SHREE VARDAYINI CHEMICAL INDUSTRIES PVT LTD",
"SHREE VARDHMAAN SURGICARE PRIVATE LIMITED",
"SHREE VARDHMAN DEVELOPERS PRIVATE LIMITED",
"SHREE VARDHMAN INFRAHOME PRIVATE LIMITED",
"SHREE VARDHMAN POWER PRIVATE. LIMITED.",
"SHREE VARDHMAN VENTURES LLP",
"SHREE VARI MULTIPLAST INDIA PRIVATE LIMITED",
"SHREE VARMA BIO NATURALS PRIVATE LIMITED",
"SHREE VARNIKA ROYAL PRODUCTS PRIVATE LIMITED",
"SHREE VARSA INVESTORS & TRADERS PVT LTD",
"SHREE VASI HOMES PRIVATE LIMITED",
"SHREE VASISHTHA VIDHYALAYA",
"SHREE VASU AUTOMOBILES PRIVATE LIMITED",
"SHREE VASU LOGISTICS LIMITED",
"SHREE VASU STEELS PRIVATE LIMITED",
"SHREE VASUDEO INDUSTRIES",
"SHREE VASUDEV PROCESSORS PRIVATE LIMITED",
"SHREE VASUDEVBHAI AND KANTILAL PATEL INSTITUTE OF ENGINEERING",
"SHREE VED INDUSTRIES INDIA PRIVATE LIMITED",
"SHREE VEDANTA INDUSTRIAL PRODUCTS PRIVATE LIMITED",
"SHREE VEER BUILDBEST PRIVATE LIMITED",
"SHREE VEER TEJA MARBLES PVT LTD",
"SHREE VEERABHADRESHWAR COTTON INDUSTRIES PRIVATE LIMITED",
"SHREE VEHICLES PRIVATE LIMITED",
"SHREE VELU BUILDERS PRIVATE LIMITED",
"SHREE VENKATESH BUILDCON",
"SHREE VENKATESH BUILDCON PRIVATE LIMITED",
"SHREE VENKATESH INTERNATIONAL LIMITED",
"SHREE VENKATESH MULTI SERVICES PRIVATE LIMITED",
"SHREE VENKATESH PLYWOOD PRIVATE LIMITED",
"SHREE VENKATESHWARA ELECTROCAST PRIVATE LIMITED",
"SHREE VENKATESHWARA FOODS PRIVATE LIMITED",
"SHREE VENKATESHWARA GOODS MOVERS PVT.LTD.",
"SHREE VENKATESHWARA HI-TECH ENGINEERING COLLEGE",
"SHREE VENKATESHWARA INFRASTRUCTURE PRIVATE LIMITED",
"SHREE VENKATESHWARA SPONGE AND POWER PRIVATE LIMITED",
"SHREE VENKATESHWARA TURNKEY PROJECT SOLUTION PRIVATE LIMITED",
"SHREE VENKATESWARA TOURS PRIVATE LIMITED",
"SHREE VENKETESH PAPER MILLS LIMITED",
"SHREE VENKTESH WIRES AND STEELS PRIVATE LIMITED",
"SHREE VENKTESHWAR SILK MILLS PRIVATE LIMITED",
"SHREE VENTURES - NAGPUR",
"SHREE VENUS ENERGY SYSTEM PRIVATE LIMITED",
"SHREE VERAI SHAKTI SALT PRIVATE LIMITED",
"SHREE VIDHYADHISH SCE & H SEC SCHOOL",
"SHREE VIDYA NIKETAN COLLEGE OF MEDICAL SCIENCE & RESEARCH",
"SHREE VIDYASAGAR APPARELS PRIVATE LIMITED",
"SHREE VIGHNESHWARA CHIT FUND PRIVATE LIMITED",
"SHREE VIHAR APARTMENTS PVT LTD",
"SHREE VIHAR HOUSING & DEVELOPERS PRIVATE LIMITED",
"SHREE VIJAY AQUA FEEDS PRIVATE LIMITED",
"SHREE VIJAY LAXMI CABLES PRIVATE LIMITED",
"SHREE VIJAYLAXMI LOGIX PRIVATE LIMITED",
"SHREE VIJAYVARGIYA TECHNOLOGIES PRIVATE LIMITED",
"SHREE VIKASH FINVEST PRIVATE LIMITED",
"SHREE VIMAL SAGAR METAL UDYOG PRIVATE LIMITED",
"SHREE VINAY ENGINEERING SERVICES PRIVATE LIMITED",
"SHREE VINAYAK AUTOCOMP (INDIA) PRIVATE LIMITED",
"SHREE VINAYAK FERTILISERS PRIVATE LIMITED",
"SHREE VINAYAK FORGING & STEEL PRIVATE LIMITED",
"SHREE VINAYAK INDIA BIO-FERTILISERS PRIVATE LIMITED",
"SHREE VINAYAK INFRATECH PRIVATE LIMITED",
"SHREE VINAYAK ORGANICS INDIA PRIVATE LIMITED",
"SHREE VINAYAK SHYAM ENTERPRISES PRIVATE LIMITED",
"SHREE VINAYAK SPRINGS PRIVATE LIMITED",
"SHREE VINAYAKA LIFE SCIENCES PRIVATE LIMITED",
"SHREE VINYLS PRIVATE LIMITED",
"SHREE VIRAJ ENTERPRISES",
"SHREE VISHAL JEWELLERS",
"SHREE VISHAL SUITINGS PRIVATE LIMITED",
"SHREE VISHNOVI ALLOYS PRIVATE LIMITED",
"SHREE VISHNU POWER & ENERGY PRIVATE LIMITED.",
"SHREE VISHNU SAREES PRIVATE LIMITED",
"SHREE VISHVAMURTE TRADINVEST PRIVATE LIMITED",
"SHREE VISHWAKARMA ALU PROJECTS PRIVATE LIMITED",
"SHREE VISHWAKARMA ELECTROTECH PRIVATE LIMITED",
"SHREE VISHWANATH SAREES PRIVATE LIMITED",
"SHREE VMC PARTS PRIVATE LIMITED",
"SHREE VRINDAVANBIHARI COLD STORAGE PRIVATE LIMITED",
"SHREE VRUNDAVAN GOLD PALACE PRIVATE LIMITED",
"SHREE VYANKATESHA ENTERPRISES",
"SHREE VYANKATESHWARA MANGANESE INDUSTRIES PRIVATE LIMITED",
"SHREE VYAPARI NAGARI PAT SANSTHA MURGUD",
"SHREE WAGADWALA PAPER PRIVATE LIMITED",
"SHREE WAGHESHWAR VIDYDHAM MANDAVGAN PHARATA",
"SHREE WAHE GURU FASHIONS PRIVATE LIMITED",
"SHREE WAREHOUSING SERVICES AND REALTY LIMITED",
"SHREE WARIS PIYA STEEL COMPANY PRIVATE LIMITED",
"SHREE WARNA SAHAKARI DUDH UTPADAK PRAKRIYA SANGH LIMITED.",
"UNIFINZ CAPITAL INDIA LIMITED",
"SHREE YADUNANDAN FOODS PRIVATE LIMITED",
"SHREE YAMUNA AKSHAT PRIVATE LIMITED",
"SHREE YAMUNA GINNING AND PRESSING FACTORY",
"SHREE YASH DESTINATIONS PRIVATE LIMITED",
"SHREE YASH STAINLESS PRIVATE LIMITED",
"SHREE YOGANAND TEXTILES PVT LTD",
"SHREE YOGESHWAR PUBLIC SCHOOL",
"SHREE YOGESHWARI DEVELOPERS PRIVATE LIMITED",
"SHREE YUG ISPAT PRIVATE LIMITED",
"SHREEABHIRAM RICE MILL PRIVATE LIMITED",
"SHREEAIR CARGO PRIVATE LIMITED",
"SHREEANAND NATHAY MINERALS PRIVATE LIMITED",
"SHREEARIHANT LOGISTICS PVT LTD",
"SHREEASHIRVAD SOLAR SYSTEMS PRIVATE LIMITED",
"SHREEBANKE BIHARI BUILDHOME PRIVATE LIMITED",
"SHREEBHAGWATI COMMODITIES PRIVATE LIMITED",
"SHREEBHAN PACKAGING PRIVATE LIMITED",
"SHREEBHAV POLYKNITS PRIVATE. LIMITED.",
"SHREEBHAV POLYWEAVES PRIVATE. LIMITED.",
"SHREEBRAJRAJ AGRIPRODUCT PRIVATE LIMITED",
"SHREECHAKRA GOURMET SERVICES PRIVATE LIMITED",
"SHREECHAKRA VENTURES INDIA PRIVATE LIMITED",
"SHREECHAND HARDWARE PRIVATE LIMITED",
"SHREEDATTAKRUPA PACKAGING INDUSTRIES PRIVATE LIMITED",
"SHREEDAYAL ENTERPRISES PRIVATE LIMITED",
"SHREEDEEP HOSPITAL",
"SHREEDESTINATIONS TRAVEL PRIVATE LIMITED",
"SHREEDHAM CONSTRUCTIONS PRIVATE LIMITED",
"SHREEDHAM SILK INDUSTRIES PRIVATE LIMITED",
"SHREEDHAR AUTO SALES AND SERVICE PRIVATE LIMITED",
"SHREEDHAR COTTON INDUSTRIES",
"SHREEDHAR IRRIGATION PRIVATE LIMITED",
"SHREEDHAR LASERCUT PRIVATE LIMITED",
"SHREEDHAR PRINTERS PRIVATE LIMITED",
"SHREEDHI MILK AND FOOD PRODUCTS PRIVATE LIMITED",
"SHREEDURGA CHEMFOOD PRIVATE LIMITED",
"SHREEG AUTOMECH PRIVATE LIMITED",
"SHREEGAJRAJ HOUSING NIRMAN PRIVATE LIMITED",
"SHREEGANESH CHILLIES PRIVATE LIMITED",
"SHREEGEE IMPEX PRIVATE LIMITED",
"SHREEGEE METRADE PRIVATE LIMITED",
"SHREEGEE PRIVATE LIMITED",
"SHREEGEN PHARMA LIMITED",
"SHREEGIRI SPINNERS PRIVATE LIMITED",
"SHREEGOPAL AUTO PRIVATE LIMITED",
"SHREEGOPAL CELLUCHEM PRIVATE LIMITED",
"SHREEGOPAL CONCRETE PRIVATE LIMITED",
"SHREEGOPAL GOBIND AGRO TECH PRIVATE LIMITED",
"SHREEGOPAL GOVIND SPONGE PRIVATE LIMITED",
"SHREEGURU REAL ESTATES PRIVATE LIMITED",
"SHREEHANS HOLDING PVT LTD",
"SHREEHARI BUILDHEIGHT PRIVATE LIMITED",
"SHREEHARI ENGINEERING SOLUTIONS PRIVATE LIMITED",
"SHREEHARI INFRACITY PRIVATE LIMITED",
"SHREEHARI ISPAT PRIVATE LIMITED",
"SHREEHARI JEWELLERY PRIVATE LIMITED",
"SHREEHARI SAREES PRIVATE LIMITED",
"SHREEHARI STEELEX PRIVATE LIMITED",
"SHREEJA DEVCON PRIVATE LIMITED",
"SHREEJA INDUSTRIAL SOLUTION PRIVATE LIMITED",
"SHREEJA MAHILA MILK PRODUCER COMPANY LIMITED",
"SHREEJA MULTIFILMS PRIVATE LIMITED",
"SHREEJAY WEALTH ADVISORS PRIVATE LIMITED",
"SHREEJEE COTTON MILLS PRIVATE LIMITED",
"SHREEJEE GEMS AND JEWELS PRIVATE LIMITED",
"SHREEJEE JEWELLERS PRIVATE LIMITED",
"SHREEJEE METPLAS PRIVATE LIMITED",
"SHREEJEE NEW COLLECTIONS PRIVATE LIMITED",
"SHREEJEE STRUCTURAL STEEL PRIVATE LIMITED",
"SHREEJEE SYNPACKS PRIVATE LIMITED",
"SHREEJEE TIMBER MERCHANTS PRIVATE LIMITED",
"SHREEJEE TRAVELS AND TOURS",
"SHREEJI ADVISORY SERVICES PRIVATE LIMITED",
"SHREEJI AGRI COMMODITY PRIVATE LIMITED",
"SHREEJI AIR PRODUCTS PRIVATE LIMITED",
"SHREEJI ALLOY STEEL CENTRE PRIVATE LIMITED",
"SHREEJI ANALYTICAL AND RESEARCH LABORATORIES PRIVATE LIMITED",
"SHREEJI AQUA TREATMENT PRIVATE LIMITED",
"SHREEJI ASSOCIATES",
"SHREEJI AUTOMART PRIVATE LIMITED",
"SHREEJI AUTOMOBILES PRIVATE LIMITED",
"SHREEJI AVIATION PRIVATE LIMITED",
"SHREEJI BATHJEWELS PRIVATE LIMITED",
"SHREEJI BLOCKS PRIVATE LIMITED",
"SHREEJI BUILDMART PRIVATE LIMITED",
"SHREEJI CALECHEM PRIVATE LIMITED",
"SHREEJI CAPITAL AND FINANCE LIMITED",
"SHREEJI CARBONIC GASES",
"SHREEJI CATTLE FOODS PRIVATE LIMITED",
"SHREEJI CERACASA PRIVATE LIMITED",
"SHREEJI COATERS PRIVATE LIMITED",
"SHREEJI COMSEC INDIA PRIVATE LIMITED",
"SHREEJI CONSTRUCTION",
"SHREEJI CORN PRODUCTS PRIVATE LIMITED",
"SHREEJI DAHOD AUTO PRIVATE LIMITED",
"SHREEJI DEVCON (INDIA) PRIVATE LIMITED",
"SHREEJI DISTRIBUTORS PHARMA PRIVATE LIMITED",
"SHREEJI ELECTRO POWER PRIVATE LIMITED",
"SHREEJI ENTERPRISE",
"SHREEJI EPC PRIVATE LIMITED",
"SHREEJI EYE CARE PRIVATE LIMITED",
"SHREEJI FACADE SYSTEMS PRIVATE LIMITED",
"SHREEJI FASHIONS PRIVATE LIMITED",
"SHREEJI FERROALLOYS PRIVATE LIMITED",
"SHREEJI FIBRE PRIVATE. LIMITED.",
"SHREEJI FINE CHEM PRIVATE LIMITED",
"SHREEJI FONES PRIVATE LIMITED",
"SHREEJI FOODS PRIVATE LIMITED",
"SHREEJI GEMS LTD",
"SHREEJI HONEY (INDIA) PRIVATE LIMITED",
"SHREEJI HOSPITALITY GLOBAL PRIVATE LIMITED",
"SHREEJI HR SOLUTIONS PRIVATE LIMITED",
"SHREEJI ICECREAM PRIVATE LIMITED",
"SHREEJI IMAGING AND DIAGNOSTIC CENTRE PRIVATE LIMITED",
"SHREEJI INDUSTRIAL ENGINEERS (BOMBAY) PRIVATE LIMITED",
"SHREEJI INFRAPROJECTS PRIVATE LIMITED.",
"SHREEJI INFRASPACE PRIVATE LIMITED",
"SHREEJI INFRASTRUCTURE INDIA PRIVATE LIMITED",
"SHREEJI INNOVA WALLCOVERINGS PRIVATE LIMITED",
"SHREEJI KAJUWALA PRIVATE LIMITED",
"SHREEJI KELA PAPERS PRIVATE LIMITED",
"SHREEJI KOSH SERVICES PRIVATE LIMITED",
"SHREEJI LEATHER BELTS AND STORES",
"SHREEJI LIQUID STORAGE TERMINALS PRIVATE LIMITED",
"SHREEJI LOGISTIC TRADING CO",
"SHREEJI MEDIQUIP PRIVATE LIMITED",
"SHREEJI MINECHEM PRIVATE LIMITED",
"SHREEJI MOULDS PRIVATE LIMITED",
"SHREEJI ORNAMENTS PRIVATE LIMITED",
"SHREEJI PACKERS PRIVATE LIMITED",
"SHREEJI PESTICIDES PRIVATE LIMITED",
"SHREEJI PHARMA EQUIPMENT PRIVATE LIMITED",
"SHREEJI PHARMADEAL PRIVATE LIMITED",
"SHREEJI PHARMAWORLD PRIVATE LIMITED",
"SHREEJI POLYFAB PRIVATE LIMITED",
"SHREEJI PRINTS PRIVATE LIMITED",
"SHREEJI PROCESS CONTROL PRIVATE LIMITED",
"SHREEJI PROPACK PRIVATE LIMITED",
"SHREEJI RAYON PRIVATE LIMITED",
"SHREEJI REALTIES PRIVATE LIMITED",
"SHREEJI SECURITY & MANPOWER SERVICES PRIVATE LIMITED",
"SHREEJI SHIPPING SERVICES INDIA LIMITED",
"SHREEJI SPACELINKS PRIVATE LIMITED",
"SHREEJI SPACIO SOLUTIONS PRIVATE LIMITED",
"SHREEJI SS PLYWOOD INDUSTRY PRIVATE LIMITED",
"SHREEJI SULZ PRIVATE LIMITED",
"SHREEJI SURFACE COATINGS PRIVATE LIMITED",
"SHREEJI TEXPRO PVT LTD",
"SHREEJI TEXTILES",
"SHREEJI TEXTILES PRIVATE LIMITED",
"SHREEJI TRADELINK PRIVATE LIMITED",
"SHREEJI TRANSLOGISTICS LIMITED",
"SHREEJI VITRIFIED PRIVATE LIMITED",
"SHREEJI WEAVING MILLS PRIVATE LIMITED",
"SHREEJI WIRE INDUSTRIES DHULE",
"SHREEJI WOODCRAFT PRIVATE LIMITED",
"SHREEJI WOODPLY PRIVATE LIMITED",
"SHREEJI YARN (INDIA) PRIVATE LIMITED",
"SHREEJIDHAM HOTELS AND RESORTS PRIVATE LIMITED",
"SHREEJIKRUPA PROJECT LIMITED",
"SHREEKALA AEROMATIC PRIVATE LIMITED",
"SHREEKALA INTERMEDIATE PRIVATE LIMITED",
"SHREEKANT OILS PRIVATE LIMITED",
"SHREEKANTH BUILDTRON PRIVATE LIMITED",
"SHREEKAR POLYSTER PRIVATE LIMITED",
"SHREEKAVIRAJ INFRATECH PRIVATE LIMITED",
"SHREEKEERTI PROPERTIES PRIVATE LIMITED",
"SHREEKISHAN INFOCOM PRIVATE LIMITED",
"SHREEKRIPA AUTOMOBILES PRIVATE LIMITED",
"SHREEKRISHNA AGRIDIET LIMITED",
"SHREEKRISHNA COTSYN PRIVATE LIMITED",
"SHREEKRISHNA IMPEX VENTURES PRIVATE LIMITED",
"SHREEKRISHNA LANDBASE PVIVATE LIMITED",
"SHREEKUNJ AAI LIMITED",
"SHREEKUNJ SECURITIES PVT LTD",
"SHREEKUSH MACHINERY &SPARES PVT.LTD",
"SHREELAXMI CREATION PRIVATE LIMITED",
"SHREELAXMI ENGINEERING PRIVATE LIMITED",
"SHREELAXMI ESTATE PRIVATE LIMITED",
"SHREELAXMI HOUSING PRIVATE LIMITED",
"SHREE-LAXMI TECHNOWELL (INDIA) PRIVATE LIMITED",
"SHREELAXMIKANTAM SALES PRIVATE LIMITED",
"SHREELIGHT POWER PRIVATE LIMITED",
"SHREELOK SUITING MILLS PRIVATE LIMITED",
"SHREEM AKARSH ELPLAST PRIVATE LIMITED",
"SHREEM AUTOMOBILES PRIVATE LIMITED",
"SHREEM BRZEE BIOCARE PRIVATE LIMITED",
"SHREEM DESIGN LLP",
"SHREEM MOTORS PRIVATE LIMITED",
"SHREEM PACKAGING PRODUCTS PRIVATE LIMITED",
"SHREEM REALTY PRIVATE LIMITED",
"SHREEM RESTAURANT AND BEVERAGES PRIVATE LIMITED",
"SHREEM SWARNAM DESIGN CONCEPTS PRIVATE LIMITED",
"SHREEM SWARNAM DIVINE PRODUCTS PRIVATE LIMITED",
"SHREEM VITRIFIED PRIVATE LIMITED",
"SHREEMA NUVOTECH PRIVATE LIMITED",
"SHREEMAHAKAAL CONCAST PRIVATE LIMITED",
"SHREEMAHAKALI AGRO FEED PRIVATE LIMITED",
"SHREEMAHAVEER HOME DECOR PRIVATE LIMITED",
"SHREEMAN AND AMAN INFRA PRIVATE LIMITED",
"SHREEMAN FZ PRIVATE LIMITED",
"SHREEMANJI BESAN PRIVATE LIMITED",
"SHREEMANT SHIVAJIRAJE COLLEGE OF HORTICULTURE PHALTAN",
"SHREEMARUTI INSTRUMENTS PRIVATE LIMITED",
"SHREEMATI FASHIONS PRIVATE LIMITED",
"SHREEMATI PARMA RATAN DEVI INTER COLLEGE MACHHLIGAON",
"SHREEMATI S B SOLANKI VIDHYALAYA",
"SHREEMATI SR GANATRA GUJRAT VIDHYALAYA PRATHMIK SHALA",
"SHREEMAYA AGRO INDUSTRIES PRIVATE LIMITED",
"SHREEMEERA ELECTRONIC SERVICES PRIVATE LIMITED",
"SHREEMIRRA FOOD INDUSTRIES PRIVATE LIMITED",
"SHREEMIX CONCRETE INDIA PRIVATE LIMITED",
"SHREEMOOKAMBIKA ENGINEERING PRIVATE LIMITED",
"SHREEMUKH NAMITHA HOMES PRIVATE LIMITED",
"SHREEMUL DAIRY PRIVATE LIMITED",
"SHREEMULTI STICKS & LABELS PRIVATE LIMITED",
"SHREENATH AGRO TECH PRIVATE LIMITED",
"SHREENATH CARS PRIVATE LIMITED",
"SHREENATH COLONIZER DEVELOPERS PRIVATE LIMITED",
"SHREENATH CONSTRUWELL PRIVATE LIMITED",
"SHREENATH CONTAINERS MOVEMENT PRIVATE LIMITED",
"SHREENATH ENCLAVES PRIVATE LIMITED",
"SHREENATH ENTERPRISES PRIVATE LIMITED",
"SHREENATH FINE CHEM INDIA PRIVATE LIMITED",
"SHREENATH FLEXOTECH PRIVATE LIMITED",
"SHREENATH INFRAPROJECTS PRIVATE LIMITED",
"SHREENATH INFRASOLUTIONS PRIVATE LIMITED",
"SHREENATH INVESTMENT COMPANY LIMITED",
"SHREENATH LIFESTYLE PRIVATE LIMITED",
"SHREENATH METCHEM PRIVATE LIMITED",
"SHREENATH MHASKOBA SAKHAR KARKHANA LIMITED",
"SHREENATH MINING WORKS PRIVATE LIMITED",
"SHREENATH MOTORS PRIVATE LIMITED",
"SHREENATH MULTITRADE PRIVATE LIMITED",
"SHREENATH PAPER PRODUCTS LIMITED",
"SHREENATH PLASTOPACK PVT LTD",
"SHREENATH POLYPLAST PRIVATE LIMITED",
"SHREENATH PRINTERS INDIA PRIVATE LIMITED",
"SHREENATH ROADWAYS PRIVATE LIMITED",
"SHREENATH SAFE DEPOSIT VAULT PRIVATE. LIMITED",
"SHREENATH SMART TECHNOLOGIES PRIVATE LIMITED",
"SHREENATH SPEDIATERS PRIVATE LIMITED",
"SHREENATH TERROLOCK WATERPROOFING PRIVATE LIMITED",
"SHREENATH TEXTILE PROCESSORS PVT LTD",
"SHREENATH TRAVELLERS PRIVATE LIMITED",
"SHREENATH VEHICLES PRIVATE LIMITED",
"SHREENATHJI APEX PRIVATE LIMITED",
"SHREENATHJI AUBERGE PRIVATE LIMITED",
"SHREENATHJI AUTOMOBILES PRIVATE LIMITED",
"SHREENATHJI BALAJI COMPUTECH PRIVATE LIMITED",
"SHREENATHJI CHEMFOOD PRIVATE LIMITED",
"SHREENATHJI COTGIN PRIVATE LIMITED",
"SHREENATHJI DEVELOPERS PRIVATE LIMITED",
"SHREENATHJI DWELLINGS PRIVATE LIMITED",
"SHREENATHJI GEMS AND JEWELS PRIVATE LIMITED",
"SHREENATHJI HEAVY ENGINEERS PRIVATE LIMITED",
"SHREENATHJI INFRA NETWORK PRIVATE LIMITED",
"SHREENATHJI ORGANISERS PRIVATE LIMITED",
"SHREENATHJI RASAYAN PVT.LTD.",
"SHREENATHJI TEXTILE INDUSTRIES PRIVATE LIMITED",
"SHREENATHJI VEGITABLE OIL INDUSTRIES PRIVATE LIMITED",
"SHREENATHJI WELDING & SAFETY PRIVATE LIMITED",
"SHREENATHJI WORLDWIDE PRIVATE LIMITED",
"SHREENATHJI-UDAIPUR TOLLWAY PRIVATE LIMITED",
"SHREENATHNAGRI HOSPITAL PRIVATE LIMITED",
"SHREENEELKAMAL GLASS PRIVATE LIMITED",
"SHREENIDHI JEWELLERY PRIVATE LIMITED",
"SHREENIDHI MINERALS PRIVATE LIMITED",
"SHREENIDHI OILS & FOODS INGREDIENTS PRIVATE LIMITED",
"SHREENIDHI RUBBER PRIVATE LIMITED",
"SHREENIVAS CHEMICALS PRIVATE LIMITED",
"SHREENIVASA AGRO & POULTRY FARM PRIVATE LIMITED",
"SHREENIWAS INNOVATIONS PRIVATE LIMITED",
"SHREENKIN LABELS PRIVATE LIMITED",
"SHREEOM ALLOY AND TUBES PRIVATE LIMITED",
"SHREEOMSREE PIPE FABRICATORS INDIA PRIVATE LIMITED",
"SHREEOSWAL PSYLLIUM EXPORTS INDIA LIMITED",
"SHREEOSWAL SEEDS AND CHEMICALS LIMITED",
"SHREEPA LOGISTICS PRIVATE LIMITED",
"SHREEPAD IMPORT EXPORT PRIVATE LIMITED",
"SHREEPAL GREEN FUTURES PRIVATE LIMITED",
"SHREEPAL STEEL",
"SHREEPARAM EXIM AND CARGO INDIA (OPC) PRIVATE LIMITED",
"SHREEPATI APARTMENTS PVT LTD",
"SHREEPATI BUILD INFRA INVESTMENT LIMITED",
"SHREEPATI COMPUTECH PRIVATE LIMITED",
"SHREEPATI HOLDING AND FINANCE PRIVATE LIMITED",
"SHREEPATI INFRA REALTY LIMITED",
"SHREEPATI PHARMACEUTICALS PVT LTD",
"SHREEPOWERTECH ALLIED PRIVATE LIMITED",
"SHREEPREMA INDUSTRIES AND ELECTRICALS PRIVATE LIMITED",
"SHREEPRIYA AUTO PARTS PRIVATE LIMITED",
"SHREEPRIYA STAMPING AND TOOLING PRIVATE LIMITED",
"SHREERADHA MADHAV HOSPITALITY SERVICES PRIVATE LIMITED",
"SHREERADHA ORNAMENT GALLERY PRIVATE LIMITED",
"SHREERAG ENGINEERING AND AUTO PRIVATE LIMITED",
"SHREERAJ DEVELOPER LLP",
"SHREERAJ INFRAHOUSING PRIVATE LIMITED",
"SHREERAJ ROTO INDIA LIMITED",
"SHREERAKSHA LABS PRIVATE LIMITED",
"SHREERAKSHYAN INFRACON PRIVATE LIMITED",
"SHREERAM BIZVENTURES INDIA PRIVATE LIMITED",
"SHREERAM BROKING & COMMODITIES PRIVATE LIMITED",
"SHREERAM BUILDCONS PRIVATE LIMITED",
"SHREERAM CHEMFOOD PRIVATE LIMITED",
"SHREERAM FIBRES INDIA PRIVATE LIMITED",
"SHREERAM HIGH SCHOOL",
"SHREERAM LOGISTICS PRIVATE LIMITED",
"SHREERAM METAFUSION ENGINEERS PVT LTD",
"SHREERAM TECHNOLOGY SERVICES PRIVATE LIMITED",
"SHREERAM VANIJYA GLOBAL EXIM PRIVATE LIMITED",
"SHREERAM VIDYALAYA AIROLI",
"SHREERAM VIDYALAYA AND JUNIOR COLLEGE OF SCIENCE",
"SHREERAMJI AGRO FOOD PRIVATE LIMITED",
"SHREERAMJI CLOTHING INDIA PRIVATE LIMITED",
"SHREERAMJI DEALTRADES PRIVATE LIMITED",
"SHREERANG VIDYALAYA",
"SHREERANGA POLYMERS PRIVATE LIMITED",
"SHREERANGAM PACKAGING PRIVATE LIMITED",
"SHREERATH FINANCIAL SERVICES PRIVATE LIMITED",
"SHREEROSE WEALTH VENTURES LIMITED",
"SHREERUKMANI SPUN FAB PRIVATE LIMITED",
"SHREESADGURU FASHION PRIVATE LIMITED",
"SHREESAI HOSPITAL & TRAUMA CENTER PRIVATE LIMITED",
"SHREESAI INTERMEDIATES PRIVATE LIMITED",
"SHREESAIBABA INFRAPROJECTS PRIVATE LIMITED",
"SHREESAMARTH TECH PROCESS ENGINEERING PRIVATE LIMITED",
"SHREESAMOR BULLION PRIVATE LIMITED",
"SHREESANMATI AUTOEXPERTS PRIVATE LIMITED",
"SHREESATYA HOLDINGS PRIVATE LIMITED",
"SHREESATYA ISPAT PRIVATE LIMITED",
"SHREESATYA METAL & ALLOYS PRIVATE LIMITED",
"SHREESATYA SPONGE & POWER PRIVATE LIMITED",
"SHREESATYA STEEL & POWER PRIVATE LIMITED",
"SHREESH IMPEX PRIVATE LIMITED",
"SHREESH VENEERS PRIVATE LIMITED",
"SHREESHA FABS AND HANDLOOMS PRIVATE LIMITED",
"SHREESHAIL CHEMICALS PRIVATE LIMITED",
"SHREESHAKTI MOTORS AND FREIGHT CARRIERS PRIVATE LIMITED",
"SHREESHAKTI SYN BAGS PRIVATE LIMITED",
"SHREESHAN ENGENTERPRISE PRIVATE LIMITED",
"SHREESHANKAR JEWELLERS PRIVATE LIMITED",
"SHREESHARDA POLY TECHNO PRIVATE LIMITED",
"SHREESHAY ENGINEERS LIMITED",
"SHREESHILPA FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"SHREESHIVAM INFRAWAY PRIVATE LIMITED",
"SHREESHIVKARNI INDUSTRIES PRIVATE LIMITED",
"SHREESHRUTI EDUCATION FOUNDATION",
"SHREESHYAM AGRO PROTEINS PRIVATE LIMITED",
"SHREESHYAM METALIKS PRIVATE LIMITED",
"SHREESHYAM OLEO CHEMICALS PRIVATE LIMITED",
"SHREESHYAM TRADE VENTURES PRIVATE LIMITED",
"SHREESIDDHI AGROTECH PRIVATE LIMITED",
"SHREESOLAR VENTURES PRIVATE LIMITED",
"SHREESON TECHNOLOGIES PRIVATE LIMITED",
"SHREESR TRADING PRIVATE LIMITED",
"SHREESRI BUILDTECH PRIVATE LIMITED",
"SHREESURABHI POLYMERS PRIVATE LIMITED",
"SHREESURYA PHARMA PRIVATE LIMITED",
"SHREESURYA RICE MILL PVT LTD",
"SHREESWASTIK PLASTIC INDUSTRIES PRIVATE LIMITED",
"SHREETECH DATA LIMITED",
"SHREETECH LIFE SCIENCES PRIVATE LIMITED",
"SHREEVALLABH ASHRAM ENGLISH MEDIUM SCHOOL",
"SHREEVARI ENERGY SYSTEMS PRIVATE LIMITED",
"SHREEVEER ORGANICS AGRO INDIA PRIVATE LIMITED",
"SHREEVIDYA PLANT & EQUIPMENTS PRIVATE LIMITED",
"SHREEVIM INFRA PROJECTS PRIVATE LIMITED",
"SHREEYA FABTECH PRIVATE LIMITED",
"SHREEYA GAURISUTA COMMERCE PRIVATE LIMITED",
"SHREEYA PEANUTS PRIVATE LIMITED",
"SHREEYA POLYFAB PRIVATE LIMITED",
"SHREEYA SYNCOTEX PRIVATE LIMITED",
"SHREEYAM POWER AND STEEL INDUSTRIES LIMITED",
"SHREEYANSH DB SOFTWARE PRIVATE LIMITED",
"SHREEYANSH LABS PRIVATE LIMITED",
"SHREEYASH COLLEGE OF ENGINEERING AND TECHNOLOGY",
"SHREEYASH HOSPITALS PRIVATE LIMITED",
"SHREEYUM FOODS PRIVATE LIMITED",
"SHREJAL IMPEX PRIVATE LIMITED",
"SHREM AIRPORT HOTELS PRIVATE LIMITED",
"SHREM CONSTRUCTION PRIVATE LIMITED",
"SHREM FINANCIAL PRIVATE LIMITED",
"SHREM IMPEX PRIVATE LIMITED",
"SHREM INFRA INVEST PRIVATE LIMITED",
"SHREM INVESTMENTS PRIVATE LIMITED",
"SHREM LIGHT PRIVATE LIMITED",
"SHREM RESORT PRIVATE LIMITED",
"SHREM ROAD PROJECTS PRIVATE LIMITED",
"SHRENI SHARES LIMITED",
"SHRENIC SPINNERS PRIVATE LIMITED",
"SHRENIK DIAMOND PRIVATE LIMITED",
"SHRENIK LIMITED",
"SHRENIK MARBLE PRIVATE LIMITED",
"SHRENIK PROPERTIES PRIVATE LIMITED",
"SHRENO LIMITED",
"SHRERIT AUTO PRIVATE LIMITED",
"SHRESHAY EXIM PRIVATE LIMITED",
"SHRESHT ALLOYS PRIVATE LIMITED",
"SHRESHT CORPORATE ADVISORS PRIVATE LIMITED",
"SHRESHT INDUSTRIES PRIVATE LIMITED",
"SHRESHTH COMPUTERS AND COMMUNICATIONS PRIVATE LIMITED",
"SHRESHTH REALTECHNOLOGIES PRIVATE LIMITED",
"SHRESHTHA AUTOMOTIVES PRIVATE LIMITED",
"SHRESHTHA BUSINESS SOLUTIONS LLP",
"SHRESHTHA WELLNESS PRIVATE LIMITED",
"SHRESSHATH POLYCHEM PRIVATE LIMITED",
"SHRESTA E-TECHNOLOGIES PRIVATE LIMITED",
"SHRESTA NUTRITIONS PRIVATE LIMITED",
"SHRESTA SOLVENTS PRIVATE LIMITED",
"SHRESTH BAGS PRIVATE LIMITED",
"SHRESTH DETECTIVE AND SECURITIES PRIVATE LIMITED",
"SHRESTH PACKWELL PRIVATE LIMITED",
"SHRESTHA BHARAT ELEVATOR PRIVATE LIMITED",
"SHRESTHA CHEMICALS PRIVATE LIMITED",
"SHRESTHA COLD STORAGE PRIVATE LIMITED",
"SHRESTHA HEALTHCARE & MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"SHRESTHA STONES PRIVATE LIMITED",
"SHRESTHABHISHEK BUILDCON PRIVATE LIMITED",
"SHREWD CONSTRUCTIONS PRIVATE LIMITED",
"SHREWD TECHLINK SERVICES PRIVATE LIMITED",
"SHREWDIFY TECHNOLOGIES PRIVATE LIMITED (OPC)",
"SHREY AUTOMOTIVES HYDERABAD PRIVATE LIMITED",
"SHREY COMMUNICATIONS PRIVATE LIMITED",
"SHREY ELECTRO SALES PRIVATE LIMITED",
"SHREY FINANCE AND INVESTMENTS PVT LTD",
"SHREY INFOTECH PRIVATE LIMITED",
"SHREY INSTITUTE OF NURSING AND ALLIED SCIENCES",
"SHREY MULTI FACILITIES PRIVATE LIMITED",
"SHREY NUTRACEUTICALS AND HERBALS PRIVATE LIMITED",
"SHREY RAJ ELECTRO PRIVATE LIMITED",
"SHREY SOFTWARE PRIVATE LIMITED",
"SHREYA AGRO FOODS LIMITED",
"SHREYA APPARELS (INDIA) PRIVATE LIMITED",
"SHREYA BROADCASTING PRIVATE LIMITED",
"SHREYA DRUK-YUL POWERTECH PRIVATE LIMITED",
"SHREYA ENGITECH PRIVATE LIMITED",
"SHREYA ENTERPRISES",
"SHREYA EX-TECH PRIVATE LIMITED",
"SHREYA FERTILIZERS PRIVATE LIMITED",
"SHREYA FURNICRAFT PRIVATE LIMITED",
"SHREYA HEALTH PAVILION PVT LTD",
"SHREYA HOSPITALITY SERVICES PRIVATE LIMITED",
"SHREYA INFRA CONSTRUCTION PRIVATE LIMITED",
"SHREYA LIFE SCIENCES PRIVATE LIMITED",
"SHREYA MEDICARE PRIVATE LIMITED",
"SHREYA MICROPLAST PRIVATE LIMITED",
"SHREYA MULTISPECIALITY HOSPITAL PRIVATE LIMITED",
"SHREYA PETROCHEM PRIVATE LIMITED",
"SHREYA PRINT PRIVATE LIMITED",
"SHREYA RICE MILL INDUSTRIES PRIVATE LIMITED",
"SHREYA SAI ENGINEERING",
"SHREYA SAUMYA CONSTRUCTIONS PRIVATE LIMITED",
"SHREYA SHUDH FOOD PACKAGINGS PRIVATE LIMITED",
"SHREYA SPLINE GAUGES & TOOLS PRIVATE LIMITED",
"SHREYA STEEL AND AGRO PRIVATE LIMITED",
"SHREYA STRIPS PRIVATE LIMITED",
"SHREYAAS HEALTH CARE PRODUCTS PRIVATE LIMITED",
"SHREYACAR AGENCIES INDIA PRIVATE LIMITED",
"SHREYADITA PROPERTIES PRIVATE LIMITED",
"SHREYAL CHEM (INDIA) PRIVATE LIMITED",
"SHREYANS AUTO AND COMPONENTS PRIVATE LIMITED",
"SHREYANS CREATION GLOBAL LIMITED",
"SHREYANS INDUSTRIES LIMITED",
"SHREYANS OIL LIMITED",
"SHREYANS OILS PRIVATE LIMITED",
"SHREYANS OVERSEAS PRIVATE LIMITED",
"SHREYANS PACKAGING",
"SHREYANS PRINTS PVT LTD",
"SHREYANS VANIJYA PRIVATE LIMITED",
"SHREYANS WIRES LIMITED",
"SHREYANS YARN PROCESSORS PRIVATE LIMITED",
"SHREYANSH HEALTHCARE PRIVATE LIMITED",
"SHREYANSH INNOVATIONS PRIVATE LIMITED",
"SHREYANSH MARBLE TILES PRIVATE LIMITED",
"SHREYANSH STATIONERY PRIVATE LIMITED",
"SHREYANSH TRADING AND CONSTRUCTIONS PRIVATE LIMITED",
"SHREYANSH UDYOG PRIVATE LIMITED",
"SHREYANSHI HEALTHCARE PRIVATE LIMITED",
"SHREYAS AUTO ENGINEERING PRIVATE LIMITED",
"SHREYAS COTTONS GINNING & PRESSING FACTORY",
"SHREYAS FOUNDATION",
"SHREYAS HOLDING PRIVATE LIMITED",
"SHREYAS INCORPORATION",
"SHREYAS INDIA PRIVATE LIMITED",
"SHREYA'S INDIA PRIVATE LIMITED",
"SHREYAS INTEGRATED SYSTEMS PRIVATE LIMITED",
"SHREYAS MORAKHIA AND FAMIILY ASSETS PRIVATE LIMITED",
"SHREYAS PETROLEUM ADDITIVES LIMITED",
"SHREYAS RENEWABLE ENERGY PRIVATE LIMITED",
"SHREYAS SHIPPING AGENCIES PRIVATE LIMITED",
"SHREYAS SHIPPING AND LOGISTICS LIMITED",
"SHREYAS SOLARFARMS LIMITED",
"SHREYAS SORTEX INDUSTRIES PRIVATE LIMITED",
"SHREYAS STONES PRIVATE LIMITED",
"SHREYAS TECH SOLUTIONS PRIVATE LIMITED",
"SHREYAS TECHNOSOFT PRIVATE LIMITED",
"SHREYASH ALUMINIUM & ALLOYS PRIVATE. LIMITED.",
"SHREYASH BIOTECH PRIVATE LIMITED",
"SHREYASH INSURANCE BROKERS PRIVATE LIMITED",
"SHREYASH RESOURCES PRIVATE LIMITED",
"SHREYASH RETAIL PRIVATE LIMITED",
"SHREYES CHAKRA VENTURES PRIVATE LIMITED",
"SHREYONIDHI ENTERPRISES (INDIA) PRIVATE LIMITED",
"SHREYSHA TEXTILES PRIVATE LIMITED",
"SHREYSHREE SELECTIONS PRIVATE LIMITED",
"SHRI A K DOSHI VIDHYALAYA",
"SHRI AADINATH DEVELOPERS PRIVATE LIMITED",
"SHRI AADINATH MERCANTILE AND EXPORTS PRIVATE LIMITED",
"SHRI AADINATH TECHMECH PRIVATE LIMITED",
"SHRI AANDAL LOGISTICS",
"SHRI AAVISHKAR METALS PRIVATE LIMITED",
"SHRI AAYANA RUDRA REKHA DEVELOPERS PRIVATE LIMITED",
"SHRI ADARSH INTER COLLEGE MATHURA",
"SHRI ADARSH SHIKSHA NIKETAN INTER COLLEGE BAREILLY",
"SHRI ADARSH VIDHYAVIHAR UJALESHVER",
"SHRI ADHYA EDUCATIONAL BOOKS PRIVATE LIMITED",
"SHRI ADINATH EEQUIPMENTS PRIVATE LIMITED",
"SHRI ADINATH FASHIONS PRIVATE LIMITED",
"SHRI ADINATH MINERAL INDUSTRIES PRIVATE LIMITED",
"SHRI ADINATH UTENSILS PRIVATE LIMITED",
"SHRI ADITHYA HOSPITALS",
"SHRI ADITYA MENTHOL PRIVATE LIMITED",
"SHRI ADITYA RAJ MILKPROTIENS PRIVATE LIMITED",
"SHRI AGRASEN FLOUR MILLS PRIVATE LIMITED",
"SHRI AGRASEN REFINERY PRIVATE LIMITED",
"SHRI AGRASEN WHEAT PRODUCTS PRIVATE LIMITED",
"SHRI AGRAWAL EDUCATIONAL AND CULTURAL SOCIETY",
"SHRI AHIMSA NATURALS LIMITED",
"SHRI AKRUTI ENGINEERING",
"SHRI AKSHAYAM FOODS AND CATERING PRIVATE LIMITED",
"SHRI AMARANARAYANA HORTICULTURE FARMERS PRODUCER COMPANY LIMITED",
"SHRI AMARNATH MILKFOODS PRIVATE LIMITED",
"SHRI AMBAJI FOOD PRODUCTS PRIVATE LIMITED",
"SHRI AMBAJI PULVERSING PRIVATE LIMITED",
"SHRI AMBALAL CHATURBHAI JEWELS PRIVATE LIMITED",
"SHRI AMBALIKA SUGAR PRIVATE LIMITED",
"SHRI AMBICA MASTERBATCH PRIVATE LIMITED",
"SHRI AMBICA POLYMER PRIVATE LIMITED",
"SHRI AMBIKA AGRO PRIVATE LIMITED",
"SHRI AMBIKA METALIKS PRIVATE. LIMITED.",
"SHRI AMLA PROCESSING PRIVATE LIMITED",
"SHRI AMMAN STEEL AND ALIED INDUSTRIES PRIVATE LIMITED",
"SHRI AMRUT VIDHYALAYA ODHAV.",
"SHRI ANAGHA DATTA HOSPITAL",
"SHRI ANANDESHWAR PRESERVATIONS PRIVATE LIMITED",
"SHRI ANANT STEEL PRIVATE LIMITED",
"SHRI ANANT SYNTEX LIMITED",
"SHRI ANGALAMMAN COLLEGE OF ENGG & TECH",
"SHRI ANIKAISH INVESTMENTS PRIVATE LIMITED",
"SHRI ANJANEYA DEVELOPERS PRIVATE LIMITED",
"SHRI ANNALAKSHMI SPINNING PRIVATE. LIMITED.",
"SHRI ANNAMALAI AGRO PRODUCTS PRIVATE LIMITED",
"SHRI ANNAPOORNA INFRASTRUCTURE PRIVATE LIMITED",
"SHRI ANNAPURNA INDUSTRIES",
"SHRI ANNAPURNA RICE MILLS",
"SHRI ANNAPURNA ROLLER FRESH PRIVATE LIMITED",
"SHRI ARIHANT CO-OPERATIVE BANK LIMITED",
"SHRI ARIHANT DISTRIBUTORS PRIVATE LIMITED",
"SHRI ARUNA CONSTRUCTIONS PRIVATE LIMITED",
"SHRI ARYAVARAT TRADING CO LTD",
"SHRI ASARAMJI BHANDWALDAR ARTS COMMERCE & SCIENCE",
"SHRI ASARAMJI BHANDWALDAR ARTS COMMERCE & SCIENCE COLLEGE",
"SHRI ASARAMJI BHANDWALDAR ARTS COMMERCE & SCIENCE COLLEGE DEOGAON",
"SHRI ASHAPURA RUBBER PRIVATE LIMITED",
"SHRI ASHUTOSH STRUCTURES PRIVATE. LIMITED.",
"SHRI ATMARAM COLD STORAGE AND ICE FACTORY PRIVATE LIMITED",
"SHRI AURBINDO INSTITUTE OF MEDICAL SCIEN",
"SHRI AUTOMOBILES (INDORE) PRIVATE LIMITED",
"SHRI AVAYA SKILL DEVELOPMENT INDIA PRIVATE LIMITED",
"SHRI AYURVED SEVA SADAN PRIVATE LIMITED",
"SHRI AYURVEDIK COLLEGE",
"SHRI AYYAPPA FORGINGS PRIVATE LIMITED",
"SHRI B D MEHTA MAHAVIR HEART INSTITUTE",
"SHRI B M PATIL MEDICAL COLLEGE HOSPITAL AND RESEARCH CENTRE",
"SHRI BABA DHARSHU CREATION PRIVATE LIMITED",
"SHRI BABULAL POLYURETHANE PRODUCTS PRIVATE LIMITED",
"SHRI BADRINATH INVESTMENT PRIVATE LIMITED",
"SHRI BADRINATH KEDARNATH MANDIR SAMITI",
"SHRI BADRINATH VAIKALPIK URJA LIMITED",
"SHRI BAHUBALI TRADERS PVT LTD",
"SHRI BAJRANG ALLIANCE LIMITED",
"SHRI BAJRANG POWER AND ISPAT LIMITED",
"SHRI BAJRANGBALI ASHOK CONSTRUCTION PRIVATE LIMITED",
"SHRI BAJRANGBALI JUTE PRODUCTS PRIVATE LIMITED",
"SHRI BALAJEE NEST BUILDER PRIVATE LIMITED",
"SHRI BALAJEE PALACE PRIVATE LIMITED",
"SHRI BALAJI (INDIA) PVT. LTD.",
"SHRI BALAJI AAROGYAM HOSPITAL PRIVATE LIMITED",
"SHRI BALAJI ASSOCIATES",
"SHRI BALAJI BUILDMATE PRIVATE LIMITED",
"SHRI BALAJI BUSINESS HOUSE PRIVATE LIMITED",
"SHRI BALAJI COMPONENTS",
"SHRI BALAJI CORRUPACK INDUSTRIES PRIVATE LIMITED",
"SHRI BALAJI ENTERPRISE",
"SHRI BALAJI ENTERPRISES",
"SHRI BALAJI EXPOTRADE PRIVATE LIMITED",
"SHRI BALAJI FABMARK PRIVATE LIMITED",
"SHRI BALAJI FANCYDIAM PRIVATE LIMITED",
"SHRI BALAJI FINISHING MILLS PRIVATE LIMITED",
"SHRI BALAJI FRUITS PRIVATE LIMITED",
"SHRI BALAJI GINNING FACTORY",
"SHRI BALAJI HANDLOOMS PRIVATE LIMITED",
"SHRI BALAJI INDUSTRIAL ENGINEERING LIMITED",
"SHRI BALAJI INDUSTRIAL PRODUCTS LIMITED",
"BALAJI INDUSTRIES",
"SHRI BALAJI INFRADEVELOPERS PRIVATE LIMITED",
"SHRI BALAJI INFRAPORT PRIVATE LIMITED",
"SHRI BALAJI INSTITUTE OF MEDICAL SCIENCE MOWA",
"SHRI BALAJI INSTITUTE OF MEDICAL SCIENCE PRIVATE LIMITED",
"SHRI BALAJI INSTITUTE OF NURSING PRIVATE LIMITED",
"SHRI BALAJI INTERNATIONAL SCHOOL",
"SHRI BALAJI KRAFT PAPER PRIVATE LIMITED",
"SHRI BALAJI KRIPA AGRO PROCESSING PRIVATE LIMITED",
"SHRI BALAJI MANAGEMENT AND HR SOLUTION PRIVATE LIMITED",
"SHRI BALAJI MAT INDUSTRIES PRIVATE LIMITED",
"SHRI BALAJI METACAST PRIVATE LIMITED",
"SHRI BALAJI METALTECH PRIVATE LIMITED",
"SHRI BALAJI MOULDS PRIVATE LIMITED",
"SHRI BALAJI MULTI DESIGNS PRIVATE LIMITED",
"SHRI BALAJI MULTIMETALS PRIVATE LIMITED",
"SHRI BALAJI PAPER PACK PRIVATE LIMITED",
"SHRI BALAJI POLYMERS PRIVATE LIMITED",
"SHRI BALAJI PRESSES PRIVATE LIMITED",
"SHRI BALAJI RAJGHARANA SAREES PRIVATE LIMITED",
"SHRI BALAJI RICE PRODUCTS PRIVATE LIMITED",
"SHRI BALAJI ROADWAYS INDIA LIMITED",
"SHRI BALAJI ROLLINGS PRIVATE LIMITED",
"SHRI BALAJI SHIPPING SOLUTIONS PRIVATE LIMITED",
"SHRI BALAJI SOLVEX PRIVATE LIMITED",
"SHRI BALAJI SUGARS AND CHEMICALS PRIVATE LIMITED",
"SHRI BALAJI SWAMI MINERALS PRIVATE LIMITED",
"SHRI BALAJI THINK MEDIA PRIVATE LIMITED",
"SHRI BALAJI TRACTORS AND FARM EQUIPMENT PRIVATE LIMITED",
"SHRI BALAJI TRADEMART(INDIA)PRIVATE LIMITED",
"SHRI BALAJI TRAINING PRIVATE LIMITED",
"SHRI BALAJI UNIVERSITY PUNE",
"SHRI BALAJI VALVE COMPONENTS LIMITED",
"SHRI BALAJIMAHARAJ INFRATECH PRIVATE LIMITED",
"SHRI BALASAHEB TIRPURDE COLLEGE OF HOTEL",
"SHRI BALKISHAN AGARWAL GLASS INDUSTRIES PRIVATE LIMITED",
"SHRI BALVEER SINGH ICE & COLD STORAGE PRIVATE LIMITED",
"SHRI BANKAY BIHARI SAREES PRIVATE LIMITED",
"SHRI BANKEY BIHARI AUTO PRIVATE LIMITED",
"SHRI BANKEY BIHARI BEVERAGES PRIVATE LIMITED",
"SHRI BANKEY BIHARI COTTON INDUSTRIES PRIVATE LIMITED",
"SHRI BANKEY BIHARI GARMENTS PRIVATE LIMITED",
"SHRI BANKEY FOODS & BEVERAGES PRIVATE LIMITED",
"SHRI BANSIDHAR AGGARWAL MODEL SCHOOL",
"SHRI BAPURAVJI KHARKAR VIDYALAY SUKLI",
"SHRI BARANI EDUCATIONAL FOUNDATION",
"SHRI BARSANA CREATIONS PRIVATE LIMITED",
"SHRI BARSANA E-VEHICLES PRIVATE LIMITED",
"SHRI BASAVA TEXTILES LIMITED",
"SHRI BEERESHWAR CO-OPERATIVE CREDIT SOCIETY LTD",
"SHRI BEERESHWAR SOUHARD CREDIT SAHAKARI LIMITED",
"SHRI BHAGATJEE ISPAT LIMITED",
"SHRI BHAGATJI SURGICALS PRIVATE LIMITED",
"SHRI BHAGAVAAN GARDEN PRIVATE LIMITED",
"SHRI BHAGAVATI BRIGHT BARS LTD",
"SHRI BHAGIYALAKSHMI TRAVELS",
"SHRI BHAGVATI VIDHYALAYA",
"SHRI BHAGWAN AGRO MILLS PRIVATE LIMITED",
"SHRI BHAGWAN DIAGNOSTIC AND IMAGING CENTRE PRIVATE LIMITED",
"SHRI BHAGWAN PROJECTS PRIVATE LIMITED",
"SHRI BHAGWAT PULSES PRIVATE LIMITED",
"SHRI BHAGWATI AGRO INDUSTRIES PVT LTD",
"SHRI BHAGWATI FLOUR MILLS PRIVATE. LIMITED.",
"SHRI BHAGWATI MACHINES PRIVATE LIMITED",
"SHRI BHAGYODAYA METALS PRIVATE LIMITED",
"SHRI BHAIRAV SUPER SERVICES PRIVATE LIMITED",
"SHRI BHAIRAV VIDYALAY PALAVE KHURD TA PALNER DIST AHMEDNAGAR",
"SHRI BHAIRAVNATH VIDYALAY PALDE KHURD PARNER",
"SHRI BHAKTI MEDICAL AGENCIES PRIVATE LIMITED",
"SHRI BHARATSINH GEMALSINH MAKWANA COLLEGE OF NURSING",
"SHRI BHARTIMAIYA MEMORIAL FOUNDATION",
"SHRI BHARTIYA SANSKRITI SHIKSHA SANSTHAN",
"SHRI BHAUSAHEB T T SALUNKHE COMMERCE AND G R PANDIT SCIENCE COLLEGE",
"SHRI BHAUSAHEBHIRE GOVERNMENT MEDICAL COLLEGE DHULE",
"SHRI BHAVSINHJI POLYTECHNIC INSTITUTE",
"SHRI BHOLA NATH SARRF INTER COLLEGE JAGNER",
"SHRI BHOLANATH CARPETS LIMITED",
"SHRI BIHARI LAL INTER COLLEGE ALIGARH",
"SHRI BIJAIRAJ SAJJANRAJ MOOTHA GIRLS SENIOR SECONDARY SCHOOL",
"SHRI BINZANI NAGAR COLLEGE",
"SHRI BIRLA BUILDMAT PRIVATE LIMITED",
"SHRI BISHANLAL SARAF AND SONS PRIVATE LIMITED",
"SHRI BOHRA GANESHJI TRADELINK PRIVATE LIMITED",
"SHRI BRAHMA PAPER MILLS PRIVATE LIMITED",
"SHRI BRAMMAADURGA ENGINEERING PRIVATE LIMITED",
"SHRI BRIJ SECURITIES PRIVATE LIMITED",
"SHRI BUDDHSEN PREMCHAND INTER COLLEGE BAHLOLPUR",
"SHRI BUILDUP PRIVATE LIMITED",
"SHRI BULIDAN RATHI MUK BADHIR VIDYALAY",
"SHRI CHAITANYA SEVA TRUST",
"SHRI CHAKRADHAR TEXTILES PVT LTD",
"SHRI CHALUKYA EDUCATION SOCIETY'S",
"SHRI CHAMELI DEVI INTER COLLEGE",
"SHRI CHAMUNDA MULTIMETALS PRIVATE LIMITED",
"SHRI CHAMUNDESWARI MINERALS LIMITED",
"SHRI CHANANI ALLOY STEELS PRIVATE LIMITED",
"SHRI CHAND COMPUTERS PRIVATE LIMITED",
"SHRI CHAND PRADEEP KUMAR PRIVATE LIMITED",
"SHRI CHANDRA BULK CARGO SERVICES PRIVATE LIMITED",
"SHRI CHATRAPATI SHAHU PRATHAMIK ASHRAMSHALA BARDAPUR",
"SHRI CHATRAPATI SHIVAJI MAHARAJ GANERAL HOSPITAL SOLAPUR",
"SHRI CHATRAPATI SIVAJI MAHARAJ SARVOPCHAR RUGNALAY SOLAPUR",
"SHRI CHHATRAPATI RAJARSHI SHAHU URBAN CO-OP BANK LTD",
"SHRI CHHATRAPATI SHIVAJIRAJE COLLEGE OF ENGINEERING",
"SHRI CHITRAPUR TILES PRIVATE LIMITED",
"SHRI CHOUDESVARI SILKS PRIVATE LIMITED",
"SHRI COIMBATORE JEWELLERS INDIA PRIVATE LIMITED",
"SHRI COLONIZERS AND DEVELOPERS PRIVATE LIMITED",
"SHRI CP INTER COLLEGE",
"SHRI D K KOLATE PATIL JR COLLEGE TEKEPAR",
"SHRI D MANJUNATHESHWAR BUSI MGT COLLEGE",
"SHRI D.C.C.V HIGH SCHOOL AND N D SHAH HS VIDHYALAY",
"SHRI DADA MATRI AVUM SHISHU CHIKITSALAYA",
"SHRI DADAJI TYRE AND SALES PRIVATE LIMITED",
"SHRI DAHYALAL SHANKARLAL TOBACCO PRIVATE LIMITED",
"SHRI DAKSHINESHWARI MAA POLYFABS LIMITED",
"SHRI DAMODAR YARN MANUFACTURING PRIVATE LIMITED",
"SHRI DAMODARPANT DUPLLIWAR COLLEGE OF EN",
"SHRI DARSHAN BHARTI VIDHYALAYA GONDBURANDA",
"SHRI DATTA AGENCIES PRIVATE LIMITED",
"SHRI DATTA FOUNDERS AND ENGINEERS PRIVATE LIMITED",
"SHRI DATTA VIDYA MANDIR HI SCHOOL PATONDA",
"SHRI DATTAKRUPA SHAIKSHNIK AND KRUSHI GRAMVIKAS PRATHISHTHAN",
"SHRI DATTAPRABHU AGRO INDUSTRIES PRIVATE LIMITED",
"SHRI DAUBABA COLD STORAGE PRIVATE LIMITED",
"SHRI DAUJI COLD STORAGE PRIVATE LIMITED",
"SHRI DAUJI SHEETGRAH PRIVATE LIMITED",
"SHRI DAYAL INDUSTRIES PRIVATE LIMITED",
"SHRI DEVARAJ GRANITES PRIVATE LIMITED",
"SHRI DEVKRIPA TEXTILE MILLS PRIVATE LIMITED",
"SHRI DEVKUVARBA HIGH SCHOOL",
"SHRI DHANALAKSHMI GREEN ENERGY INDIA PRIVATE. LIMITED.",
"SHRI DHANALAKSHMI SPINNTEX PRIVATE LIMITED",
"SHRI DHANALAXMI METAL INDUSTRIES",
"SHRI DHANDA RICE MILL PRIVATE LIMITED",
"SHRI DHANESHWARI MANAV VIKAS MANDALS COLLEGE OF AGRIL BIOTECHNOLOGY AURANGABAD",
"SHRI DHANESHWARI NURSING COLLEGE",
"SHRI DHANESHWARI NURSING COLLEGE AURANGABAD",
"SHRI DHANIRAM LAMINATES PRIVATE LIMITED",
"SHRI DHANLAXMI REAL- INFRA PRIVATE LIMITED",
"SHRI DHANPATI STEELS PRIVATE LIMITED",
"SHRI DHANPATRAI AGRO PRODUCTS PRIVATE LIMITED",
"SHRI DHANYA TRAVELS PRIVATE LIMITED",
"SHRI DHANYALAKSHMI BIOSCIENCE PRIVATE LIMITED",
"SHRI DHARMASTHALA MANJUNATHESHWARA COLLEGE OF BUSINESS MANAGEMENT",
"SHRI DHARMASTHALA MANJUNATHESHWARA UNIVERSITY",
"SHRI DHOKESHWAR COLLEGE TAKALI DHOKESHWAR PARNER AHEMDNAGAR",
"SHRI DIGAMBER JAIN ACHARYA SANSKRIT MAHAVIDYALAYA",
"SHRI DIGAMBER JAIN HOSPITAL",
"SHRI DINESH MILLS LIMITED",
"SHRI DINESH WAREHOUSING PRIVATE LIMITED",
"SHRI DISNAU SHAKTI DHAM FOODS PRIVATE LIMITED",
"SHRI DIVYADRASHTI LASER CLINIC PRIVATE LIMITED",
"SHRI DNYANESHWAR SAHAKARI SAKHAR KARKHANA LIMITED",
"SHRI DOODHNATH SHUKLA SANSKRIT MAHAVIDYALAYA",
"SHRI DR R G RATHOD ARTS AND SCIENCE COLLAGE MURTIZAPUR DIST AKOLA",
"SHRI DRONACHARYA RAMESHCHAND VIDYAWATI CONVENT SCHOOL",
"SHRI DUDHNATH SARVODAYA MAHAVIDYALAYA, JHANSI",
"SHRI DURGA AGRO OILS PRIVATE LIMITED",
"SHRI DURGA BEVERAGES PRIVATE LIMITED",
"SHRI DURGA FINE CHEMICALS PRIVATE LIMITED",
"SHRI DURGA LOHA BHANDAR PRIVATE LIMITED",
"SHRI DURGA METACRAFT PRIVATE LIMITED",
"SHRI DURGA SCAFFOLDING NOIDA PRIVATE LIMITED",
"SHRI DURGA TEXCOAT PRIVATE LIMITED",
"SHRI DURGA VIDYALAYA UCHCH SHALA",
"SHRI DUTT INDIA PRIVATE LIMITED",
"SHRI EDUCARE LIMITED",
"SHRI EKVIRA MANUFACTURERS AND COATS PRIVATE LIMITED",
"SHRI FIRANGAIMATA VIDYALAYA KURKUMBH",
"SHRI FULCHANDBHAI SHAH KUMAR MANDIR",
"SHRI G K DHOLAKIYA SCHOOL",
"SHRI G P G VIDYALAYA HIGHER SECONDARY SCHOOL",
"SHRI G P M DEGREE COLLEGE SCIENCE AND COMMERCE",
"SHRI GADGE MAHARAJ PRATHMIK ASHRAM SHALA VALAN RAHURI AHMEDNAGAR",
"SHRI GADH GANESH STEELS PRIVATE LIMITED",
"SHRI GAJANAN FERTILIZERS PRIVATE LIMITED",
"SHRI GAJANAN MAHARAJ SUGAR LIMITED",
"SHRI GAJANAN VIDYALAY AND KANISHT MAHAVIDYALAY",
"SHRI GAMI ENTERPRISES PRIVATE LIMITED",
"SHRI GAMI INFOTECH PRIVATE LIMITED",
"SHRI GANDHI INTER COLLEGE",
"SHRI GANDHI SMARAK INTER COLLEGE IN CHAKATHAL ALIGARH",
"SHRI GANESH ADHESIVE PRIVATE LIMITED",
"SHRI GANESH AIR PRODUCTS PRIVATE LIMITED",
"SHRI GANESH FOUNDRY PRIVATE LIMITED",
"SHRI GANESH HIGH SCHOOL JAWALKHED",
"SHRI GANESH INFRADEVELOPERS PRIVATE LIMITED",
"SHRI GANESH LAXMI POLYMERS PRIVATE LIMITED",
"SHRI GANESH MADHYAMIK VIDYALAYA HAMAL GALLI LATUR",
"SHRI GANESH MARUTI GARMENTS",
"SHRI GANESH OLEOCHEM PRIVATE LIMITED",
"SHRI GANESH SHEETLA MAA DISTRIBUTORS PRIVATE LIMITED",
"SHRI GANESH TEXTILE AND INFRASTRUCTURE INDIA PRIVATE LIMITED",
"SHRI GANESH VEG OIL PRODUCTS PRIVATE LIMITED",
"SHRI GANESH VIDYALAYA HAMAL GALLI LATUR",
"SHRI GANESH VINAYAK MEDICAL SCIENCE PRIVATE LIMITED",
"SHRI GANESHA GLOBAL GULAL PRIVATE LIMITED",
"SHRI GANESHAM AGRILINK PRIVATE LIMITED",
"SHRI GANESHILAL OM PRAKASH SAREES PRIVATE LIMITED",
"SHRI GANG INDUSTRIES AND ALLIED PRODUCTS LIMITED",
"SHRI GANGA BISHAN COTTON MILLS",
"SHRI GANGA FOUR WHEELS PRIVATE LIMITED",
"SHRI GANGA GALVANISING COMPANY PRIVATE LIMITED",
"SHRI GANGA VEHICLES PRIVATE LIMITED",
"SHRI GANGADASS ENTERPRISES PRIVATE LIMITED",
"SHRI GANGADHARESHWARAR HEALTH SERVICES PRIVATE LIMITED",
"SHRI GANPATI EDUCATION AND RESEARCH INSTITUTE",
"SHRI GANPATI FERTILIZERS LIMITED",
"SHRI GANPATI HOMES PRIVATE LIMITED",
"SHRI GANPATI RECYCLERS PRIVATE LIMITED",
"SHRI GANPATIDEV FOOD PRIVATE LIMITED",
"SHRI GANPATLAL AGARWAL MEMORIAL AYUSH HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED",
"SHRI GARGI BUILDCON PRIVATE LIMITED",
"SHRI GAURI MODEL HIGH SCHOOL",
"SHRI GAUTAM AUTOMOTIVE PRIVATE LIMITED",
"SHRI GAUTAM GARMENTS PRIVATE LIMITED",
"SHRI GAUTAM SHIPBREAKING INDUSTRIES PRIVATE LIMITED",
"SHRI GAYATRI MOULDS PRIVATE LIMITED",
"SHRI GAYATRI VIDYAMANDIR SHIHOLI MO",
"SHRI GEETA SACKS PRIVATE LIMITED",
"SHRI GIRI SPINNING MILLS INDIA PRIVATE LIMITED",
"SHRI GIRIJA ALLOY & POWER (I) PRIVATE LIMITED",
"SHRI GIRIRAJ COLD STORAGE PRIVATE LIMITED",
"SHRI GIRIRAJ CONSTRUCTION INFRATECH PRIVATE LIMITED",
"SHRI GIRIRAJ LOHA PRIVATE LIMITED",
"SHRI GIRIRAJ STEELS PVT LTD",
"SHRI GIRIRAJ STRUCTURES PRIVATE LIMITED",
"SHRI GITA PLASTOPACK PRIVATE LIMITED",
"SHRI GOBIND NUTRITIONS PRIVATE LIMITED",
"SHRI GOG STEEL ALLOYS PRIVATE LIMITED",
"SHRI GOKAN MAIZE PRODUCTS PRIVATE LIMITED",
"SHRI GOKARNATHESWARA COLLEGE MANGALORE",
"SHRI GOKUL INFRAPROMOTERS PRIVATE LIMITED",
"SHRI GOPAL ENGINEERING AND CHEMICAL WORKS PRIVATE LIMITED",
"SHRI GOPAL PAINTER",
"SHRI GOPESHWAR SHEETGRAH PRIVATE LIMITED",
"SHRI GOPINATH INTER COLLEGE",
"SHRI GOVARDHAN ESTATES PRIVATE LIMITED",
"SHRI GOVIND AGENCIES PRIVATE LIMITED",
"SHRI GOVIND REALTY PRIVATE. LIMITED.",
"SHRI GOVINDAM AGRO FOODS PRIVATE LIMTED",
"SHRI GOVINDAM INFRAPROJECT PRIVATE LIMITED",
"SHRI GOVINDKRUPA COTTON PROCESSING PRIVATE LIMITED",
"SHRI GOWRISHANKARAR AGENCIES PRIVATE LIMITED",
"SHRI GUJRAT REFINERY JAWAHARNAGAR BARO",
"SHRI GULABSINGH HOTELS PRIVATE LIMITED",
"SHRI GULKANDI RAM RAM SINGH AGARWAL INTER COLLEGE AGRA",
"SHRI GULKANDIRAM RAMSINGH AGARWAL INTER COLLEGE",
"SHRI GUMANDEV PROCESSORS PRIVATE LIMITED",
"SHRI GURMUKHDAS CONTRACTORS PRIVATE LIMITED",
"SHRI GURU GANESH VIDYAMANDIR PRATHMIK",
"SHRI GURU GOPAL ELECTRICALS PRIVATE LIMITED",
"SHRI GURU KIRPA ASSOCIATES PRIVATE LIMITED",
"SHRI GURU KRIPA AUTOMOBILES PRIVATE LIMITED",
"SHRI GURU KRIPA ENGINEERING PRIVATE LIMITED",
"SHRI GURU RAM RAI INSTITUTE OF MEDICAL AND HEALTH SCIENCE",
"SHRI GURU RAM RAI PG COLLEGE DEHRA DUN",
"SHRI GURU RAM RAI PUBLIC SCHOOL",
"SHRI GURU SERVICES & MARKETING",
"SHRI GURU STONE CRUSHER PRIVATE LIMITED",
"GURU TEG BAHADUR PUBLIC SCHOOL",
"SHRI GURUDATT SUGARS LIMITED.",
"SHRI GURUDATTA HIGH SCHOOL AND ARTS JR COLLEGE DHULE",
"SHRI GURUDATTA VIDYALAY GHUMARI KARJAT AHMEDNAGAR",
"SHRI GURUDEV CERATECH PRIVATE LIMITED",
"SHRI GURUJI RUGNALAYA",
"SHRI GURUKRUPA AUTOMATION PRIVATE LIMITED",
"SHRI GURUNANAK PRIMARY SCHOOL DAYALBAND BILASPUR",
"SHRI HANS ELECTRICALS PRIVATE LIMITED",
"SHRI HANUMAN EXPORTS INDIA PRIVATE LIMITED",
"SHRI HANUMAN POLY FAB PRIVATE LIMITED",
"SHRI HANUMAN WIRON PRIVATE LIMITED",
"SHRI HANUMANJI ROLLER FLOUR MILLS PRIVATE LIMITED",
"SHRI HANUMANT MOTORS PRIVATE LIMITED",
"SHRI HANUMANTRAO CHATE SCHOOL & JR COLLEGE OF SCIENCE",
"SHRI HANWANT SR SEC SCHOOL",
"SHRI HAP CHEMICAL ENTERPRISES PRIVATE LIMITED",
"SHRI HARDAYAL SINGH SHEETGARH PRIVATE LIMITED",
"SHRI HARE-KRISHNA SPONGE IRON LIMITED",
"SHRI HARI AGRO IMPEX PRIVATE LIMITED",
"SHRI HARI BAGS PRIVATE LIMITED",
"SHRI HARI BENTONITE MINECHEM PRIVATE LIMITED",
"SHRI HARI FABTECH (INDIA) PRIVATE LIMITED",
"SHRI HARI FERRO ALLOYS PRIVATE LIMITED",
"SHRI HARI FORGING PRODUCTS",
"SHRI HARI GRITS PRIVATE LIMITED",
"SHRI HARI KRISHNA PAPERS PRIVATE LIMITED",
"SHRI HARI PROJECTS PRIVATE LIMITED",
"SHRI HARI STONEGRITS PRIVATE LIMITED",
"SHRI HARI URMILA AUTOMAX PRIVATE LIMITED",
"SHRI HARI VISHNU VINYLS PRIVATE LIMITED",
"SHRI HARI WAX-O CHEM PRIVATE LIMITED",
"SHRI HARIHAR PROCESSORS PRIVATE LIMITED",
"SHRI HARIKRISHNA COTTON MILLS PRIVATE LIMITED",
"SHRI HARIKRISHNA SIZING PVT LTD",
"SHRI HARINI MEDIA LIMITED",
"SHRI HARIOM AGRICULTURE PRIVATE LIMITED",
"SHRI HATKESHWAR GOLD PRIVATE LIMITED",
"SHRI HI - TECH (INDIA) PRIVATE LIMITED",
"SHRI HINDUSTAN TIMBER PRIVATE LIMITED",
"SHRI HIRAJI TRANSPORT CO",
"SHRI HIRAMANI COLD STORAGE PRIVATE LIMITED",
"SHRI HIRANYAKESHI FEEDS AND FARMS PRIVATE LIMITED",
"SHRI HIRANYAKESHI SAHAKARI SAKKARE KARKHANE NIYAMIT",
"SHRI I J PATEL M ED COURSE",
"SHRI I P PACKAGING PRIVATE LIMITED",
"SHRI ILAMCHAND SARAV HITKARI VIDYA MANDIR HIGH SCHOOL",
"SHRI IMAGING AND X-RAY FILMS PRIVATE LIMITED",
"SHRI J V HIGH SCHOOL JANOD",
"SHRI JAGADAMBA VIDYALAYA ACHALPUR CITY",
"SHRI JAGANNATH PIPELINE PRIVATE LIMITED",
"SHRI JAGANNATH STEELS & POWER LIMITED",
"SHRI JAGANNATH TEMPLE OFFICE PURI",
"SHRI JAGAT NARAYAN SANSKRIT MAHAVIDHAYALAY",
"SHRI JAGDAMBA POLYMERS LIMITED",
"SHRI JAGDAMBA SILK MILLS PRIVATE LIMITED",
"SHRI JAGRITI SOLVEX PRIVATE LIMITED",
"SHRI JAI BABA MINERALS PRIVATE LIMITED",
"SHRI JAIBABA CASTING PRIVATE LIMITED",
"SHRI JAIBABA STEEL PRIVATE LIMITED",
"SHRI JAIN INTER COLLEGE DEOBAND",
"SHRI JAIPAL SINGH SHARMA TRUST",
"SHRI JAMBMUNI PRASHALA SOLAPUR",
"SHRI JANANI HOMES PRIVATE LIMITED",
"SHRI JANKI FOODGRAINS PRIVATE LIMITED",
"SHRI JATADHARI RICE MILL PRIVATE LIMITED",
"SHRI JAYA SAKKTHI SPINNER (INDIA) PRIVATE LIMITED",
"SHRI JAYRAJ FOODS PRIVATE LIMITED",
"SHRI JEE MFG PRIVATE LIMITED",
"SHRI JEE TRANSPORT PRIVATE LIMITED",
"SHRI JEETENDRA GODARA'S SLBS EDUCATION FOUNDATION",
"SHRI JI TRADERS",
"SHRI JINDAL TOR INDIA PVT LTD",
"SHRI JOTHILINGAM PATTU MAHAL PRIVATE LIMITED",
"SHRI JRG FOODS PRIVATE LIMITED",
"SHRI JWALA JI JEWELS PRIVATE LIMITED",
"SHRI JYOTI COTTON MILLS PRIVATE LIMITED",
"SHRI K G DHOLAKIYA SCHOOL RAJKOT",
"SHRI K J POLYTECHNIC",
"SHRI K K TUNGAL MEMORIAL TRUST",
"SHRI K R DESAI ARTS AND COMMERCE COLLEGE",
"SHRI KAILASH FIBRES PRIVATE LIMITED",
"SHRI KAILASH HEAVY HAULERS PRIVATE LIMITED",
"SHRI KAILASH LOGISTICS (CHENNAI) LIMITED",
"SHRI KAKASAHEB HIRALAL MAGANLAL CHAUDHARI PRA VIDHYA MANDIR WARD NO 22",
"SHRI KAKSHI METALS PRIVATE LIMITED",
"SHRI KALBHAIRAV COLD STORAGE PRIVATE LIMITED",
"SHRI KALBHAIRAV POULTRY FARMS PRIVATE LIMITED",
"SHRI KALBHAIRAV SUGARCANE PROCESS PRIVATE LIMITED",
"SHRI KALKA AGRO INDUSTRIES",
"SHRI KALKI SPECIALITY'S PRIVATE LIMITED",
"SHRI KALUKA STEELS PRIVATE LIMITED",
"SHRI KALYAN HOLDINGS LIMITED",
"SHRI KALYANIKA PROMOTORS & DEVELOPERS PRIVATE LIMITED",
"SHRI KANHA STAINLESS PRIVATE LIMITED",
"SHRI KANHIYA FABRICS PRIVATE LIMITED",
"SHRI KANNAN DEPARTMENTAL STORE LIMITED",
"SHRI KANNAN DEPARTMENTAL STORE PRIVATE LIMITED",
"SHRI KANWARTARA PUBLIC HIGHER SECONDARY SCHOOL",
"SHRI KAPA INDUSTRIES PRIVATE LIMITED",
"SHRI KARA ENGINEERING PRIVATE LIMITED",
"SHRI KARNI POLY PRODUCTS PRIVATE LIMITED",
"SHRI KARPADHA AGRO FOODS",
"SHRI KARSHNI ALLOYS PRIVATE LIMITED",
"SHRI KARVIR NIVASINI MAHALAXMI ISPAT PRIVATE LIMITED",
"SHRI KASHUMBARI FOODS LLP",
"SHRI KATYANNI SALES PRIVATE LIMITED",
"SHRI KAYAN IMPEX PRIVATE LIMITED",
"SHRI KED INSULATIONS PRIVATE LIMITED",
"SHRI KELAJEE BOOKS PRIVATE LIMITED",
"SHRI KESHARIA CONCRETE PRODUCTS PVT LTD",
"SHRI KESHAV CEMENTS AND INFRA LIMITED",
"SHRI KESHAVRAJ MADHYAMIK VIDYALAY LATUR",
"SHRI KHAM BABA LOGISTICS & MINERALS PRIVATE LIMITED",
"SHRI KHANDESHWAR VIDYALAYA KUSLAMB",
"SHRI KHARIA HANUMAN SALT WORKS PRIVATE LIMITED",
"SHRI KHATU SHYAM ALLOYS PRIVATE LIMITED",
"SHRI KHATU SHYAM REAL ESTATE PRIVATE LIMITED",
"SHRI KHEMA BABA MAHILA MAHAVIDYALY",
"SHRI KHEMISATI PLASPACK LLP",
"SHRI KHEMISATI POLYSACKS PRIVATE LIMITED",
"SHRI KOSHI PRINT PACK PRIVATE LIMITED",
"SHRI KRISHAK KANYA INT COLL BAHANPUR HATHRAS",
"SHRI KRISHAK KANYA INTER COLLEGE",
"SHRI KRISHAN KRIPA FINANCIAL CONSULTANTS PRIVATE LIMITED",
"SHRI KRISHAN MANPOWER SERVICES PRIVATE LIMITED",
"SHRI KRISHAN VANASTHALI INT COLL MANAGARHI MATHURA",
"SHRI KRISHNA ADS PRIVATE LIMITED",
"SHRI KRISHNA AGRO INDUSTRIES",
"SHRI KRISHNA AUTO INDUSTRIES PRIVATE LIMITED",
"SHRI KRISHNA AUTOMOBILES PVT LTD",
"SHRI KRISHNA AUTOSALES PRIVATE LIMITED",
"SHRI KRISHNA BIOCHEM PRIVATE LIMITED",
"SHRI KRISHNA BUILDUP PRIVATE LIMITED",
"SHRI KRISHNA DEALERS PVT. LTD",
"SHRI KRISHNA DETCHEM PRIVATE LIMITED",
"SHRI KRISHNA DEVCON LIMITED",
"SHRI KRISHNA EDUCATIONAL TRUST",
"SHRI KRISHNA EMBROIDERIES PRIVATE LIMITED",
"SHRI KRISHNA FOUR WHEELS PRIVATE LIMITED",
"SHRI KRISHNA FRUIT PROCESSORS PRIVATE LIMITED",
"SHRI KRISHNA HOSPITAL LIMITED",
"SHRI KRISHNA INFRADESIGN PRIVATE LIMITED",
"SHRI KRISHNA INTER COLLEGE PATLONI MATHURA",
"SHRI KRISHNA INVESTMENTS PRIVATE LIMITED",
"SHRI KRISHNA KRIPA FOUR WHEEL PRIVATE LIMITED",
"SHRI KRISHNA KRIPA JEWELLERS PRIVATE LIMITED",
"SHRI KRISHNA LIFE LINE HOSPITAL PRIVATE LIMITED",
"SHRI KRISHNA LOHA ISPAT PRIVATE LIMITED",
"SHRI KRISHNA OIL & GENERAL MILLS",
"SHRI KRISHNA PACKAGING CONSULTANTS PRIVATE LIMITED",
"SHRI KRISHNA PEARLS PRIVATE LIMITED",
"SHRI KRISHNA PLYWOOD PRIVATE LIMITED",
"SHRI KRISHNA SHARE BROKERS PRIVATE LIMITED",
"SHRI KRISHNA SHARIRIK SHIKSHAN MAHAVIDYALAYA",
"SHRI KRISHNA SHIKSHA PRASAR SAMITI",
"SHRI KRISHNA SHUTTERINGS PRIVATE LIMITED",
"SHRI KRISHNA SOLVENT EXTRUCTION PRIVATE LIMITED",
"SHRI KRISHNA SPINNING MILLS (INDIA) PRIVATE LIMITED",
"SHRI KRISHNA STEELAGE P LIMITED",
"SHRI KRISHNA STRAWBOARD INDUSTRIES PRIVATE LIMITED",
"SHRI KRISHNA TECHTEX PRIVATE LIMITED",
"SHRI KRISHNA UNIVERSITY",
"SHRI KRISHNA WELLNESS PRIVATE LIMITED",
"SHRI KRISHNAM POSHAK AND SAREES PRIVATE LIMITED",
"SHRI KRISHNASHRAY INDIA PRIVATE. LIMITED",
"SHRI KRISHNASWAMY COLLEGE FOR WOMEN",
"SHRI KRISHNASWAMY MATRICULATION HIGHER SECONDARY SCHOOL",
"SHRI KRSNA SUDARSHAN URJA PRIVATE LIMITED",
"SHRI KRSNA URJA PROJECT PRIVATE LIMITED",
"SHRI KRUPA SERVICES PRIVATE LIMITED",
"SHRI KS FARMIMPLEMENTS PRIVATE LIMITED",
"SHRI KSHETHRA DHARMASTHALA RURAL DEVELOPMENT PROJECT",
"SHRI KUBERJI COLD STORAGE PRIVATE LIMITED",
"SHRI KUBERJI MARKETING CO. (LUCKNOW) PRIVATE LIMITED",
"SHRI KUMARAN MEDICAL CENTRE PRIVATE LIMITED",
"SHRI KUNJBIHARI RETAIL PRIVATE LIMITED",
"SHRI KUSHALSURI ENGINEERING SERVICES PRIVATE LIMITED",
"SHRI KY AGROVET PRIVATE LIMITED",
"SHRI LABHUBHAI TRIVEDI INSTITUTE OF ENGINEERING & TECHNOLOGY",
"SHRI LAKHA INTER COLLAGE BIRVALA HERNOL MATHURA",
"SHRI LAKSHMI AGRO FOODS PRIVATE LIMITED",
"SHRI LAKSHMI AUTO MACHINE TOOLS PRIVATE LIMITED",
"SHRI LAKSHMI ENGINEERING INDUSTRIES LIMITED",
"SHRI LAKSHMI GANAPATHY INDUSTRIES PRIVATE LIMITED",
"SHRI LAKSHMI INFRA INDIA PRIVATE LIMITED",
"SHRI LAKSHMI METAL UDYOG LIMITED",
"SHRI LAKSHMI NARASIMHAR FOUNDRIES PRIVATE LIMITED",
"SHRI LAKSHMI NARAYANAN INDUSTRIES PRIVATE LIMITED",
"SHRI LAKSHMI STEEL SUPPLIERS",
"SHRI LAL BAHADUR SHASTRI INTER COLLEGE BABINA JHANSI",
"SHRI LAL BAHADUR SHASTRI SR SEC SCHOOL",
"SHRI LAL MAHAL AGRO PRODUCTS PRIVATE LIMITED",
"SHRI LALBAHADUR SHASTRI MADHYAMIK AND UCHHA MADHYAMIK VIDYALAY",
"SHRI LALSHAH PAPERS PRIVATE LIMITED",
"SHRI LAXMI ARCHCON PRIVATE LIMITED",
"SHRI LAXMI NARAYAN REAL ISPAT PRIVATE LIMITED",
"SHRI LAXMI NIWAS EXPORTS PRIVATE LIMITED",
"SHRI LAXMI SEEDS INDIA PRIVATE LIMITED",
"SHRI LAXMI SPICES AND PULSES PRIVATE LIMITED",
"SHRI LAXMI VENKETESH COMMODITIES PRIVATE LIMITED",
"SHRI LAXMI VIJAY STEELS PRIVATE LIMITED",
"SHRI LAXMIBADRI AGRO FOODS PRIVATE. LIMITED.",
"SHRI LAXMII CRUSHERS PRIVATE LIMITED",
"SHRI LAXMINARAYAN SPARE PARTS PRIVATE LIMITED",
"SHRI LOKESH INFRASTRUCTURE PRIVATE LIMITED",
"SHRI M B DESAI HIGH SCHOOL GHADI",
"SHRI M D SHAH MAHILA COLLEGE OF ARTS AND COMMERCE",
"SHRI M N SHUKLA EDUC COLLEGE",
"SHRI M P SHAH JR COLLEGE OF ARTS AND COMMERCE",
"SHRI M.B.DESAI HIGHSCHOOL GHADI",
"SHRI MA BAL NIKETAN HIGH SCHOOL",
"SHRI MAA MARKETING PRIVATE. LIMITED.",
"SHRI MAA OILS LIMITED",
"SHRI MAA POLYFABS LIMITED",
"SHRI MAA SALES",
"SHRI MADHAV SYNTEX PRIVATE LIMITED",
"SHRI MADHOPUR CEMENT PRIVATE LIMITED",
"SHRI MADHUR FOODS PRODUCTS PVT LTD",
"SHRI MADHUSUDAN DYEING AND PRINTING MILLS PRIVATE LIMITED",
"SHRI MADHUSUDAN RAYONS PRIVATE LIMITED",
"SHRI MAHABIR DYG & PTG MILLS PRIVATE. LIMITED.",
"SHRI MAHADEV SILK MILLS PRIVATE LIMITED",
"SHRI MAHADEV VIDYAMANDIR BORGAON AKKALKOT",
"SHRI MAHALAXMI AUTOPARTS PRIVATE LIMITED",
"SHRI MAHALAXMI CO-OPERATVE BANK LTD",
"SHRI MAHALAXMI PHARMA PRIVATE LIMITED",
"SHRI MAHANT INDIRESH HOSPITAL",
"SHRI MAHARANA CHAINS",
"SHRI MAHARDDHI CONSTRUCTIONS PRIVATE LIMITED",
"SHRI MAHAVEER INFRA CONCRETE PRIVATE LIMITED",
"SHRI MAHAVIR CEREALS",
"SHRI MAHAVIR DEVELOPERS & MARKETING LIMITED",
"SHRI MAHAVIR FERRO ALLOYS PRIVATE LIMITED",
"SHRI MAHAVIR FOAM PRIVATE LIMITED",
"SHRI MAHAVIR IRON & STEEL PRIVATE LIMITED",
"SHRI MAHAVIR PULSES PRIVATE LIMITED",
"SHRI MAHAVIR SHIKSHA SADAN INTER COLLEGE",
"SHRI MAHAVIR WIRES PRIVATE LIMITED",
"SHRI MAHESH SHIKSHAN SANSTHAN",
"SHRI MAHESWAR INTER COLLEGE",
"SHRI MAHILA GRIHA UDYOG LIJJAT PAPAD",
"SHRI MAHILA SEWA SAHAKRAI BANK LTD",
"SHRI MALLAPPA KONAPURE PRASHALA V K MAHAVIDHYALAY AAHERWADI",
"SHRI MALLIKARJUN HIGH SCHOOL HATTURE NAGAR SOLAPUR",
"SHRI MALLIKARJUN HIGH SCHOOL SOLAPUR",
"SHRI MAN NARAYAN POLYTAX PRIVATE LIMITED",
"SHRI MANDEV MARBLE AND GRANITES PRIVATE LIMITED",
"SHRI MANGAL STONE CRUSHER PRIVATE LIMITED",
"SHRI MANGALAM AUTO PRIVATE LIMITED",
"SHRI MANGALMURTI CLINIC & RESEARCH CENTRE PRIVATE LIMITED",
"SHRI MANGALNATH INNOVATIONS PRIVATE LIMITED",
"SHRI MARKANDEYA VIDYALAYA SOLAPUR",
"SHRI MAROOTI (SPECIAL SMOKE LESS FUEL) INDUSTRIES PRIVATE LIMITED",
"SHRI MARU SILK MILLS PRIVATE LIMITED",
"SHRI MARUDHAR KESRI SAREE PRIVATE LIMITED",
"SHRI MARUTI CHEM ENTERPRISE PRIVATE LIMITED",
"SHRI MARUTI INFRATECH INDIA PRIVATE LIMITED",
"SHRI MARUTI NANDAN ENTERPRISES PRIVATE LIMITED",
"SHRI MARUTI NANDAN RICE MILLS PRIVATE LIMITED",
"SHRI MARUTINANDAN HEALTHCARE PRIVATE LIMITED",
"SHRI MASANIYAMMAN THUNAI SPINNING MILLS PRIVATE LIMITED",
"SHRI MASHA AUTOS PRIVATE LIMITED",
"SHRI MATHURADAS MOHOTA COLLEGE OF SCIENCE",
"SHRI MATHURADAS MOHTA SCIENCE COLLEGE",
"SHRI MATI DEVKALI INTER COLLEGE",
"SHRI MEENAKSHI FAN HOUSE PRIVATE LIMITED",
"SHRI MEERA LABS PRIVATE LIMITED",
"SHRI MEHENDIPUR BALAJI CONSTRUCTIONS PRIVATE LIMITED",
"SHRI MEHNDIPUR BALAJI ENTERPRISES PRIVATE LIMITED",
"SHRI MEVANAGAR SALES PRIVATE LIMITED",
"SHRI MHALSAKANT VIDYALAYA AKURDI",
"SHRI MISHRI LAL ADARSH INTER COLLEGE",
"SHRI MITTAL AGRITECH PRIVATE LIMITED",
"SHRI MODI LEVIGATED KAOLIN PRIVATE LIMITED",
"SHRI MODI MINERALS GRINDING MILLS PVT LTD",
"SHRI MODI SHIKSHAN SANSTHAN",
"SHRI MOHANLAL D DEDHIA ENGLISH HIGH SCHOOL",
"SHRI MOOKAMBIGA SPINNING MILLS PRIVATE LIMITED",
"SHRI MORARJI DESAI ARTS & COMMERCE COLLEGE",
"SHRI MORARJI DESAI ARTS AND COMMERCE COLLEGE BUHARI",
"SHRI MOTI NATH SANSKRIT MAHAVIDYALAYA",
"SHRI MOULIISWARA POLY PRIVATE LIMITED",
"SHRI MUNISHWAR MOTORS PRIVATE LIMITED",
"SHRI MURLIDHAR INDUSTRIES PRIVATE LIMITED",
"SHRI MURLIDHAR MEDIUM SCHOOL",
"SHRI N S BHAGWANDAS INTER COLLAGE",
"SHRI N V PATEL VIDYAMANDIR",
"SHRI N.P.P. TEXTILES PRIVATE LIMITED",
"SHRI NAAGHA NAATHAR TEXTILES PRIVATE LIMITED",
"SHRI NAGESHWAR MADHYAMIK VIDYALAYA DUDHKHEDA",
"SHRI NALLAPULLIAMMAN HI-TECH MODERN RICE MILL",
"SHRI NANDHI DHALL MILLS INDIA PRIVATE LIMITED",
"SHRI NARAHARI CHEMICALS PRIVATE LIMITED",
"SHRI NARAKESARI PRAKASHAN LIMITED",
"SHRI NARASIMHA SARASWATI MEDICAL FOUNDATION INDRAYANI HOSPITAL & CANCER INSTITUTE",
"SHRI NARAYAN GIRLS PG COLLEGE UNNAO",
"SHRI NARAYANI NIDHI LIMITED",
"SHRI NARAYANI PACKAGING PRIVATE LIMITED",
"SHRI NARSINGH CLOTH EMPORIUM PRIVATE LIMITED",
"SHRI NATH HOSPITAL",
"SHRI NATH TRADERS",
"SHRI NATHJI POLYRUB PRIVATE LIMITED",
"SHRI NATRAJ CHEMTECH PRIVATE LIMITED",
"SHRI NATRAJ POLY-FAB PVT LTD",
"SHRI NAVDEEP HEALTHCARE PRIVATE LIMITED",
"SHRI NAVKAR BLOWPACK PRIVATE LIMITED",
"SHRI NAVSARJAN UTTAR BUNIYADI VIDHYALAY NAGHUNA",
"SHRI NEMINATH PRINTERS AND PACKAGING PRIVATE LIMITED",
"SHRI NIRALA HINDI PRIMARY SCHOOL",
"SHRI NIRMAL ELECTECH PRIVATE LIMITED",
"SHRI NIVAS (GUJARAT) LABORATORIES PVT LTD",
"SHRI NIWAS BOARD AND PAPER PRIVATE LIMITED",
"SHRI NIWAS PULSES PRIVATE LIMITED",
"SHRI NIWASAN WIRE PRIVATE LIMITED",
"SHRI NURSING VIDHYALAYA AKOT",
"SHRI O.H. NAZAR AYURVED COLLEGE HOSPITAL SURAT",
"SHRI OM AGROIL PRIVATE LIMITED",
"SHRI OM INDUSTRIAL CATERERS PRIVATE LIMITED",
"SHRI OM OIL EXTRACTION PRIVATE LIMITED",
"SHRI OM PLYWOOD PRIVATE LIMITED",
"SHRI OMTEE STEEL PRIVATE LIMITED",
"SHRI ONKAR PAPER AND BOARD MILLS PRIVATE LIMITED",
"SHRI OSWAL JAIN SENIOR SECONDARY SCHOOL ALWAR",
"SHRI P B CHHADVA HIGH SCHOOL",
"SHRI P R PROTEINS PRIVATE LIMITED",
"SHRI PABUJI EXIM PRIVATE LIMITED",
"SHRI PADMAMANI JAIN (ARTS & COMMERCE) COLLEGE PABAL",
"SHRI PADMAMANI JAIN ARTS & COMMERCE COLLEGE PABAL",
"SHRI PADMAVATHI BISCUITS PRIVATE LIMITED",
"SHRI PAHARIMATA COLD STORAGE PVT LTD",
"SHRI PALIWAL CATTLE FEED PRIVATE LIMITED",
"SHRI PANDITGURU PARDIKAR MAHAVIDYALAYA SIRSALA",
"SHRI PANNA PAPERS PRIVATE LIMITED",
"SHRI PARAMSUKH EDIBLE FOODS PRIVATE LIMITED",
"SHRI PARASHNATH TEXTILES PRIVATE LIMITED",
"SHRI PARASNATH BUILDERS AND DEVELOPERS INDIA PRIVATE LIMITED",
"SHRI PARASNATH PACKAGINGS PRIVATE LIMITED",
"SHRI PARASRAM COMMODITIES PRIVATE LIMITED",
"SHRI PARASRAM ESTATES PRIVATE LIMITED",
"SHRI PARASRAM HOLDINGS PRIVATE LIMITED",
"SHRI PARIYUR AMMAN KRAFT PAPERS PRIVATE LIMITED",
"SHRI PARMANAND STEEL INDUSTRIES PRIVATE LIMITED",
"SHRI PARSHVANATH PRINTEX PRIVATE LIMITED",
"SHRI PARSHVANATH SPINTEX PRIVATE LIMITED",
"SHRI PARVATHI EXPORT INDIA PRIVATE LIMITED",
"SHRI PAVITHRA AUTO PRODUCT PRIVATE LIMITED",
"SHRI PAWAN ESTATES PRIVATE LIMITED",
"SHRI PD JAIN INTER COLLEGE",
"SHRI PHARMA PACK",
"SHRI PITA MARUTI IRON STORES PRIVATE LIMITED",
"SHRI PLASTO PACKERS PRIVATE LIMITED",
"SHRI PRABHAKAR COLONIZERS & DEVELOPERS PRIVATE LIMITED",
"SHRI PRABHU RAMCHANDRA HIGH SCHOOL AND JR COLLEGE NANDA",
"SHRI PRABHULINGESHWAR SUGARS AND CHEMICALS LIMITED",
"SHRI PRAGNACHAKSHU MAHILA SEVA KUNJ",
"SHRI PRANAV TEXTILE CREATIONS PRIVATE LIMITED",
"SHRI PRAYAG TEXOFAB PRIVATE LIMITED",
"SHRI PREM SARAF PRIVATE LIMITED",
"SHRI PREMPURIJI GRANIMARBO PRIVATE LIMITED",
"SHRI PRIYAJI AGRO OILS PRIVATE LIMITED",
"SHRI PURAN MULTIMEDIA LIMITED",
"SHRI PURNANAND HEALTHCARE AND RESEARCH CENTRE PRIVATE LIMITED",
"SHRI PYARE LAL SHEETGRAH PRIVATE LIMITED",
"SHRI R D C BANK LTD",
"SHRI R K H S SCH JAUNAI MATHURA",
"SHRI R R LALAN COLLEGE BHUJ",
"SHRI R R M INTER COLLEGE",
"SHRI R.R.LAHOTI SCIENCE COLLEGE MORSHI",
"SHRI RAAJYALAKSHMI POWER INFRA PRIVATE LIMITED",
"SHRI RADHA KRISHNA FERRO ALLOYS PVT LTD",
"SHRI RADHA KRISHNA INT COLL HASANPUR MATHURA",
"SHRI RADHA POLYMERS",
"SHRI RADHA RAMAN ALLOYS PRIVATE LIMITED",
"SHRI RADHA RAMAN STEELS PRIVATE LIMITED",
"SHRI RADHA SARVESHWAR LAMINATES PRIVATE LIMITED",
"SHRI RADHABALLABH STEELS PRIVATE LIMITED",
"SHRI RADHAKRISHNA ISPAT PRIVATE LIMITED",
"SHRI RADHARANI EDIBLE OILS PRIVATE LIMITED",
"SHRI RADHEMANI MULTITRADE PRIVATE LIMITED",
"SHRI RADHEY COMSEC PRIVATE LIMITED",
"SHRI RADHEY INTERMEDIARIES PRIVATE LIMITED",
"SHRI RADHEYGOVINDAM RESORT PRIVATE LIMITED",
"SHRI RADHEYLAL ARYA INTER COLLEGE",
"SHRI RADHEYSHYAM SHEETGRAH PRIVATE LIMITED",
"SHRI RADHIKA NONWOVEN PRIVATE LIMITED",
"SHRI RAGHAVENDRA COT FIBRES PRIVATE LIMITED",
"SHRI RAGHUBIR MADHYAMIK VIDYALAYA",
"SHRI RAGHUBIRA CARBONS PRIVATE LIMITED",
"SHRI RAGHUNATH LAXMINARAYAN AGROTECH PRIVATE LIMITED",
"SHRI RAGHUNATH SAHAI SARAF PRIVATE LIMITED",
"SHRI RAGHUVEER JEWELLER PRIVATE LIMITED",
"SHRI RAGHUWAR SHAYAM HOSPITAL AND RESEARCH CENTRE PRIVATE LTD",
"SHRI RAHUL MALT PRIVATE LIMITED",
"SHRI RAJ ELECTRONICS PRIVATE LIMITED",
"SHRI RAJ JI ENTERPRISES PRIVATE LIMITED",
"SHRI RAJ VIDHYAMANDIR",
"SHRI RAJ WEBSOLUTIONS PRIVATE LIMITED",
"SHRI RAJARAM TEXTILES INDIA PRIVATE LIMITED",
"SHRI RAJDHANI JEWELLERS PRIVATE LIMITED",
"SHRI RAJENDRA HIGH SCHOOL AND JUNIOR COLLEGE NAGPUR",
"SHRI RAJRAJESHWAR COTTON PRIVATE LIMITED",
"SHRI RAM AGRO CHEMICALS PVT LTD",
"SHRI RAM AGRO SCIENCES PRIVATE LIMITED",
"SHRI RAM APPARELS PRIVATE LIMITED",
"SHRI RAM ASHRAM PUBLIC SCHOOL",
"SHRI RAM AUTOTECH PRIVATE LIMITED",
"SHRI RAM CASTECH PRIVATE LIMITED",
"SHRI RAM CENTENNIAL SCHOOL AGRA",
"SHRI RAM CHAND MEMORIAL HOSPITAL PRIVATE LIMITED",
"SHRI RAM CHLOROCHEM LIMITED",
"SHRI RAM CHLOROCHEM PRIVATE LIMITED",
"SHRI RAM COLLEGE OF COMMERCE",
"SHRI RAM COMSOFT PRIVATE LIMITED",
"SHRI RAM CONSTRUCTION COMPANY",
"SHRI RAM EXPLOTECH PRIVATE LIMITED",
"SHRI RAM FARMS AND COLD STORAGE PRIVATE LIMITED",
"SHRI RAM FINANCE CORPORATION PRIVATE LIMITED",
"SHRI RAM FINANCE CORPORATION PRIVATE. LIMITED.",
"SHRI RAM GLOBAL PRE SCHOOL",
"SHRI RAM HIGHSCHOOL",
"SHRI RAM HI-TECH STEEL AND POWER PRIVATE LIMITED",
"SHRI RAM HOSPITAL",
"SHRI RAM IMPEX (INDIA) PRIVATE LIMITED",
"SHRI RAM KRISHANA HEALTHCARE PRIVATE LIMITED",
"SHRI RAM KRUPA MEDICARE PRIVATE LIMITED",
"SHRI RAM LABEL (INDIA) PRIVATE LIMITED",
"SHRI RAM LAMINATORS PRIVATE. LIMITED.",
"SHRI RAM LIMECHEM PRIVATE LIMITED",
"SHRI RAM MAHENDER KISHORE INTERNATIONAL PRIVATE LIMITED",
"SHRI RAM MALL PRIVATE LIMITED",
"SHRI RAM METALLOYS PRIVAT LIMITED",
"SHRI RAM MODEL INTER COLLEGE THORA",
"SHRI RAM MOVERS PRIVATE LIMITED",
"SHRI RAM MULTICOM PRIVATE LIMITED",
"SHRI RAM MULTISOLUTIONS PRIVATE LIMITED",
"SHRI RAM MURTI SMARAK FUNCTIONAL IMAGING AND MEDICAL CENTER LUCKNOW",
"SHRI RAM MURTI SMARAK INSTITUTE OF MEDICAL SCIENCES BAREILLY",
"SHRI RAM PETRO TRADE PRIVATE LIMITED",
"SHRI RAM POLYPLAST PRIVATE LIMITED",
"SHRI RAM READY MIX CONCRETE PRIVATE LIMITED",
"SHRI RAM RESIDENCY PRIVATE LIMITED",
"SHRI RAM RICE MILLS",
"SHRI RAM ROLLER FLOUR MILLS (INDIA) PRIVATE LIMITED",
"SHRI RAM ROLLING MILL",
"SHRI RAM RUBTECH PRIVATE. LIMITED.",
"SHRI RAM SARUP GARG COTTON MILLS",
"SHRI RAM SCHOOL",
"SHRI RAM SHARANAM CONSULTANTS PRIVATE LIMITED",
"SHRI RAM SNEH BUILDTECH PRIVATE LIMITED",
"SHRI RAM SOLVENT EXTRACTIONS PRIVATE LIMITED",
"SHRI RAM SONS WAX PRIVATE LIMITED",
"SHRI RAM SPICES PRIVATE LIMITED",
"SHRI RAM SPINTEX PRIVATE LIMITED",
"SHRI RAM SUPER SPECIALITY SURGICAL CENTRE PRIVATE LIMITED",
"SHRI RAM SWITCHGEARS LIMITED",
"SHRI RAM TEA COMPANY PVT LTD",
"SHRI RAM TECHNO ENGINEERING PRIVATE LIMITED",
"SHRI RAM TRANSPORT FINANCE CO.LIMITED",
"SHRI RAM WIRE PRODUCTS PRIVATE LIMITED",
"SHRI RAMA GREEN INFRA PRIVATE LIMITED",
"SHRI RAMA KRISHNA COLLEGE OF POLYTECHNIC & MANAGEMENT",
"SHRI RAMA PAPER & CARDS PRIVATE LIMITED",
"SHRI RAMAKRISHNA GRAIN MILLS PRIVATE LIMITED",
"SHRI RAMALINGA MILLS LIMITED",
"SHRI RAMALINGA MILLS PRIVATE LIMITED",
"SHRI RAMALINGA TEXTILES (ARUPPUKOTTAI) PRIVATE LIMITED",
"SHRI RAMALINGESHWARA AGRO FOOD PRODUCTS PRIVATE LIMITED",
"SHRI RAMAN BIHARI AGRO INDUSTRIES PRIVATE LIMITED",
"SHRI RAMANA MEDICAL AGENCIES PRIVATE LIMITED",
"SHRI RAMCHANDRA VAIDYA AYURVEDIC COLLEGE LUCKNOW",
"SHRI RAMDEOBABA COLLEGE OF ENGINEERING AND MANAGEMENT",
"SHRI RAMDEOBABA KAMLA NEHRU COLLEGE OF E",
"SHRI RAMDEV COT YARN PRIVATE LIMITED",
"SHRI RAMDEV MOTORS PRIVATE LIMITED",
"SHRI RAMDHARA COMFORT PRODUCTS PRIVATE LIMITED",
"SHRI RAMDOOT TECH TEXTILES PRIVATE LIMITED",
"SHRI RAMESTH INDUSTRY PRIVATE LIMITED",
"SHRI RAMKRISHNA PARAMHANS VIDYA NIKETAN",
"SHRI RAMNATH MADHYAMIK V UCHHA MADHYAMIK VIDYALAY ALMALA",
"SHRI RAMSHAKTI FABRICS PRIVATE LIMITED",
"SHRI RAMSWAROOP MEMORIAL CHARITABLE TRUST",
"SHRI RAMSWAROOP MULTI ENGINEERING SOLUTIONS PRIVATE LIMITED",
"SHRI RANG INFRASTRUCTURE PRIVATE LIMITED",
"SHRI RANGJI REALTIES PRIVATE LIMITED",
"SHRI RANI SATI FOODS AND GRAINS PRIVATE LIMITED",
"SHRI RANISATI CONTAINERS PRIVATE LIMITED",
"SHRI RAS INFRABUILD PRIVATE LIMITED",
"SHRI RASBIHARI AGRO PROCESSORS PRIVATE LIMITED",
"SHRI RASSIGAPRIYA SILKS PRIVATE LIMITED",
"SHRI RATAN MUNI JAIN INTER COLLEGE",
"SHRI RATAN RAJ FOODS PRIVATE LIMITED",
"SHRI RATHI AGRO INDUSTRIES",
"SHRI RATHI STEEL DAKSHIN LIMITED.",
"SHRI RATHI STEEL LIMITED",
"SHRI RATHNA AKSHAYA ESTATES PRIVATE LIMITED",
"SHRI RAVINDRANATH TAGORE MADHYAMIK VIDYALAY LATUR",
"SHRI RAWATPURA SARKAR UNIVERSITY",
"SHRI RB BULK CARRIER PRIVATE LIMITED",
"SHRI RENUKAMATA MULTISTATE CO-OP URBAN CREDIT SOCIETY LTD",
"SHRI REWA PRAKASHAN LIMITED",
"SHRI REWA RICE MILLS PRIVATE LIMITED",
"SHRI RG HOSPITALITY SERVICES PRIVATE LIMITED",
"SHRI RISHABH INDIA PRIVATE LIMITED",
"SHRI ROHITH SPINNERS PRIVATE LIMITED",
"SHRI ROYALTEX FAB PRIVATE LIMITED",
"SHRI RUDRAM TECHNOCRATS PRIVATE LIMITED",
"SHRI RUSHABH ELECTRA & CABLES PRIVATE LIMITED",
"SHRI S M AUTADE PRIVATE LIMITED",
"SHRI SABHARI SMELTERS PRIVATE LIMITED",
"SHRI S'AD VIDYA MANDAL INSTITUTE OF TECHNOLOGY",
"SHRI SADGURU COKE PRIVATE LIMITED",
"SHRI SAGAR TEXFAB PRIVATE LIMITED",
"SHRI SAGAR WOVEN PRIVATE. LIMITED.",
"SHRI SAHAJANAND GURUKUL",
"SHRI SAHIB MOTORS PRIVATE LIMITED",
"SHRI SAI AGRO EQUIPMENTS PRIVATE LIMITED",
"SHRI SAI BABA INFRA PROJECTS PRIVATE LIMITED",
"SHRI SAI BALAJI PHARMATECH PRIVATE LIMITED",
"SHRI SAI BHARGAVA MEDICAL IMAGING PRIVATE LIMITED",
"SHRI SAI CASHEW PRIVATE LIMITED",
"SHRI SAI COTTEX PRIVATE LIMITED",
"SHRI SAI FACILITY MANAGEMENT PRIVATE LIMITED",
"SHRI SAI GINNING AND PRESSING FACTORY",
"SHRI SAI INFRASTRUCTURES & REAL ESTATE PRIVATE LIMITED",
"SHRI SAI JANVIKAS PRATLSHTHAN'S OJAS COLLEGE OF PHARMACY",
"SHRI SAI KIRPA THERMOFORMING PRIVATE LIMITED",
"SHRI SAI KRUPA CREATIONS PRIVATE LIMITED",
"SHRI SAI MARBLES PRIVATE LIMITED",
"SHRI SAI PRASAD MULTI",
"SHRI SAI PRIYA SUGARS LIMITED",
"SHRI SAI PURNANAND GREEN ENERGY PRIVATE LIMITED",
"SHRI SAI RAIL SERVICES NASHIK",
"SHRI SAI REALINFRA PRIVATE LIMITED",
"SHRI SAI TRADE IMPEX PRIVATE LIMITED",
"SHRI SAI TRANSWAYS",
"SHRI SAIBABA SANSTHAN TRUST",
"SHRI SAINAHT VIDYALAYA",
"SHRI SAINATH COTTONS PRIVATE LIMITED",
"SHRI SAINATH ENTERPRISES PRIVATE LIMITED",
"SHRI SAISHYAM COTSPIN",
"SHRI SALASAR BALAJI AUTOMOBILES & SERVICES PRIVATE LIMITED",
"SHRI SALASAR CONTRACTORS PRIVATE LIMITED",
"SHRI SALASAR DIGITAL PRIVATE LIMITED",
"SHRI SALASAR JI WHEAT PRODUCTS PRIVATE LIMITED",
"SHRI SALASAR SILK MILLS PVT LTD",
"SHRI SALASAR STEEL STRUCTURALS PRIVATE LIMITED",
"SHRI SALASAR TUBES PRIVATE LIMITED",
"SHRI SAMARTH MARATHI SHALA DARWHA",
"SHRI SAMARTH VIDYA MANDIR",
"SHRI SANATAN DHARAM PRAKASH CHAND KANYA INTER COLLEGE",
"SHRI SANATAN DHARAM VIDYALAYA & JR COLLEGE",
"SHRI SANATAN DHARM SANSKRIT VIDYALAY RAKSHASHAAM",
"SHRI SANGAM SAHAKARI SAKKARE KARKHANE NIYAMIT HIDKAL-DAM",
"SHRI SANKHESHWAR TEXTILE PRIVATE LIMITED",
"SHRI SANSKRIT COLLEGE AURAIYA",
"SHRI SANT BHAGWANBABA MADHYAMIK VIDYALAYA JAIKWADI VASAHAT BAG PIMPALGAON",
"SHRI SANT DNYANESHWAR MULTISTATE CO OPERATIVE CREDIT SOCIETY LTD",
"SHRI SANT EKNATH U P SCHOOL",
"SHRI SANT GADGE BABA HINDI MAHAVIDYALAY BHUSAWAL",
"SHRI SANT GADGE MAHARAJ COLLGE",
"SHRI SANT HARIHAR MAHARAJ MADYAMIK VIDYALAY NIPANE",
"SHRI SANT SADHGURU BALUMAMA BUILDING PRODUCTS PRIVATE LIMITED",
"SHRI SANT SHANKAR MAHARAJ COLLEGE OF AGRICULTURE PIMPALKHUTA",
"SHRI SANWARIYA COLD STORAGE PRIVATE LIMITED",
"SHRI SAPTDEV AUTOMOBILES PRIVATE LIMITED",
"SHRI SARA POLYMERS PRIVATE LIMITED",
"SHRI SARASWATI EDUCATION TRUST",
"SHRI SARASWATI FOOD UDYOG PRIVATE LIMITED",
"SHRI SARASWATI PRATHAMIK VIDYAMANDIR AKURDI PUNE",
"SHRI SARAVANA INDUSTRIES PRIVATE. LIMITED.",
"SHRI SARDAR PATEL INTER COLLEGE SHERGARH MATHURA",
"SHRI SARDAR SAFE DEPOSIT VAULT PVT LTD",
"SHRI SARSWATI U M SANSKRIT VIDYALAY",
"SHRI SARYANSH HOLIDAYS PRIVATE LIMITED",
"SHRI SATGURU METALLOYS PRIVATE LIMITED",
"SHRI SATGURU STONE PRIVATE LIMITED",
"SHRI SATHYA SAI MEDICAL COLLEGE AND RESEARCH INSTITUTE",
"SHRI SATI BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"SHRI SATIJI INFRATECH AND MEDIA PRIVATE LIMITED",
"SHRI SATPUDA VAIBHAV VIDYALAYA VA KANISHTA MAHAVIDYALAYA VANYAVIHIR TAL AKKALKUWA DIST NANDURBAR",
"SHRI SATYA NARAYAN TIWARI VIDYA MANDIR INTER COLLEGE",
"SHRI SATYA SHANTI ENTERPRISES JHANSI",
"SHRI SATYANARAYANA HINDI PRIMARY SCHOOL",
"SHRI SATYASAI BABA INFRA VENTURES PRIVATE LIMITED",
"SHRI SENTHURVELAN INFRAS",
"SHRI SEVALAL CONSTRUCTION PRIVATE LIMITED",
"SHRI SHADI GHAR PRIVATE LIMITED",
"SHRI SHAH K L INSTITUTE FOR THE DEAF TRUST",
"SHRI SHAHU MANDIR MAHAVIDYALAYA",
"SHRI SHAKAMBARI FERROUS PRIVATE LIMITED",
"SHRI SHAKTHI WEAVING MILLS PRIVATE LIMITED",
"SHRI SHAKTI AGENCIES PRIVATE LIMITED",
"SHRI SHAKTI ALTERNATIVE ENERGY LIMITED",
"SHRI SHAKTI COLLEGE OF HOTEL NAMANGEMENT",
"SHRI SHAKTI CYLINDERS PVT LTD",
"SHRI SHAKTI GRANI MARMO PRIVATE LIMITED",
"SHRI SHAKTI RESORTS AND HOTELS LIMITED",
"SHRI SHAKTI SCHOOLS PRIVATE LIMITED",
"SHRI SHAKUMBARI COTSPIN LIMITED",
"SHRI SHAKUN OILS LIMITED",
"SHRI SHAMBHU MAHADEV PRATHAMIK VIDHYALAYA FURSUNGI",
"SHRI SHANIDEV MAHARAJ INFRA PRIVATE LIMITED",
"SHRI SHANKAR BAX SINGH JHS",
"SHRI SHANKAR GRAMIN BIGAR SHETI SAHKARI PATHSANSTHA",
"SHRI SHANKARACHARYA INSTITUTE OF MEDICAL SCIENCES BHILAI",
"SHRI SHANKARLAL SUNDARBAI SHASUN JAIN COLLEGE FOR WOMEN",
"SHRI SHANKARPRASAD AGNIHOTRI COLLAGE OF ENGINEERING",
"SHRI SHANKER DEV ADARSH INTER COLLEGE",
"SHRI SHANKER GAURI AGRO PRODUCT PRIVATE LIMITED",
"SHRI SHANKER TALA BHANDAR PRIVATE LIMITED",
"SHRI SHANMUGA AGGREGATES AND INFRA PRIVATE LIMITED",
"SHRI SHANTI SOLVEX PRIVATE LIMITED",
"SHRI SHARAN SOLAR PRIVATE LIMITED",
"SHRI SHARAN STEEL PRIVATE LIMITED",
"SHRI SHARDA IT-SOLUTIONS PRIVATE LIMITED",
"SHRI SHARDA KANJUR ENTERPRISES PRIVATE LIMITED",
"SHRI SHARDANAND FOOD PROCESSING PRIVATE LIMITED",
"SHRI SHARMA STEELTECH (INDIA) PRIVATE LIMITED",
"SHRI SHARNAM INFRA PRIVATE LIMITED",
"SHRI SHIKSHAYATAN COLLEGE",
"SHRI SHIV KRIPA COLD STORAGE PRIVATE LIMITED",
"SHRI SHIV NANDI DAIRY PRODUCTS PRIVATE LIMITED",
"SHRI SHIV PRASAD RASHTRIYA INTER COLLEGE",
"SHRI SHIV SHANKAR CHEMICALS & MANUFACTURING PRIVATE LIMITED",
"SHRI SHIV SHANKAR INFRA ROYALTY PRIVATE LIMITED",
"SHRI SHIVA RAM FLOUR MILLS PRIVATE LIMITED",
"SHRI SHIVAJI AGRICULTURE COLLEGE AMRAVATI",
"SHRI SHIVAJI ARTS AND COMMERACE CLOLLEGE AMRAVATI",
"SHRI SHIVAJI COLLEGE OF PHYSICAL EDUCATION",
"SHRI SHIVAJI HIGHSCHOOL",
"SHRI SHIVAJI HIGHSCHOOL AND ARTS SCIENCE COLLEGE SAKRI DHULE",
"SHRI SHIVAJI HIGHSCHOOL PAROLA",
"SHRI SHIVAJI JUNIOR SCIENCE COLLEGE DARWA",
"SHRI SHIVAJI MARATHA HIGHSCHOOL AND JUNIOR COLLEGE SHUKRAWAR PETH PUNE",
"SHRI SHIVAJI PREPARATORY MILITARY SCHOOL AND JR COLLEGE",
"SHRI SHIVAJI VIDYA PRASARAK SANTHA'S L.K DR. P.R GHOGREY SCIENCE COLLEGE DHULE",
"SHRI SHIVAJI VIDYALAYA DARWAH",
"SHRI SHIVAJIRAO DESHMUKH INSTITUTE OF TECHNOLOGY",
"SHRI SHIVAJIRAO KHORATE VIDYALAY AND JR COLLEGE SARAWADE",
"SHRI SHIVAM OIL REFINERY UDYOG PRIVATE LIMITED",
"SHRI SHIVGIRI HINDI UPPER PRIMARY SCHOOL",
"SHRI SHIVJOT DEVELOPERS AND BUILDERS LIMITED",
"SHRI SHIVKRUPA SYNTHETICS PRIVATE LIMITED",
"SHRI SHRI BABAJI EARTH MOVERS PRIVATE LIMITED",
"SHRI SHRI NIWASJI OIL REFINERS PRIVATE LIMITED",
"SHRI SHRI SHAMBHUNATH FOOD PRODUCTS PRIVATE LIMITED",
"SHRI SHRIKRISHNA RAIL ENGINEERS PRIVATE LIMITED",
"SHRI SHRISTI CONSTRUCTION PRIVATE LIMITED",
"SHRI SHYAM AGRO BIOTECH PRIVATE LIMITED",
"SHRI SHYAM ALANKAR PRIVATE LIMITED",
"SHRI SHYAM CEMENT WORKS PVT LTD",
"SHRI SHYAM COMMUNICATION PRIVATE LIMITED",
"SHRI SHYAM DIGICARE PRIVATE LIMITED",
"SHRI SHYAM EXCLUSIVE PRIVATE LIMITED",
"SHRI SHYAM GENSET INDIA PRIVATE LIMITED",
"SHRI SHYAM GLOBAL PRIVATE LIMITED",
"SHRI SHYAM INDUSTRIES PVT. LTD.",
"SHRI SHYAM INFRA PRIVATE LIMITED",
"SHRI SHYAM IRON & POWER PRIVATE. LIMITED.",
"SHRI SHYAM ISPATINDIA PRIVATE LIMITED",
"SHRI SHYAM JEE AUTO-WHEELS PRIVATE LIMITED",
"SHRI SHYAM KRIPA INVESTMENTS PRIVATE LIMITED",
"SHRI SHYAM KRIPA STEEL PRIVATE LIMITED",
"SHRI SHYAM OIL EXTRACTIONS PRIVATE LIMITED",
"SHRI SHYAM POLYCOAT PRIVATE. LIMITED.",
"SHRI SHYAM PULSES PRIVATE LIMITED",
"SHRI SHYAM SUNRISE INDUSTRIES PRIVATE LIMITED",
"SHRI SHYAM TRADEX PRIVATE LIMITED",
"SHRI SHYAM VEHICLE AGENCY PRIVATE LIMITED",
"SHRI SHYAM WAX FACTORY PRIVATE LIMITED",
"SHRI SHYAMA SHYAM DYES PRIVATE LIMITED",
"SHRI SHYAMJI TOOLS PRIVATE LIMITED",
"SHRI SHYAMKRIPA INTERIOR & LIGHTING PRIVATE LIMITED",
"SHRI SIDDESHWAR SUPER BAZAR PRIVATE LIMITED",
"SHRI SIDDHA POLYMERS & PACKAGING PRIVATE LIMITED",
"SHRI SIDDHARTH VIDHYALAY",
"SHRI SIDDHESHWAR GINNING AND PRESSING PRIVATE LIMITED",
"SHRI SIDDHESHWAR GUMS PRIVATE LIMITED",
"SHRI SIDDHESHWAR MARATHI SHALA",
"SHRI SIDDHESHWAR ORGANIC FOODS PRIVATE LIMITED",
"SHRI SIDDHESHWAR ROLLER AND FLOUR MILLS PRIVATE LIMITED",
"SHRI SIDDHESHWAR SAHAKARI SAKHAR KARKHANA LTD",
"SHRI SIDDHI AGRI CHEM PRIVATE LIMITED",
"SHRI SIDDHI KUMAR INFRASTRUCTURE PRIVATE LIMITED",
"SHRI SIDDHI SANTATI CONSTRUCTION PRIVATE LIMITED",
"SHRI SIDDHI VINAYAGA TEX INDIA PRIVATE LIMITED",
"SHRI SIDDHI VINAYAK CREATIONS PRIVATE LIMITED",
"SHRI SIDDHIVINAYAK GANAPATI CANCER HOSPITAL",
"SHRI SIDDHIVINAYAK INDUSTRIES",
"SHRI SIDDHIVINAYAK MAHILA MAHAVIDYALAYA",
"SHRI SIDDHIVINAYAK POLYTECHNIC",
"SHRI SIDDHIVINAYAK SOLAR SOLUTIONS PRIVATE LIMITED",
"SHRI SIDDIVINAYAKA LEISURES PRIVATE LIMITED",
"SHRI SIDH POLYPRODUCTS PRIVATE LIMITED",
"SHRI SIDHBALI TRADING PRIVATE LIMITED",
"SHRI SIDHESHWAR MARATHI SHALA",
"SHRI SIDHIVINAYAK INFRATECH PRIVATE LIMITED",
"SHRI SIDHIVINAYAK OVERSEAS PRIVATE LIMITED",
"SHRI SIDRAMPPA HATURE PRIMARY SCHOOL HATURENAGAR",
"SHRI SIMANDHAR MULTI TRADE & SERVICES PRIVATE LIMITED",
"SHRI SINGAJI POWER PROJECT LIMITED",
"SHRI SIRISHA AUTO PRIVATE LIMITED",
"SHRI SITARAM SANSKRIT MAHAVIDYALAYA, KATIYARI SATRANVA",
"SHRI SIVA MARKETING AGENCIES PRIVATE LIMITED",
"SHRI SN SIDHESHWAR PUBLIC SCHOOL",
"SHRI SOLAR ENERGY PRODUCTS PRIVATE LIMITED",
"SHRI SOMANATHA TRADELINK PRIVATE LIMITED",
"SHRI SOMESHWAR ALLOYS PRIVATE LIMITED",
"SHRI SOMESHWAR VID GURSALE",
"SHRI SOURAB SAGAR TRADING CO. PRIVATE LIMITED",
"SHRI SOWPARNIKA TILE WORKS PRIVATE LIMITED",
"SHRI SSSD ALIMENTS PRIVATE LIMITED",
"SHRI SUBEDAR SINGH INTERMEDIATE COLLEGE",
"SHRI SUBHASH SUGAR PRIVATE LIMITED",
"SHRI SUDARSHAN COTTON INDUSTRIES PRIVATE LIMITED",
"SHRI SUDARSHAN FILAMENTS PRIVATE LIMITED",
"SHRI SUMATI INDUSTRIES PRIVATE LIMITED",
"SHRI SUPARNA INFOTECH LIMITED",
"SHRI SUPER JAIN TIMBER PRIVATE LIMTIED",
"SHRI SURYA FEEDS PRIVATE LIMITED",
"SHRI SWAMI BHUMANAND COLLEGE OF NURSING",
"SHRI SWAMI SAMARTH MADHYAMIK VIDYALAYA LANDEWADI",
"SHRI SWAMI SAMARTH MEDICO",
"SHRI SWAMI SAMARTH PHARMACEUTICALS LIMITED",
"SHRI SWAMI VIDYALAYA DONGARGAON",
"SHRI SWAMI VIVEKANAND SHIKSHAN SANSTHA",
"SHRI SWAMIJI IMPEX PRIVATE LIMITED",
"SHRI SWAMINARAYAN HIGH SCHOOL DHRANGADHARA",
"SHRI SWASAN CHEMICALS MADRAS PRIVATE LIMITED",
"SHRI SWAYAMBHU HIGHSCHOOL BOLOLI",
"SHRI T.P. SPINNING MILLS PRIVATE LIMITED",
"SHRI T.P.TEXTILES PRIVATE LIMITED",
"SHRI TANSUKHDAS RATHI VIDHYALAYA VARHA",
"SHRI TAPIBAI AYURVED HOSPITAL",
"SHRI TARA METALS PRIVATE LIMITED",
"SHRI TECHNORAM TEX PARTS PRIVATE LIMITED",
"SHRI TECHTEX PRIVATE LIMITED",
"SHRI THANGAM SPINNERS INDIA PRIVATE LIMITED",
"SHRI TILAK VIDHLAYA INTER COLLEGE",
"SHRI TILAK VIDYALAYA INTER COLLEGE",
"SHRI TIRUPATI AGRITECH PRIVATE LIMITED",
"SHRI TIRUPATI BALAJI SUGAR INDUSTRIES PRIVATE LIMITED",
"SHRI TIRUPATI LOGISTICS & TRANSPORT PRIVATE LIMITED",
"SHRI TULARAM INTER COLLEGE",
"SHRI TULSI CRITICARE CLINIC",
"SHRI TULSI INDUSTRIES",
"SHRI TULSI OIL PRODUCTS",
"SHRI TULSI SWITCHGEAR PRIVATE LIMITED",
"SHRI UDAY SINGH JAIN KANYA INTER COLLEGE IN THE CITY ALIGARH",
"SHRI UDYOG TRADES PRIVATE LIMITED",
"SHRI UMA CATTLEFEEDS PRIVATE LIMITED",
"SHRI UMA JR COLLEGE AND VOCATIONAL SECTION",
"SHRI UMA PLASTIC INDUSTRIES PRIVATE LIMITED",
"SHRI V S PATEL MILK PRODUCTS PRIVATE LIMITED",
"SHRI VAARI ELECTRICALS PRIVATE LIMITED",
"SHRI VAIBHAV METACAST PRIVATE LIMITED",
"SHRI VAISHNAV INSTITUTE OF TECHNOLOGY",
"SHRI VAISHNAV POLYTECHNIC COLLEGE",
"SHRI VAISHNAV VIDYAPEETH VISHWAVIDYALAYA",
"SHRI VAISHNO NUTS FACTORY PRIVATE LIMITED",
"SHRI VALLABH FOREX PRIVATE LIMITED",
"SHRI VALLEY REFRACTORIES LIMITED",
"SHRI VALLI VIDHYALAYA MATRICULATION SCHOOL",
"SHRI VALLIMURUGAN SPINNERS PRIVATE LIMITED",
"SHRI VARDHAMAN JAIN MATRIC HR. SEC SCHOOL",
"SHRI VARDHMAAN INSTITUTE PRIVATE LIMITED",
"SHRI VARDHMAN TECHNOLOGIES PRIVATE LIMITED",
"SHRI VARI CARGO PRIVATE LIMITED",
"SHRI VARI PHARMA PRIVATE LIMITED",
"SHRI VARU POLYTEX PRIVATE LIMITED",
"SHRI VASANTHRAJ TEXTILES PRIVATE LIMITED",
"SHRI VASANTRAO NAIK GOVERNMENT MEDICAL COLLEGE YAVATMAL",
"SHRI VASANTRAO NAIK GOVT MED CPLLEGE AND WOMENS HOSP",
"SHRI VASIHNAV INSTITUTE OF MANAGEMENT",
"SHRI VASUDEV DIAGNOSTIC PRIVATE LIMITED",
"SHRI VASUDEVA WEAVING MILLS PRIVATE LIMITED",
"SHRI VASUPRADA PLANTATIONS LIMITED",
"SHRI VEDANTA CLOTHINGS PRIVATE LIMITED",
"SHRI VEER TEJA REAL ESTATE AND DEVELOPERS PRIVATE LIMITED",
"SHRI VENGATESWARA TEX PRIVATE LIMITED",
"SHRI VENKATESH FILAMENTS PRIVATE LIMITED",
"SHRI VENKATESH HIGH SCHOOL AND KANISHTH MAHAVIDYALAYA",
"SHRI VENKATESH HOME APPLIANCES PRIVATE LIMITED",
"SHRI VENKATESH JR COLLEGE",
"SHRI VENKATESH POLYCORE PRIVATE LIMITED",
"SHRI VENKATESH REFINERIES LIMITED",
"SHRI VENKATESHWAR FAUCETS PRIVATE LIMITED",
"SHRI VENKATESHWARA AGRO INDUSTRIES",
"SHRI VENKATESHWARA UNIVERSITY",
"SHRI VENKATESWARA HI-TECH MACHINERIES PRIVATE LIMITED",
"SHRI VENKETESHWARA BIO REFINERIES AND BIO-FUELS PRIVATE LIMITED",
"SHRI VENKETESHWARA BUILDTECH PRIVATE LIMITED",
"SHRI VENKTESH SOFTECH PRIVATE LIMITED",
"SHRI VENKTESHWAR HOSPITAL AND MEDICAL RESEARCH CENTRES PVT LTD",
"SHRI VERAI SHIPPING AGENCIES",
"SHRI VIBRACION TECHNOLOGIES PRIVATE LIMITED",
"SHRI VIDYANIKETAN PRATHMIK VIDYAMANDIR LATUR",
"SHRI VIDYARAM INTER COLLEGE",
"SHRI VIGHNESHWAR AGROTECH & LOGISTICS PRIVATE LIMITED",
"SHRI VIGNESH AIR CONDITIONING ENGINEERS PRIVATE LIMITED",
"SHRI VIGNESH COCONUT POWDERS PRIVATE LIMITED",
"SHRI VILE PARLE KELAVANI MANDAL(SVKM)",
"SHRI VINAIK LOGISTICS PRIVATE LIMITED",
"SHRI VINAY OPERATIONAL CONSULTANCY SERVICES",
"SHRI VINAYAK CHEMEX (INDIA) PVT.LTD.",
"SHRI VINAYAK IMPORTS PRIVATE LIMITED",
"SHRI VINAYAK INFRALAND PRIVATE LIMITED",
"SHRI VINAYAK PACKAGING MACHINE PRIVATE LIMITED",
"SHRI VINAYAK SHODH EVAM PRASHIKSHAN SANSTHAN",
"SHRI VINAYAKA IMPEX PRIVATE LIMITED",
"SHRI VINAYAKRAO MADHYAMIK VIDYALAYA VAIDYAKINHI PATODA BEED",
"SHRI VIRATRA INFRATECH PRIVATE LIMITED",
"SHRI VISHNU ENGINEERING COLLEGE FOR WOMEN",
"SHRI VISHNU PERUMAAL SPIN YARN LIMITED",
"SHRI VISHNU PICKLES PRIVATE LIMITED",
"SHRI VISHNU REFRACTORIES LIMITED",
"SHRI VISHU PAPER PRIVATE LIMITED",
"SHRI VISHWABHARTI GLOBAL INFRASTRUCTURE PRIVATE LIMITED",
"SHRI VISHWAKARMA SKILL UNIVERSITY",
"SHRI VIVEKANAND MAHILA VIKAS FEDERATION",
"SHRI VRIDDHI INFRAPROPERTIES PRIVATE LIMITED",
"SHRI WARDHMAN ACADEMY FOR TECHNICAL EDUCATION, JABALPUR",
"SHRI YASH ESTATE PRIVATE LIMITED",
"SHRI YOGI MULTITRADE PRIVATE LIMITED",
"SHRI ZELCO FOODS PRIVATE LIMITED",
"SHRI.MAHALXMI VID.KUNDANLAL GUPTA NAGAR NGP",
"SHRIAJAB FOODS PRIVATE LIMITED",
"SHRIAMAN AGROVET PRIVATE LIMITED",
"SHRIANDSHRI INDUSTRIES PRIVATE LIMITED",
"SHRIANK ENTERPRISE PRIVATE LIMITED",
"SHRIARIHANT MANGAL EXPO IMPO PRIVATE LIMITED",
"SHRIARJUN NEEDDAY PRIMEMART PRIVATE LIMITED",
"SHRIAUNSH ERECTORS PRIVATE LIMITED",
"SHRIBALAJI ADDITIVES PRIVATE LIMITED",
"SHRIBALAJI AUTOAGENCY MYSORE PRIVATE LIMITED",
"SHRIBALAJI INTEGRATED SOLUTIONS PRIVATE LIMITED",
"SHRIBALAJI POLYTAPE LIMITED",
"SHRIBALDIGAMBAR INFRASTRUCTURE PRIVATE LIMITED",
"SHRIBARSANA WIRE AND WIRE MESH PRIVATE LIMITED",
"SHRICARE SOLUTIONS PRIVATE LIMITED",
"SHRICHTI ENTERPRISES RUPNAGAR",
"SHRICOM OFFICE AUTOMATION PRIVATE LIMITED",
"SHRICON INDUSTRIES LIMITED",
"SHRIDAKSH DESIGNER JEWELS PRIVATE LIMITED",
"SHRIDATTAGURU DAIRYFARM PRIVATE LIMITED",
"SHRIDDHA POWER SOLUTIONS PRIVATE LIMITED",
"SHRIDEEP LABS PRIVATE LIMITED",
"SHRIDEV OVERSEAS PRIVATE LIMITED",
"SHRIDEVA TECHNOMECH PRIVATE LIMITED",
"SHRIDEVI HOSPITALITY SERVICES PRIVATE LIMITED",
"SHRIDEVI INSTITUTE OF MEDICAL SCIENCES & RESEARCH HOSPITAL",
"SHRIDHAN AUTOMATION PRIVATE LIMITED",
"SHRIDHAN INTERNATIONAL PRIVATE LIMITED",
"SHRIDHAR INDUSTRIES KATNI PRIVATE LIMITED",
"SHRIDHAR INFRATEL PRIVATE LIMITED",
"SHRIDHAR METALS PRIVATE LIMITED",
"SHRIDHAR MINERALS PRIVATE LIMITED",
"SHRIDHAR REAL ESTATES PRIVATE LIMITED",
"SHRIDHAR TRADEX PRIVATE LIMITED",
"SHRIDHAR VYAPAAR PRIVATE LIMITED",
"SHRIDHARA INFRATECH PRIVATE LIMITED",
"SHRIDI PROPERTIES & BUILDERS PRIVATE LIMITED",
"SHRIDI SAI HANDLING EQUIPMENTS PRIVATE LIMITED",
"SHRIE HARIVALLABI SPINNERS PRIVATE LIMITED",
"SHRIGANESH KIRANA PRIVATE LIMITED",
"SHRIGOPAL RAMESHKUMAR SALES PRIVATE. LIMITED.",
"SHRIGOVIND POLYTEX PRIVATE LIMITED",
"SHRIGUN PHARMACHEM PRIVATE LIMITED",
"SHRIH SWASTIK SIZERS PRIVATE LIMITED",
"SHRIHAAN AGRO & EXIM PRIVATE LIMITED",
"SHRIHANUMANT LIFESTYLE PRIVATE LIMITED",
"SHRIHARI INFRA HOMES PRIVATE LIMITED",
"SHRIHARI POLYHOUSES PRIVATE LIMITED",
"SHRIHARI TRADEX PRIVATE LIMITED",
"SHRIHARI WOVEN SACKS INDIA PRIVATE LIMITED",
"SHRII WINMARK INDUSTRIES PRIVATE LIMITED",
"SHRIJAN INFRAVENTURES PRIVATE LIMITED",
"SHRIJAWATERLINKS PRIVATE LIMITED",
"SHRIJAY CASHEWS & ALLIED PRODUCTS PRIVATE LIMITED",
"SHRIJAY TECHNOCRATS PRIVATE LIMITED",
"SHRIJEE COTTON MILLS LIMITED",
"SHRIJEE FARE PRIVATE LIMITED",
"SHRIJEE HEAVY PROJECTS WORKS LIMITED",
"SHRIJEE LIFE STYLE PRIVATE LIMITED",
"SHRIJEE LIFESTYLE PRIVATE LIMITED",
"SHRIJEE PAPER MILLS PRIVATE LIMITED",
"SHRIJEE PROCESS ENGINEERING WORKS LIMITED",
"SHRIJEE SUGAR AND POWER PRIVATE LIMITED",
"SHRIJI AWAS VIKAS PRIVATE LIMITED",
"SHRIJI BABA SARASWATI VIDYA MANDIR",
"SHRIJI CAR RENTALS PRIVATE LIMITED",
"SHRIJI EDUCATION SERVICES",
"SHRIJI GOURMETLINES PRIVATE LIMITED",
"SHRIJI INFRATEL PRIVATE LIMITED",
"SHRIJI INKS PRIVATE LIMITED",
"SHRIJI KRAFT DECORATORS PRIVATE LIMITED",
"SHRIJI POLYMERS INDIA LIMITED",
"SHRIJI POWER & AUTOMATION PRIVATE LIMITED",
"SHRIJI RESORT HOTELS PVT LTD",
"SHRIJI SHARANAM TRADING PRIVATE LIMITED",
"SHRIJI SHEETGRAH PRIVATE LIMITED",
"SHRIJI TECHNOASPIRE PRIVATE LIMITED",
"SHRIJI TEXTILE PRIVATE LIMITED",
"SHRIJI TRAVELTEAM FACILITY & HOSPITALITY PRIVATE LIMITED",
"SHRIJRG FOOD PRODUCTS PRIVATE LIMITED",
"SHRIKA DEVELOPERS PRIVATE LIMITED",
"SHRIKA INDUSTRIES PRIVATE LIMITED",
"SHRIKALPA PRODUCTS PRIVATE LIMITED",
"SHRIKALYANI AGRITECH PRIVATE LIMITED",
"SHRIKANT ENTERPRISES PRIVATE LIMITED",
"SHRIKANT MARKETING PRIVATE LIMITED",
"SHRIKANT PROCESSORS PVT. LTD.",
"SHRIKANTHA AGRO FOODS PRIVATE LIMITED",
"SHRIKAR HOTELS PRIVATE LIMITED",
"SHRIKARA ENGINNERING LIMITED",
"SHRIKHANDE CONSULTANTS LIMITED",
"SHRIKHANDE CONSULTANTS PRIVATE LIMITED",
"SHRIKISHAN AND COMPANY PRIVATE LIMITED",
"SHRIKRIPA GENERAL MILLS PRIVATE LIMITED",
"SHRIKRISHANATH IMPEX PRIVATE LIMITED",
"SHRIKRISHNA AVDHOOT AGRO PRIVATE LIMITED",
"SHRIKRISHNA ENVIRONMENT CONSULTANTS PRIVATE LIMITED",
"SHRIKRISHNA FINVEST AND CAPITAL MANAGEMENT PVT LTD",
"SHRIKRISHNA FOILS N LAMINATES PRIVATE LIMITED",
"SHRIKRISHNA GARAGE PRIVATE LIMITED",
"SHRIKRISHNA HRUDAYALAYA AND CRITICAL CARE CENTER",
"SHRIKRISHNA ICE AND SHEET GRAH PRIVATE LIMITED",
"SHRIKRISHNA INVESTIGATION & SECURITY SOLUTIONS OPC PRIVATE LIMITED",
"SHRIKRISHNA KHANDSARI SUGAR MILLS",
"SHRIKRISHNA SPICES PVT LTD",
"SHRIKRUPA GINNERS PRIVATE LIMITED.",
"SHRIKRUPA INDUSTRIES PRIVATE LIMITED",
"SHRIKRUSHNA MILK & COMMODITIES PRIVATE LIMITED",
"SHRILEARNING MANAGEMENT CONSULTANCY PRIVATE LIMITED",
"SHRILEKHA BUSINESS CONSULTANCY PRIVATE LIMITED",
"SHRILEKHA TRADING PRIVATE LIMITED",
"SHRILL INVESTMENTS LIMITED",
"SHRIM BHANU CONSTRUCTION PRIVATE LIMITED",
"SHRIM INTERNATIONAL PRIVATE LIMITED",
"SHRIM INVESTMENT SOLUTIONS PRIVATE LIMITED",
"SHRIM PHARMA PRIVATE LIMITED",
"SHRIMA MACHINES PRIVATE LIMITED",
"SHRIMA TECH TEX PRIVATE LIMITED",
"SHRIMAD GOKUL DAIRY PRIVATE LIMITED",
"SHRIMAD INDIA PRIVATE LIMITED",
"SHRIMAD RAJCHANDRA HOSPITAL",
"SHRIMADHOPUR TRADINGS PRIVATE LIMITED",
"SHRIMAHALAXMI ENGIMECH PRIVATE LIMITED",
"SHRIMAHALAXMI GOLD ARTS PRIVATE LIMITED",
"SHRIMAHANAND LEISURE VALLEY PRIVATE LIMITED",
"SHRIMAHAVEER HOME FURNISH EXPO PRIVATE LIMITED",
"SHRIMAHAVIR PAPERS TRADING PRIVATE LIMITED",
"SHRIMAL MARBLES (INDIA) PRIVATE LIMITED",
"SHRIMALI FINANCIAL SERVICES PRIVATE LIMITED",
"SHRIMAN ELECTRICAL ASSOCIATES PRIVATE LIMITED",
"SHRI-MAN ENGINEERS PRIVATE LIMITED",
"SHRIMAN G R WARANGE JUNIOR COLLGE MALKAPUR",
"SHRIMAN NARAYAN FIBER UDHOG PRIVATE LIMITED",
"SHRIMAN NARAYAN ROLLER FLOUR MILLS PRIVATE LIMITED",
"SHRIMANNARAYAN ENTERPRISES PRIVATE LIMITED",
"SHRIMANT BABASAHEB DESHMUKH MILK PRODUCER COMPANY LIMITED",
"SHRIMANT BHAIYYASAHEB RAJEMANE MAHAVIDYALAYA",
"SHRIMANT CHATRAPATI PRATAPSINGH VIDYALAY",
"SHRIMANT HOLDINGS P LTD",
"SHRIMANT MAISAHEB BAVADEKAR ACADEMY",
"SHRIMARUTI POWER & FUEL PRIVATE LIMITED",
"SHRIMARUTI PRECISION ENGINEERING PRIVATE LIMITED",
"SHRIMARUTINANDAN IRON & STEEL PRIVATE LIMITED",
"SHRIMATE PROMOTERS PRIVATE LIMITED",
"SHRIMATI BINZANI WOMENS COLLEGE",
"SHRIMATI HARIPAYRI DEVI INTER COLLEGE ROHAI",
"SHRIMATI INDIRA GANDHI PRI VIDYALAYA",
"SHRIMATI JIVIBA KANYA VIDHYALAY",
"SHRIMATI KISHORITAI BHOYAR COLLGE OF PHA",
"SHRIMATI LAXMIBAI TAPKIR MADHYAMIC VIDYALAYA",
"SHRIMATI MATA RADHABAI APANG NIVASI MUK BADHIR VIDYALAYA",
"SHRIMATI MITHIBAI MOTIRAM KUNDNANI COLLEGE OF COMMERCE & ECONOMICS",
"SHRIMATI RADHIKABAI PANDAV COLLEGE OF EN",
"SHRIMATI SULOCHNA DEVI EDUCATION FOUNDATION",
"SHRIMAY ENTERPRISES PRIVATE LIMITED",
"SHRIMAYI TRADEMART SERVICES PRIVATE LIMITED",
"SHRIMPEX BIOTECH SERVICES PRIVATE LIMITED",
"SHRIMPEX HATCHERIES PRIVATE LIMITED",
"SHRIMUKTAI MART PRIVATE LIMITED",
"SHRIMURLIDHAR INFRA HOMES PRIVATE LIMITED",
"SHRINAATH BUILDINTERIO PRIVATE LIMITED",
"SHRINAG AUTOTOOLS PRIVATE LIMITED",
"SHRINATH ADHESIVE PRODUCT PRIVATE LIMITED",
"SHRINATH CARGO PRIVATE LIMITED",
"SHRINATH CARTONS PRIVATE LIMITED",
"SHRINATH COLLEGE OF PHARMACY",
"SHRINATH COTTON CO.",
"SHRINATH ENGINEERINGS",
"SHRINATH FLEXIPACK PRIVATE LIMITED",
"SHRINATH INFRACITY PRIVATE LIMITED",
"SHRINATH NATURAL ENERGY PRIVATE LIMITED",
"SHRINATH ROTOPACK PRIVATE LIMITED",
"SHRINATH SOYA PRIVATE LIMITED",
"SHRINATH TRAVEL AGENCY PRIVATE LIMITED",
"SHRINATH UNIQUEGEMS PRIVATE LIMITED",
"SHRINATH WOVEN PACK PRIVATE LIMITED",
"SHRINATHJI CONSULTLALTACY SERVICES",
"SHRINATHJI ECO AQUA PRIVATE LIMITED",
"SHRINATHJI ELECTRICALS & INFRASTRUCTURE PRIVATE LIMITED",
"SHRINATHJI EQUIPMENTS PRIVATE LIMITED",
"SHRINATHJI FORWARDERS PRIVATE LIMITED",
"SHRINATHJI FRUITS PRIVATE LIMITED",
"SHRINATHJI KAYAKALP REMEDIES PRIVATE LIMITED",
"SHRINATHJI PRESTRESSED PRIVATE LIMITED",
"SHRINATHJI SOLVEX LIMITED",
"SHRINATHSOLITAIRE PRIVATE LIMITED",
"SHRINATURE GREEN AGROTECH PRIVATE LIMITED",
"SHRINE AUTO PRIVATE LIMITED",
"SHRINE BUILDTECH PRIVATE LIMITED",
"SHRINE CHEMICALS PRIVATE LIMITED",
"SHRINE ELECTRO INDIA PRIVATE LIMITED",
"SHRINE ENGINEERING PRIVATE LIMITED",
"SHRINE LABORATORIES PRIVATE LIMITED",
"SHRINE LIFESCIENCES PRIVATE LIMITED",
"SHRINES PROJECTS PRIVATE LIMITED",
"SHRINET & SHANDILYA CONSTRUCTION PRIVATE LIMITED",
"SHRING CONSTRUCTION",
"SHRINGAAR NEEDLED NONWOVENS PVT LTD",
"SHRINGAR ENGINEERING AND ENERGY SYSTEMS PRIVATE LIMITED",
"SHRINGAR FASHION JEWELLERY PRIVATE LIMITED",
"SHRINGAR FILM PRIVATE LIMITED",
"SHRINGAR HOUSE OF MANGALSUTRA PRIVATE LIMITED",
"SHRINGVED BUILDERS PRIVATE LIMITED",
"SHRINI SOFTEX INDIA LIMITED",
"SHRINIBAS BIRI FACTORY PVT LTD",
"SHRINIDHI CHEMICALS & MINERALS PRIVATE LIMITED",
"SHRINIDHI COMPUTERS PRIVATE LIMITED",
"SHRINIDHI INNOTECH PRIVATE LIMITED",
"SHRINIDHI LAMINATES LIMITED",
"SHRINIKA AGRO PRODUCER COMPANY LIMITED",
"SHRINIKA CAPITAL FINANCE PRIVATE LIMITED",
"SHRINIKA IMPEX PRIVATE LIMITED",
"SHRINIKA MOTORS PRIVATE LIMITED",
"SHRINITHI CAPITAL PRIVATE LIMITED",
"SHRINIVAS AGENCY SOLAPUR",
"SHRINIVAS AND SONS PRIVATE LIMITED",
"SHRINIVAS ELECTRICALS",
"SHRINIVAS ORGANISORS PRIVATE LIMITED",
"SHRINIVAS SUGANDHALAYA BNG LLP",
"SHRINIVASA AGRO FOODS PRIVATE LIMITED",
"SHRINIVASA CATTLE FEEDS PRIVATE LIMITED",
"SHRINIWAS ENGINEERING AUTO COMPONENTS PRIVATE LIMITED",
"SHRINIWAS GINNING INDUSTRIES",
"SHRINIWAS LOGISTICS SERVICES PRIVATE LIMITED",
"SHRINIWAS POLYFABRICS AND PACKWELL PRIVATE LIMITED",
"SHRINIWAS SALES PRIVATE LIMITED",
"SHRINIWAS SPINTEX INDUSTRIES PRIVATE LIMITED",
"SHRINIWAS VASTUNIRMAN PRIVATE LIMITED",
"SHRINIWASA APPARELS PRIVATE LIMITED",
"SHRINIWASA PROTEINS PRIVATE LIMITED",
"SHRINIWASA ROAD CARRIERS PRIVATE LIMITED",
"SHRINIWASA ROADWAYS PRIVATE LIMITED",
"SHRINK PACKAGING SYSTEMS PRIVATE LIMITED",
"SHRINK PACK-LABELS PVT LTD",
"SHRIOM FACILITY MANAGEMENT PRIVATE LIMITED",
"SHRIOMSAI STEELS PRIVATE LIMITED",
"SHRIPAD AGRO SALES PRIVATE LIMITED",
"SHRIPAD CONCHEM PRIVATE LIMITED",
"SHRIPAD FILTERS PRIVATE LIMITED",
"SHRIPAD POLYMERS PRIVATE LIMITED",
"SHRIPAL DEVELOPERS PVT LTD",
"SHRIPAL METAL LIMITED",
"SHRIPAPER PRODUCT (INDORE) PRIVATE LIMITED",
"SHRIPATI HOTELS PRIVATE LIMITED",
"SHRIPATI INFRAPROJECTS PRIVATE LIMITED",
"SHRIPATI INFRASTRUCTURES PRIVATE LIMITED",
"SHRIPATRAO CHOUGULE ARTS AND SCIENCE COLLEGE",
"SHRIPATRAO DADA SAHAKARI BANK LTD",
"SHRIPRASAD SHIPPING PRIVATE LIMITED",
"SHRIPROP AEROSPACE PRIVATE LIMITED",
"SHRIPROP BUILDERS PRIVATE LIMITED",
"SHRIPROP CONSTRUCTORS PRIVATE LIMITED",
"SHRIPROP DEVELOPERS PRIVATE LIMITED",
"SHRIPROP PROJECTS PRIVATE LIMITED",
"SHRIPROP PROPERTIES PRIVATE LIMITED",
"SHRIPROP STRUCTURES PRIVATE LIMITED",
"SHRIRADHABALLABH COLD STORAGE PRIVATE LIMITED",
"SHRIRADHEYRADHEY INFRABUILDTECH PRIVATE LIMITED",
"SHRIRAJ ENGINEERS PRIVATE LIMITED",
"SHRIRAJARSHI SHAHU VIDYALAYA",
"SHRIRAJLAXMI DENIM LIMITED.",
"SHRIRAM ASSET MANAGEMENT COMPANY LIMITED",
"SHRIRAM AUTOMALL INDIA LIMITED",
"SHRIRAM AUTOMOTIVE PRODUCTS LIMITED",
"SHRIRAM AUTOWHEELS PRIVATE LIMITED",
"SHRIRAM BIOSEED VENTURES LIMITED",
"SHRIRAM BRIQUETTING PRIVATE LIMITED",
"SHRIRAM CAPITAL LIMITED",
"SHRIRAM CAPITAL PRIVATE LIMITED",
"SHRIRAM CAPITAL TRUST PRIVATE LIMITED",
"SHRIRAM CHITS INDIA PRIVATE LIMITED",
"SHRIRAM CHITS KARNATAKA PRIVATE LIMITED",
"SHRIRAM CHITS TAMILNADU PRIVATE LIMITED",
"SHRIRAM CITY UNION FINANCE LIMITED.",
"SHRIRAM CREDIT COMPANY LIMITED",
"SHRIRAM ENTERPRISES PRIVATE LIMITED",
"SHRIRAM EQUIPMENT FINANCE COMPANY LIMITED",
"SHRIRAM FILAMENTS AND ROPES PRIVATE LIMITED",
"SHRIRAM FINANCE LIMITED",
"SHRIRAM FINANCIAL PRODUCTS SOLUTIONS CHENNAI PRIVATE LIMITED",
"SHRIRAM FIREWORKS PRIVATE LIMITED",
"SHRIRAM FOOD INDUSTRY LIMITED",
"SHRIRAM FOOD INDUSTRY PRIVATE LIMITED",
"SHRIRAM FOOD PRODUCTS",
"SHRIRAM FORTUNE SOLUTIONS LIMITED",
"SHRIRAM FOUNDATIONS PRIVATE LIMITED",
"SHRIRAM FOUNDRY PRIVATE LIMITED",
"SHRIRAM GEARBOXES PRIVATE LIMITED",
"SHRIRAM GENERAL INSURANCE COMPANY LIMITED",
"SHRIRAM GI HOLDINGS PRIVATE LIMITED",
"SHRIRAM HARIRAM JEWELLERS",
"SHRIRAM HOUSING FINANCE LIMITED",
"SHRIRAM INDUSTRIES AND EXPORTS PRIVATE LIMITED",
"SHRIRAM INSIGHT SHARE BROKERS LIMITED",
"SHRIRAM INSTITUTE FOR INDUSTRIAL RESEARCH",
"SHRIRAM INVESTMENT HOLDINGS PRIVATE LIMITED",
"SHRIRAM LI HOLDINGS PRIVATE LIMITED",
"SHRIRAM LIFE INSURANCE COMPANY LIMITED",
"SHRIRAM MARKETING",
"SHRIRAM MEHAR POLYMERS PRIVATE LIMITED",
"SHRIRAM MITRA MANDAL PRATHAMIK VIDYAMANDIR",
"SHRIRAM MOTOR WORKS PRIVATE LIMITED",
"SHRIRAM NAVINKUMAR & SONS ISPAT PRIVATE LIMITED",
"SHRIRAM OVERSEAS INVESTMENTS PRIVATE LIMITED",
"SHRIRAM OZONE HOUSING DEVELOPMENT PRIVATE LIMITED",
"SHRIRAM PISTONS AND RINGS LIMITED",
"SHRIRAM POLYTECH LIMITED",
"SHRIRAM POWER SOLUTIONS PRIVATE LIMITED",
"SHRIRAM PROPERTIES LIMITED",
"SHRIRAM RAYONS",
"SHRIRAM RUBBER PRODUCTS PRIVATE LIMITED",
"SHRIRAM SALES AND MARKETING DEVELOPMENT PRIVATE LIMITED",
"SHRIRAM SALES CORPORATION",
"SHRIRAM SARVARIA AND SONS PRIVATE LIMITED",
"SHRIRAM SEEDS PRIVATE LIMITED",
"SHRIRAM STONE AND MARBLE PVT LTD",
"SHRIRAM TEXOLENE PRIVATE LIMITED",
"SHRIRAM TEXTRADE PRIVATE LIMITED",
"SHRIRAM TRADEX PRIVATE LIMITED",
"SHRIRAM VALUE PRIVATE LIMITED",
"SHRIRAM VERITECH SOLUTIONS PRIVATE LIMITED",
"SHRIRAM VIDYA MANDIR HIGH SCHOOL",
"SHRIRAM WAREHOUSING PRIVATE LIMITED.",
"SHRIRAM WEALTH ADVISORS LIMITED",
"SHRIRAM YATRA COMPANY PRIVATE LIMITED",
"SHRIRAMAYA REALITY PRIVATE LIMITED",
"SHRIRAMBHARATH CHEMICALS AND DETERGENTS PRIVATE LIMITED",
"SHRIRAMOZONE RETAIL PRIVATE LIMITED",
"SHRIRAMPUR MUNICIPAL COUNCIL",
"SHRIRAMPUR SUPER SPECIALITY HOSPITAL PRIVATE LIMITED",
"SHRIRAMRAGHAVENDRA CHITS PRIVATE LTD",
"SHRIRANG MOTELS PRIVATE LIMITED",
"SHRIRANG PRAKASHAN PRIVATE LIMITED",
"SHRIS INFOTECH SERVICES PRIVATE LIMITED",
"SHRISAI AKAR CIVILINFRA INDIA PRIVATE LIMITED",
"SHRISAI MEDICARE SERVICES PRIVATE LIMITED",
"SHRISAI SIDDI TRADERS PRIVATE LIMITED",
"SHRISAMARTH INFRAWAY (INDIA) PRIVATE LIMITED",
"SHRISANT AUTOMAX PRIVATE LIMITED",
"SHRISASHI VANGAPALLI COUTURE PRIVATE LIMITED",
"SHRISH ENTERPRISES PRIVATE LIMITED",
"SHRISHAILA ELECTRICALS (INDIA) PRIVATE LIMITED",
"SHRISHIVAY SANKATMOCHAN PHARMA PRIVATE LIMITED",
"SHRISHRI INFRASTRUCTURE PRIVATE LIMITED",
"SHRISHRIJI MEDISYS LIMITED",
"SHRISHTI AGRO AND ENERGY (OPC) PRIVATE LIMITED",
"SHRISHTI AGRO PRODUCTS PRIVATE LIMITED",
"SHRISHTI AIRCON PRIVATE LIMITED",
"SHRISHTI ALLOYS PRIVATE LIMITED",
"SHRISHTI COMMUNICATIONS & SOLUTIONS PRIVATE LIMITED",
"SHRISHTI ELECTRICALS PRIVATE LIMITED",
"SHRISHTI ELECTROMECH PRIVATE LIMITED",
"SHRISHTI FERRO PRODUCTS PRIVATE LIMITED",
"SHRISHTI INFRA SOLUTIONS PRIVATE LIMITED",
"SHRISHTI INFRAVENTURE PRIVATE LIMITED",
"SHRISHTI LOGISTICS PRIVATE LIMITED",
"SHRISHTI MARKETING PRIVATE LIMITED",
"SHRISHTI OVERSEAS PRIVATE LIMITED",
"SHRISHTI POWER TECHNOLOGIES PRIVATE LIMITED",
"SHRISHTI TECHNOLOGIES",
"SHRISHTI TOURS AND TRAVELS PRIVATE LIMITED",
"SHRISHTI TRADING CORPORATION PRIVATE LIMITED",
"SHRISIDDHI MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"SHRISTAB PRIVATE LIMITED",
"SHRISTE MARKETING PRIVATE LIMITED",
"SHRISTHI BHUMI INFRASTRUCTURE PRIVATE LIMITED",
"SHRISTHI LPG BOTLING PLANT PRIVATE LIMITED",
"SHRISTI ASSOCIATES",
"SHRISTI CARGO WAREHOUSE PRIVATE LIMITED",
"SHRISTI CEMENT LIMITED",
"SHRISTI COMMOTRADE PRIVATE LIMITED",
"SHRISTI COTSPINN PRIVATE LIMITED",
"SHRISTI DATA PRO PRIVATE LIMITED",
"SHRISTI DEVELOPERS PRIVATE LIMITED",
"SHRISTI ENTERPRISE",
"SHRISTI HOUSING INFRA PRIVATE LIMITED",
"SHRISTI INFRAENGINEERING PRIVATE LIMITED",
"SHRISTI INFRASTRUCTURE DEVELOPMENT CORPORATION LIMITED",
"SHRISTI INTERNATIONAL",
"SHRISTI INVESTMENTS PVT LTD",
"SHRISTI ISPAT & ALLOYS LIMITED",
"SHRISTI LEYING & BREEDING PRIVATE LIMITED",
"SHRISTI MINERALS PRIVATE LIMITED",
"SHRISTI SURVEY CONSULTING PRIVATE LIMITED",
"SHRISTI TOUR & TRAVELS PRIVATE LIMITED",
"SHRISTI TRADELINK PRIVATE LIMITED",
"SHRISWAMI SAMARTH AIRFREIGHT PRIVATE LIMITED",
"SHRITIRUPATI STEELCAST LIMITED",
"SHRIV COMMEDIA SOLUTIONS PRIVATE LIMITED",
"SHRIVA PUMPS PVT LTD",
"SHRIVAARI ELECTROTECH PRIVATE LIMITED",
"SHRIVAIKUNTH PAPER AND BOARDS PRIVATE LIMITED",
"SHRIVAIS INFRATECH PRIVATE LIMITED",
"SHRIVAISHNAVI INFRA PRIVATE LIMITED",
"SHRIVALLABH PITTIE INDUSTRIES LIMITED",
"SHRIVARAD POLYFAB PRIVATE LIMITED",
"SHRIVARDHMAN MILK DAIRY PRIVATE LIMITED",
"SHRIVARI REALITY PRIVATE LIMITED",
"SHRIVASTAVA COLD STORAGE PRIVATE LIMITED",
"SHRIVEE CAPITAL CONSULTANTS PRIVATE LIMITED",
"SHRIVEN AGRITECHS PRIVATE LIMITED",
"SHRIVIDYA EDUCATION FOUNDATION",
"SHRIVIK INDUSTRIES PRIVATE LIMITED",
"SHRIVILLA POLYPRODUCTS PRIVATE LIMITED",
"SHRIVIN PHARMA PRIVATE LIMITED",
"SHRIVINAYAK ELECTROPLATERS PRIVATE LIMITED",
"SHRIVIRAJ SECURITY SOLUTIONS PRIVATE LIMITED",
"SHRIVISION HOMES PRIVATE LIMITED",
"SHRIVISION TOWERS PRIVATE LIMITED",
"SHRIYA HOME TEXTILES PRIVATE LIMITED",
"SHRIYA PACKAGING PRIVATE LIMITED",
"SHRIYA RICE MILLS",
"SHRIYAM BROKING INTERMEDIARY LIMITED",
"SHRIYAM DECOR PRIVATE LIMITED",
"SHRIYAM SYNTHETIC PRIVATE LIMITED",
"SHRIYANTRA CONTROLS PRIVATE LIMITED",
"SHRIYASOM FASHIONS INTERNATIONAL LLP",
"SHRJAI FINE ARTS PRIVATE LIMITED",
"SHRM INFRA PRIVATE LIMITED",
"SHRMIK HOSPITALITY PRIVATE LIMITED",
"SHRO SYSTEMS PRIVATE LIMITED",
"SHROCONS INFRASTRUCTURES PRIVATE LIMITED",
"SHROFF AND ASSOCIATES ENGINEERS PRIVATE LIMITED",
"SHROFF CHEMICALS PVT LTD",
"SHROFF CONSTRUCTION PRIVATE LIMITED",
"SHROFF CONSULTING ENGINEERS LLP",
"SHROFF ESTATES PRIVATE LIMITED",
"SHROFF EYE CENTRE",
"SHROFF OIL MANUFACTURING COMPANY PRIVATE LIMITED",
"SHROFF POLYCRAFT PRIVATE LIMITED",
"SHROFF POLYTECH PRIVATE LIMITED",
"SHROFF PROCESSED FOODS & COLD STORAGE PRIVATE LIMITED",
"SHROFF PUBLISHERS AND DISTRIBUTORS PRIVATE LIMITED",
"SHROFF S R ROTARY INSTITUTE OF CHEMICAL TECHNOLOGY",
"SHROFF SR ROTATRY INSTITUTE OF CHEMICAL TECHNOLGY",
"SHROFILE TECHNOLOGIES PRIVATE LIMITED",
"SHROGS OVERSEAS PRIVATE LIMITED",
"SHROTI TELECOM PRIVATE LIMITED",
"SHROTRA ENTERPRISES PRIVATE LIMITED",
"SHRRISHTI HEALTHCARE PRODUCTS INDIA PRIVATE LIMITED",
"SHRUBERRY LIFESTYLE PRIVATE LIMITED",
"SHRUJAL CHEM PRIVATE LIMITED",
"SHRUM TECH",
"SHRUSHA BUSINESS SOLUTIONS PRIVATE LIMITED",
"SHRUSHTI CONTECH PRIVATE LIMITED",
"SHRUSTHI PLASTICS PRIVATE LIMITED",
"SHRUSTI",
"SHRUSTI CERAMICS PRIVATE LIMITED",
"SHRUTEE EXPORTS PRIVATE LIMITED",
"SHRUTHI MILK PRODUCTS PRIVATE LIMITED",
"SHRUTHIKESH INDUSTRIES PRIVATE LIMITED",
"SHRUTI & SIDDHARTH CONSTRUCTIONS PRIVATE LIMITED",
"SHRUTI BUSINESS ENTERPRISES PRIVATE LIMITED",
"SHRUTI CEMENT TRADERS PRIVATE LIMITED",
"SHRUTI CREATIONS PRIVATE LIMITED",
"SHRUTI DRUGS PRIVATE LIMITED",
"SHRUTI EMBROIDERY PRIVATE LIMITED",
"SHRUTI FASHIONS PRIVATE LIMITED",
"SHRUTI FASTNERS PRIVATE LIMITED",
"SHRUTI FINANCIAL SERVICES PRIVATE LIMITED",
"SHRUTI FINSEC PRIVATE LIMITED",
"SHRUTI MARMO PRIVATE LIMITED",
"SHRUTI MOTORS",
"SHRUTI NIRMAN AND ISPAT PRIVATE LIMITED",
"SHRUTI OVERSEAS PRIVATE LIMITED",
"SHRUTI POWER PROJECTS PRIVATE LIMITED",
"SHRUTI PRINT SOLUTION PRIVATE LIMITED",
"SHRUTI PRINTPACK PRIVATE LIMITED",
"SHRUTI SNACKS PRIVATE LIMITED",
"SHRUTIRAJ FASTENERS PRIVATE LIMITED",
"SHRYDUS INDUSTRIES LIMITED",
"SHS EXCAVATOR SPARES PRIVATE LIMITED",
"SHS HOLIDAYS PRIVATE LIMITED",
"SHS HOSPITALITY PRIVATE LIMITED",
"SHS INDUCTOMELT PRIVATE LIMITED",
"SHS MERCHANTS PRIVATE LIMITED",
"SHSHRUT RADIOLOGY IMAGING AND MEDICAL CARE PRIVATE LIMITED",
"SHT GLOBAL SR SEC SCHOOL",
"SHUABHI INVESTMENTS PRIVATE LIMITED",
"SHUANGMA MACHINERY INDIA PRIVATE LIMITED",
"SHUANGYI PRIVATE LIMITED",
"SHUB HOSPITAL",
"SHUBAM LIFTS PRIVATE LIMITED",
"SHUBAN AGRITECH PRIVATE LIMITED",
"SHUBAN HCMR MOTORS PRIVATE LIMITED",
"SHUBBAAN INVESTMENTS PRIVATE LIMITED",
"SHUBH & SANCHAY TEXOFAB PRIVATE LIMITED",
"SHUBH AAROGYAM PRIVATE LIMITED",
"SHUBH ARAMBH RESORTS PRIVATE LIMITED",
"SHUBH ARYA INFRATECH PRIVATE LIMITED",
"SHUBH ARYA STEEL PRIVATE LIMITED",
"SHUBH AUTOMOTIVE ACCESSORIES PRIVATE LIMITED",
"SHUBH BUILDCON PVT. LTD.",
"SHUBH CARS PRIVATE LIMITED",
"SHUBH CERAMICS PVT LTD",
"SHUBH CHEMICALS AND ORGANOSYS PRIVATE LIMITED",
"SHUBH DIE CASTINGS PRIVATE LIMITED",
"SHUBH FABRICS LIMITED",
"SHUBH FLAVOUR AND FRAGRANCES PRIVATE LIMITED",
"SHUBH FOOD INDUSTRIES PRIVATE LIMITED",
"SHUBH FOOTWEAR PRODUCTS PRIVATE LIMITED",
"SHUBH GRANI MARMO PVT LTD",
"SHUBH IMPEX PRIVATE LIMITED",
"SHUBH INNOVSOURCE PRIVATE LIMITED",
"SHUBH ISPAT PRIVATE LIMITED",
"SHUBH JEWELLERY PRIVATE LIMITED",
"SHUBH KARAN DAS CHIRANJI LAL AGENCIES PRIVATE LIMITED",
"SHUBH KARMAN FASHIONS PRIVATE LIMITED.",
"SHUBH LAABH BULLION PRIVATE LIMITED",
"SHUBH LAABH GLOBEX PRIVATE LIMITED",
"SHUBH LAABH LOGISTICS PRIVATE LIMITED",
"SHUBH LABH AGRIINPUT PRIVATE LIMITED",
"SHUBH LABH CASTING LLP",
"SHUBH LABH CONTRACTOR PRIVATE LIMITED",
"SHUBH LABH INTERNATIONAL PRIVATE LIMITED",
"SHUBH LAXMI EDUCATIONAL SOCIETY",
"SHUBH LAXMI IRON & STEEL PRIVATE LIMITED",
"SHUBH LAXMI MOTELS AND INNS PRIVATE LIMITED",
"SHUBH M L SHAH & SONS STEEL PRIVATE LIMITED",
"SHUBH MANGAL MARBLES AND GRANITES PRIVATE LIMITED",
"SHUBH MANGAL TEXTILE INDUSTRIES LLP",
"SHUBH MARUTI LOGISTICS PRIVATE LIMITED",
"SHUBH MEDIA PRIVATE LIMITED",
"SHUBH MEDICORP (INDIA) PRIVATE LIMITED",
"SHUBH MINERALS PRIVATE LIMITED",
"SHUBH MOTORS PRIVATE LIMITED",
"SHUBH MULTISPECIALITY HOSPITAL",
"SHUBH PACKERS PRIVATE LIMITED",
"SHUBH PLASTICS",
"SHUBH POLYFAB PRIVATE LIMITED",
"SHUBH PRABHAV GRUH NIRMAN PRIVATE LIMITED",
"SHUBH PRAGYA MARKETING AND FINANCE CO PVT LTD",
"SHUBH PROPACK PRIVATE LIMITED",
"SHUBH RAAG INFRA BUILDS PRIVATE LIMITED",
"SHUBH RASAYAN PVT LTD",
"SHUBH REALTY SOUTH PRIVATE LIMITED",
"SHUBH RICE EXPORTS PRIVATE LIMITED",
"SHUBH SAGAR RESTAURANT PRIVATE LIMITED",
"SHUBH SALES PRODUCTS PRIVATE LIMITED",
"SHUBH SHAGUN PACKAGING PRIVATE LIMITED",
"SHUBH SHARE BROKING PRIVATE LIMITED",
"SHUBH SHREE MERCANDISE PVT.LTD.",
"SHUBH SHREE PACKAGING PRIVATE LIMITED",
"SHUBH SPIN PRIVATE LIMITED",
"SHUBH SRI VINAYAK CHEM INDUSTRIES PRIVATE LIMITED",
"SHUBH SWASAN INDIA PRIVATE LIMITED",
"SHUBH SWASTIK DAL MILL CO. PRIVATE. LIMITED.",
"SHUBH TELECOM PRIVATE LIMITED",
"SHUBH TEXSPIN PRIVATE LIMITED",
"SHUBH TILES PRIVATE LIMITED",
"SHUBH TIMBER PRIVATE LIMITED",
"SHUBH TRADEX PRIVATE LIMITED",
"SHUBH UPCHAR PRIVATE LIMITED",
"SHUBH VINAYAK INFRA PRIVATE LIMITED",
"SHUBH VINAYAK TRADING AND INVESTMENTS PRIVATE LIMITED",
"SHUBHAAM CONCRET FLOORS PRIVATE LIMITED",
"SHUBHAARAMBH BUSINESS SERVICES PRIVATE LIMITED",
"SHUBHALAKSHMI HOTELS PRIVATE LIMITED",
"SHUBHALAKSHMI POLYESTERS LIMITED",
"SHUBHALAXMI AGENCIES PRIVATE LIMITED",
"SHUBHALAXMI TRADING & ENTERPRISE PRIVATE LIMITED",
"SHUBHAM ACQUALINK INDIA PRIVATE LIMITED",
"SHUBHAM AUDIO VEDIO PRIVATE LIMITED",
"SHUBHAM AUTOMATION PRIVATE LIMITED",
"SHUBHAM BARTAN AVM STEEL FURNITURE",
"SHUBHAM BIZ FACILITY MANAGEMENT PRIVATE LIMITED",
"SHUBHAM BUILDMART PRIVATE LIMITED",
"SHUBHAM BUILDUP PRIVATE LIMITED",
"SHUBHAM CARGO COMPANY PRIVATE LIMITED",
"SHUBHAM CHEMICALS AND SOLVENTS LIMITED",
"SHUBHAM COMPUTECH PRIVATE LIMITED",
"SHUBHAM COMTECH AND EXPORTS PRIVATE LIMITED",
"SHUBHAM CONSTRAMAT PRIVATE LIMITED",
"SHUBHAM CONSUMER DURABLES PRIVATE LIMITED",
"SHUBHAM COT-FAB PRIVATE LIMITED",
"SHUBHAM COTTON MILLS PRIVATE LIMITED",
"SHUBHAM ENGITECH PRIVATE LIMITED",
"SHUBHAM ENTERPRISES",
"SHUBHAM ENTERPRISES (RAIPUR) PRIVATE LIMITED",
"SHUBHAM EPC PRIVATE LIMITED",
"SHUBHAM EQUIPMENTS PRIVATE LIMITED",
"SHUBHAM EXTRUSION TECHNIK PRIVATE LIMITED",
"SHUBHAM FERTILIZER & CHEMICALS",
"SHUBHAM FLEXIBLE PACKAGING MACHINES PRIVATE LIMITED",
"SHUBHAM FLORA SALES PRIVATE LIMITED",
"SHUBHAM FOODS",
"SHUBHAM FORWARDINGS PRIVATE LIMITED",
"SHUBHAM FREIGHT PRIVATE LIMITED",
"SHUBHAM FURNITURES PRIVATE LIMITED",
"SHUBHAM GOLDIEE MASALE PRIVATE LIMITED",
"SHUBHAM GREEN COLONIZERS PRIVATE LIMITED",
"SHUBHAM HOME FURNISHING PRIVATE LIMITED",
"SHUBHAM HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED",
"SHUBHAM HOTELS PVT LTD",
"SHUBHAM HOUSING DEVELOPERS PRIVATE LIMITED",
"SHUBHAM HOUSING DEVELOPMENT FINANCE COMPANY LIMITED",
"SHUBHAM HYDROTECH ENGINEERS PRIVATE LIMITED",
"SHUBHAM IMPORTS PRIVATE LIMITED",
"SHUBHAM INCORPORATED",
"SHUBHAM INDUSTRIES",
"SHUBHAM K GHODKE",
"SHUBHAM K-MART PRIVATE LIMITED",
"SHUBHAM KNIT WEARS PVT LTD",
"SHUBHAM LUCKY CONSTRUCTIONS PRIVATE LIMITED",
"SHUBHAM MACHINES PRIVATE LIMITED",
"SHUBHAM MARBLE PRIVATE LIMITED",
"SHUBHAM MARMO PRIVATE LIMITED",
"SHUBHAM MEDICARE PRIVATE LIMITED",
"SHUBHAM METLINK PRIVATE LIMITED",
"SHUBHAM MINCHEM PRIVATE LIMITED",
"SHUBHAM MOTIWALA AND JEWELLERS PRIVATE LIMITED",
"SHUBHAM MOUTH FRESHNER PRIVATE LIMITED",
"SHUBHAM MULTICOM PRIVATE LIMITED",
"SHUBHAM ORGANICS LIMITED",
"SHUBHAM PACKERS & PRINTERS PRIVATE LIMITED",
"SHUBHAM PHARMACHEM PVT LTD",
"SHUBHAM POLYESTER PRIVATE LIMITED",
"SHUBHAM POLYSPIN LIMITED",
"SHUBHAM PROPMART PRIVATE LIMITED",
"SHUBHAM REALINFRA PRIVATE LIMITED",
"SHUBHAM RESORTS PRIVATE LIMITED",
"SHUBHAM SPECIALTY PRODUCTS (INDIA) PRIVATE LIMITED",
"SHUBHAM SUGARS LIMITED",
"SHUBHAM TANKS AND LINERS PRIVATE LIMITED",
"SHUBHAM TEX-O-PACK PRIVATE LIMITED",
"SHUBHAM TEXPLAST PRIVATE LIMITED",
"SHUBHAM TEXPORT PRIVATE LIMITED",
"SHUBHAM TEXTILES",
"SHUBHAM TIE-UP TRADE PRIVATE LIMITED",
"SHUBHAM TRADING CO",
"SHUBHAM TREXIM PRIVATE LIMITED",
"SHUBHAM WATER SOLUTION PRIVATE LIMITED",
"SHUBHAM WEAVES PRIVATE LIMITED",
"SHUBHAM YARNS PRIVATE LIMITED",
"SHUBHAMPRESS AUTOMATION PRIVATE LIMITED",
"SHUBHAN INKS AND CHEMICALS PRIVATE LIMITED",
"SHUBHANANDA TEXTILE MILLS PRIVATE LIMITED",
"SHUBHANG AUTOMOBILE PRIVATE LIMITED",
"SHUBHANG ENTERPRISES PRIVATE LIMITED",
"SHUBHANG HOSPITALS PRIVATE LIMITED",
"SHUBHANG OILS PRIVATE LIMITED",
"SHUBHANG PROCESSING MILLS PVT LTD",
"SHUBHANGI AGRITECH PRIVATE LIMITED",
"SHUBHANGI PAPERS PRIVATE LIMITED",
"SHUBHANKAR FASTENERS PRIVATE LIMITED",
"SHUBHANSHU INDUSTRIES PRIVATE LIMITED",
"SHUBHARAMBH INFRAESTATE PRIVATE LIMITED",
"SHUBHARAMBH PARIVAR PRIVATE LIMITED",
"SHUBHARAMBH PRODUCTIONS PRIVATE LIMITED",
"SHUBHASH TWISTERS PVT LTD",
"SHUBHASHISH MARBLES PRIVATE LIMITED",
"SHUBHAV BEVERAGES NORTH PRIVATE LIMITED",
"SHUBHDEEP AGRO FOOD PRIVATE LIMITED",
"SHUBHDEEP AYURVED MEDICAL COLLEGE & HOSPITAL",
"SHUBHDEEP COLLEGE OF NURSING INDORE",
"SHUBHECHHA MULTISPECIALITY HOSPITALS MILLS PRIVATE LIMITED",
"SHUBHEKSHA ADVISORS PRIVATE LIMITED",
"SHUBHI STEEL PRIVATE LIMITED",
"SHUBHIKA ENGINEERS PRIVATE LIMITED",
"SHUBHIKA ESTATE AND TRADING PVT LTD",
"SHUBHIKA TECHNOLOGIES PRIVATE LIMITED",
"SHUBHKAMANA SAREES PRIVATE LIMITED",
"SHUBHKAMNA AUTO AGENCIES PRIVATE LIMITED",
"SHUBHKAMNA COMPLEX PRIVATE LIMITED",
"SHUBHKAMNA HOSPITAL",
"SHUBHKARMA UDYOG PRIVATE LIMITED",
"SHUBHKART INDIA PRIVATE LIMITED",
"SHUBH-LABH HOLDINGS P LTD",
"SHUBHLABH UNICOM PRIVATE LIMITED",
"SHUBHLAKSHMI SHEETS AND STRIPS PRIVATE LIMITED",
"SHUBHLAXMI AGRO PRODUCTS PRIVATE LIMITED",
"SHUBHLAXMI CASTING PRIVATE LIMITED",
"SHUBHLAXMI COAL & EXIM PVT LTD",
"SHUBHLAXMI DIAMOND PRIVATE LIMITED",
"SHUBHLAXMI DYETEX PVT LTD",
"SHUBHLAXMI FARMER PRODUCER COMPANY LIMITED",
"SHUBHLAXMI FERRUM PRIVATE LIMITED",
"SHUBHLAXMI FOOD PROCESSORS PRIVATE LIMITED",
"SHUBHLAXMI GUM INDUSTRIES",
"SHUBHLAXMI JEWEL ART LIMITED",
"SHUBHLAXMI METALS AND TUBES PRIVATE LIMITED",
"SHUBHLAXMI POLYTEX LIMITED",
"SHUBHLAXMI TECHNOCAST PRIVATE LIMITED",
"SHUBHLAXMI TEXPRINTS PRIVATE LIMITED",
"SHUBHLINE AUTOMATION PRIVATE LIMITED",
"SHUBHMANGAL JEWELLERS PRIVATE LIMITED",
"SHUBHMANGAL MARKETING PRIVATE LIMITED",
"SHUBHMARUTI AUTOCAST PRIVATE LIMITED",
"SHUBHMED PRIVATE LIMITED",
"SHUBHODAYA RICE INDUSTRIES",
"SHUBHPRIYA RUGS AND FURNISHINGS PRIVATE LIMITED",
"SHUBHRA PLASTICS PRIVATE LIMITED",
"SHUBHRA RANJAN IAS STUDY PRIVATE LIMITED",
"SHUBHRA SECURITY SERVICES PRIVATE LIMITED",
"SHUBHRIDDHI AGRIFOODS PRODUCTS PRIVATE LIMITED",
"SHUBH-SHIV CONSTRUCTIONS PRIVATE LIMITED",
"SHUBHSHREE BIOFUELS ENERGY LIMITED",
"SHUBHSHREE ENGINEERING AND CONSTRUCTIONS PRIVATE LIMITED",
"SHUBHSIDDHI INFRATECH PRIVATE LIMITED",
"SHUBHSNEH TEXTILES PRIVATE. LIMITED.",
"SHUBHSUKI VENTURES PRIVATE LIMITED",
"SHUBHYAN AUTO PRIVATE LIMITED",
"SHUBHYOG LANDSCAPES PRIVATE LIMITED",
"SHUBODH ELECTRICALS PRIVATE LIMITED",
"SHUBRA INDUSTRIES PRIVATE LIMITED",
"SHUBRA MOTEL PRIVATE LIMITED",
"SHUCHI ANANT VIRYA PRIVATE LIMITED",
"SHUCHI ENERGY AD PROMOTIONS PRIVATE LIMITED",
"SHUCHI FRICTION ADDITIVES PRIVATE LIMITED",
"SHUCHI MANPOWER SERVICES PRIVATE LIMITED",
"SHUCHII FACILITY PRIVATE LIMITED",
"SHUCHITA PRAKASHAN PRIVATE LIMITED",
"SHUCHITA RETAIL PRIVATE LIMITED",
"SHUDDH PUNJABI FOOD PRODUCTS PRIVATE LIMITED",
"SHUDDH RECIPES PRIVATE LIMITED",
"SHUDDHA MANUFACTURING INDIA PRIVATE LIMITED",
"SHUDH EDIBLE PRODUCTS PRIVATE LIMITED",
"SHUDH HOSPITALITY PRIVATE LIMITED",
"SHUDH JIVAN RETAIL PRIVATE LIMITED",
"SHUDH PLUS HYGIENE PRODUCTS PRIVATE LIMITED",
"SHUDH PLUS INTERNATIONAL PRIVATE LIMITED",
"SHUDH PLUS PAN MASALA PRIVATE LIMITED",
"SHUGAN HOSPITALITY PRIVATE LIMITED",
"SHUGO TELECOM LIMITED",
"SHUHUL AUTOMOBILES PRIVATE LIMITED.",
"SHUJABITS INFOTECH SOLUTIONS PRIVATE LIMITED",
"SHUKA CONSULTANCY SERVICES PRIVATE LIMITED",
"SHUKAN CERAMIC PRIVATE LIMITED",
"SHUKAN EVENT CARE PRIVATE LIMITED",
"SHUKAN IMPEX PRIVATE LIMITED",
"SHUKLA AGENCIES PRIVATE LIMITED",
"SHUKLA AGRITECH PRIVATE LIMITED",
"SHUKLA DAIRY PRIVATE LIMITED",
"SHUKLA DEVELOPERS PRIVATE LIMITED",
"SHUKLA GLOBAL DEVELOPERS INDIA PRIVATE LIMITED",
"SHUKLA INFORMATION SOLUTIONS PRIVATE LIMITED",
"SHUKLA JUTE PRIVATE LIMITED",
"SHUKLA LOGISTICS PRIVATE LIMITED",
"SHUKLA PACKAGING INDUSTRIES PRIVATE LIMITED",
"SHUKLAMBARA PAPERS PRIVATE LIMITED",
"SHUKRA BEEDIES PRIVATE LIMITED",
"SHUKRA INFRACITY PRIVATE LIMITED",
"SHUKRA JEWELLERY LIMITED",
"SHUKRA LAND DEVELOPERS LIMITED",
"SHUKRA PACKAGING PRIVATE LIMITED",
"SHUKRA PHARMACEUTICALS LIMITED",
"SHUKRIYA INVESTMENT PRIVATE LIMITED",
"SHUKRIYA TRAVELS PRIVATE LIMITED",
"SHUKUN BUILDERS PRIVATE LIMITED",
"SHUKUN PROPERTIES PRIVATE LIMITED",
"SHULIN SOLAR POWER PRIVATE LIMITED",
"SHULKE CONSULTING IND PRIVATE LIMITED",
"SHULKON HEALTHCARE PRIVATE LIMITED",
"SHUMATHY SPINNING MILLS PRIVATE LIMITED",
"SHUMEE TOYS PRIVATE LIMITED",
"SHUMS GIRLS HIGH SCHOOL",
"SHUMS GIRLS URDU PRIMARY SCHOOL",
"SHUN SHING INDIA PRIVATE LIMITED",
"SHUNMUGA ANANTH EXIM PRIVATE LIMITED",
"SHUNMUGA ART PRINTERS PRIVATE LIMITED",
"SHUNMUGA SALT PRIVATE LIMITED",
"SHUNONG CHEMICAL PRIVATE LIMITED",
"SHUNTY BUNTY AUTOMOBILES PRIVATE LIMITED",
"SHUNYA TECHNOLOGIES PRIVATE LIMITED",
"SHUNYEKA SYSTEMS PRIVATE LIMITED",
"SHURE AUDIO TECHNOLOGIES PRIVATE LIMITED",
"SHURI AUTOMOTIVE PRIVATE LIMITED",
"SHUSHRUSHA CHARITABLE TRUST",
"SHUSHRUSHA CITIZENS CO OP HOSPITAL LTD",
"SHUSHRUSHA HOSPITAL",
"SHUSHRUSHA HOSPITALS PRIVATE LIMITED",
"SHUSHRUSHA NURSING HOME PRIVATE LIMITED",
"SHUTER ENTERPRISES INDIA PRIVATE LIMITED",
"SHUTTER SECURITY PRIVATE LIMITED",
"SHUTTLE CARS INDIA PRIVATE LIMITED",
"SHUVAM CONSTRUCTION PRIVATE LIMITED",
"SHUVAN VALVES LIMITED",
"SHUVONEEL RAS SYSTEM PRIVATE LIMITED",
"SHV ENERGY INDIA PRIVATE LIMITED",
"SHV ENERGY PRIVATE LIMITED",
"SHV LPG INDIA PRIVATE LIMITED",
"SHVETDHARA DAIRY FOODS PRIVATE LIMITED",
"SHVINTECH INDIA LLP",
"SHW INDUSTRIES AND MARINE PRIVATE LIMITED",
"SHW MACHINE TOOLS (INDIA) PRIVATE LIMITED",
"SHWAS HOMES PRIVATE LIMITED",
"SHWETA AGRITECH",
"SHWETA AGRO FARMS PVT LTD",
"SHWETA ENGINEERS PRIVATE LIMITED",
"SHWETA INDUSTRIES PRIVATE LIMITED",
"SHWETA INFRASTRUCTURE AND HOUSING (INDIA) PRIVATE LIMITED",
"SHWETA INFRASTRUCTURE AND HOUSING INDIA PRIVATE",
"SHWETA MICRONS PRIVATE LIMITED",
"SHWETA PAPER INDUSTRIES PRIVATE LIMITED",
"SHWETA PRINT-PACK PRIVATE LIMITED",
"SHWETA TECHNOPHILE CONSULTANTS PRIVATE LIMITED",
"SHWETAL TRADING PRIVATE LIMITED",
"SHWETDHARA MILK PRODUCER COMPANY LIMITED",
"SHYAAM SWITCHGEARS PRIVATE LIMITED",
"SHYAM & COMPANY OF NORTH PRIVATE LIMITED",
"SHYAM ADARSH PACK PRIVATE LIMITED",
"SHYAM ADVISORY LIMITED",
"SHYAM AGENCY PRIVATE LIMITED",
"SHYAM AGROMILLS PRIVATE LIMITED",
"SHYAM ALLOYS PRIVATE LIMITED",
"SHYAM APPARELS PVT. LTD.",
"SHYAM AUTOMOBILES LIMITED",
"SHYAM BABA CAB RENTALS PRIVATE LIMITED",
"SHYAM BEARINGS PRIVATE LIMITED",
"SHYAM BRIGHT INDUSTRIES PRIVATE LIMITED",
"SHYAM BUILDWELL PRIVATE LIMITED",
"SHYAM CABLES INDIA PRIVATE LIMITED",
"SHYAM CEMENT PRIVATE LIMITED",
"SHYAM CENTURY FERROUS LIMITED",
"SHYAM CEREAL MILLS PRIVATE LIMITED",
"SHYAM CHEMICALS PVT LTD",
"SHYAM COLLECTION PRIVATE LIMITED",
"SHYAM CONNECT-LINK PRIVATE LIMITED",
"SHYAM CORPORATION PRIVATE LIMITED",
"SHYAM COTEX INDIA PRIVATE LIMITED",
"SHYAM COTSYN INDIA LTD",
"SHYAM DESIGNERS AND CONSULTANTS PRIVATE LIMITED",
"SHYAM DHANI INDUSTRIES PRIVATE LIMITED",
"SHYAM DIGITAL COMMUNICATIONS PRIVATE LIMITED",
"SHYAM DRESSES PRIVATE LIMITED",
"SHYAM DYESTUFF PRIVATE LIMITED",
"SHYAM ENTERPRISES",
"SHYAM EVENT MANAGEMENT PRIVATE LIMITED",
"SHYAM FABRICS PVT LTD",
"SHYAM FEEDS PRIVATE LIMITED",
"SHYAM FERRO ALLOYS LIMITED",
"SHYAM FERROUS LIMITED",
"SHYAM FIBRES PRIVATE LIMITED",
"SHYAM FLOUR MILLS PRIVATE LIMITED",
"SHYAM FOOT TECH PRIVATE LIMITED",
"SHYAM FURNISHINGS PRIVATE LIMITED",
"SHYAM GARMENTS PRIVATE LTD",
"SHYAM GLOBAL TECHNOVENTURES PRIVATE LIMITED",
"SHYAM GODAVARI STEELS PRIVATE LIMITED",
"SHYAM GRAMODYOG SANSTHAN",
"SHYAM HITECH FUELS PRIVATE LIMITED",
"SHYAM HOSPITALITY PRIVATE LIMITED",
"SHYAM INDOFAB PRIVATE LIMITED",
"SHYAM INDOSPIN LIMITED",
"SHYAM INDUSTRIAL VENTURES PRIVATE LIMITED",
"SHYAM INDUSTRIES",
"SHYAM INFRA NIRMAN PRIVATE LIMITED",
"SHYAM INFRANETWORK PRIVATE LIMITED",
"SHYAM INGOTS PVT LTD",
"SHYAM INTERNATIONAL SCHOOL",
"SHYAM ISPAT UDYOG",
"SHYAM J.P. AGRO PRIVATE LIMITED",
"SHYAM JIE FOOD AND FARMS PRIVATE LIMITED",
"SHYAM JOTI RICE MILL PRIVATE LIMITED",
"SHYAM JR COLLEGE DAHIPHAL WADMAVALI",
"SHYAM KRIPA FOODS PRIVATE LIMITED",
"SHYAM KRIPA POLYPACK PRIVATE LIMITED",
"SHYAM KUMAR AND COMPANY PRIVATE LIMITED",
"SHYAM LAL GOYAL FABRICS PRIVATE LIMITED",
"SHYAM LAL GOYAL TEXTILES PRIVATE LIMITED",
"SHYAM LAL RANGI LAL PRIVATE LIMITED",
"SHYAM LAMINATERS PRIVATE LIMITED",
"SHYAM LEELA SYNTEX PRIVATE LIMITED",
"SHYAM LIFTER PRIVATE LIMITED",
"SHYAM MICA EXTRUTION PRIVATE LIMITED",
"SHYAM MULTIPACK PRIVATE LIMITED",
"SHYAM OIL REFINERY PRIVATE LIMITED",
"SHYAM ORES(JHARKHAND) PRIVATE LIMITED",
"SHYAM PACK-MARK PRIVATE LIMITED",
"SHYAM PACKSEAL PRIVATE LIMITED",
"SHYAM PAINTS HARDWARE AND SANITARY STORE PRIVATE LIMITED",
"SHYAM PHENO-CHEM PRIVATE LIMITED",
"SHYAM POLYSPIN PVT LTD",
"SHYAM POLYTEX PVT LTD",
"SHYAM PULSES PRIVATE LIMITED",
"SHYAM RESINS PRIVATE LIMITED",
"SHYAM REXIN TRADING PRIVATE LIMITED",
"SHYAM SAKHA FOOD & BEVERAGES PRIVATE LIMITED",
"SHYAM SALASAR LOGISTIC PRIVATE LIMITED",
"SHYAM SALES",
"SHYAM SANGAM AUTOMOBILES PRIVATE LIMITED",
"SHYAM SANGAM VEHICLES PRIVATE LIMITED",
"SHYAM SEL AND POWER LIMITED",
"SHYAM SEVA TELEAGENCY PRIVATE LIMITED",
"SHYAM SHAKTI VYAPAAR PRIVATE LIMITED",
"SHYAM SHANKAR DECORATORS PRIVATE LIMITED",
"SHYAM SHREE REAL ESTATES PRIVATE LIMITED",
"SHYAM SINGH INDUSTRIES PRIVATE LIMITED",
"SHYAM SIZERS PVT LTD",
"SHYAM SOLVEX (INDIA) PRIVATE LIMITED",
"SHYAM SPECTRA IT SERVICES PRIVATE LIMITED",
"SHYAM SPECTRA PRIVATE LIMITED",
"SHYAM SPICES COMPANY PRIVATE LIMITED",
"SHYAM STEEL INDUSTRIES LIMITED",
"SHYAM STEEL MANUFACTURING LIMITED",
"SHYAM STEEL WORKS PRIVATE LIMITED",
"SHYAM STORES SAREES PRIVATE LIMITED",
"SHYAM STRIPS-TUBES PRIVATE LIMITED",
"SHYAM SUNDAR & CO. PRIVATE LIMITED",
"SHYAM SUNDAR AGRO TECH PRIVATE LIMITED",
"SHYAM SUNDAR CASTING PRIVATE LIMITED",
"SHYAM SUNDAR CO. JEWELLERS PRIVATE LIMITED.",
"SHYAM SUNDER GUPTA POOJA UDYOG PRIVATE LIMITED",
"SHYAM SUNDER VANASPATI LIMITED",
"SHYAM SYNCOTEX PVT LTD",
"SHYAM TELECOM LIMITED",
"SHYAM TEX EXPORTS LIMITED",
"SHYAM TEX-FAB PRIVATE LIMITED",
"SHYAM TEXTILES LIMITED",
"SHYAM TEXURISERS PVT LTD",
"SHYAM TIMBER PRIVATE LIMITED",
"SHYAM TRANSWAYS INDIA PRIVATE LIMITED",
"SHYAM TRAVELS SOLUTION PRIVATE LIMITED",
"SHYAM UDYOG",
"SHYAM VABHAV INDUSTRIES PRIVATE LIMITED",
"SHYAM WARP AND WEFT PRIVATE LIMITED",
"SHYAM WATERPROOF WORKS PVT LTD",
"SHYAMA AGRO FOODS & EXPORTS PRIVATE LIMITED",
"SHYAMA BUILDCON PRIVATE LIMITED",
"SHYAMA ICE AND COLD STORAGE PRIVATE LIMITED",
"SHYAMA INFOSYS LIMITED",
"SHYAMA ISPAT PRIVATE LIMITED",
"SHYAMA JEWELS (GONIKOPPAL) PRIVATE LIMITED",
"SHYAMA JEWELS (MADIKERI ) PRIVATE LIMITED",
"SHYAMA JEWELS (PUTTUR) PRIVATE LIMITED",
"SHYAMA JEWELS SOURCING PRIVATE LIMITED",
"SHYAMA MAA FOOD PROCESSING PRIVATE LIMITED",
"SHYAMA PACKART PRIVATE LIMITED",
"SHYAMA POWER INDIA PRIVATE LIMITED",
"SHYAMA PRASAD COLLEGE",
"SHYAMA SHYAM P1 CITY BUS OPERATIONS PRIVATE LIMITED",
"SHYAMA SHYAM SALES PRIVATE LIMITED",
"SHYAMA SHYAM TRENDZ PRIVATE LIMITED",
"SHYAMA SHYAM VSK BUS OPERATIONS PRIVATE LIMITED",
"SHYAMA SHYAM VSK WATER MANAGEMENT PRIVATE LIMITED",
"SHYAMA WEALTH MANAGEMENT PRIVATE LIMITED.",
"SHYAMAJI OILCHEM PRIVATE LIMITED",
"SHYAMAL DEVELOPERS PRIVATE LIMITED",
"SHYAMAL INTERMEDIATES PRIVATE LIMITED",
"SHYAMALAN MODERN RICE INDUSTRIES",
"SHYAMALI BREEDINGS PRIVATE LIMITED",
"SHYAMALI COLD STORAGE PRIVATE LIMITED",
"SHYAMANUJ AGRO EXIM PRIVATE LIMITED",
"SHYAMARAJU AND COMPANY INDIA PRIVATE LIMITED",
"SHYAMASHISH COLONIZERS & DEVELOPERS PRIVATE LIMITED",
"SHYAMA-TARA RICE MILLS PRIVATE LIMITED",
"SHYAMBABA TRENDS PRIVATE LIMITED",
"SHYAMBEHARI AGRO FOODS PRIVATE LIMITED",
"SHYAMBHAVI LABS PRIVATE LIMITED",
"SHYAMDEV VYAPAAR PRIVATE LIMITED",
"SHYAMDHANJOTE HIGH SCHOOL",
"SHYAMGOPAL FLOUR MILLS PRIVATE LIMITED",
"SHYAMILI INDP PRE UNIVERSITY COLLEGE",
"SHYAMJEE LUMBERS PRIVATE LIMITED",
"SHYAMJI PROCESSORS AND RECYCLERS PRIVATE LIMITED",
"SHYAMJYOT FABTEX PRIVATE LIMITED",
"SHYAMKALA AGRO PROCESSORS PRIVATE LIMITED",
"SHYAMKRIPA AGRICOLD PRIVATE LIMITED",
"SHYAMOLI CONSULTANTS PRIVATE LIMITED",
"SHYAMOLI PARIBAHAN PRIVATE LIMITED",
"SHYAMPRAKASH SPINNING MILLS LIMITED",
"SHYAMPREM ESTATE PRIVATE LIMITED",
"SHYAMRAIPORE TEA COMPANY PVT.LTD.",
"SHYAMRATAN METALS & POLYMERS PRIVATE LIMITED",
"SHYAMRIYA INFRASTRUCTURE PRIVATE LIMITED",
"SHYAMSHREE RESIDENCY PRIVATE LIMITED",
"SHYAMSONS TRADING (I) PRIVATE LIMITED",
"SHYAMSREE FOOD PROCESSING PRIVATE LIMITED",
"SHYAMSUNDAR POLYMERS PRIVATE LIMITED",
"SHYAMSUNDAR SATYANARAYAN TEXTILES P LIMITED",
"SHYAMSUNDER GRAIN PRODUCTS PRIVATE LIMITED",
"SHYAMSYL PAPERS PRIVATE LIMITED",
"SHYAMTEX GARMENTS PRIVATE LIMITED",
"SHYAMVIJAY INFRAESTATE PRIVATE LIMITED",
"SHYAMYA RICE MILL PRIVATE LIMITED",
"SHYAN ENGINEERS PROJECT PRIVATE LIMITED",
"SHYENA SOLUTIONS PRIVATE LIMITED",
"SHYENA TECH YARNS PRIVATE LIMITED",
"SHYMOVA TRANSFORMATION PRIVATE LIMITED",
"SI ADCON INDIA PRIVATE LIMITED",
"SI AIR SPRINGS PRIVATE LIMITED",
"SI CHITANYA EDUCATIONAL INSTITUTIONS",
"SI CREVA CAPITAL SERVICES PRIVATE LIMITED",
"SI FIRE ENGINEERS PRIVATE LIMITED",
"SI GROUP INDIA PRIVATE LIMITED",
"SI INFRATEL PRIVATE LIMITED",
"SI KA DESIGN PRIVATE LIMITED",
"SI MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"SI OF SCHOOLS",
"SI VEGA HOSPITAL PRIVATE LIMITED",
"SI2 TECHNOLOGIES PRIVATE LIMITED",
"SI2CHIP TECHNOLOGIES PRIVATE LIMITED",
"SIA BUILDER PRIVATE LIMITED",
"SIA CARRIERS LLP",
"SIA DIGITAL CONSULTANCY INDIA PRIVATE LIMITED",
"SIA FLUID CONTROLS PRIVATE LIMITED",
"SIA INDUSTRIAL TAPES AND ADHESIVES PRIVATE LIMITED",
"SIA INTEGRATED TECHNOLOGIES PRIVATE LIMITED",
"SIA JEWELS PRIVATE LIMITED",
"SIA LIFESTYLES PRIVATE LIMITED",
"SIA PHARMA PRIVATE LIMITED",
"SIA PUBLISHERS & DISTRIBUTORS PRIVATE LIMITED",
"SIAAGRO FOODS PRIVATE LIMITED",
"SIAASH FOODS PRIVATE LIMITED",
"SIAC SKH INDIA CABS MANUFACTURING PRIVATE LIMITED",
"SIADOW SYSTEMS PRIVATE LIMITED",
"SIAL MANUFACTURERS PRIVATE LIMITED",
"SIAM CANADIAN FROZEN FOODS INDIA PRIVATE LIMITED",
"SIAM TRADE IMPEX PRIVATE LIMITED",
"SIAMP INDIA PRIVATE LIMITED",
"SIAN INFRA AND REALCON LLP",
"SIANG TEA AND INDUSTRIES PVT LTD",
"SIARA ENGINEERING PRIVATE LIMITED",
"SIARAM CLINICAL RESEARCH PRIVATE LIMITED",
"SIARAM TRANSPORT PRIVATE LIMITED",
"SIATE FELICI SCHOOL",
"SIBA ANDO PRIVATE LIMITED",
"SIBA HABITATS PRIVATE LIMITED",
"SIBAFLOR NATURAL DECORATIONS PRIVATE LIMITED",
"SIBAN HOLDINGS P LTD",
"SIBANGI AGROTECH PRIVATE LIMITED",
"SIBAR AUTO PARTS LTD",
"SIBCA ELECTRONICS PRIVATE LIMITED",
"SIBCO OVERSEAS PRIVATE LIMITED",
"SIBCO PLASTIC INDUSTRIES PRIVATE LIMITED",
"SIBELCO INDIA MINERALS PRIVATE LIMITED",
"SIBI POLYPLAST PRIVATE LIMITED",
"SIBI TALENT PRIVATE LIMITED",
"SIBIA ANALYTICS AND CONSULTING SERVICES PRIVATE LIMITED",
"SIBLAL AGROVET PRIVATE LIMITED",
"SIBLING LIFECARE PRIVATE LIMITED",
"SIBNATH SHASTRI COLLEGE",
"SIBRE BRAKES (INDIA) PRIVATE LIMITED",
"SIBRO STEELS & MINERALS PRIVATE LIMITED",
"SIBT CHEMICALS INDIA PRIVATE LIMITED",
"SIBY MINING AND INFRASTRUCTURE PRIVATE LIMITED",
"SIBY SOLVENT EXTRACTION PRIVATE LIMITED",
"SIBYLL SOFTWARE PRIVATE LIMITED",
"SIBYLRETAIL ANALYTICS PRIVATE LIMITED",
"SIBZ TRADERS LIMITED",
"SIC PRODUCTIONS (FILMS) PRIVATE LIMITED",
"SICA PLASTIC MACHINERY PRIVATE LIMITED",
"SICA SENIOR SECONDARY SCHOOL",
"SICAF PRIVATE LIMITED",
"SICAGEN INDIA LIMITED",
"SICAL ABRASIVES",
"SICAL IRON ORE TERMINALS LIMITED",
"SICAL MULTIMODAL AND RAIL TRANSPORT LIMITED.",
"SICAME INDIA CONNECTORS PRIVATE LIMITED",
"SICAP INDIA PRIVATE LIMITED",
"SICER INDIA PRIVATE LIMITED",
"SICGIL INDIA LIMITED",
"SICGIL INDUSTRIAL GASES LIMITED",
"SICGILSOL GASES PRIVATE LIMITED",
"SICILIA HOTELS PVT LTD",
"SICILIAN VENTURES PRIVATE LIMITED",
"SICK INDIA PRIVATE LIMITED",
"SICKCURE PHARMACEUTICALS PRIVATE LIMITED",
"SICKLE INNOVATIONS PRIVATE LIMITED",
"SICO CERAMIC PRIVATE LIMITED",
"SICO VINYL PRIVATE LIMITED",
"SICOM ARC LIMITED",
"SICOM INVESTMENTS AND FINANCE LIMITED",
"SICOM IT SOLUTIONS PRIVATE LIMITED",
"SICOM LIMITED",
"SICOM SALES AND ENGINEERING PRIVATE LIMITED",
"SICOMA MIXERS INDIA PRIVATE LIMITED",
"SICOMORO ADVISORS PRIVATE LIMITED",
"SICON DESIGN TECHNOLOGIES PRIVATE LIMITED",
"SICON PACKS PRIVATE LIMITED",
"SICOR ENGINEERING INDIA PRIVATE LIMITED",
"SICPA INDIA PRIVATE LIMITED",
"SI-CREVA CONSULTING SERVICES PRIVATE LIMITED",
"SICURO GLASSTEIN PRIVATE LIMITED",
"SICURO INFOSYSTEM PRIVATE LIMITED",
"SID CONSTRUCTIONS PRIVATE LIMITED",
"SID ELECTRIC PRIVATE LIMITED",
"SID HOSPITALITY PRIVATE LIMITED",
"SID TECH PRIVATE LIMITED",
"SID WIN HEALTHCARE SOLUTIONS",
"SIDAAN ALLOYS PRIVATE LIMITED",
"SIDAK AUTOMOBILES PRIVATE LIMITED",
"SIDAK LIFE CARE PRIVATE LIMITED",
"SIDAK TECHNOLOGIES PRIVATE LIMITED",
"SIDAN GLOBAL SOLUTIONS PRIVATE LIMITED",
"SIDANA SILK MILLS PVT LTD",
"SIDARTH HOSPITALS",
"SIDBI",
"SIDBI VENTURE CAPITAL LIMITED",
"SIDCO",
"SIDCO FOODS OPC PRIVATE LIMITED",
"SIDCON INDIA PRIVATE LIMITED",
"SIDCUL CONCOR INFRA COMPANY LIMITED",
"SIDDAGANGA CEMENTS PRIVATE LIMITED",
"SIDDAGANGA HOSPITAL",
"SIDDAGANGA INSTITUTE OF TECHNOLOGY",
"SIDDAGANGA PU SCIENCE COLLEGE",
"SIDDAGANGA SPUN CONCRETE PIPES CO. PRIVATE LIMITED",
"SIDDAGANGA TOURS AND TRAVELS",
"SIDDAGURU ECOMMERCE LLP",
"SIDDAM CONSTRUCTIONS PRIVATE LIMITED",
"SIDDANTH CARE & CURE PRIVATE LIMITED",
"SIDDANTH WOODEN WORKS PRIVATE LIMITED",
"SIDDAPUR DISTILLERIES LIMITED",
"SIDDAR PACKAGING PRIVATE.LIMITED",
"SIDDARTH CONCLAVE PRIVATE LIMITED",
"SIDDARTH EMPORIUM INDIA PRIAVTE LIMITED",
"SIDDARTH GARWIN CONSTRUCTION PRIVATE LIMITED",
"SIDDARTH MARMO PRIVATE LIMITED",
"SIDDARTH MECHANICAL WORKS PRIVATE LIMITED",
"SIDDARTH ORGANISATION LIMITED",
"SIDDARTH SHIVAM TRADEWINGS PRIVATE LIMITED",
"SIDDARTHA AQUATICS INDIA PVT LTD",
"SIDDARTHA CIVIL WORKS PRIVATE LIMITED",
"SIDDARTHA EDUCATIONAL ACADEMY GROUP OF INSTITUTIONS",
"SIDDARTHA HIGH SCHOOL",
"SIDDESHWAR MULTIPURPOSE HEEMGHAR PRIVATE LIMITED",
"SIDDESHWARI TRADEX PRIVATE LIMITED",
"SIDDH AUTO PRIVATE LIMITED",
"SIDDH CHEMIPLAST PRIVATE LIMITED",
"SIDDH CORPORATION PRIVATE LIMITED",
"SIDDH CRUSHERS PRIVATE LIMITED",
"SIDDH PERLITE PRIVATE LIMITED",
"SIDDH SANKALAP AUTO AGENCY PRIVATE LIMITED",
"SIDDHA BRIXWELL INFRASTRUCTURE LIMITED",
"SIDDHA CHAKRA WEAVING PRIVATE LIMITED",
"SIDDHA DESIGNERS PRIVATE LIMITED",
"SIDDHA DEVELOPMENT RESEARCH AND CONSULTANCY PRIVATE LIMITED",
"SIDDHA ELECTRICALS",
"SIDDHA GAS TECHNIK PRIVATE LIMITED",
"SIDDHA LAXMI ENGINEERING INDUSTRIES PRIVATE LIMITED",
"SIDDHA PERFECT SYSTEMS PRIVATE LIMITED",
"SIDDHA PROJECTS PRIVATE LIMITED",
"SIDDHA PROMOTERS PRIVATE LIMITED",
"SIDDHA REAL ESTATE DEVELOPMENT PRIVATE LIMITED",
"SIDDHA SEEDS PRIVATE LIMITED",
"SIDDHA TRADELINKS PRIVATE LIMITED",
"SIDDHA VANIJYA PRIVATE LIMITED",
"SIDDHA VENTURES LIMITED",
"SIDDHACHAL FAB PRIVATE LIMITED",
"SIDDHACHAL TEXTILE PRIVATE LIMITED",
"SIDDHAGIRI ENTERPRISES",
"SIDDHAKALA BARRELS PRIVATE LIMITED",
"SIDDHAKALA PRINT MEDIA AND PUBLICATIONS PRIVATE LIMITED",
"SIDDHAKALA RENEWABLE ENERGY SYSTEM PRIVATE LIMITED",
"SIDDHAKALA STEEL PRIVATE LIMITED",
"SIDDHAM GEMS PRIVATE LIMITED",
"SIDDHAM RESOURCES PRIVATE LIMITED",
"SIDDHANAND ENTERPRISES P LTD",
"SIDDHANATH LOGISTICS PRIVATE LIMITED",
"SIDDHANT AGRO TRADERS PRIVATE LIMITED",
"SIDDHANT AUTOMOTIVES PRIVATE LIMITED",
"SIDDHANT CINEVISION PRIVATE LIMITED",
"SIDDHANT DIAMONDS P LIMITED",
"SIDDHANT EQUIPMENTS PRIVATE LIMITED",
"SIDDHANT FREIGHT FORWARDERS PRIVATE LIMITED",
"SIDDHANT ISPAT PRIVATE LIMITED",
"SIDDHANT LIME PRIVATE LIMITED",
"SIDDHANT RAJ CONSTRUCTION PRIVATE LIMITED",
"SIDDHANT SEEDS PRIVATE LIMITED",
"SIDDHANT TEA PRIVATE LIMITED",
"SIDDHANTA ALUMET PRIVATE LIMITED",
"SIDDHANTA SUPERSPECIALITY HOSPITAL",
"SIDDHANTHAM TOLLWAY PRIVATE LIMITED",
"SIDDHAR SIVAGNAANI ARTS AND SCIENCE COLLEGE",
"SIDDHARAJ PROJECTS PRIVATE LIMITED",
"SIDDHARDHA CONSTRUCTIONS PRIVATE LIMITED",
"SIDDHARTA RESORTS & FOODS PRIVATE LIMITED",
"SIDDHARTH ARTS COMMERCE & SCIENCE COLLEGE",
"SIDDHARTH AUTO ENGINEERS PRIVATE LIMITED",
"SIDDHARTH BRAKES PRIVATE LIMITED",
"SIDDHARTH CARBOCHEM PRODUCTS LIMITED",
"SIDDHARTH CHLOROCHEM PVT LTD",
"SIDDHARTH CIVICON PRIVATE LIMITED",
"SIDDHARTH COLORCHEM LIMITED",
"SIDDHARTH DALL AND FLOUR MILLS PRIVATE LIMITED",
"SIDDHARTH DEVELOPERS",
"SIDDHARTH DISPLAYS & DEVICES INDIA PRIVATE LIMITED",
"SIDDHARTH DRUGS PRIVATE LIMITED",
"SIDDHARTH ENTERPRISES",
"SIDDHARTH ENVIRON SYSTEMS PRIVATE LIMITED",
"SIDDHARTH EXTRUSIONS PRIVATE LIMITED",
"SIDDHARTH FOUNDRY PRIVATE LIMITED",
"SIDDHARTH GLOBAL PRIVATE LIMITED",
"SIDDHARTH GREASE & LUBES PRIVATE LIMITED",
"SIDDHARTH HEAVY INDUSTRIES PRIVATE LIMITED",
"SIDDHARTH HOSPITAL",
"SIDDHARTH IMPORTS PRIVATE LIMITED",
"SIDDHARTH INFRA POWER PRIVATE LIMITED",
"SIDDHARTH INFRACON PRIVATE LIMITED",
"SIDDHARTH INSTITUTE OF ENGINEERING AND TECHNOLOGY",
"SIDDHARTH INTERCHEM PRIVATE LIMITED",
"SIDDHARTH INTERNATIONAL SCHOOL",
"SIDDHARTH KANISHTHA MAHAVIDYALAY LATUR",
"SIDDHARTH KAPOOR VENTURES PRIVATE LIMITED",
"SIDDHARTH LIME PRIVATE LIMITED",
"SIDDHARTH MEDIA HOLDINGS PRIVATE LIMITED",
"SIDDHARTH MERCANTILE PRIVATE. LIMITED.",
"SIDDHARTH MRI AND CT-SCAN SERVICES PRIVATE LIMITED",
"SIDDHARTH MULTISPECIALITY HOSPITAL PRIVATE LIMITED",
"SIDDHARTH ORNAMENTS PRIVATE LIMITED",
"SIDDHARTH PETROPRODUCTS PRIVATE LIMITED",
"SIDDHARTH POLYMERS PRIVATE LIMITED",
"SIDDHARTH POLYTUBES PRIVATE LIMITED",
"SIDDHARTH PRESSINGS (INDIA) PRIVATE LIMITED",
"SIDDHARTH PRIMARY, SECONDARY & HIGHER SECONDARY SIDHARTH ASHRAM SHALA",
"SIDDHARTH PRINTING MACHINES PRIVATE LIMITED",
"SIDDHARTH PURESPUN PRIVATE LIMITED",
"SIDDHARTH REALITY (INDIA) PRIVATE LIMITED",
"SIDDHARTH SALT AND CHEMICALS PRIVATE LIMITED",
"SIDDHARTH STARCH PRIVATE LIMITED",
"SIDDHARTH SUPPLIERS AND DISTRIBUTORS PRIVATE LIMITED",
"SIDDHARTH SYNTEX PRIVATE LIMITED",
"SIDDHARTH TANKS AND VESSELS PRIVATE LIMITED",
"SIDDHARTH TRADE LINKS PRIVATE LIMITED",
"SIDDHARTH TRADECHEM PRIVATE LIMITED",
"SIDDHARTH TRADING CO",
"SIDDHARTH VIDYA MANDIR NETIVALI KALYAN",
"SIDDHARTH WEAVES PRIVATE LIMITED",
"SIDDHARTH WIRES PRIVATE LIMITED",
"SIDDHARTHA BRONZE PRODUCTS PRIVATE LIMITED",
"SIDDHARTHA CERAMICS PRIVATE LIMITED",
"SIDDHARTHA COMMODITIES PRIVATE LIMITED",
"SIDDHARTHA CONSTRUCTION",
"SIDDHARTHA CONSTRUCTIONS PRIVATE LIMITED",
"SIDDHARTHA DEGREE COLLEGE",
"SIDDHARTHA ELECTROTEC & TRADING PVT.LTD.",
"SIDDHARTHA ENGICON PRIVATE LIMITED",
"SIDDHARTHA ENGINEERING LIMITED",
"SIDDHARTHA ENTERPRISES",
"SIDDHARTHA HEAVY EQUIPMENT PRIVATE LIMITED",
"SIDDHARTHA HOSPITAL",
"SIDDHARTHA INNOPACK INDUSTRIES PRIVATE LIMITED",
"SIDDHARTHA INSTITUTE OF ENGINEERING AND TECHNOLOGY",
"SIDDHARTHA INSTITUTE OF TECH & SCIENCES",
"SIDDHARTHA LOGISTICS COMPANY PRIVATE LIMITED",
"SIDDHARTHA LOGISTICS FTWZ PRIVATE LIMITED",
"SIDDHARTHA MARKETING SERVICES LIMITED",
"SIDDHARTHA MEDICAL COLLEGE",
"SIDDHARTHA MULTI VENTURES PRIVATE LIMITED",
"SIDDHARTHA RAJA ENTERPRISES PVT LTD",
"SIDDHARTHA ROLLING AND ENERGY PRIVATE LIMITED",
"SIDDHARTHA STRUCTURALS PRIVATE LIMITED",
"SIDDHARTHA SUPER SPINNING MILLS LIMITED",
"SIDDHARTHA SUPER SPINNING MILLS LTD",
"SIDDHARTHA TEXARCADE PRIVATE LIMITED",
"SIDDHARTHA TILES & SANITARY PRIVATE. LIMITED.",
"SIDDHARTHALAXMI ENGITECH PRIVATE LIMITED",
"SIDDHASHRAM RICE MILL CLUSTER PRIVATE LIMITED",
"SIDDHASIRI ETHANOL & POWER CINCHOLI",
"SIDDHATECH SOFTWARE SERVICES PRIVATE LIMITED",
"SIDDHAYE STRUCTURES PRIVATE LIMITED",
"SIDDHAYU AYURVEDIC RESEARCH FOUNDATION PVT LTD",
"SIDDHAYU HEALTHCARE PRIVATE LIMITED",
"SIDDHDEV GARMENTS PRIVATE LIMITED",
"SIDDHEBHYAH ASSOCIATES PRIVATE LIMITED",
"SIDDHEE PRODUCTS PRIVATE LIMITED",
"SIDDHESH CAPITAL MARKET SERVICES PRIVATE LIMITED",
"SIDDHESH CHARITABLE TRUST",
"SIDDHESH MOTORS PRIVATE LIMITED",
"SIDDHESH PROPERTIES PRIVATE LIMITED",
"SIDDHESHWAR BUILDERS PRIVATE LIMITED",
"SIDDHESHWAR ENTERPRISES",
"SIDDHESHWAR FORGING AND AUTO PARTS PRIVATE LIMITED",
"SIDDHESHWAR INFRA PRIVATE LIMITED",
"SIDDHESHWAR TECHNOFORGE PRIVATE LIMITED",
"SIDDHESHWARI INDUSTRIES PRIVATE. LIMITED.",
"SIDDHESHWARI PAPER UDYOG LIMITED",
"SIDDHESHWARI PRINTS PRIVATE LIMITED",
"SIDDHESHWARI VYAPAAR PRIVATE LIMITED",
"SIDDHESWARI COTTON MILLS PVT LTD",
"SIDDHESWARY FOREX & TRAVELS PRIVATE LIMITED",
"SIDDHI AUTO MOTORS PRIVATE LIMITED",
"SIDDHI BINAYAK BAG MANUFACTURING PRIVATE LIMITED",
"SIDDHI BLINDS PRIVATE LIMITED",
"SIDDHI BUSINESS SOLUTIONS PRIVATE LIMITED",
"SIDDHI CAST PVT LTD",
"SIDDHI CERAMIC DESIGNERS PRIVATE LIMITED",
"SIDDHI CHLOROEXIM PRIVATE LIMITED",
"SIDDHI CNC PRIVATE LIMITED",
"SIDDHI CONSULTING ENGINEERS PRIVATE LIMITED",
"SIDDHI COTSPIN LIMITED",
"SIDDHI COTTON GINNING & PRESSING PRIVATE LIMITED",
"SIDDHI DAL MILLS PRIVATE LIMITED",
"SIDDHI DEALTRADE PRIVATE LIMITED",
"SIDDHI DECOR PRIVATE LIMITED",
"SIDDHI DIAMONDS",
"SIDDHI ELECTROTECH CABLES PRIVATE LIMITED",
"SIDDHI FERROUS PRIVATE LIMITED",
"SIDDHI FORGE PRIVATE LIMITED",
"SIDDHI GANESH METAL PRIVATE LIMITED",
"SIDDHI GOLD INDIA PRIVATE LIMITED",
"SIDDHI GRAVURES PRIVATE LIMITED",
"SIDDHI GREEN EXCELLENCE PRIVATE LIMITED",
"SIDDHI HOSPITAL AND LEPROSCOPIC CENTERS PVT LTD",
"SIDDHI INDUSTRIES",
"SIDDHI ISPAT PRIVATE LIMITED",
"SIDDHI JANANA HOSPITAL",
"SIDDHI KABEL CORPORATION PRIVATE LIMITED",
"SIDDHI LEISURES AND LIFESTYLE PRIVATE LIMITED",
"SIDDHI MARGARINE SPECIALITIES LIMITED",
"SIDDHI NAMOH FABTEX PRIVATE LIMITED",
"SIDDHI PACKAGING PRIVATE LIMITED",
"SIDDHI PAPER MILL PRIVATE LIMITED",
"SIDDHI PLAST PRIVATE LIMITED",
"SIDDHI PORTFOLIO SERVICES P LIMITED",
"SIDDHI PRESS PRIVATE LIMITED",
"SIDDHI ROBO PLASMA CUTS PRIVATE LIMITED",
"SIDDHI SOFTECH",
"SIDDHI SPINNERS PRIVATE LIMITED",
"SIDDHI STEELS PRIVATE LIMITED",
"SIDDHI SUGAR AND ALLIED INDUSTRIES LIMITED",
"SIDDHI TECHNOSHRINK PRIVATE LIMITED",
"SIDDHI TEXFAB PRIVATE LIMITED",
"SIDDHI VINAYAK AGRI PROCESSING PRIVATE LIMITED",
"SIDDHI VINAYAK AVIATION PRIVATE LIMITED",
"SIDDHI VINAYAK BAKE-WELL PRIVATE LIMITED",
"SIDDHI VINAYAK CARGO SERVICE",
"SIDDHI VINAYAK CASTINGS PRIVATE LIMITED",
"SIDDHI VINAYAK CHEMEX INDIA PRIVATE LIMITED",
"SIDDHI VINAYAK CLOTHING PRIVATE LIMITED",
"SIDDHI VINAYAK COLD STORAGE PRIVATE LIMITED",
"SIDDHI VINAYAK CONSTRUCTION CHEMICAL PRIVATE LIMITED",
"SIDDHI VINAYAK CONTAINERS PRIVATE LIMITED",
"SIDDHI VINAYAK DEVELOPERS",
"SIDDHI VINAYAK DYEING AND PRINTING MILLS PRIVATE LIMITED",
"SIDDHI VINAYAK FIBRE PRIVATE LIMITED",
"SIDDHI VINAYAK FINCAP LIMITED",
"SIDDHI VINAYAK HOSPITAL",
"SIDDHI VINAYAK HOSPITAL AND RESEARCH CENTRE",
"SIDDHI VINAYAK INDIA PVT LTD",
"SIDDHI VINAYAK KNOTS & PRINTS PRIVATE LIMITED",
"SIDDHI VINAYAK MOULDS (INDIA) PRIVATE LIMITED",
"SIDDHI VINAYAK NATURAL RESOURCES AND METALS PRIVATE LIMITED",
"SIDDHI VINAYAK PLASTICWARES PRIVATE LIMITED",
"SIDDHI VINAYAK PREMIUM HOMES PRIVATE LIMITED",
"SIDDHI VINAYAK ROLLER FLOUR MILLS PRIVATE LIMITED",
"SIDDHI VINAYAK VINIMAY TRADING PRIVATE LIMITED",
"SIDDHI VINAYAKA GRAPHICS PRIVATE LIMITED",
"SIDDHI VINAYAKAM SOLUTIONS PRIVATE LIMITED",
"SIDDHI WEAVES PRIVATE LIMITED",
"SIDDHI WHEELS PRIVATE LIMITED",
"SIDDHIDATRI AAHAR PRIVATE LIMITED",
"SIDDHIDATRI MINIRALS PRIVATE LIMITED",
"SIDDHIKA COATINGS LIMITED",
"SIDDHIKSHA INFRASTRUCTURE PRIVATE LIMITED",
"SIDDHIPRIYA CASHEW PROCESSING PRIVATE LIMITED",
"SIDDHIRIDDHI AUTO SERVICES PRIVATE LIMITED",
"SIDDHIRIDDHI INTERNATIONAL PRIVATE LIMITED",
"SIDDHIRIDDHI LOGISTICS PRIVATE LIMITED",
"SIDDHITEC COMFORTS PRIVATE LIMITED",
"SIDDHIVINAYAK AESTHETICS PRIVATE LIMITED",
"SIDDHIVINAYAK AGGREGATES PRIVATE LIMITED",
"SIDDHIVINAYAK BIO - ENERGY (INDIA) PRIVATE LIMITED",
"SIDDHIVINAYAK BIZSOL PRIVATE LIMITED",
"SIDDHIVINAYAK CLEARING AND CARRIERS PRIVATE LIMITED",
"SIDDHIVINAYAK COAL CARRIERS PRIVATE LIMITED",
"SIDDHIVINAYAK CONSTRUCTION",
"SIDDHIVINAYAK EXIM",
"SIDDHIVINAYAK GENSET PRIVATE LIMITED",
"SIDDHIVINAYAK GUARD FORCE PRIVATE LIMITED",
"SIDDHIVINAYAK HEALTHCARE PRIVATE LIMITED",
"SIDDHIVINAYAK HOMES PRIVATE LIMITED",
"SIDDHIVINAYAK HOSPITAL",
"SIDDHIVINAYAK LIFE SCIENCE PRIVATE LIMITED",
"SIDDHIVINAYAK MATERNITY AND GENERAL HOSPITAL",
"SIDDHIVINAYAK MOTORS PRIVATE LIMITED",
"SIDDHIVINAYAK NETWORKS PRIVATE LIMITED",
"SIDDHIVINAYAK PHARMACHEM PRIVATE LIMITED",
"SIDDHIVINAYAK POLYTEX PRIVATE LIMITED",
"SIDDHIVINAYAK POULTRY BREEDING FARM & HATCHERIES PRIVATE LIMITED",
"SIDDHIVINAYAK PRECAST PIPES PRIVATE LIMITED",
"SIDDHIVINAYAK PROCESS EQUIPMENTS PRIVATE LIMITED",
"SIDDHIVINAYAK SUGARS LIMITED.",
"SIDDHIVINAYAK TIMBERS PRIVATE LIMITED",
"SIDDHIVINAYAK VASTUNIRMITI LIMITED",
"SIDDHIVINAYAKCREATIONS FACADE PRIVATE LIMITED",
"SIDDHKALYANAK FOUNDATION",
"SIDDHNATH EXPORTS PRIVATE LIMITED",
"SIDDHOMAL AIR PRODUCTS PRIVATE LIMITED",
"SIDDHOMAL PAPER CONVERSION CO PRIVATE LIMITED",
"SIDDHRAJ INFRABUILD PRIVATE LIMITED",
"SIDDI VIGNESWARA BUILDCON PRIVATE LIMITED",
"SIDDIQ FAIZ-E-AM INTER COLLEGE",
"SIDDIQUI HOME DEVELOPERS PRIVATE LIMITED",
"SIDDS JEWELS INDIA LLP",
"SIDDS JEWELS PRIVATE LIMITED",
"SIDDSOFT IT SOLUTIONS PRIVATE LIMITED",
"SIDDU PACKAGING PRIVATE LIMITED",
"SIDEEP EXIM PRIVATE LIMITED",
"SIDEL INDIA PRIVATE LIMITED",
"SIDERFORGEROSSI INDIA PRIVATE LIMITED",
"SIDEWOK TRADEPLACE PRIVATE LIMITED",
"SIDH GRANITES PVT LTD",
"SIDH MASTERBATCHES PRIVATE LIMITED",
"SIDH ORGANICS PRIVATE LIMITED",
"SIDH ROTOGRAVURE PRIVATE LIMITED",
"SIDH TOOLS LIMITED",
"SIDH TRADING PRIVATE LIMITED",
"SIDHA CONSTRUCTIONS PRIVATE LIMITED",
"SIDHAANT LIFE SCIENCES PRIVATE LIMITED",
"SIDHAARTH EXPORTS PRIVATE LIMITED",
"SIDHANATH SUGAR MILLS LIMITED",
"SIDHANSH ELECTRONICS PRIVATE LIMITED",
"SIDHANT CREATIONS PRIVATE LIMITED",
"SIDHANT INDIA PRIVATE LIMITED",
"SIDHANT INVESTMENT CONSULTANTS PRIVATE LIMITED.",
"SIDHANT MERCHANTS PRIVATE LIMITED",
"SIDHANT MINES AND MINERALS PRIVATE LIMITED",
"SIDHANT MOTORS PRIVATE LIMITED",
"SIDHANT REAL ESTATE DEVELOPERS AND SERVICES PRIVATE LIMITED",
"SIDHANT THERMOWARE PROMOTERS",
"SIDHANT VYAPAAR PVT LTD",
"SIDHARTH & GAUTAM ENGINEERS",
"SIDHARTH ARORA CONSULTATION PRIVATE LIMITED",
"SIDHARTH AUTOLINK PRIVATE LIMITED",
"SIDHARTH AUTOMAT INDIA PRIVATE LIMITED",
"SIDHARTH COPPER PRIVATE LIMITED",
"SIDHARTH EXPORTERS",
"SIDHARTH FABTEX PRIVATE LIMITED",
"SIDHARTH FOUNDATIONS AND HOUSING LIMITED",
"SIDHARTH PAPERS LIMITED.",
"SIDHARTH PLASTOMER INDUSTRIES PRIVATE LIMITED",
"SIDHARTH POLYSACKS PRIVATE LIMITED",
"SIDHARTH SYSTEMS PVT LTD",
"SIDHARTH TEXTILES PRIVATE LIMITED",
"SIDHARTH TRAVELS PRIVATE LIMITED",
"SIDHARTHA GELATINES PVT LTD",
"SIDHARTHA MARBLES AND GRANITES PRIVATE LIMITED",
"SIDHARTHA MECHANICAL WORKS PRIVATE LIMITED",
"SIDHARTHA RUBBER PRIVATE LIMITED",
"SIDHARTHA TOOLS PRIVATE LIMITED",
"SIDHARTHA VENTURE PRIVATE LIMITED",
"SIDHBALI INDUSTRIES PRIVATE LIMITED",
"SIDHE PETROCHEMICALS PRIVATE LIMITED",
"SIDHESHWAR ALLOYS PRIVATE LIMITED",
"SIDHESHWAR INFRASTRUCTURE INDIA PRIVATE LIMITED",
"SIDHESHWAR MULTISPECIALITY HOSPITAL PRIVATE LIMITED",
"SIDHESHWAR RMC INDIA PRIVATE LIMITED",
"SIDHESHWAR SYNTEX PRIVATE LIMITED",
"SIDHESHWARI COMMOTRADE PRIVATE LIMITED",
"SIDHGIRI HOLDINGS PRIVATE LIMITED",
"SIDHHARTHA CORPORATION PRIVATE LIMITED",
"SIDHI BINAYAK INFRASTRUCTURE PRIVATE LIMITED",
"SIDHI INTERNATIONAL METALLOYS PRIVATE LIMITED",
"SIDHI SINGRAULI ROAD PROJECT LIMITED",
"SIDHI VINAYAK ALLOYS LIMITED",
"SIDHI VINAYAK BUILDTECH AND PROMOTERS PRIVATE LIMITED",
"SIDHI VINAYAK BUILT HOME SPECALITIES PRIVATE LIMITED",
"SIDHI VINAYAK CARGO PRIVATE LIMITED",
"SIDHI VINAYAK COTSPIN LIMITED",
"SIDHI VINAYAK COTSPIN PRIVATE LIMITED",
"SIDHI VINAYAK EDIBLES PRIVATE LIMITED",
"SIDHI VINAYAK FABTEX PRIVATE LIMITED",
"SIDHI VINAYAK FOODS PRIVATE LIMITED",
"SIDHI VINAYAK HOME TOWNSHIP PRIVATE LIMITED",
"SIDHI VINAYAK METCOM LIMITED.",
"SIDHI VINAYAK POLYPLAST PRIVATE LIMITED",
"SIDHI VINAYAKA FAB ENGINEERING PRIVATE LIMITED",
"SIDHIDATA SOLAR URJA LIMITED",
"SIDHIGAN PLYWOOD PRIVATE LIMITED",
"SIDHIRATAN CONSTRUCTION PRIVATE LIMITED",
"SIDHIVINAYAK CHEMTECH PRIVATE LIMITED",
"SIDHIVINAYAK FILAMENTS PRIVATE LIMITED",
"SIDHIVINAYAK FOOTCARE PRIVATE LIMITED",
"SIDHIVINAYAK INFRAVENTURES PRIVATE LIMITED",
"SIDHIVINAYAK INVESTMENT ADVISORY PRIVATE LIMITED",
"SIDHIVINAYAK TRADING AND INVESTMENT LIMITED",
"SIDHJAI ENTERPRISES PRIVATE LIMITED",
"SIDHJAY LOGISTICS PRIVATE LIMITED",
"SIDHSHREE COMPUTRONICS PRIVATE LIMITED",
"SIDHSHREY DEVELOPERS PRIVATE LIMITED",
"SIDHU HOSPITAL PVT LTD",
"SIDHU TOURS & TRAVEL PRIVATE LIMITED",
"SIDHURMI PRIVATE LIMITED",
"SIDHVI DIA ABRASIVES PRIVATE LIMITED",
"SIDHVI INFRASTRUCTURE PROJECTS LIMITED",
"SIDHVI SOLUTIONS INDIA PRIVATE LIMITED",
"SIDHVINAYAK BITUMEN ENTERPRISE PRIVATE LIMITED",
"SIDHWAN HYDRO POWER PRIVATE. LIMITED.",
"SIDHYATI TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"SIDKAN CONSULTANCY PRIVATE LIMITED",
"SIDMA INDUSTRIAL AND LOGISTIC PARK PRIVATE LIMITED",
"SIDMAK LABORATORIESINDIAPRIVATE LIMITED",
"SIDMARK SALES ENTERPRISE PRIVATE LIMITED",
"SIDMAX VENTURES PRIVATE LIMITED",
"SIDQAM TECHNOLOGIES PRIVATE LIMITED",
"SIDRA HOMESTYLES PRIVATE LIMITED",
"SIDRAH OVERSEAS PRIVATE LIMITED",
"SIDS FARM PRIVATE LIMITED",
"SIDS HEALTH CARE PRIVATE LIMITED",
"SIDS HOSPITAL & RESEARCH CENTRE",
"SIDS MOTORS PRIVATE LIMITED",
"SIDSAM FORMILAN MACHINES PRIVATE LIMITED",
"SIDSON PHARMA DISTRIBUTORS PRIVATE LIMITED",
"SIDSSOL TECHNOLOGIES PRIVATE LIMITED",
"SIDUS ARCHITECTS & ENGINEERS PRIVATE LIMITED",
"SIDUS NATURAL PRODUCTS PRIVATE LIMITED",
"SIDVIM LIFESCIENCES PRIVATE LIMITED",
"SIDVIN ADVISORY SERVICES PRIVATE LIMITED",
"SIDVIN CORE-TECH INDIA PRIVATE LIMITED",
"SIDVIN HOSPITAL PRIVATE LIMITED",
"SIDVIN OUTOTEC ENGINEERING PRIVATE LIMITED",
"SIDWAL REFRIGERATION INDUSTRIES PRIVATE LIMITED",
"SIDWIN FABRIC PRIVATE LIMITED",
"SIEAT ENGINEERING PRIVATE LIMITED",
"SIEBENBERG TECHNOLOGIES PRIVATE LIMITED",
"SIE-BRAINS TECHNOLOGY SERVICES PRIVATE LIMITED",
"SIEC EDUCATION PRIVATE LIMITED",
"SIECHEM TECHNOLOGIES P LIMITED",
"SIECHEM TECHNOLOGIES PRIVATE LIMITED",
"SIECO ENGINEERS PRIVATE LIMITED",
"SIEG TECH PRODUCTS PRIVATE LIMITED",
"SIEGENIA INDIA PRIVATE LIMITED",
"SIEGER BUILDING SYSTEMS PRIVATE LIMITED",
"SIEGER ELECTRICAL SYSTEM PRIVATE LIMITED",
"SIEGHART ENGINEERS & STEEL DETAILERS PRIVATE LIMITED",
"SIEGWERK INDIA PRIVATE LIMITED",
"SIEMENS EDA (INDIA) PRIVATE LIMITED",
"SIEMENS EDA SALES & SERVICES PRIVATE LIMITED",
"SIEMENS ENERGY INDUSTRIAL TURBOMACHINERY INDIA PRIVATE LIMITED",
"SIEMENS FACTORING PRIVATE LIMITED",
"SIEMENS FINANCIAL SERVICES PRIVATE LIMITED",
"SIEMENS GAMESA RENEWABLE ENERGY ENGINEERING CENTRE PRIVATE LIMITED",
"SIEMENS GAMESA RENEWABLE ENERGY PROJECTS PRIVATE LIMITED",
"SIEMENS GAMESA RENEWABLE POWER PRIVATE LIMITED",
"SIEMENS HEALTHCARE PRIVATE LIMITED",
"SIEMENS HEALTHINEERS INDIA LLP",
"SIEMENS INDUSTRY SOFTWARE INDIA PRIVATE LIMITED",
"SIEMENS LIMITED",
"SIEMENS POSTAL PARCEL & AIRPORT LOGISTICS PRIVATE LIMITED",
"SIEMENS RAIL AUTOMATION PRIVATE LIMITED",
"SIEMENS TECHNOLOGY AND SERVICES PRIVATE LIMITED",
"SIEMON CABLING SOLUTIONS PRIVATE LIMITED",
"SIEMOTECH INFRASTRUCTURE PRIVATE LIMITED",
"SIEMTEL COMMUNICATIONS AND BUSINESS SERVICES PRIVATE LIMITED",
"SIENA CHEMICAL PRIVATE LIMITED",
"SIENA COLLEGE OF PROFESSIONAL STUDIES",
"SIENA ENGINEERING PRIVATE LIMITED",
"SIENNA ECAD TECHNOLOGIES PRIVATE LIMITED",
"SIENNA ENGINEERS PVT LTD",
"SIERA IT SERVICES PRIVATE LIMITED",
"SIERA SILK MILLS PRIVATE LIMITED",
"SIERENTZ GLOBAL MERCHANTS INDIA PRIVATE LIMITED",
"SIERRA APPLIANCES PRIVATE LIMITED",
"SIERRA CEDAR INDIA PRIVATE LIMITED",
"SIERRA CIRCUITS INDIA PRIVATE LIMITED",
"SIERRA CONCEPTS E SOLUTIONS PRIVATE LIMITED",
"SIERRA ENGINEERING & CONSTRUCTION (INDIA) PRIVATE LIMITED",
"SIERRA ENGINEERING & CONSTRUCTION INDIA PRIVATE LIMITED",
"SIERRA INNOVATIONS PRIVATE LIMITED",
"SIERRA NEVADA RESTAURANTS PRIVATE LIMITED",
"SIERRA ODC PRIVATE LIMITED",
"SIERRA PHARMACEUTICALS LIMITED.",
"SIERRA SUPPORT CENTRE P LIMITED",
"SIERRA WARE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"SIERRA WEB SOLUTIONS PRIVATE LIMITED",
"SIES COLLEGE OF ARTS SCIENCE AND COMMERCE SION",
"SIES COLLEGE OF COMMERCE AND ECONOMICS",
"SIES GRADUATE SCHOOL OF TECHNOLOGY",
"SIES SCHOOL OF BUSINESS STUDIES",
"SIESTA HOSPITALITY SERVICES LIMITED",
"SIESTA LAMINATES PRIVATE LIMITED",
"SIESTA LOGISTICS CORPORATION LIMITED",
"SIET COLLEGE FOR WOMEN",
"SIETZ TECHNOLOGIES INDIA PRIVATE LIMITED",
"SIEVA NETWORKS SOLUTIONS PRIVATE LIMITED",
"SIEVE SYNERGIES PRIVATE LIMITED",
"SIEVERT INDIA PRIVATE LIMITED",
"SIEVES MANUFACTURERS (INDIA) PRIVATE LIMITED",
"SIEWERT AND DHOLAKIA OVERSEAS PRIVATE LIMITED",
"SIF GARMENTS PRIVATE LIMITED",
"SIFA INVENTECH PRIVATE LIMITED",
"SIFA MOTORS PRIVATE LIMITED",
"SIFAM HEALTHCARE PRIVATE LIMITED",
"SIFANG AUTOMATION INDIA PRIVATE LIMITED",
"SIFCO ENGINEERING PRIVATE LIMITED",
"SIFEL MINERALS PRIVATE LIMITED",
"SIFLON DRUGS AND PHARMACEUTICALS PRIVATE LIMITED",
"SIFLON DRUGS PRIVATE LIMITED",
"SIFLON POLYMERS PRIVATE LIMITED",
"SIFMA CORPORATE SERVICES PRIVATE LIMITED",
"SIFT CONSULTANCY PRIVATE LIMITED",
"SIFY DIGITAL SERVICES LIMITED",
"SIFY INFINIT SPACES LIMITED",
"SIFY TECHNOLOGIES LIMITED",
"SIG COMBIBLOC INDIA PRIVATE LIMITED",
"SIG PRINTPACK PRIVATE LIMITED",
"SIG PROPERTIES PRIVATE LIMITED",
"SIG SYSTEMS PRIVATE LIMITED",
"SIG TECHNOSOFT PRIVATE LIMITED",
"SIGA GASES INDIA PRIVATE LIMITED",
"SIGACHI INDUSTRIES LIMITED",
"SIGACHI INDUSTRIES PRIVATE. LIMITED.",
"SIGACHI LABORATORIES LIMITED",
"SIGCURE PHARMACY PRIVATE LIMITED",
"SIGFIG INDIA PRIVATE LIMITED",
"SIGHT AND SOUND INDIA PRIVATE LIMITED",
"SIGHT AVENUE PRIVATE LIMITED",
"SIGHT SOUND ELECTRONICS (INDIA) PRIVATE LIMITED",
"SIGHTLIFE INDIA",
"SIGHTOM PHARMACEUTICALS PRIVATE LIMITED",
"SIGHTSPECTRUM TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"SIGLO INTERNATIONAL PRIVATE LIMITED",
"SIGMA ADVANCED SYSTEMS PRIVATE LIMITED",
"SIGMA AGRIPRODUCTS PRIVATE LIMITED",
"SIGMA AIRTECH ENGINEERS PRIVATE LIMITED",
"SIGMA ALDRICH CHEMICALS PRIVATE LIMITED",
"SIGMA ALLIED SERVICES PRIVATE LIMITED",
"SIGMA AUTO CRAFT PRIVATE LIMITED",
"SIGMA AUTOMOTIVE MATERIALS PRIVATE LIMITED",
"SIGMA AVIT TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"SIGMA BEARING AND AUTOS PRIVATE LIMITED",
"SIGMA BUILDWELL PRIVATE LIMITED",
"SIGMA BYTE COMPUTERS PRIVATE LIMITED",
"SIGMA CARTONS PVT LTD",
"SIGMA CASTINGS LIMITED",
"SIGMA CHEMICALS",
"SIGMA CHEMTRADE PRIVATE LIMITED",
"SIGMA CONSULTANCY",
"SIGMA CONTAINER PRIVATE LIMITED",
"SIGMA CORPORATION INDIA LIMITED",
"SIGMA CRANES AND HOISTS PRIVATE LIMITED",
"SIGMA ELECTRIC MANUFACTURING CORPORATION PRIVATE LIMITED",
"SIGMA ELEMENTS PRIVATE LIMITED",
"SIGMA ENERGY RESOURCES PRIVATE LIMITED",
"SIGMA ENGINEERING PRIVATE LIMITED",
"SIGMA ESOLUTION PRIVATE LIMITED",
"SIGMA FITNESS PRIVATE LIMITED",
"SIGMA FLOW CONTROL INDIA LIMITED",
"SIGMA FORGING & FORMING PRIVATE LIMITED",
"SIGMA GALVANIZING PRIVATE LIMITED",
"SIGMA GASES AND SERVICES",
"SIGMA GENERATORS PRIVATE LIMITED",
"SIGMA HEAVY ENGINEERING INDUSTRIES BHOPAL PRIVATE LIMITED",
"SIGMA HEAVY PROJECTS PRIVATE LIMITED",
"SIGMA I T SERVICES PRIVATE LIMITED",
"SIGMA I.T. SUPER STORE PRIVATE LIMITED",
"SIGMA INFOSOLUTIONS LIMITED",
"SIGMA INFOTECH PVT.LTD.",
"SIGMA INSIGHTS PRIVATE LIMITED",
"SIGMA INSPECTION AND TESTING PRIVATE LIMITED",
"SIGMA INSTITUTE OF TECHNOLOGY & ENGINEERING",
"SIGMA INSURANCE BROKING PRIVATE LIMITED",
"SIGMA LABORATORIES PRIVATE LIMITED",
"SIGMA LASERTECH PRIVATE LIMITED",
"SIGMA LIFE CARE (MYSORE) PRIVATE LIMITED",
"SIGMA MAT PRIVATE LIMITED",
"SIGMA MECHOTRONICS PRIVATE LIMITED",
"SIGMA MEDITECH SERVICES PRIVATE LIMITED",
"SIGMA METAL AND POWER PRIVATE LIMITED",
"SIGMA METALTEK ENGINEERS PRIVATE LIMITED",
"SIGMA MINERALS LIMITED",
"SIGMA MOULDS AND STAMPINGS PRIVATE LIMITED",
"SIGMA NDT SERVICES PRIVATE LIMITED",
"SIGMA OPTIMA SOLUTIONS PRIVATE LIMITED",
"SIGMA ORGANICS AND CHEMICALS PRIVATE LIMITED",
"SIGMA OSS SYSTEMS INDIA PRIVATE LIMITED",
"SIGMA OUTSOURCING SERVICES PRIVATE LIMITED",
"SIGMA PLASTOCHEM PRIVATE LIMITED",
"SIGMA POINT",
"SIGMA POLYCHEM PRIVATE LIMITED",
"SIGMA POLYTEC PRIVATE LIMITED",
"SIGMA POWER CONTROL SYSTEMS PRIVATE LIMITED",
"SIGMA POWER PRODUCT PRIVATE LIMITED",
"SIGMA POWER TECH PRIVATE LIMITED",
"SIGMA POWER TILLERS PRIVATE LIMITED",
"SIGMA PRINTERS PRIVATE LIMITED",
"SIGMA PUNCH FORMS PRIVATE LIMITED",
"SIGMA RAIL SYSTEMS PRIVATE LIMITED",
"SIGMA REALTORS (INDIA) PRIVATE LIMITED",
"SIGMA REFRACTORY PRIVATE LIMITED",
"SIGMA RESEARCH AND CONSULTING PRIVATE LIMITED",
"SIGMA ROLLERS PRIVATE LIMITED",
"SIGMA SALES PVT. LTD.",
"SIGMA SCAN SYSTEMS PVT.LTD.",
"SIGMA SCIENTIFIC GLASS PRIVATE LIMITED",
"SIGMA SEARCHLIGHTS LTD.",
"SIGMA SHIPPING AGENCY PRIVATE LIMITED",
"SIGMA SOFTGEL & FORMULATION",
"SIGMA SOLVE IT TECH PRIVATE LIMITED",
"SIGMA SOLVE LIMITED",
"SIGMA SOLVENTS AND PHARMACEUTICALS LIMITED",
"SIGMA SOLVENTS PRIVATE. LIMITED",
"SIGMA SPICE INDUSTRIES PRIVATE. LIMITED.",
"SIGMA STAFFING SOLUTIONS PRIVATE LIMITED",
"SIGMA SUPPLY CHAIN SOLUIOTNS PRIVATE LIMITED",
"SIGMA SURGICAL PRIVATE LIMITED",
"SIGMA TECHINFRA SOLUTIONS INDIA PRIVATE LIMITED",
"SIGMA TEXTILE AND GARMENTS PRIVATE LIMITED",
"SIGMA TOOLINGS INDIA PRIVATE LIMITED",
"SIGMA TOOLS AND ACCESSORIES PRIVATE LIMITED",
"SIGMA TRAVEL & CARGO PRIVATE LIMITED",
"SIGMA WEAR-RESIST PRODUCTS PRIVATE LIMITED",
"SIGMA WEB SOLUTIONS PRIVATE LIMITED",
"SIGMAAVIT INFRA SERVICES PRIVATE LIMITED",
"SIGMAAVIT TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"SIGMACHEMIE SPECIALITY PRIVATE LIMITED",
"SIGMAFLOW PRODUCTION SOLUTIONS PRIVATE LIMITED",
"SIGMA-HSE (INDIA) PRIVATE LIMITED",
"SIGMALLOY PRIVATE LIMITED",
"SIGMA-PI POWER SOURCES PRIVATE LIMITED",
"SIGMAQUANT TECHNOLOGIES PRIVATE LIMITED",
"SIGMARQ TECHNOLOGIES PRIVATE LIMITED",
"SIGMASOFT INFOTECH PRIVATE LIMITED",
"SIGMATEK SYSTEMS INDIA PRIVATE LIMITED",
"SIGMAVIX INFRA INDIA PRIVATE LIMITED",
"SIGMEX FOODS INDIA PRIVATE LIMITED",
"SIGMOID HEALTHCARE PRIVATE LIMITED",
"SIGN FOR SAFETY INDIA PRIVATE LIMITED",
"SIGN O SIGN DESIGNS CHENNAI PRIVATE LIMITED",
"SIGN PHARMA TRADE SERVICES PRIVATE LIMITED",
"SIGN TECHNIC INDUSTRIES PRIVATE LIMITED",
"SIGN WRITE INDIA PRIVATE LIMITED",
"SIGNA MEDI SOLUTIONS PRIVATE LIMITED",
"SIGNA TECH SERVICES PRIVATE LIMITED",
"SIGN-AGE (INDIA) PRIVATE LIMITED",
"SIGNAGES MAKERS PRINTS MEDIA PRIVATE LIMITED",
"SIGNAGEUS VALUE ADVISORS PRIVATE LIMITED",
"SIGNAL LOGISTICS PRIVATE LIMITED",
"SIGNALCHIP INNOVATIONS PRIVATE LIMITED",
"SIGNALS AND SYSTEMS (INDIA) PRIVATE LIMITED",
"SIGNALX PRIVATE LIMITED",
"SIGNART INTERNATIONAL PRIVATE LIMITED",
"SIGNASSURE SERVICES INDIA LIMITED",
"SIGNATIZE ELECTRONICS INDIA PRIVATE LIMITED",
"SIGNATURE AUTOMOBILES INDIA PRIVATE LIMITED",
"SIGNATURE AUTOMOBILES KASARGOD PRIVATE LIMITED",
"SIGNATURE AVENUES LLP",
"SIGNATURE BUILDERS PRIVATE LIMITED",
"SIGNATURE CERAMIC PRIVATE LIMITED",
"SIGNATURE CREATIONS PRIVATE LIMITED",
"SIGNATURE DWELLINGS PRIVATE LIMITED",
"SIGNATURE FOAM PRIVATE LIMITED",
"SIGNATURE FOREX & ALLIED SERVICES PRIVATE LIMITED",
"SIGNATURE GLOBAL",
"SIGNATURE GLOBAL PRIVATE LIMITED",
"SIGNATURE HOSIERY PRIVATE LIMITED",
"SIGNATURE HOSPITAL GURGAON",
"SIGNATURE INSURANCE BROKERS PRIVATE LIMITED",
"SIGNATURE INTERNATIONAL FOODS INDIA PRIVATE LIMITED",
"SIGNATURE LAMINATES PRIVATE LIMITED",
"SIGNATURE LIFESTYLES PRIVATE LIMITED",
"SIGNATURE MOTORS INDIA PRIVATE LIMITED",
"SIGNATURE MOTORS KASARGOD PRIVATE LIMITED",
"SIGNATURE OVERSEAS",
"SIGNATURE SALES PRIVATE LIMITED",
"SIGNATURE SOLUTIONS INDIA PRIVATE LIMITED",
"SIGNATURE VACATIONS PRIVATE LIMITED",
"SIGNATURE VANIJYA PRIVATE LIMITED",
"SIGNATUREGLOBAL (INDIA) LIMITED",
"SIGNATUREGLOBAL BUSINESS PARK PRIVATE LIMITED",
"SIGNATUREGLOBAL DEVELOPERS PRIVATE LIMITED",
"SIGNATUREGLOBAL HOMES PRIVATE LIMITED",
"SIGNATUREGLOBAL MARKETING SOLUTIONS PRIVATE LIMITED",
"SIGNATUREGLOBAL SECURITIES PRIVATE LIMITED",
"SIGNATURES ADVERTISING PRIVATE LIMITED",
"SIGNATURES DESIGNS AND COMMUNICATIONS PRIVATE LIMITED",
"SIGNEASY TECHNOLOGIES PRIVATE LIMITED",
"SIGNEDGE LEATHER PRIVATE LIMITED",
"SIGNELLENT TECHNOLOGIES INDIA PRIVATE LIMITED",
"SIGNET AUTOMATION ENGINEERS PRIVATE LIMITED",
"SIGNET CAPITAL PRIVATE LIMITED",
"SIGNET CHEMICAL CORPORATION PRIVATE LIMITED",
"SIGNET CONDUCTORS PRIVATE LIMITED",
"SIGNET CROP SCIENCES INDIA PRIVATE LIMITED",
"SIGNET DENIM PRIVATE LIMITED",
"SIGNET DIGITAL PRIVATE LIMITED",
"SIGNET ENERTECH PRIVATE LIMITED",
"SIGNET EXCIPIENTS PRIVATE LIMITED",
"SIGNET FOODS & PACKAGING PRIVATE LIMITED",
"SIGNET GARMENTS PRIVATE LIMITED",
"SIGNET INDUSTRIES LIMITED",
"SIGNET MEDIA SERVICE PRIVATE LIMITED",
"SIGNET PROJECTS PRIVATE LIMITED",
"SIG-NET RUBBER (INDIA) PRIVATE LIMITED",
"SIGNET VYAPAAR PVT LTD",
"SIGNEXOO TECHNOLOGIES PRIVATE LIMITED",
"SIGNEXT DISPLAY SYSTEMS PRIVATE LIMITED",
"SIGNI JEWELS PRIVATE LIMITED",
"SIGNIFIC PROCESS MASTERS PRIVATE LIMITED",
"SIGNIFICANT FASHION PRIVATE LIMITED",
"SIGNIFIER TECHNOLOGY PRIVATE LIMITED",
"SIGNIFY INNOVATIONS INDIA LIMITED",
"SIGNIFY NIRMAN PRIVATE LIMITED",
"SIGNIN SOFT PRIVATE LIMITED",
"SIGNIT LABORATORIES PVT LTD",
"SIGNITIVE SOLUTIONS LLP",
"SIGNITY INDIA PRIVATE LIMITED",
"SIGNITY PHARMACEUTICALS PRIVATE LIMITED",
"SIGNITY SOFTWARE SOLUTIONS PRIVATE LIMITED",
"SIGNIWIS TECHNOLOGIES PRIVATE LIMITED",
"SIGNMAX EXIM PRIVATE LIMITED",
"SIGNODE INDIA LIMITED",
"SIGNODRIVE TECHNOLOGIES PRIVATE LIMITED",
"SIGNOFF SEMICONDUCTORS PRIVATE LIMITED",
"SIGNOR HISEC PACKAGING PRIVATE LIMITED",
"SIGNOR SECURITIES PRIVATE LIMITED",
"SIGNORA POLYTEX PRIVATE LIMITED",
"SIGNORIA CREATION LIMITED",
"SIGNOTECH SYSTEMS PRIVATE LIMITED",
"SIGNOTRON INDIA PRIVATE LIMITED",
"SIGNOVA AGRO MANAGEMENT PRIVATE LIMITED",
"SIGNOVA CROP SCIENCES PRIVATE LIMITED",
"SIGNOVA PHARMA PRIVATE LIMITED",
"SIGNOVUS TECHNOLOGIES PRIVATE LIMITED",
"SIGNPOST INDIA LIMITED",
"SIGNPOST INDIA PRIVATE LIMITED",
"SIGNS300 DISTRIBUTORS PRIVATE LIMITED",
"SIGNSUTRA INTERNATIONAL PRIVATE LIMITED",
"SIGNUM ELECTRO PRIVATE LIMITED",
"SIGNUM FIRE PROTECTION INDIA PRIVATE LIMITED",
"SIGNUM HOSPITALITY PRIVATE LIMITED",
"SIGNUM IMPEX PRIVATE LIMITED",
"SIGNURE TECHNOLOGIES PRIVATE LIMITED",
"SIGNUS MULTISPECIALITY HOSPITAL PRIVATE LIMITED",
"SIGNZY TECHNOLOGIES PRIVATE LIMITED",
"SIGRUN REALTIES LIMITED",
"SIGTEL SIGNAL & TELECOMMUNICATION PRIVATE LIMITED",
"SIGTUPLE TECHNOLOGIES PRIVATE LIMITED",
"SIGUE SUPPORT SERVICES PRIVATE LIMITED",
"SIGULER GUFF INDIA ADVISERS PRIVATE LIMITED",
"SIHA EARTH MOVERS PRIVATE LIMITED",
"SI-HIVE TECHNOLOGIES PRIVATE LIMITED",
"SIHL CONSULTANCY LIMITED",
"SIHL FINCAP LIMITED",
"SII INDIA IT AND ENGINEERING SERVICES PRIVATE LIMITED",
"SII TECHNOLOGIES PRIVATE LIMITED",
"SIIA ADVISORY CONSULTANTS LLP",
"SIIVAGANAPATHI SPINNERS PRIVATE LIMITED",
"SIJA LOGISTICS PRIVATE LIMITED",
"SIJCON CONSULTANTS PRIVATE LIMITED",
"SIJMAK EXPORTS PRIVATE LIMITED",
"SIJO PLASTICS PRIVATE LIMITED",
"SIKA INDIA PRIVATE LIMITED",
"SIKA INTERPLANT SYSTEMS LIMITED",
"SIKA PROPERTIES PRIVATE LIMITED",
"SIKAND & CO",
"SIKANDS LIMITED",
"SIKAR LOGISTICS LIMITED",
"SIKAR-BIKANER HIGHWAY LIMITED",
"SIKARIA INFRAPROJECTS PRIVATE LIMITED",
"SIKARWAR INTERNATIONAL SCHOOL AURANGABAD MATHURA",
"SIKARWAR PLASTIC INDUSTRIES PRIVATE LIMITED",
"SIKHA FOREX & TRAVELS PRIVATE LIMITED",
"SIKHA MEDIEQUIP PRIVATE LIMITED",
"SIKHYA ENTERTAINMENT PRIVATE LIMITED",
"SIKKA AUTOMOBILE PRIVATE LIMITED",
"SIKKA BROADBAND PRIVATE LIMITED",
"SIKKA ENGINEERING COMPANY PRIVATE LIMITED",
"SIKKA FORGINGS PRIVATE LIMITED",
"SIKKA INFRATECH PRIVATE LIMITED",
"SIKKA KARS GLOBAL PRIVATE LIMITED",
"SIKKA MOTORS PRIVATE LIMITED",
"SIKKA PROMOTERS PRIVATE LTD.",
"SIKKAS KWICK HANDLING SERVICES PRIVATE LIMITED",
"SIKKAWALA INDIA PRIVATE LIMITED",
"SIKKIM FERRO ALLOYS LIMITED",
"SIKKIM GLOBAL TECHNICAL UNIVERSITY",
"SIKKIM LAND DEVELOPERS PRIVATE LIMITED",
"SIKKIM MANIPAL UNIVERSITY",
"SIKKO INDUSTRIES LIMITED",
"SIKORA INDIA PRIVATE LIMITED",
"SIKRAFT INFOTECH PRIVATE LIMITED",
"SIKSHA 'O' ANUSANDHAN",
"SIKSHA TRAINING AND DEVELOPMENT PRIVATE LIMITED",
"SIL AUTOFAB LIMITED",
"SIL FOOD INDIA PRIVATE LIMITED",
"SIL RETAILS PRIVATE LIMITED",
"SIL SAFEWAY INDIA LOGISTICS PRIVATE LIMITED",
"SIL TECHNOLOGIES PRIVATE LIMITED",
"SILA PROJECT MANAGEMENT SERVICES PRIVATE LIMITED",
"SILA REAL ESTATE PRIVATE LIMITED",
"SILA SOLUTIONS P LIMITED",
"SILA SOLUTIONS PRIVATE LIMITED",
"SILABATI GARMENTS PRIVATE LIMITED",
"SILAGE AGRO PRIVATE LIMITED",
"SILANIA ASSOCIATES PACKAGING PRIVATE LIMITED",
"SILARIS CLOTHING PRIVATE LIMITED",
"SILARIS INFORMATIONS PRIVATE LIMITED",
"SILARIS INFOSYSTEM PRIVATE LIMITED",
"SILBIS PHARMA PRIVATE LIMITED",
"SILCARB RECRYSTALLIZED PRIVATE LIMITED",
"SILCHROME METAL FINISHERS PRIVATE LIMITED",
"SILCO AUTOMOTIVE SOLUTIONS LLP",
"SILCON STEELS PRIVATE LIMITED",
"SILCOTECH BONNY PRODUCTS (INDIA) PRIVATE LIMITED",
"SILCOTEX SILICONES PRIVATE LIMITED",
"SILENG MANUFACTURING INDIA PRIVATE LIMITED",
"SILENT HILLS RESORT PRIVATE LIMITED",
"SILENT INFOTECH PRIVATE LIMITED",
"SILENT LEOPARD TOURS & TRAVELS PRIVATE LIMITED",
"SILERGY TECHNOLOGIES PRIVATE LIMITED",
"SILEX INDUSTRIES PRIVATE LIMITED",
"SILEX TECHNOLOGY INDIA PRIVATE LIMITED",
"SILFIX INDIA PRIVATE LIMITED",
"SILGAN DISPENSING SYSTEMS INDIA PRIVATE LIMITED",
"SILGATE SOLUTIONS LIMITED",
"SILGO CREATIONS (JAIPUR) PRIVATE LIMITED",
"SILGO RETAIL LIMITED",
"SILICA BOTTLING AND BLENDING ENTERPRISES LLP",
"SILICA CERAMICA PRIVATE LIMITED",
"SILICA HOUSE PRIVATE LIMITED",
"SILICA INFOTECH PRIVATE LIMITED",
"SILICA INFRAPROJECTS PRIVATE LIMITED",
"SILICA PETROLEUM PRIVATE LIMITED",
"SILICA UDYOG INDIA PRIVATE LIMITED",
"SILICATE INDIA PRIVATE LIMITED",
"SILICIOM TECHNOLOGIES PRIVATE LIMITED",
"SILICOM ELECTRONICS PRIVATE LIMITED",
"SILICON AUTOMOBILES PRIVATE LIMITED",
"SILICON BIZTECH PRIVATE LIMITED",
"SILICON BUILDERS PRIVATE LIMITED",
"SILICON BUSINESS SOLUTIONS PRIVATE LIMITED",
"SILICON CEMENT PRIVATE LIMITED",
"SILICON CITY TRANSPORT SERVICES PRIVATE LIMITED",
"SILICON COMPUTECH PRIVATE LIMITED",
"SILICON CONSTRUCTIONS PRIVATE LIMITED",
"SILICON CORTECH PRIVATE LIMITED",
"SILICON DRUGS AND INTERMEDIATES PRIVATE LIMITED",
"SILICON ENGINEERING CONSULTANTS PRIVATE LIMITED",
"SILICON FACILITIES SERVICES PRIVATE LIMITED",
"SILICON FERTILIZER LIMITED",
"SILICON IMAGE INDIA RESEARCH AND DEVELOPMENT PRIVATE LIMITED",
"SILICON INDUSTRIAL DRIVES & AUTOMATION PRIVATE LIMITED",
"SILICON INFOCARE (OPC) PRIVATE LIMITED",
"SILICON INFRASTRUCTURE PRIVATE LIMITED",
"SILICON INSTITUTE OF TECHNOLOGY",
"SILICON ITHUB PRIVATE LIMITED",
"SILICON JEWEL INDUSTRIES PRIVATE LIMITED",
"SILICON LABORATORIES SEMICONDUCTORS INDIA PRIVATE LIMITED",
"SILICON LIFE SCIENCES PRIVATE LIMITED",
"SILICON MEADOWS ENGINEERING SERVICES LIMITED",
"SILICON NETSECURE PRIVATE LIMITED",
"SILICON RENTAL SOLUTIONS LIMITED",
"SILICON RENTAL SOLUTIONS PRIVATE LIMITED",
"SILICON SAFEPACK PRIVATE LIMITED",
"SILICON SECURE SYSTEMS PRIVATE LIMITED",
"SILICON SEMI CONDUCTORS PRIVATE LIMITED",
"SILICON SYSTECH & SERVICES PRIVATE LIMITED",
"SILICON TECHLAB PRIVATE LIMITED",
"SILICON TELE-POINT PRIVATE LIMITED",
"SILICON VALLEY CERTIFICATIONS INDIA PRIVATE LIMITED",
"SILICONBIZTECH PRIVATE LIMITED",
"SILICONCH SYSTEMS PRIVATE LIMITED",
"SILICONE CONCEPTS INTERNATIONAL PRIVATE LIMITED",
"SILICONMEDIA TECHNOLOGIES PRIVATE LIMITED",
"SILICONREVIEW TECHNOLOGIES INDIA PRIVATE. LIMITED",
"SILICONUNION TECHNOLOGIES PRIVATE LIMITED",
"SILICONVALLEY GRAPE WINERY PRIVATE LIMITED",
"SILICONVEINS PRIVATE LIMITED",
"SILICOSYS TECHNOLOGIES INDIA PRIVATE LIMITED",
"SILIGURI APPAREL PRIVATE LIMITED",
"SILIGURI BUILDER STORES",
"SILIGURI COMMODITIES PRIVATE LIMITED",
"SILIGURI HEIGHTS PRIVATE LIMITED",
"SILIGURI INSTITUTE OF TECHNOLOGY",
"SILIGURI LOGISTIC PRIVATE LIMITED",
"SILIGURI MARKETING PRIVATE LIMITED",
"SILIGURI MERCHANTILES PRIVATE LIMITED",
"SILIGURI PRESS PRIVATE LIMITED",
"SILIGURI RICE & GENERAL MILLS PRIVATE LIMITED",
"SILIGURI TRADELINK PRIVATE LIMITED",
"SILIS LABS PRIVATE LIMITED",
"SILK AFFAIR PRIVATE LIMITED",
"SILK CREATIONS PRIVATE LIMITED",
"SILK INDIA INTERNATIONAL LIMITED",
"SILK N FAB PRIVATE LIMITED",
"SILK TOUCH VITRIFIED PRIVATE LIMITED",
"SILK WOVEN SACK PRIVATE LIMITED",
"SILKAANS ELECTRICALS MANUFACTURING COMPANY PRIVATE LIMITED",
"SILKASIA EXPORTS PRIVATE LIMITED",
"SILKEE ELECTRONICS PRIVATE LIMITED",
"SILKFLEX POLYMERS (INDIA) LIMITED",
"SILKFLEX TREXIM PRIVATE LIMITED",
"SILKINA APPAREL MANUFACTURING COMPANY PRIVATE LIMITED",
"SILKON ADDITIVES INDIA PRIVATE LIMITED",
"SILKON BUSINESS PRIVATE LIMITED",
"SILKON HEALTH CARE PRIVATE LIMITED",
"SILKON SYNTHETICS AND COTTON DYEING PRIVATE LIMITED",
"SILKROUTE HOLIDAYS INDIA PRIVATE LIMITED",
"SILKY IMAGES FASHIONS PRIVATE LIMITED",
"SILKY OVERSEAS LIMITED",
"SILKY OVERSEAS PRIVATE LIMITED",
"SILKY PAINTS PRIVATE LIMITED",
"SILLY MONKS ENTERTAINMENT LIMITED",
"SILMARIL SOFTWARE PRIVATE LIMITED",
"SILMAX TOOLS INDIA PRIVATE LIMITED",
"SILMOHAN GEMS PRIVATE LIMITED",
"SILO BAG INDIA PRIVATE LIMITED",
"SILO GRANITES INDIA PRIVATE LIMITED",
"SILONIBARI TEA CO LTD",
"SILOX INDIA PRIVATE LIMITED",
"SILOXANE AGGRANDIZE INNOVATIVE INDUSTRIES",
"SILPA HOSPITALITY PRIVATE LIMITED",
"SILPA INFRATECH LIMITED",
"SILPA PROJECTS AND INFRASTRUCTURE INDIA PRIVATE LIMITED",
"SILPABARTA PRINTING PRESS LTD",
"SILPHA FINVEST PVT LTD",
"SILPI TECHNOLOGIES PRIVATE LIMITED",
"SILPO SATHI INDUSTRIAL PROJECTS CONSULTA",
"SILRES ENERGY SOLUTIONS PRIVATE LIMITED",
"SILTOP AUTO COMPONENTS PRIVATE LIMITED",
"SILVA REAL ESTATES AND DEVELOPERS PRIVATE LIMITED",
"SILVAN ELECTRICAL AND LIGHTING PRIVATE LIMITED",
"SILVAN INNOVATION LABS PRIVATE LIMITED",
"SILVASSA CEMENT PRODUCTS PRIVATE LIMITED",
"SILVASSA ESTATES PRIVATE LIMITED",
"SILVASSA FIBRES PRIVATE. LIMITED",
"SILVASSA RESOURCES PRIVATE LIMITED",
"SILVASSA WOVEN SACKS PRIVATE LIMITED",
"SILVENIA CERAMIC PRIVATE LIMITED",
"SILVENTA CERAMIC TILES PRIVATE LIMITED",
"SILVER ANGEL IMPEX LIMITED",
"SILVER APPARELS INDUSTRIES PRIVATE LIMITED",
"SILVER ARROW AUTOMOBILES PRIVATE LIMITED",
"SILVER BEACH ENTERTAINMENT & HOSPITALITYINDIA PRIVATE LIMITED",
"SILVER BELLS FOREX & TRAVELS PRIVATE LIMITED",
"SILVER BELLS PUBLIC SCHOOL",
"SILVER BROOK FINANCIAL LEARNING CENTER PRIVATE LIMITED",
"SILVER CITY HOUSING AND INFRASTRUCTURE LIMITED",
"SILVER COATS PRIVATE LIMITED",
"SILVER COIN EXTRUSION PRIVATE LIMITED",
"SILVER COLLECTIONS PRIVATE LIMITED",
"SILVER COMPLEX PRIVATE LIMITED",
"SILVER CONSUMER ELECTRICALS PRIVATE LIMITED",
"SILVER CONTAINERS PRIVATE LIMITED",
"SILVER CREATIONS PRIVATE LIMITED",
"SILVER CREEKS INFRA PRIVATE LIMITED",
"SILVER CREST CLOTHING PRIVATE LIMITED",
"SILVER CROSS MARKETING PVT LTD",
"SILVER CROWN POWER PRODUCTS PRIVATE LIMITED",
"SILVER DALE SERVICES (INDIA) PRIVATE LIMITED",
"SILVER DROP FOODS AND BEVERAGES PRIVATE LIMITED",
"SILVER DUCK TRADERS PRIVATE LIMITED",
"SILVER FAB SUITINGS PRIVATE LIMITED",
"SILVER FINANCE SOLUTIONS PRIVATE LIMITED",
"SILVER FOILS PRIVATE LIMITED",
"SILVER FORGE PRIVATE LIMITED",
"SILVER GLOBAL SERVICES PRIVATE LIMITED",
"SILVER ICE BEVERAGES",
"SILVER INTERNATIONAL PRIVATE LIMITED",
"SILVER JUBILEE MOTORS LIMITED",
"SILVER KEY DEVELOPERS PRIVATE LIMITED",
"SILVER LAND DEVELOPERS P LTD",
"SILVER LEAF HOTELS PRIVATE LIMITED",
"SILVER LEAF SOLUTIONS PRIVATE LIMITED",
"SILVER LEAF TEA PRIVATE LIMITED",
"SILVER LINE FITNESS SYSTEMS PRIVATE LIMITED",
"SILVER LINE INVESTMENT COMPANY PRIVATE LIMITED",
"SILVER LINE IT SOLUTIONS PRIVATE LIMITED",
"SILVER LINE LABORATORIES PRIVATE LIMITED",
"SILVER LINE SCHOOL",
"SILVER MINE SILK PROCESSORS PRIVATE LIMITED",
"SILVER MOON CONSTRUCTIONS PRIVATE LIMITED",
"SILVER MOON IMPEX PRIVATE LIMITED",
"SILVER MOON JEWELLERY PRIVATE LIMITED",
"SILVER MULLER RUBBER LIMITED",
"SILVER OAK PROJECTS PRIVATE LIMITED",
"SILVER OAK SCHOOL ALWAR",
"SILVER OAK UNIVERSITY",
"SILVER OAKS HOSPITAL",
"SILVER OAKS TOWNSHIP PRIVATE LIMITED",
"SILVER PALACE PVT LTD",
"SILVER PALM HOTEL & RESORTS PRIVATE LIMITED",
"SILVER PEARL HOSPITALITY & LUXURY SPACES LIMITED",
"SILVER PETROCHEMICALS PRIVATE LIMITED",
"SILVER PINE HOSPITALITY PRIVATE LIMITED",
"SILVER PLASTOCHEM PRIVATE LIMITED",
"SILVER POINT SCHOOL",
"SILVER PORT SERVICES PRIVATE LIMITED",
"SILVER PRINTS PRIVATE LIMITED",
"SILVER PROFILE PVT LTD",
"SILVER RIDGE INFRATECH PRIVATE LIMITED",
"SILVER ROSE IMPEX PRIVATE LIMITED",
"SILVER ROSE OVERSEAS PRIVATE LIMITED",
"SILVER SHADOW EXPORTS PRIVATE LIMITED",
"SILVER SHINE JEWELLERY PRIVATE LIMITED",
"SILVER SIGN PRIVATE LIMITED",
"SILVER SOFTWARE PRIVATE LIMITED",
"SILVER SPARK APPAREL LIMITED",
"SILVER SPOON ENTERTAINMENT PRIVATE LIMITED",
"SILVER SPORTS INDIA PRIVATE LIMITED",
"SILVER SPRING SPINNERS INDIA PRIVATE LIMITED",
"SILVER SPRINGS PLEASURE RESORTS PRIVATE LIMITED",
"SILVER SQUARE CORPORATION INDIA PRIVATE LIMITED",
"SILVER STAR AGRO PRIVATE LIMITED",
"SILVER STAR COMMOTRADE PVT LTD",
"SILVER STAR DISTILLERY",
"SILVER STAR FINANCE AND LEASING LTD.",
"SILVER STREAK HOTELS PRIVATE LIMITED",
"SILVER STREAK MULTI SPECIALITY HOSPITAL",
"SILVER STREAM EQUITIES PRIVATE LIMITED",
"SILVER STRIPS (INDIA) PRIVATE LIMITED",
"SILVER TOUCH HOSPITALS",
"SILVER TOUCH TECHNOLOGIES LIMITED",
"SILVER TRACK SYSTEMS & SERVICES PRIVATE LIMITED",
"SILVER TREE AGRO TECH PRIVATE LIMITED",
"SILVER VILLA CONSTRUCTIONS PRIVATE LIMITED",
"SILVER ZONE ENTERPRISES INDIA PRIVATE LIMITED",
"SILVERAPPLE ENTERTAINMENT PRIVATE LIMITED",
"SILVERBIRCH MULTISPECIALITY HOSPITAL PRIVATE LIMITED",
"SILVERCASTLE HOLIDAYS AND RESORTS (INDIA) PRIVATE LIMITED",
"SILVERCAYDE INFOTECH PRIVATE LIMITED",
"SILVERCITY HEALTHCARE PRIVATE LIMITED",
"SILVERCLOUD STUDIOS PRIVATE LIMITED",
"SILVERCORD HOME FURNISHING PRIVATE LIMITED",
"SILVERDALE FASHIONS",
"SILVERDENE EXPORTS PRIVATE LIMITED",
"SILVEREDGE CORPORATE SERVICES PRIVATE LIMITED",
"SILVEREDGE TECHNOLOGIES PRIVATE LIMITED",
"SILVEREST INDUSTRIES PRIVATE LIMITED",
"SILVERFINE ART PRIVATE LIMITED",
"SILVERGATE ENGINEERING PRIVATE LIMITED",
"SILVERGLADES INFRASTRUCTURE PRIVATE. LIMITED.",
"SILVER-GOLD CASTINGS PVT LTD",
"SILVERGREY TECHNOLOGIES PRIVATE LIMITED",
"SILVERHEIGHTS HOTEL PRIVATE LIMITED",
"SILVERHILL SECURITIES & SERVICES INDIA PRIVATE LIMITED",
"SILVERHILLS EXPORTS (OPC) PRIVATE LIMITED",
"SILVERHILLS KNIT WEAR PRIVATE LIMITED",
"SILVERINTEGRATION PRIVATE LIMITED",
"SILVERITE POWER CONTROLS PRIVATE LIMITED",
"SILVERJET AEROPARTS PRIVATE LIMITED",
"SILVERLABS INDIA PRIVATE LIMITED",
"SILVERLAKE INFORMATION SYSTEMS PRIVATE LIMITED",
"SILVERLAND HOSPITALITY PRIVATE LIMITED",
"SILVERLEAF CAPITAL SERVICES PRIVATE LIMITED",
"SILVERLINE COLLECTIONS OPC PRIVATE LIMITED",
"SILVERLINE ELECRICALS PRIVATE LIMITED",
"SILVERLINE FASHION FABRICS LIMITED",
"SILVERLINE FERTILISERS PRIVATE LIMITED",
"SILVERLINE GLOBAL FREIGHT PRIVATE LIMITED",
"SILVERLINE GRAPHICS PRIVATE LIMITED",
"SILVERLINE HOLDINGS PVT LTD",
"SILVERLINE HOMES PRIVATE LIMITED",
"SILVERLINE LIGHTING & EXIM INDIA PRIVATE LIMITED",
"SILVERLINE MEDI TECH PRIVATE LIMITED",
"SILVERLINE METAL ENGINEERING PRIVATE LIMITED",
"SILVERLINE PAYAL PRIVATE LIMITED",
"SILVERLINE PLASTPACKS PVT LTD",
"SILVERLINE POWER INFRASTRUCTURE PRIVATE LIMITED",
"SILVERLINE PRESTIGE SCHOOL",
"SILVERLINE SYNTHETICS PVT. LTD.",
"SILVERLINE TAPES MANUFACTURING PVT LTD",
"SILVERLINES GEMS AND JEWELLERY PRIVATE. LIMITED.",
"SILVERLINK TECHNOLOGIES PRIVATE LIMITED",
"SILVERMAPLE HEALTHCARE SERVICES PRIVATE LIMITED",
"SILVERMILE CAPITAL PRIVATE LIMITED",
"SILVERMINE SOFTWARE INDIA PRIVATE LIMITED",
"SILVERPALACE HOTEL ORGANISERS PRIVATE LIMITED",
"SILVERPEAK GLOBAL PRIVATE LIMITED",
"SILVERPEARL TILES (I) PRIVATE LIMITED",
"SILVERPLUSH HOMES PRIVATE LIMITED",
"SILVERPOINT PRESS PRIVATE LIMITED",
"SILVERSAND INFRATECH PRIVATE LIMITED",
"SILVERSEAL ADHESIVE PRIVATE LIMITED",
"SILVERSEAS TRADING PRIVATE LIMITED",
"SILVERSEVEN MOTORS PRIVATE LIMITED",
"SILVERSHEEN INKS AND COATINGS PRIVATE LIMITED",
"SILVERSHINE STAINLESS PRIVATE LIMITED",
"SILVERSKILLS PRIVATE LIMITED",
"SILVERSON AGROCHEM PRIVATE LIMITED",
"SILVERSON DEVELOPERS PRIVATE LIMITED",
"SILVERSON OVERSEAS PRIVATE LIMITED",
"SILVERSPACE TECHNOLOGIES PRIVATE LIMITED",
"SILVERSTAR COMMUNICATIONS LIMITED",
"SILVERSTAR PLASTICS LTD",
"SILVERSTONE CRUSHERS AND MINERALS PRIVATE LIMITED",
"SILVERSTONE ELASTOMERS PRIVATE LIMITED",
"SILVERSTONE INFRASPACE PRIVATE LIMITED",
"SILVERSTONE INFRAVENTURES PRIVATE LIMITED",
"SILVERSTONE RUBBER INDIA PRIVATE LIMITED",
"SILVERSTONE TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"SILVERSTREAK CABLES PRIVATE LIMITED",
"SILVERSTREAM DEVELOPERS PRIVATE LIMITED",
"SILVERSYSTEM ENTERPRISES PRIVATE LIMITED",
"SILVERTECH COTSPIN PRIVATE LIMITED",
"SILVERTECH FIBERS PRIVATE LIMITED",
"SILVERTECH ISPAT PRIVATE LIMITED",
"SILVERTOAN PAPERS LIMITED",
"SILVERTON METALS PVT LTD",
"SILVERTON PULP AND PAPERS PRIVATE LIMITED",
"SILVERTONE GRAVU-FLEX PRIVATE LIMITED",
"SILVERTONE SOFTWARE PRIVATE LIMITED",
"SILVERTONE SYNTHETICS PVT. LTD",
"SILVERTONES SPECIALITY TEXTILES PRIVATE LIMITED",
"SILVERTOSS INDUSTRIES PRIVATE LIMITED",
"SILVERTOSS SECURITIES PRIVATE LIMITED",
"SILVERTOSS VANIJYA PRIVATE LIMITED",
"SILVERVIEW CAFE PRIVATE LIMITED",
"SILVERWATER METALS AND MINERALS PRIVATE LIMITED",
"SILVERWING ROADWAYS PRIVATE LIMITED",
"SILVERWIRE NETWORKS PRIVATE LIMITED",
"SILVERZONE FOUNDATION",
"SILVEX EXPORTS PRIVATE LIMITED",
"SILVIA REST PRIVATE LIMITED",
"SILVICS WOOD VENEERS PRIVATE LIMITED",
"SILWESTER TEXTILES PRIVATE LIMITED",
"SILWIN WINCHES INDIA PRIVATE LIMITED",
"SIM AGRO CHAIN",
"SIM AND SAM'S INDIA PRIVATE LIMITED",
"SIM DIAM PRIVATE LIMITED",
"SIM INFOSYSTEMS PRIVATE LIMITED",
"SIM JEWELLERY PRIVATE LIMITED",
"SIM PALM TECH INDIA PRIVATE LIMITED",
"SIM SOLUTIONS PRIVATE LIMITED",
"SIM TECHNOLOGIES PRIVATE LIMTED",
"SIM TRAVELS PRIVATE LIMITED",
"SIMA LABS PRIVATE. LIMITED WWW.SIMALAB.COM",
"SIMA MARINE INDIA PRIVATE LIMITED",
"SIMAI MANAGEMENT CONSULTING AND ANALYTICS PRIVATE LIMITED",
"SIMAL INTERNATIONAL PRIVATE LIMITED",
"SIMALIN CHEMICAL INDUSTRIES PRIVATE LIMITED",
"SIMAN STONES INTERNATIONAL PRIVATE LIMITED",
"SIMANCHAL CONSTRUCTION PRIVATE LIMITED",
"SIMANCHAL INFRATECH PRIVATE LIMITED",
"SIMANDHAR ALLUSHEET PRIVATE LIMITED",
"SIMANDHAR ELECTRO PRIVATE LIMITED",
"SIMANDHAR ENTERPRISES PRIVATE LIMITED",
"SIMANDHAR FABTEX PRIVATE LIMITED",
"SIMANDHAR FINLEASE PRIVATE LIMITED",
"SIMANDHAR HERBAL PRIVATE LIMITED",
"SIMANJO FOODS PRIVATE LIMITED",
"SIMANSI SOLUTIONS PRIVATE LIMITED",
"SIMAR ENTERPRISES PRIVATE LIMITED",
"SIMAR HOTEL AND RESORTS PRIVATE LIMITED",
"SIMAR INFRASTRUCTURES LIMITED",
"SIMAR PORT PRIVATE LIMITED",
"SIMAR PRIDE VENTURES LIMITED LIABILITY P ARTNERSHIP",
"SIMAR TECH CONSULTANTS PRIVATE LIMITED",
"SIMARA EXIM PRIVATE LIMITED",
"SIMAS EXPORTS PRIVATE LIMITED",
"SIMASH ADVISORS PRIVATE LIMITED",
"SIMAYA HR SERVICES PRIVATE LIMITED",
"SIMBA LOGISTICS PRIVATE LIMITED",
"SIMBA PROPERTIES LLP",
"SIMBA TOYS INDIA PRIVATE LIMITED",
"SIMBHAOLI POWER PRIVATE. LIMITED.",
"SIMBHAOLI SUGARS LIMITED",
"SIMBIOSYS BIOWARES INDIA PRIVATE LIMITED",
"SIMBROWN LABORATORIES PVT LTD",
"SIMBUS TECHNOLOGIES PRIVATE LIMITED",
"SIMCHEM PRIVATE LIMITED",
"SIMCO AUTO LIMITED",
"SIMCO GLOBAL TECHNOLOGY AND SYSTEM LIMITED",
"SIMCO MATERIALS INTERNATIONAL PRIVATE LIMITED",
"SIMCO PAINTS INDUSTRIES PRIVATE LIMITED",
"SIMCON DESIGNERS AND CONSULTANTS PRIVATE LIMITED",
"SIMCORP INDIA LLP",
"SIMEC INDUS RESOURCES PRIVATE LIMITED",
"SIMECTIVE ENGINEERS PRIVATE LIMITED",
"SIMEIO DEVELOPMENT CENTER PRIVATE LIMITED",
"SIMEN TECH (INDIA) PRIVATE LIMITED",
"SIMERO VITRIFIED PRIVATE LIMITED",
"SIMEX PROJECTS PRIVATE LIMITED",
"SIMFA LABS PRIVATE LIMITED",
"SIMFORM SOFTWARE LLP",
"SIMFORM SOLUTIONS PRIVATE LIMITED",
"SIMFRA FROZEN FOODS PRIVATE LIMITED",
"SIMGA REALTY PRIVATE LIMITED",
"SIMGROSYS CONSULTING SERVICES PRIVATE LIMITED",
"SIMHA MOTORS PRIVATE LIMITED",
"SIMHA SOLUTIONS PRIVATE LIMITED",
"SIMHADRI ENGINEERS & STEVEDORES PRIVATE LIMITED",
"SIMHADRI ENTERPRISES PRIVATE LIMITED",
"SIMHADRI POWER LIMITED",
"SIMHAPURI EXPRESSWAY LIMITED",
"SIMHAPURI FARMERS AGRI PARKS PRIVATE LIMITED",
"SIMHAPURI INFRA PROJECTS PRIVATE LIMITED",
"SIMHO HR SERVICES PRIVATE LIMITED",
"SIMI TRAVELS PRIVATE LIMITED",
"SIMIC ELECTRONICS PVT LTD",
"SIMILIA RESEARCH LABORATORY PRIVATE LIMITED",
"SIMINO HEALTHCARE PRIVATE LIMITED",
"SIMIRA HEALTHCARE PRIVATE LIMITED",
"SIMITRI INDIA PRIVATE LIMITED",
"SIMKEN CERAMIC PRIVATE LIMITED",
"SIMKRAFT SOLUTIONS PRIVATE LIMITED",
"SIMLA AUTOMOBILES PRIVATE LIMITED",
"SIMLA CHEMICALS PRIVATE LIMITED",
"SIMLA GOMTI PAN PRODUCTS PRIVATE LIMITED",
"SIMMERING FOODS & RESTAURANTS PRIVATE LIMITED",
"SIMMONDS MARSHALL LIMITED",
"SIMMONS RANA RACING PRIVATE LIMITED",
"SIMMRO INFRASTRUCTURE AND DEVELOPERS PRIVATE LIMITED",
"SIMMS ENGINEERING PRIVATE LIMITED",
"SIMMTRONICS INFOTECH PRIVATE LIMITED",
"SIMNOVUS TECH PRIVATE LIMITED",
"SIMO RESEARCH ENGINEERS PRIVATE LIMITED",
"SIMOCO SYSTEMS & INFRASTRUCTURE SOLUTIONS LIMITED",
"SIMOLA VITRIFIED PRIVATE LIMITED",
"SIMOLEX CERAMIC PRIVATE LIMITED",
"SIMON & SCHUSTER PUBLISHERS INDIA PRIVATE LIMITED",
"SIMON AND CAILAND PRIVATE LIMITED",
"SIMON AND SONS ITES SERVICES PRIVATE LIMITED",
"SIMON ELECTRIC PRIVTAE LIMITED",
"SIMON INDIA LIMITED",
"SIMONA INDIA PRIVATE LIMITED",
"SIMOND FIBERTECH LIMITED",
"SIMONE NATURALLY INSPIRED LIVING LLP",
"SIMONE VENTURES PRIVATE LIMITED",
"SIMONS SHIPPING PRIVATE LIMITED",
"SIMONY SYSTEMS & SOLUTIONS PRIVATE LIMITED",
"SIMOS PERIPHERALS PRIVATE LIMITED",
"SIMOSIS INTERNATIONAL PRIVATE LIMITED",
"SIMPA ENERGY INDIA PRIVATE LIMITED",
"SIMPAN CERAMIC PRIVATE LIMITED",
"SIMPARK INFRASTRUCT URE PRIVATE LIMITED",
"SIMPATICO E- SOLUTION PRIVATE LIMITED",
"SIMPEX ENGINEERING INDIA PRIVATE LIMITED",
"SIMPEX OVERSEAS PRIVATE LIMITED",
"SIMPEX PHARMA PRIVATE LIMITED",
"SIMPL INNOVATIVE BRANDS PRIVATE LIMITED",
"SIMPLADENT IMPLANT SOLUTIONS PRIVATE LIMITED",
"SIMPLAIN SOFTWARES INDIA PRIVATE LIMITED",
"SIMPLAST INDIA PRIVATE LIMITED",
"SIMPLAST POLYPACKS PRIVATE LIMITED",
"SIMPLE INTEGRAL PRIVATE LIMITED",
"SIMPLE LOGIC IT PRIVATE LIMITED",
"SIMPLE SILK MILLS PRIVATE LIMITED",
"SIMPLE TECHNOLOGY PRIVATE LIMITED",
"SIMPLEASE SOLUTIONS PRIVATE LIMITED",
"SIMPLEPLAN SOLUTIONS PRIVATE LIMITED",
"SIMPLESOLVE TECHNOLOGIES PRIVATE LIMITED",
"SIMPLETEC AUTOMATICS PVT LTD",
"SIMPLE-TECH AEROSPACE PRIVATE LIMITED",
"SIMPLEWORKS SOLUTIONS PRIVATE LIMITED",
"SIMPLEX CASTINGS LIMITED.",
"SIMPLEX CHEMICALS INDUSTRIES PRIVATE LIMITED",
"SIMPLEX CHEMOPACK PRIVATE LIMITED",
"SIMPLEX COKE AND REFRACTORY PRIVATE LIMITED",
"SIMPLEX CONCRETE PILES INDIA LIMITED",
"SIMPLEX ELECTRICAL ENGINEERING PRIVATE LIMITED",
"SIMPLEX ENGINEERING FOUNDRY WORKS LIMITED",
"SIMPLEX ESOLUTIONS PRIVATE LIMITED",
"SIMPLEX EXPORTS PRIVATE LIMITED",
"SIMPLEX EXTRUDER PVT. LTD.",
"SIMPLEX FINVEST PRIVATE LIMITED",
"SIMPLEX FORGE PRIVATE LIMITED",
"SIMPLEX INFRA DEVELOPMENT PRIVATE LIMITE D",
"SIMPLEX INFRASTRUCTURE TECHNOLOGY AND SERVICES PRIVATE LIMITED",
"SIMPLEX INSULATION PRIVATE LIMITED",
"SIMPLEX ISPAT UDYOG PRIVATE LIMITED",
"SIMPLEX MERCHANDISE PRIVATE LIMITED",
"SIMPLEX METAL PROCESSORS (INDIA) PRIVATE LIMITED",
"SIMPLEX MILLS",
"SIMPLEX OIL AND GAS CONSULTANCY PRIVATE LIMITED",
"SIMPLEX PACKAGING LIMITED",
"SIMPLEX PREFAB INFRASTRUCTURE INDIA PRIVATE LIMITED",
"SIMPLEX PROPERTIES & TRADING PRIVATE LIMITED",
"SIMPLEX REALTY LIMITED",
"SIMPLEX SWITCHGEAR PRIVATE LIMITED",
"SIMPLEX SYSCON PRIVATE LIMITED",
"SIMPLI5D TECHNOLOGIES PRIVATE LIMITED",
"SIMPLIANCE TECHNOLOGIES PRIVATE LIMITED",
"SIMPLIAXIS SOLUTIONS PRIVATE LIMITED",
"SIMPLICITY CREATIONS TECHNOLOGIES PRIVATE LIMITED",
"SIMPLICITY ENGINEERS PVT LTD",
"SIMPLICITY INVESTING INDIA PRIVATE LIMITED",
"SIMPLICITY LABS PRIVATE LIMITED",
"SIMPLICITY PROJECTS PVT LTD",
"SIMPLIFAI COGNITIVE SERVICES PRIVATE LIMITED",
"SIMPLIFIED COMMUNICATIONS PRIVATE LIMITED",
"SIMPLIFIED FINANCIAL SOLUTIONS PRIVATE LIMITED",
"SIMPLIFIED PROCUREMENT SERVICES PRIVATE LIMITED",
"SIMPLIFIED WOODCRAFTING SOLUTIONS PRIVATE LIMITED",
"SIMPLIFY ADVERTISING AND EVENT PRIVATE LIMITED",
"SIMPLIFY GROWTH RESEARCH & CONSULTING PRIVATE LIMITED",
"SIMPLIFY WELLNESS INDIA PRIVATE LIMITED",
"SIMPLIFY WORKFORCE TECHNOLOGIES PRIVATE LIMITED",
"SIMPLIFY360 INDIA PRIVATE LIMITED",
"SIMPLIFY3X SOFTWARE PRIVATE LIMITED",
"SIMPLINITY SOLUTIONS PRIVATE LIMITED",
"SIMPLION TECHNOLOGIES INDIA PRIVATE LIMITED",
"SIMPLISAFE SECURITY & ALLIED SERVICES PRIVATE LIMITED",
"SIMPLIV SERVICES INDIA PRIVATE LIMITED",
"SIMPLIWORK OFFICES PRIVATE LIMITED",
"SIMPLOGICS SOLUTIONS PRIVATE LIMITED",
"SIMPLON CERAMIC PRIVATE LIMITED",
"SIMPLOTEL TECHNOLOGIES PRIVATE LIMITED",
"SIMPLURIS TECHNOLOGIES PRIVATE LIMITED",
"SIMPLY ALGO FINTECH PRIVATE LIMITED",
"SIMPLY ELECTRIFYING PRIVATE LIMITED",
"SIMPLY FLYSMART PRIVATE LIMITED",
"SIMPLY GOLD PRIVATE LIMITED",
"SIMPLY GREEN INNOVATIONS PRIVATE LIMITED",
"SIMPLY LOGISTICS PRIVATE LIMITED",
"SIMPLY MONEY SERVICES PRIVATE LIMITED",
"SIMPLY ORGANIC PRIVATE LIMITED",
"SIMPLY TASTY FOODS AND BEVERAGES PRIVATE LIMITED",
"SIMPLY VYAPAR APPS PRIVATE LIMITED",
"SIMPLYBUY SOLUTIONS PRIVATE LIMITED",
"SIMPLYPHI SOFTWARE SOLUTIONS PRIVATE LIMITED",
"SIMPLYTRACK PRIVATE LIMITED",
"SIMPOLO VITRIFIED PRIVATE. LIMITED.",
"SIMPPLR SOFTWARE INDIA PRIVATE LIMITED",
"SIMPRAGMA SOLUTIONS PRIVATE LIMITED",
"SIMPROSYS INFOMEDIA",
"SIMPSOFT SOLUTIONS PRIVATE LIMITED",
"SIMPSON & CO. LIMITED",
"SIMPSON & GENERAL FINANCE COMPANY LIMITED",
"SIMPSON DRIVES AND CONTROLS PRIVATE LIMITED",
"SIMPSON SPENCE YOUNG INDIA PRIVATE LIMITED",
"SIMPTRA TECHNOLOGIES PRIVATE LIMITED",
"SIMRA CONTAINER LINES PRIVATE LIMITED",
"SIMRA INDUSTRIES PRIVATE LIMITED",
"SIMRAJ OVERSEAS PRIVATE LIMITED",
"SIMRAN AGRITECH PRIVATE LIMITED",
"SIMRAN AGROVET PRIVATE LIMITED",
"SIMRAN BIKES PRIVATE LIMITED",
"SIMRAN CUISINE PRIVATE LIMITED",
"SIMRAN ESTATES PRIVATE LIMITED",
"SIMRAN EXIM PRIVATE LIMITED",
"SIMRAN EXPORTS PRIVATE LIMITED",
"SIMRAN FARMS LIMITED.",
"SIMRAN FASHIONS PRIVATE LIMITED",
"SIMRAN FEEDS PRIVATE. LIMITED.",
"SIMRAN FISHERIES PRIVATE LIMITED.",
"SIMRAN FOOD INFRATECH LLP",
"SIMRAN FOOD PRIVATE LIMITED",
"SIMRAN FOODS PRIVATE LIMITED",
"SIMRAN FOREX & TRAVEL SERVICES PRIVATE LIMITED",
"SIMRAN HATCHERIES PRIVATE LIMITED",
"SIMRAN HOLIDAYS PRIVATE LIMITED",
"SIMRAN INDUSTRIES PRIVATE LIMITED",
"SIMRAN INFRACARE SERVICES PRIVATE LIMITED",
"SIMRAN INFRAPROJECT PRIVATE LIMITED",
"SIMRAN INTERNATIONAL EXPORT (INDIA) PRIVATE LIMITED",
"SIMRAN MANAGEMENT SERVIECES PRIVATE LIMI",
"SIMRAN MOTELS PRIVATE LIMITED",
"SIMRAN MOTORS PRIVATE LIMITED",
"SIMRAN NUTRIFOODS PRIVATE LIMITED",
"SIMRAN OUTSOURCING SERVICES PRIVATE LIMITED",
"SIMRAN TECHNOCRATS (INDIA) PRIVATE LIMITED",
"SIMRAN TRAVELS PRIVATE LIMITED",
"SIMRAN WHEELS PRIVATE LIMITED",
"SIMRI COLD STORAGE PRIVATE. LIMITED",
"SIMS GROUP OF INSTITUTIONS",
"SIMS PERFECT MAINTENANCE SERVICES PRIVATE LIMITED",
"SIMS RECYCLING SOLUTIONS INDIA PRIVATE LIMITED",
"SIMSAN EXIM & TRADING COMPANY PRIVATE LIMITED",
"SIMSO TEX SUBLIMATION PRINTING INDIA PRIVATE LIMITED",
"SIMSOL TECHNOLOGIES & SERVICES PRIVATE LIMITED",
"SIMSON DEVELOPERS PRIVATE LIMITED",
"SIMSON LIFE SCIENCES PRIVATE LIMITED",
"SIMSON PHARMA LIMITED",
"SIMSON SOFTWARES PRIVATE LIMITED",
"SIMSONA TECHNOLOGY PRIVATE LIMITED",
"SIMSTONE CERAMIC PRIVATE LIMITED",
"SIMTA CLEAR COATS PRIVATE LIMITED",
"SIMTECH CONSULTANTS PRIVATE LIMITED",
"SIMTECH IT SOLUTIONS PRIVATE LIMITED",
"SIMTEX INDUSTRIES PRIVATE LIMITED",
"SIMTO INVESTMENT CO LTD",
"SIMTRAD OVERSEAS PRIVATE. LIMITED.",
"SIMUBLADE TECHNOLOGY PRIVATE LIMITED",
"SIMULANIS SOLUTIONS PRIVATE LIMITED",
"SIMULBARIE TEA CO PVT LTD",
"SIMULI ENGINEERING SOLUTION PRIVATE LIMITED",
"SIMULTANEOUS GEOGRAPHICAL REALITY LABS PRIVATE LIMITED",
"SIMURG APPLIANCES PRIVATE LIMITED",
"SIMURG TRADERS PRIVATE LIMITED",
"SIMURISE LEARNING PRIVATE LIMITED",
"SIMYOG TECHNOLOGY PRIVATE LIMITED",
"SIMZEN PHARMACHEM PRIVATE LIMITED",
"SINAI MARITIME SERVICES PRIVATE LIMITED",
"SINALKAR PRIVATE LIMITED",
"SINAR INDAH PULP AND PAPER PRIVATE LIMITED",
"SINARMAS CHEMICALS PRIVATE LIMITED",
"SINARMAS DIGITAL PRIVATE LIMITED",
"SINASTA MARITIME PRIVATE LIMITED",
"SINAXIS ENTERPRISES PRIVATE LIMITED",
"SINCERA CONSULTING INDIA PRIVATE LIMITED",
"SINCERE ARCHITECTS ENGINEERS PRIVATE LIMITED",
"SINCERE DEVELOPERS PVT. LTD.",
"SINCERE INFRASTRUCTURE PRIVATE LIMITED",
"SINCERE MARKETING SERVICES PRIVATE LIMITED",
"SINCERE SYNDICATION AND CORPORATE SERVIC ES LLP",
"SINCERITY INNOVATION TECHNOLOGY INDIA PRIVATE LIMITED",
"SINCERPLUS INTERIOR PRIVATE LIMITED",
"SINCETELE INFO SOLUTIONS PRIVATE LIMITED",
"SINCLAIR TRADELINK PVT LTD",
"SINCLAIRS HOTELS LIMITED",
"SINCLUS ENGINEERING AND CONSULTING PRIVATE LIMITED",
"SINCLUS MARKETING SERVICES PRIVATE LIMITED",
"SINCO COMMUNICATION (INDIA) PRIVATE LIMITED",
"SINCON INFRASTRUCTURE PRIVATE LIMITED",
"SINCORE STEEL HOMEWARE PRIVATE LIMITED",
"SINCRO DIGITAL MARKETING (INDIA) PRIVATE LIMITED",
"SINCRON TECHNO INDIA PRIVATE LIMITED",
"SINDH FOOTWEAR PRIVATE LIMITED",
"SINDH RENEWABLE POWER PRIVATE LIMITED",
"SINDHANAI ARTIFICIAL INTELLIGENCE SYSTEMS PRIVATE LIMITED",
"SINDHANUR GANGAVATHI TOLLWAY PRIVATE LIMITED",
"SINDHAVI MULTISERVICES",
"SINDHI JEWELLERS PRIVATE LIMITED",
"SINDHI MODEL SENIOR SECONDARY SCHOOL",
"SINDHI MOTORS PRIVATE LIMITED",
"SINDHRAJ INFRACART PRIVATE LIMITED",
"SINDHU CARGO MOVERS",
"SINDHU DEGREE COLLEGE FOR WOMEN",
"SINDHU FARMS PVT LTD",
"SINDHU FLORAA PRIVATE LIMITED",
"SINDHU GAYATHRI KITCHEN EQUIPMENT PRIVATE LIMITED",
"SINDHU INDIA PRIVATE LIMITED",
"SINDHU MEMORIAL MADHYAMIK VIDYALAY",
"SINDHU ORGANICS PRIVATE LIMITED",
"SINDHU RESETTLEMENT CORPN LIMITED",
"SINDHU SPECIALITY CHEMICALS INDIA PRIVATE LIMITED",
"SINDHU TRADE LINKS LIMITED.",
"SINDHUDURGA RADIO DIAGNOSTIC CENTRE PRIVATE LIMITED",
"SINDHUJA EXPORTS PRIVATE LIMITED",
"SINDHUJA FOREX AND TRAVELS PRIVATE LIMITED",
"SINDHUJA HYDROCARBONS PRIVATE LIMITED",
"SINDHUJA IMPORTS PRIVATE LIMITED",
"SINDHUJA MICROCREDIT PRIVATE LIMITED",
"SINDHUR FORGE PRIVATE LIMITED",
"SINDHURI HOTELS AND RESORTS PRIVATE LIMITED",
"SINDHUSAGAR DREDGETECH PRIVATE LIMITED",
"SINDHWANI AGRO PRIVATE LIMITED",
"SINDHWANI METAL ENGINEERING PVT LTD",
"SINDIA STEELS LIMITED",
"SINDIA TEKNICS PRIVATE LIMITED",
"SINDICATUM RENEWABLE ENERGY INDIA PRIVATE LIMITED",
"SINDOORI MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"SINDU BUILDING EQUIPMENTS LIMITED",
"SINDUS HOSPITAL",
"SINDYA INFRASTRUCTURE DEVELOPMENT COMPANY PRIVATE LIMITED",
"SINE CLADDING SOLUTIONS PRIVATE LIMITED",
"SINE WAVE PRIVATE LIMITED",
"SINECERA IMPORT EXPORT PRIVATE LIMITED",
"SINECERA TEXTILES PRIVATE LIMITED",
"SINECOS PROFILES PRIVATE LIMITED",
"SINECYCLE TECHNOLOGIES PRIVATE LIMITED",
"SINEEDGE CONSULTING PRIVATE LIMITED",
"SINELAB TECHNOLOGIES PRIVATE LIMITED",
"SINENG ELECTRIC INDIA PRIVATE LIMITED",
"SINERCO POWER SYSTEMS PRIVATE LIMITED",
"SINETEC AUTOMATION PRIVATE LIMITED",
"SINEW DEVELOPERS PRIVATE. LIMITED.",
"SINEW NUTRITION PRIVATE LIMITED",
"SINEWAVE (REWA) ELECTRONICS PRIVATE LIMITED",
"SINEWAVE COMPUTER SERVICES PRIVATE LIMITED",
"SINEWAVE ENERGY SAVER PRIVATE LIMITED",
"SINEWAVE ENGINEERING PRIVATE LIMITED",
"SINEWAVE GENERATORS PRIVATE LIMITED",
"SINEWAVE POWER TECHNOLOGIES PRIVATE LIMITED",
"SINEX SYSTEMS PRIVATE LIMITED",
"SINEXCEL POWER TECHNOLOGY PRIVATE LIMITED",
"SING CHEUNG CO. PRIVATE LIMITED",
"SING N SMILE FASHION PRIVATE LIMITED",
"SING SYS SOFTWARE SERVICES PRIVATE LIMITED",
"SINGADE CONSTRUCTIONS & INFRASTRUCTURE PRIVATE LIMITED",
"SINGAL PROJECTS PRIVATE LIMITED",
"SINGAL SOLUTIONS PRIVATE LIMITED",
"SINGAL TRANSLINK PRIVATE LIMITED",
"SINGALS BUILDWELL (INDIA)LIMITED.",
"SINGALSONS GEM AND JEWELS PRIVATE LIMITED",
"SINGALSONS MARKETING PRIVATE LIMITED",
"SINGAN PROJECTS LIMITED",
"SINGAPANGA HEALTHCARE INDIA PRIVATE LIMI",
"SINGAPORE AIRLINES LIMITED",
"SINGAPORE INFOTECH INDIA PRIVATE LIMITED",
"SINGAPORE INTERNATIONAL SCHOOL",
"SINGAPORE INVESTCORP (INDIA) PRIVATE LIMITED",
"SINGAPORE SOURCING & TECHNOLOGY PRIVATE LIMITED",
"SINGAPORE TECHNOLOGIES ELECTRONICS LIMITED",
"SINGAPORE TELECOM INDIA PRIVATE LIMITED",
"SINGAPORE TOURISM BOARD",
"SINGAPORE WHITEFIELD INVESTMENTS (INDIA) PRIVATE LIMITED",
"SINGAPOREAN HOTELS PRIVATE LIMITED",
"SINGAPURASHIP PRODUCE (I) PRIVATE LIMITED",
"SINGARAM PILLAI GIRLS' HIGHER SECONDARY SCHOOL",
"SINGBHUM INDUSTRIES & ALLOYS PRIVATE LIMITED",
"SINGE SOLAR ENERGY PRIVATE LIMITED",
"SINGER",
"SINGER INDIA LIMITED",
"SINGERY MARINES PRIVATE LIMITED",
"SINGESWAR FOREX PRIVATE LIMITED",
"SINGH & SINGH LAW FIRM LLP",
"SINGH & SONS INFRAGREEN PRIVATE LIMITED",
"SINGH AGRITECH PRIVATE LIMITED",
"SINGH ASSET RECON SERVICES PRIVATE LIMITED",
"SINGH AUTO LINK PRIVATE LIMITED.",
"SINGH BRONZE POWDER PRIVATE LTD",
"SINGH BUILDESTATE PRIVATE LIMITED",
"SINGH BUILDHOMES PRIVATE LIMITED",
"SINGH CASUALS PRIVATE LIMITED",
"SINGH CONDEV PRIVATE LIMITED",
"SINGH CONSTECH PRIVATE LIMITED",
"SINGH CORPORATE SERVICES (OPC) PRIVATE LIMITED",
"SINGH CRUSHERS PRIVATE LIMITED",
"SINGH CYCLE AND MOTOR CO PRIVATE LIMITED",
"SINGH DIAMONDS",
"SINGH DRINKS ASSOCIATES PRIVATE LIMITED",
"SINGH ELECTROLYTIC COILS & CONDUCTERS PRIVATE LIMITED",
"SINGH ENGICON (INDIA) PRIVATE LIMITED",
"SINGH ENTERPRISES PRIVATE LIMITED",
"SINGH ERECTORS PRIVATE LIMITED",
"SINGH EXPORTS PRIVATE LIMITED",
"SINGH FINLEASE PRIVATE LIMITED",
"SINGH FURNCRAFT PRIVATE LIMITED",
"SINGH GUARD FORCE PRIVATE LIMITED",
"SINGH HINDUSTAN MARINE PRIVATE LIMITED",
"SINGH HOLDINGS PRIVATE LIMITED",
"SINGH HOTELS PRIVATE LIMITED",
"SINGH HYDRAULICS PRIVATE LIMITED",
"SINGH INDUSTRIES PRIVATE LIMITED",
"SINGH INFRATEL PRIVATE LIMITED",
"SINGH INTELLIGENCE SECURITY PRIVATE LIMITED",
"SINGH ISOTECH PRIVATE LIMITED",
"SINGH LIFE SCIENCE LIMITED",
"SINGH MANAGEMENT SERVICES PRIVATE LIMITED",
"SINGH MEHANDI INDUSTRIES PRIVATE LIMITED",
"SINGH MODELERS PRIVATE LIMITED",
"SINGH NATURAL RESOURCE PRIVATE LIMITED",
"SINGH PLASTICISERS AND RESINS (INDIA) PRIVATE LIMITED",
"SINGH POULTRY PRIVATE LIMITED",
"SINGH QUARRY EQUIPMENTS PRIVATE LIMITED",
"SINGH SAHIB MOTORS PRIVATE LIMITED",
"SINGH SECURITY PRIVATE LIMITED",
"SINGH SEMICONDUCTORS & SYSTEMS PRIVATE LIMITED",
"SINGH SKILL RECRUITMENT AGENCY PRIVATE LIMITED",
"SINGH SONS INDIA",
"SINGH TRANSPORTERS",
"SINGH UDYOG PRIVATE LIMITED",
"SINGH WHEELS INDIA PRIVATE LIMITED",
"SINGHA BATH CREATIONS PRIVATE LIMITED",
"SINGHA COMPONENTS PRIVATE LIMITED",
"SINGHAL AND SONS (INDIA) PVT LTD",
"SINGHAL BUILDHOME PRIVATE LIMITED",
"SINGHAL BUSINESS PRIVATE LIMITED",
"SINGHAL COMMODITIES PRIVATE. LIMITED.",
"SINGHAL EDIBLE PRODUCTS PRIVATE LIMITED",
"SINGHAL ELECTROCAST PRIVATE LIMITED",
"SINGHAL ENERGY PRIVATE LIMITED",
"SINGHAL STEEL & POWER PRIVATE LIMITED",
"SINGHAL EXIM PRIVATE LIMITED",
"SINGHAL FABRICS PRIVATE LIMITED",
"SINGHAL FINSTOCK PVT LTD",
"SINGHAL FORESTRY PRIVATE LIMITED",
"SINGHAL GRAH UDHYOG PRIVATE LIMITED",
"SINGHAL GRANITES PRIVATE LIMITED",
"SINGHAL HARDWARE & PAINTS PRIVATE LIMITED",
"SINGHAL INDUSTRIAL SCREWS PRIVATE LIMITED",
"SINGHAL INDUSTRIES PRIVATE LIMITED",
"SINGHAL INFOSYSTEMS PRIVATE LIMITED",
"SINGHAL IRON FOUNDRY PRIVATE LIMITED",
"SINGHAL ISPAT [INDIA] PVT LTD",
"SINGHAL LOHA TRADING PRIVATE LIMITED",
"SINGHAL METALLICS PRIVATE LIMITED",
"SINGHAL METALLOYS PRIVATE LIMITED",
"SINGHAL PAINTS PRIVATE LIMITED",
"SINGHAL PLYWOOD INDUSTRIES PRIVATE LIMITED",
"SINGHAL POWER PRESSES PRIVATE LIMITED",
"SINGHAL PRINT MEDIA PVT LTD",
"SINGHAL RICE & PULSES PRIVATE LIMITED",
"SINGHAL SINTERED PRIVATE LIMITED",
"SINGHAL SOLVENT LIMITED",
"SINGHAL SONS ELECTRONICS AGENCIES PRIVATE LIMITED",
"SINGHAL SPINTEX PRIVATE LIMITED",
"SINGHAL THERMOPACK PRIVATE LIMITED",
"SINGHAL TIMBERS PRIVATE LIMITED",
"SINGHAL VASTRAM PRIVATE LIMITED",
"SINGHAL VENTURES PRIVATE LIMITED",
"SINGHAM BIO CROP CARE PRIVATE LIMITED",
"SINGHAM SECURITY & SOLUTIONS PRIVATE LIMITED",
"SINGHANIA AND SONS PRIVATE LIMITED",
"SINGHANIA BUILDCON PRIVATE LIMITED",
"SINGHANIA CLOTHING PRIVATE LIMITED",
"SINGHANIA CORPORATION PRIVATE LIMITED",
"SINGHANIA EDUCATION SERVICES LIMITED",
"SINGHANIA FLEXO PACK PRIVATE LIMITED",
"SINGHANIA FOREX PRIVATE LIMITED",
"SINGHANIA FUTURE PRIVATE LIMITED",
"SINGHANIA INTERNATIONAL LIMITED",
"SINGHANIA LOGISTICS & DISTRIBUTION PRIVATE LIMITED",
"SINGHANIA MARBLES PRIVATE LIMITED",
"SINGHANIA MILK PRODUCTS PRIVATE LIMITED",
"SINGHANIA MINERALS PVT LTD",
"SINGHANIA MOTORS PRIVATE LIMITED",
"SINGHANIA PRINTERS PRIVATE LIMITED",
"SINGHANIA RESOURCES PRIVATE LIMITED",
"SINGHANIA SYSTEM TECHNOLOGISTS PRIVATE LIMITED",
"SINGHANIA TEA CO PVT LTD",
"SINGHANIA WAREHOUSING AND LOGISTICS PRIVATE LIMITED",
"SINGHBHUM MACHINO METAL PRIVATE LIMITED",
"SINGHBHUM TECHNOCAST PRIVATE LIMITED",
"SINGHI ADVISORS PRIVATE LIMITED",
"SINGHI GRANITES PVT.LTD.",
"SINGHI INDUSTRIES PRIVATE LIMITED",
"SINGHI INFRAPOWER PROJECTS PRIVATE LIMITED",
"SINGHI STEELS PRIVATE LIMITED",
"SINGHI SUNSHINE HOSPITAL PRIVATE LIMITED",
"SINGHLA AUTOTECH PRIVATE LIMITED",
"SINGHLA LAMINATES PRIVATE LIMITED",
"SINGHLAND MARKETING PRIVATE LIMITED",
"SINGHSON INTERNATIONAL PRIVATE LIMITED",
"SINGHSONS BAKERVILLE PRIVATE LIMITED",
"SINGHVAHINI INFRAPROJECTS PRIVATE LIMITED",
"SINGHVI CORPORATE SERVICES PRIVATE LIMITED",
"SINGHVI DEV & UNNI LLP",
"SINGHVI DEVELOPERS PRIVATE LIMITED",
"SINGHVI FASHIONS PRIVATE LIMITED",
"SINGHVI JEWELS PRIVATE LIMITED",
"SINGHVI MEDICARE AND RESEARCH CENTRE PVT. LTD.",
"SINGHVI PROCESSORS PRIVATE LIMITED",
"SINGLA AGROTECH PRIVATE LIMITED",
"SINGLA APPARELS PRIVATE LIMITED",
"SINGLA BUILDERS AND PROMOTERS LIMITED.",
"SINGLA COLLECTIONS PRIVATE LIMITED",
"SINGLA COMMUNICATIONS PRIVATE LIMITED",
"SINGLA CONSTRUCTIONS LIMITED",
"SINGLA ENGRAVURES PRIVATE LIMITED",
"SINGLA FORGING PRIVATE LIMITED",
"SINGLA GLOBAL NUTZ PRIVATE LIMITED",
"SINGLA INFRASTRUCTURE PRIVATE LIMITED",
"SINGLA KNIT FASHION PRIVATE LIMITED",
"SINGLA MOTORS PRIVATE. LIMITED.",
"SINGLA ORGANICS PRIVATE LIMITED",
"SINGLA PACKERS PRIVATE LIMITED",
"SINGLA RICE OIL & GEN. MILL",
"SINGLA STRIPS & TUBES PRIVATE LIMITED",
"SINGLA TIMBERS PRIVATE LIMITED",
"SINGLA WOOD PRODUCTS PRIVATE LIMITED",
"SINGLACHERRA TEA COMPANY PRIVATE LIMITED",
"SINGLAMEDICOS PHARMA PRIVATE LIMITED",
"SINGLAS RETAIL PRIVATE LIMITED",
"SINGLE POINT HR SOLUTIONS (INDIA) PRIVATE LIMITED",
"SINGLE POINT SECURITY SOLUTIONS PRIVATE LIMITED",
"SINGLE POINT TECHNOLOGIES PRIVATE LIMITED",
"SINGLESTORE INDIA PRIVATE LIMITED",
"SINGLETON CONSTRUCTIONS COMPANY PRIVATE LIMITED",
"SINGODIA ELECTRONICS PRIVATE LIMITED",
"SINGODWALA FINTECH PRIVATE LIMITED",
"SINGODWALA WAREHOUSING AND LOGISTICS PRIVATE LIMITED",
"SINGRAULI FINLEASE PRIVATE LIMITED",
"SINGRAULI HOSPITAL PRIVATE LIMITED",
"SINGRAULI MINERAL PRODUCTS PRIVATE LIMITED",
"SINGRODIA BROS HOLDING PRIVATE LIMITED",
"SINGTAM BUILDWELL PRIVATE LIMITED",
"SINGTEL GLOBAL (INDIA) PRIVATE LIMITED\n",
"SINGULAR HEALTH PRIVATE LIMITED",
"SINGULARITY AUTOMATION PRIVATE LIMITED",
"SINGULARITY CREDITWORLD PRIVATE LIMITED",
"SINGULARITY FURNITURE PRIVATE LIMITED",
"SINGULARITY HOLDINGS LIMITED",
"SINGULARITY LABS PRIVATE LIMITED",
"SINGULARITY VENTURES PRIVATE LIMITED",
"SINGULARIUM TECHNOLOGIES PRIVATE LIMITED",
"SINGUR COLD STORAGE PVT LTD",
"SINGX CROSS BORDER SOLUTIONS PRIVATE LIMITED",
"SINHA AUTO SALES & SERVICES PRIVATE LIMITED",
"SINHA COLD STORAGE & WAREHOUSE COMPANY PRIVATE LIMITED",
"SINHA CREATION PRIVATE LIMITED",
"SINHA INFRATECH PRIVATE LIMITED",
"SINHA INSULATED CABLES PRIVATE LIMITED",
"SINHA MULTILEVEL MARKETING PRIVATE LIMITED",
"SINHAGAD PHARMA PRIVATE LIMITED",
"SINHAL METAL INDUSTRIES LIMITED",
"SINHAL NUTRITIONS PRIVATE LIMITED",
"SINHASI CONSULTANTS PRIVATE LIMITED",
"SINHGAD COLLEGE OF ENGINEERING",
"SINHGAD SPRING DALE PUBLIC SCHOOL",
"SINHGAD TECHNICAL EDUCATION SOCIETY PUNE",
"SINHOP ENGINEERING CONSULTANTS PRIVATE LIMITED",
"SINHOTIA METALS & MINERALS PRIVATE LIMITED",
"SINI DESIGNS PRIVATE LIMITED",
"SINICON CONTROLS PVT LTD",
"SINJAN SOLUTIONS PRIVATE LIMITED",
"SINJHA INTERNATIONAL PRIVATE LIMITED",
"SINKHAI HEALTHCARE LIMITED",
"SINKO MILLSTONES PRIVATE LIMITED",
"SINLEY TRADE PRIVATE LIMITED",
"SINMADO ENGINEERING (INDIA) PRIVATE LIMITED",
"SINMEC ENGINEERING SERVICES INDIA PRIVATE LIMITED",
"SINNAR BIDI UDYOG LIMITED",
"SINNI POLYMERS PRIVATE LIMITED",
"SINNOR INDIA INSTRUMENTS PRIVATE LIMITED",
"SINO CARE SURGICALS PRIVATE LIMITED",
"SINO IMPORT AND EXPORTS PRIVATE LIMITED",
"SINO INDIA ETAIL PRIVATE LIMITED",
"SINO INDIA TEXTILES PRIVATE LIMITED",
"SINOCHEM INDIA COMPANY PRIVATE LIMITED",
"SINODIA HEALTHCARE PRIVATE LIMITED",
"SINOEA TECHNOLOGICAL ENGINEERING (INDIA) PRIVATE LIMITED",
"SINOPHARM INDIA PRIVATE LIMITED",
"SINOSEF ENTERPRISES PRIVATE LIMITED",
"SINOSTEEL INDIA PRIVATE LIMITED",
"SINOTRANS INDIA PRIVATE LIMITED",
"SINQ BEVERAGES PRIVATE LIMITED",
"SINSAN PHARMACEUTICALS PRIVATE LIMITED",
"SINSIL INTERNATIONAL PRIVATE LIMITED",
"SINTBUSH (INDIA) PVT LTD",
"SINTECH MACHINERY PRIVATE LIMITED",
"SINTECH PRECISION PRODUCTS LIMITED",
"SINTERCOM INDIA LIMITED",
"SINTERING SOLUTIONS PRIVATE LIMITED",
"SINTO BHARAT MANUFACTURING PRIVATE LIMITED",
"SINTONIK EQUIPMENTS PRIVATE LIMITED",
"SINTRON ELECTRONICS PRIVATE LIMITED",
"SINTRON POLYMERS PRIVATE LIMITED",
"SINU POLYMERS PRIVATE LIMITED",
"SIOM REALTY PRIVATE LIMITED",
"SION CERAMICS PRIVATE LIMITED",
"SION FINANCE AND LEASING PVT LTD",
"SION GARAGE PRIVATE LIMITED",
"SION SEMICONDUCTORS PRIVATE LIMITED",
"SION STEELS",
"SIONA PLASTO (INDIA) PRIVATE LIMITED",
"SIONA SYSTEMS AND SOLUTIONS PRIVATE LIMITED",
"SIONC PHARMACEUTICALS PRIVATE LIMITED",
"DAVIES ADVISORS INDIA PRIVATE LIMITED",
"SIORA SURGICALS PRIVATE.LIMITED",
"SIOS INDIA PRIVATE LIMITED",
"SIP GLOBAL CORPORATE PRIVATE LIMITED",
"SIP MOULDS PRIVATE LIMITED",
"SIP SEFAL INDIA PHARMACEUTICALS",
"SIP TECHNOLOGIES & EXPORTS LIMITED",
"SIPA INDIA PRIVATE LIMITED",
"SIPAL TECHNOLOGIES INDIA PRIVATE LIMITED",
"SIPANI ENERGY LIMITED",
"SIPANI FIBRES LIMITED",
"SIPANI INFRASTRUCTURE PRIVATE LIMITED",
"SIPANI PROPERTIES PRIVATE LIMITED",
"SIPANI SOFT STONES PRIVATE LIMITED",
"SIPANI WOOLLEN MILLS PRIVATE LIMITED",
"SIPAT TRANSMISSION LIMITED",
"SIPERA SYSTEMS PRIVATE LIMITED",
"SIPHON ENGINEERING PRIVATE LIMITED",
"SIPHON REFRACTORIES PRIVATE LIMITED",
"SIPL PLYWOOD PRIVATE LIMITED",
"SIPL PRIVATE LIMITED",
"SIPL TEXTILES PRIVATE LIMITED",
"SIPLEC INTERNATIONAL LIMITED",
"SIPLY SERVICES PRIVATE LIMITED",
"SIPOREX INDIA PRIVATE LIMITED",
"SIPOTECH LIGHT PRIVATE LIMITED",
"SIPPING SPIRITS PRIVATE LIMITED",
"SIPR FASHION PRIVATE LIMITED",
"SIPRA ENGINEERS PRIVATE LIMITED",
"SIPRA LABS LIMITED",
"SIPRA POWER TECHNOLOGIES PRIVATE LIMITED",
"SIPRA SERVICES AND INVESTMENTS PRIVATE LIMITED",
"SIPRA SURGI-MED PRIVATE LIMITED",
"SIQSESS TECHNOLOGY INDIA PRIVATE LIMITED",
"SIR BIO TECH INDIA PRIVATE LIMITED",
"SIR C R REDDY COLLEGE OF ENGINEERING",
"SIR CHHOTU RAM INSTITUTE OF ENGINEERING AND TECHNOLOGY",
"SIR CHOTU RAM HOSPITAL AND RESEARCH CENTRE",
"SIR GANGA RAM HOSPITAL",
"SIR H N HOSPITAL",
"SIR H N HOSPITAL TRUST",
"SIR H N RELIANCE FOUNDATION HOSPITAL AND RESEARCH CENTRE",
"SIR HURKISANDAS NURROTUMDAS HOSPITAL",
"SIR J J COLLEGE OF ARCHITECTURE MUMBAI",
"SIR J J FORT BOYS HIGH SCHOOL",
"SIR J J GROUP OF HOSPITAL",
"SIR J J SCHOOL OF ART MUMBAI",
"SIR J P COLLEGE OF EDUCATION & RESEARCH (B ED)",
"SIR JACOB SASSOON HIGH SCHOOL",
"SIR L S K GROUP",
"SIR M V PU COLLEGE",
"SIR M VISVESVARAYA INSTITUTE OF TECHNOLOGY",
"SIR MUTHA SCHOOL",
"SIR PADAMPAT SINGHANIA EDUCATION CENTRE",
"SIR PADAMPAT SINGHANIA UNIVERSITY",
"SIR PADAMPAT SINGHHANIA SCHOOL",
"SIR SAHABJI MAHARAJ MILLS LIMITED",
"SIR SAYAJIRAO GENERAL HOSPITAL",
"SIR SAYYED MARATHI PRI SCHOOL",
"SIR SIVASWAMI KALALAYA HIGHER SECONDARY SCHOOL",
"SIR SYED PUBLIC SCHOOL",
"SIR TAKHTASINHJI GENERAL HOSPITAL",
"SIR VITHTHALDAS DAMODARDAS THAKERSY GIRLS HIGH SCHOOL",
"SIRAHU TECHNOLOGIES PRIVATE LIMITED",
"SIRAJ MEMORIAL HOSPITAL & DIAGNOSTIC CENTER",
"SIRAJUL ULOOM NISWAN COLLEGE ALIGARH VIDHYANT",
"SIRAK PHARMACEUTICALS PRIVATE LIMITED",
"SIRANSKN RESEARCH AND MARKETING SOLUTIONS PRIVATE LIMITED",
"SIRAS ENGINEERING PRIVATE LIMITED",
"SIRASIA TECHNOLOGIES PRIVATE LIMITED",
"SIRAZEE TILES PRIVATE LIMITED",
"SIRCA PAINTS INDIA LIMITED",
"SIRCLETECH LABS PRIVATE LIMITED",
"SIREENA ROCKS PRIVATE LIMITED",
"SIREESH AUTO PRIVATE LIMITED",
"SIREESHA GEO GRANITE PRIVATE LIMITED",
"SIRENA LABS PRIVATE LIMITED",
"SIRENA TECHNOLOGIES PRIVATE LIMITED",
"SIRF HUM TUM FOODS PRIVATE LIMITED",
"SIRHA CONSTRUCTION AND DEVELOPERS PRIVATE LIMITED",
"SIRI AB INDIA PRIVATE LIMITED",
"SIRI AGRO INDUSTRIES PRIVATE LIMITED",
"SIRI BREEDERS PRIVATE LIMITED",
"SIRI CHANDANA AUTOMOTIVES PRIVATE LIMITED",
"SIRI CHEMICALS PRIVATE LIMITED",
"SIRI CONSTRUCTIONS INFRASTRUCTURE PRIVATE LIMITED",
"SIRI ECO STAY PRIVATE LIMITED",
"SIRI ENGINEERING CONTRACTORS",
"SIRI HOSPITALS",
"SIRI IT SOLUTIONS PRIVATE LIMITED",
"SIRI LAXMI SAI CONSTRUCTION PRIVATE LIMITED",
"SIRI MAHALINGESWAR HOTELS PRIVATE LIMITED",
"SIRI MAHARAJA GRANITES PRIVATE LIMITED",
"SIRI MALLE INFRA DEVELOPERS PRIVATE LIMITED",
"SIRI RAM SYAL HYDRO POWER PRIVATE LIMITED",
"SIRI SAMPADA INFRASTRUCTURE PRIVATE LIMITED",
"SIRI SEEDS (INDIA) PRIVATE LIMITED",
"SIRI SHELTERS PRIVATE LIMITED",
"SIRI SMELTERS & ENERGY PRIVATE LIMITED",
"SIRI SURGICAL PARTS PRIVATE LIMITED",
"SIRI TECON",
"SIRIA ELEMET PRIVATE LIMITED",
"SIRIAN OVERSEAS EDUCARE PRIVATE LIMITED",
"SIRICON INDUSTRIAL MANAGEMENT SERVICES PRIVATE LIMITED",
"SIRIDAO BEACH RESORTS PVT LTD",
"SIRIGIRI PLAST PRIVATE LIMITED",
"SIRIMIRI NUTRITION FOOD PRODUCTS PRIVATE LIMITED",
"SIRINA HEALTHCARE SERVICES PRIVATE LIMITED",
"SIRINITI TECHSOURCE PRIVATE LIMITED",
"SIRIO INDIA INDUCTIVE COMPONENTS PRIVATE LIMITED",
"SIRION LABS PRIVATE LIMITED.",
"SIRIS AGRO LIMITED",
"SIRIS FACILITY SERVICES PRIVATE LIMITED",
"SIRISHA HOMES PRIVATE LIMITED",
"SIRISHA PROJECTS PRIVATE LIMITED",
"SIRITEK TECHNOLOGIES PRIVATE LIMITED",
"SIRITEL SYSTEMS PRIVATE LIMITED",
"SIRIUM CERAMIC PRIVATE LIMITED",
"SIRIUS EMBEDDED SOFTWARE PRIVATE LIMITED",
"SIRIUS ENGINEERING PRIVATE LIMITED",
"SIRIUS FASHION PRIVATE LIMITED",
"SIRIUS FINANCIAL SERVICES PRIVATE LIMITED",
"SIRIUS FOODS PRIVATE LIMITED",
"SIRIUS GLOBAL LIMITED",
"SIRIUS MINERALS INDIA PRIVATE LIMITED",
"SIRIUS SECURITIES PRIVATE LIMITED",
"SIRIUS SOLAR ENERGY SYSTEMS PRIVATE LIMITED",
"SIRIUS ZIP FASTENERS PRIVATE LIMITED",
"SIRIWIN AUTO SPARES INDUSTRY",
"SIRJON CONSTRUCTIONS PRIVATE LIMITED",
"SIRMA BUSINESS CONSULTING (INDIA) PRIVATE LIMITED",
"SIRMAUR HOTELS PRIVATE LIMITED",
"SIRMAUR SOAPS AND ALLIED PRODUCTS PRIVATE LIMITED",
"SIRMAX ENGINEERING INDIA PRIVATE LIMITED",
"SIRMAXO CHEMICALS PRIVATE LIMITED",
"SIRMOUR REMEDIES PRIVATE LIMITED",
"SIRMOUR RETREAT PRIVATE LIMITED",
"SIRMOUR SMALL HYDRO POWER PRIVATE LIMITED",
"SIRMOUR STEEL METALLOYS PRIVATE LIMITED",
"SIRO CLINPHARM PRIVATE LIMITED",
"SIROCCO HOTELS PRIVATE LIMITED",
"SIROCCO PRESSING PRIVATE LIMITED",
"SIROHI CHEMTECH PRIVATE LIMITED",
"SIROHI COLONIZERS PRIVATE LIMITED",
"SIROHI INVESTMENT PRIVATE LIMITED",
"SIROHI MEDICAL CENTRE PRIVATE LIMITED",
"SIRONA DENTAL SYSTEMS PRIVATE LIMITED",
"SIRONA DIAGNOSTICS PRIVATE LIMITED",
"SIRONA HYGIENE PRIVATE LIMITED",
"SIRONJ CROPS PRODUCERS COMPANY PRIVATE LIMITED",
"SIROT SEED & CHEMICAL PRIVATE LIMITED",
"SIRS POLO ENTERPRISES PRIVATE LIMITED",
"SIRSA FELTS PRIVATE LIMITED",
"SIRSAI INDUSTRIES PRIVATE LIMITED",
"SIRSEJ INTERIOR PRIVATE LIMITED",
"SIRSI CRITICAL CARE UNIT PRIVATE LIMITED",
"SIRTAJ CONSTRUCTIONS PRIVATE LIMITED",
"SIRTAJ FARM FRESH PRODUCTS LIMITED",
"SIRUS BIOCARE PRIVATE LIMITED",
"SIRUS ELECTRONET INDIA PRIVATE LIMITED",
"SIRUS GREEN INDUSTRIES PRIVATE LIMITED",
"SIRUVAPURI MURUGAN INDUSTRIAL AND LOGISTICS PRIVATE LIMITED",
"SIRVEEN CONTROLS SYSTEMS PRIVATE LIMITED",
"SIRWAR RENEWABLE ENERGY PRIVATE LIMITED",
"SIS ALARM MONITORING AND RESPONSE SERVICES PRIVATE LIMITED",
"SIS BUSINESS SUPPORT SERVICES AND SOLUTIONS PRIVATE LIMITED",
"SIS CASH SERVICES PRIVATE LIMITED",
"SIS FACILITIES INDIA PRIVATE LIMITED",
"SIS FACILITY SERVICES PRIVATE LIMITED",
"SIS INFOTECH PRIVATE LIMITED",
"SIS INTERLOGISTICS INDIA PRIVATE LIMITED",
"SIS LIMITED",
"SIS ORTHO PRIVATE LIMITED",
"SIS PREP PRIVATE LIMITED",
"SIS PROSEGUR CASH LOGISSTICS PRIVATE LIMITED",
"SIS PROSEGUR HOLDINGS PRIVATE LIMITED",
"SIS SOFTWARE INDIA PRIVATE LIMITED",
"SIS TELE SERVICES PRIVATE LIMITED",
"SISA CONSULTANTS LLP",
"SISA INFORMATION SECURITY PRIVATE LIMITED",
"SISAH TECHNOLOGIES PRIVATE LIMITED",
"SISAI FIBRES PRIVATE LIMITED",
"SISAM CERAMICS PRIVATE LIMITED",
"SISCASO PRIVATE LIMITED",
"SISCO INDUSTRIES LIMITED",
"SISCO LATEX PRIVATE LIMITED",
"SISCO RESEARCH LABORATORIES PRIVATE LIMITED",
"SISCON INDIA PVT LTD",
"SISECAM FLAT GLASS INDIA LIMITED",
"SISEONG INDIA GLOBAL PRIVATE LIMITED",
"SISH MULTYFAB PRIVATE LIMITED",
"SISHIR CONDEV PRIVATE LIMITED",
"SISHODIA RESEARCH LABORATORIES PRIVATE LIMITED",
"SISHU INTERNATIONAL PRIVATE LIMITED",
"SISHYA MATRICULATION HIGHER SECONDARY SCHOOL",
"SISHYA SCHOOL",
"SISIRABHA PROPERTIES PRIVATE LIMITED",
"SISKAA CHEMICALS LIMITED",
"SISKO CONSILIO (OPC) PRIVATE LIMITED",
"SISKO WORLDWIDE LOGISTICS INDIA PRIVATE LIMITED",
"SISKON VENTURES PRIVATE LIMITED",
"SISL INFOTECH PRIVATE LIMITED",
"SISLAX PHARMA PRIVATE LIMITED",
"SISMANAGE INTEGRATED SOLUTIONS PRIVATE LIMITED",
"SISMATIX SYSTEMS PRIVATE LIMITED",
"SISMCA BUILDERS PRIVATE LIMITED",
"SISNE POLYMERS PRIVATE LIMITED",
"SISO COSMETICS PRIVATE LIMITED",
"SISO SOFTWARE'S INDIA PRIVATE LIMITED",
"SISOC SEMICONDUCTOR TECHNOLOGIES PRIVATE LIMITED",
"SISODIA AUTOMOBILES PRIVATE LIMITED",
"SISODIYA SUPERCLAN PRIVATE LIMITED",
"SISQO ENGINEERING PRIVATE LIMITED",
"SISRB TECHNOLOGIES PRIVATE LIMITED",
"SISTEMA SHYAM TELESERVICES LIMITED",
"SISTEMA SMART TECHNOLOGIES LIMITED",
"SISTER NIVEDITA UNIVERSITY",
"SISTERS FOODCRAFT PRIVATE LIMITED",
"SISTLA INFRASTRUCTURES PRIVATE LIMITED",
"SISU HOSPITAL INDIA LIMITED",
"SISUM HEALTHCARE PRIVATE LIMITED",
"SIT FLEXIBLE HOSE PRIVATE LIMITED",
"SITA AGRO TECH PRIVATE. LIMITED.",
"SITA ALLOYS PRIVATE LIMITED",
"SITA APPAREL PRIVATE LIMITED",
"SITA CEMENT LTD",
"SITA CORP INDIA PRIVATE LIMITED",
"SITA CREATION PRIVATE LIMITED",
"SITA FASHIONS PRIVATE LIMITED",
"SITA FINE ARTS PRIVATE LIMITED",
"SITA HOMES PRIVATE LIMITED",
"SITA INDUSTRIAL PRODUCTS PRIVATE LIMITED",
"SITA INFORMATION NETWORKING COMPUTING (INDIA) PRIVATE LIMITED",
"SITA INVESTMENT COMPANY LIMITED",
"SITA KOOLINGS PRIVATE LIMITED",
"SITA NIWAS PVT LTD",
"SITA PETROCHEM PRIVATE LIMITED",
"SITA PLANTATIONS PRIVATE LIMITED",
"SITA POLYWEAVE PRIVATE LIMITED",
"SITA RAM AND COMPANY PRIVATE LIMITED",
"SITA RAM COMPUTECH PRIVATE LIMITED",
"SITA RAM FEROZI LALL JAIN PRIVATE LIMITED",
"SITA RAM SALES PRIVATE LIMITED",
"SITA RIDERS PRIVATE LIMITED",
"SITA SHELTERS PRIVATE LIMITED",
"SITABARI AGRO PRODUCER COMPANY LIMITED",
"SITAC KABINI RENEWABLES PRIVATE LIMITED",
"SITAC RE PRIVATE LIMITED",
"SITAC RENEWABLE ENERGY PRIVATE LIMITED",
"SITAL LEASING AND FINANCE LTD",
"SITAL SOAP PACKAGING PRIVATE LIMITED",
"SITALA RETAIL PRIVATE LIMITED",
"SITAMANI ORGANIC PVT LTD",
"SITANCHAL CONSULTANTS LLP",
"SITANI COAL TRANSPORT PRIVATE LIMITED",
"SITANI COMMERCIAL PRIVATE LIMITED",
"SITAPUR MILK AND FOODS PRIVATE LIMITED",
"SITAPUR SUGAR INDUSTRIES PRIVATE LIMITED",
"SITAPURAM POWER LIMITED",
"SITARA COATINGS INDIA PRIVATE LIMITED",
"SITARA DIAMOND PRIVATE LIMITED",
"SITARA DIGITAL VENTURES PRIVATE LIMITED",
"SITARA JEWELLERY PRIVATE LIMITED",
"SITARA PROPERTIES PRIVATE LIMITED",
"SITARA SHIPPING LIMITED",
"SITARA SOLAR ENERGY PRIVATE LIMITED",
"SITARAM AGRO PRODUCTS PRIVATE LIMITED",
"SITARAM AYURVEDA PRIVATE LIMITED",
"SITARAM BHARTIA INSTITUTE OF SCIENCE & RESEARCH",
"SITARAM BHARTIA INSTITUTE OF SCIENCE AND RESEARCH",
"SITARAM BRICKS PRIVATE LIMITED",
"SITARAM BUILDERS",
"SITARAM CREATION PRIVATE LIMITED",
"SITARAM DENIMS INDIA LIMITED",
"SITARAM ENERGY AND LOGISTICS LIMITED.",
"SITARAM GEMS",
"SITARAM INDIA LIMITED",
"SITARAM INFRAPROJECT PRIVATE LIMITED",
"SITARAM INVESTMENT LIMITED",
"SITARAM IRON AND STEEL PRIVATE LIMITED",
"SITARAM MULTIPORTS INDIA PRIVATE LIMITED",
"SITARAM NANDRAM AGRO PRIVATE LIMITED",
"SITARAM POLYPLAST PRIVATE LIMITED",
"SITARAM PRAKASH HIGH SCHOOL",
"SITARAM PRINTS PVT LTD",
"SITARAM RICE MILL PRIVATE LIMITED",
"SITARAM SILK MILLS PRIVATE LIMITED",
"SITARAM SOMANI AND SONS SAREES PRIVATE LIMITED",
"SITARAM SPINNERS PRIVATE. LIMITED.",
"SITARAM SUGARS AND ALLIED INDUSTRIES LIMITED",
"SITARAMSON INDUSTRIES PRIVATE LIMITED",
"SITARE FOUNDATION NG0",
"SITASHRI TRADING AND FINANCE PRIVATE LIMITED.",
"SITAWAR STEEL PRIVATE LIMITED",
"SITE - N - SIGN MEDIA NETWORK PRIVATE LIMITED",
"SITE CONCEPTS PRIVATE LIMITED",
"SITEC LABS LIMITED",
"SITEC LABS PRIVATE LIMITED",
"SITEC TECHNOLOGIES PRIVATE LIMITED",
"SITECH ENGINEERS PRIVATE LIMITED",
"SITECORE INDIA PRIVATE LIMITED",
"SITEMINDER (INDIA) PRIVATE LIMITED",
"SITES LEARNING INDIA PRIVATE LIMITED",
"SITESUPPLY INFRATECH PRIVATE LIMITED",
"SITHARA PLASTICS PRIVATE LIMITED",
"SITI CABLE NETWORK LIMITED",
"SITI ENERGY LIMITED",
"SITI VISION MARKETING PRIVATE LIMITED",
"SITKA MERCANTILE PRIVATE LIMITED",
"SITRA INFOTECH PRIVATE LIMITED",
"SITRIX ADVANCED MATERIALS PRIVATE LIMITED",
"SITRONICS INTRACOM INDIA PRIVATE LIMITED",
"SITS EXPRESS PRIVATE LIMITED",
"SITS INFO-SOLUTIONS PRIVATE LIMITED",
"SITSON INDIA LIMITED",
"SITSON INDIA PRIVATE LIMITED",
"SITUATIONS ADVERTISING AND MARKETING SERVICES PVT LTD",
"SITUSAMC INDIA PRIVATE LIMITED",
"SIVA AUTOMOTIVE TRADING PRIVATE LIMITED",
"SIVA BUSINESS MANAGEMENT SERVICES PRIVATE LIMITED",
"SIVA CITY CENTER PRIVATE LIMITED",
"SIVA CIVIL AND STRUCTURALS PRIVATE LIMITED",
"SIVA COMPLETE SOLUTIONS PRIVATE LIMITED",
"SIVA ELECTRIC GENERATION PRIVATE LIMITED",
"SIVA ELECTRONICA INDIA PVT LTD",
"SIVA ENERGY INFRASTRUCTURE PRIVATE LIMITED",
"SIVA ENT HEAD NECK HOSPITAL",
"SIVA FOODS IMPEX PRIVATE LIMITED",
"SIVA INOTEC LIMITED",
"SIVA SAI EXPORTS",
"SIVA SAKTHI WATER JET CUTTING PRIVATE LIMITED",
"SIVA SANKAR MOTORS PRIVATE LIMITED",
"SIVA SIVANI GROUP OF INSTITUTIONS",
"SIVA TECHNICAL SERVICES PRIVATE LIMITED",
"SIVA VAISHNAVI MARINE PRIVATE LIMITED SVMPL",
"SIVA VALLI VILAS JEWELLERS PRIVATE LIMITED",
"SIVA WINDTURBINE INDIA PRIVATE LIMITED",
"SIVAANI AGRIBUSINESS PRIVATE LIMITED",
"SIVACERULEAN TECHNOLOGIES PRIVATE LIMITED",
"SIVADHARSAN SIZING PRIVATE LIMITED",
"SIVADHARSHINI PAPERS PRIVATE LIMITED",
"SIVAGURU SPINNING MILLS PRIVATE LIMITED",
"SIVAKASI HINDU NADARS' GIRLS SCHOOL COMMITTEE",
"SIVALIK ENTERPRISES PRIVATE LIMITED",
"SIVALTECH PRIVATE LIMITED",
"SIVAM JEWELLERS PRIVATE LIMITED",
"SIVAM REMEDIES PRIVATE LIMITED",
"SIVAN SECURITIES PRIVATE LIMITED",
"SIVAN SEEDS PRIVATE LIMITED",
"SIVANA INSURANCE BROKERS PRIVATE LIMITED",
"SIVANA STEEL AND POWER PRIVATE LIMITED",
"SIVANANDHA MILLS LIMITED",
"SIVANANDHA PIPE FITTINGS LIMITED",
"SIVANDANA COMMERCIAL COMPNAY PRIVATE LIMITED",
"SIVANI PUMPS AND SYSTEMS PRIVATE LIMITED",
"SIVANSSH INFRASTRUCTURE DEVELOPMENT PRIVATE LIMITED",
"SIVANTA FLEXI PACK PRIVATE LIMITED",
"SIVANTA ROOFING PRIVATE LIMITED",
"SIVANTA SPUNTEX PRIVATE LIMITED",
"SIVANTHI JOE POLYMERS PRIVATE LIMITED",
"SIVANTHI JOE SUBSTRATES PRIVATE LIMITED",
"SIVANTOS INDIA PRIVATE LIMITED",
"SIVAPARAMESH SPINNING MILL PRIVATE LIMITED",
"SIVAPARVATHI COLD STORAGE PRIVATE LIMITED",
"SIVAPRIYA EXIM PRIVATE LIMITED",
"SIVARAJ HOLIDAY INN PRIVATE LIMITED",
"SIVARAJ SPINNING MILLS PRIVATE LIMITED",
"SIVARAMA KRISHNA FORGINGS PRIVATE LIMITED",
"SIVARAMAKRISHNA FORGINGS PRIVATE LIMITED",
"SIVARAMS BUILDERS AND PROMOTORS PRIVATE LIMITED",
"SIVARATHISH SPINNING MILLS PRIVATE LIMITED",
"SIVAROMA NATURALS PRIVATE LIMITED",
"SIVASAKTHI ENGINEERING & FABRICATORS PRIVATE LIMITED",
"SIVASAKTHI FOODS (I) PRIVATE LIMITED",
"SIVASAKTHI HOTELS PRIVATE. LIMITED.",
"SIVASAKTHI PHARMACEUTICALS PRIVATE LIMITED",
"SIVASAKTHI SPINTEX MILL PRIVATE LIMITED",
"SIVASAKTI FLOUR MILL PRIVATE LIMITED",
"SIVASHAKTHI LABORATORIES PRIVATE LIMITED",
"SIVASHAKTI AGROVET PRIVATE LIMITED",
"SIVASHANKAR PROJECTS PRIVATE LIMITED",
"SIVASREE SILKS PRIVATE LIMITED",
"SIVASRI ENGINEERING PRIVATE LIMITED",
"SIVASUNDAR HOSPITAL",
"SIVASWAMY HOLDINGS PRIVATE LIMITED",
"SIVASWATI TEXTILE PRIVATE LIMITED",
"SIVATAR VENTURES PRIVATE LIMITED",
"SIVENDHI AGRO FOODS PRIVATE LIMITED",
"SIVIKA FOODS PRIVATE. LIMITED.",
"SIVISOFT SOLUTIONS PRIVATE LIMITED",
"SIVOM PROJECTS PRIVATE LIMITED",
"SIVSHREE MEDITTEX (INDIA) PRIVATE LIMITED",
"SIWACH STEEL PRIVATE LIMITED",
"SIWAL INFRACON PRIVATE LIMITED",
"SIWAN CEMENT DISTRIBUTORS PRIVATE LIMITED",
"SIWANA SOLAR POWER PROJECT PRIVATE LIMITED",
"SIWON ENTERPRISES PRIVATE LIMITED",
"SIWOO TECH ENGINEERING PRIVATE LIMITED",
"SIWS",
"SIX DEE NETAD SOLUTIONS PRIVATE LIMITED",
"SIX DEGREES BCW PRIVATE LIMITED",
"SIX ELITE HI-TECH PACKAGING PRIVATE LIMITED",
"SIX O TU INVESTMENTS AND TRADERS PRIVATE LIMITED",
"SIX RED MARBLES LEARNING PRIVATE LIMITED",
"SIX SAILS TECHNOLOGIES INDIA PRIVATE LIMITED",
"SIX SEASONS CONCRETEX PRIVATE LIMITED",
"SIX SEASONS SERVICES AND CONSULTANTS PRIVATE LIMITED",
"SIX SENSES FINANCIAL SERVICES PRIVATE LIMITED",
"SIX SIGMA CERTIFICATION PRIVATE LIMITED",
"SIX SIGMA ESTABLISHMENT PRIVATE LIMITED",
"SIX SIGMA INFRASTRUCTURE PROVIDERS PRIVATE LIMITED",
"SIX SIGMA READYMIX CONCRETE PRIVATE LIMITED",
"SIX SIGMA SOFT WARE PRIVATE LIMITED",
"SIX SIGMA STAR HEALTHCARE PRIVATE LIMITED",
"SIX STAR IMPEX PRIAVTE LIMITED",
"SIX TWENTY REALTY PRIVATE LIMITED",
"SIXD ENGINEERING SOLUTIONS PRIVATE LIMITED",
"SIXGUARDS SAFETY PRIVATE LIMITED",
"SIXS SPORTS AND BUSINESS SOLUTIONS INC",
"SIX-SIGMA GASES INDIA PRIVATE LIMITED",
"SIXSIGMA MEDICARE AND RESEARCH LIMITED",
"SIXSIGMA SOFTSOLUTIONS PRIVATE LIMITED",
"SIXT R&D PRIVATE LIMITED",
"SIXTEEN DIRECTIONS HOMECARE PRIVATE LIMITED",
"SIXTH AXIS DIAGNOSTIC AND HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"SIXTH ELEMENT ADVERTISING PRIVATE LIMITED",
"SIXTH ELEMENT FURNISHING SOLUTIONS PRIVATE LIMITED",
"SIXTH ENERGY TECHNOLOGIES PRIVATE LIMITED",
"SIXTH FORCE SOLUTIONS PRIVATE LIMITED",
"SIXTH GENERATION TECHNOLOGIES PRIVATE LIMITED",
"SIXTH PACE GLOBAL PRIVATE LIMITED",
"SIXTH SENSE COMMERCIAL PRIVATE LIMITED",
"SIXTH SENSE DEVELOPERS PRIVATE LIMITED",
"SIXTH SENSE ENTERPRISES OPC PRIVATE LIMITED",
"SIXTH SENSE HOSPITALITY",
"SIXTH SENSE INFO DEPLOY INNOVATION",
"SIXTH SENSE RESEARCH SOLUTIONS PRIVATE LIMITED",
"SIXTH SENSE SECURITY AND MANAGEMENT SOLUTION PRIVATE LIMITED",
"SIXTHSENSE COMMUNICATIONS PRIVATE LIMITED",
"SIXTY FOUR SQUARES PRIVATE LIMITED",
"SIYA AGRIZONE PRIVATE LIMITED",
"SIYA AUTOMOTIVES PRIVATE LIMITED",
"SIYA CLEARING & FORWARDING PRIVATE LIMITED",
"SIYA GENERAL TRADING PRIVATE LIMITED",
"SIYA INFOTECH SOLUTIONS PRIVATE LIMITED",
"SIYA INFRAPROJECTS PRIVATE LIMITED",
"SIYA METALS PRIVATE LIMITED",
"SIYA RAM ENTERPRISES",
"SIYA RAM POLY PET PRIVATE LIMITED",
"SIYA RAM RAM SHREE SHEETALAYA PRIVATE LIMITED",
"SIYA TECH VENTURES PRIVATE LIMITED",
"SIYACLOUD PRIVATE LIMITED",
"SIYAM EDIBLE INTERNATIONAL PRIVATE LIMITED",
"SIYANA INFO SOLOUTION PRIVATE LIMITED",
"SIYARAM BHOOMI PRIVATE LIMITED",
"SIYARAM CHEMICALS PRIVATE LIMITED",
"SIYARAM COLD STORAGE PRIVATE LIMITED",
"SIYARAM COTTON INDUSTRIES",
"SIYARAM ENGINEERING PRIVATE LIMITED",
"SIYARAM GRANITO PRIVATE LIMITED",
"SIYARAM HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED",
"SIYARAM IMPEX PRIVATE LIMITED",
"SIYARAM IRRIGATION PRIVATE LIMITED",
"SIYARAM METAL UDYOG PRIVATE LIMITED",
"SIYARAM OM PRAKASH AUTO PRIVATE LIMITED",
"SIYARAM PACKAGERS PRIVATE LIMITED",
"SIYARAM PACKAGING PRIVATE LIMITED",
"SIYARAM PETROTECH PRIVATE LIMITED",
"SIYARAM PRESERVATION PRIVATE LIMITED",
"SIYARAM RECYCLING INDUSTRIES LIMITED",
"SIYARAM SILK MILLS LIMITED",
"SIYARAM STEELS PRIVATE LIMITED",
"SIYARAM VITRIFIED PRIVATE LIMITED",
"SIYARAM YARN PRIVATE LIMITED",
"SIYASIZA GLOBAL ENTERPRISE PRIVATE LIMITED",
"SIYAT HOLDINGS PRIVATE LIMITED",
"SIYAT PROPERTY PRIVATE LIMITED",
"SIYATON SOFTWARE SOLUTIONS PRIVATE LIMITED",
"SIYAZ CREATIONS PRIVATE LIMITED",
"SIYOM HYDRO POWER PRIVATE LIMITED",
"SIYON ORGANIC PRIVATE LIMITED",
"SIYONA DESIGNERS PRIVATE LIMITED",
"SIYOTA HYDRO POWER PRIVATE LIMITED",
"SIZACO ELECTRIC INDIA PRIVATE LIMITED",
"SIZE CONTROL GAUGES AND TOOLS PRIVATE LIMITED",
"SIZER METALS PRIVATE LIMITED",
"SIZING SOLUTION PRIVATE LIMITED",
"SIZZLE PROPERTIES PRIVATE LIMITED",
"SIZZLEZ IMPEX PRIVATE LIMITED",
"SJ AGRO PRODUCTS PRIVATE LIMITED",
"SJ BIZ SOLUTIONS PRIVATE LIMITED",
"SJ CONTRACTS PRIVATE LIMITED",
"SJ CORPORATE SERVICES PRIVATE LIMITED",
"SJ CORPORATION LIMITED",
"SJ ENGINEERS RENEWABLE ENERGY PRIVATE LIMITED",
"SJ FABRICSS PRIVATE LIMITED",
"SJ FASHIONS PRIVATE LIMITED",
"SJ FLOORS PRIVATE LIMITED",
"SJ FOREX PRIVATE LIMITED",
"SJ HOLIDAYS AND RESORTS PRIVATE LIMITED",
"SJ INFRAMINNING PRIVATE LIMITED",
"SJ KALA AGRO FOODS PRIVATE LIMITED",
"SJ LIFE SCIENCES PRIVATE LIMITED",
"SJ PROMAAN INDIA PRIVATE LIMITED",
"SJ SECURITY SYSTEMS PRIVATE LIMITED",
"SJ SEYMOUR SERVICES PRIVATE LIMITED",
"SJ SHIPPING AND LOGISTICS PRIVATE LIMITED",
"SJ UDYOG PRIVATE LIMITED",
"SJA BIOTECH INDIA PRIVATE LIMITED",
"SJA INDUSTRIAL CONSULTANTS PRIVATE LIMITED",
"SJA INFOSOLUTIONS PRIVATE LIMITED",
"SJA INFRAHEIGHTS PRIVATE LIMITED",
"SJA LOGISOL INDIA PRIVATE LIMITED",
"SJA TECHNICAL CONSULTANTS PRIVATE LIMITED",
"SJAAR EDUHEALTH PRIVATE LIMITED",
"SJAIN VENTURES LIMITED",
"SJAS SUPER SPECIALTY HOSPITAL",
"SJB AUTOMOBILES PRIVATE LIMITED",
"SJB CLEARING AGENCY PRIVATE LIMITED",
"SJB INSTITUTE OF TECHNOLOGY",
"SJC INDIA PRIVATE LIMITED",
"SJF MILK PRODUCTS MERCHANT PRIVATE LIMITED",
"SJFMC CAPITAL LIMITED",
"SJH INFOTECH PRIVATE LIMITED",
"SJI HOSPITALITY AND FOODS PRIVATE LIMITED",
"SJI INFRABUILD PRIVATE LIMITED",
"SJIWOO INDIA PRIVATE LIMITED",
"SJJS PROJECTS PRIVATE LIMITED",
"SJK BUSINESS SOLUTIONS PRIVATE LIMITED",
"SJK ENTERPRISES PRIVATE LIMITED",
"SJK INNOVATIONS PRIVATE LIMITED",
"SJK MEDICAL (INDIA) PRIVATE LIMITED",
"SJLT SPINNING MILLS PRIVATE LIMITED",
"SJLT TEXTILES PRIVATE LIMITED",
"SJM IMPORTS PRIVATE LIMITED",
"SJM METALS PRIVATE LIMITED",
"SJM VIDYAPEETHA",
"SJN FARMERS PRODUCER COMPANY LIMITED",
"SJNS JAIN MAT HR SEC SCHOOL",
"SJP CONSTRUCTIONS PRIVATE. LIMITED.",
"SJP GLOBAL LIMITED",
"SJP HOTELS &RESORTS PRIVATE LIMITED",
"SJP INFRACON LIMITED",
"SJP REALITY VENTURES PRIVATE LIMITED",
"SJP ULTRASONICS LIMITED",
"SJP ULTRASONICS PRIVATE LIMITED",
"SJR COLLEGE",
"SJR COLLEGE FOR WOMEN",
"SJR EMBROIDERY PRIVATE LIMITED",
"SJR HOTELS AND PROPERTIES PRIVATE LIMITED",
"SJR INFRASTRUCTURE PRIVATE. LIMITED",
"SJR PRIME CORPORATION PRIVATE LIMITED",
"SJR PRIME SPECTRUM PRIVATE LIMITED",
"SJRC COLLEGE",
"SJRENTERPRISESPRIVATELIMITED",
"SJS AGRO INDUSTRIES PRIVATE LIMITED",
"SJS CONNECT PRIVATE LIMITED",
"SJS ENTERPRISES PRIVATE LIMITED",
"SJS GLOBAL LOGISTICS PRIVATE LIMITED",
"SJS GOLD PRIVATE LIMITED",
"SJS HEALTHCARE LIMITED",
"SJS INFRADEVELOPERS PRIVATE LIMITED",
"SJS INFRATECH PRIVATE LIMITED",
"SJS MOTORS",
"SJS PLASTIBLENDS PRIVATE LIMITED",
"SJSP JEWELLERY PRIVATE LIMITED",
"SJV SWAMMI VENTURES PRIVATE LIMITED",
"SJVN LIMITED",
"SK & COMPANY FABCON PRIVATE LIMITED",
"SK AUTO SMART CARE PRIVATE LIMITED",
"SK AUTOMOTIVES LIMITED",
"SK BIOBIZ AGRO PRIVATE LIMITED",
"SK CAFE BROOKE HOTS PRIVATE LIMITED",
"SK CUTTING TOOLS SOLUTION PRIVATE LIMITED",
"SK ENGINEERS INDIA PRIVATE LIMITED",
"SK ENGIPRO AND ALLIED SOLUTIONS PRIVATE LIMITED",
"SK ENMOVE INDIA PRIVATE LIMITED",
"SK ENSURE MACHINERY PRIVATE LIMITED",
"SK ENTERPRISES",
"SK EXPORTS",
"SK EXPORTS PVT.LTD.",
"SK EXPRESS SERVICES PRIVATE LIMITED",
"SK FINANCE LIMITED",
"SK FIRE SYSTEM",
"SK FLEET SOLUTIONS PRIVATE LIMITED",
"SK FREIGHT CARRIERS PRIVATE LIMITED",
"SK GOLDSMITHS INDUSTRIAL COOP SOCIETY LTD",
"SK HOSPITAL",
"SK HYNIX SEMICONDUCTOR INDIA PRIVATE LIMITED",
"SK IMPORT EXPORT PRIVATE LIMITED",
"SK INTERNATIONAL EXPORT LIMITED",
"SK MANAGEMENT SERVICES PRIVATE LIMITED",
"SK MOBI PRIVATE LIMITED",
"SK NASIRUDDIN BIRI MERCHANTS PVT LTD",
"SK OUTSOURCING PRIVATE LIMITED",
"SK OVERSEAS",
"SK OVERSEAS IND PRIVATE LIMITED",
"SK PORWAL COLLEGE",
"SK RESTAURANTS PRIVATE LIMITED",
"SK RETAIL PRIVATE LIMITED",
"SK SARTHI PRIVATE LIMITED",
"SK SEA SCAPE PRIVATE LIMITED",
"SK SUPERSPECIALITY HOSPITAL",
"SK SYSTEMS PRIVATE LIMITED",
"SK UEM WATER PROJECTS PRIVATE LIMITED",
"SKA ALLIANCE PRIVATE LIMITED",
"SKA DAIRY FOODS INDIA PRIVATE LIMITED",
"SKA DIAGNOSTIC PRIVATE LIMITED",
"SKA FABTEX PRIVATE LIMITED",
"SKA MARKETING PRIVATE LIMITED",
"SKA MEDIA",
"SKA RESORTS PRIVATE LIMITED",
"SKA SECURITIES & FINANCIAL SERVICES PRIVATE LIMITED",
"SKA STEEL AND POWER PRIVATE LIMITED",
"SKAAS TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"SKAAT HOSPITALITY PRIVATE LIMITED",
"SKAAT MACHINE WORKS INDIA PRIVATE LIMITED",
"SKABELSE CREATIONS (OPC) PRIVATE LIMITED",
"SKADOOSH MEDIA PRIVATE LIMITED",
"SKAF CONSTRUCTION PRIVATE LIMITED",
"SKAI AIR CONTROL PRIVATE LIMITED",
"SKAI AUTO PRIVATE LIMITED",
"SKAID DESIGNS PRIVATE LIMITED",
"SKAJEN VITRIFIED PRIVATE LIMITED",
"SKAK TEXTILE PRIVATE LIMITED",
"SKALABLE TECHNOLOGIES INDIA PRIVATE LIMITED",
"SKALAR ANALYTICAL INDIA PRIVATE LIMITED",
"SKAMBHA RESOURCE RECOVERY PRIVATE LIMITED",
"SKAN BPO PRIVATE LIMITED",
"SKAN INSTRUMENTS AND ELECTRONICS PRIVATE LIMITED",
"SKAN MARINE SERVICES PRIVATE LIMITED",
"SKAN NETCOMMUNICATIONS TECHNOLOGY PRIVATE LIMITED",
"SKAN RESEARCH LAB PRIVATE LTIMITED",
"SKANAI LABS PRIVATE LIMITED",
"SKANAN HARDWARE PRIVATE LIMITED",
"SKAND CREATIONS PRIVATE LIMITED",
"SKAND PRIVATE LIMITED",
"SKANDA AEROSPACE PRIVATE LIMITED",
"SKANDA AEROSPACE TECHNOLOGY PRIVATE LIMITED",
"SKANDA FREIGHT SERVICES PRIVATE LIMITED",
"SKANDA INFRA PROJECTS INDIA PRIVATE LIMITED",
"SKANDA INFRACON PRIVATE LIMITED",
"SKANDA IT CONSULTING PRIVATE LIMITED",
"SKANDA MANUFACTURING SYSTEMS PRIVATE LIMITED",
"SKANDA NAVIA LOGISTICS INDIA PRIVATE LIMITED",
"SKANDA ORNAMENTAL STONE (INDIA) PRIVATE LIMITED",
"SKANDA RETAIL PRIVATE LIMITED",
"SKANDA SALES PRIVATE LIMITED",
"SKANDA SURGICALS & PHARMA PRIVATE LIMITED",
"SKANDAAVANI SHELTERS PRIVATE LIMITED",
"SKANDANAVISKA ENSKILDA BANKEN",
"SKANDAYA INFRASTRUCTURES PRIVATE LIMITED",
"SKANDHA IT SERVICES PRIVATE LIMITED",
"SKANDHA MEDIA SERVICES PRIVATE LIMITED",
"SKANDHANSHI INFRA PROJECTS INDIA PRIVATE LIMITED",
"SKANDWIL INDIA PRIVATE LIMITED",
"SKANDYSYS PRIVATE LIMITED",
"SKANEM INDIA PRIVATE LIMITED",
"SKANEM INTERLABELS INDUSTRIES PRIVATE LIMITED",
"SKANMIT SYSTEM PRIVATE LIMITED",
"SKANRAY DENTAL TECHNOLOGIES PRIVATE LIMITED",
"SKANRAY TECHNOLOGIES LIMITED",
"SKAPARE CORPORATE SOLUTIONS PRIVATE LIMITED",
"SKAPS INDUSTRIES INDIA PRIVATE LIMITED",
"SKARDI REALTECH PRIVATE. LIMITED.",
"SKARS HEALTH CARE PRIVATE LIMITED",
"SKART GLOBAL EXPRESS PRIVATE LIMITED",
"SKAS AUTOTECH PRIVATE LIMITED",
"SKATE TRADES AND AGENCIES PRIVATE LIMITED",
"SKATER INFRATECH INDIA PRIVATE LIMITED",
"SKAV DEVELOPERS PRIVATE LIMITED",
"SKAVA ELECTRIC LIMITED",
"SKAY COLLECTIONS PRIVATE LIMITED",
"SKB FOOD PRODUCTS PRIVATE LIMITED",
"SKB PUBLISHING SOLUTION PRIVATE LIMITED",
"SKB TRADEX PRIVATE LIMITED",
"SKBM MINING PROJECTS PRIVATE LIMITED",
"SKBR EXPORTS PRIVATE LIMITED",
"SKC CHEMIE PRIVATE LIMITED",
"SKC CONSULTING PRIVATE LIMITED",
"SKC DISTRIBUTIONS PRIVATE LIMITED",
"SKC ENVIRON LAB PRIVATE LIMITED",
"SKC INFRA TECH PRIVATE LIMITED",
"SKC INVESTMENT ADVISORS PRIVATE LIMITED",
"SKC POLY ENGINEERING PRIVATE LIMITED",
"SKC TRADING & BUILDING MATERIALS PRIVATE LIMITED",
"SKC TRADING PRIVATE LIMITED",
"SKCB FOODS PRIVATE LIMITED",
"SKCC PAPER & BOARD PVT LTD",
"SKCL WEALTH MANAGEMENT PRIVATE LIMITED",
"SKCO PAINTS PRIVATE LIMITED",
"SKD ACADEMY",
"SKD AGRO MARKETING PRIVATE LIMITED",
"SKD CONSULTANTS PRIVATE LIMITED",
"SKD ELECTRO SALES PRIVATE LIMITED",
"SKD LEATHER INDIA PRIVATE LIMITED",
"SKD PHARMA PRODUCTS PRIVATE LIMITED",
"SKD RICE INDUSTRIES PRIVATE LIMITED",
"SKE EQUIPMENTS PRIVATE LIMITED",
"SKE SUSRUTA INSTITUTE OF MEDICAL SCIENCES PRIVATE LIMITED",
"SKE WORKS PRIVATE LIMITED",
"SKECHERS RETAIL INDIA PRIVATE LIMITED",
"SKECHERS SOUTH ASIA PRIVATE LIMITED",
"SKEGA ENGINEERING CO. PRIVATE LIMITED",
"SKEIRON RENEWABLE ENERGY AMIDYALA PRIVATE LIMITED",
"SKEIRON RENEWABLE ENERGY KUSTAGI PRIVATE LIMITED",
"SKELETON CONSULTANTS PRIVATE LIMITED",
"SKELI LIMITED",
"SKELLAM AI PRIVATE LIMITED",
"SKEM PROJECTS PRIVATE LIMITED",
"SKEMA INTERNATIONAL PRIVATE LIMITED",
"SKEPPER CREATIVE AGENCY PRIVATE LIMITED",
"SKETCHBOARD CREATIVE PRODUCTION PRIVATE LIMITED",
"SKETCHERS RETAIL PRIVATE LIMITED",
"SKETCHLINE APPARELS PRIVATE LIMITED",
"SKETS STUDIO PRIVATE LIMITED",
"SKEVI INTERIOR PRODUCTS PRIVATE LIMITED",
"SKEWER TECHNOLOGIES PRIVATE LIMITED",
"SKF BOILERS & DRIERS PRIVATE. LIMITED.",
"SKF ELIXER INDIA PRIVATE LIMITED",
"SKF ENGINEERING AND LUBRICATION INDIA PRIVATE LIMITED",
"SKF ENGINEERING PRIVATE LIMITED",
"SKF INDIA LIMITED",
"SKF TECHNOLOGIES INDIA PRIVATE LIMITED",
"SKFFINDIA PRIVATE LIMITED",
"SKG & DAUGHTERS PRIVATE LIMITED",
"SKG CONSULTANTS AND ENGINEERING PRIVATE LIMITED",
"SKG ENGINEERING PRIVATE LIMITED",
"SKG FOREX & TRAVEL PRIVATE LIMITED",
"SKG HOMES PRIVATE LIMITED",
"SKG INFRATECH PRIVATE LIMITED",
"SKG PLASTICS PRIVATE LIMITED",
"SKG POLYMERS PRIVATE LIMITED",
"SKG PROJECT AND ENGG PRIVATE LIMITED",
"SKG REFRACTORIES LIMITED",
"SKG SPECIALITY SERVICES PRIVATE LIMITED",
"SKG TERRA PROMENADE PRIVATE LIMITED",
"SKG TIMBERS PRIVATE LIMITED",
"SKGC INFRAPROJECTS PRIVATE LIMITED",
"SKGC MINERALS LIMITED",
"SKH GLOBAL TRAVELS PRIVATE LIMITED",
"SKH MAGNETI MARELLI EXHAUST SYSTEMS PRIVATE LIMITED",
"SKH MANAGEMENT SERVICES LIMITED",
"SKH MANAGEMENT STRATEGY SERVICES INDIA LLP",
"SKH MARELLI EXHAUST SYSTEM PRIVATE LIMITED",
"SKH METALS LIMITED",
"SKH SHEET METALS COMPONENTS PRIVATE LIMITED",
"SKH SILA INDIA PRIVATE LIMITED",
"SKH Y TEC INDIA PRIVATE LIMITED",
"SKHC PRIVATE LIMITED",
"SKI CAPITAL SERVICES LIMITED",
"SKI ENGINEERING PRIVATE LIMITED",
"SKI FOOD AND FEED PRIVATE LIMITED",
"SKI LOGITECH PRIVATE LIMITED",
"SKI PLASTOWARE PRIVATE LIMITED",
"SKI RETAIL CAPITAL LIMITED",
"SKI TECHNOLOGIES PRIVATE LIMITED",
"SKI TRADE & HOLDINGS PVT LTD",
"SKICORP MARKETING VENTURES PRIVATE LIMITED",
"SKIDATA INDIA PRIVATE LIMITED",
"SKIDATA TECHNOLOGIES BANGALORE PRIVATE LIMITED",
"SKIDOS LEARNING PRIVATE LIMITED",
"SKIDTECH ENGINEERING PRIVATE LIMITED",
"SKIER EXPORT AND IMPORT PRIVATE LIMITED",
"SKIES ACADEMY",
"SKIFFLE HEALTHCARE SERVICES LIMITED",
"SKIL FOUNDERS PRIVATE LIMITED",
"SKIL GAVGES AND TOOLS PRIVATE LIMITED",
"SKIL INFRASTRUCTURE LIMITED",
"SKIL TRAVEL PRIVATE LIMITED",
"SKIL WORTH TECHNOLOGIES PRIVATE LIMITED",
"SKILANCER SOLAR PRIVATE LIMITED",
"SKILHAT BIZSOL PRIVATE LIMITED",
"SKILL COUNCIL FOR GREEN JOBS",
"SKILL DEVELOPMENT & INDUSTRIAL TRAINING",
"SKILL DEVELOPMENT EMPLOYMENT AND ENTREPRENEURSHIP GUIDANCE",
"SKILL DYE CHEM PRIVATE LIMITED",
"SKILL GROOMERS MANAGEMENT SERVICES PRIVATE LIMITED",
"SKILL LOTTO SOLUTIONS PRIVATE. LIMITED",
"SKILL PRECISION BALLS PRIVATE LIMITED",
"SKILL PROMOTERS INFRA PRIVATE LIMITED",
"SKILL PROMOTERS PRIVATE LIMITED",
"SKILL RESOURCE DEVELOPMENT PRIVATE LIMITED",
"SKILL RICH MANAGEMENT PRIVATE LIMITED",
"SKILL ROLLERS PRIVATE LIMITED",
"SKILL SONICS INDIA PRIVATE LIMITED",
"SKILL STORK INTERNATIONAL SCHOOL",
"SKILL TREE CONSULTING PRIVATE LIMITED",
"SKILLABLERS TECHNOLOGIES PRIVATE LIMITED",
"SKILLBIZ PUBLICATION PRIVATE LIMITED",
"SKILLED CONSTRUCTION COMPANY LIMITED",
"SKILLFOLIO INNOVATION PRIVATE LIMITED",
"SKILLIANTECH INDIA PRIVATE LIMITED",
"SKILLMINE TECHNOLOGY CONSULTING PRIVATE LIMITED",
"SKILLNET SOLUTIONS INDIA PRIVATE LIMITED",
"SKILLNET TECHNOLOGIES PRIVATE LIMITED",
"SKILLPLAN CONSULTANT LLP",
"SKILLPLUS INFRA PRIVATE LIMITED",
"SKILLS ACADEMY PRIVATE LIMITED",
"SKILLS AND YOU CONSULTANTS PRIVATE LIMITED",
"SKILLS CREATOR PRIVATE LIMITED",
"SKILLS DEVELOPMENT NETWORK",
"SKILLS MANTRA EDUTECH CONSULTING INDIA PRIVATE LIMITED",
"SKILLS OUTSOURCETHINK PRIVATE LIMITED",
"SKILLS ROOT EDU TECH CONSULTING INDIA PRIVATE LIMITED",
"SKILLSEARCH INFOTECH PRIVATE LIMITED",
"SKILLSOFT SOFTWARE SERVICES INDIA PRIVATE LIMITED",
"SKILLSOURCE LEARNING AND TECHNOLOGIES PRIVATE LIMITED",
"SKILLTECH ENGINEERS AND CONTRACTORS PRIVATE LIMITED",
"SKILLUP PACE PRIVATE LIMITED",
"SKILL-UP TECH INDIA PRIVATE LIMITED",
"SKILLVENTORY MANPOWER SERVICE LLP",
"SKILLVERI TRAINING SOLUTIONS PRIVATE LIMITED",
"SKILLWIN TECHNOLOGY PRIVATE LIMITED",
"SKILROCK TECHNOLOGIES PRIVATE LIMITED",
"SKILVEL VENTURES PRIVATE LIMITED",
"SKILWORTH TECHNOLOGIES PRIVATE LIMITED",
"SKIN AESTHETICS INTERNATIONAL PRIVATE LIMITED",
"SKIN CITY PRIVATE LIMITED",
"SKIN COSMEDICA LLP",
"SKIN SCIENCE LABORATORY PRIVATE LIMITED",
"SKINCARE FIBER PRIVATE LIMITED",
"SKINCARE SURGIPHARMA PRIVATE LIMITED",
"SKINDIA FINANCE PVT LTD",
"SKINNCELLS SEASONS PRIVATE LIMITED",
"SKINNER SOFTWARE PRIVATE LIMITED",
"SKINNOVATION PRIVATE LIMITED",
"SKINSATIONAL CARE PRIVATE LIMITED",
"SKINSKA PHARMACEUTICA PRIVATE LIMITED",
"SKINTIFIC PRIVATE LIMITED",
"SKINTL ENTERPRISES PRIVATE LIMITED",
"SKINWAVE INDIA PRIVATE LIMITED",
"SKIPPER ELECTRICALS INDIA LIMITED",
"SKIPPER FURNISHING PRIVATE LIMITED",
"SKIPPER HOMES PRIVATE LIMITED",
"SKIPPER HOSIERY PRIVATE LIMITED",
"SKIPPER HOUSING PRIVATE LIMITED",
"SKIPPER LIMITED",
"SKIPPER PROPERTIES PVT LTD",
"SKIPPER REALTIES LIMITED",
"SKIPPER SALES PVT LTD",
"SKIPPER SYNTHETICS PRIVATE LIMITED",
"SKIPPER TECHNOLOGIES INDIA PRIVATE LIMITED",
"SKIPPERSEIL LIMITED",
"SKIPPING STONES ENTERTAINMENT PRIVATE LIMITED",
"SKITES PHARMA PRIVATE LIMITED",
"SKITES TECHNOLOGIES PRIVATE LIMITED",
"SKITTER SOLUTIONS PRIVATE LIMITED",
"SKITTISH REALTORS PRIVATE LIMITED",
"SKIVVIES INDUSTRIES PRIVATE LIMITED",
"SKJ ENGINEERING PRIVATE LIMITED",
"SKJ PUREFUN INDIA PRIVATE LIMITED",
"SKK EXIM INDIA PRIVATE LIMITED",
"SKK INDUSTRIES PRIVATE LIMITED",
"SKK INFRA SOLUTIONS PRIVATE LIMITED",
"SKK RESORTS PRIVATE LIMITED",
"SKK S PTE LIMITED",
"SKK STEEL ENTERPRISES PRIVATE LIMITED",
"SKKARMA CONSTRUCTION PRIVATE LIMITED",
"SKKATO INDIA PRIVATE LIMITED",
"SKKR MARITIME PRIVATE LIMITED",
"SKL CARGO MOVERS INDIA PRIVATE LIMITED",
"SKL CONSULTANTS PRIVATE LIMITED",
"SKL ENTERPRISES",
"SKL EQUIPMENT PRIVATE LIMITED",
"SKL EXPORTS LIMITED",
"SKL HY-LINKS PRIVATE LIMITED",
"SKL INDIA PRIVATE LIMITED",
"SKL SHIPPING AND LOGISTICS PRIVATE LIMITED",
"SKL UNIVERSAL PRIVATE LIMITED",
"SKLN SALES AND SERVICES PRIVATE LIMITED",
"SKLO MANAGEMENT PRIVATE LIMITED",
"SKM AGRO PRIVATE LIMITED",
"SKM COMMUNICATIONS PRIVATE LIMITED",
"SKM CONSTRA",
"SKM CONTRACTOR AND SERVICES PRIVATE LIMITED",
"SKM DISTRIBUTORS PRIVATE LIMITED",
"SKM EGG PRODUCTS EXPORT INDIA LIMITED",
"SKM ESTATES LIMITED",
"SKM EXPORTS INDUSTRIES PRIVATE LIMITED",
"SKM INDUSTRIES",
"SKM INTERNATIONAL PRIVATE LIMITED",
"SKM MARKETING PRIVATE LIMITED",
"SKM PHARMA PRIVATE LIMITED,",
"SKM RAMDIN ULTRATECH PRIVATE LIMITED",
"SKM SIDDHA AND AYURVEDHA COMPANY PRIVATE LIMITED",
"SKM STEELS LIMITED",
"SKM TRADERS PRIVATE LIMITED",
"SKM UNIVERSAL MARKETING COMPANY INDIA PRIVATE LIMITED",
"SKMAHAJAN TRADELINK PRIVATE LIMITED",
"SKMC BUILDCON PRIVATE LIMITED",
"SKMK IMPEX PRIVATE LIMITED",
"SKML EXIM PRIVATE LIMITED",
"SKML INFO TECHNOLOGY SERVICES PRIVATE LIMITED",
"SKN ADVISORS PRIVATE LIMITED",
"SKN CONSTRUCTION CONSULTANCY PRIVATE LIMITED",
"SKN ENERGY INFRA VENTURES PRIVATE LIMITED",
"SKN HOSPITAL",
"SKN INDUSTRIES LIMITED",
"SKN INFRASTRUCTURE PRIVATE LIMITED",
"SKN ORGANICS PRIVATE LIMITED",
"SKN RICE INDUSTRIES",
"SKN SINHAGAD INSTITUTE OF TECHNOLOGY & SCIENCE",
"SKN TEXTILES PRIVATE LIMITED",
"SKNK GLOBAL EXPORTS PRIVATE LIMITED",
"SKNR CONSTRUCTIONS PRIVATE LIMITED",
"SKOCH CONSULTANCY SERVICES PRIVATE LIMITED",
"SKOCIATE CONSULTING PRIVATE LIMITED",
"SKODA AUTO INDIA PRIVATE LIMITED",
"SKODA AUTO VOLKSWAGEN INDIA PRIVATE LIMITED",
"SKODA POWER PRIVATE LIMITED",
"SKODEM TECHNOLOGIES PRIVATE LIMITED",
"SKON FLEXIPACK PRIVATE LIMITED",
"SKONNECTS MARKETING PRIVATE LIMITED",
"SKOODLE LEARNING PRIVATE LIMITED",
"SKOOLDRESS.IN PRIVATE LIMITED",
"SKOOTR FINSAVE PRIVATE LIMITED",
"SKOOTR GLOBAL PRIVATE LIMITED",
"SKOPE HOTELS PRIVATE LIMITED",
"SKOPE PRODUCTS PVT LTD",
"SKOPEINDIA BUSINESS CONSULTING PRIVATE LIMITED",
"SKORION TECHNOLOGIES PRIVATE LIMITED",
"SKORUZ TECHNOLOGIES PRIVATE LIMITED",
"SKOSH COMMERICAL (INDIA) PRIVATE LIMITED",
"SKP BUSINESS CONSULTING LLP",
"SKP CORP PRIVATE LIMITED",
"SKP GLOBAL MEDICINES PRIVATE LIMITED",
"SKP INTEX PRIVATE LIMITED",
"SKP PROJECTS PRIVATE LIMITED",
"SKP SECURITIES LTD",
"SKP STEEL INDUSTRIES PRIVATE. LIMITED.",
"SKP TITLE SEARCH PRIVATE LIMITED",
"SKP VANITHA INTERNATIONAL SCHOOL",
"SKR ALLIANCE PRIVATE LIMITED",
"SKR APPARELS PRIVATE LIMITED",
"SKR DISTRIBUTORS PRIVATE LIMITED",
"SKR EDUCATIONAL FOUNDATION",
"SKR ELECTRIC POWER EQUIPMENTS OPC PRIVATE LIMITED",
"SKR ENGINEERING COLLEGE",
"SKR EXPORTS INDIA PRIVATE LIMITED",
"SKR HOSPITALS & TRAUMA CENTRE PRIVATE LIMITED",
"SKR SUPPLY CHAIN MANAGEMENT PRIVATE LIMITED",
"SKR VEG-OIL INDUSTRIES PRIVATE LIMITED",
"SKRB AUTOMOBILITY PRIVATE LIMITED",
"SKRE AMS PRIVATE LIMITED",
"SKRE RENEWABLE ENERGY INDIA PRIVATE LIMITED",
"SKREEM TECHNOLOGY PRIVATE LIMITED",
"SKRETTING AQUACULTURE INDIA PRIVATE LIMITED",
"SKRK COTTON PRIVATE LIMITED",
"SKRK ENTERPRISES PRIVATE LIMITED",
"SKRK MARKETING (INDIA) PRIVATE LIMITED.",
"SKRM FOODS INDIA PRIVATE LIMITED",
"SKROMAN SWITCHES PRIVATE LIMITED",
"SKS ARTS PRIVATE LIMITED",
"SKS BUSINESS SERVICES INDIA PRIVATE LIMITED",
"SKS CAPITAL & RESEARCH PRIVATE LIMITED",
"SKS CLEANTECH PRIVATE LIMITED",
"SKS FASTENERS LIMITED",
"SKS FINECHEM PRIVATE LIMITED",
"SKS FOUNDATION INDIA PRIVATE LIMITED",
"SKS GLOBAL PRIVATE LIMITED",
"SKS GLOCHEM (I) PRIVATE LIMITED",
"SKS HOSPITAL INDIA PRIVATE. LIMITED.",
"SKS INDIA PRIVATE LIMITED",
"SKS INFRA PROJECTS PRIVATE LIMITED",
"SKS ISPAT AND POWER LIMITED",
"SKS KARKALA INFRA PROJECTS PRIVATE LIMITED",
"SKS MEGAPROJECTS INDIA PRIVATE LIMITED",
"SKS MULTY AMC SERVICES PRIVATE LIMITED",
"SKS NIRMAN VAANIJAY PRIVATE LIMITED",
"SKS PACKAGING PRIVATE LIMITED",
"SKS TRADE INDIA PRIVATE LIMITED",
"SKS WELDING SYSTEMS PRIVATE LIMITED",
"SKSB MINING AND MINERALS PRIVATE LIMITED",
"SKSE SECURITIES LIMITED",
"SKSJ FOODS PRIVATE LIMITED",
"SKSK LANDMARK PRIVATE LIMITED",
"SKSM DIAMONDS IMPEX LIMITED",
"SKSS LIFESTYLE LIMITED",
"SKST CHIT FUNDS PRIVATE LIMITED",
"SKT BUILDCON PRIVATE LIMITED",
"SKT CHEMSPEC PRIVATE LIMITED",
"SKTD SERVICES PRIVATE LIMITED",
"SKU CONSTRUCTION PRIVATE LIMITED",
"SKUFLA TECH VENTURES PRIVATE LIMITED",
"SKUG INSIGHTS PRIVATE LIMITED",
"SKULOGIC INDIA DEVELOPMENT CENTRE PRIVATE LIMITED",
"SKUMAR AND COMPANY TRADES PRIVATE LIMITED",
"SKUNG COMMXPERTS LIMITED",
"SKUNIVERSE AUTOMOBILE PRIVATE LIMITED",
"SKV AUTOMOTIVE PRIVATE LIMITED",
"SKV CARGO SYSTEMS PRIVATE LIMITED",
"SKV COLLECTION PRIVATE LIMITED",
"SKV ENGINEERING INDIA PRIVATE LIMITED",
"SKV HITECH PRIVATE LIMITED",
"SKV HR SEC SCHOOL",
"SKV INFRATECH PRIVATE LIMITED",
"SKV VIDHYAASHARAM CBSE SCHOOL",
"SKVA RUBBER SOLUTIONS PRIVATE LIMITED",
"SKVR SOFTWARE SOLUTION PRIVATE LIMITED",
"SKW SOIL AND SURVEYS PRIVATE LIMITED",
"SKW TAQNIQ PRIVATE LIMITED",
"SKY 2 C FREIGHT SYSTEMS INDIA PRIVATE LIMITED",
"SKY AIR GASES PRIVATE LIMITED",
"SKY ALLOYS AND POWER LIMITED",
"SKY AMA INFRA PRIVATE LIMITED",
"SKY AND SKY FOREX PRIVATE LIMITED",
"SKY AUTOWINGS PRIVATE LIMITED",
"SKY B (BANGLA) PRIVATE LIMITED",
"SKY BLUE ART PRIVATE LIMITED",
"SKY BLUE CARGO PRIVATE LIMITED",
"SKY BLUE INTERNATIONAL PRIVATE LIMITED",
"SKY BRANDS RETAIL PRIVATE LIMITED",
"SKY BRIDGE INFOTECH PRIVATE LIMITED",
"SKY CERAMIC PRIVATE LIMITED",
"SKY CHAINS AND JEWELLERY PRIVATE LIMITED",
"SKY CHEMI-PHARMA PRIVATE LIMITED",
"SKY COMMODITIES INDIA PRIVATE LIMITED",
"SKY CONSULTANCY SERVICES PRIVATE LIMITED",
"SKY COTEX INDIA PRIVATE LIMITED",
"SKY DATASOFT PRIVATE LIMITED",
"SKY DECORATIONS PRIVATE LIMITED",
"SKY DEVELOPERS AND PROMOTERS (INDIA) PRIVATE LIMITED",
"SKY DEVELOPERS PRIVATE LIMITED",
"SKY DIAGNOSTICS PRIVATE LIMITED",
"SKY DREAM PROJECTS PRIVATE LIMITED",
"SKY E IT SOLUTIONS PRIVATE LIMITED",
"SKY ELECTRONICS PRIVATE LIMITED",
"SKY ENTERPRISE PRIVATE LIMITED",
"SKY EQUITY PRIVATE LIMITED",
"SKY FIRE SERVICES PRIVATE LIMITED",
"SKY FOREST PROJECTS PRIVATE LIMITED",
"SKY FORGE PRIVATE LIMITED",
"SKY FREIGHT LOGISTICS PRIVATE LIMITED",
"SKY GATE HOSPITALITY PRIVATE LIMITED",
"SKY GLOBAL PRIVATE LIMITED",
"SKY GOLD PRIVATE. LIMITED.",
"SKY GOODIES PRODUCTS AND APPLICATIONS PRIVATE LIMITED",
"SKY HAWK TRAVELS PRIVATE LIMITED",
"SKY HEMMAY PRIVATE LIMITED",
"SKY HIGH PACKAGING PRIVATE LIMITED",
"SKY I T INFRATECH PRIVATE LIMITED",
"SKY IMF LIMITED",
"SKY INDUSTRIES LIMITED",
"SKY INFRASTRUCTURES PRIVATE LIMITED",
"SKY LAM PRIVATE LIMITED",
"SKY LARK FASHIONS PRIVATE LIMITED",
"SKY LIFECARE PRIVATE LIMITED",
"SKY LIFELINE PRIVATE LIMITED",
"SKY LINE MARKETING PRIVATE LIMITED",
"SKY LINER EDUCATION NETWORK",
"SKY LOGITRANS PRIVATE LIMITED",
"SKY MASTERS PVT LTD",
"SKY MINING SERVICES INDIA PRIVATE LIMITED",
"SKY MODEL AND EVENT MANAGEMENT PRIVATE LIMITED",
"SKY MOTO AUTOMOBILES PRIVATE LIMITED",
"SKY ONBOARD MARINE SERVICES PRIVATE LIMITED",
"SKY ONE AIRWAYS PRIVATE LIMITED",
"SKY PACK VENTURE PRIVATE LIMITED",
"SKY PRIMWEAR INDIA PRIVATE LIMITED",
"SKY PRODUCTIVITY PRIVATE LIMITED",
"SKY REAL ESTATES PRIVATE LIMITED.",
"SKY REALTY PROJECTS PRIVATE LIMITED",
"SKY ROUTE WORLD WIDE¬†",
"SKY SCREEN PRIVATE LIMITED",
"SKY SPACE DEVELOPERS PRIVATE LIMITED",
"SKY SPARES PRIVATE LIMITED",
"SKY SPINTEX PRIVATE LIMITED",
"SKY STAYS PRIVATE LIMITED",
"SKY SUPPLY CHAIN SOLUTION PRIVATE LIMITED",
"SKY TECH & CLEANING SYSTEMS PRIVATE LIMITED",
"SKY TECH SOLUTION",
"SKY TECHNOCAST PRIVATE LIMITED",
"SKY TEX INDUSTRIES PRIVATE LIMITED",
"SKY TEXPROS PVT LTD",
"SKY TEXTILES INDIA PRIVATE LIMITED",
"SKY TOP BUILDERS PRIVATE LIMITED",
"SKY TOUCH AVIATION PRIVATE LIMITED",
"SKY TRADE ZONE MANDSAUR PRIVATE LIMITED",
"SKY TRAVEL & TOURS BRANCH PRIVATE LIMITED",
"SKY VIEW OPTICS PRIVATE LIMITED",
"SKY VISION INDIA PRIVATE LIMITED",
"SKY WAVES SECURITY PRIVATE LIMITED",
"SKY WAY RMC PRIVATE LIMITED",
"SKY WHEELS PRIVATE LIMITED",
"SKY WIPERS PRIVATE LIMITED",
"SKY Z TRAVEL SOLUTION PRIVATE LIMITED",
"SKY ZONE INFRASTRUCTURE PRIVATE LIMITED",
"SKYARK FREIGHT EXPRESS LOGISTICS PRIVATE LIMITED",
"SKYBACK AUTOMOTIVE PRIVATE LIMITED",
"SKYBARGE FREIGHT PRIVATE LIMITED",
"SKYBASENET SOLUTIONS INDIA PRIVATE LIMITED",
"SKYBAY SHIPPING AND TRADING PRIVATE LIMITED",
"SKYBEAT CONSULTANCY PRIVATE LIMITED",
"SKYBIOTECH LIFE SCIENCES PRIVATE LIMITED",
"SKYBIRD SECURITY PRIVATE LIMITED",
"SKYBLUE AERO PRIVATE LIMITED",
"SKYBLUE DIGITAL TECHNOLOGIES PRIVATE LIMITED",
"SKYBLUE HOSPITALITY PRIVATE LIMITED",
"SKYBLUE LOGISTICS INDIA PRIVATE LIMITED",
"SKYBOARD MEDIA PRIVATE LIMITED",
"SKYBRIDGE CARGO WORLD PRIVATE LIMITED",
"SKYBRIDGE INDIA DEVELOPERS PRIVATE LIMITED",
"SKYBRIDGE SOLUTIONS PRIVATE LIMITED",
"SKYBRITE INDUSTRIES PRIVATE LIMITED",
"SKYBUILD ENGINEERING CONSTRUCTION PRIVATE LIMITED",
"SKYCAR ELEVATORS PRIVATE LIMITED",
"SKYCELL DISTRIBUTION PRIVATE LIMITED",
"SKYCHEM RESINS PRIVATE LIMITED",
"SKYCITY HOTELS PRIVATE LIMITED",
"SKYCLIFF IT PRIVATE LIMITED",
"SKYCOM EXPRESS PRIVATE LIMITED",
"SKYCON SHIPPING LINE PRIVATE LIMITED",
"SKYCONTROLS AUTOMATION SYSTEMS PRIVATE LIMITED",
"SKYCORE CODEREADR PRIVATE LIMITED",
"SKYCORE TECHNOLOGIES PRIVATE LIMITED",
"SKYCRAFT INDUSTRIES PRIVATE LIMITED",
"SKYDA CARRYWELL PRIVATE LIMITED",
"SKYDA ELECTRICAL INDUSTRIES PRIVATE LIMITED",
"SKYDECK PROPERTIES AND DEVELOPERS PRIVATE LIMITED",
"SKYDECOR LAMINATES PRIVATE LIMITED",
"SKYDR TRANS PRIVATE LIMITED",
"SKYE BATTERIES PRIVATE LIMITED",
"SKYE BRIDGE SYSTEMS PRIVATE LIMITED",
"SKYE EARTH DEVELOPERS PRIVATE LIMITED",
"SKYEC DRUGS AND PHARMACEUTICALS PRIVATE LIMITED",
"SKYELON SEEDS PRIVATE LIMITED",
"SKYEO ANALYTICS PRIVATE LIMITED",
"SKYEX FREIGHT SOLUTION PRIVATE LIMITED",
"SKYFI EDUCATION LABS PRIVATE LIMITED",
"SKYFIN TRADING & CONSULTANCY PRIVATE LIMITED",
"SKYFRI ENERGY PRIVATE LIMITED",
"SKYFULL MAINTENANCE SERVICES PRIVATE LIMITED",
"SKYGO POLYMERS PRIVATE LIMITED",
"SKYGOAL SPORTS PRIVATE LIMITED",
"SKYGOURMET CATERING PRIVATE LIMITED",
"SKYGREEN BIOTECH PRIVATE LIMITED",
"SKYGREEN PLANTATIONS AND PRODUCE PRIVATE LIMITED",
"SKY-HEIGHTS INFRA SPACE PRIVATE LIMITED",
"SKYHI ASSOCIATES PRIVATE LIMITED",
"SKYHIGH HOSPITALITY PRIVATE LIMITED",
"SKYHIGH INDUSTRIES PRIVATE LIMITED",
"SKYHIGH INFRAPROJECTS PRIVATE LIMITED",
"SKYHIGH NETWORKS TECHNOLOGIES PRIVATE LIMITED",
"SKYHILL ENGINEERING PRIVATE LIMITED",
"SKYHILL GAMES PRIVATE LIMITED",
"SKYI COMPOSITES PRIVATE LIMITED",
"SKYI FKUR BIOPOLYMERS PRIVATE LIMITED",
"SKYI PATE VENTURES PRIVATE LIMITED",
"SKYIES INFRAHOME (OPC) PRIVATE LIMITED",
"SKYIMAX INDUSTRY PRIVATE LIMITED",
"SKYJET EXPRESS & LOGISTICS PRIVATE LIMITED",
"SKYJETS INTERNATIONAL PRIVATE LIMITED",
"SKYJUMPER SPORTS AND AMUSEMENTS PRIVATE LIMITED",
"SKYKING (I) TOURS AND TRAVELS PRIVATE LIMITED",
"SKYKNIT YARN PRIVATE LIMITED",
"SKYLA HOSPITALITY PRIVATE LIMITED",
"SKYLAB HYGIENE INDIA PRIVATE LIMITED",
"SKYLABS SOLUTION INDIA PRIVATE LIMITED",
"SKYLAD INDUSTRIES PRIVATE LIMITED",
"SKYLAMP INFRAHOMES PRIVATE LIMITED",
"SKYLAND FACILITY MANAGEMENT AND CONSULTANTS PRIVATE LIMITED",
"SKYLAND INTERNATIONAL PRIVATE LIMITED",
"SKYLAND TRANSPORT LTD",
"SKYLAR TECHNOLOGY PRIVATE LIMITED",
"SKYLARK CABLES AND CORDS PRIVATE LIMITED",
"SKYLARK CAGERS INDIA PRIVATE LIMITED",
"SKYLARK CMC PRIVATE LIMITED",
"SKYLARK CONSTRUCTIONS PRIVATE LIMITED",
"SKYLARK DRONES PRIVATE LIMITED",
"SKYLARK DYEING PRIVATE LIMITED",
"SKYLARK EQUIPMENTS",
"SKYLARK EXPRESS DELHI PRIVATE LIMITED",
"SKYLARK FACILITY SERVICES PRIVATE LIMITED",
"SKYLARK FEEDS PRIVATE LIMITED",
"SKYLARK FOODS PRIVATE LIMITED",
"SKYLARK GLOBAL BPO SERVICES PRIVATE LIMITED",
"SKYLARK HATCHERIES PRIVATE LIMITED",
"SKYLARK HR SOLUTIONS",
"SKYLARK INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"SKYLARK INFRA ENGINEERING PRIVATE LIMITED",
"SKYLARK PHARMACEUTICALS PRIVATE LIMITED",
"SKYLARK PRINTERS AND PUBLISHERS PRIVATE LIMITED",
"SKYLARK PROMOTERS PRIVATE LIMITED",
"SKYLARK REALTORS PRIVATE LIMITED",
"SKYLARK SECURITY SERVICES PRIVATE LIMITED",
"SKYLARK TELECOM SERVICES PRIVATE LIMITED",
"SKYLARK WAREHOUSING SOLUTIONS PRIVATE LIMITED",
"SKYLEAD LOGISTICS PRIVATE LIMITED",
"SKYLER TRADELINKS PRIVATE LIMITED",
"SKYLET PHARMA PRIVATE LIMITED",
"SKYLET POWER PRIVATE LIMITED",
"SKYLEX TECHNOLOGIES",
"SKYLIFT CARGO PRIVATE LIMITED",
"SKYLIGHT EXPRESS PRIVATE LIMITED",
"SKYLIGHT PHARMACEUTICALS PRIVATE LIMITED",
"SKYLINE ADVISORY SERVICES PRIVATE LIMITED",
"SKYLINE AIR LOGISTICS LIMITED",
"SKYLINE AIRCONDITIONING ENGINEERS PRIVATE LIMITED",
"SKYLINE ARCHCON (HYD) PRIVATE LIMITED",
"SKYLINE ARCHITECTURAL CONSULTANT PRIVATE LIMITED",
"SKYLINE AUTOMOVERS PRIVATE LIMITED",
"SKYLINE AUTOWHEELS PRIVATE LIMITED",
"SKYLINE BUILDESTATES PRIVATE LIMITED",
"SKYLINE CLUB & RESORTS PRIVATE LIMITED",
"SKYLINE CONDUCTOR PRIVATE LIMITED",
"SKYLINE DISTRIBUTORS",
"SKYLINE ENGINEERING CONTRACTS (INDIA) PVT LIMITED",
"SKYLINE FINANCIAL SERVICES PRIVATE LIMITED",
"SKYLINE FOUNDATIONS AND STRUCTURES PRIVATE LIMITED",
"SKYLINE FREIGHT & TRAVELS PRIVATE LIMITED",
"SKYLINE GLOBAL TRADE PRIVATE LIMITED",
"SKYLINE HERBALS PRIVATE LIMITED",
"SKYLINE INDUSTRIES PVT LTD",
"SKYLINE INFRABUILT CONSULTANTS PRIVATE LIMITED",
"SKYLINE INTERNATIONAL SERVICES(PVT)LTD",
"SKYLINE LANDMARK PROJECTS PRIVATE LIMITED",
"SKYLINE LIGHTING PRIVATE LIMITED",
"SKYLINE MANSION PRIVATE LIMITED",
"SKYLINE MOTORS INDIA PRIVATE LIMITED",
"SKYLINE PEEVEES PROPERTIES PVT LTD",
"SKYLINE POLYCATS PRIVATE LIMITED",
"SKYLINE POWER SOLUTIONS",
"SKYLINE PRASHASTI",
"SKYLINE RADIO NETWORK LIMITED",
"SKYLINE REALTY PRIVATE LIMITED",
"SKYLINE RESIDENCY LLP- CAT D",
"SKYLINE SHIPPING & LOGISTICS PRIVATE LIMITED",
"SKYLINE TELE MEDIA SERVICES LIMITED",
"SKYLINE TRAVELS",
"SKYLINE TRIUMPH LOGISTICS PRIVATE LIMITED",
"SKYLINE VISION PRIVATE LIMITED",
"SKYLINK AIRLINE TICKET CENTRE PRIVATE LIMITED",
"SKYLINK DEVELOPERS",
"SKYLINK EXPRESS SERVICES PRIVATE LIMITED",
"SKYLINK FIBERNET PRIVATE LIMITED",
"SKYLINK FREIGHT FORWARDERS PRIVATE LIMITED",
"SKYLINK HOSPITALITY LLP",
"SKYLINK TELECOMMUNICATIONS PRIVATE LIMITED",
"SKYLINK TRADERS PRIVATE LIMITED",
"SKYLINK TRAVEL PRIVATE LIMITED",
"SKYLITE INNOVATIONS PRIVATE LIMITED",
"SKYLITE LOGISTICS PRIVATE LIMITED",
"SKYLLER CARGO LOGISTICS INDIA PRIVATE LIMITED",
"SKYLOG MARINE INDIA PRIVATE LIMITED",
"SKYLONE INFRA SERVICES PRIVATE LIMITED",
"SKYLOR INDUSTRIAL SOLUTIONS PRIVATE LIMITED",
"SKYLUXE WELLNESS BRANDS PRIVATE LIMITED",
"SKYMAIL BUSINESS SOLUTIONS PRIVATE LIMITED",
"SKYMAIL EXPRESS SERVICES PRIVATE LIMITED",
"SKYMAP GLOBAL (INDIA) PRIVATE LIMITED",
"SKYMAP HEALTHCARE PRIVATE LIMITED",
"SKYMAP PHARMACEUTICALS PRIVATE LIMITED",
"SKYMAPS INTERNATIONAL PRIVATE LIMITED",
"SKYMARK MOTORS PRIVATE LIMITED",
"SKYMAX CERAMIC",
"SKYMAX CONSTRUCTION PRIVATE LIMITED",
"SKYMAX LIFESCIENCE PRIVATE LIMITED",
"SKYMAX LOGISTICS INDIA PRIVATE LIMITED",
"SKYMET WEATHER SERVICES PRIVATE LIMITED",
"SKYMETTLE INFRASTRUCTURES PRIVATE LIMITED",
"SKYMIT RECHARGEWALE PRIVATE LIMITED",
"SKYN CROP CARE PRIVATE LIMITED",
"SKYNET COMMOSALES PRIVATE LIMITED",
"SKYNET DIGITAL SERVICES PRIVATE LIMITED",
"SKYNET ELECTRONIC PRIVATE LIMITED",
"SKYNET E-SOLUTION PRIVATE LIMITED",
"SKYNET EXPRESS INDIA PRIVATE LIMITED",
"SKYNET INFRA DEVELOPERS PRIVATE LIMITED",
"SKYNET INFRAVENTURES PRIVATE LIMITED",
"SKYNET INTERNET BROADBAND PRIVATE LIMITED",
"SKYNET MERCANTILES PRIVATE LIMITED",
"SKYNET OVERSEAS PRIVATE LIMITED",
"SKYNIK FOOD PRODUCTS PRIVATE LIMITED",
"SKYNIK FREIGHT INDIA PRIVATE LIMITED",
"SKYONN TECHNOLOGIES PRIVATE LIMITED",
"SKYPACK INDIA PRIVATE LIMITED",
"SKYPACK LOGISTICS PRIVATE LIMITED",
"SKYPALS21 EDPREP PRIVATE LIMITED",
"SKYPASS TRAVEL PRIVATE LIMITED",
"SKYPE EMBROIDERIES PRIVATE LIMITED",
"SKYPET AND POLYMERS PRIVATE LIMITED",
"SKYPLEX SOLUTION PRIVATE LIMITED",
"SKYPOWER SERVICES ULC",
"SKYPOWER SOLAR INDIA PRIVATE LIMITED",
"SKYPRINT PACK PRIVATE LIMITED",
"SKYPRO TECHNOLOGIES PRIVATE LIMITED",
"SKYQUAD ELECTRONICS AND APPLIANCES PRIVATE LIMITED",
"SKYQUEST TECHNOLOGY CONSULTING PRIVATE LIMITED",
"SKYRA PROFESSIONAL EQUIPMENT PRIVATE LIMITED",
"SKYRAH ECOBRICKS PRIVATE LIMITED",
"SKYRAMS OUTDOOR ADVERTISINGS INDIA PRIVATE LIMITED",
"SKYRAS PRIVATE LIMITED",
"SKYRIDE ENGINEERING PVT.LTD.",
"SKYRIDER TECHNOLOGIES PRIVATE LIMITED",
"SKYRIDERS TACKSHOP OPC PRIVATE LIMITED",
"SKYRIVER INDIA PRIVATE LIMITED",
"SKYRL LOGISTICS PRIVATE LIMITED",
"SKYROS CERAMIC PRIVATE LIMITED",
"SKYROSE FINVEST PRIVATE LIMITED",
"SKYROTEK SPECIALITY CONSTRUCTION PRIVATE LIMITED",
"SKYROUTES INDIA PRIVATE LIMITED",
"SKYS ADOBE PLUS PRIVATE LIMITED",
"SKYSAILOR VENTURES PRIVATE LIMITED",
"SKYSAILORS INDIA PRIVATE LIMITED",
"SKYSCAPE DEVELOPERS PRIVATE LIMITED",
"SKYSCEND BUSINESS SOLUTIONS PRIVATE LIMITED",
"SKYSCRAPER INFOTECH PRIVATE LIMITED",
"SKYSCRAPER REALBUILD PRIVATE LIMITED",
"SKYSCRAPPERS INFRACON PRIVATE LIMITED",
"SKYSCRAPPERS REAL ESTATE PRIVATE LIMITED",
"SKYSCREEN INTERNATIONAL PRIVATE LIMITED",
"SKYSECURE TECHNOLOGIES PRIVATE LIMITED",
"SKYSENSE TECH PRIVATE LIMITED",
"SKYSHADE DAYLIGHTS PRIVATE LIMITED",
"SKYSHADE TECHNOLOGIES PRIVATE LIMITED",
"SKYSHARP IT SOLUTIONS PRIVATE LIMITED",
"SKYSHOP IMPEX PRIVATE LIMITED",
"SKYSOFT IT SERVICES PRIVATE LIMITED",
"SKYSTAR BUILDCON PRIVATE LIMITED",
"SKYSTAR ENTERTAINMENT PRIVATE LIMITED",
"SKYSTAR EXPORTS PRIVATE LIMITED",
"SKYSTAR LAMINATES PRIVATE LIMITED",
"SKYSTAR LOGISTICS PRIVATE LIMITED SKYSTA",
"SKYSTAR SHIPPING AGENCIES PRIVATE LIMITED",
"SKYSTAY HOTEL VENTURES PRIVATE LIMITED",
"SKYSTOCK SERVICES INDIA PRIVATE LIMITED",
"SKYSUN LIFESCIENCES PRIVATE LIMITED",
"SKYSURGE BUSINESS SOLUTIONS PRIVATE LIMITED",
"SKYTEAM LOGISTIC PRIVATE LIMITED",
"SKYTECH CONSTRUCTIONS PRIVATE LIMITED",
"SKYTECH ENGINEERS PRIVATE LIMITED",
"SKYTECH INFINITE PLATFORM PRIVATE LIMITED",
"SKYTECH MEDICOS PRIVATE LIMITED",
"SKYTECH ROLLING MILL PRIVATE LIMITED",
"SKYTECH SOFTECH PRIVATE LIMITED",
"SKYTECH SWITCHGEAR PRIVATE LIMITED",
"SKYTECH SYSTEMS INDIA PRIVATE LIMITED",
"SKYTEL TELE - SERVICES PRIVATE LIMITED",
"SKYTEX UNMANNED AERIAL SOLUTIONS PRIVATE LIMITED",
"SKYTONE FOODS PRIVATE LIMITED",
"SKYTOP PROJECTS PRIVATE LIMITED",
"SKYTOUCH CERAMIC PRIVATE LIMITED",
"SKYTOUCH TAPES PVT LTD",
"SKYTOUCHE AGGREGATE PRIVATE LIMITED",
"SKYTRACK TOURS & TRAVELS PRIVATE LIMITED",
"SKYTREE CONSULTING ENGINEERS (I) PRIVATE LIMITED",
"SKYTRON ENGINEERING PRIVATE LIMITED",
"SKYVECTORS PRIVATE LIMITED",
"SKYWARD INFRASTRUCTURE PRIVATE LIMITED",
"SKYWARD TECHNO SOLUTIONS PRIVATE LIMITED",
"SKYWAY CARGO CARRIERS INDIA PRIVATE LIMITED",
"SKYWAY COMPUTERS PRIVATE LIMITED",
"SKYWAY HOMES PRIVATE LIMITED",
"SKYWAY INDUSTRIAL ESTATE COMPANY PRIVATE LIMITED",
"SKYWAY INFO SOLUTIONS PRIVATE LIMITED",
"SKYWAY INFRAPROJECTS PRIVATE LIMITED",
"SKYWAY MARKETING PRIVATE LIMITED",
"SKYWAY POLYMERS PRIVATE LIMITED",
"SKYWAY RMC PLANTS PRIVATE LIMITED",
"SKYWAY ROADLINES PRIVATE LIMITED",
"SKYWAY TELEVENTURE PRIVATE LIMITED",
"SKYWAYS AIR SERVICES PRIVATE LIMITED",
"SKYWAYS TOURS PRIVATE LIMITED",
"SKYWAYS TOWNSHIP PRIVATE LIMITED",
"SKYWIN SPINNING PRIVATE. LIMITED.",
"SKYWING CARRIERS PRIVATE LIMITED",
"SKYWINGS HOLIDAYS",
"SKYWINGS INTERNATIONAL TRAVELS PRIVATE LIMITED",
"SKYWIZZ EVENTS & ADVERTISING INDIA PRIVATE LIMITED",
"SKYWORLD TOURS & TRAVELS PRIVATE LIMITED",
"SKYWORTH INDIA ELECTRONICS PRIVATE LIMITED",
"SKYY RIDER ELECTRIC PRIVATE LIMITED",
"SKYYLIVES INFOTECH PRIVATE LIMITED",
"SKYZ STONES PRIVATE LIMITED",
"SKYZED SECURITASK AND SERVICES PRIVATE LIMITED",
"SKYZEN INFRABUILD PRIVATE LIMITED",
"SKYZONE PARKING SYSTEMS PRIVATE LIMITED",
"SL AP PRIVATE LIMITED",
"SL CHOKHANY LEASING & FINANCE COMPANY PRIVATE LIMITED",
"SL CLOTHING PRIVATE LIMITED",
"SL COKES LIMITED",
"SL CORBOX PRIVATE LIMITED",
"SL ELEVATORS INDIA PRIVATE LIMITED",
"SL LIVING SPACES PRIVATE LIMITED",
"SL LOGISTICS",
"SL LUMAX LIMITED",
"SL NUTRITIONS PRIVATE LIMITED",
"SL RAHEJA HOSPITAL",
"SL SHIPPING AND LOGISTICS PRIVATE LIMITED",
"SL TECHKNOW SOLUTIONS INDIA PRIVATE LIMITED",
"SL4 TECHNOLOGY INDIA PRIVATE LIMITED",
"SLA ENGINEERING PRIVATE LIMITED",
"SLA FINSERV PRIVATE LIMITED",
"SLA IMPEX PRIVATE LIMITED",
"SLACH HYDRATECS EQUIPMENT PRIVATE LIMITED",
"SLACH RUBBER MAC PRIVATE LIMITED",
"SLAK FOREX PRIVATE LIMITED",
"SLANEY HEALTHCARE PRIVATE LIMITED",
"SLANG CONCEPT DEVELOPMENT PRIVATE LIMITED",
"SLASH21 SPORTS MANAGEMENT PRIVATE LIMITED",
"SLASHRTC SOFTWARE SERVICES PRIVATE LIMITED",
"SLATE THE SCHOOL",
"SLAYBACK PHARMA INDIA LLP",
"SLB CLEAN POWER PRIVATE LIMITED",
"SLB FLAVOURS & INGREDIENTS PRIVATE LIMITED",
"SLB HOSPITAL PRIVATE LIMITED",
"SLB LOGISTICS PRIVATE LIMITED",
"SLB REALTY (OPC) PRIVATE LIMITED",
"SLC INDUSTRIES INDIA PRIVATE LIMITED",
"SLC PROJECTS PRIVATE LIMITED",
"SLC RESOURCES PRIVATE LIMITED",
"SLCS ENTERPRISES (OPC) PRIVATE LIMITED",
"SLE GAS TECHNOLOGIES PRIVATE LIMITED",
"SLE TECHNOLOGY CONSULTING INDIA PRIVATE LIMITED",
"SLEC INFRA PROJECTS PRIVATE LIMITED",
"SLEDGEHAMMER OIL TOOLS PRIVATE LIMITED.",
"SLEDGEHAMMER WORKS PRIVATE LIMITED",
"SLEEBA & SONS AUTOMOTIVE PRIVATE LIMITED",
"SLEEK BUILDTECH PRIVATE LIMITED",
"SLEEK INTERNATIONAL PRIVATE LIMITED",
"SLEEK PHARMACEUTICALS PRIVATE LIMITED",
"SLEEK PRINTING & PACKAGING PRIVATE LIMITED",
"SLEEP MANAGEMENT PRIVATE LIMITED",
"SLEEP PRODUCTS MANUFACTURING COMPANY PRIVATE LIMITED",
"SLEEPIZ INDIA PRIVATE LIMITED",
"SLEEPLOOP INDIA PRIVATE LIMITED",
"SLEEPOTEX OVERSEAS PRIVATE LIMITED",
"SLEEPSIA INDIA PRIVATE LIMITED",
"SLEEPSURE COMFORT PRODUCTS PRIVATE LIMITED",
"SLEEPSUTRAA PRIVATE LIMITED",
"SLEEPY EDUSOLUTIONS PRIVATE LIMITED",
"SLEEPYHEAD HOME DECOR PRIVATE LIMITED",
"SLEKHA DESIGNER PRIVATE LIMITED",
"SLEUTHS INDIA CONSULTANCY PRIVATE LIMITED",
"SLG COMMODITIES PRIVATE LIMITED",
"SLG DEVELOPER AND PROMOTOR PRIVATE LIMITED",
"SLG ELECTRONICS PRIVATE LIMITED",
"SLG GEHENA PRIVATE LIMITED",
"SLG HOSPITALS",
"SLG JEWELLERS PRIVATE LIMITED",
"SLG KUMAR ENGINEERING INDUSTRIES PRIVATE LIMITED",
"SLG KUMAR PUMPS AND MOTORS",
"SLG RETAIL PRIVATE LIMITED",
"SLH ENGINEERING",
"SLI POWER ENGINEERS PRIVATE LIMITED",
"SLI SERVICES PRIVATE LIMITED",
"SLICER SOLUTIONS PRIVATE LIMITED",
"SLICK EVENT MANAGEMENT (OPC) PRIVATE LIMITED",
"SLICK ORGANICS PRIVATE LIMITED",
"SLICK SOFTWARE SOLUTIONS PRIVATE LIMITED",
"SLIDER BAGS BENGALURU PRIVATE LIMITED",
"SLIDERULE LABS INDIA PRIVATE LIMITED",
"SLIDEWELL MEILLEUR-TECH PRIVATE LIMITED",
"SLIDEXPRESS PRIVATE LIMITED",
"SLIEVE FABRICS PRIVATE LIMITED",
"SLIMLITES ELECTRICALS PRIVATE LIMITED",
"S-LINE TECHNOLOGIES PRIVATE LIMITED",
"SLING FLEXI CARTONS PRIVATE LIMITED",
"DISH NETWORK TECHNOLOGIES INDIA PRIVATE LIMITED",
"SLINTEL INDIA PRIVATE LIMITED",
"SLIPCO CONSTRUCTIONS PRIVATE LIMITED",
"SLIPSTREAM IT SOLUTIONS PRIVATE LIMITED",
"SLIQ INDFORMATION TECHNOLOGIES PRIVATE LIMITED",
"SLJ ENTERPRISES PRIVATE LIMITED",
"SLJ INFRACON PRIVATE LIMITED",
"SLK BIMA BROKERS PRIVATE LIMITED",
"SLK ENGINEERS PRIVATE LIMITED",
"SLK GLOBAL SOLUTIONS PRIVATE LIMITED",
"SLK KRISHNA FOODS PRIVATE LIMITED",
"SLK LOGISTICS INDIA PRIVATE LIMITED",
"SLK PROGRESSIVE VENEER PRIVATE LIMITED",
"SLK SOFTWARE PRIVATE LIMITED",
"SLKMD JEWELS PRIVATE LIMITED",
"SLL CAPITAL INDIA PRIVATE LIMITED",
"SLM APPLIANCES PRIVATE LIMITED",
"SLM CONTRACTS PRIVATE LIMITED",
"SLM EDUCATIONAL SERVICES PRIVATE LIMITED",
"SLM HOME PRODUCTS PRIVATE LIMITED",
"SLM METAL PRIVATE LIMITED",
"SLM TECHNOLOGY PRIVATE LIMITED",
"SLMG BEVERAGES PRIVATE LIMITED",
"SLMI INFRAPROJECTS PRIVATE LIMITED",
"SLN AUTOMATION INDIA PRIVATE LIMITED",
"SLN BUILDCON INDIA PRIVATE LIMITED",
"SLN BULLION PRIVATE LIMITED",
"SLN COFFEE AND SPICES EXPORTS PRIVATE LIMITED",
"SLN COFFEE PRIVATE LIMITED",
"SLN COLLEGE",
"SLN ELECTRICALS & SARAN INSULATORS PRIVATE LIMITED",
"SLN ENTERPRISES PRIVATE LIMITED",
"SLN FACILITY MANAGEMENT PRIVATE LIMITED",
"SLN JEWELLERY PRIVATE LIMITED",
"SLN PHARMACHEM PRIVATE. LIMITED",
"SLN ROCKSTONES PRIVATE LIMITED",
"SLN TECH-FABS (BENGALURU) PRIVATE LIMITED",
"SLN TECHNOLOGIES PRIVATE LIMITED",
"SLN TERMINUS HOTELS & RESORTS PRIVATE LIMITED",
"SLNKO ENERGY PRIVATE LIMITED",
"SLNS MINERALS PRIVATE LIMITED",
"SLOG SQUARE ELECTROMECH PRIVATE LIMITED",
"SLOGAN POLYPACK PRIVATE LIMITED",
"SLOGANS FIBC PRIVATE LIMITED",
"SLOGANTAGSZ CLEAR DISPLAYS INDIA PRIVATE LIMITED",
"SLOKA ADVERTISING PRIVATE LIMITED",
"SLOKA THE SCHOOL",
"SLOTCO STEEL PRODUCTS PRIVATE LIMITED",
"SLOWFORM MEDIA PRIVATE LIMITED",
"SLP INFRA ENGINEERS PRIVATE LIMITED",
"SLP VYAPAAR PRIVATE LIMITED",
"SLPT MOTORS PRIVATE LIMITED",
"SLR BPO SERVICES OPCPRIVATE LIMITED",
"SLR CONSTRUCTION PRIVATE LIMITED",
"SLR FINLEASE LIMITED",
"SLR FOODS PRIVATE LIMITED",
"SLR HATCHERIES PRIVATE LIMITED",
"SLR METALIKS LIMITED",
"SLR PROPMART LIMITED",
"SLRD MEMORIAL HOSPITAL",
"SLRI SOLUTIONS PRIVATE LIMITED",
"SLRL AGENCIES PRIVATE LIMITED",
"SLS DESIGNS INDIA PRIVATE LIMITED",
"SLS EXPORTS PRIVATE LIMITED",
"SLS MERCANTILE PRIVATE LIMITED",
"SLS OVERSEAS PRIVATE LIMITED",
"SLS ZIPPERS LIMITED",
"SLSR CONSTRUCTIONS PRIVATE LIMITED",
"SLSURESH SILVERWARE PRIVATE LIMITED",
"SLT CEMENT MARKETERS PRIVATE LIMITED",
"SLT INFRACON PRIVATE. LIMITED.",
"SLU EXPORT PRIVATE LIMITED",
"SLUSBY TECHNOLOGIES PRIVATE LIMITED",
"SLV AGRO FOODS",
"SLV CONSULTING PRIVATE LIMITED",
"SLV DEVELOPERS PRIVATE LIMITED",
"SLV EARTH MOVERS PRIVATE LIMITED",
"SLV ENGINEERING WORKS",
"SLV ENTERPRISES PRIVATE LIMITED",
"SLV FACILITY MANAGEMENT PRIVATE LIMITED",
"SLV SECURITY SERVICES PRIVATE LIMITED",
"SLV TRANSPORTS INDIA PRIVATE LIMITED",
"SLV VENTURES INDIA PRIVATE LIMITED",
"SLVR AIRCOMFORT SYSTEMS PRIVATE LIMITED",
"SLVS INFRA EQUIPMENTS PRIVATE LIMITED",
"SLY LOGTRADE PRIVATE LIMITED",
"SLYDS SERVICES PRIVATE LIMITED",
"SLYLANDRO POWER PRIVATE LIMITED",
"SLZTECH AUTOMATION INDIA PRIVATE LIMITED",
"SM AGENCY",
"SM AKER MANAGEMENT SERVICES PRIVATE LIMITED",
"SM ANANYA PRODUCTS (OPC) PRIVATE LIMITED",
"SM AUTO STAMPING LIMITED",
"SM AUTO STAR PRIVATE LIMITED",
"SM AUTOVISION PRIVATE LIMITED",
"SM BHANDARI ARTS RR BHANDARI COMMERCE AND SKR SCIENCE COLLEGE",
"SM BOUND SERVICES PRIVATE LIMITED",
"SM CAR PRIVATE LIMITED",
"SM CONCAST PRIVATE LIMITED",
"SM CORPORATION LIMITED",
"SM DENTAL SOLUTIONS PRIVATE LIMITED",
"SM DHARANI CHEM PRIVATE LIMITED",
"SM DIAMONDS PRIVATE LIMITED",
"SM ELECTRONIC TECHNOLOGIES PRIVATE LIMITED",
"SM ENVIRONMENTAL TECHNOLOGIES PRIVATE. LIMITED.",
"SM EXHAUST TECHNOLOGY PRIVATE LIMITED",
"SM EXPRESS LOGISTICS PRIVATE LIMITED",
"SM FINLEASE LIMITED",
"SM FLEXDUCT PRIVATE LIMITED",
"SM FLOW & CONTROLS PRIVATE LIMITED",
"SM FROZEN FOODS PRIVATE LIMITED",
"SM GREENLAM INVESTMENTS PRIVATE LIMITED",
"SM HERBALS PRIVATE LIMITED",
"SM INFRASTRUCTURE PRIVATE LIMITED",
"SM ISPAT LIMITED",
"SM JDB ESTATE PRIVATE LIMITED",
"SM LABS PRIVATE LIMITED",
"SM LIFE SCIENCES PRIVATE LIMITED",
"SM LPG CYLINDERS PRIVATE LIMITED",
"SM METALAND ENGINEERING",
"SM MILKOSE LIMITED",
"SM NETSERV TECHNOLOGIES PRIVATE LIMITED",
"SM NETWORKS & SOLUTIONS PRIVATE LIMITED",
"SM POLYMERS & FILM SOLUTIONS PRIVATE LIMITED",
"SM SHOP A DOCKET INDIA PRIVATE LIMITED",
"SM SONS HOLDINGS PRIVATE LIMITED",
"SM SUN POWER LIMITED",
"SM TECHNO CONSULTANTS PRIVATE LIMITED",
"SMA DEVICES PRIVATE LIMITED",
"SMA E-EXPERTS PRIVATE LIMITED",
"SMA INTERNATIONAL MAKEUP ACADEMY PRIVATE LIMITED",
"SMA MINERAL TRADING PRIVATE LIMITED",
"SMA MULTISERVICES PRIVATE LIMITED",
"SMA POWER CONTROL PRIVATE LIMITED",
"SMA SOLAR INDIA PRIVATE LIMITED",
"SMAAASH LEISURE LIMITED",
"SMAARTT DIGITAL CONSULTING PRIVATE LIMITED",
"SMAAT INDIA PRIVATE LIMITED",
"SMAC TECHNOLOGY LABS PRIVATE LIMITED",
"SMACO ENGINEERING PRIVATE LIMITED",
"SMAG PEINER GRABS (INDIA) PRIVATE LIMITED",
"SMAG RETAILS PRIVATE LIMITED",
"SMAK FILM PRIVATE LIMITED",
"SMALL AND MEDIUM BUSINESS DEVELOPMENT CHAMBER OF INDIA",
"SMALL ARMS FACTORY KANPUR",
"SMALL INDUSTRIES DEVELOPMENT BANK OF INDIA",
"SMALL INDUSTRIES DEVELOPMENT BANK OF INDIASIDBI",
"SMALL INDUSTRIES SERVICE INSTITUTE",
"SMALL INDUSTRIES TESTING AND RESEARCH CE",
"SMALL JOHNSON FLOOR TILES PRIVATE LIMITED",
"SMALL SAVINGS DEPTT",
"SMALL SCREEN FILM & TELEVISION PRIVATE LIMITED",
"SMALL STREAM INDIA PRIVATE LIMITED",
"SMALL WONDER SECONDARY SCHOOL",
"SMALL WORLD DIGITAL SERVICES PRIVATE LIMITED",
"SMALLDAY IT SERVICES PRIVATE LIMITED",
"SMALTICERAM INDIA PRIVATE LIMITED",
"SMALTOCHEM INDIA PRIVATE LIMITED",
"SMAM AUTOMART PRIVATE LIMITED",
"SMAP BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"SMARAKON SANGRHALAYON SANSATHAO PARKO V UPVANO AADI KI PRABANDHAN SURAKSHA AVAM ANURAKSHAN SAMITI LUCKNOW BOUDH VIHAR SHANTI UPVAN LUCKNOW",
"SMARAN PROJECTS PRIVATE LIMITED",
"SMARCO INDUSTRIES PRIVATE LIMITED",
"SMARDOCE SOLUTIONS PRIVATE LIMITED",
"SMARDTV GLOBAL TECHNOLOGY PRIVATE LIMITED",
"SMARGAV SOLUTIONS PRIVATE LIMITED",
"SMARK ENGINEERS PRIVATE LIMITED",
"SMARKETERS LLP",
"SMARKO SANGARLAYO,SANTHAYO,PARKO EVAM UPWANO KI MANAGEMENT,SECURITY EVAM ANURAKSHAN SAMITI",
"SMARNIYA INFRA VENTURE PRIVATE LIMITED",
"SMARNIYA PROPERTIES PRIVATE LIMITED",
"SMARSH INDIA PRIVATE LIMITED",
"SMART 24*7 RESPONSE SERVICES PRIVATE. LIMITED",
"SMART AGE FASHION PRIVATE LIMITED",
"SMART AGRO FOOD PARK PRIVATE LIMITED",
"SMART ANALYST INDIA PRIVATE LIMITED",
"SMART APPLICATION SOLUTIONS PRIVATE LIMITED",
"SMART BEE FACILITY SERVICES PRIVATE LIMITED",
"SMART BHARAT PRIVATE LIMITED",
"SMART BILAL INDIA HOUSING PRIVATE LIMITED",
"SMART BOARDS (INDIA) PRIVATE LIMITED",
"SMART BRANDS PRODUCTS PRIVATE LIMITED",
"SMART CABLES AND CORDS PRIVATE LIMITED",
"SMART CALL CENTER SOLUTIONS PVT LTD",
"SMART CARS LIMITED",
"SMART CARS PRIVATE LIMITED",
"SMART CHIP PRIVATE LIMITED",
"SMART CITY AHMEDABAD DEVELOPMENT LIMITED",
"SMART CLASS EDUCATIONAL SERVICES PRIVATE LIMITED",
"SMART CLIENT IT INNOVATIONS",
"SMART CLOUD COMPUTING PRIVATE LIMITED",
"SMART COLLABORATIVE SOLUTIONS INDIA PRIVATE LIMITED",
"SMART COMMERCE SOLUTIONS PRIVATE LIMITED",
"SMART CONTROL ELECTRICALS PRIVATE LIMITED",
"SMART CONTROLS INDIA LIMITED",
"SMART CONVEYER DESIGN SOLUTIONS PRIVATE LIMITED",
"SMART CRAFT PRIVATE LIMITED",
"SMART CUBE INDIA PRIVATE LIMITED",
"SMART CUBE INIDIA PRIVATE LIMITED",
"SMART CUSTOMER SERVICES PRIVATE LIMITED",
"SMART DATAPROCESSING SERVICES PRIVATE LIMITED",
"SMART DETECTIVE & ALLIED SERVICES (INDIA) PRIVATE LIMITED",
"SMART ENERGY SUNRISE SOLAR SYSTEM PRIVATE LIMITED",
"SMART ENOVATIONS INDIA PRIVATE LIMITED",
"SMART EQUIPMENTS PRIVATE LIMITED",
"SMART EQUITY BROKERS PRIVATE LIMITED",
"SMART ERP SOLUTIONS INDIA PRIVATE LIMITED",
"SMART ERP TECHNOLOGIES INDIA PRIVATE LIMITED",
"SMART ESHOP PRIVATE LIMITED",
"SMART FINSEC LIMITED",
"SMART GRAPH ART ADVERTISING PRIVATE LIMITED",
"SMART HYPERMARKET (INDIA) PRIVATE LIMITED",
"SMART I ELECTRONIC SYSTEMS PRIVATE LIMITED",
"SMART I T SERVICES PRIVATE LIMITED",
"SMART INFOCOM PRIVATE LIMITED",
"SMART INFORCE COMPUTING INDIA PRIVATE LIMITED",
"SMART INFORMATION MANAGEMENT SYSTEMS (INDIA) PRIVATE LIMITED",
"SMART INSTRUMENTS COMPANY PRIVATE LIMITED",
"SMART IOPS (INDIA) RESEARCH CENTER PRIVATE LIMITED",
"SMART IT PARK (NAGPUR) PRIVATE LIMITED",
"SMART IT-CONCEPTS (NGP) PRIVATE LIMITED",
"SMART JOULES PRIVATE LIMITED",
"SMART KID - ABACUS LEARNING PRIVATE LIMITED",
"SMART KITCHENS GALLERY PRIVATE LIMITED",
"SMART LABORATORIES PRIVATE LIMITED",
"SMART LABTECH PRIVATE LIMITED",
"SMART LEARN EDUCARE PRIVATE LIMITED",
"SMART LIVING HOME AUTOMATION PRIVATE LIMITED",
"SMART LIVING RETAIL PRIVATE LIMITED",
"SMART MACHINERIES AND MOULDS PRIVATE LIMITED",
"SMART MANAGEMENT &FACILITY SOLUTION",
"SMART MARINE SERVICES PRIVATE LIMITED",
"SMART MARKETING",
"SMART MEDISCIENCE PRIVATE LIMITED",
"SMART METAL COMPONENTS PRIVATE LIMITED",
"SMART MINDS ACADEMY",
"SMART MOBILE PAYMENTS PRIVATE LIMITED",
"SMART MODERN SCHOOL",
"SMART MONITORING & SURVEILLANCE PRIVATE LIMITED",
"SMART MOTORS PRIVATE LIMITED",
"SMART MOVE HOUSING PRIVATE LIMITED",
"SMART NET INDIA PRIVATE LIMITED",
"SMART OILS PETRO CHEM PRIVATE LIMITED",
"SMART PARKING INDIA PRIVATE LIMITED",
"SMART PARTS ONLINE PRIVATE LIMITED",
"SMART PAYMENT SOLUTIONS PRIVATE LIMITED",
"SMART PLANET IT SOLUTIONS PRIVATE LIMITED",
"SMART PLANNER PRIVATE LIMITED",
"SMART POINT TECHNOLOGIES PRIVATE LIMITED",
"SMART POWER FOR RURAL DEVELOPMENT INDIA FOUNDATION",
"SMART REPORTS TECHNOLOGIES PRIVATE LIMITED",
"SMART RESEARCH ANALYTICA SERVICES PRIVATE LIMITED",
"SMART RETAIL PRIVATE LIMITED",
"SMART RIDE TRIP PLANNER PRIVATE LIMITED",
"SMART ROOF SOLAR SOLUTIONS PRIVATE LIMITED",
"SMART ROOFING & CEILING SYSTEM PRIVATE LIMITED",
"SMART ROOFING PRIVATE LIMITED",
"SMART RS SERVICES P LIMITED",
"SMART SCHOOL EDUCATION PRIVATE LIMITED",
"SMART SENTRY AI INDIA PRIVATE LIMITED",
"SMART SHIP INNOVATIVE SOLUTIONS PRIVATE LIMITED",
"SMART SHIP LOGISTICS PRIVATE LIMITED",
"SMART SKILL TECH PRIVATE LIMITED",
"SMART SKILLS TRAINING PRIVATE LIMITED",
"SMART SOFT INDIA SOLUTIONS PRIVATE LIMITED",
"SMART SOFTWARE TESTING SOLUTIONS INDIA PRIVATE LIMITED",
"SMART STAINLESS TUBES PRIVATE LIMITED",
"SMART STARW INDIA PRIVATE LIMITED",
"SMART STUDY",
"SMART STYLE FASHIONS PRIVATE LIMITED",
"SMART SUPPLY CHAIN MANAGEMENT SOFTWARE PRIVATE LIMITED",
"SMART SYSTEMS SOLUTIONS PRIVATE LIMITED",
"SMART TAILOR",
"SMART TALK SOLUTIONS INDIA PRIVATE LIMITED",
"SMART TECH INFOSYSTEMS PRIVATE LIMITED",
"SMART TECH OVERSEAS",
"SMART TECHNO SYSTEM (INDIA) PRIVATE LIMITED",
"SMART TECHNOCRATS AND CONSULTANCY SERVICES I PRIVATE LIMITED",
"SMART TELESYSTEM INDIA PRIVATE LIMITED",
"SMART TOOLING SOLUTION PRIVATE LIMITED",
"SMART TRAINING RESOURCES INDIA PRIVATE LIMITED",
"SMART TRIP TOUR AND TRAVELS PRIVATE LIMITED",
"SMART UTILITY SERVICES PRIVATE LIMITED",
"SMART VALUE EQUISEARCH PRIVATE LIMITED",
"SMART VALUE HOMES BOISAR PRIVATE LIMITED",
"SMART VALUE HOMES NEW PROJECT LLP",
"SMART VALUE HOMES PEENYA PROJECT PRIVATE LIMITED",
"SMART VINIMAY PVT LTD",
"SMART VISION COMMUNICATIONS PRIVATE LIMITED",
"SMART VISION PRIVATE LIMITED",
"SMART WELLNESS PRIVATE LIMITED",
"SMART WHEELS PRIVATE LIMITED",
"SMART WIRELESS PRIVATE LIMITED",
"SMARTAGE PROJECTS PRIVATE LIMITED",
"SMARTAIR INTEGRATED TECHNOLOGIES PRIVATE LIMITED",
"SMARTAK FOOTCARE PRIVATE LIMITED",
"SMARTAUDIT SERVICES PRIVATE LIMITED",
"SMART-AUTOMATION AND LV SYSTEMS PRIVATE LIMITED",
"SMARTBIZ TECHNOLOGIES PRIVATE LIMITED",
"SMARTBOX ECOMMERCE SOLUTIONS PRIVATE LIMITED",
"SMARTBRAINS ENGINEERS & TECHNOLOGIST PRIVATE LIMITED",
"SMARTBRIDGE EDUCATIONAL SERVICES PRIVATE LIMITED",
"SMARTBRIDGE TRADING SOLUTIONS PRIVATE LIMITED",
"SMARTBYTES TECHNOLOGY SERVICES PRIVATE LIMITED",
"SMARTCARE ANALYTICA PRIVATE LIMITED",
"SMARTCHAIN INNOVATION PRIVATE LIMITED",
"SMARTCHAINERS PRIVATE LIMITED",
"SMARTCHEM TECHNOLOGIES LIMITED",
"SMARTCIRQLS INFOTECH PRIVATE LIMITED",
"SMARTCITY (KOCHI) INFRASTRUCTURE PRIVATE LIMITED",
"SMARTCLOUD INFOFUSION PRIVATE LIMITED",
"SMARTCLOUD INFOSERVICES PRIVATE LIMITED",
"SMARTCOIN FINANCIALS PRIVATE LIMITED",
"SMARTCONNECT TECHNOLOGIES PRIVATE LIMITED",
"SMARTCOOL SYSTEMS PRIVATE LIMITED",
"SMARTCOW AI TECHNOLOGIES PRIVATE LIMITED",
"SMARTDATA ENTERPRISES INDIA LIMITED",
"SMARTDOCS BUSINESS SOLUTIONS PRIVATE LIMITED",
"SMARTDRIVE SYSTEMS (INDIA) PRIVATE LIMITED",
"SMARTDV IP SOLUTIONS PRIVATE LIMITED",
"SMARTDV TECHNOLOGIES INDIA PRIVATE LIMITED",
"SMARTE DAAS PRIVATE LIMITED",
"SMARTE SOLUTIONS PRIVATE LIMITED",
"SMARTECH ENGINEERING AND SERVICES PRIVATE LIMITED",
"SMARTECH GRAPHICS PRIVATE LIMITED",
"SMARTECH INNOVATIONS PRIVATE LIMITED",
"SMARTECH INTERACTIVE PRIVATE LIMITED",
"SMARTEDGE TECHNOLOGIES PRIVATE LIMITED",
"SMARTEK CONSULTANCY SERVICES INDIA PRIVATE LIMITED",
"SMARTEK21 PRIVATE LIMITED",
"SMARTEL",
"SMARTEN POWER SYSTEMS PRIVATE LIMITED",
"SMARTEN SCHOOL",
"SMARTENVIRO SYSTEMS PRIVATE LIMITED",
"SMARTER BIZ TECHNOLOGIES PRIVATE LIMITED",
"SMARTER E-LEARNING PRIVATE LIMITED",
"SMARTERHOMES TECHNOLOGIES PRIVATE LIMITED",
"SMARTERP CONSULTING PRIVATE LIMITED",
"SMARTESTING SOFTWARE SOLUTIONS INDIA PRIVATE LIMITED",
"SMARTEX POLYFABS PRIVATE LIMITED",
"SMARTFISH DESIGNS PRIVATE LIMITED",
"SMARTFIT ENGINEERS PRIVATE LIMITED",
"SMARTFLOW ENGINEERING SERVICES PRIVATE LIMITED",
"SMARTFOODSAFE INDIA PRIVATE LIMITED",
"SMARTGAIN CAPITAL MANAGEMENT PRIVATE LIMITED",
"SMARTGEN INFRA PRIVATE LIMITED",
"SMARTGEN TECHNOLOGIES PRIVATE LIMITED",
"SMARTHA ENTERPRISES PRIVATE LIMITED",
"SMARTHOMES DEVELOPERS (INDIA) PRIVATE LIMITED",
"SMARTHOMES INFRASTRUCTURE PRIVATE LIMITED",
"SMARTHOPE HEALTHTECH VISIONS PRIVATE LIMITED",
"SMARTHOUSING BUILDCON LIMITED",
"SMARTHUB INNOVATION PRIVATE LIMITED",
"SMARTICE DEVICE GLOBAL PRIVATE LIMITED",
"SMARTICE LLP",
"SMARTIVITY LABS PRIVATE LIMITED",
"SMARTLABS CONSULTING PRIVATE LIMITED",
"SMARTLENS PARKING SOLUTIONS PRIVATE LIMITED",
"SMARTLIFE PRODUCTS PRIVATE LIMITED",
"SMARTLINE IT SOLUTION PRIVATE LIMITED",
"SMARTLINE METAL PRIVATE LIMITED",
"SMARTLINK BROADBAND SERVICES PRIVATE LIMITED",
"SMARTLINK HOLDINGS LIMITED",
"SMARTLINK NETWORK SYSTEMS LIMITED",
"SMARTLINK REALTY PRIVATE LIMITED",
"SMARTLINK SOLUTIONS PRIVATE LIMITED",
"SMARTLY BUILT SOFTWARE PRIVATE LIMITED",
"SMARTLYTICS INNOVATIONS PRIVATE LIMITED",
"SMARTMETERS TECHNOLOGIES PRIVATE LIMITED",
"SMARTMILE GLOBAL TECHNOLOGIES PRIVATE LIMITED",
"SMARTMIND ENERGY LLP",
"SMARTMOVE DEVELOPERS PRIVATE LIMITED",
"SMARTNET IT SOLUTIONS AP PRIVATE LIMITED",
"SMARTNET SOFTWARE PRIVATE LIMITED",
"SMARTNODE AUTOMATIONS PRIVATE LIMITED",
"SMARTONAPP TECHNOLOGIES PRIVATE LIMITED",
"SMARTOUS CONSULTING SERVICES PRIVATE LIMITED",
"SMARTPANEL INDIA PRIVATE LIMITED",
"SMARTPOINT TECHNOLOGIES PRIVATE LIMITED",
"SMARTPOWER AUTOMATION PRIVATE LIMITED",
"SMARTSENSE CONSULTING SOLUTIONS PRIVATE LIMITED",
"SMARTSENSE TECHNOLOGIES PRIVATE LIMITED",
"SMARTSERVE HOUSEWARE PRIVATE LIMITED",
"SMARTSHIFT LOGISTICS SOLUTIONS PRIVATE LIMITED",
"SMARTSHIFT TECHNOLOGIES PRIVATE LIMITED",
"SMARTSHOP GLOBAL E-SERVICES PRIVATE LIMITED",
"SMARTSHORE INFOSERVICES PRIVATE LIMITED",
"SMARTSIGN DESIGNS INDIA PRIVATE LIMITED",
"SMARTSKILLS BITS AND BYTES PRIVATE LIMITED",
"SMARTSKY CARGO LOGISTICS PRIVATE LIMITED",
"SMARTSOC SOLUTIONS PRIVATE LIMITED",
"SMARTSPACES DWELLING PRIVATE LIMITED",
"SMARTSTATZ SOLUTIONS LLP",
"SMARTSTONE PRIVATE LIMITED",
"SMARTSTREAM RDU INDIA PRIVATE LIMITED",
"SMARTSTREAM TECHNOLOGIES INDIA PRIVATE LIMITED",
"SMARTSTYLEZ VENTURES PRIVATE LIMITED",
"SMARTTECH INFRA SERVICES PRIVATE LIMITED",
"SMARTTECH SECURE SOLUTION PRIVATE LIMITED",
"SMARTTRAK SOLAR SYSTEMS PRIVATE LIMITED",
"SMARTTRENDS ELECTRONICS PRIVATE LIMITED",
"SMARTTRON AUTOMATIONS PRIVATE LIMITED",
"SMARTVIZS PRIVATE LIMITED",
"SMARTWARE TECHNOLOGIES PRIVATE LIMITED",
"SMART-WAVES TECHNOLOGIES PRIVATE LIMITED",
"SMARTWEB INTERNET SERVICES LIMITED",
"SMARTWHEELS PRIVATE LIMITED",
"SMARTWIN GLOBAL SALUTATIONS PRIVATE LIMITED",
"SMARTWORKS COWORKING SPACES PRIVATE LIMITED",
"SMARTX SERVICES LIMITED",
"SMAS AUTO LEASING INDIA PRIVATE LIMITED",
"SMASHX STRATEGIES PRIVATE LIMITED",
"SMAY VENTURES PRIVATE LIMITED",
"SMAYAN HEALTHCARE PRIVATE LIMITED",
"SMB CORRUPLAST PRIVATE LIMITED",
"SMB ENABLERS PRIVATE LIMITED",
"SMB HOTELS AND RESORTS PRIVATE LIMITED",
"SMB INTER COLLEGE",
"SMB MARKETING PVT LTD",
"SMB MEDICAL DEVICES PRIVATE LIMITED",
"SMB PHARMA PRIVATE LIMITED",
"SMB SYSTEMS PRIVATE LIMITED",
"SMB TECHNICAL CONSULTANCY AND SERVICES PRIVATE LIMITED",
"SMBT DENTAL COLLEGE AND HOSPITAL AND POST GRADUATE RESEARCH CENTER",
"SMBT SEVABHAVI TRUST COLLEGE AND HOSPITAL",
"SMBXL PRIVATE LIMITED",
"SMC ALLOYS (INDIA) PRIVATE LIMITED",
"SMC CAPITALS LIMITED",
"SMC COMTRADE LIMITED",
"SMC CORPORATION INDIA PRIVATE LIMITED",
"SMC CREDITS LIMITED.",
"SMC ENTERPRISES PRIVATE LIMITED",
"SMC FLEET SOLUTIONS PRIVATE LIMITED",
"SMC FOODS LIMITED. SMCFL",
"SMC GLOBAL IFSC PRIVATE LIMITED",
"SMC GLOBAL SECURITIES LIMITED",
"SMC HEART INSTITUTE AND IVF RESEARCH CENTRE",
"SMC HEART INSTITUTE AND IVF RESEARCH CENTRE PRIVATE LIMITED",
"SMC INFRASTRUCTURES PRIVATE LIMITED",
"SMC INSURANCE BROKERS PRIVATE LIMITED",
"SMC INVESTEMENTS AND ADVISORS LIMITED",
"SMC MEDICAL MANUFACTURING PRIVATE LIMITED",
"SMC PACKAGING PRIVATE LIMITED",
"SMC POWER GENERATION LIMITED",
"SMC REAL ESTATE ADVISORS PRIVATE LIMITED",
"SMC SANITATIONS PRIVATE LIMITED",
"SMC TECHNOLOGIES PRIVATE LIMITED",
"SMCB SOLUTIONS PRIVATE LIMITED",
"SMCC CONSTRUCTION INDIA LIMITED",
"SMCC PRODUCT MANUFACTURING INDUSTRIES PRIVATE LIMITED",
"SMCH ELECTRO MECH PRIVATE LIMITED",
"SMCM CONSTRUCTIONS PRIVATE LIMITED",
"SMCORE INC",
"SMCORE INDIA PRIVATE LIMITED",
"SMCORE INFRA PRIVATE LIMITED",
"SMC-SWASTIK CONCRETE PRIVATE LIMITED",
"SMD CONSULTANTS PRIVATE LIMITED",
"SMD HOSPITALS PRIVATE LIMITED",
"SMD INTECH PRIVATE LIMITED",
"SMD LED & EMS PRIVATE LIMITED",
"SME CARGO PRIVATE LIMITED",
"SME CHAMER OF INDIA",
"SME LOGISTICS PRIVATE LIMITED",
"SME STEELS PRIVATE LIMITED",
"SMEATON DEVELOPERS PRIVATE LIMITED",
"SMEC AUTOMATION PRIVATE LIMITED",
"SMEC INDIA PRIVATE LIMITED",
"SMEC RAIL INDIA PRIVATE LIMITED",
"SMEC TRUST",
"SMENON CONSULTANCY PRIVATE LIMITED",
"SMERA RATINGS PRIVATE LIMITED",
"SMEST CAPITAL PRIVATE LIMITED",
"SMEW TEXTILE MACHINERY PRIVATE LIMITED",
"SMF DEVELOPERS PRIVATE LIMITED",
"SMF TEXTILES PRIVATE LIMITED",
"SMFG INDIA CREDIT COMPANY LIMITED",
"SMFG INDIA HOME FINANCE COMPANY LIMITED",
"SMG ESTATES PRIVATE LIMITED",
"SMG GASES AND CHEMICALS PRIVATE LIMITED",
"SMG HOSPITALS PRIVATE LIMITED",
"SMG INFOSOLUTIONS PRIVATE LIMITED",
"SMG PLASTICS PRIVATE LIMITED",
"SMG REALITIES PRIVATE LIMITED",
"SMH SHIPPING PRIVATE LIMITED",
"SMI AMTEK CRANKSHAFT PRIVATE LIMITED",
"SMI COATED PRODUCTS PRIVATE LIMITED",
"SMI EXPORTS PRIVATE LIMITED",
"SMI GLOBAL LEARNING PRIVATE LIMITED",
"SMI NEWQUEST INDIA PRIVATE LIMITED",
"SMI STEELS PRIVATE LIMITED",
"SMI TECH PRIVATE LIMITED",
"SMIANKA STYLE AND FASHION PRIVATE LIMITED",
"SMIC AUTOPARTS PRIVATE LIMITED",
"SMICK LABORATORIES PRIVATE LIMITED",
"SMIFS CAPITAL MARKETS LTD.",
"SMIFS LIMITED",
"SMIKO EQUIPMENTS PRIVATE LIMITED",
"SMILAX HEALTHCARE PRIVATE. LIMITED.",
"SMILAX LABORATORIES LIMITED",
"SMILAX PSYLLIUM IMPEX CO",
"SMILAX TREXIM PRIVATE LIMITED",
"SMILE AND PROFILE DENTAL TREATMENT CENTRE PVT LTD",
"SMILE AUTOMATION PRIVATE LIMITED",
"SMILE CARE CLINIC PRIVATE LIMITED",
"SMILE CERAMIC",
"SMILE ELECTRONICS LIMITED",
"SMILE FOUNDATION",
"SMILE GROUPS PRIVATE LIMITED",
"SMILE INTERIORS PRIVATE LIMITED",
"SMILE INTERNET TECHNOLOGIES PRIVATE LIMITED",
"SMILE INTRA TRADE I PRIVATE. LIMITED.",
"SMILE MERCHANDISING LIMITED",
"SMILE MICROFINANCE LIMITED",
"SMILE NONWOVENS PRIVATE LIMITED",
"SMILE ONLINE SALES SERVICES PRIVATE LIMITED",
"SMILE PLEASE TEETH CARE PRIVATE LIMITED",
"SMILE SANITATIONS PRIVATE LIMITED",
"SMILE SECURITY & SURVEILLANCE PRIVATE LIMITED",
"SMILE STONE MOTELS PRIVATE LIMITED",
"SMILE STONES DENTAL PRIVATE LIMITED",
"SMILE STONETECH SERVICES INDIA PRIVATE LIMITED",
"SMILE TOURS & TRAVELS PRIVATE LIMITED",
"SMILEE GREEN INR PROJECTS PRIVATE LIMITED",
"SMILEINDIA KNOWLEDGE SERVICES PRIVATE LIMITED",
"SMILES FOREVER DENTAL ACADEMY PRIVATE LIMITED",
"SMILES FOUNDATION",
"SMILESVILLE CARE PRIVATE LIMITED",
"SMILEX ORALCARE PRIVATE LIMITED",
"SMILEY MONROE RUBBER & ALLIED PRODUCTS INDIA PRIVATE LIMITED",
"SMILEY ZIPPERS PRIVATE LIMITED",
"SMILINE DENTAL HOSPITAL PRIVATE LIMITED",
"SMILING STAR ADVISORY PRIVATE. LIMITED.",
"SMILINGTON HOLDINGS PVT LTD",
"SMILY HOSPITALITY PRIVATE LIMITED",
"SMINT TIQ PRIVATE LIMITED",
"SMIROM POLY FILM PRIVATE LIMITED",
"SMIRTI INFOSOFT PRIVATE LIMITED",
"SMIRTLEM BUCKLES (INDIA) PRIVATE LIMITED",
"SMISEN CONTROLS PRIVATE LIMITED",
"SMIT & ZOON INDIA PRIVATE LIMITED",
"SMIT ADVERTISERS PRIVATE LIMITED",
"SMIT CAPITAL SERVICES PRIVATE LIMITED",
"SMIT CONSTRUCTION ENGINEERING PRIVATE LIMITED",
"SMIT EXPORT PRIVATE LIMITED",
"SMIT MEDIMED PRIVATE LIMITED",
"SMIT TELECOM PRIVATE LIMITED",
"SMITA & SONS COAL PRIVATE LIMITED",
"SMITA CONDUCTORS PRIVATE LIMITED",
"SMITA EXPORTS PRIVATE LIMITED",
"SMITA STEELS ROLLING MILLS PRIVATE LIMITED",
"SMITABH INTERCON LIMITED",
"SMITH & ARNER FACILITY SERVICES PRIVATE LIMITED",
"SMITH & NEPHEW GBS PRIVATE LIMITED",
"SMITH & NEPHEW HEALTHCARE PRIVATE LIMITED",
"SMITH & THOMSON CAPITAL ADVISORY SERVICES PRIVATE LIMITED",
"SMITH AND SCHNIDER FACILITY SOLUTIONS PRIVATE LIMITED",
"SMITH AND SHARKS PROJECTS INDIA PVT LTD",
"SMITH INDUSTRIAL CORPORATION P LIMITED",
"SMITH INTERNATIONAL INC",
"SMITH N SMITH CHEMICALS LIMITED",
"SMITH STONE WALTERS PRIVATE LIMITED",
"SMITH STRUCTURES INDIA PRIVATE LIMITED",
"SMITH THERM PRIVATE LIMITED",
"SMITHA LOGISTICS AND SERVICES PRIVATE LIMITED",
"SMITHA PETROCHEMICALS PRIVATE LIMITED",
"SMITHA SURGICALS INDIA PRIVATE LIMITED",
"SMITHA TECHNICAL TRAINING INSTITUTE",
"SMITHERS OASIS (INDIA) PRIVATE LIMITED",
"SMITHS & FOUNDERS INDIA LIMITED",
"SMITHS DETECTION SYSTEMS PRIVATE LIMITED",
"SMITHS INTERCONNECT INDIA PRIVATE LIMITED",
"SMITHS MEDICAL INDIA PRIVATE LIMITED",
"SMITHWAYS HEALTH CARE PRIVATE LIMITED",
"SMITI HOLDING AND TRADING COMPANY PRIVATE LIMITED",
"SMITIV MOBILES TECHNOLOGIES OPC PRIVATE LIMITED",
"SMITSAGAR TRACON PVT LTD",
"SMJ EXIMP LIMITED",
"SMJ EXPORTS PRIVATE LIMITED",
"SMJ VENTURE PRIVATE LIMITED",
"SMK IMPEX SERVICES PRIVATE LIMITED",
"SMK PETRO CHEMICALS INDIA PRIVATE LIMITED.",
"SMK STEELS PRIVATE LIMITED",
"SMK TURNKEY SOLUTIONS PRIVATE LIMITED",
"SMKAGARWAL PRIVATE LIMITED",
"SMKB ASSOCIATES PRIVATE LIMITED",
"SMKGM SILENT PILING CONTRACTOR PRIVATE LIMITED",
"SMKRV COLLEGE",
"SML EDU-INFRA PRIVATE LIMITED",
"SML ELECTRICALS INDIA PRIVATE LIMITED",
"SML FAR EAST PTE LIMITED",
"SML FILMS LIMITED",
"SML GOODEARTH PRIVATE LIMITED",
"SML ISUZU LIMITED",
"SML LABELS INDIA PRIVATE LIMITED",
"SML LIMITED",
"SML PROPERTIES PRIVATE LIMITED",
"SML SUPERVALUE EDUCATION PRIVATE LIMITED",
"SMLASH ISPAT PRIVATE LIMITED",
"SMLP CONCRETE PRIVATE LIMITED",
"SMM INDUSTRIES",
"SMM INFRATECH PRIVATE LIMITED",
"SMMARAINS ADVANCES GEARBOXS INDIA PRIVATE LIMITED",
"SMMARINE EXPORTS PRIVATE LIMITED",
"SMMART TRAINING & CONSULTANCY SERVICES PRIVATE LIMITED",
"SMMILKOSE LIMITED",
"SMMM ENTERPRISE",
"SMMS ENGINEERING SYSTEMS PRIVATE LIMITED",
"SMO FERRO ALLOYS PRIVATE LIMITED",
"SMOAD NETWORKS PRIVATE LIMITED",
"SMODI INFRASTEEL PRIVATE LIMITED",
"SMOKE VALLEY COMMERCIAL PRIVATE LIMITED",
"SMOKE VALLEY MERCHANTS PRIVATE LIMITED",
"SMOKESCREEN TECHNOLOGIES PRIVATE LIMITED",
"SMOKESTACK PRIVATE LIMITED",
"SMOKIN' JOE'S PIZZA PRIVATE LIMITED",
"SMOKIN LEES RESTAURANTS PRIVATE LIMITED",
"SMOLLAN INDIA FIELD MANAGEMENT PRIVATE LIMITED",
"SMOLLAN INDIA PRIVATE LIMITED",
"SMOLLAN INDIA TECHNOLOGY PRIVATE LIMITED",
"SMOOTH AYURVEDIC PHARMACY PRIVATE LIMITED",
"SMOOTH CARGO MOVERS PRIVATE LIMITED",
"SMOOTH COMMERCIAL PRIVATE LIMITED",
"SMOOTH DEVELOPERS PRIVATE LIMITED.",
"SMOOTH INFOTECH PRIVATE LIMITED",
"SMOOTH LINE WRITING INSTRUMENTS PRIVATE LIMITED",
"SMOOTH LOGISTICS PRIVATE LIMITED",
"SMOOTH POWER PRIVATE LIMITED",
"SMOOTH PRECISION PRIVATE LIMITED",
"SMOOTH RUN EXPORTS PRIVATE LIMITED",
"SMOOTHEX CHEMICALS PVT LTD",
"SMOTO INDUSTRIES PRIVATE LIMITED",
"SMP AUTOTECH PRIVATE LIMITED",
"SMP CONSTRUCTIONS PRIVATE LIMITED",
"SMP ENGINEERS AND ELECTRICALS PRIVATE LIMITED",
"SMP ENTERPRISES PRIVATE LIMITED",
"SMP HOSPITALITY SERVICES PRIVATE LIMITED",
"SMP INFRA PRIVATE LIMITED",
"SMP INTERNATIONAL PRIVATE LIMITED",
"SMP SECURITIES LIMITED",
"SMP SOFT SOLUTIONS PRIVATE LIMITED",
"SMP TEXTILES MILLS PRIVATE LIMITED",
"SMPC INDUSTRIES INDIA PRIVATE LIMITED",
"SMPC MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"SMPL INFRA (INDIA) PRIVATE LIMITED",
"SMPL LIFE SCIENCES PRIVATE LIMITED",
"SMPP PRIVATE LIMITED",
"SMPS CONSULTANTS LLP",
"SMPS INNOVATIONS PRIVATE LIMITED",
"SMR AUTOMOTIVE SYSTEMS INDIA LIMITED",
"SMR AVIATION PRIVATE LIMITED",
"SMR BLUE VALLEY PROJECTS PRIVATE LIMITED",
"SMR BUILDERS PRIVATE LIMITED",
"SMR CONSTRUCTION",
"SMR EDUCATINAL SOCIETY",
"SMR FIBER TRADING PRIVATE LIMITED",
"SMR HOLDINGS PRIVATE LIMITED",
"SMR HR TECHNOLOGIES PRIVATE LIMITED",
"SMR INDIA PRIVATE LIMITED",
"SMR INFORMATICS PRIVATE LIMITED",
"SMR INTERNATIONAL PRIVATE LIMITED",
"SMR INTERNATIONAL SCHOOL",
"SMR ISPAT PRIVATE LIMITED",
"SMR JEWELS PRIVATE LIMITED",
"SMR OPHTHALMIC PRIVATE LIMITED",
"SMR TRANS SOLUTION PRIVATE LIMITED",
"SMRATULYA CONSTRUCTIONS PRIVATE LIMITED",
"SMRC AUTOMOTIVE PRODUCTS INDIA LIMITED",
"SMRIDHI PIPES ENTERPRISES PRIVATE LIMITED",
"SMRIDHI SPONGE LIMITED",
"SMRITI COLLEGE OF PHARMACEUTICAL EDUCATION",
"SMRITI FORGING & ENGINEERING CO PRIVATE LIMITED",
"SMRITI INDUSTRIES INDIA PRIVATE LIMITED",
"SMRITI JEWELS PRIVATE LIMITED",
"SMRITI MARBLES PVT LTD",
"SMRITI PRODUCTS PRIVATE LIMITED",
"SMRITI SAURABH (INDIA) PVT LTD",
"SMRITI TELEVISION MEDIA AND FILMS PRIVATE LIMITED",
"SMRITI TILES PRIVATE LIMITED",
"SMRITI VINIMAY PRIVATE LIMITED",
"SMRITIKONA AGRO PRODUCTS PRIVATE LIMITED",
"SMRITY PAPER MILLS PRIVATE LIMITED",
"SMRJ ENGINEERS PRIVATE LIMITED",
"SMRM INNOVATIVE VENTURES PRIVATE LIMITED",
"SMRT LOGISTICS PRIVATE LIMITED",
"SMRUTHI ORGANICS LIMITED",
"SMRUTHI TECHNOLOGIES PRIVATE LIMITED",
"SMRUTI CERAMICS INDUSTRIES PRIVATE LIMITED",
"SMRUTI MARKETEERS PRIVATE LIMITED",
"SMRUTI OFFSET PRIVATE LIMITED",
"SMRVA INFRASTRUCTURE PROJECTS PRIVATE LIMITED",
"SMRY HOSPITALITY PRIVATE LIMITED",
"SMS 24KARATEGG AND AGRO PRIVATE LIMITED",
"SMS AGRO PRODUCTS PRIVATE LIMITED",
"SMS ARTS SCIENCE COLLEGE",
"SMS AUTOLINE EQUIPMENTS PRIVATE LIMITED",
"SMS AUTOWHEELS PRIVATE LIMITED",
"SMS CARBON AND MINERALS PRIVATE LIMITED",
"SMS CLEARING & FORWARDING PRIVATE LIMITED",
"SMS COUNTRY NETWORKS PRIVATE LIMITED",
"SMS DESIGN CONSULTANTS PRIVATE LIMITED",
"SMS ENERGY HOSPITAL",
"SMS ENGINEERING TRADING & AGENCY LLP",
"SMS ENVOCARE LIMITED",
"SMS ENVOCLEAN PRIVATE LIMITED",
"SMS ENVOCLEAN PRIVATE. LIMITED.",
"SMS FASHION STUDIOS PRIVATE LIMITED",
"SMS FINANCIAL SERVICES",
"SMS HOLDINGS PRIVATE LIMITED",
"SMS HOSPITAL",
"SMS HOSPITAL - JAIPUR",
"SMS HOSPITAL- GOVT RAJ",
"SMS INDIA PRIVATE LIMITED",
"SMS INFRASTRUCTURE LIMITED.",
"SMS INTEGRATED FACILITY SERVICES PRIVATELIMITED",
"SMS INTERIORS PRIVATE LIMITED",
"SMS INTERNATIONAL BEVERAGES PRIVATE LIMITED",
"SMS LABS SERVICES PRIVATE LIMITED",
"SMS LIFESCIENCES INDIA LIMITED",
"SMS LIMITED",
"SMS MARBLE AND TILES PRIVATE LIMITED",
"SMS MEER INDIA PRIVATE.LIMITED",
"SMS METALS PRIVATE LIMITED",
"SMS MULTI SPECIALITY HOSPITAL",
"SMS MULTITECH INDIA PRIVATE LIMITED",
"SMS PARKING SOLUTIONS PRIVATE. LIMITED.",
"SMS PHARMACEUTICALS LIMITED",
"SMS PRODUCTS INDIA PRIVATE LIMITED",
"SMS SMELTERS LIMITED",
"SMS TOLLS AND DEVELOPERS LIMITED",
"SMS VANS SKILLING AND ADVISORY PRIVATE LIMITED",
"SMS VIDHYUT PRIVATE. LIMITED.",
"SMS WALUJ CETP PRIVATE. LIMITED.",
"SMS WATER GRACE BMW PRIVATE LIMITED",
"SMS WATER GRACE ENVIROPROTECT PRIVATE LIMITED",
"SMS WATER GRACE MEDIWASTE MANAGEMENT PRIVATE LIMITED",
"SMS-AABS INDIA TOLLWAYS PRIVATE LIMITED",
"SMSEA FREIGHT INDIA PRIVATE LIMITED",
"SMSEA MARINES PRIVATE LIMITED",
"SMSG AUTOMART PRIVATE LIMITED",
"SMSILICON INDIA PRIVATE LIMITED",
"SMT A R PATIL KANYA MAHAVIDHYALAYA ICHALKARANJI",
"SMT ANGOORI DEVI EDUCATIONAL & CULTURAL SOCIETYREGD",
"SMT ATPL ASSOCIATES",
"SMT B F KADRI COLLEGE OF EDUCATION GIRLS NANI DAMAN",
"SMT BHAGWATI DEVI JAIN GIRLS INTER COLLEGE TARGAR AGRA",
"SMT C K GOYAL ARTS AND COMMERCE COLLEGE",
"SMT CARGO AGENCIES PRIVATE LIMITED",
"SMT CHANDABAI PAGARIYA JAIN MATRICULATION HIGHER SECONDARY SCHOOL",
"SMT CHANDABEN MOHANBHAI PATEL HOMEOPATHIC MEDICAL COLLEGE",
"SMT CHANDIBAI HIMATHMAL MANSUKHANI COLLEGE",
"SMT CHANDRAKALA KISHORILAL GOYAL JUNIOR COLLEGE",
"SMT DHANNABAI DIPCHAND GANGWAL TECHNICAL HIGH SCHOOL & JUNIOR COLLEGE",
"SMT DROPATI DEVI MEMORIAL EDUCATION SOCETY - G D GOENKA LA' PETITE",
"SMT G R DOSHI & SMT K M MEHTA",
"SMT GITABAI MUKANDAS BAMB PRY SCHOOL DAUND",
"SMT H G SHROFF HIGH SCHOOL & JR COLLEGE NANDURBAR",
"SMT H G SHROFF HIGH SCHOOL NANDURBAR",
"SMT HARPYARI DEVI INTER COLLEGE ROHAI HATHRAS",
"SMT HARSHABEN CHHAGANBHAI PATEL (KANDARI ) ARTS AND COMMERCE COLLEGE",
"SMT I M JINWALA KELAVANI MANDAL",
"SMT INDIRA GANDHI COLLEGE OF ENGINEERING",
"SMT JANKIDEVI JAISWAL PRATHMIK SCHOOL AND JUNIOR COLLEGE",
"SMT K D BHOLE VIDYA ASODA",
"SMT K K KADAM KANYA VIDHYALAY",
"SMT K R MODI H SC SCHOOL",
"SMT KANTABEN CHANDULAL GANDHI ENGLISH SCHOOL",
"SMT KASHIBAI NAVALE COLLEGE OF ENGINEERING",
"SMT KASHIBAI NAVALE MEDICAL COLLEGE",
"SMT M B HUILGOL COLLEGE OF EDUCATION",
"SMT M M M PATEL SARVAJANIK VIDHYALAYA",
"SMT M R C HIGHSCHOOL DIHEN",
"SMT MACHINES INDIA LIMITED",
"SMT MANIBEN AMRUTLAL HARGOVANDAS GOVERNMENT AYURVED HOSPITAL",
"SMT MANIBEN M P SHAH WOMENS COLLEGE ARTS AND COMMERCE",
"SMT NARSAMMA ARTS COMMERCE AND SCIENCE COLLEGE",
"SMT P K GANGAR HINDI SEC VIDYALAYA",
"SMT PACKAGING PRIVATE LIMITED",
"SMT PUSHPA SHAMANUR MAHALINGAPPA PU COLLEGE",
"SMT R B SHAH MAHAVIR SUPER SPECIALITY HOSPITAL SURAT",
"SMT R G PATEL GIRLS SECONDARY & HIGHER SECONDARY SCHOOL",
"SMT R SATHE MADHYAMIK VIDYALAYA",
"SMT RADHIKABHAI MEGHE SHIKSHAN SANSTHAN",
"SMT S B GARDI VIDYALAYA GUNDIYALA",
"SMT S J VARMORA BBA & BCA MAHILA COLLEGE",
"SMT S K GANDHI ARTS AMOLAK SCIENCE P.H GANDHI COMMERCE COLLEGE KADA",
"SMT SADGUNABEN C U SHAH MUNL GIRLS HIGH SCHOOL",
"SMT SAROJA DEVI ADARSH",
"SMT SAROJINI NAYDU GIRLS HIGH SCHOOL RAJKOT",
"SMT SAVITRIDEVI THIRANI VIDYAMANDIR",
"SMT SHARADCHANDRIKA SURESH PATIL COLLEGE OF PHARMACY CHOPDA",
"SMT SHUREKHABEN HASMUKHBHAI GARDI UTTAR BUNIYADI VIDHYALAY",
"SMT SUH GARDI VIDYALAY",
"SMT SULOCHANADEVI SINGHANIA SCHOOL",
"SMT SUNDERDEVI G NAHATA KIDS WORLD",
"SMT SUNITIDEVI SINGHANIA SCHOOL",
"SMT SUSHILADEVI DESHMUKH MAHILA MAHAVIDYALAYA LATUR",
"SMT SYSTEMS LLP",
"SMT. B. C. J. HIGH SCHOOL",
"SMT. B. SEETHA POLYTECHNIC COLLEGE COURSES",
"SMT. L P SAVANI VIDHYABHAVAN",
"SMT. RAJKAMAL BABURAO TIDKE MAHAVIDYALAYA",
"SMT. SHAKUNTALA EDUCAITONAL AND WELFARE SOCIETY",
"SMTB ENGINEERING PRIVATE LIMITED",
"SMTC STEEL AND POWER PRIVATE LIMITED",
"SMUND CONSTRUCTIONS PRIVATE LIMITED",
"SMURUGAN LOGISTICS PRIVATE LIMITED",
"SMV AGENCIES PRIVATE. LIMITED.",
"SMV AGRO PRODUCTS PRIVATE LIMITED",
"SMV BEVERAGES PRIVATE. LIMITED.",
"SMV ENGINEERS",
"SMV ENTERPRISES PRIVATE LIMITED",
"SMV GREEN SOLUTIONS PRIVATE LIMITED",
"SMV HEALTHCARE PRIVATE LIMITED",
"SMV HERBAL REMEDIES PRIVATE LIMITED",
"SMV TUBES INDIA PRIVATE LIMITED",
"SMVD POLY PACK LIMITED",
"SMVS SWAMINARAYAN HOSPITAL AND RESEARCH FOUNDATION",
"SMW AUTOBLOK WORKHOLDING PRIVATE LIMITED",
"SMW ISPAT PRIVATE LIMITED",
"SMW LENSTECH PRIVATE LIMITED",
"SMW METAL PRIVATE LIMITED",
"SMXL KLOTHINGS PRIVATE LIMITED",
"SMYLABS PRIVATE LIMITED",
"SN ADVANCE VENTURES PRIVATE LIMITED",
"SN CONSULTANTS PRIVATE LIMITED",
"SN ELECTRIC & AUTOMATION PRIVATE LIMITED",
"SN ENGINEERING SERVICES PVT. LTD.",
"SN ENVIRO - TECH PRIVATE LIMITED",
"SN GENELAB PRIVATE LIMITED",
"SN JYOTI ASSOCIATES PRIVATE LIMITED",
"SN KNITTING PRIVATE LIMITED",
"SN MEDICAL COLLEGE AGRA",
"SN NIRMAN INFRA PROJECTS PRIVATE LIMITED",
"SN SPACE DEVELOPERS PRIVATE LIMITED",
"SN SUN POWER INDIA PRIVATE LIMITED",
"SN VANITHA COLLEGE W",
"SN YARN-TEX PRIVATE LIMITED",
"SN2 ASYMMETRIX PRIVATE LIMITED",
"SNA FABRICS AND SILHOUETTE PRIVATE LIMITED",
"SNA FIBER TEX PRIVATE LIMITED",
"SNA HEALTHCARE PRIVATE LIMITED",
"SNA MILK AND MILK PRODUCTS PRIVATE LIMITED",
"SNA OUSHADHASALA PRIVATE LIMITED",
"SNA POWER ENGINEERING PRIVATE LIMITED",
"SNAA BUSINESS PROCESSING CENTRE PRIVATE LIMITED",
"SNAB GRAPHIX INDIA PRIVATE LIMITED",
"SNACKO DELIGHT FOODS PRIVATE LIMITED",
"SNACKSMITHS PRIVATE LIMITED",
"SNAGAM MEGA MART PRIVATE LIMITED",
"SNAIL CONSULTANCY PRIVATE LIMITED",
"SNAK INDIA CONSULTANCY SERVICES PRIVATE LIMITED",
"SNAM ABRASIVES PRIVATE LIMITED",
"SNAM ALLOYS PRIVATE LIMITED",
"SNAM VIJAYA FEEDS LIMITED",
"SNAP CAMERA INDIA PRIVATE LIMITED",
"SNAP CHEMICALS INDIA PRIVATE LIMITED",
"SNAP COMPUTER SYSTEMS PRIVATE LIMITED",
"SNAP ENERGY PRIVATE LIMITED",
"SNAP FASHION INDIA PRIVATE LIMITED",
"SNAP HOSPITALS AND RESEARCH CENTRE PRIVATE LIMITED",
"SNAP NATURAL AND ALGINATE PRODUCTS PRIVATE LIMITED",
"SNAP NETWORKS PRIVATE LIMITED.",
"SNAP OFFICES PRIVATE LIMITED",
"SNAP ON BUSINESS SOLUTIONS INDIA PRIVATE LIMITED",
"SNAP2INSIGHT INDIA PRIVATE LIMITED",
"SNAP2LIFE GLOBAL PRIVATE LIMITED",
"SNAPBIZZ CLOUDTECH PRIVATE LIMITED",
"SNAPCHAI PRODUCTIONS PRIVATE LIMITED",
"SNAPCLICK PRIVATE LIMITED",
"SNAPCLUES PRIVATE LIMITED",
"SNAPMINDS TECHNOLOGIES LLP",
"SNAPMINT CREDIT ADVISORY PRIVATE LIMITED",
"SNAPMINT FINANCIAL SERVICES PRIVATE LIMITED",
"SNAP-ON TOOLS PRIVATE LIMITED",
"SNAPONE INDIA PRIVATE LIMITED",
"SNAPPER FUTURE TECH PRIVATE LIMITED",
"SNAPPERS ADVERTISING & MARKETING PRIVATE LIMITED",
"SNAPWIZ EDUTEC INDIA PRIVATE LIMITED",
"SNAPWORK TECHNOLOGIES PRIVATE LIMITED",
"SNAPZONS ECOMMERCE PRIVATE LIMITED",
"SNARK POWER PRIVATE LIMITED",
"SNAZZY CARE PRIVATE LIMITED",
"SNB ENTERPRISES PRIVATE LIMITED",
"SNB IMPEX PRIVATE LIMITED",
"SNB INFRASTRUCTURE PRIVATE LIMITED",
"SNB MINERALS LIMITED",
"SNBP GROUP OF INSTITUTES",
"SNBP TECHNO SCHOOL",
"SNBS PROJECTS PRIVATE LIMITED",
"SNC INFRA",
"SNC JEWELS PRIVATE LIMITED",
"SNCA CHANNEL MANAGEMENT PRIVATE LIMITED",
"SNCA ENERGY & INFRASTRUCTURE PRIVATE LIMITED",
"SNCL TRADING PRIVATE LIMITED",
"SNC-LAVALIN INFRASTRUCTURE PRIVATE LIMITED",
"SND ELECTRICALS PRIVATE LIMITED",
"SND ISPAAT PRIVATE LIMITED",
"SND STEELWOOL ABRESSIVE PRIVATE LIMITED",
"SNDG RICE AND AGRO EXPORTS PRIVATE LIMITED",
"SNDPJ HEALTHCARE PRIVATE LIMITED",
"SNDT AUTOMATION PRIVATE LIMITED",
"SNDT WOMEN'S UNIVERSITY",
"SNE BUSINESS INDIA PRIVATE LIMITED",
"SNEH ASHA FOUNDATION",
"SNEH CHAIN PRIVATE LIMITED",
"SNEH COMPRINT PRIVATE LIMITED",
"SNEH DEEP REALTY PRIVATE LIMITED",
"SNEH PACKAGING PRIVATE LIMITED",
"SNEH POLYMERS PRIVATE LIMITED",
"SNEH PRECAST PRODUCTS",
"SNEH QUALITY SPICES PRIVATE LIMITED",
"SNEH RAMAN ELECTRICALS PRIVATE LIMITED",
"SNEH SELECTIONS PVT LTD",
"SNEH SHARES & SECURITIES PRIVATE LIMITED",
"SNEH SILICATE PRIVATE LIMITED",
"SNEH SILK MILLS PRIVATE LIMITED",
"SNEHA ASHIANA PRIVATE LIMITED SAPL",
"SNEHA BEARINGS PRIVATE LIMITED",
"SNEHA DISTRIBUTORS PRIVATE LIMITED",
"SNEHA ENCLAVE PRIVATE LIMITED SEPL",
"SNEHA FAB PRIVATE LIMITED",
"SNEHA FARMS PRIVATE LIMITED",
"SNEHA FASHIONS PRIVATE LIMITED",
"SNEHA FOODS AND FEEDS PRIVATE LIMITED",
"SNEHA GARMENTS PRIVATE LIMITED",
"SNEHA GRAPHICS (INDIA) PRIVATE LIMITED",
"SNEHA INSULATION PRIVATE LIMITED",
"SNEHA INTERTRADE SERVICES PRIVATE LIMITED",
"SNEHA KINETIC POWER PROJECTS PRIVATE LIMITED",
"SNEHA KIRAN TECHNO CONSULTANTS PRIVATE LIMITED",
"SNEHA MAHILA VIKAS INSTITUTE OF HOTEL MG",
"SNEHA MARKETING",
"SNEHA MEDICARE PRIVATE LIMITED",
"SNEHA NEWS CHANNEL LIMITED",
"SNEHA PACKERS PRIVATE. LIMITED.",
"SNEHA POLYFAB PRIVATE LIMITED",
"SNEHA RESTAURANT AND FAST FOOD",
"SNEHA SALES & SERVICES PRIVATE LIMITED",
"SNEHA STAR H R SOLUTIONS PRIVATE LIMITED",
"SNEHA SYNERGY SOLUTIONS PRIVATE LIMITED",
"SNEHA SYNPACKS PRIVATE LIMITED",
"SNEHA VINYL PRODUCTS PVT LTD",
"SNEHAL IMPEX PRIVATE LIMITED",
"SNEHAL LOGYSYS PRIVATE LIMITED",
"SNEHAL PHARMA & SURGICALS PRIVATE LIMITED",
"SNEHAL UTTAR BUNIYADI VIDHYALAYA",
"SNEHALATA COLD STORAGE PVT LTD",
"SNEHANAND QUARRY WORKS PRIVATE LIMITED",
"SNEHANJALI ELECTRONICS AND APPLIANCES PRIVATE LIMITED",
"SNEHANJALI ELECTRONICS AND TRADING PRIVATE LIMITED",
"SNEHANJALI RETAIL PRIVATE LIMITED",
"SNEHASRI POLYSACKS PRIVATE LIMITED",
"SNEHASUDHA CHIT FUND PRIVATE LIMITED",
"SNEHDEEP CNC MACHINING PRIVATE LIMITED",
"SNEHDEEP PACKAGING PRIVATE LIMITED",
"SNEHDEEP PRECISION COMPONENTS PRIVATE LIMITED",
"SNEHJYOTI COMMERCE PRIVATE LIMITED",
"SNEHJYOTI COMMODITIES PRIVATE LIMITED",
"SNEHSHILP FABRICS PRIVATE LIMITED",
"SNEHTANGO FOOD PRODUCTS PRIVATE LIMITED",
"SNEJOS OPC PRIVATE LIMITED",
"SNEL BIOSCIENCE PRIVATE LIMITED",
"SNEL CHARGE INDIA PRIVATE LIMITED",
"SNEPRA SECURE SERVICES PRIVATE LIMITED",
"SNEREA PROPERTIES PRIVATE LIMITED",
"SNESH RESORTS PRIVATE LIMITED",
"SNESMI TECHNO PRIVATE LIMITED",
"S-NET FREIGHT INDIA PRIVATE LIMITED",
"SNET NETWORKS PRIVATE LIMITED",
"SNETAJ IT SOLUTIONS PRIVATE LIMITED",
"SNEUS HYDEL PRIVATE LIMITED",
"SNF COMPONENTS PRIVATE LIMITED",
"SNF FLOPAM INDIA PRIVATE LIMITED",
"SNF INDIA PRIVATE LIMITED",
"SNFL CLOUDTECH INDIA PRIVATE LIMITED",
"SNG CONSTRUCTIONS PRIVATE LIMITED",
"SNG DEVELOPERS LIMITED",
"SNG ENVIROSOLUTIONS PRIVATE LIMITED",
"SNG INTERIORS PRIVATE LIMITED",
"SNG INTERNATIONAL SCHOOL",
"SNG MICRONS PRIVATE LIMITED",
"SNG PACKAGING PRIVATE LIMITED",
"SNG SECURITY SERVICES PRIVATE LIMITED",
"SNG SOLVENTS PRIVATE LIMITED",
"SNG TRADING COMPANY PRIVATE. LIMITED.",
"SNGY MACHINES PRIVATE LIMITED",
"SNIBE DIAGNOSTIC INDIA PRIVATE LIMITED",
"SNIC SOLUTIONS PRIVATE LIMITED",
"SNIG PHARMA PRIVATE LIMITED",
"SNIGDHAA SHANTI REALTORS PRIVATE LIMITED",
"SNIGDHASMITA INTERNATIONAL (OPC) PRIVATE LIMITED",
"SNIK INDIA PRIVATE LIMITED",
"SNIP IMPEX PRIVATELIMITED",
"SNIPE ENGINEERS PRIVATE LIMITED",
"SNIPER FACILITY MANAGEMENT SERVICES (INDIA) PRIVATE LIMITED",
"SNIPER SYSTEMS & SOLUTIONS PRIVATE LIMITED",
"SNIPP INTERACTIVE INDIA PRIVATE LIMITED",
"SNIPS SOLUTION PRIVATE LIMITED",
"SNITA TRANSPORT PRIVATE LIMITED",
"SNJ BREWERIES PRIVATE LIMITED",
"SNJ DISTILLERS PRIVATE LIMITED",
"SNJ LABS PRIVATE LIMITED",
"SNJ MARKETING AND TRADING INDIA PRIVATE LIMITED",
"SNJ SUGARS AND PRODUCTS LIMITED",
"SNJ SYNTHETICS LIMITED",
"SNK CONCEPT DESIGNER PRIVATE LIMITED",
"SNK DRAINTECH INDIA PRIVATE LIMITED",
"SNK INDIA PRIVATE LIMITED",
"SNK RESOURCES PRIVATE LIMITED",
"SNKJ INFRAPROJECTS PRIVATE LIMITED",
"SNL BEARINGS LIMITED",
"SNL INNOVATIONS PRIVATE LIMITED",
"SNL LIFESTYLE PRIVATE LIMITED",
"SNN BUILDERS PRIVATE LIMITED",
"SNN HOMES",
"SNN PROPERTIES LLP",
"SNNR PRIVATE LIMITED",
"SNO BIZDEALS PRIVATE LIMITED",
"SNOCAP ICE CREAMS PVT LTD",
"SNOM TECHNOLOGY INDIA PRIVATE LIMITED",
"SNOOPER COMMERCE PRIVATE LIMITED",
"SNOOZER BEDDING LIMITED",
"SNOVAC SYSTEMS PRIVATE LIMITED",
"SNOVASYS SOFTWARE SOLUTIONS INDIA PRIVATE LIMITED",
"SNOW BIRD FACILITIES MANAGEMENT PRIVATE LIMITED",
"SNOW CERA PRIVATE LIMITED",
"SNOW LEOPARD ADVENTURES PRIVATE LIMITED",
"SNOW PLANNERS & BUILDERS PRIVATE LIMITED",
"SNOW SPACE FURNITURE SYSTEMS PRIVATE LIMITED",
"SNOW VALVES AND COILS PRIVATE LIMITED",
"SNOW VIEW CAFE PRIVATE LIMITED",
"SNOW WHITE CHEMICALS INDUSTRIES PRIVATE LIMITED",
"SNOW WHITE LAUDRETTE PRIVATE LIMITED",
"SNOW WHITE MARBLE PRIVATE LIMITED",
"SNOW WHITE MINERALS PRIVATE LIMITED",
"SNOW WHITE PUBLICATIONS PRIVATE LIMITED",
"SNOW WHITE WOOLLEN MILLS PVT LTD",
"SNOW WORLD MARINE EXPORTS PRIVATE LIMITED",
"SNOWBALL STUDIOS PRIVATE LIMITED",
"SNOWBELL FACILITY SERVICES PRIVATE LIMITED",
"SNOWBELL MACHINES PRIVATE LIMITED",
"SNOWBELL TRADELINKS PRIVATE LIMITED",
"SNOWBLUE ENCLAVE PRIVATE LIMITED",
"SNOWBUBBLE EVENTS & PRODUCTIONS PRIVATE LIMITED",
"SNOWCAP VIEW HOTELIERS PRIVATE LIMITED",
"SNOWCEM PAINTS LIMITED",
"SNOWDEW HYDROELECTRIC POWER PROJECTS PRIVATE LIMITED",
"SNOWDROP ENGINEERING PRIVATE LIMITED",
"SNOWEBS SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"SNOW-EX LOGISTICS PRIVATE LIMITED",
"SNOWFLAKE COMPUTING INDIA LLP",
"SNOWFLOWER PROPERTIES PRIVATE LIMITED",
"SNOWHILL DISTRIBUTOR PRIVATE LIMITED",
"SNOWLAN EPICURE PRIVATE LIMITED",
"SNOWLINE ADVENTURE HOLIDAYS PRIVATE LIMITED",
"SNOWMAN LOGISTICS LIMITED",
"SNOWMASTERS SPECIAL EFFECTS INDIA PRIVATE LIMITED",
"SNOWMAX LOGISTICS PRIVATE LIMITED",
"SNOWMEX ENGINEERS LIMITED",
"SNOWMINING IRON AND COALS PRIVATE LIMITED",
"SNOWSTONE MICRONS PRIVATE LIMITED",
"SNOWTECH EQUIPMENTS PRIVATE LIMITED",
"SNOWTEMP COMMERCIAL PVT LTD",
"SNOWTEX TRADELINK PVT LTD",
"SNOWTEX UDYOG LTD",
"SNOWTREE TECHNOLOGIES PRIVATE LIMITED",
"SNOWVIEW AUTOMOBILES PRIVATE LIMITED",
"SNOWVIEW TEA CO PVT LTD",
"SNOWWHITE INFRASTRUCTURE PRIVATE LIMITED",
"SNP CLOUD TECHNOLOGIES PRIVATE LIMITED",
"SNP CORPORATE SERVICES PRIVATE LIMITED",
"SNP CREATIONS PRIVATE LIMITED",
"SNP ENTERPRISE",
"SNP ENTERPRISES PRIVATE LIMITED",
"SNP INDUSTRIES",
"SNP SHIPPING SERVICES PRIVATE LIMITED",
"SNP STEELS PRIVATE LIMITED",
"SNP WATER INFRA PRIVATE LIMITED",
"SNPC MACHINES PRIVATE LIMITED",
"SNPP SEALS PRIVATE LIMITED",
"SNQS INTERNATIONAL SOCKS PRIVATE LIMITED",
"SNR AVENUES PRIVATE LIMITED",
"SNR COLLEGE - 641 006",
"SNR EDATAS PRIVATE LIMITED",
"SNR FORWARDERS PRIVATE LIMITED",
"SNR RECLAMATIONS PRIVATE LIMITED",
"SNR SQUARE PRIVATE LIMITED",
"SNRG PHARMA CONSULTING (INDIA) PRIVATE LIMITED",
"SNRM MARKETING INDIA PRIVATE LIMITED",
"SNS BOTTLES PRIVATE LIMITED",
"SNS CLOTHING PRIVATE LIMITED",
"SNS CNC EQUIPMENTS PRIVATE LIMITED",
"SNS CONTRACTS PRIVATE LIMITED",
"SNS CORPORATE SERVICES PRIVATE LIMITED",
"SNS ELECTRICAL TECHNOLOGIES PRIVATE LIMITED",
"SNS ENGINEERING PRIVATE LIMITED",
"SNS FACILITY MANAGEMENT PRIVATE LIMITED",
"SNS FOOD AND BEVERAGES",
"SNS INDUSTRIAL TOOLS AND EQUIPMENT PRIVATE LIMITED",
"SNS INFRACON PRIVATE LIMITED",
"SNS INFRAPROJECTS PRIVATE LIMITED",
"SNS INFRASERVICES PRIVATE LIMITED",
"SNS INFRATECH PRIVATE LIMITED",
"SNS INSTITUTIONS",
"SNS MUTUAL FUND DISTRIBUTORS PRIVATE LIMITED",
"SNS OVERSEAS PRIVATE LIMITED",
"SNS RESTAURANTS PRIVATE LIMITED",
"SNS SALES PRIVATE LIMITED",
"SNS SOFT TECH PRIVATE LIMITED",
"SNS SYSTEM PRIVATE LIMITED",
"SNS TECHNOCORP PRIVATE LIMITED",
"SNS TECHNOLOGIES PRIVATE LIMITED",
"SNSGAP INFRATECH PRIVATE LIMITED",
"SNSGAP INTERNATIONAL SERVICES PRIVATE LIMITED",
"SNSS GLOBAL SERVICES PRIVATE LIMITED",
"SNT INTERNATIONAL PRIVATE LIMITED",
"SNT TRADERS PRIVATE LIMITED",
"SNTECH TECHNOLOGY PRIVATE LIMITED",
"SNUG TECHNOLOGIES PRIVATE LIMITED",
"SNUHI RETAILS PRIVATE LIMITED",
"SNUR TEXTILE PRIVATE LIMITED",
"SNUVIK TECHNOLOGIES PRIVATE LIMITED",
"SNV DECOR TRADING PRIVATE LIMITED",
"SNV HOLDINGS PRIVATE LIMITED",
"SNV MOTORS PRIVATE LIMITED",
"SNV PU COLLEGE",
"SNVA TRAVELTECH PRIVATE LIMITED",
"SNVA VENTURES PRIVATE LIMITED",
"SNVC INFRA PRIVATE LIMITED",
"SNW SMITH CONSULTANTS PRIVATE LIMITED",
"SNWARE RESEARCH SERVICES PRIVATE LIMITED",
"SNWORLDWIDE EXPORTS PRIVATE LIMITED",
"SNY AUTOTECH PRIVATE LIMITED",
"SNY INFOSOFT PRIVATE LIMITED",
"SNYCON SOFTWARE SOLUTIONS PRIVATE LIMITED",
"SNYDER TECHNOLOGIES INDIA LIMITED",
"SNYLLO INNOVATIONS PRIVATE LIMITED",
"SNZ CONCEPTS PRIVATE LIMITED",
"SO DESIGN FACTORY PRIVATE LIMITED",
"SO FOR CHIEF ELECTROL OFFICER MADHYA PRADESH",
"SO WHAT",
"SOARES ENTERPRISES INDIA PRIVATE LIMITED",
"SOARING ENTERPRISES PRIVATE LIMITED",
"SOARSWELL CONSULTING PRIVATE LIMITED",
"SOATECH SOLUTION PRIVATE LIMITED",
"SOBA INFOSEC PRIVATE LIMITED",
"SOBA LOGISTICS INDIA PRIVATE LIMITED",
"SOBE FINMAN PRIVATE LIMITED",
"SOBEK AUTO INDIA PRIVATE LIMITED",
"SOBER GRAPHICS PRIVATE LIMITED",
"SOBHA DEVELOPERS (PUNE) LIMITED",
"SOBHA HIGHRISE VENTURES PRIVATE LIMITED",
"SOBHA INTERIORS PRIVATE LIMITED",
"SOBHA LIMITED",
"SOBHA NANDAMBAKKAM DEVELOPERS LIMITED",
"SOBHA PROJECTS AND TRADE PRIVATE LIMITED",
"SOBHA PURAVANKARA AVIATION PRIVATE LIMITED",
"SOBHA RICE MILL PRIVATE LIMITED",
"SOBHA TAMBARAM DEVELOPERS LIMITED",
"SOBHA TRADING PRIVATE LIMITED",
"SOBHAGAYA MEDIA PRIVATE LIMITED",
"SOBHAGIA SALES PRIVATE LIMITED",
"SOBHAGYA HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED",
"SOBHAGYA HOSPITAL AND RESEARCH CENTRE PRIVATE. LIMITED.",
"SOBHAGYA PIPELINES INFRA DEVELOPERS PRIVATE LIMITED",
"SOBHAGYAM COMPUTECH PRIVATE LIMITED",
"SOBHAYGYA MERCANTILE LIMITED",
"SOBHRAJ LAL CHAND JEWELLERS (INDIA) PRIVATE LIMITED",
"SOBIS TEKSOFT PRIVATE LIMITED",
"SOBIT METALS PRIVATE LIMITED",
"SOBO FILMS HOLDING PRIVATE LIMITED",
"SOBREMESA HOSPITALITY PRIVATE LIMITED",
"SOBTI INFRATECH LIMITED",
"SOBTI PLASTICS PRIVATE LIMITED",
"SOBY TRAVELS PRIVATE LIMITED",
"SOC ALIGARH",
"SOC FILMS PRIVATE LIMITED",
"SOCCER INTERNATIONAL PRIVATE LIMITED",
"SOCCERLAB SOFTWARE DEVELOPMENT PRIVATE LIMITED",
"SOCDV TECHNOLOGIES PRIVATE LIMITED",
"SOCH APPARELS PRIVATE LIMITED",
"SOCH CERA ZONE PRIVATE LIMITED",
"SOCH CERAMIC PRIVATE LIMITED",
"SOCH FOODS LLP",
"SOCH IMPEX PRIVATE LIMITED",
"SOCH SOUTH ZONE PRIVATE LIMITED",
"SOCH TILES PRIVATE LIMITED",
"SOCHEERS INFOTECH PRIVATE LIMITED",
"SOCHI EXPORTS PVT LTD",
"SOCIAL ACTION FOR RURAL DEVELOPMENT",
"SOCIAL ALPHA ADVISERS LLP",
"SOCIAL BEAT DIGITAL MARKETING LLP",
"SOCIAL CAPITALISM FOUNDATION",
"SOCIAL ENGINEERS PRIVATE LIMITED",
"SOCIAL HABITATS LLP",
"SOCIAL INFLUENCER INDIDIGITAL MEDIA PRIVATE LIMITED",
"SOCIAL JUSTICE AND EMPOWERMENT",
"SOCIAL JUSTICE AND EMPOWERMENT OF PERSONS WITH DISABILITIES DEPARTMENT",
"SOCIAL LENS CONSULTING PRIVATE LIMITED",
"SOCIAL MARKETING AND DEVELOPMENT RESEARCH ASSOCIATES PRIVATE LIMITED",
"SOCIAL MUTUAL BENEFITS NIDHI LIMITED",
"SOCIAL PILL PRIVATE LIMITED",
"SOCIAL PIPAL",
"SOCIAL RESTAURANTS PRIVATE LIMITED",
"SOCIAL SEA INDIA PRIVATE LIMITED",
"SOCIAL STORIES PRIVATE LIMITED",
"SOCIAL SWAG TECHNOLOGY PRIVATE LIMITED",
"SOCIAL WELFARE U P GOVT LKO",
"SOCIALCENTRAL MEDIA SOLUTIONS LLP",
"SOCIALCTR SOLUTIONS PRIVATE LIMITED",
"SOCIALEE CREATIVE DIGITAL MARKETERS",
"SOCIALFAIM TECHNOLOGY PRIVATE LIMITED",
"SOCIAL-IMPACT INNOVATIONS PRIVATE LIMITED",
"SOCIALMAGNET INNOVATIONS PRIVATE LIMITED",
"SOCIALYSE INDIA PRIVATE LIMITED",
"SOCIAM EQUIPMENT SOLUTIONS PRIVATE LIMITED",
"SOCIEDADE DE FOMENTO INDUSTRIAL PRIVATE LIMITED",
"SOCIETE GENERAL",
"SOCIETE GENERALE GLOBAL SOLUTION CENTRE PRIVATE LIMITED",
"SOCIETE INTERNATIONAL DE TELECOMMUNICATION AURONATUIQUE",
"SOCIETY DISTRIBUTORS PRIVATE LIMITED",
"SOCIETY FOR APPLIED MICROWAVE ELECTRONICS ENGINEERING AND RESEARCH",
"SOCIETY FOR APPLIED STUDIES",
"SOCIETY FOR COMMUNITY HEALTH AWARENESS RESEARCH AND ACTION",
"SOCIETY FOR EDUCATION AND ECONOMICAL DEVELOPMENT",
"SOCIETY FOR ELIMINATION OF RURAL POVERTY",
"SOCIETY FOR HEALTH ALLIED RESEARCH AND EDUCATION INDIA",
"SOCIETY FOR INNOVATION AND DEVELOPMENT",
"SOCIETY FOR NUTRITION EDUCATION AND HEALTH ACTION (SNEHA)",
"SOCIETY FOR PUBLIC EDUCATION CULTURAL TRAINING & RURAL ACTION",
"SOCIETY FOR RURAL DEVELOPMENT",
"SOCIETY FOR RURAL DEVELOPMENT SERVICES",
"SOCIETY FOR THE UPLIFTMENT OF VILLAGERS & DEVELOPMENT OF HIMALAYAN AREAS SUVIDHA",
"SOCIETY MOTORS LIMITED",
"SOCIETY OF FRIENDS OF SASSOON HOSPITALS",
"SOCIETY OF GREEN MAKERS PRIVATE LIMITED",
"SOCIETY OF ST JOSEPHE HOSPITAL",
"SOCIETY OF UNIQUE HOSPITALS AND RESEARCH INSTITUTE",
"SOCIETY123 SUPPORT SERVICES PRIVATE LIMITED",
"SOCIETYFOR MUMBAI INCUBATION LAB TO ENTREPRENEURSHIP COUNCIL",
"SOCIETYSTORES RETAIL PRIVATE LIMITED",
"SOCIETYTRUCKING SERVICES PRIVATE LIMITED",
"SOCIOBOARD TECHNOLOGIES PRIVATE LIMITED",
"SOCIOGRAPH SOLUTIONS PRIVATE LIMITED",
"SOCIOMANTIC LABS PRIVATE LIMITED",
"SOCIOMINATI MARKETING PRIVATE LIMITED",
"SOCIOPOOL INDIA PRIVATE LIMITED",
"SOCIOSQUARE DIGITECH PRIVATE LIMITED",
"SOCIUS WORKS AND SERVICES PRIVATE LIMITED",
"SOCMO CARS PRIVATE LIMITED",
"SOCO PRODUCTS PRIVATE LIMITED",
"SOCOMEC INDIA PRIVATE LIMITED",
"SOCOMEC INNOVATIVE POWER SOLUTIONS PRIVATE LIMITED",
"SOCOMED PHARMA PRIVATE LIMITED",
"SOCOMO TECHNOLOGIES PRIVATE LIMITED",
"SOCRATO CAPITAL PRIVATE LIMITED",
"SOCTRONICS TECHNOLOGIES PRIVATE LIMITED",
"SOCURE INDIA PRIVATE LIMITED",
"SOCVIEW SOLUTIONS PRIVATE LIMITED",
"SODAGAR WOOLLEN MILLS PRIVATE LIMITED",
"SODALES LABS INDIA PRIVATE LIMITED",
"SODANI HOSPITAL & DIAGNOSTICS PRIVATE LIMITED",
"SODANI STEEL & STRIPS PRIVATE LIMITED",
"SODECIA INDIA PRIVATE LIMITED",
"SODEL SOFTWARE SOLUTIONS PRIVATE LIMITED",
"SODEPUR CHANDRACHUR VIDYAPITH",
"SODEPUR HIGH SCHOOL",
"SODEPUR NABODAY INSTITUTE",
"SODEPUR STATE GENERAL HOSPITAL",
"SODEXIS INDIA PRIVATE LIMITED",
"SODEXO FOOD SOLUTIONS INDIA PRIVATE LIMITED",
"SODEXO INDIA SERVICES PRIVATE LIMITED",
"PLUXEE INDIA PRIVATE LIMITED",
"SODEXO TECHNICAL SERVICES INDIA PRIVATE LIMITED",
"SODHA INSTITUTE OF NURSING",
"SODHANI ACADEMY OF FINTECH ENABLERS LIMITED",
"SODHANI BIOTECH PRIVATE LIMITED",
"SODHANI CAPITAL LIMITED",
"SODHANI STOCKS PRIVATE LIMITED",
"SODHANI SWEETS PRIVATE LIMITED",
"SODHI AUTO PRIVATE LIMITED",
"SODHI BROTHERS HYDRO POWER PRIVATE LIMITED",
"SODHI TEXTILES AND HOME FURNISHINGS PRIVATE LIMITED",
"SODHI'S JAYPORE TEXTILES & HOME FURNISHINGS PRIVATE LIMITED",
"SODICK TECHNOLOGIES INDIA PRIVATE LIMITED",
"SODIUM METAL PRIVATE LIMITED",
"SODUM DRUGS AND PHARMACEUTICALS PRIVATE LIMITED",
"SOEX INDIA PRIVATE LIMITED",
"SOFA FACTORY THE COMPLETE LIVING SOLUTIONS PRIVATE LIMITED",
"SOFAAB DESIGNS AND FURNISHING PRIVATE LIMITED",
"SOFAKINGS PRIVATE LIMITED",
"SOFAR MEDIA PRIVATE LIMITED",
"SOFCOM SYSTEMS LIMITED",
"SOFCON INDIA PRIVATE LIMITED",
"SOFCON SYSTEMS INDIA PRIVATE LIMITED",
"SOFEENE BRANDS AND MARKETING PRIVATE LIMITED",
"SOFEENE YARN PTE LIMITED",
"SOFFIS INDIA EXPORTS PRIVATE LIMITED",
"SOFFIT INFRASTRUCTURE SERVICES PRIVATE LIMITED",
"SOFFRONT SOFTWARE PRIVATE LIMITED",
"SOFI BAGS AND NOVELTIES PRIVATE LIMITED",
"SOFIA MARINE PRIVATE LIMITED",
"SOFIA SURGICALS PRIVATE LIMITED",
"SOFIA TWIST AND TEXT PRIVATE LIMITED",
"SOFIMA FILTERS INDIA PRIVATE LIMITED",
"SO-FINE ELECTRONIS PRIVATE LIMITED",
"SOFINE PAPER MILLS PRIVATE LIMITED",
"SOFINE TOURS AND EVENTS PRIVATE LIMITED",
"SOFIYA ENTERTAINMENT PRIVATE LIMITED",
"SOFIYA INTERNATIONAL SCHOOL",
"SOFLENE TEXTILES PVT LTD",
"SOFMEN TECHNOLOGIES PRIVATE LIMITED",
"SOFOMATION ENERGY CONSULTANTS PRIVATE LIMITED",
"SOFOTEL INFRA PRIVATE LIMITED",
"SOFPARK INFRA MGMT SERVICES PRIVATE LIMITED",
"SOFREAL MERCANTRADE PRIVATE LIMITED",
"SOFRITEK PRIVATE LIMITED",
"SOFSCRIPT HEALTHCARE SYSTEMS & SERVICES PRIVATE LIMITED",
"SOFSCRIPT SYSTEMS & SERVICES LIMITED",
"SOFT CALL CUST-O-CARE PRIVATE LIMITED",
"SOFT CLEAN FACILITY INDIA PRIVATE LIMITED",
"SOFT COM INDIA PRIVATE LIMITED",
"SOFT FIBRES IMPEX PRIVATE LIMITED",
"SOFT LITE IMPEX PRIVATE LIMITED",
"SOFT MEDICAPS LIMITED",
"SOFT PEOPLE COMPUTERS PRIVATE LIMITED",
"SOFT PRODIGY SYSTEM S0LUTIONS PRIVATE LIMITED",
"SOFT SENSATIONS PRIVATE LIMITED",
"SOFT SUAVE TECHNOLOGIES PRIVATE LIMITED",
"SOFT TOUCH AVIATION PRIVATE LIMITED",
"SOFT TOUCHLINE PRODUCTS PRIVATE LIMITED",
"SOFTACULOUS LIMITED",
"SOFTAGE COMMUNICATIONS PRIVATE LIMITED",
"SOFTAGE INFORMATION TECHNOLOGY",
"SOFTAGE INFORMATION TECHNOLOGY LIMITED",
"SOFTAGE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"SOFTAPPSPRO TECHNOLOGIES PRIVATE LIMITED",
"SOFTBERRY TECHNOLOGY PRIVATE LIMITED",
"SOFTBIZ SOLUTIONS PRIVATE LIMITED",
"SOFTBORNE TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"SOFTBOX SYSTEMS (INDIA) PRIVATE LIMITED",
"SOFTBRIJ IT SOLUTIONS",
"SOFTBYTE (INDIA) PRIVATE LIMITED",
"SOFTCELL TECHNOLOGIES GLOBAL PRIVATE LIMITED",
"SOFTCELL TECHNOLOGIES LIMITED",
"SOFTCELL TECHNOLOGIES PRIVATE LIMITED",
"SOFTCHASE SOLUTIONS PRIVATE LIMITED",
"SOFTCLOUDS INDIA PRIVATE LIMITED",
"SOFTCON SYSTEMS PRIVATE LIMITED",
"SOFTCONS INNOVATIONS INDIA PRIVATE LIMITED",
"SOFTCORE INFOTECH PRIVATE LIMITED",
"SOFTCORE SOLUTIONS PRIVATE LIMITED",
"SOFTCRAFT SYSTEMS AND SOLUTIONS PRIVATE LIMITED",
"SOFTCRYLIC TECHNOLOGY SOLUTIONS INDIA PRIVATE LIMITED",
"SOFTDEAL PHARMACEUTICAL PRIVATE LIMITED",
"SOFTDEL SYSTEMS PRIVATE LIMITED",
"SOFTEASY NETWORKING SOLUTIONS PRIVATE LIMITED",
"SOFTEC SERVICES",
"SOFTECH INFOCOM PRIVATE LIMITED",
"SOFTECH INTERNATIONAL PRIVATE LIMITED",
"SOFTECH PHARMA PRIVATE LIMITED",
"SOFTEK OFFICE PRODUCTS PRIVATE LIMITED",
"SOFTEK SURYA (INDIA) PRIVATE LIMITED",
"SOFTEL SOLUTIONS PRIVATE LIMITED",
"SOFTENGER INDIA PRIVATE LIMITED",
"SOFTEON INDIA PRIVATE LIMITED",
"SOFTESULE PRIVATE LIMITED",
"SOFTEX INDUSTRIAL PRODUCTS PVT LTD",
"SOFTEX INFOTECH PRIVATE LIMITED",
"SOFTFORCE CONSULTANTS PRIVATE LIMITED",
"SOFTGEL HEALTHCARE PRIVATE LIMITED",
"SOFTGEN TECHNOLOGIES PRIVATE LIMITED",
"SOFTGRID COMPUTERS PRIVATE LIMITED",
"SOFTHARD AUTOMATION PRIVATE LIMITED",
"SOFTHEALTH INDIA PRIVATE LIMITED",
"SOFTHQ INDIA PRIVATE LIMITED",
"SOFTICES CONSULTANCY PRIVATE LIMITED",
"SOFTIN SYSTEM PRIVATE LIMITED",
"SOFTINFO SYSTEMS PRIVATE LIMITED",
"SOFTINWAY TURBOMACHINERY SOLUTIONS PRIVATE LIMITED",
"SOFTKEY EDUCATION AND INFOTECH LIMITED",
"SOFTKEY INFOSOLUTIONS PRIVATE LIMITED",
"SOFTKEY SOLUTIONS PRIVATE LIMITED",
"SOFTKOASH SOLUTIONS PRIVATE LIMITED",
"SOFTLABS INFOTECH PRIVATE LIMITED",
"SOFTLAND INDIA LIMITED",
"SOFTLAYER TECHNOLOGIES INDIA PRIVATE LIMITED",
"SOFTLINE SERVICES INDIA PRIVATE LIMITED",
"SOFTLINK GLOBAL PRIVATE LIMITED",
"SOFTLINK INTERNATIONAL PRIVATE LIMITED",
"SOFTLOGIC SYSTEMS PRIVATE LIMITED",
"SOFTLOGIQUE IT SOLUTIONS PRIVATE LIMITED",
"SOFTMAN INFOSOLUTIONS (INDIA ) PRIVATE LIMITED",
"SOFTMARK SOLUTIONS PRIVATE LIMITED",
"SOFTMEDIA ERP (OPC) PRIVATE LIMITED",
"SOFTNAUTICS LLP",
"SOFTNET MEGATRENDS PRIVATE LIMITED",
"SOFTNICE INDIA PRIVATE LIMITED",
"SOFTNOTIONS TECHNOLOGIES PRIVATE LIMITED",
"SOFTOBIZ TECHNOLOGIES PRIVATE LIMITED",
"SOFTOBOTICS TECHNOLOGIES PRIVATE LIMITED",
"SOFTOMOTIVE ROBOTIC PROCESS AUTOMATION",
"SOFTONE SPEECH & HEARING CLINICS PRIVATE LIMITED",
"SOFTOUCH HYGIENE PRODUCTS LIMITED",
"SOFTPATH BIZTEK SOLUTIONS INDIA PRIVATE LIMITED",
"SOFTPATH SYSTEMS PRIVATE LIMITED",
"SOFTPATH TECH SOLUTIONS PRIVATE LIMITED",
"SOFTPEARL INNOVATIONS INDIA PRIVATE LIMITED",
"SOFTPILLAR TECHNOLOGIES PRIVATE LIMITED",
"SOFTPRIME TECHNOLOGIES PRIVATE LIMITED",
"SOFTQUBE TECHNOLOGIES PRIVATE LIMITED",
"SOFTRADIX TECHNOLOGIES PRIVATE LIMITED",
"SOFTREFINE TECHNOLOGY PRIVATE LIMITED",
"SOFTRONIC SOLUTIONS (INDIA) PRIVATE LIMITED",
"SOFTRONIKX TECHNOLOGIES AND SOLUTIONS PRIVATE LIMITED",
"SOFTSECURE INFOTECH PRIVATE LIMITED",
"SOFTSENS CONSUMER PRODUCTS PRIVATE LIMITED",
"SOFTSENSOR AI PRIVATE LIMITED",
"SOFTSHELL SYSTEMS INDIA PRIVATE LIMITED",
"SOFTSMITH INFOTECH PRIVATE LIMITED",
"SOFTSOL INDIA LIMITED",
"SOFTSPIN TECHNOLOGIES PRIVATE LIMITED",
"SOFTSPOT INFRADEVELOPERS PRIVATE LIMITED",
"SOFTSQUARE SOLUTIONS PRIVATE LIMITED",
"SOFTSTANDARD SOLUTIONS LLP",
"SOFTSYS HOSTING PRIVATE LIMITED",
"SOFTTAG SOLUTIONS PRIVATE LIMITED",
"SOFT-TECH COMPUTERS PVT LTD",
"SOFTTECH ENGINEERS LIMITED",
"SOFT-TECH INFO SYSTEMS PRIVATE LIMITED",
"SOFTTEK INDIA PRIVATE LIMITED",
"SOFTTRIX WEB SOLUTIONS LLP",
"SOFTTRUST TRADING COMPANY PRIVATE LIMITED",
"SOFTURA PRIVATE LIMITED",
"SOFTUVO SOLUTIONS PRIVATE LIMITED",
"SOFTVAN LABS PRIVATE LIMITED",
"SOFTVAN PRIVATE LIMITED",
"SOFTVIEW TECHNOLOGIES PRIVATE LIMITED",
"SOFTVIK VENTURES PRIVATE LIMITED",
"SOFTVISION COLLEGE",
"SOFTWARE A G INDIA SALES PRIVATE LIMITED",
"SOFTWARE A G KOCHI PRIVATE LIMITED",
"SOFTWARE AG BANGALORE TECHNOLOGIES PRIVATE LIMITED",
"SOFTWARE AG CHENNAI DEVELOPMENT CENTER INDIA PRIVATE LIMITED",
"SOFTWARE ALLIANCE INDIA P LTD",
"SOFTWARE ASSOCIATES INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"SOFTWARE AT WORK I P LIMITED",
"SOFTWARE BUSINESS SOLUTIONS CONSULTING INDIA PRIVATE LIMITED",
"SOFTWARE BUSINESS SYSTEMS CONSULTING PRIVATE LIMITED",
"SOFTWARE CONGLOMERATE PRIVATE LIMITED",
"SOFTWARE CUNSULTANT CODEARRAY TECH PRIVATE LIMITED",
"SOFTWARE DATA INDIA LIMITED",
"SOFTWARE EDUCATION & RESEARCH PRIVATE LIMITED",
"SOFTWARE INCUBATOR PRIVATE LIMITED",
"SOFTWARE ONE INDIA PRIVATE LIMITED",
"SOFTWARE PARADIGMS INDIA FINANCIAL SERVICES PRIVATE LIMITED",
"SOFTWARE PARADIGMS INDIA PRIVATE LIMITED",
"SOFTWARE PARADIGMS INFOTECH PRIVATE LIMITED",
"SOFTWARE PUNDITS (INDIA) PRIVATE LIMITED",
"SOFTWARE TECHNOLOGY PARKS OF INDIA",
"SOFTWAREONE INDIA PRIVATE LIMITED",
"SOFTWAY CONSULTANCY PRIVATE LIMITED",
"SOFTWAY SOLUTIONS PRIVATE LIMITED",
"SOFTWIDE TECHNO SOLUTIONS PRIVATE LIMITED",
"SOFTWILL INFOTECH PRIVATE LIMITED",
"SOFTWIN TECHNOLOGIES PRIVATE LIMITED",
"SOFTWORLD INDIA PRIVATE LIMITED",
"SOFTZEAL TECHNOLOGY PRIVATE LIMITED",
"SOFTZONE TECH PARK LIMITED",
"SOFY HEALTHCARE PRIVATE LIMITED",
"SOGANI AGRO TRADE PRIVATE LIMITED",
"SOGANI DEVELOPERS AND BUILDERS PRIVATE LIMITED",
"SOGANI HERITAGE HOTEL LIMITED",
"SOGANI HOSPITAL",
"SOGANI JEWELLERS PRIVATE LIMITED",
"SOGARATH LOGISTICS PRIVATE LIMITED",
"SOGEFI ADM SUSPENSIONS PRIVATE LIMITED",
"SOGEFI ENGINE SYSTEMS INDIA PRIVATE LIMITED",
"SOGEX OMAN INDIA PRIVATE LIMITED",
"SOGNO OFFICE FURNITURE INDIA PRIVATE LIMITED",
"SOGO COMPUTERS PRIVATE. LIMITED.",
"SOGO FASHIONS PRIVATE LIMITED",
"SOGO SYNERGY PRIVATE LIMITED",
"SOH MED CARE PRIVATE LIMITED",
"SOHA DEVELOPERS PRIVATE LIMITED",
"SOHAM AUTOTECH PRIVATE LIMITED",
"SOHAM BEARINGS PRIVATE LIMITED",
"SOHAM BUILDERS LIMITED",
"SOHAM CLASSES PRIVATE LIMITED",
"SOHAM CLEARING & FORWARDING PRIVATE LIMITED",
"SOHAM COAL PRIVATE LIMITED",
"SOHAM COLD STORAGE PRIVATE LIMITED",
"SOHAM COLLECTIONS PRIVATE LIMITED",
"SOHAM DEVELOPERS",
"SOHAM DISTRIBUTORS PRIVATE LIMITED",
"SOHAM ELEC INFRA PRIVATE LIMITED",
"SOHAM ERP SOLUTIONS PRIVATE LIMITED",
"SOHAM HI-TECH PARTS PRIVATE LIMITED",
"SOHAM INFRA BUILD PRIVATE LIMITED",
"SOHAM INTEGRATED TEXTILE PARK AMDAVAD PRIVATE LIMITED",
"SOHAM INTERNATIONAL CHEMYTECH LIMITED",
"SOHAM JEWEL-TECH (I) PRIVATE LIMITED",
"SOHAM LOGISTICS PRIVATE LIMITED",
"SOHAM MANNAPITLU POWER PRIVATE LIMITED",
"SOHAM MARITIME PRIVATE LIMITED",
"SOHAM MOTORS PRIVATE LIMITED",
"SOHAM MULTI TECH PRIVATE LIMITED",
"SOHAM OVERSEAS PRIVATE LIMITED",
"SOHAM PAPERS PRIVATE LIMITED",
"SOHAM PHALGUNI RENEWABLE ENERGY PRIVATE LIMITED",
"SOHAM POLYMERS PRIVATE LIMITED",
"SOHAM RENEWABLE ENERGY INDIA PRIVATE LIMITED",
"SOHAM ROCKSTAR ENTERTAINMENT PRIVATE LIMITED",
"SOHAM SOFTWARE SERVICES PRIVATE LIMITED",
"SOHAM SOLAR SOLUTION PRIVATE LIMITED",
"SOHAM SURFACE COATINGS PRIVATE LIMITED",
"SOHAM WORLDTRADE PRIVATE LIMITED",
"SOHAM.AI INTELLIGENCE PRIVATE LIMITED",
"SOHAMM DISTRICOM PRIVATE LIMITED",
"SOHAMMA INTERNATIONAL PRIVATE LIMITED",
"SOHAN AGROMILLS PRIVATE LIMITED",
"SOHAN AUTO INDIA PRIVATE LIMITED",
"SOHAN BULLION PRIVATE LIMITED",
"SOHAN COPPERTECH PRIVATE LIMITED",
"SOHAN HEALTHCARE PRIVATE LIMITED",
"SOHAN INDUSTRIES PRIVATE LIMITED",
"SOHAN JEWELLERS PRIVATE LIMITED",
"SOHAN LAL COMMODITY MANAGEMENT PRIVATE LIMITED",
"SOHAN MINERALS AND MINING COMPANY PRIVATE LIMITED",
"SOHANA WOOLLEN MILLS PRIVATE LIMITED",
"SOHANLAL SONS",
"SOHAR CHEMICALS PRIVATE LIMITED",
"SOHIL PACKAGING PRIVATE LIMITED",
"SOHINI MARKETING PRIVATE LIMITED",
"SOHM ANALYTICAL SERVICES I PRIVATE LIMITED",
"SOHN STEEL PRIVATE LIMITED",
"SOHNA REAL ESTATES PRIVATE LIMITED",
"SOHNA STUD FARM PRIVATE LIMITED",
"SOHNI FLEXPACK PRIVATE LIMITED",
"SOHNI IMPRINTS (INDIA) PRIVATE LIMITED",
"SOHNI PACKWELL INDUSTRIES PRIVATE LIMITED",
"SOHNI PAPER TUBING PRIVATE LIMITED",
"SOHO DRAGON SOLUTIONS INDIA PRIVATE LIMITED",
"SOHO LIMITED",
"SOHOM FENSTER TECH PRIVATE LIMITED",
"SOHOM SHIPPING PRIVATE LIMITED",
"SOHOM SHIPPING SERVICES PRIVATE LIMITED",
"SOHOM TRADING & COMPANY PRIVATE LIMITED",
"SOHONI METAL CRAFT PVT LTD",
"SOHRAB SPINNING MILLS LIMITED",
"SOHRAI LIVESTOCK FARMS PRIVATE LIMITED",
"SOHUM AUTOGAS SYSTEMS PRIVATE LIMITED",
"SOHUM FOODS PRIVATE. LIMITED.",
"SOHUM READYMADES PRIVATE LIMITED",
"SOHUM SHOPPE PRIVATE LIMITED",
"SOHUM WELLNESS LIMITED",
"SOI HOSPITALITY PRIVATE LIMITED",
"SOIGNE MODE PRIVATE LIMITED",
"SOIKA MARKETING PRIVATE LIMITED",
"SOIL & ENVIRO INDUSTRIES PRIVATE LIMITED",
"SOIL AND LAND USE SURVEY OF INDIA",
"SOIL AND WATER CONSERVATION SUB DIVISION JALGAON DIST JALGAON",
"SOIL AND WATER CONSERVATION SUB DIVISION KARAD DIST SATARA",
"SOILCART AGRIWHEELS PRIVATE LIMITED",
"SOILEX CONSULTANT PRIVATE LIMITED",
"SOILMEC FOUNDATION EQUIPMENTS PRIVATE LIMITED",
"SOILTECH INDIA PRIVATE LIMITED",
"SOJAT CEMENT WORKS PVT.LTD.",
"SOJAT HENNA PRIVATE LIMITED",
"SOJATIA AUTO PRIVATE LIMITED",
"SOJITZ INDIA PRIVATE LIMITED",
"SOKA IKEDA COLLEGE OF ARTS SCIENCE",
"SOKHI BOILER ENGINEERING WORKS PRIVATE LIMITED",
"SOKHI ENGINEERING COMPANY PRIVATE LIMITED",
"SOKHI HELI-WOM GEARS PRIVATE LIMITED",
"SOKTAS INDIA PRIVATE LIMITED",
"SOKU DEVELOPERS PRIVATE LIMITED",
"SOL AUTOMOTIVE INDIA PRIVATE LIMITED",
"SOL BRAND SOLUTIONS PRIVATE LIMITED",
"SOL COMMODITIES PRIVATE LIMITED",
"SOL DERMA PHARMACEUTICALS PRIVATE LIMITED",
"SOL HSINYI PRIVATE LIMITED",
"SOL INNOCAB PRIVATE LIMITED",
"SOL MEDIC LIMITED",
"SOL MOBILES PRIVATE LIMITED",
"SOL MOBILES PRIVATE.LIMITED",
"SOL POWER PRIVATE LIMITED",
"SOL PRODUCTION PRIVATE LIMITED",
"SOL TECHNOCRATS PRIVATE LIMITED",
"SOLABOT TECHNOLOGIES PRIVATE LIMITED",
"SOLACE BIOTECH LIMITED",
"SOLACE COGEN PRIVATE LIMITED",
"SOLACE ENGINEERS (MARKETING) PVT LTD",
"SOLACE ENTERPRISES PRIVATE LIMITED",
"SOLACE HEALTHCARE PRIVATE LIMITED",
"SOLACE HOSPITAL AND RESEARCH CENTRE PVT LTD",
"SOLACE HUGIANIO PRIVATE LIMITED",
"SOLACE INFOTECH PRIVATE LIMITED",
"SOLACE LOGISTIC PRIVATE LIMITED",
"SOLACE RENEWABLE ENERGY PRIVATE LIMITED",
"SOLAE COMPANY INDIA PRIVATE LIMITED",
"SOLAI COTTON MILLS PRIVATE LIMITED",
"SOLAIMALAI ENTERPRISES",
"SOLAIRE IMPEX PRIVATE LIMITED",
"SOLAIRE POWER PRIVATE LIMITED",
"SOLAIRE SURYA URJA PRIVATE LIMITED",
"SOLAIRE TYRE PRIVATE LIMITED",
"SOLAIRE URJA PRIVATE LIMITED",
"SOLAIREDIRECT ENERGY INDIA PRIVATE LIMITED",
"SOLAIREDIRECT PROJECTS INDIA PRIVATE LIMITED",
"SOLAIREPRO URJA PRIVATE LIMITED",
"SOLAN BREWERY",
"SOLAN DEVELOPERS PRIVATE LIMITED",
"SOLAN SPINNING MILLS PRIVATE LIMITED",
"SOLANA LIFE SCIENCES PRIVATE LIMITED",
"SOLANGE RETAIL PRIVATE LIMITED",
"SOLANKI & SONS HOSPITALITY PRIVATE LIMITED",
"SOLANKI BUS SERVICE PRIVATE LIMITED",
"SOLANKI FABRICS PRIVATE LIMITED",
"SOLANKI FASHION PRIVATE LIMITED",
"SOLANKI INDUSTRIES PRIVATE LIMITED",
"SOLANKI POLYMERS PRIVATE LIMITED",
"SOLANKI SYNTHETICS PRIVATE LIMITED",
"SOLANKI TEA COMPANY PRIVATE LIMITED",
"SOLANKILI LOGISTICS MANAGEMENT PRIVATE LIMITED",
"SOLANO CERAMIC PRIVATE LIMITED",
"SOLAPUR BIOENERGY SYSTEMS PRIVATE LIMITED",
"SOLAPUR CARE MULTISPECIALTY HOSPITAL & RESEARCH CENTER PRIVATE LIMITED",
"SOLAPUR CITY HOSPITAL, SOLAPUR",
"SOLAPUR CONSTRUCTION AND FABRICATION PVT LTD",
"SOLAPUR INFRACONS PRIVATE LIMITED",
"SOLAPUR JANATA SAHAKARI BANK LTD",
"SOLAPUR JILHA MATIMAND VIDYALAYA",
"SOLAPUR MUNICIPAL CORPORATION",
"SOLAPUR RAISIN PROCESSING ASSOCIATION",
"SOLAPUR SOCIAL ASSOCIATION URDU PRIMARY SCHOOL SOLAPUR",
"SOLAPUR SOLAR ENERGY PRIVATE LIMITED",
"SOLAPUR TARUN BHARAT MEDIA LIMITED",
"SOLAPUR TOLLWAYS PRIVATE LIMITED",
"SOLAPUR YEDESHI TOLLWAY LIMITED",
"SOLAR AGROTECH PVT LTD",
"SOLAR ARISE SERVICES LLP",
"SOLAR AUTO ENGINEERS PRIVATE LIMITED",
"SOLAR BIOTECH PRIVATE LIMITED",
"SOLAR BIOTRONIC LABORATORIES PRIVATE LIMITED",
"SOLAR CHEMFERTS PRIVATE LIMITED",
"SOLAR COLOURANTS (INDIA) PRIVATE LIMITED",
"SOLAR COPYER LIMITED",
"SOLAR CREATIONS PRIVATE LIMITED",
"SOLAR DIAMOND TOOLS (INDIA) PRIVATE LIMITED",
"SOLAR EDGE POWER AND ENERGY PRIVATE LIMITED",
"SOLAR ENERGIETECHNIK LIMITED",
"SOLAR ENERGY CORPORATION OF INDIA",
"SOLAR EQUIPMENT PRIVATE LIMITED",
"SOLAR FEEDS PRIVATE LIMITED",
"SOLAR FINANCIAL SERVICES PRIVATE LIMITED",
"SOLAR FIRST ENERGY PRIVATE LIMITED",
"SOLAR GLASS WORKS LIMITED",
"SOLAR HEALTHCARE PRIVATE LIMITED",
"SOLAR HERBO PVT LTD",
"SOLAR HITECH GEYSERS",
"SOLAR HOSPITAL PRIVATE LIMITED",
"SOLAR HUMAN RESOURCES MANAGEMENT PRIVATE LIMITED",
"SOLAR IDEA PRIVATE LIMITED",
"SOLAR INDUSTRIES INDIA LIMITED",
"SOLAR INDUSTRIES PRIVATE LIMITED",
"SOLAR LIFE SCIENCES MEDICARE PRIVATE LIMITED",
"SOLAR MAGIC PRIVATE LIMITED",
"SOLAR OPTIMISED LINE PRIVATE LIMITED",
"SOLAR PACKAGING PRIVATE LIMITED",
"SOLAR PRINT PROCESS PRIVATE LIMITED",
"SOLAR PULSE ENERGY PRIVATE LIMITED",
"SOLAR QUEST ENERGY PRIVATE LIMITED",
"SOLAR QUEST PROJECTS THREE PRIVATE LIMITED",
"SOLAR RESINS PRIVATE LIMITED",
"SOLAR SEMICONDUCTOR ENERGY SYSTEMS INDIA PRIVATE LIMITED",
"SOLAR SEMICONDUCTOR POWER COMPANY INDIA PRIVATE LIMITED",
"SOLAR SEWAGE BASIC INFRASTRUCTURE PRIVATE LIMITED",
"SOLAR SMART PRIVATE LIMITED",
"SOLAR SOLES PRIVATE LIMITED",
"SOLAR SPRINGS PRIVATE LIMITED",
"SOLAR TECH",
"SOLAR TECHNOCAST PRIVATE LIMITED",
"SOLAR TIMBERS PVT LTD",
"SOLAR TOWN ENERGY SOLUTIONS PRIVATE LIMITED",
"SOLAR TURBINES INDIA PRIVATE LIMITED",
"SOLAR91 CLEANTECH PRIVATE LIMITED",
"SOLARA ACTIVE PHARMA SCIENCES LIMITED",
"SOLARARISE INDIA PROJECTS PRIVATE LIMITED",
"SOLARARK PROJECTS PRIVATE LIMITED",
"SOLARBEES PRIVATE LIMITED",
"SOLARCARE (INDIA) PRIVATE LIMITED",
"SOLARCRAFT BABADHAM PRIVATE LIMITED",
"SOLARCRAFT CLEANTECH PRIVATE LIMITED",
"SOLARCRAFT INFRASTRUCTURE AND SERVICES PRIVATE LIMITED",
"SOLARCRAFT KOPPAL PRIVATE LIMITED",
"SOLARCRAFT MAHASOLAR PRIVATE LIMITED",
"SOLARCRAFT RENEW PRIVATE LIMITED",
"SOLARCRAFT TN 1 PRIVATE LIMITED",
"SOLARCRAFT TUTICORIN 2 PRIVATE LIMITED",
"SOLARCRAFT VIJAYAPURA PRIVATE LIMITED",
"SOLAREDGE TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"SOLAREX PRIVATE LIMITED",
"SOLARFIELD ENERGY PRIVATE LIMITED",
"SOLARFIELD ENERGY TWO PRIVATE LIMITED",
"SOLARGICA POWER PRIVATE LIMITED",
"SOLARGRIDX VENTURES PRIVATE LIMITED",
"SOLARIG GENSOL UTILITIES PRIVATE LIMITED",
"SOLARIKA INDIA PRIVATE LIMITED",
"SOLARIN SOLAR POWER SOLUTIONS PRIVATE LIMITED",
"SOLARINERTIA POWER PRIVATE LIMITED",
"SOLARIO TUFF'N GLASS PRIVATE LIMITED",
"SOLARIOM HOSPITAL PRIVATE LIMITED",
"SOLARIS CERAMICS PRIVATE LIMITED",
"SOLARIS CHEMTECH INDUSTRIES LIMITED",
"SOLARIS COMPUTERS P LIMITED",
"SOLARIS REALTY PRIVATE LIMITED",
"SOLARIS STEEL PRIVATE LIMITED",
"SOLARISE INDUSTRIES PRIVATE LIMITED",
"SOLARIUM GREEN ENERGY PRIVATE LIMITED",
"SOLARIZE RENEWABLES PRIVATE LIMITED",
"SOLARIZE SOLAR SOLUTIONS LLP",
"SOLARMAN ENGINEERING PROJECT PRIVATE LIMITED",
"SOLARON HOMES PRIVATE LIMITED",
"SOLAROY ENGINEERS PRIVATE LIMITED",
"SOLARPACK INDIA LLP",
"SOLARPLUS ENERGY PRIVATE LIMITED",
"SOLARSMITH ENERGY PRIVATE LIMITED",
"SOLARSQUARE ENERGY PRIVATE LIMITED",
"SOLARSTREAM RENEWABLE SERVICES PRIVATE LIMITED",
"SOLARSYS NON-CONVENTIONAL ENERGY PRIVATE LIMITED",
"SOLARTIS TECHNOLOGY SERVICES PRIVATE LIMITED",
"SOLARTIVE TECHNO INDUSTRIES PRIVATE LIMITED",
"SOLARWAY NXTGENERATION PRIVATE LIMITED",
"SOLARWORLD ENERGY SOLUTIONS PRIVATE LIMITED",
"SOLAS CROPTECH PRIVATE LIMITED",
"SOLAS FIRE SAFETY EQUIPMENT PRIVATE LIMITED",
"SOLAS MARINE SERVICES PRIVATE LIMITED",
"SOLAS MODU MARINE SERVICES PRIVATE LIMITED",
"SOLAS SAFETY SERVICE STATION PRIVATE LIMITED",
"SOLASMAR MARINE SERVICES PRIVATE LIMITED",
"SOLBEG INDIA PRIVATE LIMITED",
"SOLBERG INTERNATIONAL (INDIA) PRIVATE LIMITED",
"SOLBRIDGE ENERGY PRIVATE LIMITED",
"SOLBUGGY CONNECT PRIVATE LIMITED",
"SOLCEN INFRA PRIVATE LIMITED",
"SOLCEN TECHNOLOGIES PRIVATE LIMITED",
"SOLCHROME PRIVATE LIMITED",
"SOLCO BIOMEDICAL CO. INDIA PRIVATE LIMITED",
"SOLCON ENGINEERS PRIVATE LIMITED",
"SOLDIER EYE SECURITY SERVICES PRIVATE LIMITED",
"SOLDOM ELECTRONICS PRIVATE LIMITED",
"SOLEDIFY SYSTEMS PRIVATE LIMITED",
"SOLEIL ENGINEERS PRIVATE LIMITED",
"SOLEMN LOGISTICS PRIVATE LIMITED",
"SOLEMOUNT POLYTEX PRIVATE LIMITED",
"SOLENCO INFRA PRIVATE LIMITED",
"SOLENIS CHEMICALS INDIA PRIVATE LIMITED",
"SOLENT AUTOSYS PRIVATE LIMITED",
"SOLEOS SOLAR ENERGY PRIVATE LIMITED",
"SOLERA LIFE SCIENCES PRIVATE LIMITED",
"SOLEUS FABRITECH PRIVATE LIMITED",
"SOLEX COMMERCIAL & CREDIT PVT LTD",
"SOLEX ENERGY LIMITED",
"SOLFICE RESEARCH INDIA PRIVATE LIMITED",
"SOLFLICKS FILMWORKS PRIVATE LIMITED",
"SOLFREEDOM POWER LIMITED",
"SOL-GEL FILM PRIVATE LIMITED",
"SOLGEN ENERGY PRIVATE LIMITED",
"SOLI SHIVA SYNCOT PRIVATE LIMITED",
"SOLICITOUS PHARMACEUTICALS PRIVATE LIMITED",
"SOLICITUDE IT SERVICES LLP",
"SOLICITUDE PROPERTY MANAGEMENT AND SERVICES PRIVATE LIMITED",
"SOLICON PRIVATE LIMITED",
"SOLID CONTAINERS LIMITED",
"SOLID FINANCIAL TECHNOLOGIES PRIVATE LIMITED",
"SOLID PLY PRIVATE LIMITED",
"SOLID PROPERTIES PRIVATE LIMITED",
"SOLID SOLAR PRIVATE LIMITED",
"SOLID SOLUTIONS INTERNATIONAL PRIVATE LIMITED",
"SOLID STATE INFRASTRUCTURE PRIVATE LIMITED",
"SOLID STATE SYSTEMS PRIVATE LIMITED",
"SOLID STONE COMPANY LIMITED",
"SOLIDARITY ADVISORS PRIVATE LIMITED",
"SOLIDCAM SOFTWARE INDIA PRIVATE LIMITED",
"SOLIDFORCE FACILITIES PRIVATE LIMITED",
"SOLIDITY DEVELOPERS PRIVATE LIMITED",
"SOLIDPRO ENGINEERING SUPPORT PRIVATE LIMITED",
"SOLIDREBAR ENGINEERING SERVICES PRIVATE LIMITED",
"SOLIDS AND MODELS ENGINEERING PRIVATE LIMITED",
"SOLID-TECH INDIA COMPUTER SERVICES PRIVATE LIMITED",
"SOLIDUS HI-TECH PRODUCT PRIVATE LIMITED",
"SOLIDUS TECHNO POWER PRIVATE LIMITED",
"SOLIDWOOD CONSTRUCTIONS PRIVATE LIMITED",
"SOLIEL OILEX PRIVATE LIMITED",
"SOLIFI SOFTWARE INDIA PRIVATE LIMITED",
"SOLIFLEX PACKAGING PRIVATE LIMITED",
"SOLINAS INTEGRITY PRIVATE LIMITED",
"SOLINNOS AGRO SCIENCES PRIVATE LIMITED",
"SOLINO HOME PRIVATE LIMITED",
"SOLINO INTERNATIONAL PRIVATE LIMITED",
"SOLIS EYE CARE HOSPITALS PRIVATE LIMITED",
"SOLIS HYGIENE PRIVATE LIMITED",
"SOLIS NATURALS PRIVATE LIMITED",
"SOLIS SOLUTIONS PRIVATE LIMITED",
"SOLISTAA PHARMACEUTICALS PRIVATE LIMITED",
"SOLITAIRE BTN SOLAR PRIVATE LIMITED",
"SOLITAIRE CAPITAL ADVISORS PRIVATE LIMITED",
"SOLITAIRE COLONISERS AND BUILDERS PRIVATE LIMITED",
"SOLITAIRE DRUGS & PHARMA PRIVATE LIMITED",
"SOLITAIRE ENERGIES LIMITED",
"SOLITAIRE ESTATES PRIVATE LIMITED",
"SOLITAIRE GEMOLOGICAL LABORATORIES PRIVATE.LIMITED.",
"SOLITAIRE INDUSTRIAL INFRASTRUCTURE PRIVATE LIMITED",
"SOLITAIRE INFOSYSTEMS PRIVATE LIMITED",
"SOLITAIRE INFRAHOME PRIVATE LIMITED",
"SOLITAIRE LEASING & INFOTECH PRIVATE LIMITED",
"SOLITAIRE LOGISTIC PRIVATE LIMITED",
"SOLITAIRE MACHINE TOOLS LIMITED",
"SOLITAIRE MERCHANDISING PRIVATE LIMITED",
"SOLITAIRE ORNAMENTS INDIA PRIVATE LIMITED",
"SOLITAIRE PACKAGING PRIVATE LIMITED",
"SOLITAIRE PHARMACIA PRIVATE LIMITED",
"SOLITAIRE POWERTECH PRIVATE LIMITED",
"SOLITAIRE PROPERTY MANAGEMENT PRIVATE LIMITED",
"SOLITAIRE REALMART DEVELOPERS PRIVATE LIMITED",
"SOLITAIRE RESIDENCY SERVICES PRIVATE LIMITED",
"SOLITAIRE RESOURCES PRIVATE LIMITED",
"SOLITAIRE SANITARY WARES PRIVATE LIMITED",
"SOLITAIRE TRADE-LINK PRIVATE LIMITED",
"SOLITAIRE WORLD PRIVATE LIMITED",
"SOLITARE MULTIVENTURES PRIVATE LIMITED",
"SOLITARY FOODS PRIVATE LIMITED",
"SOLITARY OWL MARKETING PRIVATE LIMITED",
"SOLITHRO PRIVATE LIMITED",
"SOLITIS ELECTRICAL SOLUTIONS PRIVATE LIMITED",
"SOLITON TECHNOLOGIES PRIVATE LIMITED",
"SOLITUDE INFRA PRIVATE LIMITED",
"SOLIX SOFTECH PRIVATE LIMITED",
"SOLIZE INDIA TECHNOLOGIES PRIVATE LIMITED",
"SOLIZO VITRIFIED PRIVATE LIMITED",
"SOLKIT DISTILLERY AND BREWERY PRIVATE LIMITED",
"SOLLERS INFOTECH PRIVATE LIMITED",
"SOLLFEGE ELECTRONICS PRIVATE LIMITED",
"SOLLUZ ENERGY PRIVATE LIMITED",
"SOLMAZ ELASTO CHEM INDIA PRIVATE LIMITED",
"SOLMED LIFESCIENCES PRIVATE LIMITED",
"SOLMITRA POWER & STEEL PRIVATE LIMITED",
"SOLNET SYSTEMS PRIVATE LIMITED",
"SOLNOVA POWER PRIVATE LIMITED",
"SOLNXT ENERGY PRIVATE LIMITED",
"SOLO CLINIC PRIVATE LIMITED",
"SOLO ELECTRONIC APPLIANCES PRIVATE LIMITED",
"SOLO MANUFACTURING PRIVATE LIMITED",
"SOLOGRES GRANITO PRIVATE LIMITED",
"SOLOMAN MANUFACTURERS PRIVATE LIMITED",
"SOLOMO MEDIA PRIVATE LIMITED",
"SOLOMOFY TECHNOLOGY PRIVATE LIMITED",
"SOLON INDIA PRIVATE LIMITED",
"SOLOPGANG SERVICES INDIA PRIVATE LIMITED",
"SOLORO TECH PRIVATE LIMITED",
"SOLOS POLYMERS PRIVATE LIMITED",
"SOLOSTONE TILES PRIVATE LIMITED",
"SOLPOWER INDIA PRIVATE LIMITED",
"SOLS ASSESSMENT AND REMEDIAL CENTER",
"SOLSTAR ENTERPRISES PRIVATE LIMITED",
"SOLSTICE HOSPITALITY PRIVATE LIMITED",
"SOLSYNCH TECHNOLOGIES PRIVATE LIMITED",
"SOLTEC",
"SOLTECH ENERGIES PRIVATE LIMITED",
"SOLTECH PUMPS AND EQUIPMENT PRIVATE LIMITED",
"SOLTEK INSOLATION PRIVATE LIMITED",
"SOLTEK PHOTOVOLTEK PRIVATE LIMITED",
"SOLTEK POLYMERS PRIVATE LIMITED",
"SOLTEL POWER PRIVATE LIMITED",
"SOLTEX PETRO PRODUCTS LTD",
"SOLTHERMAL PANELS PRIVATE LIMITED",
"SOLTRIX IT SERVICES PRIVATE LIMITED",
"SOLTY AGENCIES PRIVATE LIMITED",
"SOLTY COMMERCIAL PRIVATE LIMITED",
"SOLUBIX TECHNOLOGIES",
"SOLUBLE SILICATES PRIVATE LIMITED",
"SOLUCIO INFRA PRIVATE LIMITED",
"SOLUFEED PLANT PRODUCTS AND SERVICES PRIVATE LIMITED",
"SOLUGENIX INDIA PRIVATE LIMITED",
"SOLUM AGRITECH PRIVATE LIMITED",
"SOLUM INDIA HIGHTECH PRIVATE LIMITED",
"SOLUM TECHNOLOGIES INDIA PRIVATE LIMITED",
"SOLUMIKS HERBACEUTICALS LIMITED",
"SOLUNUS TECHNOLOGIES PRIVATE LIMITED",
"SOLUS SECURITY SYSTEM PRIVATE LIMITED",
"SOLUSOFT TECHNOLOGIES PRIVATE LIMITED",
"SOLUTE TECHNOLABS LLP",
"SOLUTIA CHEMICALS INDIA PRIVATE LIMITED",
"SOLUTIIONEYES CONSULTANCY SERVICESS & CONSTRUCTIONS PRIVATE LIMITED",
"SOLUTION 1 INTERIORS INDIA PRIVATE LIMITED",
"SOLUTION ANALYSTS PRIVATE LIMITED",
"SOLUTION BEYOND SOFTWARE DEVELOPMENT PRIVATE LIMITED.",
"SOLUTION FORMWORK KOREA CO. LIMITED",
"SOLUTION INFINITE NETWORKS LLP",
"SOLUTION INFRABUILD PRIVATE LIMITED",
"SOLUTION ONE CONSULTING PRIVATE LIMITED",
"SOLUTION POINT AUTOMATION PRIVATE LIMITED",
"SOLUTIONCHAMPS TECHNOLOGIES PRIVATE LIMITED",
"SOLUTIONEC PRIVATE LIMITED",
"SOLUTIONS 4 ENERGY PRIVATE LIMITED",
"SOLUTIONS BPO",
"SOLUTIONS COMPLETE SOURCING HUL PRIVATE LIMITED",
"SOLUTIONS ENTERPRISE PRIVATE LIMITED",
"SOLUTIONS GENIE PRIVATE LIMITED",
"SOLUTIONS INDIA SYSTEMS PRIVATE LIMITED",
"SOLUTIONS INFINI TECHNOLOGIESINDIA PRIVATE LIMITED",
"SOLUTIONS UNLIMITED",
"SOLUTIONSE9 TECHNOLOGIES PRIVATE LIMITED",
"SOLUTREAN BUILDING TECHNOLOGIES LIMITED",
"SOLUTUS CONSULTING ENGINEERS PRIVATE LIMITED",
"SOLUX GALFAB PRIVATE LIMITED",
"SOLUZIONE IT SERVICES PRIVATE LIMITED",
"SOLVATE LABORATORIES PRIVATE LIMITED",
"SOLVATIVE PRIVATE LIMITED",
"SOLVAY SPECIALITIES INDIA PRIVATE LIMITED",
"SOLVE ENGINEERING PRIVATE LIMITED",
"SOLVE PLASTIC PRODUCTS PVT LTD",
"SOLVEDA SOFTWARE INDIA PRIVATE LIMITED",
"SOLVEDGE TECHNOLOGY SERVICES PRIVATE LIMITED",
"SOLVEIG SOLAR PRIVATE LIMITED",
"SOLVEN POWER SYSTEMS PRIVATE LIMITED",
"SOLVENTEK PRIVATE LIMITED",
"SOLVERA CONSULTING PRIVATE LIMITED",
"SOLVERMINDS SOLUTIONS AND TECHNOLOGIES PRIVATE LIMITED",
"SOLVEX EDIBLES PRIVATE LIMITED",
"SOLVEX INTERCHEM PRIVATE LIMITED",
"SOLVEX PROPERTIES & SERVICES PRIVATE LIMITED",
"SOLVEX RENEWABLES AND GREEN ENERGY PRIVATE LIMITED",
"SOLVIER TECHNOLOGIES PRIVATE LIMITED",
"SOLVINA INDIA PRIVATE LIMITED",
"SOLVIUS LLP",
"SOLVO-CHEM (INDIA) PRIVATE LIMITED",
"SOLVOSOL PAINTS PVT LTD",
"SOLVOTICS LIMITED",
"SOLVY TECH SOLUTIONS PRIVATE LIMITED",
"SOLWARE IT INFOTECH PRIVATE LIMITED",
"SOLWEARTH ECOTECH PRIVATE LIMITED",
"SOLWET MARKETING PRIVATE LIMITED",
"SOLYTICS PARTNERS PRIVATE LIMITED",
"SOM AGROTECH INDIA LIMITED",
"SOM AUTOTECH PRIVATE LIMITED",
"SOM CREDINVEST PRIVATE LIMITED",
"SOM DATT BUILDERS PRIVATE LIMITED",
"SOM DATT FINANCE CORPORATION LTD",
"SOM DATT LANDMARK HOTELS & RECREATIONS PRIVATE LIMITED",
"SOM DISTILLERIES AND BREWERIES LIMITED",
"SOM DISTILLERIES AND BREWERIES ODISHA PRIVATE LIMITED",
"SOM DISTILLERIES PRIVATE LIMITED",
"SOM EXTRACTS LIMITED",
"SOM FRAGRANCES PRIVATE LIMITED",
"SOM GLOBAL PAN MASALA PRIVATE LIMITED",
"SOM GLOBAL ZARDA PRIVATE LIMITED",
"SOM IMAGING INFORMATICS PRIVATE LIMITED",
"SOM PRO FACILITIES INDIA PRIVATE LIMITED",
"SOM PROJECTS PRIVATE LIMITED",
"SOM SHIVA (IMPEX) LIMITED",
"SOM SHIVA IMPEX LIMITED",
"SOMA CLEARING AGENTS PRIVATE LIMITED",
"SOMA FOOD PRODUCTS PRIVATE LIMITED",
"SOMA INDUS VARANASI AURANGABAD TOLLWAY PRIVATE LIMITED",
"SOMA MARITIME PRIVATE LIMITED",
"SOMA NEW TOWNS P LIMITED.",
"SOMA NUTRITION LABS PRIVATE LIMITED",
"SOMA POLY PUF METAL PRIVATE LIMITED",
"SOMA PUF METAL PRIVATE LIMITED",
"SOMA PUNJAB WAREHOUSING PRIVATE. LIMITED.",
"SOMA SPECIALITIES PRIVATE LIMITED",
"SOMA TECH PRIVATE LIMITED",
"SOMA TOLLWAYS PRIVATE LIMITED",
"SOMA UNIVERSAL LOGISTICS PRIVATE LIMITED",
"SOMA VINE VILLAGE PRIVATE LIMITED",
"SOMABHAI TEA PROCESSORS PRIVATE LIMITED",
"SOMADO MEDICARE PRIVATE LIMITED",
"SOMAIAH AGRICULTURAL AND CHEMICALS PRIVATE LIMITED",
"SOMAIYA AGENCIES PRIVATE LIMITED",
"SOMAIYA CHEMICAL INDUSTRIES PRIVATE LIMITED",
"SOMAIYA VIDYAVIHAR",
"SOMAL PIPES PVT LTD",
"SOMALATA AYURVEDA INDIA PRIVATE LIMITED",
"SOMALWAR SCHOOL",
"SOMAN ELECTROMECH ENGINEERS PRIVATE LIMITED",
"SOMANATH SEEDS PRIVATE LIMITED",
"SOMANI APPAREL PRIVATE LIMITED",
"SOMANI AUTO PRIVATE LIMITED",
"SOMANI AUTOMOBILE COMPONENTS PRIVATE LIMITED",
"SOMANI COMTRADE PRIVATE LIMITED",
"SOMANI CREATION PRIVATE LIMITED",
"SOMANI DISTRIBUTORS PRIVATE LIMITED",
"SOMANI ESTATES PRIVATE LIMITED",
"SOMANI FABRICS PRIVATE LIMITED",
"SOMANI FASHION PRIVATE LIMITED",
"SOMANI FOOD PRODUCTS PRIVATE LIMITED",
"SOMANI HOME STUDIO PRIVATE LIMITED",
"SOMANI HOUSING PRIVATE LIMITED",
"SOMANI ISPAT PRIVATE LIMITED",
"SOMANI KANAK SEEDZ PRIVATE LIMITED",
"SOMANI MOTORS PRIVATE LIMITED",
"SOMANI MULTIBIZ LIMITED",
"SOMANI OVERSEAS PRIVATE LIMITED",
"SOMANI PACKAGING PRIVATE LIMITED",
"SOMANI POLY TRADE PRIVATE LIMITED",
"SOMANI POLYPLAST (INDIA) PRIVATE LIMITED",
"SOMANI PROCESSORS PRIVATE LIMITED",
"SOMANI REALTORS PRIVATE LIMITED",
"SOMANI SAVORY FOODS PRIVATE LIMITED",
"SOMANI STOCK BROKING PVT.LTD.",
"SOMANI SYNTEX PRIVATE LIMITED",
"SOMANI THREADS PRIVATE LIMITED",
"SOMANI VENTURE PRIVATE LIMITED",
"SOMANI WOOLLENS PRIVATE LIMITED",
"SOMANINX SYNFAB PRIVATE LIMITED",
"SOMANS LEISURE TOURS INDIA PRIVATE LIMITED",
"SOMANUR KALPANA COTTON INDIA PRIVATE. LIMITED.",
"SOMANY BATH FITTINGS PRIVATE LIMITED",
"SOMANY CERAMICS LIMITED",
"SOMANY EVERGREEN KNITS LIMITED",
"SOMANY IMPRESA LIMITED",
"SOMANY PIASTRELLE PRIVATE LIMITED",
"SOMANY SANITARY WARE PRIVATE LIMITED",
"SOMANY TILES LIMITED",
"SOMAR CORPORATION INDIA PRIVATE LIMITED",
"SOMARA IMPEX PRIVATE LIMITED",
"SOMARATA EXIM PRIVATE LIMITED",
"SOMASILA SOLAR POWER LIMITED.",
"SOMAT INFRASTRUCTURE INDIA PRIVATE LIMITED",
"SOMATHEERAM AYURVEDIC HOSPITAL AND YOGA CENTRE PRIVATE LIMITED",
"SOMATICO PHARMACAL PRIVATE LIMITED",
"SOMAYA AND KALAPPA CONSULTANTS PRIVATE LIMITED",
"SOMAYA SOLAR SOLUTIONS PRIVATE LIMITED",
"SOMAYAJI CERAMICS PRIVATE LIMITED",
"SOMAYAJI ESTATES PRIVATE LIMITED",
"SOMAYAJI HOLDINGS PRIVATE LIMITED",
"SOMAYAJI HOTELS PRIVATE LIMITED",
"SOMAYAJULU & COMPANY LIMITED",
"SOMBANSI ENVIRO ENGG PRIVATE.LIMITED",
"SOMBARIA CO LTD",
"SOMDEEP ALLOYS PRIVATE LIMITED",
"SOMDEEP CONSTRUCTIONS AND HOTELS PRIVATE LIMITED",
"SOMEGIRI PLACEMENT SERVICES PRIVATE LIMITED",
"SOMEN VENTURES PRIVATE LIMITED",
"SOMERO INDIA PRIVATE LIMITED",
"SOMERSET EXPORTS PRIVATE LIMITED",
"SOMERSET HEALTHCARE INVESTMENT ADVISORS PRIVATE LIMITED",
"SOMERSET THERAPEUTICS LIMITED",
"SOMERVILLE SCHOOL",
"SOMESH FORGE PRIVATE. LIMITED.",
"SOMESH PAPER TUBES PRIVATE LIMITED",
"SOMESHWAR AGRO PRIVATE LIMITED",
"SOMESHWAR CASTINGS PRIVATE LIMITED",
"SOMESHWAR ENTERPRISES PRIVATE LIMITED",
"SOMESHWAR ISPAT PRIVATE LIMITED",
"SOMESHWAR MADHYAMIK VIDYALAYA SHRISTI",
"SOMESHWAR METAL PRIVATE LIMITED (OPC)",
"SOMESHWAR PLASTO CHEM PVT LTD",
"SOMESHWARA FERTILISERS PRIVATE LIMITED",
"SOMESHWARA INDUSTRIES AND EXPORTS LIMITED",
"SOMESHWARAYA INFRA TECH (INDIA) PRIVATE LIMITED",
"SOMETHING DIFFERENT RETAIL PRIVATE LIMITED",
"SOMETHING SPECIAL CG DESIGNERS & DECORATORS PRIVATE LIMITED",
"SOMEX CERAMIC PRIVATE LIMITED",
"SOMEX INDIA IMPEX PRIVATE LIMITED",
"SOMFY INDIA PRIVATE LIMITED",
"SOMI CONVEYOR BELTINGS LIMITED",
"SOMIC ZF COMPONENETS PRIVATE LIMITED",
"SOMIK ENTERPRISES PRIVATE LIMITED",
"SOMILA TEXFAB (INDIA) PRIVATE LIMITED",
"SOMINIGHT GLOBAL PRIVATE LIMITED",
"SOMIRA DIAM PRIVATE LIMITED",
"SOMI'S INTERNATIONAL PRIVATE LIMITED",
"SOMISH SOLUTIONS LIMITED",
"SOMIYA BONG INVESTMENTS PRIVATE LIMITED",
"SOMJAI TRADING PRIVATE LIMITED",
"SOMMANI ALUCORE (INDIA) PRIVATE LIMITED",
"SOMNATH AUTOMOBILES PRIVATE LIMITED",
"SOMNATH BOARDS PRIVATE LIMITED",
"SOMNATH BUILDCON PRIVATE LIMITED",
"SOMNATH COLD STORAGE PRIVATE LIMITED",
"SOMNATH COTTON PRIVATE LIMITED",
"SOMNATH FARMERS PRODUCER COMPANY LIMITED",
"SOMNATH FLOUR MILLS PRIVATE LIMITED",
"SOMNATH GINNING AND PRESSING PRIVATE. LIMITED.",
"SOMNATH INDUSTRIES PRIVATE LIMITED",
"SOMNATH ISPAT PRIVATE LIMITED",
"SOMNATH MERCHANDISE PRIVATE LIMITED",
"SOMNATH PRODUCTS PRIVATE LIMITED",
"SOMNATH RICE MILLS PRIVATE LIMITED",
"SOMNATH WEAVING PRIVATE LIMITED",
"SOMNIATE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"SOMNUS PROPERTIES PRIVATE LIMITED",
"SOMO MEDIA PRIVATE LIMITED",
"SOMOCHEM INDIA PRIVATE LIMITED",
"SOMOONNAN GUEST HOUSE PRIVATE LIMITED",
"SOMRIDDHI DIGITAL PRIVATE LIMITED",
"SOMSAI INDUSTRIES PRIVATE LIMITED",
"SOMSONS INFRA LIMITED",
"SOMU CHEM PACK PRIVATE LIMITED",
"SOMU CHEMICALS AND PHARMACEUTICALS PRIVATE LIMITED",
"SOMU ORGANO CHEM PRIVATE LIMITED",
"SOMU SOLVENTS PRIVATE LIMITED",
"SOMVANSHI SOLAR & POWER CONSULTANCY PRIVATE LIMITED",
"SOMVED SOLUTIONS PRIVATE LIMITED",
"SOMY RESORTS PRIVATE LIMITED",
"SOMYA CARS PRIVATE LIMITED",
"SOMYA ENGGCON PRIVATE LIMITED",
"SOMYA FLEXIBAG PRIVATE LIMITED",
"SOMYA MOTORS PRIVATE LIMITED",
"SOMYA PYROTEK SERVICES PRIVATE LIMITED",
"SOMYA TRANSLATORS PRIVATE LIMITED",
"SOMYA VEHICLE SOLUTIONS PRIVATE LIMITED",
"SOMYA VEHICLES PRIVATE LIMITED",
"SOMYA WHEELS PRIVATE LIMITED",
"SONA AGROTEX PRIVATE LIMITED",
"SONA ARCADES PRIVATE LIMITED",
"SONA AUTOMATIVE PRIVATE LIMITED",
"SONA BATH CARE PRIVATE LIMITED",
"SONA BEVERAGES PRIVATE. LIMITED.",
"SONA BISCUITS LTD.",
"SONA BLW PRECISION FORGINGS LIMITED",
"SONA BUILDMART PRIVATE LIMITED",
"SONA CASTINGS PRIVATE LIMITED",
"SONA CEREAL PRODUCTS PRIVATE LIMITED",
"SONA CHEM INDUSTRIES PRIVATE LIMITED",
"SONA COLLEGE OF ARTS AND SCIENCE",
"SONA COLLEGE OF TECHNOLOGY",
"SONA CONSTRUCTION TECHNOLOGIES PRIVATE LIMITED",
"SONA CONTRACTORS PRIVATE LIMITED",
"SONA CORPORATION INDIA PRIVATE LIMITED",
"SONA ENGICON PRIVATE LIMITED",
"SONA EXTRUSION PRIVATE LIMITED",
"SONA FLAVOURS AND TEA PVT LTD",
"SONA GENETICS PRIVATE LIMITED",
"SONA GLOBAL LIMITED",
"SONA GOLD AGROCHEM PRIVATE LIMITED",
"SONA GOLD DEVELOPERS PRIVATE LIMITED",
"SONA GOLD WELLNESS PRIVATE LIMITED",
"SONA HOROLOGICALS PRIVATE LIMITED",
"SONA INDUSTRIES PRIVATE LIMITED",
"SONA INSTITUTE OF TECHNOLOGY",
"SONA INTER-CHEM PVT LTD",
"SONA ISPAT INDIA PRIVATE LIMITED",
"SONA MACHINERY LIMITED",
"SONA MACHINERY PRIVATE LIMITED",
"SONA METAL CONTAINERS PRIVATE LIMITED",
"SONA MOBIKES PRIVATE LIMITED",
"SONA OXYGEN PRIVATE LIMITED",
"SONA PAPERS PRIVATE LIMITED",
"SONA POLY PLAST PVT LTD",
"SONA POLYSPIN PRIVATE LIMITED",
"SONA PRINTERS PRIVATE LTD",
"SONA PROCESSORS INDIA LIMITED",
"SONA PROJECTS PRIVATE LIMITED",
"SONA PUBLIC SCHOOL",
"SONA RESINS PRIVATE LIMITED",
"SONA SAREES",
"SONA SHIP MANAGEMENT PVT LTD",
"SONA SIGNATURE LLP",
"SONA SKILL DEVELOPMENT CENTRE LIMITED",
"SONA SPICES PVT LTD",
"SONA SPUN TEX PRIVATE LIMITED",
"SONA STYLES LIMITED",
"SONA TEA LTD.",
"SONA TEXFAB PRIVATE LIMITED",
"SONA TEXTILES PRIVATE LIMITED",
"SONA VETS PRIVATE LIMITED",
"SONA WHEELS PRIVATE LIMITED",
"SONA WIRES PRIVATE LIMITED",
"SONA YUKTI PRIVATE LIMITED",
"SONAA ENGINEERS PRIVATE LIMITED",
"SONAAR JEWELS PRIVATE LIMITED",
"SONABHEEL TEA LTD.",
"SONACON ENTERTAINMENT PRIVATE LIMITED",
"SONADKA INDUSTRIES PRIVATE LIMITED",
"SONAFINE CORPORATION PRIVATE LIMITED",
"SONAGACHHI F P SCHOOL",
"SONAGIR TEXTILES PRIVATE LIMITED",
"SONAGOLD COMMERCIAL PRIVATE LIMITED",
"SONAI CATTLE FEED PRIVATE LIMITED",
"SONAI EATABLES INDIA PRIVATE LIMITED",
"SONAI ENGINEERING PRIVATE LIMITED",
"SONAI FOOD MARKETING PRIVATE LIMITED",
"SONAI INFRASTRUCTURE PRIVATE LIMITED",
"SONAI KRUSHI PRAKRIYA KARKHANA LIMITED",
"SONAJULI PLANTATIONS PRIVATE LIMITED",
"SONAK AUTOMOBILES PRIVATE LIMITED",
"SONAK ENGINEERING PRIVATE LIMITED",
"SONAK SURFACE TECHNOLOGIES PRIVATE LIMITED",
"SONAKHALI HIGH SCHOOL HS",
"SONAKSHI BUILDTECH PRIVATE LIMITED",
"SONAKSHI MILK PRODUCTS PRIVATE LIMITED",
"SONAL ALLOY AND STEELS PRIVATE LIMITED",
"SONAL ASSOCIATES",
"SONAL AUTOMATION PRIVATE LIMITED",
"SONAL DEV-CON PRIVATE LIMITED",
"SONAL ENGINEERING PLASTIC FABRICATOR PRIVATE LIMITED",
"SONAL ENTERPRISES PRIVATE LIMITED",
"SONAL FABRICATORS",
"SONAL FABRICATORS PVT.LTD.",
"SONAL IRONS INDUSTRY PRIVATE LIMITED",
"SONAL MERCANTILE LIMITED",
"SONAL MOTORS PRIVATE LIMITED",
"SONAL PAPER AGENCIES PRIVATE LIMITED",
"SONAL PLASRUB INDUSTRIES PRIVATE LIMITED",
"SONAL VYAPAR LIMITED",
"SONALAC PAINTS & COATINGS LIMITED",
"SONALE FABRICS PRIVATE LIMITED",
"SONALI AGRO PRIVATE LIMITED",
"SONALI AUTOS PRIVATE LIMITED",
"SONALI BUILDCON PRIVATE LIMITED",
"SONALI CABLE VISION PRIVATE LIMITED",
"SONALI DYEING AND PRINTING PRIVATE LIMITED",
"SONALI EXIM PRIVATE LIMITED",
"SONALI EXTRUSIONS PRIVATE LIMITED",
"SONALI FASHION PRIVATE LIMITED",
"SONALI INTERNATIONAL TRADING PRIVATE LIMITED",
"SONALI INTERNET SERVICES PRIVATE LIMITED",
"SONALI MANUFACTURING PRIVATE LIMITED",
"SONALI OVERSEAS PRIVATE LIMITED",
"SONALI PETROCHEMICALS PRIVATE LIMITED",
"SONALI POLYMERS PRIVATE LIMITED",
"SONALI POLYPLAST PRIVATE LIMITED",
"SONALIA JEWELLERY MERCHANTS PRIVATE LIMITED",
"SONALIKA INDUSTRIES A UNIT OF ICML",
"SONALIKA SOCIAL DEVELOPMENT SOCIETY",
"SONALINI SECURE PRINT PRIVATE LIMITED",
"SONALIVE ENTERTAINMENT PRIVATE LIMITED",
"SONAM CLOCK P. LIMITED.",
"SONAM FINVEST SERVICES PRIVATE LIMITED",
"SONAM FURNITURE LLP",
"SONAM MANAGEMENT SOLUTION PRIVATE LIMITED",
"SONAM MARBLES AND GRANITES PVT LTD",
"SONAM SEED TECHNOLOGIES PRIVATE LIMITED",
"SONAMATA PRASHALA LIMAYEWADI",
"SONAMATA VIDYALAYA",
"SONAMOTI AGROTECH PRIVATE LIMITED",
"SONAMU ENGINEERING AND CONSTRUCTION INDIA PRIVATE LIMITED",
"SONAMUKHI JANAKALYAN VIDYAPITH",
"SONANI INDUSTRIES PRIVATE LIMITED",
"SONANSH CREATIONS PRIVATE LIMITED",
"SONAPUR HERBAL CENTRE PRIVATE LIMITED",
"SONAR APPLIANCES PRIVATE LIMITED",
"SONAR BANGLA FASHION PRIVATE LIMITED",
"SONAR BANGLA JEWELLERS PRIVATE LIMITED",
"SONAR MARINE CONSULTANT PRIVATE LIMITED",
"SONAR SOFTECH (INDIA) PRIVATE LIMITED",
"SONAR TELE TECHNOLOGIES PRIVATE LIMITED",
"SONARA SANITARY WARES PRIVATE LIMITED",
"SONARG PLASTICS PRIVATE LIMITED",
"SONARIE TEA CO PVT LTD",
"SONARIKA HOTELS PRIVATE LIMITED",
"SONAROME PRIVATE LIMITED",
"SONARPUR ICDS PROJECT",
"SONARTARI TRADELINK PRIVATE LIMITED",
"SONARTORI RICE MILL PRIVATE LIMITED",
"SONARYS CO-BRANDS PRIVATE LIMITED",
"SONATA FINANCE PRIVATE LIMITED",
"SONATA GOLD JEWELLERS PRIVATE LIMITED",
"SONATA INFORMATION TECHNOLOGY LIMITED",
"SONATA POLYMERS LIMITED",
"SONATA RUBBER PRIVATE LIMITED",
"SONATA SECURITIES PRIVATE LIMITED",
"SONATA SOFTWARE LIMITED",
"SONATA SOFTWARE SOLUTIONS LIMITED",
"SONATANI FOOD INDUSTRIES PRIVATE LIMITED",
"SONATAPES PRIVATE LIMITED",
"SONATEST PRIVATE LIMITED",
"SONAVI LABORATORIES",
"SONAWALA INDUSTRIES PRIVATE LIMITED",
"SONAWANE INFRASTRUCTURE PRIVATE LIMITED",
"SONAWAT AGROFOODS PRIVATE LIMITED",
"SONAY ENTERPRISE NEW FUTURE PLAZA",
"SONBHADRA AUTOMOBILES PRIVATE LIMITED",
"SONCHAJYO INVESTMENTS AND FINANCE PRIVATE LIMITED",
"SONCOYA SOLUTIONS PRIVATE LIMITED",
"SOND ASSOCIATES ENGG PVT LTD",
"SOND GEARS PVT LTD",
"SOND SMITH PRIVATE LIMITED",
"SONDEX HEAT EXCHANGERS INDIA PRIVATE LIMITED",
"SONDREL INDIA PRIVATE LIMITED",
"SONE HARADEO FLOUR MILLS PRIVATE LIMITED",
"SONEJI ENGINEERING PRIVATE LIMITED",
"SONEKA CHEMICALS PRIVATE LIMITED",
"SONEKO MARKETING PVT LTD",
"SONEKO WAREHOUSING LIMITED",
"SONEL INSTRUMENTS INDIA PRIVATE LIMITED",
"SONEN IMPEX PRIVATE LIMITED",
"SONEPAR INDIA PRIVATE LIMITED",
"SONEPAT AUTOMOBILES (P) LTD.",
"SONERI MARINE FOODS",
"SONESTA INNS PRIVATE LIMITED",
"SONETA LOGISTICS PRIVATE LIMITED",
"SONETEL SOFTWARE SERVICES PRIVATE LIMITED",
"SONEX INDUSTRIES",
"SONEX MACHINE COMBINES INDIA PRIVATE LIMITED",
"SONEX TV APPLIANCES PRIVATE LIMITED",
"SONG BIRD PRODUCTION",
"SONGADH INFRASTRUCTURE & HOUSING LIMITED",
"SONGARA ALL AYURVEDIC PRIVATE LIMITED",
"SONGBIRD DIGITAL INDIA PRIVATE LIMITED",
"SONGDEW MEDIA PRIVATE LIMITED",
"SONGWON SPECIALTY CHEMICALS INDIA PRIVATE LIMITED",
"SONI ADVISION PRIVATE LIMITED",
"SONI AUTO AND ALLIED INDUSTRIES LIMITED",
"SONI CENTAR",
"SONI COMMODITIES PRIVATE LIMITED",
"SONI CONDUCTORS PRIVATE LIMITED",
"SONI DALAJI PARAGAJI PRIVATE LIMITED",
"SONI GINNING FACTORY SGF",
"SONI HARJI MONEY CHANGER PRIVATE LIMITED",
"SONI HOSPITALS PRIVATE LIMITED",
"SONI HOTELS AND PROPERTY DEALERS PRIVATE LIMITED",
"SONI HYDRAULICS PRIVATE LIMITED",
"SONI JHAWAR & CO",
"SONI KANJI ANANDJI JEWELLERS PRIVATE LIMITED",
"SONI MAJAN SERVICES PRIVATE LIMITED",
"SONI MANAGEMENT AND ALLIED SERVICES PRIVATE LIMITED",
"SONI MEDICARE LIMITED",
"SONI MOTELS AND RESORTS PRIVATE LIMITED",
"SONI NANALAL BECHARDAS JEWELLERS PRIVATE LIMITED",
"SONI PAINTS PRIVATE LIMITED",
"SONI PLAY EQUIPMENTS PRIVATE LIMITED",
"SONI POLYMERS PRIVATE LIMITED",
"SONI PRABHUDAS BHUDARDAS JEWELLERS PRIVATE LIMITED",
"SONI PUBLICATIONS PRIVATE LIMITED",
"SONI RENTAL POWER PRIVATE LIMITED",
"SONI ROLLERS PRIVATE LIMITED",
"SONI RUBBER PRODUCTS LTD",
"SONI SHAILESH NANALAL JEWELLERS PRIVATE LIMITED",
"SONI SHIVLAL JEWELLERS PRIVATE LIMITED",
"SONI SOYA PRODUCTS LIMITED",
"SONI SPECIAL STEELS AND ALLOYS (INDIA) PRIVATE LIMITED",
"SONI STEEL AND APPLIANCES PRIVATE LIMITED",
"SONI WIRE PRIVATE LIMITED",
"SONIA ENGINEERING WORKS PRIVATE LIMITED",
"SONIA ENTERPRISES INDIA PRIVATE LIMITED",
"SONIA EXIM PRIVATE LIMITED",
"SONIA FISHERIES PRIVATE LIMITED",
"SONIA FORGINGS PRIVATE LIMITED",
"SONIA LABORATORY PRIVATE LIMITED",
"SONIA MARINE EXPORTS PRIVATE LIMITED",
"SONIA PLASTICS PRIVATE LIMITED",
"SONIA SILK MILLS PVT LTD",
"SONIA THEATRES PVT LTD",
"SONIC BIOCHEM EXTRACTIONS PRIVATE LIMITED",
"SONIC CERAMIC PRIVATE LIMITED",
"SONIC JEWELLERS LIMITED",
"SONIC OCTAVES PRIVATE LIMITED",
"SONIC THERMAL LIMITED.",
"SONICTRONIC TECHNOLOGIES PRIVATE LIMITED",
"SONICWALL TECHNOLOGY SYSTEMS INDIA PRIVATE LIMITED",
"SONIE INDIA CONSTRUCTION PRIVATE LIMITED",
"SONIGARA FASHIONS PRIVATE LIMITED",
"SONIGARA JEWELLERS PRIVATE LIMITED",
"SONIKS CONSULTING SERVICES PRIVATE LIMITED",
"SONIL VALVES PRIVATE LIMITED",
"SONILEX PRIVATE LIMITED",
"SONIM TECHNOLOGIES INDIA PRIVATE LIMITED",
"SONIR JEWELS PRIVATE LIMITED",
"SONISONS GARMENTS PRIVATE LIMITED",
"SONIT TECHNOLOGIES INDIA PRIVATE LIMITED",
"SONITECH INDIA PRIVATE LIMITED",
"SONITEK CONSULTANCY PRIVATE LIMITED",
"SONITPUR SOLVEX PRIVATE LIMITED",
"SONIYA AGENCIES PRIVATE LIMITED",
"SONIYA INFRACON PRIVATE LIMITED",
"SONIYA MOTORS PRIVATE LIMITED",
"SONIZ PROCON PRIVATE LIMITED",
"SONJAY HOSPITALS PRIVATE LIMITED",
"SONKAMAL ENTERPRISES PRIVATE LIMITED",
"SONKATCH AGRO PRODUCER COMPANY LIMITED",
"SONKHAR INDUSTRIAL SALT WORKS PRIVATE LIMITED",
"SONKHIA FASTENERS PRIVATE LIMITED",
"SONKHIYA GARMENTS PRIVATE LIMITED",
"SONKHIYA TRACTORS PRIVATE LIMITED",
"SONKUL AGRO INDUSTRIES PRIVATE LIMITED",
"SONKUL ENERGY PRODUCTS PRIVATE LIMITED",
"SONKUL SOLAR PRIVATE LIMITED",
"SONNALGI AQUAPARK PRIVATE LIMITED",
"SONNAX TRANSMISSION INDIA PRIVATE LIMITED",
"SONNE INFRASTRUCTURE PRIVATE LIMITED",
"SONNEN INSURANCE BROKING SERVICES PRIVATE LIMITED",
"SONNENKRAFT SOLUTIONS LLP",
"SONNET BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"SONNET CREATIONS PRIVATE LIMITED",
"SONNET LUGGAGE PRIVATE LIMITED",
"SONNET STONE PRIVATE LIMITED",
"SONNET TRADE AND INVESTMENTS PRIVATE LIMITED",
"SONNY FIREWORKS PRIVATE LIMITED",
"SONOCO GRAPHICS INDIA PRIVATE LIMITED",
"SONODYNE INTERNATIONAL PRIVATE LIMITED",
"SONODYNE TECHNOLOGIES PRIVATE LIMITED",
"SONODYNE TELEVISION CO LIMITED",
"SONOMA MANAGEMENT PARTNERS PRIVATE LIMITED",
"SONOPIX PRODUCTIONS PRIVATE LIMITED",
"SONORA SOFTWARE PRIVATE LIMITED",
"SONOS HEALTHCARE INDIA PRIVATE LIMITED",
"SONOSCAN HEALTHCARE PRIVATE LIMITED",
"SONOSCAPE MEDICAL INDIA PRIVATE LIMITED",
"SONOTEL HOTELS & RESORTS PRIVATE LIMITED",
"SONOVISION AETOS TECHNICAL SERVICES PRIVATE LIMITED",
"SONOVISION ELECTRONICS PRIVATE LIMITED",
"SONOVISION PRIVATE LIMITED",
"SONPORI SECURITIES PRIVATE LIMITED",
"SONREIR 4 U FOREX PRIVATE LIMITED",
"SONRISE TEA PROCESSING COMPANY PRIVATE LIMITED",
"SONSY ENGINEERS AND CONSTRUCTIONS PRIVATE LIMITED",
"SONTHALIA FOOD PRODUCTS PRIVATE LIMITED",
"SONTHALIA MOTORS PRIVATE LIMITED",
"SONTHALIA RICE MILL",
"SONTRAX INDIA PRIVATE LIMITED",
"SONU BUILDERS PRIVATE LIMITED",
"SONU CARGO MOVERS INDIA PRIVATE LIMITED",
"SONU COMMERCIALS PRIVATE LIMITED",
"SONU EXIM PRIVATE LIMITED",
"SONU FREIGHT CARRIERS PRIVATE LIMITED",
"SONU HOSE PRIVATE LIMITED",
"SONU INDIAN SECURITY SERVICES PRIVATE LIMITED",
"SONU INFRATECH LIMITED",
"SONU MONU AGRO PRIVATE LIMITED",
"SONU VALVES PRIVATE LIMITED",
"SONUS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"SONY AIRGASES PRIVATE LIMITED",
"SONY FINANCIAL SERVICES PRIVATE LIMITED",
"SONY GIFTS PRIVATE LIMITED",
"SONY INDIA PRIVATE LIMITED",
"SONY INDIA SOFTWARE CENTRE PRIVATE LIMITED",
"SONY MONY DEVELOPERS PRIVATE LIMITED",
"SONY MONY ELECTRONICS LIMITED",
"SONY MONY TRADERS PRIVATE LIMITED",
"SONY MUSIC ENTERTAINMENT INDIA PRIVATE LIMITED",
"SONY MUSIC PUBLISHING (INDIA) PRIVATE LIMITED",
"SONY PETRO-CHEMICALS INDUSTRIES PRIVATE LIMITED",
"SONY PICTURES FILMS INDIA PRIVATE LIMITED",
"SONY PICTURES NETWORKS DISTRIBUTION INDIA PRIVATE LIMITED",
"SONY RESEARCH INDIA PRIVATE LIMITED",
"SONY SURGICAL PRIVATE LIMITED",
"SONYA FOODS PRIVATE LIMITED",
"SONYO MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"SOOCEL DIGITAL SOLUTIONS PRIVATE LIMITED",
"SOOD AGRITECH PRIVATE LIMITED",
"SOOD AND SOOD BUILDERS PRIVATE LIMITED",
"SOOD ASSOCIATES PRIVATE LIMITED.",
"SOOD ENGINEERING PRIVATE LIMITED",
"SOOD HOSPITAL PRIVATE LIMITED",
"SOOD MEDICINE TRADERS PRIVATE LIMITED",
"SOOD OIL TRADERS PRIVATE LIMITED",
"SOOD PLASTICS PVT LTD",
"SOOD RISHI PAL (RP) INDUSTRIES PRIVATE LIMITED",
"SOOD SEEDS COMPANY PRIVATE LIMITED",
"SOOD STEEL INDUSTRIES",
"SOOD STUDIO PRIVATE LIMITED",
"SOOKERATING TEA ESTATE PVT LTD",
"SOOKSHM INFORMATION SERVICES PRIVATE LIMITED",
"SOOKTHA CONSULTING PRIVATE LIMITED",
"SOONGACHI TEA INDUSTRIES PVT LTD",
"SOON-N-SURE HOLDINGS LTD",
"SOOPERBUY PRIVATE LIMITED",
"SOOPRAZA AGRO ENTERPRISES (OPC) PRIVATE LIMITED",
"SOOR NEOGI COOMAR & CO PRIVATE LIMITED",
"SOORAJ AGRO MILLS (INDIA) PRIVATE LIMITED",
"SOORAJ FAB PRIVATE LIMITED",
"SOORAJ STEEL LTD",
"SOORAJMULL BAIJNATH PRIVATE LIMITED",
"SOORAJSAGAR RESORTS PRIVATE LIMITED",
"SOORIYA HOSPITAL",
"SOORYA GOLD LOAN",
"SOORYA HOSPITALITIES (INDIA) PRIVATE LIMITED",
"SOORYAOLI SOLAR PRODUCTS PRIVATE LIMITED",
"SOPA SYSTEMS PRIVATE LIMITED",
"SOPAN HOSPITAL AND NEUROLOGY INSTITUTE",
"SOPAN MEDICARE PRIVATE LIMITED",
"SOPAN O AND M COMPANY PRIVATE LIMITED",
"SOPAN OVERSEAS PRIVATE LIMITED",
"SOPAN PAPER MILL PRIVATE LIMITED",
"SOPAN PROCESS TECHNOLOGIES PRIVATE LIMITED",
"SOPAN PROPERTIES PRIVATE LIMITED",
"SOPARIWALA EXPORTS PRIVATE LIMITED",
"SOPARKAR & KOTHARI TECHNOLOGIES PRIVATE LIMITED",
"SOPHIA COLLEGE POLYTECHNIC MUMBAI",
"SOPHIA EXPORTS LIMITED",
"SOPHIA GIRLS COLLEGE AUTONOMOUS AJMER",
"SOPHIA PUBLICITY INDIA PRIVATE LIMITED",
"SOPHIA SCHOOL",
"SOPHIA SENIOR SECONDARY SCHOOL",
"SOPHISTICA INDUSTRIES PRIVATE LIMITED",
"SOPHISTICATED INDUSTRIAL MATERIALS ANALYTIC LABS PRIVATE LIMITED",
"SOPHISTS TECHNOLOGIES PRIVATE LIMITED",
"SOPHOS IT SERVICES PRIVATE LIMITED",
"SOPHOS TECHNOLOGIES PRIVATE LIMITED",
"SOPHROSYNE CONCEPT SCHOOL",
"SOPHUS INFOTECH INDIA PRIVATE LIMITED",
"SOPL PRIVATE LIMITED",
"SOPLAR INDIA PRIVATE LIMITED",
"SOPOS TECHNOLOGIES PRIVATE LIMITED",
"SOPRA BANKING SOFTWARE SOLUTIONS INDIA PRIVATE LIMITED",
"SOPRA STERIA INDIA LIMITED",
"SOPRANO INFRATECH PRIVATE LIMITED",
"SOPREMA PRIVATE LIMITED",
"SORA BUILDERS PRIVATE LIMITED",
"SORA SHIPPING AND LOGISTICS PRIVATE LIMITED",
"SORABH CEMENT LTD",
"SORAKE CHANDRA SHEKAR HOSPITALS PRIVATE LIMITED",
"SORANGE PRIVATE LIMITED",
"SORANUS LIFESCIENCES PRIVATE LIMITED",
"SORAYA PAPER AND MARKETING PRIVATE LIMITED",
"SORBE BIOTECHNOLOGY (INDIA) PRIVATE LIMITED",
"SORBHI CONSULTANTS AND REALTORS PRIVATE LIMITED",
"SORBITOL CHEM PRIVATE LIMITED",
"SORFIN YOSHIMURA (INDIA) PRIVATE LIMITED",
"SORIAAN RECYCLERS PRIVATE LIMITED",
"SORICE SOLUTIONS PRIVATE LIMITED",
"SORICH FOILS LIMITED",
"SORIL INFRA RESOURCES LIMITED",
"SORION SOLAR PRIVATE LIMITED",
"SORISO CERAMIC PRIVATE LIMITED",
"SORKHI INDUSTRIES PRIVATE LIMITED",
"SORMISTHA BUILDERS & CONSTRUCTION PRIVATE LIMITED",
"SORNALAKSHMI SPINNING MILLS PRIVATE LIMITED",
"SOROCO INDIA PRIVATE LIMITED",
"SORREAL SYSTEMS PRIVATE LIMITED",
"SORREL HOSPITALITY PRIVATE LIMITED",
"SORRENTO TEXTILES PRIVATE LIMITED",
"SORTED STEEL PRIVATE LIMITED",
"SORTING TAX ADVISORY SERVICES PRIVATE LIMITED",
"SOS CHILDREN'S VILLAGES",
"SOS CHILDREN'S VILLAGES OF INDIA",
"SOS IDEAS PRIVATE LIMITED",
"SOS KINDERDORF INTERNATIONAL",
"SOS SYSTEMS ON SHIP PRIVATE LIMITED",
"SOSUV CONSULTING PRIVATE LIMITED",
"SOSYO HAJOORI BEVERAGES PRIVATE LIMITED",
"SOTAC HEALTHCARE PRIVATE LIMITED",
"SOTAC PHARMACEUTICALS LIMITED",
"SOTAI TEA CO PVT LTD",
"SOTAX INDIA PRIVATE LIMITED",
"SOTC TRAVEL LIMITED",
"SOTC TRAVEL SERVICES PRIVATE LIMITED",
"SOTEFIN PARKING PRIVATE LIMITED",
"SOTERIA COMMAND CENTER PRIVATE LIMITED",
"SOTEXPA QUALIDIS TEXTILE INDIA PRIVATE LIMITED",
"SOTHEBY 'S ART SERVICES (INDIA) PRIVATE LIMITED",
"SOTI INDIA PRIVATE LIMITED",
"SOU SUSHILABAI VIRKAR HIGH SCHOOL NATU BAUG PUNE",
"SOUBHAGYA AGENCY PRIVATE LIMITED",
"SOUBHAGYA CONFECTIONERY PRIVATE LIMITED",
"SOUBHAGYA ENGINEERING PRIVATE LIMITED",
"SOUBHAGYA PROCESSOR PRIVATE LIMITED",
"SOUBHAGYALAXMI FOODS PRIVATE LIMITED",
"SOUBHIK EXPORTS LIMITED",
"SOUCE ENGINEERING & TECHNOLOGY SERVICES PRIVATE LIMITED",
"SOUDARSHINI VALVE PRIVATE LIMITED",
"SOUDHA DESIGN AND INFRA PRIVATE LIMITED",
"SOUFFLE FOODWORKS I PRIVATE LIMITED",
"SOUFFLET MALT ALWAR PRIVATE LIMITED",
"SOUFFLET MALT INDIA PRIVATE LIMITED",
"SOUHARDHA INFRA-TECH PRIVATE LIMITED",
"SOUHITI INFRAPROJECTS PRIVATE LIMITED",
"SOUJANYA COLOR PRIVATE LIMITED",
"SOUK MEDIA PRIVATE LIMITED",
"SOUKYA INDIAN HOLISTIC HEALTH CENTRE PRIVATE LIMITED",
"SOUL CLOTHING PRIVATE LIMITED",
"SOUL ELECTRIC PRIVATE LIMITED",
"SOUL FRY BAR AND KITCHEN PRIVATE LIMITED",
"SOUL HEALTH CARE",
"SOUL HEALTH CARE (I) PRIVATE LIMITED",
"SOUL KONNECT HOSPITALITY LLP",
"SOUL LEISURE PRIVATE LIMITED",
"SOUL OF PLUTO TECH LLP",
"SOUL ONE PRIVATE LIMITED",
"SOUL SPACE PROJECT LIMITED",
"SOUL TOUCH MEDIA PRIVATE LIMITED",
"SOULACE CONSULTING PRIVATE LIMITED",
"SOULAGER HEALTHCARE PRIVATE LIMITED",
"SOULFIT LIFESTYLE PRIVATE LIMITED",
"SOULILUTION IT SERVICES PRIVATE LIMITED",
"SOULMACHINE INNOVATIONS PRIVATE LIMITED",
"SOULPAGE IT SOLUTIONS PRIVATE LIMITED",
"SOULPRISM CARE SOLUTIONS PRIVATE LIMITED",
"SOULTRIPPY ADVENTURES PRIVATE LIMITED",
"SOULWEAVES PRIVATE LIMITED",
"SOUMIC JEWEL CRAFT PRIVATE LIMITED",
"SOUMIL TRADEIMPEX PRIVATE LIMITED",
"SOUMI'S HERBAL PRODUCTS PRIVATE LIMITED",
"SOUMYA HOMES PRIVATE LIMITED",
"SOUMYA IMPEX PRIVATE LIMITED",
"SOUNAK CONSTRUCTION PRIVATE LIMITED",
"SOUND & VISION STUDIOS PRIVATE LIMITED",
"SOUND CASTINGS PRIVATE LIMITED",
"SOUND MAX MUSIC PVT LTD",
"SOUND OF MUSIC INDIA PRIVATE LIMITED",
"SOUND. COM PRIVATE LIMITED.",
"SOUNDARA PANDIAN BONE AND JOINT HOSPITAL & RESEARCH INSTITUTE PRIVATE LIMITED",
"SOUNDARAPANDIAN BONE AND JOINT HOSPITAL",
"SOUNDARARAJA MILLS LIMITED.",
"SOUNDARYA & PRASADHAN INDIA PRIVATE LIMITED",
"SOUNDARYA DECORATORS PRIVATE LIMITED",
"SOUNDIDEAZ ACADEMY PRIVATE LIMITED",
"SOUNDRISE HEARING SOLUTIONS PRIVATE LIMITED",
"SOUNDSHINE PROJECTS PRIVATE LIMITED",
"SOUQGIN TECHNOLOGIES PRIVATE LIMITED",
"SOURA CONSTRUCTIONS PRIVATE LIMITED",
"SOURABH COLD STORAGE'S LIMITED",
"SOURABH CONSTRUCTIONS PRIVATE LIMITED",
"SOURABH GARMENTS PRIVATE LIMITED",
"SOURABH ROLLING MILLS PRIVATE LIMITED",
"SOURABH SILK PRIVATE LIMITED",
"SOURABH SPICES PRIVATE LIMITED",
"SOURABH TEA TRADERS PRIVATE LIMITED",
"SOURAJ ENERGY PRIVATE LIMITED",
"SOURAJ INDUSTRIES PRIVATE LIMITED",
"SOURAJYOTI POULTRY PRIVATE LIMITED",
"SOURASHAKTHI ENERGY PRIVATE LIMITED",
"SOURASHTRA COLLEGE FOR WOMEN",
"SOURAV FOOD AND AGRO PRIVATE LIMITED",
"SOURAV PLASTO PRIVATE LIMITED",
"SOURAV ROADLINES PRIVATE LIMITED",
"SOURAV SAREE EMPORIUM PRIVATE LIMITED",
"SOURAYAN TECHNOLOGIES PRIVATE LIMITED",
"SOURBH FASHION PRIVATE LIMITED",
"SOURCE DIRECT INTERNATIONAL LIMITED",
"SOURCE DOCK PRIVATE LIMITED",
"SOURCE DOT COM PRIVATE LIMTED",
"SOURCE FUSE TECHNOLOGIES INDIA PVT LTD",
"SOURCE HUB INDIA PRIVATE LIMITED",
"SOURCE MY TRIP PRIVATE LIMITED",
"SOURCE NATURAL FOODS AND HERBAL SUPPLEMENTS LIMITED",
"SOURCE ONE BUYING SERVICES PRIVATE LIMITED",
"SOURCE ONE EXPORTS PRIVATE LIMITED",
"SOURCE ONE MANAGEMENT SERVICES PRIVATE LIMITED",
"SOURCE ONE SYNERGIES PRIVATE LIMITED",
"SOURCE PUNDIT INFO SYSTEMS PRIVATE LIMITED",
"SOURCE SCAN AGENCY (INDIA) PRIVATE LIMITED.",
"SOURCE SECURITY INDIA PRIVATE LIMITED",
"SOURCE SHIPPING (INDIA) PRIVATE LIMITED",
"SOURCE SOFT SOLUTIONS PRIVATE LIMITED",
"SOURCEABILITY INDIA PRIVATE LIMITED",
"SOURCEBITS TECHNOLOGIES PRIVATE LIMITED",
"SOURCED FINTECH PRIVATE LIMITED",
"SOURCEEDGE SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"SOURCEHOV INDIA PRIVATE LIMITED",
"SOURCEITRIGHT PRIVATE LIMITED",
"SOURCEKART INFINITE SOLUTIONS PRIVATE LIMITED",
"SOURCEMASH TECHNOLOGIES PRIVATE LIMITED",
"SOURCENET IT SERVICE PROVIDER PRIVATE LIMITED",
"SOURCEPRO INFOTECH PRIVATE LIMITED",
"SOURCETRACE SYSTEMS INDIA PRIVATE LIMITED",
"SOURCETRENDZ CONSULTING PRIVATE LIMITED",
"SOURCEVED TECHNOLOGIES PRIVATE LIMITED",
"SOURCEWELL AGRO FOODS PRIVATE LIMITED",
"SOURCEWELL DEVICES PRIVATE LIMITED",
"SOURCEWELL FLOURS PRIVATE LIMITED",
"SOURCING EXPERTS PRIVATE LIMITED",
"SOURCINGBEE RETAIL PRIVATE LIMITED",
"SOURENDRA MOHINI PUBLIC SCHOOL",
"SOURIAU INDIA PRIVATE LIMITED",
"SOURISH COMMOSALE PRIVATE LIMITED",
"SOURO METALS & ALLOYS PRIVATE LIMITED",
"SOURSOP SERVICES",
"SOURUSH TECHNO SOLUTIONS PRIVATE LIMITED",
"SOURYA AGRICARE PRIVATE LIMITED",
"SOURYA ROLLING AND ENERGY PRIVATE LIMITED",
"SOUSA TRADING COMPANY PRIVATE LIMITED",
"SOUTENIR INDIA PRIVATE LIMITED",
"SOUTH ASIA FM LIMITED",
"SOUTH ASIA HOTELS LIMITED",
"SOUTH ASIA INTERNATIONAL MARKETING PRIVATE LIMITED",
"SOUTH ASIA LPG COMPANY PRIVATE LIMITED",
"SOUTH ASIAN CERAMIC TILES PRIVATE LIMITED",
"SOUTH ASIAN DEVELOPERS PRIVATE LIMITED",
"SOUTH ASIAN LOGISTIC SERVICES PRIVATE LIMITED",
"SOUTH ASIAN SALES ORGANISATION PRIVATE LIMITED",
"SOUTH ASIAN STOCKS LIMITED",
"SOUTH ASIAN TOLLWAYS PRIVATE LIMITED",
"SOUTH ASIAN UNIVERSITY",
"SOUTH ASSAM ROADWAYS LIMITED",
"SOUTH BENGAL STATE TRANSPORT CORPORATION",
"SOUTH BIHAR POWER DISTUBUTION COMPANY LIMTED",
"SOUTH BISHNUPUR GIRLS HIGH SCHOOL HS",
"SOUTH CALCUTTA DIESELS PRIVATE LIMITED",
"SOUTH CALCUTTA GIRLS COLLEGE",
"SOUTH CANARA DISTRICT CENTRAL CO-OPERATIVE BANK LTD",
"SOUTH CARRYING PRIVATE LIMITED",
"SOUTH CENTRAL RAILWAY",
"SOUTH CENTRAL RAILWAYS",
"SOUTH CITY INTERNATIONAL SCHOOL",
"SOUTH CITY PROJECTS KOLKATA LIMITED",
"SOUTH DELHI FURNISHERS PRIVATE LIMITED",
"SOUTH DELHI HOSPITALITY PRIVATE LIMITED",
"SOUTH DELHI MUNICIPAL CORPORATION",
"SOUTH DELHI PUBLIC SCHOOL",
"SOUTH DELHI VAULTS AND CREDITS LIMITED",
"SOUTH EAST ASIAN EDUCATION TRUST",
"SOUTH EAST CENTRAL RAILWAY",
"SOUTH EAST CONSTRUCTIONS COMPANY PRIVATE. LIMITED.",
"SOUTH EAST ELECTRONIC COMPANY PRIVATEL",
"SOUTH EASTERN CARRIERS PRIVATE LIMITED",
"SOUTH EASTERN CARRIERS PVT LTD",
"SOUTH EASTERN COALFIELDS LIMITED.",
"SOUTH EASTERN RAILWAY",
"SOUTH EASTERN ROADWAYS LIMITED",
"SOUTH END BUILDERS PRIVATE LIMITED",
"SOUTH GANGA WATERS TECHNOLOGIES PRIVATE LIMITED",
"SOUTH GLASS PRIVATE LIMITED",
"SOUTH GUJARAT CARDIOLOGY PRIVATE LIMITED",
"SOUTH GUJARAT CONSTRUCTION COMPANY PRIVATE LIMITED",
"SOUTH GUJARAT SHARES AND SHAREBROKERS LIMITED",
"SOUTH GUJARAT TRANSPORT PRIVATE LIMITED",
"SOUTH HARYANA GOODS CARRIERS PRIVATE LIMITED",
"SOUTH HIMALAYA RENEWABLE POWER PRIVATE LIMITED",
"SOUTH HOWRAH DISTRICT HOSPITAL",
"SOUTH INDIA BEVERAGES PRIVATE LIMITED",
"SOUTH INDIA BOTTLING COMPANY PRIVATE LIMITED",
"SOUTH INDIA BROMINE AND ALLIED CHEMICALS PRIVATE LIMITED",
"SOUTH INDIA CORPORATION TRAVANCORE PVT LTD",
"SOUTH INDIA DIGITAL MUSIC MANAGEMENT PRIVATE LIMITED",
"SOUTH INDIA ENTERPRISES PRIVATE LIMITED",
"SOUTH INDIA FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"SOUTH INDIA FINVEST PRIVATE LIMITED",
"SOUTH INDIA JEWELLERS PRIVATE LIMITED",
"SOUTH INDIA KRISHNA OIL AND FATS PRIVATE LIMITED",
"SOUTH INDIA PAPER DISTRIBUTING COMPANY PRIVATE LIMITED",
"SOUTH INDIA PEST CONTROL PRIVATE LIMITED",
"SOUTH INDIA POLYPRO PRIVATE LIMITED",
"SOUTH INDIA PRIME TANNERY PVT LTD",
"SOUTH INDIA RESEARCH INSTITUTE PVT LTD",
"SOUTH INDIA SHELTERS PRIVATE LIMITED",
"SOUTH INDIA SPINNING MILLS PRIVATE LIMITED",
"SOUTH INDIA STAR PARIVAHAN PRIVATE LIMITED",
"SOUTH INDIA SURGICAL CO LIMITED",
"SOUTH INDIA SURGICAL CO PRIVATE LIMITED",
"SOUTH INDIA TOURIST HOME PRIVATE LIMITED",
"SOUTH INDIA TRANSPORT CORPORATION PRIVATE LIMITED",
"SOUTH INDIA WAREHOUSE CORPORATION",
"SOUTH INDIA WIRE PRODUCTS PRIVATE LIMITED",
"SOUTH INDIAN CONSTRUCTIONS",
"SOUTH INDIAN EDUCATION SOCIETY",
"SOUTH INDIAN GREEN CARDAMOM COMPANY LIMITED",
"SOUTH INTERNATIONAL SCHOOL",
"SOUTH JEWELS (INDIA) PRIVATE LIMITED",
"SOUTH KOREA EMBASSY",
"SOUTH MALABAR STEELS AND ALLOYS PRIVATE LIMITED",
"SOUTH MUM. DIST. CONSUM DISPS REDRL",
"SOUTH MUMBAI CHESS ACADEMY PRIVATE LIMITED",
"SOUTH NESTS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"SOUTH OCEAN LOGISTICSS PRIVATE LIMITED",
"SOUTH OCEAN TRANSPORT PRIVATE LIMITED",
"SOUTH PARK MOTOR PRIVATE LIMITED",
"SOUTH POINT HIGH SCHOOL",
"SOUTH POINT MARKETING PRIVATE LIMITED",
"SOUTH POINT SCHOOL",
"SOUTH PRECISION INSTRUMENT PRIVATE LIMITED",
"SOUTH SHORE ICE CREAMS PVT LTD",
"SOUTH STAR JEWELLERY MANUFACTURING PRIVATE LIMITED",
"SOUTH SUBARBAN CLINIC PVT LTD",
"SOUTH WEST AUTOMATION PRIVATE LIMITED",
"SOUTH WEST MINING LIMITED",
"SOUTH WEST PINNACLE EXPLORATION LIMITED",
"SOUTH WEST PINNACLE EXPLORATION PRIVATE LIMITED",
"SOUTH WEST PORT LIMITED",
"SOUTH WESTERN ENGINEERING INDIA LIMITED",
"SOUTH WESTERN RAILWAY",
"SOUTH. STAR PAPER (INDIA) PRIVATE LIMITED",
"SOUTHBIHAR PLASTIC PRIVATE LIMITED",
"SOUTHCITY PROPERTIES (INDIA) PRIVATE LIMITED",
"SOUTHCO INDIA PRIVATE LIMITED",
"SOUTHEND PHARMA PVT LTD",
"SOUTHERN ACADEMY OF MARITIME STUDIES",
"SOUTHERN AGRIFURANE INDUSTRIES PRIVATE. LIMITED.",
"SOUTHERN AGROTECH INDIA PRIVATE LIMITED",
"SOUTHERN ALLOY FOUNDRIES PRIVATE LIMITED",
"SOUTHERN AUTOMATION AND ELECTRICAL SOLUTIONS PRIVATE LIMITED",
"SOUTHERN AUTOMOBILES PRIVATE LIMITED",
"SOUTHERN BAKERIES PRIVATE LIMITED",
"SOUTHERN BOREWELLS PRIVATE LIMITED",
"SOUTHERN CASHEW EXPORTERS",
"SOUTHERN CHEMICALS INDIA PRIVATE LIMITED",
"SOUTHERN COGEN SYSTEMS PRIVATE LIMITED",
"SOUTHERN COMPOSITES PRIVATE LIMITED",
"SOUTHERN CONCRETE PILES INDIA PRIVATE LIMITED",
"SOUTHERN CONDIMENTS PRIVATE LIMITED",
"SOUTHERN COTSPINNERS COIMBATORE PRIVATE LIMITED",
"SOUTHERN CROP SCIENCE PRIVATE LIMITED",
"SOUTHERN CROSS GROUP INDIA PRIVATE LIMITED",
"SOUTHERN CYLINDERS PVT LTD",
"SOUTHERN ECOLOGICS & SERVICES PRIVATE LIMITED",
"SOUTHERN ELECTRIC CONTROLS INDIA PRIVATE LIMITED",
"SOUTHERN ELECTRICITY SUPPLY COMPANY OF ODISHA LIMITED",
"SOUTHERN ELECTRONICS BANGALORE PRIVATE LIMITED",
"SOUTHERN ENERGY DEVELOPMENT CORPORATION",
"SOUTHERN EQUIPMENT FINANCE LIMITED",
"SOUTHERN EXPANDED POLYSTYRENE PRIVATE LIMITED",
"SOUTHERN EXPLOSIVES COMPANY PRIVATE LIMITED",
"SOUTHERN FERRO STEELS LIMITED",
"SOUTHERN FOREX PRIVATE LIMITED",
"SOUTHERN FORKLIFTERS PRIVATE LIMITED",
"SOUTHERN GRAND HOTELS PRIVATE LIMITED",
"SOUTHERN GREEN FARMING AND MARKETING MULTI STATE CO-OPERATIVE SOCIETY LIMITED",
"SOUTHERN GUARD FORCE PRIVATE LIMITED",
"SOUTHERN HEALTH FOODS PRIVATE LIMITED",
"SOUTHERN HEAVY ENGINEERING PRIVATE LIMITED",
"SOUTHERN HI-Q PAPER CONES AND TUBES PRIVATE LIMITED",
"SOUTHERN HOLDINGS & INVESTMENTS (CHENNAI) PRIVATE LIMITED",
"SOUTHERN INDIA BIDI WORKS PVT LTD",
"SOUTHERN INDIA CHAMBER OF COMMERCE & INDUSTRY",
"SOUTHERN INDIA CIVIL AND TECHNICAL CONSTRUCTION PRIVATE LIMITED",
"SOUTHERN INDIA POLY PRODUCTS PVT LTD",
"SOUTHERN LUBRICATION PRIVATE LIMITED",
"SOUTHERN MAGNESIUM AND CHEMICALS LIMITED",
"SOUTHERN MAGNETICS PRIVATE LIMITED",
"SOUTHERN MARINE EXIM PRIVATE LIMITED",
"SOUTHERN MERCANTILE SERVICES PRIVATE LIMITED",
"SOUTHERN METALS AND ALLOYS PRIVATE LIMITED",
"SOUTHERN MOTORCYCLES",
"SOUTHERN OPTO ELECTRONIC DEVICES PRIVATE LIMITED",
"SOUTHERN OXYGEN CO. PRIVATE LIMITED",
"SOUTHERN PAPER PRODUCTS PVT LTD",
"SOUTHERN PET PLAST (INDIA) PRIVATE LIMITED",
"SOUTHERN PETROCHEMICAL INDUSTRIES CORPORATION LIMITED",
"SOUTHERN PLASTICS PRODUCTS (INDIA) PRIVATE LIMITED",
"SOUTHERN PLASTOWARE PRIVATE LIMITED",
"SOUTHERN POWER DISTRIBUTION COMPANY OF A.P LIMITED",
"SOUTHERN POWER DISTRIBUTION COMPANY OF TELANGANA LIMITED",
"SOUTHERN POWER EQUIPMENT COMPANY PRIVATE LIMITED",
"SOUTHERN POWERSYSTEM REWINDS PRIVATE LIMITED",
"SOUTHERN PROJECTS INDIA PRIVATE LIMITED",
"SOUTHERN RAILWAY",
"SOUTHERN REALTORS AND TOWERS PRIVATE LIMITED",
"SOUTHERN REFRIGERATION SYSTEMS PRIVATE LIMITED",
"SOUTHERN ROAD CARRIERS LIMITED",
"SOUTHERN ROADWAYS LIMITED",
"SOUTHERN ROADWAYS PRIVATE LIMITED",
"SOUTHERN ROCKS AND MINERALS PRIVATE LIMITED",
"SOUTHERN SAVOURIES PRIVATE LIMITED",
"SOUTHERN SCRIBE INSTRUMENTS PRIVATE LIMITED",
"SOUTHERN SPINNERS AND PROCESSORS LIMITED",
"SOUTHERN STAINLESS STEEL FABRICATION INDIA PRIVATE LIMITED",
"SOUTHERN STAR JEWELLERS PRIVATE LIMITED",
"SOUTHERN STAR TRG AREA AND SPORTS COMPLEX",
"SOUTHERN SUPER MARKET PRIVATE LIMITED",
"SOUTHERN SUPPLIES HR SOLUTIONS PRIVATE LIMITED",
"SOUTHERN SURGICALS PRIVATE LIMITED",
"SOUTHERN TAPIOCA INDUSTRIES PRIVATE LIMITED",
"SOUTHERN TERAI TEA PRIVATE LIMITED",
"SOUTHERN TRAILS PRIVATE LIMITED",
"SOUTHERN TRAVELS PRIVATE LIMITED",
"SOUTHERN TREE FARMS LIMITED",
"SOUTHERN TROPICAL FOODS PRIVATE LIMITED",
"SOUTHERN ULOGS PRIVATE LIMITED",
"SOUTHERN UNION PHARMACEUTICALS KERALA PRIVATE LIMITED",
"SOUTHERN WAREHOUSING CO PRIVATE LIMITED",
"SOUTHERN WIND FARMS LIMITED",
"SOUTHERN WOOD LAMINATION CENTER PRIVATE LIMITED",
"SOUTHERN WRITING INSTRUMENTS PRIVATE LIMITED",
"SOUTHEX SHIPING AND CLEARING AGENCY PRIVATE LIMITED",
"SOUTHFIELD PAINTS LIMITED.",
"SOUTH-GUJARAT CARDIAC CARE PRIVATE LIMITED",
"SOUTHINDIAN FOODTECH PRIVATE LIMITED",
"SOUTHMADE REALTY & RETAIL PRIVATE LIMITED",
"SOUTHSIDE HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"SOUTHSIDE MEDICAL SERVICES LLP",
"SOUTH-TECH ENGINEERING PRIVATE LIMITED",
"SOUTHWEST AUTOMATION PRIVATE LIMITED",
"SOUTHWEST CONSULTANCY SERVICES PRIVATE LIMITED",
"SOUTHWEST INDIA MACHINE TRADING PRIVATE LIMITED",
"SOUTHWEST MEDTEC SOLUTIONS PRIVATE LIMITED",
"SOUTHWINDS RESIDENTS ASSOCIATION",
"SOUTIEN INFOTECH OPC PRIVATE LIMITED",
"SOUVENIR (INDIA) PRIVATE LIMITED",
"SOUVENIR PUBLISHERS PRIVATE LIMITED",
"SOUVIN PHARMACEUTICALS (INDIA) PRIVATE LIMITED",
"SOVA ELECTROCASTING LIMITED",
"SOVA FOOD PRODUCTS PVT LTD",
"SOVA FOODWORKS",
"SOVA POWER LIMITED",
"SOVA STORES & SPARES PRIVATE LIMITED",
"SOVAM CROP SCIENCE PRIVATE LIMITED",
"SOVARANI TEA COMPANY PRIVATE LIMITED",
"SOVEREIGN AGRO TECH REFINERY PRIVATE LIMITED",
"SOVEREIGN DIAMONDS LIMITED",
"SOVEREIGN EMBROIDERY PRIVATE LIMITED",
"SOVEREIGN ENGINEERS PRIVATE LIMITED",
"SOVEREIGN GLOBAL MARKETS PRIVATE LIMITED",
"SOVEREIGN HEALTH INDIA PRIVATE LIMITED",
"SOVEREIGN INDUSTRIES",
"SOVEREIGN INTERNATIONAL PRIVATE LIMITED",
"SOVEREIGN IT SOLUTIONS PRIVATE LIMITED",
"SOVEREIGN MEDIA MARKETING PRIVATE LIMITED",
"SOVEREIGN METALS LIMITED",
"SOVEREIGN PET PREFORMS PRIVATE LIMITED",
"SOVEREIGN PHARMA PRIVATE LIMITED",
"SOVEREIGN PUMPING SOLUTIONS PRIVATE LIMITED",
"SOVEREIGN SHIPPING PRIVATE LIMITED",
"SOVEREIGN SOLUTIONS INDIA PRIVATE LIMITED",
"SOVEREIGN TECH ENGINEERING SERVICES PRIVATE LIMITED",
"SOVEREIGN WOOLLENS PRIVATE LIMITED",
"SOVERG PRIVATE LIMITED",
"SOVI INTERNATIONAL TRADING PRIVATE LIMITED",
"SOVIK AUTOS PRIVATE LIMITED",
"SOVIKA AVIATION SERVICES PRIVATE LIMITED",
"SOVIKA CHEMICALS PRIVATE LIMITED",
"SOVINO FOODS PRIVATE LIMITED",
"SOVITRON INTERIORS PRIVATE LIMITED",
"SOVOTEX TEXTILES PRIVATE LIMITED",
"SOVOX RENEWABLES PRIVATE LIMITED",
"SOVPLYM INDIA PRIVATE LIMITED",
"SOVRANO ELECTRIC PRIVATE LIMITED",
"SOWAR PRIVATE LIMITED",
"SOWARE INNOVATIONS PRIVATE LIMITED",
"SOWBAGHYA ENTERPRISES PRIVATE LIMITED",
"SOWBHAGYA PLASTICS PRIVATE LIMITED",
"SOWBHAGYA POLYMERS LIMITED",
"SOWDAMBIKAA MATRICULATION HIGHER SECONDARY SCHOOL",
"SOWDESWARI AMMAN SPINNERS LIMITED",
"SOWIL LIMITED",
"SOWILO INDIA PHARMACEUTICALS PRIVATE LIMITED",
"SOWJANYA FOODS PRIVATE LIMITED",
"SOWJANYA HOUSING PRIVATE LIMITED",
"SOWMIYA SPINNERS PRIVATE LIMITED",
"SOWMIYA TEXTILES PRIVATE LIMITED",
"SOWMYA AGRITECH PRIVATE LIMITED",
"SOWMYA CONTAINER LOGISTICS PRIVATE LIMITED",
"SOWNAKA FINANCE PRIVATE LIMITED",
"SOWNDARIYA LAKSHMI TRADING AGENCY PRIVATE LIMITED",
"SOWPARNIKA PROJECTS AND INFRASTRUCTURE PRIVATE LIMITED",
"SOWPARNIKA RETAIL PRIVATE LIMITED",
"SOWRA AGRO PRIVATE LIMITED",
"SOWRYA CONSULTANCY PRIVATE LIMITED",
"SOWTHU VENTURES PRIVATE LIMITED",
"SOYAGA INFRA VENTURES PRIVATE LIMITED",
"SOYAGREEN PRIVATE LIMITED",
"SOYO CERAMIC PRIVATE LIMITED",
"SOYO ENERGIES PRIVATE LIMITED",
"SOYUZ TALIB ARCHITECTS PRIVATE LIMITED",
"SOYUZ TECHNOLOGIES LLP",
"SOYUZ TRADING COMPANY LIMITED",
"SP ACCURE LABS PRIVATE LIMITED",
"SP ARMADA OIL EXPLORATION PRIVATE LIMITED",
"SP BEVCODE CONSULTANCY SERVICES PRIVATE LIMITED",
"SP CINECORP CINEMATIC VENTURE LIMITED",
"SP COAL RESOURCES PRIVATE LIMITED",
"SP COLLEGE",
"SP CONCARE PRIVATE LIMITED",
"SP CONSTRUCTION PRODUCTS PRIVATE LIMITED",
"SP CORPORATE CONSULTING PRIVATE LIMITED",
"SP CRANES AND STRUCTURES PRIVATE LIMITED",
"SP CRANES PRIVATE LIMITED",
"SP DYNAMIC SERVICES PRIVATE LIMITED",
"SP ENGG CORP PRIVATE LIMITED",
"SP ENGINEERING WORKS PRIVATE LIMITED",
"SP ENGINEERS AUTOTECH INDIA PRIVATE LIMITED",
"SP FABRICATORS PRIVATE LIMITED",
"SP GOLD MINE PRIVATE LIMITED",
"SP GROWTH INDIA PRIVATE LIMITED",
"SP GUIDE PUBLICATIONS PRIVATE LIMITED",
"SP GUPTA OVERSEAS PRIVATE LIMITED",
"SP HI TECH PRINTERS PRIVATE LIMITED",
"SP HI-FY REALTORS PRIVATE LIMITED",
"SP INSTITUTE OF WORKFORCE DEVELOPMENT PRIVATE LIMITED",
"SP INTER COLLEGE CHIRAURI",
"SP INTERNATIONAL SCHOOL FIROZPUR CANTT",
"SP IPROPAT INTELLECTUAL PROPERTY SOLUTIONS PRIVATE LIMITED",
"SP JAMMU UDHAMPUR HIGHWAY LIMITED",
"SP KAMAT HOTELS PRIVATE LIMITED",
"SP LEAK TEST AND AUTOMATION PRIVATE LIMITED",
"SP LIFESTYLE BRANDS PRIVATE LIMITED",
"SP MEDICAL CENTER PRIVATE LIMITED",
"SP METALFAB ENGINEERS PRIVATE LIMITED",
"SP MULTI SPECIALITY HOSPITALS PRIVATE LIMITED",
"SP PORT MAINTENANCE PRIVATE LIMITED",
"SP POWER & INFRA PRIVATE LIMITED",
"SP PREVENTIVE HEALTHCARE PRIVATE LIMITED",
"SP REFRACTORIES LIMITED",
"SP REPCON PRIVATE LIMITED",
"SP ROBOTIC WORKS PRIVATE LIMITED",
"SP S INTRAD PRIVATE LIMITED",
"SP SAFE CONTROL SYSTEMS PRIVATE LIMITED",
"SP SAI IT PRIVATE LIMITED",
"SP SANYAL ENTERPRISE PRIVATE LIMITED",
"SP SEMICONDUCTORS PRIVATE LIMITED",
"SP SOFTWARE PRIVATE LIMITED",
"SP SPINNING MILLS PRIVATE LIMITED",
"SP STAFFING SERVICES PRIVATE LIMITED",
"SP STUDY PLANNER LLP",
"SP SUGAR & AGRO PRIVATE LIMITED",
"SP SUPERFINE COTTON MILLS PRIVATE LIMITED",
"SP TECHPIONEER PRIVATE LIMITED",
"SP VALLEY VIEW RESORTS PRIVATE LIMITED",
"SP WHEELERS PRIVATE LIMITED",
"SPA AGRO LIMITED",
"SPA BUILDERS PRIVATE LIMITED",
"SPA CAPITAL SERVICES LIMITED",
"SPA CERAMIC PRIVATE LIMITED",
"SPA DESIGN PRIVATE LIMITED",
"SPA ENTERPRISES",
"SPA FABRICS PROCESSOR PRIVATE LIMITED",
"SPA HEIGHTS PRIVATE LIMITED",
"SPA HOLDINGS PRIVATE LIMITED",
"SPA INSURANCE BROKING SERVICES LIMITED",
"SPA LIFESTYLE PRIVATE LIMITED",
"SPA SECURITIES LIMITED.",
"SPA VET-MIN PRIVATE LIMITED",
"SPA YOGA PRIVATE LIMITED",
"SPAAK SUPER INFRA INDIA PRIVATE LIMITED",
"SPAB CHEMICALS PRIVATE LIMITED",
"SPAC PRECISION PRIVATE LIMITED",
"SPAC STARCH PRODUCTS (INDIA) PRIVATE LIMITED",
"SPAC STARCH PRODUCTS INDIA LIMITED",
"SPACE AGE ASSOCIATES POWER-INFRA PRIVATE LIMITED",
"SPACE AGE NETWORKS LIMITED",
"SPACE AGE POWER PRIVATE LIMITED",
"SPACE AGE RESEARCH & TECHNOLOGY FOUNDATION CHARITABLE TRUST",
"SPACE ALLOYS PRIVATE LIMITED",
"SPACE BUILDCON PRIVATE LIMITED",
"SPACE BUSINESS SOLUTIONS",
"SPACE CHEM ENGINEERS PRIVATE LIMITED",
"SPACE CIRCLE CLUBS & RESORTS PRIVATE LIMITED",
"SPACE COMPUTECH INDIA PRIVATE LIMITED",
"SPACE CONNECTORS PRIVATE LIMITED",
"SPACE CORPORATION LIMITED",
"SPACE CREATING TECHNOLOGY PRIVATE LIMITED",
"SPACE CREATORS",
"SPACE DESIGN FURNITURE AND FIXTURES INDIA PRIVATE LIMITED",
"SPACE ELEVATORS PRIVATE LIMITED",
"SPACE ENGINEERS CONSORTIUM PRIVATE LIMITED",
"SPACE ERA MATERIALS AND PROCESSES PRIVATE LIMITED",
"SPACE FACILITIES PRIVATE LIMITED",
"SPACE FASHIONS LIMITED",
"SPACE HUB SMART LIVINGS PRIVATE LIMITED",
"SPACE HUNTERS INDIA PRIVATE LIMITED",
"SPACE HVAC SYSTEMS PRIVATE LIMITED",
"SPACE INFRA CONSULTING PRIVATE LIMITED",
"SPACE INFRA INTERIOR SOLUTION PRIVATE LIMITED",
"SPACE INTERNATIONAL AIR TRAVELS PRIVATE LIMITED",
"SPACE KNITWEARS PVT LTD",
"SPACE KONSTRYST PRIVATE LIMITED",
"SPACE KREATORS DEVELOPERS PRIVATE LIMITED",
"SPACE LINK EXIM PRIVATE LIMITED",
"SPACE LINK SYSTEMS PRIVATE LIMITED",
"SPACE MAGNUM EQUIPMENT PRIVATE LIMITED",
"SPACE MANAGEMENT SERVICES PRIVATE LIMITED",
"SPACE MANAGEMENT SYSTEMS INDIA PRIVATE LIMITED",
"SPACE MONKEY MEDIA PROJECT PRIVATE LIMITED",
"SPACE MULTIMEDIA PRIVATE LIMITED",
"SPACE MUSH LLP",
"SPACE OFFICE SYSTEMS INDIA PRIVATE LIMITED",
"SPACE PLUS DESIGN LABS PRIVATE LIMITED",
"SPACE REALTORS PRIVATE LIMITED",
"SPACE SOLUTIONS REALTY PRIVATE LIMITED",
"SPACE STEM PRIVATE LIMITED",
"SPACE TECH EQUIPMENTS AND STRUCTURALS PRIVATE LIMITED",
"SPACE TELEINFRA PRIVATE LIMITED",
"SPACE TELELINK LIMITED",
"SPACE TEXTILES PRIVATE LIMITED",
"SPACE TRADEMART PRIVATE LIMITED",
"SPACE VENTILATION SYSTEMS PRIVATE LIMITED",
"SPACE VILLA PRIVATE LIMITED",
"SPACE VISION DIGITAL NETWORK PRIVATE LIMITED",
"SPACE VISION PROJECTS PRIVATE LIMITED",
"SPACE WOOD FURNISHERS PRIVATE LIMITED",
"SPACE X COM PRIVATE LIMITED",
"SPACE2HOST WEB SERVICES PRIVATE LIMITED",
"SPACEACE CREATIVE PRIVATE LIMITED",
"SPACEAGE ASSOCIATES",
"SPACEAGE MULTIPRODUCTS PRIVATE.LIMITED",
"SPACEAGE SECURITY SYSTEMS LIMITED",
"SPACEAGE STORAGE CONCEPTS PRIVATE LIMITED",
"SPACEAGE SWITCHGEARS LIMITED",
"SPACEAGE SWITCHGEARS PRIVATE LIMITED",
"SPACEAGE SYNTEX PRIVATE LIMITED",
"SPACEBAR TECHNOLOGIES PRIVATE LIMITED",
"SPACEBIZ SOLUTIONS PRIVATE LIMITED",
"SPACEBOT ENTERTAINMENT PRIVATE LIMITED",
"SPACEBOUND WEB LABS PRIVATE LIMITED",
"SPACECHEM ENTERPRISES PRIVATE LIMITED",
"SPACECODE INDIA PRIVATE LIMITED",
"SPACECREATO INDUSTRIES PRIVATE LIMITED",
"SPACEDGE EXPRESS SOLUTIONS PRIVATE LIMITED",
"SPACEEX MOBITECH PRIVATE LIMITED",
"SPACEGRAPH TECHNOLOGIES PRIVATE LIMITED",
"SPACEKON CONSTRUCTIONS PRIVATE LIMITED",
"SPACEKREATORS URBAN PLANNERS AND DESIGNERS PRIVATE LIMITED",
"SPACELABS INTERIOR PRIVATE LIMITED",
"SPACELANCE OFFICE SOLUTIONS PRIVATE LIMITED",
"SPACELINE INFRA PRIVATE LIMITED",
"SPACELINK NETWORK PRIVATE LIMITED",
"SPACEMAN SPIRITS LAB PRIVATE LIMITED",
"SPACEMAX INDOOR SOLUTIONS PRIVATE LIMITED",
"SPACEMEKK DESIGNERS PRIVATE LIMITED",
"SPACEMEN DIGITAL PRIVATE LIMITED",
"SPACENET INTERNET SERVICES PRIVATE LIMITED",
"SPACENEX AERO PRIVATE LIMITED",
"SPACENOS TECHNOLOGIES PRIVATE LIMITED",
"SPACE-O INFOWEB PRIVATE LIMITED",
"SPACES AND BETWEEN PRIVATE LIMITED",
"SPACESAVER MODULAR FURNITURE PRIVATE LIMITED",
"SPACESHIP INFRA LIMITED",
"SPACESTART TRADEX (OPC) PRIVATE LIMITED",
"SPACETECH CRYO EQUIPMENTS PRIVATE LIMITED",
"SPACETECH DEVELOPERS PRIVATE LIMITED",
"SPACETECH LOGISTICS SOLUTIONS PRIVATE LIMITED",
"SPACETHEORY SOLUTIONS PRIVATE LIMITED",
"SPACETHETICS INTERIOR SOLUTION PRIVATE LIMITED",
"SPACETIME MANAGEMENT PRIVATE LIMITED",
"SPACEWOOD OFFICE SOLUTIONS PRIVATE LIMITED",
"SPACEWORKZ SOLUTIONS PRIVATE LIMITED",
"SPACEX COMPOSITES INDIA PRIVATE LIMITED",
"SPACEX FURNITURE PRIVATE LIMITED",
"SPACEX STUDIO PRIVATE LIMITED",
"SPACEZONE INDIA PRIVATE LIMITED",
"SPACK AUTOMOTIVES PRIVATE LIMITED",
"SPACK COATERS PRIVATE LIMITED",
"SPACK LAMINATORS PRIVATE LIMITED",
"SPACONS EPC PRIVATE LIMITED",
"SPACTRO MEDIA PRIVATE LIMITED",
"SPADE FARMS AND FINANCE PRIVATE LIMITED",
"SPADE INFOTECH PRIVATE LIMITED",
"SPADE INTEGRATED SERVICES PRIVATE LIMITED",
"SPADE PROJECTS PRIVATE LIMITED",
"SPADEWORKS SOURCING PRIVATE LIMITED",
"SPADEZ SOLUTIONS PRIVATE LIMITED",
"SPADILLE CLEANING SERVICES PRIVATE LIMITED",
"SPADS POLYPLAST PRODUCTS PRIVATE LIMITED",
"SPADS RED FIELDS EXIM PRIVATE LIMITED",
"SPAG CONSULTANTS PRIVATE LIMITED",
"SPAGRES INDIA PRIVATE LIMITED",
"SPAGRO PROCESSOR PRIVATE LIMITED",
"SPAK ORGOCHEM INDIA PRIVATE LIMITED",
"SPAK TECHNOLOGIES PRIVATE LIMITED",
"SPAKY ENGINEERING PRIVATE LIMITED",
"SPAL AUTOMOTIVE TECHNOLOGY INDIA PRIVATE LIMITED",
"SPAL CONNECTS PRIVATE LIMITED",
"SPALON INDIA PRIVATE LIMITED",
"SPAN AIR PRIVATE LIMITED",
"SPAN APPARELS PRIVATE LIMITED",
"SPAN ARCH DEVELOPERS PRIVATE LIMITED",
"SPAN AUTOTECH PRIVATE LIMITED",
"SPAN CAPLEASE PRIVATE LIMITED",
"SPAN COMMUNICATIONS",
"SPAN CONTROL SYSTEMS PRIVATE LIMITED",
"SPAN DIVERGENT LIMITED",
"SPAN ENGINE COOLING SYSTEMS PVT LTD",
"SPAN FASTENERS PRIVATE LIMITED",
"SPAN FILLING SYSTEMS PRIVATE LIMITED",
"SPAN FILTRATION SYSTEMS PRIVATE LIMITED",
"SPAN FINCAP PRIVATE LIMITED",
"SPAN FORGING PRIVATE LIMITED",
"SPAN FURNISHERS PRIVATE LIMITED",
"SPAN HEALTHCARE CONSULTING PRIVATE",
"SPAN HEALTHCARE PRIVATE LIMITED",
"SPAN HI-TECH PRIVATE LIMITED",
"SPAN HOLDINGS PRIVATE LTD.",
"SPAN HYDROTECH PRIVATE LIMITED",
"SPAN INDIA PVT LTD",
"SPAN INFRA BUILDERS PRIVATE LIMITED",
"SPAN INNOVATIONS PRIVATE LIMITED",
"SPAN INSPECTION SYSTEMS PRIVATE LIMITED",
"SPAN INTERMEDIATES P LTD",
"SPAN LIFE SCIENCES PRIVATE LIMITED",
"SPAN MARINE INDIA PRIVATE LIMITED",
"SPAN MATERIAL TESTING AND CONSULTANCY SERVICES LIMITED",
"SPAN MINERALS PRIVATE LIMITED",
"SPAN MOTELS PRIVATE LIMITED",
"SPAN NETWORK AND FACILITY MANAGEMENT PRIVATE LIMITED",
"SPAN OUTSOURCING PRIVATE LIMITED",
"SPAN PACKAGING PRIVATE LIMITED",
"SPAN PLASTICS PRIVATE LIMITED",
"SPAN PRECISION COMPONENTS PRIVATE LIMITED",
"SPAN PUMPS PRIVATE LIMITED",
"SPAN REMEDIES PRIVATE LIMITED",
"SPAN RETAIL PRIVATE LIMITED",
"SPAN SALES PRIVATE LIMITED",
"SPAN SEATING SYSTEMS PRIVATE LIMITED",
"SPAN SPECTRUM PRIVATE LIMITED",
"SPAN TECHNOLOGY SERVICES PRIVATE LIMITED",
"SPAN VENTURES PRIVATE LIMITED",
"SPAN WALL3 PRIVATE LIMITED",
"SPANCHEM TECHNOLOGIES PRIVATE LIMITED",
"SPANDAN ADVANCE MEDICARE PRIVATE LIMITED",
"SPANDAN BUSINESS PVT LTD",
"SPANDAN DIAGNOSTIC CENTRE PRIVATE LIMITED",
"SPANDAN ENTERPRISE PVT LTD",
"SPANDAN HEART INSTITUTE",
"SPANDAN HOSPITAL",
"SPANDAN MULTISPECIALITY HOSPITAL",
"SPANDAN NURSING HOME & ICCU",
"SPANDANA HOSPITALS PRIVATE LIMITED",
"SPANDANA LEARNING SOLUTIONS PRIVATE LIMITED",
"SPANDANA ONCOLOGY CENTRE PRIVATE LIMITED",
"SPANDANA SPHOORTY FINANCIAL LIMITED",
"SPANEX GLOBAL SERVICES PRIVATE LIMITED",
"SPANFIELD LOGISTICS PRIVATE LIMITED",
"SPANGLE ALLOYS PRIVATE LIMITED",
"SPANGLE CLOTHING PRIVATE LIMITED",
"SPANGLE ENERGY PRIVATE LIMITED",
"SPANIDEA SYSTEMS PRIVATE LIMITED",
"SPANIND DESIGNS PRIVATE LIMITED",
"SPANISH STANDARD SANITARYWARE PRIVATE LIMITED",
"SPANISO STUDIO",
"SPANKER INTERNATIONAL PRIVATE LIMITED",
"SPANMAX BUILDING SYSTEMS PRIVATE LIMITED",
"SPANNKRAFT HYDROSYSTEMS PRIVATE LIMITED",
"SPANS ENVIROTECH PRIVATE LIMITED",
"SPANSA PHARMACEUTICALS PRIVATE LIMITED",
"SPANSULES FORMULATIONS PRIVATE LIMITED",
"SPANSULES PHARMATECH PRIVATE LIMITED",
"SPANSURE MEDICAL INSTRUMENTS PRIVATE LIMITED",
"SPANTECH DREAMBUILD PRIVATE LIMITED",
"SPANTECH ENGINEERING INDUSTRIES PRIVATE LIMITED",
"SPANTECH ENGINEERS PRIVATE LIMITED",
"SPANV MEDISEARCH LIFESCIENCES PRIVATE LIMITED",
"SPAR APPLIANCES PRIVATE LIMITED",
"SPAR GEO INFRA PRIVATE LIMITED",
"SPAR KROGNOS MARKETING PRIVATE LIMITED",
"SPAR MANAGEMENT & TECHNOLOGIES PRIVATE LIMITED",
"SPAR REALTORS PRIVATE LIMITED",
"SPAR SOLUTIONS INDIA PRIVATE LIMITED",
"SPAR TEXFAB PRIVATE LIMITED",
"SPAR WELDTECH PRIVATE LIMITED",
"SPARC BIOTECH PRIVATE LIMITED",
"SPARC CYBERTECH PRIVATE LIMITED",
"SPARC ELECTREX LIMITED",
"SPARC INFOTECH PRIVATE LIMITED",
"SPARCO BATTERIES PRIVATE LIMITED",
"SPARCO ENGINEERING PVT LTD",
"SPARCO MULTIPLAST PRIVATE LIMITED",
"SPARDHA STEEL PRIVATE LIMITED",
"SPARE AUTOTECH PRIVATE LIMITED",
"SPARE MACHINES CONSULTANTS PRIVATE LIMITED",
"SPAREAGE SEALING SOLUTIONS LLP",
"SPAREPEDIA PRIVATE LIMITED",
"SPARES AND COMPONENTS CO PRIVATE LIMITED",
"SPARIENT GLOBAL LLP",
"SPARION INFRASTRUCTURE PRIVATE LIMITED",
"SPARION INTERNATIONAL PRIVATE LIMITED",
"SPARITY SOFT TECHNOLOGIES PRIVATE LIMITED",
"SPARK ASIA IMPACT MANAGERS PRIVATE LIMITED",
"SPARK ASIA IMPACT PRIVATE LIMITED",
"SPARK AUTOMECH PRIVATE LIMITED",
"SPARK AUTOMETAL COMP PRIVATE LIMITED",
"SPARK CAPITAL ADVISORS INDIA PRIVATE LIMITED",
"SPARK CONDUCTORS PRIVATE LIMITED",
"SPARK CORPORATE SERVICES PRIVATE LIMITED",
"SPARK CUTTING SOLUTION PRIVATE LIMITED",
"SPARK EIGHTEEN LIFESTYLE PRIVATE LIMITED",
"SPARK ELECTRICALS & PROJECTS PRIVATE LIMITED",
"SPARK ELECTRICALS PVT LTD",
"SPARK ELECTRO CONSULTANTS (INDIA) PRIVATE LIMITED",
"SPARK ELECTRODES PRIVATE LIMITED",
"SPARK ENGINEERING PRIVATE LIMITED",
"SPARK ENGINEERING PRIVATE. LIMITED.",
"SPARK ENGINEERS",
"SPARK ENGINEERS PRIVATE LIMITED",
"SPARK FINWIZ PRIVATE LIMITED",
"SPARK FURNITURES PRIVATE LIMITED",
"SPARK GLOBAL SCS SERVICES PRIVATE LIMITED",
"SPARK HEALTHCARE PRIVATE LIMITED",
"SPARK HOLIDAYS PRIVATE LIMITED",
"SPARK HYDRO PNEUMATICS PRIVATE. LIMITED",
"SPARK INDUSTRIES LLP",
"SPARK INFRAMARK PRIVATE LIMITED",
"SPARK INSULATORS PRIVATE. LIMITED.",
"SPARK INTERNATIONAL PRIVATE LIMITED",
"SPARK IRRIGATION PRIVATE LIMITED",
"SPARK JEWELRY PRIVATE LIMITED",
"SPARK LOGISTICS PRIVATE LIMITED",
"SPARK MARKBUILDCAP PRIVATE LIMITED",
"SPARK MATRICULATION HR SEC SCHOOL",
"SPARK MEDICARE PRIVATE LIMITED.",
"SPARK MINDA FOUNDATION",
"SPARK MOTORS PRIVATE LIMITED",
"SPARK ONLINE PRIVATE LIMITED",
"SPARK PLACEMENT PRIVATE LIMITED",
"SPARK PLASTOMECH INDIA PRIVATE LIMITED",
"SPARK REAL ESTATE PRIVATE LIMITED",
"SPARK REALTORS PRIVATE LIMITED",
"SPARK SCIENTIFIC PRIVATE LIMITED",
"SPARK SECURITIES PVT LTD",
"SPARK SOLAR TECHNOLOGIES PRIVATE LIMITED",
"SPARK SPRING INDUSTRIES PRIVATE LIMITED",
"SPARK SR SEC SCHOOL",
"SPARK TECHNOLOGIES PRIVATE LIMITED",
"SPARK TG INFO PRIVATE LIMITED",
"SPARK UTILITY SERVICES PRIVATE LIMITED",
"SPARK YUGCHEM PRIVATE LIMITED",
"SPARK44 DEMAND CREATION PRIVATE LIMITED",
"SPARK-ALL SECURITY AND ALLIED SERVICES PRIVATE LIMITED",
"SPARKEN IT SOLUTIONS PRIVATE LIMITED",
"SPARKIN SUNLIT PRIVATE LIMITED",
"SPARKLE ASSOCIATES ENTERPRISES PRIVATE LIMITED",
"SPARKLE CLEAN TECH PRIVATE LIMITED",
"SPARKLE COMMERCIAL PRIVATE LIMITED",
"SPARKLE DIAM PRIVATE LIMITED",
"SPARKLE FACILITY SERVICES PRIVATE LIMITED",
"SPARKLE GOLD MINES PRIVATE LIMITED",
"SPARKLE GOLD RETAIL VENTURES LLP",
"SPARKLE HOSPITALS PRIVATE LIMITED",
"SPARKLE IMPEX PRIVATE LIMITED",
"SPARKLE MANUFACTURING PRIVATE LIMITED",
"SPARKLE MEDICHEM PRIVATE LIMITED",
"SPARKLE METAL WORKS PRIVATE LIMITED",
"SPARKLE PORT SERVICES LIMITED",
"SPARKLE SERVICES MUMBAI PRIVATE LIMITED",
"SPARKLE SERVICES PRIVATE LIMITED",
"SPARKLE SHIPPING & LOGISTICS PRIVATE LIMITED",
"SPARKLE SOFT-TECH PRIVATE LIMITED",
"SPARKLE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"SPARKLE STEEL PROFILES PRIVATE LIMITED",
"SPARKLE TERMINAL AND TOWAGE SERVICES LIMITED",
"SPARKLE TOOLS PRIVATE LIMITED",
"SPARKLEAN FACILITY MANAGEMENT PRIVATE LIMITED",
"SPARKLER CERAMICS PRIVATE LIMITED",
"SPARKLER METALS PRIVATE LIMITED",
"SPARKLES EXIM PRIVATE LIMITED",
"SPARKLET ENGINEERS PRIVATE LIMITED",
"SPARKLIN INNOVATIONS PRIVATE LIMITED",
"SPARKLINE EQUIPMENTS PRIVATE LIMITED",
"SPARKLINE WELD TECHNOLOGIES PRIVATE LIMITED",
"SPARKLING FACILITIES PRIVATE LIMITED",
"SPARKLING HUES GEMS PRIVATE LIMITED",
"SPARKLING INITIATIVES PRIVATE LIMITED",
"SPARKLING STARS SCHOOL",
"SPARKONIX INDIA PRIVATE LIMITED",
"SPARKPRO CREATIVES PRIVATE LIMITED",
"SPARKS & GS PRIVATE LIMITED",
"SPARKSUPPORT INFOTECH PRIVATE LIMITED",
"SPARKT PRIVATE LIMITED",
"SPARKTECH SYSTEMS PRIVATE LIMITED",
"SPARKTIME LOGISTICS PRIVATE LIMITED",
"SPARKY ENTERTAINMENT INDIA PRIVATE LIMITED",
"SPARKYO TECHNOLOGY PRIVATE LIMITED",
"SPARNOD FITNESS EQUIPMENT PRIVATE LIMITED",
"SPARQUE INDUSTRIAL PRODUCTS (OPC) PRIVATE LIMITED",
"SPARR ELECTRONICS LIMITED",
"SPARRC",
"SPARROW CAPITAL ADVISORS PRIVATE LIMITED",
"SPARROW DEVCON PRIVATE LIMITED",
"SPARROW ELECTRONICS LIMITED",
"SPARROW HR SOLUTIONS PRIVATE LIMITED",
"SPARROW INTERACTIVE PRIVATE LIMITED",
"SPARROW LIFECARE PRIVATE LIMITED",
"SPARROW REALTY PRIVATE LIMITED",
"SPARROW RISK MANAGEMENT PRIVATE LIMITED",
"SPARROW SOFTECH PRIVATE LIMITED",
"SPARROW TECHNOLOGIES LIMITED",
"SPARROWCLASSIC TRENDS PRIVATE LIMITED",
"SPARROWS OFFSHORE SERVICES INDIA PRIVATE LIMITED",
"SPARSA DIGITAL PRIVATE LIMITED",
"SPARSH AUTOMOBILES PRIVATE LIMITED",
"SPARSH AUTOTECH PRIVATE LIMITED",
"SPARSH BALDEV EXPORTS PRIVATE LIMITED",
"SPARSH BIO-TECH PRIVATE LIMITED",
"SPARSH BUILDERS PRIVATE LIMITED",
"SPARSH CARGO PRIVATE LIMITED",
"SPARSH COMMUNICATIONS LIMITED",
"SPARSH DESIGNS PRIVATE LIMITED",
"SPARSH DIAGNOSTICA PRIVATE LIMITED",
"SPARSH ELECTRONICS (INDIA) PRIVATE LIMITED",
"SPARSH ENGINEERING COMPANY PRIVATE LIMITED",
"SPARSH FAB TEXTILES PRIVATE LIMITED",
"SPARSH FASHIONS PRIVATE LIMITED",
"SPARSH FOODS INDIA PRIVATE LIMITED",
"SPARSH GOVERNMENT BLIND INTER COLLEGE",
"SPARSH GRAIN INTERNATIONAL PRIVATE LIMITED",
"SPARSH HEALING AND CARE (INDIA) PVT. LTD.",
"SPARSH HOSPITAL",
"SPARSH INDUSTRIES PRIVATE LIMITED",
"SPARSH INFORMATION TECHNOLOGY PRIVATE LIMITED",
"SPARSH INFRATECH PRIVATE LIMITED",
"SPARSH LAMINATORS PRIVATE LIMITED",
"SPARSH LIFECARE PRIVATE LIMITED",
"SPARSH LIFESTYLE PRIVATE LIMITED",
"SPARSH LOGISTICS PRIVATE LIMITED",
"SPARSH MULTISPECIALTY HOSPITAL PRIVATE LIMITED",
"SPARSH PACKAGINGS PRIVATE LIMITED",
"SPARSH POLYCHEM PRIVATE LIMITED",
"SPARSH SUPER SPECIALITY HOSPITAL,¬†YESWANTHPUR",
"SPARSH SUPERSPECIALITY HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED",
"SPARSH SYNTHETICS PRIVATE LIMITED",
"SPARSH TIE-UP PRIVATE LIMITED",
"SPARSH TRANSPORT CARRIERS PRIVATE LIMITED",
"SPARSH VIDYUT PRIVATE. LIMITED.",
"SPARSHA INFERTILITY CENTRE PRIVATE LIMITED",
"SPARSHA PHARMA INTERNATIONAL PRIVATE LIMITED",
"SPARTA AGRITECH PRIVATE LIMITED",
"SPARTA BROKING PRIVATE LIMITED",
"SPARTA CLOUD SOLUTIONS PRIVATE LIMITED",
"SPARTA GLASS PRIVATE LIMITED",
"SPARTA SECURITY & ALLIED SOLUTIONS PRIVATE LIMITED",
"SPARTA VENTURE PRIVATE LIMITED",
"SPARTAINFOTECH SOLUTIONS PRIVATE LIMITED",
"SPARTAN BUILDERS PRIVATE LIMITED",
"SPARTAN ENGINEERING INDUSTRIES PRIVATE LIMITED",
"SPARTAN INDUSTRIES",
"SPARTAN MATRICULATION HIGHER SECONDARY SCHOOL",
"SPARTAN ONLINE PRIVATE LIMITED",
"SPARTAN SAFETY INDIA PRIVATE LIMITED",
"SPARTAN SUPPLY PRIVATE LIMITED",
"SPARTAN TRADING PRIVATE LIMITED",
"SPARTANS COMPUTECH PRIVATE LIMITED",
"SPARTEK CERAMICS INDIA LIMITED",
"SPARTEN GRANITO PRIVATE LIMITED",
"SPARTEN PULP PRIVATE LIMITED",
"SPARTINE INFOTECH PRIVATE LIMITED",
"SPARX IT SOLUTIONS PRIVATE LIMITED",
"SPARX TECHNOLOGIES PRIVATE LIMITED",
"SPARXX MARITIME & LOGISTICS PRIVATE LIMITED",
"SPAS ENGINEERS PRIVATE LIMITED",
"SPASA RUBBER PRODUCTS PRIVATE LIMITED",
"SPASA RUBBER ROLLERS PRIVATE LIMITED",
"SPASH ADVISORS PRIVATE LIMITED",
"SPASHTA TECHNOLOGIES PRIVATE LIMITED",
"SPASIA INFOTECH PRIVATE LIMITED",
"SPASIBO ENTERPRISE PRIVATE LIMITED",
"SPATIAL ACCESS PRIVATE LIMITED",
"SPATIAL PLANNING AND ANALYSIS RESEARCH CENTRE PRIVATE LIMITED",
"SPATIEN VENTURES PRIVATE LIMITED",
"SPATIKA INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"SPAURA INFRASTRUCTURE LIMITED",
"SPAV SHIPPING INDIA PRIVATE LIMITED",
"SPAXE HOSPITALITY & WELLNESS PRIVATE LIMITED",
"SPAY TECHNOLOGY PRIVATE LIMITED",
"SPAZE HUB LOGISTICS PRIVATE LIMITED",
"SPAZE TOWERS PRIVATE LIMITED",
"SPAZIUM FURNITURE SYSTEMS PRIVATE LIMITED",
"SPB NEW ALLOY STEEL PRIVATE LIMITED",
"SPB PACKAGING PRIVATE LIMITED",
"SPB PROJECTS AND CONSULTANCY LIMITED",
"SPBL ENERGY PRIVATE LIMITED",
"SPBP TEA INDIA LIMITED",
"SPC CHETAK TOLLWAYS PRIVATE LIMITED",
"SPC ELECTROTECH PRIVATE LIMITED",
"SPC FAB PRIVATE LIMITED",
"SPC HEALTHCARE PRIVATE LIMITED",
"SPC INFOSOFT PRIVATE LIMITED",
"SPC INTERNATIONAL INDIA PRIVATE LIMITED",
"SPC LIFE SCIENCES LIMITED",
"SPC MANAGEMENT SERVICES PRIVATE LIMITED",
"SPC NEXT CONSULTING PRIVATE LIMITED",
"SPCX PRIVATE LIMITED",
"SPD CONSTRUCTIONS LIMITED",
"SPD INDIA HEALTHCARE PRIVATE LIMITED",
"SPD INDUSTRIES INDIA PRIVATE LIMITED",
"SPD INFRA PROJECTS PRIVATE LIMITED",
"SPD INFRACON PRIVATE LIMITED",
"SPD INTERNATIONAL INFRATECH PRIVATE LIMITED",
"SPDD INFRA PRIVATE LIMITED",
"SPE FILMS INDIA PRIVATE LIMITED",
"SPE HOMES PRIVATE LIMITED",
"SPE INDUSTRIES PRIVATE LIMITED",
"SPE PROCESS PUMPS PRIVATE LIMITED",
"SPEAKING TREE PICTURES PRIVATE LIMITED",
"SPEAKOUT BPO SERVICES PRIVATE LIMITED",
"SPEAKWELL ENTERPRISES PRIVATE LIMITED",
"SPEAKWELL SKILLS ACADEMY PRIVATE LIMITED",
"SPEAR AGRO INDUSTRIES PRIVATE LIMITED",
"SPEAR LOGISTICS PRIVATE LIMITED",
"SPEAR PACK PRIVATE LIMITED",
"SPEARHEAD BUSDUCTS PRIVATE LIMITED",
"SPEARHEAD CORPORATE SERVICES PRIVATE LIMITED",
"SPEARHEAD DESTINATIONS PRIVATE LIMITED",
"SPEARHEAD INFOTECH PRIVATE LIMITED",
"SPEARHEAD LIVE (INDIA) PRIVATE LIMITED",
"SPEARHEAD MEDIA PRIVATE LIMITED",
"SPEARHEAD PROPERTIES PRIVATE LIMITED",
"SPEARHEAD RESEARCH INDIA PRIVATE LIMITED",
"SPEARTALENT IT CONSULTING PRIVATE LIMITED",
"SPEB ADHESIVES PRIVATE LIMITED",
"SPECADEL TECHNOLOGIES PRIVATE LIMITED",
"SPECAGRI TECHNOLOGIES PRIVATE LIMITED",
"SPECBEE CONSULTING SERVICES PRIVATE LIMITED",
"SPECGRAPH (INDIA ) PVT LTD",
"SPECHEM INDIA PRIVATE LIMITED",
"SPECIAL AGENT SECURE SERVICES PRIVATE LIMITED",
"SPECIAL AUDITOR MILK AUDIT OFFICE",
"SPECIAL BIOCHEM PRIVATE LIMITED",
"SPECIAL BLASTS LIMITED",
"SPECIAL CABLES PRIVATE. LIMITED.",
"SPECIAL CERAMICS PRIVATE LIMITED",
"SPECIAL DIST SOCIAL WELFARE OFFICER LATUR",
"SPECIAL ENGG. SERVICES LTD",
"SPECIAL EXECUTIVE MAGISTRATE PUNE SUB DIVISON PUNE",
"SPECIAL FOODS PRIVATE LIMITED",
"SPECIAL GAS & EQUIPMENT SOLUTIONS PRIVATE LIMITED",
"SPECIAL HOME FOR GIRLS MUNDHAWA",
"SPECIAL LIME STONE PRIVATE LIMITED",
"SPECIAL LUBRICANTS PRIVATE LIMITED",
"SPECIAL MINERALSPECIALITIES PRIVATE LIMITED",
"SPECIAL PROTECTION GROUP",
"SPECIAL SPRING INDIA PVT LTD",
"SPECIAL STEELWIRE ROPES LIMITED",
"SPECIAL TOOLS PRIVATE LIMITED",
"SPECIAL WIRE PRODUCTS PRIVATE LIMITED",
"SPECIAL YARNS PVT LTD",
"SPECIALISED ANILA FOODS PRIVATE LIMITED",
"SPECIALISED COMPONENTS PVT LTD",
"SPECIALISED IT SQUAD PRIVATE LIMITED",
"SPECIALISED SHIP & CARGO HANDLING AGENCY PVT LTD",
"SPECIALIST ENGINEERING SERVICES PRIVATE LIMITED",
"SPECIALIST HEALTH SYSTEMS PRIVATE LIMITED",
"SPECIALIST HOUSEKEEPING & SAFETY INDIA PRIVATE LIMITED",
"SPECIALITIES ALUMINIUM GRILLS PRIVATE LIMITED",
"SPECIALITY BUILDCON PRIVATE LIMITED",
"SPECIALITY CANS INDIA PRIVATE LIMITED",
"SPECIALITY ENTERPRISES PRIVATE LIMITED",
"SPECIALITY EXIM PVT LTD",
"SPECIALITY GASES PRIVATE LIMITED",
"SPECIALITY INDIAN FOOD PARKS EXPORTS PRIVATE LIMITED",
"SPECIALITY INDUSTRIAL POLYMERS AND COATINGS PRIVATE LIMITED",
"SPECIALITY INNOTECH PRIVATE LIMITED",
"SPECIALITY KAOLIN PRIVATE LIMITED",
"SPECIALITY MEDICINES PRIVATE LIMITED",
"SPECIALITY MEDITECH PRIVATE LIMITED",
"SPECIALITY MERCHANDISING SERVICES PRIVATE LIMITED",
"SPECIALITY ORGANICS PVT LTD",
"SPECIALITY PAPER & BOARDS PRIVATE LIMITED",
"SPECIALITY REINFORCED MATRIX PRIVATE LIMITED",
"SPECIALITY RESTAURANTS LIMITED",
"SPECIALITY SILICA PRIVATE LIMITED",
"SPECIALITY SINTERED PRODUCTS PRIVATE LIMITED",
"SPECIALITY URETHANES PRIVATE LIMITED",
"SPECIALITY VALUE LIGHTING & DESIGN PRIVATE LIMITED",
"SPECIALITY WOOD PACK PRIVATE LIMITED",
"SPECIALIZED PROCESS INNOVATION PRIVATE LIMITED",
"SPECIALLISE INSTRUMENTS MARKETING COMPANY PRIVATE LIMITED",
"SPECIALTY LOGISTICS PRIVATE LIMITED",
"SPECIALTY POLYFILMS INDIA PRIVATE LIMITED",
"SPECIALTY PRODUCTS AND SERVICES INDIA LLP",
"SPECIE FINANCE PRIVATE LIMITED",
"SPECIFIC COMMODITIES PRIVATE LIMITED",
"SPECIFIC CONSTRUCTION PRIVATE LIMITED",
"SPECIFIC ELECTRONICS WORLD PRIVATE LIMITED",
"SPECIFIC INFRAPROJECTS PRIVATE LIMITED",
"SPECIFIC PACKERS PRIVATE LIMITED",
"SPECIFIC WIRE PRIVATE LIMITED",
"SPECIFIED UNDERTAKING OF UTI",
"SPECIOCHEM PRODUCTS PRIVATE LIMITED",
"SPECKLES DEVELOPERS PRIVATE LIMITED",
"SPECKYFOX TECHNOLOGIES INDIA PRIVATE LIMITED",
"SPECMAC TECHNO PRIVATE LIMITED",
"SPECO INFRASTRUCTURE",
"SPECPICK ONLINE SERVICES PRIVATE LIMITED",
"SPECSMAKERS OPTICIANS PRIVATE LIMITED",
"SPECSMODE PRIVATE LIMITED",
"SPECT SYSTEMS INDIA PRIVATE LIMITED",
"SPECTA DECOR PRIVATE LIMITED",
"SPECTACLE ADVISORY SOLUTIONS PRIVATE LIMITED",
"SPECTACULAR BUSINESS CENTRE PRIVATE LIMITED",
"SPECTACULAR MMT DIGITAL PRIVATE LIMITED",
"SPECTACULAR REPROGRAPHICS PRIVATE LIMITED",
"SPECTACULAR RETAIL VENTURES LLP",
"SPECTAWORLD ENTERPRISES PRIVATE LIMITED",
"SPECTEC TECHNO PROJECTS PRIVATE LIMITED",
"SPECTEC VALVES & INSTRUMENTATIONS PRIVATE LIMITED",
"SPECTEVO TECHNOLOGIES PRIVATE LIMITED",
"SPECTOMS ENGINEERING PRIVATE LIMITED",
"SPECTRA & STAR CONVERGENCE LIMITED",
"SPECTRA ALLOYS PRIVATE LIMITED",
"SPECTRA BUSINESS SYSTEMS PRIVATE LIMITED",
"SPECTRA CAST PRIVATE LIMITED",
"SPECTRA COLOURTECH INDIA PRIVATE LIMITED",
"SPECTRA COMPUNET PRIVATE LIMITED",
"SPECTRA COMPUTECH PRIVATE LIMITED",
"SPECTRA CONNECTRONICS LLP",
"SPECTRA CONSTRUCTIONS AND INFRASTRUCTURE PRIVATE LIMITED",
"SPECTRA CONSTRUCTIONS PRIVATE. LIMITED.",
"SPECTRA CUISINES PRIVATE LIMITED",
"SPECTRA DYNAMICS LIMITED",
"SPECTRA ENERGY CORP",
"SPECTRA ENVIROTECH PRIVATE LIMITED",
"SPECTRA EYE-FOUNDATION PRIVATE LIMITED",
"SPECTRA FIRE SYSTEMS PRIVATE LIMITED",
"SPECTRA FOODS & BEVERAGES PRIVATE LIMITED",
"SPECTRA FOREX PRIVATE LIMITED",
"SPECTRA HOSPITAL SERVICES PRIVATE LIMITED",
"SPECTRA INDIA HOUSING PRIVATE LIMITED",
"SPECTRA INNOVATIONS INDIA PRIVATE LIMITED",
"SPECTRA INTERNATIONAL LIMITED",
"SPECTRA ISP NETWORKS PRIVATE LIMITED",
"SPECTRA LIFE SCIENCES PRIVATE LIMITED",
"SPECTRA LOGISTICS PRIVATE LIMITED",
"SPECTRA LUMINAIRES PRIVATE LIMITED",
"SPECTRA MANAGEMENT CONSULTANCY PRIVATE LIMITED",
"SPECTRA MEDICAL INDIA PRIVATE LIMITED",
"SPECTRA MEDITECH PRIVATE LIMITED",
"SPECTRA MEP PROJECTS AND SERVICES PRIVATE LIMITED",
"SPECTRA NET LIMITED",
"SPECTRA OUTSOURCE SOLUTION PRIVATE LIMITED",
"SPECTRA PAVERS PRIVATE LIMITED",
"SPECTRA PIPES PRIVATE. LIMITED.",
"SPECTRA PLAST INDIA PRIVATE LIMITED",
"SPECTRA PRODUCTS PRIVATE LIMITED",
"SPECTRA PROPERTIES PRIVATE LIMITED",
"SPECTRA PUNJ LLOYD LIMITED",
"SPECTRA SHARES AND SCRIPS PRIVATE LIMITED",
"SPECTRA SUPER ALLOYS LIMITED",
"SPECTRA TECHNOLOGIES INDIA PRIVATE LIMITED",
"SPECTRA TECHNOVISION INDIA PRIVATE LIMITED",
"SPECTRA TELEVENTURES PRIVATE LIMITED",
"SPECTRA THERAPEUTICS PRIVATE LIMITED",
"SPECTRAA EYE HOSPITAL PRIVATE LIMITED",
"SPECTRAA FACILITY SOLUTIONS PRIVATE LIMITED",
"SPECTRAA TECHNOLOGY SOLUTIONS LIMITED",
"SPECTRAA TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"SPECTRAFORCE TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"SPECTRALAB INSTRUMENTS PRIVATE LIMITED",
"SPECTRAMEDIX INDIA PRIVATE LIMITED",
"SPECTRAPACK AUTOMATION PRIVATE LIMITED",
"SPECTRASOFT TECHNOLOGIES PRIVATE LIMITED",
"SPECTRIS TECHNOLOGIES PRIVATE LIMITED",
"SPECTRO ANALYTICAL LABS PRIVATE LIMITED",
"SPECTRO CLOUD INDIA PRIVATE LIMITED",
"SPECTRO DUCTILE IRON PRIVATE LIMITED",
"SPECTRO PHOSCHEM LIMITED",
"SPECTRO RESEARCH LAB VENTURES PRIVATE LIMITED",
"SPECTRO SSA LABS PRIVATE LIMITED",
"SPECTROCHEM PRIVATE. LIMITED.",
"SPECTROGEN PHARMACHEM LIMITED",
"SPECTROMAX TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"SPECTRON ENGINEERS PRIVATE LIMITED",
"SPECTRON SAFETY SYSTEMS PRIVATE LIMITED",
"SPECTRONIC PLATING PRIVATE LIMITED",
"SPECTROVISION INSTRUMENTS PRIVATE LIMITED",
"SPECTRUM AERO PRIVATE LIMITED",
"SPECTRUM AGRI-TECH PRIVATE LIMITED",
"SPECTRUM ANTENNA AND AVIONICS SYSTEMS PRIVATE LIMITED",
"SPECTRUM AQUA PRIVATE LIMITED",
"SPECTRUM ARTCOMM PRIVATE LIMITED",
"SPECTRUM AUXI-CHEM PRIVATE LIMITED",
"SPECTRUM BIOCIDES INDIA PRIVATE LIMITED",
"SPECTRUM BOOKS PRIVATE LIMITED",
"SPECTRUM BROADCAST INFRASTRUCTURE SERVICES PRIVATE LIMITED",
"SPECTRUM BUSINESS SOLUTION LIMITED",
"SPECTRUM BUSINESS SOLUTIONS PRIVATE LTD",
"SPECTRUM CALLNET PRIVATE LIMITED",
"SPECTRUM CERAMICS PRIVATE LIMITED",
"SPECTRUM CLINICAL RESEARCH PRIVATE LIMITED",
"SPECTRUM COAL AND POWER LIMITED",
"SPECTRUM COMPLEX PRIVATE LIMITED SCPL",
"SPECTRUM CONCRETE PRIVATE LIMITED",
"SPECTRUM CONSULTANTS INDIA PRIVATE LIMITED",
"SPECTRUM CORPORATE SERVICES PRIVATE LIMITED",
"SPECTRUM CREATIONS PRIVATE LIMITED",
"SPECTRUM CUTTING SOLUTIONS PRIVATE LIMITED",
"SPECTRUM DIGITRONIC SYSTEMS PRIVATE LIMITED",
"SPECTRUM DYES AND CHEMICALS PRIVATE LIMITED",
"SPECTRUM ELECTRICAL INDUSTRIES LIMITED",
"SPECTRUM ELECTRICAL LIFE SOLUTIONS PRIVATE LIMITED",
"SPECTRUM ENGINEERING TECH PRIVATE LIMITED",
"SPECTRUM ETHERS PRIVATE LIMITED",
"SPECTRUM EVENTS PRIVATE LIMITED",
"SPECTRUM EYE WEAR PRIVATE LIMITED",
"SPECTRUM FOOD & SPICES PRIVATE LIMITED",
"SPECTRUM FOODS LIMITED",
"SPECTRUM FORMULATION PRIVATE LIMITED",
"SPECTRUM GLOBAL PROJECTS PRIVATE LIMITED",
"SPECTRUM GROUP INTERNATIONAL, INC.",
"SPECTRUM HOSPITAL",
"SPECTRUM IMAGING AND RADIOLOGY SOLUTIONS PRIVATE LIMITED",
"SPECTRUM INDUSTRIAL PROJECTS PRIVATE LIMITED",
"SPECTRUM INFOSOLUTIONS PRIVATE LIMITED",
"SPECTRUM INFOTECH PRIVATE LIMITED",
"SPECTRUM INFRA VENTURES PRIVATE LIMITED",
"SPECTRUM INFRASERVICES PRIVATE LIMITED",
"SPECTRUM INGREDIENTS PRIVATE LIMITED",
"SPECTRUM INNOVATIVE ENGINEERS PRIVATE LIMITED",
"SPECTRUM INNS AND MOTELS PRIVATE LIMITED",
"SPECTRUM INSURANCE DISTRIBUTION LIMITED",
"SPECTRUM INTERNATIONAL PRIVATE. LIMITED.",
"SPECTRUM INVESTMENT ADVISORS PRIVATE LIMITED",
"SPECTRUM JEWELMART PRIVATE LIMITED",
"SPECTRUM JOHNSON TILES PRIVATE LIMITED",
"SPECTRUM LIFE MEDICAL DEVICES PRIVATE LIMITED",
"SPECTRUM LIFE SCHOOL",
"SPECTRUM LIFE SCIENCES PRIVATE LIMITED",
"SPECTRUM LOGISTICS PRIVATE LIMITED",
"SPECTRUM MEDICAL INDUSTRIES PRIVATE LIMITED",
"SPECTRUM MEDICARE PRIVATE LIMITED",
"SPECTRUM MEDTECH PRIVATE LIMITED",
"SPECTRUM OFFSHORE & ONSHORE SERVICES PRIVATE LIMITED",
"SPECTRUM PETROMAC PRIVATE LIMITED",
"SPECTRUM PHARMATECH CONSULTANTS PRIVATE LIMITED",
"SPECTRUM PLANNING (INDIA) LIMITED.",
"SPECTRUM POLYMERS PVT LTD",
"SPECTRUM POWDER SMEARS PRIVATE LIMITED",
"SPECTRUM PRINTING PRESS PRIVATE LIMITED",
"SPECTRUM RADIODIAGNOSTICS (MUMBAI) PRIVATE LIMITED",
"SPECTRUM SAFETY SOLUTIONS PRIVATE LIMITED",
"SPECTRUM SCAN PRIVATE LIMITED",
"SPECTRUM SCIENTIFIC PRIVATE LIMITED",
"SPECTRUM SOFTTECH SOLUTIONS PRIVATE LIMITED",
"SPECTRUM SOLUTIONS AND TECHNOLOGIES PRIVATE LIMITED",
"SPECTRUM SPACETECHNICS PRIVATE LIMITED",
"SPECTRUM SUPPLYCHAIN SOLUTIONS PRIVATE LIMITED",
"SPECTRUM SURFACE SOLUTIONS INDIA PRIVATE LIMITED",
"SPECTRUM TECHLABS PRIVATE LIMITED",
"SPECTRUM TECHNO-CONSULTANTS PRIVATE LIMITED",
"SPECTRUM TECHVISION PRIVATE LIMITED",
"SPECTRUM TOOL ENGINEERS PRIVATE LIMITED",
"SPECTRUM TRIMPEX PVT.LTD.",
"SPECTRUM TYRES AND SERVICES INDIA PRIVATE LIMITED",
"SPECTRUM VENTURE INTERNATIONAL PRIVATE LIMITED",
"SPECTRUM VOYAGES PRIVATE LIMITED",
"SPECTRUM WASHING PRIVATE LIMITED",
"SPECTRUM WASTE SOLUTIONS PRIVATE LIMITED",
"SPECTRUM WEALTH MANAGEMENT PRIVATE LIMITED",
"SPECTRUM WEIGHPACK PRIVATE LIMITED",
"SPECTRUM WINDOWS AND BEYOND PRIVATE LIMITED",
"SPECTRUM WIRELESS AND TECHNOLOGIES LIMITED",
"SPECTRUM7 TECHNOLOGIES PRIVATE LIMITED",
"SPECTRUMSTAB INDIA PRIVATE LIMITED",
"SPECTRUS INFORMATICS PRIVATE LIMITED",
"SPECTRUS SUSTAINABLE SOLUTIONS PRIVATE LIMITED",
"SPECTS WORLD PRIVATE LIMITED",
"SPECULAR BUILDMART PRIVATE LIMITED",
"SPECULAR GRAPHICS PRIVATE LIMITED",
"SPECULUM PLAST PRIVATE LIMITED",
"SPECVIN TECHNOLOGIES PRIVATE LIMITED",
"SPEECH 2 TEXT MEDICAL SOLUTIONS INDIA PRIVATE LIMITED",
"SPEECH AND HEARING CARE PRIVATE LIMITED",
"SPEECH SOFT SOLUTIONS PRIVATE LIMITED",
"SPEED 4 PREFAB SOLUTIONS PRIVATE LIMITED",
"SPEED AIR LOGISTIC PRIVATE LIMITED",
"SPEED AUTO SERVICE PRIVATE LIMITED",
"SPEED AUTOMOTIVE PRIVATE LIMITED",
"SPEED BIKES PRIVATE LIMITED",
"SPEED CARGO MOVERS PVT LTD",
"SPEED CARRIERS (BOMBAY) PRIVATE LIMITED",
"SPEED CATERING SERVICES PRIVATE LIMITED",
"SPEED DESIGNER FOOTWEAR PRIVATE LIMITED",
"SPEED ENGINEERING SOLUTIONS PRIVATE LIMITED",
"SPEED ENTERPRISE",
"SPEED E-SOLUTIONS INDIA PRIVATE LIMITED",
"SPEED FINANCIAL SOLUTIONS",
"SPEED INFRASTRUCTURE INDIA PRIVATE LIMITED",
"SPEED INTERNATIONAL (INDIA) PRIAVTE LIMITED",
"SPEED LINE LOGISTICS AND CHARTERING PRIVATE LIMITED",
"SPEED MONEY TRANSFER SERVICE PRIVATE LIMITED",
"SPEED MOTOCORP PRIVATE LIMITED",
"SPEED MOTORS PRIVATE LIMITED",
"SPEED MOVERS LOGISTICS PRIVATE LIMITED",
"SPEED PROJECTS PRIVATE LIMITED",
"SPEED RECORDS ENTERTAINMENT PRIVATE LIMITED",
"SPEED ROADWAYS PRIVATE LIMITED",
"SPEED TEAM INFRA PRIVATE LIMITED",
"SPEED TEAM WIND TECH PRIVATE LIMITED",
"SPEED VIDYUT VENTURE PRIVATE LIMITED",
"SPEED WAY MACHINES PRIVATE LIMITED",
"SPEED WINGS LOGISTICES SOLUTIONS PRIVATE LIMITED",
"SPEED4NET TECHNOLOGIES PRIVATE LIMITED",
"SPEEDAGE LOGISTICS CORPORATION PRIVATE LIMITED",
"SPEEDAGE TRADE LIMITED",
"SPEEDAIR FREIGHT SOLUTIONS PRIVATE LIMITED",
"SPEED-A-WAY PRIVATE LIMITED",
"SPEEDBIRD TRAVELS PVT LTD",
"SPEEDCOM INTERNET SERVICES PRIVATE LIMITED",
"SPEEDCRAFTS INFRATECH PRIVATE LIMITED",
"SPEEDCRAFTS LIMITED",
"SPEEDCRAFTS PRIVATE LIMITED",
"SPEEDEX FREIGHT SYSTEMS PRIVATE LIMITED",
"SPEEDEX OVERSEAS PRIVATE LIMITED",
"SPEEDEX TRANSCARRIERS PRIVATE LIMITED",
"SPEEDFAM INDIA PRIVATE LIMITED",
"SPEED-FORCE VENTURES PRIVATE LIMITED",
"SPEEDFROST SERVICES PRIVATE LIMITED",
"SPEEDGAZE TECHNOLOGIES SOLUTIONS PRIVATE LIMITED",
"SPEEDINGO INDIA PRIVATE LIMITED",
"SPEEDIO MOVE PRIVATE LIMITED",
"SPEEDKING COMMUNICATION SERVICES PRIVATE LIMITED",
"SPEEDKING PHARMA LIMITED",
"SPEEDLAND REAL ESTATE PRIVATE LIMITED",
"SPEEDLIGHT CABLES PRIVATE LIMITED",
"SPEEDLINE SPINNERS INDIA PRIVATE LIMITED",
"SPEEDMACHINES INDIA PRIVATE LIMITED",
"SPEEDMINE LOGISTICS PRIVATE LIMITED",
"SPEEDO TELECOM SERVICES PRIVATE LIMITED",
"SPEED-O-CONTROLS PRIVATE LIMITED",
"SPEEDOFER COMPONENTS PRIVATE LIMITED",
"SPEEDOGISTIC PROJECTS PRIVATE LIMITED",
"SPEEDOMAT ENGINEERS PVT LTD",
"SPEEDON NETWORK LIMITED",
"SPEEDSAFE AUTO PRIVATE LIMITED",
"SPEEDSTEP SOFTWARE SOLUTIONS INDIA PRIVATE LIMITED",
"SPEEDSTER TRANS SOLUTIONS PRIVATE LIMITED",
"SPEEDTEK ENGINEERS PRIVATE LIMITED",
"SPEEDWAY INDUSTRIES PRIVATE LIMITED",
"SPEEDWAYS FLEET & TRAVEL MANAGEMENT PRIVATE LIMITED",
"SPEEDWAYS LOGISTICS PRIVATE LIMITED",
"SPEEDWAYS RENT-A-CAR PRIVATE LIMITED",
"SPEEDWAYS ROADLINKS PRIVATE LIMITED",
"SPEEDWAYS RUBBER PRIVATE LIMITED",
"SPEEDWAYS TYRE LIMITED",
"SPEEDWELL ABRASIVE PRIVATE LIMITED",
"SPEEDWELL IT SOLUTIONS PRIVATE LIMITED",
"SPEEDWELL TECHNOLOGIES PRIVATE LIMITED",
"SPEEDX HOSPITALITY PRIVATE LIMITED",
"SPEEDY BUSINESS MACHINES PRIVATE LIMITED",
"SPEEDY MULTIMODES LIMITED",
"SPEEGO VEHICLES CO PRIVATE LIMITED",
"SPEEL FINANCE COMPANY PRIVATE LIMITED",
"SPEEVO INDUSTRIES LLP",
"SPEICHER CONSULTING SERVICES PRIVATE LIMITED",
"SPEKTRA SYSTEMS",
"SPEKTRUM FLUID POWER PRIVATE LIMITED",
"SPEL SEMICONDUCTOR LIMITED",
"SPELL BOUND AUDITS PRIVATE LIMITED",
"SPELL FASHIONS PRIVATE LIMITED",
"SPELL FOOD CHEMICALS PRIVATE LIMITED",
"SPELL MEDIA PRIVATE LIMITED",
"SPELL ORGANICS LIMITED",
"SPELL SECURITY PRIVATE LIMITED",
"SPELL SKILL SERVICES PRIVATE LIMITED",
"SPELLBEE INTERNATIONAL PRIVATE LIMITED",
"SPELLBOUND VISUAL EFFECTS & ANIMATION PRIVATE LIMITED",
"SPELLENX INNOVATIONS PRIVATE LIMITED",
"SPEN FORMULATIONS PVT LTD",
"SPENCE AND CO",
"SPENCER AND COMPANY LIMITED",
"SPENCER INDIA TECHNOLOGIES PRIVATE LIMITED",
"SPENCER N HILLS CONSULTING PRIVATE LIMITED",
"SPENCER PRINTS PRIVATE LIMITED",
"SPENCER STUARTINDIA PVT LTD",
"SPENCERS INTERNATIONAL",
"SPENCER'S RETAIL LIMITED",
"SPENCHEM PHARMACEUTICALS PRIVATE LIMITED",
"SPENCURE BIOTECH PRIVATE LIMITED",
"SPENDFLO INDIA PRIVATE LIMITED",
"SPENLO BUSINESS PVT LTD",
"SPENNY FINTECH PRIVATE LIMITED",
"SPENTA AGRO INDUSTRIES PPRIVATE LIMITED",
"SPENTA CORPORATE SERVICES PRIVATE LIMITED",
"SPENTA DIGITAL MEDIA PRIVATE LIMITED",
"SPENTA ENCLAVE PRIVATE LIMITED",
"SPENTA ENTERPRISES PRIVATE LIMITED",
"SPENTA INTERNATIONAL LIMITED",
"SPENTA MULTIMEDIA PRIVATE LIMITED",
"SPENTA REALTY PRIVATE LIMITED",
"SPENTA SHIPPING AND LOGISTICS PRIVATE LIMITED",
"SPENTA SUN CITY PRIVATE LIMITED",
"SPENTAGON CERAMIC PRIVATE LIMITED",
"SPENTO FLOOR TILES PRIVATE LIMITED",
"SPENZEN CERAMIC PRIVATE LIMITED",
"SPENZZER CERAMIC PRIVATE LIMITED",
"SPENZZER CRAFT PRIVATE LIMITED",
"SPEQTO TECHNOLOGIES PRIVATE LIMITED",
"SPERA DIGITAL CONSULTING SERVICES PRIVATE LIMITED",
"SPERA INFRA CONSULTANTS PRIVATE LIMITED",
"SPERA MANAGEMENT PRIVATE LIMITED",
"SPERANZA TILES PRIVATE LIMITED",
"SPERENE COMPOUNDING PRIVATE LIMITED",
"SPERICORN TECHNOLOGY PRIVATE LIMITED",
"SPERM PROCESSOR PRIVATE LIMITED",
"SPERO FOUNDATIONS PRIVATE LIMITED",
"SPERO HEALTHCARE INNOVATIONS PRIVATE LIMITED",
"SPERO PROPERTIES AND SERVICES PRIVATE LIMITED",
"SPEROGENX BIOSCIENCES PRIVATE LIMITED",
"SPERONI INDIA PRIVATE LIMITED",
"SPERRY ENGINEERING PRIVATE LIMITED",
"SPERRY INTERNATIONAL PRIVATE. LIMITED. SIPL",
"SPERRY PLAST LIMTED",
"SPETTRO RESOURCES PRIVATE LIMITED",
"SPETTRO VISION PRIVATE LIMITED",
"SPEXTRA MULTIBIZ PRIVATE LIMITED",
"SPEY BOTTLERS PRIVATE LIMITED",
"SPEY MATTRESSES PRIVATE LIMITED",
"SPEY MEDICAL PRIVATE LIMITED",
"SPEYSIDE CORPORATE RELATIONS PRIVATE LIMITED",
"SPFL SECURITIES LIMITED",
"SPG AUTO COMPONENTS PRIVATE LIMITED",
"SPG CORPORATION PRIVATE LIMITED",
"SPG DECOTRADE PRIVATE LIMITED",
"SPG FACILITY MANAGEMENT PRIVATE LIMITED",
"SPG GLASS FIBRE PRIVATE LIMITED",
"SPG INDIA PRIVATE LIMITED",
"SPG INFOTECH LIMITED",
"SPG INFRACON PRIVATE LIMITED",
"SPG INFRAPROJECTS PRIVATE. LIMITED.",
"SPG METALS LIMITED",
"SPG SALES PRIVATE LIMITED",
"SPG SHIPPING PRIVATE LIMITED",
"SPH AGENCIES PRIVATE LIMITED",
"SPHAERA PHARMA PRIVATE LIMITED",
"SPHAIRA TRANSPORT PRIVATE LIMITED",
"SPHATA SYSTEMS PRIVATE LIMITED",
"SPHATIKA FACILITY SERVICE INDIA PRIVATE LIMITED",
"SPHEAR SPEECH & HEARING CLINICS PRIVATE LIMITED",
"SPHECON INFRA PROJECT PRIVATE LIMITED",
"SPHEERO DEVELOPERS LIMITED",
"SPHERA INDIA PRIVATE LIMITED",
"SPHERE COM SERVICES PRIVATE LIMITED",
"SPHERE ENGINEERS PRIVATE LIMITED",
"SPHERE EQUIPMENTS PRIVATE LIMITED",
"SPHERE HOME APPLIANCES PRIVATE LIMITED",
"SPHERE INFO SOLUTIONS PRIVATE LIMITED",
"SPHERE RAYS TECHNOLABS PRIVATE LIMITED",
"SPHERE SOFT SOLUTIONS INDIA PRIVATE LIMITED",
"SPHERE THERMAL SYSTEMS PRIVATE LIMITED",
"SPHERE TRAVELMEDIA & EXHIBITIONS PRIVATE LIMITED",
"SPHEREGEN SOFTWARE INDIA PRIVATE LIMITED",
"SPHEREGEN TECHNOLOGIES PRIVATE LIMITED",
"SPHEREORIGINS MULTIVISION PRIVATE LIMITED",
"SPHERETECH PACKAGING INDIA PRIVATE LIMITED",
"SPHERIC INNOVATION PRIVATE LIMITED",
"SPHERISOL TECHNOLOGY PRIVATE LIMITED",
"SPHERULE FOUNDATION",
"SPHH PEACEFUL ESCAPE PRIVATE LIMITED",
"SPHINAX CHEMICAL INDUSTRIES PRIVATE LIMITED",
"SPHINX ADONIS EVENTS PRIVATE LIMITED",
"SPHINX REALTY PRIVATE LIMITED",
"SPHINX SOLUTIONS PRIVATE LIMITED",
"SPHINX WORLDBIZ LIMITED",
"SPHIRO INFRATECH PRIVATE LIMITED",
"SPHOORTHI PRINTERS PRIVATE LIMITED",
"SPHOORTHY DEGREE PG COLLEGE",
"SPHOORTHY ENGINEERING COLLEGE",
"SPHOORTHY PROJECTS PRIVATE LIMITED",
"SPHOORTI MACHINE TOOLS PRIVATE LIMITED",
"SPHOTA BUSINESS SOLUTIONS",
"SPHURTHY PUBLICATIONS PRIVATE LIMITED",
"SPI AUTO INDIA PRIVATE LIMITED",
"SPI CINEMAS PRIVATE LIMITED",
"SPI CREATION PRIVATE LIMITED",
"SPI ENGINEERS PVT LTD",
"SPI GLOBAL TECHNOLOGIES INDIA PRIVATE LIMITED",
"SPI INDUSTRIES PRIVATE LIMITED",
"SPI MUSIC PRIVATE LIMITED",
"SPI PHARMA INC INDIA BRANCH OFFICE",
"SPI PLASTICS PRIVATE LIMITED",
"SPI PROPERTIES PRIVATE LIMITED",
"SPI SPECIALTIES PHARMA PRIVATE LIMITED",
"SPI TECHNOLOGIES INDIA PRIVATE LIMITED",
"SPIC AND SPAN LIFE MANAGEMENT PRIVATE LIMITED",
"SPIC FASHIONS PRIVATE LIMITED",
"SPIC N SPAN HOUSEKEEPERS PRIVATE LIMITED",
"SPICA ASSEMBLIES LLP",
"SPICA ELASTIC PRIVATE LIMITED",
"SPICA HYDRAULICS PRIVATE LIMITED",
"SPICA MEDICAL EQUIPMENTS PRIVATE LIMITED",
"SPICA METFAB SOLUTIONS INDIA PRIVATE LIMITED",
"SPICA MODULAR SOLUTIONS LIMITED",
"SPICA PROJECTS & INFRASTRUCTURES PRIVATE LIMITED",
"SPICA TECHNITEX PRIVATE LIMITED",
"SPICAWORKS INDIA PRIVATE LIMITED",
"SPICE CERAMIC PRIVATE LIMITED",
"SPICE CONNECT PRIVATE LIMITED",
"SPICE ENERGY PRIVATE LIMITED",
"SPICE ISLANDS APPARELS LIMITED",
"SPICE LABS PRIVATE LIMITED",
"SPICE LOGISTICS PRIVATE LIMITED",
"SPICE MEDIA PRIVATE LIMITED",
"SPICE MOBILES LIMITED",
"SPICE MONEY LIMITED",
"SPICE NATURALE EXIM PRIVATE LIMITED",
"SPICE OF LIFE HOTELS PRIVATE LIMITED",
"SPICE PACKAGING PRIVATE LIMITED",
"SPICE SMART SOLUTIONS LIMITED",
"SPICEBLUE ONLINE SERVICES PRIVATE LIMITED",
"SPICEBULLS INVESTMENTS LIMITED",
"SPICEDELIGHT PRIVATE LIMITED",
"SPICEFREIGHT PRIVATE LIMITED",
"SPICERACK KITCHENS PRIVATE LIMITED",
"SPICERETREAT HOSPITALITY SERVICES PRIVATE LIMITED",
"SPICES (INDIA) LTD",
"SPICESOLOGY PRIVATE LIMITED",
"SPICETECH IT SOLUTIONS PRIVATE LIMITED",
"SPICETREE DESIGN AGENCY PRIVATE LIMITED",
"SPICEWORKS IT SOLUTIONS INDIA PRIVATE LIMITED",
"SPICK MAINTENANCE SERVICE",
"SPICO PRINTING INKS PRIVATE LIMITED",
"SPICTEX COTON MILLS PRIVATE LIMITED",
"SPICY ENTERTAINMENT AND MEDIA LIMITED",
"SPIDER COMMOTRADE PRIVATE LIMITED.",
"SPIDER FASHIONS PRIVATE LIMITED",
"SPIDER METAL PRODUCTS PRIVATE LIMITED",
"SPIDER PRINTS PRIVATE LIMITED",
"SPIDER SOFTWARE PRIVATE LIMITED",
"SPIDER TECHNO SOFT PRIVATE LIMITED",
"SPIDERFOCUS SOLUTIONS",
"SPIDERLINK NETWORKS PRIVATE LIMITED",
"SPIDERLINK TECHNO PRIVATE LIMITED",
"SPIDERORB PRIVATE LIMITED",
"SPIDERSWEB NETWORK SOLUTIONS PRIVATE LIMITED",
"SPIDIGO LOGISTICS PRIVATE LIMITED",
"SPIDIGO NET PRIVATE LIMITED",
"SPIFFY SPOOLS INDIA PRIVATE LIMITED",
"SPIFFY TECHNOLOGIES PRIVATE LIMITED",
"SPIG COOLING TOWERS INDIA P LIMITED",
"SPIGOT SOFTWARE PRIVATE LIMITED",
"SPIKA DIGITAL LABS PRIVATE LIMITED",
"SPIKE ADVERTISING PRIVATE LIMITED",
"SPIKE AEROTEK PRIVATE LIMITED",
"SPIKE MEDIA PRIVATE LIMITED",
"SPIKEWELL INDIA PRIVATE LIMITED",
"SPIKRA PRIVATE LIMITED",
"SPIKTEL TECHNOLOGIES PRIVATE LIMITED",
"SPILLBAN CONVEYOR EQUIPMENTS PRIVATE LIMITED",
"SPIME INDIA TECHNOLOGIES PRIVATE LIMITED",
"SPIME TECHNOLOGY PRIVATE LIMITED",
"SPIN ANALYTICS AND STRATEGY OPC PRIVATE LIMITED",
"SPIN GAMES INDIA PRIVATE LIMITED",
"SPIN INVESTMENT INDIA LIMITED",
"SPIN ON WEB PRIVATE LIMITED",
"SPIN PACKAGING LIMITED.",
"SPIN2WEAVE APPARELS PRIVATE LIMITED",
"SPINACH TECHNOLOGIES INDIA PRIVATE LIMITED",
"SPINAROO COMMERCIAL PRIVATE LIMITED",
"SPINART SPORTS PRIVATE LIMITED",
"SPINCO ANALYTICA PRIVATE LIMITED",
"SPINCO BIOTECH PRIVATE LIMITED",
"SPINCO INDIA LIMITED",
"SPINCOTECH PRIVATE LIMITED",
"SPINCOTECH SYSTEMS LLP",
"SPIND CONSULTANCY SERVICES PRIVATE LIMITED",
"SPINDLE INNOVATION LABS PRIVATE LIMITED",
"SPINDRAW FIBRES PRIVATE LIMITED",
"SPINE ADVISORY PRIVATE LIMITED",
"SPINE ARTHROSCOPIC AND JOINT REPLACEMENT CENTRE PRIVATE. LIMITED.",
"SPINE CLINIC AHMEDABAD PRIVATE LIMITED",
"SPINE HEALTH CARE PRIVATE LIMITED",
"SPINE INFRATECH PRIVATE LIMITED",
"SPINE SOFTWARE SYSTEMS PRIVATE LIMITED",
"SPINE TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"SPINEBIZ SERVICES PRIVATE LIMITED",
"SPINECURE HOME SOLUTIONS PRIVATE LIMITED",
"SPINEL ENERGY & INFRASTRUCTURE LIMITED",
"SPINEMAT INDUSTRIES PRIVATE LIMITED",
"SPINEOR WEBSERVICES PRIVATE LIMITED",
"SPINEURO MEDITECH PRIVATE LIMITED",
"SPINFOTRONICS PRIVATE LIMITED",
"SPINGO FOODS PRIVATE LIMITED",
"SPINIRCLE INDIA PRIVATE LIMITED",
"SPINKS INDIA PRIVATE LIMITED",
"SPINKS SOFTECH PRIVATE LIMITED",
"SPINMET ENGINEERS PRIVATE LIMITED",
"SPINN DECOR PRIVATE LIMITED",
"SPINNAKER CORPORATE ADVISORS PRIVATE LIMITED",
"SPINNER EXTRUSIONS PRIVATE LIMITED",
"SPINNER PLASTIC INDUSTRIES LIMITED",
"SPINNERET IMPEX PRIVATE LIMITED",
"SPINNERZ GLOBE PRIVATE LIMITED",
"SPINNEX INDIA PRIVATE LIMITED",
"SPINNING KING (INDIA) LIMITED",
"SPINNING PLATES HOSPITALITY PRIVATE LIMITED",
"SPINNMAX TYRES PRIVATE LIMITED",
"SPINO PAPER PRODUCTS PRIVATE LIMITED",
"SPINO TECHNOLOGIES PRIVATE LIMITED",
"SPINOFF TECHNOPARK PRIVATE LIMITED",
"SPINORA TILES PRIVATE LIMITED",
"SPINOS LIFE SCIENCE AND RESEARCH PRIVATE LIMITED",
"SPINSCI TECHNOLOGIES PRIVATE LIMITED",
"SPINTEC ENGINEERING PRIVATE LIMITED",
"SPIN-TECH FITTINGS INDIA PRIVATE LIMITED",
"SPINTECH TUBES PRIVATE LIMITED",
"SPINTEX IMPEX PRIVATE LIMITED",
"SPINTEX JUTE INDIA PRIVATE LIMITED",
"SPINTEX WOOLLEN MILLS",
"SPINVISION INDIA LLP",
"SPIRAL IMPEX PRIVATE LIMITED",
"SPIRAL PRODUCT DESIGN PRIVATE LIMITED",
"SPIRAL TECHNOLABS PRIVATE LIMITED",
"SPIRAL TOOLS PVT LTD",
"SPIRAL TUBES PVT LTD",
"SPIRALLING HEALTHCARE PRIVATE LIMITED",
"SPIRANT COMMUNICATION PRIVATE LIMITED",
"SPIRARE ENERGY PRIVATE LIMITED",
"SPIRAX-SARCO INDIA PRIVATE LIMITED",
"SPIRE BUILDCON PRIVATE LIMITED",
"SPIRE CERA FRIT PRIVATE LIMITED",
"SPIRE LOGISTICS INDIA PRIVATE LIMITED",
"SPIRE PREMISES PRIVATE LIMITED",
"SPIRE PROJECTS PRIVATE LIMITED",
"SPIRE TECHNOLOGIES AND SOLUTIONS PRIVATE LIMITED",
"SPIRE TECHPARK PRIVATE LIMITED",
"SPIRENET DIGITAL COMMUNICATIONS PRIVATE LIMITED",
"SPIRENT COMMUNICATIONS INDIA PRIVATE LIMITED",
"SPIRIE MARKETING SOLUTIONS PRIVATE LIMITED",
"SPIRIT GLOBAL CONSTRUCTIONS PRIVATE LIMITED",
"SPIRIT INFRASTRUCTURE PRIVATE LIMITED",
"SPIRIT OF INDIA EXPOTEX PRIVATE LIMITED",
"SPIRITED AUTO CARS I LIMITED",
"SPIRITED MOTOR VEHICLES LIMITED",
"SPIRITIUS CONSULTING PRIVATE LIMITED",
"SPIRITUAL ESSENTIALS PRIVATE LIMITED",
"SPIRITUAL LUXURY LIVING PRIVATE LIMITED",
"SPIRITUAL MARKETING PRIVATE LIMITED",
"SPIRITUS PAYMENTS PRIVATE LIMITED",
"SPIRO HOSES INDIA PRIVATE LIMITED",
"SPIRO LIFECARE PRIVATE LIMITED",
"SPIRO PACK PVT LTD",
"SPIRO SYSTEM PRIVATE LIMITED",
"SPIROTECH HEAT EXCHANGERS PRIVATE LIMITED",
"SPIROWIND MACHINES PRIVATE LIMITED",
"SPIRY ENERGY PRIVATE LIMITED",
"SPITZEN ANALYTIC INSTRUMENTS PRIVATE LIMITED",
"SPITZENMASCHINENBAU PRIVATE LIMITED",
"SPJ CARGO PRIVATE LIMITED",
"SPJ HOSPITALITY PRIVATE LIMITED",
"SPJ INFRACON LIMITED",
"SPJ ISPATS (INDIA) PRIVATE LIMITED",
"SPJ ONCO CARE PRIVATE LIMITED",
"SPK POWER INFRA PRIVATE LIMITED",
"SPL AGRO PRODUCTS PRIVATE LIMITED",
"SPL ALLOYS & MINERALS PRIVATE LIMITED",
"SPL DIST SOCIAL WELFARE OFFICER AURANGABAD",
"SPL ESTATES PRIVATE LIMITED",
"SPL FINANCE LIMITED",
"SPL HEALTHCARE INDIA PRIVATE LIMITED",
"SPL INDUSTRIES LIMITED",
"SPL INFO PATHWAY PRIVATE LIMITED",
"SPL INFRASTRUCTURE PRIVATE LIMITED",
"SPL LIMITED",
"SPL MOTORS PRIVATE LIMITED",
"SPL PLAST PRIVATE LIMITED",
"SPL REALTORS PRIVATE LIMITED",
"SPL STEEL PROCESSORS PRIVATE LIMITED",
"SPL TECHNOLOGIES PRIVATE LIMITED",
"SPL TOWERS PRIVATE LIMITED",
"SPLAR MACHINERY PRIVATE LIMITED",
"SPLASH BUSINESS INTELLIGENCE PRIVATE LIMITED",
"SPLASH DESIGNERS PRIVATE LIMITED",
"SPLASH ENGINEERING PRIVATE LIMITED",
"SPLASH EQUIPMENTS AND SERVICES (INDIA) PRIVATE LIMITED",
"SPLASH FURNISHING PRIVATE LIMITED",
"SPLASH POLYMERS PRIVATE LIMITED",
"SPLASH POWER PRIVATE LIMITED",
"SPLASHGAIN TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"SPLAT MEDIA PRIVATE LIMITED",
"SPLENDED TRADING COMPANY PVT LTD",
"SPLENDEUR PROJECTS PRIVATE LIMITED",
"SPLENDID AD-VISION INDIA PRIVATE LIMITED",
"SPLENDID FACILITY MANAGEMENT INDIA PRIVATE LIMITED",
"SPLENDID LOGISTICS SOLUTIONS PRIVATE LIMITED",
"SPLENDID MOTORS PRIVATE LIMITED",
"SPLENDID SUITES & SPA PRIVATE LIMITED",
"SPLENDOR BUILDWELL PRIVATE LIMITED",
"SPLENDOR FITNESS PRIVATE LIMITED",
"SPLENDOR LANDBASE LIMITED",
"SPLENDOR METACHEM PRIVATE LIMITED",
"SPLENDOR VINIMAY PRIVATE LIMITED",
"SPLENDORNET TECHNOLOGIES PRIVATE LIMITED",
"SPLENDOUR GOLD COLLECTIONS LLP",
"SPLENDOUR HOLIDAYS PRIVATE LIMITED",
"SPLENTA SYSTEMS PRIVATE LIMITED",
"SPLENZ PHARMACEUTICALS PRIVATE LIMITED",
"SPLENZO POLYFAB PRIVATE LIMITED",
"SPLICE GLOBAL SERVICES PRIVATE LIMITED",
"SPLICE LAMINATES PRIVATE LIMITED",
"SPLINE GUAGES AND TOOLS PRIVATE LIMITED",
"SPLISYS IT CONSULTING PRIVATE LIMITED",
"SPLS LIMITED",
"SPLUNK SERVICES INDIA PRIVATE LIMITED",
"SPLUS MEDIA LIMITED",
"SPM AUTOCOMP SYSTEMS PRIVATE LIMITED",
"SPM BRANDS FASHION PRIVATE LIMITED",
"SPM CAPITAL ADVISERS PRIVATE LIMITED",
"SPM CAREERS PRIVATE LIMITED",
"SPM ENERGY PRIVATE. LIMITED.",
"SPM ENGMECH INDIA) PRIVATE LIMITED",
"SPM ENTERPRISE COMMUNICATIONS PRIVATE LIMITED",
"SPM EXTRUSION PRIVATE LIMITED",
"SPM INDIA LTD",
"SPM INSTRUMENT INDIA PRIVATE LIMITED",
"SPM LOGISTICS PRIVATE LIMITED",
"SPM MARBLES PRIVATE LIMITED",
"SPM MEDICARE PRIVATE LIMITED",
"SPM MULTIPACK PRIVATE LIMITED",
"SPM RECYCLING PRIVATE LIMITED",
"SPM TECHSOLUTIONS PRIVATE LIMITED",
"SPM TRADECON INDIA PRIVATE LIMITED",
"SPM WIRES AND CABLES PRIVATE LIMITED",
"SPMESH HOUSE PRIVATE LIMITED",
"SPMG STEELS PRIVATE LIMITED",
"SPML ENERGY LIMITED",
"SPML INFRA LIMITED.",
"SPML INFRASTRUCTURE LIMITED",
"SPML LIMITED",
"SPMLIL-AMRUTHA CONSTRUCTIONS PRIVATE LIMITED",
"SPMM HEALTH CARE SERVICES PRIVATE LIMITED",
"SPN GOLD & PRECIOUS METALS (INDIA) PRIVATE LIMITED",
"SPN GOLD (INDIA) PRIVATE LIMITED",
"SPN HOTELS PRIVATE LIMITED",
"SPN POWER EXIM PRIVATE LIMITED",
"SPN RENEWABLE ENERGIES PRIVATE LIMITED",
"SPNJIT ENGINEERING SOLUTIONS PRIVATE LIMITED",
"SP-NMJ PROJECT PRIVATE LIMITED",
"SPNP PAPER AND PACK PRIVATE LIMITED",
"SPNZ TECHNOLOGIES PRIVATE LIMITED",
"SPOCTECH GREEN VENTURES PRIVATE LIMITED",
"SPOCTO SOLUTIONS PRIVATE LIMITED",
"SPOL INNOVATIONS PRIVATE LIMITED",
"SPOLO CERAMIC PRIVATE LIMITED",
"SPOMAG ONLINE PRIVATE LIMITED",
"SPONGE ENTERPRISES PRIVATE LIMITED",
"SPONGE SALES INDIA PRIVATE LIMITED",
"SPONGE UDYOG PRIVATE LIMITED",
"SPONSIFYME TECHNOLOGIES PRIVATE LIMITED",
"SPONTAK SUPPLIES PRIVATE LIMITED",
"SPONTANE TECHNOLOGIES PRIVATE LIMITED",
"SPONTANEOUS COMMUNICATIONS PRIVATE LIMITED",
"SPONTEY COMPUTER SYSTEMS PRIVATE LIMITED",
"SPOOKFISH INNOVATIONS PRIVATE LIMITED",
"SPOONER INDUSTRIES PRIVATE LIMITED",
"SPOORS TECHNOLOGY SOLUTIONS INDIA PRIVATE LIMITED",
"SPOORTHI COMMUNICATIONS PRIVATE LIMITED",
"SPOORTHI HR SOLUTIONS PRIVATE LIMITED",
"SPOORTHI LABELING SOLUTIONS PRIVATE LIMITED",
"SPOORTHY CONSULTANCY AND IT SOLUTIONS PRIVATE LIMITED",
"SPOORTHY INTEGRATED SOLUTIONS (I) PRIVATE LIMITED",
"SPOORTHY METAL TECHNOLOGIES PRIVATE LIMITED",
"SPORE INVESTMENT MANAGEMENT (INDIA) PRIVATE LIMITED",
"SPORFY INDIA PRIVATE LIMITED",
"SPORT DEVELOPMENT AUTHORITY OF TAMILNADU",
"SPORT FOCUS INVESTMENTS PRIVATE LIMITED",
"SPORTELL INDIA PRIVATE LIMITED",
"SPORTIFF INDIA PRIVATE LIMITED",
"SPORTIFY SPORTS EDUCATION AND MANAGEMENT SERVICES PRIVATE LIMITED",
"SPORTINA EXIM PRIVATE LIMITED",
"SPORTING AND OUTDOOR SOLUTIONS PRIVATE LIMITED",
"SPORTING PASTIME INDIA LIMITED",
"SPORTING SYNDICATE INTERNATIONAL PRIVATE LIMITED",
"SPORTING SYNDICATE PRIVATE LIMITED",
"SPORTIVA LIFESTYLE PRIVATE LIMITED",
"SPORTKING INDIA LIMITED",
"SPORTS AND LEISURE APPAREL LIMITED",
"SPORTS AND YOUTH WELFARE DEPARTMENT SPORTS",
"SPORTS AUTHORITY OF INDIA",
"SPORTS BIOTECH NUTRITION PRIVATE LIMITED",
"SPORTS DEPARTMENT CHANDIGARH",
"SPORTS FACILITIES CO PRIVATE LIMITED",
"SPORTS FOR LIFE EDUCATION PRIVATE LIMITED",
"SPORTS FUEL DISTRIBUTION PRIVATE LIMITED",
"SPORTS GURUKUL LLP",
"SPORTS INFRATECH PRIVATE LIMITED",
"SPORTS LIFESTYLE PRIVATE LIMITED.",
"SPORTS MEDIA PRIVATE LIMITED",
"SPORTS SPECIALISTS PRIVATE LIMITED",
"SPORTS SQUARE INDIA PRIVATE LIMITED",
"SPORTS SYNDICATE (INDIA) PRIVATE LIMITED",
"SPORTSKINGDOM INDIA PRIVATE LIMITED",
"SPORTSLAND OVERSEAS PRIVATE LIMITED",
"SPORTSMECHANICS INDIA PRIVATE LIMITED",
"SPORTSMED MUMBAI PRIVATE LIMITED",
"SPORTSNEST RETAIL INDIA PRIVATE LIMITED",
"SPORTY SOLUTIONZ PRIVATE LIMITED",
"SPORTZ & LIVE ENTERTAINMENT PRIVATE LIMITED",
"SPORTZ ARENA EQUIPMENTS PRIVATE LIMITED",
"SPORTZVILLAGE FOUNDATION",
"SPOT AD-MEDIA PRIVATE LIMITED",
"SPOT LABS PRIVATE LIMITED",
"SPOT MANPOWER SERVICES PRIVATE LIMITED",
"SPOTBOY TRACOM PVT. LTD.",
"SPOTCHECK HEALTH AND WELLNESS SERVICES PRIVATE LIMITED",
"SPOTLIGHT ENTERPRISE PRIVATE LIMITED",
"SPOTLIGHT FINANCE & CONSULTANCY PVT LTD",
"SPOTLIGHT VANIJYA LTD",
"SPOTLINE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"SPOTNANA TECHNOLOGY PRIVATE LIMITED",
"SPOTON COATINGS PRIVATE LIMITED",
"SPOT-ON ESTATES PRIVATE LIMITED",
"SPOTON LOGISTICS PRIVATE LIMITED",
"SPOTON SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED",
"SPOTQA INDIA PRIVATE LIMITED",
"SPOTTED COW FROMAGERIE PRIVATE LIMITED",
"SPOTZOT INDIA PRIVATE LIMITED",
"SPOXY GAS PRODUCTS PRIVATE LIMITED",
"SPOYL TECH SOLUTIONS PRIVATE LIMITED",
"SPP POLY PACK PRIVATE LIMITED",
"SPP POLYMER LIMITED",
"SPPL HOTELS PRIVATE LIMITED",
"SPPLICETEK INDIA PRIVATE LIMITED",
"SPPR INFRACON PRIVATE LIMITED",
"SPPRADO INDIA PRIVATE LIMITED",
"SPPS CONSTRUCTION INDIA PRIVATE LIMITED",
"SPPU EDUTECH FOUNDATION",
"SPR & CO",
"SPR & RG CONSTRUCTIONS PRIVATE LIMITED",
"SPR BUILDTECH LIMITED",
"SPR CHEMOPHARMA PRIVATE LIMITED",
"SPR CITY ESTATES PRIVATE LIMITED",
"SPR COMMERCIAL MALLS & MARKETS PRIVATE LIMITED",
"SPR CONSTRUCTION PRIVATE LIMITED",
"SPR CONSTRUCTIONS",
"SPR COURIER AND CARGO MOVERS",
"SPR GLOBAL SPORTS PRIVATE LIMITED",
"SPR MANAGEMENT SERVICES PRIVATE LIMITED",
"SPR ONCOCARE PRIVATE LIMITED",
"SPRANDI INTERNATIONAL PRIVATE LIMITED",
"SPRAXA SOLUTIONS PRIVATE LIMITED",
"SPRAY DRYING AND CHEMICALS PRIVATE LIMITED",
"SPRAY ENGINEERING DEVICES LIMITED",
"SPRAY GUN INDIA PRIVATE LIMITED",
"SPRAYFILL INDIA PRIVATE LIMITED",
"SPRAYGRANCES PRIVATE LIMITED",
"SPRAYING SYSTEMS INDIA PRIVATE LIMITED",
"SPRAYKING LIMITED",
"SPRAYMET SURFACE TECHNOLOGIES PRIVATE LIMITED",
"SPRAYTEC (INDIA) LIMITED",
"SPRAYTECH AUTOMATION INDIA PRIVATE LIMITED",
"SPRAYTECH SYSTEMS INDIA PRIVATE LIMITED",
"SPREAD DESIGN AND INNOVATION PRIVATE LIMITED",
"SPREAD HOME PRODUCTS PRIVATE LIMITED",
"SPREADFUN TECHNOLOGIES PRIVATE LIMITED",
"SPREADTRUM COMMUNICATIONS INDIA PRIVATE LIMITED",
"SPREE HOTELS AND REAL ESTATE PRIVATE LIMITED",
"SPRICS ENTERPRISE PRIVATE LIMITED",
"SPRIDE PROPERTIES PRIVATE LIMITED",
"SPRIGHTLITE FOODS PRIVATE LIMITED",
"SPRIIO SOFTWARE SOLUTIONS LLP",
"SPRING BOARD DESIGN STUDIOS LLP",
"SPRING BOX FILMS PRIVATE LIMITED",
"SPRING CITY BUILDTECH LLP",
"SPRING CLEAN LIMITED",
"SPRING COMPUTING TECHNOLOGIES PRIVATE LIMITED",
"SPRING CONCEPT INDIA PRIVATE LIMITED",
"SPRING CONVERGENCE SERVICES PRIVATE LIMITED",
"SPRING DALE COLLEGE LUCKNOW",
"SPRING DALE PUBLIC SCHOOL",
"SPRING DAYS SR SEC SCHOOL",
"SPRING DYNAMICS PRIVATE LIMITED",
"SPRING FRESH WATER TREATMENTS LIMITED",
"SPRING HEALTH WATER INDIA PRIVATE LIMITED",
"SPRING HOSPITALITY PRIVATE LIMITED",
"SPRING INFOMATICS PRIVATE LIMITED",
"SPRING LEAF RETAIL PRIVATE LIMITED",
"SPRING LIFE RETAIL STORES PRIVATE LIMITED",
"SPRING MERCHANDISERS PRIVATE LIMITED",
"SPRING OVERSEAS PRIVATE LIMITED",
"SPRING TRADING PRIVATE LIMITED",
"SPRING VALLEY COMPUTECH PRIVATE LIMITED",
"SPRING WATER HYDRATION TECHNOLOGIES PRIVATE LIMITED",
"SPRING WATER PROPERTIES PRIVATE LIMITED",
"SPRINGBOARD ENTERPRISES INDIA LIMITED",
"SPRINGBOARD MEDIA VENTURES PRIVATE LIMITED",
"SPRINGBOARD SOLUTIONS PRIVATE LIMITED",
"SPRINGBOARDS SPUR PRIVATE LIMITED",
"SPRINGBOK PROPERTIES PVT LTD",
"SPRINGBORD SYSTEMS PRIVATE LIMITED",
"SPRINGCREEK MULTIVENTURE PRIVATE LIMITED",
"SPRINGDALE HIGH SCHOOL HS",
"SPRINGDALE HOTELS PRIVATE LIMITED",
"SPRINGDALE SCHOOLS PRIVATE LIMITED",
"SPRINGDALES SENIOR SECONDARY SCHOOL",
"SPRINGDAYS SCHOOL",
"SPRINGER HEALTHCARE SYSTEMS PRIVATE LIMITED",
"SPRINGER NATURE INDIA PRIVATE LIMITED",
"SPRINGER NATURE TECHNOLOGY AND PUBLISHING SOLUTIONS PRIVATE LIMITED",
"SPRINGFEEL POLYURETHANE FOAMS PRIVATE LIMITED",
"SPRINGFEEL WIND ENERGY PRIVATE LIMITED",
"SPRINGFIELD LEATHER PRIVATE LIMITED",
"SPRINGFIELD PROJECTS PRIVATE LIMITED",
"SPRINGFIT MATTRESS PRIVATE LIMITED",
"SPRINGHOUSE COWORKING PRIVATE LIMITED",
"SPRINGLEA DEVELOPERS PRIVATE LIMITED",
"SPRINGLEAF HEALTHCARE PRIVATE LIMITED",
"SPRINGML INDIA DEVELOPMENT CENTER PRIVATE LIMITED",
"SPRINGPEOPLE SOFTWARE PRIVATE LIMITED",
"SPRINGROLE INDIA PRIVATE LIMITED",
"SPRINGS HOME DECOR PRIVATE LIMITED",
"SPRINGTECH SUSPENSIONS PRIVATE LIMITED",
"SPRINGTIME CLUBS AND HOSPTALITY SERVICES PRIVATE LIMITED",
"SPRINGTIME FLORA PRIVATE LIMITED",
"SPRINGTON AGRO INDIA PRIVATE LIMITED",
"SPRINGVALLEY MARKETING PRIVATE LIMITED",
"SPRINGWEL MATTRESSES PRIVATE LIMITED",
"SPRINGWELL MATTRESSES PRIVATE LIMITED",
"SPRINT (INDIA) IMAGING PRIVATE LIMITED",
"SPRINT CONSYS PRIVATE LIMITED",
"SPRINT EXPORTS PRIVATE LIMITED",
"SPRINT INTEGRATED SOLUTIONS PRIVATE LIMITED",
"SPRINT LOGISTICS PRIVATE LIMITED",
"SPRINT SEDAN CAR RENTAL SERVICES PRIVATE LIMITED",
"SPRINT SPORTS PRIVATE LIMITED",
"SPRINT TELEFILMS PRIVATE. LIMITED.",
"SPRINT TEXTILE MILLS PRIVATE LIMITED",
"SPRINTPARK TECHNOLOGY & MARKETING PRIVATE LIMITED",
"SPRISM INVESTMENT SERVICES PRIVATE LIMITED",
"SPRIT INFRAPOWER & MULTIVENTURES PRIVATE LIMITED",
"SPRIT SPORTS PRIVATE LIMITED",
"SPRITE INVESTMENT PRIVATE LIMITED",
"SPRITLE SOFTWARE PRIVATE LIMITED",
"SPRITUAL DEVELOPERS PRIVATE LIMITED",
"SPRIVIL HEALTHCARE PRIVATE LIMITED",
"SPRK ALUM PRIVATE LIMITED",
"SPRM ENERGY INFRASTRUCTURE PRIVATE LIMITED",
"SPRNG AGNITRA PRIVATE LIMITED",
"SPRNG NATURAL POWER SOURCE PRIVATE LIMITED",
"SPRNG PHOTOVOLTAIC PRIVATE LIMITED",
"SPRNG RENEWABLE ENERGY PRIVATE LIMITED",
"SPRNG SOLAR INDIA PRIVATE LIMITED",
"SPRNG SOLAR PLUS PRIVATE LIMITED",
"SPRNG SOLREN PRIVATE LIMITED",
"SPRNG SURYODAY ENERGY PRIVATE LIMITED",
"SPRNG TRANSFORM SUN ENERGY PRIVATE LIMITED",
"SPRNG UJJVALA ENERGY PRIVATE LIMITED",
"SPROUT INDIA PRIVATE LIMITED",
"SPROUT LABORATORIES PRIVATE LIMITED",
"SPROUT PRIVATE LIMITED",
"SPROUT STUDIOS PRIVATE LIMITED",
"SPROUTAMINS SUPER FOODS PRIVATE LIMITED",
"SPROUTLIFE FOODS PRIVATE LIMITED",
"SPROUTLOGIX PRIVATE LIMITED",
"SPROUTS ENERGY PRIVATE LIMITED",
"SPROXIL BRAND PROTECTION SOLUTIONS PRIVATE LIMITED",
"SPRUCE ENTERPRISES PRIVATE LIMITED",
"SPRUCE IT PRIVATE LIMITED",
"SPRUCE PAX PRIVATE LIMITED",
"SPRUCE SOFTWARE TECHNOLOGY PRIVATE LIMITED",
"SPRUCE UP INDUSTRIES PRIVATE LIMITED",
"SPRUCEFLY CONSULTING INDIA PRIVATE LIMITED",
"SPRUCEWORLD INDIA PRIVATE LIMITED",
"SPRV TECHNOLOGIES PRIVATE LIMITED",
"SPRYBIT SOFTLABS LLP",
"SPRYIQ TECHNOLOGIES PRIVATE LIMITED",
"SPRYLOGIC TECHNOLOGIES LIMITED",
"SPRYLOGIC TECHNOLOGIES PRIVATE LIMITED",
"SPRYSOFT TECHNOLOGIES PRIVATE LIMITED",
"SPS CONSULTANTS INSURANCE BROKERS LLP",
"SPS ENAMELS PRIVATE LIMITED",
"SPS FINQUEST LIMITED",
"SPS INFRABUILD PRIVATE LIMITED",
"SPS INFRASTRUCTURE PRIVATE LIMITED",
"SPS INTERMODAL SERVICES INDIA PRIVATE LIMITED",
"SPS METAL COMPONENTS PRIVATE LIMITED",
"SPS SHARE BROKERS PRIVATE LIMITED",
"SPS SPINNERS PRIVATE LIMITED",
"SPS STEELS ROLLING MILLS LIMITED",
"SPS TECHNOCRATS PRIVATE LIMITED",
"SPS TRANSFORMERS PRIVATE LIMITED",
"SPS VAIKUNTH REALTY PRIVATE LIMITED",
"SPS YOJANA JR COLLEGE",
"SPSBIO-CHEM PRIVATE LIMITED",
"SPSG TOPHIRE PRIVATE LIMITED",
"SPSS SOUTH ASIA PRIVATE LIMITED",
"SPSY BPO SERVICES PRIVATE LIMITED",
"SPT COMMODITIES PRIVATE LIMITED",
"SPT INVESTMENT ADVISORY SERVICES PRIVATE LIMITED",
"SPT LABTECH INDIA PRIVATE LIMITED",
"SPT SECURITIES LTD.",
"SPUN MICRO PROCESSING PRIVATE LIMITED",
"SPUNDAN CONSULTANCY AND IT SOLUTIONS PRIVATE LIMITED",
"SP-UNITED WATERPROOFING MATERIALS PRIVATE LIMITED",
"SPUNK TELECOMMUNICATIONS PRIVATE LIMITED",
"SPUNKADS MEDIA PRIVATE LIMITED",
"SPUNLINE NONWOVEN PRIVATE LIMITED",
"SPUNWEB NONWOVEN PRIVATE LIMITED",
"SPUNWELL SYNTEX PRIVATE LIMITED",
"SPUR DISPLAY & PROMOTIONS PRIVATE LIMITED",
"SPUR DTDS MICROWAVE PRIVATE LIMITED",
"SPUR TECHNOLOGIES PRIVATE LIMITED",
"SPUR VISION MULTI SERVICES PRIVATE LIMITED",
"SPURGEON TRANSPORT PRIVATE LIMITED",
"SPURLINK TELESERVICES PRIVATE LIMITED",
"SPURS AND THREADS SOLUTIONS PRIVATE LIMITED",
"SPURTREE TECHNOLOGIES PRIVATE LIMITED",
"SPURTZ FASHIONS PRIVATE LIMITED",
"SPUTNIK STEELS PRIVATE LIMITED",
"SPUTNIK SWITCH GEARS PRIVATE LIMITED",
"SPV COMMOTRADE PRIVATE LIMITED",
"SPV GLOBAL TRADING LIMITED",
"SPV SYNERGY PRIVATE LIMITED",
"SPVA SOLUTIONS LLP",
"SPVH PRIVATE LIMITED",
"SPVR PROJECTS PRIVATE LIMITED",
"SPX FLOW TECHNOLOGY INDIA PRIVATE LIMITED",
"SPX LOGISTICS SERVICES PRIVATE LIMITED",
"SPX THERMAL EQUIPMENT AND SERVICES INDIA PRIVATE LIMITED",
"SPY CLOUD PRIVATE LIMITED",
"SPY PLASTICS PRIVATE LIMITED",
"SPYCOM INDIA PRIVATE LIMITED",
"SPYCY FAST FOOD PRIVATE LIMITED",
"SPYDER GREEN INDIA PRIVATE LIMITED",
"SPYKA HOMES PRIVATE LIMITED",
"SPYKAR LIFESTYLES PRIVATE LIMITED",
"SPYKAR SHIPPING PRIVATE LIMITED",
"SPYKE TECHNOLOGIES PRIVATE LIMITED",
"SPYKKE INNOVATIONS PRIVATE LIMITED",
"SPYLARK PRIVATE LIMITED",
"SPYROS LOGISTICS PRIVATE LIMITED",
"SPYTECH REALTORS PRIVATE LIMITED",
"SPYVISION SOLUTIONS & TECHNOLOGY PRIVATE LIMITED",
"SPYWARE GLOBAL SOLUTIONS PRIVATE LIMITED",
"SQ CONSULTANCY SERVICES PRIVATE LIMITED",
"SQ ENTERPRISES PRIVATE LIMITED",
"SQAD GEAR PRIVATE LIMITED",
"SQINTALK COSMECEUTICALS PRIVATE LIMITED",
"SQK VALVES FITTINGS & AUTOMATION PRIVATE LIMITED",
"SQR INFOTECH PRIVATE LIMITED",
"SQS INDIA INFOSYSTEMS PRIVATE LIMITED",
"SQUAD 7 PROJECTS AND SERVICES PRIVATE LIMITED",
"SQUAD FORGING INDIA PRIVATE LIMITED",
"SQUAD INDIA SECURE SERVICES PRIVATE LIMITED",
"SQUAD INFOTECT PRIVATE LIMITED",
"SQUAD SOFTWARE PRIVATE LIMITED",
"SQUAD SYSTEMS PRIVATE LIMITED",
"SQUAD TECHNOLOGIES PRIVATE LIMITED",
"SQUADCAST LABS PRIVATE LIMITED",
"SQUADGAIN TECHLABS PRIVATE LIMITED",
"SQUADM TECHNOLOGIES PRIVATE LIMITED",
"SQUADRA MEDIA PRIVATE LIMITED",
"SQUADRON GRAPHICS INDIA PRIVATE LIMITED",
"SQUADRON SECURITY SERVICES PRIVATE LIMITED",
"SQUADRUN SOLUTIONS PRIVATE LIMITED",
"SQUADX INNOVATIONS PRIVATE LIMITED",
"SQUAIRCLE DIGITAL PRIVATE LIMITED",
"SQUARE BAKERS CONFECTIONARIES PRIVATE LIMITED",
"SQUARE BITS PRIVATE LIMITED",
"SQUARE BUSINESS SERVICES PRIVATE LIMITED",
"SQUARE CERAMIC PRIVATE LIMITED",
"SQUARE CIRCLE OUTDOORS PRIVATE LIMITED-HEMANT SINGH",
"SQUARE COMMUNICATIONS PRIVATE LIMITED",
"SQUARE DETAILING PRIVATE LIMITED",
"SQUARE FEET INFRASTRUCTURE LLP",
"SQUARE FEET ONLINE REALTY SERVICES PRIVATE LIMITED",
"SQUARE FEET PROPERTY CONSULTANT PRIVATE LIMITED",
"SQUARE FOUNDRY PRIVATE LIMITED",
"SQUARE FOUR HOUSING & INFRASTRUCTURE DEVELOPMENT PRIVATE LIMITED",
"SQUARE INFO SOLUTIONS PRIVATE LIMITED",
"SQUARE INSURANCE BROKERS PRIVATE LIMITED",
"SQUARE MANGO INNOVATIONS PRIVATE LIMITED",
"SQUARE MARKETING PRIVATE LIMITED",
"SQUARE MEAL PRIVATE LIMITED",
"SQUARE NETWORK SOLUTIONS PRIVATE LIMITED",
"SQUARE ONE MEDIA SOLUTIONS PRIVATE LIMITED",
"SQUARE PANDA EDUCATION PRIVATE LIMITED",
"SQUARE PETROFIELD PRIVATE LIMITED",
"SQUARE PIXEL STUDIO",
"SQUARE ROOT CONSULTING PRIVATE LIMITED",
"SQUARE ROOT HOSPITALITIES PRIVATE LIMITED",
"SQUARE TEXTILE VENTURES PRIVATE LIMITED",
"SQUARE VISION INDIA PRIVATE LIMITED",
"SQUARE YARDS TECHNOLOGY PRIVATE LIMITED",
"SQUARE9 CORPORATION PRIVATE LIMITED",
"SQUAREBOX EXHIBITION SOLUTIONS (OPC) PRIVATE LIMITED",
"SQUARED CIRCLE ECOM PRIVATE LIMITED",
"SQUAREM BIO-ORGANIC PRIVATE LIMITED",
"SQUAREMEAL FOODS PRIVATE LIMITED",
"SQUAREONE INSIGHTS PRIVATE LIMITED",
"SQUAREOPS TECHNOLOGIES PRIVATE LIMITED",
"SQUAREPOINT TECHNOLOGIES INDIA PRIVATE LIMITED",
"SQUAREROOTS WATERWAYS INDIA PRIVATE LIMITED",
"SQUARETECH EQUIPMENTS PRIVATE LIMITED",
"SQUAREVISION PROPERTIES PRIVATE LIMITED",
"SQUAREWOOD PROJECTS PRIVATE LIMITED",
"SQUARICLE INNOVATIONS PRIVATE LIMITED",
"SQUASH APPS PRIVATE LIMITED",
"SQUBE BUILDERS PRIVATE LIMITED",
"SQUBIX DIGITAL PRIVATE LIMITED",
"SQUEAMISH SUPPORT SERVICES PRIVATE LIMITED",
"SQUENDO INDIA PRIVATE LIMITED",
"SQUIRE INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"SQUIRKLE PRODUCTIONS PRIVATE LIMITED",
"SQUIRREL ENTERPRISES PRIVATE LIMITED",
"SQUIRREL SOFTECH SERVICES PRIVATE LIMITED",
"SR AIRWORTHINESS OFFICER CONTROLLER OF AIRWORTHINESS BHOPAL",
"SR ARTEFACTS PRIVATE LIMITED",
"SR ASHOK AND ASSOCIATES SPV PRIVATE LIMITED",
"SR ASSOCIATES INFRASTRUCTURE PRIVATE LIMITED",
"SR BIZSCIENCES TECHNOLOGY AND TRAVEL SOLUTIONS PRIVATE LIMITED",
"SR BUSINESS SOLUTIONS PRIVATE LIMITED",
"SR CABS PRIVATE LIMITED",
"SR CEMENTECH PRIVATE LIMITED",
"SR COMPOSITES PRIVATE LIMITED",
"SR CORPORATE CONSULTANT PRIVATE LIMITED",
"SR CROP SCIENCE PRIVATE LIMITED",
"SR DEGREE COLLEGE",
"SR DESHMUKH ENGINEERS & CONTRACTOR PRIVATE LIMITED",
"SR DIGI SCHOOL",
"SR EDIFICE PRIVATE LIMITED",
"SR EDU CENTRE PRIVATE LIMITED",
"SR ELECTROSTEEL PRIVATE LIMITED",
"SR ENTERPRISE",
"SR ENTERPRISES",
"SR FACADES INDIA PRIVATE LIMITED",
"SR FERRO ALLOYS PRIVATE LIMITED",
"SR FIBREGLASS AUTO PRIVATE LIMITED",
"SR GUDLAVALLERU ENGINEERING COLLEGE",
"SR HIGHTECH PRIVATE LIMITED",
"SR INDUS ELECTRO SYS PRIVATE LIMITED",
"SR INDUSTRIES",
"SR INSTITUTE OF ADVANCED AYURVEDIC SCIENCES PRIVATE LIMITED",
"SR INSTITUTE OF MANAGEMENT AND TECHNOLOGY",
"SR INTEGRATED CIRCUIT INDIA PRIVATE LIMITED",
"SR INTELLIGENT TECHNOLOGIES INDIA PRIVATE LIMITED",
"SR JUNIOR COLLEGE",
"SR KHAN CONSTRUCTION LIMITED",
"SR LANDMARK DEVELOPERS PRIVATE LIMITED",
"SR LOGISTICS INDIA PRIVATE LIMITED",
"SR MAGICSTONE RUBBER PRIVATE LIMITED",
"SR MANAGEMENT TECHNOLOGY CONSULTING PRIVATE LIMITED",
"SR MARINE & OFFSHORE ENGINEERING PRIVATE LIMITED",
"SR MARINE FOODS PRIVATE LIMITED",
"SR MEDICARE PRIVATE LIMITED",
"SR MEDISYS PRIVATE LIMITED",
"SR METALLIZERS",
"SR METALLOYS PRIVATE LIMITED",
"SR MULTI SPECIALITY HOSPITAL",
"SR PEDDI ESTATES (INDIA) PRIVATE LIMITED",
"SR PHARMACEUTICAL INDUSTRIES PRIVATE LIMITED",
"SR PLASTERS PRIVATE LIMITED",
"SR POLYIMPEX PRIVATE LIMITED",
"SR POWER SYSTEMS INDIA PRIVATE LIMITED",
"SR PRIME SCHOOL",
"SR QUALITY ASSURANCE ESTTVEHICLES MUMBAI",
"SR RESIDENCY PRIVATE LIMITED",
"SR SECURITY PRIVATE LIMITED",
"SR SUITES AND HOTELS PRIVATE LIMITED",
"SR TECHNOLOGIES PRIVATE LIMITED",
"SR TEKBOX PRIVATE LIMITED",
"SR UNIVERSITY",
"SR VISION SHOPPE PRIVATE LIMITED",
"SR39 ENGINEERS PRIVATE LIMITED",
"SRA ASSOCIATES PRIVATE LIMITED",
"SRA BUSINESS SOLUTIONS PRIVATE LIMITED",
"SRA CONSTRUCTION COMPANY PRIVATE LIMITED",
"SRA ENTERPRISES PRIVATE LIMITED",
"SRA EXIM PRIVATE LIMITED",
"SRA INDIA PRIVATE LIMITED",
"SRA INFORMATION TECHNOLOGY CONSULTANTS PRIVATE LIMITED",
"SRA PROJECT DEVELOPERS PRIVATE LIMITED",
"SRA SYSTEMS LIMITED",
"SRA TECHNO CRAFT PRIVATE LIMITED",
"SRAAT RETAIL SOLUTIONS PRIVATE LIMITED",
"SRABONI PRIMARY SCHOOL",
"SRAC PETROCHEM PRIVATE LIMITED",
"SRADYA LIFECARE PRIVATE LIMITED",
"SRAI CONSTRUCTIONS PRIVATE LIMITED",
"SRAI CONSULTING PRIVATE LIMITED",
"SRAI GRANITES PRIVATE LIMITED",
"SRAJAN ALLIED SERVICES PRIVATE LIMITED",
"SRAJAN AUTOMOTORS PRIVATE LIMITED",
"SRAJAN CAPITAL LIMITED",
"SRAJAN DHARA FARMERS PRODUCER COMPANY LIMITED",
"SRAJAN VIDYAVRAT PRIVATE LIMITED",
"SRAK PRESTEK PRIVATE LIMITED",
"SRAMMRAM TECHNOLOGIES AND RESOURCES PRIVATE LIMITED",
"SRANSH TRADERS PRIVATE LIMITED",
"SRAS INDIA PRIVATE LIMITED",
"SRAS SHIPPING AND OFFSHORE PRIVATE LIMITED",
"SRASTI LIQUOR PRIVATE LIMITED",
"SRAVAN CORRUGATERS PRIVATE LIMITED",
"SRAVAN SHIPPING SERVICES PRIVATE. LIMITED.",
"SRAVANI HOSPITAL",
"SRAVANTHI ENERGY PRIVATE LIMITED",
"SRAVASTI UDYOG VINIYOG PVT LTD",
"SRAVENCO CONSULTING SERVICES PRIVATE LIMITED",
"SRAVYA INFRA PROJECTS PRIVATE LIMITED",
"SRAVYA TEXTILES PRIVATE LIMITED",
"SRB AIRCON PRIVATE LIMITED",
"SRB CONSULTANCY PRIVATE LIMITED",
"SRB CUSTOM BUILT EQUIPMENTS PRIVATE LIMITED",
"SRB INTERNATIONAL PRIVATE LIMITED",
"SRB IRRIGATION PRIVATE LIMITED",
"SRB MACHINES PRIVATE LIMITED",
"SRB MULTITECH LIMITED",
"SRB PAPERTECH PRIVATE LIMITED",
"SRB PROMOTERS PRIVATE LIMITED",
"SRB STEEL PRIVATE LIMITED",
"SRB VENTURES PRIVATE LIMITED",
"SRBH ENGINEERING & EQUIPMENT PRIVATE LIMITED",
"SRBS COATING PRIVATE LIMITED",
"SRBS INTERIORS INDIA PRIVATE LIMITED",
"SRC COMPANY INFRA PRIVATE LIMITED",
"SRC CONSTRUCTIONS PVT LTD",
"SRC FARMS PRIVATE LIMITED",
"SRC FLEET MANAGEMENT PRIVATE LIMITED",
"SRC INDUSTRIAL PACKAGING SOLUTIONS",
"SRC INFRA DEVELOPERS PRIVATE LIMITED",
"SRC INFRAPROJECTS PRIVATE LIMITED",
"SRC LABORATORIES PRIVATE LIMITED",
"SRC MARKETING PRIVATE LIMITED",
"SRC MASTERJET AVIATION PRIVATE LIMITED.",
"SRC PARIVAHAN PRIVATE LIMITED",
"SRC PROJECTS PRIVATE LIMITED",
"SRCHIP ELECTRONICS PRIVATE LIMITED",
"SRCT THREAD PRIVATE LIMITED",
"SRCV SUPPLY CHAIN PRIVATE LIMITED",
"SRD LOGISTICS PRIVATE LIMITED",
"SRD NUTRIENTS PRIVATE LIMITED",
"SRDF ORGANIC PRIVATE LIMITED",
"SRDM SALES PRIVATE LIMITED",
"SRE HITECH PRIVATE LIMITED",
"SRE MACHINERIES PRIVATE LIMITED",
"SRE SYSTEMS PRIVATE LIMITED",
"SREDSTVA REGIONALE CHEMIE PRIVATE LIMITED",
"SREE ABIRAAMI ARTS AND SCIENCE COLLEGE FOR WOMEN",
"SREE AGRO PRODUCTS PRIVATE LIMITED",
"SREE AKKAMAMBA TEXTILES LIMITED",
"SREE AKSHARA JUNIOR COLLEGE",
"SREE AMBAL PROCESSORS PRIVATE LIMITED",
"SREE AMMU MART (OPC) PRIVATE LIMITED",
"SREE ANANDHAKUMAR MILLS LIMITED",
"SREE ANANTHALAKSHMI TEXTILES PRIVATE LIMITED",
"SREE ANNAPOORNA FOODS",
"SREE ANNAPOORNA HOSPITALITY SERVICES PRIVATE LIMITED",
"SREE ANNAPOORNA SREE GOWRISHANKAR HOTELS PRIVATE LIMITED",
"SREE ARULMANI EXPORTS",
"SREE ARUNODAYA AGRO EXTRACTION PRIVATE LIMITED",
"SREE ASHAPURI MARKETING (MADRAS) PRIVATE LIMITED",
"SREE ASTALAXMI SPINNING MILLS PRIVATE LIMITED",
"SREE AYYANAR SPINNING AND WEAVING MILLS PRIVATE LIMITED",
"SREE AYYAPPA PUBLIC SCHOOL",
"SREE BALAJI BRIQUETTES & BIOMASS PRIVATE LIMITED",
"SREE BALAJI BUILDCARE PRIVATE LIMITED",
"SREE BALAJI DENIM PRIVATE LIMITED",
"SREE BALAJI DENTAL COLLEGE & HOSPITAL",
"SREE BALAJI FASTENERS PRIVATE LIMITED",
"SREE BALAJI MEDICAL COLLEGE & HOSPITAL",
"SREE BANASHANKARI MAHILA CO-OPERATIVE BANK LTD",
"SREE BEHARIJI MILLS PRIVATE LIMITED",
"SREE BHADRADRI SPONGE IRON PRIVATE LIMITED",
"SREE BHAGVAN ENTERPRISES",
"SREE BHARATI BIO GENETICS PRIVATE LIMITED",
"SREE BHRAMARA INFRASTRUCTURES PRIVATE LIMITED",
"SREE BRHITA VISTA CHEMICALS PRIVATE LIMITED",
"SREE CHAITANYA COLLEGE HABRA",
"SREE CHAITANYA JUNIOR COLLEGE",
"SREE CHAKRA CLEARING & FORWARDING PRIVATE LIMITED",
"SREE CHAND ELECTRICAL INDUSTRIES PVT LTD",
"SREE CHANDANA BROTHERS",
"SREE CHANDRA AUTO COMPONENTS PRIVATE LIMITED",
"SREE CHARAN SOUHARDHA CO-OPERATIVE BANK LTD",
"SREE CHITHIRA ENGINEERING INDIA PRIVATE LIMITED",
"SREE CHITIRA THIRUNAL COLLEGE OF ENGINEE",
"SREE CONSTRUCTIONS.",
"SREE DAKSHA PROPERTY DEVELOPERS (INDIA) PRIVATE LIMITED",
"SREE DATTHA INSTITUTE OF PHARMACY",
"SREE DEVI JEWELLERS PRIVATE LIMITED",
"SREE DHANAM AUTOMATION PRIVATE LIMITED",
"SREE DINAKAR FABRICS PRIVATE LIMITED",
"SREE DURGA FIBRE PRODUCTS PRIVATE LIMITED",
"SREE DURGA MARKETING",
"SREE DURGAPRATHIMA POULTRIES PRIVATE LIMITED (ALTER)",
"SREE ESHWAR FOREX PRIVATE LIMITED",
"SREE FERTILITY & GYANE CENTRE PRIVATE LIMITED",
"SREE GANESAR TEXTILE MILLS LIMITED",
"SREE GANESH GEARS PRIVATE LIMITED",
"SREE GENGA MILLS PRIVATE LIMITED",
"SREE GODAVARI KRAFT PAPERS LIMITED",
"SREE GOKULAM CHIT & FINANCE CO PRIVATE LIMITED",
"SREE GOKULAM EXPORTS AND IMPORTS INDIA PRIVATE LIMITED",
"SREE GOKULAM FILM STUDIOS PRIVATE LIMITED",
"SREE GOKULAM FOOD AND BEVERAGES PRIVATE LIMITED",
"SREE GOKULAM FOOD PRODUCTS PRIVATE LIMITED",
"SREE GOKULAM HOTEL INDIA PRIVATE LIMITED",
"SREE GOKULAM JEWELLERY MART PRIVATE LIMITED",
"SREE GOKULAM KERALA FOOTBALL CLUB PRIVATE LIMITED",
"SREE GOKULAM MEDICAL COLLEGE AND RESEARCH FOUNDATION",
"SREE GOKULAM MOBILES PRIVATE LIMITED",
"SREE GOKULAM MOTORS AND SERVICES PRIVATE LIMITED",
"SREE GOKUL'S BUILD MART PRIVATE LIMITED",
"SREE GOMATHI AMMAN SPINNING MILLS PRIVATE LIMITED",
"SREE GOWRI GANESHA CHITS PRIVATE LIMITED",
"SREE GUPTA BHAVAN PRIVATE LIMITED",
"SREE GURU FOUNDATIONS PRIVATE LIMITED",
"SREE GURUDEVA CHARITABLE AND EDUCATIONAL TRUST",
"SREE HANUMAN INFRA PRIVATE LIMITED",
"SREE HANUMAN VYAYAM SHALA HIGH SCHOOL",
"SREE HARIHARA PUTHRA CHITS PRIVATE LIMITED",
"SREE HARSHA AUTOMOTIVE SERVICES PRIVATE LIMITED",
"SREE INFORMATICS PRIVATE LIMITED",
"SREE ISWARYA TEXTILES PRIVATE LIMITED",
"SREE IVY ROCKKS OVERSEAS PRIVATE LIMITED",
"SREE IYAPPA MATRICULATION HIGHER SECONDARY SCHOOL",
"SREE JAGADAMBA TEA CO PVT LTD",
"SREE JAGATHGURU TEXTILES MILLS PRIVATE LIMITED",
"SREE JAYA SURYA HOSPITAL PRIVATE LIMITED",
"SREE JAYAJOTHI CEMENTS PRIVATE LIMITED",
"SREE JAYAM TRANS PRIVATE LIMITED",
"SREE JAYAMURUGAN ALLOYS PRIVATE LIMITED",
"SREE JAYARAJ SOAPS PRIVATE LIMITED",
"SREE JAYASUBHA SPINNERS PRIVATE LIMITED",
"SREE JNANAKSHI RENEWABLE ENERGY PRIVATE LIMITED",
"SREE JOTHI SUPERMARKET",
"SREE JYOTHILAKSHMI CARS PRIVATE LIMITED",
"SREE KADERI AMBAL MILLS PRIVATE LIMITED",
"SREE KAILAII SPINNERS PRIVATE LIMITED",
"SREE KAMAKHYA TEA CO PVT LTD",
"SREE KANTESHWARA COLD STORAGE PRIVATE LIMITED",
"SREE KARPAGAMBAL MILLS LIMITED",
"SREE KEERTHI TRANSLINES SERVICES PRIVATE LIMITED",
"SREE KHEMISATI CONSTRUCTIONS PVT LTD",
"SREE KOPPAMMAL COTTON SPINNING MILLS PRIVATE LIMITED",
"SREE KRISHNA ALLOYS INDUSTRIES PRIVATE LIMITED",
"SREE KRISHNA LABELS & SOLUTIONS PRIVATE LIMITED",
"SREE KUMAR AGRO OILS PRIVATE LIMITED",
"SREE LAKSHMI APPARELS PRIVATE LIMITED",
"SREE LAKSHMI EGG PRODUCTS PRIVATE LIMITED",
"SREE LAKSHMI GANAPATHI INFRATECH PRIVATE LIMITED",
"SREE LAKSHMI GAYATRI HOSPITALS PRIVATE LIMITED",
"SREE LAKSHMI HATCHERIES PVT LTD",
"SREE LAKSHMI VENKATESWARA SPINNING MILLS PRIVATE LIMITED",
"SREE LALITHA PARAMESWARI SPINNING MILLS PRIVATE LIMITED",
"SREE LPG PRIVATE LIMITED",
"SREE MAHABAHU TREXIM PRIVATE LIMITED",
"SREE MAHALAKSHMI VIDYALAYA MATRIC HIGHER SECONDARY SCHOOL",
"SREE MAHALAXMI RICE INDUSTRIES PRIVATE LIMITED",
"SREE MANGALAMBIGAI COTTON MILLS PRIVATE LIMITED",
"SREE MANGAYARKARASI MILLS PRIVATE LIMITED",
"SREE METALIKS LTD",
"SREE MOOKAMBIKA TEXTILES PRIVATE LIMITED",
"SREE MOUNIKA INDUSTRIES PRIVATE LIMITED",
"SREE MOUNT BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"SREE MUGAMBIGAI GLAZING PRIVATE LIMITED",
"SREE MURALI MOHANA BOILED RAW RICE MILL PRIVATE. LIMITED.",
"SREE MUTHUKUMARASWAMY COLLEGE",
"SREE NACHIYAR TECH PRIVATE LIMITED",
"SREE NANDHEES TECHNOLOGIES PRIVATE LIMITED",
"SREE NANDINI KRAFT BOARDS PRIVATE LIMITED",
"SREE NANDISWARA POLYMERS INDIA PRIVATE LIMITED",
"SREE NARASIMHA HOTELS PRIVATE LIMITED",
"SREE NARASIMHA TEXTILES PRIVATE LIMITED",
"SREE NARAYANA COLLEGE",
"SREE NARAYANA EDUCATIONAL SOCIETY",
"SREE NARAYANA FACILITIES PRIVATE LIMITED",
"SREE NARAYANA GURU HIGH SCHOOL",
"SREE NARAYANA INSTITUTE OF MEDICAL SCIENCE",
"SREE NARAYANA MEDICAL MISSION HOSPITAL",
"SREE NARAYANA VIDHYALAYA H UPS KANHAN",
"SREE NAVKAR BOUTIQUE PRIVATE LIMITED",
"SREE NEELAMPATI LAKSHMI AMMAVARI COLD STORAGE PRIVATE. LIMITED.",
"SREE NETRALAYA EYE HOSPITAL & LASER CENTRE PRIVATE LIMITED",
"SREE NIRMALA YARN MILL PRIVATE LIMITED",
"SREE OVERSEAS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"SREE PALANI ANDAVAR ALLOYS AND STEELS PRIVATE LIMITED",
"SREE PRAAGNA HOSPITALS PRIVATE LIMITED",
"SREE PRABHUKISHAN AGRO PRODUCTS PVT. LTD.",
"SREE PRASEEDHA STEELS AND MINERALS PRIVATE LIMITED",
"SREE RADHA CREATION PRIVATE LIMITED",
"SREE RAGHAVENDRA ELECTRIC SERVICES PRIVATE LIMITED",
"SREE RAGHAVENDRA ENTERPRISES",
"SREE RAJARAJESWARI METALS & ORES PRIVATE LIMITED",
"SREE RAJASEEKAR SPINNING MILLS PRIVATE LIMITED",
"SREE RAM PLYWOOD MFG CO PVT LTD",
"SREE RAMA ENGINEERING COLLEGE",
"SREE RAMA SHRIMP PRODUCTS PRIVATE LIMITED",
"SREE RAMACHANDRA HEALTH SERVICES PRIVATE LIMITED.",
"SREE RAMACHANDRA PAPER BOARDS PRIVATE LIMITED",
"SREE RAMADEVI MULTI SPECIALITY HOSPITAL",
"SREE RAMADEVI MULTI SUPER SPECIALITY HOSPITAL",
"SREE RAMU SPECIALITY SURFACTANTS PRIVATE LIMITED",
"SREE RANI SATI OVERSEAS PRIVATE LIMITED",
"SREE RANKA ROAD LINES PRIVATE LIMITED",
"SREE RAYALASEEMA GALAXY PROJECTS PRIVATE LIMITED",
"SREE RAYALASEEMA GREEN ENERGY PRIVATE LIMITED",
"SREE RAYALASEEMA HI-SRENGTH HYPO LIMITED",
"SREE RAYALSEEMA GREEN STELOY PRIVATE LIMITED",
"SREE RAYALSEEMA SUGAR AND ENERGY PRIVATE LIMITED",
"SREE RENGARAAJ STEEL AND ALLOYS PRIVATE LIMITED",
"SREE RENGARAJ ISPAT INDUSTRIES PRIVATE LIMITED",
"SREE SAI MITRA DRIP INDUSTRIES PRIVATE LIMITED",
"SREE SAI RAJESWARI COMPLEX",
"SREE SAI RAM ENTERPRISES",
"SREE SAI ROLLER FLOUR MILL PRIVATE LIMITED",
"SREE SAI WATER TREATMENT PRIVATE LIMITED",
"SREE SAIKRIPA CHEMISOLES PRIVATE LIMITED",
"SREE SAIPRASAD MULTI",
"SREE SAKTHI CONSTRUCTIONS AND INFRASTRUCTURE LIMITED",
"SREE SAKTHI RENEWABLE POWERS PRIVATE LIMITED",
"SREE SANKARA COLLEGE",
"SREE SANKARA UNIVERSITY OF SANSKRIT",
"SREE SANTHOSH GARMENTS",
"SREE SARADA ASHRAMA BALIKA BIDYALAYA",
"SREE SARADHAMBAL AUTOMOBILES ERODE PRIVATE LIMITED",
"SREE SARADHAMBAL AUTOMOBILES PRIVATE LIMITED",
"SREE SARASWATHI EDUCATIONAL TRUST",
"SREE SARAVANABALAJI TEXTILES PRIVATE LIMITED",
"SREE SASTHA INSTITUTE OF ENGINEERING AND TECHNOLOGY",
"SREE SATYA FASTNERS PVT LTD",
"SREE SATYA SREENIVASA RAW AND BOILED RICE MILL",
"SREE SATYANARAYANA SPINNING MILLS LIMITED",
"SREE SELLANDIAMMAN RICE MILL",
"SREE SESHACHALA BUILDERS LIMITED",
"SREE SHANMUGA MODERN RICE MILL PRIVATE LIMITED",
"SREE SHASHTI HOTELS PRIVATE LIMITED",
"SREE SHIVA SAI CAST PRIVATE LIMITED",
"SREE SHIVMAYA INDUSTRIES LLP",
"SREE SHYAM CATTLE FOOD",
"SREE SHYAM SAYI CORPORATION PRIVATE LIMITED",
"SREE SIDDHI VARAHA INFRACON PRIVATE LIMITED",
"SREE SIRISAI TRADERS PRIVATE LIMITED",
"SREE SIVA SANKAR AUTOMOBILES",
"SREE SIVANI INFRAENGINEERING INDIA PRIVATE LIMITED",
"SREE SIVANI MULTI SPECIALITY HOSPITAL & RESEARCH INSTITUTE",
"SREE SKANDHA FOOD PROCESSING INDIA PRIVATE LIMITED",
"SREE SLOKA SCHOOL",
"SREE SMLR ARADHYA FOODS PRIVATE LIMITED",
"SREE SOORYA INFRA ASSET PROJECTS PRIVATE LIMITED",
"SREE SREE GANGADHAR RICE MILL PRIVATE LIMITED",
"SREE SREE MANJUNATHA TRAVEL SOLUTIONS PRIVATE LIMITED",
"SREE SREE RAKHAHARI COLD STORAGE PRIVATE LIMITED",
"SREE SREE SITARAM COLD STORAGE PRIVATE LIMITED",
"SREE SREENIVASA TEXTILE PROCESSING PRIVATE LIMITED",
"SREE SRINIVASA REFCON PRIVATE LIMITED",
"SREE SUBHALAKSHMI SPINNING MILLS",
"SREE SUBHIKSHA HOUSING AND ENTERPRISES P LTD",
"SREE SUBRAMANIAM PROPERTIES PRIVATE LIMITED",
"SREE SUDHEER CERAMICS PRIVATE LIMITED",
"SREE SUMANGALA METALS AND INDUSTRIES PRIVATE LIMITED",
"SREE SURABHI MILK & MILK PRODUCTS",
"SREE SURYODAYA INDUSTRIES PRIVATE LIMITED",
"SREE SWARNA URBAN INFRA LLP",
"SREE SYNCHEM PRIVATE LIMITED",
"SREE TAMMINA SOFTWARE SOLUTIONS PRIVATE LIMITED",
"SREE THIRUKUMARAN AUTO PRIVATE LIMITED",
"SREE TIRUMALA STEEL ROLLING MILLS PRIVATE LIMITED",
"SREE TRAVELS AND FACILITY SOLUTION PRIVATE LIMITED",
"SREE TYCOFAB PVT LTD",
"SREE UGCL PROJECTS LIMITED",
"SREE VAARI ROOFING CO PRIVATE LIMITED",
"SREE VAIBHAVI INFRASTRUCTURES PRIVATE LIMITED",
"SREE VALLIAPPA TEXTILE PRIVATE LIMITED",
"SREE VANAMALI AGRO-FARMS PVT LTD",
"SREE VANDANA INFRA BUILD PRIVATE LIMITED",
"SREE VANI WOMEN DEGREE AND PG COLLEGE",
"SREE VARADARAJA NIDHI LIMITED",
"SREE VARAHHAS TECHNOLOGIES PRIVATE LIMITED",
"SREE VARI IRON STEELS PRIVATE LIMITED",
"SREE VARU NURSERY",
"SREE VASAA PRINTECH PRIVATE LIMITED",
"SREE VASTHU PAINTS PRIVATE LIMITED",
"SREE VEE FOODS PRIVATE LIMITED",
"SREE VEERA BHADRA SWAMY SHOPPING MALL",
"SREE VEERABRAHMENDRA SWAMY SPINNING MILLS PRIVATE LIMITED",
"SREE VEERANJANEYA MILK PRODUCTS INDIA PRIVATE LIMITED",
"SREE VEN HATCHERIES PRIVATE LIMITED",
"SREE VENKATA RAMANA CONSTRUCTION MATERIALS PRIVATE LIMITED",
"SREE VENKATA SAI INFRATECH PRIVATE LIMITED",
"SREE VENKATA SAI PACKAGING PRIVATE LIMITED",
"SREE VENKATARAYA PRINTERS & PACKERS PRIVATE LIMITED",
"SREE VENKATE3SHWARA WINERY & DISTILERY P",
"SREE VENKATESHWARA LOGISTICS INDIA LLP",
"SREE VENKATESHWARA SWITCH GEAR PRIVATE LIMITED",
"SREE VENKATESWARA COMMUNICATIONS PRIVATE LIMITED",
"SREE VENKATESWARA MOTORS INDIA PRIVATE LIMITED",
"SREE VENKATESWARA ROAD CONSTRUCTIONS PRIVATE. LIMITED.",
"SREE VENKATESWARA STRUCTURALS PRIVATE LIMITED",
"SREE VENSAI REALTORS PRIVATE LIMITED",
"SREE VIDYA BOOKS PRIVATE LIMITED",
"SREE VIDYANIKETHAN COLLEGE OF PHARMACY",
"SREE VIDYANIKETHAN EDUCATIONAL TRUST",
"SREE VIDYANIKETHAN ENGINEERING COLLEGE",
"SREE VIDYANIKETHAN INTERNATIONAL SCHOOL",
"SREE VIHAR AGRO TECH PRIVATE LIMITED",
"SREE VIMALNATH FOREX PRIVATE LIMITED",
"SREE VINAYAKA BUILDWELL PROJECTS PRIVATE LIMITED",
"SREE VINAYAKA ENTERPRISES",
"SREE VISALAM CHIT FUND LTD",
"SREE VISHNU ASSAYERS PRIVATE LIMITED",
"SREE VISHNUPRIYA MOTORS",
"SREE VISWAAS AGRO BIOTECH INDIA LIMITED",
"SREE VRINDAVAN PAINTS AND CHEMICALS PVT LTD",
"SREE VYASA N S S COLLEGE",
"SREE VYSHNAVI CLOTHING PRIVATE LIMITED",
"SREE YANAM STEELS PRIVATE LIMITED",
"SREEAADHIBRAMMAR ENTERPRISES PRIVATE LIMITED",
"SREEAKSHAY BUILDERS PRIVATE LIMITED",
"SREEALANKAR GOLD HUB PRIVATE LIMITED",
"SREEB TECHNOLOGIES PRIVATE LIMITED",
"SREECHAND SPECIALITY HOSPITALS PRIVATE LIMITED",
"SREECHEM RESINS LIMITED",
"SREEDEEP REALTY PRIVATE LIMITED",
"SREEDEVI POWDER COATING PRIVATE LIMITED",
"SREEDEVI WIND FARM INDIA PRIVATE LIMITED",
"SREEDHANYA CONSTRUCTIONS PRIVATE LIMITED",
"SREEDHANYA HOMES PRIVATE LIMITED",
"SREEDHARA TEXTILES PRIVATE LIMITED",
"SREEDHARAN AND COMPANY PVT LTD",
"SREEDHAREEYAM AYURVEDIC EYE CLINICS AND PANCHAKARMA CENTRE PRIVATE LIMITED",
"SREEDHAREEYAM AYURVEDIC EYE HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED",
"SREEDHAREEYAM FARMHERBS INDIA PRIVATE LIMITED",
"SREEE NAVNNET GAS AGENSIES",
"SREEGHAN HOTELS & RESORTS LLP",
"SREEGURU SALES PRIVATE LIMITED",
"SREEHITHA CONSTRUCTIONS PRIVATE LIMITED",
"SREEHITHA REFINERIES PRIVATE LIMITED",
"SREEJA CONSTRUCTIONS PRIVATE LIMITED",
"SREEJA HOSIERIES PRIVATE LIMITED",
"SREEJA LUBRICANTS PRIVATE LIMITED",
"SREEJANANI GREEN CEMENTS PRIVATE LIMITED",
"SREEJANANI INFRACON PRIVATE LIMITED",
"SREEJI COASTAL SHIPPING PRIVATE LIMITED",
"SREEJIT AUTOMOTIVE PRIVATE LIMITED",
"SREEKANTESHWARA CONSTRUCTIONS PRIVATE LIMITED",
"SREEKANTH PIPES PRIVATE LIMITED (PART IX).",
"SREEKANYA DEVALLU AND SONS HOTELS PRIVATE LIMITED",
"SREEKARA ORGANICS",
"SREEKARA TEXTILES PRIVATE LIMITED",
"SREEKARS VISIONS PRIVATE LIMITED",
"SREEKOVIL BLUE METALS AND BLOCKS PRIVATE LIMITED",
"SREEKRISHNA DISTRIBUTORS PRIVATE LIMITED",
"SREEKUMAR & ABILASH HEALTH CARE PRIVATE LIMITED",
"SREELA & SUNDARAN HEALTHCARE PRIVATE LIMITED",
"SREELAKSHMI AUTOMOTIVE SERVICES INDIA PRIVATE LIMITED",
"SREELAKSHMI STOCKISTS AND APPLIANCES PRIVATE LIMITED",
"SREELEATHERS LIMITED",
"SREELEKSHMI CASHEW COMPANY",
"SREELN MOTORS PRIVATE LIMITED",
"SREEMA FASHION KNITTING & DYEING INDIA LIMITED",
"SREEMA FILAMENTS PRIVATE LIMITED",
"SREEMA MAHILA SAMITY",
"SREEMA RICE MILL PRIVATE LIMITED",
"SREEMAAN PALANI PRABHAKARAN AGRO PRODUCTS PRIVATE LIMITED",
"SREEMEDHAS SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"SREENAGAR COLD STORAGE PVT LTD",
"SREENARAYANA VOCATIONAL TEACH TRNG INSTT",
"SREENATH ENGG. SALES AND SERVICE PRIVATE LIMITED",
"SREENETHRA EYE CARE PRIVATE LIMITED",
"SREENI LABS PRIVATE LIMITED",
"SREENIDHI ESTATES INDIA PRIVATE LIMITED",
"SREENIDHI GLOBAL OLYMPIAD EDUCATIONAL SOCIETY",
"SREENIDHI INFRA PRIVATE LIMITED",
"SREENIDHI INFRA PROJECTS",
"SREENIDHI INSTITUTE OF SCIENCE AND TECHNOLOGY",
"SREENIDHI INTERNATIONAL PRIVATE LIMITED",
"SREENIDHI INTERNATIONAL SCHOOL",
"SREENIDHI IT SPACES PRIVATE LIMITED",
"SREENIDHI OLYMPIAD EDUCATIONAL SOCIETY",
"SREENIDHI RAJA PACKING SOLUTIONS PRIVATE LIMITED",
"SREENIDHI SPINTEX PRIVATE LIMITED",
"SREENIDHI TOWERS PRIVATE LIMITED",
"SREENIKETANA CARRIERS PRIVATE LIMITED",
"SREENIKETANA LOGISTICS LIMITED",
"SREENIVAS BUILDTECH INDIA PRIVATE LIMITED",
"SREENIVAS LEATHERS PRIVATE LIMITED",
"SREENIVASA BALAJI PAPERS PRIVATE LIMITED",
"SREENIVASA BRAHMINS BAKERY PRIVATE LIMITED",
"SREENIVASA INDUSTRIES",
"SREENIVASA INSTITUTE OF TECHNOLOGY AND MANAGEMENT STUDIES",
"SREEPA PROPERTIES PRIVATE LIMITED",
"SREEPAADA DEGREE COLLEGE",
"SREEPARNA PHARMACEUTICAL DISTRIBUTORS PRIVATE LIMITED",
"SREEPATHI LAB PRIVATE LIMITED",
"SREEPATHI PHARMACEUTICALS LIMITED",
"SREEPRIYA EXPORTS PRIVATE LIMITED",
"SREERAGAM EXPORTS PRIVATE LIMITED",
"SREERAGH GENERAL FINANCE LTD",
"SREERAM IRON WORKS PVT LTD",
"SREERAM SMELTERS PRIVATE LIMITED",
"SREERAM SPHEROIDS AND GRAPHITES PRIVATE LIMITED",
"SREERAMA SCAFFOLDINGS PRIVATE LIMITED",
"SREEROSH DEVELOPERS PRIVATE LIMITED",
"SREERS TRADING PRIVATE LIMITED",
"SREESAILA NETWORKS PRIVATE LIMITED",
"SREESAMRUDHH PROJECTS PRIVATE LIMITED",
"SREESOLDER MANUFACTURING COMPANY PRIVATE LIMITED",
"SREESTI STEEL PRIVATE LIMITED",
"SREETRANS LOGISTICS (INDIA) PRIVATE LIMITED",
"SREEVAAS ROOFING PRIVATE LIMITED",
"SREEVALSAM HOTELS AND RESORTS PRIVATE LIMITED",
"SREEVASA SPINNERS PRIVATE LIMITED",
"SREEVATSA REAL ESTATES PRIVATE LIMITED",
"SREEVATSA STANILESS STEEL FABRICATORS PRIVATE LIMITED",
"SREEVATSA TUBES PRIVATE LIMITED",
"SREEVEERA SHIPPING PRIVATE LIMITED",
"SREEVEN BUILDCON PRIVATE LIMITED",
"SREEVEN PHARMA PRIVATE LIMITED",
"SREI INFRASTRUCTURE FINANCE LIMITED.",
"SREI INSURANCE BROKING PRIVATE LIMITED",
"SREMON CONSTRUCTION PVT LTD",
"SREO CGC FOR SC/ST SURAT",
"SRESHTA HOSPITALITY PRIVATE LIMITED",
"SRESHTA LEISURE PRIVATE LIMITED",
"SRESHTA SUMANTH BUILDERS PRIVATE LIMITED",
"SRESTA INFRA AND SERVICES PRIVATE LIMITED",
"SRESTA NATURAL BIOPRODUCTS PRIVATE LIMITED",
"SRESTH PRODUCTS PVT LTD",
"SRESTHA FINVEST LIMITED",
"SREVEE EDIBLE OILS PRIVATE LIMITED",
"SREX POWER INDIA PRIVATE LIMITED",
"SREYANS MARINE EXPORTS PRIVATE LIMITED",
"SREYAS HOLISTIC REMEDIES PRIVATE LIMITED",
"SREYAS INSTITUTE OF ENGINEERING AND TECHNOLOGY",
"SREYES SYNTANS PRIVATE LIMITED",
"SRF DETECTIVE & SECURITY SERVICES PRIVATE LIMITED",
"SRF LIMITED",
"SRF POLYMERS LIMITED",
"SRF TRANSNATIONAL HOLDINGS LIMITED",
"SRFB TRADERS PRIVATE LIMITED",
"SRFI PULSES PRIVATE LIMITED",
"SRG ALUMINIUM PRIVATE LIMITED",
"SRG APPARELS LIMITED",
"SRG CLOTHINGS PRIVATE LIMITED",
"SRG DISTRIBUTORS PRIVATE LIMITED",
"SRG EARTH RESOURCES PRIVATE LIMITED",
"SRG EXIM PRIVATE LIMITED",
"SRG GLOBAL CAPITAL PRIVATE LIMITED",
"SRG HOUSING FINANCE LIMITED",
"SRG INDUSTRIES PRIVATE LIMITED",
"SRG INSURANCE BROKERS PRIVATE LIMITED",
"SRG INTERNATIONAL PRIVATE LIMITED",
"SRG IRON & STEEL PRIVATE LIMITED",
"SRG MACHINES PRIVATE LIMITED",
"SRG MANAGEMENT SERVICES PRIVATE LIMITED",
"SRG METALCRAFTS (INDIA) PRIVATE LIMITED",
"SRG NUTRITION PRIVATE LIMITED",
"SRG SPINNING AND WEAVING MILLS PRIVATE LIMITED",
"SRG TECHNO PRIVATE LIMITED",
"SRG TRADERS PRIVATE LIMITED",
"SRGG RETAILS PRIVATE LIMITED",
"SRGP CORPORATION LIMITED",
"SRH CORAL CAPITAL PRIVATE LIMITED",
"SRH FOOD INDUSTRIES PRIVATE LIMITED",
"SRH MOTORS PRIVATE LIMITED",
"SRHK PROPERTIES PRIVATE LIMITED",
"SRHK TRANSPORT PRIVATE LIMITED",
"SRI AADARSH JUNIOR COLLEGE",
"SRI AADHAVA ENGINEERING PRIVATE LIMITED",
"SRI AARADHYA INTERIORS INDIA PRIVATE LIMITED",
"SRI AARAVIKA MOTORS PRIVATE LIMITED",
"SRI AARVEE HOTELS PRIVATE LIMITED",
"SRI ABHIDA BALAJI EDUCATIONAL SERVICES PRIVATE LIMITED",
"SRI ABHINANDANA HOMES PRIVATE LIMITED",
"SRI ABHISEK TEXTILES MILLS PRIVATE LIMITED",
"SRI ACHYUTA EDUCATIONAL SOCIETY",
"SRI ADARSHA COLLEGE OF NURSING",
"SRI ADHIKARI BROTHERS DIGITAL NETWORK PRIVATE LIMITED",
"SRI ADICHUNCHANAGIRI INDEPENDENT PU COLLEGE",
"SRI ADILAKSHMI PROPERTY DEVELOPERS PRIVATE LIMITED",
"SRI ADISHANKARACHARYA COTTON & OIL MILLS PRIVATE LIMITED",
"SRI ADITYA HOMES PRIVATE LIMITED",
"SRI ADITYA LOGISTICS PRIVATE LIMITED",
"SRI ADITYA POLYFILMS PRIVATE LIMITED",
"SRI AGARWAL ISPAT",
"SRI AISHWARYA REFINERY PRIVATE LIMITED",
"SRI AKILAA SPINNING MILLS PRIVATE LIMITED",
"SRI AKSHADA AIRCON SYSTEMS PRIVATE LIMITED",
"SRI ALAMELU AMMAL MILLS INDIA PRIVATE LIMITED",
"SRI AMARNATH FINANCE LIMITED",
"SRI AMBAL PROMOTERS PRIVATE LIMITED",
"SRI AMBIKA RICE MILL",
"SRI AMBIKA SOLVEX LIMITED",
"SRI AMMA INDUSTRIAL DEVELOPERS PRIVATE LIMITED",
"SRI AMMAN CARS INDIA PRIVATE LIMITED",
"SRI AMOGHA EDUCATIONAL SOCIETY",
"SRI AMRUTHALINGESWARA WAREHOUSING LLP",
"SRI ANAGHA MOTORS PRIVATE LIMITED",
"SRI ANAGHA REFINERIES PRIVATE LIMITED",
"SRI ANANDA LAKSHMI NARASIMHA INDUSTRIES INDIA PRIVATE LIMITED",
"SRI ANANDA TEERTHA AROMATICS PRIVATE LIMITED",
"SRI ANANTH MARUTHI PRIVATE LIMITED",
"SRI ANANTHA LAKSHMI SPINNING MILLS PRIVATE LIMITED",
"SRI ANANTHA PADMANABHA SWAMY PHARMA PRIVATE LIMITED",
"SRI ANANTHESHWARA FOODS PRIVATE LIMITED",
"SRI ANDAL ALAGAR CEMENT PRIVATE LIMITED",
"SRI ANDAL PAPER AND BOARDS PRIVATE LIMITED",
"SRI ANDAL PAPER MILLS PRIVATE LIMITED",
"SRI ANDAL PAPER MILLS UNIT II PRIVATE LIMITED",
"SRI ANEKA PROPERTIES PRIVATE LIMITED",
"SRI ANJANEYA AGRO-TECH PRIVATE LIMITED",
"SRI ANJANEYA CARTONS PRIVATE LIMITED",
"SRI ANJANEYA CONTAINER TRANSPORTS PRIVATE LIMITED",
"SRI ANJANEYA POLYMERS INDIA PRIVATE LIMITED",
"SRI ANN CONSTRUCTIONS",
"SRI ANNAI KAMAKSHI MUSIC AND FINE ARTS COLLEGE",
"SRI ANNAPURNA (AP) DRUGS PRIVATE LIMITED",
"SRI ANNAPURNA AGRO INDUSTRIES",
"SRI ANNAPURNA COTTON MILLS & INDUSTRIES LTD",
"SRI ANNAPURNA PADDY MILLERS PVT LTD",
"SRI ANNUR ANNAMALAIAR TEXTILE MILLS PRIVATE LIMITED",
"SRI ANU HOSPITALS LIMITED",
"SRI ANUSHAM RUBBER INDUSTRIES PRIVATE LIMITED",
"SRI AROGYA HOSPITAL",
"SRI ARUL MURUGAN TEXTILES PRIVATE LIMITED",
"SRI ARUMUGA WAREHOUSING PRIVATE LIMITED",
"SRI ARUMUGAM FIREWORKS PRIVATE LIMITED",
"SRI ARUNA AUTO SERVICE LIMITED",
"SRI ARUNAI CHITS NAMAKKAL PRIVATE LIMITED",
"SRI ASHWATTA NARAYANA MINERALS INDIA PRIVATE LIMITED",
"SRI ASL FINVEST PRIVATE LIMITED",
"SRI ATCHAYA ENGINEERING PRIVATE LIMITED",
"SRI AURBINDO FUELS LIMITED",
"SRI AUROBINDO CENTRE OF NEW EDUCATION",
"SRI AUROBINDO INSTITUTE OF EDUCATION",
"SRI AUROBINDO INSTITUTE OF MEDICAL SCIENCES",
"SRI AUROBINDO MIRA MATRICULATION HIGHER SECONDARY SCHOOL",
"SRI AUROBINDO MIRA UNIVERSAL SCHOOL",
"SRI AUROBINDO PACKAGERS PRIVATE LIMITED",
"SRI AUROBINDO SCHOOL OF INTEGRAL EDUCATION",
"SRI AUROBINDO SCIENCE HIGHER SECONDARY SCHOOL",
"SRI AUROBINDO SOCIETY RUPANTAR",
"SRI AVANTIKA CONTRACTORS (I) LIMITED",
"SRI AVANTIKA CONTRACTORS I LIMITED",
"SRI AVANTIKA POWER PROJECTS PRIVATE LIMITED",
"SRI AYYAPPA RICE INDUSTRIES",
"SRI B L C PVT LTD",
"SRI BABY TEXTILES PRIVATE LIMITED",
"SRI BAL FAB TECH PRIVATE LIMITED",
"SRI BALA MEDICAL CENTRE AND HOSPITALS PRIVATE. LIMITED",
"SRI BALA TRIPURA SUNDARI HEALTH CARE PRIVATE LIMITED",
"SRI BALAGOPAL ENTERPRISES PRIVATE LIMITED",
"SRI BALAGOPALAN JEWELLERY MART PRIVATE LIMITED",
"SRI BALAHA CHEMICALS PRIVATE LIMITED",
"SRI BALAJEE AGRO FOODS PRIVATE LIMITED",
"SRI BALAJI ACTION MEDICAL INSTITUTE",
"SRI BALAJI AGENCIES",
"SRI BALAJI AGRI CHEM (INDIA) PRIVATE LIMITED",
"SRI BALAJI AGRO INDUSTRIES",
"SRI BALAJI AQUA TRADING PRIVATE LIMITED",
"SRI BALAJI ASSEMBLIES & PLASTICS PRIVATE LIMITED",
"SRI BALAJI CASTINGS PRIVATE LIMITED",
"SRI BALAJI COLLEGE OF ENGINEERING AND TECHNOLOGY",
"SRI BALAJI DENTAL COLLEGE HOSPITAL",
"SRI BALAJI FASHIONS PRIVATE LIMITED",
"SRI BALAJI FORGINGS PRIVATE LIMITED",
"SRI BALAJI KNITWEAR PRIVATE LIMITED",
"SRI BALAJI LOGISTICS SOLUTIONS (INDIA) PRIVATE LIMITED",
"SRI BALAJI MAX MAIL PRIVATE LIMITED",
"SRI BALAJI MEDICAL COLLEGE",
"SRI BALAJI MEDICAL COLLEGE & HOSPITAL",
"SRI BALAJI METALLICS PRIVATE LIMITED",
"SRI BALAJI METALS AND MINERALS PRIVATE LIMITED",
"SRI BALAJI MOTOCORPS PRIVATE LIMITED",
"SRI BALAJI PREFORMS",
"SRI BALAJI RETREADING PRIVATE LIMITED",
"SRI BALAJI RICE MILLS PVT.LTD.",
"SRI BALAJI SURVEILLANCE SOLUTIONS PRIVATE LIMITED",
"SRI BALAJI TOLLWAYS (MADURAI) PRIVATE LIMITED",
"SRI BALAJI TRADERS",
"SRI BALAJI UNIVERSITY",
"SRI BALAKUMARAN COTTON MILLS PRIVATE LIMITED",
"SRI BALAMBIKA TEXTILE MILLS PRIVATE LIMITED",
"SRI BALAMURUGAN ENGINEERING WORKS PRIVATE LIMITED",
"SRI BALAMURUGAN INDUSTRIES PRIVATE LIMITED",
"SRI BALAMURUGAN TEXTILE PROCESSING LIMITED",
"SRI BALMUKUND POLYPACK PRIVATE LIMITED",
"SRI BANSI BEHARIJI TEA INDUSTRIES PRIVATE LIMITED",
"SRI BANWARI FABRICS PRIVATE LIMITED",
"SRI BAPUJI CONSTRUCTIONS PRIVATE LIMITED",
"SRI BASARA JUNIOR COLLEGE",
"SRI BASAVESHWARA SCIENCE & COMMERCE P U COLLEGE",
"SRI BELESWAR GOPINATH HIGHER SECONDARY SCHOOL",
"SRI BENGAL TEA CHEST FITTINGS MFG PVT LTD",
"SRI BHAGAVATHI CO OPERATIVE BANK LTD",
"SRI BHAGAVATHY TRADERS",
"SRI BHAGAVATI FACILITIES PRIVATE LIMITED",
"SRI BHAGAWAN TIMBERS",
"SRI BHAGIRATH TEXTILES LIMITED.",
"SRI BHAGWAN JAIN MAHAVEER JAIN COLLEGE",
"SRI BHAGWAN MAHAVIR JAIN EDUCATIONAL AND CULTURAL TRUST",
"SRI BHAGYALAKSHMI AGRO FOODS PRIVATE LIMITED",
"SRI BHAGYALAKSHMI COTEX PRIVATE LIMITED",
"SRI BHARANI MOTORS PRIVATE LIMITED",
"SRI BHARATHI ROOFING INDUSTRIES PRIVATE LIMITED",
"SRI BHARATHIDASAN MATRICULATION HR SEC SCHOOL",
"SRI BHARATHIDASAN MATRICULATION SCHOOL",
"SRI BHARGAVI AMMONIA & CHEMICALS PRIVATE LIMITED",
"SRI BHAVANI CASTINGS LIMITED",
"SRI BHAVANI CERAMIC PRIVATE LIMITED",
"SRI BHAVANI JEWELS & GEMS INDIA PRIVATE LIMITED",
"SRI BHAVANI SAW MILLS",
"SRI BHAVISHYA EDUCATIONAL ACADEMY",
"SRI BHAVISHYA EDUCATIONAL SOCIETY",
"SRI BHOOMIDURGA ENTERPRISES PRIVATE LIMITED",
"SRI BHRAMARA TOWNSHIPS PRIVATE LIMITED",
"SRI BHRAMARI COLD STORAGE PRIVATE LIMITED",
"SRI BHUVANESWARI SECURITY SERVICES PRIVATE LIMITED",
"SRI BIHARIRAJ TRADERS PRIVATE LIMITED",
"SRI BINNY INDUSTRIES PRIVATE LIMITED",
"SRI BIOAESTHETICS PRIVATE LIMITED",
"SRI BUDDHA ENGINEERING AND CONSTRUCTIONS PRIVATE LIMITED",
"SRI BUTCHI INDUSTRIES PRIVATE LIMITED",
"SRI CHAITANYA CHILDREN'S ACADEMY",
"SRI CHAITANYA CRAFT PRIVATE LIMITED",
"SRI CHAITANYA DEGREE COLLEGE",
"SRI CHAITANYA EDUCATIONAL COMMITTEE",
"SRI CHAITANYA GLOBAL SCHOOL",
"SRI CHAITANYA JUNIOR COLLEGE",
"SRI CHAITANYA PU COLLEGE",
"SRI CHAITANYA RICE MILL",
"SRI CHAITANYA SCHOOL",
"SRI CHAITANYA SEVA TRUST",
"SRI CHAITANYA TECHNO SCHOOL",
"SRI CHAKRA AUTOMOTIVES PRIVATE LIMITED",
"SRI CHAKRA BEARING PRODUCTS PRIVATE LIMITED",
"SRI CHAKRA CEMENT LIMITED",
"SRI CHAKRA CONTAINERS PRIVATE LIMITED",
"SRI CHAKRA HOSPITALS PRIVATE LIMITED",
"SRI CHAKRA MULTISPECIALITY HOSPITAL",
"SRI CHAKRA OILS & EXTRACTION PRIVATE LIMITED",
"SRI CHAKRA POLY PLAST INDIA PRIVATE LIMITED",
"SRI CHAKRA SCANS PRIVATE LIMITED",
"SRI CHAKRADHAR ENGINEERING PRIVATE LIMITED",
"SRI CHAMUNDESWARI SUGARS LIMITED.",
"SRI CHAMUNDI JEWELS PRIVATE LIMITED",
"SRI CHAND PLYWOOD INDUSTRIES PRIVATE LIMITED",
"SRI CHANDRA JUNIOR & DEGREE COLLEGE",
"SRI CHANDRA SEKARA HOSPITALS PRIVATE LIMITED",
"SRI CHANUKYA CARAMEL PRIVATE LIMITED",
"SRI CHARITHA DEVELOPERS",
"SRI CHIMA CARS PRIVATE LIMITED",
"SRI CHIMA NOTE BOOK PRIVATE LIMITED",
"SRI CHOWDESHWARI CONCRETE INDIA PRIVATE LIMITED",
"SRI CITY PRIVATE LIMITED",
"SRI DANDESWAR RICE MILL PRIVATE LIMITED",
"SRI DAS HANUMAN GRANITES PRIVATE LIMITED",
"SRI DATTA LOGISTICS PRIVATE LIMITED",
"SRI DAUJI MISTHAN BHANDAR PRIVATE LIMITED",
"SRI DESIKANATHAR TEXTILES PRIVATE LIMITED",
"SRI DEVARAJ URS ACADEMY OF HIGHER EDUCATION & RESEARCH",
"SRI DEVARAJ URS MEDICAL COLLEGE/SRI DEVA",
"SRI DEVI ASSOCIATES INDIA PRIVATE LIMITED",
"SRI DEVI CINEMAS PRIVATE LIMITED",
"SRI DEVI DISTRIBUTORS PRIVATE LIMITED",
"SRI DEVI HOSPITAL FOUNDATION PRIVATE LIMITED",
"SRI DEVI TOOL ENGINEERS PRIVATE LIMITED",
"SRI DHANAKUBERA CHIT PRIVATE LIMITED",
"SRI DHANALAKSHMI AUTOMOBILES PRIVATE LIMITED",
"SRI DHANALAKSHMI COTTON & RICE MILLS PRIVATE LIMITED",
"SRI DHANALAXMI RICE MILLS PRIVATE LIMITED",
"SRI DHANDAYUTHAPANI SPINNERS PRIVATE LIMITED",
"SRI DHARAM BHAGWATI IRON PRIVATE LIMITED",
"SRI DHARMA SPINNERS PRIVATE LIMITED",
"SRI DHARMASTHALA SIRI GRAMODYOGA SAMSTHE",
"SRI DHATRI INFRATECH INDIA PRIVATE LIMITED",
"SRI DHAYANANDAPURI MODEL PUBLIC SCHOOL",
"SRI DHIRENDRA NATH DUTTA GOLD PRIVATE LIMITED",
"SRI DHIRENDRANATH DUTTA JEWELLERS PRIVATE LIMITED",
"SRI DIVYA CHAITANYA MATRICULATION SCHOOL",
"SRI DURAIAPPA AGENCY",
"SRI DURGA CONSULTANCY PRIVATE LIMITED",
"SRI DURGA DEVI PROPERTY MANAGEMENT PRIVATE LIMITED",
"SRI DURGA ENGINEERING WORKS PRIVATE LIMITED",
"SRI DURGA FOOD PRODUCTS PVT LTD",
"SRI DURGA MALLESWARA SWAMY DEVASTANAM TRUST",
"SRI DURGA MARUTHI AUTOMOTIVES PRIVATE LIMITED",
"SRI DURGA PUSTAK BHANDAR PRIVATE LIMITED",
"SRI DURGAMBA TRANSIT PRIVATE LIMITED",
"SRI DURGAMBA TRANSWAY PRIVATE LIMITED",
"SRI DWARAKA SAI CONSTRUCTION (INDIA) PRIVATE LIMITED",
"SRI DWARIKA DHEESH POLYMERS PRIVATE LIMITED",
"SRI EDUCATIONAL SOCIETY",
"SRI ELUMALAI INSULATION PRIVATE LIMITED",
"SRI ENERGY VALVES PRIVATE LIMITED",
"SRI ENIYA HOSPITAL",
"SRI ESHWAR COLLEGE OF ENGINEERING",
"SRI ESHWARA RICE MILLS PRIVATE LIMITED",
"SRI ESWARI AUTO COMPONENTS PRIVATE LIMITED",
"SRI FAMILY BIZNET PRIVATE LIMITED",
"SRI FURN IMPEX PRIVATE LIMITED",
"SRI GABA SANITARY AND TILES PRIVATE LIMITED",
"SRI GAJALAKSHMI COTSPIN INDIA PRIVATE LIMITED",
"SRI GAJANAN E-SLATES PRIVATE LIMITED",
"SRI GAJENDIRA PAPER AND BOARDS PRIVATE LIMITED",
"SRI GAJPATI FOODS PRIVATE LIMITED",
"SRI GANAPATHY AGENCY",
"SRI GANAPATHY INFRASTRUCTURE PRIVATE LIMITED",
"SRI GANAPATHY SILKS SANKARAN KOIL",
"SRI GANAPATI PROPERTY DEVELOPERS LIMITED",
"SRI GANESH AUTOMOTIVE IMPEX PRIVATE LIMITED",
"SRI GANESH COLLEGE OF ENGINEERING AND TECHNOLOGY",
"SRI GANESH ENTERPRISES",
"SRI GANESH EXIME",
"SRI GANESH OXY-ACETYLENE PRIVATE LIMITED",
"SRI GANESH POULTRY FARMS PRIVATE LIMITED",
"SRI GANESH SILK FASHIONS PRIVATE LIMITED",
"SRI GANESH WOOD PACKING PRIVATE LIMITED",
"SRI GANGA KUNTI PRIVATE LIMITED",
"SRI GANPATI LABOUR AND SECURITY SERVICE PRIVATE LIMITED",
"SRI GAURISHANKAR AGRO INPUTS PRIVATE LIMITED",
"SRI GAYATHRI DRUGS PRIVATE LIMITED",
"SRI GAYATHRI MODERN RAW AND BOILED RICE MILLS PVT.LTD.",
"SRI GAYATHRI TRAVELS PRIVATE LIMITED",
"SRI GAYATHRI VIDYA MANDHIR ENGLISH MEDIUN SCHOOL",
"SRI GAYATHRI WOMEN & CHILD CARE HOSPITALS PRIVATE LIMITED",
"SRI GAYATRI EDIBLE OILS PRIVATE LIMITED",
"SRI GAYATRI EDUCATIONAL SOCIETY",
"SRI GEE ARR SPINNERS PRIVATE LIMITED",
"SRI GITA TEXTURISERS",
"SRI GNANAVEL SPINNING MILLS PRIVATE LIMITED",
"SRI GOBINDA TECHNOLOGIES PRIVATE LIMITED",
"SRI GOKUL KANNAN MODERN RICE MILL",
"SRI GOKUL MOTORS",
"SRI GOMATHI SANKAR CONSTRUCTIONS PRIVATE LIMITED",
"SRI GOMATHY MILLS PRIVATE LIMITED",
"SRI GOMUKI TEX CHEM PRIVATE LIMITED",
"SRI GOPAL AUTOMOBILES",
"SRI GOPAL AUTOMOTIVE LIMITED",
"SRI GOPAL FIBRES PVT LTD",
"SRI GOPAL INVESTMENTS VENTURES LIMITED",
"SRI GOPAL KRISHNA LABS PRIVATE LIMITED",
"SRI GOPAL SATYANARAYAN TEX PRIVATE LIMITED",
"SRI GOPIKRISHNA INFRASTRUCTURE PRIVATE. LIMITED.",
"SRI GORANI PACKAGING PRIVATE LIMITED",
"SRI GOVIND FLOUR MILLS PRIVATE LIMITED",
"SRI GOWMARIAMMAN FOOD PRIVATE LIMITED",
"SRI GOWRISH CNC PRIVATE LIMITED",
"SRI GOWTHAM ACADEMY OF GENERAL AND TECHNICAL EDUCATION",
"SRI GREEN ASSETS YESHWANTHPUR PRIVATE LIMITED",
"SRI GREEN LANDSCAPE INDIA PRIVATE LIMITED",
"SRI GURU ARJAN DEV SECONDARY SCHOOL",
"SRI GURU EXTRACTIONS PRIVATE LIMITED",
"SRI GURU GOVIND SINGH COLLEGE",
"SRI GURU HARKRISHAN SAHIB C EYE INSTITUTE AND SUPER SPECIALITY HOSPITAL",
"SRI GURU HARKRISHAN SR SEC PUBLIC SCHOOL",
"SRI GURU JEWELS PRIVATE LIMITED",
"SRI GURU NANAK DEV KHALSA COLLEGE",
"SRI GURU PU COLLEGE HOSPET",
"SRI GURU RAGHAVENDRA FOODS PRIVATE LIMITED",
"SRI GURU RAGHAVENDRA INDUSTRIES",
"SRI GURU RAGHAVENDRA SAHAKARA BANK",
"SRI GURU RAGHAVENDRA VIDYANIKETAN ENGLISH MEDIUM SCHOOL",
"SRI GURU RAM DASS CHARITABLE HOSPITAL",
"SRI GURU RAM DASS INTERNATIONAL PRIVATE LIMITED",
"SRI GURU SAI RICE INDUSTRIES",
"SRI GURUDATHA EXPORTS PRIVATE LIMITED",
"SRI GURUDEVA INDUSTRIES",
"SRI GURUHARKRISHAN PUBLIC SCHOOL",
"SRI GURUKRUPA TECHNO VENTURES PRIVATE LIMITED",
"SRI GURUVAYURAPPAN AUTOMOBILE PRIVATE LIMITED",
"SRI HAAS LIFE SCIENCES PRIVATE LIMITED",
"SRI HANS ENERGY SYSTEMS PVT LTD",
"SRI HANS MARKETING PRIVATE LIMITED",
"SRI HANUMA ENTERPRISES",
"SRI HARDEV STEELS PRIVATE LIMITED",
"SRI HARI HAR OVERSEAS PRIVATE. LIMITED.",
"SRI HARI OM KRAFT PAPER PRIVATE LIMITED",
"SRI HARI OM LOGISTICS PRIVATE LIMITED",
"SRI HARI PACKAGING INDUSTRIES PRIVATE LIMITED",
"SRI HARI PRASATH TEXTILES PRIVATE LIMITED",
"SRI HARI VENKATESWARA PAPER MILLS PRIVATE LIMITED",
"SRI HARIHAR HOSPITALS PRIVATE LIMITED",
"SRI HARIPRIYA HOTELS PRIVATE LIMITED",
"SRI HARSHA CONCRETE PROJECTS (INDIA) PRIVATE LIMITED",
"SRI HARSHA CONSULTING ENGINEERS PRIVATE LIMITED",
"SRI HARSHA MOTORS PRIVATE LIMITED",
"SRI HARSHA TRUCKING PRIVATE LIMITED",
"SRI HAVISHA HOSPITALITY AND INFRASTRUCTURE LIMITED",
"SRI HIMAGHNA CONSTRUCTIONS PRIVATE LIMITED",
"SRI HIMAGHNA INFRASTRUCTURE PRIVATE LIMITED",
"SRI HM TEXTILES PRIVATE LIMITED",
"SRI INDRA SOLVENT OILS PRIVATE LIMITED",
"SRI INDU COLLEGE OF ENGINEERING AND TECHNOLOGY",
"SRI INDU INSTITUTE OF PHARMACY",
"SRI INFOTECH",
"SRI INVESTMENT & FINANCE PRIVATE LIMITED",
"SRI J RAMAIAH ROLLER FLOUR MILLS PRIVATE LIMITED",
"SRI JAGAN MEDICALS PRIVATE LIMITED",
"SRI JAGANNATH CASHEW CLUSTER PRIVATE LIMITED",
"SRI JAGANNATH COMBINE COKE PRIVATE LIMITED",
"SRI JAGANNATH CONSTRUCTION PRIVATE LIMITED",
"SRI JAGANNATH PROMOTERS AND BUILDERS PRIVATE LIMITED",
"SRI JAGANNATH WATER PUMPS PRIVATE LIMITED",
"SRI JAGANNATHA SPINNERS PRIVATE LIMITED",
"SRI JAGATHSWAPNA REALTORS PRIVATE LIMITED",
"SRI JAGDAMBA TREXIM PRIVATE LIMITED",
"SRI JAI ANUMAN SILK MILLS INDIA PRIVATE LIMITED",
"SRI JAIBALAJEE AGRO PRODUCTS PRIVATE LIMITED",
"SRI JAIBALAJI STEEL ROLLING MILLS PRIVATE LIMITED",
"SRI JAIBALAJI WIND ENERGY PRIVATE LIMITED",
"SRI JANKI LIFESTYLE PRIVATE LIMITED",
"SRI JANU TEXTILES PRIVATE LIMITED",
"SRI JAYA EDUCATION INSTITUTION",
"SRI JAYA JOTHI TEXTILE MILLS P LTD",
"SRI JAYA MAARUTHI YARN (INDIAA) PRIVATE LIMITED",
"SRI JAYA PARA-MEDICAL EDUCATION INSTITUT",
"SRI JAYA SAKTHI EDIBILE OILS PRIVATE LIMITED",
"SRI JAYABALAJI SPINNERS PRIVATE LIMITED",
"SRI JAYADEV COLLEGE OF SCIENCE & TECHNOL",
"SRI JAYADEVA INSTITUTE OF CARDIOVASCULAR SCIENCES AND RESEARCH",
"SRI JAYAHARI TEX TRADING PRIVATE LIMITED",
"SRI JAYAJOTHI & COMPANY PRIVATE LIMITED",
"SRI JAYAJOTHI POWER MANAGEMENT COMPANY PRIVATE LIMITED",
"SRI JAYALAKSHMI SPINNING MILLS LIMITED",
"SRI JAYALAKSHMI TRADING PRIVATE LIMITED",
"SRI JAYAMALAR SPINNING MILLS PRIVATE LIMITED",
"SRI JAYARAMA AUTOMOTIVES PRIVATE LIMITED",
"SRI JAYARAMA MOTORS PRIVATE LIMITED",
"SRI JETHUJI AGRO INDUSTRIES PRIVATE LIMITED",
"SRI JEYA PRABHA JEWELLERS PRIVATE LIMITED",
"SRI JIWAN BUILDERS PRIVATE LIMITED",
"SRI JYOTHI COTTON GINNERS",
"SRI JYOTHILAKSHMI AUTOMOTIVES PRIVATE LIMITED",
"SRI JYOTI STEELS (INDIA) PRIVATE LIMITED",
"SRI KAKATIYA INDUSTRIES (INDIA) PRIVATE LIMITED",
"SRI KAKATIYA SHELTERS PRIVATE LIMITED",
"SRI KALAHASTEESWARA SWAMI VARI DEVASTANAM SRIKALAHASTI",
"SRI KALI PARAMESHWARI CO-OP SOCIETY LTD",
"SRI KALIKAMBAL SHIPPING PRIVATE LIMITED",
"SRI KALISWARI FIREWORKS PRIVATE LIMITED",
"SRI KALISWARI METAL POWDERS PRIVATE LIMITED",
"SRI KALISWARI STEEL PRIVATE LIMITED",
"SRI KALPATRU REALTY PRIVATE LIMITED",
"SRI KALYAN EXPORT PRIVATE LIMITED",
"SRI KALYANA CHAKRAVARTHI MEMORIAL EDUCATIONAL TRUST",
"SRI KALYANA CHAKRAVARTHI RICE MILL",
"SRI KALYANI EDUCATIONAL SOCIETY",
"SRI KAMAKHYA AQUA PRIVATE LIMITED",
"SRI KAMAKSHI LOGISTICS PRIVATE LIMITED",
"SRI KAMAKSHI WIND POWER PRIVATE LIMITED",
"SRI KAMAKSHITHAI LOGISTICS PRIVATE LIMITED",
"SRI KAMALAGANAPATHY STEEL ROLLING MILLS PRIVATE LIMITED",
"SRI KANCHI MAHASWAMI VIDYA MANDIR",
"SRI KANDHAGURU SPINNING MILLS PRIVATE LIMITED",
"SRI KANGEYAA TEXTILES PRIVATE LIMITED",
"SRI KANNAN & CO",
"SRI KANNAPIRAN MILLS LIMITED",
"SRI KANNIKA PARAMESHWARI SILKS AND SAREES PRIVATE LIMITED",
"SRI KANNIKA PARAMESWARI CHIT CORPORATION PRIVATE LIMITED",
"SRI KANNIKA PARAMESWARI TRADERS PRIVATE LIMITED",
"SRI KANYA CORPORATION",
"SRI KANYAKA PARAMESWARI ARTS AND SCIENCE COLLEGE FOR WOMEN",
"SRI KARAN NARENDRA AGRICULTURE UNIVERSITY",
"SRI KARAN SINGH JANTA INTER COLLEGE",
"SRI KARNI APPARELS PRIVATE LIMITED",
"SRI KARPAGA VINAYAGAR TEXTILES",
"SRI KARPAGAM MILLS INDIA PRIVATE LIMITED",
"SRI KARTHIKEYA BIO & PHARMA PROJECTS PRIVATE LIMITED",
"SRI KARTHIKEYA SECURITY SERVICES",
"SRI KARTHIKEYA SPINNING AND WEAVING MILLS PRIVATE LIMITED",
"SRI KARTHIKEYA TEXTILES PRIVATE LIMITED",
"SRI KARTHIKUMAR TEXTILES PRIVATE LIMITED",
"SRI KARUPASSAMY UMA JEWELLER PRIVATE LIMITED",
"SRI KARVEMBU TEXTILES PRIVATE LIMITED",
"SRI KARVEMBUKUMARAN YARN PRIVATE LIMITED",
"SRI KASHI APARTMENT & FORT PRIVATE LIMITED",
"SRI KAUSALYA CONSTRUCTIONS LIMITED",
"SRI KAUSTHUB MOTORS PRIVATE LIMITED",
"SRI KAUVERY MEDICAL CARE INDIA LIMITED",
"SRI KESHAV FASHIONS PRIVATE LIMITED",
"SRI KHALPAVRUKSHA INFRA SOLUTIONS PRIVATE LIMITED",
"SRI KIRPA EMPIRE EXIM PRIVATE LIMITED",
"SRI KIRTHI POWER SOLUTIONS INDIA PRIVATE LIMITED",
"SRI KIRTHIKA BUILDERS PRIVATE LIMITED",
"SRI KIRTHIKA PIPES PRIVATE LIMITED",
"SRI KISHAN JI TRADERS PRIVATE LIMITED",
"SRI KODANDARAMA BOILED & RAW RICE MILL",
"SRI KODE FINVEST PRIVATE LIMITED",
"SRI KODURI ENTERPRISES PRIVATE LIMITED",
"SRI KORAKA TECHNOLOGIES PRIVATE LIMITED",
"SRI KOTESWARA CAM SYSTEMS PRIVATE LIMITED",
"SRI KPR INDUSTRIES LIMITED",
"SRI KPR INFRA & PROJECTS LIMITED",
"SRI KRIPA STONES AND GRANITES PRIVATE LIMITED",
"SRI KRISH INTERNATIONAL SCHOOL",
"SRI KRISHNA ACADEMY",
"SRI KRISHNA ARTS AND SCIENCE COLLEGE",
"SRI KRISHNA COIL CRAFTS PRIVATE LIMITED",
"SRI KRISHNA COLLEGE OF ENGINEERING AND TECHNOLOGY",
"SRI KRISHNA COMMERCIAL CO LTD",
"SRI KRISHNA DESCALERS PRIVATE LIMITED",
"SRI KRISHNA FIRE WORKS FACTORY PRIVATE LIMITED",
"SRI KRISHNA I-TECH AND MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"SRI KRISHNA JEWELLERS PRIVATE LIMITED",
"SRI KRISHNA JEWELLERY MART",
"SRI KRISHNA MATRIC HR SEC SCHOOL",
"SRI KRISHNA MILKS PRIVATE LIMITED",
"SRI KRISHNA MODERN RICE MILL",
"SRI KRISHNA NAGAI MALIGAI MADURAI PRIVATE LIMITED",
"SRI KRISHNA NUTRITIONS INDIA PRIVATE. LIMITED.",
"SRI KRISHNA PHARMACEUTICALS LIMITED",
"SRI KRISHNA POLY PACK PRIVATE LIMITED",
"SRI KRISHNA PYRO EXPORTS PRIVATE LIMITED",
"SRI KRISHNA SAI BIO PRODUCTS PRIVATE LIM ITED",
"SRI KRISHNA SAI DIAGNOSTIC AND RESEARCH INSTITUTE PRIVATE LIMITED",
"SRI KRISHNA SPINNING AND WEAVING MILLS PRIVATE. LIMITED.",
"SRI KRISHNA STEAM RICE & OIL MILL PRIVATE LIMITED",
"SRI KRISHNA SWEETS PRIVATE LIMITED",
"SRI KRISHNA TECHNO COMPONENTS PRIVATE LIMITED",
"SRI KRISHNA TILES & POTTERIES MADRAS PRIVATE LIMITED",
"SRI KRISHNA VENTURES PRIVATE LIMITED",
"SRI KRISHNA VINIYOG PVT LTD",
"SRI KRISHNADEVARAYA HATCHERIES PRIVATE. LIMITED.",
"SRI KRISHNADEVARAYA UNIVERSITY",
"SRI KSHIPRA ENERGY PRIVATE LIMITED",
"SRI KSR METAL AND ALLOYS PRIVATE LIMITED",
"SRI KSSV FINVEST PRIVATE LIMITED",
"SRI KUMAR ENGINEERING PRIVATE LIMITED",
"SRI KUMARAGURU MILL LIMITED",
"SRI KUMARAN ALLOYS PRIVATE LIMITED",
"SRI KUMARAN MATRIC HR SEC SCHOOL",
"SRI KUMARAN MILLS LIMITED.",
"SRI KUMARAN STEELS INDIA PRIVATE LIMITED",
"SRI KUMARASWAMY MINERAL EXPORTS PRIVATE LIMITED",
"SRI KURUMBA EDUCATIONAL AND CHARITABLE TRUST",
"SRI LAKOSHA POLYMER PRIVATE LIMITED",
"SRI LAKSHMI AGRO FARMS",
"SRI LAKSHMI AND BROTHERS MEDIA EVENTS PRIVATE LIMITED",
"SRI LAKSHMI AUTOMOBILES PRIVATE. LIMITED.",
"SRI LAKSHMI BHARGAVI PHARMA PRIVATE LIMITED",
"SRI LAKSHMI COATS PRIVATE LIMITED",
"SRI LAKSHMI CONSTRUCTIONS",
"SRI LAKSHMI EDUCATIONAL FOUNDATION",
"SRI LAKSHMI EDUCATIONAL SOCIETY ?",
"SRI LAKSHMI EGG FARMING PRIVATE LIMITED",
"SRI LAKSHMI ENGINEERS & CONSTRUCTIONS",
"SRI LAKSHMI FINVEST PVT LTD",
"SRI LAKSHMI GANAPATHI POULTRY'S PRIVATE LIMITED",
"SRI LAKSHMI GODAVARI SPINNING MILLS PRIVATE LIMITED",
"SRI LAKSHMI HOMES PRIVATE LIMITED",
"SRI LAKSHMI INDUSTRIAL COATINGS PRIVATE LIMITED",
"SRI LAKSHMI MADHAVI ALUMS PRIVATE LIMITED",
"SRI LAKSHMI MOTORS SERVICE PRIVATE LIMITED",
"SRI LAKSHMI NARASIMHA BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"SRI LAKSHMI NARASIMHA COLD STORAGE PRIVATE LIMITED",
"SRI LAKSHMI NARASIMHA ELECTRICALS",
"SRI LAKSHMI NARASIMHA INDUSTRIES PRIVATE LIMITED",
"SRI LAKSHMI NARASIMHA SPINNING MILLS INDIA PRIVATE LIMITED",
"SRI LAKSHMI NARAYANA INSTITUTE OF MEDICAL SCIENCES",
"SRI LAKSHMI NARAYANA MATRICULATION SCHOOL",
"SRI LAKSHMI PATI CONTROL CABLES PRIVATE LIMITED",
"SRI LAKSHMI POULTRY COMPLEX PRIVATE LIMITED",
"SRI LAKSHMI POULTRY FARM",
"SRI LAKSHMI PRABHA ENGINEERING INDUSTRIES PRIVATE LIMITED",
"SRI LAKSHMI PRASANNA AGRO PAPER INDUSTRIES LIMITED",
"SRI LAKSHMI ROSIN PRIVATE LIMITED",
"SRI LAKSHMI SARASWATHI TEXTILES ARNI LIMITED",
"SRI LAKSHMI SATYANARAYANA RAW & BOILED RICE MILL",
"SRI LAKSHMI SRINIVASA AUTOMOBILES PRIVATE LIMITED",
"SRI LAKSHMI SRINIVASA MODERN RICE MILL",
"SRI LAKSHMI SUPER SPECIALITY HOSPITAL",
"SRI LAKSHMI VENKATESHWARA HOSPITAL",
"SRI LAKSHMI VENKATESHWARA HOSPITALS PRIVATE LIMITED",
"SRI LAKSHMI VENKATESHWARA RICE INDUSTRY",
"SRI LAKSHMI VENKATESHWARA WAREHOUSING AND PFT PRIVATE LIMITED",
"SRI LAKSHMI VENKATESWARA COLD STORAGE PRIVATE LIMITED",
"SRI LAKSHMI VENKATESWARA HYGIENIC FOODS PRIVATE LIMITED",
"SRI LAKSHMI VENKATESWARA TRADING COMPANY PRIVATE LIMITED",
"SRI LAKSHMIKANTHA ENTERPRISE LIMITED",
"SRI LAKSHMINARAYAN MATRICULATION HIGHER SECONDARY SCHOOL",
"SRI LAKSHMINARAYANA MATRICULATION HIGHER SECONDARY SCHOOL",
"SRI LAKSHMISRINIVASA AGRO INDUSTRIES PRIVATE LIMITED",
"SRI LAKSHMISRINIVASA COLD STORAGE PRIVATE LIMITED",
"SRI LAL FOODS PRIVATE LIMITED",
"SRI LALITA DEVI CASHEW PRODUCTS",
"SRI LALITHA DAIRY FOODS PRIVATE LIMITED",
"SRI LALITHA ENTERPRISES INDUSTRIES PRIVATE LIMITED",
"SRI LALITHA MULTI SPECIALITY HOSPITAL",
"SRI LALITHAMBIGAI MEDICAL COLLEGE & HOSPITAL",
"SRI LALITHAMBIGHAI TEXTILES PRIVATE LIMITED",
"SRI LAVANYA SPRINGS PRIVATE LIMITED",
"SRI LAXMI COTTON MILLS",
"SRI LAXMI DHANWANTARI HOSPITALS & RESEARCH PRIVATE LIMITED",
"SRI LAXMI FACILITIES MANAGEMENT SERVICES INDIA PRIVATE LIMITED",
"SRI LAXMI GANAPATHI CRANES AND CONSTRUCTION PRIVATE LIMITED",
"SRI LAXMI GANAPATHY TRADING PRIVATE LIMITED",
"SRI LAXMI GOLD PRIVATE LIMITED",
"SRI LAXMI KRAVIA TECHLABS PRIVATE LIMITED",
"SRI LAXMI NARASIMHA INDUSTRIES",
"SRI LAXMI TALASILA INFRA PROJECTS PRIVATE LIMITED",
"SRI LAXMINARAYAN CHEMICALS AND FERTILIZERS PRIVATE LIMITED",
"SRI LOGILLU MARKETING AND SERVICES PRIVATE LIMITED",
"SRI LOHITHA FOODS PRIVATE LIMITED",
"SRI LOHITHAKSH SHIPPING PRIVATE LIMITED",
"SRI LORD VENKATESWARA LAND HOLDINGS PRIVATE LIMITED",
"SRI LOTUS CHICK FOODS PRIVATE LIMITED",
"SRI LUXMI TULASI AGRO PAPER PRIVATE LIMITED",
"SRI M K PAPER MILLS PRIVATE LIMITED",
"SRI M M GHODASARA MAHILA ARTS AND COMMERCE COLLEGE",
"SRI M M SHERRY H S SCHOOL",
"SRI M.S.T SMELTERS PRIVATE LIMITED",
"SRI MAATANGI PLASTICIZER PRIVATE LIMITED",
"SRI MAGENTA CHEMICALS PRIVATE LIMITED",
"SRI MAHA GANAPATHI JEWELLERS PRIVATE LIMITED",
"SRI MAHALAKSHMI DAIRY PRIVATE LIMITED",
"SRI MAHALAXMI COTTON MILLS",
"SRI MAHALAXMI ENTERPRISES",
"SRI MAHALAXMI TEXPRINTS PRIVATE LIMITED",
"SRI MAHARAJA ENTERPRISES",
"SRI MAHARSHI SHIPPING PRIVATE LIMITED",
"SRI MAHASAI FINE CHEMICALS HYDERABAD PRIVATE LIMITED",
"SRI MAHASAKTHI MILLS PRIVATE LIMITED",
"SRI MAHASHIV ASTROLOGY CENTRE PRIVATE LIMITED",
"SRI MAHESHWARA ENGINEERING",
"SRI MAHESHWARY GRANITES PRIVATE LIMITED",
"SRI MALLIKARJUNA CHEMICALS PRIVATE LIMITED",
"SRI MANAKULA VINAYAGA EDUCATIONAL TRUST",
"SRI MANAKULA VINAYAGAR ENGINEERING COLLEGE",
"SRI MANAKULA VINAYAGAR MEDICAL COLLEGE AND HOSPITAL",
"SRI MANIRAM SYNTHETICS PRIVATE LIMITED",
"SRI MANJUBASHINI CHEMICALS PRIVATE. LIMITED.",
"SRI MANJUNATH CONTAINER SERVICES PRIVATE LIMITED",
"SRI MANJUNATH FOODS AND PACKAGINGS PRIVATE LIMITED",
"SRI MANJUNATHA COLD STORAGE PRIVATE LIMITED",
"SRI MANJUNATHA SPINNING MILLS LIMITED",
"SRI MANJUNATHA SS PRIVATE LIMITED",
"SRI MANJUNATHA STONES PRIVATE LIMITED",
"SRI MANKAMESHWARI INTER COLLEGE",
"SRI MANMAYA TEXTILES PRIVATE LIMITED",
"SRI MARUDAMALAI MURUGAN SPINNING MILLS PRIVATE LIMITED",
"SRI MARUTHI POWER-GEN (INDIA) PRIVATE LIMITED",
"SRI MARUTHI RICE INDUSTRIES",
"SRI MARUTHI VASTRAS PRIVATE LIMITED",
"SRI MARUTI AGRO COMMODITIES PRIVATE LIMITED",
"SRI MATHA SPINNING MILLS PRIVATE LIMITED",
"SRI MATHANGI MATHA AGROS PRIVATE LIMITED",
"SRI MATHANGI TEXTILES PRIVATE LIMITED",
"SRI MAYUR BISCUIT COMPANY PVT. LTD.",
"SRI MAYURI BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"SRI MAYYIA CATERERS",
"SRI MDHAVANI JUNIOR COLLEGE",
"SRI MEDHAVI JUNIOR COLLEGE",
"SRI MEENAKSHI MOTORS PRIVATE LIMITED",
"SRI MEHRA JEWELLERS PRIVATE LIMITED",
"SRI MITTAPALLI COLLEGE OF ENGINEERING",
"SRI MITTAPALLI INSTITUTE OF TECHNOLOGY FOR WOMEN",
"SRI MJR 92 PRIVATE LIMITED",
"SRI MM SHERRY HS SCHOOL",
"SRI MONASHI LIFE SCIENCES PRIVATE LIMITED",
"SRI MOOGAMIKAI AGENCIES",
"SRI MOOKAMBIGAI LOGISTICS PRIVATE LIMITED",
"SRI MOOKAMBIKA INFOSOLUTIONS PRIVATE LIMITED",
"SRI MOOKAMBIKA TEMPLE HS KOLLURU",
"SRI MOTHUKURI MOTORS PRIVATE LIMITED",
"SRI MOTI PVT LTD.",
"SRI MOULI TEXTILES PRIVATE LIMITED SMPTL",
"SRI MULTI MAG PRIVATE LIMITED",
"SRI MUNI PACHAIAPPAN TEXTILES PRIVATE LIMITED",
"SRI MUNI PACHAIYAMMAN TEXTILES LIMITED",
"SRI MURALI KRISHNA DEGREE COLLEGE",
"SRI MURALIDHARA SWAMIJI VIDHYA MANDIR",
"SRI MURUGAN INDUSTRIES",
"SRI MURUGAN STORES RETAILERS PRIVATE LIMITED",
"SRI MURUGAN TRANSPORT",
"SRI MURUGAN WIRES & CABLES PRIVATE LIMITED",
"SRI MUTHUKUMARAN INSTITUTE OF TECHNOLOGY",
"SRI MUTHUKUMARAN MEDICAL COLLEGE HOSPITAL AND RESEARCH INSTITUE",
"SRI MUTHUKUMARASAWAMY COLLEGE",
"SRI MVR COTTON OIL MILLS PRIVATE LIMITED",
"SRI NACHAMMAI COTTON",
"SRI NAGA SAI HEALTHCARE PRIVATE LIMITED",
"SRI NAGAMALLESWARA SPINTEX INDIA PRIVATE LIMITED",
"SRI NAGAVALI SOLVENT OILS PVT LTD.",
"SRI NAGENDRA CREDIT CO OPERATIVE SOCIETY LTD",
"SRI NAKODA CONSTRUCTION LIMITED",
"SRI NALANDA EDUCATIONAL SOCIETY",
"SRI NALLATHAL SPINNING MILLS PRIVATE LIMITED",
"SRI NANDI ELECTMART (INDIA) PRIVATE LIMITED",
"SRI NANJUNDESHWARA CHITS PRIVATE LIMITED",
"SRI NARASUS COFFEE COMPANY LIMITED",
"SRI NARAYANA ENGINEERING INDUSTRIES PVT LTD",
"SRI NARAYANA HIGH SCHOOL",
"SRI NARAYANI HOSPITAL & RESEARCH CENTRE",
"SRI NATIONAL SCHOOL",
"SRI NAVDURGA BILLETS PRIVATE LIMITED",
"SRI NAVDURGA TEXTILE PROCESSORS PRIVATE LIMITED",
"SRI NAVODAYA INSTITUTE OF MEDICAL SCIENCES PRIVATE LIMITED",
"SRI NAVRATHNA DIAMONDS PRIVATE LIMITED",
"SRI NEELKANTH IMPEX PRIVATE LIMITED",
"SRI NEELKANTH NATURAL RESOURCES PRIVATE LIMITED",
"SRI NEUROCARE PRIVATE LIMITED",
"SRI NIDAMANURI EDUCATIONAL SOCIETY",
"SRI NISTY PRIVATE LIMITED",
"SRI NITHYAKALYANI CHIT FUNDS PRIVATE LIMITED",
"SRI NITYA INTERNATIONAL PRIVATE LIMITED",
"SRI NIWAS HEALTH CARE FOOD PRODUCTS PRIVATE LIMITED",
"SRI NUKALA RAMA KOTESWARA RAO TEXTILES PRIVATE LIMITED",
"SRI NUTHATCH NUTRICARE TECHNOLOGIES PRIVATE LIMITED",
"SRI OM CONSTRUCTIONS PRIVATE LIMITED",
"SRI ONKAR TEXTILES PRIVATE LIMITED",
"SRI ORBIT DISTRIBUTORS PRIVATE LIMITED",
"SRI P.M. FAABS PRIVATE LIMITED",
"SRI PAAMBAN INTERIORS PRIVATE LIMITED",
"SRI PADMA PRIYA FINANCE CORPORATION",
"SRI PADMAM BIOSCIENCES PRIVATE LIMITED",
"SRI PADMAVATHI BREEDING FARMS PRIVATE LIMITED",
"SRI PADMAVATHI EDUCATIONAL INSTITUTIONS",
"SRI PADMAVATHI POLYCHEM PRIVATE LIMITED",
"SRI PADMAVATHI SCHOOL OF PHARMACY",
"SRI PADMAVATHY COLLEGE OF ENGINEERING",
"SRI PADMAVATHY PRINTERS PRIVATE LIMITED",
"SRI PADMAVATHY YARNS INDIA PRIVATE LIMITED",
"SRI PADMAVATI ENERGY SOLUTIONS INDIA PRIVATE LIMITED",
"SRI PADMAVATI MAHILA VISVAVIDYALAYAM",
"SRI PALANI MURUGAN ENTERPRISES LIMITED",
"SRI PANCHAJANYA WAREHOUSING PRIVATE LIMITED",
"SRI PANCHAMUKHI NUTRIENTS PRIVATE LIMITED",
"SRI PANDURANGA RICE MILLS",
"SRI PARAMESHWARA ENGINEERING SOLUTIONS PRIVATE LIMITED",
"SRI PARAMESHWARI PROJECTS PRIVATE LIMITED",
"SRI PARAMESWARI SPINNING MILLS PRIVATE LIMITED",
"SRI PARASHAKTI PRINTERS PRIVATE LIMITED",
"SRI PARIJATHA MACHINERY WORKS PRIVATE LIMITED",
"SRI PARVATHI PARAMESWARA FOODS",
"SRI PARVATHIANGALAMMAN MILL PRIVATE LIMITED",
"SRI PATHY ASSOCIATES PRIVATE LIMITED",
"SRI PAVAN ENERGY PRIVATE LIMITED",
"SRI PAVANI ENGINEERING COMPANY PRIVATE LIMITED",
"SRI PAVITHRA COTTON MILLS PRIVATE LIMITED",
"SRI PAVITRA PACK PRIVATE LIMITED",
"SRI PONNI TRAVELS I PRIVATE LIMITED",
"SRI POWER GENERATION INDIA PRIVATE LIMITED",
"SRI PRAKASH VIDYANIKETAN",
"SRI PRANAV WELD PRIVATE LIMITED",
"SRI PRASANA TEX",
"SRI PRASSANA METALS AND ALLOY",
"SRI PRASUNAMBA LOGISTICS PRIVATE LIMITED",
"SRI PRASWATHI PLUMBING WORKS PRIVATE LIMITED",
"SRI PRATHIBHA EDUCATIONAL INSTITUTIONS",
"SRI PREETHI TRAVELS PRIVATE LIMITED",
"SRI PRIYALAKSHMI SPINNERS PRIVATE LIMITED",
"SRI PRIYANKA AGRO ENTERPRISES PRIVATE LIMITED",
"SRI PRIYANKA GRAPH-TECH PRIVATE LIMITED",
"SRI PROGRESSIVE EDUCATIONAL SOCIETY",
"SRI PROJECTSS PUNE INFRATECH & BUILDCON PRIVATE LIMITED",
"SRI PUBLICATION AND STATIONERS PRIVATE LIMITED",
"SRI PUSHPAVATHI AGRO TECH PRIVATE LIMITED",
"SRI R K HOTEL MANAGEMENT SERVICE PRIVATE LIMITED",
"SRI R.P. MILLS INDIA PRIVATE LIMITED",
"SRI RAAYAN AUTO CARE PRIVATE LIMITED",
"SRI RADHA GOPAL JI HSS RAYA MATHURA",
"SRI RADHA KRISHNA RICE INDUSTRIES",
"SRI RADHAKRISHNA MULTIPLE INDUSTRIES PRIVATE LIMITED",
"SRI RADHARAMAN MAHILA HIGHER SECONDARY SCHOOL",
"SRI RAGAVENDHRA NEURO CARE PRIVATE LIMITED",
"SRI RAGAVENDRA HEALTH CARE",
"SRI RAGHAVA TEXTILES LTD",
"SRI RAGHAVENDRA B.ED COLLEGE",
"SRI RAGHAVENDRA FERRO ALLOYS PRIVATE LIMITED",
"SRI RAGHAVENDRA SHIPPING COMPANY PRIVATE LIMITED",
"SRI RAGHUNANDA PAPER AND BOARDS PRIVATE LIMITED",
"SRI RAJ RE-ROLLING MILLS LIMITED",
"SRI RAJ TUBES PRIVATE LIMITED",
"SRI RAJA RAJESHWARA COTTON INDUSTRIES",
"SRI RAJA RAJESHWARA SWAMY DEVASTANAM",
"SRI RAJA RAJESWARI CONSTRUCTIONS INDIA PRIVATE LIMITED",
"SRI RAJA RAJESWARI HOTELS CHENNAI PRIVATE LIMITED",
"SRI RAJA RAJESWARI HOTELS VELLORE PRIVATE LIMITED",
"SRI RAJALAKSHMI COMMERCIAL KITCHEN EQUIPMENTS PRIVATE LIMITED",
"SRI RAJARAJESWARI MATRICULATION HIGHER SECONDARY SCHOOL KANGAYAM",
"SRI RAJENDRA GINNERS PRIVATE LIMITED",
"SRI RAJESHWARA EDUCATIONAL SOCIETY",
"SRI RAJESHWARA HATCHERIES PRIVATE LIMITED",
"SRI RAJESHWARA POLYMERS PRIVATE LIMITED",
"SRI RAJESWARI FIREWORKS",
"SRI RAJRAJESHWARI INFRAPROJECTS PRIVATE LIMITED",
"SRI RAM CABLES PRIVATE LIMITED",
"SRI RAM CONSTRUCTION",
"SRI RAM FLEXIBLES PRIVATE LIMITED",
"SRI RAM FOOD INDUSTRIES",
"SRI RAM FORKLIFT & EQUIPMENTS PRIVATE LIMITED",
"SRI RAM HOMESS",
"SRI RAM HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED",
"SRI RAM INDUSTRIES",
"SRI RAM MATRIC HR SEC SCHOOL",
"SRI RAM MEDICARE PRIVATE LIMITED",
"SRI RAM MURTI GUPTA GOVT P G COLLEGE CHHARRA ALIGARH",
"SRI RAM POLYPET PRIVATE LIMITED",
"SRI RAM SPINNING MILLS LTD",
"SRI RAM TECHNO PLAST PRIVATE LIMITED",
"SRI RAM TECHNOPACK PRIVATE LIMITED",
"SRI RAM TUBES PRIVATE LIMITED",
"SRI RAMA AGRI GENETICS INDIA PRIVATE LIMITED",
"SRI RAMA COTTON CORPORATION",
"SRI RAMA EDUCATIONAL TRUST",
"SRI RAMA NARASIMHAN SONS (AUTOMOBILES) PVT LTD",
"SRI RAMA RAW & BOILED RICE MILL",
"SRI RAMA TEA MANUFACTURING CO PRIVATE LIMITED",
"SRI RAMA TEXTILE SPINNING MILLS LIMITED",
"SRI RAMA VILAS SERVICE LIMITED",
"SRI RAMABHADRA JR COLLEGE",
"SRI RAMACHANDRA ENTERPRISES PRIVATE LIMITED",
"SRI RAMACHANDRA INSTITUTE OF HIGHER EDUCATION AND RESEARCH",
"SRI RAMACHANDRA PIPES PRIVATE LIMITED",
"SRI RAMADAS MOTOR TRANSPORT LIMITED",
"SRI RAMADAS PAPER BOARDS PRIVATE LIMITED",
"SRI RAMAKRISHNA AQUA CULTURE PVT LTD",
"SRI RAMAKRISHNA COLLEGE OF ARTS & SCIENCE",
"SRI RAMAKRISHNA ENGINEERING COLLEGE",
"SRI RAMAKRISHNA FERRO ALLOYS (INDIA) PRIVATE LIMITED",
"SRI RAMAKRISHNA HOSPITAL",
"SRI RAMAKRISHNA MATH VIVEKANANDA CENTENARY GIRLS HR SEC SCHOOL",
"SRI RAMAKRISHNA MATRICULATION HIGHER SEC SCHOOL",
"SRI RAMAKRISHNA MILLS (COIMBATORE) LIMITED",
"SRI RAMAKRISHNA MISSION VIDYALAYA GIRLS HR SEC SCHOOL",
"SRI RAMAKRISHNA RAW & PARA BOILED MODERN RICE MILL",
"SRI RAMAKRISHNA YARN CARRIERS LIMITED",
"SRI RAMALINGA CHOODAMBIKAI MILLS LIMITED",
"SRI RAMALINGAM SPINNERS PRIVATE LIMITED",
"SRI RAMALINGESWARA PAPER PRODUCTS PRIVATE. LIMITED.",
"SRI RAMALINGESWARA RICE MILL",
"SRI RAMANA BUILDING CONSTRUCTIONS PRIVATE LIMITED",
"SRI RAMANA FISHERIES PVT.LTD.",
"SRI RAMANA HATCHERIES PRIVATE LIMITED",
"SRI RAMANA MAHARSHI HOSPITALITY SERVICES PRIVATE LIMITED",
"SRI RAMANA SOLVEX PRIVATE LIMITED",
"SRI RAMANI SPINNERS PRIVATE LIMITED",
"SRI RAMANJANEYA AGRO INDUSTRIES",
"SRI RAMANJANEYA PRASANNA ENTERPRISES PRIVATE LIMITED",
"SRI RAMANUJA HOSPITALITY SERVICES PRIVATE LIMITED",
"SRI RAMANUJA HOTELS PRIVATE LIMITED",
"SRI RAMANUJAR ENGINEERING COLLEGE",
"SRI RAMCHANDRA SHIPPING AGENCIES PRIVATE LIMITED",
"SRI RAMKARTHIC POLYMERS PRIVATE LIMITED",
"SRI RAMNARAYAN MILLS LIMITED",
"SRI RAM'S NAVODAYA CHIT FUND PRIVATE LIMITED",
"SRI RANGA ENTERPRISES PRIVATE LIMITED",
"SRI RANGA FURNITURE PRIVATE LIMITED",
"SRI RANGA MOTORS PRIVATE LIMITED",
"SRI RANGA TEXTILES",
"SRI RANGALAKSHMI GOLDEN ARCADE PRIVATE LIMITED",
"SRI RANGAN BUILDER PRIVATE LIMITED",
"SRI RANGANATHAR CONSTRUCTIONS PRIVATE. LIMITED.",
"SRI RANGANATHAR INDUSTRIES PRIVATE LIMITED",
"SRI RANGANATHAR INSTITUTE OF ENGINEERING AND TECHNOLOGY",
"SRI RANGANATHAR VALVES AND CONTROL PRIVATE LIMITED",
"SRI RANGANATHAR VALVES PRIVATE LIMITED",
"SRI RANI SATI AGRI FEEDS PRIVATE LIMITED",
"SRI RANILAKSHMI TEXTILES PRIVATE LIMITED",
"SRI RANISATI STEELS PRIVATE LIMITED",
"SRI RATAN TRANSPORTER AND COAL SUPPLIERS PRIVATE LIMITED",
"SRI RATHINAGIRI HOMETEX PRIVATE LIMITED",
"SRI RATNA PACKAGING PRIVATE LIMITED",
"SRI RATNALAKSHMI SPINNING MILLS PRIVATE LIMITED",
"SRI RAVI GOLD PALACE",
"SRI RENGA APPARELS INDIA PRIVATE LIMITED",
"SRI RENGA TIMBERS",
"SRI RENUKA SHAKTI SECURITY SERVICES PRIVATE LIMITED",
"SRI RM JAIN VIDHYASHRAM",
"SRI ROONWAL MARKETING PRIVATE LIMITED",
"SRI ROONWAL MOTORS PRIVATE LIMITED",
"SRI ROOP OVERSEAS PRIVATE LIMITED",
"SRI ROZ CONSULTANTS PRIVATE LIMITED",
"SRI RUDHRA ALLOY CASTINGS PRIVATE LIMITED",
"SRI SAASTRA JUNIOR COLLEGE",
"SRI SABARI ENGIMECH PRIVATE LIMITED",
"SRI SADANANDA FOODS PRIVATE LIMITED",
"SRI SAGUNTHALA DEVI MILLS PRIVATE LIMITED",
"SRI SAHITHI MANPOWER AND SECURITY SERVICES PRIVATE LIMITED",
"SRI SAHITHI SPINNING MILLS PRIVATE LIMITED",
"SRI SAI ASHIRWAAD ENTERPRISES LIMITED",
"SRI SAI BABA CELLULOSE PVT.LTD.",
"SRI SAI BABA COTTON INDUSTRIES",
"SRI SAI BALAJI HEALTH CARE INDIA PRIVATE LIMITED",
"SRI SAI BALAJI POULTRIES PRIVATE LIMITED",
"SRI SAI BALAJI TOBACCOS PRIVATE LIMITED",
"SRI SAI BASAVA SUGARS LIMITED",
"SRI SAI BASAVA TARAKA RAMA OILS PRIVATE LIMITED",
"SRI SAI CABLE AND BROAD BAND PRIVATE LIMITED",
"SRI SAI CHANDRA INFRAWELL PRIVATE LIMITED",
"SRI SAI CIVIL & TECHNO ENGINEERS PRIVATE LIMITED",
"SRI SAI CONSULTANCY AND INFOSOFT INDIA PRIVATE LIMITED",
"SRI SAI CREATIONS",
"SRI SAI DEEPTHI POWER PRIVATE LIMITED",
"SRI SAI DIVINE MINING PRIVATE LIMITED",
"SRI SAI DURGA FOODS",
"SRI SAI EDUCATIONAL TRUST",
"SRI SAI EGG EXPORTS PRIVATE LIMITED",
"SRI SAI ENTERPRISES",
"SRI SAI GARMENT MACHINES PRIVATE LIMITED",
"SRI SAI HARIPADMA LOGISTICS PRIVATE LIMITED",
"SRI SAI INFRASTRUCTURES PRIVATE LIMITED",
"SRI SAI INTERNATIONAL SCHOOL",
"SRI SAI KAMALA HOSPITAL",
"SRI SAI KRISHNA CONTAINERS PRIVATE LIMITED",
"SRI SAI KRISHNA SECURITY SERVICES PRIVATE LIMITED",
"SRI SAI LAKSHMI DIE CASTINGS LIMITED",
"SRI SAI LEELA ELECTRICAL PROJECTS",
"SRI SAI LOGISTICS EXPERT PRIVATE LIMITED",
"SRI SAI MANASA NATURE TECH PRIVATE LIMITED",
"SRI SAI MANUFACTURING AND ENGINEERING COMPANY PRIVATE LIMITED",
"SRI SAI MARITECNO PVT LTD",
"SRI SAI MATERNITY & CHILD HOSPITAL PRIVATE LIMITED",
"SRI SAI METAL AND LOGISTIC PRIVATE LIMITED",
"SRI SAI MICROTECH PRIVATE LIMITED",
"SRI SAI MILK LINES PRIVATE LIMITED",
"SRI SAI NATH AGRI INDUSTRIES PRIVATE LIMITED",
"SRI SAI NIDHI REALTORS PRIVATE LIMITED",
"SRI SAI POLYBLENDS PRIVATE LIMITED",
"SRI SAI POWER AND EQUIPMENTS PRIVATE LIMITED",
"SRI SAI PUBLIC SCHOOL",
"SRI SAI RAM POLYMERS PRIVATE LIMITED",
"SRI SAI RAMA FROZEN FOODS PRIVATE LIMITED",
"SRI SAI RR MOTORS PRIVATE LIMITED",
"SRI SAI SAPTAGIRI SPONGE PRIVATE LIMITED",
"SRI SAI SHIVA HIGH SCHOOL",
"SRI SAI SRINIVASA RICE INDUSTRIES PRIVATE LIMITED",
"SRI SAI TEJA AGRO INDUSTRIES PRIVATE LIMITED",
"SRI SAI TEJA PACKAGING PRIVATE LIMITED",
"SRI SAI TIRUMALA CONSTRUCTIONS PRIVATE LIMITED",
"SRI SAI UMA LABORATORIES PRIVATE LIMITED",
"SRI SAI YOG AND NISAGUPCHAR KENDRA AYURVEDIC AUSHADALAY",
"SRI SAIBABA ENTERPRISES",
"SRI SAIBALAJI SPINTEX (INDIA) PRIVATE LIMITED",
"SRI SAIKRISHNAS MARKETING PRIVATE LIMITED",
"SRI SAINADH RICE INDUSTRIES",
"SRI SAINATH INDUSTRY PRIVATE LIMITED",
"SRI SAINATHA MULTISPECIALITY HOSPITALS PRIVATE LIMITED",
"SRI SAIRAM ENGINEERING COLLEGE",
"SRI SAIRAM ENTERTAINMENT PRIVATE LIMITED",
"SRI SAIRAM INSTITUTE OF TECHNOLOGY",
"SRI SAISRINIVASA AUTOMOBILES PRIVATE LIMITED",
"SRI SAKTHI EDUCATIONAL TRUST",
"SRI SAKTHI TEXTILES PRIVATE LIMITED",
"SRI SALASAR BALAJI AGRO TECH PRIVATE LIMITED",
"SRI SALASAR INTERNATIONAL PRIVATE LIMITED",
"SRI SALASAR SUPPLIERS PVT LTD",
"SRI SALASAR TRANSPORT PRIVATE LIMITED",
"SRI SAMARTH UTILITY SERVICES PRIVATE LIMITED",
"SRI SAMBASIVA DAIRY PRODUCTS (INDIA) PRIVATE LIMITED",
"SRI SAMUNDEESWARI FOOD PRODUCTS PRIVATE LIMITED",
"SRI SANGAMESHWAR MADYAMIC SHALA. CHADCHAN",
"SRI SANGHVI JEWELLERS (INDIA) PRIVATE LIMITED",
"SRI SANKARA GLOBAL ACADEMY",
"SRI SANKARA INSTITUTE 0F HEALTH SCIENCES AND RESEARCH PRIVATE LIMITED",
"SRI SANKARA SENIOR SECONDARY SCHOOL",
"SRI SANKARA SILPASALA PRIVATE LIMITED",
"SRI SANKARA VIDYA KENDRA MAT HIGHER SECONDARY SCHOOL",
"SRI SANKARI YARNS PRIVATE LIMITED",
"SRI SANTHANA LAKSHMI SPINNERS PRIVATE LIMITED",
"SRI SANTHIPRIYA MINERALS PRIVATE LIMITED",
"SRI SANTHOSHI MATHA COTTON INDUSTRIES",
"SRI SAPTHAGIRI FOODS",
"SRI SAPTHAGIRI PRE UNIVERSITY COLLEGE",
"SRI SAPTHAGIRI SRINIVASA ENTERPRISES PRIVATE LIMITED",
"SRI SARADA TEXTILE PROCESSORS PRIVATE LIMITED",
"SRI SARADA VIDYAVANAM MATRICULATION GIRLS HIGHER SECONDARY SCHOOL",
"SRI SARADHA LOGISTICS PRIVATE LIMITED",
"SRI SARADHAMBIKA SPINTEX PRIVATE LIMITED",
"SRI SARASWATHI EDUCATIONAL SOCIETY",
"SRI SARASWATHI HIGH SCHOOL",
"SRI SARASWATHI MILK KOVA PRIVATE LIMITED",
"SRI SARASWATHI VIDHYAALAYA MATRICULATION HIGHER SECONDARY SCHOOL",
"SRI SARATHI STUDIOS PRIVATE LIMITED",
"SRI SARAVANA CARGO INDIA PRIVATE LIMITED",
"SRI SARAVANA INFRA ASSOCIATES PRIVATE LIMITED",
"SRI SARAVANA MILLS PRIVATE LIMITED",
"SRI SARAVANA TEX EXPORTS INDIA PRIVATE LIMITED",
"SRI SARAVANAA FILMS (OPC) PRIVATE LIMITED",
"SRI SARVA SIDDHI SAI RAM WAREHOUSE PRIVA TE LIMITED",
"SRI SARVADA NUTRIENTS PRIVATE LIMITED",
"SRI SARVARAYA SUGARS LIMITED",
"SRI SARWO NATRAJ AGRO INDIA PRIVATE LIMITED",
"SRI SASTHA PRECISION PRODUCTS PRIVATE LIMITED",
"SRI SATHE INFRACON PRIVATE LIMITED",
"SRI SATHYA AGRI BIO-TECH PRIVATE LIMITED",
"SRI SATHYA EXIM",
"SRI SATHYA SAI INSTITUTE OF HIGHER MEDICAL SCIENCES",
"SRI SATHYA SAI LOKA SEVA TRUST",
"SRI SATNAM JEWELLS PRIVATE LIMITED",
"SRI SATYA SAI INFRASTRUCTURE PRIVATE LIMITED",
"SRI SATYA SAI PAPER & BOARD MILLS PRIVATE LIMITED",
"SRI SATYA SAI UNIVERSITY OF HUMAN EXCELLENCE",
"SRI SATYA SAI UNIVERSITY OF TECHNOLOGY & MEDICAL SCIENCE SEHORE",
"SRI SATYA SAI VIDYA VIHAR",
"SRI SATYALAKSHMI RICE MILL",
"SRI SATYAM ISPAT INDUSTRIES INDIA PRIVATE LIMITED",
"SRI SATYAM TECH TOWER PRIVATE LIMITED",
"SRI SATYASAI CT SCAN ANDDIAGNOSTICS PRIVATE LIMITED",
"SRI SAVITR SOLAR PRIVATE LIMITED",
"SRI SAWALIASETH MINERALS PRIVATE LIMITED",
"SRI SCL INFRATECH LIMITED",
"SRI SEETHALAKSHMI STEEL CASTINGS PRIVATE LIMITED",
"SRI SEETHARAMA CONSTRUCTIONS",
"SRI SEETHARAMA JUTETWINE MILLS PRIVATE LIMITED",
"SRI SELLAM TEXTILE PRIVATE LIMITED",
"SRI SENTHILANDAVAR COTTON MILLS PRIVATE LIMITED",
"SRI SENTHURVELAN TRADERS INDIA PRIVATE LIMITED",
"SRI SESHASAI SPINNING MILLS PRIVATE LIMITED",
"SRI SGR LOGISTICS PRIVATE LIMITED",
"SRI SHAKTHI INSTITUTE OF ENGINEERING AND TECHNOLOGY",
"SRI SHAKTHI REFINERIES PRIVATE LIMITED",
"SRI SHAKTI GRAVURES INDIA PRIVATE LIMITED",
"SRI SHANDAR INDUSTRY PRIVATE LIMITED",
"SRI SHANDAR SNACKS PRIVATE LIMITED",
"SRI SHANKAR INT COLL",
"SRI SHANKARA CANCER HOSPITAL AND RESEARCH CENTER",
"SRI SHANKARANAND INTER COLLEGE",
"SRI SHANMUGA POLYMERS PRIVATE LIMITED",
"SRI SHANMUGAVEL MILLS PRIVATE LIMITED",
"SRI SHANMUGHA COLLEGE OF NURSING FOR WOMEN",
"SRI SHANTHI POLYMERS PRIVATE LIMITED",
"SRI SHANTI VIDYALAYA PRIVATE LIMITED",
"SRI SHARADA INTERNATIONAL SCHOOL",
"SRI SHARADHA PARAMESHWARI GASES PRIVATE LIMITED",
"SRI SHARADHA TIMBERS",
"SRI SHARVESHWARAA FABRICATION PRIVATE LIMITED",
"SRI SHEETHALA BALAJI MOTORS PRIVATE LIMITED",
"SRI SHIPPING SERVICES PRIVATE LIMITED",
"SRI SHIRDI SECURITIES PRIVATE LIMITED",
"SRI SHIRIDI SAIRAM RICE MILL",
"SRI SHIVA HEALTH CARE PRIVATE LIMITED",
"SRI SHIVA LOHITHA CONSTRUCTIONS PRIVATE LIMITED",
"SRI SHIVA PARVATHI INDUSTRIES",
"SRI SHIVANI AUTOMOBILES INDIA PRIVATE LIMITED",
"SRI SHIVSAKTHI MERCANTILE PRIVATE LIMITED",
"SRI SHUBA TEX PRIVATE LIMITED",
"SRI SHYAM ADDITIVES PRIVATE LIMITED",
"SRI SHYAM AGRO TRADERS",
"SRI SHYAM FASHION INDIA PRIVATE LIMITED",
"SRI SHYAM FASHION TEXTILES PRIVATE LTD",
"SRI SHYAM MILLERS PRIVATE LIMITED",
"SRI SHYAM PLASTO PRODUCTS PRIVATE LIMITED",
"SRI SHYAMBABA JEWELLERS PRIVATE LIMITED",
"SRI SIDDALINGESHWARA RICE INDUSTRIES",
"SRI SIDDHARTH INFRATECH & SERVICES I PRIVATE LIMITED",
"SRI SIDDHDATA FARMAID PRIVATE LIMITED",
"SRI SIDDHESHWAR ENGINEERS INDIA PRIVATE LIMITED",
"SRI SIDDHI ALANKARAM PRIVATE LIMITED",
"SRI SIDDHI FOODS AGRO PRIVATE LIMITED",
"SRI SIDDHI FREEZERS AND EXPORTERS PRIVATE LIMITED",
"SRI SIDDHI VINAYAK PAPER MILLS PRIVATE LIMITED",
"SRI SIDDHNATH BUILDCON PRIVATE LIMITED",
"SRI SIDDI RAMESHWAR AGRO INDUSTRIES PRIVATE LIMITED",
"SRI SIDDI VINAYAK FOODS PVT LTD",
"SRI SIDDI VINAYAK JEWELLERS AND EXPORTS PRIVATE LIMITED",
"SRI SIKSHAYATAN COLLEGE",
"SRI SINGHAL FOAMS PRIVATE LIMITED",
"SRI SITARAM MODERN PARA BOILED RICE MILL",
"SRI SITARAMA DAIRY PRIVATE LIMITED",
"SRI SITARAMA LAKSHMI JUTE MILLS PRIVATE LIMITED",
"SRI SIVA JYOTHI EXPORTS & IMPORTS (INDIA) PRIVATE LIMITED",
"SRI SIVA SUBRAMANYA NADAR COLLEGE OF ENG",
"SRI SIVAGURU SPINTEX PRIVATE LIMITED",
"SRI SIVAJOTHI SPINNING MILLS PRIVATE LIMITED",
"SRI SIVAPRIYA SHELTERS PRIVATE LIMITED",
"SRI SIVASAKHTHI AUTO ANCILLARIES MADRS PRIVATE LIMITED",
"SRI SIVASAKTHI ENGINEERS P LTD",
"SRI SIVASAKTHI FOOD PROCESSING AND TRADING PRIVATE LIMITED",
"SRI SKANDAGURU EDVENTURES PRIVATE LIMITED",
"SRI SOMESHWARA FERTILIZERS & CHEMICALS",
"SRI SOMESHWARA PROJECTS PRIVATE LIMITED",
"SRI SOUNDARYA SPINNING MILLS PRIVATE LIMITED",
"SRI SPR BIOLOGICS PRIVATE LIMITED",
"SRI SPR GLOBAL CONSULTING SERVICES PRIVATE LIMITED",
"SRI SRAVANI AGRITECH PRIVATE LIMITED",
"SRI SREE MANPOWER",
"SRI SREENIVASA PAPER MILL PRIVATE LIMITED",
"SRI SRI COLLEGE OF AYURVEDIC SCIENCE AND RESEARCH HOSPITAL",
"SRI SRI ENTERPRISES PRIVATE LIMITED",
"SRI SRI EXIM AGRO INDIA PRIVATE LIMITED",
"SRI SRI GRUHA NIRMAN INDIA PRAVATE LIMITED",
"SRI SRI HOLISTIC HOSPITALS",
"SRI SRI RAVI SHANKAR VIDYA MANDIR SCHOOL",
"SRI SRI RAVISHANKAR ENGLISH PRIMARY SCHOOL LATUR",
"SRI SRI SRI ATTIRE PRIVATE LIMITED",
"SRI SRI SRI AUTO CARS INDIA PRIVATE LIMITED",
"SRI SRI SRI PARAMESWARA AUTOMOBILES PRIVATE LIMITED",
"SRI SRI TATTVA PANCHAKARMA",
"SRI SRI UNIVERSITY",
"SRI SRINIVASA AGRI PRODUCTS INDIA PRIVATE. LIMITED.",
"SRI SRINIVASA CARTONS AND CONTAINERS PVT LTD",
"SRI SRINIVASA CONSTRUCTION INDIA PRIVATE LIMITED",
"SRI SRINIVASA DAIRY PRODUCTS PRIVATE. LIMITED.",
"SRI SRINIVASA EDUCATIONAL & CHARITABLE TRUST",
"SRI SRINIVASA GINNING MILL",
"SRI SRINIVASA HOSPITAL PRIVATE LIMITED",
"SRI SRINIVASA INFRA PROJECTS PRIVATE LIMITED",
"SRI SRINIVASA MATRICULATION SCHOOL",
"SRI SRINIVASA PAPER MILLS PRIVATE LIMITED",
"SRI SRINIVASA PRESSING COMPANY PRIVATE LIMITED",
"SRI SRINIVASA RAJESWARI AGRO-TEK MILLS PRIVATE LIMITED",
"SRI SRINIVASA RESIDENCY PRIVATE LIMITED",
"SRI SRINIVASA SPINTEX INDIA LIMITED",
"SRI SRITHIK DAIRY PRODUCTS PRIVATE LIMITED",
"SRI SRIVATHSA PAPER MILLS PRIVATE LIMITED",
"SRI SS WELDMESH PRIVATE LIMITED",
"SRI SUBADRA ENERGY INNOVATIONS PRIVATE LIMITED",
"SRI SUBALAKSHMI CONSTRUCTION PRIVATE LIMITED",
"SRI SUBIKSHAM FOOD INDUSTRIES PRIVATE LIMITED",
"SRI SUBRAHMANYA SWAMY COLLEGE OF PHARMACY",
"SRI SUDARSAN GASES PRIVATE LIMITED",
"SRI SUDHA CO-OPERATIVE BANK LIMITED",
"SRI SUDHA SESAMUM AGRO FOODS AND EXPORTS PRIVATE LIMITED.",
"SRI SUDHARSANAM HOSPITAL PRIVATE LIMITED",
"SRI SUGUNA MACHINE WORKS PRIVATE LIMITED",
"SRI SUKI PHARMA",
"SRI SUMANTH RICE AND BIO TECHNOLOGIES PRIVATE LIMITED",
"SRI SUMERU HOUSING PRIVATE LIMITED",
"SRI SUMERU REALTY PRIVATE LIMITED",
"SRI SUNDARAGANESH FREIGHTS PRIVATE LIMITED",
"SRI SUNDARI ENTERPRISES INDIA PRIVATE LIMITED",
"SRI SURAAS INDUSTRIES LIMITED",
"SRI SURYA AGRO TECH PRIVATE LIMITED",
"SRI SURYA KANYA RICE MILL",
"SRI SURYA NAMKEEN PRIVATE LIMITED",
"SRI SURYA SPRAY DRY TECHNOLOGIES PRIVATE LIMITED",
"SRI SURYANARAYANA SWAMY SOLAR POWER PRIVATE LIMITED",
"SRI SURYODAYA LOGISTICS PRIVATE LIMITED",
"SRI SURYODHAYAA PROCESSING PRIVATE LIMITED",
"SRI SVT AGRO RICE INDUSTRIES PRIVATE LIMITED",
"SRI SWASI INFRAZ PRIVATE LIMITED",
"SRI SWASTIK HOME LAND AGENCIES PRIVATE LIMITED",
"SRI TECHNOLOGIES PRIVATE LIMITED",
"SRI TELECOM INDIA TELESERVICES PRIVATE LIMITED",
"SRI THAMEEN MINES AND MINERALS PRIVATE LIMITED",
"SRI THANDEESWARAR ENGINEERING PRIVATE LIMITED",
"SRI THIRUMALA STONE CRUSHER & MSAND UNIT PRIVATE LIMITED",
"SRI THIRUMURUGAN AGENCIES",
"SRI THIRUVETTAI AYYANAR SPINNERS PRIVATE LIMITED",
"SRI TIKA RAM KANYA MAHAVIDYALAYA ALIGARH",
"SRI TIRUMALA HOUSING PRIVATE LIMITED",
"SRI TIRUMALA VENKATESWARA AGRO PRIVATE LIMITED",
"SRI TOORSA PLANTATIONS PRIVATE LIMITED",
"SRI TRINETRA IRON AND STEELS PRIVATE LIMITED",
"SRI TULSHI CLOTHING COMPANY PRIVATE LIMITED",
"SRI UJJAINI MAHAKALI DEVASTHANAM",
"SRI UKAI PRADESH SAHAKARI KHAND UDYOG MANDLI",
"SRI UMA CARTONS PRIVATE LIMITED",
"SRI UMA JEWELLERS INDIA PRIVATE LIMITED",
"SRI V BALAJI SPINNING MILLS INDIA PRIVATE LIMITED",
"SRI V.N.S. SPINNING MILLS INDIA PRIVATE LIMITED",
"SRI VAIBHAV MURUGA AGRO TECH INDUSTRIES",
"SRI VAIBHAVA LAKSHMI ENTERPRISES PRIVATE LIMITED",
"SRI VAIBHAVA SAI HOMES PRIVATE LIMITED",
"SRI VAIDEHI FOOD PROCESSING & AGRO INDUSTRIES PRIVATE LIMITED",
"SRI VAISHNAOI AUTOMOBILES (INDIA) PRIVATE LIMITED",
"SRI VAISHNAVI AGRO FOODS PRIVATE LIMITED",
"SRI VAISHNAVI OLYMPIAD SCHOOL",
"SRI VAISHNAVI SPINTEX I PRIVATE LIMITED",
"SRI VALLABHA INVESTMENT PRIVATE LIMITED",
"SRI VALLINATRAJ METAL ALLOY INDIA PRIVATE LIMITED",
"SRI VAMSI TEXTILES PRIVATE LIMITED",
"SRI VANI CONVENT HIGH SCHOOL",
"SRI VARADARAJA TEXTILES PRIVATE LIMITED",
"SRI VARADHARAJA FRUIT PRODUCTS PRIVATE LIMITED",
"SRI VARAHI SILICATE INDUSTRIES PRIVATE LIMITED",
"SRI VARALAKSHMI AUTO COMPONENTS PRIVATE LIMITED",
"SRI VARALAKSHMI RICE INDUSTRIES",
"SRI VARALAKSHMI SOLVENT OILS PRIVATE LIMITED",
"SRI VARDHAMAN KRAFTPAPERS PRIVATE LIMITED",
"SRI VARI BUSINESS CONSULTANTS INDIA PRIVATE LIMITED",
"SRI VARI MONEY EXCHANGE PRIVATE LIMITED",
"SRI VARSA AUTO AGENCIES PRIVATE LIMITED",
"SRI VARSHA FOOD PRODUCTS INDIA LIMITED",
"SRI VARSHA FOOD PRODUCTS INDIA PRIVATE LIMITED",
"SRI VASAVI EDUCATIONAL SOCIETY",
"SRI VASAVI ENGINEERING COLLEGE",
"SRI VASAVI GOLD & BULLION PRIVATE LIMITED",
"SRI VASAVI INSTITUTE OF ENGINEERING & TECHNOLOGY",
"SRI VASAVI PIGMENTS PRIVATE LIMITED",
"SRI VASAVI TECHNOCAST PRIVATE LIMITED",
"SRI VASISTA EDUCATION MANAGEMENT PRIVATE LIMITED",
"SRI VASISTA EDUCATIONAL TRUST",
"SRI VASUDEVA TEXTILES PRIVATE. LIMITED.",
"SRI VASUKI POWER SYSTEMS PRIVATE LIMITED",
"SRI VASUNDHARA RICE PRODUCTS PRIVATE LIMITED",
"SRI VATHSA POULTRIES PRIVATE LIMITED",
"SRI VAYUPUTHRA INDUSTRIES PRIVATE LIMITED",
"SRI VEDA ECET INSTITUTION",
"SRI VEDA VINAYAGAR FOUNDATIONS PRIVATE LIMITED",
"SRI VEDATRAYE DEVELOPERS PRIVATE LIMITED",
"SRI VEDHAA CREATIONS PRIVATE. LIMITED.",
"SRI VEERA VENKATA SATYANARAYANA RICE MILL",
"SRI VEERABHADRA PROPERTIES PRIVATE LIMITED",
"SRI VEERAMATHIAMMAN FOUNDATIONS PRIVATE LIMITED",
"SRI VEERAMATHIAMMAN INFRA DEVELOPER PRIVATE LIMITED",
"SRI VEL ELECTRICAL & FABRICATORS PRIVATE LIMITED",
"SRI VELA SMELTERS PRIVATE LIMITED",
"SRI VELAVAN MOTORS PRIVATE LIMITED",
"SRI VELAYUDHASWAMY SPINNING MILLS PRIVATE LIMITED",
"SRI VELLALA INFRA PRIVATE LIMITED",
"SRI VEMBU CHITS PRIVATE LIMITED",
"SRI VEN FOREX PRIVATE LIMITED",
"SRI VENGAMAMBA BUS TRANSPORT PRIVATE LIMITED",
"SRI VENGAMAMBA HOTELS AND RESORTS PRIVATE LIMITED",
"SRI VENKATA DURGA MILK DAIRY PRIVATE LIMITED",
"SRI VENKATA DURGA OLD IRON",
"SRI VENKATA LAKSHMI NARASIMHA SPINNING MILLS PRIVATE LIMITED",
"SRI VENKATA SAI MEDICAL SERVICES PRIVATE LIMITED",
"SRI VENKATA SIVA PARVATHI SPINNING MILLS PRIVATE LIMITED.",
"SRI VENKATA SRINIVASA BUILDERS PRIVATE LIMITED",
"SRI VENKATACHALAPATHY ALLOYS PRIVATE LIMITED",
"SRI VENKATACHALAPATHY CONSTRUCTIONS PRIVATE LIMITED",
"SRI VENKATACHALAPATHY SPINNING MILLS PRIVATE LIMITED",
"SRI VENKATALAKSHMI SPINNERS PRIVATE LIMITED",
"SRI VENKATARAMA OIL INDUSTRIES LIMITED",
"SRI VENKATARAMANA PARA BOILED RICE MILL PRIVATE LIMITED",
"SRI VENKATARAMANA SWAMY COLLEGE BANTWAL",
"SRI VENKATASAI TRADING PRIVATE LIMITED",
"SRI VENKATASRINIVASA POLYMERS PRIVATE LIMITED",
"SRI VENKATESH GRANITES PRIVATE LIMITED",
"SRI VENKATESH IRON & ALLOYS INDIA LIMITED.",
"SRI VENKATESHWAR BUILDCON PRIVATE LIMITED",
"SRI VENKATESHWARA BHAKTI CHANNEL",
"SRI VENKATESHWARA CHILDRENS HIGH SCHOOL",
"SRI VENKATESHWARA CHILLIES PRIVATE LIMITED",
"SRI VENKATESHWARA COIL MILL PRIVATE LIMITED",
"SRI VENKATESHWARA DIGITAL HOME ENTERTAINMENT PRIVATE LIMITED",
"SRI VENKATESHWARA FIBRE UDYOG PRIVATE LIMITED",
"SRI VENKATESHWARA JUNIOR COLLEGE",
"SRI VENKATESHWARA MULTIPLEXES PRIVATE LIMITED",
"SRI VENKATESHWARA POLYMERS",
"SRI VENKATESHWARA SMART BUILDING SOLUTIONS PRIVATE LIMITED",
"SRI VENKATESHWARA SPINNING MILLS INDIA PRIVATE LIMITED",
"SRI VENKATESHWARA TECH PRINTS PRIVATE LIMITED",
"SRI VENKATESHWARAA MEDICAL COLLEGE HOSPITAL AND RESEARCH CENTRE",
"SRI VENKATESWARA AEROSPACE PRIVATE LIMITED",
"SRI VENKATESWARA AGENCIES",
"SRI VENKATESWARA AGENCIES PVT LTD",
"SRI VENKATESWARA BHAKTI CHANNEL",
"SRI VENKATESWARA CANS PRIVATE LIMITED TRF.",
"SRI VENKATESWARA CARBONIC GASES PRIVATE LIMITED",
"SRI VENKATESWARA COIR PRODUCTS PRIVATE LIMITED",
"SRI VENKATESWARA COLLEGE OF ENGINEERING",
"SRI VENKATESWARA COTTON YARN MILLS (SALEM) PRIVATE LIMITED",
"SRI VENKATESWARA DEGREE & P G COLLEGE",
"SRI VENKATESWARA DENTAL COLLEGE AND HOSPITAL",
"SRI VENKATESWARA DIAGNOSTICS PRIVATE LIMITED",
"SRI VENKATESWARA ENTERPRISES",
"SRI VENKATESWARA FERTILIZERS PRIVATE LIMITED",
"SRI VENKATESWARA FOOD & BEVERAGES PRIVATE LIMITED",
"SRI VENKATESWARA FOOD PROCESSING INDUSTRIES",
"SRI VENKATESWARA HP GAS",
"SRI VENKATESWARA INSTITUTE OF MEDICAL SCIENCES",
"SRI VENKATESWARA MULTI SPECIALITY HOSPITAL",
"SRI VENKATESWARA ORCHARDES PRIVATE LIMITED",
"SRI VENKATESWARA OXYGEN PRIVATE LIMITED",
"SRI VENKATESWARA POLYTECHNIC COLLEGE",
"SRI VENKATESWARA POWER SYSTEMS",
"SRI VENKATESWARA RICE INDUSTRY",
"SRI VENKATESWARA RICE MILL",
"SRI VENKATESWARA SHRIMP HATCHERIES PRIVATE LIMITED",
"SRI VENKATESWARA SPINTEX P LIMITED",
"SRI VENKATESWARA UNIVERSITY",
"SRI VENKATESWARA VETERINARY UNIVERSITY FISHERIES RESEARCH STATION",
"SRI VENKATESWARA WHEAT MILLS PRIVATE LIMITED",
"SRI VENKATESWARAA AIR PRODUCTS PRIVATE LIMITED",
"SRI VENKATRAM SPINNERS PRIVATE. LIMITED.",
"SRI VETRI CARS PRIVATE LIMITED",
"SRI VETTRI EXPORT PRIVATE LIMITED",
"SRI VIDHYA NIKETAN MATRIC SCHOOL",
"SRI VIDHYALAKSHMI MATRIC HIGHER SECONDARY SCHOOL",
"SRI VIDYA EDUCATIONAL & CHARITABLE TRUST",
"SRI VIDYA EDUCATIONAL INSTITUTE",
"SRI VIDYA JUNIOR COLLEGE",
"SRI VIDYA MANDIR MATRIC HIGHER SECONDARY SCHOOL",
"SRI VIDYAJYOTHI ENGINEERING COLLEGE",
"SRI VIDYANIKETAN PUBLIC SCHOOL",
"SRI VIDYARANAYA CREDIT CO-OPERATIVE SOCIETY LTD",
"SRI VIGNESH YARNS PRIVATE LIMITED",
"SRI VIGNESHWARA CONSTRUCTIONS PRIVATE LIMITED",
"SRI VIGNESHWARA EDUCATIONAL SOCIETY",
"SRI VIGNESHWARA PETROCHEM PRIVATE LIMITED",
"SRI VIGNESHWARA WOOD INDUSTRIES",
"SRI VIGNESWARA FARMERS PRODUCER COMPANY LIMITED",
"SRI VIJAY VIDYALAYA MATRIC HIGHER SECONDARY SCHOOL",
"SRI VIJAY VIDYASHRAM SENIOR SECONDARY SCHOOL",
"SRI VIJAYA BIO FERTILIZERS (INDIA) PRIVATE LIMITED",
"SRI VIJAYA DURGA MOTORS PRIVATE LIMITED",
"SRI VIJAYA EDUCATIONAL ACADEMY",
"SRI VIJAYA PLYWOOD PRIVATE LIMITED",
"SRI VIJAYA VENKATESWARA COTTON MILLS PRIVATE LIMITED",
"SRI VIJAYA VISAKHA MILK PRODUCERS COMPANY LIMITED PART - IX A",
"SRI VIJAYAA LAMINATES PRIVATE LIMITED",
"SRI VIJAYADURGA INVESTMENTS AND AGENCIES PRIVATE LIMITED",
"SRI VIJAYAGANAPATHY FOOD PRODUCTS PRIVATE LIMITED",
"SRI VIJAYALAKSHIMI INFRASTRUCTURES PRIVATE LIMITED",
"SRI VIJAYALAKSHMI POLYMERS PRIVATE LIMITED",
"SRI VIJAYALAKSHMI STEEL HOUSE",
"SRI VIJAYYA VIDHYALAYA MATRIC HR SEC SCHOOL",
"SRI VIJETHA ENGINEERS & INFRASTRUCTURE PRIVATE LIMITED",
"SRI VIJETHA ENGINEERS AND INFRASTRUCTURE PRIVATE LIMITED",
"SRI VIJNANA VIHARA ENGLISH MEDIUM HIGH SCHOOL",
"SRI VINAYAGA ALLOYS PRIVATE LIMITED",
"SRI VINAYAGA GREEN POWER GENERATION PRIVATE. LIMITED.",
"SRI VINAYAGA HANDLERS PRIVATE LIMITED",
"SRI VINAYAGA PRINTERS PRIVATE LIMITED",
"SRI VINAYAGA PRIVATE LIMITED",
"SRI VINAYAGA SURFACE TREATERS",
"SRI VINAYAK AGRO AGENCIES PRIVATE LIMITED",
"SRI VINAYAK IRRIGATION PRIVATE LIMITED",
"SRI VINAYAKA AUTOMOBILES PRIVATE LIMITED",
"SRI VINAYAKA CHEMTECH PRIVATE LIMITED",
"SRI VINAYAKA CUTTING TOOLS PRIVATE LIMITED",
"SRI VINAYAKA MARKETING",
"SRI VINAYAKA MOBIKES PRIVATE LIMITED",
"SRI VINAYAKA VIDYA MANDIRA",
"SRI VINAYAKHA SPINNING MILLS PRIVATE LIMITED",
"SRI VISAKA TEXTILES PRIVATE LIMITED",
"SRI VISHNU ASSOCIATES PRIVATE LIMITED",
"SRI VISHNU BUILDCON PRIVATE LIMITED",
"SRI VISHNU CONSOL PRIVATE LIMITED",
"SRI VISHNU EXPLOSIVES PRIVATE LIMITED",
"SRI VISHNU GRANITES PRIVATE LIMITED",
"SRI VISHNU HOSIERY KNITTING PRIVATE LIMITED",
"SRI VISHNU LASERS PRIVATE LIMITED",
"SRI VISHNU PRIYA FINANCE",
"SRI VISHNU SHANKAR MILL LIMITED",
"SRI VISHNU SURYA TRANSPORT AND ENTERPRISES PRIVATE LIMITED",
"SRI VISHNU TIMBER",
"SRI VISHVANATH ENTERPRISES LIMITED",
"SRI VISHWA MEDSYSTEMS PRIVATE LIMITED",
"SRI VISHWAKARMA (EMERY STONES)INDUSTRIES PVT LTD",
"SRI VISHWAKARMA CO-OPERATIVE SOCIETY",
"SRI VISHWAKSENA BUILDERS PRIVATE LIMITED",
"SRI VISTHARA INFRASTRUCTURES PRIVATE LIMITED",
"SRI VISWA MEDICARE LIMITED",
"SRI VISWA SAI EDUCATIONAL SOCIETY",
"SRI VISWANADHA MUSHROOM FARM PRIVATE LIMITED",
"SRI VISWASANTHI EDUCATIONAL INSTITUTIONS PRIVATE LIMITED",
"SRI VITHYA SPINNERS PRIVATE LIMITED",
"SRI VIVEGHA ENGINEERING PRIVATE LIMITED",
"SRI VIVEKANANDA HOSPITALS",
"SRI VVNS LOGISTICS PRIVATE LIMITED",
"SRI VYJAYANTHI LABS PRIVATE LIMITED",
"SRI VYSHNAVI CHETANA PU SCIENCE COLLEGE",
"SRI VYSHNAVI DAIRY SPECIALITIES PRIVATE LIMITED",
"SRI VYSHNAVI FOODS PRIVATE LIMITED",
"SRI VYUHALAKSHMI PAPERS PRIVATE LIMITED",
"SRI WRIGHT HOMES INDIA PRIVATE LIMITED",
"SRI YADADRI LIFESCIENCES PRIVATE LIMITED",
"SRI YASHODA STEELS TRADING PRIVATE LIMITED",
"SRI YOGALAKSHMI BLUE METAL INDUSTRIES",
"SRI. UPASANA MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"SRI.AMMIREDDY OILS PRIVATE LIMITED",
"SRIAB CHEMICALS PRIVATE LIMITED",
"SRIADITYA VINYLS PRIVATE LIMITED",
"SRIAM LABS PRIVATE LIMITED",
"SRIAN INFRASTRUCTURES PRIVATE LIMITED",
"SRIAS LIFE SPACES LLP",
"SRIBALAJI CALLNET PRIVATE LIMITED",
"SRIBALAJI ENTERPRISES INDIA PRIVATE LIMITED",
"SRIBASH CHANDRA AGRO MILLS PRIVATE LIMITED",
"SRIBIR INDIA LTD",
"SRIBIR OVERSEAS LIMITED",
"SRIBS BIOTECHNIQS PRIVATE LIMITED",
"SRICHAITANYA STUDENTS FACILITY MANAGEMENT PRIVATE LIMITED",
"SRICHAKRA MILK PRODUCTS LLP",
"SRICHAKRA PRINTS PRIVATE LIMITED",
"SRICHAKRA TRANSTECH PRIVATE LIMITED",
"SRICHANDA M N M INSTITUTION",
"SRICHEM CONSULTANTS PRIVATE LIMITED",
"SRICITY ELECTRONICS MANUFACTURING CLUSTER PRIVATE LIMITED",
"SRICITY PROJECTS PRIVATE LIMITED",
"SRICO MARKETING PRIVATE LIMITED",
"SRICO POWERTECH PRIVATE. LIMITED",
"SRICO PROJECTS PRIVATE LIMITED",
"SRICO SEA AIR SERVICES PRIVATE LIMITED",
"SRICON LOGISTICS PRIVATE LIMITED",
"SRICURE HERBS INDIA PRIVATE LIMITED",
"SRIDATRI CONSUMER INDIA PRIVATE LIMITED",
"SRIDEVA LAM PRIVATE LIMITED",
"SRIDEVI MARBLES PRIVATE LIMITED",
"SRIDEVI WOMEN'S ENGINEERING COLLEGE",
"SRIDHA ENGINEERING PRIVATE LIMITED",
"SRIDHANALAKSHMI AUTO AGENCIES PRIVATE LIMITED",
"SRIDHAR AND BRITO",
"SRIDHAR INSURANCE BROKER PRIVATE LIMITED",
"SRIDHARA FOODS PRIVATE LIMITED",
"SRIDHI TRANSPORT COMPANY PRIVATE LIMITED",
"SRIDISAI ENGG COLLEGE",
"SRIDURGA ENTERPRISES PRIVATE LIMITED",
"SRIGAJANAN PETROLEUM PRIVATE LIMITED",
"SRIGEE ENTEPRISES PRIVATE LIMITED",
"SRIGGLE TECH PRIVATE LIMITED",
"SRIGOBIND AGRITECH PRIVATE LIMITED",
"SRIGOPAL PLYWOODS & LAMINATES PRIVATE LIMITED",
"SRIGOPAL YARN TRADING PRIVATE LIMITED",
"SRIGRO INTERACTIVE PRIVATE LIMITED",
"SRIHAN INFRATECH PRIVATE LIMITED",
"SRIHANS TECHNOLOGIES EXPORTS PRIVATE LIMITED",
"SRIHARI INFRACON PRIVATE LIMITED",
"SRIHIT LABS PRIVATE LIMITED",
"SRIHITHA HOSPITALS PRIVATE LIMITED",
"SRIHITHA SHOPPING SERVICES PRIVATE LIMITED",
"SRIJA SOLUTIONS PRIVATE LIMITED",
"SRIJAGANNATH COLD STORAGE PRIVATE LIMITED",
"SRIJAGDAMBA CYLINDER GASES PRIVATE LIMITED",
"SRIJAI AUTOS PRIVATE LIMITED",
"SRIJAN ALLOYS AND STEEL PRIVATE LIMITED",
"SRIJAN BHOG COMPANIES PRIVATE LIMITED",
"SRIJAN CEMENTS LIMITED",
"SRIJAN CHILDREN HOSPITAL PRIVATE LIMITED",
"SRIJAN COMMERCIAL PRIVATE LIMITED",
"SRIJAN DEVCON LIMITED",
"SRIJAN ECOLOGICAL UPLIFTMENT PRIVATE LIMITED",
"SRIJAN ENERGY SYSTEMS PRIVATE LIMITED",
"SRIJAN FERTILITY CLINIC PRIVATE LIMITED",
"SRIJAN INFRASSOCIATE PRIVATE LIMITED",
"SRIJAN MEDI SOLUTIONS PRIVATE LIMITED",
"SRIJAN MOTORS PRIVATE LIMITED",
"SRIJAN POLYPACKS LIMITED",
"SRIJAN PRIVATE LIMITED",
"SRIJAN PUBLISHERS PRIVATE LIMITED SPPL",
"SRIJAN REALTY PRIVATE LIMITED",
"SRIJAN SPECTRUM PRIVATE LIMITED",
"SRIJAN SUPAR FACILITIES LLP",
"SRIJAN SYSTEMS PRIVATE LIMITED",
"SRIJAN TECHNOLOGIES PRIVATE LIMITED",
"SRIJAN VATSALYA HOSPITAL PRIVATE LIMITED",
"SRIJATI SHOES PRIVATE LIMITED",
"SRIJAY ENGINEERING AND CONSULTANTS PRIVATE LIMITED",
"SRIJAY TECHINSIGHTS PRIVATE LIMITED",
"SRIJAYALAKSHMI AUTOMOBILES PRIVATE LIMITED",
"SRIJAYALAKSHMI AUTOMOTIVES PRIVATE LIMITED",
"SRIJAYAVILAS SUBBARAJ SPINNING MILLS PRIVATE LIMITED",
"SRIJI BALAJI TRADERS PRIVATE LIMITED",
"SRIJI COMPUTERS PRIVATE LIMITED",
"SRIJI CORPORATION PRIVATE LIMITED",
"SRIJI GOPALJI FOUNDRIES PRIVATE LIMITED",
"SRIJI METALLOYS PRIVATE LIMITED",
"SRIJITA AGENCIES PRIVATE LIMITED",
"SRIJITA STEEL PRIVATE LIMITED",
"SRIJON PACIFIC PRIVATE LIMITED",
"SRIJONI HEALING HOME",
"SRIKAA AQUA MINERAL PRIVATE LIMITED",
"SRIKAAR RETAIL PRIVATE LIMITED",
"SRIKAARYA INDUSTRIES PRIVATE LIMITED",
"SRIKAL AUTOMATION PRIVATE LIMITED",
"SRIKALAHASTHI PIPES LIMITED",
"SRIKALS GRAPHICS PRIVATE LIMITED",
"SRIKALYANI AUTOMOBILES PRIVATE LIMITED",
"SRIKAM PRINT PACK PRIVATE LIMITED",
"SRIKAMAL FASHIONS PRIVATE LIMITED",
"SRIKAMATCHI MEDICAL CENTER",
"SRIKANT MINECHEM (INDIA) PRIVATE LIMITED",
"SRIKANTH INTERNATIONAL",
"SRIKANTH PRODUCTIONS PRIVATE LIMITED",
"SRIKANYA STEEL BUILDING SYSTEMS PRIVATE LIMITED",
"SRIKAR BIOTECH PRIVATE LIMITED",
"SRIKAR CHEM & PHARMA INDIA PRIVATE LIMITED",
"SRIKAR ENTERPRISES PRIVATE LIMITED",
"SRIKAR LABORATORIES PRIVATE. LIMITED.",
"SRIKAR RICE AND SOLVENT INDUSTRIES PRIVATE LIMITED",
"SRIKARA AUTOMOBILES PRIVATE LIMITED",
"SRIKARA CONSULTANCY SERVICES PRIVATE LIMITED",
"SRIKARA HOSPITALS",
"SRIKARA PACKAGING PRIVATE LIMITED",
"SRIKARAM INFRATECH PRIVATE LIMITED",
"SRIKARAM PRESCIENCE PRIVATE LIMITED",
"SRIKARG PROJECTS PRIVATE LIMITED",
"SRIKARI IMPETUS SOLUTIONS PRIVATE LIMITED",
"SRIKAYA HEALTH INSTITUTE LIMITED",
"SRIKEM LABORATORIES PRIVATE LIMITED",
"SRIKHATU SHYAM TRADERS PRIVATE LIMITED",
"SRIKISHAN DALL UDYOG PRIVATE LIMITED",
"SRIKON MINING AND PROJECTS PRIVATE LIMITED",
"SRIKRISHNA INDUSTRIAL WORKS INDIA PRIVATE LIMITED",
"SRIKRISHNA POLYMER INDUSTRIES PRIVATE LIMITED",
"SRIKRISHNANJANEYA GAS AGENCY PRIVATE LIMITED",
"SRIKRISNA ESTATES AND CONSTRUCTIONS PRIVATE LIMITED",
"SRILA BUILDERS PRIVATE LIMITED",
"SRILAB POLYMERS PRIVATE LIMITED",
"SRILAKSHMI AUTO AGENCIES INDIA PRIVATE LIMITED",
"SRILAKSHMI AUTO ENTERPRISES INDIA PRIVATE LIMITED",
"SRILAKSHMI AUTOMOBILES PRIVATE LIMITED",
"SRILANAND MANSION PRIVATE LIMITED",
"SRILANKAN AIRLINES LIMITED",
"SRIMAANYA CONSUMER PRODUCTS PRIVATE LIMITED",
"SRIMAD ANDAVAN ARTS AND SCIENCE COLLEGE",
"SRIMADHU FACILITY SERVICES PRIVATE LIMITED",
"SRIMAN CHEMICALS PVT LTD",
"SRIMAN NARAYAN COMMERCIAL PRIVATE LIMITED",
"SRIMANI SILPAYAN (INDIA) PVT LTD",
"SRIMANTA SANKARDEV AUTO WORLD PRIVATE LIMITED",
"SRIMANTS DESIGNER CLOTHING PRIVATE LIMITED",
"SRIMAT KRIPA PRIVATE LIMITED",
"SRIMATHI SUNDARAVALLI MEMORIAL EDUCATIONAL TRUST",
"SRIMATI SUSHILADEVI DAGADUJIRAO DESHMUKH ANU AASHRAMSHALA TALAVADI",
"SRIMUKHA PRECISION PRODUCTS",
"SRIMY JEWELS PRIVATE LIMITED",
"SRIN SOFT TECHNOLOGIES PRIVATE LIMITED",
"SRINAG PHARMA PRIVATE LIMITED",
"SRINAGAR BANIHAL EXPRESSWAY LIMITED",
"SRINAGAR GLASS & PLYWOOD PRIVATE LIMITED.",
"SRINAGAR GLASS & WOOD PRIVATE LIMITED",
"SRINAGAR NET TECH PRIVATE LIMITED",
"SRINAGAR TECHNOLOGY CONSULTANTS PRIVATE LIMITED",
"SRINALA LEATHERS INDIA PRIVATE LIMITED",
"SRINANDA BUILDERS PRIVATE LIMITED",
"SRINAR ELECTRONICS PRIVATE LIMITED",
"SRINATE AGRI VENTURES AND REAL ESTATE PRIVATE LIMITED",
"SRINATH AGRO PRODUCTS PRIVATE LIMITED",
"SRINATH COLLEGE OF PHARMACY",
"SRINATH ELEVATORS PRIVATE LIMITED",
"SRINATH HOMES INDIA PRIVATE LIMITED",
"SRINATH PLANT AND EQUIPMENTS PRIVATE LIMITED",
"SRINATH SPINNERS PRIVATE LIMITED",
"SRINATH SPINNING MILLS PRIVATE LIMITED",
"SRINATH TRADING COMPANY",
"SRINATHJI ISPAT LIMITED",
"SRINATHJI'S CUISINES PRIVATE LIMITED",
"SRINAV OIL EXTRACTION PRIVATE LIMITED",
"SRINERGY CLEANTECH PRIVATE LIMITED",
"SRINI BPO PROJECTS PRIVATE LIMITED",
"SRINI INFOTECH PRIVATE LIMITED",
"SRINI PHARMACEUTICALS LIMITED",
"SRINIBAS PRADHAN CONSTRUCTIONS PRIVATE LIMITED",
"SRINIDHI ASSOCIATES",
"SRINIDHI COMPRINT PRIVATE LIMITED",
"SRINIDHI COTTONS PRIVATE LIMITED",
"SRINIDHI CREDIT PRIVATE LIMITED",
"SRINIDHI DESIGNBUILD PRIVATE LIMITED",
"SRINIDHI EDIBLE BRAN OILS PRIVATE LIMITED",
"SRINIDHI FINANCE PRIVATE LIMITED",
"SRINIDHI HOMES PRIVATE LIMITED",
"SRINIDHI HOSPITALITY SERVICES PRIVATE LIMITED",
"SRINIDHI INTERNATIONAL PRIVATE LIMITED",
"SRINIDHI INVESTMENT ADVISORS PRIVATE LIMITED",
"SRINIDHI REAL ESTATE AND CONSTRUCTIONS",
"SRINIDHI TRADEWINGS PRIVATE LIMITED",
"SRINIJA DRUGS PRIVATE LIMITED",
"SRINIKETAN FASHIONS LIMITED",
"SRINISHA COCOPEAT PRIVATE LIMITED",
"SRINITHI ENTERPRISES PRIVATE LIMITED",
"SRINIVAAS INFRA DEVELOPERS PRIVATE LIMITED",
"SRINIVAS CLEARING & SHIPPING INDIA PRIVATE LIMITED",
"SRINIVAS ELASTOMERS INDIA PRIVATE LIMITED",
"SRINIVAS ENGINEERING & ALLIED WORKS PRIVATE LIMITED",
"SRINIVAS FINE ARTS PRIVATE LIMITED",
"SRINIVAS INFRASTRUCTURE PRIVATE LIMITED",
"SRINIVAS INSTITUTE OF MEDICAL SCIENCE & RESEARCH CENTRE",
"SRINIVAS INSTITUTE OF TECHNOLOGY",
"SRINIVAS PAPERS PRIVATE LIMITED",
"SRINIVAS PRIYA HOSPITAL PRIVATE LIMITED",
"SRINIVAS PROCESSROS",
"SRINIVAS THEATRES PRIVATE LIMITED",
"SRINIVAS UNIVERSITY",
"SRINIVAS WASTE MANAGEMENT SERVICES PRIVATE LIMITED",
"SRINIVAS WASTE MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"SRINIVASA AUTOMOTIVES PRIVATE LIMITED",
"SRINIVASA BROILERS PRIVATE LIMITED",
"SRINIVASA BUILDCON (INDIA) PRIVATE LIMITED",
"SRINIVASA COTTON AND OIL MILLS LIMITED",
"SRINIVASA CYSTINE PRIVATE LIMITED",
"SRINIVASA EDIFICE PRIVATE LIMITED",
"SRINIVASA ENGINEERING PROJECTS PRIVATE LIMITED",
"SRINIVASA FARMS BIO ENERGY PRIVATE LIMITED",
"SRINIVASA FARMS PRIVATE LIMITED",
"SRINIVASA GARMENT PRIVATE LIMITED",
"SRINIVASA HAIR INDUSTRIES",
"SRINIVASA HATCHERIES PRIVATE LIMITED",
"SRINIVASA HOSPITAL",
"SRINIVASA INFRA BUILDCON INDIA PRIVATE LIMITED",
"SRINIVASA INSTT OF ENGINEERING & TECH",
"SRINIVASA MARUTI STEELS PRIVATE LIMITED",
"SRINIVASA MEDICAL AND IMAGING PRODUCTS PVT. LTD.",
"SRINIVASA MEDISALES PRIVATE LIMITED",
"SRINIVASA NERO MULTI SPECIALITY HOSPITAL",
"SRINIVASA NURSING HOME",
"SRINIVASA PAPER AGENCIES PRIVATE LIMITED",
"SRINIVASA PINNACLE HOSPITAL",
"SRINIVASA RAMANUJAN INSTITUTE OF TECHNOLOGY",
"SRINIVASA RESORTS LTD",
"SRINIVASA RICE INDUSTRIES",
"SRINIVASA ROAD TRANSPORT PRIVATE LIMITED",
"SRINIVASA SALES & SERVICES PRIVATE LIMITED",
"SRINIVASA SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED",
"SRINIVASA TRANSPORTS",
"SRINIVASA WELDMESH PRIVATE LIMITED",
"SRINIVASAN ASSOCIATES PRIVATE LIMITED",
"SRINIVASAN COLLEGE OF ARTS AND SCIENCE",
"SRINIVASAN HARDWARE",
"SRINIVASAN HEALTH & EDUCATIONAL TRUST",
"SRINIVASAN MEDICAL COLLEGE AND HOSPITAL",
"SRINIVASAN SOFTWARE SOLUTIONS PRIVATE LIMITED",
"SRINNOVA ISPAT PRIVATE LIMITED",
"SRIOM TEXOLENE PRIVATE LIMITED",
"SRIPA & RD VENTURES PRIVATE LIMITED",
"SRIPAD HOSPITAL",
"SRIPAD HOSPITALITY AND RETAIL PRIVATE LIMITED",
"SRIPAD STEELS PRIVATE LIMITED",
"SRIPADHA INDUSTRIES PRIVATE LIMITED",
"SRIPATH DIAGNOSTICS PRIVATE LIMITED",
"SRIPATHI PAPER AND BOARDS PRIVATE LIMITED",
"SRIPEKSHA ENGINEERING CONSULTANCY SERVICES PRIVATE LIMITED",
"SRIPOORNA HOLDINGS PRIVATE LIMITED",
"SRIPTON TECHNOLOGIES PRIVATE LIMITED",
"SRIPURNA AGRO PRODUCTS PRIVATE LIMITED",
"SRIRAAM CHEMICALS PRIVATE LIMITED",
"SRIRAGHAVENDRA CONCRETE TECHNOLOGIES PRIVATE LIMITED",
"SRIRAM ASSOCIATES PRIVATE LIMITED",
"SRIRAM COLD FORGINGS PRIVATE LIMITED",
"SRIRAM CONSTRUCTIONS",
"SRIRAM CONSULTANCY SERVICES INDIA PRIVATE LIMITED",
"SRIRAM CT SCAN SERVICES PRIVATE LIMITED",
"SRIRAM DESIGNERS & BUILDERS PRIVATE LIMITED",
"SRIRAM DISTRIBUTORS PRIVATE LIMITED",
"SRIRAM ENGINEERING COLLEGE",
"SRIRAM EXIM PRIVATE LIMITED",
"SRIRAM FOAMS PRIVATE LIMITED",
"SRIRAM GOLD PRIVATE LIMITED",
"SRIRAM HEALTHCARE PRIVATE LIMITED",
"SRIRAM KESHRIMAL STEELS PRIVATE LIMITED",
"SRIRAM SAFETY AND QUALITY MANAGEMENT SERVICES PRIVATE LIMITED",
"SRIRAM SEAFOOD PRIVATE LIMITED",
"SRIRAMA MOTOHUB PRIVATE LIMITED",
"SRIRAMCHARAN ENERGY AND INFRA PRIVATE LIMITED",
"SRIRAMSAVITRI BUILDERS AND LOGISTICS PRIVATE LIMITED",
"SRIRANGA CONCRETE PRODUCT PRIVATE LIMITED",
"SRIRANGA INFRASTRUCTURE PRIVATE LIMITED",
"SRIRANGAM DAIRY PRODUCTS PRIVATE LIMITED",
"SRIRANGAM MILK PRODUCTS PRIVATE LIMITED",
"SRIRATANA ELECTRICALS",
"SRIRENGA MOTORS PRIVATE LIMITED",
"SRIROOF INDUSTRIES PRIVATE LIMITED",
"SRIS FASTENERS PRIVATE LIMITED",
"SRIS SYNTHESIS PRIVATE LIMITED",
"SRISA JEWELLERS PRIVATE LIMITED",
"SRISABARI RELIABLE BUILDERS PRIVATE LIMITED",
"SRISAI IOL FIELD EQUIOMENT & MARINE SERVICES PRIVATE LIMITED",
"SRISAI TEJA ENGINEERS PRIVATE LIMITED",
"SRISAICHANDANA API PRIVATE LIMITED",
"SRISAILA NETWORKS PRIVATE LIMITED",
"SRISAIRAM PROJECTS LIMITED",
"SRISANVED AADIMAYA INDUSTRIES PRIVATE LIMITED",
"SRISESEVA HOSPITAL",
"SRISESHAA TECHNOLOGIES PRIVATE LIMITED",
"SRISHA FINE LINENS PRIVATE LIMITED",
"SRISHA FOUNDATION",
"SRISHAILA CONSTRUCTIONS PRIVATE LIMITED",
"SRISHAN AGENCIES PRIVATE LIMITED",
"SRISHOBA ORGANIC AGRO FARM INDIA PRIVATE LIMITED",
"SRISHOWRYA AUTOMOTIVE PRIVATE LIMITED",
"SRISHTA TECHNOLOGY PRIVATE LIMITED",
"SRISHTECH METAL CASTING (I) PRIVATE LIMITED",
"SRISHTI",
"SRISHTI BUILDERS PRIVATE LIMITED",
"SRISHTI CHAINS PRIVATE LIMITED",
"SRISHTI CLINIC PRIVATE LIMITED",
"SRISHTI COMMODITIES AND DERIVATIVES PRIVATE LIMITED",
"SRISHTI CONSTRUCTIONS",
"SRISHTI CREATIONS",
"SRISHTI DEN NETWORKS LIMITED",
"SRISHTI DIGILIFE PRIVATE LIMITED",
"SRISHTI DISTRIBUTORS PRIVATE LIMITED",
"SRISHTI FABRICS PRIVATE LIMITED",
"SRISHTI GOLD PRIVATE LIMITED",
"SRISHTI HOSPITALS AND RESEARCH CENTRE PRIVATE LIMITED",
"SRISHTI INFRABUILD PRIVATE LIMITED",
"SRISHTI INFRASTRUCTURE LIMITED.",
"SRISHTI INNOVATIVE COMPUTER SYSTEMS PRIVATE LIMITED",
"SRISHTI KRAFT & METALS (INDIA) PRIVATE LIMITED",
"SRISHTI MERCHANTS PRIVATE LIMITED",
"SRISHTI METALS PRIVATE LIMITED",
"SRISHTI MOBILES PRIVATE LIMITED",
"SRISHTI MOTORS PRIVATE LIMITED",
"SRISHTI OUTREACH PRIVATE LIMITED",
"SRISHTI PACKAGING PRIVATE LIMITED",
"SRISHTI PRECAST PRIVATE LIMITED",
"SRISHTI PROJECT CONSULTANTS PRIVATE LIMITED",
"SRISHTI PROMOTERS PRIVATE LIMITED",
"SRISHTI SOFTWARE APPLICATIONS PRIVATE LIMITED",
"SRISHTI SPECIALITY CHEMICALS PRIVATE LIMITED",
"SRISHTIS ENGITECH PRIVATE LIMITED",
"SRISHTY MEDICAL PRIVATE LIMITED",
"SRISHYLA FARMS PRIVATE LIMITED",
"SRISIRI INFRA PROJECTS PRIVATE LIMITED",
"SRISIVA INFRA PRIVATE LIMITED",
"SRISTAR SONA CHANDI PRIVATE LIMITED",
"SRISTI BIO-SCIENCES PRIVATE LIMITED",
"SRISTI CONSTRUCTION SERVICES PRIVATE LIMITED",
"SRISTI TEX-PACK PVT LTD",
"SRISTI VYAPAAR PRIVATE LIMITED",
"SRISTISANCHAR WEBNET LIMITED",
"SRISUPRADEEP ENTERPRISES PRIVATE LIMITED",
"SRISWASTI HOSPITALS PRIVATE LIMITED",
"SRIT EGOVERNANCE PRIVATE LIMITED",
"SRIT INFOSYSTEMS PRIVATE LIMITED",
"SRITECH ELECTRONICS AND SYSTEMS PRIVATE LIMITED",
"SRITECH LIPID PROCESS TECHNOLOGIES PRIVATE LIMITED",
"SRITHAI SUPERWARE INDIA LIMITED",
"SRITHAI SUPERWARE MANUFACTURING PRIVATE LIMITED",
"SRITRANSWAYS LOGISTICS PRIVATE LIMITED",
"SRIVA TECHNOLOGIES PRIVATE LIMITED",
"SRIVAARI CHEMICALS PRIVATE LIMITED",
"SRIVAASUDEVAA TOWNSHIP PRIVATE LIMITED",
"SRIVALLI SHIPPING & TRANSPORT PRIVATE LIMITED",
"SRIVANGO TECHNOLOGIES",
"SRIVANI JR DEGREE COLLEGE",
"SRIVANI JUNIOR COLLEGE",
"SRIVAR PHARMA PRIVATE LIMITED",
"SRIVARI AUTOMOTIVES PRIVATE LIMITED",
"SRIVARI AVENUES (INDIA) PRIVATE LIMITED",
"SRIVARI COTTON PRIVATE LIMITED",
"SRIVARI HI-TECH INDUSTRIES PRIVATE LIMITED",
"SRIVARI HOTELS RESORTS & FARMS PRIVATE LIMITED",
"SRIVARI INTERNATIONAL PRIVATE LIMITED",
"SRIVARI LITES PRIVATE LIMITED",
"SRIVARI SPICES AND FOODS LIMITED",
"SRIVASAVI ADHESIVE TAPES LIMITED",
"SRIVASAVI ADHESIVE TAPES PRIVATE LIMITED",
"SRIVASTAVA FRACTURE AND ORTHOPAEDEC CARE PRIVATE LIMITED",
"SRIVATHSA CHIT FUND (I) PRIVATE LIMITED",
"SRIVATHSA LIFESCIENCES PRIVATE LIMITED",
"SRIVATHSA POWER PROJECTS PRIVATE LIMITED",
"SRIVATSA BIO-TECH INDIA PRIVATE LIMITED",
"SRIVATSA ENTERPRISES PRIVATE LIMITED",
"SRIVATSAV URBAN ESTATES & DEVELOPERS PRIVATE LIMITED",
"SRIVAY INDUSTRIES LIMITED",
"SRIVAY INFRA PROJECTS PRIVATE LIMITED",
"SRIVEDA SATTVA PRIVATE LIMITED",
"SRIVELMURUGAN ENGINEERING & CONSTRUCTION PRIVATE LIMITED",
"SRIVEN AVENUES PRIVATE LIMITED",
"SRIVEN CORPORATION",
"SRIVEN EDUCATIONAL SOCIETY",
"SRIVEN ESTATES PRIVATE LIMITED",
"SRIVEN HOSPITALS PRIVATE LIMITED",
"SRIVEN INFO CONSULTANTS INDIA PRIVATE LIMITED",
"SRIVEN PHARMACHEM INDIA PRIVATE LIMITED",
"SRIVEN PROPERTIES",
"SRIVEN SPINCOT PRIVATE. LIMITED.",
"SRIVENK INVESTMENTS AND FINANCE PRIVATE LIMITED",
"SRIVENKANNA MOTORS PRIVATE LIMITED",
"SRIVI EXPORTS AND IMPORTS PRIVATE LIMITED",
"SRIVI LIONS MATRIC HR SEC SCHOOL",
"SRIVIBHU TEXTILE PRIVATE LIMITED",
"SRIVIDYA INFRASTRUCTURES PRIVATE LIMITED",
"SRIVIGREN SOLUTIONS PRIVATE LIMITED",
"SRIVILAS HYDROTECH PRIVATE.LIMITED",
"SRIVIN AGRO FARMS PRIVATE LIMITED",
"SRIVIRA INFRA PRIVATE LIMITED",
"SRIYA FARMS AND FEEDS PRIVATE LIMITED",
"SRIYAH INSURANCE BROKERS PRIVATE LIMITED",
"SRIYAM SOFTWARE SOLUTIONS LLP",
"SRIYAN ENGINEERS & CONTRACTORS PRIVATE LIMITED",
"SRIYAN INFRAPROJECTS INDIA PRIVATE LIMITED",
"SRIYAN UDYOG PRIVATE LIMITED",
"SRIYANS ENTERPRISES LIMITED",
"SRIYANSH ISPAT LIMITED",
"SRIYANSH KNITTERS",
"SRIYANTRA ENGINEERS PRIVATE LIMITED",
"SRIYASH COUNTRY HOMES PRIVATE LIMITED",
"SRIYASH FASHIONS PRIVATE LIMITED",
"SRIYASH VYAPAAR PRIVATE LIMITED",
"SRIYATHARTH INFRATECH PRIVATE LIMITED",
"SRJ APPARELS PRIVATE LIMITED",
"SRJ CONSTRUCTION PRIVATE LIMITED",
"SRJ EDU SERVICES PRIVATE LIMITED",
"SRJ ENGINEERS PRIVATE LIMITED",
"SRJ ENGITECH PRIVATE LIMITED",
"SRJ HEALTH CARE PRIVATE LIMITED",
"SRJ INFOJNANA SYSTEM PRIVATE LIMITED",
"SRJ PIPING INDIA PRIVATE LIMITED",
"SRJK FOREX PRIVATE LIMITED",
"SRK AUTOMOBILE AND MARKETING PRIVATE LIMITED",
"SRK AVIACOM (INDIA) PRIVATE LIMITED",
"SRK BHARAT VIDYUT PRIVATE LIMITED",
"SRK CLEANROOMS PRIVATE LIMITED",
"SRK CONSTRUCTIONS AND PROJECTS PRIVATE LIMITED",
"SRK FASTENERS PRIVATE LIMITED",
"SRK GAS INDUSTRIES PRIVATE LIMITED",
"SRK GREEN AVENUES PRIVATE LIMITED",
"SRK HOLIDAYS PRIVATE LIMITED",
"SRK INFRA PROJECTS PRIVATE LIMITED",
"SRK INFRACON INDIA PRIVATE LIMITED",
"SRK INFRATECH PRIVATE LIMITED",
"SRK INGREDIENTS PRIVATE LIMITED",
"SRK LIFE SCIENCES & RESEARCH INDIA PRIVATE LIMITED",
"SRK MARKETING PRIVATE LIMITED",
"SRK MATRIC HR SEC SCHOOL",
"SRK METALS AND PLASTICS PRIVATE LIMITED",
"SRK MINING SERVICES INDIA PRIVATE LIMITED",
"SRK MULTITRADE CORPORATION PRIVATE LIMITED",
"SRK PEOPLE CONSULTANT I PRIVATE LIMITED",
"SRK PETROCHEMICALS LIMITED",
"SRK POWERTECH PRIVATE LIMITED",
"SRK PROCESSES AND CONTROLS PRIVATE LIMITED",
"SRK RECREATIONS PRIVATE LIMITED",
"SRK TECHNOLOGY PRIVATE LIMITED",
"SRK TEXTILES PRIVATE LIMITED",
"SRK TOOL & MOULDERS PRIVATE LIMITED",
"SRKAY CONSULTING GROUP LLP",
"SRKM STEEL PRIVATE LIMITED",
"SRKN ADVISORY SERVICES PRIVATE LIMITED",
"SRKV GANDHI TEACHERS TRNG INST-641020",
"SRKV INDUSTRIAL TRAINING INST-641020",
"SRKV INST OF AGRI AND RURAL DEV-641020",
"SRL CONSTRUCTION PRIVATE LIMITED",
"SRL DEVELOPERS PRIVATE LIMITED",
"SRL EARTHMOVING SOLUTION PRIVATE LIMITED",
"SRL GREEN AND CLEAN POWER PRIVATE LIMITED",
"SRL IMPEX PVT LTD",
"SRL MINING AND DEVELOPER PRIVATE LIMITED",
"SRL PROFESSIONAL SERVICES PRIVATE LIMITED",
"SRL REACH LIMITED",
"SRLPS FOODS PRIVATE LIMITED",
"SRM ARTS AND SCIENCE COLLEGE",
"SRM AXIS INTELLECTS INDIA PRIVATE LIMITED",
"SRM BIO ORGANIC INDIA PRIVATE LIMITED",
"SRM CAPITAL MARKET PVT.LTD.",
"SRM CONTRACTORS LIMITED",
"SRM EDUCATION AND FINANCIAL CONSULTANTS PRIVATE LIMITED",
"SRM ENGINEERING COLLEGE",
"SRM ENGINEERING CONSTRUCTION CORPORATION LIMITED",
"SRM ENTERPRISES PRIVATE LIMITED",
"SRM ESWARI ENGINEERING COLLEGE",
"SRM GLOBAL INFRAA LIMITED",
"SRM HOSPITALS (UNIT OF SRM GROUP OF INSTITUTIONS )",
"SRM HOTELS PRIVATE LIMITED",
"SRM INSTITUTE FOR MEDICAL SCIENCE",
"SRM INSTITUTE OF HOTEL MANAGEMENT",
"SRM INSTITUTE OF SCIENCE AND TECHNOLOGY",
"SRM INSTITUTE OF SCIENCE AND TECHNOLOGY EXAMINATIONS",
"SRM IST COLLEGE OF SCIENCE AND HUMANITIES",
"SRM LEARNING TREE PRIVATE LIMITED",
"SRM MEDICAL COLLEGE HOSPITAL RESEARCH CENTRE",
"SRM MOTORS PRIVATE LIMITED",
"SRM NIKKI AUTO SYSTEMS INDIA PRIVATE LIMITED",
"SRM NURSING COLLEGE",
"SRM PHYSIOTHERAPHY COLLEGE",
"SRM PLASTO PRIVATE LIMITED",
"SRM PLASTOCHEM PRIVATE LIMITED",
"SRM POWER PRIVATE LIMITED",
"SRM PRIVATE LIMITED",
"SRM PRODUCTS PRIVATE LIMITED",
"SRM PUBLIC SCHOOL",
"SRM REASEARCH INSTITUTE",
"SRM RESOURCES PRIVATE LIMITED",
"SRM RETAILS AND HOSPITALITY SERVICES LIMITED",
"SRM SCHOOL OF LAW",
"SRM SMART HOOPS PRIVATE. LIMITED.",
"SRM SPINNERS LIMITED",
"SRM TECHNOLOGIES PRIVATE LIMITED",
"SRM TECHSOL PRIVATE LIMITED",
"SRM TRANSPORTS INDIA PRIVATE LIMITED",
"SRM TRP ENGINEERING COLLEGE",
"SRM UNIVERSITY",
"SRM VALLIAMMAI ENGINEERING COLLEGE",
"SRM360 CONSULTING SERVICES PRIVATE LIMITED",
"SRMB SRIJAN PRIVATE LIMITED",
"SRMC INDIA PRIVATE LIMITED",
"SRMG STONE PRIVATE LIMITED",
"SRMK FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"SRMPR CONSTRUCTION PRIVATE LIMITED",
"SRMT WASTE MANAGEMENT PRIVATE LIMITED",
"SRN AUTOMATION PRIVATE LIMITED",
"SRN CHAIN AND JEWELLERY PRIVATE LIMITED",
"SRN DATA CREATE SYSTEMS PRIVATE LIMITED",
"SRN DISTRIBUTIONS PRIVATE LIMITED",
"SRN ENGINEERING AND CONSULTING SERVICES PRIVATE LIMITED",
"SRN GLOBALS PRIVATE LIMITED",
"SRN KNITS PRIVATE LIMITED",
"SRN MEDICAL COLLEGE",
"SRN MEDITECH PRIVATE LIMITED",
"SRNC BODYCARE PRIVATE LIMITED",
"SRNG FINANCE PRIVATE LIMITED",
"SRNK LOGISTICS PRIVATE LIMITED",
"SRO FOODS INDIA PRIVATE LIMITED",
"SRP ADHESIVES PRIVATE LIMITED",
"SRP AUTOMATION PRIVATE LIMITED",
"SRP COATINGS AND CHEMICALS (INDIA) PRIVATE LIMITED",
"SRP CRANE CONTROLS (INDIA) PRIVATE LIMITED",
"SRP DIGITAL SERVICES PRIVATE LIMITED",
"SRP ENTERPRISES PRIVATE LIMITED",
"SRP ENVIRO SYSTEMS PRIVATE LIMITED",
"SRP GEARS PRIVATE LIMITED",
"SRP LOGISTICS PRIVATE LIMITED",
"SRP PROSPERITA HOTEL VENTURES LIMITED",
"SRP PUMPS PRIVATE LIMITED",
"SRP SYNTHETIC RUBBER PRODUCTS PRIVATE LIMITED",
"SRPETRO CHEMICAL PRIVATE LIMITED",
"SRPM HAAT LLP",
"SRPS FINTECH PRIVATE LIMITED",
"SRPT ENGINEERING PRIVATE LIMITED",
"SRR ANALYTICAL LAB PRIVATE LIMITED",
"SRR ENERGY AND AUTOMATION PRIVATE LIMITED",
"SRR ENTERPRISE",
"SRR GRAND BUILDTECH PRIVATE LIMITED",
"SRR PROJECTS PRIVATE LIMITED",
"SRR TECHNO SERVICES PRIVATE LIMITED",
"SRRI BALA JAGATHAMBAL SPINNING MILLS PRIVATE LIMITED",
"SRRINIVAS INFRABUILDTECH PRIVATE LIMITED",
"SRRM PROJECTS PRIVATE LIMITED",
"SRRS TELE SERVICES PRIVATE LIMITED",
"SRS ADVISORY PRIVATE LIMITED",
"SRS AGRI FOODS",
"SRS BUSINESS SOLUTIONS INDIA PRIVATE LIMITED",
"SRS CARGO LOGISTICS INDIA PRIVATE LIMITED",
"SRS CARS PRIVATE LIMITED",
"SRS COMBINED CARGO PRIVATE LIMITED",
"SRS DIECASTING PRIVATE LIMITED",
"SRS ENTERTAINMENT INDIA LIMITED",
"SRS FASHIONS PRIVATE LIMITED",
"SRS FREIGHT LOGISTICS PRIVATE LIMITED",
"SRS FREIGHT MANAGEMENT LIMITED",
"SRS INFOWAY",
"SRS INFRAWAY PRIVATE LIMITED",
"SRS INTERNATIONAL SCHOOL",
"SRS ISPATT PRIVATE LIMITED",
"SRS LIVE TECHNOLOGIES PRIVATE LIMITED",
"SRS LOGICARE PRIVATE LIMITED",
"SRS PAPERS AND BOARDS PRIVATE LIMITED",
"SRS PHARMACEUTICALS PRIVATE LIMITED",
"SRS PORTFOLIO LIMITED",
"SRS STEEL PRIVATE LIMITED",
"SRS TECH EXPERTS PRIVATE LIMITED",
"SRS THERMAX LIMITED",
"SRS TRANS LOGISTICS PRIVATE LIMITED",
"SRS ZIP INDUSTRIES PRIVATE LIMITED",
"SRSC INFRA PRIVATE LIMITED",
"SRSG BROADCAST INDIA PRIVATE LIMITED",
"SRSINDIA TECHNICALS PRIVATE LIMITED",
"SRSS AGRO PRIVATE LIMITED",
"SRSS SECURITY SERVICE",
"SRSS VENUS HOSPITAL",
"SRT COTSYN PRIVATE LIMITED",
"SRT SPORTS MANAGEMENT PRIVATE LIMITED",
"SRTC TECH SOLUTIONS PRIVATE LIMITED",
"SRTP GOURMET FOODS PRIVATE LIMITED",
"SRU STEELS LIMITED",
"SRUJAN FOODS PRIVATE LIMITED",
"SRUJAN JEWELLERS INDIA PRIVATE LIMITED",
"SRUJAN MAHILA VIKAS FOUNDATION",
"SRUJAN SOFTECH INDIA PRIVATE LIMITED",
"SRUSHTI BATHS AND INTERIORS PRIVATE LIMITED",
"SRUSHTI CORPORATION",
"SRUSHTI CREATIONS PRIVATE LIMITED",
"SRUSHTI EDUCATION SYSTEMS PRIVATE LIMITED",
"SRUSHTI ENGINEERING INNOVATIONS PRIVATE LIMITED",
"SRUSHTI ENTERPRISES",
"SRUSHTI EVENTS PRIVATE LIMITED",
"SRUSHTI EXPORTS (INDIA) PRIVATE LIMITED",
"SRUSHTI G INFRA & AGRO LLP",
"SRUSHTI HOSPITAL PRIVATE LIMITED",
"SRUSHTI INFRA & AGRO PROJECTS LLP",
"SRUSHTI PHARMACEUTICALS PRIVATE LIMITED",
"SRUSHTI SANGAM ENTERPRISES PRIVATE LIMITED",
"SRUSHTI SEVA PRIVATE LIMITED",
"SRUSHTI TUBES PRIVATE LIMITED",
"SRUSHTIDHARA EXIM PRIVATE LIMITED",
"SRUSHTY GLOBAL SOLUTIONS PRIVATE LIMITED",
"SRUSTI AGRO FARMS PRIVATE LIMITED",
"SRUSTI INFRADEVELOPERS (INDIA) PRIVATE LIMITED",
"SRUTHI ENTERPRISES PRIVATE LIMITED",
"SRUTHI TOTAL HR SOLUTIONS PRIVATE LIMITED",
"SRUTI FILATEX PRIVATE LIMITED",
"SRUTIKSHA CONSULTANCY AND CONSTRUCTIONS PRIVATE LIMITED",
"SRV BIZCON PRIVATE LIMITED",
"SRV C HOSPITAL LLP",
"SRV DAMAGE PREVENTIONS PRIVATE LIMITED",
"SRV FOREX PRIVATE LIMITED",
"SRV GLOBAL FREIGHT PRIVATE LIMITED",
"SRV HOSPITAL",
"SRV IT HUB PRIVATE LIMITED",
"SRV KNITTECH PRIVATE LIMITED",
"SRV MAMATA HOSPITAL",
"SRV MEDIA PRIVATE LIMITED",
"SRV STEELS PRIVATE LIMITED",
"SRV SYTHETICS",
"SRV TECHNO ENGINEERING PRIVATE LIMITED",
"SRVC CONSTRUCTIONS PRIVATE LIMITED",
"SRY CASTINGS PRIVATE LIMITED",
"SRYARHAM SAFETY SOLUTION PRIVATE LIMITED",
"SRYMPEX STAFFING PRIVATE LIMITED",
"SS & COMPANY",
"SS AGRI TECHNOPOLIS AND TRADES PRIVATE LIMITED",
"SS ALLOY PRODUCTS PVT LTD",
"SS ALUM PRIVATE LIMITED",
"SS AND C GLOBE OP",
"SS ASSOCIATES INNOVATION LAB PRIVATE LIMITED",
"SS AUTOMATION SOLUTIONS PRIVATE LIMITED",
"SS BHARTI MEDICARE PRIVATE LIMITED",
"SS BISWAL VENTURES PRIVATE LIMITED",
"SS BUILDTECH VENTURES PRIVATE LIMITED",
"SS BUILDWELL PRIVATE LIMITED",
"SS BUSINESS ENABLERS PRIVATE LIMITED",
"SS CARGO & LOGISTICS PRIVATE LIMITED",
"SS CARGO MOVERS",
"SS CHAUHANS CONSTRUCTION PRIVATE LIMITED",
"SS COMMUNICATION & SERVICES PRIVATE LIMITED",
"SS CON-CAST PRIVATE. LIMITED.",
"SS CONTRACTORS",
"SS CORESHOP",
"SS CORPORATE SECURITIES LIMITED",
"SS COUNTRYWIDE HOTELS PRIVATE LIMITED",
"SS DENTAL BOUTIQUES PRIVATE LIMITED",
"SS DIAL PRIVATE LIMITED",
"SS DIGITAL SOLUTIONS PRIVATE LIMITED",
"SS EDUKS MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"SS ENGINEERING WORKS LIMITED",
"SS ENTERPRISES",
"SS ENVIROTHERMAL TECHNOLOGIES PRIVATE LIMITED",
"SS EXCAVATION SOLUTIONS LLP",
"SS EXHIBITIONS & MEDIA PRIVATE LIMITED",
"SS FASTNERS PRIVATE LIMITED",
"SS FIBER NET OPTICAL COMMUNICATION PRIVATE LIMITED",
"SS FILTERS PRIVATE LIMITED",
"SS FLEXHOSE INDIA PRIVATE LIMITED",
"SS FLEXIBLES PRIVATE LIMITED",
"SS GLOBAL LOGISTICS PRIVATE LIMITED",
"SS GRAVURES PRIVATE LIMITED",
"SS GROUP PRIVATE LIMITED",
"SS HOSPITAL & RESEARCH CENTRE",
"SS HOSPITALITY PRIVATE LIMITED",
"SS INDUS SOLAR ENERGY PRIVATE LIMITED",
"SS INFORMATION SYSTEMS PRIVATE LIMITED",
"SS INFRA SERVICES INDIA PRIVATE LIMITED",
"SS INSURANCE BROKERS PRIVATE LIMITED",
"SS INTERNATIONAL ENERGY PRIVATE LIMITED",
"SS JAY PROJECT CONSULTANTS INDIA PRIVATE LIMITED",
"SS JUPITER INFRA LIMITED",
"SS KHEDEKAR LEADING EDGE PRIVATE LIMITED",
"SS LIFEVISION PRIVATE LIMITED",
"SS MANUFACTURING PRIVATE LIMITED",
"SS MICROTECH PRIVATE LIMITED",
"SS MOTOGEN PRIVATE LIMITED",
"SS MULTISPECIALTY HOSPITAL",
"SS NIRAMAYA PRIVATE LIMITED",
"SS OPTIMIZED SOFTECH PRIVATE LIMITED",
"SS PRINT TO PACK PRIVATE LIMITED",
"SS PULAGAM SPINNING MILLS PRIVATE LIMITED",
"SS RAIL WORKS PRIVATE LIMITED",
"SS RANA CONSTRUCTION PRIVATE LIMITED",
"SS REALTY INVESTMENTS PRIVATE LIMITED",
"SS REFRIGERATION & INFRAPROMOTERS PRIVATE LIMITED",
"SS RYDERS INDIA PRIVATE LIMITED",
"SS SOAM ENGINEERS PRIVATE LIMITED",
"SS SOFT SOLUTIONS PRIVATE LIMITED",
"SS SPARSH HOSPITAL, RAJARAJESHWARI NAGAR",
"SS SS CONSTRUCTIONS PRIVATE LIMITED",
"SS STEELLOY PRIVATE LIMITED",
"SS STUDIO FILMS PRIVATE LIMITED",
"SS SUPPLY CHAIN SOLUTION PRIVATE LIMITED",
"SS TECHINT PRIVATE LIMITED",
"SS TECHNO LIMITED",
"SS TELECOM AND INFRASTRUCTURE PRIVATE LIMITED",
"SS TEXTILE MILLS PRIVATE LIMITED",
"SS TOTAL CONSTRUCTION (INDIA) PRIVATE LIMITED",
"SS TOURS PRIVATE LIMITED",
"SS UTENSILS MANUFACTURING COMPANY PRIVATE LIMITED",
"SS UTILITY SERVICES PRIVATE LIMITED",
"SS UV SERVICES PRIVATE LIMITED",
"SS VAIDYA HEALTH CARE PRIVATE LIMITED",
"SS VITRAN HEALTHCARE PRIVATE LIMITED",
"SS WINDOWS PRIVATE LIMITED",
"SS&C FINTECH SERVICES INDIA PRIVATE LIMITED",
"SS&C GLOBEOP",
"SS4 SECURITY MANAGEMENT PRIVATE LIMITED",
"SSA FACILITY MANAGEMENT PRIVATE LIMITED",
"SSA FINSERV PRIVATE LIMITED",
"SSA GEMS LIMITED LIABILITY PARTNERSHIP",
"SSA INFOSYSTEMS PRIVATE LIMITED",
"SSA TECHNO CONSTRUCTION PRIVATE LIMITED",
"SSAB ENERGY & MINERALS LIMITED",
"SSAGRI GROUP PRIVATE LIMITED",
"SSAMH INTERNATIONAL PRIVATE LIMITED",
"SSAMJUNG ENVIRONMENT CLEANING PRIVATE LIMITED",
"SSANGYONG ENGINEERING & CONSTRUCTION COMPANY LIMITED",
"SSAP ENGINEERS AND CONSULTANTS (OPC) PRIVATE LIMITED",
"SSAPP OVERSEAS PRIVATE LIMITED",
"SSAPPHIRE ASTA PRIVATE LIMITED",
"SSAR IMPEX PRIVATE LIMITED",
"SSAVCO UNIVERSAL PRIVATE LIMITED",
"SSAY LOGISTICS AND CARRIERS PRIVATE LIMITED",
"SSB ALLOYS AND STEELS PRIVATE LIMITED",
"SSB ANIMAL FEED PRIVATE LIMITED",
"SSB AUTOMOBILES PRIVATE LIMITED",
"SSB DEVELOPERS BUILDERS & PROMOTERS PRIVATE LIMITED",
"SSB DIGITAL PRIVATE LIMITED",
"SSB ENGINEERS PRIVATE. LIMITED.",
"SSB HEART AND MULTISPECIALTY HOSPITAL",
"SSB INDUSTRIES",
"SSB INFOSYSTEMS PRIVATE LIMITED",
"SSB INFRASTRUCTURE PRIVATE LIMITED",
"SSB INFRATECH PRIVATE LIMITED",
"SSB SOFTWARE SOLUTIONS PRIVATE LIMITED",
"SSBA SERVICES PRIVATE LIMITED",
"SSBJ ENTERPRISE PRIVATE LIMITED",
"SSBM REALTY AND HOSPITALITY PRIVATE LIMITED",
"SSBRAND SOLUTIONS PRIVATE LIMITED",
"SSBT LOGISTIC INDIA PRIVATE LIMITED",
"SSC PROJECTS PRIVATE LIMITED",
"SSC SHOES PRIVATE LIMITED",
"SSC TRADECOM PRIVATE LIMITED",
"SSCA FUELS PRIVATE LIMITED",
"SSCC CONSTRUCTIONS PRIVATE LIMITED",
"SSCN PRIVATE LIMITED",
"SSD AGRO CARE PRIVATE LIMITED",
"SSD AUTOMOBILES PRIVATE LIMITED",
"SSD FLOWTECH PRIVATE LIMITED",
"SSD FOODS AND PAPERS PRIVATE LIMITED",
"SSD INFRASTRUCTURES PRIVATE LIMITED",
"SSD MANAGEMENT SERVICES PRIVATE LIMITED",
"SSD MEDICAL SUPPLIES PRIVATE LIMITED",
"SSD OVERSEAS",
"SSD REALTORS PRIVATE LIMITED",
"SSD SECURITIES PRIVATE LIMITED",
"SSD SWITCHGEAR PRIVATE LIMITED",
"SSD VIJAY TRADING PRIVATE LIMITED",
"SSDB TECH SERVICES PRIVATE LIMITED",
"SSDC INFRASTRUCTURE PRIVATE LIMITED",
"SSDM INFRASTRUCTURE PRIVATE LIMITED",
"SSDN CREATIONS PRIVATE LIMITED",
"SSDN IMPEX PRIVATE LIMITED",
"SSDN TECHNOLOGIES PRIVATE LIMITED",
"SSE EXMO PRIVATE LIMITED",
"SSE INFRASTRUCTURE AND DEVELOPERS PRIVATE LIMITED",
"SSE MANPOWER CONSULTANCY PRIVATE LIMITED",
"SSE WORKFORCE SERVICES PRIVATE LIMITED",
"SSE&S ENGINEERS PRIVATE LIMITED",
"SSENT METAL WORKS PRIVATE LIMITED",
"SSENTIALIST CLOTHING PRIVATE LIMITED",
"SSEPL TECHNO PRIVATE LIMITED",
"SSF LIMITED",
"SSF PLASTICS INDIA PRIVATE LIMITED",
"SSF POLYMERS PRIVATE LIMITED",
"SSG AUTOMOTIVE COMPONENTS PRIVATE LIMITED",
"SSG BUSINESS SERVICES PRIVATE LIMITED",
"SSG CONSULTING PRIVATE LIMITED",
"SSG FOOD PRIVATE LIMITED",
"SSG GLOBAL PETRO PRIVATE LIMITED",
"SSG HOSPITAL",
"SSG INFRATECH PRIVATE LIMITED",
"SSG METALIKS (INDIA) PRIVATE LIMITED",
"SSG PHARMA PRIVATE LIMITED",
"SSG RENEW-TECH PRIVATE LIMITED",
"SSG STELCO PRIVATE LIMITED",
"SSG YARNS PRIVATE LIMITED",
"SSGL INNOVATIONS PRIVATE LIMITED",
"SSGT HVAC & IT INFRA PRIVATE LIMITED",
"SSH AGRO PRIVATE LIMITED",
"SSH DELICACIES PRIVATE LIMITED",
"SSHIVAY TECHNOCAST PRIVATE LIMITED",
"SSHOPPEE.COM PRIVATE LIMITED",
"SSI AERATION PRIVATE LIMITED",
"SSI CABLES PRIVATE LIMITED",
"SSI CONTRACTORS PRIVATE LIMITED",
"SSI STAFFING PRIVATE LIMITED",
"SSIEL SIGNATURE GRAINS PRIVATE LIMITED",
"SSIF INDUSTRIES PRIVATE LIMITED",
"SSIPL LIFESTYLE PRIVATE LIMITED",
"SSIPL RETAIL LIMITED",
"SSIZ INTERNATIONAL PRIVATE LIMITED\n",
"SSJ COMMODITIES PRIVATE LIMITED",
"SSJ ENGINEERS AND EXPORTERS PRIVATE LIMITED",
"SSJ FINANCE & SECURITIES PRIVATE LIMITED",
"SSJK EXIM PRIVATE LIMITED",
"SSK AGRO FARMER PRODUCER COMPANY LIMITED",
"SSK BIOSCIENCES PRIVATE LIMITED",
"SSK CHEMICALS PRIVATE LIMITED.",
"SSK DEVCON PRIVATE LIMITED",
"SSK ELECTRONICSANDSYSTEMS PRIVATE LIMITED",
"SSK EXPORTS LIMITED",
"SSK FOODS PRIVATE LIMITED",
"SSK FRESH FRUIT PRIVATE LIMITED",
"SSK INFOTECH PRIVATE. LIMITED",
"SSK IRON AND STEELS PRIVATE LIMITED",
"SSK ISPAT PRIVATE LIMITED",
"SSK LABS PRIVATE LIMITED",
"SSK LOGITECH PRIVATE LIMITED",
"SSK MILK FOODS PRIVATE LIMITED",
"SSK PRECISION COMPONENTS MANUFACTURING PRIVATE LIMITED",
"SSK RETAILS PRIVATE LIMITED",
"SSK SMART MOVE LOGISTICS PRIVATE LIMITED",
"SSK TEA COMPANY PRIVATE LIMITED",
"SSK TILES PRIVATE LIMITED",
"SSK VENTURES PRIVATE LIMITED",
"SSKC INFRATECH PRIVATE LIMITED",
"SSKINNOVATIVE POWER SOLUTIONS PRIVATE LIMITED",
"SSKK EXPORTS PRIVATE LIMITED",
"SSKS TRADERS PRIVATE LIMITED",
"SSKTECH INFOLINE PRIVATE LIMITED",
"SSKV COLLEGE OF ARTS AND SCIENCE FOR WOMEN",
"SSKV TECHBUILDS PRIVATE LIMITED",
"SSL BIOTECH INDIA PRIVATE LIMITED",
"SSL CONSOLIDATED LTD",
"SSL FOREX PRIVATE LIMITED",
"SSL FREIGHT FORWARDERS PRIVATE LIMITED",
"SSL INDUSTRIES LIMITED",
"SSLD VARSHNEY INSTITUTE OF MANAGEMENT & ENGINEERING? ALIGARH",
"SSM CENTRAL SCHOOL SENIOR SECONDARY",
"SSM CREATIVE SOLUTIONS PRIVATE LIMITED",
"SSM FORGE PRIVATE LIMITED",
"SSM FORMULATIONS PRIVATE LIMITED",
"SSM HOTELS & PROJECTS PRIVATE LIMITED",
"SSM MULTISPECIALITY HOSPITAL PRIVATE LIMITED",
"SSM ORGANIC PRIVATE LIMITED",
"SSM RETAIL PRIVATE LIMITED",
"SSM SECURITIES PRIVATE LIMITED",
"SS-MART RETAIL LLP",
"SSMASS MARKETING PRIVATE LIMITED",
"SSMF LEATHER TREND PRIVATE LIMITED",
"SSMRV COLLEGE",
"SSMS BUSINESSTOSME PRIVATE LIMITED",
"SSMT POWER PRIVATE LIMITED",
"SSN COLLEGE OF ENGINEERING",
"SSN HEALTH CARE PRIVATE LIMITED",
"SSN INFRA DEVELOPERS PRIVATE LIMITED",
"SSNR POWER PRIVATE LIMITED",
"SSNR PROJECTS PRIVATE. LIMITED.",
"SSOE CONSULTANCY INDIA PRIVATE LIMITED",
"SSP DEVELOPERS PRIVATE LIMITED",
"SSP ENTERPRISES PRIVATE LIMITED",
"SSP INDIA PRIVATE LIMITED",
"SSP JEWELS PRIVATE LIMITED",
"SSP PLASTIPACK PRIVATE LIMITED",
"SSP PRIVATE LIMITED",
"SSP PROMOTERS & BUILDERS PRIVATE LIMITED",
"SSP PUMPS PRIVATE LIMITED",
"SSPARSH CASHEW INDUSTRIES PRIVATE LIMITED",
"SSPL COMMODITIES PRIVATE LIMITED",
"SSPL HOMES PRIVATE LIMITED",
"SSPL POLYMERS PRIVATE LIMITED",
"SSPL WEALTH ADVISORS LLP",
"SSPL WEALTH PRIVATE LIMITED",
"SSPP ENGINEERING PRIVATE LIMITED",
"SSPP PETRO PRODUCTS PRIVATE LIMITED",
"SSPR VALVE MANUFACTURING PRIVATE LIMITED",
"SSQUAD INFORMATION SYSTEMS PRIVATE LIMITED",
"S-SQUARE DATA SYSTEMS PRIVATE LIMITED",
"S-SQUARE SPENTA TECHNOLOGIES LLP",
"SSR CINEMAS PRIVATE LIMITED",
"SSR CREST ENGINEERS AND CONSTRUCTIONS LIMITED",
"SSR DIES AND MOULDS PRIVATE LIMITED",
"SSR ENTERPRISES PRIVATE LIMITED",
"SSR FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"SSR FOOTCARE PRIVATE LIMITED",
"SSR GLOBAL PRIVATE LIMITED",
"SSR INFOSYSTEMS PRIVATE LIMITED",
"SSR INFRA BUILDTECH PRIVATE LIMITED",
"SSR INFRABUILDCON PRIVATE LIMITED",
"SSR MAHA NIRMAAN PRIVATE LIMITED",
"SSR MARINE SERVICES PRIVATE LIMITED",
"SSR MEMORIASL TRUST",
"SSR POLYMERS PRIVATE LIMITED",
"SSR SHIPPING PRIVATE LIMITED",
"SSR TECHVISION PRIVATE LIMITED",
"SSR UNIQUE GRAPHICS PRIVATE LIMITED",
"SSRB ENGINEERS & CONSTRUCTIONS PRIVATE LIMITED",
"SSRL BATTERY CHEMICALS PRIVATE LIMITED",
"SSRMJ ALERT SECURITY PRIVATE LIMITED",
"SSRPS DEVELOPERS LLP",
"SSRS SATHYA INFRA (INDIA) PRIVATE LIMITED",
"SSS BIOCARE PHARMACEUTICALS PRIVATE LIMITED",
"SSS CASHEWS PRIVATE LIMITED",
"SSS DESIGNTEK PRIVATE LIMITED",
"SSS GLOBAL FREIGHT PRIVATE LIMITED",
"SSS HI TECH CONSTRUCTIONS PRIVATE LIMITED",
"SSS INTERNATIONAL EXPO PRIVATE LIMITED",
"SSS LOHA MARKETING PRIVATE LIMITED",
"SSS MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"SSS MEDIA PUBLICATIONS PRIVATE LIMITED",
"SSS PHARMACHEM PRIVATE LIMITED",
"SSS RICE MILL PRIVATE LIMITED",
"SSS RISK MANAGEMENT AND INSURANCE BROKERS PRIVATE LIMITED",
"SSS SAI FORWARDERS PRIVATE LIMITED",
"SSS SAI SHIPPING SERVICES PRIVATE LIMITED.",
"SSS SERVICES PRIVATE LIMITED",
"SSS SOFT SOURCE AND PRINTING SOLUTIONS PRIVATE LIMITED",
"SSS TILES SQUARE (INDIA) PRIVATE LIMITED",
"SSS TRADE ZONE PRIVATE LIMITED",
"SSS X METALICKS PRIVATE LIMITED",
"SSSAL BAHAR LOGISTICS PRIVATE LIMITED",
"SSSBC INFRA PROJECTS PRIVATE LIMITED",
"SSSH EQUIPMENTS PRIVATE LIMITED",
"SSSP MANDAL AURANGABAD KALA MAHAVIDYALAYA NANDUR GHAT",
"SSSP SPECIALITY PACKAGINGS PRIVATE LIMITED",
"SSSV JEWELLERY PRIVATE LIMITED",
"SST BUSINESS SOLUTIONS PRIVATE LIMITED",
"SST GARMENTS PRIVATE LIMITED",
"SST IMPEX PRIVATE LIMITED",
"SST INDIA",
"SST INFOTECH INDIA PRIVATE LIMITED",
"SST SOFTWARE INTERNATIONAL PRIVATE LIMITED",
"SST STEELS PRIVATE LIMITED",
"SST TECHNISOLUTIONS PRIVATE LIMITED",
"SSTL INDIA PRIVATE LIMITED",
"SSTL INDUSTRIES PRIVATE LIMITED",
"SSTS INFRAMANTRA PRIVATE LIMITED",
"SSULB INFRAPROJECTS PRIVATE LIMITED",
"SSV ALLOYS PRIVATE LIMITED",
"SSV CHIT FUND PRIVATE LIMITED",
"SSV COLD FORGINGS PRIVATE LIMITED",
"SSV CYLINDERS PRIVATE LIMITED",
"SSV ELECTRICALS PRIVATE LIMITED",
"SSV EMART PRIVATE LIMITED",
"SSV FAB INDUSTRIES PRIVATE LIMITED",
"SSV FUTURE BROADBAND LLP",
"SSV GINNERS PRIVATE. LIMITED.",
"SSV HI TECH RUDRAPUR PRIVATE LIMITED",
"SSV SPINNERS PRIVATE LIMITED",
"SSV VALVES",
"SSV VESSELS PRIVATE LIMITED",
"SSV VISTA BROADBAND LLP",
"SSVG INDUSTRIES PRIVATE LIMITED",
"SSVK TRADERS PRIVATE LIMITED",
"SSVM CONSTRUCTION PRIVATE LIMITED",
"SSVM WORLD SCHOOL",
"SSY CONTAINERS PRIVATE LIMITED",
"SSY TRADING PRIVATE LIMITED",
"SSZ COMMODITIES PRIVATE LIMITED",
"ST A DESIGN STUDIO P LIMITED",
"ST AANALYTICSIQ CONSULTING SERVICES PRIVATE LIMITED",
"ST ADVANCED COMPOSITES PRIVATE LIMITED",
"ST AGNES COLLEGE",
"ST AGNES LORETO DAY SCHOOL",
"ST AGNES SCHOOL",
"ST AGNES WOMENS COLLEGE",
"ST ALLOYSIOUS COLLEGE MANGALORE",
"ST ALLOYSIOUS EVENING COLLEGE MANGALORE",
"ST ALOYSIUS COLLEGE",
"ST ALOYSIUS GONZAGA SCHOOL",
"ST ALOYSIUS HIGH SCHOOL",
"ST ALOYSIUS INDUSTRIAL TRAINING INSTITUTE",
"ST ALOYSIUS PRE UNIVERSITY COLLEGE",
"ST ALOYSIUS SR SEC SCHOOL",
"ST ANDREWS PUBLIC SCHOOL",
"ST ANDREWS SCOTS SENIOR SECONDARY SCHOOL",
"ST ANGELO S COMPUTER EDUCATION",
"ST ANGELO S COMPUTERS LIMITED",
"ST ANGELO S VNCT VENTURES LLP",
"ST ANGELOES COLLEGE",
"ST ANGELS SCHOOL ROHINI",
"ST ANNE'S DEGREE COLLEGE FOR WOMEN",
"ST ANNE'S ENGLISH HIGH SCHOOL",
"ST ANN'S HIGH SCHOOL",
"ST ANNE'S PRE UNIVERSITY",
"ST ANNE'S SCHOOL",
"ST ANNES SR SEC SCHOOL JODHPUR",
"ST ANNS COLLEGE FOR WOMEN",
"ST ANNS COLLEGE OF ENGINEERING & TECHNOLOGY",
"ST ANN'S HOSPITAL",
"ST ANNS SENIOR SECONDARY SCHOOL",
"ST ANSELM‚ÄôS NORTH CITY SCHOOL",
"ST ANTHONY PRE PRIMARY SCHOOL SHOLAPUR BAZAAR PUNE",
"ST ANTHONYS ANGLO INDIAN HIGH SCHOOL",
"ST ANTHONYS CONVENT SCHOOL",
"ST ANTHONYS HIGH SCHOOL",
"ST ANTHONYS PRE UNIVERSITY COLLEGE",
"ST ANTHONY'S SCHOOL",
"ST ANTHONY'S SR SECONDERY SCHOOL",
"ST ANTONY MIDDLE SCH AVADI",
"ST ANTONY S HOSPITAL",
"ST ANTONYS SCHOOL KHORA",
"ST ARNOLD‚ÄôS HIGHER SECONDARY SCHOOL",
"ST ARNOLD'S HIGH SCHOOL AND JUNIOR COLLEGE",
"ST AUGUSTINE SCHOOL",
"ST AUGUSTINE'S DAY SCHOOL",
"ST AUTOMOBILES PRIVATE LIMITED",
"ST BEDE'S ACADEMY SENIOR SECONDARY SCHOOL",
"ST BEDES COLLEGE",
"ST BERCHMANS COLLEGE",
"ST BRITTO'S ACADEMY",
"ST CATHERINES HIGH SCHOOL",
"ST CHARLES HIGH SCHOOL",
"ST CHRISTOPHERS COLLEGE OF EDUCATION",
"ST CLARES CONVENT SCHOOL",
"ST CLARE'S SCHOOL",
"ST CLARET SCHOOL",
"ST COLUMBUS SCHOOL SURAJKUND FARIDABAD",
"ST CONRAD S INTER COLLEGE 282005",
"ST CONRADS INTER COLLEGE",
"ST COURIER PRIVATE LIMITED",
"ST DOMINIC SAVIO'S HIGH SCHOOL",
"ST EDWARDS SCHOOL",
"ST ELIZABETH HOSPITAL",
"ST ENGINEERING URBAN SOLUTIONS LTD",
"ST FELIX NURSERY SCHOOL",
"ST FRANCIS COLLEGE",
"ST FRANCIS COLLEGE FOR WOMEN",
"ST FRANCIS COLLEGE OF NURSING",
"ST FRANCIS DASSIS H S",
"ST FRANCIS DE SALES COLLEGE",
"ST FRANCIS DE SALES SCHOOL",
"ST FRANCIS HIGH SCHOOL",
"ST FRANCIS HOSPITAL",
"ST FRANCIS INDUSTRIAL TRAINING INSTITUTE",
"ST FRANCIS INTER COLLEGE",
"ST FRANCIS SCHOOL",
"ST FRANCIS SCHOOL PALAYUR",
"ST FRANCIS WOMEN COLLEGE",
"ST FRANCIS XAVIER A I HIGHER SECONDARY SCHOOL",
"ST FRANCIS XAVIER SCHOOL",
"ST FRANCIS XAVIER'S H S SCHOOL",
"ST FRANCIS XAVIERS HIGH SCHOOL",
"ST GABRIEL'S HIGH SCHOOL",
"ST GABRIELS HIGHER SECONDARY SCHOOL",
"ST GEORGE BOYS JR COLLEGE",
"ST GEORGE HOSPITAL",
"ST GEORGE'S COLLEGE",
"ST GEORGE'S GRAMMAR SCHOOL",
"ST GEORGES HOSPITAL MUMBAI",
"ST GEORGE'S SCHOOL",
"ST GERMAIN ACADEMY",
"ST GERMAIN EXCELLENT HIGH SCHOOL",
"ST GERMAN EXCELLENT HIGH SCHOOL",
"ST GIRI SR SEC SCHOOL",
"ST GREGORIOS HIGH SCHOOL",
"ST GREGORIOS MEDICAL MISSION HOSPITAL",
"ST GREGORIOS SCHOOL",
"ST INFOSYS PRIVATE LIMITED",
"ST ISABAEL S HOSPITAL",
"ST JAMES CHURCH SCHOOL",
"ST JAMES COLLEGE OF PHARMACEUTICAL SCIENCES CHALAKUDY",
"ST JAMES MATRICULATION HIGHER SECONDARY SCHOOL",
"ST JAMES‚Äô HOSPITAL CHALAKKUDY",
"ST JOHN COLLEGE",
"ST JOHN S SR SEC SCHOOL & JR COLLEGE",
"ST JOHN THE EVANGELIST HIGH SCHOOL",
"ST JOHN'S ENGLISH SCHOOL & JUNIOR COLLEGE",
"ST JOHNS HEALTH INNOVATION FOUNDATION",
"ST JOHN'S HIGH SCHOOL",
"ST JOHNS INTER COLLEGE",
"ST JOHNS MATRICULATION HIGHER SECONDARY SCHOOL",
"ST JOHNS PRIVATE INDUSTRIAL TRAINING INSTITUTE",
"ST JOHNS PUBLIC SCHOOL",
"ST JOHN'S SCHOOL",
"ST JOHN'S SCHOOL BLW",
"ST JOSEPH'S COLLEGE",
"ST JOSEPH CONVENT GIRLS HIGH SCHOOL AND JUNIOR COLLEGE",
"ST JOSEPH CONVENT HIGH SCHOOL",
"ST JOSEPH CONVENT PRIMARY SCHOOL",
"ST JOSEPH DAY SCHOOL",
"ST JOSEPH DEGREE COLLEGE",
"ST JOSEPH ENGINEERING COLLEGE",
"ST JOSEPH HIGH SCHOOL",
"ST JOSEPH MONTESSORI SCHOOL",
"ST JOSEPH OF CLUNY SCHOOL",
"ST JOSEPH PRE PRIMARY SCHOOL",
"ST JOSEPH PRIMARY SCHOOL",
"ST JOSEPH S ARTS COMM COLLEGE",
"ST JOSEPH S COLLEGE OF ENGINEERING",
"ST JOSEPH S MEDICAL COLLEGE",
"ST JOSEPH S SAMHITA JR COLLEGE",
"ST JOSEPH‚ÄôS COLLEGE OF LAW",
"ST JOSEPH‚ÄôS SCHOOL",
"ST JOSEPH‚ÄôS¬†MATRICULATION HIGHER SECONDARY SCHOOL MATRICULATION",
"ST JOSEPH'S ACADEMY DEHRADUN",
"ST JOSEPHS ARTS AND SCIENCE COLLEGE",
"ST JOSEPH'S BETHANY CONVENT SCHOOL",
"ST JOSEPH'S BOY'S HIGH SCHOOL",
"ST JOSEPHS COMMERCE COLLEGE",
"ST JOSEPHS ENGLISH MEDIUM HIGH SCHOOL",
"ST JOSEPHS EVENING COLLEGE",
"ST JOSEPHS GIRLS INTER COLLEGE",
"ST JOSEPHS HOSPITAL",
"ST JOSEPHS INSTITUTE OF TECHNOLOGY",
"ST JOSEPH'S INSTITUTE OF TECHNOLOGY",
"ST JOSEPH'S MATRICULATION HIGHER SECONDARY SCHOOL",
"ST JOSEPH'S PUBLIC SCHOOL",
"ST JOSEPH'S SCHOOL",
"ST JOSEPHS SCHOOL OF NURSING",
"ST JOSEPHS TEA CO LTD",
"ST JOSEPH'S UNIVERSITY",
"ST JUDE MEDICAL INDIA PRIVATE LIMITED",
"ST JUDES HOSPITAL JHANSI",
"ST JUDE'S SCHOOL",
"ST KABIR HIGH SCHOOL",
"ST KABIR INSTITUTE OF PROFESSIONAL STUDIES",
"ST KEVINS ANGLO INDIAN HIGHER SECONDARY SCHOOL",
"ST LAWRENCE EDUCATION SOCIETY",
"ST LAWRENCE HIGH SCHOOL",
"ST LAWRENCE SR SEC SCHOOL",
"ST LAWRENCE UNAIDED ENGLISH MEDIUM HIGH SCHOOL",
"ST LOGISTICS",
"ST LOUIS EDUCATION SOCIETY",
"ST LUKE LIFE SCIENCES PRIVATE LIMITED",
"ST LUKE MED DEVICES PRIVATE LIMITED",
"ST LUKES KINDERGARDEN",
"ST MARK‚ÄôS SR SEC PUBLIC SCHOOL",
"ST MARKS BOYS TOWN HIGH SCHOOL",
"ST MARK'S BOYS TOWN HIGH SCHOOL",
"ST MARK'S SENIOR SECONDARY PUBLIC SCHOOL",
"ST MARTHA'S HOSPITAL",
"ST MARTIN‚ÄôS ENGINEERING COLLEGE",
"ST MARTINS HIGH SCHOOL",
"ST MARY CHAMPION H S SCHOOL",
"ST MARYS ACADEMY",
"ST MARYS ANGLO INDIAN HR SEC SCHOOL",
"ST MARYS BUDS BLOSSOM SCHOOL",
"ST MARY'S COLLEGE OF NURSING",
"ST MARYS CONVENT INTER COLLEGE",
"ST MARY'S CONVENT JUNIOR HIGH SCHOOL",
"ST MARYS CONVENT SCHOOL",
"ST MARY'S CONVENT SCHOOL",
"ST MARY'S CONVENT SENIOR SECONDARY SCHOOL",
"ST MARY'S ENGINEERING COLLEGE",
"ST MARY'S ENGLISH MEDIUM SCHOOL",
"ST MARYS GIRLS HIGHER SECONDARY SCHOOL",
"ST MARY'S GROUP OF INSTITUTIONS HYDERABAD",
"ST MARY'S HIGH SCHOOL",
"ST MARYS MATRIC HR SEC SCHOOL",
"ST MARY'S ORPHANAGE & DAY SCHOOL",
"ST MARY'S PUBLIC SCHOOL",
"ST MARYS RUBBERS PRIVATE LIMITED",
"ST MARYS SCHOOL",
"ST MARY'S SCHOOL",
"ST MARYS SECONDARY SCHOOL",
"ST MARY'S SR SEC SCHOOL",
"ST MARY'S TECHNICAL CAMPUS KOLKATA",
"ST MARYS WOMENS ENGINEERING COLLEGE",
"ST MICHAEL CONVENT SCHOOL",
"ST MICHAEL ENGLISH SCHOOL",
"ST MICHAEL HIGH SCHOOL",
"ST MICHAEL'S ACADEMY MATRICULATION HIGHER SECONDARY SCHOOL",
"ST MICHAEL'S MATRIC HIGHER SECONDARY SCHOOL",
"ST MICHAELS SCHOOL",
"ST MICHAEL'S SR SEC SCHOOL",
"ST MILAGRES CREDIT SOUHARDHA CO-OPERATIVE SOCIETY LTD",
"ST MINERALS PRIVATE LIMITED",
"ST PATRICK‚ÄôS JUNIOR COLLEGE",
"ST PATRICKS ACADEMY MEERUT",
"ST PATRICKS JUNIOR COLLEGE",
"ST PAUL CATHEDRIAL MISSION COLLEGE",
"ST PAUL DEGREE COLLEGE",
"ST PAUL HIGHER SECONDARY SCHOOL",
"ST PAUL PREPARATORY SCHOOL",
"ST PAUL PUBLIC SCHOOL",
"ST PAUL SCHOOL",
"ST PAUL‚ÄôS CHURCH COLLEGE",
"ST PAUL‚ÄôS MISSION SCHOOL",
"ST PAULS BOOKS AND MEDIA PRIVATE LIMITED",
"ST PAULS CHURCH COLLEGE",
"ST PAULS CHURCH SCHOOL",
"ST PAULS COLLEGE OF PHARMACY",
"ST PAUL'S INTER COLLEGE",
"ST PAULS INTER COLLEGE AGRA",
"ST PAUL'S PRE-UNIVERSITY COLLEGE",
"ST PAULS SCHOOL",
"ST PETER & PAUL SEA FOOD EXPORTS PRIVATE LIMITED",
"ST PETERS ACADEMY",
"ST PETERS COLLEGE AGRA",
"ST PETERS CONVENT",
"ST PETERS ENGINEERING COLLEGE",
"ST PETER'S HIGHER SECONDARY SCHOOL",
"ST PETER'S MEDICAL COLLEGE HOSPITAL & RESEARCH INSTITUTE",
"ST PETER'S SCHOOL",
"ST PHILOMENA'S COLLEGE",
"ST PHILOMENA'S HOSPITAL",
"ST PIOUS X DEGREE & PG COLLEGE FOR WOMEN",
"ST PIOUS X HIGH SCHOOL",
"ST PIUS X MATRICULATION HIGHER SECONDARY SCHOOL",
"ST PRODUCTS PRIVATE LIMITED",
"ST RAPHAEL CO-ED SCHOOL BHOPAL",
"ST RAPHAELS GIRLS HR SEC SCHOOL",
"ST RAVINDRA BHARTI SCHOOL",
"ST S N KREATIONS PRIVATE LIMITED",
"ST SEBASTIAN'S HIGH SCHOOL",
"ST SOFTECH INDIA PRIVATE LIMITED",
"ST SOLDIER INDUSTRIAL TRAINING INSTITUTE",
"ST SOLDIER INTER COLLEGE",
"ST SOLDIER PUBLIC SCHOOL KULAM BARNALA",
"ST STEPHEN HOSPITAL",
"ST STEPHENS HOSPITAL",
"ST STEPHEN'S HOSPITAL",
"ST STEPHENS SCHOOL",
"ST STEVE CONVENT EDUCATION SOCIETY",
"ST STONE MEDICAL DEVICES PRIVATE LIMITED",
"ST SUNDARDAS JHS BHERO BAZAR",
"ST TERESAS COLLEGE",
"ST TERESA'S HIGH SCHOOL",
"ST TEXTILES LIMITED",
"ST THERESA CONVENT HIGH",
"ST THERESA EDUCATIONAL CULTURAL AND SOCIAL DEVELOPMENT SOCIETY",
"ST THERESA SENIOR SECONDARY SCHOOL",
"ST THERESA'S HOSPITAL",
"ST THERESA'S SCHOOL",
"ST THERSA'S GIRLS SCHOOL",
"ST THOMAS CHURCH SCHOOL",
"ST THOMAS COLLEGE OF ARTS AND SCIENCE",
"ST THOMAS DAY SCHOOL",
"ST THOMAS ENGLISH MEDIUM SCHOOL(STEMS) VAPI",
"ST THOMAS HIGH SCHOOL",
"ST THOMAS HOSPITAL",
"ST THOMAS MATRICULATION HIGHER SECONDARY SCHOOL",
"ST THOMAS MATRICULATION SCHOOL KOOTHAPAKKAM",
"ST THOMAS MOUNT HOSPITAL",
"ST THOMAS PUBLIC SCHOO PRAGATI NAGAR SECL",
"ST THOMAS SCHOOL",
"ST URSULA HIGHER SEC SCHOOL",
"ST VINCENT DE PAUL PRIMARY SCHOOL",
"ST VINCENT PALLOTTI SCHOOL",
"ST VIVEKANAND PUBLIC SCHOOL",
"ST WILFRED EDUCATION SOCIETY",
"ST WILFREDS PG COLLEGE",
"ST WOVEN BAGS PRIVATE LIMITED",
"ST XAVIER HIGH SCHOOL",
"ST XAVIER‚ÄôS COLLEGE OF ARTS SCIENCE & COMMERCE",
"ST XAVIER'S BOYS ACADEMY",
"ST XAVIER'S COLLEGE JAIPUR",
"ST XAVIERS COLLEGIATE SCHOOL",
"ST XAVIERS ENGLISH HIGH SCHOOL AND JR COLLEGE",
"ST XAVIER'S HIGH SCHOOL AND HIGHER SECONDARY",
"ST XAVIERS HIGH SCHOOL EDUCATION",
"ST XAVIERS HIGH SCHOOL NAGALA PARK",
"ST XAVIER'S INSTITUTION",
"ST XAVIERS INTERNATIONAL SCHOOL",
"ST XAVIERS PRIMARY SCHOOL",
"ST XAVIERS PUBLIC SCHOOL KORBA",
"ST XAVIERS SCHOOL",
"ST XAVIER'S SENIOR SECONDARY SCHOOL",
"ST XAVIER'S UNIVERSITY KOLKATA",
"ST. ANDREW‚ÄôS HIGH SCHOOL",
"ST. ANGELO'S VNCT VENTURES PRIVATE LIMITED",
"ST. ANN'S COLLEGE OF ENGINEERING & TECHNOLOGY",
"ST. ANN'S HIGH SCHOOL",
"ST. ANSELM'S PINK CITY SCHOOL",
"ST. ANTONY'S PUBLIC SCHOOL",
"ST. JOHN COLLEGE OF ENGINEERING AND MANAGEMENT",
"ST. JOHNS CASHEW COMPANY",
"ST. JOHN'S MEDICAL COLLEGE HOSPITAL",
"ST. JOSEPH SHIPPING AGENCIES PRIVATE LIMITED",
"ST. JOSEPH'S DEGREE AND PG COLLEGE",
"ST. LUKE INFRASTRUCTURES PRIVATE LIMITED",
"ST. MARKS HOTEL PRIVATE LIMITED",
"ST. MARTIN'S ENGINEERING COLLEGE",
"ST. MARY'S GROUP OF INSTITUTIONS HYDERABAD",
"ST. MICHAEL SECURITY AND PERSONNEL CONSULTANTS PRIVATE LIMITED",
"ST. MICHAEL'S EDUCATIONAL SERVICES PRIVATE LIMITED",
"ST. NICHOLAS CASHEW EXPORTS",
"ST. PAUL SENIOR SECONDARY SCHOOL",
"ST. PAULS SCHOOL",
"ST. PAUL'S SCHOOL",
"ST. PAUL'S SENIOR SECONDARY SCHOOL",
"ST. SIRDI SAI EDUCATION SOCIETY PRIVATE LIMITED",
"ST. STEPHEN'S HOSPITAL",
"ST. THERESA EDUCATIONAL CULTURAL AND SOCIAL DEVELOPMENT SOCIETY",
"ST. VINCENT'S HIGH SCHOOL",
"ST. XAVIER'S WORLD SCHOOL",
"ST.ANNE'S COLLEGE OF ENGINEERING AND TECHNOLOGY",
"ST.CLARET MERCY FOUNDATION",
"ST.DOMINIC'S ANGLO-INDIAN SCHOOL",
"ST.FRANCIS COMPOSITE PU COLLEGE",
"ST.GEORGE ELECTRONICA PRIVATE LIMITED",
"ST.JOSEPH'S HIGHER SECONDARY SCHOOL",
"ST.MARTIN'S ENGINEERING COLLEGE",
"ST.MARY'S HEALTHCARE PRIVATE LIMITED",
"ST.MARYS ICSE SCHOOL",
"ST.MARY'S ICSE SCHOOL",
"ST.MARY'S TECHNOLOGICAL FOUNADATION",
"ST.PATRICK'S REALITY PRIVATE LIMITED",
"ST.PETERS ENGINEERING COLLEGE",
"ST.THOMAS COLLEGE",
"ST.VINCENT'S MATRICULATION HR SEC SCHOOL",
"ST.XAVIERS CMI PUBLIC SCHOOL",
"STA INFOTECH PRIVATE LIMITED",
"STAAH HOTEL SOFTWARE PRIVATE LIMITED",
"STAAN BIOMED ENGINEERING PRIVATE LIMITED",
"STAAR SURGICAL INDIA PRIVATE LIMITED",
"STAAT EXPO PRIVATE LIMITED",
"STAAYZ HOSPITALITY SOLUTIONS PRIVATE LIMITED",
"STABICON LIFE SCIENCES PRIVATE LIMITED",
"STABILIANT PRECISION POSITIONING PVT LTD",
"STABILINE SYSTEMS PRIVATE LTD.",
"STABILIS BUSINESS SOLUTIONS PRIVATE LIMITED",
"STABILITAS SOLVENTS AND CHEMICALS PRIVATE LIMITED",
"STABILIX SOLUTIONS PRIVATE LIMITED",
"STABLE EVERSHINE BUILDERS PRIVATE LIMITED",
"STABLE PACKAGING PRIVATE LIMITED",
"STABLE PHARMA",
"STABLE POLYFAB PRIVATE LIMITED",
"STABLE TEXTILE PRIVATE LIMITED",
"STABPLAST CHEMO-INDUSTRIES PRIVATE LIMITED",
"STAC ENTERPRISE PRIVATE LIMITED",
"STACI SOLUTIONS PRIVATE LIMITED",
"STACK PACK LIMITED",
"STACKBOTS TECHNOLOGY PRIVATE LIMITED",
"STACKBOX SERVICES PRIVATE LIMITED",
"STACKFUSION PRIVATE LIMITED",
"STACKSEER TECHNOLOGIES INDIA PRIVATE LIMITED",
"STACKTRAIL CASH AND CARRY PRIVATE LIMITED",
"STACKUP TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"STA-CO NUTRA PRODUCTS PRIVATE LIMITED",
"STACUS SOLUTION PRIVATE LIMITED",
"STADA PHARMA SERVICES INDIA PRIVATE LIMITED",
"STADCHEM PHARMA PRIVATE LIMITED",
"STADIA INFRASTRUCTURE PROJECTS PRIVATE LIMITED",
"STADMED PRIVATE LIMITED",
"STAFCON SERVICES LLP",
"STAFF SELECTION COMMISSION",
"STAFFCLOUD SERVICES PRIVATE LIMITED",
"STAFFING CARE SOLUTION INC",
"STAFFING CUBE PRIVATE LIMITED",
"STAFFING SOLUTIONS (INDIA) PRIVATE LIMITED",
"STAFFINGINE TECHNOLOGIES PRIVATE LIMITED",
"STAFFKON SOLUTIONS PRIVATE LIMITED",
"STAFFORD CONTROLS LIMITED",
"STAFFORD CONTROLS PRIVATE LIMITED",
"STAFFORD LABORATORIES PRIVATE LIMITED",
"STAG INNOVATIONS PRIVATE LIMITED",
"STAG SOFTWARE PRIVATE LIMITED",
"STAG TRADING PRIVATE LIMITED",
"STAGE TECHNOLOGIES PRIVATE LIMITED",
"STAGO INDIA PRIVATE LIMITED",
"STAGS YARNS PRIVATE LIMITED",
"STAHL CRANESYSTEMS (INDIA) PRIVATE LIMITED",
"STAHL INDIA PRIVATE LIMITED",
"STAHL LAUNDRY MACHINE INDIA PRIVATE LIMITED",
"STAHL TECNIKS PRIVATE LIMITED",
"STAHLKIND PRIVATE LIMITED",
"STAHLLFORM TECHNIK PRIVATE LIMITED",
"STAHLMET CASTINGS PVT LTD",
"STAHLWORX ENGINEERING PRIVATE LIMITED",
"STAIDLOGIC SOFTWARE PRIVATE LIMITED",
"STAINLAY INDIA PRIVATE LIMITED",
"STAINLESS BOLT INDUSTRIES PRIVATE LIMITED",
"STAINLESS EMPORIUM PRIVATE LIMITED",
"STAINLESS INTERNATIONAL PRIVATE LIMITED",
"STAINOX ALLOYS PRIVATE LIMITED",
"STAIRS REHAB AND FITNESS PRIVATE LIMITED",
"STAIRWAY DEVELOPERS PRIVATE LIMITED",
"STAIVE ENGINEERING AND TECHNICAL SERVICES PRIVATE LIMITED",
"STAIZI INDIA PRIVATE LIMITED",
"STAKEHOLDERS EMPOWERMENT SERVICES",
"STALLEN SOUTH ASIA PRIVATE LIMITED",
"STALLION ASSET PRIVATE LIMITED",
"STALLION AUTO PARTS PRIVATE LIMITED",
"STALLION ENERGY PRIVATE LIMITED",
"STALLION ENGINEERING SYSTEMS PRIVATE LIMITED",
"STALLION GLOBAL INDIA PRIVATE LIMITED",
"STALLION GRAPHICS PRIVATE LIMITED",
"STALLION IMPEX PRIVATE LIMITED",
"STALLION INDIA FLUOROCHEMICALS LIMITED",
"STALLION INVESTMENT PRIVATE LIMITED",
"STALLION LABORATORIES PRIVATE LIMITED",
"STALLION MACHINE TOOLS PRIVATE LIMITED",
"STALLION MEDIA PRIVATE LIMITED",
"STALLION ONEBYTE PRIVATE LIMITED",
"STALLION PACKAGING PRIVATE LIMITED",
"STALLION PRIVATE LIMITED",
"STALLION PROCESSORS PRIVATE LIMITED",
"STALLION REMEDIES PRIVATE LIMITED",
"STALLION STEELWARES PRIVATE LIMITED",
"STALLION TECHNOLOGIES PRIVATE LIMITED",
"STALLIONS MULTISERVICES PRIVATE LIMITED",
"STALMEC ENGINEERING PRIVATE LIMITED",
"STALWART AGRONOMICS PRIVATE LIMITED",
"STALWART ALLOYS INDIA LIMITED",
"STALWART ELEVATORS PRODUCTS PRIVATE LIMITED",
"STALWART ENERGY PRIVATE LIMITED",
"STALWART ENGINEERING COMPANY PRIVATE LIMITED",
"STALWART HOME PRIVATE LIMITED",
"STALWART IMPEX PRIVATE LIMITED",
"STALWART INFRAPROJECTS INDIA PRIVATE LIMITED",
"STALWART LEARNING PRIVATE LIMITED",
"STALWART LIFESTYLE PRIVATE LIMITED",
"STALWART LOGISTICS (DELHI) PRIVATE LIMITED",
"STALWART MEDITECH PRIVATE LIMITED",
"STALWART PEOPLE SERVICES INDIA LIMITED",
"STALWART PROJECTS PRIVATE LIMITED",
"STALWART SEEDS AND FERTILIZERS PRIVATE LIMITED",
"STALWART SHIPPING AGENCIES PRIVATE LIMITED",
"STALWART SOLAR ENERGY PROMOTERS PRIVATE LIMITED",
"STALWART TECHNIK PRIVATE LIMITED",
"STALWART TECHNOSOURCE INDIA PRIVATE LIMITED",
"STAM DIGITAL TOOLING INDIA PRIVATE LIMITED",
"STAM INTERACTIVE SOLUTIONS PRIVATE LIMITED",
"STAMBH POWER SYSTEM PRIVATE LIMITED",
"STAMCO STEEL PROCESSORS PRIVATE LIMITED",
"STAMFORD TECHNOLOGY INDIA PRIVATE LIMITED",
"STAMLO INDUSTRIES LIMITED",
"STAMP 'IT ROBOTAI & SOLUTIONS PRIVATE LIMITED",
"STAMPCORE INDIA PRIVATE LIMITED",
"STAMPEDE CAPITAL LIMITED",
"STAMPEDE CLOUD SERVICES PRIVATE LIMITED",
"STAMPTEK COMPONENTS PRIVATE LIMITED",
"STAN AUTOS PRIVATE. LIMITED.",
"STAN INDIA PRIVATE LIMITED",
"STAN PROFESSIONALS PRIVATE LIMITED",
"STAN SOFTECH PRIVATE LIMITED",
"STAN TECH INDIA PRIVATE. LIMITED.",
"STANADYNE INDIA PRIVATE LIMITTED",
"STANBIK COMMERCIAL PRIVATE LIMITED",
"STANCE BIOGENICS PRIVATE LIMITED",
"STANCE ESERVICES PRIVATE LIMITED",
"STANCE INDUSTRIES PRIVATE LIMITED",
"STANCH PROJECTS PRIVATE LIMITED",
"STANCHART IMPEX PRIVATE LIMITED",
"STANCHEM PRIVATE LIMITED",
"STANCOR TUBULAR PRODUCTS PRIVATE LIMITED",
"STAND ONE AGRO PRIVATE LIMITED",
"STAND21 EXPORTS INDIA PRIVATE LIMITED",
"STANDARD & POORS SOUTH ASIA SERVICES PRIVATE LIMITED",
"STANDARD AGRI SOLUTIONS PRIVATE LIMITED",
"STANDARD AGRO VET PRIVATE LIMITED",
"STANDARD AIR FILTERS PRIVATE LIMITED",
"STANDARD ALLOYS (INDIA) PRIVATE LIMITED",
"STANDARD ANALYTICAL LABORATORY N D PRIVATE LIMITED",
"STANDARD AUTO AGENCIES",
"STANDARD AUTO ENGINEERS PRIVATE LIMITED",
"STANDARD AUTOMOTIVE MACHINES INDIA PRIVATE LIMITED",
"STANDARD BELEX (INDIA) PRIVATE LIMITED",
"STANDARD BUILDCON",
"STANDARD CAPACITORS PRIVATE LIMITED",
"STANDARD CAPITAL MARKETS LIMITED",
"STANDARD CARTONS PRIVATE LIMITED",
"STANDARD CASTINGS PVT LTD",
"STANDARD CHARTERED (INDIA) MODELING AND ANALYTICS CENTRE PRIVATE LIMITED",
"STANDARD CHARTERED BANK LIMITED",
"STANDARD CHARTERED CAPITAL LIMITED",
"STANDARD CHARTERED GLOBAL BUSINESS SERVICES PRIVATE LIMITED",
"STANDARD CHARTERED RESEARCH AND TECHNOLOGY INDIA PRIVATE LIMITED",
"STANDARD CHARTERED SECURITIES INDIA LIMITED",
"STANDARD CIVIL ENGINEERS PRIVATE LIMITED",
"STANDARD COLORS AND CHEMICALS INDIA PRIVATE LIMITED",
"STANDARD COMBINE PRIVATE LIMITED",
"STANDARD CONDUITS PRIVATE LIMITED",
"STANDARD CORPORATION INDIA LIMITED",
"STANDARD DEPARTMENTAL STORES PRIVATE LIMITED",
"STANDARD DIAGNOSTICS PRIVATE LIMITED",
"STANDARD ENAMEL WORKS PRIVATE LIMITED",
"STANDARD FIRE WORKS PRIVATE LIMITED",
"STANDARD FORMS & STATIONERY PVT. LTD",
"STANDARD FREIGHT SOLUTIONS PRIVATE LIMITED",
"STANDARD FROZEN FOODS EXPORTS PRIVATE LIMITED",
"STANDARD GANPATI MERCHANDISE PRIVATE LIMITED",
"STANDARD GLASS LINING TECHNOLOGY LIMITED",
"STANDARD GLASS LINING TECHNOLOGY PRIVATE LIMITED",
"STANDARD GLOBAL SUPPLY PRIVATE LIMITED",
"STANDARD GREASES & SPECIALITIES PRIVATE LIMITED",
"STANDARD GREASES PRIVATE LIMITED",
"STANDARD HERBAL PRODUCTS PRIVATE LIMITED",
"STANDARD INDUSTRIES LIMITED",
"STANDARD INFORMATION SERVICES PRIVATE LIMITED",
"STANDARD INFRACAP SERVICES LIMITED",
"STANDARD INFRATECH INDIA PRIVATE LIMITED",
"STANDARD INNOVATIONS PRIVATE LIMITED",
"STANDARD MACHINE TOOLS TRADEX PRIVATE LIMITED",
"STANDARD MATCH INDUSTRIES PRIVATE. LIMITED.",
"STANDARD MERCANTILE COMPANY (MINING DIVISION) PVT LTD",
"STANDARD METAL PROCESSORS PRIVATE LIMITED",
"STANDARD METAL WIRES PRIVATE LIMITED",
"STANDARD MOTOCORP PRIVATE LIMITED",
"STANDARD MULTIMODAL LOGISTICS PRIVATE LIMITED",
"STANDARD OILS GREASES PRIVATE LIMITED",
"STANDARD PAINTING DECORATORS LLP",
"STANDARD PAPER CONTAINERS PRIVATE LIMITED",
"STANDARD PENCILS PRIVATE LIMITED",
"STANDARD PESTICIDES PRIVATE LIMITED",
"STANDARD PHARMACEUTICALS LIMITED",
"STANDARD PORTFOLIOS PRIVATE LIMITED",
"STANDARD PRODUCTS PRIVATE LIMITED",
"STANDARD PUBLICITY PVT LTD",
"STANDARD PYROTECHNICS LTD",
"STANDARD RADIATORS PRIVATE LIMITED",
"STANDARD REAGENTS",
"STANDARD REALTORS PRIVATE LIMITED",
"STANDARD REFRIGERATION PRIVATE LIMITED",
"STANDARD REHABILITATORS PRIVATE LIMITED",
"STANDARD RETAIL PRIVATE LIMITED",
"STANDARD RING PRIVATE LTD.",
"STANDARD SALT WORKS LTD",
"STANDARD SCREWS INDUSTRIES",
"STANDARD SECURITIES AND INVESTMENT INTERMEDIATES LIMITED",
"STANDARD SOFTWARE PRIVATE LIMITED",
"STANDARD SPINNING AND WEAVING MILLS LIMITED",
"STANDARD STRIPS INDIA PRIVATE LIMITED",
"STANDARD SURFA CHEM INDIA PRIVATE LIMITED",
"STANDARD SURFACTANTS LIMITED",
"STANDARD TRANSPORT SOLUTIONS PRIVATE LIMITED",
"STANDARD TREADS PVT LTD",
"STANDARD UNITS SUPPLY(INDIA) PRIVATE LIMITED",
"STANDARD WAREHOUSING LIMITED",
"STANDARD WAY INTELLIGENCE SECURITY SERVICES PRIVATE LIMITED",
"STANDARDS INTERNATIONAL PRECISION ENGINEERS PRIVATE LIMITED",
"STANDARDWINGS TECHNOLOGIES PRIVATE LIMITED",
"STANDAV LABS PRIVATE LIMITED",
"STANDAV LLP",
"STANDEX ELECTRONICS INDIA PRIVATE LIMITED",
"STANDEX ENGRAVING INDIA PRIVATE LIMITED",
"STANDI PACK PRIVATE LIMITED",
"STANDOUT IT SOLUTIONS PRIVATE LIMITED",
"STANDUP COMMUNICATIONS PRIVATE LIMITED",
"STANELEC PVT LTD",
"STANES AMALGAMATED ESTATES LIMITED",
"STANES HIGHER SECONDARY SCHOOL",
"STANES MOTORS SOUTH INDIA LIMITED",
"STANESH SEMICONDUCTOR PRIVATE LIMITED",
"STANEX BREEDING FARMS PRIVATE LIMITED",
"STANEX DRUGS AND CHEMICALS PRIVATE LIMITED",
"STANFAB APPARELS PRIVATE LIMITED",
"STANFORD BIOSCIENCES PRIVATE LIMITED",
"STANFORD CRICKET INDUSTRIES",
"STANFORD LABORATORIES PRIVATE LTD",
"STANFORD OPERATIONS & MAINTENANCE PRIVATE LIMITED",
"STANLEE (INDIA) ENTERPRISES PRIVATE LIMITED",
"STANLEE (INDIA) PETROCHEM PRIVATE LIMITED",
"STANLEK ENGINEERING PRIVATE LIMITED",
"STANLEY BLACK & DECKER INDIA PRIVATE LIMITED",
"STANLEY CHEMICALS PVT. LTD.",
"STANLEY COLLEGE OF ENGINEERING AND TECH FOR WOMEN",
"STANLEY ELECTRIC SALES OF INDIA PRIVATE LIMITED",
"STANLEY ENGINEERED FASTENING INDIA PRIVATE LIMITED",
"STANLEY LIFESTYLES LIMITED",
"STANLEY MEDICAL COLLEGE",
"STANLEY MEDICARE PRIVATE LIMITED",
"STANLEY OEM SOFAS LIMITED",
"STANLEY RETAIL LIMITED",
"STANLEY SAFETY PRODUCTS PRIVATE LIMITED",
"STANLEY SECURITY SOLUTIONS INDIA PRIVATE LIMITED",
"STANLEY SYSTEMS LIMITED",
"STANLEY WOMENS COLLEGE",
"STANLUBES AND SPECIALITIES (INDIA) PVT LTD",
"STANMARK HEALTHCARE PRIVATE LIMITED",
"STANMAX LABORATORIES PRIVATE LIMITED",
"STANMORE ESTATES PRIVATE LIMITED",
"STANPACKS INDIA LIMITED",
"STANPLUS TECHNOLOGIES PRIVATE LIMITED",
"STANRA TECH SOLUTIONS PRIVATE LIMITED",
"STANROSE ENVIROTECH INDIA PRIVATE LIMITED",
"STANROSE MAFATLAL INVESTMENTS AND FINANCE LIMITED",
"STANSON PLASTIC EXTRUSION PRIVATE LIMITED",
"STANSON RUBBER PRODUCTS PRIVATE LIMITED",
"STANTEC RESOURCENET (INDIA) PRIVATE LIMITED",
"STANTECH PHARMACEUTICALS PRIVATE LIMITED",
"STANTON CHASE INTERNATIONAL LLP",
"STANVAC CHEMICALS (INDIA) LIMITED",
"STANVAC INTERNATIONAL LIMITED",
"STANVAC PAINTS LIMITED",
"STANVAC PRIME PRIVATE LIMITED",
"STANVALVES AND CONTROLS PRIVATE LIMITED",
"STANWELL LIFESCIENCES PRIVATE LIMITED",
"STANWOOD ENTERPRISES PRIVATE LIMITED",
"STANWORTH MANAGEMENT PRIVATE LIMITED",
"STANYA INFRA PRIVATE LIMITED",
"STANZEN ENGINEERING PRIVATE LIMITED",
"STAPLE INDIA IMPEX PRIVATE LIMITED",
"STAPLE KNITFAB PRIVATE LIMITED",
"STAPLES, INC.",
"STAQO SOFTWARE PRIVATE LIMITED",
"STAQO WORLD PRIVATE LIMITED",
"STAR ADVERTISING",
"STAR AEROSPACE PRIVATE LIMITED",
"STAR AGRIBAZAAR TECHNOLOGY LIMITED",
"STAR AGRIBAZAAR TECHNOLOGY PRIVATE LIMITED",
"STAR AGRICO INDIA PRIVATE LIMITED",
"STAR AGRIINFRASTRUCTURE PRIVATE LIMITED",
"STAR AGRISEEDS PRIVATE LIMITED",
"STAR AGRIWAREHOUSING AND COLLATERAL MANAGEMENT LIMITED",
"STAR AGRIWAREHOUSING AND COLLATERAL MANAGEMENT LIMITED.",
"STAR AGRO MARINE EXPORTS PRIVATE LIMITED",
"STAR AGRONOMICS LIMITED",
"STAR AGROTECH PRIVATE LIMITED",
"STAR AIR SEA LOGISTICS PRIVATE LIMITED",
"STAR AIRCON ENGINEERS PRIVATE LIMITED",
"STAR ALLOYS & CHEMICALS PRIVATE LIMITED",
"STAR AND SITARA WELLNESS LIMITED",
"STAR ANIMAL FEEDS PRIVATE LIMITED",
"STAR ANISE FINE FOODS AND LEISURE PRIVATE LIMITED",
"STAR APPLIANCES PRIVATE LIMITED",
"STAR APPLIED MECHANICS PRIVATE LIMITED",
"STAR ARC DESIGN PRIVATE LIMITED",
"STAR ASSAYING & HALLMARKING CENTRE PRIVATE LIMITED",
"STAR AUTO INDUSTRIES PRIVATE LIMITED",
"STAR AUTOMOBILES LIMITED",
"STAR AUTOMOBILES MP LIMITED",
"STAR AVIA PARTS AND SERVICES PRIVATE LIMITED",
"STAR BALLS AND ROLLERS PRIVATE LIMITED",
"STAR BATTERY LIMITED",
"STAR BIOFUELS PRIVATE LIMITED",
"STAR BIOMED PRIVATE LIMITED",
"STAR BLUE JEWELS PRIVATE LIMITED",
"STAR BOILERS PRIVATE LIMITED",
"STAR BOXES INDIA PRIVATE LIMITED",
"STAR BROAD BAND SERVICES (INDIA) PRIVATE LIMITED",
"STAR BUILDERS AND DEVELOPERS SBD",
"STAR BUILDERS PRIVATE. LIMITED.",
"STAR BUS SERVICES PRIVATE LIMITED",
"STAR BUSINESS SOLUTION PRIVATE LIMITED",
"STAR CAPITAL",
"STAR CASTINGS PRIVATE LIMITED",
"STAR CEMENT LIMITED",
"STAR CEMENT MEGHALAYA LIMITED",
"STAR CHEM POLY TRADE PRIVATE LIMITED",
"STAR CHEMICALS (BOMBAY) PRIVATE LIMITED",
"STAR CIRCLIPS & ENGINEERING LIMITED",
"STAR CITY BUILDTECH PRIVATE LIMITED",
"STAR CLAYTECH PRIVATE LIMITED",
"STAR CLEARING AND FORWARDING SERVICES PRIVATE LIMITED",
"STAR COAL INDIA PRIVATE LIMITED",
"STAR COATINGS AND MEMBRANES PRIVATE LIMITED",
"STAR COLOURPARK INDIA PRIVATE LIMITED",
"STAR COMNET PRIVATE LIMITED",
"STAR CONSORTIUM AVIATION SERVICES PRIVATE LIMITED",
"STAR COOLERS AND CONDENSERS PRIVATE LIMITED",
"STAR COPIERS PRIVATE LIMITED",
"STAR COTSPIN LIMITED",
"STAR COTTEX PRIVATE LIMITED",
"STAR DECALS INDIA PRIVATE LIMITED",
"STAR DELTA TRANSFORMERS LIMITED",
"STAR DENTAL CENTRE PRIVATE LIMITED",
"STAR DIAGNOSTICS PRIVATE LIMITED",
"STAR DIMENSIONS INDIA PRIVATE LIMITED",
"STAR DOT STAR SOFTWARE LIMITED",
"STAR DREAMZZ ENTERTAINMENT PRIVATE LIMITED",
"STAR EARTH MINERALS PRIVATE LIMITED",
"STAR EARTH REALTORS PRIVATE LIMITED",
"STAR EASTERN GUARDS & SERVICES PRIVATE LIMITED",
"STAR ECO ENERGY PRIVATE LIMITED",
"STAR EDUCATIONAL BOOKS DISTRIBUTOR PRIVATE LIMITED",
"STAR ELEGANCE STORES PRIVATE LIMITED",
"STAR ENGINEERS (INDIA) PRIVATE LIMITED",
"STAR ENTERPRISE",
"STAR ENTERTAINMENT PRIVATE LIMITED",
"STAR ENTERTAINMENT WORLDWIDE PRIVATE LIMITED",
"STAR EXIM MANAGEMENT CONSULTANCY AND SERVICES PRIVATE LIMITED",
"STAR EXPRESS CONSULTANTS PRIVATE LIMITED",
"STAR FAB STORAGE PRIVATE LIMITED",
"STAR FASTNERS PRIVATE LIMITED",
"STAR FERTILISERS PRIVATE LIMITED",
"STAR FERTILITY PRIVATE LIMITED",
"STAR FINVEST PRIVATE LIMITED",
"STAR FIRE SYSTEMS PRIVATE LIMITED",
"STAR FLOUR MILLS PRIVATE LIMITED",
"STAR FREIGHT PRIVATE LIMITED",
"STAR GLOBAL CURRENCY EXCHANGE PRIVATE LIMITED",
"STAR GLOBAL ENDURA LIMITED",
"STAR GLOBAL MULTI VENTURES PRIVATE LIMITED",
"STAR GLOBAL RESOURCES LIMITED",
"STAR GOLD MARKETING PRIVATE LIMITED",
"STAR GOLD PRIVATE LIMITED",
"STAR GRAIN AND SHIPPING PRIVATE LIMITED",
"STAR HARDWARE (INDIA) PRIVATE LIMITED",
"STAR HEALTH AND ALLIED INSURANCE COMPANY LIMITED",
"STAR HEALTH SCIENCES INDIA LIMITED",
"STAR HENTZEN COATINGS PRIVATE LIMITED",
"STAR HI-HERBS PRIVATE. LIMITED.",
"STAR HITECH BUILDTECH PRIVATE LIMITED",
"STAR HOLIDAYS",
"STAR HOSPITAL METERNITY & LAPAROSCPTY CENTER",
"STAR HOSPITAL PRIVATE LIMITED",
"STAR HOTELS PRIVATE LIMITED",
"STAR HOUSING FINANCE LIMITED",
"STAR HUMAN SCIENCES PRIVATE LIMITED",
"STAR HYDRAULICS PRIVATE LIMITED",
"STAR IGLOBAL AUTOMOTIVE PRIVATE LIMITED",
"STAR IMAGING AND PATH LAB PRIVATE LIMITED",
"STAR IMPACT PRIVATE LIMITED",
"STAR IMPEX INDIA PRIVATE LIMITED",
"STAR INDIA AGENCIES PRIVATE LIMITED",
"STAR INDIA CONTAINER LINE PRIVATE LIMITED",
"STAR INDIA ELECTRICALS",
"STAR INDIA PRIVATE. LIMITED",
"STAR INDUSTRIES",
"STAR INFOMATIC PRIVATE LIMITED",
"STAR INFRA DESIGN PRIVATE LIMITED",
"STAR INFRA DEVELOPERS PRIVATE LIMITED",
"STAR INFRA TECH PRIVATE LIMITED",
"STAR INFRATECH",
"STAR INFRAVISION (INDIA) PRIVATE LIMITED",
"STAR INN SUITES AND RETREAT LIMITED",
"STAR INTERIORS PRIVATE LIMITED",
"STAR INTERNATIONAL PRIVATE LIMITED",
"STAR INXS SOLUTIONS PRIVATE LIMITED",
"STAR IRIS EXPORTS PRIVATE LIMITED",
"STAR JOBS PRIVATE LIMITED",
"STAR KRAFT PAPERS PRIVATE LIMITED",
"STAR LAMINATES INDIA PRIVATE LIMITED",
"STAR LAND INTER COLLEGE",
"STAR LANDBASE PRIVATE LIMITED",
"STAR LANDCRAFT PRIVATE LIMITED",
"STAR LINK COMMUNICATION PRIVATE LIMITED",
"STAR MEDIA MARKETING PRIVATE LIMITED",
"STAR METAWARE INDIA PRIVATE LIMITED",
"STAR MINING INFRACON INDIA PRIVATE LIMITED",
"STAR MINT FIELDS PRIVATE LIMITED",
"STAR MOBITEL LIMITED",
"STAR NOVA INTELLIGENT LOGISTICS EQUIPMENT PRIVATE LIMITED",
"STAR NOVATION PRIVATE LIMITED",
"STAR NUKE CONSULTING ENGINEERING SERVICES PRIVATE LIMITED",
"STAR ONLINE TECHNOLOGIES LIMITED",
"STAR ORECHEM INTERNATIONAL PRIVATE LIMITED",
"STAR OXALATE PRIVATE LIMITED",
"STAR OXOCHEM PRIVATE LIMITED",
"STAR PAPER MILL UCHCHTAR MADHYAMIK VIDYALYA SAHARANPUR",
"STAR PAPER MILLS LTD",
"STAR PARIVAR INDIA PRIVATE LIMITED",
"STAR PATHOLOGY",
"STAR PET TRADING PRIVATE LIMITED",
"STAR PINNACLE HEART CENTRE PRIVATE LIMITED",
"STAR PIPE FOUNDRY INDIA PRIVATE LIMITED",
"STAR PIPE PRODUCTS INDIA PRIVATE LIMITED",
"STAR PLASTICS",
"STAR PLASTS",
"STAR PLYLAM LIMITED",
"STAR POINT TECHNOLOGY PRIVATE LIMITED",
"STAR POWER DISTRIBUTION PRIVATE LIMITED",
"STAR PRECISION WORKS (INDIA) PRIVATE LIMITED",
"STAR PREMIER PAPER MART PRIVATE LIMITED",
"STAR PRODUCTS PRIVATE LIMITED",
"STAR PROPWELL PRIVATE LIMITED",
"STAR PVC PIPES AND FITTINGS PRIVATE LIMITED",
"STAR RADIATORS PRIVATE LIMITED",
"STAR RAYS",
"STAR REALCON PRIVATE LIMITED",
"STAR REALTECH AND DEVELOPERS PRIVATE LIMITED",
"STAR REDRAWERS PRIVATE LIMITED",
"STAR RFID AND SYSTEMS INDIA PRIVATE LIMITED",
"STAR RICE LAND PRIVATE LIMITED",
"STAR RISING ENERGY PRIVATE LIMITED",
"STAR ROYAL DISTRIBUTORS",
"STAR SEAL (INDIA) PRIVATE LIMITED",
"STAR SECUTECH PRIVATE LIMITED",
"STAR SHIPPING SERVICES INDIA PRIVATE LIMITED",
"STAR SILK EXPORTS PRIVATE LIMITED",
"STAR SINTERED PRODUCTS LIMITED",
"STAR SMITH EXPORT PRIVATE LIMITED",
"STAR SOLAR POWER PRIVATE LIMITED",
"STAR SPECIAL AIR GASES PRIVATE LIMITED",
"STAR SPECIALTIES POLYMERS PRIVATE LIMITED",
"STAR SPECTRUM SECURITY PRIVATE LIMITED",
"STAR SPINTEX PRIVATE LIMITED",
"STAR SQUARE HOMES PRIVATE LIMITED",
"STAR STATIONERY",
"STAR SU INDIA PRIVATE LIMITED",
"STAR SUPPORT SERVICES PRIVATE LIMITED",
"STAR SYNTHETICS PVT LTD",
"STAR SYSTEMS ( INDIA ) PRIVATE LIMITED",
"STAR TEA CO PVT LTD",
"STAR TECHNICAL SERVICES PRIVATE LIMITED",
"STAR TECHNOCRATES PRIVATE LIMITED",
"STAR THERAPEUTIC PRIVATE LIMITED",
"STAR THREADS PRIVATE LIMITED",
"STAR TILE WORKS LIMITED",
"STAR TOUCH INDIA PRIVATE LIMITED",
"STAR TOURS & HOLIDAYS PRIVATE LIMITED",
"STAR TRACK FASTENERS PRIVATE LIMITED",
"STAR TRACK FOOTWEAR PRIVATE LIMITED",
"STAR TRACK SHIPPING PRIVATE LIMITED",
"STAR TRACK TERMINALS PRIVATE LIMITED",
"STAR TRANSFORMERS LIMITED",
"STAR TREASURE TRAVELS PRIVATE LIMITED",
"STAR TRECK TEXTILES PRIVATE LIMITED",
"STAR TROOPER TECHNOLOGIES PRIVATE LIMITED",
"STAR UNION DAI-ICHI LIFE INSURANCE COMPANY LIMITED",
"STAR VALLY BUILDERS INDIA PRIVATE LIMITED",
"STAR VENTURES MARKETING PRIVATE LIMITED",
"STAR VETCHEM PRIVATE LIMITED",
"STAR VISIONARY MULTITRADE PRIVATE LIMITED",
"STAR WAREHOUSING AND TRANSPORT SERVICES PRIVATE LIMITED",
"STAR WEB MAKER SERVICES PRIVATE LIMITED",
"STAR WHEELS LOGISTICS & SERVICES PRIVATE LIMITED",
"STAR WIRE (INDIA) LIMITED",
"STAR WIRE (INDIA) VIDYUT PRIVATE LIMITED",
"STAR WIRE INDIA ENGINEERING LIMITED",
"STAR WIRE INDIA LIMITED",
"STAR WORLD WIDE INFOTECH LIMITED",
"STAR WORLDWIDE GROUP PRIVATE LIMITED",
"STAR ZIPPERS PRIVATE LIMITED",
"STAR1 MANAGEMENT SERVICES PRIVATE LIMITED",
"STAR9 REFRATCH",
"STARALLIANCE RESORTS LLP",
"STARAS SEATING PRIVATE LIMITED",
"STARASHIYANA CONSTRUCTION PRIVATE LIMITED",
"STARAX BUSINESS PRIVATE LIMITED",
"STARAX MINERALS INDIA PRIVATE LIMITED",
"STARBERRY LTD",
"STARBIC BUSINESS SOLUTIONS PRIVATE LIMITED",
"STARBIGBLOC BUILDING MATERIAL PRIVATE LIMITED",
"STARBOARD HOTELS PRIVATE LIMITED",
"STARBUCKS CORPORATION",
"STARBURST MOTORS PRIVATE LIMITED",
"STARC ENERGY SOLUTIONS PRIVATE LIMITED",
"STARCARE HOSPITAL KOZHIKODE PRIVATE LIMITED",
"STARCARE TECHNOLOGIES PRIVATE LIMITED",
"STARCHART SHIPBROKERS PRIVATE LIMITED",
"STARCHEM POLYTRADE PRIVATE. LIMITED.",
"STARCHIK FOODS PRIVATE LIMITED",
"STARCITY BUILDCON PRIVATE LIMITED",
"STARCITY REAL ESTATES PRIVATE LIMITED",
"STARCK IMPEX PRIVATE LIMITED",
"STARCKE ABRASIVES INDIA PRIVATE LIMITED",
"STARCO AROCHEM PRIVATE LIMITED",
"STARCO METAPLAST PRIVATE LIMITED",
"STARCODE SOLUTIONS PRIVATE LIMITED",
"STARCOM INFORMATION TECHNOLOGY LIMITED",
"STARCON INFRA PROJECTS INDIA PRIVATE LIMITED",
"STARCON LOGISTICS PRIVATE LIMITED",
"STARCORE REFRIGERATION LIMITED",
"STARCREST SERVICES PRIVATE. LIMITED.",
"STARDIAMOND STEEL INDUSTRIES PRIVATE LIMITED",
"STAREAST HEALTHTECH PRIVATE LIMITED",
"STARENERGY FUELS PRIVATE LIMITED",
"STAREX DRYCLEANERS PRIVATE LIMITED",
"STAREX INFOTECH PRIVATE LIMITED",
"STAREX UNIVERSITY",
"STARFIELD RENEWABLES PRIVATE LIMITED",
"STARFIN INDIA PRIVATE LIMITED",
"STARFIRE GEMS PRIVATE LIMITED",
"STARFISH EXPORTS INTERNATIONAL PRIVATE LIMITED",
"STARFLEX BELLOWS PRIVATE LIMITED",
"STARFLEX SEALING INDIA PRIVATE LIMITED",
"STARFUTURE CONSTRUCTION PRIVATE LIMITED",
"STARGATE ENTERPRISES PRIVATE LIMITED",
"STARGAZE PROPERTIES PRIVATE LIMITED",
"STARGEMS EXPORTS PRIVATE LIMITED",
"STARGLOW LIFE SOLUTIONS LLP",
"STARHAVEN BUILDERS PRIVATE LIMITED",
"STARHEAD COMMERCIAL PRIVATE LIMITED",
"STARHOME MACH",
"STARHOMES INFRATECH INDIA PRIVATE LIMITED",
"STARINDIA FIELDS PRIVATE LIMITED",
"STARION INDIA PVT LTD",
"STARIOR PHARMA PRIVATE LIMITED",
"STARISH AUTOPAC PRIVATE LIMITED",
"STARK COMMUNICATIONS PRIVATE LIMITED",
"STARK COMPUTECH PRIVATE LIMITED",
"STARK CONTAINERS PRIVATE LIMITED",
"STARK DIGITAL MEDIA SERVICES PRIVATE LIMITED",
"STARK ENGINEERING PRIVATE LIMITED",
"STARK ENTERPRISES PRIVATE LIMITED",
"STARK INFRAPROJECTS PRIVATE LIMITED",
"STARK PACKMATE PRIVATE LIMITED",
"STARK RIDGE PAPER PRIVATE LIMITED",
"STARKA INNOVATIVESYSTEMS PRIVATE LIMITED",
"STARKE ADHESIVE PRIVATE LIMITED",
"STARKE INTERNATIONAL EXIM PRIVATE LIMITED",
"STARKEY LABORATORIES INDIA PRIVATE LIMITED",
"STARKSTEN CONSULTANTS PRIVATE LIMITED",
"STARKWAYS SPECIALITY MATERIALS PRIVATE LIMITED",
"STARKYE SHOES PRIVATE LIMITED",
"STARLAC GLASS PRIVATE LIMITED",
"STARLASE SYSTEMS PRIVATE LIMITED",
"STARLET LED LIGHTING PRIVATE LIMITED",
"STARLEY BUSINESS SERVICES PRIVATE LIMITED",
"STARLIFT SERVICES PRIVATE LIMITED",
"STARLIGHT BRUCHEM LIMITED",
"STARLIGHT DATA SOLUTIONS PRIVATE LIMITED",
"STARLIGHT HOLDINGS PRIVATE LIMITED",
"STARLIGHT HOSPITALS PRIVATE LIMITED",
"STARLIGHT ISPAT PRIVATE LIMITED",
"STARLIGHT MANAGEMENT & MANPOWER SOLUTION PRIVATE LIMITED",
"STARLIGHT SYSTEMS I LLP",
"STARLINE BRACKETS PRIVATE LIMITED",
"STARLINE CARS (AHMEDABAD) PRIVATE LIMITED",
"STARLINE CARS PRIVATE LIMITED",
"STARLINE EQUIFIN PRIVATE LIMITED",
"STARLINE HOTELS & INFRA PRIVATE LIMITED",
"STARLINE INDUSTRIES (INDIA) PRIVATE LIMITED",
"STARLINE NIRMAN PRIVATE LIMITED",
"STARLINE ORGANICS PRIVATE LIMITED",
"STARLINE PACKERS PRIVATE LIMITED",
"STARLINE POLYMERS PRIVATE LIMITED",
"STARLINE TRACTORS PRIVATE LIMITED",
"STARLINE TRAVELS PRIVATE LIMITED",
"STARLINEPS ENTERPRISES LIMITED",
"STARLINES (INDIA) PRIVATE LIMITED",
"STARLING ASSOCIATES PRIVATE LIMITED",
"STARLINGER PLASTICS MACHINERY INDIA PRIVATE LIMITED",
"STARLINGS WIRELESS COMMUNICATIONS PRIVATE LIMITED",
"STARLINK CONNECTION PRIVATE LIMITED",
"STARLINK LOGISTICS PRIVATE LIMITED",
"STARLINK MANAGEMENT SERVICES PRIVATE LIMITED",
"STARLINKS RESOURCES PRIVATE LIMITED",
"STARLIT FINANCE LIMITED",
"STARLIT PAPERS TRADE PRIVATE LIMITED",
"STARLIT SHIPPING PRIVATE LIMITED",
"STARLITE ELECTRODRIVES PRIVATE LIMITED",
"STARLITE GLOBAL ENTERPRISES (INDIA) LIMITED.",
"STARLITE INDUSTRIES PRIVATE LIMITED",
"STARLITE LIGHTING LIMITED",
"STARLITE MOULDING PRODUCTS PRIVATE LIMITED",
"STARLITE RUBBERS PRIVATE LIMITED",
"STARLITE SPINTECH LIMITED",
"STARLOG ENTERPRISES LIMITED",
"STARLON EXIM PRIVATE LIMITED",
"STARMARK MARKETING PRIVATE LIMITED",
"STARMARK SOFTWARE PRIVATE LIMITED",
"STARMAXX DISTRIBUTORS PRIVATE LIMITED",
"STARMED HEALTH CARE PRIVATE LIMITED",
"STARMEDIA COMMUNICATION LIMITED",
"STARMERC INFRATECH PRIVATE LIMITED",
"STARMILK PRODUCTS PRIVATE LIMITED",
"STARMOON CONSULTING SERVICES PRIVATE LIMITED",
"STARNET MARKETING PVT LTD",
"STARNET SOFTWARE INDIA LIMITED",
"STAROL MARKETING PRIVATE LIMITED",
"STAROL PETROLEUM LIMITED",
"STARON CHEMICALS PRIVATE LIMITED",
"STARONE GLOBAL PRIVATE LIMITED",
"STARONE IT SOLUTIONS (INDIA) PRIVATE LIMITED",
"STARPACK OVERSEAS PRIVATE LIMITED",
"STARPORT CONTAINER LINE PRIVATE LIMITED",
"STARRAG INDIA PRIVATE LIMITED",
"STARRIDE PAPER TUBE PRIVATE LIMITED",
"STARRUBY.IN PRIVATE LIMITED",
"STARS ALUMINIUM EXTRUSION PRIVATE LIMITED",
"STARS AND MERIT INTERIORS PRIVATE LIMITED",
"STAR'S COSMETICS (INDIA) PRIVATE LIMITED",
"STARS MULTIPURPOSE COOPERATIVE SOCIETY LIMITED",
"STARSHIELD SECURITY SOLUTION PRIVATE LIMITED",
"STARSHIELD TECHNOLOGIES PRIVATE LIMITED",
"STARSHINE ALUMINIUM EXTRUSIONS PRIVATE LIMITED",
"STAR-SHINE CLOTHING PRIVATE LIMITED",
"STARSHINE LAND DEVELOPERS PRIVATE LIMITED",
"STARSHINE MANUFACTURING COMPANY PRIVATE LIMITED",
"STARSHINE TIE-UP PRIVATE LIMITED",
"STARSHIP FREIGHT PRIVATE LIMITED",
"STARSHIP VALUE CHAIN AND MANUFACTURING PRIVATE LIMITED",
"STARSHOT TOOLS PRIVATE LIMITED",
"START SOLAR PRIVATE LIMITED",
"START UP FARMS IT PRIVATE LIMITED",
"STARTBIT IT SOLUTIONS PRIVATE LIMITED",
"STARTECH CONCRETE PRIVATE LIMITED",
"STARTECH FIBRES PRIVATE LIMITED",
"STARTECH LABS PRIVATE LIMITED",
"STARTECK FINANCE LIMITED",
"STARTEK ELECTRICALS PRIVATE LIMITED",
"STARTEL SOLUTION",
"STARTELE TECH PRIVATE LIMITED",
"STARTELL BIOCEUTICALS PRIVATE LIMITED",
"STARTEX INTEGRATED SOLUTIONS PRIVATE LIMITED",
"STARTEX KNITWEARS PRIVATE LIMITED",
"STARTLING SOLAR PRIVATE LIMITED",
"STARTOS HEALTHCARE PRIVATE LIMITED",
"STARTRACK COMMODITIES PVT.LTD.",
"STARTREE COMTRADE PRIVATE LIMITED",
"STARTRONIX MODULAR SYSTEMS PRIVATE LIMITED",
"STARTUBES TRADEX PRIVATE LIMITED",
"STARTUP BUDDY SERVICES PRIVATE LIMITED",
"STARTUP EQUITY PARTNERS PRIVATE LIMITED",
"STARTUP INVESTMENTS (HOLDING) LIMITED",
"STARTUP LABS INFOTECH PRIVATE LIMITED",
"STARTUP ODISHA",
"STARTUPHUTS ARENA PRIVATE LIMITED",
"STARTUPWALA TECHNOLOGIES PRIVATE LIMITED",
"STARTXLABS TECHNOLOGIES PRIVATE LIMITED",
"STARVOIGHT PRIVATE LIMITED",
"STARWAYS ENGINEERS PRIVATE LIMITED",
"STARWAYS PRECISIONS PRIVATE LIMITED",
"STARWELL PROMOTERS PRIVATE LIMITED",
"STARWELL PROPERTIES PRIVATE LIMITED",
"STARWIN PERFECT MANUFACTURING COMPANY PRIVATE LIMITED",
"STARWING DEVELOPERS PRIVATE LIMITED",
"STARWINGS FASHION TRADING LIMITED",
"STARWOOD CONTRACTS PRIVATE LIMITED",
"STARWOOD DEVELOPERS LIMITED",
"STARWOOD HOTELS & RESORTS WORLDWIDE, INC.",
"STARWOOD INDIA PRIVATE LIMITED",
"STARWOOD VENEERS PVT LTD",
"STARWOODS SHIPPING (INDIA) PRIVATE LIMITED",
"STARWORTH INFRASTRUCTURE & CONSTRUCTION LIMITED",
"STARX CASTORS PRIVATE LIMITED",
"STARX CREATIONS PRIVATE LIMITED",
"STARX DISTRIBUTORS PRIVATE LIMITED",
"STAS BIOCHEM PRIVATE LIMITED",
"STAS CHEM TECHNOLOGIES PRIVATE LIMITED",
"STASH SALES AND MARKETING PRIVATE LIMITED",
"STASIS HEALTH PRIVATE LIMITED",
"STAT BILLING SOLUTIONS PRIVATE LIMITED",
"STAT CONSULTANCY PRIVATE LIMITED",
"STAT MEDIA PRIVATE LIMITED",
"STAT WEIGH INDIA PRIVATE LIMITED",
"STATCOMP TECHNOLOGY PRIVATE LIMITED",
"STATCON ELECTRONICS INDIA LIMITED",
"STATCON ENERGIAA PRIVATE LIMITED",
"STATCON POWER CONTROLS LIMITED",
"STATE BANK OF BIKANER AND JAIPUR",
"STATE BANK OF INDIA",
"STATE BANK OF INDIA EMPLOYEES ( CHARLES COUTTO) CO OPERATIVE CREDIT SOCIETY LIMITED",
"STATE BANK OF MAURITIUS",
"STATE BANK OF MYSORE",
"STATE BANK OF PATIALA",
"STATE BANK OF SAURASHTRA",
"STATE CONSUMER D R COMMISSION",
"STATE DISASTER RESQUE FORCE S. R. P. F. GROUP- 4, NAGPUR",
"STATE ELECTRICITY BOARD",
"STATE EXAMINATION BOARD GANDHINAGAR",
"STATE EXPRESS TRANSPORT CORPORATION ,TAMIL NADU LIMITED",
"STATE FARM INSURANCE COS.",
"STATE FORENSIC SCIENCE LABORATORY RAIPUR CHHATTISGARH",
"STATE GOVERNMENT AGRI DEPARTMENT",
"STATE GOVERNMENT",
"STATE GOVT GUJARAT GOGAPURA PRIMARY SCHOOL",
"STATE HEALTH RESOURCE CENTER CHHATTISGARH",
"STATE HEALTH SOCIETY INDORE",
"STATE HEALTH SOCIETY MAHARASHTRA",
"STATE INDUSTRIES PROMOTION CORP. OF TAMIL NADU",
"STATE INST OF HEALTH FAMILY WELFAR",
"STATE INST OF RURAL DEVELOPMENT",
"STATE INSTITUTE OF PHYSICAL EDUCATION FO",
"STATE LITERACY MISSION AUTHORITY",
"STATE MESIUM UP LKO",
"STATE OF DIRECTORATE OF VETERINARY SERVICES",
"STATE PROJECT MANAGEMENT UNIT UTTAR PRADESH",
"STATE PROTOCOL OFFICER",
"STATE RURAL LIVELIHOODS MISSION",
"STATE STREET CORPORATE SERVICES MUMBAI PRIVATE LIMITED",
"STATE STREET SERVICES PRIVATE LIMITED",
"STATE UNANI MEDICAL COLLEGE",
"STATE URBAN DEVELOPMENT AGENCY",
"STATELY LIFE-SCIENCE PRIVATE LIMITED",
"STATELY SUITES PRIVATE LIMITED",
"STATESMAN TRAVEL SERVICES PRIVATE LIMITED",
"STATESTEET CORPORATE SERVICES MUMBAI PRIVATE",
"STATESTREET GLOBAL ADVISORS INDIA PRIVATE LIMITED",
"STATESTREET CORPORATE SERVICES DELHI PRIVATE LIMITED",
"STATFIELD EQUIPMENTS PRIVATE LIMITED",
"STATIC CONTROL SYSTEMS PVT LTD",
"STATIC HYDRAULIC PVT LTD",
"STATIC SYSTEMS ELECTRONICS PRIVATE LIMITED",
"STATIC SYSTEMS PRIVATE LIMITED",
"STATIC WORKSHOP EME",
"STATICE ENERGY PRIVATE LIMITED",
"STATION CELL HQ BSA KOLKATA MINISTRY OF DEFENCE",
"STATION CELL HQ PH AND HPI SUB AREA AMBALA CANT",
"STATION HEADQUARTERS CELL",
"STATION HEADQUARTERS DEVLALI",
"STATION HEADQUARTERS ROORKEE CANTT",
"STATION HEALTH ORGANISATION",
"STATION SATCOM PRIVATE LIMITED",
"STATION WORKSHOP EME KIRKEE",
"STATIONERY DEPOT CALCUTTA",
"STATIONERY POINT (INDIA) LIMITED",
"STATKRAFT INDIA PRIVATE LIMITED",
"STATKRAFT MARKETS PRIVATE LIMITED",
"STATOMAT SPECIAL MACHINES INDIA PRIVATE LIMITED",
"STATRON INDIA PRIVATE LIMITED",
"STATS SPECIALITY PRODUCTS PRIVATE LIMITED",
"STATS SYSTEMS INDIA PRIVATE LIMITED",
"STATUS CLUB PRIVATE LIMITEDD.",
"STATUS CONSTRUCTIONS PRIVATE LIMITED",
"STATUS CREDIT AND CAPITAL PRIVATE LIMITED",
"STATUS LEISURE TRAVELLERS PRIVATE LIMITED",
"STATUS MONEY CHANGER PRIVATE LIMITED",
"STATUS PORTFOLIOS LIMITED",
"STATUS QUO LIFESTYLE CO",
"STATUS QUO TRAVELS PRIVATE LIMITED",
"STATUS SANITECH PRIVATE LIMITED",
"STATUS SERAMIK INDIA PRIVATE LIMITED",
"STATUS SPINNING MILLS PRIVATE LIMITED",
"STATUS TRACON PVT.LTD.",
"STATUSNEO TECHNOLOGY CONSULTING PRIVATE LIMITED",
"STATXO ANALYTICS PRIVATE LIMITED",
"STAUBLI INDIA PRIVATE LIMITED",
"STAUBLI TEC SYSTEMS INDIA PRIVATE LIMITED",
"STAUFF INDIA PRIVATE LIMITED",
"STAUNCH ELECTRONICS INDIA LLP",
"STAUNCH EXIM PRIVATE LIMITED",
"STAUNCH LOGISTICS PRIVATE LIMITED",
"STAUNCH TECHNOLOGIES PRIVATE LIMITED",
"STAUNCHLY MOTORSALES PRIVATE LIMITED",
"STAUNCHONDEMAND SOLUTIONS PRIVATE LIMITED",
"STAVE PHARMACEUTICALS PRIVATE LIMITED",
"STAVTAR INDIA PRIVATE LIMITED",
"STAVTAR SOLUTIONS INDIA PRIVATE LIMITED",
"STAVYA SPINE HOSPITAL & RESEARCH INSTITUTE PRIVATE LIMITED",
"STAVYA TECHNOCRAFTS PRIVATE LIMITED",
"STAXX SPEARS MHE PRIVATE LIMITED",
"STAY N EXPLORE PRIVATE LIMITED",
"STAY QURIOUS VENTURES PRIVATE LIMITED",
"STAY SHARP DIAMOND TOOLS PVT LTD",
"STAY VISTA PRIVATE LIMITED",
"STAYABODE VENTURES PRIVATE LIMITED",
"STAYALT BRANDS PRIVATE LIMITED",
"STAYFIT ENTERPRIZE PRIVATE LIMITED",
"STAYFIT HEALTH AND FITNESS WORLD PRIVATE LIMITED",
"STAYINFRONT INDIA PRIVATE LIMITED",
"STAY-ON PAPERS PVT LTD",
"STAYQRIOUS INDIA PRIVATE LIMITED",
"STAYSAFE ENVIRO ENGINEERING PRIVATE LIMITED",
"STAYWELL APARTMENTS LLP",
"STAYWELL BUSINESS SUPPORT SERVICES PRIVATE LIMITED",
"STAYWELL FORMULATION PRIVATE. LIMITED.",
"STAYWELL HOSPITALITY MGT PRIVATE LIMITED",
"STAYZY HYGIENE PRIVATE LIMITED",
"STB MARKETING PRIVATE LIMITED",
"STB TECHNOLOGIES PRIVATE LIMITED",
"STBL PROJECTS LIMITED",
"STC DEVELOPERS PRIVATE LIMITED",
"STC GLOBAL METAL PRIVATE LIMITED",
"STC INDIA PRIVATE LIMITED",
"STC INFRA & TRADE INDUSTRIES PRIVATE LIMITED",
"STC LOGISTICS PRIVATE LIMITED",
"STC PACKAGING PRIVATE LIMITED",
"STC SECURITIES PRIVATE LIMITED",
"STC TECHNOLOGIES PRIVATE LIMITED",
"STC THIRDEYE TECHNOLOGY INDIA PRIVATE LIMITED",
"STC TRANSPORTS PRIVATE LIMITED",
"STC VENTURES PRIVATE LIMITED",
"STCH DIGITAL SOLUTIONS PRIVATE LIMITED",
"STCH INTEGRATED MARKETING SOLUTION PRIVATE LIMITED",
"STCI FINANCE LIMITED",
"STCI PRIMARY DEALER LIMITED",
"STDK AGRO INDUSTRY PRIVATE LIMITED",
"STDM FOOD AND BEVERAGES PRIVATE LIMITED",
"STEADFAST BUSINESS CONSULTING LLP",
"STEADFAST HEALTHCARE PRIVATE LIMITED",
"STEADFAST INTERNATIONAL PRIVATE LIMITED",
"STEADFAST MEDISHIELD PRIVATE LIMITED",
"STEADFAST METAL PRODUCTS PRIVATE LIMITED",
"STEAG ENERGY SERVICES (INDIA) PRIVATE LIMITED",
"STEAG O&M COMPANY PRIVATE LIMITED",
"STEALTH BRIDGE PRIVATE LIMITED",
"STEALTH GUARD PRIVATE LIMITED",
"STEALTH INTEGRATED SERVICES PRIVATE LIMITED",
"STEALTH MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"STEAM EQUIPMENTS PRIVATE LIMITED",
"STEAM POINT BOILERS & HEATERS PRIVATE LIMITED",
"STEAM POWER ENERTECH PRIVATE LIMITED",
"STEAM RADIATORS MANUFACTURING COMPANY (INDIA) P LTD",
"STEAM TRANZACT CONSULTING PRIVATE LIMITED",
"STEAM TURBINE ENGINEERING INDIA PRIVATE LIMITED",
"STEAMATIC COMPONENTS PRIVATE LIMITED",
"STEAMAX ENVIROCARE PRIVATE LIMITED",
"STEAMFIELD INTERNATIONAL SCHOOL",
"STEAMHOUSE INDIA LIMITED",
"STEAMLINE TECHNOCRATES PRIVATE LIMITED",
"STEAMLOK ENGINEERING PRIVATE LIMITED",
"STEBER ENERGY SOLUTIONS PRIVATE LIMITED",
"STECH AUTOMATION PRIVATE LIMITED",
"STECH IVF SOLUTIONS PRIVATE LIMITED",
"STECK STREAMS PRIVATE LIMITED",
"STECKBECK JEWELRY PRIVATE LIMITED",
"STECKTRA TECHNOLOGIES PRIVATE LIMITED",
"STECOL INTERNATIONAL PRIVATE LIMITED",
"STECON ENGINEERING COMPANY PRIVATE LIMITED",
"STEDMAN PHARMACEUTICALS PRIVATE LIMITED",
"STEDRANT TECHNOCLINIC PRIVATE LIMITED",
"STEED ENGINEERING PRIVATE LIMITED",
"STEEFO INDUSTRIES PRIVATE LIMITED",
"STEEL & METALS",
"STEEL & TUBE FIELD INDIA PRIVATE LIMITED",
"STEEL AIDS PRIVATE LIMITED",
"STEEL AND INDUSTRIAL FORGINGS LIMITED",
"STEEL AND METAL TUBES (INDIA) PRIVATE LIMITED",
"STEEL AND SCRAP PRIVATE LIMITED",
"STEEL ART INDUSTRIES PRIVATE LIMITED",
"STEEL AUTHORITY OF INDIA LIMITED",
"STEEL BARREL PRIVATE LIMITED",
"STEEL BULLS INDIA PRIVATE LIMITED",
"STEEL CARRIERS INFRASTRUCTURE PRIVATE LIMITED",
"STEEL CAST AID LIMITED",
"STEEL CENTRE PVT LTD",
"STEEL CHAMBER OF INDIA",
"STEEL CITY COMMODITIES PRIVATE LIMITED",
"STEEL CITY COMPTO AIDS PVT LTD",
"STEEL CITY FINANCIAL SERVICES PRIVATE LIMITED",
"STEEL CITY FOOD PRODUCTS PRIVATE LIMITED",
"STEEL CITY PHARMACEUTICALS PVT LTD",
"STEEL CITY PRESS PRIVATE LIMITED",
"STEEL CITY SECURITIES LIMITED",
"STEEL CITY TECHNO WORKS PRIVATE LIMITED",
"STEEL CLUSTER SERVICES SALEM PRIVATE LIMITED",
"STEEL CRACKERS PVT LTD",
"STEEL DIMENSIONS INDIA PRIVATE LIMITED",
"STEEL EMPORIUM LTD",
"STEEL EXCHANGE INDIA LIMITED",
"STEEL FAB ENGINEERING CONTRACTORS",
"STEEL GRACE INDIA PRIVATE LIMITED",
"STEEL HOUSE",
"STEEL HOUSE & INFRA PRIVATE LIMITED",
"STEEL ICON STAINLESS PRIVATE LIMITED",
"STEEL INDIA COMPANY",
"STEEL INFRA SOLUTIONS PRIVATE LIMITED",
"STEEL INNOVATIONS PRIVATE LIMITED",
"STEEL INVESTMENTS PRIVATE LIMITED",
"STEEL KALA ENGINEERING PRIVATE LIMITED",
"STEEL MAC CONTROLS PRIVATE LIMITED",
"STEEL MAX ROLLING MILLS LIMITED",
"STEEL MONT PRIVATE LIMITED",
"STEEL PARADISE (INDIA) PRIVATE LIMITED",
"STEEL PLANT PRIVATE LIMITED",
"STEEL PLANT SPECIALITIES LLP",
"STEEL PLANTECH INDIA PRIVATE LIMITED",
"STEEL PLAY INNOVATIONS PRIVATE LIMITED",
"STEEL POINT",
"STEEL POINT (I) PRIVATE LIMITED",
"STEEL PRODUCTS LTD.",
"STEEL PROJECTS (INDIA) PRIVATE LIMITED",
"STEEL SE ENGINEERING PRIVATE LIMITED",
"STEEL SHOPPE INDIA PRIVATE LIMITED",
"STEEL SPACE PRIVATE LIMITED",
"STEEL STRIPS INFRASTRUCTURES LIMITED",
"STEEL STRIPS WHEELS LIMITED",
"STEEL STRONG VALVES INDIA PRIVATE LIMITED",
"STEEL SUN",
"STEEL TRADERS",
"STEEL WELD(BOMBAY) PVT LTD",
"STEEL WORKS AND POWER ENGINEERS PRIVATE LIMITED",
"STEELAGE OVERSEAS PRIVATE LIMITED",
"STEELAGE REFRACTORIES PRIVATE LIMITED",
"STEELART ENGINEERING PVT LTD",
"STEELBIRD HI-TECH INDIA LIMITED",
"STEELBOY PRIVATE LIMITED",
"STEELBUILD INFRA PROJECTS PRIVATE LIMITED",
"STEELCASE ASIA PACIFIC HOLDINGS INDIA PRIVATE LIMITED",
"STEELCAST LIMITED",
"STEEL-CEM CONSTRUCTIONS PRIVATE LIMITED",
"STEELCITY SERVICES SOLUTION PRIVATE LIMITED",
"STEELCO FURNITURE PRIVATE LIMITED",
"STEELCOAT INDUSTRIES PRIVATE LIMITED",
"STEELCON IMPEX PRIVATE LIMITED",
"STEELCONS ENGINEERS PRIVATE LIMITED",
"STEELCRAFT FOODSERVICE EQUIPMENTS PRIVATE LIMITED",
"STEELCRAFT HOSPITAL FURNITURE INDUSTRIES PRIVATE LIMITED",
"STEEL-CRETE PRIVATE LIMITED",
"STEELEX ELECTROCAST PRIVATE LIMITED",
"STEELEX EXPORTS PRIVATE LIMITED",
"STEELEX HOROLOGICAL PRIVATE LIMITED",
"STEELEX INDIA PVT LTD.",
"STEELEX PRECISIONS PRIVATE LIMITED",
"STEELEXPERT INDUSTRIES (INDORE) PRIVATE LIMITED",
"STEELEYE INDIA PRIVATE LIMITED",
"STEELFAB ENGINEERING PRIVATE LIMITED",
"STEELFUR SYSTEM PRIVATE LIMITED",
"STEELINT BLASTING EQUIPMENT PRIVATE LIMITED",
"STEELION BUILDING SOLUTIONS PRIVATE LIMITED",
"STEELION PREFAB INFRA SOLUTIONS PRIVATE LIMITED",
"STEELITE ENGINEERING LIMITED",
"STEELKING ENTERPRISES PRIVATE LIMITED",
"STEELKRAFT EQUIPMENTS INDIA PRIVATE LIMITED",
"STEELKRAFT HOSPITALITY PRIVATE LIMITED",
"STEELLORD ENGINEERING PRIVATE LIMITED",
"STEELLOYS INDIA PRIVATE LIMITED",
"STEELMAN ENGINEERINGS AND FORGINGS",
"STEELMAN EXIM INDIA PRIVATE LIMITED",
"STEELMAN GASES PRIVATE LIMITED",
"STEELMAN INDUSTRIES",
"STEELMAN ROLLING MILLS PVT LTD",
"STEELMAN TELECOM LIMITED",
"STEELMAN TELECOM PRIVATE LIMITED",
"STEELMAX PROCESSORS PRIVATE LIMITED",
"STEELMEN MACHINERY PRIVATE LIMITED",
"STEELMINT INDUSTRIES PRIVATE LIMITED",
"STEELON BUILDING SYSTEMS PRIVATE LIMITED",
"STEELS AND CARRIERS PRIVATE LIMITED",
"STEELSMITH CONTINENTAL MANUFACTURING PRIVATE LIMITED",
"STEELSWORTH PRIVATE LIMITED",
"STEELTECH ALLOYS PRIVATE LIMITED",
"STEELTOUCH HARDWARE PRIVATE LIMITED",
"STEELWEDGE TECHNOLOGIES PRIVATE LIMITED",
"STEEP RISE INFOTECH PRIVATE LIMITED",
"STEEPGRAPH SYSTEMS PRIVATE LIMITED",
"STEEPLE & HUDSON PEST CONTROL PRIVATE LIMITED",
"STEER DAVIES GLEAVE INDIA PRIVATE LIMITED",
"STEER ENGINEERING PRIVATE LIMITED",
"STEERLEAN CONSULTANCY SERVICES PRIVATE LIMITED",
"STEERLIFE INDIA PRIVATE LIMITED",
"STEERMATE INDIA PRIVATE LIMITED",
"STEER-WHEEL INFRA AND LOGISTICS PRIVATE LIMITED",
"STEERWISE SOLUTIONS PRIVATE LIMITED",
"STEEWO ENGINEERS AND CONSULTANTS PRIVATE LIMITED",
"STEFAB INDIA LIMITED .",
"STEFANINI INDIA PRIVATE LIMITED",
"STEFEN ELECTRIC PRIVATE LIMITED",
"STEFINA CERAMIC PRIVATE LIMITED",
"STEFRONT TECHNOLOGIES PRIVATE LIMITED",
"STEGPEARL TECHNOLOGIES PRIVATE LIMITED",
"STEHLEN REAL INFRATECH PRIVATE LIMITED",
"STEIN SEAL COMPANY INDIA PRIVATE LIMITED",
"STEINBERG INDIA ADVISORS PRIVATE LIMITED",
"STEINER INDIA LIMITED",
"STEINMETZ OVERSEAS PRIVATE LIMITED",
"STEINN LABS LLP",
"STEINWEG SHARAF (INDIA) PRIVATE LIMITED",
"STEL HOLDINGS LIMITED",
"STELATOES SHOES AND ACCESSORIES PRIVATE LIMITED",
"STELCO LIMITED",
"STELCORE MANAGEMENT SERVICES PRIVATE LIMITED",
"STELIC SOLUTIONS PRIVATE LIMITED",
"STELIS BIOPHARMA LIMITED",
"STELLA COMBINES ENTERPRISES LLP",
"STELLA EXPRESS AND LOGISTICS PRIVATE LIMITED",
"STELLA INDUSTRIES LIMITED.",
"STELLA LIFE CARE",
"STELLA MARIS SCHOOL",
"STELLA MARY COLLEGE",
"STELLA MATUTIA COLLEGE OF EDUCATION",
"STELLA MODA FAB LLP",
"STELLAIRE GEMS PRIVATE LIMITED",
"STELLANS TECHNOSOFT PRIVATE LIMITED",
"STELLANT CAPITAL ADVISORY SERVICES PRIVATE LIMITED",
"STELLAPPS TECHNOLOGIES PRIVATE LIMITED",
"STELLAR ABRASIVE PRIVATE LIMITED",
"STELLAR AND UNI-MAX INDIA LIMITED",
"STELLAR AUTOHAUS PRIVATE LIMITED",
"STELLAR AVIATION SOLUTIONS PRIVATE LIMITED",
"STELLAR BUILDHOME PRIVATE LIMITED",
"STELLAR BUILDTECH PRIVATE LIMITED",
"STELLAR CABLES & INFRASTRUCTURE PRIVATE LIMITED",
"STELLAR CHEMICAL LAB PRIVATE LIMITED",
"STELLAR CONCEPTS PRIVATE LIMITED",
"STELLAR CONSTELLATION PROJECTS PRIVATE LIMITED",
"STELLAR CONTAINERS INDIA PRIVATE LIMITED",
"STELLAR DESTINATION MANAGEMENT SERVICES PRIVATE LIMITED",
"STELLAR DYNAMICS PRIVATE LIMITED",
"STELLAR FORMULATIONS INDUSTRIES PRIVATE LIMITED",
"STELLAR GASTRONOM PRIVATE LIMITED",
"STELLAR GROWTH ADVISORS PRIVATE LIMITED",
"STELLAR INFORMATICS PRIVATE LIMITED",
"STELLAR INFORMATION SYSTEMS LIMITED",
"STELLAR INFORMATION TECHNOLOGY PRIVATE. LIMITED.",
"STELLAR INNOVATIONS PRIVATE LIMITED",
"STELLAR INNOVATIVE TRANSPORTATION SOLUTIONS PRIVATE LIMITED",
"STELLAR IR ADVISORS PRIVATE LIMITED",
"STELLAR KELVIN COLD CHAIN LOGISTICS AND DISTRIBUTION PRIVATE LIMITED",
"STELLAR LOGISTICS PRIVATE LIMITED",
"STELLAR MARINE FOOD PROCESSOR INDIA PRIVATE LIMITED",
"STELLAR OUTSOURCE INDIA PRIVATE LIMITED",
"STELLAR PAPER CHEMICALS PRIVATE LIMITED",
"STELLAR PARKS PRIVATE LIMITED",
"STELLAR PLASTICS INDIA PRIVATE LIMITED",
"STELLAR PROJECT MATERIALS PRIVATE LIMITED",
"STELLAR REFRACTORIES PRIVATE LIMITED",
"STELLAR RENEWABLES PRIVATE LIMITED",
"STELLAR RESOURCES PRIVATE LIMITED",
"STELLAR RUBBER ROLLERS PRIVATE LIMITED",
"STELLAR SEARCH AND SELECTION PRIVATE LIMITED",
"STELLAR STRUCTURES PRIVATE LIMITED",
"STELLAR TOYS INDUSTRIES PRIVATE LIMITED",
"STELLAR VALUE CHAIN SOLUTIONS PRIVATE LIMITED",
"STELLAR VENTURES PRIVATE LIMITED",
"STELLAR360 STAFFING SERVICES PRIVATE LIMITED",
"STELLARAY DIAMONDS PRIVATE LIMITED",
"STELLARIX CONSULTANCY SERVICES PRIVATE LIMITED",
"STELLARSN IT SERVICES PRIVATE LIMITED",
"STELLAS ENGINEERS PRIVATE LIMITED",
"STELLAS EQUIPMENTS PRIVATE LIMITED",
"STELLENCE INFRA TECHNOLOGY PRIVATE LIMITED",
"STELLENCE PHARMSCIENCE PRIVATE LIMITED",
"STELLENT COMPONENTS PRIVATE LIMITED",
"STELLENT HEALTHCARE PRIVATE LIMITED",
"STELLENT SYSTEMS PRIVATE LIMITED",
"STELLER ELECTRONICS PRIVATE LIMITED",
"STELLER MOTORS PRIVATE LIMITED",
"STELLEX EQUIPMENTS PRIVATE LIMITED",
"STELLING TECHNOLOGIES PRIVATE LIMITED",
"STELLIUM CONSULTING INDIA PRIVATE LIMITED",
"STELLOID INFRASTRUCTURE PRIVATE LIMITED",
"STELLOY TECHNOCAST PRIVATE LIMITED",
"STELMEC LIMITED",
"STELMOR INDUSTRIES",
"STEM INFRA SERVICES PRIVATE LIMITED",
"STEM WATER DISTRIBUTION AND INFRASTRUCTURE COMPANY PRIVATE LIMITED",
"STEMADE BIOTECH PRIVATE LIMITED",
"STEMCYTE INDIA THERAPEUTICS PRIVATE LIMITED",
"STEMFIELD INTERNATIONAL SCHOOL",
"STEMFORD ENERGY PRIVATE LIMITED",
"STEMLINE FLORAL DESIGN",
"STEMMONS BUSINESS SERVICES PRIVATE LIMITED",
"STEMMONS ENTERPRISE PRIVATE LIMITED",
"STEMPEUTICS RESEARCH PRIVATE LIMITED",
"STEMROBO TECHNOLOGIES PRIVATE LIMITED",
"STEMRX BIOSSCIENCE SOLUTIONS PRIVATE LIMITED",
"STEMZ HEALTHCARE PRIVATE LIMITED",
"STEMZ RADIOLOGY PRIVATE LIMITED",
"STENCIL ENGINEERING PRIVATE LIMITED",
"STENCIL INFRA PROJECT PRIVATE LIMITED",
"STENHOUSE INSURANCE BROKERS PRIVATE LIMITED",
"STENMECH ENGINEERING WORKS PRIVATE LIMITED",
"STENNA WALLPAPERS PRIVATE LIMITED",
"STEP AGROTECH PRIVATE LIMITED",
"STEP BY STEP SCHOOL",
"STEP COMPUTERS PRIVATE LIMITED",
"STEP EDUCATION AND TRAINING SERVICES PRIVATE LIMITED",
"STEP FREIGHT LOGISTICS PRIVATE LIMITED",
"STEP IN STAYS PRIVATE LIMITED",
"STEP INDUSTRIES PRIVATE LIMITED",
"STEP LOGISTICS PRIVATE LIMITED",
"STEP REALTY PRIVATE LIMITED.",
"STEP UP FOR INDIA",
"STEP UP INFRA PRIVATE LIMITED",
"STEP UP SCHOOL",
"STEP2GEN TECHNOLOGIES PRIVATE LIMITED",
"STEPAHEAD LIFE SCIENCE PRIVATE LIMITED",
"STEPAN (INDIA) PRIVATE LIMITED",
"STEPATHLON LIFESTYLE PRIVATE LIMITED",
"STEPEARLY PRIVATE LIMITED",
"STEPHAN DESIGN & ENGINEERING LIMITED",
"STEPHANOTIS FINANCE LIMITED",
"STEPHEN BALARAM ENGINEERING PRIVATE LIMITED",
"STEPIN DIAMOND PRIVATE LIMITED",
"STEPNSTONES TECHNOLOGIES PRIVATE LIMITED",
"STEPON GLOBAL EDU-CON PRIVATE LIMITED",
"STEPON POWERMAC (INDIA) PRIVATE LIMITED",
"STEPOUT SOLUTIONS PRIVATE LIMITED",
"STEPPE DEVELOPERS PRIVATE LIMITED",
"STEPPE TRAVELS PRIVATE LIMITED",
"STEPPING CLOUD CONSULTING PRIVATE LIMITED",
"STEPRISE TECHNOLOGY PRIVATE LIMITED",
"STEPRON TECHNOLOGIES PRIVATE LIMITED",
"STEPS PREMISES PRIVATE LIMITED",
"STEPS SOURCING INDIA PRIVATE LIMITED",
"STEPSSTONE PROMOTERS PRIVATE LIMITED",
"STEPSSTONEINFRAS PRIVATE LIMITED",
"STEPTOSTRATEGY SOFTWARE CONSULTING PRIVATE LIMITED",
"STEPUP BUILDING SOLUTIONS PRIVATE LIMITED",
"STEP-UP BUSINESS SERVICES PRIVATE LIMITED",
"STEPUP CREDITS AND CAPITAL PRIVATE LIMITED",
"STEP-UP ELECTRICALS PRIVATE LIMITED",
"STEPUP ELEVATOR EQUIPMENTS MANUFACTURERS PRIVATE LIMITED",
"STEPUP ENGINEERING SERVICES PRIVATE LIMITED",
"STER INDIA PRIVATE LIMITED",
"STERA ENGINEERING INDIA PRIVATE LIMITED",
"STERADIAN SEMICONDUCTORS PRIVATE LIMITED",
"STERANCO HEALTHCARE PRIVATE LIMITED",
"STERCO DIGITEX PRIVATE LIMITED",
"STERDILL EQUIPMENTS PRIVATE LIMITED",
"STEREN IMPEX PRIVATE LIMITED",
"STEREO DRUGS PRIVATE LIMITED",
"STEREOKEM PHARMACEUTICALS PRIVATE LIMITED",
"STEREOKEM PRIVATE LIMITED",
"STERI EQUIP SOLUTION PRIVATE LIMITED",
"STERI MOULD PRIVATE LIMITED",
"STERI SHEETS PRIVATE LIMITED",
"STERIATTIRE INDIA PRIVATE LIMITED",
"STERICON PHARMA PRIVATE LIMITED",
"ST-ERICSSON INDIA PRIVATE LIMITED",
"STERIL GENE LIFE SCIENCES P LIMITED",
"STERILE INDIA PRIVATE LIMITED",
"STERILE SPECIALITIES INDIA PRIVATE LIMITED",
"STERILEM BIOSYSTEMS PRIVATE LIMITED",
"STERIMAC LIFECARE PRIVATE LIMITED",
"STERIMAX INDIA PRIVATE LIMITED",
"STERIMED MEDICAL DEVICES PRIVATE LIMITED",
"STERIMED SURGICALS (INDIA) PRIVATE LIMIT ED",
"STERIPLAST PRIVATE LIMITED",
"STERIPLATE PVT LTD.",
"STERIS (INDIA) PRIVATE LIMITED",
"STERIS HEALTHCARE PRIVATE LIMITED",
"STERIS INDIA PRIVATE LIMITED",
"STERIWELL ECOSYS PRIVATE LIMITED",
"STERK STAFFING PRIVATE LIMITED",
"STERKEM PHARMA PRIVATE LIMITED",
"STERLIFE BIOTECH PRIVATE LIMITED",
"STERLIFE PHARMA PRIVATE LIMITED",
"STERLINE BIO REMEDIES PRIVATE LIMITED",
"STERLING & WILSON POWER GEN PRIVATE LIMITED",
"STERLING ABRASIVES LIMITED",
"STERLING ACCURIS WELLNESS PRIVATE LIMITED",
"STERLING ADDLIFE INDIA PRIVATE LIMITED",
"STERLING AGRICHEM PRIVATE LIMITED",
"STERLING AGRO INDUSTRIES LIMITED",
"STERLING AND WILSON CO-GEN SOLUTIONS PRIVATE LIMITED",
"STERLING AND WILSON PRIVATE LIMITED",
"STERLING AND WILSON RENEWABLE ENERGY LIMITED",
"STERLING AND WILSON SERVICES PRIVATE LIMITED",
"STERLING AND WILSON SOLAR LIMITED",
"STERLING AUTOMOBILES PRIVATE LIMITED",
"STERLING AUXILIARIES PRIVATE LIMITED",
"STERLING BOLTS PRIVATE LIMITED",
"STERLING BUILDCON PRIVATE LIMITED",
"STERLING CANCER HOSPITAL",
"STERLING CERAMICS PRIVATE LIMITED",
"STERLING CHEMICALS AND ALCOHOLS LIMITED",
"STERLING COCONUT OILS AND CAKES PRIVATE LIMITED",
"STERLING COMMERCE SOLUTIONS INDIA PRIVATE LIMITED",
"STERLING COMPONENTS INDIA PRIVATE LIMITED",
"STERLING CORPORATE COMMUNICATIONS PRIVATE LIMITED",
"STERLING CORRUGATION INDUSTRY PRIVATE LIMITED",
"STERLING CRAFT PAPER MILL PRIVATE LIMITED",
"STERLING CREATIONS PRIVATE LIMITED",
"STERLING DEVELOPERS PRIVATE LIMITED",
"STERLING DOORS AND PLY PRIVATE LIMITED",
"STERLING ELECTRO ENTERPRISES PRIVATE LIMITED",
"STERLING ENAMELLED WIRES PRIVATE LIMITED",
"STERLING ENGINEERING CONSULTANCY SERVICES PRIVATE LIMITED",
"STERLING ENGINEERS & BOILERS PRIVATE LIMITED",
"STERLING ENTERPRISES PRIVATE LIMITED",
"STERLING ENVIROWISERS AND EQUIPMENTS PRIVATE LIMITED",
"STERLING EQUIPMENT PVT LTD",
"STERLING EXPRESS PRIVATE LIMITED",
"STERLING FABORY INDIA PRIVATE LIMITED",
"STERLING FARM RESEARCH AND SERVICES PVT LTD",
"STERLING FREIGHTS PRIVATE LIMITED",
"STERLING GENERATORS PRIVATE LIMITED",
"STERLING GERA RESIDENCE LLP",
"STERLING GRAPHICS PRIVATE LIMITED",
"STERLING GREENWOODS LIMITED",
"STERLING GROCERIES PRIVATE LIMITED",
"STERLING GTAKE E-MOBILITY LIMITED",
"STERLING HABITATS PRIVATE LIMITED",
"STERLING HEALTHCARE LIMITED",
"STERLING HOLIDAY RESORTS (KODAIKANAL) LTD",
"STERLING HOLIDAY RESORTS LIMITED",
"STERLING HOLIDAYS (OOTY) LTD",
"STERLING HOME INNOVATOR PRIVATE LIMITED",
"STERLING HOSPITALS",
"STERLING HOTELIERS AND INVESTMENTS PVT LTD",
"STERLING IMPEX",
"STERLING INDIA",
"STERLING INDIA MINERS PRIVATE LIMITED",
"STERLING INDO TECH CONSULTANTS PRIVATE LIMITED",
"STERLING INDUSTRIAL CHEMICALS AND ALLIED INDUSTRIES PVT LTD",
"STERLING INFORMATION RESOURCES INDIA PRIVATE LIMITED",
"STERLING INFOSYSTEM",
"STERLING INFOWAYS PRIVATE LIMITED",
"STERLING INTERNATIONAL TOURS AND TRAVELS",
"STERLING INVESTMENT CORPORATION PRIVATE LIMITED",
"STERLING IRRIGATIONS LIMITED",
"STERLING ISOLATORS PVT LTD",
"STERLING LEAD PRIVATE LIMITED",
"STERLING LOMAX PROJECT SERVICES INDIA PRIVATE LIMITED",
"STERLING LUBRICANTS PVT LTD",
"STERLING MANAGEMENT AND SECURITY SERVICES PRIVATE LIMITED",
"STERLING MECHANICAL WORKS PRIVATE LIMITED",
"STERLING META PLAST INDIA PRIVATE LIMITED",
"STERLING METCHEM TRADE PRIVATE LIMITED",
"STERLING MOBIKES PRIVATE LIMITED",
"STERLING NEW HORIZONS PRIVATE LIMITED",
"STERLING ORNAMENTS PRIVATE LIMITED",
"STERLING OUTSOURCING PRIVATE LIMITED",
"STERLING PRECISION PRIVATE LIMITED",
"STERLING PRINT HOUSE PVT LTD",
"STERLING PUBLISHERS PRIVATE LIMITED",
"STERLING RELOCATION PRIVATE LIMITED",
"STERLING RESORTS",
"STERLING ROTATING SYSTEMS PRIVATE LIMITED",
"STERLING SALES PRIVATE LTD",
"STERLING SEA AIR FREIGHT EXPRESS PRIVATE LIMITED",
"STERLING SECURITY ENTERPRISES PRIVATE LIMITED",
"STERLING SHIPPING SERVICES PRIVATE LIMITED",
"STERLING SOFTWARE PRIVATE LIMITED",
"STERLING SOLID TYRES PRIVATE LTD",
"STERLING SPARES PRIVATE LIMITED",
"STERLING STONEX PRIVATE LIMITED",
"STERLING SWITCHGEARS CONTROLS PRIVATE LIMITED",
"STERLING TAPES LIMITED",
"STERLING TECHNOLOGIES PRIVATE LIMITED",
"STERLING TOOLS LIMITED",
"STERLING TRANSLOGISTICS PRIVATE LIMITED",
"STERLING URBAN VENTURES PRIVATE LIMITED",
"STERLING VEHICLE SALES PRIVATE LIMITED",
"STERLING VIKING POWER PRIVATE LIMITED",
"STERLINGQ PRIVATE LIMITED",
"STERLINGS MAC HOTEL",
"STERLINGSAI FOAMS AND INTEGRALS PRIVATE LIMITED",
"STERLINGSOUL SOFTWARE SOLUTIONS PRIVATE LIMITED",
"STERLITE AGRO LIMITED",
"STERLITE CONVERGENCE LIMITED",
"STERLITE COPPER ROLLING MILLS PRIVATE LIMITED",
"STERLITE EDINDIA FOUNDATION",
"STERLITE GRID 16 LIMITED",
"STERLITE GRID 29 LIMITED",
"STERLITE INTERLINKS LIMITED",
"STERLITE LUBRICANTS PRIVATE LIMITED",
"STERLITE POWER GRID VENTURES LIMITED",
"STERLITE POWER TRANSMISSION LIMITED",
"STERLITE TECH CABLES SOLUTIONS LIMITED",
"STERLITE TECHNOLOGIES LIMITED",
"STERMONE CHEMICALS PRIVATE LIMITED",
"STERN ADVISORY (INDIA) PRIVATE LIMITED",
"STERN INGREDIENTS INDIA PRIVATE LIMITED",
"STERN TRADING PRIVATE LIMITED",
"STERNA SECURITY DEVICES PRIVATE LIMITED",
"STERNAL BUILDCON PRIVATE LIMITED",
"STERNE INDIA PRIVATE LIMITED",
"STERNLEICHT SOFTWARE SOLUTIONS PRIVATE LIMITED",
"STERP SOFTWARE PRIVATE LIMITED",
"STESALIT AUTOMATION PRIVATE LIMITED",
"STESALIT INFOTECH PRIVATE LIMITED",
"STESALIT LIMITED",
"STESALIT SYSTEMS LIMITED",
"STETIG CONSULTING PRIVATE LIMITED",
"STEULER INDUSTRIAL SOLUTION (INDIA) PRIVATE LIMITED",
"STEVE CRAGG ADVERTISING PRIVATE LIMITED",
"STEVEN CREEKS PRIVATE LIMITED",
"STEVEN INDUSTRIES LIMITED",
"STEVIA WORLD AGROTECH PRIVATE LIMITED",
"STEWART & MACKERTICH WEALTH MANAGEMENT LIMITED",
"STEWART COLLEGE",
"STEWART PINNED PRODUCTS PRIVATE LIMITED",
"STEWART SCHOOL BHUBANESWAR",
"STEWOLS INDIA (P) LTD",
"STEYWARD CLOTHING PRIVATE LIMITED",
"STF JHARKHAND JAGUAR",
"STF MEDICARE & RESEARCH CENTRE PRIVATE LIMITED",
"STG HEATING PRIVATE LIMITED",
"STG INFOTECH INDIA LLP",
"STG INFRASYS PRIVATE LIMITED",
"STG LIFESCIENCES PRIVATE LIMITED",
"STG PHARMAGENERICS PRIVATE LIMITED",
"STG REFRACTORY SERVICES PRIVATE LIMITED",
"STGC UNIFORMITY PRIVATE LIMITED",
"STHAPANA INFRATECH PRIVATE LIMITED",
"STHAPATI ARCHITECTURE AND INTERIORS PRIVATE LIMITED",
"STHAPATI ASSOCIATES PRIVATE LIMITED",
"STHAPATI DESIGNERS AND CONSULTANTS PVT LTD",
"STHAPATYA CONSULTANTS (INDIA) PRIVATE LIMITED",
"STHAPATYA EVALUATORS & ACTUARIES PRIVATE LIMITED",
"STHAVARA PROJECTS INDIA PRIVATE LIMITED",
"STHAVIRA AUTOMAT AND TECH SOLUTIONS PRIVATE LIMITED",
"STHAVISHATAY INVESTMENT AND TRADING CO PVT LTD",
"STHAYIKA SEEDS PRIVATE LIMITED",
"STHIRA INFRA PROJECTS PRIVATE LIMITED",
"STHIRA PROJECTS & AVENUES PRIVATE LIMITED",
"STHIRA TATVA PRIVATE LIMITED",
"STHIRLAKSHMI MERCHANTS PVT LTD",
"STHREE CHEMICALS PRIVATE LIMITED",
"S-THREE SALES INTERNATIONAL PRIVATE LIMITED",
"STI APPAREL AUTOMOTION PRIVATE LIMITED",
"STI INDUSTRIES",
"STI INFOTECH PRIVATE LIMITED",
"STI METALIKS PRIVATE LIMITED",
"STIACK ENGINEERING PRIVATE LIMITED",
"STIBO SYSTEMS INDIA PRIVATE LIMITED",
"STIC GSA SERVICES PRIVATE LIMITED",
"STIC ON PAPERS PRIVATE LIMITED",
"STIC PENS LIMITED",
"STIC PENS PRIVATE LIMITED",
"STIC SOFT E SOLUTIONS PRIVATE LIMITED",
"STIC TRAVELS PRIVATE LIMITED",
"STICHWELL EXPORTS PRIVATE LIMITED",
"STICK PACK PRIVATE LIMITED",
"STICK TAPES PRIVATE LIMITED",
"STICKMAN CONSULTING PRIVATE LIMITED",
"STICKWELL PAPERS PRIVATE LIMITED",
"STICKWELL PRINT PRIVATE LIMITED",
"STICON CONSTRUCTION PRIVATE LIMITED",
"STIEBEL ELTRON INDIA PRIVATE LIMITED",
"STIER SOLUTION PRIVATE LIMITED",
"STIFF COLLAR APPAREL PRIVATE LIMITED",
"STIFF ENTERPRISE PRIVATE LIMITED",
"STIFF PACKAGING PRIVATE LIMITED",
"STIFF SECURITY PRIVATE LIMITED",
"STIFFEN CREDITS AND CAPITAL PRIVATE LIMITED",
"STIGASOFT PRIVATE LIMITED",
"STIGMA CREDITS AND CAPITAL PRIVATE LIMITED",
"STILBENE BIOPHARMA PRIVATE LIMITED",
"STILE CLOTHING PRIVATE LIMITED",
"STILEDIVITA INDIA PRIVATE LIMITED",
"STILL WATERS FILMS PRIVATE LIMITED",
"STILLDISTILLING SPIRITS PRIVATE LIMITED",
"STILONN VALVES AND CONTROLS PRIVATE LIMITED",
"STIMULUS CONSULTING PRIVATE LIMITED",
"STIMULUS INFOSYSTEMS PRIVATE LIMITED",
"STINGER DRAFTING PRIVATE LIMITED",
"STINGWELL HEALTHCARE PRIVATE LIMITED",
"STINZO AUTOMOTIVES PRIVATE LIMITED",
"STIRLING CRYOGENICS INDIA PRIVATE LIMITED",
"STIRRED CREATIVE ADVERTISING PRIVATE LIMITED",
"STITCH OVERSEAS PRIVATE LIMITED",
"STITCH TECHNOLOGIES INDIA PRIVATE LIMITE D",
"STITCHCARE CONTROLS PRIVATE LIMITED",
"STITCHED TEXTILES LIMITED",
"STITCHFAB (INDIA) PRIVATE LIMITED.",
"STITCHWELL GARMENTS PRIVATE LIMITED",
"STITCHWELL INDUSTRIES",
"STITCHXPERT TEXFAB INDIA PRIVATE LIMITED",
"STIWAS INNOVATIONS PRIVATE LIMITED",
"STJ ELECTRONICS PRIVATE LIMITED",
"STJ GLOBAL ENTERTAINMENT & MEDIA PRIVATE LIMITED",
"STK FOOD PROCESSING PRIVATE LIMITED",
"STL DIGITAL LIMITED",
"STL ENTERPRISES (INDIA) PRIVATE LIMITED",
"STL GLOBAL LIMITED",
"STL PHARMA PRIVATE LIMITED",
"STL SERVICES PRIVATE LIMITED",
"STL TRANSWORLD PRIVATE LIMITED",
"STM CONSTRUCTION EQUIPMENT (INDIA) PRIVATE LIMITED",
"STM INFRA HITECH PRIVATE LIMITED",
"STM PROJECTS LIMITED",
"STM TRADERS PRIVATE LIMITED",
"ST'MERY ENTERPRISES",
"STMICROELECTRONICS MARKETING PRIVATE LIMITED",
"STMICROELECTRONICS PRIVATE LIMITED",
"STN HQ KAMPTEE",
"STN INFRA PRIVATE LIMITED",
"STOCK HOLDING CORPORATION OF INDIA LIMITED",
"STOCK MANDI PRIVATE LIMITED",
"STOCKHOLDING DOCUMENT MANAGEMENT SERVICES LIMITED",
"STOCKHOLDING SECURITIES IFSC LIMITED",
"STOCKHOLDING SERVICES LIMITED",
"STOCKHOME INDIA LIMITED",
"STOCKS ARENA PRIVATE LIMITED",
"STOCKTALKS PRIVATE LIMITED",
"STOCKX INDIA PRIVATE LIMITED",
"STOE LIFE PRIVATE LIMITED",
"STOICS SOFTWARE DEVELOPMENT (INDIA) PRIVATE LIMITED",
"STOKE NETWORKS PRIVATE LIMITED",
"STOKE RESTAURANTS INDIA LLP",
"STOKER CONCAST PRIVATE LIMITED",
"STOKVIS PROSTICK TAPES PRIVATE LIMITED",
"STOLN FUNKY FASHION FUNDAS PRIVATE LIMITED",
"STOLT TANK CONTAINERS CLEANING AND REPAIR KANDLA PRIVATE LIMITED",
"STOLT-NIELSEN INDIA PRIVATE LIMITED",
"STOMOMA INFRA PRIVATE LIMITED",
"STONE AGE BUNDI PRIVATE LIMITED",
"STONE AGE PRIVATE LIMITED",
"STONE AND ACRES REALTY CONSULTANTS LLP",
"STONE ART PRIVATE LIMITED",
"STONE BENCH PRIVATE LIMITED",
"STONE BRIDGE BUSINESS SOLUTIONS PRIVATE LIMITED",
"STONE BRIDGE CONCEPTS PRIVATE LIMITED",
"STONE BRIDGE PROMOTERS PRIVATE LIMITED",
"STONE BUILDTECH PRIVATE LIMITED",
"STONE CONCERN INFRASTRUCTURE DEVELOPMENT PRIVATE LIMITED",
"STONE CRAFT INDIA PRIVATE LIMITED",
"STONE EXPORTERS INDIA PRIVATE LIMITED",
"STONE HILL PLY INDUSTRIES PRIVATE LIMITED",
"STONE MASTERS (INDIA) PRIVATE LIMITED",
"STONE RESTORATION SERVICES PRIVATE LIMITED",
"STONE SAPPHIRE (INDIA) PRIVATE LIMITED",
"STONE SHIPPERS LIMITED",
"STONE WONDERS INDIA LIMITED",
"STONE WOOD BEACH RESORT",
"STONEAGE BUILDERS & DEVELOPERS PRIVATE LIMITED",
"STONEBRICKS PROPERTY DEVELOPMENT PRIVATE LIMITED",
"STONECOLOUR EXIM PRIVATE LIMITED",
"STONECOM TRADERS PRIVATE LIMITED",
"STONECRAFT DEVELOPERS PRIVATE LIMITED",
"STONEFIELD FLAVOURS PRIVATE LIMITED",
"STONEHENGE DESIGNS PRIVATE LIMITED",
"STONEHILL EDUCATION FOUNDATION",
"STONEHILL INTERNATIONAL SCHOOL",
"STONELAM SURFACE LLP",
"STONEMANN ROYALE LIMITED",
"STONEMARK ENGINEERING PRIVATE LIMITED",
"STONEMEN CRAFTS INDIA PRIVATE LIMITED",
"STONEPLUS ENTERPRISES PRIVATE LIMITED",
"STONERA SYSTEMS PRIVATE LIMITED",
"STONES INFRA PROJECTS PRIVATE LIMITED",
"STONES WIZARD PRIVATE LIMITED",
"STONES2MILESTONES EDU SERVICES PRIVATE LIMITED",
"STONESBRIDGE ENGINEERING PRIVATE LIMITED",
"STONESMITH INDIA PRIVATE LIMITED",
"STONETRADING EXPORT PRIVATE LIMITED",
"STONEWORLD DIRECT EXPORTS PRIVATE LIMITED",
"STONEX GRANITES INDIA PRIVATE LIMITED",
"STONEX INDIA PRIVATE LIMITED",
"STONEY VINIMAY PRIVATE LIMITED",
"STONKRAFT RETAIL PRIVATE LIMITED",
"STONNEAGGE BUSSIINESS HUB PRIVATE LIMITED",
"STOP N SHOP TRAVEL & TOURS PRIVATE LIMITED",
"STOPLIK SERVICES INDIA PVT LTD",
"STOPNOT SERVICES (OPC) PRIVATE LIMITED",
"STORAGE TECHNOLOGIES AND AUTOMATION LIMITED",
"STORAGE TECHNOLOGIES AND AUTOMATION PRIVATE LIMITED",
"STORAGIANS LOGISTICS PRIVATE LIMITED",
"STORE APPS TECHNOLOGIES LLP",
"STORE ELEMENT INDIA PRIVATE LIMITED",
"STORE INDYA PRIVATE LIMITED",
"STORE SOFT SOLUTION PRIVATE LIMITED",
"STOREACE LOGISTICS PRIVATE LIMITED",
"STOREEX SOLUTIONS PRIVATE LIMITED",
"STOREJI PRIVATE LIMITED",
"STORELEAF PRIVATE LIMITED",
"STOREMAN STORAGE SOLUTIONS PRIVATE LIMITED",
"STOREMATE KART SERVICES PRIVATE LIMITED",
"STORENET RECHARGE SERVICES PRIVATE LIMITED",
"STORES SUPPLY INDIA AGENCY",
"STOREWELL SHIPPING PRIVATE LIMITED",
"STOREWORKS PRIVATE LIMITED",
"STOREWORKS TECHNOLOGIES INDIA PRIVATE LIMITED",
"STORI FASHIONS PRIVATE LIMITED",
"STORIA FOODS AND BEVERAGES PRIVATE LIMITED",
"STORICULTURE NETWORK PRIVATE LIMITED",
"STORIES GLOBAL HOMES PRIVATE LIMITED",
"STORK AUTO ENGINEERING PRIVATE LIMITED.",
"STORK FERRO AND MINERAL INDUSTRIES PRIVATE LIMITED",
"STORK RUBBER PRODUCTS PRIVATE LIMITED",
"STORK SYSTEMS & PROJECTS PRIVATE LIMITED",
"STORKS MEDI-TEK PRIVATE LIMITED",
"STORM COMMUNICATIONS PRIVATE LIMITED",
"STORM EDUCATION GROUP PRIVATE LIMITED",
"STORM ENERGY SOLUTIONS PRIVATE LIMITED",
"STORM ENGINEERING INDIA PRIVATE LIMITED",
"STORM EXPORT PRIVATE LIMITED",
"STORM INFRACON PRIVATE LIMITED",
"STORM SOFT TECHNOLOGIES PRIVATE LIMITED",
"STORMFAST GLOBAL TRADING PRIVATE LIMITED",
"STORY WALA PRIVATE LIMITED",
"STORYBOARD BRANDCOM PRIVATE LIMITED",
"STORYBOATS CONSULTING & CREATIVE SERVICES PRIVATE LIMITED",
"STORYMIRROR INFOTECH PRIVATE LIMITED",
"STORYSIDE INDIA LLP",
"STORYTAILORS CONTENT SOLUTIONS PRIVATE LIMITED",
"STORYTELLER",
"STORYTELLERS BRANDING AND ADVERTISING PRIVATE LIMITED",
"STOTZ GEARS PRIVATE LIMITED",
"STOVE KRAFT LIMITED",
"STOVEC INDUSTRIES LIMITED",
"STOWE RESEARCH INDIA PRIVATE LIMITED",
"STOWNEST TECHNOLOGIES PRIVATE LIMITED",
"STP INFRACARE PRIVATE LIMITED",
"STP INVESTMENT SERVICES INDIA PRIVATE LIMITED",
"STP SERVICES PRIVATE LIMITED",
"STPL HORTICULTURE PRIVATE LIMITED",
"STR INFRASTRUCTURES PRIVATE LIMITED",
"STR POULTRY TRADERS PRIVATE LIMITED",
"STR8BAT SOLUTIONS INDIA PRIVATE LIMITED",
"STRABAG ENGINEERS PRIVATE LIMITED",
"STRABAG INFRASTRUCTURE AND SAFETY SOLUTIONS PRIVATE LIMITED",
"STRABUS SOFTWARE SOL PRIVATE LIMITED",
"STRACEY MEMORIAL COMPOSITE COLLEGE",
"STRACTION CONSULTING",
"STRACTIVE CONSULTING PRIVATE LIMITED",
"STRADEGI SOLUTIONS INDIA PRIVATE LIMITED",
"STRAIGHT LINE CARGO SERVICES PRIVATE LIMITED",
"STRAIGHT LINE FOOD PRODUCTS PRIVATE LIMITED",
"STRAIGHTLINE SOLUTIONS PRIVATE LIMITED",
"STRAINA INTERNATIONAL PRIVATE LIMITED",
"STRAIT LOGISTICS PRIVATE LIMITED",
"STRAITS RESEARCH PRIVATE LIMITED",
"STRAITSBRIDGE ANALYTICS INDIA LLP",
"STRALTO GLOBAL PRIVATE LIMITED",
"STRAMA-SUMMIT MACHINERY PRIVATE LIMITED",
"STRAND LIFE SCIENCES PRIVATE LIMITED",
"STRANDS SALONS PRIVATE LIMITED",
"STRANDS TEXTILE MILLS PRIVATE. LIMITED.",
"STRANG SYSTEMS INDIA PRIVATE LIMITED",
"STRANGE EXPORTS PRIVATE LIMITED",
"STRANGER AUDIO PRIVATE LIMITED",
"STRANQUIL CONSTRUCTION PRIVATE LIMITED",
"STRANS LOGISTICS PRIVATE LIMITED",
"STRAPEX PACKAGING PRIVATE LIMITED",
"STRAPP BUSINESS SOLUTIONS PRIVATE LIMITED",
"STRAPTEX (INDIA) PRIVATE LIMITED",
"STRASSENBURG PHARMACEUTICALS LTD",
"STRASSENBURG PHARMACEUTICALS PRIVATE LTD.",
"STRAT SURE ASSOCIATES PRIVATE LIMITED",
"STRATA EXIM PRIVATE LIMITED",
"STRATA GEOSYSTEMS INDIA PRIVATE LIMITED",
"STRATA SOLAR PRIVATE LIMITED",
"STRATACACHE INDIA PRIVATE LIMITED",
"STRATACENT INDIA PRIVATE LIMITED",
"STRATADIGM EDUCATION AND TRAINING PRIVATE LIMITED",
"STRATAGEM STOCK BROKER PRIVATE LIMITED",
"STRATAGILE MARKETING CONSULTANCY PRIVATE LIMITED",
"STRATAPPS SOLUTIONS PRIVATE LIMITED",
"STRATASYS INDIA PRIVATE LIMITED",
"STRATBEANS CONSULTING PRIVATE LIMITED",
"STRATBIZ CONSULTING PRIVATE LIMITED",
"STRATCAP WEALTH MANAGEMENT PRIVATE LIMITED",
"STRATECHEM (INDIA) PRIVATE LIMITED",
"STRATEGI AUTOMATION SOLUTIONS PRIVATE LIMITED",
"STRATEGIC ALLIANCE MANAGEMENT SERVICES PRIVATE LIMITED",
"STRATEGIC ANALYSIS (INDIA) PRIVATE LIMITED.",
"STRATEGIC ANALYSIS INDIA PRIVATE LIMITED.",
"STRATEGIC CONTENT TRANSFORMATION LABS PRIVATE LIMITED",
"STRATEGIC DESIGNS PRIVATE LIMITED",
"STRATEGIC DEVELOPERS PRIVATE LIMITED",
"STRATEGIC EDUCATIONAL PROFESSIONALS PRIVATE LIMITED",
"STRATEGIC ENGAGEMENT & EVENT SOLUTIONS PRIVATE LIMITED",
"STRATEGIC GROWTH ADVISORS PRIVATE LIMITED",
"SHRM EAST PRIVATE LIMITED",
"STRATEGIC HUMAN RESOURCES CONSULTANTS PRIVATE LIMITED",
"STRATEGIC INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"STRATEGIC INTELLECTUAL PROPERTY INFORMATION PRIVATE LIMITED",
"STRATEGIC INTERVENTIONS INDIA PRIVATE LIMITED",
"STRATEGIC MARKETING PRIVATE LIMITED",
"STRATEGIC MARKETING SOLUTIONS AND RESEARCH CENTRE PRIVATE LIMITED",
"STRATEGIC PROJECTS AND TECHNICAL SERVICES PRIVATE LIMITED",
"STRATEGIC SYSTEMS IT SOLUTIONS PRIVATE LIMITED",
"STRATEGIC TECHNOLOGY RESOURCES INTERNATIONAL PRIVATE LIMITED",
"STRATEGINK SOLUTIONS PRIVATE LIMITED",
"STRATEGUM EDUSERVE PRIVATE LIMITED",
"STRATEGY ADVERTISING AND MARKETING PVT LTD",
"STRATEOLOGY IT SOLUTIONS PRIVATE LIMITED",
"STRATESPHERE GLOBAL SERVICES PRIVATE LIMITED",
"STRATEVISTA AUTOMOBILES PRIVATE LIMITED",
"STRATEXIC KNOVATIC PRIVATE LIMITED",
"STRATFORD REALTY LLP",
"STRATFORWARD MARKETING CONSULTING PRIVATE LIMITED",
"STRATHSPEY LABS PRIVATE LIMITED",
"STRATICO RESOURCES PRIVATE LIMITED",
"STRATIX HOSPITALITY PRIVATE LIMITED",
"STRATIZANT INDIA PRIVATE LIMITED",
"STRATLYTICS CONSULTING PRIVATE LIMITED",
"STRATMONT INDUSTRIES LIMITED",
"STRATMORE WEALTH PRIVATE LIMITED",
"STRATOGENT TECHNOLOGY SERVICES PRIVATE LIMITED",
"STRATON BUSINESS SOLUTIONS PRIVATE LIMITED",
"STRATOSHEAR TECHNOLOGIES PRIVATE LIMITED",
"STRATOSPHERE IT SERVICES PRIVATE LIMITED",
"STRATPRO HVACR AND BUILDING SOLUTIONS PRIVATE LIMITED",
"STRATSOL SOFTWARE SYSTEMS PRIVATE LIMITED",
"STRATTEK CONSULTING PRIVATE LIMITED",
"STRATTON TEA PRIVATE LIMITED",
"STRATUM CONSULTANCY SERVICES PRIVATE LIMITED",
"STRATUS GLOBAL (INDIA) PRIVATE LIMITED\n",
"STRATUS TECHNOLOGIES PRIVATE LIMITED",
"STRATVISORS PRIVATE LIMITED",
"STRATWON BUSINESS CONSULTING PRIVATE LIMITED",
"STRATYCON BUSINESS SOLUTIONS PRIVATE LIMITED",
"STRAUMANN DENTAL INDIA LLP",
"STRAVIS IT SOLUTIONS PRIVATE LIMITED",
"STRAVISO INDIA PRIVATE LIMITED",
"STRAWBERRY BUSINESS SOLUTIONS PRIVATE LIMITED",
"STRAWBERRY CERAMIC PRIVATE LIMITED",
"STRAWBERRY CONSTRUCTIONS PRIVATE LIMITED",
"STRAWBERRY FIELDS HIGH SCHOOL",
"STRAWBERRY INFOTECH PRIVATE LIMITED",
"STRAWBERRY STUDIO EXPORTS PRIVATE LIMITED",
"STRAWCTURE ECO PRIVATE LIMITED",
"STRAWFLEX PRIVATE LIMITED",
"STRAXIS TECHNOLOGY INDIA PRIVATE LIMITED",
"STREAK AI TECHNOLOGIES PRIVATE LIMITED",
"STREAM CABLES PRIVATE LIMITED",
"STREAM CERAMIC PRIVATE LIMITED",
"STREAM DESIGNS PRIVATE LIMITED",
"STREAM DIGITAL SERVICES PRIVATE LIMITED",
"STREAM LINE HR SOLUTIONS INDIA PRIVATE LIMITED",
"STREAM LINE LOGISTICS PRIVATE LIMITED",
"STREAMALGO PRIVATE LIMITED",
"STREAMFIX BUSINESS MANAGEMENT PRIVATE LIMITED",
"STREAMFORCE SOLUTIONS PRIVATE LIMITED",
"STREAMINGO SOLUTIONS PRIVATE LIMITED",
"STREAMLINE APPARELS PRIVATE LIMITED",
"STREAMLINE BUSINESS INDIA PRIVATE LIMITED",
"STREAMLINE CONSULTANTS PRIVATE LIMITED",
"STREAMLINE CONTROLS PRIVATE LIMITED",
"STREAMLINE CPQ CONSULTANTS INDIA PRIVATE LIMITED",
"STREAMLINE FINANCE AND INVESTMENT PRIVATE LIMITED",
"STREAMLINE HEALTHCARE SOLUTIONS INDIA PRIVATE LIMITED",
"STREAMLINE POWER SYSTEMS PRIVATE LIMITED",
"STREAMLINE REFRIGERATION PRIVATE LIMITED",
"STREAMLINED MEDICAL SOLUTIONS PRIVATE LIMITED",
"STREAMLYN SEMISOFT PRIVATE LIMITED",
"STREAMOID TECHNOLOGIES PRIVATE LIMITED",
"STREAMON TECHNOLOGIES PRIVATE LIMITED",
"STREAMS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"STREAMSOURCE TECHNOLOGIES INDIA PRIVATE LIMITED",
"STREAMVECTOR TECHNOLOGY PRIVATE LIMITED",
"STREAMY TECH PRIVATE LIMITED",
"STRECKEN INDIA MANUFACTURING PRIVATE LIMITED",
"STREE NIDHI CREDIT CO- OPERATIVE FEDERATION LTD",
"STREE SANGHATANA AUDYOGIK SAHAKARI MANDAL LTD",
"STREEBO SOLUTIONS PRIVATE LIMITED",
"STREENIDHI CREDIT COOPERATIVE FEDERATION (GOVT OF ANDHRAPRADESH)",
"STREET FINANCIAL INSTITUTION AND TECHNOLOGY LLP",
"STREET LIFE ADVERTISING PRIVATE LIMITED",
"STREET- NEON (INDIA) PRIVATE LIMITED",
"STREET NINE FASHIONS PRIVATE LIMITED",
"STREFA PROJECTS PRIVATE LIMITED",
"STREGA MODULAR FURNITURE PRIVATE LIMITED",
"STRENGTH FACILITY SERVICES PRIVATE LIMITED",
"STRENGTH REALTORS PRIVATE LIMITED",
"STRENGTHENING INDIA PRIVATE LIMITED",
"STRENGTHSCAPE PRIVATE LIMITED",
"STREPARAVA INDIA PRIVATE LIMITED",
"STRESCON INDUSTRIES LTD",
"STRESCON WIRE INDUSTRIES PRIVATE LIMITED",
"STRESSCRETE PRIVATE LIMITED",
"STRESSTECH BHARAT PRIVATE LIMITED",
"STRESSTECH ENGINEERS PRIVATE LIMITED",
"STRETCH BANDS GUJARAT PRIVATE LIMITED",
"STRETTO AUTOMATION PRIVATE LIMITED",
"STREVEN TECHPRO PRIVATE LIMITED",
"STRIDE CAPITAL CONSULTANTS PRIVATE LIMITED",
"STRIDE HOTELS PRIVATE LIMITED",
"STRIDE ONE CAPITAL PRIVATE LIMITED",
"STRIDE ORGANICS PRIVATE LIMITED",
"STRIDE STEELS PRIVATE LIMITED",
"STRIDE VENTURES CAPITAL PRIVATE LIMITED",
"STRIDE.AI R&D PRIVATE LIMITED",
"STRIDELY SOLUTIONS INDIA PRIVATE LIMITED",
"STRIDERS MILES PRIVATE LIMITED",
"STRIDES ALATHUR PRIVATE LIMITED",
"STRIDES AUTOMAG PRIVATE LIMITED",
"STRIDES COMMERCE PRIVATE LIMITED",
"STRIDES CONSUMER PRIVATE LIMITED",
"STRIDES EMERGING MARKETS LIMITED",
"STRIDES PHARMA SCIENCE LIMITED",
"STRIDING RESOURCES PRIVATE LIMITED",
"STRIDUM VENTURE PRIVATE LIMITED",
"STRIIM ENGINEERING SERVICES INDIA PRIVATE LIMITED",
"STRIKE RIGHT INTEGRATED SERVICES LIMITED",
"STRIKE-IT-RITE MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"STRIKER FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"STRIKER INDUSTRIES PRIVATE LIMITED",
"STRIKER LOGISTICS PRIVATE LIMITED",
"STRIKER RESTAURANTS PRIVATE LIMITED",
"STRIKER SOFT SOLUTIONS PRIVATE LIMITED",
"STRIKING ONLINE SERVICE & SHOPPING PRIVATE LIMITED",
"STRING AND WELD PRIVATE LIMITED",
"STRIPE TECHNOLOGY INDIA PRIVATE LIMITED",
"STRIPEDATA PRIVATE LIMITED",
"STRIVE FIVE INTERNET SERVICES PRIVATE LIMITED",
"STRIVE INDIA EDUCATION FOUNDATION",
"STRIVE SHIPPING SERVICES PRIVATE LIMITED",
"STRIVEMINDZ PRIVATE LIMITED",
"STRIVEO HEALTH CARE PRIVATE LIMITED",
"STRIVOS LABORATORIES PRIVATE LIMITED",
"STRIX WIRELESS SYSTEMS PRIVATE LIMITED",
"STROBB IMPEX PRIVATE LIMITED",
"STROKE EQUIPMENTS INDIA PRIVATE LIMITED",
"STROKES ADVERTISING PRIVATE LIMITED",
"STROLLER DISTRIBUTORS PVT.LTD.",
"STROLLOUT SERVICES INDIA PRIVATE LIMITED",
"STROM ENERGIE PRIVATE LIMITED",
"STRONG BONDS POLY SEAL PVT.LTD.",
"STRONG BUILDSOLUTIONS PRIVATE LIMITED",
"STRONG GOLD CEMENT PRIVATE LIMITED",
"STRONG PLANT INFRASTRUCTURE PRIVATE LIMITED",
"STRONG TECH ENGINEERING SERVICES AND RESEARCH INDIA PRIVATE LIMITED",
"STRONGBOX IT PRIVATE LIMITED",
"STRONGCRETE PRODUCTS PRIVATE LIMITED",
"STRONGPLUS INDIA PRIVATE LIMITED",
"STRONGSUN RENEWABLES PRIVATE LIMITED",
"STRONTIUM FERRITEN INDIA LIMITED",
"STRONTIUM TECHNOLOGY INDIA PRIVATE LIMITED",
"STRT PEN WINGS PRIVATE LIMITED",
"STRUB INDIA PRIVATE LIMITED",
"STRUCOL ENGINEERING INDIA PRIVATE LIMITED",
"STRUCON CONSULTING PRIVATE LIMITED",
"STRUCT GEOTECH RESEARCH LABORATARIES PRIVATE LIMITED",
"STRUCT RE TECH STRUTURAL RESTORATION PRIVATE LIMITED",
"STRUCTCON DESIGNS PRIVATE LIMITED",
"STRUCTCORE SERVICES PRIVATE LIMITED",
"STRUCTEN PREFAB PRIVATE LIMITED",
"STRUCT-EST DESIGNS PRIVATE LIMITED",
"STRUCTURAL CONCEPT DESIGNS PRIVATE LIMITED",
"STRUCTURAL INSULATION AND GLAZING COMPANY PRIVATE LIMITED",
"STRUCTURAL SOLUTIONS PRIVATE LIMITED",
"STRUCTURAL SPECIALITIES AND PROJECTS INDIA PRIVATE LIMITED",
"STRUCTURE ENVELOPES INDIA PRIVATE LIMITED",
"STRUCTURES AND DESIGNS PRIVATE LIMITED",
"STRUCTURES AND FOUNDATIONS PRIVATE LIMITED",
"STRUCTURES INDIA ANZ PROJECT MANAGEMENT SERVICES PRIVATE LIMITED",
"STRUCTURES ONLINE",
"STRUCTWEL CONSTRUCTIONS PRIVATE LIMITED",
"STRUCTWEL DESIGNERS & CONSULTANTS PRIVATE LIMITED",
"STRUDCOM CONSULTANTS PRIVATE LIMITED",
"STRUENGINEERS INDIA PRIVATE LIMITED",
"STRUFRAME SOLUTIONS PRIVATE LIMITED",
"STRUMED SOLUTIONS PRIVATE LIMITED",
"STRUMM ENTERTAINMENT PRIVATE LIMITED",
"STRUT CONSULTANTS PRIVATE LIMITED",
"STRUTSOL ENERGY PRIVATE LIMITED",
"STRUZON GLOBAL WING PRIVATE LIMITED",
"STRUZON TECHNOLOGIES PRIVATE LIMITED",
"STRYDER CYCLE PRIVATE LIMITED",
"STRYKER CORPORATION",
"STRYKER GLOBAL TECHNOLOGY CENTER PRIVATE LIMITED",
"STRYKER INDIA PRIVATE LIMITED",
"STRYKER SECURITY & STAFFING SOLUTIONS PRIVATE LIMITED",
"STS AUTO BIKES PRIVATE LIMITED",
"STS INFRACON PRIVATE LIMITED",
"STS TITEFLEX INDIA PRIVATE LIMITED",
"STS TRANSLOG SOLUTION LLP",
"STS VALVES INDIA PRIVATE LIMITED",
"STS WORLD PRIVATE LIMITED",
"STSONS INDUSTRIES PRIVATE LIMITED",
"STT GLOBAL DATA CENTRES INDIA PRIVATE LIMITED",
"STT PAYTECHS PRIVATE LIMITED",
"STT SERVICES PVT LTD",
"STUAM TECHNOLOGIES LIMITED",
"STUCK CHEMICALS PRIVATE LIMITED",
"STUCKE ELEKTRONIK INDIA PRIVATE LIMITED",
"STUD CRAFT (INDIA) PRIVATE LIMITED",
"STUDD FLU GARMENT PRIVATE LIMITED",
"STUDDS ACCESSORIES LIMITED",
"STUDENT BOX AND SERVICES PRIVATE LIMITED",
"STUDENT HOUSING INDIA PRIVATE LIMITED",
"STUDENTS AGENCIES INDIA PRIVATE LIMITED",
"STUDER INNOTEC INDIA PRIVATE LIMITED",
"STUDIO 13 DESIGN PRIVATE LIMITED",
"STUDIO 34 DESIGNART PRIVATE LIMITED",
"STUDIO 360 TRADE PRIVATE LIMITED",
"STUDIO 6 LIFESTYLE CLINIC PRIVATE LIMITED",
"STUDIO 7 PROJECTS PRIVATE LIMITED",
"STUDIO 9 CONSTRUCTION PRIVATE LIMITED",
"STUDIO ABD DESIGN SERVICES PRIVATE LIMITED",
"STUDIO APS",
"STUDIO B DESIGNS PRIVATE LIMITED",
"STUDIO B PROJECTS PRIVATE LIMITED",
"STUDIO BENTEL PRIVATE LIMITED",
"STUDIO BRAHMA PRIVATE LIMITED",
"STUDIO BRIO PRIVATE LIMITED",
"STUDIO BY CHHAVI CREATION PRIVATE LIMITED",
"STUDIO CAST GLASS PRIVATE LIMITED",
"STUDIO CERAMIC INDIA PRIVATE LIMITED",
"STUDIO COPPRE PRIVATE LIMITED",
"STUDIO COVERS PRIVATE LIMITED",
"STUDIO DRA INTERNATIONAL DESIGNERS PRIVATE LIMITED",
"STUDIO DRAAFT DESIGN & MAKE PRIVATE LIMITED",
"STUDIO EEKSAURUS PRODUCTIONS PRIVATE LIMITED",
"STUDIO ETHENO LIFESTYLE AND TECHNOLOGY PRIVATE LIMITED",
"STUDIO GRAPHENE PRIVATE LIMITED",
"STUDIO HINGE",
"STUDIO KALAVANT (OPC) PRIVATE LIMITED",
"STUDIO LCX FASHION PRIVATE LIMITED",
"STUDIO LSD PRIVATE LIMITED",
"STUDIO MARS PRIVATE LIMITED",
"STUDIO MARVEL PRIVATE LIMITED",
"STUDIO MASONS PRIVATE LIMITED",
"STUDIO MERCHANDISE PRIVATE LIMITED",
"STUDIO METRIC PRIVATE LIMITED",
"STUDIO MRS LLP",
"STUDIO MUMBAI ARCHITECTURE AND DESIGN PRIVATE LIMITED",
"STUDIO NEXT TECHNOLOGY PRIVATE LIMITED",
"STUDIO NOVUS PRIVATE LIMITED",
"STUDIO PARAMETRIC ARCHITECTS INDIA PRIVATE LIMITED",
"STUDIO PROFILE INDIA PRIVATE LIMITED",
"STUDIO QCSQUARE PRIVATE LIMITED",
"STUDIO U PLUS A ADVISORY PRIVATE LIMITED",
"STUDIO U PLUS A INDIA PRIVATE LIMITED",
"STUDIO URBAN SPACE CONSULTANTS PRIVATE LIMITED",
"STUDIO XP MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"STUDIO19 OFFICES PRIVATE LIMITED",
"STUDIO4 CONSULTANTS PRIVATE LIMITED",
"STUDIO45 IT SERVICES PRIVATE LIMITED",
"STUDIO-F INTERIORS PRIVATE LIMITED",
"STUDIOFRY PRODUCTIONS PRIVATE LIMITED",
"STUDIOKON VENTURES PRIVATE LIMITED",
"STUDIOLOTUS UNIT OF TAC DESIGN P LTD",
"STUDIOSOFT SOLUTIONS PRIVATE LIMITED",
"STUDY AT HOME PRIVATE LIMITED",
"STUDY HALL EDUCATION VENTURES PRIVATE LIMITED",
"STUDY VAULT EDUCATION PRIVATE LIMITED",
"STUDYASK EDUCATION PRIVATE LIMITED",
"STUDYNATION 360 PRIVATE LIMITED",
"STUEVE ENGINEERING INDIA PRIVATE LIMITED",
"STULZ CHSPL INDIA PRIVATE LIMITED",
"STUMPP SCHUELE & SOMAPPA AUTO SUSPENSION SYSTEMS PRIVATE LIMITED",
"STUMPP SCHUELE & SOMAPPA PRIVATE LIMITED",
"STUMPP SCHUELE & SOMAPPA SPRINGS PRIVATE LIMITED",
"STUMPP SCHUELE LEWIS MACHINE TOOLS PRIVATE LIMITED",
"STUN BEAUTY PRIVATE LIMITED",
"STUN SIGN LOGISTICS PRIVATE LIMITED",
"STUNNERY BEAUTY LABS PRIVATE LIMITED",
"STUP CONSULTANTS PRIVATE LIMITED",
"STUP INFRA PRIVATE LIMITED",
"STURDY INDUSTRIES LIMITED",
"STURLITE ELECTRIC PRIVATE LIMITED",
"STURMFREI HOSPITALITY PRIVATE LIMITED",
"STUTI DEVCON PRIVATE LIMITED",
"STUTI EXPORTS PVT LTD",
"STUTI FOREX PRIVATE LIMITED",
"STUTI PIPES PRIVATE LIMITED",
"STUTI PROCESSORS PRIVATE LIMITED",
"STUTI TECHNOLOGIES PRIVATE LIMITED",
"STUTI UDYOGS PRIVATE LIMITED",
"STUVE COREMIN PRIVATE LIMITED",
"STW E-COMMERCE PRIVATE LIMITED",
"STW SERVICES LLP",
"STWO PRODUCTS AND SERVICES PRIVATE LIMITED",
"STXYZ SOLUTIONS PRIVATE LIMITED",
"STYLABS TECHNOLOGIES PRIVATE LIMITED",
"STYLAM INDUSTRIES LIMITED",
"STYLE DESIGN EMBROIDERIES PRIVATE LIMITED",
"STYLE INDIA TEX-STYLE PRIVATE LIMITED",
"STYLE ISLAND PRIVATE LIMITED",
"STYLE ONE RETAIL PRIVATE LIMITED",
"STYLE QUOTIENT JEWELLERY PRIVATE LIMITED",
"STYLE SOLUTIONS PRIVATE LIMITED",
"STYLE STITCH LLP",
"STYLE TOWERS PRIVATE LIMITED",
"STYLE ZONE BABY PRODUCTS PRIVATE LIMITED",
"STYLEDOTME FASHION AND LIFESTYLE PRIVATE LIMITED",
"STYLEFAB PRIVATE LIMITED",
"STYLEFLEX PRINT SYSTEM PRIVATE LIMITED",
"STYLEIIN INDIA PRIVATE LIMITED",
"STYLEMOND SHOPPING PRIVATE LIMITED",
"STYLEPITARA PRIVATE LIMITED",
"STYLEPORT FASHION PRIVATE LIMITED",
"STYLESHORE EMARKETING PRIVATE LIMITED",
"STYLETRIBE FASHION APPAREL PRIVATE LIMITED",
"STYLEWORK ENGINEERING PRIVATE LIMITED",
"STYLEWORK INNOVATION HUB PRIVATE LIMITED",
"STYLEX INDUSTRIES PRIVATE LIMITED",
"STYLIN SANITARYWARES",
"STYLISH HOTELS PRIVATE LIMITED",
"STYLISH MERCHANTS PRIVATE LIMITED",
"STYLISH PACKERS PVT LTD",
"STYLISH SUPER SERVICES PRIVATE LIMITED",
"STYLIVE IMPORTERS PRIVATE LIMITED",
"STYLO EXPORTS PRIVATE LIMITED",
"STYLO GRAPHIC IMAGING PRIVATE LIMITED",
"STYLO MEDIA PRIVATE LIMITED",
"STYLO SHOES PVT LTD",
"STYLUM MART PRIVATE LIMITED",
"STYLUMIA INTELLIGENCE TECHNOLOGY PRIVATE LIMITED",
"STYLUS EVENTS INDIA PRIVATE LIMITED",
"STYLUS SYSTEMS PRIVATE LIMITED",
"STYRAX COMMODITIES LIMITED EDELWEISS",
"STYRAX INSTRUMENTS INDIA PRIVATE LIMITED",
"STYRAX LABORATORIES PRIVATE LIMITED",
"STYRAX LIFE SCIENCES PRIVATE LIMITED",
"STYRAX PHARMA PRIVATE LIMITED",
"STYRENE PACKINGS PRIVATE LIMITED",
"STYRENIX PERFORMANCE MATERIALS LIMITED",
"STYRIC CHEM PRIVATE LIMITED",
"STYRO BOND PRIVATE LIMITED",
"STYRO POLY CHEM PRIVATE LIMITED",
"STYRO STEEL CAST PRIVATE LIMITED",
"STYROPACK PRIVATE LIMITED",
"STYROPLAST TRADING PRIVATE LIMITED",
"STYXTECH SYSTEMS PRIVATE LIMITED",
"SU CREATIONS PRIVATE LIMITED",
"SU LOGISTICS PRIVATE LIMITED",
"SU MANGALA COKE PRIVATE LIMITED",
"SU SQUARE PROJECTS AND INFRASTRUCTURE PRIVATE LIMITED",
"SU TOLL ROAD PRIVATE LIMITED",
"SU1 CAPITAL PRIVATE LIMITED",
"SUA EXPLOSIVES ANDACCESSORIES PRIVATE LIMITED",
"SUAAN TECHMECHS PVT.LTD.",
"SUADELA CONSTRUCTIONS PRIVATE LIMITED",
"SUAM OVERSEAS PRIVATE LIMITED",
"SUAN CARRIERS SOLUTIONS PRIVATE LIMITED",
"SUARABHAKTI GOODS PRIVATE LIMITED",
"SUASHISH APPARELS PRIVATE LIMITED",
"SUASHISH JEWELS DIV OF SUASHISH DIAMONDS LIMITED",
"SUASTH HEALTH CARE INDIA LIMITED",
"SUAVAL LORVEN INDIA PRIVATE LIMITED",
"SUAVE CORPORATION INDIA PRIVATE LIMITED",
"SUAVE MED SCIENCES PRIVATE LIMITED",
"SUB COLLECTOR SUB DIVISION TALCHER",
"SUB DISTRICT HOSPITAL KURKHEDA",
"SUB DISTRICT HOSPITAL NANDURBAR",
"SUB DISTRICT HOSPITAL SONGADH",
"SUB DISTRICT MAGISTRATE SAHARANPUR",
"SUB DIVISION WORK MUKTAINAGAR",
"SUB DIVISIONAL AGRICULTURE OFFICE",
"SUB DIVISIONAL ENGINEER PW SUB DIVISION AMBAD",
"SUB DIVISIONAL FOREST OFFICER SANGLI",
"SUB DIVISIONAL MEDICAL OFFICER BANKI",
"SUB DIVISIONAL OFFICER AGRICULTURE",
"SUB DIVISON AGRICULTURE OFFICE",
"SUB KO COFFEE PRIVATE LIMITED",
"SUB SURFACE CONSULTANTS PRIVATE LIMITED",
"SUB ZERO INSULATION TECHNOLOGIES PRIVATE LIMITED",
"SUBA HOSPITALITY PRIVATE LIMITED",
"SUBA HOTELS LIMITED",
"SUBA MALL PRIVATE LIMITED",
"SUBA PLASTICS PRIVATE LIMITED",
"SUBA PRADA OILS PRIVATE LIMITED",
"SUBA SOLUTIONS PRIVATE LIMITED",
"SUBAASH ELECTRICAL PRIVATE LIMITED",
"SUBABHALAJI SPINNING MILLS INDIA PRIVATE LIMITED",
"SUBADRA TEXTILE PRIVATE LIMITED",
"SUBAL FOODS (OPC) PRIVATE LIMITED",
"SUBALA ENGINEERING PRIVATE LIMITED",
"SUBALLIANCE SUPPLY CHAIN MANAGEMENT PRIVATE LIMITED",
"SUBAM PAPER AND BOARDS PRIVATE LIMITED",
"SUBAM PAPERS PRIVATE LIMITED",
"SUBAM POOJA PRODUCTS PRIVATE LIMITED",
"SUBARNAREKHA AGRICULTURE PRODUCER COMPANY LIMITED",
"SUBARNAREKHA PORT PRIVATE LIMITED",
"SUBASH WIRES AND CABLES PRIVATE LIMITED",
"SUBASHRI CHEMICALS PRIVATE LIMITED",
"SUBASRI REALTY PRIVATE LIMITED",
"SUBAYA CONSTRUCTIONS COMPANY LIMITED",
"SUBBA REDDY AND SONS CONSTRUCTIONS PRIVATE LIMITED",
"SUBBAIAH INSTITUTE OF MEDICAL SCIENCES",
"SUBBALAKSHMI LAKSHMIPATHY FOUNDATION.",
"SUBBU AND COMPANY PRIVATE LIMITED",
"SUBBU INFRA PROJECTS PRIVATE LIMITED",
"SUBBURAAJ COTTON MILL PRIVATE LIMITED",
"SUBBURAMAN IRON AND STEELS PRIVATE LIMITED",
"SUBCODEVS IT CONSULTING AND SERVICES PRIVATE LIMITED",
"SUBDEEP FOODS PRIVATE LIMITED",
"SUBEX LIMITED",
"SUBH CREDIT CO-OPERATIVE SOCIETY LIMITED",
"SUBH HANDICRAFT PRIVATE LIMITED",
"SUBH INDUSTRIAL COMPONENTS PRIVATE LIMITED",
"SUBH IRRIGATION PRIVATE LIMITED",
"SUBH LABH ARTS",
"SUBH LABH BUILDTECH PRIVATE LIMITED",
"SUBH LAKSHYA METAL EXIM PRIVATE LIMITED",
"SUBH LAXMI COLD STORAGE AND ICE FACTORY PRIVATE LIMITED",
"SUBH LAXMI COTTON PRIVATE LIMITED",
"SUBH LAXMI MULTISOLUTION PRIVATE LIMITED",
"SUBH LAXMI SYNTEX LIMITED",
"SUBH LAXMI TEXTRADE PRIVATE LIMITED",
"SUBH PROPERTIES PRIVATE LIMITED",
"SUBH RESINS AND FUELS PVT. LTD.",
"SUBH SANKET TRADERS PRIVATE LIMITED",
"SUBH SHRI ROAD CARRIER PRIVATE LIMITED",
"SUBH STEELFAB ENGINEERS PRIVATE LIMITED",
"SUBH VIKALP FATEPUR FARMER PRODUCER COMPANY LIMITED",
"SUBH VYAPAAR PVT LTD",
"SUBHA ANANDHAM MEDICAL CENTRE",
"SUBHA COMPREHENSIVE CANCER CARE PRIVATE LIMITED",
"SUBHA GRUHA PROJECTS (INDIA) PRIVATE LIMITED",
"SUBHA LABHA EDIFICE PRIVATE LIMITED",
"SUBHA LAXMI RICE MILLS PRIVATE LIMITED",
"SUBHA RAKSHA KALI RICE MILLS PRIVATE LIMITED",
"SUBHA SHAM INDUSTRIES PRIVATE LIMITED",
"SUBHADRA BUILDCON PRIVATE LIMITED",
"SUBHADRA COMMERCIAL PRIVATE LIMITED",
"SUBHADRA ENGINEERING PRIVATE LIMITED",
"SUBHADRA INFRAESTATE PRIVATE LIMITED",
"SUBHADRA LOCAL AREA BANK LIMITED",
"SUBHADRA METALS PRIVATE LIMITED",
"SUBHADRA PETROCHEMICALS PRIVATE LIMITED",
"SUBHADRA RINGS PRIVATE LIMITED",
"SUBHADRAA ENGINEERING AND TECHNOLOGIES PRIVATE LIMITED",
"SUBHAG IMPEX PRIVATE LIMITED",
"SUBHAGRUHA INFRASTRUCTURES PRIVATE LIMITED",
"SUBHAGYA PROMOTERS & BUILDERS PRIVATE LIMITED",
"SUBHAGYAM PRINTS PRIVATE LIMITED",
"SUBHALAKHI BONDED WAREHOUSE PRIVATE LIMITED",
"SUBHALAKSHMI MOTORS PRIVATE LIMITED",
"SUBHAM AGENCIES PRIVATE LIMITED",
"SUBHAM AGRO INDIA",
"SUBHAM BUILDWELL PRIVATE LIMITED",
"SUBHAM CAPITAL PRIVATE LIMITED",
"SUBHAM CHEMICALS PRIVATE LIMITED",
"SUBHAM COMMERCIAL ENTERPRISES PVT LTD",
"SUBHAM CORPORATION PRIVATE LIMITED",
"SUBHAM FREIGHT CARRIERS INDIA PRIVATE LIMITED",
"SUBHAM MAHESWARI COLD STORAGE PRIVATE LIMITED",
"SUBHAM MERCHANDISE PRIVATE LIMITED",
"SUBHAM OILS & RESINS PRIVATE LIMITED",
"SUBHAM PLANNERS LIMITED",
"SUBHAM POLES PROJECTS PRIVATE LIMITED",
"SUBHAM POLYCHEM PRIVATE LIMITED",
"SUBHAM RICE MILL PRIVATE LIMITED.",
"SUBHAM SOLAR SOLUTIONS PRIVATE LIMITED",
"SUBHAM TRADERS",
"SUBHAMASTHU SHOPPING MALL PRIVATE LIMITED",
"SUBHAN EXPORT PRIVATE LIMITED",
"SUBHANG CAPSAS PRIVATE LIMITED",
"SUBHANJALI CHIT FUND PRIVATE LIMITED",
"SUBHANKAR CHATTOPADHYAY PRODUCTION PRIVATE LIMITED",
"SUBHANU RAPIDD INDOGLOBAL TECHNOLOGIES PRIVATE LIMITED",
"SUBHARTI MEDIA LIMITED",
"SUBHAS PUBLISHING HOUSE PRIVATE LIMITED",
"SUBHASH ABHISHEK STEELS PRIVATE LIMITED",
"SUBHASH AUTO HOME PRIVATE LIMITED",
"SUBHASH CHEMICAL INDUSTRIES PRIVATE LIMITED",
"SUBHASH COMPUTERS PRIVATE LIMITED",
"SUBHASH DISTRIBUTORS LIMITED.",
"SUBHASH ENGINEERS",
"SUBHASH INFRA PROJECTS PRIVATE LIMITED",
"SUBHASH INFRAENGINEERS PRIVATE LIMITED",
"SUBHASH INTER COLLEGE MATHURA",
"SUBHASH INTERNATIONAL PVT LTD",
"SUBHASH JEWELS (INDIA) PRIVATE LIMITED",
"SUBHASH KUMAR AGRAWAL",
"SUBHASH MASALA COMPANY PRIVATE LIMITED",
"SUBHASH PLACE MANAGEMENT PRIVATE LIMITED",
"SUBHASH POLYTEX LIMITED",
"SUBHASH POWER COMPANY LIMITED",
"SUBHASH PRECISION COMPONENTS PRIVATE LIMITED",
"SUBHASH PROCESSORES",
"SUBHASH SALES PRIVATE LIMITED",
"SUBHASH SAREES & INDUSTRIES PRIVATE LIMITED",
"SUBHASH SHAH AND ASSOCIATES ARCHITECTS PRIVATE LIMITED",
"SUBHASH SILK MILLS LIMITED",
"SUBHASH SMARAK INTER COLLEGE",
"SUBHASH STONE INDUSTRIES PRIVATE. LIMITED.",
"SUBHASH STUDIOS PRIVATE LIMITED",
"SUBHASH TOWER CONSTRUCTION PVT LTD",
"SUBHASHANI CONSTRUCTIONS PVT LTD",
"SUBHASHCHANDRA BOSE VIDYAMANDIR",
"SUBHASHINI OIL MILLS PRIVATE LIMITED",
"SUBHASHNAGAR EDUCATION SOCIETY",
"SUBHASHREE PACKERS PRIVATE LIMITED",
"SUBHASISH JENA ENGINEERS & BUILDERS PRIVATE LIMITED",
"SUBHA-SOUMYA COLD STORAGE PRIVATE LIMITED",
"SUBHASREE PROJECTS PRIVATE LIMITED",
"SUBHASRI BUILDERS PRIVATE LIMITED",
"SUBHASRI PIGMENTS PRIVATE LIMITED",
"SUBHASURYA ENERGY AND ENGINEERING SERVICES PRIVATE LIMITED",
"SUBHDISHA NIDHI LIMITED",
"SUBH-DRISHTI LAMIPACK PRIVATE LIMITED",
"SUBHIKSH STEEL IMPEX PRIVATE LIMITED",
"SUBHIKSHAM ENGINEERING PRIVATE LIMITED",
"SUBHKAM VENTURES (I) PRIVATE LIMITED",
"SUBHKIRAN CAPITAL LIMITED",
"SUBHLABH CEMENTS PRIVATE LIMITED",
"SUBHLABH FISCAL SERVICES PVT LTD",
"SUBHLABH TRADELINK PRIVATE LIMITED",
"SUBHLAGAN.COM PRIVATE LIMITED",
"SUBHLAKSHMI FINANCE PRIVATE LIMITED",
"SUBHLAXMI AGRO OILS PRIVATE LIMITED",
"SUBHLAXMI INVESTMENT ADVISORY PRIVATE LIMITED",
"SUBHLAXMI SPECIAL STEEL PRIVATE LIMITED",
"SUBHLAXMI TEXTILE PRIVATE LIMITED",
"SUBHLENE FABRICS",
"SUBHMANGAL GOLD PRIVATE LIMITED",
"SUBHMAYA SURYA NARAYAN HIGH SCHOOL",
"SUBHNEN PANEL PRODUCTS PRIVATE LIMITED",
"SUBHODAYA DIGITAL ENTERTAINMENT PRIVATE LIMITED",
"SUBHODAYA FERTILISERS PRIVATE LIMITED",
"SUBHODAYA PAPER PRODUCTS",
"SUBHODAYA WAREHOUSING PRIVATE LIMITED",
"SUBHOLAXMI FABRICS PRIVATE LIMITED",
"SUBHOSTING INNOVATIONS PRIVATE LIMITED",
"SUBHRAA METALS PRIVATE LIMITED",
"SUBHRASHI PROPERTIES PRIVATE LIMITED",
"SUBHSAGAR MERCANTILES PRIVATE LIMITED",
"SUBHSAN INTERFAB PRIVATE LIMITED",
"SUBHSHREE LOGISTICS LLP",
"SUBHSHREE MERCANTILE PRIVATE LIMITED",
"SUBHUJO TECHNOLOGIES PRIVATE LIMITED",
"SUBHWANTI INSTITUTE OF EDUCATION",
"SUBI CHEMICALS PRIVATE LIMITED",
"SUBICSHA COCONUTS PRODUCER COMPANY LIMITED (UNDER PART IXA)",
"SUBIDSON ELECTRONICS PRIVATE LIMITED",
"SUBIKSHA HOUSING PRIVATE LIMITED",
"SUBIR DIAMONDS PRIVATE LIMITED",
"SUBIR ENGINEERING WORKS PVT LTD",
"SUBIR PRECISION INDUSTRIES PRIVATE LIMITED",
"SUBIR UDYOG LTD",
"SUBIRA PHARMACEUTICALS PRIVATE LIMITED",
"SUBIZZ TRAVEL SOLUTIONS PRIVATE LIMITED",
"SUBLA'S PUBLICATION PRIVATE LIMITED",
"SUBLIME AGRO LTD",
"SUBLIME DATA SYSTEMS PRIVATE LIMITED",
"SUBLIME EDGE PRAGMATIC SOLUTIONS PRIVATE LIMITED",
"SUBLIME FOODS LIMITED",
"SUBLIME RESOURCES PRIVATE LIMITED",
"SUBLIME WAREHOUSING PRIVATE LIMITED",
"SUBMARINE INTERNATIONAL",
"SUBMERGE ENTERTAINMENT PRIVATE LIMITED",
"SUBODH BUILDWELL PRIVATE LIMITED",
"SUBODH LOGISTIC SOLUTIONS PRIVATE LIMITED",
"SUBODHAN ENGINEERS PUNE PVT LTD",
"SUBODHCHANDRA JEWELLERS PRIVATE LIMITED",
"SUBOLI ICE & COLD STORAGE PRIVATE LIMITED",
"SUBONEYO CHEMICALS AND PHARMACEUTICALS PRIVATE LIMITED",
"SUBRA INFRASTRUCTURES PRIVATE LIMITED",
"SUBRA INTERNATIONAL PRIVATE LIMITED",
"SUBRA TRADING PRIVATE LIMITED",
"SUBRAA POLYMERS PRIVATE LIMITED",
"SUBRAMANIAM CHEMICALS AND EXPLOSIVES PRIVATE LIMITED",
"SUBRAMANIAM MOTORS PRIVATE LIMITED",
"SUBRAMANIAN ENGINEERING LIMITED",
"SUBRAO INDUSTRIES PRIVATE LIMITED",
"SUBRAT ORGANICS PVT LTD",
"SUBRATA AUTOMOBILE PRIVATE LIMITED",
"SUBRAY CATALCHEM PRIVATE LIMITED",
"SUBROS LIMITED",
"SUBSCRIBEIT SOLUTIONS PRIVATE LIMITED",
"SUBSCRIPT MEDIA SERVICES PRIVATE LIMITED",
"SUBSEA PRO ENGINEERING PRIVATE LIMITED",
"SUBSERVE IT SOLUTION PRIVATE LIMITED",
"SUBSIDIARY INTELLIGENCE BUREAU",
"SUBSIDIARY INTELLIGENCE BUREAU MINISTRY OF HOME AFFAIRS GOVT OF INDIA",
"SUBSTANCE INFOTECH SOLUTIONS PRIVATE LIMITED",
"SUBSUKH TRADING PRIVATE LIMITED",
"SUBTLE CONTROLS (I) PRIVATE LIMITED",
"SUBTLELABS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"SUBTLEWEIGH ELECTRIC (INDIA) PRIVATE LIMITED",
"SUBURBAN DIAGNOSTICS INDIA PRIVATE LIMITED",
"SUBURBAN INDUSTRIAL WORKS PRIVATE LIMITED",
"SUBURBIA PERIODICALS PRIVATE LIMITED",
"SUBVIJAY INTERNATIONAL PVT LTD",
"SUBYARTH CRAFT PRIVATE LIMITED",
"SUBZERO ENTERTAINMENT PRIVATE LIMITED",
"SUBZERO TUBE TOOLS PRIVATE LIMITED",
"SUCCEED TECHNOLOGIES PRIVATE LIMITED",
"SUCCESS AGENCY PRIVATE LIMITED",
"SUCCESS AUTOMOBILE PRIVATE LIMITED",
"SUCCESS ENGRAVERS PRIVATE LIMITED",
"SUCCESS EXIM PRIVATE LIMITED",
"SUCCESS FIRE PROTECTION PRIVATE LIMITED",
"SUCCESS GYAN INDIA LLP",
"SUCCESS GYAN INDIA PRIVATE LIMITED",
"SUCCESS IMPEX PRIVATE LIMITED",
"SUCCESS KREATORS MARCOM PRIVATE LIMITED",
"SUCCESS MACHINE TOOL SERVICES PRIVATE LIMITED",
"SUCCESS NIRYAT PRIVATE LIMITED",
"SUCCESS NUMBERS PRIVATE LIMITED",
"SUCCESS PACT CONSULTING PRIVATE LIMITED",
"SUCCESS PARTNER CONSULTANTS PRIVATE LIMITED",
"SUCCESS PROMOS & EVENTS PRIVATE LIMITED",
"SUCCESS SEALING AND SURVEYOR PRIVATE LIMITED",
"SUCCESS STEPS PRIVATE LIMITED",
"SUCCESS TECH ERA PRIVATE LIMITED",
"SUCCESS UDYOG PRIVATE LIMITED",
"SUCCESS-9 FACILITIES SERVICES PRIVATE LIMITED",
"SUCCESSBASED RESEARCH & ANALYTICS PRIVATE LIMITED",
"SUCCESSIVE TECHNOLOGIES PRIVATE LIMITED",
"SUCCESSSHORE IT SOLUTIONS PRIVATE LIMITED",
"SUCCESSURE GLOBAL INVESTMENT PRIVATE LIMITED",
"SUCCESSWRKS HR SOLUTIONS PRIVATE LIMITED",
"SUCCEVO SOLUTIONS INDIA PRIVATE LIMITED",
"SUCCINCT INFRA PRIVATE LIMITED",
"SUCCINNOVA TECHNOLOGIES PRIVATE LIMITED",
"SUCCOUR SHIPPING LINES INDIA PRIVATE LIMITED",
"SUCDEN COFFEE INDIA PRIVATE LIMITED",
"SUCDEN INDIA PRIVATE LIMITED",
"SUCESSKING CONTRACTORS PRIVATE LIMITED",
"SUCG INFRASTRUCTURE INDIA PRIVATE LIMITED",
"SUCH EXPORTS PRIVATE LIMITED",
"SUCH IMPEX PRIVATE LIMITED",
"SUCH WELL FOREX PRIVATE LIMITED",
"SUCHAK HOSPITAL",
"SUCHAKRA INFRACON PRIVATE LIMITED",
"SUCHALIS CONFECTIONERY PRIVATE LIMITED",
"SUCHAN SOFTWARE PRIVATE LIMITED",
"SUCHANA MARINE SERVICES PRIVATE.LIMITED",
"SUCHEM ORGANICS PRIVATE LIMITED",
"SUCHETA FOOTWEAR PRIVATE LIMITED",
"SUCHETA JWELLERY PRIVATE LIMITED",
"SUCHETA KRIPLANI HOSPITAL",
"SUCHI FASTENERS PRIVATE LIMITED",
"SUCHI FOAMS PRIVATE LIMITED",
"SUCHI INDUSTRIES LIMITED",
"SUCHI PAPER MILLS LIMITED",
"SUCHI STEEL PRIVATE LIMITED",
"SUCHI TRADING COMPANY PRIVATE LIMITED",
"SUCHI TURNKEY PROJECTS PRIVATE LIMITED",
"SUCHIKA FOODS PRIVATE LIMITED",
"SUCHINTA EDUCATIONAL SOCIETY",
"SUCHIR CHEMICALS PRIVATE LIMITED",
"SUCHIR LIGHTING EXPORTS PRIVATE LIMITED",
"SUCHIRAYU HEALTH CARE SOLUTIONS LIMITED.",
"SUCHIRINDIA CONSTRUCTIONS PRIVATE LIMITED",
"SUCHIRINDIA HOTELS AND RESORTS PRIVATE LIMITED",
"SUCHIRINDIA INFRACON PRIVATE. LIMITED",
"SUCHIRINDIA INFRATECH PRIVATE. LIMITED.",
"SUCHIT POLYSHRINK PRIVATE LIMITED",
"SUCHITA MARKETINGS PRIVATE LIMITED",
"SUCHITA MILLENIUM PROJECTS PRIVATE LIMITED",
"SUCHITA POWER PRIVATE LIMITED",
"SUCHITA RENTALS PRIVATE LIMITED",
"SUCHITRA ACADEMY",
"SUCHITRA BADMINTON ACADEMY",
"SUCHITRA EDUCATION TRUST SET",
"SUCHITRA FABTEX PRIVATE LIMITED",
"SUCHITRA SILK MILLS PRIVATE LIMITED",
"SUCHITRAA SILK PRIVATE LIMITED",
"SUCHNA MARINE SERVICES PRIVATE LIMITED",
"SUCO EXPORTS PRIVATE LIMITED",
"SUCOPEIA REFERENCESTANDARDS (OPC) PRIVATE LIMITED",
"SUCROMAX ENGINEERING INDIA PRIVATE LIMITED",
"SUCROTECH ENGINEERING PRIVATE LIMITED",
"SUD APPARELS PRIVATE LIMITED",
"SUD CHEMIE INDIA PRIVATE LIMITED",
"SUD HOTELS AND ALLIED ENTERPRISES PVT LTD",
"SUD PINES PRIVATE LIMITED",
"SUDA INFRASTRUCTURES PRIVATE LIMITED",
"SUDAKARN TECHNOLOGIES PRIVATE LIMITED",
"SUDALAGUNTA AGRO MILLS LIMITED",
"SUDALAGUNTA FLOUR MILLS LIMITED",
"SUDAM MEDI AGRO RESEARCH AND TRAINING PRIVATE LIMITED",
"SUDAMA ASSOCIATES PVT LTD",
"SUDAMA PRESERVATION PRIVATE LIMITED",
"SUDAMO IMPEX PRIVATE LIMITED",
"SUDAN TECHNOPRUDENT PRIVATE LIMITED",
"SUDANA AGENCIES PRIVATE LIMITED",
"SUDANIA CROP CARE PRIVATE LIMITED",
"SUDAR SURGICAL PRIVATE LIMITED",
"SUDARSAN CLAY AND CERAMICS LTD",
"SUDARSAN ENGINEERING INDUSTRIES PRIVATE LIMITED",
"SUDARSAN TRADING CO LIMITED",
"SUDARSHAN (INDIA) PRIVATE LIMITED",
"SUDARSHAN ADDPACK PRIVATE LIMITED",
"SUDARSHAN AGENCY PRIVATE LIMITED.",
"SUDARSHAN ALLUMINIUM INDIA LIMITED",
"SUDARSHAN AUTO INDUSTRIES PRIVATE LIMITED",
"SUDARSHAN BEOPAR CO LTD",
"SUDARSHAN BEOPAR COMPANY LIMITED SBCL",
"SUDARSHAN CARGO PRIVATE LIMITED",
"SUDARSHAN CHEMICALS INDUSTRIES LIMITED",
"SUDARSHAN CHEMPRO PRIVATE LIMITED",
"SUDARSHAN CSR FOUNDATION",
"SUDARSHAN DHOOP PRIVATE LTD",
"SUDARSHAN ESTCON PRIVATE LIMITED",
"SUDARSHAN EXTRUSIONS PRIVATE LIMITED",
"SUDARSHAN FACILITIES PRIVATE LIMITED",
"SUDARSHAN FARM CHEMICALS INDIA PRIVATE LIMITED",
"SUDARSHAN FISCAL SERVICES PVT LTD",
"SUDARSHAN GLASS PRIVATE LIMITED",
"SUDARSHAN IMPORT PVT LTD",
"SUDARSHAN INFRA-PROJECTS PRIVATE LIMITED",
"SUDARSHAN JEANS PRIVATE LIMITED",
"SUDARSHAN KRUSHIADHAR PRIVATE LIMITED",
"SUDARSHAN MANTECH PRIVATE LIMITED",
"SUDARSHAN MARMO PRIVATE LIMITED",
"SUDARSHAN METALLIC PRIVATE LIMITED",
"SUDARSHAN MILK AND AGRO PRODUCTS PRIVATE LIMITED",
"SUDARSHAN MINCHEM LIMITED",
"SUDARSHAN MV SHRINAGAR LATUR",
"SUDARSHAN PACKWELL PRIVATE LIMITED",
"SUDARSHAN PAPER & BOARD PRIVATE LIMITED",
"SUDARSHAN PHARMA INDUSTRIES LIMITED",
"SUDARSHAN PHARMACEUTICALS PVT LTD",
"SUDARSHAN PIPES EXTRUSIONS PRIVATE LIMITED",
"SUDARSHAN POLYFAB PRIVATE LIMITED",
"SUDARSHAN PULSES & REAL ESTATE PRIVATE LIMITED",
"SUDARSHAN SAUR SHAKTI PRIVATE LIMITED",
"SUDARSHAN SEEDS PVT LTD",
"SUDARSHAN SILICATE PRIVATE LIMITED",
"SUDARSHAN SOLVENTS INDUSTRIES LIMITED",
"SUDARSHAN SULZ PRIVATE LIMITED",
"SUDARSHAN TECHNO SOLUTION PRIVATE LIMITED",
"SUDARSHAN TEXFABS PRIVATE LIMITED",
"SUDARSHAN TEXTILES PRIVATE LIMITED",
"SUDARSHAN TRADEPOINT PRIVATE LIMITED",
"SUDARSHAN TRANSFORMERS PRIVATE LIMITED",
"SUDARSHAN UDYOG PRIVATE LIMITED",
"SUDARSSHAN POLLYBLENDS PRIVATE LIMITED",
"SUDDH INFRA PROJECTS PRIVATE LIMITED",
"SUDDHA MACHINERIES AND INDUSTRIES PRIVATE LIMITED",
"SUDDPRAM AUTO ENGINEERING COMPANY PRIVATE LIMITED",
"SUDEEKSHA HEALTHCARE PRIVATE LIMITED",
"SUDEEP EXIM PRIVATE LIMITED",
"SUDEEP LOGISTICS PRIVATE LIMITED",
"SUDEEP NUTRITION PRIVATE LIMITED",
"SUDEEP PHARMA LIMITED",
"SUDEEP POLYMERS PRIVATE LIMITED",
"SUDERA PROPERTIES PRIVATE LIMITED",
"SUDERA REALTY PRIVATE LIMITED",
"SUDERSHAN CASTINGS PRIVATE LIMITED",
"SUDERSHAN DOORS PRIVATE LIMITED",
"SUDERSHAN FIBRE ENTERPRISES PRIVATE LIMITED",
"SUDERSHAN GLOBAL EVENTS AND SERVICES PRIVATE LIMITED",
"SUDERSHAN LABORATORIES LIMITED",
"SUDERSHAN MEASURING AND ENGINEERING PRIVATE LIMITED",
"SUDERSHAN PLYBOARDS PRIVATE LIMITED",
"SUDERSHAN ROADWAYS INDIA PRIVATE LIMITED",
"SUDESH AUTOMOBILES PRIVATE LIMITED",
"SUDESH CHEMICALS PVT LTD",
"SUDESH SYNTHETIC MILLS PRIVATE LIMITED",
"SUDESI INFOTECH PRIVATE LIMITED",
"SUDESU AV TECH PRIVATE LIMITED",
"SUDEV FASHION PRIVATE LIMITED",
"SU-DEV GROUP PRIVATE LIMITED",
"SUDEV SPINNERS PRIVATE LIMITED",
"SUDH INVESTMENTS PVT. LTD.",
"SUDH PRIYA PLASTICHEM PRIVATE LIMITED",
"SUDHA AGRO OIL AND CHEMICAL INDUSTRIES LIMITED",
"SUDHA ANALYTICALS PRIVATE LIMITED",
"SUDHA APPARELS LTD",
"SUDHA BIO POWER PRIVATE LIMITED",
"SUDHA BUSINESS ENTERPRISES PRIVATE LIMITED",
"SUDHA CASTINGS PRIVATE LIMITED",
"SUDHA COMMERCIAL CO LTD",
"SUDHA DYEING AND PRINTING MILLS PRIVATE LIMITED",
"SUDHA FLEET MANAGEMENT PRIVATE LIMITED",
"SUDHA FUELS PRIVATE LIMITED",
"SUDHA HOSPITAL",
"SUDHA INFRAELECTRICAL PRIVATE LIMITED",
"SUDHA JEWELLERS PVT. LTD.",
"SUDHA KANT ENTERPRISES PRIVATE LIMITED",
"SUDHA MEDICARE LLP",
"SUDHA METAL PRINTERS PRIVATE LIMITED",
"SUDHA ORTHOPAEDIC AND GYNEC HOSPITAL PRIVATE LIMITED",
"SUDHA PRABHAKAR COMPLEX PRIVATE LIMITED",
"SUDHA PROMOTERS PRIVATE LIMITED",
"SUDHA SECURITY PROTECTION FORCE PRIVATE LIMITED",
"SUDHA SOMANY CERAMICS PRIVATE LIMITED",
"SUDHA STEEL MANUFACTURER PRIVATE LIMITED",
"SUDHA SURGICAL HOSPITAL PRIVATE LIMITED",
"SUDHA SYNTEX PRIVATE LIMITED",
"SUDHA TECHNICAL CONSULTANTS PRIVATE LIMITED",
"SUDHA VENTILATING SYSTEMS PRIVATE LIMITED",
"SUDHAI AIRTECH PRIVATE LIMITED",
"SUDHAKAR IRRIGATION SYSTEMS PRIVATE LIMITED",
"SUDHAKAR MARKETING AGENCIES PRIVATE LIMITED",
"SUDHAKAR POLYMERS LIMITED",
"SUDHAKAR PVC PRODUCTS PRIVATE LIMITED",
"SUDHAKARA INFRATECH PRIVATE LIMITED",
"SUDHAKARAN NAIR & COMPANY PRIVATE LIMITED",
"SUDHAMAYEE PAPERS PRIVATE LIMITED",
"SUDHAMOY AGRO INDUSTRY PRIVATE LIMITED",
"SUDHAMRIT SOLUTIONS PRIVATE LIMITED",
"SUDHAN ELECTROMECH PRIVATE LIMITED",
"SUDHAN SPINNING MILLS PRIVATE LIMITED",
"SUDHAN TRADING PRIVATE LIMITED",
"SUDHANA TELECOMMUNICATIONS PRIVATE LIMITED",
"SUDHANSHU INFRASTRUCTURES PRIVATE LIMITED",
"SUDHANVA INVESTMENTS AND TRADING COMPANY PRIVATE LIMITED",
"SUDHANVA TECHNOLOGIES PRIVATE LIMITED",
"SUDHAPATI DEVELOPERS PRIVATE LIMITED",
"SUDHARA SANITATIONS PRIVATE LIMITED",
"SUDHARM AYATNIRYAT PRIVATE LIMITED",
"SUDHARMA CLOTHING COMPANY PRIVATE LIMITED",
"SUDHARMA INFRATECH PRIVATE LIMITED",
"SUDHARMA KNITS PRIVATE LIMITED",
"SUDHARMA METROPOLIS HEALTH SERVICES PRIVATE LIMITED",
"SUDHARSAN ENGINEERING COLLEGE",
"SUDHARSAN LOGISTICS PRIVATE LIMITED",
"SUDHARSANAM VIDYAASHRAM CBSE SCHOOL",
"SUDHARSHAN MECOTRONICS PRIVATE LIMITED",
"SUDHASAGAR POLYMERS PRIVATE LIMITED",
"SUDHASAGAR SPINNERS INDIA PRIVATE LIMITED",
"SUDHASREE MINERALS AND NUTRIENTS PRIVATE LIMITED",
"SUDHESH INDUSTRIES PRIVATE LIMITED",
"SUDHIR & SONS IMPORTS PRIVATE LIMITED",
"SUDHIR AGRO OILS PRIVATE LIMITED",
"SUDHIR AUTOMOTIVE INDUSTRIES PRIVATE LIMITED",
"SUDHIR BROTHERS",
"SUDHIR CONSTRUCTIONS INFRASPACE (SHEGAON PALKHI ROAD) PRIVATE LIMITED",
"SUDHIR CRANES PRIVATE LIMITED",
"SUDHIR DAIRY & SWEETS PRIVATE LIMITED",
"SUDHIR ELECTRICALS PVT LTD",
"SUDHIR ENTERPRISES PRIVATE LIMITED",
"SUDHIR FACILITY MANAGEMENT PRIVATE LIMITED",
"SUDHIR FOOD PRODUCTS INDIA LIMITED",
"SUDHIR FOOD PRODUCTS INDIA PRIVATE LIMITED",
"SUDHIR FORGINGS PRIVATE LIMITED",
"SUDHIR LIFE SCIENCES PRIVATE LIMITED",
"SUDHIR MINERALS PRIVATE LIMITED",
"SUDHIR PAPERS PRIVATE LIMITED",
"SUDHIR PHARMACIA PRIVATE LIMITED",
"SUDHIR POWER LIMITED",
"SUDHIR POWER PROJECTS LIMITED",
"SUDHIR SALES & SERVICES LIMITED",
"SUDHIR SHIVARAM PHOTOGRAPHY PRIVATE LIMITED",
"SUDHIR SRIVASTAVA INNOVATIONS PRIVATE LIMITED",
"SUDHIR SWITCHGEARS PRIVATE LIMITED",
"SUDHIR TECHNOLOGIES PRIVATE LIMITED",
"SUDHIR TRANSFORMERS LIMITED",
"SUDHIRA LOGISTICS PRIVATE LIMITED",
"SUDHIRBHAI SAREE WALA PRIVATE LIMITED",
"SUDIN TRAVELS AND FOREX PRIVATE LIMITED",
"SUDISA ENTERPRISES PRIVATE LIMITED",
"SUDISA FOUNDRY PRIVATE LIMITED",
"SUDISA UTILITIES PRIVATE LIMITED",
"SUDITI DESIGN STUDIO LIMITED",
"SUDITI INDUSTRIES LIMITED",
"SUDITI SPORTS APPAREL LIMITED",
"SUDIVA SPINNERS PRIVATE LIMITED",
"SUDLER AND HENNESSEY PRIVATE LIMITED",
"SUDLOWS INDIA PRIVATE LIMITED",
"SUDRAJ PACKERS PRIVATE LIMITED",
"SUDSONS WOOLLENS PRIVATE LIMITED",
"SUDTRAC LINKAGES PRIVATE LIMITED",
"SUDYOG INFRAPROJECTS PRIVATE LIMITED",
"SUEBEL SEALS INTERNATIONAL PRIVATE LIMITED",
"SUEERAA ALLOYS GLOBAL PRIVATE LIMITED",
"SUEERAA ALLOYS PRIVATE LIMITED",
"SUENETZEL SOLUTIONS PRIVATE LIMITED",
"SUEZ INDIA PRIVATE LIMITED",
"SUEZ PROJECTS PRIVATE LIMITED",
"VEOLIA WATER TECHNOLOGIES AND SOLUTIONS",
"SUFAL COMMERCIAL PRIVATE LIMITED",
"SUFALAM INFRA PROJECTS LIMITED",
"SUFALAM SEEDS PRIVATE LIMITED",
"SUFALAM SOLUTIONS PRIVATE LIMITED",
"SUFALAM TECHNOLOGIES PRIVATE LIMITED",
"SUFFA BAKERS INDIA PRIVATE LIMITED",
"SUFFESCOM SOLUTIONS PRIVATE LIMITED",
"SUFI STRUCTURAL TUBES PRIVATE LIMITED",
"SUGA COCO PRODUCTS PRIVATE LIMITED",
"SUGAH HEALTHCORP PRIVATE LIMITED",
"SUGAL & DAMANI FINANCIAL SERVICES LIMITED",
"SUGAL & DAMANI UTILITY SERVICES PRIVATE LIMITED",
"SUGAL AND DAMANI SHARE BROKERS LIMITED",
"SUGAL TRAVELS PRIVATE LIMITED",
"SUGALI ENTERPRISES PRIVATE LIMITED",
"SUGALI FINLEASE PRIVATE LIMITED",
"SUGAM DIAMOND PROJECTS LLP",
"SUGAM EXPRESS PRIVATE LIMITED",
"SUGAM HOLDINGS PVT LTD",
"SUGAM HOSPITAL",
"SUGAM INFRASTRUCTURE LIMITED",
"SUGAM LOGISTIC PRIVATE LIMITED",
"SUGAM PARIVAHAN LIMITED",
"SUGAM PARIVAHAN PRIVATE LIMITED",
"SUGAM PARYAVARAN VIKALP PRIVATE LIMITED",
"SUGAM POLYTECH PRIVATE LIMITED",
"SUGAM SOLAR ENERGY PRIVATE LIMITED",
"SUGAM TECHNOCRATS PRIVATE LIMITED",
"SUGAMBHIKA PHARMACEUTICALS PRIVATE LIMITED",
"SUGAN ENGINEERING PVT LTD",
"SUGAN FINSTOCK PVT LTD",
"SUGAN GOLD PRIVATE LIMITED",
"SUGANDH AUTO STAMPINGS PRIVATE LIMITED",
"SUGANDH SHOPPEE PRIVATE LIMITED",
"SUGANDH TEA PRIVATE LIMITED",
"SUGANDHA STEELS PRIVATE LIMITED",
"SUGANDHAGIRI SPICES PROMOTERS AND TRADERS PRIVATE LIMITED",
"SUGANDHI COLD STORAGE PRIVATE LIMITED",
"SUGANDHI PRESERVATION PRIVATE LIMITED",
"SUGANDHI SNUFF KING PRIVATE LIMITED",
"SUGANDHIM FOOD & CATERING PRIVATE LIMITED",
"SUGANJ ECO CHEMICALS PRIVATE LIMITED",
"SUGAR AND SPICE INDIA PRIVATE LIMITED",
"SUGAR CRAFT PRIVATE LIMITED",
"SUGAR INDUSTRY AND CANE DEVELOPMENT DEPARTMENT",
"SUGAR MEDIAZ PRIVATE LIMITED",
"SUGAR N SPICE RESTAURANTS PRIVATE LIMITED",
"SUGARCANE BREEDING INSTITUTE",
"SUGARCANE MASTER JAGGERY AND ALLIED PRODUCTS PRIVATE LIMITED",
"SUGARKART TECHNOLOGIES PRIVATE LIMITED",
"SUGARNPOWER PROJECTS PRIVATE LIMITED",
"SUGATSUNE KOGYO INDIA PRIVATE LIMITED",
"SUGATU INFRA PRIVATE LIMITED",
"SUGAUTI STONE CRUSHER PRIVATE LIMITED",
"SUGAVANESWARA SPINNING MILLS PRIVATE LIMITED",
"SUGAVYA DAIRY FARMS PRIVATE LIMITED",
"SUGEE DEVELOPER",
"SUGEE DEVELOPERS PRIVATE LIMITED",
"SUGEE REALTY & DEVELOPERS INDIA PRIVATE LIMITED",
"SUGEN PHARMA PRIVATE LIMITED",
"SUGHANDH RESTAURANT PRIVATE LIMITED",
"SUGHNA UTENSILS PRIVATE LIMITED",
"SUGI PRODUCER COMPANY LIMITED",
"SUGII SURGICAL INDIA PRIVATE LIMITED",
"SUGINO MACHINE INDIA PRIVATE LIMITED",
"SUGMYA FINANCE PRIVATE LIMITED",
"SUGNA IMPEX PRIVATE LIMITED",
"SUGNA METALS LIMITED",
"SUGNA SPONGE & POWER PRIVATE LIMITED",
"SUGOI LABS PRIVATE LIMITED",
"SUGOI MOTORS PRIVATE LIMITED",
"SUGOTA VENTURE PRIVATE LIMITED",
"SUGS LLOYD PRIVATE LIMITED",
"SUGUNA DAIRY PRIVATE LIMITED",
"SUGUNA FOODS PRIVATE LIMITED",
"SUGUNA HOLDINGS PRIVATE LIMITED",
"SUGUNA HOSPITAL",
"SUGUNA INTERNATIONAL SCHOOL",
"SUGUNA PIP SCHOOL",
"SUGUNA RAMAIAH HOSPITALS PRIVATE LIMITED",
"SUGUNA RIP V SCHOOL",
"SUHAAN ENTERPRISES PRIVATE LIMITED",
"SUHAG GEMS AND JEWELS INDIA PRIVATE LIMITED",
"SUHAG OVERSEAS TRADING PRIVATE LIMITED",
"SUHAG PRINTS PRIVATE LIMITED",
"SUHAIL ENTERPRISES PRIVATE LIMITED",
"SUHAIL TRADELINK PRIVATE LIMITED",
"SUHALAYA TRAVELS PRIVATE LIMITED",
"SUHAM TRADE LINKS PRIVATE LIMITED",
"SUHAN AVIATION PRIVATE LIMITED",
"SUHAN PACK TECH PRIVATE LIMITED",
"SUHAN VENTURES PRIVATE LIMITED",
"SUHANA MARKETING PRIVATE LIMITED",
"SUHANA MASALE",
"SUHANA MERCHANDISE PRIVATE LIMITED",
"SUHANA PRAVIN MASALEWALE",
"SUHANA SYNERGIES PRIVATE LIMITED",
"SUHANI ALLOYS PRIVATE LIMITED",
"SUHANI FASHIONS PRIVATE LIMITED",
"SUHANI HOMES PRIVATE LIMITED",
"SUHANI KNITFAB PRIVATE LIMITED",
"SUHANI MALL MANAGEMENT COMPANY PRIVATE LIMITED",
"SUHANI METACAST PRIVATE LIMITED",
"SUHANS CHEMICALS PRIVATE LIMITED",
"SUHARA POWERLINE PRIVATE LIMITED",
"SUHARSHA MINERALS PRIVATE LIMITED",
"SUHASINI SPINNERS LIMITED........",
"SUHASINI TEXTILE PRIVATE LIMITED",
"SUHNER INDIA PRIVATE LIMITED",
"SUHORA TECHNOLOGIES PRIVATE LIMITED",
"SUI GENERIS CONSULTING PRIVATE LIMITED",
"SUIDHAGGA FASHIONS PRIVATE LIMITED",
"SUIJJIN SHIPPING PRIVATE LIMITED",
"SUJA LIFESTYLES PRIVATE LIMITED",
"SUJA SHOEI INDUSTRIES PRIVATE LIMITED",
"SUJAG CORPORATE SERVICES PRIVATE LIMITED",
"SUJAG FINE CHEMICALS PRIVATE LIMITED",
"SUJAG TEXTILE PRIVATE LIMITED",
"SUJAKO INTERIORS PRIVATE LIMITED",
"SUJAL ADVERTISERS PRIVATE LIMITED",
"SUJAL DYECHEM PRIVATE LIMITED",
"SUJAL ENVIROTECH PRIVATE LIMITED",
"SUJAL EXIM INDIA PRIVATE LIMITED",
"SUJAL LOGISTICS PRIVATE LIMITED",
"SUJALA INVESTMENTS PRIVATE LIMITED",
"SUJALA PIPES PVT.LTD.",
"SUJALA TRADING AND HOLDINGS LTD",
"SUJALI TEA & INDUSTRIES LIMITED.",
"SUJALI TRADELINK PRIVATE LIMITED",
"SUJAN BUILDERS PRIVATE LIMITED",
"SUJAN CHEMOPLAST PRIVATE LIMITED",
"SUJAN CONTITECH AVS PRIVATE LIMITED",
"SUJAN IMPEX PRIVATE LIMITED",
"SUJAN INDUSTRIES",
"SUJAN LUXURY HOSPITALITY PRIVATE LIMITED",
"SUJAN MARKETING PVT LTD",
"SUJAN MULTIPORTS LIMITED",
"SUJAN TIMBER TRADERS PRIVATE LIMITED",
"SUJANA TRADE (INDIA) PRIVATE LIMITED",
"SUJANAND ENGINEERS & CONTRACTORS PRIVATE LIMITED",
"SUJANIX PRIVATE LIMITED",
"SUJAS LEATHER CLOTH MANUFACTURING COMPANY PRIVATE LIMITED",
"SUJASH STEEL AND IRON PRIVATE LIMITED",
"SUJATA CARBONS PRIVATE LIMITED",
"SUJATA COMPUTERS PRIVATE LIMITED",
"SUJATA ELECTRIC PVT. LTD.",
"SUJATA FABS PRIVATE LIMITED",
"SUJATA FORGE PRIVATE LIMITED",
"SUJATA HOTEL PRIVATE LIMITED",
"SUJATA NUTRI-PHARMA PRIVATE LIMITED",
"SUJATA SALES & SERVICES PRIVATE LIMITED",
"SUJATA SYNTHETICS LIMITED",
"SUJATA TRADING PRIVATE LIMITED",
"SUJATA UDIT BUILDERS PRIVATE LIMITED",
"SUJATHA FEEDS PRIVATE LIMITED",
"SUJAY ESTATES PRIVATE LIMITED",
"SUJAY HOSPITAL KPRIVATE LIMITED",
"SUJAY IRRIGATIONS PRIVATE LIMITED SIPL",
"SUJAY SALUNKESCOS 18 NETWORKING PRIVATE LIMITED",
"SUJAY SHAH ENERGY VENTURES PRIVATE LIMITED",
"SUJAY SOFTTECH PRIVATE LIMITED",
"SUJAYA ENTERPRISES PRIVATE LIMITED",
"SUJAY'S DENTAL CARE (OPC) PRIVATE LIMITED",
"SUJE TEX PRIVATE LIMITED",
"SUJEET INDUSTRIES PRIVATE LIMITED",
"SUJEEVAN ENVIRO PRIVATE LIMITED",
"SUJITHA COTTON MILLS PRIVATE LIMITED",
"SUJIVAN HEALTHCARE PRIVATE LIMITED",
"SUJORA SHIPPING PRIVATE LIMITED",
"SUJYOTI FININVEST PRIVATE LIMITED",
"SUJYOTI INDIA PRIVATE LIMITED",
"SUKAMAL FINSERVE PRIVATE LIMITED",
"SUKAN ENGINEERING PRIVATE LIMITED",
"SUKAN INDUSTRIAL MARKETING PRIVATE LIMITED",
"SUKAN MARKETING PRIVATE LIMITED",
"SUKANI ENTERPRISES PRIVATE LIMITED",
"SUKANI HR MANAGEMENT PRIVATE LIMITED",
"SUKANYA ENGINEERING & INFRA PRIVATE LIMITED",
"SUKARMA FACILITY MANAGEMENT PRIVATE LIMITED",
"SUKASHI ENTERPRISE PRIVATE LIMITED",
"SUKASO CERACOLORS PRIVATE LIMITED",
"SUKATA TRACTOR PARTS PRIVATE LIMITED",
"SUKAVALA RENEWABLE ENERGY PRIVATE LIMITED",
"SUKCHAIN PROPERTIES PVT LTD",
"SUKDEVPUR QUAZIPARA MILANI VIDYAPITH HS",
"SUKDHA INDUSTRIES PRIVATE LIMITED",
"SU-KEERTHI CONSTRUCTION & PROPERTIES PRIVATE LIMITED",
"SUKESH INDUSTRIES PRIVATE LIMITED",
"SUKESH KUMAR PRIVATE LIMITED",
"SUKESHAN EQUIPMENTS PVT LTD",
"SUKET CONSTRUCTION COMPANY PRIVATE LIMITED",
"SUKETU ORGANICS PRIVATE LIMITED",
"SUKH HOTELS MOTELS PRIVATE LIMITED",
"SUKH SAGAR SYNTHETICS PRIVATE LIMITED",
"SUKH SAROJ JEWELLERS PRIVATE LIMITED",
"SUKH STEELS PRIVATE LIMITED",
"SUKHAKARTA GENERAL ENGINEERING CLUSTER PRIVATE LIMITED",
"SUKHAM DYEING & PRINTING MILLS PRIVATE LIMITED",
"SUKHAM HOSPITAL",
"SUKHAM PROPERTIES PRIVATE LIMITED",
"SUKHANAND INFRA PRIVATE LIMITED",
"SUKHAR ENGINEERING PRIVATE LIMITED",
"SUKHAYU AGRO PRODUCER COMPANY LIMITED",
"SUKHAYU HEALTH CARE PRIVATE LIMITED",
"SUKHBIR AGRO ENERGY LIMITED",
"SUKHBIR SOLAR ENERGY PRIVATE LIMITED",
"SUKHCHAIN HIRE PURCHASE PRIVATE LIMITED",
"SUKHDA HOSPITAL",
"SUKHDATA FOODS PRIVATE LIMITED",
"SUKHDEV AND KAMAL SHARMA EDUCATIONAL TRUST",
"SUKHDEV EXPLOSIVES PVT LTD",
"SUKHDEV INTERNATIONAL PRIVATE LIMITED",
"SUKHDEV VAISHNO DHABA",
"SUKHDEVRAJ SHARMA ENGINEERS AND CONTRACTORS PRIVATE LIMITED",
"SUKHDHAM HOSPITALITY PRIVATE LIMITED",
"SUKHESH MARKETING PRIVATE LIMITED",
"SUKHI FACILITY SERVICES PRIVATE LIMITED",
"SUKHI INDIA PRIVATE LIMITED",
"SUKHIA PLAST PRIVATE LIMITED",
"SUKHIBHAVA BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"SUKHIJA BAR & GRILL PRIVATE LIMITED",
"SUKHIJA GARMENTS PRIVATE LIMITED",
"SUKHIJA REAL ESTATES PVT LTD",
"SUKHIM CONSTRUCTION ENGINEERING PRIVATE LIMITED",
"SUKHINO CROP SCIENCE PRIVATE LIMITED",
"SUKHJIT MEGA FOOD PARK & INFRA LIMITED",
"SUKHJIT STARCH & CHEMICALS LIMITED",
"SUKHKARTA ADVANCED DIAGNOSTIC CENTRE PRIVATE LIMITED",
"SUKHMAA BUILDCON PRIVATE LIMITED",
"SUKHMANI COTTON INDUSTRIES",
"SUKHMANI FOREX SERVICES PRIVATE LIMITED",
"SUKHMANI GASES INDIA PRIVATE LIMITED",
"SUKHMANI HEALTH CARE PRIVATE LIMITED",
"SUKHMANI HOLIDAYS-INN PRIVATE LIMITED",
"SUKHMANI INFOTECH PRIVATE LIMITED",
"SUKHMANI MOTORS PRIVATE LIMITED",
"SUKHMANI PROPMART PRIVATE LIMITED",
"SUKHMANI SUDARSHAN SAREES PRIVATE LIMITED",
"SUKHMEHAR FINANCE PRIVATE LIMITED",
"SUKHNA PLYWOOD PRIVATE LIMITED",
"SUKHNAG ENTERPRISES PRIVATE LIMITED",
"SUKHO THAI INDIA PRIVATE LIMITED",
"SUKHOCHAYA TRADING PRIVATE LIMITED",
"SUKHRAJ JEWELLS PRIVATE LIMITED",
"SUKHRAS MACHINES PRIVATE LIMITED",
"SUKHSAGAR COMPLEXES PRIVATE LIMITED",
"SUKHSAGAR FABCRAFT PRIVATE LIMITED",
"SUKHSAGAR FOOD PRIVATE LIMITED",
"SUKHSHANTI TRADELINK (INDIA) PRIVATE LIMITED",
"SUKHVARSHA FURNISHINGS PRIVATE LIMITED",
"SUKHVARSHA MANAGEMENT SERVICES PRIVATE LIMITED",
"SUKHVARSHA PROJECTS PRIVATE LIMITED",
"SUKHWANI CHAWLA ERECTORS PRIVATE LIMITED",
"SUKI CREATIONS PRIVATE LIMITED",
"SUKI SUPPLYCHAIN SOLUTIONS PRIVATE LIMITED",
"SUKI TEXPARTS PRIVATE LIMITED",
"SUKI WATER SOLUTIONS PRIVATE LIMITED",
"SUKIMOS MEDICAL PRIVATE LIMITED",
"SUKINO HEALTHCARE SOLUTIONS PRIVATED LIMITED",
"SUKIR CONSULTING ENGINEERS PRIVATE LIMITED",
"SUKIRTI PACKAGING PRIVATE LIMITED",
"SUKKHI ONLINE PRIVATE LIMITED",
"SUKLAI TEA COMPANY PRIVATE LIMITED",
"SUKNA TEA & INDUSTRIES LTD.",
"SUKONI MODULAR SYSTEMS P.LTD.",
"SUKOON DEVELOPERS PRIVATE LIMITED",
"SUKOON HEALTHCARE SERVICES PRIVATE LIMITED",
"SUKOON SOLUTIONS PRIVATE LIMITED",
"SUKRA CULINARY ARTS PRIVATE LIMITED",
"SUKRA PROPERTY DEVELOPERS PRIVATE LIMITED",
"SUKRAA SOFTWARE SOLUTION PRIVATE LIMITED",
"SUKRAFT PAPER MILLS PRIVATE LIMITED",
"SUKRAFT RECYCLING PRIVATE LIMITED",
"SUKRALA IT SERVICES PRIVATE LIMITED",
"SUKRIT CYLINDERS PRIVATE LIMITED",
"SUKRIT INDUSTRIES PRIVATE LIMITED",
"SUKRITA BUILDERS PRIVATE LIMITED",
"SUKRITI ENTERPRISES PRIVATE LIMITED",
"SUKRITI FOODS PRIVATE LIMITED",
"SUKRITI FOREX AND TRAVEL PRIVATE LIMITED",
"SUKRITI HELPLINE SOLUTIONS PRIVATE LIMITED",
"SUKRITI HOUSING INDUSTRIES PRIVATE LIMITED",
"SUKRITI REALCON PRIVATE LIMITED",
"SUKRITI TRADE PRIVATE LIMITED",
"SUKRIYA.COM",
"SUKRT RETAIL PRIVATE LIMITED",
"SUKRTA TECHNOLOGIES PRIVATE LIMITED",
"SUKRUPA EDUCATION CENTRE",
"SUKRUT ELECTRIC COMPANY PRIVATE LIMITED",
"SUKRUT UV SYSTEMS PRIVATE LIMITED",
"SUKRUTHI FINANCIAL SERVICES PRIVATE LIMITED",
"SUKRUTI MACHINE TOOLS PRIVATE LIMITED",
"SUKSH TECHNOLOGY PRIVATE LIMITED",
"SUKSHA DEVELOPERS PRIVATE LIMITED",
"SUKSHEMA HOSPITAL PRIVATE LIMITED",
"SUKSHETRA INFRA PROJECTS PRIVATE LIMITED",
"SUKSHI TECHNOLOGY INNOVATION PRIVATE LIMITED",
"SUKU COIL HANDLING PRIVATE LIMITED",
"SUKU CONTROLS PRIVATE LIMITED",
"SUKU INFRACON PRIVATE LIMITED",
"SUKUMAR COIR INDIA PRIVATE LIMITED",
"SUKUMAR SOLVENT PRIVATE LIMITED",
"SUKUMAR TOWNSHIP DEVELOPMENT PVT.LTD",
"SUKUN PACKAGING",
"SUKUN SEEDS PRIVATE LIMITED",
"SUKUSHI INFRASTRUCTURE PRIVATE LIMITED",
"SUKVEN INFRASTRUCTURE PRIVATE LIMITED",
"SUL STEEL PRIVATE LIMITED",
"SULA VINEYARDS",
"SULA VINEYARDS LIMITED",
"SULABH INDUSTRIES & WAREHOUSING PRIVATE LIMITED",
"SULABH INTERNATIONAL SOCIAL SERVICE ORGANISATION",
"SULABHA MARKETING PRIVATE LIMITED",
"SULAKI CHEMICAL PVT LTD",
"SULAKSHA CONSTRUCTIONS PRIVATE LIMITED",
"SULAKSHANA SECURITIES LIMITED",
"SULAKSHNA WIRES PRIVATE LIMITED",
"SULEKHA.COM NEW MEDIA PRIVATE LIMITED",
"SULEKHRAM STEELS PRIVATE LIMITED",
"SULEMANI FOREX AND TRAVELS PRIVATE LIMITED",
"SULFAST CHEMICAL INDUSTRIES",
"SULFOZYME AGRO (INDIA) PRIVATE LIMITED",
"SULK SERVICES PRIVATE LIMITED",
"SULOACHNA ORGANIC PRIVATE LIMITED",
"SULOCHAN RETINA CARE CENTRE JALGAON",
"SULOCHANA AGRO AND INFRATECH PRIVATE LIMITED",
"SULOCHANA COTTON SPINNING MILLS PRIVATE LIMITED",
"SULOCHNA RETAIL MART PRIVATE LIMITED",
"SULPHUR CROP CARE PRIVATE LIMITED",
"SULPHUR TECHNOLOGIES OPC PRIVATE LIMITED",
"SULSON OVERSEAS PRIVATE LIMITED",
"SULTAN APPARELS PRIVATE LIMITED",
"SULTAN CHAND AND SONS PRIVATE LIMITED",
"SULTAN TANNERIES AND LEATHER PRODUCTS PRIVATE LIMITED",
"SULTAN UL ULOOM COLLEGE OF BUSINESS ADM",
"SULTAN UL ULOOM JUNIOR COLLEGE",
"SULTAN UL-LOOM JR COLLEGE",
"SULTANGACHA HIGH SCHOOL",
"SULTANIA CARRIERS PRIVATE LIMITED",
"SULTANIA LADY HOSPITAL",
"SULTANIA MARBLES & TILES PVT LTD",
"SULTANIA OIL INDUSTRIES PRIVATE LIMITED",
"SULTANIA TRADE PRIVATE LIMITED",
"SULTANPUR BUILDERS AND SUPPLIERS PRIVATE LIMITED",
"SULTANPURE TEXTILE MILLS PRIVATE LIMITED",
"SULTHAN GOLD PRIVATE LIMITED",
"SULTHAN RETAIL LLP",
"SULUX PHOSPHATES LTD",
"SULZER INDIA PRIVATE LIMITED",
"SULZER PROCESSORS PRIVATE LIMITED",
"SULZER PUMPS INDIA PRIVATE LIMITED",
"SULZER TECH INDIA PRIVATE LIMITED",
"SULZRO SUITINGS PRIVATE LIMITED",
"SUM DECOR PRIVATE LIMITED",
"SUM OVERSEAS PRIVATE LIMITED",
"SUM ULTIMATE MEDICARE",
"SUMA AGRO INDIA PRIVATE LIMITED",
"SUMA CHEMICALS PVT LTD",
"SUMA ENCON PROJECTS PRIVATE LIMITED",
"SUMA INFOTECH PRIVATE LIMITED",
"SUMA LABORATORIES PRIVATE LIMITED",
"SUMA MINERALS PRIVATE LIMITED",
"SUMA PHARMACEUTICALS PRIVATE LIMITED",
"SUMA SHILP LIMITED",
"SUMA SOFT PRIVATE LIMITED",
"SUMA SPRINGS PRIVATE LIMITED",
"SUMA TRADEX PRIVATE LIMITED",
"SUMAANYA DEVELOPERS PRIVATE LIMITED",
"SUMAC KITCHEN LLP",
"SUMAC PHARMA PRIVATE LIMITED",
"SUMADHU TRADERS PRIVATE LIMITED",
"SUMADHURA GEOMATICA PRIVATE LIMITED",
"SUMADHURA INFRACON PRIVATE LIMITED",
"SUMAIYAH DISTRIBUTORS PRIVATE LIMITED",
"SUMAJA ELECTROINFRA PRIVATE LIMITED",
"SUMAN AGRO & FOOD PROCESSING PRIVATE LIMITED",
"SUMAN ASSOCIATES",
"SUMAN COMPUTERS PRIVATE LIMITED",
"SUMAN CONTROLS PRIVATE LIMITED",
"SUMAN CORRUGATION PRIVATE LIMITED",
"SUMAN ELECTRIC UDYOGS PRIVATE LIMITED",
"SUMAN ELECTRICALS & CONSTRUCTIONS PRIVATE LIMITED",
"SUMAN ENGINEERING AND CHEMICALS PRIVATE LIMITED",
"SUMAN EQUITRADE PRIVATE LIMITED",
"SUMAN FORWARDING AGENCY PRIVATE LIMITED",
"SUMAN HATCHERIES LIMITED.",
"SUMAN HATCHERIES PRIVATE LIMITED",
"SUMAN HOMETEX PRIVATE LIMITED",
"SUMAN HOSPITAL",
"SUMAN INDUSTRIAL PRODUCTS PRIVATE LIMITED",
"SUMAN INDUSTRIES PVT LTD",
"SUMAN INFO HEALTH CARE PRIVATE LIMITED",
"SUMAN JEWELLERY",
"SUMAN KAMAL FARMS PRIVATE LIMITED",
"SUMAN MARBLE INDUSTRIES PRIVATE LIMITED",
"SUMAN MFG. WORKS PRIVATE LIMITED",
"SUMAN MODERN RICE MILL PRIVATE LIMITED",
"SUMAN POLY SILK PRIVATE LIMITED",
"SUMAN POLYMERS PRIVATE LIMITED",
"SUMAN POULTARY FARMINGS PRIVATE LIMITED",
"SUMAN PRESERVATIVE FOODS PRIVATE LIMITED",
"SUMAN PRODUCTS PRIVATE LIMITED",
"SUMAN PROTEINS PRIVATE LIMITED",
"SUMAN RAMESH TULSIANI TECHNICAL CAMPUS",
"SUMAN SHUDHA ABHARANA PRIVATE LIMITED",
"SUMAN TECHNOBUILD PRIVATE LIMITED",
"SUMAN TRADINVEST PRIVATE LIMITED",
"SUMAN UDYOG PRIVATE LIMITED",
"SUMAN VINIMAY PRIVATE LIMITED",
"SUMANAM ENGINEERING SERVICES PRIVATE LIMITED.",
"SUMANAS TECHNOLOGIES PRIVATE LIMITED",
"SUMANDEEP MULTIPURPOSE LIMITED",
"SUMANDEEP VIDYAPEETH DEEMED TO BE UNIVERSIY",
"SUMANGAL BUILDTECH PRIVATE LIMITED",
"SUMANGAL CASTINGS PRIVATE LIMITED",
"SUMANGAL DYEING AND PRINTING MILLS PRIVATE LIMITED",
"SUMANGAL ELECTRONICS PRIVATE LIMITED",
"SUMANGAL FASHIONS PRIVATE LIMITED",
"SUMANGAL FIBRES PVT LTD",
"SUMANGAL FOREX & TRAVELS PRIVATE LIMITED",
"SUMANGAL FORGINGS PVT LTD",
"SUMANGAL GLASS PRIVATE LIMITED",
"SUMANGAL HR SERVICES PRIVATE LIMITED",
"SUMANGAL ISPAT PRIVATE LIMITED",
"SUMANGAL PETROCHEMICALS PRIVATE LIMITED",
"SUMANGAL POLYMERS PRIVATE LIMITED",
"SUMANGAL PRESS PRIVATE LIMITED",
"SUMANGAL SHARES & SECURITIES PRIVATE LIMITED",
"SUMANGAL SILK MILLS PRIVATE LIMITED",
"SUMANGAL SOFTWARE PRIVATE LIMITED",
"SUMANGAL TECHNOCAST PRIVATE LIMITED",
"SUMANGAL TIE UP PRIVATE LIMITED",
"SUMANGALA STEEL PRIVATE LIMITED",
"SUMANGALAM ALUMINIUM EXTRUSIONS PRIVATE LIMITED",
"SUMANGALAM DISTRIBUTOR PRIVATE LIMITED",
"SUMANGALAM EXPORTS PVT LTD",
"SUMANGALAM FINANCIAL CONSULTANCY PRIVATE LIMITED",
"SUMANGALAM GOLD CREATIONS PRIVATE LIMITED",
"SUMANGALAM GOLD JEWELLERS PRIVATE LIMITED",
"SUMANGALAM INDUSTRIES PRIVATE LIMITED",
"SUMANGALAM JEWELLERS PRIVATE LIMITED",
"SUMANGALAM METALIC PRIVATE LIMITED",
"SUMANGALAM REALTECH PRIVATE LIMITED",
"SUMANGALAM RETAILERS PRIVATE LIMITED",
"SUMANGALAM SUITINGS PRIVATE LIMITED",
"SUMANGALI PROPERTIES PRIVATE LIMITED",
"SUMANGLA DEVELOPERS AND FARMS PRIVATE LIMITED",
"SUMANGLAM CONCRETE PRODUCTS PRIVATE LIMITED",
"SUMANGLAM EQUIPMENTS PRIVATE LIMITED",
"SUMANGLAM INTERNATIONAL PRIVATE LIMITED",
"SUMANGLAM WOOD PRODUCTS I PRIVATE. LIMITED.",
"SUMANIA EXPORTS PRIVATE LIMITED",
"SUMANJALI PARBOILED PRIVATE LIMITED",
"SUMANKIRTI CARS PRIVATE LIMITED",
"SUMANLATA HOSPITALITY SERVICES PRIVATE. LIMITED.",
"SUMANT AGROTECH PRIVATE LIMITED",
"SUMANT INVESTMENTS PVT.LTD.",
"SUMANT JAYAKRISHNAN DESIGN PRIVATE LIMITED",
"SUMANTA SUSANTA EXPORTS PVT LTD.",
"SUMANTA SUSANTA OVERSEAS PVT LTD",
"SUMANTH HOLDINGS PRIVATE LIMITED",
"SUMANTRA TECH SERVICES PRIVATE LIMITED",
"SUMARAN PROJECTS PRIVATE LIMITED",
"SUMARIA APPLIANCES PRIVATE LIMITED",
"SUMARIA INDUSTRIES PRIVATE LIMITED",
"SUMATHI CORPORATE SERVICES PRIVATE LIMITED",
"SUMATHI HOMES & DEVELOPERS PRIVATE LIMITED",
"SUMATHI SEEDS PRIVATE LIMITED",
"SUMATI CYCLES PRIVATE LIMITED",
"SUMATI ELECTRONICS PRIVATE LIMITED",
"SUMATI LEGAL SERVICES PRIVATE LIMITED",
"SUMATI NEUROLOGY CLINIC PRIVATE LIMITED",
"SUMATI PLASTIC PRIVATE LIMITED",
"SUMATI POLYFIBERS PRIVATE LIMITED",
"SUMATI PRINTS PRIVATE LIMITED",
"SUMATI SOLUTIONS PRIVATE LIMITED",
"SUMATI SPINTEX PRIVATE LIMITED",
"SUMATI VINYL PRIVATE LIMITED",
"SUMATIBHAI SHAH AYURVED MAHAVIDYALAYA",
"SUMATICHAND GOUTI JEWELLERS PRIVATE LIMITED",
"SUMATINATH POLYPACK PRIVATE LIMITED",
"SUMATO GLOBALTECH PRIVATE LIMITED",
"SUMAX ENGINEERING PRIVATE LIMITED",
"SUMAX ENTERPRISES PRIVATE LIMITED",
"SUMBHARTIYA AGRO PRIVATE LIMITED",
"SUMCONCEPTS TECHNOLOGIES PRIVATE LIMITED",
"SUMECH ENGINEERS PVT LTD",
"SUMECO METAL PRESSING PRIVATE LIMITED",
"SUMEDH TOOLS PRIVATE LIMITED",
"SUMEDHA ENTERPRISES PRIVATE LIMITED",
"SUMEDHA FISCAL SERVICES LIMITED",
"SUMEDHA INFRA PROJECTS PRIVATE LIMITED",
"SUMEDHA SOFTTECH PRIVATE LIMITED",
"SUMEDHA VEHICLES PRIVATE LIMITED",
"SUMEDHAS TECH SOLUTIONS PRIVATE LIMITED",
"SUMEERA FOOD PRODUCTSS PRIVATE LIMITED",
"SUMEET BAJORIYA INFRASTRUCTURE PRIVATE LIMITED",
"SUMEET BROKERAGE AND SECURITIES PRIVATE LIMITED",
"SUMEET FACILITIES LIMITED",
"SUMEET FIRE ENGINEERS PRIVATE LIMITED",
"SUMEET GEMS AND JEWELLERS PRIVATE LIMITED",
"SUMEET GREEN ENVIRO SERVICES PRIVATE LIMITED",
"SUMEET INDUSTRIES LIMITED.",
"SUMEET INFRACON PRIVATE. LIMITED.",
"SUMEET INFRAVENTURES PRIVATE LIMITED",
"SUMEET INTERNATIONAL PRIVATE LIMITED",
"SUMEET POLY POWER LIMITED.",
"SUMEET SCREWS PRIVATE LIMITED",
"SUMEET SYNFAB INDIA PRIVATE LIMITED",
"SUMEET TRANS LOGISTICS PRIVATE LIMITED",
"SUMEET URBAN SERVICES (CHENNAI) V PRIVATE LIMITED",
"SUMEET URBAN SERVICES CHENNAI II PRIVATE LIMITED",
"SUMEL INDUSTRIES INFRATECH PRIVATE LIMITED",
"SUMELA EXPORTS PRIVATE LIMITED",
"SUMER BUILDERS PRIVATE LIMITED",
"SUMER INTERIORS PRIVATE LIMITED",
"SUMER SONS AUTOTECH PRIVATE LIMITED",
"SUMER SONS PRIVATE LIMITED",
"SUMERTI INDUSTRIES PRIVATE LIMITED",
"SUMERU AVIATION SERVICES PRIVATE LIMITED",
"SUMERU BUILDCON PRIVATE LIMITED",
"SUMERU DEVELOPERS",
"SUMERU ENERGY PRIVATE LIMITED",
"SUMERU ENTERPRISE TIGER BUSINESS SOLUTIONS PRIVATE LIMITED",
"SUMERU ESTATES PRIVATE LIMITED",
"SUMERU GLOBAL TECHNOLOGIES PRIVATE LIMITED",
"SUMERU HOSPITALITY PRIVATE LIMITED",
"SUMERU MICROWAVE COMMUNICATIONS PRIVATE LIMITED",
"SUMERU PACKAGINGS PRIVATE LIMITED",
"SUMERU RESOURCES PRIVATE LIMITED",
"SUMERU SALES PRIVATE LIMITED",
"SUMERU SOFT PRIVATE LIMITED",
"SUMERU SOFTWARE SOLUTIONS PRIVATE LIMITED",
"SUMERU SUPPLIERS & TRADERS PRIVATE LIMITED",
"SUMERU TRADELINK PRIVATE LIMITED",
"SUMERU VINIMAY PRIVATE LIMITED",
"SUMESH ENGINEERS PRIVATE LIMITED",
"SUMESH PETROLEUM PRIVATE LIMITED",
"SUMETCO ALLOYS PRIVATE LIMITED",
"SUMEX PETROCHEM PRIVATE LIMITED",
"SUMFONL AUTO TRADERS PRIVATE LIMITED",
"SUMHITHA POLYFABRICS PRIVATE LIMITED",
"SUMHR SOFTWARE PRIVATE LIMITED",
"SUMI COLLECTION PRIVATE LIMITED",
"SUMI CYCLO DRIVE INDIA PRIVATE LIMITED",
"SUMI MERCANTILE COMPANY PVT LTD",
"SUMI YASHSHREE HOTELS & RESORTS PRIVATE LIMITED",
"SUMICHEM ORGANICS PRIVATE LIMITED",
"SUMIKA POLYMER COMPOUNDS (INDIA) PRIVATE LIMITED",
"SUMIKA POLYMER COMPOUNDS INDIA PRIVATE LIMITED",
"SUMIKA SEALS PRIVATE LIMITED",
"SUMIL CHEMICAL INDUSTRIES PRIVATE LIMITED",
"SUMIL TRADING PRIVATE LIMITED",
"SUMILAX SMT TECHNOLOGIES PRIVATE LIMITED",
"SUMILON INDUSTRIES LIMITED",
"SUMILON INDUSTRIES PRIVATE LIMITED",
"SUMILON POLYESTER PRIVATE LIMITED",
"SUMINDEX SOLUTIONS LLP",
"SUMINOE TEIJIN TECHNO KRISHNA INDIA PRIVATE LIMITED",
"SUMINTER INDIA ORGANICS PRIVATE LIMITED",
"SUMIP COMPOSITES PRIVATE LIMITED",
"SUMIRAN ASSOCIATES",
"SUMIRAN FOODS PRIVATE LIMITED",
"SUMIRAN MASTERBATCH PRIVATE LIMITED",
"SUMISHO AGRO INDIA PRIVATE LIMITED",
"SUMIT AUTO ELECTRICALS PRIVATE LIMITED",
"SUMIT CREATION PRIVATE LIMITED",
"SUMIT DIAMOND INDIA PVT LTD",
"SUMIT ENGG (INDIA) PRIVATE LIMITED",
"SUMIT ENTERPRISES",
"SUMIT GAS AGENCIES PRIVATE LIMITED",
"SUMIT GLASSES PVT LTD",
"SUMIT INDUSTRIESLIMITED",
"SUMIT INFRA SUPPLIERS PRIVATE LIMITED",
"SUMIT LOGISTIC PRIVATE LIMITED",
"SUMIT MATUNGA BUILDERS PRIVATE LIMITED",
"SUMIT MEDICAL DEVICES PRIVATE LIMITED",
"SUMIT MHATRE INFRASTRUCTURE PRIVATE LIMITED",
"SUMIT PHARMACEUTICALS PRIVATE LIMITED",
"SUMIT POLYCOT PRIVATE LIMITED",
"SUMIT PRAGATI SHELTERS LLP",
"SUMIT PRECISION FASTENERS PRIVATE LIMITED",
"SUMIT PROJECTS PVT LTD",
"SUMIT RESORTS AND FARMS PRIVATE LIMITED",
"SUMIT SERVICE",
"SUMIT SU APPARELS PRIVATE LIMITED",
"SUMIT TEXSPIN PRIVATE LIMITED",
"SUMIT TEXTILE INDUSTRIES",
"SUMIT UDYOG PRIVATE LIMITED",
"SUMIT WOOL PROCESSORS",
"SUMITA TEX SPIN PRIVATE LIMITED",
"SUMITEK NATRAJ MACHINERY PRIVATE LIMITED",
"SUMITH ELECTRONICS PRIVATE LIMITED",
"SUMITHRA HOSPITALS PRIVATE LIMITED",
"SUMITI ALLOYS PRIVATE LIMITED",
"SUMITOMO CHEMICAL INDIA LIMITED",
"SUMITOMO CHEMICAL INDIA PRIVATE LIMITED",
"SUMITOMO CORPORATION INDIA PRIVATE LIMITED",
"SUMITRA CONSULTANTS INDIA PRIVATE LIMITED",
"SUMITRA D S MOTORS PRIVATE LIMITED",
"SUMITRA MALHOTRA ENTERPRISES PRIVATE LIMITED",
"SUMITRA NURSING AND MATERNITY HOME LIMITED",
"SUMITRA RICE MILL PRIVATE LIMITED",
"SUMITRA SILK MILLS PRIVATE LIMITED",
"SUMITRA SONS",
"SUMITRA WOODCRAFT PRIVATE LIMITED",
"SUMITRON EXPORTS PRIVATE LIMITED",
"SUMIX AQUA SPORTS PRIVATE LIMITED",
"SUMKESH TRADING PRIVATE LIMITED",
"SUMMA REAL MEDIA PRIVATE LIMITED",
"SUMMER BLUE CLOTHING PRIVATE LIMITED",
"SUMMER COOL HOME APPLIANCES LIMITED",
"SUMMER KING ELECTRICALS PRIVATE LIMITED",
"SUMMER SET ENT PRIVATE LIMITED",
"SUMMER VALLEY SCHOOL DEHRADUN",
"SUMMERBORNE SERVICES PRIVATE LIMITED",
"SUMMERDROP ENGINEERS PRIVATE LIMITED",
"SUMMERFIELDS INFRA PRIVATE LIMITED",
"SUMMERRAYS LIFESTYLE PRIVATE LIMITED",
"SUMMIROW DENTAL PRIVATE LIMITED",
"SUMMIT AUTO SEATS INDUSTRY (DELHI) COMPANY PRIVATE LIMITED",
"SUMMIT CARE SERVICES PRIVATE LIMITED",
"SUMMIT CORPORATION PRIVATE LIMITED",
"SUMMIT DEVELOPMENTS PRIVATE LIMITED",
"SUMMIT DIGITEL INFRASTRUCTURE LIMITED",
"SUMMIT ENERGY ANALYTICS LLP",
"SUMMIT ENGINEERING TECHNOLOGY PRIVATE LIMITED",
"SUMMIT ENGINEERS AND CONSULTANTS PRIVATE LIMITED",
"SUMMIT HEALTHCARE PRIVATE LIMITED",
"SUMMIT HOTELS & RESORTS PRIVATE LIMITED",
"SUMMIT INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"SUMMIT IT SOLUTIONS PRIVATE LIMITED",
"SUMMIT JEWELLERY LLP",
"SUMMIT MARINE EXPORTS PRIVATE LIMITED",
"SUMMIT ONLINE TRADE SOLUTIONS PRIVATE LIMITED",
"SUMMIT POWER INDUSTRIES PVT LTD",
"SUMMIT SECURITIES LIMITED",
"SUMMIT SPORTS PRIVATE LIMITED",
"SUMMIT TECHNODYNE PRIVATE LIMITED",
"SUMMIT TERRACRAFT PRIVATE LIMITED",
"SUMMITS HYGRONICS PRIVATE LIMITED",
"SUMMITWORKS TECHNOLOGIES PRIVATE LIMITED",
"SUMO AUTOTECH PRIVATE LIMITED",
"SUMO BISCUITS PRIVATE LIMITED",
"SUMO BUISCUITS PRIVATE LIMITED",
"SUMO ELECTRONICS PRIVATE LIMITED",
"SUMO FOODS PRIVATE LIMITED",
"SUMO HI-TECH MARKETING PRIVATE LIMITED",
"SUMO POLYPLAST PRIVATE LIMITED",
"SUMO STEELS PRIVATE LIMITED",
"SUMO TECHNOLOGIES PRIVATE LIMITED",
"SUMO VIDEO GAMES PRIVATE LIMITED",
"SUMOD FLOUR MILLS PRIVATE LIMITED",
"SUMOHAN PROJECTS PRIVATE LIMITED",
"SUMOKAV PRECISION ENGINEERING PRIVATE LIMITED",
"SUMOLOGIC TECHNOLOGIES PRIVATE LIMITED",
"SUMOTO ELASTOMERS PRIVATE LIMITED",
"SUMPAP LOGISTICS PRIVATE LIMITED",
"SUMPOSITIVE SERVICES PRIVATE LIMITED",
"SUMPRAXIS SERVICES PRIVATE LIMITED",
"SUMPTUOUS DATA SCIENCES PRIVATE LIMITED",
"SUMPUN AUTOMOBILES PRIVATE LIMITED",
"SUMRAN AGRO PRIVATE LIMITED",
"SUMRIDHI ALUMINIUM PRIVATE LIMITED",
"SUMRIT METALIKS PRIVATE LIMITED",
"SUMRUDHA HOTEL PRIVATE LIMITED",
"SUMTECH DIGITAL WORLD PRIVATE LIMITED",
"SUMTINATH REAL ESTATE PRIVATE LIMITED",
"SUMTOTAL SYSTEMS INDIA PRIVATE LIMITED",
"SUMUKA STEELS PRIVATE LIMITED",
"SUMUKHA AUTOMATION PRIVATE LIMITED",
"SUMUKHA ENGINEERING PRIVATE LIMITED",
"SUMUKHA ENTERPRISES PRIVATE LIMITED",
"SUMUKHA FARM PRODUCTS PRIVATE LIMITED",
"SUMUKHA SURGICALS INDIA PRIVATE LIMITED",
"SUMUKHA TECHNOLOGIES & SOFTWARE PRIVATE LIMITED",
"SUMUKHA WAY2HUNT PRIVATE LIMITED",
"SUMUKHAH TRADING PRIVATE LIMITED",
"SUMULAS COLOUR LAB",
"SUN & JAY ENGINEERING CONSULTANTS PRIVATE LIMITED",
"SUN & SURF LEISURE PRIVATE LIMITED",
"SUN (TAMILNADU) SECURITY MANAGEMENT SERVICES PRIVATE LIMITED",
"SUN ACE CHEMICAL (INDIA) PRIVATE LIMITED",
"SUN ACRYLAM PRIVATE LIMITED",
"SUN AEROSPACE SYSTEMS LIMITED",
"SUN AIRVOICE PRIVATE LIMITED",
"SUN ALPHATEC MOULDS (INDIA) PRIVATE LIMITED",
"SUN AND MOON TRAVELS (INDIA) PRIVATE LIMITED",
"SUN AND OCEAN AGRO (INDIA) PRIVATE LIMITED",
"SUN AND SNOW RESORTS LIMITED",
"SUN AND SUN CATTLE FEED PRATIVE LIMITED",
"SUN ANIMAL FEEDS PRIVATE LIMITED",
"SUN AQUATIC PRODUCTS PRIVATE LIMITED",
"SUN ARK ALUMINIUM INDUSTRIES PRIVATE. LIMITED.",
"SUN ASTRA ENERGY SOLUTIONS PRIVATE LIMITED",
"SUN AUTOMAT CONTROLS PRIVATE LIMITED",
"SUN BIO IT SOLUTIONS PRIVATE LIMITED",
"SUN BIO NATURALS INDIA PRIVATE LIMITED",
"SUN BIOCEUTICALS PRIVATE LIMITED",
"SUN BRANDING SOLUTION INDIA PRIVATE LIMITED",
"SUN BRASS INDIA PRIVATE LIMITED",
"SUN BRIGHT HEAT TREATMENT PRIVATE LIMITED",
"SUN BRIGHT MANPOWER SOLUTIONS PRIVATE LIMITED",
"SUN BRIGHT TREXIM PVT. LTD.",
"SUN BROADCAST EQUIPMENTS PRIVATE LIMITED",
"SUN BUILDERS PRIVATE LIMITED",
"SUN BUILDWELL PROPERTIES PRIVATE LIMITED",
"SUN BUSINESS SOLUTION PRIVATE LIMITED",
"SUN CAPITAL ADVISORY SERVICES PRIVATE LIMITED",
"SUN CASTINGS",
"SUN CEREAL SERVICES PRIVATE LIMITED",
"SUN CHEM PROCESS MACHINES PRIVATE LIMITED",
"SUN CHLORIDE PVT LTD",
"SUN CLEAN RENEWABLE POWER PRIVATE. LIMITED.",
"SUN CLEARING AGENCY PRIVATE LIMITED",
"SUN COLOURS AND CHEMICALS",
"SUN COMMODITIES AND STOCKS PRIVATE LIMITED",
"SUN COMPUTER",
"SUN COSMECEUTICAL PRIVATE LIMITED",
"SUN DATA PROCESSING PRIVATE LIMITED",
"SUN DECORS INDIA PRIVATE LIMITED",
"SUN DEW SOLUTIONS PRIVATE LIMITED",
"SUN DIGITAL SOLUTIONS PRIVATE LIMITED",
"SUN DIRECT TV PRIVATE LIMITED",
"SUN DISTRIBUTION SERVICES PRIVATE LIMITED",
"SUN DREAMS HOLIDAYS",
"SUN DROPS ENERGIA PRIVATE LIMITED",
"SUN EAST ENERGY PRIVATE LIMITED",
"SUN EDGE MARKETING PRIVATE LIMITED",
"SUN EDU FOUNDATION",
"SUN ELECTRO CONTROL SYSTEMS PRIVATE LIMITED",
"SUN ELECTRO DEVICES PRIVATE LIMITED",
"SUN ELECTRO GRAVURES PRIVATE LIMITED",
"SUN ELECTROSTATIC ENGINEERING PRIVATE LIMITED",
"SUN ENERGY SYSTEMS",
"SUN ENTERPRISE",
"SUN ENVIRO TECHNOLOGIES PRIVATE LIMITED",
"SUN EXPORT PRIVATE LIMITED",
"SUN EXPRESS LOGISTICS (INDIA) PRIVATE LIMITED",
"SUN EYE HOSPITAL & LASER CENTRE PRIVATE LIMITED",
"SUN FACILICORP PRIVATE LIMITED",
"SUN FACILITY SERVICES PRIVATE LIMITED",
"SUN FIBO TECHNOLOGY PRIVATE LIMITED",
"SUN FILTRATION PRIVATE LIMITED",
"SUN FINE PAPERS PRIVATE LIMITED",
"SUN FLAG HOSPITAL",
"SUN FLOWER CYCLES PRIVATE LIMITED",
"SUN FOOD TECH PRIVATE LIMITED",
"SUN FOOTWEAR INDUSTRIES PRIVATE LIMITED",
"SUN FORGE INTERNATIONAL PRIVATE LIMITED",
"SUN FUND MANAGEMENT LTD",
"SUN GEN TECH PRIVATE LIMITED",
"SUN GLASS WORKS PRIVATE LIMITED",
"SUN GLOBAL LOGISTICS PRIVATE LIMITED",
"SUN GLOBELINK PRIVATE LIMITED",
"SUN GLORY EDUCATION FOUNDATION",
"SUN GLOW GREEN SOLUTIONS PRIVATE LIMITED",
"SUN GRANITES INDIA PRIVATE LIMITED",
"SUN GRAPHICS INDIA PRIVATE LIMITED",
"SUN GROW PACKERS PRIVATE LIMITED",
"SUN HOME APPLIANCES PRIVATE LIMITED",
"SUN HOSPITAL PRIVATE LIMITED",
"SUN HOSPITALITY & SERVICE APARTMENTS PRIVATE LIMITED",
"SUN HYGIENE FOODS PRIVATE LIMITED",
"SUN IMAGING PRIVATE LIMITED",
"SUN IMPEX CLEARING AND SHIPPING AGENCY PRIVATE LIMITED",
"SUN INDCHEMICALS PRIVATE LIMITED",
"SUN INDIA HATCHERIES PRIVATE LIMITED",
"SUN INDIA PHARMACY PRIVATE LIMITED",
"SUN INDUSTRIAL AUTOMATION & SOLUTIONS",
"SUN INFONET PRIVATE LIMITED",
"SUN INFRA SERVICES PRIVATE LIMITED",
"SUN INFRAENGINEERING PRIVATE LIMITED",
"SUN INFRASITE PRIVATE LIMITED",
"SUN INTERIOWOODS PRIVATE LIMITED",
"SUN INTERNATIONAL LIMITED",
"SUN INTERNATIONAL PRIVATE LIMITED",
"SUN INTERNATIONAL SCHOOL JHANSI",
"SUN INVESTMENTS PRIVATE LIMITED TFRL. FROM MUMBAI TO DELHI",
"SUN IRRIGATION SYSTEMS PRIVATE LIMITED",
"SUN JUPITER INTERNATIONAL SCHOOL",
"SUN KAGAKU INDIA PRIVATE LIMITED",
"SUN KISSED MERCHANDISE PVT.LTD.",
"SUN KNOWLEDGE PRIVATE LIMITED",
"SUN KPO SYSTEMS LLP",
"SUN LEASING LIMITED",
"SUN LED PRODUCTS LLP",
"SUN LEISURE INDIA PRIVATE LIMITED",
"SUN LIFE GLOBAL SOLUTIONS PRIVATE LIMITED",
"SUN LIFE SCIENCES PRIVATE LIMITED",
"SUN LIFE‚ÄôS HOSPITAL",
"SUN LINKS INDIA PRIVATE LIMITED",
"SUN LOGISTICS PRIVATE LIMITED",
"SUN LUCIUS PRIVATE LIMITED",
"SUN MALLEABLE PRIVATE LIMITED",
"SUN MARK STAINLESS PRIVATE LIMITED",
"SUN MASTERBATCH PRIVATE LIMITED",
"SUN MEDICAL AND RESEARCH CENTRE THRISSUR",
"SUN MEDICAL SYSTEMS PRIVATE LIMITED",
"SUN MEDISURGE PRIVATE LIMITED",
"SUN MEDITEK PRIVATE LIMITED",
"SUN MEGA VENTURES PRIVATE LIMITED",
"SUN METAL FACTORY (INDIA) PRIVATE LIMITED",
"SUN METALLICS & ALLOYS PRIVATE LIMITED",
"SUN MICRO COMPONENTS PRIVATE LIMITED",
"SUN MICRO INVIT PRIVATE LIMITED",
"SUN MICRO NETWORKS PRIVATE LIMITED",
"SUN MOBILITY EV INFRA PRIVATE LIMITED",
"SUN MOBILITY PRIVATE LIMITED",
"SUN MOON PHARMACEUTICALS PRIVATE LIMITED",
"SUN N SAND ENERGIES LLP",
"SUN N SAND EXIM (INDIA) PRIVATE LIMITED",
"SUN N SAND HOTELS PRIVATE LIMITED",
"SUN N SHADE SUNVISORS PRIVATE LIMITED",
"SUN 'N' SILVER INN PVT LTD",
"SUN N STAR GOURMET FOODS PRIVATE LIMITED",
"SUN N WIND INFRAENERGY PRIVATE LIMITED",
"SUN N WIND RENEWABLES PRIVATE LIMITED",
"SUN NARROW FAB PRIVATE LIMITED",
"SUN OIL CO PVT LTD",
"SUN ON MOUNT HOTELS PRIVATE LIMITED",
"SUN OPERATIONS & MAINTENANCE ENGG.PRIVATE LIMITED",
"SUN ORGANIC INDUSTRIES PRIVATE LIMITED",
"SUN OUTSOURCE CONSULTANCY PRIVATE LIMITED",
"SUN PACKMET PRIVATE LIMITED",
"SUN PAK KILN PVT LTD",
"SUN PETROCHEMICALS",
"SUN PHARMA ADVANCED RESEARCH COMPANY LIMITED",
"SUN PHARMA DISTRIBUTORS LIMITED",
"SUN PHARMA FIELD OPERATION",
"SUN PHARMA LABORATORIES LIMITED",
"SUN PHARMACEUTICAL INDUSTRIES LIMITED",
"SUN PHARMACEUTICAL MEDICARE LIMITED",
"SUN PHOTO VOLTAIC ENERGY INDIA PRIVATE LIMITED",
"SUN PHOTONICS PRIVATE LIMITED",
"SUN PLUS SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"SUN PLY PRIVATE LIMITED",
"SUN POLY TARP OVERSEAS PVT LTD",
"SUN POLYBAG PRIVATE LIMITED",
"SUN POLYBLENDS PRIVATE LIMITED",
"SUN POLYMERS (INDIA) PRIVATE LIMITED",
"SUN POLYTEX PRIVATE LIMITED",
"SUN POWER CONTROLS AND SERVICES PRIVATE LIMITED",
"SUN POWER CONVERSION PRIVATE LIMITED",
"SUN PRECISIONCAST PRIVATE LIMITED",
"SUN PRESSING PRIVATE. LIMITED.",
"SUN PROJECTS INDIA PRIVATE LIMITED",
"SUN PRO-PACK PRIVATE LIMITED",
"SUN RAMIFIED SOLUTIONS PRIVATE LIMITED",
"SUN RAY DEVCON PRIVATE LIMITED",
"SUN RAYS BOTTLING AND BEVERAGES PRIVATE LIMITED",
"SUN REALTY INDIA",
"SUN RED INFOTECH PRIVATE LIMITED",
"SUN RENEWABLES RT PRIVATE LIMITED",
"SUN RENEWABLES WH PRIVATE LIMITED",
"SUN RENT A CAR LOGISTICS PRIVATE LIMITED",
"SUN RETAIL LIMITED",
"SUN RISE E WASTE PRIVATE LIMITED",
"SUN RISE NATUROPATHY AND HEALTH RESORT PRIVATE LIMITED",
"SUN RISK MANAGEMENT & INSURANCE BROKING SERVICES PRIVATE LIMITED",
"SUN SATELLITE TOWERS PRIVATE LIMITED",
"SUN SECURITY SERVICE",
"SUN SERVICES FORK LEFT PARTS",
"SUN SHINE AUTOMATION INDIA LIMITED",
"SUN SHINE AUTOS PRIVATE LIMITED",
"SUN SHINE DYEING PRIVATE LIMITED",
"SUN SHINE TOWNPLANNERS PRIVATE LIMITED",
"SUN SKILLS TRANING & RESEARCH PRIVATE LIMITED",
"SUN SMART SYSTEMS PRIVATE LIMITED",
"SUN SMIT DYECHEM PRIVATE LIMITED",
"SUN SOLAR ENERGY SYSTEM",
"SUN SOLAR TECHNO LIMITED",
"SUN STAR INNOVATIONS PRIVATE LIMITED",
"SUN STAR SPACES PRIVATE LIMITED",
"SUN STERIFAAB PRIVATE LIMITED",
"SUN SWITCH INDIA PRIVATE LIMITED",
"SUN SYNDICATE BUILDERS PRIVATE LIMITED",
"SUN SYNDICATE INDUSTRIES PRIVATE LIMITED",
"SUN TECH INDUSTRIES",
"SUN TECHNOCRATES PRIVATE LIMITED",
"SUN TECHNOLOGIES",
"SUN TECHNOLOGIES INDIA PRIVATE LIMITED",
"SUN TECHNOLOGY INTEGRATORS PRIVATE LIMITED",
"SUN TECHNOSOLUTION INDIA PRIVATE LIMITED",
"SUN TECHPRO ENGINEERING (BANGALORE) PRIVATE LIMITED",
"SUN TEKNOVATION PRIVATE LIMITED",
"SUN TO MOON DEVELOPERS PRIVATE LIMITED",
"SUN TOURIISM INTERNATIONALL PRIVATE LIMITED",
"SUN TOURS PRIVATE LIMITED",
"SUN TRADING CORPORATION PRIVATE LIMITED",
"SUN TRANSMOVERS INDIA PRIVATE LIMITED",
"SUN TV NETWORK LIMITED",
"SUN ULTRA TECHNOLOGIES PRIVATE LIMITED",
"SUN UMBRELLA PRIVATE LIMITED",
"SUN UP (INDIA) PAPER BOARD MACHINERY PRIVATE LIMITED",
"SUN VACUUM FORMERS P LIMITED MNS",
"SUN VALLEY DIABETIC CARE & RESEARCH CENTRE PRIVATE LIMITED",
"SUN VALVES INDUSTRIES PRIVATE LIMITED",
"SUN VISTA SPACES PRIVATE LIMITED",
"SUN WORLD VENTURES PRIVATE LIMITED",
"SUN X CONCRETE INDIA PRIVATE LIMITED",
"SUN ZONE SOLAR SYSTEMS",
"SUN(INOX) STEELS PRIVATE LIMITED",
"SUNABH CONSULTANCY PRIVATE LIMITED",
"SUNAG ENGINEERING PVT LTD",
"SUNAGR TRADING PRIVATE LIMITED",
"SUNAGRO INSECTICIDES PRIVATE LIMITED",
"SUNAHRI MULTI GRAIN PRIVATE LIMITED",
"SUNAIR HOTELS LIMITED",
"SUNALCO ALLOYS PRIVATE LIMITED",
"SUNALPHA GREEN TECHNOLOGIES PRIVATE LIMITED",
"SUNALPHA SOLAR RAJ PRIVATE LIMITED",
"SUNAND HOSPITAL AND IVF CENTRE PRIVATE LIMITED",
"SUNANDA ENVIROMENTAL INTERNATIONAL PRIVATE LIMITED",
"SUNANDA FEEDS PRIVATE LIMITED",
"SUNANDA HOSPITALITY PRIVATE LIMITED",
"SUNANDA IVF PRIVATE LIMITED",
"SUNANDA MEDICARE SERVICES PRIVATE LIMITED",
"SUNANDA SOLAR ENERGY PRIVATE LIMITED",
"SUNANDA SPECIALITY COATINGS PVT LTD",
"SUNANDARAM FOODS PRIVATE LIMITED",
"SUNANDINI FOOD PRODUCTS LIMITED",
"SUNANSHUL TECHNOLOGIES PRIVATE LIMITED",
"SUNARC TECHNOLOGIES PRIVATE LIMITED",
"SUN-ARES INDIA REAL ESTATE PRIVATE LIMITED",
"SUNARISES PACKING",
"SUNART AGENCIES PRIVATE LIMITED",
"SUNASA INTEGRATED SOLUTIONS PRIVATE LIMITED",
"SUNATURA EXPORTS PRIVATE LIMITED",
"SU-NAV SAGAR PRIVATE LIMITED",
"SU-NAV SHIP MANAGEMENT PRIVATE LIMITED",
"SUNAYANA LASBR VISION CENTRBP LIMITED",
"SUNBARN RENEWABLES PRIVATE LIMITED",
"SUNBATH SANITARY PRIVATE LIMITED",
"SUNBEAM ELASTOMERS PRIVATE LIMITED",
"SUNBEAM ELECTRONICS PRIVATE LIMITED",
"SUNBEAM ENTERPRISES",
"SUNBEAM GENERATORS PRIVATE LIMITED",
"SUNBEAM INDUSTRIAL PRODUCTS PRIVATE LIMITED",
"SUNBEAM INFOCOM PRIVATE LIMITED",
"SUNBEAM INFOTECH PRIVATE LIMITED",
"SUNBEAM INTERNATIONAL PRIVATE LIMITED",
"SUNBEAM LENO PACK PRIVATE LIMITED",
"SUNBEAM LIFESCIENCES PRIVATE LIMITED",
"SUNBEAM LIGHTWEIGHTING SOLUTIONS PRIVATE LIMITED",
"SUNBEAM MERCHANTILE VENTURES PRIVATE LIMITED",
"SUNBEAM PUBLISHERS PRIVATE LIMITED",
"SUNBEAM REAL VENTURES PRIVATE LIMITED",
"SUNBEAM SCHOOL",
"SUNBEAM STRUCTURALS PRIVATE LIMITED",
"SUNBEAM VANIJYA PRIVATE LIMITED",
"SUNBEAM WORLDWIDE COMMERCE PRIVATE LIMITED",
"SUNBEAMS TRAVELS BARODA PRIVATE LIMITED",
"SUNBEEN IMPEX PRIVATE LIMITED",
"SUNBEL ALLOYS COMPANY OF INDIA LIMITED",
"SUNBERG LIFE SCIENCES PRIVATE LIMITED",
"SUNBERRY RENEWABLE ENERGY PRIVATE LIMITED",
"SUNBIRD SEALS AND PLASTICS PRIVATE LIMITED",
"SUNBIRDS FOREX PRIVATE LIMITED",
"SUNBLAZE APPLIANCES PRIVATE LIMITED",
"SUNBOND CERAMIC PRIVATE LIMITED",
"SUNBOND ENERGY PRIVATE LIMITED",
"SUNBORNE ENERGY ANDHRA PRIVATE LIMITED",
"SUNBORNE ENERGY GUJARAT ONE PRIVATE LIMITED",
"SUNBORNE ENERGY RAJASTHAN SOLAR PRIVATE LIMITED",
"SUNBORNE ENERGY SERVICES INDIA PRIVATE LIMITED",
"SUNBORNE ENERGY TECHNOLOGIES PRIVATE LIMITED",
"SUNBOUND ENERGY PRIVATE LIMITED",
"SUNBOURNE DEVELOPERS PRIVATE LIMITED",
"SUNBOW INSULATION PRIVATE LIMITED",
"SUNBREEZE BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"SUNBRICK REALTOR LIMITED",
"SUNBRIGHT CERAMIC PRIVATE LIMITED",
"SUNBRIGHT FABRICS PRIVATE LIMITED",
"SUNBRIGHT INDUSTRIES PRIVATE LIMITED",
"SUNBRILO TECHNOLOGIES PRIVATE LIMITED",
"SUNBUD MULTIVENTURES PRIVATE LIMITED",
"SUNBURST HEALTHCARE PRIVATE LIMITED",
"SUNBUY RENEWABLES PRIVATE LIMITED",
"SUNCAP TELECOM PRIVATE LIMITED",
"SUNCARE ENERTECH PRIVATE LIMITED",
"SUNCARE FORMULATIONS PRIVATE LIMITED",
"SUNCARE TRADERS LIMITED",
"SUNCAST ENERGY PRIVATE LIMITED",
"SUNCE INFO SOLUTION PRIVATE LIMITED",
"SUNCE RENEWABLES PRIVATE LIMITED",
"SUNCHASER STRUCTURES PRIVATE LIMITED",
"SUNCHEM MARKETING PRIVATE LIMITED",
"SUNCHEM PVT LTD",
"SUNCHEM TECHNOLOGIES INDIA PRIVATE LIMITED",
"SUNCHIRIN AUTOPARTS INDIA PRIVATE LIMITED",
"SUNCITY AADHAR INFRAPROJECTS PRIVATE LIMITED",
"SUNCITY ART EXPORTERS",
"SUNCITY BUILDCON PRIVATE LIMITED",
"SUNCITY CERAMICS",
"SUNCITY DHOOT COLONIZERS PRIVATE LIMITED",
"SUNCITY HARYANA SEZ DEVELOPERS PRIVATE LIMITED",
"SUNCITY HI-TECH INFRASTRUCTURES PVT LTD",
"SUNCITY HI-TECH PROJECTS PRIVATE LIMITED",
"SUNCITY LANDMARK TOWNSHIPS PRIVATE LIMITED",
"SUNCITY POLYESTER PVT LTD",
"SUNCITY PROJECTS PRIVATE LIMITED",
"SUNCITY REALTORS PRIVATE LIMITED",
"SUNCITY SCHOOL",
"SUNCITY SHARE BROKER PRIVATE LIMITED",
"SUNCITY SHEETS PRIVATE LIMITED",
"SUNCITY SUITES PRIVATE LIMITED",
"SUNCITY SYNTHETICS LIMITED",
"SUNCITY TEXTILE PRIVATE. LIMITED.",
"SUNCITY THREADS . LTD",
"SUNCOAT ENGINEERING KOVAI PRIVATE LIMITED",
"SUNCON ENGINEERS PRIVATE LIMITED",
"SUNCORE ENGINEERING SOLUTIONS PRIVATE LIMITED",
"SUNCORE TILES PRIVATE LIMITED",
"SUNCROWN SECURITY SERVICES LLP",
"SUNCUPID TECHNOLOGY INDIA PRIVATE LIMITED",
"SUNDAE CAPITAL ADVISORS PRIVATE LIMITED",
"SUNDAK SOLAR SOLUTIONS PRIVATE LIMITED",
"SUNDALE PACKERS",
"SUNDAR CHEMICALS PRIVATE LIMITED",
"SUNDAR DEZIRE PRIVATE LIMITED",
"SUNDAR LAKSHMI AGENCIES AND TRADERS PRIVATE LIMITED",
"SUNDAR MANAGEMENT SERVICES LLP",
"SUNDAR METAL TECHNO PRIVATE LIMITED",
"SUNDAR STEEL UDYOG PRIVATE LIMITED",
"SUNDAR TAJMAHAL HOTELS PRIVATE LIMITED",
"SUNDAR TYRES AND WHEELS PRIVATE LIMITED",
"SUNDARAM ALLOYS LIMITED",
"SUNDARAM ALTERNATE ASSETS LIMITED",
"SUNDARAM ARCHITECTS PRIVATE LIMITED",
"SUNDARAM ASSET MANAGEMENT COMPANY LIMITED",
"SUNDARAM AUTO COMPONENTS LIMITED",
"SUNDARAM BNP PARIBAS FUND SERVICES LIMITED",
"SUNDARAM BNP PARIBAS HOME FINANCE LIMITED",
"SUNDARAM BPO INDIA LIMITED",
"SUNDARAM BRAKE LININGS LIMITED",
"SUNDARAM BUSINESS SERVICES LIMITED",
"SUNDARAM CERA IMPEX PRIVATE LIMITED",
"SUNDARAM CHAINS PRIVATE LIMITED",
"SUNDARAM CLAYTON LIMITED",
"SUNDARAM COMPOSITE STRUCTURES PRIVATE LIMITED",
"SUNDARAM DYNACAST P LIMITED",
"SUNDARAM ENTERPRISES PVT LTD",
"SUNDARAM FINANCE HOLDINGS LIMITED",
"SUNDARAM FINANCE LIMITED",
"SUNDARAM FINANCIAL ADVISORY PRIVATE LIMITED",
"SUNDARAM HOME FINANCE LIMITED",
"SUNDARAM HYDRAULICS LIMITED",
"SUNDARAM INDUSTRIES PRIVATE LIMITED",
"SUNDARAM INFOTECH SOLUTIONS LIMITED",
"SUNDARAM MEDICAL DEVICES PRIVATE LIMITED",
"SUNDARAM MEDICAL FOUNDATION",
"SUNDARAM MOTORS PRIVATE LIMITED",
"SUNDARAM MULTI PAP LIMITED",
"SUNDARAM PACKAGING INDIA PRIVATE LIMITED",
"SUNDARAM PAPER PRODUCTS PRIVATE LIMITED",
"SUNDARAM PHARMA PRIVATE LIMITED",
"SUNDARAM SALES PRIVATE LIMITED",
"SUNDARAM STEELS PRIVATE LIMITED",
"SUNDARAM TEXTILES LIMITED",
"SUNDARAM TEXTILES PRIVATE LIMITED",
"SUNDARAM TRADING AND INVESTEMENT PRIVATE LIMITED",
"SUNDARAM VINCOM PRIVATE LIMITED",
"SUNDARAMS SOUTH INDIAN FOOD PRIVATE LIMITED",
"SUNDARAVALLI MOTORS PRIVATE LIMITED",
"SUNDARAVEL BLUE METAL PRIVATE LIMITED",
"SUNDARAVEL MATCH INDUSTRIES PRIVATE LIMITED",
"SUNDARAVIJAYAM AUTOMOBILE SERVICES PRIVATE LIMITED",
"SUNDARBAI MARATHE VIDYALAY",
"SUNDARBANS FOOD PRODUCTS (I) PRIVATE LIMITED",
"SUNDARI CREATIONS PRIVATE LIMITED",
"SUNDARI DEVI INTER COLLEGE",
"SUNDARI SAREE PVT.LTD.",
"SUNDARLAL PHARMA DISTRIBUTORS PRIVATE LIMITED",
"SUNDATTA HIGH SCHOOL",
"SUNDAY RETAIL PRIVATE LIMITED",
"SUNDEEP AGRO CHEM PRIVATE LIMITED",
"SUNDEEP ELECTRICALS PRIVATE LIMITED",
"SUNDEEP ELECTRODES PRIVATE LIMITED",
"SUNDEEP JEWELS PRIVATE LIMITED",
"SUNDEEP LOGISTICS PRIVATE LIMITED",
"SUNDEEP PURI LEGAL ADVISORS PRIVATE LIMITED",
"SUNDEEP TRAVELS AND CARGO PRIVATE LIMITED",
"SUNDEK INDIA LIMITED",
"SUNDEK INTERIO PRIVATE LIMITED",
"SUNDER CRANES PRIVATE LIMITED",
"SUNDER DEEP ENGINEERING COLLEGE",
"SUNDER FABRICS PRIVATE LIMITED",
"SUNDER HOME APPLIANCES PRIVATE LIMITED",
"SUNDER IMPEX PRIVATE LIMITED",
"SUNDER IRON REROLLERS PRIVATE LIMITED",
"SUNDER ISPAT LIMITED",
"SUNDER JEWELLERY HOUSE PRIVATE LIMITED",
"SUNDER LAL JAIN HOSPITAL",
"SUNDER LUMBERS PRIVATE LIMITED",
"SUNDER MARKETING ASSOCIATES",
"SUNDER MAYA SINTERED PRODUCTS PRIVATE LIMITED",
"SUNDER NAMKEENS",
"SUNDER OIL INDUSTRIES PRIVATE LIMITED",
"SUNDER PLASTICS PRIVATE LIMITED",
"SUNDER PROFILE CUTTER COMPANY PRIVATE LIMITED",
"SUNDER SIZERS PRIVATE LIMITED",
"SUNDER SYNTHETICS PRIVATE LIMITED",
"SUNDER SYSTEMS PRIVATE LIMITED",
"SUNDER TIMBER INDUSTRIES PRIVATE LIMITED",
"SUNDERAM BUILDHOME PRIVATE LIMITED",
"SUNDERAM ELECTROTECH PRIVATE LIMITED",
"SUNDERDEEP CONSTRUCTIONS PRIVATE LIMITED",
"SUNDERKRAFT CLOTHING PRIVATE LIMITED",
"SUNDERLAL MOOLCHAND JAIN TOBACCONIST PRIVATE LIMITED",
"SUNDERNARAYAN & CO INFRASTRUCTURE PRIVATE LIMITED",
"SUNDERRAO SOLANKE MAHAVIDYALAYA",
"SUNDERS KITCHEN PRIVATE LIMITED",
"SUNDERSONS LOGISTICS PRIVATE LIMITED",
"SUNDESH SOLAR SYSTEMS & SERVICES MARKETING INDIA PRIVATE LIMITED",
"SUNDESHA ENTERPRISES PRIVATE LIMITED",
"SUNDEW PROPERTIES LIMITED",
"SUNDEW REAL ESTATE PRIVATE LIMITED",
"SUNDEX PROCESS ENGINEERS PVT LTD",
"SUNDHA JEWELLERS PRIVATE LIMITED",
"SUNDHAMATAY NAMAH TEXFAB PRIVATE LIMITED",
"SUNDHAR ELECTRICALS PRIVATE LIMITED",
"SUNDHARAMS P LTD",
"SUNDIAL INFOTECH PRIVATE LIMITED",
"SUNDIAL MINING AND METALS LLP",
"SUNDIAL TRADELINK PRIVATE LIMITED",
"SUNDIGO SOLAR SOLUTIONS",
"SUNDLAS BUILDERS PRIVATE LIMITED",
"SUNDOOR MANUFACTURING PRIVATE LIMITED",
"SUNDOWNER OFFSHORE INTERNATIONAL BERMUDA LIMITED",
"SUNDRA LOGISTICS PRIVATE LIMITED",
"SUNDRAM FASTENERS LIMITED",
"SUNDRAM INFRA PRIVATE LIMITED",
"SUNDRAM NON- CONVENTIONAL ENERGY SYSTEMS",
"SUNDRAM PRECISION COMPONENTS LIMITED",
"SUNDREX OIL COMPANY LIMITED.",
"SUNDROP FOODS INDIA PRIVATE LIMITED",
"SUNDUM INDUSTRIES PRIVATE LIMITED",
"SUNDYNE PUMPS AND COMPRESSORS INDIA PRIVATE LIMITED",
"SUNDYOTA NUMANDIS PHARMACUTICALS PRIVATE LIMITED.",
"SUNDYOTA NUMANDIS PROBIOCEUTICALS PRIVATE LIMITED",
"SUNEDISON ENERGY INDIA PRIVATE LIMITED",
"SUNEDISON INFRASTRUCTURE LIMITED",
"SUNEDISON SOLAR POWER INDIA PRIVATE LIMITED",
"SUNEEL HOSIERY PRIVATE LIMITED",
"SUNEET ENGINEERING PRIVATE LIMITED",
"SUNEET FINMAN PRIVATE LIMITED",
"SUNEET VARMA DESIGN PRIVATE LIMITED",
"SUNEETHA POLYMERS PRIVATE LIMITED",
"SUNEHARI BAGH BUILDERS PRIVATE LIMITED",
"SUNEHRA ASSOCIATES LIMITED",
"SUNEHRI AUTOMOTIVE PRIVATE LIMITED",
"SUNEHRI CARS PRIVATE LIMITED",
"SUNEJA FASHION FABRICS & LIFESTYLES PRIVATE LIMITED",
"SUNEJA SONS",
"SUNERA TECHNOLOGIES PRIVATE LIMITED",
"SUNERI STEELS PRIVATE LIMITED",
"SUNESONS ENGINEERING AND FABRICATIONS PRIVATE LIMITED",
"SUNETHRA INFOTECH PRIVATE LIMITED",
"SUNETRA EYE CENTRE PRIVATE LIMITED",
"SUNEV JEWELS AND GEMS PRIVATE LIMITED",
"SUNEX AIR TOOLS PRIVATE LIMITED",
"SUNEX PRECISION PRIVATE LIMITED.",
"SUNEX STONES PRIVATE LIMITED",
"SUNEX TUBE TOOLS PRIVATE LIMITED",
"SUNFAB",
"SUNFAB TEXTILES PRIVATE LIMITED",
"SUNFAME CERAMIC PRIVATE LIMITED",
"SUNFEED ECOSOLUTIONS INDIA PRIVATE LIMITED",
"SUNFERT INTERNATIONAL PRIVATE LIMITED",
"SUNFEST INFRATECH & POWER PRIVATE LIMITED",
"SUNFIELD AGRO INDIA PRIVATE LIMITED",
"SUNFIELD ENERGY PRIVATE LIMITED",
"SUNFIN (INDIA) PRIVATE LIMITED",
"SUNFIN REALTY PRIVATE LIMITED",
"SUNFIRE TECHNOLOGIES PRIVATE LIMITED",
"SUNFIX PLAST PRIVATE LIMITED",
"SUNFLAG ADDITIVES PRIVATE LIMITED",
"SUNFLAG CHEMICALS PRIVATE LIMITED",
"SUNFLAG FILAMENTS LIMITED",
"SUNFLAG IRON AND STEEL CO LIMITED",
"SUNFLAKES FOOD PRODUCTS PRIVATE LIMITED",
"SUNFLAME ENTERPRISES PRIVATE LIMITED",
"SUNFLAME FUELS PVT LTD",
"SUN-FLAMES PETROCHEMICALS PRIVATE LIMITED",
"SUNFLARE IMPEX PRIVATE LIMITED",
"SUNFLEX LAMINATORS",
"SUNFLEX PACKAGERS (INDIA) PRIVATE LIMITED",
"SUNFLEX PIPES PRIVATE LIMITED",
"SUNFLEX RECYCLING PRIVATE LIMITED",
"SUNFLORA VITRIFIED PRIVATE LIMITED",
"SUNFLOW BATH PRIVATE LIMITED",
"SUNFLOWER (INDIA) PRIVATE LIMITED",
"SUNFLOWER BROKING PRIVATE LIMITED",
"SUNFLOWER EDUCATIONAL SOCIETY",
"SUNFLOWER MARBLES PRIVATE LIMITED",
"SUNFLOWER ORGANICS PRIVATE LIMITED",
"SUNFLOWER PRE SCHOOL & DAY CARE",
"SUNFLOWER PROCESSORS PRIVATE LIMITED",
"SUNFLOWER PUBLISHERS PRIVATE LIMITED",
"SUNFLOWER SOLUTIONS",
"SUNFLOWER TECHNO SOLUTIONS PRIVATE LIMITED",
"SUNFLOWER TRANSFORMERS PRIVATE LIMITED",
"SUNFLOWER VINIMAY PRIVATE LIMITED",
"SUNFLOWER WOMENS ENDO INFERTILIT & HOSPITAL PRIVATE",
"SUNFLY INFRA PRIVATE LIMITED",
"SUNFOCUS SOLUTIONS PRIVATE LIMITED",
"SUNFORGE PRIVATE LIMITED",
"SUNFOX PRODUCTION HOUSE PRIVATE LIMITED",
"SUNFOX TECHNOLOGIES PRIVATE LIMITED",
"SUNFREE PASCHIM RENEWABLE ENERGY PRIVATE LIMITED",
"SUNFRESH AGRO INDUSTRIES PRIVATE LIMITED PRABHAT GROUP ENTITY",
"SUNFUND SOLAR PRIVATE LIMITED",
"SUNG JI TRADING PRIVATE LIMITED",
"SUNG SHIN TECH INDIA PRIVATE LIMITED",
"SUNGARD AVAILABILITY SERVICES INDIA PRIVATE LIMITED",
"SUNGARD ELEVATORS PRIVATE LIMITED",
"SUNGARNER ENERGIES LIMITED",
"SUNGARNER ENERGIES PRIVATE LIMITED",
"SUNGAZE POWER PRIVATE LIMITED",
"SUNGEEL INDIA RECYCLING PRIVATE LIMITED",
"SUNGEOMATICS ENGINEERING SERVICES PRIVATE LIMITED",
"SUNGHANDHA NIRMAN PRIVATE LIMITED",
"SUNGJI PAINT PRIVATE LIMITED",
"SUNGLARE VITRIFIED PRIVATE LIMITED",
"SUNGLASS PALACE PRIVATE LIMITED",
"SUNGLAXO INFOTECH PRIVATE LIMITED",
"SUNGLOSS CERAMIC INDUSTRIES",
"SUNGLOW ELECTRIC POWER PRIVATE LIMITED",
"SUNGLOW FININVEST PRIVATE LIMITED",
"SUNGLOW INSURANCE SURVEYORS & LOSS ASSESSORS PRIVATE LIMITED",
"SUNGLOW LIFESCIENCE PRIVATE LIMITED",
"SUNGLOW PHARMACEUTICALSS PRIVATE LIMITED",
"SUNGLOW PROMOTERS PRIVATE LIMITED",
"SUNGLOW SUITINGS PRIVATE LIMITED",
"SUNGLOW TEXTILES PRIVATE LIMITED",
"SUN-GOLD AGRO PRIVATE LIMITED",
"SUNGOLD CAPITAL LIMITED",
"SUNGOLD ENERGY PRIVATE LIMITED",
"SUNGOLD ENGINEERING & EQUIPMENTS PRIVATE LIMITED",
"SUNGOLD SUPPLIERS PRIVATE LIMITED",
"SUNGOLD TROPIC FRUIT PRODUCTS PRIVATE LIMITED",
"SUNGOV ENGINEERING PRIVATE LIMITED",
"SUNGRACE ENERGY SOLUTIONS PRIVATE LIMITED",
"SUNGRACE ENGINEERING PROJECTS PRIVATE LIMITED",
"SUNGRACE FABRICS PVT LTD",
"SUNGRACE FINVEST PVT LTD",
"SUNGRACE PHARMA PRIVATE LIMITED",
"SUNGRACE PRODUCTS (INDIA) PRIVATE LIMITED",
"SUNGRACE SYNTEX PRIVATE LIMITED",
"SUNGREEN POWER & RENEWABLE ENERGY PRIVATE LIMITED",
"SUNGROUP ENTERPRISES PRIVATE LIMITED",
"SUNGROW (INDIA) PRIVATE LIMITED",
"SUNGROW DEVELOPERS INDIA PRIVATE LIMITED",
"SUNGRUPTA CONSULTANCY AND OUTSOURCING OPC PRIVATE LIMITED",
"SUNGUARD CONSTRUCTION PRIVATE LIMITED",
"SUNGWOO HITECH AP PRIVATE LIMITED",
"SUNGWOO HITECH INDIA LIMITED",
"SUNGWOO HITECH INDIA PRIVATE LIMITED",
"SUNGWOO STAMPING PRIVATE LIMITED",
"SUNHAM HOME FASHIONS PRIVATE LIMITED",
"SUNHEART CERAMICK",
"SUNHERI MARKETING PRIVATE LIMITED",
"SUNHERI TEXCRAFT PRIVATE LIMITED",
"SUNHERI YARNS & FIBRES PRIVATE LIMITED",
"SUNHETI SOLAR PROJECTS PRIVATE LIMITED",
"SUNHILL CERAMIK PRIVATE LIMITED",
"SUNHILL HOSPITALS PRIVATE LIMITED",
"SUNHILL SYSTEMS PRIVATE LIMITED",
"SUNIC TECHNOLOGIES PRIVATE LIMITED",
"SUNICON BUILDWELL PRIVATE LIMITED",
"SUNIDHI CAPITAL PRIVATE LIMITED",
"SUNIDHI ESTATES PRIVATE LIMITED",
"SUNIDHI RUBBER PRIVATE LIMITED",
"SUNIDHI SECURITIES & FINANCE LIMITED",
"SUNIDHI TIMBER PRODUCTS PRIVATE LIMITED",
"SUNIDHI TRADE & LOGISTICS PRIVATE LIMITED",
"SUNIJ PHARMA PRIVATE LIMITED",
"SUNIK INTERNATIONAL PRIVATE LIMITED",
"SUNIKH COMPONENTS PRIVATE LIMITED",
"SUNIKSHA MANAGEMENT SERVICES PRIVATE LIMITED",
"SUNIL AGENCIES PRIVATE LIMITED",
"SUNIL AGENTS AND DISTRIBUTORS PVT LTD",
"SUNIL AGRO FOODS LIMITED",
"SUNIL ALCOP COMPANY PRIVATE LIMITED",
"SUNIL AND SONS PRIVATE LIMITED",
"SUNIL AUTO SALES PRIVATE LIMITED",
"SUNIL AUTOMOTIVE INDIA PRIVATE LIMITED",
"SUNIL CAPITAL AND SECURITIES PVT LTD",
"SUNIL CERAMICS & SANITATIONS PRIVATE LIMITED",
"SUNIL COLD STORAGE AND AGRO PRODUCTS PRIVATE LIMITED",
"SUNIL COMMODITIES PRIVATE LIMITED",
"SUNIL DAIRY PRIVATE LIMITED",
"SUNIL ENGICON PRIVATE LIMITED",
"SUNIL FERROMET PRIVATE LIMITED",
"SUNIL GARG AND CO",
"SUNIL GEMS AND JEWELLERY PRIVATE LIMITED",
"SUNIL GOLD INDIA PRIVATE LIMITED",
"SUNIL GREAT (HOSIERY YARN AND KAPADIA) PROCESSORS PVT LTD",
"SUNIL HANDLOOMS PRIVATE LIMITED",
"SUNIL HEALTHCARE LIMITED",
"SUNIL HOTELS PRIVATE LIMITED",
"SUNIL ISPAT AND POWER PRIVATE LIMITED",
"SUNIL JEWELLERS PRIVATE LIMITED",
"SUNIL KUMAR AGRAWAL LLP",
"SUNIL KUMAR SECURITY AGENCY",
"SUNIL MAHAJAN AND SONS SPORTING PRIVATE LIMITED",
"SUNIL MANUFACTURING AND TRADING INDIA PRIVATE LIMITED",
"SUNIL MINGLANI EDUFIN PRIVATE LIMITED",
"SUNIL NITRATE PRIVATE LIMITED",
"SUNIL PAINT AND VARNISHERS COMPANY PRIVATE LIMITED",
"SUNIL PLYWOOD PRIVATE LIMITED",
"SUNIL RE-ROLLERS AND STEELS PVT LTD",
"SUNIL ROADWAYS PRIVATE LIMITED",
"SUNIL SANGEET DEALCOM PRIVATE LIMITED",
"SUNIL SCOOTERS PVT LTD",
"SUNIL SPONGE PRIVATE LIMITED",
"SUNIL STEEL WIRES PRIVATE LIMITED",
"SUNIL TEXFAB PRIVATE LIMITED",
"SUNIL WIRE INDUSTRIES PRIVATE LIMITED",
"SUNILI LEATHERN PVT. LTD",
"SUNINFRA ENERGIES PRIVATE LIMITED",
"SUNINFRA REALCON PRIVATE LIMITED",
"SUNINTOWN RENEWABLES PRIVATE LIMITED",
"SUNIT HOUSING PRIVATE LIMITED",
"SUNITA AUTO PRIVATE LIMITED",
"SUNITA CARRIERS PRIVATE LIMITED",
"SUNITA COMMERCIALS P LTD",
"SUNITA DIE PARTS PVT LTD",
"SUNITA DYEING MILLS PRIVATE LIMITED",
"SUNITA ENGINEERING WORKS INDIA PRIVATE LIMITED",
"SUNITA ENGINEERS PRIVATE LIMITED",
"SUNITA FINLEASE LIMITED",
"SUNITA GOLD & DIAMONDS PRIVATE LIMITED",
"SUNITA HYDROCOLLOIDS PRIVATE LIMITED",
"SUNITA IMPEX PRIVATE LIMITED",
"SUNITA INFRA PROJECTS PRIVATE LIMITED",
"SUNITA JEWELLERS PRIVATE LIMITED",
"SUNITA NATURAL FORSET PRODUCTS PVT.LTD.",
"SUNITA NETWORK PRIVATE LIMITED",
"SUNITA PROCESSORS PRIVATE LIMITED",
"SUNITA TOOLS LIMITED",
"SUNITA TOOLS PRIVATE LIMITED",
"SUNITA TRADES LINKS PRIVATE LIMITED",
"SUNITECH AUTOMOTIVE PRIVATE LIMITED",
"SUNITHA GRAPHICS",
"SUNITHA INFOVISION LIMITED",
"SUNITHA SALES AND SERVICE PRIVATE LIMITED",
"SUNITI ELECTRICALS PRIVATE LIMITED",
"SUNITI HOSPITALITY PRIVATE LIMITED",
"SUNITTA TEXTILE MILLS PVT LTD",
"SUNITTI PAPERS PRIVATE LIMITED",
"SUNJAAY ATHANKI PROJECTS MANAGEMENT PRIVATE LIMITED",
"SUNJAY TECHNOLOGIES PRIVATE LIMITED",
"SUNJEET COMMUNICATIONS PRIVATE LIMITED",
"SUNJEWELS PRIVATE LIMITED",
"SUNJIN INDIA FEEDS PRIVATE LIMITED",
"SUNJRAY INFO-SYSTEMS PRIVATE LIMITED",
"SUNJYOT GEMS",
"SUNJYOTI TEXFAB PRIVATE LIMITED",
"SUNKALP COTTONCRAFT PRIVATE LIMITED",
"SUNKALP ENERGY A UNIT OF BD KHANNA ESTATES PRIVATE LIMITED.",
"SUNKAPUR SPICE PRODUCT PRIVATE LIMITED",
"SUNKIND INDIA PRIVATE LIMITED",
"SUNKKALP CREATION PRIVATE LIMITED",
"SUNKOLL INDUSTRIES LIMITED",
"SUNKON ENERGY PRIVATE LIMITED",
"SUNKRANTI ENERGY PRIVATE LIMITED",
"SUNKRISHNA INDUSTRIES PRIVATE LIMITED",
"SUNKU LIFESTYLE PRIVATE LIMITED",
"SUN-KWIK APPLIANCES PRIVATE LIMITED",
"SUNKYONG LIMITED",
"SUNLAB DIAGNOSTICS PRIVATE LIMITED",
"SUNLAC PAINTS LIMITED",
"SUNLAM LAMINATES INDIA PRIVATE LIMITED",
"SUNLAN MOTOR INDIA PRIVATE LIMITED",
"SUNLAND CERAMIC PRIVATE LIMITED",
"SUNLAND PROJECTS PRIVATE LIMITED",
"SUNLAND RECYCLING INDUSTRIES LIMITED",
"SUNLARGE CONSULTANTS PRIVATE LIMITED",
"SUNLARGE FILAMENTS PRIVATE LIMITED",
"SUNLARGE INDUSTRIES PRIVATE LIMITED",
"SUNLARGE PROPERTIES PRIVATE LIMITED",
"SUNLEX CERAMIC PRIVATE LIMITED",
"SUNLEX FABRICS PRIVATE LIMITED",
"SUNLIFE IMPEX PRIVATE LIMITED",
"SUNLIFE PHARMA SERVICES",
"SUNLIFE TRADE LINKS PRIVATE LIMITED",
"SUNLIGHT ACTIVE DRUG INGREDIENTS PRIVATE LIMITED",
"SUNLIGHT AUTOMATION PRIVATE LIMITED",
"SUNLIGHT BARTER PRIVATE LIMITED.",
"SUNLIGHT BOARDS PVT LTD",
"SUNLIGHT CAPITAL SERVICES PRIVATE LIMITED",
"SUNLIGHT CAR RENTAL SERVICES PRIVATE LIMITED",
"SUNLIGHT FIRE SOLUTIONS PRIVATE LIMITED",
"SUNLIGHT FOREX PRIVATE LIMITED",
"SUNLIGHT FORGE AND FITTING PRIVATE LIMITED",
"SUNLIGHT GAS & EQUIPMENTS PRIVATE LIMITED",
"SUNLIGHT HOUSING DEVELOPMENT PRIVATE LIMITED",
"SUNLIGHT INFRA ENERGY PRIVATE LIMITED",
"SUNLIGHT MARBLE PRIVATE LIMITED",
"SUNLIGHT PULP & PAPER PRIVATE LIMITED",
"SUNLIGHT SPIRITS PRIVATE LIMITED",
"SUNLIGHT SPORTS PRIVATE LIMITED",
"SUNLIGHT VIDHYALAYA",
"SUNLIGHT WASTE MANAGEMENT PRIVATE LIMITED",
"SUNLIKE WAREHOUSING PRIVATE LIMITED",
"SUNLINK PHOTOVOLTAIC PRIVATE LIMITED",
"SUNLITE ALLOYS PRIVATE LIMITED",
"SUNLITE FOOD PRODUCTS PRIVATE LIMITED",
"SUNLITE INDIA AGRO PRODUCER COMPANY LIMITED",
"SUNLITE INDUSTRIES SI",
"SUNLITE REFINERIES PRIVATE LIMITED",
"SUNLITE SYSTEMS PRIVATE LIMITED",
"SUNLONG ENERGY PRIVATE LIMITED",
"SUNLORD APPARELS MFG CO LIMITED",
"SUNLORD INDUSTRIES PRIVATE LIMITED",
"SUNLUX ENERGY PRIVATE LIMITED",
"SUNLUX TECHNOLOGIES PRIVATE LIMITED",
"SUNLUX TECHNOVATIONS PRIVATE LIMITED",
"SUNMAG ENGINEERING SOLUTIONS PRIVATE LIMITED",
"SUNMARG SECURITIES PRIVATE LIMITED",
"SUNMARK CERAMIC",
"SUNMARK ENERGY PROJECTS LIMITED",
"SUNMARK FOODS PRIVATE LIMITED",
"SUNMARKS HOTELS PRIVATE LIMITED",
"SUNMAX AUTO ENGINEERING PRIVATE LIMITED",
"SUNMAX BOILER ENGINEERS PRIVATE LIMITED",
"SUNMAX CONSTRUCTIONS PRIVATE LIMITED",
"SUNMAX CORPORATION PRIVATE LIMITED",
"SUNMAX HATCHERIES PRIVATE LIMITED",
"SUNMAX LABORATORIES PRIVATE LIMITED",
"SUNMAX PHARMA LIMITED",
"SUNMAYA CONSTRUCTION PRIVATE LIMITED",
"SUNMECH MOTOR PRIVATE LIMITED",
"SUNMED HEALTH CARE PRIVATE LIMITED",
"SUNMEET LOGISTIC PRIVATE LIMITED",
"SUNMEISTER ENERGY PRIVATE LIMITED (OPC)",
"SUNMET HOLDINGS INDIA PRIVATE LIMITED",
"SUNMET METALLURGICAL PVT LTD",
"SUNMOKSHA POWER PRIVATE LIMITED",
"SUNMOON CHEMICALS PRIVATE LIMITED",
"SUNMOON SLEEVES PRIVATE LIMITED",
"SUNNBURN ENERGY PRIVATE LIMITED",
"SUNNEN INDIA PRIVATE LIMITED",
"SUNNESS CAPITAL INDIA PRIVATE LIMITED",
"SUNNET SOLUTIONS PRIVATE LIMITED",
"SUNNICE ENERGY SOLUTIONS PRIVATE LIMITED",
"SUNNIDHI PROCESSORS LIMITED",
"SUNNIVA CORPORATE ADVISORY PRIVATE LIMITED",
"SUNNLEKS AGRO PRIVATE LIMITED",
"SUN-N-STAR ADVERTISING PRIVATE LIMITED",
"SUNNY AGRI PRODUCTS PRIVATE LIMITED",
"SUNNY APARTMENTS PRIVATE LIMITED",
"SUNNY BUILDCON PRIVATE LIMITED",
"SUNNY BUILDTECH PRIVATE LIMITED",
"SUNNY CHEMICALS PRIVATE LIMITED",
"SUNNY DEVELOPERS PRIVATE LIMITED",
"SUNNY DIAMONDS PRIVATE LIMITED",
"SUNNY EARTH MINERALS PRIVATE LIMITED",
"SUNNY EDIBLE PRODUCTS PRIVATE LIMITED",
"SUNNY ENTERPRISE",
"SUNNY ENTERPRISES PRIVATE LIMITED",
"SUNNY ENTERTAINMENTS PRIVATE LIMITED",
"SUNNY EXPORTS PRIVATE LIMITED",
"SUNNY FASHIONS PRIVATE LIMITED",
"SUNNY FOOTWEARS PRIVATE LIMITED",
"SUNNY FORESIGHT PRIVATE LIMITED",
"SUNNY HOMECARE PRIVATE LIMITED",
"SUNNY HOUSING INDIA PRIVATE LIMITED",
"SUNNY INDUSTRIAL SALES PRIVATE LIMITED",
"SUNNY INTERNATIONAL LIMITED",
"SUNNY IRON AND STEEL PROCESSORS PRIVATE LIMITED",
"SUNNY LOVELY DEVELOPERS",
"SUNNY MANUFACTURING COMPANY PRIVATE LIMITED",
"SUNNY MARINE ENGINEERS PRIVATE LIMITED",
"SUNNY METROPOLIS PRIVATE LIMITED",
"SUNNY MOTORS PRIVATE LIMITED",
"SUNNY OPOTECH INDIA PRIVATE LIMITED",
"SUNNY PAPERS PRIVATE LIMITED",
"SUNNY POWER TECH PRIVATE LIMITED",
"SUNNY REALCONSTRUCTION PRIVATE LIMITED",
"SUNNY RESTAURANT AND CATERERS PRIVATE LIMITED",
"SUNNY ROCK ESTATES & DEVELOPERS PVT LTD",
"SUNNY SEALS PRIVATE LIMITED",
"SUNNY SILK MILLS PVT LTD",
"SUNNY SOUNDS PVT LTD",
"SUNNY STERILE PRODUCTS PRIVATE LIMITED",
"SUNNY TREXIM PVT.LTD.",
"SUNNY VALLEY TEA & INDUSTRIES LTD",
"SUNNY VIEW ESTATES PRIVATE LIMITED",
"SUNNY WORLD PUNE PRIVATE LIMITED",
"SUNNYCOM TRAINING INSTITUTE",
"SUNNYSIDE TRADING PRIVATE LIMITED",
"SUNNYSIDEUP ADVERTISING INDIA PRIVATE LIMITED",
"SUNOGENICA LABORATORIUM PRIVATE LIMITED",
"SUNOIDA SOLUTIONS PRIVATE LIMITED",
"SUNOLA EXIM PVT LTD (TRAN FROM CALCUTTA TO DELHI)",
"SUNON ELECTRONICS INDIA PRIVATE LIMITED",
"SUNON MODULAR INDIA PRIVATE LIMITED",
"SUNONIX INDIA PRIVATE LIMITED",
"SUNOVAA TECH PRIVATE LIMITED",
"SUNOVATECH INDIA PRIVATE LIMITED",
"SUNOVATIVE PRIVATE LIMITED",
"SUNPAC (INDIA) PRIVATE LIMITED",
"SUNPACK BARRIER FILMS PRIVATE LIMITED",
"SUNPARK GRANITO PRIVATE LIMITED",
"SUNPARK HOTEL AND RESORTS PRIVATE LIMITED",
"SUNPAY SANDWICHES PRIVATE LIMITED",
"SUNPEDIA JEWELLERS PRIVATE LIMITED",
"SUNPHOENIX NEWSPRINT PRIVATE LIMITED",
"SUNPLAST ELECTRONICS PRIVATE LIMITED",
"SUNPOWER CEMENT COMPANY PRIVATE LIMITED",
"SUNPRA ESTATES PRIVATE LIMITED",
"SUNPRIME ENERGY SOLUTIONS PRIVATE LIMITED",
"SUNPRIME INFRATECH PRIVATE LIMITED",
"SUNPRISM INDIA PRIVATE LIMITED",
"SUNPRO INSTRUMENTS (INDIA) PRIVATE LIMITED",
"SUNPRO INTEGRATED SERVICES LIMITED",
"SUNPRO SOLARSYS PRIVATE LIMITED",
"SUNPURE ENERGY PRIVATE LIMITED",
"SUNPURE EXTRACTS PRIVATE LIMITED",
"SUNPURE TECHNOLOGIES PRIVATE LIMITED",
"SUNPV ENERGY PRIVATE LIMITED",
"SUNQUEST INFORMATION SYSTEMS INDIA PRIVATE LIMITED",
"SUNQURO CERAMIC PRIVATE LIMITED",
"SUNRADIANCE TECHNOLOGIES PRIVATE LIMITED",
"SUNRAISE TECHNOTEX PRIVATE LIMITED",
"SUNRAJ CERAMICS PRIVATE. LIMITED.",
"SUNRAJ CORRUGATORS",
"SUNRAJ CYCLE INDUSTRIES",
"SUNRAJ DIAMOND EXPORTS LIMITED",
"SUNRAJA OIL INDUSTRIES PRIVATE LIMITED",
"SUNRAY COTSPIN PRIVATE LIMITED",
"SUNRAY DESIGNS PRIVATE LIMITED",
"SUNRAY ENGINEERING AND TECHNOLOGIES P LIMITED",
"SUNRAY GLASS PRIVATE LIMITED",
"SUNRAY GLOBALTEX PRIVATE LIMITED",
"SUNRAY GREEN SPACE PRIVATE LIMITED",
"SUNRAY INTEXO PRIVATE LIMITED",
"SUNRAY MATERIAL HANDLING PRIVATE LIMITED",
"SUNRAY PROJECTS PRIVATE LIMITED",
"SUNRAY RESORTS PRIVATE LIMITED",
"SUNRAY TILES PRIVATE LIMITED",
"SUNRAYS BIZ SERV PRIVATE LIMITED",
"SUNRAYS ENGINEERS PRIVATE LIMITED",
"SUNRAYS IMAGE TECHNOLOGY PRIVATE LIMITED",
"SUNRAYS INFRA SPACE LIMITED",
"SUNRAYS LAPAROSCOPIC CENTRE",
"SUNRAYS PACKAGING PRIVATE LIMITED",
"SUNRAYS PROPERTIES AND INVESTMENTS COMPANY PRIVATE LIMITED",
"SUNRAYS SHIPPING SERVICES PRIVATE LIMITED",
"SUNRAYSIA ORGANICS PRIVATE LIMITED",
"SUNREFORM ENERGY PRIVATE LIMITED",
"SUNREN AUTOMOTIVE PRIVATE LIMITED",
"SUNREN INDUSTRIES PRIVATE LIMITED",
"SUNREN POWER PRIVATE LIMITED",
"SUNREN TECHNICAL SOLUTIONS PRIVATE LIMITED",
"SUNREST LIFESCIENCE LIMITED",
"SUNREST LIFESCIENCE PRIVATE LIMITED",
"SUNREX FABRICS PRIVATE LIMITED",
"SUNRIA AGRO PRODUCE (OPC) PRIVATE LIMITED",
"SUNRICH CHARTERING PRIVATE LIMITED",
"SUNRICH INTERIOR MANUFACTURING PRIVATE LIMITED",
"SUNRICH LOGISTICS PRIVATE LIMITED",
"SUNRICH SHIP MANAGEMENT PRIVATE LIMITED",
"SUNRICH TECHNOLOGIES PRIVATE LIMITED",
"SUNRIDER INDIA PRIVATE LIMITED",
"SUNRIDGES SPORTING GOODS PRIVATE LIMITED",
"SUNRIISE AGRO INDUSTRIES PRIVATE LIMITED",
"SUNRING TRADE PRIVATE LIMITED",
"SUNRISE ACADEMY MANAGEMENT SOCIETY",
"SUNRISE AGRI TECH PRIVATE LIMITED",
"SUNRISE AGRILAND DEVELOPMENT AND RESEARCH PRIVATE LIMITED",
"SUNRISE ASHIYANA PRIVATE LIMITED",
"SUNRISE AUTOCOMP PRIVATE LIMITED",
"SUNRISE AUTOMATION ENTERPRISES",
"SUNRISE AUTOMATION SOLUTIONS PRIVATE LIMITED",
"SUNRISE AUTOTECH PRIVATE LIMITED",
"SUNRISE AUTOWORLD PRIVATE LIMITED",
"SUNRISE AUXICHEM PRIVATE LIMITED",
"SUNRISE BEVERAGES PRIVATE LIMITED",
"SUNRISE BISCUIT COMPANY PRIVATE LIMITED",
"SUNRISE BIZCOM PRIVATE LIMITED",
"SUNRISE BIZTECH SYSTEMS PRIVATE LIMITED",
"SUNRISE BLINDS INDIA PRIVATE LIMITED",
"SUNRISE BROKING PRIVATE LIMITED",
"SUNRISE BUILDERS",
"SUNRISE CAR CARE INDIA PRIVATE LIMITED",
"SUNRISE CHEMICALS PVT. LTD.",
"SUNRISE CHEMTECH PRIVATE LIMITED",
"SUNRISE CIVICON PROJECT PRIVATE LIMITED",
"SUNRISE COMMERCIALS PRIVATE LIMITED",
"SUNRISE CONSULTANCY SERVICES",
"SUNRISE CONTAINERS LIMITED",
"SUNRISE COPIERS P LIMITED",
"SUNRISE CORRUGATED INDIA PRIVATE LIMITED",
"SUNRISE CREATIVE FASHION PRIVATE LIMITED",
"SUNRISE DEALCOM PRIVATE LIMITED",
"SUNRISE DISTRIBUTORS",
"SUNRISE DREAM SHELTERS PRIVATE LIMITED",
"SUNRISE DYEING AND PRINTING MILLS PRIVATE LIMITED",
"SUNRISE DYERS AND PROCESSORS PRIVATE LIMITED",
"SUNRISE EARTHMOVERS PRIVATE LIMITED",
"SUNRISE EFFICIENT MARKETING LIMITED",
"SUNRISE EGG TRADERS",
"SUNRISE ELECTROMELT PRIVATE LIMITED",
"SUNRISE EMBEDDED SOLUTIONS PRIVATE LIMITED",
"SUNRISE ENCON PROJECTS PRIVATE LIMITED",
"SUNRISE ENGINEERING SOLUTIONS PRIVATE LIMITED",
"SUNRISE ENGITECH PRIVATE LIMITED",
"SUNRISE ENTERPRISES",
"SUNRISE ESUPPORT PRIVATE LIMITED",
"SUNRISE F & B RESTAURANT PRIVATE LIMITED",
"SUNRISE FACILITATORS PRIVATE LIMITED",
"SUNRISE FINCAP LIMITED",
"SUNRISE FOAM PRODUCT PRIVATE LIMITED",
"SUNRISE FREIGHT FORWARDERS PRIVATE LIMITED",
"SUNRISE FREIGHT MOVERS PRIVATE LIMITED",
"SUNRISE FURNITURE SOLUTIONS PRIVATE LIMITED",
"SUNRISE GILTS & SECURITIES PRIVATE LIMITED",
"SUNRISE GLASS INDUSTRIES PRIVATE. LIMITED.",
"SUNRISE GLOBAL SCHOOL",
"SUNRISE GROUP",
"SUNRISE HEAVY LIFTERS PRIVATE LIMITED",
"SUNRISE HOSPITAL PRIVATE LIMITED",
"SUNRISE HOTELS (INDIA) PRIVATE LIMITED",
"SUNRISE HOUSE KEEPING AND SUPPORT SERVICES PRIVATE LIMITED",
"SUNRISE HOUSING CONSTRUCTIONS LIMITED",
"SUNRISE HYGIENE FLOURS PRIVATE LIMITED",
"SUNRISE IMMIGRATION CONSULTANTS PRIVATE LIMITED",
"SUNRISE INDUSTRIAL TRADERS LIMITED",
"SUNRISE INDUSTRIES INDIA LIMITED",
"SUNRISE INFRAMART PRIVATE LIMITED",
"SUNRISE INFRASOLUTIONS PRIVATE LIMITED",
"SUNRISE INFRAVENTURE LIMITED",
"SUNRISE INNOVATIVE INFRASTRUCTURE PRIVATE LIMITED",
"SUNRISE INSTITUTE OF MEDICAL SCIENCES PRIVATE LIMITED",
"SUNRISE INSTRUMENTS PRIVATE LIMITED",
"SUNRISE INTEGRATED FACILITY PRIVATE LIMITED",
"SUNRISE INTERNATIONAL LABS LIMITED",
"SUNRISE KNITTING MILLS PRIVATE LIMITED",
"SUNRISE LOGISTICS PRIVATE LIMITED",
"SUNRISE LUXURY RETAIL PRIVATE LIMITED",
"SUNRISE MARITIME PTE LIMITED",
"SUNRISE MEDIA & EFFECTS PRIVATE LIMITED",
"SUNRISE MENTORS PRIVATE LIMITED",
"SUNRISE METACHEM INDIA PRIVATE LIMITED",
"SUNRISE METALS PVT LTD",
"SUNRISE MULTI STEEL PRIVATE LIMITED",
"SUNRISE MULTI TECH FASTENERS PRIVATE LIMITED",
"SUNRISE NATURALS PRIVATE LIMITED",
"SUNRISE ORGANISERS PRIVATE LIMITED",
"SUNRISE PLASTIC & PAPER INDUSTRIES INDIA PRIVATE LIMITED",
"SUNRISE POLYPACK PRIVATE LIMITED",
"SUNRISE PRINTPACK PRIVATE LIMITED",
"SUNRISE PROCESS EQUIPMENTS",
"SUNRISE PUBLIC SCHOOL",
"SUNRISE REALCON PRIVATE LIMITED",
"SUNRISE REMEDIES PRIVATE LIMITED",
"SUNRISE RETREADS PVT LTD",
"SUNRISE RICELAND PRIVATE LIMITED",
"SUNRISE SAI DEVELOPERS PRIVATE LIMITED",
"SUNRISE SEAFOODS INDIA PRIVATE LIMITED",
"SUNRISE SERVICES",
"SUNRISE SHEET METAL SOLUTIONS PRIVATE LIMITED",
"SUNRISE SILICHEM INDUSTRIES PRIVATE LIMITED",
"SUNRISE SPORTS INDIA PRIVATE LIMITED",
"SUNRISE STAINLESS PRIVATE LIMITED",
"SUNRISE STONE INDUSTRIES",
"SUNRISE STRUCTURALS AND ENGINEERING PVT LTD",
"SUNRISE STRUCTURES & DEVELOPERS PRIVATE LIMITED",
"SUNRISE SUBSISTENCE AND SECURITY PRIVATE LIMITED",
"SUNRISE SYNTHETICS PRIVATE LIMITED",
"SUNRISE TANKS PRIVATE LIMITED",
"SUNRISE TELECOM INFRASTRUCTURE PRIVATE LIMITED",
"SUNRISE TEXTILE INDUSTRIES",
"SUNRISE TIMPLY CO PRIVATE LIMITED",
"SUNRISE TOOLING SYSTEMS P LIMITED",
"SUNRISE TRADEMART PRIVATE LIMITED",
"SUNRISE VICTUALS PRIVATE LIMITED",
"SUNRISE VIDYALAYA",
"SUNRISE WHEELS PRIVATE LIMITED",
"SUNRISE WORKFORCE PRIVATE LIMITED",
"SUNRISING STAFFING SERVICES PRIVATE LIMITED",
"SUNRIX IT SOLUTIONS PRIVATE LIMITED",
"SUNROCK INFRATECH PRIVATE LIMITED",
"SUNROOF BUILDWELL PRIVATE LIMITED",
"SUNROOT ENERGY PRIVATE LIMITED",
"SUNROSE SYNTEX PRIVATE LIMITED",
"SUNROVER PRIVATE LIMITED",
"SUNRYDGE INDIA HERITAGE PRIVATE LIMITED",
"SUNRYDGE KILA RESORTS PRIVATE LIMITED",
"SUNSACK GEOTEX PRIVATE LIMITED",
"SUNSAI PHARMA EQUIPMENTS PRIVATE LIMITED",
"SUNSAT INFOTECH PRIVATE LIMITED",
"SUNSAT WAREHOUSING PRIVATE LIMITED",
"SUNSDUST COMMERCIAL PRIVATE LIMITED",
"SUNSELECT PRIVATE LIMITED",
"SUNSERVICES FORKLIFT PARTS PRIVATE LIMITED",
"SUNSHADE ENERGY PRIVATE LIMITED",
"SUNSHADE FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"SUNSHAKTI SOLAR POWER PROJECTS PRIVATE LIMITED",
"SUNSHELL TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"SUNSHIELD CHEMICALS LIMITED",
"SUNSHINE AGRI PRIVATE LIMITED",
"SUNSHINE BAKERY FOODS PRIVATE LIMITED",
"SUNSHINE BUILDERS",
"SUNSHINE CAPITAL LIMITED",
"SUNSHINE CARDIAC CENTRE LLP",
"SUNSHINE CARS PRIVATE LIMITED",
"SUNSHINE CHENNAI SENIOR SECONDARY SCHOOL",
"SUNSHINE COALMIN PRIVATE LIMITED",
"SUNSHINE CONTAINERS PRIVATE LTD",
"SUNSHINE CONVEYORS PRIVATE LIMITED",
"SUNSHINE ELECTRIC COMPANY PRIVATE LIMITED",
"SUNSHINE ENTERPRISES",
"SUNSHINE EXTRUSIONS INDIA PRIVATE. LIMITED.",
"SUNSHINE FACILITY MANAGEMENT PRIVATE LIMITED",
"SUNSHINE FASTECH LIMITED",
"SUNSHINE FASTECH PRIVATE LIMITED",
"SUNSHINE FASTENERS PRIVATE LIMITED",
"SUNSHINE FERTILITY AND IVF CENTRE PRIVATE LIMITED",
"SUNSHINE FIBRE PRIVATE LIMITED",
"SUNSHINE FINE CHEMSOL INDIA PRIVATE LIMITED",
"SUNSHINE FINSEC AND MERCANTILE LIMITED",
"SUNSHINE FINVEST PRIVATE LIMITED",
"SUN-SHINE FOOD PRODUCTS",
"SUNSHINE GLASS COMPANY PRIVATE LIMITED",
"SUNSHINE GLOBAL HOSPITAL",
"SUNSHINE HATCHERIES PVT LTD",
"SUNSHINE HEALTHCARE SERVICES (INDIA) PRIVATE LIMITED",
"SUNSHINE HOSPITALS",
"SUNSHINE HYDRAULICS INDIA PRIVATE LIMITED",
"SUNSHINE INDIA INC",
"SUNSHINE INDO PROJECTS PRIVATE LIMITED",
"SUNSHINE INFRA PRIVATE LIMITED",
"SUNSHINE INFRAENERGY PRIVATE LIMITED",
"SUNSHINE INFRAESTATE PRIVATE LIMITED",
"SUNSHINE INFRAWELL PRIVATE LIMITED",
"SUNSHINE IT INFRA SERVICES PRIVATE LIMITED",
"SUNSHINE LAMINATORS (SILVASSA) PRIVATE LIMITED",
"SUNSHINE LIQUID STORAGE PRIVATE LIMITED",
"SUNSHINE ORGANICS PVT LTD",
"SUNSHINE OVERSEAS PRIVATE LIMITED",
"SUNSHINE PAP TECH PRIVATE LIMITED",
"SUNSHINE PAP-TECH PRIVATE. LIMITED.",
"SUNSHINE PICTURES PRIVATE LIMITED",
"SUNSHINE POWER PRODUCTS PRIVATE LIMITED",
"SUNSHINE POWERTRONICS PRIVATE LIMITED",
"SUNSHINE REFRACTORIES PRIVATE LIMITED",
"SUNSHINE ROOFING PRIVATE LIMITED",
"SUNSHINE ROYAL DEVELOPERS PRIVATE LIMITED",
"SUNSHINE SOLPOWER GENERATION LIMITED",
"SUNSHINE STOCK BROKING PRIVATE LIMITED",
"SUNSHINE TEAHOUSE PRIVATE LIMITED",
"SUNSHINE TECH PVT LTD",
"SUNSHINE TILES COMPANY PRIVATE LIMITED",
"SUNSHINE UTILITY SERVICES PRIVATE LIMITED",
"SUNSHINE VEGETABLES PRIVATE LIMITED",
"SUNSHINE VELVET PRIVATE LIMITED",
"SUNSHINE WASHERS PRIVATE LIMITED",
"SUNSHOT TECHNOLOGIES PRIVATE LIMITED",
"SUNSKRITY ENERGY PRIVATE LIMITED",
"SUNSKY IRON FOUNDRY PRIVATE LIMITED",
"SUNSKY LOGISTICS PRIVATE LIMITED",
"SUNSMART TECHNOLOGIES PRIVATE LIMITED",
"SUNSMITH HEALTHCARE PRIVATE LIMITED",
"SUNSOFT ERP SOLUTIONS PRIVATE LIMITED",
"SUNSOIL METALS PRIVATE LIMITED",
"SUNSON ENERGY DEVICES PRIVATE LIMITED",
"SUNSOVI INFOTECH PRIVATE LIMITED",
"SUNSPARSH ENERGY SOLUTIONS PRIVATE LIMITED",
"SUNSPRING SOLAR PRIVATE LIMITED",
"SUNSTAR APPARELS PRIVATE LIMITED",
"SUNSTAR COMPUTERS PRIVATE LIMITED",
"SUNSTAR ENTERPRISES PRIVATE LIMITED",
"SUNSTAR EXPOTRADE PRIVATE LIMITED",
"SUNSTAR EXTRACTION PRIVATE LIMITED",
"SUNSTAR FINANCE AND HOLDINGS LIMITED",
"SUNSTAR GRAPHICS PRIVATE LIMITED",
"SUNSTAR LOGISTICS PRIVATE LIMITED",
"SUNSTAR LUBRICANTS LIMITED",
"SUNSTAR PRECISION FORGE LIMITED",
"SUNSTAR SALES AND DISTRIBUTION PRIVATE LIMITED",
"SUNSTAR SHARE BROKERS PRIVATE LIMITED",
"SUNSTAR TRADING AND INVESTMENT PRIVATE LIMITED",
"SUNSTONE ENGINEERING INDUSTRIES PVT LTD",
"SUNSTORM INTERNATIONAL PRIVATE LIMITED",
"SUNSTREAM CITY PRIVATE LIMITED",
"SUNSTREET SOLAR PRIVATE LIMITED",
"SUNSTRENGTH RENEWABLES PRIVATE LIMITED",
"SUNSTRENGTH SOLAR PRIVATE LIMITED",
"SUNSTRIKE INFOCOM PRIVATE LIMITED",
"SUNSTROAT GREEN TECHNOLOGIES PRIVATE LIMITED",
"SUNSTYLE DESIGN STUDIO PRIVATE LIMITED",
"SUNSUBA POWERDEAL LIMITED",
"SUNSUN ETECHNOLOGIES PRIVATE LIMITED",
"SUNSURE ENERGY PRIVATE LIMITED",
"SUNTANA TEXTILE MILLS PRIVATE LIMITED",
"SUN-TAP POWER PROJECTS PRIVATE LIMITED",
"SUNTARA COSMETICS PRIVATE LIMITED",
"SUNTEC AGRI EQUIPMENTS INDIA PRIVATE LIMITED",
"SUNTEC BUSINESS SOLUTIONS PRIVATE LIMITED",
"SUNTEC DIGITAL SOLUTIONS PRIVATE LIMITED",
"SUNTEC ENERGY SYSTEMS",
"SUNTEC INFRASTRUCTURE PRIVATE LIMITED",
"SUNTEC WEB SERVICES PRIVATE LIMITED",
"SUNTECH APPLICATIONS PRIVATE LIMITED",
"SUNTECH BUSINESS SOLUTIONS LLP",
"SUNTECH CONSULTANCY SERVICES",
"SUNTECH CREW MANAGEMENT PRIVATE LIMITED",
"SUNTECH ENGI-AUTOMATION PRIVATE LIMITED",
"SUNTECH ENGINEERING PRIVATE LIMITED",
"SUNTECH FIBRE EQUIPMENTS & ENGINEERING PRIVATE LIMITED",
"SUNTECH GEOTEXTILE PRIVATE LIMITED",
"SUNTECH GLOBAL INFOSOLUTIONS PRIVATE LIMITED",
"SUNTECH HEALTHCITY PRIVATE LIMITED",
"SUNTECH INFRA SOLUTIONS PRIVATE LIMITED",
"SUNTECH LANDRIANI MACHINE TOOLS PRIVATE LIMITED",
"SUNTECH MEDICAL SYSTEMS LIMITED",
"SUNTECH OVERSEAS PRIVATE LIMITED",
"SUNTECH SHIP MANAGEMENT PRIVATE LIMITED",
"SUNTECH STRUCTURAL SYSTEMS PRIVATE LIMITED",
"SUNTECH SYSTEMS PRIVATE LIMITED",
"SUNTECH VISION LIMITED",
"SUNTECK HI-TECH PRIVATE LIMITED",
"SUNTECK REAL ESTATES PRIVATE LIMITED",
"SUNTECK REALTY LIMITED",
"SUNTEK AXPRESS INDIA PRIVATE LIMITED",
"SUNTEK CHLORIDES PRIVATE LIMITED",
"SUNTEK ENERGY SYSTEMS PRIVATE LIMITED",
"SUNTEK LOGISTICS INDIA PRIVATE LIMITED",
"SUNTEK PLASTICIZER PRIVATE LIMITED",
"SUNTEK POLYPACK PRIVATE LIMITED",
"SUNTEK STATIONERS PRIVATE LIMITED",
"SUNTEL CERAMIC PRIVATE LIMITED",
"SUNTEL MARKETING PRIVATE LIMITED",
"SUNTELE GLOBAL DATA PROCESSING PRIVATE LIMITED",
"SUNTERA ENERGY SERVICES (INDIA) PRIVATE LIMITED",
"SUNTERRA RENEWABLES PRIVATE LIMITED",
"SUNTERRACE ENERGY ONE PRIVATE LIMITED",
"SUNTEX CLOTHING LIMITED",
"SUNTEX CREATION PRIVATE LIMITED",
"SUNTEX PROCESSING MILLS PRIVATE LIMITED",
"SUNTIME TRADERS PRIVATE LIMITED",
"SUNTON CERAMIC PRIVATE LIMITED",
"SUNTOOL INDIA PRIVATE LIMITED",
"SUNTOP CERAMIC PRIVATE LIMITED",
"SUNTOP ENTERPRISES PRIVATE LIMITED",
"SUNTRACK COMMERCE PRIVATE LIMITED SCPL",
"SUNTRACK ENERGY SYSTEMS PRIVATE LIMITED",
"SUNTRAP ENERGY SOLUTIONS PRIVATE LIMITED",
"SUNTRECK FINANCE PRIVATE LIMITED",
"SUNTREK SOFTECH PRIVATE LIMITED",
"SUNTRIL PHARMACEUTICALS PRIVATE LIMITED",
"SUNTRONIC INFOTECH PRIVATE LIMITED",
"SUNTRONIC RENEWABLES PRIVATE LIMITED",
"SUNTROP SOLAR PRIVATE LIMITED",
"SUNTRUST ALUMINIUM PRIVATE LIMITED",
"SUNTRUST BANKS INC.",
"SUN-UP (INDIA ) PACKAGING MACHINERY COMPANY PRIVATE LIMITED",
"SUNUP AGROFOODS PRIVATE LIMITED",
"SUN-UP INDIA MACHINERY COMPANY PRIVATE LIMITED",
"SUNUSA INDUSTRIES PRIVATE LIMITED",
"SUNVAULT POWERTECH PRIVATE LIMITED",
"SUNVERGE PRIVATE LIMITED",
"SUNVESTA PIPES PRIVATE LIMITED",
"SUNVET PHARMA PRIVATE LIMITED",
"SUNVIEW EXPRESS LOGISTICS PRIVATE LIMITED",
"SUNVIEW RETAIL PRIVATE LIMITED",
"SUNVIEW TRADEMART PRIVATE LIMITED",
"SUNVIJ DRUGS PRIVATE LIMITED",
"SUNVIK STEELS PRIVATE LIMITED",
"SUNVILLA SHIPPING MARITIME PRIVATE LIMITED",
"SUNVILLE HOTELS AND RESORTS PRIVATE LIMITED",
"SUNVIN INDUSTRIES PRIVATE LIMITED",
"SUNVISION BUILDERS PRIVATE LIMITED",
"SUN-VISOR ENGINEERS PRIVATE LIMITED",
"SUNVISORS INDIA PRIVATE LIMITED",
"SUNVIZ IMPEX PRIVATE LIMITED",
"SUNVOICE ELECTRONICS PRIVATE LIMITED",
"SUNVOLTA INDUSTRIES PRIVATE LIMITED",
"SUNWAT SOLUTIONS PRIVATE LIMITED",
"SUNWATT SOLTECH P LIMITED",
"SUNWAVE FASHIONS PRIVATE LIMITED",
"SUNWAVE MANAGEMENT AND SECURITY SERVICES PRIVATE LIMITED",
"SUNWAY CONSTRUCTION INDIA PRIVATE LIMITED",
"SUNWAY OPUS INTERNATIONAL PRIVATE LIMITED",
"SUNWAY RNS TJ PRIVATE LIMITED",
"SUNWAY RNSIL MC PRIVATE LIMITED",
"SUNWAY TECHNOLOGIES PRIVATE LIMITED",
"SUNWAYS BIOSCIENCE EXPORT PRIVATE LIMITED",
"SUNWAYS INDIA PRIVATE LIMITED",
"SUNWAYS INOR MEDICAL DEVICES PRIVATE LIMITED",
"SUNWAYS LABORATORIES PRIVATE LIMITED",
"SUNWAYS ROHTO PHARMACEUTICAL PRIVATE LIMITED",
"SUNWEAVE INDUSTRIES PRIVATE LIMITED",
"SUNWELLS OXYGEN INDIA PRIVATE LIMITED",
"SUNWETA STEELS LIMITED",
"SUNWIN AUTO PRIVATE LIMITED",
"SUNWIN ENERGY AND INFRA PRIVATE LIMITED",
"SUNWIN FOOD & AGRO PRODUCTS PRIVATE LIMITED",
"SUNWIND DEVICES PRIVATE LIMITED",
"SUNWISE ENGINEERING PRIVATE LIMITED",
"SUNWODA ELECTRONIC INDIA PRIVATE LIMITED",
"SUNWOOD SPEAKERS PVT LTD",
"SUNWORKS COMPLETE SOLAR PRIVATE LIMITED",
"SUNWORKS ENERGY PRIVATE LIMITED",
"SUNWORLD DEVELOPERS PRIVATE LIMITED",
"SUNWORLD ENERGY PRIVATE LIMITED",
"SUNWORLD RESIDENCY PRIVATE. LIMITED.",
"SUNWORLD SOLAR POWER PRIVATE LIMITED",
"SUNWORLD VITRIFIED PRIVATE LIMITED",
"SUNXCHANGE MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"SUNYNA STEELS PRIVATE LIMITED",
"SUNYO MARKETING PRIVATE LIMITED",
"SUNYOUNG ELECTRONICS PRIVATE LIMITED",
"SUNZANT TECHNOLOGIES PRIVATE LIMITED",
"SUNZONE SOLAR SYSTEM INDIA PRIVATE LIMITED",
"SUOLA TEA ESTATES PVT LTD",
"SUOLIFICIO LINEA ITALIA INDIA PRIVATE LIMITED",
"SUONY FIBRE GLASS (INDIA) PVT LTD",
"SUPA BIOTECH PRIVATE LIMITED",
"SUPA FLEX PRIVATE LIMITED",
"SUPA LAMINATES PRIVATE LIMITED",
"SUPA STYLE MANUFACTURING PRIVATE LIMITED",
"SUPAASI SOLAR AUTO TRACKING SYSTEMS PRIVATE LIMITED",
"SUPACK INDUSTRIES PRIVATE LIMITED",
"SUPACK PRIVATE LIMITED",
"SUPADHA INFRA PRIVATE LIMITED",
"SUPAFLY ENTERPRISES PRIVATE LIMITED",
"SUPAI INFOTECH INDIA PRIVATE LIMITED",
"SUPAMA FOREX PRIVATE LIMITED",
"SUPAMA TRADING PRIVATE LIMITED",
"SUPANGITA ENGINEERS PRIVATE LIMITED",
"SUPARNA CHEMICALS LIMITED",
"SUPARNA FERTILISERS PRIVATE LIMITED",
"SUPARNA PLASTICS PRIVATE LIMITED",
"SUPARSHVA CYANITE INDIA PRIVATE LIMITED",
"SUPARSHVA DIAMOND PRIVATE LIMITED",
"SUPARSHVAMATI MERCANTILES PVT LTD",
"SUPARSHWASAGAR PRIVATE LIMITED",
"SUPATH HEALTHCARE SERVICES PRIVATE LIMITED",
"SUPATH INFO TECHNOLOGIES PRIVATE LIMITED",
"SUPDT CENTRAL JAIL JABALPUR",
"SUPDT EMPLOYEES STATE INSURANCE HOS UJJAIN",
"SUPDT GOVT CERTIFIED SCHOOL",
"SUPDT GOVT TB CLINIC JABALPUR",
"SUPDT JAIL JAIL HQ MP BHOPAL",
"SUPDT JAN SEWA RUGN ITARSI MADHYA PRADESH",
"SUPDT JAWAHARLAL NEHRU HOSPITAL GAS RAHAT BHOPAL",
"SUPDT. ENGINEER MANDAL WATER RESOURCE UJJAIN",
"SUPDT. ENGINEER MANDAL WATER RESOURCES KHARGONE",
"SUPEEMA COTTONS PRIVATE LIMITED",
"SUPER (INDIA) SPARES PRIVATE LIMITED",
"SUPER 4 SECURITY & DETECTIVE PRIVATE LIMITED",
"SUPER ADS CREATIVE MEDIA PRIVATE LIMITED",
"SUPER AGRO INDIA PRIVATE LIMITED",
"SUPER AGRO INDUSTRY",
"SUPER ALLOY CASTINGS PRIVATE LIMITED",
"SUPER AMMONIA PVT LTD",
"SUPER ANGEL SECURITAS PRIVATE LIMITED",
"SUPER AUDIO (MADRAS) PRIVATE LIMITED",
"SUPER AUTO ELECTRICALS PVT LTD",
"SUPER AUTO FORGE PRIVATE LIMITED",
"SUPER AUTO INDIA LIMITED",
"SUPER AUTOMOBILES LIMITED",
"SUPER BOND ADHESIVES PRIVATE LIMITED",
"SUPER BOND MANUFACTURING PVT. LTD.",
"SUPER BOND PANEL INDIA PRIVATE LIMITED",
"SUPER BRIGHT STEELS PRIVATE LIMITED",
"SUPER CASSETTES INDUSTRIES PRIVATE LIMITED",
"SUPER CASTINGS BOMBAY PRIVATE LIMITED",
"SUPER CHEMICAL AGENCIES PRIVATE LIMITED",
"SUPER CHEMIFIX PRIVATE LIMITED",
"SUPER CIRCLE AUTO LIMITED",
"SUPER CITY BUILDERS PRIVATE LIMITED",
"SUPER CITY DEVELOPERS PRIVATE LIMITED",
"SUPER CITYWAY LABS PRIVATE LIMITED",
"SUPER CLOTH STORE PRIVATE LIMITED",
"SUPER COIL SPRING MANUFACTURING CO PRIVATE LIMITED",
"SUPER COLD STORE PRIVATE LIMITED",
"SUPER COLLAPSIBLE TUBE INDUSTRIES PRIVATE LIMITED",
"SUPER COMMODITIES PVT LTD",
"SUPER COMPUTECH PRIVATE LIMITED",
"SUPER CONES INDIA PRIVATE LIMITED",
"SUPER CONTAINERS PRIVATE LIMITED",
"SUPER CRAFT FOUNDRY",
"SUPER CREATIONS INTERIORS & EXTERIORS PRIVATE LIMITED",
"SUPER CREATIVE GRAPHIC SERVICES PRIVATE LIMITED",
"SUPER CROP SAFE LIMITED",
"SUPER CRYOGENIC SYSTEMS PRIVATE LIMITED",
"SUPER DEALZZZ BUSINESS VENTURES PRIVATE LIMITED",
"SUPER DELUXE PAPER MILLS PRIVATE LIMITED",
"SUPER DELUXE UNIVERSAL PRIVATE LIMITED",
"SUPER DESIRE MONEY FOREX & TRAVELS PRIVATE LIMITED",
"SUPER DIAMOND NIRMAN PRIVATE LIMITED",
"SUPER DISTILLERIES PRIVATE LIMITED",
"SUPER DP PRODUCTS PRIVATE LIMITED",
"SUPER DRILLING PRIVATE LIMITED",
"SUPER DRY DESICCANT PRIVATE LIMITED.",
"SUPER DYNIC CLOTHING PRIVATE LIMITED",
"SUPER E FACTORY DEPOT PRIVATE LIMITED",
"SUPER EASY SOFTWARE PRIVATE LIMITED",
"SUPER ELECTRO FILMS LIMITED",
"SUPER ELECTRO PROCESSORS PRIVATE LIMITED",
"SUPER ELECTRONICS PRIVATE LIMITED",
"SUPER ELEMENTS PRIVATE LIMITED",
"SUPER ELMECH ENGINEERS PRIVATE LIMITED",
"SUPER EMPIRE INDUSTRIES PRIVATE LIMITED",
"SUPER ENGINEERS",
"SUPER ENGINEERS (INDIA) PRIVATE LIMITED",
"SUPER ENGI-TECH PRIVATE LIMITED",
"SUPER EX-SERVICEMEN COS PRIVATE LIMITED",
"SUPER FACILITY SERVICES PRIVATE LIMITED",
"SUPER FARM PRODUCTS PRIVATE LIMITED",
"SUPER FASHIONS INDIA PRIVATE LIMITED",
"SUPER FAST HOLDINGS PRIVATE LIMITED",
"SUPER FILTERATION SYSTEMS (INDIA) PRIVATE LIMITED",
"SUPER FINE KNITTERS LIMITED",
"SUPER FIRE ENGINEERING PRIVATE LIMITED",
"SUPER FIREL PRIVATE LIMITED",
"SUPER FLEX PLASTIC MOULDERS PRIVATE LIMITED",
"SUPER FLOORINGS PRIVATE LIMITED",
"SUPER FOODIS PRIVATE LIMITED",
"SUPER FORD INSECTICIDES LIMITED",
"SUPER FORGINGS & STEELS LTD",
"SUPER FORMULATIONS PRIVATE LIMITED",
"SUPER FRESH AGRI PRODUCTS PRIVATE LIMITED",
"SUPER FRESH FRUITS PRIVATE LIMITED",
"SUPER FURNACE WORKS (INDIA) PRIVATE LIMITED",
"SUPER FURNITURE AND OFFICE SYSTEMS PRIVATE LIMITED",
"SUPER GALVANIZED SHEETS PRIVATE LIMITED",
"SUPER GASES & APPLIANCES PVT LTD",
"SUPER GO MOTORS INDIA PRIVATE LIMITED",
"SUPER GOLD BAKERY",
"SUPER GOLD SUITINGS PRIVATE LIMITED",
"SUPER GOOD AGROW PRIVATE LIMITED",
"SUPER HANDLERS PRIVATE LIMITED",
"SUPER HEAT INDUCTION INDUSTRIES PRIVATE LIMITED",
"SUPER HELIUM INDIA PRIVATE LIMITED",
"SUPER HIGHWAY INTERNATIONAL PRIVATE LIMITED",
"SUPER HIGHWAY LABS PRIVATE LIMITED",
"SUPER HOBS AND BROACHES PRIVATE LIMITED",
"SUPER HOME ELECTRONICS PRIVATE LIMITED",
"SUPER HOZE INDUSTRIES PRIVATE LIMITED",
"SUPER HYLAM PRIVATE LIMITED",
"SUPER INDIA BUILDPRO PRIVATE LIMITED",
"SUPER INDIA GLOBAL LOGISTICS PRIVATE LIMITED",
"SUPER INDIA PARIVAHAN PRIVATE LIMITED",
"SUPER INDIA PROPERTIES AND INDUSTRIES PRIVATE LIMITED",
"SUPER INDIA ROADLINKS PRIVATE LIMITED",
"SUPER INDIA ROADWAYS PRIVATE LIMITED",
"SUPER INDIA SHOE MATERIAL PRIVATE LIMITED",
"SUPER INDUSTRIAL LINING",
"SUPER INFOMATICS PRIVATE LIMITED",
"SUPER INFRATECH PRIVATE LIMITED",
"SUPER INN AND WELLNESS PRIVATE LIMITED",
"SUPER INVESTMENT (INDIA ) LIMITED",
"SUPER IRON FOUNDRY",
"SUPER ISPAT RAIPUR PRIVATE. LIMITED.",
"SUPER JEWELLERS PRIVATE LIMITED",
"SUPER KICKS INDIA PRIVATE LIMITED",
"SUPER KINO EQUIPMENTS PRIVATE LIMITED",
"SUPER KOL COMMERCE PRIVATE LIMITED",
"SUPER LAXMI ROADWAYS PRIVATE LIMITED",
"SUPER LIFECARE PRIVATE LIMITED",
"SUPER LOGI-TECH PRIVATE LIMITED",
"SUPER LPG APPLIANCES PRIVATE LIMITED",
"SUPER MACHINE WORKS PRIVATE LIMITED",
"SUPER MARCHE 37 TRADERS LLP",
"SUPER MARKETING SERVICES PRIVATE LIMITED",
"SUPER MAX AFFORDABLE HOUSING PRIVATE LIMITED",
"SUPER MAX CNC CENTRE PRIVATE LIMITED",
"SUPER MECHANICAL SEAL PRIVATE LIMITED",
"SUPER METAL REROLLERS PRIVATE LIMITED",
"SUPER METRIC FASTENERS PRIVATE LIMITED",
"SUPER MICA HOMES PRIVATE LIMITED",
"SUPER MICA PVT. LTD.",
"SUPER MOUNT PACK PRIVATE LIMITED",
"SUPER NEEDLE COLLECTIONS PRIVATE LIMITED",
"SUPER NOBLE AUTOMOBILE PRIVATE LIMITED",
"SUPER NOVA AUTOLITE PRIVATE LIMITED",
"SUPER NOVA TECH CRAFT ENGINEERING OVERSEAS LIMITED",
"SUPER OLEFINS PRIVATE LIMITED",
"SUPER ONTRACK TRAVEL SERVICES PRIVATE LIMITED",
"SUPER OVERSEAS PRIVATE LIMITED",
"SUPER PACKWELL PRIVATE LIMITED",
"SUPER PAINTS PRIVATE LIMITED",
"SUPER PANNEL PRIVATE LIMITED",
"SUPER PARTS PVT. LTD",
"SUPER PHOENIX INDIA LLP",
"SUPER PLASTIC COATS PRIVATE LIMITED",
"SUPER PLASTRONICS PRIVATE LIMITED",
"SUPER PLATECK PVT LTD",
"SUPER POLYMERS",
"SUPER POWER EQUIPMENTS PRIVATE LIMITED",
"SUPER POWER GADGETS PRIVATE LIMITED",
"SUPER PRIME CONSTRUCTION PRIVATE LIMITED",
"SUPER PRIME LAMINATES PRIVATE LIMITED",
"SUPER PROPACK PRIVATE LIMITED",
"SUPER PROTECTION SECURITY SERVICE PRIVATE LIMITED",
"SUPER PUBLICITY PRIVATE LIMITED",
"SUPER PUMPS PVT LTD",
"SUPER QUALI CAST INDIA PRIVATE LIMITED",
"SUPER RECORDS BUSINESS SERVICES LLP",
"SUPER RESTAURANT PRIVATE LIMITED",
"SUPER RESTRUANTS PRIVATE LIMITED",
"SUPER RETAILS PRIVATE LIMITED",
"SUPER RMC BUILDCON PRIVATE LIMITED",
"SUPER ROLLER FLOUR MILLS LIMITED",
"SUPER RUBBER MIX",
"SUPER SADIQ ENTERPRISES PRIVATE LIMITED",
"SUPER SAFE LOGISTICS (INDIA) PRIVATE LIMITED",
"SUPER SALES INDIA LIMITED",
"SUPER SALES MOTORS PRIVATE LIMITED",
"SUPER SALTS PRIVATE. LIMITED",
"SUPER SCANNING & DIAGNOSTICS PRIVATE LIMITED",
"SUPER SCIENTIFIC GLASS INDUSTRIES PRIVATE LIMITED",
"SUPER SCIENTIFIC SALES PRIVATE LIMITED",
"SUPER SCIENTIFIC WORKS PRIVATE LIMITED",
"SUPER SCREWS PRIVATE LIMITED",
"SUPER SEAFOOD PRODUCTS PRIVATE LIMITED",
"SUPER SEALS (INDIA) PRIVATE LIMITED",
"SUPER SEALS INDIA LIMITED",
"SUPER SEATS PRIVATE LIMITED",
"SUPER SECURITY SERVICES PRIVATE LIMITED",
"SUPER SHEET (INDIA) PRIVATE LIMITED",
"SUPER SHINE SERVICES PRIVATE LIMITED",
"SUPER SHOES LIMITED",
"SUPER SHUTDOWN RESOURCES",
"SUPER SHUTTLE LOGISTICS PRIVATE LIMITED",
"SUPER SLEUTH SECURITY AGENCY & ALLIED SERVICES PRIVATE LIMITED",
"SUPER SMELTERS LIMITED",
"SUPER SNACKS PRIVATE LIMITED",
"SUPER SOFT CARE PRODUCTS PRIVATE LIMITED",
"SUPER SONIC BROADBAND PRIVATE LIMITED",
"SUPER SONIC CARRIER PVT LTD",
"SUPER SONIC LOGISTICS PRIVATE LIMITED",
"SUPER SOUNDS PRIVATE LIMITED",
"SUPER SPECIALITIES PHARMA WAREHOUSING & LOGISTICS PRIVATE LIMITED",
"SUPER SPECIALITY PAEDIATRIC HOSPITAL&POST GRADUATE TRACHING INSTITUTE",
"SUPER SPEEDS PRIVATE LIMITED",
"SUPER SPINNING MILLS LIMITED",
"SUPER SPINTEX PRIVATE LIMITED",
"SUPER SPRINGS PRIVATE LIMITED",
"SUPER SQUAD CLOTHING PRIVATE LIMITED",
"SUPER STAHL INDIA PRIVATE LIMITED",
"SUPER STAR STEELS PRIVATE LIMITED",
"SUPER SUN SOLAR LIMITED",
"SUPER SURFACES INDIA PRIVATE LIMITED",
"SUPER SURGMED PRIVATE LIMITED",
"SUPER TANNERY LIMITED",
"SUPER TASTY BAKERY FOODS (INDIA) PRIVATE LIMITED",
"SUPER TEA PACKERS PRIVATE LIMITED",
"SUPER TECH CASTINGS PRIVATE LIMITED",
"SUPER TECH FORGINGS INDIA PRIVATE LIMITED",
"SUPER TECH LACES TIRUPUR PRIVATE LIMITED",
"SUPER TECHNICAL (INDIA) PRIVATE LIMITED",
"SUPER TECHNOFAB PRIVATE LIMITED",
"SUPER TECHNOFORGE PRIVATE LIMITED",
"SUPER TECHNOLOGIES PRIVATE LIMITED",
"SUPER TEXFAB PRIVATE LIMITED",
"SUPER TEXOWEAVC PVT LTD",
"SUPER THERMO SENSORS PRIVATE LIMITED",
"SUPER TOUCH PAINTS LIMITED",
"SUPER TRACTOR INDUSTRIES PRIVATE LIMITED",
"SUPER TRANSIT SERVICES PRIVATE LIMITED",
"SUPER TREADS PVT LTD.",
"SUPER TUG OFFSHORE SERVICES PRIVATE LIMITED",
"SUPER VALVES PRIVATE LIMITED",
"SUPER WAUDITE JOINTINGS PRIVATE LIMITED",
"SUPER WEALTH FINANCIAL ENTERPRISES PVT LTD",
"SUPER WINDING WIRES PRIVATE LIMITED",
"SUPER WOOLLENS PRIVATE LIMITED",
"SUPERAGE ADVERTISING PRIVATE LIMITED",
"SUPERANNUATIONOPS PRIVATE LIMITED",
"SUPERB AGROCHEM PRIVATE LIMITED",
"SUPERB AUDIT & MANAGEMENT SERVICES LIMITED",
"SUPERB CONSTRUCTION PRIVATE LIMITED",
"SUPERB DESIGNS PRIVATE LIMITED",
"SUPERB ENTERPRISES PRIVATE LIMITED",
"SUPERB FOOT TECH PRIVATE LIMITED",
"SUPERB HYGENIC DISPOSALS (INDIA) PRIVATE LIMITED",
"SUPERB MINERALS (INDIA) P.LTD.",
"SUPERB MY TRIP PRIVATE LIMITED",
"SUPERB SECURITY PRIVATE LIMITED",
"SUPERB TRAVEL DESIRE PRIVATE LIMITED",
"SUPERBOTICS MULTITECH PRIVATE LIMITED",
"SUPERBRANDS INDIA MEDIA PRIVATE LIMITED",
"SUPERCENTRE RETAILHUB PRIVATE LIMITED",
"SUPERCHIP ELECTRONICS PRIVATE LIMITED",
"SUPERCLEAN ENGINEERING COMPANY PRIVATE LIMITED",
"SUPERCLOUD PRIVATE LIMITED",
"SUPERCLOUDY FASHION WORLD PRIVATE LIMITED",
"SUPERCOAT PAINTS PRIVATE LIMITED",
"SUPERCOLD REFIGERATION SYSTEMS PRIVATE LIMITED",
"SUPERCOMP ELECTRONICS PVT. LTD.",
"SUPERCON CHEMICALS PRIVATE LIMITED",
"SUPERCRAFT FOUNDRY PRIVATE LIMITED",
"SUPERDNA TECHNOLAB PRIVATE LIMITED",
"SUPEREQ SYSTEMS PRIVATE LIMITED",
"SUPEREXCEL MARKETING PRIVATE LIMITED",
"SUPERFAAST PROPERTY MANAGEMENT PRIVATE LIMITED",
"SUPERFAB INDUSTRIES PRIVATE LIMITED",
"SUPERFAB MACHINES PRIVATE LIMITED",
"SUPERFASHION FILAMENTS PRIVATE LIMITED",
"SUPERFAST MOVERS & PACKERS PRIVATE LIMITED",
"SUPERFAT STUDIOS PRIVATE LIMITED",
"SUPERFEED SOLUTIONS PRIVATE LIMITED",
"SUPERFIL PRODUCTS PRIVATE LIMITED",
"SUPERFINE BRIGHT STEEL PVT LTD",
"SUPERFINE COMPONENTS PRIVATE LIMITED",
"SUPERFINE ELECTRONICS PRIVATE LIMITED",
"SUPERFINE FORGINGS PRIVATE LIMITED",
"SUPERFINE HOTELS PRIVATE LIMITED",
"SUPERFINE NEEDLES PRIVATE LIMITED",
"SUPERFINE PRINT & PACK PRIVATE LIMITED",
"SUPERFINE PROPERTIES LIMITED",
"SUPERFINE SAND (HYDERABAD) LIMITED",
"SUPERFIT CONTINENTAL PVT LTD",
"SUPERFLEET AUTO HIRE AGENCY PRIVATE LIMITED",
"SUPERFLO FILTERS PRIVATE LIMITED",
"SUPERFLO PRIVATE LIMITED",
"SUPERFLOW COOLING TOWERS PRIVATE LIMITED",
"SUPERFLOW PUMPS PRIVATE LIMITED",
"SUPERFLUX AND ELECTRODES (INDIA) PRIVATE LIMITED",
"SUPERFLY FILMS PRIVATE LIMITED",
"SUPERFREEZE INDIA PRIVATE LIMITED",
"SUPERFRY INDIA PRIVATE LIMITED",
"SUPERFYN TECHNO ENGINEERS PRIVATE LIMITED",
"SUPERGARD STEELS PRIVATE LIMITED",
"SUPERGEMS (INDIA) PVT LTD",
"SUPERGEMS JEWELLERY MANUFACTURING PRIVATE LIMITED",
"SUPERGROUP INDIA",
"SUPERHERO BRANDS PRIVATE LIMITED",
"SUPERHOMES CONSTRUCTIONS",
"SUPERHOUSE EDUCATION FOUNDATION",
"SUPERHOUSE LIMITED",
"SUPERHOUSE MERCHANTILE IMPEX PRIVATE LIMITED",
"SUPERHUB KOMPONENTS PRIVATE LIMITED",
"SUPERHUMANZ PRODUCTION STUDIOS PRIVATE LIMITED",
"SUPERINDIA (FRP) PRIVATE LIMITED",
"SUPERINTEDING ENGINEER MAIN DAM DIVISION BURLA",
"SUPERINTENDENT AHMADNAGAR DISTRICT PRISON",
"SUPERINTENDENT DISTRICT HOSPITAL",
"SUPERINTENDENT DISTRICT HOSPITAL HOWRAH",
"SUPERINTENDENT KOLHAPUR CENTRAL PRISON",
"SUPERINTENDENT LAND RECORDS CHHATARPUR OFFICE",
"SUPERINTENDENT M L A HOSTEL",
"SUPERINTENDENT MUMBAI CENTRAL PRISON",
"SUPERINTENDENT OF POLICE BEED",
"SUPERINTENDENT R R GENERAL HOSPITAL LIMBDI",
"SUPERINTENDENT RANIDURGAWATI HOSPITAL JABALPUR",
"SUPERINTENDENT REGIONAL MENTAL HOSPITAL",
"SUPERINTENDENT STATE EXCISE AHMEDNAGAR",
"SUPERINTENDENT STATE EXCISE THANE",
"SUPERINTENDENT SUB DISTRICT HOSPITAL RADHANPUR",
"SUPERINTENDENT SUB DIVISIONAL HOSPITAL KAMAKHYANAGAR",
"SUPERINTENDING ARCHAEOLOGIST A S I HYDERABAD CIRCLE",
"SUPERINTENDING ENGINEER DESIGN GANDHINAGAR",
"SUPERINTENDING ENGINEER ELECTRICAL AND SAFETY INDORE",
"SUPERINTENDING ENGINEER MECHANICAL",
"SUPERINTENDING ENGINEER MUMBAI CONSTRUCTION CIRCLE CHEMBUR",
"SUPERINTENDING ENGINEER QUALITY ASSURANCE DIVISION CUTTACK",
"SUPERINTENDING ENGINEER RENGALI DAM DIVISION RENGALI DAM SITE AMGUL",
"SUPERINTENDING ENGINEER ROADS & BUILDINGS DIVISION NO I CUTTACK",
"SUPERINTENDING ENGINEER RURAL WORKS",
"SUPERINTENDING ENGINEER V AND Q C CIRCLE AMRAVATI",
"SUPERIOR AGRO CROPS PRIVATE LIMITED.",
"SUPERIOR AIRCON PRIVATE LIMITED",
"SUPERIOR AUTOMOBILES PRIVATE LIMITED",
"SUPERIOR BOARD PRODUCTS PRIVATE LIMITED",
"SUPERIOR BOX INDUSTRIES PRIVATE LIMITED",
"SUPERIOR COMMODEAL PRIVATE LIMITED",
"SUPERIOR COMPUTRONICS PRIVATE LIMITED",
"SUPERIOR CONSTRUCTIONS PRIVATE LIMITED",
"SUPERIOR DIGITAL PRIVATE LIMITED",
"SUPERIOR DRINKS PRIVATE LIMITED",
"SUPERIOR ELECTRIC MACHINES PRIVATE LIMITED",
"SUPERIOR FILMS PVT LTD",
"SUPERIOR FINANCIAL CONSULTANCY SERVICES PRIVATE LIMITED",
"SUPERIOR FIRE AND SECURITY SERVICES PRIVATE LIMITED",
"SUPERIOR FOOD GRAINS PRIVATE LIMITED",
"SUPERIOR GLASS PRIVATE LIMITED",
"SUPERIOR GLASSTECH PRIVATE LIMITED",
"SUPERIOR HI-TECH CONTRACTORS PRIVATE LIMITED",
"SUPERIOR HYDROLIQUE PRIVATE LIMITED",
"SUPERIOR INDUSTRIAL ENTERPRISES LIMITED",
"SUPERIOR INDUSTRIES LIMITED",
"SUPERIOR INNOVATIVE TECHNOLOGIES PRIVATE LIMITED",
"SUPERIOR INVESTMENT (INDIA) LIMITED",
"SUPERIOR IOT PRIVATE LIMITED",
"SUPERIOR LIME INDUSTRIES LLP",
"SUPERIOR MACHINING SOLUTIONS PRIVATE LIMITED",
"SUPERIOR MALT PRIVATE LIMITED",
"SUPERIOR MANPOWER SERVICES PRIVATE LIMITED",
"SUPERIOR MOTORS PRIVATE LIMITED",
"SUPERIOR SERVICES ADVERTISING PRIVATE LIMITED",
"SUPERIOR SOFTWARE PRIVATE LIMITED",
"SUPERIOR SPICES (INDIA) PRIVATE LIMITED",
"SUPERIOR STRUCTURAL DESIGN AND DETAILING PRIVATE LIMITED",
"SUPERIOR WELDMESH PRIVATE LIMITED",
"SUPERITENDENT REGIONAL MENTAL HOSPITAL YERWADA",
"SUPERJET TECHNOLOGY PRIVATE LIMITED",
"SUPERKING GLASS AND CERAMIC PRIVATE LIMITED",
"SUPERKING MANUFACTURERS (TYRE)PVT LTD",
"SUPERKNIT INDUSTRIES",
"SUPERLAC PAINTS PRIVATE LIMITED",
"SUPERLATIVE PRODUCTS PRIVATE LIMITED",
"SUPERLATIVE STEEL CAST PRIVATE LIMITED",
"SUPERLATIVE WINES PRIVATE LIMITED",
"SUPER-LAXMI YARNTEX PVT LTD",
"SUPERLIFE HEALTHCARE PRIVATE LIMITED",
"SUPERLIFT MAGNETS PVT LTD",
"SUPERLINE LOGISTICS PRIVATE LIMITED",
"SUPERLITE JOINTINGS PRIVATE LIMITED",
"SUPERLON TEXTILE MILLS PRIVATE LIMITED",
"SUPERMAC INDUSTRIES INDIA LIMITED",
"SUPERMAN KNITTERS PRIVATE LIMITED",
"SUPERMARKET GROCERY SUPPLIES PRIVATE LIMITED",
"SUPERMAX BOILERS INDIA PRIVATE LIMITED",
"SUPERMAX DRUGS & PHARMACEUTICALS PRIVATE LIMITED",
"SUPERMAX INDUSTRIES PRIVATE LIMITED",
"SUPERMAX METAL PRIVATE LIMITED",
"SUPERMAX PERSONAL CARE PRIVATE. LIMITED.",
"SUPERMECH ENGINEERING & CONSTRUCTION PRIVATE LIMITED",
"SUPERMECH INFRASTRUCTURE PRIVATE LIMITED",
"SUPERMED PHARMACY - A UNIT OF REGENIX DRUGS LIMITED",
"SUPERMEXX ENERGIES PRIVATE LIMITED",
"SUPERMINT EXPORTS PRIVATE LIMITED",
"SUPERMOBILITY SERVICES PRIVATE LIMITED",
"SUPERNET ADVERTISING AND MARKETING PRIVATE LIMITED",
"SUPERNET TECHNOLOGIES INDIA PRIVATE LIMITED",
"SUPERNORMAL CONCEPTS PRIVATE LIMITED",
"SUPERNOVA (INDIA) PRIVATE LIMITED",
"SUPERNOVA AUTOMOBILES PRIVATE LIMITED",
"SUPERNOVA ELECTRICALS PRIVATE LIMITED",
"SUPERNOVA ELECTROTECH PRIVATE LIMITED",
"SUPERNOVA ENGINEERS LIMITED",
"SUPERNOVA PUBLISHERS AND DISTRIBUTORS PRIVATE LIMITED",
"SUPERNOVA SYSTEMS PRIVATE LIMITED",
"SUPERNOVA TRADERS PRIVATE LIMITED",
"SUPERNTENDING ENGINEER PUBLIC HEALTH DIVISION BHUBANESWAR",
"SUPERON SCHWEISSTECHNIK INDIA LIMITED",
"SUPEROPS TECHNOLOGIES PRIVATE LIMITED",
"SUPERPLAST POLYPRODUCTS INDIA PRIVATE LIMITED",
"SUPERPOWER INDUSTRIAL PRIVATE LIMITED",
"SUPERPOWER LUBRICANTS PRIVATE LIMITED",
"SUPERPROOF SEALS ENGINEERING PRIVATE LIMITED",
"SUPER-SEAL INDUSTRIES PRIVATE LIMITED",
"SUPERSEDE ALLOYS PRIVATE LIMITED",
"SUPERSEVA GLOBAL SERVICES PRIVATE LIMITED",
"SUPERSEVA SERVICE PRIVATE LIMITED",
"SUPERSHAKTI METALIKS LIMITED",
"SUPERSHEET STEEL PROFILE PRIVATE LIMITED",
"SUPERSHIELD PRIVATE LIMITED",
"SUPERSHINE ABS PLATERS PRIVATE LIMITED",
"SUPERSHINE HOSPITALITY SOLUTIONS PRIVATE LIMITED",
"SUPERSHINE JEWELLERY PRIVATE LIMITED",
"SUPERSHINE LAUNDRY SYSTEMS PRIVATE LIMITED",
"SUPERSHINE REALTORS PRIVATE LIMITED",
"SUPERSHINE SYNCOTEX PRIVATE LIMITED",
"SUPERSIGMA ALLOYS & FORGGINGS PRIVATE LIMITED",
"SUPERSIL ARCHITECTURAL PRODUCTS PRIVATE LIMITED",
"SUPERSIL BUILDING PRODUCTS PRIVATE LIMITED",
"SUPERSMART CEMENT PRIVATE LIMITED",
"SUPERSMART SECURITY FORCE PRIVATE LIMITED",
"SUPERSMELT FERRO ALLOYS PRIVATE LIMITED",
"SUPERSMELT INDUSTRIES PRIVATE LIMITED",
"SUPERSMELT SPONGE PRIVATE LIMITED",
"SUPERSOFT CONSULTANTS PRIVATE LIMITED",
"SUPERSONIC DISTRIBUTION AND SERVICES PRIVATE LIMITED",
"SUPERSONIC MARKETING PRIVATE LIMITED",
"SUPERSONIC TECHNOBUILD PRIVATE LIMITED",
"SUPERSOURCING TECHNOLOGIES PRIVATE LIMITED",
"SUPERSPEED CARRIERS PRIVATE LIMITED",
"SUPERSTAR AMUSEMENT PVT LTD",
"SUPERSTRONG ENGINEERS PRIVATE LIMITED",
"SUPERSTRUCT INFRACON PRIVATE LIMITED",
"SUPERSUN PREFAB PRIVATE LIMITED",
"SUPERTAL PRIVATE LIMITED",
"SUPERTEC MACHINES PVT LTD",
"SUPERTECH BUILDESTATE PRIVATE LIMITED",
"SUPERTECH COMMODITY CARE PRIVATE LIMITED",
"SUPERTECH CONDUCTORS (GUJARAT)PRIVATE LIMITED",
"SUPERTECH CONSTRUCTION COMPANY PRIVATE LIMITED",
"SUPERTECH ENGINEERING & TRADE PVT LTD",
"SUPERTECH ESTATE PRIVATE LIMITED",
"SUPERTECH FABRICS PRIVATE LIMITED",
"SUPERTECH FINANCIAL SERVICES PRIVATE LIMITED",
"SUPERTECH HOTELS PRIVATE LIMITED",
"SUPERTECH INDIA PRIVATE LIMITED",
"SUPERTECH INSTRUMENTATION SERVICES (INDIA) PRIVATE LIMITED",
"SUPERTECH LAMINATES PRIVATE LIMITED",
"SUPERTECH MECHANICAL ENGINEERS PRIVATE LIMITED",
"SUPERTECH MINE TOOLS PRIVATE LIMITED",
"SUPERTECH MULTIFAB PRIVATE LIMITED",
"SUPERTECH PAPERS PRIVATE LIMITED",
"SUPER-TECH PLASTPACK PRIVATE LIMITED",
"SUPERTECH PRECAST TECHNOLOGIES PRIVATE LIMITED",
"SUPERTECH RESORT PRIVATE LIMITED",
"SUPERTECH SERVICES PRIVATE LIMITED",
"SUPER-TECH SYSTEM INDIA PRIVATE LIMITED",
"SUPERTECH TOOLS AND COMPONENTS PRIVATE LIMITED",
"SUPERTEK RO SYSTEM PRIVATE LIMITED",
"SUPERTEX MILLS (INDIA) PRIVATE LIMITED",
"SUPERTOPMAN DRESSINGS PRIVATE LIMITED",
"SUPERTRACK LOGISTICS PRIVATE LIMITED",
"SUPERTRADE INFOTECH PRIVATE LIMITED",
"SUPERTRON ELECTRONICS PRIVATE LIMITED",
"SUPERTRUST FOREX PRIVATE LIMITED",
"SUPERUS SYSTEMS PRIVATE LIMITED",
"SUPERV TECHNOLOGIES PRIVATE LIMITED",
"SUPERVALU INC.",
"SUPERVALUE INDUSTRIES PRIVATE LIMITED",
"SUPERVALUE PHARMACY PRIVATE LIMITED",
"SUPERVALUE REALTY PRIVATE LIMITED SRPL",
"SUPERVISION SECURE SERVICES PRIVATE LIMITED",
"SUPERWAVE COMMUNICATION AND INFRASOLUTION PRIVATE LIMITED",
"SUPERWAVE INFRASYS SOLUTION PRIVATE LIMITED",
"SUPERWELD SOURCES PRIVATE LIMITED",
"SUPERWELL SERVICES PRIVATE LIMITED",
"SUPERWHEELS AUTOMOBILE PRIVATE LIMITED",
"SUPHALA AGRI GENETICS PRIVATE LIMITED",
"SUPHALA SEEDS (INDIA) PRIVATE LIMITED",
"SUPINCO AUTOMATION PRIVATE LIMITED",
"SUPL VENTURES PRIVATE LIMITED",
"SUPPLE RUBBER CHEMICALS PRIVATE LIMITED",
"SUPPLE TEK INDUSTRIES PRIVATE LIMITED",
"SUPPLEMENT SACK PRIVATE LIMITED",
"SUPPLY CHAIN LOGISTICS PRIVATE LIMITED",
"SUPPLY COMMISSIONER",
"SUPPLY TECHNOLOGIES INDIA PRIVATE LIMITED",
"SUPPLY WISDOM SERVICES INDIA PRIVATE LIMITED",
"SUPPLYCOPIA SOFTWARE SERVICES PRIVATE LIMITED",
"SUPPLYEXCEL SOLUTIONS PRIVATE LIMITED",
"SUPPORT DIRECT INDIA PRIVATE LIMITED",
"SUPPORT ELDERS PRIVATE LIMITED",
"SUPPORT FACILITIES PRIVATE LIMITED",
"SUPPORT FOR YOU INFO SOLUTIONS PRIVATE LIMITED",
"SUPPORT SHOP INDIA PRIVATE LIMITED",
"SUPPORT STAR CORPORATE SERVICES PRIVATE LIMITED",
"SUPPORT.COM INDIA PRIVATE LIMITED",
"SUPPORTAHOLIC TECHNOLOGIES PRIVATE LIMITED",
"SUPPORTIVE CAREERS PRIVATE LIMITED",
"SUPPORTMART TECHNICAL SERVICES PRIVATE LIMITED",
"SUPR INFOTECH SOLUTIONS PRIVATE LIMITED",
"SUPRA AGRI BIO INNOVATIONS PRIVATE LIMITED",
"SUPRA CELLTECH PRIVATE LIMITED",
"SUPRA CONTROLS PRIVATE LIMITED",
"SUPRA CRAFT PACKAGING PRIVATE LIMITED",
"SUPRA DIGITAL SERVICES PRIVATE LIMITED",
"SUPRA GARMENTS PRIVATE LIMITED",
"SUPRA HI TECH ELECTRO EQUIPMENTS PVT LTD",
"SUPRA INDUSTRIES PRIVATE LIMITED",
"SUPRA METAL-TECH PRIVATE LIMITED",
"SUPRA PACIFIC FINANCIAL SERVICES LIMITED",
"SUPRA PACK PVT LTD",
"SUPRA PRODUCTS PRIVATE LIMITED",
"SUPRA PUBLICITY PRIVATE LIMITED",
"SUPRA QUALITY EXPORTS (INDIA) PRIVATE LIMITED",
"SUPRA STEEL AND POWER PRIVATE LIMITED",
"SUPRA VESSELS AND ENGINEERS PRIVATE LIMITED",
"SUPRA WAREHOUSING PRIVATE LIMITED",
"SUPRAB TECHNOLOGIES PRIVATE LIMITED",
"SUPRABAT TIMBER PRIVATE LIMITED",
"SUPRABATH RESTAURANTS PRIVATE LIMITED",
"SUPRABHA COLOR GRAFIX PRIVATE LIMITED",
"SUPRABHA INDUSTRIES LIMITED",
"SUPRABHA PROTECTIVE PRODUCTS PVT LTD",
"SUPRABHA RICE MILL PRIVATE LIMITED",
"SUPRABHAT ASSOCIATES PRIVATE LIMITED",
"SUPRABHAT CORPORATION LLP",
"SUPRABHAT INFRABUILD & DEVELOPERS PRIVATE LIMITED",
"SUPRABHAT INFRASTRUCTURE AND PROJECTS PRIVATE LIMITED",
"SUPRABHAT INFRAZONE PRIVATE LIMITED",
"SUPRABHAT PRINTS PRIVATE LIMITED",
"SUPRABHAT ROLLER FLOUR MILLS PRIVATE LIMITED",
"SUPRABHATAM ALLOYS PRIVATE LIMITED",
"SUPRADA CONSTRUCTION COMPANY",
"SUPRADA INDUSTRIES PRIVATE LIMITED",
"SUPRAES PRIVATE LIMITED",
"SUPRAJA DAIRY PVT LTD",
"SUPRAJA FOODS PRIVATE LIMITED",
"SUPRAJA HOSPITALS",
"SUPRAJIT AUTOMOTIVE PRIVATE LIMITED",
"SUPRAJIT ENGINEERING LIMITED",
"SUPRAMA TECHNO PROJECTS PRIVATE LIMITED",
"SUPRAMOTORS PRIVATE LIMITED",
"SUPRAN EXIM PRIVATE LIMITED",
"SUPRANAV CHEMICAL INDUSTRIES PRIVATE LIMITED",
"SUPRAPTI FINVEST PRIVATE LIMITED",
"SUPRASANNA SOLAIRE ENERGY PRIVATE LIMITED",
"SUPRASESH GENERAL INSURANCE SERVICES AND BROKERS PRIVATE LIMITED",
"SUPRASOFT TECHNOLOGIES PRIVATE LIMITED",
"SUPRATECH MICROPATH PATHOLOGY PRIVATE LIMITED",
"SUPRATIK INFRA VENTURES PRIVATE LIMITED",
"SUPRAVENI CHEMICALS PRIVATE LIMITED",
"SUPRAVITZ LIFESCIENCES PRIVATE LIMITED",
"SUPRAWIN TECHNOLOGIES LIMITED",
"SUPREDIENT GEOLOGIST MINES & GEOLOGY DPT JAIPUR",
"SUPREEM PHARMACEUTICALS MYSORE PRIVATE. LIMITED.",
"SUPREET BUSINESS SOLUTIONS PRIVATE LIMITED",
"SUPREET CHEMICALS PRIVATE LIMITED",
"SUPREET ENGINEERS PRIVATE LIMITED",
"SUPREET VYAPAAR PVT LTD",
"SUPREME & COMPANY PRIVATE LIMITED",
"SUPREME ADVERTISING PRIVATE LIMITED",
"SUPREME AGRO PRODUCTS LIMITED",
"SUPREME AGROFOODS PRIVATE LIMITED",
"SUPREME AHMEDNAGAR KARMALA TEMBHURNI TOLLWAYS PRIVATE LIMITED",
"SUPREME AIR PRODUCTS PRIVATE LIMITED",
"SUPREME AIRCON PRIVATE LIMITED",
"SUPREME ALLIED SERVICES PRIVATE LIMITED",
"SUPREME AUDIOTEK PRIVATE LIMITED",
"SUPREME AUDIOTRONICS PRIVATE LIMITED",
"SUPREME AUTO CARRIER PRIVATE LIMITED",
"SUPREME AUTO DEALERS PRIVATE LIMITED",
"SUPREME AUTO INDIA PRIVATE. LIMITED.",
"SUPREME AUTOSHELL INDIA PRIVATE LIMITED",
"SUPREME BEST VALUE KOLHAPURSANGLI TOLLWAYS PRIVATE LIMITED",
"SUPREME BITUCHEM INDIA PRIVATE LIMITED",
"SUPREME BONDS PRIVATE LIMITED",
"SUPREME BOROCHEM PRIVATE LIMITED",
"SUPREME BREEDERS PRIVATE LIMITED",
"SUPREME BUILDCON PRIVATE LIMITED",
"SUPREME BUILDHOME PRIVATE LIMITED",
"SUPREME BUILDING SOLUTION PRIVATE LIMITED",
"SUPREME CARICO MOVERS PRIVATE LIMITED",
"SUPREME CHEMICAL VENTURES PRIVATE LIMITED",
"SUPREME COLLECTIONS INDIA PRIVATE LIMITED",
"SUPREME COLOUR ROOFING AND DECKING PRIVATE LIMITED",
"SUPREME COMMERCIAL ENTERPRISES LIMITED",
"SUPREME COMPONENTS INTERNATIONAL PTE LTD",
"SUPREME COMPUTERS INDIA PRIVATE LIMITED",
"SUPREME CONSTRUCTION AND DEVELOPERS PRIVATE LIMITED",
"SUPREME CONTROLING VALVE PRIVATE LIMITED",
"SUPREME COOKWARES PRIVATE LIMITED",
"SUPREME CORRUGATING INDUSTRIES PRIVATE LIMITED",
"SUPREME CORRUGATORS PRIVATE LIMITED",
"SUPREME COURT BAR CO-OPERATIVE HOUSE BUILDING SOCIETY LIMITED",
"SUPREME COURT OF INDIA",
"SUPREME DIAJEWELS PRIVATE LIMITED",
"SUPREME DYECHEM PRIVATE LIMITED",
"SUPREME EDUCATION PRIVATE LIMITED",
"SUPREME ELECTRICAL ENGINEERING PRIVATE LIMITED",
"SUPREME ELECTRICAL PRIVATE LIMITED",
"SUPREME ELECTRICALS AND SWITCHGEARS INDIA PRIVATE LIMITED",
"SUPREME ELEVATORS LIMITED",
"SUPREME ENGINEERING LIMITED",
"SUPREME ENTERPRISES",
"SUPREME EQUIPMENTS PRIVATE LIMITED",
"SUPREME FACILITY MANAGEMENT LIMITED",
"SUPREME FACILITY MANAGEMENT PRIVATE LIMITED",
"SUPREME FEEDS INDIA PRIVATE LIMITED",
"SUPREME FIBRE GLASS PRIVATE LIMITED",
"SUPREME FILAMENTS LIMITED",
"SUPREME FINCORP PRIVATE LIMITED",
"SUPREME FIREWORKS FACTORY PRIVATE LIMITED",
"SUPREME GEMS PRIVATE LIMITED",
"SUPREME GEOTECH PRIVATE LIMITED",
"SUPREME GLAZES PRIVATE LIMITED",
"SUPREME GLOBAL SERVICES PRIVATE LIMITED",
"SUPREME GLOBAL TRADING PRIVATE LIMITED",
"SUPREME GLOW PRINTING SOLUTIONS PRIVATE LIMITED",
"SUPREME GOLD IRRIGATIONS LIMITED",
"SUPREME GREEN DIAMONDS PRIVATE LIMITED",
"SUPREME GUMS PRIVATE LIMITED",
"SUPREME GYPSUM PRIVATE LIMITED",
"SUPREME HEALTHCARE (BANGALORE) PRIVATE LIMITED",
"SUPREME HIGH SPACES LLP",
"SUPREME HOLDINGS & HOSPITALITY INDIA LIMITED",
"SUPREME HOLIDAY RESORTS PRIVATE LIMITED",
"SUPREME HOSPITALITY SERVICES PRIVATE LIMITED",
"SUPREME HOUSING AND HOSPITALITY PRIVATE. LIMITED",
"SUPREME HOUSING FINANCE LIMITED",
"SUPREME HR CONSULTANTS PRIVATE LIMITED",
"SUPREME HYDRAULICS PVT LTD",
"SUPREME HYDRO ENGINEERING PRIVATE LIMITED",
"SUPREME IMPEX LTD",
"SUPREME INFOTRADE PRIVATE LIMITED",
"SUPREME INFRASTRUCTURE INDIA LIMITED",
"SUPREME IRON (INDIA) PVT.LTD.",
"SUPREME ISPAT PRIVATE LIMITED",
"SUPREME ISPAT UDYOG PRIVATE LIMITED",
"SUPREME KNOWLEDGE FOUNDATION GROUP OF INSTITUTIONS",
"SUPREME KOPARGAON AHMEDNAGAR TOLLWAYS PRIVATE. LIMITED",
"SUPREME KRAFT PRIVATE LIMITED",
"SUPREME LAUNDRY SERVICES JOINT VENTURE PRIVATE LIMITED",
"SUPREME LIFESTYLE PRIVATE LIMITED",
"SUPREME MANNINGS INDUCTION HEATING PRIVATE LIMITED",
"SUPREME MARKETING AND ALLIED SERVICES PRIVATE LIMITED",
"SUPREME MAXFILES PRIVATE LIMITED",
"SUPREME METALLURGICAL SERVICES PVT LTD",
"SUPREME MICROFINES PRIVATE LIMITED",
"SUPREME MILLS INDIA PRIVATE LIMITED",
"SUPREME MOBILES PRIVATE LIMITED",
"SUPREME MOTORS PRIVATE LIMITED",
"SUPREME NETSOFT PRIVATE LIMITED",
"SUPREME NONWOVEN",
"SUPREME NONWOVEN INDUSTRIES PRIVATE LIMITED",
"SUPREME NONWOVENS PRIVATE LIMITED",
"SUPREME NUTRI GRAIN PRIVATE LIMITED",
"SUPREME NUTRIENTS PRIVATE LIMITED",
"SUPREME OFFSHORE CONSTRUCTION AND TECHNICAL SERVICES LIMITED",
"SUPREME OVERSEAS EXPORTS PRIVATE. LIMITED.",
"SUPREME PANVEL INDAPUR TOLLWAYS PRIVATE LIMITED",
"SUPREME PAVER AND TILES PRIVATE LIMITED",
"SUPREME PETROCHEM LIMITED",
"SUPREME POLYMERS PRIVATE LIMITED",
"SUPREME POLYWEAVE PRIVATE LIMITED",
"SUPREME POULTRY PRIVATE LIMITED",
"SUPREME POWER EQUIPMENT LIMITED",
"SUPREME POWER EQUIPMENT PRIVATE LIMITED",
"SUPREME PRESSFAB PRIVATE. LIMITED",
"SUPREME QUALITY FOOD PRODUCTS PRIVATE LIMITED",
"SUPREME REAL ESTATE DEVELOPERS PRIVATE LIMITED",
"SUPREME ROAD TRANSPORT PRIVATE LIMITED",
"SUPREME ROLLFORM PRIVATE LIMITED",
"SUPREME SAFFRON PRIVATE LIMITED",
"SUPREME SECURITIES LIMITED",
"SUPREME SERVICE CENTER PRIVATE LIMITED",
"SUPREME SERVICES (INDIA) PRIVATE LIMITED",
"SUPREME SHAVERS INDIA PRIVATE LIMITED",
"SUPREME SILICONES INDIA PRIVATE LIMITED",
"SUPREME SOLAR PROJECTS PRIVATE LIMITED",
"SUPREME SOLUTIONS PRIVATE LIMITED",
"SUPREME SOLVEX PRIVATE LIMITED",
"SUPREME SPECIALITY FOODS PRIVATE LIMITED",
"SUPREME SPECIALITY HOSPITALS PRIVATE LIMITED",
"SUPREME STARTECH PRIVATE LIMITED",
"SUPREME STEEL PACKAGINGS PRIVATE LIMITED",
"SUPREME STOCKS PRIVATE LIMITED",
"SUPREME STONE MINE INDIA PRIVATE LIMITED",
"SUPREME SURFACTANTS PRIVATE LIMITED",
"SUPREME SUYOG FUNICULAR ROPEWAYS PRIVATE LIMITED",
"SUPREME SWITCHGEARS AND TRANSFORMERS PVT LTD",
"SUPREME SYNFIL PRIVATE LIMITED",
"SUPREME SYNTH (INDIA) PRIVATE LIMITED",
"SUPREME SYNTHETIC MILLS PRIVATE LIMITED",
"SUPREME TECHNOCRATS PRIVATE LIMITED",
"SUPREME TECHNOLOGIES PRIVATE LIMITED",
"SUPREME TRANS CONCEPTS PRIVATE LIMITED",
"SUPREME TRANSLINES PRIVATE LIMITED",
"SUPREME TRANSPORT SOLUTIONS PRIVATE LIMITED",
"SUPREME TREON PRIVATE LIMITED",
"SUPREME TYRES PRIVATE LIMITED",
"SUPREME UNIVERSAL PRIVATE LIMITED",
"SUPREME VENTURES LLP",
"SUPREME WEATHER MAKERS PRIVATE LIMITED",
"SUPREME YARN SPINNERS LIMITED",
"SUPREMELINK DEVELOPERS PRIVATE LIMITED",
"SUPREMEPACKS PLASTIC PRIVATE LIMITED",
"SUPREME-TREVES PRIVATE LIMITED",
"SUPREMEURBAN REALITIES PRIVATE LIMITED",
"SUPREMEWORK INFRA SOLUTIONS PRIVATE LIMITED",
"SUPREMEX EQUIPMENTS LIMITED",
"SUPREMIA INDIA PRIVATE LIMITED",
"SUPREMO DYESTUFF PRIVATE LIMITED",
"SUPREMO INDIA PRIVATE LIMITED",
"SUPREMO PROFILES P LIMITED",
"SUPREMO TUBES PRIVATE LIMITED",
"SUPREMUS DEVELOPERS PRIVATE LIMITED",
"SUPRIM CEMENT PRIVATE LIMITED",
"SUPRIME AGRO INPUT PRIVATE LIMITED",
"SUPRIMO AUTOMATION PRIVATE LIMITED",
"SUPRIMO EXCLUSIVE PRIVATE LIMITED",
"SUPRIMO VYAPAAR PRIVATE LIMITED",
"SUPRIMUS SUPERSTRUCTURES PRIVATE LIMITED",
"SUPRINT TEXTILES JAIPUR PRIVATE LIMITED",
"SUPRITA TEXFAB PRIVATE LIMITED",
"SUPRITENDENT SUB JAIL",
"SUPRIYA CORN PRODUCTS PRIVATE LIMITED",
"SUPRIYA ELEVATOR COMPANY INDIA LIMITED",
"SUPRIYA FARMS PRIVATE LIMITED",
"SUPRIYA FASHIONS PVT LTD",
"SUPRIYA LIFESCIENCE LIMITED",
"SUPRIYA MEDIHEALTHCARE PRIVATE LIMITED",
"SUPRIYA MOULDING PRIVATE LIMITED",
"SUPRIYA PACKAGING PRIVATE LIMITED",
"SUPRIYA POLYMER PRIVATE LIMITED",
"SUPRIYA SILK MILLS PRIVATE LIMITED",
"SUPRIYA SPINNING MILLS PRIVATE LIMITED",
"SUPRIYAA ISPAT PRIVATE LIMITED",
"SUPRIYATA PRIVATE LIMITED",
"SUPRO SECURITY SERVICES PRIVATE LIMITED",
"SUPROBHAT FOREX PRIVATE LIMITED",
"SUPROL INDIA PRIVATE LIMITED",
"SUPROVA COTTON AND LOGISTICS PRIVATE LIMITED",
"SUPT E S I HOSPITAL NAGDA",
"SUPTASWAR INVESTMENTS AND TRADING COMPANY LIMITED",
"SUPTD ENGINEER BENGANGA COMMAND AREA DEVP AUTHORITY SEONI MADHYA PRADESH",
"SUPTD ENGR MECHANICAL CIRCLE C P KOLHAPUR",
"SUPTD S C B MEDICAL COLLEGE GENERAL",
"SUR ARADHANA EVENT CREATIONS PRIVATE LIMITED",
"SUR ARMOUR PRIVATE LIMITED",
"SUR BASANT OVERSEAS PRIVATE LIMITED",
"SUR BREEDING FARMS PRIVATE LIMITED",
"SUR EDUCATION AND PROPERTIES PRIVATE LIMITED",
"SUR FEED CENTRE PRIVATE LIMITED",
"SUR IRON & STEEL CO PVT LTD",
"SUR MUSIC WORLD PRIVATE LIMITED",
"SUR SANGAM ELECTRO MARKETING CO.",
"SUR UDYOG PRIVATE LIMITED",
"SURA BOOKS PRIVATE LIMITED",
"SURA INVESTORS PRIVATE LIMITED",
"SURA SYSTEMS PRIVATE LIMITED",
"SURAAJ LINENS PRIVATE LIMITED",
"SURABHI AGRICO PRIVATE LIMITED",
"SURABHI AQUA MINERALS PRIVATE LIMITED",
"SURABHI AUTOMOTIVE PRIVATE LIMITED",
"SURABHI CHITS LIMITED",
"SURABHI ELITE HOSPICON PRIVATE LIMITED",
"SURABHI ENGINEERS LIMITED",
"SURABHI ENTERPRISES PRIVATE LIMITED",
"SURABHI FASHIONS PRIVATE LIMITED",
"SURABHI FOODPROCESSORS PRIVATE LIMITED",
"SURABHI HEALTHCARE & RESEARCH PRIVATE LIMITED",
"SURABHI HIRE PURCHASING COMPANY PRIVATE LIMITED",
"SURABHI HOLIDAY INN PRIVATE LIMITED.",
"SURABHI HOME APPLIANCESS PRIVATE LIMITED",
"SURABHI INDUSTRIES INDIA PRIVATE LIMITED",
"SURABHI INNOVATION PRIVATE LIMITED",
"SURABHI INTEGRATED SERVICES",
"SURABHI LIFESPACES PRIVATE LIMITED",
"SURABHI STORES PRIVATE LIMITED",
"SURABHI TECH-FAB ENGINEERS PRIVATE LIMITED",
"SURABHI TRADE CONNECTIONS PRIVATE LIMITED",
"SURABHI TRANSPORT PRIVATE LIMITED",
"SURABHINATURALS PRIVATE LIMITED",
"SURABI WINDFARMS TECHNOLOGIES PRIVATE LIMITED",
"SURACHITA AGRO PRODUCER COMPANY LIMITED",
"SURACSH FILTERS PRIVATE LIMITED",
"SURAGI POWER PRIVATE LIMITED",
"SURAGO AGRO PRIVATE LIMITED",
"SURAIYA PVT LTD",
"SURAJ ACTIVEGEAR PRIVATE LIMITED",
"SURAJ AGENCIES PRIVATE LIMITED",
"SURAJ AGRO INFRASTRUCTURE INDIA PRIVATE LIMITED",
"SURAJ AGRO INPRASIFUTURE PRIVATE LIMITED",
"SURAJ AGRO LOGISTICS PRIVATE LIMITED",
"SURAJ AGRO PIPES PRIVATE LIMITED",
"SURAJ AGROTEX PRIVATE LIMITED",
"SURAJ AIR (INDIA) PRIVATE LIMITED",
"SURAJ ASSAM TEA MANUFACTURING COMPANY PRIVATE LIMITED",
"SURAJ ASSOCIATES PRIVATE LIMITED",
"SURAJ AUTO COMPONENTS",
"SURAJ BHAN AGENCIES LIMITED",
"SURAJ BHAN DAV PUBLIC SCHOOL",
"SURAJ BLOW PLAST PRIVATE LIMITED",
"SURAJ BORE WELLS PRIVATE LIMITED",
"SURAJ BUILDER INDIA PRIVATE LIMITED",
"SURAJ BUSINESS PRIVATE LIMITED",
"SURAJ CABLES AND SERVICES PRIVATE LIMITED",
"SURAJ COMPONENTS PRIVATE LIMITED",
"SURAJ CONTAINERS LTD",
"SURAJ CORPORATE SERVICES PRIVATE LIMITED",
"SURAJ CROPSCIENCES LIMITED",
"SURAJ CYCLES PRIVATE LIMITED",
"SURAJ DALL MILLS PRIVATE LIMITED",
"SU-RAJ DIAMOND INDUSTRIES PRIVATE LIMITED",
"SURAJ DYEING AND PRINTING LIMITED",
"SURAJ ESTATE DEVELOPERS LIMITED",
"SURAJ ESTATE DEVELOPERS PRIVATE LIMITED",
"SURAJ FINVEST PRIVATE LIMITED",
"SURAJ FORWARDERS PRIVATE LIMITED",
"SURAJ FOUNDRIES PRIVATE LIMITED",
"SURAJ FREIGHT CARRIER PRIVATE LIMITED",
"SURAJ GENECA PRIVATE LIMITED",
"SURAJ GENERAL ENGINEERS PVT LTD",
"SURAJ GOVIND ESTATES PRIVATE LIMITED",
"SURAJ HINGES PRIVATE LIMITED",
"SURAJ HITECH PRIVATE LIMITED",
"SURAJ HOSPITAL",
"SURAJ IMPEX INDIA PRIVATE LIMITED",
"SURAJ INDUSTRIES",
"SURAJ INDUSTRIES LTD",
"SURAJ INFO PRIVATE LIMITED",
"SURAJ INFORMATICS PRIVATE LIMITED",
"SURAJ INFO-TECH PRIVATE LIMITED",
"SURAJ INFRAVENTURES PRIVATE LIMITED",
"SURAJ INN PRIVATE LIMITED",
"SURAJ INNOVATIVE SOLUTIONS PRIVATE LIMITED",
"SURAJ LIMITED",
"SURAJ LOGISTIX PRIVATE LIMITED",
"SURAJ MAGIC LAND PRIVATE LIMITED",
"SURAJ MAL ANIL KUMAR PRIVATE LIMITED",
"SURAJ MANI ENGINEERS PRIVATE LIMITED",
"SURAJ MARBLES P. LTD.",
"SURAJ MEDICAL AND DIAGNOSTICS PRIVATE LIMITED",
"SURAJ MOTORS PRIVATE LIMITED",
"SURAJ MOULDERS PRIVATE LIMITED",
"SURAJ NIRMAN PRIVATE LIMITED",
"SURAJ PIPE PRIVATE LIMITED",
"SURAJ PRAKASH JAIN PRIVATE LIMITED",
"SURAJ PRESSINGS PRIVATE LIMITED",
"SURAJ PRINT PACK PRIVATE LIMITED",
"SURAJ PRODUCTS LIMITED",
"SURAJ PUBLIC SCHOOL",
"SURAJ PULSES",
"SURAJ PULSES PROCESSORS PRIVATE LIMITED",
"SURAJ REALTORS INDIA PRIVATE LIMITED",
"SURAJ RECYCLING PRIVATE LIMITED",
"SURAJ REMEDIES PRIVATE LIMITED",
"SURAJ ROLLING PRIVATE LIMITED",
"SURAJ SCHOOL",
"SURAJ SIM TECHNO WORKS PRIVATE LIMITED",
"SURAJ STEELMET PRIVATE LIMITED",
"SURAJ SYNTHETICS PRIVATE LIMITED",
"SURAJ TOOLS AND EQUIPMENTS PRIVATE LIMITED",
"SURAJ TRADELINK PRIVATE. LIMITED.",
"SURAJ TRADING COMPANY PRIVATE LIMITED",
"SURAJ TRANSPORT ROADWAYS (PVT) LTD",
"SURAJ TYRE CARE PRIVATE LIMITED",
"SURAJ UNIVERSAL LIMITED",
"SURAJ VALUE INFRASTRUCTURES PRIVATE LIMITED",
"SURAJ WOOD PRODUCTS PRIVATE LIMITED",
"SURAJBALA EXPORTS PRIVATE LIMITED",
"SURAJBHAN RAJKUMAR PRIVATE LIMITED",
"SURAJKIRAN RENEWABLE RESOURCES LIMITED",
"SURAJKIRAN SOLAR TECHNOLOGIES LIMITED",
"SURAJKUND INTERNATIONAL SCHOOL",
"SURAJLOK CHEMICALS PRIVATE LIMITED",
"SURAJMAL GARG METALS PRIVATE LIMITED",
"SURAJMAL JAINARAYAN SMJN",
"SURAJMAL MEDICAL COLLEGE OF AYURVED & HOSPITAL",
"SURAJMAL RAMNIWAS OILS MILLS PRIVATE LIMITED",
"SURAJMUKHI TEA PRIVATE LIMITED",
"SURAJMULL SHREEGOPAL PRIVATE LIMITED",
"SURAJRAM HOTELS INDIA PRIVATE LIMITED",
"SURAJYA SERVICES LIMITED",
"SURAJYA SERVICES PRIVATE LIMITED",
"SURAKHSHA TRANSPORT SYSTEMS (INDIA ) PRIVATE LIMITED",
"SURAKSHA ASSET RECONSTRUCTION LIMITED",
"SURAKSHA AVENUES PRIVATE LIMITED",
"SURAKSHA CNC MANUFACTURING PRIVATE LIMITED",
"SURAKSHA CORPORATE SERVICES PRIVATE LIMITED",
"SURAKSHA DIAGNOSTIC & EYE CENTRE PRIVATE LIMITED",
"SURAKSHA DIAGNOSTIC PRIVATE LIMITED",
"SURAKSHA EXPRESS CARGO SERVICE PRIVATE LIMITED",
"SURAKSHA FLEXO PACK PRIVATE LIMITED",
"SURAKSHA HEALTH CARE PRIVATE LIMITED",
"SURAKSHA INSURANCE BROKERS PRIVATE LIMITED",
"SURAKSHA PACKERS PRIVATE LIMITED",
"SURAKSHA PACKNSEAL PRIVATE LIMITED",
"SURAKSHA PETROSKILLS PRIVATE LIMITED",
"SURAKSHA PHARMA PRIVATE LIMITED",
"SURAKSHA REALTY LIMITED",
"SURAKSHA RUBBER PRODUCTS PRIVATE LIMITED",
"SURAKSHA TECH SERVICES PRIVATE LIMITED",
"SURAKSHA TRAVELS PRIVATE LIMITED",
"SURAKSHAA CAR CARE PRIVATE LIMITED",
"SURAKSHAA HEALTHCARE & DIAGNOSTICS PRIVATE LIMITED",
"SURAKSHAA LIGHTING PRIVATE LIMITED",
"SURAKSHIT TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"SURAKSHITHA HEALTHCARE PRIVATE LIMITED",
"SURAL MAL BOMBAY WALA HOSPITAL - JAIPUR",
"SURAMEX PRIVATE LIMITED",
"SURAMI IMPEX PRIVATE LIMITED",
"SURANA ALANKAR ASSOCIATES PRIVATE LIMITED",
"SURANA CINE VENTURES PRIVATE LIMITED",
"SURANA COLLEGE",
"SURANA DIAMOND JEWELLERY PRIVATE LIMITED",
"SURANA DYECHEM PRIVATE LIMITED",
"SURANA ESSENTIALS PVT LTD",
"SURANA EXIM PRIVATE LIMITED",
"SURANA HOSPITAL AND RESEARCH CENTRE",
"SURANA KHANDSARI PRODUCTS PRIVATE LIMITED",
"SURANA METACAST INDIA PRIVATE LIMITED",
"SURANA MOTORS PRIVATE LIMITED",
"SURANA POLYCOT TEXTILES INDIA PRIVATE LIMITED",
"SURANA S ELECTRONICS PRIVATE LIMITED",
"SURANA SETHIA HOSPITAL AND RESEARCH CENTRE",
"SURANA SOLAR SYSTEMS PRIVATE LIMITED",
"SURANA SPICES PRIVATE LIMITED",
"SURANA SUPERPACK PRIVATE LIMITED",
"SURANA TAX SOLUTION PRIVATE LIMITED",
"SURANA TELECOM AND POWER LIMITED",
"SURANA VENTURES LIMITED",
"SURANGE HEALTHCARE (NORTH INDIA) PRIVATE LIMITED",
"SURANI FASHION PRIVATE LIMITED",
"SURANI PAPER PRIVATE LIMITED",
"SURANI PLY INDUSTRIES PRIVATE LIMITED",
"SURANI STEEL TUBES LIMITED",
"SURAPATI AGRO PRODUCTS PRIVATE LIMITED",
"SURARCHIT PRINTPACK PRIVATE LIMITED",
"SURASA ENGINEERING PRIVATE LIMITED",
"SURASANI CONSTRUCTIONS PRIVATE LIMITED",
"SURASSA FABRICATION PRIVATE LIMITED",
"SURAT CHILDREN WELFARE ORGANIZATION",
"SURAT COMMERCIAL PRIVATE LIMITED",
"SURAT CONSTRUCTION PRIVATE LIMITED",
"SURAT DAHISAR TOLLWAY PRIVATE LIMITED IRBSD",
"SURAT DIAMOND JEWELLERY PRIVATE LIMITED",
"SURAT DISTRICT CO.OP MILK PRODUCER'S UNION LTD",
"SURAT DISTRICT CO-OP MILK PRODUCERS UNION LTD",
"SURAT DISTRICT EDUCATION COMMITTEE",
"SURAT EXIM PRIVATE LIMITED",
"SURAT GOODS TRANSPORT PRIVATE LIMITED",
"SURAT GREEN PRECAST PRIVATE LIMITED",
"SURAT HAZIRA NH 6 TOLLWAY PRIVATE LIMITED",
"SURAT IMPEX PRIVATE LIMITED",
"SURAT INSTITUTE OF MEDICAL SCIENCE LLP",
"SURAT INTEGRATED TRANSPORTATION DEVELOPMENT CORPORATION LIMITED",
"SURAT ISLAM YATIMKHANA SOCIETY BOYS PRIMARY SCHOOL",
"SURAT JEWELTECH FOUNDATION",
"SURAT LIFECARE PRIVATE LIMITED",
"SURAT MANAV SEVA SANGH CHHAYDO",
"SURAT MARRIOTT HOTEL",
"SURAT MUNICIPAL CORPORATION",
"SURAT MUNICIPAL INSTITUTION OF MEDICAL & RESEARCH",
"SURAT NATIONAL CO OP BANK LTD",
"SURAT PEDIATRIC LIFELINE PRIVATE LIMITED",
"SURAT ROADKING PRIVATE LIMITED",
"SURAT SALES PVT LTD",
"SURAT SITILINK LIMITED",
"SURAT TAPI DISTRICT CO OP MILK PRODUCERS UNION LIMITED",
"SURAT TRADE AND MERCANTILE LIMITED",
"SURAT URBAN DEVELOPMENT AUTHORITY",
"SURATGARH BIKANER TOLL ROAD CO. PRIVATE. LIMITED.",
"SURATWALA SONS PRIVATE LIMITED",
"SURATWWALA BUSINESS GROUP LIMITED",
"SURAVI CHEMICALS INDIA PRIVATE LIMITED",
"SURAVISWADIST MILK (OPC) PRIVATE LIMITED",
"SURBACON DEVELOPMENT PRIVATE LIMITED",
"SURBHAYEE UDYAM PRIVATE LIMITED",
"SURBHEE POLYMERS PRIVATE LIMITED",
"SURBHI ADVENTURE PRIVATE LIMITED",
"SURBHI BROADBAND PRIVATE LIMITED",
"SURBHI CLOTH EMPORIUM PRIVATE LIMITED",
"SURBHI ELECTRONET PRIVATE LIMITED",
"SURBHI EYE CARE RETAIL PRIVATE LIMITED",
"SURBHI GLASS PRIVATE LIMITED",
"SURBHI GOLD PRIVATE LIMITED",
"SURBHI HOLIDAYS PRIVATE LIMITED",
"SURBHI HOSPITAL PRIVATE LIMITED",
"SURBHI INDIA TECHNOLOGY PRIVATE LIMITED",
"SURBHI INDUSTRIES LTD",
"SURBHI INVESTMENTS AND TRADING COMPANY PRIVATE LIMITED",
"SURBHI JEWELLERS PRIVATE LIMITED",
"SURBHI METALS (INDIA) PRIVATE LIMITED",
"SURBHI MILK FOODS AND BEVERAGES LIMITED",
"SURBHI MINES AND MINERALS PVT LTD",
"SURBHI SALES PVT LTD",
"SURBHI SANITARYWARES PRIVATE LIMITED",
"SURBHI SATCOM PRIVATE LIMITED",
"SURBHI STONES PRIVATE LIMITED",
"SURBHI TELELINK PRIVATE LIMITED",
"SURBHI TEXTILE MILLS PRIVATE LIMITED",
"SURBHIKA STEELS PRIVATE LTD",
"SURBHIT IMPEX PRIVATE LIMITED",
"SURBHITAM PHARMACEUTICALS PRIVATE LIMITED",
"SURCHEM CHEMICALS PVT LTD",
"SURCHEM MV CHEMICALS PRIVATE LIMITED",
"SURCOAT PAINTS PRIVATE LIMITED",
"SURDHENU FOODS PRIVATE LIMITED",
"SURE CARGO CONTROL PRIVATE LIMITED",
"SURE DELIVERIES PRIVATE LIMITED",
"SURE ENERGY SYSTEMS PRIVATE LIMITED",
"SURE FOR CURE FARMULATIONS (INDIA ) PRIVATE LIMITED",
"SURE HORIZON SOFTTECH END2END SOLUTION PRIVATE LIMITED",
"SURE SAFE GLASS WORKS PVT LTD",
"SURE SAFETY (INDIA) LIMITED",
"SURE SAFETY INDIA PRIVATE LIMITED",
"SURE SHOT SUGGESTIONS (INDIA) PRIVATE LIMITED",
"SURE START BATT POWER INDIA PRIVATE LIMITED",
"SURE VINYL PRIVATE LIMITED",
"SURECARE PHARMA PRIVATE LIMITED",
"SURECON FASTENING AND ENGINEERING PRIVATE LIMITED",
"SURE-CURE REMEDIES PVT LTD",
"SUREFLO TECHCON PRIVATE LIMITED",
"SUREGROW FARMS (OPC) PRIVATE LIMITED",
"SUREIFY LABS TECHNOLOGY PRIVATE LIMITED",
"SUREIT SOLUTIONS INDIA PRIVATE LIMITED",
"SUREKA MARKETING AND ENGINEERING PVT LTD",
"SUREKA PAPER CONTAINERS PVTLTD",
"SUREKA PUBLICATIONS PRIVATE LIMITED",
"SUREKA TEKNIK PVT LTD",
"SUREKA VENTURES PRIVATE LIMITED",
"SUREKHA BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"SUREKHA COMMUNICATION PRIVATE LIMITED",
"SUREKHA CRITICARE HOSPITAL",
"SUREKHA DESIGNS PRIVATE LIMITED",
"SUREKHA TECHNOLOGIES PRIVATE LIMITED",
"SUREKLEEN SERVICES PRIVATE LIMITED",
"SURELINE SYSTEMS INDIA PRIVATE LIMITED",
"SURELOCK PLASTICS PRIVATE LIMITED",
"SUREMINDS SOLUTIONS PRIVATE LIMITED",
"SUREMIX CHEMICALS PRIVATE LIMITED",
"SUREN ENTERPRISE PRIVATE LIMITED",
"SURENDRA AND CO",
"SURENDRA ELASTOMERS PRIVATE LIMITED",
"SURENDRA ELECTRICALS PRIVATE LIMITED",
"SURENDRA FORGINGS PVT LTD",
"SURENDRA INFRASTRUCTURE PVT LTD",
"SURENDRA INVESTIGATION SERVICES (BOMBAY) PRIVATE LIMITED",
"SURENDRA MEDICAL DEVICES PRIVATE LIMITED",
"SURENDRA MINERALS PRIVATE LIMITED",
"SURENDRA MINING INDUSTRIES PRIVATE LIMITED.",
"SURENDRA NATH RICE MILL PRIVATE LIMITED",
"SURENDRA POWERTECH PRIVATE LIMITED",
"SURENDRA PRASAD & LAHRI CONSTRUCTION PRIVATE LIMITED",
"SURENDRA RE-ROLLERS PRIVATE LIMITED",
"SURENDRA SOLVENT OILS PRIVATE LIMITED",
"SURENDRA SPRINGS PVT LTD",
"SURENDRA STEELS PRIVATE LIMITED",
"SURENDRANAGAR DISTRICT EDUCATION COMMITTEE MANAGED PRIMARY SCHOOL",
"SURENDRANATH CENTENARY SCHOOL",
"SURENDRANATH COLLEGE",
"SURENDRANATH COLLEGE FOR WOMEN",
"SURENDRANATH EVENING COLLEGE",
"SUREPASS TECHNOLOGIES PRIVATE LIMITED",
"SUREPREP INDIA PRIVATE LIMITED",
"SUREPRINT TECHNOLOGIES PRIVATE LIMITED",
"SURESAA TEA LIMITED",
"SURESAFE SAFETY AND LIFTING SOLUTIONS PRIVATE LIMITED",
"SURESALES AUTOMATION PRIVATE LIMITED",
"SURESECURE SERVICES PRIVATE LIMITED",
"SURESH AGENCIES AND DISTRIBUTORS PRIVATE LIMITED",
"SURESH AGRO AND POULTRY SERVICES PRIVATE LIMITED",
"SURESH APPARELS PVT LTD",
"SURESH BIZGLOBE (OPC) PRIVATE LIMITED",
"SURESH CHAND SARAF PRIVATE LIMITED",
"SURESH CHANDRA SAHOO",
"SURESH CHIPS AND SEMICONDUCTOR PRIVATE LIMITED",
"SURESH ENTERPRISES",
"SURESH ENTERPRISES PRIVATE LIMITED",
"SURESH FASHION HUB PRIVATE LIMITED",
"SURESH FLAVOURS AND EXTRACTS PRIVATE LIMITED",
"SURESH GYAN VIHAR UNIVERSITY",
"SURESH HOSIERY PRIVATE LIMITED",
"SURESH INDU LASERS PRIVATE LIMITED",
"SURESH KUMAR AND COMPANY (IMPEX) PRIVATE LIMITED",
"SURESH KUMAR GOEL BUILDCON PRIVATE LIMITED",
"SURESH KUMAR RAMESH KUMAR YARN PRIVATE LIMITED",
"SURESH MANAGEMENT PRIVATE LIMITED",
"SURESH MASS MARKETING PRIVATE LIMITED",
"SURESH METAL INDUSTRIES PRIVATE LIMITED",
"SURESH ORGANICS PRIVATE LIMITED",
"SURESH PAPER PRIVATE LTD",
"SURESH PHARMA AGENCIES CHENNAI PRIVATE LIMITED",
"SURESH POLYMERS PVT LTD",
"SURESH PRESS WORKS PRIVATE LIMITED",
"SURESH PRESS WORKS-UNIT-II",
"SURESH PRODUCTIONS PVT LTD",
"SURESH RATHI FINVEST PRIVATE LIMITED",
"SURESH RATHI SECURITIES PRIVATE LIMITED",
"SURESH SILK MILLS PVT LTD",
"SURESH STEEL TUBES PRIVATE LIMITED",
"SURESH SURANA AND ASSOCIATES LLP",
"SURESH SYNTH CHEM INDUSTRIES PRIVATE LIMITED",
"SURESH TEXFAB PRIVATE LIMITED",
"SURESH WADKARS MUSIC AT AJIVASAN PRIVATE LIMITED",
"SURESOL ADVISORS PRIVATE LIMITED",
"SURESTEP VENTURES PRIVATE LIMITED",
"SURETEC PRECISION LIMITED",
"SURETECH COLLEGE OF NURSING",
"SURETECH HOSPITAL",
"SURETECH INFRASTRUCTURE PRIVATE LIMITED",
"SURETEK INFOSOFT PRIVATE LIMITED",
"SURETEX PROPHYLACTICS (INDIA) PRIVATE LIMITED",
"SURETEX PROPHYLACTICS INDIA LIMITED",
"SUREVIN WEARTECH PRIVATE LIMITED",
"SUREWAVES MEDIATECH PRIVATE LIMITED",
"SUREWORKS INFOTECH PRIVATE LIMITED",
"SURF RIDE HOTELS & RESTAURANT PVT. LTD.",
"SURFA COATS INDIA PRIVATE LIMITED",
"SURFACE CARGO SERVICES PRIVATE LIMITED",
"SURFACE CHEMICAL TECHNOLOGY INDIA PRIVATE LIMITED",
"SURFACE CONCEPTS PRIVATE LIMITED",
"SURFACE DEKOR (INDIA) PRIVATE LIMITED",
"SURFACE DESIGN TECHNOLOGIES PRIVATE LIMITED",
"SURFACE ENGINEERING PRIVATE LIMITED",
"SURFACE FINISHING ENGINEERING PRIVATE LIMITED",
"SURFACE IMPROVEMENTS (INDIA) PRIVATE LIMITED",
"SURFACE MODIFICATION TECHNOLOGIES PRIVATE LIMITED",
"SURFACE PAINTS PRIVATE LIMITED",
"SURFACE PREPARATION SOLUTIONS AND TECHNOLOGIES PRIVATE LIMITED",
"SURFACE PROTECTION & RESTORATION CONTRACTORS PRIVATE LIMITED",
"SURFACE SHIPPING & TRANSPORT SYSTEMS PRIVATE LMITED",
"SURFACES (INDIA) FLOORING PRIVATE LIMITED",
"SURFACOAT CHEMICALS PRIVATE LIMITED",
"SURFACTANTS AND ALLIED CHEMICALS PRIVATE LIMITED",
"SURFAIR EXPRESS CARGO & LOGISTICS PRIVATE LIMITED",
"SURFBOARD INDIA PRIVATE LIMITED",
"SURFBOARD PAYMENTS INDIA PRIVATE LIMITED",
"SURFBOATS SOLUTIONS PRIVATE LIMITED",
"SURFCHEM ORGANICS PRIVATE LIMITED",
"SURFICA INDIA LIMITED",
"SURFIN ABRASIVES INDIA PRIVATE LIMITED",
"SURFIN COATING SYSTEMS PRIVATE LIMITED",
"SUR'FIS KLENZ (INDIA) PRIVATE LIMITED",
"SURFLAND COMPOSITES PRIVATE LIMITED",
"SURFTECH ENGINEERING PRIVATE LIMITED",
"SURFWAVES EXIM PRIVATE LIMITED",
"SURGE ALLOYS PRIVATE LIMITED",
"SURGE BIOTECH PRIVATE LIMITED",
"SURGE FORTH TECHNOLOGIES PRIVATE LIMITED",
"SURGE IT TECHNOLOGY SOLUTIONS LLP",
"SURGE MARINE SERVICES PRIVATE LIMITED",
"SURGE PHARMACEUTICALS PRIVATE LIMITED",
"SURGE SYSTEMS INDIA PRIVATE LIMITED",
"SURGEF99 PRIVATE LIMITED",
"SURGEINE HEALTHCARE (INDIA) PRIVATE LIMITED",
"SURGEPORT LOGISTICS PRIVATE LIMITED",
"SURGETECH ENERGY PRIVATE LIMITED",
"SURGI AID LIFECARE PRIVATE LIMITED",
"SURGI PACK INDIA PRIVATE LIMITED",
"SURGICAL MALL OF INDIA PRIVATE LIMITED",
"SURGICAL PRODUCTS INDIA PRIVATE LIMITED",
"SURGICAL SUTURES PRIVATE LIMITED",
"SURGICOIN MEDEQUIP PRIVATE LIMITED",
"SURGICON HEALTHCARE PRIVATE LIMITED",
"SURGICOTFAB TEXTILES PRIVATE LIMITED",
"SURGIFIELD PRIVATE LIMITED",
"SURGIKON INDIA PRIVATE LIMITED",
"SURGILIFE MEDICAL DEVICES PRIVATE LIMITED",
"SURGIMED CART PRIVATE LIMITED",
"SURGIMED HEALTH CARE INDIA PRIVATE LIMITED",
"SURGIMED PRIVATE LIMITED",
"SURGIMEDIK HEALTHCARE INDIA PRIVATE LIMITED",
"SURGISOL HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"SURGITECH INNOVATION PRIVATE LIMITED",
"SURGUJA PIPES PRIVATE LIMITED",
"SURGUJA SOLVENT EXTRACTION PRIVATE LIMITED",
"SURI AGRO FRESH PRIVATE LIMITED",
"SURI AUTO PRIVATE LIMITED",
"SURI AUTO PRIVATE LTD.",
"SURI CONSUMER PRIVATE LIMITED",
"SURI ENGINEERS PRIVATE LIMITED",
"SURI INFOTECH PRIVATE LIMITED",
"SURI PROBUILD PRIVATE LIMITED",
"SURI PROFILES PRIVATE LIMITED",
"SURI SHOES PRIVATE LIMITED",
"SURI TRAVELS PRIVATE LIMITED",
"SURIDHI INDUSTRIES PRIVATE LIMITED",
"SURIE POLEX INDUSTRIES PRIVATE LIMITED",
"SURIE POLEX PRIVATE LIMITED",
"SURIEN PHARMACEUTICALS PRIVATE LIMITED",
"SURIN AUTOMOTIVE PRIVATE LIMITED",
"SURIN INDIA PRIVATE LIMITED",
"SURINDER FILMS PRIVATE LIMITED",
"SURINDERA CYCLES PRIVATE LIMITED",
"SURINDRA ENGINEERING COMPANY PRIVATE LIMITED",
"SURINDRA METALS PRIVATE LIMITED",
"SURINDRA PACKAGING PRIVATE LIMITED",
"SURINDRA RADIOS PVT LTD",
"SURINDRA THERMOPACK PRIVATE LIMITED",
"SURIYA GARMENTS",
"SURIYA KIRAN COMPUTERS PRIVATE LIMITED",
"SURIYA POLYFILM PRIVATE LIMITED",
"SURIYADITA ENERGY PRIVATE LIMITED",
"SURIYAGIRI SPINNING MILLS PRIVATE LIMITED",
"SURJEET AUTO PRIVATE LIMITED",
"SURJEET SINGH FOODS AND RESTAURANTS PRIVATE LIMITED",
"SURJI AGRO FOODS PRIVATE LIMITED",
"SURJIT ELECTRICAL PRIVATE LIMITED",
"SURJIT GOODS CARRIERS PRIVATE LIMITED",
"SURJIT HIRE PURCHASE PRIVATE LIMITED",
"SURJIT MOULDS & TOOLS PRIVATE LIMITED",
"SURJIT TEXTILE (INDIA) PRIVATE LIMITED",
"SURJYA KUMAR BANIK AGENCY PRIVATE LIMITED",
"SURKHAB EXPORTS PRIVATE LIMITED",
"SURLAX ENGINEERS PRIVATE LIMITED",
"SURLON DUREL SPRINGS PRIVATE LIMITED",
"SURMA DISTILLERY PRIVATE LIMITED",
"SUR-MAN TRADING PRIVATE LIMITED",
"SUR-MANGAL HOLDINGS PVT. LTD.",
"SURMANJA INFOTECH PRIVATE LIMITED",
"SURMELA TOOLS PVT LTD",
"SURMOUNT ENERGY SOLUTIONS PRIVATE LIMITED",
"SURMOUNT ENTERPRISES PRIVATE LIMITED",
"SURMOUNT LABORATORIES PRIVATE. LIMITED.",
"SURNISHA PUBLICATIONS LIMITED",
"SURO LOGISTICLE INDIA PRIVATE LIMITED",
"SUROBHI AGRO INDUSTRIES PRIVATE LIMITED",
"SUROBHI ANALYTICAL CONSULTING (OPC) PRIVATE LIMITED",
"SUROJ BUILDCON PRIVATE LIMITED",
"SUROJ MODULAR HOUSING PRIVATE LIMITED",
"SURONIK OVERSEAS PRIVATE LIMITED",
"SUROVI MANSION JEWELLERS PRIVATE LIMITED",
"SURPAL CYCLES PRIVATE LIMITED",
"SURPASSING HR SOLUTION PRIVATE LIMITED",
"SURPATH DEVELOPERS PRIVATE LIMITED",
"SURPATI DISTRIBUTORS PRIVATE LIMITED",
"SURPLUS FINVEST PRIVATE LIMITED",
"SURPLUS PLASTICS PRIVATE LIMITED",
"SURPRISE HOUSEHOLD LINEN PRIVATE LIMITED",
"SURPRISE SANITATION PRIVATE LIMITED",
"SURPRISE STEEL PRIVATE LIMITED",
"SURQTE TECHNOLOGIES PRIVATE LIMITED",
"SURRAJ LOGISTICS (I) PRIVATE LIMITED",
"SURRAL SURFACE COATINGS PRIVATE LIMITED",
"SURREAL BRAND SOLUTIONS INDIA PRIVATE LIMITED",
"SURROUND NETWORKS PRIVATE LIMITED",
"SURROUNDU IT PRIVATE LIMITED",
"SURSADHANA SPONGE & ISPAT PVT LTD",
"SURSARITA VANIJYA PVT LTD",
"SURSUNA HIGH SCHOOL HS",
"SURTEC CHEMICALS INDIA PRIVATE LIMITED",
"SURTEL TECHNOLOGIES PRIVATE LIMITED",
"SURU CHEMICALS AND PHARMACEUTICALS PRIVATE LIMITED",
"SURU INTERNATIONAL P LIMITED",
"SURU INTERNATIONAL P LTD",
"SURUBHI GARMENTS PRIVATE LIMITED",
"SURUCHI ALLOYS PRIVATE LIMITED",
"SURUCHI ANUDANIT PRATHMIK ASHRAM SHALA",
"SURUCHI BUSINESS SUPPORT SERVICES PRIVATE LIMITED",
"SURUCHI CONTINENTAL PRIVATE LIMITED",
"SURUCHI DAIRY & DAIRY PRODUCTS PRIVATE LIMITED",
"SURUCHI DAIRY INDUSTRIES PRIVATE LIMITED",
"SURUCHI FOODS PRIVATE LIMITED",
"SURUCHI GOODS PRIVATE LIMITED",
"SURUCHI HOSIERY & ELASTICS PRIVATE LIMITED",
"SURUCHI HOTELS PRIVATE LIMITED",
"SURUCHI MERCHANTS CONSULTANTS PVT LTD",
"SURUCHI PAPERS PRIVATE LIMITED",
"SURUCHI PROCESSORS PRIVATE LIMITED",
"SURUCHI REFINERY PRIVATE LIMITED",
"SURUCHI SILK PARK PRIVATE LIMITED",
"SURUCHI SPICES PRIVATE LIMITED",
"SURUCHI VIHAR PVT LTD",
"SURUCHIT ANUDHANIT PRIMARY ASHRAM SCHOOL",
"SURUGA INDIA PRIVATE LIMITED",
"SURVAM INVESTMENTS PRIVATE LIMITED",
"SURVASES SURYA MOTELS PRIVATE LIMITED",
"SURVEN CARE PRIVATE LIMITED",
"SURVEY OF INDIA",
"SURVEY SAMPLING INTERNATIONAL HYDERABAD PRIVATE LIMITED",
"SURVEY TECHNOLOGIES PRIVATE LIMITED",
"SURVEY2CONNECT PRIVATE LIMITED",
"SURVEYNATICS PRIVATE LIMITED",
"SURVEYSPARROW PRIVATE LIMITED",
"SURVI PROJECTS PRIVATE LIMITED",
"SURVIK SOFTWARE PRIVATE LIMITED",
"SURVIN FINANCE AND INVESTMENTS LIMITED",
"SURVIN INDIA PRIVATE LIMITED",
"SURVIN INDIA PRIVATE LTD",
"SURVIVAL SYSTEMS INDIA DIV OF LITTLESILVER SOFTWARE INDIA PRIVATE LIMITED",
"SURVIVAL TECHNOLOGIES LIMITED",
"SURVIVAL TECHNOLOGIES PRIVATE LIMITED",
"SURY SANCHAR INDIA PRIVATE LIMITED",
"SURYA & COMPANY",
"SURYA ADSYSTEMS PRIVATE LIMITED",
"SURYA AGENCY PRIVATE LIMITED",
"SURYA AGRIMART INDIA PRIVATE LIMITED",
"SURYA AGRO INDUSTRIES",
"SURYA AGRO PRODUCTS PRIVATE LIMITED",
"SURYA AIR PRODUCTS PRIVATE LIMITED",
"SURYA ALLOY INDUSTRIES LIMITED",
"SURYA AUTOCORP PRIVATE LIMITED",
"SURYA AUTOMATION PRIVATE LIMITED",
"SURYA AUTOMOBILES PRIVATE LIMITED",
"SURYA BAKERY AND CONFECTIONERY PRIVATE LIMITED",
"SURYA BISCUIT INDUSTRIES PRIVATE LIMITED",
"SURYA BUILDTECH PRIVATE LIMITED",
"SURYA BUILDWELL PRIVATE LIMITED",
"SURYA BUSINESS PVT LTD",
"SURYA CARGO FORWARDERS PRIVATE LIMITED",
"SURYA CARPET PRIVATE LIMITED",
"SURYA CARRIERS PRIVATE LIMITED",
"SURYA CARTONS PRIVATE LIMITED",
"SURYA CEM PRIVATE LIMITED",
"SURYA CHAINS PRIVATE LIMITED",
"SURYA CHANDRA PAPER MILLS LIMITED.",
"SURYA CHARITABLE AND WELFARE SOCIETY REGD.",
"SURYA CHILDRENS MEDICARE PRIVATE LIMITED",
"SURYA COATS PRIVATE LIMITED",
"SURYA COLLECTION PRIVATE LIMITED",
"SURYA COLONIZERS PRIVATE LIMITED",
"SURYA COLOUR PRODUCTS PRIVATE LIMITED",
"SURYA COLOURS PVT LTD",
"SURYA COMMERCIAL LIMITED",
"SURYA COMMOSALE PRIVATE LIMITED",
"SURYA CONDUCTORS PRIVATE LIMITED",
"SURYA CONS PRIVATE. LIMITED.",
"SURYA CONSTRUCTIONS PRIVATE LIMITED",
"SURYA CONTRACTORS PRIVATE LIMITED",
"SURYA COTEX PRIVATE LIMITED",
"SURYA DATA MANAGEMENT AND NETWORK TECHNOLOGIES PRIVATE LIMITED",
"SURYA DAY PRIVATE LIMITED",
"SURYA DESIGN & DISPLAY PRIVATE LIMITED",
"SURYA DISPLAY PRIVATE LIMITED",
"SURYA DURGA POWERS",
"SURYA ELECTRICALS & ENGINEERS PRIVATE LIMITED",
"SURYA ELECTRO MULTI SERVICES PRIVATE LIMITED",
"SURYA ENGINEERS AND CONTRACTORS PRIVATE LIMITED",
"SURYA EQUIPMENTS PRIVATE LIMITED",
"SURYA ETHNIC FASHION (INDIA) PRIVATE LIMITED",
"SURYA EXIM LIMITED",
"SURYA EYE INSTITUTE & RESEARCH CENTRE PRIVATE LIMITED",
"SURYA FASHIONCRAFTS PRIVATE LIMITED",
"SURYA FERROUS ALLOYS PRIVATE LIMITED",
"SURYA FINE OILS PRIVATE LIMITED",
"SURYA FINLEASE PRIVATE LIMITED",
"SURYA FISHERIES PVT.LTD.",
"SURYA FOOD AND AGRO LIMITED",
"SURYA FOUNDRY PRIVATE LIMITED",
"SURYA FRESH FOODS LIMITED",
"SURYA FUN CITY LTD",
"SURYA FURNITECH PRIVATE LIMITED",
"SURYA GLOBAL FLEXIFILMS PRIVATE LIMITED",
"SURYA GOLDS PRIVATE LIMITED",
"SURYA HERBAL CARE PRIVATE LIMITED",
"SURYA HERBAL LIMITED",
"SURYA HI-TECH SERVICES PRIVATE LIMITED",
"SURYA HOSPITAL",
"SURYA HOSPITALITY & HOTEL INDIA PRIVATE LIMITED",
"SURYA HOSPITALS PVT LTD",
"SURYA IMAGING AND PATHOLOGY CENTRE PRIVATE LIMITED",
"SURYA INDIA LIMITED",
"SURYA INDIA PALACE PRIVATE LIMITED",
"SURYA INDUSTECH PRIVATE LIMITED",
"SURYA INDUSTRIES",
"SURYA INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"SURYA INFRABUILD (INDIA) PRIVATE LIMITED",
"SURYA INFRACON INDIA PRIVATE LIMITED",
"SURYA INFRATECH",
"SURYA INFRAVENTURE PRIVATE LIMITED",
"SURYA INNOVATIVE BUILDING MATERIALS PRIVATE LIMITED",
"SURYA IVF CLINIC PRIVATE LIMITED",
"SURYA JYOTI COTTEX PRIVATE LIMITED",
"SURYA KIRAN ENGINEERING WORKS PRIVATE LIMITED",
"SURYA KIRAN HOSPITAL",
"SURYA KIRAN METALS PVT LTD",
"SURYA KIRAN TRADECOM PRIVATE LIMITED",
"SURYA KIRANA STORES",
"SURYA LABORATORIES PVT LTD",
"SURYA LAKSHMI COTTON MILLS LTD",
"SURYA LIFE SCIENCES LIMITED",
"SURYA LIFTS PRIVATE LIMITED",
"SURYA MAINTENANCE AGENCY PRIVATE LIMITED",
"SURYA MANUFACTURING COMPANY",
"SURYA MARBLES PRIVATE LIMITED",
"SURYA MASTERBATCHES PRIVATE LIMITED",
"SURYA MATTRESSES PRIVATE LIMITED",
"SURYA MEDICAL RESEARCH CENTER PRIVATE LIMITED",
"SURYA MEDISALES PRIVATE LIMITED",
"SURYA MELANGE & BISTRO PRIVATE LIMITED",
"SURYA METALLOYS PRIVATE LIMITED",
"SURYA MOTHER AND CHILD CARE JAIPUR PRIVATE LIMITED",
"SURYA MOTHER AND CHILD CARE PRIVATE LIMITED",
"SURYA MOTOCORP PRIVATE LIMITED",
"SURYA MOTORS PVT LTD",
"SURYA MOVERS PRIVATE LIMITED",
"SURYA MUSHROOMS PRIVATE LIMITED",
"SURYA NAGRI TELELINKS PRIVATE LIMITED",
"SURYA NARAYAN AGRO PRIVATE LIMITED",
"SURYA NESTBUILD LIMITED",
"SURYA NIRMAL INFRASTRUCTURES PRIVATE LIMITED",
"SURYA ORGANICS & CHEMICALS",
"SURYA PANEL PRIVATE LIMITED",
"SURYA PELLE CHEMICAL & MOULD PRIVATE LIMITED",
"SURYA PETROLEUM PRODUCTS PVT LTD",
"SURYA POLYPACK PRIVATE LIMITED",
"SURYA POLYPET PRIVATE LIMITED",
"SURYA POLYTEX PVT LTD",
"SURYA POLYVIN LIMITED(TRFD PUNJAB TO DELHI)",
"SURYA POWERTECH AND GEARS PRIVATE LIMITED",
"SURYA PRESS-MET PVT. LTD.",
"SURYA PRINT PROCESS PRIVATE LIMITED",
"SURYA PROCESSED FOOD PRIVATE LIMITED",
"SURYA PROCESSORS PRIVATE LIMITED",
"SURYA PRODUCTS LIMITED",
"SURYA PROPERTIES (NASHIK )PRIVATE LIMITED",
"SURYA PUBLIC SCHOOL",
"SURYA R.O. SYSTEMS PRIVATE LIMITED",
"SURYA RAJ SECURITIES PRIVATE LIMITED",
"SURYA RAY ELIXIRS PRIVATE LIMITED",
"SURYA REAL INFRA PRIVATE LIMITED",
"SURYA REALCON PRIVATE LIMITED",
"SURYA RECREATION TRAVELS PRIVATE LIMITED",
"SURYA REMEDIES PRIVATE LIMITED",
"SURYA REMELTERS AND EXTRUDERS PRIVATE LIMITED",
"SURYA RESORTS PVT LTD",
"SURYA RICE & GENERAL MILLS",
"SURYA ROSHNI LED LIGHTING PROJECTS LIMITED",
"SURYA ROSHNI LIMITED",
"SURYA SAHYADRI HOSPITAL",
"SURYA SALT PRIVATE LIMITED",
"SURYA SANKARA TRADING PRIVATE LIMITED",
"SURYA SAREES PRIVATE LIMITED",
"SURYA SCAFFOLDS PRIVATE LIMITED",
"SURYA SCOOTERS PRIVATE LIMITED",
"SURYA SHAKTI GREENLANDS PRIVATE. LIMITED.",
"SURYA SHAKTI INDIA PRIVATE LIMITED",
"SURYA SHAKTI INDUSTRIES PRIVATE LIMITED",
"SURYA SHAKTI VESSELS PRIVATE LIMITED",
"SURYA SHIPPING & PROJECTS PRIVATE LIMITED",
"SURYA SILK MILLS",
"SURYA SMART FASHION PRIVATE LIMITED",
"SURYA SMELTERS PRIVATE LIMITED",
"SURYA SOFTWARE SYSTEMS PRIVATE LIMITED",
"SURYA SPRINGS PRIVATE LIMITED",
"SURYA SUPER THREADS PRIVATE LIMITED",
"SURYA SYNPACKS PRIVATE LIMITED",
"SURYA SYNTHETICS",
"SURYA TEA COMPANY PRIVATE LIMITED",
"SURYA TECHNOFAB LLP",
"SURYA TEJA FACILITIES MANAGEMENT PRIVATE LIMITED",
"SURYA TEJA POWER PROJECTS PRIVATE LIMITED",
"SURYA TEX-PRINTS PRIVATE LIMITED",
"SURYA TIMBER TRADERS",
"SURYA TRANSCORE PRIVATE LIMITED",
"SURYA VAMSI FISHERIES PRIVATE LIMITED",
"SURYA VARSANI ACADEMY",
"SURYA VIDYUT LIMITED",
"SURYA VINYL PRIVATE LIMITED",
"SURYA VISTACOM PRIVATE LIMITED",
"SURYA WALL CARE CHEM PRIVATE LIMITED",
"SURYA WATER PURIFIER PRIVATE LIMITED",
"SURYA WIRES PRIVATE LIMITED",
"SURYA WOOLLEN MILLS PRIVATE LIMITED",
"SURYAA BATTERIES PRIVATE LIMITED",
"SURYAA FACILITIES SERVICES PRIVATE LIMITED",
"SURYAAMBA SPINNING MILL LIMITED",
"SURYABALA AUTOS PRIVATE LIMITED",
"SURYABALA MOTORS AND WHEELS PRIVATE LIMITED",
"SURYACHAMBAL POWER LIMITED",
"SURYADATTA COLLEGE OF MANAGEMENT INFORMATION RESEARCH AND TECHNOLOGY BAVDHAN PUNE",
"SURYADATTA EDUCATION FOUNDATION",
"SURYADEEP ALLOY STEEL CASTINGS PRIVATE LIMITED",
"SURYADEEP ENGINEERING PRIVATE. LIMITED.",
"SURYADEEP HOSPITALS INDIA PRIVATE LIMITED",
"SURYADEEP INDIA FOODS PRIVATE LIMITED",
"SURYADEV ALLOYS AND POWER PRIVATE LIMITED",
"SURYADEV FOOD AND BEVERAGES PRIVATE LIMITED",
"SURYADEV HEALTHCARE PRIVATE LIMITED",
"SURYADIPTA PROJECTS PRIVATE LIMITED",
"SURYAG INFRAZONE PRIVATE LIMITED",
"SURYAGOLD AGRO FOOD PRIVATE LIMITED",
"SURYAJIT PUBLICATIONS PRIVATE LIMITED",
"SURYAJYOTI INFOTECH LIMITED",
"SURYAJYOTI MULTITRADING PRIVATE LIMITED",
"SURYAKAMAL INFRA PRIVATE LIMITED",
"SURYAKANCHAN VINIMAY PRIVATE LIMITED",
"SURYAKAVACH VENTURES PRIVATE LIMITED",
"SURYAKIRAN EARTHMOVERS PRIVATE LIMITED",
"SURYAKIRAN LITE INDUSTRIES PRIVATE LIMITED",
"SURYALATA SPINNING MILLS LIMITED",
"SURYALAXMI COTTEX PRIVATE LIMITED",
"SURYALAXMI JEWELLERS PRIVATE LIMITED",
"SURYALAXMI SPINNERS PRIVATE LIMITED",
"SURYALAXMI TEXFAB PRIVATE LIMITED",
"SURYALCO IMPEX PRIVATE LIMITED",
"SURYALOGIX PRIVATE LIMITED",
"SURYAM INTERNATIONAL PRIVATE LIMITED",
"SURYAM MINECHEM PRIVATE LIMITED",
"SURYAM POLYFILMS PRIVATE LIMITED",
"SURYAMAN PACKAGING",
"SURYAMANI GLASSED STEEL EQUIPMENT PRIVATE LIMITED",
"SURYAMITRA EXIM PRIVATE LIMITED",
"SURYANAGRI TRADING AND CONSULTANCY PRIVATE LIMITED",
"SURYANANDAN TEXTURIZERS PRIVATE LIMITED",
"SURYANARAYAN FOREX AND TRAVELS PRIVATE LIMITED",
"SURYANARAYAN PACKAGING (I) PRIVATE LIMITED",
"SURYANARAYAN SYNTHETICS PRIVATE LIMITED",
"SURYANS COOLEX & PACKAGING PRIVATE LIMITED",
"SURYANS FARMING PRIVATE LIMITED",
"SURYANSH BROADCASTING PRIVATE LIMITED",
"SURYANSH CONTRACTS INDIA PRIVATE LIMITED",
"SURYANSH ENERTECH PRIVATE LIMITED",
"SURYANSH INFRACON PRIVATE LIMITED",
"SURYANSH INFRADEVELOPERS PRIVATE LIMITED",
"SURYANSH INSTITUTIONS PRIVATE LIMITED",
"SURYANSH KIDNEY CARE PRIVATE LIMITED",
"SURYANSH MERCHANDISE INDIA LIMITED",
"SURYANSH POWER INFRA PRIVATE LIMITED",
"SURYANSH PRATHAM INDUSTRIES PRIVATE LIMITED",
"SURYANSH PULP AND BOARD PRIVATE LIMITED",
"SURYANSH TELECOM PRIVATE LIMITED",
"SURYANSH TRADEX PRIVATE LIMITED",
"SURYAPET KHAMMAM ROAD PRIVATE LIMITED",
"SURYARUC ELECTRIC WORKZ INDIA PRIVATE LIMITED",
"SURYAS OLDFORT INDUSTRIES PRIVATE LIMITED",
"SURYASAGAR COMMUNICATION PRIVATE LIMITED",
"SURYASHAKTI GREENLANDS PRIVATE LIMITED",
"SURYASRI HOSPITAL PRIVATE LIMITED",
"SURYASTONE ENTERPRISES PRIVATE LIMITED",
"SURYASTONE INDUSTRIES PRIVATE LIMITED",
"SURYASUMAN SPINNING MILLS PRIVATE. LIMITED.",
"SURYAT TRADELINK PRIVATE LIMITED",
"SURYATAAP ENERGIES AND INFRASTRUCTURE PRIVATE LIMITED",
"SURYATEJ INFRATECH PRIVATE LIMITED",
"SURYATEJA HEALTHCARE PRIVATE LIMITED",
"SURYATEJA RICE INDUSTRY",
"SURYAUDAY SOLAIRE PRAKASH PRIVATE LIMITED",
"SURYAUDAY SPINNING MILLS PRIVATE LIMITED",
"SURYAVAMSI FARMS PRIVATE LIMITED",
"SURYAVANSHI COMMOTRADE PVT LTD",
"SURYAVANSHI FOREX PRIVATE LIMITED",
"SURYAVANSHI GEMS AND JEWELLERY PRIVATE LIMITED",
"SURYAVANSHI INFRASTRUCTURE PRIVATE LIMITED",
"SURYAVANSHI SHIPPING PRIVATE LIMITED",
"SURYAVANSHI SPINNING MILLS LIMITED",
"SURYAVARADA SPINNING MILLS LIMITED",
"SURYAVARDHAN ESTATES PRIVATE LIMITED",
"SURYAVIZHUDHUGAL ENERGY SOLUTIONS PRIVATE LIMITED",
"SURYO PAPERS PRIVATE LIMITED",
"SURYODAI BUILDERS PRIVATE LIMITED",
"SURYODAY AUTO PRIVATE LIMITED",
"SURYODAY FASHIONS PRIVATE LIMITED",
"SURYODAY MICRO FINANCE PRIVATE LIMITED",
"SURYODAY ONE ENERGY PRIVATE LIMITED",
"SURYODAY SMALL FINANCE BANK LIMITED",
"SURYODAY TOURS AND TRAVEL PRIVATE LIMITED",
"SURYODAY VYAPAR PRIVATE LIMITED",
"SURYODAYA COAL CARRIERS PRIVATE LIMITED",
"SURYODAYA EDIBLES (INDIA) PRIVATE LIMITED",
"SURYODAYA ELEVATORS PRIVATE LIMITED.",
"SURYODAYA HOSPITAL",
"SURYODAYA INDUSTRIES PRIVATE LIMITED",
"SURYODAYA INFRA PROJECTS INDIA PRIVATE LIMITED",
"SURYODAYA MOTORS PRIVATE LIMITED",
"SURYODAYA POWER PROTEINS PRIVATE LIMITED",
"SURYODAYA TEXTILES LIMITED",
"SURYSHREE WELLNESS PRIVATE LIMITED",
"SUS AGRO FOODS INDIA PRIVATE LIMITED",
"SUS POLYMERS PRIVATE LIMITED",
"SUSAAH LABORATORIES PRIVATE LIMITED",
"SUSAJJA ENTERPRISES PRIVATE LIMITED",
"SUSAJJIT TEXFAB PRIVATE LIMITED",
"SUSAN COLD CARE LOGISTICS PRIVATE LIMITED",
"SUSAN ELECTRICALS INDIA PRIVATE LIMITED",
"SUSANA METHODIST GIRLS B ED COLLEGE",
"SUSANA METHODIST GIRL'S B.ED COLLEGE",
"SUSANSKAR HIGHSCHOOL",
"SUSE SOFTWARE SOLUTIONS INDIA PRIVATE LIMITED",
"SUSEE AUTO LTD",
"SUSEE CARS AND TRUCKS PRIVATE LIMITED",
"SUSEE MOTORS INDIA PRIVATE LIMITED",
"SUSEE POLYMERS PRIVATE LIMITED",
"SUSEE PREMIUM AUTOMOBILES PRIVATE LIMITED",
"SUSEE TRUCKS PRIVATE LIMITED",
"SUSEE VEHICLE DEALERS PRIVATE LIMITED",
"SUSEELA NETRALAYA PRIVATE LIMITED",
"SUSEMA INFOSYSTEM PRIVATE LIMITED",
"SUSEMA INFOSYSTEM PRIVATE LIMITED OPC",
"SUSHA BE DESI DESIGN & CREATIONS PRIVATE LIMITED",
"SUSHAMA MULTITRADE PRIVATE LIMITED",
"SUSHAN TECHNO CRAFTS PRIVATE LIMITED",
"SUSHAN TRADINGS PRIVATE LIMITED",
"SUSHANT MINERALS PRIVATE LIMITED",
"SUSHANT PACKAGING PRIVATE LIMITED",
"SUSHANT PRINTS PRIVATE LIMITED",
"SUSHANT SONALI CONSTRUCTION PRIVATE LIMITED",
"SUSHANT TRAVELS PRIVATE LIMITED",
"SUSHANT UNIVERSITY",
"SUSHE MARINE SERVICES PRIVATE LIMITED",
"SUSHEE COATINGS PRIVATE LIMITED",
"SUSHEE HI-TECH PROJECTS PRIVATE LIMITED",
"SUSHEE INFRA & MINING LIMITED",
"SUSHEE VENTURES PRIVATE LIMITED",
"SUSHEEL JEWELLERY MART PRIVATE LIMITED",
"SUSHEEL MANPOWER SERVICES PRIVATE LIMITED",
"SUSHEEL MOTORS PRIVATE LIMITED",
"SUSHEEL YARNS PRIVATE LIMITED",
"SUSHEN MEDICAMENTOS PRIVATE LIMITED",
"SUSHI AGRO PRIVATE LIMITED",
"SUSHI AND MORE INDIA PRIVATE LIMITED",
"SUSHI ANIMAL NUTRITION PRIVATE LIMITED",
"SUSHI V EXIM PRIVATE LIMITED",
"SUSHIL AGGARWAL AND CO. PRIVATE LIMITED",
"SUSHIL BAHIRAT PATIL AND ASSOCIATES",
"SUSHIL BAHUUDDESHIYA SHIKSHAN SANSTHA",
"SUSHIL CAPITAL PRIVATE LIMITED",
"SUSHIL CORRUGATING AND CHEMICALS PRIVATE LIMITED",
"SUSHIL ENTERPRISES PRIVATE LIMITED",
"SUSHIL FINANCE CONSULTANTS LIMITED",
"SUSHIL FINANCIAL SERVICES PRIVATE LIMITED",
"SUSHIL FROZEN AGRO PROCESSING PRIVATE LIMITED",
"SUSHIL GLOBAL COMMODITIES PRIVATE LIMITED",
"SUSHIL JAIN HOLDINGS PRIVATE LIMITED",
"SUSHIL MEDICARE PRIVATE LIMITED",
"SUSHIL PULSES PRIVATE LIMITED",
"SUSHIL SPUNTEX PRIVATE LIMITED",
"SUSHILA AGENCIES PRIVATE LIMITED",
"SUSHILA AGROVET PRIVATE LIMITED",
"SUSHILA BIRLA GIRLS' SCHOOL",
"SUSHILA CARPETS PRIVATE LIMITED",
"SUSHILA DEVI BANSAL COLLEGE OF TECHNOLOGY",
"SUSHILA DEVI LOGISTICS & RELOCATIONS (OPC) PRIVATE LIMITED",
"SUSHILA GINNING PRIVATE LIMITED",
"SUSHILA INTERNATIONAL",
"SUSHILA PARMAR INTERNATIONAL PRIVATE LIMITED",
"SUSHILA TRANSPORT PRIVATE LIMITED",
"SUSHIMA PHARMACEUTICALS PRIVATE LIMITED",
"SUSHMA & CO ELECTRICALS",
"SUSHMA ASSOCIATES PRIVATE LIMITED",
"SUSHMA BUILDTECH LIMITED",
"SUSHMA EVERFRESH FOODS PRIVATE LIMITED",
"SUSHMA HIGH PRIMARY SCHOOL",
"SUSHMA HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED",
"SUSHMA INDUSTRIES PRIVATE LIMITED",
"SUSHMA ENGINEERING PRIVATE LIMITED",
"SUSHMA PRAMOD CONSTRUCTION PRIVATE LIMITED",
"SUSHOBHIT FOODS INDIA PRIVATE LIMITED",
"SUSHODHA INSTITUTE OF GASTROENTEROLOGY PRIVATE LIMITED",
"SUSHOM HEALTHCARE PRIVATE LIMITED",
"SUSHOM HOSPITALS PRIVATE LIMITED",
"SUSHRAVYA UPLIFTMENT FOUNDATION",
"SUSHREE TRADING LIMITED",
"SUSHREESARADA CONSTRUCTION PRIVATE LIMITED",
"SUSHRI TRADECOM PVT LTD",
"SUSHRUSHAH MEDICARE CENTRE PRIVATE LIMITED",
"SUSHRUT HOSPITAL AND RESEARCH CENTRE",
"SUSHRUT HOSPITAL RESCARCH CENTER",
"SUSHRUT INSTITUTE OF MEDICAL SCIENCES (INDIA) PRIVATE LIMITED",
"SUSHRUT INSTITUTE OF PLASTIC SURGERY PRIVATE LIMITED",
"SUSHRUT MEDICAL CENTRE PRIVATE LIMITED",
"SUSHRUTA ANO- RECTAL INSTITUTE PRIVATE LIMITED",
"SUSHRUTA HOSPITAL AND TRAUMA CARE PRIVATE LIMITED",
"SUSHRUTA MULTI SPECIALITY HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED",
"SUSHRUTA SURGICALS PRIVATE LIMITED",
"SUSHYAM FOODS PRIVATE LIMITED",
"SUSI COMMODITIES PRIVATE LIMITED",
"SUSIL KAR COLLEGE",
"SUSIN I - TORK INDIA PRIVATE LIMITED",
"SUSIN TECHNOLOGIES PRIVATE LIMITED",
"SUSKNIT EXPORTS PVT LTD",
"SUSMITA AUTOMOBILES PRIVATE LIMITED",
"SUSMITA ENTERPRISES",
"SUSONS HOTELS PRIVATE LIMITED",
"SUSPA PNEUMATICS INDIA PRIVATE LIMITED",
"SUSRI COMPUTERS AND CONSULTANCY PRIVATE LIMITED",
"SUSRI FINANCE PVT LTD",
"SUSRITAM BUILDERS AND DEVLOPERS PRIVATE LIMITED",
"SUSRUTA INSTRUMENTS PRIVATE LIMITED",
"SUSTAIN PROPERTIES PRIVATE LIMITED",
"SUSTAINABILITY INNOVATIONS AND ADVISORIES (SIA) PRIVATE LIMITED",
"SUSTAINABLE COMMUNITIES INDIA PRIVATE LIMITED",
"SUSTAINABLE COTTON SOLUTIONS PRIVATE LIMITED",
"SUSTAINABLE ENGINEERING AND FARMING ALLIANCE PRIVATE LIMITED",
"SUSTAINABLE PACKAGING PRIVATE LIMITED",
"SUSTAINABLE PROJECTS PRIVATE LIMITED",
"SUSTAINABLE SCIENCES PRIVATE LIMITED",
"SUSTAINABLE SKILL CAPITAL PRIVATE LIMITED",
"SUSTAINABLE SPINNING AND COMMODITIES PRIVATE LIMITED",
"SUSTAINABLE TECHNOSOLUTIONS FOR ENVIRONMENTAL PROTECTION PRIVATE LIMITED",
"SUSTAINABLY CRAFTED CLOTHING PRIVATE LIMITED",
"SUSTECH POWER SOLUTIONS PRIVATE LIMITED",
"SUSTHIRAA INFRA PROJECTS LLP",
"SUSVIN DENIM PRIVATE LIMITED",
"SUSWADEEPAGRO SERVICES PRIVATE LIMITED",
"SUSWANI INDIA PRIVATE LIMITED",
"SUSWANI TEXTILES PRIVATE LIMITED",
"SUT HOSPITAL SERVICES PRIVATE LIMITED",
"SUT RURAL GENERAL HOSPITAL",
"SUT SUPER SPECIALITY HOSPITAL",
"SUTA PRIVATE LIMITED",
"SUTA PVT LTD",
"SUTABECHA F P SCHOOL",
"SUTALIYA FINANCE PRIVATE LIMITED",
"SU-TANTRA EQUIPMENTS PRIVATE LIMITED",
"SUTANTRA INFOTECH PRIVATE LIMITED",
"SUTANTRA MACHINES PRIVATE LIMITED",
"SUTANTU SIZERS PRIVATE LIMITED",
"SUTARIA AUTO CENTRE",
"SUTARIA EXIM PRIVATE LIMITED",
"SUTARIYA GEMS PRIVATE LIMITED",
"SUTCO BEARINGS INDIA PRIVATE LIMITED",
"SUTECH INDUSTRIES PRIVATE LIMITED",
"SUTEJ HOLDINGS PRIVATE LIMITED",
"SUTEX YARNS PRIVATE LIMITED",
"SUTHAR INTERIOR PRIVATE LIMITED",
"SUTHAR RAMCHANDRA JAISWAL TECH PRIVATE LIMITED",
"SUTHERLAND GLOBAL SERVICES PRIVATE LIMITED",
"SUTHERLAND HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"SUTHERLAND MORTGAGE SERVICES INC",
"SUTHERLAND MORTGAGE SVCS INC",
"SUTISOFT PRIVATE LIMITED",
"SUTLAJ SALES PVT. LTD.",
"SUTLEJ ADVANCED DIAGNOSTICS PRIVATE LIMITED",
"SUTLEJ COACH PRODUCTS PRIVATE LIMITED",
"SUTLEJ CONSTRUCTIONS PRIVATE LIMITED",
"SUTLEJ INDUSTRIES LIMITED",
"SUTLEJ LOGISTICS PRIVATE LIMITED",
"SUTLEJ PUBLIC SENIOR SECONDARY SCHOOL",
"SUTLEJ TEXTILES AND INDUSTRIES LIMITED",
"SUTRA SERVICES PRIVATE LIMITED",
"SUTRA SYSTEMS INDIA PRIVATE LIMITED",
"SUTRAA CREATIONS PRIVATE LIMITED",
"SUTRAM CREATIONS PRIVATE LIMITED",
"SUTRAN POLYMERS PVT LTD",
"SUTRO LI INDIA PRIVATE LIMITED",
"SUTTATTI ENTERPRISES PRIVATE LIMITED",
"SUTTHIMANI FOODS PRIVATE LIMITED",
"SUTTIND SEEDS PRIVATE LIMITED",
"SUTURES INDIA PRIVATE LIMITED",
"SUU-BAG ENGINEERING & PIPING SYSTEMS PRIVATE LIMITED",
"SUUBH LAAXMI DAIRY PRODUCER COMPANY LIMITED",
"SUUMAYA AGRO LIMITED",
"SUUMAYA CORPORATION LIMITED",
"SUUMAYA INDUSTRIES LIMITED",
"SUUMAYA PROTECTIVE TEXCORP LIMITED",
"SUUMAYA RETAIL LIMITED",
"SU-URJA SOLAR SYSTEMS PRIVATE LIMITED",
"SUVAAS HOMES PRIVATE LIMITED",
"SUVACA TECHNOLOGIES PRIVATE LIMITED",
"SUVAI HEALTHY KITCHENS PRIVATE LIMITED",
"SUVALKHA BIO ORGANICS AGRICULTURAL PRODUCE & EXPORTS PRODUCER COMPANY LIMITED",
"SUVAM TRANSMISSION PRIVATE LIMITED",
"SUVAN STEELS PRIVATE LIMITED",
"SUVAN TECHNOLOGY SOLUTIONS INDIA PRIVATE LIMITED",
"SUVARCHAS SOLAR POWER PRIVATE LIMITED",
"SUVARN APPLIANCES PRIVATE LIMITED",
"SUVARNA ADDITIVES PRIVATE LIMITED",
"SUVARNA ALLOYS PRIVATE LIMITED",
"SUVARNA BHASKAR INFRASTRUCTURE PRIVATE LIMITED",
"SUVARNA DURGA AGRO PRODUCTS PRIVATE LIMITED",
"SUVARNA DURGA BOTTLES PRIVATE LIMITED",
"SUVARNA DURGA PAPER BOARDS PRIVATE LIMITED",
"SUVARNA DURGA PAPER MILLS PRIVATE LIMITED",
"SUVARNA ELECTRICALS PRIVATE LIMITED",
"SUVARNA FACILITIES MANAGEMENT SERVICES PRIVATE LIMITED",
"SUVARNA FLOREX LIMITED",
"SUVARNA SANJIVANI SUGARCANE TRANSPORT PRIVATE LIMITED",
"SUVARNA SHILPI JEWELLERS PRIVATE LIMITED",
"SUVARNA TECHNOSOFT PRIVATE LIMITED",
"SUVARNABHOOMI ENTERPRISES PRIVATE LIMITED",
"SUVARNAINDRADHANU FRATERNITY FUND INDIA PRIVATE LIMITED",
"SUVARNAKALA PRIVATE LIMITED",
"SUVARNAKUTEER DEVELOPERS PRIVATE LIMITED",
"SUVARNAMAYEE ENTERPRISES PRIVATE LIMITED",
"SUVARNAMAYEE INFRA PRIVATE LIMITED",
"SUVARNASANSKRITI JEWELS PRIVATE LIMITED",
"SUVARNBHUMI GOLD PRIVATE LIMITED",
"SUVAS HOLDINGS LIMITED",
"SUVAS INFRASTRUCTURE PRIVATE LIMITED",
"SUVASA APPAREL AND FURNISHING PRIVATE LIMITED",
"SU-VASTIKA SYSTEMS PRIVATE LIMITED",
"SUVASTU HOUSING PRIVATE LIMITED",
"SUVEDA FACILITY MANAGEMENT PRIVATE LIMITED",
"SUVEDAA HOMES PRIVATE LIMITED",
"SUVEECHI TECHNOLOGIES PRIVATE LIMITED",
"SUVEGA ENTERPRISES PRIVATE LIMITED",
"SUVEGA TECHNOLOGIES PRIVATE LIMITED",
"SUVEN AGRO INDUSTRIES PRIVATE LIMITED",
"SUVEN LIFE SCIENCE LIMITED",
"SUVEN PHARMACEUTICALS LIMITED",
"SUVENTURE SERVICES PRIVATE LIMITED",
"SUVERA FLUID POWER PRIVATE LIMITED",
"SUVERA HATCHERIES PVT LTD.",
"SUVI EYE HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED",
"SUVI INTERNATIONAL PRIVATE LIMITED",
"SUVID SOLUTIONS PRIVATE LIMITED",
"SUVIDA INTEGRATED SERVICES PRIVATE LIMITED",
"SUVIDH COMMODITIES E COM PRIVATE LIMITED",
"SUVIDHA AGRIPRO PRIVATE LIMITED",
"SUVIDHA CONSULTANTS LIMITED",
"SUVIDHA CONSULTANTS PRIVATE LIMITED",
"SUVIDHA COOLING TOWERS PRIVATE LIMITED",
"SUVIDHA EXPRESS (OPC) PRIVATE LIMITED",
"SUVIDHA HOME DEVELOPERS PRIVATE LIMITED",
"SUVIDHA INFRACON PRIVATE LIMITED",
"SUVIDHA INFRASTRUCTURE PRIVATE LIMITED",
"SUVIDHA INSURANCE BROKING PRIVATE LIMITED",
"SUVIDHA INTERIORS AND TURNKEY PRIVATE LIMITED",
"SUVIDHA MOVERS PRIVATE LIMITED",
"SUVIDHA PROJECTS PRIVATE LIMITED",
"SUVIDHA REALTORSANDCONSTRUCTIONS PRIVATE LIMITED",
"SUVIDHA S SERVICES",
"SUVIDHA SAREES INDIA PRIVATE LIMITED",
"SUVIDHA SECURITIES PRIVATE LIMITED",
"SUVIDHA SERVICES",
"SUVIDHA STORES PRIVATE LIMITED",
"SUVIDHA TALENT PRIVATE LIMITED",
"SUVIDHAA INFOSERVE LIMITED",
"SUVIDHAA INFOSERVE PRIVATE LIMITED",
"SUVIDHI CREATIONS PRIVATE LIMITED",
"SUVIDHI ENERGY INDIA PRIVATE LIMITED",
"SUVIDHI ENTERPRISES PRIVATE LIMITED",
"SUVIDHI GOLD PRIVATE LIMITED",
"SUVIDHI INTERNATIONAL PRIVATE LIMITED",
"SUVIDHI ORNA PRIVATE LIMITED",
"SUVIDHI PROCON PRIVATE LIMITED",
"SUVIDHI RAYONS PRIVATE LIMITED",
"SUVIDHI REALTIES PRIVATE LIMITED",
"SUVIDHI SYNTHETICS PRIVATE LIMITED",
"SUVIDHI UDYOG PRIVATE LIMITED",
"SUVIDHYA SCHOOL",
"SUVIDYA INSTITUTE OF TECHNOLOGY PRIVATE LIMITED",
"SUVIH ENGINEERING SERVICES PRIVATE LIMITED",
"SUVIK HITEK PVT LTD",
"SUVIKAS LOGISTICS PRIVATE LIMITED",
"SUVIKSHA HEALTH CARE PRIVATE. LIMITED.",
"SUVILAS PROPERTIES PRIVATE LIMITED",
"SUVILON RAREFEB PRIVATE LIMITED",
"SUVINI INFRA PRIVATE LIMITED",
"SUVINO EXPORTS PRIVATE LIMITED",
"SUVIRA UTILITY SERVICES PRIVATE LIMITED",
"SUVIRE ELECTRIC PRIVATE LIMITED",
"SUVIRON EQUIPMENTS PRIVATE LIMITED",
"SUVISHESH LOGISTICS PRIVATE LIMITED",
"SUVISHRHU SPECIALITY CHEMICALS PRIVATE LIMITED",
"SUVITA REAL ESTATES PRIVATE LIMITED",
"SUVITAS HOLISTIC HEALTHCARE PRIVATE LIMITED",
"SUVITH TECHNO SOLUTIONS PRIVATE LIMITED",
"SUVOCHEM INDUSTRIES PVT LTD",
"SUVRAT INDUSTRIAL PRODUCTS INDIA PRIVATE LIMITED",
"SUVRAT STEELS PRIVATE LIMITED",
"SUVRIDHI CAPITAL MARKETS PRIVATE LIMITED",
"SUVYA WEB",
"SUWALAL RAJESH KUMAR TRADING PRIVATE LIMITED",
"SUWALAL RAVI PRAKASH OILS PVT LTD",
"SUWALKA INDUSTRIES PRIVATE LIMITED",
"SUWALKA MOTORS PRIVATE LIMITED",
"SUWASTHI INTENSE BEAUTY PRODUCTS PRIVATE LIMITED",
"SUWBHA CAFE PRIVATE LIMITED",
"SUWIN SOFTWARE SOLUTIONS PRIVATE LIMITED",
"SUWINKA ENGINEERING PRIVATE LIMITED",
"SUXES HOSPITALITY SOLUTIONS PRIVATE LIMITED",
"SUXUS SYSTEMS LTD",
"SUYAAN INFRASTRUCTURE PRIVATE LIMITED",
"SUYAN TEXTILE PRIVATE LIMITED",
"SUYARA INDUSTRIES PRIVATE LIMITED",
"SUYASH AUTO PRESS COMPONENTS & ASSEMBLYS PRIVATE LIMITED",
"SUYASH CHEMICAL AND FERTILIZER PRIVATE LIMITED",
"SUYASH COMMODITIES PRIVATE LIMITED",
"SUYASH CONSTRUWELL PRIVATE LIMITED",
"SUYASH CONVENT",
"SUYASH DIAGNOSTIC CENTRE PVT LTD",
"SUYASH ENGINE COMP PRIVATE LIMITED",
"SUYASH ENGINEERS AND AUTOMATION PRIVATE LIMITED",
"SUYASH EQUIPMENTS PRIVATE LIMITED",
"SUYASH GLOBAL PRIVATE LIMITED",
"SUYASH HOSPITAL PVT. LTD",
"SUYASH HOTELS PVT LTD",
"SUYASH INSTITUTE OF MEDICAL SCIENCE PRIVATE LIMITED",
"SUYASH KRAFT AND PAPERS LIMITED.",
"SUYASH KRAFT AND PAPERS PRIVATE LIMITED",
"SUYASH MART PRIVATE LIMITED",
"SUYASH MEDICAL FOUNDATION PRIVATE LIMITED",
"SUYASH METAL PRESSINGS PVT LTD",
"SUYASH METATECH PRIVATE LIMITED",
"SUYASH ORGANICS PRIVATE LIMITED",
"SUYASH POLYMER",
"SUYASH REALTORS",
"SUYASH SOLUTIONS PRIVATE LIMITED",
"SUYASH SPECIALITY ENGINEERING",
"SUYASH SYNTHETIC PRIVATE LIMITED",
"SUYATI TECHNOLOGIES PRIVATE LIMITED",
"SUYESH DUCTILE CASTING PRIVATE LIMITED",
"SUYESH FOUNDRY PRIVATE LIMITED",
"SUYESH GURUKUL SOLAPUR",
"SUYESH IRON & STEELS PRIVATE LIMITED",
"SUYOG AGRO AND POULTRY PRODUCTS PRIVATE LIMITED",
"SUYOG AUTOCAST PRIVATE LIMITED",
"SUYOG COMPUTECH PRIVATE LIMITED",
"SUYOG CONSTRUCTIONS",
"SUYOG DEVELOPMENT CORPORATION LIMITED",
"SUYOG DIAGNOSTICS PRIVATE LIMITED",
"SUYOG DIGITAL PRIVATE LIMITED",
"SUYOG DYE CHEMIE PVT LTD",
"SUYOG ELECTRICALS LIMITED",
"SUYOG ELEMENTS INDIA PRIVATE LIMITED",
"SUYOG GURBAXANI FUNICULAR ROPEWAYS LIMITED",
"SUYOG GURBAXANI FUNICULAR ROPEWAYS PRIVATE. LIMITED.",
"SUYOG HOSPITAL",
"SUYOG INFRA (INDIA) PRIVATE LIMITED",
"SUYOG LIFE SCIENCES PRIVATE LIMITED",
"SUYOG LOGISTICS PARK PRIVATE LIMITED",
"SUYOG MERCHANDISE SHIPPING PRIVATE LIMITED",
"SUYOG MILK AND AGRO PRODUCTS PRIVATE LIMITED",
"SUYOG NURSING HOME PRIVATE LIMITED",
"SUYOG PHARMACEUTICALS PRIVATE LIMITED",
"SUYOG PRINTERS PRIVATE LIMITED",
"SUYOG RUBBER INDIA PRIVATE LIMITED",
"SUYOG SALES PRIVATE LIMITED",
"SUYOG SECURITIES PRIVATE LIMITED",
"SUYOG STEELS PRIVATE LIMITED",
"SUYOG SYSTEM AND SOFTWARE PRIVATE LIMITED",
"SUYOG TELEMATICS LIMITED",
"SUYOG TELEMATICS PRIVATE. LIMITED.",
"SUYOG TRADING COMPANY PRIVATE LIMITED",
"SUYOG URJA PRIVATE LIMITED",
"SUYOJAN HYDROMECHANICAL SYSTEMS PRIVATE LIMITED",
"SUYOJIT CHEMICALS WORKS PRIVATE LIMITED",
"SUYOJIT INFRASTRUCTURE PRIVATE LIMITED",
"SUYOSHA HEALTHCARE PRIVATE LIMITED",
"SUYUKTA TAX N TECH PRIVATE LIMITED",
"SUZAL AQUA MINERALS PRIVATE LIMITED",
"SUZALKEM TECHNOLOGIES PRIVATE LIMITED",
"SUZ-DENT (INDIA) PRIVATE LIMITED",
"SUZERAIN POLYMERS PRIVATE LIMITED",
"SUZETTE GOURMET PRIVATE LIMITED",
"SUZHIK FLOW CONTROL PRIVATE LIMITED",
"SUZIKEM DRUGS PRIVATE LIMITED",
"SUZION MERCANTILE PRIVATE LIMITED",
"SUZLON ENERGY LIMITED",
"SUZLON FOUNDATION",
"SUZLON GLOBAL SERVICES LIMITED",
"SUZLON GUJARAT WIND PARK LIMITED",
"SUZUKI MOTOR GUJARAT PRIVATE LIMITED",
"SUZUKI MOTORCYCLE INDIA PRIVATE LIMITED",
"SUZY INDUSTRIES LIMITED",
"SUZYNOVA DENTAL PVT LTD",
"SV AGRICO INDIA PRIVATE LIMITED",
"SV AGRO FOODS PRIVATE LIMITED",
"SV ASSOCIATES MANAGEMENT CONSULTANCY PRIVATE LIMITED",
"SV AUTOMOTIVES PRIVATE LIMITED",
"SV CARRIERS PRIVATE LIMITED",
"SV CONCRETE PRODUCTS PRIVATE LIMITED",
"SV CREDIT LINE PRIVATE. LIMITED.",
"SV DECCAN IMPEX PRIVATE LIMITED",
"SV DECOR PRIVATE LIMITED",
"SV DREEAMPLANNERS PRIVATE LIMITED",
"SV ECCENTRICS PRIVATE LIMITED",
"SV GAS SOLUTIONS PRIVATE LIMITED",
"SV GLOBAL DESIGNS PRIVATE LIMITED",
"SV GLOBAL FINANCE PRIVATE LIMITED",
"SV HOLIDAY BAZAAR PRIVATE LIMITED",
"SV LEATHERS (INDIA) PRIVATE LIMITED",
"SV MATERIALS HANDLING SYSTEMS PRIVATE LIMITED",
"SV METALS AND EXTRUSIONS PRIVATE LIMITED",
"SV PITTIE INDUSTRIES PRIVATE LIMITED",
"SV PITTIE INTERNATIONAL PRIVATE LIMITED",
"SV PLASTOCHEM PRIVATE LIMITED",
"SV SHARDA MECHANISM PRIVATE LIMITED",
"SV SMART INDIA PRIVATE LIMITED",
"SV STEELAGE PRIVATE LIMITED",
"SV SURGITECH PRIVATE LIMITED",
"SV TURNKEY PROJECTS PRIVATE LIMITED",
"SVA COUTURE PRIVATE LIMITED",
"SVA INDIA LTD",
"SVA LOGISTICS PRIVATE LIMITED",
"SVA READY MIX CONCRETE PRIVATE LIMITED",
"SVA SYNTEX PRIVATE LIMITED",
"SVA TURNKEY PROJECTS PRIVATE LIMITED",
"SVAAR PROCESS SOLUTIONS PRIVATE LIMITED",
"SVAB DIAMONDS N JEWELS PRIVATE LIMITED",
"SVADHIN SOLUTIONS PRIVATE LIMITED",
"SVADHYAYA EDUCATION FOUNDATION",
"SVAHGRAHA CONSTRUCTIONS AND HOLDINGS PRIVATE LIMITED",
"SVAKRUTHI AESTHETICS PRIVATE LIMITED",
"SVAKSHA DISTILLERY LIMITED",
"SVAM POWER PLANTS PRIVATE LIMITED",
"SVAM TOYAL PACKAGING INDUSTRIES PRIVATE LIMITED",
"SVAMAAN FINANCIAL SERVICES PRIVATE LIMITED",
"SVAMITVA INFRA PRIVATE LIMITED",
"SVAMYARTHA SHIPPING AND TRADING SOLUTIONS PRIVATE LIMITED",
"SVAN TEXCON PRIVATE LIMITED",
"SVANA SYSTEMS PRIVATE LIMITED",
"SVANZ INTERNATIONAL PRIVATE LIMITED",
"SVAP INFOTECH PRIVATE LIMITED",
"SVAP LINKS PRIVATE LIMITED",
"SVAPAS INNOVATIONS PRIVATE LIMITED",
"SVAR FRAGRANCES AND FLAVORS PRIVATE LIMITED",
"SVARA PURE GRAINS PRIVATE LIMITED",
"SVARAPPS TECHNOLOGIES INDIA PRIVATE LIMITED",
"SVARN CONSULTANCY INVESTMENT PRIVATE LIMITED",
"SVARN INFRATEL PRIVATE LIMITED",
"SVARN TELECOM LIMITED",
"SVARN TEX PRINTS PRIVATE LIMITED",
"SVARNA INFRASTRUCTURE & BUILDERS PRIVATE LIMITED",
"SVAROG GLOBAL POWER PRIVATE LIMITED",
"SVARRNIM INFRASTRUCTURES PRIVATE LIMITED",
"SVARYU ENERGY LIMITED",
"SVAS INVESTMENTS PRIVATE LIMITED",
"SVAS MED PRIVATE LIMITED",
"SVASCA INDUSTRIES (INDIA) LTD.",
"SVASTANIBHANDA MEDICAL TECHNOLOGIES PRIVATE LIMITED",
"SVASTH HEALTHI SOLUTIONS PRIVATE LIMITED",
"SVASTH LIFE PRIVATE LIMITED",
"SVASTHYA CLINICS PRIVATE LIMITED",
"SVASTHYAM HEALTHCARE PRIVATE LIMITED",
"SVASTI MICROFINANCE PRIVATE LIMITED",
"SVASTIKA GAMES PRIVATE LIMITED",
"SVATANTRA HOLDINGS PRIVATE LIMITED",
"SVATANTRA MICRO HOUSING FINANCE CORPORATION LIMITED",
"SVATANTRA MICROFIN PRIVATE LIMITED",
"SVATANTRA ONLINE SERVICES PRIVATE LIMITED",
"SVAVA TECHNOLOGIES INDIA PRIVATE LIMITED",
"SVAVVASHAA TECHNOLOGIES PRIVATE LIMITED",
"SVB BEARINGS PRIVATE LIMITED",
"SVB COMPONENTS LLP",
"SVB S SARASWATHI COLLEGE OF EDUCATION & RESEARCH",
"SVC CARGO PRIVATE LIMITED",
"SVC CO OPERATIVE BANK LTD",
"SVC FARMERS PRODUCER COMPANY LIMITED",
"SVC HR SOLUTIONS PRIVATE LIMITED",
"SVC VENTURES PRIVATE LIMITED",
"SVCC LATUR COLLEGE OF PHYSIOTHERAPY HASEGAON",
"SVD INFRACON LIMITED",
"SVD MOTORS PRIVATE LIMITED",
"SVE CASTINGS PRIVATE LIMITED",
"SVE DRILLING TOOLS PRIVATE LIMITED",
"SVE ENGINEERS PRIVATE LIMITED",
"SVE STEELS PRIVATE LIMITED",
"SVENSKA GLOBAL MANAGEMENT SERVICES PRIVATE LIMITED",
"SVENSKA TECHNOLOGIES PRIVATE LIMITED",
"SVERA AGRO LIMITED",
"SVEYDI INFRASTRUCTURE PRIVATE LIMITED",
"SVEZZ AGRO EXIM PRIVATE LIMITED",
"SVF ENTERTAINMENT PRIVATE LIMITED",
"SVF INVESTMENT ADVISERS (INDIA) PRIVATE LIMITED",
"SVG CONTROL SYSTEMS PRIVATE LIMITED",
"SVG EXPORTS PRIVATE. LIMITED.",
"SVG EXPRESS SERVICES PRIVATE LIMITED",
"SVG FASHIONS LIMITED",
"SVG FASHIONS PRIVATE LIMITED",
"SVG GRANITES LIMITED",
"SVG INTERNATIONAL PRIVATE LIMITED",
"SVG MEDIA PRIVATE LIMITED",
"SVG PROPERTIES PRIVATE LIMITED",
"SVGV MATRICULATION HIGHER SECONDARY SCHOOL",
"SVI CARBON PRIVATE LIMITED",
"SVIB SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"SVICC COMPUTERS PRIVATE LIMITED",
"SVIIT SOFTWARE PRIVATE LIMITED",
"SVIL AUTOMATION PRIVATE LIMITED",
"SVINT ENGINEERING PRIVATE LIMITED",
"SVISS LABSS PRIVATE LIMITED",
"SVITCH ENERGY PRIVATE LIMITED",
"SVITZER HAZIRA PRIVATE LIMITED",
"SVITZER INDIA PRIVATE LIMITED",
"SVIZERA HEALTHCARE PRIVATE LIMITED",
"SVIZERA LABS PRIVATE LIMITED",
"SVK FOODS PRIVATE LIMITED",
"SVK GREENTECH PRIVATE LIMITED",
"SVK INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"SVK INFRACON PRIVATE LIMITED",
"SVK LABORATORIES PRIVATE LIMITED",
"SVK MOTORS PRIVATE LIMITED",
"SVK PHARMA PRIVATE LIMITED",
"SVK ROCK DRILLS PRIVATE LIMITED",
"SVKM BHAGHUBHAI MAFATLAL POLYTECHNIC",
"SVKM FOUNDATION",
"SVKM'S NMIMS",
"SVL CORPORATE SERVICES",
"SVL INDIA PRIVATE LIMITED",
"SVL PRINTERS PRIVATE LIMITED",
"SVL TEXTILES PRIVATE LIMITED",
"SVM BUILDCON PRIVATE LIMITED",
"SVM CATERING SERVICES PRIVATE LIMITED",
"SVM CERA PRIVATE LIMITED",
"SVM ELECTRONIC INDIA PRIVATE LIMITED",
"SVM ENG MED SCHOOL",
"SVM ENGLISH MEDIUM SCHOOL DASCROI",
"SVM IMPEX PRIVATE LIMITED",
"SVM INFRAESTATE PRIVATE LIMITED",
"SVM INFRATECH PRIVATE LIMITED",
"SVM MOTORS PRIVATE LIMITED",
"SVM NONWOVENS PRIVATE LIMITED",
"SVM PRIVATE LIMITED",
"SVMA SOYA FOODS PRIVATE LIMITED",
"SVMED SOLUTIONS PRIVATE LIMITED",
"SVN BUILDERS PRIVATE LIMITED",
"SVN LASER TECH PRIVATE LIMITED",
"SVN SYSTECH INDIA PRIVATE LIMITED",
"SVNEEL AUTO COMP PRIVATE LIMITED",
"SVNT INFOTECH PRIVATE LIMITED",
"SVOD ADVISORY (INDIA) PRIVATE LIMITED",
"SVOJAS RETAIL PRIVATE LIMITED",
"SVP BUILDERS I LIMITED",
"SVP DEVELOPERS LIMITED",
"SVP ENERGY PRIVATE LIMITED",
"SVP FAB & ELECTRO ENGINEERING PRIVATE LIMITED",
"SVP FOODS PRIVATE LIMITED",
"SVP GLOBAL TEXTILES LIMITED",
"SVP INDUSTRIES LIMITED.",
"SVP LASER TECHNOLOGIES PRIVATE LIMITED",
"SVP MINING TECHNOLOGIES PRIVATE LIMITED",
"SVP ONLINE SHOPPING PRIVATE LIMITED",
"SVP PACKING INDUSTRY PRIVATE LIMITED",
"SVP SHIKSHAN AVAM ANUSANDHAN SANSTHAN",
"SVP TECHNO ENGINEERS PRIVATE LIMITED",
"SVPA EXPORTS PRIVATE LIMITED",
"SVPC AUTOMOTIVE PRIVATE LIMITED",
"SVPC INFRASTRUCTURE PRIVATE LIMITED",
"SVPL DEVELOPERS PRIVATE LIMITED",
"SVR AGROTECH PRIVATE LIMITED",
"SVR BIO PRIVATE LIMITED",
"SVR BROTHERS PRIVATE LIMITED",
"SVR CREATIONS PRIVATE LIMITED",
"SVR DRUGS PRIVATE LIMITED",
"SVR ELECTRO PROJECTS PRIVATE LIMITED",
"SVR ENTERPRISES",
"SVR FOODS",
"SVR HYDRAULICS",
"SVR INFRAATEL PRIVATE LIMITED",
"SVR LABORATORIES PRIVATE LIMITED",
"SVR MEDICAL TECHNOLOGIES PRIVATE LIMITED",
"SVR SEA FOODS EXPORTS PRIVATE LIMITED",
"SVR SPINNING MILLS PRIVATE LIMITED",
"SVRE PACKAGING PRIVATE LIMITED",
"SVRK DEGREE COLLEGE",
"SVS ALLOYS PRIVATE LIMITED",
"SVS BUILDWEL PRIVATE LIMITED",
"SVS COTTONS (INDIA) PRIVATE LIMITED",
"SVS ENGINEERING SERVICES PRIVATE LIMITED",
"SVS FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"SVS FOOD PROCESSORS PRIVATE LIMITED",
"SVS GLOBAL SOFTECH LLP",
"SVS GROUP OF INSTITUTIONS",
"SVS GUARDING SERVICES PRIVATE LIMITED",
"SVS HIGH SCHOOL",
"SVS HYDRAULICS PRIVATE LIMITED",
"SVS INFRACON PRIVATE LIMITED",
"SVS INSTRUMENTS AND CONTROL SYSTEMS (INDIA) PRIVATE LIMITED",
"SVS JR DEGREE COLLEGE",
"SVS MARINE SERVICES PRIVATE LIMITED",
"SVS MED TECH PRIVATE LIMITED",
"SVS MEDICAL COLLEGE AND HOSPITAL",
"SVS MEDICAL DEVICES INDIA PRIVATE LIMITED",
"SVS MEDICARE PRIVATE LIMITED",
"SVS MINERALS PRIVATE LIMITED",
"SVS MOOKAMBIKA CONSTRUCTIONS PRIVATE LIMITED",
"SVS MULTIEXIM PRIVATE LIMITED",
"SVS NOVOTEC PRIVATE LIMITED",
"SVS PRODUCTS PRIVATE LIMITED",
"SVS PROJECTS INDIA PRIVATE LIMITED",
"SVS RN PROJECTS PRIVATE LIMITED",
"SVS ROADLINES PRIVATE LIMITED",
"SVS SOLUTIONS PRIVATE LIMITED",
"SVS SOURCINGS PRIVATE LIMITED",
"SVS TECHNOLOGY SERVICES PRIVATE LIMITED",
"SVS TRADERS PRIVATE LIMITED",
"SVS VENTURES LIMITED",
"SVSM PACKAGING PRIVATE LIMITED",
"SVSS INFOTECH PRIVATE LIMITED",
"SVSS SHRIMANT RAJE DAULATSINGHJI RAWAL B ED COLLEGE DONDAICHA",
"SVT ENGINEERING SYSTEMS PRIVATE LIMITED",
"SVT INFRASTRUCTURE INDIA PRIVATE LIMITED",
"SVT LOGISTICS PRIVATE LIMITED",
"SVT MARKETING (I) PRIVATE LIMITED",
"SVTL VANIJYA LIMITED",
"SVTM PRIVATE LIMITED",
"SVTN CONSTRUCTIONS PRIVATE LIMITED",
"SVV INNOVATIONS PRIVATE LIMITED",
"SVVD GREEN HOUSING PRIVATE LIMITED",
"SVVN PU COLLEGE",
"SW CAPITAL PRIVATE LIMITED",
"SW CONSULTANTS PRIVATE LIMITED",
"SW ENGINEERING PRIVATE LIMITED",
"SW FARMS PRIVATE LIMITED",
"SW HEALTH CARE PRIVATE LIMITED",
"SW IRON WORKS PRIVATE LIMITED",
"SW METAFORM PRIVATE LIMITED",
"SWA AUTOMATION PRIVATE LIMITED",
"SWA LIFFSTYLE LLP",
"SWAAADLE TECH PRIVATE LIMITED",
"SWAAD AGRO INDUSTRIES PRIVATE LIMITED",
"SWAAD MANTRA HOTELS AND RESTAURANTS PRIVATE LIMITED",
"SWAADAM AGROTECH PRIVATE LIMITED",
"SWAADYA SPICE ENTERPRISES PRIVATE LIMITED",
"SWAAHA EMC PRIVATE LIMITED",
"SWAANUSH FRUIT OASIS PRIVATE LIMITED",
"SWAAS SYSTEMS PRIVATE LIMITED",
"SWAASA PHARMA PRIVATE LIMITED",
"SWABHIMAAN DISTRIBUTION SERVICES PRIVATE LIMITED",
"SWABHIMAAN FINANCE PRIVATE LIMITED",
"SWABHIMAN COMMERCIAL PRIVATE LIMITED",
"SWABHIMAN VIJ TANTRIK NAGARI SEWA SAHKARI SANSTHA AMRAVATI",
"SWABHIMANI AGRO PRODUCTS PRODUCER COMPANY LIMITED",
"SWABHIMANKISAN WHEAT PRODUCER COMPANY LIMITED",
"SWACH ENVIRONMENT PRIVATE LIMITED",
"SWACH PLUS SEVA SAHAKARI SANSHTA MARYADIT",
"SWACH PUNE SEVA SAHAKARI SANSTHA LTD",
"SWACHAL CONSTRUCTION PRIVATE LIMITED",
"SWACHH PACKAGING PRIVATE LIMITED",
"SWACHH PURIFIER PRIVATE LIMITED",
"SWACHH SUSTAINABLE SOLUTIONS PRIVATE LIMITED",
"SWAD AGRO COLD CHAIN PRIVATE LIMITED",
"SWADARSH ENGINEERING AND SERVICES",
"SWADARSHAN FARMERS PRODUCER COMPANY LIMITED",
"SWADDLE PROJECTS PRIVATE LIMITED",
"SWADEEP EXPORTS PRIVATE LIMITED",
"SWADES FOUNDATION",
"SWADES SOURCING SOLUTIONS PRIVATE LIMITED",
"SWADESH AUTO PRIVATE LIMITED",
"SWADESH BUSINESS SOLUTION PRIVATE LIMITED",
"SWADESH FOUNDATION",
"SWADESH GREEN INFRA LIMITED",
"SWADESH INFRA MARKETING PRIVATE LIMITED",
"SWADESH MILK PRODUCTS PRIVATE LIMITED",
"SWADESH PRAKASHAN GWALIOR PVT LTD",
"SWADESH SUITINGS PRIVATE LIMITED",
"SWADESHI AUTO PRIVATE LIMITED",
"SWADESHI CIVIL INFRASTRUCTURE PRIVATE LIMITED",
"SWADESHI DYEING AND BLEACHING MILLS PRIVATE LIMITED",
"SWADESHI EMPRESA PRIVATE LIMITED",
"SWADESHI ENGINEERING ENTERPRISES PRIVATE LIMITED",
"SWADESHI EXIM PRIVATE LIMITED",
"SWADESHI FOOTCARE PRIVATE LIMITED",
"SWADESHI KHADI TRADERS PRIVATE LIMITED",
"SWADESHI LOOMTEX PRIVATE LIMITED",
"SWADESHI POLYFILLS PRIVATE LIMITED",
"SWADESHI POLYTEX LTD",
"SWADESHI RAIMENT PRIVATE LIMITED.",
"SWADESHI SILK",
"SWADESHI TEXTILES PRIVATE LIMITED",
"SWADESHI TUBES LTD",
"SWADESHI VISION PRIVATE LIMITED",
"SWADHA AARAV INFRASTRUCTURE PRIVATE LIMITED",
"SWADHA DEVELOPERS PRIVATE LIMITED",
"SWADHA FINLEASE PRIVATE LIMITED",
"SWADHAAR FINSERVE PRIVATE. LIMITED",
"SWADHYAYA FLEXIPACK PRIVATE LIMITED",
"SWADHYAYA PRINTERS PRIVATE LIMITED",
"SWADIK TRADE PRIVATE LIMITED",
"SWADISHTA MASALA & FOOD",
"SWAGAT CATERERS PRIVATE LIMITED",
"SWAGAT FREIGHT CARRIERS PRIVATE LIMITED",
"SWAGAT HOSPITALS PRIVATE LIMITED",
"SWAGAT HOUSING FINANCE COMPANY LIMITED",
"SWAGAT INFRASTRUCTURE PRIVATE LIMITED",
"SWAGAT MAKEWELL INDIA PRIVATE LIMITED",
"SWAGAT PRECISION PRODUCTS PRIVATE LIMITED",
"SWAGAT SARESS PRIVATE LIMITED",
"SWAGAT SHAKTI TRADE WORLD PRIVATE LIMITED",
"SWAGATA ELECTRICALS PRIVATE LIMTED",
"SWAGATAM HOLIDAYS PRIVATE LIMITED",
"SWAGATAM REAL ESTATE PRIVATE LIMITED",
"SWAGATAM TOURS PRIVATE LIMITED",
"SWAGATH CONTINENTAL PRIVATE LIMITED.",
"SWAGATH THREADS PVT LTD",
"SWAGATH URETHANE PRIVATE LIMITED",
"SWAGATHAM RESOURCE MANAGEMENT INDIA PRIVATE LIMITED",
"SWAGO WEB PRIVATE LIMITED",
"SWAGSTAY PRIVATE LIMITED",
"SWAI TECHNOLOGIES PRIVATE LIMITED",
"SWAIKA EXPORTS PRIVATE LIMITED",
"SWAINZ BUSINESS SERVICES PRIVATE LIMITED",
"SWAJAL WATER PRIVATE LIMITED",
"SWAJAN INDUSTRIES PRIVATE LIMITED",
"SWAJI NUTRITIONALS PRIVATE LIMITED",
"SWAJIT ABRASIVES PRIVATE LIMITED",
"SWAJIT ENGINEERING PRIVATE. LIMITED.",
"SWAJYOT SYSTEMS PRIVATE LIMITED",
"SWAJYOTI FOREX AND TRAVELS PRIVATE LIMITED",
"SWAKAM BIOTECH PRIVATE LIMITED",
"SWAKI ELECTRICAL PRIVATE LIMITED",
"SWAKUL AGRO PRODUCER COMPANY LIMITED",
"SWAL CORPORATION LIMITED",
"SWAM PNEUMATICS PRIVATE LIMITED",
"SWAMBHUNATH COLD STORAGE PVT. LTD.",
"SWAMI ASHIRWAD ENGIMECH PRIVATE LIMITED",
"SWAMI ATMANANDA",
"SWAMI AUTO BIKES PRIVATE LIMITED",
"SWAMI AUTO CARE PRIVATE LIMITED",
"SWAMI BRAHMANAND¬†MAHAVIDYALAYAM",
"SWAMI CONTRACTORS PVT LTD",
"SWAMI DAYANAND AND HOSPITAL",
"SWAMI FEEDS PRIVATE LIMITED",
"SWAMI FILMS ENTERTAINMENT PRIVATE LIMITED",
"SWAMI FUELS PRIVATE LIMITED",
"SWAMI HEALTHCARE PRIVATE LIMITED",
"SWAMI INFRACON PRIVATE LIMITED",
"SWAMI INFRAVENTURES PRIVATE LIMITED",
"SWAMI INOVATIVE AUTO PRIVATE LIMITED",
"SWAMI INTERNATIONAL BACK OFFICE SERVICES PRIVATE LIMITED",
"SWAMI KESHVANAND INSTITUTE OF TECHNOLOGY",
"SWAMI KRISHNAJIVANDASJI INSTITUTE OF TECHNOLOGY",
"SWAMI KRISHNANAND INTER COLLEGE",
"SWAMI PREMANAND CHARITABLE HOSPITAL",
"SWAMI RAMA HIMALAYAN UNIVERSITY",
"SWAMI RAMA HIMALYANA UNIVERSITY",
"SWAMI SAMARTH ELECTRONICS PRIVATE LIMITED",
"SWAMI SAMARTH KRUPA INFRASTRUCTURE PRIVATE LIMITED",
"SWAMI SAMARTH POLYFILM INDUSTRIES PRIVATE LIMITED",
"SWAMI SHANTI PRAKASH ENGLISH HIGH SCHOOL",
"SWAMI SHRI SWAROOPANAND SARASWATI MAHAVIDYALAYA",
"SWAMI SYNTEX PRIVATE LIMITED",
"SWAMI TEXTILES PRIVATE LIMITED",
"SWAMI THREADS PRIVATE LIMITED",
"SWAMI TRADE LINK PRIVATE LIMITED",
"SWAMI VESSELS PRIVATE LIMITED",
"SWAMI VIVAKANAND VIDYALAYA MATEPHAL",
"SWAMI VIVEKANAND CREDIT CO OP SOCIETY LTD",
"SWAMI VIVEKANAND EDUCATION FOUNDATION IDEAL PUBLIC SCHOOL",
"SWAMI VIVEKANAND GUJARATI MEDIUM SCHOOL",
"SWAMI VIVEKANAND HIGH SCHOOL",
"SWAMI VIVEKANAND HOMOEOPATHIC MEDICAL COLLEGE",
"SWAMI VIVEKANAND INTEGRATION ENGLISH SCHOOL",
"SWAMI VIVEKANAND INTERNATIONAL SCHOOL",
"SWAMI VIVEKANAND NATIONAL INST",
"SWAMI VIVEKANAND NETRA MANDIR",
"SWAMI VIVEKANAND NIGHT COLLEGE",
"SWAMI VIVEKANAND PLAYGROUP AND NURSERY",
"SWAMI VIVEKANAND PUBLIC SCHOOL",
"SWAMI VIVEKANAND SENIOR COLLEGE",
"SWAMI VIVEKANAND SHIKSHAK SAHKARI PATSANSTHA LTD KADA",
"SWAMI VIVEKANAND SHIKSHAN SANSTHA",
"SWAMI VIVEKANAND SUBHARTI UNIVERSITY",
"SWAMI VIVEKANAND UP PRI SCHOOL PANGRI GO",
"SWAMI VIVEKANAND VIDYALAY CHAPOLI",
"SWAMI VIVEKANANDA INSTITUTE OF MODERN SCIENCE",
"SWAMI VIVEKANANDA INSTITUTE OF PHARMACEUTICAL SCIENCES",
"SWAMI VIVEKANANDA INSTITUTE OF SCIENCE & TECHNOLOGY",
"SWAMI VIVEKANANDA MATRICULATION HIGHER SECONDARY SCHOOL",
"SWAMI VIVEKANANDA UNIVERSITY",
"SWAMI VIVEKANANDA VIDYA MANDIR",
"SWAMIGLOBAL ADROITNESS MANAGEMENT PRIVATE LIMITED",
"SWAMIJI BUILDERS PRIVATE LIMITED",
"SWAMIKRUPA ENGINEERING NASHIK",
"SWAMINA INTERNATIONAL PRIVATE LIMITED",
"SWAMINARAYAN DHAM GURUKUL",
"SWAMINARAYAN DIAMONDS PRIVATE LIMITED",
"SWAMINARAYAN GURUKUL VIDYALAYA",
"SWAMINARAYAN VIDHYALAYA",
"SWAMINARAYAN VIJAY CARRY TRADE PVT LTD",
"SWAMINATHAN CLINIC PRIVATE LIMITED",
"SWAMINATHAN ENTERPRISES PRIVATE LIMITED",
"SWAMINI INFRA PRIVATE LIMITED",
"SWAMINI INVESTIGATION AND SECURITY SERVICES PRIVATE LIMITED",
"SWAMIRAJ INOUT SOLUTIONS PRIVATE LIMITED",
"SWAMIS CONDIMENTS PRIVATE LIMITED",
"SWAMIYARMADAM RATHNA MEMORIAL HOSPITAL PRIVATE LIMITED",
"SWAMPFOX INDIA PRIVATE LIMITED",
"SWAMY CONCRETE PRODUCTS PRIVATE. LIMITED.",
"SWAMY COTTON MILL TIRUPUR PRIVATE LIMITED",
"SWAMY PUBLISHERS EDUCATIONAL AND CHARITABLE TRUST",
"SWAMY PUBLISHERS PRIVATE LIMITED",
"SWAMY SONS (AGENCIES) PRIVATE LIMITED",
"SWAMY VIVEKANANDA DEGREE & P G COLLEGE",
"SWAN ADVERTISING PRIVATE LIMITED",
"SWAN AGRI PRODUCTS PRIVATE LIMITED",
"SWAN ANGEL INVESTORS PRIVATE LIMITED",
"SWAN BIOTEC PRIVATE LIMITED",
"SWAN COMMODITIES & EXPORTS PRIVATE LIMITED",
"SWAN CREW PRIVATE LIMITED",
"SWAN ELECTRIC CONTRACTS COMPANY PRIVATE LIMITED",
"SWAN ELECTRIC ENGINEERING COMPANY PRIVATE LIMITED",
"SWAN ENERGY LIMITED",
"SWAN ENTERPRISES PRIVATE LIMITED",
"SWAN ENVIRONMENTAL PRIVATE LIMITED",
"SWAN ENVIRONMENTAL SOUTH PRIVATE LIMITED",
"SWAN FINANCE LIMITED",
"SWAN GENX PROJECTS PRIVATE LIMITED",
"SWAN INDUSTRIES PRIVATE LIMITED",
"SWAN INOX PRIVATE LIMITED",
"SWAN LNG PRIVATE LIMITED",
"SWAN MACHINE TOOLS PRIVATE LIMITED",
"SWAN MOTORS PRIVATE LIMITED",
"SWAN MULTI TECH PRODUCTS PRIVATE LIMITED",
"SWAN SHIPPING COMPANY PRIVATE LIMITED",
"SWAN SILK PRIVATE LIMITED",
"SWAN SOLUTIONS AND SERVICES PRIVATE LIMITED",
"SWAN SORTER SYSTEMS PRIVATE LIMITED",
"SWAN SUITES & SERVICES PRIVATE LIMITED",
"SWAN SWEETS PVT LTD",
"SWAN TECHNICAL SERVICES PRIVATE LIMITED",
"SWAN TURBINE SERVICES PRIVATE LIMITED",
"SWANAG INFRASTRUCTURES",
"SWANAND FOODS PRIVATE LIMITED",
"SWANAND SALES AND SERVICES PRIVATE LIMITED",
"SWANAND TRADERS PVT LTD",
"SWANANDA TEA PRIVATE LIMITED",
"SWANBAY TECHNOLOGIES INDIA PRIVATE LIMITED",
"SWANDEALS MARKETING PRIVATE LIMITED",
"SWANHOUSING & INFRA PRIVATE LIMITED",
"SWANI FUNITURE POINT PRIVATE LIMITED",
"SWANI INTERIORS PRIVATE LIMITED",
"SWANI MOTORS PRIVATE LIMITED",
"SWANI SPICE MILLS PVT LTD",
"SWANIP INFRACON PRIVATE LIMITED",
"SWANK TEK PRIVATE LIMITED",
"SWANKY INFRASTATE ENERGY PRIVATE LIMITED",
"SWANPACK PACKAGING MACHINES PRIVATE LIMITED",
"SWANSON PLASTICS INDIA PRIVATE LIMITED",
"SWANYA IMAGING CENTRE PRIVATE LIMITED",
"SWAPANLI TRADE & COMMERCE PVT.LTD.",
"SWAPANRANJAN INFRASTRUCTURE PRIVATE LIMITED",
"SWAPECO SOLUTIONS PRIVATE LIMITED",
"SWAPN HEALTHCARE HOSPITALS PRIVATE LIMITED",
"SWAPNA PRINTING WORKS PRIVATE LIMITED",
"SWAPNA PROJECTS PRIVATE LIMITED",
"SWAPNA SRUSHTI HORIZON PRIVATE LIMITED",
"SWAPNA SRUSHTI INTERNATIONAL CLUB PRIVATE LIMITED",
"SWAPNA UDYOG PRIVATE LIMITED",
"SWAPNALOK MEDIA & TECHNOLOGY PRIVATE LIMITED",
"SWAPNAPARI FASHIONMART PRIVATE LIMITED",
"SWAPNAPURTEE REALTY PRIVATE LIMITED",
"SWAPNAPURTI FOOD PRODUCTS PRIVATE LIMITED",
"SWAPNAPURTI MAHILA URBAN CO OP CREDIT SOC LTD",
"SWAPNAPURTI MOTORS PRIVATE LIMITED",
"SWAPNATARI FINSERVE LIMITED",
"SWAPNAVEDH MULTISTATE CO-OPERATIVE CREDIT SOCIETY LTD",
"SWAPNESWAR PROJECTS PRIVATE LIMITED",
"SWAPNEX LOGISTICS PRIVATE LIMITED",
"SWAPNIL AGRO PRIVATE LIMITED",
"SWAPNIL AUTO ENGINEERING PRIVATE LIMITED",
"SWAPNIL COMPUTERS PRIVATE LIMITED",
"SWAPNIL ELECTRICALS PRIVATE LIMITED",
"SWAPNIL EXIM PRIVATE LIMITED",
"SWAPNIL GHANSHYAM BAGWE HUF PRIME INDUSTRIAL SERVICES",
"SWAPNIL ORGANICS PRIVATE LIMITED",
"SWAPNIL SWITCHES PRIVATE LIMITED",
"SWAPNO TRADING PRIVATE LIMITED",
"SWAPRA ENGINEERING PRIVATE LIMITED",
"SWAR LAND DEVELOPERS LIMITED",
"SWAR MAYA INFOTECH PRIVATE LIMITED",
"SWARA BABY PRODUCTS PRIVATE LIMITED",
"SWARA INTERNATIONAL PRIVATE LIMITED",
"SWARA TECH",
"SWARAAJ SHIPPING AND LOGISTICS PRIVATE LIMITED",
"SWARAASHI HEALTHCARE PRIVATE LIMITED",
"SWARADHYA HEALTHCARE PRIVATE LIMITED",
"SWARAJ ASSOCIATES",
"SWARAJ BEVERAGES PRIVATE LIMITED",
"SWARAJ COLD STORAGE PRIVATE LIMITED",
"SWARAJ COMMERCIAL PRIVATE LIMITED",
"SWARAJ ENGINEERS (MADRAS) PRIVATE LIMITED",
"SWARAJ ENGINES LIMITED",
"SWARAJ EXCELLENT MANPOWER FACILITIES PRIVATE LIMITED",
"SWARAJ EXTRUSION PRIVATE LIMITED",
"SWARAJ FACILITY MANAGEMENT PRIVATE LIMITED",
"SWARAJ INDIA AGRO LIMITED.",
"SWARAJ INDIA INDUSTRIES LIMITED",
"SWARAJ INDIA PUBLIC SCHOOL",
"SWARAJ INDUSTRIAL AND DOMESTIC APPLIANCES PVT LTD",
"SWARAJ LIFESCIENCES PRIVATE LIMITED",
"SWARAJ MEN MANAGEMENT PRIVATE LIMITED",
"SWARAJ NARROW FABRICS P LTD",
"SWARAJ PLANT NUTRITION PRIVATE LIMITED",
"SWARAJ POLYPLAST PRIVATE LIMITED",
"SWARAJ PROCESSORS PRIVATE LIMITED",
"SWARAJ PULP AND PAPERS PRIVATE LIMITED",
"SWARAJ SECUTECH PRIVATE LIMITED",
"SWARAJ SEEDS COMPANY PRIVATE LIMITED",
"SWARAJ STEEL WIRE ROPES INDIA PRIVATE LIMITED",
"SWARAJ SUITING LIMITED",
"SWARAJ SULZ PRIVATE LIMITED",
"SWARAJ SYNTEX PRIVATE. LIMITED.",
"SWARAJ SYNTHETICS PRIVATE LIMITED",
"SWARAJ TECHNO ENGINEERS PRIVATE LIMITED",
"SWARAJ TECHNOCRAFTS PRIVATE LIMITED",
"SWARAJ TRAANSLINK PRIVATE LIMITED",
"SWARAJAYA CLEARING & CARRIER PRIVATE LIMITED",
"SWARAM HOSPITALS",
"SWARAN AQUATECH PRIVATE LIMITED",
"SWARAN FINANCIAL PRIVATE LIMITED",
"SWARAN JEWELL ARTS PRIVATE LIMITED",
"SWARAN PROJECTECH PRIVATE LIMITED",
"SWARAN SOFT SUPPORT SOLUTIONS PRIVATE LIMITED",
"SWARAN TEXTILES PRIVATE LIMITED",
"SWARANBHUMI TRADELINK PRIVATE LIMITED",
"SWARANGANGA INVESTMENT AND CONSULTANCY SERVICES PRIVATE LIMITED",
"SWARANIMAKASH LIFE SCIENCES PRIVATE LIMITED",
"SWARANJALI PUBLIC SCHOOL",
"SWARANLAXMI TEXTILE PRIVATE LIMITED",
"SWARASIDH TOURS AND TRAVELS PRIVATE LIMITED",
"SWARG ADVISORS & TRADERS PRIVATE LIMITED",
"SWARG GOLDTOUCH LIMITED",
"SWARGA SEEMA SANDALWOOD FARMS PRIVATE LIMITED",
"SWARGAAM FAB PRIVATE LIMITED",
"SWARGAPTI TRADE PRIVATE LIMITED",
"SWARGIYA DADASAHEB KALMEGH SMRUTI PRATISHTHAN",
"SWARGIYA SANGDA PATIL AASHRAMSHALA KAWADGONDI",
"SWARIT AUTOPARTS INDIA PRIVATE LIMITED",
"SWARMA SHIPPING PRIVATE LIMITED",
"SWARN BHAVYA MANGAL JEWELS PRIVATE LIMITED",
"SWARN COSMETICS INDIA PRIVATE LIMITED",
"SWARN HANS TECHNOMECH PRIVATE LIMITED",
"SWARN JYANTI CONSTRUCTIONS PRIVATE LIMITED",
"SWARN LAKE JEWELLERS PRIVATE LIMITED",
"SWARN MAHAL JEWELLERS PRIVATE LIMITED",
"SWARN REKHA BUILDCON PRIVATE LIMITED",
"SWARN SARITA JEWELLERS PRIVATE LIMITED",
"SWARN SHILP CHAINS PRIVATE LIMITED",
"SWARNA AND SHWETHA STOCKS PRIVATE LIMITED",
"SWARNA DAIRY PRIVATE LIMITED",
"SWARNA FERTILIZER AND CHEMICALS PRIVATE LIMITED",
"SWARNA GANGA JEWELLERS PRIVATE LIMITED",
"SWARNA INDUSTRIES LIMITED",
"SWARNA JYOTHI PUBLIC SCHOOL",
"SWARNA JYOTHI VIDYA KENDRA",
"SWARNA KAMAL JEWELS (INDIA) PRIVATE LIMITED",
"SWARNA KAMALAM MULTI SPECIALITY HOSPITALS PRIVATE LIMITED",
"SWARNA LAKSHMI DISTRIBUTORS PRIVATE LIMITED",
"SWARNA PRINTO PACK PRIVATE LIMITED",
"SWARNA SECURITIES LIMITED",
"SWARNA SHILPI JEWELLERS (CHENNAI) PRIVATE LIMITED",
"SWARNA SIDDHI ORNAMENTS PRIVATE LIMITED",
"SWARNA TECHNOLOGY PRIVATE LIMITED",
"SWARNA TOLLWAY PRIVATE LIMITED",
"SWARNAA TECHNO CONSTRUCTIONS PRIVATE LIMITED",
"SWARNAABHARAN JEWELLERIES PRIVATE LIMITED",
"SWARNABBHOOMI ACADEMIC INSTITUTIONS",
"SWARNABHOOMI ACADEMIC INSTITUTIONS",
"SWARNABHUMI RESORTS PRIVATE LIMITED",
"SWARNAGIRI INSULATING COMPANY PRIVATE LIMITED",
"SWARNAGIRI WIRE INSULATIONS PRIVATE LIMITED",
"SWARNAKALINGA AGRO TECH PRIVATE LIMITED",
"SWARNAKSHAR PRAKASANI PVT LTD",
"SWARNALATHA SPINTEX PRIVATE LIMITED",
"SWARNALAXMI MERCANTILE PRIVATE LIMITED",
"SWARNAM HEALTH AND LIFESTYLE LLP",
"SWARNAM POWER INFRASTRUCTURE PRIVATE LIMITED",
"SWARNAMANGAL JEWELS PRIVATE LIMITED",
"SWARNAMANI RESIDENTS WELFARE ASSOCIATION",
"SWARNAMAYEE HEALTHCARE PRIVATE LIMITED",
"SWARNAPRABHA JEWELLERS PRIVATE LIMITED",
"SWARNASWAPNA MEGAMART PRIVATE LIMITED",
"SWARNBHADRA RETAIL PRIVATE LIMITED",
"SWARNDEEP CASTINGS PRIVATE LIMITED",
"SWARNGANGA JEWEL ARTS PRIVATE LIMITED",
"SWARNIM AABHA HOME APPLINCES PRIVATE LIMITED",
"SWARNIM COMMOSALE PRIVATE LIMITED",
"SWARNIM EYE CARE PRIVATE LIMITED",
"SWARNIM FANCY WEAR PRIVATE LIMITED",
"SWARNIM FARMS INDIA PRIVATE LIMITED",
"SWARNIM FOODS PRIVATE LIMITED",
"SWARNIM METALS PRIVATE LIMITED",
"SWARNIM STARTUP & INNOVATION UNIVERSITY",
"SWARNIMTOUCH SOLUTIONS PRIVATE LIMITED",
"SWARNODHAYAM CREDITS PRIVATE LIMITED",
"SWARNSARITA GEMS LIMITED",
"SWARNSATHI SUPPLIERS PRIVATE LIMITED",
"SWARNSRI GOLD & DIAMONDS PRIVATE LIMITED",
"SWAROOP AGRO PRODUCTS PRIVATE LIMITED",
"SWAROOP ALLOY PRIVATE LIMITED",
"SWAROOP AUTOTECHNOLOGIES PRIVATE LIMITED",
"SWAROOP CONSTRUCTIONS PRIVATE LIMITED",
"SWAROOP INTERIORS PRIVATE LIMITED",
"SWAROOP NARAIN SHIV NARAIN",
"SWAROOP PHARMACEUTICALS PRIVATE LIMITED",
"SWAROOP SHETKARI PRODUCER COMPANY LIMITED",
"SWAROOP STEEL TUBE INDIA PRIVATE LIMITED",
"SWAROOP TECHNO COMPONENTS PRIVATE LIMITED",
"SWAROOPA INFRA PROJECTS PRIVATE LIMITED",
"SWAROVSKI INDIA PRIVATE LIMITED",
"SWARRIISH IMPORT AND EXPORT PRIVATE LIMITED",
"SWARUP CASTINGS PRIVATE LIMITED",
"SWARUP LUNKAD'S DHANLAXMI JEWELLERS PRIVATE LIMITED",
"SWARUP MOTORS PRIVATE LIMITED",
"SWARUP POLYMERS PRIVATE LIMITED",
"SWARUP ROLLING MILLS LIMITED",
"SWARUP ROLLING MILLS PRIVATE LIMITED",
"SWARUUP LIFESTYLE PRIVATE LIMITED",
"SWARVISHWA FARM FRESH PRIVATE LIMITED",
"SWAS & IT PRIVATE LIMITED",
"SWAS HEALTHCARE PRIVATE LIMITED",
"SWAS PET PRIVATE LIMITED",
"SWASA HOSPITALS (INDIA) PRIVATE LIMITED",
"SWASAN CHEMICALS PVT LTD",
"SWASH NONIONICS PRIVATE LIMITED",
"SWASH PAPERTECH PRIVATE LIMITED",
"SWASHBUCKLER HOSPITALITY PRIVATE LIMITED",
"SWASHTHIK CAPS PRIVATE LIMITED",
"SWASHTHIK PLASCON LIMITED",
"SWASHTHIK PREFORMS PRIVATE LIMITED",
"SWASRAYA AGRICULTURAL DEVELOPMENT PRODUCTION ENTERPRISES PRIVATE LIMITED",
"SWASTH AAHAR PRIVATE LIMITED",
"SWASTH INDIA SERVICES PRIVATE LIMITED",
"SWASTHIK MULTITECH PRIVATE LIMITED",
"SWASTHUM WELLNESS PRIVATE LIMITED",
"SWASTHYA KALYAN BLOOD BANK & THALASSAEMIA RESEARCH CENTRE",
"SWASTHYA LIFESCIENCE PRIVATE LIMITED",
"SWASTHYA VARDHAK HEALTHCARE PRIVATE LIMITED",
"SWASTHYA VARDHAK PHARMACY PRIVATE LIMITED",
"SWASTI CHEM PRIVATE LIMITED",
"SWASTI ENVIRO SOLUTIONS PRIVATE LIMITED",
"SWASTI HOTELS PRIVATE LIMITED",
"SWASTI MINERALS PRIVATE LIMITED",
"SWASTI SUPPORT SERVICES INDIA PRIVATE LIMITED",
"SWASTI VANIJYA PRIVATE LIMITED",
"SWASTI VINAYAKA ART AND HERITAGE CORPORATION LIMITED",
"SWASTI VINAYAKA INVESTECH PRIVATE LIMITED",
"SWASTI VINAYAKA REALESTATE DEVELOPMENT PRIVATE LIMITED",
"SWASTI VINAYAKA SYNTHETICS LIMITED",
"SWASTIC CORPORATION LIMITED",
"SWASTIC REAL HOME PRIVATE LIMITED",
"SWASTICK INVESTMENT MANAGEMENT PRIVATE LIMITED",
"SWASTICK TUBES PRIVATE LIMITED",
"SWASTICO PIPE & TUBE PRIVATE LIMITED",
"SWASTID ENGINEERING PRIVATE LIMITED",
"SWASTIK AAHAR MILLS PRIVATE LIMITED",
"SWASTIK AGRO IMPEX (INDIA) PRIVATE LIMITED",
"SWASTIK ALUGLAZE PRIVATE LIMITED",
"SWASTIK ARCADE PRIVATE LIMITED",
"SWASTIK ARMAAN STEELS PRIVATE LIMITED",
"SWASTIK ASPHALT PRIVATE LIMITED",
"SWASTIK ASSETS PRIVATE LIMITED",
"SWASTIK AUDIOLINES PRIVATE LIMITED",
"SWASTIK AUTO AGENCIES PRIVATE LIMITED",
"SWASTIK AUTOMECH PRIVATE LIMITED",
"SWASTIK BATH COLLECTION PRIVATE LIMITED",
"SWASTIK BIZ PRIVATE LIMITED",
"SWASTIK BUILDMAT (INDIA) PRIVATE LIMITED",
"SWASTIK CASTINGS PVT LTD",
"SWASTIK CEMENT PRODUCTS PRIVATE LIMITED",
"SWASTIK CERAMIC",
"SWASTIK CHEMPLAST PRIVATE LIMITED",
"SWASTIK CLINIC & SEVA SADAN PRIVATE LIMITED",
"SWASTIK COAL & LOGISTICS PRIVATE LIMITED",
"SWASTIK CONVEYOR SYSTEMS PVT LTD",
"SWASTIK COPPER PRIVATE LIMITED",
"SWASTIK COTFAB PRIVATE LIMITED",
"SWASTIK CUTMAC AND LUBES PRIVATE LIMITED",
"SWASTIK DAIRIES PRIVATE LIMITED",
"SWASTIK DEHYDRATES PRIVATE LIMITED",
"SWASTIK DENIM PRIVATE LIMITED",
"SWASTIK ECOPLAST PRIVATE LIMITED",
"SWASTIK ELECTROPOWER PRIVATE LIMITED",
"SWASTIK ELECTROTECH PRIVATE LIMITED",
"SWASTIK EMBROIDERIES PRIVATE LIMITED",
"SWASTIK ENERCON PROJECTS LIMITED",
"SWASTIK ENGINEERS AND CONSTRUCTIONS PRIVATE LIMITED",
"SWASTIK ENGITECH PRIVATE LIMITED",
"SWASTIK ENTERPRISE",
"SWASTIK ENTRADE PVT LTD",
"SWASTIK EXIM PRIVATE LIMITED",
"SWASTIK EXPRESSWAYS PRIVATE LIMITED",
"SWASTIK FERROTEC PRIVATE LIMITED",
"SWASTIK FILAMENTS PRIVATE LIMITED",
"SWASTIK FLEXIPACK PRIVATE LIMITED",
"SWASTIK FOODMART PRIVATE LIMITED",
"SWASTIK FORMULATIONS PRIVATE LIMITED",
"SWASTIK FREIGHT MOVERS PRIVATE LIMITED",
"SWASTIK FURNACES PRIVATE LIMITED",
"SWASTIK GENPOWER PRIVATE LIMITED",
"SWASTIK GLASS PRIVATE LIMITED",
"SWASTIK GRAINS PRODUCTS PRIVATE LIMITED",
"SWASTIK GRAPHICS PRIVATE LIMITED",
"SWASTIK HABITATES ( INDIA) PRIVATE LIMITED",
"SWASTIK HEALTHCARE SERVICES PRIVATE LIMITED",
"SWASTIK HEAVY STRUCTURALS PRIVATE LIMITED",
"SWASTIK HOSPITAL",
"SWASTIK HOTELS AND INNS PRIVATE LIMITED",
"SWASTIK IMAGING CENTRE PRIVATE LIMITED",
"SWASTIK INDUSTRIAL GASES P LTD",
"SWASTIK INDUSTRIAL POWER LINES PRIVATE LIMITED",
"SWASTIK INDUSTRIES INTERNATIONAL PRIVATE LIMITED",
"SWASTIK INFRA EQUIPMENTS PRIVATE LIMITED",
"SWASTIK INFRALOGICS PRIVATE LIMITED",
"SWASTIK INTERCHEM PRIVATE LIMITED",
"SWASTIK JEWELS PRIVATE LIMITED",
"SWASTIK KATTHA PRIVATE LIMITED",
"SWASTIK KRUSHI POLY PIPES PRIVATE LIMITED",
"SWASTIK LAMINATORS PRIVATE LTD",
"SWASTIK LIFT AND SHIFT PVT LTD",
"SWASTIK LUBRICANTS PRIVATE LIMITED",
"SWASTIK LUMBERS PRIVATE LIMITED",
"SWASTIK MACHINE TOOLS PRIVATE LIMITED",
"SWASTIK MANURES AND EXPORTS PRIVATE LIMITED",
"SWASTIK MARBLE PRIVATE LIMITED",
"SWASTIK MARBOGRANIT PRIVATE LIMITED",
"SWASTIK MARKETING",
"SWASTIK METAFORGE PRIVATE LIMITED",
"SWASTIK METAL DISTRIBUTORS PRIVATE LIMITED",
"SWASTIK METAL WORKS PRIVATE LIMITED",
"SWASTIK METALS PRIVATE LIMITED",
"SWASTIK MOTORS",
"SWASTIK MOTORS INDIA PRIVATE LIMITED",
"SWASTIK MULTIFIBRE PRIVATE LIMITED",
"SWASTIK MULTISPECIALITY HOSPITAL",
"SWASTIK OFFSHORE SERVICES PRIVATE LIMITED",
"SWASTIK OIL CHEM PRIVATE LIMITED",
"SWASTIK OIL PRODUCTS MANUFACTURING NAVSARI PRIVATE LIMITED",
"SWASTIK PACKAGING & ALLIED INDUSTRIES PVT LTD",
"SWASTIK PACKAGING PRIVATE LIMITED",
"SWASTIK PESTICIDES LIMITED",
"SWASTIK PIGMENTS PRIVATE LIMITED",
"SWASTIK PIPES AND TUBES PRIVATE LIMITED",
"SWASTIK PIPES LIMITED",
"SWASTIK PLASCHEM PRIVATE LIMITED",
"SWASTIK PLASTICIZER AND PVC PIPES INDORE PRIVATE LIMITED",
"SWASTIK PLASTICS",
"SWASTIK PLASTOALLOYS PRIVATE LIMITED",
"SWASTIK PLYBOARD LIMITED",
"SWASTIK POLYCOATS LIMITED",
"SWASTIK POLYMERS PVT LTD",
"SWASTIK POLYPRINTS PRIVATE LIMITED",
"SWASTIK POLYTEX PRIVATE LIMITED",
"SWASTIK POLYVINYLS PRIVATE LIMITED",
"SWASTIK POWER ELECTRONICS (INDIA) PRIVATE LIMITED",
"SWASTIK PREFAB PRIVATE LIMITED",
"SWASTIK PRINT-TECH PRIVATE LIMITED",
"SWASTIK PRODUCTIONS PRIVATE LIMITED",
"SWASTIK PULP AND PAPERS PRIVATE LIMITED",
"SWASTIK RECRUITMENT PRIVATE LIMITED",
"SWASTIK RICELAND PRIVATE LIMITED",
"SWASTIK ROADLINES PRIVATE LIMITED",
"SWASTIK RUBBER INDUSTRIES PRIVATE LIMITED",
"SWASTIK SAFETY GLASS BANGALORE PRIVATE LIMITED",
"SWASTIK SCIENTIFIC INSTRUMENTS PRIVATE LIMITED",
"SWASTIK SECURETECH PRIVATE LIMITED",
"SWASTIK SHOE CO PRIVATE LIMITED",
"SWASTIK SOLVENT PRODUCTS(INDIA) LIMITED",
"SWASTIK SPACES LIMITED",
"SWASTIK SPINTEX LIMITED",
"SWASTIK STEELS PRIVATE LIMITED",
"SWASTIK STEVEDORES PRIVATE LIMITED",
"SWASTIK STOCKISTS & TRADERS PRIVATE LIMITED",
"SWASTIK SYNERGY ENGINEERING PRIVATE LIMITED",
"SWASTIK TECHNOCAST LIMITED",
"SWASTIK TECHNOLOGIES BANGALORE PRIVATE LIMITED",
"SWASTIK TECHNOPACK PRIVATE LIMITED",
"SWASTIK TELEVENTURES PRIVATE LIMITED",
"SWASTIK TEXPRINT PRIVATE LIMITED",
"SWASTIK TEXTILE",
"SWASTIK TEXTILE ENGINEERS PRIVATE LIMITED",
"SWASTIK TIE UP PRIVATE LIMITED",
"SWASTIK TILES AND SANITARY",
"SWASTIK TIMBER PRIVATE LIMITED",
"SWASTIK TINS PRIVATE LIMITED",
"SWASTIK TOTAL SERVICES PRIVATE LIMITED",
"SWASTIK TRADERS",
"SWASTIK TRADEVISION PRIVATE LIMITED",
"SWASTIK TRANSMEDIA SERVICES PRIVATE LIMITED",
"SWASTIK VALUE ADDITION PRIVATE LIMITED",
"SWASTIK VENTURES PRIVATE LIMITED",
"SWASTIK WHEELERS PRIVATE LIMITED",
"SWASTIK WINDING WIRES PRIVATE LIMITED",
"SWASTIK WIRE INDUSTRIES PRIVATE LIMITED",
"SWASTIKA AGROCOM PRIVATE LIMITED",
"SWASTIKA CASTAL LIMITED",
"SWASTIKA COMPONENTS PVT. LTD.",
"SWASTIKA FIN-MART PRIVATE LIMITED",
"SWASTIKA INFRA PRIVATE LIMITED",
"SWASTIKA INVESTMART LIMITED",
"SWASTIKA MECHANICAL WORKS PRIVATE LIMITED",
"SWASTIKA ORES AND MINERALS PRIVATE LIMITED",
"SWASTIKA POLYMERS PRIVATE LIMITED",
"SWASTIKA STEEL AND ALLIED PRODUCTS PRIVATE LIMITED",
"SWASTIKA STRUCTURAL PRODUCTS PVT LTD",
"SWASTIKA SUITINGS LIMITED",
"SWASTIKA THREADS PRIVATE LIMITED",
"SWASTIKA WEARS PRIVATE LIMITED",
"SWASTIKA WELLNESS PRIVATE LIMITED",
"SWASTIKA WOOLLEN INDUSTRIES PRIVATE LIMITED",
"SWASTIKAKP ENGINEERS PRIVATE LIMITED",
"SWASTIKS MASALAS PICKLES AND FOOD PRODUCTS PRIVATE LIMITED",
"SWASTIKTECHNO SERVICES PRIVATE LIMITED",
"SWASTINOX STAINLESS B'LORE PRIVATE LIMITED",
"SWASTUSH CONSULTING PRIVATE LIMITED",
"SWASYA SOLUTIONS PRIVATE LIMITED",
"SWAT CERAMIC PRIVATE LIMITED",
"SWATANTRA AUTO INDUSTRIES PRIVATE LIMITED",
"SWATANTRA BHARAT PAPER MILLS PRIVATE LIMITED",
"SWATANTRA ESTATES PRIVATE LIMITED",
"SWATANTRA HOSPITALS (MULTI SPECIALITIES) PVT LTD",
"SWATANTRA INTER COLLEGE KASERU",
"SWATANTRA LAND AND FINANCE PVT LTD",
"SWATANTRA POWER PRIVATE LIMITED",
"SWATANTRYA SAINIK SURYABHANJI PAWAR COLLEGE PURNA",
"SWATCH GROUP INDIA PRIVATE LIMITED",
"SWATHE GARMENTS PRIVATE LIMITED",
"SWATHI BUILD-TECH PRIVATE LIMITED",
"SWATHI COTTONS PRIVATE LIMITED",
"SWATHI GINNING MILLS PRIVATE. LIMITED.",
"SWATHI HATCHERIES",
"SWATHI HOSPITALITY SERVICES PRIVATE LIMITED",
"SWATHI INNOVATIONS PRIVATE LIMITED",
"SWATHI ORGANICS & SPECIALITIES PRIVATE LIMITED",
"SWATHI RICE MILL CO PRIVATE LIMITED",
"SWATHISRI PLASTIC INDUSTRIES (INDIA) PRIVATE LIMITED",
"SWATHY POULTRY FARMS",
"SWATHY PROCESSORS LIMITED",
"SWATI AIRPORT SUPPORT SERVICES PRIVATE LIMITED",
"SWATI CAMPHOR & SPECIALITY CHEMICALS PRIVATE LIMITED",
"SWATI CHLORIDES PRIVATE LIMITED",
"SWATI CONCAST & POWER PRIVATE. LIMITED.",
"SWATI DYEING AND PRINTING MILLS PRIVATE LIMITED",
"SWATI ENERGY AND PROJECTS PRIVATE LIMITED",
"SWATI EXIM PRIVATE LIMITED",
"SWATI EXPORTS INDIA PRIVATE LIMITED",
"SWATI FIRE PROTECTION PRIVATE LIMITED",
"SWATI FRAGRANCES PRIVATE LIMITED",
"SWATI INTERIOR CONCEPTS PRIVATE LIMITED",
"SWATI INTERIORS",
"SWATI LOGISTICS PRIVATE LIMITED",
"SWATI MANAGEMENT SERVICES PRIVATE LIMITED",
"SWATI MARBLE INDUSTRIES PRIVATE LIMITED",
"SWATI MEDICARE PRIVATE LIMITED",
"SWATI MENTHOL AND ALLIED CHEMICALS LIMITED",
"SWATI OIL TECHNOLOGIES PRIVATE LIMITED",
"SWATI ORNAMENTS",
"SWATI PACKAGING PRIVATE LIMITED",
"SWATI PETRO PRODUCTS PRIVATE LIMITED",
"SWATI POLY INDUSTRIES PRIVATE LIMITED",
"SWATI POLYTEX PRIVATE LIMITED",
"SWATI PROJECTS LTD.",
"SWATI PULLEY COMPANY PRIVATE LIMITED",
"SWATI RELOCATIONS PRIVATE LIMITED",
"SWATI SAFESECURE EQUIPMENTS PRIVATE LIMITED",
"SWATI SANTOSH UBALE",
"SWATI SPENTOSE PRIVATE LIMITED",
"SWATI STRUCTURE SOLUTIONS PRIVATE LIMITED.",
"SWATI SWITCHGEARS (INDIA) PRIVATE LIMITED",
"SWATI TECHNOPRODUCTS PRIVATE LIMITED",
"SWATISANDHYA PROCON LLP",
"SWATITULSI RELIABLE FOODS PRIVATE LIMITED",
"SWAUTO MOTORS PRIVATE LIMITED",
"SWAVALAMB HR INDIA PRIVATE LIMITED",
"SWAYAAN DIGITAL SOLUTIONS PRIVATE LIMITED",
"SWAYAM BIOTECH PRIVATE LIMITED",
"SWAYAM COMICBUK PRIVATE LIMITED",
"SWAYAM INFOLOGIC PRIVATE LIMITED",
"SWAYAM INFOTAINMENT PRIVATE LIMITED",
"SWAYAM MICRO SERVICES",
"SWAYAM REALTORS AND TRAERS LLP",
"SWAYAM SADASIBA CONSTRUCTIONS PRIVATE LIMITED",
"SWAYAM SHIPPING SERVICES PRIVATE LIMITED",
"SWAYAM SWACHATTA INITIATIVE LIMITED",
"SWAYAM SWACHATTA INITIATIVE PRIVATE LIMITED",
"SWAYAMBHU ACADEMY OF MEDICAL SCIENCES",
"SWAYAMBHU CONSTRUCTION PRIVATE LIMITED",
"SWAYAMBHU IMPEX PRIVATE LIMITED",
"SWAYAMBHU LOGISTICS PRIVATE LIMITED",
"SWAYAMBHU RETAIL INDIA PRIVATE LIMITED",
"SWAYAMBHU VAHAN SEWA PRIVATE LIMITED",
"SWAYAMPRABHA UDYAM & COMPANY",
"SWAYAMSHREE LOGISTICS AND INFRAPROJECTS PRIVATE LIMITED",
"SWBI ARCHITECTS PRIVATE LIMITED",
"SWEAR HEALTHCARE PRIVATE LIMITED",
"SWEATBATH TECHNOLOGIES PRIVATE LIMITED",
"SWECHA COMMERCIAL PVT.LTD.",
"SWECO INIDA PRIVATE LIMITED",
"SWEDE AUTO PRIVATE LIMITED",
"SWEDISH CHAMBER OF COMMERCE INDIA",
"SWEEBIC FOODS PRIVATE LIMITED",
"SWEEPSMART WASTE MANAGEMENT PRIVATE LIMITED",
"SWEET & CUTE RETAIL PRIVATE LIMITED",
"SWEET CERAMIC PRIVATE LIMITED",
"SWEET CONFECTIONERY PRIVATE LIMITED",
"SWEET COUCH TECHNOLOGY PRIVATE LIMITED",
"SWEET HOSPITALITY PRIVATE LIMITED",
"SWEET HUT INFRASTRUCTURE PRIVATE LIMITED",
"SWEET MAGIC PRIVATE LIMITED",
"SWEET MAHAL SWEETS AND BAKERS PRIVATE LIMITED",
"SWEETANNIA FOOD & BEVERAGES PRIVATE LIMITED",
"SWEETONE INDUSTRIES PRIVATE LIMITED",
"SWEETPEPPER MEDIA (INDIA) PRIVATE LIMITED",
"SWEETWORLD FOODS INDIA PRIVATE LIMITED",
"SWEETY FABRICS PRIVATE LIMITED",
"SWEETY FASHION PRIVATE LIMITED",
"SWEETY INFRASTRUCTURE PRIVATE LIMITED",
"SWEETY JEWELS PRIVATE LIMITED",
"SWEETY LOGISTICS PRIVATE LIMITED",
"SWEETY TRADE & AGENCY PVT.LTD.",
"SWEETYET DEVELOPMENT DISTRIBUTION (INDIA) PRIVATE LIMITED",
"SWEFN PHARMACEUTICALS PRIVATE LIMITED",
"SWEGA LABORATORIES LIMITED",
"SWEGON BLUE BOX PRIVATE LIMITED",
"SWEIZ PHARMACEUTICAL PRIVATE LIMITED",
"SWELECT ENERGY SYSTEMS LIMITED",
"SWELECT GREEN ENERGY SOLUTIONS PRIVATE LIMITED",
"SWELECT POWER SYSTEMS PRIVATE LIMITED",
"SWELECT SUN ENERGY PRIVATE LIMITED",
"SWELL AGRO TECH PRIVATE LIMITED",
"SWELL WELL MINECHEM PRIVATE LIMITED",
"SWELLORE ENGINEERING. PRIVATE. LIMITED",
"SWELTER ENERGY PRIVATE LIMITED",
"SWEM WATER TECH (INDIA) PRIVATE LIMITED",
"SWEMED BIOMEDICALS PRIVATE LIMITED",
"SWEN AGENCIES PRIVATE LIMITED",
"SWEN CONTAINER LINE PRIVATE LIMITED",
"SWEN HVAC ENGINEERS PRIVATE LIMITED",
"SWEN STUDIO DESIGN PRIVATE LIMITED",
"SWETA DISTRIBUTORS PRIVATE LIMITED",
"SWETA ESTATES PRIVATE LIMITED",
"SWETA HOLDINGS PVT LTD",
"SWETA LIFE CARE PRIVATE LIMITED",
"SWETALEE DEVELOPERS PRIVATE LIMITED",
"SWETAPADMA CONSTRUCTIONS PRIVATE LIMITED",
"SWETAPADMA UNITED HOTELS PRIVATE LIMITED",
"SWETKETU HEALTH AND INFRA PRIVATE LIMITED",
"SWETPUR JR HIGH SCHOOL",
"SWETS INFORMATION SERVICES PRIVATE LIMITED",
"SWEWS START WISDOM PRIVATE LIMITED",
"SWG CONSUMER CARE LIMITED",
"SWG INDUSTRIES LIMITED",
"SWG SOLUTIONS INDIA PRIVATE LIMITED",
"SWIBER OFFSHORE MARINE PTE LIMITED",
"SWID PROCESS TECHNOLOGIES PRIVATE LIMITED",
"SWIDE SOLUTIONS PRIVATE LIMITED",
"SWIFT AGRO CHEMICALS AND NUTRIENTS PRIVATE LIMITED",
"SWIFT AIR SERVICES PRIVATE LIMITED",
"SWIFT AND SAFE LOGISTICS PRIVATE LIMITED",
"SWIFT AUDIO VIDEO ENTERTAINMENTS PRIVATE LIMITED",
"SWIFT CARGO PRIVATE LIMITED",
"SWIFT CHEMICALS PRIVATE LIMITED",
"SWIFT COMMODITIES PVT LTD",
"SWIFT CORPORATION LIMITED",
"SWIFT DEALERS PRIVATE LIMITED",
"SWIFT ELECTROCOMP SOLUTIONS PRIVATE LIMITED",
"SWIFT ENTERPRISE PRIVATE LIMITED",
"SWIFT FINANCIAL RESULTS LTD",
"SWIFT FINVEST PRIVATE LIMITED",
"SWIFT FREIGHT INDIA PRIVATE LIMITED",
"SWIFT INDIA DOMESTIC SERVICES PRIVATE LIMITED",
"SWIFT INDIA PRIVATE LIMITED",
"SWIFT INTERMEDIA CONVERGENCE PRIVATE LIMITED",
"SWIFT LIFE SCIENCES PRIVATE LIMITED",
"SWIFT MULTIPRINT & PACK PRIVATE LIMITED",
"SWIFT POWER SOLUTION PRIVATE LIMITED",
"SWIFT ROAD LINK PRIVATE LIMITED",
"SWIFT SECURITAS PRIVATE LIMITED",
"SWIFT SECURUTAS PRIVATE LIMITED",
"SWIFT SERVICES PRIVATE LIMITED",
"SWIFT STAFFING SOLUTIONS PRIVATE LIMITED",
"SWIFT STRIPS INDIA PRIVATE LIMITED",
"SWIFT TECHNO CRAFTS PRIVATE LIMITED",
"SWIFT TECHNOPLAST PRIVATE LIMITED",
"SWIFT TEXTILES PRIVATE LIMITED",
"SWIFT TIE-UP PRIVATE LIMITED",
"SWIFT VETCARE PRIVATE LIMITED",
"SWIFT VITTHIYA SAMAVESH PRIVATE LIMITED",
"SWIFTAIR TRANSPEED PRIVATE LIMITED",
"SWIFTANT IT SOLUTIONS INDIA PRIVATE LIMITED",
"SWIFTBIZ SOLUTIONS PRIVATE LIMITED",
"SWIFTCOM CONVERGENCE DEVICES PRIVATE LIMITED",
"SWIFTER TECHNOLOGIES PRIVATE LIMITED",
"SWIFTINDI INTERNET SERVICES PRIVATE LIMITED",
"SWIFTLINE TRANSPORT SOLUTIONS PRIVATE LIMITED",
"SWIFTLINK CONNECTIONS PRIVATE LIMITED",
"SWIFTMAIL COMMUNICATIONS LIMITED",
"SWIFTMET WIRE & RESIN PRIVATE LIMITED",
"SWIFTNESS LOGISTICS PRIVATE LIMITED",
"SWIFTNET BROADBAND PRIVATE LIMITED",
"SWIFTPIM PRODUCTS PRIVATE LIMITED",
"SWIFTS PRIVATE LIMITED",
"SWIFTSEALS PRIVATE LIMITED",
"SWIFTSENSE IT SOLUTIONS (OPC) PRIVATE LIMITED",
"SWIFTSPIRE INNOVATIONS PRIVATE LIMITED",
"SWIFTSY FREIGHT PRIVATE LIMITED",
"SWIFTWIN TECHNOLOGIES LLP",
"SWIGGY APPLIANCES PRIVATE LIMITED",
"SWIKRITI RENEWABLES PRIVATE LIMITED",
"SWIKRUTEE FINANCE PRIVATE LIMITED",
"SWILUM AUTOTECH PRIVATE LIMITED",
"SWIMS TECHNOLOGIES PRIVATE LIMITED FORMERLY KNOWN AS TRILLIUM FLOW TECHNOLOGIES INDIA PRIVATE LIMITED",
"SWIMWELL POOLS INDIA PRIVATE LIMITED",
"SWIN TECHNOLOGIES PRIVATE LIMITED",
"SWING AROMATICS PRIVATE LIMITED",
"SWING INFRASPACE PRIVATE LIMITED",
"SWINGTEL COMMUNICATIONS PRIVATE LIMITED",
"SWINNZEA PHARMACEUTICALS PRIVATE LIMITED",
"SWIPE RECORD SYSTEM PRIVATE LIMITED",
"SWIPENOW SOLUTIONS PRIVATE LIMITED",
"SWIRE DIGITAL CENTRE PRIVATE LIMITED",
"SWIRLAIR EQUIPMENTS PRIVATE LIMITED",
"SWIS N R SWAMY COLLEGE OF COMMERCE & ECONOMICS AND SMT THIRUMALAI COLLEGE OF SCIENCE WADALA",
"SWISH BOSS APPARELS PRIVATE LIMITED",
"SWISS ARMS SMART SOLUTIONS PRIVATE LIMITED",
"SWISS AUTO PRIVATE LIMITED",
"SWISS BAKE INGREDIENTS PRIVATE LIMITED",
"SWISS BAKERIE AND PATISSERIE PRIVATE LIMITED",
"SWISS BEAUTY COSMETICS PRIVATE LIMITED",
"SWISS CERT PRIVATE LIMITED",
"SWISS ELMECH PRIVATE LIMITED",
"SWISS ENGINEERING PRIVATE LIMITED",
"SWISS GALLARY PRIVATE LIMITED",
"SWISS GARNIER BIOTECH PRIVATE LIMITED",
"SWISS GARNIER GENEXIAA SCIENCES PRIVATE LIMITED",
"SWISS INTERNATIONAL & CARGO INC",
"SWISS MEDICARE PRIVATE LIMITED",
"SWISS MILITARY CONSUMER GOODS LIMITED",
"SWISS MILITARY LIFE STYLE PRODUCTS PRIVATE LIMITED",
"SWISS PAC PVT LTD",
"SWISS PARENTERALS PRIVATE LIMITED",
"SWISS PARK HOTELS PRIVATE LIMITED",
"SWISS PERFUMES PRIVATE LIMITED",
"SWISS PESTICIDES AND FERTILIZER (OPC) PRIVATE LIMITED",
"SWISS PHARMA PRIVATE LIMITED",
"SWISS RE GLOBAL BUSINESS SOLUTIONS INDIA PRIVATE LIMITED",
"SWISS RE SERVICES INDIA PRIVATE LIMITED",
"SWISS SERVICE MANAGEMENT INDIA PRIVATE LIMITED",
"SWISS SINGAPORE INDIA PRIVATE LIMITED",
"SWISS SINGAPORE OVERSEAS ENTERPRISES PTE LIMITED",
"SWISS STEEL INDIA PRIVATE LIMITED",
"SWISS VOICE INDIA PRIVATE LIMITED",
"SWISS WATCH BOUTIQUE PRIVATE LIMITED",
"SWISSAGRO FEED PRIVATE LIMITED",
"SWISSCLEAR SERVICES PRIVATE LIMITED",
"SWISSCORE HEALTHCARE SERVICES PRIVATE LIMITED",
"SWISSCUT PRIVATE LIMITED",
"SWISSER INSTRUMENTS PRIVATE LIMITED",
"SWISSOL ORGANICS PRIVATE LIMITED",
"SWISSOL SPECIALITIES PRIVATE LIMITED",
"SWITCH 2 NATURE PRIVATE LIMITED",
"SWITCH BUILD ENGINEERS (INDIA) PRIVATE LTD",
"SWITCH EVENTS AND ENTERTAINMENT PRIVATE LIMITED",
"SWITCH MY LOAN PRIVATE LIMITED",
"SWITCH N CONTROL GEARS PVT LTD",
"SWITCH SOFT TECHNOLOGIES PRIVATE LIMITED",
"SWITCHGEAR AND CONTROL TECHNICS PRIVATE LIMITED",
"SWITCHGEAR MANUFACTURING COMPANY PRIVATE LIMITED",
"SWITCHGEARS & STRUCTURALS INDIA",
"SWITCHGEARS AND STRUCTURALS INDIA PVT LTD",
"SWITCHING AVO ELECTRO POWER LIMITED",
"SWITCHING POWER CONVERSION PRIVATE LIMITED",
"SWITCHING TECHNOLOGIES GUNTHAR LIMITED",
"SWITCHLANE TECHNOLOGIES PRIVATE LIMITED",
"SWITCHME TECHNOLOGIES AND SERVICES PRIVATE LIMITED",
"SWITZ FOODS PVT LTD",
"SWITZ INTERNATIONAL PRIVATE LIMITED",
"SWITZER INSTRUMENT LIMITED",
"SWITZER INSTRUMENT PRIVATE LIMITED",
"SWITZER PROCESS INSTRUMENTS PRIVATE LIMITED",
"SWIZZER CERAMIC PRIVATE LIMITED",
"SWNAC E-KIRAYA SERVICES PRIVATE LIMITED",
"SWOJAS PULSES PRIVATE LIMITED",
"SWOP ENGINEERING PRIVATE LIMITED",
"SWORD GLOBAL INDIA PRIVATE LIMITED",
"SWORDFISH EVENTS & ENTERTAINMENT PRIVATE LIMITED",
"SWORDLILY CULTURAL AND SPORTS PRIVATE LIMITED",
"SWORDS LOGISTICS PRIVATE LIMITED",
"SWORNAJYOTI PRODUCER COMPANY LIMITED",
"SWOSTI INFRASTRUCTURES PRIVATE LIMITED",
"SWOSTI PREMIUM LIMITED",
"SWOSTI TRAVELS & EXPORTS PRIVATE LIMITED",
"SWS FINANCIAL SOLUTIONS PRIVATE LIMITED",
"SWS INDIA MANAGEMENT SUPPORT AND SERVICE PRIVATE LIMITED",
"SWYAM MOTORS PRIVATE LIMITED",
"SWYM TECHNOLOGIES PRIVATE LIMITED",
"SWYOM ADVISORS LIMITED",
"SX PRO PRIVATE LIMITED",
"SX SPORTS PRIVATE LIMITED",
"SXR BIG BOSS WHOLESALE & RETAIL PRIVATE LIMITED",
"SY ASSOCIATES PRIVATE LIMITED",
"SYAM TRELLEBORG TIRES LLP",
"SYAMA DYNAMIC IT SERVICES PRIVATE LIMITED",
"SYAMA DYNAMIC PROJECT DEVELOPERS PRIVATE LIMITED",
"SYAMA PRASAD MOOKERJEE PORT KOLKATA",
"SYAMADYNAMIC MOTORCYCLES PRIVATE LIMITED",
"SYAMADYNAMIC TRADING PRIVATE LIMITED",
"SYAMALA DRY FRUITS PRIVATE LIMITED",
"SYAMALI SECURITY & CONSULTANT PRIVATE LIMITED",
"SYBEX SUPPORT SERVICES PRIVATE LIMITED",
"SYBIL INDUSTRIES PRIVATE LIMITED",
"SYBLY THREADS LIMITED",
"SYBRANT TECH PRIVATE LIMITED",
"SYBRON LEASING AND FINANCE PRIVATE LIMITED",
"SYBYLGLOBAL IT SERVICES INDIA PRIVATE LIMITED",
"SYCAMORE PROPERTIES PRIVATE LIMITED",
"SYCAMORE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"SYCOM POWER PROTECTION PRIVATE LIMITED",
"SYCOMP TECHNOLOGIES INDIA PRIVATE LIMITED",
"SYCON CONSTRUCTIONS PRIVATE LIMITED.",
"SYCONE CPMC PRIVATE LIMITED",
"SYDATA CONSULTING INDIA PRIVATE LIMITED",
"SYDENHAM COLLEGE OF COMMERCE AND ECONOMIC",
"SYDENHAM INSTITUTE OF MANAGEMENT STUDIES",
"SYDLER ELECTRONICS PRIVATE LIMITED",
"SYDLER REMEDIES PRIVATE LIMITED",
"SYDLER TECHNOLOGIES PRIVATE LIMITED",
"SYDNEY AGENCIES PRIVATE LIMITED",
"SYED FOODS PRIVATE LIMITED",
"SYED NIZAMUDDIN BEEDI MANUFACTURERS PRIVATE LIMITED",
"SYEDA URDU COLLEGE ONLY BOYS",
"SYENA HEALTHCARE SERVICES PRIVATE LIMITED",
"SYENERGY ENVIRONICS LIMITED",
"SYGINA DATA SYSTEMS PRIVATE LIMITED",
"SYGITECH SOLUTIONS PRIVATE LIMITED",
"SYGNET INFRA PRIVATE LIMITED",
"SYGNIFIC CORPORATE SOLUTIONS PRIVATE LIMITED",
"SYGNIUS SHIP MANAGEMENT PRIVATE LIMITED",
"SYHR CONSULTING PRIVATE LIMITED",
"SYKES & RAY EQUITIES I LIMITED",
"SYKES AND RAY EQUITIES (MUMBAI) PRIVATE LIMITED",
"SYKES ENTERPRISES INDIA PRIVATE LIMITED",
"SYKHAI IMPEX INDIA PRIVATE LIMITED",
"SYL TECHNOLOGIES PRIVATE LIMITED",
"SYLEE TEA ESTATE PRIVATE LIMITED",
"SYLIS TECHNOLOGIES LLP",
"SYLON BIO PHARMA PRIVATE LIMITED",
"SYLVAC METROLOGY (INDIA) PRIVATE LIMITED",
"SYLVAN GREENS PRIVATE LIMITED",
"SYLVAN PLYBOARD (INDIA) LIMITED",
"SYLVANUS BUILDERS AND DEVELOPERS LIMITED",
"SYLVANUS PROPERTIES LIMITED",
"SYLVESA INFOTECH PRIVATE LIMITED",
"SYLVEX CABLE COMPANY PRIVATE LIMITED",
"SYLVI LIFE SCIENCES PRIVATE LIMITED",
"SYLYS ENTERPRISES PRIVATE LIMITED",
"SYM RPA PRIVATE LIMITED",
"SYM SINGHAL ALLOYS PRIVATE LIMITED",
"SYMANTEC SOFTWARE AND SERVICES INDIA PRIVATE LIMITED",
"SYMANTEC SOFTWARE SOLUTIONS PRIVATE LIMITED",
"SYMATIC ENGINEERING PRIVATE LIMITED",
"SYMBEN SOLUTIONS PRIVATE LIMITED",
"SYMBIAN SOFTWARE INDIA PRIVATE LIMITED",
"SYMBIANCE PHARMA SOLUTIONS PRIVATE LIMITED",
"SYMBIANS ENERSOL PRIVATE LIMITED",
"SYMBIO GENERRICS INDIA PRIVATE LIMITED",
"SYMBIO SCIENTIFIC PRIVATE LIMITED",
"SYMBIOME ORGANICS PRIVATE LIMITED",
"SYMBIOSIS",
"SYMBIOSIS ANIMAL HEALTH PRIVATE LIMITED",
"SYMBIOSIS ASSISTANCE PRIVATE LIMITED",
"SYMBIOSIS CENTER FOR INFORMATION TECHNOLOGY",
"SYMBIOSIS CENTRE FOR ENTREPRENEURSHIP AND INNOVATION",
"SYMBIOSIS E-SERVE PRIVATE LIMITED",
"SYMBIOSIS FEEDS INDIA PRIVATE LIMITED",
"SYMBIOSIS INFRA PRIVATE LIMITED",
"SYMBIOSIS INSTITUTE OF BUSINESS MANAGEME",
"SYMBIOSIS INSTITUTE OF DESIGN",
"SYMBIOSIS INSTITUTE OF INTERNATIONAL BUSINESS",
"SYMBIOSIS INSTITUTE OF MANAGEMENT",
"SYMBIOSIS INSTITUTE OF TECHNOLOGY",
"SYMBIOSIS INTERNATIONAL SCHOOL",
"SYMBIOSIS INTERNATIONAL UNIVERSITY",
"SYMBIOSIS LABORATORIES AND RESEARCH CENTRE",
"SYMBIOSIS LAW SCHOOL",
"SYMBIOSIS LIFE SCIENCES LIMITED",
"SYMBIOSIS MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"SYMBIOSIS NETWORK PRIVATE LIMITED",
"SYMBIOSIS OPEN EDUCATION SOCIETY",
"SYMBIOSIS PACKAGE DEAL PRIVATE LIMITED",
"SYMBIOSIS PHARMACEUTICALS PRIVATE. LIMITED.",
"SYMBIOSIS PRIMARY AND SECONDARY SCHOOL",
"SYMBIOSIS PROPERTIES AND INFRASTRUCTURES INDIA PRIVATE LIMITED",
"SYMBIOSIS SCHOOL OF ECONOMICS",
"SYMBIOSIS SKILL AND PROFESSIONAL UNIVERSITY",
"SYMBIOSIS SKILLS & PROFESSIONAL UNIVERSITY",
"SYMBIOSIS SOCIETY",
"SYMBIOSIS UNIVERSITY HOSPITAL & RESEARCH CENTRE",
"SYMBIOSYS TECHNOLOGIES",
"SYMBIOTE DIAMOND MULTITRADE PRIVATE LIMITED",
"SYMBIOTEC PHARMALAB PRIVATE LIMITED",
"SYMBIOTIC AUTOMATION SYSTEMS P LIMITED",
"SYMBIOTIC DRUGS & DIABETIC CARE PRIVATE LIMITED",
"SYMBIOTIC INFOTECH PRIVATE LIMITED",
"SYMBIOTIC SCIENCES PRIVATE LIMITED",
"SYMBIOUN TECHNOLOGIES",
"SYMBIOX INVESTMENT & TRADING CO LTD",
"SYMBO INDIA INSURANCE BROKING PRIVATE LIMITED",
"SYMBOL FOODS PRIVATE LIMITED",
"SYMBOL MERCHANTS PRIVATE LIMITED",
"SYMBOL TECHNOLOGIES INDIA PRIVATE LIMITED",
"SYMBOLIC FABTEX PRIVATE LIMITED",
"SYMBOSA GRANITO PRIVATE LIMITED",
"SYMBOSIS INSTITUTES",
"SYMBYONT ASSET MANAGEMENT PRIVATE LIMITED",
"SYMBYONT PROJECTS PRIVATE LIMITED",
"SYMCO CONSULTANTS PRIVATE LIMITED",
"SYMCOM EXIM PRIVATE LIMITED",
"SYMCOM IMPEX PRIVATE LIMITED",
"SYMEC ENGINEERS INDIA PRIVATE.LIMITED",
"SYMED LABS LIMITED",
"SYMEGA FOOD INGREDIENTS LIMITED",
"SYMFOSYS TECHNOLOGIES PRIVATE LIMITED",
"SYMFRICON TECHNOSOFT PRIVATE LIMITED",
"SYMGRO CHEMICALS PRIVATE LIMITED",
"SYMMETRIC I.T.SERVICES PRIVATE LIMITED",
"SYMMETRIC TECHNOLOGIES PRIVATE LIMITED",
"SYMMETRICAL GLOBAL SEARCH PRIVATE LIMITED",
"SYMMETRICS DEVELOPMENT SERVICES PRIVATE LIMITED",
"SYMMETRIX BIOTECH PRIVATE LIMITED",
"SYMMETRIX COMPUTER SYSTEMS PRIVATE LIMITED",
"SYMMETRIX PRINTS PRIVATE LIMITED",
"SYMO GENESIS INDIA PRIVATE LIMITED",
"SYMPATEC INDIA PRIVATE LIMITED",
"SYMPHONI HR PRIVATE LIMITED",
"SYMPHONIA & GRAPHICUS PRIVATE. LIMITED.",
"SYMPHONIA WEALTH PRIVATE LIMITED",
"SYMPHONIZE ENTERPRISE SOLUTIONS PRIVATE LIMITED",
"SYMPHONY CELEBRATORS PRIVATE LIMITED",
"SYMPHONY EYC INDIA PRIVATE LIMITED",
"SYMPHONY FINTECH SOLUTIONS PRIVATE LIMITED",
"SYMPHONY LIMITED",
"SYMPHONY MULTITRADE PRIVATE LIMITED",
"SYMPHONY PHARMA LIFESCIENCES PRIVATE LIMITED",
"SYMPHONY POLYMERS PRIVATE LIMITED",
"SYMPHONY PRINTS PRIVATE LIMITED",
"SYMPHONY SOFTWARE PRIVATE LIMITED",
"SYMPHONY SYNTEX P LTD",
"SYMPHONY TALENT INDIA PRIVATE LIMITED",
"SYMPHONY TECHNOVENTURES PRIVATE LIMITED",
"SYMPHONY VYAPAAR PRIVATE LIMITED",
"SYMPHONYINCUBATOR BUSINESS SERVICES PRIVATE LIMITED",
"SYMPRO CONSULTING PRIVATE LIMITED",
"SYMRISE PRIVATE LIMITED",
"SYMS CONSTRUCTION PRIVATE LIMITED",
"SYMSAFE SYSTEMS PRIVATE LIMITED",
"SYMTEC ENGINEERS PRIVATE LIMITED",
"SYMTRAX SOFTWARE PRIVATE LIMITED",
"SYMTRONICS AUTOMATION PRIVATE LIMITED",
"SYN - FINECHEM LABORATORIES PRIVATE LIMITED",
"SYN ADVERTISING PRIVATE LIMITED",
"SYN AUTO SOLUTIONS PRIVATE LIMITED",
"SYN INFOWAYS & VENTURES LIMITED",
"SYN PROMPT TECHNOLOGIES PRIVATE LIMITED",
"SYN WATER TECHNOLOGIES PRIVATE LIMITED",
"SYNA STEELS PRIVATE LIMITED",
"SYNAC PHARMACEUTICALS PRIVATE LIMITED",
"SYNAESTECH COMMUNICATIONS TECHNOLOGIES PRIVATE LIMITED",
"SYNAMEDIA INDIA PRIVATE LIMITED",
"SYNAPES LIFE SCIENCES PRIVATE LIMITED",
"SYNAPSE COMMUNICATION DESIGN PRIVATE LIMITED",
"SYNAPSE COMMUNICATIONS PRIVATE LIMITED",
"SYNAPSE EDUCARE PRIVATE LIMITED",
"SYNAPSE INFORMATION SERVICES PRIVATE LIMITED",
"SYNAPSE LABS PRIVATE LIMITED",
"SYNAPSE MARKETING CONSULTANCY PRIVATE LIMITED",
"SYNAPSE MEDICAL SERVICES INDIA PRIVATE LIMITED",
"SYNAPSE NEUROCARE PRIVATE LIMITED",
"SYNAPSE PUBLIC RELATIONS PRIVATE LIMITED",
"SYNAPSE SOFTECH PRIVATE LIMITED",
"SYNAPSE TECHNO DESIGN INNOVATIONS PRIVATE LIMITED",
"SYNAPSE TRADE SOLUTIONS PRIVATE LIMITED",
"SYNAPSE WORKS INDIA PRIVATE LIMITED",
"SYNAPSICA HEALTHCARE PRIVATE LIMITED",
"SYNAPSIS MOBI PRIVATE LIMITED",
"SYNAPTEIN SOLUTIONS PRIVATE LIMITED",
"SYNAPTIC INTEGRATED TELECOMMUNICATION SERVICES PRIVATE LIMITED",
"SYNAPTICS INDIA PRIVATE LIMITED",
"SYNAPTICS LABS PRIVATE LIMITED",
"SYNAPTRIS DECISIONS PRIVATE LIMITED",
"SYNAPTRIS SOFTWARE PRIVATE LIMITED",
"SYNARION IT PRIVATE LIMITED",
"SYNATY AUTOMOTIVE PRIVATE LIMITED",
"SYNBIO TECHNOVA PRIVATE LIMITED",
"SYNBIOTICS LIMITED",
"SYNC HOSPITALITY SERVICES PRIVATE LIMITED",
"SYNC HR PRIVATE LIMITED",
"SYNC SUN ENERGY PRIVATE LIMITED",
"SYNCBYTE INNOVATIONS PRIVATE LIMITED",
"SYNCFUSION SOFTWARE PRIVATE LIMITED",
"SYNCHEM LABORATORIES PRIVATE LIMITED",
"SYNCHEM PHARMACEUTICALS PRIVATE LIMITED",
"SYNCHEM POLYMERS PRIVATE LIMITED",
"SYNCHRIST NETWORK SERVICES PRIVATE LIMITED",
"SYNCHRO PACK LIMITED",
"SYNCHRON GLOBAL ONESOURCE PRIVATE LIMITED",
"SYNCHRON MACHINE TOOLS PRIVATE LIMITED",
"SYNCHRONICITY COMMUNICATIONS PRIVATE LIMITED",
"SYNCHRONISE SCIENTIFIC GLASS WORKS PVT LTD",
"SYNCHRONIZED COMMUNICATIONS PRIVATE LIMITED",
"SYNCHRONIZED SUPPLY SYSTEMS LIMITED",
"SYNCHRONOSS TECHNOLOGIES INDIA PRIVATE LIMITED",
"SYNCHRONY FINANCIAL",
"SYNCHRONY INTERNATIONAL SERVICES PRIVATE LIMITED",
"SYNCHROSERVE GLOBAL SOLUTIONS PRIVATE LIMITED",
"SYNCHROSERVE IT SOLUTIONS PRIVATE LIMITED",
"SYNCHROTRON TECHNOLOGY PRIVATE LIMITED",
"SYNCIA LIFECARE PRIVATE LIMITED",
"SYNCLATURE CONSULTANCY PRIVATE LIMITED",
"SYNCLINE FILMS PRIVATE LIMITED",
"SYNCLOVIS SYSTEMS PRIVATE LIMITED",
"SYNCMEDIA AND ADTECH PRIVATE LIMITED",
"SYNCO INDUSTRIES LIMITED",
"SYNCOM BIOTECH PRIVATE LIMITED",
"SYNCOM FORMULATION I LIMITED",
"SYNCOMINT SOLUTIONS PRIVATE LIMITED",
"SYNCOMP MATERIALS INDIA PRIVATE LIMITED",
"SYNCON ELEVATORSINDIA PRIVATE LIMITED",
"SYNCONICS TECHNOLOGIES PRIVATE LIMITED",
"SYNCOR SOLUTIONS PRIVATE LIMITED",
"SYNCORE CONSULTING PRIVATE LIMITED",
"SYNCOTTS INTERNATIONAL PRIVATE LIMITED",
"SYNCPRO SOLUTIONS PRIVATE LIMITED",
"SYNCREON CONSULTING LIMITED",
"SYNCRO ENGINEERING PRIVATE LIMITED",
"SYNCRON SOFTWARE INDIA PRIVATE LIMITED",
"SYNCWORKS SOLUTIONS PRIVATE LIMITED",
"SYNDICATE BANK",
"SYNDICATE BOTTLES PRIVATE LIMITED",
"SYNDICATE BUILDERS PRIVATE LIMITED",
"SYNDICATE CLOTH HOUSE PRIVATE LIMITED",
"SYNDICATE DIAGNOSTICS PRIVATE LIMITED",
"SYNDICATE EXPORTS PRIVATE LIMITED",
"SYNDICATE FREIGHT PRIVATE LIMITED",
"SYNDICATE INNOVATIONS INTERNATIONAL LIMITED",
"SYNDICATE JEWELLERS PRIVATE LIMITED",
"SYNDICATE LIFE SCIENCES PRIVATE LIMITED",
"SYNDICATE LOGISTICS PRIVATE LIMITED",
"SYNDICATE MACHINES PRIVATE LIMITED",
"SYNDICATE SECURITY SERVICE PRIVATE LIMITED",
"SYNDICATE SPORTS PRIVATE LIMITED",
"SYNDICATE WIPER SYSTEMS PRIVATE LIMITED",
"SYNDROME TECHNOLOGIES PRIVATE LIMITED",
"SYNECHRON DIGITAL PAYMENTS SERVICES PRIVATE LIMITED",
"SYNECHRON TECHNOLOGIES PRIVATE LIMITED",
"SYNECTIC TELECOM EXPORTS PRIVATE LIMITED",
"SYNECTIKS INDIA PRIVATE LIMITED",
"SYNECTIX ENCLOSURE SYSTEMS PRIVATE LIMITED",
"SYNEDYNE SYSTEMS PRIVATE LIMITED",
"SYNEGRA EMS LIMITED",
"SYNERGEE CAPITAL SERVICES PRIVATE LIMITED",
"SYNERGEN BIO PRIVATE LIMITED",
"SYNERGEN PHARMA INDIA PRIVATE LIMITED",
"SYNERGETIC AUTOMATION PRIVATE LIMITED",
"SYNERGETIC ENGINEERING SOLUTIONS PRIVATE LIMITED",
"SYNERGETIC RELIABLE ADVISORS PRIVATE LIMITED",
"SYNERGETICS INFORMATION TECHNOLOGY SERVICES INDIA PRIVATE LIMITED",
"SYNERGETIX GREEN POWER EXPLOITATION PRIVATE LIMITED",
"SYNERGIA CONSULTANTS PRIVATE LIMITED",
"SYNERGIA ENERGY LTD",
"SYNERGIA ENGINEERING PRIVATE LIMITED",
"SYNERGIA LIFE SCIENCES PRIVATE LIMITED",
"SYNERGIA METIER PRIVATE LIMITED",
"SYNERGIA SCIENCES PRIVATE LIMITED",
"SYNERGIC IMPRESSIONS PRIVATE LIMITED",
"SYNERGIC TRAILER & AUTO SOLUTIONS PRIVATE LIMITED",
"SYNERGIC TRANSPORTS & LOGISTICS INDIA PRIVATE LIMITED",
"SYNERGICS SOLUTIONS PRIVATE LIMITED",
"SYNERGIE CONTROLS & SYSTEMS PRIVATE LIMITED",
"SYNERGIE INSTITUTE OF TRADE COMMERCE AND INDUSTRY",
"SYNERGIES CASTINGS LIMITED",
"SYNERGIES DEVELOPMENT & SOURCING PRIVATE LIMITED",
"SYNERGISE SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED",
"SYNERGISTIC COMPUSOFT PRIVATE LIMITED",
"SYNERGISTIC FINANCIAL NETWORKS PRIVATE LIMITED",
"SYNERGISTIX INDIA PRIVATE LIMITED",
"SYNERGITA SOFTWARE PRIVATE LIMITED",
"SYNERGIZ GLOBAL SERVICES PRIVATE LIMITED",
"SYNERGIZE SOLUTIONS PRIVATE LIMITED",
"SYNERGIZERS SUSTAINABLE FOUNDATION",
"SYNERGY ACE SOLUTIONS PRIVATE LIMITED",
"SYNERGY ADVISORY PRIVATE LIMITED",
"SYNERGY AEROMATICS PRIVATE LIMITED",
"SYNERGY AGRO CHEMICALS HYDERABAD PRIVATE LIMITED",
"SYNERGY AGRO-TECH PRIVATE LIMITED",
"SYNERGY AIR PRODUCTS PRIVATE LIMITED",
"SYNERGY ALLOYS AND WEAR SOLUTIONS PRIVATE LIMITED",
"SYNERGY ART FOUNDATION LIMITED",
"SYNERGY AUTOKRAFT PRIVATE LIMITED",
"SYNERGY BAXI LOGISTICS PRIVATE LIMITED",
"SYNERGY BAXIS ENTERPRISES PRIVATE LIMITED",
"SYNERGY BIOTECHNOLOGIES",
"SYNERGY BONDING SOLUTIONS PRIVATE LIMITED",
"SYNERGY BUILDWELL PRIVATE LIMITED",
"SYNERGY BUSINESS PRIVATE LIMITED",
"SYNERGY BUSINESS SOLUTIONS INDIA PRIVATE LIMITED",
"SYNERGY CAPCORP INDIA PRIVATE LIMITED",
"SYNERGY CAPITAL TECH PRIVATE LIMITED",
"SYNERGY CARGO MANAGEMENT INDIA PRIVATE LIMITED",
"SYNERGY CIRCUITS PRIVATE LIMITED",
"SYNERGY COMPUTER SOLUTIONS INTERNATIONAL LIMITED",
"SYNERGY CONSULTANTS",
"SYNERGY CONSULTANTS PRIVATE LIMITED",
"SYNERGY CORPORATE INTERIORS PRIVATE LIMITED",
"SYNERGY CREATIONS (I) PRIVATE LIMITED",
"SYNERGY CROP PROTECTION PRIVATE LIMITED",
"SYNERGY CROPSCIENCE PRIVATE LIMITED",
"SYNERGY DATALINKS PRIVATE LIMITED",
"SYNERGY DEALCOM (IFSC) PRIVATE LIMITED",
"SYNERGY DEALCOM PRIVATE LIMITED",
"SYNERGY DEVELOPMENT PRIVATE LIMITED",
"SYNERGY EARTH RESOURCES PRIVATE LIMITED",
"SYNERGY ENERGY SOLUTIONS PRIVATE LIMITED",
"SYNERGY ENGINEERS GROUP PRIVATE LIMITED",
"SYNERGY ENVIRONICS LIMITED",
"SYNERGY EXCHANGE PLAZA PRIVATE LIMITED",
"SYNERGY EXPRESS LOGISTICS PRIVATE LIMITED",
"SYNERGY FACILITY SERVICES PRIVATE LIMITED",
"SYNERGY FERTICHEM PRIVATE LIMITED",
"SYNERGY FILTRATION PRIVATE LIMITED",
"SYNERGY FINANCIAL SERVICES PRIVATE LIMITED",
"SYNERGY FINTECH PRIVATE LIMITED",
"SYNERGY FIRESEC PRIVATE LIMITED",
"SYNERGY FOOD AND AGRO PROCESSORS PRIVATE LIMITED",
"SYNERGY FORGE PRIVATE LIMITED",
"SYNERGY GLOBAL LOGISTICS PRIVATE LIMITED",
"SYNERGY GLOBAL STEEL PRIVATE LIMITED",
"SYNERGY GREEN INDUSTRIES LIMITED",
"SYNERGY HEALTH SCIENCES PRIVATE LIMITED",
"SYNERGY HR SOLUTIONS PRIVATE LIMITED",
"SYNERGY HRD CONSULTANTS PRIVATE LIMITED",
"SYNERGY IMAGING",
"SYNERGY INDIA MARKETING PRIVATE LIMITED",
"SYNERGY INDUSTRIAL SERVICES PVT LTD",
"SYNERGY INFO OUTSOURCINNG PRIVATE LIMITED",
"SYNERGY INFRA CONSULTANTS PRIVATE LIMITED",
"SYNERGY INFRATECH PRIVATE LIMITED",
"SYNERGY INSECTISIDES PRIVATE LIMITED",
"SYNERGY INSTITUTE OF MEDICAL SCIENCES",
"SYNERGY INSURANCE BROKING SERVICES PRIVATE LIMITED",
"SYNERGY JEWEL-TECH PRIVATE LIMITED",
"SYNERGY LABELS & PRINT SOLUTIONS PRIVATE LIMITED",
"SYNERGY LIFECARE PRIVATE LIMITED",
"SYNERGY LIFESTYLES PRIVATE LIMITED",
"SYNERGY LOGISTIC PRIVATE LIMITED",
"SYNERGY MANPOWER SOLUTION",
"SYNERGY MARITIME PRIVATE LIMITED",
"SYNERGY MARITIME RECRUITMENT SERVICES PRIVATE LIMITED",
"SYNERGY MEASUREMENT TECHNOLOGIES PRIVATE LIMITED",
"SYNERGY MECHANICS PRIVATE LIMITED",
"SYNERGY MEDIPLUS PRIVATE LIMITED",
"SYNERGY MEDSOL PRIVATE LIMITED",
"SYNERGY METALS PRIVATE LIMITED",
"SYNERGY MULTI SPECIALITY HOSPITAL LLP",
"SYNERGY NAVIS MARINE PRIVATE LIMITED",
"SYNERGY OCEANIC SERVICES INDIA PRIVATE LIMITED",
"SYNERGY OF SERVICES NITELIFE PRIVATE LIMITED",
"SYNERGY OPTIC PRIVATE LIMITED",
"SYNERGY PACKAGING PRIVATE LIMITED",
"SYNERGY PHOSPHATES LIMITED",
"SYNERGY POLY ADDITIVES PRIVATE LIMITED",
"SYNERGY POLYCHEM PRIVATE LIMITED",
"SYNERGY POWER EQUIPMENT PRIVATE LIMITED",
"SYNERGY POWER PRIVATE LIMITED",
"SYNERGY PROPERTY DEVELOPMENT SERVICES PRIVATE LIMITED",
"SYNERGY PUNCHING PRIVATE. LIMITED.",
"SYNERGY RAIL ENGINEERING PRIVATE LIMITED",
"SYNERGY RELATIONSHIP MANAGEMENT SERVICES PRIVATE LIMITED",
"SYNERGY REMEDIES PRIVATE LIMITED",
"SYNERGY SCIENTIFIC SERVICES PRIVATE LIMITED",
"SYNERGY SEACOAST PRIVATE LIMITED",
"SYNERGY SEAPORTS PRIVATE LIMITED",
"SYNERGY SHAKTHI RENEWABLE ENERGY LIMITED",
"SYNERGY SHIPPING PRIVATE LIMITED",
"SYNERGY SOFTWARES LIMITED",
"SYNERGY STAFFING & CONSULTANCY SERVICES PRIVATE LIMITED",
"SYNERGY STEELS LIMITED",
"SYNERGY TECHNO SUPPORT AND SOLUTIONS LLP",
"SYNERGY TECHNOFIN PRIVATE LIMITED",
"SYNERGY TECHNOLOGY SERVICES PRIVATE LIMITED",
"SYNERGY TELECOMMUNICATIONS PRIVATE LIMITED",
"SYNERGY TELEMATICS PRIVATE LIMITED",
"SYNERGY TELETECH PRIVATE LIMITED",
"SYNERGY TRANSFORMERS PRIVATE LIMITED",
"SYNERGY WASTE MANAGEMENT PRIVATE LIMITED",
"SYNERGY WATERPARK RIDES PRIVATE LIMITED",
"SYNERGYBYTE INFOTAINMENT PRIVATE LIMITED",
"SYNERGYCONNECT DATA INNOVATIONS PRIVATE LIMITED",
"SYNERGYPHARMA FORMULATIONS INDIA PRIVATE LIMITED",
"SYNERGYPRO PROMOTIONS AND EVENTS INDIA PRIVATE LIMITED",
"SYNERGYREVO GLOBAL BUSINESS SERVICES PRIVATE LIMITED",
"SYNERGYTECH AUTOMATION PRIVATE LIMITED",
"SYNERGYTOP SOFTLAB PRIVATE LIMITED",
"SYNERIC CONSULTANTS AND DISTRIBUTORS PRIVATE LIMITED",
"SYNEROX INDIA PRIVATE LIMITED",
"SYNERSOFT TECHNOLOGIES PRIVATE LIMITED",
"SYNERSYS TECHNOLOGIES",
"SYNERZEZ SOLUTIONS PRIVATE LIMITED",
"SYNETECA ENGINEERING SOLUTIONS PRIVATE LIMITED",
"SYNETICS AUTOMATION SOLUTIONS PRIVATE LIMITED",
"SYNEX BIOTECH PRIVATE LIMITED",
"SYNEXTIC GLOBAL BUSINESS SOLUTION PRIVATE LIMITED",
"SYNFAB SEFINVEST PRIVATE LIMITED",
"SYNFLEX ELEKTRO PRIVATE LIMITED",
"SYNFOSYS BUSINESS SOLUTIONS LIMITED",
"SYNGENE INTERNATIONAL LIMITED",
"SYNGENE SCIENTIFIC SOLUTIONS LIMITED",
"SYNGENTA BIOSCIENCES PRIVATE LIMITED",
"SYNGENTA CROP PROTECTION LIMITED",
"SYNGENTA INDIA LIMITED",
"SYNGENTA INDIA PRIVATE LIMITED",
"SYNGENTA SERVICES PRIVATE LIMITED",
"SYNGEX PHARMA PRIVATE LIMITED",
"CORSEARCH INDIA PRIVATE LIMITED",
"SYNGYMAXIM SOLUTIONS PRIVATE LIMITED",
"SYNIGENCE BUSINESS SOLUTIONS PRIVATE LIMITED",
"SYNIGENCE GLOBAL SERVICES PRIVATE LIMITED",
"SYNIGENCE TECHNICAL SOLUTIONS PRIVATE LIMITED",
"SYNISE TECHNOLOGIES LIMITED",
"SYNISO IT SOLUTIONS PRIVATE LIMITED",
"SYNIVERSE MOBILE SOLUTIONS PRIVATE LIMITED",
"SYNIVERSE TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"SYNIVERSE TECHNOLOGIES SERVICES INDIA PRIVATE LIMITED",
"SYNIVERSE TELEDATA SYSTEMS PRIVATE LIMITED",
"SYNKOM TECHNOLOGIES PRIVATE LIMITED",
"SYNKROMAX BIOTECH PRIVATE LIMITED",
"SYNLOGICA SOLUTIONS PRIVATE LIMITED",
"SYNMAC CHEMICALS PRIVATE LIMITED",
"SYNMAX CONSULTANTS & TRADING PRIVATE LIMITED",
"SYNMEDIC LABORATORIES PRIVATE LIMITED",
"SYNMR CHEMICALS PRIVATE LIMITED",
"SYNNAT PHARMA PRIVATE LIMITED",
"SYNNEX BUSINESS MEDIA PRIVATE LIMITED",
"SYNNEX CORPORATION",
"SYNNOV SOFTWARE LLP",
"SYNNOVA CERAMIC PRIVATE LIMITED",
"SYNNOVA GEARS & TRANSMISSIONS PRIVATE LIMITED",
"SYNOCHEM ORGANICS PRIVATE LIMITED",
"SYNOCULE RESEARCH LABS PRIVATE LIMITED",
"SYNODIC BUSINESS CONSULTANTS PRIVATE LIMITED",
"SYNODIC DIGITAL BRANDINGS PRIVATE LIMITED",
"SYNOKEM PHARMACEUTICALS LIMITED",
"SYNONN LIFESCIENCES LIMITED",
"SYNOPHIC GLOBAL RESEARCH PRIVATE LIMITED",
"SYNOPSYS INDIA EDA SOFTWARE PRIVATE LIMITED",
"SYNOPSYS INDIA PRIVATE LIMITED",
"SYNOPSYS SOFTWARE INTEGRITY SOLUTIONS (INDIA) PRIVATE LIMITED",
"SYNOPSYS TECH PRIVATE LIMITED",
"SYNOPTICS TECHNOLOGIES LIMITED",
"SYNOPTION INDIA PRIVATE LIMITED",
"SYNORIQ R & D PRIVATE LIMITED",
"SYNORIS INFORMATION SYSTEMS PRIVATE LIMITED",
"SYNOTIVE TECHNOLOGIES INDIA PRIVATE LIMITED",
"SYNOVA CROP SCIENCES PRIVATE LIMITED",
"SYNOVA LASER TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"SYNOVATIC INDIA MACHINERY PRIVATE LIMITED",
"SYNOVERGE TECHNOLOGIES PRIVATE LIMITED",
"SYNOVIA LIFE SCIENCES PRIVATE LIMITED",
"SYNOVITA CORPORATE SERVICES PRIVATE LIMITED",
"SYNPACK ESTATES PRIVATE LIMITED",
"SYNPACK FLEXIBLES PRIVATE LIMITED",
"SYNPACK POLYOLEFIN PRIVATE LIMITED",
"SYNPACK ZIPPER BAGS PRIVATE LIMITED",
"SYNPOL PRODUCTS PRIVATE LIMITED",
"SYNPRO NUTRITIONS PRIVATE LIMITED",
"SYNPURE LABS INDIA PRIVATE LIMITED",
"SYNSILVA SMART TRADING PRIVATE LIMITED",
"SYNSMART RASAYAN RESEARCH PRIVATE LIMITED",
"SYNTAX POLYFIBRES PRIVATE LIMITED",
"SYNTAX SOFT TECH INDIA PRIVATE LIMITED",
"SYNTAX SYSTEMS PRIVATE LIMITED",
"SYNTEC SYSTEMS INDIA PRIVATE LIMITED",
"SYNTEGON TECHNOLOGY INDIA PRIVATE LIMITED",
"SYNTEL GLOBAL PRIVATE LIMITED",
"SYNTEL INTERNATIONAL PRIVATE LIMITED",
"SYNTEL PRIVATE LIMITED",
"SYNTEL SERVICES PRIVATE LIMITED",
"SYNTEL SOFTWARE LLP",
"SYNTEL SOLUTIONS INDIA PRIVATE LIMITED",
"SYNTEL TELECOM LIMITED",
"SYNTELLECT RESEARCH EUROPE PRIVATE LIMITED",
"SYNTEX CORPORATION PRIVATE LIMITED",
"SYNTHESIS HEALTHCARE SERVICES LLP",
"SYNTHESIS HOME TEXTILES PRIVATE LIMITED",
"SYNTHESIS SPACELINKS PRIVATE LIMITED",
"SYNTHESIS SYSTEMS INDIA PRIVATE LIMITED",
"SYNTHESIS TECHNOLOGY PRIVATE LIMITED",
"SYNTHESIS WINDING TECHNOLOGIES PRIVATE. LIMITED.",
"SYNTHESIS WITH CATALYSTS PRIVATE LIMITED",
"SYNTHESYS SOLUTIONS PRIVATE LIMITED",
"SYNTHETIC MOULDERS LIMITED.",
"SYNTHETIC PACKERS PRIVATE LIMITED",
"SYNTHETIC RESEARCH PHARMA LABORATORIES PRIVATE LIMITED",
"SYNTHETICS AND POLYMERS PRIVATE LIMITED",
"SYNTHIKO EXPORTS PRIVATE LIMITED",
"SYNTHIKO FOILS LIMITED",
"SYNTHITE INDUSTRIES LIMITED",
"SYNTHITE INDUSTRIES PRIVATE LIMITED",
"SYNTHITE INFRASTRUCTURE PROJECTS PRIVATE LIMITED",
"SYNTHITE PROJECTS (COCHIN) PRIVATE LIMITED",
"SYNTHO CHEM PVT LTD",
"SYNTHO CHIRALS PRIVATE LIMITED",
"SYNTHO PHARMACEUTICALS PRIVATE LIMITED",
"SYNTHOKEM LABS PRIVATE LIMITED",
"SYNTHOTEX CHEMICALS PRIVATE LIMITED",
"SYNTIZEN TECHNOLOGIES PRIVATE LIMITED",
"SYNTRA MANUFACTURERS PRIVATE LIMITED",
"SYNTRIC ENGINEERING PRIVATE LIMITED",
"SYNTRIO TECHNOLOGIES PRIVATE LIMITED",
"SYNTRON INDUSTRIES PRIVATE LIMITED",
"SYNTRONS TECHNOLOGIES PRIVATE LIMITED",
"SYNTYCHE TRADEX ENTERPRISES (OPC) PRIVATE LIMITED",
"SYNUP DIGITAL PRIVATE LIMITED",
"SYNUS LABORATORY LLP",
"SYNVEN SHREE LIFE SCIENCES PRIVATE LIMITED",
"SYNVENTIVE MOLDING SOLUTIONS JBJ PRIVATE LIMITED",
"SYNWOOD AGRO LIMITED",
"SYNYOGIC LIFESCIENCE PRIVATE LIMITED",
"SYNZEAL RESEARCH PRIVATE LIMITED",
"SYOCARE FACILITY MANAGEMENT CONSULTANCY PRIVATE LIMITED",
"SYON MED PRIVATE LIMITED",
"SYONA COSMETICS PRIVATE LIMITED",
"SYP CONSTRUCTION COMPANY PRIVATE LIMITED.",
"SYP ENGINEERING COMPANY PVT LTD",
"SYPHASE ENGINEERING PRIVATE LIMITED",
"SYPHON AUTOMATION PRIVATE LIMITED",
"SYPPSA INFOTECH PRIVATE LIMITED",
"SYPRAM WORLD TRADE PRIVATE LIMITED",
"SYRA SPICES PRIVATE LIMITED",
"SYRATRON TECHNOLOGIES PRIVATE LIMITED",
"SYREN TECHNOLOGIES PRIVATE LIMITED",
"SYREX INFOSERVICES INDIA PRIVATE LIMITED",
"SYRIS BIOTECH PRIVATE LIMITED",
"SYRMA SGS TECHNOLOGY LIMITED",
"SYRMA TECHNOLOGY PRIVATE LIMITED",
"SYROHCHEM LABORATORIES PRIVATE LIMITED",
"SYROTECH INNOVATIONS PRIVATE LIMITED",
"SYROW PRIVATE LIMITED",
"SYRRIS SCIENTIFIC EQUIPMENT PRIVATE LIMITED",
"SYRUP TECHNOLOGIES PRIVATE LIMITED",
"SYS ELECTROMAC PRIVATE LIMITED",
"SYS MEDTECH INTERNATIONAL PRIVATE LIMITED",
"SYS PACKAGING PRIVATE LIMITED",
"SYSARC INFOMATIX PRIVATE LIMITED",
"SYSARKS TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"SYSBIZ TECHNOLOGIES PRIVATE LIMITED",
"SYSCAB NETWORK PRIVATE LIMITED",
"SYSCAD ENGINEERING PRIVATE LIMITED",
"SYSCARE TECHNOLOGIES AND SERVICES PRIVATE LIMITED",
"SYSCHEM (INDIA) LIMITED",
"SYSCLOUD TECHNOLOGIES PRIVATE LIMITED",
"SYSCO INDIA PRIVATE LIMITED",
"SYSCOM EDUTECH PRIVATE LIMITED",
"SYSCOM VENTURES PRIVATE LIMITED",
"SYSCOMP IMPEX PVT. LTD.",
"SYSCON AUTOMATION & CONTROLS PRIVATE LIMITED",
"SYSCON CALIBRATION CENTRE PRIVATE LIMITED",
"SYSCON ENERGY CONSERVATION SOLUTIONS PRIVATE LIMITED",
"SYSCON INFOTECH PRIVATE LIMITED",
"SYSCON INFOWAY PRIVATE LIMITED",
"SYSCON INSTRUMENTS PRIVATE LIMITED",
"SYSCON METERING SOLUTIONS PRIVATE LIMITED",
"SYSCON SYSNET PRIVATE LIMITED",
"SYSCO-TECH SYSTEMS (INDIA) PRIVATE LIMITED",
"SYSCRAFT SOLUTIONS PRIVATE LIMITED",
"SYSDIVA CONSULTANTS PRIVATE LIMITED",
"SYS-EDGE MICRO INFORMATICS PRIVATE LIMITED",
"SYSELEC TECHNOLOGIES PRIVATE LIMITED",
"SYSFORE TECHNOLOGIES PRIVATE LIMITED",
"SYSGAIN INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"SYSGEE SOFT SOLUTIONS PRIVATE LIMITED",
"SYSINFO TOOLS SOFTWARE PRIVATE LIMITED",
"SYSINFORMATION HEALTHCARE INDIA PRIVATE LIMITED",
"SYSINTEGRA",
"SYSINTELLI SOFTWARE AND SERVICES PRIVATE LIMITED",
"SYSKA LED LIGHTS PRIVATE LIMITED",
"SYSLOGICS TECHNOLOGIES PRIVATE LIMITED",
"SYSMAC IT SOLUTIONS PRIVATE LIMITED",
"SYSMATIC INTERNATIONAL EDUCATION AND MANAGEMENT SERVICES",
"SYSMED EXIM PRIVATE LIMITED",
"SYSMEDAC TECHNOLOGIES INDIA PRIVATE LIMITED",
"SYSMEX INDIA PRIVATE LIMITED",
"SYSMIND TECH PRIVATE LIMITED",
"SYSMIX INFOTECH PRIVATE LIMITED",
"SYSNET GLOBAL SOLUTIONS INDIA PRIVATE LIMITED",
"SYSNET GLOBAL TECHNOLOGIES PRIVATE LIMITED",
"SYSOIN TECHNOLOGIES PRIVATE LIMITED",
"SYSOTECH ENGINEERS AND MANUFACTURERS PRIVATE LIMITED",
"SYSPRO ELECTRO CONTROLS PRIVATE LIMITED",
"SYSPRO FOODS PRIVATE LIMITED",
"SYSSOFT INFOTECH INDIA PRIVATE LIMITED",
"SYSTA MET INDIA PRIVATE LIMITED",
"SYSTALDYN CONSULTANCY PRIVATE LIMITED",
"SYSTALENT SOFTWARE PRIVATE LIMITED",
"SYSTANGO TECHNOLOGIES LIMITED",
"SYSTANGO TECHNOLOGIES PRIVATE LIMITED",
"SYSTECH SERVICES LIMITED",
"SYSTECH SERVICES PRIVATE LIMITED",
"SYSTECH SOLUTIONS PRIVATE LIMITED",
"SYSTECH TECHNOCRAFT SERVICES PRIVATE LIMITED",
"SYSTECHCORP PRIVATE LIMITED",
"SYSTEL ENERGY SOLUTIONS PRIVATE LIMITED",
"SYSTEL TECHNOLOGY SERVICES PRIVATE LIMITED",
"SYSTEM 5S PRIVATE LIMITED",
"SYSTEM AIRCONDITIONING PRIVATE LIMITED",
"SYSTEM ANATECH (INDIA) PRIVATE LIMITED",
"SYSTEM AND AUTOMATION ENGINEERS (INDIA) PRIVATE LIMITED",
"SYSTEM CERAMICS INDIA PRIVATE LIMITED",
"SYSTEM CONTROL & AUTOMATION PVT LTD",
"SYSTEM CONTROLS TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"SYSTEM ENGINEERS CUTTING AND WELDING PRIVATE LIMITED",
"SYSTEM ENGINEERS PRIVATE LIMITED",
"SYSTEM ENGITECH PRIVATE LIMITED",
"SYSTEM INFRA SOLUTIONS PRIVATE LIMITED",
"SYSTEM LEVEL SOLUTIONS INDIA PRIVATE LIMITED",
"SYSTEM LOGISTICS INDIA PRIVATE LIMITED",
"SYSTEM NETWORK PRIVATE LIMITED",
"SYSTEM SOFT TECHNOLOGIES GLOBAL PRIVATE LIMITED",
"SYSTEM SOFT TECHNOLOGIES INDIA PRIVATE LIMITED",
"SYSTEM TECSYS SOLUTIONS PRIVATE LIMITED",
"SYSTEMA AUTOMATION INDIA PRIVATE LIMITED",
"SYSTEMAIR INDIA PRIVATE LIMITED",
"SYSTEMATIC AND ADVANCE CONSTRUCTION PRIVATE LIMITED",
"SYSTEMATIC COMMUNICATIONS PRIVATE LIMITED",
"SYSTEMATIC CONSCOM LIMITED",
"SYSTEMATIC FINANCE COMPANY PRIVATE LIMITED",
"SYSTEMATIC INDUSTRIES PRIVATE LIMITED",
"SYSTEMATIC LOGISTICS PRIVATE LIMITED",
"SYSTEMATIC MARKETING CONCEPTS PRIVATE LIMITED",
"SYSTEMATIC STEEL INDUSTRIES LIMITED",
"SYSTEMATICS INFOTECH PRIVATE LIMITED",
"SYSTEMATICWIRES PRIVATE LIMITED",
"SYSTEMATIX CORPORATE SERVICES LIMITED",
"SYSTEMATIX FINCORP INDIA LIMITED",
"SYSTEMATIX FINVEST PRIVATE LIMITED",
"SYSTEMATIX INFOTECH PRIVATE LIMITED",
"SYSTEMATIX MEDIA PRIVATE LIMITED",
"SYSTEMATIX SHARES & STOCKS INDIA LIMITED",
"SYSTEMS ADVISERS SOFTWARE SERVICES PRIVATE LIMITED",
"SYSTEMS AND CONTROLS(SANGLI)PVT LTD",
"SYSTEMS CABLE AND WIRES PRIVATE LIMITED",
"SYSTEMS INDIA PRIVATE LIMITED",
"SYSTEMS PLUS PRIVATE LIMITED",
"SYSTEMS PLUS TRANSFORMATIONS LIMITED LIABILITY PARTNERSHIP",
"SYSTEMS TEK INDIA PRIVATE LIMITED",
"SYSTEQ FACILITY MANAGEMENT & SECURITY SERVICES (INDIA) PRIVATE LIMITED",
"SYSTHERM ENGINEERING PRIVATE LIMITED",
"SYSTHINK TECHNOLOGIES PRIVATE LIMITED",
"SYSTIME COMPUTERS LIMITED",
"SYSTOCHEM LABORATORIES LIMITED",
"SYSTOMAT SOLUTIONS PRIVATE LIMITED",
"SYSTOOLS SOFTWARE PRIVATE LIMITED",
"SYSTOPIC LABORATORIES PRIVATE LIMITED",
"SYSTOS SHIPMANAGEMENT PRIVATE LIMITED",
"SYSTRA MVA CONSULTING (INDIA) PRIVATE LIMITED",
"SYSTRAC SOLUTIONS PRIVATE LIMITED",
"SYSTROME NETWORKS (INDIA) PRIVATE LIMITED",
"SYSTRONIC ENGINEERS PRIVATE LIMITED",
"SYSTRONICS INDIA LIMITED",
"SYSTURN AUTO ENGINEERING PRIVATE LIMITED",
"SYSTWEAK SOFTWARE PRIVATE LIMITED",
"SYSTY INFO PRIVATE LIMITED",
"SYSTYLE PROJECTS PRIVATE LIMITED",
"SYSVEDA INFORMATION TECHNOLOGY PRIVATE LIMITED",
"SYSVINE TECHNOLOGIES PRIVATE LIMITED",
"SYSWARE INFOTECH PRIVATE LIMITED",
"SYSWIN PHARMACEUTICALS PRIVATE LIMITED",
"SYTCO ENGINEERS",
"SY-TECH ENGINEERING PRIVATE LIMITED",
"SYTEX SCIENTIFIC AND HYDRAULICS PRIVATE LIMITED",
"SYVEN GLOBAL SERVICES PRIVATE LIMITED",
"SYVO DIGITAL PRIVATE LIMITED",
"SYX SERVICES PRIVATE LIMITED",
"SZIIAH TECHNOLOGY PRIVATE LIMITED",
"SZK GLOBAL CONSULTING INDIA PRIVATE LIMITED",
"SZS TECH PRIVATE LIMITED",
"T & A CONSULTING PRIVATE LIMITED",
"T & AS DESIGNTECH SERVICES PRIVATE LIMITED",
"T & I PROJECTS LIMITED",
"T & M SERVICES CONSULTING PRIVATE LIMITED",
"T & T ENGINEERS AND CONTRACTORS INDIA PRIVATE LIMITED",
"T & T MOTORS PRIVATE LIMITED",
"T & T PROJECTS LIMITED",
"T & T V SARVAJANIK HIGH SCHOOL",
"T .N. COLLEGE OF COMPETITIONS PRIVATE LIMITED",
"T A JETS PRIVATE LIMITED",
"T A PAI MANAGEMENT INSTITUTE",
"T AND D GALIAKOT CONTAINERS PRIVATE LIMITED",
"T AND D TRADING PRIVATE LIMITED",
"T AND F INSULATIONS PRIVATE LIMITED",
"T AND L GASES PRIVATE LIMITED",
"T AND M PLATER LLP",
"T AND R HEAVY FORGINGS PRIVATE LIMITED",
"T AND T INFRA LIMITED",
"T AND T INFRA PRIVATE LIMITED",
"T AND T REALITY SERVICES PRIVATE LIMITED",
"T AND T SOLAR ENERGY PRIVATE LIMITED",
"T B DESAI FAMILY PUBLIC CHARITABLE TRUST",
"T B S BARI HOSPITAL UDAIPUR",
"T BALAJI ENGINERING PRIVATE LIMITED",
"T C COMMUNICATION PRIVATE LIMITED",
"T C HEALTH CARE PRIVATE LIMITED",
"T C JINDAL AND CONSULTANTS PRIVATE LIMITED",
"T C MOTORS PRIVATE LIMITED",
"T C P ADVERTISING PRIVATE LIMITED",
"T C SPINNERS PRIVATE LIMITED",
"T C TEA AND ENTERPRISES PRIVATE LIMITED",
"T C TERRYTEX LIMITED",
"T D S MANAGEMENT CONSULTANT PRIVATE LIMITED",
"T D W FURNITURE PRIVATE LIMITED",
"T D WILLIAMSON INDIA PRIVATE LIMITED",
"T EN GLOBAL BUSINESS SERVICES PRIVATE LIMITED",
"T G DEVELOPERS PRIVATE LIMITED",
"T G I PACKAGING PRIVATE LIMITED",
"T G LEISURE AND RESORTS PRIVATE LIMITED",
"T G R PROJECTS INDIA PRIVATE LIMITED",
"T G ROLLER FLOUR MILLS PRIVATE LIMITED",
"T G V PROJECTS AND INVESTMENTS PRIVATE LIMITED",
"T- GLOBAL TECHNOLOGIES PRIVATE LIMITED",
"T H E PEARLS STONE PRIVATE LIMITED",
"T H O NEWASA",
"T HUB FOUNDATION",
"T I AUTOMOTIVES PRIVATE LIMITED",
"T I C C CONTAINER LINE INDIA PRIVATE LIMITED",
"T I COMMUNICATION PRIVATE LIMITED",
"T I INFOTECH PRIVATE LIMITED",
"T I MOTORS PRIVATE LIMITED",
"T J FINANCIAL CONSULTANCY AND INVESTMENTS PRIVATE LIMITED",
"T K D ENTERPRISE PRIVATE LIMITED",
"T K EXIM PRIVATE LIMITED",
"T K HOTELS PRIVATE LIMITED",
"T K INTERNATIONAL LIMITED",
"T K PRECISION PRIVATE LIMITED",
"T K RUBBER INDUSTRIES PVT LTD",
"T K STEEL ROLLING MILLS PRIVATE LIMITED",
"T M ENTERPRISES PRIVATE LIMITED",
"T M FABRICS PRIVATE LIMITED",
"T M HALLMARK JEWELLERS PRIVATE LIMITED",
"T M PATEL PROCESSING PRIVATE LIMITED",
"T M PRINTERS PRIVATE LIMITED",
"T M S REAL ESTATE PRIVATE LIMITED",
"T M V AROMATICS PVT LTD",
"T M YOGESH TEXTILE PRIVATE LIMITED",
"T N AUTO AND GENERAL ENGINEERING COMPANY PRIVATE LIMITED",
"T N CHOWDHURY TEA ESTATE P LTD",
"T N KATIYAR KISAN COLD STORAGE PRIVATE LIMITED",
"T N RAO COLLEGE RAJKOT",
"T N UROLOGICAL RESEARCH CENTRE",
"T P BUILDART PRIVATE LIMITED",
"T P D MALWA COLLEGE",
"T P GAYATRI ENTERPRISES PRIVATE LIMITED",
"T P LOGISTICS PRIVATE LIMITED",
"T P ROY CHOWDHURY & CO PRIVATE LIMITED",
"T P TEXTILES PRIVATE LIMITED",
"T PRASAD RAO PRIVATE LIMITED",
"T R B EXPORTS PRIVATE LIMITED",
"T R CHADHA & CO LLP",
"T R ENGINEERS PRIVATE LIMITED",
"T R FINISHED VEHICLES LOGISTICS SOLUTIONS LIMITED",
"T R ISPAT AND POWER PRIVATE LIMITED",
"T R MILLS PRIVATE LIMITED",
"T R RETAILS LIMITED",
"T R SAWHNEY AUTOMOBILES PRIVATE LIMITED",
"T R SAWHNEY MOTORS PRIVATE LIMITED",
"T R SOLVENT OILS PRIVATE LIMITED",
"T R TREHAN CONSTRUCTIONS PRIVATE. LIMITED.",
"T S ALLOYS LIMITED",
"T S CLOTHING PRIVATE LIMITED",
"T S CONSTRUCTION ENGINEERS PRIVATE LIMITED",
"T S DIGHOLE PRATHAMIK VIDYALAY",
"T S G IMPEX (INDIA) PRIVATE LIMITED",
"T S INFORMATICS PRIVATE LIMITED",
"T S ISPAT PRIVATE LIMITED",
"T S J MEDIA PRIVATE LIMITED",
"T S LINES INDIA PRIVATE LIMITED",
"T S LOGISTIC SOLUTIONS PRIVATE LIMITED",
"T S MARKETING SERVICES PRIVATE LIMITED",
"T S MECHANICAL WORKS PVT LTD",
"T S MEDICAL SERVICES AND INFRASTRUCTURE DEVELOPMENT CORPORATION",
"T S MISHRA MEDICAL COLLEGE AND HOSPITAL",
"T S R T B K DEGREE COLLEGE",
"T S ROADWAYS PVT LTD",
"T SPACE PLANNING AND SERVICES PRIVATE LIMITED",
"T SQUARE TOOLS PRIVATE LIMITED",
"T STANES AND COMPANY LIMITED",
"T SYSTEMS INFORMATION AND COMMUNICATION TECHNOLOGY INDIA PRIVATE LIMITED",
"T T L MINERALS EXPORTS PVT LTD",
"T T LIMITED",
"T T TEXTILE WINGS PVT LTD",
"T V AIR CONTROL SYSTEMS PRIVATE LIMITED",
"T V SUNDRAM IYENGAR & SONS PRIVATE LIMITED",
"T V TODAY NETWORK BUSINESS LIMITED",
"T WEB EXPONENT SERVICES PRIVATE LIMITED",
"T Z VIDYA MANDIR BHAGUR",
"T&C ENGINEERS PRIVATE LIMITED",
"T&D SOLAR SOLUTIONS PRIVATE LIMITED",
"T&I GLOBAL LIMITED",
"T&N BUSINESS SERVICES PRIVATE LIMITED",
"T&TS ENGINEERING CONSULTANCY INDIA PRIVATE LIMITED",
"T. G. BUILDCON PRIVATE LIMITED",
"T. G. INTERLININGS PRIVATE LIMITED",
"T. GOGAD COTTON PRIVATE LIMITED",
"T. INTERNATIONAL PRIVATE LIMITED",
"T. K. CENTENARY CARGO SERVICES PRIVATE LIMITED",
"T. PODDAR INFRADEVELOPERS PRIVATE LIMITED",
"T. R. CHEMICALS LIMITED",
"T.A.C DESIGN PRIVATE LIMITED",
"T.A.V. AGENCIES PRIVATE LIMITED",
"T.A.V. PRODUCTS PRIVATE LIMITED",
"T.ABDUL WAHID AND CO",
"T.C.C INFRASTRUCTURE PRIVATE LIMITED",
"T.C.D.A. SERVICES PRIVATE LIMITED",
"T.G.LEATHERS PRIVATE LIMITED",
"T.H.E AC ZONE PRIVATE LIMITED",
"T.I.M.E. EDUCATION BANGALORE PRIVATE LIMITED",
"T.I.M.E. EDUCATION CHENNAI PRIVATE LIMITED",
"T.I.M.E. KIDS PRIVATE LIMITED",
"T.J COMMUNICATIONS PRIVATE LIMITED",
"T.J. AGRO CHEMICALS & FERTILIZERS PRIVATE LIMITED",
"T.K. AGRO PRIVATE LIMITED",
"T.K. GURUSAMY NADAR AND SONS SRI KOODALINGAM PATTU CENTRE PRIVATE LIMITED",
"T.K. NANJUNDA SETTY SILKS PRIVATE LIMITED",
"T.K.R.WIRES PVT LTD",
"T.KHAN LOGISTIC PRIVATE LIMITED",
"T.M. CONCRETE CREATION PRIVATE LIMITED",
"T.M.INPUTS AND SERVICES PRIVATE LIMITED",
"T.M.P. ENGINEERING WORKS PRIVATE LIMITED",
"T.N. SYS MERYL PHARMA PRIVATE. LIMITED.",
"T.O.PHILIP ADVERTISING COMPANY PRIVATE LIMITED",
"T.P. MINING INDUSTRIES PRIVATE LIMITED",
"T.P.S. WIND FARM PRIVATE LIMITED",
"T.R. BONDINGS PRIVATE LIMITED",
"T.R. ENERGY & AGRO PRIVATE LIMITED",
"T.R.AND SONS BUSINESS PRIVATE LIMITED",
"T.R.G. INDUSTRIES PRIVATE LIMITED",
"T.R.GUPTA CONSTRUCTIONS PVT LTD",
"T.R.S STEELS INDIA PRIVATE LIMITED",
"T.R.S.FORMS & SERVICES PRIVATE LIMITED",
"T.RAM FINANCIAL SERVICES PRIVATE LIMITED",
"T.S. MAHALINGAM FINANCIAL SERVICES PRIVATE LIMITED",
"T.S. PULSES PRIVATE LIMITED",
"T.S.M MEDICAL COLLAGE AND HOSPITAL",
"T.T. IRONS PRIVATE LIMITED",
"T2 TECHNOLOGY CONSULTING PRIVATE LIMITED",
"T24 GLOBAL IMPEX PRIVATE LIMITED",
"T2S SOFTWARE SOLUTIONS PRIVATE LIMITED",
"T3 INTEGRATION TECHNOLOGIES SERVICES PRIVATE LIMITED",
"T3 TRANSLIFE PRIVATE LIMITED",
"T3D LABS PRIVATE LIMITED",
"T4 INITIATIVES PRIVATE LIMITED",
"T4 TAPES PRIVATE LIMITED",
"T4 TEXULTANTS PRIVATE LIMITED",
"T7E AFTERMARKET CONNECT PRIVATE LIMITED",
"T8 FOOD PROCESSING AND TRADING PRIVATE LIMITED",
"T92 FASHION PRIVATE LIMITED",
"TA ASSOCIATES ADVISORY PRIVATE LIMITED",
"TA AUTOTEC INFORMATION SYSTEMS INDIA PRIVATE LIMITED",
"TA GREENTECH PRIVATE LIMITED",
"TA HYDRAULICS PRIVATE LIMITED",
"TA LABS PRIVATE LIMITED",
"TA PAI MANAGEMENT INSTITUTE",
"TA TECHNOLOGIES AND HEALTHCARE",
"TA. RA. INNOVATIONS",
"TA3S SOLUTIONS PRIVATE LIMITED",
"TAAHA ENGINEERS PRIVATE LIMITED",
"TAAJ HEALTH CARE CHEMICALS PRIVATE LIMITED",
"TAAL ENTERPRISES LIMITED",
"TAAL NAGAR PARISHAD",
"TAAL TECH INDIA PRIVATE LIMITED",
"TAAL WALE BABA INFRA DEVELOPERS PRIVATE LIMITED",
"TAALAY METALLICS PRIVATE LIMITED",
"TAALIN MACHINERY & ROBOTICS PRIVATE LIMITED",
"TAAMARA ESTATES PRIVATE LIMITED",
"TAAMAS FABRICS PVT LTD",
"TAAMRA ENGINEERING CONSULTANTS INDIA PRIVATE LIMITED",
"TAANI INDUSTRIES PRIVATE LIMITED",
"TAANNAZ BRONZZE PRIVATE LIMITED",
"TAANUSHRE INTERNATIONALS PRIVATE LIMITED",
"TAANZ FASHIONS INDIA PRIVATE LIMITED",
"TAAPASI MOTORS PRIVATE LIMITED",
"TAAQ MUSIC PRIVATE LIMITED",
"TAARAK INDIA PRIVATE LIMITED",
"TAARK EQUIPMENTS PRIVATE LIMITED",
"TAARU GEE MARKETING PRIVATE LIMITED",
"TAARUNI CONNECTIONS ( INDIA) PRIVATE LIMITED",
"TAASHATECH INFOSOLUTIONS PRIVATE LIMITED",
"TAAZA FOOD PRODUCTS PRIVATE LIMITED",
"TAAZA INFOTAINMENT PRIVATE LIMITED",
"TAAZA MITHAI PRIVATE LIMITED",
"TAAZAA TECH PRIVATE LIMITED",
"TAAZIBHAAJI FARMERS PRODUCER COMPANY LIMITED",
"TAB CAPITAL LIMITED",
"TAB INDIA GRANITES PRIVATE LIMITED",
"TAB INTERIOR PRODUCT PRIVATE LIMITED",
"TAB SPA & HEALTHCARE LLP",
"TABA KASHI PRIVATE LIMITED",
"TABASCOHINDUSTAN INFRADEVELOPERS PRIVATE LIMITED",
"TABEER HOSPITALITY PRIVATE LIMITED",
"TABIB MEDICAL TOURISM PRIVATE LIMITED",
"TABINDIA HEALTHCARE PRIVATE LIMITED",
"TABLE BARN PRIVATE LIMITED",
"TABLE IMAGE SOLUTIONS PRIVATE LIMITED",
"TABLERO SHUTTER (INDIA) PRIVATE LIMITED",
"TABLESPACE CONSTRUCTIONS PRIVATE LIMITED",
"TABLESPACE SERVICES PRIVATE LIMITED",
"TABLESPACE TECHNOLOGIES PRIVATE LIMITED",
"TABLETS INDIA LIMITED",
"TABLEWORTH HOSPITALITY PRIVATE LIMITED",
"TABLEZ AND TOYAZ PRIVATE LIMITED",
"TABLEZ PROPERTIES PRIVATE LIMITED",
"TABLOID BUSINESS SOLUTIONS PRIVATE LIMITED",
"TABOOLA INDIA PRIVATE LIMITED",
"TABOR FREIGHT AND LOGISTICS PRIVATE LIMITED",
"TABP SNACKS AND BEVERAGES PRIVATE LIMITED",
"TABPACK PRIVATE LIMITED",
"TABTREE IT CONSULTING & SERVICES LLP",
"TAC AUTOMATION PRIVATE LIMITED",
"TAC CARGO AND LOGISTICS PRIVATE LIMITED",
"TAC GARMENTS PRIVATE LIMITED",
"TAC INFOSEC LIMITED",
"TAC INFOSEC PRIVATE LIMITED",
"TACENT INDUSTRIES PRIVATE LIMITED",
"TACFAB FASHIONS PRIVATE LIMITED",
"TACHION ELECTRICALS AND CONTROLS PRIVATE LIMITED",
"TACHOCLINE RENEWABLES PRIVATE LIMITED",
"TACHUS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"TACHYON COMMUNICATIONS PRIVATE LIMITED",
"TACHYON TECHNOLOGIES PRIVATE LIMITED",
"TACIT HOME SOLUTIONS PRIVATE LIMITED",
"TACIT TECHNOVATIVE PRIVATE LIMITED",
"TACK EXIM PRIVATE LIMITED",
"TACK INNOVATION INDIA PRIVATE LIMITED",
"TACKER TECHNOLOGIES PRIVATE LIMITED",
"TACO CONSULTANTS PRIVATE LIMITED",
"TACO PRESTOLITE ELECTRIC PRIVATE LIMITED",
"TACO VISIONS PRIVATE LIMITED",
"TACOMA GLOBAL PRIVATE LIMITED",
"TACON INFRASTRUCTURE PRIVATE LIMITED",
"TACON SECURITY SYSTEM PRIVATE LIMITED",
"TACOS RESTAURANTS PRIVATE LIMITED",
"TACT INDIA PRIVATE LIMITED",
"TACTAI SOFTWARE INDIA PRIVATE LIMITED",
"TACTERIAL CONSULTING PRIVATE LIMITED",
"TACTFUL SYSTEMS PRIVATE LIMITED",
"TACTICA CAPITAL MANAGEMENT PRIVATE LIMITED",
"TACTICAL LOGISTICS PRIVATE LIMITED",
"TACTICAL SYSTEMS PRIVATE LIMITED",
"TACTICAL VALUE TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"TACTICIAL SERVICES PRIVATE LIMITED",
"TACTILE SOFTWARE & SOLUTION PRIVATE LIMITED",
"TACTIVE SOFTWARE SYSTEMS PRIVATE LIMITED",
"TACTREU SERVICES PRIVATE LIMITED",
"TACTWISE ADVISORY SOLUTIONS PRIVATE LIMITED",
"TADANO CRANES INDIA PRIVATE LIMITED",
"TADANO ESCORTS INDIA PRIVATE LIMITED",
"TADAS WIND ENERGY LIMITED",
"TADAS WIND ENERGY PRIVATE LIMITED",
"TADE POWERTECH PRIVATE LIMITED",
"TADIKONDA EXPORTS PRIVATE LIMITED",
"TADIMETY AROMATICS PRIVATE LIMITED",
"TADPOLE ENGINEERING CONSULTANCY PRIVATE LIMITED",
"TADPOLE INTERACTIVE PRIVATE LIMITED",
"TAE HWA ENTERPRISES INDIA PRIVATE LIMITED",
"TAEGUTEC INDIA PRIVATE LIMITED",
"TAEIN CONSTRUCTION AND INFRASTRUCTURE PRIVATE LIMITED",
"TAESUNG AUTOIND PRIVATE LIMITED",
"TAEWOONG LOGISTICS PRIVATE LIMITED",
"TAEYANG METAL INDIA PRIVATE LIMITED",
"TAFA AGRITECH PRIVATE LIMITED",
"TAFE ACCESS LIMITED",
"TAFE LIMITED",
"TAFE MOTORS AND TRACTORS LIMITED",
"TAFE REACH LIMITED",
"TAFECON PRIVATE LIMITED",
"TAFFLES ADVISORY SERVICES PRIVATE LIMITED",
"TAFFLES EXPORTS PRIVATE LIMITED",
"TAFFLES PROJECTS PRIVATE LIMITED",
"TAFFLES TRADING SERVICES PRIVATE LIMITED",
"TAFNE OVERSEAS EDUCATION PRIVATE LIMITED",
"TAFREEH STUDIOS PRIVATE LIMITED",
"TAG ASSESSORS GUILD PRIVATE LIMITED",
"TAG CHEMICALS INDIA PRIVATE LIMITED",
"TAG CORPORATION",
"TAG DEVELOPERS PVT LTD",
"TAG GLASS P LTD",
"TAG INDIA PRIVATE LIMITED",
"TAG INGREDIENTS INDIA PRIVATE LIMITED",
"TAG MOTORS LIMITED",
"TAG POLYMERS INDUSTRIES PRIVATE LIMITED",
"TAG SEEDS PRIVATE LIMITED",
"TAG VACATION INDIA LIMITED",
"TAGBOX SOLUTIONS PRIVATE LIMITED",
"TAGFACT SERVICES PRIVATE LIMITED",
"TAGG TELESERVICES PRIVATE LIMITED",
"TAGGART CONTINUUM INDIA SOLUTIONS PRIVATE LIMITED",
"TAGGLABS EXPERIENTIAL PRIVATE LIMITED",
"TAGID SOLUTIONS PRIVATE LIMITED",
"TAGINDIA CONSULTANCY SERVICES PRIVATE LIMITED",
"TAGIT INDIA PRIVATE LIMITED",
"TAGJOY CONSULTANTS PRIVATE LIMITED",
"TAGLINE INFOTECH LLP",
"TAGLINE TRADERS PRIVATE LIMITED",
"TAGLOY MEDIA PRIVATE LIMITED",
"TAGLYNK CAREERS PRIVATE LIMITED",
"TAGMANGO PRIVATE LIMITED",
"TAGNOS-IND PRIVATE LIMITED",
"TAGNPIN WEB SOLUTIONS LLP",
"TAGOOR AQUA TECHNOLOGIES PRIVATE LIMITED",
"TAGOOR CHEMICALS PRIVATE LIMITED",
"TAGOOR LABORATORIES PRIVATE LIMITED",
"TAGORE COLLEGE OF ARTS & SCIENCE",
"TAGORE COLLEGE OF NURSING",
"TAGORE ENGINEERING COLLEGE",
"TAGORE GLOBAL SCHOOL",
"TAGORE HOSPITAL & HEART CARE CENTRE PRIVATE LIMITED",
"TAGORE HOSPITAL AND NURSING HOME PVT LTD",
"TAGORE HOSPITAL RESEARCH INSTITUTE",
"TAGORE INTERNATIONAL SCHOOL",
"TAGORE MATRICULATION HIGHER SECONDARY SCHOOL",
"TAGORE MEDICAL COLLEGE AND HOSPITAL",
"TAGORE PUBLIC SCHOOL",
"TAGORE SR SEC SCHOOL",
"TAGRA PLASTICS PRIVATE LIMITED",
"TAGREM INDIA PRIVATE LIMITED",
"TAGROS CHEMICALS INDIA PRIVATE LIMITED",
"TAGS PROJECTS PRIVATE LIMITED",
"TAHA CARBO MODIFIERS PRIVATE LIMITED",
"TAHA JARI COPPER PRIVATE LIMITED",
"TAHAFET FIBER EXPORTS PRIVATE LIMITED",
"TAHAL CONSULTING ENGINEERS INDIA PRIVATE LIMITED",
"TAHAL CONSULTING ENGINEERS LIMITED",
"TAHASIL OFFICE BEED",
"TAHASIL OFFICE DAUND",
"TAHASIL OFFICE KOREGAON",
"TAHASILDAR ASTARANGA PURI",
"TAHASILDAR BHAGWANPURA",
"TAHASILDAR BHIKANGAON",
"TAHASILDAR GOGANWA",
"TAHASILDAR ZIRNIYA MADHYA PRAEDSH",
"TAHER & HUSAIN ADAMALI ADENWALA HIGH SCHOOL",
"TAHERA BEGUM URDU HIGH SCHOOL",
"TAHILIANI DESIGN PRIVATE LIMITED",
"TAHIRA INDUSTRIES (INDIA) PRIVATE LIMITED",
"TAHMAR ENTERPRISES LIMITED",
"TAHSEEL SIRAULIGAUS PUR BBK",
"TAHSIL OFFICE ARVI",
"TAHSIL OFFICE AURANGABAD",
"TAHSIL OFFICE AUSA",
"TAHSIL OFFICE CHAKUR",
"TAHSIL OFFICE HINGNA",
"TAHSIL OFFICE JALNA",
"TAHSIL OFFICE KAMPTEE",
"TAHSIL OFFICE KATOL",
"TAHSIL OFFICE NARKHED",
"TAHSIL OFFICE SHINDHKHEDA",
"TAHSIL OFFICE SHINDKHEDA",
"TAHSIL OFFICE SHIRALA",
"TAHSIL OFFICE SOEYGAON",
"TAHSILDAR AMRAVATI",
"TAHSILDAR CHANDURBAZAR",
"TAHSILDAR KESLI MP",
"TAHSILDAR KORPANA",
"TAHSILDAR MUL",
"TAHSILDAR NAGOD",
"TAHSILDAR NER DIST YAVATMAL",
"TAHSILDAR PARASIA",
"TAHSILDAR SANGLI",
"TAHSILDAR SHAHPURA",
"TAHSILDAR SHYAMPUR MADHYA PRADESH",
"TAHSILDAR SONKACHHA",
"TAHUMO EXPORTS PRIVATE LIMITED",
"TAI ENGINEERS INDIA PRIVATE LIMITED",
"TAI INDUSTRIES LIMITED.",
"TAI JETS PRIVATE LIMITED",
"TAICHUANG ENGINEERING INDIA PRIVATE LIMITED",
"TAIG FASHION PROFILES PRIVATE LIMITED",
"TAIGA KNITWEAR PRIVATE LIMITED",
"TAIGA READY MIX PRIVATE LIMITED",
"TAIIN STEEL FAB AND INFRA PRIVATE LIMITED",
"TAIKAI ELECTRIC (INDIA) PRIVATE LIMITED",
"TAIKISHA ENGINEERING INDIA PRIVATE LIMITED",
"TAILHUB PRIVATE LIMITED",
"TAILOR AND CIRCUS CLOTHING PRIVATE LIMITED",
"TAILORBIRD TRADING PRIVATE LIMITED",
"TAILORS CREATION INDIA PRIVATE LIMITED",
"TAILORS POINT PRIVATE LIMITED",
"TAILORSOFT PRIVATE LIMITED",
"TAILSTORM HEALTH INDIA PRIVATE LIMITED",
"TAINMO ENVIRONMENTAL INDIA PRIVATE LIMITED",
"TAINWALA CHEMICALS AND PLASTICS INDIA LIMITED",
"TAINWALA HOLDINGS PRIVATE LIMITED",
"TAINWALA PERSONAL CARE PRODUCTS PRIVATE LIMITED",
"TAIPAN ASSOCIATES PVT LTD",
"TAIPAN EXPORTS PRIVATE LIMITED",
"TAISAL TRADING LIMITED",
"TAISEI ONCHO INDIA PRIVATE LIMITED",
"TAISEI TECHNICAL SERVICES PRIVATE LIMITED",
"TAISEI TRADING PRIVATE LIMITED",
"TAISHO VENTURES PRIVATE LIMITED",
"TAISYS INDIA PRIVATE LIMITED",
"TAITON HARDWARE PRIVATE LIMITED",
"TAIYANGXI PROPERTIES & INFRASTRUCTURE PRIVATE LIMITED",
"TAIYEBIYAH GIRLS HIGH SCHOOL",
"TAIYEBJI WIRES PRIVATE LIMITED",
"TAIYO FEED MILL PRIVATE LIMITED",
"TAIYO GOLD AGRI BIOTECH INDIA PRIVATE LIMITED",
"TAIYO INDIA PRIVATE LIMITED",
"TAIYO KAGAKU INDIA PRIVATE LIMITED",
"TAIYO NIPPON SANSO INDIA PRIVATE LIMITED",
"TAIYOU AUTOMATION PRIVATE LIMITED",
"TAIYUAN HEAVY INDUSTRY (INDIA) PRIVATE LIMITED",
"TAIYUNG SOLAR PROJECTS PRIVATE LIMITED",
"TAJ AGRO COMMODITIES PRIVATE LIMITED",
"TAJ AIR LIMITED",
"TAJ CATERERS PRIVATE LIMITED",
"TAJ CHANDIGARH",
"TAJ COMPUTER SOLUTIONS PRIVATE LIMITED",
"TAJ COROMANDEL",
"TAJ COTTON FABRICS PRIVATE LIMITED",
"TAJ EDUGLOBE LIMITED",
"TAJ ENTERPRISES LIMITED",
"TAJ FLEXIPLAST PRIVATE LIMITED",
"TAJ FORGING PRIVATE LIMITED",
"TAJ FOUNDATIONS PRIVATE LIMITED",
"TAJ GRANITES PVT.LTD.",
"TAJ GROUP",
"TAJ GVK HOTELS AND RESORTS LIMITED",
"TAJ HI-TECH COATING PRIVATE LIMITED",
"TAJ HOTELS",
"TAJ INDUSTRIES PRIVATE LIMITED",
"TAJ IRON AND STEEL WORKS PRIVATE LIMITED",
"TAJ KARNATAKA HOTELS AND RESORTS LIMITED",
"TAJ KERALA HOTELS AND RESORTS LTD",
"TAJ LAKEFRONT BHOPAL",
"TAJ MADRAS FLIGHT KITCHEN PRIVATE LIMITED",
"TAJ MADURAI LIMITED",
"TAJ MAHAL GOLD SUPERMARKET PRIVATE LIMITED",
"TAJ METALS PRIVATE LIMITED",
"TAJ NEEDLE CRAFT PRIVATE LIMITED",
"TAJ PLASTIC UDYOG PRIVATE LIMITED",
"TAJ PLYBOARDS PRIVATE LIMITED",
"TAJ PNEUMATIC PRIVATE LIMITED",
"TAJ REALBUILD PRIVATE LIMITED",
"TAJ RELOCATIONS PRIVATE LIMITED",
"TAJ RESTAURANT",
"TAJ SAFARIS LIMITED",
"TAJ SATS AIR CATERING LIMITED",
"TAJ SKYLINE AHMEDABAD",
"TAJ TECHNO",
"TAJ TELEVISION INDIA PRIVATE LIMITED",
"TAJ TRADE & TRANSPORT COMPANY LIMITED",
"TAJ TRAVELS PRIVATE LIMITED",
"TAJALLI TECH PRIVATE LIMITED",
"TAJASVI ESTATE PRIVATE LIMITED",
"TAJINTL FOOD SERVICES INDIA PRIVATE LIMITED",
"TAJIR PRIVATE LIMITED",
"TAJNA RIVER INDUSTRIES PRIVATE LIMITED",
"TAJNA SHELLAC PVT LTD",
"TAJONLINE INDIA PRIVATE LIMITED",
"TAJPURIA INDUSTRIES PRIVATE LIMITED",
"TAJPURIA VENEER PRIVATE LIMITED",
"TAJSHREE AUTOWHEELS PRIVATE LIMITED",
"TAJURBA BUSINESS NETWORK PRIVATE LIMITED",
"TAK BUILDTECH PRIVATE LIMITED",
"TAK BUS OPERATIONS PRIVATE LIMITED",
"TAK CONSULTING PRIVATE LIMITED",
"TAK TECHNOLOGIES PRIVATE LIMITED",
"TAKAHATA PRECISION INDIA PRIVATE LIMITED",
"TAKALKAR CLASSES PRIVATE LIMITED",
"TAKALKAR POWER ENGINEERS & CONSULTANTS PRIVATE LIMITED",
"TAKANG GLOBAL MACHINE TOOLS INDIA PRIVATE LIMITED",
"TAKASAGO INTERNATIONAL INDIA PRIVATE LIMITED",
"TAKE AGRO INDIA PRIVATE LIMITED",
"TAKE ONE JK MEDIA PRIVATE LIMITED",
"TAKE SOLUTIONS LIMITED",
"TAKE TWO INTERACTIVE INDIA PRIVATE LIMITED\n",
"TAKEDA BIOPHARMACEUTICALS INDIA PRIVATE LIMITED",
"TAKEKAR MOTORS PRIVATE LIMITED",
"TAKEMOTO YOHKI INDIA PRIVATE LIMITED",
"TAKENAKA INDIA PRIVATE LIMITED",
"TAKHAT SACHKHAND SHRI HAZUR ABCHAL NAGAR NANDED",
"TAKI GOVT COLLEGE",
"TAKI HOUSE GOVT SPONSORED H S INSTITUTE",
"TAKIAR OVERSEAS PRIVATE LIMITED",
"TAKII SEEDS INDIA PRIVATE LIMITED",
"TAKK STUDIO PRIVATE LIMITED",
"TAKLE JEWELLERS PRIVATE LIMITED",
"TAKMIN TRADING PVT LTD",
"TAKNEK AUTOMATION SYSTEM PRIVATE LIMITED",
"TAKO MEGA CONSTRUCTION PRIVATE LIMITED",
"TAKRAF INDIA PRIVATE LIMITED",
"TAKSALI LOGISTICS PRIVATE LIMITED",
"TAKSH JEWELS PRIVATE LIMITED",
"TAKSH LIFESCIENCES PRIVATE LIMITED",
"TAKSH MEDIA PRIVATE LIMITED",
"TAKSH REALTECH PRIVATE LIMITED",
"TAKSH STRUCTBUILD PRIVATE LIMITED",
"TAKSHAKA INTERIORS PRIVATE LIMITED",
"TAKSHARYA FOOD WORKS PRIVATE LIMITED",
"TAKSHASHILA DEVELOPERS PRIVATE LIMITED",
"TAKSHASHILA EDUPUNK PRIVATE LIMITED",
"TAKSHASHILA MANAGEMENT CONSULTING PRIVATE LIMITED",
"TAKSHASHILA PROJECTS PRIVATE LIMITED",
"TAKSHASILA HOSPITALS OPERATING PRIVATE LIMITED",
"TAKSHASILA PUBLIC SCHOOL",
"TAKSHI AUTO COMPONENTS PRIVATE LIMITED",
"TAKSHILA FOODS PRIVATE LIMITED",
"TAKSHILA INSTITUTE",
"TAKSHILA PUBLIC SCHOOL",
"TAKSHILA SCHOOL AHMEDNAGAR",
"TAKSHILA TEXTILES PRIVATE LIMITED",
"TAKSHITAM PRIVATE LIMITED",
"TAKSHVI INFRA PRIVATE LIMITED",
"TAKSUS STEELS PRIVATE LIMITED",
"TAKULA HEALTH OFFICE PALSANA",
"TAKUMI INTERNATIONAL PRIVATE LIMITED",
"TAKVAVIYA ANALYTICS PRIVATE LIMITED",
"TAKWEEN INDUSTRIES PRIVATE LIMITED",
"TAKYON NETWORKS PRIVATE LIMITED",
"TAKYON SYSTEM SOLUTIONS PRIVATE LIMITED",
"TAL EXPORTS PRIVATE LIMITED",
"TAL SALES PVT LTD",
"TALA PROPERTIES PRIVATE LIMITED",
"TALABIRA (ODISHA) MINING PRIVATE LIMITED",
"TALAKUNCHI NETWORKS PRIVATE LIMITED",
"TALAMPALLY INFRA PRIVATE LIMITED",
"TALAMPALLY POWER CORPORATION PRIVATE LIMITED",
"TALANK TRADEX PRIVATE LIMITED",
"TALASCEND INDIA PRIVATE LIMITED",
"TALASH INFOSOFT PRIVATE LIMITED",
"TALASRI STEELS PVT LTD",
"TALAT INTERNATIONAL (INDIA) PRIVATE LIMITED",
"TALATI & TALATI LLP",
"TALATI AND PANTHAKY ASSOCIATED PRIVATE LIMITED",
"TALATI ELECTRIC WORKS PRIVATE LIMITED",
"TALATI FOODS PRIVATE LIMITED",
"TALATI KITCHEN DESIGN (INDIA) PRIVATE LIMITED",
"TALAYAR TEA COMPANY LIMITED",
"TALBOTFORCE SERVICES PRIVATE LIMITED",
"TALBROS AUTOMOTIVE COMPONENTS LIMITED",
"TALBROS ENGINEERING LIMITED",
"TALBROS FOODS PRIVATE LIMITED",
"TALBROS INDIPARTS PRIVATE LIMITED",
"TALBROS INTERNATIONAL PRIVATE LIMITED",
"TALBROS MARUGO RUBBER PRIVATE LIMITED",
"TALBROS SEALING MATERIALS PRIVATE LIMITED",
"TALCEM CASTINGS PRIVATE LIMITED",
"TALCHER FERTILIZERS LIMITED",
"TALDAR HOTELS AND RESORTS PRIVATE LIMITED",
"TALDI MOHAN CHAND HIGH SCHOOL HS",
"TALEEM RESEARCH FOUNDATION",
"TALEGAONKAR LASER PRIVATE LIMITED",
"TALEGAONKAR PROFILES PRIVATE LIMITED",
"TALEMA ELECTRONIC INDIA PRIVATE LIMITED",
"TALEND DATA INTEGRATION SERVICES PRIVATE LIMITED",
"TALENDROID TECHNOLOGIES PRIVATE LIMITED",
"TALENSETU SERVICES PRIVATE LIMITED",
"TALENT AND SKILLS LABS PRIVATE LIMITED",
"TALENT ANYWHERE SERVICES PRIVATE LIMITED",
"TALENT BAZAAR PRIVATE LIMITED",
"TALENT CAPITAL INDIA PRIVATE LIMITED",
"TALENT COLLABORATORY INDIA PRIVATE LIMITED",
"TALENT CONNECTED WORLDWIDE INDIA PRIVATE LIMITED",
"TALENT CORNER HR SERVICES PRIVATE LIMITED",
"TALENT CORP MULTI SERVICES",
"TALENT DIMENSION TECHNICAL SERVICES PRIVATE LIMITED",
"TALENT FINDER CONSULTANTS PRIVATE LIMITED (OPC)",
"TALENT FORMULA PRIVATE LIMITED",
"TALENT GARMENT'S PRIVATE LIMITED",
"TALENT HIRED THE JOB STORE PRIVATE LIMITED",
"TALENT HR NETWORKS PRIVATE LIMITED",
"TALENT HUB SERVICES PRIVATE LIMITED",
"TALENT INDIA PRIVATE LIMITED",
"TALENT INVIGORATION AND SPORTS MANAGEMENT PRIVATE LIMITED",
"TALENT LABS PRIVATE LIMITED",
"TALENT MAXIMUS INDIA PRIVATE LIMITED",
"TALENT MAXIMUS PAYROLL SERVICES PRIVATE LIMITED",
"TALENT MOSAIC PRIVATE LIMITED",
"TALENT PARTNERS CONSULTANCY PRIVATE LIMITED",
"TALENT POWER CONSULTING SERVICES PRIVATE LIMITED",
"TALENT PRO INDIA HR PRIVATE LIMITED",
"TALENT RECRUIT SOFTWARE PRIVATE LIMITED",
"TALENT RESOURCE CONSULTING PRIVATE LIMITED",
"TALENT ROVER INDIA PRIVATE LIMITED",
"TALENT STOCK SOLUTIONS",
"TALENT TOPPERS LLP",
"TALENT UNLIMITED ONLINE SERVICES PRIVATE LIMITED",
"TALENT ZONE PRIVATE LIMITED",
"TALENT21 MANAGEMENT AND SHARED SERVICES PRIVATE LIMITED",
"TALENT4ASSURE ASSESSMENT SERVICES PRIVATE LIMITED",
"TALENT4ASSURE TEST SERVICES PRIVATE LIMITED",
"TALENTAHEAD INDIA PRIVATE LIMITED",
"TALENTAIN TECHNOLOGIES PRIVATE LIMITED",
"TALENTAS TECHNOLOGY PRIVATE LIMITED",
"TALENTBEACON HR SOLUTIONS PRIVATE LIMITED",
"TALENTBRIDGE TECHNOLOGIES PRIVATE LIMITED",
"TALENTBURST INDIA PRIVATE LIMITED",
"TALENTCAFE SOLUTIONS LLP",
"TALENTEAST STAFFING SERVICES PRIVATE LIMITED",
"TALENTECH SOLUTIONS PRIVATE LIMITED",
"TALENTEL PLATFORMS PRIVATE LIMITED",
"TALENTELGIA TECHNOLOGIES PRIVATE LIMITED",
"TALENTEQ TECHNOLOGY INDIA PRIVATE LIMITED",
"TALENTHOUSE ENTERTAINMENT PRIVATE LIMITED",
"TALENTI HR CONSULTING PRIVATE LIMITED",
"TALENTIA EXECUTIVE SEARCH & SOLUTIONS INDIA (OPC) PRIVATE LIMITED",
"TALENTICA SOFTWARE INDIA PRIVATE LIMITED",
"TALENTICK EDUSOLUTIONS PRIVATE LIMITED",
"TALENTIKA BUSINESS SOLUTIONS LLP",
"TALENTIO SOLUTIONS INDIA PRIVATE LIMITED",
"TALENTIQO WORKFORCE AND RPO PRIVATE LIMITED",
"TALENTLOGIC INFO SERVICES PRIVATE LIMITED",
"TALENTMETRIX & CONSULTING PRIVATE LIMITED",
"TALENTMICRO INNOVATIONS PRIVATE LIMITED",
"TALENTMINT CONSULTING PRIVATE LIMITED",
"TALENTNOW SOLUTION SERVICES PRIVATE LIMITED",
"TALENTO CONSULTING PRIVATE LIMITED",
"TALENTO TECHNICAL PLANT SERVICES PRIVATE LIMITED",
"TALENTOLA SOLUTIONS PRIVATE LIMITED",
"TALENTONIC HR SOLUTIONS PRIVATE LIMITED",
"TALENTOS (INDIA) PRIVATE LIMITED",
"TALENTPATH MANAGEMENT SERVICES PRIVATE LIMITED",
"TALENTPLOYER PRIVATE LIMITED",
"TALENTPRO INDIA FOUNDATION",
"TALENTPRO INDIA HR PRIVATE LIMITED",
"TALENTPULL AND INFRASTRUCTURE PRIVATE LIMITED",
"TALENTQUEST SOLUTIONS PRIVATE LIMITED",
"TALENTRACKR TECHNOLOGIES PRIVATE LIMITED",
"TALENTRUPT RPO LLP",
"TALENTS CREED SOLUTIONS PRIVATE LIMITED",
"TALENTSERV CONSULTING PRIVATE LIMITED",
"TALENTSPRINT PRIVATE LIMITED",
"TALENTSTOCK",
"TALENTTRIBE CONSULTING PRIVATE LIMITED",
"TALENTXPERT SERVICES PRIVATE LIMITED",
"TALERA AUTOMOBILES PRIVATE LIMITED",
"TALERA MOTORS PRIVATE LIMITED",
"TALES & SPIRITS HOSPITALITY PRIVATE LIMITED",
"TALES & STORIES DENIM COMPANY PRIVATE LIMITED",
"TALES FROM INDIA TOURS PRIVATE LIMITED",
"TALESARA INT COLL TALESARA",
"TALESARA MARBLE AND TILES PRIVATE LIMITED",
"TALESH ENTERPRISES PRIVATE LIMITED",
"TALETTUTAYI SOLAR PROJECTS FIVE PRIVATE LIMITED",
"TALETTUTAYI SOLAR PROJECTS FOUR PRIVATE LIMITED",
"TALETTUTAYI SOLAR PROJECTS ONE PRIVATE LIMITED",
"TALETTUTAYI SOLAR PROJECTS PRIVATE LIMITED",
"TALETTUTAYI SOLAR PROJECTS SIX PRIVATE LIMITED",
"TALETTUTAYI SOLAR PROJECTS TWO PRIVATE LIMITED",
"TALF ASR SOLAR URJA PRIVATE LIMITED",
"TALF SAUR URJA PRIVATE LIMITED",
"TALF SOLAR INDIA PRIVATE LIMITED",
"TALFORCE SERVICES PRIVATE LIMITED",
"TALGO INDIA PRIVATE LIMITED",
"TALGROW AGRI TRADING PRIVATE LIMITED",
"TALI ENTERPRISES PRIVATE LIMITED",
"TALIANNA CONSULTANTS PRIVATE LIMITED",
"TALIB AND SHAMSI CONSTRUCTIONS PRIVATE LIMITED",
"TALIFIC CONSULTING SERVICES PRIVATE LIMITED",
"TALIMUL QURAN RAHMANIA",
"TALIN INTERNATIONAL PRIVATE LIMITED",
"TALIN MODULAR OFFICE FURNITURE SYSTEMS PRIVATE LIMITED",
"TALIN REMEDIES PRIVATE LIMITED",
"TALISMA CORPORATION PRIVATE LIMITED",
"TALISMAN ADVISORS PRIVATE LIMITED",
"TALISMAN EDUCATION SOLUTIONS PRIVATE LIMITED",
"TALISMAN HOSPITALITY SERVICES PRIVATE LIMITED",
"TALISMAN HR SOLUTIONS PRIVATE LIMITED",
"TALISMAN SECURITIES PRIVATE LIMITED",
"TALK TALK COMMUNICATION LLP",
"TALKATORA INVESTMENTS AND TRADING CO PRIVATE LIMITED",
"TALKCHARGE TECHNOLOGIES PRIVATE LIMITED",
"TALKD PRIVATE LIMITED",
"TALKING TECHNOLOGY PRIVATE LIMITED",
"TALL TALES PRODUCTION PRIVATE LIMITED",
"TALL TREES HOTELS PRIVATE LIMITED",
"TALLA JEWELLERS PRIVATE LIMITED",
"TALLAM INVESTMENTS PRIVATE LIMITED",
"TALLAMPALLY RUBBERS PRIVATE LIMITED",
"TALL-STEEDS TRADECOM PRIVATE LIMITED",
"TALLURI SOLUTIONS",
"TALLURI TECHNOLOGIES PRIVATE LIMITED",
"TALLURI TEXTILES PRIVATE LIMITED",
"TALLY EDUCATION PRIVATE LIMITED",
"TALLY INDIA PRIVATE LIMITED",
"TALLY SOLUTIONS PRIVATE LIMITED",
"TALOD FOOD PRODUCTS PRIVATE LIMITED",
"TALODYN NETWORKS PRIVATE LIMITED",
"TALOJA AGRO FOODS PRIVATE LIMITED",
"TALOJA FORGINGS PRIVATE LIMITED",
"TALOJA STEEL SERVICE CENTRE LIMITED",
"TALPUR PATHSALA HS",
"TALRAK CONSTRUCTION CHEMICALS PRIVATE LIMITED",
"TALREJA MINERALS PRIVATE LIMITED",
"TALREJA TEXTILES INDUSTRIES PRIVATE LIMITED",
"TALUKA AGRICULTURAL OFFICER",
"TALUKA AROGYA KACHERI KAMREJ",
"TALUKA DEVELOPMENT OFFICE",
"TALUKA HEALTH OFFICE DHROL",
"TALUKA HEALTH OFFICE BHESAN",
"TALUKA HEALTH OFFICE CHHOTAUDAIPUR",
"TALUKA HEALTH OFFICE DHRANGADHARA",
"TALUKA HEALTH OFFICE GARUDESHWER",
"TALUKA HEALTH OFFICE JALALPORE",
"TALUKA HEALTH OFFICE JAMJODHPUR",
"TALUKA HEALTH OFFICE KALWAD",
"TALUKA HEALTH OFFICE KARJAN",
"TALUKA HEALTH OFFICE KHAMBHAT",
"TALUKA HEALTH OFFICE KHEDA",
"TALUKA HEALTH OFFICE LALPUR",
"TALUKA HEALTH OFFICE MALIYA",
"TALUKA HEALTH OFFICE MANGROL",
"TALUKA HEALTH OFFICE NAVSARI",
"TALUKA HEALTH OFFICE PRANTIJ",
"TALUKA HEALTH OFFICE SIHOR",
"TALUKA HEALTH OFFICE SONGADH",
"TALUKA HEALTH OFFICE TALOD",
"TALUKA HEALTH OFFICER CHUDA",
"TALUKA HEALTH OFFICER DASCROI",
"TALUKA HEALTH OFFICER DASKROI",
"TALUKA HEATH OFFICE WADHWAN",
"TALUKA INSPECTOR OF LAND RECORDS KOREGAON",
"TALUKA PANCHAYANT LAKHPAT-KUTCH",
"TALUKA PANCHAYAT BAVLA",
"TALUKA PANCHAYAT KACHERI CHIKHLI I R D P TA CHIKHLI DIST NAVSARI",
"TALUKA PANCHAYAT KACHERI MAHUA",
"TALUKA PANCHAYAT KACHERI RAJKOT",
"TALUKA PANCHAYAT KACHERI SUTRAPADA",
"TALUKA PANCHAYAT OFFICE JETPUR",
"TALUKA PRIMARY EDUCATION OFFICE SAGBARA",
"TALUKA SCHOOL NO 3 DHORAJI",
"TALWANDI SABO POWER LIMITED",
"TALWAR & KHULLAR PRIVATE LIMITED",
"TALWAR & TALWAR CONSULTANTS PRIVATE LIMITED",
"TALWAR AND TALWAR CONSULTANTS AND SERVICES PRIVATE LIMITED",
"TALWAR AUTO GARAGES PRIVATE LIMITED",
"TALWAR BROTHERS PRIVATE LIMITED",
"TALWAR COMMERCIAL PRIVATE LIMITED",
"TALWAR ENTERPRISES PRIVATE LIMITED",
"TALWAR JEWELLERS",
"TALWAR MARKETING PRIVATE LIMITED",
"TALWAR MOBILES PRIVATE LIMITED",
"TALWAR MOTORS PRIVATE LIMITED",
"TAM INDIA PRIVATE LIMITED",
"TAM LOGISTICS PRIVATE LIMITED",
"TAM MEDIA",
"TAM MEDIA RESEARCH PRIVATE LIMITED",
"TAMADA MEDIA PRIVATE LIMITED",
"TAMANNA COMMOSALES PRIVATE LIMITED",
"TAMANNA DE BOUTIQUE PRIVATE LIMITED",
"TAMANNA DEVELOPERS PRIVATE LIMITED",
"TAMANNA HOTELS PRIVATE LIMITED",
"TAMANNA INTERNATIONALS PRIVATE LIMITED",
"TAMANNA SCHOOL FOR SPECIALLY ABLED CHILDREN",
"TAMANNA SOLUTIONS PRIVATE LIMITED",
"TAMARA LANDSCAPE PRIVATE LIMITED",
"TAMARA LEISURE EXPERIENCES PRIVATE LIMITED",
"TAMARAI DRUGS PRIVATE LIMITED",
"TAMARAI HOMES PRIVATE LIMITED",
"TAMARIN CLOTHING (INDIA) PRIVATE LIMITED",
"TAMARIN CLOTHING INDIA PRIVATE LIMITED",
"TAMARIND FOODS & ENTERTAINMENT PRIVATE LIMITED",
"TAMARIND GLOBAL SERVICES PRIVATE LIMITED",
"TAMARIND HOSPITALITY PRIVATE LIMITED",
"TAMARUGATAM PHARMACEUTICALS PRIVATE LIMITED",
"TAMASHA WORLDWIDE ENTERTAINMENT PRIVATE LIMITED",
"TAMASI INFRACON PRIVATE LIMITED",
"TAMBEE ENGINEERING PRIVATE LIMITED",
"TAMBOLI CASTINGS LIMITED",
"TAMBOLI CORPORATION PRIVATE LIMITED",
"TAMBOLI ENGINEERS PRIVATE LIMITED",
"TAMBOLI ENTERPRISE LIMITED",
"TAMBOLI INDUSTRIES LIMITED",
"TAMBORA SYSTEMS INDIA PRIVATE LIMITED",
"TAM-BRAN PHARMACEUTICALS PRIVATE LIMITED",
"TAMCHERRY TECHNOLOGIES PRIVATE LIMITED",
"TAMEER CONSTRUCTIONS PRIVATE LIMITED",
"TAMEER INFRADEVELOPERS PRIVATE LIMITED",
"TAMIL NAADU EDIBLE OILS PRIVATE LIMITED",
"TAMIL NADU AGRICLUTURAL UNIVERSITY - COI",
"TAMIL NADU CENTRE OF EXCELLENCE FOR ADVANCED MANUFACTURING",
"TAMIL NADU COLLEGE OF ARTS AND SCIENCE",
"TAMIL NADU CORP FOR DEVP WOMEN LIMITED",
"TAMIL NADU ELECTRICITY REGULATORY COMMISSION",
"TAMIL NADU FIBRENET CORPORATION LIMITED",
"TAMIL NADU HEAT TREATMENT AND FITTINGS P",
"TAMIL NADU HOUSING BOARD",
"TAMIL NADU INFRASTRUCTURE FUND MANAGEMENT CORPORATION LIMITED",
"TAMIL NADU INSTITUTE OF LABOUR STUDIES",
"TAMIL NADU MEDICAL SERVICES CORPORATION LIMITED",
"TAMIL NADU MERCANTILE BANK",
"TAMILNADU NEWSPRINT & PAPERS LIMITED",
"TAMIL NADU PHYSICAL EDUCATION AND SPORTS UNIVERSITY",
"TAMIL NADU POLLUTION CONTROL BOARD",
"TAMIL NADU REAL ESTATES PRIVATE LIMITED",
"TAMIL NADU SIDDHA MEDICAL COUNCIL",
"TAMIL NADU SKILL DEVELOPMENT CORPORATION",
"TAMIL NADU STATE TRANSPORT CORPORATION (MADURAI) LIMITED",
"TAMIL NADU STATE TRANSPORT CORPORATION (TIRUNELVELI) LIMITED",
"TAMIL NADU STATE TRANSPORT CORPORATION (VILLUPURAM) LIMITED",
"TAMIL NADU STATE TRANSPORT CORPORATION-SALEM LIMITED.",
"TAMIL NADU VETERINARY AND ANIMAL SCIENCES UNIVERSITY",
"TAMIL NADU WATER INVESTMENT COMPANY LIMITED",
"TAMILA TEXTILES PRIVATE LIMITED",
"TAMILAN KALAI KOODAM PRIVATE LIMITED",
"TAMILDHANAM MOTORS PRIVATE LIMITED",
"TAMILNAD KIDNEY RESEARCH FOUNDATION",
"TAMILNAD MERCANTILE BANK LIMITED",
"TAMILNAD TOOLS PRIVATE LIMITED",
"TAMILNADU ADIDRAVIDAR HOUSING AND DEVELOPMENT CORPORATION LIMITED",
"TAMILNADU ARASU CABLE T.V. CORPORATION PUBLIC LIMITED",
"TAMILNADU CEMENTS CORPORATION LIMITED",
"TAMILNADU CIVIL SUPPLIES CORP.",
"TAMILNADU COKE & POWER LIMITED",
"TAMILNADU COKE & POWER PRIVATE LIMITED",
"TAMILNADU COLLEGE OF ENGG",
"TAMILNADU CO-OP SUGAR FEDERATION LTD",
"TAMILNADU CO-OPERATIVE MILK PRODUCERS‚Äô FEDERATION LIMITED",
"TAMILNADU DR AMBEDKAR UNIVERSITY OF LAW",
"TAMILNADU DR J JAYALALITHAA FISHERIES UNIVERSITY",
"TAMILNADU ELECTRICITY BOARD",
"TAMILNADU EX-SERVICEMEN'S CORPORATION LIMITED",
"TAMILNADU FISHERIES DEVELOPMENT CORPORATION LIMITED",
"TAMILNADU FLORITECH PRIVATE LIMITED",
"TAMILNADU FOREST PLANTATION CORPORATION LIMITED",
"TAMILNADU GENERATION AND DISTRIBUTION CORPORATION LIMITED",
"TAMILNADU HANDICRAFTS DEVELOPMENT CORPORATION LIMITED",
"TAMILNADU HANDLOOM DEVELOPMENT CORPORATION LIMITED",
"TAMILNADU INDUSTRIAL DEVELOPMENT CORPORATION LIMITED",
"TAMILNADU INDUSTRIAL INVESTMENT CORPORATION LIMITED THE",
"TAMILNADU MAGNESITE LIMITED",
"TAMILNADU MEDICAL COLLEGE",
"TAMILNADU MEDICINAL PLANT FARMS AND HERBAL MEDICINES CORPORATION LIMITED",
"TAMILNADU MINERALS LIMITED",
"TAMILNADU MUSIC COLLEGE",
"TAMILNADU PADDY & RICE PROCESSING FEDERATION",
"TAMILNADU PETROPRODUCT LIMITED",
"TAMILNADU POLICE HOUSING CORPN. LTD.",
"TAMILNADU POWER FINANCE AND INFRASTRUCTURE DEVELOPMENT CORPORATION LIMITED",
"TAMILNADU SALT CORPORATION LIMITED",
"TAMILNADU SMALL INDUSTRIES DEVELOPMENT CORPORATION LIMITED",
"TAMILNADU STATE MARKETING CORPORATION LIMITED",
"TAMILNADU STATE TRANSPORT CORP",
"TAMILNADU STATE TRANSPORT CORPORATION (KUMBAKONAM) LIMITED",
"TAMILNADU SUGAR CORPORATION LIMITED",
"TAMILNADU SUSTAINABLE INDUSTRIAL WATER CORPORATION LIMITED",
"TAMILNADU SYNTHETIC PACKAGINGS LIMITED",
"TAMILNADU TEXTILE CORPORATION LIMITED",
"TAMILNADU TRADE PROMOTION ORGANISATION",
"TAMILNADU TRANSMISSION CORPORATION LIMITED",
"TAMILNADU TRANSPORT DEVELOPMENT FINANCE CORPORATION LIMITED",
"TAMILNADU URBAN FINANCE AND INFRASTRUCTURE DEVELOPMENT CORPORATION LIMITED",
"TAMILNADU URBAN INFRASTRUCTURE FINANCIAL SERVICES LIMITED",
"TAMILNADU WATERRESOURCESCONSERVATION & RIVERSRESTORATIONCORPORATION LIMITED",
"TAMINI TRASFORMATORI INDIA PRIVATE LIMITED",
"TAMIRA AESTHETIC HEALTH CARE AND LIFESTYLE PRIVATE LIMITED",
"TAMISER ADVISORS PRIVATE LIMITED",
"TAMIZHI FOODS PRIVATE LIMITED",
"TAMMAN TITOE PHARMA PRIVATE LIMITED",
"TAMOHARA INVESTMENT MANAGERS PRIVATE LIMITED",
"TAMPRA ESTATE PRIVATE LIMITED",
"TAMRA DHATU UDYOG PVT LTD",
"TAMRAG GREEN SOLUTIONS (INDIA) PRIVATE LIMITED",
"TAMRALIPTA CO-OPERATIVE SPINNING MILLS LTD",
"TAMRON INDIA PRIVATE LIMITED",
"TAMS GLOBAL PRIVATE LIMITED",
"TAMS INFOTECH PRIVATE LIMITED",
"TAMSYS INDIA PRIVATE LIMITED",
"TAMURA ELCOMPONICS TECHNOLOGIES PRIVATE LIMITED",
"TAMUSH PROJECTS PRIVATE LIMITED",
"TAN LEATHERS AND CHEMICALS PRIVATE LIMITED",
"TAN PRINTS (INDIA) PRIVATE LIMITED",
"TAN TECH MOULDS INDIA PRIVATE LIMITED",
"TAN90 THERMAL SOLUTIONS PRIVATE LIMITED",
"TANAJI MALUSARE MADHYAMIK VIDYALAYA KOYLARI",
"TANAJI'S CREATIVE TURNKEY PROJECTS PRIVATE LIMITED",
"TANAKA KIKINZOKU (INDIA) PRIVATE LIMITED",
"TANAM INVESTMENT SERVICES PRIVATE LIMITED",
"TANANYA EXIM PRIVATE LIMITED",
"TANASH FOOD PRODUCTS PRIVATE LIMITED",
"TANATEX CHEMICALS INDIA PRIVATE LIMITED",
"TANAY INFRASTRUCTURES LIMITED",
"TANAY SECURITIES & SERVICES PRIVATE LIMITED",
"TANAY TRADE LINKS PRIVATE LIMITED",
"TANAYU PHARMACEUTICAL PRIVATE LIMITED",
"TANAZ GODIWALLA FOODS PRIVATE LIMITED",
"TAN-B CONSTRUCTIONS",
"TANCATA COATS PRIVATE LIMITED",
"TANCO STEEL AND ENGG PVT LTD",
"TANCOM ELECTRONICS PRIVATE LIMITED",
"TANDBERG TECHNOLOGY INDIA PRIVATE LIMITED",
"TANDEM ACCOUNTING SERVICES PRIVATE LIMITED",
"TANDEM ALLIED SERVICES PRIVATE LIMITED",
"TANDEM CONSULTING PRIVATE LIMITED",
"TANDEM DATA PROCESSING PRIVATE LIMITED",
"TANDEM GLOBAL LOGISTICS INDIA PRIVATE LIMITED",
"TANDEM HEALTHCARE PROJECTS",
"TANDEM HYDRAULICS PRIVATE LIMITED",
"TANDEM MACHINES PRIVATE LIMITED",
"TANDHAN EXIM PRIVATE LIMITED",
"TANDHAN FASHION PRIVATE LIMITED",
"TANDHAN IMPEX PRIVATE LIMITED",
"TANDHAN POLYPLAST LIMITED",
"TANDON CHEMICALS PRIVATE LIMITED",
"TANDON CONSULTANTS PRIVATE LIMITED",
"TANDON HOLDINGS LIMITED",
"TANDON HOSPITALS PRIVATE LIMITED",
"TANDON INTERNATIONAL SCHOOL",
"TANDON MINES AND MINERALS PRIVATE LIMITED",
"TANDON URBAN SOLUTIONS PRIVATE LIMITED",
"TANDOORI NIGHTS GRAND CATERING SERVICES PRIVATE LIMITED",
"TANDS PROJECT MANAGEMENT SERVICES PRIVATE LIMITED",
"TANDT REALTECH PRIVATE LIMITED",
"TANDY INNOVATIVE CHEMICALS PRIVATE LIMITED",
"TANEJA AEROSPACE AND AVIATION LIMITED",
"TANEJA APPARELS PRIVATE LIMITED",
"TANEJA COLD STORAGE PRIVATE LIMITED",
"TANEJA COMPLETE HOME SOLUTIONS PRIVATE LIMITED",
"TANEJA GREAT INDUSTRIES LLP",
"TANEJA HANDLOOMS HOUSE PRIVATE LIMITED",
"TANEJA HEALTH SERVICES PRIVATE LIMITED",
"TANEJA HYBRID SEEDS PRIVATE LIMITED",
"TANEJA IRON & STEEL CO. LIMITED",
"TANEJA MILK & FOOD PRODUCTS PRIVATE LIMITED",
"TANEJA PROPERTIES PRIVATE LIMITED",
"TANEJA TYRES PRIVATE LIMITED",
"TANEJA VIDYUT CONTROL PRIVATE LIMITED",
"TANFAC APPARELS LIMITED",
"TANFAC INDUSTRIES LIMITED",
"TANFLORA INFRASTRUCTURE PARK LIMITED",
"TANGAR SHIP MANAGEMENT PRIVATE LIMITED",
"TANGATUR DIGITAL COMMUNICATIONS PRIVATE LIMITED",
"TANGENCE SOLUTIONS INDIA PRIVATE LIMITED",
"TANGENSIS IT SOLUTIONS PRIVATE LIMITED",
"TANGENT CHEMICALS PRIVATE LIMITED",
"TANGENT FILMS INDIA PRIVATE LIMITED",
"TANGENT INFOCOM PRIVATE LIMITED",
"TANGENT INFRATECH PRIVATE LIMITED",
"TANGENT INTERNATIONAL CONSULTANCY PRIVATE LIMITED",
"TANGENTIA INDIA TECHNOLOGIES PRIVATE LIMITED",
"TANGENTIA TRAVANCORE PRIVATE LIMITED",
"TANGENTTECH INFOSOFT PRIVATE LIMITED",
"TANGENZ INDIA PRIVATE LIMITED",
"TANGERINE DESIGN PRIVATE LIMITED",
"TANGERINE SKIES PRIVATE LIMITED",
"TANGFUR MALL PRIVATE LIMITED",
"TANGIAPPS IT SOLUTION PRIVATE LIMITED",
"TANGIBLE ASSIST INDIA PRIVATE LIMITED",
"TANGLE SOLUTIONS PRIVATE LIMITED",
"TANGLIN DEVELOPMENTS LIMITED",
"TANGO IT SOLUTIONS INDIA PRIVATE LIMITED",
"TANGO SOFTWARE SOLUTIONS PRIVATE LIMITED",
"TANGOE INDIA SOFTEK SERVICES PRIVATE LIMITED",
"TANGRA KAIZEN RESTAURANT PVT LTD",
"TANGRABICHI NEW FP PRIMARY SCHOOL",
"TANGUDU ASSOCIATES PRIVATE LIMITED",
"TANGY SUPPLIES & SOLUTIONS PRIVATE LIMITED",
"TANHAJI MALUSARE MADHYAMIK VIDYALAYA KOYLARI",
"TANIA INFRACON PRIVATE LIMITED",
"TANIA POLY FILMS PRIVATE LIMITED",
"TANIESH POWER SOLUTIONS PRIVATE LIMITED",
"TANIMA TECHNOLOGIES PRIVATE LIMITED",
"TANINDO SEED PRIVATE LIMITED",
"TANISH AGRISCIENCE PRIVATE LIMITED",
"TANISH AUTOCARS PRIVATE LIMITED",
"TANISH FORWARDERS PRIVATE LIMITED",
"TANISH INDUSTRIES PRIVATE LIMITED",
"TANISH SECURITY AND HOUSEKEEPING SERVICES PRIVATE LIMITED",
"TANISH TECHNOLOGIES PRIVATE LIMITED",
"TANISHA AUNIT ENGICON PRIVATE LIMITED",
"TANISHA HOUSING PRIVATE LIMITED",
"TANISHA RESINS PRIVATE LIMITED",
"TANISHA SYSTEMS PRIVATE LIMITED",
"TANISHA TRAVEL LINKS PRIVATE LIMITED",
"TANISHK INSTA TRUCKING SOLUTIONS PRIVATE LIMITED",
"TANISHKA AND TANISHKA ELECTRO TRADING PRIVATE LIMITED",
"TANISHKA ENTERPRISES",
"TANISHKA PHARMACEUTICALS PRIVATE LIMITED",
"TANISHKA REALTY & BROKERAGE PRIVATE LIMITED",
"TANISHKA SALES AND SERVICES PRIVATE LIMITED",
"TANISHQ INDUSTRIES PRIVATE LIMITED",
"TANISHQ PROPERTIES PRIVATE LIMITED",
"TANISHQ STEELS LIMITED",
"TANISHQUE INFRATECH PRIVATE LIMITED",
"TANISI DIGITAL INDIA PRIVATE LIMITED",
"TANISI IT SERVICES PRIVATE LIMITED",
"TANISKHA MACHINERY PRIVATE LIMITED",
"TANISUJAN INFRA PRIVATE LIMITED",
"TANIVI SOLAR PRIVATE LIMITED",
"TANIYA MACHINERY PRIVATE LIMITED",
"TANJANA ENTERPRISES PRIVATE LIMITED",
"TANJELS ELECTRICS",
"TANK TECH DEPOT PRIVATE LIMITED",
"TANKARIA INDUSTRIES PRIVATE LIMITED",
"TANKARIA VENTURES PRIVATE LIMITED",
"TANKESHWARI METAL POWDER PRODUCTS PRIVATE LIMITED",
"TANKHI DESIGNS1 PRIVATE LIMITED",
"TANKTECH ASIA PRIVATE LIMITED",
"TANKUP ENGINEERS PRIVATE LIMITED",
"TANLA PLATFORMS LIMITED",
"TANLA SOLUTIONS",
"TANMAI CREATIONS PRIVATE LIMITED",
"TANMAY DHYATA STEEL CONCAST LIMITED",
"TANMAY ENTERPRISES PRIVATE LIMITED",
"TANMAY EXIM PRIVATE LIMITED",
"TANMAY PACKAGING PRIVATE LIMITED",
"TANMAY VEGETABLE GUM WORKS PRIVATE LIMITED",
"TANMAYI SHIPPING & LOGISTICS PRIVATE LIMITED",
"TANMED PHARMA INDIA PRIVATE LIMITED",
"TANMEDTECH BIOTHERANOSTICS PRIVATE LIMITED",
"TANN UTILITY SERVICES PRIVATE LIMITED",
"TANNA AGRO IMPEX PRIVATE LIMITED",
"TANNA BROKERS PRIVATE LIMITED",
"TANNA CRANKTECH PRIVATE LIMITED",
"TANNA FINANCIAL SERVICES PRIVATE LIMITED",
"TANNA VENTURES PRIVATE LIMITED",
"TANNERU INFRASTRUCTURES PRIVATE LIMITED",
"TANNU TOOLS PRIVATE LIMITED",
"TANNUSHKAA ARTS PRIVATE LIMITED",
"TANNUSHRI ENTERPRISE",
"TANNY RESOURCES MANAGEMENT PRIVATE LIMITED",
"TANNY SHELTERS PRIVATE LIMITED",
"TANOT WIND POWER VENTURES PRIVATE LIMITED",
"TANQAA PAYROLL PRIVATE LIMITED",
"TANRIYA AMUSEMENT RIDES PRIVATE LIMITED",
"TANRUB LININGS PRIVATE LIMITED",
"TANSA EQUIPMENTS PVT LTD",
"TANSA ORGANICS PRIVATE LIMITED",
"TANSARA LOGISTIC INDIA PRIVATE LIMITED",
"TANSEN FOODS PRIVATE LIMITED",
"TANSERV BUSINESS PROCESS PRIVATE LIMITED",
"TANSHA",
"TANSHI FASHIONS PRIVATE LIMITED",
"TANSI MOTORS PRIVATE LIMITED",
"TANSUKH HERBALS PRIVATE LIMITED",
"TANSY PAINTS INDIA PRIVATE LIMITED",
"TANSY PROPERTIES PRIVATE LIMITED",
"TANTEX CHEMIZONIA PRIVATE LIMITED",
"TANTI HOLDINGS PRIVATE LIMITED",
"TANTIA INDUSTRIES PRIVATE LIMITED",
"TANTIA TEXTILES PRIVATE LIMITED",
"TANTIV4 TECHNOLOGIES PRIVATE LIMITED",
"TANTRA DESIGNS PRIVATE LIMITED",
"TANTRA INFOSOLUTIONS PRIVATE LIMITED",
"TANTRA UNIVERSE PRIVATE LIMITED",
"TANTRA-CHEM INDIA PRIVATE LIMITED",
"TANTRAGYAN TECHNOLOGIES PRIVATE LIMITED",
"TANTRANZM TECHNOLOGIES LLP",
"TANTRASOFT SOLUTIONS INDIA PRIVATE LIMITED",
"TANTRAYUT TELECOMMUNICATIONS PRIVATE LIMITED",
"TANU GARMENTS PRIVATE LIMITED",
"TANU MARKETING PRIVATE LIMITED",
"TANU MOTORS PRIVATE LIMITED",
"TANUJ HYDRAULICS PRIVATE LIMITED",
"TANUJ PROPERTIES PRIVATE LIMITED",
"TANUKU HOSPITALS PRIVATE LIMITED",
"TANUSH MICRO MINERALS PRIVATE LIMITED",
"TANUSHA FOOD AND BEVERAGES PRIVATE LIMITED",
"TANUSHA REAL ESTATE PRIVATE LIMITED",
"TANUSHKA AGRO PRIVATE LIMITED",
"TANUSHKA AUTOMOBILES PRIVATE LIMITED",
"TANUSHREE AIR TECHNIQUES PRIVATE LIMITED",
"TANUSHREE LOGISTICS PRIVATE LIMITED",
"TANVEER VINIMAY PRIVATE LIMITED",
"TANVI AGRI TRADELINK PRIVATE LIMITED",
"TANVI BIO CHEMICAL PRIVATE LIMITED",
"TANVI COLLECTION (INDIA) PVT LTD",
"TANVI EXPORTS INDIA LIMITED",
"TANVI FINANCIAL SERVICES PRIVATE LIMITED",
"TANVI FINCAP PRIVATE LIMITED",
"TANVI FITNESS PRIVATE LIMITED",
"TANVI FOODS INDIA LIMITED",
"TANVI FOODS INDIA PRIVATE. LIMITED.",
"TANVI GEMS PRIVATE LIMITED",
"TANVI GOLD PRIVATE LIMITED",
"TANVI INFOSOLUTION PRIVATE LIMITED",
"TANVI JEWELS PRIVATE LIMITED",
"TANVI KRUSHI SEVA KENDRA",
"TANVI MARINETECH PRIVATE LIMITED",
"TANVI MEDICARE PRIVATE LIMITED",
"TANVI PRODUCTIONS PRIVATE LIMITED",
"TANVIKA POLYMERS PRIVATE LIMITED",
"TANVIR PHARMA INDIA PRIVATE LIMITED",
"TANVISHTRADING PRIVATE LIMITED",
"TANWAR INDUSTRIES PRIVATE LIMITED",
"TANWAR PROJECTS PRIVATE LIMITED",
"TANYA AUTOMOBILES PRIVATE. LIMITED.",
"TANYA CARS PRIVATE LIMITED",
"TANYA COMEX PRIVATE LIMITED",
"TANYA EXIM PRIVATE LIMITED",
"TANYA HOMES PRIVATE LIMITED",
"TANYA MARKETING PRIVATE LIMITED",
"TANYA MARKETING PRIVATE. LIMITED.",
"TANYA MODERATORS PRIVATE LIMITED",
"TANYA PACKAGING PRIVATE LIMITED",
"TANYA PAPER DISTRIBUTORS PRIVATE LIMITED",
"TANYO EXPORTS PRIVATE LIMITED",
"TANZEB TEXTILES PRIVATE LIMITED",
"TAO AUTOMATION SERVICES PRIVATE LIMITED",
"TAO DESIGN STUDIO PRIVATE LIMITED",
"TAOKA CHEMICAL INDIA PRIVATE LIMITED",
"TAOM LEARNING PRIVATE LIMITED",
"TAORU WAREHOUSING PRIVATE LIMITED",
"TAP THE ARTISTS PROJECT PRIVATE LIMITED",
"TAP TURBO ENGINEERS PRIVATE LIMITED",
"TAPADIA CONDUCTORS PRIVATE LIMITED",
"TAPADIA CONSTRUCTIONS LIMITED",
"TAPADIA DIAGNOSTIC CENTRE PRIVATE LIMITED",
"TAPADIA ENGINEERS & TRADERS PVT LTD",
"TAPADIA ENTERPRISES INDIA PRIVATE LIMITED",
"TAPADIA POLYESTERS PRIVATE LIMITED",
"TAPAMS ADVANCED MANAGEMENT AND INDUSTRIES PRIVATE LIMITED",
"TAPAN AGRO INDUSTRIES PRIVATE LIMITED",
"TAPAN HEALTHCARE 24X7 PRIVATE LIMITED",
"TAPAN HOSPITAL PRIVATE LIMITED",
"TAPAN HOTEL & RESORTS PRIVATE LIMITED",
"TAPAN SCHOOL",
"TAPAN SCIENCE SCHOOL",
"TAPAN SOLAR ENERGY PRIVATE LIMITED",
"TAPAN SUITINGS PRIVATE LIMITED",
"TAPARIA IMPEX PRIVATE LIMITED",
"TAPARIA PRODUCTS PRIVATE LIMITED",
"TAPARIA TOOLS LIMITED",
"TAPAS GERIATRIC CARE PRIVATE LIMITED",
"TAPAS GREENGROCER PRIVATE LIMITED",
"TAPASYA BUSINESS SOLUTIONS PRIVATE LIMITED",
"TAPASYA CALCINATION AND CERAMICS PVT LTD",
"TAPASYA EDUCATIONAL INSTITUTIONS PRIVATE LIMITED",
"TAPASYA ENGINEERING WORKS PRIVATE LIMITED",
"TAPASYA FOODS AND BEVERAGES PRIVATE LIMITED",
"TAPASYA JEWELLERS PRIVATE LIMITED",
"TAPASYA TEXTILES PRIVATE LIMITED",
"TAPASYA TRANSFORMERS PRIVATE LIMITED",
"TAPCO PNEUMATICS PRIVATE LIMITED",
"TAPECOM PACKAGINGS PRIVATE LIMITED",
"TAPER SOLAR ENERGY LIMITED",
"TAPESHWAR APPARELS PRIVATE LIMITED",
"TAPFLO FLUID HANDLING INDIA PRIVATE LIMITED",
"TAPI DISTRICT EDUCATION COMMITTEE MANAGED PRIMARY SCHOOL",
"TAPI ENERGY PROJECTS LIMITED",
"TAPI FRUIT PROCESSING LIMITED",
"TAPI PAPER INDUSTRIES PRIVATE LIMITED",
"TAPINDU HOTELS & RESORTS PRIVATE LIMITED",
"TAPIO CREATIONS PRIVATE LIMITED",
"TAPIO YFM DESIGNS PRIVATE LIMITED",
"TAPISH SECURITAS PRIVATE LIMITED",
"TAPISSERIE HOMES PRIVATE LIMITED",
"TAPISSERIE LIFESTYLE PRIVATE LIMITED",
"TAPITS TECHNOLOGIES PRIVATE LIMITED",
"TAPMYADS TECHNOLOGIES PRIVATE LIMITED",
"TAPO BHUMI GANGA NARMADA PRIVATE LIMITED",
"TAPOBAN HOUSING DEVELOPMENT PRIVATE LIMITED",
"TAPON TECH SOLUTIONS PRIVATE LIMITED",
"TAPOVAN AUTO TECH PRIVATE LIMITED",
"TAPOVAN FOODS PRIVATE LIMITED",
"TAPOVAN IMPEX PRIVATE LIMITED",
"TAPOVAN INTERNATIONAL SCHOOL",
"TAPOVAN TOOLS AND PROTO TECH LLP",
"TAPP INDIA PRIVATE LIMITED",
"TAPP SEMICONDUCTOR INDIA PRIVATE LIMITED",
"TAPP TALENT TECHNOLOGIES PRIVATE LIMITED",
"TAPPERS SERVICES CO OPERATIVE SOCIETY LIMITED",
"TAPRATH POLYMERS PRIVATE LIMITED",
"TAPROBANE AVIATION PRIVATE LIMITED",
"TAPROBANE FOOD & BEVERAGE PRODUCTS PRIVATE LIMITED",
"TAPROGGE INDITECH PRIVATE LIMITED",
"TAPROOT DENTSU INDIA COMMUNICATION PRIVATE LIMITED",
"TAPSTART CAPITAL PRIVATE LIMITED",
"TAPTI LEATHERS PRIVATE LIMITED",
"TAPTI SILK MILLS PRIVATE LIMITED",
"TAPTI VALLEY EDUCATION FOUNDATION",
"TAPTI VALLEY INTERNATIONAL SCHOOL",
"TAPTI WATERWAYS PRIVATE LIMITED",
"TAQA NEYVELI POWER COMPANY PRIVATE LIMITED",
"TAR CARPET PRIVATE LIMITED",
"TARA ART PRINTERS PRIVATE LIMITED",
"TARA AUTOMOBILES",
"TARA BIOSCIENCES PRIVATE LIMITED",
"TARA CAPITAL PARTNERS INDIA PRIVATE LIMITED",
"TARA CHAND INDUSTRIES LIMITED",
"TARA CHAND KUKREJA TIMBERS PRIVATE LIMITED",
"TARA CHAND LOGISTIC SOLUTIONS LIMITED.",
"TARA CHAND MALHOTRA AND SONS PVT LTD",
"TARA CORPORATE SERVICES LIMITED",
"TARA CORRUGATED PAPER BOX PVT. LTD.",
"TARA CROP CARE PRIVATE LIMITED",
"TARA ELECTRO APPLIANCES PRIVATE LIMITED",
"TARA ENGINEERS & CONTRACTORS PRIVATE LIMITED",
"TARA EXPORTS LIMITED.",
"TARA FABRICS INDIA LIMITED",
"TARA FOOTWEARS PRIVATE LIMITED",
"TARA GLOBAL PRIVATE LIMITED",
"TARA GRAINS PRIVATE LIMITED",
"TARA HEALTH FOODS LIMITED",
"TARA HOSPITAL",
"TARA HOSPITAL AND MEDICAL RESEARCH CENTRE PRIVATE LIMITED",
"TARA HOSPITALITY PRIVATE LIMITED",
"TARA INFRAPRO INDIA PRIVATE LIMITED",
"TARA LOHIA PRIVATE LIMITED",
"TARA MACHINES AND TECH SERVICES PRIVATE LIMITED",
"TARA MARINE SYNDICATE PVT LTD",
"TARA MECHCONS PRIVATE LIMITED",
"TARA MEDICOS PRIVATE LIMITED",
"TARA MEDICOS WELLNESS PRIVATE LIMITED",
"TARA MERCANTILE PRIVATE LIMITED",
"TARA MINERALS AND CHEMICALS PRIVATE LIMITED",
"TARA MULCHAND FOODS PRIVATE LIMITED",
"TARA PLYWOOD PVT LTD",
"TARA POLYTECH PRIVATE LIMITED",
"TARA PRASAD INFOTECH PRIVATE LIMITED",
"TARA PRODUCTS AND SERVICES PRIVATE LIMITED",
"TARA PROJECTS (INDIA) LIMITED",
"TARA RELAYS PRIVATE LIMITED",
"TARA SALES LIMITED",
"TARA SOFTTECH SERVICES PRIVATE LIMITED",
"TARA STEELS PRIVATE LIMITED",
"TARA STONE PRIVATE LIMITED",
"TARA SYNTEX PRIVATE LIMITED",
"TARA TARINI CONSTRUCTIONS PRIVATE LIMITED",
"TARA TARINI STONE PRODUCTS PRIVATE LIMITED",
"TARA TECHNO MACHINES PRIVATE LIMITED",
"TARA TILES PVT LTD",
"TARA TRADELINK PRIVATE LIMITED",
"TARAA LPG BOTTLING PRIVATE LIMITED",
"TARAASHA CREATIONS PRIVATE LIMITED",
"TARAASHNA FINANCIAL SERVICES LIMITED",
"TARABASUDEO TRADERS PRIVATE LIMITED",
"TARABEN MASTER ENGLISH PRIMARY SCHOOL",
"TARACHAND AND SONS (TRADING) PVT LTD",
"TARACHAND IMPEX PRIVATE LIMITED",
"TARACHANDRA ENGINEERING PRIVATE LIMITED",
"TARADE BROTHERS CONSTRUCTION PRIVATE. LIMITED.",
"TARAI BIO TECH PRIVATE LIMITED",
"TARAJAN TEA CO PVT LTD",
"TARAJYOT POLYMERS LIMITED",
"TARAK CHEMICALS LIMITED",
"TARAK HOSPITALS INDIA PRIVATE LIMITED",
"TARAK INFRA AND SERVICES PRIVATE LIMITED",
"TARAK ONLINE OFFLINE PRIVATE LIMITED",
"TARAK TEXTILES PRIVATE LIMITED",
"TARAK UTENSILS MANUFACTURING PRIVATE LIMITED",
"TARAKESWARA SPINNING AND WEAVING MILLS PRIVATE LIMITED",
"TARAKESWARA TEXTILE PARK PRIVATE LIMITED",
"TARAKRAMA INFRATECH PRIVATE LIMITED",
"TARALEKAR MOTORS PRIVATE LIMITED",
"TARALIFE SUSTAINABILITY SOLUTIONS PRIVATE LIMITED",
"TARA-LINKS CARRIERS PRIVATE LIMITED",
"TARAM TEXTILES (A DIVISION OF THE RAMARAJU SURGICAL COTTON MILLS LIMITED)",
"TARAMA RICE MILLS PRIVATE LIMITED",
"TARAMIS LABS PRIVATE LIMITED",
"TARAMS SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"TARAN ANGAD TRADERS PVT LTD",
"TARAN IMPEX PRIVATE LIMITED",
"TARANA LOGISTICS PRIVATE LIMITED",
"TARANA NAGAR PARISHAD",
"TARANA WIRELESS INDIA PRIVATE LIMITED",
"TARANDA HYDRO POWER PRIVATE LIMITED",
"TARANG ADVISORY PRIVATE LIMITED",
"TARANG APPARELS PRIVATE LIMITED",
"TARANG BUSINESS PROMOTERS AND CONSULTANTS LIMITED",
"TARANG ENGINEERING PRIVATE LIMITED",
"TARANG JEWELS PRIVATE LIMITED",
"TARANG KINETICS PRIVATE LIMITED",
"TARANGA MOTORS PRIVATE LIMITED",
"TARANGAN HOLIDAYS PRIVATE LIMITED",
"TARANGAN INFRAVENTURES PRIVATE LIMITED",
"TARANGINI HOME CARE PRIVATE LIMITED",
"TARANGINI LAYERS PRIVATE LIMITED",
"TARANI HOSPITAL",
"TARANJOT CERAMICS PRIVATE LIMITED",
"TARANJOT ENERGY SOLUTIONS PRIVATE LIMITED",
"TARANJOT RESOURCES PRIVATE LIMITED",
"TARANTULA.NET INDIA PRIVATE LIMITED",
"TARAPUKUR GOVT QUARTERS PRIMARY SCHOOL",
"TARAPUR EDUCATION SOCIETY",
"TARAPUR GREASE INDUSTRIES PRIVATE LIMITED",
"TARAPUR SERVO-TECH PRIVATE LIMITED",
"TARAPUR TRANSFORMERS LIMITED",
"TARARAJAT ENCLAVE PRIVATE LIMITED",
"TARASAFE INTERNATIONAL PRIVATE LIMITED",
"TARASANKAR MOTOR PRIVATE LIMITED",
"TARASH OVERSEAS PRIVATE LIMITED",
"TARASHAKTI RICE MILL PRIVATE LIMITED",
"TARASREE TECHNOCAST PRIVATE LIMITED",
"TARATARINEE AGRO IMPEX PRIVATE LIMITED",
"TARATARINI POLYMERS PRIVATE LIMITED",
"TARATARINI RUBBER (INDIA) PRIVATE LIMITED",
"TARAWADE LOGISTICS PRIVATE LIMITED",
"TARAWADE TRANSPORTS PRIVATE LIMITED",
"TARAX TECH PRIVATE LIMITED",
"TARBOLIN LUBRICANTS PRIVATE LIMITED",
"TARC LIMITED",
"TARC PROJECTS LIMITED",
"TARDID TECHNOLOGIES PRIVATE LIMITED",
"TARDIS IT SOLUTIONS PRIVATE LIMITED",
"TARENDRA INFRASTRUCTURE CHENNAI PRIVATE LIMITED",
"TARENTO TECHNOLOGIES PRIVATE LIMITED",
"TARGET",
"TARGET AERO PRIVATE LIMITED",
"TARGET ASSOCIATES PRIVATE LIMITED",
"TARGET A-STAR SURVEILLANCES SYSTEMS PRIVATE LIMITED",
"TARGET CORPORATION INDIA PRIVATE LIMITED",
"TARGET EDUCARE PRIVATE LIMITED",
"TARGET EQUIPMENTS AND MACHINES PVT LTD",
"TARGET EXPORTS PRIVATE LIMITED",
"TARGET FREIGHT SERVICES (I) PVT.LTD.",
"TARGET HYDRAUTECH PRIVATE LIMITED",
"TARGET INTEGRATION CONSULTANCY PRIVATE LIMITED",
"TARGET INTERNET SERVICES PRIVATE LIMITED",
"TARGET MANPOWER SERVICES LIMITED",
"TARGET POLYMERS PRIVATE LIMITED",
"TARGET PUBLICATIONS PRIVATE LIMITED",
"TARGET SECURITAS PRIVATE LIMITED",
"TARGET SHIPPING PRIVATE LIMITED",
"TARGET SOURCING SERVICES INDIA PRIVATE LIMITED",
"TARGET SPECIALTY PACKAGING PRIVATE LIMITED",
"TARGET TECHNOLOGIES PRIVATE LIMITED",
"TARGET TECH-TEX PRIVATE LIMITED",
"TARGET TOURS (INDIA) PRIVATE LIMITED",
"TARGETBAY ECOMMERCE SOLUTIONS PRIVATE LIMITED",
"TARGETCLOSE TECHNOLOGY INDIA PRIVATE LIMITED",
"TARGETEVERYONE IT PRIVATE LIMITED",
"TARGETORATE CONSULTING LLP",
"TARGETPLUS EDUCATION PRIVATE LIMITED",
"TARGRAY INDIA PRIVATE LIMITED",
"TARGUS INDIA PRIVATE LIMITED",
"TARGUS TECHNOLOGIES PRIVATE LIMITED",
"TARIDES INDIA PRIVATE LIMITED",
"TARIKA TECHNOLOGIES PRIVATE LIMITED",
"TARIL INFRASTRUCTURE LIMITED",
"TARIL SWITCHGEAR PRIVATE LIMITED",
"TARIMELA ADVISORS PRIVATE LIMITED",
"TARINEE PROMOTERS PRIVATE LIMITED",
"TARINI AGRO FOODPROCESS PRIVATE LIMITED",
"TARINI CONSTRUCTION PRIVATE LIMITED",
"TARINI INFRASTRUCTURE LIMITED",
"TARINI INTERNATIONAL LIMITED",
"TARINI JEWELS PRIVATE LIMITED",
"TARINI MINERALS PRIVATE LIMITED",
"TARINI MOTORS PRIVATE LIMITED",
"TARINI STEEL COMPANY LIMITED",
"TARINIKA PRIVATE LIMITED",
"TARISH INVESTMENT AND TRADING COMPANY PRIVATE LIMITED.",
"TARITAS SOFTWARE SOLUTION PRIVATE LIMITED",
"TARJANI INSURANCE BROKING PRIVATE LIMITED",
"TARKA INFOTECH PRIVATE LIMITED",
"TARKETT FLOORING INDIA PRIVATE LIMITED",
"TARMAN EKAM DEVELOPERS PRIVATE LIMITED",
"TARMAT LIMITED",
"TARNEA TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"TARNETAR PRIMARY SCHOOL 1",
"TARNI CONSTRUCTION PRIVATE LIMITED",
"TARNI PROJECTS AND CONSULTANCY PRIVATE LIMITED",
"TAROKO MINERAL PRIVATE LIMITED",
"TARON MATERIAL HANDLING EQUIPMENTS PRIVATE LIMITED",
"TAROOJIT SWEET HOME PRIVATE LIMITED",
"TARPAULINS INDIA TARP PRIVATE LIMITED",
"TARSADI NAGARPALIKA",
"TARSAN MVAS PRIVATE LIMITED",
"TARSENSE TECHNOLOGIES PRIVATE LIMITED",
"TARSIER VIEW CONSULTING PRIVATE LIMITED",
"TARSONS PRODUCTS LIMITED",
"TARSUN STEELS INDIA PRIVATE LIMITED",
"TARTE ENGINEERS PRIVATE LIMITED",
"TARU AGENCIES AND INVESTMENTS PRIVATE LIMITED",
"TARU ELASTOMERS PRIVATE LIMITED",
"TARU LEADING EDGE PRIVATE LIMITED",
"TARU OVERSEAS PRIVATE LIMITED",
"TARU PALLAV AGRI FARMING PRIVATE LIMITED",
"TARU VIKAS PRIVATE LIMITED",
"TARUCHAYA COLONIZERS PRIVATE LIMITED",
"TARUK IMPEX PRIVATE LIMITED",
"TARUN ALUM PRIVATE LIMITED",
"TARUN BHARAT DAILY PRIVATE LIMITED",
"TARUN BOOKS PRIVATE LIMITED",
"TARUN COMPOSITES PRIVATE LIMITED",
"TARUN ENTERPRISE",
"TARUN ENTERPRISES PRIVATE LIMITED",
"TARUN FASHIONS PVT LTD",
"TARUN FLUO-CHEM PRIVATE LIMITED",
"TARUN GLOBAL PRIVATE LIMITED",
"TARUN INTERNATIONAL LIMITED",
"TARUN KHIWAL PHOTOGRAPHY PRIVATE LIMITED",
"TARUN KIRAN BHOOMI PRIVATE LIMITED",
"TARUN LUBRICANTS PRIVATE LIMITED",
"TARUN MITRA MEDIA PRIVATE LIMITED",
"TARUN OILS PRIVATE LIMITED",
"TARUN PAINT PRIVATE LIMITED",
"TARUN PREMIER CORPORATION PRIVATE LIMITED",
"TARUN PRINTING WORKS PRIVATE LIMITED",
"TARUN REALTORS P LIMITED.",
"TARUN SARDESAI GOLF PRIVATE LIMITED",
"TARUN THERMOWARE PRIVATE LIMITED",
"TARUN TOOLS PRIVATE LIMITED",
"TARUN TRADECON PRIVATE LIMITED",
"TARUN TRADERS PRIVATE LIMITED.",
"TARUNA AUTO PRIVATE LIMITED",
"TARUNA DECHOME PRIVATE LIMITED",
"TARUNI CLOTHING PRIVATE LIMITED",
"TARUNIKAA INDUSTRIAL PRODUCTS PRIVATE LIMITED",
"TARUNS ACCOUNTANCY CLASSES",
"TARUSH STAMPING PRIVATE LIMITED",
"TARVOSTAR INFRA SOLUTION PRIVATE LIMITED",
"TARWAY EXPORTS PRIVATE LIMITED",
"TARZ DISTRIBUTION INDIA PRIAVTE LIMITED",
"TARZAN ELECTRICALS PRIVATE LIMITED",
"TAS FOUNDRIES PRIVATE LIMITED",
"TAS HILL PLA NTATIONS PRIVATE LIMITED",
"TAS INDIA PRIVATE LIMITED",
"TAS MED INDIA PRIVATE LIMITED",
"TAS POWERTEK LIMITED",
"TAS PRECISION PRIVATE LIMITED",
"TAS TEXTILES INDIA PRIVATE LIMITED",
"TASA BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"TASA FOODS PRIVATE LIMITED",
"TASA GLOBAL EDUCATION PRIVATE LIMITED",
"TASA MICRO SPECIAL PURPOSE MACHINES PRIVATE LIMITED",
"TASAA SOFTWARE SERVICES PRIVATE LIMITED",
"TAS-AGT SYSTEMS LIMITED",
"TASAR DEVELOPMENT FOUNDATION",
"TASC BUSINESS SOLUTIONS PRIVATE LIMITED",
"TASC CHEMICALS INDUSTRIES PRIVATE LIMITED",
"TASHA GOLD PRIVATE LIMITED",
"TASHA NEST HOME MAKERS PRIVATE LIMITED",
"TASHE POWER INDIA PRIVATE LIMITED",
"TASHI INDIA LIMITED",
"TASHI LHENDUP ENTERPRISES PRIVATE LIMITED",
"TASHI SECURITIES LIMITED",
"TASHILA LOGISTICS PRIVATE LIMITED",
"TASHIPTA EVENTS & ENTERTAINMENT PRIVATE LIMITED",
"TASHKAND HANDLOOMS PRIVATE LIMITED",
"TASHKENT OIL COMPANY PRIVATE LIMITED",
"TASHOKU COATING WORLD PRIVATE LIMITED",
"TASHREE HOTELS PRIVATE LIMITED",
"TASHU COLLECTION PRIVATE LIMITED",
"TASILDAR PATAN",
"TASK DISTRIBUTORS PRIVATE LIMITED",
"TASK FACILITY SERVICES PRIVATE LIMITED",
"TASK INFRACON PRIVATE LIMITED",
"TASK MASTERS ENGINEERING AND PROJECT SOLUTIONS PRIVATE LIMITED",
"TASK POLYMERS PRIVATE LIMITED",
"TASK PRECISION INDUSTRIES PRIVATE LIMITED",
"TASK PRESSINGS LIMITED",
"TASK STAFFING SOLUTIONS PRIVATE LIMITED",
"TASKAR ENGINEERS PRIVATE LIMITED",
"TASKAR GLOBAL PRIVATE LIMITED",
"TASKER VIRTUAL ASSISTANCE SERVICES PRIVATE LIMITED",
"TASKFLOW ANSWER PRIVATE LIMITED",
"TASKI TECHNOLOGIES PRIVATE LIMITED",
"TASKMONK TECHNOLOGY PRIVATE LIMITED",
"TASKTAKERS MANUFACTURERS PRIVATE LIMITED",
"TASKUS INDIA PRIVATE LIMITED",
"TASKWEND SOLUTIONS PRIVATE LIMITED",
"TASMAI FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"TASMAN IMPEX PRIVATE LIMITED",
"TASNIM INTERNATIONAL PRIVATE LIMITED",
"TASS GLOBAL INFRASTRUCTURE SERVICES PRIVATE LIMITED",
"TASS SERVICES INDIA PRIVATE LIMITED",
"TASSOS CONSTRUCTION PRIVATE LIMITED",
"TASTE AND TRENDS HOSPITALITY PRIVATE LIMITED",
"TASTE HUB INTERNATIONAL PRIVATE LIMITED",
"TASTE MASTER FLAVOURS PRIVATE LIMITED",
"TASTEA ANAND NAMKEEN PRIVATE LIMITED",
"TASTEL FINE FOOD PRIVATE LIMITED",
"TASTESHOP PRIVATE LIMITED",
"TASTETARIA FOODS PRIVATE LIMITED",
"TASTEXPRESS FOODS PRIVATE LIMITED",
"TASTIFY OVERSEAS PRIVATE LIMITED",
"TASTY BITE EATABLES LTD",
"TASTY BITES HOSPITALITY",
"TASTY DAIRY SPECIALITIES LIMITED",
"TASTY FOODIE HOSPITALITY SERVICES PRIVATE LIMITED",
"TASTY MANUFACTURING CO. PRIVATE LIMITED",
"TASTY OILPRODUCTS PRIVATE LIMITED",
"TASTYBUDZ SPECIALITY FOOD SERVICES PRIVATE LIMITED",
"TASTYSPREAD KITCHEN PRIVATE LIMITED",
"TASWIN PHARMA PRIVATE LIMITED",
"TASYA EDUFOOD (OPC) PRIVATE LIMITED",
"TATA 1MG HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"TATA 1MG TECHNOLOGIES PRIVATE LIMITED",
"TATA ADVANCED SYSTEMS LIMITED",
"TATA AIA LIFE INSURANCE COMPANY LIMITED",
"TATA AIG GENERAL INSURANCE COMPANY LIMITED\n",
"TATA ASSET MANAGEMENT PRIVATE LIMITED",
"TATA AUTOCOMP GOTION GREEN ENERGY SOLUTIONS PRIVATE LIMITED",
"TATA AUTOCOMP GY BATTERIES PRIVATE LIMITED",
"TATA AUTOCOMP HENDRICKSON SUSPENSIONS PRIVATE LIMITED",
"TATA AUTOCOMP KATCON EXHAUST SYSTEMS PRIVATE LIMITED",
"TATA AUTOCOMP SYSTEMS LIMITED",
"TATA BLUESCOPE STEEL PRIVATE LIMITED",
"TATA BOEING AEROSPACE LIMITED",
"TATA BP SOLAR INDIA LIMITED",
"TATA BUSINESS HUB LIMITED",
"TATA CANCER CARE FOUNDATION",
"TATA CAPITAL FOREX LIMITED",
"TATA CAPITAL HOUSING FINANCE LIMITED",
"TATA CAPITAL LIMITED",
"TATA CHEMICALS LIMITED",
"TATA CLASS EDGE",
"TATA CLASSEDGE LIMITED",
"TATA COFFEE LIMITED",
"TATA COMMUNICATIONS COLLABORATION SERVICES PRIVATE LIMITED",
"TATA COMMUNICATIONS LIMITED.",
"TATA COMMUNICATIONS PAYMENT SOLUTIONS LIMITED",
"TATA COMMUNICATIONS TRANSFORMATION SERVICES LIMITED",
"TATA COMMUNITY INITIATIVE TRUST",
"TATA CONSULTANCY SERVICES LIMITED",
"TATA CONSULTING ENGINEERS LIMITED",
"TATA CONSUMER PRODUCTS LIMITED",
"TATA CONSUMER SOULFULL PRIVATE LIMITED",
"TATA CUMMINS PRIVATE LIMITED",
"TATA DAV SCHOOL JAMADOBA",
"TATA DIGITAL LIMITED",
"TATA DIGITAL PRIVATE LIMITED",
"TATA ELECTRONICS PRIVATE LIMITED",
"TATA ELXSI LIMITED",
"TATA ENERGY REASEARCH INSTITUTE",
"TATA FICOSA AUTOMOTIVE SYSTEMS LIMITED",
"TATA FINTECH PRIVATE LIMITED",
"TATA GLOBAL BEVERAGES LIMITED",
"TATA HITACHI CONSTRUCTION MACHINERY COMPANY LIMITED",
"TATA HOUSING DEVELOPMENT COMPANY LIMITED",
"TATA INDIAN INSTITUTE OF SKILLS",
"TATA INDUSTRIES LIMITED",
"TATA INSIGHTS AND QUANTS A DIVISION OF TATA INDUSTRIES LIMITED REVENUE AND COMPETITORS",
"TATA INSTITUTE FOR GENETICS AND SOCIETY",
"TATA INSTITUTE OF FUNDAMENTAL RESEARCH",
"TATA INSTITUTE OF SOCIAL SCIENCES MUMBAI",
"TATA INTERNATIONAL GST AUTOLEATHER LIMITED",
"TATA INTERNATIONAL LIMITED",
"TATA INTERNATIONAL VECHILE APPLICATION PRIVATE LIMITED",
"TATA INVESTMENT CORPORATION LIMITED",
"TATA KORF ENGINERING SERVICES LIMITED",
"TATA LOCKHEED MARTIN AEROSTRUCTURES LIMITED",
"TATA MAIN HOSPITAL",
"TATA MOTORS BODY SOLUTIONS LIMITED",
"TATA MEDICAL AND DIAGNOSTICS LIMITED",
"TATA MEDICAL CENTER",
"TATA MEMORIAL CENTRE",
"TATA MEMORIAL HOSPITAL",
"TATA METALIKS DI PIPES LIMITED",
"TATA METALIKS LIMITED",
"TATA MOTORS FINANCE LIMITED",
"TATA MOTORS FINANCE LIMITED PERPETUAL DEBT PROGRAMME",
"TATA MOTORS FINANCE SOLUTIONS LIMITED",
"TATA MOTORS INSURANCE BROKING & ADVISORY SERVICES LIMITED",
"TATA MOTORS LIMITED",
"TATA MOTORS PASSENGER VEHICLES LIMITED",
"TATA NYK SHIPPING INDIA PRIVATE LIMITED",
"TATA PASSENGER ELECTRIC MOBILITY LIMITED",
"TATA PAYMENTS LIMITED",
"TATA PETRODYNE LIMITED",
"TATA PLAY BROADBAND PRIVATE LIMITED",
"TATA PLAY LIMITED",
"TATA POWER DELHI DISTRIBUTION LIMITED",
"TATA POWER EV CHARGING SOLUTIONS LIMITED",
"TATA POWER GREEN ENERGY LIMITED",
"TATA POWER RENEWABLE ENERGY LIMITED",
"TATA POWER SOLAR SYSTEMS LIMITED",
"TATA POWER TRADING COMPANY LIMITED",
"TATA PRECISION INDUSTRIES INDIA LIMITED",
"TATA PROJECTS LIMITED",
"TATA REALTY AND INFRASTRUCTURE LIMITED",
"TATA SECURITIES LIMITED",
"TATA SEMICONDUCTOR ASSEMBLY AND TEST PRIVATE LIMITED",
"TATA SERVICES LIMITED",
"TATA SIKORSKY AEROSPACE LIMITED",
"TATA SMARTFOODZ LIMITED",
"TATA SONS PRIVATE LIMITED",
"TATA STARBUCKS PRIVATE LIMITED",
"TATA STEEL BUSINESS DELIVERY CENTRE LIMITED",
"TATA STEEL DOWNSTREAM PRODUCTS LIMITED",
"TATA STEEL FOUNDATION",
"TATA STEEL INTERNATIONAL (INDIA) LIMITED",
"TATA STEEL LIMITED",
"TATA STEEL LONG PRODUCTS LIMITED",
"TATA STEEL SPECIAL ECONOMIC ZONE LIMITED",
"TATA STEEL SUPPORT SERVICES LIMITED",
"TATA STEEL TECHNICAL SERVICES LIMITED",
"TATA STEEL UTILITIES AND INFRASTRUCTURE SERVICES LIMITED",
"TATA STRATEGIC MANAGEMENT GROUP",
"TATA TELE NXTGEN SOLUTIONS LIMITED",
"TATA TELESERVICES LIMITED",
"TATA TELESERVICES MAHARASHTRA LIMITED",
"TATA TOYO RADIATOR LIMITED",
"TATA TRUSTEE COMPANY PRIVATE LIMITED",
"TATA TRUSTS",
"TATA UNISTORE LIMITED",
"TATA VALUE HOMES LIMITED",
"TATAATSU IDEALABS PRIVATE LIMITED",
"TATAGARI TERRO TECHNOLOGIES PRIVATE LIMITED",
"TATANAGAR ENTERPRISES PRIVATE LIMITED",
"TATANAGAR MOTOR SERVICES PRIVATE LIMITED",
"TATANWALA IMPEX PRIVATE LIMITED",
"TATHAASTU INFRABUILD PRIVATE LIMITED",
"TATHAGAT CONSTRUCTION PRIVATE LIMITED",
"TATHAGAT JEWELS PRIVATE LIMITED",
"TATHAGAT NEEDS PRIVATE LIMITED",
"TATHAGAT STONE PRIVATE LIMITED",
"TATHASTHU TECHNOLOGIES PRIVATE LIMITED",
"TATHASTU INTERNATIONAL PRIVATE LIMITED",
"TATHASTU SPINTEX PRIVATE LIMITED",
"TATHASTU TEXFAB PRIVATE LIMITED",
"TATHYA TEXFAB PRIVATE LIMITED",
"TATI CONSTRUCTION PRIVATE LIMITED",
"TATIA CHEMICAL CORPORATION PRIVATE LIMITED",
"TATIA DEVELOPER PRIVATE LIMITED",
"TATIA GLOBAL VENNTURE LIMITED",
"TATKAL LOAN INDIA PRIVATE LIMITED",
"TATKALORRY PRIVATE LIMITED",
"TATO HYDRO POWER PRIVATE LIMITED",
"TATPADAM UPAVAN",
"TATRAS DATA SERVICES PRIVATE LIMITED",
"TATSO BEVERAGES PRIVATE LIMITED",
"TATSUNO INDIA PRIVATE LIMITED",
"TATTERS INTERNATIONAL PRIVATE LIMITED",
"TATTVA & MITTAL CORPORATION PRIVATE LIMITED",
"TATTVA CREATIONS PRIVATE LIMITED",
"TATTVA EMBEDDED SOLUTIONS PRIVATE LIMITED",
"TATTVA FINCORP LIMITED",
"TATTVA HICAL AND COMPOUNDS PRIVATE LIMITED",
"TATTVA HOLDINGS PRIVATE LIMITED",
"TATTVA HOME HEALTHCARE PRIVATE LIMITED",
"TATTVA SCHOOL",
"TATTVAM INDUSTRIES PRIVATE LIMITED",
"TATTVAM VYAPAAR PRIVATE LIMITED",
"TATULEGE INDIA PRIVATE LIMITED",
"TATVA CHINTAN PHARMA CHEM LIMITED",
"TATVA CHINTAN PHARMA CHEM PRIVATE LIMITED",
"TATVA DHATU (OPC) PRIVATE LIMITED",
"TATVA GLOBAL ENVIRONMENT PRIVATE LIMITED",
"TATVA GLOBAL SCHOOL",
"TATVA GLOBAL TECHNO SERVICES PRIVATE LIMITED",
"TATVA HEALTH & WELLNESS PRIVATE LIMITED",
"TATVA INTERIORS AND CONTRACTORS PRIVATE LIMITED",
"TATVA MARKETING AND SERVICES PRIVATE LIMITED",
"TATVA RENEWABLE ENERGY PRIVATE LIMITED",
"TATVAM VENTURES LIMITED",
"TATVAMASI ENGINEERING PRIVATE LIMITED",
"TATVANG PROJECTS PRIVATE LIMITED",
"TATVARTHA HEALTH PRIVATE LIMITED",
"TATVASOFT",
"TATVIC ANALYTICS PRIVATE LIMITED",
"TATVIK BIOSYSTEMS PRIVATE LIMITED",
"TATVIK SYSTEM SOLUTIONS PRIVATE LIMITED",
"TATVIKA HOLDINGS PRIVATE LIMITED",
"TATWA TECHNOLOGIES LIMITED",
"TATWADARSHA HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"TATYNERDS PRIVATE LIMITED",
"TAU AGRO SALES PRIVATE LIMITED",
"TAU AGRO TECH PRIVATE LIMITED",
"TAU FILMS INDIA PRIVATE LIMITED",
"TAUFIQ MANPOWER CONSULTANTS PRIVATE LIMITED",
"TAURAL INDIA PRIVATE LIMITED",
"TAURAS FINANCIAL SERVICES PRIVATE LIMITED",
"TAURIAN ENGINEERING PRIVATE LIMITED",
"TAURIAN INFRASTRUCTURE PRIVATE LIMITED",
"TAURIAN MINERALS PROCESSING PRIVATE LIMITED",
"TAURIAN MPS PRIVATE LIMITED",
"TAURLUBE PETROCHEMICALS PRIVATE LIMITED",
"TAUROTEC ENGINEERING PRIVATE LIMITED",
"TAURRUS FINSEC PRIVATE LIMITED",
"TAURUS ADVERTISING PRIVATE LIMITED",
"TAURUS AEROSPACE SYSTEMS PRIVATE LIMITED",
"TAURUS AND TAURUS INDIA ENTERPRISES PRIVATE LIMITED",
"TAURUS ASSET MANAGEMENT COMPANY LIMITED",
"TAURUS BIO-MEDICAL AIDS PRIVATE LIMITED",
"TAURUS BPO SERVICES INDIA LLP",
"TAURUS BUILDWELL PRIVATE LIMITED",
"TAURUS CHEMICALS PVT LTD",
"TAURUS COLLECTION PRIVATE LIMITED",
"TAURUS COMMERCIALS PRIVATE LIMITED",
"TAURUS CONTRACTORS PRIVATE LIMITED",
"TAURUS CORIUM IMPEX PRIVATE LIMITED",
"TAURUS CORPORATE ADVISORY SERVICES LIMITED",
"TAURUS ENGINEERS PRIVATE LIMITED",
"TAURUS ENGLOBE LIMITED",
"TAURUS ENGLOBE PRIVATE LIMITED",
"TAURUS FORWARDERS PRIVATE LIMITED",
"TAURUS HEALTH CARE PRIVATE LIMITED",
"TAURUS HOME FURNISHINGS LIMITED",
"TAURUS HR PRIVATE LIMITED",
"TAURUS INDIA LIMITED",
"TAURUS INTELLIGENT TRADING SOLUTIONS PRIVATE LIMITED.",
"TAURUS LIFE SCIENCES LIMITED",
"TAURUS LINES PRIVATE LIMITED",
"TAURUS LOGISTICS AND TRANSPORT PRIVATE LIMITED",
"TAURUS MERCHANTS PRIVATE LIMITED",
"TAURUS PACKAGING PRIVATE LIMITED",
"TAURUS PRIVATE LIMITED",
"TAURUS SHIPPING PRIVATE LIMITED",
"TAURUS STOCK BROKING PRIVATE LIMITED",
"TAURUS THERMOPLASTICS PRIVATE. LIMITED.",
"TAURUS TILES PRIVATE LIMITED",
"TAURUS TRADING PVT LTD",
"TAURUS TREASURY MANAGEMENT SERVICES PRIVATE LIMITED",
"TAURUS VALUE STEEL & PIPES PRIVATE LIMITED",
"TAURUSQUEST GLOBAL SERVICES PRIVATE LIMITED",
"TAVAASMI COTTON AND AGRO INDUSTRIES PRIVATE LIMITED",
"TAVAGRAHA HEALTH SOLUTIONS PRIVATE LIMITED",
"TAVANT TECHNOLOGIES INDIA PRIVATE LIMITED",
"TAVARA MINES & MINERALS",
"TAVAS BIOSOLUTIONS PRIVATE LIMITED",
"TAVAS CONSTRUCTION PRIVATE LIMITED",
"TAVASYA CAPITAL PRIVATE LIMITED",
"TAVASYA HOSPITALITY PRIVATE LIMITED",
"TAVASYA VENTURE PARTNERS PRIVATE LIMITED",
"TAVAT INGENIOUS PRODUCTS PRIVATE LIMITED",
"TAVERNIER RESOURCES LIMITED",
"TAVISCA SOLUTIONS PRIVATE LIMITED",
"TAVISHA HOSPITALITY PRIVATE LIMITED",
"TAVISHA HOTELS AND RESORTS PRIVATE LIMITED",
"TAVISHI FOODS INDIA PRIVATE LIMITED",
"TAVISHI HOLDINGS PRIVATE LIMITED",
"TAVISS PHARMA PRIVATE LIMITED",
"TAVISSH POLYWEAVES PRIVATE LIMITED",
"TAVOY WORKWEAR PRIVATE LIMITED",
"TAVROHI ANIMATIONS PRIVATE LIMITED",
"TAW EXPORTS PRIVATE LIMITED",
"TAWAKKAL SALT WORKS PRIVATE LIMITED",
"TAWAKKAL SUPER MART AND HEALTHCARE PRIVATE LIMITED",
"TAWAKKAL WOOD PRODUCTS PRIVATE LIMITED",
"TAWI HATCHERIES PRIVATE LIMITED",
"TAWI INDUSTRIES PRIVATE LIMITED",
"TAWRI MULTIGASES PRIVATE LIMITED",
"TAWWAB PHARMA PRIVATE LIMITED",
"TAX LAWS ONLINE.COM PRIVATE LIMITED",
"TAX SOFT MARKETING PRIVATE LIMITED",
"TAX TECH INDIA PRIVATE LIMITED",
"TAXANE HEALTHCARE PRIVATE LIMITED",
"TAXBLOCK INDIA PRIVATE LIMITED",
"TAXCON INDIA PRIVATE LIMITED",
"TAXILA GURUKUL PRIVATE LIMITED",
"TAXILA WELCURE PRIVATE LIMITED",
"TAXILLA IT SOLUTIONS PRIVATE LIMITED",
"TAXIMENS SERVICES LIMITED",
"TAXIONCALL PRIVATE LIMITED",
"TAXMANN ALLIED SERVICES PRIVATE LIMITED",
"TAXMANN PUBLICATIONS PRIVATE LIMITED",
"TAXMANN TECHNOLOGIES PRIVATE LIMITED",
"TAXON SEEDS & AGRO CHEMICALS PRIVATE LIMITED",
"TAXPERT PROFESSIONALS PRIVATE LIMITED",
"TAXTOOLS INFOTECH PRIVATE LIMITED",
"TAXTUBE CONSULTING PRIVATE LIMITED",
"TAXUS INFRASTRUCTURE & POWER PROJECTS PRIVATE LIMITED",
"TAXYOG SOLUTIONS PRIVATE LIMITED",
"TAYAJE AND SONS PRIVATE LIMITED",
"TAYAL COTTON PRIVATE LIMITED",
"TAYAL GARMENTS PRIVATE LIMITED",
"TAYAL HOSIERY MILLS PRIVATE LIMITED",
"TAYAL INDIA MOTORS PRIVATE LIMITED",
"TAYAL INORGANIC PRIVATE LIMITED",
"TAYAL ISPAT UDYOG PRIVATE LIMITED",
"TAYAL POWERTEL PRIVATE LIMITED",
"TAYAL PROPERTES PRIVATE LIMITED",
"TAYAL RICE MILL PRIVATE LIMITED",
"TAYAL SONS LIMITED",
"TAYAL SONS PRIVATE LIMITED",
"TAYAL VINIMAY PRIVATE LIMITED",
"TAYANA SOFTWARE SOLUTIONS PRIVATE LIMITED",
"TAYANA TECHNOLOGIES PRIVATE LIMITED",
"TAYASH TRADE & IMPEX PRIVATE LIMITED",
"TAYLIAS INDUSTRY PRIVATE LIMITED",
"TAYLOR & FRANCIS TECHNOLOGY SERVICES LLP",
"TAYLOR AND FRANCIS BOOKS INDIA PRIVATE LIMITED",
"TAYLOR RUBBER PRIVATE LIMITED",
"TAYLORMADE RENEWABLES LIMITED",
"TAYSONS INDUSTRIES PRIVATE LIMITED",
"TAYWADE COLLEGE",
"TAZ ENGINEERING AND CONSULTANCY INDIA PRIVATE LIMITED",
"TAZ TRANSPORTS PRIVATE LIMITED",
"TAZKMAZTER CONTROLLED INSTRUMENTATION PRIVATE LIMITED",
"TB ALERT INDIA",
"TB BUSINESS ADVISORY PRIVATE LIMITED",
"TB CONSTRUCTION PRIVATE LIMITED",
"TB HOSPITAL",
"TB HYDRO FLOVEL VALVES PRIVATE LIMITED",
"TB KAWASHIMA AUNDE (INDIA) PRIVATE LIMITED",
"TB SPORTS NETWORK PRIVATE LIMITED",
"TBA INFRASTRUCTURE PRIVATE LIMITED",
"TBA JEWELS PRIVATE LIMITED",
"TBA OSNAR CHEMICAL PRIVATE LIMITED",
"TBB MEDIA PRIVATE LIMITED",
"TBCL SATNA UMARIA TOLLWAYS PRIVATE LIMITED",
"TBEA ENERGY INDIA PRIVATE LIMITED",
"TBEA GREEN ENERGY (INDIA) PRIVATE LIMITED",
"TBEA INDIA TRANSFORMER PRIVATE LIMITED",
"TBEN ULTRA PROJECTS PRIVATE LIMITED",
"TBF FASTENERS PRIVATE LIMITED",
"TBH BREWERIES INDIA PRIVATE LIMITED",
"TBJ IMPEX PRIVATE LIMITED",
"TBJP SILKS PRIVATE LIMITED",
"TBK DEEPGIRI TILE BATH KITCHEN PRIVATE LIMITED",
"TBK DEZINER'S HOME PRIVATE LIMITED",
"TBK FLORANCE CERAMICS PRIVATE LIMITED",
"TBK INDIA PRIVATE LIMITED",
"TBK PRATHAP TILE BATH KITCHEN PRIVATE LIMITED",
"TBK RAJ KAMAL TILE BATH KITCHEN PRIVATE LIMITED",
"TBK SANITARY SALES PRIVATE LIMITED",
"TBK SHRI RAM TILE BATH KITCHEN PRIVATE LIMITED",
"TBL EDUCATION (I) PRIVATE LIMITED",
"TBL INDUSTRIAL & ENGINEERING EXPORTS PRIVATE LIMITED",
"TBL INTERNATIONAL LIMITED",
"TBM TECHNOLOGIES PRIVATE LIMITED",
"TBML PROJECTS PRIVATE LIMITED",
"TBO CARGO PRIVATE LIMITED",
"TBOF FOODS PRIVATE LIMITED",
"TBOT TECHNO SYSTEMS PRIVATE LIMITED",
"TBR INFRA PRIVATE LIMITED",
"TBRC BUSINESS RESEARCH PRIVATE LIMITED.",
"TBS FACILITY SERVICES PRIVATE LIMITED",
"TBS FOREVER RETAILS PRIVATE LIMITED",
"TBS INDIA TELEMATIC AND BIOMEDICAL SERVICES PRIVATE LIMITED",
"TBS METAL PRIVATE LIMITED",
"TBS2 SERVICES PRIVATE LIMITED",
"TBSE HOTELS PRIVATE LIMITED",
"TBWA INDIA PRIVATE LIMITED",
"TBZ NIRMAL ZAVERI P LIMITED",
"TC COMPONENTS INDIA PRIVATE LIMITED",
"TC INFOTECH PRIVATE LIMITED",
"TC LINK PROJECTS PRIVATE LIMITED",
"TC ORNAMENTS PRIVATE LIMITED",
"TC R ENGINEERING SERVICES PRIVATE LIMITED",
"TC TEXTILES PRIVATE LIMITED",
"TC TRAVEL & SERVICES PRIVATE LIMITED",
"TC WIRE & CABLES PRIVATE LIMITED",
"TCA CONSULTANTS PRIVATE LIMITED",
"TCB ACCOUNTING SERVICES PRIVATE LIMITED",
"TCB CONFERENCE BOARD INDIA PRIVATE LIMITED",
"TCC BUILDERS PRIVATE LIMITED",
"TCC CONCEPT LIMITED",
"TCC CONSTRUCTION PRIVATE LIMITED",
"TCCI MANUFACTURING INDIA PRIVATE LIMITED",
"TCCO INDIA PROJECTS PRIVATE LIMITED",
"TCD TECHNOLOGIES PRIVATE LIMITED",
"TCE SERVICES PRIVATE LIMITED",
"TCF CHOCOLATES AND GIFTS PRIVATE LIMITED",
"TCF LOGISTICS PRIVATE LIMITED",
"TCFC FINANCE LIMITED",
"TCFS INDIA PRIVATE LIMITED",
"TCG ADVISORY SERVICES PRIVATE LIMITED",
"TCG CENTRES FOR RESEARCH AND EDUCATION IN SCIENCE AND TECHNOLOGY",
"TCG DEVELOPMENTS INDIA PVT LTD",
"TCG DIGITAL SOLUTIONS PRIVATE LIMITED",
"TCG FACILITIES MANAGEMENT SERVICES PRIVATE LIMITED",
"TCG LIFESCIENCES PRIVATE LIMITED",
"TCG MY-OFFICE PRIVATE LIMITED",
"TCG REAL ESTATE INVESTMENT MANAGEMENT CO PRIVATE LIMITED",
"TCG SOFTWARE SERVICES PRIVATE LIMITED",
"TCG STOCK BROKING PRIVATE LIMITED",
"TCG URBAN INFRASTRUCTURE HOLDINGS PRIVATE LIMITED",
"TCGLOBAL INDIA PRIVATE LIMITED",
"T-CHOWK LABS PRIVATE LIMITED",
"TCI BHORUKA PROJECTS LIMITED",
"TCI CHEMICALS INDIA PRIVATE LIMITED",
"TCI COLD CHAIN SOLUTIONS LIMITED",
"TCI DEVELOPERS LIMITED",
"TCI EXIM PRIVATE LIMITED",
"TCI EXPRESS LIMITED",
"TCI HI-WAYS PRIVATE LIMITED",
"TCI INDIA LIMITED",
"TCI INDUSTRIES LIMITED",
"TCI INFRASTRUCTURE LIMITED",
"TCI RESEARCH PRIVATE LIMITED",
"TCI TELENET SOLUTIONS PRIVATE LIMITED",
"TCI-CONCOR MULTIMODAL SOLUTIONS PRIVATE LIMITED",
"TCI-GO VACATION INDIA PRIVATE LIMITED",
"TCIL BINA TOLL ROAD LIMITED",
"TCIL LAKHNADONE TOLL ROAD LIMITED",
"TCIS INDIA PRIVATE LIMITED",
"TCL CERAMICS LIMITED",
"TCL INDIA HOLDINGS PRIVATE LIMITED",
"TCL INTERMEDIATES PRIVATE LIMITED",
"TCL MONITORS PRIVATE LIMITED",
"TCM EXIM PRIVATE LIMITED",
"TCM FINANCIAL SERVICES PRIVATE LIMITED",
"TCM FOXP&D PRIVATE LIMITED",
"TCM HAULERS (INDIA) PRIVATE LIMITED",
"TCM LIMITED",
"TCM LOGISTICS PRIVATE LIMITED",
"TCM SPORTS MANAGEMENT PRIVATE LIMITED",
"TCMPL LOGISTICS PRIVATE LIMITED",
"TCNS CLOTHING CO. LIMITED",
"TCNS LIMITED",
"TCO RELIANCE INDIA PRIVATE LIMITED",
"TCOGNITION CONSULTANCY PRIVATE LIMITED",
"TC-ONE PROPERTIES AND PROJECTS (INDIA) PRIVATE LIMITED",
"T-CONSTRO HUB PRIVATE LIMITED",
"TCP HOMES & DECOR PRIVATE LIMITED",
"TCP INTERNATIONAL PRIVATE LIMITED",
"TCP LIMITED",
"TCP WAVE PRIVATE LIMITED",
"TCPL INNOFILMS PRIVATE LIMITED",
"TCPL PACKAGING LIMITED",
"TCR ADVANCED ENGINEERING PRIVATE LIMITED",
"TCR TRADING PRIVATE LIMITED",
"TCRC INSPECTIONS PRIVATE LIMITED",
"TCRPL GURUGRAM CITY TRANSPORT PRIVATE LIMITED",
"TCS & ASSOCIATES PRIVATE LIMITED",
"TCS E-SERVE INTERNATIONAL LIMITED",
"TCS FOUNDATION",
"TCT AQUA CHEMICALS PRIVATE LIMITED",
"TCT LINENS PRIVATE LIMITED",
"TCT THE CONTENT TEAM PRIVATE LIMITED",
"TCT VENTURES PRIVATE LIMITED",
"TCTS PRIVATE LIMITED",
"TCTT INDIA PRIVATE LIMITED",
"TCTT TOURISM PRIVATE LIMITED",
"TCUBE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"TCV COFFEE VAULT BEVERAGES PRIVATE LIMITED",
"TCW HOMES PRIVATE LIMITED",
"TCW INFRAESTATE PRIVATE LIMITED",
"TCW REALTY PRIVATE LIMITED",
"TCW TEA PRIVATE LIMITED",
"TCY LEARNING SOLUTIONS PRIVATE LIMITED",
"TCZ DIGITAL PRIVATE LIMITED",
"TD MEDIA NETWORK PRIVATE LIMITED",
"TD POWER SYSTEMS LIMITED",
"TDA AUTOWORKS PRIVATE LIMITED",
"TDA WELLNESS PRIVATE LIMITED",
"TDC AGRO FOODS PRIVATE LIMITED",
"TDCX DIGILAB INDIA PRIVATE LIMITED",
"TDD HOME PRIVATE LIMITED",
"TDF BRANDS PRIVATE LIMITED",
"TDF DIAMOND FACTORY INDIA PRIVATE LIMITED",
"TDF MOTOWERKS AND SERVICES PRIVATE LIMITED",
"TDFM INFRASTRUCTURE PRIVATE LIMITED",
"TDI INFRACORP INDIA LIMITED",
"TDI INFRATECH LIMITED",
"TDI INTERNATIONAL INDIA PRIVATE LIMITED",
"TDI MANSION PRIVATE LIMITED",
"TDI MARKETING PRIVATE LIMITED",
"TDI REALCON PRIVATE LIMITED",
"TDK INDIA PRIVATE LIMITED",
"TDM FABRICS PRIVATE LIMITED",
"TDR ENGINEERS AND FABRICATORS LLP",
"TDS INFRA ESTATE DEVELOPERS PRIVATE. LIMITED",
"TDS LITHIUM ION BATTERY GUJARAT PRIVATE LIMITED",
"TDS MANAGEMENT CONSULTANT PRIVATE LIMITED",
"TDS PLACEMENTS AND SERVICES PRIVATE LIMITED",
"TDS STEEL SOLUTIONS PRIVATE LIMITED",
"TE CONNECTIVITY GLOBAL SHARED SERVICES INDIA PRIVATE LIMITED",
"TE CONNECTIVITY INDIA PRIVATE LIMITED",
"TE CONNECTIVITY SERVICES INDIA PRIVATE LIMITED",
"TE DEUM CONSTRUCTION PRIVATE LIMITED",
"TE HOSPITALITY & ESTATES LIMITED",
"TE THERMO ELECTRIC COMPANY INDIA PRIVATE LIMITED",
"TEA BOARD OF INDIA",
"TEA CHAMPAGNE PVT LTD",
"TEA CONSULTANCY & PLANTATION SERVICES (INDIA) PVT LTD",
"TEA DISTRIBUTORS (INDIA) PVT LTD",
"TEA ESTATES INDIA LIMITED",
"TEA EXPERTS INDIA PRIVATE LIMITED",
"TEA PACKERS INDIA PVT LTD",
"TEA POST PRIVATE LIMITED",
"TEA PROMOTERS (INDIA) PVT LTD",
"TEA PROMOTERS EXPORTS PRIVATE LIMITED",
"TEA SERVICES INDIA PRIVATE LIMITED",
"TEA STUDIO PRIVATE LIMITED",
"TEA4HEALTH PRIVATE LIMITED",
"TEACH TO LEAD",
"TEACHERS CO OPERATIVE BANK LTD",
"TEACHFORCE EDUCATION & TRAINING PRIVATE LIMITED",
"TEACHSMART GLOBAL LEARNING SOLUTIONS PRIVATE LIMITED",
"TEADIT PACKING AND GASKETS PRIVATE LIMITED",
"TEAFIZZ ENTERPRISES PRIVATE LIMITED",
"TEAGLE ELEVATORS PRIVATE LIMITED",
"TEAK STAFFING PRIVATE LIMITED",
"TEALOGY CAFE PRIVATE LIMITED",
"TEAM 1 SECURITY AND ALLIED SERVICES PRIVATE LIMITED",
"TEAM 10 MARCH ARCHITECTS & GRAPHIC DESIGNERS PRIVATE LIMITED",
"TEAM 360 DEGREE GLOBAL INDIA PRIVATE LIMITED",
"TEAM AGROTECH PRIVATE LIMITED",
"TEAM ANAMIKA ALGO LIMITED",
"TEAM ARMOR FOUR SHIELD PRIVATE LIMITED",
"TEAM ASV CONSULTANTS PRIVATE LIMITED",
"TEAM AUTO TECH INDIA PRIVATE LIMITED",
"TEAM AVIATION INDIA PRIVATE LIMITED",
"TEAM BACKSTAGE PRIVATE LIMITED",
"TEAM BRYKS PRIVATE LIMITED",
"TEAM CARGO CONSOLIDATION PRIVATE LIMITED",
"TEAM COMPUTER PRIVATE LIMITED",
"TEAM COMPUTERS PRIVATE LIMITED",
"TEAM DELTA OUTSOURCING SERVICES PRIVATE LIMITED",
"TEAM DETAILING SOLUTIONS PRIVATE LIMITED",
"TEAM ENGINEERS ADVANCE TECHNOLOGIES INDIA PRIVATE LIMITED",
"TEAM ENGINEERS PRIVATE LIMITED",
"TEAM EXPERTS TOURS & TRAVEL PRIVATE LIMITED",
"TEAM EXPRESS PRIVATE LIMITED",
"TEAM FERRO ALLOYS PRIVATE LIMITED",
"TEAM FRONTLINE LIMITED",
"TEAM GROWTH PRIVATE LIMITED",
"TEAM HR GSA PRIVATE LIMITED",
"TEAM HR SERVICES LIMITED",
"TEAM HR SERVICES PRIVATE LIMITED",
"TEAM HRD CONSULTING PRIVATE LIMITED",
"TEAM IDEAL PRIVATE LIMITED",
"TEAM INDIA FOODS PRIVATE LIMITED",
"TEAM INDIA MANAGERS LIMITED",
"TEAM INERTIA TECHNOLOGIES",
"TEAM INFOVISION PRIVATE LIMITED",
"TEAM INFRASTRUCTURES PRIVATE LIMITED",
"TEAM INSURANCE SURVEYORS AND LOSS ASSESSORS LLP",
"TEAM JSTAR ENTERPRISES PRIVATE LIMITED",
"TEAM LABEL (INDIA) PRIVATE LIMITED",
"TEAM LIFTSS-IT SYSTEMS AND SOLUTIONS PRIVATE LIMITED",
"TEAM MANGO MEDIA PRIVATE LIMITED",
"TEAM MEDIA & HOSPITALITY PRIVATE LIMITED",
"TEAM MYRIADS IT PRIVATE LIMITED",
"TEAM ONE ARCHITECTS INDIA PRIVATE LIMITED",
"TEAM ONE ARTEQ PRIVATE LIMITED",
"TEAM ONE TECHNOLOGIES PRIVATE LIMITED",
"TEAM PAPERS PRIVATE LIMITED",
"TEAM PLUS HR SERVICES PRIVATE LIMITED",
"TEAM PURPLENEST STUDIOS PRIVATE LIMITED",
"TEAM ROTEK ENGINEERING PRIVATE LIMITED",
"TEAM RUSTIC PRIVATE LIMITED",
"TEAM SEEDS PRIVATE LIMITED",
"TEAM SPECIALITY HOSPITAL PRIVATE LIMITED",
"TEAM STRENGTH SOLUTIONS PRIVATE LIMITED",
"TEAM SYNERGEIN GLOBAL SOLUTIONS PRIVATE LIMITED",
"TEAM TIGER ENTERPRISES PRIVATE LIMITED",
"TEAM TRANQUIL SOFTWARE SOLUTIONS PRIVATE LIMITED",
"TEAM TRANS LOGISTICS PRIVATE LIMITED",
"TEAM TWEAKS TECHNOLOGIES PRIVATE LIMITED",
"TEAM UNITED MARKETING PRIVATE LIMITED",
"TEAM UNIVERSAL INFRATECH PRIVATE LIMITED",
"TEAM VERTEX GLOBAL SERVICES LLP",
"TEAM WIRELESS SERVICES PRIVATE LIMITED",
"TEAM WORK GLASS SOLUTIONS PRIVATE LIMITED",
"TEAM WORK PROJECT CONSULTANTS PRIVATE LIMITED",
"TEAM WORXS TECHIN PRIVATE LIMITED",
"TEAM ZOOM SERVICES PRIVATE LIMITED",
"TEAM1 CONSULTING PRIVATE LIMITED",
"TEAM365 INFRA PROJECTS PRIVATE LIMITED",
"TEAM4 LIFE SPACES LLP",
"TEAM5 TECHNOLOGIES PRIVATE LIMITED",
"TEAMAFCO PRIVATE. LIMITED.",
"TEAMALCO SOLUTIONS PRIVATE LIMITED",
"TEAMARCS TECHNOLOGIES PRIVATE LIMITED",
"TEAMASIA MARKETING PRIVATE LIMITED",
"TEAMASIA TECHNICAL TEXTILE PRIVATE LIMITED",
"TEAMBEST ASIA PRIVATE LIMITED",
"TEAMCYCLE WORLD PRIVATE LIMITED",
"TEAMEDGE DEVELOPERS & LAND CONSTRUCTION PRIVATE LIMITED",
"TEAMEDGE SERVICES PRIVATE LIMITED",
"TEAMEX RETAIL LIMITED",
"TEAMF1 NETWORKS PRIVATE LIMITED",
"TEAMG SOLUTIONS PRIVATE LIMITED",
"TEAMGLOBAL AIRCON PRIVATE LIMITED",
"TEAMGLOBAL LOGISTICS PRIVATE LIMITED",
"TEAMIE INDIA PRIVATE LIMITED",
"TEAMINSPIRE BUSINESS SOLUTIONS PRIVATE LIMITED",
"TEAMJEC PROJECTS INDIA PRIVATE LIMITED",
"TEAMLEADER LOGISTICS PRIVATE LIMITED",
"TEAMLEASE DIGITAL PRIVATE LIMITED",
"TEAMLEASE EDTECH LIMITED",
"TEAMLEASE EDUCATION FOUNDATION",
"TEAMLEASE HRTECH PRIVATE LIMITED",
"TEAMLEASE REGTECH PRIVATE LIMITED",
"TEAMLEASE SERVICES LIMITED",
"TEAMLEASE SKILLS UNIVERSITY",
"TEAMMINDS SOFTWARE PRIVATE LIMITED",
"TEAMO PRODUCTIONS HQ LIMITED",
"TEAMONE COMPOSITES PRIVATE LIMITED",
"TEAMONE HVAC SERVICES PRIVATE LIMITED",
"TEAMONE INDIA PRIVATE LIMITED",
"TEAMONE LOGISTICS SOLUTIONS PRIVATE LIMITED",
"TEAMPLAY MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"TEAMPRO HR & IT SERVICES PRIVATE LIMITED",
"TEAMQUEST CONSULTANT PRIVATE LIMITED",
"TEAMSPACE FINANCIAL SERVICES PRIVATE LIMITED",
"TEAMSPIRIT LOGISTICS (INDIA) PRIVATE LIMITED",
"TEAMSTAND INDIA PRIVATE LIMITED",
"TEAMSTREAMZ INDIA PRIVATE LIMITED",
"TEAMSUCCESSO SOFTWARE PRIVATE LIMITED",
"TEAMSWIFT PROJECTS PRIVATE LIMITED",
"TEAMTECH ELECTRONICS LIMITED",
"TEAMTECH FORMWORK SOLUTIONS PRIVATE LIMITED",
"TEAMTRONIX (INDIA) PRIVATE LIMITED",
"TEAMULTIMA SERVICES PRIVATE LIMITED",
"TEAMVIEW LOGISTICS PRIVATE LIMITED",
"TEAMVIEWER INDIA PRIVATE LIMITED",
"TEAMWIN GLOBAL TECHNOLOGICA PRIVATE LIMITED",
"TEAMWORK ARTS PRIVATE LIMITED",
"TEAMWORK CABLES PRIVATE LIMITED",
"TEAMWORK COMMUNICATION SOLUTIONS PRIVATE LIMITED",
"TEAMWORK EDUCATION PRIVATE LIMITED",
"TEAMWORK GLASS SOLUTIONS PRIVATE LIMITED",
"TEAMWORK INFO SOLUTIONS PRIVATE LIMITED",
"TEAMWORK RETAIL PRIVATE LIMITED",
"TEAMWORLD LOGISTICS PRIVATE LIMITED",
"TEAMX MANPOWER CONSULTANCY PRIVATE LIMITED",
"TEASEL INFOTECH PRIVATE LIMITED",
"TEASPOON PHARMACEUTICALS (INDIA) PRIVATE LIMITED",
"TEATREE HEALTHCARE PRIVATE LIMITED",
"TEAXPRESS PRIVATE LIMITED",
"TEB SOLUTIONS PRIVATE LIMITED",
"TEBLIK DRUGS PRIVATE LIMITED",
"TEBMA MARINE PRIVATE LIMITED",
"TEBMA SHIPYARDS LIMITED",
"TEBNINE FOOD FACILITIES AND PROJECT MANAGEMENT PRIVATE LIMITED",
"TEC DATUM INFOSERVICES PRIVATE LIMITED",
"TEC HOME",
"TEC INDIA ENTERTAINMENT PRIVATE LIMITED",
"TEC PAPERS PRIVATE LIMITED",
"TEC ZONE RETAIL PRIVATE LIMITED",
"TECAFE SOFTWARE PRIVATE LIMITED",
"TECAFINE POLYMER PRIVATE LIMITED",
"TECBLIC PRIVATE LIMITED",
"TECCAP ELECTRONICS PVT LTD",
"TECDATA EDUCATION SERVICES PRIVATE LIMITED",
"TECE INDIA PRIVATE LIMITED",
"TECFORLIME INDIA PRIVATE LIMITED",
"TECGENOME CONSULTING PRIVATE LIMITED",
"TECH 4 LOGIC PRIVATE LIMITED",
"TECH ACTIVE SOLUTIONS INDIA PRIVATE LIMITED",
"TECH ALMOND SOLUTIONS PRIVATE LIMITED",
"TECH ANCUBATE PRIVATE LIMITED",
"TECH ARCH AUTOCOMP PRIVATE LIMITED",
"TECH AUTO PRIVATE LIMITED",
"TECH BLUE SOFTWARE PRIVATE LIMITED",
"TECH BUSINESS INDIA PRIVATE LIMITED",
"TECH CARE FOR ALL INDIA PRIVATE LIMITED",
"TECH CHASKA PRIVATE LIMITED",
"TECH CHEF DATARECOVERY",
"TECH CLEAN INDIA PRIVATE LIMITED",
"TECH CONNECT SERVICES PRIVATE LIMITED",
"TECH CONTROL SYSTEMS PRIVATE LIMITED",
"TECH DATA ADVANCED SOLUTIONS INDIA PRIVATE LIMITED",
"TECH DATA CORPORATION",
"TECH DATA SOLUTION PRIVATE LIMITED",
"TECH DELTA ENGINEERING PRIVATE LIMITED",
"TECH EDUCATION DEPT-GOVT RAJ",
"TECH ELECON PRIVATE LIMITED",
"TECH ENVIROZ PRIVATE LIMITED",
"TECH ESSENTIA LLP",
"TECH ETHOS ENGINEERS PRIVATE LIMITED",
"TECH EVANGELIST PRIVATE LIMITED",
"TECH EXTENSOR PRIVATE LIMITED",
"TECH FAKTORY VENTURES PRIVATE LIMITED",
"TECH FIELD PRIVATE LIMITED",
"TECH FIREFLY PRIVATE LIMITED",
"TECH FLOW ENGINEERS INDIA PRIVATE LIMITED",
"TECH FLOW IT SOLUTIONS PRIVATE LIMITED",
"TECH FLOW VALVES (INDIA) PRIVATE LIMITED",
"TECH FORCE WAYAND PRIVATE LIMITED",
"TECH GALLERY PRIVATE LIMITED",
"TECH GREEN ENTERPRISES PRIVATE LIMITED",
"TECH HOLDING PRIVATE LIMITED",
"TECH I.S. INDIA PRIVATE LIMITED",
"TECH INDIA ELECTROSOLUTIONS PRIVATE LIMITED",
"TECH INDIA ENGINEERS PRIVATE LIMITED",
"TECH INDIA SOLUTIONS PRIVATE LIMITED",
"TECH MAHINDRA BUSINESS SERVICES",
"TECH MAHINDRA CERIUM PRIVATE LIMITED",
"TECH MAHINDRA FOUNDATION",
"TECH MAHINDRA GROWTH FACTORIES LIMITED",
"TECH MAHINDRA LIMITED",
"TECH NEXT SOFTWARE PRIVATE LIMITED",
"TECH NIRMAN ISPAT PRIVATE LIMITED",
"TECH OBSERVER INDIA PRIVATE LIMITED",
"TECH ORBIT SOFT SYSTEMS PRIVATE LIMITED",
"TECH PACIFIC EXPORTS PRIVATE LIMITED",
"TECH PLAASTIC INDUSTRIE PRIVATE LIMITED",
"TECH PLASTFEB PRIVATE LIMITED",
"TECH PLASTIC INDUSTRIES PRIVATE LIMITED",
"TECH PRASTISH SOFTWARE SOLUTIONS PRIVATE LIMITED",
"TECH PROJECTS INDIA PRIVATE LIMITED",
"TECH Q WARE TECHNOLOGIES PRIVATE LIMITED",
"TECH RAPPO PRIVATE LIMITED",
"TECH RECEPTIVES SOLUTIONS PRIVATE LIMITED",
"TECH REVO INDIA PRIVATE LIMITED",
"TECH RIDGE SOLUTIONS PRIVATE LIMITED",
"TECH SAVVY ENGINEERS PRIVATE LIMITED",
"TECH SEA TOOLS PRIVATE LIMITED",
"TECH SERVERS INFRA PRIVATE LIMITED",
"TECH SERVICES",
"TECH SHARP ENVIRO SYSTEMS PRIVATE LIMITED",
"TECH SIS LIMITED",
"TECH SMART",
"TECH SMCSQUARED (GCC) INDIA PRIVATE LIMITED",
"TECH SOLAR SOLUTIONS PRIVATE LIMITED",
"TECH SPANNER INFO PRIVATE LIMITED",
"TECH SPHERE ENGINEERING PRIVATE LIMITED",
"TECH STEEL DESIGN SERVICES PRIVATE LIMITED",
"TECH SUPPORT INFRASTRUCTURE PRIVATE LIMITED",
"TECH SUTRE INDUSTRIES LIMITED",
"TECH SYNERGY TECHNOLOGY PRIVATE LIMITED",
"TECH TANGENT SOLUTIONS PRIVATE LIMITED",
"TECH U GO PRIVATE LIMITED",
"TECH UP ENGINEERING PRIVATE LIMITED",
"TECH VEDIKA SOFTWARE PRIVATE LIMITED",
"TECH VIBRANT INNOVATIVE SOLUTIONS PRIVATE LIMITED",
"TECH VIKAS PRIVATE LIMITED",
"TECH VISIT IT PRIVATE LIMITED",
"TECH WIZARD IT AND INFRA PRIVATE LIMITED",
"TECH XERS TECHNOLOGIES PRIVATE LIMITED",
"TECH27 SYSTEMS PRIVATE LIMITED",
"TECH2GLOBE WEB SOLUTIONS INDIA PRIVATE LIMITED",
"TECH2GLOBE WEB SOLUTIONS LLP",
"TECH3COMMERCE INNOVATION LAB PRIVATE LIMITED",
"TECH3PILLARS TECHNOLOGIES, LLC",
"TECH630 SOFTWARE PRIVATE LIMITED",
"TECHABOARD DIGI SOLUTIONS PRIVATE LIMITED",
"TECHAFFINITY GLOBAL PRIVATE LIMITED",
"TECHAHEAD SOFTWARE PRIVATE LIMITED",
"TECHAID SYSTEMS PRIVATE LIMITED",
"TECHAIM INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"TECHARMY CONSULTING INDIA PRIVATE LIMITED",
"TECHAROHA SOLUTIONS PRIVATE LIMITED",
"TECHARSH PRIVATE LIMITED",
"TECHART SOFTWARE SOLUTIONS PRIVATE LIMITED",
"TECHASOFT PRIVATE LIMITED",
"TECHASPECT SOLUTIONS PRIVATE LIMITED",
"TECHATALYST SOFTWARE PRIVATE LIMITED",
"TECHATI INDIA PRIVATE LIMITED",
"TECHAVIDUS PRIVATE LIMITED",
"TECHAVIOM FINANCE PRIVATE LIMITED",
"TECHBEAN SYSTEMS PRIVATE LIMITED",
"TECHBEATS SOFTWARE PRIVATE LIMITED",
"TECHBELIEVER TECHNOLOGIES PRIVATE LIMITED",
"TECHBERG ENTERPRISE SOLUTIONS PRIVATE LIMITED",
"TECHBERRY INFOTECH PRIVATE LIMITED",
"TECHBINS SOLUTIONS PRIVATE LIMITED",
"TECHBIT SOLUTIONS PRIVATE LIMITED",
"TECHBIZ INFOSERVICES PRIVATE LIMITED",
"TECHBLISS DIGITAL SOLUTION PRIVATE LIMITED",
"TECHBLOCKS CONSULTING PRIVATE LIMITED",
"TECHBOLT INDUSTRIES PRIVATE LIMITED",
"TECHBOOKS ELECTRONIC SERVICES PRIVATE LIMITED",
"TECHBOOKS INTERNATIONAL PRIVATE LIMITED",
"TECHBORN VENTURES PRIVATE LIMITED",
"TECHBRAWN IT SOLUTIONS PRIVATE LIMITED",
"TECHBRIDGE RESOURCE PRIVATE LIMITED",
"TECHBRO SOFTWARE PRIVATE LIMITED",
"TECHBUILD IMPEX PVT LTD",
"TECHBULLS SOFTTECH PRIVATE LIMITED",
"TECHBULLS SOFTWARE SERVICES PRIVATE LIMITED",
"TECHBYTE INDIA ENGINEERING PRIVATE LIMITED",
"TECHCANOPY SOFTWARE LABS PRIVATE LIMITED",
"TECHCARGO LOGISTICS INDIA PRIVATE LIMITED",
"TECHCELLENCE SERVICES PRIVATE LIMITED",
"TECHCHEF DATA RECOVERY",
"TECHCHEFS SOFTWARE PRIVATE LIMITED",
"TECHCIL TECHNOLOGY PRIVATE LIMITED",
"TECHCITI TECHNOLOGIES PRIVATE LIMITED",
"TECHCLUB TECHNOLOGIES PRIVATE LIMITED",
"TECHCOM PRECISION INDIA PRIVATE LIMITED",
"TECHCOM SOLUTIONS INDIA PRIVATE LIMITED",
"TECHCOM TECHNOLOGIES PRIVATE LIMITED",
"TECHCOMPOSE SOLUTIONS PRIVATE LIMITED",
"TECHCON INDIA PRIVATE LIMITED",
"TECHCON INFRASTRUCTURE PRIVATE LIMITED",
"TECH-CONNECT RETAIL PRIVATE LIMITED",
"TECHCOOPERS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"TECHCORR INDIA PRIVATE LIMITED",
"TECHCRONUS BUSINESS SOLUTIONS PRIVATE LIMITED",
"TECHCULTURE SOLUTIONS PRIVATE LIMITED",
"TECHCURL MEDIA SOLUTIONS PRIVATE LIMITED",
"TECHDEFENCE LABS SOLUTIONS PRIVATE LIMITED",
"TECHDENALI INDIA PRIVATE LIMITED",
"TECHDEV IT SOLUTIONS PRIVATE LIMITED",
"TECHDEW UX DESIGN AND CONSULTING PRIVATE LIMITED",
"TECHDIGITAL INDIA PRIVATE LIMITED",
"TECHDOGS MARKETING PRIVATE LIMITED",
"TECHDOQUEST PRIVATE LIMITED",
"TECHEALERZ SOLUTIONS PRIVATE LIMITED",
"TECHEASE SYSTEMS PRIVATE LIMITED",
"TECHEDGE AIR ENGINEERING PRIVATE LIMITED",
"TECHEDGE COATING AND MFG PRIVATE LIMITED",
"TECHEFFICIO SOLUTIONS PRIVATE LIMITED",
"TECHENCE IT SOLUTIONS PRIVATE LIMITED",
"TECHENGG PROJECT SERVICES & EQUIPMENTS INDIA PRIVATE LIMITED",
"TECHERA ENGINEERING INDIA PRIVATE LIMITED",
"TECHERA IT CONSULTING PRIVATE LIMITED",
"TECHERGO SOLUTIONS LIMITED",
"TECHESPACE TECHNOLOGIES PRIVATE LIMITED",
"TECHEXCEL SOFTWARE SOLUTIONS PRIVATE LIMITED",
"TECHEXPED TECHNOLOGY SERVICES PRIVATE LIMITED",
"TECHEXPERT ENGINEERING PRIVATE LIMITED",
"TECHFAB EXPORTS PRIVATE LIMITED",
"TECHFAB INDIA INDUSTRIES LIMITED",
"TECHFAB INTERNATIONAL PRIVATE LIMITED.",
"TECHFAB SYSTEMS PRIVATE LIMITED",
"TECHFANATICS EQUIPMENT LIMITED",
"TECH-FAST REBUILD PRIVATE LIMITED",
"TECHFAYA INNOVATIONS PRIVATE LIMITED",
"TECHFER GLOBAL PRIVATE LIMITED",
"TECHFERRY INFOTECH PRIVATE LIMITED",
"TECHFIL ENGINEERING LLP",
"TECHFIN CONSULTANTS PRIVATE LIMITED",
"TECHFINO CAPITAL PRIVATE LIMITED",
"TECHFIT ENGINEERING PRIVATE LIMITED",
"TECHFLEX SOLUTIONS PRIVATE LIMITED",
"TECHFLITTER SOLUTIONS PRIVATE LIMITED",
"TECHFLOW ENTERPRISES PRIVATE LIMITED",
"TECHFLUENT SOLUTIONS PRIVATE LIMITED",
"TECHFOCO GLOBAL SERVICES PRIVATE LIMITED",
"TECHFORCE COMPOSITES PVT LTD",
"TECHFORCE CONSULTANT PRIVATE LIMITED",
"TECHFORCE INFOTECH PRIVATE LIMITED",
"TECHFOUR ENGINEERING SOLUTIONS PRIVATE LIMITED",
"TECHFROLIC SOFTWARE SOLUTIONS PRIVATE LIMITED",
"TECHFRUIT TECHNOLOGIES PRIVATE LIMITED",
"TECHFRUITS SOLUTIONS PRIVATE LIMITED",
"TECHFULLY PRIVATE LIMITED",
"TECHGENE SOLUTIONS PRIVATE LIMITED",
"TECHGENTSIA SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"TECHGRAINS TECHNOLOGIES PRIVATE LIMITED",
"TECHGRIT SOLUTIONS INDIA PRIVATE LIMITED",
"TECHHIGHWAY SYSTEMS PRIVATE LIMITED",
"TECHIEANTS PRIVATE LIMITED",
"TECHIEVOLVE GLOBAL IT SOLUTIONS PRIVATE LIMITED",
"TECHIFY SOLUTIONS PRIVATE LIMITED",
"TECHIGENT TECHNOLOGIES PRIVATE LIMITED",
"TECHILA GLOBAL SERVICES LIMITED",
"TECHILA GLOBAL SERVICES PRIVATE LIMITED",
"TECHILA SOLUTIONS PRIVATE LIMITED",
"TECHIN PROCESS TECHNOLOGIES PRIVATE LIMITED",
"TECH-INDIA INFOSOLUTIONS PRIVATE LIMITED",
"TECHINDIA INFOWAY PRIVATE LIMITED",
"TECHINDUSTAN SOLUTIONS PRIVATE LIMITED",
"TECHINFINI SOLUTIONS PRIVATE LIMITED",
"TECHINFINITI INFOSOLUTIONS PRIVATE LIMITED",
"TECHINFY SOLUTIONS PRIVATE LIMITED",
"TECHINT INDIA PRIVATE LIMITED TERNIUM GROUP",
"TECHINTERIO PRIVATE LIMITED",
"TECHINVENTION LIFECARE PRIVATE LIMITED",
"TECHIVIES SOLUTIONS PRIVATE LIMITED",
"TECHIZEN INDIA PRIVATE LIMITED",
"TECHJIVAA SOFTWARE PRIVATE LIMITED",
"TECHJOCKEY INFOTECH PRIVATE LIMITED",
"TECHKART TECHNOLOGIES PRIVATE LIMITED",
"TECHKNOMATIC SERVICES PRIVATE LIMITED",
"TECHKNOW VISTA TECHNOLOGIES PRIVATE LIMITED",
"TECHKNOWLABS PRIVATE LIMITED",
"TECHKNOWLOGIC CONSULTANTS INDIA PRIVATE LIMITED",
"TECHKNOWSENSATIONS PRIVATE LIMITED",
"TECHKRAFT INDUSTRIES PRIVATE LIMITED",
"TECHLAB AUTO GAS PRIVATE LIMITED",
"TECHLAB HEALTHCARE PRIVATE LIMITED",
"TECHLAND SYSTEMS PRIVATE LIMITED",
"TECHLANDERS SOLUTIONS LLP",
"TECH-LATEETUD PRIVATE LIMITED",
"TECHLEAD INFRA PROJECTS PRIVATE LIMITED",
"TECHLEAD SOFTWARE ENGINEERING PVT LTD",
"TECHLET SOLUTIONS PRIVATE LIMITED",
"TECHLICIOUS DESIGN AND DEVELOPMENT PRIVATE LIMITED",
"TECHLIGENT SYSTEMS PRIVATE LIMITED",
"TECHLINK INFOWARE PRIVATE LIMITED",
"TECHLINK SYSTEMS INDIA PRIVATE LIMITED",
"TECHLOG SUPPORT SERVICES PRIVATE LIMITED",
"TECH LONG PACKAGING MACHINERY INDIA PRIVATE LIMITED",
"TECHLUSSO SYSTEMS PRIVATE LIMITED",
"TECH-MACHINERY AND MORE PRIVATE LIMITED",
"TECHMAGNA SOLUTIONS INDIA PRIVATE LIMITED",
"TECHMANGO TECHNOLOGY SERVICES PRIVATE LIMITED",
"TECHMANTU DIGITAL PRIVATE LIMITED OPC",
"TECHMARBLES WEB SOLUTIONS PRIVATE LIMITED",
"TECHMART DIGITAL SYSTEMS PRIVATE LIMITED",
"TECHMART SYSTEMS COMPANY PRIVATE LIMITED",
"TECHMART TECHNOLOGIES PRIVATE LIMITED",
"TECHMAS TECHNICAL SERVICES PRIVATE LIMITED",
"TECHMASTERS INFOMATRIX PRIVATE LIMITED",
"TECHMAT ENTERPRISES INDIA P LTD",
"TECHMATIC SYSTEMS INDIA PRIVATE LIMITED",
"TECHMATION INDIA EQUIPMENT PRIVATE LIMITED",
"TECHMATRIX IT CONSULTING PRIVATE LIMITED",
"TECHMECH CRANES INDIA PRIVATE LIMITED",
"TECHMECH ENGINEERS",
"TECHMED HEALTH CENTRE AND DIAGNOSTIC PRIVATE LIMITED",
"TECHMEK ENGINEERS PRIVATE LIMITED",
"TECHMENS HYDRO CARBONS PRIVATE LIMITED",
"TECHMIGHTY",
"TECHMILL TECHNOLOGIES PRIVATE LIMITED",
"TECHMINDS GROUP INDIA PRIVATE LIMITED",
"TECHMINDS INFRASOL PRIVATE LIMITED",
"TECHMOBIA DIGITAL SOLUTIONS PRIVATE LIMITED",
"TECHMODEC CONSULTANTS PRIVATE LIMITED",
"TECHMOJO SOLUTIONS PRIVATE LIMITED",
"TECHMOLOGICS INNOVATIONS PRIVATE LIMITED",
"TECHMORGONITE SOFTWARE SOLUTIONS LLP",
"TECHMOVERS SYSTEMS (INDIA) LIMITED",
"TECHNA INFRASTRUCTURE PRIVATE LIMITED",
"TECHNE AI PRIVATE LIMITED",
"TECHNET GLOBAL PRIVATE LIMITED",
"TECHNET INFORMATION SYSTEMS PRIVATE LIMITED",
"TECHNET SOFTWARE SOLITIONS PRIVATE LIMITED",
"TECHNEX HARVESTGRID PRIVATE LIMITED",
"TECHNEXA TECHNOLOGIES PRIVATE LIMITED",
"TECHNEXT SOFTWARE PRIVATE LIMITED",
"TECHNEXY CONSULTING PRIVATE LIMITED",
"TECHNI BHARATHI PRIVATE LIMITED",
"TECHNI PLAST PRIVATE LIMITED",
"TECHNIC FABRICATIONS PVT LTD",
"TECHNIC PROJECT CONSULTANTS PRIVATE LIMITED",
"TECHNICA FIBER TECH PRIVATE LIMITED",
"TECHNICAL AND SCIENTIFIC SALE",
"TECHNICAL ASSISTANT SIPNA WILDLIFE DEVISION PARATWADA",
"TECHNICAL DRYING SERVICES ASIA PRIVATE LIMITED",
"TECHNICAL EDUCATION AND SKILL DEVELOPMENT GOVT . POLYTECHNIC AMBIKAPUR",
"TECHNICAL EDUCATION RAIPUR",
"TECHNICAL ENTERPENEUR AGILE MANAGEMENT",
"TECHNICAL RESOURCES AND PLANNING SERVICES PRIVATE LIMITED",
"TECHNICAL STRATEGIES (INDIA) PRIVATE LIMITED",
"TECHNICAL TEACHERS TRAINING INSTITIUE",
"TECHNICALIYA CONSULTANTS PRIVATE LIMITED",
"TECHNICHE CONSULTING SERVICES PRIVATE LIMITED",
"TECHNICHE ENGINEERING PRIVATE LIMITED",
"TECHNICHEM ORGANICS PRIVATE LIMITED",
"TECHNICIANS GUILD PVT. LTD.",
"TECHNICO AGRI SCIENCES LIMITED",
"TECHNICO INDIA PRIVATE LIMITED",
"TECHNICO INDUSTRIES LIMITED",
"TECHNICO LABORATORY PRODUCTS PRIVATE LIMITED",
"TECHNICO METALS PRIVATE LIMITED",
"TECHNICO STRIPS AND TUBES PRIVATE LIMITED",
"TECHNICOAT INDIA PRIVATE LIMITED",
"TECHNICOLOR CONNECTED HOME INDIA PRIVATE LIMITED",
"TECHNICOLOR INDIA SHARED SERVICES LLP",
"TECHNICOLOUR DREAM PANTS PRIVATE LIMITED",
"TECHNICS INFOSOLUTIONS PRIVATE LIMITED",
"TECHNICUS PROJECTS INDIA PRIVATE LIMITED",
"TECHNIGROUP INTERNATIONAL PRIVATE LIMITED",
"TECHNIK INFINITE SOLUTIONS PRIVATE LIMITED",
"TECHNIKO CONSULTANCY SERVICES PRIVATE LIMITED",
"TECHNILAND INFO SYSTEMS PRIVATE LIMITED",
"TECHNIMONT PRIVATE LIMITED",
"TECHNIP ENERGIES INDIA LIMITED",
"TECHNIP ENGINEERING WORKS PRIVATE LIMITED",
"TECHNIP INDIA LIMITED",
"TECHNIPLEX COMPLEX PRIVATE LIMITED",
"TECHNIQUE CONTROL FACILITY MANAGEMENT PRIVATE LIMITED",
"TECHNIQUE DIABRASIVES LIMITED",
"TECHNIQUE SAFETY DEVICE PRIVATE LIMITED",
"TECHNIQUE SOLAIRE INVEST 1 INDIA PRIVATE LIMITED",
"TECHNISUN SOLUTIONS PRIVATE LIMITED",
"TECHNISYS ENGINEERING PRIVATE LIMITED",
"TECHNITHON TECHNOLOGIES PRIVATE LIMITED",
"TECHNIX ACS PRIVATE LIMITED",
"TECHNO (HIND) MARBLES AND GRANITES PVT LTD",
"TECHNO AIRCON INDUSTRIES PRIVATE LIMITED",
"TECHNO AMI SOLUTIONS PRIVATE LIMITED",
"TECHNO AQUA TECH PRIVATE LIMITED",
"TECHNO ASSOCIATES VIDYUT PRIVATE LIMITED",
"TECHNO AUTO COMPONENTS INDIA PRIVATE LIMITED",
"TECHNO AUTOMOBILES PRIVATE LIMITED",
"TECHNO BLOW MOULDERS PRIVATE LIMITED",
"TECHNO BOARDS PRIVATE LIMITED",
"TECHNO BONANZA PRIVATE LIMITED",
"TECHNO BRAIN INDIA PRIVATE LIMITED",
"TECHNO BRAIN SHARED SERVICES PRIVATE LIMITED",
"TECHNO BUILDCON LLP",
"TECHNO BYTES INFORMATION PRIVATE LIMITED",
"TECHNO CENTRE (INDIA) PVT LTD",
"TECHNO CNC PRIVATE LIMITED",
"TECHNO COMMERCIAL COMPANY PRIVATE LIMITED",
"TECHNO CONCEPTS INSTRUMENTS PRIVATE LIMITED",
"TECHNO CRAT FOUNDRY CHEM PRIVATE LIMITED",
"TECHNO CREST PRIVATE LIMITED",
"TECHNO DRILLING PROJECT PRIVATE LIMITED",
"TECHNO DRIVE ENGINEERING PRIVATE LIMITED",
"TECHNO DRIVE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"TECHNO DRUGS AND INTERMEDIATES PRIVATE LIMITED",
"TECHNO EDGE ELECTRONICS PRIVATE LIMITED",
"TECHNO ELECTRIC & ENGINEERING COMPANY LIMITED",
"TECHNO ELECTROMECH PRIVATE LIMITED",
"TECHNO EMINDS PRIVATE LIMITED",
"TECHNO ENERGY ENGINEERING PRIVATE LIMITED",
"TECHNO ENGINEERING",
"TECHNO ENGINEERING & CONSULTANTS PRIVATE LIMITED",
"TECHNO ENGINEERING COLLEGE BANIPUR",
"TECHNO FABRICATORS INDIA PRIVATE LIMITED",
"TECHNO FAC CONTRACTS PRIVATE LIMITED",
"TECHNO FACTS SOLUTIONS PRIVATE LIMITED",
"TECHNO FEEDER PRIVATE LIMITED",
"TECHNO FINVESTRADE INDIA PVT LTD",
"TECHNO FIRE PROTECTION SERVICES PRIVATE LIMITED",
"TECHNO FLEX CABLES",
"TECHNO FLOW CONSTRUCTIONS PRIVATE LIMITED",
"TECHNO FORCE SOLUTION I PRIVATE LIMITED",
"TECHNO FUEL (INDIA) PRIVATE LIMITED",
"TECHNO GEAR WORKS PRIVATE LIMITED",
"TECHNO GLOBAL SERVICES PRIVATE LIMITED",
"TECHNO GRID PRIVATE LIMITED",
"TECHNO HEAVEN CONSULTANCY PRIVATE LIMITED",
"TECHNO HIPURITY WATER SYSTEMS PRIVATE LIMITED",
"TECHNO HONEY SYSTEMS PRIVATE LIMITED",
"TECHNO HUB ENGINEERS PRIVATE LIMITED",
"TECHNO HYDRAULICS PRIVATE LIMITED",
"TECHNO INDIA DAMA HEALTHCARE & MEDICAL CENTRE",
"TECHNO INDIA GROUP PUBLIC SCHOOL",
"TECHNO INDIA INSTITUTE OF TECHNOLOGY",
"TECHNO INDIA PAINTS PRIVATE LIMITED",
"TECHNO INDIA PROJECT PRIVATE LIMITED",
"TECHNO INDIA TECHHNOLOGIES LIMITED",
"TECHNO INDUSTRIES PRIVATE LIMITED",
"TECHNO INFONET GUJARAT PRIVATE LIMITED",
"TECHNO INFRACON PRIVATE LIMITED",
"TECHNO INFRATECH PROJECTS (INDIA) PRIVATE LIMITED",
"TECHNO INSTITUTE OF HEIGHER STUDIES",
"TECHNO INSTRUMENTATION (INDIA) PRIVATE LIMITED",
"TECHNO INTERNATIONAL LTD",
"TECHNO INTERNATIONAL NEW TOWN",
"TECHNO LEASING & FINANCE COMPANY PVT LTD",
"TECHNO LINK CONVEYOR SYSTEMS PRIVATE LIMITED",
"TECHNO MARKETING PRIVATE LIMITED",
"TECHNO MEDICAL SERVICES PRIVATE LIMITED",
"TECHNO MERCANTILE PRIVATE LIMITED",
"TECHNO MILLENIUM PLASTIC PRIVATE LIMITED",
"TECHNO MUSIC INDIA PRIVATE LIMITED",
"TECHNO PACK SOFTWARE SERVICES PRIVATE LIMITED",
"TECHNO PLAST INDUSTRIES",
"TECHNO POWER ENTERPRISES PRIVATE LIMITED",
"TECHNO POWER PROJECTS LTD",
"TECHNO PRECISION ENGINEERS PRIVATE LIMITED",
"TECHNO PRIME RMC PRIVATE LIMITED",
"TECHNO PRINT CHEMICALS PRIVATE LIMITED",
"TECHNO PROCESS ENGINEERING (OPC) PRIVATE LIMITED",
"TECHNO PROCESS EQUIPMENTS INDIA LIMITED",
"TECHNO PRODUCTS DEVELOPMENT PRIVATE LIMITED",
"TECHNO PROPERTY DEVELOPERS PRIVATE LIMITED",
"TECHNO QUEST",
"TECHNO RAM ENGINEERING PRIVATE LIMITED",
"TECHNO REALTORS PRIVATE LIMITED",
"TECHNO RELEIF OVERSEAS I PRIVATE.LIMITED",
"TECHNO ROOFING SYSTEM SOLUTION INDIA PRIVATE LIMITED",
"TECHNO SATCOMM INDIA PRIVATE LIMITED",
"TECHNO SINGAL TUBES PRIVATE LIMITED",
"TECHNO SPORTSWEAR PRIVATE LIMITED",
"TECHNO SPRINGS INDIA PVT LTD",
"TECHNO TARP AND POLYMERS PRIVATE LIMITED",
"TECHNO TELEPROJECTS PRIVATE LIMITED",
"TECHNO TEXTILES PRIVATE LIMITED",
"TECHNO THERMAL TREATERS PRIVATE LIMITED",
"TECHNO TOYS PRIVATE LIMITED",
"TECHNO TRADINGS AND SERVICES PRIVATE LIMITED",
"TECHNO TRANSPLUS PRIVATE LIMITED",
"TECHNO TREXIM (INDIA) PRIVATE LIMITED",
"TECHNO TRONICS PRIVATE LIMITED",
"TECHNO WAXCHEM PRIVATE LIMITED",
"TECHNO WEIGH SYSTEMS PRIVATE. LIMITED",
"TECHNO WIN IT INFRA PRIVATE LIMITED",
"TECHNO XO PRIVATE LIMITED",
"TECHNO3 AQUA PRIVATE LIMITED",
"TECHNOACE SYSTEMS PRIVATE LIMITED",
"TECHNOARETE RESEARCH AND DEVELOPMENT ASSOCIATION",
"TECHNOART CONSTRUCTIONS PRIVATE LIMITED",
"TECHNOART TOOLS AND SERVICES PRIVATE LIMITED",
"TECHNOBASE IT SOLUTIONS PRIVATE LIMITED",
"TECHNOBILE SYSTEMS PRIVATE LIMITED",
"TECHNOBIND SOLUTIONS PRIVATE LIMITED",
"TECHNOBIT INDUSTRIES PRIVATE LIMITED",
"TECHNOBIT POWER INDIA PRIVATE LIMITED",
"TECHNOBLE CONSULTING SERVICES PRIVATE LIMITED",
"TECHNO-CAP EQUIPMENTS INDIA PRIVATE LIMITED",
"TECHNOCEM SYSTEMS INDIA PRIVATE LIMITED",
"TECHNOCENTRIC SOLUTIONS PRIVATE LIMITED",
"TECHNOCHEM AGENCIES BOMBAY PRIVATE LIMITED",
"TECHNOCHEM ENGINEERS INDIA PRIVATE LIMITED",
"TECHNOCHORDS SOFTWARE PRIVATE LIMITED",
"TECHNOCIAN FASHIONS PRIVATE LIMITED",
"TECHNOCIATE SOLUTIONS PRIVATE LIMITED",
"TECHNOCLEAN EQUIPMENTS PRIVATE LIMITED",
"TECHNOCLEAN INDIA PRIVATE LIMITED",
"TECHNOCOAT SOLUTION INDIA PRIVATE LIMITED",
"TECHNOCOM",
"TECHNOCOM NETWORKS INDIA PRIVATE LIMITED",
"TECHNOCOMM INSTRUMENTS PRIVATE LIMITED",
"TECHNO COMP COMPUTER SERVICES PRIVATE LIMITED",
"TECHNOCOMPASS CONSULTING PRIVATE LIMITED",
"TECHNOCON CONSTRUCTIONS & INFRASTRUCTURE PRIVATE LIMITED",
"TECHNOCON INFRATECH INDIA PRIVATE LIMITED",
"TECHNOCONCEPT INDIA PRIVATE LIMITED",
"TECHNOCRAFT ASSOCIATES PRIVATE LIMITED",
"TECHNOCRAFT CONSTRUCTION PRIVATE. LIMITED.",
"TECHNOCRAFT CRANES PRIVATE LIMITED",
"TECHNOCRAFT FASHIONS LIMITED",
"TECHNOCRAFT INDUSTRIES INDIA LIMITED",
"TECHNOCRAFT TEXMACH PRIVATE LIMITED",
"TECHNOCRAFTS SWITCHGEARS PRIVATE LIMITED",
"TECHNOCRAT AUTO ANCILLARY PRIVATE LIMITED.",
"TECHNOCRAT CONNECTIVITY SYSTEMS PRIVATE LIMITED",
"TECHNOCRAT INFOTECH PRIVATE LIMITED",
"TECHNOCRAT MOULDINGS PVT LTD",
"TECHNOCRAT PRINTERS PRIVATE LIMITED",
"TECHNOCRATS ADVISORY SERVICES PRIVATE LIMITED",
"TECHNOCRATS ALLIANCE ENGINEERING PRIVATE LIMITED",
"TECHNOCRATS DIE CASTING INDIA PRIVATE LIMITED",
"TECHNOCRATS INSTITUTE OF TECHNOLOGY & SCIENCE",
"TECHNOCRATS KOHLHAUER INFRASTRUCTURE PRIVATE LIMITED",
"TECHNOCRATS PAPERCHEM PVT LTD",
"TECHNOCRATS PLASMA SYSTEMS PRIVATE LIMITED",
"TECHNOCRATS SAFETY & SECURITY SYSTEMS PRIVATE LIMITED",
"TECHNOCRATS SAFETY AND SECURITY SOLUTIONS PRIVATE LIMITED",
"TECHNOCRATS SALES AND SERVICES PRIVATE LIMITED",
"TECHNOCRATS SECURITY SYSTEMS PRIVATE LIMITED",
"TECHNOCRETE INDIA PRIVATE LIMITED",
"TECHNOCRUITX UNIVERSAL SERVICES PRIVATE LIMITED",
"TECHNOCUBE INDIA PRIVATE LIMITED",
"TECHNOCULTURE BUILDING CENTRE PRIVATE LIMITED",
"TECHNOCULTURE RESORTS AND BUSINESS CENTRE PRIVATE LIMITED",
"TECHNODATA ANALYTICS SERVICES PRIVATE LIMITED",
"TECHNODEAL ENERPOWER PRIVATE LIMITED",
"TECHNODEED IT SERVICES PRIVATE LIMITED",
"TECHNODENT DENTAL SOLUTION PRIVATE LIMITED",
"TECHNODENT EXIM INDIA PRIVATE LIMITED",
"TECHNODRY SYSTEM ENGINEERING PRIVATE LIMITED",
"TECHNODUCES INFO SOLUTIONS PRIVATE LIMITED",
"TECHNODYSIS PRIVATE LIMITED",
"TECHNOEDGE LEARNING SERVICES INDIA PRIVATE LIMITED",
"TECHNOEX TRADING CORPORATION PRIVATE LIMITED",
"TECHNOFAB ANNAPURNA PRIVATE LIMITED",
"TECHNOFIN INTERNATIONAL PRIVATE LIMITED",
"TECHNOFIRE PROTECTION SYSTEMS PRIVATE LIMITED",
"TECHNOFLAIR SOLUTIONS INDIA PRIVATE LIMITED",
"TECHNOFLEX RUBBER PRODUCTS PRIVATE LIMITED",
"TECHNOFLEX STEEL INDIA PRIVATE LIMITED",
"TECHNO-FLO ENGINEERS PRIVATE LIMITED",
"TECHNOFLUX ENGINEERS PRIVATE LIMITED",
"TECHNOFOCUS SOLUTIONS PRIVATE LIMITED",
"TECHNOFORCE SOLUTIONS I PRIVATE LIMITED",
"TECHNOFORM BAUTEC HOLDING GMBH",
"TECHNOFORTE SOFTWARE PRIVATE LIMITED",
"TECHNOFOUR COMBINES PRIVATE LIMITED",
"TECHNOFOUR ELECTRONICS DEFENCE PRIVATE LIMITED",
"TECHNOFOUR ELECTRONICS PRIVATE LIMITED",
"TECHNOGAS SYSTEMS PRIVATE LIMITED",
"TECHNOGEM CONSULTANTS PRIVATE LIMITED",
"TECHNOGEM ENGINEERS PRIVATE LIMITED",
"TECHNOGEN INDIA PRIVATE LIMITED",
"TECHNOGEN IT SERVICES INDIA PRIVATE LIMITED",
"TECHNOGEO SOFT SOLUTION PRIVATE LIMITED",
"TECHNOGISE PRIVATE LIMITED",
"TECHNOGRADIENT TECHNOLOGIES PRIVATE LIMITED",
"TECHNOGRAM PRIVATE LIMITED",
"TECHNOGRAPH ENGINEERING PRIVATE LIMITED",
"TECHNOGREEN AIRCONDITIONING PRIVATE LIMITED",
"TECHNOGREEN RECYCLING PRIVATE LIMITED",
"TECHNOGRIP INDUSTRIES PRIVATE LIMITED",
"TECHNOGRIP PRODUCTS PRIVATE LIMITED",
"TECHNOHEAT BAKERY EQUIPMENTS PRIVATE LIMITED",
"TECHNOHERTZ TECHNOLOGIES LLP",
"TECHNOILOGY INDIA OILS & FATS PRIVATE LIMITED",
"TECHNOKRAFT PACKAGING PRIVATE LIMITED",
"TECHNOLINE ENGINEERING (KERALA) PRIVATE LIMITED",
"TECHNOLOGY EXCHANGE SERVICES PRIVATE LIMITED",
"TECHNOLOGY HOUSE (INDIA) PRIVATE LIMITED",
"TECHNOLOGY INFORMATION ENGINEERING SERVICES PRIVATE LIMITED",
"TECHNOLOGY PLASTOMECH PRIVATE LIMITED",
"TECHNOLOGY PROMOTERS (INDIA) PRIVATE LIMITED",
"TECHNOLOGY SOLUTIONS2 INDIA PRIVATE LIMITED",
"TECHNOLOGY TIGERS PRIVATE LIMITED",
"TECHNOMAC BIOMATICS PRIVATE LIMITED",
"TECHNOMARK ENGINEERS INDIA PRIVATE LIMITED",
"TECHNOMAT COMPOSHEET PRIVATE LIMITED",
"TECHNOMAT SPRINGS PRIVATE LIMITED",
"TECHNOMATICS EQUIPMENTS PRIVATE LIMITED",
"TECHNOMATION INDIA PRIVATE LIMITED",
"TECHNOMAX ENGINEERING PRIVATE LIMITED",
"TECHNOMAX ENTERPRISES INDIA PRIVATE LIMITED",
"TECHNOMAX FLOWHOSE PRIVATE LIMITED",
"TECHNOMAX INDIA PRIVATE LIMITED",
"TECHNOMAXX FORENSICS PRIVATE LIMITED",
"TECHNOMEC ROLL MANUFACTURING COMPANY PRIVATE LIMITED",
"TECHNOMEC SOLUTIONS PRIVATE LIMITED",
"TECHNOMECAZ BUSINESS SOLUTIONS PRIVATE LIMITED",
"TECHNOMECHANICAL SERVICES PVT LTD",
"TECHNOMED ( INDIA ) PRIVATE LIMITED",
"TECHNOMED DEVICES INDIA PRIVATE LIMITED",
"TECHNOMED LIFE SCIENCE",
"TECHNOMEDIA SOLUTIONS PRIVATE LIMITED",
"TECHNOMENS INDIA PRIVATE LIMITED",
"TECHNOMILE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"TECHNOMIN METALLURGICALS PRIVATE LIMITED",
"TECHNOMINE BPO PRIVATE LIMITED",
"TECHNOMIX POLYMERS PRIVATE LIMITED",
"TECHNOMOTION ENGINEERS PRIVATE LIMITED",
"TECHNONICOL INDIA PRIVATE LIMITED",
"TECHNO-NOBLE INFOWAY LIMITED",
"TECHNOPACK POLYMERS LIMITED",
"TECHNOPAK ADVISORS PRIVATE LIMITED",
"TECHNOPAYMENT PRIVATE LIMITED",
"TECHNOPHARM PRIVATE LIMITED",
"TECHNOPHILE AUTOMATION PRIVATE LIMITED",
"TECHNOPLAST ENTERPRISES PRIVATE LIMITED",
"TECHNOPLAST PACKAGING PRIVATE LIMITED",
"TECHNOPOLIS CONSTRUCTION COMPANY PRIVATE LIMITED",
"TECHNOPOLIS DEALCOM PRIVATE LIMITED",
"TECHNOPOLIS INSURANCE BROKERS PRIVATE LIMITED",
"TECHNOPURPLE IT SOLUTIONS PRIVATE LIMITED",
"TECHNOQUEST CONSULTING PRIVATE LIMITED",
"TECHNOQUIP ENGINEERS PRIVATE LIMITED",
"TECHNORBITAL ADVANCED MATERIALS PRIVATE LIMITED",
"TECHNORIZEN SOFTWARE SOLUTIONS PRIVATE LIMITED",
"TECHNOROBOTIC MACHINES PRIVATE LIMITED",
"TECHNORR ENGINEERING PRODUCTS PRIVATE LIMITED",
"TECHNORUCS PRIVATE LIMITED",
"TECHNOS PRAZISE ENGINEERING PRIVATE LIMITED",
"TECHNOSALES MULTIMEDIA TECHNOLOGIES PRIVATE LIMITED",
"TECHNOSAVE PRODUCTS PRIVATE LIMITED",
"TECHNOSHELL AUTOMATIONS PRIVATE LIMITED",
"TECHNOSHINE VIE PRIVATE LIMITED",
"TECHNOSKILL FACADE EXPERTS PRIVATE LIMITED",
"TECHNOSMART AUTOMATION PRIVATE LIMITED",
"TECHNOSMART MANPOWER SERVICES PRIVATE LIMITED",
"TECHNOSOFT CONSULTING LLP",
"TECHNOSOFT ENGINEERING PROJECTS LIMITED",
"TECHNOSOFT GLOBAL SERVICES PRIVATE LIMITED",
"TECHNOSOFT GLOBAL SOLUTIONS LLP",
"TECHNOSOFT SERVICES PRIVATE LIMITED",
"TECHNOSOLIS INFORMATICS LIMITED",
"TECHNOSPAN STRUCTURES PRIVATE LIMITED",
"TECHNOSPHERE ENGINEERING PRIVATE LIMITED",
"TECHNOSPHERE LABS PRIVATE LIMITED",
"TECHNOSPIN INDUSTRIES PRIVATE LIMITED",
"TECHNOSPURS INDIA PRIVATE LIMITED",
"TECHNOSSUS SOFTWARE SERVICES PRIVATE LIMITED",
"TECHNOSTACKS INFOTECH PRIVATE LIMITED",
"TECHNOSTAR ENGINEERING PRIVATE LIMITED",
"TECHNOSTEEL INFRAPROJECTS PRIVATE LIMITED",
"TECHNOSTRATS CONSULTING PRIVATE LIMITED",
"TECHNOSTRENGTH PRIVATE LIMITED",
"TECHNOSYS ENGINEERS AND CONSULTANTS CHENNAI PRIVATE LIMITED",
"TECHNOSYS EQUIPMENTS PRIVATE LIMITED",
"TECHNOSYS INTEGRATED SOLUTIONS PRIVATE LIMITED",
"TECHNOSYS SERVICES PRIVATE LIMITED",
"TECHNOSYS SOFTWARE & NETWORKING SOLUTIONS PRIVATE LIMITED",
"TECHNOSYS TECHNOLOGIES PRIVATE LIMITED",
"TECHNOTALENT ENGINEERING INDIA PRIVATE LIMITED",
"TECHNOTASK BUSINESS SOLUTIONS PRIVATE LIMITED",
"TECHNOTECH AQUA INDUSTRIES PRIVATE LIMITED",
"TECHNOTECH MARKETING (INDIA) PVT. LTD.",
"TECHNOTECH TECHNOLOGIES PRIVATE LIMITED",
"TECHNOTEF ENTERPRISES PRIVATE LIMITED",
"TECHNOTHERMA FURNACES",
"TECHNOTHERMA FURNACES PRIVATE LIMITED",
"TECHNOTHERMA INDIA PRIVATE LIMITED",
"TECHNOTON SENSORS PRIVATE LIMITED",
"TECHNOTORC TOOLS PRIVATE LIMITED",
"TECHNOTOUCH SOLUTIONS PRIVATE LIMITED",
"TECHNOTRADE IMPEX INDIA PRIVATE LIMITED",
"TECHNOTRADE RETAIL SERVICES INDIA PRIVATE LIMITED",
"TECHNOTRAK CHAINS AND CONVEYOR SYSTEMS PRIVATE LIMITED",
"TECHNOTRENDS MARKETING PRIVATE LIMITED",
"TECHNOTRENDZ SOLUTIONS PRIVATE LIMITED",
"TECHNOTRONICS GLOBAL SECURITY SOLUTION PRIVATE LIMITED",
"TECHNOTUDE AUTOMATION PRIVATE LIMITED",
"TECHNOURBAN INFRAVENTURES PRIVATE LIMITED",
"TECHNOURCE PRIVATE LIMITED",
"TECHNOVA IMAGING SYSTEMS PRIVATE LIMITED",
"TECHNOVA INFRASTRUCTURE PRIVATE LIMITED",
"TECHNOVA RECYCLING INDIA PRIVATE LIMITED",
"TECHNOVA TAPES (INDIA)PRIVATE LIMITED",
"TECHNOVA VENTURES PRIVATE LIMITED",
"TECHNOVAA PLASTIC INDUSTRIES PRIVATE LIMITED",
"TECHNOVAA SOFTWARE & HARDWARE SOLUTION PRIVATE LIMITED",
"TECHNOVALLEY SOFTWARE INDIA PRIVATE LIMITED",
"TECHNOVALUE SOLUTIONS PRIVATE LIMITED",
"TECHNOVATE INDIA INNOVATIONS",
"TECHNOVATE LEARNING PRIVATE LIMITED",
"TECHNOVATION ANALYTICAL INSTRUMENTS PRIVATE LIMITED",
"TECHNOVATIONS SOFTWARE PRIVATE LIMITED",
"TECHNOVATIVE ENGINEERS PRIVATE LIMITED",
"TECHNOVENTOR INNOVATIONS PRIVATE LIMITED",
"TECHNOVERT SOLUTIONS PRIVATE LIMITED",
"TECHNOVIA INFO SOLUTIONS PRIVATE LIMITED",
"TECHNO-VIJAY ENGINEERING PRIVATE LIMITED",
"TECHNOVISION AUTO COMPONENTS PRIVATE LIMITED",
"TECHNOVISION ENERGY PRIVATE LIMITED",
"TECHNOVISION ENGINEERING AND SERVICES (INDIA) PRIVATE LIMITED",
"TECHNOVISION ENGINEERS PRIVATE LIMITED",
"TECHNOVISION INDIA PRIVATE LIMITED",
"TECHNOVISION MACHINERY INDIA PRIVATE LIMITED",
"TECHNOVISION PROJECT MANAGEMENT PRIVATE LIMITED",
"TECHNOVO DISTRIBUTION PRIVATE LIMITED",
"TECHNOVO WEB INDIA PRIVATE LIMITED",
"TECHNOWARE SYSTEMS INDIA PRIVATE LIMITED",
"TECHNOWATT INDIA PRIVATE LIMITED",
"TECHNOWAVE ID SYSTEMS PRIVATE LIMITED",
"TECHNOWEB MARKETING PRIVATE LIMITED",
"TECHNOWEB TEXTILE ENGINEERING PRIVATE LIMITED",
"TECHNOWELL SOFTWARE SOLUTIONS PRIVATE LIMITED",
"TECHNOWINGS AUTOMATION INDIA PRIVATE LIMITED",
"TECHNOWIRE DATA SCIENCE LIMITED",
"TECHNOWORKZ TECHNOLOGIES PRIVATE LIMITED",
"TECHNOX ENGINEERING AND SERVICES PRIVATE LIMITED",
"TECHNOY MOTORS INDIA PRIVATE LIMITED",
"TECHNOYEN SOFTWARE VENTURES PRIVATE LIMITED",
"TECHNU INTERNATIONAL PRIVATE LIMITED",
"TECHNUMEN SYSTEMS PRIVATE LIMITED",
"TECHNVISION VENTURES LIMITED",
"TECHNYMON TECHNOLOGY INDIA PRIVATE LIMITED",
"TECHOGRAFIX PRINTPACK PRIVATE LIMITED",
"TECHOL LUBRICANTS AND SPECIALTIES PRIVATE LIMITED",
"TECHOLUTION INDIA PRIVATE LIMITED",
"TECHON COMMERCIAL PRIVATE LIMITED",
"TECHON DATER SYSTEMS PRIVATE LIMITED",
"TECHON ENGINEERING PRIVATE LIMITED",
"TECH-ON ENGINEERS PRIVATE LIMITED",
"TECHON GREEN INFRA PRIVATE LIMITED",
"TECHOPS INFRASTRUCTURE PRIVATE LIMITED",
"TECHORBIT SOLUTIONS PRIVATE LIMITED",
"TECHOUTS SOLUTIONS INDIA PRIVATE LIMITED",
"TECHOVET PHARMA PRIVATE LIMITED",
"TECHOWL INFOSEC PRIVATE LIMITED",
"TECHPACK CORRUGATORS PVT LTD",
"TECHPACK FOIL PRIVATE LIMITED",
"TECHPANION SOLUTIONS PRIVATE LIMITED",
"TECHPARK HOTELS PRIVATE LIMITED",
"TECHPARTNER ALLIANCE PRIVATE LIMITED",
"TECHPARTNER CONSULTING SERVICES PRIVATE LIMITED",
"TECHPEARL SOFTWARE PRIVATE LIMITED",
"TECHPLUS MEDIA PRIVATE LIMITED",
"TECHPLUS SOFTWARE PRIVATE LIMITED",
"TECHPOLI FILMS LIMITED",
"TECHPORT SOLUTIONS PRIVATE LIMITED",
"TECHPRIMELAB SOFTWARE PRIVATE LIMITED",
"TECHPRIMO SOLUTIONS PRIVATE LIMITED",
"TECHPRO COMPSOFT PRIVATE LIMITED",
"TECHPRO ENGINEERS PRIVATE LIMITED",
"TECHPRO SERVICES PRIVATE LIMITED",
"TECHPRO VENTURES LLP",
"TECHPROP CONSTRUCTION PRIVATE LIMITED",
"TECHQUAINT SERVICES PRIVATE LIMITED",
"TECHRACERS PRIVATE LIMITED",
"TECHRAQ INFO SOLUTIONS PRIVATE LIMITED",
"TECHRAYS CONSULTING PRIVATE LIMITED",
"TECHREFIC TECHNOLOGIES PRIVATE LIMITED",
"TECHRON SYSTEMS PRIVATE LIMITED",
"TECHROUTES NETWORK PRIVATE LIMITED",
"TECHROVER TECHNOLOGIES PRIVATE LIMITED",
"TECHSA SERVICES PRIVATE LIMITED",
"TECHSAFE CHEMICALS (INDIA) PRIVATE LIMITED",
"TECHSAGA CORPORATIONS PRIVATE LIMITED",
"TECHSCIENCE SERVICES PRIVATE LIMITED",
"TECHSEC SOLUTIONS INDIA PRIVATE LIMITED",
"TECHSECURE ELECTRONIC SECURITY SYSTEMS PRIVATE LIMITED",
"TECHSENSE LABS PRIVATE LIMITED",
"TECHSER POWER SOLUTIONS PRIVATE LIMITED",
"TECHSERA SOFTWARE PRIVATE LIMITED",
"TECHSERV INNOVATIONS PRIVATE LIMITED",
"TECHSHARP HYDRAULIC SOLUTIONS PRIVATE LIMITED",
"TECHSHOT IMAGINE PRIVATE LIMITED",
"TECHSHRESTA SOLUTIONS PRIVATE LIMITED",
"TECHSIST SOLUTION PRIVATE LIMITED",
"TECHSKILL ( INDIA ) PRIVATE LIMITED",
"TECHSMART",
"TECHSMART INFRA SOLUTIONS PRIVATE LIMITED",
"TECHSMITH SOFTWARE PRIVATE LIMITED",
"TECHSOFIN PRIVATE LIMITED",
"TECHSOFT TECHNOLOGIES INDIA PRIVATE LIMITED",
"TECHSOL ENGINEERING SERVICES INDIA PRIVATE LIMITED",
"TECHSOL INFOSEC PRIVATE LIMITED",
"TECHSOL INSTRUMENTS PRIVATE LIMITED",
"TECHSOL LIFE SCIENCES PRIVATE LIMITED",
"TECHSOL SERVICES PRIVATE LIMITED",
"TECHSOPHY INFORMATION SOLUTIONS PRIVATE LIMITED.",
"TECHSPAWN SOLUTIONS PRIVATE LIMITED",
"TECHSPIAN SERVICES PRIVATE LIMITED",
"TECHSPINE SYSTEMS PRIVATE LIMITED",
"TECHSPIRE SERVICES PRIVATE LIMITED",
"TECHSTALWARTS SOFTWARE DEVELOPMENT LLP",
"TECHSTAR INDIA LIMITED",
"TSIT DIGITAL TECHNOLOGIES PRIVATE LIMITED",
"TECHSTAR PRECISION COMPONENTS PRIVATE LIMITED",
"TECHSTAR SOFTWARE DEVLOPMENT INDIA PRIVATE LIMITED",
"TECHSTEEDS GLOBAL SERVICES PRIVATE LIMITED",
"TECHSUN ENERGIES AND ENGINEERING SERVICES PRIVATE LIMITED",
"TECHSURGE LEARNING PRIVATE LIMITED",
"TECH-SYNERGY PRIVATE LIMITED",
"TECHSYS AUTOMATION PRIVATE LIMITED",
"TECHTALENTO SOFTSER TECHNOLOGIES PRIVATE LIMITED",
"TECHTARU LABS PRIVATE LIMITED",
"TECHTIER IT SOLUTIONS PRIVATE LIMITED",
"TECHTILT INFO SOLUTIONS PRIVATE LIMITED",
"TECHTON BUILDCONS PRIVATE LIMITED",
"TECHTONIC MEDIA INDIA PRIVATE LIMITED",
"TECHTOOLS TRADING INDIA PRIVATE LIMITED",
"TECHTRA CONTECH PRIVATE LIMITED",
"TECHTRAF SOFTWARE PRIVATE LIMITED",
"TECHTRAN POLYLENSES LTD",
"TECHTREE I T SYSTEMS PRIVATE LIMITED",
"TECHTRIO SOLUTIONS PRIVATE LIMITED",
"TECHTRON ELECTRONICS PRIVATE LIMITED",
"TECHTURE STRUCTURES PRIVATE LIMITED",
"TECHULTRA SOLUTIONS PRIVATE LIMITED",
"TECHUNIDO SOFTWARE SOLUTIONS PRIVATE LIMITED",
"TECHUNITED SOLUTIONS PRIVATE LIMITED",
"TECHUNITY SOFTWARE SYSTEMS INDIA PRIVATE LIMITED",
"TECHURATE SYSTEMS PRIVATE LIMITED",
"TECHUZ INFOWEB PRIVATE LIMITED",
"TECHVANTAGE SYSTEMS PRIVATE LIMITED",
"TECHVED CONSULTING INDIA PRIVATE LIMITED",
"TECHVEIN IT SOLUTIONS PRIVATE LIMITED",
"TECHVERSANT INFOTECH PRIVATE LIMITED",
"TECHVERVE SOLUTIONS PRIVATE LIMITED",
"TECHVIBES INDUSTRIES PRIVATE LIMITED",
"TECHVISIO DESIGN PRIVATE LIMITED",
"TECHVISTAR IT SOLUTIONS PRIVATE LIMITED",
"TECHVZERO PRIVATE LIMITED",
"TECHWAUKEE PRIVATE LIMITED",
"TECHWAVE CONSULTING INDIA PRIVATE LIMITED",
"TECHWAVE INFOTECH PRIVATE LIMITED",
"TECHWEALTH CAPITAL SERVICES PRIVATE LIMITED",
"TECHWEL ENVIRO EQUIPMENTS PRIVATE LIMITED",
"TECHWELL FINTRADE PVT LTD",
"TECHWIDER TECHNOLOGIES PRIVATE LIMITED",
"TECHWIN SOLUTIONS PRIVATE LIMITED",
"TECHWISE DIGITAL PRIVATE LIMITED",
"TECHWORKS ENGINEERING PRIVATE LIMITED",
"TECHWORKX IT INNOVATIONS PRIVATE LIMITED",
"TECHWORM SOLUTIONS LLP",
"TECHWYSE IT SOLUTIONS PRIVATE LIMITED",
"TECHXIM IT SERVICES PRIVATE LIMITED",
"TECHXIMUM SOLUTIONS PRIVATE LIMITED",
"TECHXOTICA ANALYTICS PRIVATE LIMITED",
"TECHXR INNOVATIONS PRIVATE LIMITED",
"TECHXUS SECURED BUSINESS SOLUTIONS INDIA PRIVATE LIMITED",
"TECHYON BIOTECH PRIVATE LIMITED",
"TECHYZY SOLUTIONS PRIVATE LIMITED",
"TECHZEAL INFO PRIVATE LIMITED",
"TECHZOBRIS PRIVATE LIMITED",
"TECHZONE ENGINEERING PRIVATE LIMITED",
"TECIGNITE (INDIA) PRIVATE LIMITED",
"TECK CONSULTANCY & SERVICES PVT LTD",
"TECKINFO SOLUTIONS PRIVATE LIMITED",
"TECKLINK SALES & MARKETING PRIVATE LIMITED",
"TECKNACK TECHNOLOGIES PRIVATE LIMITED",
"TECKNO FUSION AUTOMATION PRIVATE LIMITED",
"TECKNO INGENIOUS SOLUTIONS PRIVATE LIMITED",
"TECKNODREAMS SOFTWARE CONSULTING PRIVATE LIMITED",
"TECKNOMEN FACILITY SERVICES PRIVATE LIMITED",
"TECKNOTROVE SYSTEMS INDIA PRIVATE LIMITED",
"TECKNOVUS ENTERPRISES PRIVATE LIMITED",
"TECKNOWELD ALLOYS (OVERSEAS) PRIVATE LIMITED",
"TECKNOWELD ALLOYS INDIA PRIVATE. LIMITED.",
"TECKOST IT SERVICES PRIVATE LIMITED",
"TECKRAFT INFOSOLUTIONS PRIVATE LIMITED",
"TECKVALLEY INDIA PRIVATE LIMITED",
"TECKWAH LOGISTICS (INDIA) PRIVATE LIMITED",
"TECLEVER SOLUTIONS PRIVATE LIMITED",
"TECLOGOS AUTOMATION PRIVATE LIMITED",
"TECMEE TECHNOLOGIES PRIVATE LIMITED",
"TECNA WELDCON INDIA PRIVATE LIMITED",
"TECNIA METFAB PRIVATE LIMITED",
"TECNICA Y PROYECTOS SA",
"TECNICAS REUNIDAS ENGINEERS INDIA PRIVATE LIMITED",
"TECNICS INTEGRATION TECHNOLOGIES PRIVATE LIMITED",
"TECNIK FLUID CONTROLS PVT. LTD.",
"TECNIK VALVES PRIVATE LIMITED",
"TECNIMONT PRIVATE LIMITED",
"TECNIQA GREEN VENTURE PRIVATE LIMITED",
"TECNIQUA INDIA PRIVATE LIMITED",
"TECNO DOORS PRIVATE LIMITED",
"TECNO SYSTEMS INDIA ELECTRONICS PRIVATE LIMITED",
"TECNOCAP ORIENTAL PRIVATE LIMITED",
"TECNOGLARE INFOTECH PRIVATE LIMITED",
"TECNOMIC COMPONENTS PRIVATE LIMITED",
"TECNOMIC MARKETING SERVICES PRIVATE LIMITED",
"TECNOMIC SYSTEMS AND NETWORKS PRIVATE LIMITED",
"TECNOVA INDIA PRIVATE LIMITED",
"TECO ELECTRICAL INDUSTRIES PRIVATE LIMITED",
"TECO INDUSTRIAL SYSTEM PRIVATE LIMITED",
"TECOCRAFT INFUSION PRIVATE LIMITED",
"TECON TILES PRIVATE LIMITED",
"TECOP INDIA PRIVATE LIMITED",
"TECORB TECHNOLOGIES PRIVATE LIMITED",
"TECORE LABS PRIVATE LIMITED",
"TECOSIM ENGINEERING SERVICES PRIVATE LIMITED",
"TECOY INDIA PRIVATE LIMITED",
"TECOY INFOSYSTEMS PRIVATE LIMITED",
"TECPACT TECHNOLOGIES PRIVATE LIMITED",
"TECPLIX TECHNOLOGIES PRIVATE LIMITED",
"TECPROCESS PAYMENT SERVICES LIMITED",
"TECQUBES TECHNOLOGIES INDIA PRIVATE LIMITED",
"TECQUISITIVE MINDS PRIVATE LIMITED",
"TECRA LOGISTICS PRIVATE LIMITED",
"TECRA SYSTEMS PRIVATE LIMITED",
"TECSIDEL INDIA PRIVATE LIMITED",
"TECSO CHARGE ZONE LIMITED",
"TECSO ENERGY TWO PRIVATE LIMITED",
"TECSO PROJECTS LIMITED",
"TECSOE COMMERCIAL PRIVATE LIMITED",
"TECSOL MARKETING PRIVATE LIMITED",
"TECSYS SOLUTIONS PRIVATE LIMITED",
"TECTICON TECHNOLOGIES PRIVATE LIMITED",
"TECTON BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"TECTON EAGLE INDIA PRIVATE LIMITED",
"TECTON INTERNATIONAL ENGINEERING CONSTRUCTION COMPANY PRIVATE LIMITED",
"TECTON PROJECT SERVICES PRIVATE LIMITED",
"TECTONA SOFTSOLUTIONS PRIVATE LIMITED",
"TECTONIC ENGINEERING CONSULTANTS INDIA PRIVATE LIMITED",
"TECTONICS TECHNOLOGIES PRIVATE LIMITED",
"TECTONICUS SERVICES (INDIA) PRIVATE LIMITED",
"TECTORO CONSULTING PRIVATE LIMITED",
"TECTREE SOFTWARE CONSULTING PRIVATE LIMITED",
"TECTURA INFOTECH PRIVATE LIMITED",
"TECTYL OIL AND CHEMICALS INDIAPRIVATE LIMITED",
"TECUMSEH PRODUCTS INDIA PRIVATE LIMITED",
"TECUNO INDIA PRIVATE LIMITED",
"TECVIVID SOFTWARE CONSULTANCY PRIVATE LIMITED",
"TECXPERT SOFTWARE PRIVATE LIMITED",
"TECZIQ SOLUTIONS PRIVATE LIMITED",
"TED CONSULTING",
"TEDAVI LIFESCIENCES PRIVATE LIMITED",
"TEDDY TOY PRIVATE LIMITED",
"TEDI (INDIA) PRIVATE LIMITED",
"TEDI INDIA PRIVATE LIMITED",
"TEDORIK INDIA PRIVATE LIMITED",
"TEDRA AUTOMOTIVE SOLUTIONS PRIVATE LIMITED",
"TEDRE REALCON INDIA PRIVATE LIMITED",
"TEDSYS TECHNOLOGIES PRIVATE LIMITED",
"TEE CEE HOSIERY PRIVATE LIMITED",
"TEE CEE HYDRAULICS PRIVATE LIMITED",
"TEE EM TEE INFRA & DISTRIPARKS PRIVATE LIMITED",
"TEE KAY INDIA REAL ESTATE PRIVATE LIMITED",
"TEE VENTURES (INDIA) PRIVATE LIMITED",
"TEEGALA KRISHNA REDDY EDUCATIONAL SOCIETY",
"TEEGALA RAM REDDY COLLAGE OF PHARMACY",
"TEEGEE SUPER STORES PVT LTD",
"TEEJAN BEVERAGES LIMITED",
"TEEJAN FOODS PVT LTD",
"TEEJAY INDIA PRIVATE LIMITED",
"TEEKAY FOAMS PRIVATE LIMITED",
"TEEKAY MARINES PRIVATE LIMITED",
"TEEKAY NON WOVEN PRIVATE LIMITED",
"TEEKAY SHIPPING INDIA PRIVATE LIMITED",
"TEEKAY TUBES PRIVATE LIMITED",
"TEEKAYS INTERIOR SOLUTIONS PRIVATE LIMITED",
"TEELIV HEALTHCARE INDIA PRIVATE LIMITED",
"TEEM TRAVELWORLD PRIVATE LIMITED",
"TEEMAGE BUILDERS PRIVATE LIMITED",
"TEEMGENIE LABS PRIVATE LIMITED",
"TEEMS INDIA TOWER LINES PRIVATE LIMITED",
"TEEN EKKA FOODS PRIVATE LIMITED",
"TEEN MURTI PRODUCTS PRIVATE LIMITED",
"TEEN TELE COMMUNICATION PRIVATE LIMITED",
"TEENA BIO LABS PRIVATE LIMITED",
"TEENA FOREX PRIVATE LIMITED",
"TEENGO TECHNOLOGY PRIVATE LIMITED",
"TEER LOGISTICS PRIVATE LIMITED",
"TEERTH COMMERCIALS PRIVATE LIMITED",
"TEERTH DEVELOPERS AND SUYOJIT INFRASTRUCTURE LIMITED JV",
"TEES AND TOES FINANCE AND INVESTMENTS LIMITED",
"TEESSIDE UNIVERSITY",
"TEESTA AGRO INDUSTRIES LTD",
"TEESTA BUILDCON PRIVATE LIMITED",
"TEESTA INVESTMENT PRIVATE LIMITED",
"TEESTA RIVERVIEW TEA CO. PRIVATE LIMITED",
"TEESTA TEA CO. PRIVATE LIMITED",
"TEESTA URJA LIMITED",
"TEESTA VALLEY EXPORTS LIMITED",
"TEESTA VALLEY TEA CO LTD",
"TEESTAVALLEY POWER TRANSMISSION LIMITED",
"TEESTRA LIFESTYLE PRIVATE LIMITED",
"TEEVRA IMPEX PRIVATE LIMITED",
"TEEZLE TELEMATICS INDIA PRIVATE LIMITED",
"TEFABO PRODUCT PRIVATE LIMITED",
"TEFCON BEARING PRIVATE LIMITED",
"TEFE INFORMATION TECHNOLOGY PRIVATE LIMITED",
"TEFLAS RESEARCH & MARKETING COMMUNICATIONS PRIVATE LIMITED",
"TEFON APPLIANCES (INDIA) PRIVATE LIMITED",
"TEFUGEN TECHNOLOGIES PRIVATE LIMITED",
"TEG BUSINESS SOLUTIONS PRIVATE LIMITED",
"TEG COMPUTERS PRIVATE LIMITED",
"TEG GLOBAL INFRASTRUCTURES PRIVATE LIMITED",
"TEG INDIA PRIVATE LIMITED",
"TEGA INDUSTRIES LIMITED",
"TEGA MCNALLY MINERALS LIMITED",
"TEGAN TEXOFAB PRIVATE LIMITED",
"TEGATAI PACKAGING INDIA PRIVATE LIMITED",
"TEGH CABLES PRIVATE LIMITED",
"TEGNA ELECTRONICS PRIVATE LIMITED",
"TEGOLA TEMA INDIA PRIVATE LIMITED",
"TEGRA ENGINEERS PRIVATE LIMITED",
"TEGRO INDIA PRIVATE LIMITED",
"TEHARE JWELLERS AND SONS PRIVATE LIMITED",
"TEHELKA COM PRIVATE LIMITED",
"TEHRI IRON & STEEL CASTING LIMITED",
"TEHRI PULP AND PAPER LIMITED",
"TEHSILDAR BAGLI MADHYA PRADESH",
"TEHSILDAR BAJNA RATLAM",
"TEHSILDAR DEWAS",
"TEHSILDAR GOHAD MADHYA PRADESH",
"TEHSILDAR JUNNARDEO",
"TEHSILDAR MOHKHED",
"TEHSILDAR PANDHANA",
"TEHSILDAR PIPLODA",
"TEHSILDAR RAT0TI RATLAM",
"TEHSILDAR RATLAM",
"TEHSILDAR SONKACHHA",
"TEHSILDAR TARANA",
"TEHSILDAR UJJAIN",
"TEICON ENGINEERING INDIA PRIVATE LIMITED",
"TEIGNBRIDGE PROPELLERS INDIA PRIVATE LIMITED",
"TEIJIN FRONTIER INDIA PRIVATE LIMITED",
"TEIJIN INDIA PRIVATE LIMITED",
"TEIKAMETRICS INDIA PRIVATE LIMITED",
"TEIKOKU PRINTING INKS INDIA PRIVATE LIMITED",
"TEJ AGRO INDIA PRIVATE LIMITED",
"TEJ AUTOSYSTEM PRIVATE LIMITED",
"TEJ CARRIER PRIVATE LIMITED",
"TEJ CONTROL SYSTEMS PRIVATE LIMITED",
"TEJ COURIER SERVICES",
"TEJ ENGINEERING PRIVATE LIMITED",
"TEJ ENGINEERS",
"TEJ EYE CENTER",
"TEJ FACILITY & SECURITY MANAGEMENT SERVICES P LIMITED",
"TEJ FARM SERVICES PRIVATE LIMITED",
"TEJ INFRATECH PRIVATE LIMITED",
"TEJ INTERNATIONAL PRIVATE LIMITED",
"TEJ INTERNATIONAL PVT LTD.",
"TEJ JEWELS PRIVATE LIMITED",
"TEJ LOGISTIC FREIGHT EXPRESS PRIVATE LIMITED",
"TEJ RAM DHARAM PAUL PRIVATE LIMITED",
"TEJ SHOE TECH",
"TEJ SHREE ENTERPRISES",
"TEJ SUPPLY CHAIN PRIVATE LIMITED",
"TEJ VEDAANT HEALTHCARE PRIVATE LIMITED",
"TEJA ENGINEERING & INFRA PRIVATE LIMITED",
"TEJA ENGINEERING SERVICES",
"TEJA FOODS INDUSTRIES LLP",
"TEJA HOMES PRIVATE LIMITED",
"TEJA MACHINERY PRIVATE LIMITED.",
"TEJAL ENGINEERS PRIVATE LIMITED",
"TEJAL LOGISTICS PRIVATE LIMITED",
"TEJAL MERCHANTILE PRIVATE LIMITED",
"TEJAL PACKERS AND MOVERS PRIVATE LIMITED",
"TEJAL SYNTHETICS PRIVATE LIMITED",
"TEJAL TRANSMISSION PRIVATE LIMITED",
"TEJAN ENGINEERING PRIVATE LIMITED",
"TEJANKAR HEALTH CARE AND MEDICAL RESEARCH INSTITUTE PRIVATE LIMITED",
"TEJARI SOLUTIONS PRIVATE LIMITED",
"TEJAS AEROSPACE PRODUCTS PRIVATE LIMITED",
"TEJAS AGRO IRRIGATION SYSTEMS PRIVATE LIMITED",
"TEJAS CARS PRIVATE LIMITED",
"TEJAS CONCAST PRIVATE LIMITED",
"TEJAS CONSTRUCTIONS AND INFRASTRUCTURE PRIVATE LIMITED",
"TEJAS DRUGS & SURGICAL",
"TEJAS ENERGY AND PROJECTS PRIVATE. LIMITED.",
"TEJAS ENTERPRISES PRIVATE LIMITED",
"TEJAS FUELS AND OILS PRIVATE LIMITED",
"TEJAS GLOBAL LIMITED",
"TEJAS IMPEX PRIVATE LIMITED",
"TEJAS INNOVATIVE SOLUTIONS PRIVATE LIMITED",
"TEJAS INTERNATIONAL EDUCATIONAL INSTITUTIONS",
"TEJAS INTERNATIONAL PRIVATE LIMITED",
"TEJAS IRON & STEEL PRIVATE LIMITED",
"TEJAS MARITIME PRIVATE LIMITED",
"TEJAS MULTI ENDEAVORS PRIVATE LIMITED",
"TEJAS NETWORKS LIMITED",
"TEJAS OPEN HAUL FREIGHT LOGISTICS PRIVATE LIMITED",
"TEJAS RASAYAN PRIVATE LIMITED",
"TEJAS SOFTECH INDIA PRIVATE LIMITED",
"TEJAS SUPERSTRUCTURES PRIVATE LIMITED",
"TEJAS VIDYALAYA",
"TEJAS WIRES PRIVATE LIMITED",
"TEJAS WORLD LOGISTICS PRIVATE LIMITED",
"TEJASCO TECHSOFT PRIVATE LIMITED",
"TEJASH ELECTRICALS PROJECT PRIVATE LIMITED",
"TEJASH FINSTOCK PRIVATE LIMITED",
"TEJASHWINI ENTERPRISES",
"TEJASHWINI FACILITY MANAGEMENT PRIVATE LIMITED",
"TEJASLITE LIGHTING SOLUTIONS PRIVATE LIMITED",
"TEJASVEE MEDINOVA PRIVATE LIMITED",
"TEJASVI VIPIN KHEDEKAR",
"TEJASVINI HOSPITAL AND SSIOT",
"TEJASVINI HOSPITAL GROUP OF INSTITUTIONS",
"TEJASVINI NURSING INSTITUTE",
"TEJASWANI BUILDWELL PRIVATE LIMITED",
"TEJASWI HIGH SCHOOL",
"TEJASWI INFRAATECH PRIVATE LIMITED",
"TEJASWI MANUFACTURING PRIVATE LIMITED",
"TEJASWI MOTORS PRIVATE LIMITED",
"TEJASWI PACKAGING LIMITED",
"TEJASWI PLASTIC PRIVATE LIMITED",
"TEJASWINI HEALTHCARE SERVICES PRIVATE LIMITED",
"TEJASWINI SHIPPING SOLUTION PRIVATE LIMITED",
"TEJAX SUPPORT SERVICES PRIVATE LIMITED",
"TEJAYS DYNAMIC LIMITED",
"TEJBHUSHAN TRANSMISSION PRIVATE LIMITED",
"TEJCAB ENTERPRISES PRIVATE LIMITED",
"TEJDARSHAN INFRA PRIVATE LIMITED",
"TEJENDRA INFRACON PRIVATE LIMITED",
"TEJENDRA INFRASTRUCTURE PRIVATE LIMITED",
"TEJFIRE SAFETY INDIA PRIVATE LIMITED",
"TEJGYAN GLOBAL FOUNDATION",
"TEJHA POWER CONTROLS PRIVATE LIMITED",
"TEJJAS INCENSE PRIVATE LIMITED",
"TEJNAKSH HEALTHCARE LIMITED",
"TEJO MEDICALS AND PHARMACY",
"TEJOMA TECHNOLOGIES PRIVATE LIMITED",
"TEJOMAYA ENERGY & TECHNOLOGY PRIVATE LIMITED",
"TEJORA PRIVATE LIMITED",
"TEJOSMA TECHNOLOGIES PRIVATE LIMITED",
"TEJPAL MOTORS PRIVATE LIMITED",
"TEJRAJ BUILDCON PRIVATE LIMITED",
"TEJRAJ DIGITECH PRIVATE LIMITED",
"TEJRAJ PROMOTERS & BUILDERS PRIVATE LIMITED",
"TEJRIYA FOODS PRIVATE LIMITED",
"TEJ-SONS FOODS PRIVATE LIMITED",
"TEJURA OVERSEAS ENTERPRISES PRIVATE LIMITED",
"TEJUS CENTERING AND CONSTRUCTIONS EQUIPMENTS PRIVATE LIMITED",
"TEJWANEY APPARELS PRIVATE LIMITED",
"TEK ADVERTISING AND MANAGEMENT PRIVATE LIMITED",
"TEK COMPONENTS PRIVATE LIMITED",
"TEK CUBE PRIVATE LIMITED",
"TEK INFOTREE PRIVATE LIMITED",
"TEK INSPIRATIONS PRIVATE LIMITED",
"TEK LEADERS INDIA PRIVATE LIMITED",
"TEK TRAVELS PRIVATE LIMITED",
"TEK1 ENGINEERING SERVICES PRIVATE LIMITED",
"TEK7 BUSINESS SERVICES PRIVATE LIMITED",
"TEKANALYTICS PRIVATE LIMITED",
"TEKARCH TECHNOLOGY PRIVATE LIMITED",
"TEKAWADE AGRO INDUSTRIES PRIVATE LIMITED",
"TEKBIO LABSOLUTIONS PRIVATE LIMITED",
"TEKBON SOFTWARE SOLUTIONS PRIVATE LIMITED",
"TEKBURO ENGINEERING PRIVATE LIMITED",
"TEKCEL AUTOMATION PRIVATE LIMITED",
"TEKCEL ENGINEERING PRIVATE LIMITED",
"TEKCLAN SOFTWARE SOLUTIONS PRIVATE LIMITED",
"TEKDI TECHNOLOGIES PRIVATE LIMITED",
"TEKEGE SOLUTIONS PRIVATE LIMITED",
"TEKEINSTEIN PRIVATE LIMITED",
"TEKENLIGHT SOLUTIONS PRIVATE LIMITED",
"TEKEQ INDIA PRIVATE LIMITED",
"TEKESSENCE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"TEKFRENS ENGINEERS PVT LTD",
"TEKFRIDAY PROCESSING SOLUTIONS PRIVATE LIMITED",
"TEKGILE SOLUTIONS PRIVATE LIMITED",
"TEKHNE DERETAILSTAD PRIVATE LIMITED",
"TEK-HUMMINGBIRD PRIVATE LIMITED",
"TEKINWI PRIVATE LIMITED",
"TEKIP KNOWLEDGE CONSULTING PRIVATE LIMITED",
"TEKISHUB CONSULTING SERVICES PRIVATE LIMITED",
"TEKIZMA INDIA SOLUTIONS PRIVATE LIMITED",
"TEKKI WEB SOLUTIONS PRIVATE LIMITED",
"TEKKR TECHNOLOGIES PRIVATE LIMITED",
"TEKLIGHT COMPONENTS PRIVATE LIMITED",
"TEKLINK SOFTWARE PRIVATE LIMITED",
"TEKMAK CABLES INDIA PRIVATE LIMITED",
"TEKMAN INDIA PRIVATE LIMITED",
"TEKMEASURE TECHNOLOGIES PRIVATE LIMITED",
"TEKMINDERS IT SERVICES INTERNATIONAL PRIVATE LIMITED",
"TEKNA MANUFACTURING PRIVATE LIMITED",
"TEKNEEK SPINNERS PVT LTD",
"TEKNI PLEX INDIA PRIVATE LIMITED",
"TEKNIC CONTROLGEAR PVT LTD",
"TEKNIC ELECTRIC (I) PRIVATE LIMITED",
"TEKNIC ELECTROMECONICS PRIVATE LIMITED",
"TEKNIC ENGINEERING I PRIVATE LIMITED",
"TEKNIC EUCHNER ELECTRONICS PRIVATE LIMITED",
"TEKNIC SWITCHGEAR PRIVATE LIMITED",
"TEKNIC TOOLINGS PRIVATE LIMITED",
"TEKNIK MEDICO PRIVATE LIMITED",
"TEKNION FURNITURE SYSTEMS INDIA PRIVATE LIMITED",
"TEKNIRVANA TRADELINK PRIVATE LIMITED",
"TEKNITI SOFTWARE SOLUTIONS PRIVATE LIMITED",
"TEKNIX ELEVATORS PRIVATE LIMITED",
"TEKNO POINT MULTIMEDIA INDIA PRIVATE LIMITED",
"TEKNO TELE INFRA SERVICES PRIVATE LIMITED",
"TEKNO VALVES",
"TEKNOBIZ SOLUTIONS PRIVATE LIMITED",
"TEKNOBLOOM CONSULTING PRIVATE LIMITED",
"TEKNOBUILT SOLUTIONS PRIVATE LIMITED",
"TEKNOBYTE INDIA PRIVATE LIMITED",
"TEKNOCRAT'S CONTROL SYSTEMS (INDIA ) PRIVATE LIMITED",
"TEKNODOME INDIA PRIVATE LIMITED",
"TEKNOFAB INDUSTRIES PRIVATE LIMITED",
"TEKNOFINE FOODS PRIVATE LIMITED",
"TEKNOFLOW GREEN EQUIPMENTS PRIVATE LIMITED",
"TEKNOKOM IRRIGATION PRIVATE LIMITED",
"TEKNOLOGIKOL LOGISTICS PRIVATE LIMITED",
"TEKNOMIN CONSTRUCTION LIMITED",
"TEKNOS COATINGS AND PAINTS PRIVATE LIMITED",
"TEKNOS INDIA AND CO. PRIVATE LIMITED",
"TEKNOSARUS EMBEDDED SYSTEMS PRIVATE LIMITED",
"TEKNOTRAIT SOLUTIONS PRIVATE LIMITED",
"TEKNOTUFF GLASS PRIVATE. LIMITED.",
"TEKNOTURF INFO SERVICES PRIVATE LIMITED",
"TEKNOVACE WOOD COATINGS PRIVATE LIMITED",
"TEKNOVANCE SOLUTIONS PRIVATE LIMITED",
"TEKNOVATE PLASTICS PRIVATE LIMITED",
"TEKNOW OVERSEAS PRIVATE LIMITED",
"TEKNOWKEM ENGINEERS PRIVATE LIMITED",
"TEKNOWMICS KNOWLEDGE SOLUTIONS PRIVATE LIMITED",
"TEKNOWSOURCE MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"TEKNUANCE INFO SOLUTIONS PRIVATE LIMITED",
"TEKONE IT SERVICES PRIVATE LIMITED",
"TEKONIKA SYSTEMS PRIVATE LIMITED",
"TEKOR MINERALS PRIVATE LIMITED",
"TEKPLAY SYSTEM LIMITED",
"TEKPYRAMIDS INDIA PRIVATE LIMITED",
"TEKREANT INDIA PRIVATE LIMITED",
"TEKRIWAL AGENCIES PRIVATE LIMITED",
"TEKRIWAL MOTORS PRIVATE LIMITED",
"TEKRIWAL TRACTORS PRIVATE LIMITED",
"TEKROI PRIVATE LIMITED",
"TEKS TECH INSPECTION INDIA PRIVATE LIMITED",
"TEKSHAPERS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"TEKSHIV SYSTEMS PRIVATE LIMITED",
"TEKSHORE ECOMMERCE PRIVATE LIMITED",
"TEKSKILLS INDIA PRIVATE LIMITED",
"TEKSOFT LABS PRIVATE LIMITED",
"TEKSOL ENGINEERING PRIVATE LIMITED",
"TEKSONS COOLING SYSTEMS PRIVATE LIMITED",
"TEKSTAR DISTRIBUTION PRIVATE LIMITED",
"TEKSTAR ENGINEERS PRIVATE LIMITED",
"TEKSTAR GLOBAL PRIVATE LIMITED",
"TEKSUN MICROSYS PRIVATE LIMITED",
"TEKSYSTEMS GLOBAL SERVICES PRIVATE LIMITED",
"TEKTONINFRA INDIA PRIVATE LIMITED",
"TEKTREE SOFTWARE SERVICES PRIVATE LIMITED",
"TEKTRONICS EMS PRIVATE LIMITED",
"TEKTRONIX INDIA PRIVATE LIMITED",
"TEKTTARGET SYSTEMS INDIA PRIVATE LIMITED",
"TEKVAC HEAT TREATMENT SERVICES PRIVATE LIMITED",
"TEKVIZION VOICE SOLUTIONS PRIVATE LIMITED",
"TEKWIN POWER SYSTEMS INDIA PRIVATE LIMITED",
"TEKWISSEN SOFTWARE PRIVATE LIMITED",
"TEKWORKS ENTERPRISE SOLUTIONS PRIVATE LIMITED",
"TEKYSLAB PRIVATE LIMITED",
"TEKZEE TECHNOLOGIES PRIVATE LIMITED",
"TEKZENIT INDIA PRIVATE LIMITED",
"TEL TOWERS PRIVATE LIMITED",
"TELAMON INVESTMENT ADVISORS AND CONSULTANTS PRIVATE LIMITED",
"TELAMON TECHNOLOGIES INDIA LLP",
"TELANGANA BROADCASTING PRIVATE LIMITED",
"TELANGANA COMMUNICATIONS PRIVATE LIMITED",
"TELANGANA ELECTRICAL AND APPLIANCES PRIVATE LIMITED",
"TELANGANA FOODS",
"TELANGANA GRAMEENA BANK",
"TELANGANA INDUSTRIAL HEALTH CLINIC LIMITED",
"TELANGANA MINORITIES RESIDENTIAL EDUCATIONAL INSTITUTIONS SOCIETY",
"TELANGANA MODEL SCHOOLS",
"TELANGANA NEW & RENEWABLE ENERGY DEVP. CORP. LIMITED",
"TELANGANA PIPES PRIVATE LIMITED",
"TELANGANA PUBLICATIONS PRIVATE LIMITED",
"TELANGANA STATE CIVIL SUPPLIES CORPORATION LIMITED",
"TELANGANA STATE COOPERATIVE BANK",
"TELANGANA STATE CO-OPERATIVE OILSEEDS GROWERS FEDERATION LTD",
"TELANGANA STATE HOUSING CORPORATION LIMITED",
"TELANGANA STATE INDUSTRIAL INFRASTRUCTURE CORPORATION LIMITED",
"TELANGANA STATE POLICE HOUSING CORPORATION LIMITED",
"TELANGANA STATE POLLUTION CONTROL BOARD",
"TELANGANA POWER GENERATION CORPORATION LIMITED",
"TELANGANA STATE ROAD CORPORATION",
"TELANGANA STATE ROAD TRANSPORT CORPORTION",
"TELANGANA STATE SEEDS DEVELOPMENT CORPORATION",
"TELANGANA STATE TOURISM DEVELOPMENT CORPORATON",
"TELANGANA TRADERS",
"TELANGANA TRIBAL WELFARE IIT STUDY CENTRE",
"TELANGANA TRIBAL WELFARE RESIDENTIAL EDUCATIONAL INSTITUTIONS SOCIETY",
"TELANGE BUILDERS & DEVELOPERS PRIVATE LIMITED",
"TELAVERGE COMMUNICATIONS INDIA PRIVATE LIMITED",
"TELAWNE CROMPTEK ELECTRICALS PRIVATE LIMITED",
"TELAWNE POWER EQUIPMENTS PRIVATE LIMITED",
"TELCON BIMETALS",
"TELCOVAS SOLUTIONS & SERVICES PRIVATE LIMITED",
"TELE ACCESS E-SERVICES PRIVATE LIMITED",
"TELE AUDIO VIDEO PRIVATE LIMITED",
"TELE BUILD CONSTRUCTION PRIVATE. LIMITED",
"TELE DNA COMMUNICATIONS PRIVATE LIMITED",
"TELE HOME DISTRIBUTION HUB PRIVATE LIMITED",
"TELE LOGIX COMMUNICATION SERVICES PRIVATE LIMITED",
"TELE SYSTEM COMMUNICATIONS INDIA PRIVATE LIMITED",
"TELE SYSTEM ELECTRONIC (INDIA) PRIVATE LIMITED",
"TELEAPPS INDIA PRIVATE LIMITED",
"TELEBLISS SOLUTIONS PRIVATE LIMITED",
"TELEBU COMMUNICATIONS LLP",
"TELEBYTE TECHNOLOGIES PRIVATE LIMITED",
"TELECMI TECHNOLOGIES PRIVATE LIMITED",
"TELECOM COLLABORATION SERVICES PRIVATE LIMITED",
"TELECOM INFRASTRUCTURAL CONSULTANCY SERVICES PRIVATE LIMITED",
"TELECOM ITALIA SPARKLE S P A",
"TELECOM NETWORK SOLUTIONS PRIVATE LIMITED",
"TELECOM NETWORK SOLUTIONS PVT. LTD.",
"TELECOM REGULATORY AUTHORITY OF IND",
"TELECOMMUNICATION HEADSETS INDIA LIMITED",
"TELECOMMUNICATIONS CONSULTANTS INDIA LIMITED",
"TELECOMMUNICATORS (INDIA) PRIVATE LIMITED",
"TELECOMONE TELESERVICES INDIA PRIVATE LIMITED",
"TELECOPIER SYSTEM AND SERVICES",
"TELECRAFT E-SOLUTIONS PRIVATE LIMITED",
"TELECRAFT INDUSTRIES PRIVATE LIMITED",
"TELECRATS INDIA PRIVATE LIMITED",
"TELEDGERS TECHNOLOGY PRIVATE LIMITED",
"TELEDNA COMMUNICATIONS PRIVATE LIMITED",
"TELEECARE NETWORK INDIA PRIVATE LIMITED",
"TELEFLEX MEDICAL PRIVATE LIMITED",
"TELEFLO INDIA PRIVATE LIMITED",
"TELEFONICA COMMUNICATIONS LLP",
"TELEGATE ITC SERVICES PRIVATE LIMITED",
"TELEGENCE POWERCOMM PRIVATE LIMITED",
"TELEGLOBAL COMMUNICATIONS PRIVATE LIMITED",
"TELEGLOBAL INTERNATIONAL PRIVATE LIMITED",
"TELEHEALTH INNOVATIONS FOUNDATION",
"TELEINDIA NETWORKS PRIVATE LIMITED",
"TELEIOS AUTOMATION & ENGINEERING SERVICES I PRIVATE LIMITED",
"TELEKONNECTORS LIMITED",
"TELELEC HEATING EQUIPMENT PRIVATE LIMITED.",
"TELEMA ELECTRICALS PRIVATE LIMITED",
"TELEMAN INSTITUTE OF WIRELESS TECHNOLOGIES PRIVATE LIMITED",
"TELEMART SHOPPING NETWORK PRIVATE LIMITED",
"TELEMATIC COMSEC PRIVATE LIMITED",
"TELEMATIC ENGINEERS & COMMUNICATIONS PRIVATE LIMITED",
"TELEMATICS 4U SERVICES PRIVATE LIMITED",
"TELEMAX COMMUNICATIONS PRIVATE LIMITED",
"TELEMERGE IT SERVICES PRIVATE LIMITED",
"TELEMINDS INFOTECH PRIVATE. LIMITED",
"TELEMUNE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"TELENET INSTRUMENTATION PRIVATE LIMITED",
"TELENET MARKETING PVT LTD",
"TELENITY SYSTEMS SOFTWARE INDIA PRIVATE LIMITED",
"TELENOR INDIA COMMUNICATIONS PRIVATE LIMITED",
"TELENOX TECHNOLOGIES PRIVATE LIMITED",
"TELEON SOLUTIONS PRIVATE LIMITED",
"TELEONE CONSUMERS PRODUCT PRIVATE LIMITED",
"TELEPERFORMANCE BUSINESS SERVICES INDIA LIMITED",
"TELEPERFORMANCE GLOBAL BUSINESS PRIVATE LIMITED",
"TELEPERFORMANCE INDIA PRIVATE LIMITED",
"TELEPERFORMANCE TOURISM SERVICES INDIAPRIVATE LIMITED",
"TELEPHONE SYSTEMS INDIA PRIVATE LIMITED",
"TELEPORT COMMERCE IN PRIVATE LIMITED",
"TELEPOWER SALES PRIVATE LIMITED",
"TELEPRESS PRODUCTS PRIVATE LIMITED",
"TELEQUESTAI PRIVATE LIMITED",
"TELERAD RX DX HEALTHCARE PRIVATE LIMITED",
"TELERAD TECH PRIVATE LIMITED",
"TELERATE MERCANTILE PRIVATE LIMITED",
"TELESCIENTIFIC",
"TELESIS ARCHITECTS AND DESIGNERS PRIVATE LIMITED",
"TELESOFT TECHNOLOGIES LIMITED",
"TELESTO ENERGY PRIVATE LIMITED",
"TELESTRATUM NETWORKS PRIVATE LIMITED",
"TELESTREAM INDIA PRIVATE LIMITED",
"TELESUPRECON INDIA PRIVATE LIMITED",
"TELESYS INFO-INFRA (I) LIMITED",
"TELETECH INDUSTRIES PRIVATE LIMITED",
"TELETECH SERVICES INDIA LIMITED",
"TELETEXT INDIA PRIVATE LIMITED",
"TELETO POWERLINKS PRIVATE LIMITED",
"TELETUBE ELECTRONICS LIMITED",
"TELEVAR INFOCOM PRIVATE LIMITED",
"TELEVISION CULTURAL & SPORTS CLUB R",
"TELEVISORY (INDIA) PRIVATE LIMITED",
"TELEVITAL INDIA PRIVATE LIMITED",
"TELEWIRE SOLUTIONS PRIVATE LIMITED",
"TELEWORLD MINES AND MINERALS PRIVATE LIMITED",
"TELEWORLD MOBILES PRIVATE LIMITED",
"TELEX ADVERTISING PRIVATE LIMITED",
"TELEYSIA NETWORKS PRIVATE LIMITED",
"TELGE PROJECTS LIMITED",
"TELGE PROJECTS PRIVATE LIMITED",
"TELI MARKETING PRIVATE LIMITED",
"TELIA CYGATE INDIA PRIVATE LIMITED",
"TELIBRAHMA TECHNOLOGIES PRIVATE LIMITED",
"TELIC FINVEST PRIVATE LIMITED",
"TELIC INFO SERVICES PRIVATE LIMITED",
"TELIGENZ TECH SOLUTIONS PRIVATE LIMITED",
"TELIMART INDIA PRIVATE LIMITED",
"TELIT COMMUNICATIONS INDIA PRIVATE LIMITED",
"TELITEK E-SERVICES PRIVATE LIMITED",
"TELITICS TECHNOLOGIES PRIVATE LIMITED",
"TELKO INFO SOLUTIONS PRIVATE LIMITED",
"TELLABS CHEMICALS PRIVATE LIMITED",
"TELLAPUR TECHNOCITY PRIVATE LIMITED",
"TELL-A-TALE MEDIA PRIVATE LIMITED",
"TELLIANT SYSTEMS INDIA PRIVATE LIMITED",
"TELLIGENT SUPPORT LLP",
"TELLIUS INDIA PRIVATE LIMITED",
"TELLUS POWER PRIVATE LIMITED",
"TELLUSSOL INDIA PRIVATE LIMITED",
"TELLUSYS INFO PRIVATE LIMITED",
"TELLWELL BOOKS PRINT AND PACK PRIVATE LIMITED",
"TELLY SAFETY SOLUTION PRIVATE LIMITED",
"TELLY SOFT SERVICE PRIVATE LIMITED",
"TELLYTUNE ENTERTAINMENT PRIVATE LIMITED",
"TELMA INDUCTION BRAKES PRIVATE LIMITED",
"TELMAT MATERIALS AND TECHNOLOGIES INDIA PRIVATE LIMITED",
"TELMOS AUTOMOBILES PRIVATE LIMITED",
"TELMOS ELECTRONICS PVT LTD",
"TELNET INNOVATIVE SOLUTIONS PRIVATE LIMITED",
"TELO INFO SYSTEMS PRIVATE LIMITED",
"TELOS INVESTMENTS & TECHNOLOGIES PRIVATE LIMITED",
"TELOS RISK MANAGEMENT & INSURANCE BROKING SERVICES P LIMITED",
"TELPHACARE INDIA PRIVATE LIMITED",
"TELR PAYMENT SOLUTIONS INDIA PRIVATE LIMITED",
"TELRE DESIGN DRAFTING SOLUTION PRIVATE LIMITED",
"TELSA MARKETING PVT LTD",
"TELSA POWER USA",
"TELSIMA COMMUNICATIONS PRIVATE LIMITED",
"TELSOURCE SOFTWARE LABS PRIVATE LIMITED",
"TELSPIEL COMMUNICATIONS PRIVATE LIMITED",
"TELSTRA GLOBAL BUSINESS SERVICES LLP",
"TELSTRA INDIA PRIVATE LIMITED",
"TELSTRA TELECOMMUNICATION PRIVATE LIMITED",
"TELTURE SOLUTIONS PRIVATE LIMITED",
"TELUGUNADU STEELS PRIVATE LIMITED",
"TELVEL IT SOLUTIONS PRIVATE LIMITED",
"TELWAVE INDIA PRIVATE LIMITED",
"TELY MEDICAL CENTRE LTD",
"TELYCOM INDUSTRIES PRIVATE LIMITED",
"TEMA BUSINESS SYSTEMS PRIVATE LIMITED",
"TEMA INDIA LIMITED",
"TEMA INDIA PRIVATE LIMITED",
"TEMANI PROPERTIES PRIVATE LIMITED",
"TEMASEK HOLDINGS ADVISORS INDIA PRIVATE LIMITED",
"TEMASME VESELEX INDIA PRIVATE LIMITED",
"TEMBHU POWER PRIVATE LIMITED",
"TEMBO GLOBAL INDUSTRIES LIMITED",
"TEMCO RENEWABLE ENERGY SOLUTIONS PRIVATE LIMITED",
"TEMENOS INDIA PRIVATE LIMITED",
"TEMERE INDIA LLP",
"TEMFLO SYSTEMS PRIVATE LIMITED",
"TEMPAIR ENGINEERS PRIVATE LIMITED",
"TEMPBRIDGE NETWORKS",
"TEMPCON EXPRESS PRIVATE LIMITED",
"TEMPEL PRECISION METAL PRODUCTS INDIA PRIVATE LIMITED",
"TEMPEST ADVERTISING PRIVATE LIMITED",
"TEMPESTA LUXURY PRODUCTS PRIVATE LIMITED",
"TEMPINDIA STAFFING SERVICES PRIVATE LIMITED",
"TEMPLE ADVERTISING PRIVATE LIMITED",
"TEMPLE ART JEWELLERY PRIVATE LIMITED",
"TEMPLE CITY HOTELS INDIA PRIVATE LIMITED",
"TEMPLE CITY TECHNOLOGIES PRIVATE LIMITED",
"TEMPLE PACKAGING PRIVATE LIMITED",
"TEMPLE ROSE CONSTRUCTION PRIVATE LIMITED",
"TEMPLE ROSE REAL ESTATE PRIVATE LIMITED",
"TEMPLETON DEVELOPERS PRIVATE LIMITED",
"TEMPO AUTOMOBILES PVT LTD",
"TEMPO INSTRUMENTS PRIVATE LIMITED",
"TEMPROZE BUSINESS ASSOCIATES PRIVATE LIMITED",
"TEMPS LIFESTYLE PRIVATE LIMITED",
"TEMPSENS INSTRUMENTS INDIA PRIVATE LIMITED",
"TEMPTING HOME PRIVATE LIMITED",
"TEMPUS FUGIT PRIVATE LIMITED",
"TEMPUS GEMS PRIVATE LIMITED",
"TEMVOL SOLUTIONS PRIVATE LIMITED",
"TEN APPARELS & INDUSTRIES PRIVATE LIMITED",
"TEN BRINK ENGINEERING INDIA PRIVATE LIMITED",
"TEN BUILDCON PRIVATE LIMITED",
"TEN CONSTRUCTION (INDIA) PRIVATE LIMITED",
"TEN DOT INFRA PRIVATE LIMITED",
"TEN LIFESTYLE MANAGEMENT INDIA PRIVATE LIMITED",
"TEN LOGISTICS INDIA PRIVATE LIMITED",
"TEN NAM FOODS PRIVATE LIMITED",
"TEN ON TEN HABITAT PRIVATE LIMITED",
"TEN ON TEN INTERNATIONAL PRIVATE LIMITED",
"TEN ON TEN RUBTECH PRIVATE LIMITED",
"TEN PASSION ECOM PRIVATE LIMITED",
"TEN SQUARE MEDIA & PRODUCTION PRIVATE LIMITED",
"TEN TIMES ONLINE PRIVATE LIMITED",
"TENA PRIMARY SCHOOL",
"TENACIOUS SERVICES PRIVATE LIMITED",
"TENACIOUS TECHNOLOGY PRIVATE LIMITED",
"TENACITICS INDIA PRIVATE LIMITED",
"TENACITY TECHNOLOGY PRIVATE LIMITED",
"TENAGA PARKING INDIA PRIVATE LIMITED",
"TENAGA PARKING SERVICES (INDIA) PRIVATE LIMITED",
"TENANTCUBE TECHNOLOGIES PRIVATE LIMITED",
"TENART PRIVATE LIMITED",
"TENATRA CHEMIE PRIVATE LIMITED",
"TENATRA EXPORTS PRIVATE LIMITED",
"TENAX INDIA INDUSTRIAL CHEMICAL PRIVATE LIMITED",
"TENAX PIDILITE INDIA PRIVATE LIMITED",
"TENCO SYSTEMS & SWITCH GEARS PVT LTD.,",
"TENDER FEET EDUCATION SOCIETY",
"TENDER FRESH FOODS AND ICE CREAM PRIVATE LIMITED",
"TENDER HEALTHTECH LLP",
"TENDER HEART SENIOR SECONDARY SCHOOL",
"TENDER SOFTWARE INDIA PRIVATE LIMITED",
"TENDER TIGER PRIVATE LIMITED",
"TENDERCARE NURSING HOME PRIVATE LIMITED",
"TENDRIL MY SCHOOL",
"TENE AGRICULTURAL SOLUTIONS PRIVATE LIMITED",
"TENERGY INDIA PRIVATE LIMITED",
"TENERON LIMITED",
"TENET DIAGNOSTICS PRIVATE LIMITED",
"TENET HEALTH EDUTECH PRIVATE LIMITED",
"TENET LIFE SCIENCES PRIVATE LIMITED",
"TENET MEDCORP PRIVATE LIMITED",
"TENET NETWORKS PRIVATE LIMITED",
"TENET TAX & LEGAL PRIVATE LIMITED",
"TENETCOMPUTER AND COMMUNICATION PRIVATE LIMITED",
"TENFOLD PHARMACEUTICALS PRIVATE LIMITED",
"TENGPANI TEA ESTATES PRIVATE LIMITED",
"TENJIKU FOODS PRIVATE LIMITED",
"TENMILES TECHNOLOGIES PRIVATE LIMITED",
"TENNECO AUTOMOTIVE INDIA PRIVATE LIMITED",
"TENNECO CLEAN AIR INDIA PRIVATE LIMITED",
"TENORA CHEM PRIVATE LIMITED",
"TENORMAC ENTERPRISES PRIVATE LIMITED",
"TENOVIA SOLUTIONS PRIVATE LIMITED",
"TENRYU SAW INDIA PRIVATE LIMITED",
"TENSAR GEOSYNTHETICS INDIA PRIVATE LIMITED",
"TENSHI KAIZEN PRIVATE LIMITED",
"TENSIL LABGLASS TECHNOLOGIES PRIVATE LIMITED",
"TENSOR FIELDS CONSULTANCY SERVICES PRIVATE LIMITED",
"TENSORIOT SOFTWARE SERVICES PRIVATE LIMITED",
"TENSTAR ENGINEERING AND CONSTRUCTIONS PRIVATE LIMITED",
"TENT SOFTWARE PRIVATE LIMITED",
"TENTABS TECH SOLUTIONS PRIVATE LIMITED",
"TENTACLE AEROLOGISTIX PRIVATE LIMITED",
"TENTACLE INFOTECH INDIA PRIVATE LIMITED",
"TENTACLE SECURE SQUADS PRIVATE LIMITED",
"TENTAMUS INDIA PRIVATE LIMITED",
"TENTECH LED DISPLAY PRIVATE LIMITED",
"TENTH PLANET TECHNOLOGIES PRIVATE LIMITED",
"TENTHPIN MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"TENTWENTY DIGITAL LIMITED LIABILITY PARTNERSHIP",
"TENTY MARKETING COMPANY P LIMITED",
"TENVENT COMMUNICATION PRIVATE LIMITED",
"TENVIC SPORTS EDUCATION PRIVATE LIMITED",
"TENWAVE INFOTECH PRIVATE LIMITED",
"TENWAZE IMPEX PRIVATE LIMITED",
"TENXER TECHNOLOGIES PRIVATE LIMITED",
"TENZIN CONSTRUCTION CO.PRIVATE LIMITED",
"TEOCO SOFTWARE PRIVATE LIMITED",
"TEOLER EDUCATION SERVICES PRIVATE LIMITED",
"TEOLER HIGH SCHOOL",
"TEOS LOGISTICS INDIA PRIVATE LIMITED",
"TEP INDIA PRIVATE LIMITED",
"TEPCON INTERNATIONAL INDIA LTD",
"TEPHRA POLYMERS PRIVATE LIMITED",
"TEQ DILIGENT PRODUCT SOLUTIONS PRIVATE LIMITED",
"TEQ MAVENS PRIVATE LIMITED",
"TEQBEE CONSULTING SOLUTIONS PRIVATE LIMITED",
"TEQFOCUS SOLUTIONS PRIVATE LIMITED",
"TEQLINX SOFTWARE SOLUTIONS PRIVATE LIMITED",
"TEQNOZO POLYPLAST PRIVATE LIMITED",
"TEQSAR PRIVATE LIMITED",
"TEQTURE INDUSTRIES PRIVATE LIMITED",
"TEQZO RETAIL PRODUCTS PRIVATE LIMITED",
"TERA CONSTRUCTIONS PRIVATE LIMITED",
"TERA FOREX PRIVATE LIMITED",
"TERA INFORMATICS PRIVATE. LIMITED",
"TERA PANTH FOODS LIMITED",
"TERA PROJECTS & SHIPPING PRIVATE LIMITED",
"TERA SOFTWARE LIMITED",
"TERABEAM PROXIM WIRELESS PRIVATE LIMITED",
"TERABYTE COMPUTER SYSTEMS AND SERVICES PRIVATE LIMITED",
"TERABYTES INDIA PRIVATE LIMITED",
"TERACOM LIMITED",
"TERADATA INDIA PRIVATE LIMITED",
"TERAFAST NETWORKS PRIVATE LIMITED",
"TERAFINA SOFTWARE SOLUTIONS PRIVATE LIMITED",
"TERAFLO ENGINEERING PRIVATE LIMITED",
"TERAI FOODS PRIVATE LIMITED",
"TERAI ISPAT & TRADING PRIVATE LIMITED",
"TERAI TEA CO.LTD.",
"TERAPACT TECHNOLOGY PRIVATE LIMITED",
"TERAPANTH MARKETING PRIVATE LIMITED",
"TERASOFT TECHNOLOGIES PRIVATE LIMITED",
"TERASU ENTERPRISE PRIVATE LIMITED",
"TERATEC STEEL INDUSTRIES LLP",
"TERAVOLT POWER PRIVATE LIMITED",
"TERAWE TECHNOLOGIES PRIVATE LIMITED",
"TERBIUM SOLUTIONS PRIVATE LIMITED",
"TERBOL LABORATORIES PRIVATE LIMITED",
"TERCEPT TECHNOLOGIES PRIVATE LIMITED",
"TERELI ESTATES PRIVATE LIMITED",
"TEREN POWER PRIVATE LIMITED",
"TEREOS INDIA PRIVATE LIMITED",
"TERESIAN COLLEGE",
"TEREX CORPORATION",
"TEREX INDIA PRIVATE LIMITED",
"TERGENE BIOTECH LIMITED",
"TERGUM REMEDIES PRIVATE LIMITED",
"TERI OAT AGRO INDUSTRIES PRIVATE LIMITED",
"TERI SCHOOL OF ADVANCED STUDIES",
"TERICSOFT TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"TERITEX KNITTING INDUSTRIES PRIVATE LIMITED",
"TERIX COMPUTER SERVICE INDIA PRIVATE LIMITED",
"TERMA (INDIA) PRIVATE LIMITED",
"TERMA MEDICARE INDIA PRIVATE LIMITED",
"TERMICO ENGINEERS & ERECTORS PRIVATE LIMITED",
"TERMINAL TECHNOLOGIES INDIA PRIVATE LIMITED",
"TERMINAL WINE PRIVATE LIMITED",
"TERMINALX GLOBAL TECHNOLOGIES PRIVATE LIMITED",
"TERMINIX SIS INDIA PRIVATE LIMITED",
"TERMINUS CIRCUITS PRIVATE LIMITED",
"TERMINUS DEVELOPERS PRIVATE LIMITED",
"TERMINUS INFRASTRUCTURES INDIA PRIVATE LIMITED",
"TERMINUS KG VENTURES PRIVATE LIMITED",
"TERMINUS OWNERS ASSOCIATION",
"TERMINUS VENTURES PRIVATE LIMITED",
"TERN ENGINEERING & CONSTRUCTION SERVICES PRIVATE LIMITED",
"TERN VOYAGES PRIVATE LIMITED",
"TERNA MEDICAL COLLEGE",
"TERNA ORCHIDS THE INTERNATIONAL SCHOOL",
"TERNA PUBLIC CHARITABLE TRUSTS TERNA ENGINEERING COLLEGE",
"TERNA PUBLIC CHARTIABLE TRUST TERNA MEDICAL COLLEGE",
"TERNA VIDYALAYA ENGLISH MEDIUM",
"TERNATE TECHSOL PRIVATE LIMITED",
"TERONIX INDIA PRIVATE LIMITED",
"TEROTECH ENGINEERS PVT LTD",
"TERPENE FLAVOURS AND FRAGRANCES PRIVATE LIMITED",
"TERPL INDIA PRIVATE LIMITED",
"TERRA AGROBIOTECH PRIVATE LIMITED",
"TERRA BESPOKE BUILD PRIVATE LIMITED",
"TERRA BLUE EXPLORATION TECHNOLOGIES PRIVATE LIMITED",
"TERRA EDGE SOFT PRIVATE LIMITED",
"TERRA FINANCIAL SERVICES PRIVATE LIMITED",
"TERRA FIRMA PROJECTS PRIVATE LIMITED",
"TERRA INTERIORS INDIA PRIVATE LIMITED",
"TERRA MIN RESOURCES PRIVATE LIMITED",
"TERRA MOTORS INDIA PRIVATE LIMITED",
"TERRA PHARMA PRIVATE LIMITED",
"TERRA POLYPLAST PRIVATE LIMITED",
"TERRA VERDE FOODS PRIVATE LIMITED",
"TERRA WORLD TRAVEL INDIA PRIVATE LIMITED",
"TERRABIT CONSULTING PRIVATE LIMITED",
"TERRACE BAY PULP MILL",
"TERRACE PHARMACEUTICALS PRIVATE LIMITED",
"TERRACIS TECHNOLOGIES LIMITED",
"TERRACLE PRIVATE LIMITED",
"TERRACO INDIA PRIVATE LIMITED",
"TERRACODE SYSTEMS PRIVATE LIMITED",
"TERRACON ECOTECH PRIVATE LIMITED",
"TERRACON TRADING PRIVATE LIMITED",
"TERRAFORM GEOTECHNICAL SERVICES PRIVATE LIMITED",
"TERRAFORM GLOBAL INDIA PRIVATE LIMITED",
"TERRAGLEBE FARMERS PRODUCER COMPANY LIMITED",
"TERRAGNI CONSULTING PRIVATE LIMITED",
"TERRAGO LOGISTICS PRIVATE LIMITED",
"TERRAGREEN AGRITECH VENTURES PRIVATE LIMITED",
"TERRAIN ENGINEERING SOLUTIONS PRIVATE LIMITED",
"TERRAIN GREENS PRIVATE LIMITED",
"TERRALENZE TECHNOLOGIES PRIVATE LIMITED",
"TERRALIGHT KANJI SOLAR PRIVATE LIMITED",
"TERRALIGHT RAJAPALAYAM SOLAR PRIVATE LIMITED",
"TERRALIGHT SOLAR ENERGY CHARANKA PRIVATE LIMITED",
"TERRALIGHT SOLAR ENERGY NANGLA PRIVATE LIMITED",
"TERRALIGHT SOLAR ENERGY PATLASI PRIVATE LIMITED",
"TERRALIGHT SOLAR ENERGY TINWARI PRIVATE LIMITED",
"TERRALOGIC DIGITAL CREATIVE PRIVATE LIMITED",
"TERRALOGIC SOFTWARE SOLUTIONS PRIVATE LIMITED",
"TERRALYTICS ANALYSIS PRIVATE LIMITED",
"TERRAMAR SALES PRIVATE LIMITED",
"TERRAMARE INDIA PRIVATE LIMITED",
"TERRAMERA BIOSCIENCES INDIA PRIVATE LIMITED",
"TERRAMICA CERAMICS AND AUTOMATION INDIA PRIVATE LIMITED",
"TERRAMOM AGROTECH PRIVATE LIMITED",
"TERRAPAY SOLUTIONS INDIA PRIVATE LIMITED",
"TERRAPLAZO REALTY MANAGEMENT PRIVATE LIMITED",
"TERRAPOLIS ASSETS PRIVATE LIMITED",
"TERRAPRO TRADEX PRIVATE LIMITED",
"TERRAQUAER VENTURE PRIVATE LIMITED",
"TERRASERVE FOODS PRIVATE LIMITED",
"TERRASHINE INFRAHEIGHT PRIVATE LIMITED",
"TERRASOFT INFOSYSTEMS PRIVATE LIMITED",
"TERRASPACE ESERVICES PRIVATE LIMITED",
"TERRATEC INDIA PRIVATE LIMITED",
"TERRATECH CHEMICALS (INDIA) PRIVATE LIMITED",
"TERRATECH INFRA INDIA PRIVATE LIMITED",
"TERRESTRIAL FOOD PROCESSORS PRIVATE LIMITED",
"TERRESTRIAL FOODS LIMITED",
"TERREXO RAIL INFRASTRUCTURE PRIVATE LIMITED",
"TERRIBERRI APPARELS PRIVATE LIMITED",
"TERRIBLY TINY VENTURES PRIVATE LIMITED",
"TERRIER SECURITY SERVICES INDIA PRIVATE LIMITED",
"TERRIER UTILITY SERVICES PRIVATE LIMITED",
"TERRIFIC MINDS PRIVATE LIMITED",
"TERRIL IMPEX INDIA PRIVATE LIMITED",
"TERRITORY OF DELHI",
"TERSE SOFTWARE PRIVATE LIMITED",
"TERSUS ENERGY PRIVATE LIMITED",
"TERTIUM TECHNOLOGY PRIVATE LIMITED",
"T-ERUDITE SHIP MANAGERS PRIVATE LIMITED",
"TERUMO CORPORATION",
"TERUMO INDIA PRIVATE LIMITED",
"TERUMO PENPOL PRIVATE LIMITED",
"TERVIVA INDIA PRIVATE LIMITED",
"TERYAIR EQUIPMENT PRIVATE LIMITED",
"TES ELECTRONIC SOLUTIONS INDIA PRIVATE LIMITED",
"TES PACKAGING PRIVATE LIMITED",
"TES TECHNO COATS PRIVATE LIMITED",
"TESA TAPES INDIA PRIVATE LIMITED",
"TES-AMM INDIA PRIVATE LIMITED",
"TESC LOGISTICS SOLUTIONS PRIVATE LIMITED",
"TESCA TECHNOLOGIES PRIVATE LIMITED",
"TESCA TEXTILES & SEAT COMPONENTS (INDIA) PRIVATE LIMITED",
"TESCAR EQUIPMENTS PRIVATE LIMITED",
"TESCO BENGALURU PRIVATE LIMITED",
"TESCO INTERNATIONAL SOURCING LIMITED",
"TESCO SOURCING INDIA PRIVATE LIMITED",
"TESCOM ELECTRONICS PRIVATE LIMITED",
"TESCON MULTI PRODUCT PRIVATE LIMITED",
"TESCOS LIFE CARE PRIVATE LIMITED",
"TESCRA SOFTWARE PRIVATE LIMITED",
"TESHI ENGINEERS & SALES PROMOTERS PRIVATE LIMITED",
"TESHI FITTINGS PRIVATE LIMITED",
"TESIN PRODUCTS PRIVATE LIMITED",
"TESLA CONTROLS INDIA PRIVATE LIMITED",
"TESLA ELECTRIC AND ENGINEERING INDIA PRIVATE LIMITED",
"TESLA ELECTROSYSTEMS PRIVATE LIMITED",
"TESLA ENGINEERS PVT LTD",
"TESLA FOODS MANUFACTURING PRIVATE LIMITED",
"TESLA FOODS PRIVATE LIMITED",
"TESLA INFOTECH PRIVATE LIMITED",
"TESLA LABS PRIVATE LIMITED",
"TESLA OUTSOURCING SERVICES",
"TESLA POWER EQUIPMENTS AND PROJECTS PRIVATE LIMITED",
"TESLA TRANSFORMERS (GLOBAL) PRIVATE LIMITED",
"TESLA TRANSFORMERS (INDIA) LIMITED",
"TESLA TRANSFORMERS LIMITED",
"TESLATECH INDIA PRIVATE LIMITED",
"TESLEAD EQUIPMENTS PRIVATE LIMITED",
"TESLON TECHNOLOGIES PRIVATE LIMITED",
"TESMO MOTORCAST PRIVATE LIMITED",
"TESNA TECH PRIVATE LIMITED",
"TESPA INDIA PRIVATE LIMITED",
"TESPA INFOTECH PRIVATE LIMITED",
"TESPA TOOLS PRIVATE LIMITED",
"TESS DATA SOLUTIONS LLP",
"TESSARAKT EXPERIENTIAL PRIVATE LIMITED",
"TESSCORN NANO SCIENCE INC",
"TESSCORN SYSTEMS INDIA PRIVATE LIMITED",
"TESSENDERLO KERLEY INDIA PRIVATE LIMITED",
"TESSER INSIGHTS PRIVATE LIMITED",
"TESSERACT IMAGING PRIVATE LIMITED",
"TESSERACT LEARNING PRIVATE LIMITED",
"TESSILE CLOTHING PRIVATE LIMITED",
"TESSITURA MONTI INDIA PRIVATE LIMITED",
"TESSMOTECH PRIVATE LIMITED",
"TESSOLVE SEMICONDUCTOR PRIVATE LIMITED",
"TESSRAC INNOVATIONS PRIVATE LIMITED",
"TEST & RESEARCH INDIA PRIVATE LIMITED",
"TEST AND VERIFICATION SOLUTIONS INDIA PRIVATE LIMITED",
"TEST COMPANY",
"TEST TRIANGLE SOFTWARE SERVICES PRIVATE LIMITED",
"TEST YANTRA SOFTWARE SOLUTIONS INDIA PRIVATE LIMITED",
"TESTAMATIC SYSTEMS PRIVATE LIMITED",
"TESTCORE IT SOLUTIONS PRIVATE LIMITED",
"TESTED AND TRUSTED PHARMA PRIVATE LIMITED",
"TESTEX NDT INDIA PRIVATE LIMITED",
"TESTHOUSE INDIA PRIVATE LIMITED",
"TESTING INSTRUMENTS MANUFACTURING CO. PRIVATE LIMITED",
"TESTING MAVENS SOFTWARE PRIVATE LIMITED",
"TESTINGMIND CONSULTING OPC PRIVATE LIMITED",
"TESTINGXPERTS PRIVATE LIMITED",
"TESTO INDIA PRIVATE LIMITED",
"TESTON CONSULTING PRIVATE LIMITED",
"TESTORIGEN SOFTWARE TESTING SERVICES PRIVATE LIMITED",
"TESTPAN INDIA PRIVATE LIMITED",
"TESTPREP PRINTS PRIVATE LIMITED",
"TESTPRESS TECH LABS LLP",
"TESTQ TECHNOLOGIES PRIVATE LIMITED",
"TESTRIQ QA LAB LLP",
"TESTRITE INTERNATIONAL COMPANY LIMITED",
"TESTSIGMA TECHNOLOGIES PRIVATE LIMITED",
"TESTTEX INDIA LABORATORIES PRIVATE LIMITED",
"TESTVAGRANT TECHNOLOGIES PRIVATE LIMITED",
"TESTWELL PLASTCHEM PRIVATE LIMITED",
"TESYNC TECHNOLOGY PRIVATE LIMITED",
"TETHERFI TECHNOLOGIES PRIVATE LIMITED",
"TETHYS CHEM PRIVATE LIMITED",
"TETHYS FOODS & BEVERAGES PRIVATE LIMITED",
"TETHYS LOGISTICS PRIVATE LIMITED",
"TETHYS TECHNOLOGIES PRIVATE LIMITED",
"TETON PROJECTS PRIVATE LIMITED",
"TETRA GRAND CONSTRUCTION PRIVATE LIMITED",
"TETRA INDIA PRIVATE LIMITED",
"TETRA INFORMATION SERVICES PRIVATE LIMITED",
"TETRA INTERNATIONAL INDIA PRIVATE LIMITED",
"TETRA MEDIA PRIVATE LIMITED",
"TETRA PAK INDIA PRIVATE LIMITED",
"TETRA QUEENS DISTILLERIES AND BREWERIES PRIVATE LIMITED",
"TETRA SOFT INDIA PRIVATE LIMITED",
"TETRA TECH ES INDIA PRIVATE LIMITED",
"TETRA TECH INDIA LIMITED",
"TETRA TEKSEAL PRIVATE LIMITED",
"TETRAD INFRASTRUCTURE PRIVATE LIMITED",
"TETRAD MICROBREWERIES PRIVATE LIMITED",
"TETRADRIP PHARMA PRIVATE LIMITED",
"TETRAHEDRON MANUFACTURING SERVICES PRIVATE LIMITED",
"TETRAHYDRON JR COLLEGE",
"TETRAKTYS LIFE SCIENCES PRIVATE LIMITED",
"TETRAMED BIOTEK PRIVATE LIMITED",
"TETRAPRO FINANCIAL CONSULTANTS P LIMITED",
"TETRASKELION SOFTWARES PRIVATE LIMITED",
"TETRASOFT LABS PRIVATE LIMITED",
"TETRON CAPITAL LIMITED",
"TETRON COMMERCIAL LTD",
"TETULIA COKE PLANT PVT. LTD.",
"TEUS AND TONS LOGISTICS PRIVATE LIMITED",
"TEVA API INDIA PRIVATE LIMITED",
"TEVA GLOBAL BUSINESS SERVICES PRIVATE LIMITED",
"TEVA INDIA PRIVATE LIMITED",
"TEVA PHARMACEUTICAL AND CHEMICAL INDUSTRIES INDIA PRIVATE LIMITED",
"TEVAPHARM INDIA PRIVATE LIMITED",
"TEVATRON TECHNOLOGIES PRIVATE LIMITED",
"TEVOS PHARMACEUTICALS LLP",
"TEW AUTOMATION PRIVATE LIMITED",
"TEWANI AND AMARNANI INFRASTRUCTURE PROJECTS PRIVATE LIMITED",
"TEWARI BROS. CONFECTIONERS PRIVATE LIMITED",
"TEWARI BROTHERS MITHAIWALA PRIVATE LIMITED",
"TEWARI CONFECTIONERS MITHAIWALA PRIVATE LIMITED",
"TEWARI ENTERPRISES PRIVATE LIMITED",
"TEWARI EYE CENTRE PRIVATE LIMITED",
"TEWARI FOODS PRIVATE LIMITED",
"TEWARI SWEETS PRIVATE LIMITED",
"TEWARI TEA TRADING PRIVATE LIMITED",
"TEWARI WAREHOUSING CO PRIVATE LIMITED",
"TEWATIA CONSTRUCTION PRIVATE LIMITED",
"TEX AND NETS PRIVATE LIMITED",
"TEX APPARELS PRIVATE LIMITED",
"TEX BIOSCIENCES PRIVATE LIMITED",
"TEX CORP LIMITED",
"TEX COTTON INDIA PRIVATE LIMITED",
"TEX INDIA ENTERPRISES PRIVATE LIMITED",
"TEX LIFESTYLE RETAIL PRIVATE LIMITED",
"TEX LINE INDIA PRIVATE LIMITED",
"TEX SHADOW PRIVATE LIMITED",
"TEX TECH INDUSTRIES INDIA PRIVATE LIMITED",
"TEX YEAR INDUSTRIAL ADHESIVES PRIVATE LIMITED",
"TEXACO OVERSEAS PRIVATE LIMITED",
"TEXALA INDIA PRIVATE LIMITED",
"TEXAM TECHNOLOGIES PRIVATE LIMITED",
"TEXAN INFRA MANAGEMENT PRIVATE LIMITED",
"TEXANLAB LABORATORIES PRIVATE LIMITED",
"TEXAS INSTRUMENTS INDIA PRIVATE LIMITED",
"TEXAS LEATHERS PRIVATE LIMITED",
"TEXAS LIFESCIENCES PRIVATE LIMITED",
"TEXAS LIFESTYLE FURNITURE PRIVATE LIMITED",
"TEXAS PHARMACEUTICALS PRIVATE LIMITED",
"TEXAS WOOLLEN MILLS PRIVATE LIMITED",
"TEXBASKET PRIVATE LIMITED",
"TEXBELT INDUSTRIES PVT.LTD.",
"TEX-BOLT FABRICS PRIVATE LIMITED",
"TEXBOND NONWOVENS",
"TEXCARP CONSULTING PRIVATE LIMITED",
"TEXCEL ENGINEERS PRIVATE. LIMITED.",
"TEXCEL INTERNATIONAL PRIVATE LIMITED",
"TEXCEL TOOLS AND SERVICES PRIVATE LIMITED",
"TEXCELEAD INDIA PRIVATE LIMITED",
"TEXCHEM DISTRIBUTORS PRIVATE LIMITED",
"TEXCITY BIOSCIENCES PRIVATE LIMITED",
"TEXCITY COLLEGE OF PARAMEDICAL SCIENCES",
"TEXCITY WIND FARM PRIVATE LIMITED",
"TEXCO MARKETING PRIVATE LIMITED",
"TEXCON STEELS LIMITED",
"TEXCORE TECHNOLOGIES PRIVATE LIMITED",
"TEXCORE TEXTILE PRIVATE LIMITED",
"TEXCOTT MILLS PRIVATE LIMITED",
"TEXEL INDIA TECHNOLOGY PRIVATE LIMITED",
"TEXEL INDUSTRIES LIMITED",
"TEXELLANCE CNC PRIVATE LIMITED",
"TEXELQ ENGINEERING INDIA PRIVATE LIMITED",
"TEXES CONNECT PRIVATE LIMITED",
"TEXES TELECOM PRIVATE LIMITED",
"TEXFAB ENGINEERS INDIA PRIVATE LIMITED",
"TEXIGN TRADING PRIVATE LIMITED",
"TEXILA EDUCARE HEALTHCARE AND TECHNOLOGY ENTERPRISES PRIVATE LIMITED",
"TEXILA EDUCATIONAL AND MANAGEMENT SERVICES PRIVATE LIMITED",
"TEXIMCO FOILS PRIVATE LIMITED",
"TEXLA INDUSTRIES",
"TEXLA PLASTICS AND METALS PVT LTD",
"TEXMACO INFRASTRUCTURE & HOLDINGS LIMITED",
"TEXMACO RAIL & ENGINEERING LIMITED",
"TEXMART TRADERS PRIVATE LIMITED",
"TEXMAT AGENCIES PVT LTD",
"TEXMEX CUISINE INDIA PRIVATE LIMITED",
"TEXMILL SPARES PVT LTD",
"TEXMO INDUSTRIES",
"TEXMO PIPES & PRODUCTS LIMITED.",
"TEXMY TRENDS PRIVATE LIMITED",
"TEXO TRADE PVT LTD",
"TEXOFIL INDUSTRIES PRIVATE LIMITED",
"TEXOL ENERGY PRIVATE LIMITED",
"TEXOL ENGINEERING PRIVATE LIMITED",
"TEXON FABRICS PRIVATE LIMITED",
"TEXON INDIA PRIVATE LIMITED",
"TEXON PACKAGING PRIVATE LIMITED",
"TEXONIC INSTRUMETNS",
"TEXOOL LIMITED",
"TEXOR ENERGY PRIVATE LIMITED",
"TEXPERTS INDIA PRIVATE LIMITED",
"TEXPLORE TRADING PRIVATE LIMITED",
"TEXPORT INDUSTRIES PRIVATE LIMITED",
"TEXPORT INTERNATIONAL PRIVATE LIMITED",
"TEXPORT OVERSEAS PRIVATE LIMITED",
"TEXPORT SYNDICATE INDIA LIMITED",
"TEXPRO INDUSTRIES PVT LTD",
"TEXRICA INDIA ORGANICS PRIVATE LIMITED",
"TEXSHADE PREFABS PRIVATE LIMITED",
"TEXSOL CHEMISOL PRIVATE LIMITED",
"TEXSOL ENTERPRISES PRIVATE LIMITED",
"TEXSPIN BEARINGS LTD",
"TEXSPUN YARNS & FABRICS PRIVATE LIMITED",
"TEX-STYLES INTERNATIONAL PRIVATE LIMITED",
"TEXSYS INDIA PRIVATE LIMITED",
"TEXTECH INDO INDIA PRIVATE LIMITED",
"TEXTEL TECHNOLOGIES PRIVATE LIMITED",
"TEXTIFY DIGITALS PRIVATE LIMITED",
"TEXTILE AND ENGINEERING INSTITUTE",
"TEXTILE CREATIONS INDIA PRIVATE LIMITED",
"TEXTILE LABOURER'S CO-OP STORES LIMITED",
"TEXTILE PLUS INDIA LIMITED",
"TEXTILE RUBBER AND CHEMICAL COMPANY (INDIA) PRIVATE LIMITED",
"TEXTILE SECTOR SKILL COUNCIL",
"TEXTILE SOURCING AND SERVICES PRIVATE LIMITED",
"TEXTILE TEXTILE (KAMAL) PRIVATE LIMITED",
"TEXTILE TRADERS PRIVATE LIMITED",
"TEXTNATION DIGITAL SOLUTIONS PRIVATE LIMITED",
"TEXTRADE INTERNATIONAL LIMITED",
"TEX-TREE COMMODITIES PRIVATE LIMITED",
"TEXTREND LIFESTYLE PRIVATE LIMITED",
"TEXTRON INDIA PRIVATE LIMITED",
"TEXTRONICS DESIGN SYSTEMS (INDIA) PRIVATE LIMITED",
"TEXTRONIK INDUSTRIES PRIVATE LIMITED",
"TEXTUAL ANALYTICS SOLUTIONS PRIVATE LIMITED",
"TEXTURE CONCEPTS PRIVATE LIMITED",
"TEXTURES AND WEAVES INDIA PRIVATE LIMITED",
"TEXTURING TECHNOLOGY PRIVATE LIMITED",
"TEXUS HEALTHCARE SYSTEM PRIVATE LIMITED",
"TEXVALLEY MARKET LIMITED",
"TEXWIN SPINNING PRIVATE LIMITED",
"TEXWORKS TESSILE PRIVATE LIMITED",
"TEXWORLD FASHIONS PRIVATE LIMITED",
"TEXXCO APPARELS PRIVATE LIMITED",
"TEXZIUM INTERNATIONAL PRIVATE LIMITED",
"TEXZONE INFORMATION SERVICES PRIVATE LIMITED",
"TEYHAR KNITWEARS PRIVATE LIMITED",
"TEYMA INDIA PRIVATE LIMITED",
"TEZ GATI CARGOMOVERS PRIVATE LIMITED",
"TEZAS INFRACON PRIVATE LIMITED",
"TEZAS TRADING CO. PRIVATE LIMITED",
"TEZPUR INSTITUTE OF MEDICAL SCIENCES PRIVATE LIMITED",
"TEZYASH POWER ENERGY PRIVATE LIMITED",
"TFA AGRI INITIATIVES PRIVATE LIMITED",
"TFB EXIM INDIA PRIVATE LIMITED",
"TFC DIGITAL (OPC) PRIVATE LIMITED",
"TFC INDUSTRIES",
"TFD COMMUNICATIONS PRIVATE LIMITED",
"TFG TOURS AND TRAVELS PRIVATE LIMITED",
"TFG VACATIONS INDIA PRIVATE LIMITED",
"T-FIT INSULATION SOLUTIONS INDIA PRIVATE LIMITED",
"TFK PROJECTS PRIVATE LIMITED",
"TFK WHOLESALES PRIVATE LIMITED",
"TFL CONTINUOUS LEARNING PRIVATE LIMITED",
"TFL FOODS PRIVATE LIMITED",
"TFL QUINN INDIA PRIVATE LIMITED",
"TFM FASHION AND ENTERTAINMENT INDIA PRIVATE LIMITED",
"TFR FURNITURE & INTERIORS PRIVATE LIMITED",
"TFR TECHNOLOGIES INDIA PRIVATE LIMITED",
"TFS (R&R WORKS) PRIVATE LIMITED",
"TFS BUSINESS ADVISORS INDIA PRIVATE LIMITED",
"TFS CORPORATE SOLUTIONS LIMITED",
"TFSM INDIA PRIVATE LIMITED",
"TFT FOODS AND BEVERAGES PRIVATE LIMITED",
"TFURNISH PRIVATE LIMITED",
"TG ADVAIT INDIA PRIVATE LIMITED",
"TG APPAREL & DECOR PRIVATE LIMITED",
"TG CONNECT PRIVATE LIMITED",
"TG LEGACY PRIVATE LIMITED",
"TG SUGARS LIMITED",
"TG TERMINALS PRIVATE LIMITED",
"TGA SALES AND SERVICES PRIVATE LIMITED",
"TGB BAKERS AND CONFECTIONERS PRIVATE LIMITED",
"TGB BANQUETS AND HOTELS LIMITED",
"TGB FOODS PRIVATE LIMITED",
"TGB REALCON PRIVATE LIMITED",
"TGC EXPORTS PRIVATE LIMITED",
"TGC INNOVATION RETAILS PRIVATE LIMITED",
"TGC MOTORS PRIVATE LIMITED",
"TGC TECHNOLOGIES PRIVATE LIMITED",
"TGD MARKETING PRIVATE LIMITED",
"TGE GAS ENGINEERING PRIVATE LIMITED",
"T-GENIES (INDIA) PRIVATE LIMITED",
"TGG LEARNING SOLUTIONS PRIVATE LIMITED",
"TGG VENTURES PRIVATE LIMITED",
"TGH LIFESTYLE SERVICES PRIVATE LIMITED",
"TGH PROCESS SOLUTIONS PRIVATE LIMITED",
"TGI HOTELS AND HOSPITALITY SERVICES PRIVATE LIMITED",
"TGK INFOTECH PRIVATE LIMITED",
"TGK SPECIAL STEEL PRIVATE LIMITED",
"TGN CORPORATE ADVISORS PRIVATE LIMITED",
"TGR TRADES PRIVATE LIMITED",
"TGS CONSTRUCTIONS PRIVATE LIMITED",
"TGS FOODZ PRIVATE LIMITED",
"TGS FOREX SERVICES PRIVATE LIMITED",
"TGS MINMET PRIVATE LIMITED",
"TGT FUEL TECHNOLOGIES PRIVATE LIMITED",
"TGT IT SERVICES PRIVATE LIMITED",
"TGT TECH PRIVATE LIMITED",
"TGV INDUSTRIES PRIVATE LIMITED",
"TGV SRAAC LIMITED",
"TGW MACHINE KNIVES PRIVATE LIMITED",
"THA GIRDHARDAS SUNDARJI EXIM PRIVATE LIMITED",
"THAAI CASTING",
"THAAIMAI FERTILITY & RESEARCH CENTRE",
"THAAIMAI HOSPITAL",
"THACKER AND COMPANY LIMITED",
"THACKER DAIRY PRODUCTS PRIVATE LIMITED",
"THACKER INDUSTRIES (INDIA) LIMITED",
"THACKER RUBBER AND ALLIED INDUSTRIES PRIVATE LIMITED",
"THACKERS HOLDINGS PRIVATE LIMITED",
"THADOMAL SHAHANI ENGINEERING COLLEGE",
"THAI AIRWAYS INTERNATIONAL PUBLIC COMPANY LIMITED",
"THAI HOMES PRIVATE LIMITED",
"THAI IMPEX PRIVATE LIMITED",
"THAI MOOGAMBIKAI AGENCIES",
"THAI PEROXIDE COMPANY LIMITED",
"THAI PLASTIC PRIVATE LIMITED",
"THAI SUMMIT AUTOPARTS INDIA PRIVATE LIMITED",
"THAI TEXTILES 05 PRIVATE LIMITED",
"THAI THIRUNAAL AGRO FOODS PRIVATE LIMITED",
"THAICRATE DELIVERY PRIVATE LIMITED",
"THAIGER PHARMA PRIVATE LIMITED",
"THAIKKATTU MOOSS VAIDYARATNAM OUSHADHASALA PRIVATE LIMITED",
"THAIMOOKAMBIKAI COLLEGE OF PHYSIOTHERAPH",
"THAKAR CHEMICALS LIMITED",
"THAKAR DASS NAND GOPAL",
"THAKAR SOFTWARE PRIVATE LIMITED",
"THAKARA INFRADEVELOPERS PRIVATE LIMITED",
"THAKARSHI TEA PROCESSORS AND PACKERS PRIVATE LIMITED",
"THAKER COSMETICS PRIVATE LIMITED",
"THAKER ENGINEERING COMPANY PRIVATE LIMITED",
"THAKKAR INORGANICS PRIVATE LIMITED",
"THAKKAR MANPOWER SERVICES PVT LTD",
"THAKKAR POPATLAL VELJI SALES LIMITED",
"THAKKARS STARDOM EVENTS PRIVATE LIMITED",
"THAKKER MERCANTILE PRIVATE LIMITED",
"THAKKER ROADLINES PRIVATE LIMITED",
"THAKKERS DEVELOPERS LIMITED",
"THAKOR ELECTRONICS LIMITED",
"THAKOR REDUCTANT PRIVATE LIMITED",
"THAKORLAL HIRALAL EXPORTS PRIVATE LIMITED",
"THAKRAL CLOTHING PRIVATE LIMITED",
"THAKRAL ONE SOLUTIONS PRIVATE LIMITED",
"THAKRAL SERVICES INDIA LIMITED",
"THAKRAR INFOTRENDZ PRIVATE LIMITED",
"THAKUR APPARELS PRIVATE LIMITED",
"THAKUR AYURVEDIC PHARMACY PRIVATE LIMITED",
"THAKUR BHAGWANIDEVI MUSAFIR PUBLIC SCHOOL",
"THAKUR BUILDTECH PRIVATE LIMITED",
"THAKUR CABINS (INDIA) PRIVATE LIMITED",
"THAKUR COLLEGE OF ENG TECH",
"THAKUR CONSTRUCTIONS PRIVATE LIMITED",
"THAKUR CUT-PIECE HOUSE PRIVATE LIMITED",
"THAKUR ELECTRICALS & ENGINEERS PRIVATE LIMITED",
"THAKUR ENGINEERING & MAINTENANCE SERVICES PRIVATE LIMITED",
"THAKUR ENTERPRISES",
"THAKUR ESTATE DEVELOPMENT PVT LTD",
"THAKUR FININVEST PRIVATE LIMITED",
"THAKUR HARDSOFT PRIVATE LIMITED",
"THAKUR INFRA CONSTRUCTIONS PRIVATE LIMITED",
"THAKUR INFRA PROJECTS PRIVATE LIMITED",
"THAKUR INST OF MANAGEMANT STUDIES RESE",
"THAKUR INSTITUTE OF AVIATION TECHNOLOGY",
"THAKUR INSTITUTE OF MANAGEMENT STUDIES & RESEARCH",
"THAKUR JI LEASING AND FINANCE LIMITED",
"THAKUR MANUFACTURING PRIVATE LIMITED",
"THAKUR MHATRE JV",
"THAKUR MUKUND SINGH JH HIGH SCHOOL",
"THAKUR OVERSEAS PRIVATE LIMITED",
"THAKUR PRASAD MURARI LAL JEWELLERS PRIVATE LIMITED",
"THAKUR PRASAD SAO & SONS (WINES) PVT. LTD.",
"THAKUR PRASAD SAO & SONS PRIVATE LIMITED",
"THAKUR PUBLIC SCHOOL",
"THAKUR PUBLICATION PRIVATE LIMITED",
"THAKUR RAMESHWAR SINGH PVT LTD",
"THAKUR RAMNARAYAN PUBLIC SCHOOL",
"THAKUR REALTORS PRIVATE LIMITED",
"THAKUR REALTY PRIVATE LIMITED",
"THAKUR SAVADEKAR AND COMPANY PRIVATE LIMITED",
"THAKUR SCHOOL OF ARCHITECTURE & PLANNING",
"THAKUR SCHOOL OF ARCHITECTURE AND PLANNING",
"THAKUR SHYAMNARAYAN DEGREE COLLEGE",
"THAKUR V. S. BIDI WORKS POONA",
"THAKURDEVI INVESTNENTS PVT LTD",
"THAKURJI SOLVEX PRIVATE LIMITED",
"THALAIVAR STEELS LIMITED",
"THALAPPAKATTI HOTELS PRIVATE. LIMITED.",
"THALASSA ENTERPRISES LIMITED",
"THALASSERY LULU GOLD SUPER MARKET PRIVATE LIMITED",
"THALASSERY LULU SAREES AND TEXTILES PRIVATE LIMITED",
"THALASSERY MISSION HOSPITAL PRIVATE LIMITED",
"THALES",
"THALES DIS TECHNOLOGY INDIA PRIVATE LIMITED",
"THALES INDIA PRIVATE LIMITED",
"THALES RELIANCE DEFENCE SYSTEMS LIMITED",
"THALI AND MORE MEALS LLP",
"THALIA LABH HOMEMAKERS PRIVATE LIMITED",
"THALIA LABHA HOME PRIVATE LIMITED",
"THALIA TECHNOLOGIES PRIVATE LIMITED",
"THALIA TRADING & LOGISTICS PRIVATE LIMITED",
"THALIGAI AGRO FOODS PRIVATE LIMITED",
"THALIYAN TRADERS PRIVATE LIMITED",
"THAMAR FRESH INDIA PRIVATE LIMITED",
"THAMARA HOUSING DEVELOPERS PRIVATE LIMITED",
"THAMARAI AUTOMOBILES",
"THAMARAI INTERNATIONAL SCHOOL",
"THAMARAPPALLY BROTHERS TRADING PRIVATE LIMITED",
"THAMBBI MODERN SPINNING MILLS LIMITED",
"THAMBI MEDICAL SURGICAL EYE HOSPITAL PRIVATE LIMITED",
"THAMES CONSULTANTS PRIVATE LIMITED",
"THAMES SIDE SENSORS INDIA PRIVATE LIMITED",
"THAMES STEELS PRIVATE LIMITED",
"THAMES TECHNOLOGIES PRIVATE LIMITED",
"THAMESLINK INFO SOLUTIONS PRIVATE LIMITED",
"THAMIZH POWER SOLUTIONS PRIVATE LIMITED",
"THAMIZHAGA CABLE TV COMMUNICATION LIMITED",
"THAMIZHAGA CABLE TV COMMUNICATION PRIVATE LIMITED",
"THAMIZHAGA INTERNET COMMUNICATIONS PRIVATE LIMITED",
"THAMPURAN JEWELLERY",
"THANAPANDIYAN POLYTECHNIC COLLEGE",
"THANAWALA BROTHERS AND INNS PRIVATE LIMITED",
"THANAWALA CYCLES PRIVATE LIMITED",
"THANCO NATURAL FOODS PRIVATE LIMITED",
"THANE BHARAT SAHAKARI BANK LIMITED",
"THANE BHARAT SAHAKARI BANK LTD",
"THANE CREEK BRIDGE INFRASTRUCTURE LIMITED",
"THANE DIAGNOSTICS PRIVATE LIMITED",
"THANE DISTRICT MILK & AGRO ORGANISATION PRIVATE LIMITED",
"THANE GHODBUNDER TOLL ROAD PRIVATE LIMITED",
"THANE HEALTH CARE PRIVATE LIMITED",
"THANE MOTORS PRIVATE LIMITED",
"THANE MUNICIPAL CORPORATION",
"THANE POLICE SCHOOL",
"THANE STEELS PRIVATE LIMITED",
"THANGA PRATAPH SPINNING MILLS PRIVATE LIMITED",
"THANGALS JEWELLERY PRIVATE LIMITED",
"THANGAM CORPORATE SERVICES PRIVATE LIMITED",
"THANGAM ELECTRONICS PRIVATE LIMITED",
"THANGAM HOSPITAL OF PMRC",
"THANGAM METAL CANS PRIVATE LIMITED",
"THANGAM OFFSETS PRIVATE LIMITED",
"THANGAM PIPES PRIVATE LIMITED",
"THANGAM TIN CANS PRIVATE LIMITED",
"THANGAMANI ENGINEERING INDUSTRY PRIVATE LIMITED",
"THANGAMANI PROPERTY DEVELOPERS PRIVATE LIMITED",
"THANGAMAYIL JEWELLERY LIMITED",
"THANGAMMAN IMPEX PRIVATE LIMITED",
"THANGAMMAN TEXTILE",
"THANGAVELU ENGINEERING COLLEGE",
"THANGAVELU TEXTILE MILLS PRIVATE LIMITED",
"THANGE TRANSPORT SERVICE PRIVATE LIMITED",
"THANGJAM AGRO INDUSTRIES PRIVATE LIMITED",
"THANIA INFRASTRUCTURE & PROJECT PRIVATE LIMITED",
"THANIGAI MURUGAN RESTAURANTS PRIVATE LIMITED",
"THANKS POWERS PRIVATE LIMITED",
"THANKYS EXPORTS PVT LTD",
"THANOS TECHNOLOGIES PRIVATE LIMITED",
"THANSAU DECORS PRIVATE LIMITED",
"THANTHAI HANS ROEVER COLLEGE OF ARTS S",
"THANUSH ISPAT PRIVATE LIMITED",
"THAPAR BUILDTECH PRIVATE LIMITED",
"THAPAR INSTITUTE OF ENGG AND TECHNOLOGY",
"THAPAR REALTORS PRIVATE LIMITED",
"THAPARSONS K.V. SHIPPING AGENTS PRIVATE LIMITED",
"THAPOVAN INFO SYSTEMS PRIVATE LIMITED",
"THAPSON SYSTEMS PVT LTD",
"THAR AUTOMOBILES PRIVATE LIMITED",
"THAR CAMPS PRIVATE LIMITED",
"THAR COMMERCIAL FINANCE PRIVATE LIMITED",
"THAR COMMODITIES PRIVATE LIMITED",
"THAR HOUSING AND INFRA DEVELOPERS PRIVATE LIMITED",
"THAR LIFESTYLE PRIVATE LIMITED",
"THAR MACHINING CITY PRIVATE LIMITED",
"THAR MERCHANTS PRIVATE LIMITED",
"THAR MOTOR COMPANY PRIVATE LIMITED",
"THAR OASIS RESORT AND CAMP PRIVATE LIMITED",
"THAR POWER TRANSMISSION SERVICE LIMITED",
"THAR SHARE BROKERS PRIVATE LIMITED",
"THAR WORX PRIVATE LIMITED",
"THARA SUPER MARKET PRIVATE LIMITED",
"THARAKAN FOODS PRIVATE LIMITED",
"THARAKAN WEB INNOVATIONS PRIVATE LIMITED",
"THARAVU TECHNOLOGIES PRIVATE LIMITED",
"THARAYIL ENGINEERING PRIVATE LIMITED",
"THARAYIL POWER AND ENERGY SOLUTIONS PRIVATE LIMITED",
"THARD PVT LTD",
"THARI AND THARSI ASSOCIATES SERVICES PRIVATE LIMITED",
"THARUN GLOBAL IMPEX ENTERPRISES PRIVATE LIMITED",
"THARUN TEXSPIN MILLS PRIVATE LIMITED",
"THARWANI CONSTRUCTIONS PRIVATE LIMITED",
"THASMA CONSTRUCTION PRIVATE LIMITED",
"THATAVARTHI APPARELS PRIVATE LIMITED",
"THATHI INFIN LEASE SERVICES PRIVATE LIMITED",
"THATTE ASSOCIATES PRIVATE LIMITED",
"THATZ IT PRIVATE LIMITED",
"THAVKI SAREES PRIVATE LIMITED",
"THAYNE AUTOMATION PRIVATE LIMITED",
"THCO. INDIA PRIVATE LIMITED",
"THD MAINTENANCE COMPANY PRIVATE LIMITED",
"THDC EDUCATION SOCEITY HIGH SCHOOL RISHIKESH",
"THDC INDIA LIMITED",
"THDC MANAGEMENT SERVICES LIMITED",
"THE A I ZAVERI HIGH SCHOOL &NIMA H S SCHOOL",
"THE A P STATE CO OPERATIVE BANK LIMITED",
"THE ACACIA HOTEL AND SPA",
"THE ACCORD METROPOLITAN J HOTELS PRIVATE",
"THE ACETECH MACHINERY COMPONENTS INDIA PRIVATE LIMITED",
"THE ADDRESS MAKERS DEVELOPERS PRIVATE LIMITED",
"THE ADILABAD DISTRICT CO-OP CENTRAL BANK",
"THE ADITYA BIRLA INTEGRATED SCHOOL",
"THE ADITYA BIRLA PUBLIC SCHOOL",
"THE ADITYA BIRLA PUBLIC SCHOOL NAGDA",
"THE ADVENT SCHOOL",
"THE ADVERTISING CORPN OF INDIA PVT LTD",
"THE ADVERTISING STANDARDS COUNCIL OF INDIA",
"THE AGRICULTURAL PRODUCE MARKET COMMITTEE",
"THE AGRICULTURE PRODUCE MARKET COMMITTEE , BARDOLI",
"THE AHMEDNAGAR DISTRICT CENTRAL CO-OP BANK LTD",
"THE AIR FORCE SCHOOL",
"THE AJARA URBAN CO OP BANK LTD",
"THE AKANKSHA FOUNDATION",
"THE AKOLA URBAN CO OPERATIVE BANK LTD",
"THE AKSHAYA PATRA FOUNDATION",
"THE ALCHEMISTS ARK PRIVATE LIMITED",
"THE ALL INDIA PLASTICS MANUFACTURES ASSOCIATION",
"THE ALL INDIA TEA & TRADING COMPANY LTD",
"THE ALLEPPEY COMPANY LIMITED",
"THE ALLIED FOUNDERS PRIVATE LIMITED",
"THE ALLSTATE CORPORATION",
"THE AMAIZE GOURMET FOODS PRIVATE LIMITED",
"THE AMALGAMATED COALFIELDS LIMITED",
"THE AMERICAN INDIA FOUNDATION TRUST",
"THE AMERICAN INDIAFOUNDATION TRUST",
"THE AMORE BANQUETS",
"THE AMRAVATI Z P SHIKSHAK SAHAKARI BANK LTD",
"THE AMRITSAR DISTT CO-OP MILK PROD UNION LTD",
"THE ANANDA BAG TEA CO LTD",
"THE ANANDA IMPERIAL",
"THE ANANTAPUR DISTRICT COOPERATIVE CENTRAL BANK LTD",
"THE ANAPARAI ESTATES LIMITED",
"THE ANDERSONS, INC.",
"THE ANDHRA PETROCHEMICALS LIMITED",
"THE ANDHRA PRADESH MERCANTILE CO OP CREDIT SOCIETY LTD",
"THE ANGLO SCOTTISH EDUCATION SOCIETY",
"THE ANGUS COMPANY LIMITED",
"THE ANNAPURNA TEXTILES PRIVATE LIMITED",
"THE ANUP ENGINEERING LIMITED",
"THE ARASAN ALUMINIUM INDUSTRIES PRIVATE LIMITED",
"THE ARYA VAIDYA PHARMACY COIMBATORE LIMITED",
"ARYAN PUBLIC SCHOOL",
"THE ASIAN SCHOOL",
"THE ASIATIC SOCIETY KOLKATA",
"THE ASIATIC SOCIETY OF MUMBAI",
"THE ASSEMBLY OF GOD CHURCH",
"THE ASSEMBLY OF GOD CHURCH SCHOOL",
"THE ASSISTANT COMMISSIONER DIVISION DEPARTMENT",
"THE ASSOCIATED AUTO PARTS PRIVATE LIMITED",
"THE ASSOCIATED BUILDING COMPANY LIMITED",
"THE ASSOCIATED CHAMBERS OF COMMERCE AND INDUSTRY OF INDIA",
"THE ASSOCIATED JOURNALS LIMITED",
"THE ASSOCIATED PRESS",
"THE ASSOCIATION FOR MANUFACTURING TECHNOLOGY",
"THE ASSOCIATION OF PEOPLE WITH DISABILITY (APD) INDIA",
"THE ATHENA SCHOOL",
"THE ATLANTIC OIL CO PVT LTD",
"THE ATLAS ELECTRIC INDUSTRIES PRIVATE LIMITED",
"THE ATPADI EDUCATION SOCIETY",
"THE AUDIO WORLD PRIVATE LIMITED",
"THE AURA CREATION EXPORTS PRIVATE LIMITED",
"THE AUTOMOTIVE RESEARCH ASSOCIATION OF INDIA",
"THE AZAD NAKODAR BUS SERVICE PVT LTD",
"THE BADHOULI PRIMARY CO-OP AGRI SOCIETY LTD",
"THE BAGHA PURANA CO-OPERATIVE MARKETING SOCIETY LTD",
"THE BAI SAKARBAI DINSHAW PETIT HOSPITAL FOR ANIMALS",
"THE BAILHONGAL URBAN CO-OP BANK LTD",
"THE BANDRA HOLY FAMILY HOSPITAL SOCIETY",
"THE BANGALORE CITY CO-OPERATIVE BANK LIMITED",
"THE BANGALORE PRINTING AND PUBLISHING COMPANY LIMITED",
"THE BANK OF NEW YORK MELLON CORPORATION",
"THE BANK OF NOVA SCOTIA",
"THE BANSIWALA MILLS PRIVATE LIMITED",
"THE BANTRA CO-OPERATIVE BANK LTD",
"THE BANYAN",
"THE BARAMATI SAHAKARI BANK LIMITED",
"THE BARODA RAYON CORPORATION LIMITED",
"THE BASAVANAGUDI CO OPERATIVE SOCIETY LTD",
"THE BAVLA NAGRIK SAHAKARI BANK LTD",
"THE BAZPUR CO-OPERATIVE SUGAR FACTORY LTD",
"THE BE BE RUBBER ESTATES LTD",
"THE BELAGAVI DISTRICT CENTRAL CO-OPERATIVE BANK LIMITED",
"THE BELGACHI TEA CO. LTD",
"THE BENGAL CHAMBER OF COMMERCE",
"THE BENGAL CHAMBER OF COMMERCE AND INDUSTRY",
"THE BENGAL CLUB LTD",
"THE BESANT THEOSOPHICAL HIGHER SECONDARY SCHOOL",
"THE BEST EMPLOYEES CO OP CREDIT SOCIETY LTD",
"THE BEST MOVE DEVELOPERS PRIVATE LIMITED",
"THE BHARAT CO OPERATIVE BANK LIMITED",
"THE BHARAT COLD STORAGE PRIVATE LIMITED",
"THE BHARAT MOTOR TRANSPORT CO PVT LTD",
"THE BHARUCH DIST CT CO OP BANK LTD",
"THE BHARUCH DISTRICT CENTRAL CO-OPERATIVE BANK LTD",
"THE BHAVANI TEA AND PRODUCE CO LTD",
"THE BHAVNAGAR SALT AND INDUSTRIAL WORKS PRIVATE LIMITED",
"THE BHOR CHEMICALS AND PLASTICS PRIVATE LIMITED",
"THE BHUBANDHAR TEA CO LTD",
"THE BHUJ MERCANTILE CO-OP BANK LTD",
"THE BIBLE SOCIETY OF INDIA",
"THE BIDAR DISTRICT CO-OP CENTRAL BANK LTD",
"THE BIG W COMPANY PRIVATE LIMITED",
"THE BIKER'S CAFE PRIVATE LIMITED",
"THE BIRLA COTTON SPINNING AND WEAVING MILLS LIMITED.",
"THE BISHOPS EDUCATION SOCIETY",
"THE BISRA STONE LIME COMPANY LIMITED",
"THE BLOCK DATA IT SOLUTION",
"THE BLUE DOOR CAFE PRIVATE LIMITED",
"THE BLUE MOUNTAINS SCHOOL",
"THE BOMBAY DYEING AND MANUFACTURING COMPANY LIMITED",
"THE BOMBAY FLYING CLUB'S",
"THE BOMBAY GARAGE ( RAJKOT ) PRIVATE LIMITED",
"THE BOMBAY INSTITUTION FOR DEAF AND MUTES",
"THE BOMBAY IRON MERCHANTS ASSOCIATION",
"THE BOMBAY LEATHER CLOTH MANUFACTURING COMPAMY PRIVATE LTD",
"THE BOMBAY PRESIDENCY GOLF CLUB LIMITED",
"THE BOMBAY SAMACHAR PRIVATE LIMITED",
"THE BOMBAY SUBURBAN GRAIN DEALERS' JUNIOR COLLEGE OF COMMERCE ARTS AND SCIENCE",
"THE BORMAH JAN TEA (1936) LIMITED",
"THE BOSTON CONSULTING GROUP INDIA PRIVATE LIMITED",
"THE BRAITHWAITE BURN AND JESSOP CONSTRUCTION COMPANY LIMITED",
"THE BRAND BREWERY PRIVATE LIMITED",
"THE BRIDGE TRUST",
"THE BRIGADE SCHOOL",
"THE BRIHAN MAHARASHTRA SUGAR SYNDICATE LIMITED",
"THE BRIHASPATI INFOTECH PRIVATE LIMITED",
"THE BRISTOL HOTEL",
"THE BRITISH INSTITUTE OF ENGG TECHNOLOGY (INDIA) PRIVATE LIMITED",
"THE BRITISH METAL CORPORATION INDIA PRIVATE LIMITED",
"THE BRITISH MOTOR CAR COMPANY (1934) PRIVATE LIMITED",
"THE BRITISH SCHOOL NEW DELHI",
"THE BRITISH SCHOOL PANCHKULA",
"THE BSS SCHOOL",
"THE BYKE HOSPITALITY LIMITED",
"THE BYRAMJEE JEEJEEBHOY PARSEE CHARITABLE INSTITUTION",
"THE CALCUTTA EMMANUEL SCHOOL",
"THE CALCUTTA PUNJAB CLUB LTD",
"THE CALCUTTA STOCK EXCHANGE LIMITED",
"THE CAMBAY INVESTMENT CORPORATION LIMITED",
"THE CANARA LAND INVESTMENTS LIMITED",
"THE CANARA SALES CORPORATION LIMITED",
"THE CANARA WORKSHOPS LIMITED",
"THE CANNING INDUSTRIES COCHIN LTD",
"THE CANVAS",
"THE CATHEDRAL VIDYA SCHOOL",
"THE CAWNPORE CLUB LIMITED",
"THE CELESTIAL PARK HOTEL",
"THE CENTRAL FINANCIAL CREDIT AND INVESTMENT CO OPERATIVE INDIA LIMITED",
"THE CENTRAL FINANCIAL CREDIT AND INVESTMENT CO-OPERATIVE (INDIA) LTD",
"THE CENTRAL PARK HOTEL",
"THE CENTRAL PRESS PRIVATE LIMITED",
"THE CENTRAL PROVINCES CLUB NAGPUR LIMITED",
"THE CENTRAL RAILWAY EMPLOYEES CO OP CREDIT SOCIETY LTD",
"THE CENTRE FOR SCIENCE AND ENVIRONMENT",
"THE CES COLLEGE OF ARTS AND COMMERCE",
"THE CHAMONG TEA CO LTD",
"THE CHANDIGARH STATE COOPERATIVE BANK LTD",
"THE CHARLES SCHWAB CORPORATION",
"THE CHEMBUR NAGRIK SAHAKARI BANK LTD",
"THE CHEMOURS INDIA PRIVATE LIMITED",
"THE CHENNAI SHOPPING MALL-JEWELLERS",
"THE CHIKHLI URBAN CO-OPERATIVE BANK LIMITED",
"THE CHILDREN'S AID SOCIETY MUMBAI",
"THE CHILDRENS GARDEN KINDERGARTEN SCHOOL",
"THE CHILDREN'S PLACE INDIA PRIVATE LIMITED",
"THE CHINTELS SCHOOL",
"THE CHIPLUN URBAN CO-OPERATIVE BANK LTD",
"THE CHOCALATE ROOM INDIA PRIVATE LIMITED",
"THE CHOCOLATE SPOON CO PRIVATE LIMITED",
"THE CHOCOLATEROOM INDIA PRIVATE LIMITED",
"THE CHOICE FASHION PRIVATE LIMITED",
"THE CHOPRAS I TECH PRIVATE LIMITED",
"THE CHRISTION CENTRAL HIGH SCHOOL UMARI ROAD",
"THE CHUBB CORPORATION",
"THE CITI CLUB PRIVATE LIMITED",
"THE CITY HIGH SCHOOL",
"THE CIVIL SERVICES SOCIETY",
"THE CLASSIC JOCKEY",
"THE CLEARING CORPORATION INDIA LIMITED",
"THE COCA-COLA COMPANY",
"THE COCHIN PLANTATIONS LTD",
"THE COCKTAIL-KING PRIVATE LIMITED",
"THE COIMBATORE COSMOPOLITAN CLUB",
"THE COLABA LAND AND MILL COMPANY LIMITED",
"THE COMMERCIAL MOTORS PRIVATE LIMITED",
"COMMUNITY HEALTH CENTRE",
"THE COMORIN MATCH INDUSTRIES PRIVATE LIMITED",
"THE COMPANY OF MASTER MARINERS OF INDIA.",
"THE COMPETENT HOTELS PRIVATE LIMITED",
"THE CONCEPT HOUSE INDIA PRIVATE LIMITED",
"THE CONNECTIVITY INDIA PRIVATE LIMITED",
"THE CONSTRUCTIONS AND INDUSTRIES PRIVATE LIMITED",
"THE CONTONMENT BOARD",
"THE CONTROLLER OF ACCOUNTS CENTRAL ACCOUNTS OFFICE",
"THE CORBETT FOUNDATION",
"THE CORONATION ARTS CRAFTS",
"THE CORONATION TEA CO. LTD.",
"THE COSMO WORLD",
"THE COSMOS CO-OPERATIVE BANK LIMITED",
"THE COTTANAD PLANTATIONS LTD",
"THE COTTON CORPORATION OF INDIA LIMITED",
"THE CREATIVE INFRA AND INTERIORS PRIVATE LIMITED",
"THE CREATIVE TEXTURE",
"THE CREEK PLANET SCHOOL",
"THE CROWN GROUP",
"THE D G RUPAREL COLLEGE OF ARTS SCIENCE & COMMERCE",
"THE DADAR PARSEE YOUTHS ASSEMBLY HIGH SCHOOL",
"THE DAILY THANTHI",
"THE DALAL FAMILY CHARITABLE FOUNDATION",
"THE DEAL INDIA PRIVATE LIMITED",
"THE DECCAN MERCHANT CO-OPERATIVE BANK LIMITED",
"THE DECORATIVE LAMINATES INDIA PRIVATE LIMITED",
"THE DELHI FLOUR MILLS COMPANY LIMITED",
"THE DELHI GOLF CLUB",
"THE DELHI SAFE DEPOSIT COMPANY LIMITED",
"THE DELHI STATE COOPERATIVE BANK LIMITED",
"THE DESIGN COMPANY INDIA",
"THE DESIGN VILLAGE FOUNDATION",
"THE DEVELOPMENT COMMISSIONER HANDICRAFTS",
"THE DEVICOLAM DISTILLERIES LTD",
"THE DHARAMSI MORARJI CHEMICAL COMPANY LIMITED",
"THE DIDWANA INVESTMENT COMPANY LIMITED",
"THE DINDIGUL IRON AND HARDWARES PRIVATE LIMITED",
"THE DIRBA C A S S LTD DIRBA",
"THE DIRECTOR GENERAL G S I",
"THE DISTRICT & SESSIONS JUDGE",
"THE DISTRICT COOPERATIVE CENTRAL BANK LTD",
"THE DIVINE TASTE PRIVATE LIMITED",
"THE DOABA CO-OP MILK PRODUCERS UNION LTD",
"THE DOLAGURI TEA CO PVT LTD",
"THE DOON GRAMMAR SCHOOL",
"THE DOON VALLEY PUBLIC SCHOOL",
"THE DUKES RETREAT PRIVATE LIMITED",
"THE DURGAPUR PROJECTS LTD",
"THE DWELLWELL PREMISES LLP",
"THE EASTERN BUNKERERS PRIVATE LIMITED",
"THE EASTERN OXYGEN & ACETYLENE PRIVATE LIMITED",
"THE EASTERN TEA CO LTD",
"THE EASTERN TEA ESTATES LIMITED",
"THE EIMCO-K C P LIMITED",
"THE EINFACH GROUP",
"THE ELURI CO OPERATIVE BANK",
"THE EMBASSY OF UNITED STATES OF AMERICA",
"THE EMERALD HEIGHTS INTERNATIONAL SCHOOL",
"THE EMPIRE JUTE COMPANY LTD",
"THE EMPOWERED COMMITTEE OF STATE FINANCE MINISTERS",
"THE ENERGY AND RESOURCES INSTITUTE",
"THE ENGLISH AND FOREIGN LANGUAGES UNIVERSITY",
"THE ERUDITE WORLD SCHOOL",
"THE ESTATE INVESTMENT COMPANY PRIVATE LIMITED",
"THE ETHIRAJ COLLEGE FOR WOMEN",
"THE EXECUTIVE CLUB HOTEL INDIA PRIVATE LIMITED",
"THE EXECUTIVE INN LIMITED",
"THE FD CENTRE SERVICES (INDIA) PRIVATE LIMITED",
"THE FEDERAL TRAVELS & TOURS",
"THE FEDERATION OF HOTEL AND RESTAURANT ASSOCIATIONS OF INDIA",
"THE FEDERATION OF TELANGANA CHAMBERS OF COMMERCE AND INDUSTRY",
"THE FERN RESIDENCY MUNDRA",
"THE FEROZEPUR CENTRAL COOPERATIVE BANK LTD",
"THE FERTILISER ASSOCIATION OF INDIA.",
"THE FINANCIAL EXPRESS PRINT MEDIA PRIVATE LIMITED",
"THE FIRST CUSTODIAN FUND (INDIA) LTD",
"THE FISHIN COMPANY",
"THE FITNESS LAB PRIVATE LIMITED",
"THE FLAVORS INDIA PRIVATE LIMITED",
"THE FRANK ANTHONY PUBLIC SCHOOL",
"THE FRANK ANTONY PUBLIC SCHOOL",
"THE FREYSSINET PRE-STRESSED CONCRETE COMPANY LIMITED",
"THE FRIENDS TEA CO LTD",
"THE FUTURE FOUNDATION SCHOOL",
"THE FUTURE KIDS SCHOOL",
"THE GALAXY SCHOOL WADI",
"THE GANDHI CO-OPERATIVE URBAN BANK LTD",
"THE GANDHI GUNJ COOPERATIVE BANK LTD",
"THE GANDHIDHAM MERCANTILE CO OPERATIVE BANK",
"THE GANDHIGRAM RURAL INSTITUTE (DEEMED TO BE UNIVERSITY)",
"THE GANGES MANUFACTURING COMPANY",
"THE GAP INC.",
"THE GATEWAY HOTEL AMBAD NASHIK",
"THE GATEWAY HOTEL PUNE",
"THE GATEWAY INVESTORS LIMITED",
"THE GAUDIUM SCHOOL",
"THE GAYATRI CO-OPERATIVE URBAN BANK LTD",
"THE GEM AND JEWELLERY EXPORT PROMOTION COUNCIL",
"THE GENERAL & INDUSTRIAL LEATHERS PRIVATE LIMITED",
"THE GENERAL FIBRE DEALERS PVT LTD",
"THE GLACIERS PRODUCTS INDIA PVT LTD",
"THE GLOBALIZERS EDUTRAIN PRIVATE LIMITED",
"THE GODAVARI GAS COMAPNY PRIVATE LIMITED",
"THE GOLD PUBLIC SCHOOL",
"THE GOLDEN JUBILEE CO OPERATIVE CREDIT SOCIETY LTD",
"THE GOLDMAN SACHS GROUP INC.",
"THE GOLKONDA HOTEL",
"THE GOOD STUFF PRIVATE LIMITED",
"THE GOPALPUR TEA CO LTD",
"THE GRAMPS INFRA PRIVATE LIMITED",
"THE GRAND HYATT PLAZA",
"THE GRAND JBR",
"THE GRAND RADIANT",
"THE GRAPEVINE CO SERVICES PRIVATE LIMITED",
"THE GREAT EASTERNS SHIPPING CO LIMITED",
"THE GREAT INDIA TOUR COMPANY PRIVATE LIMITED",
"THE GREATER BOMBAY CO-OPERATIVE BANK LIMITED",
"THE GREEN ENVIRONMENT SERVICES CO OP SOCIETY LIMITED",
"THE GREEN OPTION PRIVATE LIMITED",
"THE GUDIVADA COOPERATIVE URBAN BANK",
"THE GUJARAT CANCER AND RESEARCH INSTITUTE",
"THE GUJARAT FLYING CLUB.",
"THE GUJARAT STATE CIVIL SUPPLIES CORPORATION LIMITED",
"THE GUJARAT STATE CO OPERATIVE AGRICULTURE AND RURAL DEVELOPMENT BANK LTD",
"THE GUJARAT STATE CO-OP. BANK LTD",
"THE GUNTUR CO-OPERATIVE URBAN BANK LTD",
"THE GUNTUR DISTRICT COOPERATIVE CENTRAL BANK LTD",
"THE GUNTUR DISTRICT CO-OPERATIVE CENTRAL BANK LTD",
"THE GURDASPUR CENTRAL CO-OPERATIVE BANK LIMITED",
"THE GURDASPUR CO-OPERATIVE SUGAR MILLS LTD",
"THE GURUKUL",
"THE GURUKUL PRACTICE CENTRE PRIVATE LIMITED",
"THE GURUKUL SCHOOL",
"THE GURUKUL TRUST",
"THE GWALIOR FOREST PRODUCTS LIMITED.",
"THE H B KAPADIA NEW HIGH SCHOOL",
"THE H B KAPADIA PRATHMIK SHALA",
"THE HAMDARD EDUCATION SOCIETY",
"THE HANS FOUNDATION",
"THE HANS FOUNDATION HOSPITALS",
"THE HANUMAN ESTATES LTD",
"THE HARTFORD FINANCIAL SERVICES GROUP, INC.",
"THE HARYANA CO-OPERATIVE SUGAR MILLS LTD",
"THE HARYANA STATE CO OP APEX BANK LTD",
"THE HAVERI URBAN CO-OP BANK LTD",
"THE HDFC SCHOOL GURUGRAM",
"THE HDFC SCHOOL PUNE",
"THE HEAD AND NECK CENTRE & HOSPITAL",
"THE HEALING CIRCLE",
"THE HEALTH STORE PRIVATE LIMITED",
"THE HERITAGE SCHOOL",
"THE HI TECH GEARS LIMITED",
"THE HI TECH ROBOTIC SYSTEMZ LIMITED",
"THE HIGHLAND PRODUCE CO LTD",
"THE HIGHRANGE RURAL DEVELOPMENT SOCIETY",
"THE HIMACHAL PRADESH STATE CO-ORPORATIVE BANK LTD",
"THE HINDU EDUCATIONAL ORGANISATION",
"HINDU SENIOR SECONDARY SCHOOL",
"THE HINDUSTAN ENTERPRISES",
"THE HINDUSTAN TIMES LIMITED",
"THE HINDUSTHAN CO-OP BANK LIMITED",
"THE HI-TECH ENGINEERING SYSTEMS PRIVATE LIMITED",
"THE HOOGHLY CO OP CREDIT BANK LIMITED",
"THE HOOGHLY MILLS CO LTD",
"THE HOSHIARPUR CENTRAL COOPERATIVE BANK",
"THE HOSHIARPUR EXPRESS TRANSPORT COMPANY LIMITED",
"THE HOSTELLER HOSPITALITY PRIVATE LIMITED",
"THE HOTEL GOLCONDA",
"THE HOTELIERZ",
"THE HUMMING BIRDS SCHOOL",
"THE HUTTI GOLD MINES CO LTD",
"THE HYDERABAD DISTRICT CO-OPERATIVE CENTRAL BANK LTD",
"THE HYDERABAD PUBLIC SCHOOL",
"THE ICFAI FOUNDATION FOR HIGHER EDUCATION",
"THE ICFAI SOCIETY",
"THE ICFAI UNIVERSITY DEHRADUN",
"THE ICFAI UNIVERSITY HIMACHAL PRADESH",
"THE ICFAI UNIVERSITY RAIPUR",
"THE IDEAL MOUNT LITERA ZEE SCHOOL",
"THE IDEAL PRINTERS PRIVATE LIMITED",
"THE IMPERIAL HOTEL",
"THE INCLEN TRUST INTERNATIONAL",
"THE INCOME TAX DEPARTMENT CO OP BANK AAYAAKAR BHAVAN",
"THE INDIA CEMENTS LIMITED",
"THE INDIA CO OPERATIVE BANK LIMITED",
"THE INDIA COMPANY PRIVATE LIMITED",
"THE INDIA FITNESS CONNECT PRIVATE LIMITED",
"THE INDIA FRUITS PRIVATE LIMITED",
"THE INDIA JUTE AND INDUSTRIES LTD",
"THE INDIA THERMIT CORPORATION LIMITED",
"THE INDIAN AND EASTERN ENGINEER COMPANY PRIVATE LIMITED",
"THE INDIAN CARD CLOTHING COMPANY LIMITED",
"THE INDIAN COFFEE WORKERS CO OPERATIVE SOCIETY LIMITED",
"THE INDIAN EXPRESS P LIMITED",
"THE INDIAN FERRO ALLOY PRODUCERS ASSOCIATION",
"THE INDIAN FILM COMBINE PVT LTD",
"THE INDIAN GARAGE CO",
"THE INDIAN HOTELS COMPANY LIMITED",
"THE INDIAN HUME PIPE CO.LIMITED",
"THE INDIAN INSTITUTE OF BUSINESS MANAGEMENT & STUDIES",
"THE INDIAN NEWSPAPER SOCIETY.",
"THE INDIAN PERFORMING RIGHT SOCIETY LIMITED",
"THE INDIAN PUBLIC SCHOOL",
"THE INDIAN SCIENCE CONGRESS ASSOCIATION",
"THE INDIAN SILK EXPORT PROMOTION COUNCIL",
"THE INDIAN SOCIETY OF ADVERTISERS",
"THE INDIAN STEEL & WIRE PRODUCTS LIMITED",
"THE INDIAN TEXTILES CO. PRIVATE LIMITED",
"THE INDIAN WOOD PRODUCTS COMPANY LIMITED",
"THE INDIGENOUS ALLIANCE PRIVATE.LIMITED.",
"THE INDO GERMAN CHAMBER OF COMMERCE",
"THE INDO-ITALIAN CHAMBER OF COMMERCE AND INDUSTRY",
"THE INFANTRY SCHOOL",
"THE INFINITY SCHOOL",
"THE INFORMATION COMPANY PRIVATE LIMITED",
"THE INNOVATORS DIGITAL ADS PRIVATE LIMITED",
"THE INSTITUTE FOR SOCIAL ECONOMIC CHAN",
"THE INSTITUTE OF CHARTERED ACCOUNTANTS OF INDIA",
"THE INSTITUTE OF COMPANY SECRETARIES OF INDIA",
"THE INSTITUTE OF LEARNING AND EDUCATION",
"THE INSTITUTE OF MATHEMATICAL SCIENCES",
"THE INTEGRATED COASTAL AND MARINE AREA MANAGEMENT",
"THE INTERNATIONAL ASSOCIATION OF LIONS CLUBS",
"THE INTERNATIONAL SCHOOL AGRA",
"THE INTERNATIONAL VILLAGE SCHOOL",
"THE INTERPUBLIC GROUP OF COMPANIES, INC.",
"THE INVESTMENT TRUST OF INDIA LIMITED",
"THE IRISH HOUSE FOOD AND BEVERAGES PRIVATE LIMITED",
"THE ISHWAR MINING AND INDUSTRIAL CORPORATION PRIVATE LIMITED",
"THE J B VACHHA HIGH SCHOOL",
"THE J M DESAI HIGHSCHOOL",
"THE J.M. SMUCKER COMPANY",
"THE JAI MICA SUPPLY CO PVT LTD",
"THE JAIN INTERNATIONAL SCHOOL",
"THE JAIN SAHAKARI BANK LIMITED",
"THE JAIPUR UDYOG LIMITED",
"THE JALGAON PEOPLES CO-OP BANK LTD JALGAON",
"THE JAMNAGAR DISTRICT CO-OPERATIVE BANK LTD",
"THE JAMNAGAR PEOPLES CO-OPERATIVE BANK LTD",
"THE JANATA CO OPERATIVE BANK LIMITED",
"THE JANTA COOPERATIVE BANK LTD",
"THE JAY SHREE CHEMICALS & FERTILISERS",
"THE JEWELRY CO",
"THE JIMMY S BILIMORIA FOUNDATION",
"THE JOREHAUT AGRO LIMITED",
"THE JOREHAUT GROUP LIMITED",
"THE JOREHAUT TEA LIMITED",
"THE JUNGLE BROOK RESORT",
"THE JUTE CORPORATION OF INDIA LIMITED",
"THE K C P LIMITED",
"THE KACHCHH DISTRICT CENTRAL CO-OPERATIVE BANK LTD",
"THE KADRI MILLS CBE LIMITED",
"THE KAITHAL CO-OP SUGAR MILLS LTD",
"THE KAKATEEYA MUTUALLY AIDED THRIFT & CREDIT CO-OPERATIVE SOCIETY LIMITED",
"THE KAKINADA COOPERATIVE TOWN BANK LIMITED",
"THE KALUPRU COMMERCIAL CO-OP BANK LTD",
"THE KALUPUR COMMERCIAL CO-OPERATIVE BANK",
"THE KALYAN JANATA SAHAKARI BANK LTD",
"THE KALYANI SCHOOL",
"THE KAMLA COMPANY LTD.",
"THE KANCHEEPURAM CENTRAL CO-OPERATIVE BANK LTD",
"THE KANDI MOHOLLA ISMAILIA STUDENTS LIBRARY",
"THE KANGRA CO-OPERATIVE BANK LIMITED",
"THE KANTHIMATHI PLANTATIONS PVT LTD",
"THE KAPOL CO-OPRATIVE BANK LTD",
"THE KAPURTHALA CENTRAL CO OPERATIVE BANK LTD",
"THE KARANPUR GINNING AND PRESSING COMPANY PVT LTD",
"THE KARAVALI CO OPERATIVE SOCIETY LIMITED",
"THE KARAVALI CREDIT CO- OPERATIVE SOCIETY LIMITED",
"THE KARIMNAGAR DISTRICT COOPERATIVE CENTRAL BANK LTD",
"THE KARMAD SARVAJANIK HIGH SCHOOL",
"THE KARNATAKA BANK LIMITED",
"THE KARNATAKA HANDLOOM DEVELOPMENT CORPORATION LIMITED",
"THE KARNATAKA STATE CO-OP APEX BANK LTD",
"THE KARNAVATI CO OP BANK LTD",
"THE KASTURI SHIKSHAN SANSTHA'S COLLEGE OF PHARMACY",
"THE KAVERY EDUCATIONAL INSTITUTIONS",
"THE KERALA CARDAMOM PROCESSING AND MARKETING COMPANY LIMITED",
"THE KERALA PEOPLE‚ÄôS EDUCATION SOCIETY",
"THE KERALA STATE CO-OPERATIVE BANK LTD",
"THE KETS V G VAZE COLLEGE",
"THE KHAMGAON URBAN CO-OP BANK LTD",
"THE KHANDESH SPINNING AND WEAVING MILLS COMPANY LIMITED",
"THE KILPAUK BENEFIT SASWATHA NIDHI LIMITED",
"THE KINGS CLUB PRIVATE LIMITED",
"THE KISAN CO-OPERATIVE SUGAR FACTORY LTD",
"THE KISAN SAHKARI CHINI MILLS LTD",
"THE KITCHEN GARDEN",
"THE KOLHAPUR METALS LLP",
"THE KOLKATA MUSEUM OF MODERN ART",
"THE KRISHNA DISTRICT COOPERATIVE CENTRAL BANK LTD",
"THE KRISHNA DISTRICT MILK PRODUCERS MUTUALLY AIDED CO-OP UNION LIMITED",
"THE KRISHNAGIRI DISTRICT CO-OPERATIVE SPINNING MILLS LTD",
"THE KRISHNAVENI AGRO OIL PRODUCTS PRIVATE LIMITED",
"THE KTM JEWELLERY LIMITED",
"THE KUKARWADA NAGARIK SAHA BANK LTD",
"THE LAKE PALACE HOTELS AND MOTELS PRIVATE LIMITED",
"THE LAKE SHORE PALACE HOTEL PRIVATE LIMITED",
"THE LAKEWOOD SCHOOL",
"THE LAKHOTIA TEXTILES PVT LTD",
"THE LAKSHMI MILLS COMPANY LIMITED",
"THE LAKSHMIJI ORGANICS PRIVATE LIMITED",
"THE LAUNDRY BAG",
"THE LAURENCE SCHOOL",
"THE LAWRENCE SCHOOL",
"THE LEADING HOTELS OF THE WORLD LIMITED",
"THE LEELA BHARTIYA CITY BENGALURU",
"THE LEELA PALACES",
"THE LEPROSY MISSION TRUST INDIA",
"THE LEXICON INTERNATIONAL SCHOOL",
"THE LEXICON SCHOOL",
"THE LIFE PLUS HOSPITAL",
"THE LITTLE KINGDOM NURSERY SCHOOL",
"THE LNM INSTITUTE OF INFORMATION TECHNOLOGY",
"THE LOUIS BERGER GROUP INC.",
"THE LOVE HOMES LLP",
"THE LUDHIANA DISTRICT COOPERATIVE MILK PRODUCERS UNION LIMITED",
"THE MADHYA PRADESH FLYING CLUB LIMITED",
"THE MADRAS ADVERTISING COMPANY PRIVATE LIMITED",
"THE MADRAS MEDICAL MISSION",
"THE MADRAS SILKS INDIA PRIVATE LIMITED",
"THE MAHABIR JUTE MILLS LIMITED",
"THE MAHARAJA SAYAJIRAO UNIVERSITY OF BARODA",
"THE MAHARASHTRA EXECUTOR AND TRUSTEE COMPANY PRIVATE LIMITED",
"THE MAHARASHTRA STATE BHARAT SCOUTS & GUIDES",
"THE MAHARASHTRA STATE CO OPERATIVE MARKETING FEDERATION LIMITED",
"THE MAHARASHTRA STATE CO-OP BANK LTD",
"THE MAHARASHTRA STATE COOPERATIVE MARKETING FEDERATION LIMITED",
"THE MAHINDRA UNITED WORLD COLLEGE OF INDIA",
"THE MAJESTIC PACKAGING CO PVT LTD",
"THE MALABAR DYEING AND FINISHING MILLS LTD",
"THE MALAYALA MANORAMA CO PRIVATE LIMITED",
"THE MALESWARAM CO-OPERATIVE BANK",
"THE MALLESWARAM CO-OPERATIVE BANK LTD",
"THE MALNAD ARECA MARKETING CO-OPERATIVE SOCIETY LIMITED.",
"THE MALT COMPANY INDIA PRIVATE LIMITED",
"THE MALWA INDUSTRIAL & MARKETING FERTI CHEM CO OPERATIVE SOCIETY LIMITED",
"THE MANDHANA RETAIL VENTURES LIMITED",
"THE MANGALORE CATHOLIC CO OPERATIVE BANK LTD",
"THE MANGALORE TRADING ASSOCIATION PRIVATE LIMITED",
"THE MANJRI STUD FARM PRIVATE LIMITED",
"THE MANTHAN SCHOOL",
"THE MARSDEN BAKUBHAI AND SONS PRIVATE LIMITED",
"THE MASTER CLOCK AND WATCH WORKS PRIVATE LIMITED",
"THE MASTERMINDS HIGH SCHOOL",
"THE MATADOR FOAM PRIVATE LIMITED",
"THE MATHRUBHUMI PRINTING AND PUBLISHING CO. LIMITED",
"THE MAURYA SCHOOL",
"THE MEDIA STREET",
"THE MEHSANA DIST CENTRAL CO-OP BANK LTD",
"THE MEHSANA URBAN CO OPERATIVE BANK LTD",
"THE MERCARA RUBBERS LIMITED",
"THE METAL POWDER COMPANY LIMITED",
"THE METHONI TEA COMPANY LIMITED",
"THE METROPOLITAN HOTEL",
"THE MIDLAND RUBBER AND PRODUCE COMPANY LTD",
"THE MILE STONE SMART SCHOOL",
"THE MILLENNIUM SCHOOL",
"THE MISSION HOSPITAL",
"THE MOBILESTORE LIMITED",
"THE MODEL ENGLISH SCHOOL SAITAWADE",
"THE MODERN ACADEMY MATRIC HIGHER SECONDARY SCHOOL",
"THE MOGAVEERA CO OPERATIVE BANK LTD",
"THE MOGAVEERA CO-OPERATIVE BANK TD",
"THE MONARCH ENTERPRISES",
"THE MONTANA INTERNATIONAL PRE SCHOOL PRIVATE LIMITED",
"THE MOOVERS",
"THE MOSAIC COMPANY",
"THE MOTOR AND GENERAL FINANCE LIMITED",
"THE MOTWANE MANUFACTURING COMPANY PRIVATE LIMITED",
"THE MP STATE AGRO INDUSTRIES DEVELOPMENT CORPORATION LTD",
"THE MUNICIPAL CO-OPERATIVE BANK LTD",
"THE MUZAFFARPUR PROPERTIES PRIVATE LIMITED",
"THE MYLAPORE HINDU PERMANENT FUND NIDHI LIMITED",
"THE MYSORE ELECTRICAL INDUSTRIES LIMITED",
"THE MYSORE LAMP WORKS LIMITED",
"THE NADAR PRESS LIMITED",
"THE NADIAD PEOPLES CO-OP BANK LTD",
"THE NAGPUR ASHOK HOTEL",
"THE NAGPUR FRANSALIAN CORPORATION",
"THE NAGPUR ROMAN CATHOLIC DIOCESAN CORPORATION PVT LIMITED",
"THE NAIHATI JUTE MILLS CO LIMITED",
"THE NAINITAL BANK LIMITED",
"THE NANDURBAR MERCHANT‚ÄôS CO OP BANK LTD",
"THE NARAR PRIMARY AGRICULTURE COOPERATIVE SOCIETY LTD",
"THE NARODA NAGRIK CO.OP BANK LTD",
"THE NASHIK MATHADI& UNPROTECTED LABOUR BOARD NASHIK",
"THE NATIONAL AUTOMOTIVE TESTING AND R & D INFRASTRUCTURE PROJECT",
"THE NATIONAL COLLEGE",
"THE NATIONAL FEDERATION OF URBAN COOPERATIVE BANKS AND CREDIT SOCIETIES LTD",
"THE NATIONAL GRID COMPANY PLC",
"THE NATIONAL INDIA RUBBER WORKS LIMITED",
"THE NATIONAL INSTITUTE OF BUSINESS EDUCATION",
"THE NATIONAL INSTITUTE OF ENGINEERING",
"THE NATIONAL INSTITUTE OF OPTHOMOLOGY",
"THE NATIONAL SMALL INDUSTRIES CORPORATION LIMITED",
"THE NATIONAL SPORTS CLUB OF INDIA",
"THE NAVNIRMAN CO OP BANK LTD",
"THE NAZARETH ACADEMY",
"THE NAZRBATTU PRODUCTIONS PRIVATE LIMITED",
"THE NELLIAMPATHY TEA AND PRODUCE COMPANY LIMITED",
"THE NEOTIA UNIVERSITY",
"THE NEW AHMEDABAD SPORTS DEPOT",
"THE NEW BALL BEARING CO. LLP",
"THE NEW CLUB (POONA) LIMITED",
"THE NEW COLLEGE",
"THE NEW GLENCOE TEA COMPANY LIMITED",
"THE NEW GREAT EASTERN SPINNING AND WEAVING COMPANY LIMITED",
"THE NEW INDIA ASSURANCE CO. LIMITED",
"THE NEW INDIA CIVIL ERECTORS PVT LTD",
"THE NEW INDIA RICE MILLS PVT LTD",
"THE NEW MIDDLE HIGH SCHOOL",
"THE NEW MIDDLE HIGH SCHOOL RELIEF ROAD",
"THE NEWTOWN SCHOOL",
"THE NEXT MILESTONE TECHNOLOGIES PRIVATE LIMITED",
"THE NILGIRI DAIRY FARM PRIVATE LIMITED",
"THE NORTHCAP UNIVERSITY",
"THE NORTHSTAR SCHOOL",
"THE NORTHWOOD SCHOOL",
"THE NURSING & ALLIED SERVICES CO-OPERATIVE SOCIETY LTD",
"THE NURSING¬†AND¬†ALLIED SERVICES CO-OPERATIVE SOCIETY",
"THE O HOTEL",
"THE OFFSETTERS (INDIA) PRIVATE LIMITED",
"THE OJASWI BHAGWATI DAHIYA EDUCATIONAL SOCIETY",
"THE ONLINE PLUS",
"THE OPAL LABS PRIVATE LIMITED",
"THE ORANGE LANE LLP",
"THE ORBIS EDUCATION",
"THE ORIENTAL COMPANY LIMITED",
"THE ORIENTAL INSURANCE COMPANY LIMITED",
"THE ORISSA MINERALS DEVELOPMENT COMPANY LIMITED",
"THE ORISSA STATE COOPERATIVE MILK PRODUCERS' FEDERATION LIMITED",
"THE ORISSA UNIV OF AGRI AND TECHNO",
"THE OTHER CIRCLE PR AND MARKETING PRIVATE LIMIT",
"THE OUDH TRADING CO PRIVATE LIMITED",
"THE OXFORD DENTAL COLLEGE",
"THE OXFORD MEDICAL COLLEGE HOSPITAL RESEARCH CENTERE",
"THE OXFORD SCHOOL",
"THE OXYGEN EQUIPMENT & ENGINEERING COMPANY PRIVATE LIMITED",
"THE PACKSHOT INDIA PRIVATE LIMITED",
"THE PALACE BY PARK JEWELS HOTEL & RESORT JAIPUR",
"THE PALANI ANDAVAR MILLS LIMITED",
"THE PALANI ANDAVAR MILLS PRIVATE LIMITED",
"THE PALMS GOLF CLUB & RESORT PRIVATE LIMITED",
"THE PALSANA INDUSTRIAL CO OP SOCIETY LIMITED",
"THE PANIPAT CO-OPERATIVE SUGAR MILLS LIMITED",
"THE PANIPAT URBAN COOPERATIVE BANK LTD",
"THE PARTHENON GROUP INDIA LLC",
"THE PATIALA CENTRAL BANK CO-OP BANK LTD",
"THE PATIALA CENTRAL CO-OP BANK LTD",
"THE PATIDAR GIN SCIENCE COLLEGE",
"THE PAUL",
"THE PEERLESS GENERAL FINANCE & INVESTMENT CO LTD",
"THE PERIA KARAMALAI TEA AND PRODUCE COMPANY LIMITED",
"THE PHOENIX MILLS LIMITED",
"THE PHOENIX TRADEVISION PRIVATE LIMITED",
"THE PHONE SUPPORT PRIVATE LIMITED",
"THE PHOSPHATE COMPANY LIMITED",
"THE PILLARS PUBLIC SCHOOL",
"THE PINNACLE SCHOOL",
"THE PIONEER HIGH SCHOOL",
"THE PLANTERS CO-OPERATIVE BANK LIMITED",
"THE PLASTICS EXPORT PROMOTION COUNCIL",
"THE POLY PRINT COTTAGE INDUSTRIES PRIVATE LIMITED",
"THE POONA CLUB LIMITED",
"THE POONA PRESS OWNERS` ASSOCIATION LIMITED",
"THE POONA STUD FARM PRIVATE LIMITED",
"THE POPULAR CYCLE MANUFACTURING COMPANY PRIVATE LIMITED",
"THE PREPARATORY SCHOOL",
"THE PRESS TRUST OF INDIA LIMITED",
"THE PRESSURE PILING COMPANY (INDIA) PRIVATE LIMITED",
"THE PRICELINE GROUP INC.",
"THE PRIMARY AGRICULTURAL CO OPERATIVE SOCIETY LTD",
"THE PRINTERS MYSORE PRIVATE LIMITED",
"THE PRODIGIES INTERNATIONAL SCHOOL",
"THE PROFESSIONAL COURIERS (MUMBAI-WESTERN) PRIVATE LIMITED",
"THE PROFESSIONAL COURIERS CHENNAI LLP",
"THE PROFESSIONAL COURIERS COCHIN NORTH PRIVATE LIMITED",
"THE PROFESSIONAL COURIERS PRIVATE LIMITED",
"THE PROFESSIONAL HAIR SALON & SPA (INDIA) PRIVATE LIMITED",
"THE PROGRESS HIGH SCHOOL",
"THE PROLOGUE SCHOOL",
"THE PSBB MILLENNIUM SCHOOL",
"THE PUNE POST & TELECOM CO OPERATIVE CREDIT SOCIETY LTD",
"THE PUNJAB PRODUCE & TRADING CO. PVT. LTD.",
"THE PUNJAB PUBLIC SCHOOL",
"THE PUNJAB STATE BOARD OF TECHNICAL EDUCATION & INDUSTRIAL TRAINING CHANDIGARH",
"THE PUNJAB STATE CO-OP SUPPLY & MARKETING FEDERATION¬†LTD",
"THE PUNJAB STATE COOPERATIVE BANK",
"THE PUNJAB STATE COOPERATIVE MILK PRODUCERS FEDERATION LIMITED",
"THE PUPIL SAVEETHA ECO SCHOOL",
"THE PUTHUTOTAM ESTATES (1943) LIMITED",
"THE RAILWAY EMPLOYEES CO-OPERATIVE CREDIT SOCIETY LTD",
"THE RAILWAY GOODS CLEARING & FORWARDING EST LABOUR BOARD MUMBAI",
"THE RAINTREE HOTELS",
"THE RAIPUR DABBA AGRI CO OP SERVICE SOCIETY LIMITED",
"THE RAJAGIRI RUBBER & PRODUCE CO LIMITED.",
"THE RAJARATNA MILLS PRIVATE LIMITED",
"THE RAJASTHAN STATE CO-OPERATIVE BANK LIMITED",
"THE RAJASTHAN TUBE COMPANY PRIVATE LIMITED.",
"THE RAJKUMAR COLLEGE",
"THE RAJLAKSHMI COTTON MILLS PRIVATE LIMITED",
"THE RAJPUTANA MAHILA URBAN CO-OPERATIVE BANK LTD",
"THE RAMARAJU SURGICAL COTTON MILLS LIMITED",
"THE RAMCO CEMENTS LIMITED",
"THE RAMESHWARA JUTE MILLS LIMITED",
"THE RANIBARI TEA COMPANY LIMITED",
"THE RAVIZ KOVALAM UNIT OF KOVALAM RESORT PRIVATE LIMITED",
"THE RED BANGLE FILM COLLABORATIVE PRIVATE LIMITED",
"THE REDWOOD MONTESSORI SCHOOL LLP",
"THE REGISTRAR DEBTS RECOVERY II MUMBAI",
"THE RELIANCE INVESTMENT COMPANY PRIVATE LIMITED",
"THE REPUBLIC PRIVATE LIMITED",
"THE RESIDENCY TOWERS",
"THE RHINO INDIA PRIVATE LIMITED",
"THE RICE COMPANY INDIA PRIVATE LIMITED",
"THE RISE CREATIVE SOLUTIONS PRIVATE LIMITED",
"THE RISHABH WINPRO PRIVATE LIMITED",
"THE RISING MEDICARE PRIVATE LIMITED",
"THE RIVERSIDE SCHOOL",
"THE ROHTAK AND HISSAR DISTRICTS ELECTRIC SUPPLY COMPANY PRIVATE LIMITED",
"THE ROYAL BANK OF SCOTLAND N.V RBS",
"THE ROYAL TIMBERS",
"THE ROYAL WORLD INTERNATIONAL SCHOOL",
"THE RUBBER PRODUCTS LIMITED",
"THE RUBY MILL LIMITED.",
"THE SABARKANTHA DIST CENTRAL CO-OP BANK LTD",
"THE SAHEBRAO DESHMUKH CO OP BANK LIMITED",
"THE SAINT MARRY SCHOOL RAJKOT",
"THE SALEM URBAN CO OPERATIVE BANK LIMITED",
"THE SALESBRIDGE",
"THE SALVATION ARMY",
"THE SAMAJA",
"THE SAMHITA ACADEMY",
"THE SANDESH LIMITED",
"THE SANDUR MANGANESE AND IRON ORES LIMITED",
"THE SANGALA CO-OPERATIVE SOCETY LIMITED",
"THE SANGRUR DISTT COOP MILK PRODUCERS UNION LTD",
"THE SANSKAAR VALLEY SCHOOL",
"THE SARASWAT CO OPERATIVE BANK",
"THE SARASWAT CO-OPERATIVE BANK",
"THE SASWAD MALI SUGAR FACTORY LIMITED",
"THE SATARA DISTRICT CENTRAL CO-OPERATIVE BANK LTD SATARA",
"THE SATARA SAHAKARI BANK LTD",
"THE SAVAMALAI ESTATES PRIVATE LIMITED",
"THE SCHOLAR HIGH SCHOOL",
"THE SCHOOL OF SCIENCE",
"THE SCHOOL OF SHRI MARKANDEYA VIDYALAYA SOLAPUR",
"THE SCHRAM ACADEMY",
"THE SCHU MACHER INDIA PRIVATE LIMITED",
"THE SCIENCE AND INFORMATION (SAI) ORGANIZATION PRIVATE LIMITED",
"THE SCIENTIFIC FERTILISER COMPANY PRIVATE LIMITED",
"THE SCINDIA SCHOOL",
"THE SCOTTISH ASSAM INDIA LIMITED",
"THE SCOTTISH CHURCH COLLEGIATE SCHOOL",
"THE SEAL COAT STRUCTURAL WORKS PRIVATE LIMITED",
"THE SEKSARIA BISWAN SUGAR FACTORY LIMITED",
"THE SEVA VIKAS CO-OPERATIVE BANK LTD",
"THE SHAHABAD CO-OPERATIVE SUGAR MILLS LIMITED",
"THE SHALIMAR WORKS (1980) LTD",
"THE SHARDA HIGH SCHOOL ANANDPURA",
"THE SHIMOGA ARECANUT MANDY MERCHANTS CO OPERATIVE BANK LTD",
"THE SHIPPING CORPORATION OF INDIA LIMITED",
"THE SHIRPUR PEOPLES CO OP BANK LTD",
"THE SHISHUKUNJ INTERNATIONAL SCHOOL",
"THE SHOBHANA EDUCATION SOCIETY",
"THE SHRI RAM SCHOOL",
"THE SHRI RAM UNIVERSAL SCHOOL",
"THE SIA PRIMARY & KG SCHOOL DOMBIVLI (WEST)",
"THE SIAM COMMERCIAL BANK",
"THE SIKH REGIMENT RAMGARH CANTT",
"THE SINGARENI COLLIERIES COMPANY LIMITED",
"THE SMALL TOOLS MANUFACTURING COMPANY OF INDIA LTD",
"THE SOCIETY OF ST PETERS SCHOOL PANCHGANI",
"THE SOLAPUR CHEMICALS PVT LTD",
"THE SOLUTIONS INSTITUTE OF MENTAL HEALTH SCIENCES",
"THE SOLVENT EXTRACTORS ASSOCIATION OF INDIA",
"THE SONAPUR TEA CO. PVT. LTD.",
"THE SONAWALA COMPANY PVT LTD",
"THE SONIPAT COOP SUGAR MILLS LTD",
"THE SOULED STORE PRIVATE LIMITED",
"THE SOUND BRAND CONSULTING AND STRATEGIC RESEARCH PRIVATE LIMITED",
"THE SOUTH CANARA DISTRICT CENTRAL CO-OP. BANK LTD",
"THE SOUTH INDIA PAPER MILLS LIMITED",
"THE SOUTH INDIAN BANK LIMITED",
"THE SOUTHERN ASSOCIATES",
"THE SOUTHERN COMPANY",
"THE SOUTHERN GAS LIMITED",
"THE SOVEREIGN SCHOOL",
"THE SOYBEAN PROCESSORS ASSOCIATION OF INDIA",
"THE SPEED SPIRE",
"THE SPIRIT AUTOMOTIVE PRIVATE LIMITED",
"THE SPUNPIPE AND CONSTRUCTION COMPANY (BARODA) PRIVATE LIMITED",
"THE SRIJAN SCHOOL O P SURI MEMORIAL EDU",
"THE STANDARD BATTERIES LIMITED",
"THE STANDARD BRICK & TILE CO.(YELAHANKA) PRIVATE LIMITED",
"THE STANDARD CHEMICAL COMPANY PRIVATE LIMITED",
"THE STANDARD TYPE FOUNDRY PRIVATE LIMITED",
"THE STAR PRINTS PRIVATE LIMITED",
"THE STATE TRADING CORPORATION OF INDIA LIMITED",
"THE STRAW BOARD MFG CO LTD",
"THE SUGUNA MILLS PRIVATE LIMITED",
"THE SUMINTER ORGANIC AND FAIR TRADE COTTON GINNING MILL PRIVATE LIMITED",
"THE SUN SMART FOUNDATION INTERNATIONAL SCHOOL",
"THE SUNSHINE INTERNATIONAL SCHOOL",
"THE SUPREME INDUSTRIES LIMITED",
"THE SUPTD SCB MEDICAL COLLEGE HOSPI",
"THE SURAT DISTRICT CO-OPERATIVE BANK LTD",
"THE SURAT DISTRICT CRICKET ASSOCIATION",
"THE SURAT PEOPLES CO-OP BANK LIMITED",
"THE SURAT TECHNICAL EDUCATION AND RESERCH SOCIETY",
"THE SURYAA NEW DELHI",
"THE SUTEX CO OPERATIVE BANK LTD",
"THE SUVIKAS PEOPLES CO OP BANK LTD",
"THE SYNTHETIC & RAYON TEXTILES EXPORT PROMOTION COUNCIL",
"THE SYNTHETIC AND RAYON TEXTILE EXP",
"THE TAMIL NADU DR M G R MEDICAL UNIVERSITY",
"THE TAMILNADU CO OP MILK FEDERATION",
"THE TAMILNADU TEA PLANTATION CORPORATION LIMITED",
"THE TATA PIGMENTS LIMITED",
"THE TATA POWER COMPANY LIMITED",
"THE TAYABBI DWAKHANA UNANI (INDORE) PVT LTD",
"THE TELOIJAN TEA CO LTD",
"THE THANE DISTRICT CENTRAL CO OP BANK LIMITED",
"THE THAR DRY PORT A UNIT OF HASTI PETRO CAMICAL & SHIPPING LTD",
"THE THE MILLENIUM SCHOOL",
"THE THEME HOTEL",
"THE TIGER CAMP",
"THE TIPS GLOBAL INSTITUTE DEEPA",
"THE TOKAI BANK LIMITED",
"THE TORONTO-DOMINION BANK",
"THE TRAVANCORE MATS AND MATTING COMPANY",
"THE TRAVEL LOUNGE INDIA PRIVATE LIMITED",
"THE TRAVEL TECH",
"THE TRAVELERS COMPANIES INC.",
"THE TRIBHUVAN SCHOOL",
"THE TRIBUNE TRUST CHANDIGARH",
"THE TROPICAL PLANTATIONS LTD",
"THE TRUE SAI WORKS",
"THE TURNING POINT ENGG. PRIVATE LIMITED",
"THE TUTICORIN SPINNING MILLS LIMITED",
"THE UDAIPUR URBAN CO OPERATIVE BANK LTD",
"THE UDUPI CO OPERATIVE TOWN BANK LTD",
"THE UGALA PRIMARY AGRICULTURE CO OPRATIVE SOCIETY LTD UGALA",
"THE UGAR SUGAR WORKS LIMITED",
"THE ULTIMATE SOLUTION",
"THE UNIFIED CLOUD PRIVATE LIMITED",
"THE UNITED CHURCH OF NORTHERN INDIA TRUST ASSOCIATION",
"THE UNITED CO OP BANK LTD",
"THE UNITED INVESTMENT CO. PRIVATE LIMITED",
"THE UNITED NILGIRI TEA ESTATES COMPANY LIMITED",
"THE UNITED PROVINCES SUGAR COMPANY LIMITED",
"THE UNIVERSE WORLD SCHOOL",
"THE UNIVERSITY OF TRANS-DISCIPLAINARY HEALTH SEINCES AND TEC",
"THE UPPER INDIA COUPER PAPER MILLS COMPANY PRIVATE LIMITED",
"THE URBAN CO-OPERATIVE BANK LIMITED CUTTACK",
"THE VAALPHARAI RUBBERS PRIVATE LIMITED",
"THE VACUUM FORMING COMPANY PRIVATE LIMITED",
"THE VAISH CO-OPERATIVE NEW BANK LTD",
"THE VARACHHA CO-OP BANK LTD",
"THE VARACHHA CO-OPRATING BANK",
"THE VAVVERU CO OPERATIVE RURAL CREDIT SOCIETY LTD",
"THE VELAMMAL INTERNTIONAL SCHOOL",
"THE VENKTESH CO. PRIVATE LIMITED",
"THE VERAVAL INDUSTRIES ASSOCIATION",
"THE VICTORIA MEMORIAL SCHOOL FOR THE BLIND",
"THE VICTORIA MILLS LIMITED",
"THE VIDARBHA PREMIER CO OPERATIVE HOUSING SOCIETY LTD",
"THE VIJAYPUR DISTRICT CENTRAL CO-OPERATIVE BANK LTD",
"THE VIJOY STEEL AND GENERAL MILLS CO LTD",
"THE VIKASA SCHOOL",
"THE VIRAMGAM MERCANTILE CO- OPERATIVE BANK LTD",
"THE VISAKHAPATNAM CO OP BANK LTD",
"THE VISHWESHWAR SAHAKARI BANK LMITED",
"THE VISION HOUSE",
"THE VOLUNTARY HEALTH SERVICES MULTI SPECIALITY HOSPITAL & RESEARCH INSTITUTE",
"THE WALL STREET HOTELA UNIT OF GPHRPL",
"THE WALT DISNEY COMPANY INDIA PRIVATE LIMITED",
"THE WARANGAL CO-OP CENTRAL BANK LTD",
"THE WARANGAL DISTRICT CO-OPERATIVE CENTRAL BANK LTD",
"THE WARRIER MINING MINERALS & INFRA PRIVATE LIMITED",
"THE WATERBASE LIMITED",
"THE WAXPOL INDUSTRIES LTD",
"THE WEB PATRIOT",
"THE WEB PLANT PRIVATE LIMITED",
"THE WESMAN ENGINEERING COMPANY PRIVATE LIMITED",
"THE WEST BENGAL POWER DEVELOPMENT CORPORATION LIMITED",
"THE WEST BENGAL STATE CO-OPERATIVE MARKETING FEDERATION LIMITED",
"THE WEST INDIA POWER EQUIPMENTS PRIVATE LIMITED",
"THE WESTERN INDIA GENUINE GHEE COMPANY PRIVATE LIMITED",
"THE WESTERN INDIA PLYWOODS LIMITED",
"THE WESTERN UNION COMPANY",
"THE WESTIN CHENNAI VELACHERY",
"THE WESTIN KOLKATA RAJARHAT",
"THE WHITEBOARD COMPANY PRIVATE LIMITED",
"THE WHOLE DIGIDOODLE SOFTWARE PRIVATE LIMITED",
"THE WILD BARREL BREWING COMPANY",
"THE WILLINGDON SPORTS CLUB",
"THE WIPE HOTWIRE INDIA THERMAL EQUIPMENTS PRIVATE LIMITED",
"THE WISDOM GLOBAL SCHOOL",
"THE WISDOM SCHOOL OF ACADEMICS & SPORTS",
"THE WISDOM TREE SCHOOL",
"THE WOODENSTREET FURNITURES PRIVATE LIMITED",
"THE WOODPECKERS",
"THE WOODS HERITAGE SCHOOL JHANSI",
"THE WORLD BANK GROUP",
"THE WORLD RETAILS PRIVATE LIMITED",
"THE YELLOW COIN COMMUNICATION PRIVATE LIMITED",
"THE YENEPOYA SCHOOL",
"THE ZIGMA TECHNOLOGIES INDIA PRIVATE LIMITED",
"THEA KITCHEN PRIVATE LIMITED",
"THEA TECHNOLOGIES PRIVATE LIMITED",
"THEA TEX HEALTHCARE INDIA PRIVATE LIMITED",
"THE-ADITYAZ HOTELS LIMITED",
"THEAEC GLOBAL ASSOCIATES PRIVATE LIMITED",
"THEATRE SOLUTIONS (INDIA) PRIVATE LIMITED",
"THEBIGWORD INDIA PRIVATE LIMITED",
"THECO INDIA PRIVATE LIMITED",
"THE-CONNECTIONS ITES BUSINESS SERVICES PRIVATE LIM",
"THE-CONNECTIONS ITES BUSINESS SERVICES PRIVATE LIMITED",
"THEDECISIONLABS CONSULTING PRIVATE LIMITED",
"THEDIGIFAC SERVICES PRIVATE LIMITED",
"THEDIGIFAC SERVICES (OPC) PRIVATE LIMITED",
"THEETA ELECTRICALS PRIVATE LIMITED",
"THEFINANCIALMALL PRIVATE LIMITED",
"THEFOOTBALLLINK SPORT PRIVATE LIMITED",
"THEGOT HOSPITALITY PRIVATE LIMITED",
"THEGREENBILLIONS LIMITED",
"THEHOPE HOSPITAL AND HEALTHCARE PRIVATE LIMITED",
"THEINDOGRID INFRA PRIVATE LIMITED",
"THEIS PRECISION STEEL INDIA PRIVATE LIMITED",
"THEISM CEEMEC PRIVATE LIMITED",
"THEJAS AUTOSPA PRIVATE LIMITED",
"THEJI CONSTRUCTIONS PRIVATE LIMITED",
"THEJO ENGINEERING LIMITED",
"THEKHARIBARI TEA CO LTD",
"THEKKADY TRADING COMPANY PRIVATE LIMITED",
"THEKKEMALA INFRA DEVELOPERS PRIVATE LIMITED",
"THELAGAADI PRIVATE LIMITED",
"THEM CONSULTING PRIVATE LIMITED",
"THEMA CORPORATE SERVICES LLP",
"THEMA NUTRIMENT AND PACKAGING PRIVATE LIMITED",
"THEMARBLESTORE PRIVATE LIMITED",
"THEMATHCOMPANY PRIVATE LIMITED",
"THEMAVERICS TECHNOLOGIES PRIVATE LIMITED",
"THEME AMBIENCE RESORTS AND HOTELS PRIVATE LIMITED",
"THEME D' ARTZ INDIA PRIVATE LIMITED",
"THEME ENGINEERING SERVICES PRIVATE LIMITED",
"THEME HOTELS PRIVATE LIMITED",
"THEME INFOTECH PRIVATE LIMITED",
"THEME LOGISTICS AND MANAGEMENT PRIVATE LIMITED",
"THEME MUSIC COMPANY PRIVATE LIMITED",
"THEME MUSIC INSTITUTE PRIVATE LIMITED",
"THEME REALTY SERVICES PRIVATE LIMITED",
"THEME SPECIALITY RESTRO PRIVATE LIMITED",
"THEME WEAVERS INTERNATIONAL PRIVATE LIMITED",
"THEMESOFT INDIA PRIVATE LIMITED",
"THEMIS ADVISORS PRIVATE LIMITED",
"THEMIS AUTOMATION PRIVATE LIMITED",
"THEMIS DISTRIBUTORS PRIVATE LIMITED",
"THEMIS MEDICARE LIMITED",
"THENEW THEATRES CARNATIC TALKIES PRIVATE LIMITED",
"THENI ANANDA KRISHNA TEXTILE MILLS PRIVATE LIMITED",
"THENI ANANTHAM PATTU CENTRE PRIVATE LIMITED",
"THENI ANANTHM SILKS AND READYMADES PRIVATE LIMITED",
"THENI GURU KRISHNA TEXTILE MILLS PRIVATE LIMITED",
"THENI INDUSTRIES PRIVATE LIMITED",
"THENI KRISHNA MILLS PRIVATE LIMITED",
"THENPANDIAN TEXTILE INDIA PRIVATE. LIMITED.",
"THENPANDIYAN LPG IMPORT TERMINAL PRIVATE LIMITED",
"THEO PHARMA PRIVATE LIMITED",
"THEO SOLUTIONS PRIVATE LIMITED",
"THEOBROMA FOODS PRIVATE LIMITED",
"THEOCOM FOOD PRODUCTS PRIVATE LIMITED",
"THEODORA IMPEX INDIA PRIVATE LIMITED",
"THEOGEN PRIVATE LIMITED",
"THEON PHARMACEUTICALS LIMITED",
"THEOREM ALLOYS & BUILDWELL PRIVATE LIMITED",
"THEOREM INDIA PRIVATE LIMITED",
"THEORGANIC CARBON PRIVATE LIMITED",
"THEOS FOOD PRIVATE LIMITED",
"THEOS GLOBAL CULINARIA PRIVATE LIMITED",
"THEOS METALS TRADA PRIVATE LIMITED",
"THERA WELLNESS PRIVATE LIMITED",
"THERABIMB LIFESCIENCES PRIVATE LIMITED",
"THERACHEM RESEARCH MEDICAL INDIA PRIVATE LIMITED",
"THERACUES INNOVATIONS PRIVATE LIMITED",
"THERAGEN LIFESCIENCES PRIVATE LIMITED",
"THERAINDX LIFESCIENCES PRIVATE LIMITED",
"THERALLEN PHARMA PRIVATE LIMITED",
"THERAPEIA BIOTICS PRIVATE LIMITED",
"THERAPEUTICS CHEMICAL RESEARCH CORPORATION",
"THERAPIA SANJEEVANI LLP",
"THERAPIDHIRE PRIVATE LIMITED",
"THERAPIVA PRIVATE LIMITED",
"THERATRAQ INDIA PRIVATE LIMITED",
"THERDOSE PHARMA PRIVATE LIMITED",
"THERE4 VIRTUAL MEDIA PRIVATE LIMITED",
"THEREFORE DESIGN PRIVATE LIMITED",
"THERELEK FURNACES PRIVATE LIMITED",
"THERELEK MACHINES P LTD",
"THERLI INFRA PRIVATE LIMITED",
"THERM AQUA SOLUTION PRIVATE LIMITED",
"THERM TRANSFER EQUIPMENT PRIVATE LIMITED",
"THERMADYNE PRIVATE LIMITED",
"THERMAL ASSOCIATE PRIVATE LIMITED",
"THERMAL ENERGY SERVICE SOLUTIONS PRIVATE LIMITED",
"THERMAL ENGINEERS AND INSULATORS PRIVATE LIMITED",
"THERMAL ENGITECH PRIVATE LIMITED",
"THERMAL FABRICATORS PRIVATE LIMITED",
"THERMAL INSTRUMENT INDIA PRIVATE LIMITED",
"THERMAL PAPERS PRIVATE LTD",
"THERMAL POWERTECH CORPORATION INDIA LIMITED",
"THERMAL POWERTECH CORPORATION INDIA LIMITED TPCIL",
"THERMAL SYSTEMS HYDERABADPRIVATE LIMITED",
"THERMALON METALROOF PRIVATE LIMITED",
"THERMATEK GREEN PRODUCTS PRIVATE LIMITED",
"THERMAX BABCOCK & WILCOX ENERGY SOLUTIONS LIMITED",
"THERMAX BABCOCK & WILCOX ENERGY SOLUTIONS PRIVATE LIMITED",
"THERMAX ENGINEERING CONSTRUCTION COMPANY LIMITED",
"THERMAX FOUNDATION",
"THERMAX INSTRUMENTATION LIMITED",
"THERMAX LIMITED",
"THERMAX ONSITE ENERGY SOLUTIONS LIMITED",
"THERMAX SPX ENERGY TECHNOLOGIES LIMITED",
"THERMIC FLUIDS PRIVATE LIMITED",
"THERMICA INDIA PRIVATE LIMITED",
"THERMO CABLES LIMITED",
"THERMO CARE ROCKWOOL INDIA PRIVATE LIMITED",
"THERMO CONTROL FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"THERMO FISHER SCIENTIFIC INC.",
"THERMO FISHER SCIENTIFIC INDIA PRIVATE LIMITED",
"THERMO HOUSEWARES PRIVATE LIMITED",
"THERMO INSUPACK PRIVATE LIMITED",
"THERMO PACKING INDUSTRIES PVT LTD",
"THERMO POLYMERS PRIVATE LIMITED",
"THERMO TECH FURNACE AND ENGINEERS PRIVATE LIMITED",
"THERMO TOUCH INDIA PRIVATE LIMITED",
"THERMOCARE BOILERS PRIVATE LIMITED",
"THERMOCARE INDUSTRIES LIMITED",
"THERMOCHEM CORPORATION PRIVATE LIMITED",
"THERMOCHEM FURNACES PRIVATE LIMITED",
"THERMOCHEM PROCESSES PRIVATE LIMITED",
"THERMOCOOL ENGINEERING PRIVATE LIMITED",
"THERMOCOOL HOME APPLIANCES LIMITED",
"THERMODORS PRIVATE LIMITED",
"THERMODYNAMIC ENGINEERS PRIVATE LIMITED",
"THERMODYNE BAKERY & INDUSTRIAL EQUIPMENTS PRIVATE LIMITED",
"THERMODYNE ENGINEERING SYSTEMS",
"THERMODYNE TECHNOLOGIES PRIVATE LIMITED",
"THERMOFLUX SYSTEMS PRIVATE LIMITED",
"THERMOFLYDE INDUSTRIES PRIVATE LIMITED",
"THERMOGREEN COOL COAT PRIVATE LIMITED",
"THERMOLAB HEALTHCARE PRIVATE LIMITED",
"THERMOLAB SALES AND SERVICES PRIVATE LIMITED",
"THERMOLAB SCIENTIFIC EQUIPMENTS PRIVATE LIMITED",
"THERMOLAB TESTING SERVICES PRIVATE LIMITED",
"THERMOLITE JOINTINGS PRIVATE LIMITED",
"THERMOLITE MOULDINGS PRIVATE LIMITED",
"THERMOMAX INDUSTRIES PRIVATE LIMITED",
"THERMON INDIA PRIVATE LIMITED",
"THERMONIX TECHNOLOGIES PRIVATE LIMITED",
"THERMOPAC PROCESS ENGINEERING LLP",
"THERMOPADS PRIVATE LIMITED",
"THERMOPAK ENGINEERS & MANUFACTURERS PRIVATE LIMITED",
"THERMOPHARM PRIVATE LIMITED",
"THERMOPLASTICS INDIA LIMITED",
"THERMOPLAY INDIA PRIVATE LIMITED",
"THERMOSEN TECHNOLOGIES PRIVATE LIMITED",
"THERMOSEP ENGINEERING PRIVATE LIMITED",
"THERMOSET POLYPRODUCTS INDIA PRIVATE LIMITED",
"THERMOSOL GLASS INDIA PRIVATE LIMITED",
"THERMOSONICS PRIVATE LIMITED",
"THERMOSUN ENGINEERING AND POWER INDIA PRIVATE LIMITED",
"THERMOSYSTEMS PRIVATE LIMITED",
"THERMOTECH INDUSTRIES (INDIA) PRIVATE LIMITED",
"THERMOTECH SYSTEMS LIMITED",
"THERMOTEK COMPOSITE INDUSTRIES PRIVATE LIMITED",
"THERMOVAC AEROSPACE PRIVATE LIMITED",
"THERMOVAC PACKAGING INDIA PRIVATE LIMITED",
"THERMOVISION TECHNOLOGIES INDIA PRIVATE LIMITED",
"THERM-PROCESS ENGINEERING PRIVATE LIMITED",
"THERM-X INDUSTRIAL EQUIPMENTS PRIVATE LIMITED",
"THERPUP INDIA PRIVATE LIMITED",
"THERYCO HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"THESAN ENERGY PRIVATE LIMITED",
"THESEUS TECHNOLOGIES PRIVATE LIMITED",
"THESEUS VENTURES LIMITED",
"THETA CONTROLS PRIVATE LIMITED",
"THETA LABS PRIVATE LIMITED",
"THETA MANAGEMENT CONSULTANCY PRIVATE LIMITED",
"THETA MEASUREMENT AND CONTROL SOLUTIONS PRIVATE LIMITED",
"THETABETA ANALGORITHMS PRIVATE LIMITED",
"THETHI AUTO TRANSMISSION PVT LTD",
"THETHICK SHAKE FACTORY PRIVATE LIMITED",
"THEVAR HOLDINGS PRIVATE LIMITED",
"THEY VISUALIZE VALUE PRIVATE LIMITED",
"THEYAGARAYANAGAR NIDHI LIMITED",
"THEYSOHN EXTRUSIONSTECHNIK INDIA PRIVATE LIMITED",
"THF CREATORS HUB PRIVATE LIMITED",
"THF OVERSEAS PRIVATE LIMITED",
"THG PUBLISHING PRIVATE LIMITED",
"THIAGARAJAN AGRO PRODUCTS PRIVATE LIMITED",
"THIAGARAJAR MILLS LIMITED",
"THIAGARAJAR POLYTECHNIC COLLEGE",
"THIAGARAJAR SCHOOL OF MANAGEMENT",
"THIEH INGOTS PRIVATE LIMITED",
"THIEME MEDICAL AND SCIENTIFIC PUBLISHERS PRIVATE LIMITED",
"THIES TEXTILE MACHINES INDIA PRIVATE LIMITED",
"THIESS INDIA PRIVATE LIMITED",
"THILAGA CONSTRUCTION PRIVATE LIMITED",
"THILAGARAJ AGENCY",
"THILLAI NATARAJA ROAD CONSTRUCTION PRIVATE LIMITED",
"THILLAIS ANALYTICAL SOLUTIONS PRIVATE LIMITED",
"T-HILLS PRIVATE LIMITED",
"THIN COMPUTING SOLUTIONS PRIVATE LIMITED",
"THINCREDBLU SECURITIES PRIVATE LIMITED",
"THIND EYE HOSPITAL PRIVATE LIMITED",
"THINGAL PRODUCTS PRIVATE LIMITED",
"THINGBITS ELECTRONICS PRIVATE LIMITED",
"THINGS ALIVE SOLUTIONS PRIVATE LIMITED",
"THINGSMEET SOLUTIONS PRIVATE LIMITED",
"THINGSXTHINGS TECH PRIVATE LIMITED",
"THINGULARITY CONSULTING PRIVATE LIMITED",
"THINK 360 SOLUTIONS PRIVATE LIMITED",
"THINK AHEAD INNOVATIONS PRIVATE LIMITED",
"THINK ANALYTICS INDIA PRIVATE LIMITED",
"THINK BIG ENTERPRISES PRIVATE LIMITED",
"THINK CHITS PRIVATE LIMITED",
"THINK DATA TECHNOLOGY PRIVATE LIMITED",
"THINK DESIGN COLLABORATIVE PRIVATE LIMITED",
"THINK EBIKEGO PRIVATE LIMITED",
"THINK EMBEDDED PRIVATE LIMITED",
"THINK FASHION PRIVATE LIMITED",
"THINK FUTURE TECHNOLOGIES PRIVATE LIMITED",
"THINK GAS BEGUSARAI PRIVATE LIMITED",
"THINK GAS DISTRIBUTION PRIVATE LIMITED",
"THINK GAS LUDHIANA PRIVATE LIMITED",
"THINK HEALTHY",
"THINK HYGIENE SOLUTIONS PRIVATE LIMITED",
"THINK INDIA HOSPITALITY SERVICES PRIVATE LIMITED",
"THINK INNOV SOLUTIONS TECHNOLOGIES PRIVATE LIMITED",
"THINK LEAN PREFAB SYSTEMS PRIVATE LIMITED",
"THINK LNG INVESTMENTS PRIVATE LIMITED",
"THINK N 3D STUDIO PRIVATE LIMITED",
"THINK N SOLUTIONS SOFTWARE PRIVATE LIMITED",
"THINK NORTH MANAGEMENT CONSULTANTS (OPC) PRIVATE LIMITED",
"THINK OF US INDIA PRIVATE LIMITED",
"THINK PATTERN PRIVATE LIMITED",
"THINK PEOPLE SOLUTIONS PRIVATE LIMITED",
"THINK RECYCLING PRIVATE LIMITED",
"THINK RICH INDIA SERVICES PRIVATE LIMITED",
"THINK TALENT SERVICES PRIVATE LIMITED",
"THINK TANK DIGITAL MEDIA PRIVATE LIMITED",
"THINK TANKER",
"THINK THRIVE TALENT TRACK PRIVATE LIMITED",
"THINK WALNUT DIGITAL PRIVATE LIMITED",
"THINK WHYNOT INTEGRATED COMMUNICATIONS PRIVATE LIMITED",
"THINK9 CONSUMER TECHNOLOGIES PRIVATE LIMITED",
"THINKANALYTICS DEVELOPMENT INDIA PRIVATE LIMITED",
"THINKAPACE CONSULTING INDIA PRIVATE LIMITED",
"THINKAPPS SOLUTIONS PRIVATE LIMITED",
"THINKBIZ SOLUTIONS",
"THINKBIZ TECHNOLOGY PRIVATE LIMITED",
"THINKBOTIC TECHNOLOGY PRIVATE LIMITED",
"THINKBRIDGE SOFTWARE PRIVATE LIMITED",
"THINKBUMBLEBEE ANALYTICS PRIVATE LIMITED",
"THINKCELL LEARNING SOLUTIONS PRIVATE LIMITED",
"THINKCIRCUIT RAILTECH PRIVATE LIMITED",
"THINKCORE TECHNOLOGIES PRIVATE LIMITED",
"THINKERBELL LABS PRIVATE LIMITED",
"THINKFOUNDERS ADVISORS PRIVATE LIMITED",
"THINKGREEN ENVIROTECH PRIVATE LIMITED",
"THINKHALL TRAINING AND CONSULTANCY LLP",
"THINKHIGH SOLUTIONS PRIVATE LIMITED",
"THINKIFY LABS PRIVATE LIMITED",
"THINKING ADVERTISING PRIVATE LIMITED",
"THINKING CODE TECHNOLOGIES PRIVATE LIMITED",
"THINKING FORKS CONSULTING PRIVATE LIMITED",
"THINKING HATS ENTERTAINMENT SOLUTIONS LIMITED",
"THINKING HUT IT SOLUTIONS PRIVATE LIMITED",
"THINKING MINDS COM INDIA PRIVATE LIMITED",
"THINKINK PICTUREZ LIMITED",
"THINKINNO TECHNOLOGIES PRIVATE LIMITED",
"THINKINNOV SOLUTION TECHNOLOGIES PRIVATE LIMITED",
"THINKITIVE GLOBAL CONSULTING PRIVATE LIMITED",
"THINKITIVE TECHNOLOGIES PRIVATE LIMITED",
"THINKJS PRIVATE LIMITED",
"THINKLABS TECHNOSOLUTIONS PRIVATE LIMITED",
"THINKLINK SUPPLY CHAIN SERVICES PRIVATE LIMITED",
"THINKONIC SOFTWARE PRIVATE LIMITED",
"THINKPALM TECHNOLOGIES PRIVATE LIMITED",
"THINKPARMS INFOTECH PRIVATE LIMITED",
"THINKPLUS SOLUTIONS PRIVATE LIMITED",
"THINKPOT ADVERTISING PRIVATE LIMITED",
"THINKPRISE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"THINKQUOTIENT SOFTWARE PRIVATE LIMITED",
"THINKSERV TECHNOLOGIES PRIVATE LIMITED",
"THINKSMART IT SOLUTIONS PRIVATE LIMITED",
"THINKSOL SOFTWARE PRIVATE LIMITED",
"THINKSYNQ SOLUTIONS PRIVATE LIMITED",
"THINKSYS SOFTWARE PRIVATE LIMITED",
"THINKTHROUGH CONSULTING PRIVATE LIMITED",
"THINKVATE TECHNOLOGIES PRIVATE LIMITED",
"THINKVIDYA LEARNING PRIVATE LIMITED",
"THINKWAY INDUSTRIES PRIVATE LIMITED",
"THINKWRIGHT LEARNING SERVICES PRIVATE LIMITED",
"THINPC TECHNOLOGY PRIVATE LIMITED",
"THINQ GREEN COMPUTECH PRIVATE LIMITED",
"THINQ PHARMA-CRO LIMITED",
"THINQLOUD SOLUTIONS PRIVATE LIMITED",
"THINVENT TECHNOLOGIES PRIVATE LIMITED",
"THIO CHEMI PRIVATE LIMITED",
"THIPPARTHI CONSTRUCTIONS AND HOUSING PRIVATE LIMITED",
"THIRAN CONSTRUCTIONS PRIVATE LIMITED",
"THIRAN TECHNOLOGIES PRIVATE LIMITED",
"THIRANI SECURITIES PRIVATE LIMITED",
"THIRAVIAM ENGINEERING PRIVATE LIMITED",
"THIRD BRIDGE INDIA PRIVATE LIMITED",
"THIRD CULTURE ENTERTAINMENT PRIVATE LIMITED",
"THIRD EYE AUTOMATION PRIVATE LIMITED",
"THIRD EYE BRANDS & CONCEPTS PRIVATE LIMITED",
"THIRD EYE EDUCATION PRIVATE LIMITED",
"THIRD EYE ELITE SECURITY PROVIDERS PRIVATE LIMITED",
"THIRD EYE GUARDING SERVICES PRIVATE LIMITED",
"THIRD EYE INTEGRATED SERVICES PRIVATE LIMITED",
"THIRD EYE QUALITATIVE RESEARCHERS PRIVATE LIMITED",
"THIRD EYE SECURITY GUARDING PRIVATE LIMITED",
"THIRD EYE SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"THIRD GENERATION TRADERS PRIVATE LIMITED",
"THIRD I TECHNOSOFT PRIVATE LIMITED",
"THIRD VENDOR STUDIOS PRIVATE LIMITED",
"THIRD WAVE BPM SERVICES PRIVATE LIMITED",
"THIRD WAVE POWER INDIA PRIVATE LIMITED",
"THIRD WAVE RUGGEDTECH PRIVATE LIMITED",
"THIRD WAVE SERVICES PRIVATE LIMITED",
"THIRDEYE AI PRIVATE LIMITED",
"THIRDEYE INFRASERVICES PRIVATE LIMITED",
"THIRDEYE SECURITY SERVICES PVT.LTD.",
"THIRDEYE TRADELINK PRIVATE LIMITED",
"THIRDWARE SOLUTION LIMITED",
"THIRDWAVE CONSTRUCTIONS PRIVATE LIMITED",
"THIRDWAVE DISTRIBUTORS PRIVATE LIMITED",
"THIRTEEN ODDS DESIGN DOCKYARD PRIVATE LIMITED",
"THIRTY SIX AUTOMOBILES PRIVATE LIMITED",
"THIRTY SIX CAPITAL PRIVATE LIMITED",
"THIRTY TWO HEALTH CARE PRIVATE LIMITED",
"THIRU PICTURES PRIVATE LIMITED",
"THIRU RANI LOGISTIC PRIVATE LIMITED",
"THIRU SEVEN HILLS POLYTECHNIC COLLEGE",
"THIRUBALA CHEMICALS PRIVATE LIMITED",
"THIRUCHY STEELS",
"THIRUKUMARAN BUILDERS PRIVATE LIMITED",
"THIRUMALA CABS",
"THIRUMALA CHILD HEALTH SERVICES PRIVATE LIMITED",
"THIRUMALA PRECICASTS PRIVATE LIMITED",
"THIRUMALA PRESS COMPONENTS PRIVATE LIMITED",
"THIRUMALA SYSTEMS & SERVICE PRIVATE LIMITED",
"THIRUMALA TIRUPATHI AGRO COLD STORAGE PRIVATE LIMITED",
"THIRUMALAGIRI INFRA PROJECTS PRIVATE LIMITED",
"THIRUMALAI CHEMICALS LIMITED",
"THIRUMALAI MEDITEX PRIVATE LIMITED",
"THIRUMALSREE SPINNERS PRIVATE LIMITED",
"THIRUMANI FINANCE PRIVATE LIMITED",
"THIRUMATHI MUTHAMMAL TEXTILES PRIVATE LIMITED",
"THIRUMENI FINANCE PRIVATE LIMITED",
"THIRUPATHI INNOVATIVE CASTING PRIVATE LIMITED",
"THIRUPATHI STEELS PRIVATE LIMITED",
"THIRUTHANGAL NADAR COLLEGE",
"THIRUVALLUVAR MATRIC HR SEC SCHOOL",
"THIRUVALLUVAR POLYTECHNIC COLLEGE",
"THIRUVEDI AGENCY",
"THISIT SOLUTIONS PRIVATE LIMITED",
"THISTLE HEALTHCARE INDIA PRIVATE LIMITED",
"THITE VALUERS AND ENGINEERS PRIVATE LIMITED",
"THIYAGARAJA HOUSING & CONSTRUCTIONS PRIVATE LIMITED",
"THK INDIA PRIVATE LIMITED",
"THM HUADE HYDRAULICS PRIVATE LIMITED",
"THODUPUZHA DRUG HOUSE PRIVATE LIMITED",
"THODUPUZHA MEDIGEN PRIVATE LIMITED",
"THOGARIHUNKAL ESTATES PRIVATE LIMITED",
"THOLASI PRINTS INDIA PRIVATE LIMITED",
"THOLE PLASTICS PVT LTD",
"THOLONS KNOWLEDGE MANAGEMENT PRIVATE LIMITED",
"THOM INDIA PRIVATE LIMITED",
"THOMAS & BRIAN MFG. PRIVATE LIMITED",
"THOMAS & COMPANY PRIVATE LIMITED T&CPL",
"THOMAS ASSESSMENTS PRIVATE LIMITED",
"THOMAS BAKER CHEMICALS PRIVATE LIMITED",
"THOMAS CONSTRUCTIONS PRIVATE LIMITED",
"THOMAS COOK INDIA LIMITED",
"THOMAS GLOBAL LOGISTICS PRIVATE LIMITED",
"THOMAS HOTELS & RESORTS INDIA PRIVATE LIMITED",
"THOMAS INTERNATIONAL PUBLISHING COMPANY INDIA PRIVATE LIMITED",
"THOMAS IYADURAI INFRASTRUCTURE PRIVATE LIMITED",
"THOMAS SCOTT INDIA LIMITED",
"THOMAS TRANSPORT PRIVATE LIMITED",
"THOMAS TRAVEL SOLUTIONS PRIVATE LIMITED",
"THOMAS WHITE INDIA PRIVATE LIMITED",
"THOMAS WORDSWORTH HR SYSTEMS PRIVATE LIMITED",
"THOMBATHU INFRA PROJECTS PRIVATE LIMITED",
"OSM THOME INDIA PRIVATE LIMITED",
"THOME SHIP MANAGEMENT PTE LIMITED",
"THOMSON AND TAYLOR PRIVATE LIMITED",
"THOMSON CREATIONS PRIVATE LIMITED",
"THOMSON DIGITAL INDIA LIMITED",
"THOMSON GENTECH CONTROLS PRIVATE LIMITED",
"THOMSON PRESS INDIA LIMITED",
"THOMSON REUTERS INDIA PRIVATE LIMITED",
"THOMSON REUTERS INTERNATIONAL SERVICES PRIVATE LIMITED",
"THOMSON REUTERS SOUTH ASIA PRIVATE LIMITED",
"THOMSON RUBBERS INDIA PRIVATE LIMITED",
"THOMSON SURGICALS PRIVATE LIMITED",
"THOMSUN INFOCARE LLP",
"THOOTHUKUDI GOVT MEDICAL COLG HOSP",
"THOPPIL CONTRACTORS (INDIA) PRIVATE LIMITED",
"THOPPU VINAYAKA SALT REFINERY PRIVATE LIMITED",
"THORAN TECHNOLOGIES AND SERVICES PRIVATE LIMITED",
"THORAT FILTRATION PRIVATE LIMITED",
"THORAT MUNGSE DAIRY PRIVATE LIMITED",
"THORAT VALVES PRIVATE LIMITED",
"THORN LIGHTING INDIA PRIVATE LIMITED",
"THORNTON TOMASETTI INC",
"THORNYCROFT ENGINES (INDIA) PRIVATE LIMITED",
"THOROGOOD ASSOCIATES INDIA PRIVATE LIMITED",
"THORON TURNKEY SOLUTIONS PRIVATE LIMITED",
"THOROUGHCLEAN ULTRASONIC INDIA PRIVATE LIMITED",
"THOSE GUYS PRODUCTIONS PRIVATE LIMITED",
"THOST PROJECT MANAGEMENT INDIA PRIVATE LIMITED",
"THOT MEDIA PRIVATE LIMITED",
"THOTAKA TEKHNOLOGIES INDIA PRIVATE LIMITED",
"THOTE MILK PRIVATE LIMITED",
"THOTHFUL TECHNOLOGIES INDIA PRIVATE LIMITED",
"THOTNR CONSULTING PRIVATE LIMITED",
"THOTTAN GOLD & DIAMONDS PRIVATE LIMITED",
"THOTWEILER ADVERTISING PRIVATE LIMITED",
"THOU GLOBAL MERCANTILE SERVICES PRIVATE LIMITED",
"THOUCENTRIC LABS PRIVATE LIMITED",
"THOUCENTRIC TECHNOLOGY PRIVATE LIMITED",
"THOUGHT BUBBLE CONSULTING INDIA PRIVATE LIMITED",
"THOUGHTBEES TECHNOLOGIES PRIVATE LIMITED",
"THOUGHTCLAN TECHNOLOGIES PRIVATE LIMITED",
"THOUGHTCOM INDIA PRIVATE LIMITED",
"THOUGHTFOCUS INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"THOUGHTGENESIS TECHNOLOGIES PRIVATE LIMITED",
"THOUGHTLINE TECHNOLOGIES PRIVATE LIMITED",
"THOUGHTPLEX PRIVATE LIMITED",
"THOUGHTPULP TECHNOLOGIES PRIVATE LIMITED",
"THOUGHTRAINS DESIGNS PRIVATE LIMITED",
"THOUGHTSCREST SOFTWARE PRIVATE LIMITED (OPC)",
"THOUGHTSHOP ADVERTISING AND FILM PRODUCTIONS PRIVATE LIMITED",
"THOUGHTSIP PRIVATE LIMITED",
"THOUGHTSOL INFOTECH PRIVATE LIMITED",
"THOUGHTSPARK SOFTWARE CONSULTING PRIVATE LIMITED",
"THOUGHTSPOT INDIA PRIVATE LIMITED",
"THOUGHTSTORM TECHNOLOGIES INDIA PRIVATE LIMITED",
"THOUGHTWAVE INFO SYSTEMS INDIA PRIVATE LIMITED",
"THOUGHTWORKS TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"THOUSAND LIGHTS INVESTMENTS PVT LTD",
"THPL SUPPORT SERVICES LIMITED",
"THREAD GAUGE PRODUCTS PRIVATE LIMITED",
"THREADBUCKET STUDIO LLP",
"THREADMILL CLOTHING PRIVATE LIMITED",
"THREADS INDIA LIMITED",
"THREADS INDIA PRIVATE LIMITED",
"THREDZ INFORMATION TECHNOLOGY PRIVATE LIMITED",
"THREE ACES GLOBAL LOGISTICS PRIVATE LIMITED",
"THREE ACES STRUCTURALS AND CONSTRUCTION PRIVATE LIMITED",
"THREE ANGELS EXPORT PRIVATE LIMITED",
"THREE AUTUMN LEAVES & A STORY LLP",
"THREE B HEALTHCARE LIMITED",
"THREE BOND INDIA PRIVATE LIMITED",
"THREE BROTHERS AUTOMATIONS PRIVATE LIMITED",
"THREE BROTHERS ENTERPRISES PRIVATE LIMITED",
"THREE C GREENS DEVELOPERS PRIVATE LIMITED",
"THREE C PROPERTIES PRIVATE LIMITED",
"THREE CEE CAPS AND CARTONS PRIVATE LIMITED",
"THREE CEE CAPS PRIVATE LIMITED",
"THREE CUBE MANAGED SERVICES & SOLUTIONS PRIVATE LIMITED",
"THREE D ENTERTAINMENT PRIVATE LIMITED",
"THREE D HOLOGRAMS PRIVATE LIMITED",
"THREE D INTEGRATED SOLUTIONS LIMITED",
"THREE D MAGIC INFO SOLUTIONS PRIVATE LIMITED",
"THREE D MICRO SYSTEMS PRIVATE LIMITED",
"THREE D MODERN CARE PRIVATE LIMITED",
"THREE E INFORMATION TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"THREE EG PROJECT MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"THREE ESS COMPUTER SERVICES INDIA PRIVATE LIMITED",
"THREE G FLUOROPOLYMERS PRIVATE LIMITED",
"THREE GEE ENGINEERS PRIVATE LIMITED",
"THREE GEE SOLUTIONS PRIVATE LIMITED",
"THREE HANDS INFRASTRUCTURE (INDIA) PRIVATE LIMITED",
"THREE LEAVES INDIA PVT LTD",
"THREE LEGGED VOYAGER PRIVATE LIMITED",
"THREE M PAPER BOARDS LIMITED",
"THREE M SOFTWARE PRIVATE LIMITED",
"THREE MANGOES MEGA MARTS PRIVATE LIMITED",
"THREE MEADOWS SOFTWARE PRIVATE LIMITED",
"THREE P CONSULTAINTS PRIVATE LIMITED",
"THREE PEARL EXPORTS PRIVATE LIMITED",
"THREE PISCES TRAVELS AND TOURS PRIVATE LIMITED",
"THREE R INFOCOM PRIVATE LIMITED",
"THREE R JOINTS & SEALS PRIVATE LIMITED",
"THREE S ENGINEERING SERVICES PRIVATE LIMITED",
"THREE S. INSTRUMENTS PRIVATE LIMITED",
"THREE SEASONS EXIM LIMITED",
"THREE SEVEN THREE EXPORTS PRIVATE LIMITED",
"THREE SIXTY DEGREE SOLUTIONS PRIVATE LIMITED",
"THREE SIXTY ENERGY PRIVATE LIMITED",
"THREE SIXTY EXPORTS PRIVATE LIMITED",
"THREE SIXTY LOGISTICS PRIVATE LIMITED",
"THREE SIXTY ONE COMMUNICATIONS PRIVATE LIMITED",
"THREE SIXTY POWER PRODUCTS PRIVATE LIMITED",
"THREE SIXTY TEXTILES PRIVATE LIMITED",
"THREE SONS FOREX INDIA PRIVATE LIMITED",
"THREE STAR DEVELOPERS PRIVATE LIMITED",
"THREE STAR ENGINEERING WORKS PRIVATE LIMITED",
"THREE STAR ENGINEERS PRIVATE LIMITED",
"THREE STAR FINE CHEM PRODUCTS PRIVATE LIMITED",
"THREE STAR GRANITES PVT LTD",
"THREE STAR WAREHOUSING & LOGISTICS PRIVATE LIMITED",
"THREE TEE AUTO LOGISTICS PRIVATE LIMITED",
"THREE TEL NETWORK SERVICES PRIVATE LIMITED",
"THREE V GOURMET HOSPITALITY PRIVATE LIMITED",
"THREE VEE COMMUNICATIONS PRIVATE LIMITED",
"THREE VEE MARKETING PRIVATE LIMITED",
"THREE WAY SHIPPING SERVICES PRIVATE LIMITED",
"THREE WHEELS CAPITAL PRIVATE LIMITED",
"THREE65 FINANCIAL SERVICES PRIVATE LIMITED",
"THRE-EL ENGINEERING PRIVATE LIMITED",
"THREELINE LOGISTICS AND SHIPPING PRIVATE LIMITED",
"THREE-N-PRODUCTS PRIVATE LIMITED",
"THREESIXTY GARMENTS PRIVATE LIMITED",
"THREESIXTY LOGICA TESTING SERVICES PRIVATE LIMITED",
"THREESIXTY TRADING NETWORKS (INDIA) PRIVATE LIMITED",
"THREESIXTYONE DEGREE MINDS CONSULTING PRIVATE LIMITED",
"THREESONS PAINTS ANDCHEMICALS PRIVATE LIMITED",
"THREESTAR SOLUTIONS AND SERVICES PRIVATE LIMITED",
"THREPSI SOLUTIONS PRIVATE LIMITED",
"THRESHOLD SOFTWARE SOLUTIONS PRIVATE LIMITED",
"THREYES SRINISONS HARNESS PRIVATE LIMITED",
"THRI AUTOMOTIVES",
"THRIAM MOULDS AND DIES PRIVATE LIMITED",
"THRIAMVOS ENERGY PRIVATE LIMITED",
"THRIARR POLYMERS PRIVATE LIMITED",
"THRIBE CREATORS PRIVATE LIMITED",
"THRIFT PHARMACEUTICALS PRIVATE LIMITED",
"THRIIVE CARS",
"THRILL IMPEX PRIVATE LIMITED",
"THRILLOPHILIA TRAVEL SOLUTIONS PRIVATE LIMITED",
"THRISHANKU TECHNOLOGIES PRIVATE LIMITED",
"THRISSUR BUILDERS PRIVATE LIMITED",
"THRISSUR ELITE DRUGS PRIVATE LIMITED",
"THRISSUR EXPRESSWAY LIMITED",
"THRISSUR GAS PRODUCTS PRIVATE LIMITED",
"THRISSUR PADDY FARMERS PRODUCER COMPANY LIMITED",
"THRISSUR REPRO HEALTH CARE PRIVATE LIMITED",
"THRIVE 360EAST DEVELOPERS PRIVATE LIMITED",
"THRIVE AUTOMOBILES PRIVATE LIMITED",
"THRIVE FASHION PRIVATE LIMITED",
"THRIVENI APPARELS AND TEXTILES PRIVATE LIMITED",
"THRIVENI CAR COMPANY PRIVATE LIMITED",
"THRIVENI EARTHMOVERS PRIVATE LIMITED",
"THRIVENI PELLETS PRIVATE LIMITED",
"THRIVENI SAINIK MINING PRIVATE LIMITED",
"THRIVENT FINANCIAL FOR LUTHERANS",
"THRIVEPASS INDIA PRIVATE LIMITED",
"THRIVERA STAFFING SERVICES PRIVATE LIMITED",
"THRIVEX LIFE SCIENCES PRIVATE LIMITED",
"THRIVING DEVELOPERS PRIVATE LIMITED",
"THRIVING GLOBAL SERVICES PRIVATE LIMITED",
"THRIWE CONSULTING PRIVATE LIMITED",
"THRIWE GLOCAL PRIVATE LIMITED",
"THRONE PHARMA SOLUTIONS PRIVATE LIMITED",
"THRONS INFRASTRUCTURE PRIVATE LIMITED",
"THROTTLE AEROSPACE SYSTEMS PRIVATE LIMITED",
"THROTTLE ENGINEERING INDIA PRIVATE LIMITED",
"THROTTLE TECHNICAL INNOVATIONS PRIVATE LIMITED",
"THROUGHOUT TECHNOLOGIES PRIVATE LIMITED",
"THRS TRAVEL AND HOSPITALITY REPRESENTATION SERVICES PRIVATE LIMITED",
"THRYMR SOFTWARE PRIVATE LIMITED",
"THRYVE DIGITAL HEALTH LLP",
"THS HEALTHCARE PRIVATE LIMITED",
"THS WELLNESS PRIVATE LIMITED",
"T-HUB FOUNDATION",
"THUKKAPUR SOLAR PRIVATE LIMITED",
"THUKKARAM BUILDERS AND CONTRACTORS PRIVATE LIMITED",
"THUKRAL CEMENT WORKS PRIVATE LIMITED",
"THUKRAL DIAGNOSTIC CENTRE PRIVATE LIMITED",
"THUKRAL ELECTRIC BIKES PRIVATE LIMITED",
"THUKRAL METALS PRIVATE LIMITED",
"THULASI PHARMACIES INDIA PRIVATE LIMITED",
"THULASIMOHAN CONSTRUCTIONS PRIVATE LIMITED",
"THULASIS TECHNOLOGY PRIVATE LIMITED",
"THULIR LEARNING SOLUTION PRIVATE LIMITED",
"THULP FOODS PRIVATE LIMITED",
"THUMBAY HOSPITAL INDIA PRIVATE LIMITED",
"THUMBAY TECHNOLOGIES PRIVATE LIMITED",
"THUMBNAIL PICTURES PRIVATE LIMITED",
"THUMBPRINT ADVERTISING PVT LTD",
"THUMBY AVIATION PRIVATE LIMITED",
"THUNCHATHU EZHUTHACHAN RUBBERS PVT LTD",
"THUNDER FORCE LIMITED",
"THUNDER MERCHANDISE PRIVATE LIMITED",
"THUNDER MOTORS PRIVATE LIMITED",
"THUNDERSOFT INDIA PRIVATE LIMITED",
"THUNDERWELL INDIA PRIVATE LIMITED",
"THUNGA HEALTHCARE LLP",
"THUNGA HOSPITAL PRIVATE LIMITED",
"THURAIPAKKAM DEVELOPERS PRIVATE LIMITED",
"THURS ORGANICS PRIVATE LIMITED",
"THUSE ELEKTRONICS PRIVATE LIMITED",
"THUSMAA SMS NONWOVENS PRIVATE LIMITED",
"THYAGARAYA COLLEGE",
"THYKN INDIA INTERNATIONAL",
"THYLAKOID BIOTECH PRIVATE LIMITED",
"THYMAS ELECTRONICS PVT LTD",
"THYME INDIA PRIVATE LIMITED",
"THYNK CLOUD PRIVATE LIMITED",
"THYROCARE TECHNOLOGIES LIMITED",
"THYSSENKRUPP AEROSPACE INDIA PRIVATE LIMITED",
"THYSSENKRUPP AIRPORT SERVICES S.L",
"THYSSENKRUPP AUTOMOTIVE BODY SOLUTIONS PRIVATE LIMITED",
"THYSSENKRUPP ELECTRICAL STEEL INDIA PRIVATE LIMITED",
"THYSSENKRUPP INDIA PRIVATE LIMITED",
"THYSSENKRUPP UHDE INDIA PRIVATE LIMITED",
"TKIL INDUSTRIES PRIVATE LIMITED",
"THYSSENKRUPP MARINE SYSTEMS (INDIA) PRIVATE LIMITED",
"THYSSENKRUPP MATERIALS IT SERVICES INDIA PRIVATE LIMITED",
"TI ANODE FABRICATORS PRIVATE LIMITED",
"TI LEARNING NETWORK",
"TI MATRICULATION HIGHER SECONDARY SCHOOL",
"TI MEDICAL PRIVATE LIMITED",
"TI SOLUTIONS PRIVATE LIMITED",
"TI TSUBAMEX PRIVATE LIMITED",
"TI2 SHIPPING INDIA PRIVATE LIMITED",
"TIA CUSTOMER CARE PRIVATE LIMITED",
"TIA ENTERPRISES PRIVATE LIMITED",
"TIA TECHNOLOGY (INDIA) PRIVATE LIMITED",
"TIAA GLOBAL CAPABILITIES PRIVATE LIMITED",
"TIAA-CREF",
"TIAAN WHEELS PRIVATE LIMITED",
"TIAM FOODS PRIVATE LIMITED",
"TIANA JEWELLERY EXPORTS PRIVATE LIMITED",
"TIANCI TECHNO INDIA PRIVATE LIMITED",
"TIANJIN TIANSHI INDIA PRIVATE LIMITED",
"TIANU FURNITURE PRIVATE LIMITED",
"TIANYIN WORLDTECH INDIA PRIVATE LIMITED",
"TIANZHU ELECTRONICS PRIVATE LIMITED",
"TIARA AUTO COMP PRIVATE LIMITED",
"TIARA COMTRADE PRIVATE LIMITED",
"TIARA CONSULTING SERVICES INDIA PRIVATE LIMITED",
"TIARA HOSPITALITY PRIVATE LIMITED",
"TIARA JEWELS PRIVATE LIMITED",
"TIARA METALS PRIVATE LIMITED",
"TIARA SILVER PRIVATE LIMITED",
"TIARA SOFTWARES WORLD PRIVATE LIMITED",
"TIATECH HEALTH TECHNOLOGIES PRIVATE LIMITED",
"TIAZO TRADE PRIVATE LIMITED",
"TIB RETAIL PRIVATE LIMITED",
"TIBALAJI PETROCHEM PRIVATE LIMITED",
"TIBCO SOFTWARE INDIA PRIVATE LIMITED",
"TIBERIAS DEVELOPERS LIMITED",
"TIBIL COMPUTER SOLUTIONS PRIVATE LIMITED",
"TIBOS SOLUTIONS AND SERVICES PRIVATE LIMITED",
"TIBREWAL AGENCIES PRIVATE LIMITED",
"TIBREWALA ELECTRICALS PRIVATE LIMITED",
"TIBREWALA ELECTROMECH PRIVATE LIMITED",
"TIBREWALA ELECTRONICS LIMITED",
"TIBREWALA INSULATION LTD.",
"TIBREWALA REALTORS PRIVATE LIMITED",
"TIBREWALA TEXTILE MILLS PRIVATE LIMITED",
"TIBRIWAL PLASTICS PVT LTD",
"TIBRO TOURS PRIVATE LIMITED",
"TIBURON MEDIA GROUP INDIA PRIVATE LIMITED",
"TIC INTEGRATED MARKETING SERVICES PRIVATE LIMITED",
"TIC RETAIL ACCESSORIES INDIA PRIVATE LIMITED",
"TICEL BIO PARK LIMITED",
"TICK BUSINESS SOLUTIONS PRIVATE LIMITED",
"TICK MARK PROCESS SOLUTIONS PRIVATE LIMITED",
"TICKET DESIGN PRIVATE LIMITED",
"TICKETGENIE SOLUTIONS PRIVATE LIMITED",
"TICKETGOOSECOM INDIA PRIVATE LIMITED",
"TICKETS NETWORK INDIA PRIVATE LIMITED",
"TICKING MINDS TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"TICKLE RIGHT EDUVENTURES PRIVATE LIMITED",
"TICKLED MEDIA (INDIA) PRIVATE LIMITED",
"TICKMARKS TECHNOLOGY AND RISK CONSULTING PRIVATE LIMITED",
"TICKTO SOLUTIONS INDIA PRIVATE LIMITED",
"TICKWELL TREXIM PVT LTD",
"TICOMP HEELS PRIVATE LIMITED",
"TICVIC TECHNOLOGIES PRIVATE LIMITED",
"TIDAL HEALTHCARE PRIVATE LIMITED",
"TIDAL LABORATORIES PRIVATE LIMITED",
"TIDAL TRADING PRIVATE LIMITED",
"TIDAL WAVE TECHNOLOGIES PRIVATE LIMITED",
"TIDAL7 BRAND AND DIGITAL PRIVATE LIMITED",
"TIDBIT SOLUTIONS LLP",
"TIDC INDIA",
"TIDC INDIA LIMITED",
"TIDE PROJECTS PRIVATE LIMITED",
"TIDE TECHNOCRATS PRIVATE LIMITED",
"TIDE WATER OIL CO. INDIA LIMITED",
"TIDEL PARK COIMBATORE LIMITED",
"TIDEL PARK LIMITED",
"TIDEWATER SHIPPING PRIVATE LIMITED",
"TIDINGS DIGITAL PUBLICATIONS PRIVATE LIMITED",
"TIDWELL HOME PRIVATE LIMITED",
"TIDY CORPORATE SERVICES PRIVATE LIMITED",
"TIE CONSULTECH PRIVATE LIMITED",
"TIE GLOBAL SERVICES PRIVATE LIMITED",
"TIEA CONNECTORS PRIVATE LIMITED",
"TIECO ECOM AND RETAIL PRIVATE LIMITED",
"TIEMAC SNACK FOODS PRIVATE LIMITED",
"TIENDA ADVANCED MATERIALS PRIVATE LIMITED",
"TIER 1 AGRI TECH PRIVATE LIMITED",
"TIER5 TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"TIERONE OSS SOLUTIONS INDIA PRIVATE LIMITED",
"TIERRA AGROTECH LIMITED",
"TIERRA AGROTECH PRIVATE LIMITED",
"TIERRA FARM ASSETS COMPANY PRIVATE LIMITED",
"TIERRA FERTILIZER PRIVATE LIMITED",
"TIERRA LOGISTICS PRIVATE LIMITED",
"TIESAR PERSONAL CARE PRIVATE LIMITED",
"TIETOEVRY FINTECH INDIA PRIVATE LIMITED",
"TIETOEVRY INDIA PRIVATE LIMITED",
"TIEZ INTERACTIVE PRIVATE LIMITED",
"TIF INTEGRATED INDUSTRIAL PARKS PRIVATE LIMITED",
"TIF LABS PRIVATE LIMITED",
"TIFC (INDIA) ONLINE RETAIL PRIVATE LIMITED",
"TIFFANY FINANCE PRIVATE LIMITED",
"TIFFINIS INDIA PVT LTD",
"TIFFINS FRESH FOODS PRIVATE LIMITED",
"TIFIN FINTECH INDIA LLP",
"TIG INFRASTRUCTURE PRIVATE LIMITED",
"TIGER 4 INDIA LIMITED",
"TIGER 4 SECURITY & FACILITIES INDIA PRIVATE LIMITED",
"TIGER ANALYTICS INDIA CONSULTING PRIVATE LIMITED",
"TIGER ANALYTICS INDIA LLP",
"TIGER CEMENT PRIVATE LIMITED",
"TIGER EYE VEHICLE SERVICES PRIVATE LIMITED",
"TIGER FORGINGS PVT LTD",
"TIGER GUARDS PRIVATE LIMITED",
"TIGER HR SOLUTIONS PRIVATE LIMITED",
"TIGER INDIA PRIVATE LIMITED",
"TIGER JEWELLERY (INDIA) PRIVATE LIMITED",
"TIGER LOGISTICS INDIA LIMITED",
"TIGER PROJECT MELGHAT",
"TIGER PUG COMMERCE PRIVATE LIMITED",
"TIGER SECURITAS PRIVATE LIMITED",
"TIGER SONS GLASS INDUSTRIES PRIVATE LIMITED",
"TIGER SYNERGIES PRIVATE LIMITED",
"TIGER TOP CULTURAL AND ADVENTURE TOURS PRIVATE LIMITED",
"TIGER VANIJYA PRIVATE LIMITED",
"TIGER WEALTH MANAGEMENT PRIVATE LIMITED",
"TIGERHILL VINTRADE PRIVATE LIMITED",
"TIGERISH TRADING PRIVATE LIMITED",
"TIGERMED CLINICAL RESEARCH INDIA PRIVATE LIMITED",
"TIGERS WORLDWIDE LOGISTICS PRIVATE LIMITED",
"TIGHTWELL FORGINGS LIMITED",
"TIGI INDUSTRIES INDIA PRIVATE LIMITED",
"TIGMA TECHNOLOGIES",
"TIGON REALITY PRIVATE LIMITED",
"TIGRIS ENVIRONMENT INDIA PRIVATE LIMITED",
"TIGS & MIGS WELD PRIVATE LIMITED",
"TIH FOUNDATION FOR IOT AND IOE",
"TII INDIA PRIVATE LIMITED",
"TII TECHNO TESTING INSTRUMENTS PRIVATE LIMITED",
"TII TECHNO TESTING SERVICES PRIVATE LIMITED",
"TIINLAB ACOUSTIC TECHNOLOGY INDIA PRIVATE LIMITED",
"TIITAN HOLDINGS INDIA PRIVATE LIMITED",
"TIJARE ENGINEERS & CONSULTANTS PRIVATE LIMITED",
"TIJIYA EXPORTS PRIVATE LIMITED",
"TIJORI FINANCIAL SERVICES PRIVATE LIMITED",
"TIK TALK CAFE",
"TIKA DATA SERVICES (OPC) PRIVATE LIMITED",
"TIKAMDAS MOTIRAM JEWELLERS PRIVATE LIMITED",
"TIKAMSA DULICHAND NATURAL FIBRES LIMITED",
"TIKANI EXPORTS LIMITED",
"TIKARAM JAGANNATH COLLEGE",
"TIKAULA SUGAR MILLS LIMITED",
"TIKAUTEX SILK MILLS PRIVATE LIMITED",
"TIKI TAR AND SHELL INDIA PRIVATE LIMITED",
"TIKI TAR DANOSA INDIA PRIVATE LIMITED",
"TIKI TAR INDUSTRIES BARODA LIMITED",
"TIKI TAR INDUSTRIES INDIA LIMITED",
"TIKKA JUNCTION PRIVATE LIMITED",
"TIKKI FOOD PRIVATE LIMITED",
"TIKMANY STEEL FORGINGS PVT. LTD.",
"TIKMANY TELESYSTEMS PRIVATE LIMITED",
"TIKOLO APPARELS PRIVATE LIMITED",
"TIKONA INFINET PRIVATE LIMITED",
"TIKRI MANAGEMENT PRIVATE LIMITED",
"TIKSNA LIVELIHOOD PRIVATE LIMITED",
"TIKU RAM GUM AND CHEMICALS PRIVATE LIMITED",
"TIL ADVISORS PRIVATE LIMITED",
"TIL HEALTHCARE PRIVATE LIMITED",
"TIL INVESTMENTS PVT. LTD.",
"TILAK AYURVED MAHAVIDYALAYA",
"TILAK MAHARASHTRA VIDYAPEETH",
"TILAK MARBLES PRIVATE LIMITED",
"TILAK POLYPACK PVT LTD",
"TILAK RAJ PUBLICATIONS PRIVATE LIMITED",
"TILAK RAM BABU RAM PRIVATE LIMITED",
"TILAK TRADING COMPANY PRIVATE LIMITED",
"TILAK UTPADAN PRIVATE LIMITED",
"TILAK VENTURES LIMITED",
"TILAKNAGAR INDUSTRIES LIMITED",
"TILAKRAJ MOTORS",
"TILARA POLYPLAST PRIVATE LIMITED",
"TILDA HAIN INDIA PRIVATE LIMITED",
"TILE ITALIA MOSAICS PRIVATE. LIMITED.",
"TILE PLAZA",
"TILE STUDIO",
"TILECO GARTEX PRIVATE LIMITED",
"TILECO NATURAL STONES PRIVATE LIMITED",
"TILECO PVT LTD",
"TILEKART PRIVATE LIMITED",
"TILES BOUTIQUE PRIVATE LIMITED",
"TILFI BRANDS PRIVATE LIMITED",
"TILID LOGISTICS PRIVATE LIMITED",
"TILLAGE AGROCHEMICALS PRIVATE LIMITED",
"TILLAGE ECONOMIC GROWERS PRIVATE LIMITED",
"TILLAGE TOWERS FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"TILLID SOFTWARE SOLUTION PRIVATE LIMITED",
"TILLPOS TECHNOLOGIES PRIVATE LIMITED",
"TILON ENTERPRISES PRIVATE LIMITED",
"TILOTTAMA HOLDINGS PVT LTD",
"TILT BRAND SOLUTIONS PRIVATE LIMITED",
"TILTLABS CONSULTANCY SERVICES PRIVATE LIMITED",
"TILTRO ADVISORY PRIVATE LIMITED",
"TILWARA LEFT BANK CANAL DIVISION KEOLARI",
"TIM DELHI AIRPORT ADVERTISING PRIVATE LIMITED",
"TIM INFRATECH PRIVATE LIMITED",
"TIM LEISURE SERVICES PRIVATE LIMITED",
"TIMA DEVELOPERS PRIVATE LIMITED",
"TIMAB INDIA PRIVATE LIMITED",
"TIMAC AGRO INDIA PRIVATE LIMITED",
"TIMARPUR OKHLA WASTE MANAGEMENT COMPANY LIMITED",
"TIMBE WINDOWS PRIVATE LIMITED",
"TIMBER BELLY RESTAURANTS PRIVATE LIMITED",
"TIMBER CRAFT AND VENEER PRODUCTS INDIA P RIVATE LIMITED",
"TIMBER TRENDZ FLOOR PRIVATE LIMITED",
"TIMBERART DESIGN PRIVATE LIMITED",
"TIMBERTUNES DESIGNS & INTERIORS PRIVATE LIMITED",
"TIMBLE TECHNOLOGIES PRIVATE LIMITED",
"TIMBLO DRYDOCKS PRIVATE LIMITED",
"TIMBMET DOOR SOLUTIONS PRIVATE LIMITED",
"TIMBRESONIC LIFESTYLE PRIVATE LIMITED",
"TIME & SPACE ENGINEERING CONSTRUCTION PRIVATE LIMITED",
"TIME & SPACE LOGISTICS PRIVATE LIMITED",
"TIME AD-MEDIA INDIA PRIVATE LIMITED",
"TIME AND LABOUR PRIVATE LIMITED",
"TIME AND STYLE (INDIA) PRIVATE LIMITED",
"TIME AVENUE PRIVATE LIMITED",
"TIME BODYCARE PRIVATE LIMITED",
"TIME CAP PHARMA LABS PRIVATE LIMITED",
"TIME CAPITAL LIMITED",
"TIME EDUCATION PRIVATE LIMITED",
"TIME EQUIPMENT PRIVATE LIMITED",
"TIME EXPORTS PRIVATE LIMITED",
"TIME EXPRESS(INDIA)PRIVATE LIMITED",
"TIME HOSPITALS PRIVATE LIMITED",
"TIME INFOSYSTEMS PRIVATE LIMITED",
"TIME LEGEND IT AND HR CONSULTING SOLUTIONS PRIVATE LIMITED",
"TIME LIFESTYLE PRIVATE LIMITED",
"TIME MACHINE BEAUTY SOLUTIONS PRIVATE LIMITED",
"TIME MAUSER INDUSTRIES PRIVATE LIMITED",
"TIME N SPACE INSTADIA (OPC) PRIVATE LIMITED",
"TIME PROJECTS PRIVATE LIMITED",
"TIME REMEDIES PRIVATE LIMITED",
"TIME RICH SHIPPING PRIVATE LIMITED",
"TIME SAVING COURIERS PRIVATE LIMITED",
"TIME SEAWAYS PRIVATE LIMITED",
"TIME SECURITIES SERVICES PRIVATE LIMITED",
"TIME SQUARE INVESTMENTS PRIVATE LIMITED",
"TIME SQUARE RESTAURANT AND BAR",
"TIME TECH WASTE SOLUTIONS PRIVATE LIMITED",
"TIME TECHNOPLAST LIMITED",
"TIME TOWER ESTATE MANAGEMENT SERVICES PRIVATE LIMITED",
"TIME TOWER INTERNATIONAL PRIVATE LIMITED",
"TIME TRACK OVERSEAS PRIVATE LIMITED",
"TIME TRAVEL ODYSSEYS PRIVATE LIMITED",
"TIMECITY REAL ESTATES (INDIA) LIMITED",
"TIMEHONOURED MARKETING NETWORKS PRIVATE LIMITED",
"TIMELESS VENTURES PRIVATE LIMITED",
"TIMELINE CONSTRUCTIONS PRIVATE LIMITED",
"TIMELY FINANCIAL CONSULTANTS PRIVATE LIMITED",
"TIMENET SOLUTIONS PRIVATE LIMITED",
"TIMEREWARDS SOFTWARE PRIVATE LIMITED",
"TIMES ACADEMY OF SCIENCE AND COMMERECE",
"TIMES AUTOMATION PRIVATE LIMITED",
"TIMES COMTRADE PRIVATE LIMITED",
"TIMES CONTENT LIMITED",
"TIMES DRUGS AND PHARMACETICALS PRIVATE LIMITED",
"TIMES EDUTECH AND EVENTS LIMITED",
"TIMES EXPRESS SERVICES PRIVATE LIMITED",
"TIMES GLOBAL BROADCASTING COMPANY LIMITED",
"TIMES GREEN ENERGY (INDIA) LIMITED",
"TIMES GROWTH SECURITIES LIMITED",
"TIMES GUARANTY LIMITED",
"TIMES HEALTHCARE PRIVATE LIMITED",
"TIMES INDUSTRIAL ENGINEERS PRIVATE LIMITED",
"TIMES INNOVATIVE MEDIA LIMITED",
"TIMES IT SERVICES PRIVATE LIMITED",
"TIMES LOGISTICS LIMITED",
"TIMES MARKETING PRIVATE LIMITED",
"TIMES OF INDIA",
"TIMES PRESS PEOPLE PRIVATE LIMITED",
"TIMES PUBLISHING HOUSE LIMITED",
"TIMES SHIPPING AGENCIES PRIVATE LIMITED",
"TIMES SQUARE FACILITY MANAGEMENT LLP",
"TIMES STATIONERS PRIVATE LIMITED",
"TIMES STEEL & POWER PRIVATE LIMITED",
"TIMES STRATEGIC SOLUTIONS LIMITED",
"TIMESAVERZ DOTCOM PRIVATE LIMITED",
"TIMESCAN LOGISTICS (INDIA) LIMITED",
"TIMESCAN LOGISTICS INDIA PRIVATE LIMITED",
"TIMESHELL CIVIL PROJECTS E-MONITORING CONSULTANCY PRIVATE LIMITED",
"TIMESOFMONEY PRIVATE LIMITED",
"TIMESOL FACILITY MANAGEMENT PRIVATE LIMITED",
"TIMESPRO",
"TIMESTAR PRIVATE LIMITED",
"TIMESWORLD MEDIA AND TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"TIMESYS TECHNOLOGIES INDIA LLP",
"TIMETECH PHARMA PRIVATE LIMITED",
"TIMETOOTH TECHNOLOGIES PRIVATE LIMITED",
"TIMEWATCH INFOCOM PRIVATE LIMITED",
"TIMEX ART DECOR PRIVATE LIMITED",
"TIMEX GROUP INDIA LIMITED",
"TIMEX GROUP PRECISION ENGINEERING LIMITED",
"TIMEXBOND INDUSTRIES PRIVATE LIMITED",
"TIMEXO FASTENERS (INDIA) PRIVATE LIMITED",
"TIMEZ CARE SERVICES PRIVATE LIMITED",
"TIMEZEECONSUMER PRODUCTS PRIVATE LIMITED",
"TIMEZONE ENTERTAINMENT PRIVATE LIMITED",
"TIMING TECHNOLOGIES INDIA PRIVATE LIMITED",
"TIMKEN ENGINEERING AND RESEARCH INDIA PRIVATE LIMITED",
"TIMKEN INDIA LIMITED",
"TIMLA FOODS PRIVATE LIMITED",
"TIMO EVA WELLNESS PRIVATE LIMITED",
"TIMOKSH BUSINESS PRIVATE LIMITED",
"TIMON PHARMACEUTICALS PRIVATE LIMITED",
"TIMONEER SALES AND SERVICES PRIVATE LIMITED",
"TIMPAC HEALTHCARE PRIVATE LIMITED",
"TIMPACK PVT LTD",
"TIMS FOODS PRIVATE LIMITED",
"TIMS LEARNING SOLUTIONS PRIVATE LIMITED",
"TIMS PRODUCTS LTD.",
"TIMS SOLUTIONS PRIVATE LIMITED",
"TIMUZ SOLUTIONS PRIVATE LIMITED",
"TIMWOOD PLASTICS PRIVATE LIMITED",
"TIMWORLD INTERNATIONAL PRIVATE LIMITED",
"TINA ENGINEERING PRIVATE LIMITED",
"TINA FILMS UNIVERSAL PRIVATE LIMITED",
"TINA KNIT FAB PRIVATE LIMITED",
"TINA MARKETING PRIVATE LIMITED",
"TINA ORGANICS PRIVATE LIMITED",
"TINCO CHEMICALS PRIVATE LIMITED",
"TINCO TRADING PRIVATE LIMITED",
"TINCTURA COLOUR PRIVATE LIMITED",
"TINE AGRO LIMITED",
"TINETA PHARMA PRIVATE LIMITED",
"TING TONG INTERNATIONAL PRIVATE LIMITED",
"TING WORKS LLP",
"TINGE BLENDS PRIVATE LIMITED",
"TINGLING BUDS PRIVATE LIMITED",
"TINI POWER PRIVATE LIMITED",
"TINITA ENGINEERING PRIVATE LIMITED",
"TINIUS OLSEN INDIA PRIVATE LIMITED",
"TINKARA RETAIL PRIVATE LIMITED",
"TINKERCODERS EDTECH PRIVATE LIMITED",
"TINKERLABS DESIGN SOLUTIONS PRIVATE LIMITED",
"TINKHARIA TEA PRIVATE LIMITED",
"TINKLE BELLS INTERNATIONAL PRIVATE LIMITED",
"TINMET IMPEX PRIVATE LIMITED",
"TINNA RUBBER & INFRASTRUCTURE LIMITED",
"TINNA TRADE LIMITED",
"TINNA VVIP RESORTS PRIVATE LIMITED",
"TINNU INTERNATIONAL PRIVATE LIMITED",
"TINNY CRAFT PRIVATE LIMITED",
"TINO ENGINEERING PRIVATE LIMITED",
"TINOMED HEALTHCARE PRIVATE LIMITED",
"TINPLATE COMPANY OF INDIA LIMITED",
"TINS LAB PRIVATE LIMITED",
"TINSLEY SPRING INDUSTRIES LIMITED",
"TINSUKIA TRADING COMPANY PRIVATE LIMITED",
"TINTECH ONLINE PRIVATE LIMITED",
"TINTESS PRIVATE LIMITED",
"TINTOMETER INDIA PRIVATE LIMITED",
"TINUP TRADE LINKS",
"TINWALA FOREX TRADING PRIVATE LIMITED",
"TINY CLAWS APPARELS PRIVATE LIMITED",
"TINY CONTROLS PRIVATE LIMITED",
"TINY GIRL CLOTHING COMPANY PRIVATE LIMITED",
"TINY PLANET INFOTECH PRIVATE LIMITED",
"TINY TACTICS PRIVATE LIMITED",
"TINY TOTS VOGUE ( INDIA ) PRIVATE LIMITED",
"TINYBYTE SOLUTIONS PRIVATE LIMITED",
"TINYTOP ENGINEERING INDIA PRIVATE LIMITED",
"TINYTOPP PRINT PACK PRIVATE LIMITED",
"TINYZO ONLINE PRIVATE LIMITED",
"TIO PAINTS PRIVATE LIMITED",
"TIOL PRIVATE LIMITED",
"TIONALE IMPEX PRIVATE LIMITED",
"TIONG WOON PROJECT AND CONTRACTING INDIA PRIVATE LIMITED",
"TIP KNOWLEDGE SERVICES PRIVATE LIMITED",
"TIP TOP DEVELOPERS PRIVATE LIMITED",
"TIP TOP FOOD TECH (INDIA) PRIVATE LIMITED",
"TIPCO INDUSTRIES PRIVATE LIMITED",
"TIPL JMMIPL JV PRIVATE LIMITED",
"TIPL TECHANALYTICS INFOTECH PRIVATE LIMITED",
"TIPOYA ENTERPRISES PRIVATE LIMITED",
"TIPPERS & TRAILERS INDIA PRIVATE LIMITED",
"TIPPING MR PINK PRIVATE LIMITED",
"TIPPING POINT HOSPITALITY PRIVATE LIMITED",
"TIPPLE CASA PRIVATE LIMITED",
"TIPPU SULTHAN PRE UNIVERSITY COLLEGE",
"TIPS INDUSTRIES LIMITED",
"TIPSON CYCLES PVT LTD",
"TIPSONS CONSULTANCY SERVICES PRIVATE LIMITED",
"TIPSONS FINANCIAL SERVICES PRIVATE LIMITED",
"TIPSONS STOCK BROKERS PRIVATE LIMITED",
"TIPSY ANAND DESIGNS PRIVATE LIMITED",
"TIPSY FASHIONS PRIVATE LIMITED",
"TIQUITAKA WRITERS PRIVATE LIMITED",
"TIRAME TECHNOLOGY PRIVATE LIMITED",
"TIRAMISU NEW MEDIA SOLUTIONS PRIVATE LIMITED",
"TIRANGA AGRO PRIVATE LIMITED",
"TIRANGA AUTOTECH INDIA PRIVATE LIMITED",
"TIRANGA DESIGNS PRIVATE LIMITED",
"TIRANGA FOODS PRIVATE LIMITED",
"TIRANGA LOGISTICS PRIVATE LIMITED",
"TIRASSA PROJECTS PRIVATE LIMITED",
"TIRATH CONSTRUCTION PRIVATE LIMITED",
"TIRATH FASTNERS PVT LTD",
"TIRATH RAM AHUJA PRIVATE LIMITED",
"TIRATH RAM HOSPITALS PRIVATE LIMITED",
"TIRATH SINGH & BROS AGENCIES PRIVATE LIMITED",
"TIRATH SOAP FACTORY PRIVATE LIMITED",
"TIREX CHARGING INFRA PRIVATE LIMITED",
"TIREX TRANSMISSION PRIVATE LIMITED",
"TIRKUT KRISHAK PRODUCER COMPANY LIMITED",
"TIRO STEELS PRIVATE LIMITED",
"TIRPUDE COLLEGE OF SOCIAL WORK",
"TIRRIHANNAH CO LTD",
"TIRSHIL ALGOCOMM TECHNOLOGIES LIMITED",
"TIRSHIL ENTERPRISES PRIVATE LIMITED",
"TIRTH AGRO TECHNOLOGY PRIVATE LIMITED",
"TIRTH ALLOYS PRIVATE LIMITED",
"TIRTH EDUCATIONAL FOUNDATION",
"TIRTH HYGIENE TECHNOLOGY PRIVATE LIMITED",
"TIRTH POLYMERS PRIVATE LIMITED",
"TIRTH PRINTPACK PRIVATE LIMITED",
"TIRTHA AGENCIES PRIVATE LIMITED",
"TIRTHABARTI INSTITUTION",
"TIRTHAK PAPER MILL PRIVATE LIMITED",
"TIRTHANJALI EDUCATION SOCIETY",
"TIRTHANKAR CITY BUS OPERATIONS PRIVATE LIMITED",
"TIRTHANKAR COMOTRADE PRIVATE LIMITED",
"TIRTHANKAR ENGINEERING WORKS PRIVATE LIMITED",
"TIRTHDAS SHAUKATRAI CONSTRUCTIONS PVT LTD",
"TIRTHEDEN PRIVATE LIMITED",
"TIRTHRAM SHAH HOSPITAL",
"TIRU KRIS STEELS PRIVATE LIMITED",
"TIRUAL BORTIMAN TEA ESTATE PVT LTD",
"TIRUBALA EXPORTS (INDIA) PRIVATE LIMITED",
"TIRUBALA INTERNATIONAL PRIVATE LIMITED",
"TIRUBALA MANUFACTURING & MARKETING PRIVATE LIMITED",
"TIRUCHIRAPALLI ENGINEERING AND TECHNOLOGY CLUSTER",
"TIRUCHIRAPPALLI CITY CORPORATION",
"TIRUCHY MEDICAL CENTRE AND HOSPITAL PRIVATE LIMITED",
"TIRUKUTA MARKETING SERVICES PRIVATE LIMITED",
"TIRUMALA AERATED BLOCKS PRIVATE. LIMITED.",
"TIRUMALA AGRI TECH PRIVATE. LIMITED.",
"TIRUMALA BALAJI ALLOYS PRIVATE. LIMITED",
"TIRUMALA BALAJI SMELTERS PRIVATE LIMITED",
"TIRUMALA BEARINGS PRIVATE LIMITED",
"TIRUMALA BREEDERS PRIVATE LIMITED",
"TIRUMALA COTTON & AGRO PRODUCTS PRIVATE LIMITED",
"TIRUMALA DESIGNERS PRIVATE LIMITED",
"TIRUMALA DEVASWAM MEDICAL COLLEGE",
"TIRUMALA EDUCATIONAL INSTITUTES",
"TIRUMALA ENGINEERING COLLEGE",
"TIRUMALA ENTERPRISES PRIVATE LIMITED",
"TIRUMALA FACILITY MANAGEMENT INDIA LLP",
"TIRUMALA FACILITY MANAGEMENT PRIVATE LIMITED",
"TIRUMALA FINETEX PRIVATE LIMITED",
"TIRUMALA HATCHERIES PRIVATE LIMITED",
"TIRUMALA HIGHRISE PRIVATE LIMITED",
"TIRUMALA IIT AND MEDICA ACADEMY",
"TIRUMALA INFRASTRUCTURE AND DEVELOPMENT PRIVATE LIMITED",
"TIRUMALA MARINE FOODS PRIVATE LIMITED",
"TIRUMALA METRO PLYLAM PRIVATE LIMITED",
"TIRUMALA MILK PRODUCTS PRIVATE LIMITED",
"TIRUMALA MULTI SPECIALITY HOSPITALS (INDIA) PRIVATE LIMITED",
"TIRUMALA MUSIC CENTRE PRIVATE. LIMITED.",
"TIRUMALA OILCHEM INDIA PRIVATE LIMITED",
"TIRUMALA OUTSOURCING PRIVATE LIMITED",
"TIRUMALA OVERSEAS PRIVATE LIMITED",
"TIRUMALA PULSES PRIVATE LIMITED",
"TIRUMALA ROTO LAM PRIVATE LIMITED",
"TIRUMALA SALES PVT LTD",
"TIRUMALA SEEDS PRIVATE LIMITED",
"TIRUMALA SEVEN HILLS PRIVATE LIMITED",
"TIRUMALA TIRUPATI DEVASTHANAM",
"TIRUMALA TIRUPATI RICE MILL PRIVATE LIMITED",
"TIRUMALA TRADERS PRIVATE LIMITED",
"TIRUMALA VIJAYA HOSPITAL",
"TIRUMALA VIJAYA MEDICAL CARE PRIVATE LIMITED",
"TIRUMALA VINAYAK PROJECTS PRIVATE LIMITED",
"TIRUMALABALAJI PAPER PRIVATE LIMITED",
"TIRUMALAI STEELS PRIVATE LIMITED",
"TIRUMALLA HAIR OIL INDIA PRIVATE LIMITED",
"TIRUMALLA OIL REFINERY PRIVATE LIMITED",
"TIRUMALLA TIRUPATI MULTISTATE CO-OPERATIVE CREDIT SOCIETY LIMITED",
"TIRUMALLA TRADEMARTS INDIA PRIVATE LIMITED",
"TIRUMALLA TRENDS PRIVATE LIMITED",
"TIRUMALLYA SPINNERS PRIVATE LIMITED",
"TIRUMANI FLAT OWNERS ASSOCIATION",
"TIRUMULA INDUSTRIES PRIVATE LIMITED",
"TIRUNELVELI DAKSHINA MARANADAR SANG",
"TIRUNELVELI VAYU ENERGY GENERATION PRIVATE LIMITED",
"TIRUNVELI SOLAR PROJECT PRIVATE LIMITED",
"TIRUPATEE AGRO INDUSTRIES PRIVATE LIMITED",
"TIRUPATHI HYDROCARBON PRIVATE LIMITED",
"TIRUPATHI NONWOVEN PRIVATE LIMITED",
"TIRUPATHI YARNTEX SPINNERS PRIVATE LIMITED",
"TIRUPATI & ASSOCIATES PRIVATE LIMITED",
"TIRUPATI AGRI IMPEX PRIVATE LIMITED",
"TIRUPATI AGRI TRADE PRIVATE LIMITED",
"TIRUPATI AGRO PRODUCT",
"TIRUPATI AGRO SEED DISTRIBUTORS PRIVATE LIMITED",
"TIRUPATI AGROOILS PRIVATE LIMITED",
"TIRUPATI ANCILLARIES PVT LTD",
"TIRUPATI AND TIRUPATI FASTENERS PRIVATE LIMITED",
"TIRUPATI ASSETS PRIVATE LIMITED",
"TIRUPATI AUTOMART PRIVATE LIMITED",
"TIRUPATI AUTOSERVICE STATION PRIVATE LIMITED",
"TIRUPATI AWAS PRIVATE LIMITED",
"TIRUPATI BALAJEE NUTRITION PRIVATE LIMITED",
"TIRUPATI BALAJI AGRO PRODUCTS PRIVATE LIMITED",
"TIRUPATI BALAJI BUILDERS PRIVATE LIMITED",
"TIRUPATI BALAJI CARGO MOVERS PRIVATE LIMITED",
"TIRUPATI BALAJI COTFAB PRIVATE LIMITED",
"TIRUPATI BALAJI EARTH WORK PRIVATE LIMITED",
"TIRUPATI BALAJI EXIM PRIVATE. LIMITED.",
"TIRUPATI BALAJI FOODS PRIVATE LIMITED",
"TIRUPATI BALAJI LUMBERS PRIVATE LIMITED",
"TIRUPATI BALAJI MINERALS PVT. LTD",
"TIRUPATI BALAJI ROADLINES PRIVATE LIMITED",
"TIRUPATI BALAJI STEELS PRIVATE LIMITED",
"TIRUPATI BIZ LINK LLP",
"TIRUPATI BRIGHT BARS PRIVATE LIMITED",
"TIRUPATI BUILD & COAL PRIVATE LIMITED",
"TIRUPATI BUILDCON PRIVATE LIMITED",
"TIRUPATI BUILDESTATES PRIVATE LIMITED",
"TIRUPATI BUILDINGS AND OFFICES PRIVATE LIMITED",
"TIRUPATI CARBON PRODUCTS PRIVATE LIMITED",
"TIRUPATI CARBONS & CHEMICALS PRIVATE LIMITED",
"TIRUPATI CARRIER LIMITED",
"TIRUPATI CELLCOM PRIVATE LIMITED",
"TIRUPATI CEMPRO PRIVATE LIMITED",
"TIRUPATI CEREALS AND COMMOTRADE PRIVATE LIMITED",
"TIRUPATI COLD STORAGE PVT LTD",
"TIRUPATI COLOUR PENS PRIVATE LIMITED",
"TIRUPATI COMMODITIES PRIVATE LIMITED",
"TIRUPATI CONDUCTORS PRIVATE LIMITED",
"TIRUPATI CONDUCTORS PVT LTD",
"TIRUPATI CONNECTING GADGETS PRIVATE LIMITED",
"TIRUPATI CONSTRUCORP PRIVATE LIMITED",
"TIRUPATI CONSTRUCTION",
"TIRUPATI CONSTRUCTION AND DEVELOPERS",
"TIRUPATI CONTAINERS PRIVATE LIMITED",
"TIRUPATI CONVEYORS INDIA PRIVATE LIMITED",
"TIRUPATI CORPORATE SERVICES PRIVATE LIMITED",
"TIRUPATI CORPORATION PRIVATE LIMITED",
"TIRUPATI COTTEX",
"TIRUPATI CYLINDERS PRIVATE LIMITED",
"TIRUPATI DECOR PRIVATE LIMITED",
"TIRUPATI DESIGNER PRIVATE LIMITED",
"TIRUPATI DRILLING & MINING SERVICES PRIVATE LIMITED",
"TIRUPATI DUROBUILD PRIVATE LIMITED",
"TIRUPATI EARTH AND PROJECT WORKS PRIVATE LIMITED",
"TIRUPATI ELECTRIFY SHOPS PRIVATE LIMITED",
"TIRUPATI ENGICON PRIVATE LIMITED",
"TIRUPATI ENTERPRISES (RANCHI) PRIVATE LIMITED",
"TIRUPATI FANCY YARN INDUSTRIES PVT LTD",
"TIRUPATI FIBRES AND INDUSTRIES LTD",
"TIRUPATI FINCON PRIVATE LIMITED",
"TIRUPATI FINLEASE LTD",
"TIRUPATI FITTING SUPPLIERS PRIVATE LIMITED",
"TIRUPATI FLOUR MACHINES INDIA PRIVATE LIMITED",
"TIRUPATI FOAM LIMITED",
"TIRUPATI FOOD INDUSTRIES PRIVATE LIMITED",
"TIRUPATI FORGE LIMITED",
"TIRUPATI FOUNDRIES INDIA PRIVATE LIMITED",
"TIRUPATI GANESHKRIPA AGRO PRODUCTS PRIVATE LIMITED",
"TIRUPATI GLADIATOR INDUSTRIES PRIVATE LIMITED",
"TIRUPATI GLOBAL FACILITIES INDIA PRIVATE LIMITED",
"TIRUPATI GLOBAL TRADE PRIVATE LIMITED",
"TIRUPATI GOLBAL FACILITIES",
"TIRUPATI GOLD PRIVATE LIMITED",
"TIRUPATI GRANISTONE INDIA PRIVATE LIMITED",
"TIRUPATI HITECH PVT LTD",
"TIRUPATI HI-TECH STAMPING PRIVATE LIMITED",
"TIRUPATI HOMES LIMITED",
"TIRUPATI INDUSTRIAL SERVICES PRIVATE LIMITED",
"TIRUPATI INDUSTRIES - RAJKOT",
"TIRUPATI IRON COMMERCIAL PRIVATE LIMITED",
"TIRUPATI JARS PRIVATE LIMITED",
"TIRUPATI JEWELS INDIA PRIVATE LIMITED",
"TIRUPATI KP COTTON INDUSTRIES PRIVATE. LIMITED.",
"TIRUPATI LIFESCIENCES PRIVATE LIMITED",
"TIRUPATI LOGISTICS PRIVATE LIMITED",
"TIRUPATI LPG INDUSTRIES PRIVATE LIMITED",
"TIRUPATI MARMO PRIVATE LIMITED",
"TIRUPATI MATSUP PRIVATE LIMITED",
"TIRUPATI MEAL PRODUCERS PRIVATE LIMITED",
"TIRUPATI MEDICAL & HEALTHCARE PRIVATE LIMITED",
"TIRUPATI MEDICARE LIMITED",
"TIRUPATI MEDICOS PVT LTD",
"TIRUPATI MEDILINES PRIVATE LIMITED",
"TIRUPATI MERCANTILE AND TRADING COMPANY LTD.",
"TIRUPATI MERCANTILES PVT LTD",
"TIRUPATI METACHEMS PRIVATE LIMITED",
"TIRUPATI MICROTECH PRIVATE LIMITED",
"TIRUPATI MINERALS PRIVATE LIMITED",
"TIRUPATI MOTELS PRIVATE LIMITED",
"TIRUPATI MOTORS PRIVATE LIMITED",
"TIRUPATI NATURAL RESOURCES & INFRA PRIVATE LIMITED",
"TIRUPATI NIRYAT PVT LTD",
"TIRUPATI OFFICE SYSTEMS PRIVATE LIMITED",
"TIRUPATI OIL EXTRACTS PRIVATE LIMITED",
"TIRUPATI OIL INDUSTRIES",
"TIRUPATI ORGANICS PRIVATE LIMITED",
"TIRUPATI OXYGEN PVT LTD",
"TIRUPATI PIPE AND ALLIED INDUSTRIES PRIVATE LIMITED",
"TIRUPATI PLACEMENT ASSOCIATES PRIVATE LIMITED",
"TIRUPATI PLASTOMATICS PRIVATE. LIMITED.",
"TIRUPATI PLAZA PRIVATE LIMITED",
"TIRUPATI POLY ROTO LAMINATION PRIVATE LIMITED",
"TIRUPATI POLYPLAST IRRIGATION SYSTEMS PRIVATE LIMITED",
"TIRUPATI PULSES PRIVATE LIMITED",
"TIRUPATI RECRUITMENTS PRIVATE LIMITED",
"TIRUPATI REELS PRIVATE LIMITED",
"TIRUPATI REFRIGERATION PVT LTD",
"TIRUPATI RENEWABLE ENERGY COMPANY PRIVATE LIMITED",
"TIRUPATI ROLLER FLOUR MILLS PRIVATE LIMITED",
"TIRUPATI ROLLER FLOUR MILLS PVT LTD",
"TIRUPATI RUGS PRIVATE LIMITED",
"TIRUPATI SARJAN LIMITED",
"TIRUPATI SAVINGS PVT LTD",
"TIRUPATI SERVICES PRIVATE LIMITED",
"TIRUPATI SHELTERS LTD.",
"TIRUPATI SILVER HOUSE PRIVATE LIMITED",
"TIRUPATI SLG PLASTIC PRIVATE LIMITED",
"TIRUPATI SMART CITY CORPORATION LIMITED",
"TIRUPATI SOLVENT EXTRACTIONS & REFINERIES PRIVATE LIMITED",
"TIRUPATI SPRINKLERS PRIVATE LIMITED",
"TIRUPATI STARCH & CHEMICALS LIMITED",
"TIRUPATI STEEL TRADING PRIVATE LIMITED",
"TIRUPATI STONE CENTRE PRIVATE LIMITED",
"TIRUPATI STONES PRIVATE LIMITED",
"TIRUPATI STONEX PRIVATE LIMITED",
"TIRUPATI STRUCTURALS LIMITED",
"TIRUPATI STRUCTURES (INDIA) PRIVATE LIMITED",
"TIRUPATI SUGARS LIMITED",
"TIRUPATI SYSTEM FORMS AND PACKAGING PRIVATE LIMITED",
"TIRUPATI TARAI SEEDS PRIVATE LIMITED",
"TIRUPATI TECHNOPACKS PRIVATE LIMITED",
"TIRUPATI TECHNOPLAST PRIVATE LIMITED",
"TIRUPATI TEXTURISERS PVT. LTD.",
"TIRUPATI THREADS PRIVATE LIMITED",
"TIRUPATI TIMBERS & PACKAGING PVT LTD",
"TIRUPATI TRADELINKS PRIVATE LIMITED",
"TIRUPATI TRADEWING PRIVATE LIMITED",
"TIRUPATI TRAVELS & GOODS SERVICE PRIVATE LIMITED",
"TIRUPATI TUBES PRIVATE LIMITED",
"TIRUPATI URBAN CO-OP BANK",
"TIRUPATI VANCOM PVT LTD",
"TIRUPATI VEHICLES PRIVATE LIMITED",
"TIRUPATI VENEERS PRIVATE LIMITED",
"TIRUPATI VENKATESH FOODS PRIVATE LIMITED",
"TIRUPATI VESSEL PRIVATE LIMITED",
"TIRUPATI VINIYOGE PVT LTD",
"TIRUPATI VINYL INDIA PRIVATE LIMITED",
"TIRUPATI WELLNESS PRIVATE LIMITED",
"TIRUPATI WIRE PRIVATE LIMITED",
"TIRUPATI WOOD PRODUCTS (INDIA) PRIVATE LIMITED",
"TIRUPATI WORK SPACE SOLUTIONS PRIVATE LIMITED",
"TIRUPATIBAALAJI FIBERRS PRIVATE LIMITED",
"TIRUPATIBALAJI MILLS PRIVATE LIMITED",
"TIRUPATIS MINCHEM PRIVATE LIMITED",
"TIRUPTI PADDY PRODUCTS PRIVATE LIMITED",
"TIRUPTI POWDER PRIVATE LIMITED",
"TIRUPUR MEDICAL FOUNDATION PRIVATE LIMITED",
"TIRUPUR MURUGAMPALAYAM COMMON EFFLUENTS TREATMENT COMPANY PRIVATE LIMITED",
"TIRUPUR PANDIT HOSIERY MILLSS PRIVATE LIMITED",
"TIRUPUR TEXTILES PRIVATE LIMITED",
"TIRUPUR THIRUKUMARAN TEXTILES PRIVATE LIMITED",
"TIRUR MISSION HOSPITAL PRIVATE LIMITED",
"TIRUTTANI INFRALOG PRIVATE LIMITED",
"TIRUVALLA MEDICAL MISSION",
"TIRUVALLUR MUNICIPALITY",
"TIRUVARUR MEDICAL CENTRE PRIVATE LIMITED",
"TIRUVATEESWARAR HINDUS JONOPAKARA NIDHI LTD",
"TIRUVEN INFO TECH PRIVATE LIMITED",
"TIRVEN INDUSTRIES PRIVATE LIMITED",
"TIRWA COLD STORAGE PRIVATE LIMITED",
"TIS HAZARI COURT",
"TIS INDIA BUSINESS CONSULTANTS PRIVATE LIMITED",
"TIS INFRASTRUCTURE SERVICES PRIVATE LIMITED",
"TIS LABS PRIVATE LIMITED",
"TISA TECH SECURE PRIVATE LIMITED",
"TISCON REALTY PRIVATE LIMITED",
"TISH CONSULTANTS PRIVATE LIMITED",
"TISHA ENTERPRISES",
"TISHA FOODS AND PACKAGING PRIVATE LIMITED",
"TISHA ORGANICS PRIVATE LIMITED",
"TISHA SHIP MANAGEMENT PRIVATE LIMITED.",
"TISHMAN SPEYER INDIA PRIVATE LIMITED",
"TISMO TECHNOLOGY SOLUTIONS PRIVATE IMITED",
"TISSA POWER TRANSMISSION PRIVATE. LIMITED.",
"TISS-KGK SECURITY SYSTEMS PRIVATE LIMITED",
"TIST MEDIA PRIVATE LIMITED",
"TISTA AGENCIES PVT LTD",
"TISTA CREATIONS PRIVATE LIMITED",
"TISTA SALES PRIVATE LIMITED",
"TISTA VENEERS PRIVATE LIMITED",
"TISYA COOLING SOLUTIONS PRIVATE LIMITED",
"TISYA MONEY CHANGER PRIVATE LIMITED",
"TISYA SOFTWARE SOLUTIONS PRIVATE LIMITED",
"TITABAR ROLLER FLOUR MILLS PVT LTD",
"TITAGARH AGRICO PRIVATE LIMITED",
"TITAGARH ENTERPRISES LIMITED",
"TITAGARH RAIL SYSTEMS LIMITED",
"TITAN AERATION COMPANY PRIVATE LIMITED",
"TITAN BIOSCIENCE PRIVATE LIMITED",
"TITAN BIOTECH LIMITED",
"TITAN COMMODITY TRADING LIMITED",
"TITAN COMPANY LIMITED",
"TITAN CRUSHING MACHINERY PRIVATE LIMITED",
"TITAN ENGINEERING & AUTOMATION LIMITED",
"TITAN ENGINEERING PRIVATE LIMITED",
"TITAN HEALTHCARE PRIVATE LIMITED",
"TITAN INTECH LIMITED",
"TITAN LABORATORIES PRIVATE LIMITED",
"TITAN MEDIA LIMITED",
"TITAN PAINTS AND CHEMICALS LIMITED",
"TITAN SEA AND AIR SERVICES PRIVATE LIMITED.",
"TITAN SECURITIES LIMITED",
"TITAN STAINLESS INDIA PRIVATE LIMITED",
"TITAN STEELS PRIVATE LIMITED",
"TITAN TEX FAB PRIVATE LIMITED",
"TITAN TIMEPRODUCTS LIMITED",
"TITAN ZIP FASTENER INDUSTRIES PRIVATE LIMITED",
"TITANIA INFRATECH PRIVATE LIMITED",
"TITANIA MOTOCORP PRIVATE LIMITED",
"TITANIA PRODUCTS PRIVATE LIMITED",
"TITANIC FINANCE PRIVATE LIMITED",
"TITANIC OCEAN SERVICES PRIVATE LIMITED",
"TITANIC PHARMACEUTICALS PRIVATE LIMITED",
"TITANIC STEEL INDUSTRIES PRIVATE LIMITED",
"TITANICOM TECH INDIA PRIVATE LIMITED",
"TITANIUM EQUIPMENT & ANODE MANUFACTURING COMPANY PRIVATE LIMITED",
"TITANIUM EQUIPMENT AND ANODE MANUFACTURING COMPANY LIMITED",
"TITANIUM ESTATES PRIVATE LIMITED",
"TITANIUM LOGISPACE PRIVATE LIMITED",
"TITANIUM SECURITY & SERVICES PRIVATE LIMITED",
"TITANIUM TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"TITANIUM VITRIFIED PRIVATE LIMITED",
"TITAS AGRO PRODUCTS PRIVATE LIMITED",
"TIT-BIT FOODS INDIA PRIVATE LIMITED",
"TITBIT INTERACTIVE SYSTEMS PRIVATE LIMITED",
"TITE BEVERAGES PRIVATE LIMITED",
"TITHAL TRADING PRIVATE LIMITED",
"TITICO ENTERTAINMENTS PRIVATE LIMITED",
"TITICO EXPORTS PRIVATE LIMITED",
"TITIKSHA PUBLIC SCHOOL",
"TITLE DISPLAY SYSTEM PRIVATE LIMITED",
"TITLE GRAPHICS PRIVATE LIMITED",
"TITLE PRODUCTS PRIVATE LIMITED",
"TITLI GOLDS LIMITED",
"TITLI JEWELLERS PRIVATE LIMITED",
"TITTONS CARGO MANAGEMENT SYSTEMS PRIVATE LIMITED",
"TITU AND MAHENDRA TEX PRIVATE LIMITED",
"TITU LOGISTICS PRIVATE LIMITED",
"TITUPRINT PRIVATE LIMITED",
"TIU CONSULTING PRIVATE LIMITED",
"TIVO TECH PRIVATE LIMITED",
"TIVOLI INVESTMENT AND TRADING COMPANY PRIVATE LIMITED",
"TIVOLI PARK APARTMENTS PVT LTD",
"TIVONA AGRI PRIVATE LIMITED",
"TIVONA GLOBAL TECHNOLOGIES PRIVATE LIMITED",
"TIVRE BUSINESS SOLUTIONS PRIVATE LIMITED",
"TIVY FINANCE PVT LTD",
"TIWAM STAINLESS TUBES PRIVATE LIMITED",
"TIWANA OIL MILLS PRIVATE LIMITED",
"TIWARI AGRO INDUSTRIES PRIVATE LIMITED",
"TIWARI AUTOBIKES PRIVATE LIMITED",
"TIWARI AUTOMOBILES PRIVATE LIMITED",
"TIWARI COACH PRIVATE LIMITED",
"TIWARI PHARMA PRIVATE LIMITED",
"TIWARTA COAL BENEFICIATION LIMITED",
"TIX ECOSYSTEMS PRIVATE LIMITED",
"TIYA ENGINEERING AND ELECTRONICS PRIVATE LIMITED",
"TIYA TOURS & TRAVELS PRIVATE LIMITED",
"TIYAS CONSULTANCY AND INFRASTRUCTURE PRIVATE LIMITED",
"TJ DHARAM GLOBAL FOODS PRIVATE LIMITED",
"TJ MARINE PRODUCTS PRIVATE LIMITED",
"TJ SUSPENSION SYSTEMS PRIVATE LIMITED",
"TJC INDIA PRIVATE LIMITED",
"TJIKKO PRIVATE LIMITED",
"TJN CONSTRUCTION PRIVATE LIMITED",
"TJOHN GROUP OF INSTITUTION",
"TJS BEAUTY SECRETS (INDIA) PRIVATE LIMITED",
"TJS ENGINEERING COLLEGE",
"TJS POLYTECHNIC COLLEGE",
"TJSB SAHAKARI BANK LTD",
"TJSV STEEL FABRICATIONS & GALVANIZING I LIMITED",
"TJUK TRADE NETWORKS PRIVATE LIMITED",
"TJYN ENTERPRISES PRIVATE LIMITED",
"TK ELEVATOR INDIA PRIVATE LIMITED",
"TK INDIA PRIVATE LIMITED",
"TK INFRA PROJECTS INDIA PRIVATE LIMITED",
"TK INTERACTIVE PRIVATE LIMITED",
"TK SPORTS PRIVATE LIMITED",
"TKD AUTO TECHNOLOGIES PRIVATE LIMITED",
"TKG INDUSTRIES PRIVATE LIMITED",
"TKG INFRASTRUCTURES PRIVATE LIMITED",
"TKG SOLUTIONS PRIVATE LIMITED",
"TKL KNITS INDIA PRIVATE LIMITED",
"TKM BUSINESS SOLUTIONS PRIVATE LIMITED",
"TKM GLOBAL LOGISTICS LIMITED",
"TKM INFOTECH PRIVATE LIMITED",
"TKN ADVISORS PRIVATE LIMITED",
"TKR BUSINESS MEDIA PRIVATE LIMITED",
"TKS BEARING PRIVATE LIMITED",
"TKS PACWEL PRIVATE LIMITED",
"TKS PRODUCTS PRIVATE LIMITED",
"TKT GREENTEC PRIVATE LIMITED",
"TKT INTERIORS EXTERIORS PRIVATE LIMITED",
"TKV MARKETING INDIA PRIVATE LIMITED",
"TKW FASTNERS PRIVATE LIMITED",
"TKW MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"TKW SKILL DEVELOPMENT PRIVATE LIMITED",
"TL HOSPITALITY (I) PRIVATE LIMITED",
"TLC CHILDCARE SERVICES PRIVATE LIMITED",
"TLC DIGITECH PRIVATE LIMITED",
"TLC GETAWAYS PRIVATE LIMITED",
"TLC POLYMERS (INDIA) PRIVATE LIMITED",
"TLC PROPERTY ADVISORY PRIVATE LIMITED",
"TLC VEHICLE ASSIST PRIVATE LIMITED",
"TLD OVERSEAS PRIVATE LIMITED",
"TLE TECHNOLOGIES PRIVATE LIMITED",
"TLFCB PRIVATE LIMITED",
"TLG AGRO TRADERS PRIVATE LIMITED",
"TLG INDIA PRIVATE LIMITED",
"TLI SOFTWARE PRIVATE LIMITED",
"T-LINE INFRA PRIVATE LIMITED",
"TLM INSIDE SALES SUPPORT PRIVATE LIMITED",
"TLPC PACKAGING PRIVATE LIMITED",
"TLPL INTEGRATED SHIPPING SERVICES PRIVATE LIMITED",
"TLPL SHIPPING AND LOGISTICS PRIVATE LIMITED",
"TLS LOGISTICS PRIVATE LIMITED",
"TLS MERCANTILE PRIVATE LIMITED",
"TLT BABCOCK INDIA PRIVATE LIMITED",
"TLT ENGINEERING INDIA PVT LTD",
"TLT-TURBO INDIA PRIVATE LIMITED",
"TLV PACKAGING SOLUTIONS PRIVATE LIMITED",
"TLX TECH SOLUTIONS PRIVATE LIMITED",
"TM AUTOMOTIVE SEATING SYSTEMS PRIVATE LIMITED",
"TM BUILDING MATERIALS PRIVATE LIMITED",
"TM INPUTS AND SERVICES PRIVATE LIMITED",
"TM INTERNATIONAL LOGISTICS LIMITED",
"TM INVESTMENTS LIMITED",
"TM MOTORS PRIVATE. LIMITED.",
"TM MUSIC PRIVATE LIMITED",
"TM POWER LINE PRODUCTS PVT LTD.",
"TM PRINTERS PRIVATE LIMITED",
"TM SOFTECH PRIVATE LIMITED",
"TM SOLUTECH PRIVATE LIMITED",
"TM SOLUTIONS PRIVATE LIMITED",
"TM SYSTEMS PRIVATE LIMITED",
"TM VENTURES PRIVATE LIMITED",
"TMA INFRASTRUCTURE PRIVATE LIMITED",
"TMA INTERNATIONAL PRIVATE LIMITED",
"TMAES ACADEMY OF SCIENCE AND COMMERCE",
"TMAES AYURVEDA MEDICAL COLLEGE AND HOSPITAL",
"TMAP PROJECTS LLP",
"TMAXSOFT TECHNOLOGIES PRIVATE LIMITED",
"TMB BATTERY INDIA LLP",
"TMB BATTERY SOLUTIONS INDIA PRIVATE LIMITED",
"TMB SHIPPING PRIVATE LIMITED",
"TMB TAXFAB PRIVATE LIMITED",
"TMC EDUCATION DEPARTMENT",
"TMC ENTERPRISES PRIVATE LIMITED",
"TMC GLOBAL FORWARDING INDIA PRIVATE LIMITED",
"TMC INTELLECTUAL SERVICES PRIVATE LIMITED",
"TMC MEASURING INSTRUMENTS PVT LTD",
"TMC MINERAL RESOURCES PRIVATE LIMITED",
"TMC SHIPPING PRIVATE LIMITED",
"TMC TRANSFORMERS (INDIA) PRIVATE LIMITED",
"TMD EXPORTS PRIVATE LIMITED",
"TMEIC INDUSTRIAL SYSTEMS INDIA PRIVATE LIMITED",
"TMERCHANDISING SERVICES PRIVATE LIMITED",
"TMF SERVICES INDIA PRIVATE LIMITED",
"TMG BUSINESS SOLUTIONS INDIA PRIVATE LIMITED",
"TMI E2E ACADEMY PRIVATE. LIMITED",
"TMI HEALTHCARE PRIVATE LIMITED",
"TMI STAFFING SERVICES PRIVATE LIMITED",
"TMKI MACHINE PARTS PRIVATE LIMITED",
"TML BUSINESS SERVICES LIMITED",
"TML DISTRIBUTION COMPANY LIMITED",
"TML DRIVELINES LIMITED",
"TML INDIA PRIVATE LIMITED",
"TML INDUSTRIES LIMITED",
"TMMS SOLUTIONS PRIVATE LIMITED",
"TMN PARKS PRIVATE LIMITED",
"TMOTIONS GLOBAL PRIVATE LIMITED",
"TMP WORLDWIDE INDIA PRIVATE LIMITED",
"TMR DEVELOPERS PRIVATE LIMITED",
"TMR INFRA PRIVATE LIMITED",
"TMS ALOXIN GLOBAL MANUFACTURING PRIVATE LIMITED",
"TMS ENGINEERS PRIVATE LIMITED",
"TMS FASHION DELHI PRIVATE LIMITED",
"TMS INDIA PRIVATE LIMITED",
"TMS INFONET PRIVATE LIMITED",
"TMS TECHNOV M SYSTEMS PRIVATE LIMITED",
"TMSQUARE GLOBAL SOLUTIONS PRIVATE LIMITED",
"TMSTULSI MEDSCIENCES PRIVATE LIMITED",
"TMT COLD STORAGE PRIVATE LIMITED",
"TMT CONNEKT INDIA PRIVATE LIMITED",
"TMT GRANITES PRIVATE LIMITED",
"TMT LOGISTICS PRIVATE LIMITED",
"TMT POLYMERS INDIA PRIVATE LIMITED",
"TMTE METAL TECH PRIVATE LIMITED",
"TMTR PEOPLE SOLUTIONS PRIVATE LIMITED",
"TMVT INDUSTRIES PRIVATE LIMITED",
"TMX PRECISION TOOLING INDIA PRIVATE LIMITED",
"TN (DK) EXPRESSWAYS LIMITED",
"TN INDIA PRIVATE LIMITED",
"TN INFOTECH PRIVATE LIMITED",
"TN OXYGEN PRIVATE LIMITED",
"TN PACKAGING PRIVATE LIMITED",
"TN SINGH (JV) PRIVATE LIMITED",
"TN SOLAR POWER ENERGY PRIVATE LIMITED",
"TN URJA PRIVATE LIMITED",
"TNA READYMIX INDIA PRIVATE LIMITED",
"TNAGAR SHOBA SILKS PRIVATE LIMITED",
"TNBI INDUSTRIES PRIVATE LIMITED",
"TNC AVIATION PRIVATE LIMITED",
"TNE AAC PRIVATE LIMITED",
"TNEB",
"TNET MESSAGING SERVICES PRIVATE LIMITED",
"TN-EXCELUS PRIVATE LIMITED",
"TNG INNOVATION LABS PRIVATE LIMITED",
"T-NINE LOGISTICS PRIVATE LIMITED",
"TNL LOGISTICS PRIVATE LIMITED",
"TNL TRANS LOGISTICS PRIVATE LIMITED",
"TNM GENIE PRIVATE LIMITED",
"TNM MEDIA PRIVATE LIMITED",
"TNM SOFTWARE SOLUTIONS PRIVATE LIMITED",
"TNP CLOUDIUM PRIVATE LIMITED",
"TNP CONSULTANCY PRIVATE LIMITED",
"TNP SEAFOODS PRIVATE LIMITED",
"TNQ BOOKS AND JOURNALS PRIVATE LIMITED",
"TNR - PRESTON PROJECTS LLP",
"TNR ESTATES PRIVATE LIMITED",
"TNS AUDIO GUYS PRIVATE LIMITED",
"TNS AUTOMOBILES PRIVATE LIMITED",
"TNS EXPRESS PRIVATE LIMITED",
"TNS HEAVY ENGINEERING PRIVATE LIMITED",
"TNS LOGI-PARK PRIVATE LIMITED",
"TNS MOBILE INDIA PRIVATE LIMITED",
"TNS NETWORKING SOLUTIONS PRIVATE LIMITED",
"TNS SAFETY PRIVATE LIMITED",
"TNS TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"TNSI RETAIL PRIVATE LIMITED",
"TNST COMPONENT INDIA PRIVATE LIMITED",
"TNSTC",
"TNT BUSINESS SERVICES PRIVATE LIMITED",
"TNT INDIA PRIVATE LIMITED",
"TNV CERTIFICATION PRIVATE LIMITED",
"TNV SYSTEM CERTIFICATION PRIVATE LIMITED",
"TNW INTERNATIONAL PRIVATE LIMITED",
"TNX CONTINENTAL PRIVATE LIMITED",
"TO THE NEW PRIVATE LIMITED",
"TOABH CREATIVE AGENCY PRIVATE LIMITED",
"TOABH MANAGEMENT PRIVATE LIMITED",
"TOADFLY TECHNICAL SERVICES PRIVATE LIMITED",
"TOAST EVENTS PRIVATE LIMITED",
"TOBACCO BOARD",
"TOBACCO VISION PRIVATE LIMITED",
"TOBEN LOGISTICS SOLUTIONS PRIVATE LIMITED",
"TOBOX VENTURES PRIVATE LIMITED",
"TOBU INDUSTRIES PVT LTD",
"TOBUSOL MANAGEMENT SERVICES PRIVATE.LIMITED",
"TOC TECH INDIA PRIVATE LIMITED",
"TOCCO CERAMIC PRIVATE LIMITED",
"TOCH PUBLIC SCHOOL",
"TOCHEUNGLEE STATIONERY MFG CO PRIVATE LIMITED",
"TOCODE TECHNOLOGIES PRIVATE LIMITED",
"TOCOL MACHINE TOOLS",
"TOD INNOVATIONS PRIVATE LIMITED",
"TODAS FOODS PRIVATE LIMITED",
"TODAY ADVERTISING PRIVATE LIMITED",
"TODAY CLEAN ENERGY PRIVATE LIMITED",
"TODAY FOILS PRIVATE LIMITED",
"TODAY FOOTWEAR PRIVATE LIMITED",
"TODAY HOTELS NEW DELHI PRIVATE LIMITED",
"TODAY HOTELS PRIVATE LIMITED",
"TODAY MERCHANDISE PRIVATE LIMITED",
"TODAY REALTY PRIVATE LIMITED",
"TODAY SYNTHETICS PRIVATE LIMITED",
"TODAY TEA LIMITED",
"TODAYINDIA PHARMACEUTICALS PRIVATE LIMITED",
"TODAYS ARCHITECTS PRIVATE LIMITED",
"TODAY'S GLOBAL CROP PROTECTION",
"TODAYS HEALTHCARE INDIA PRIVATE LIMITED",
"TODAY'S HEALTHCARE INDIA PRIVATE LIMITED",
"TODAYTEC INDIA PRIVATE LIMITED",
"TODDLERS ACTIVITY CENTRE PRIVATE LIMITED",
"TODDLERS NURSERY",
"TODDLERS RETAIL INDIA PRIVATE LIMITED",
"TODDLER'S WORLD SCHOOL",
"TODEZ CREATION PRIVATE LIMITED",
"TODI BULK CARRIERS PRIVATE LIMITED",
"TODI CONSTRUCTIONS PVT LTD",
"TODI INDUSTIRES PRIVATE LIMITED",
"TODI INVESTORS (INDIA) PRIVATE LIMITED",
"TODI MINERALS PRIVATE LIMITED",
"TODI RAYONS PRIVATE LIMITED",
"TODI SECURITIES PRIVATE LIMITED",
"TODINI METALS AND CHEMICALS INDIA PRIVATE LIMITED",
"TODKAR SANJEEVANI NISARGOPCHAR KENDRA PRIVATE LIMITED",
"TODS RETAIL INDIA PRIVATE LIMITED",
"TODY BROTHERS PRIVATE LIMITED",
"TOE NETWORKS INDIA PRIVATE LIMITED",
"TOE TECH ENGINEERS PRIVATE LIMITED",
"TOEHOLD TRAVEL AND PHOTOGRAPHY PRIVATE LIMITED",
"TOFFEE PRIVATE LIMITED",
"TOFFLON INDIA PRIVATE LIMITED",
"TOFFUX INDIA PRIVATE LIMITED",
"TOGETHER FITNESS PRIVATE LIMITED",
"TOGGLE FASHION PRIVATE LIMITED",
"TOGGLEHEAD DIGITAL PRIVATE LIMITED",
"TOGGLENOW SOFTWARE SOLUTIONS PRIVATE LIMITED",
"TOGGLR SOLUTIONS PRIVATE LIMITED",
"TOHOKU STEEL INDIA PRIVATE LIMITED",
"TOILETS AND TOILETS PRIVATE LIMITED",
"TOJA TYRE AND TREADS PVT LTD",
"TOJO VIKAS INTERNATIONAL PRIVATE LIMITED",
"TOKAI ENGINEERING PRIVATE LIMITED",
"TOKAI IMPERIAL HYDRAULICS INDIA PRIVATE LIMITED",
"TOKAI IMPERIAL RUBBER INDIA PRIVATE LIMITED",
"TOKAI RIKA MINDA INDIA PRIVATE LIMITED",
"TOKAI RUBBER AUTO-PARTS INDIA PRIVATE LIMITED",
"TOKHEIM INDIA PRIVATE LIMITED",
"TOKIO MARINE & NICHIDO FIRE INSURANCE CO LIMITED",
"TOKITA SEED INDIA PRIVATE LIMITED",
"TOKOPEDIA INDIA PRIVATE LIMITED",
"TOKYO CONSULTING FIRM PRIVATE LIMITED",
"TOKYO ELECTRIC POWER SERVICES COMPANY LIMITED",
"TOKYO PLAST INTERNATIONAL LIMITED",
"TOKYO ZAIRYO (INDIA) PRIVATE LIMITED",
"TOL INNOVATIONS PRIVATE LIMITED",
"TOLA RAM SATYA DEV AGRO PRIVATE LIMITED",
"TOLANI COLLEGE OF COMMERCE",
"TOLANI EDUCATION FOUNDATION",
"TOLANI PIPES PRIVATE LIMITED",
"TOLANI PROJECTS PRIVATE LIMITED",
"TOLANI SHIPPING COMPANY LIMITED",
"TOLAR OCEAN PRODUCTS PRIVATE LIMITED",
"TOLBURN MANAGEMENT SERVICES PRIVATE LIMITED",
"TOLEXO ONLINE PRIVATE LIMITED",
"TOLIA CARBIDES PRIVATE LIMITED",
"TOLIN RUBBERS PRIVATE LIMITED",
"TOLINS PURE FOODS PRIVATE LIMITED",
"TOLINS TREAD INDIA PRIVATE LIMITED",
"TOLINS TYRES LIMITED",
"TOLL GLOBAL FORWARDING INDIA PRIVATE LIMITED",
"TOLL INDIA LOGISTICS PRIVATE LIMITED",
"TOLLMAN INTERNATIONAL PRIVATE LIMITED",
"TOLLYGUNGE CLUB LTD",
"TOLLYGUNGE GIRISH CHANDRA INSTITUTION",
"TOLSONS PIPES AND PROFILES PRIVATE LIMITED",
"TOLUNA INDIA PRIVATE LIMITED",
"TOM BURG FASHIONS PRIVATE LIMITED",
"TOMAR AVIATION PRIVATE LIMITED",
"TOMAR BUILDERS AND CONTRACTORS PRIVATE LIMITED",
"TOMAR CIVILTECH PRIVATE LIMITED",
"TOMAR ICE AND COLD STORAGE PRIVATE LIMITED",
"TOMAR MULTYSPECIALITY HOSPITAL",
"TOMAR SALES AND SERVICES PRIVATE LIMITED",
"TOMASETTO ACHILLE INDIA PRIVATE LIMITED",
"TOMCO ENGINEERING PRIVATE LIMITED",
"TOMEN ELECTRONICS INDIA PRIVATE LIMITED",
"TOMER ADVISORY PRIVATE LIMITED",
"TOMER ENGINEERING WORKS PRIVATE LIMITED",
"TOMER ESTATE PRIVATE LIMITED",
"TOMMORROWLAND LIMITED",
"TOMMY HILFIGER ARVIND FASHION PRIVATE LIMITED",
"TOMOE SPECIALTY GAS AND CHEMICALS INDIA PRIVATE LIMITED",
"TOMORROW CAPITAL ENTERPRISES PRIVATE LIMITED",
"TOMORROW COMPANIES IN PRIVATE LIMITED",
"TOMORROWLAND APPARELS PRIVATE LIMITED",
"TOMORROWS MARKET INNOVATORS PRIVATE LIMITED",
"TOMORROWS SALES AGENCY PVT LTD",
"TOMRA SORTING INDIA PRIVATE LIMITED",
"TOMS MOTORS PRIVATE LIMITED",
"TOMS PIPES PRIVATE LIMITED",
"TOMSON MEDICARE PRIVATE LIMITED",
"TOMTOM INDIA PRIVATE LIMITED",
"TONBO IMAGING INDIA PRIVATE LIMITED",
"TONBO IMAGING PRIVATE LIMITED",
"TONCHI EXPORTS PRIVATE LIMITED",
"TONDVALKAR VIDYANIDHI PRI SECTION DOMBIVALI",
"T-ONE TOOLS PRIVATE LIMITED",
"TONERLINE PRIVATE LIMITED",
"TONG GARDEN FOOD MARKETING (INDIA) PRIVATE LIMITED",
"TONG GARDEN FOOD MARKETING INDIA PRIVATE LIMITED",
"TONG GARDEN FOOD PRODUCTS (INDIA) PRIVATE LIMITED",
"TONG I HSING LIGHT INDUSTRIAL PRIVATE LIMITED",
"TONGANAGAON TEA CO PVT LTD",
"TONGANI TEA COMPANY LIMITED",
"TONGIA HEART GENERAL HOSPITAL",
"TONGLIT AUTOGISTIC PRIVATE LIMITED",
"TONGUE & TASTE FOODS LIMITED",
"TONGUESTUN FOOD NETWORK PRIVATE LIMITED",
"TONGYA RESORTS PRIVATE LIMITED",
"TONI INDUSTRIES PRIVATE LIMITED",
"TONIA ESTATE AND RESORTS PRIVATE LIMITED",
"TONIC MEDIA DIGITAL PRIVATE LIMITED.",
"TONICO MEDIA PRIVATE LIMITED",
"TONIK FINANCIAL INDIA PRIVATE LIMITED",
"TONIKA AGROS (INDIA) PRIVATE LIMITED",
"TONIQ RETAIL BRANDS PRIVATE LIMITED",
"TONK WATER SUPPLY LIMITED",
"TONTECH ENGINEERS PRIVATE LIMITED",
"TOOBA PHARMACEUTICALS PRIVATE LIMITED",
"TOOBLER TECHNOLOGIES PRIVATE LIMITED",
"TOOKITAKI TECHNOLOGIES PRIVATE LIMITED",
"TOOL FAB ENGINEERING PRIVATE LIMITED - TRICHY",
"TOOL HOLDERS PRIVATE LIMITED",
"TOOL MAKER & ASSOCIATES PRIVATE LIMITED.",
"TOOL TECH COMPONENTS PRIVATE LIMITED",
"TOOLAGEN TECHNOLOGY SERVICES PRIVATE LIMITED",
"TOOLBOX ANIMATION STUDIO PRIVATE LIMITED",
"TOOLCART INDIA BANGALORE",
"TOOLCOMP SYSTEMS PRIVATE LIMITED",
"TOOLCRAFT MACHINING SOLUTIONS",
"TOOLEX ENGINEERS PRIVATE LIMITED",
"TOOLING PLANET PRIVATE LIMITED",
"TOOLMAN SPECIAL STEELS PRIVATE LIMITED",
"TOOLMECH PRIVATE LIMITED",
"TOOLMETRICS ENGINEERS PRIVATE LIMITED",
"TOOLS AND SOLUTIONS GLOBAL PRIVATE LIMITED",
"TOOLS MARCOM PRIVATE LIMITED",
"TOOLS TRADERS TURBHE PRIVATE LIMITED",
"TOOLTECH GLOBAL ENGINEERING PRIVATE LIMITED",
"TOOLTECH INDIA PRIUVATE LIMITED",
"TOOLTECH METFORMS INDIA PRIVATE LIMITED",
"TOOL-TECH MOULDS & MOULDING PRIVATE LIMITED",
"TOOLZILLA MARKETING PRIVATE LIMITED",
"TOONBRANDS SOLUTIONS PRIVATE LIMITED",
"TOONMEDIA CONSULTING PRIVATE LIMITED",
"TOONZ ANIMATION INDIA PRIVATE LIMITED",
"TOOR FINANCE COMPANY LIMITED",
"TOOR SALES PRIVATE LIMITED",
"TOORSA TEA COMPANY PVT LTD",
"TOOT MNE TECH PRIVATE LIMITED",
"TOOTH MOUNTAIN HOSPITALITY PRIVATE LIMITED",
"TOP APPARELS PVT LTD",
"TOP BUSINESS CONSULTANCY SERVICES PRIVATE LIMITED",
"TOP CASHEW PRIVATE LIMITED",
"TOP CLASS CAPITAL MARKETS PRIVATE LIMITED",
"TOP CRANE SYSTEM PRIVATE LIMITED",
"TOP EQUIPMENT AND MACHINES PRIVATE LIMITED",
"TOP FORCE SECURITY SOLUTIONS INDIA PRIVATE LIMITED",
"TOP GEAR CARS PRIVATE LIMITED",
"TOP GEAR METALS PRIVATE LIMITED",
"TOP GEAR MOTORS PRIVATE LIMITED",
"TOP GEAR TRANSMISSION PRIVATE LIMITED",
"TOP GLOBAL SECURITAS PRIVATE LIMITED",
"TOP GROW EXIM PRIVATE LIMITED",
"TOP GUARDING SERVICES PRIVATE LIMITED",
"TOP HOME CONCEPTS PRIVATE LIMITED",
"TOP HYBRID SEEDS PRIVATE LIMITED",
"TOP IMPEX PRIVATE LIMITED",
"TOP INDIA ELEVATOR PRIVATE LIMITED",
"TOP INDUSTRY SECURITY PRIVATE LIMITED",
"TOP LIGHT FABRICS PRIVATE LIMITED",
"TOP LIGHT RENEWABLE ENERGY PRIVATE LIMITED",
"TOP LIGHT TEXTILES PRIVATE LIMITED",
"TOP LINE TEA CO. PRIVATE LIMITED",
"TOP LINE WRITING INSTRUMENTS PRIVATE LIMITED",
"TOP MANPOWER MANAGMENT SERVICES PRIVATE LIMITED",
"TOP METALS LIMITED",
"TOP MOTOCOMPONENTS PRIVATE LIMITED",
"TOP NAMKEEN INDUSTRIES PRIVATE LIMITED",
"TOP NOTCH HOSPITALITY PRIVATE LIMITED",
"TOP OCEAN CARGO MOVEMENTS PRIVATE LIMITED",
"TOP PEARL EXIM PRIVATE LIMITED",
"TOP PLYWOODS PRIVATE LIMITED",
"TOP PRODUCTS INDIA PRIVATE LIMITED",
"TOP RANKERS ACADEMY",
"TOP RESEARCH HICROP (INDIA) PRIVATE LIMITED",
"TOP STORY MEDIA PRIVATE LIMITED",
"TOP TEAM MACHINES PRIVATE LIMITED",
"TOP TECH STEELS PRIVATE LIMITED",
"TOP TECHNOLOGIES PRIVATE LIMITED",
"TOP TOOLS PRIVATE LIMITED",
"TOP TRAVEL AND TOURS PRIVATE LIMITED",
"TOP VICTORY INVESTMENTS LIMITED",
"TOPACK CERAMICS PRIVATE LIMITED",
"TOPAIM PROPERTIES PRIVATE LIMITED",
"TOPAZ AUTO ENTERPRISES PRIVATE LIMITED",
"TOPAZ FIRE SYSTEMS PRIVATE LIMITED",
"TOPAZ INTERNATIONAL",
"TOPAZ PRODUCTS PRIVATE LIMITED",
"TOPAZ TEXCHEM PRIVATE LIMITED",
"TOPBAND INDIA PRIVATE LIMITED",
"TOPBATH FIXTURES PRIVATE LIMITED",
"TOPBELLS HR SOLUTIONS PRIVATE LIMITED",
"TOPCLASS SECURITY AND ALLIED SERVICES PRIVATE LIMITED",
"TOPCON CONSULTING SERVICES",
"TOPCON SOKKIA INDIA PRIVATE LIMITED",
"TOPD ALLIANCE PRIVATE LIMITED",
"TOPDOM MARKETING PRIVATE LIMITED",
"TOPECT INTERNATIONAL PRIVATE LIMITED",
"TOPEX ELECTRIC INDUSTRIES PRIVATE LIMITED",
"TOPFLITE COMPONENTS PRIVATE LIMITED",
"TOPFLOW CONSTRUCTIONS PRIVATE LIMITED",
"TOPFRESH INTERNATIONAL PRIVATE LIMITED",
"TOPGAIN FINANCE PRIVATE LIMITED",
"TOPGEAR CONSULTANTS PRIVATE LIMITED",
"TOPGRADE MANPOWER AND SECURITY SERVICES INDIA PRIVATE LIMITED",
"TOPGRAIN FLOUR AND FOODS PRIVATE LIMITED",
"TOPGRAIN TEA PRIVATE LIMITED",
"TOPGUN CORPORATE SERVICES PRIVATE LIMITED",
"TOPHATTER SOFTWARE INDIA PRIVATE LIMITED",
"TOPHILL PHARMA LIMITED",
"TOPINTOWN IMPEX AND TRADES KERALA PRIVATE LIMITED",
"TOPIOX RESEARCH CENTRE PRIVATE LIMITED",
"TOPLAND CERAMIC PRIVATE LIMITED",
"TOPLAND ENGINES PRIVATE LIMITED",
"TOPLAND PUMPS PRIVATE LIMITED",
"TOPLIGHT CORPORATE MANAGEMENT PRIVATE LIMITED",
"TOPLIGHT MERCHANTILES PVT.LTD.",
"TOPLINE BUSINESS SUPPORT SOLUTIONS PRIVATE LIMITED",
"TOPLINE CERAMICS PRIVATE LIMITED",
"TOPLINE COLD CHAIN PRIVATE LIMITED",
"TOPLINE COMMODITIES PVT LTD",
"TOPLINE ELECTRONICS PRIVATE LIMITED",
"TOPLINE INDUSTRIES PRIVATE LIMITED",
"TOPLINE INFRA PROJECTS PRIVATE LIMITED",
"TOPLINE LAMINATION PRIVATE LIMITED",
"TOPLINE LOGISTICS PARK PRIVATE LIMITED",
"TOPLINE PRINT MEDIA PRIVATE LIMITED",
"TOPLINE PRODUCTS PRIVATE LIMITED",
"TOPLINE SOLUTIONS PRIVATE LIMITED",
"TOPLINE SWITCHGEAR PRIVATE LIMITED",
"TOPLINE VINIMAY PVT LTD",
"TOPLINK MOTORS PRIVATE LIMITED",
"TOPLLER FASHIONS (INDIA) PRIVATE LIMITED",
"TOPLLER LIFESTYLE FASHIONS PRIVATE LIMITED",
"TOPMAN EXPORTS LIMITED",
"TOPMAN FASHION PRIVATE LIMITED",
"TOPMAN INTERNATIONAL LIMITED",
"TOPMIND COMMUNICATION PRIVATE LIMITED",
"TOPMODULE INTERIORS PRIVATE LIMITED",
"TOPNOTCH CHEMICALS PVT LTD",
"TOPNOTCH ENGINEERING SERVICES PRIVATE LIMITED",
"TOP-NOTCH FASHION PRIVATE LIMITED",
"TOPNOTCH PROJECTS PRIVATE LIMITED",
"TOPNOTCH RETAIL PRIVATE LIMITED",
"TOPNOTCH SOFTSOL INDIA PRIVATE LIMITED",
"TOPNOTCH TRADING CORPORATION PRIVATE LIMITED",
"TOPNTOE E-COMMERCE INDIA PRIVATE LIMITED",
"TOPPAN MERRILL TECHNOLOGY SERVICES PRIVATE LIMITED",
"TOPPAN SPECIALITY FILMS PRIVATE LIMITED",
"TOPPEQ TECH PRIVATE LIMITED",
"TOPPER & ROUTER LOGISTICS PRIVATE LIMITED",
"TOPPERS TUTORIAL PRIVATE LIMITED",
"TOPPERSEDGE.COM INDIA PRIVATE LIMITED",
"TOPRE INDIA PRIVATE LIMITED",
"TOPRUN AUTOMOTIVE INDIA PRIVATE LIMITED",
"TOPS AIR AND SEA MASTERS PVT LTD",
"TOPS INFOSOLUTIONS PRIVATE LIMITED",
"TOPS NIGHT PATROLLING PRIVATE LIMITED",
"TOPS SECURITY LIMITED",
"TOPS TECHNOLOGIES PRIVATE LIMITED",
"TOPSACK PACKAGING PRIVATE LIMITED",
"TOPSAIL APPLIANCES PRIVATE LIMITED",
"TOPSAIL FINTECH PRIVATE LIMITED",
"TOPSCOUT DIGITAL PRIVATE LIMITED",
"TOPSE PROCESS SOLUTIONS PRIVATE LIMITED",
"TOPSEED ENGINEERING PRIVATE LIMITED",
"TOPSEL MARKETING PVT.LTD.",
"TOPSEL PVT LTD",
"TOPSEL SERVICES PRIVATE LIMITED",
"TOPSERV INFOTECH PRIVATE LIMITED",
"TOPSGRUP RISK INTELLIGENCE PRIVATE LIMITED",
"TOPSHIELD SECURITY SERVICES PRIVATE LIMITED",
"TOPSIA ESTATES PVT LTD",
"TOPSLINE LIFE RESPONSE SERVICES PRIVATE LIMITED",
"TOPSOURCE INFOTECH SOLUTIONS PRIVATE LIMITED",
"TOPSOURCE SUPPORT SERVICES PRIVATE LIMITED",
"TOPSPARES PRIVATE LIMITED",
"TOPSTAR ELECTRODES ( INDIA ) PRIVATE LIMITED",
"TOPSTAR INFRA PROJECTS PRIVATE LIMITED",
"TOPSTAR SUPPLIERS PRIVATE LIMITED",
"TOPSTARS HOSPITALS PRIVATE LIMITED",
"TOPSWA LOGISTICS PRIVATE LIMITED",
"TOPSYS SOLUTIONS PRIVATE LIMITED",
"TOP-TECH CEMENT CO. PRIVATE LIMITED",
"TOP-TEN SOFTWARE PVT.LTD.",
"TOPTIME CONSUMER PRIVATE LIMITED",
"TOPULENT HYPERMARKET PRIVATE LIMITED",
"TOPVIEW INFRATECH INDIA PRIVATE LIMITED",
"TOPVISION ENGINEERING INDIA PRIVATE LIMITED",
"TOPWELL APPARELS PRIVATE LIMITED",
"TOPWHEELZ AUTOMOTIVE PRIVATE LIMITED",
"TOPWORTH TOLLWAYS MANGAWAN PRIVATE LIMITED",
"TOPYA INDIA PRIVATE LIMITED",
"TOQFACTOR TECHNOLOGIES PRIVATE LIMITED",
"TOQSOFT TECHNOLOGIES PRIVATE LIMITED",
"TOQUE CONTENT SOLUTIONS PRIVATE LIMITED",
"TORADEX SYSTEMS INDIA PRIVATE LIMITED",
"TORAH SHIPPING AND LOGISTICS PRIVATE LIMITED",
"TORAL SYNTHETICS PVT LTD",
"TORAM CREATORS PRIVATE LIMITED",
"TORAM EXPORTS PRIVATE LIMITED",
"TORAN IMITATION JEWELLERY PRIVATE LIMITED",
"TORANA ENTERPRISES PRIVATE LIMITED",
"TORANA SAGAR MADHYAMIK VIDYALAY TAL VELHE",
"TORANCE HEALTH CARE PRIVATE LIMITED",
"TORANE ISPAT UDYOG PRIVATE LIMITED",
"TORAS SOLUTIONS PRIVATE LIMITED",
"TORAY INDUSTRIES INDIA PRIVATE LIMITED",
"TORAY INTERNATIONAL INDIA PRIVATE LIMITED",
"TORAY KUSUMGAR ADVANCED TECTILE PRIVATE LIMITED",
"TORC STAR BOLTING TOOLS PRIVATE LIMITED",
"TORCH SECURITY FORCE PRIVATE LIMITED",
"TORCHIT ELECTRONICS PRIVATE LIMITED",
"TORCHTAR MEMBRANES & BITUMEN PRODUCTS PRIVATE LIMITED",
"TORCIUM BIOTECH PRIVATE LIMITED",
"TORENZO TECHNOLOGIES PRIVATE LIMITED",
"TORERO CAPITAL PRIVATE LIMITED",
"TORERO CORPORATION PRIVATE LIMITED",
"TORERO SOFTWARES LIMITED",
"TORETO RETAIL PRIVATE LIMITED",
"TOREX INTERIORS PRIVATE LIMITED",
"TORFAC INDIA PRIVATE LIMITED",
"TORFENSTER SYSTEMS INDIA PRIVATE LIMITED",
"TORG INDIA PRIVATE LIMITED",
"TORGY MEK INDIA PRIVATE LIMITED",
"TORINO CERAMIC PRIVATE LIMITED",
"TORINO LABORATORIES PRIVATE LIMITED",
"TORISHIMA PUMPS INDIA PRIVATE LIMITED",
"TORK MOTORS PRIVATE LIMITED",
"TORM SHIPPING INDIA PRIVATE LIMITED",
"TORNA ENGINEERING COMPANY PRIVATE LIMITED",
"TORNADO SOLARFARMS LIMITED",
"TORO HEALTH PRIVATE LIMITED",
"TOROID TECHNOLOGIES PRIVATE LIMITED",
"TORONTO CERAMIC PRIVATE LIMITED",
"TORO-ORSO CAPITAL PRIVATE LIMITED",
"TOROTECH PROJECTS PRIVATE LIMITED",
"TORPEDO SHOES PRIVATE LIMITED",
"TORQ 03 SPORTS & ADVENTURES PRIVATE LIMITED",
"TORQ COMMODITIES PRIVATE LIMITED",
"TORQBOLT PRIVATE LIMITED",
"TORQON POWER DRIVES PRIVATE LIMITED",
"TORQUE COMMERCIAL VEHICLES PRIVATE LIMITED",
"TORQUE COMMUNICATIONS PRIVATE LIMITED",
"TORQUE MASTER TOOLS PRIVATE LIMITED",
"TORQUE MINERALS PRIVATE LIMITED",
"TORQUE PHARMACEUTICALS PRIVATE LIMITED",
"TORQUS SYSTEMS PRIVATE LIMITED",
"TORRAUTOMATION SYSTEMS PRIVATE LIMITED",
"TORRECID INDIA PRIVATE LIMITED",
"TORREL COSMETICS PRIVATE LIMITED",
"TORRENT ELECTRICALS PRIVATE LIMITED",
"TORRENT FINCORP PRIVATE LIMITED",
"TORRENT GAS CHENNAI PRIVATE LIMITED",
"TORRENT GAS LIMITED",
"TORRENT GAS PRIVATE LIMITED",
"TORRENT INDUSTRY PRIVATE LIMITED",
"TORRENT INVESTMENTS PRIVATE LIMITED",
"TORRENT MINECHEM PRIVATE LIMITED",
"TORRENT MINERALS PRIVATE LIMITED",
"TORRENT PHARMACEUTICALS LTD",
"TORRENT POWER GRID LIMITED",
"TORRENT POWER LIMITED",
"TORRENT SAURYA URJA 6 PRIVATE LIMITED",
"TORRENT SOLARGEN LIMITED",
"TORRENT URJA 7 PRIVATE LIMITED",
"TORRES NETWORKS INDIA PRIVATE LIMITED",
"TORRES REMEDIES PRIVATE LIMITED",
"TORREX VENTURES LIMITED",
"TORRID SOLAR POWER PRIVATE LIMITED",
"TORRINS ANTHEM PRIVATE LIMITED",
"TORRVIS PHARMACEUTICALS PRIVATE LIMITED",
"TORRY HARRIS BUSINESS SOLUTIONS PRIVATE LIMITED",
"TORRY HARRIS RESTAURANTS PRIVATE LIMITED",
"TORRY HARRIS SEAFOODS PRIVATE LTD",
"TORSA MACHINES LIMITED",
"TORTEK INDIA PRIVATE LIMITED",
"TORTOISE CLOUD SOLUTIONS PRIVATE LIMITED",
"TORTOISE SYSTEMS PRIVATE LIMITED",
"TORUS FINANCIAL MARKETS PRIVATE LIMITED",
"TORUS ROBOTICS PRIVATE LIMITED",
"TORUS SYNERGY SERVICES PRIVATE LIMITED",
"TORWAY PHARMACIA PRIVATE LIMITED",
"TORZEL HINDUSTAN PRIVATE LIMITED",
"TOS FACILITIES MANAGEMENT PRIVATE LIMITED",
"TOS HEAVY ENGINEERING PRIVATE LIMITED",
"TOSALL INDIA PRIVATE LIMITED",
"TOSAWAR JEWELLERY PRIVATE LIMITED",
"TOSBS INDIA PRIVATE LIMITED",
"TOSCANA MERCANTILE PRIVATE LIMITED",
"TOSCANO INFRASTRUCTURE PRIVATE LIMITED",
"TOSCO PHARMA PRIVATE LIMITED",
"TOSCO PHARMACHEM PRIVATE LIMITED",
"TOSEI ENGINEERING PRIVATE LIMITED",
"TOSH HOSPITALS PRIVATE LIMITED",
"TOSH INNOVATIONS PRIVATE LIMITED",
"TOSHALI CEMENTS PRIVATE LIMITED",
"TOSHALI HEALTH CARE SERVICE PRIVATE LIMITED",
"TOSHALI LOGISTICS PRIVATE LIMITED",
"TOSHALI RESORTS INTERNATIONAL",
"TOSHAMIYA JUTE COMPANY PRIVATE LIMITED",
"TOSHAN SEEDS PRIVATE LIMITED",
"TOSHANI INDUSTRIES PRIVATE LIMITED",
"TOSHANI PREMIUM DIGITAL SERVICES PRIVATE LIMITED",
"TOSHANI VENTURES PRIVATE LIMITED",
"TOSHBRO CONTROLS PRIVATE LIMITED",
"TOSHBRO MEDICALS PRIVATE LIMITED",
"TOSHCON CD AUTOMATION ( INDIA) PRIVATE LIMITED",
"TOSHCON JESCO (INDIA) PRIVATE LIMITED",
"TOSHEE INDUSTRIES PRIVATE LIMITED",
"TOSHI OUTSOURCING SOLUTION PRIVATE LIMITED",
"TOSHIBA CARRIER AIR CONDITIONING INDIA PRIVATE LIMITED",
"TOSHIBA INDIA PRIVATE LIMITED",
"TOSHIBA JOHNSON ELEVATORS INDIA PRIVATE LIMITED",
"TOSHIBA JSW POWER SYSTEMS PRIVATE.LIMITED.",
"TOSHIBA LOGISTICS INDIA PRIVATE LIMITED",
"TOSHIBA PLANT SYSTEMS AND SERVICES CORPORATION",
"TOSHIBA SOFTWARE INDIA PRIVATE LIMITED",
"TOSHIBA TRANSMISSION DISTRIBUTION SYSTEMS INDIA PRIVATE LIMITED",
"TOSHIBA WATER SOLUTIONS & SERVICES PRIVATE LIMITED",
"TOSHIBA WATER SOLUTIONS PRIVATE LIMITED",
"TOSHIMA PACKAGING PRIVATE LIMITED",
"TOSHIO PRIVATE LIMITED",
"TOSHIO TECHNOLOGY PRIVATE LIMITED",
"TOSHIWA SOLAR PRIVATE LIMITED",
"TOSHNIWAL BEVERAGES PRIVATE LIMITED",
"TOSHNIWAL BROTHERS SR PRIVATE LIMITED",
"TOSHNIWAL CLINIC",
"TOSHNIWAL GRANITES PRIVATE LIMITED",
"TOSHNIWAL HYVAC PRIVATE LIMITED",
"TOSHNIWAL INDUSTRIES PRIVATE LIMITED",
"TOSHNIWAL INSTRUMENTS MADRAS PRIVATE LIMITED",
"TOSHNIWAL INSTRUMENTS MANUFACTURING PRIVATE LIMITED",
"TOSHNIWAL MINERALS PRIVATE LIMITED",
"TOSHNIWAL SENSORS PRIVATE LIMITED",
"TOSHOTEX PRIVATE LIMITED",
"TOSHVI COMPUTER SERVICES PRIVATE LIMITED",
"TOSHVIN ANALYTICAL PRIVATE LIMITED",
"TOSIBA APPLIANCES COMPANY PRIVATE LIMITED",
"TOSOH INDIA PRIVATE LIMITED",
"TOSS LOGISTICS PRIVATE LIMITED",
"TOSS MARKETING PRIVATE LIMITED",
"TOSS THE COIN PRIVATE LIMITED",
"TOSS TRUCKING PRIVATE LIMITED",
"TOTA RAM COMMISSION AGENTS PRIVATE. LIMITED.",
"TOTAL AGRI CARE CONCERN PRIVATE LIMITED",
"TOTAL AGRI SERVICES AHMEDABAD PRIVATE LIMITED",
"TOTAL APPLICATION SOFTWARE COMPANY PRIVATE LIMITED",
"TOTAL BROADCAST SOLUTIONS PRIVATE LIMITED",
"TOTAL BUSINESS SOLUTIONS INDIA PRIVATE LIMITED",
"TOTAL CARDIO VASCULAR SOLUTIONS PRIVATE LIMITED",
"TOTAL CARGO & LOGISTICS PRIVATE LIMITED",
"TOTAL CARGO LINKAGE PRIVATE LIMITED",
"TOTAL CARGO SOLUTIONS PRIVATE LIMITED",
"TOTAL CONTAINER LINES PRIVATE LIMITED",
"TOTAL CONTAINER MOVERS PRIVATE LIMITED",
"TOTAL CONTROL AND AUTOMATION PRIVATE LIMITED",
"TOTAL DENTAL CARE PRIVATE LIMITED",
"TOTAL DIAGNOSIS PRIVATE LIMITED",
"TOTAL DRUGS AND INTERMEDIATES PRIVATE LIMITED",
"TOTAL EARTH MOVERS PRIVATE LIMITED",
"TOTAL ELEVATORS AND ESCALATORS PRIVATE LIMITED",
"TOTAL ENVIRONMENT",
"TOTAL ENVIRONMENT BUILDING SYSTEMS PRIVATE LIMITED",
"TOTAL ENVIRONMENT CONSTRUCTIONS PRIVATE LIMITED",
"TOTAL ENVIRONMENT HABITAT PRIVATE LIMITED",
"TOTAL ENVIRONMENT HOSPITALITY PRIVATE LIMITED",
"TOTAL ENVIRONMENT LIVING SPACES PRIVATE LIMITED",
"TOTAL ENVIRONMENT PROJECTS INDIA PRIVATE LIMITED",
"TOTAL FOOTCARE OVERSEAS PRIVATE LIMITED",
"TOTAL FUELS PRIVATE LIMITED",
"TOTAL GIFT SOLUTIONS PRIVATE LIMITED",
"TOTAL HEALTH",
"TOTAL HEAT TREATMENT SOLUTIONS PRIVATE LIMITED",
"TOTAL HOLDINGS FINVEST PRIVATE LIMITED",
"TOTAL HOLIDAY OPTIONS PRIVATE LIMITED",
"TOTAL I T SOFTWARE SOLUTIONS PRIVATE LIMITED",
"TOTAL INTEGRATED DESIGN INDIA PRIVATE LIMITED",
"TOTAL INTERNET SOLUTIONS PRIVATE LIMITED",
"TOTAL INVESTMENTS PRIVATE LIMITED",
"TOTAL IT CONSULT LLP",
"TOTAL LABORATORIES PRIVATE LIMITED",
"TOTAL LIBRARY SOLUTIONS INDIA PRIVATE LTD",
"TOTAL LOGISTICS INDIA PRIVATE LIMITED",
"TOTAL LOGISTICS SERVICES PRIVATE LIMITED",
"TOTAL MARKETING SUPPORT INDIA PRIVATE LIMITED",
"TOTAL MATTRESS SOLUTIONS PRIVATE LIMITED",
"TOTAL MOTORS PRIVATE LIMITED",
"TOTAL MOVEMENTS PRIVATE LIMITED",
"TOTAL POWER CONDITIONERS PRIVATE LIMITED",
"TOTAL PRINT SOLUTIONS PRIVATE LIMITED",
"TOTAL PROSTHETICS & ORTHOTICS INDIA PRIVATE LIMITED",
"TOTAL PROTOTYPING PRIVATE LIMITED",
"TOTAL QUALITY MANAGEMENT SERVICES PRIVATE LIMITED",
"TOTAL SEA-LAND LOGISTICS PRIVATE LIMITED",
"TOTAL SECURITIES LIMITED",
"TOTAL SHIPPING & LOGISTICS PRIVATE LIMITED",
"TOTAL SOLUTION SUPPORT SERVICES PRIVATE LIMITED",
"TOTAL SOLUTIONS INTEC PRIVATE LIMITED",
"TOTAL SPORTING AND FITNESS SOLUTION PRIVATE.LIMITED",
"TOTAL SPORTS AND ENTERTAINMENT INDIA PRIVATE LIMITED",
"TOTAL STRATEGIC SOLUTIONS INDIA PRIVATE LIMITED",
"TOTAL SYNERGY CONSULTING PRIVATE LIMITED",
"TOTAL TALENT SOLUTION PRIVATE LIMITED",
"TOTAL TELEFILMS PRIVATE LIMITED",
"TOTAL TOOLS AND EQUIPMENTS P LTD",
"TOTAL TRAINING INNOVATIONS PRIVATE LIMITED",
"TOTAL TRANSPORT SYSTEMS LIMITED",
"TOTAL TRANSPORTATION PRIVATE LIMITED",
"TOTAL WIRELESS TECHNOLOGIES PRIVATE LIMITED",
"TOTAL X-RAY AND LAB SOLUTIONS PRIVATE LIMITED",
"TOTALA TEXTILES PRIVATE LIMITED",
"TOTALCHOICE HOSTING",
"TOTALE GLOBAL PRIVATE LIMITED",
"TOTALENERGIES GAS & POWER PROJECTS INDIA PRIVATE LIMITED",
"TOTALENERGIES MARKETING INDIA PRIVATE LIMITED",
"TOTALL INSTITUTE OF HEALTH EDUCATION PRIVATE LIMITED",
"TOTALRCM SOLUTIONS PRIVATE LIMITED",
"TOTALS SOLUTION LOGISTIC & WAREHOUSING SERVICES PRIVATE LIMITED",
"TOTALTOOLS METAL PRIVATE LIMITED",
"TOTALWAY LOGISTICS AND INFRASTRUCTURE PRIVATE LIMITED",
"TOTELEC AGRO INDIA PRIVATE LITIMITED",
"TOTEM BIOTECH PRIVATE LIMITED",
"TOTES E-MART PRIVATE LIMITED",
"TOTIENT BUSINESS SOLUTIONS PRIVATE LIMITED",
"TOTIPOTENTRX CELL THERAPY PRIVATE LIMITED",
"TOTLANI INVESTMENTS PRIVATE LIMITED",
"TOTO INDIA INDUSTRIES PRIVATE LIMITED",
"TOTO PVC LEATHER PRIVATE. LIMITED.",
"TOTOODO MOBILE COMMUNICATIONS SERVICE PRIVATE LIMITED",
"TOTT FOODWORKS PRIVATE LIMITED",
"TOTUS CERAMICS INDIA PRIVATE LIMITED",
"TOTUS HEALTH CARE INDIA LIMITED",
"TOUAX TEXMACO RAILCAR LEASING PRIVATE LIMITED",
"TOUCH AND CLICK E SOLUTION SERVICES PRIVATE LIMITED",
"TOUCH AUTOMATION PRIVATE LIMITED",
"TOUCH ENERGY TECHNOLOGIES PRIVATE LIMITED",
"TOUCH HOMES EXPRESS SERVICES PRIVATE LIMITED",
"TOUCH HYGIENE SERVICES PRIVATE LIMITED",
"TOUCH LOGIC TECHNOLOGIES PRIVATE LIMITED",
"TOUCH SECURITY SERVICES PRIVATE LIMITED",
"TOUCH TONE TELESERVICES",
"TOUCH WOOD INFRA VENTURES PRIVATE LIMITED",
"TOUCHCORE SYSTEMS PRIVATE LIMITED",
"TOUCHE GOLF SPORTS PRIVATE LIMITED",
"TOUCHKIN ESERVICES PRIVATE LIMITED",
"TOUCHLABS HEALTHCARE PRIVATE LIMITED",
"TOUCHLESS ID PRIVATE LIMITED",
"TOUCHLINE SECURITIES PRIVATE LIMITED",
"TOUCHLINE TECHNOLOGIES PRIVATE LIMITED",
"TOUCHMAGIX MEDIA PRIVATE LIMITED",
"TOUCHMIND SOFTWARE LLP",
"TOUCHNET BROADBAND SERVICES PRIVATE LIMITED",
"TOUCH-STONE ADVERTISING PRIVATE LIMITED",
"TOUCHSTONE BUSINESS PRIVATE LIMITED",
"TOUCHSTONE CAPITAL LIMITED",
"TOUCHSTONE CAPITAL MARKET SERVICES PRIVATE LIMITED",
"TOUCHSTONE ENTERPRISES PRIVATE LIMITED",
"TOUCHSTONE EQUITIES LIMITED",
"TOUCHSTONE ESTATES INDIA PRIVATE LIMITED",
"TOUCHSTONE FASHION PRIVATE LIMITED",
"TOUCHSTONE INFRASTRUCTURE AND SOLUTIONS PRIVATE LIMITED",
"TOUCHSTONE PRIVATE LIMITED",
"TOUCHSTONE PROPERTY DEVELOPERS PRIVATE LIMITED",
"TOUCHSTONE TELESERVICES PRIVATE LIMITED",
"TOUCHWOOD ENGINEERING AND PROJECTS PRIVATE LIMITED",
"TOUCHWOOD ENTERTAINMENT LIMITED",
"TOUCHWOOD WEAVES PRIVATE LIMITED",
"TOUCHZING MEDIA PRIVATE LIMITED",
"TOUGH 2 ENOUGH FITNESS & SPA PRIVATE LIMITED",
"TOUGH CASTING PRIVATE LIMITED",
"TOUGH COLOR RESINS PRIVATE LIMITED",
"TOUGH TEAM PROJECTS PRIVATE LIMITED",
"TOUGHCONS NIRMAN PRIVATE LIMITED",
"TOUGHERGO PRIVATE LIMITED",
"TOUGHGLASS INDIA PRIVATE LIMITED",
"TOUGHLA AUTOMOTIVE PRIVATE LIMITED",
"TOUGHTEAM INFRA PRIVATE LIMITED",
"TOUNETSU INDIA PRIVATE LIMITED",
"TOUR INDIA TOURS AND TRAVELS PRIVATE LIMITED",
"TOUR MASTERS INDIA PRIVATE LIMITED",
"TOUREPEDIA HOLIDAYS PRIVATE LIMITED",
"TOURISM & HOSPITALLY SECTOR SKILL COUNCIL",
"TOURISM AUSTRALIA",
"TOURISM CIVIL AVIATION DEPTT",
"TOURISM CORP OF GUJ LIMITED",
"TOURISM FINANCE CORPORATION OF INDIA LIMITED.",
"TOURISM INDIA MANAGEMENT ENTERPRISE PRIVATE LIMITED",
"TOURIST HOMES PRIVATE LIMITED",
"TOURISTA INTERNATIONAL PRIVATE LIMITED",
"TOURKRAFT TRAVEL SERVICES PRIVATE LIMITED",
"TOURLANDISH ONLINE VENTURES PRIVATE LIMITED",
"TOURMALINE HOTEL ADVISERS PRIVATE LIMITED",
"TOUT AND OWN PRIVATE LIMITED",
"TOWA OPTICS INDIA PRIVATE LIMITED",
"TOWA PHARMA PRIVATE LIMITED",
"TOWARDS VISION TECHNOLOGIES PRIVATE LIMITED",
"TOWELL ENGINEERING INTERNATIONAL LLP",
"TOWER AUTOMOTIVE INDIA PRIVATE LIMITED",
"TOWER CAPITAL AND SECURITIES PRIVATE LIMITED",
"TOWER ENGINEERING PRIVATE LIMITED",
"TOWER INSURANCE & REINSURANCE BROKERSINDIA PRIVATE LIMITED",
"TOWER MECHANICS PRIVATE LIMITED",
"TOWER PROMOTERS PRIVATE LIMITED",
"TOWER RESEARCH CAPITAL INDIA PRIVATE LIMITED",
"TOWER RESEARCH CAPITAL MARKETS INDIA PRIVATE LIMITED",
"TOWER RUBBER PRIVATE LIMITED",
"TOWER VISION INDIA PRIVATE LIMITED",
"TOWER VISION INDIA PRIVATE. LIMITED.",
"TOWER360 INDIA PRIVATE LIMITED",
"TOWERS' INFOTECH PRIVATE LIMITED",
"TOWERS TOYS AND GAMES PRIVATE LIMITED",
"TOWERTECH COOLING SYSTEM PRIVATE LIMITED",
"TOWN HIGHER SECONDARY SCHOOL",
"TOWN PLANNER WARDHA",
"TOWN PLANNING DEPT",
"TOWNCITY REALTORS PRIVATE LIMITED",
"TOWNPARK BUILDCON PRIVATE LIMITED",
"TOWNSHIP REAL ESTATE DEVELOPERS (INDIA) PRIVATE LIMITED",
"TOWNY NEST VENTURES PRIVATE LIMITED",
"TOX PRESSOTECHNIK INDIA PRIVATE LIMITED",
"TOXETA INNOVATION PRIVATE LIMITED",
"TOXMINDS INDIA CONSULTING PRIVATE LIMITED",
"TOXMO ELECTRIC MOTORS PRIVATE LIMITED",
"TOXSL TECHNOLOGIES PRIVATE LIMITED",
"TOY BALLOON FASHION PRIVATE LIMITED",
"TOY PARK DELHI PRIVATE LIMITED",
"TOY ZONE IMPEX PRIVATE LIMITED",
"TOYAM SPORTS LIMITED",
"TOYAM TECHNOLOGIES INDIA PRIVATE LIMITED",
"TOYAMA CONTROLS AND SYSTEMS PRIVATE LIMITED",
"TOYAMA ELECTRIC LIMITED",
"TOYO COMPUTERS PRIVATE LIMITED",
"TOYO ENGINEERING INDIA PRIVATE LIMITED",
"TOYO FASHIONS PRIVATE LIMITED",
"TOYO INK ARETS INDIA PRIVATE LIMITED",
"TOYO INK INDIA PRIVATE LIMITED",
"TOYO METALLURGICALS LIMITED",
"TOYO PAINTS PRIVATE LIMITED",
"TOYO SANITARY WARES PRIVATE LIMITED",
"TOYO SHARDA INDIA PRIVATE LIMITED",
"TOYO SPRINGS LIMITED",
"TOYODA GOSEI MINDA INDIA PRIVATE LIMITED",
"TOYODA GOSEI SOUTH INDIA PRIVATE LIMITED",
"TOYOP RELIEF PRIVATE LIMITED",
"TOYOTA BOSHOKU AUTOMOTIVE INDIA PRIVATE LIMITED",
"TOYOTA CHEMICAL INDUSTRIES PVT LTD",
"TOYOTA CONNECTED INDIA PRIVATE LIMITED",
"TOYOTA CONSTRUCTION PRIVATE. LIMITED.",
"TOYOTA ENTERPRISE INDIA PRIVATE LIMITED",
"TOYOTA FINANCIAL SERVICES INDIA LIMITED",
"TOYOTA FORMS INDIA PRIVATE LIMITED",
"TOYOTA INDUSTRIES ENGINE INDIA PRIVATE LIMITED",
"TOYOTA KIRLOSKAR AUTO PARTS PRIVATE LIMITED",
"TOYOTA KIRLOSKAR MOTOR PRIVATE LIMITED",
"TOYOTA LAKOZY AUTO PRIVATE LIMITED",
"TOYOTA LOGISTICS KISHOR INDIA PRIVATE LIMITED",
"TOYOTA MATERIAL HANDLING INDIA PRIVATE LIMITED",
"TOYOTA TECHNO PARK INDIA PRIVATE LIMITED",
"TOYOTA TSUSHO INDIA PRIVATE LIMITED",
"TOYOTA TSUSHO INSURANCE BROKER INDIA PRIVATE LIMITED",
"TOYOTA TSUSHO NEXTY ELECTRONICS INDIA PRIVATE LIMITED",
"TOYOTETSU INDIA AUTO PARTS PRIVATE LIMITED",
"TOYOTETSU INDIA PRIVATE LIMITED",
"TOYOTSU AMBIKA AUTOMOTIVE SAFETY COMPONENTS INDIA PRIVATE LIMITED",
"TOYOTSU BHARAT INTEGRATED SERVICES PRIVATE LIMITED",
"TOYOTSU RARE EARTHS INDIA PRIVATE LIMITED",
"TOYS CREATION PRIVATE LIMITED",
"TOZAI ENTERPRISES PRIVATE LIMITED",
"TOZAI SAFETY PRIVATE LIMITED",
"TOZON PRODUCTS & SOLUTIONS PRIVATE LIMITED",
"TP AIRCON REFRIGERATION COMPANY PRIVATE LIMITED",
"TP AJMER DISTRIBUTION LIMITED",
"TP AKKALKOT RENEWABLE LIMITED",
"TP BUILDTECH PRIVATE LIMITED",
"TP CENTRAL ODISHA DISTRIBUTION LIMITED",
"TP IMPEX LIMITED",
"TP INGREDIENTS PRIVATE LIMITED",
"TP JEWEL GALLERIA PRIVATE LIMITED",
"TP KIRNALI LIMITED",
"TP KIRNALI SOLAR LIMITED",
"TP LINK INDIA PRIVATE LIMITED",
"TP LUMINAIRE PRIVATE LIMITED",
"TP NORTHERN ODISHA DISTRIBUTION LIMITED",
"TP POLYMER PRIVATE LIMITED",
"TP RENEWABLE MICROGRID LIMITED",
"TP SAURYA LIMITED",
"TP SOLAPUR SOLAR LIMITED",
"TP SOUTHERN ODISHA DISTRIBUTION LIMITED",
"TP VISION INDIA PRIVATE LIMITED",
"TP WESTERN ODISHA DISTRIBUTION LIMITED",
"TP WIND POWER LIMITED",
"TPAC PACKAGING INDIA PRIVATE LIMITED",
"T-PACK INDIA PRIVATE LIMITED",
"TPAX PACKAGING PRIVATE LIMITED",
"TPC TECHNICAL PROJECTS CONSULTANTS PRIVATE LIMITED",
"TPE ENGINEERS AND CONSULTANTS PRIVATE LIMITED",
"TPES PRIVATE LIMITED",
"TPF ENGINEERING PRIVATE LIMITED",
"TPF GETINSA EUROESTUDIOS SL",
"TPF SOFTWARE INDIA PRIVATE LIMITED",
"TPF TECHNOLOGIES PRIVATE LIMITED",
"TPG CAPITAL INDIA PRIVATE LIMITED",
"TPG SOFTWARE PRIVATE LIMITED",
"TPG WHOLESALE PRIVATE LIMITED",
"TPGLOBAL CREATIONS PRIVATE LIMITED",
"TPHK SYNTEX PRIVATE LIMITED",
"TPI ADVISORY SERVICES INDIA PRIVATE LIMITED",
"TPI COMPOSITES INDIA LLP",
"TPI COMPOSITES INDIA PRIVATE LIMITED",
"TPI GLOBAL SSC INDIA PRIVATE LIMITED",
"TPI INDIA LIMITED",
"TPI INDUSTRIES PRIVATE LIMITED",
"TPI STAFFING PRIVATE LIMITED",
"TPI UNDERCARRIAGE PRIVATE LIMITED",
"TPK SAND CRUSHERS PRIVATE LIMITED",
"TPL FINANCE LIMITED",
"TPL PLASTECH LIMITED.",
"TPM AGRITECH PRODUCER COMPANY LIMITED",
"TPM CONSULTANTS PRIVATE LIMITED",
"TPOWER TRANSFORMER AND SWITCHGEAR PRIVATE LIMITED",
"TPP BOILERS PRIVATE LIMITED",
"TPPL PHARMACEUTICALS PRIVATE LIMITED",
"TPR AUTOPARTS MFG. INDIA PRIVATE LIMITED",
"TPR EXPORTS PRIVATE LIMITED",
"TPR GOLD SUPERMARKET PRIVATE LIMITED",
"TPRG FRAGRANCES PRIVATE LIMITED",
"TPRI TECHNOLOGIES PRIVATE LIMITED",
"TPRS ENTERPRISES PRIVATE LIMITED",
"TPS AUTOMATION PRIVATE LIMITED",
"TPS INFRAVSTRUCTURE LIMITED",
"TPSCINDIA PRIVATE LIMITED",
"TPT PRODUCTIONS PRIVATE LIMITED",
"TPV TECHNOLOGY INDIA PRIVATE LIMITED",
"TQ CERT SERVICES PRIVATE LIMITED",
"TQ TEKNOLOGIES PRIVATE LIMITED",
"TQG SERVICES PRIVATE LIMITED",
"TQH CONSULTING PRIVATE LIMITED",
"TQM CORPCARE PVT LTD",
"TQM INTERNATIONAL PRIVATE LIMITED",
"TQS INTEGRATION PRIVATE LIMITED",
"TQS LOGISTICS SERVICES PRIVATE LIMITED",
"TQUANTA TECHNOLOGIES PRIVATE LIMITED",
"TR BUILDCON PRIVATE LIMITED",
"TR FORMAC FASTENINGS PRIVATE LIMITED",
"TR FOUNDRY PRIVATE LIMITED",
"TR TRAINING AND CONSULTING SERVICES",
"TR VASUDEV ENGINEERING PRIVATE LIMITED",
"TRA INTERNATIONAL KNOWLEDGE SERVICES",
"TRA RESEARCH PRIVATE LIMITED",
"TRAAB ENGG INDIA PRIVATE LIMITED",
"TRA-AUGMENT PEOPLE.SOLUTIONS PRIVATE LIMITED",
"TRABACUS TECHNOLOGIES PRIVATE LIMITED",
"TRAC MEDIA PRIVATE LIMITED",
"TRAC REPRESENTATION INDIA PRIVATE LIMITED",
"TRACE NETWORK & ENGINEERING PRIVATE LIMITED",
"TRACE ONE TECHNOLOGY INDIA PRIVATE LIMITED",
"TRACE SECURITY AND ALLIED SERVICES PRIVATE LIMITED",
"TRACE SOFTWARE PVT LTD",
"TRACE VFX SOLUTIONS INDIA PRIVATE LIMITED",
"TRACEABLE LUXURY SOLUTIONS PRIVATE LIMITED",
"TRACEABLEAI SOFTWARE INDIA PRIVATE LIMITED",
"TRACELINK INDIA PRIVATE LIMITED",
"TRACEROOT SOFTWARE SOLUTIONS PRIVATE LIMITED",
"TRACERS INDIA SEARCH PRIVATE LIMITED",
"TRACESUTRA PRIVATE LIMITED",
"TRACK COMPONENTS LIMITED",
"TRACK EXPRESS LIMITED",
"TRACK FOUR INFOTEC (I) PRIVATE LIMITED",
"TRACK INDIA PRIVATE LIMITED",
"TRACK INNOVATIONS INDIA PRIVATE LIMITED",
"TRACK IT TECH SYSTEMS PRIVATE LIMITED",
"TRACK MANUFACTURING CO. PRIVATE LIMITED",
"TRACK OPINION RESEARCH PRIVATE LIMITED",
"TRACK SHOES PRIVATE LIMITED",
"TRACKBUDGET TOURS AND TRAVELS PRIVATE LIMITED",
"TRACKER WAVE PRIVATE LIMITED",
"TRACKLINK LOGISTICS (INDIA) PRIVATE LIMITED",
"TRACKMYTRUCKS PRIVATE LIMITED",
"TRACKNOVATE MOBILE RESOURCE MANAGEMENT PRIVATE LIMITED",
"TRACKNOVATE TECHNOLOGIES PRIVATE LIMITED",
"TRACKON COURIERS PRIVATE LIMITED",
"TRACKON LOGISTICS & EXPRESS SERVICES PRIVATE LIMITED",
"TRACKPOINT GPS LIMITED",
"TRACKPOINT GPS PRIVATE LIMITED",
"TRACKROAD TRANSPORTER PRIVATE LIMITED",
"TRACKROVER MOBILITY TECHNOLOGIES PRIVATE LIMITED",
"TRACKS & TOWERS INFRATECH PRIVATE LIMITED",
"TRACKSUN SOLAR PRIVATE LIMITED",
"TRACKTECH INTERNATIONAL PRIVATE LIMITED",
"TRACKWAY REALTY PRIVATE LIMITED",
"TRACLAXX TRACTORS PRIVATE LIMITED",
"TRACO CABLE COMPANY LIMITED",
"TRACOM STOCK BROKERS PVT LTD",
"TRACON COURIERS PRIVATE.PTD",
"TRACON EXPORT SERVICES PRIVATE LIMITED",
"TRACTEBEL ENGINEERING PRIVATE LIMITED",
"TRACTEBEL GKW GMBH",
"TRACTEL TIRFOR INDIA PVT LTD",
"TRACTIC PRIVATE LIMITED",
"TRACTION INDUSTRIES PRIVATE LIMITED",
"TRACTOR SUPPLY COMPANY",
"TRACTORS AND FARM EQUIPMENT LIMITED",
"TRACTORS INDIA PRIVATE LIMITED",
"TRACTUS ASIA (INDIA) PRIVATE LIMITED",
"TRACXN TECHNOLOGIES LIMITED",
"TRACXN TECHNOLOGIES PRIVATE LIMITED",
"TRADABILITY GLOBAL PRIVATE LIMITED",
"TRADE (WORLDWIDE) PVT. LTD",
"TRADE ACHIEVERS TRAINING ACADEMY PRIVATE LIMITED",
"TRADE AND INVESTMENT QUEENSLAND AUSTRALIA QUEENSLAND GOVERNMENT TRADE & INVESTMENT OFFICE BANGALORE",
"TRADE AND TECHNOLOGY EXPOSITION I PRIVATE LIMITED",
"TRADE AND TECHNOLOGY PVT LTD",
"TRADE BULLS SECURITIES P LIMITED",
"TRADE COOL SERVICES (INDIA) PVT LTD",
"TRADE DESK INDIA PRIVATE LIMITED",
"TRADE FACILITES MANAGEMENT INDIA PRIVATE LIMITED",
"TRADE HORIZON PRIVATE LIMITED",
"TRADE IMPEX INC.",
"TRADE INDIA CONSTRUCTION PRIVATE LIMITED",
"TRADE INDIA EXPORTS AND OILS PRIVATE LIMITED",
"TRADE LINERS AUTO PRIVATE LIMITED",
"TRADE LINKS PRIVATE LIMITED",
"TRADE MASTER IMPORT AND EXPORT PRIVATE LIMITED",
"TRADE NET WEALTH BROKING PRIVATE LIMITED",
"TRADE PERFECTIONS",
"TRADE PLUS RESOURCES AND SOLUTIONS PRIVATE LIMITED",
"TRADE TAX DEPARTMENT",
"TRADE TORCH PRIVATE LIMITED",
"TRADE TRACK CARGO PRIVATE LIMITED",
"TRADE TRUMP TABLEWARE PRIVATE LIMITED",
"TRADE ULTRA VENTURES PRIVATE LIMITED",
"TRADE UNLISTED PRIVATE LIMITED",
"TRADE VISION INDIA PRIVATE LIMITED",
"TRADE VISION INFRA VENTURES INDIA PRIVATE LIMITED",
"TRADE WINGS LOGISTICS INDIA PRIVATE LIMITED",
"TRADE WORLD LOGISTICS PRIVATE LIMITED",
"TRADEAIR (IFSC) PRIVATE LIMITED",
"TRADEASIA INTERNATIONAL PRIVATE LIMITED",
"TRADEBULLS",
"TRADEBULLS COMMODITIES BROKING PRIVATE LIMITED",
"TRADEBULLS HOLDINGS PRIVATE LIMITED",
"TRADEBULLS SECURITIES PRIVATE LIMITED",
"TRADECHEM ORGANICS LIMITED",
"TRADECO PHARMACEUTICALS PRIVATE LIMITED",
"TRADECOM INTERNATIONAL PRIVATE LIMITED",
"TRADECOM MEDITRANS PRIVATE LIMITED",
"TRADECON SHIPPING AND LOGISTICS PRIVATE LIMITED",
"TRADECORP ROVENSA INDIA PRIVATE LIMITED",
"TRADEDEAL ENTERPRISES PRIVATE LIMITED",
"TRADEGYANI ANALYTICS PRIVATE LIMITED",
"TRADEIMEX INFO SOLUTION PRIVATE LIMITED",
"TRADEIMPEX POLYMERS (INDIA) PRIVATE LIMITED",
"TRADEIMPEX POLYMERS INDIA PRIVATE LIMITED",
"TRADEJINI FINANCIAL SERVICES PRIVATE LIMITED",
"TRADELEAVES INDIA PRIVATE LIMITED",
"TRADELINK COMPUTERS PRIVATE LIMITED",
"TRADELINK EXIM (INDIA) PRIVATE LIMITED",
"TRADELINK SECURITIES LTD",
"TRADELINK TECHNOLOGIES INDIA PRIVATE LIMITED",
"TRADEMAX SOLUTIONS PRIVATE LIMITED",
"TRADENEXT SECURITIES LIMITED",
"TRADENFILL INDIA PRIVATE LIMITED",
"TRADEON TECHNOLOGIES PRIVATE LIMITED",
"TRADEPASS LLP",
"TRADEROUTE INTEGRATED LOGISTICS PRIVATE LIMITED",
"TRADERS & ENGINEERS PVT LTD",
"TRADERS TRAINING ACADEMY",
"TRADESATE OVERSEAS PRIVATE LIMITED",
"TRADESMAN CORPORATION",
"TRADESMAN SERVICES INDIA PRIVATE LIMITED",
"TRADESOCIO INDIA PRIVATE LIMITED",
"TRADESVEL SECURITY SERVICES PRIVATE LIMITED",
"TRADESWIFT BROKING PRIVATE LIMITED",
"TRADEWALK BROKING PRIVATE LIMITED",
"TRADEWEL INDIA SALES PRIVATE LIMITED",
"TRADEWEL SPARES INDIA PRIVATE LIMITED",
"TRADEWELL FERROMET PRIVATE LIMITED",
"TRADEWELL HOLDINGS LIMITED",
"TRADEWELL INTERNATIONAL PRIVATE LIMITED",
"TRADEWELL PORTFOLIOS PRIVATE LIMITED",
"TRADEWELL SECURITIES LIMITED",
"TRADEWINGS MARKETING PRIVATE LIMITED",
"TRADEX FINANCIAL SERVICES PRIVATE LIMITED",
"TRADEX INDIA CORPORATION PRIVATE LIMITED",
"TRADEX PHARMA PRIVATE LIMITED",
"TRADEX POLYMERS PVT LTD",
"TRADEX PRO PRIVATE LIMITED",
"TRADEX SHIPPING COMPANY PRIVATE LIMITED",
"TRADEX SYSTEMS PRIVATE LIMITED",
"TRADEXA TECHNOLOGIES PRIVATE LIMITED",
"TRADEXL MEDIA PRIVATE LIMITED",
"TRADEZEAL ONLINE PRIVATE LIMITED",
"TRADING TECHNOLOGIES INDIA PRIVATE LIMITED",
"TRADINOVA INTERNATIONAL PRIVATE LIMITED",
"TRADITIONAL GALLERY PRIVATE. LIMITED.",
"TRADITIONAL HERITAGE HOTELS PRIVATE. LIMITED.",
"TRADITIONS EVENT MANAGEMENT & MARKETING PRIVATE LIMITED",
"TRADLIYNK MARKETING PRIVATE LIMITED",
"TRAFAG CONTROLS INDIA PRIVATE LIMITED",
"TRAFALGAR EPC PRIVATE LIMITED",
"TRAFALGAR INVESTMENT COMPANY PRIVATE LIMITED",
"TRAFEX INDIA PRIVATE LIMITED",
"TRAFFIC ENTERTAINMENT PRIVATE LIMITED",
"TRAFFIC MEDIA INDIA PRIVATE LIMITED",
"TRAFFSYS TECHNOLOGIES PRIVATE LIMITED",
"TRAFIGURA GLOBAL SERVICES PRIVATE LIMITED",
"TRAFIGURA INDIA PRIVATE LIMITED",
"TRAFIKSOL ELECTROMECHANICAL PRIVATE LIMITED",
"TRAFIKSOL ITS TECHNOLOGIES PRIVATE LIMITED",
"TRAFITEK SOLUTIONS PRIVATE LIMITED",
"TRAFITRONICS INDIA PRIVATE LIMITED",
"TRAFO POWER & ELECTRICALS (P) LTD",
"TRAFO RADIATORS AND TANKS PRIVATE LIMITED",
"TRAFOMEC INDIA PRIVATE LIMITED",
"TRAFORM TRAVEL TECHNOLOGIES INDIA PRIVATE LIMITED",
"TRAGEN TECHNOLOGY PRIVATE LIMITED",
"TRAGON SHIPPING AND FREIGHT FORWARDING PRIVATE LIMITED",
"TRAGOPAN TRANSFORMER PRIVATE LIMITED",
"TRAIL BLAZER IT CONSULTING PRIVATE LIMITED.",
"TRAIL BLAZER TOURS INDIA PRIVATE LIMITED",
"TRAIL TRADE INDIA PRIVATE LIMITED",
"TRAILBLAZER VACATIONS PRIVATE LIMITED",
"TRAILBLAZERS ADVENTURE TRAVEL PRIVATE LIMITED",
"TRAILFINDER LEISURE PRIVATE LIMITED",
"TRAIN & TRANS LOGISTIC PRIVATE LIMITED",
"TRAIN PLACE PRIVATE LIMITED",
"TRAINING OFFICER ITI",
"TRAINING SUPDT ITI MAHIDPUR",
"TRAINNG SUPDT ITI MANPUR MHOW",
"TRAINOCATE NETWORKS INDIA PRIVATE LIMITED",
"TRAINOTRACK SOLUTIONS PRIVATE LIMITED",
"TRAINSMART LEARNING SOLUTIONS PRIVATE LIMITED",
"TRAINTECH ELECTRONICS PRIVATE LIMITED",
"TRAIO MACHINES PRIVATE LIMITED",
"TRAIT IT PARK PRIVATE LIMITED",
"TRAJECTORIES BUSINESS SOLUTIONS PRIVATE LIMITED",
"TRAK SECURITIES AND FINANCIAL SERVICES PRIVATE LIMITED",
"TRAKITNOW TECHNOLOGIES PRIVATE LIMITED",
"TRAKMATE DESIGN SOLUTIONS PRIVATE LIMITED",
"TRAKO MEP (I) PRIVATE LIMITED",
"TRALA ELECTROMECH SYSTEMS PRIVATE LIMITED",
"TRAMBAK RUBBER INDUSTRIES LIMITED",
"TRAMBAK RUBBER INDUSTRIES PRIVATE LIMITED",
"TRAMBAK TRAVELS PRIVATE LIMITED",
"TRAMBAKAM FLOUR MILLS LIMITED",
"TRAMBAKESHWAR TRADE PRIVATE LIMITED",
"TRAMBOO ENTERPRISES PRIVATE LIMITED.",
"TRAMCO COACHES PRIVATE LIMITED",
"TRAMCO ELECTRICALS PRIVATE LIMITED",
"TRAMES PRIVATE LIMITED",
"TRAMEX IPEC GLOBAL PRIVATE LIMITED",
"TRAMMO INDIA PRIVATE LIMITED",
"TRAMO TECHNOLAB PRIVATE LIMITED",
"TRAMPOLINE TECH PRIVATE LIMITED",
"TRANALAB PRIVATE LIMITED",
"TRANCE GREENFIELDS RECREATUM AND CONVERTION CENTER PRIVATE LIMITED",
"TRANCE HOME INDIA SERVICES PRIVATE LIMITED",
"TRANCECARE LOGISTICS PRIVATE LIMITED",
"TRANCEFX STUDIOS PRIVATE LIMITED",
"TRANCEMARINE AND CONFREIGHT LOGISTICS PRIVATE LIMITED",
"TRANCO LOGSTICS PRIVATE LIMITED",
"TRANDIS ELECTRO MECHANICAL SERVICES PRIVATE LIMITED",
"TRANE TECHNOLOGIES INDIA PRIVATE LIMITED",
"TRANFORMEX FERROUS PRIVATE LIMITED",
"TRANG ENGINEERING AND CONSTRUCTION PRIVATE LIMITED",
"TRANGILE SERVICES PRIVATE LIMITED",
"TRANISTICS DATA TECHNOLOGIES PRIVATE LIMITED",
"TRANK TECHNOLOGIES PRIVATE LIMITED",
"TRANONT INTERNATIONAL PRIVATE LIMITED",
"TRANPAC SOFTWARE SOLUTIONS PRIVATE LIMITED",
"TRANQUIIL SPECIALITY PRODUCTS PRIVATE LIMITED",
"TRANQUIL",
"TRANQUIL HOMES AND HOLDINGS PRIVATE LIMITED",
"TRANQUIL TIMBERLANDS PRIVATE LIMITED",
"TRANQUIL TOURS PRIVATE LIMITED",
"TRANQUILITY SERVICES PRIVATE LIMITED",
"TRANS ACNR SOLUTIONS PRIVATE LIMITED",
"TRANS ASIA CONSULTANTS PVT LTD",
"TRANS ASIA HOTELS PRIVATE LIMITED",
"TRANS ASIAN INDUSTRIES EXPOSITION PRIVATE LIMITED",
"TRANS ASIAN SHIPPING SERVICES PRIVATE LIMITED",
"TRANS ASSIST INDIA PRIVATE LIMITED",
"TRANS AUTO INTERNATIONAL",
"TRANS AVIACONS PRIVATE LIMITED",
"TRANS BHARAT AVIATION PVT LTD",
"TRANS CARGO CARRIERS OF INDIA PRIVATE LIMITED",
"TRANS CARGO LOGISTICS PRIVATE LIMITED",
"TRANS CARGO(GUJARAT) PRIVATE LIMITED",
"TRANS CONCRETE PRIVATE LIMITED",
"TRANS CONDUCT INDIA",
"TRANS CONSTRUCTION EQUIPMENT ENGINEERING PRIVATE LIMITED",
"TRANS CONTINENTAL E SERVICES PRIVATE LIMITED",
"TRANS CONTINENTAL FREIGHT SERVICE INDIA PVT LTD",
"TRANS CORPORATE ADVISORY SERVICES PRIVATE LIMITED",
"TRANS DIESEL ENGINEERS PRIVATE LIMITED",
"TRANS DYNE ENGINEERS PRIVATE LIMITED",
"TRANS EARTH LOGISTICS PRIVATE LIMITED",
"TRANS EKKO LIVING SOLUTIONS PRIVATE LIMITED",
"TRANS ELECTRO ACCESSORIES PRIVATE LIMITED",
"TRANS ENGINEERS INDIA PRIVATE LIMITED",
"TRANS ENTERPRISES PRIVATE LIMITED",
"TRANS FOAM INDUSTRIES PRIVATE LIMITED",
"TRANS FREIGHT CONTAINERS LIMITED",
"TRANS GLOBAL LOGISTICS INDIA PRIVATE LIMITED",
"TRANS GLOBAL LOGISTICS PRIVATE LIMITED",
"TRANS GLOBAL SECURITIES LTD",
"TRANS GLOBE NKS HOLDINGS LIMITED",
"TRANS HEALTH CARE INDIA PRIVATE LIMITED",
"TRANS INDIA BUSINESS SOLUTIONS PRIVATE LIMITED",
"TRANS INDIA CERAMICS PRIVATE LIMITED",
"TRANS INDIA FOREX PRIVATE LIMITED",
"TRANS INDIA HOLIDAYS PRIVATE LIMITED",
"TRANS INFRA & LOGISTICS PRIVATE LIMITED",
"TRANS LOG-SHIP PRIVATE LIMITED",
"TRANS MECH SYSTEM",
"TRANS METALITE (INDIA) LIMITED",
"TRANS NEURON TECHNOLOGIES PRIVATE LIMITED",
"TRANS OCEANIC CHEMICALS PRIVATE LIMITED",
"TRANS OCEANIC INTELLIGENCE SOLUTIONS PRIVATE LIMITED",
"TRANS OILFIELD CHEMICALS PRIVATE LIMITED",
"TRANS ORGANICS (INDIA) PRIVATE LIMITED",
"TRANS PIONEER FREIGHT MANAGEMENT PRIVATE LIMITED",
"TRANS QUALITY SYSTEM CONSULTANCY PRIVATE LIMITED",
"TRANS RAIL INDUSTRIES PRIVATE LIMITED",
"TRANS SCAN SECURITIES PRIVATE LIMITED",
"TRANS SEA SERVICES PRIVATE LIMITED",
"TRANS TECH HVAC PRIVATE LIMITED",
"TRANS TECH PACKAGING VENTURES PRIVATE LIMITED",
"TRANS TECH PROJECTS PRIVATE. LIMITED",
"TRANS THANE CREEK WASTE MANAGEMENT ASSOCIATION",
"TRANS TOOL PRIVATE LIMITED",
"TRANS TYRES INDIA PRIVATE LIMITED",
"TRANS UNION SOFTWARE SERVICES PRIVATE LIMITED",
"TRANS UNIQUE FIRE DOORS PRIVATE LIMITED",
"TRANS UNIVERSAL LOGISTICS (I) PRIVATE LIMITED",
"TRANS VALVES INDIA PRIVATE. LIMITED.",
"TRANS VIRTUAL PRIVATE LIMITED",
"TRANS VOLT ENGINEERING",
"TRANS WAVES EQUIPMENTS PVT LTD",
"TRANSACT BPO SERVICES INDIA PRIVATE LIMITED",
"TRANSACT CAMPUS INDIA PRIVATE LIMITED",
"TRANSACTBOX TECHNOLOGIES PRIVATE LIMITED",
"TRANSACTION ANALYSTS INDIA PRIVATE LIMITED",
"TRANSACTION NETWORK SERVICES (INDIA) PRIVATE LIMITED",
"TRANSACTION SOLUTIONS INTERNATIONAL INDIA PRIVATE LIMITED",
"TRANSACTION SQUARE LLP",
"TRANSAEROMARINE IMEX SOLUTIONS PRIVATE LIMITED",
"TRANSAFE FREIGHT SYSTEMS PRIVATE LIMITED",
"TRANSAFE SERVICES LTD.",
"TRANSAGAR SHIPPING LINES INDIA PRIVATE LIMITED",
"TRANSALPINA LOGISTICS PRIVATE LIMITED",
"TRANSALTUS MANAGEMENT CONSULTING PRIVATE LIMITED",
"TRANSAMERICA DIRECT MARKETING CONSULTANTS PRIVATE LIMITED",
"TRANSASIA BIO MEDICALS LIMITED",
"TRANSASIA COMPOSITE INSURANCE BROKING LIMITED",
"TRANSASIA FINE PAPERS PRIVATE LIMITED",
"TRANSASIA MARKETING PRIVATE LIMITED",
"TRANSASIA PAPERS INDIA PRIVATE LIMITED",
"TRANSASIA PETROCHEM PRIVATE LIMITED",
"TRANSASIA RISK ADVISORS PRIVATE LIMITED-B",
"TRANSASIA TRAVELNET PRIVATE LIMITED",
"TRANSASIA VENTURES PRIVATE LIMITED",
"TRANSATLANTIC INFRAPROJECTS PRIVATE LIMITED",
"TRANSATLANTIC LADHA CONSULTANTS PRIVATE LIMITED",
"TRANSATLANTIC LOGISTICS PRIVATE LIMITED",
"TRANSAUTO AND MECHAIDS PRIVATE LIMITED",
"TRANSBADI TECH SOLUTIONS PRIVATE LIMITED",
"TRANSBARRIER TRADERS AND SERVICES PRIVATE LIMITED",
"TRANSCAAL POWER DIVISION INDIA PRIVATE LIMITED",
"TRANSCARGO INDIA PRIVATE LIMITED",
"TRANSCART MANAGEMENT PRIVATE LIMITED",
"TRANSCEDENCE AUTOMATION PRIVATE LIMITED",
"TRANSCELL BIOLIFE PRIVATE LIMITED",
"TRANSCELL ONCOLOGICS PRIVATE LIMITED",
"TRANSCELTIC CORES PRIVATE LIMITED",
"TRANSCEND CLEANTEC PRIVATE LIMITED",
"TRANSCEND CREATIVE SERVICES PRIVATE LIMITED",
"TRANSCEND INDIA PRIVATE LIMITED",
"TRANSCEND INFOSYSTEMS PRIVATE LIMITED",
"TRANSCEND INFRASTRUCTURE PRIVATE LIMITED",
"TRANSCEND MOBILITY PRIVATE LIMITED",
"TRANSCEND MT SERVICES PRIVATE LIMITED",
"TRANSCEND STREET INDIA PRIVATE LIMITED",
"TRANSCENDENCE HUMAN RESOURCES PRIVATE LIMITED",
"TRANSCENDENT CONDOMINIUMS PRIVATE LIMITED",
"TRANSCENTRA FTS PRIVATE LIMITED",
"TRANSCHEM IMPEX PRIVATE LIMITED",
"TRANSCHEM LIMITED",
"TRANSCOAL IMPEX PRIVATE LIMITED",
"TRANSCON AUTOMATION & CONVEYORS PRIVATE LIMITED",
"TRANSCON ELECTRONICS PRIVATE LIMITED",
"TRANSCON ENGINEERS PRIVATE LIMITED",
"TRANSCON FREIGHT SYSTEM PRIVATE LIMITED",
"TRANSCON HI-TECH EQUIPMENTS PRIVATE LIMITED",
"TRANSCON ICONICA PRIVATE LIMITED",
"TRANSCON POWER PRIVATE LIMITED",
"TRANSCON SHETH CREATORS PRIVATE LIMITED",
"TRANSCON SKYCITY PRIVATE LIMITED",
"TRANSCONSEIL LOGISTICS PRIVATE LIMITED",
"TRANSCONT (INDIA) FINVEST PRIVATE LIMITED",
"TRANSCORP ENTERPRISES LIMITED",
"TRANSCORP INTERNATIONAL LIMITED",
"TRANSCREEK ENGINEERS PRIVATE LIMITED",
"TRANSCRIBE BUSINESS SOLUTIONS PRIVATE LIMITED",
"TRANSCRIPTO BUSINESS SERVICES PRIVATE LIMITED",
"TRANSCURE THERAPEUTICS PRIVATE LIMITED",
"TRANSDAMODAR MINING PRIVATE LIMITED",
"TRANSDECCAN ELECTRICALS PRIVATE LIMITED",
"TRANSDELTA TRANSFORMERS PRIVATE LIMITED",
"TRANSDIEN PRIVATE LIMITED",
"TRANSDIGM TECHNOLOGIES INDIA PRIVATE LIMITED",
"TRANSDOT PRIVATE LIMITED",
"TRANSDUCT PRIVATE LIMITED",
"TRANSDYNAMICS ENGINEERING AND TECHNOLOGY PRIVATE LIMITED",
"TRANSDYNE IT SERVICES PRIVATE LIMITED",
"TRANSE VISION CARE PRIVATE LIMITED",
"TRANSEARCH CONSULTANTS PRIVATE LIMITED",
"TRANSEASY RELOCATIONS (INDIA) PRIVATE LIMITED",
"TRANSEAZY LOGISTICS PRIVATE LIMITED",
"TRANSECUR TELEMATICS PRIVATE LIMITED",
"TRANSEL IMPEX PRIVATE LIMITED",
"TRANSELECT CONSULTANTS PRIVATE LIMITED",
"TRANSENDO SHIPPING AND LOGISTICS PRIVATE LIMITED",
"TRANSENERGY PRIVATE LIMITED",
"TRANSERECT TESTING & COMMISSIONING ENGINEERS PRIVATE LIMITED",
"TRANSERV PRIVATE LIMITED",
"TRANSERVE ADVISORS PRIVATE LIMITED",
"TRANSERVE TECHNOLOGIES PRIVATE LIMITED",
"TRANSEXIM COMMODITIES INDIA PRIVATE LIMITED",
"TRANSEXPRESS LOGISTICS INDIA PRIVATE LIMITED",
"TRANSFAR CHEMICAL INDIA PRIVATE LIMITED",
"TRANSFAST INDIA PRIVATE LIMITED",
"TRANSFERET RELOCATION SERVICES INDIA PRIVATE LIMITED",
"TRANSFINITE INNOVATIVE SOLUTIONS PRIVATE LIMITED",
"TRANSFIX INDIA PRIVATE LIMITED",
"TRANSFLEX CONVEYORS PRIVATE LIMITED",
"TRANSFLO PUMPS PRIVATE LIMITED",
"TRANSFLOW PROCESS SYSTEMS PRIVATE LIMITED",
"TRANSFORM FURNITURES PRIVATE LIMITED",
"TRANSFORM SOLUTION PRIVATE LIMITED",
"TRANSFORM SPORTS MEDIA AND ENTERTAINMENT PRIVATE LIMITED",
"TRANSFORMA MANAGEMENT PARTNERS PRIVATE LIMITED",
"TRANSFORMA PRIVATE LIMITED",
"TRANSFORMATION GLOBAL SERVICES INDIA PRIVATE LIMITED",
"TRANSFORMATION TRAINING SERVICES PRIVATE LIMITED",
"TRANSFORMATIONS SUSTAINABILITY CONSULTANTS PRIVATE LIMITED",
"TRANSFORMATIVE LEARNING SOLUTIONS PRIVATE LIMITED",
"TRANSFORMATIVE PHARMACEUTICAL SOLUTIONS INDIA PRIVATE LIMITED",
"TRANSFORME LEARNING & LEADERSHIP SOLUTIONS PRIVATE LIMITED",
"TRANSFORMEDGE ENTERPRISE SERVICES PRIVATE LIMITED",
"TRANSFORMERS AND ELECTRICALS KERALA LIMITED.",
"TRANSFORMERS AND HIGH VOLTAGE EQUIPMENTS PRIVATE LIMITED",
"TRANSFORMERS AND RECTIFIERS INDIA LIMITED",
"TRANSFORMING HIGHER EDUCATION GATE ACADEMY PRIVATE LIMITED",
"TRANSFORMING RETAIL PRIVATE LIMITED",
"TRANSFORMING RURAL INDIA FOUNDATION",
"TRANSFRETUS PARTNERS INDIA PRIVATE LIMITED",
"TRANSFUNNEL CONSULTING PRIVATE LIMITED",
"TRANSGANIZATION CREATION PRIVATE LIMITED",
"TRANSGEAR ELECTRICAL SERVICES PRIVATE LIMITED",
"TRANSGEAR POWER SYSTEMS PRIVATE LIMITED",
"TRANSGENEZ SOLUTIONS PRIVATE LIMITED",
"TRANSGLOBAL GEOMATICS PRIVATE LIMITED",
"TRANSGLOBAL POWER LIMITED",
"TRANSGLOBAL TRADE INTEGRATION PRIVATE LIMITED",
"TRANSGLOBE FREIGHT FORWARDERS PRIVATE LIMITED",
"TRANSGRAPH CONSULTING PRIVATE LIMITED",
"TRANSHEALTH PRIVATE LIMITED",
"TRANSHIP PACKERS AND MOVERS PRIVATE LIMITED",
"TRANS-I PRESS PARTS PRIVATE LIMITED",
"TRANSIENT HR SOLUTIONS PRIVATE LIMITED",
"TRANSIGHT SYSTEMS PRIVATE LIMITED",
"TRANSIMPACT PRIVATE LIMITED",
"TRANSIN LOGISTICS PRIVATE LIMITED",
"TRANSINDIA CONTROL SYSTEMS PRIVATE LIMITED",
"TRANSINDIA FREIGHT SERVICES PRIVATE LIMITED",
"TRANSINDIA LOGISTIC PARK PRIVATE LIMITED",
"TRANSINDIA NONWOVENS PRIVATE LIMITED",
"TRANSINT ENDEAVOURS PRIVATE LIMITED",
"TRANSIT ADVERTISING PRIVATE LIMITED",
"TRANSIT ELECTRONICS LIMITED",
"TRANSIT INDIA LOGISTICS PRIVATE LIMITED",
"TRANSITECH PRIVATE LIMITED",
"TRANSITIAL AGRO COMMODITIES PRIVATE LIMITED",
"TRANSITIONS ARCHITECTS PRIVATE LIMITED",
"TRANSITIONS DESIGNS PRIVATE LIMITED",
"TRANSKING CARRIER PRIVATE LIMITED",
"TRANSLAB EQUIPMENT SOLUTION PRIVATE LIMITED",
"TRANSLAM ACADEMY INTERNATIONAL",
"TRANSLAND LOGISTICS PRIVATE LIMITED",
"TRANSLANDS INFRASTRUCTURE DEVELOPERS PRIVATE LIMITED",
"TRANSLANG WAYS SOLUTIONS PRIVATE LIMITED",
"TRANSLANKAAIRTRAVELSPRIVATELIMITED",
"TRANSLANTECK NESTING & AUTOMATION INDIA PRIVATE LIMITED",
"TRANSLATE HANDCRAFTED PRODUCTS (INDIA) PRIVATE LIMITED",
"TRANSLATIONAL HEALTH SCIENCE AND TECHNOLOGY INSTITUTE",
"TRANSLINE AIR CARGO SERVICES PRIVATE.LIMITED",
"TRANSLINE CONVEYORS PRIVATE LIMITED",
"TRANSLINE LOGISTICS PRIVATE LIMITED",
"TRANSLINE TECHNOLOGIES LIMITED",
"TRANSLINE TECHNOLOGIES PRIVATE. LIMITED.",
"TRANSLINER MARTIME PRIVATE LIMITED",
"TRANSLINER STRATEGIC SOLUTIONS PRIVATE LIMITED",
"TRANSLINK INFRASTRUCTURE CONSULTANTS PRIVATE LIMITED",
"TRANSLINK LOGISTICS PRIVATE LIMITED",
"TRANSLITE ENERGY LIMITED",
"TRANSLITE OVERSEAS PRIVATE LIMITED",
"TRANSLITE SCAFFOLDING LIMITED",
"TRANSLLOY INDIA PRIVATE LIMITED",
"TRANSLOG EXPRESS PRIVATE LIMITED",
"TRANSLOG LINES PRIVATE LIMITED",
"TRANSLUMINA THERAPEUTICS LLP",
"TRANSMARINE AGENCIES INDIA PRIVATE LIMITED",
"TRANSMARINE CARGO SERVICES PRIVATE LIMITED",
"TRANSMARINE CORPORATION",
"TRANSMARINE LOGISTICS PRIVATE LIMITED",
"TRANSMARINE SERVICES INDIA PRIVATE LIMITED",
"TRANSMARINELINE GLOBAL PRIVATE LIMITED",
"TRANSMART DIGITAL PRIVATE LIMITED",
"TRANSMART INDIA PRIVATE LIMITED",
"TRANSMAX CABLES PRIVATE LIMITED",
"TRANSMEC INDIA PRIVATE LIMITED",
"TRANSMEDIA SOFTWARE LIMITED",
"TRANSMILLE LIMITED",
"TRANSMIN INDIA PRIVATE LIMITED",
"TRANSMISSION CORPORATION OF ANDHRA PRADESH LIMITED",
"TRANSMISSION CORPORATION OF TELANGANA LIMITED",
"TRANSMISSION PROJECTS PRIVATE LIMITED",
"TRANSMODAL SERVICES PRIVATE LIMITED",
"TRANSMODE SHIPPING SERVICES PRIVATE LIMITED",
"TRANSMONK INDIA PRIVATE LIMITED",
"TRANSNATIONAL DRILLING & MINING ASSOCIATES PRIVATE LIMITED",
"TRANSNATIONAL SHIPPING INDIA PRIVATE LIMITED",
"TRANS-NOBLES REALTY PRIVATE LIMITED",
"TRANSNOESIS TECHNOLOGIES PRIVATE LIMITED",
"TRANSOCEAN CARGO SERVICES PRIVATE LIMITED",
"TRANSOCEAN DRILLING SERVICES INDIA PRIVATE LIMITED",
"TRANSOCEAN OFFSHORE INTERNTIONAL VENTURES LIMITED",
"TRANSOCEAN RIG 140 LIMITED",
"TRANSOCEAN SHIPPING VENTURES PRIVATE LIMITED",
"TRANSOCEANIC AGRO COMM PRIVATE LIMITED",
"TRANSOFT WEB APPLICATIONS PRIVATE LIMITED",
"TRANSOL GLOBAL FORWARDING PRIVATE LIMITED",
"TRANSOLUTIONS PRIVATE LIMITED",
"TRANSONIC INFRASTRUCTURE PRIVATE LIMITED",
"TRANSONS OVERSEAS (INDIA) PRIVATE LIMITED",
"TRANSOR INDIA PRIVATE LIMITED",
"TRANSORG SOLUTIONS & SERVICES PRIVATE LIMITED",
"TRANSORION LOGISTICS INDIA PRIVATE LIMITED",
"TRANSORION LOGISTICS SERVICES P LIMITED",
"TRANSORZE INFORMATION PROCESSING SOLUTIONS PRIVATE LIMITED",
"TRANSOVATIVE SOLUTIONS PRIVATE LIMITED",
"TRANSPACE TECHNOLOGIES PRIVATE LIMITED",
"TRANSPACIFIC CERTIFICATIONS LIMITED",
"TRANSPACIFIC FREIGHT SERVICES PRIVATE LIMITED",
"TRANSPACIFIC SOFTWARE PRIVATE LIMITED",
"TRANSPACIFIC TRADELINK PRIVATE LIMITED",
"TRANSPADE ENGINEERS PRIVATE. LIMITED.",
"TRANSPARENCY BUILDERS PRIVATE LIMITED",
"TRANSPARENCY MARKET RESEARCH PRIVATE LIMITED",
"TRANSPARENT COGEN SYSTEMS PRIVATE LIMITED",
"TRANSPARENT FINANCE PRIVATE LIMITED",
"TRANSPARENT GLOBAL CONSULTANCY & LOGISTICS PRIVATE LIMITED",
"TRANSPARENT METALS & PIGMENTS PRIVATE LIMITED",
"TRANSPARENT PLAST (INDIA) LIMITED",
"TRANSPARENT TRANSPORT OPERANT PRIVATE LIMITED",
"TRANSPARENT VALUE PRIVATE LIMITED",
"TRANSPARES LIMITED",
"TRANSPEAK COURIERS & LOGISTIC PRIVATE LIMITED",
"TRANSPEED CARGO PRIVATE LIMITED",
"TRANSPEED LOGISTICS PRIVATE LIMITED",
"TRANSPEK INDUSTRY LIMITED",
"TRANSPERFECT SOLUTIONS INDIA PRIVATE LIMITED",
"TRANSPERFECT TRANSLATIONS INTERNATIONAL INC",
"TRANSPIPE INTEGRITY SOLUTIONS PRIVATE LIMITED",
"TRANSPOL IMPEX PRIVATE LIMITED",
"TRANSPOREON INDIA PRIVATE LIMITED",
"TRANSPORT & HANDLING EQUIPMENTS MFG CO PVT LTD",
"TRANSPORT COMMISSIONER MP (RTO OFFICE)",
"TRANSPORT CORPORATION OF INDIA LIMITED",
"TRANSPORT DEPARTMENT",
"TRANSPORT DEPTT PARIVAHAN BHAWAN",
"TRANSPORT ENGINEERING SOLUTIONS INDIA PRIVATE LIMITED",
"TRANSPORT FINANCE LIMITED",
"TRANSPORT WINGS (CAL) PVT LTD",
"TRANSPOSE SOLUTIONS INDIA PRIVATE LIMITED",
"TRANSPOST TECHNOLOGIES PRIVATE LIMITED",
"TRANSPOWER INDIA ELECTRONICS PRIVATE LIMITED",
"TRANSPOWER TECHNOLOGIES PRIVATE LIMITED",
"TRANSPRECISION GEARS PRIVATE LIMITED",
"TRANSPRO ENGINEERING PRIVATE LIMMITED",
"TRANSRAIL LIGHTING LIMITED",
"TRANSRAIL LOGISTICS LIMITED",
"TRANSS TECHNOCONSULTANTS PRIVATE LIMITED",
"TRANSSPHERE LOGISTIKS PRIVATE LIMITED",
"TRANSSTADIA TECHNOLOGIES PRIVATE LIMITED",
"TRANSSYS SOLUTIONS PRIVATE LIMITED",
"TRANSTAR HANDLING & WAREHOUSING PRIVATE LIMITED",
"TRANSTATE LOGISTICS PRIVATE LIMITED",
"TRANSTEC MARKETING AND CONSULTANCY PRIVATE LIMITED",
"TRANSTEC OVERSEAS PRIVATE LIMITED",
"TRANSTECH CHEMICALS PRIVATE LIMITED",
"TRANSTECH EQUIPMENTS PRIVATE LIMITED",
"TRANSTECH GEARS PRIVATE LIMITED",
"TRANSTECH GREEN POWER PRIVATE LIMITED",
"TRANSTECH LOGISTICS PRIVATE LIMITED",
"TRANSTECH PRESS PRODUCTS PRIVATE LIMITED",
"TRANSTECH PROJECTS PRIVATE LIMITED",
"TRANSTECH SHIPPING AND LOGISTICS PRIVATE LIMITED",
"TRANSTECHNOLOGIES THERMAL PRIVATE LIMITED",
"TRANSTECHNOLOGY INDIA PRIVATE LIMITED",
"TRANSTEEL SEATING TECHNOLOGIES LIMITED",
"TRANSTEEL SEATING TECHNOLOGY PRIVATE LIMITED",
"TRANSTEK COAL & MINERALS PRIVATE LIMITED",
"TRANSTEK ENGINEERS & SERVICES PRIVATE LIMITED",
"TRANSTEK INFOWAYS PRIVATE LIMITED",
"TRANSTEL CONTECH PRIVATE LIMITED",
"TRANSTEL UTILITIES PRIVATE LIMITED",
"TRANSTRACK AEROSERVICES PRIVATE LIMITED",
"TRANSTREASURE SERVICES INDIAPRIVATE LIMITED",
"TRANSTREE EXPRESS PRIVATE LIMITED",
"TRANSTRON ELECTRICALS PRIVATE LIMITED.",
"TRANSUNION CIBIL LIMITED",
"TRANSUNION GLOBAL CAPABILITY CENTER PRIVATE LIMITED",
"TRANSUNION GLOBAL TECHNOLOGY CENTER LLP",
"TRANSVEN CONSULTING PRIVATE LIMITED",
"TRANSVERSAL E NETWORKS PRIVATE LIMITED",
"TRANSVICK INDUSTRIES PRIVATE LIMITED",
"TRANSVIEW ENTERPRISE INDIA PRIVATE LIMITED",
"TRANSVISION SHIPPING PRIVATE LIMITED",
"TRANSVISION SOFTWARE & DATA SOLUTIONS PRIVATE LIMITED",
"TRANSVOLT ENGINEERING PRIVATE LIMITED",
"TRANSVOY LOGISTICS INDIA LIMITED",
"TRANSWARRANTY FINANCE LIMITED",
"TRANSWAT ENGINEERING CONSULTANCY PRIVATE LIMITED",
"TRANSWATER LOGISTICS PRIVATE LIMITED",
"TRANSWATER SYSTEM PRIVATE LIMITED",
"TRANSWAY FREIGHT CARRIERS PRIVATE LIMITED",
"TRANSWAYS EXIM PRIVATE LIMITED",
"TRANSWAYS WINE PRIVATE LIMITED",
"TRANSWEB EDUCATIONAL SERVICES PRIVATE LIMITED",
"TRANSWEIGH ENGINEERING INDUSTRIES PRIVATE LIMITED",
"TRANSWELD MECHANICAL ENGINEERING WORKS LIMITED",
"TRANSWELL EXPRESS LOGISTICS P LIMITED",
"TRANSWIND INFRASTRUCTURES LIMITED",
"TRANSWORLD AIRLINES INC.",
"TRANSWORLD BREWERIES AND DISTILLERIES PRIVATE LIMITED",
"TRANSWORLD E CYCLES PRIVATE LIMITED",
"TRANSWORLD EDUCARE PRIVATE LIMITED",
"TRANSWORLD FEEDERS PRIVATE LIMITED",
"TRANSWORLD FURTICHEM PRIVATE LIMITED",
"TRANSWORLD GLOBAL LOGISTICS SOLUTIONS INDIA PRIVATE LIMITED",
"TRANSWORLD INTEGRATED LOGISTEK PRIVATE LIMITED",
"TRANSWORLD INTERNATIONAL RECORDS & DATA MANAGEMENT SERVICES PRIVATE LIMITED",
"TRANSWORLD INTERNATIONAL WAREHOUSING SERVICES PRIVATE LIMITED",
"TRANSWORLD LOGISTICS INDIA PRIVATE LIMITED",
"TRANSWORLD LOGISTICS PRIVATE LIMITED",
"TRANSWORLD MANAGEMENT CONSULTANCY PRIVATE LIMITED",
"TRANSWORLD MEDICAL CORRORTION PRIVATE",
"TRANSWORLD SHIPPING AGENCIES PRIVATE LIMITED",
"TRANSWORLD SHIPPING AND LOGISTICS LIMITED",
"TRANSWORLD SHIPPING AND LOGISTICS PRIVATE LIMITED",
"TRANSWORLD SHOES PRIVATE LIMITED",
"TRANSWORLD SYSTEMS INDIA PRIVATE LIMITED",
"TRANSWORLD TECHNOLOGIES LIMITED",
"TRANSWORLD TERMINALS DADRI PRIVATE LIMITED",
"TRANSWORLD TERMINALS PRIVATE LIMITED",
"TRANSWORLD WOOD PRIVATE. LIMITED.",
"TRANSYS CONSULTING PRIVATE LIMITED",
"TRANSYS GLOBAL FORWADING PRIVATE LIMITED",
"TRANSYS PROJECTS PRIVATE LIMITED",
"TRANSYSTEM LOGISTICS INTERNATIONAL PRIVATE LIMITED",
"TRANSZEND SCIENTIFIC PRIVATE LIMITED",
"TRANSZONE LOGISTICS (INDIA) PRIVATE LIMITED",
"TRANTER INDIA PRIVATE LIMITED",
"TRANTOR SOFTWARE PRIVATE LIMITED",
"TRANWAY TECHNOLOGIES LIMITED",
"TRANXIT TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"TRANZ INDIA CORPORATE NETWORK PRIVATE LIMITED",
"TRANZ MANNEQUINS PRIVATE LIMITED",
"TRANZACT INFORMATION SERVICES P LIMITED",
"TRANZEAL TECHNOLOGIES PRIVATE LIMITED",
"TRANZEVO TECHNOLOGIES PRIVATE LIMITED",
"TRANZFREIGHT LOGISTICS SOLUTIONS PRIVATE LIMITED",
"TRANZITA SYSTEMS",
"TRANZLEASE HOLDINGS INDIA PRIVATE LIMITED",
"TRANZMEDIA NETVISION PRIVATE LIMITED",
"TRANZROAD CONSULTING ENGINEERS PRIVATE LIMITED",
"TRANZTAR COMMERCIAL VEHICLE APPLICATION LIMITED",
"TRANZY TOURS & TRAVELS INDIA PRIVATE LIMITED",
"TRAPASOL INDIA PRIVATE LIMITED",
"TRASANVI LOGISTICS PRIVATE LIMITED",
"TRASCCON INTERCONNECTION SYSTEMS PRIVATE LIMITED",
"TRASCO CORPORATE SOLUTIONS PRIVATE LIMITED",
"TRASHCON LABS PRIVATE LIMITED",
"TRASHIN RECYCLING PRIVATE LIMITED",
"TRASHONOMY PRIVATE LIMITED",
"TRATICO ENGINEERING INDIA PRIVATE LIMITED",
"TRATUM TECHNOLOGIES PRIVATE LIMITED",
"TRAVANCORE AMMONIA PVT LTD",
"TRAVANCORE ANALYTICS PRIVATE LIMITED",
"TRAVANCORE BLUE METAL INDUSTRIES PRIVATE LIMITED",
"TRAVANCORE BUILDERS PRIVATE LIMITED",
"TRAVANCORE COCHIN CHEMICALS LIMITED",
"TRAVANCORE COCOTUFT PRIVATE LIMITED",
"TRAVANCORE COFFEE COMPANY PRIVATE LIMITED",
"TRAVANCORE COPPER FUNGICIDE PRIVATE LIMITED",
"TRAVANCORE FIBRES PRIVATE LIMITED",
"TRAVANCORE GOLD INDIA PRIVATE LIMITED",
"TRAVANCORE GRANITES PVT LTD",
"TRAVANCORE HEALTH CARE PRIVATE LIMITED",
"TRAVANCORE JEWELS PRIVATE LIMITED",
"TRAVANCORE MATS AND MATTING PRIVATE LIMITED",
"TRAVANCORE POLYMERS PRIVATE LIMITED",
"TRAVANCORE RUBBER AND TEA CO LTD",
"TRAVANCORE RURAL DEVELOPMENT PRODUCER COMPANY LIMITED (UNDER PART IXA)",
"TRAVANCORE TITANIUM PRODUCTS LIMITED",
"TRAVANLEO INFO SOLUTIONS ( INDIA) PRIVATE LIMITED",
"TRAVASH SOFTWARE SOLUTIONS PRIVATE LIMITED",
"TRAVCLAN TECHNOLOGY INDIA PRIVATE LIMITED",
"TRAVCOM INDIA PRIVATE LIMITED",
"TRAVCON TRAVELS PRIVATE LIMITED",
"TRAVEAZY TECHNOLOGIES PRIVATE LIMITED",
"TRAVEGO HOLIDAYS AND VISAS P LIMITED",
"TRAVEL AND BEYOND PRIVATE LIMITED",
"TRAVEL BIRD VACATIONS PRIVATE LIMITED",
"TRAVEL BLUE PRODUCTS INDIA PRIVATE LIMITED",
"TRAVEL BULLZ INDIA PRIVATE LIMITED",
"TRAVEL CONCIERGE INDIA (OPC) PRIVATE LIMITED",
"TRAVEL CONSULTANTS",
"TRAVEL CORPORATION INDIA LIMITED",
"TRAVEL CUE MANAGEMENT PRIVATE LIMITED",
"TRAVEL DEALS 24X7",
"TRAVEL DELIGHT PRIVATE. LIMITED",
"TRAVEL DESIGNER INDIA PRIVATE LIMITED",
"TRAVEL DYNAMICS INDIA PRIVATE LIMITED",
"TRAVEL ERA",
"TRAVEL FOOD SERVICES CHENNAI PRIVATE LIMITED",
"TRAVEL FOOD SERVICES DELHI TERMINAL 3 PRIVATE LIMITED",
"TRAVEL FOOD SERVICES KOLKATA PRIVATE LIMITED",
"TRAVEL FOOD SERVICES PRIVATE LIMITED",
"TRAVEL GENIUS",
"TRAVEL HOME PRIVATE LIMITED",
"TRAVEL INDIA PRIVATE LIMITED",
"TRAVEL INDIA TOURISM PRIVATE LIMITED",
"TRAVEL INN INDIA PRIVATE LIMITED",
"TRAVEL LEAF INDIA PRIVATE LIMITED",
"TRAVEL LINKS AND TOURS PRIVATE LIMITED",
"TRAVEL MART",
"TRAVEL MART INDIA COM PRIVATE LIMITED",
"TRAVEL MASTERS INDIA PRIVATE LIMITED",
"TRAVEL MASTERS MUMBAI PRIVATE LIMITED",
"TRAVEL 'N' EASE PRIVATE LIMITED",
"TRAVEL N MORE INDIA PRIVATE LIMITED",
"TRAVEL NEWS SERVICES INDIA PRIVATE LIMITED",
"TRAVEL OYTSER INDIA PRIVATE LIMITED",
"TRAVEL PALS INDIA PRIVATE LIMITED",
"TRAVEL PEDIA PRIVATE LIMITED",
"TRAVEL PLANNERS LIMITED",
"TRAVEL RETAIL SERVICES PRIVATE LIMITED",
"TRAVEL SCOPE INDIA PRIVATE LIMITED",
"TRAVEL SIARA PRIVATE LIMITED",
"TRAVEL SPIRIT INTERNATIONAL PRIVATE LIMITED",
"TRAVEL SYSTEMS LIMITED",
"TRAVEL TIMES (INDIA) PRIVATE LIMITED",
"TRAVEL TIP",
"TRAVEL TOURS PRIVATE LIMITED",
"TRAVEL TROOPS GLOBAL PRIVATE LIMITED",
"TRAVEL UNRAVEL HOLIDAYS PRIVATE LIMITED",
"TRAVEL VOLT PRIVATE LIMITED",
"TRAVEL WORLD TRIP PRIVATE LIMITED",
"TRAVEL XPERT VACATIONS PRIVATE LIMITED",
"TRAVEL.CO.IN LIMITED",
"TRAVELBRIDGE INDIA PRIVATE LIMITED",
"TRAVELER'S MIND PRIVATE LIMITED",
"TRAVELEX INDIA PRIVATE LIMITED",
"TRAVELICIOUS TOURS PRIVATE LIMITED",
"TRAVELLADDER SERVICES PRIVATE LIMITED",
"TRAVELLER'S FASHION PRIVATE LIMITED",
"TRAVELLERS INN HOTELS (INDIA) PRIVATE LIMITED",
"TRAVELLING TRUNK PRIVATE LIMITED",
"TRAVELMANAGER HOLIDAYS INDIA PRIVATE LIMITED",
"TRAVELOGY HOLIDAYS PRIVATE LIMITED",
"TRAVELOGY INDIA PRIVATE LIMITED",
"TRAVELOMATRIX TRIP PLANNERS PRIVATE LIMITED",
"TRAVEL-O-MEDIA SOLUTIONS PRIVATE LIMITED",
"TRAVELONE INDIA PRIVATE LIMITED",
"TRAVELOPOD WORLDWIDE PRIVATE LIMITED",
"TRAVELOX INDIA PRIVATE LIMITED",
"TRAVELS PRIVATE LIMITED",
"TRAVELSCAPES HOTELS PRIVATE LIMITED",
"TRAVELSMITH ADVENTURE PRIVATE LIMITED",
"TRAVELTECH EXPERIENCES PRIVATE LIMITED",
"TRAVELTIME CITY BUS SERVICES (GURUGRAM) PRIVATE LIMITED",
"TRAVELTIME CITY BUS SERVICES (NAGPUR) PRIVATE LIMITED",
"TRAVELTIME MOBILITY INDIA PRIVATE LIMITED",
"TRAVELVOYAGES",
"TRAVELXP INDIA PRIVATE LIMITED",
"TRAVENTURE HOMES PRIVATE LIMITED",
"TRAVENTURE INTERNATIONAL PRIVATE LIMITED",
"TRAVENUES TECHNOLOGY PRIVATE LIMITED",
"TRAVERSE STRATEGY CONSULTANTS PRIVATE LIMITED",
"TRAVERSE TECHNOLOGIES PRIVATE LIMITED",
"TRAVERSIA TECHNOLOGY PRIVATE LIMITED",
"TRAVERZE CONSULTANCY SOLUTIONS PRIVATE LIMITED",
"TRAVIAN FLIGHT SERVICES PRIVATE LIMITED",
"TRAVIS INTERNET PRIVATE LIMITED",
"TRAVIX LEISURE AND TRAVEL PRIVATE LIMITED",
"TRAVLOGUE INDIA PRIVATE LIMITED",
"TRAVOINSPIRE GLOBAL PRIVATE LIMITED",
"TRAVOREX FOREX & TRAVELS PRIVATE LIMITED",
"TRAVPANDA SOLUTIONS PRIVATE LIMITED",
"TRAVSTORE TRAVEL MANAGEMENT PRIVATE LIMITED",
"TRAVTECH SOFTWARE PRIVATE LIMITED",
"TRAVVY TRAVEL SERVICES PRIVATE LIMITED",
"TRAWELMART WORLD TOURS PRIVATE LIMITED",
"TRAWISH PRIVATE LIMITED",
"TRAX INDIA LOGISTICS PRIVATE LIMITED",
"TRAX TIMES ELECTRONICS PRIVATE LIMITED",
"TRAXIT ENGINEERS PRIVATE LIMITED",
"TRAXON INDIA PRIVATE LIMITED",
"TRAXON INVESTMENTS PRIVATE LIMITED",
"TRAXUN TOWERS INDIA PRIVATE LIMITED",
"TRAXYS EUROPE S A",
"TRAYAM CONSULTANCY SERVICES PRIVATE LIMITED",
"TRAYDO LOGISTICS PRIVATE LIMITED",
"TRAYDSTREAM PRIVATE LIMITED",
"TRAYEE BUSINESS SOLUTIONS PRIVATE LIMITED",
"TRAYI CONSULTING PRIVATE LIMITED",
"TRAYMBKESHWAR FOODS PRIVATE LIMITED",
"TRAYO CONSTRUCTION PRIVATE LIMITED",
"TRAYS TUNNEL SOLUTIONS PRIVATE LIMITED",
"TRB INFRATECH PRIVATE LIMITED",
"TRBEX IMPEX PRIVATE LIMITED",
"TRBHI CONSULTING INDIA PRIVATE LIMITED",
"TRC COLD CHAIN SOLUTIONS PRIVATE LIMITED",
"TRC CORPORATE CONSULTING PRIVATE LIMITED",
"TRC ENGINEERING INDIA PRIVATE LIMITED",
"TRC EXPORTS PRIVATE LIMITED",
"TRC HOSPITALITY SERVICES",
"TRC MAHAVIDYALAYA DEPARTMENT OF PHARMACY",
"TRC SOLUTIONS PRIVATE LIMITED",
"TRCAK MATES",
"TRDFIN SUPPORT SERVICES PRIVATE LIMITED",
"TRDP HAPPY WORLD PRIVATE LIMITED",
"TRDP INTERNATIONAL PRIVATE LIMITED",
"TREADFIT TECHNOLOGIES PRIVATE LIMITED",
"TREADSAFE ENGINEERS INDIA PRIVATE LIMITED",
"TREADSTONE ALLIANZ PRIVATE LIMITED",
"TREADSTONE LIMITED",
"TREAMIS WORLD SCHOOL",
"TREASURE ISLAND HOLIDAYS PRIVATE LIMITED",
"TREASURE ORBIT INDIA FMCG PRIVATE LIMITED",
"TREASURE RETAIL PRIVATE LIMITED",
"TREASURE TOURISM CORPORATION LIMITED",
"TREASURE TREE INVESTMENTS LIMITED",
"TREASURE TROVE PICTURES PRIVATE LIMITED",
"TREASURY GWALIOR",
"TREASURY OFFICE JALGAON",
"TREASURY OFFICER VALLABH BHAWAN TREASURY SATPURA BHOPAL",
"TREASURY STAFF BIHAR GOVT",
"TREAT BEAT PRODUCTS PRIVATE LIMITED",
"TREAT HOMES PRIVATE LIMITED",
"TREATMENT POSSIBLE INDIA PRIVATE LIMITED",
"TREATMENT RANGE HOSPITAL PRIVATE LIMITED",
"TREAVIAN INVESTMENTS PRIVATE LIMITED",
"TREBLE CLEF TECHNOLOGY SERVICES PRIVATE LIMITED",
"TRECO WIRE (INDIA) PRIVATE LIMITED",
"TREDENCE ANALYTICS SOLUTIONS PRIVATE LIMITED",
"TREE DESIGN PRIVATE LIMITED",
"TREE ENGINEERING CONSULTANTS PRIVATE LIMITED",
"TREE HILL ESTATES PRIVATE LIMITED",
"TREE HOTELS PRIVATE LIMITED",
"TREE HOUSE CREATIONS PRIVATE LIMITED",
"TREE LINE BUSINESS SOLUTIONS PRIVATE LIMITED",
"TREE OF KNOWLEDGE DIGITAL PRIVATE LIMITED",
"TREE OF KNOWLEDGE DOT COM PRIVATE LIMITED",
"TREE OF LIFE PRIVATE LIMITED",
"TREE TOP RESORTS AND SPA PRIVATE LIMITED",
"TREECAP ADVISORS PRIVATE LIMITED",
"TREEFROG COMMUNICATION SERVICES PRIVATE LIMITED",
"TREEL MOBILITY SOLUTIONS PRIVATE LIMITED",
"TREELIFE VENTURES SERVICES PRIVATE LIMITED",
"TREELINE CORPORATE SERVICES PRIVATE LIMITED",
"TREELY AGRO PANELS PRIVATE LIMITED",
"TREEMARK SOLUTIONS PRIVATE LIMITED",
"TREEMENDOUS PLANTS PRIVATE LIMITED",
"TREEMOUSE RESEARCH & DESIGN PRIVATE LIMITED",
"TREEORE PRIVATE LIMITED",
"TREES RETAIL PRIVATE LIMITED",
"TREESA'S FOOD CRAFTS PRIVATE LIMITED",
"TREESPOON PRIVATE LIMITED",
"TREESTACK MEDIA PRIVATE LIMITED",
"TREEWALKER TECHNOLOGIES INDIA PRIVATE LIMITED",
"TREEZEC E SOLUTIONS PRIVATE LIMITED",
"TREFF TRAVEL TEAM LIMITED",
"TREFFER POWER SYSTEM SOLUTION PRIVATE LIMITED",
"TREFILERIES WIRE INDIA PRIVATE LIMITED",
"TREGUS PRIVATE LIMITED",
"TREHAN AUTOMOTIVES PRIVATE LIMITED.",
"TREHAN DAMODAR ROPEWAYS PRIVATE LIMITED",
"TREHAN HOME DEV PRIVATE LIMITED",
"TREHAN HOSPITALITY AND REALITY PRIVATE LIMITED",
"TREHAN PROMOTERS AND BUILDERS PRIVATE LIMITED",
"TREIS SOLUTIONS LLP",
"TREISTEK INDIA PRIVATE LIMITED",
"TREJHARA SOLUTIONS LIMITED",
"TREK BICYCLE INDIA PRIVATE LIMITED",
"TREK KIT INDIA PRIVATE LIMITED",
"TREKMUNK PRIVATE LIMITED",
"TREKNOCOM ENGINEERING PRIVATE LIMITED",
"TREKOMAC REFURBS PRIVATE LIMITED",
"TREKTONE FOOTWEAR PRIVATE LIMITED",
"TRELA FOOTWEAR EXPORTS PRIVATE LIMITED",
"TRELA OVERSEAS PRIVATE LIMITED",
"TRELION BUSINESS SOLUTIONS PRIVATE LIMITED",
"TRELLEBORG INDIA PRIVATE LIMITED",
"TRELLEBORG MARINE SYSTEMS INDIA PRIVATE LIMITED",
"TRELLEBORG SEALING SOLUTIONS INDIA PRIVATE LIMITED",
"TRELLIS HORTICULTURE INTERNATIONAL PRIVATE LIMITED",
"TRELLISSOFT ENGINEERING SERVICES PRIVATE LIMITED",
"TRELLISYS.NET PRIVATE LIMITED",
"TREMCO CPG INDIA PRIVATE LIMITED",
"TREMENTO EXPORTS PRIVATE LIMITED",
"TRENCH SHORING RENTAL PRIVATE LIMITED",
"TRENCHANT INFOSOFT PRIVATE LIMITED",
"TRENCHLESS ENGINEERING SERVICES PRIVATE LIMITED",
"TRENCHLESS TOOLBOX PRIVATE LIMITED",
"TREND ARREST CLOTHING PRIVATE LIMITED",
"TREND BIO-PRODUCTS PRIVATE LIMITED",
"TREND IMPEX PRIVATE LIMITED",
"TREND INDIA BUSINESS CENTRE PRIVATE LIMITED",
"TREND MICRO INDIA PRIVATE LIMITED",
"TREND MOSAICS VENEZIA PRIVATE LIMITED",
"TREND PLASTPOUCHPACK PRIVATE LIMITED",
"TREND SETTERS BOOKS LIMITED",
"TREND TECHNOLOGIES INDIA PUNE PRIVATE LIMITED",
"TRENDESIGN TECHNICAL CENTER PRIVATE LIMITED",
"TRENDEST TEXKEYS PRIVATE LIMITED",
"TRENDLINE COMMERCIALS PRIVATE LIMITED",
"TRENDLINES RETAIL INDIA LLP",
"TRENDLINES RETAIL PRIVATE LIMITED",
"TRENDLOUD DIGITAL INDIA PRIVATE LIMITED",
"TRENDO FABRICS PRIVATE LIMITED",
"TRENDPHORIA PRIVATE LIMITED",
"TRENDS ADFILM MAKERS PRIVATE LIMITED",
"TRENDS APPAREL PRIVATE LIMITED",
"TRENDS BABY SHOP PRIVATE LIMITED",
"TRENDS EXPORTS PVT LTD",
"TRENDS LIFESTYLE PRIVATE LIMITED",
"TRENDS PHARMA PVT LTD",
"TRENDS POLYMERS PVT LTD",
"TRENDSET BUILDERS PRIVATE LIMITED",
"TRENDSET ROCKS PRIVATE LIMITED",
"TRENDSETTERS FACILITIES & TECHNICAL SERVICES PRIVATE LIMITED",
"TRENDSETTERS SERVICES PRIVATE LIMITED",
"TRENDSETTERS SKILL ASSESSORS PRIVATE LIMITED",
"TRENDSETTERZ IT SERVICES PRIVATE LIMITED",
"TRENDSOFT TECHNOLOGIES PRIVATE LIMITED",
"TRENDSPACE BUSINESS SOLUTIONS PRIVATE LIMITED",
"TRENDSUTRA CLIENT SERVICES PRIVATE LIMITED",
"TRENDWITH CONSULTANCY LTD",
"TRENDY ADVERTISING SERVICES ASSOCIATES PRIVATE LIMITED",
"TRENDY DEALS ECOMMERCE PRIVATE LIMITED",
"TRENDY WHEELS PRIVATE LIMITED",
"TRENDYFROG INDIA PRIVATE LIMITED",
"TRENDYTECH BERA MOTORS PRIVATE LIMITED",
"TRENDYWORKS TECHNOLOGIES PRIVATE LIMITED",
"TRENDZ CLOTHING PRIVATE LIMITED",
"TRENDZ DEVELOPERS PRIVATE LIMITED",
"TRENDZ FOREX INDIA PRIVATE LIMITED",
"TRENDZ HOUSING LLP",
"TRENDZ INFRATECH (INDIA) PRIVATE LIMITED",
"TRENDZ INTERIORS PRIVATE LIMITED",
"TRENDZ PAPER AND STATIONERS (INDIA) PRIVATE LIMITED",
"TRENDZ UTENSILS PRIVATE LIMITED",
"TRENDZONE INDIA PRIVATE LIMITED",
"TRENOVA FASHIONS PRIVATE LIMITED",
"TRENSER TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"TRENT CHEMICAL INDUSTRIES MEGHMANI GROUP",
"TRENT HYPERMARKET LIMITED",
"TRENT HYPERMARKET PRIVATE LIMITED",
"TRENT LIMITED",
"TRENTIUM LIFESCIENCES PRIVATE LIMITED",
"TRENTON INVESTMENTS COMPANY PVT LTD",
"TRENTY ENGINEERING SOLUTIONS PRIVATE LIMITED",
"TRENZ BATH SOLUTIONS",
"TREO ENGINEERING PRIVATE LIMITED",
"TREPUP TECHNOLOGIES PRIVATE LIMITED",
"TRES COMMAS TECHNOLOGIES PRIVATE LIMITED",
"TRES MANOS INDIA PRIVATE LIMITED",
"TRESARA HEALTH LIMITED",
"TRESATA TECHNOLOGIES PRIVATE LIMITED",
"TRESBIEN BIOSYNTH PRIVATE LIMITED",
"TRESBU DIGITAL INDIA PRIVATE LIMITED",
"TRESBU TECHNOLOGIES PRIVATE LIMITED",
"TRESCENT LIFESTYLES PRIVATE LIMITED",
"TRESCHO PACK",
"TRESCO LAB",
"TRESCON GLOBAL BUSINESS SOLUTIONS PRIVATE LIMITED",
"TRESCON LIMITED",
"TRESELLE SYSTEMS PRIVATE LIMITED",
"TRESILIENT BUSINESS SOLUTIONS PRIVATE LIMITED",
"TRESOR HEALTHCARE PRIVATE LIMITED",
"TRESOR SMITH PRIVATE LIMITED",
"TRESOR SYSTEMS PRIVATE LIMITED",
"TRESORIE TRADERS PRIVATE LIMITED",
"TRESPECT INDIA PRIVATE LIMITED",
"TRESTLE FOODS AND BEVERAGES PRIVATE LIMITED",
"TRESVISTA ANALYTICS LLP",
"TRESVISTA FINANCIAL SERVICES PRIVATE LIMITED",
"TRETA AGRO PRIVATE LIMITED",
"TRETANATURE AGRI PRODUCTS PRIVATE LIMITED",
"TREVANI INTERNATIONAL PRIVATE LIMITED",
"TREVI FURNITURE CORP PRIVATE LIMITED",
"TREVISAN INDIA PRIVATE LIMITED",
"TREXCHEM ORGANOSYS PRIVATE LIMITED",
"TREXGEN PHARMACEUTICALS PRIVATE LIMITED",
"TREXO FAB INDUSTRIES",
"TREXTA INDIA LEATHER ACCESSORIES MANUFACTURING COMPANY PRIVATE L",
"TREYA WIRELESS PRIVATE LIMITED",
"TRF LIMITED.",
"TRG ADVISORS INDIA PRIVATE LIMITED",
"TRG MAJESTIC PORTFOLIO PRIVATE LIMITED",
"TRG PACKAGINGS PRIVATE LIMITED",
"TRG TOOLS PRIVATE LIMITED",
"TRI ELECTRIC PRIVATE LIMITED",
"TRI FORCE SECURITY PRIVATE LIMITED",
"TRI GASES PRIVATE LIMITED",
"TRI MEDIX PHARMA PRIVATE LIMITED",
"TRI MOHAN INNS PRIVATE LIMITED",
"TRI O TECH SOLUTIONS PRIVATE LIMITED",
"TRI POLARCON PRIVATE LIMITED",
"TRI SOLAR PRIVATE LIMITED",
"TRI SPEED CARGO PRIVATE LIMITED",
"TRI STAR DECOR INDIA PRIVATE LIMITED",
"TRIA FOOD PRODUCTS PRIVATE LIMITED",
"TRIA INDUSTRIES LLP",
"TRIACE MACHINES PRIVATE LIMITED",
"TRIAD ENGINEERING WORKS PRIVATE LTD.",
"TRIAD EXPORTS PRIVATE LIMITED",
"TRIAD SOFTWARE PRIVATE LIMITED",
"TRIAD SQUARE INFOSEC PRIVATE LIMITED",
"TRIAD TECHNOLOGIES PRIVATE LIMITED",
"TRIAD TECHNOMET PRIVATE LIMITED",
"TRIADSS CONSULTING SERVICES PRIVATE LIMITED",
"TRIADSS TECH SOLUTIONS PRIVATE LIMITED",
"TRIAGE INDUSTRIES PRIVATE LIMITED",
"TRIAGE MEDITECH PRIVATE LIMITED",
"TRIAGE OVERSEAS",
"TRIALLIANCE GLOBAL SOLUTIONS INDIA PRIVATE LIMITED",
"TRIAM SYSTEMS PRIVATE LIMITED",
"TRIAMBIKA FOODS PRIVATE LIMITED",
"TRIANGLE BERRY MEDIA AND ENTERTAINMENT PRIVATE LIMITED",
"TRIANGLE ENGINEERS PRIVATE LIMITED",
"TRIANGLE INFRASTRUCTURE PRIVATE LIMITED",
"TRIANGLE PROPERTY DEVELOPERS PRIVATE LIMITED",
"TRIANGLE SIMULATION PRIVATE LIMITED",
"TRIANGLE TECHNOLOGIES PRIVATE LIMITED",
"TRIANGLE TRADING & INFRA PRIVATE LIMITED",
"TRIANGLE WEAVERS PRIVATE LIMITED",
"TRIANGULAR AUTOMATION PRIVATE LIMITED",
"TRIANGULAR DOTS CREATIVE SOLUTIONS PRIVATE LIMITED",
"TRIANGULAR INFOSOLUTIONS PRIVATE LIMITED",
"TRIANGULUM CHEMICALS PRIVATE LIMITED",
"TRIANGULUM EMBEDDED INNOVATIVE SOLUTIONS PRIVATE LIMITED",
"TRIANZ DIGITAL CONSULTING PRIVATE LIMITED",
"TRIANZ HOLDINGS P LIMITED.",
"TRIANZ IT & CLOUD SOLUTIONS PRIVATE LIMITED",
"TRIASSIC SOLUTIONS PRIVATE LIMITED",
"TRIATURE DIGITAL MARKETING AND TECHNOLOGY PRIVATE LIMITED",
"TRIATURE DIGITAL MARKETING PRIVATE LIMITED",
"TRIAVSAAT COUSINS TRADING PRIVATE LIMITED",
"TRIBAL BOX MEDIA PRIVATE LIMITED",
"TRIBAL DEVELOPMENT COMMISSIONER",
"TRIBAL DEVELOPMENT COOPERATIVE CORPARATION OF ODISHA LIMITED",
"TRIBAL EARTH SOUNDS (INDIA) PRIVATE LIMITED",
"TRIBAL FUSION R & D LLP",
"TRIBAL FUSION R&D PRIVATE LIMITED",
"TRIBAL OFFICE ASSTT COMMISSIONER TRIBAL DEVELOPMENT RAIGARH",
"TRIBAL RESEARCH & TRAINING INSTITUTE",
"TRIBAL WELFARE DEPARTMENT",
"TRIBAL WELFARE DEPARTMENT KHARSIA RAIGARH C.G",
"TRIBE INVESTMENTS AND SERVICES PRIVATE LIMITED",
"TRIBECA CARE PRIVATE LIMITED",
"TRIBECA COPPERS PRIVATE LIMITED",
"TRIBECA CREATORS LLP",
"TRIBEL WELFARE DEPARTMENT KHARSIA RAIGARH C G",
"TRIBENAUTIX ECOMMERCE CONSULTANTS PRIVATE LIMITED",
"TRIBENI METALLOYS PRIVATE LIMITED",
"TRIBENI PROCESSORS PRIVATE LIMITED",
"TRIBENI RESOURCES PVT LTD",
"TRIBENI TECHNOCOM LTD",
"TRIBENI WORLDWIDE PRIVATE LIMITED",
"TRIBES COMMUNICATION PRIVATE LIMITED",
"TRIBEVIBE ENTERTAINMENT PRIVATE LIMITED",
"TRIBHOVAN DAS FOUNDATION TRUST HOSPITAL",
"TRIBHOVANDAS BHIMJI ZAVERI (DELHI) PRIVATE LIMITED",
"TRIBHOVANDAS BHIMJI ZAVERI AND SONS INDIA PRIVATE LIMITED",
"TRIBHOVANDAS BHIMJI ZAVERI BOMBAY LIMITED",
"TRIBHOVANDAS BHIMJI ZAVERI JEWELLERS",
"TRIBHOVANDAS BHIMJI ZAVERI LIMITED",
"TRIBHUVAN APPARELS PRIVATE LIMITED",
"TRIBHUVAN CARRIER PRIVATE LIMITED",
"TRIBHUVAN INDUSTRIES LIMITED.",
"TRIBHUVAN INDUSTRIES PRIVATE LIMITED",
"TRIBHUVAN SPINTEX PRIVATE LIMITED",
"TRIBHUVANSONS JEWELLERS PRIVATE LIMITED",
"TRIBHUWAN BUSINESSES PRIVATE LIMITED",
"TRIBI SYSTEMS PRIVATE LIMITED",
"TRIBO LUBES PRIVATE LIMITED",
"TRIBOLOGY INDIA LIMITED",
"TRIBOND WORLDWIDE LOGISTIC PRIVATE LIMITED",
"TRIBOX DESIGN SOLUTIONS PRIVATE LIMITED",
"TRIBULUS TECH SOLUTIONS PRIVATE LIMITED",
"TRIBUNE DIGITAL VENTURES SOFTWARE DEVELOPMENT CENTER INDIA PRIVATE LIMITED",
"TRIBURG CONSULTANTS PRIVATE LIMITED",
"TRIBURG SOURCING SERVICES PRIVATE LIMITED",
"TRIBURG SPORTSWEAR AGENCY SERVICES LLP",
"TRIBURG SPORTSWEAR PRIVATE LIMITED",
"TRIBUS INDUSTRIES PRIVATE LIMITED",
"TRIBUS ORIGINAL FOODS PRIVATE LIMITED",
"TRIBUS POINT SOFTWARE PRIVATE LIMITED",
"TRIBUTUM CONSULTANTS PRIVATE LIMITED",
"TRICAD DESIGN CONSULTANTS PRIVATE LIMITED",
"TRICADIA INFRATECH PRIVATE LIMITED",
"TRICAP INDIA CAPITAL PRIVATE LIMITED",
"TRICARE SERVICES PRIVATE LIMITED",
"TRICELL BIOLOGICS PRIVATE LIMITED",
"TRICENT SOFTWARE SOLUTIONS PRIVATE LIMITED",
"TRICENTIS INDIA PRIVATE LIMITED",
"TRICEPT LIFE SCIENCE PRIVATE LIMITED",
"TRICHEM HEALTHCARE PRIVATE LIMITED",
"TRICHEM INTERMEDIATES PRIVATE LIMITED",
"TRICHEM LABORATORIES BOMBAY PRIVATE LIMITED",
"TRICHEM LIFE SCIENCES LIMITED",
"TRICHEM SOLUTIONS PRIVATE LIMITED",
"TRICHIKAVERI FOODS PRIVATE LIMITED",
"TRICHIRAPALLI COLL OF ENG TECH",
"TRICHROMY ENTERPRISES PRIVATE LIMITED",
"TRICHUR DISTRICT CO-OP BANK",
"TRICHUR HEART HOSPITAL",
"TRICHUR METROPOLITAN HEALTH CARE PRIVATE LIMITED",
"TRICHUR SUNDARAM SANTHANAM & FAMILY PRIVATE LIMITED",
"TRICHUR TOWERS HOTEL PRIVATE LIMITED",
"TRICHUR TREAD RUBBER PRIVATE LIMITED",
"TRICHY COLD STORAGE PRIVATE LIMITED",
"TRICHY COLLEGE OF PHARAMACY",
"TRICHY SRI KANNAN TRANSPORTS PRIVATE LIMITED",
"TRICHY TOLLWAY PRIVATE LIMITED",
"TRICIL PACKAGING PRIVATE LIMITED",
"TRICITIES SECURITY AND ALLIED SERVICES PRIVATE LIMITED",
"TRICITY EDUCATORS PRIVATE LIMITED",
"TRICITY INFRA PLANNERS & DEVELOPERS PRIVATE LIMITED",
"TRICITY INSTITUTE OF PLASTIC SURGERY PRIVATE LIMITED",
"TRICITY TECHNOLOGIES PRIVATE LIMITED",
"TRICKSHOT SOLUTIONS PRIVATE LIMITED",
"TRICLAD BIOTECH PRIVATE LIMITED",
"TRICOG HEALTH INDIA PRIVATE LIMITED",
"TRICOLITE ELECTRICAL INDUSTRIES LIMITED.",
"TRICOLOR BUSINESS SERVICES PRIVATE LIMITED",
"TRICOLOR INDIA SCHAUSPIEL PRIVATE LIMITED",
"TRICOLOR MARKETING SOLUTIONS PRIVATE LIMITED",
"TRI-COLOUR AUTO PRIVATE LIMITED",
"TRICOLOUR AUTOMATION PRIVATE LIMITED",
"TRICOLOUR EVOKE SPORTS PRIVATE LIMITED",
"TRICOLOUR HOLIDAYS PRIVATE LIMITED",
"TRICOLOUR HOSPITALS",
"TRICOLOUR MEDIA PRIVATE LIMITED",
"TRICOLOUR PROPERTIES P LIMITED",
"TRICOM IMPRESS PRIVATE LIMITED",
"TRICOM MULTIMEDIA PRIVATE LIMITED",
"TRICOM PHARMACEUTICALS PRIVATE LIMITED",
"TRICON BUILDWELL PRIVATE LIMITED",
"TRICON COMMODITIES TRADING PRIVATE LIMITED",
"TRICON ENERGY INDIA PRIVATE LIMITED",
"TRICON ENGINERING",
"TRICON ENTERPRISES PRIVATE LIMITED",
"TRICON GLOBAL SERVICES PRIVATE LIMITED",
"TRICON INFOTECH PRIVATE LIMITED",
"TRICON INFRA BUILDTECH PRIVATE LIMITED",
"TRICON POLYFABS PRIVATE LIMITED",
"TRICON POLYMERS PRIVATE LIMITED",
"TRICON REALTECH PRIVATE LIMITED",
"TRICON SPECIALITY CHEMICAL PRIVATE LIMITED",
"TRICON SYSTEM PRIVATE LIMITED",
"TRICON TECHNOLOGIES PRIVATE LIMITED",
"TRICON TRADERS PRIVATE LIMITED",
"TRICONE BUILDING PRODUCTS (INDIA) PRIVATE LIMITED",
"TRICONE PROJECTS INDIA LIMITED",
"TRICONNECT INFRA PRIVATE LIMITED",
"TRICONTINENTAL RESEARCH SERVICES PRIVATE LIMITED",
"TRICOR TRIBAL WELFARE DEPARTMENT",
"TRICORE INFO TECH PRIVATE LIMITED",
"TRICORE SOLUTIONS PRIVATE LIMITED",
"TRICOS DERMATOLOGICS PRIVATE LIMITED",
"TRICTA TECHNOLOGIES PRIVATE LIMITED",
"TRICTY CREATORS PRIVATE LIMITED",
"TRICYCLE TRIBE CREATIVE VENTURES PRIVATE LIMITED",
"TRID TECHNO CRAFT PRIVATE LIMITED",
"TRIDAC SOLUTION PRIVATE LIMITED",
"TRIDAT TECHNOLOGIES PRIVATE LIMITED",
"TRIDAX ENGINEERING SOFTWARES PRIVATE LIMITED",
"TRIDE INNOVATIVE TECHNOLOGIES PRIVATE LIMITED",
"TRIDEANT ELEXI PRIVATE LIMITED",
"TRIDEL TECHNOLOGIES PRIVATE LIMITED",
"TRIDENT (INDIA) LIMITED",
"TRIDENT ACADEMY OF TECHNOLOGY",
"TRIDENT AGENCIES PRIVATE LIMITED",
"TRIDENT AGRI PRIVATE LIMITED",
"TRIDENT AGROCOM EXPORTS PRIVATE LIMITED",
"TRIDENT ARCHITECTURAL ALUMINIUM PRODUCTS PRIVATE LIMITED",
"TRIDENT AUTO COMPONENTS PRIVATE LIMITED",
"TRIDENT AUTO ENTERPRISES PRIVATE LIMITED",
"TRIDENT AUTO PRIVATE LIMITED",
"TRIDENT AUTOMOBILES (BANGALORE) PRIVATE LIMITED",
"TRIDENT AUTOMOBILES PRIVATE LIMITED",
"TRIDENT BUILDTECH PRIVATE LIMITED",
"TRIDENT BUILDWELL PRIVATE LIMITED",
"TRIDENT CHEMPHAR LIMITED",
"TRIDENT COATINGS PRIVATE LIMITED",
"TRIDENT COLD CHAIN SOLUTIONS PRIVATE LIMITED",
"TRIDENT COLOURS PRIVATE LIMITED",
"TRIDENT CREATION PRIVATE LIMITED",
"TRIDENT DIAGNOSTICS",
"TRIDENT DIESEL SYSTEMS PRIVATE LIMITED",
"TRIDENT ENTERPRISES",
"TRIDENT EPC LIMITED",
"TRIDENT EQUIPMENTS PRIVATE LIMITED",
"TRIDENT ESTATES PRIVATE LIMITED",
"TRIDENT EXHIBITORS PRIVATE LIMITED",
"TRIDENT FABRICATORS PRIVATE LIMITED",
"TRIDENT FASTENERS",
"TRIDENT FINANCIAL SERVICES PRIVATE LIMITED",
"TRIDENT GENTECH PRIVATE LIMITED",
"TRIDENT GLOBAL CORP LIMITED",
"TRIDENT GROUP",
"TRIDENT HOTELS PRIVATE LIMITED",
"TRIDENT HUMAN RESOURCE MANAGEMENT PRIVATE LIMITED",
"TRIDENT INFORMATION SYSTEMS PRIVATE LIMITED",
"TRIDENT INFOSOL PRIVATE LIMITED",
"TRIDENT INFRAHOMES PRIVATE LIMITED",
"TRIDENT INFRAPROJECTS PRIVATE LIMITED",
"TRIDENT INFRASTRUCTURE",
"TRIDENT INSTITUTE OF SOCIAL SCIENCES",
"TRIDENT INTERNATIONAL PRIVATE LIMITED",
"TRIDENT IRON & STEEL PRIVATE LIMITED",
"TRIDENT JAIPUR A UNIT OF EIH ASSOCIATED HOTELS LIMITED",
"TRIDENT JEWELS PRIVATE LIMITED",
"TRIDENT LIFELINE LIMITED",
"TRIDENT LIMITED",
"TRIDENT MANPOWER MANAGEMENT PRIVATE LIMITED",
"TRIDENT MARBLES PRIVATE LIMITED",
"TRIDENT MARKETING STRATEGIES PRIVATE LIMITED",
"TRIDENT MEDIQUIP LIMITED",
"TRIDENT MEDLIFE PRIVATE LIMITED",
"TRIDENT MEDSOLUTIONS PRIVATE LIMITED",
"TRIDENT MICROSYSTEMS INDIA PRIVATE LIMITED",
"TRIDENT OVERSES GROUP",
"TRIDENT PNEUMATICS PRIVATE LIMITED",
"TRIDENT POLYCHEM PRIVATE LIMITED",
"TRIDENT POWER PRIVATE LIMITED",
"TRIDENT PRODUCTS PRIVATE LIMITED",
"TRIDENT PROPERTIES PRIVATE LIMITED",
"TRIDENT SERVICES PRIVATE LIMITED",
"TRIDENT SOLUTIONS PRIVATE LIMITED",
"TRIDENT SPARK INFOTECH",
"TRIDENT STAFF SOLUTIONS PRIVATE LIMITED",
"TRIDENT STRUCTURES PRIVATE LIMITED",
"TRIDENT TECHLABS LIMITED",
"TRIDENT TECHLABS PRIVATE. LIMITED.",
"TRIDENT TECHNICAL RESOURCES PRIVATE LIMITED",
"TRIDENT TELESERVICES PRIVATE LIMITED",
"TRIDENT TEXOFAB LIMITED",
"TRIDENT THOUGHTS ORIGINATION PRIVATE LIMITED",
"TRIDENT TIMESHARE PRIVATE LIMITED",
"TRIDENT VALVES PRIVATE LIMITED",
"TRIDEV BUSINESS PRIVATE LIMITED",
"TRIDEV ENGICON PRIVATE LIMITED",
"TRIDEV GUAR GUM AND CHEMICALS PRIVATE LIMITED",
"TRIDEV INDUSTRIES PRIVATE LIMITED",
"TRIDEV ISPAT PRIVATE LIMITED TIPL",
"TRIDEV JEWELLERS PRIVATE LIMITED",
"TRIDEV METAL INDUSTRIES PRIVATE LIMITED",
"TRIDEV MULTI TRADE PRIVATE LIMITED",
"TRIDEV PROJECTS PRIVATE LIMITED",
"TRIDEV RESINS INDIA PRIVATE LIMITED",
"TRIDEV RESINS PRIVATE LIMITED",
"TRIDEV SPICES PRIVATE LIMITED",
"TRIDEV URJA PRIVATE LIMITED",
"TRIDEVVISION INFRATECH PRIVATE LIMITED",
"TRIDEX SOLUTIONS PRIVATE LIMITED",
"TRIDHA ARUDOLF STEINER SCHOOL",
"TRIDHAA WORLDWIDE LOGISTICS PRIVATE LIMITED",
"TRIDHAATU CONSTRUCTIONS PRIVATE LIMITED",
"TRIDHAATU REALTY AND INFRA PRIVATE LIMITED",
"TRIDHATU MINERALS PRIVATE LIMITED",
"TRIDHYA TECH LIMITED",
"TRIDIAGONAL SOFTWARE PRIVATE LIMITED",
"TRIDIAGONAL SOLUTIONS PRIVATE LIMITED",
"TRIDIB INDUSTRIES LIMITED",
"TRIDINDIA IT TRANSLATION SERVICES PRIVATE LIMITED",
"TRIDISENO INDIA LIMITED",
"TRIDOSS LABORATORIES LIMITED",
"TRIDZ TECHNOLOGIES PRIVATE LIMITED",
"TRIE CODERS PRIVATE LIMITED",
"TRIECO GREEN PRIVATE LIMITED",
"TRIEKA INNOVATIONS PRIVATE LIMITED",
"TRIENDO IMPEX PRIVATE LIMITED",
"TRIENITY CONTAINERS PRIVATE LIMITED",
"TRIERA VENTURES PRIVATE LIMITED",
"TRIE-VIZ INFRACON PRIVATE LIMITED",
"TRI-EXCLE AGRO VENTURE SERVICES PRIVATE LIMITED",
"TRIF REAL ESTATE AND DEVELOPMENT PRIVATE LIMITED",
"TRIFECTA ENTERTAINMENT PRIVATE LIMITED",
"TRIFECTA PROJECTS PRIVATE LIMITED",
"TRIFFORTS PROJECTS (INDIA) PRIVATE LIMITED",
"TRIFIN INFORMATION TECHNOLOGY PRIVATE LIMITED",
"TRIFLEX INK PRIVATE LIMITED",
"TRIFLI TECHNOLOGIES PRIVATE LIMITED",
"TRIFLO TECHNOLOGIES PRIVATE LIMITED",
"TRI-FLP ENGINEERS PRIVATE LIMITED",
"TRIG DETECTIVES PRIVATE LIMITED",
"TRIG GUARDFORCE LIMITED",
"TRIG TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"TRIGAT LIFE SCIENCES PRIVATE LIMITED",
"TRIGEL PETROCHEM PRIVATE LIMITED",
"TRIGEM INFOSOLUTIONS LIMITED",
"TRIGENESIS CHEMICALS PRIVATE LIMITED",
"TRIGENT SOFTWARE PRIVATE LIMITED",
"TRIGEO TECHNOLOGIES PRIVATE LIMITED",
"TRIGGER APPARELS LIMITED",
"TRIGGER MARKETING LIMITED",
"TRIGGER SUPPLY PVT LTD",
"TRIGGERHAPPY ENTERTAINMENT PRIVATE LIMITED",
"TRIGGERISE INDIA PRIVATE LIMITED",
"TRIGITAL SOLUTIONS PRIVATE LIMITED",
"TRIGLOBAL LIFESCIENCES (OPC) PRIVATE LIMITED",
"TRIGMA SOLUTIONS PRIVATE LIMITED",
"TRIGNO ENGINEERING PRIVATE LIMITED",
"TRIGNODEV SOFTWARES PRIVATE LIMITED",
"TRIGNOSOFT SOLUTIONS PRIVATE LIMITED",
"TRIGO QUALITY PRODUCTION SERVICES PRIVATE LIMITED",
"TRIGON ANTIOXIDANTS PRIVATE LIMITED",
"TRIGON CHEMICALS PRIVATE LIMITED",
"TRIGON DIGIPACK PRIVATE LIMITED",
"TRIGON ENTERPRISES PRIVATE LIMITED",
"TRIGON INFORMATICS PRIVATE LIMITED",
"TRIGON SYNERGIES PRIVATE LIMITED",
"TRIGON TOOLING SOLUTIONS PRIVATE.LIMITED.",
"TRIGON TRANSIT PRIVATE LIMITED",
"TRIGON TS LLP",
"TRIGUN TECHNOLOGY PRIVATE LIMITED",
"TRIGUNA AGRITECH PRIVATE LIMITED",
"TRIGUNA FARMS PRIVATE LIMITED",
"TRIGUNA HOSPITALITY VENTURES INDIA PRIVATE LIMITED",
"TRIGUNI FOOD PRIVATE LIMITED",
"TRIGYA TECHNOLOGIES PRIVATE LIMITED",
"TRIGYN TECHNOLOGIES INDIA PRIVATE LIMITED",
"TRIGYN TECHNOLOGIES LIMITED",
"TRIHUND SOLUTIONS PRIVATE LIMITED",
"TRIJAL CONSTRUCTIONS PRIVATE LIMITED",
"TRIJAL ELECTRIKALS PRIVATE LIMITED",
"TRIJAL ENTERPRISES PRIVATE LIMITED",
"TRIJAMA FILTERALL (INDIA) PRIVATE LIMITED",
"TRIJITH INTERNATIONAL PRIVATE LIMITED",
"TRIJOG - KNOW YOUR MIND PRIVATE LIMITED",
"TRIKA TECHNOLOGIES PRIVATE LIMITED",
"TRIKAAL ADVERTISING PRIVATE LIMITED",
"TRIKAAL TECH ENTERPRISES PRIVATE LIMITED",
"TRIKAAL THEATRES AND REALTY INDIA PRIVATE LIMITED",
"TRIKALA INDUSTRIES INDIA PRIVATE LIMITED",
"TRIKAUSCH INDIA PRIVATE LIMITED",
"TRIKAYA AGRICULTURE PRIVATE LIMITED",
"TRIKAYA COATINGS PRIVATE LIMITED",
"TRIKOM SHIPPING PRIVATE LIMITED",
"TRIKON ELECTRONICS PRIVATE LIMITED",
"TRIKON MACHINE PRIVATE LIMITED",
"TRIKON TELESOFT SOLUTIONS PRIVATE LIMITED",
"TRIKUT INFO SERVICES PRIVATE LIMITED",
"TRIKUTA AGRI SEEDS PRIVATE LIMITED",
"TRIKUTA AGRO PRODUCTS PRIVATE LIMITED",
"TRIKUTA AGROFRESH AND DAIRY INDUSTRIES PRIVATE LIMITED",
"TRIKUTA COMMUNICATIONS PRIVATE LIMITED",
"TRIKUTA MOTORS PRIVATE LIMITED",
"TRIKUTA RETAILERS PRIVATE LIMITED",
"TRIKUTA ROLLER FLOUR MILLS PRIVATE LIMITED",
"TRIKUTA WASINI INFRATECH PRIVATE LIMITED",
"TRIL BENGALURU CONSULTANTS PRIVATE LIMITED",
"TRIL INFOPARK LIMITED",
"TRIL ROADS PRIVATE LIMITED",
"TRILASOFT SOLUTIONS PRIVATE LIMITED",
"TRILEGAL",
"TRILIG ENERGY PRIVATE LIMITED",
"TRILLBIT SOLUTIONS PRIVATE LIMITED",
"TRILLERVERZ PRIVATE LIMITED",
"TRILLION JEWELS PRIVATE LIMITED",
"TRILLIONLOANS FINTECH PRIVATE LIMITED",
"TRILLIUM IT SOLUTIONS PRIVATE LIMITED",
"TRILLIUM VENTURES PRIVATE LIMITED",
"TRILOCANA LOGISTICS PRIVATE LIMITED",
"TRILOCHAN EDUCATIONAL SERVICES PRIVATE LIMITED",
"TRILOCHAN FOODS PRIVATE LIMITED",
"TRILOCHAN PROJECTS AND DEVELOPERS PRIVATE LIMITED",
"TRILOGIC DIGITAL MEDIA LIMITED",
"TRILOK CHEMICALS PVT LTD",
"TRILOK COTTON PRIVATE. LIMITED.",
"TRILOK ENTERPRISES PRIVATE LIMITED",
"TRILOK FABRICATION AND EQUIPMENTS PRIVATE LIMITED",
"TRILOK FOODS PRIVATE LIMITED",
"TRILOK LABORATORIES PRIVATE LIMITED",
"TRILOK NIRMAN PRIVATE LIMITED",
"TRILOK PHARMA PRIVATE LIMITED",
"TRILOK PRECAST PRIVATE LIMITED",
"TRILOK PROPERTIES PRIVATE LIMITED",
"TRILOKESHWAR ESTATES PRIVATE LIMITED",
"TRIM INDIA PRIVATE LIMITED",
"TRIM PAINTS PRIVATE LIMITED",
"TRIMAAX TECHLONOGIES PRIVATE LIMITED",
"TRIMAC PRODUCTS PRIVATE LIMITED",
"TRIMACIMPEX TRADING PRIVATE LIMITED",
"TRIMASTER PRIVATE LIMITED",
"TRIMASYS CONTROL SOLUTIONS PRIVATE LIMITED",
"TRIMATIC SOLUTIONS PRIVATE LIMITED",
"TRIMAX BIO SCIENCE PRIVATE. LIMITED.",
"TRIMAX FORWARDERS INDIA PRIVATE LIMITED",
"TRIMAX INTERNATIONAL PRIVATE LIMITED",
"TRIMAX MARKETING PRIVATE LIMITED",
"TRIMAX SMART INFRAPROJECTS PRIVATE LIMITED",
"TRIMAX UMBRELLA PRIVATE LIMITED",
"TRIMAXINC PRECISION TOOLING PRIVATE LIMITED",
"TRIMBAKESHWAR COTTON CORPORATION",
"TRIMBAKESHWAR ENGINEERING PRIVATE LIMITED",
"TRIMBAKESHWAR STEEL AND ALLOYS PRIVATE LIMITED",
"TRIMBAKRAJ AGROTECH PRIVATE LIMITED",
"TRIMBEKSHWAR AGRO INDUSTRIES PRIVATE LIMITED",
"TRIMBHAK INVESTMENT AND FINANCE SERVICES PRIVATE LIMITED",
"TRIMBLE INFORMATION TECHNOLOGIES INDIA PRIVATE LIMITED",
"TRIMBLE NAVIGATION INDIA PRIVATE LIMITED",
"TRIMBLE SOLUTIONS INDIA PRIVATE LIMITED",
"TRIMCO (INDIA) PRIVATE LIMITED",
"TRIMECH ENGINEERS PRIVATE LIMITED",
"TRIMECH INDIA PRIVATE LIMITED",
"TRIMED SOLUTIONS INDIA PRIVATE LIMITED",
"TRIMED SYSTEMS PRIVATE LIMITED",
"TRIMEDX INDIA PRIVATE LIMITED",
"TRIMEN LOGISTICS PRIVATE LIMITED",
"TRIMERGE GLOBAL INFOTECH PRIVATE LIMITED",
"TRIMEX FISCAL SERVICES PVT LTD",
"TRIMEX FOODS PRIVATE LIMITED",
"TRIMEX INDUSTRIES PRIVATE LIMITED",
"TRIMEX ORES PRIVATE LIMITED",
"TRIMEX RESOURCES PRIVATE LIMITED",
"TRIMEX SANDS PRIVATE LIMITED",
"TRI-MILLENNIAL DESIGN AND SERVICE ENGINEERS PRIVATE LIMITED",
"TRIMIND TECH SOLUTIONS PRIVATE LIMITED",
"TRIMODAL SOFTECH SOLUTIONS PRIVATE LIMITED",
"TRIMODE PROPERTIES PRIVATE LIMITED",
"TRIMOORTI ELECTRICALS SERVICES PRIVATE LIMITED",
"TRIMOORTI POWER MANAGEMENT PRIVATE LIMITED",
"TRIMOORTY AUTODECO COMPONENTS PRIVATE LIMITED",
"TRIMOS INDIA PRIVATE LIMITED",
"TRIMOS METROLOGY INDIA PRIVATE LIMITED",
"TRIMPACKS SERVICES PRIVATE LIMITED",
"TRIMPLEX INVESTMENTS LIMITED",
"TRIMUDRA TRADE & HOLDINGS P LTD",
"TRIMUKHE HEART AND CHEST SUPER SPECIALITY HOSPITAL",
"TRIMULA SPONGE IRON PRIVATE LIMITED",
"TRIMURTHI HITECH COMPANY PRIVATE LIMITED",
"TRIMURTHI LIMITED",
"TRIMURTI ASSOCIATES PVT LTD",
"TRIMURTI AUTO SALES PRIVATE LIMITED",
"TRIMURTI BUILDTECH PRIVATE LIMITED",
"TRIMURTI BUILDWELL PRIVATE LIMITED",
"TRIMURTI CAD CAM PRIVATE LIMITED",
"TRIMURTI CARGO MOVERS PRIVATE LIMITED",
"TRIMURTI CARS PRIVATE LIMITED",
"TRIMURTI COLONISERS AND CONSTRUCTIONS PRIVATE LIMITED",
"TRIMURTI CONCERN PRIVATE LIMITED",
"TRIMURTI EARTHMOVERS & INFRA BUILDCON PRIVATE LIMITED",
"TRIMURTI ENGIMETAL AND STEEL WORKS PRIVATE LIMITED",
"TRIMURTI ENGINEERING SERVICES",
"TRIMURTI ENGINEERING TOOLS PRIVATE LIMITED",
"TRIMURTI FABRICATORS PRIVATE LIMITED",
"TRIMURTI FILMS PRIVATE LIMITED",
"TRIMURTI FLOUR MILL PRIVATE LIMITED",
"TRIMURTI FRAGRANCES PRIVATE LIMITED",
"TRIMURTI GRIHANIRMAN PRIVATE LIMITED",
"TRIMURTI HARDWARE AND PLYWOOD PRIVATE LIMITED",
"TRIMURTI HEIGHTS AND PROPERTIES PRIVATE LIMITED",
"TRIMURTI HOSIERY MILLS PRIVATE LIMITED",
"TRIMURTI INDUSTRIES PRIVATE LIMITED",
"TRIMURTI INFRA LOGISTICS PRIVATE LIMITED",
"TRIMURTI ISPAT LIMITED",
"TRIMURTI K.B.RAJ. HOUSING CONSTRUCTION PRIVATE LIMITED",
"TRIMURTI LIFESTYLE PRIVATE LIMITED",
"TRIMURTI MILK PROCESSING PRIVATE LIMITED",
"TRIMURTI OVERSEAS LIMITED",
"TRIMURTI PESTICIDES PRIVATE LIMITED",
"TRIMURTI PLANT SCIENCES PRIVATE LIMITED",
"TRIMURTI PLAST CONTAINERS PRIVATE LIMITED",
"TRIMURTI PUBLICITY & MARKETING PRIVATE LIMITED",
"TRIMURTI RE-ROLLERS PRIVATE LIMITED",
"TRIMURTI SHELTERS PRIVATE LIMITED",
"TRIMURTI SOLAR STEAM PRIVATE LIMITED",
"TRIMURTI STAINLINK EQUIPMENTS PRIVATE LIMITED",
"TRIMURTI VELVET PRIVATE LIMITED",
"TRIMURTI WALL CARE PRODUCTS PRIVATE LIMITED",
"TRIMURTY COLONIZERS AND BUILDERS INDIA PRIVATE LIMITED",
"TRIMURTY COLONIZERS AND BUILDERS PRIVATE LIMITED",
"TRIMURTY LANDCON",
"TRIMURTY SPINNING MILLS PRIVATE LIMITED",
"TRIMURTY UTILITY SERVICES PRIVATE LIMITED",
"TRIMWHIM VENTURE PRIVATE LIMITED",
"TRINA CONSTRUCTION PRIVATE LIMITED",
"TRINA NRE TRANSPORTATION LIMITED",
"TRINAMIX SYSTEMS PRIVATE LIMITED",
"TRINATH RICE MILLS PVT LTD",
"TRINATH SMART PAC PRIVATE LIMITED",
"TRINATHESWAR AGRO PRODUCTS PRIVATE LIMITED",
"TRINAU TALENT SOLUTIONS PRIVATE LIMITED",
"TRINAY HOSPITAL PRIVATE LIMITED",
"TRINAYAN BUILDERS PRIVATE LIMITED",
"TRINCASS VYAPAAR PVT LTD",
"TRINE CONCRETE PRIVATE LIMITED",
"TRINE EDUCATION VENTURES PRIVATE LIMITED",
"TRINE PROJECTS LLP",
"TRINEAS COMMERCE PRIVATE LIMITED",
"TRINESIS TECHNOLOGIES PRIVATE LIMITED",
"TRINETHRA SUPERRETAIL PRIVATE LIMITED",
"TRINETHRA WIND AND HYDRO POWER PRIVATE LIMITED",
"TRINETIUM TECH PRIVATE LIMITED",
"TRINETRA CARBON PRIVATE LIMITED",
"TRINETRA CO PVT LTD",
"TRINETRA FURNISHING PRIVATE LIMITED",
"TRINETRA IMPEX PRIVATE LIMITED",
"TRINETRA POULTRIES PRIVATE LIMITED",
"TRINETRA SUPER SPECIALITY EYE CARE CENTER PRIVATE LIMITED",
"TRINETRA TOURS PRIVATE LIMITED",
"TRINETRA WIRELESS PRIVATE LIMITED",
"TRINETRAM CONSULTANTS PRIVATE LIMITED",
"TRINETRAMILAN PRODUCT PROTECTION SOLUTIONS PRIVATE LIMITED",
"TRINEVA INFRA PROJECTS PRIVATE LIMITED",
"TRING SECURITY SOLUTIONS PRIVATE LIMITED",
"TRINGAPPS RESEARCH LABS PRIVATE LIMITED",
"TRINGULA ONLINE EDUCATION PRIVATE LIMITED",
"TRINI B2B INFRA PRIVATE LIMITED",
"TRINIDHI FINANCE PRIVATE LIMITED",
"TRINIITY COLOUR INDIA PRIVATE LIMITED",
"TRINITAS ENGINEERS AND FOUNDERS PRIVATE LIMITED",
"TRINITAS SHIP MANAGEMENT PRIVATE LIMITED",
"TRINITECH INFRASTRUCTURE (INDIA) PRIVATE LIMITED",
"TRINITI ADVANCED SOFTWARE LABS PRIVATE LIMITED",
"TRINITRON AUTOMATION PRIVATE LIMITED",
"TRINITRON CONTROL SYSTEMS PRIVATE LIMITED",
"TRINITY ACADEMY FOR CORPORATE TRAINING LIMITED",
"TRINITY ACADEMY LIMITED",
"TRINITY ACADEMY OF ENGINEERING",
"TRINITY AIR TRAVEL & TOUR PRIVATE LIMITED",
"TRINITY AIR TRAVEL AND TOURS KERALA PRIVATE LIMITED",
"TRINITY ASSOCIATES",
"TRINITY AUTO COMPONENTS LIMITED",
"TRINITY AUTOEQUIP PRIVATE LIMITED",
"TRINITY B E D COLLEGE",
"TRINITY CAR CARE PRIVATE LIMITED",
"TRINITY CAR RENTAL COMPANY PRIVATE LIMITED",
"TRINITY CENTRAL HOSPITAL",
"TRINITY CLEANTECH PRIVATE LIMITED",
"TRINITY COAL TRADING PRIVATE LIMITED",
"TRINITY COATING SYSTEMS LIMITED",
"TRINITY COLLEGE LONDON INDIA PRIVATE LIMITED",
"TRINITY COLLEGE OF ENGINEERING AND RESEARCH",
"TRINITY COMPOUNDS PRIVATE LIMITED",
"TRINITY CYCLES INDIA PRIVATE LIMITED",
"TRINITY DIAMANTS PRIVATE LIMITED",
"TRINITY ENERGY SYSTEMS PRIVATE LIMITED",
"TRINITY ENTERTAINMENT AND STRATEGIC CONSULTANTS LLP",
"TRINITY EXPRESS CARGO PRIVATE LIMITED",
"TRINITY EYE CARE PRIVATE LIMITED",
"TRINITY EYE HOSPITAL",
"TRINITY FERTILITY SEVICES PRIVATE LIMITED",
"TRINITY FILTRATION TECHNOLOGIES PRIVATE LIMITED",
"TRINITY FINSEC PRIVATE LIMITED",
"TRINITY FREIGHT SERVICES PRIVATE LIMITED",
"TRINITY FRESH PRODUCE TRADING PRIVATE LIMITED",
"TRINITY FRONT LIVE ZYDUS HEALTHCARE LIMITED",
"TRINITY FRUCTA LIMITED",
"TRINITY FURNITURE PRIVATE LIMITED",
"TRINITY GAMING INDIA PRIVATE LIMITED",
"TRINITY GLOBAL ENTERPRISES LIMITED",
"TRINITY GOLD LLP",
"TRINITY GOLF INDIA PRIVATE LIMITED",
"TRINITY HEALTH TECHNOLOGIES PRIVATE LIMITED",
"TRINITY HEART FOUNDATION PRIVATE LIMITED",
"TRINITY HIGH SCHOOL",
"TRINITY HOUSE (INDIA) PRIVATE LIMITED",
"TRINITY HYDRAULIC PRIVATE LIMITED",
"TRINITY HYDRAULICS AND PNEUMATICS PRIVATE LIMITED",
"TRINITY INDIA FORGETECH PRIVATE LIMITED",
"TRINITY INDUSTRIES LIMITED",
"TRINITY INFRACON PRIVATE LIMITED",
"TRINITY INFRAPARK LLP",
"TRINITY INFRAVENTURES LIMITED",
"TRINITY INSTITUTE OF INNOVATIONS IN PROFESSIONAL STUDIES",
"TRINITY INSTITUTE OF PROFESSION STUDIES",
"TRINITY INSURANCE BROKERS PRIVATE LIMITED",
"TRINITY INTERNATIONAL SCHOOL",
"TRINITY KITCHENWARE LIMITED",
"TRINITY LEAGUE INDIA LIMITED",
"TRINITY MAHALASA DURGA SALES AND SERVICES",
"TRINITY MECHANICAL CONTRACTORS PRIVATE LIMITED",
"TRINITY MICROSYSTEMS PRIVATE LIMITED",
"TRINITY MOBILITY PRIVATE LIMITED",
"TRINITY NURSING HOME PRIVATE LIMITED",
"TRINITY PACKAGING COMPANY PRIVATE LIMITED",
"TRINITY PAINT PLUSS PRIVATE LIMITED",
"TRINITY PHARMACEUTICALS & FOOD PRIVATE LIMITED",
"TRINITY POLYTECH PRIVATE LIMITED",
"TRINITY POLYTECHNIC",
"TRINITY POLYTECHNIC COLLEGE PUNE",
"TRINITY REALTY & FININVEST CONSULTANTS PRIVATE LIMITED",
"TRINITY REINSURANCE BROKERS LIMITED",
"TRINITY SAND & MINERALS PRIVATE LIMITED",
"TRINITY SHIPPING AND ALLIED SERVICES PRIVATE LIMITED",
"TRINITY SHOES PRIVATE LIMITED",
"TRINITY SUNRISE HEALTHCARE PRIVATE LIMITED",
"TRINITY TAPES PRIVATE LIMITED",
"TRINITY TECHNOLOGIES AND SOFTWARE SOLUTIONS PRIVATE LIMITED",
"TRINITY TELECOM SOLUTIONS (INDIA) PRIVATE LIMITED",
"TRINITY TOUCH PRIVATE LIMITED",
"TRINITY TRADEX PRIVATE LIMITED",
"TRINITY TRANSCRIPTION PRIVATE LIMITED",
"TRINITY UNICEPTS PRIVATE LIMITED",
"TRINITY VENTURES PRIVATE LIMITED",
"TRINITY VINCOM PRIVATE LIMITED",
"TRINITY WORLD HOLIDAYS PRIVATE LIMITED",
"TRINITY WORLDWIDE EXPORTS PRIVATE LIMITED",
"TRINITYPARTNERS INDIA LLP",
"TRINKET ENGINEERING PRIVATE LIMITED",
"TRINKET INFO SERVICES PRIVATE LIMITED",
"TRINOM DIGITAL PRIVATE LIMITED",
"TRINVIK ULTRAVISUALS PRIVATE LIMITED",
"TRIO APPARELS INDIA PRIVATE LIMITED",
"TRIO BIOTECH PRIVATE LIMITED",
"TRIO ELEVATORS CO INDIA PRIVATE LIMITED",
"TRIO ELEVATORS COMPANY LIMITED",
"TRIO FAB (INDIA) PRIVATE LIMITED",
"TRIO INTERNATIONAL PRIVATE LIMITED",
"TRIO JEWELS PRIVATE LIMITED",
"TRIO LIFESCIENCE PRIVATE LIMITED",
"TRIO MERCANTILE AND TRADING LIMITED",
"TRIO MOTION TECHNOLOGY LIMITED",
"TRIO PROPERTY DEVELOPERS PRIVATE LIMITED",
"TRIO REMEDIES PVT LTD",
"TRIO SECURITY AND INTELLIGENCE PRIVATE LIMITED",
"TRIO SHIPPING SERVICES PRIVATE LIMITED",
"TRIO SHOPPING MALL SPACES PRIVATE LIMITED",
"TRIO SOLAR PRIVATE LIMITED",
"TRIO TRADERS PVT LTD",
"TRIO TRAVELS & HOLIDAYS PRIVATE LIMITED",
"TRIO TREND EXPORTS PRIVATE LIMITED",
"TRIO TREND PRIVATE LIMITED",
"TRIO VIDYAKKENDRA PRIVATE LIMITED",
"TRIOANGLE MINDS TECHNOLOGIES PRIVATE LIMITED",
"TRIOCHEM PRODUCTS LIMITED",
"TRIODEC SOLUTIONS LLP",
"TRIOFI TECHNOLOGIES PRIVATE LIMITED",
"TRIOLOGIC ENTERPRISES PRIVATE LIMITED",
"TRIOLOGY SOLUTIONS PRIVATE LIMITED",
"TRIOMEGA INDIA PRIVATE LIMITED",
"TRIOMICS HEALTHCARE PRIVATE LIMITED",
"TRION LOGISTICS INDIA PRIVATE LIMITED",
"TRION PROPERTIES PRIVATE LIMITED",
"TRIONES EXIM PRIVATE LIMITED",
"TRIOPLUS PHARMACEUTICALS PRIVATE LIMITED",
"TRIOS COWORKING PRIVATE LIMITED",
"TRIOS DEVELOPMENT SUPPORT PRIVATE LIMITED",
"TRIOTECH ENGINEERING INDIA PRIVATE LIMITED",
"TRIOTREE TECHNOLOGIES PRIVATE LIMITED",
"TRIOVISION COMPOSITE TECHNOLOGIES PRIVATE LIMITED",
"TRIOWASH CLEANING SERVICES PRIVATE LIMITED",
"TRIOX PHARMCHEM PRIVATE LIMITED",
"TRIOX TECHNOLOGIES PRIVATE LIMITED",
"TRIOZONE MEP SOLUTIONS PRIVATE LIMITED",
"TRIP CATCHERS PRIVATE LIMITED",
"TRIP CIRCUIT HOLIDAYS PRIVATE LIMITED",
"TRIP FACTORY PRIVATE LIMITED",
"TRIP JACK PRIVATE LIMITED",
"TRIP MAKERS FOREX PRIVATE LIMITED",
"TRIP NAVIGATOR PRIVATE LIMITED",
"TRIP PLANNERS WORLD PRIVATE LIMITED",
"TRIP PROCESS PRIVATE LIMITED",
"TRIPADA ENTERPRISE PRIVATE LIMITED",
"TRIPADA HEALTHCARE PRIVATE LIMITED",
"TRIPADA LIFECARE PRIVATE LIMITED",
"TRIPADAM LOGISTICS PRIVATE LIMITED",
"TRIPADAYA INNOVATIONS AND MARKETING PRIVATE LIMITED",
"TRIPADVISOR TRAVEL INDIA PRIVATE LIMITED",
"TRIPATH LOGISTICS PRIVATE LIMITED",
"TRIPATHI FOREX MART PRIVATE LIMITED",
"TRIPATHI HOSPITAL PRIVATE LIMITED",
"TRIPATHI LIFTING COMPANY PRIVATE LIMITED",
"TRIPATI INSTITUTION",
"TRIPCON ENGINEERING PRIVATE LIMITED",
"TRIPENTA HOTELS PRIVATE LIMITED",
"TRIPFIN TRADE & CONSULTANCY PRIVATE LIMITED",
"TRIPFORO PRIVATE LIMITED",
"TRIPHASE PHARMACEUTICALS PRIVATE LIMITED",
"TRIPHASE TECHNOLOGIES PRIVATE LIMITED",
"TRIPLAN INDIA PRIVATE. LIMITED",
"TRIPLE A ENGINEERING PRIVATE LIMITED",
"TRIPLE COM MEDIA PRIVATE LIMITED",
"TRIPLE CROWN TRADING PRIVATE LIMITED",
"TRIPLE LINE SHIPPING PRIVATE LIMITED",
"TRIPLE NINE HOSPITALITY PRIVATE LIMITED",
"TRIPLE PEE SOLUTIONS PRIVATE LIMITED",
"TRIPLE PLAY BROADBAND PRIVATE LIMITED",
"TRIPLE PLAY INTERACTIVE NETWORK PRIVATE LIMITED",
"TRIPLE POINT TECHNOLOGY INDIA PRIVATE LIMITED",
"TRIPLE POWER TRADING PRIVATE LIMITED",
"TRIPLE RAJ RE-ROLLING STEEL PRODUCTS PRIVATE LIMITED",
"TRIPLE S ELECTRIC POWERS PRIVATE LIMITED",
"TRIPLE THREE INDIA ENERGY SOLUTIONS PRIVATE LIMITED",
"TRIPLE TREE SOLUTIONS",
"TRIPLE999 RETAIL PRIVATE LIMITED",
"TRIPLEI ACADEMY PRIVATE LIMITED",
"TRIPLEM ENGINEERS PVT LTD",
"TRIPLEPLAYER TELECOM PRIVATE LIMITED",
"TRIPLERANK MARKETING PVT LTD",
"TRIPLERANK VINIMAY PRIVATE LIMITED",
"TRIPLEROCK SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED",
"TRIPLE-S COMPONENTS PRIVATE LIMITED",
"TRIPLEX GLASS WORKS PVT. LTD",
"TRIPLICANE PERMANENT FUND NIDHI LIMITED",
"TRIPOD INFRASTRUCTURE PRIVATE LIMITED",
"TRIPOD SOFTWARE SOLUTIONS PRIVATE LIMITED",
"TRIPOLI MANAGEMENT PVT LTD",
"TRIPOLY STUDIO PRIVATE LIMITED",
"TRIPOOT INDIA PRIVATE LTD",
"TRIPOTO TRAVEL PRIVATE LIMITED",
"TRIPOWER INVESTMENT PRIVATE LIMITED",
"TRIPPLE ESS TOYS PRIVATE LIMITED",
"TRIPPLE STAR AGRI PRIVATE LIMITED",
"TRIPPLEARM INDIA PRIVATE LIMITED",
"TRIPSTER SOLUTIONS PRIVATE LIMITED",
"TRIPSWAY FOREX PRIVATE LIMITED",
"TRIPTA INNOVATIONS PRIVATE LIMITED",
"TRIPTI ALCOBREW PRIVATE LIMITED",
"TRIPTI ENGINEERING SERVICES PVT LTD",
"TRIPTI GASES PRIVATE LIMITED",
"TRIPUND SOLUTIONS PRIVATE LIMITED (OPC)",
"TRIPUR TUBES PRIVATE LIMITED",
"TRIPURA AUTOMOTIVES PRIVATE LIMITED",
"TRIPURA COLOUR COMPANY PVT. LTD.",
"TRIPURA ISPAT",
"TRIPURA JUTE MILLS LIMITED",
"TRIPURA MANIPUR AND MIZORAM GEOSPATIAL DATA CENTRE SILCHAR",
"TRIPURA NATURAL GAS CO LTD",
"TRIPURA STATE ELECTRICITY CORPORATION LIMITED",
"TRIPURA STONES PRIVATE LIMITED",
"TRIPURASHWARI AGRO PRODUCT PRIVATE LIMITED",
"TRIPURESWARI FEED & LAYER PRIVATE LIMITED",
"TRIPUTI ENTERPRISES PRIVATE LIMITED",
"TRIPXPERTS HOSPITALITY PRIVATE LIMITED",
"TRIPY TECH PRIVATE LIMITED",
"TRIQUARK INTERNET PRIVATE LIMITED",
"TRIQUENCH INDIA PRIVATE LIMITED",
"TRIQUETRA HEALTHCARE AND TECHNOLOGY PRIVATE LIMITED",
"TRIREME INFRASTRUCTURRE PRIVATE LIMITED",
"TRIREME LIFE SCIENCES PRIVATE LIMITED",
"TRIRUP CONSTRUCTION PRIVATE LIMITED",
"TRISA EXPORTS PRIVATE LIMITED",
"TRISAGAR FARMER PRODUCER COMPANY LIMITED",
"TRISCENT MARKETING SERVICE PRIVATE LIMITED",
"TRISH IMPEX PRIVATE LIMITED",
"TRISHA ENGINEERS PRIVATE LIMITED",
"TRISHA ENTERPRISES",
"TRISHA HEALTHCARE PRIVATE LIMITED",
"TRISHA INFRACON PROJECTS PRIVATE LIMITED",
"TRISHA INFRASTRUCTURE LIMITED",
"TRISHA MARKETING PRIVATE LIMITED",
"TRISHA POLYCHEM PRIVATE LIMITED",
"TRISHA POLYPLAST PRIVATE LIMITED",
"TRISHA RENEWABLE ENERGY PRIVATE LIMITED",
"TRISHA SPECIALITY CHEMICALS PRIVATE LIMITED",
"TRISHA STUDIOS LIMITED",
"TRISHA TRENDS PRIVATE LIMITED",
"TRISHAKTI ALLOYS PRIVATE LIMITED",
"TRISHAKTI FINANCIAL SERVICES PRIVATE LIMITED",
"TRISHAKTI INDUSTRIES LIMITED",
"TRISHAKTI INFRA AND TRADE PRIVATE LIMITED",
"TRISHAKTI LEATHER ENTERPRISES PRIVATE LIMITED",
"TRISHAKTI POWER HOLDINGS PRIVATE LIMITED",
"TRISHAKTI POWER PRIVATE LIMITED",
"TRISHAKTI PRODUCTS PRIVATE LIMITED",
"TRISHAKTI REAL ESTATE INFRASTRUCTURE AND DEVELOPERS LIMITED",
"TRISHAKTI SECURITY PRIVATE LIMITED",
"TRISHAKTI TRADING ENTERPRISE PRIVATE LIMITED",
"TRISHALA ALLOYS PRIVATE LIMITED",
"TRISHALA ELECTROLYTICS PRIVATE LIMITED",
"TRISHALA INFRASTRUCTURE PRIVATE LIMITED",
"TRISHALA INSULATION PRIVATE LIMITED",
"TRISHALA LAMINATES PRIVATE LIMITED",
"TRISHALA SOURCEING SERVICES PRIVATE LIMITED",
"TRISHAN EXPORTS PRIVATE LIMITED",
"TRISHAN METALS PRIVATE LIMITED",
"TRISHAN SCHOOL OF MUSIC ART & DANCE",
"TRISHASHNA HOLDINGS & INVESTMENTS PRIVATE LIMITED",
"TRISHIELD LOGISTICS PRIVATE LIMITED",
"TRISHIKA INDUSTRIES PRIVATE LIMITED",
"TRISHIKHA AUTOMOBILES PRIVATE LIMITED",
"TRISHLA BUILDTECH PRIVATE LIMITED",
"TRISHLA COTTON AND GENERAL MILLS PRIVATE LIMITED",
"TRISHLA FABRICS PRIVATE LIMITED",
"TRISHLA TOOLS PVT LTD",
"TRISHLANANDAN SAREES PRIVATE LIMITED",
"TRISHNA REAL ESTATE PRIVATE LIMITED",
"TRISHNA SKYSCRAPER LIMITED",
"TRISHNA TIEUP PRIVATE LIMITED",
"TRISHNA TRANSPORT AGENCY PRIVATE LIMITED",
"TRISHUL APPAREL PRIVATE LIMITED",
"TRISHUL ARECANUT GRANULE PRIVATE LIMITED",
"TRISHUL BUILDTECH & INFRASTRUCTURES PRIVATE LIMITED",
"TRISHUL COMMERCIAL COMPLEXES PRIVATE LIMITED",
"TRISHUL CONCRETE PRODUCTS LIMITED",
"TRISHUL DEALCOM PRIVATE LIMITED",
"TRISHUL ELECTROCASTINGS PRIVATE LIMITED",
"TRISHUL ELECTROMECH ENGINEERING INDIA PRIVATE LIMITED",
"TRISHUL ENGICON PRIVATE LIMITED",
"TRISHUL EXIM PRIVATE LIMITED",
"TRISHUL EXOTIC PRIVATE LIMITED",
"TRISHUL FASHIONS PRIVATE LIMITED",
"TRISHUL INFRAPROJECTS PRIVATE LIMITED",
"TRISHUL METAL INDUSTRIES LIMITED",
"TRISHUL MINING AND ALLIED SERVICES PRIVATE LIMITED",
"TRISHUL OXYGEN PRIVATE LIMITED",
"TRISHUL POLYMERS PRIVATE LIMITED",
"TRISHUL POWER PRIVATE LIMITED",
"TRISHUL PROCESSORS PRIVATE LIMITED",
"TRISHUL REALCON PRIVATE LIMITED",
"TRISHUL SACCHARIN PRIVATE LIMITED",
"TRISHUL SECURITECH PRIVATE LIMITED",
"TRISHUL SERVICE STATION PRIVATE LIMITED",
"TRISHUL SOLAR PRIVATE LIMITED",
"TRISHUL TEAK PRODUCTS PRIVATE LIMITED",
"TRISHUL TRACTORS PRIVATE LIMITED",
"TRISHUL TRADING COMPANY PRIVATE LIMITED",
"TRISHUL TRANSPORT COMPANY PRIVATE LIMITED",
"TRISHUL TREAD PRIVATE LIMITED",
"TRISHUL WINDING SOLUTIONS PRIVATE LIMITED",
"TRISHULII PRODUCER COMPANY LIMITED",
"TRISHULRUDRA CORRUGATORS PRIVATE LIMITED",
"TRISHYIRAYA RECYCLING INDIA PRIVATE LIMITED",
"TRISIM TECHNOLOGIES PRIVATE LIMITED",
"TRISING AUTOMATION PRIVATE LIMITED",
"TRISING PAPERS PRIVATE LIMITED",
"TRISITA MARKETING PRIVATE LIMITED",
"TRISKAIDEKA INFRATECH PRIVATE LIMITED",
"TRISNEHA HANDLOOMS PRIVATE LIMITED",
"TRISOFT DISTRIBUTION PRIVATE LIMITED",
"TRISOL RED INFRAVENTURES PRIVATE LIMITED",
"TRISON INFRASTRUCTURE CONSTRUCTION PRIVATE LIMITED",
"TRISPACE LOGISTICS PRIVATE LIMITED",
"TRISQUARE PROPERTIES PRIVATE LIMITED",
"TRISQUARE SWITCHGEARS PRIVATE LIMITED",
"TRISTAR ACCOMMODATIONS PRIVATE LIMITED",
"TRISTAR AERODYNAMICS PRIVATE LIMITED",
"TRISTAR AUTO AGENCIES VIZAG PRIVATE L",
"TRISTAR BUSINESS ENTERPRISES LIMITED",
"TRISTAR CONTAINER SERVICES (ASIA) PRIVATE LIMITED",
"TRISTAR EPC AND MERCANTILE SERVICES PRIVATE LIMITED",
"TRISTAR EQUIPMENTS PRIVATE LIMITED",
"TRISTAR FORMULATIONS PRIVATE LIMITED",
"TRISTAR HEALTHCARE LLP",
"TRISTAR HOSPITAL",
"TRISTAR HOTELS PRIVATE LIMITED",
"TRISTAR HYDROTECH ENGINEERING PVT LTD",
"TRISTAR INDUSTRIAL TOOLS P.LTD.",
"TRISTAR INTERMEDIATES PRIVATE LIMITED",
"TRISTAR LIFESCIENCES PRIVATE LIMITED",
"TRISTAR LINES PRIVATE LIMITED",
"TRISTAR LOGISTICS INDIA PRIVATE LIMITED",
"TRISTAR MANAGEMENT SERVICES PRIVATE LIMITED",
"TRISTAR METALLURGICAL PRIVATE LIMITED",
"TRISTAR OCEANIC SERVICES PRIVATE LIMITED",
"TRI-STAR PRODUCT PRIVATE LIMITED",
"TRISTAR TELEVENTURES PRIVATE LIMITED",
"TRISTAR VINIMAY PRIVATE LIMITED",
"TRISTHA GLOBAL PRIVATE LIMITED",
"TRISTONE FLOWTECH INDIA PRIVATE LIMITED",
"TRISU ADVISORSOPC PRIVATE LIMITED",
"TRISUKA INFRASTRUCTURE PRIVATE LIMITED",
"TRISUKA PRIVATE LIMITED",
"TRISUKA PROJECT PRIVATE LIMITED",
"TRISYS COMMUNICATIONS PRIVATE LIMITED",
"TRISYS IT SERVICES PRIVATE LIMITED",
"TRITAIL PRIVATE LIMITED",
"TRITAN INCENSE PRIVATE LIMITED",
"TRITAN LEATHERWORKS PRIVATE LIMITED",
"TRITAN WORKS PRIVATE LIMITED",
"TRITECH CATALYST AND INTERMEDIATE PRIVATE LIMITED",
"TRITECH DISCONNECTORS (INDIA) PRIVATE LIMITED",
"TRITECH INSTRUMENTS (INDIA) PRIVATE LIMITED",
"TRITECH MULTISOFT",
"TRITECH TEAM PRIVATE LIMITED",
"TRITEK MICRO CONTROLS PRIVATE LIMITED",
"TRITIUM CONSULTING PRIVATE LIMITED",
"TRITON ADVISORY PRIVATE LIMITED",
"TRITON BUILDWELL LIMITED",
"TRITON COMMUNICATIONS P LIMITED",
"TRITON FACILITATORS AND LOGISTIQUE PRIVATE LIMITED",
"TRITON GREENTECH INNOVATIONS PRIVATE LIMITED",
"TRITON HEALTH CARE PRIVATE LIMITED",
"TRITON HOSPITALITY PRIVATE LIMITED",
"TRITON HOTELS & RESORTS PRIVATE LIMITED",
"TRITON INTERNATIONAL PRIVATE LIMITED",
"TRITON LOGISTICS AND MARITIME PRIVATE LIMITED",
"TRITON MARINE OILFIELD SERVICES PRIVATE LIMITED",
"TRITON MARITIME PRIVATE LIMITED",
"TRITON MEDICAL SERVICES PRIVATE LIMITED",
"TRITON MULTIMODAL INDIA PRIVATE LIMITED",
"TRITON PROCESS AUTOMATION PRIVATE LIMITED",
"TRITON RETAIL PRIVATE LIMITED",
"TRITON SYNERGIES PRIVATE LIMITED",
"TRITON TRADING CO.PRIVATE LIMITED",
"TRITON VALVES LIMITED",
"TRITON VENTURES PRIVATE LIMITED",
"TRITONIC GRAPHITE PRIVATE LIMITED",
"TRITONVALVES CLIMATECH PRIVATE LIMITED",
"TRITONVALVES FUTURE TECH PRIVATE LIMITED",
"TRITORC EQUIPMENTS PRIVATE LIMITED",
"TRITRONICS INDIA PRIVATE LIMITED",
"TRIUM INFO SOLUTIONS PRIVATE LIMITED",
"TRIUM LOGISTICS INDIA PRIVATE LIMITED",
"TRIUMFO TECHNOGROUP PRIVATE LIMITED",
"TRIUMPH AUTO (CV) PRIVATE LIMITED",
"TRIUMPH AUTO ENGINEERING PRIVATE LIMITED",
"TRIUMPH AUTO PARTS DISTRIBUTORS PRIVATE LIMITED",
"TRIUMPH AUTO PRIVATE LIMITED",
"TRIUMPH AUTO SALES PRIVATE LIMITED",
"TRIUMPH AUTO SERVICES PRIVATE LIMITED",
"TRIUMPH CONCEPTS INDIA PRIVATE LIMITED",
"TRIUMPH CORPORATION",
"TRIUMPH EDUCATION AND PUBLISHING PRIVATE LIMITED",
"TRIUMPH EDUDEVELOPERS PRIVATE LIMITED",
"TRIUMPH GARMENTS PRIVATE LIMITED",
"TRIUMPH GLOBAL INDIA PRIVATE LIMITED",
"TRIUMPH HIGH SCHOOL",
"TRIUMPH HOSPITALS PRIVATE LIMITED",
"TRIUMPH INNOVATIONS & ARTWORKS INDIA PRIVATE LIMITED",
"TRIUMPH INTERNATIONAL FINANCE INDIA LIMITED",
"TRIUMPH INTERNATIONAL INDIA PRIVATE LIMITED",
"TRIUMPH MEDIATECH PRIVATE LIMITED",
"TRIUMPH MOTORCYCLES INDIA PRIVATE LIMITED",
"TRIUMPH OFFSHORE PRIVATE LIMITED",
"TRIUMPH PACK PRIVATE LIMITED",
"TRIUMPH REALTY PRIVATE LIMITED",
"TRIUMPH RESOURCE MANAGEMENT LLP",
"TRIUMPH SOLUTIONS PRIVATE LIMITED",
"TRIUMPH SPORTSWEAR DESIGN STUDIO PRIVATE LIMITED",
"TRIUMPH SYSTEMS AND SOLUTIONS PRIVATE LIMITED",
"TRIUMPHAL STAR PRIVATE LIMITED",
"TRIUNE ENERGY SERVICES PRIVATE. LIMITED.",
"TRIUNE MANAGEMENT SERVICES PRIVATE LIMITED",
"TRIUNE PROJECTS PRIVATE LIMITED",
"TRIUNE TECHNOFAB PRIVATE LIMITED",
"TRIUPATI BALAJI WOOD LINKS PRIVATE LIMITED",
"TRIUPATI BOILERS PRIVATE LIMITED",
"TRIUS CALLING SOLUTIONS PRIVATE LIMITED",
"TRIUS HOLIDAY PRIVATE LIMITED",
"TRIV SOFTWARE PRIVATE LIMITED",
"TRIVALENT ENGINEERS AND CONSULTANTS PRIVATE LIMITED",
"TRIVAND TECHNOLOGIES PRIVATE LIMITED",
"TRIVANDRUM APOLLO TOWERS PRIVATE LIMITED",
"TRIVANDRUM DISTRICT COOPERATIVE BANK",
"TRIVANDRUM FLOUR MILLS PVT LTD",
"TRIVANDRUM INTERNATIONAL SCHOOL PRIVATE LIMITED",
"TRIVANDRUM MOTORS PRIVATE LIMITED",
"TRIVANTAGE CAPITAL MANAGEMENT INDIA PRIVATE LIMITED",
"TRIVAYU MEDIA WORKS PRIVATE LIMITED",
"TRIVECTA DIGITAL SOLUTIONS PRIVATE LIMITED",
"TRIVEDA HEALTHCARE PRIVATE LIMITED",
"TRIVEDI AND ASSOCIATES TECKNICAL SERVICES PRIVATE LIMITED",
"TRIVEDI AND SONS PRIVATE LIMITED",
"TRIVEDI CORP PRIVATE. LIMITED.",
"TRIVEDI MOTORS SALES AND SERVICES PRIVATE LIMITED",
"TRIVENEE PEST CONTROL PRIVATE LIMITED",
"TRIVENI AGRO SEEDS PRIVATE LIMITED",
"TRIVENI AGROCON PRIVATE LIMITED",
"TRIVENI ALLUCAST INDUSTRIES PRIVATE LIMITED",
"TRIVENI ALMIRAH PRIVATE LIMITED",
"TRIVENI BIALETTI INDUSTRIES PRIVATE LIMITED",
"TRIVENI BOILER PRIVATE LIMITED",
"TRIVENI BUILD-CON PVT. LTD",
"TRIVENI CARGO EXPRESS INDIA PRIVATE LIMITED",
"TRIVENI COLLEGE OF PHARMACY",
"TRIVENI CONDUCTORS LIMITED",
"TRIVENI DEPARTMENTAL STORE",
"TRIVENI DESIGN PRIVATE LIMITED",
"TRIVENI DIES AND TOOLS PRIVATE LIMITED",
"TRIVENI ELECTRODES PRIVATE LIMITED",
"TRIVENI ELECTROPLAST PRIVATE LIMITED",
"TRIVENI ENGICONS PRIVATE LIMITED",
"TRIVENI ENGINEERING AND INDUSTRIES LIMITED",
"TRIVENI ENTERPRISES",
"TRIVENI ENTERPRISES LIMITED",
"TRIVENI FISHERIES PVT. LTD.",
"TRIVENI FORMULATIONS LIMITED",
"TRIVENI FOUNDATION",
"TRIVENI GLASS LIMITED",
"TRIVENI GLOBAL PRIVATE LIMITED",
"TRIVENI GLOBAL SOFTWARE SERVICES LLP",
"TRIVENI HARDWARE PRODUCTS PRIVATE LIMITED",
"TRIVENI HI-TECH PRIVATE LIMITED",
"TRIVENI HOSPITAL",
"TRIVENI HOSPITAL & TRAUMA CENTRE",
"TRIVENI HOUSEHOLD ITEMS MANUFACTURERS PRIVATE LIMITED",
"TRIVENI IMPEX PRIVATE LIMITED",
"TRIVENI IMPLEMENTS MANUFACTURING CO PVT LTD",
"TRIVENI INFRASPACE PRIVATE LIMITED",
"TRIVENI IN-ORGANICS PRIVATE LIMITED",
"TRIVENI INTERCHEM PRIVATE LIMITED",
"TRIVENI IRON AND STEEL INDUSTRIES PRIVATE LIMITED",
"TRIVENI KNITS PRIVATE LIMITED",
"TRIVENI LANDMARK PRIVATE LIMITED",
"TRIVENI LIFESTYLE DEVELOPERS LLP",
"TRIVENI LIFESTYLE PRIVATE LIMITED",
"TRIVENI LIGHTS PRIVATE LIMITED",
"TRIVENI MEAT PRODUCTS PRIVATE LIMITED",
"TRIVENI MEDIA MARKETING SERVICES PRIVATE LIMITED",
"TRIVENI MOVERS PRIVATE LIMITED",
"TRIVENI PATTERN GLASS PRIVATE LIMITED",
"TRIVENI PETROCHEM PVT LTD",
"TRIVENI POLYMERS PRIVATE LIMITED",
"TRIVENI PUMPS PVT. LTD",
"TRIVENI QUALITY MINERALS PRIVATE LIMITED",
"TRIVENI REFRACTORIES PVT LTD",
"TRIVENI ROAD CARRIERS PRIVATE LIMITED",
"TRIVENI SANGAM KISAN AGRO PRODUCER COMPANY LIMITED",
"TRIVENI SANGAM TECHNOPACK PRIVATE LIMITED",
"TRIVENI SHIP BREAKERS",
"TRIVENI SILK MILLS",
"TRIVENI SMELTERS PRIVATE LIMITED",
"TRIVENI SOLVEX PRIVATE LIMITED",
"TRIVENI STONES PVT. LTD",
"TRIVENI STRIPS PRIVATE LIMITED",
"TRIVENI TRADERS AND DIAGNOSTIC PRIVATE LIMITED",
"TRIVENI TRANSLINE PRIVATE LIMITED",
"TRIVENI TRANSPORT PRIVATE LIMITED",
"TRIVENI TURBINE LIMITED",
"TRIVENI TV NETWORK PRIVATE LIMITED",
"TRIVENI WIRE CRAFT PRIVATE LIMITED",
"TRIVENI WIRES PRIVATE LIMITED",
"TRIVENIGOLD GLASS PRODUCTS PRIVATE LIMITED",
"TRIVENIVIEW ENTERPRISES PRIVATE LIMITED",
"TRIVENT SYSTEMS PRIVATE LIMITED",
"TRIVENTURE ADVISORY PRIVATE LIMITED",
"TRIVENTURE SERVICES PRIVATE LIMITED",
"TRIVER INTEGRATED SERVICES PRIVATE LIMITED",
"TRIVERSE ADVERTISING PRIVATE LIMITED",
"TRIVIAL WORKS SOLUTIONS PRIVATE LIMITED",
"TRIVIDH CHEMICALS PRIVATE LIMITED",
"TRIVIDH TEXTILES",
"TRIVIDHI PRESCIENCE (3PL LOGISTICS) PRIVATE LIMITED",
"TRIVIK HOTELS AND RESORTS PRIVATE LIMITED",
"TRIVIKRAM EQUIPMENTS AND SERVICES PRIVATE LIMITED",
"TRIVIKRAMA MEDICAL SERVICES PRIVATE LIMITED",
"TRIVISION MOBILITY PRIVATE LIMITED",
"TRIVISTA STEEL AND POWER PRIVATE. LIMITED.",
"TRIVITRON HEALTHCARE PRIVATE LIMITED",
"TRIVITRON MEDICAL SYSTEMS PRIVATE LIMITED",
"TRIVIUM EDUCATION SERVICES PRIVATE LIMITED",
"TRIVIUM ESOLUTIONS PRIVATE LIMITED",
"TRIVIUM POWER ENGINEERS PRIVATE LIMITED",
"TRIVONE DIGITAL SERVICES PRIVATE LIMITED",
"TRIWALL PAK PRIVATE LIMITED",
"TRIWAY CONTAINER FREIGHT STATION PRIVATE LIMITED",
"TRIWAY FORWARDERS PRIVATE LIMITED",
"TRIWAYS TRANSPORTATION PRIVATE LIMITED",
"TRIYA FASHIONS PVT LTD",
"TRIYAM INFORMATION TECHNOLOGY PRIVATE LIMITED",
"TRIYAMA SOFTWARE PRIVATE LIMITED",
"TRIYAMB SECURITIES PRIVATE LIMITED",
"TRIYOG AYURVED HOSPITALS",
"TRIYUG PROJECTS PRIVATE LIMITED.",
"TRIZETTO INDIA PRIVATE LIMITED",
"TRIZETTO SERVICES INDIA PRIVATE LIMITED",
"TRIZONE ELECTRICALS SERVICES PRIVATE LIMITED",
"TRIZOOM SOLUTIONS PRIVATE LIMITED",
"TRK INDUSTRIES PRIVATE LIMITED",
"TRK TEXTILE INDIA PRIVATE LIMITED",
"TRL KROSAKI REFRACTORIES LIMITED",
"T-RMC PRIVATE LIMITED",
"TRN MEDICAL SERVICES LLP",
"TRNDIGITAL CONSULTING PRIVATE LIMITED",
"TROB AUTO INDIA PRIVATE LIMITED",
"TROCHE LABORATORIES PRIVATE LIMITED",
"TROCKO LOGI PRIVATE LIMITED",
"TRODAT MARKING INDIA PRIVATE LIMITED",
"TROFI CHAIN FACTORY PRIVATE LIMITED",
"TROI MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"TROIKA AUTOPRODUCTS INDIA PRIVATE LIMITED",
"TROIKA HEALTH CARE PRIVATE LIMITED",
"TROIKA INTERNATIONAL PRIVATE LIMITED",
"TROIKA MANAGEMENT SERVICES PRIVATE LIMITED",
"TROIKAA PHARMACEUTICALS LIMITED",
"TROIS BIOTECH PRIVATE LIMITED",
"TROIS INFOTECH PRIVATE LIMITED",
"TROIX CHEMICALS PVT LTD",
"TROJAN LOGISTICS PRIVATE LIMITED",
"TROJAN PROTECTIVES INDIA PRIVATE LIMITED",
"TROKUT SOLUTIONS PRIVATE LIMITED",
"TROLEXINDIAPRIVATE LIMITED",
"TROM INDUSTRIES LIMITED",
"TROMBA LUXURY PRIVATE LIMITED",
"TRONOX INDIA PRIVATE LIMITED",
"TRONTEK ELECTRONICS PRIVATE LIMITED",
"TROOINBOUND PRIVATE LIMITED",
"TROOP COMFORTS LIMITED",
"TROOP WORK LLP",
"TROOPS INDUSTRIAL SECURITY AGENCY PRIVATE LIMITED",
"TROOTECH BUSINESS SOLUTIONS PRIVATE LIMITED",
"TROPFRUIT PRODUCTS PRIVATE LIMITED",
"TROPHIC WELLNESS PRIVATE LIMITED",
"TROPHY ESTATES PRIVATE LIMITED",
"TROPICA HORTICULTURE PRIVATE LIMITED",
"TROPICA SEEDS PRIVATE LIMITED",
"TROPICAAL WATERS INDIA PRIVATE LIMITED",
"TROPICAL AGRO SYSTEM (INDIA) PRIVATE LIMITED",
"TROPICAL AGRO SYSTEM INDIA PRIVATE LIMITED",
"TROPICAL BATH SOLUTIONS PRIVATE LIMITED",
"TROPICAL BEVERAGES PRIVATE LIMITED",
"TROPICAL BIOMARINE SYSTEMS PRIVATE LIMITED",
"TROPICAL CLOTHING COMPANY PRIVATE LIMITED",
"TROPICAL CROPSCIENCES PRIVATE LIMITED",
"TROPICAL ECOLOGY PRIVATE LIMITED",
"TROPICAL EXIM INTERNATIONAL PRIVATE LIMITED",
"TROPICAL FLAVOURS P LIMITED",
"TROPICAL FOREST RESEARCH INSTITUTE",
"TROPICAL HOTELS PVT. LTD.",
"TROPICAL INDUSTRIES INTERNATIONAL PRIVATE LIMITED",
"TROPICAL MUSHROOMS (GOA) PRIVATE LIMITED",
"TROPICAL SOLAR ENERGY PRIVATE LIMITED",
"TROPICAL TRANSPORT SYSTEMS (INDIA) PRIVATE LIMITED",
"TROPICANA ENTERPRISES PRIVATE LIMITED",
"TROPICANA EXOTICS PRIVATE LIMITED",
"TROPICANA LEISURE HOSPITALITY PRIVATE LIMITED",
"TROPICANA LOGISTICS PRIVATE LIMITED",
"TROPICATURE AGRO PRIVATE LIMITED",
"TROPICOOL CAR GADGETS PRIVATE LIMITED",
"TROPICOOL FOODS PRIVATE LIMITED",
"TROPILITE BIOSCIENCES PRIVATE LIMITED",
"TROPILITE FOODS PRIVATE LIMITED",
"TROPOGO TECHNOLOGIES PRIVATE LIMITED",
"TROTTING WHEELS PRIVATE LIMITED",
"TROUNCE LIFE SCIENCES PRIVATE LIMITED",
"TROUW NUTRITION INDIA PRIVATE LIMITED",
"TROVENZA TRAVEL PRIVATE LIMITED",
"TROX INDIA PRIVATE LIMITED",
"TROY CHEMICAL INDIA PRIVATE LIMITED",
"TRP FOOD PRIVATE LIMITED",
"TRP HOSPITALITY SERVICES PRIVATE LIMITED",
"TRP SEALING SYSTEMS INDIA PRIVATE LIMITED",
"TRPC SERVICE TEAM PRIVATE LIMITED",
"TRPL RESOURCES & CONSULTANCY SERVICES PRIVATE LIMITED",
"TRR INFRA PRIVATE LIMITED",
"TRRAIN CIRCLE PRIVATE LIMITED",
"TRS LIFT & SHIFT SERVICES PRIVATE LIMITED",
"TRS STAFFING SOLUTIONS INDIA PRIVATE LIMITED",
"TRSD FOODS PRIVATE LIMITED",
"TRSOFT TECHNOLOGIES PRIVATE LIMITED",
"TRTAUTO GLOBAL PRIVATE LIMITED",
"TRU BUSINESS SOLUTIONS PRIVATE LIMITED",
"TRU E BIKES PRIVATE LIMITED",
"TRU HALLMARK BANQUETS PRIVATE LIMITED",
"TRU INFORMATIONS AND SYSTEMS PRIVATE LIMITED",
"TRU TEK SYSTEMS COMBINE PRIVATE LIMITED",
"TRU THREAD GAUGES AND TOOLS PVT LTD",
"TRU TIMES HEALTH CARE PRIVATE LIMITED",
"TRU TRADING AND INVESTMENTS PRIVATE LIMITED",
"TRU VALUE OVERSEAS PRIVATE. LIMITED",
"TRUCAP FINANCE LIMITED",
"TRUCKBOOK TECHNOLOGIES PRIVATE LIMITED",
"TRUCKBULLS TRANSPORT PRIVATE LIMITED",
"TRUCKCENTRAL SOLUTIONS PRIVATE LIMITED",
"TRUCKERS INDIA",
"TRUCKEZE LOGISTICS SOLUTIONS PRIVATE LIMITED",
"TRUCKGO LOGISTICS PRIVATE LIMITED",
"TRUCKIT INDIA PRIVATE LIMITED",
"TRUCKTEK PRIVATE LIMITED",
"TRUCON POWER ENGINEERS PRIVATE LIMITED",
"TRUCONNECT SOLUTIONS PRIVATE LIMITED",
"TRUCUT TOOLS INDIA P LIMITED",
"TRUCVR TECHNOLOGIES PRIVATE LIMITED",
"TRUDEL FASHIONS PRIVATE LIMITED",
"TRUDIMET CASTINGS PRIVATE LIMITED",
"TRUE ADVISORS PRIVATE LIMITED",
"TRUE AGROROOTS PRIVATE LIMITED",
"TRUE BEACON INVESTMENT ADVISORS LLP",
"TRUE BLUE CODER",
"TRUE BLUE M2M PRIVATE LIMITED",
"TRUE BLUE RESTROBAR PRIVATE LIMITED",
"TRUE BLUE VOICE INDIA PRIVATE LIMITED",
"TRUE BUILD TECHNOLOGIES PRIVATE LIMITED",
"TRUE COAT PAINTS PRIVATE LIMITED",
"TRUE CODEOLOGY SOLUTIONS PRIVATE LIMITED",
"TRUE COLORS APPARELS PRIVATE LIMITED",
"TRUE COLORS SOLUTIONS & TECHNOLOGIES INDIA PRIVATE LIMITED",
"TRUE COUNT SYSTEMS PRIVATE LIMITED",
"TRUE CREDITS PRIVATE LIMITED",
"TRUE CRYSTAL BIZ SOLUTIONS PRIVATE LIMITED",
"TRUE DEVELOPERS PRIVATE LIMITED",
"TRUE EDUCATION INSTITUTE PRIVATE LIMITED",
"TRUE EXPRRESS PRIVATE LIMITED",
"TRUE FIT DEVELOPMENT INDIA PRIVATE LIMITED",
"TRUE FORGE PVT LTD",
"TRUE FREIGHT SERVICES PRIVATE LIMITED",
"TRUE FRIEND MANAGEMENT SUPPORT SERVICE PRIVATE LIMITED",
"TRUE FURNITURE PRIVATE LIMITED",
"TRUE GREEN TECHNOLOGIES PRIVATE LIMITED",
"TRUE HEIGHT INTERFACE INFOSOLUTION PRIVATE LIMITED",
"TRUE HOME DECOR PRIVATE LIMITED",
"TRUE HOSPITALITY PRIVATE LIMITED",
"TRUE INFOSYSTEM PRIVATE. LIMITED.",
"TRUE INFOSYSTEMS PRIVATE LIMITED",
"TRUE INTEGRAL CONCRETE PRIVATE LIMITED",
"TRUE JEWEL (INDIA) PRIVATE LIMITED",
"TRUE LINK FINANCE LIMITED",
"TRUE LIVING SPACES PRIVATE LIMITED",
"TRUE LOGISTICS PRIVATE. LIMITED.",
"TRUE MARINE FOODS PRIVATE LIMITED",
"TRUE NAVYA INDIA PRIVATE LIMITED",
"TRUE NORTH AR INDIA PRIVATE LIMITED",
"TRUE NORTH ENTERPRISE PRIVATE LIMITED",
"TRUE PAL INFRASTRUCTURES PRIVATE LIMITED",
"TRUE POWER LIMITED",
"TRUE POWER WIRES AND CABLES PRIVATE LIMITED",
"TRUE PRICE TRAVEL PRIVATE LIMITED",
"TRUE QUALITY CERTIFICATIONS PRIVATE LIMITED",
"TRUE RCM PRIVATE LIMITED",
"TRUE RINGS INDIA PRIVATE LIMITED",
"TRUE SOURCE INDIA PRIVATE LIMITED",
"TRUE SPARROW SYSTEMS PRIVATE LIMITED",
"TRUE STAR TECHNOLOGIES LLP",
"TRUE TALENTS CONSULTING PRIVATE LIMITED",
"TRUE TEST",
"TRUE TEXOFAB PRIVATE LIMITED",
"TRUE TONE INK PRIVATE LIMITED",
"TRUE VALUE CALIBRATION SERVICES PRIVATE LIMITED",
"TRUE VALUE GARMENTS PROCESSORS PRIVATE LIMITED",
"TRUE VALUE HOMES (INDIA) PRIVATE LIMITED",
"TRUE VALUE INVESTMENT SERVICES PRIVATE LIMITED",
"TRUE VALUE MEDIA PRIVATE LIMITED",
"TRUE VALUE NIRMAN PRIVATE LIMITED",
"TRUE VALUE PETROLEUM PRIVATE LIMITED",
"TRUE VALUE SOLUTIONS LIMITED",
"TRUE VIEW HR CONSULTING PRIVATE LIMITED",
"TRUE VILLAS DEVELOPERS PRIVATE LIMITED",
"TRUE VISION DIAGNOSTICS PRIVATE LIMITED",
"TRUE VISION TECHNOLOGIES PRIVATE LIMITED",
"TRUE WALL SPECIALITIES PRIVATE LIMITED",
"TRUE WANDERER PRIVATE LIMITED",
"TRUE WELL PIPE INDUSTRIES",
"TRUE WORTH TRADELINK PRIVATE LIMITED",
"TRUEARTH DEVELOPERS PRIVATE LIMITED",
"TRUEBELL MARKETING AND DISTRIBUTION PRIVATE LIMITED",
"TRUEBLUE EDIFICE PRIVATE LIMITED",
"TRUEBLUE INDIA LLP",
"TRUE-BLUE REALTY PRIVATE LIMITED",
"TRUEBROWNS LIFESTYLE PRIVATE LIMITED",
"TRUECALLER INTERNATIONAL LLP",
"TRUCAREKIDZ INDIA PRIVATE LIMITED",
"TRUECOM NETWORKS PRIVATE LIMITED",
"TRUECOM TELESOFT PRIVATE LIMITED",
"TRUECOPY CREDENTIALS PRIVATE LIMITED",
"TRUEDIAMOND JEWELS INDIA PRIVATE LIMITED",
"TRUEFARM FOODS INDIA PRIVATE LIMITED",
"TRUEFILL SOFTWARE PRIVATE LIMITED",
"TRUEFIT ENGINEERING COMPANY LIMITED",
"TRUEFORM EXPORTS PRIVATE LIMITED",
"TRUEFS AUTOMOBILE SOLUTION PRIVATE LIMITED",
"TRUEGUARD REALCON PRIVATE LIMITED",
"TRUEHOST IT SERVICES PRIVATE LIMITED",
"TRUEID PRIVATE LIMITED",
"TRUELAN TEXTILES PRIVATE LIMITED",
"TRUELANCER INTERNET PRIVATE LIMITED",
"TRUELIFE PHARMA PRIVATE LIMITED",
"TRUELIXIR LIFE SCIENCE PRIVATE LIMITED",
"TRUELOAD LOGISTICS PRIVATE LIMITED",
"TRUEMAX POLYMERS PRIVATE LIMITED",
"TRUEMAXX RUBBER PRIVATE LIMITED",
"TRUEMEAL FEEDS PRIVATE LIMITED",
"TRUEMIX CONCRETE INDIA PRIVATE LIMITED",
"TRUENORTH ADVISORY SERVICES PRIVATE LIMITED",
"TRUENORTH AUTOMOBILES PRIVATE LIMITED",
"TRUEONE 37 INDIA RETAIL PRIVATE LIMITED",
"TRUEPAK INDUSTRIES PRIVATE LIMITED",
"TRUEPOWER EARTHINGS PRIVATE LIMITED",
"TRUEPOWER ENERGY AND AUTOMATION PRIVATE LIMITED",
"TRUEQUATIONS PRIVATE LIMITED",
"TRUEROOTS IMPEX PRIVATE LIMITED",
"TRUES STEELS PRIVATE LIMITED",
"TRUESAPPHIRE INFRADEVELOPERS PRIVATE LIMITED",
"TRUESEED INVESTMENT CONSULTANTS PRIVATE LIMITED",
"TRUESERVE TECHNOLOGIES PRIVATE LIMITED",
"TRUESTAR ENTERPRISE PRIVATE LIMITED",
"TRUETECH SERVICES PRIVATE LIMITED",
"TRUETECH SOLUTIONS PRIVATE LIMITED",
"TRUETECH VISION INDUSTRY PRIVATE LIMITED",
"TRUETONE PRINT SYSTEM PRIVATE LIMITED",
"TRUETZSCHLER INDIA PRIVATE LIMITED",
"TRUEVALUE COMPUTERS PRIVATE LIMITED",
"TRUEVALUE CONCRETE PRODUCTS LIMITED",
"TRUEVALUE MARKETING SERVICES PRIVATE LIMITED",
"TRUEVENTURE ELECTRONICS PRIVATE LIMITED",
"TRUEWAY FINANCIAL SERVICES PRIVATE LIMITED",
"TRUEWAY ORGANIC PRIVATE LIMITED",
"TRUEWIN REALTY LIMITED",
"TRUFFLES",
"TRUFFLES HOSPITALITY PRIVATE LIMITED",
"TRUFID SERVICES PRIVATE LIMITED",
"TRUFORM TECHNO PRODUCTS PRIVATE LIMITED",
"TRUFROST COOLING PRIVATE LIMITED",
"TRUGEN NEUROSCIENCES PRIVATE LIMITED",
"TRUGEN PHARMACEUTICALS PRIVATE LIMITED",
"TRUHEALTH CARE INTERNATIONAL PRIVATE LIMITED",
"TRUHEALTHY LLP",
"TRUKKER TECHNOLOGIES PRIVATE LIMITED",
"TRUKKY LOGISTICS SERVICES PRIVATE LIMITED",
"TRULAY PHARMACEUTICALS PRIVATE LIMITED",
"TRULEARN SPACES PRIVATE LIMITED",
"TRULINE PROJECTS PRIVATE LIMITED",
"TRULIV PROPERTIES & SERVICES PRIVATE LIMITED",
"TRULY CREATIVE DEVELOPERS PRIVATE LIMITED",
"TRULY PEST SOLUTION PRIVATE LIMITED",
"TRULYTRIPS AND EVENTS PRIVATE LIMITED",
"TRULYY INDIA CAMPS AND SAFARIS PRIVATE LIMITED",
"TRUMAN CONSULTANCY SOLUTIONS PRIVATE LIMITED",
"TRUMAN INNOVATIONS PRIVATE LIMITED",
"TRUMARK FOODS PRIVATE LIMITED",
"TRUMBOO CEMENT INDUSTRIES PRIVATE LIMITED",
"TRUMBOO FOOD INDUSTRIES PRIVATE LIMITED",
"TRUMBOO INDUSTRIES PRIVATE LIMITED",
"TRUMEN TECHNOLOGIES PRIVATE LIMITED",
"TRUMOVE SERVICES PRIVATE LIMITED",
"TRUMP TRAINERS AND CONSULTANTS PRIVATE LIMITED",
"TRUMPF INDIA PRIVATE LIMITED",
"TRUMPF METAMATION PRIVATE LIMITED",
"TRUN FIBRES PVT LTD",
"TRUNEXA INFOWAYS PRIVATE LIMITED",
"TRUNKOZ TECHNOLOGIES PRIVATE LIMITED",
"TRUNOW TECHNOLOGIES PRIVATE LIMITED",
"TRUPATI ELECTRICALS PRIVATE LIMITED",
"TRUPIL TRADERS AND ASSOCIATES PRIVATE LIMITED",
"TRUPOINT IT & CONSULTING PRIVATE LIMITED",
"TRUPP GLOBAL TECHNOLOGIES PRIVATE LIMITED",
"TRUPT RASOI PRIVATE LIMITED",
"TRUPTHI HARDWARE AND TOOLS MART HOSUR PRIVATE LIMITED",
"TRUPTI CATERERS PRIVATE LIMITED",
"TRUPTI ENTERPRISES PRIVATE LIMITED",
"TRUPTI GARMENTS AND FINISHING PRIVATE LIMITED",
"TRUPTI HOSPITALITY PRIVATE LIMITED",
"TRUPTI INFRASTRUCTURE PRIVATE LIMITED",
"TRUPTI MILK AGRO PRODUCTS AND BEVERAGES PRIVATE LIMITED",
"TRUPTI RETAIL VENTURES PRIVATE LIMITED",
"TRUREALTY PRIVATE LIMITED",
"TRUSCAN DIAGNOSTIC CENTRE PRIVATE LIMITED",
"TRUSERVE ENGINEERS INDIA PRIVATE LIMITED",
"TRUSHITA EXPORTS PRIVATE LIMITED",
"TRUSHNA ENGINEERING & INFRASTRUCTURE PRIVATE LIMITED",
"TRUSHNA PROJECTS LIMITED",
"TRUSOLAR ENERGY (OPC) PRIVATE LIMITED",
"TRUSOUND PRIVATE LIMITED",
"TRUSOURCE TECHNOLOGY PRIVATE LIMITED",
"TRUSPEQ CONSULTING PRIVATE LIMITED",
"TRU-SPRAG FREEWHEELS PRIVATE LIMITED",
"TRUST ASSET MANAGEMENT PRIVATE LIMITED",
"TRUST CAPITAL SERVICES PRIVATE LIMITED",
"TRUST CHEMISTS AND DRUGGISTS LIMITED",
"TRUST CHEMISTS AND DRUGGISTS PRIVATE LIMITED",
"TRUST COMMODITIES PRIVATE LIMITED",
"TRUST FINANCIAL CONSULTANCY SERVICES P LIMITED",
"TRUST FINSTOCK PRIVATE LIMITED",
"TRUST FINTECH LIMITED",
"TRUST HOSPITAL",
"TRUST INVESTMENT ADVISORS PRIVATE LIMITED",
"TRUST LEGAL",
"TRUST SECURITIES SERVICES PRIVATE LIMITED",
"TRUST SYSTEMS AND SOFTWARE (INDIA) PRIVATE LIMITED",
"TRUST TRAVEL AND TOURS PRIVATE LIMITED",
"TRUST WELL ENGINEERS (INDIA) PRIVATE LIM ITED",
"TRUSTABOVE SHIPPING & LOGISTICS PRIVATE LIMITED",
"TRUSTBOX GLOBAL SOLUTIONS PRIVATE LIMITED",
"TRUSTCAP PRIVATE LIMITED",
"TRUSTCHEM PIGMENTS PRIVATE LIMITED",
"TRUSTEA SUSTAINABLE TEA FOUNDATION",
"TRUSTECH AV SOLUTION PRIVATE LIMITED",
"TRUSTED AEROSPACE ENGINEERING PRIVATE LIMITED",
"TRUSTED MANPOWER SERCVICES CO",
"TRUSTED RESOURCES PRIVATE LIMITED",
"TRUSTED SOFTWARE LABS",
"TRUSTEEL PEB PRIVATE LIMITED",
"TRUSTEL TELECOM PRIVATE LIMITED",
"TRUSTFORT",
"TRUSTGROW FERTILISERS INDIA PRIVATE LIMITED",
"TRUSTHOUSE SECURITIES PRIVATE LIMITED",
"TRUSTIN TAPE PRIVATE LIMITED",
"TRUSTING SOCIAL PRIVATE LIMITED",
"TRUSTKNIT PRIVATE LIMITED",
"TRUSTLENDERS CAPITAL PRIVATE LIMITED",
"TRUSTLENDERS FINSERV PRIVATE LIMITED",
"TRUSTLINE COMMODITIES PRIVATE LIMITED",
"TRUSTLINE DEALERS PRIVATE LIMITED",
"TRUSTLINE HOLDINGS PRIVATE LIMITED",
"TRUSTLINE INSURANCE BROKERS PRIVATE LIMITED",
"TRUSTLINE SECURITIES LIMITED",
"TRUSTLING SERVICES PRIVATE LIMITED",
"TRUSTLY TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"TRUSTME RECYCLE PRIVATE LIMITED",
"TRUSTNRIDE VEHICLES PRIVATE LIMITED",
"TRUSTONE WEGMANS DEVELOPERS PRIVATE LIMITED",
"TRUSTPOWER EARTHINGS PRIVATE LIMITED",
"TRUSTSIGNAL VENTURES PRIVATE LIMITED",
"TRUSTUS LOGISTICS PRIVATE LIMITED",
"TRUSTWELD ENGINEERS INDIA PRIVATE LIMITED",
"TRUSTWELL HOSPITALS PRIVATE LIMITED",
"TRUSTWELL JEWELLERS PRIVATE LIMITED",
"TRUSTWORTH INFRACORE PRIVATE LIMITED",
"TRUSTWORTHY AGRICULTURAL SERVICES PRIVATE LIMITED",
"TRUSTY AGRO PRIVATE LIMITED",
"TRUTECH CONSTRUCTIONS PRIVATE LIMITED",
"TRUTECH WEBS PRIVATE LIMITED",
"TRUTEK FASTENERS PRIVATE LIMITED",
"TRUTH FINDER SERVICES PRIVATE LIMITED",
"TRUTH SOLUTIONS PRIVATE LIMITED",
"TRUTH UDYOG METAL AND STEEL PRIVATE LIMITED",
"TRUTUF PIPES AND FITTINGS PRIVATE LIMITED",
"TRUTUFF FACILITY MANAGEMENT PRIVATE LIMITED",
"TRUTUFF SAFETY GLASS PRIVATE LIMITED",
"TRUVALUE AGRO VENTURES PRIVATE LIMITED",
"TRUVETA ENTERPRISES PRIVATE LIMITED",
"TRUVIC CONSULTING PRIVATE LIMITED",
"TRUVIM TECHNOLOGY PRIVATE LIMITED",
"TRUVIQ SYSTEMS PRIVATE LIMITED",
"TRUVISON INDUSTRIES PRIVATE LIMITED",
"TRUVOLT ENGINEERING CO PVT LTD",
"TRUWEIGHT WELLNESS PRIVATE LIMITED",
"TRUWORTH HEALTH TECHNOLOGIES PRIVATE LIMITED",
"TRUWORTH IMPEX PVT LTD",
"TRUWORTH INFOTECH PRIVATE LIMITED",
"TRUZIO TECHNOLOGIES INDIA PRIVATE LIMITED",
"TRV (KERALA) INTERNATIONAL AIRPORT LIMITED",
"TRV COMMODITIES PRIVATE LIMITED",
"TRV GLOBAL EXPORTS PRIVATE LIMITED",
"TRW AUTOMOTIVE HOLDINGS CORP.",
"TRW SUN STEERING WHEELS PRIVATE LIMITED",
"TRX LOGISTICS AND SUPPORT SERVICES PRIVATE LIMITED",
"TRY AUTO GEARS PRIVATE LIMITED",
"TRY BIRD HEALTHCARE PRIVATE LIMITED",
"TRY DEVELOPERS PRIVATE LIMITED",
"TRY UP DESIGNS PRIVATE LIMITED",
"TRYAKSI TECHNOLOGIES PRIVATE LIMITED",
"TRYCHEM STEEL PROCESS PRIVATE LIMITED",
"TRYCON CROP SCIENCE PRIVATE LIMITED",
"TRYCON TECHNOLOGIES PRIVATE LIMITED",
"TRYDAN SOLUTIONS PRIVATE LIMITED",
"TRYFACTA CONSULTING PRIVATE LIMITED",
"TRYKSHA PROJECTS PRIVATE LIMITED",
"TRYSHOERA(INDIA) PRIVATE LIMITED",
"TRYSOL GLOBAL SERVICES PRIVATE LIMITED",
"TRYSQUARE FLOORING PRIVATE LIMITED",
"TRYSQUARE MB PRIVATE LIMITED",
"TRYST AUTO PRIVATE LIMITED",
"TRYZENS INDIA PRIVATE LIMITED",
"TRZ MART PRIVATE LIMITED",
"TS BRASS AND BRONZE WORKS PRIVATE LIMITED",
"TS COMPROZONE PRIVATE LIMITED",
"TS FASHIONS PRIVATE LIMITED",
"TS FLOW CONTROLS PRIVATE LIMITED",
"TS INFOTECH INDIA PRIVATE LIMITED",
"TS INTERSEATS INDIA PRIVATE LIMITED",
"TS LAB PRIVATE LIMITED",
"TS SKILL AND TECH PRIVATE LIMITED",
"TS TECH MANDAL PRIVATE LIMITED",
"TS TECH SUN INDIA P LIMITED",
"TS TECH SUN RAJASTHAN PRIVATE LIMITED",
"TS TOP STAR SECURITY & ALLIED SERVICES LLP",
"TS5 SECURE PRIVATE LIMITED",
"TSA PROCESS EQUIPMENTS PRIVATE LIMITED",
"T-SANCT TECHNOLOGIES PRIVATE LIMITED",
"TSANGPOOL TEA PRIVATE LIMITED",
"TSAROLABS PRIVATE LIMITED",
"TSC",
"TSC CREST SOUTH ASIA PRIVATE LIMITED",
"TSC HOSPITAL PRIVATE LIMITED",
"TSC INSTRUMENTS PRIVATE LIMITED",
"TSC TRAVEL SERVICES PRIVATE LIMITED",
"TSCCF SHRISTI INFRASTRUCTURE DEVELOPMENT LIMITED",
"TSD CORPORATION LIMITED",
"TSE RENEWABLES PRIVATE LIMITED",
"TSECOND GENERATION TECHNOLOGY PRIVATE LIMITED",
"TSEPAK TECHNOLOGIES PRIVATE LIMITED",
"T-SERIES STAGEWORKS ACADEMY PRIVATE LIMITED",
"TSF ENGINEERS PRIVATE LIMITED",
"TSF FINANCIAL SERVICES PRIVATE LIMITED",
"TSF LIMITED",
"TSF MEDIA PRIVATE LIMITED",
"TSG AUTOMOBILES PRIVATE LIMITED",
"TSI BUSINESS PARKS HYDERABAD PRIVATE LIMITED",
"TSI INSTRUMENTS INDIA PRIVATE LIMITED",
"TSI MEP (I) PRIVATE LIMITED",
"TSI POWER PRIVATE LIMITED",
"TSI SOFTECH INDIA PRIVATE LIMITED",
"TSI YATRA PRIVATE LIMITED",
"TSIGHT CONSULTING PRIVATE LIMITED",
"TSIM COMMUNICATION SERVICES PRIVATE LIMITED",
"TSIPL PRIVATE LIMITED",
"TSK ENGINEERS PRIVATE LIMITED",
"TSK HOSPITALITY LLP",
"TSK PLY & VENEER INDUSTRIES PRIVATE LIMITED",
"TSKEI INDIA PRIVATE LIMITED",
"TSKP PROJECTS INDIA PRIVATE LIMITED",
"TSL CONSULTING PRIVATE LIMITED",
"TSL ELECTRO POWER PRIVATE LIMITED",
"TSL HOLDINGS PRIVATE LIMITED",
"TSLD CASTING PRIVATE LIMITED",
"TSM EDUCATION PRIVATE LIMITED",
"TSM LUBRICANTS PRIVATE LIMITED",
"TSMT CONSULTING PRIVATE LIMITED",
"TSMT TECHNOLOGY (INDIA) PRIVATE LIMITED",
"TSN EXPERT SERVICES PRIVATE LIMITED",
"TSN INFRASTRUCTURE PRIVATE LIMITED",
"TSN TIMBER HUB PRIVATE LIMITED",
"TSOLITSS INDIA PRIVATE LIMITED",
"TSORGO ORGANICS PRIVATE LIMITED",
"TSP ENGINEERS PRIVATE LIMITED",
"TSPH EDUCARE PRIVATE LIMITED",
"TSPI INFOTECH PRIVATE LIMITED",
"TSQ SYSTEMS PRIVATE LIMITED",
"TSR AGRI SOLUTIONS PRIVATE LIMITED",
"TSR CARGO PRIVATE LIMITED",
"TSR CONSULTANTS PRIVATE LIMITED",
"TSR DARASHAW LIMITED",
"TSR DATA PROCESSING PRIVATE LIMITED",
"TSR FILMS PRIVATE LIMITED",
"TSR NIRMAAN PRIVATE LIMITED",
"TSR RECYCLING INDIA PRIVATE LIMITED",
"TSR SECURITY SERVICES PRIVATE LIMITED",
"TSRTC",
"TSS CONSULTANCY PRIVATE LIMITED",
"TSS STAFFING SOLUTIONS PRIVATE LIMITED",
"TSSC ENGINEERING PRIVATE LIMITED",
"TSSDG INDIA PRIVATE LIMITED",
"TSSM BHIVARABAI SAWANT COLLEGE OF ENGINEERING AND RESEARCH NARHE PUNE",
"TSSM CYGNET PUBLIC SCHOOL",
"TSSS INFOTECH AND INFRA PRIVATE LIMITED",
"TST24X7 ONCALL SERVICES PRIVATE LIMITED",
"TSTEPS PRIVATE LIMITED",
"TSTM CREATIONS PRIVATE LIMITED",
"TSUBAKI CONVEYOR SYSTEMS INDIA PRIVATE LIMITED",
"TSUBAKI INDIA POWER TRANSMISSION PRIVATE LIMITED",
"TSUDAKOMA SERVICE INDIA PRIVATE LIMITED",
"TSUGAMI PRECISION ENGINEERING INDIA PRIVATE LIMITED",
"TSUJI IPPEI INDIA PRIVATE LIMITED",
"TSUJIKAWA INDIA PRIVATE LIMITED",
"TSUMITOMO AIRCON PRIVATE LIMITED",
"TSUNAMI TOURS AND TRAVELS PRIVATE LIMITED",
"TSUYO MANUFACTURING PRIVATE LIMITED",
"TSUYOI BIOSCIENCE TECHNOLOGIES PRIVATE LIMITED",
"TSUZUKI INDIA PRECISION LLP",
"TSV EXIMP PRIVATE LIMITED",
"TSV GLOBAL SOLUTIONS PRIVATE LIMITED",
"TSW CAPITAL SERVICES PRIVATE LIMITED",
"TSW INDUSTRIAL SOLUTIONS PRIVATE LIMITED",
"TSY LEISURE PRIVATE LIMITED",
"TSYS CARD TECH SERVICES INDIA LLP",
"TSYS CARD TECH SERVICES INDIA PRIVATE LIMITED",
"TT AUTOCOMPONENT SYSTEMS PRIVATE LIMITED",
"TT AVIATION HANDLING SERVICES PRIVATE LIMITED",
"TT BHARAT INTEGRATED LOGISTICS PRIVATE LIMITED",
"TT BUILDCON PRIVATE LIMITED",
"TT INSURANCE BROKING SERVICES PRIVATE LIMITED",
"TT LOGISTICS AND CARGO PRIVATE LIMITED",
"TT RECYCLING MANAGEMENT INDIA PRIVATE LIMITED",
"TT STEEL SERVICE INDIA PRIVATE LIMITED",
"TT TECHNO PARK MANAGEMENT SERVICES INDIA PRIVATE LIMITED",
"TTA TRAINING PRIVATE LIMITED",
"TTD LOGISTICS PRIVATE LIMITED",
"TTE TECHNOLOGY INDIA PRIVATE LIMITED",
"TTEC DIGITAL ANALYTICS INDIA LLP",
"TTEC INDIA CUSTOMER SOLUTIONS PRIVATE LIMITED",
"TTEVO INFRATECH PRIVATE LIMITED",
"TTF EDUCATION SERVICES PRIVATE LIMITED",
"TTF TECHNOLOGIES PRIVATE LIMITED",
"TTGA PRIVATE LIMITED",
"T-THREE INSURANCE SURVEYOR AND LOSS ASSESSOR PRIVATE LIMITED",
"TTI ELECTRONICS ASIA INDIA PRIVATE LIMITED",
"TTI ENTERPRISE LIMITED",
"TTI POLYMERS PRIVATE LIMITED",
"TTK HEALTHCARE LIMITED",
"TTK HOSPITAL",
"TTK PRESTIGE LIMITED",
"TTK SERVICES PRIVATE LIMITED",
"TTL ENGINEERING PRIVATE LIMITED",
"TTL HOLIDAYS PRIVATE LIMITED",
"TTL INFOTEC PRIVATE LIMITED",
"TTP TECHNOLOGIES PRIVATE LIMITED",
"TTS BUSINESS SERVICES PRIVATE LIMITED",
"TTS EDUCATION PRIVATE LIMITED OPC",
"TTS SYSTEMATIX PVT LTD",
"TTSF CLOUD ONE PRIVATE LIMITED",
"TU CAGR VENTURES LLP",
"TUAMAN ENGINEERING LIMITED",
"TUAMAN INFRASTRUCTURE LIMITED",
"TUAREG MARKETING PRIVATE LIMITED",
"TUBACEX TUBES AND PIPES PRIVATE LIMITED",
"TUBAS WIRE AND CONDUCTOR PVT LTD",
"TUBBY IMPEX PRIVATE LIMITED",
"TUBE CLAMPS INDIA PRIVATE LIMITED",
"TUBE FORMES TECHNOLOGY PRIVATE LIMITED",
"TUBE INVESTMENTS OF INDIA LIMITED",
"TUBE PRODUCTS OF INDIA",
"TUBE ROSE ESTATES PRIVATE LIMITED",
"TUBE TECH COPPER & ALLOYS PRIVATE LIMITED",
"TUBE TURN INDIA PRIVATE LIMITED",
"TUBE-INDIA CONTAINER PRIVATE LIMITED",
"TUBEKRAFT PRECISION PRIVATE LIMITED",
"TUBELIGHT DIGITAL MEDIA & SERVICES P L",
"TUBERCLOCES CLINIC TB GZB",
"TUBEROSE LOGISTICS PRIVATE LIMITED",
"TUBES & PIPES (INDIA) PVT LTD",
"TUBESTAR OIL AND GAS SERVICES PRIVATE LIMITED",
"TUBETECH EQUIPMENT PRIVATE LIMITED",
"TUBETRON INDIA PRIVATE LIMITED",
"TUBEWELL CIRCLE¬† SAHARANPUR",
"TUBEWELL DIVISION BARABANKI",
"TUCANA LIGHTS PRIVATE LIMITED",
"TUCKER MOTORS PRIVATE LIMITED",
"TUCSON HYDROCONTROLS PRIVATE LIMITED",
"TUCSONPAC (INDIA) PRIVATE LIMITED",
"TUDIP TECHNOLOGIES PRIVATE LIMITED",
"TUDOR INDIA PRIVATE LIMITED",
"TUDOR MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"TUF KOTE AUTOMOTIVE PRIVATE LIMITED",
"TUF METALLURGICAL PRIVATE LIMITED",
"TUFAN MOTORS PRIVATE LIMITED",
"TUFANGANJ AGRO INDUSTRIES PRIVATE LIMITED",
"TUFCARE PHARMA PRIVATE LIMITED",
"TUFF OFFSHORE ENERGY AND ENGINEERING (INDIA) PRIVATE LIMITED",
"TUFF PLAST PUNE PVT LTD",
"TUFF-BOND INDUSTRIAL ADHESIVES PRIVATE LIMITED",
"TUFFEST SAFETY GLASSES PRIVATE LIMITED",
"TUFFWUD(INDIA) PRIVATE LIMITED",
"TUFLITE POLYMERS LIMITED",
"TUFROPES PRIVATE LIMITED",
"TUFWUD DOORS AND ACCESSORIES PRIVATE LIMITED",
"TUGANIA INFRATECH PRIVATE LIMITED",
"TUHIRAM POLYPACK & TEXTILES PRIVATE LIMITED",
"TUI CONSULTING LLP",
"TUI INDIA PRIVATE LIMITED",
"TUIBINZ TRADING INDIA PRIVATE LIMITED",
"TUISHA IMPEX PRIVATE LIMITED",
"TUJENT INDIA PRIVATE LIMITED",
"TUK INDUSTRY",
"TUKA TECH INDIA PRIVATE LIMITED",
"TULA DIGITAL (INDIA) PRIVATE LIMITED",
"TULA ENGINEERING PRIVATE LIMITED",
"TULA FINANCE LIMITED",
"TULA FOOD PRODUCTS PRIVATE LIMITED",
"TULAS INSTITUTE",
"TULASI AVENUES PRIVATE LIMITED",
"TULASI INFRATECH PRIVATE LIMITED",
"TULASI MOTORS PRIVATE LIMITED",
"TULASI MULTI SPECIALITY HOSPITAL",
"TULASI PSYCHIATRIC & REHABILITATION PRIVATE LIMITED",
"TULASI SEEDS PRIVATE LIMITED",
"TULFA PRIVATE LIMITED",
"TULI COLLEGE OF HOTEL MANAGEMENT",
"TULI DAIRY PRIVATE LIMITED",
"TULI ENGINEERING BROS PVT LTD",
"TULI HOTELS PVT LTD",
"TULI INTERNATIONAL PRIVATE LIMITED",
"TULI MINING CORPORATION PRIVATE LIMITED",
"TULI OFF SET PRINTERS PRIVATE LIMITED",
"TULI RESEARCH AND BREEDING FARM PRIVATE LIMITED",
"TULI TRADE PRIVATE LIMITED",
"TULIIP NESTZ HOSPITALITY PRIVATE LIMITED",
"TULIKA APPLIANCES PRIVATE LIMITED",
"TULIKA ENGINEERS PRIVATE LIMITED",
"TULIP 3P MEDIA PRIVATE LIMITED",
"TULIP BUILDTECH PRIVATE LIMITED",
"TULIP CASTING PRIVATE LIMITED",
"TULIP COMPONENTS PRIVATE LIMITED",
"TULIP COMPRESSION PRIVATE LIMITED",
"TULIP COTSPIN PRIVATE LIMITED",
"TULIP CREATIONS PRIVATE LIMITED",
"TULIP DIAGNOSTICS PRIVATE LIMITED",
"TULIP ELASTICS PRIVATE LIMITED",
"TULIP ENERGY PRIVATE LIMITED",
"TULIP FABRICS PRIVATE LIMITED",
"TULIP FLUID-TECH PRIVATE LIMITED",
"TULIP FOREX PRIVATE LIMITED",
"TULIP GRANITES PRIVATE LIMITED",
"TULIP HAVA HARDWARE INDIA LIMITED",
"TULIP HI-TECH INDIA PRIVATE LIMITED",
"TULIP HOLIDAYS PRIVATE LIMITED",
"TULIP HOSPITALS PRIVATE LIMITED",
"TULIP INFRATECH PRIVATE LIMITED",
"TULIP INFRATOWERS PRIVATE LIMITED",
"TULIP INN CONSTRUWELL PRIVATE LIMITED",
"TULIP INSTITUTIONAL SERVICES PRIVATE LIMITED",
"TULIP LAB PRIVATE LIMITED",
"TULIP LIVING SOLUTIONS PRIVATE LIMITED",
"TULIP MALLS PRIVATE LIMITED",
"TULIP MULTISPECIALITY HOSPITAL PRIVATE LIMITED",
"TULIP NILGIRIS EXPORTS PRIVATE LIMITED",
"TULIP NURSING HOME PRIVATE LIMITED",
"TULIP POLYCHEM PRIVATE LIMITED",
"TULIP PROPERTIES PRIVATE LIMITED",
"TULIP RENEWABLE POWERTECH PRIVATE LIMITED",
"TULIP STAR HOTELS LIMITED",
"TULIP TEA CO LTD",
"TULIP TRAVEL SERVICES LIMITED",
"TULIP TRENDS PRIVATE LIMITED",
"TULIP VENTURES PRIVATE LIMITED",
"TULIPCROP SCIENCE PRIVATE LIMITED",
"TULIPS AMBBIENCE PRIVATE LIMITED",
"TULIPS CONSULTANTS PRIVATE LIMITED",
"TULIPS HEALTHCARE PRIVATE LIMITED",
"TULITA AHARA PRIVATE LIMITED",
"TULJA BHAVANI ISPAT PRIVATE LIMITED",
"TULJA BHAVANI JEWELLERS PRIVATE LIMITED",
"TULJA BHAWANI ENGIMECH PRIVATE LIMITED",
"TULJA ESTATE PRIVATE LIMITED",
"TULJABHAVANI COLD STORAGE PRIVATE LIMITED",
"TULJABHAVANI PAPER MILLS PRIVATE LIMITED",
"TULJABHAVANI PRATHMIK VIDYA MANDIR TULJAPUR",
"TULJAI LABPOINT PRIVATE LIMITED",
"TULLEEHO PORTALS PRIVATE LIMITED",
"TULLU DOMESTIC APPLIANCES PRIVATE LIMITED",
"TULLU SALES PRIVATE LIMITED",
"TULSA COMBUSTION & INFRASTRUCTURE PRIVATE LIMITED",
"TULSANA CONSULTANCY SERVICES PRIVATE LIMITED",
"TULSE ELECTRONICS INDIA PRIVATE LIMITED",
"TULSEA PICTURES PRIVATE LIMITED",
"TULSHI RICETECH PRIVATE LIMITED",
"TULSI AGRO ENGI MECH PRIVATE LIMITED",
"TULSI AMRIT PRIVATE LIMITED",
"TULSI BIOSCIENCES PRIVATE LIMITED",
"TULSI BUILDCON",
"TULSI BUILDWELL PRIVATE LIMITED",
"TULSI CAPITAL MARKET LIMITED",
"TULSI CHEMICALS AND PAINTS PRIVATE LIMITED",
"TULSI CLOTH PROCESSORS PRIVATE LIMITED",
"TULSI COTEX PRIVATE LIMITED",
"TULSI COTTON MILLS PRIVATE LIMITED",
"TULSI DEVELOPERS INDIA PRIVATE LIMITED",
"TULSI DIAMONDS PRIVATE LIMITED",
"TULSI DYECHEM PRIVATE LIMITED",
"TULSI ELECTROINFRA PRIVATE LIMITED",
"TULSI ENTERPRISES PRIVATE LIMITED",
"TULSI FABRICS (INDIA) PRIVATE LIMITED",
"TULSI FOODS",
"TULSI GLOBAL LOGISTICS PRIVATE LIMITED",
"TULSI HIGHRISE PVT LTD",
"TULSI HOSPITALS (INDIA) LIMITED",
"TULSI HOTELS PRIVATE LIMITED",
"TULSI IMPEX PVT LTD",
"TULSI INFRA PROJECTS PRIVATE LIMITED",
"TULSI INTERMEDIATES PRIVATE LIMITED",
"TULSI LOGISTICS PRIVATE LIMITED",
"TULSI MARBLES PVT LTD",
"TULSI MULTI SPECIALITY HOSPITAL",
"TULSI MULTISPECIALITY HOSPITAL",
"TULSI PAINTS PRIVATE LIMITED",
"TULSI PALACE RESORT PRIVATE LIMITED",
"TULSI PAPER MILLS PRIVATE LIMITED",
"TULSI POLY FILM PRIVATE LIMITED",
"TULSI RAM GAYA PRASAD PRIVATE LIMITED",
"TULSI RETAIL STORES INDIA PRIVATE LIMITED",
"TULSI RUBBER PRODUCTS PRIVATE LIMITED",
"TULSI SHIPPING PRIVATE LIMITED",
"TULSI SURGICAL DEVICES PRIVATE LIMITED",
"TULSI SYNTHETICS PRIVATE LIMITED",
"TULSI WEAVES PRIVATE LIMITED",
"TULSI WEIGH SOLUTIONS PRIVATE LIMITED",
"TULSIAN ELECTRICALS AND CONDUCTORS P LIMITED",
"TULSIAN GLOBAL PRIVATE LIMITED",
"TULSIAN PMS LIMITED",
"TULSIAN PROCESSORS PRIVATE LIMITED",
"TULSIAN REFINERY PRIVATE LIMITED",
"TULSIANI BUILDERS AND TEXTILES PRIVATE LIMITED",
"TULSIANI CONSTRUCTIONS AND DEVELOPERS PRIVATE LIMITED",
"TULSIDAS KHIMJI HOLIDAYS PRIVATE LIMITED",
"TULSIDAS KHIMJI PRIVATE LIMITED",
"TULSIDAS MEMORIAL CATALYST HYBRID SCHOOL",
"TULSIRATAN PLASTICS PVT LTD",
"TULSIVISTA MACHINETECH PRIVATE LIMITED",
"TULSONS FINANCIAL AND CONSULTANCY SERVICES PVT LTD",
"TULSYAN ENTERPRISE PVT LTD",
"TULSYAN FOODS PRIVATE LIMITED",
"TULSYAN HEALTHCARE PRIVATE LIMITED",
"TULSYAN IMPEX PVT LTD",
"TULSYAN JEWELLERY PRIVATE LIMITED",
"TULSYAN SECURITY SERVICES PRIVATE LIMITED",
"TULSYAN SMELTERS PRIVATE LIMITED",
"TULSYAN VASTRALAYA PRIVATE LIMITED",
"TULYA AGRI SEEDS PRIVATE LIMITED",
"TULYA FOOD PRODUCTS PRIVATE LIMITED",
"TUMAKURU MACHINE TOOL PARK",
"TUMAX PIPES PRIVATE LIMITED",
"TUMBLEDRY SOLUTIONS PRIVATE LIMITED",
"TUMKUR DISTRIC CO-OPERATIVE CENTRAL BANK LTD",
"TUMKUR GRAIN MERCHANTS CO-OPERATIVE BANK",
"TUMKUR HEALTH SERVICES PRIVATE LIMITED",
"TUMKUR MERCHANTS CREDIT CO OPERATIVE LIMITED",
"TUMKUR MINERALS PRIVATE LIMITED",
"TUMLARE SOFTWARE SERVICES PRIVATE LIMITED",
"TUMMALA INFRASTRUCTURE LIMITED",
"TUMMALA TEKNOSOFT SOLUTION PRIVATE LIMITED",
"TUMMYFULL FOODVENTURE PRIVATE LIMITED",
"TUNA SOFTWARE SOLUTIONS PRIVATE LIMITED",
"TUNBRIDGE HIGH SCHOOL",
"TUNDRA TECHNICAL SOLUTIONS INDIA PRIVATE LIMITED",
"TUNERLABS CONSULTING PRIVATE LIMITED",
"TUNG BUILDERS PRIVATE LIMITED",
"TUNGA PVC PIPES PRIVATE LIMITED",
"TUNGABHADRA AGRI TECH PRIVATE LIMITED",
"TUNGABHADRA POWER COMPANY PRIVATE LIMITED",
"TUNGABHADRA SOLAR PARKS PRIVATE LIMITED",
"TUNGAL IND PU SCIENCE COLLEGE VIJAYAPUR",
"TUNGALOY INDIA PRIVATE LIMITED",
"TUNGARESHWAR PACKAGING PVT LTD",
"TUNGNATH EDUCATIONAL SOCIETY",
"TUNGSTEN CONSUMER GOODS PRIVATE LIMITED",
"TUNGSTEN INDIA PRIVATE LIMITED",
"TUNICALABS MEDIA PRIVATE LIMITED",
"TUNICS SPONGE PRIVATE LIMITED",
"TUNIP INFO SERVICES PRIVATE LIMITED",
"TUNKAI MARKETING PRIVATE LIMITED",
"TUNKERS AUTOMATION INDIA PRIVATE LIMITED",
"TUNTURU ENGINEERING AID (OPC) PRIVATE LIMITED",
"TUNWAL E MOTORS PRIVATE LIMITED",
"TUNWAL E VEHICLE INDIA PRIVATE LIMITED",
"TUNWAL E-MOTORS LIMITED",
"TUOBRO FURGUSON (INDIA) PVT LTD",
"TUOLUMNE TECHNOLOGY PRIVATE LIMITED",
"TUOREN MEDICAL DEVICE INDIA PRIVATE LIMITED",
"TUPELO BUILDERS PRIVATE LIMITED",
"TUPELO PROPERTIES PRIVATE LIMITED",
"TUPPADAHALLI ENERGY INDIA PRIVATE LIMITED",
"TUPPERWARE INDIA PRIVATE LIMITED",
"TURAAB STEEL PRIVATE LIMITED",
"TURABIT SOLUTIONS PRIVATE LIMITED",
"TURABUL HAQ URDU HIGH SCHOOL GANGAPUR",
"TURACOZ HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"TURAKHIA FERROMET PRIVATE LIMITED",
"TURAKHIA INTERNATIONAL PRIVATE LIMITED",
"TURAKHIA METAL FORMS PRIVATE LIMITED",
"TURAKHIA OVERSEAS PRIVATE LIMITED",
"TURAKHIA POLYMERS PRIVATE LIMITED",
"TURAKHIA STEELS PRIVATE LIMITED (CN)",
"TURAKHIA TEXTILES PRIVATE LIMITED",
"TURAKHIYA METALS PRIVATE LIMITED",
"TURANT SAMADHAN (I) PRIVATE LIMITED",
"TURANTH LOGISTIC PRIVATE LIMITED",
"TURANTH SURAKSHA INSURANCE WEB AGGREGATOR PRIVATE LIMITED",
"TURBHE CHEMICALS PRIVATE LIMITED",
"TURBHE IRON AND STEEL TRADING PRIVATE LTD",
"TURBHE POLYCANS PRIVATE LIMITED",
"TURBO AUTOMOTIVES PRIVATE LIMITED",
"TURBO BEARINGS PRIVATE LIMITED",
"TURBO BELL MOULDS PRIVATE LIMITED",
"TURBO CAST (INDIA) PRIVATE LIMITED",
"TURBO ENERGY PRIVATE LIMITED",
"TURBO INDIA INTERCONNECT SOLUTIONS LLP",
"TURBO INDUSTRIES PRIVATE LIMITED",
"TURBO INTERTRADE COMPANY INDIA PRIVATE LIMITED",
"TURBO LOGISTICS PRIVATE LIMITED",
"TURBO MARINE PRIVATE LIMITED",
"TURBO MECH SERVICES PRIVATE LIMITED",
"TURBO MEGHA AIRWAYS PRIVATE LIMITED",
"TURBO MOT INDIA PRIVATE LIMITED",
"TURBO PLASTIBLENDS PRIVATE LIMITED",
"TURBO POWER ENGINEERING",
"TURBO RETAIL PRIVATE LIMITED",
"TURBO TECH PRECISION ENGINEERING PRIVATE LIMITED",
"TURBO TELECOM PRIVATE LIMITED",
"TURBO TOOLS PRIVATE LIMITED",
"TURBO TRAVELS INDIA PRIVATE LIMITED",
"TURBO WHEELS PRIVATE LIMITED",
"TURBO WIRE INDUSTRIES PRIVATE LIMITED",
"TURBOCAM INDIA PRIVATE LIMITED",
"TURBOCHARGING INDUSTRIES AND SERVICES INDIA PRIVATE LIMITED",
"TURBOLAB TECHNOLOGIES PRIVATE LIMITED",
"TURBOLUX PAINTS PRIVATE LIMITED",
"TURBOMECA INDIA ENGINES PRIVATE LIMITED",
"TURBONET SYSTEMS PRIVATE LIMITED",
"TURBOSMART TELEVENTURES PRIVATE LIMITED",
"TURBOT HQ INDIA PRIVATE LIMITED",
"TURBOTECH INFRANET PRIVATE LIMITED",
"TURBOTECH PROJECTS AND SERVICES PRIVATE LIMITED",
"TURBOTOYZ PRIVATE LIMITED",
"TURBOVENT INDUSTRIES PRIVATE LIMITED",
"TURCK INDIA AUTOMATION PRIVATE LIMITED",
"TUREEN SPECIALTY INGREDIENTS PRIVATE LIMITED",
"TURF TEXTILE EXPORTS PRIVATE LIMITED",
"TURFTOWN SPORTING PURSUITS PRIVATE LIMITED",
"TURGAJO TECHNOLOGIES PRIVATE LIMITED",
"TURGIS ET GAILLARD INDIA PRIVATE LIMITED",
"TURING EASTLAND PRIVATE LIMITED",
"TURINGS XYZ PRIVATE LIMITED",
"TURK DIS TICARET BANKASI AS",
"TURK EKONOMI BANKASI AS",
"TURK MITHANI ENTERPRISE PRIVATE LIMITED",
"TURKINZ ONE HOSPITALITY PRIVATE LIMITED",
"TURKISH AIRLINES INC",
"TURKISH EMBASSY IN NEW DELHI",
"TURKISH ENGINEERING CONSULTING & CONTRACTING - TUMAS INDIA PRIVATE LIMITED",
"TURMERIC CLOUD TECHNOLOGIES PRIVATE LIMITED",
"TURMERIC VISION PRIVATE LIMITED",
"TURMERIQ INTEGRATED MARKETING SOLUTIONS PRIVATE LIMITED",
"TURNAROUND CORPORATE ADVISORS PRIVATE LIMITED",
"TURNAROUND GLOBAL SERVICES LLP",
"TURNB BUSINESS SERVICES PRIVATE LIMITED",
"TURNER & TOWNSEND PRIVATE LIMITED",
"TURNER AND TOWNSEND PRIVATE LIMITED",
"TURNER CONSULTING AND MANAGEMENT SERVICES PRIVATE LIMITED",
"TURNER GENERAL ENTERTAINMENT NETWORKS INDIA PRIVATE LIMITED",
"TURNER INTERNATIONAL CONSULTING INDIA PRIVATE LIMITED",
"TURNER LOGISTICS INDIA PRIVATE LIMITED",
"TURNER MORRISON LIMITED",
"TURNER PROJECT MANAGEMENT INDIA PRIVATE LIMITED",
"TURNING POINT CONSULTANTS",
"TURNING POINT EXPORTS PRIVATE LIMITED",
"TURNING POINT TRAINING AND ASSESSMENT SYSTEMS PRIVATE LIMITED",
"TURNINGIDEAS SOLUTION PRIVATE LIMITED",
"TURNING-POINT HEALTH CARE PRIVATE LIMITED",
"TURNINGPOINT SOFTWARE SOLUTIONS PRIVATE LIMITED",
"TURNIPSEED ACCOUNTING PRIVATE LIMITED",
"TURNKEY ELECTRICAL ENGINEERS PRIVATE LIMITED",
"TURNKEY ENTERPRISE PRIVATE LIMITED",
"TURNKEY INFRASTRUCTURES PRIVATE LIMITED",
"TURNKEY INSIGHTS I PRIVATE LIMITED",
"TURNKEY MUSIC & PUBLISHING PRIVATE LIMITED",
"TURNKEY SOLUTIONS PRIVATE LIMITED",
"TURNKEY TALENT SOLUTIONS PRIVATE LIMITED",
"TURNKEY TRAINING PRIVATE LIMITED",
"TURNO - TECH AUTO ENGINEERING PRIVATE LIMITED",
"TURNOMILL EQUIPMENTS PRIVATE LIMITED",
"TURNPIKE INDIA PRIVATE LIMITED",
"TURNREST RESOURCES PRIVATE LIMITED",
"TURNSTAND PRIVATE LIMITED",
"TURNWELL ENGINEERS PVT LTD",
"TURPENTINE TECHNOLOGIES PRIVATE LIMITED",
"TURPYMOBILEAPPS PRIVATE LIMITED",
"TURQUOISE FASHIONS PRIVATE LIMITED",
"TURQUOISE INVESTMENTS AND FINANCE PRIVATE LIMITED",
"TURRET ENGINEERS AND BUILDERS PRIVATE LIMITED",
"TURRET PHARMA PRIVATE LIMITED",
"TURRINO ADVERTISING PRIVATE LIMITED",
"TURTLE DOWN UNDER",
"TURTLE LIMITED",
"TURTLE ON THE BEACH",
"TURTLE QUICK PRIVATE LIMITED",
"TURTLE TURBINES PRIVATE LIMITED",
"TURTLE WAX CAR CARE INDIA PRIVATE LIMITED",
"TURTLE WEALTH MANAGEMENT PRIVATE LIMITED",
"TURTLEBOWL CONSULTING PRIVATE LIMITED",
"TURTLEMINT INSURANCE BROKING SERVICES PRIVATE LIMITED",
"TURVO INDIA PRIVATE LIMITED",
"TUSAJ LIFESTYLE PRIVATE LIMITED",
"TUSAR FABENGINEERS PRIVATE LIMITED",
"TUSARA JEWELS PRIVATE LIMITED",
"TUSCAN CONSULTANTS AND DEVELOPERS PRIVAT",
"TUSCAN PROPERTIES PRIVATE LIMITED",
"TUSCAN REAL ESTATE PRIVATE LIMITED",
"TUSCANO EQUIPMENTS PRIVATE LIMITED",
"TUSCANY PROPERTIES PRIVATE LIMITED",
"TUSCO LIMITED",
"TUSCON (ENGINEERS) PRIVATE LIMITED",
"TUSHA TEXTILES MUMBAI PRIVATE LIMITED",
"TUSHANK ENTERPRISES PRIVATE LIMITED",
"TUSHAR CLOTHING PRIVATE LIMITED",
"TUSHAR CONSULTANCY PRIVATE LIMITED",
"TUSHAR DYE-CHEM PVT LTD",
"TUSHAR ENGINEERING PRIVATE LIMITED",
"TUSHAR FABRICS PRIVATE LIMITED",
"TUSHAR NUTRITIVE FOODS PRIVATE LIMITED",
"TUSHAR PIPES PRIVATE LIMITED",
"TUSHAR PRECICOMP PRIVATE LIMITED",
"TUSHAR SOGANI DESIGNS PRIVATE LIMITED",
"TUSHAR TOURS & MOTELS PRIVATE LIMITED",
"TUSHAR TRADELINK PRIVATE LIMITED",
"TUSHAR TRANS EQUIPMENT PRIVATE LIMITED",
"TUSHI CREATION INDIA PRIVATE LIMITED",
"TUSHI ENGINEERING PRIVATE LIMITED",
"TUSHI MOTORS PRIVATE LIMITED",
"TUSHNIL IMPEX PRIVATE LIMITED",
"TUSHTI AGRI PRODUCTS PRIVATE LIMITED",
"TUSHTI INTERNATIONAL PRIVATE LIMITED",
"TUSKAR MANUFACTURING SOLUTIONS PRIVATE LIMITED",
"TUSKER DYE CHEM PRIVATE LIMITED",
"TUSKER ENTERPRISES PRIVATE LIMITED",
"TUSKER INDIA ENGINEERS PRIVATE LIMITED",
"TUSKER MOTORCYCLES PRIVATE LIMITED",
"TUSKER PAPER BOXES PRIVATE LIMITED",
"TUSKER SECURITY PRIVATE LIMITED",
"TUSKER TECHNOMATE PRIVATE LIMITED",
"TUSKER TRAVELS",
"TUSKER WORKSPACE PRIVATE LIMITED",
"TUSKERS FACILITY & PROPERTY MANAGEMENT PRIVATE LIMITED",
"TUSOVA AGRO PRIVATE LIMITED",
"TUSSHAR AXLES PRIVATE LIMITED",
"TUSSHAR INFRA DEVELOPERS PRIVATE LIMITED",
"TUSSOR MACHINE TOOLS INDIA PRIVATE LIMITED",
"TUTEJA MARKETING PRIVATE LIMITED",
"TUTICORIN ALKALI CHEMICALS AND FERTILIZERS LIMITED",
"TUTICORIN CINEMA CO PRIVATE LIMITED",
"TUTICORIN HINDUSTAN BIOPLANT PRIVATE LIMITED",
"TUTICORIN PORT ROAD COMPANY LIMITED",
"TUTICORIN SALT & MARINE CHEMICALS LTD",
"TUTIS INNOVATIVE E-SERVICES PRIVATE LIMITED",
"TUTOR INVESTMENT AND FINANCE PVT LTD",
"TUTORBRO PRIVATE LIMITED",
"TUTORIALS POINT (INDIA) PRIVATE LIMITED",
"TUTORIALS POINT I PRIVATE LIMITED",
"TUTORIALS POINT INDIA LIMITED",
"TUTTSAN PHARMA PRIVATE LIMITED",
"TUTUS INDIA AUTOMATION PRIVATE LIMITED",
"TUV INDIA P LTD",
"TUV RHEINLAND INDIA PRIVATE LIMITED",
"TUV RHEINLAND NIFE ACADEMY PRIVATE LIMITED",
"TUV SUD SOUTH ASIA PRIVATE LIMITED",
"TUVIJAT DEVELOPER PRIVATE LIMITED",
"TUYASMART (INDIA) PRIVATE LIMITED",
"TUZEN TECHNOLOGIES PRIVATE LIMITED",
"TV TODAY NETWORK LIMITED",
"TV VISION LIMITED",
"TV18 BROADCAST LIMITED",
"TV18 HOME SHOPPING NETWORK LIMITED",
"TV2Z INDIA DEVELOPMENT AND SUPPORT PRIVATE LIMITED",
"TV9 KARNATAKA PRIVATE LIMITED",
"TV9 MEDIA MAHARASHTRA PRIVATE LIMITED",
"TVAKSA TECHNOLOGIES PRIVATE LIMITED",
"TVAM LIFESTYLE LLP",
"TVARA AUTOMOTIVE INNOVATIONS PRIVATE LIMITED",
"TVARANA SOFTWARE SOLUTIONS PRIVATE LIMITED",
"TVARITA SOFTWARE PRIVATE LIMITED",
"TVARUR OILS & FATS PRIVATE LIMITED",
"TVASHTA ENGINEERING PVT LTD",
"TVASTAR INFRATECH PRIVATE LIMITED",
"TVB HEALTHCARE PRIVATE LIMITED",
"TVC ELECTRONICS",
"TVC SHARES STOCK INVESTMENT PRIVATE LIMITED",
"TVCH DISTRIBUTION SERVICES PRIVATE LIMITED",
"TVCORP SOLUTIONS PRIVATE LIMITED",
"TVCS INDIA OPC PRIVATE LIMITED",
"TVESA TRADING PRIVATE LIMITED",
"TVESAS ELECTRIC SOLUTIONS PRIVATE LIMITED",
"TVH CONSUMER PRODUCTS PRIVATE LIMITED",
"TVH ESTATES CHENNAI PRIVATE LIMITED",
"TVH INDIA PRIVATE LIMITED",
"TVH PROPERTY DEVELOPMENTS INDIA PRIVATE LIMITED",
"TVIS CONSULTING PRIVATE LIMITED",
"TVIS FASHIONS PRIVATE LIMITED",
"TVIS VELAMMAL VIDYALAYA",
"TVISHA TECHNOLOGIES PRIVATE LIMITED",
"TVISHI SERVICES PRIVATE LIMITED",
"TVISHI TECHNOLOGIES PRIVATE LIMITED",
"TVISION INSIGHTS INDIA PRIVATE LIMITED",
"TVL ENGINEERS PRIVATE LIMITED",
"TVL MEDIA PRIVATE LIMITED",
"TVLK INDIA PRIVATE LIMITED",
"TVLS TRANSPORTS PRIVATE LIMITED",
"TVM SIGNALLING AND TRANSPORTATION SYSTEMS PRIVATE LIMITED",
"TVO TOUR AND TRAVEL PRIVATE LIMITED",
"TVR REALCON PRIVATE LIMITED",
"TVR REALTY SOLUTIONS PRIVATE LIMITED",
"TVR VENTURES PRIVATE LIMITED",
"TVS ARGOMM PRIVATE LIMITED",
"TVS AUTO ASSIST INDIA LIMITED",
"TVS AUTOMOBILE SOLUTIONS LIMITED",
"TVS AUTOMOBILE SOLUTIONS PRIVATE LIMITED",
"TVS CAPITAL FUNDS PRIVATE LIMITED",
"TVS COMMUTATION SOLUTIONS LIMITED.",
"TVS CREDIT SERVICES LIMITED",
"TVS EDUCATIONAL SOCIETY",
"TVS ELECTRONICS LIMITED.",
"TVS INDUSTRIAL & LOGISTICS PARKS PRIVATE LIMITED",
"TVS INSURANCE BROKING LIMITED",
"TVS INSURANCE BROKING PRIVATE LIMITED",
"TVS INTERCONNECT SYSTEMS PRIVATE LIMITED",
"TVS INVESTMENTS PRIVATE LIMITED",
"TVS MOBILITY PRIVATE LIMITED",
"TVS MOTOR COMPANY LIMITED",
"TVS NEXT LIMITED",
"TVS NEXT PRIVATE LIMITED",
"TVS ORGANICS PRIVATE LIMITED",
"TVS SCS GLOBAL FREIGHT SOLUTIONS LIMITED",
"TVS SENSING SOLUTIONS PRIVATE LIMITED",
"TVS SEWING NEEDLES LIMITED",
"TVS SIRIUS CONTROLS PRIVATE LIMITED",
"TVS SRICHAKRA INVESTMENTS LIMITED",
"TVS SRICHAKRA LIMITED",
"TVS STAFFING SOLUTIONS PRIVATE LIMITED",
"TVS SUPPLY CHAIN SOLUTIONS LIMITED",
"TVS TOYOTA TSUSHO SUPPLY CHAIN SOLUTION LIMITED",
"TVS TRAINING AND SERVICES LIMITED",
"TVS UPASANA LIMITED",
"TVS WEALTH PRIVATE LIMITED",
"TVU NETWORKS INDIA PRIVATE LIMITED",
"TW HOSPITALITY SERVICES PRIVATE LIMITED",
"TW METALS (BANGALORE) PRIVATE LIMITED",
"TW SHIP MANAGEMENT PRIVATE LIMITED",
"TWALKAR BROTHERS PRIVATE LIMITED",
"T'WALKER'S PHARMACEUTICALS PRIVATE LIMITED",
"TWARIT NIDAN MICRO FOUNDATION",
"TWARIT TECHNOLOGIES & INNOVATIONS PRIVATE LIMITED",
"TWASHTRE AUTOMOTIVE PVT LTD.",
"TWBS SOFTWARE DEVELOPMENT CENTER PRIVATE LIMITED",
"TWC LOGISTICS PRIVATE LIMITED",
"TWD SUN ACOUSTIC PRIVATE LIMITED",
"TWEAKING TECHNOLOGIES PRIVATE LIMITED",
"TWEAVERS HR CONSULTANCY PRIVATE LIMITED",
"TWEET INDIA PHARMACEUTICALS PRIVATE LIMITED",
"TWEEZERMAN INDIA PRIVATE LIMITED",
"TWELFTH TIER PROPERTY LIMITED",
"TWENTY FIRST CENTURY CREATIONS PRIVATE LIMITED",
"TWENTY FIRST CENTURY ERECTORS PVT LTD",
"TWENTY FIRST CENTURY MARKETING LIMITED",
"TWENTY FIRST CENTURY MEDIA PRIVATE LIMITED",
"TWENTY FIRST CENTURY MEDICAL PRIVATE LIMITED",
"TWENTY FIRST CENTURY MILLS PRIVATE LIMITED",
"TWENTY FIRST CENTURY PHARMACEUTICALS PRIVATE LIMITED",
"TWENTY FIRST CENTURY SECURITIES LTD.",
"TWENTY FIRST CENTURY TECHNOPRODUCTS PVT LTD",
"TWENTY FIRST CENTURY TEXTILES PRIVATE LIMITED",
"TWENTY FIVE SOUTH REALTY LIMITED",
"TWENTY FOUR GUARDING PRIVATE LIMITED",
"TWENTY FOUR STREET GARMENTS PRIVATE LIMITED",
"TWENTY FOUR SYSTEMS PRIVATE LIMITED",
"TWENTY TWENTY INTERIOR DESIGN SOFTWARE INDIA PRIVATE LIMITED",
"TWENTY TWO BY 7 SOLUTIONS PRIVATE LIMITED",
"TWENTY TWO CAMAC STREET SERVICES PRIVATE LIMITED",
"TWENTYFIRST CENTURY PHARMACEUTICALS PRIVATE LIMITED",
"TWENTYFIRST CENTURY SHARES AND SECURITIES LIMITED",
"TWENTYONE SUGARS LIMITED",
"TWENTYSECOND CENTURY BAZAAR PRIVATE LIMITED",
"TWF SHORING INDIA LLP",
"TWF STUDIOS PRIVATE LIMITED",
"TWF TECHNOLOGIES PRIVATE LIMITED",
"TWHOUSE SOURCING PRIVATE LIMITED",
"TWI INDIA PRIVATE LIMITED",
"TWICE DIGITALE PRIVATE LIMITED",
"TWIG LABS PRIVATE LIMITED",
"TWIGS SERVICES PRIVATE LIMITED",
"TWIGZ TECHNOLOGIES PRIVATE LIMITED",
"TWILIGHT ENTERTAINMENT PRIVATE LIMITED",
"TWILIGHT IT SOLUTIONS PRIVATE LIMITED",
"TWILIGHT JEWELLERY PRIVATE LIMITED",
"TWILIGHT MARKETING PRIVATE LIMITED",
"TWILIGHT SHIPPING PRIVATE LIMITED",
"TWILIGHT SOFTWARE SOLUTIONS PRIVATE LIMITED",
"TWILLS CLOTHING PRIVATE LIMITED",
"TWIMBIT RESEARCH INDIA PRIVATE LIMITED",
"TWIN CITY FAN INDIA PRIVATE LIMITED",
"TWIN COOLING SOLUTIONS PRIVATE LIMITED",
"TWIN DISC FAR EAST PTE LIMITED",
"TWIN DISC POWER TRANSMISSION PRIVATE LIMITED",
"TWIN EARTH SECURITIES PRIVATE LIMITED",
"TWIN ENERGY SOLUTIONS PRIVATE LIMITED",
"TWIN ENGINEERS PRIVATE LIMITED",
"TWIN INFO SOLUTIONS PRIVATE LIMITED",
"TWIN MULTIFLORA PRIVATE LIMITED",
"TWIN SEAL TECH PRIVATE LIMITED",
"TWIN STAR ENGINEERING PRIVATE LIMITED",
"TWIN TECH (INDIA) PRIVATE LIMITED",
"TWIN TORQUE (INDIA) PRIVATE LIMITED",
"TWIN WHEELS AND COMPONENTS PRIVATE LIMITED",
"TWINARCUS INFOLAB PRIVATE LIMITED",
"TWINCITIES MINERAL WATERS PRIVATE LIMITED",
"TWINCITY CASTINGS PRIVATE LIMITED",
"TWINCITY GLASS PRIVATE LIMITED",
"TWINCITY HOLIDAY HOMES PRIVATE LIMITED",
"TWINCITY HOUSING DEVELOPERS PRIVATE LIMITED",
"TWINCITY INFRACON PRIVATE LIMITED",
"TWINCITY SUNLIFE PRIVATE. LIMITED",
"TWINDERJIT MINING & CONSTRUCTION LIMITED",
"TWININGS PRIVATE LIMITED.",
"TWINKLE AGRO FOOD PRODUCTS & COLD STORAGE PRIVATE LIMITED",
"TWINKLE CHEMI LAB PRIVATE LIMITED",
"TWINKLE COMMOTRADE PRIVATE LIMITED",
"TWINKLE CREATIONS PRIVATE LIMITED",
"TWINKLE DIAMOND EXPORTS PRIVATE LIMITED",
"TWINKLE DIAMOND JEWELLERY INDIA PRIVATE LIMITED",
"TWINKLE FASHIONS",
"TWINKLE INDUSTRIES PRIVATE LIMITED",
"TWINKLE LUMINAIRES PRIVATE LIMITED",
"TWINKLE PAPERS LIMITED",
"TWINKLE PAPERS PRIVATE LIMITED",
"TWINKLE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"TWINKLE TRADECOM PRIVATE LIMITED",
"TWINKLING STAR ELECTRICALS INDIA PRIVATE LIMITED",
"TWINS IDEAS AND INNOVATIONS PRIVATE LIMITED",
"TWINSUN INNOVATORS PRIVATE LIMITED",
"TWINTECH CONTROL SYSTEMS PRIVATE LIMITED",
"TWIPPY TECHNOLOGIES PRIVATE LIMITED",
"TWISON DIAM PRIVATE LIMITED",
"TWIST STUDIO ENTERTAINMENT PRIVATE LIMITED",
"TWISTEDPAIR TECHNOLOGIES PRIVATE LIMITED",
"TWISTER CORNER",
"TWISTING SCOOPS PRIVATE LIMITED",
"TWITTER COMMUNICATIONS INDIA PRIVATE LIMITED",
"TWIVI TECHNOLOGY PRIVATE LIMITED",
"TWJ ASSOCIATES PRIVATE LIMITED",
"TWM INDIA PRIVATE LIMITED",
"TWN LOGISTICS PRIVATE LIMITED",
"TWO BROTHERS HOLDING LIMITED",
"TWO DAUGHTERS HOSPITALITY PRIVATE LIMITED",
"TWO GUYS PRIVATE LIMITED",
"TWO HMP COMMUNICATIONS PRIVATE LIMITED",
"TWO MINDS TECHNOLOGY PRIVATE LIMITED",
"TWO MOUSTACHES INDIA PRIVATE LIMITED",
"TWO NICE MEN MEDIAWORKS PRIVATE LIMITED",
"TWO ROADS TRADING PRIVATE LIMITED",
"TWO55AM STUDIO PRIVATE LIMITED",
"TWO95 INT'L STAFFING SERVICES PRIVATE LIMITED",
"TWOBROS & CO",
"TWODOTS SOFTWARE SERVICES (OPC) PRIVATE LIMITED",
"TWO-M OPHTHOTRONICS PRIVATE LIMITED",
"TWOPIR CONSULTING PRIVATE LIMITED",
"TWOPIRADIAN INFOTECH PRIVATE LIMITED",
"T-WORKS FOUNDATION",
"TWOX INFOTECH PRIVATE LIMITED",
"TWS SYSTEMS PRIVATE LIMITED",
"TWT TEXTILES PRIVATE LIMITED",
"TWU TRAVEL WITH US PRIVATE LIMITED",
"TX HOSPITALS",
"TXD (INDIA) TECHNOLOGY PRIVATE LIMITED",
"TXHUB INDIA PRIVATE LIMITED",
"TYA BUSINESS SOLUTIONS PRIVATE LIMITED",
"TYABJI ESTATE PRIVATE LIMITED",
"TYAG READYMIX PRIVATE LIMITED",
"TYAGI & SONS PRIVATE LIMITED",
"TYAGI ANAND MALL MANAGEMENT COMPANY PRIVATE LIMITED",
"TYAGI ENTERPRISES PRIVATE LIMITED",
"TYAGI FOREX PRIVATE LIMITED",
"TYAGI NURSING HOME PRIVATE LIMITED",
"TYBROS RESORTS PRIVATE LIMITED",
"TYCHE AUTOMOTIVE INDIA PRIVATE LIMITED",
"TYCHE CAST TECH PRIVATE LIMITED",
"TYCHE DIECAST PRIVATE LIMITED",
"TYCHE HOME FURNISHINGS PRIVATE LIMITED",
"TYCHE INDUSTRIES LIMITED",
"TYCHE PAYMENT SOLUTIONS PRIVATE LIMITED",
"TYCHE WELLNESS PRIVATE LIMITED",
"TYCHO TECHNOLOGIES PRIVATE LIMITED",
"TYCHON SOLUTIONS PRIVATE LIMITED",
"TYCHOS THERAPEUTICS PRIVATE LIMITED",
"TYCO (INDIA)PVT LTD",
"TYCO FIRE AND SECURITY INDIA PRIVATE LIMITED TR FRM MAH",
"TYCO HOSPITALS PRIVATE LIMITED",
"TYCO SAFETY PRODUCTS INDIA PRIVATE LIMITED",
"TYCON AUTOMATION PRIVATE LIMITED",
"TYCON CABLES INDIA PRIVATE LIMITED",
"TYCON ELEVATORS PRIVATE LIMITED",
"TYCOON EVENTS AND PROMOTIONS PRIVATE LIMITED",
"TYCOON SUPPLIERS PRIVATE LIMITED",
"TYCOONS INDUSTRIES PRIVATE LIMITED",
"TYFONE COMMUNICATIONS DEVELOPMENT INDIA PRIVATE LIMITED",
"TYFORD TEA LIMITED",
"TYG FOODS PRIVATE LIMITED",
"TYK POLYMERS PRIVATE LIMITED",
"TYLER PAYMENT TECHNOLOGIES PRIVATE LIMITED",
"TYLT TECHNOLOGIES PRIVATE LIMITED",
"TYM LOGISTICS SERVICES PRIVATE LIMITED",
"TYMK HEALTH & WELLNESS PRIVATE LIMITED",
"TYMON HEALTHCARE PRIVATE LIMITED",
"TYMTIX TECHNOLOGIES PRIVATE LIMITED",
"TYNDAL LABS PRIVATE LIMITED",
"TYNOR ORTHOTICS PRIVATE LIMITED",
"TYP RUBBER BELTINGS (INDIA) PRIVATE LIMITED",
"TYPSA INDIA PRIVATE LIMITED",
"TYRE GRIP PRIVATE LIMITED",
"TYRE SHOPPE INDIA PRIVATE LIMITED",
"TYRE TECHNOCRATS (INDIA) PRIVATE LIMITED",
"TYRE TECHNOCRATS INDIA PRIVATE LIMITED",
"TYREPLEX TECHNOLOGIES AND COMMERCE PRIVATE LIMITED",
"TYRESNMORE ONLINE PRIVATE LIMITED",
"TYRESOLES INDIA PRIVATE LIMITED",
"TYRESOLES RETREADING GUJARAT PRIVATE LIMITED",
"TYRO AQUA-TECH PRIVATE LIMITED",
"TYROD CLOTHING PRIVATE LIMITED",
"TYROLIT INDIA SUPERABRASIVE TOOLS PRIVATE LIMITED",
"TYRON AGENCY PRIVATE LIMITED",
"TYRONE AGRO CHEMICALS PRIVATE LIMITED",
"TYRONE STORES PRIVATE LIMITED",
"TYROON TEA CO LTD",
"TYRUS TECHNOLOGIES PRIVATE LIMITED",
"TYRZRUS PRIVATE LIMITED",
"TYSON ENTERPRISES PRIVATE LIMITED",
"TYSON FOODS INC.",
"TYTO SOFTWARE PRIVATE LIMITED",
"TZAR INDUSTRIES PRIVATE LIMITED",
"TZF LOGISTICS SOLUTIONS PRIVATE LIMITED",
"TZMO INDIA SOUTH PRIVATE LIMITED",
"TZMO INDIA WEST PRIVATE LIMITED",
"U & I CORPORATE CLUB PRIVATE LIMITED",
"U & I INTERIORS PRIVATE LIMITED",
"U & I MANAGGEMENT SERVICES PRIVATE LIMITED",
"U & M OVERSEAS PRIVATE LIMITED",
"U & ME COMMUNICATION INDIA PRIVATE LIMITED",
"U & N ENTERPRISES PRIVATE LIMITED",
"U & V CANCURE PRIVATE LIMITED",
"U & V NEXGEN EXIM PRIVATE LIMITED",
"U AND D SQUARE SOLUTIONS PRIVATE LIMITED",
"U AND I FASHION HOUSE PRIVATE LIMITED",
"U AND I RESOURCES PRIVATE LIMITED",
"U AND I VAULTS LTD",
"U AND R ENGINEERING PRIVATE LIMITED",
"U AND T TRACTOR SPARES PRIVATE LIMITED",
"U B S PUBLISHERS DISTRIBUTORS PVT LTD",
"U B XPRESS SOUTH PRIVATE LIMITED",
"U C C CARE PRIVATE LIMITED",
"U C C INFRASTRUCTURE PRIVATE LIMITED",
"U C C K MATRIC HR SEC SCHOOL",
"U D ARCHITECTS PRIVATE LIMITED",
"U D CAPS LIMITED",
"U D H PUBLISHERS AND DISTRIBUTORS PRIVATE LIMITED",
"U D INFRASTRUCTURES PRIVATE LIMITED",
"U DIGITAL CONTENT PRIVATE LIMITED",
"U F M INDUSTRIES LIMITED",
"U FOODS INDIA PRIVATE LIMITED",
"U G CONSTRUCTIONS PRIVATE LIMITED",
"U GAMES PRIVATE LIMITED",
"U GOENKA SONS PRIVATE LIMITED",
"U K E LOGISTICS PRIVATE LIMITED",
"U K FIN SERVICES LIMITED",
"U K INDUSTRIES PRIVATE LIMITED",
"U K LOGISTICS INDIA PRIVATE LIMITED",
"U K PAINTS (INDIA) PRIVATE LIMITED",
"U K PAPER CONVERTERS PRIVATE LIMITED",
"U K S STRUCTURES PRIVATE LIMITED",
"U K TECHNOINFRA PRIVATE LIMITED",
"U M CABLES LIMITED",
"U N DHUR & SONS PVT LTD",
"U P ACADEMY OF ADMINISTRATION AND MANAGEMENT",
"U P ALP SANKHYAK VITTIYA EVAM VIKAS NIGAM LIMITED",
"U P ALUMS PRIVATE LIMITED",
"U P BHAWAN NEW DELHI",
"U P CO OPERATIVE FEDERATION LTD",
"U P DEVELOPMENT SYSTEMS CORPORATION LIMITED",
"U P HOTELS CLARKS LIMITED",
"U P HOTELS LIMITED",
"U P NATIONAL MANUFACTURERS LIMITED",
"U P PAPER CORPORATION PRIVATE LIMITED",
"U P PLASTICS & PACKAGING PVT LTD",
"U P POLLUTION CONTROL BOARD (GOVT)",
"U P POWER TRANSMISSION CORPORATION LIMITED",
"U P PROJECTS CORPORATION LIMITED",
"U P PT DEEN DAYAL UPADHYAYA PASHU CHIKITSA VIGYAN VISHWAVIDYALAYA",
"U P PURVA SAINIK KALYAN NIGAM LIMITED",
"U P RAJASHI TANDON OPEN UNIVERSITY - AL",
"U P S C UNION PUBLIC SERVICE COMMI",
"U P SADAN",
"U P SAMAJ KALYAN NIRMAN NIGAM LIMITED",
"U P STATE BRIDGE CORPORATION LIMITED",
"U P TELELINKS LIMITED",
"U P TOBACCO PRODUCTS PRIVATE LIMITED",
"U P TRANSFORMERS (INDIA) PRIVATE LIMITED",
"U R AGROFRESH PRIVATE LIMITED",
"U R ENERGY (INDIA) PRIVATE LIMITED",
"U R GROUND ENGINEERING PRIVATE LIMITED",
"U R RAO SATELLITE CENTRE GOVT OF INDIA DEPARTMENT OF SPACE",
"U S ADVERTISING AGENCY PRIVATE LIMITED",
"U S BIOMEDICAL SYSTEMS INDIA PRIVATE LIMITED",
"U S ENGINEERINGS PRIVATE LIMITED",
"U S MANAGEMENT SERVICES PRIVATE LIMITED",
"U S PHARMA INDIA PRIVATE LIMITED",
"U S TECHNOSOFT PRIVATE LIMITED",
"U SOFTWARE SYSTEMS INDIA PRIVATE LIMITED",
"U SQUARE LIFESCIENCE PRIVATE LIMITED",
"U T ELECTRONICS PRIVATE LIMITED",
"U TO SOLUTIONS INDIA PRIVATE LIMITED",
"U U BUNIADI VIDHYALAY AMARBHARTI",
"U V FASHIONS PRIVATE LIMITED",
"U V GRAPHIC TECHNOLOGIES PRIVATE LIMITED",
"U V METALISING (INDIA) PRIVATE LIMITED",
"U VISTURE FINANCIAL SERVICES",
"U WILL PRIVATE LIMITED",
"U Y TRIENVIRO PRIVATE LIMITED",
"U&M TECHNOPLAST PRIVATE LIMITED",
"U. B. RICE MILL PRIVATE LIMITED",
"U. H. ZAVERI LIMITED",
"U. K. AGRI CHEM INDUSTRIES PRIVATE LIMITED",
"U. K. JEWELLERY INDIA PRIVATE LIMITED",
"U. P. PROJECTS CORPORATION LTD",
"U. P. TWIGA FIBERGLASS LIMITED",
"U. S. M. ALLOYS AND CASTINGS PRIVATE LIMITED",
"U. S. METAL PRODUCTS",
"U. S. TRADEPRINT PRIVATE LIMITED",
"U. Y. FINCORP LIMITED",
"U.A. HOUSING PROJECTS PRIVATE LIMITED",
"U.B.COTTON PRIVATE LIMITED",
"U.C CONNECT SERVICES PRIVATE LIMITED",
"U.D. ENTERPRISE PRIVATE LIMITED",
"U.G. ENGINEERING PRIVATE LIMITED",
"U.J.B CLOTH MERCHANTS PRIVATE LIMITED",
"U.J.C. INDIA PRIVATE LIMITED",
"U.K.M INFRA PRIVATE LIMITED",
"U.L.J.K SECURITIES PRIVATE LIMITED",
"U.M. A MANUFACTURING PRIVATE LIMITED",
"U.P AVAS AVAM VIKAS PARISHAD LUCKNOW",
"U.P COUNCIL OF AGRICULTURAL RESEARCH",
"U.P. CERAMICS & POTTERIES PRIVATE LIMITED",
"U.P. CERAMICS AND POTTERIES LIMITED",
"U.P. PUMPS PRIVATE LIMITED",
"U.P. SILK MILLS PRIVATE LIMITED",
"U.P. STOCK AND CAPITAL LIMITED",
"U.S. AGENCIES PVT. LTD.",
"U.S. CLOTHING INDIA PRIVATE LIMITED",
"U.S. DEVELOPERS PRIVATE LIMITED",
"U.S. DIAM PRIVATE LIMITED",
"U.S. KATIYAR INDUSTRIES PVT LTD",
"U.S. LABCO PRIVATE LIMITED",
"U.S. SAI FOREX PRIVATE LIMITED",
"U.S.FOODS LIMITED",
"U.V. RESEARCH PRIVATE LIMITED",
"U.V. RESINS PRIVATE LIMITED",
"U.Y. INDUSTRIES PRIVATE LIMITED (TRF.)",
"U.Y.AVIATION PRIVATE LIMITED",
"U1 RECORDS PRIVATE LIMITED",
"U2OPIA MOBILE PRIVATE LIMITED",
"U3 INFOTECH INDIA PRIVATE LIMITED",
"U3S CHEMSOLUTIONS PRIVATE LIMITED",
"U3S ENGITECH PRIVATE LIMITED",
"U4IC INTERNATIONAL PRIVATE LIMITED",
"UA AGRO SOLUTIONS PRIVATE LIMITED",
"UA BRANDS INTERNATIONAL PRIVATE LIMITED",
"UA DESIGN STUDIO PRIVATE LIMITED",
"UACI SEEDS & BIOTECH PRIVATE LIMITED",
"UAE EXCHANGE CENTRE L.L.C.",
"UAE EXCHANGEANDFINANCE LIMITED",
"UAMS DESIGNS PRIVATE LIMITED",
"UAO FREIGHT LOGISTICS PRIVATE LIMITED",
"UAV WELLNESS PRIVATE LIMITED",
"UAW AUTO PARTS PVT LTD",
"UB ALUMINIUMS PRIVATE LIMITED",
"UB CONSTRUCTIONS PRIVATE LIMITED",
"UB CORPORATE SERVICES PRIVATE LIMITED",
"UB EQUIPMENTS PRIVATE LIMITED",
"UB FOODS PRIVATE LIMITED",
"UB INTERNATIONAL TRADING LIMITED",
"UB ORGANIC INDIA PRIVATE LIMITED",
"UB STAINLESS LIMITED",
"UB VENTURES PRIVATE LIMITED",
"UBA AGROCHEM AND BIOTECHNOLOGIES PRIVATE LIMITED",
"UBBER BUILDCON PRIVATE LIMITED",
"UBBER BUILDTECH PRIVATE LIMITED",
"UBBUNTU LIFE CARE PRIVATE LIMITED",
"UBC CARGO WORLD INDIA PRIVATE LIMITED",
"UBC ENGINEERS PRIVATE LIMITED",
"UBC-ABSOLUTE EDUCATION PRIVATE LIMITED",
"UBE MACHINERY INDIA PRIVATE LIMITED",
"UBEC TECHNOLOGIES INDIA PRIVATE LIMITED",
"UBER FASHION MERCHANDISE PRIVATE LIMITED",
"UBER INDIA RESEARCH AND DEVELOPMENT PRIVATE LIMITED.",
"UBER INDIA SYSTEMS PRIVATE LIMITED",
"UBER IT",
"UBER MINING PRIVATE LIMITED",
"UBER PROJECT LIGHTING PRIVATE LIMITED",
"UBER9 BUSINESS PROCESS SERVICES PRIVATE LIMITED",
"UBERALL SOLUTIONS INDIA LIMITED",
"UBERDREAMS PRIVATE LIMITED",
"UBERGRAD INDIA PRIVATE LIMITED",
"UBERICS CONSULTING PRIVATE LIMITED",
"UBERLIFE CONSULTING PRIVATE LIMITED",
"UBERRY INTERNATIONAL PRIVATE LIMITED",
"UBERTAL INDIA PRIVATE LIMITED",
"UBERTY INFRASTRUCTURES PRIVATE LIMITED",
"UBI SERVICES LIMITED",
"UBICS INDIA PRIVATE LIMITED",
"UBICS TECHNOLOGIES PRIVATE LIMITED",
"UBIK FILM PRIVATE LIMITED",
"UBIK SOLUTIONS PRIVATE LIMITED",
"UBIQARE HEALTH PRIVATE LIMITED",
"UBIQUBE INDIA LLP",
"UBIQUE ALLOYS PRIVATE LIMITED",
"UBIQUE COUNSEL PRIVATE LIMITED",
"UBIQUE PACKAGING SYSTEMS PVT LTD",
"UBIQUE SYSTEMS PRIVATE LIMITED",
"UBIQUITI TECHNICAL SERVICES PRIVATE LIMITED",
"UBIQUITOUS FOODS PRIVATE LIMITED",
"UBIQUITOUS SIGNS PRIVATE LIMITED",
"UBIQUITY TRANSTECH PRIVATE LIMITED",
"UBI'S CANNING PRIVATE LIMITED",
"UBITECH PRIVATE LIMITED",
"UBIX SYSTEMS MARKETING PRIVATE LIMITED",
"U-BLOX SINGAPORE PTE LTD",
"UBM AUTOPOWER PRIVATE LIMITED",
"UBM MEDICA INDIA PRIVATE LIMITED",
"UBM TRAVEL SOLUTIONS INDIA PRIVATE LIMITED",
"UBN QTECH SOLUTIONS INDIA PRIVATE LIMITED",
"UBN SOFTWARE SOLUTIONS PRIVATE LIMITED",
"UBOARD INDIA LIMITED",
"UBONA TECHNOLOGIES PRIVATE LIMITED",
"UBP MEDIA & ENTERTAINMENTS PRIVATE LIMITED",
"UBQ TECHNOLOGIES PRIVATE LIMITED",
"UBR CAPITAL PRIVATE LIMITED",
"UBR REALTY PRIVATE LIMITED",
"UBS BUSINESS SOLUTIONS (INDIA) PRIVATE LIMITED",
"UBS INFRAA PROJECTS PRIVATE LIMITED",
"UBS OPTIMUS FOUNDATION INDIA",
"UBS SECURITIES INDIA PRIVATE LIMITED",
"UBUNTU & ORENDA PRIVATE LIMITED",
"UBUNTU HEALTH SOLUTIONS PRIVATE LIMITED",
"UBUNTU MEDICAL EQUIPMENTS AND LOGISTICS PRIVATE LIMITED",
"UBUY TECHNOLOGIES PRIVATE LIMITED",
"UBV INFRASTRUCTURES LIMITED",
"UBYLD RETAIL PRIVATE LIMITED",
"UC INCLUSIVE CREDIT PRIVATE LIMITED",
"UC IT MANAGED SERVICES PRIVATE LIMITED",
"UC METALS PRIVATE LIMITED",
"UC PIGMENTS (INDIA) PRIVATE LIMITED",
"UC WORLD ONLINE LIMITED",
"UCAL AUTO PRIVATE LIMITED",
"UCAL EXPORTS PRIVATE LIMITED",
"UCAL FUEL SYSTEMS LIMITED",
"UCAL POLYMER INDUSTRIES LIMITED",
"UCAL PRODUCTS PRIVATE LIMITED",
"UCAM PRIVATE LIMITED",
"UCB INDIA PRIVATE LIMITED",
"UCCHVAS HEALTHCARE PRIVATE LIMITED",
"UCERTIFY TRAINING AND LEARNING PRIVATE LIMITED",
"UCF INDUSTRY LLP",
"UCH LOGISTICS (INDIA) PRIVATE LIMITED",
"UCHALLAN S. S. RICE MILL PRIVATE LIMITED",
"UCHICAGO CENTER IN INDIA PRIVATE LIMITED",
"UCHIMURA INDIA PRIVATE LIMITED",
"UCHIT EXPRESSWAYS PRIVATE LIMITED",
"UCHITHA GRAPHIC PRINTERS PRIVATE LIMITED",
"UCHIYAMA INDIA PRIVATE LIMITED",
"UCHS INDIA PRIVATE LIMITED",
"UCI FREIGHT SOLUTIONS PRIVATE LIMITED",
"UCI LOGISTICS SOLUTIONS PRIVATE LIMITED",
"UCID PRIVATE LIMITED",
"UCINFOSYSTEMS PRIVATE LIMITED",
"UCN CABLE NETWORK PRIVATE LIMITED",
"UCN CONSTRUCTION COMPANY PRIVATE LIMITED",
"UCO BANK",
"UCON PT STRUCTURAL SYSTEM PRIVATE LIMITED",
"UCON STRUCTURAL SYSTEMS PRIVATE LIMITED",
"UCOUNT TECHNOLOGIES PRIVATE LIMITED",
"UCREATE IT PRIVATE LIMITED",
"UCRK AGROS PRIVATE LIMITED",
"UCRON (INDIA) PRIVATE LIMITED",
"UCS BUSINESS SOLUTIONS PRIVATE LIMITED",
"UCS CONSTRUCTION PRIVATE LIMITED",
"UCS CONVEYOR SYSTEMS PRIVATE LIMITED",
"UCS CORPORATE SERVICES PRIVATE LIMITED",
"UCS MANUFACTURING CO. PRIVATE LIMITED",
"UCWEB MOBILE PRIVATE LIMITED",
"UD HOSPITALITY PRIVATE LIMITED",
"UD MARKETING PVT LTD",
"UD SOLUTION PRIVATE LIMITED",
"UD TRUCKS INDIA PRIVATE LIMITED",
"UDAAN BUILDCON PRIVATE LIMITED",
"UDAAN CREATIVE SOLUTIONS PRIVATE LIMITED",
"UDAAN HOTELS & RESORTS PRIVATE LIMITED",
"UDAAN PAPER INDUSTRIES PRIVATE LIMITED",
"UDAAN TECHNOLOGIES PRIVATE LIMITED",
"UDAAN VIDHYALAY",
"UDAARAN PROPERTIES AND TRADING PRIVATE LIMITED",
"UDACITY INDIA PRIVATE LIMITED",
"UDAGIRI SUGAR AND POWER LIMITED",
"UDAI AVIATION PRIVATE LIMITED",
"UDAI COLD STORAGE AND ICE PLANT PRIVATE LIMITED",
"UDAI OMNI HOSPITALS PRIVATE LIMITED",
"UDAIKANT MISHRA AND SONS MINES PRIVATE LIMITED",
"UDAIPUR BEVERAGES LIMITED",
"UDAIPUR CEMENT WORKS LIMITED",
"UDAIPUR COTTON MILLS CO LTD",
"UDAIPUR DIVISONAL COMMISSIONER UDAIPUR",
"UDAIPUR GOLDEN TRANSPORT LOGISTIC PRIVATE LIMITED",
"UDAIPUR HEALTH CARE PRIVATE LIMITED",
"UDAIPUR MALL MANAGEMENT PRIVATE LIMITED",
"UDAIPUR MINERAL DEVELOPMENT SYNDICATE PRIVATE LIMITED",
"UDAIPUR POLY SACKS LTD",
"UDAIPUR SURGICALS PRIVATE LIMITED",
"UDAIRAJ INFRA POWER PRIVATE LIMITED",
"UDAISAGAR HOSPITALITY AND RESORTS PRIVATE LIMITED",
"UDAISHWAR PUBLIC SCHOOL",
"UDALGURI BEVERAGES PRIVATE LIMITED",
"UDAMA INDUSTRIES (INDIA) PRIVATE LIMITED",
"UDAN MEDIA AND COMMUNICATIONS PRIVATE LIMITED",
"UDAN RECREATION SERVICES PRIVATE LIMITED",
"UDAR OVERSEAS PRIVATE LIMITED",
"UDASEE STAMPINGS PRIVATE LIMITED",
"UDAY AUTOLINK PRIVATE LIMITED",
"UDAY AUTOSALES PRIVATE LIMITED",
"UDAY CHAND TANSUKH RAI PRIVATE LIMITED",
"UDAY COLOUR AND CHEMICALS PVT LTD",
"UDAY EXPORTS PRIVATE LIMITED",
"UDAY FASHION",
"UDAY FINVEST PVT LTD",
"UDAY JEWELLERY INDUSTRIES LIMITED",
"UDAY KRISHNA HEALTH CARE PRIVATE LIMITED",
"UDAY MANAGEMENT SERVICES PRIVATE LIMITED",
"UDAY MEDISALES PRIVATE LIMITED",
"UDAY MICRONS PRIVATE LIMITED",
"UDAY PU SCIENCE COLLEGE",
"UDAY RESHELLERS & CAST ALLOYS LLP",
"UDAY RESIDENCY PRIVATE LIMITED",
"UDAY SHOES PRIVATE LIMITED",
"UDAY SPONGE AND POWER PRIVATE LIMITED",
"UDAY STORES PRIVATE LIMITED",
"UDAY STRUCTURALS AND ENGINEERS PRIVATE LIMITED",
"UDAY TOURS AND TRAVELS PRIVATE LIMITED",
"UDAY TRAVELS",
"UDAY UDYOG ELECTRONICS PRIVATE LIMITED",
"UDAYA B G SECURITIES PRIVATE LIMITED",
"UDAYA EDUCATION SOCIETY",
"UDAYA FM PRIVATE LIMITED",
"UDAYA INDUSTRIAL BUILDERS PRIVATE LIMITED",
"UDAYA MOTORS",
"UDAYA SHETTY",
"UDAYACHAL LEASING & EXPORTS PRIVATE LIMITED",
"UDAYAK AGRO PRODUCTS PRIVATE LIMITED",
"UDAYAM ENGINEERS & BUILDERS PRIVATE LIMITED",
"UDAYAM MEDICAL CENTRE (TRICHY) PRIVATE LIMITED",
"UDAYAN CHAUDHARI AND ASSOCIATES PRIVATE LIMITED",
"UDAYAN EDUCATION PRIVATE LIMITED",
"UDAYAN GREENFIELDS PRIVATE LIMITED",
"UDAYATEL COMMUNICATIONS PRIVATE LIMITED",
"UDAYEE INTERNATIONAL HOTELS PRIVATE LIMITED",
"UDAYGIRI MULTISPECIALITY HOSPITAL PRIVATE LIMITED",
"UDAYMAAN INFRASTRUCTURES PRIVATE LIMITED",
"UDAYRAJ PALACE PRIVATE LIMITED",
"UDAYSEEM INFRATECH PRIVATE LIMITED",
"UDAYSHIVAKUMAR INFRA LIMITED",
"UDBHAV CERAMICS PRIVATE LIMITED",
"UDBHAV INFRASTRUCTURE PRIVATE LIMITED",
"UDBHAV INFRA-TECH PRIVATE LIMITED",
"UDC INDIA TECHNOLOGIES PRIVATE LIMITED",
"UDC SATELLITE LABORATORY PRIVATE LIMITED",
"UDDHAV REALTECH PRIVATE LIMITED",
"UDDHAVA LOGISTICS PRIVATE LIMITED",
"UD-DKOR INTERIO INDIA PRIVATE LIMITED",
"UDDYAM CEMENT PRIVATE LIMITED",
"UDEHRA FASTNERS LIMITED",
"UDEY PYROCABLES PRIVATE LIMITED",
"UDGAM COMMERCIAL LTD",
"UDGAM EDUCATION INSTITUTE PRIVATE LIMITED",
"UDGAM INDUSTRIES PRIVATE LIMITED",
"UDGAM LOGISTICS PRIVATE LIMITED",
"UDGAM SCHOOL FOR CHILDREN",
"UDGEETH NIRMAN PRIVATE LIMITED",
"UDGHATA TECHNOLOGY PRIVATE LIMITED",
"UDHAN HOSPITALITY PRIVATE LIMITED",
"UDHAV HOLDINGS PRIVATE LIMITED",
"UDHAV SALES & MARKETING PRIVATE LIMITED",
"UDHAYA FOUNDRIES INDIA PRIVATE LIMITED",
"UDHAYASRI PLASTICS PRIVATE LIMITED",
"UDHAY-VJ REALTY PRIVATE LIMITED",
"UDHNA CITIZEN COMMERCE COLLEGE & S P B COLLEGE OF BUSINESS ADMINISTRATION & SMT DIWALIBEN HARJIBHA GAONDALIA COLLEGE OF BCA & I T",
"UDHYAM LEARNING FOUNDATION",
"UDHYAMAN INVESTMENTS PRIVATE LIMITED",
"UDI FOODS AND BEVERAGES (INDIA) PRIVATE LIMITED",
"UDI PHARMA PRIVATE LIMITED",
"UDI SALES PRIVATE LIMITED",
"U-DIGITAL NETWORK PRIVATE LIMITED",
"UDIPI RESIDENCY HOTELS PRIVATE LIMITED",
"UDIPTA ENERGY & EQUIPMENT PRIVATE LIMITED",
"UDIT BAIHAR LAMTA PRIVATE LIMITED",
"UDIT BETUL PARATWARA PATHWAYS PRIVATE LIMITED",
"UDIT DINARA DATIA TOLLWAYS PRIVATE LIMITED",
"UDIT FRESH FOODS PRIVATE LIMITED",
"UDIT INFRAWORLD PRIVATE LIMITED",
"UDIT INFRAWORLD PRIVATE. LIMITED.",
"UDIT KHAMLA HIGHWAYS PRIVATE LIMITED",
"UDIT PACKAGING PRIVATE LIMITED",
"UDIT PATHWAYS PRIVATE LIMITED",
"UDITI BUILDWEL PRIVATE LIMITED",
"UDM GLOBAL SOLUTION PRIVATE LIMITED",
"UDNAV SOFTWARE SERVICES PRIVATE LIMITED",
"UDOJI HORIZON SCHOOL",
"UDRA CONSTRUCTION PRIVATE LIMITED",
"UDREAM TECHNOLAB PRIVATE LIMITED",
"UDS HOSPITALITY PRIVATE LIMITED",
"UDUPI COCHIN SHIPYARD LIMITED",
"UDUPI KASARGODE TRANSMISSION LIMITED",
"UDUPI POWER CORPORATION LIMITED",
"UDVR INDUSTRIES PRIVATE LIMITED",
"UDY HEALTHCARE PRIVATE LIMITED",
"UDYAM IMPEX INDIA PRIVATE LIMITED",
"UDYAM PRAKASHAN PRIVATE LIMITED",
"UDYAMI VIKAS PRIVATE LIMITED",
"UDYAMI VIKAS SANSTHAN",
"UDYAN HERBOMATRIX PRIVATE LIMITED",
"UDYANCHAL MEGA CONSTRUCTIONS PRIVATE LIMITED",
"UDYOG SERVICES LIMITED",
"UDYOG SOFTWARE (INDIA) LIMITED",
"UDYOGI AGRITECH PRIVATE LIMITED",
"UDYOGI INTERNATIONAL PRIVATE LIMITED",
"UDYOGI PLASTICS PRIVATE LIMITED",
"UDYOGI SAFETY APPLIANCES PRIVATE LIMITED",
"UDYOGIKA PRIVATE LIMITED",
"UDYOGINI",
"UE ALLOYS PRIVATE LIMITED",
"UE AUTOTECH (I) PRIVATE LIMITED",
"UE DEVELOPMENT INDIA PRIVATE LIMITED",
"UE LIFESCIENCES (INDIA) PRIVATE LIMITED",
"UE PRESS TOOLS PRIVATE LIMITED",
"UE SYSTEMS IMENA PRIVATE LIMITED",
"UEC TECHNOLOGIES PRIVATE LIMITED",
"UEE ELECTRICAL ENGINEERS PRIVATE LIMITED",
"UEGS SHIKARIKHEDA",
"UEI GLOBAL EDUCATION PRIVATE LIMITED",
"UEM INDIA PRIVATE LIMITED",
"UEM PISTONS PRIVATE LIMITED",
"UENGAGE SERVICES PRIVATE LIMITED",
"UES EXPRESS PRIVATE LIMITED",
"UF CEILINGS (INDIA) PRIVATE LIMITED",
"UFABER EDUTECH PRIVATE LIMITED",
"UFFIZIO INDIA SOFTWARE CONS PRIVATE LIMITED",
"UFI FILTERS INDIA PRIVATE LIMITED.",
"UFI INNOVATION CENTER INDIA PRIVATE LIMITED",
"UFIL PRIVATE LIMITED",
"UFIRM TECHNOLOGIES PRIVATE LIMITED",
"UFIRST HEALTHCARE PRIVATE LIMITED",
"UFLEX LIMITED",
"UFLIX INTERNATIONAL PRIVATE LIMITED",
"UFLOW AUTOMATION",
"UFO MOVIEZ INDIA LIMITED",
"UFONY SERVICES PRIVATE LIMITED",
"UFS DIGITAL LIMITED",
"UFS EXPRESS INDIA PRIVATE LIMITED",
"UFS PROTECTS INDIA PRIVATE LIMITED",
"UFT RICE MILLS PRIVATE LIMITED",
"UFTULTRA FACILITY MANAGEMENT PRIVATE LIMITED",
"UG LIFE STYLE PRIVATE LIMITED",
"UG SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"UGAC STEELS PRIVATE LIMITED",
"UGAM AGRO AND DAIRY PRODUCTS PRIVATE LIMITED",
"UGAM SOLUTIONS PRIVATE LIMITED",
"UGAM SOLUTIONS SEZ PRIVATE LIMITED",
"UGAOO AGRITECH PRIVATE LIMITED",
"UGC DAE CONSORTIUM FOR SCIENTIFIC RESEARCH",
"UGC SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED",
"UGEMUGE HOTELS AND AMUSEMENT PRIVATE LIMITED",
"UGES POWERMAX PRIVATE LIMITED",
"UGI ENGINEERING WORKS PRIVATE LIMITED",
"UGL ENGINEERING PRIVATE LIMITED",
"UGO LOGISTICS PRIVATE LIMITED",
"UGRAYA FOODS & FEEDS PRIVATE LIMITED",
"UGRI POLYPLAST PVT LTD",
"UGRO CAPITAL LIMITED",
"UGS ENTERPRISES PRIVATE LIMITED",
"UGS FACILITY MANAGEMENT PRIVATE LIMITED",
"UGS PUBLICATIONS PRIVATE LIMITED",
"UGS TRANSMEN PRIVATE LIMITED",
"UGVS",
"UH REALCON PRIVATE LIMITED",
"UHA INDIA PRIVATE LIMITED",
"UHBVN",
"UHK MANPOWER SERVICES PRIVATE LIMITED",
"UHM VACATION PRIVATE LIMITED",
"UHP TECHNOLOGIES PRIVATE LIMITED",
"UHPC INDIA PRIVATE LIMITED",
"UI FABRICATORS PRIVATE LIMITED",
"UI FOREX AND HOLIDAY PRIVATE LIMITED",
"UI HEALING LLP",
"UI PIPE FITTINGS PRIVATE LIMITED",
"UI SOLUTIONS INDIA PRIVATE LIMITED",
"UI VR PRIVATE LIMITED",
"UIB INSURANCE BROKERS INDIA PRIVATE LIMITED",
"UIL ELECTRONICS INDIA PRIVATE LIMITED",
"UINCEPT GLOBAL PRIVATE LIMITED",
"UINFINITY TECHNOLOGY PRIVATE LIMITED",
"UIPEP TECHNOLOGIES PRIVATE LIMITED",
"UIPL INNOVATIONS PRIVATE LIMITED",
"UIREVOLUTION INDIA PRIVATE LIMITED",
"UIS GLOBAL PRIVATE LIMITED",
"UJAGAR ESTATES LIMITED",
"UJALA AQUATECH INDIA PRIVATE LIMITED",
"UJALA COMMUNICATION PRIVATE LIMITED",
"UJALA CREDIT CO-OPERATIVE SOCIETY LIMITED",
"UJALA CYGNUS CENTRAL HOSPITAL",
"UJALA CYGNUS HOSPITALS",
"UJALA CYGNUS SH MUTISPECIALITY HOSPITAL",
"UJALA DYEING &PRINTING MILLS P. LIMITED",
"UJALA FABRICATORS PRIVATE LIMITED",
"UJALA FASHIONS PRIVATE LIMITED",
"UJALA HEALTHCARE SERVICES LIMITED",
"UJALA MERCHANTS AND TRADERS LIMITED",
"UJALA STAINLESS PRIVATE LIMITED",
"UJALA TRADING COMPANY",
"UJALAA MILK PRODUCER COMPANY LIMITED",
"UJALADEEP TEXTILES (SOUTH INDIA) PRIVATE LIMITED",
"UJANI JALVIDHYUT VIBHAG",
"UJAS DIAMONDS PRIVATE LIMITED",
"UJAS EXPORTS PRIVATE LIMITED",
"UJJAIN DEVELOPMENT AUTHORITY",
"UJJAIN DIESEL PVT LTD",
"UJJAIN ENGICON INDIA PRIVATE. LIMITED.",
"UJJAIN ENGINEERING COLLEGE",
"UJJAIN ICE AND COLD STORAGE PVT LTD",
"UJJAIN PACKAGING PRIVATE LIMITED",
"UJJAIN SMART CITY LIMITED",
"UJJAINI MOTORS PRIVATE LIMITED",
"UJJAINIMATA MADHYAMIK VIDYALAYA PIMPALGAON UJJAINI AHMEDNAGAR",
"UJJAWAL BIOTECH AND ORGANICS PRIVATE LIMITED",
"UJJAWAL MANAGEMENT SERVICES PRIVATE LIMITED",
"UJJAWAL MARBLES PVT.LTD",
"UJJAWAL OVERSEAS (INDIA) PRIVATE LIMITED",
"UJJAWAL PROTEINS PRIVATE. LIMITED.",
"UJJAWAL SAVERA SAMITI MEERUT",
"UJJAWAL SEEDS PRIVATE LIMITED",
"UJJAWAL TRADEX PRIVATE LIMITED",
"UJJAWALA HOUSING AND FINANCE PRIVATE. LIMITED.",
"UJJAWALA POWER PRIVATE LIMITED UPPL",
"UJJAYINI HIGHWAYS PRIVATE LIMITED",
"UJJI VAN SMALL FINANCE BANK",
"UJJIBAN DIAGONOSTIC PRIVATE LIMITED",
"UJJIVAN FINANCIAL SERVICES LIMITED",
"UJJIVAN FINANCIAL SERVICES PRIVATE LIMITED",
"UJJIVAN SMALL FINANCE BANK LIMITED",
"UJJVALATEJAS SOLAIRE URJA PRIVATE LIMITED",
"UJJWAL AUTOWHEELS PRIVATE LIMITED",
"UJJWAL BARTER PRIVATE LIMITED",
"UJJWAL BHARAT LLP",
"UJJWAL BISCUITS PRIVATE LIMITED",
"UJJWAL CONTRACTS PRIVATE LIMITED",
"UJJWAL GRANITES PRIVATE LIMITED",
"UJJWAL HR SOLUTIONS PRIVATE LIMITED",
"UJJWAL INFRACON LIMITED",
"UJJWAL INFRATECH (INDIA) PRIVATE LIMITED",
"UJJWAL ISPAT PRIVATE LIMITED",
"UJJWAL LUXURY HOTELS PRIVATE LIMITED",
"UJJWAL MINERAL AND STEELS PRIVATE LIMITED",
"UJJWAL MOULDINGS LIMITED",
"UJJWAL PACKERS AND DISTRIBUTORS PRIVATE LIMITED",
"UJJWAL POLY PACK (INDIA) PRIVATE LIMITED",
"UJJWAL PUNE LIMITED",
"UJJWAL TOOLS AND COMPONENTS PRIVATE LIMITED",
"UJJWAL TRADING PVT LTD",
"UJJWALAM IMPEX PRIVATE LIMITED",
"UJNA MILK PRODUCTS PRIVATE LIMITED",
"UJWAL AUTOMOTIVES PRIVATE LIMITED",
"UJWAL BOOKS AND STATIONERY PRIVATE LIMITED",
"UJWAL ENTERPRISES (INDIA) PRIVATE LIMITED",
"UJWAL PHARMA PVT LTD",
"UJWAL PLASTICS INDUSTRIES PRIVATE LIMITED",
"UJWALA AUTOMATION AND ENGINEERING SERVICES PRIVATE LIMITED",
"UJWALA DEVELOPERS PRIVATE LIMITED",
"UJWALA INFRATECH (INDIA) PRIVATE LIMITED",
"UJWALYOG INDIA OPC PRIVATE LIMITED",
"UK CROP SCIENCES PRIVATE LIMITED",
"UK FACILITY SERVICE PRIVATE LIMITED",
"UK FREIGHT SERVICES PRIVATE LIMITED",
"UK INDIA BUSINESS COUNCIL INDIA PRIVATE LIMITED",
"UK INTERIA PRIVATE LIMITED",
"UK LOGISTICS INDIA PRIVATE LIMITED",
"UK MARKETING PRIVATE LIMITED",
"UKA TARSADIA UNIVERSITY",
"UKANDIN INTERNATIONAL PRIVATE LIMITED",
"UKAR HEALTHCARE PRIVATE LIMITED",
"UKAY LUGGAGE INDIA PRIVATE LIMITED",
"UKAY METAL INDUSTRIES PRIVATE LIMITED",
"UKAY REMEDYS PRIVATE LIMITED",
"UKB IT SOLUTIONS PRIVATE LIMITED",
"UKC FOODS PRIVATE LIMITED",
"UKE EXPORT PRIVATE LIMITED",
"UKEAS EDUCATION CONSULTING PRIVATE LIMITED",
"UKHI INDIA PRIVATE LIMITED",
"UKHRA K B INSTITUTION",
"UKKO GOOD LIFE PRIVATE LIMITED",
"UKL INSTRUMENTS PRIVATE LIMITED",
"UKN PROJECTS PRIVATE LIMITED",
"UKN PROPERTIES PRIVATE LIMITED",
"UKS COLD STORAGE PRIVATE LIMITED",
"UKS FOREX PRIVATE LIMITED",
"UKS GLOBAL LOGISTICS PRIVATE LIMITED",
"UKS GLOBAL PEST MANAGEMENT SOLUTIONS (INDIA) PRIVATE LIMITED",
"UK'S RESORT PRIVATE LIMITED",
"UKSAS AMBULANCE PRIVATE LIMITED",
"UKTECHNO FOODS AND BEVERAGES PRIVATE LIMITED",
"UKV ENTERPRISES LLP",
"UL ELECTRODEVICES PRIVATE LIMITED",
"UL ENGINEERING SERVICES AND SOFTWARE PRIVATE LIMITED",
"UL INDIA PRIVATE LIMITED",
"UL QUALITY ASSURANCE PRIVATE LIMITED",
"UL TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"ULABS PRIVATE LIMITED",
"ULAUTOMATION SYSTEMS PRIVATE LIMITED",
"ULCCS CALICUT CITY INFRASTRUCTURE DEVELOPMENT PRIVATE LIMITED",
"ULCCS IT INFRASTRUCTURE PRIVATE LIMITED",
"ULDAN AGRICULTURE PRODUCER COMPANY LIMITED",
"ULEKTZ LEARNING SOLUTIONS PRIVATE LIMITED",
"ULFCAR CHEMICALS PRIVATE LIMITED",
"ULHAS JEWELLERS PRIVATE LIMITED",
"ULHAS OIL AND CHEMICAL INDUSTRIES PRIVATE LIMITED",
"ULHASNAGAR MUNICIPAL CORPORATION",
"ULIS TECHNOLOGY PRIVATE LIMITED",
"ULISES CONSULTANCY SERVICES PRIVATE LIMITED",
"ULIV INTERNATIONAL PRIVATE LIMITED",
"ULIXO TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"ULJK ANALYTICS PRIVATE LIMITED",
"ULJK FINANCIAL SERVICES PRIVATE LIMITED",
"ULKA INDUSTRIES PRIVATE LIMITED",
"ULKA INFRAA PRIVATE LIMITED",
"ULKA INSTRUMENTS AND CONTROLS PRIVATE LIMITED",
"ULKA PROJECTS PRIVATE LIMITED",
"ULKA SEA FOODS PRIVATE LIMITED",
"ULKAS FERTICHEM PRIVATE LIMITED",
"ULLAHAS NANDINI UDYOG PRIVATE LIMITED",
"ULLENGAL BROTHERS TEXTILE PRIVATE LIMITED",
"ULLMANN LABORATORIES PRIVATE LIMITED",
"ULLU DIGITAL LIMITED",
"ULLU DIGITAL PRIVATE LIMITED",
"ULMA FORMWORK SYSTEMS INDIA PRIVATE LIMITED",
"ULOG INDIA BUSINESS SOLUTIONS PRIVATE LIMITED",
"UL-SYSTEMS AND CONTROLS (INDIA) PRIVATE LIMITED",
"ULT SUPPORT SERVICES INDIA PRIVATE LIMITED",
"ULTEAM COMPUTERS & TECHNOLOGIES",
"ULTIMA FINVEST LIMITED",
"ULTIMA INFOTECH PRIVATE LIMITED",
"ULTIMA MATERIAL HANDLING SOLUTIONS PRIVATE LIMITED",
"ULTIMA SWITCHGEARS LIMITED",
"ULTIMATE ALLOYS PRIVATE LIMITED",
"ULTIMATE APPARELS PRIVATE LIMITED",
"ULTIMATE AUTOMOBILES PRIVATE. LIMITED",
"ULTIMATE CHEM INDIA PRIVATE. LIMITED.",
"ULTIMATE COMPUTECH PRIVATE LIMITED",
"ULTIMATE DIGITAL SOLUTIONS PRIVATE LIMITED",
"ULTIMATE ENERGY RESOURCE PRIVATE LIMITED",
"ULTIMATE E-SOLUTIONS PRIVATE LIMITED",
"ULTIMATE FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"ULTIMATE FASHION MAKER LIMITED",
"ULTIMATE FITNESS TEMPLE LLP",
"ULTIMATE FLEXIPACK LIMITED",
"ULTIMATE FOILS AND PAPER PRIVATE LIMITED",
"ULTIMATE FURNITURE PRIVATE LIMITED",
"ULTIMATE GOLF PRIVATE LIMITED",
"ULTIMATE INDUSTRIES LIMITED",
"ULTIMATE INFOSEC TECHNOLOGY PRIVATE LIMITED",
"ULTIMATE INFOTECH PRIVATE LIMITED",
"ULTIMATE INTERNATIONAL PRIVATE LIMITED",
"ULTIMATE INVESTOFIN LIMITED",
"ULTIMATE MARINE PRIVATE LIMITED",
"ULTIMATE PERFORMANCE INDIA PRIVATE LIMITED",
"ULTIMATE PEST MANAGEMENT PRIVATE LIMITED",
"ULTIMATE SHIPPING PRIVATE LIMITED",
"ULTIMATE SOLUTIONS MEDICARE PRIVATE LIMITED",
"ULTIMATE SUN SYSTEMS PRIVATE LIMITED",
"ULTIMATE TELECOM ENNG. SOLUTION PVT LTD.",
"ULTIMATE VENTURES SECURITY SYSTEM PRIVATE LIMITED",
"ULTIMATE VIDEOTRONICS (INDIA) LTD",
"ULTIMATE WEALTH PRIVATE LIMITED",
"ULTIMATEMILE INDIA PRIVATE LIMITED",
"ULTIMATUM INFORMATICS PRIVATE LIMITED",
"ULTIMAX CORPORATE SERVICES PRIVATE LIMITED",
"ULTIMAX GOODS PRIVATE LIMITED",
"ULTIMAX MANPOWER SOLUTIONS PRIVATE LIMITED",
"ULTIMO CEMENT INDIA PRIVATE LIMITED",
"ULTIMO CREDIT PVT LTD.",
"ULTINITY MINERALS PRIVATE LIMITED",
"ULTIOR TIMATE PERFORMANCE",
"ULTIS TECHNOLOGIES PRIVATE LIMITED",
"ULTIVIC PRIVATE LIMITED",
"ULTRA ALLUMINIUM PRIVATE LIMITED",
"ULTRA BEAUTY CARE PRIVATE LIMITED",
"ULTRA BIOLABS PRIVATE LIMITED",
"ULTRA CHIRON PHARMACEUTICALS PRIVATE LIMITED",
"ULTRA CINEMA & NUTECH LIMITED",
"ULTRA CLEAN AND CARE SERVICES PRIVATE LIMITED",
"ULTRA COMMERCIAL REALTY PRIVATE LIMITED",
"ULTRA CONSERVE PRIVATE LIMITED",
"ULTRA CORPOTECH PRIVATE LIMITED",
"ULTRA CRAFT MOLDERS PRIVATE LIMITED",
"ULTRA DENIM PRIVATE LIMITED",
"ULTRA DIGITAL STUDIO PRIVATE LIMITED",
"ULTRA DIMENSIONS PRIVATE LIMITED",
"ULTRA DRUGS FORMULATIONS PRIVATE LIMITED",
"ULTRA DRUGS PRIVATE LIMITED",
"ULTRA DRYTECH ENGINEERING PROJECTS PRIVATE LIMITED",
"ULTRA ELECTRIC COMPANY (INDIA) PRIVATE LIMITED",
"ULTRA ELECTRONICS PVT LTD",
"ULTRA ELEVATORS PRIVATE LIMITED",
"ULTRA ENVIRO-SYSTEMS PRIVATE LIMITED",
"ULTRA FINE CHEM & INST",
"ULTRA FIRETECH SYSTEMS PRIVATE LIMITED",
"ULTRA FLEXIPACK INDIA PRIVATE LIMITED",
"ULTRA GAS & ENERGY LIMITED",
"ULTRA HOMES INDIA PRIVATE LIMITED",
"ULTRA KNIT FINISHERS INDIA PRIVATE LIMITED",
"ULTRA LABORATORIES PRIVATE LIMITED",
"ULTRA MARINE",
"ULTRA MEDIA & ENTERTAINMENT PRIVATE LIMITED",
"ULTRA MEGA POWER PRIVATE LIMITED",
"ULTRA MODERN ELECTRIC & INTERIOR PRIVATE LIMITED",
"ULTRA PACKERS PRIVATE LIMITED",
"ULTRA PEST CONTROL PRIVATE LIMITED",
"ULTRA PLUS CEMENT PRIVATE LIMITED",
"ULTRA POLYDYE PRIVATE LIMITED",
"ULTRA POLYMIN LIMITED",
"ULTRA PORTFOLIO MANAGEMENT PRIVATE LIMITED",
"ULTRA PRECISION TOOLS AND VESSELS PRIVATE LIMITED",
"ULTRA PROMOTERS & DEVELOPERS PRIVATE LIMITED",
"ULTRA PURE GASES (INDIA) PRIVATE LIMITED",
"ULTRA READYMIX CONCRETE PRIVATE LIMITED",
"ULTRA RESORTS AND HOTELS PRIVATE LIMITED",
"ULTRA SPINNERS INDIA PRIVATE LIMITED",
"ULTRA STRONG CEMENT PRIVATE LIMITED",
"ULTRA TECH COAL PRIVATE LIMITED",
"ULTRA TECH COMPONENTS (INDIA) PRIVATE LIMITED",
"ULTRA TECH CORE INDUSTRIES PRIVATE LIMITED",
"ULTRA TECH LABORATORIES PRIVATE LIMITED",
"ULTRA TECH SUSPENSIONS PRIVATE LIMITED",
"ULTRA TECH TRANSMISSIONS PRIVATE LIMITED",
"ULTRA TECHNO-MECH ENGINEERING PRIVATE LIMITED",
"ULTRA TOOLS INDUSTRY PRIVATE LIMITED",
"ULTRA TRADES & HOLDINGS COMPANY PVT LTD",
"ULTRA VEGGIES PRIVATE LIMITED",
"ULTRA VENEERS AND BOARDS PRIVATE LIMITED",
"ULTRA WASH TEX PRIVATE LIMITED",
"ULTRA WIRING CONNECTIVITY SYSTEM LIMITED",
"ULTRA WORLDWIDE PRIVATE LIMITED",
"ULTRACAB INDIA LIMITED",
"ULTRACASH TECHNOLOGIES PRIVATE LIMITED",
"ULTRACON CONSTRUCTIONS PRIVATE LIMITED",
"ULTRACON ENGIMECH PRIVATE LIMITED",
"ULTRACON INFRACHEM PRIVATE LIMITED",
"ULTRACONFIDENTIEL DESIGN PRIVATE LIMITED",
"ULTRACORE SOLUTIONS PRIVATE LIMITED",
"ULTRAFIL AIR SYSTEMS (INDIA) PRIVATE LIMITED",
"ULTRAFILTER (INDIA) PRIVATE LIMITED",
"ULTRAFINE MINERAL & ADMIXTURES PRIVATE LIMITED",
"ULTRAFINE PRODUCTS PRIVATE LIMITED",
"ULTRAFRESH MODULAR SOLUTIONS LIMITED",
"ULTRAGENIC RESEARCH AND TECHNOLOGIES PRIVATE LIMITED",
"ULTRALIFE BATTERIES INDIA PRIVATE LIMITED",
"ULTRAMAIN SOFTWARE INDIA PRIVATE LIMITED",
"ULTRAMARINE & PIGMENTS LIMITED",
"ULTRAMARINE SPECIALTY CHEMICALS LIMITED",
"ULTRAMARINE YACHTS PRIVATE LIMITED",
"ULTRAMARK HEALTH CARE PRIVATE LIMITED",
"ULTRAMATICS INDIA PRIVATE LIMITED",
"ULTRAMAX HYDROJET PRIVATE LIMITED",
"ULTRANET SERVICES PRIVATE LIMITED",
"ULTRAPLAST CHAINBELTS PRIVATE LIMITED",
"ULTRAPOWER EV TECH LIMITED",
"ULTRAPURE ENVIROCARE PRIVATE LIMITED",
"ULTRAQUERY TECHNOLOGIES INDIA PRIVATE LIMITED",
"ULTRARAIL INFRA SERVICES LLP",
"ULTRA-REACH AGRIMARKETS LIMITED.",
"ULTRASEAL INDIA PRIVATE LIMITED",
"ULTRASECURE INDUSTRIAL SERVICES PRIVATE LIMITED",
"ULTRA-SEEDTECH (INDIA) PRIVATE LIMITED",
"ULTRASHIELD TECHNOLOGY PRIVATE LIMITED",
"ULTRASHINE METAL FINISHING PRIVATE LIMITED",
"ULTRASOFT IT INFRASTRUCTURE & SERVICES PRIVATE LIMITED",
"ULTRATECH CEMENT LIMITED",
"ULTRATECH COMMUNITY WELFARE FOUNDATION",
"ULTRATECH ENERGY LIMITED",
"ULTRATECH ENGINEERING PRIVATE LIMITED",
"ULTRATECH INDIA LIMITED",
"ULTRATECH NATHDWARA CEMENT LIMITED",
"ULTRATECH POWER POINT PRIVATE LIMITED",
"ULTRATECH TEXTURES PAINTS PRIVATE LIMITED",
"ULTRATECH TOWNSHIP DEVELOPERS PRIVATE LIMITED",
"ULTRATECH WIRES PRIVATE LIMITED",
"ULTRAVIBRANT SOLAR ENERGY PRIVATE LIMITED",
"ULTREZE ENZYMES PRIVATE LIMITED",
"ULTRIA SOFTWARE PRIVATE LIMITED",
"ULTRIX DIGITAL PRODUCTS PRIVATE LIMITED",
"ULTRON BIOSCIENCES (OPC) PRIVATE LIMITED",
"ULTRON COMMERCE PRIVATE LIMITED",
"ULTRON HOME APPLIANCES INDIA LIMITED",
"ULTRON HOME APPLIANCES INDIA PRIVATE LIMITED",
"ULUNDURPET EXPRESSWAYS PRIVATE LIMITED",
"ULURU FOREX PRIVATE LIMITED",
"ULYSESS SYSTEMS INDIA PRIVATE LIMITED",
"ULYSTA IT SERVICES PRIVATE LIMITED",
"UM GREEN LIGHTING PRIVATE LIMITED",
"UM HIGH PRESSURE HYDRAULICS PRIVATE LIMITED",
"UM INDIA TWO WHEELERS PRIVATE LIMITED",
"UM VENTURES PRIVATE LIMITED",
"UMA AGRO EXPORTS PRIVATE LIMITED",
"UMA AQUA TRADING PRIVATE LIMITED",
"UMA AYURVEDICS PRIVATE LIMITED",
"UMA BUILDTECH PRIVATE LIMITED",
"UMA CERAMICS PRIVATE LIMITED",
"UMA CHEMTECH PRIVATE LIMITED",
"UMA COMMODEAL PRIVATE LIMITED",
"UMA CONVERTER LIMITED",
"UMA COSMOPLASTICS PVT LTD",
"UMA COTTON INDUSTRIES",
"UMA DAIRY PRIVATE LIMITED",
"UMA DRUGS PRIVATE LIMITED",
"UMA EDIBLE PRODUCTS PRIVATE LIMITED",
"UMA ENTERPRISES PVT LTD",
"UMA ESTATES AND INFRASTRUCTURE PRIVATE LIMITED",
"UMA ESTATES AND PROJECTS PRIVATE LIMITED",
"UMA EXPORTS LTD",
"UMA GASPOINT BOTTLING PRIVATE LIMITED",
"UMA GLASS WORKS PRIVATE LIMITED",
"UMA IMPACT PRIVATE LIMITED",
"UMA INDUS GAS PRIVATE LIMITED",
"UMA INFRATECH PRIVATE LIMITED",
"UMA ISPAT PRIVATE LIMITED",
"UMA KRAFTPAPER PRIVATE LIMITED",
"UMA KRISHNA EDUCATION FOUNDATION",
"UMA KRISHNA EDUCATIONAL FOUNDATION",
"UMA LUMINAIRES PRIVATE LIMITED",
"UMA MAHESH SILKS PRIVATE LIMITED",
"UMA MEDICAL RELATED INSTITUTE PRIVATE LIMITED",
"UMA MEDICARE LIMITED",
"UMA METALDEC PRIVATE LIMITED",
"UMA METALS PRIVATE LIMITED",
"UMA MOTORS PRIVATE LIMITED",
"UMA PLASTICS LIMITED",
"UMA PLASTOWARE PRIVATE LIMITED",
"UMA POLY SOLUTIONS PRIVATE LIMITED",
"UMA POLYESTERS PRIVATE LIMITED",
"UMA POLYMERS LIMITED",
"UMA POWERTRONICS PRIVATE LIMITED",
"UMA ROAD CARRIER PRIVATE LIMITED",
"UMA SHAKTI COAL PROCESSORS PRIVATE LIMITED",
"UMA SHANKAR DIXIT DISTRICT FEMALE HOSPITAL UNNAO",
"UMA SHANKAR ENTERPRISES PRIVATE LIMITED",
"UMA SHANKAR KHANDEWAL FORGING LIMITED",
"UMA SHANKAR TEXTILES",
"UMA SHREE EXPORTS PRIVATE LIMITED",
"UMA SPINNING MILLS PRIVATE LIMITED",
"UMA SPINTEX INDIA PRIVATE LIMITED",
"UMA SPRING PRIVATE LIMITED",
"UMA STRIPS LIMITED",
"UMA VINIMAY PRIVATE LIMITED",
"UMA WEAVETECH PRIVATE LIMITED",
"UMAAHA SOLUTIONS PRIVATE LIMITED",
"UMABAI KINIKAR KANYA VIDYALAYA DARWAH DIST YAVATMAL",
"UMABARI TEA CO PVT LTD",
"UMADEVI PHARMACEUTICALS PRIVATE LIMITED",
"UMADUTT INDUSTRIES LIMITED",
"UMAEXPO PRIVATE LIMITED",
"UMAID HOSPITAL",
"UMAIYAL ENTERPRISES SERVICES PRIVATE LIMITED",
"UMAK HOSPITALITY PRIVATE LIMITED",
"UMALAXMI ORGANICS PRIVATE LIMITED",
"UMANANDA RICE MILL LIMITED",
"UMANANDAN ENTERPRISES PRIVATE LIMITED",
"UMANATH RICE MILL PRIVATE LIMITED",
"UMANG ACID CHEM PRIVATE LIMITED",
"UMANG APPARELS PRIVATE LIMITED",
"UMANG ASSOCIATES PRIVATE LIMITED",
"UMANG BOARDS LIMITED",
"UMANG BUSINESS CONSULTANT PRIVATE LIMITED",
"UMANG COMMERCIAL CO PRIVATE LIMITED",
"UMANG COMMUNICATIONS PRIVATE LIMITED",
"UMANG CURE PRIVATE LIMITED",
"UMANG DISTRIBUTORS PRIVATE LIMITED",
"UMANG ENGINEERING PRIVATE LIMITED",
"UMANG ENTERPRISE",
"UMANG FIBRES PVT LTD",
"UMANG GLOBAL GROUP PRIVATE LIMITED",
"UMANG GLOBAL LOGISTICS INDIA PRIVATE LIMITED",
"UMANG MANGAL FINANCIAL SERVICES LLP",
"UMANG MOTORS PRIVATE LIMITED",
"UMANG OILS PRIVATE LIMITED",
"UMANG PACK-CRAFT PRIVATE LIMITED",
"UMANG PHARMATECH PRIVATE LIMITED",
"UMANG SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"UMANG UDYOG PRIVATE LIMITED",
"UMANGG PAPERS PRIVATE LIMITED",
"UMANO HEALTHCARE PRIVATE LIMITED",
"UMAPATI OIL MILL PRIVATE LIMITED",
"UMAPUTRA TIE-UP PRIVATE LIMITED.",
"UMAR INFRASTRUCTURE PRIVATE LIMITED",
"UMAR MEDICARE PRIVATE LIMITED",
"UMARANI AGROTECH PRIVATE LIMITED",
"UMARGAON TEXTILE MACHINERY P LTD",
"UMASHANKAR ALLOYS PRIVATE LIMITED",
"UMASHANKAR PROJECTS PRIVATE LIMITED",
"UMASHREE PROPERTIES PVT LTD",
"UMASHREE RICE MILLS PRIVATE. LIMITED.",
"UMASON PAPER PRIVATE LIMITED",
"UMASONS AUTO COMPO PRIVATE LIMITED",
"UMASONS STEELFAB PRIVATE LIMITED",
"UMASREE TEXPLAST PRIVATE. LIMITED.",
"UMAWALA ENGINEERS PRIVATE LIMITED",
"UMAXE PROJECTS PRIVATE LIMITED",
"UMAYAMBIKAI FINANCIAL SERVICES PRIVATE LIMITED",
"UMB SECURITIES LIMITED",
"UMBAR SYMBIOTICS INDIA PRIVATE LIMITED",
"UMBEL PROPERTIES PRIVATE LIMITED",
"UMBER CELL COMPONENTS PVT LTD",
"UMBERGAON CLUB AND RESORT PRIVATE LIMITED",
"UMBERTO CERAMICS INTERNATIONAL PRIVATE LIMITED",
"UMBILICAL PHARMACEUTICALS PRIVATE. LIMITED.",
"UMBO IDTECH PRIVATE LIMITED",
"UMBRA MINING PRIVATE LIMITED",
"UMBRELLA ADVERTISERS PRIVATE LIMITED",
"UMBRELLA CABLE SYSTEMS PRIVATE LIMITED",
"UMBRELLA FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"UMBRELLA HOSPITALITY PRIVATE LIMITED",
"UMBRELLA INFOCARE PRIVATE LIMITED",
"UMBRELLA PROTECTION SYSTEMS PRIVATE LIMITED",
"UMBRETTE CONSULTING LLP",
"UMBREY ENGINEERING PRIVATE LIMITED.",
"UMC TECHNOLOGIES PRIVATE LIMITED",
"UMDS ENGINEERS PRIVATE LIMITED",
"UMECO TRADERS PRIVATE LIMITED",
"UMED HOSPITAL",
"UMED MAHARASHTRA STATE RURAL LIVELIHOOD MISSION",
"UMED PHARMA LAB PRIVATE LIMITED",
"UMEDICA LABORATORIES PRIVATE LIMITED",
"UMEED BUILDER & CONSTRUCTOR PRIVATE LIMITED",
"UMEEKA PACKAGING PRIVATE LIMITED",
"UMENDRA EXPORTS PRIVATE LIMITED",
"UMERI DISTILLERY PRIVATE LIMITED",
"UMESH AND MANIK CONSTRUCTION PRIVATE LIMITED",
"UMESH BOARD AND PAPER MILLS PRIVATE LIMITED",
"UMESH CAL-CHEM (INDIA) PRIVATE LIMITED",
"UMESH CHANDRA COLLEGE",
"UMESH INDUSTRIES PRIVATE LIMITED",
"UMESH MINERAL INDUSTRIES PVT. LTD",
"UMESH PENCILS PROCESSORS PRIVATE LIMITED",
"UMESH PROPERTIES PRIVATE LIMITED",
"UMESHWAR SECURITIES PRIVATE LIMITED",
"UMET ALLOYS PRIVATE LIMITED",
"UMEUS UNITED PRIVATE LIMITED",
"UMEX POLYMERS PRIVATE LIMITED",
"UMICORE AUTOCAT INDIA PRIVATE LIMITED",
"UMICORE INDIA PRIVATE LIMITED",
"UMIL SHARE & STOCK BROKING SERVICES LTD.",
"UMIRO RESOURCES PRIVATE LIMITED",
"UMIYA AIRPACK PRIVATE LIMITED",
"UMIYA ALLOYS PRIVATE LIMITED",
"UMIYA ASSOCIATES",
"UMIYA BATTERIES PRIVATE LIMITED",
"UMIYA BOARD AND PAPER MILLS PRIVATE LIMITED",
"UMIYA CABLE PRIVATE LIMITED",
"UMIYA CARBON PRIVATE LIMITED",
"UMIYA FLEXIFOAM PRIVATE LIMITED",
"UMIYA FMCG PRIVATE LIMITED",
"UMIYA GARMENTS PRIVATE LIMITED",
"UMIYA HOLDING PRIVATE LIMITED",
"UMIYA METALS PRIVATE LIMITED",
"UMIYA MILK PRODUCTS PRIVATE LIMITED",
"UMIYA MINERAL PRIVATE LIMITED",
"UMIYA MOBILE PRIVATE LIMITED",
"UMIYA PHONES PRIVATE LIMITED",
"UMIYA TEA PRIVATE LIMITED",
"UMIYA TIMBERS PRIVATE LIMITED",
"UMIYA TUBES LIMITED",
"UMIYA WOOD WORKS PRIVATE LIMITED.",
"UMIYAJI INDUSTRIES PRIVATE LIMITED",
"UMKAL HEALTH CARE PRIVATE LIMITED",
"UMKAL HOSPITALS PRIVATE LIMITED",
"UMM STUDIOS AND TECHNOLOGIES PRIVATE LIMITED",
"UMMA INFRAPROJECTS PRIVATE LIMITED",
"UMMED EDUCATIONAL FOUNDATION",
"UMMEED HOUSING FINANCE PRIVATE LIMITED",
"UMMU CONSTRUCTION & DEVELOPERS PRIVATE LIMITED",
"UMP INFRA SERVICES INDIA PRIVATE LIMITED",
"UMP SECURITY & FACILITY PRIVATE LIMITED",
"UMR ASSOCIATES",
"UMR TECH PRIVATE LIMITED",
"UMRAH ENGINEERING AND CONSTRUCTIONS PRIVATE LIMITED",
"UMRAO AUTOMATION PRIVATE LIMITED",
"UMRAO HOTELS & RESORTS PRIVATE LIMITED",
"UMRAO SINGH MAHAVIR PARSHAD JAIN JEWELLERS PRIVATE LIMITED",
"UMRAO THEATRE PRIVATE LIMITED",
"UMRAWAT ENGICON PRIVATE LIMITED",
"UMRED NAGAR PARISHAD",
"UMRI POOPH PRATAPPUR TOLLWAY PRIVATE. LIMITED.",
"UMRIT EXPORTS AND INVESTMENTS PRIVATE LIMITED",
"UMS INFOTECH PRIVATE LIMITED",
"UMS TECHNOLOGIES LIMITED",
"UMS TECHNOLOGIES PRIVATE LIMITED",
"UMSL LIMITED",
"UMW INDUSTRIES LIMITED",
"UMW METAL PRIVATE LIMITED",
"UMWELT ENGINEER PRIVATE LIMITED",
"UMWELT RESEARCH LAB PRIVATE LIMITED",
"UN EXIM PRIVATE LIMITED",
"UN MEHTA INSTITUTE OF CARDIOLOGY AND RESEARCH CENTRE",
"UN PATEL INFRADEVELOPERS PRIVATE LIMITED",
"UN REALITY PRIVATE LIMITED",
"UNA ASSOCIATES PRIVATE LIMITED",
"UNA CARGO SERVICES PRIVATE LIMITED",
"UNACCO FINANCIAL SERVICES PRIVATE LIMITED",
"UNACORES SOLUTIONS PRIVATE LIMITED",
"UNAKOTI SCIENTIFIC PRIVATE LIMITED",
"UNANI MEDICAL COLLEGE",
"UNANU TECHNOLOGIES PRIVATE LIMITED",
"UNAONE SHIP MANAGEMENT PRIVATE LIMITED",
"UNAPRIME INVESTMENT ADVISORS PRIVATE LIMITED",
"UNARAA INTERNATIONAL PRIVATE LIMITED",
"UNAVA SHRESTH PRATHMIK SHALA",
"UNAYAAN TRADE AND COMMERCE PRIVATE LIMITED",
"UNAZO GLOBAL PRIVATE LIMITED",
"UNBAY SECURITY SERVICES PRIVATE LIMITED",
"UNBLOCK INDIA PRIVATE LIMITED",
"UNBOUND MEETINGS AND INCENTIVES PRIVATE LIMITED",
"UNBOX GADGETS PRIVATE LIMITED",
"UNBOX TECHNOLOGIES PRIVATE LIMITED",
"UNBOXED INNOVATING EXPERIENCES PRIVATE LIMITED",
"UNBRAKO PRIVATE LIMITED",
"UNBXD SOFTWARE PRIVATE LIMITED",
"UNCHARTED INFOLABS PRIVATE LIMITED",
"UNCIA TECHNOLOGIES PRIVATE LIMITED",
"UNCLE'S KITCHEN GROUP PRIVATE LIMITED",
"UNCOMMONSENSE FILMS PRIVATE LIMITED",
"UNDAVALLI CONSTRUCTIONS",
"UNDER ARMOUR INDIA TRADING PRIVATE LIMITED",
"UNDER SECRETARY (DDO) PRESIDENT SECRETARYIAT",
"UNDER THE MANGO TREE NATURALS AND ORGANICS PRIVATE LIMITED",
"UNDERCARRIAGE AND TRACTOR PARTS PRIVATE LIMITED",
"UNDERGROUND MAGNETICS PRIVATE LIMITED",
"UNDERGROUND PIPELINE AND NONDESTRUCTIVE TESTING SERVICE PRIVATE LIMITED",
"UNDERGROUND SUPPLIES AND SERVICES PRIVATE LIMITED",
"UNDERSOUNDS ENTERTAINMENT PRIVATE LIMITED",
"UNDERWATER SERVICES COMPANY LIMITED",
"UNDERWATER SEVICES COMPANY LIMITED",
"UNDI POLYMERS PRIVATE LIMITED",
"UNE ENTERTAINMENT PRIVATE LIMITED",
"UNEECOPS BUSINESS SOLUTIONS PRIVATE LIMITED",
"UNEECOPS TECHNOLOGIES LIMITED",
"UNEECOPS WORKPLACE SOLUTIONS PRIVATE LIMITED",
"UNEED SOLUTIONS PRIVATE LIMITED",
"UNEEVIU TECHNOLOGIES INDIA PRIVATE LIMITED",
"UNELECT CONNECT PRIVATE LIMITED",
"UNENDLICHE BUSINESS SOLUTIONS PRIVATE LIMITED",
"UNEX POWER POINT PRIVATE LIMITED",
"UNEXBUILD INDIA PRIVATE LIMITED",
"UNEXO LABORATORIES PRIVATE LIMITED",
"UNEXO LIFE SCIENCES PRIVATE LIMITED",
"UNFLASHY SOLUTION LIMITED",
"UNGER INDIA PRIVATE LIMITED",
"UNH MANAGEMENT SERVICES PRIVATE LIMITED",
"UNI ABEX ALLOY PRODUCTS LIMITED",
"UNI ACADEMIC CONSULTANTS LLP",
"UNI ADS LIMITED",
"UNI AGENCIES CHEMICALS PRIVATE LTD",
"UNI AUTOMATION INDIA PRIVATE LIMITED",
"UNI BIOTECH HEALTHCARE PRIVATE LIMITED",
"UNI CARD TECHNOLOGIES PRIVATE LIMITED",
"UNI CLEAN EQUIPMENTS PRIVATE LIMITED",
"UNI DERITEND LIMITED",
"UNI DESIGN ELITE JEWELLERY PRIVATE LIMITED",
"UNI DESIGN JEWELLERY INDIA PRIVATE LIMITED",
"UNI GAS INDUSTRIES LIMITED",
"UNI GEM INDIA LIMITED",
"UNI GEM INDIA PRIVATE LIMITED",
"UNI KLINGER LIMITED",
"UNI LOGITRANS INDIA PRIVATE LIMITED",
"UNI MEDITREK PRIVATE LIMITED",
"UNI MODERN TOOLING SOLUTION CHENNAI PRIVATE LIMITED",
"UNI ONE INDIA PRIVATE LIMITED",
"UNI PACK MACHINES PVT LTD",
"UNI POWER TECHNICAL SERVICES AND CONSULTANCY PRIVATE LIMITED",
"UNI POWER TRANSMISSION (MYSORE) PRIVATE LIMITED",
"UNI PROFILES PRIVATE LIMITED",
"UNI RAIL COMPLETE RAIL SOLUTION",
"UNI RECYCLERS PVT LTD",
"UNI SHIP AGENCY & LOGISTICS PRIVATE LIMITED",
"UNI SILKS PRIVATE LIMITED",
"UNI TACK DIALS PRIVATE LIMITED",
"UNI TECH AUTOMATION PRIVATE LIMITED",
"UNI TRANSPORT INDIA PRIVATE LIMITED",
"UNI TRITECH PRIVATE LIMITED",
"UNI10 MEDIA WORKS PRIVATE LIMITED",
"UNIALL PHARMA PRIVATE LIMITED",
"UNIARK HEALTHCARE PRIVATE LIMITED",
"UNIAYUR PRIVATE LIMITED",
"UNIBAIT AUTO PARTS PRIVATE LIMITED",
"UNIBAIT FEEDS PRIVATE LIMITED",
"UNIBERA DEVELOPERS PRIVATE LIMITED",
"UNIBEV LIMITED",
"UNIBIC FOODS INDIA PRIVATE LIMITED",
"UNIBILD ENGINEERING AND CONSTRUCTION COMPANY PRIVATE LIMITED",
"UNIBIM SERVICES PRIVATE LIMITED",
"UNIBIO (INDIA) HATCHERIES PRIVATE LIMITED",
"UNIBIOTIC INDIA PRIVATE LIMITED",
"UNIBIZ MULTI TRADE PRIVATE. LIMITED",
"UNIBIZ SOFTWARE SOLUTIONS PRIVATE LIMITED",
"UNIBRAIN CONSULTANCY SERVICE PRIVATE LIMITED",
"UNIBRO MARTECH PRIVATE LIMITED",
"UNIBUDDY INDIA PRIVATE LIMITED",
"UNIC ALUTECH PRIVATE LIMITED",
"UNIC SOFTWARE TECHNOLOGY PRIVATE LIMITED",
"UNIC TRADING COMPANY PRIVATE LIMITED",
"UNICA ENGINEERS AND CONTRACTOR PRIVATE LIMITED",
"UNICA PACK INDIA PRIVATE LIMITED",
"UNICAL SYSTEMS PRIVATE LIMITED",
"UNICAN CONTROLS AND AUTOMATION PRIVATE LIMITED",
"UNICAN RESOURCES PRIVATE LIMITED",
"UNICAP CONSULTING PRIVATE LIMITED",
"UNICARE DEVELOPER LIMITED",
"UNICARE EMERGENCY EQUIPMENT PRIVATE LIMITED",
"UNICARE FIRE SAFETY (INDIA) PRIVATE LIMITED",
"UNICARE HEALTHSCIENCES PRIVATE LIMITED",
"UNICARE HEART INSTITUTE AND RESEARCH CENTER",
"UNICARE INTEGRATED FACILITY SERVICES PRIVATE LIMITED",
"UNICARE TECHNOLOGIES PRIVATE LIMITED",
"UNICAST ALLOYS PRIVATE LIMITED",
"UNICAST COMPONENTS PRIVATE LIMITED",
"UNICCHEM TECHNOLOGIES INDIA PRIVATE LIMITED",
"UNICEF",
"UNICEL AUTOTECH INDIA PRIVATE LIMITED",
"UNICEL ENGINEERING PRIVATE LIMITED",
"UNICEL INFRA PRIVATE LIMITED",
"UNICELER HEALTHCARE PRIVATE LIMITED",
"UNICHARM INDIA PRIVATE LIMITED",
"UNICHEM FINANCE & ENTERPRISES PVT LTD",
"UNICHEM LABORATORIES LIMITED",
"UNICHEM STEEL & ALLOYS PRIVATE LIMITED",
"UNICHROM LABORATORIES PRIVATE LIMITED",
"UNICITA CONSULTING PRIVATE LIMITED",
"UNICITI SOLUTIONS PRIVATE LIMITED",
"UNICITY HEALTH PRIVATE LIMITED",
"UNICITY PETROCHEMS CO PRIVATE LIMITED",
"UNICK FIX-A-FORM AND PRINTERS LIMITED",
"UNICK PLASTIC SYSTEMS PRIVATE LIMITED",
"UNICK TRAVEL & FOREX PRIVATE LIMITED",
"UNICLAN HEALTHCARE PRIVATE LIMITED",
"UNICLAN HYGIENE PRIVATE LIMITED",
"UNICLAN TRADEX PRIVATE LIMITED",
"UNICLARE SOLUTIONS PRIVATE LIMITED",
"UNICLEAR LOGISTICS PRIVATE LIMITED",
"UNICO ELECTRICALS PRIVATE LIMITED",
"UNICO EXIM SERVICES PRIVATE LIMITED",
"UNICO INFRAENGINEERS PRIVATE LIMITED",
"UNICO LOGISTICS INDIA PRIVATE LIMITED",
"UNICO PHARMA PRIVATE LIMITED",
"UNICO SEEDS PRIVATE LIMITED",
"UNICO TILES PRIVATE LIMITED",
"UNICODE SYSTEMS PRIVATE LIMITED",
"UNICOLOUR TEXTILES PRIVATE LIMITED",
"UNICOLOURS LIFESTYLE PRIVATE LIMITED",
"UNI-COM ENTERPRISES INDIA PRIVATE LIMITED",
"UNICOM FINANCE PRIVATE LIMITED",
"UNI-COM FINCORP PRIVATE LIMITED",
"UNI-COM INDIA PRIVATE LIMITED",
"UNICOM INFOTEL PRIVATE LIMITED",
"UNI-COM INTERNATIONAL PRIVATE LIMITED",
"UNICOM MOBILES PRIVATE LIMITED",
"UNICOM RETAILS PRIVATE LIMITED",
"UNICOMMERCE ESOLUTIONS LIMITED",
"UNICOMMERCE ESOLUTIONS PRIVATE LIMITED",
"UNICOMP INFOSOLUTIONS PRIVATE LIMITED",
"UNICON BUILDSPACE INDIA PRIVATE LIMITED",
"UNICON COMMOTRADE PRIVATE LIMITED",
"UNICON DISTRIBUTORS PRIVATE LIMITED",
"UNICON FIBRO CHEMICALS PVT LTD",
"UNICON LOGISTICS INDIA PRIVATE LIMITED",
"UNICON METALS AND ALLOYS PRIVATE LIMITED",
"UNICON PHARMA PRIVATE LIMITED",
"UNICON SHELTERS PRIVATE. LIMITED.",
"UNICON SUPPLIERS PVT LTD",
"UNICON TECHNO SOLUTIONS PRIVATE LIMITED",
"UNICON TECHNOLOGY INTERNATONAL PRIVATE LIMITED",
"UNICON VANIJYA PRIVATE LIMITED",
"UNICONNECT SIM PRIVATE LIMITED",
"UNICONSYS PRIVATE LIMITED",
"UNICORE FINSERVE PRIVATE LIMITED",
"UNICORN (BANGALORE) PRIVATE LIMITED",
"UNICORN ABASAN PRIVATE LIMITED",
"UNICORN AUTOMATION PRIVATE LIMITED",
"UNICORN CONCHEM PRIVATE LIMITED",
"UNICORN CONVENTION SERVICES PRIVATE LIMITED",
"UNICORN DENMART LIMITED",
"UNICORN DIGITAL SYSTEMS PVT LTD",
"UNICORN FACILITY SUPPORT SERVICES PRIVATE LIMITED",
"UNICORN INCENSE PRIVATE LIMITED",
"UNICORN INDUSTRIES PRIVATE LIMITED",
"UNICORN INFOSOLUTIONS PRIVATE LIMITED",
"UNICORN INFRA PROJECTS AND ESTATES PRIVATE LIMITED",
"UNICORN INSIGHTS PRIVATE LIMITED",
"UNICORN INSURANCE BROKERS PVT LTD",
"UNICORN INTEGRATED SERVICES PRIVATE LIMITED",
"UNICORN IT RESOURCES PRIVATE LIMITED",
"UNICORN LAND SOLUTION PRIVATE LIMITED",
"UNICORN M E P CONSUL TANTS PRIVATE LIMITED",
"UNICORN MARKETING (BANGALORE) PRIVATE LIMITED",
"UNICORN MCF SOLUTIONS PRIVATE LIMITED",
"UNICORN MEDIDENT PVT LTD",
"UNICORN NATURAL PRODUCTS PRIVATE LIMITED",
"UNICORN NUTRITION PRIVATE LIMITED",
"UNICORN PACKAGING LLP",
"UNICORN PETROLEUM INDUSTRIES PRIVATE LIMITED SERVICES",
"UNICORN PHARMACHEM PRIVATE LIMITED",
"UNICORN POLES PRIVATE LIMITED",
"UNICORN POST MEDIA SOLUTIONS PRIVATE LIMITED",
"UNICORN PRESSURE VESSELS PRIVATE LIMITED",
"UNICORN SALES AGENCIES PRIVATE LIMITED",
"UNICORN SPORTSWEAR & LIFESTYLE PRIVATE LIMITED",
"UNICORN TOURISM & TOURS SERVICES PRIVATE LIMITED",
"UNICORN UPTIME POWER PRIVATE LIMITED,",
"UNICORN VALVES PRIVATE LIMITED",
"UNICORP GLOBAL INDUSTRIES PRIVATE LIMITED",
"UNICORP HVAC SOLUTIONS PRIVATE LIMITED",
"UNICORP INTERNATIONAL PRIVATE LIMITED",
"UNICORP REALTY PRIVATE LIMITED",
"UNICORP SOLUTIONS PRIVATE LIMITED",
"UNICORP UTILITIES STRAINERS PRIVATE LIMITED",
"UNICOTSYN PRIVATE LIMITED",
"UNICOTTON APPAREL EXPORTS PRIVATE LIMITED",
"UNICRAFT APPLIANCES PRIVATE LIMITED",
"UNICRAFT MACHINERY & TROLLEY PVT LTD",
"UNICRATE PACKAGING PRIVATE LIMITED",
"UNICREDIT S.P.A",
"UNICRETE BUILDING SOLUTIONS(INDIA) PRIVATE LIMITED",
"UNICROSS GLOBAL PRIVATE LIMITED",
"UNICULTURE MANUFACTURING PRIVATE LIMITED",
"UNICURE INDIA LIMITED",
"UNICURE REMEDIES PRIVATE LIMITED",
"UNICUS INFOLABS PRIVATE LIMITED",
"UNID FINANCE CONSULTANCY PRIVATE LIMITED",
"UNIDEC FOUNDATIONS PRIVATE LIMITED",
"UNIDEEP FOOD PROCESSING PRIVATE LIMITED",
"UNIDEL DESIGNS PRIVATE LIMITED",
"UNIDENT INSTRUMENTS (INDIA) PRIVATE LIMITED",
"UNI-DESIGN JEWELLERY PRIVATE LIMITED",
"UNIDOS INSTA PRINT PRIVATE LIMITED",
"UNIDRUG INNOVATIVE PHARMA TECHNOLOGIES LIMITED",
"UNIDYES CHEMICALS PRIVATE LIMITED",
"UNIEARTH EARTHING SOLUTIONS PRIVATE LIMITED",
"UNIEN CAPITAL ADVISORS PRIVATE LIMITED",
"UNIERA INFRATECH LIMITED",
"UNIEXCEL AGENCIES AND SERVICES PRIVATE LIMITED",
"UNIEXCEL POLYCHEM PRIVATE LIMITED",
"UNIEXCEL WEAVE TECH PRIVATE LIMITED",
"UNIFAB ENGINEERING PROJECT PRIVATE LIMITED",
"UNIFAB FASHION PRIVATE LIMITED",
"UNIFAB INDIA SOLUTION‚ÄôS",
"UNIFAB INFRA PROJECTS PRIVATE LIMITED",
"UNIFAB PHARMACEUTICAL PRIVATE LIMITED",
"UNIFAB TEXCOT INDIA PRIVATE LIMITED",
"UNIFAC MANAGEMENT SERVICES ( INDIA) PRIVATE LIMITED",
"UNIFAITH BIOTECH PRIVATE LIMITED",
"UNIFECT OVERSEAS PRIVATE LIMITED",
"UNIFEEDER AGENCIES INDIA PRIVATE LIMITED",
"UNIFI CAPITAL PRIVATE LIMITED",
"UNIFI FINANCIAL PRIVATE LIMITED",
"UNIFIED BRAINZ VIRTUOSO LIMITED",
"UNIFIED CORPORATION PRIVATE LIMITED",
"UNIFIED DATA TECH SOLUTIONS PRIVATE LIMITED",
"UNIFIED DATA- TECH SOLUTIONS PRIVATE LIMITED",
"UNIFIED ELECTRO-TECH PRIVATE LIMITED",
"UNIFIED ENGINEERING SOLUTIONS PRIVATE LIMITED",
"UNIFIED FACILITY SERVICES PRIVATE LIMITED",
"UNIFIED FORMWORK SYSTEMS PRIVATE LIMITED",
"UNIFIED GLOBALTECH (I) PRIVATE LIMITED",
"UNIFIED INFOTECH PRIVATE LIMITED",
"UNIFIED INNOVATIONS & DESIGNS PRIVATE LIMITED",
"UNIFIED IT SERVICES PRIVATE LIMITED",
"UNIFIED LOGISTICS INDIA PRIVATE LIMITED",
"UNIFIED LOGISTICS SOLUTIONS PRIVATE LIMITED",
"UNIFIED POWER PRIVATE LIMITED",
"UNIFIED SIGNALLING AND TRANSPORTATION SYSTEMS PRIVATE LIMITED",
"UNIFIED VISION CAPITAL PRIVATE LIMITED",
"UNIFIED VOICE COMMUNICATION PRIVATE LIMITED",
"UNIFIED WIRE INDUSTRIES PRIVATE LIMITED",
"UNIFIED WORKPLACE INDIA PRIVATE LIMITED",
"UNIFIERS SOCIAL VENTURES PRIVATE LIMITED",
"UNIFII DELIVERY CENTER PRIVATE LIMITED",
"UNIFIX PLAST PRIVATE LIMITED",
"UNIFIZE INDIA PRIVATE LIMITED",
"UNIFLEX HOSE ASSEMBLY MACHINES INDIA PRIVATE LIMITED",
"UNIFLEX PRECISION PRODUCTS PRIVATE LIMITED",
"UNIFLEX PROJECTS PRIVATE LIMITED",
"UNIFLOCK INTERNATIONAL PRIVATE LIMITED",
"UNIFLOW CONTROLS PRIVATE LIMITED",
"UNIFLY RUBBER YARN LIMITED",
"UNIFO PRIVATE LIMITED",
"UNIFORCE ENGINEERING INDIA PRIVATE LIMITED",
"UNIFORM IN A BOX PRIVATE LIMITED",
"UNIFORMS UNLIMITED",
"UNIFOUR DEVELOPERS PRIVATE LIMITED",
"UNIFOUR VENTURES PRIVATE LIMITED",
"UNIFRANCO LIFE SCIENCES PVT LTD",
"UNIFRAX INDIA LIMITED",
"UNIFRAX INDIA PRIVATE LIMITED",
"UNIFREIGHT MOVERS PRIVATE LIMITED",
"UNIFRIEND TELECOM PRIVATE LIMITED",
"UNIFRONT TEXTILES PROCESSORS PRIVATE LIMITED",
"UNIFRONTIER TECHNOLOGIES PRIVATE LIMITED",
"UNIFUDS INDIA PRIVATE LIMITED",
"UNIFY FACILITY MANAGEMENT PRIVATE LIMITED",
"UNIFY IT SOLUTIONS PRIVATE LIMITED",
"UNIFY SYSTEMS PRIVATE LIMITED",
"UNIFY TECHNOLOGIES PRIVATE LIMITED",
"UNIFY TEXTURISERS PRIVATE LIMITED",
"UNIFYIA SOLUTIONS INDIA PRIVATE LIMITED",
"UNIFYND TECHNOLOGIES PRIVATE LIMITED",
"UNIGASKET INDIA PRIVATE LIMITED",
"UNIGATE FORWARDING INDIA PRIVATE LIMITED",
"UNIGATE GENERAL MEDIA PRIVATE LIMITED",
"UNIGENETICS INSTRUMENTS PRIVATE LIMITED",
"UNIGLAZE INDIA PRIVATE LIMITED",
"UNIGLOBAL DISTRIBUTORS PRIVATE LIMITED",
"UNIGLOBAL PAPERS PRIVATE LIMITED",
"UNIGLOBAL TRANSWAYS PRIVATE LIMITED",
"UNIGLOBE AGRO IMPEX PRIVATE LIMITED",
"UNIGLOBE ANALYTICA PRIVATE LIMITED",
"UNIGLOBE ECONOMIC PARK PRIVATE LIMITED",
"UNIGLOBE EXPORTS PRIVATE LIMITED",
"UNIGLOBE FOODS PRIVATE LIMITED",
"UNIGLOBE FOREX PRIVATE LIMITED",
"UNIGLOBE INFOTECH PRIVATE LIMITED",
"UNIGLOBE LOGISTICS PRIVATE LIMITED",
"UNIGLOBE MARKETING PRIVATE LIMITED.",
"UNIGLOBE PACKAGING PRIVATE LIMITED",
"UNIGLOBE TRAVEL SOUTH ASIA PRIVATE LIMITED",
"UNIGLOBUS ELECTRICALS AND ELECTRONICS PRIVATE LIMITED",
"UNI-GLOBUS RESOURCE PRIVATE LIMITED",
"UNIGLORY TEXTILES PRIVATE LIMITED",
"UNIGO TRAVEL (INDIA) PRIVATE LIMITED",
"UNIGOLD AGRO BIOTECH PRIVATE LIMITED",
"UNIGOODS INDIA CARRIERS PRIVATE LIMITED",
"UNIGREEN FOODS (INDIA) PRIVATE LIMITED",
"UNIHEALTH CONSULTANCY LIMITED",
"UNIHEALTH PHARMACEUTICALS PRIVATE LIMITED",
"UNIHEIGHTS INTERIO PRIVATE LIMITED",
"UNIHORN INDIA PRIVATE LIMITED",
"UNIHUB INDIA INFOTECH PRIVATE LIMITED",
"UNIIKART ESTORE PRIVATE LIMITED",
"UNI-IMPEX STEELS PRIVATE LIMITED",
"UNIINFO TELECOM SERVICES LIMITED",
"UNI-INFRATECH PRIVATE LIMITED",
"UNIJET PNEUMATICS PRIVATE LIMITED",
"UNIJULES LIFE SCIENCES LIMITED",
"UNIK IT PRIVATE LIMITED",
"UNIK MERCHANTS PVT LTD",
"UNIK PNEUMATIC ENGINEERING COMPANY PRIVATE LIMITED",
"UNIK PRINTERS PRIVATE LIMITED",
"UNIK SEWING SYSTEMS PRIVATE LIMITED",
"UNIK SYSTEM",
"UNIK TECHNO SYSTEMS PRIVATE LIMITED",
"UNIK TECHNOLOGIES PRIVATE LIMITED",
"UNIKA INDIA PRIVATE LIMITED",
"UNIKAIHATSU SOFTWARE PRIVATE LIMITED",
"UNIKELVIN VENTURES PRIVATE LIMITED",
"UNIKEN INDIA PRIVATE LIMITED",
"UNIKEN SYSTEMS PRIVATE LIMITED",
"UNIKIND SECURE SOLUTIONS PRIVATE LIMITED",
"UNIKO PLAST PRIVATE LIMITED",
"UNIKORN AGRO PRIVATE LIMITED",
"UNIKORN COATINGS PRIVATE LIMITED",
"UNIKOVE TECHNOLOGIES PRIVATE LIMITED",
"UNIKRANGE INDIA PRIVATE LIMITED",
"UNIKUE CONHEIGHT PRIVATE LIMITED",
"UNIKUE KITCHEN AND HOSPITALITY SERVICES PRIVATE LIMITED",
"UNILAB CHEMICALS AND PHARMACEUTICALS PRIVATE LIMITED",
"UNILAB MICROSCOPE MANUFACTURING CO. PRIVATE LIMITED",
"UNI-LABS INDIA PRIVATE LIMITED",
"UNILAC ENGINEERING PRIVATE LIMITED",
"UNILATERAL TECHNOLOGY PRIVATE LIMITED",
"UNILAX PAINTS PVT LTD",
"UNILAY COATINGS PRIVATE LIMITED",
"UNILAZER VENTURES PRIVATE LIMITED",
"UNILEATHER INDIA PRIVATE LIMITED",
"UNILED TECHNOLOGIES INDIA PRIVATE LIMITED",
"UNILET APPLIANCES PRIVATE LIMITED",
"UNILEVER INDIA EXPORTS LIMITED",
"UNILEVER INDIA LIMITED",
"UNILEVER INDUSTRIES PRIVATE LIMITED",
"UNILEVER VENTURES INDIA ADVISORY PRIVATE LIMITED",
"UNILEX COLOURS AND CHEMICALS LIMITED",
"UNILEX LIFESCIENCES PRIVATE LIMITED",
"UNILIFE PHARMACHEM PRIVATE LIMITED",
"UNILIFT CARGO SYSTEMS PRIVATE LIMITED",
"UNILIGHT INSURANCE BROKERS PRIVATE LIMITED",
"UNILIGHT REINSURANCE BROKERS PRIVATE LIMITED",
"UNILIN FLOORING INDIA PRIVATE LIMITED",
"UNILINE ENERGY SYSTEMS PRIVATE LIMITED",
"UNILINK CHEMICALS PRIVATE LIMITED",
"UNILINK ENGINEERING CORPORATION PRIVATE LIMITED",
"UNILINK LOGISTICS PRIVATE LIMITED",
"UNILINK PHARMA PRIVATE LIMITED",
"UNILODE AVIATION SOLUTIONS INDIA PRIVATE LIMITED",
"UNILOG CONTENT SOLUTION PRIVATE LIMITED",
"UNILOGIC TECHNOLOGIES PRIVATE LIMITED",
"UNILON EXPORTS PRIVATE LIMITED",
"UNILOY PLASTICS MACHINERY PRIVATE LIMITED",
"UNIM PHARMALAB PVT LTD",
"UNIMAC OVERSEAS PRIVATE LIMITED",
"UNIMAG POWER TRANSFORMER PRIVATE LIMITED",
"UNIMAPLE MODUTECH PRIVATE LIMITED",
"UNIMAR MARINE SERVICES PRIVATE LIMITED",
"UNIMARCK PHARMA INDIA LIMITED",
"UNIMARK BUSINESS SOLUTIONS PRIVATE LIMITED",
"UNIMAT CONCEPTS PRIVATE LIMITED",
"UNIMAX AUTOMOTIVE PRIVATE LIMITED",
"UNIMAX CHEMICALS PRIVATE LIMITED",
"UNIMAX ENGINEERING CO PRIVATE LIMITED",
"UNIMAX FROZEN TREAT PRIVATE LIMITED",
"UNIMAX PHARMACEUTICALS PVT LTD",
"UNIMAX POLLUTION CONTROL INDIA PRIVATE LIMITED",
"UNIMAX ROOFING SOLUTIONS PRIVATE LIMITED",
"UNIMAXE BUILDERS PRIVATE LIMITED",
"UNIMAY ELECTRONIC PRIVATE LIMITED",
"UNIMECH AEROSPACE AND MANUFACTURING PRIVATE LIMITED",
"UNIMECH ENGINEERS PRIVATE LIMITED",
"UNIMECH ENTERPRISES INDIA PRIVATE LIMITED",
"UNIMECH INDUSTRIES PRIVATE LIMITED",
"UNIMECH LIFTING EQUIPMENTS PVT LTD",
"UNIMECH SYSTEMS BANGALORE PRIVATE LIMITED",
"UNIMECH SYSTEMS INDIA PRIVATE LIMITED",
"UNIMECH WELDTECH PRIVATE LIMITED",
"UNIMED HEALTHCARE PRIVATE LIMITED",
"UNIMED INVESTMENTS LIMITED",
"UNIMED TECHNOLOGIES LIMITED",
"UNIMEDIA PHARMACEUTICALS PRIVATE LIMITED",
"UNIMET ALLOYS AND ELECTRONICS PRIVATE LIMITED",
"UNI-METAL SYSTEMS PRIVATE LIMITED",
"UNIMITY SOLUTIONS PRIVATE LIMITED",
"UNIMIX EQUIPMENTS PVT LTD",
"UNIMO EXPORTS PRIVATE LIMITED",
"UNIMONI FINANCIAL SERVICES LIMITED",
"UNIMONI GLOBAL BUSINESS SERVICES PRIVATELIMITED",
"UNIMRKT RESEARCH PRIVATE LIMITED",
"UNIMUSE RECORDS PRIVATE LIMITED",
"UNINAME MEDI-HUB PRIVATE LIMITED",
"UNINAV DEVELOPERS PRIVATE LIMITED",
"UNINET STRATEGIC ADVISORY LIMITED",
"UNINTERRUPTED SOLUTION PRIVATE LIMITED",
"UNION ADVERTISING SERVICE PRIVATE LIMITED",
"UNION AGROTECH INDIA PRIVATE LIMITED",
"UNION ASSET MANAGEMENT COMPANY PRIVATE LIMITED",
"UNION BANK OF INDIA",
"UNION BANK OF SWITZERLAND",
"UNION BUILDMART PRIVATE LIMITED",
"UNION CHEMICAR INDIA PRIVATE LIMITED",
"UNION CHRISTIAN COLLEGE ALUVA",
"UNION CHRISTIAN MATRICULATION HIGHER SEC SCHOOL",
"UNION CHRISTIAN PUBLIC SCHOOL",
"UNION COMMODITIES PRIVATE LIMITED",
"UNION DRUG CO LTD",
"UNION EDUCATION SOCIETY PRIMARY SCHOOL SOLAPUR",
"UNION ENTERPRISE PRIVATE LIMITED",
"UNION LAND AND BUILDING SOCIETY LIMITED",
"UNION MATRICULATION HIGHER SEC SCHOOL",
"UNION PARK CHEMICALS BOMBAY PRIVATE LIMITED",
"UNION PRESTRESS EXPORTS PRIVATE LIMITED",
"UNION PRESTRESS PRIVATE LIMITED",
"UNION PUBLIC SERVICE COMMISION",
"UNION ROADWAYS CORPORATION",
"UNION ROLLER FLOUR MILLS PRIVATE LIMITED",
"UNIORANGE LIFE CARE PRIVATE LIMITED",
"UNIORBIT PAYMENT SOLUTIONS PRIVATE LIMITED",
"UNI-PAC DISPENSERS PRIVATE LIMITED",
"UNIPACK CONTAINERS PRIVATE LIMITED",
"UNIPACK ENGINEERING PRIVATE LIMITED",
"UNIPACK PACKAGING PRIVATE. LIMITED",
"UNIPACK POLYFOAMS PRIVATE LIMITED",
"UNIPAN PROFILES INDIA PRIVATE LIMITED",
"UNIPAR ENERGY SYSTEMS PRIVATE LIMITED",
"UNIPART SERVICES INDIA PRIVATE LIMITED",
"UNIPARTS INDIA LIMITED",
"UNIPARTS TECHNOLOGIES PRIVATE LIMITED",
"UNIPATCH RUBBER LIMITED",
"UNIPATH SOLUTIONS LLP",
"UNIPATH SPECIALTY LABORATORY LIMITED",
"UNIPE SERVICES PRIVATE LIMITED",
"UNIPEGASUS PROFILES PRIVATE LIMITED",
"UNIPER INDIA PRIVATE LIMITED",
"UNI-PEX PHARMACEUTICALS PRIVATE LIMITED",
"UNIPHARMA AMPOULES AND VIALS PRIVATE LIMITED",
"UNIPHARMA PRODUCTS PRIVATE LIMITED",
"UNIPHI PRIVATE LIMITED",
"UNIPHORE SOFTWARE SYSTEMS PRIVATE LIMITED",
"UNIPHOS ENTERPRISES LIMITED",
"UNIPHOS ENVIROTRONIC PRIVATE. LIMITED.",
"UNIPHOS INTERNATIONAL LIMITED",
"UNIPICK FOODS PRIVATE LIMITED",
"UNIPLY INDUSTRIES LIMITED",
"UNIPOLYMERS INDIA PRIVATE LIMITED",
"UNIPON HOSPITAL & MEDICAL SCIENCES PRIVATE LIMITED",
"UNIPON MERCHANTS PRIVATE LIMITED",
"UNIPOWER TRANSFORMERS PRIVATE LIMITED",
"UNIPRAN SALES PRIVATE LIMITED",
"UNIPRES INDIA PRIVATE LIMITED",
"UNIPRO EDUCATION PRIVATE LIMITED",
"UNIPRO TECH SOLUTIONS PRIVATE LIMITED",
"UNIPRO TECHNO INFRASTRUCTURE PRIVATE LIMITED",
"UNIPRO TECHNOCRATS PRIVATE LIMITED",
"UNIPRODUCTS INDIA LIMITED",
"UNIPROGEN HEALTHCARE LLP",
"UNIPUNCH TOOLINGS P LTD",
"UNIQ DETECTIVE AND SECURITY SERVICES (AP) PRIVATE LIMITED",
"UNIQ DETECTIVE AND SECURITY SERVICES PRIVATE LIMITED",
"UNIQ FACILITY SERVICES PRIVATE LIMITED",
"UNIQ FREIGHT LOGISTICS PRIVATE LIMITED",
"UNIQ NATURAL OILS INDIA PRIVATE LIMITED",
"UNIQ SECURITY SOLUTIONS PRIVATE LIMITED",
"UNIQCORE CONSTRUCTIONS INDIA PRIVATE LIMITED",
"UNIQLEADS RESEARCH PRIVATE LIMITED",
"UNIQLIFE BIOSCIENCES PRIVATE LIMITED",
"UNIQLO INDIA PRIVATE LIMITED",
"UNIQON DECALS INDIA PRIVATE LIMITED",
"UNIQRR TECHNOLOGIES PRIVATE LIMITED",
"UNIQUBIC SOLUTIONS PRIVATE LIMITED",
"UNIQUE ACADEMY PUBLICATIONS PRIVATE LIMITED",
"UNIQUE AFFORDABLE HOMES PRIVATE LIMITED",
"UNIQUE AIR CONDITIONING PROJECTS INDIA PRIVATE LIMITED",
"UNIQUE AIR TRAVELS PVT LTD",
"UNIQUE AIRFREIGHT EXPRESS AND LOGISTICS PRIVATE LIMITED",
"UNIQUE ALANKAR JEWELLERS PRIVATE LIMITED",
"UNIQUE ALLOYS PVT LTD",
"UNIQUE ASSOCIATES",
"UNIQUE AUTO ASSEMBLIES (ICHALKARANJI) PRIVATE LIMITED",
"UNIQUE AUTO FINANCE AND LEASING PRIVATE LIMITED",
"UNIQUE AUTOMOBILES (KOP) PRIVATE LIMITED",
"UNIQUE AUTOMOBILES INDIA PRIVATE LIMITED",
"UNIQUE AUTOMOBILES MAHARASHTRA PRIVATE LIMITED",
"UNIQUE AUTORUBBER UDYOG PRIVATE LIMITED",
"UNIQUE AUTOSALES PRIVATE. LIMITED.",
"UNIQUE AVIATION SERVICES PRIVATE LIMITED",
"UNIQUE BEVERAGES PRIVATE LIMITED",
"UNIQUE BIOTECH LIMITED",
"UNIQUE CARRIERS PRIVATE LIMITED",
"UNIQUE CENTRAL PIPED GASES PRIVATE LIMITED",
"UNIQUE CHAINS PRIVATE LIMITED",
"UNIQUE CHEMOPLANT EQUIPMENTS",
"UNIQUE CIRCLE AUTOMATION PRIVATE LIMITED",
"UNIQUE CIRCLE ENGINEERING PRIVATE LIMITED",
"UNIQUE CIVITECH SYSTEMS PRIVATE LIMITED",
"UNIQUE COAL CORPORATION",
"UNIQUE COLLECTIONS INDIA PRIVATE LIMITED",
"UNIQUE COLOR SORTER PRIVATE LIMITED",
"UNIQUE COMMODITIES PRIVATE LIMITED",
"UNIQUE COMPLEX PRIVATE LIMITED",
"UNIQUE COMPSOL PRIVATE LIMITED",
"UNIQUE CONCRETE TECHNOLOGIES PRIVATE LIMITED",
"UNIQUE CONTRACTS PRIVATE LIMITED",
"UNIQUE CONTROLS PRIVATE LIMITED",
"UNIQUE COOKWARE (INDIA) PRIVATE LIMITED",
"UNIQUE DECOR (INDIA) PRIVATE LIMITED",
"UNIQUE DELTA FORCE SECURITY PRIVATE LIMITED",
"UNIQUE DESIGN AND INSPECTION PRIVATE LIMITED",
"UNIQUE DESIGNERS & ENGINEERS PRIVATE LIMITED",
"UNIQUE DIAGNOSTICE CENTER",
"UNIQUE DIECASTING PRODUCTS PRIVATE LIMITED",
"UNIQUE EDGE DIAMOND TOOLS PRIVATE LIMITED",
"UNIQUE EDUCATIONAL PUBLICATIONS PRIVATE LIMITED",
"UNIQUE ELECTRO ENGINEERS PRIVATE LIMITED",
"UNIQUE ELECTROCAB PRIVATE LIMITED",
"UNIQUE ELECTROTECH PRIVATE LIMITED",
"UNIQUE ELECTROVISION PRIVATE LIMITED",
"UNIQUE ENERGOS PRIVATE LIMITED",
"UNIQUE ENGINEERING AND CONTRACTORS PRIVATE LIMITED",
"UNIQUE ENGINEERING ENTERPRISES PRIVATE LIMITED",
"UNIQUE ENGINEERS PRIVATE LIMITED",
"UNIQUE ENTERPRISE",
"UNIQUE ENVICARE PRIVATE LIMITED",
"UNIQUE ERA INFRA PRIVATE LIMITED",
"UNIQUE ERGONOMIC FURNITURE PRIVATE LIMITED",
"UNIQUE ESTATES DEVELOPMENT CO LIMITED",
"UNIQUE EYE LUXURY APPARELS PRIVATE LIMITED",
"UNIQUE FABCARE PRIVATE LIMITED",
"UNIQUE FARMAID PRIVATE LTD.",
"UNIQUE FARMESTATE PRIVATE LIMITED",
"UNIQUE FINMAN CONSULTANCY PRIVATE LIMITED",
"UNIQUE FLORICULTURE PROJECTS LIMITED",
"UNIQUE FOODS",
"UNIQUE FORGE GUJARAT PVT LTD",
"UNIQUE FORGINGS INDIA PRIVATE LIMITED",
"UNIQUE FREIGHT LINES PRIVATE LIMITED",
"UNIQUE FROZEN FOOD CORPORATION",
"UNIQUE FUR N FABRICS PRIVATE LIMITED",
"UNIQUE GREEN ENERGY TECHNOLOGIES PRIVATE LIMITED",
"UNIQUE GROW GARDEN SOLUTIONS PRIVATE LIMITED",
"UNIQUE HEALTHCARE & MEDICAL SERVICES PRIVATE LIMITED",
"UNIQUE HIGH SCHOOL",
"UNIQUE HIMTECH PRIVATE LIMITED",
"UNIQUE HOUSEKEEPING SERVICES PRIVATE LIMITED",
"UNIQUE HR SERVICES PRIVATE LIMITED",
"UNIQUE HYDROGRAPHIC SYSTEMS PRIVATE LIMITED",
"UNIQUE INDIA CONSTRUCTIONS PRIVATE LIMITED",
"UNIQUE INDUSTRIAL AUTOMATION PRIVATE LIMITED",
"UNIQUE INDUSTRIAL HANDLERS PRIVATE LIMITED",
"UNIQUE INFLATABLES LIMITED",
"UNIQUE INFOWAYS PRIVATE LIMITED",
"UNIQUE INFRA ENGINEERS PRIVATE LIMITED",
"UNIQUE INFRACON PRIVATE LIMITED",
"UNIQUE INFRAENGINEERING INDIA PRIVATE LIMITED",
"UNIQUE INFRASPACE PRIVATE LIMITED",
"UNIQUE INNOVATION PRIVATE. LIMITED",
"UNIQUE INNOVATIONS SPORTING LIFESTYLES PRIVATE LIMITED",
"UNIQUE INSTITUTE OF HIGHER LEARNING PRIVATE LIMITED",
"UNIQUE INTERNATIONAL PVT LTD",
"UNIQUE INTERNATIONL SCHOOL",
"UNIQUE INTERTRADE PRIVATE LIMITED",
"UNIQUE ISPAT PRIVATE LIMITED",
"UNIQUE KIDS MART PRIVATE LIMITED",
"UNIQUE LABELS PRIVATE LIMITED",
"UNIQUE LIFESTYLE PRIVATE LIMITED",
"UNIQUE LOGISTICS INTERNATIONAL INDIA LIMITED",
"UNIQUE MADHUBAN HOMES PRIVATE LIMITED",
"UNIQUE MALLS PRIVATE LIMITED",
"UNIQUE MARCOM PRIVATE LIMITED",
"UNIQUE MARKETING",
"UNIQUE MARMOCHEM PRIVATE LIMITED",
"UNIQUE MEP PROJECTS PRIVATE LIMITED",
"UNIQUE MERCANITLE INDIA LIMITED",
"UNIQUE MERCHANT PVT LTD",
"UNIQUE MICRO COMPUTERS (KARUR) PRIVATE LIMITED",
"UNIQUE MIXERS AND FURNACES PRIVATE LIMITED",
"UNIQUE MOST APPLICATION AND SOLUTIONS PRIVATE LIMITED",
"UNIQUE MULTIFILMS VIRUDHUNAGAR PRIVATE LIMITED",
"UNIQUE NATURAL PRODUCTS PRIVATE LIMITED",
"UNIQUE ORGANICS LIMITED",
"UNIQUE PATHOLOGY LAB PRIVATE LIMITED",
"UNIQUE PERFECT PRODUCTIONS PRIVATE LIMITED",
"UNIQUE PERFORMANCE TECHSOFT PRIVATE LIMITED",
"UNIQUE PHARMACEUTICAL LABORATORIES LIMITED",
"UNIQUE PIPELINE PROJECTS PRIVATE LIMITED",
"UNIQUE PLANT CARE PRIVATE LIMITED",
"UNIQUE POLYPACK PRIVATE LIMITED",
"UNIQUE POTTERIES PRIVATE LIMITED",
"UNIQUE POWER AND AUTOMATION PRIVATE LIMITED",
"UNIQUE POWER CONTROL PRIVATE LIMITED",
"UNIQUE PROCON PRIVATE LIMITED",
"UNIQUE PROPERTIES PRIVATE LIMITED",
"UNIQUE PROPERTY ENTERPRISES PRIVATE LIMITED",
"UNIQUE PUBLISHERS INDIA PRIVATE LIMITED",
"UNIQUE PUNCH SYSTEMS PRIVATE LIMITED",
"UNIQUE REALTY",
"UNIQUE RESOURCES PRIVATE LIMITED",
"UNIQUE ROOF PRIVATE LIMITED",
"UNIQUE SAWS AND MACHINERY PRIVATE LIMITED",
"UNIQUE SECURITY AND INDUSTRIAL SERVICES PRIVATE LIMITED",
"UNIQUE SERVICES PRIVATE LIMITED",
"UNIQUE SHELL MOULD INDIA PRIVATE LIMITED",
"UNIQUE SOLUTIONS",
"UNIQUE SOLUTIONS SERVICES",
"UNIQUE SPEDITORER PRIVATE LIMITED",
"UNIQUE STAR ALLIANCE TOOLS MANUFACTURING PRIVATE LIMITED",
"UNIQUE STEEL AND POWER PRIVATE LIMITED",
"UNIQUE STOCKBRO PRIVATE LIMITED",
"UNIQUE STRUCTURES AND TOWERS LIMITED",
"UNIQUE SWITCHGEARS SERVICES PRIVATE LIMITED",
"UNIQUE SYSTEM SKILLS INDIA PRIVATE LIMITED",
"UNIQUE TAGS PRIVATE LIMITED",
"UNIQUE TEA BORN PRIVATE LIMITED",
"UNIQUE TECHNO SERVICES PRIVATE LIMITED",
"UNIQUE TECHNOSOLUTIONS PRIVATE LIMITED",
"UNIQUE TELE SERVICES INDIA PRIVATE LIMITED",
"UNIQUE TFM SERVICES PRIVATE LIMITED",
"UNIQUE TOOLING SOLUTIONS PRIVATE LIMITED",
"UNIQUE TOOLS PVT. LTD.",
"UNIQUE TOWNSHIP PRIVATE LIMITED",
"UNIQUE TRANSMISSION INDIA PVT LTD",
"UNIQUE UHPC INFRA LLP",
"UNIQUE UNITY CELLCOM PRIVATE LIMITED",
"UNIQUE UV AND LIGHT PRIVATE LIMITED",
"UNIQUE VACATION HOMES PRIVATE LIMITED",
"UNIQUE VASTUSHILP AND PROJECTS PRIVATE LIMITED",
"UNIQUE VM VEHICLES PRIVATE LIMITED",
"UNIQUE WEARS PRIVATE LIMITED",
"UNIQUE WELDING PRODUCTS PVT LTD",
"UNIQUE WELLNESS PRIVATE LIMITED",
"UNIQUE WEPRETAIL PRIVATE LIMITED",
"UNIQUE WINDOWS PRIVATE LIMITED",
"UNIQUECYNAX HEALTHCARE PRIVATE LIMITED",
"UNIQUE-DK DEVELOPERS PRIVATE LIMITED",
"UNIQUEENT ALUMINIUM METAL RECYCLING PRIVATE LIMITED",
"UNIQUEFORCE TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"UNIQUEHIRE CONSULTING LLP",
"UNIQUEIT ENTERPRISE SOLUTIONS PRIVATE LIMITED",
"UNIQUELY SECURITY AND MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"UNIQUEST DEVELOPERS PRIVATE LIMITED",
"UNIQUEST INFRA VENTURES PRIVATE LIMITED",
"UNIQUESTAR LIFE SCIENCES PRIVATE LIMITED",
"UNIQUETECHSOLUTIONS NETWORK PRIVATE LIMITED",
"UNIQUEVET FEEDS PRIVATE LIMITED",
"UNIQUS INDIA PRIVATE LIMITED",
"UNIRE BUSINESS SOLUTIONS PRIVATE LIMITED",
"UNIRICH FOREX PRIVATE LIMITED",
"UNIROAD LOGISTICS PRIVATE LIMITED",
"UNIROCK CHEMICALS PRIVATE LIMITED",
"UNIROSE PHARMA PRIVATE LIMITED",
"UNIROSE TEXTILE PROCESSORS PVT.LTD.",
"UNIROYAL CHEMICALS PRIVATE LIMITED",
"UNIROYAL MARINE EXPORTS LTD",
"UNIRUB TECHNO INDIA PRIVATE LIMITED",
"UNISAFE INSURANCE BROKERS PRIVATE LIMITED",
"UNISAFE SYSTEMS INDIA PRIVATE LIMITED",
"UNISEARCH INDIA (INSTRUMENTS) PRIVATE LIMITED",
"UNISEC MANAGEMENT SERVICES PRIVATE LIMITED",
"UNISEC TESTING SOLUTIONS PRIVATE LIMITED",
"UNISEM AGRITECH PRIVATE LIMITED",
"UNISEM ELECTRONICS PRIVATE LIMITED",
"UNISER INDUSTRIES PRIVATE LIMITED",
"UNISERT MACHINES PRIVATE LIMITED",
"UNISERVE DISTRIBUTORS PRIVATE LIMITED",
"UNISERVE LOGISTICS GATEWAY PRIVATE LIMITED",
"UNISERVE TELECOM PRIVATE LIMITED",
"UNISERVED TECH SOLUTIONS PRIVATE LIMITED",
"UNISERVICE APARTMENT SOLUTIONS LLP",
"UNISEVEN ENGINEERING & INFRASTRUCTURE PRIVATE LIMITED",
"UNISHA ENTERPRISES PRIVATE LIMITED",
"UNISHIP MANAGEMENT PRIVATE LIMITED",
"UNISHIRE URBAN INFRA LIMITED",
"UNISIDDHA TRADING PRIVATE LIMITED",
"UNISIS SYSTEMS AND SOLUTIONS INDIA PRIVATE LIMITED",
"UNISIS TECHGLOBE SERVICES PRIVATE LIMITED",
"UNISK SECURITY & FACILITIES PRIVATE LIMITED",
"UNISO RETAIL INDIA PRIVATE LIMITED",
"UNISOFT GLOBAL SERVICES PRIVATE LIMITED",
"UNISOFT INFOTECH PRIVATE LIMITED",
"UNISOL COMMUNICATIONS PRIVATE LIMITED",
"UNISOL INDIA PRIVATE LIMITED",
"UNISOL IT SOLUTIONS PRIVATE LIMITED",
"UNISOLAR POWER PRIVATE LIMITED",
"UNI-SOLUTIONS BANGALORE PRIVATE LIMITED",
"UNISON AUTO MOTORS PRIVATE LIMITED",
"UNISON AUTOMATION TECHNOLOGIES PRIVATE LIMITED",
"UNISON CONTROLS PRIVATE LIMITED",
"UNISON ENVIRO PRIVATE LIMITED",
"UNISON FORGINGS PRIVATE LIMITED",
"UNISON HOTELS PRIVATE LIMITED",
"UNISON INFRATECH PRIVATE LIMITED",
"UNISON INSURANCE BROKING SERVICES PRIVATE LIMITED",
"UNISON JEWELS PRIVATE LIMITED",
"UNISON LOGISTICS & PACKERS PRIVATE LIMITED",
"UNISON METALS LIMITED",
"UNISON PHARMACEUTICALS PRIVATE LIMITED",
"UNISON PROJECT MANAGEMENT PRIVATE LIMITED",
"UNISON VALVES PRIVATE LIMITED",
"UNISOURCE AUTOMATION PRIVATE LIMITED",
"UNISOURCE CHEMICALS PRIVATE LIMITED",
"UNISOURCE EXIM PRIVATE LIMITED",
"UNISOURCE PAPERS PRIVATE LIMITED",
"UNISOURCE TRADING (INDIA) PRIVATE LIMITED",
"UNISPACE CONTRACTS PRIVATE LIMITED",
"UNISPACE DEVELOPERS PRIVATE LIMITED",
"UNISPANNERS PRIVATE LIMITED",
"UNISPEED PHARMACEUTICALS PRIVATE LIMITED",
"UNISPIN CARD CLOTHING INDIA PRIVATE LIMITED",
"UNISPIRITS ALCOBREW PRIVATE LIMITED",
"UNISSI (INDIA) PVT. LTD.",
"UNISTAL SYSTEMS PRIVATE LIMITED",
"UNISTANZ SOFTWARE PRIVATELIMITED",
"UNISTAR AQUA-TECH PRIVATE LIMITED",
"UNISTAR BIOTECH LIMITED",
"UNISTAR BOOKS PRIVATE LIMITED",
"UNISTAR ENVIRONMENT AND RESEARCH LABS PRIVATE LIMITED",
"UNISTAR FOOTWEARS PRIVATE LIMITED",
"UNISTAR METALS PRIVATE LIMITED",
"UNISTAR MULTIMEDIA LIMITED",
"UNISTAR SHOES PRIVATE LIMITED",
"UNISTAR TECHNOPLAST PRIVATE LIMITED",
"UNISTEEL AND ENGINEERING COMPANY PRIVATE LIMITED",
"UNISTIL ALCOBLENDS PRIVATE LIMITED",
"UNISTONE CAPITAL PRIVATE LIMITED",
"UNISTONE INTERIORS PRIVATE LIMITED",
"UNISTONE PANELS PRIVATE LIMITED",
"UNISTONE PRODUCTS INDIA PRIVATE LIMITED",
"UNISTRAT BUSINESS SOLUTIONS PRIVATE LIMITED",
"UNISTRING TECH SOLUTIONS PRIVATE LIMITED",
"UNISTRONG ENGINEERS PRIVATE LIMITED",
"UNISUN TECHNOLOGIES PRIVATE LIMITED",
"UNISUN TRENDZ PRIVATE LIMITED",
"UNISUR LIFECARE PRIVATE LIMITED",
"UNISYS INDIA PRIVATE LIMITED",
"UNISYS INFOSOLUTIONS PRIVATE LIMITED",
"UNISYSPRO IT SERVICES PRIVATE LIMITED",
"UNITAC ENERGY SOLUTIONS INDIA PRIVATE LIMITED",
"UNITARA MOTORS PRIVATE LIMITED",
"UNITAS HEALTHCARE PRIVATE LIMITED",
"UNITAS LOGISTIX PRIVATE LIMITED",
"UNITAS PHARMACEUTICALS PRIVATE LIMITED",
"UNITASK TECHNOLOGIES (OPC) PRIVATE LIMITED",
"UNITE STACK LINES PRIVATE LIMITED",
"UNITE TECHNIMONT PRIVATE LIMITED",
"UNITEAM INFRA PRIVATE LIMITED",
"UNITEC FIBRES PRIVATE LIMITED",
"UNI-TECH CHEMICALS PRIVATE LIMITED",
"UNI-TECH CNC CENTRE PRIVATE LIMITED",
"UNITECH CORPORATION PRIVATE LIMITED",
"UNITECH COTSPIN LIMITED",
"UNITECH COUNTRY CLUB LIMITED",
"UNITECH COUPLERS INDIA PRIVATE LIMITED",
"UNITECH ENGINEERS PVT LTD",
"UNITECH EXHIBITIONS PRIVATE LIMITED",
"UNITECH FABRICATORS & ENGINEERS PRIVATE LIMITED",
"UNITECH FINCON PVT LTD",
"UNITECH GLASS TECH PRIVATE LIMITED",
"UNITECH HI TECH STRUCTURES LIMITED",
"UNITECH IMAGING SYSTEMS INDIA PRIVATE LIMITED",
"UNITECH INSULATIONS & CABLES (INDIA) PRIVATE LIMITED",
"UNITECH INTERNATIONAL LIMITED",
"UNITECH MERCANTILE PRIVATE LIMITED",
"UNITECH MINING AND MINERALS PRIVATE LIMITED",
"UNITECH MOTORS PRIVATE LIMITED",
"UNITECH PAPER & BOARD INDUSTRIES LTD",
"UNITECH PAPER MILLS PVT LTD",
"UNITECH PHARMACEUTICALS PVT LTD",
"UNITECH PIONEER NIRVANA RECREATION PRIVATE LIMITED",
"UNITECH PLASTO COMPONENTS PRIVATE LIMITED",
"UNITECH POWER CONTROL",
"UNITECH POWER SYSTEMS PRIVATE LIMITED",
"UNITECH POWER TRANSMISSION LIMITED",
"UNITECH SECURITY SYSTEMS PRIVATE LIMITED",
"UNITECH SMARTPROJECTS PRIVATE LIMITED",
"UNITECH TECHNOCRATS PRIVATE LIMITED",
"UNITECH TEXMECH PRIVATE LIMITED",
"UNITECH TRADE SERVICES PRIVATE LIMITED",
"UNI-TECH VALVES&AUTOMATION",
"UNITECH WIRELESS TAMILNADU PRIVATE LIMITED",
"UNITECH WORKHOLDING SYSTEMS PRIVATE LIMITED",
"UNITECH-PIONEER RECREATION LIMITED",
"UNITED (INDIA) METAL FORMINGS PVT LTD",
"UNITED 18 CLOTHING CO",
"UNITED ACCESS FLOORS PRIVATE LIMITED",
"UNITED AERO SERVICES PRIVATE.LIMITED",
"UNITED AGRI TECH PVT LTD",
"UNITED AGRICARE INDIA PRIVATE LIMITED",
"UNITED AGRO BIOTEEK PRIVATE LIMITED",
"UNITED AGRO ENGINEERING PVT LTD",
"UNITED AGRO FROZEN FOODS PRODUCTS PRIVATE LIMITED",
"UNITED AGRO IMPEX PRIVATE LIMITED",
"UNITED AGRO INDUSTRIES",
"UNITED AIR GAS PRIVATE LIMITED",
"UNITED AIRLINE INC",
"UNITED AIRLINES BUSINESS SERVICES PRIVATE LIMITED",
"UNITED AIRLINES INC.",
"UNITED ALACRITY INDIA PRIVATE LIMITED",
"UNITED ALCOBEV PRIVATE LIMITED",
"UNITED ALKALIES AND ACIDS PRIVATE LIMITED",
"UNITED ALLIANCE HEALTHCARE PRIVATE LIMITED",
"UNITED ARAB SHIPPING AGENCY COMPANY INDIA PRIVATE LIMITED",
"UNITED ARTLOGISTICS INDIA PRIVATE LIMITED",
"UNITED ASIAN TRADERS LTD",
"UNITED ASSOCIATE",
"UNITED AUTOMOBILES PRIVATE LIMITED",
"UNITED BANK OF INDIA",
"UNITED BIOCEUTICALS PRIVATE LIMITED",
"UNITED BLEACHERS PRIVATE LIMITED",
"UNITED BRANDS OF SHISHA INDIA PRIVATE LIMITED",
"UNITED BREWERIES LIMITED",
"UNITED BROTHERS",
"UNITED BROTHERS DISTILLERIES PRIVATE LIMITED",
"UNITED BROTHERSS HEALTHCARE SERVICES PRIVATE LIMITED",
"UNITED BUILDWELL PRIVATE LIMITED",
"UNITED BUSINESS XPRESS INDIA PRIVATE LIMITED",
"UNITED CAPZ PRIVATE LIMITED",
"UNITED CARBON SOLUTIONS PRIVATE LIMITED",
"UNITED CARGO AND TRAVELS PRIVATE LIMITED",
"UNITED CARS PRIVATE LIMITED",
"UNITED CHEM",
"UNITED CHEM-ENERGY TRADING PRIVATE LIMITED",
"UNITED CHEMICALS AND INDUSTRIES PRIVATE LIMITED",
"UNITED CHEMIE PRIVATE LIMITED",
"UNITED CIIGMA HOSPITALS HEALTHCARE PRIVATE LIMITED",
"UNITED CIIGMA INSTITUTE OF MEDICAL SCIENCES",
"UNITED CIIGMA INSTITUTE OF MEDICAL SCIENCES PRIVATE LIMITED",
"UNITED COLORS OF BENETON",
"UNITED COLOUR PAPER PRINTS PRIVATE LIMITED",
"UNITED COMPONENTS AND TOOLS PRIVATE LIMITED",
"UNITED COMPOSHEETS PRIVATE LIMITED",
"UNITED COMPUTECH SYSTEMS (INDIA) PRIVATE LIMITED",
"UNITED CONCEPTS & SOLUTIONS PRIVATE LIMITED",
"UNITED CONDUCTORS PRIVATE LIMITED",
"UNITED CONSTRUCTION SYSTEMS PRIVATE LIMITED",
"UNITED CONSTRUCTIONS AND PROJECTS (BANGALORE) PRIVATE LIMITED",
"UNITED CONSULTANCY SERVICES INDIA PRIVATE LIMITED",
"UNITED CONTAINER LINES (INDIA) PRIVATE LIMITED",
"UNITED CONTINENTAL HOLDINGS INC.",
"UNITED CONTROL ENGINEERS INDIA PRIVATE LIMITED",
"UNITED CONVEYOR CORPORATION (INDIA) PRIVATE LIMITED",
"UNITED COOLING SYSTEMS PRIVATE LIMITED",
"UNITED CORES PVT LTD",
"UNITED CRANE COMPONENTS PRIVATE LIMITED",
"UNITED CREDIT LTD",
"UNITED CRITICARE PRIVATE LIMITED",
"UNITED CROP SCIENCE PRIVATE LIMITED",
"UNITED DECORATIVES PRIVATE LIMITED UNIT-2",
"UNITED DELTA CHEMICALS PRIVATE LIMITED",
"UNITED DESCALER PRIVATE LIMITED",
"UNITED DRILLING TOOLS LIMITED",
"UNITED DRY GOODS PRIVATE LIMITED",
"UNITED EDUPLUS PRIVATE LIMITED",
"UNITED EKTA ENGINEERING UDYOG PRIVATE LIMITED",
"UNITED ELECTRIC CO DELHI PRIVATE LIMITED",
"UNITED ELECTRICAL INDUSTRIES LTD",
"UNITED ELECTRICALS AND ENGINEERING PRIVATE LIMITED",
"UNITED ELEMENTS LIMITED",
"UNITED ENGG. & INFRA PRIVATE LIMITED",
"UNITED ENGIFAB PRIVATE LIMITED",
"UNITED ENGINEERING & TECHNOLOGIES PRIVATE LIMITED",
"UNITED ENGINEERING COMPANY PVT LTD",
"UNITED ENGINEERING ENTERPRISES PRIVATE LIMITED",
"UNITED ENGINEERING INDUSTRIES PRIVATE LIMITED",
"UNITED ENGINEERS ALLIANCE PRIVATE LIMITED",
"UNITED ENGINEERS PRIVATE LIMITED",
"UNITED ENGITECH PRIVATE LIMITED",
"UNITED ENVIROTECH PRIVATE LIMITED",
"UNITED EXIM PRIVATE LIMITED",
"UNITED EXPLORATION INDIA PRIVATE LIMITED",
"UNITED FACILITIES & LOGISTIC PRIVATE LIMITED",
"UNITED FARM PRODUCT PRIVATE LIMITED",
"UNITED FARMERS CREAMERY PRIVATE LIMITED",
"UNITED FASHION APPARELS PRIVATE LIMITED",
"UNITED FIBER COMPOSITES PRIVATE LIMITED",
"UNITED FINSEC PRIVATE LIMITED",
"UNITED FIRE EQUIPMENTS PRIVATE LIMITED",
"UNITED FLEXI PACK PRIVATE LIMITED",
"UNITED FOODLINKS PRIVATE LIMITED",
"UNITED FOOT CARE PRIVATE LIMITED",
"UNITED FORTUNE INTERNATIONAL PRIVATE LIMITED",
"UNITED FOUNDRIES PRIVATE LIMITED",
"UNITED FREIGHT CARRIERS PRIVATE LIMITED",
"UNITED FREIGHT MANAGEMENT PRIVATE LIMITED",
"UNITED FRIGO PRIVATE LIMITED",
"UNITED FUTURISTIC TRADE IMPEX PRIVATE LIMITED",
"UNITED GARMENTS PRIVATE LIMITED",
"UNITED GASKETS AND COMPONENTS PRIVATE LIMITED",
"UNITED GEM CREATIONS PRIVATE LIMITED",
"UNITED GENETICS INDIA PRIVATE LIMITED",
"UNITED GENSETS PRIVATE LIMITED",
"UNITED GLASS BOTTLES MANUFACTURING COMPANY PRIVATE LIMITED",
"UNITED GLOBAL ENGINEERING SOLUTIONS PRIVATE LIMITED",
"UNITED GLOBAL LINES PRIVATE LIMITED",
"UNITED GRANITES PRIVATE LIMITED",
"UNITED GREEN HOSPITAL",
"UNITED HEALTH GROUP INFORMATION SERVICES PRIVATE. LIMITED",
"UNITED HEAT TRANSFER PRIVATE LIMITED",
"UNITED HELICHARTERS PRIVATE LIMITED",
"UNITED HI-TECH (INDIA) PRIVATE LIMITED",
"UNITED HITECH PRIVATE LIMITED",
"UNITED HOME ENTERTAINMENT LIMITED",
"UNITED HOSPITAL",
"UNITED HOTELS LIMITED",
"UNITED HR SOLUTIONS PRIVATE LIMITED",
"UNITED HUMM INDIA PRIVATE LIMITED",
"UNITED HVAC PRIVATE LIMITED",
"UNITED IIN PRIVATE LIMITED",
"UNITED INDIA INSURANCE COMPANY LIMITED",
"UNITED INDIA MARKETING PRIVATE LIMITED",
"UNITED INDIA PERIODICAL PVT LTD",
"UNITED INDIA TRADEX PRIVATE LIMITED",
"UNITED INDUSTRIAL COMPONENTS COMPANY PRIVATE LIMITED",
"UNITED INDUSTRIAL ENTERPRISES (INDIA) PRIVATE LIMITED",
"UNITED INDUSTRIES AUTOMOTIVE PLASTIC PRIVATE LIMITED",
"UNITED INDUSTRIES PLASTIC PRIVATE LIMITED",
"UNITED INFRA MINERALS PRIVATE LIMITED",
"UNITED INFRA SERVICES PRIVATE LIMITED",
"UNITED INFRACORE LIMITED",
"UNITED INFRATECH PRIVATE LIMITED",
"UNITED INK AND VARNISH COMPANY PRIVATE LIMITED",
"UNITED INSECTICIDES PRIVATE LIMITED",
"UNITED INSTITUTE OF TECHNOLOGY",
"UNITED INTERNATIONAL IMPORT PRIVATE LIMITED",
"UNITED INTERNATIONAL SCHOOL",
"UNITED IT TECHNICAL SERVICES PRIVATE LIMITED",
"UNITED JEWELLERY MANUFACTURING PRIVATE LIMITED",
"UNITED KNOWLEDGE EDUCATION CONSULTANTS PRIVATE LIMITED",
"UNITED LABORATORIES INDIA PVT LTD",
"UNITED LEADOXIDE PRODUCTS PRIVATE LIMITED",
"UNITED LEASING & INDUSTRIES LIMITED",
"UNITED LINER SHIPPING SERVICES LLP",
"UNITED LOGISTICS",
"UNITED LOGITECH INDIA PRIVATE LIMITED",
"UNITED LUBRICANTS PRIVATE LIMITED",
"UNITED MACHINE CO LTD",
"UNITED MACHINERY STORES PRIVATE LIMITED",
"UNITED MACPRO PRIVATE LIMITED",
"UNITED MANSIONS PRIVATE LIMITED",
"UNITED MARATHON ENGINEERS PRIVATE LIMITED",
"UNITED MARINE EXPORTS PRIVATE LIMITED",
"UNITED MASTERBATCHES PRIVATE LIMITED",
"UNITED MECHANICAL ENGINEERS PRIVATE LIMTED",
"UNITED MEDIAWORKS PRIVATE LIMITED",
"UNITED MEDI-EQUIP PRIVATE LIMITED",
"UNITED MEDISALES PRIVATE LIMITED",
"UNITED METAL INDUSTRIES (BOMBAY) PRIVATE LIMITED",
"UNITED METALIK PRIVATE LIMITED",
"UNITED METALLURGICALS PRIVATE LIMITED",
"UNITED METAMIN PRIVATE LIMITED",
"UNITED MOTORS INDIA LIMITED",
"UNITED MUD CHEM PRIVATE LIMITED",
"UNITED MULTI SPECIALITY HOSPITALS (INDIA) PRIVATE LIMITED",
"UNITED MULTICOLOUR PRINTERS PRIVATE LIMITED",
"UNITED NANOTECH PRODUCTS LIMITED",
"UNITED NATIONS OFFICE FOR PROJECT SERVICES",
"UNITED NEWS OF INDIA",
"UNITED OCEAN SHIP MANAGEMENT PRIVATE LIMITED",
"UNITED OFFICE SYSTEMS PRIVATE LIMITED",
"UNITED OIL DISTRIBUTORS (GUJARAT) PRIVATE LIMITED",
"UNITED OIL MILL MACHINERY AND SPARES PRIVATE LIMITED",
"UNITED ONLINE SOFTWARE DEVELOPMENT INDIA PRIVATE LIMITED",
"UNITED OVERSEAS COURIERS PRIVATE LIMITED",
"UNITED OVERSEAS FACILITIES MANAGEMENT PRIVATE LIMITED",
"UNITED OVERSEAS FINANCE LIMITED",
"UNITED OXYGEN COMPANY PRIVATE LIMITED",
"UNITED PACKAGING CONCEPTS PRIVATE LIMITED",
"UNITED PACKAGING SOLUTIONS (INDIA) PRIVATE LIMITED",
"UNITED PACTEC PRIVATE LIMITED",
"UNITED PARCEL SERVICE",
"UNITED PARTICLE BOARDS INDUSTRIES",
"UNITED PERFUMERS PVT LTD",
"UNITED PESTICHEM AND NONIONICS PRIVATE LIMITED",
"UNITED PESTICIDES RAIPUR PRIVATE LIMITED",
"UNITED PETRO FINANCE LIMITED",
"UNITED PETROCHEM P LIMITED",
"UNITED PETROCHEM PRIVATE LIMITED",
"UNITED PETROFER LIMITED",
"UNITED PHOSPHATE PRIVATE LIMITED",
"UNITED PIPES AND FITTINGS KOCHI PRIVATE LIMITED",
"UNITED PLANNTATIONN LIMITED",
"UNITED PLYWOOD",
"UNITED PLYWOODS LTD",
"UNITED POLY ENGINEERING PRIVATE LIMITED",
"UNITED POLYFAB GUJARAT LIMITED",
"UNITED POLYMER & CHEMICALS PRIVATE LIMITED",
"UNITED POLYMERS",
"UNITED PORTSERVICES PRIVATE LIMITED",
"UNITED PRODUCTS ROLLER FLOUR MILLS INDIA PRIVATE LIMITED",
"UNITED PROJECT CONSTRUCTION LIMITED",
"UNITED PUBLIC SCHOOL",
"UNITED RACING AND BLOODSTOCK BREEDERS LIMITED",
"UNITED RAIL ROAD CONSULTANTS PRIVATE LIMITED",
"UNITED RESTAURANTS LIMITED",
"UNITED ROAD CONSTRUCTIONS PRIVATE LIMITED",
"UNITED ROADS INFRATECH PRIVATE LIMITED",
"UNITED ROYAL CARTONS PRIVATE LIMITED",
"UNITED RUBBER INDUSTRIES INDIA PRIVATE LIMITED",
"UNITED RUBBER PVT LTD",
"UNITED SAFEWAY INDIA PRIVATE LIMITED",
"UNITED SALES AGENCIES (CALCUTTA) PRIVATE LIMITED",
"UNITED SCIENTIFIC ARENA TECHNOLOGY PRIVATE LIMITED",
"UNITED SEALS AND COMPONENTS INDIA PRIVATE LIMITED",
"UNITED SECURITY SOLUTION PRIVATE LIMITED",
"UNITED SERVICES AUTOMOBILE ASSOCIATION",
"UNITED SHELTERS PRIVATE LIMITED",
"UNITED SHIP CHANDLERS",
"UNITED SHIP REPAIRS AND MARINE WORKS PRIVATE LIMITED",
"UNITED SHIPPERS LIMITED",
"UNITED SHIPPING SERVICES PRIVATE LIMITED",
"UNITED SM (INDIA) EXIM PRIVATE LIMITED",
"UNITED SOFTWARE ASSOCIATES PRIVATE LIMITED",
"UNITED SOURCES SERVICE PRIVATE LIMITED",
"UNITED SPECIALITIES PRIVATE LIMITED",
"UNITED SPECIALITY INKS PRIVATE LIMITED",
"UNITED SPIRITS LIMITED",
"UNITED SPORTS TRADERS (DELHI) PRIVATE LIMITED",
"UNITED STATES INDIA EDUCATIONAL FOUNDATION",
"UNITED STATES OF AMERICA",
"UNITED STATES PHARMACOPEIA INDIA PRIVATE LIMITED",
"UNITED STATES STEEL CORPORATION",
"UNITED STEEL BUILDING SYSTEMS PRIVATE LIMITED",
"UNITED STOCK EXCHANGE",
"UNITED SURYA ENERGY LIMITED",
"UNITED SUSTAINABLE DEVELOPMENTS PRIVATE LIMITED",
"UNITED SYSTEMS AND PROJECTS (INDIA) PRIVATE LIMITED",
"UNITED TAR PRODUCTS PVT LTD",
"UNITED TEAM HR CONSULTANTS PRIVATE LIMITED",
"UNITED TECHFAB PRIVATE LIMITED",
"UNITED TECHNICAL AND ECONOMIC SERVICES PRIVATE LIMITED",
"UNITED TECHNO INFO SYSTEMS PRIVATE LIMITED",
"UNITED TECHNO PROJECTS PRIVATE LIMITED",
"UNITED TECHNOLINK PRIVATE LIMITED",
"UNITED TECHNOLOGIES CORPORATION INDIA PRIVATE LIMITED",
"UNITED TECHNOMECH ENGINEERS PRIVATE LIMITED",
"UNITED TELECOM LIMITED.",
"UNITED TELECOM VENTURES PRIVATE LIMITED",
"UNITED TELECOMS LIMITED",
"UNITED TELELINKSBANGALORELIMITED",
"UNITED TELESERVICES LIMITED",
"UNITED TEX CHEM SOLUTIONS PRIVATE LIMITED",
"UNITED TEXTILE MILLS PRIVATE LIMITED",
"UNITED TEXTILES LIMITED",
"UNITED THREADS PRIVATE LIMITED",
"UNITED TOURIST SERVICE PRIVATE LIMITED",
"UNITED TRADECOM PRIVATE LIMITED",
"UNITED TRADELINE PRIVATE LIMITED",
"UNITED TRADING CORPN AND WORKSHOP PRIVATE LIMITED",
"UNITED TRANSMOVERS PRIVATE LIMITED",
"UNITED TRANSTECH PRIVATE LIMITED",
"UNITED TUFF GLASS PRIVATE LIMITED",
"UNITED TYREKRAFTS PVT LTD",
"UNITED UNIVERSITY PRAYAGRAJ",
"UNITED VISA SERVICES PRIVATE LIMITED",
"UNITED WAREHOUSING PRIVATE LIMITED",
"UNITED WATERS INDIA PRIVATE LIMITED",
"UNITED WAY OF MUMBAI",
"UNITED WORKS PRIVATE LIMITED",
"UNITED WORLD HALAL DEVELOPMENT PRIVATE LIMITED",
"UNITED WORLD SCHOOL OF LAW",
"UNITED WORLDWIDE COURIER PRIVATE LIMITED",
"UNITEDLAYER (INDIA) PRIVATE LIMITED",
"UNITEDLEX BPO PRIVATE LIMITED",
"UNITEDONE INFRA PRIVATE LIMITED",
"UNITEDWORLD INSTITUTE OF DESIGN",
"UNITEDWORLD SCHOOL OF BUSINESS",
"UNITEDWORLD WAREHOUSING PRIVATE LIMITED",
"UNITEED POLYPACKS PRIVATE LIMITED",
"UNITEK BIO PRODUCTS (INDIA) PRIVATE LIMITED.",
"UNITEK ENGINEERS PRIVATE LIMITED",
"UNITEK PACKAGING SYSTEMS PRIVATE LIMITED",
"UNITEL ENTERPRISE PRIVATE LIMITED",
"UNITEL FINANCE AND INVESTMENTS PRIVATE LIMITED",
"UNITEL MEDIA PRIVATE LIMITED",
"UNITELWORKS WIRELESS SOLUTION PRIVATE LIMITED",
"UNITEX LOGISTICS INDIA PRIVATE LIMITED",
"UNITEX PLASTICS PRIVATE LIMITED",
"UNITEX SYNTHETICS (INDIA) P LTD",
"UNITEXICA INDUSTRIES PRIVATE LIMITED",
"UNITFORCE TECHNOLOGIES CONSULTING PRIVATE LIMITED",
"UNITHERM ENGINEERS LIMITED",
"UNITHERM INDUCTOWELD (INDIA) PRIVATE LIMITED",
"UNITHOS BUSINESS ADVISORS PRIVATE LIMITED",
"UNITICS INFRASTRUCTURE AND TECHNOLOGY PRIVATE LIMITED",
"UNITIDE MEDICALS PRIVATE LIMITED",
"UNITIZED PACKAGING PRIVATE LIMITED",
"UNITON ENTERPRISE PRIVATE LIMITED",
"UNITON IHUB PRIVATE LIMITED",
"UNITON INFRA PRIVATE LIMITED",
"UNITOP AQUACARE LIMITED",
"UNITOP CHEMICALS PRIVATE LIMITED",
"UNITOP POWER ELECTRONICS PRIVATE LIMITED",
"UNITRADE AQUALINES PRIVATE LIMITED",
"UNITRADE WEAVING ENGINEERING PRIVATE LIMITED",
"UNITRANS INFOTECH SERVICES PRIVATE LIMITED",
"UNITRANS LINES INDIA PRIVATE LIMITED",
"UNITRANS SHIPPING & TRADING PRIVATE LIMITED",
"UNITRON COMPUTER PRIVATE LIMITED",
"UNITRON INSTRUMENTATION TECHNOLOGY PRIVATE LIMITED",
"UNITRON SOFTECH PRIVATE LIMITED",
"UNITRUCKS TRANSPORTATION SOLUTIONS PRIVATE LIMITED",
"UNITRUST KRISHI SERVICES PRIVATE LIMITED",
"UNI-TRUTH PROJECTS PRIVATE LIMITED",
"UNITTAS MULTISPECIALITY HOSPITAL PRIVATE LIMITED",
"UNITUS CAPITAL PRIVATE LIMITED",
"UNITUS WEBSERVICES PRIVATE LIMITED",
"UNITY 3PL SERVICES PRIVATE LIMITED",
"UNITY AHMEDNAGAR IMAGING PRIVATE LIMITED",
"UNITY AURUM CONSTRUCTION PRIVATE LIMITED",
"UNITY AUTOMATION SERVICES PRIVATE LIMITED",
"UNITY BUILD TECH PRIVATE LIMITED",
"UNITY BUILDMART PRIVATE LIMITED",
"UNITY BUILDWELL LIMITED",
"UNITY CARE AND HEALTH SERVICES PRIVATE LIMITED",
"UNITY CONDUCTOR & WIRE CO PVT LTD",
"UNITY CONTRACTING PRIVATE LIMITED",
"UNITY CONTROLS PRIVATE LIMITED",
"UNITY CYLINDERS & EQUIPMENTS PRIVATE LIMITED",
"UNITY DERMA MEDICAL PRIVATE LIMITED",
"UNITY DIAGNOSTICS PRIVATE LIMITED",
"UNITY DISTRIBUTORS PRIVATE LIMITED",
"UNITY DYECHEM PRIVATE LIMITED",
"UNITY ECOGREEN PRIVATE LIMITED",
"UNITY FABRICATORS PRIVATE LIMITED",
"UNITY FABTEXT INDUSTRIES PRIVATE LIMITED",
"UNITY FACILITIES PRIVATE LIMITED",
"UNITY FLEXI PACK GLOBAL PRIVATE LIMITED",
"UNITY FORGE PRIVATE LIMITED",
"UNITY GOODS PRIVATE LIMITED",
"UNITY HEALTH SERVICES PVT LTD",
"UNITY HOSITAL",
"UNITY HOSPITALITY VENTURES PRIVATE LIMITED",
"UNITY IE WORLD PRIVATE LIMITED",
"UNITY INDUSTRIAL AUTOMATION PRIVATE LIMITED",
"UNITY INDUSTRIES PRIVATE LIMITED",
"UNITY JEWEL ARCADE PRIVATE LIMITED",
"UNITY LIFELINE HOSPITAL (INDIA) PRIVATE LIMITED",
"UNITY LOGISTICS AND SHIPPING (INDIA) PRIVATE LIMITED",
"UNITY MANPOWER SOLUTIONS PRIVATE LIMITED",
"UNITY MATRIC HIGHER SECONDARY SCHOOL",
"UNITY MILK & FOOD PRODUCTS PRIVATE LIMITED",
"UNITY MOTORS PRIVATE LIMITED",
"UNITY MOVERS PRIVATE LIMITED",
"UNITY MULTICONS PRIVATE LIMITED",
"UNITY ORGANICS PVT LTD",
"UNITY POLY BARRELS PRIVATE LIMITED",
"UNITY PROJECTS PRIVATE LIMITED",
"UNITY PULP AND PAPERS PRIVATE LIMITED",
"UNITY SECURITY FORCE & TRAINING INSTITUTE",
"UNITY SECURITY FORCE AND TRAINING INSTITUTE",
"UNITY SKY HEIGHTS PRIVATE LIMITED",
"UNITY SMALL FINANCE BANK LIMITED",
"UNITY STONE CRUSHERS PRIVATE LIMITED",
"UNITY STRUCTURAL ENGINEERING DESIGN SERVICES INDIA PRIVATE LIMITED",
"UNITY TEA WAREHOUSING COMPANY PVT LTD",
"UNIV CARE STAINLESS PRIVATE LIMITED",
"UNIVABS SLEEPERS PRIVATE LIMITED",
"UNIVABS SOLUTIONS PRIVATE LIMITED",
"UNIVAN MANAGEMENT INDIA PRIVATE LIMITED",
"UNIVARSAL MEDISYSTEMS PRIVATE LIMITED",
"UNIVASTU INDIA LIMITED",
"UNIVDATOS RESEARCH & ANALYTICS SOLUTIONS PRIVATE LIMITED",
"UNIVEC POLYTECH PRIVATE LIMITED",
"UNIVED HEALTHCARE PRODUCTS PRIVATE LIMITED",
"UNIVEG SEED TECHNOLOGIES PRIVATE LIMITED",
"UNIVEND ASSOCIATES PRIVATE LIMITED",
"UNIVENTIS MEDICARE LIMITED",
"UNIVENTURE INDUSTRIES PRIVATE LIMITED",
"UNIVER SOLUTION PRIVATE LIMITED",
"UNIVERCELL TELECOMMUNICATIONS INDIA PRIVATE LIMITED",
"UNIVERSAL ABRASIVES AND MINERALS PRIVATE LIMITED",
"UNIVERSAL ACOUSTIC AND EMISSION TECHNOLOGIES PRIVATE LIMITED",
"UNIVERSAL AGENCY RAMGARH PRIVATE LIMITED",
"UNIVERSAL AGRO CHEMICAL INDUSTRIES",
"UNIVERSAL AIR PRODUCTS PRIVATE LIMITED",
"UNIVERSAL APPAREL DESIGN PRIVATE LIMITED",
"UNIVERSAL AQUA SOL PRIVATE LIMITED",
"UNIVERSAL ASPHALT PRIVATE LIMITED",
"UNIVERSAL AUDIOLOGY & HEARING PRIVATE LIMITED",
"UNIVERSAL AUTOFOUNDRY LIMITED",
"UNIVERSAL AXIS LIFTING SOLUTIONS PRIVATE LIMITED",
"UNIVERSAL BIOCON PRIVATE LIMITED",
"UNIVERSAL BIOFEEDS HUB PRIVATE LIMITED",
"UNIVERSAL BIOMASS ENERGY PRIVATE LIMITED.",
"UNIVERSAL BITUMINOUS INDUSTRIES PVT LTD",
"UNIVERSAL BOTTLE TRADING CORPORATION PRIVATE LIMITED",
"UNIVERSAL BOTTLER PRIVATE LIMITED",
"UNIVERSAL BRIGHT ENGINEERING SOLUTIONS PRIVATE LIMITED",
"UNIVERSAL BUILDING PRODUCTS PRIVATE LIMITED",
"UNIVERSAL CABLES LIMITED",
"UNIVERSAL CANCER CONQUEST INDIA PRIVATE LIMITED",
"UNIVERSAL CANCER HOSPITAL LIMITED",
"UNIVERSAL CAPITAL SECURITIES PRIVATE LIMITED",
"UNIVERSAL CARE WAREHOUSING PRIVATE LIMITED",
"UNIVERSAL CARGO SOLUTIONS PRIVATE LIMITED",
"UNIVERSAL CARTONS SOLUTIONS PRIVATE LIMITED",
"UNIVERSAL CHEMICALS AND INDUSTRIES PRIVATE LIMITED",
"UNIVERSAL CHEMSOL PRIVATE LIMITED",
"UNIVERSAL CINE TRADES PRIVATE LIMITED",
"UNIVERSAL COLD STORAGE PRIVATE LIMITED",
"UNIVERSAL COLLEGE OF ENGINEERING MUMBAI",
"UNIVERSAL COMFORT PRODUCTS LIMITED",
"UNIVERSAL COMPONENTS DISTRIBUTION PRIVATE LIMITED",
"UNIVERSAL CONFECTIONERY AND FOOD PRODUCTS PRIVATE LIMITED",
"UNIVERSAL CONSTORE PRIVATE LIMITED",
"UNIVERSAL CONSULTING INDIA PRIVATE LIMITED",
"UNIVERSAL CONTAINERS PRIVATE LIMITED",
"UNIVERSAL CONTRACTORS AND ENGINEERS PRIVATE LIMITED",
"UNIVERSAL CORPORATION LIMITED",
"UNIVERSAL CRAFT PAPER PRIVATE LIMITED",
"UNIVERSAL CROP CARE PRIVATE LIMITED",
"UNIVERSAL CURRENCY EXCHANGE INDIA PRIVATE LIMITED",
"UNIVERSAL CYBER INFOWAY PRIVATE LIMITED",
"UNIVERSAL CYLINDERS LIMITED.",
"UNIVERSAL DEVELOPERS AND BUILDERS PRIVATE LIMITED",
"UNIVERSAL DIGITAL CONNECT LIMITED",
"UNIVERSAL DRINKS PRIVATE LIMITED",
"UNIVERSAL DRUG HOUSE PVT LTD",
"UNIVERSAL DYECHEM PRIVATE LIMITED",
"UNIVERSAL EDUCATION FOUNDATION",
"UNIVERSAL EDUCON PRIVATE LIMITED",
"UNIVERSAL EDU-INFRA SERVICES PRIVATE LIMITED",
"UNIVERSAL ENERGIES LIMITED",
"UNIVERSAL ENERGY SOLUTIONS PRIVATE LIMITED",
"UNIVERSAL ENERGY SYSTEMS PRIVATE LIMITED",
"UNIVERSAL ENGINEERING COLLEGE",
"UNIVERSAL ENGINEERS CHENNAI PRIVATE LIMITED",
"UNIVERSAL ERECTORS PRIVATE LIMITED",
"UNIVERSAL EXPOSITIONS LIMITED",
"UNIVERSAL FABRIC PRIVATE LIMITED",
"UNIVERSAL FEEDS (INDIA) PRIVATE LIMITED",
"UNIVERSAL FINE CHEMICALS PRIVATE LIMITED",
"UNIVERSAL FINGROWTH PRIVATE LIMITED",
"UNIVERSAL FIRE AND SAFETY SERVICES LIMITED",
"UNIVERSAL FLEXIBLES PRIVATE LIMITED",
"UNIVERSAL FLYING SERVICES PRIVATE LIMITED",
"UNIVERSAL FOODS PVT LTD",
"UNIVERSAL FORWARDERS INDIA PRIVATE LIMITED",
"UNIVERSAL FURNITURE COMPANY PRIVATE LIMITED",
"UNIVERSAL GRANIMARMO PRIVATE LIMITED",
"UNIVERSAL GROUP OF INSTITUTIONS",
"UNIVERSAL HEALTH SERVICES INC.",
"UNIVERSAL HIGH SCHOOL",
"UNIVERSAL HOSPITAL",
"UNIVERSAL HOTELS & RESORTS PRIVATE LIMITED",
"UNIVERSAL HOUSE PRIVATE LIMITED",
"UNIVERSAL HUNT PRIVATE LIMITED",
"UNIVERSAL IMPORT EXPORT AND HOSPITALITY PRIVATE LIMITED",
"UNIVERSAL INDIA AGRO FOODS",
"UNIVERSAL INDUSTRIAL PLANTS MFG.CO. PRIVATE LIMITED",
"UNIVERSAL INFRA & AGRI OILS PRIVATE LIMITED",
"UNIVERSAL INFRA PRIVATE LIMITED",
"UNIVERSAL INFRAPROJECT PRIVATE LIMITED",
"UNIVERSAL INFRASTRUCTURE COMPANY PRIVATE LIMITED",
"UNIVERSAL ING.LA.BOSCHI PLANTS PRIVATE LIMITED",
"UNIVERSAL INSTRUMENTS MANUFACTURING CO PRIVATE LIMITED",
"UNIVERSAL INSURANCE BROKERS SERVICES PRIVATE LIMITED",
"UNIVERSAL INTERNATIONAL BUSINESS PRIVATE LIMITED",
"UNIVERSAL IRON INDUSTRIES PRIVATE LIMITED",
"UNIVERSAL JET & SEA LOGISTICS PRIVATE LIMITED",
"UNIVERSAL JOURNEYS INDIA PRIVATE LIMITED",
"UNIVERSAL KINGDOM HIGH SCHOOL",
"UNIVERSAL KNITTING MILLS PRIVATE LIMITED",
"UNIVERSAL LEARN TODAY PRIVATE LIMITED",
"UNIVERSAL LUBRICANTS ZINOL PRIVATE LIMITED",
"UNIVERSAL MACHINES LTD",
"UNIVERSAL MAGNOFLUX PVT LTD",
"UNIVERSAL MANPOWER SOLUTIONS PRIVATE LIMITED",
"UNIVERSAL MASTERBATCH LLP",
"UNIVERSAL MECHATRONICS INDIA PRIVATE LIMITED",
"UNIVERSAL MEDICAP LIMITED",
"UNIVERSAL MEP PROJECTS & ENGINEERING SERVICES LIMITED",
"UNIVERSAL METAL COMPANY LIMITED.",
"UNIVERSAL METALLICS PRIVATE LIMITED",
"UNIVERSAL METALLOYS PRIVATE LIMITED",
"UNIVERSAL MINE DEVELOPERS & SERVICE PROVIDERS PRIVATE LIMITED",
"UNIVERSAL MOULD AND DIE INDIA PRIVATE LIMITED",
"UNIVERSAL MULTISPECIALITY HOSPITAL",
"UNIVERSAL MUSIC INDIA PRIVATE LIMITED",
"UNIVERSAL MUSIC PUBLISHING PRIVATE LIMITED",
"UNIVERSAL NAVIGATION PRIVATE LIMITED",
"UNIVERSAL NETWORKS (INDIA) PRIVATE LIMITED",
"UNIVERSAL NURSERIES EXPORTS & IMPORTS PRIVATE LIMITED",
"UNIVERSAL NURSERY SCHOOL",
"UNIVERSAL NUTRISCIENCE PRIVATE LIMITED",
"UNIVERSAL OLEORESINS PRIVATE LIMITED",
"UNIVERSAL ORBITAL SYSTEMS PRIVATE LIMITED",
"UNIVERSAL PERFORMANCE CHEMICALS PRIVATE LIMITED",
"UNIVERSAL PETRO-CHEMICALS LTD",
"UNIVERSAL PHARMACEUTICAL PRIVATE LIMITED",
"UNIVERSAL PHARMACEUTICALS LIMITED",
"UNIVERSAL PIGMENTS PRIVATE LIMITED",
"UNIVERSAL PLACEMENT SERVICES PRIVATE LIMITED",
"UNIVERSAL POLYBAGS INDUSTRIES PRIVATE LIMITED",
"UNIVERSAL POLYCHEM INDIA PRIVATE LIMITED",
"UNIVERSAL POLYMERS PRIVATE LIMITED",
"UNIVERSAL POLYSACK (INDIA) PRIVATE LIMITED",
"UNIVERSAL POWER EQUIPMENT PRIVATE LIMITED",
"UNIVERSAL POWER SYSTEMS PRIVATE LIMITED",
"UNIVERSAL POWER TRANSFORMER PRIVATE LIMITED",
"UNIVERSAL PRECISION SCREWS PRIVATE LIMITED",
"UNIVERSAL PRIDE INTERIORS PRIVATE LIMITED",
"UNIVERSAL PROCESS ENGINEERS PRIVATE LIMITED",
"UNIVERSAL PRODUCT AND SOLUTION",
"UNIVERSAL PRODUCTS PVT LTD",
"UNIVERSAL PRODUCTS SEALS PRIVATE LIMITED",
"UNIVERSAL PROPHYLACTIC PRIVATE LIMITED",
"UNIVERSAL PUBLIC SCHOOL",
"UNIVERSAL RADIATORS LIMITED",
"UNIVERSAL REALTORS PRIVATE LIMITED",
"UNIVERSAL RELOCATION SERVICES & MANAGEMENT",
"UNIVERSAL RELOCATIONS INDIA PRIVATE LIMITED",
"UNIVERSAL ROAD SHIP PRIVATE LIMITED",
"UNIVERSAL ROBOTS (INDIA) PRIVATE LIMITED",
"UNIVERSAL ROOFINGS PRIVATE LIMITED",
"UNIVERSAL SANITATIONS PRIVATE LIMITED",
"UNIVERSAL SAUR URJA PRIVATE LIMITED",
"UNIVERSAL SEAPORT PRIVATE LIMITED",
"UNIVERSAL SECURITIES PRIVATE LIMITED",
"UNIVERSAL SERVICES",
"UNIVERSAL SILK MILLS PRIVATE LIMITED",
"UNIVERSAL SKIN IMPEX PRIVATE LIMITED",
"UNIVERSAL SOMPO GENERAL INSURANCE COMPANY LIMITED",
"UNIVERSAL SPECIALITY CHEMICALS P LIMITEDCAT",
"UNIVERSAL SPORTSBIZ PRIVATE LIMITED",
"UNIVERSAL STARCH CHEM ALLIED LIMITED",
"UNIVERSAL STEEL DISCS PRIVATE LIMITED",
"UNIVERSAL STEEL INFORMATION TECHNOLOGY INDIA PRIVATE LIMITED",
"UNIVERSAL STOCK BROKERS PRIVATE LIMITED",
"UNIVERSAL SURVEY AND ANALYSIS SERVICES PRIVATE LIMITED",
"UNIVERSAL SYSTEMS TECHNOLOGIESI INC",
"UNIVERSAL TECH TRADE PRIVATE LIMITED",
"UNIVERSAL TECHNICAL SYSTEMS (INDIA) PRIVATE LIMITED",
"UNIVERSAL TECHNOLOGY SERVICES PRIVATE LIMITED",
"UNIVERSAL TELECOM INDIA PRIVATE LIMITED",
"UNIVERSAL TEXTILES PRIVATE LIMITED",
"UNIVERSAL THREADS PRIVATE. LIMITED.",
"UNIVERSAL TILLAGE SOLUTIONS PRIVATE LIMITED",
"UNIVERSAL TOOLS INDUSTRIES",
"UNIVERSAL TOYS PRIVATE LIMITED",
"UNIVERSAL TRADING CO.LTD.",
"UNIVERSAL TRAINING SOLUTIONS PRIVATE LIMITED",
"UNIVERSAL TRUSTEES PRIVATE LIMITED",
"UNIVERSAL TRUSTEESHIP SERVICES LIMITED",
"UNIVERSAL TUTORIALS PRIVATE LIMITED",
"UNIVERSAL TWIN LABS",
"UNIVERSAL VICTORY CAARGO",
"UNIVERSAL WATER CHEMICALS PRIVATE LIMITED",
"UNIVERSAL WEATHER AND AVIATION INDIA PRIVATE LIMITED",
"UNIVERSAL YARNS & TEX PRIVATE LIMITED",
"UNIVERSALA AGRI INPUTS INDIA PRIVATE LIMITED",
"UNIVERSALADVISER MIGRATION SERVICES PRIVATE LIMITED",
"UNIVERSALMIND TECHNOLOGIES PRIVATE LIMITED",
"UNIVERSALSHIELD SECURE SERVICES PRIVATE LIMITED",
"UNIVERSE ALLOYS PRIVATE LIMITED",
"UNIVERSE INSPECTION SERVICES PRIVATE LIMITED",
"UNIVERSITIES PRESS(INDIA)PVT LTD",
"UNIVERSITY COLLEGE",
"UNIVERSITY COLLEGE OF ENGINEERING",
"UNIVERSITY COLLEGE OF MEDICAL SCIENCES",
"UNIVERSITY DISPENSARY",
"UNIVERSITY HEALTH CENTER",
"UNIVERSITY INSTITUTE OF TECHNOLOGY",
"UNIVERSITY LIVING ACCOMMODATION PRIVATE LIMITED",
"UNIVERSITY OF AGRICULTURAL AND HORTICULTURAL SCIENCES",
"UNIVERSITY OF AGRICULTURAL SCIENCE - BAN",
"UNIVERSITY OF ALLAHABAD",
"UNIVERSITY OF CALICUT",
"UNIVERSITY OF CHICAGO TRUST",
"UNIVERSITY OF DELHI",
"UNIVERSITY OF ENGINEERING AND MANAGEMENT",
"UNIVERSITY OF ENGINEERING AND TECHNOLOGY",
"UNIVERSITY OF KERALA",
"UNIVERSITY OF LUCKNOW",
"UNIVERSITY OF MADRAS",
"UNIVERSITY OF MUMBAI",
"UNIVERSITY OF MYSORE",
"UNIVERSITY OF NORTH BENGAL",
"UNIVERSITY OF PETROLEUM & ENERGY STUDIES",
"UNIVERSITY OF POONA",
"UNIVERSITY OF PUNE",
"UNIVERSITY OF RAJASTHAN",
"UNIVERSITY OF TOMMOROW",
"UNIVERSUS PHOTO IMAGINGS LIMITED",
"UNIVERSYS TECHNOLOGIES PRIVATE LIMITED",
"UNIVERZSAL FIBC PRIVATE LIMITED",
"UNIVERZSAL POLY PACKKS PRIVATE LIMITED",
"UNIVESO INTEGRATED SOLUTIONS PRIVATE LIMITED",
"UNIVET POHARMACEUTICALS PRIVATE LIMITED",
"UNIVIA PRIVATE LIMITED",
"UNIVIC PRIVATE LIMITED",
"UNIVICTOR HEALTHCARE PRIVATE LIMITED",
"UNIVIEW TECHNOLOGY INDIA PRIVATE LIMITED",
"UNIVISION ELECTROTECH PRIVATE LIMITED",
"UNIVISION SKILLS PRIVATE LIMITED",
"UNIVISION SOFTECH PRIVATE LIMITED",
"UNIVISION TECHNOLOGY CONSULTING PRIVATE LIMITED",
"UNIVISION VET PRIVATE LIMITED",
"UNIVIVE HEALTHCARE PRIVATE LIMITED",
"UNIVLABS TECHNOLOGIES PRIVATE LIMITED",
"UNIVO EDTECH LLP",
"UNIVTECH PRIVATE LIMITED",
"UNIWARE SYSTEMS PRIVATE LIMITED",
"UNIWAY ENGINEERRS PRIVATE LIMITED",
"UNIWELL MEDICARE PRIVATE LIMITED",
"UNIWEND MEDICALS PVT LTD",
"UNIWINDOWS PRIVATE LIMITED",
"UNIWINGS CARGO PRIVATE LIMITED",
"UNIWIRE CABLES INDIA PRIVATE LIMITED",
"UNIWORKS DESIGNS PRIVATE LIMITED",
"UNIWORLD LOGISTICS PRIVATE LIMITED",
"UNIWORLD TRANSERV PRIVATE LIMITED",
"UNIWORLD VISION PRIVATE LIMITED",
"UNIWORTH CONSTRUCTION PRIVATE LIMITED",
"UNIWORTH CREATIONS PRIVATE LIMITED",
"UNIWORTH FINVEST PRIVATE LIMITED",
"UNIWORTH FURNITURE MANUFACTURING CO PRIVATE LIMITED",
"UNIWRAP SYSTEMS PRIVATE LIMITED",
"UNIX BIOTECH",
"UNIX CELLULOSE PRIVATE LIMITED",
"UNIX ELECTRONICS (INDIA) PRIVATE LIMITED",
"UNIX STITCHMACHINES PRIVATE LIMITED",
"UNIX SWITCHGEAR PRIVATE LIMITED",
"UNIYAL CARGO MOVERS PRIVATE LIMITED",
"UNIZA HEALTHCARE LLP",
"UNIZA LIFECARE PRIVATE LIMITED",
"UNIZA TOOLINGS PRIVATE LIMITED",
"UNIZENT TECHNOLOGIES PRIVATE LIMITED",
"UNJHA FORMULATIONS LIMITED",
"UNJHA MUNICIPALITY",
"UNJHA PHARMACEUTICALS PRIVATE LIMITED",
"UNLEAKO OIL SEALS INDIA PRIVATE LIMITED",
"UNLIMIT IOT PRIVATE LIMITED",
"UNLIMITED INNOVATIONS INDIA PRIVATE LIMITED",
"UNLIMITED WATER FUN & ENTERTAINMENT PRIVATE LIMITED",
"UNLIMITEDWP PRIVATE LIMITED",
"UNLOCK TECHNOLOGIES PRIVATE LIMITED",
"UNLOCK WEALTH SECURITIES LIMITED",
"UNM FOUNDATION",
"UNMATCHED SYSTEMS PRIVATE LIMITED",
"UNMETRIC TECHNOLOGIES PRIVATE LIMITED",
"UNMUKTI TECHNOLOGY PRIVATE LIMITED",
"UNN TIMBERTECH PRIVATE LIMITED",
"UNNAO DISTILLERIES AND BREWERIES LIMITED",
"UNNAO INFRADEVELOPERS PRIVATE LIMITED",
"UNNAO ROLLER FLOUR MILLS PRIVATE LIMITED",
"UNNAT AGRO INPUTS PRIVATE LIMITED",
"UNNAT ENGINEERING PRIVATE LIMITED",
"UNNAT FEEDS PRIVATE LIMITED",
"UNNAT INFRATECH PRIVATE LIMITED",
"UNNATHI CNC TECHNOLOGIES PRIVATE LIMITED",
"UNNATHI DIGITALEDGE PRIVATE LIMITED",
"UNNATI CONSTRUCTION PRIVATE LIMITED",
"UNNATI DEVELOPMENT AND TRAINING CENTRE PRIVATE LIMITED",
"UNNATI ENGLISH ACADEMY",
"UNNATI FOREX PRIVATE LIMITED",
"UNNATI ISPAT & MINERAL PRIVATE LIMITED",
"UNNATI LAND DEVELOPERS PRIVATE LIMITED",
"UNNATI LOGISTICS PARK PRIVATE LIMITED",
"UNNATI MOTORSDIVISION OF MICROPARK LOGISTICS PVT LTD",
"UNNATI PHARMACUTICALS PRIVATE LIMITED",
"UNNATI POLYMERS PRIVATE LIMITED",
"UNNATI PU SCIENCE AND COMMERCE COLLEGE",
"UNNATI PUMPS PRIVATE LIMITED",
"UNNATI SILK PRINTS PRIVATE LIMITED",
"UNNATI STONE TOOLS PRIVATE LIMITED",
"UNNATI TRADING AND INVESTMENTS PRIVATE LIMITED",
"UNNATI VEHICLES PRIVATE LIMITED",
"UNNATI VINIMOY PRIVATE LIMITED",
"UNNATTI CONSTRUCTION PRIVATE LIMITED",
"UNNATTI FINSERV PRIVATE LIMITED",
"UNNI MUKUNDAN FILMS PRIVATE LIMITED",
"UNNITIA POLYFAB (INDIA) PRIVATE LIMITED",
"UNO BITUMIX PRIVATE LIMITED",
"UNO DIGITAL PRIVATE LIMITED",
"UNO ELECTRICALS PRIVATE LIMITED",
"UNO INFRACON PRIVATE LIMITED",
"UNO MARINE SERVICES PRIVATE LIMITED",
"UNO METALS LTD",
"UNO MINDA D-TEN INDIA PRIVATE LIMITED",
"UNO MINDA KATOLEC ELECTRONICS SERVICES PRIVATE LIMITED",
"UNO MINDA LIMITED",
"UNO POLYMERS PRIVATE LIMITED",
"UNOBANC PRIVATE LIMITED",
"UNOCOIN TECHNOLOGIES PRIVATE LIMITED",
"UNOFIN TECHNOLOGY LLP",
"UNOGROWTH TECHNOLOGIES PRIVATE LIMITED",
"UNOHQ TECHNOLOGIES PRIVATE LIMITED",
"UNOIDEO TECHNOLOGY PRIVATE LIMITED",
"UNOKEM RESINS PRIVATE LIMITED",
"UNOMAX PENS AND STATIONERY PRIVATE LIMITED",
"UNOMECH ENGINEERS PRIVATE LIMITED",
"UNOR EXIM PRIVATE LIMITED",
"UNORTHODOX DESIGNS PRIVATE LIMITED",
"UNORTHODOX SOLUTIONS PRIVATE LIMITED",
"UNOSACK FLEXIBLE PACKAGING PRIVATE. LIMITED.",
"UNOSOURCE PHARMA LIMITED",
"UNOSTAR VALUE CHAIN PRIVATE LIMITED",
"UNOSTRUCTURES PRIVATE LIMITED",
"UNOSYS SOLUTIONS PRIVATE LIMITED",
"UNOTECH SOFTWARE PRIVATE LIMITED",
"UNOVA APPLIANCES PRIVATE LIMITED",
"UNOVEL INDUSTRIES PRIVATE LIMITED",
"UNOX INDIA PRIVATE LIMITED",
"UNP POLYVALVES INDIA PRIVATE LIMITED",
"UNPC ENERGY SERVICES PRIVATE LIMITED",
"UNPLANNED JOURNEYS PRIVATE LIMITED",
"UNRAVEL DATA SYSTEMS PRIVATE LIMITED",
"UNREAL AI TECHNOLOGIES PRIVATE LIMITED",
"UNROLL FOODS INDIA PRIVATE LIMITED",
"UNS FINVEST ADVISORY PRIVATE LIMITED",
"UNSCRAMBL INDIA PRIVATE LIMITED",
"UNSW GLOBAL INDIA PRIVATE LIMITED",
"UNTHINKABLE SOLUTIONS LLP",
"UNTITLED HOMES PRIVATE LIMITED",
"UNTITLED HOTELS & RESORTS PRIVATE LIMITED",
"UNUM GROUP",
"UNVIRED SOFTWARE INDIA PRIVATE LIMITED",
"UNWAL INFRA PRIVATE LIMITED",
"UNWIND LEARNING LABS PRIVATE LIMITED",
"UNYKLOUD TECHNOLOGIES PRIVATE LIMITED",
"UNYSCAPE INFOCOM PRIVATE LIMITED",
"UOEC CONSULTANTS OPC PRIVATE LIMITED",
"U-ONE ENGINEERING CO",
"UOP INDIA PRIVATE LIMITED",
"UOS INDIA PRIVATE LIMITED",
"UP AGRO",
"UP ASBESTOS LIMITED",
"UP CO OPERATIVE BANK LIMITED",
"UP COOPERATIVE DEPARTMENT",
"UP COOPERATIVE FEDERATION LTD",
"UP FOREST DEPARTMENT",
"UP HARYANA FREIGHT CARRIERS PRIVATE LIMITED",
"UP HOUSING AND DEVELOPMENT BOARD",
"UP INDUSTRIAL CONSULTANTS LIMITED",
"UP KORAUN URJA PRIVATE LIMITED",
"UP MEHRAUNI - I URJA PRIVATE LIMITED",
"UP MEHRAUNI - II URJA PRIVATE LIMITED",
"UP MONEY CORE INVESTMENT PRIVATE LIMITED",
"UP MONEY LIMITED",
"UP NIDESHAK VATNERY PATHOLOGYIST VARANASI",
"UP SAMBAGIYE KARSHI PARSAR ADHIKARI",
"UP SARILA URJA PRIVATE LIMITED",
"UP SHIKSHA ADHIKARI BASIC",
"UP STATE INDUSTRIAL DEVELOPMENT CORPORATION LIMITED",
"UP STATE ROAD TRANSPORT CORPORATION",
"UP STATE WAREHOUSING CORPORATION",
"UP TELEVISION NETWORK PRIVATE LIMITED",
"UP TESTING LABORATORY PRIVATE LIMITED",
"UP TOWN TRADING AND INVESTMENTS LTD",
"UP TOWNSHIP INFRASTRUCTURE PRIVATE LIMITED",
"UP TOWNSHIP PRIVATE LIMITED",
"UP2DATEZ BUSINESS SOLUTIONS PRIVATE LIMITED",
"UPADHAYA VALVES MANUFACTURES PVT LTD",
"UPADHI MAHAVIDYALAYA PILIBHIT",
"UPADHRISH",
"UPADHRISH RESERCHEM LLP",
"UPADHYAY CONTRACTOR PRIVATE LIMITED",
"UPADRO SOFTWARE & SERVICES PRIVATE LIMITED",
"UPAHAR INFRACON PRIVATE LIMITED",
"UPAJ BUILDCON PRIVATE LIMITED",
"UPAJ INVESTMENT AND FINANCE PRIVATE LIMITED",
"UPAJ LEASING AND FINANCE COMPANY PRIVATE LIMITED",
"UPAKAR INFRA PROJECTS PRIVATE LIMITED",
"UPAKARMA AYURVEDA PRIVATE LIMITED",
"UPAL DEVELOPERS PRIVATE LIMITED",
"UPALI HIGHSCHOOL UPALI WADWANI BEED",
"UPAMA CONSTRUCTIONS PRIVATE LIMITED",
"UPANAL CNC PRIVATE LIMITED",
"UPANI INDIA PRIVATE LIMITED",
"UPASANA COLONISERS AND RESORTS PRIVATE LIMITED",
"UPASANA DIAGNOSTIC CENTRE PRIVATE LIMITED",
"UPASANA FINANCE LIMITED",
"UPASANA JEWELLERS PRIVATE LIMITED",
"UPASANA RESOURCES PVT LTD",
"UPASANA VIDHYAVIHAR",
"UPASANA VINAY MANDIR",
"UPASANI SUPER SPECIALITY HOSPITAL PRIVATE LIMITED",
"UPAYA SOCIAL VENTURES INDIA PRIVATE LIMITED",
"UPBRINGING TECHNOLOGIES PRIVATE LIMITED",
"UPC INSTRUMENTS PRIVATE LIMITED",
"UPC SOLAR INDIA PRIVATE LIMITED",
"UPCAP INDIA LIMITED",
"UPCEM ENGINEERING & CONSULTANCY PRIVATE LIMITED",
"UPCOUNTRY LAND DEVELOPERS PRIVATE LIMITED",
"UPCOUNTRY PROMOTERS AND DEVELOPERS PRIVATE LIMITED",
"UPCOUNTRY VEHICLE PRIVATE LIMITED",
"UPCURVE CONSUMER TECHNOLOGIES PRIVATE LIMITED",
"UPDAPT CSR PRIVATE LIMITED",
"UPDATE ADVERTISING AND MARKETING PRIVATE LIMITED",
"UPDATE RECREATION AND GAMING PRIVATE LIMITED",
"UPDATER SERVICES LIMITED",
"UPDATUS INC. SOFTWARE PRIVATE LIMITED",
"UPDOER TECHNOLOGY PRIVATE LIMITED",
"UPEKA VENTURE CATALYST PRIVATE LIMITED",
"UPENDRA SINGH INFRA PROJECT PRIVATE LIMITED",
"UPFORCE TECH",
"UPG TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"UPGEET METALS PRIVATE LIMITED",
"UPHAAR SAREES AND PRINTS PRIVATE LIMITED",
"UPHAM INTERNATIONAL CORPORATION PRIVATE LIMITED",
"UPHAR STEELS LIMITED",
"UPHEALTHY MEDICAL DEVICES PRIVATE LIMITED",
"UPI POLYMERS PRIVATE LIMITED",
"UPI POLYMERS PRIVATE. LIMITED.",
"UPICA PAINTS PRIVATE LIMITED",
"UPICO MEDICARE PRIVATE LIMITED",
"UPKAR AGROFOODS PRIVATE LIMITED",
"UPKAR GOODS TRANSPORT COMPANY PRIVATE LIMITED",
"UPKAR HEALTHCARE INDIA PRIVATE LIMITED",
"UPKAR INTERNATIONAL PRIVATE LIMITED",
"UPKAR LOGISTICS PRIVATE LIMITED",
"UPKAR MERCHANTRY PRIVATE LIMITED",
"UPKAR ORNAMENTS (INDIA) PRIVATE LIMITED",
"UPKAR REMEDIES PRIVATE LIMITED",
"UPKAR RETAIL PRIVATE LIMITED",
"UPKAR ROLLER FLOUR MILLS PRIVATE LIMITED.",
"UPKAR VINIMAY PRIVATE LIMITED",
"UPKARAK TECH SOLUTIONS PRIVATE LIMITED",
"UPKRAM TECHNOLOGIES PRIVATE LIMITED",
"UPL ENVIRONMENTAL ENGINEERS LIMITED",
"UPL GASOCONS PRIVATE LIMITED",
"UPL GLOBAL BUSINESS SERVICES LIMITED",
"UPL LIMITED",
"UPL SUSTAINABLE AGRI SOLUTIONS LIMITED",
"UPL UNIVERSITY OF SUSTAINABLE TECHNOLOGY",
"UPLASTA TECHNOLOGIES PRIVATE LIMITED",
"UPLEADING ENGINEERS PRIVATE LIMITED",
"UPLERS SOLUTIONS PRIVATE LIMITED",
"UPLIFT EVENTS & PROMOTIONS PRIVATE LIMITED",
"UPLIFT MEDIANEWS4U DIGITAL PRIVATE LIMITED",
"UPLIQUOR INDIA PRIVATE LIMITED",
"UPLUS TECHNOLOGY INDIA PRIVATE LIMITED",
"UPM HEAT SHRINK INDIA PRIVATE LIMITED",
"UPM KYMMENE INDIA PRIVATE LIMITED",
"UPMANYU ENTERPRISES PRIVATE LIMITED",
"UPMANYU INDUSTRIES LIMITED",
"UPMINT FINSERV PRIVATE LIMITED",
"UPMOVE CAPITAL PRIVATE LIMITED",
"UPNIDESHAK RASHTRIYA BACHAT LUCKNOW MANDAL",
"UPOWER LOGISTICS INDIA PRIVATE LIMITED",
"UPPAL CHADHA HI-TECH DEVELOPERS PRIVATE LIMITED",
"UPPAL FERROCAST PRIVATE LIMITED",
"UPPAL HOUSING PRIVATE LIMITED",
"UPPAL INDIA PRIVATE LIMITED",
"UPPAL MOTORS PRIVATE LIMITED",
"UPPAL REALTY & INFRASTRUCTURE PRIVATE LIMITED",
"UPPAL RESORTS PRIVATE LIMITED",
"UPPAL SALES & SERVICES PRIVATE LIMITED",
"UPPALS ENGINEERING PROJECTS (INDIA) PRIVATE LIMITED",
"UPPER ASSAM PETROCOKE PRIVATE LIMITED",
"UPPER CLASS FASHIONS PRIVATE LIMITED",
"UPPER CRUST CUISINES AND EVENTS PRIVATE LIMITED",
"UPPER CRUST FOODS PRIVATE LIMITED",
"UPPER CRUST HOSPITALITY PRIVATE LIMITED",
"UPPER DECK RESORTS PRIVATE LIMITED",
"UPPER INDIA SMELTING AND REFINERY WORKS",
"UPPER INDIA STEEL MANUFACTURING & ENGINEERING COMPANY LIMITED",
"UPPER INDIA TRADING COMPANY (DELHI) PRIVATE LIMITED",
"UPPER JILA ADHIKARI BHUMI ADHIPATI KANPUR",
"UPPER PRIMARY SCHOOL GUMTHADA",
"UPPLI BALAJI ENGINEERING CONSTRUCTION COMPANY PRIVATE LIMITED",
"UPPRO KISAN PRODUCER COMPANY LIMITED",
"UPPULURI FARMS PRIVATE LIMITED",
"UPPUTURAMMA HOTELS AND RESORTS PRIVATE LIMITED",
"UPRA CHEM PRIVATE LIMITED",
"UPRATE AUTO COMPONENTS PRIVATE LIMITED",
"UPRIGHT AQUATECHNOLOGIES PRIVATE LIMITED",
"UPRIGHT LEASING AND INFOTECH PRIVATE LIMITED",
"UPRISE ADVERTISING PRIVATE LIMITED",
"UPRISE LAMINATORS PRIVATE LIMITED",
"UPRISE STAFF SOLUTIONS PRIVATE LIMITED",
"UPRISING SCIENCE PRIVATE LIMITED",
"UPRIST SERVICE PORTAL PRIVATE LIMITED",
"U-PROTEC EARTHING PRIVATE LIMITED",
"UPS CONSTRUCTIONS PRIVATE LIMITED",
"UPS EXPRESS PRIVATE LIMITED",
"UPS LOGISTICS PRIVATE LIMITED",
"UPSCALE HEALTHCARE BILLING SOLUTIONS PRIVATE LIMITED",
"UPSCALE MEDIA PRIVATE LIMITED",
"UPSCALE RESEARCH AND CONSULTING PRIVATE LIMITED",
"UPSHOT ENGINEERING LLP",
"UPSIDE CLOUD TECHNOLOGIES (OPC) PRIVATE LIMITED",
"UPSIDE LEARNING SOLUTIONS PRIVATE LIMITED",
"UPSKILL BHARATH CHARITABLE TRUST",
"UPSPL INTEGRATED SERVICES PRIVATE LIMITED",
"UPSQUARE SOLUTIONS PRIVATE LIMITED",
"UPSTANDING CONSTRUCTION PRIVATE LIMITED",
"UPSTOX SECURITIES PRIVATE LIMITED",
"UPSTREAM BUSINESS CONSULTANTS LLP",
"UPSURGE INFOTECH LLP",
"UPSURGE INVESTMENT AND FINANCE LIMITED",
"UPSWIIT PRIVATE LIMITED",
"UPT SPARES & SERVICES PRIVATE LIMITED",
"UPTEC COMPUTER CONSULTANCY LIMITED",
"UPTHINK EDUTECH SERVICES PRIVATE LIMITED",
"UPTIME SALES AND SERVICES",
"UPTODATE IMPEX PRIVATE LTD",
"UPTODATE PLASTIC AND PACKAGINGS PRIVATE LIMITED",
"UPTOP CAREER INSTITUTE PRIVATE LIMITED",
"UPTOWN GALERIA CLOTHING PRIVATE LIMITED",
"UPTRON POWERTRONICS LIMITED",
"UPTURN UNITED CONSULTANCY PRIVATE LIMITED",
"UPTYCS INDIA PRIVATE LIMITED",
"UPVAN HORTICULTURE SERVICES (OPC) PRIVATE LIMITED",
"UPVAN SYNTEX PRIVATE LIMITED",
"UPVC TECHNOCRATS PRIVATE LIMITED",
"UPVENTURES PRIVATE LIMITED",
"UPVOTE CONSULTING SERVICES PRIVATE LIMITED",
"UPWARDS CAPITAL PRIVATE LIMITED",
"UPWISERY INSURANCE BROKERS PRIVATE LIMITED",
"UPWORD FOUNDATION",
"UQUIFA INDIA PRIVATE LIMITED",
"UR AUTOMATION PRIVATE LIMITED",
"UR CFO CONSULTANCY PRIVATE LIMITED",
"UR CHOICE PRODUCTS PRIVATE LIMITED",
"UR DISTREE PRIVATE LIMITED",
"UR OVERSEAS PVT LTD",
"UR REALTORS PRIVATE LIMITED",
"UR SUGAR INDUSTRIES LIMITED",
"UR TRAVEL SHOP PRIVATE LIMITED",
"UR UDYOG PRIVATE LIMITED",
"URA STAR (GEMS) PRIVATE LIMITED",
"URAL HEALTH CARE PRIVATE LIMITED",
"URAN EDUCATION SOCIETYS COLLEGE OF MANAGEMENT AND TECHNOLOGY",
"URAN NAGAR PARISHAD URAN",
"URANIUM CORPORATION OF INDIA LIMITED",
"URANIUM FINVEST COMPANY PVT LTD",
"URANUS ELECTRO TECHNIK PRIVATE LIMITED",
"URANUS REALTORS PRIVATE LIMITED",
"URANUS SECURE SOLUTION INDIA PRIVATE LIMITED",
"URANUS TECHNOLOGIES PRIVATE LIMITED",
"URATOM SOLAR (INDIA) PRIVATE LIMITED",
"URAVI T AND WEDGE LAMPS LIMITED",
"URB ENGINEERING PRIVATE LIMITED",
"URB INDIA BEARING FACTORY AND TRADE PRIVATE LIMITED",
"URBAN AGROFOODS PRIVATE LIMITED",
"URBAN AKARSH INFRASTRUCTURE PRIVATE LIMITED",
"URBAN COMMUNITY HEALTH CENTRE",
"URBAN CO-OPERATIVE BANK LTD",
"URBAN DEVELOPMENT DEPT GOVT OF MAHARAS",
"URBAN ECOINFRA PRIVATE LIMITED",
"URBAN ENGINEER CONSULTANCY (OPC) PRIVATE LIMITED",
"URBAN ENGINEERING ASSOCIATION PRIVATE LIMITED",
"URBAN ENVIRO WASTE MANAGEMENT LIMITED",
"URBAN ENVIROTECH SERVICES PRIVATE LIMITED",
"URBAN ESSENTIALS INDIA PRIVATE LIMITED",
"URBAN EXPORTS PRIVATE LIMITED",
"URBAN FOODMART INDIA PRIVATE LIMITED",
"URBAN FRAME PRIVATE LIMITED",
"URBAN GOURMET INDIA PRIVATE LIMITED",
"URBAN GROOVE FURNITURE PRIVATE LIMITED",
"URBAN HABITATS PT LIMITED",
"URBAN HABITS META",
"URBAN HEALTH RESOURCE CENTRE",
"URBAN HEIGHTS REALTORS PRIVATE LIMITED",
"URBAN HI-BREED FARM LTD",
"URBAN HIVES INDIA PRIVATE LIMITED",
"URBAN IMPEX PRIVATE LIMITED",
"URBAN IMPROVEMENT CO PRIVATE LIMITED",
"URBAN INFRACON PRIVATE LIMITED",
"URBAN INFRAPROJECTS PRIVATE LIMITED",
"URBAN INFRASTRUCTURE CONSTRUCTIONS PRIVATE LIMITED",
"URBAN INFRASTRUCTURE VENTURE CAPITAL LIMITED",
"URBAN INFRAVENTURES PRIVATE LIMITED",
"URBAN JUNGGLE PRIVATE LIMITED",
"URBAN KHICHDI PRIVATE LIMITED",
"URBAN KSHETRA INFRASTRUCTURE PRIVATE LIMITED",
"URBAN LADDER HOME DECOR SOLUTIONS LIMITED",
"URBAN LAND BUILDING TAXEN DEPT",
"URBAN LAND DEVELOPERS PRIVATE LIMITED",
"URBAN LAND MANAGEMENT PRIVATE LIMITED",
"URBAN LANDPRO INFRATECH PRIVATE LIMITED",
"URBAN LIVING FINANCE INDIA LIMITED",
"URBAN LIVING VENTURES PRIVATE LIMITED",
"URBAN LOCAL BODY DIRECTORATE ULB NAGAR NIGAM",
"URBAN MANAGEMENT CENTRE",
"URBAN MASS TRANSIT COMPANY LIMITED",
"URBAN MEDIQUIP PRIVATE LIMITED",
"URBAN MOBILITY TRANSFORMATION SERVICES PRIVATE LIMITED",
"URBAN MONEY PRIVATE LIMITED",
"URBAN MONK PRIVATE LIMITED",
"URBAN NIRVANA WELLNESS CORPORATION LLP",
"URBAN ONLINE SERVICES PRIVATE LIMITED",
"URBAN PANDIT INFRA-CONSULTANTS PRIVATE LIMITED",
"URBAN PARATHA PRIVATE LIMITED",
"URBAN PARIBAHAN SERVICES PRIVATE LIMITED",
"URBAN REALITY BUSINESS VENTURES PRIVATE LIMITED",
"URBAN REALTY PRIVATE LIMITED",
"URBAN RETAIL PRIVATE LIMITED",
"URBAN SALONS LLP",
"URBAN SCIENCE APPLICATIONS PRIVATE LIMITED",
"URBAN SPACE PROJECTS PRIVATE LIMITED",
"URBAN SPICES PRIVATE LIMITED",
"URBAN SQUARE HOME STYLE TRADE PRIVATE LIMITED",
"URBAN STORES (WINES) PVT LTD",
"URBAN STREET INTERNATIONAL PRIVATE LIMITED",
"URBAN TEKNO-SYSTEMS PRIVATE LIMITED",
"URBAN TREE HOUSING PROJECTS LLP",
"URBAN TREE INFRASTRUCTURES PRIVATE LIMITED",
"URBAN VOGUE INDIA PRIVATE LIMITED",
"URBANA FACILITY MAINTENANCE PRIVATE LIMITED",
"URBANAAC INFRASTRUCTURES PRIVATE LIMITED",
"URBANAC PROJECTS PRIVATE LIMITED",
"URBANAID INFRATECH PRIVATE LIMITED",
"URBANBED COMFORT PRODUCTS PRIVATE LIMITED",
"URBANCLAP TECHNOLOGIES INDIA PRIVATE LIMITED",
"URBANDOOR INFRATECH PRIVATE LIMITED",
"URBANDOOR MARRKETING PRIVATE LIMITED",
"URBANE INDIA PRIVATE LIMITED",
"URBANETEK HVAC ENG PRIVATE LIMITED",
"URBANFRESH AGROFOOD PRODUCTS PRIVATE LIMITED",
"URBANIZE DEVELOPERS (INDIA) PRIVATE LIMITED",
"URBANKISAAN FARMS PRIVATE LIMITED",
"URBANLEAF INFRASTRUCTURE PRIVATE LIMITED",
"URBANO CREATIONS PRIVATE LIMITED",
"URBANPIPER TECHNOLOGY PRIVATE LIMITED",
"URBANPLUS INFRABUILD PRIVATE LIMITED",
"URBANPUNJAB FOODS PRIVATE LIMITED",
"URBANRISE AN ALLINCE GROUP",
"URBANRISE PROJECTS LLP",
"URBANTRANDZ PRIVATE LIMITED",
"URBANWAY INFRA PRIVATE LIMITED",
"URBANWELL RESOURCE MANAGEMENT PRIVATE LIMITED",
"URBANWEST SPACES PRIVATE LIMITED",
"URBANWRK PRIVATE LIMITED",
"URBANZEN INDIA PRIVATE LIMITED",
"URBASY APPARELS PRIVATE LIMITED",
"URBE TECHNOVATIVES PRIVATE LIMITED",
"URBENO PRIVATE LIMITED",
"URBI ENTERPRISES PRIVATE LIMITED",
"URBKRA BEARINGS PRIVATE LIMITED",
"URBO VENTURES PRIVATE LIMITED",
"URBTECH INDIA DEVELOPERS PRIVATE LIMITED",
"URC CONSTRUCTION PRIVATE LIMITED",
"URC CREATIVE DEVELOPERS PRIVATE LIMITED",
"URD MOTORS PRIVATE LIMITED",
"URDHVAM ENVIRONMENTAL TECHNOLOGIES PRIVATE LIMITED",
"URDU HIGH SCHOOL & JR COLLEGE",
"URDU HIGH SCHOOL KATOL",
"URDU PRI M C SCHOOL M C ARVI",
"URDU PRIMARY SAIFIYA SCHOOL AMRAVATI",
"URDU V M DAVAT NAGAR KABNOOR KABNUR HATKANANGALE KOLHAPUR",
"URDU VIDYA MANDIR DAWATNAGAR KABNUR",
"URDU VIDYA MANDIR RENDAL",
"UREATAC INDIA PRIVATE LIMITED",
"UREHA MARKETING PRIVATE LIMITED",
"URETEK INDIA PRIVATE LIMITED",
"URICH GRACE INFRASTRUCTURES PRIVATE LIMITED",
"URIHK PHARMACEUTICAL PRIVATE LIMITED",
"URJA BATTERIES LIMITED",
"URJA BIO SYSTEM PRIVATE LIMITED",
"URJA CHILD DEVELOPMENT CENTRE",
"URJA COMMUNICATIONS PRIVATE LIMITED",
"URJA CONSULTANCY & ENGINEERING SERVICES PRIVATE LIMITED",
"URJA DEVELOPERS AND BEAUTIFICATIONS PRIVATE LIMITED",
"URJA DIGITAL WORLD LIMITED",
"URJA FABRICS PRIVATE LIMITED",
"URJA FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"URJA FEEDS PRIVATE LIMITED",
"URJA FOODS AND AGRO PRIVATE LIMITED",
"URJA GLOBAL LIMITED",
"URJA INFRASTRUCTURE (INDIA) PRIVATE LIMITED",
"URJA INVESTMENT",
"URJA MULTITRADE PRIVATE LIMITED",
"URJA PACKAGING PRIVATE LIMITED",
"URJA PLASTMET PRIVATE LIMITED",
"URJA PRODUCTS PRIVATE LIMITED",
"URJA SEALANTS PRIVATE LIMITED",
"URJA TECHNIQUES INDIA PRIVATE LIMITED",
"URJAA EXIM PRIVATE LIMITED",
"URJALAYA RENEWABLE PRIVATE LIMITED",
"URJANET ENERGY SOLUTIONS PRIVATE LIMITED",
"URJANKUR SHREE DATTA POWER COMPANY LIMITED",
"URJANKUR SHREE TATYASAHEB KORE WARANA POWER COMPANY LIMITED",
"URJASTROT ENTERPRISE PRIVATE LIMITED",
"URJASVINI SOLUTION (OPC) PRIVATE LIMITED",
"URJATECH PRIVATE LIMITED",
"URJATHERM ENTERPRISES PRIVATE LIMITED",
"URJAY ELECTRICALS PRIVATE LIMITED",
"URJAYANT ENGINEERING PRIVATE LIMITED",
"URJEX BOILERS PRIVATE LIMITED",
"URJIKA CONSULTING & ENGINEERING SOLUTIONS PRIVATE LIMITED",
"URJITA ELECTRONICS PRIVATE LIMITED",
"URJITA FINANCIAL SERVICES PRIVATE LIMITED",
"URMI HEALTHCARE PRIVATE LIMITED",
"URMI REAL ESTATE PRIVATE LIMITED",
"URMI SOLAR SYSTEMS LIMITED",
"URMI TRENCHLESS TECHNOLOGY PRIVATE LIMITED",
"URMIE UVTECH INDIA PRIVATE LIMITED",
"URMIL HOSPITAL",
"URMIL PROPERTIES AND INVESTMENT PRIVATE LIMITED",
"URMIL TECHNOFAB PRIVATE LIMITED",
"URMILA BUILDERS PRIVATE LIMITED",
"URMILA BUILDTECH PRIVATE LIMITED",
"URMILA FOODS PRIVATE LIMITED",
"URMILA HANDLOOMS PRIVATE LIMITED",
"URMILA INTERNATIONAL SERVICES PRIVATE LIMITED",
"URMILA PACKTECH PRIVATE LIMITED",
"URMILA POLYMER PRIVATE LIMITED",
"URMILA R C P PROJECTS PRIVATE LIMITED",
"URMILA SILKS PRIVATE LIMITED",
"URMILA TEXTILES PRIVATE LIMITED",
"URMILLA ENTERPRISES PRIVATE LIMITED",
"URMILLA INFRA SOLUTIONS PRIVATE LIMITED",
"URMILON SILK MILLS PRIVATE LIMITED",
"URMIN FOODS PRIVATE LIMITED",
"URMIN PRODUCTS PRIVATE LIMITED",
"URMIT CHEMICALS PRIVATE LIMITED",
"URNA EVOLVED LIVING PRIVATE LIMITED",
"URO FERRO PRIVATE LIMITED",
"URO STONE RESEARCH CENTRE PRIVATE LIMITED",
"UROLANA TEXTILES PRIVATE LIMITED",
"UROLIME TECHNOLOGIES PRIVATE LIMITED",
"URONEEL INDIA PRIVATE LIMITED",
"UROSTAR ELECTRICALS INDIA PRIVATE LIMITED.",
"UROTEC SOLUTIONS PRIVATE LIMITED",
"UROTECK ENGINEERS PRIVATE LIMITED",
"UROVISION DIAGNOSTICS & RESEARCH CENTRE PRIVATE LIMITED",
"URPAY SOLUTIONS PRIVATE LIMITED",
"URR HOUSING AND CONSTRUCTION PRIVATE LIMITED",
"URS CERTIFICATION LIMITED",
"URS CONSULTING (INDIA) PRIVATE LIMITED",
"URS CONSULTING INDIA PRIVATE LIMITED",
"URS KAR SERVICE CENTRE PRIVATE LIMITED",
"URS PRODUCTS AND TESTING PRIVATE LIMITED",
"URS SALES AND SERVICES PRIVATE LIMITED",
"URS SCOTT WILSON INDIA PRIVATE LIMITED",
"URS SYSTEMS PRIVATE LIMITED",
"URS VERIFICATION PRIVATE LIMITED",
"URSALA HOSPITAL",
"URSCHEL INDIA TRADING PRIVATE LIMITED",
"URSS TECHSERVICES PRIVATE LIMITED",
"URUDAVAN INVESTMENT AND TRADING PRIVATE LIMITED",
"URUMU DHANALAKSHMI COLLEGE-",
"URUVAKKU TECHONOLOGY PRIVATE LIMITED",
"URVARA AGRO BIOTECH PRIVATE LIMITED",
"URVARAA IVF MEDICAL RESEARCH CENTRE PRIVATE LIMITED",
"URVARAK ABHIKARAN NEEMUCH PRIVATE LIMITED",
"URVASHI PULP AND PAPER MILLS PRIVATE LIMITED",
"URVASHI SAREES P LTD",
"URVASI INN PRIVATE LIMITED",
"URVASI MERCANTILE PRIVATE LIMITED",
"URVEEKA CHEMTECK PRIVATE LIMITED",
"URVESH PSYLLIUM INDUSTRIES LIMITED",
"URVI ENTERPRISE",
"URVI IMPEX PVT LTD",
"URVI OVERSEAS TRADE SERVICES PRIVATE LIMITED",
"URVIZA COMTRADE PRIVATE LIMITED",
"US AGRITECH PRIVATE LIMITED",
"US AMINO PRIVATE LIMITED",
"US AUTOCONTROLS PRIVATE LIMITED",
"US CHEMTACK INDIA PRIVATE LIMITED",
"US EMBASSY",
"US FOR DY SECRETARY ACCTTS MP VIDHAN SABHA BHOPAL MADHYA PRADESH",
"US FREIGHT EXPRESS PRIVATE LIMITED",
"US SERVICES GROUP PRIVATE LIMITED",
"US SOBO WELLNESS PRIVATE LIMITED",
"US TECH SOLUTIONS PRIVATE LIMITED",
"US TECHNOLOGY INTERNATIONAL PRIVATE LIMITED",
"US TECHNOLOGY RESOURCES PRIVATE LIMITED",
"US&VG HEALTCARE PRIVATE LIMITED",
"US4 BUSINESS SOLUTIONS PRIVATE LIMITED",
"USA COLLEGE OF PHYSIOTHERAPHY",
"USA GATEWAY INDIA PRIVATE LIMITED",
"USA INFOTECH ADVISORS PRIVATE LIMITED",
"USAE EQUIPMENT PRIVATE LIMITED",
"USAKA ELECTROTECH PRIVATE LIMITED",
"USAKA HYDRO POWERS PRIVATE LIMITED",
"USAKA INDUSTRIAL COMPONENTS PRIVATE LIMITED",
"USAM CADSOFT (INDIA) PRIVATE LIMITED",
"USAM CONCEPTS PRIVATE LIMITED",
"USAM TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"USB BUILDTECH PRIVATE LIMITED",
"USB FINANCIAL CORPORATION LIMITED",
"USBCO STEELS PVT LTD",
"USBROADCAST INDIA PRIVATE LIMITED",
"USC HOLOGRAMS PRIVATE LIMITED",
"USE FABRICATORS PRIVATE LIMITED",
"USEKIWI INFOLABS PRIVATE LIMITED",
"USER EXPERIENCE DESIGN CONSULTING PRIVATE LIMITED",
"USEREADY TECHNOLOGY PRIVATE LIMITED",
"USEREXPERIOR TECHNOLOGIES PRIVATE LIMITED",
"USF PROTECTION SERVICES PRIVATE LIMITED",
"USFOUR SALES PRIVATE LIMITED",
"USG AUTOMOBILES PRIVATE LIMITED",
"USG LAB'S PRIVATE LIMITED",
"USG TECH SOLUTIONS LIMITED",
"USG TRADERS PRIVATE LIMITED",
"USHA AGRO INDUSTRIES PRIVATE LIMITED",
"USHA AIR PRODUCTS LIMITED",
"USHA AMORPHOUS METALS LIMITED",
"USHA ARMOUR PRIVATE LIMITED",
"USHA BALA CHITS PRIVATE LIMITED",
"USHA BANSAL NURSING HOME PRIVATE LIMITED",
"USHA BRECO LIMITED",
"USHA BRECOMPANY LIMITED",
"USHA BUILDING MATERIALS PRIVATE LIMITED",
"USHA CAPACITORS LIMITED",
"USHA CARDIAC CENTRE LIMITED",
"USHA CARRIERS PRIVATE LIMITED",
"USHA COMPRESSORS PRIVATE LIMITED",
"USHA CONDUCTORS PRIVATE. LIMITED.",
"USHA CORPORATION LIMITED",
"USHA CYCLE PRIVATE LIMITED",
"USHA ECOM PRIVATE LIMITED",
"USHA ELECTRIC POWER PRIVATE LIMITED",
"USHA ELECTRODES PRIVATE LIMITED",
"USHA ELECTROTRADE AGENCIES INDIAPRIVATE LIMITED",
"USHA ELEVATORS PRIVATE LIMITED",
"USHA EXIM PRIVATE LIMITED",
"USHA FABS PRIVATE LTD",
"USHA FABTEX PRIVATE LIMITED",
"USHA FASHIONS PRIVATE LIMITED",
"USHA FASTENERS PRIVATE LIMITED",
"USHA FENESTRA SYSTEMS PRIVATE LIMITED",
"USHA FINANCIAL SERVICES LIMITED",
"USHA FIRE SAFETY EQUIPMENTS PRIVATE LIMITED",
"USHA FUELS PRIVATE LIMITED",
"USHA GARMENTS MANUFACTURING COMPANY PRIVATE LIMITED",
"USHA GENERAL INDUSTRIAL CORPORATION",
"USHA GRIHA NIRMAN PRIVATE LIMITED",
"USHA HATCHERIES PRIVATE LIMITED",
"USHA HYDRO DYNAMICS LTD",
"USHA INTERNATIONAL LIMITED",
"USHA LUBES PVT LTD",
"USHA MARTIN LIMITED",
"USHA MARTIN TELEMATICS LTD",
"USHA MARTIN VENTURES LIMITED",
"USHA METAL INDUSTRIES PVT LTD",
"USHA MICRONS PRIVATE LIMITED",
"USHA MULLAPUDI CARDIAC CENTRE",
"USHA POLY CRAFTS PRIVATE LIMITED",
"USHA PRECISION PRODUCTS PRIVATE LIMITED",
"USHA RAMA COLLEGE OF ENGINEERING AND TECHNOLOGY",
"USHA SHRIRAM ENTERPRISES PRIVATE LIMITED",
"USHA SHRIRAM WATER PURIFIERS PRIVATE LIMITED",
"USHA SINGLA",
"USHA SPHERO CAST PRIVATE LIMITED",
"USHA SPINCOAT PRIVATE LIMITED",
"USHA STUD AND AGRICUTURAL FARMS PRIVATE LIMITED",
"USHA TEA COMPANY PVT. LTD.",
"USHA TRADELINKS PRIVATE LIMITED",
"USHA TUBES AND PIPES PVT.LTD.",
"USHA TUBES PRIVATE LIMITED",
"USHA WELDS LIMITED",
"USHA YARNS LIMITED",
"USHAFINLEASE INDIA PRIVATE LIMITED",
"USHAHKAL ABHINAV INSTITUTE OF MEDICAL SCIENCES",
"USHAKIRON MOVIES PRIVATE LIMITED",
"USHANKK ENTERRPRISES PRIVATE LIMITED",
"USHANTI COLOUR CHEM LIMITED",
"USHARAJE HIGHSCHOOL KOLHAPUR",
"USHARITU INDUSTRIES PRIVATE LIMITED",
"USHAS FABRICATORS PRIVATE LIMITED",
"USHASRI COTTON & GINNING MILLS PRIVATE LIMITED",
"U-SHIN INDIA PRIVATE LIMITED",
"USHMA BADHIR SECONDARY SCHOOL",
"USHNISH AGROTECH PRIVATE LIMITED",
"USHODAYA ENTERPRISES PRIVATE LIMITED",
"USHODAYA PUBLICATIONS",
"USHODAYA SUPER MARKETS PRIVATE LIMITED",
"USHTA INFINITY CONSTRUCTION COMPANY PRIVATE LIMITED",
"USHTA TE CONSULTANCY SERVICES LLP",
"USHTARA ENGINEERING PRIVATE LIMITED",
"USHUR TECHNOLOGIES PRIVATE LIMITED",
"USIBC GLOBAL PRIVATE LIMITED",
"USICA TEKNOSERVICES PRIVATE LIMITED",
"USINOR",
"USK AGRO SCIENCES",
"USK BALAJI PLAST PRIVATE LIMITED",
"USK CHEMICALS PRIVATE LIMITED",
"USK ELECTRONICS PRIVATE LIMITED",
"USK EXPORTS PRIVATE LIMITED",
"USK HEALTH CARE PRIVATE LIMITED",
"USK LPG PRIVATE LIMITED",
"USKY LOGISTICS PRIVATE LIMITED",
"USL COECLERICI LOGISTICS PRIVATE LIMITED",
"USM BUSINESS-INDIA",
"USM HEALTHCARE",
"USM INFRASTRUCTURES PRIVATE LIMITED",
"USMANI INFRASTRUCTURE PRIVATE LIMITED",
"USMANIYA URDU HIGH SCHOOL",
"USMART EDUCATION LIMITED",
"USOFT TECHNOLOGIES INDIA PRIVATE LIMITED",
"U-SOLAR CLEAN ENERGY SOLUTIONS PRIVATE LIMITED",
"USONIX INSPECTION SOLUTIONS PRIVATE LIMITED",
"USP ENTERPRISES",
"USP HYDRO ENERGY LIMITED",
"USP PACKAGING SOLUTIONS PRIVATE LIMITED",
"USP SCS INDIA PRIVATE LIMITED",
"USP SOFTWARE SOLUTIONS PRIVATE LIMITED",
"USP STUDIOS PRIVATE LIMITED",
"USP TRADING AND MANUFACTURING PRIVATE LIMITED",
"USPC JAIN PUBLIC SCHOOL",
"USPI SECURITY AND INVESTIGATION PRIVATE LIMITED",
"USR TYRES AND TREADS PRIVATE LIMITED",
"USRA UDYOG PRIVATE LIMITED",
"USS ENGINEERING SERVICES PRIVATE LIMITED",
"USS MOVERS PRIVATE LIMITED",
"USSR TELECOM PRIVATE LIMITED",
"UST GLOBAL",
"UST GLOBAL INFORMATION TECHNOLOGY PARKS PRIVATE LIMITED",
"UST GLOBAL TECHNOLOGY SERVICES INDIA PRIVATE LIMITED",
"UST SOFTWARE INDIA PRIVATE LIMITED",
"USTAD ART AND DESIGN PRIVATE LIMITED",
"USTER TECHNOLOGIES INDIA PRIVATE LIMITED",
"USTHI HOSPITAL RESEARCH CENTRE BHUBAN",
"USTUDIOS AND POST PRODUCTIONS PRIVATE LIMITED",
"USUI SUSIRA INTERNATIONAL PRIVATE LIMITED",
"USUPSO RETAIL INDIA PRIVATE LIMITED",
"USV PRIVATE LIMITED",
"UT BIKES LIMITED",
"UT PUMPS AND SYSTEMS PRIVATE LIMITED",
"UT WORLDWIDE INDIA PRIVATE LIMITED",
"UTAH TECH LABS PRIVATE LIMITED",
"UTAIR INDIA PRIVATE LIMITED",
"UTAM SYNERCON PRIVATE LIMITED",
"UTC MARKETING PRIVATE LIMITED",
"UTC OVERSEAS INDIA PRIVATE LIMITED",
"UTD E-SERVICES PRIVATE LIMITED",
"UTE DESALADORA CHENNAI OPERACION Y MANTENIMIENTO",
"UTECH BUSINESS SOLUTIONS PRIVATE LIMITED",
"UTECH DEVELOPERS LIMITED",
"UTECH DEVELOPERS PRIVATE LIMITED",
"UTECH FASTEN PRIVATE LIMITED",
"UTECH ROLLS EQUIPMENTS PRIVATE LIMITED",
"U-TECH RUBBER PRODUCTS PRIVATE LIMITED",
"UTECH TRADING COMPANY",
"UTEGRATION INDIA PRIVATE LIMITED",
"UTEKAR FOREX AND TRAVELS PRIVATE LIMITED",
"UTESHIYA MEDICARE PRIVATE LIMITED",
"UTH BEVERAGE FACTORY PRIVATE LIMITED",
"UTH HEALTHCARE LIMITED",
"UTHAN EDUCATIONAL TRUST",
"UTHISHTAA SOLUTIONS PRIVATE LIMITED",
"UTHRA LOGISTICS PRIVATE LIMITED",
"UTI ALTERNATIVES PRIVATE LIMITED",
"UTI ASSET MANAGEMENT COMPANY LIMITED",
"UTI ASSET MANAGEMENT COMPANY PRIVATE LIMITED",
"UTI INFRASTRUCTURE TECHNOLOGY AND SERVICES LIMITED",
"UTI RETIREMENT SOLUTIONS LIMITED",
"UTI TRUSTEE COMPANY PRIVATE LIMITED",
"UTI VENTURE FUNDS MANAGEMENT COMPANY PRIVATE LIMITED.",
"UTILIDEX SOFTWARE PRIVATE LIMITED",
"UTILITE POWER PRODUCTS PRIVATE LIMITED",
"UTILITY AGENCY PRIVATE LIMITED",
"UTILITY ELECTRICALS AND PNEUMATICS PRIVATE LIMITED",
"UTILITY FORMS PRIVATE LIMITED",
"UTILITY INFRAPROJECTS SERVICES PRIVATE LIMITED",
"UTILITY PIPING SYSTEMS PRIVATE LIMITED",
"UTILITY POWER TEST",
"UTILITY POWERTECH LIMITED",
"UTIMRAJ COMMERCIAL PRIVATE LIMITED",
"UTIQUE ENTERPRISES LIMITED",
"UTISHTA BHARATA PRIVATE LIMITED",
"UTIVAC HEALTHCARE PRIVATE LIMITED",
"UTIZ GLOBAL VENTURES PRIVATE LIMITED",
"UTKAL ALUMINA INTERNATIONAL LIMITED",
"UTKAL ASHOK HOTEL CORPORATION LIMITED",
"UTKAL AUTO ENTERPRISER PRIVATE LIMITED",
"UTKAL AUTOCOACH PRIVATE LIMITED",
"UTKAL AUTOMOBILES LIMITED",
"UTKAL AUTOMOTIVE PRIVATE LIMITED",
"UTKAL BRICKS & INDUSTRIES PRIVATE LIMITED",
"UTKAL BUILDING MATERALS PVT LTD",
"UTKAL CANCER SEVA TRUST HOSPITALITY",
"UTKAL COAL LIMITED",
"UTKAL ENERGY RESOURCES LIMITED",
"UTKAL ENGINEERS PVT LTD",
"UTKAL FACILITY SERVICES PRIVATE LIMITED",
"UTKAL FEEDS PRIVATE LIMITED",
"UTKAL FISHERIES PRIVATE LIMITED",
"UTKAL FLOUR MILLS PVT LTD",
"UTKAL FLOUR MILLS(ROURKELA) PVT LTD",
"UTKAL FOUNDRY AND ENGINEERING CO PVT LTD",
"UTKAL GALVANIZERS LIMITED",
"UTKAL GRAMEEN BANK",
"UTKAL HEALTHCARE PRIVATE LIMITED",
"UTKAL INFRASTRUCTURE DEVELOPMENT CONSORTORIUM PRIVATE LIMITED",
"UTKAL LABS PRIVATE LIMITED",
"UTKAL LAXMI ENGINEERS PRIVATE LIMITED",
"UTKAL LUMBERS PRIVATE LIMITED",
"UTKAL MAIL PRAKASANI PRIVATE LIMITED",
"UTKAL MATRIX PRIVATE LIMITED",
"UTKAL METALLICS LIMITED",
"UTKAL MOULDINGS PVT LTD",
"UTKAL POLYWEAVE INDUSTRIES PVT LTD",
"UTKAL PROJECTS PRIVATE LIMITED",
"UTKAL PUMPS PRIVATE LIMITED",
"UTKAL SALES PRIVATE LIMITED",
"UTKAL TECHNOCARE PRIVATE LIMITED",
"UTKAL TYPE FOUNDRY & MACHINERIES PRIVATE LIMITED",
"UTKAL UDYAN PRIVATE LIMITED",
"UTKAL UNIVERSITY",
"UTKARASH PETRO CHEMICALS PRIVATE LIMITED",
"UTKARSH AGROCHEM PRIVATE LIMITED",
"UTKARSH BARS PRIVATE LIMITED",
"UTKARSH BRUSH PRIVATE LIMITED",
"UTKARSH C & F SERVICES PRIVATE LIMITED",
"UTKARSH CARRIERS PRIVATE LIMITED",
"UTKARSH HEALTH CARE INDIA PRIVATE LIMITED",
"UTKARSH INCORP PRIVATE LIMITED",
"UTKARSH INDIA LIMITED",
"UTKARSH INFOTECH PRIVATE LIMITED",
"UTKARSH KONCEPT PRIVATE LIMITED",
"UTKARSH MANDIR",
"UTKARSH MICRO FINANCE PRIVATE LIMITED",
"UTKARSH MINERALS PRIVATE LIMITED",
"UTKARSH MOTOTECH PRIVATE LIMITED",
"UTKARSH NAGARI SAHAKARI PATSANSTHA LIMITED",
"UTKARSH NURSING COLLEGE",
"UTKARSH PRIVATE LIMITED",
"UTKARSH PROFESSIONAL SERVICES PRIVATE LIMITED",
"UTKARSH SERVICES PRIVATE LIMITED",
"UTKARSH SFATIK LIMITED",
"UTKARSH SMALL FINANCE BANK LIMITED",
"UTKARSH TRADING AND HOLDINGS LIMITED",
"UTKARSH TRANSMISSIONS PRIVATE LIMITED",
"UTKARSH TRANSPORT PRIVATE LIMITED",
"UTKARSHA ALUMINIUM DHATU NIGAM LIMITED",
"UTKARSHA AUTO PARTS PRIVATE LIMITED",
"UTKARSHA EDUCARE PRIVATE LIMITED",
"UTKARSHA NAGARI SAH PATSANSTHA LTD",
"UTKARSHA VIDYALAYA",
"UTKARSHA VIDYALAYA JUNIOR COLLEGE",
"UTKRAM CHEMICALS PVT LTD",
"UTKRANTI SOLUTIONS PRIVATE LIMITED",
"UTKRISHT TRADE SOLUTIONS PRIVATE LIMITED",
"UTKRISHT UTILITIES PRIVATE LIMITED",
"UTKRISHT VATIKA FASHIONS PRIVATE LIMITED",
"UTKRISHTA AUTOMOTIVE PRIVATE LIMITED",
"UTKRUSSHTA INFRACON PRIVATE LIMITED",
"UTL MOVERS WORLDWIDE SERVICES PRIVATE LIMITED",
"UTL TECHNOLOGIES LIMITED",
"UTLRA VISION HIGH SCHOOL",
"UTOMI SYNERGY PRIVATE LIMITED",
"UTOPEIA COMMUNICATIONZ PRIVATE LIMITED",
"UTOPIA DECOR PRIVATE LIMITED",
"UTOPIA FOREX PRIVATE LIMITED",
"UTOPIA HOSPITALITY PRIVATE LIMITED",
"UTOPIA INDIA PRIVATE LIMITED",
"UTOPIA TRAVEL SERVICES PRIVATE LIMITED",
"UTOPIAN DREAMS PRIVATE LIMITED",
"UTOPIAN HEALTHCARE PRIVATE LIMITED",
"UTOPIATECH PRIVATE LIMITED",
"UTOPUS INSIGHTS INDIA PRIVATE LIMITED",
"U-TOURIZMO PRIVATE LIMITED",
"UTPAL INFRASTRUCTURE PRIVATE LIMITED",
"UTPALAKSHI AGRO PRODUCTS PRIVATE LIMITED",
"UTRACON ENGINEERING SERVICES PRIVATE LIMITED",
"UTRADE SOLUTIONS PRIVATE LIMITED",
"U-TRANS INDIA PRIVATE LIMITED",
"UTRI HR SERVICES PRIVATE LIMITED",
"UTRYAN ENERGY AGRA PRIVATE LIMITED",
"UTRYAN ENERGY PRIVATE LIMITED",
"UTS (INDIA) PVT LTD",
"UTS EXPRESS CARGO PRIVATE LIMITED",
"UTS SAFETY SYSTEMS PRIVATE LIMITED",
"UTSAH ENGINEERING PRIVATE LIMITED",
"UTSARG LOGISTICAL SOLUTIONS PRIVATE LIMITED",
"UTSAV AUTOMOBILES PRIVATE LIMITED",
"UTSAV BUSINESS SOLUTIONS PRIVATE LIMITED",
"UTSAV EXIM LIMITED",
"UTSAV FASHION PRIVATE LIMITED",
"UTSAV FASION PRIVATE LIMITED",
"UTSAV FINTECH PRIVATE LIMITED",
"UTSAV INDIA EXPORTS PRIVATE LIMITED",
"UTSAV INDIA LIMITED",
"UTSAV INDUSTRIES PVT LTD",
"UTSAV INFRA PROJECTS PRIVATE LIMITED",
"UTSAV INTERNATIONAL BRAND PRIVATE LIMITED",
"UTSAV LOGISTICS PRIVATE LIMITED",
"UTSAV MALL MANAGEMENT COMPANY PRIVATE LIMITED",
"UTSAV PARIVAHAN PRIVATE LIMITED",
"UTSAV PAYTECH PRIVATE LIMITED",
"UTSAV RESORT PVT LTD",
"UTSAV SECURITIES PRIVATE LIMITED",
"UTSAV SEEDS PRIVATE LIMITED",
"UTSAV VINIMAY PRIVATE LIMITED",
"UTSAVGIRI CMPUTERS AND ELECTRONIC INDUSTRIES PRIVATE LIMITED",
"UTSAVJI PROTEINS PRIVATE LIMITED",
"UTSSAV CZ GOLD JEWELS LIMITED",
"UTSTARCOM INDIA TELECOM PRIVATE LIMITED",
"UTSV ENTERPRIISE PRIVATE LIMITED",
"UTT INDIA PRIVATE LIMITED",
"UTTAM AGRO FOODS (INDIA) P LTD",
"UTTAM AGRO INPUTS PRIVATE LIMITED",
"UTTAM AIR PRODUCTS PVT.LTD.",
"UTTAM BHARAT ELECTRICALS PRIVATE LIMITED",
"UTTAM CABLE PRIVATE LIMITED",
"UTTAM COMMERCIAL CO LTD",
"UTTAM CON INFRASTRUCTURE COMPANY PRIVATE LIMITED",
"UTTAM CYLINDERS PRIVATE LIMITED",
"UTTAM DHATU AND ISPAT PRIVATE LIMITED",
"UTTAM DISTILLERIES LIMITED",
"UTTAM EXPORTS PRIVATE LIMITED",
"UTTAM FINALEASE PVT LTD",
"UTTAM FOOD INFRASTRUCTURE PARK PRIVATE LIMITED",
"UTTAM FOUNDRIES AND ISPAT PRIVATE LIMITED",
"UTTAM GEMS PRIVATE LIMITED",
"UTTAM INDUSTRIAL ENGINEERING LIMITED",
"UTTAM INSTITUTE OF MANAGEMENT STUDIES",
"UTTAM MARKETING AND SALES PRIVATE LIMITED",
"UTTAM MEDICAL CONCIERGE PRIVATE LIMITED",
"UTTAM ORGANIC FERTICHEM PRIVATE LIMITED",
"UTTAM PHOSPHATES PRIVATE LIMITED",
"UTTAM PLASTOMERS PRIVATE LIMITED",
"UTTAM POLYRUBS INDIA PRIVATE LIMITED",
"UTTAM POWER TOOLS PRIVATE LIMITED",
"UTTAM PRESTRESS PROCESSES PRIVATE LIMITED",
"UTTAM RICE AND SEEDS PRIVATE LIMITED",
"UTTAM SALES PRIVATE LIMITED",
"UTTAM SHARE BROKERS PRIVATE LIMITED",
"UTTAM SHOE & CHAPPAL",
"UTTAM SINGH TEA COMPNAY PRIVATE LIMITED",
"UTTAM STEEL ALLOYS PRIVATE LIMITED",
"UTTAM STRIPS LIMITED",
"UTTAM SUCROTECH INTERNATIONAL PRIVATE LIMITED",
"UTTAM SUCROTECH LIMITED",
"UTTAM SUGAR MILLS LIMITED",
"UTTAM TOYOTA",
"UTTAMENERGY LIMITED",
"UTTAN VIVIDH LAKSHYEE SHIKSHAN SANSTHA",
"UTTAR BANGA DAIRY PRIVATE LIMITED",
"UTTAR BHARAT HYDRO POWER PRIVATE LIMITED",
"UTTAR BIHAR GRAMIN BANK",
"UTTAR BUNIYADI ASHRAMSHALA VADI BHENSROT",
"UTTAR BUNIYADI KANYA VIDHYALAY",
"UTTAR BUNIYADI VIDYALAYA",
"UTTAR GUJARAT VIJ COMPANY LIMITED",
"UTTAR HARYANA BIJLI VITRAN NIGAM LIMITED",
"UTTAR KSHETRIYA SAMAJ VIKAS KENDRA",
"UTTAR PRADESH AWAS VIKASH NIGAM",
"UTTAR PRADESH BEEJ VIKAS NIGAM",
"UTTAR PRADESH BHARAT SCOUT AND GUIDE",
"UTTAR PRADESH BOARD OF REVENUE",
"UTTAR PRADESH CO OPERATIVE BANK LIMITED",
"UTTAR PRADESH COMMERCIAL TAXES DEPARTMENT",
"UTTAR PRADESH COOPERATIVE SUGAR FACTORIES FEDERATION LIMITED",
"UTTAR PRADESH EDUCATION DEPARTMENT",
"UTTAR PRADESH JAL NIGAM",
"UTTAR PRADESH METRO RAIL CORPORATION LIMITED",
"UTTAR PRADESH NATIONAL HEALTH MISSION",
"UTTAR PRADESH POWER CORPORATION LIMITED",
"UTTAR PRADESH RAJKIYA NIRMAN NIGAM",
"UTTAR PRADESH RAJKIYA NIRMAN NIGAM LTD",
"UTTAR PRADESH RAJYA NIRMAN SAHKARI SANGH LIMITED",
"UTTAR PRADESH RAJYA VIDYUT UTPADAN NIGAM LIMITED",
"UTTAR PRADESH SACHIVALAYA SATKAR SEWA SANSTHA",
"UTTAR PRADESH SAFETY GLASS WORKS (P) LTD.",
"UTTAR PRADESH SHAKARI GRAM VIKAS BANK LTD",
"UTTAR PRADESH SMALL INDUSTRIES CORPPRATION LIMITED",
"UTTAR PRADESH STATE BRIDGE CORPN LIMITED",
"UTTAR PRADESH STATE ROAD TRANSPORT CORPORATION",
"UTTAR PRADESH STATE TOURISM DEVELOPMENT CORPORATION LIMITED",
"UTTAR URJA PROJECTS PRIVATE LIMITED",
"UTTARA FOODS AND FEEDS PRIVATE LIMITED",
"UTTARA IMPEX PRIVATE LIMITED",
"UTTARA INFOSOLUTIONS PRIVATE LIMITED",
"UTTARAK INDUSTRIES PRIVATE LIMITED",
"UTTARAKHAND AYURVED UNIVERSITY",
"UTTARAKHAND ENGINEERING PRODUCTS PRIVATE LIMITED",
"UTTARAKHAND FOREST DEVELOPMENT CORPORATION",
"UTTARAKHAND FOREST RESOURCE MANAGEMENT PROJECT",
"UTTARAKHAND GRAMIN BANK",
"UTTARAKHAND GRAMYA VIKAS SAMITI",
"UTTARAKHAND JAL SANSTHAN",
"UTTARAKHAND JAL VIDYUT NIGAM LIMITED",
"UTTARAKHAND METRO RAIL URBAN INFRASTRUCTURE AND BUILDING CONSTRUCTION CORPORATION LIMITED",
"UTTARAKHAND PEYJAL SANSADHAN VIKAS EVAM NIRMAN NIGAM",
"UTTARAKHAND POWER CORPORATION LIMITED",
"UTTARAKHAND PROJECT DEVELOPMENT AND CONSTRUCTION CORPORATION LIMITED",
"UTTARAKHAND PURV SAINIK KALYAN NIGAM LIMITED",
"UTTARAKHAND SEEDS & TARAI DEVELOPMENT CORP. LIMITED",
"UTTARAKHAND STATE AIDS CONTROL SOCIETY",
"UTTARAKHAND STATE DISASTER MANAGEMENT AUTHORITY",
"UTTARAKHAND STONE PRODUCTS PRIVATE LIMITED",
"UTTARAKHAND TOURISM DEVELOPMENT BOARD OFFICE",
"UTTARAKHAND TRANSPORT CORPORATION",
"UTTARAKHAND UTHAN SAMITI UUS",
"UTTARANCHAL ALUMS PRIVATE LIMITED",
"UTTARANCHAL AUTOMOBILES PRIVATE LIMITED",
"UTTARANCHAL BIOTECH LIMITED",
"UTTARANCHAL CABLE AND CONDUCTOR PRIVATE LIMITED",
"UTTARANCHAL ISPAT LIMITED",
"UTTARANCHAL PACKAGING PRIVATE LIMITED",
"UTTARAYAAN COLD STORAGE PRIVATE LIMITED",
"UTTARAYAN FOODS PRIVATE. LIMITED.",
"UTTARAYAN STEEL PRIVATE LIMITED",
"UTTARKASHI STEELS PRIVATE LIMITED",
"UTTARPARA MODEL SCHOOL",
"UTTER GUJARAT VIJ COMPANY LIMITED",
"UTTERLY ALLIED (INDIA) PRIVATE LIMITED",
"UTTEZ DIGITAL INDIA PRIVATE LIMITED",
"UTTHEJANA TRADING AND SERVICES PRIVATE LIMITED",
"UTTHUNGA TECHNOLOGIES PRIVATE LIMITED",
"UTTORAYON TEA INDUSTRIES PRIVATE LIMITED",
"UTTRA HOTELS AND CONSTRUCTION PRIVATE LIMITED",
"UTTRAKHAND AYURVED UNIVERSITY",
"UTTRAKHAND CONSTRUCTION CO PVT LTD",
"UTTRAKHAND ETHYL CHEM PRIVATE LIMITED",
"UTTRAKHAND PARIVHAN NIGAM",
"UTTRANCHAL BUILDWELL PRIVATE LIMITED",
"UTTRANCHAL COMPUTERS PRIVATE LIMITED",
"UTTRANCHAL METALS PRIVATE LIMITED",
"UTTRANCHAL PHARMACEUTICALS PRIVATE LIMITED",
"UTTRANCHAL PULP AND PAPER MILLS PRIVATE LIMITED",
"UTTRAYAN FINANCIAL SERVICES PRIVATE LIMITED",
"UTTURKARS WOOD CULTURE",
"UTU TECHSOLUTIONS PRIVATE LIMITED",
"U-TURN APPARELS PRIVATE LIMITED",
"U-TURN PROMOTERS PRIVATE LIMITED",
"UTV SOFTWARE COMMUNICATIONS PRIVATE LIMITED",
"UTVYAKTA SOLUTIONS PRIVATE LIMITED",
"UTZ INDIA PRIVATE LIMITED",
"UURMI SYSTEMS PRIVATE LIMITED",
"UV ASSET RECONSTRUCTION COMPANY LIMITED.",
"UV ASSOCIATES PRIVATE LIMITED",
"UV COLOUR PRIVATE LIMITED",
"UV GARMENTS PRIVATE LIMITED",
"UV GLOBAL GEO SOLUTIONS PRIVATE LIMITED",
"UV HITECH PRIVATE LIMITED",
"UV HOMES PRIVATE LIMITED",
"UV NIRMAN PRIVATE LIMITED",
"UV PRINTERS INDIA PRIVATE LIMITED",
"UV REALTORS PRIVATE LIMITED",
"UV TECHNOLOGIES PRIVATE LIMITED",
"UV&W PRODUCTS PRIVATE LIMITED",
"UVA INFRA PRIVATE LIMITED",
"UVA LIDKOPING PRIVATE LIMITED",
"UVA WEALTH PRIVATE LIMITED",
"UVAAM CREATION PRIVATE LIMITED",
"U-VALSET INDUSTRIES PRIVATE LIMITED",
"UVAN CONSUMER PRIVATE LIMITED",
"UVB HEALTHCARE PRIVATE LIMITED",
"UVIK TECHNOLOGIES PRIVATE LIMITED",
"UVIMAC ENGINEERING SOLUTIONS PRIVATE LIMITED",
"UVIRAJ GLOBAL PRIVATE LIMITED",
"UVIRAJ IMPEX PRIVATE LIMITED",
"UVIZZYZ CREATION PRIVATE LIMITED",
"UVKAN HEALTHCARE PRIVATE LIMITED",
"UVR NATURAL FOODS PRIVATE LIMITED",
"UVS CHEMICALS PRIVATE LIMITED",
"UVS INDIA PRIVATE LIMITED",
"UVS STEELS PRIVATE LIMITED",
"UVTECH BIOSCIENCES PRIVATE LIMITED",
"UVXCEL IT SOLUTIONS PRIVATE LIMITED",
"UWC AND CT VENTURES PRIVATE LIMITED",
"UWC FOOD PRIVATE LIMITED",
"UWORLD INDIA PRIVATE LIMITED",
"UWS ENVIRO-TECH PRIVATE LIMITED",
"UWS INTEGRATED LOGISTICS PRIVATE LIMITED",
"UWT LEVEL CONTROL INDIA PRIVATE LIMITED",
"UX INSIGHTS LLP",
"UXC INDIA IT SERVICES PRIVATE LIMITED",
"UXLI CONSULTING PRIVATE LIMITED",
"UXMAL MARINE SERVICES PRIVATE LIMITED",
"UXREACTOR INDIA PRIVATE LIMITED",
"UYIR AGRICULTURE PRIVATE LIMITED",
"UZHAVAR PAZAHMUDIR NILAYAM PRIVATE LIMITED",
"UZHAVARBUMI AGRO PRODUCTS PRIVATE LIMITED",
"UZHNAQ TECHNOLOGY PRIVATE LIMITED",
"UZIO TECHNOLOGY INDIA PRIVATE LIMITED",
"UZMI LABORATORIES INDIA PRIVATE LIMITED",
"UZON HOSPITALITY AND ENTERTAINMENT PRIVATE LIMITED",
"V - DIAMOND LIMITED",
"V RETAIL LIMITED",
"V - TECH ELASTOMERS PRIVATE LIMITED",
"V - VILLAGE RESORTS PRIVATE LIMITED",
"V & H INFRA PRIVATE LIMITED",
"V & M PRINTS PRIVATE LIMITED",
"V & M TOOLINGS PRIVATE LIMITED",
"V & S INDIA PRIVATE LIMITED",
"V & S SEAIR LOGISTICS PRIVATE LIMITED",
"V & V MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"V 2 S FARMS PRIVATE LIMITED",
"V 2 TECH VENTURES PRIVATE LIMITED",
"V 5 INFOTECH PRIVATE LIMITED",
"V A G HOLDINGS PRIVATE LIMITED",
"V A INTERNATIONAL PRIVATE LIMITED",
"V A PRINT CRAFTS PRIVATE LIMITED",
"V ACCESS INDIA PRIVATE LIMITED",
"V- ADD INFRA PRIVATE LIMITED",
"V AND O LOGISTICS PRIVATE LIMITED",
"V AND S INTERNATIONAL PVT LTD",
"V AND V COMPTECH SYSTEMS PRIVATE LIMITED",
"V AUTOMAT AND INSTRUMENTS PRIVATE LIMITED",
"V B BUSINESS CENTRE PRIVATE LIMITED",
"V B DESAI FINANCIAL SERVICES LTD",
"V B INFOTECH INDIA PRIVATE LIMITED",
"V B K WOODS (INDIA) PRIVATE LIMITED",
"V B PATEL CHEST INSTT",
"V B PRAJAPATI HEALTHCARE PRIVATE LIMITED",
"V B RESORTS PRIVATE LIMITED",
"V BAZAAR RETAIL PRIVATE LIMITED",
"V BAZAR GENERAL STORE",
"V BELIEVERS MARKETING PRIVATE LIMITED",
"V BHADU INFRABUILD PRIVATE LIMITED",
"V C CORPORATE ADVISORS PRIVATE LIMITED",
"V C JHAVERI REALTY PRIVATE LIMITED",
"V C MOTORS PRIVATE LIMITED",
"V C PHARMACEUTICALS (INDIA) PRIVATE LIMITED",
"V C PLASTIC PRIVATE LIMITED",
"V C SHAH PATEL SERVICES PRIVATE LIMITED",
"V C SYSTEMS PVT LTD",
"V C UDHYOG PRIVATE LIMITED",
"V CARDS HEALTH CARE PRIVATE LIMITED",
"V CARE AGRITECH",
"V CARE COMMUNICATIONS PRIVATE LIMITED",
"V CARE SEEDS PRIVATE LIMITED",
"V CARE SUPPORT SERVICES PRIVATE LIMITED",
"V CIVILNET INDIA PRIVATE LIMITED",
"V CON MOBILE & INFRA PRIVATE LIMITED",
"V CONCRETE BUILT PRIVATE LIMITED",
"V CUBE ENGINEERING PRIVATE LIMITED",
"V CUBED PRIVATE LIMITED",
"V D CREATIONS PRIVATE LIMITED",
"V D FOOD PRODUCTS PRIVATE LIMITED",
"V D MANIAR SHARE AND STOCK BROKERS PRIVATE LIMITED",
"V D M-POWER PRIVATE LIMITED",
"V D PAPER MILL PRIVATE LIMITED",
"V D SILK MILLS PRIVATE LIMITED",
"V DREAM TECHNOLOGY & COMMUNICATION PRIVATE LIMITED",
"V E IMPEX PRIVATE LIMITED",
"V E T MANANDI COMPOSITE PU COLLEGE",
"V ENSURE PHARMA TECHNOLOGIES PRIVATE LIMITED",
"V G INFRA PROJECTS PRIVATE LIMITED",
"V G N JEWELLERY PRIVATE LIMITED",
"V G P HOUSING PRIVATE LIMITED",
"V G PLASTICS PRIVATE LIMITED",
"V G RAJAMANI AGENCIES PRIVATE LIMITED",
"V G SARAF MEMORIAL HOSPITAL PRIVATE LIMITED",
"V GREEN MEDIA PRIVATE LIMITED",
"V GROUP CONSULTANCY SERVICES PRIVATE. LIMITED",
"V GUARD INDUSTRIES LIMITED",
"V H WORLD EXIM",
"V HONEY MARKETING AND MANAGEMENT SERVICES PRIVATE LIMITED",
"V I C ENTERPRISES PRIVATE LTD.",
"V I ENGINEERING SOLUTIONS PRIVATE LIMITED",
"V I P INDUSTRIES LIMITED",
"V I POINT SOLUTIONS PRIVATE LIMITED",
"V I R INFRASTRUCTURE AND ESTATE DEVELOPERS PRIVATE LIMITED",
"V INSPIRER FACILITY MANAGEMENT PRIVATE LIMITED",
"V J B J MADHYAMIK ASHARAMSHALA MORDAND THANDA",
"V J CAPACITORS PRIVATE LIMITED",
"V J CORESOFT PRIVATE LIMITED",
"V J INDUSTRIES PRIVATE LIMITED",
"V J JOSEPH JEWELLERY PRIVATE LIMITED",
"V J NETWORK PRIVATE LIMITED",
"V J STORES",
"V J TECHNICAL INSTITUTE MUMBAI",
"V JETHALAL RAMJI SHARE BROKERS PRIVATE LIMITED",
"V K AUTO ZONE PRIVATE LIMITED",
"V K B ENGINEERING PRIVATE LIMITED",
"V K B S CONSTRUCTION PRIVATE LIMITED",
"V K BUILDCON PRIVATE LIMITED",
"V K CLOTHING PRIVATE LIMITED",
"V K ENTERPRISE",
"V K FASTENERS PRIVATE LIMITED",
"V K FOREX PRIVATE LIMITED",
"V K HEALTHCARE AND MEDICAL INSTITUTE PRIVATE LIMITED",
"V K INDUSTRIAL CORPORATION LIMITED",
"V K INDUSTRIES",
"V K KRISHNA MENON COLLEGE",
"V K KRISHNA MENON COLLEGE OF COMMERCE AND ECONOMICS AND S.S DIGHE COLLEGE OF SCIENCE",
"V K LALCO PRIVATE LIMITED",
"V K MART",
"V K METCAST PRIVATE LIMITED",
"V K MOTORS PRIVATE LIMITED",
"V K OFFSHORE SERVICES INDIA PRIVATE LIMITED",
"V K OILS LTD",
"V K PACKWELL PRIVATE LIMITED",
"V K PEB & METAL PROCESSORS PRIVATE LIMITED",
"V K PUMP INDUSTRIES PRIVATE LIMITED",
"V K R PROJECTS PRIVATE LIMITED",
"V K RUB PLAST (INDIA) PRIVATE LIMITED",
"V K S INFRATECH MANAGEMENT PRIVATE LIMITED",
"V K TRANSPORT PRIVATE LIMITED",
"V K UDYOG LTD",
"V K V EXPORTS PRIVATE LIMITED",
"V K VALVES PVT LTD",
"V K VENTURE PRIVATE LIMITED",
"V K WINES PRIVATE LIMITED",
"V K YARN PRIVATE LIMITED",
"V KAY TRANSLINES PRIVATE LIMITED",
"V L RAKA JEWELLERS PRIVATE LIMITED",
"V L S FOODS PRIVATE LIMITED",
"V LINK SYSTEMS PRIVATE LIMITED",
"V- LIVE SECURE INDIA PRIVATE LIMITED",
"V LOGISTICS INDIA PRIVATE LIMITED",
"V M D MILLS PRIVATE LIMITED",
"V M G R HOTELS AND RESORTS PRIVATE LIMITED",
"V M G THREADS PRIVATE LIMITED",
"V M GUARDFORCE PRIVATE LIMITED",
"V M K TEXTILES PRIVATE LIMITED",
"V M KREATION",
"V M N R CONSTRUCTIONS PRIVATE LIMITED",
"V M R TEXTILES PRIVATE LIMITED",
"V M S CONSULTANTS PRIVATE LIMITED",
"V M SALGAOCAR AND BROTHER PRIVATE LIMITED",
"V MARC INDIA LIMITED",
"V MARK IT SOLUTION",
"V MART RETAIL LIMITED",
"V MATHRAN & CO PRIVATE LIMITED",
"V N B CONSULTING SERVICES PRIVATE LIMITED",
"V N CLOTHING PRIVATE LIMITED",
"V N ELASTIC AND LACES PRIVATE LIMITED",
"V N HIGH SCHOOL",
"V N P ELECTRICALS PRIVATE LIMITED",
"V N SALLA AND SONS REAL ESTATES PRIVATE LIMITED",
"V N SHARMA BUILDERS PRIVATE LIMITED",
"V N SUPPORT TECHNICAL SERVICES PRIVATE LIMITED",
"V N V BUILDERS PRIVATE LIMITED",
"V O CHIDAMBARANAR PORT AUTHORITY",
"V OAK ENGINEERS PRIVATE LIMITED",
"V ONE HOSPITAL",
"V ONE VENTURES PRIVATE LIMITED",
"V P BEDEKAR AND SONS PRIVATE LIMITED",
"V P CONSULTANTS PRIVATE LIMITED",
"V P DISTRIBUTORS PRIVATE LIMITED",
"V P EXIM INFRACON PRIVATE LIMITED",
"V P INFANT GOODS PRIVATE LIMITED",
"V P M S S SHRI MADHAVRAO BHAGWAT HIGH SCHOOL ( ENG.MED)",
"V P S HIGH SCHOOL AND D P MEHTA JR COLLEGE",
"V P SCIENCE COLLEGE",
"V P SOFTWARES PRIVATE LIMITED",
"V P T P S RADHANAGARI",
"V P UDYOG LTD",
"V P VIDYANIDHI HIGH SCHOOL",
"V PAC CARTONS INDIA PRIVATE LIMITED",
"V PROMPT E SERVICES PRIVATE LIMITED",
"V PUBLISHING SOLUTIONS PRIVATE LIMITED",
"V R A COTTON MILLS PRIVATE LIMITED",
"V R APPARELS PRIVATE LIMITED",
"V R COATINGS PRIVATE LIMITED",
"V R CONSTRUCTORS PRIVATE LIMITED",
"V R DACRO PRIVATE LIMITED",
"V R DELLA IT SERVICES PRIVATE LIMITED",
"V R E TOOLS PRIVATE LIMITED",
"V R FILMS & STUDIOS LIMITED",
"V R FILMS AND STUDIOS PRIVATE LIMITED",
"V R G CONSTRUCTIONS PRIVATE LIMITED",
"V R GLOBAL PRIVATE LIMITED",
"V R INDUSTRIES PRIVATE LIMITED",
"V R INFRASPACE LIMITED",
"V R JEWEL MAKERS PRIVATE LIMITED",
"V R K BUILDERS & DEVELOPERS PRIVATE LIMITED",
"V R K CONSULTANTS PRIVATE LIMITED",
"V R LOGISTICS LIMITED",
"V R LUBRICANTS PRIVATE LIMITED",
"V R PATIL VIVIDH VIDYUT NIRMAN PRIVATE. LIMITED.",
"V R PAWAR SAREES PRIVATE LIMITED",
"V R PLACEMENT PRIVATE LIMITED",
"V R POLYFAB PRIVATE LIMITED",
"V R POWER EQUIPMENTS PRIVATE LIMITED",
"V R PROCESS ENGINEERING CONSULTANTS PRIVATE LIMITED",
"V R R DIAGNOSTIC SERVICES PRIVATE LIMITED",
"V R RESIDENCY PRIVATE LIMITED",
"V R S INTERNATIONALS PRIVATE LIMITED",
"V R SPINNING MILLS PRIVATE LIMITED",
"V R TECH",
"V R TECHNICHE CONSULTANTS PRIVATE LIMITED",
"V R WORLDWIDE PRIVATE LIMITED",
"V RETAIL PRIVATE LIMITED",
"V RISE SECURITIES PRIVATE LIMITED",
"V S A INFRA PROJECTS PRIVATE LIMITED",
"V S AUTO TECH PRIVATE LIMITED",
"V S C SILK PRIVATE LIMITED",
"V S D STUDIO (I) PRIVATE LIMITED",
"V S ELECTRICALS PRIVATE LIMITED",
"V S ENGINEERING PRIVATE LIMITED",
"V S G LEASING AND FINANCE COMPANY LIMITED",
"V S GEM & JEWELLERS PRIVATE LIMITED",
"V S GURUKUL TECH HIGH SCHOOL",
"V S INFRA LOGISTICS PRIVATE LIMITED",
"V S INSTRUMENT PRIVATE LIMITED",
"V S INTERNATIONAL PRIVATE LIMITED",
"V S K SYNTHETICS PRIVATE LIMITED",
"V S KRISHNA COLLEGE",
"V S KUKREJA AND ASSOCIATES PRIVATE LIMITED",
"V S L ALLOYS (INDIA) PRIVATE LIMITED",
"V S M EXPO PRIVATE LIMITED",
"V S N AROMATICS PRIVATE LIMITED",
"V S NETWORK SOLUTIONS PRIVATE LIMITED",
"V S P ISPAT PRIVATE LIMITED",
"V S P M DENTAL COLLEGE RESEARCH CENTER",
"V S P STORES PRIVATE LIMITED",
"V S PROJECTS & SYSTEM ENGINEERS PRIVATE LIMITED",
"V S RELATORS (INDIA) PRIVATE LIMITED",
"V S SAURYA ENERTECH PRIVATE. LIMITED.",
"V S SPINNERS PRIVATE LIMITED",
"V S STRATEGIC CONSULTANTS PRIVATE LIMITED",
"V S T & SONS PRIVATE LIMITED",
"V S T ASSOCIATED GRAPHICS PRIVATE LIMITED",
"V S T AUTO ANCILLARIES PRIVATE LIMITED",
"V S T MOTORS PRIVATE LIMITED",
"V S TEXTILES & FINANCE PVT LTD",
"V S TIMBERS PRIVATE LIMITED",
"V S WASTE PRIVATE LIMITED",
"V SERVE CONSULTANTS PRIVATE LIMITED",
"V SHIPS INDIA PRIVATE LIMITED",
"V SMART THERMOTECH PRIVATE LIMITED",
"V SOFT CONSULTING CORPORATION PRIVATE LIMITED",
"V SOURCE BUILDING MATERIALS PRIVATE LIMITED",
"V SPAK PESTICIDES INDIA LIMITED",
"V ST JOSEPH S CONVENT PUNJABI HIGH SCHOOL",
"V STAR CREATIONS PRIVATE LIMITED",
"V SUPPLY CHAIN PRIVATE LIMITED",
"V SYNERGIZE OUTSOURCING PRIVATE LIMITED",
"V T CHOKSI SARVAJANIK COLG OF EDU",
"V T COLLEGE",
"V T CORP PRIVATE LIMITED",
"V T FOODS PRIVATE LIMITED",
"V T J FISHERIES PRIVATE LIMITED",
"V T PALRESHA AND COMPANY PRIVATE LIMITED",
"V T SCIENTIFIC INSTRUMENTS PRIVATE LIMITED",
"V T VELU INVESTMENTS PRIVATE LIMITED",
"V TECH ENGINEERS",
"V TECH INDUSTRIES INDIA PRIVATE LIMITED",
"V TECH OFFSHORE SERVICES PRIVATE LIMITED",
"V TRANS INDIA LIMITED",
"V U B ENGIINEERING PRIVATE LIMITED",
"V V CORPORATE FINANCIAL SERVICES PRIVATE LIMITED",
"V V DAV PUBLIC SCHOOL",
"V V DECOR PRIVATE LIMITED",
"V V DENTISTREE INDIA PRIVATE LIMITED",
"V V DYE-CHEM PVT LTD",
"V V ELECTRICALS PRIVATE LIMITED",
"V V F LIMITED",
"V V FASHIONS PRIVATE LIMITED",
"V V GREEN POWER PRIVATE LIMITED",
"V V HITECH INNOVATIONS INDIA PRIVATE LIMITED",
"V V IRON &STEEL COMPANY PRIVATE LIMITED",
"V V K TURBOTECH PRIVATE LIMITED",
"V V L PHARMA PRIVATE LIMITED",
"V V LAGU TRAVEL CONSULTANTS PRIVATE LIMITED",
"V V PATEL VIDYAVIHAR",
"V V REFRIGERATION PRIVATE LIMITED",
"V V SANGHA S K MODI NATIONAL SCHOOL",
"V V SHIPPING & LOGISTICS PRIVATE LIMITED",
"V V TITANIUM PIGMENTS PRIVATE LIMITED",
"V V V & SONS EDIBLE OILS LIMITED",
"V VAISHALI CONSULTANT PRIVATE LIMITED",
"V WIN TRADERS LLP",
"V Y INSTITUTE OF MEDICAL SCIENCE PRIVATE LIMITED",
"V&A DIAMONDS PRIVATE LIMITED",
"V&A VENTURES LLP",
"V&B LIFESTYLE INDIA PRIVATE LIMITED",
"V&G INDUSTRIAL TESTING LABORATORIES PRIVATE LIMITED",
"V&J FURNISHINGS PRIVATE LIMITED",
"V&S AIR TECHNIQUE PRIVATE LIMITED",
"V. AGRO SEEDS PRIVATE LIMITED",
"V. ARUNACHALAM IYER & SONS PRIVATE LIMITED",
"V. B. AUTO SALES PRIVATE LIMITED",
"V. CHANDRATAN FOODS PRIVATE LIMITED",
"V. D. GEMS INDIA PRIVATE LIMITED",
"V. D. SWAMI AND COMPANY PRIVATE LIMITED",
"V. DESAI COLORS PRIVATE LIMITED",
"V. E AUTOMOTIVE INDIA PRIVATE LIMITED",
"V. K. BELTING PRIVATE LIMITED",
"V. K. ELECTRONIC DEVICES PRIVATE LIMITED",
"V. K. RICE TECH PRIVATE LIMITED",
"V. K. S. TRADING PRIVATE LIMITED",
"V. K. SOOD ENGINEERS & CONTRACTORS",
"V. M. HOMES PRIVATE LIMITED",
"V. M. TECHNO-SOFT PRIVATE LIMITED",
"V. N. ENVIRO PRIVATE LIMITED",
"V. R. OVERSEAS PRIVATE LIMITED",
"V. RAM CHANDRA IRON & STEEL PRIVATE LIMITED",
"V. RAMA KRISHNA SONS PRIVATE LIMITED",
"V. S. FABRICS AND INVESTMENTS PRIVATE LIMITED",
"V. S. INSTITUTE & HOSTEL PRIVATE LIMITED",
"V. S. MANUFACTURING AND TRADING COMPANY PRIVATE LIMITED",
"V. S. Y. INTERNATIONAL PRIVATE LIMITED",
"V. SINGHI CONSULTANTS PRIVATE LIMITED",
"V. SONS EMPORIO PRIVATE LIMITED",
"V. U. ELECTRICAL EQUIPMENTS PRIVATE LIMITED",
"V.A. POWER AND STEELS PRIVATE LIMITED",
"V.A.R. CONSTRUCTION AND PROMOTERS PRIVATE LIMITED",
"V.A.S. DESIGN AND INFRASTRUCTURES CONSULTANTS PRIVATE LIMITED",
"V.B. INDUSTRIES LTD",
"V.B. MINERALS AND RESINS PRIVATE LIMITED",
"V.B. OIL MILLS PRIVATE LIMITED",
"V.B.CONSTRUCTIONS PVT LTD",
"V.D RICE MILLS PRIVATE LIMITED",
"V.D. MOTORS PRIVATE LIMITED",
"V.D. PAREKH SEEDS PRIVATE LIMITED",
"V.D.ESTATES PRIVATE LIMITED",
"V.E.C INVESTMENT MANAGEMENT (INDIA) PRIVATE LIMITED",
"V.G. PAPER & BOARDS LIMITED VGPBL",
"V.G. TECH COMPUTERS PRIVATE LIMITED",
"V.G.N.ENTERPRISES PRIVATE LIMITED",
"V.G.S. HOLIDAYS PRIVATE LIMITED",
"V.GURUSWAMY NAIDU & CO PRIVATE LIMITED",
"V.H INDUSTRIES PRIVATE LIMITED",
"V.H. ELECTRICALS PRIVATE LIMITED",
"V.H. ENTERPRISES PRIVATE LIMITED",
"V.H. KHATRI CONSTRUCTION PRIVATE LIMITED",
"V.H.APPY MARITIME PRIVATE LIMITED",
"V.I.PLY TIMBER PRIVATE LIMITED",
"V.I.R FOODS LIMITED",
"V.J CRANES PRIVATE LIMITED",
"V.J. AUTOMOBILES PRIVATE LIMITED",
"V.J. INFONET PRIVATE LIMITED",
"V.J. KULKARNI ASSOCIATES ADVISORS PRIVATE LIMITED",
"V.J. METAL COMPONENTS PRIVATE LIMITED",
"V.J.LOGISTICS INDIA PRIVATE LIMITED",
"V.K. AUTOMART PRIVATE LIMITED",
"V.K. ENGITECH PRIVATE LIMITED",
"V.K. HOME SOLUTIONS PRIVATE LIMITED",
"V.K. MECHANICAL SERVICES PRIVATE LIMITED",
"V.K. MERCANTILE PVT. LTD.",
"V.K. PATEL SECURITIES PRIVATE LIMITED",
"V.K. SALES PRIVATE LIMITED",
"V.K. SINGH CONSTRUCTION PRIVATE LIMITED",
"V.K. SPICES INDUSTRIES PRIVATE LIMITED",
"V.K.A. POLYMERS PRIVATE LIMITED",
"V.K.GOPAL",
"V.K.PALAPPA NADAR POULTRY FARMS PRIVATE LIMITED",
"V.K.S.M. COTTON MILLS LIMITED",
"V.K.V.K.STEELS PRIVATE LIMITED",
"V.L.INFRAPROJECTS LIMITED",
"V.M BAKERY PRODUCTS PRIVATE LIMITED",
"V.M. MATERE INFRASTRUCTURES PRIVATE LIMITED",
"V.M. PROCON PRIVATE LIMITED",
"V.M. SUPER ALLOYS PRIVATE LIMITED",
"V.M.CONTAINERS PRIVATE LIMITED",
"V.M.MEDITECH PRIVATE LIMITED",
"V.M.MUSLUNKAR AND SONS JEWELLERS PRIVATE LIMITED",
"V.M.SPICE COMPANY PRIVATE LIMITED",
"V.N.DYERS AND PROCESSORS PRIVATE LIMITED",
"V.N.POLYMERS PRIVATE LIMITED",
"V.P TEX YARN INDIA PRIVATE LIMITED",
"V.P. AGRO OILS PRIVATE LIMITED",
"V.P. BHANDARI CONSTRUCTIONS PRIVATE LIMITED",
"V.P. JEWELLERS PRIVATE LIMITED",
"V.P. SINGHAL & COMPANY INSURANCE SURVEYORS & LOSS ASSESSORS PRIVATE LIMITED",
"V.P. TEX PRIVATE LIMITED",
"V.P.K. AGRO FOOD PRODUCT PRIVATE LIMITED",
"V.P.N.GELATINE PRIVATE LIMITED",
"V.P.P.S.SHIROL",
"V.R. AUTO PRODUCTS PRIVATE LIMITED",
"V.R. OFFICE NEEDS PRIVATE LIMITED",
"V.R. PETROCHEMICALS PRIVATE LIMITED",
"V.R.A. REALITY PRIVATE LIMITED",
"V.R.B.PUBLISHERS PRIVATE LIMITED",
"V.R.COLD STORAGE PRIVATE LIMITED",
"V.R.K. ASSOCIATES PRIVATE LIMITED",
"V.R.K. GRANDSONS INVESTMENT PRIVATE LIMITED",
"V.R.KNITFAB PRIVATE LIMITED",
"V.R.LOGISTICS PRIVATE LIMITED",
"V.R.S TEXTILES PRIVATE LIMITED",
"V.R.S. AGRO PRIVATE LIMITED",
"V.R.S. COLONIZERS & INFRADEVELOPERS PRIVATE LIMITED",
"V.S. ECOBLOCKS PRIVATE LIMITED",
"V.S. FIBRES PRIVATE LIMITED",
"V.S. GLOBAL LOGISTIKS CHAIN PRIVATE LIMITED",
"V.S. ICE AND COLD STORAGE PRIVATE LIMITED",
"V.S. INTERCHEM PRIVATE LIMITED",
"V.S. IRON PRIVATE LIMITED",
"V.S. PACK PRODUCTS PRIVATE LIMITED",
"V.S. POLYMERS PRIVATE LIMITED",
"V.S. TEX-FAB PRIVATE LIMITED",
"V.S.HITECH SECURITY FORMS PRIVATE LIMITED",
"V.S.HOMES AND RESORTS PRIVATE LIMITED",
"V.S.J. INDUSTRYY",
"V.S.PRESSURE VESSELS AND GAS PROJECTS PRIVATE LIMITED",
"V.S.R. PRIVATE LIMITED",
"V.SHIPS SHIP MANAGEMENT INDIA PRIVATE LIMITED",
"V.SONS DISTRIBUTORS PRIVATE LIMITED",
"V.SURESHKUMAR TEXTILE PRIVATE LIMITED",
"V.T. CONSTRUCTION PRIVATE LIMITED",
"V.TEX WVG. & MFG. MILLS PRIVATE LIMITED",
"V.THANGAVEL AND SONS PRIVATE LIMITED",
"V.V INCIN SOLUTIONS PRIVATE LIMITED",
"V.V SYSTEMS & POWER PANELS PRIVATE LIMITED",
"V.V. SAPRE CONSULTANTS PRIVATE LIMITED",
"V.V.ECO GUM MANUFACTURING PRIVATE LIMITED",
"V.V.L MINING AND ALLIED SERVICES PRIVATE LIMITED",
"V.V.T. COMMUNICATIONS PRIVATE LIMITED",
"V.V.T. HOTELS PRIVATE LIMITED",
"V.Y. PACKAGINGS PRIVATE LIMITED",
"V1 INFRADEVELOPERS PRIVATE LIMITED",
"V-10 PLY & VENEER (INDIA) PRIVATE LIMITED",
"V2 CIVIL DIAGNOSTICS PRIVATE LIMITED",
"V2 FIRE PROTECTION SERVICES PRIVATE LIMITED",
"V2 HOLDINGS HOUSING DEVELOPMENT PRIVATE LIMITED",
"V2 INNOVATIVES PRIVATE LIMITED",
"V2 PACK PRIVATE LIMITED",
"V2 PROMOTERS PRIVATE LIMITED",
"V2 REAL ESTATE PRIVATE LIMITED",
"V2 RETAIL LIMITED",
"V2 SMART MANUFACTURING PRIVATE LIMITED",
"V2 TECH VENTURES PRIVATE LIMITED",
"V2 UDYOG LIMITED",
"V2 WELLNESS SERVICES PRIVATE LIMITED",
"V2J CAPITAL FINANCIAL SERVICES PRIVATE LIMITED",
"V2RM RETAIL PRIVATE LIMITED",
"V2RS B5 ENTERPRISES PRIVATE LIMITED",
"V2STECH SOLUTIONS PRIVATE LIMITED",
"V2V SUPPLY CHAINS PRIVATE LIMITED",
"V2VALUE BIZ SOLUTIONS PRIVATE LIMITED",
"V2WEB HOSTING PRIVATE LIMITED",
"V3 AGENCIES PRIVATE LIMITED",
"V3 AUTOMATIVES PRIVATE LIMITED",
"V3 ENTERPRISES PRIVATE LIMITED",
"V3 HEALTH EDUCARE FOUNDATION",
"V3 HEALTHCARE PRIVATE LIMITED",
"V3 KATHAN INDUSTRIAL SOLUTIONS PRIVATE LIMITED",
"V3 MOULDING PRIVATE LIMITED",
"V3 NOVUS PRIVATE LIMITED",
"V3 OUTSOURCING SOL PRIVATE LIMITED",
"V3 POLYPLAST PRIVATE LIMITED",
"V3 STAFFING SOLUTIONS INDIA PRIVATE LIMITED",
"V3CUBE APPLABS PRIVATE LIMITED",
"V3CUBE INNOVATIONS PRIVATE LIMITED",
"V3S INFRATECH LIMITED",
"V4 ENTERTAINMENT PRIVATE LIMITED",
"V4 INFO PRIVATE LIMITED",
"V4 INFRASTRUCTURE PRIVATE LIMITED",
"V4 SECURITY SERVICE PRIVATE LIMITED",
"V4 TECH PRIVATE LIMITED",
"V4 TRADEX INDIA PRIVATE LIMITED",
"V4 TRANSPORT PRIVATE LIMITED",
"V4U CONSULTAANTS PRIVATE LIMITED",
"V4U HEALTHCARE PRIVATE LIMITED",
"V4U INVESTWISE PRIVATE LIMITED",
"V-5 AUTOPARTS MANUFACTURING PRIVATE LIMITED",
"V5 PUBLICATIONS PRIVATE LIMITED",
"V5 SYSTEMS INDIA PRIVATE LIMITED",
"V5 TECHSOL INDIA LLP",
"V5 TRADE & SERVICES PRIVATE LIMITED",
"V5U STEEL PRIVATE LIMITED",
"V7 HOTEL PRIVATE LIMITED",
"V7EVEN INFOTECH PRIVATE LIMITED",
"V9 TECHNOLOGIES INC",
"VA EXERGY TECHNOLOGIES INDIA PRIVATE LIMITED",
"VA HOTELS PRIVATE LIMITED",
"VA INFOSOLUTIONS INDIA PRIVATE LIMITED",
"VA PROPERTIES PRIVATE LIMITED",
"VA SYNERGY PRIVATE LIMITED",
"VA TECH VENTURES PRIVATE LIMITED",
"VA TECH WABAG LIMITED",
"VA TECHNOLOGY LABS LLP",
"VAA TECHNOLOGIES PRIVATE LIMITED",
"VAAAN INFRA PRIVATE LIMITED",
"VAACHI SEEDS PRIVATE LIMITED",
"VAADI HERBALS PRIVATE LIMITED",
"VAAGAI TECHNOLOGIES PRIVATE LIMITED",
"VAAGDEVI COLLEGE OF ENGINEERING",
"VAAGDEVI DEGREE AND PG COLLEGE",
"VAAGDEVI SOLVENT OILS PRIVATE LIMITED",
"VAAGMI INFORMATICA PRIVATE LIMITED",
"VAAHAN AUTO COMPONENTS PRIVATE LIMITED",
"VAAHID ENGINEERING WORKS (OPC) PRIVATE LIMITED",
"VAAHO INDUSTRIES PRIVATE LIMITED",
"VAAKRUTHI SOFTWARE SOLUTIONS PRIVATE LIMITED",
"VAAKULAB TECHNOLOGIES PRIVATE LIMITED",
"VAAL TRIANGLE SYSTEMS PRIVATE LIMITED",
"VAALUKA SOLUTIONS PRIVATE LIMITED",
"VAAMAN ENGINEERS INDIA",
"VAAMAN ENGINEERS INDIA LIMITED",
"VAAMAN FAB PRIVATE LIMITED",
"VAAMAN TEXPRINT PRIVATE LIMITED",
"VAAMYA FASHIONS PRIVATE LIMITED",
"VAAN MULTIOPERATIONS PRIVATE LIMITED",
"VAAN POLYPLAST PRIVATE LIMITED",
"VAANAM CONSTRUCTIONS AND DEVELOPMENT PRIVATE LIMITED",
"VAANAM TECHNOLOGIES PRIVATE LIMITED",
"VAANI ESTATE DEVELOPERS PRIVATE LIMITED",
"VAANYA METALS & STEELS PRIVATE LIMITED",
"VAANYA PACKAGING INDIA PRIVATE LIMITED",
"VAAP INTERNATIONAL PRIVATE LIMITED",
"VAAPF ENGINEERS PRIVATE LIMITED",
"VAARAAHI TECH SOLUTIONS PRIVATE LIMITED",
"VAARADHI ENTERPRISES PRIVATE LIMITED",
"VAARANAM DATA SOLUTIONS OPC PRIVATE LIMITED",
"VAARIDHI LOGISTICS PRIVATE LIMITED",
"VAASAVAA PHARMACEUTICALS PRIVATE LIMITED",
"VAASAVI NIDHI LIMITED",
"VAASTU GANGA ROTOMATICS PRIVATE LIMITED",
"VAASTU INFRABUILD PRIVATE LIMITED",
"VAASTU MARBLE AND GRANITES PRIVATE LIMITED",
"VAASUDEV GRAIN MILL PRIVATE LIMITED",
"VAASUDEVO CITY BUS OPERATIONS PRIVATE LIMITED",
"VAATA SMART LIMITED",
"VAAYA WORKPLACE SOLUTIONS PRIVATE LIMITED",
"VAAYU (INDIA) POWER CORPORATION PRIVATE LIMITED",
"VAAYU ENERGY LIMITED",
"VAAYU HOME APPLIANCES (INDIA) PRIVATE LIMITED",
"VAAYU INTERNATIONAL FOREX SERVICES PRIVATE LIMITED",
"VAAYU LOGISTICS PRIVATE LIMITED",
"VAAYU RENEWABLE ENERGY (GODAVARI) PRIVATE LIMITED",
"VAAYU RENEWABLE ENERGY (TAPTI) PRIVATE LIMITED",
"VAAYU SHANTI SOLUTIONS PRIVATE LIMITED",
"VAAYU VISION PRIVATE LIMITED",
"VAAYUJA INFO SOLUTIONS PRIVATE LIMITED",
"VAB BUSINESS ANALYSIS SERVICES PRIVATE LIMITED",
"VABROS GVMPL PRIVATE LIMITED",
"VAC APPARELS PRIVATE LIMITED",
"VAC BUILDCARE PRIVATE LIMITED",
"VAC DESIGN ENGINEERS PRIVATE LIMITED",
"VAC TELEINFRA SOLUTIONS PRIVATE LIMITED",
"VACATION SMITHS PRIVATE LIMITED",
"VACATIONS XOTICA PRIVATE LIMITED",
"VACCON VALVES PRIVATE LIMITED",
"VACCPACK SOLUTIONS PRIVATE LIMITED",
"VACCUME TECH MACHINES",
"VACHAM CONSULTANCY LLP",
"VACHAN ELECTRICALS PRIVATE LIMITED",
"VACHANA INVESTMENTS PRIVATE LIMITED",
"VACHANDEEP SHIPPING INDIA PRIVATE LIMITED",
"VACHHANI FURNITURE PRIVATE LIMITED",
"VACHI MOTORS PRIVATE LIMITED",
"VACHI VENTURES LLP",
"VACHICHEM INTERNATIONAL PRIVATE LIMITED",
"VACMAN SANITATION SOLUTIONS PRIVATE LIMITED",
"VACMET INDIA LIMITED",
"VACO BINARY SEMANTICS LLP",
"VACO ENTERPRISE LLP",
"VACOM TECHNOLOGIES INDIA PRIVATE LIMITED",
"VACS TECHNOLOGY PRIVATE LIMITED",
"VACTECH COMPOSITES PRIVATE LIMITED",
"VACUUM PLANT AND INSTRUMENTS MANUFACTURING COMPANY LIMITED",
"VACUUM TECHNIQUES PRIVATE LIMITED",
"VAD CROP SCIENCE PRIVATE LIMITED",
"VAD INDUSTRIES PRIVATE LIMITED",
"VADAKARA COCONUT FARMERS PRODUCER COMPANY LIMITED",
"VADAKKEDATH INDUSTRIES PRIVATE LIMITED",
"VADAKKEMURIYIL FINANCE COMPANY (INDIA) LIMITED",
"VADALIA FOODS",
"VADAN INTERIORS PRIVATE LIMITED",
"VADAPALANI MURUGAN INDUSTRIES PRIVATE LIMITED",
"VADATECH INDIA PRIVATE LIMITED",
"VADAYAR SERVICES PRIVATE LIMITED",
"VADEHRA ART GALLERY PRIVATE LIMITED",
"VADEHRA BUILDERS PRIVATE LIMITED",
"VADERA CONSTRUCTION PRIVATE LIMITED",
"VADERA TRADELINK PRIVATE LIMITED",
"VADHI STEELS PRIVATE LIMITED",
"VADHVAN PORT PROJECT LIMITED",
"VADICT INNOVATIONS PRIVATE LIMITED",
"VADILAL CHEMICALS LIMITED",
"VADILAL DAIRY INTERNATIONAL LIMITED",
"VADILAL ENTERPRISES LIMITED",
"VADILAL GASES LIMITED",
"VADILAL INDUSTRIES LIMITED",
"VADILAL INTERNATIONAL PRIVATE LIMITED",
"VADIM INFRASTRUCTURE PRIVATE LIMITED",
"VADINAR OIL TERMINAL LIMITED",
"VADINAR POWER COMPANY LIMITED",
"VADINI INFOCENTERIO PRIVATE LIMITED",
"VADISH PHARMA PRIVATE LIMITED",
"VADIT SNACKS PRIVATE LIMITED",
"VADIVARHE SPECIALITY CHEMICALS LIMITED",
"VADIVEL PYROTECHS PRIVATE LIMITED",
"VADIWALA DEHYDRATION PRIVATE LIMITED",
"VADIYANESH PRIMARY SCHOOL UPLETA",
"VADLAMUDI ESTATES PRIVATE LIMITED",
"VADNAGAR NAGARPALIKA",
"VADNERKAR JEWELLERS PRIVATE LIMITED",
"VADO TECHNOLOGY PRIVATE LIMITED",
"VADODARA ENVIRO CHANNEL LIMITED",
"VADODARA GAS LIMITED",
"VADODARA INSTITUTE OF ENGINEERING",
"VADODARA MAHANAGAR SEVA SADAN",
"VADODARA PEDIATRIC AFFILIATES PRIVATE LIMITED",
"VADODARA SMART CITY DEVELOPMENT LIMITED",
"VADRA OVERSEAS PRIVATE LIMITED",
"VADS CONSULTING PRIVATE LIMITED",
"VADS INDIA",
"VADS MARKETING PRIVATE LIMITED",
"VADSOFT PRIVATE LIMITED",
"VADUWALA EYE HOSPITAL",
"VAELS INTERNATIONAL SCHOOL",
"VAF DEF-AERO SYSTEMS PRIVATE LIMITED",
"VAF PRECISION ENGINEERING PRIVATE LIMITED",
"VAG INFOTECH PRIVATE LIMITED",
"VAG POLYTECH PRIVATE LIMITED",
"VAG VALVES INDIA PRIVATE LIMITED",
"VAGA HEALTHCARE PRIVATE LIMITED",
"VAGA HOSPITALS PRIVATE LIMITED",
"VAGA TRADE PRIVATE LIMITED",
"VAGAD AGRO PRIVATE LIMITED",
"VAGAD BUILDERS & DEVELOPERS PRIVATE LIMITED",
"VAGAD MART PRIVATE LIMITED",
"VAGARAI WINDFARM LIMITED",
"VAGARO TECHNOLOGIES PRIVATE LIMITED",
"VAGAS AQUA PRIVATE LIMITED",
"VAGDEVI FOOD PRODUCTS PRIVATE LIMITED",
"VAGDEVI INNOSCIENCE PRIVATE LIMITED",
"VAGDEVI PUBLIC SCHOOL",
"VAGDEVI VILAS SCHOOL VARTHUR",
"VAGH TRADER PRIVATE LIMITED",
"VAGHANI INC",
"VAGHASIA PLASTIC PRIVATE LIMITED",
"VAGMI CAPITAL SERVICES PRIVATE LIMITED",
"VAGMI CHEMICALS PRIVATE LIMITED",
"VAGMI FOREX PRIVATE LIMITED",
"VAGMII SOLUTIONS PRIVATE LIMITED",
"VAGMINE ENTERPRISES PRIVATE LIMITED",
"VAGMINE HEALTHCARE PRIVATE LIMITED",
"VAGMINE LOGISTICS PRIVATE LIMITED",
"VAGMINE OVERSEAS PRIVATE LIMITED",
"VAGMINE TEXOFABS PRIVATE LIMITED",
"VAGT SECURITY SERVICES PRIVATE LIMITED",
"VAGUS HOSPITAL",
"VAGUS SUPER SPECIALITY HOSPITAL PRIVATE LIMITED",
"VAGUS TECHNOLOGIES PRIVATE LIMITED",
"VAGVILAS SOFTWARE PRIVATE LIMITED",
"VAH AUTO PRIVATE LIMITED",
"VAHAN TECHNOLOGIES INDIA PRIVATE LIMITED",
"VAHANA TRAVELS AND SERVICES PRIVATE LIMITED",
"VAHANI INVESTMENTS PRIVATE LIMITED",
"VAHANVATI CONSULTANTS PRIVATE LIMITED",
"VAHANVATINAGAR PRIMARY SCHOOL",
"VAHATUKA PRIVATE LIMITED",
"VAHH CHEMICALS LIMITED",
"VAHIN ADVISORS AND TRADERS PRIVATE LIMITED",
"VAHIN HI-TECH PROJECTS PRIVATE LIMITED",
"VAHINI IRRIGATION PRIVATE LIMITED",
"VAHINI POULTRIES PRIVATE LIMITED",
"VAHNI DISTILLERIES PRIVATE LIMITED",
"VAIBAVSRI SOLUTIONS INDIA PRIVATE LIMITED",
"VAIBBHAV ASHOK GOEL FOUNDATION",
"VAIBH METALLURGICAL SOLUTIONS PRIVATE LIMITED",
"VAIBHAV AGROTECH PRIVATE LIMITED",
"VAIBHAV BUILD TECH PRIVATE LIMITED",
"VAIBHAV CORPORATION PRIVATE LIMITED",
"VAIBHAV COTEX PRIVATE LIMITED",
"VAIBHAV COTGIN PRIVATE LIMITED",
"VAIBHAV CREATIONS PRIVATE LIMITED",
"VAIBHAV DYECHEM INDUSTRIES PRIVATE LIMITED",
"VAIBHAV EDIBLES PRIVATE LIMITED",
"VAIBHAV EMPIRE PRIVATE LIMITED",
"VAIBHAV ENERGY SAVING EQUIPMENTS PRIVATE LIMITED",
"VAIBHAV ENTERPRISES",
"VAIBHAV FITTING INDIA PRIVATE LIMITED",
"VAIBHAV GINNING & SPINNING MILL PRIVATE LIMITED",
"VAIBHAV GLOBAL LIMITED",
"VAIBHAV HEAVY VEHICLES LTD",
"VAIBHAV INDUSTRIES",
"VAIBHAV INFRAPLANNER PRIVATE LIMITED",
"VAIBHAV INTER DECOR PRIVATE LIMITED",
"VAIBHAV INTERNATIONAL PRIVATE LIMITED",
"VAIBHAV ISPAT PRIVATE LIMITED",
"VAIBHAV LAXMI AGRO FOOD PRIVATE LIMITED",
"VAIBHAV LAXMI CAPITAL MARKET PVT LTD",
"VAIBHAV LAXMI CONTRACTS PRIVATE LIMITED",
"VAIBHAV LAXMI FILAMENTS PRIVATE. LIMITED.",
"VAIBHAV LAXMI TEX PRIVATE LIMITED",
"VAIBHAV LIFESTYLE LIMITED",
"VAIBHAV LIQUORS PRIVATE LIMITED",
"VAIBHAV MEDICAL AND EDUCATION FOUNDATION",
"VAIBHAV MERCANTILE LTD",
"VAIBHAV ORGANICS PRIVATE LIMITED",
"VAIBHAV PAPER BOARDS PRIVATE LIMITED",
"VAIBHAV PLASTO PRINTING & PACKAGING PRIVATE LIMITED",
"VAIBHAV POULTECH INDIA PRIVATE LIMITED",
"VAIBHAV PROCESSING MILLS PRIVATE LIMITED",
"VAIBHAV PROPERTIES PRIVATE LIMITED",
"VAIBHAV PUBLICATIONS PRIVATE LIMITED",
"VAIBHAV RUBBERS PRIVATE LIMITED",
"VAIBHAV SILK MILLS PRIVATE LIMITED",
"VAIBHAV STOCK & DERIVATIVES BROKING PRIVATE LIMITED",
"VAIBHAV TECH SOLUTIONS PRIVATE LIMITED",
"VAIBHAV TRANSLOGIST PRIVATE LIMITED",
"VAIBHAV VYAPAAR PRIVATE LIMITED",
"VAIBHAVA ENTERPRISES PRIVATE LIMITED",
"VAIBHAVAGRI CROP NUTRITION PRIVATE LIMITED",
"VAIBHAVCITY BUILDCON PRIVATE LIMITED",
"VAIBHAVII TEX FABLES PRIVATE LIMITED",
"VAIBHAVLAKSHMI PACKAGING PRIVATE LIMITED",
"VAIBHAVLAXMI BUILDERS & DEVELOPERS",
"VAIBHAVLAXMI EXPORTS PRIVATE LIMITED",
"VAIBHAVLAXMI INFRACON PRIVATE LIMITED",
"VAIBHAVLAXMI INTERNATIONAL LIMITED",
"VAIBHAVLAXMI SORTEX RICE MILL PRIVATE LIMITED",
"VAIBHAVLAXMI SPINNING MILLS LIMITED",
"VAIBHAVM READYMIX CONCRETE PRIVATE LIMITED",
"VAIBHAVSHAKTI INFRASTRUCTURE PRIVATE LIMITED",
"VAIBHAVUDYOG METAL INDIA PRIVATE LIMITED",
"VAIBHAWS KNITS PRIVATE LIMITED",
"VAIBHU INFRA TECH INDIA PRIVATE LIMITED",
"VAICHAL CONSTRUCTIONS PRIVATE LIMITED",
"VAID ELASTOMER PROCESSORS LIMITED",
"VAID ENTERPRISES (INDIA) PRIVATE LIMITED",
"VAID LOGISTICS PRIVATE LIMITED",
"VAID MILK PRODUCTS PRIVATE LIMITED",
"VAIDAANGI TECHNO MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"VAIDAM HEALTH PRIVATE LIMITED",
"VAIDEHEE INFRA ENGINEERING SERVICES PRIVATE LIMITED",
"VAIDEHI HOTELS PRIVATE LIMITED",
"VAIDEHI MOTORS PRIVATE LIMITED",
"VAIDHAI CONSTRUCTION AND SUPPLIER PRIVATE LIMITED",
"VAIDHRAJ LOGISTICS PRIVATE LIMITED",
"VAIDI FACILITY MANAGEMENT PRIVATE LIMITED",
"VAIDIK EDUSERVICES PRIVATE LIMITED",
"VAIDIKA AGRO SOLUTIONS PRIVATE LIMITED",
"VAIDYA NUTRACEUTICALS PRIVATE LIMITED",
"VAIDYA PATANKAR PHARMACY PRIVATE LIMITED",
"VAIDYA SANE AYURVED LABORATORIES LIMITED",
"VAIDYA SANE AYURVED LABORATORIES PRIVATE LIMITED",
"VAIDYA SPACES PRIVATE LIMITED",
"VAIDYA V AND I INFRASTRUCTURE PRIVATE LIMITED",
"VAIDYANATH ALCOBREW PRIVATE LIMITED",
"VAIDYANATH FIRE SERVICES PRIVATE LIMITED",
"VAIDYARATNAM AYURVEDA COLLEGE",
"VAIDYARATNAM OUSHADHASALA PRIVATE LIMITED",
"VAIGAI AUTOMOTIVES INDIA PRIVATE LIMITED",
"VAIGAI CANTEEN PRIVATE LIMITED",
"VAIGAI ENGINEERING PRIVATE LIMITED",
"VAIGAI ENTERTAINMENT PRIVATE LIMITED",
"VAIGAI SANITATION PRIVATE LIMITED",
"VAIGHAI AGRO PRODUCTS LIMITED",
"VAIGHAI ANIMAL NUTRITION LIMITED",
"VAIGHAI CHEMICAL INDUSTRIES LIMITED",
"VAIGHAI MOTORCYCLES PRIVATE LIMITED",
"VAIJAPUR PACHOD TOLLWAYS PRIVATE LIMITED",
"VAIJAYANTI MILK & MILK PROCESSING PRIVATE LIMITED",
"VAIJNATH MILK AND MILK PRODUCTS PRODUCER COMPANY LIMITED",
"VAIJNATH SPICES PRIVATE LIMITED",
"VAIKARAI FOODS PRIVATE LIMITED",
"VAIKUNDAM AGROTECH LIMITED",
"VAIKUNDAM PLANTATIONS LIMITED",
"VAIKUNTA WEAVES PRIVATE LIMITED",
"VAIKUNTH LINEN PRIVATE LIMITED",
"VAIKUNTH MEHTA NATIONAL INSTITUTE OF COOPERATIVE MANAGEMENT",
"VAIKUNTH PROPERTIES & BUILDERS PRIVATE LIMITED",
"VAIKUNTHA MEHTA NATIONAL INSTITUTE OF CO",
"VAILAKANNI INFO SERVICE",
"VAILANKANNI PACKAGING PRIVATE LIMITED",
"VAILLANT DILIGENT INFOSYSTEMS PRIVATE LIMITED",
"VAINATEYA BUILD PRIVATE LIMITED",
"VAINATEYA ENTREPRENEURS PRIVATE LIMITED",
"VAINATEYA MADYAMIK VIDYALAYA",
"VAINATHEYA ENTERPRISES PRIVATE LIMITED",
"VAINAVI INDUSTRIES LIMITED",
"VAINAVI INFRAASTRUCTURES PRIVATE LIMITED",
"VAINAVIN THE BAKE INN PRIVATE LIMITED",
"VAIPAN BUSINESS PRIVATE LIMITED",
"VAIPAN SECURITIES PRIVATE LIMITED",
"VAIR NETWORKS PRIVATE LIMITED",
"VAIR SYSTEMS PRIVATE LIMITED",
"VAIRAMS PUBLIC SCHOOL",
"VAISAKHI BIO-RESOURCES PRIVATE LIMITED",
"VAISALI DAIRY PRIVATE LIMITED",
"VAISAN PETROLEUM PRIVATE LIMITED",
"VAISANSAR TECHNOLOGIES PRIVATE LIMITED",
"VAISESIKA CONSULTING PRIVATE LIMITED",
"VAISH MODEL SR SEC SCHOOL",
"VAISHALI AGRI VENTURES PRIVATE LIMITED",
"VAISHALI AUTO ENGINEERING",
"VAISHALI AUTO ENTERPRISES PRIVATE LIMITED",
"VAISHALI COLLECTIONS PRIVATE LIMITED",
"VAISHALI CONFECTIONERY (INDIA) PRIVATE LIMITED",
"VAISHALI EXPRESS DELIVERY PRIVATE LIMITED",
"VAISHALI FIRE SYSTEM PRIVATE LIMITED",
"VAISHALI INFOSERV INDIA PRIVATE LIMITED",
"VAISHALI METALS PRIVATE LIMITED",
"VAISHALI PHARMA LIMITED",
"VAISHALI PLASTICS PRIVATE LIMITED",
"VAISHALI ROAD CARRIERS PRIVATE LIMITED",
"VAISHALI S THREADSTORIES PRIVATE LIMITED",
"VAISHALI SALT AND CHEMICALS PRIVATE LIMITED",
"VAISHALI SANITATION PRIVATE LIMITED",
"VAISHALI SECURITY INVESTIGATION PRIVATE LIMITED",
"VAISHISTA MANUFACTURING INDUSTRIES PRIVATE LIMITED",
"VAISHNAOI CONSTRUCTIONS LIMITED",
"VAISHNAOI HOTELS INDIA PRIVATE LMITED",
"VAISHNAOI INFRATECH AND DEVELOPERS PRIVATE LIMITED",
"VAISHNAV COLLEGE OF COMMERCE",
"VAISHNAV DALL MILL",
"VAISHNAV IMAGING INDIA PRIVATE LIMITED",
"VAISHNAV INFRASTRUCTURE PRIVATE LIMITED",
"VAISHNAV STEEL PRIVATE LIMITED",
"VAISHNAVAM STEEL TRADING PRIVATE LIMITED",
"VAISHNAVI 81 INFRASTRUCTURES LLP",
"VAISHNAVI AGROTECHE PRIVATE LIMITED",
"VAISHNAVI ALLOYS PRIVATE. LIMITED.",
"VAISHNAVI AUTO PRIVATE LIMITED",
"VAISHNAVI BIO-TECH LIMITED",
"VAISHNAVI DIGIPAYMENTS PRIVATE LIMITED",
"VAISHNAVI DUDH DAIRY",
"VAISHNAVI ENGINEERING SERVICES PRIVATE LIMITED",
"VAISHNAVI ENGINEERS AND DEVELOPERS PRIVATE LIMITED",
"VAISHNAVI ESTATES PRIVATE LIMITED",
"VAISHNAVI ESTERS PRIVATE LIMITED",
"VAISHNAVI FERRO TECH PRIVATE LIMITED",
"VAISHNAVI FOOD PRODUCTS PRIVATE LIMITED",
"VAISHNAVI FREIGHT LOGISTICS PRIVATE LIMITED",
"VAISHNAVI GLOBAL PRIVATE LIMITED",
"VAISHNAVI GRAPE AND POMOGRANATE PROCESSING PRIVATE LIMITED",
"VAISHNAVI GREEN ENERGY PRIVATE LIMITED",
"VAISHNAVI HYDRAULICS PRIVATE LIMITED",
"VAISHNAVI INFRACON INDIA PRIVATE LIMITED",
"VAISHNAVI INFRASTRUCTURE PRIVATE LIMITED",
"VAISHNAVI INFRATECH SERVICES PRIVATE LIMITED",
"VAISHNAVI LIFE CARE PRIVATE LIMITED",
"VAISHNAVI LOGISTIC SOLUTIONS PRIVATE LIMITED",
"VAISHNAVI MANAGEMENT PRIVATE LIMITED",
"VAISHNAVI METAL PRODUCTS CORPORATION PRIVATE LIMITED",
"VAISHNAVI MULTYGRAINS PRIVATE LIMITED",
"VAISHNAVI PETROLEUM PRIVATE LIMITED",
"VAISHNAVI ROLLING MILL PRIVATE LIMITED",
"VAISHNAVI UDYOG PRIVATE LIMITED",
"VAISHNAVI VAHINI MOUNT LIFE HOSPITALITY PRIVATE LIMITED",
"VAISHNAVI VYAPPAR PRIVATE LIMITED",
"VAISHNAVIMATA MULTIPROJECTS PRIVATE LIMITED",
"VAISHNO ASSOCIATES VIDYUT PROJECTS LLP",
"VAISHNO CONTRACTS PRIVATE LIMITED",
"VAISHNO DEVI RICE MILLS PRIVATE LIMITED",
"VAISHNO ELECTRONICS PRIVATE LIMITED",
"VAISHNO FLOUR MILLS PVT LTD",
"VAISHNO FURNITURE (INDIA) PRIVATE LIMITED",
"VAISHNO INDUSTRIES PRIVATE LIMITED",
"VAISHNO LOGISTIC PRIVATE LIMITED",
"VAISHNO MEDIA GRAPHIX PRIVATE LIMITED",
"VAISHNO MEGAMOVERS LLP",
"VAISHNO MERCHANDISE PRIVATE LIMITED",
"VAISHNO METALTECH PRIVATE LIMITED",
"VAISHNO PHARMATEK PRIVATE LIMITED",
"VAISHNO REAL ESTATES AND PROPERTY DEVELOPERS PRIVATE LIMITED",
"VAISHNO RUBBER INDUSTRIES PRIVATE LIMITED",
"VAISHNO SECURE SOLUTION PRIVATE LIMITED",
"VAISHNO WATER PRIVATE LIMITED",
"VAISHNO WIRE PRIVATE LIMITED",
"VAISHNODEVI ADVISORY PRIVATE LIMITED",
"VAISHNODEVI AGRO RESOURCES PRIVATE LIMITED",
"VAISHNODEVI HEALTHCARE PRIVATE LIMITED",
"VAISHNODEVI INTERNATIONAL PRIVATE LIMITED",
"VAISHNODEVI LUSH GREENS PRIVATE LIMITED",
"VAISHNODEVI REALTY PRIVATE LIMITED",
"VAISHNODEVI REFOILS AND SOLVEX",
"VAISHRAMAN INDUSTRIES PRIVATE LIMITED",
"VAISHVIK CIVILIZATION PRIVATE LIMITED",
"VAISHVIK FOODS PRIVATE. LIMITED.",
"VAISHYA REALTY PRIVATE LIMITED",
"VAISHYA SAHAKARI BANK LIMITED",
"VAISNAB SPARE PRIVATE LIMITED",
"VAISNAVI POLYMERS PRIVATE LIMITED",
"VAISYA INFRA PRIVATE LIMITED",
"VAITARNA PAINTS AND RESINS PRIVATE LIMITED",
"VAITHIANATHASWAMY THUNAI ROARKE CONSTRUCTION PRIVATE LIMITED",
"VAITHIESWARA PAPERS AND BOARDS PRIVATE LIMITED",
"VAIVIK COMMERCE PRIVATE LIMITED",
"VAJ ENGINEERING PRIVATE LIMITED",
"VAJ MARKETING AND INVESTMENTS PRIVATE LIMITED",
"VAJIRAM & RAVI INSTITUTE FOR IAS EXAMINATION",
"VAJIRAO IAS ACADEMY PRIVATE LIMITED",
"VAJRA CATERING AND HOSPITALITY SERVICES PRIVATE LIMITED",
"VAJRA CREATIONS PRIVATE LIMITED",
"VAJRA GLOBAL CONSULTING SERVICES LLP",
"VAJRA GOLD PRIVATE LIMITED",
"VAJRA MACHINERIES PRIVATE LIMITED",
"VAJRA RUBBER PRODUCTS PRIVATE LIMITED",
"VAJRA SECURITY SOLUTIONS PRIVATE LIMITED",
"VAJRA SHIPPING SERVICES PRIVATE LIMITED",
"VAJRA TELECOM PRIVATE LIMITED",
"VAJRA TRANSPOWER PRIVATE LIMITED",
"VAJRAJ JEWELS PRIVATE LIMITED",
"VAJRAKAYA HOTELS AND RESORTS PRIVATE LIMITED",
"VAJRAM AROMATICS PRIVATE LIMITED",
"VAJRAM CONSTRUCTIONS PRIVATE LIMITED",
"VAJRAM ESTATES PRIVATE LIMITED",
"VAJRAM HOLDINGS PRIVATE LIMITED",
"VAJRANAKHA TRADING PRIVATE LIMITED",
"VAJRANARAYANA POWER SERVICES PRIVATE LIMITED",
"VAJRANKURA CHIT FUNDS PRIVATE LIMITED",
"VAJRATEJA RICE CLUSTER PRIVATE LIMITED",
"VAJRO INDIA PRIVATE LIMITED",
"VAJS AGRO EXPORTS PRIVATE LIMITED",
"VAJUBHAI INVESTMENTS PVT LTD",
"VAK BOX FINNOVATORS PRIVATE LIMITED",
"VAK EDUCATION TODAY PRIVATE LIMITED",
"VAK EQUIPMENTS PRIVATE LIMITED",
"VAK LIGHTING INDIA PRIVATE LIMITED",
"VAKA RESORTS PRIVATE LIMITED",
"VAKEN TECHNOLOGIES PRIVATE LIMITED",
"VAKHARIA AIRTECH PRIVATE LIMITED",
"VAKHARIA ALUMINIUM INDUSTRIES PRIVATE LIMITED",
"VAKHARIA FOREX PRIVATE LIMITED",
"VAKIL AND SONS PRIVATE LIMITED",
"VAKILS FEFFER AND SIMONS PRIVATE LIMITED",
"VAKILS PREMEDIA PRIVATE LIMITED",
"VAKKAL IMPEX PRIVATE LIMITED",
"VAKO SEALS PRIVATE LIMITED",
"VAKONS EMBROIDERY PRIVATE LIMITED",
"VAKPATI JEWELLERS LIMITED",
"VAKRANGEE FINSERVE LIMITED",
"VAKRANGEE HOLDINGS PRIVATE LIMITED",
"VAKRANGEE LIMITED",
"VAKRATUND IMPEX PRIVATE LIMITED",
"VAKRATUND INSTITUTE HOSPITALITY AND TOURISM STUDIES",
"VAKRATUND REALINFRA PRIVATE LIMITED",
"VAKRATUNDA FARMERS PRODUCER COMPANY LIMITED",
"VAKRATUNDA HEALTHCARE PRIVATE LIMITED",
"VAKRATUNDA HOSPITAL PRIVATE LIMITED",
"VAKS INFOTECH PRIVATE LIMITED",
"VAKS MULTIPLE SERVICES PRIVATE LIMITED",
"VAKS PHARMA PRIVATE LIMITED",
"VAKSINDO ANIMAL HEALTH PRIVATE LIMITED",
"VAKSONS INDUSTRIES PRIVATE LIMITED",
"VAKTRA ACTIVATION PRIVATE LIMITED",
"VAL NIRMAN PRIVATE LIMITED",
"VAL ORGANICS PRIVATE LIMITED",
"VAL PRODUCTS INDIA PRIVATE COMPANY",
"VALA INDUSTRIES PRIVATE LIMITED",
"VALA JANU HOTELS PRIVATE LIMITED",
"VALAD BUSINESS SOLUTIONS PRIVATE LIMITED",
"VALADVISOR VALUATION AND ADVISORY SERVICES PRIVATE LIMITED",
"VALAENZA PHARMACEUTICALS PRIVATE LIMITED",
"VALAGRO BIOSCIENCES PRIVATE LIMITED",
"VALAJI FRUITNATIC PRIVATE LIMITED",
"VALAMIS INDIA PRIVATE LIMITED",
"VALAPPIL HOME STYLE PRIVATE LIMITED",
"VALAPPILA COMMUNICATIONS PRIVATE LIMITED",
"VALAR ADITI SOCIAL FINANCE PRIVATE LIMITED",
"VALARMATHI ENTERPRISES",
"VALARY LAB PRIVATE LIMITED",
"VALASYS MARKETING MEDIA LLP",
"VALASYS MEDIA PRIVATE LIMITED",
"VALATOR DEVELOPERS PRIVATE LIMITED",
"VALAYAM CREATIONS PRIVATE LIMITED",
"VALBE FOODS ( INDIA) PRIVATE LIMITED",
"VALBRUNA STAINLESS & NICKEL ALLOYS INDIA PRIVATE LIMITED",
"VALCO INDUSTRIES LIMITED",
"VALCO MELTON ENGINEERING INDIA PRIVATE LIMITED",
"VALCOM 18 MEDIA",
"VALCOM IT SERVICES PRIVATE LIMITED",
"VALCRET LIFE SCIENCES PRIVATE LIMITED",
"VALDARIA IMPEX PRIVATE LIMITED",
"VALDEL ENGINEERS AND CONSTRUCTORS PRIVATE LIMITED",
"VALDEL INVESTMENTS PRIVATE LIMITED",
"VALDEL XTENT GLOBAL SERVICES PRIVATE LIMITED",
"VALE INDIA PRIVATE LIMITED",
"VALECHA BADWANI SENDHWA TOLL WAYS LIMITED",
"VALEDRA PRIVATE LIMITED",
"VALENCIA CERAMIC PRIVATE LIMITED",
"VALENCIA HOMES PRIVATE LIMITED",
"VALENCIA INDIA PRIVATE LIMITED",
"VALENCIA NUTRITION LIMITED",
"VALENCY COMPOUNDS SERVICES PRIVATE LIMITED",
"VALENETECH PRIVATE LIMITED",
"VALENS ELEVATORS PRIVATE LIMITED",
"VALENS MOLECULES PRIVATE LIMITED",
"VALENS PHARMACHEM PRIVATE LIMITED",
"VALENS TRADESERV PRIVATE LIMITED",
"VALENS WELLBEING PRIVATE LIMITED",
"VALENTA AI PRIVATE LIMITED",
"VALENTA KPO PRIVATE LIMITED",
"VALENTE LIFESPACE CREATORS PRIVATE LIMITED",
"VALENTIA FARM FRESH PRIVATE LIMITED",
"VALENTINA PIPES PRIVATE LIMITED",
"VALENTINE AGRO PRIVATE LIMITED",
"VALENTINE CINE VISION LIMITED",
"VALENTINE JEWLLERY INDIA PRIVATE.LIMITED",
"VALENTINE PROPERTIES PRIVATE LIMITED",
"VALENTINO SYNTEX PRIVATE LIMITED",
"VALENTIS ADVISORS PRIVATE LIMITED",
"VALENTIS CANCER CARE HOSPITAL PRIVATE LIMITED",
"VALENTIS LABORATORIES PRIVATE LIMITED",
"VALEO FRICTION MATERIALS INDIA PRIVATE LIMITED",
"VALEO INDIA PRIVATE LIMITED",
"VALEO INVESTMENTS PRIVATE LIMITED",
"VALEO MOTHERSON THERMOL COMMERCIAL VEHICLES INDIA LIMITED",
"VALEO NUTRA PRIVATE LIMITED",
"VALEREY PRIVATE LIMITED",
"VALERIAN CHEM PRIVATE LIMITED",
"VALERIO INFRASTRUCTURE LLP",
"VALERION IMPEX PRIVATE LIMITED",
"VALERIUS ENTERPRISE PRIVATE LIMITED",
"VALERO ENERGY",
"VALESHVAR BIO TECH PRIVATE LIMITED",
"VALETH HIGHTECH COMPOSITES PRIVATE LIMITED",
"VALETHI TECHNOLOGIES LLP",
"VALEUR FABTEX PRIVATE LIMITED",
"VALEURHR E-SOLUTIONS PRIVATE LIMITED",
"VALFLER AND AUTLERR INDIA PRIVATE LIMITED",
"VALFOM INDUSTRIES PRIVATE LIMITED",
"VALFORMA TECHNOLOGY SERVICES PRIVATE LIMITED",
"VALGAA FINANCIAL SERVICES LIMITED",
"VALGEN BUSINESS SOLUTIONS PRIVATE LIMITED",
"VALGENESIS INDIA PRIVATE LIMITED",
"VALGRO ENGINEERS PRIVATE LIMITED",
"VALHALL EXPORTS PRIVATE LIMITED",
"VALIA RETAIL PRIVATE LIMITED",
"VALIANCE ANALYTICS PRIVATE LIMITED",
"VALIANCE ENGINEERS PRIVATE LIMITED",
"VALIANT ALUCAST TECHNOLOGY PRIVATE LIMITED",
"VALIANT CODEMARKZ PRIVATE LIMITED",
"VALIANT COMMUNICATIONS LIMITED",
"VALIANT GLASS WORKS PRIVATE LIMITED",
"VALIANT IMPEX LLP",
"VALIANT ORGANICS LIMITED",
"VALIANT-TMS SYSTEMS PRIVATE LIMITED",
"VALIDEA STOCKS MANAGEMENT PRIVATE LIMITED",
"VALIDUS INFRA PRIVATE LIMITED",
"V-ALIGN TECHNOLOGIES PRIVATE LIMITED",
"VALINGRO EXPONENTA PRIVATE LIMITED",
"VALION E ASSETS PRIVATE LIMITED",
"VALLABH AGENCIES PRIVATE LIMITED",
"VALLABH AGRI TRADE PRIVATE LIMITED",
"VALLABH BIO SCIENCE PRIVATE LIMITED",
"VALLABH DIAMONDS PRIVATE LIMITED",
"VALLABH FABRIKS LIMITED",
"VALLABH IMPEX (INDIA) PRIVATE LIMITED",
"VALLABH INFRATECH PRIVATE LIMITED",
"VALLABH KNITS PRIVATE LIMITED",
"VALLABH PESTICIDES LIMITED",
"VALLABH PUMPS PRIVATE LIMITED",
"VALLABH REALTORS PVT LTD",
"VALLABH SNACKS PRIVATE LIMITED",
"VALLABH STEEL NORTH PRIVATE LIMITED",
"VALLABH STEELS LIMITED",
"VALLABH VIDYAMANDIR PADALDE",
"VALLABH YARNS PRIVATE LIMITED",
"VALLABHA FEEDS PRIVATE LIMITED",
"VALLABHA INDUSTRIAL CHEMICAL ENGINEERS PRIVATE LIMITED",
"VALLABHANENI CONSTRUCTIONS PRIVATE LIMITED",
"VALLABHDAS KANJI LIMITED",
"VALLALAR MATRICULATION HIGHER SECONDARY SCHOOL",
"VALLALAR TEXTILES PRIVATE LIMITED",
"VALLAM (PHASE III) LOGISTICS PARK PRIVATE LIMITED",
"VALLAM (PHASE IV) LOGISTICS PARK PRIVATE LIMITED",
"VALLATHOL RUBBERS PVT LTD",
"VALLEY COMTRADE PRIVATE LIMITED",
"VALLEY CONSTRUCTION COMPANY PRIVATE LIMITED",
"VALLEY CREST SOFTWARE PRIVATE LIMITED",
"VALLEY ELECTROVISION PRIVATE LIMITED",
"VALLEY FLIERS SERVICES PRIVATE LIMITED",
"VALLEY FRESH COLD CHAIN PRIVATE. LIMITED.",
"VALLEY HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED",
"VALLEY OIL MILLS PRIVATE LIMITED",
"VALLEY POINT INDIA PRIVATE LIMITED",
"VALLEY VIEW HIGH SCHOOL",
"VALLEY VIEW SCHOOL",
"VALLEY VISTAS HOTEL PRIVATE LIMITED",
"VALLHABHA MILK PRODUCTS PRIVATE LIMITED",
"VALLI PAINTS PRIVATE LIMITED",
"VALLIAMMAI ENGINEERING COLLEGE",
"VALLIAMMAI SOCIETY",
"VALLIAMMAL COLLEGE FOR WOMEN",
"VALLIAPPA SOFTWARE TECHNOLOGICAL PARK PRIVATE LIMITED",
"VALLON FARMDIRECT PRIVATE LIMITED",
"VALLOOR MOTORS PRIVATE LIMITED",
"VALLUM CAPITAL ADVISORS PRIVATE LIMITED",
"VALLURUPALLI NAGESWARA RAO VIGNANA JYOTHI INSTITUTE OF ENG",
"VALLUVANAD HOSPITAL COMPLEX LTD",
"VALLUVANAD TRADERS PRIVATE LIMITED",
"VALLUVANADU NIDHI LIMITED",
"VALLUVAR GURUKULAM HR SEC SCHOOL",
"VALMARK DEVELOPERS PRIVATE LIMITED",
"VALMARK REALTY HOLDINGS PRIVATE LIMITED",
"VALMAX CONSTRUCTION PVT LTD",
"VALMET AUTOMATION PRIVATE LIMITED",
"VAL-MET ENGINEERING PRIVATE LIMITED",
"VALMET TECHNOLOGIES AND SERVICES PRIVATE LIMITED",
"VALMET TECHNOLOGIES PRIVATE LIMITED",
"VALMIKI CONSULTANTS PRIVATE LIMITED",
"VALMIKI NGR HIN MDY SCH N M C",
"VALMO PHARMACEUTICALS PRIVATE LIMITED",
"VALMONT STRUCTURES PRIVATE LIMITED",
"VALO AUTOMOTIVE PRIVATE LIMITED",
"VALOR ENGINEERING PRIVATE LIMITED",
"VALOR HOSPITALITY PRIVATE LIMITED",
"VALOR MECH PRIVATE LIMITED",
"VALORA PLYWOOD PRIVATE LIMITED",
"VALORANT CONSULTING PRIVATE LIMITED",
"VALOREM PRIVATE LIMITED",
"VALOREM STACK PRIVATE LIMITED",
"VALORIZ DIGITAL PRIVATE LIMITED",
"VALORX INDIA PRIVATE LIMITED",
"VALOUR WIRES PRIVATE LIMITED",
"VALOURS ALLOYS INC",
"VALPLAST TECHNOLOGIES LIMITED",
"VAL-Q INVESTMENT ADVISORY PRIVATE LIMITED",
"VALRACK MODULAR SYSTEMS PRIVATE. LIMITED.",
"VALSAD DIST CO-OP MILK PRODUCERS'S UNION LTD",
"VALSAD DISTRICT EDUCATION COMMITTEE MANAGED PRIMARY SCHOOL TEACHER",
"VALSAD JILALA SHIKSHAN SAMITI GOVERNMENT PRIMARY SCHOOL",
"VALSAD POLYMERS PRIVATE LIMITED",
"VALSAD ROYAL SALES PRIVATE LIMITED",
"VALSERVE SOURCEIN SOLUTIONS PRIVATE LIMITED",
"VALSON INDUSTRIES LIMITED",
"VALSON POLYESTER LIMITED",
"VALSONS",
"VALSON'S COMPUTERS PRIVATE LIMITED",
"VALSPAR INDIA COATINGS CORPORATION PRIVATE LIMITED",
"VALTECH INDIA SYSTEMS PRIVATE LIMITED",
"VALTITUDE TECHNOLOGIES INDIA PRIVATE LIM",
"VALTREE GLOBAL PRIVATE LIMITED",
"VALTRIS SPECIALTY CHEMICALS INDIA PRIVATE LIMITED",
"VALTRIX TECHNOLOGIES PRIVATE LIMITED",
"VALU CONNEX TELECOM SERVICES PRIVATE LIMITED",
"VALUABLE EDUTAINMENT PRIVATE LIMITED",
"VALUABLE EVENTURES LLP",
"VALUABLE MEDIA PRIVATE LIMITED",
"VALUABLE PROPERTIES PRIVATE LIMITED",
"VALUABLE TECHNOLOGIES LIMITED",
"VALUABLE TECHNOLOGIES PRIVATE LIMITED",
"VALUE & ASSETS HOLDINGS PRIVATE LIMITED",
"VALUE 360 COMMUNICATIONS PRIVATE LIMITED",
"VALUE ADDED COATING SOLUTION PRIVATE LIMITED",
"VALUE ADDED FASHION FABRICS PRIVATE LIMITED",
"VALUE ADDED FASHION FABRICS PRIVATE. LIMITED.",
"VALUE ADDED TYRE SOLUTIONS PRIVATE LIMITED",
"VALUE AND BUDGET HOUSING CORPORATION PRIVATE LIMITED",
"VALUE CAPRISE PRIVATE LIMITED",
"VALUE CENTRUM RETAIL PRIVATE LIMITED",
"VALUE CHAIN SOLUTIONS (INDIA) PRIVATE LIMITED",
"VALUE CHEM PRIVATE LIMITED",
"VALUE CREATORS & CONSULTANTP LIMITED",
"VALUE CREED CONSULTING LLP",
"VALUE ENABLERS (OPC) PRIVATE LIMITED",
"VALUE ETHICS PRIVATE LIMITED",
"VALUE FORMULATIONS PRIVATE LIMITED",
"VALUE FREIGHTDELHI PRIVATE LIMITED",
"VALUE HOMZ REALTORS PRIVATE LIMITED",
"VALUE IBMS SOLUTIONS PRIVATE LIMITED",
"VALUE IDEAS INVESTMENT SERVICES PRIVATE LIMITED",
"VALUE INGREDIENTS PRIVATE LIMITED",
"VALUE INNOVATION PRIVATE LIMITED",
"VALUE INSOURCE INDIA PRIVATE LIMITED",
"VALUE JOBS CONSULTING PRIVATE LIMITED",
"VALUE LINE ADVISORS PRIVATE LIMITED",
"VALUE LINE HOMESTYLE PRIVATE LIMITED",
"VALUE LINE INTERIORS PRIVATE LIMITED",
"VALUE LINE TRADE PRIVATE LIMITED",
"VALUE LUBRICANTS INDIA PRIVATE LIMITED",
"VALUE MANAGEMENT SOLUTION PRIVATE LIMITED",
"VALUE MAX SYSTEMS PRIVATE LIMITED",
"VALUE MOMENTUM CORPORATE SERVICES PRIVATE LIMITED",
"VALUE MOTOR AGENCY PRIVATE LIMITED",
"VALUE NETWORK VENTURES ADVISORY SERVICES PRIVATE LIMITED",
"VALUE PACK INDIA PRIVATE LIMITED",
"VALUE PACKAGING INDUSTRIES PRIVATE LIMITED",
"VALUE PHARMA HOLISTIC REMEDIES PRIVATE LIMITED",
"VALUE PHARMA RETAIL HYD PRIVATE LIMITED",
"VALUE PICK FURNISHINGS PRIVATE LIMITED",
"VALUE PLUS COMMODITIES PRIVATE LIMITED",
"VALUE PLUS RETAIL PRIVATE LIMITED",
"VALUE POINT SYSTEMS PRIVATE LIMITED",
"VALUE PROLIFIC CONSULTING SERVICES PRIVATE LIMITED",
"VALUE RECYCLERS AND RECLAIMERS PRIVATE LIMITED",
"VALUE REFRIGERANTS PRIVATE LIMITED",
"VALUE RESEARCH INDIA PRIVATE LIMITED",
"VALUE SEED PRIVATE LIMITED",
"VALUE SERVICES INTERNATIONAL PRIVATE LIMITED",
"VALUE SPACES LOGISTICS & INDUSTRIAL PARK POLIVAKKAM PRIVATE LIMITED",
"VALUE SPACES LOGISTICS PRIVATE LIMITED",
"VALUE SQUARE ADVISORS PRIVATE LIMITED",
"VALUE TREE CONSULTING SERVICES PRIVATE LIMITED",
"VALUE TREE RETAIL LLP",
"VALUE VISION OPTICALS PRIVATE LIMITED",
"VALUE V-MART PRIVATE LIMITED",
"VALUE WINGS ENTERPRISES PRIVATE LIMITED",
"VALUEADD RESEARCH AND ANALYTICS SOLUTIONS LLP",
"VALUEADD SOFTTECH & SYSTEMS PRIVATE LIMITED",
"VALUEADDS FACILITIES MANAGEMENT SERVICES PRIVATE LIMITED",
"VALUEAGRA TECHNOLOGIES PRIVATE LIMITED",
"VALUEBRIDGE CAPITAL ADVISORS PRIVATE LIMITED",
"VALUECART PRIVATE LIMITED",
"VALUECENT CONSULTANCY PRIVATE LIMITED",
"VALUECFO CONSULTING PRIVATE LIMITED",
"VALUECODERS SERVICES LLP",
"VALUECOM INFOSOLUTIONS PRIVATE LIMITED",
"VALUECON PRIVATE LIMITED",
"VALUEDATA TECHNOLOGIES PRIVATE LIMITED",
"VALUEDESIGN SERVICES PRIVATE LIMITED",
"VALUEDIRECT COMMUNICATIONS PRIVATE LIMITED",
"VALUEFIRST CONNECT PRIVATE LIMITED",
"VALUEFIRST DIGITAL MEDIA PRIVATE LIMITED",
"VALUEFY TECHNOLOGIES PRIVATE LIMITED",
"VALUELABS LLP",
"VALUELABS SERVICES PRIVATE LIMITED",
"VALUELABS SOLUTIONS LLP",
"VALUELABS TECHNOLOGIES LLP",
"VALUELEAF SERVICES INDIA PRIVATE LIMITED",
"VALUEMAN ORGANIC AGRITECH PRIVATE LIMITED",
"VALUEMAP TECHNOLOGIES PRIVATE LIMITED",
"VALUEMART SUPERMARKETS PRIVATE LIMITED",
"VALUEMATE PACK-N-PRINT PRIVATE LIMITED",
"VALUEMAX ADVISORS CONSULTING PRIVATE LIMITED",
"VALUEMENTOR INFOSEC PRIVATE LIMITED",
"VALUEMOBI MEDIA PRIVATE LIMITED",
"VALUEMOMENTUM SOFTWARE SERVICES PRIVATE LIMITED",
"VALUENCE TRAINING AND RESEARCH PRIVATE LIMITED",
"VALUENOTES STRATEGIC INTELLIGENCE PRIVATE LIMITED",
"VALUENT INFRADEVELOPERS PRIVATE LIMITED",
"VALUEONE CYBERSPACE PRIVATE LIMITED",
"VALUE-ONE RETAIL PRIVATE LIMITED",
"VALUEONSHORE ADVISORY SERVICES PRIVATE LIMITED",
"VALUEPERSQFT REALTY SERVICE PRIVATE LIMITED",
"VALUEPITCH ETECHNOLOGIES PRIVATE LIMITED",
"VALUEPLUS INVESTMENT ADVISORS PRIVATE LIMITED",
"VALUEPLUS OUT SOURCING & CONSULTANCY SERVICES PRIVATE LIMITED",
"VALUEPLUS TRADEX PRIVATE LIMITED",
"VALUEPOINT TECHSOL PRIVATE LIMITED",
"VALUEPRO LEARNING & CONSULTING PRIVATE LIMITED",
"VALUEQUEST INVESTMENT ADVISORS PRIVATE LIMITED",
"VALUES SPACES REALTORS PRIVATE LIMITED",
"VALUESHOPPE RETAILS PRIVATE LIMITED",
"VALUESHORE INFOTECH PRIVATE LIMITED",
"VALUESOFT INFO SERVICES PRIVATE LIMITED",
"VALUESOURCE TECHNOLOGIES PRIVATE LIMITED",
"VALUETREE INDIA PRIVATE LIMITED",
"VALUETREE INGREDIENTS PRIVATE LIMITED",
"VALUEVEST SERVICES PRIVATE LIMITED",
"VALUEWING CONSULTANCY SERVICES PRIVATE LIMITED",
"VALUFOCUS CORPORATE SERVICES PRIVATE LIMITED",
"VALUPACHAYIL RUBBERS PRIVATE LIMITED",
"VALUVOX DATASTORIES PRIVATE LIMITED",
"VALVAN SOENEN INDIA PRIVATE LIMITED",
"VALVAYA CAPITAL PRIVATE LIMITED",
"VALVEMATICS ENGINEERING PRIVATE LIMITED",
"VALVETORK CONTROL INDIA PRIVATE LIMITED",
"VALVEWORKS INDIA PRIVATE LIMITED",
"VALVINOX S R L INDIA PRIVATE LIMITED",
"VALVOLINE CUMMINS PRIVATE LIMITED",
"VALVOLINE LUBRICANTS AND SOLUTIONS INDIA PRIVATE LIMITED",
"VALVTECHNOLOGIES PRIVATE LIMITED",
"VALVUM PRO SCIENCES PRIVATE LIMITED",
"VALY IMPEX PRIVATE LIMITED",
"VALYOU PRODUCTS PRIVATE LIMITED",
"VALYRIAN LABS PRIVATE LIMITED",
"VAM ADVERTISING & MARKETING PRIVATE LIMITED",
"VAM BOX & CONTAINERS PRIVATE LIMITED",
"VAM HOLDINGS LIMITED",
"VAM INFOSYS PRIVATE LIMITED",
"VAM POLY PLAST PRIVATE LIMITED",
"VAMA AMRATLAL ENTERPRISES LIMITED",
"VAMA APPARELS (INDIA) PRIVATE LIMITED",
"VAMA APPARELS(INDIA) PVT LTD",
"VAMA ART & CRAFT PRIVATE LIMITED",
"VAMA COMMUNICATIONS PRIVATE LIMITED",
"VAMA CONSTRUCTION CO.",
"VAMA ECOTELS PRIVATE LIMITED",
"VAMA EVENTS PRIVATE LIMITED",
"VAMA FABRICS LIMITED",
"VAMA FOODS PRIVATE LIMITED",
"VAMA INDUSTRIES LIMITED",
"VAMA INFRA",
"VAMA INFRACREATIONS PRIVATE LIMITED",
"VAMA OIL PRIVATE LIMITED",
"VAMA SUNDARI INVESTMENTS (DELHI) PRIVATE LIMITED",
"VAMA VISHWA CO OPERATIVE CREDIT AND SUPPLY SOC LTD",
"VAMA WOMENS HOSPITAL PRIVATE LIMITED",
"VAMA WOVEN FAB PRIVATE LIMITED",
"VAMAA DAIRY PRIVATE LIMITED",
"VAMAJA ENGINEERING PRIVATE LIMITED",
"VAMAN HEALTHCARE AND EXPORTS PRIVATE LIMITED",
"VAMAN JEWELLERS INDIA PRIVATE LIMITED",
"VAMAN PHARMA PRIVATE LIMITED",
"VAMAN PIPES PRIVATE LIMITED",
"VAMAN SHANKAR MARATHE JEWELLERS PRIVATE LIMITED",
"VAMANA BHAGYA PRIVATE LIMITED",
"VAMANI OVERSEAS PRIVATE LIMITED",
"VAMAS FASHION PRIVATE LIMITED",
"VAMG CAPITAL SERVICES PRIVATE LIMITED",
"VAMG DIGITAL TELECOM SERVICES PRIVATE LIMITED",
"VAMIKA COATINGS & EQUIPMENTS PRIVATE LIMITED",
"VAMIL BUILDERS & DEVELOPERS PRIVATE LIMITED",
"VAMO SYSTEMS P LIMITED",
"VAMONA DEVELOPERS PRIVATE LIMITED",
"VAMS SAFEGUARD PRIVATE LIMITED",
"VAMSADHARA RICE INDUSTRIES",
"VAMSEE SEED (INDIA) PRIVATE LIMITED",
"VAMSEE SHIPPING CARRIER PRIVATE LIMITED",
"VAMSHA RETAIL VENTURES PRIVATE LIMITED",
"VAMSHADHARA PAPER MILLS LIMITED",
"VAMSHADHARA SEEDS PRIVATE LIMITED",
"VAMSHI ENGINEERING PRIVATE LIMITED",
"VAMSHI MOTORS PRIVATE LIMITED",
"VAMSHI RUBBER LIMITED",
"VAMSI LABS LIMITED",
"VAMSI PHARMA PRIVATE LIMITED",
"VAMSI PRAGMA HOSPITALS PRIVATE LIMITED",
"VAMSIRAM BUILDERS LLP",
"VAMSO BIOTEC PRIVATE LIMITED",
"VAMSOFT TECH AND CONSULTANCY SERVICES",
"VAMSTAR INDIA PRIVATE LIMITED",
"VAMTECH ENERGY SOLUTIONS PRIVATE LIMITED",
"VAN INKS AND CHEMICALS PRIVATE LIMITED",
"VAN NORMAN MACHINE (INDIA) PRIVATE LIMITED",
"VAN OORD INDIA PRIVATE LIMITED",
"VAN PUMPS AND CONTROL SYSTEMS PRIVATE LIMITED",
"VAN REES INDIA PRIVATE LIMITED",
"VAN TEX PRIVATE LIMITED",
"VAN VET PRIVATE LIMITED",
"VAN VITA IMAGING SYSTEMS PRIVATE LIMITED",
"VANA ENTERPRISES LIMITED",
"VANAIK INVESTORS LTD",
"VANAIK J.J. FOODS PRIVATE. LIMITED.",
"VANAIK SPINNING MILLS LIMITED",
"VANAJA BUILDERS PRIVATE LIMITED",
"VANAMALI HOSPITALS LLP",
"VANAMALI ORGANICS PRIVATE LIMITED",
"VANAMALI SEEDS PRIVATE LIMITED",
"VANAMO CARE PRIVATE LIMITED",
"VANAN ONLINE SERVICES PRIVATE LIMITED",
"VANANCHAL CONCAST PRIVATE LIMITED",
"VANANCHAL IT SERVICES PRIVATE LIMITED",
"VANANCHAL STEEL ALLOYS PRIVATE LIMITED",
"VANAPAMULA SEEDS PRIVATE LIMITED",
"VANARSENA SERVICES PRIVATE LIMITED",
"VANASPATI FATS & OIL PRIVATE LIMITED",
"VANASRI AGRO SERVICES PRIVATE LIMITED",
"VANASRI SEEDS PRIVATE LIMITED",
"VANATANTRA BEAUTY ESSENTIALS PRIVATE LIMITED",
"VANATOR TECHNOLOGY PRIVATE LIMITED",
"VANAVANI MATRICULATION HIGHER SECONDARY SCHOOL",
"VANAZ ENGINEERS LIMITED",
"VAN-BENT MINERALS PRIVATE LIMITED",
"VANBROS CONSTRUCTION INDIA LIMITED",
"VANBROS CONSTRUCTION PRIVATE LIMITED",
"VANBROS HOME PRIVATE LIMITED",
"VANCA FASHIONS PRIVATE LIMITED",
"VANCE AND HEALTH PHARMACEUTICALS PRIVATE LIMITED",
"VANCHINAD FINANCE PRIVATE LIMITED",
"VANCHINAD FORGINGS PRIVATE LIMITED",
"VANCHINAD MOTORS PRIVATE LIMITED",
"VANCHINAD PHARMA PRIVATE LIMITED",
"VANDAC PROPERTIES PRIVATE LIMITED",
"VANDAN FOODS LIMITED",
"VANDAN FORWARDERS PVT LTD",
"VANDAN INFRA PROJECTS PRIVATE LIMITED",
"VANDANA AIR TRAVELS PRIVATE LIMITED",
"VANDANA AIRCRAFT SERVICES PRIVATE LIMITED",
"VANDANA ALLOY AND METALS INDIA PRIVATE LIMITED",
"VANDANA CREATION PRIVATE LIMITED",
"VANDANA CREATIONS PRIVATE LIMITED",
"VANDANA DISTILLERIES PRIVATE LIMITED",
"VANDANA DISTRIBUTORS PRIVATE LIMITED",
"VANDANA FARMS AND RESORTS PRIVATE LIMITED",
"VANDANA FINVEST PVT. LTD.",
"VANDANA GLOBAL LIMITED",
"VANDANA GRAPHICS PRIVATE LIMITED",
"VANDANA GRIHA NIRMAN LIMITED",
"VANDANA INFRASTRUCTURES PRIVATE LIMITED",
"VANDANA INTERNATIONAL SR. SEC. SCHOOL",
"VANDANA ISPAT LIMITED",
"VANDANA ISPAT PRIVATE LIMITED",
"VANDANA KNITWEAR LIMITED",
"VANDANA LIFE SCIENCES PRIVATE LIMITED",
"VANDANA MARBLES PVT. LTD.",
"VANDANA ORGANIC TRADE PRIVATE LIMITED",
"VANDANA PACKAGING PRIVATE LIMITED",
"VANDANA PRINTING WORKS PRIVATE LIMITED",
"VANDANA ROLLING MILLS LIMITED.",
"VANDANA ROLLING MILLS PRIVATE LIMITED",
"VANDANA SPONGE & STEEL PRIVATE LIMITED",
"VANDANA SURGI PHARMA PRIVATE LIMITED",
"VANDANA TECHNOFAB PRIVATE LIMITED",
"VANDANA TIMBER PRIVATE LIMITED",
"VANDANA TRACTORS PRIVATE LIMITED",
"VANDANA TRADELINKS PRIVATE LIMITED",
"VANDANA TRAILORS AND BODY MFG PRIVATE LIMITED",
"VANDANMEDU GREEN GOLD CARDAMOM PRODUCER COMPANY LIMITED",
"VANDAYAR ENGINEERING COLLEGE",
"VANDE STEEL PRIVATE LIMITED",
"VANDEMATARAM PROJECTS PRIVATE LIMITED",
"VANDERLANDE INDUSTRIES PRIVATE LIMITED",
"VANDEU INDIA PRIVATE LIMITED",
"VANDEVI RESOURCES PRIVATE LIMITED",
"VANDEWIELE-SAVIO INDIA PRIVATE LIMITED",
"VANDEY CONSULTANCY SERVICES PRIVATE LIMITED",
"VANDHANA INTERNATIONAL PRIVATE LIMITED",
"VANDHARA INDUSTRIES PRIVATE LIMITED",
"VANDHARA RESORTS PRIVATE LIMITED",
"VANDITA ENCLAVE PRIVATE LIMITED",
"VANDO INTECH PRIVATE LIMITED",
"VANE CONSULTING PRIVATE LIMITED",
"VANEERA INDUSTRIES PRIVATE LIMITED",
"VANEESA INFRA DEVELOPERRS PRIVATE LIMITED",
"VANEETA TEXCRAFT PRIVATE LIMITED",
"VANENBURG SOFTWARE INDIA PRIVATE LIMITED",
"VANESA CARE PRIVATE LIMITED",
"VANESA COSMETICS PRIVATE LIMITED",
"VANESA INDUSTRIES PRIVATE LIMITED",
"VANESSA BUYING SERVICES PRIVATE LIMITED",
"VANGARD LOGISTICS PRIVATE LIMITED",
"VANGILI HATCHERIES PRIVATE LIMITED",
"VANGUARD BUSINESS SCHOOL PRIVATE LIMITED",
"VANGUARD DIAGNOSTICS PRIVATE LIMITED",
"VANGUARD FASHION AND APPAREL PRIVATE LIMITED",
"VANGUARD HEALTH SYSTEMS, INC.",
"VANGUARD HOLIDAYS (INDIA) LIMITED",
"VANGUARD INDUSTRIES PRIVATE LIMITED",
"VANGUARD KEMAGRO PRIVATE LIMITED",
"VANGUARD SERVICES PRIVATE LIMITED",
"VANGUARD STEEL PRIVATE LIMITED",
"VANGUARD THERAPEUTICS PRIVATE LIMITED",
"VANGUARDS SECURITY SERVICES & SYSTEMS",
"VANHEAL FOOD PRIVATE LIMITED",
"VANI AGENCIES PRIVATE LIMITED",
"VANI AGRO FARMS PRIVATE LIMITED",
"VANI AUTOMOBILES PRIVATE LIMITED",
"VANI CHEMICALS &INTERMEDIATES LIMITED",
"VANI CHEMICALS PRIVATE LIMITED",
"VANI COMMERCIALS LIMITED",
"VANI ELECTRIC VEHICLES PRIVATE LIMITED",
"VANI ENERGY PRIVATE LIMITED",
"VANI FAB ENGINEERS PVT LTD",
"VANI FABRICS PRIVATE LIMITED",
"VANI FINANCIAL AND ACCOUNTING SERVICES PRIVATE LIMITED",
"VANI GEMS PRIVATE LIMITED",
"VANI KABIR MULTIVERSE PRIVATE LIMITED",
"VANI ORGANICS PRIVATE LIMITED",
"VANI PLASTICS & PLANTATIONS PRIVATE LIMITED",
"VANI PRIVATE LIMITED.",
"VANI SOAP WORKS PRIVATE LIMITED",
"VANI SYSTEMS PRIVATE LIMITED",
"VANI VIDYALAYA MATRICULATION HR SEC SCHOOL",
"VANIJ TEXO PACK PRIVATE LIMITED",
"VANIK EDUCATION PRIVATE LIMITED",
"VANIK INFRA PRIVATE LIMITED",
"VANIK PAPERS PRIVATE LIMITED",
"VANIK PUTRAH PRIVATE LIMITED",
"VANIKA COMMERCIAL AND HOLDINGS PRIVATE LIMITED",
"VANIKA PHARMACY PRIVATE LIMITED",
"VANIKSH INTERNATIONAL PRIVATE LIMITED",
"VANIL AUTOMOTIVES PRIVATE LIMITED",
"VANILLA CLEAN POWER PRIVATE LIMITED",
"VANILLA FIELDS PVT LTD",
"VANILLA HOLDINGS AND INVESTMENTS PRIVATE LIMITED",
"VANILLA HOSPITALITY PRIVATE LIMITED",
"VANILLA NETWORKS PRIVATE LIMITED",
"VANISH ISPAT TRADE LINK PRIVATE LIMITED",
"VANISHA AUTO PRIVATE LIMITED",
"VANITA AGROCHEM INDIA PRIVATE LIMITED",
"VANITA FOODS PRIVATE LIMITED",
"VANITA PUBLIC SCHOOL",
"VANITA VISHRAM SCHOOL",
"VANITEC PRIVATE LIMITED",
"VANITHA COLLEGE",
"VANITHA SUGARS PRIVATE LIMITED",
"VANITY COMMERCIAL PRIVATE LIMITED",
"VANIVIHAR DEVELOPERS & CONSTRUCTION PRIVATE LIMITED",
"VANKADARI ESTATES AND DEVELOPERS PRIVATE LIMITED",
"VANKAL INFRASTRUCTURE PRIVATE LIMITED",
"VANKAN SECURITY SERVICES PRIVATE LIMITED",
"VANKETASH IRRIGATION SYSTEMS PVT LTD",
"VANKON MODULAR PRIVATE LIMITED",
"VANMARK FOOD EQUIPMENT (INDIA) PRIVATE LIMITED",
"VANN REDD FOODS INDIA PRIVATE LIMITED",
"VANNA INFORMATION TECHNOLOGIES INDIA PRIVATE LIMITED",
"VANNSH LIFE SCIENCES PRIVATE LIMITED",
"VANOJAY RETAIL PRIVATE LIMITED",
"VANPIC PORTS PRIVATE LIMITED",
"VANPRASTHA INFRA PRIVATE LIMITED",
"VANPROM LIFESCIENCES PRIVATE LIMITED",
"VANQUEST PHARMA PRIVATE LIMITED",
"VANQUISH INVESTEMENT & LEASING PRIVATE LIMITED",
"VANRAJ HIGH SCHOOL (GOV)",
"VANRAJ ROLLER FLOUR MILL PRIVATE LIMITED",
"VANRAJ STEELS PRIVATE LIMITED",
"VANS AGRO FOODS PRIVATE LIMITED",
"VANS CHEMISTRY PRIVATE LIMITED",
"VANS LOGISTICS PRIVATE LIMITED",
"VANS PHARMA PRIVATE LIMITED",
"VANSA DIE CASTINGS PRIVATE LIMITED",
"VANSAN COSMETICS INDIA PRIVATE LIMITED",
"VANSE INFOTECH PRIVATE LIMITED",
"VANSH DIAMOND PRIVATE LIMITED",
"VANSH ELECTROMECHANICAL DEVICES PRIVATE LIMITED",
"VANSH FERTILIZERS PRIVATE LIMITED",
"VANSH HANDLOOM",
"VANSH INDUSTRIES PRIVATE LIMITED",
"VANSH INFOTECH PRIVATE LIMITED",
"VANSH INFRASOLUTION PRIVATE LIMITED",
"VANSH ISPAT PRIVATE LIMITED",
"VANSH JEWELLERS PRIVATE LIMITED",
"VANSH ORGANICS LIMITED",
"VANSH PETROCHEM PRIVATE LIMITED",
"VANSH POLYVINYL (INDIA) PRIVATE LIMITED",
"VANSHAJ CLOTHING PRIVATE LIMITED",
"VANSHEE BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"VANSHI FARMS PRIVATE LIMITED",
"VANSHIK CLOTHING PRIVATE LIMITED",
"VANSHIKA CHEMICALS PRIVATE LIMITED",
"VANSHIKA COMMUNICATION PRIVATE LIMITED",
"VANSHIKA FLOWERS PRIVATE LIMITED",
"VANSHIKA FOREX PRIVATE LIMITED",
"VANSHIKA HR SERVICES PRIVATE LIMITED",
"VANSHIKA INFRA CITY PRIVATE LIMITED",
"VANSHIKA PLYWOOD PRIVATE LIMITED",
"VANSHIKA PROFILES PRIVATE LIMITED",
"VANSHIKA ROAD LINES INDIA PRIVATE LIMITED",
"VANSHIKA SUGAR AND POWER INDUSTRIES LIMITED",
"VANSHIKHA COMMOTRADE PRIVATE LIMITED",
"VANSHITA LIFECARE PRIVATE LIMITED",
"VANSHUBH INDUSTRIES PRIVATE LIMITED",
"VANSON ENGINEERING PRIVATE LIMITED",
"VANSUN INTERMEDIATES PRIVATE LIMITED",
"VANSUN MEDIATECH PRIVATE LIMITED",
"VANSUN OPERATIONS PRIVATE LIMITED",
"VANSUN TECHNOLOGIES PRIVATE LIMITED",
"VANTA BIOSCIENCE LIMITED",
"VANTAGE ADVERTISING PRIVATE LIMITED",
"VANTAGE AGORA MARKETING PRIVATE LIMITED",
"VANTAGE BPO SERVICES PRIVATE. LIMITED",
"VANTAGE DETECTIVE AND SAFETY SERVICES",
"VANTAGE INDIA PRIVATE LIMITED",
"VANTAGE INTEGRATED SECURITY SOLUTIONS PRIVATE LIMITED",
"VANTAGE INTERNATIONAL MANAGEMENT COMPANY",
"VANTAGE KNOWLEDGE ACADEMY LIMITED",
"VANTAGE LIFESTYLE PRIVATE LIMITED",
"VANTAGE MARITIME PRIVATE LIMITED",
"VANTAGE ORGANIC FOODS PRIVATE LIMITED",
"VANTAGE PAPERBOARD PRIVATE LIMITED",
"VANTAGE RESEARCH PRIVATE LIMITED",
"VANTAGE SPECIALTY INGREDIENTS PRIVATE LIMITED",
"VANTAGE SYSTECH PRIVATE LIMITED",
"VANTAGEO PRIVATE LIMITED",
"VANTEC LOGISTIC INDIA PRIVATE LIMITED",
"VANTECH CHEMICALS LIMITED",
"VANTERU INFRA PROJECTS (INDIA) PRIVATE LIMITED",
"VANTHAM IMPEX PRIVATE LIMITED",
"VANTO INDUSTRIES PRIVATE LIMITED",
"VANU CHEMICALS PRIVATE LIMITED",
"VANU INDIA PRIVATE LIMITED",
"VANUATU TRADING PRIVATE LIMITED",
"VANVID CHEMICALS PRIVATE LIMITED",
"VANYA AGROINTERNATIONAL PRIVATE LIMITED",
"VANYA BUILDTECH PRIVATE LIMITED",
"VANYA EDIBLE OILS & REFINERIES PRIVATE LIMITED",
"VANYA FOODS PRIVATE LIMITED",
"VANYA LANDSCAPING & HORTICULTURE SOLUTIONS PRIVATE LIMITED",
"VANYA MARKETING PRIVATE LIMITED",
"VANYA SECURITY SERVICES PRIVATE LIMITED",
"VANYA STEELS PRIVATE LIMITED",
"VAP DIE-CAST(INDIA) PRIVATE LIMITED",
"VAP INDUCTION INDIA PRIVATE LIMITED",
"VAP PRECISION PRIVATE LIMITED",
"VAP TECHNOLOGY PRIVATE LIMITED",
"VAP TRADING PRIVATE LIMITED",
"VAPA ENGINEERING PRIVATE LIMITED",
"VAPA MACHINE TOOLS PRIVATE LIMITED",
"VAPCO ENGINEERS PRIVATE LIMITED",
"VAPI CARE PHARMA PRIVATE. LIMITED.",
"VAPI CHEMICALS PRIVATE LIMITED",
"VAPI ECO ENERGY LIMITED",
"VAPI ENTERPRISE LIMITED",
"VAPI GREEN ENVIRO LIMITED",
"VAPI MULTISPECIALITY HOSPITAL & RESEARCH CENTRE PRIVATE LIMITED",
"VAPI NAGARPALIKA",
"VAPI ORGANIC CHEMICALS PRIVATE LIMITED",
"VAPI PIGMENTS PRIVATE LIMITED",
"VAPI PRODUCTS INDUSTRIES PRIVATE LIMITED",
"VAPI SPECTROCHEM PVT LTD",
"VAPO MINERALS PRIVATE LIMITED",
"VAPPY SECURITIES PRIVATE LIMITED",
"VAPRONIX WEB PRIVATE LIMITED",
"VAPS TECHNOSOFT PRIVATE LIMITED",
"VAPSMART TECHNOLOGY PRIVATE LIMITED",
"VAPSOFT TECHNOLOGIES PRIVATE LIMITED",
"VAPSON JEWELLERY EQUIPMENTS PRIVATE LIMITED",
"VAR ENERGY & INFRA PRIVATE LIMITED",
"VAR ENTERPRISES",
"VAR FACILITY MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"VAR TECHNOLOGIES PRIVATE LIMITED",
"VAR VADHU VIVAH COLLECTION PRIVATE LIMITED",
"VARA GREEN ENERGY PRIVATE LIMITED",
"VARA INFROVATE PRIVATE LIMITED",
"VARA NURSING HOME",
"VARA SOLUTION SUPPORT PRIVATE LIMITED",
"VARA TECHNOLOGY PRIVATE LIMITED",
"VARA UNITED PRIVATE LIMITED",
"VARAAHI FARMS PRIVATE LIMITED",
"VARAANGA ENGINEERS PRIVATE LIMITED",
"VARAD AGRI TECH LIMITED",
"VARAD AUTOMATION AND ROBOTICS PRIVATE LIMITED",
"VARAD CROP SCIENCE PRIVATE LIMITED",
"VARAD EXTRUSIONS PRIVATE LIMITED",
"VARAD FERRO-ALLOYS PRIVATE LIMITED",
"VARAD FORGE PRIVATE LIMITED",
"VARAD HIGHTECH AGRICULTURAL PRIVATE LIMITED",
"VARAD MEDICARE PRIVATE LIMITED",
"VARAD MILK AND MILK PROCESSING PRIVATE LIMITED",
"VARAD MULTISPECIALITY HOSPITAL PRIVATE LIMITED",
"VARAD PROPERTY SOLUTIONS PRIVATE LIMITED",
"VARAD VINAYAK EXPORT PRIVATE LIMITED",
"VARADA CORPORATE SERVICES PRIVATE LIMITED",
"VARADA INNOVATIONS PRIVATE LIMITED",
"VARADA MARKETING PRIVATE LIMITED",
"VARADA TRADING PRIVATE LIMITED",
"VARADAVINAYAK CONTRACTORS PRIVATE LIMITED",
"VARADHASTA PLASTICS AND PACKAGING PRIVATE LIMITED",
"VARADLAXMI CONSTRUCTIONS PRIVATE LIMITED",
"VARADVINAYAK MULTI-IMPEX PRIVATE LIMITED",
"VARAGANAPATI AGRO INDUSTRIES PRIVATE LIMITED",
"VARAH DISTRIBUTORS PRIVATE LIMITED",
"VARAHA IT SOLUTIONS PRIVATE LIMITED",
"VARAHA METALIKS PRIVATE LIMITED",
"VARAHAA STEELWORKS PRIVATE LIMITED",
"VARAHAMURTI FLEXIRUB INDUSTRIES PRIVATE LIMITED",
"VARAHI DIAMONDS AND FINANCE LIMITED",
"VARAHI DIAMONDS AND FINANCE LIMITED.",
"VARAHI LIMITED",
"VARAHI MADHYAMIK SHALA",
"VARAHI PHARMA PRIVATE LIMITED",
"VARAHI POLYMERS PRIVATE LIMITED",
"VARAINYA SHOUJIKI TEXCO PRIVATE LIMITED",
"VARALAKSHMI AUTOMOBILES PRIVATE LIMITED",
"VARALAKSHMI COTTONS PRIVATE LIMITED",
"VARALAKSHMI EXTRACTIONS PRIVATE LIMITED",
"VARALAKSHMI PARABOILED RICE MILLS PRIVATE. LIMITED.",
"VARALAKSHMI STARCH INDUSTRIES PRIVATE LIMITED",
"VARALAXMI HEALTHCARE PRIVATE LIMITED",
"VARALI PROPERTIES LIMITED",
"VARALKA ENGINEERS PRIVATE LIMITED",
"VARAM PARKING PRIVATE LIMITED",
"VARAMA SIR INDIA LOGISTIC AND INFRASTRUCTURE PRIVATE LIMITED",
"VARANA DESIGN PRIVATE LIMITED",
"VARANASI AUTO CARS PRIVATE LIMITED",
"VARANASI AUTOLINK PRIVATE LIMITED",
"VARANASI BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"VARANASI COMMERCIAL LTD",
"VARANASI FAN INDUSTRIES PRIVATE LIMITED",
"VARANASI FEEDS PRIVATE LIMITED",
"VARANASI HEALTHCARE PRIVATE LIMITED",
"VARANASI INFRADEVELOPERS PRIVATE LIMITED",
"VARANASI JEWELLERY PRIVATE LIMITED",
"VARANASI KISAN PRODUCER COMPANY LIMITED",
"VARANASI MARKETING PRIVATE LIMITED",
"VARANASI MOTORS PRIVATE LIMITED",
"VARANASI NURSING HOME PRIVATE LIMITED",
"VARANASI PALACE PRIVATE LIMITED",
"VARANASI SANGAM EXPRESSWAY PRIVATE LIMITED",
"VARANASI SMART CITY LIMITED",
"VARANASI THYMOL AND AROMATIC ALLIED PRODUCT PRIVATE LIMITED",
"VARANASI WASTE SOLUTIONS PRIVATE LIMITED",
"VARANDANI AND BHANDARI TOURISM PRIVATE LIMITED",
"VARANGAON NAGARPARISHAD",
"VARANGI FASHION PRIVATE LIMITED",
"VARANIUM CAPITAL ADVISORS PRIVATE LIMITED",
"VARANIUM CLOUD LIMITED",
"VARANK TECH PRIVATE LIMITED",
"VARANOUS LABS PRIVATE LIMITED",
"VARAPRADHA REAL ESTATES PRIVATE LIMITED",
"VARAS INTERNATIONAL PVT LTD",
"VARASHAKTI HOUSING FINANCE PRIVATE LIMITED",
"VARASI AIR PRODUCTS PRIVATE LIMITED",
"VARASKAND INFRASTRUCTURE PRIVATE LIMITED",
"VARASS LOUNGERIES PRIVATE LIMITED",
"VARAT PUMP & MACHINERY PVT LTD",
"VARATHRA IT TECHNOLOGIES PRIVATE LIMITED",
"VARAV BIOGENESIS PRIVATE LIMITED",
"VARAVI MALLESHWARA CONTRACT COMPANY PRIVATE LIMITED",
"VARCAS AUTOMOBILES PRIVATE LIMITED",
"VARCHAS TEXTILES PRIVATE LIMITED",
"VARCHASVA ENERGY PRIVATE LIMITED",
"VARDA DIACASTINGS INDUSTRIES PVT LTD",
"VARDA DIOS HEALTH CARE PRIVATE LIMITED",
"VARDAAM WEB SOLUTIONS PRIVATE LIMITED",
"VARDAAN BIOTECH LIMITED",
"VARDAAN CLINIC INDIA PRIVATE LIMITED",
"VARDAAN EVENTS PRIVATE LIMITED",
"VARDAAN INFERTILITY & MEDICAL RESEARCH CENTER PRIVATE LIMITED",
"VARDAAN LIFESTYLE LIMITED",
"VARDAAN MERCHANDISING PRIVATE LIMITED",
"VARDAAN STONE AND KIDNEY HOSPITAL",
"VARDAAN TECHNOLOGIES PRIVATE LIMITED",
"VARDAAN TRADELINK PRIVATE LIMITED",
"VARDAANLIVE MEDIA NETWORK PRIVATE LIMITED",
"VARDAN ASSOCIATES PRIVATE LIMITED",
"VARDAN CAPITAL PRIVATE LIMITED",
"VARDAN CEQUBE ADVISORS PRIVATE LIMITED",
"VARDAN CREATORS PRIVATE LIMITED",
"VARDAN ENGICON PRIVATE LIMITED",
"VARDAN ENTERPRISES PRIVATE LIMITED",
"VARDAN FINLEASE LIMITED",
"VARDAN FOODS PRIVATE LIMITED",
"VARDAN GEM & JEWELS PRIVATE LIMITED",
"VARDAN HOSPITAL",
"VARDAN INTENSIVE CARE HOSPITAL PRIVATE LIMITED",
"VARDAN MULTISPECIALITY HOSPITAL",
"VARDAN NURSING HOME PRIVATE LIMITED",
"VARDAYANI POWER PRIVATE LIMITED",
"VARDE INDIA INVESTMENT ADVISER PRIVATE LIMITED",
"VARDEEP PETRO CHEMICAL PRIVATE LIMITED",
"VARDENCHI MOTORCYCLES PRIVATE LIMITED",
"VARDEX TOOLING PRIVATE LIMITED",
"VARDHA DEVELCO PRIVATE LIMITED",
"VARDHA ENTERPRISES PRIVATE LIMITED",
"VARDHAMAAN INSULAATION LIMITED",
"VARDHAMAAN SCOOTERS PRIVATE LIMITED",
"VARDHAMAN ACCIDENT HOSPITAL PRIVATE LIMITED",
"VARDHAMAN AUTOWHEELS PRIVATE LIMITED",
"VARDHAMAN BAKERS PRIVATE LIMITED",
"VARDHAMAN CAPITAL PVT.LTD.",
"VARDHAMAN COLLEGE OF ENGINEERING",
"VARDHAMAN COMFORTS PRIVATE LIMITED",
"VARDHAMAN CREATIONS PRIVATE LIMITED",
"VARDHAMAN ENGIMECH PRIVATE LIMITED",
"VARDHAMAN FABRICS PRIVATE LIMITED",
"VARDHAMAN FASHIONFAB PRIVATE LIMITED",
"VARDHAMAN I.Q. TOYS PRIVATE LIMITED",
"VARDHAMAN MEGATECH PRIVATE LIMITED",
"VARDHAMAN POLYEXTRUSION",
"VARDHAMAN PUBLISHERS LTD",
"VARDHAMAN REMEDIES PRIVATE LIMITED",
"VARDHAMAN SALTS PVT.LTD.",
"VARDHAMAN SOLVENTS AND CHEMICALS PRIVATE LIMITED",
"VARDHAMAN STAMPINGS PRIVATE LIMITED",
"VARDHAMANGLOBAL SHARECOM PRIVATE LIMITED",
"VARDHAN AGRO PROCESSING LIMITED",
"VARDHAN CAPITAL AND FINANCE LIMITED",
"VARDHAN DIAMONDS PRIVATE LIMITED",
"VARDHAN FOODS PRIVATE LIMITED",
"VARDHAN LOGISTICS PRIVATE LIMITED",
"VARDHAN LTD.",
"VARDHAN PACKAGINGS INDIA PRIVATE LIMITED",
"VARDHAN PETROCHEMICALS PRIVATE LIMITED",
"VARDHAN PIPES PRIVATE LIMITED",
"VARDHAN RESOURCES PRIVATE LIMITED",
"VARDHAN_X001A_S SHELTERS PRIVATE LIMITED",
"VARDHANA FINANCIAL DISTRIBUTORS PRIVATE LIMITED",
"VARDHANAM AGRO FOODS PRIVATE LIMITED",
"VARDHANSMART PRIVATE LIMITED",
"VARDHINI HOUSING PRIVATE LIMITED",
"VARDHISHNU TECHNOLOGIES PRIVATE LIMITED",
"VARDHMAAN HOUSEWARES LLP",
"VARDHMAN ACADEMY",
"VARDHMAN ACRYLICS LIMITED",
"VARDHMAN ADARSH ISPAT PRIVATE LIMITED",
"VARDHMAN AGRITECH PRIVATE LIMITED",
"VARDHMAN AIRPORT SOLUTIONS PRIVATE LIMITED",
"VARDHMAN AMRANTE PRIVATE LIMITED",
"VARDHMAN AUTO COMPONENTS PRIVATE LIMITED",
"VARDHMAN AUTOMOBILES PRIVATE LIMITED",
"VARDHMAN AUTOTECH PRIVATE LIMITED",
"VARDHMAN BOOKS INTERNATIONAL PRIVATE LIMITED",
"VARDHMAN CARS PRIVATE LIMITED",
"VARDHMAN CHEMTECH LIMITED",
"VARDHMAN CONDUCTOR PRIVATE LIMITED",
"VARDHMAN CREATIONS PRIVATE LIMITED",
"VARDHMAN DEVELOPERS LIMITED",
"VARDHMAN DRUGS PRIVATE LIMITED",
"VARDHMAN ELECTRICAL APPLIANCES",
"VARDHMAN ELECTRO-MECH PRIVATE LIMITED",
"VARDHMAN ELECTRONICS PRIVATE LIMITED",
"VARDHMAN ESTATES AND DEVELOPERS PRIVATE LIMITED",
"VARDHMAN ESTATES PRIVATE LIMITED",
"VARDHMAN EXPORTS",
"VARDHMAN EXTRUSIONS PRIVATE LIMITED",
"VARDHMAN FABRICS",
"VARDHMAN GAR TEX CREATORS PRIVATE LIMITED",
"VARDHMAN GLOBAL INFRASTRUCTURES PRIVATE LIMITED",
"VARDHMAN HEALTH SPECIALITIES PRIVATE LIMITED",
"VARDHMAN HOLDINGS LIMITED",
"VARDHMAN HOME APPLIANCES LIMITED",
"VARDHMAN HOSES PRIVATE. LIMITED.",
"VARDHMAN INDUSTRIAL POWER PRIVATE LIMITED",
"VARDHMAN INDUSTRIAL STEEL PRIVATE LIMITED",
"VARDHMAN INSTRUMENTS AND CHEMICAL GOODS PRIVATE LIMITED",
"VARDHMAN INTERNATIONAL SCHOOL",
"VARDHMAN JEWELLERS PRIVATE LIMITED",
"VARDHMAN KITCHENWARE PRIVATE LIMITED",
"VARDHMAN MAHAVEER OPEN UNIVERSITY",
"VARDHMAN MEDICARE PRIVATE LIMITED",
"VARDHMAN METALCON PVT LTD",
"VARDHMAN MILITARY SCHOOL",
"VARDHMAN MINING PRIVATE LIMITED",
"VARDHMAN NISSHINBO GARMENTS COMPANY LIMITED",
"VARDHMAN PEN PRIVATE LIMITED",
"VARDHMAN PHARMA DISTRIBUTORS PRIVATE LIMITED",
"VARDHMAN PLASTOCHEM PRIVATE LIMITED",
"VARDHMAN POLY PRODUCTS PRIVATE LIMITED",
"VARDHMAN POLYMERS PVT. LTD",
"VARDHMAN POLYTEX LTD",
"VARDHMAN PROPERTIES LTD",
"VARDHMAN PURE BASMATI PRIVATE LIMITED",
"VARDHMAN REALITIES",
"VARDHMAN RICE & GENERAL MILLS",
"VARDHMAN RICE EXPORTS PRIVATE LIMITED",
"VARDHMAN SCHOOL GIDDERBAHA",
"VARDHMAN SLEEPWEAR & LINGERIE PRIVATE LIMITED",
"VARDHMAN SOLVENT EXTRACTION INDUSTRIES LTD",
"VARDHMAN SPECIAL STEELS LIMITED",
"VARDHMAN SRIKALYAN INTERNATIONAL SCHOOL",
"VARDHMAN SUPPLIERS PRIVATE LIMITED",
"VARDHMAN TEX DYES PRIVATE LIMITED",
"VARDHMAN TEXTILE COMPONENTS LIMITED",
"VARDHMAN TEXTILES LIMITED",
"VARDHMAN TRUCKING PRIVATE LIMITED",
"VARDHMAN TRUSTEESHIP PRIVATE LIMITED",
"VARDHMAN VILLAS PRIVATE LIMITED",
"VARDHMAN WOOLLEN MILLS PVT LTD",
"VARDHMAN YARNS AND THREADS LIMITED",
"VARDHUSA PRIVATE LIMITED",
"VARDVINAYAK FOODS AND BEVERAGES PRIVATE LIMITED",
"VARELI TECNAC PRIVATE LIMITED",
"VARENIA CIMS PRIVATE LIMITED",
"VARENYA CONSTRUCTIONS LIMITED",
"VARENYA ENGINEERING PRIVATE LIMITED",
"VARENYA SOFTECH PRIVATE LIMITED",
"VARENYAM HEALTHCARE PRIVATE LIMITED",
"VARENYAM MACHINE TOOLS PRIVATE LIMITED",
"VARETO ELECTRO PRIVATE LIMITED",
"VAREX IMAGING INDIA PRIVATE LIMITED",
"VAREX INFRA SERVICES PRIVATE LIMITED",
"VAREYN SOLAR PRIVATE LIMITED",
"VARI COLOURS PRIVATE LIMITED",
"VARI PONTOONS PRIVATE LIMITED",
"VARIA ENTERPRISES PRIVATE LIMITED",
"VARIA HOSPITAL AND ICU PRIVATE LIMITED",
"VARIAN MEDICAL SYSTEMS INTERNATIONAL (INDIA) PRIVATE LIMITED",
"VARIANCE CONFERENCE & EVENTS PRIVATE LIMITED",
"VARIANCE INFOTECH PRIVATE LIMITED",
"VARIANCE TECHNOLOGIES SOLUTIONS PRIVATE LIMITED",
"VARIANT COMMERCIAL PRIVATE LIMITED",
"VARIANT INFOSYSTEMS PRIVATE LIMITED",
"VARIANT INFRATECH PRIVATE LIMITED",
"VARIATE CONSULTANTS PRIVATE LIMITED",
"VARIATION ELECTRIC COMPANY PRIVATE LIMITED",
"VARICON PUMPS & SYSTEMS PRIVATE LIMITED",
"VARIDHI COTSPIN PRIVATE LIMITED",
"VARIDHI HYGIENE PRODUCTS PRIVATE LIMITED VARIDHI",
"VARIE VALVES PRIVATE LIMITED",
"VARIEGATE REALESTATE PRIVATE LIMITED",
"VARIETY ALLOYS AND EXTRUSIONS PVT LTD",
"VARIETY ART STONES LIMITED",
"VARIETY FEEDS PRIVATE LIMITED",
"VARIETY FOOD PRODUCTS DISTRIBUTION COMPANY PRIVATE LIMITED",
"VARIETY FOREX PRIVATE LIMITED",
"VARIETY INDUSTRIAL WORKS PVT LTD",
"VARIETY INFO SOLUTIONS PRIVATE LIMITED",
"VARIETY INNOVATION VENTURE PRIVATE LIMITED",
"VARIETY INVESTMENTS PVT LTD",
"VARIETY LUMBERS PRIVATE LIMITED",
"VARIETY METALS PVT LTD",
"VARIETY PAVERS PRIVATE LIMITED",
"VARIETY SERVICES NOIDA PVT LTD",
"VARIETY SERVICES SAKET PRIVATE LIMITED",
"VARIETY TEA COMPANY PRIVATE LIMITED",
"VARIETY TUBULAR POLES PRIVATE LIMITED",
"VARIETY VYAPAAR PVT LTD",
"VARIFORRM TECHNOLOGY SOLUTIONS INDIA PRIVATE LIMITED",
"VARIMA FASHIONS PVT LTD",
"VARIMA JEWELS PRIVATE LIMITED",
"VARIMAN GLOBAL ENTERPRISES LIMITED",
"VARIMAN PROJECTS PRIVATE LIMITED",
"VARIN INFRA PROJECTS PRIVATE LIMITED",
"VARINDA FURNISHING PRIVATE LIMITED",
"VARINDA KNITTERS PRIVATE LIMITED",
"VARINDAVAN FABRICS PRIVATE LIMITED",
"VARINDAVAN IMPEX PRIVATE LIMITED",
"VARINDER FOUNDATION",
"VARINDERA CONSTRUCTIONS LIMITED",
"VARINDERA ORGANICS PRIVATE LIMITED",
"VARINDERA SPINNERS LTD",
"VARINDERA TOOLS PRIVATE LIMITED",
"VARIO SERVICES PRIVATE LIMITED",
"VARION FOODSCIENCES PRIVATE LIMITED",
"VARION LIFESCIENCES PRIVATE LIMITED",
"VARIOUS INFRA AND RESEARCH PRIVATE LIMITED",
"VARISCON ENGINEERING SERVICES PRIVATE LIMITED",
"VARISH SYNTHETICS PRIVATE LIMITED",
"VARISIS ADVANCED ENGINEERING PRIVATE LIMITED",
"VARISTA TRADING PRIVATE LIMITED",
"VARISTOR TECHNOLOGIES PRIVATE LIMITED",
"VARITE INDIA PRIVATE LIMITED",
"VARITURN ELECTRO PRODUCTS PRIVATE LIMITED",
"VARIVAR COATING COMPANY PRIVATE LIMITED",
"VARIVAR PLAST PRODUCTS PRIVATE LIMITED",
"VARIVAR POLYFAB (INDIA) PRIVATE LIMITED",
"VARIVAS PROPERTIES PRIVATE LIMITED",
"VARIYA DENIM PRIVATE LIMITED",
"VARIZONE SOLAR PRIVATE LIMITED",
"VARK ESTATES PRIVATE LIMITED",
"VARK SNACK FOOD PRIVATE LIMITED",
"VARKOOD PAPER AND BOARDS PRIVATE LIMITED",
"VARKS ENGINEERS PRIVATE LIMITED ( PART IX )",
"VARMA CONSTRUCTIONS PRIVATE LIMITED",
"VARMA KNIT FAB PRIVATE LIMITED",
"VARMA LABS PRIVATE LIMITED",
"VARMA POULTRY FARM PRIVATE LIMITED",
"VARMA STEELS PRIVATE LIMITED",
"VARMA SUPPLY CHAIN PRIVATE LIMITED",
"VARMAAN IMPORTS PRIVATE LIMITED",
"VARMAN AVIATION PRIVATE LIMITED",
"VARMINE ENGINEERING PRIVATE LIMITED",
"VARMINE FLOORING PRIVATE LIMITED",
"VARMORA FOODS PRIVATE LIMITED",
"VARMORA FURNITURES PRIVATE LIMITED",
"VARMORA HOMEWARES PRIVATE LIMITED",
"VARMORA PLASTECH PRIVATE LIMITED",
"VARN HOSPITALITY PRIVATE LIMITED",
"VARN TRADING COMPANY PRIVATE LIMITED",
"VARNA CHEMICALS INDIA PRIVATE LIMITED",
"VARNA COATS PRIVATE LIMITED",
"VARNA DISPLAY SYSTEMS PRIVATE LIMITED",
"VARNA GLASS & PLYWOODS TRADING PRIVATE LIMITED",
"VARNA HOMES PRIVATE LIMITED",
"VARNADA INDUSTRIES PRIVATE LIMITED",
"VARNAG BANASARI INFRA CONSTRUCTION PRIVATE LIMITED",
"VARNAG CONSTRUCTIONS PRIVATE LIMITED",
"VARNALAYA CLOTHINGS PRIVATE LIMITED",
"VARNAMAYAA DYECHEM PRIVATE LIMITED",
"VARNAV ACCOMMODATIONS PRIVATE LIMITED",
"VARNER RETAIL SERVICES SOUTH ASIA PRIVATE LIMITED",
"VARNI TEXTILES PRIVATE LIMITED",
"VARNIKA JEWELLERS",
"VARNIKA KONDENSATORS PRIVATE LIMITED",
"VARNIKA SPINNERS PRIVATE LIMITED",
"VARNINDRA RESICON PRIVATE LIMITED",
"VARNIRAJ 100TECH INFRA PRIVATE LIMITED",
"VARNITA OVERSEAS PRIVATE LIMITED",
"VARNITA PRINTS PRIVATE LIMITED",
"VARNITA TEXTILES PRIVATE LIMITED",
"VAROLOGIC TECHNOLOGIES PRIVATE LIMITED",
"VARP SOLAR SKYLIGHT PRIVATE LIMITED",
"VARRENYAM CONSULTANTS PRIVATE LIMITED",
"VARROC DELL'ORTO PRIVATE LIMITED",
"VARROC ENGINEERING LIMITED",
"VARROC LIFESCIENCES PRIVATE LIMITED",
"VARROC LIGHTING SYSTTEMS INDIA PRIVATE LIMITED",
"VARROC POLYMERS LIMITED",
"VARROC POLYMERS PRIVATE LIMITED",
"VARS BUILDERS PRIVATE LIMITED",
"VARSA PLASTIC INDUSTRIES PRIVATE LIMITED",
"VARSACE APPARELS PRIVATE LIMITED",
"VARSANA LUMBERS PRIVATE LIMITED",
"VARSHA BANITA FOODS PRIVATE LIMITED",
"VARSHA BIOSCIENCE AND TECHNOLOGY INDIA PRIVATE LIMITED",
"VARSHA BRANDWAVE PRIVATE LIMITED",
"VARSHA CABLES PRIVATE LIMITED",
"VARSHA CASTINGS AND ENGINEERING PRIVATE LIMITED",
"VARSHA CONSTRUCTION",
"VARSHA CONTROLS PRIVATE LIMITED",
"VARSHA CRANES PRIVATE LIMITED",
"VARSHA DYEING AND PRINTING MILLS PRIVATE LIMITED",
"VARSHA ENGINEERING TOOLS PRIVATE LIMITED",
"VARSHA FASHION LLP",
"VARSHA FORGINGS LIMITED",
"VARSHA FORGINGS PRIVATE LIMITED",
"VARSHA FRESH MEAT PRODUCTS PRIVATE LIMITED",
"VARSHA INDUSTRIES PRIVATE LIMITED",
"VARSHA INFRACON PRIVATE LIMITED",
"VARSHA LEATHERS PRIVATE LIMITED",
"VARSHA MOULDINGS PRIVATE LIMITED",
"VARSHA MULTITECH",
"VARSHA PACKAGING PRIVATE LIMITED",
"VARSHA POLYPIPES PRIVATE LIMITED",
"VARSHA PRINTING INKS MFG. CO.",
"VARSHA REFRACTORIES PRIVATE LIMITED",
"VARSHA RITU CONSTRUCTIONS PRIVATE LIMITED",
"VARSHA ROADLINES PRIVATE LIMITED",
"VARSHA SALES PRIVATE LIMITED",
"VARSHA SILK ENTERPRISE PVT LTD",
"VARSHA STONES INTERNATIONAL PRIVATE LIMITED",
"VARSHA SUPER STOCKIST INDIA PRIVATE LIMITED",
"VARSHA TECHNO IND-EQUIP PRIVATE LIMITED",
"VARSHA TELEMAX SERVICES PRIVATE LIMITED",
"VARSHA VISWANATH PROPERTIES PRIVATE LIMITED",
"VARSHA WIRES PRIVATE LIMITED",
"VARSHAA AGRO MACH ENGG PRIVATE LIMITED",
"VARSHCHEM ENTERPRISES PRIVATE LIMITED",
"VARSHCO CHEM PRIVATE LIMITED",
"VARSHIL PACKAGING PRIVATE LIMITED",
"VARSHINI EXIM PRIVATE LIMITED",
"VARSHINI FERTILIZER PRIVATE LIMITED",
"VARSHINI POWER PROJECTS INDIA PRIVATE LIMITED",
"VARSHINI STEEL PRIVATE LIMITED",
"VARSHIT ELECTRICALS PRIVATE LIMITED",
"VARSHITHA CONCRETE TECHNOLOGIES PRIVATE LIMITED",
"VARSHNEY ALOK SUIT PRIVATE LIMITED",
"VARSHNEY CHILDREN HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED",
"VARSHNEY POLY PACK PRIVATE LIMITED",
"VARSHNEY SHEETGRAH PRIVATE LIMITED",
"VARSHYL TECHNOLOGIES PRIVATE LIMITED",
"VARSIDDHI ENTERPRISES PRIVATE LIMITED",
"VARSIDHI TEXTILES PRIVATE LIMITED",
"VARSITY INSTRUMENTS PRIVATE LIMITED",
"VARSODA PRI SCHOOL",
"VARSTREET SOFTWARE INDIA PRIVATE LIMITED",
"VARSUN ETECHNOLOGIES PRIVATE LIMITED",
"VARSUN INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"VARTAMAN WIND ENERGY PRIVATE LIMITED",
"VARTANA CONSULTING PRIVATE LIMITED",
"VARTHACAP SOFTWARE SERVICES PRIVATE LIMITED",
"VARTHALI MEDIA WORKS PRIVATE LIMITED",
"VARTHANA FINANCE PRIVATE LIMITED",
"VARTIKA CHEMICALS AND PHARMACEUTICALS PRIVATE LIMITED",
"VARTIS ENGINEERING PRIVATE LIMITED",
"VARTMAA IMPEX PRIVATE LIMITED",
"VARUN AGRO PROCESSING FOODS PRIVATE LIMITED",
"VARUN BEVERAGES LIMITED",
"VARUN COMMODITIES PRIVATE LIMITED",
"VARUN DEVELOPERS PRIVATE LIMITED",
"VARUN DYEING AND PRINTING MILLS PVT LTD",
"VARUN ELECTRODES PRIVATE LIMITED",
"VARUN ENGINEERING AGRO PRIVATE LIMITED",
"VARUN EXPORTS",
"VARUN EXPORTS GLOBAL LLP",
"VARUN FARMERS PRODUCER COMPANY LIMITED",
"VARUN FERTILIZERS PRIVATE LIMITED",
"VARUN FINANCE",
"VARUN FOILS LIMITED",
"VARUN FOODS PROCESSING PRIVATE LIMITED",
"VARUN GEMS PRIVATE LIMITED",
"VARUN GREEN POWER PRIVATE LIMITED",
"VARUN HOMES PRIVATE LIMITED",
"VARUN HOSPITALITY PRIVATE LIMITED",
"VARUN INFRACON PRIVATE LIMITED",
"VARUN LEASING",
"VARUN LIFE SCIENCES PRIVATE LIMITED",
"VARUN MEDICO LAB PRIVATE LIMITED",
"VARUN METACRAFT PRIVATE LIMITED",
"VARUN METAL INDUSTRIES PRIVATE LIMITED",
"VARUN MOTORS PRIVATE LIMITED",
"VARUN ORGANICS PRIVATE LIMITED",
"VARUN POLYFOAM PRIVATE LIMITED",
"VARUN PRESSINGS PRIVATE LIMITED",
"VARUN PROCON PRIVATE LIMITED",
"VARUN PRODUCTS PRIVATE LIMITED",
"VARUN RADIATORS PVT LTD",
"VARUN SEEDS & AGRO TECH (INDIA) PRIVATE LIMITED",
"VARUN SELECTION PRIVATE LIMITED",
"VARUN STEEL CASTINGS PVT LTD",
"VARUN TEA PLANTATIONS LIMITED",
"VARUN TEA PLANTATIONS PRIVATE LIMITED",
"VARUN TECHNOCRATS PRIVATE LIMITED",
"VARUN TEXPORT PRIVATE LIMITED",
"VARUN TIN CANS PRIVATE LIMITED",
"VARUN VISHAL CARGO MOVERS",
"VARUNA BEARINGS PRIVATE LIMITED",
"VARUNA BIOCELL PRIVATE LIMITED",
"VARUNA D JANI JEWELLERY PRIVATE LIMITED",
"VARUNA INTEGRATED LOGISTICS PRIVATE LIMITED",
"VARUNA NEERAVARI PIPES PRIVATE LIMITED",
"VARUNA PAINTS PVT LTD",
"VARUNA SULPHONATORS LIMITED",
"VARUNA WAREHOUSING PRIVATE LIMITED",
"VARUNA-VAYU FOODS PRIVATE LIMITED",
"VARUNDEV OVERSEAS PVT LTD",
"VARUNI CORPORATE SERVICES PRIVATE LIMITED",
"VARUNIKA PRINTS PRIVATE LIMITED",
"VARUSHAPRIYA AGRO TECH PRIVATE LIMITED",
"VARUTRA CONSULTING PRIVATE LIMITED",
"VARUVAN VADIVELAN INSTITUTE OF TECHNOLOGY",
"VARYA ENGINEERS PRIVATE LIMITED",
"VARZ BUILDON PRIVATE LIMITED",
"VAS COM TECH LIMITED",
"VAS ENGINEERING PRODUCTS PRIVATE LIMITED",
"VAS FINSERVE PRIVATE LIMITED",
"VAS FOR DY DIR VETY DIRECTORATE OF VETY SR MP BPL MADHYA PRADESH",
"VAS INFO SOLUTIONS PRIVATE LIMITED",
"VAS INFRASTRUCTURE LIMITED",
"VAS KNOWLEDGE GROWTH INITIATIVES PRIVATE LIMITED",
"VAS MARKETPLACE PRIVATE LIMITED",
"VAS SPECTROMETERS PRIVATE LIMITED",
"VAS SUNDAR ORGANISERS PRIVATE LIMITED",
"VAS TRADEX OPC PRIVATE LIMITED",
"VAS TRIBOLOGY SOLUTIONS PRIVATE LIMITED",
"VASA COSMETICS PRIVATE LIMITED",
"VASA DENTICITY LIMITED",
"VASA GLOBAL TOOLING SOLUTIONS PRIVATE LIMITED",
"VASA NONWOVEN INDUSTRIES PRIVATE LIMITED",
"VASA PHARMA CHEM PRIVATE LIMITED",
"VASA SPECIALITY STEELS PRIVATE LIMITED",
"VASAD AGRO PRIVATE LIMITED",
"VASAI ELECTRICALS PRIVATE LIMITED",
"VASAI JANATA SAHAKARI BANK LIMITED.",
"VASAI PHARMA PRODUCTS",
"VASAI ROLLER FLOUR MILLS PRIVATE. LIMITED.",
"VASAI TIMBER INDUSTRIES PRIVATE LIMITED",
"VASAI VIKAS SAHAKARI BANK LTD",
"VASAI VIRAR CITY MUNICIPAL CORPORATION",
"VASAK INDUSTRIES PRIVATE LIMITED",
"VASAKA PROMOTERS AND DEVELOPERS PRIVATE LIMITED",
"VASAL HOSPITAL PRIVATE LIMITED",
"VASAN EYE CARE HOSPITAL",
"VASAN PUBLICATIONS PRIVATE LIMITED",
"VASAN TIFFAN HOME CHENNAI PRIVATE LIMITED",
"VASANI COLD CHAINS PRIVATE LIMITED",
"VASANI WOOD WORKS",
"VASANT B ED COLLEGE",
"VASANT CHEMICALS PRIVATE LIMITED",
"VASANT COSTRUCTIONS PRIVATE LIMITED",
"VASANT COTTON",
"VASANT FABRICATORS PRIVATE LIMITED",
"VASANT FABRICS PVT LTD",
"VASANT FOODS PRIVATE LIMITED",
"VASANT GALAXY CO?OP ASSOCIATION LTD",
"VASANT MASALA PRIVATE LIMITED",
"VASANT OVERSEAS PRIVATE LIMITED",
"VASANT SERVICE STATION",
"VASANT SOAPS PRIVATE LIMITED",
"VASANT SURGICO MEDICAL CENTRE PRIVATE LIMITED",
"VASANT VIHAR HIGH SCHOOL AND JUNIOR COLLEGE",
"VASANT WORKS PRIVATE LIMITED",
"VASANTA BHAVAN HOTELS INDIA PRIVATE LIMITED",
"VASANTA COLLEGE FOR WOMEN",
"VASANTDADA PATIL ARTS COMMERCE & SCIENCE COLLEGE BEED",
"VASANTDADA PATIL PRATISHTHAN'S COLLEGE OF ENGINEERING & VA",
"VASANTDADA SUGAR INSTITUTE",
"VASANTH & CO. MEDIA NETWORK PRIVATE LIMITED",
"VASANTH AGRI BIOTECH PRIVATE LIMITED",
"VASANTH VIDEO VISION PRIVATE LIMITED",
"VASANTHA ADVANCED SYSTEMS",
"VASANTHA INDUSTRIES PRIVATE LIMITED",
"VASANTHA LOGISTICS PRIVATE LIMITED",
"VASANTHA SUBRAMANIAN HEALTHCARE PRIVATE LIMITED",
"VASANTHA SUBRAMANIAN HOSPITALS INDIA PRIVATE LIMITED",
"VASANTHA SUBRAMANIAN HOSPITALS PRIVATE LIMITED",
"VASANTHA TOOL CRAFTS PRIVATE LIMITED",
"VASANTHAM ENTERPRISES",
"VASANTHAM HEALTH CENTRE PRIVATE LIMITED",
"VASANTHAVIHAR AGRO FARMS PRIVATE LIMITED",
"VASANTHI ELECTRICALS PRIVATE LIMITED",
"VASANTHI EXIM PRIVATE LIMITED",
"VASANTHI ORTHOPAEDIC HOSPITAL PRIVATE LIMITED",
"VASANTI ESTATES PRIVATE LIMITED",
"VASANTI PETRO CHEM LTD",
"VASANTRAI PETRO-CHEMICALS (INDIA) PRIVATE LIMITED",
"VASANTRAO DESAI AJARA SHETKARI SAHAKARI SAKHAR KARKHANA LTD",
"VASANTRAO DESHMUKH MADHYAMIC VIDYALAYA KHAIRGAON",
"VASANTRAO NAIK MAHAVIDYALAYA",
"VASANTRAO NAIK MARATHWADA KRISHI VIDYAPEETH",
"VASANTRAO NAIK VIDYALAY ASEGAON DEVI TQ BABHULGAON DIST YAVATMAL",
"VASANTRAO VIDYALAY VAROLI",
"VASANTS LABELS PRIVATE LIMITED",
"VASARA LOGISTICS PRIVATE LIMITED",
"VASATHI HOUSING LIMITED",
"VASAV ENTERPRISES PRIVATE LIMITED",
"VASAV PRECISION ENGINEERING PRIVATE LIMITED",
"VASAVI AND GP INFRA LLP",
"VASAVI APEX HOSPITAL",
"VASAVI BALA RESINS PRIVATE LIMITED",
"VASAVI COLLEGE OF ENGINEERING",
"VASAVI DATTA IMPEX PRIVATE LIMITED",
"VASAVI ELECTRO SYSTEMS PRIVATE. LIMITED.",
"VASAVI ENGG COLLEGE",
"VASAVI FARMS",
"VASAVI FOUNDATION FOR EMPOWERMENT",
"VASAVI HOSPITALS",
"VASAVI INFRASTRUCTURE PROJECTS LIMITED",
"VASAVI LUBRICANTS PRIVATE LIMITED",
"VASAVI MEDICARE SOLUTIONS PRIVATE LIMITED",
"VASAVI MRO PRIVATE LIMITED",
"VASAVI NIRMAAN PRIVATE LIMITED",
"VASAVI PDL VENTURES PRIVATE LIMITED",
"VASAVI PIPES PRIVATE LIMITED",
"VASAVI PLAST INDUSTRIES",
"VASAVI POWER SERVICES PRIVATE LIMITED",
"VASAVI SEEDS PRIVATE LIMITED",
"VASAVI SILKS PRIVATE LIMITED",
"VASAVI SOLAR POWER PRIVATE LIMITED",
"VASAVI TECH MARKETING PRIVATE LIMITED",
"VASAVI VIDYANIKETAN COLLEGE FOR WOMEN",
"VASAVICONSTRUCTIONS LLP",
"VASAVIRATNA COLD STORAGE PRIVATE LIMITED",
"VASAYA FOODS PRIVATE LIMITED",
"VASCO DA GAMA BEACH RESORTS PRIVATE LIMITED",
"VASCO SCIENTIFICS PRIVATE LIMITED",
"VASCO TRAVEL PRIVATE LIMITED",
"VASCO WORLDWIDE INDIA PRIVATE LIMITED",
"VASCODA HOLIDAY RESORT PRIVATE LIMITED",
"VASCOM INFOTEK PRIVATE LIMITED",
"VASCON ENGINEERS LIMITED",
"VASCON INFRASTRUCTURE LIMITED",
"VASCULAR CONCEPTS LIMITED",
"VASCULAR THERAPEUTICS INDIA PRIVATE LIMITED",
"VASEELA INFRASTRUCTURE PRIVATE LIMITED",
"VASEEULLA MODERN RICE MILL",
"VASHALI VARDHMAN COLOISERS PVT LTD",
"VASHI ELECTRICALS PRIVATE LIMITED",
"VASHI INTEGRATED SOLUTIONS LIMITED",
"VASHI RAILWAY STATION COMMERCIAL COMPLEX LIMITED",
"VASHINE COMMERCIAL LINE PRIVATE LIMITED",
"VASHISHT CHEMICALS PRIVATE LIMITED",
"VASHISHT CLINIC PRIVATE LIMITED",
"VASHISHTH SEWA SANGH INTERMEDIATE COLLEGE",
"VASHISHTHA EMBROIDERIES PRIVATE LIMITED",
"VASHISHTHA NARAYAN SINGH CONSTRUCTIONS PRIVATE LIMITED",
"VASHISHTHA VIDHYALAY",
"VASHIST INFRA ENGINEERING PRIVATE LIMITED",
"VASHISTA LOGISTICS PRIVATE LIMITED",
"VASHISTH BUILDERS AND ENGINEERS LIMITED",
"VASHISTH ESTATES LIMITED",
"VASHISTH INSPECTION & LABORATORIES PRIVATE LIMITED",
"VASHISTH VATSALYA PUBLIC SCHOOL",
"VASHISTHA CHEMTECH (INDIA) PRIVATE LIMITED",
"VASHKLEEN LAUNDRY SERVICES PRIVATE LIMIT ED",
"VASHNIO SPINNER PRIVATE LIMITED",
"VASHU PERFECT PRIVATE LIMITED",
"VASHU YARN MILLS INDIA P LIMITED",
"VASHUNDHARA POLYFIBRE PRIVATE LIMITED",
"VASHUNDHARA POLYSACK PRIVATE LIMITED",
"VASI GATEWAYS PRIVATE LIMITED",
"VASIBALA VENTURES PRIVATE LIMITED",
"VASINEV NEXTEX PRIVATE LIMITED",
"VASIREDDY VENKATADRI INSTITUTE OF TECHNOLOGY",
"VASISHT AGENCIES PRIVATE LIMITED",
"VASISHT MARKETING PRIVATE LIMITED",
"VASISHTA CONSTRUCTIONS PRIVATE LIMITED",
"VASISHTA PESTICIDES PRIVATE LIMITED",
"VASISHTA PU COLLEGE BELLARY",
"VASISHTHA GENESIS SCHOOL",
"VASISHTHA TEX FAB PRIVATE LIMITED",
"VASISTA LIFE SCIENCES PRIVATE LIMITED",
"VASISTA MARINE",
"VASISTA MINES PRIVATE LIMITED",
"VASISTA PHARMA CHEM PRIVATE LIMITED",
"VASISTH CAPITAL PRIVATE LIMITED",
"VASITARS PRIVATE LIMITED",
"VASIYAM HOMES PRIVATE LIMITED",
"VASKO ISPAT PRIVATE LIMITED",
"VASKO METALLOYS PRIVATE LIMITED",
"VASKO STEELS PRIVATE LIMITED",
"VASKSPIN TEX PRIVATE LIMITED",
"VASMED HEALTH SCIENCES PRIVATE LIMITED",
"VASMI FARM FRESH PRIVATE LIMITED",
"VASO-MEDITECH PRIVATE LIMITED",
"VASON PRINTOPACK PRIVATE LIMITED",
"VASOO INFRACON PRIVATE LIMITED",
"VASOYA INDUSTRIES PRIVATE LIMITED",
"VASP ADVISORS PRIVATE LIMITED",
"VASPAL SALT & CHEMICALS PRIVATE LIMITED",
"VASPHAR PHARMACEUTICALS PRIVATE LIMITED",
"VASPOL INFRASTRUCTURE PRIVATE LIMITED",
"VASPP TECHNOLOGIES PRIVATE LIMITED",
"VASRRA VISIONS",
"VASS LEASING AND FINANCE PRIVATE LIMITED",
"VASSAM SOLUTIONS PRIVATE LIMITED",
"VASSANTRAM METHA AND COMPANY PRIVATE LIMITED",
"VASSAR LABS IT SOLUTIONS PRIVATE LIMITED",
"VASSI HOSPITTALTY PRIVATE LIMITED",
"VAST DIGITAL PUBLISHING PRIVATE LIMITED",
"VAST INTEGRATED SERVICES LIMITED",
"VAST LINKERS PRIVATE LIMITED",
"VAST METALS PRIVATE LIMITED",
"VAST NOTE BOOK SERVE (I) PRIVATE LIMITED",
"VASTA BIO INFORMATICS PRIVATE LIMITED",
"VASTA BIO-INFORMATICS PRIVATE LIMITED",
"VASTA BIOTECH PRIVATE LIMITED",
"VASTAN CREATIONS PRIVATE LIMITED",
"VASTANI CHEMICALS LIMITED",
"VASTAV DEVELOPERS PRIVATE LIMITED",
"VASTECH SOLUTIONS PRIVATE LIMITED",
"VASTEDGE CLOUD SOLUTIONS PRIVATE LIMITED",
"VASTEK SYSTEMS PRIVATE LIMITED",
"VASTHI ENGINEERS PRIVATE LIMITED",
"VASTHI INSTRUMENTS PRIVATE LIMITED",
"VASTHI TRADING PRIVATE LIMITED",
"VASTHIRA EXPORTERS PRIVATE LIMITED",
"VASTPRO TECHNOLOGIES PRIVATE LIMITED",
"VASTRAKALA EXPORTS PRIVATE LIMITED",
"VASTRAM INDIA PRIVATE LIMITED",
"VASTRAMAY PRIVATE LIMITED",
"VASTRANGANA GARMENTS PRIVATE LIMITED",
"VASTU BHOOMI REAL ESTATE (INDIA) PRIVATE LIMITED",
"VASTU FINANCIAL SERVICES PRIVATE LIMITED",
"VASTU FINSERVE INDIA PRIVATE LIMITED",
"VASTU HOUSING FINANCE CORPORATION LIMITED",
"VASTU KIRTI ENGG. PRIVATE LIMITED",
"VASTU KRUPA CONSTRUCTIONS INDIA PRIVATE. LIMITED.",
"VASTU RACHANA ARCHDESIGN PRIVATE LIMITED",
"VASTUKALA CONSULTANTS (I) PRIVATE LIMITED",
"VASTUM INDIA LIMITED VAS",
"VASTURAVIRAJ DESIGNS PRIVATE LIMITED",
"VASTURAVIRAJ HOLISTICS PRIVATE LIMITED",
"VASTUSHILPI ENTERPRISES PRIVATE LIMITED",
"VASTUSHILPI PROJECTS AND CONSULTANTS PVT LTD",
"VASTUSHREE INFRAPROJECTS PRIVATE LIMITED",
"VASTUSTAR TRADING PRIVATE LIMITED",
"VASTUTA RENEWABLES PRIVATE LIMITED",
"VASU AGENCIES HYD PRIVATE LIMITED",
"VASU ALLOYS PRIVATE LIMITED",
"VASU CHEMICAL PRIVATE LIMITED",
"VASU CHEMICALS INDIA PRIVATE LIMITED",
"VASU CHEMICALS LLP",
"VASU CLOTHING PRIVATE LIMITED",
"VASU COCO RESORTS PRIVATE LIMITED",
"VASU CONTRACTS PRIVATE LIMITED",
"VASU ENTERPRISE",
"VASU ENTERPRISES",
"VASU HEALTHCARE PRIVATE LIMITED",
"VASU INFOSEC PRIVATE LIMITED",
"VASU INFRATECH PRIVATE LIMITED",
"VASU LIFESTYLE PRIVATE LIMITED",
"VASU LOGISTICS AND WAREHOUSING PRIVATE LIMITED",
"VASU MANUFACTURER PRIVATE LIMITED",
"VASU MERCHANTS PRIVATE LIMITED",
"VASU MET PLAST PRIVATE LIMITED",
"VASU MULTIMETALS PRIVATE LIMITED",
"VASU ORGANICS PRIVATE LIMITED",
"VASU PACKS PRIVATE LIMITED",
"VASU PHARMA DISTRIBUTORS HYD PRIVATE LIMITED",
"VASU POLYMERS (INDIA) PRIVATE LIMITED",
"VASU PUMPS AND SYSTEMS PRIVATE LIMITED",
"VASU ROADLINE PRIVATE LIMITED",
"VASU SERVICES",
"VASU VACCINES & SPECIALITY DRUGS PRIVATE LIMITED",
"VASUD FINANCE PRIVATE LIMITED",
"VASUD LAMIFAB PRIVATE LIMITED",
"VASUDEV ADIGAS FASTFOOD PRIVATE LIMITED",
"VASUDEV AGRO ( INDIA ) PRIVATE LIMITED",
"VASUDEV ALUCAN PRIVATE LIMITED",
"VASUDEV C WADHWA CONSTRUCTIONS",
"VASUDEV CREATION PRIVTAE LIMITED",
"VASUDEV DYE-CHEM PRIVATE LIMITED",
"VASUDEV ELECTRICAL SYSTEMS PRIVATE LIMITED",
"VASUDEV ELECTROPROJECT PRIVATE LIMITED",
"VASUDEV ENGINEERING PRIVATE LIMITED",
"VASUDEV IMPEX PRIVATE LIMITED",
"VASUDEV INFRASTRUCTURA PRIVATE LIMITED",
"VASUDEV KUTUMBAKAM HEALTHCARE FOUNDATION",
"VASUDEV POLYPLAST PRIVATE LIMITED",
"VASUDEV POWER PRIVATE LIMITED",
"VASUDEVA DHAL PRODUCTS PRIVATE LIMITED",
"VASUDEVA GLASS SOLUTIONS PRIVATE LIMITED",
"VASUDEVA REALTORS PRIVATE LIMITED",
"VASUDEVA VILASAM HERBAL REMEDIES PRIVATE LIMITED",
"VASUDHA AGRO FOOD PRODUCTS PRIVATE LIMITED",
"VASUDHA AIRCON PRIVATE LIMITED",
"VASUDHA ALLOYS PRIVATE LIMITED",
"VASUDHA CHEMICALS PRIVATE LIMITED",
"VASUDHA COLOURS PRIVATE LIMITED",
"VASUDHA CORPORATION PRIVATE LIMITED",
"VASUDHA GLOBAL BIZ PRIVATE LIMITED",
"VASUDHA MANGAL IMPEX PRIVATE LIMITED",
"VASUDHA MARKETING PRIVATE LIMITED",
"VASUDHA ORGANICS LIMITED",
"VASUDHA PHARMA CHEM LIMITED",
"VASUDHA PUBLICATIONS PRIVATE LIMITED",
"VASUDHA SECURITY AND SERVICES PRIVATE LIMITED",
"VASUDHA SEEDS PRIVATE LIMITED",
"VASUDHA SWARAJ PRIVATE LIMITED",
"VASUDHA WASTE TREATMENT PRIVATE LIMITED",
"VASUDHAA HOSPITALITY PRIVATE LIMITED",
"VASUDHAIKA AGRITECH PRIVATE LIMITED",
"VASUDHAIKA SOFTWARE SOLUTIONS PRIVATE LIMITED",
"VASUGAN MEDICAL SPECIALITIES PRIVATE LIMITED",
"VASUKI COLOUR ANODISE PRIVATE LIMITED",
"VASUKI FLOWTECH PRIVATE LIMITED",
"VASUKI GLOBAL INDUSTRIES LIMITED",
"VASUKI TECHNOCAST PRIVATE LIMITED",
"VASUMAN ENTERPRISES PRIVATE LIMITED",
"VASUMITRA LIFE ENERGIES PRIVATE LIMITED",
"VASUNDARA MANUFACTURING SYSTEMS PRIVATE LIMITED",
"VASUNDARA WOMEN DEGREE COLLEGE",
"VASUNDHARA AGRI-HORTI PRODUCER COMPANY LIMITED",
"VASUNDHARA AGROTECH PRIVATE LIMITED",
"VASUNDHARA AUTO FUEL PRIVATE LIMITED",
"VASUNDHARA AUTOMATION AND ENGG SERVICES PRIVATE LIMITED",
"VASUNDHARA CARRIERS PRIVATE LIMITED",
"VASUNDHARA CHEM PLAST INDUSTRIES",
"VASUNDHARA COAL CARRIERS PRIVATE LIMITED",
"VASUNDHARA CONSTRUCTIONS PRIVATE LIMITED",
"VASUNDHARA COTTON MILLS PRIVATE LIMITED",
"VASUNDHARA CREATIONS PRIVATE LIMITED",
"VASUNDHARA DEALER PRIVATE LIMITED",
"VASUNDHARA DEVELOPERS",
"VASUNDHARA DIAMOND ROOF PRIVATE LIMITED",
"VASUNDHARA EARTHMOVERS PRIVATE LIMITED",
"VASUNDHARA FERTILIZERS AND SEEDS PRIVATE LIMITED",
"VASUNDHARA HOSPITAL LIMITED",
"VASUNDHARA INFOTECH",
"VASUNDHARA INFOTECH LLP",
"VASUNDHARA INFRABUILD PRIVATE LIMITED",
"VASUNDHARA IT PRIVATE LIMITED",
"VASUNDHARA LIFESTYLE PRIVATE LIMITED",
"VASUNDHARA MARMO AND MINES PRIVATE LIMITED",
"VASUNDHARA MEDIA PRIVATE LIMITED",
"VASUNDHARA MERCHANT AND DEVELOPERS PRIVATE LIMITED",
"VASUNDHARA MERCHANTS LTD",
"VASUNDHARA METALIKS PRIVATE LIMITED",
"VASUNDHARA MICROMINERAL INFINITE PRIVATE LIMITED",
"VASUNDHARA NURSING HOME PRIVATE LIMITED",
"VASUNDHARA POWER AND INFRASTRUCTURE PRIVATE LIMITED",
"VASUNDHARA RASAYANS LIMITED",
"VASUNDHARA SEEDS PRIVATE LIMITED",
"VASUNDHARA SPARES AND PARTS PRIVATE LIMITED",
"VASUNDHRA HOMES PRIVATE LIMITED",
"VASUNDHRA JEWELLERS PRIVATE LIMITED",
"VASUNDHRA SINTERED PRIVATE LIMITED",
"VASUPATI AGRO PRODUCT PRIVATE LIMITED",
"VASUPATI JEWELLERS INDIA PRIVATE LIMITED",
"VASUPRADA INDUSTRIES PRIVATE LIMITED",
"VASUPUJYA FILAMENTS",
"VASUPUJYA PVC PRIVATE LIMITED",
"VASURA CABLES PRIVATE LIMITED",
"VASURI TEXTILES PVT LTD",
"VASURUPA SAREES PRIVATE LIMITED",
"VASUTECH AUTOMATIONS PRIVATE LIMITED",
"VASWANI ESTATES DEVELOPERS PRIVATE LIMITED",
"VASWANI INDUSTRIES LIMITED",
"VASWANI PROJECTS PRIVATE LIMITED",
"VASWANI WHITEFIELD PROJECTS PRIVATE LIMITED",
"VASYSTRON TECKNOWLOGIES PRIVATE LIMITED",
"VAT HOSPITALITY PRIVATE LIMITED",
"VAT TECH ENGINEERING PRIVATE LIMITED",
"VATANIX TECHNOLOGIES PRIVATE LIMITED",
"VATANS TRAVEL AND TOURS",
"VATANUCOOL ENGINEERS PRIVATE LIMITED",
"VATCO ELEC-POWER PRIVATE LIMITED",
"VATECH INDIA PRIVATE LIMITED",
"VATHSALYA COLD STORAGE PRIVATE LIMITED",
"VATHSALYA COLLEGE OF PHARMACY",
"VATICAN LIFE SCIENCES PRIVATE LIMITED",
"VATICAN SHONA AGROTECH PRIVATE LIMITED",
"VATIKA AGRITECH PRIVATE LIMITED",
"VATIKA DISTRIBUTORS PRIVATE LIMITED",
"VATIKA DYEING AND PRINTING PRIVATE LIMITED",
"VATIKA HOTELS PRIVATE LIMITED",
"VATIKA INFRACON PRIVATE LIMITED",
"VATIKA INXT 2 PRIVATE LIMITED",
"VATIKA JAIPUR SEZ DEVELOPERS PRIVATE LIMITED",
"VATIKA LIMITED",
"VATIKA NIRMAN PRIVATE LIMITED",
"VATIKA ONE INDIA NEXT PRIVATE LIMITED",
"VATIKA ONE ON ONE PRIVATE LIMITED",
"VATIKA RAYONS PRIVATE LIMITED",
"VATIKA SEVEN ELEMENTS PRIVATE LIMITED",
"VATIKA SILK MILLS PRIVATE LIMITED",
"VATIKA TRACOM PRIVATE LIMITED",
"VATIKA TRIANGLE PRIVATE LIMITED",
"VATINS SYSTEMS PRIVATE LIMITED",
"VATIT CONSULTANTS PRIVATE LIMITED",
"VATIT INDIA SERVICES PRIVATE LIMITED",
"VATJAT PHARMA FOODS PRIVATE LIMITED",
"VATS AND VESSELS (I) PRIVATE LIMITED",
"VATS ASSOCIATES PRIVATE LIMITED",
"VATS BIOTECH PRIVATE LIMITED",
"VATS ELECTROTEK PRIVATE LIMITED",
"VATS FILTRATION TECHNOLOGIES PRIVATE LIMITED",
"VATS INDUSTRIES PRIVATE LIMITED",
"VATS INFRATECH PRIVATE LIMITED",
"VATS PACKAGING PRIVATE LIMITED",
"VATS REALTECH PRIVATE LIMITED",
"VATS SOLAR PRIVATE LIMITED",
"VATSA DILIGENCE INDUSTRIES PRIVATE LIMITED.",
"VATSA SOLUTIONS PRIVATE LIMITED",
"VATSAL AGRO PRODUCTS PRIVATE LIMITED",
"VATSAL AUTOWHEELS PRIVATE LIMITED",
"VATSAL HOTELS PRIVATE LIMITED",
"VATSAL PACKKAGING PRIVATE LIMITED",
"VATSAL VASTRAA PRIVATE LIMITED",
"VATSALA BELLARY SOLAR PROJECT PRIVATE LIMITED",
"VATSALA CONSTRUCTIONS AND CONSULTANTS PRIVATE LIMITED",
"VATSALA IMPEX PRIVATE LIMITED",
"VATSALYA BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"VATSALYA CHEMICALS PVT LTD",
"VASTALYA HEALTH CARE LLP",
"VATSALYA HEARING SYSTEM",
"VATSALYA INTERNATIONAL SCHOOL",
"VATSALYA MINERALS & POWER PRIVATE LIMITED",
"VATSGROUP INDIA PRIVATE LIMITED",
"VATSIN TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"VATSKA MEDTECH PRIVATE LIMITED",
"VATSON TELECOM PRIVATE LIMITED",
"VATVA INDUSTRIAL ESTATE INFRASTRUCTURE DEVELOPMETN LIMITED",
"VAUCH INFORMATION TECHNOLOGY PRIVATE LIMITED",
"VAULT DEVELOPER PRIVATE LIMITED",
"VAULT LIQUOR P.LIMITED",
"VAULTEDGE SOFTWARE PRIVATE LIMITED",
"VAULTER ENGINEERING SERVICES PRIVATE LIMITED",
"VAULTIZE TECHNOLOGIES PRIVATE LIMITED",
"VAULTSKIES PERSONAL CARE PRIVATE LIMITED",
"VAURAS ADVISORY SERVICES PRIVATE LIMITED",
"VAUTID INDIA PRIVATE LIMITED",
"VAV LIFE SCIENCES PRIVATE LIMITED",
"VAV LIPIDS PRIVATE LIMITED",
"VAVE INDIA ENERGY SOLUTION PRIVATE LIMITED",
"VAVE MICROTECH PRIVATE LIMITED",
"VAVIA TECHNOLOGIES PRIVATE LIMITED",
"VAVISK IMPEX PRIVATE LIMITED",
"VAVNI SERVICES PVT. LTD.",
"VAVS SUPPORT SERVICES PRIVATE LIMITED",
"VAX CONSULTANTS PRIVATE LIMITED",
"VAX ENTERPRISE PRIVATE LIMITED",
"VAX FASHION PRIVATE LIMITED",
"VAXER PHARMA LIMITED",
"VAXICARE ENTERPRISES PRIVATE LIMITED",
"VAXIDRUG PHARMACEUTICALS PRIVATE LIMITED",
"VAXLOG MICROSYSTEMS PRIVATE LIMITED",
"VAXOM PACKAGING PRIVATE LIMITED",
"VAXOVA DRUGS PRIVATE LIMITED",
"VAY NETWORK SERVICES PRIVATE LIMITED",
"VAYA ADVISORY SERVICES PRIVATE LIMITED",
"VAYA ARCHITECTURE PRIVATE LIMITED",
"VAYA FINSERV PRIVATE LIMITED",
"VAYA LIFE PRIVATE LIMITED",
"VAYA MEP ENGINEERS PRIVATE LIMITED",
"VAYALAT AUTOMOBILES PRIVATE LIMITED",
"VAYALAT MOTORS PRIVATE LIMITED",
"VAYAM FORUM FOR CITIZENSHIP",
"VAYAM INFO SOLUTIONS PRIVATE LIMITED",
"VAYATI WEAVES LLP",
"VAYATRONICS PRIVATE LIMITED",
"VAYAVYA LABS PRIVATE LIMITED",
"VAYHAN AIR CONTROLS PRIVATE LIMITED",
"VAYHAN COFFEE LIMITED",
"VAYOO NANDAN FINANCE COMPANY PRIVATE LIMITED",
"VAYRABI RICE MILL PRIVATE LIMITED",
"VAYS INFOTECH PRIVATE LIMITED",
"VAYU (PROJECT 1) PRIVATE LIMITED",
"VAYU AEROSPACE PRIVATE LIMITED",
"VAYU DISTRIBUTORS PRIVATE LIMITED",
"VAYU ENGINEERING SOLUTIONS PRIVATE LIMITED",
"VAYU MEGHA SYSTEMS PRIVATE LIMITED",
"VAYU PRODUCTS PRIVATE LIMITED",
"VAYU TELECOM PRIVATE LIMITED",
"VAYU URJA BHARAT PRIVATE LIMITED",
"VAYUCON SYSTEMS PRIVATE LIMITED",
"VAYUDOOT HOLIDAYS PRIVATE LIMITED",
"VAYUDOOT IMPEX PRIVATE LIMITED",
"VAYUDOOT ROAD CARRIERS PRIVATE LIMITED",
"VAYUDOOT SOLARFARMS LIMITED",
"VAYUDOOT STEELS PRIVATE LIMITED",
"VAYUDOOT WORLD TRAVELS INDIA PRIVATE LIMITED",
"VAYUNA VOICETECH PRIVATE LIMITED",
"VAYUNOVA SOLUTIONS LLP",
"VAYUPUTHRA ENERGY PRIVATE LIMITED",
"VAYUPUTRA AUTOMOBILES PRIVATE LIMITED",
"VAYUPUTRA BUILDERS AND INFRASTRUCTURES PRIVATE LIMITED",
"VAYUPUTRA FINANCIAL SERVICES LLP",
"VAYUPUTRA LOGISTICS PRIVATE LIMITED",
"VAYUPUTRA REALTY PRIVATE LIMITED",
"VAYUPUTRA SOLUTIONS",
"VAYUTEL TECHNOLOGY SERVICES PRIVATE LIMITED",
"VAYUZ TECHNOLOGIES PRIVATE LIMITED",
"VAZEER TOBACCO COMPANY",
"VAZHAKKULAM HOTELS AND RESORTS PRIVATE LIMITED",
"VAZHAKULAM PINEAPPLE GROWERS AND PROCESSORS PRIVATE LIMITED",
"VAZHRAA NIRMAAN PRIVATE LIMITED",
"VAZIR POLYMERS LIMITED",
"VAZIRANI REALTY PRIVATE LIMITED",
"VAZRON INDUSTRIES PRIVATE LIMITED",
"VB ENTERPRISES PRIVATE LIMITED",
"VB FOODS EXPORT PRIVATE LIMITED",
"VB GOLDEN LOGITECH PRIVATE LIMITED",
"VB HEALTH SOLUTIONS PRIVATE LIMITED",
"VB LOGISTICS EXIM PRIVATE LIMITED",
"VB MEDICARE PRIVATE LIMITED",
"VBAP ENGINEERING SOLUTIONS PRIVATE LIMITED",
"VBAP HOLDINGS PRIVATE LIMITED",
"VBB INFRA PRIVATE LIMITED",
"VBC ENGINEERS PRIVATE LIMITED",
"VBC EXPORTS LIMITED",
"VBC RENEWABLE ENERGY PRIVATE LIMITED",
"VBC TECHNOLOGIES PRIVATE LIMITED",
"VBD PUBLICATIONS PRIVATE LIMITED",
"VBD RETAIL (OPC) PRIVATE LIMITED",
"VBHC CHENNAI VALUE HOMES PRIVATE LIMITED",
"VBHC DELHI PROJECTS PRIVATE LIMITED",
"VBHC DELHI VALUE HOMES PRIVATE LIMITED",
"VBHC MUMBAI VALUE HOMES PRIVATE LIMITED",
"VBHC VALUE HOMES PRIVATE LIMITED",
"VBHDC BANGALORE VALUE HOMES PRIVATE LIMITED",
"VBIS INDIA PRIVATE LIMITED",
"VBIZAP SOFT SOLUTIONS PRIVATE LIMITED",
"VBK PROJECTS AND TRADING PRIVATE LIMITED",
"VBL INNOVATIONS PRIVATE LIMITED",
"VBM POWER AND INFRASTRUCTURE PRIVATE LIMITED",
"VBMCS SALES PRIVATE LIMITED",
"VBOARD SOFTWARE SOLUTIONS PRIVATE LIMITED",
"VBR INFRATECH INDIA PRIVATE LIMITED",
"VBR TECHNOLOGIES PRIVATE LIMITED",
"VBRL INFRA PROJECTS PRIVATE LIMITED",
"V-BRO TECH INDIA PRIVATE LIMITED",
"VBROS AUTO PRIVATE LIMITED",
"VBROTHERS PROCESSSOL PRIVATE LIMITED",
"VBRS IT SOLUTIONS PRIVATE LIMITED",
"VBS DIGITAL DISTRIBUTION NETWORK LIMITED",
"VBS RESTAURANTS PRIVATE LIMITED",
"VBS TEXTILES PRIVATE LIMITED",
"VBTI LOGISTICS PRIVATE LIMITED",
"VBTRON AUTOMATION PRIVATE LIMITED",
"VBUZZ TELESERVICES PRIVATE LIMITED",
"VC AGRITECH PRIVATE LIMITED",
"VC ENTEGRATED SOLUTION LLP",
"VC ERP CONSULTING PRIVATE LIMITED",
"VC NUTRIFOODS PRIVATE LIMITED",
"VC SAREES PRIVATE LIMITED",
"VC STUDIIOZ PRIVATE LIMITED",
"VCALL SOFT SOLUTIONS PRIVATE LIMITED",
"V-CAN FURNITECH PRIVATE LIMITED",
"V-CAN LOGISTICS SOLUTIONS PRIVATE LIMITED",
"VCAN SOLUTIONS & SERVICES PRIVATE LIMITED",
"VCARE CALL CENTERS INDIA PRIVATE LIMITED",
"VCARE ENGINEERING PRIVATE LIMITED",
"VCARE HERBS CONCEPT PRIVATE LIMITED",
"VCARE INFOTECH SOLUTIONS & SERVICES PRIVATE LIMITED",
"VCARE INVESTMENT SERVICES PRIVATE LIMITED",
"VCAREOBERON MEDICALS LLP",
"VCARVE RENEWABLE ENERGY PRIVATE LIMITED",
"VCARVE TECHNOLOGIES PRIVATE LIMITED",
"VCB ELECTRONICS PRIVATE LIMITED",
"VCB LIFE SCIENCES PRIVATE LIMITED",
"VCC CO OPERATIVE URBAN THRIFT AND CREDIT SOCIETY LTD",
"VCC INDIA PRIVATE LIMITED",
"VCD AIRVENT SYSTEMS PRIVATE LIMITED",
"VCELL INDIA IMPEX PRIVATE LIMITED",
"VCFL EXPRESS PRIVATE LIMITED",
"VCH CORPORATION PRIVATE LIMITED",
"V-CHAINS JEWELLERY PRIVATE LIMITED",
"V-CHEM",
"VCI EXPORTS PRIVATE LIMITED",
"VCI TECHNOLOGY PRIVATE LIMITED",
"VCK COMMUNICATIONS LLP",
"VCK FOREX SERVICES PRIVATE. LIMITED",
"VCLOUDX INFOTECH PRIVATE LIMITED",
"VCM AGENCIES PRIVATE LIMITED",
"VCM MOTORS AGENCIES PRIVATE LIMITED",
"VCM TRANS SOLUTION PRIVATE LIMITED",
"VCN INDIA PRIVATE LIMITED",
"VCNR BUILDERS AND DEVELOPERS LIMITED",
"VCNR TECHNOLOGIES PRIVATE LIMITED",
"VCO CONSULTANTS AND SERVICES PRIVATE LIMITED",
"VCO SYSTEMS INDIA PRIVATE LIMITED",
"VCOI DIGITAL MEDIA PRIVATE LIMITED",
"VCOM TECHNOLOGIES PRIVATE LIMITED",
"VCOMMISSION MEDIA PRIVATE LIMITED",
"VCOMPLY TECHNOLOGIES INDIA PRIVATE LIMITED",
"V-CON CARRIER SERVICES PRIVATE LIMITED",
"V-CON INTEGRATED SOLUTIONS PRIVATE LIMITED",
"V-CON TELECOM TOWERS PRIVATE LIMITED",
"V-CONNECT SYSTEMS & SERVICES PRIVATE LIMITED",
"VCONSTRUCT PRIVATE LIMITED",
"VCORP MERCANTILE PRIVATE LIMITED",
"VCORP PROPERTIES PRIVATE LIMITED",
"VCOYS IMPETUS PRIVATE LIMITED",
"VCPL NETWORK PRIVATE LIMITED",
"VCPROJECT & INFRA PRIVATE LIMITED",
"VCREATEK CONSULTING SERVICES PRIVATE LIMITED",
"VCS ENTERPRISES PRIVATE LIMITED",
"CONNPLEX CINEMAS LIMITED",
"VCS QUALITY SERVICES PRIVATE LIMITED",
"VCSP NOVA ENERGIE PRIVATE LIMITED",
"V-CTRL SOLUTIONS PRIVATE LIMITED",
"VCU DATA MANAGEMENT LIMITED",
"VCUBE CHEMICALS PRIVATE LIMITED",
"V-CUBE VENTURES PRIVATE LIMITED",
"VCURE MEDICAL CLINIC PRIVATE LIMITED",
"VD GLOBAL PRIVATE LIMITED",
"VD GLOBE RIDER INDIA PRIVATE LIMITED",
"VD JEWELS ARTISON PRIVATE LIMITED",
"VD LIFESTYLE PRIVATE LIMITED",
"VD NATURAL BIOCHEM & FERTILIZER PRIVATE LIMITED",
"VDA INFOSOLUTIONS PRIVATE LIMITED",
"VDA MICROFINANCE FOUNDATION",
"VDART SOFTWARE SERVICES PRIVATE LIMITED",
"VDART TECHNOLOGIES PRIVATE LIMITED",
"VDAS INFRA PROJECTS PRIVATE LIMITED",
"VDB INFRA AND REALTY PRIVATE LIMITED",
"VDB PROJECTS PRIVATE LIMITED",
"VDBS CONSULTANCY SERVICES PRIVATE LIMITED",
"VDC OIL LIMITED",
"VDC TECHNOLOGIES PRIVATE LIMITED",
"VDE INDUSTRIES PRIVATE LIMITED",
"VDEAL SYSTEM PRIVATE LIMITED",
"VDEVTURE TECHNOLOGIES PRIVATE LIMITED",
"VDH CHEM TECH PRIVATE LIMITED",
"VDH ECO-ENERGY ENTERPRISES PRIVATE LIMITED",
"VDH ORGANICS PRIVATE LIMITED",
"VDH SUPPLY CHAIN PRIVATE LIMITED",
"VDI AGRO PRIVATE LIMITED",
"V-DIAM GEMS PRIVATE LIMITED",
"VDIEC GLOBAL CONNECT PRIVATE LIMITED",
"VDIL DIAMONDS PRIVATE LIMITED",
"VDK EDUVENTURES PRIVATE LIMITED",
"VDK FACILITY SERVICES PRIVATE LIMITED",
"VDK PUBLICATIONS PRIVATE LIMITED",
"VDM ERECTORS PRIVATE LIMITED",
"VDM HOSPITALITY PRIVATE LIMITED",
"VDM MANAGEMENTS PRIVATE LIMITED",
"VDMA INDIA SERVICES PRIVATE LIMITED",
"VDMS PRIVATE LIMITED",
"VDND SALES PRIVATE LIMITED",
"VDNTECH ENGINEERS PRIVATE LIMITED",
"VDOCIPHER MEDIA SOLUTIONS PRIVATE LIMITED",
"VDOIT TECHNOLOGIES LIMITED",
"VDP MART PRIVATE LIMITED",
"V-DREAM TECHNOLOGY & COMMUNICATION PRIVATE LIMITED",
"VDRIVEINFO PRIVATE LIMITED",
"VDSD FOODS PRIVATE LIMITED",
"VDT PIPELINE INTEGRITY SOLUTIONS PRIVATE LIMITED",
"VDV INFRAVENTURES PRIVATE LIMITED",
"VE COMMERCIAL VEHICLES LIMITED",
"VEA IMPEX I PRIVATE LIMITED",
"VEA INFRABUILD PRIVATE LIMITED",
"VEANUS CORN PRODUCTS PRIVATE LIMITED",
"VEATIVE LABS PRIVATE LIMITED",
"VEAVE TECHNOLOGIES PRIVATE LIMITED",
"VEB SOLUTIONS GLOBAL PRIVATE LIMITED",
"VEBBLER TECHNOLOGIES PRIVATE LIMITED",
"VEBHAV SYNTHETICS PRIVATE LIMITED",
"VEBHAV YARNS PRIVATE LIMITED.",
"VEBHOLIC PRIVATE LIMITED",
"VEBOTICS SQUARE SERVICES PRIVATE LIMITED",
"VEC CHOCOLATE MACHINES PRIVATE LIMITED",
"VECARE CONSUMER SCIENCE PRIVATE LIMITED",
"VECHEM ORGANICS PRIVATE LIMITED",
"VECINO FITNESS PRIVATE LIMITED",
"VECMOCON TECHNOLOGIES PRIVATE LIMITED",
"VECO LABS PRIVATE LIMITED",
"VECO PRECISION INDIA PRIVATE LIMITED",
"VECRAS CREATIONS PRIVATE LIMITED",
"VECREAR TECHNOLOGIES PRIVATE LIMITED",
"VECTION TECHNOLOGIES INDIA PRIVATE LIMITED",
"VECTIV TECHNOLOGIES PRIVATE LIMITED",
"VECTON INTERNATIONAL PRIVATE LIMITED",
"VECTONE SOLUTIONS PRIVATE LIMITED",
"VECTOR BIO SCIENCES PRIVATE LIMITED",
"VECTOR BIOTEK PRIVATE LIMITED",
"VECTOR CONTROL RESEARCH CENTRE",
"VECTOR COURIER & BPO PRIVATE LIMITED",
"VECTOR E-COMMERCE PRIVATE LIMITED",
"VECTOR ENGINEERING (INDIA) PRIVATE LIMITED",
"VECTOR FINANCE PRIVATE LIMITED",
"VECTOR FREIGHT PRIVATE LIMITED",
"VECTOR GREEN PRAYAGRAJ SOLAR PRIVATE LIMITED",
"VECTOR GREEN SUNRISE LIMITED",
"VECTOR GREEN SUNSHINE PRIVATE LIMITED",
"VECTOR GREEN SURYA URJA PRIVATE LIMITED",
"VECTOR HR CONSULTING PRIVATE LIMITED",
"VECTOR HYDRAULICS PRIVATE LIMITED",
"VECTOR INFORMATIK INDIA PRIVATE LIMITED",
"VECTOR MANAGEMENT CONSULTING PRIVATE LIMITED",
"VECTOR NDT TECHNOLOGIES PRIVATE LIMITED",
"VECTOR SOLUTIONS PRIVATE LTD",
"VECTOR SYSTEMS PRIVATE LIMITED",
"VECTOR UPS BATTERY SOLUTIONS PRIVATE LIMITED",
"VECTORSHADES ENGINEERING SERVICES PRIVATE LIMITED",
"VECTOSCALAR TECHNOLOGIES PRIVATE LIMITED",
"VECTRA AUTOMATION SOFTWARE PRIVATE LIMITED",
"VECTRA HEALTH CARE PRIVATE LIMITED",
"VECTRA TECHNOSOFT PRIVATE LIMITED",
"VECTRAE INFOTECH PRIVATE LIMITED",
"VECTRAMIND TECHNOLOGIES PRIVATE LIMITED",
"VED BEARINGS INDIA PRIVATE LIMITED",
"VED BHUSHAN SAREE PRIVATE LIMITED",
"VED BROTHERS SECURITIES PRIVATE LIMITED",
"VED CONTRACTS PRIVATE LIMITED",
"VED DHARA EDUCATION",
"VED ELECTRICALS LLP",
"VED ELECTROMEC PRIVATE LIMITED",
"VED HOSPITAL",
"VED HOSPITAL SUPERSPECIALITY & MEDICAL RESEARCH PRIVATE LIMITED",
"VED JYOTI ALLOYS PVT LTD",
"VED LIFE SAVERS PRIVATE. LIMITED.",
"VED LIFESAVERS PRIVATE LIMITED",
"VED MAHAKAUSHAL PRODUCER COMPANY LIMITED",
"VED MED SOFTWARE AND TRADING PRIVATE LIMITED",
"VED MODEL SENIOR SECONDARY SCHOOL NIGANA ROAD KALANAUR",
"VED PARKASH AND SONS",
"VED PMC LIMITED",
"VED POHOJA ASSOCIATES PRIVATE LIMITED",
"VED PRAKASH AND ASSOCIATES PRIVATE LIMITED",
"VED RAM DAIRY PRIVATE LIMITED",
"VED SASSOMECCANICA INDIA PRIVATE LIMITED",
"VED SECURITY AND HOUSE KEEPING SERVICES PRIVATE LIMITED",
"VED TECHNOSERVE INDIA PRIVATE LIMITED",
"VED TRADERS",
"VED VISHAL RESOURCES PRIVATE LIMITED",
"VED¬†DRIP¬†IRRIGATION¬†AND¬†MACHINERY",
"VEDA ALLOYS & PRODUCTS PRIVATE LIMITED",
"VEDA CORPORATE ADVISORS PRIVATE LIMITED",
"VEDA DEFENSE SYSTEMS PRIVATE LIMITED",
"VEDA DISTRIBUTION PRIVATE LIMITED",
"VEDA ENGINEERING PRIVATE LIMITED",
"VEDA EXCOM PRIVATE LIMITED",
"VEDA EXIM PRIVATE LIMITED",
"VEDA FEEDS PRIVATE LIMITED",
"VEDA INFORMATICS PRIVATE LIMITED",
"VEDA INFRASTRUCTURES PRIVATE LIMITED",
"VEDA LOGISTICS PRIVATE LIMITED",
"VEDA NEXTGEN ENERGY PRIVATE LIMITED",
"VEDA ONLINE SCHOOL",
"VEDA POLY PRODUCTS PRIVATE LIMITED",
"VEDA REALTY PRIVATE LIMITED",
"VEDA REHABILITATION AND WELLNESS PRIVATE LIMITED",
"VEDA SEEDSCIENCES PRIVATE LIMITED",
"VEDA SPICEFARMS PRIVATE LIMITED",
"VEDA SPORTS MARKETING PRIVATE LIMITED",
"VEDA SYSTEM SOLUTIONS PRIVATE LIMITED",
"VEDAA PREFAB TECHNOLOGIES PRIVATE LIMITED",
"VEDAANTHA EDUSERVE PRIVATE LIMITED",
"VEDAANTTA RETAILS PRIVATE LIMITED",
"VEDAAZ ORGANICS PRIVATE LIMITED",
"VEDADRI PAPER MILLS (INDIA) PRIVATE LIMITED",
"VEDAGARBHA PROJECTS PRIVATE LIMITED",
"VEDAGIRI HI-TECH SPINNING MILLS PRIVATE. LIMITED.",
"VEDAGNA SUMESHA SUBODHI ACADEMY PRIVATE LIMITED",
"VEDAM DESIGN & TECHNICAL CONSULTANCY PRIVATE LIMITED",
"VEDAMATHA ENTERPRISES PRIVATE. LIMITED.",
"VEDAMI CONSUMER CARE PRIVATE LIMITED",
"VEDAMS SOFTWARE SOLUTIONS INDIA PRIVATE LIMITED",
"VEDAN INFRA & PROJECTS PRIVATE LIMITED",
"VEDANAM GRIH PRIVATE LIMITED",
"VEDANAYAGAM HOSPITAL PRIVATE LIMITED",
"VEDANG CELLULAR SERVICES PRIVATE LIMITED",
"VEDANG INNOVATIVE IT TRANSFORMATION PRIVATE LIMITED",
"VEDANG RADIO TECHNOLOGY PRIVATE LIMITED",
"VEDANGA SOLAR ENERGY PRIVATE LIMITED",
"VEDANIA SERVICES PRIVATE LIMITED",
"VEDANSH CONSTRUCTIONS PRIVATE LIMITED",
"VEDANSH CREATIONS",
"VEDANSH FASHIONS PRIVATE LIMITED",
"VEDANSH IMPEX PRIVATE LIMITED",
"VEDANSH INFRA SERVICES PRIVATE LIMITED",
"VEDANSH INTERNATIONAL SCHOOL",
"VEDANSH MINERAL & METALS PRIVATE LIMITED",
"VEDANSH PULSES PRIVATE LIMITED",
"VEDANSH TRADERS PVT LTD",
"VEDANSHEE SAFETY AND SIGN PRIVATE LIMITED",
"VEDANSHI CREATION PRIVATE LIMITED",
"VEDANSHI INDUSTRIES INDIA PRIVATE LIMITED",
"VEDANSHI TEXTILE PRIVATE LIMITED",
"VEDANT ACADEMY",
"VEDANT AGRO SCIENCE TECHNOLOGIES PRIVATE LIMITED",
"VEDANT APPARELS INDIA PRIVATE LIMITED",
"VEDANT ASSET LIMITED",
"VEDANT COMPUTERS SALES PRIVATE LIMITED",
"VEDANT CONSTRUCTION PRIVATE LIMITED",
"VEDANT CONSULTANCY PRIVATE. LIMITED",
"VEDANT CORPORATION PRIVATE LIMITED",
"VEDANT CUEING PRIVATE LIMITED",
"VEDANT DEVELOPMENTS",
"VEDANT ENGITECH AND INFRASTRUCTURE PRIVATE LIMITED",
"VEDANT ENTERPRISES",
"VEDANT EQUIP SALES AND SERVICES PRIVATE LIMITED",
"VEDANT FAIR TRADE PRIVATE LIMITED",
"VEDANT FASHIONS LIMITED",
"VEDANT FASHIONS PRIVATE LIMITED",
"VEDANT FERTILIZERS (INDIA) PRIVATE LIMITED",
"VEDANT FREIGHT FORWARDING PRIVATE LIMITED",
"VEDANT HEALTH CARE",
"VEDANT HOSPITAL",
"VEDANT INTERNATIONAL SCHOOL",
"VEDANT KOTTON PRIVATE LIMITED",
"VEDANT LASER TECHNOLOGIES PRIVATE LIMITED",
"VEDANT METALLICS PRIVATE LIMITED",
"VEDANT MULTISPECIALITY HOSPITAL",
"VEDANT PACKERS PRIVATE LIMITED",
"VEDANT PAPERCRAFT PRIVATE LIMITED",
"VEDANT POLY FABS PRIVATE LIMITED",
"VEDANT REMEDIES PRIVATE LIMITED",
"VEDANT ROAD CARRIERS PRIVATE LIMITED",
"VEDANT ROADLINES PRIVATE LIMITED",
"VEDANT SERVICES PRIVATE LIMITED",
"VEDANT SHIP MANAGEMENT (INDIA) PRIVATE LIMITED",
"VEDANT SYNERGY PRIVATE LIMITED",
"VEDANT TOOLS PRIVATE LIMITED",
"VEDANT TRADELINK PRIVATE LIMITED",
"VEDANT UNIVERSAL TRADEX PRIVATE LIMITED",
"VEDANT VINIMAY PVT LTD",
"VEDANTA ACADEMY",
"VEDANTA ALUMINA LIMITED",
"VEDANTA CONSULTING PRIVATE LIMITED",
"VEDANTA COPPER EXTRUSION PRIVATE LIMITED",
"VEDANTA CREATIONS LIMITED",
"VEDANTA EQUIPMENTS PRIVATE LIMITED.",
"VEDANTA HOSPITAL & RESEARCH CENTRE",
"VEDANTA HOSPITAL & RESEARCH CENTRE PRIVATE LIMITED",
"VEDANTA IRRIGATION SYSTEMS PRIVATE LIMITED",
"VEDANTA LIMITED",
"VEDANTA MEDICAL RESEARCH FOUNDATION",
"VEDANTA METACAST PRIVATE LIMITED",
"VEDANTA MINERALS PRIVATE LIMITED",
"VEDANTA POLYMERS PRIVATE LIMITED",
"VEDANTA REALTY PRIVATE LIMITED",
"VEDANTA TECHNO SOLUTIONS",
"VEDANTA WASHERY AND LOGISTIC SOLUTIONS PRIVATE LIMITED",
"VEDANTAA INSTITUTES OF ACADEMIC EXCELLENCE PRIVATE LIMITED",
"VEDANTAM INFOSOLUTIONS PRIVATE LIMITED",
"VEDANTH JEWELS PRIVATE LIMITED",
"VEDANTH WHITEGOLD PRIVATE LIMITED",
"VEDANTU ENERGY INDIA PRIVATE LIMITED",
"VEDAPURE NATURALS PRIVATE LIMITED",
"VEDAROOTS PRIVATE LIMITED",
"VEDARYAN INDIA PRIVATE LIMITED",
"VEDAS EXPORTS PRIVATE LIMITED",
"VEDASHREE ENTERPRISES PRIVATE LIMITED",
"VEDASRI GREEN ENERGY PRIVATE LIMITED",
"VEDASS GLOBAL INFRASTRUCTURE & PROJECTS PRIVATE LIMITED",
"VEDAVAAG SYSTEMS LIMITED",
"VEDAVYASA INTERICS PRIVATE LIMITED",
"VEDBIO CROP CARE PRIVATE LIMITED",
"VEDDIS ADVISORS PRIVATE LIMITED",
"VEDDIS SOLARS PRIVATE LIMITED",
"VEDH BACHATGAT MARKETING CORPORATION LLP",
"VEDH COLOURS PRIVATE LIMITED",
"VEDH TECHNO ENGINEERS PRIVATE LIMITED",
"VEDH VALLEY WORLD SCHOOL",
"VEDHA ENGINEERS AND CONTRACTORS PRIVATE LIMITED",
"VEDHA ENTECH INDIA PRIVATE LIMITED",
"VEDHA SPINNING MILLS PRIVATE LIMITED",
"VEDHAAH GREEN POWER PRIVATE LIMITED",
"VEDHAAH POWER PRIVATE LIMITED",
"VEDHANT CONTRACTORS PRIVATE LIMITED",
"VEDHAS TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"VEDI BOOKS PRIVATE LIMITED",
"VEDI IT SOLUTIONS PRIVATE LIMITED",
"VEDIC AGRO SCIENCE PRIVATE LIMITED",
"VEDIC AGROTECH PRIVATE LIMITED",
"VEDIC AND FUTURISTIC EDUTECH",
"VEDIC APPAREL PRIVATE LIMITED",
"VEDIC AYUR WELLNESS INDIA PRIVATE LIMITED",
"VEDIC BROADCASTING LIMITED",
"VEDIC CEREALS FLOUR PRIVATE LIMITED",
"VEDIC COSMECEUTICALS PRIVATE LIMITED",
"VEDIC DRINKS PRIVATE LIMITED",
"VEDIC FOODS PRIVATE LIMITED",
"VEDIC GIRLS SENIOR SECONDARY SCHOOL",
"VEDIC INTER COLLEGE NAGLA BIRKHU ALIGARH",
"VEDIC INTERNATIONAL SCHOOL",
"VEDIC LIFESCIENCES PRIVATE LIMITED",
"VEDIC MATHS FORUM PRIVATE LIMITED",
"VEDIC NATURAL CARE PRIVATE LIMITED",
"VEDIC PAC-SYSTEMS PRIVATE LIMITED",
"VEDIC PETROCHEMICAL PRIVATE LIMITED",
"VEDIC RESORTS & HOTELS PRIVATE LIMITED",
"VEDIC SECURITY PRIVATE LIMITED",
"VEDIC SOFT SOLUTIONS INDIA PRIVATE LIMITED",
"VEDIC SYSTEMS PRIVATE LIMITED",
"VEDIC UPCHAR PRIVATE LIMITED",
"VEDIC WASTEWATER MANAGEMENT PRIVATE LIMITED",
"VEDICA COMPUTER PRIVATE LIMITED",
"VEDICARE AYURVEDA PRIVATE LIMITED",
"VEDICINALS INDIA PRIVATE LIMITED",
"VEDIK DEALCOM PRIVATE LIMITED",
"VEDIK GO UTPAD FOUNDATION",
"VEDIKA AGRO MART PRIVATE LIMITED",
"VEDIKA BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"VEDIKA CREDIT CAPITAL LIMITED",
"VEDIKA EXPORTS TEA PVT LTD",
"VEDIKA FINANCE PRIVATE LIMITED",
"VEDIKA FINANCIAL SERVICES PRIVATE LIMITED",
"VEDIKA FINCORP PRIVATE LIMITED",
"VEDIKA IT SOLUTION PRIVATE LIMITED",
"VEDIKA MACHINERY PRIVATE LIMITED",
"VEDIKA METALS PRIVATE LIMITED",
"VEDIKA SECURITIES PVT LTD",
"VEDIKA SHIPPING & MARINE SERVICES PRIVATE LIMITED",
"VEDIKA VANIJYA PRIVATE LIMITED",
"VEDINI VINIMAY PRIVATE LIMITED",
"VEDISTRY PRIVATE LIMITED",
"VEDIT HR SOLUTION PRIVATE LIMITED",
"VEDITY SOFTWARE PRIVATE LIMITED",
"VEDKIRAN STEEL INDUSTRIES PRIVATE LIMITED",
"VEDLOGIC SOLUTIONS PRIVATE LIMITED",
"VEDMA CONSTRUCTIONS PRIVATE LIMITED",
"VEDMUTHA ELECTRICALS (INDIA) PRIVATE LIMITED",
"VEDOM ENGINEERING SERVICES PRIVATE LIMITED",
"VEDSARAL BUILDWELL LIMITED",
"VEDU INFRASTRUCTURE PRIVATE LIMITED",
"VEDULA ENGINEERING PRIVATE LIMITED",
"VEDV PUBLICATION PRIVATE LIMITED",
"VEDVAN CONSULTANTS PRIVATE LIMITED",
"VEDVYAS LOGISTIC PRIVATE LIMITED",
"VEDVYAS MINERALS PRIVATE LIMITED",
"VEDX INTERNATIONAL PRIVATE LIMITED",
"VEDYA SOFTWARE SOLUTIONS PRIVATE LIMITED",
"VEE AAR BROTHERS PRIVATE LIMITED",
"VEE AAR WOODCHEM PRIVATE LIMITED",
"VEE CARE MEDISERVICES CHENNAI PRIVATE LIMITED",
"VEE CEE EXPORTS",
"VEE CONNECT TRAVELS PRIVATE LIMITED",
"VEE DEE ENTERPRISES",
"VEE EN KAY ENGINEERING CONSULTANCY PRIVATE LIMITED",
"VEE ENGINEERS AND INFRASTRUCTURES INDIA PRIVATE LIMITED",
"VEE ESS BEVERAGES PRIVATE LIMITED",
"VEE ESS CAPFIN PRIVATE LIMITED",
"VEE ESS POULTRIES PRIVATE LIMITED",
"VEE ESS SALES PVT LTD",
"VEE EXCEL DRUGS AND PHARMACEUTICALS PRIVATE LIMITED",
"VEE GEE AUTO COMPONENTS PRIVATE LIMITED",
"VEE GEE CHEMICALS PRIVATE LIMITED",
"VEE GEE KAUSHIKO ENGINEERING PRIVATE LIMITED",
"VEE GEE PRECISION COMPONENTS PRIVATE LIMITED",
"VEE GEE SALES PRIVATE LIMITED",
"VEE GEE SQUARE PRODUCTS PRIVATE LIMITED",
"VEE GUN AGRO PRIVATE LIMITED",
"VEE HEALTHTEK PRIVATE LIMITED",
"VEE IMAGING SOLUTIONS PRIVATE LIMITED",
"VEE KAY CONCAST PRIVATE LIMITED",
"VEE KAY OILS PRIVATE LIMITED",
"VEE KAY PRESTRESSED PRIVATE LIMITED",
"VEE MEDI BIOTECH INDIA PRIVATE LIMITED",
"VEE PEE FABRIC PRIVATE LIMITED",
"VEE POINT COMMERCE PVT LTD",
"VEE RUBBER INDIA PRIVATE LIMITED",
"VEE SQUARE HITECH INFRA PRIVATE LIMITED",
"VEE TECH VALVES PRIVATE LIMITED",
"VEE TECHNOLOGIES PRIVATE LIMITED",
"VEE TEE AUTO MANUFACTURING COMPANY PRIVATE LIMITED",
"VEE TEE AUTO MFG CO PRIVATE LIMITED",
"VEE TREE POWER PRIVATE LIMITED",
"VEE VEE BUS SERVICES PRIVATE LIMITED",
"VEE VEE MERCHANDISE PRIVATE LIMITED",
"VEE VIN AGRO (INDIA) PRIVATE LIMITED",
"VEEAM SOFTWARE PRIVATE LIMITED",
"VEEAR ANALYTICS PRIVATE LIMITED",
"VEEAR PROJECTS AND TECH PRIVATE LIMITED",
"VEEBEE TECHNOLOGIES PRIVATE LIMITED",
"VEEBEE YARNNTEX PRIVATE LIMITED",
"VEEBHA BEVERAGES PRIVATE LIMITED",
"VEECHEM TRADERS PRIVATE LIMITED",
"VEEDA CLINICAL RESEARCH LIMITED",
"VEEDA CLINICAL RESEARCH PRIVATE LIMITED",
"VEEDAY AGRO INDIA PRIVATE LIMITED",
"VEEDEV IMPEX PRIVATE LIMITED",
"VEEDON MARKETING PRIVATE LIMITED",
"VEEDON TRADING COMPANY PRIVATE LIMITED",
"VEEFIN SOLUTIONS LIMITED",
"VEEFLEX ELECTRIKALS PRIVATE LIMITED",
"VEEGALAND DEVELOPERS PRIVATE LIMITED",
"VEE GEE INDUSTRIAL ENTERPRISES PRIVATE LIMITED",
"VEEGI PROJECTSS PRIVATE LIMITED",
"VEEGLOW ENGINEERING SOLUTIONS PRIVATE LIMITED",
"VEEGRIP BELTS PRIVATE LIMITED",
"VEEHA MARKETING PRIVATE LIMITED",
"VEEJAY FACILITY MANAGEMENT PRIVATE LIMITED",
"VEEJAY LAKSHMI ENGINEERING WORKS LIMITED",
"VEEJAY POLY FILMS LIMITED",
"VEEJAY POLYPLAST LIMITED",
"VEEJAY SANIWARES PRIVATE LIMITED",
"VEEJAY SYNTEX PRIVATE LIMITED",
"VEEJAY TERRY PRODUCTS LIMITED",
"VEEKAS PIPES PVT LTD",
"VEEKAS PROFILE (INDIA) PRIVATE LIMITED",
"VEEKAY CONNECTORS PRIVATE LIMITED",
"VEEKAY DIAMANTS PRIVATE LIMITED",
"VEEKAY DISTILLERIES PRIVATE LIMITED",
"VEEKAY ENTERPRISES PVT LIMITED",
"VEEKAY MINERALS PRIVATE LIMITED",
"VEEKAY PLASTICHEM PRIVATE LIMITED",
"VEEKAY PRINTS PRIVATE LIMITED",
"VEEKAY SURGICALS PRIVATE LIMITED",
"VEEKAY VIKRAM & CO. LLP",
"VEEKAYEM FASHION AND APPARELS LIMITED",
"VEEKAYLAL INVESTMENT COMPANY PRIVATE LIMITED",
"VEEKESY ELASTOMERS PRIVATE LIMITED",
"VEEKESY FOOTCARE INDIA PRIVATE LIMITED",
"VEEKESY FOOTGEAR PRIVATE LIMITED",
"VKC PLASTOMERS INDIA PRIVATE LIMITED",
"VEEKESY POLYMERS PRIVATE LIMITED",
"VEEKESY RUBBER INDUSTRIES PRIVATE LIMITED",
"VEEKESY SANDALS INDIA PRIVATE LIMITED",
"VEEKESY SHOES AND ALLIED PRODUCTS INDIA PRIVATE LIMITED",
"VEEKESY SLIPPERS INDIA PRIVATE LIMITED",
"VEEKSHITHA HOSPITALITY PRIVATE LIMITED",
"VEELEAD SOLUTIONS PRIVATE LIMITED",
"VEELINE ESTATES PVT LTD",
"VEELINE INDUSTRIES LIMITED",
"VEELINK SOURCING PRIVATE LIMITED",
"VEEN WATERS INDIA PRIVATE LIMITED",
"VEENA COLLEGE OF COMMERCE AND SCIENCE",
"VEENA DEVELOPERS",
"VEENA DIE CASTERS AND ENGINEERS PRIVATE LIMITED",
"VEENA DIECASTERS&ENGINEERS PRIVATE LIMITED",
"VEENA ENGICAST PRIVATE LIMITED",
"VEENA GARMENTS PRIVATE LIMITED",
"VEENA LIFESCIENCES INDIA PRIVATE LIMITED",
"VEENA PATIL HOSPITALITY PRIVATE LIMITED",
"VEENA PLYWOOD PRIVATE LIMITED",
"VEENA REALCON PRIVATE LIMITED",
"VEENA ROLLING FORMS INDIA PRIVATE LIMITED",
"VEENA TRADERS PRIVATE LIMITED",
"VEENAGS HEALTHCARE PRIVATE LIMITED",
"VEENASHIVAPPARAI CIVIL INFRA PRIVATE LIMITED",
"VEENASHREE FOAM & FURNISHING PRIVATE LIMITED",
"VEENAYAK POLY PRINTS PRIVATE LIMITED",
"VEENGRO PROJECTS INDIA PRIVATE LIMITED",
"VEEN'S FOOD INNOVATIONS PRIVATE LIMITED",
"VEENSAN FABRICS PRIVATE LIMITED",
"VEENUFLEX PRIVATE LIMITED",
"VEENUS ENGINEERING",
"VEENUS ERECTORS (INDIA) PRIVATE LIMITED",
"VEENUS MAINTENANCE SERVICES PRIVATE LIMITED",
"VEEPEE GRAPHIC SOLUTIONS PRIVATE LIMITED",
"VEEPHOENIX COMPLIANCE PRIVATE LIMITED",
"VEEPRHO LABORATORIES PRIVATE LIMITED",
"VEEPUL LUBRICANTS PRIVATE LIMITED",
"VEER APPLIANCES PRIVATE LIMITED",
"VEER ARAHAM BUSINESS CREDITS PRIVATE LIMITED",
"VEER ARJUN NEWS PAPERS PRIVATE LTD",
"VEER BUNDEL KHAND PRESS",
"VEER CHEMIE AND AROMATICS PVT LTD",
"VEER COLONISERS AND BUILDERS PRIVATE LIMITED",
"VEER DISTRIBUTORS PRIVATE LIMITED",
"VEER ELECTRONICS PRIVATE LIMITED",
"VEER ENERGY & INFRASTRUCTURE LIMITED",
"VEER ENTERPRISES LIMITED",
"VEER FINVEST PRIVATE LIMITED",
"VEER GEMS",
"VEER GLOBAL INFRACONSTRUCTION LIMITED",
"VEER HANUMAN BUILDPRO PRIVATE LIMITED",
"VEER HANUMAN POLYPLAST",
"VEER HUES LIMITED",
"VEER IMPEX PRIVATE LIMITED",
"VEER INFRA PRIVATE LIMITED",
"VEER JEWELLERS PRIVATE LIMITED",
"VEER JINESHWAR SILK MILLS PRIVATE LIMITED",
"VEER MANPOWER SERVICES PRIVATE LIMITED",
"VEER MARINE PVT LTD",
"VEER METAL INDUSTRIES PRIVATE LIMITED",
"VEER NARMAD SOUTH GUJARAT UNIVERSITY",
"VEER O METALS PRIVATE LIMITED",
"VEER OVERSEAS LIMITED",
"VEER PARBHU CARGO PRIVATE LIMITED",
"VEER PIPE AGENCIES PRIVATE LIMITED",
"VEER PLASTICS PRIVATE LIMITED",
"VEER RATNA METALS PRIVATE LIMITED",
"VEER SAVARKAR PROJECTS PRIVATE LIMITED",
"VEER SILK MILLS PRIVATE LIMITED",
"VEER SURENDRA SAI INSTITUTE OF MEDICAL SCIENCES AND RESEARCH",
"VEER THERMOFOAMING PRIVATE LIMITED",
"VEER TRADING CO PVT. LTD",
"VEER VARDHMAN TEXTILE MILLS LIMITED",
"VEER VASU EXPORTS PRIVATE LIMITED",
"VEER VISIONS PVT LTD",
"VEER WHEELS PRIVATE LIMITED",
"VEERA A TRADERS PRIVATE LIMITED",
"VEERA APARTMENTS PRIVATE LIMITED",
"VEERA AUTOEXIM PRIVATE LIMITED",
"VEERA DEVELOPERS PRIVATE LIMITED",
"VEERA FRAGRANCES PRIVATE LIMITED",
"VEERA HOME TEX (INDIA) PRIVATE LIMITED",
"VEERA INFRADEVELOPERS PRIVATE LIMITED",
"VEERA JEWELLERY CREATIONS PRIVATE LIMITED",
"VEERA PRECICAST PRIVATE LIMITED",
"VEERA SIVA GRANITES AND EXPORTS PRIVATE LIMITED",
"VEERA SOLAR ENERGY PRIVATE LIMITED",
"VEERA TANNERIES PRIVATE LIMITED",
"VEERA TECHNO TREC PRIVATE LIMITED",
"VEERA TRACK FASTENERS PRIVATE LIMITED",
"VEERA TRADING AND TEXTILE COMPANY PVT LTD",
"VEERA VAHANA UDYOG PRIVATE. LIMITED.",
"VEERAAYA TECHNO PLAST PRIVATE LIMITED",
"VEERABHADRA EXPORTS PRIVATE LIMITED",
"VEERABHADRA MINERALS PVT LTD.",
"VEERABHADRESHWARA INDUSTRIES PRIVATE LIMITED",
"VEERABHADRESWARA RAW & BOILED RICE MILL",
"VEERACO COLOURANTS PRIVATE LIMITED",
"VEERAIAH NON-CONVENTIONAL POWER PROJECTS LIMITED",
"VEERAL ADDITIVES PRIVATE LIMITED",
"VEERAL CONTROLS PRIVATE LIMITED",
"VEERALCO METALS PRIVATE LIMITED",
"VEERAM CLOTHING PRIVATE LIMITED",
"VEERAM PACK PRIVATE LIMITED",
"VEERAM SECURITIES LIMITED",
"VEERAM VENDORS PRIVATE LIMITED",
"VEERAMANI BISCUIT INDUSTRIES PRIVATE LIMITED",
"VEERANARAYANA METAL ALLOYS PRIVATE LIMITED",
"VEERANGANA AVANTI BAI RAJKIYA GIRLS INTER COLLEGE",
"VEERANGNA JHALKARI BAI GOVERNMENT GIRLS POLYTECHNIC JHANSI",
"VEERAPANDI COMMON EFFLUENT TREATMENT PLANT PRIVATE LIMITED",
"VEERAPANDY KALANJIA JEEVIDAM PRODUCER COMPANY LIMITED",
"VEERARAGHAVAN & CO",
"VEERAS INFOTEK PRIVATE LIMITED",
"VEERAS INFRA INDIA PRIVATE LIMITED",
"VEERASHREE INDUSTRIES PRIVATE LIMITED",
"VEERBALAJI INFRABUILD PRIVATE LIMITED",
"VEERBHADRA ENTERPRISE",
"VEERENDRA PATIL FIRST GRADE COLLEGE",
"VEERENDRA SINGH RAJPUT PROJECTS PRIVATE LIMITED",
"VEERESHA CASTINGS PRIVATE LIMITED",
"VEERESHA TECHNO INDUSTRIES PRIVATE LIMITED",
"VEERESHWARA CONSTRUCTIONS PRIVATE LIMITED",
"VEERESHWARKRIPA INFRASTRUCTURE PRIVATE LIMITED",
"VEERHEALTH CARE LIMITED",
"VEERJYOTI SAREES PRIVATE LIMITED",
"VEERKRUPA JEWELLERS LIMITED",
"VEERPRABHU AUTO PRIVATE LIMITED",
"VEERPRABHU MARKETING LIMITED",
"VEERPRABHU PRINTS PVT LTD",
"VEERVIKASH ESTATES PRIVATE LIMITED",
"VEERWAL GETWORK SERVICES PRIVATE LIMITED",
"VEERYA ATTACHMENTS PRIVATE LIMITED",
"VEESARA GLOBAL DIGITECH SOLUTION PRIVATE LIMITED",
"VEESHAMKO VENTURES PRIVATE LIMITED",
"VEESHNA POLYPACK PRIVATE LIMITED",
"VEESON VALVES PRIVATE LIMITED",
"VEESTAAR MARKETING PRIVATE LIMITED",
"VEETA HEALTH & NUTRITIONS INDIA PRIVATE LIMITED",
"VEETARAAG INFRASTRUCTURE PRIVATE LIMITED",
"VEETECH COMMUNICATION AND SERVICES PRIVATE LIMITED",
"VEETEE FINE FOODS LIMITED",
"VEETEE TRADING PRIVATE LIMITED",
"VEETEEJAY MOTORS PRIVATE LIMITED",
"VEETEK STOREMATE PRIVATE LIMITED",
"VEETO KING FOODS PRIVATE LIMITED",
"VEETON SEATING SYSTEMS PRIVATE LIMITED",
"VEETON WOODPLAST PRIVATE LIMITED",
"VEETRAG BUILDCON PRIVATE LIMITED",
"VEETRAG COMPUTERS PRIVATE LIMITED",
"VEETRAG HOSIERY PRIVATE LIMITED",
"VEETRAG INFRADEVELOPERS PRIVATE LIMITED",
"VEETRAG TEXTILES PRIVATE LIMITED",
"VEEVA SOFTWARE SYSTEMS INDIA PRIVATE LIMITED",
"VEEVEE CONTROLS PRIVATE LIMITED",
"VEEXL SURFACE ENGINEERING PRIVATE LIMITED",
"VEEYEM DISTRIBUTORS PRIVATE LIMITED",
"VEEYEM KAY PROMOTERS PRIVATE LIMITED",
"VEEYES ALLOYS PRIVATE LIMITED",
"VEEYES DENTAL HOSPITAL",
"VEEYES ELECTRONICS PRIVATE LIMITED",
"VEEYES ENGINEERING PRIVATE LIMITED",
"VEEYES FOUNDRY PRIVATE LIMITED",
"VEEYES STEELCAST PRIVATE LIMITED",
"VEEYOR POLYMERS PRIVATE LIMITED",
"VEEYU HR SOLUTIONS PRIVATE LIMITED",
"VEFAB ENGINEERING PRIVATE LIMITED",
"VEFES ENGINEERING PRIVATE LIMITED",
"V-EFFICHARGE POWER-SYSTEMS PRIVATE LIMITED",
"VEFRU AGRO PRIVATE LIMITED",
"VEGA AUTO ACCESSORIES PRIVATE LIMITED",
"VEGA AVIATION PRODUCTS PRIVATE LIMITED",
"VEGA BIOTEC PRIVATE LIMITED",
"VEGA CARGO AND LOGISTICS PRIVATE LIMITED",
"VEGA CASHEWS ENTERPRISES PRIVATE LIMITED",
"VEGA CHEMICALS PRIVATE LIMITED",
"VEGA CONTROLS PRIVATE LIMITED",
"VEGA CORPORATE SERVICES PRIVATE LIMITED",
"VEGA FUNMOBILES PRIVATE LIMITED",
"VEGA HEALTH CARE PVT.LTD.",
"VEGA HOSPITALITY PRIVATE LIMITED",
"VEGA INDUSTRIES PRIVATE LIMITED",
"VEGA INFRASTRUCTURE PRIVATE LIMITED",
"VEGA INNOVATIONS AND TECHNOCONSULTANTS PRIVATE LIMITED",
"VEGA INTELLI SOFT PRIVATE LIMITED",
"VEGA JEWELDIAM PRIVATE LIMITED",
"VEGA POWER PRIVATE LIMITED",
"VEGA PROJECT INDIA PRIVATE LIMITED",
"VEGA SCHOOLS",
"VEGA SOLUTIONS PRIVATE LIMITED",
"VEGA SRI GOLD AND DIAMONDS LLP",
"VEGA TECHNOSOFT PRIVATE LIMITED",
"VEGAALINE LOGISTICS PRIVATE LIMITED",
"VEGAD AAC PRODUCTS PRIVATE LIMITED",
"VEGAM.IO SOLUTIONS PRIVATE LIMITED",
"VEGANFLARE INDIA PRIVATE LIMITED",
"VEGANPRO NUTRIENTS PRIVATE LIMITED",
"VEGAS HOTEL AND RESORT PRIVATE LIMITED",
"VEGAS MANAGEMENT PRIVATE LIMITED",
"VEGAZVA ENG PRIVATE LIMITED",
"VEGAZVA ENGINEERING PRIVATE LIMITED",
"VEGBYNATURE (INDIA) PRIVATE LIMITED",
"VEGETAL BIOACTIVES PRIVATE LIMITED",
"VEGGIEKART MARKETING PRIVATE LIMITED",
"VEGGIESVILLAGE INDIA PRIVATE LIMITED",
"VEGGIUS IMPEX PRIVATE LIMITED",
"VEGICA FOODS PRIVATE LIMITED",
"VEGIN LOGISTICS PRIVATE LIMITED",
"VEGITH GLOBAL SERVICES PRIVATE LIMITED",
"VEGITHA LOGISTICS PRIVATE LIMITED",
"VEGMA POULTRY PRODUCTS PRIVATE LIMITED",
"VEGMATO FRESH PRIVATE LIMITED",
"VEGO & THOMSON INDIA PRIVATE LIMITED",
"VEGO HOME SEIENCE PRIVATE LIMITED",
"VEGO MACHINES INDIA PRIVATE LIMITED",
"VEGSUTRA HOSPITALITY PRIVATE LIMITED",
"VEH GLOBAL INDIA PRIVATE LIMITED",
"VEHANT TECHNOLOGIES PRIVATE LIMITED",
"VEHEMENT SECURITY AND ALLIED SERVICES PRIVATE LIMITED",
"VEHERE INTERACTIVE PRIVATE LIMITED",
"VEHICLE FACTORY JABALPUIR",
"VEHLNA STEELS & ALLOYS PRIVATE LIMITED",
"VEHMA ENGINEERING SOLUTIONS (INDIA) PRIVATE LIMITED",
"VEHMA ENGINEERING SOLUTIONS INDIA PRIVATE LIMITED",
"VEI4 COMMERCIALS PRIVATE LIMITED",
"VEICHI ELECTRIC INDIA PRIVATE LIMITED",
"VEIDEHI RING PRIVATE LIMITED",
"VEILS INDIA PRIVATE LIMITED",
"VEIN HEALTHCARE PRIVATE LIMITED",
"VEINCURE HEALTHCARE PRIVATE LIMITED",
"VEINS ADVISORS PRIVATE LIMITED",
"VEINZ MARKETING PRIVATE LIMITED",
"VEIRA ELECTRONICS PRIVATE LIMITED",
"VEIRA ELECTROTECH PRIVATE LIMITED",
"VEIRA PERSONAL CARE PRIVATE LIMITED",
"VEIVA SCIENTIFIC INDIA PRIVATE LIMITED",
"VEJAS POWER PROJECTS LIMITED",
"VEJAYANT GLOBAL TRADING PRIVATE LIMITED",
"VEJENDS INFRA PRIVATE LIMITED",
"VEKA INDIA PRIVATE LIMITED.",
"VEKALPA INTERIORS PRIVATE LIMITED",
"VEKANAND TRADERS",
"VEKARIA ENGINEERING WORKS PRIVATE LIMITED",
"VEKO CARE PRIVATE LIMITED",
"VEKTRA ENGINEERING PRIVATE LIMITED",
"VEL AGENCY",
"VEL CASTINGS PRIVATE LIMITED",
"VEL COT PRIVATE LIMITED",
"VEL EARTH MOVING PRODUCTS PRIVATE LIMITED",
"VEL GANESH EDUCATIONAL TRUST",
"VEL LOGISTICS PRIVATE LIMITED",
"VEL MATCHES PRIVATE LIMITED",
"VEL SRI RANGA SANKU COLLEGE",
"VEL TECH HIGH TECH",
"VEL TECH RANGA SANKU ARTS COLLEGE",
"VEL TECH RANGARAJAN DR SAGUNTHALA R AND D INSTITUTE OF SCIENCE AND TECHNOLOGY",
"VELA AUTOMOBILE PRIVATE LIMITED",
"VELAGA SOFT SOLUTIONS PRIVATE LIMITED",
"VELAGAPUDI RAMAKRISHNA SIDDHARTHA ENGINEERING COLLEGE",
"VELALAR VIDYALAYAA SENIOR SECOUNDARY SCHOOL",
"VELAMMAL ACADEMY A/C CAMPUS",
"VELAMMAL BODHI ACADEMY",
"VELAMMAL BODHI CAMPUS",
"VELAMMAL BOTHI CAMPUS",
"VELAMMAL ENGINEERING COLLEGE",
"VELAMMAL ENIGINEERING COLLEGE",
"VELAMMAL GLOBAL SCHOOL",
"VELAMMAL HOSPITAL AND MEDICAL COLLEGE",
"VELAMMAL INTERNATIONAL SCHOOL",
"VELAMMAL JUNIORS",
"VELAMMAL MATRICULATION HIGHER SECONDAY SCHOOL",
"VELAMMAL MEDICAL COLLEGEHOSPITAL AND RESEARCH INSTITUTE",
"VELAMMAL NEW GEN EDU NETWORK",
"VELAMMAL VIDHYASARAM",
"VELAMMAL VIDHYASHRAM",
"VELAMMAL VIDYALAYA",
"VELAN INFO SERVICES INDIA PRIVATE LIMITED",
"VELAN INFRA PROJECTS PRIVATE LIMITED",
"VELAN IT SOLUTIONS PRIVATE LIMITED",
"VELAN SPECIALITY HOSPITALS PRIVATE LIMITED",
"VELAN SPINNING MILLS INDIA PRIVATE LIMITED",
"VELAN VALVES INDIA PRIVATE LIMITED",
"VELANJA PRIMARY SCHOOL",
"VELANKANI ELECTRONICS PRIVATE LIMITED",
"VELANKANI INFORMATION SYSTEMS LIMITED VISL",
"VELANKANI INFORMATION SYSTEMS PRIVATE LIMITED",
"VELANKANI INFRASTRUCTURE & PROJECTS PRIVATE LIMITED",
"VELANKANI MACHINE CRAFT PRIVATE LIMITED",
"VELANKANI SOFTWARE PRIVATE. LIMITED",
"VELANKANNI MATHA HOSPITALS PRIVATE LIMITED",
"VELANKANNI MATRICULATION HIGHER SECONDARY SCHOOL",
"VELAR STRUCTURES PRIVATE LIMITED",
"VELARUDH INFOTECH PRIVATE LIMITED",
"VELATAL INDUSTRIES PRIVATE LIMITED",
"VELAVAN HYPER MARKET PRIVATE LIMITED",
"VELAVAN MEDICAL PRIVATE LIMITED",
"VELAVAN STORES JEWELLERS PRIVATE LIMITED",
"VELAVAN STORES SILKS PRIVATE LIMITED",
"VELAYIL TRADERS PRIVATE LIMITED",
"VELCA RACKING SYSTEMS PRIVATE LIMITED",
"VELCITI CONSULTING ENGINEERS PRIVATE LIMITED",
"VELCORD MILLS",
"VELCORD TEXTILES PRIVATE LIMITED",
"VELD INDIA ADVISORY PRIVATE LIMITED",
"VELENTINE PROPERTIES PRIVATE LIMITED",
"VELICHAM FINANCE PRIVATE LIMITED",
"VELIENT PEC INDIA PRIVATE LIMITED",
"VELIMALAI RUBBER CO LIMITED",
"VELIYATH AGRO INDUSTRIES PRIVATE LIMITED",
"VELJAN DENISON LIMITED",
"VELJAN HYDRAIR LIMITED",
"VELJEE STONES & TILES PRIVATE LIMITED",
"VELJI DOSABHAI & SONS PRIVATE LIMITED",
"VELJI P AND SONS AGENCIES PRIVATE LIMITED",
"VELJI P.& SONS CUSTOMS BROKERS",
"VELJI RATNA SORATHIA INFRA PRIVATE LIMITED",
"VELKO INFRATEK PROJECTS PRIVATE LIMITED",
"VELL BISCUITS PRIVATE LIMITED",
"VELLALAR EDUCATIONAL TRUST",
"VELLALAR GROUP OF INSTITUTIONS",
"VELLANKI ESTATES AND CONSTRUCTIONS PVT LTD",
"VELLAS PRIVATE LIMITED",
"VELLIANGIRI UZHAVAN PRODUCER COMPANY LIMITED",
"VELLICHOR MEDIA PRIVATE LIMITED",
"VELLINGIRI ANDAVAR TEXTILES PRIVATE LIMITED",
"VELLOILS LUBRICANT AND PETROCHEM LTD",
"VELLORE INSTITUTE OF TECHNOLOGY",
"VELLORE ROLLER FLOUR MILLS PRIVATE LIMITED",
"VELMED HOSPITALS",
"VELMOLD PLASTICS PRIVATE LIMITED",
"VELMURUGA ENTERPRISES PRIVATE LIMITED",
"VELMURUGAN ENERGY FARM PRIVATE LIMITED",
"VELMURUGAN HEAVY ENGINEERING INDUSTRIES PRIVATE LIMITED",
"VELMURUKAN HOTEL PRIVATE LIMITED",
"VELNET NON-CONVENTIONAL ENERGY SYSTEMS PRIVATE. LIMITED",
"VELNEX LIFE SCIENCES PRIVATE LIMITED",
"VELNIK INDIA LIMITED",
"VELNIK INDIA MARKETING PRIVATE LIMITED",
"VELO SERVICES PRIVATE LIMITED",
"VELOCE HERBALS PRIVATE LIMITED",
"VELOCE LOGISTICS PRIVATE LIMITED",
"VELOCE TECH INFORMATION PRIVATE LIMITED",
"VELOCES CONSULTING SERVICES PRIVATE LIMITED",
"VELOCIOUS LABS SYSTEM INTEGRATION PRIVATE LIMITED",
"VELOCIOUS SOLUTIONS PRIVATE LIMITED",
"VELOCIOUS TRADING PRIVATE LIMITED",
"VELOCIPED TRADING PRIVATE LIMITED",
"VELOCIS SYSTEMS PRIVATE LIMITED",
"VELOCITA BRAND CONSULTANTS PRIVATE LIMITED",
"VELOCITAI DIGITAL PRIVATE LIMITED",
"VELOCITER LOGISTICS PRIVATE LIMITED",
"VELOCITER SOLUTIONS PRIVATE LIMITED",
"VELOCITI MOBILITY SOLUTIONS PRIVATE LIMITED",
"VELOCITY",
"VELOCITY AGRITECH INDIA PRIVATE LIMITED",
"VELOCITY AUTOMOBILES PVT LTD",
"VELOCITY AUTOMOTIVES PRIVATE LIMITED",
"VELOCITY ENGINEERS PRIVATE LIMITED",
"VELOCITY FREIGHT PRIVATE LIMITED",
"VELOCITY GLOBAL MANAGEMENT SERVICES PRIVATE LIMITED",
"VELOCITY INTELLIGENCE SECURITY SERVICES PRIVATE LIMITED",
"VELOCITY PROPBUILD PRIVATE LIMITED",
"VELOCITY ROLLERS PRIVATE LIMITED",
"VELOCITY SOFTWARE SOLUTIONS PRIVATE LIMITED",
"VELOCITY SUPPLY CHAIN PRIVATE LIMITED",
"VELOCITY TECH SOL INDIA PRIVATE LIMITED",
"VELOCITY TRANSMISSIONS PRIVATE LIMITED",
"VELOCITY TRANSOLUTIONS PRIVATE LIMITED",
"VELOCITY TRAVEL AGENTS PRIVATE LIMITED",
"VELOCITY WEB TECH PRIVATE LIMITED",
"VELOCITY XCELERATOR PRIVATE LIMITED",
"VELOCIX SOLUTIONS INDIA LLP",
"VELOCRETE PRECAST PRIVATE LIMITED",
"VELOGIC INDIA PRIVATE LIMITED",
"VELOSIO OVERSEAS PRIVATE LIMITED",
"VELOSIT INDIA PRIVATE LIMITED",
"VELOSPEAR TECHNOLOGIES INDIA PRIVATE LIMITED",
"VELOTIO TECHNOLOGIES PRIVATE LIMITED",
"VELOX AUTOMATION PRIVATE LIMITED",
"VELOX BIOLOGICS PRIVATE LIMITED",
"VELOX LABS PRIVATE LIMITED",
"VELOX MOTORS PRIVATE LIMITED",
"VELOX TYRES PRIVATE LIMITED",
"VELOZE MEDICAL SOLUTIONS PRIVATE LIMITED",
"VELPACK PRIVATE LIMITED",
"VELS ACADAMY",
"VELS FILM INTERNATIONAL LIMITED",
"VELS INSTITUE OF SCIENCS TECHNOLOGY",
"VELS INSTITUTE OF SCIENCE TECHNOLOGY",
"VELS INTERNATIONAL PRESCHOOL",
"VELS STUDIOS AND ENTERTAINMENT PRIVATE LIMITED",
"VELS UNIVERSITY",
"VELSONS ENGINEERS PRIVATE LIMITED",
"VELSONS PRINTOGRAPHIC PRIVATE LIMITED",
"VELTECH AUTO PART (INDIA) PRIVATE LIMITED",
"VELTECH DR RR & DR SR UNIVERSITY",
"VELTECH FORGING PRIVATE LIMITED",
"VELTRONICS INDIA PRIVATE LIMITED",
"VELUMAILU SIDDHA MEDICAL COLLEGE & HOSPI",
"VELUMURI INFRA PRIVATE LIMITED",
"VELUXE LIVING INDIA PRIVATE LIMITED",
"VELVET GROOMING PRIVATE LIMITED",
"VELVET LADDER PRIVATE LIMITED",
"VELVET RESORTS PRIVATE LIMITED",
"VELVET SPOON",
"VELVIN PACKAGING PRIVATE LIMITED",
"VELVIN PAPER PRODUCTS",
"VELVYT CHIKAN LABEL PRIVATE LIMITED",
"VELY MONKEYS MKT PRIVATE LIMITED",
"VEM AGRO TECH PRIVATE LIMITED",
"VEM TECHNOLOGIES PRIVATE LIMITED",
"VEM TOOLING INDIA PRIVATE LIMITED",
"VEMA HOSPITALITY PRIVATE LIMITED",
"VEMA SOLAR PRIVATE LIMITED",
"VEMAR CONSTRUCTION PRIVATE LIMITED",
"VEMBANADU RUBBERS PRIVATE LIMITED",
"VEMBU TECHNOLOGIES PRIVATE LIMITED",
"VEMPRA HOLDINGS PRIVATE LIMITED",
"VEMSIO MAPPING SOLUTIONS PRIVATE LIMITED",
"VEMU INSTITUTE OF TECHNOLOGY",
"VEN BIOTECH PRIVATE LIMITED",
"VEN CONSULTING INDIA PRIVATE LIMITED",
"VEN DRILLING ADDITIVES PRIVATE LIMITED",
"VEN LIFE SCIENCES PRIVATE LIMITED",
"VEN PONN SHOES PRIVATE LIMITED",
"VEN SOFT INDIA PRIVATE LIMITED",
"VEN TECH PRIVATE LIMITED",
"VEN2RAY TECHNOLOGIES PRIVATE LIMITED",
"VENA ENERGY FATANPUR POWER PRIVATE LIMITED",
"VENA ENERGY INFRASTRUCTURE SERVICES PRIVATE LIMITED",
"VENA ENERGY KN WIND POWER PRIVATE LIMITED",
"VENA ENERGY MH WIND POWER PRIVATE LIMITED",
"VENA ENERGY PATAN POWER PRIVATE LIMITED",
"VENA ENERGY SHIVALIK WIND POWER PRIVATE LIMITED",
"VENA ENERGY SOLAR RAVI INDIA POWER RESOURCES PRIVATE LIMITED",
"VENAD CONDUCTORS PVT LTD",
"VENAD DESIGNERS AND CONTRACTORS PRIVATE LIMITED",
"VENAD GRANITES AND SAND PRIVATE LIMITED",
"VENAD POULTRY FARMERS PRODUCER COMPANY LIMITED",
"VENALICIUM DIGITAL PRIVATE LIMITED",
"VENATOR SEARCH PRIVATE LIMITED",
"VENBA TECH PRIVATE LIMITED",
"VENCER PAINTS & ADHESIVES PRIVATE LIMITED",
"VENCH MARK HEALTHCARE PRIVATE LIMITED",
"VENCHARS MEDIA COMMUNICATION PRIVATE LIMITED",
"VENCO RESEARCH AND BREEDING FARM PRIVATE LIMITED",
"VENCORE BUSINESS SOLUTIONS PRIVATE LIMITED",
"VENDAS SOLUTIONS PRIVATE LIMITED",
"VENDAVO TECHNOLOGY PRIVATE LIMITED",
"VENDEEP GREEN GLOBE ORGANIC VENTURES PRIVATE LIMITED",
"VENDEEP TECHNOIDENTITY SOLUTIONS PRIVATE LIMITED",
"VENDEKIN TECHNOLOGIES PRIVATE LIMITED",
"VENDERE SALES SERVICES (INDIA) PRIVATE LIMITED",
"VENDIGGE ENGINEERING PROJECTS PRIVATE LIMITED",
"VENDIMAN PRIVATE LIMITED",
"VENDIMIA FOODS PRIVATE LIMITED",
"VENDING UPDATES (INDIA) PRIVATE LIMITED",
"VENDITIO PRIVATE LIMITED",
"VENDMART RETAIL PRIVATE LIMITED",
"VENDOMATIC INDIA PRIVATE LIMITED",
"VENDOR INFRA GLOBAL PRIVATE LIMITED",
"VENDORSKART ONLINE SERVICES PRIVATE LIMITED",
"VENDR ALTECH PRIVATE LIMITED",
"VENDRA ENTERPRISES PRIVATE LIMITED",
"VENDSY INDIA PRIVATE LIMITED.",
"VENEER SAW MILLS PRIVATE LIMITED",
"VENEET CAPITAL SERVICES PRIVATE LIMITED",
"VENELEC ELECTROMECH INDUSTRIES PRIVATE LIMITED",
"VENERA BIO-TECH SYSTEMS PRIVATE LIMITED",
"VENERA TECHNOLOGIES PRIVATE LIMITED",
"VENERA VIDEO TECH PRIVATE LIMITED",
"VENERABLE ENERGY SOLUTIONS PRIVATE LIMITED",
"VENERATE SECURITY AND ALLIED PRIVATE LIMITED",
"VENERATE SOLUTIONS PRIVATE LIMITED",
"VENERATED TECHNOLOGY PRIVATE LIMITED",
"VENETIA LABORATORIES PRIVATE LIMITED",
"VENETUS LOGISTICS PRIVATE LIMITED",
"VENGADAMUDAIYAN HI-TECH AGRO FOODS PRIVATE LIMITED",
"VENGAI SOFTWARE SOLUTIONS PRIVATE LIMITED",
"VENGALA ENGINEERING DESIGN SERVICES PRIVATE LIMITED",
"VENHAN TECHNOLOGIES PRIVATE LIMITED",
"VENI LAKSHMI MILLS PRIVATE LIMITED",
"VENICA ECOMMERCE PRIVATE LIMITED",
"VENICE GEMS PRIVATE LIMITED",
"VENICE MAINTENANCE LLP",
"VENICECO FINANCIAL SERVICES PRIVATE LIMITED",
"VENIMADHAV TRADERS",
"VENINE MACHINES PVT LTD",
"VENISHA JEWELLERS PRIVATE LIMITED",
"VENISO SOLUTIONS PRIVATE LIMITED",
"VENJOH LOGISTICS PRIVATE LIMITED",
"VENJUS EVOLUTION PRIVATE LIMITED",
"VENKANNA SOFTWARE SERVICES PRIVATE LIMITED",
"VENKAR ADHESIVES & COATINGS PRIVATE LIMITED",
"VENKAR CHEMICALS PRIVATE LIMITED",
"VENKAT AND ASSOCIATES LLP",
"VENKAT AQUA PVT LTD",
"VENKAT ARCADE PRIVATE LIMITED",
"VENKAT ENERGY AND POWER PRIVATE LIMITED",
"VENKAT SAI ENTERPRISES PRIVATE LIMITED",
"VENKAT SHOES PRIVATE LIMITED",
"VENKATA BALAJI AUTOMOBILES PRIVATE LIMITED",
"VENKATA BALAJI STEEL ROLLING MILLS PRIVATE LIMITED",
"VENKATA DHARMA POULTRIES PRIVATE LIMITED",
"VENKATA JAYANTH POULTRIES PRIVATE LIMITED",
"VENKATA KRISHNA CONSTRUCTIONS PRIVATE LIMITED",
"VENKATA KRISHNA ENTERPRISES PRIVATE LIMITED",
"VENKATA KRISHNA SPINNERS PRIVATE LIMITED",
"VENKATA MINERALS AND CHEMICALS PRIVATE LIMITED",
"VENKATA NAGALAKSHMI PAPER MILLS PRIVATE LIMITED",
"VENKATA NARAYANA ACTIVE INGREDIENTS PRIVATE LIMITED",
"VENKATA PADMAVATHI PAPER MILLS PRIVATE LIMITED",
"VENKATA PANDURANGA CONSTRUCTIONS PRIVATE LIMITED",
"VENKATA PRANEETH DEVELOPERS PRIVATE LIMITED",
"VENKATA RAJESH POULTRIES PRIVATE LIMITED",
"VENKATA RAMANA AUTOMOBILES PVT LTD",
"VENKATA RAMANA MOTORS PRIVATE LIMITED",
"VENKATA SAI AUTOMOBILES PRIVATE LIMITED",
"VENKATA SAI MEDIA PRIVATE LIMITED",
"VENKATA SAI MOTORS PRIVATE LIMITED",
"VENKATA SAI POTTERIES PRIVATE LIMITED",
"VENKATA SAI TOBACCO PRIVATE LIMITED",
"VENKATA VIJAYA POULTRIES PRIVATE LIMITED",
"VENKATACHALAM TEXTILES (INDIA) PRIVATE LIMITED",
"VENKATACHALAPATHI PAPER MILLS PRIVATE LIMITED",
"VENKATADRI COLD STORAGE PRIVATE LIMITED",
"VENKATADRI OILS PVT LTD",
"VENKATADRI POULTRIES PRIVATE LIMITED",
"VENKATADRI PU COLLEGE",
"VENKATADRI SPICES PRIVATE LIMITED",
"VENKATADRI WOODS",
"VENKATAESWARA HOSPITALS",
"VENKATAGIRI SPINNING MILLS PRIVATE LIMITED",
"VENKATALAKSHMI ALLOY CASTINGS PRIVATE LIMITED",
"VENKATANARAYANA TEX YARN PRIVATE LIMITED",
"VENKATAPATHI AROMATICS PRIVATE LIMITED",
"VENKATAPPA ANANDA SERVICES PRIVATE LIMITED",
"VENKATAPURA LOGISTICS AND INDUSTRIAL PARKS PRIVATE LIMITED",
"VENKATARAMANA DIGITAL IMAGING PRIVATE LIMITED",
"VENKATARAMANA GRAPHICS PRIVATE LIMITED",
"VENKATARAMANA HEART AND MATERNITY HOSPITAL",
"VENKATARAMANA PARABOILED PRIVATE LIMITED",
"VENKATASAI AERATED BRICKS PRIVATE LIMITED",
"VENKATASAI AGENCIES HYD PRIVATE LIMITED",
"VENKATASAI CERAMICS PRIVATE LIMITED",
"VENKATASAI INFRA PROJECTS PRIVATE LIMITED",
"VENKATASAI SOLVENT INDIA PRIVATE LIMITED",
"VENKATASHWAR HOSPITAL",
"VENKATASIVA POULTRIES PRIVATE LIMITED",
"VENKATDHEERU INFRACON PRIVATE LIMITED",
"VENKATESH AUTOWHEELS INDIA PRIVATE LIMITED",
"VENKATESH COMMERCE PVT LTD",
"VENKATESH COMMERCIAL FINANCE PRIVATE LIMITED",
"VENKATESH COTTON COMPANY",
"VENKATESH EYE HOSPITAL",
"VENKATESH FABRICS PRIVATE LIMITED",
"VENKATESH FOUNDATION PRIVATE LIMITED",
"VENKATESH INFRA PROJECTS PRIVATE LIMITED",
"VENKATESH IT SOLUTIONS PRIVATE LIMITED",
"VENKATESH MEDICO PRIVATE LIMITED",
"VENKATESH MINING PVT LTD",
"VENKATESH NATURAL EXTRACT PRIVATE LIMITED",
"VENKATESH PACKMART PRIVATE LIMITED",
"VENKATESH RICE AGRO INDUSTRIES PRIVATE LIMITED",
"VENKATESH SHARES AND STOCK BROKERS PRIVATE LIMITED",
"VENKATESH STEEL INFRA PRIVATE LIMITED",
"VENKATESH TECNOKRAFTS PRIVATE LIMITED",
"VENKATESH TRADELINK PRIVATE LIMITED",
"VENKATESH TUBES AND PIPES PRIVATE LIMITED",
"VENKATESHA CRUSHING & MINING COMPANY PRIVATE LIMITED",
"VENKATESHKRUPA SUGAR MILLS LIMITED",
"VENKATESHWAR HOSPITAL",
"VENKATESHWAR ISPAT PRIVATE LIMITED",
"VENKATESHWAR PROTEIN PRIVATE LIMITED",
"VENKATESHWAR STRIPS PRIVATE LIMITED",
"VENKATESHWAR UDYOG & FINANCE PRIVATE LIMITED",
"VENKATESHWARA AUTOMATION AND CONTROLS PRIVATE LIMITED",
"VENKATESHWARA B V BIOCORP PRIVATE LIMITED",
"VENKATESHWARA BAKERY",
"VENKATESHWARA BIOFEED PRIVATE LIMITED",
"VENKATESHWARA EDUCATIONAL COLLEGE",
"VENKATESHWARA ENTERPRISES",
"VENKATESHWARA EYE CARE PRIVATE LIMITED",
"VENKATESHWARA FERRO ALLOYS PVT LTD",
"VENKATESHWARA FIBRE GLASS CHENNAI PRIVATE LIMITED",
"VENKATESHWARA HARDWARE PRIVATE LIMITED",
"VENKATESHWARA HATCHERIES PRIVATE LIMITED",
"VENKATESHWARA HATCHERIES PVT LTD",
"VENKATESHWARA INDUSTRIAL PROMOTION CO. LTD",
"VENKATESHWARA INDUSTRIAL SERVICES PRIVATE LIMITED",
"VENKATESHWARA INSTITUTE OF MEDICAL SCIENCES",
"VENKATESHWARA OPEN UNIVERSITY",
"VENKATESHWARA ORTHO HEALTHCARE PRIVATE LIMITED",
"VENKATESHWARA PAPERS PRIVATE LIMITED",
"VENKATESHWARA PESTICIDES AND ALLIED CHEMICALS PVT LTD",
"VENKATESHWARA POWER PROJECT LIMITED",
"VENKATESHWARA RAIL NIRMAN PRIVATE LIMITED",
"VENKATESHWARA RESEARCH AND BREEDING FARM PRIVATE LIMITED",
"VENKATESHWARA ROTO PACK PRIVATE LIMITED",
"VENKATESHWARA SPECIALITY FERTILIZERS (INDIA)PRIVATE LIMITED",
"VENKATESHWARA SPONGE & IRON CO PRIVATE LIMITED",
"VENKATESHWARA TOURIST SERVICE PRIVATE LIMITED",
"VENKATESWAR CONCRETE PRIVATE LIMITED",
"VENKATESWARA AGGREGATES MINING PRIVATE LIMITED",
"VENKATESWARA AGRO-VET ASSOCIATES PRIVATE LIMITED",
"VENKATESWARA AYURVEDA NILAYAM LIMITED",
"VENKATESWARA BATTERY",
"VENKATESWARA CHEMICALS PRIVATE LIMITED",
"VENKATESWARA ELECTRICAL INDUSTRIES PRIVATE LIMITED",
"VENKATESWARA FINANCIERS HYDERABAD PRIVATE LIMITED",
"VENKATESWARA FOODS PVT LTD",
"VENKATESWARA LIFESTYLE PRIVATE LIMITED",
"VENKATESWARA PAPER PRODUCTS PRIVATE LIMITED",
"VENKATESWARA STEELS & SPRINGS INDIA PRIVATE LIMITED",
"VENKATESWARA SUPPLIERS PRIVATE LIMITED",
"VENKATESWARA WIRES PRIVATE LIMITED.",
"VENKATESWARAN BIKES AND MOTORS PRIVATE LIMITED",
"VENKATRAMA POULTRIES PRIVATE LIMITED",
"VENKATRAMANA FOOD SPECIALITIES LIMITED",
"VENKATSRI PLAST PRIVATE LIMITED",
"VENKETSHWARA TEX-O-FAB PRIVATE LIMITED",
"VENKI GLOBAL FOODS PRIVATE LIMITED",
"VENKRAFT PAPER MILLS PRIVATE LIMITED",
"VENKTESH INVESTMENT AND TRADING COMPANY PRIVATE LIMITED",
"VENKTESHWAR FASHIONS PRIVATE LIMITED",
"VENKTESHWAR FILAMENTS PRIVATE LIMITED",
"VENKTESHWAR SYNTHETICS PRIVATE LIMITED",
"VENKTRON DIGITAL SYSTEMS PRIVATE LIMITED",
"VENKY S (INDIA) LIMITED",
"VENKYS INDIA LIMITED",
"VENLITE (INDIA) PRIVATE LIMITED",
"VENLON ENTERPRISES LIMITED",
"VENLUB PETRO PRODUCTS PRIVATE LIMITED",
"VENNA MILK AND MILK PRODUCTS PRIVATE LIMITED",
"VENNAR CERAMICS LIMITED",
"VENNAR DIGITAL FARM PRIVATE LIMITED",
"VENNELA MOTORS PRIVATE LIMITED",
"VENNILA CLOTHING COMPANY",
"VENOLIN TECHNOLOGY PRIVATE LIMITED",
"VENOR PHARMA LIMITED",
"VENOVA PHARMACEUTICALS PRIVATE LIMITED",
"VENP DAIRY SOLUTIONS PRIVATE LIMITED",
"VENPA STAFFING SERVICES INDIA PRIVATE LIMITED",
"VENPEP SOLUTIONS PRIVATE LIMITED",
"VENPER ACADEMY",
"VENPER TECHNOLOGY SERVICES PRIVATE LIMITED",
"VEN-PETRO-CHEM AND PHARMAINDIA PRIVATE LIMITED",
"VENSA INFRASTRUCTURE LIMITED",
"VENSAI GLOBAL PRIVATE LIMITED",
"VENSAR CONSTRUCTION CO. LIMITED.",
"VENSEN LIGHTING PRIVATE LIMITED",
"VENSENAL ENTERPRISES PRIVATE LIMITED",
"VENSI INDIA PRIVATE LIMITED",
"VENSIL GLASS WORKS LIMITED",
"VENSIMAL WORLD TRAVEL AGENTS PRIVATE LIMITED",
"VENSOL (BIDAR) ENERGY PRIVATE LIMITED",
"VENSOL (NIRNA) ENERGY PRIVATE LIMITED",
"VENSOL AUTOMATION",
"VENSON ELECTRIC PRIVATE LIMITED",
"VENSON ENERGY PRIVATE LIMITED",
"VENSON TRANSPORTS PRIVATE LIMITED",
"VENSOR ELECTRICALS PRIVATE LIMITED",
"VENSUN LABORATORIES PRIVATE LIMITED",
"VENSYSCO INFRA PRIVATE LIMITED",
"VENSYX DATA SOLUTIONS PRIVATE LIMITED",
"VENT FILTER TECH PRIVATE LIMITED",
"VENTA TECHNOLOGIES PRIVATE LIMITED",
"VENTANA STUDIOS PRIVATE LIMITED",
"VENTATESH INDIGENOUS PIPES PRIVATE LIMITED",
"VENTECH SYSTEMS PRIVATE LIMITED",
"VENTES AVENUES PRIVATE LIMITED",
"VENTESB2B TECHNOLOGIES PRIVATE LIMITED",
"VENTEX TRADE PVT LTD",
"VENTI AIR SERVICES PRIVATE LIMITED",
"VENTI OELDE INDIA PRIVATE LIMITED",
"VENTIL COMPONENTS PRIVATE LIMITED",
"VENTIL FLOWSERVE PRIVATE LIMITED",
"VENTILAIR ENGINEERS PRIVATE LIMITED",
"VENTILAIR INDIA PRIVATE LIMITED",
"VENTILATION ENGINEERING COMPANY PVT LTD",
"VENTILE COMPANY PRIVATE LIMITED",
"VENTIS PHARMACEUTICALS PRIVATE LIMITED",
"VENTLA INDIA PRIVATE LIMITED",
"VENTO ENERGY INFRA PRIVATE LIMITED",
"VENTO FOAM PRIVATE LIMITED",
"VENTO POWER & ENERGY LIMITED",
"VENTO POWER INFRA PRIVATE LIMITED",
"VENTO POWER PROJECTS PRIVATE LIMITED",
"VENTOIS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"VENTOURS INTERNATIONAL TRAVEL PRIVATE LIMITED",
"VENTRA HEALTH PRIVATE LIMITED",
"VENTREX ENERGY PRIVATE LIMITED",
"VENTRIKS TECHNOLOGY INDIA PRIVATE LIMITED",
"VENTRON TRADELINK PVT LTD",
"VENTRUM TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"VENTTURA BIOCEUTICALS PRIVATE LIMITED",
"VENTUGROW CONSULTANTS PRIVATE LIMITED",
"VENTUM SERVICES PRIVATE LIMITED",
"VENTUNO TECHNOLOGIES PRIVATE LIMITED",
"VENTURA AGRICHEM PRIVATE LIMITED",
"VENTURA AIRCONNECT LIMITED",
"VENTURA ALLIED SERVICES PRIVATE LIMITED",
"VENTURA ALLOY AND STEELS PRIVATE LIMITED",
"VENTURA COMMODITIES LIMITED",
"VENTURA DEVELOPERS INDIA LIMITED",
"VENTURA DIGITAL TECHNOLOGIES INDIA LLP",
"VENTURA ELECTRICALS HINDUSTAN LIMITED",
"VENTURA GUARANTY LIMITED",
"VENTURA HOSPITALITY AND TOURISM PRIVATE LIMITED",
"VENTURA INCORPORATED INDIA PRIVATE LIMITED",
"VENTURA INDIA PRIVATE LIMITED",
"VENTURA INDUSTRIES PRIVATE LIMITED",
"VENTURA INTERIORS PRIVATE LIMITED",
"VENTURA INTERNATIONAL PRIVATE LIMITED",
"VENTURA LEARNING TECHNOLOGIES LLP",
"VENTURA LIFESTYLES PRIVATE LIMITED",
"VENTURA OMNITECH PRIVATE LIMITED",
"VENTURA PACKAGERS PVT LTD",
"VENTURA SALASAR ENERGY INDUSTRIES LIMITED",
"VENTURA SALES & SERVICES PRIVATE LIMITED",
"VENTURA SECURITIES LIMITED",
"VENTURA TECHNOLOGIES NETWORK PRIVATE LIMITED",
"VENTURA TEXTILES LIMITED",
"VENTURA TRANSMETALS PRIVATE LIMITED",
"VENTURE AUTOMOTIVE TOOLING I PRIVATE LIMITED",
"VENTURE CAPITAL AND CORPORATE INVESTMENTS PRIVATE LTD.",
"VENTURE CATALYSTS PRIVATE LIMITED",
"VENTURE CATATYSTS PRIVETE LIMITE",
"VENTURE ELECTRIC MACHINES PRIVATE LIMITED",
"VENTURE IMPEX PRIVATE LIMITED",
"VENTURE INDIA FABMART PRIVATE LIMITED",
"VENTURE INDUSTRIES",
"VENTURE INSTRUMENTATION TECHNOLOGIES PRIVATE LIMITED",
"VENTURE LIGHTING INDIA LIMITED",
"VENTURE OFFSHORE INFOMATRIX PRIVATE LIMITED",
"VENTURE PHARMACEUTICALS PRIVATE LIMITED",
"VENTURE PROFESSIONAL HOSPITALITY PRIVATE LIMITED",
"VENTURE SEA TRANSPORT COMPANY PRIVATE LIMITED.",
"VENTURE SOFTTECH INDIA PRIVATE LIMITED",
"VENTURE STEELS PRIVATE LIMITED",
"VENTURE SUPPLY CHAIN PRIVATE LIMITED",
"VENTURE TECH SOLUTION PRIVATE LIMITED",
"VENTURE VEHICLE REFORMATION PRIVATE LIMITED",
"VENTURE7 TECHNOLOGY PRIVATE LIMITED",
"VENTURELABOURC OM INDIA PRIVATE LIMITED",
"VENTURES ADVERTISING PRIVATE LIMITED",
"VENTURES HOSPITALITY INDIA PRIVATE LIMITED",
"VENTURES HRD CENTRE PRIVATE LIMITED",
"HELLO KINDRED PRIVATE LIMITED",
"VENTURIFIC INDIA PRIVATE LIMITED",
"VENTURINI FOOTWEAR INDIA PRIVATE LIMITED",
"VENTURIS FERTILIZERS PRIVATE LIMITED",
"VENTURIT CONSULTING SERVICES PRIVATE LIMITED",
"VENTUROUS BUSINESS VENTURES PRIVATE LIMITED",
"VENTUS AIRCONDITIONING PRIVATE LIMITED",
"VENTUS INFOTECH PRIVATE LIMITED",
"VENTUS PHARMACEUTICALS PRIVATE LIMITED",
"VENTUS TECHNOLOGY PRIVATE LIMITED",
"VENU BESAN INDUSTRIES PRIVATE LIMITED",
"VENU BESAN MILLS PRIVATE LIMITED",
"VENU CONSULTANTS PRIVATE LIMITED",
"VENU ENGINEERING SERVICES PRIVATE LIMITED",
"VENU FEEDS (INDIA) PRIVATE LIMITED",
"VENU HYDRAULICS PRIVATE LIMITED",
"VENU SPINNERS PRIVATE LIMITED",
"VENUGOPAL DISTRIBUTORS PRIVATE LIMITED",
"VENUGOPAL FOODS PRIVATE LIMITED",
"VENUGOPAL INN PRIVATE LIMITED",
"VENUGOPALA MOTORS PRIVATE LIMITED",
"VENUGRAM HOSPITALS BELGAUM PRIVATE LIMITED",
"VENUGRAM INFRAVENTURES PRIVATE LIMITED",
"VENUKA POLYMERS PRIVATE LIMITED",
"VENUS ALBUM COMPANY PRIVATE LIMITED",
"VENUS ALLOYS PVT LTD",
"VENUS ASSOCIATES PLACEMENTS AND OUTSOURCING",
"VENUS AUTOMATION PRIVATE LIMITED",
"VENUS AUTOWHEELS PRIVATE LIMITED",
"VENUS AUTOWORKS PRIVATE LIMITED",
"VENUS BIOCEUTICALS PRIVATE LIMITED",
"VENUS BUILDTECH INDIA PRIVATE LIMITED",
"VENUS CHEMCORP PRIVATE LIMITED",
"VENUS CLEANING PRODUCTS PRIVATE LIMITED",
"VENUS CLEARING",
"VENUS COMPRESSORS PRIVATE LIMITED",
"VENUS CONTAINER LINE LOGISTICS PRIVATE L IMITED",
"VENUS COTSYN INDIA LIMITED",
"VENUS COTTEX PRIVATE LIMITED",
"VENUS COUNTY DEVELOPERS PRIVATE LIMITED",
"VENUS DATA PRODUCTS PRIVATE LIMITED",
"VENUS DECORATIVE PAINTS LIMITED",
"VENUS DIES AND MOULDS PRIVATE LIMITED",
"VENUS ELECTRONICS AND CONTROLS PRIVATE LIMITED",
"VENUS ENAMEL WORKS PRIVATE LIMITED",
"VENUS ENGICON PRIVATE LIMITED",
"VENUS ENGINEERING WORKS AND FOUNDRY PRIVATE LIMITED",
"VENUS ESSENCE PRIVATE LIMITED",
"VENUS ETHOXYETHERS PRIVATE. LIMITED.",
"VENUS FOOTARTS LIMITED",
"VENUS FOREX PRIVATE LIMITED",
"VENUS FURNITURE PRIVATE LIMITED",
"VENUS GEMS & JEWELS PRIVATE LIMITED",
"VENUS GEO SOLUTIONS PRIVATE LIMITED",
"VENUS HOME APPLIANCES P LIMITED",
"VENUS HOSPITAL",
"VENUS HOTELWARE PRIVATE LIMITED",
"VENUS ICE AND COLD STORAGE PVT LTD",
"VENUS INDIA",
"VENUS INDIA ASSET-FINANCE PRIVATE LIMITED",
"VENUS INDIA METALS PRIVATE LIMITED",
"VENUS INDUSTRIAL CORPORATION PRIVATE LIMITED",
"VENUS INDUSTRIES PRIVATE LIMITED",
"VENUS INFRASTRUCTURE AND DEVELOPERS PRIVATE LIMITED",
"VENUS INJECTOPLAST PRIVATE LIMITED",
"VENUS INTERLININGS PRIVATE LIMITED",
"VENUS INTERNATIONAL SCHOOL",
"VENUS IT SOLUTIONS PRIVATE LIMITED",
"VENUS JEWEL",
"VENUS LOGISTICS PRIVATE LIMITED",
"VENUS MANUFACTURING CO PVT LTD",
"VENUS MARKETING COMBINE PRIVATE LIMITED",
"VENUS MEDICAL SYSTEMS PRIVATE LIMITED",
"VENUS MILLS PRIVATE LIMITED",
"VENUS NIRMAN PRIVATE LIMITED",
"VENUS NURSERY PRIMARY SCHOOL",
"VENUS ORTHOCARE PRIVATE LIMITED",
"VENUS P P VARADHARAJU SPINNING MILLS PRIVATE LIMITED",
"VENUS PETROCHEMICALS (BOMBAY) PRIVATE LIMITED",
"VENUS PIPES & TUBES LIMITED",
"VENUS PLYWOODS PRIVATE LIMITED",
"VENUS POLYTHREAD PRIVATE LIMITED",
"VENUS PORTFOLIOS PRIVATE LIMITED",
"VENUS POWER CONTROL",
"VENUS PRECISION ENGINEERING (INDIA) PRIVATE LIMITED",
"VENUS PRECISION TOOLS & COMPONENTS PRIVATE LIMITED",
"VENUS PRINTS (INDIA) PVT LTD",
"VENUS REMEDIES LIMITED",
"VENUS RENT A CAR PRIVATE LIMITED",
"VENUS ROBOTICS PRIVATE LIMITED",
"VENUS SAFETY & HEALTH PRIVATE LIMITED",
"VENUS SALES CORPORATION PRIVATE LIMITED",
"VENUS SEA-AIR SERVICES PRIVATE LIMITED",
"VENUS SHEET METALS COMPONENTS PRIVATE LIMITED",
"VENUS STAMPINGS PRIVATE LIMITED",
"VENUS STAR CONSTRUCTION PRIVATE LIMITED",
"VENUS SUGAR LIMITED",
"VENUS SURGICALS PRIVATE LIMITED",
"VENUS SYNTHETICS PRIVATE LIMITED",
"VENUS TECH SOLUTIONS LIMITED LIABILITY P ARTNERSHIP",
"VENUS TECHNO EQUIPMENT PRIVATE LIMITED",
"VENUS TEXTRADE PRIVATE LIMITED",
"VENUS TRENDS AND COLLECTIONS PRIVATE LIMITED",
"VENUS WIRE INDUSTRIES PRIVATE LIMITED",
"VENUS WORLDWIDE ENTERTAINMENT PRIVATE LIMITED",
"VENUSS HERBO AROMATICS PRIVATE LIMITED",
"VENUST AGRO MILLS PRIVATE LIMITED",
"VENUTAI CHAVAN COLLEGE KARAD",
"VENVET CHEMICALS PRIVATE LIMITED",
"VENWIZ TECHNOLOGIES PRIVATE LIMITED",
"VENYA NATURALS PRIVATE LIMITED",
"VENZO CONSULTANCY SERVICES LLP",
"VENZO WOOD PRIVATE LIMITED",
"VEOL MEDICAL TECHNOLOGIES PRIVATE LIMITED",
"VEOLIA INDIA PRIVATE LIMITED",
"MAGNA ELECTRONICS INDIA PRIVATE LIMITED",
"VEOOZ LABS PRIVATE LIMITED",
"VEP BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"VE-PAR PRIVATE LIMITED",
"VEPARSEVA HEALTHCARE PRIVATE. LIMITED.",
"VEPL MSPL SMART WATER PRIVATE LIMITED",
"VEPOLY PACKS INDIA PRIVATE LIMITED",
"VEPRO WEIGHING PRIVATE LIMITED",
"VEPS INDUSTRIES PRIVATE LIMITED",
"VEPSUN INTERIORS PRIVATE LIMITED",
"VEPURI AGRO PRODUCTS PRIVATE LIMITED",
"VEPURI FROZEN FOODS PRIVATE LIMITED",
"VEQTO WORLDWIDE PRIVATE LIMITED",
"VERA AUTOMOTIVE COMPONENTS PRIVATE LIMITED",
"VERA DEVELOPERS PRIVATE LIMITED",
"VERA DISPLAY AND STORAGE PRODUCTS PRIVATE LIMITED",
"VERA EDU-INFRA PRIVATE LIMITED",
"VERA MANUFACTURING PRIVATE LIMITED",
"VERA RESOURCES PRIVATE LIMITED",
"VERA SOLUTIONS PRIVATE LIMITED",
"VERA SYNTHETIC LIMITED",
"VERACIOUS ELECTRO FAB PRIVATE LIMITED",
"VERACITIZ SOLUTIONS PRIVATE LIMITED",
"VERACITY ENERGY AND INFRASTRUCTURE PRIVATE LIMITED",
"VERACITY SOFTWARE PRIVATE LIMITED",
"VERACITY SYSTEMS SURVEILLANCE PRIVATE LIMITED",
"VERACY CONSULTING PRIVATE LIMITED",
"VERAL MANPOWER SERVICES",
"VERANA NETWORKS (INDIA) PRIVATE LIMITED",
"VERANDA LEARNING SOLUTIONS LIMITED",
"VERANDA RACE LEARNING SOLUTIONS PRIVATE LIMITED",
"VERANDA ROOF TOP RESTRO CAFE PRIVATE LIMITED",
"VERANO ALGA PRIVATE LIMITED",
"VERASYS TECHNOLOGIES PRIVATE LIMITED",
"VERAX LIFESCIENCES PRIVATE LIMITED",
"VERB DANCE STUDIO PRIVATE LIMITED",
"VERBA FOODS AND BEVERAGES PRIVATE LIMITED",
"VERBINDEN COMMUNICATION PRIVATE LIMITED",
"VERCHASKA INFOTECH PRIVATE LIMITED",
"VERDANT CLOCK WEB PRIVATE LIMITED",
"VERDANT LIFE SCIENCES PRIVATE LIMITED",
"VERDANT RENEWABLES PRIVATE LIMITED",
"VERDANT SCIENTECH",
"VERDANT TELEMETRY AND ANTENNA SYSTEMS PRIVATE LIMITED",
"VERDE POLYSFY PRIVATE LIMITED",
"VERDEEN CHEMICALS PRIVATE LIMITED",
"VERDENT EXTRUSIONS PRIVATE LIMITED",
"VERDER INDIA PUMPS PRIVATE LIMITED",
"VERDER SCIENTIFIC PRIVATE LIMITED",
"VERDEROOTS SERVICES PRIVATE LIMITED",
"VERDIA HOTELS PRIVATE LIMITED",
"VERDICAL SOLUTIONS INDIA PRIVATE LIMITED",
"VERDICT ELECTRONICS PRIVATE LIMITED",
"VEREIGEN MEDIA PRIVATE LIMITED",
"VEREMAX MANAGEMENT SERVICES PRIVATE LIMITED",
"VEREMAX TECHNOLOGIE SERVICES LIMITED",
"VEREX SYSTEMS PRIVATE LIMITED",
"VERGA ATTACHMENTS PRIVATE. LIMITED.",
"VERGE IMPEX LLP",
"VERGER GLOBAL PRIVATE LIMITED",
"VERGO PHARMA RESEARCH LABORATORIES PRIVATE LIMITED",
"VERGO PHARMA RESEARCH PRIVATE LIMITED",
"VERGYL ENTERPRISES PRIVATE LIMITED",
"VERI SCRIBE PRIVATE LIMITED",
"VERIDIC TECHNOLOGIES PRIVATE LIMITED",
"VERIFACTS SERVICES PRIVATE LIMITED",
"VERIFAST TECHNOLOGIES INDIA PRIVATE LIMITED",
"VERIFAVIA IHM TECHNICAL SERVICES PRIVATE LIMITED",
"VERIFAYA TECHNOLOGY INDIA PRIVATE LIMITED",
"VERIFICIENT SOLUTIONS PRIVATE LIMITED",
"VERIFICORP CREATIVE SERVICES INDIA PRIVATE LIMITED",
"VERIFIED LEADS & MARKETING SERVICES GLOBAL LLP",
"VERIFIQ TECHNOLOGIES PRIVATE LIMITED",
"VERIFONE INDIA SALES PRIVATE LIMITED",
"VERIFONE INDIA TECHNOLOGY PRIVATE LIMITED",
"VERIFWORKS PRIVATE LIMITED",
"VERIGOLD JEWELLERY INDIA PRIVATE LIMITED",
"VERIMATRIX VIDEO SECURITY SOLUTIONS INDIA PRIVATE LIMITED",
"VERINITE TECHNOLOGIES PRIVATE LIMITED",
"VERINON TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"VERINT CES INDIA PRIVATE LIMITED",
"VERINT SYSTEMS INDIA PRIVATE LIMITED",
"VERIPARK SOFTWARE PRIVATE LIMITED",
"VERISIGN SERVICES INDIA PRIVATE LIMITED",
"VERISK ANALYTICS INDIA PRIVATE LIMITED",
"VERISMO NETWORKS PRIVATE LIMITED",
"VERITA MANAGEMENT ADVISORS PRIVATE LIMITED",
"VERITAAS ADVERTISING PRIVATE LIMITED",
"VERITAAS GRANITO LLP",
"VERITABLE AGROTECH PRIVATE LIMITED",
"VERITABLE MULTISERV INDIA PRIVATE LIMITED",
"VERITAS (INDIA) LIMITED",
"VERITAS BIOVENTIONS PRIVATE LIMITED",
"VERITAS BUILDTECH PRIVATE LIMITED",
"VERITAS ENGINEERS SERVICES PRIVATE LIMITED",
"VERITAS FINANCE PRIVATE LIMITED",
"VERITAS GLOBAL PRIVATE LIMITED",
"VERITAS INDUSTRIES PRIVATE LIMITED",
"VERITAS INFRATECH PRIVATE LIMITED",
"VERITAS INSURANCE SERVICES PRIVATE. LIMITED",
"VERITAS LIFE SCIENCES LIMITED",
"VERITAS LOGISTICS PRIVATE LIMITED",
"VERITAS REPUTATION PR PRIVATE LIMITED",
"VERITAS RESEARCH INCORPORATION",
"VERITAS SAINIK SCHOOL",
"VERITAS SOFT SOLUTIONS PRIVATE LIMITED",
"VERITAS SOFTWARE TECHNOLOGIES INDIA PRIVATE LIMITED",
"VERITASTECH",
"VERITAZ HEALTHCARE LIMITED",
"VERITAZ TRADING & EXIM PRIVATE LIMITED",
"VERITECH INFOSYSTEMS PRIVATE LIMITED",
"VERITECH INFRASTRUCTURE PRIVATE LIMITED",
"VERITEK ENGINEERING PRIVATE LIMITED",
"VERITIS SOLUTIONS INDIA PRIVATE LIMITED",
"VERITO ENGINEERING PRIVATE LIMITED",
"VERITO TECHNOLOGIES PRIVATE LIMITED",
"VERITOS INFOSOLUTIONS PRIVATE LIMITED",
"VERITRA IT SOLUTIONS PRIVATE LIMITED",
"VERITRIER PRIVATE LIMITED",
"VERITUS OAKMONT PRIVATE LIMITED",
"VERITY FINSERVE PRIVATE LIMITED",
"VERITY GLOBAL SOLUTIONS PRIVATE LIMITED",
"VERITY INFORMATION SOLUTIONS PRIVATE LIMITED",
"VERITY KNOWLEDGE SOLUTIONS PRIVATE LIMITED",
"VERITY SPINTEX PRIVATE LIMITED",
"VERIVO ENTERPRISES PRIVATE LIMITED",
"VERIZON COMMUNICATIONS",
"VERIZON DATA SERVICES INDIA PRIVATE LIMITED",
"VERIZON INFRASTRUCTURE PRIVATE LIMITED",
"VERKA FARIDKOT DAIRY",
"VERLIN CONSUMER PRIVATE LIMITED",
"VERMA ALUMINIUM PRIVATE LIMITED",
"VERMA AUTOMOBILE",
"VERMA ENGINEERS AND CONTRACTORS PRIVATE LIMITED",
"VERMA ENTERPRISES",
"VERMA GASES (INDIA) PVT LTD",
"VERMA GLOBAL INFRATECH PRIVATE LIMITED",
"VERMA LOGISTICS PRIVATE LIMITED",
"VERMA PACKERS PRIVATE LIMITED",
"VERMA PRESS PRIVATE LIMITED",
"VERMA TRACTORS",
"VERMAJEE IT SOLUTIONS PRIVATE LIMITED",
"VERMAN MANUFACTURING & INTEGRATION PRIVATE LIMITED",
"VERMEER EQUIPMENT INDIA PRIVATE LIMITED",
"VERMEIREN INDIA REHAB PRIVATE LIMITED",
"VERMILION COSMETICS PRIVATE LIMITED",
"VERMILLION COMMUNICATION PRIVATE LTTD",
"VERMILLION FINALYTICS PRIVATE LIMITED",
"VERMMILLION COMMUNICATION PRIVATE LIMITED",
"VERMONT TECHNOLOGIES PRIVATE LIMITED",
"VERNAL INDUSTRIES PRIVATE LIMITED",
"VERNAL TEXTILES PRIVATE LIMITED",
"VERNALIS INDIA PRIVATE LIMITED",
"VERNALIS SYSTEMS PRIVATE LIMITED",
"VERNANT INVESTMENT SERVICES PRIVATE LIMITED",
"VERNASOFT CONSULTANCY INDIA PRIVATE LIMITED",
"VERNEL MARITIME SERVICES PRIVATE LIMITED",
"VERNELL PHARMA PRIVATE LIMITED",
"VERNI GASTECH PRIVATE LIMITED",
"VERNOST MARKETING SERVICES PRIVATE LIMITED",
"VERNOST MARKETING TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"VERNOXY PHARMA PRIVATE LIMITED",
"VERO INDIA SOFTWARE PRIVATE LIMITED",
"VERO MODA RETAIL PRIVATE LIMITED",
"VERODATATEX INDIA PRIVATE LIMITED",
"VEROLT ENGINEERING PRIVATE LIMITED",
"VERONA GRANITO PRIVATE LIMITED",
"VERONA PRODUCTS PRIVATE LIMITED",
"VERONICA CONSTRUCTIONS PVT LTD",
"VERONICA DIGITAL",
"VERONICA MARINE EXPORTS PRIVATE LIMITED",
"VERONICA POWER TRANSMISSION PRIVATE LIMITED",
"VERONIK MICRONUTRIENTS PRIVATE LIMITED",
"VEROS HEALTHCARE PRIVATE LIMITED",
"VERPACO INDIA PVT LTD",
"VERRITAS FURNITURE PRIVATE LIMITED",
"VERSA DRIVES PRIVATE LIMITED",
"VERSA NETWORKS INDIA PRIVATE. LIMITED",
"VERSA TRADING PRIVATE LIMITED",
"VERSABYTE DATA SYSTEMS PRIVATE LIMITED",
"VERSALIS PACIFIC (INDIA) PRIVATE LIMITED",
"VERSALITE HI TECH LIGHTING PRIVATE LIMITED",
"VERSANT SYSTEMS PRIVATE LIMITED",
"VERSANT TECHNOLOGIES PRIVATE LIMITED",
"VERSASIA INFOSOFT PRIVATE LIMITED",
"VERSATILE",
"VERSATILE ALUCAST PRIVATE LIMITED",
"VERSATILE AUTO COMPONENTS PRIVATE LIMITED",
"VERSATILE BONDS PRIVATE LIMITED",
"VERSATILE CARD TECHNOLOGY PRIVATE. LIMITED.",
"VERSATILE CONSTRUCTIONS PRIVATE LIMITED",
"VERSATILE ENGINEERS",
"VERSATILE ENTERPRISES PRIVATE LIMITED",
"VERSATILE EQUIPMENTS PVT LTD",
"VERSATILE FOOD COURTS PRIVATE LIMITED",
"VERSATILE FOODS AND MARKETING PRIVATE LIMITED",
"VERSATILE INDUSTRIES I PRIVATE LIMITED",
"VERSATILE INFOSECURITY PRIVATE LIMITED",
"VERSATILE MOBITECH PRIVATE LIMITED",
"VERSATILE NETWORK PRIVATE.LIMITED.",
"VERSATILE OPERATIONS",
"VERSATILE POLYTECH PRIVATE LIMITED",
"VERSATILE PREMEDIA SERVICES PRIVATE LIMITED",
"VERSATILE PROCESS CONTROLS PRIVATE LIMITED",
"VERSATILE REALTORS PRIVATE LIMITED",
"VERSATILE SHIPPING & LOGISTICS PRIVATE LIMITED",
"VERSATILE TECHNOLABS PRIVATE LIMITED",
"VERSATILE VANIJYA PRIVATE LIMITED",
"VERSET TECHNOLOGIES PRIVATE LIMITED",
"VERSETAL TECH SOLUTIONS PRIVATE LIMITED",
"VERSHA TECHNOTRADE PRIVATE LIMITED",
"VERSIFY TECH SOLUTIONS PRIVATE LIMITED",
"VERSION 1 SERVICES PRIVATE LIMITED",
"VERSION NEXT TECHNOLOGIES PRIVATE LIMITED",
"VERSION SOFTWARE SOLUTIONS PRIVATE LIMITED",
"VERSION SYSTEMS PRIVATE LIMITED",
"VERSION TECHNOLOGY AND STAFFING SOLUTIONS PRIVATE LIMITED",
"VERSIONX INNOVATIONS PRIVATE LIMITED",
"VERSOVA BANDRA SEA LINK LIMITED",
"VERSOVA ESTATES PRIVATE LIMITED",
"VERSOVA WELFARE ASSOCIATION HIGH SCHOOL",
"VERSUCHE TECHNOLOGIES PRIVATE LIMITED",
"VERSUTUS MANAGEMENT SERVICES PRIVATE LIMITED",
"VERT EQUIPMENT PRIVATE LIMITED",
"VERT LINE MARINE BUNKERS PRIVATE LIMITED",
"VERTAFORE INDIA PRIVATE LIMITED",
"VERTAK INFRASTRUCTURE PRIVATE LIMITED",
"VERTEBRAND MAAGEMENT CONSULTING PRIVATE LIMITED",
"VERTECH HEALTH SOLUTIONS INDIA PRIVATE LIMITED",
"VERTEEX VENDING AND ENTERPRISES SOLUTIONS PRIVATE LIMITED",
"VERTEL DIGITAL PRIVATE LIMITED",
"VERTEL INFOTEL PRIVATE LIMITED",
"VERTEX AIR TECHNOLOGIES PRIVATE LIMITED",
"VERTEX AUTOMATION SYSTEM PRIVATE LIMITED",
"VERTEX AVIATION PRIVATE LIMITED",
"VERTEX CHEM PRIVATE LIMITED",
"VERTEX CHEMICAL INDUSTRIES PRIVATE LIMITED",
"VERTEX COMSYS PRIVATE LIMITED",
"VERTEX CONCEPTION PRIVATE LIMITED",
"VERTEX CONSULTANTS PRIVATE LIMITED",
"VERTEX CONSULTING ENGINEERS (INDIA) PRIVATE LIMITED",
"VERTEX CORROTECH SOLUTIONS PRIVATE LIMITED",
"VERTEX CRANES & HOISTS INDIA PRIVATE LIMITED",
"VERTEX ELETECH PRIVATE LIMITED",
"VERTEX ENGI-MECH PRIVATE LIMITED",
"VERTEX ENGINEERING SYSTEMS PRIVATE LIMITED",
"VERTEX ENGINEERS PRIVATE LIMITED",
"VERTEX FILMS PRIVATE LIMITED",
"VERTEX GLOBAL PRIVATE LIMITED",
"VERTEX GRAPHICS PROCESS PRIVATE LIMITED",
"VERTEX HOMES PRIVATE LIMITED",
"VERTEX INDUSTRIAL ENGINEERING LLP",
"VERTEX INDUSTRIES PRIVATE LIMITED",
"VERTEX INFOSOFT SOLUTIONS PRIVATE LIMITED",
"VERTEX INNOVATIONS PRIVATE LIMITED",
"VERTEX INTERIORS PRIVATE LIMITED",
"VERTEX INTERNATIONAL PRIVATE LIMITED",
"VERTEX LIFESCIENCES PRIVATE LIMITED",
"VERTEX LOGICON PRIVATE LIMITED",
"VERTEX NEWTON PROJECTS PRIVATE LIMITED",
"VERTEX NIRMAN LLP",
"VERTEX OFFSHORE SERVICES PRIVATE LIMITED",
"VERTEX PNEUMATICS PRIVATE LIMITED",
"VERTEX POWER SOLUTIONS PRIVATE LIMITED",
"VERTEX PRECISION AND ENGINEERING PRIVATE LIMITED",
"VERTEX PREMIER PRODUCTS PRIVATE LIMITED",
"VERTEX REALTY ADVISORS PRIVATE LIMITED",
"VERTEX SECURITIES LIMITED",
"VERTEX SOLAR SOLUTIONS PRIVATE LIMITED",
"VERTEX SULZ PRIVATE LIMITED",
"VERTEX SUPPLIERS PRIVATE LIMITED",
"VERTEX TAX SOLUTIONS INDIA PRIVATE LIMITED",
"VERTEX TECHNO SOLUTIONS BANGALORE PRIVATE LIMITED",
"VERTEX VEGA DEVELOPERS LLP",
"VERTEX VENTURES SEA MANAGEMENT INDIA PRIVATE LIMITED",
"VERTEX VOLT",
"VERTEXBLUE INDIA PRIVATE LIMITED",
"VERTEXCREST LOGISTICS PRIVATE LIMITED",
"VERTEXONE PROCESS SOLUTIONS PRIVATE LIMITED",
"VERTEXPLUS SOFTWARES PRIVATE LIMITED",
"VERTEXPLUS TECHNOLOGIES LIMITED",
"VERTEXPLUS TECHNOLOGIES PRIVATE LIMITED",
"VERTEXX COMMUNICATION AND TECHNOLOGY PRIVATE LIMITED",
"VERTICA CORPORATE ADVISORY PRIVATE LIMITED",
"VERTICAL AEROSPACE PRIVATE LIMITED",
"VERTICAL DISTRIBUTORS PRIVATE LIMITED",
"VERTICAL ENVOY SOLUTIONS PRIVATE LIMITED",
"VERTICAL FARMING TECHNOLOGIES PRIVATE LIMITED",
"VERTICAL FINE INDIA PRIVATE LIMITED",
"VERTICAL ROBO SERVICES PRIVATE LIMITED",
"VERTICAL STANDARD ELEVATOR SYSTEMS PRIVATE LIMITED",
"VERTICAL VYAPAAR PRIVATE LIMITED",
"VERTICAST CONCRETE PRIVATE LIMITED",
"VERTICE ENTERTAINMENT PRIVATE LIMITED",
"VERTICE GLOBAL PRIVATE LIMITED",
"VERTICLE TECHNOLOGIES PRIVATE LIMITED",
"VERTICO BPO PRIVATE LIMITED",
"VERTICO DENTMED PRIVATE LIMITED",
"VERTICON EQUIPMENTS PRIVATE LIMITED",
"VERTICURL MARKETING PRIVATE LIMITED",
"VERTIGO IMPEX PRIVATE LIMITED",
"VERTIGO INFOTECH PRIVATE LIMITED",
"VERTILEX INFOTECH PRIVATE LIMITED",
"VERTINARY HOSPITAL",
"VERTIS PRODUCTS PRIVATE LIMITED",
"VERTISYSTEM GLOBAL PRIVATE LIMITED",
"VERTIV ENERGY PRIVATE LIMITED",
"VERTIVER PRIVATE LIMITED",
"VERTIZO CONSTRUCTION PRIVATE LIMITED",
"VERTO BIZSERV",
"VERTO BIZSERV LLP",
"VERTO MOBILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"VERTO POWER PRIVATE LIMITED",
"VERTOZ ADVERTISING LIMITED",
"VERTRICAL INDIA PRIVATE LIMITED",
"VERTVISTA ECO SOLUTIONS PRIVATE LIMITED",
"VERUDIX SOLUTIONS PRIVATE LIMITED",
"VERUMEX INDIA SERVICES PRIVATE LIMITED",
"VERVALI SYSTEMS PRIVATE LIMITED",
"VERVE ADVISORY PRIVATE LIMITED",
"VERVE AUTOMOTIVES PRIVATE LIMITED",
"VERVE COMPUSOFT PRIVATE LIMITED.",
"VERVE HEALTH CARE LIMITED",
"VERVE HUMAN CARE LABORATORIES",
"VERVE INDUSTRIES PRIVATE LIMITED",
"VERVE LOGISTICS & WAREHOUSING PRIVATE LIMITED",
"VERVE MOBILE PRIVATE LIMITED",
"VERVE RECOVERY ENFORCEMENTS PRIVATE LIMITED",
"VERVE SYSTEMS PRIVATE LIMITED",
"VERVEBA TELECOM PRIVATE LIMITED",
"VERVEMAGNUM GLOBAL IMPEX PRIVATE LIMITED",
"VERVEN COATINGS PRIVATE LIMITED",
"VERVENEST TECHNOLOGIES PRIVATE LIMITED",
"VERVENTUS HEALTHTECH SOLUTIONS PRIVATE LIMITED",
"VERVESEMI MICROELECTRONICS PRIVATE LIMITED",
"VERVEVFXSTUDIO PRIVATE LIMITED",
"VERVOTECH SOLUTIONS PRIVATE LIMITED",
"VERY HUNGRY GOD PRIVATE LIMITED",
"VERYX TECHNOLOGIES PRIVATE LIMITED",
"VERZEO EDUTECH PRIVATE LIMITED",
"VES INSTITUTE OF MANAGEMENT STUDIES AND RESEARCH",
"VESAAN TECHNOLOGIES PRIVATE LIMITED",
"VESAJ ENGINEERS AND CONSTRUCTORS PRIVATE LIMITED",
"VESAJ LIMITED",
"VESAN ENGINEERING PRIVATE LIMITED",
"VESARA JEWELS PRIVATE LIMITED",
"VESAT RENEWABLES PRIVATE LIMITED",
"VESHNO POLYPLAST PRIVATE LIMITED",
"VESNA TOURS PRIVATE LIMITED",
"VESPER HOSPITALITY PRIVATE LIMITED",
"VESS IMPEX PRIVATE LIMITED",
"VESSEL WAREHOUSING PRIVATE LIMITED",
"VESSELLA CONSTRUCTIONS PRIVATE LIMITED",
"VEST PHARMA PRIVATE LIMITED",
"VESTA AVROM CLEAN & GREEN SERVICES PRIVATE LIMITED",
"VESTA BIOTECH PRIVATE LIMITED",
"VESTA ELDER CARE PRIVATE LIMITED",
"VESTA EXIM PRIVATE LIMITED",
"VESTA OVERSEAS PRIVATE LIMITED",
"VESTA PHARMACHEM PRIVATE LIMITED",
"VESTA REALTY PRIVATE LIMITED",
"VESTAL LIFESCIENCES PRIVATE LIMITED",
"VESTAL TECHNOLOGIES PRIVATE LIMITED",
"VESTAS TECHNOLOGY R&D CHENNAI PRIVATE LIMITED",
"VESTAS WIND TECHNOLOGY INDIA PRIVATE LIMITED",
"VESTERGAARD FRANDSEN (INDIA) PRIVATE LIMITED",
"VESTIAN GLOBAL WORK PLACE SERVICES PRIVATE LIMITED",
"VESTIGE BESTDEALS PRIVATE LIMITED",
"VESTIGE MARKETING PRIVATE LIMITED",
"VESTIN PARK HOTELS PRIVATE LIMITED",
"VESTNES MARINE INDIA PRIVATE LIMITED",
"VESTRICS SOLUTIONS PRIVATE LIMITED",
"VESTRO CONTAINERS PRIVATE LIMITED",
"VESTRO SOLVENTS PRIVATE LIMITED",
"VESUVIUS INDIA LTD",
"VESUVIUS INFRA PROJECTS PRIVATE LIMITED",
"VESUVIUS REFRACTORY INDIA PRIVATE LIMITED",
"VET BIOTECH PRIVATE LIMITED",
"VET MEDICURE SOLUTIONS PRIVATE LIMITED",
"VETADD NUTRIENTS PRIVATE LIMITED",
"VETAL HITECH MACHINES PRIVATE LIMITED",
"VETAL TEXTILES AND ELECTRONICS PRIVATE LIMITED",
"VETARINARY COLLEGE",
"VETBIOCHEM INDIA PRIVATE LIMITED",
"VETBIOTICS ANIMAL HEALTHCARE PRIVATE LIMITED",
"VETE ASSOCIATES MFD PRIVATE LIMITED",
"VETELITE POULTRY SERVICES PRIVATE LIMITED",
"VETERAN CO. PVT LTD",
"VETERANS LOGISTICS PRIVATE LIMITED",
"VETERINARY HOSPITAL",
"VETERINARY HOSPITAL - JAIPUR",
"VETERNARY COLLEGE SEMINARY HILLS",
"VETEX INDIA PRIVATE LIMITED",
"VETGROW PHARMA PRIVATE LIMITED",
"VETHA VARNA CHITS PRIVATE LIMITED",
"VETHATHIRI MAHARISHI SCHOOL",
"VETINA HEALTHCARE LLP",
"VETINDIA PHARMA",
"VETINDIA PHARMACEUTICALS LIMITED",
"VETMART RETAILS PRIVATE LIMITED",
"VETO CERAMIC PRIVATE LIMITED",
"VETO ELECTRICALS PRIVATE LIMITED",
"VETO ELECTROPOWERS INDIA PRIVATE. LIMITED.",
"VETO PLASTICS PRIVATE LIMITED",
"VETO SWITCHGEARS AND CABLES LIMITED",
"VETOLOGIC TECHNOLOGIES PRIVATE LIMITED",
"VETOQUINOL INDIA ANIMAL HEALTH PRIVATE LIMITED",
"VETRACARE PRIVATE LIMITED",
"VETRAVATI RESORTS PRIVATE LIMITED",
"VETRI MOTORS PRIVATE LIMITED",
"VETRI PIPE LINE SYSTEMS PRIVATE LIMITED",
"VETRICHELVAN PROPERTIES PRIVATE LIMITED",
"VETRINA HEALTHCARE PRIVATE LIMITED",
"VETRIVA ENTERPRISE SOLUTIONS PRIVATE LIMITED",
"VETRIVADIVELAN TRAVELS SERVICES PRIVATE LIMITED",
"VETRIVAL AGROCHEMICALS PRIVATE LIMITED",
"VETRIVEL EXPLOSIVES PRIVATE LIMITED",
"VETRROW PHARMA PVT LTD",
"VETSERV ANIMAL CARE PRIVATE LIMITED",
"VETSFARMA LIMITED",
"VETTAMPARA NOBEL GRANITES PRIVATE LIMITED",
"VETTIYIL PACKAGING PRIVATE LIMITED",
"VETTOOR CONSTRUCTION ENGINEERS PRIVATE LIMITED",
"VETTRIVEL CONSTRUCTIONS PRIVATE LIMITED",
"VETYP SEWING MACHINE SOLUTIONS PRIVATE LIMITED",
"VEUP TECHNOLOGIES PRIVATE LIMITED",
"VEVAN TECHNOLOGIES PRIVATE LIMITED",
"VEVEAHAM GIRLS HR SEC SCHOOL",
"VEVEK VENTURE INVESTMENTS PRIVATE LIMITED",
"VEVELON PETROCHEM PRIVATE LIMITED",
"VEVRA PACKAGING PRIVATE LIMITED",
"VEWA INFRA TECH COMPANY PRIVATE LIMITED",
"VEX INDIA SECURITAS PRIVATE LIMITED",
"V-EXCEL EDUCATIONAL TRUST",
"VEXCOLT INDIA PRIVATE LIMITED",
"VEXENT INTERDYE PRIVATE LIMITED",
"VEXIL BUSINESS PROCESS SERVICES PRIVATE LIMITED",
"VEXIL INFOTECH PRIVATE LIMITED",
"VEXL ENVIRON PROJECTS PRIVATE LIMITED",
"VEXMA TECHNOLOGIES PRIVATE LIMITED",
"VEXXA LIFESCIENCES PRIVATE LIMITED",
"VEYANCE RUBBER INDIA PRIVATE LIMITED",
"VEZBYNATURE PRODUCTS PRIVATE LIMITED",
"VEZLAY FOODS PRIVATE LIMITED",
"VF ASIA LIMITED",
"VF SOURCING INDIA PRIVATE LIMITED",
"VFC AGRO FOODS PRODUCTS PRIVATE LIMITED",
"VFC INDUSTRIES PRIVATE LIMITED",
"V-FIBERNET INDIA PRIVATE LIMITED",
"VFIN CONSULTANTS PRIVATE LIMITED",
"VFIVE HOMES PRIVATE LIMITED",
"VFLY WORLDWIDE PRIVATE LIMITED",
"VFM BUILDCON PRIVATE LIMITED",
"VFM DESIGN PRIVATE LIMITED",
"VFM HOSPITALITY PRIVATE LIMITED",
"VFM MOTORS PRIVATE LIMITED",
"VFM SYSTEMS AND SERVICES PRIVATE LIMITED",
"VFOCC INDIA PRIVATE LIMITED",
"VFORM TECHNOPACK PRIVATE LIMITED",
"VFP BOX PRIVATE LIMITED",
"VFS CAPITAL LIMITED",
"VFS DATA PROCESSING PRIVATE LIMITED",
"VFS GLOBAL SERVICES PRIVATE LIMITED",
"VG AGRICULTURE FARMS PRIVATE LIMITED",
"VG AUTOMATION AND CONTROLS",
"VG DEFENCE SYSTEMS PRIVATE LIMITED",
"VG ENGINEERS PVT LTD",
"VG INFRAVENTURES PRIVATE LIMITED",
"VG INSTITUTE OF PARAMEDICAL SCIENCES",
"VG IT SOLUTIONS PRIVATE LIMITED",
"VG LEARNING DESTINATION (INDIA) PRIVATE LIMITED",
"VG METPRO PRIVATE LIMITED",
"VG PANNEERDAS AND COMPANY PRIVATE LIMITED",
"VG PARK BEACH RESORTS PRIVATE LIMITED",
"VGB TECHNOLOGIES PRIVATE LIMITED",
"VGC BEENA PRIVATE LIMITED",
"VGC DIAMOND PRIVATE LIMITED",
"VGEN SOFTWARE SOLUTIONS PRIVATE LIMITED",
"VGENIUS COMPONENTS INDIA PRIVATE LIMITED",
"VGG INDIA PRIVATE LIMITED",
"VGI POWER SYSTEMS PRIVATE LIMITED",
"VGK BUILDERS PRIVATE LIMITED",
"VGK PROPERTY DEVELOPERS PRIVATE LIMITED",
"VGL CARGO SOLUTIONS INDIA PRIVATE LIMITED",
"VGLOBAL ITES PRIVATE LIMITED",
"VGM CONSULTANTS PRIVATE LIMITED",
"VGM GASTRO CENTRE",
"VGM GOOD MANAGEMENT INDIA PRIVATE LIMITED",
"VGM HEALTHCARE PRIVATE LIMITED",
"VGM HOSPITAL",
"VGM PLASTICS PRIVATE LIMITED",
"VGMINDS TECHSTUDIOS PRIVATE LIMITED",
"VGMS BUILDCON LLP",
"VGN BUILDERS PRIVATE LIMITED",
"VGN CHINMAYA VIDYALAYA",
"VGN HOMES PRIVATE LIMITED",
"VGN INFRA INDIA PRIVATE LIMITED",
"VGN INFRASTRUCTURE PRIVATE LIMITED",
"VGN IT CRAFTSMEN SOLUTIONS PRIVATE LIMITED",
"VGN PROJECTS ESTATES PRIVATE LIMITED",
"V-GOLD (INDIA) PRIVATE LIMITED",
"VGON SECURITY AND INTELLIGENCE SOLUTIONS PRIVATE LIMITED",
"VGOTTHIS MARKETING PRIVATE LIMITED",
"VGP MARINE KINGDOM PRIVATE LIMITED",
"VGR ENGINEERING SERVICES PRIVATE LIMITED",
"VGR FOODTECH AGRO PRIVATE LIMITED",
"VGR LOGISTICS PRIVATE LIMITED",
"VGRASSP SERVICES",
"VGS AND TECHNOLOGIES PRIVATE LIMITED",
"VGS ENTERPRISES",
"VGS INDUSTRIES PRIVATE LIMITED",
"VGS MANAGEMENT FACILITIES PRIVATE LIMITED",
"VGS REALTY CONSTRUCTION PRIVATE LIMITED",
"VGS SYNTHESIS PRIVATE LIMITED",
"V-GUARD FOUNDATION",
"VGYAN IT SERVICES PRIVATE LIMITED",
"VH CONSTRUCTION COMPANY PRIVATE LIMITED",
"VH LIFECARE PRIVATE LIMITED",
"VH MEDCARE PRIVATE LIMITED",
"VHB ENGINEERING SOLUTIONS PRIVATE LIMITED",
"VHB LIFE SCIENCES LIMITED",
"VHB MEDI SCIENCES LIMITED",
"VHB REALITIES PRIVATE LIMITED",
"VHEAL MEDICAL SERVICES PRIVATE LIMITED",
"VHG HOSPITAL PRIVATE LIMITED",
"VHIRE4U",
"VHITZ FASHIONS PRIVATE LIMITED",
"VHK HOSPITALITY SOLUTIONS PRIVATE LIMITED",
"VHL PHARMACEUTICALS PRIVATE LIMITED",
"VHM BUNKERS PRIVATE LIMITED",
"VHM INDUSTRIES LIMITED VHM",
"VHM LOGISTICS PRIVATE LIMITED",
"VHM TEX INDIA PRIVATE LIMITED",
"VHP PHARMA PRIVATE LIMITED",
"VHR SOLUTION PRIVATE LIMITED",
"VHS CONSULTING INDIA PRIVATE LIMITED",
"VHS LOGITECH PRIVATE LIMITED",
"VHS MECHATRONICS SERVICES P LTD",
"VHYOM MINES AND MINERALS PRIVATE LIMITED",
"VI ENERG RESOURCES PRIVATE LIMITED",
"VI EXPORTS INDIA PRIVATE LIMITED",
"VI FARM ORGANICS LIMITED",
"VI JA BHA JA PRATHAMIK ANUDANIT AASHRAM SHALA AJNADGAON TAL SHIRPUR DIST DHULE",
"VI JOHN HEALTHCARE INDIA LLP",
"VI MICROSYSTEMS PRIVATE LIMITED",
"VI SON WIRES PRIVATE LIMITED",
"VIA LOGISTICS PRIVATE LIMITED",
"VIA MEDIA HEALTH COMMUNICATIONS PRIVATE LIMITED",
"VIA PROJECTS PRIVATE LIMITED",
"VIA RETAIL PRIVATE LIMITED",
"VIA+ SIGNATURE INDIA PRIVATE LIMITED",
"VIAAN E-SOLUTIONS OPC PRIVATE LIMITED",
"VIAAN FINCAP PRIVATE LIMITED",
"VIAANSH INSURANCE BROKERS PRIVATE LIMITED",
"VIAANTE BUSINESS SOLUTIONS PRIVATE LIMITED",
"VIABAN HOSPITALITY PRIVATE LIMITED",
"VIABLE FOREX AND TRAVELS PRIVATE LIMITED",
"VIABLE INFRASTRUCTURE & LOGISTICS PRIVATE LIMITED",
"VIABLE MANAGEMENT CONSULTANTS PRIVATE LIMITED",
"VIABLE RECOMMERCE INDIA PRIVATE LIMITED",
"VIABLE SERVICES PRIVATE LIMITED",
"VIABLE VENTURE PRIVATE LIMITED",
"VIABLESOFT SOLUTIONS PRIVATE LIMITED",
"VIACOM 18 MEDIA PRIVATE LIMITED",
"VIACON MARKETING AND TECHNOLOGIES PRIVATE LIMITED",
"VIADESIGN INDIA LLP",
"VIAG STUDIOS PRIVATE LIMITED",
"VIAGGIO TRADERS PRIVATE LIMITED",
"VIAHI PRINT AND PACK PRIVATE LIMITED",
"VIALOGUE MEDIA PRIVATE LIMITED",
"VIAMAGUS TECHNOLOGIES PRIVATE LIMITED",
"VIA-MEDIA INFOTECH PRIVATE LIMITED",
"VIANAAR FACILITIES PRIVATE LIMITED",
"VIANAAR HERITAGE DEVELOPMENTS PRIVATE LIMITED",
"VIANAAR HOMES PRIVATE LIMITED",
"VIANAAR HOSPITALITY PRIVATE LIMITED",
"VIANAAR INFRA LLP",
"VIANAAR PROPERTIES PRIVATE LIMITED",
"VIANET MEDIA PRIVATE LIMITED",
"VIARA INDUSTRIES PRIVATE LIMITED",
"VIARI EXPORTS PRIVATE LIMITED",
"VIAROMANAA FASHIONS INDIA PRIVATE LIMITED",
"VIARRA ENTERTAINMENT PRIVATE LIMITED",
"VIAS3D PRIVATE LIMITED",
"VIASAT INDIA PRIVATE LIMITED",
"VIASOLA PRIVATE LIMITED",
"VIAT INSTRUMENTS PVT.LTD",
"VIATLA RETAIL PRIVATE LIMITED",
"VIATON ENERGY PRIVATE LIMITED",
"VIAVI SOLUTIONS INDIA PRIVATE LIMITED",
"VIAZ TYRES LIMITED",
"VIB MEDITECH PRIVATE LIMITED",
"VIBA BIOSCIENCES PRIVATE LIMITED",
"VIBA PRESS PRIVATE LIMITED",
"VIBASH COIMBATORE SURGICAL PRIVATE LIMITED",
"VIBATEL SOLUTION PRIVATE PTD",
"VIBCARE PHARMA PRIVATE LIMITED",
"VIBCOM AGENCY PRIVATE LIMITED",
"VIBCON LIGHTING AND AUTOMATION PRIVATE LIMITED",
"VIBCON MEDI IMPEX PRIVATE LIMITED",
"VIBE FASHION APPAREL PRIVATE LIMITED",
"VIBEKART RETAIL PRIVATE LIMITED",
"VIBERAL DIGITAL SOLUTIONS PRIVATE LIMITED",
"VIBES COMMUNICATIONS PRIVATE LIMITED",
"VIBES HEALTHCARE LIMITED",
"VIBES MARKETING AND SERVICES PRIVATE LIMITED",
"VIBEZ ESTATES PRIVATE LIMITED",
"VIBEZ NETWORKS AND LEISURE MANAGEMENT LLP",
"VIBFAST PIGMENTS PRIVATE LIMITED",
"VIBFEM EQUIPMENT PRIVATE LIMITED",
"VIBGYOR AUTOMOTIVE PRIVATE LIMITED",
"VIBGYOR BRAND SERVICES PRIVATE LIMITED",
"VIBGYOR BUILDPROP PRIVATE LIMITED",
"VIBGYOR DRUGS PRIVATE LIMITED",
"VIBGYOR FACILITY MANAGEMENT PRIVATE LIMITED",
"VIBGYOR FINANCIAL SERVICES PVT LTD",
"VIBGYOR GROUP OF SCHOOL",
"VIBGYOR HEALTH CARE PRIVATE LIMITED",
"VIBGYOR HIGHSANT DNYANESHWAR MAULI SANSTHA",
"VIBGYOR INFO PRIVATE LIMITED",
"VIBGYOR INFRASTRUCTURE PRIVATE LIMITED",
"VIBGYOR INTERNATIONAL PRIVATE LIMITED",
"VIBGYOR INVESTORS & DEVELOPERS PVT LTD",
"VIBGYOR KNOWLEDGE LEARNING PRIVATE LIMITED",
"VIBGYOR NET CONNECTIONS PRIVATE LIMITED",
"VIBGYOR PACKWELL SYSTEMS PRIVATE LIMITED",
"VIBGYOR PLYWOOD PRIVATE LIMITED",
"VIBGYOR POWER INDIA PRIVATE LIMITED",
"VIBGYOR PRINTING AND PACKAGING PRIVATE LIMITED",
"VIBGYOR PRINTING AND PACKAGING PVT LTD",
"VIBGYOR PROMOTERS PRIVATE LIMITED",
"VIBGYOR REALTY & INVESTMENTS PRIVATE LIMITED",
"VIBGYOR RETAIL PRIVATE LIMITED",
"VIBGYOR STRUCTURAL CONSTRUCTIONS PVT LTD",
"VIBGYOR TECHNOGRAPHY PRIVATE LIMITED",
"VIBGYOR TECHNOPLUS PRIVATE LIMITED",
"VIBGYOR VINIMAY PRIVATE LIMITED",
"VIBGYORWEB TECHNOLOGIES PRIVATE LIMITED",
"VIBHA AUTOMATION TECHNOLOGY PRIVATE LIMITED",
"VIBHA CAPITAL PRIVATE LIMITED",
"VIBHA PUBLICATION PRIVATE LIMITED",
"VIBHAAS POLYMERS PRIVATE LIMITED",
"VIBHARAJ CONSTRUCTIONS PRIVATE LIMITED",
"VIBHATEX FASHIONS PRIVATE LIMITED",
"VIBHAVA MARKETING CORPORATION",
"VIBHAVARI CREATION PRIVATE LIMITED",
"VIBHAVARI INDUSTRIES LIMITED",
"VIBHINN RASAYAN PRIVATE LIMITED",
"VIBHOOTI HOTELS PRIVATE LIMITED",
"VIBHOR COMMUNICATIONS PRIVATE LIMITED",
"VIBHOR HOME DEVELOPERS PRIVATE LIMITED",
"VIBHOR MANAGEMENT PVT LTD",
"VIBHOR STEEL TUBES LIMITED",
"VIBHOR SYNTEX PRIVATE LIMITED",
"VIBHU CAPITAL SERVICES PRIVATE LIMITED",
"VIBHU INTERNATIONAL LIMITED",
"VIBHUM IT SOLUTIONS PRIVATE LIMITED",
"VIBHUSHAN ESTATES PRIVATE LIMITED",
"VIBHUTI FOODS INDIA PRIVATE LIMITED",
"VIBHUTI INSURANCE BROKERS PRIVATE LIMITED",
"VIBHUTI INVESTMENTS COMPANY LIMITED",
"VIBHUTI MART PRIVATE LIMITED",
"VIBHUTI ORGANISERS PRIVATE. LIMITED.",
"VIBHUTI PRINTERS PRIVATE LIMITED",
"VIBHUTI PROJECTS (INDIA) PRIVATE LIMITED",
"VIBING TECHCLOUD SOLUTIONS PRIVATE LIMITED",
"VIBINYO SOLUTIONS PRIVATE LIMITED",
"VIBITEK ENGINEERING PRIVATE LIMITED",
"VIBLIN HEALTHCARE PRIVATE LIMITED",
"VIBLIN INDIA PRIVATE LIMITED",
"VIBOL PROPERTIES PRIVATE LIMITED",
"VIBRACOUSTIC INDIA PRIVATE LIMITED",
"VIBRACOUSTIC NOIDA PRIVATE LIMITED",
"VIBRANT ACADEMY INDIA PRIVATE LIMITED",
"VIBRANT ADVERTISING PRIVATE LIMITED",
"VIBRANT ASPIRATIONS PRIVATE LIMITED",
"VIBRANT AUTOMOBILES INDIA PRIVATE LIMITED",
"VIBRANT CARS PRIVATE LIMITED",
"VIBRANT CLOTHING COMPANY PRIVATE LIMITED",
"VIBRANT COATINGS PRIVATE LIMITED",
"VIBRANT COLORTECH PRIVATE LIMITED",
"VIBRANT CONSTRUCTION EQUIPMENTS PRIVATE LIMITED",
"VIBRANT CONSTRUCTIONS PRIVATE LIMITED",
"VIBRANT CONTENT PRIVATE LIMITED",
"VIBRANT CORPORATION",
"VIBRANT COTFAB PRIVATE LIMITED",
"VIBRANT DESIGNS PRIVATE LIMITED",
"VIBRANT EAGLE STAFFING SOLUTIONS PRIVATE LIMITED",
"VIBRANT EDUCARE PRIVATE LIMITED",
"VIBRANT EDUCATION SERVICES PRIVATE LIMITED",
"VIBRANT FABTEX PRIVATE LIMITED",
"VIBRANT FLOORS PRIVATE LIMITED",
"VIBRANT FOREX PRIVATE LIMITED",
"VIBRANT GLOBAL CAPITAL LIMITED.",
"VIBRANT GLOBAL SALT PRIVATE LIMITED",
"VIBRANT GLOBAL TRADING PRIVATE LIMITED",
"VIBRANT GREENTECH INDIA PRIVATE LIMITED",
"VIBRANT HOLIDAY DESTINATIONS PRIVATE LIMITED",
"VIBRANT HOSPITAL",
"VIBRANT INDUSTRIES PRIVATE LIMITED",
"VIBRANT INFOCOM PRIVATE. LIMITED.",
"VIBRANT INSURANCE BROKING PRIVATE LIMITED",
"VIBRANT LAMINATE PRIVATE LIMITED",
"VIBRANT LIFESTYLES PRIVATE LIMITED",
"VIBRANT LIVING PRIVATE LIMITED",
"VIBRANT LOGISTICS PRIVATE LIMITED",
"VIBRANT MANAGEMENT AND SERVICES PRIVATE LIMITED",
"VIBRANT METALTECH PRIVATE LIMITED",
"VIBRANT MOTOCORP PRIVATE LIMITED",
"VIBRANT MOTORS PRIVATE LIMITED",
"VIBRANT MULTI SPECIALITY HOSPITAL",
"VIBRANT NDT SERVICES PRIVATE LIMITED",
"VIBRANT NURSING COLLEGE",
"VIBRANT PHARMACHEM PRIVATE LIMITED",
"VIBRANT PROCESSORS PRIVATE LIMITED",
"VIBRANT REALTORS PRIVATE LIMITED",
"VIBRANT REALTY AND INFRASTRUCTURE LIMITED",
"VIBRANT REMEDIES (INDIA)PRIVATE LIMITED",
"VIBRANT RESTAURANTS PRIVATE LIMITED",
"VIBRANT SAFETY SOLUTIONS PRIVATE LIMITED",
"VIBRANT SALON AND SPA SERVICES PRIVATE LIMITED",
"VIBRANT SCREEN PRIVATE LIMITED",
"VIBRANT SECURITIES PRIVATE LIMITED",
"VIBRANT STEEL TRADEX PRIVATE LIMITED",
"VIBRANT TRADE AVENUES PRIVATE LIMITED",
"VIBRANT UNIGLOBEX PRIVATE LIMITED",
"VIBRANT WORLDWIDE PRIVATE LIMITED",
"VIBRANTCAR RENTALS PRIVATE LIMITED",
"VIBRER TECHNOLOGY PRIVATE LIMITED",
"VIBRO DAMPINGS PRIVATE LIMITED",
"VIBRO EQUIPMENTS PRIVATE LIMITED",
"VIBRO PHARMA PRIVATE LIMITED",
"VIBROMECH ENGINEERS & SERVICES LIMITED",
"VIBROMEK AUTOMOTIVE INDIA PRIVATE LIMITED",
"VIBRONICS PRIVATE LIMITED",
"VIBROTECH TRAINERS AND CONSULTANTS PRIVATE LIMITED",
"VIBROTEKNIK ENGINEERS PRIVATE LIMITED",
"VIBS CORPORATE SERVICES PRIVATE LIMITED",
"VIBS INFOSOL PRIVATE LIMITED",
"VICAMP AUTO POWER PRIVATE LIMITED",
"VICARA ADVISORY PRIVATE LIMITED",
"VICARA INFOTECH PRIVATE LIMITED",
"VICASSET ADVISORS INDIA PRIVATE LIMITED",
"VICCO PRODUCTS BOMBAY PVT LTD",
"VICE MEDIA (INDIA) PRIVATE LIMITED",
"VICEROY HOTELS",
"VICEROY HOTELS LIMITED",
"VICEROY TRAVELS PRIVATE LIMITED",
"VICHARA TECHNOLOGY (INDIA) PRIVATE LIMITED",
"VICHARE AND COMPANY PRIVATE LIMITED",
"VICHARE EXPRESS & LOGISTICS PRIVATE LIMITED",
"VICHI AGRO PRODUCTS PRIVATE. LIMITED.",
"VICHITA ESTATE AND WAREHOUSING PRIVATE LIMITED",
"VICHITRA CONSTRUCTIONS PRIVATE LIMITED",
"VICHUS CONSTRUCTIONS AND HOTELS PRIVATE LIMITED",
"VICISOFT TECHNOLOGIES PRIVATE LIMITED",
"VICITRA DECOR PRIVATE LIMITED",
"VICKARAM METAL PRIVATE LIMITED",
"VICKRAM COLLEGE OF ENGINEERING",
"VICKRO BIOPHARMA PRIVATE LIMITED",
"VICKSUN SPECIALITY PRODUCTS PRIVATE LIMITED",
"VICKY AGRO FOOD PRODUCTS & SUPPLIES PRIVATE LIMITED",
"VICKY ENAMEL INDUSTRIES PRIVATE LIMITED",
"VICKY FASHION LIMITED",
"VICKY JEWEL CREATION PRIVATE LIMITED",
"VICKY JEWELLERY WORKS PRIVATE LIMITED",
"VICKY OVERSEAS PRIVATE LIMITED",
"VICKY ROADWAYS PRIVATE LIMITED",
"VICKY TOURISM PRIVATE LIMITED",
"VICO FORGE PRIVATE. LIMITED.",
"VICOAST TECH SOLUTIONS PRIVATE LIMITED",
"VICON CERAMIC PRIVATE LIMITED",
"VICON IMPERIAL (I) PRIVATE LIMITED",
"VICON MOTORCYCLE AND SCOOTER INDIA PRIVATE LIMITED",
"VICS INDUSTRIES PRIVATE LIMITED",
"VICTAS SECURITY SERVICES PRIVATE LIMITED",
"VICTAULIC PIPING PRODUCTS INDIA PRIVATE LIMITED",
"VICTERRACE ENTERPRISE PRIVATE LIMITED",
"VICTOR BIO GENETICS PRIVATE LIMITED",
"VICTOR CABLES CORPORATION LIMITED",
"VICTOR COLOURS AND COATINGS PRIVATE LIMITED",
"VICTOR COMPONENT SYSTEMS PRIVATE LIMITED",
"VICTOR CRAFT AND TEXTURE PRIVATE LIMITED",
"VICTOR ENTERPRISES",
"VICTOR HOSPITALS AND MEDICAL SERVICES LIMITED",
"VICTOR HOSPITALS AND MEDICAL SERVICES PRIVATE LIMITED",
"VICTOR LOGISTICS PRIVATE LIMITED",
"VICTOR MAGNETICS PRIVATE LIMITED",
"VICTOR RACKETS PRIVATE LIMITED",
"VICTOR REINZ INDIA PRIVATE LIMITED",
"VICTOR TANGO ENTERTAINMENT PRIVATE LIMITED",
"VICTOR TEXTILE LTD.",
"VICTORA AUTO PRIVATE LIMITED",
"VICTORA AUTOMOTIVE INC.",
"VICTORA HOSPITALITIES PRIVATE LIMITED",
"VICTORA INDUSTRIES PRIVATE LIMITED",
"VICTORA LIFTS PRIVATE LIMITED",
"VICTORA STOCK-INVEST PRIVATE LIMITED",
"VICTORE SHIPS PRIVATE LIMITED",
"VICTORIA AGRO FOOD PROCESSING PRIVATE LIMITED",
"VICTORIA CAR RENTAL PRIVATE LIMITED",
"VICTORIA COLLEGE OF PHARMACY",
"VICTORIA COOKWELL SPECIALITIES PRIVATE LIMITED",
"VICTORIA CROSS INDIA PRIVATE LIMITED",
"VICTORIA FERRO ALLOYS PRIVATE LIMITED",
"VICTORIA FOODS PRIVATE. LIMITED.",
"VICTORIA HOSPITAL",
"VICTORIA HOTEL & RESTAURENT PRIVATE LIMITED",
"VICTORIA IMPEX PRIVATE LIMITED",
"VICTORIA INSTITUTE",
"VICTORIA INTERNATIONAL PRIVATE. LIMITED",
"VICTORIA LIFE CARE PRIVATE LIMITED",
"VICTORIA MRI CENTRE PRIVATE LIMITED",
"VICTORIA PUBLIC SCHOOL",
"VICTORIA REALTORS PRIVATE LIMITED",
"VICTORIA TRAVELS PVT LTD",
"VICTORIAFALLS INGREDIENTS PRIVATE LIMITED",
"VICTORIAGOLD ALLIANCE TRADING PRIVATE LIMITED",
"VICTORIAN GLOBAL CLOTHINGS INDIA PRIVATE LIMITED",
"VICTORIAN LABEL COMPANY",
"VICTORIAN MARKETING PVT LTD",
"VICTORIAN UTILITY SOLUTION PRIVATE LIMITED",
"VICTORIAS SECRET INDIA PRIVATE LIMITED",
"VICTORIOUS EXIM PRIVATE LIMITED",
"VICTORIOUS INDUSTRIES PRIVATE LIMITED",
"VICTORIOUS MANAGERS' GROUP PRIVATE LIMITED",
"VICTORY AGGREGATES PRIVATE LIMITED",
"VICTORY ARTS FOUNDATION",
"VICTORY AUTO AGENCIES PRIVATE LIMITED",
"VICTORY AUTO GASKETS PRIVATE LIMITED",
"VICTORY DIGITAL NETWORK PRIVATE LIMITED",
"VICTORY ELECTRIC VEHICLES INTERNATIONAL LIMITED",
"VICTORY EM HIGH SCHOOL",
"VICTORY ESERVICES PRIVATE LIMITED",
"VICTORY FINANCIAL CONSULTING",
"VICTORY FINANCIAL SERVICES LIMITED",
"VICTORY FINANCIAL SERVICES PRIVATE LIMITED",
"VICTORY FLOOR TILES PRIVATE LIMITED",
"VICTORY FOREX AND TRAVEL SERVICES PRIVATE LIMITED",
"VICTORY FREIGHT SERVICES PRIVATE LIMITED",
"VICTORY GLOBALCARE PRIVATE LIMITED",
"VICTORY INFRAEDGE PRIVATE LIMITED",
"VICTORY INFRAPROJECTS PRIVATE LIMITED",
"VICTORY IRON WORKS LTD",
"VICTORY IT INFRA PRIVATE LIMITED",
"VICTORY LAMINATIONS LIMITED",
"VICTORY MATTRESSES PRIVATE LIMITED",
"VICTORY MEDIA & PUBLICITY SERVICES PRIVATE LIMITED",
"VICTORY MERCANTILE PRIVATE LIMITED",
"VICTORY MINERALS PRIVATE LIMITED",
"VICTORY NUTRITIONS INDIA PRIVATE LIMITED",
"VICTORY POLYFOAMS PRIVATE LIMITED",
"VICTORY PRECISIONS PRIVATE LIMITED",
"VICTORY RECOVERY & RECYCLE TECHNOLOGIES INDIA PRIVATE LIMITED",
"VICTORY SOAPS AND COSMETICS PRIVATE LIMITED",
"VICTORY SPINNING MILLS LIMITED",
"VICTORY WINDFARM SERVICES PRIVATE LIMITED",
"VICTOSALES IMPEX PRIVATE LIMITED",
"VICTRAM VALVES PRODUCTS PRIVATE LIMITED",
"VICTRIX SYSTEMS AND LABS PRIVATE LIMITED",
"VID EVOLUTION ENTERTAINMENT PRIVATE LIMITED",
"VIDA LIFESCIENCES PRIVATE LIMITED",
"VIDAKEM LIFESCIENCES PRIVATE LIMITED",
"VIDAL HEALTH INSURANCE TPA PRIVATE LIMITED.",
"VIDAL HEALTHCARE SERVICES PRIVATE LIMITED",
"VIDARBHA AGRICULTURAL & ALLIED PRODUCER COMPANY LIMITED",
"VIDARBHA COT-FIBRE PRIVATE LIMITED",
"VIDARBHA DECORATORS PRIVATE LIMITED",
"VIDARBHA DIAGNOSTICS PRIVATE LIMITED",
"VIDARBHA HI TECH",
"VIDARBHA INDUSTRIES LTD",
"VIDARBHA INFOTECH PRIVATE LIMITED",
"VIDARBHA INTENSIVIST & PEDIATRICIANS GROUP PRIVATE LIMITED",
"VIDARBHA KONKAN GRAMIN BANK",
"VIDARBHA NAISARGIK SHETMAL UTPADAK KISAN PRODUCER COMPANY LIMITED",
"VIDARBHA PUBLICATIONS PRIVATE LIMITED",
"VIDARBHA ROAD WAYS PRIVATE LIMITED",
"VIDARBHA SHETKARI KRUSHI MAL PRAKRIYA & UDYOG PRODUCER COMPANY LIMITED",
"VIDARBHA TOBACCO PRODUCTS PRIVATE LIMITED",
"VIDARBHA TRADELINKS PRIVATE LIMITED",
"VIDARBHA YOUTH WELFARE SOCIETY AMRAVATI",
"VIDARBHA YOUTH WELFARE SOCIETYS POLYTECHNIC BADNERA",
"VIDATHA HOTELS AND ENTERTAINMENT PRIVATE LIMITED",
"VIDATT DATA ANALYTICS PRIVATE LIMITED",
"VIDCAST ENGINEERING PRIVATE LIMITED",
"VIDCOM BUSINESS SOLUTION PRIVATE LIMITED",
"VIDEC CONSULTANTS PRIVATE LIMITED",
"VIDEEP MULLICK FOODS PRIVATE LIMITED",
"VIDEO PLAZA",
"VIDEO PLAZA 2009 PRIVATE LIMITED",
"VIDEO WALL INDIA PRIVATE LIMITED",
"VIDEOCON D2H LIMITED.",
"VIDEOGYAN STUDIOS PRIVATE LIMITED",
"VIDEOJET TECHNOLOGIES I PRIVATE LIMITED",
"VIDEOMAX INTERNATIONAL PRIVATE LIMITED",
"VIDEON TV MANUFACTURERS PRIVATE LIMITED",
"VIDEONETICS TECHNOLOGY PRIVATE LIMITED",
"VIDEOTEX INTERNATIONAL PRIVATE LIMITED",
"VIDEOWALA PRODUCTIONS LLP",
"VIDERE SOFT CONSULTING PRIVATE LIMITED",
"VIDEVISION SMART TECH PRIVATE LIMITED",
"VIDH JEWELS PRIVATE LIMITED",
"VIDHAATA'S SELECTION PVT LTD",
"VIDHAATRI TECHNOLOGIES PRIVATE LIMITED",
"VIDHAI TECHNOLOGIES PRIVATE LIMITED",
"VIDHAN SABHA UTTARAKHAND",
"VIDHANI VENEERS PRIVATE LIMITED",
"VIDHANI'S TRADELINK PRIVATE LIMITED",
"VIDHARBHA INSTITUTE OF MEDICAL SCIENCES PRIVATE LIMITED",
"VIDHARBHA IRRIGATION SYSTEM PRIVATE LIMITED",
"VIDHARTH INDUSTRIES INDIA PRIVATE LIMITED",
"VIDHATA CEMENT COMPANY PRIVATE LIMITED",
"VIDHATA FOODS PRIVATE LIMITED",
"VIDHATA INDUSTRIES PRIVATE LIMITED",
"VIDHATA PLASTICS INDIA PRIVATELIMITED",
"VIDHATA SILK MILLS PRIVATE LIMITED",
"VIDHATA SYNTHETICS PRIVATE LIMITED",
"VIDHATA TRANSFORMERS PRIVATE LIMITED",
"VIDHATRI EXPORTS PRIVATE LIMITED",
"VIDHATRI MOTORS PRIVATE LIMITED",
"VIDHI ASSOCIATES PRIVATE LIMITED",
"VIDHI BUILDCON PRIVATE LIMITED",
"VIDHI DEVELOPERS PRIVATE LIMITED",
"VIDHI HOME DECORS PRIVATE LIMITED",
"VIDHI INFRABUILD PRIVATE LIMITED",
"VIDHI JEWELS PRIVATE LIMITED",
"VIDHI NIWAS PRIVATE LIMITED",
"VIDHI PETRO PRODUCTS PRIVATE LIMITED",
"VIDHI POLYCHEM PRIVATE LIMITED",
"VIDHI SPECIALTY FOOD INGREDIENTS LIMITED",
"VIDHI STEEL IMPEX PRIVATE LIMITED",
"VIDHI TECHINNOVATION OPPORTUNITIES NETWORK PRIVATE LIMITED",
"VIDHI VINAYAK METALS PRIVATE LIMITED",
"VIDHICON INDUSTRIES PRIVATE LIMITED",
"VIDHISHA PAPER MILLS LIMITED",
"VIDHU FINANCE AND LEASING LIMITED",
"VIDHUT ELECTRICALS PRIVATE LIMITED",
"VIDHYA COLOURS PRIVATE LIMITED",
"VIDHYA CYLINDERS PVT LTD",
"VIDHYA DEVI COLD STORAGE PRIVATE LIMITED",
"VIDHYA INDUSTRIES PRIVATE LIMITED",
"VIDHYA INTERNATIONAL PRIVATE LIMITED",
"VIDHYA LAXMI STEEL INDIA PRIVATE LIMITED",
"VIDHYA MANAGEMENT SERVICES PRIVATE LIMITED",
"VIDHYA NIKETAN PUBLIC SCHOOL",
"VIDHYA RAJ REALITIES PRIVATE LIMITED",
"VIDHYA RAM HOSPITALS PRIVATE LIMITED",
"VIDHYA SAGAR WOMENS COLLEGE",
"VIDHYA SHANKAR INVESTMENTS PRIVATE LIMITED",
"VIDHYA SHREE INFRAPROJECT PRIVATE LIMITED",
"VIDHYA VARDHAKA SANGHA COLLEGE ONLY GIRL",
"VIDHYABHARATHI COLD STORAGE PRIVATE LIMITED",
"VIDHYADEEP INSTITUTE OF NURSING",
"VIDHYALAKSHMI SCHOOL",
"VIDHYAMANJARI GNANPITH SANSKRUTI SCHOOL",
"VIDHYANAGAR GIRLS HIGHSCHOOL",
"VIDHYANJALI AHINSA SONDARYA PRIVATE LIMITED",
"VIDHYARTHI COPY MANUFACTURING CO. PRIVATE LIMITED",
"VIDHYASAGAR PROTIENS PRIVATE LIMITED",
"VIDHYODAY EDUCATION PRIVATE LIMITED",
"VIDHYUT CONTROL INDIA PRIVATE LIMITED",
"VIDHYUT POWER PRIVATE LIMITED",
"VIDHYUT STEEL TUBES INDUSTRIES PVT. LTD.",
"VIDISH APPARELS PRIVATE LIMITED",
"VIDISHA ELECTRICALS PRIVATE LIMITED",
"VIDISHA IMPEX PRIVATE LIMITED",
"VIDISHA REAL ESTATE DEVLOPERS PRIVATE LIMITED",
"VIDISHA YARNS PRIVATE LIMITED",
"VIDITA SOLUTIONS PRIVATE LIMITED",
"VIDKRIS INDIA PRIVATE LIMITED",
"VIDKRIS RETAIL STORES PRIVATE LIMITED",
"VIDLEX SOLUTIONS PRIVATE LIMITED",
"VIDLI RESTAURANTS LIMITED",
"VIDMAN PHARMACEUTICALS PRIVATE LIMITED",
"VIDNYAN VARDHINI HIGH SCHOOL",
"VIDOC TECHNOLOGIES PRIVATE LIMITED",
"VIDOOLY MEDIA TECH PRIVATE LIMITED",
"VIDRES INDIA CERAMICS PRIVATE LIMITED",
"VIDSUR GOLF PRIVATE LIMITED",
"VIDTEQ INDIA PRIVATE LIMITED",
"VIDU PROPERTIES PVT LTD",
"VIDULA CONSULTANCY SERVICES LIMITED",
"VIDUNIT MEDIA PRIVATE LIMITED",
"VIDUR COMMODITIES INVESTMENT LIMITED",
"VIDUR CONTRACTS AND PROJECTS PRIVATE LIMITED",
"VIDUR LOGISTICS PRIVATE LIMITED",
"VIDURA SNACKS PRIVATE LIMITED",
"VIDURAMA SOLUTIONS PRIVATE LIMITED",
"VIDURYAM CHITS PRIVATE LIMITED",
"VIDUSHI INFOTECH SOFTWARE SOLUTIONS PROVIDER PRIVATE LIMITED",
"VIDUSHI INFRASTRUCTURE PRIVATE LIMITED",
"VIDUSHI TECHNICAL AND COMMERCIAL SERVICES PRIVATE LIMITED",
"VIDUSHI WIRES PRIVATE LIMITED",
"VIDVATAM INFRATECH PRIVATE LIMITED",
"VIDVEDAA ORNATERIOR PRIVATE LIMITED",
"VIDWAN CLASSES PRIVATE LIMITED",
"VIDWATH INNOVATIVE SOLUTIONS PRIVATE LIMITED",
"VIDYA ANAND PUBLIC SCHOOL",
"VIDYA ARADHANA ACADEMY",
"VIDYA AUTOLINKS PRIVATE LIMITED",
"VIDYA BHARATI MAHAVIDYALAYA AMRAVATI",
"VIDYA BHARATI PUBLIC SCHOOL",
"VIDYA BHARTI CHINMAYA VIDYALAYA",
"VIDYA BHARTI SANSTHAN",
"VIDYA BHAVAN PUBLIC SCHOOL",
"VIDYA BHAWAN SENIOR SECONDARY SCHOOL",
"VIDYA DAIRY",
"VIDYA DAYANI JR DEGREE COLLEGE",
"VIDYA EDUCARE PRIVATE LIMITED",
"VIDYA EDUCATIONAL TRAINING ACADEMY",
"VIDYA GURU EDUCATION PRIVATE LIMITED",
"VIDYA HERBS PRIVATE LIMITED",
"VIDYA INFRABUILT PRIVATE LIMITED",
"VIDYA JYOTHI INSTITUTE OF TECHNOLOGY",
"VIDYA JYOTI COLLEGE OF PHARMACY",
"VIDYA JYOTI EDUCATIONAL SOCIETY",
"VIDYA LAMINATORS PRIVATE LIMITED",
"VIDYA MANDIR ESTANCIA",
"VIDYA MANDIR HINDI MIDDLE SCHOOL PIPARIYA",
"VIDYA MANDIR INDEPENDENT PU COLLEGE",
"VIDYA MANDIR KHEDE",
"VIDYA MANDIR MCVC JUNIOR COLLEGE VAIRAG",
"VIDYA MANDIR NARUSINHWADI NARUSINHAWADI",
"VIDYA MANDIR NRUSINHWADI NRUSINHAWADI",
"VIDYA MANDIR PRASHALA AND KANISHTA MAHAVIDYALAYA BRAMHANPURI MIRAJ",
"VIDYA MANDIR SENIOR SEC SCHOOL",
"VIDYA MANDIR SENIOR SECONDARY SCHOOL",
"VIDYA MANTRA EDUSYSTEMS PRIVATE LIMITED",
"VIDYA METAL MANUFACTURING CO PRIVATE LIMITED",
"VIDYA MILKLINE PRIVATE LIMITED",
"VIDYA MINERALS PRIVATE LIMITED",
"VIDYA NIKETAN ENGLISH MEDIUM SCHOOL",
"VIDYA NIKETAN JR COLLEGE OF COMMERCE & SCIENCE",
"VIDYA ONLINE SERVICES PUNE PRIVATE LIMITED",
"VIDYA PEETAM SENIOR SECONDARAY SCHOOL",
"VIDYA PLYWOOD HOUSE PRIVATE LIMITED",
"VIDYA POLYMER PRIVATE LIMITED",
"VIDYA PRABODHINI ENGLISH MEDIUM SCHOOL",
"VIDYA PRAKASHAN MANDIR PRIVATE LIMITED",
"VIDYA PRASARAK MANDAL",
"VIDYA PRASARAK MANDAL DAHISAR",
"VIDYA PRATISHTHAN'S MAGARPATTA CITY PUBLIC SCHOOL",
"VIDYA PRATISHTHAN'S NANDED CITY PUBLIC SCHOOL",
"VIDYA PROJECTS PRIVATE LIMITED",
"VIDYA QUALITY AND SAFETY SOLUTION EXPERTS PRIVATE LIMITED",
"VIDYA RAM ASSOCIATES PRIVATE LIMITED",
"VIDYA SAGAR CAREER INSTITUTE LIMITED",
"VIDYA SAGAR PRE SCHOOL",
"VIDYA STATIONERY PRIVATE LIMITED",
"VIDYA TECHNO MECH (INDIA) PRIVATE LIMITED",
"VIDYA TIE-UP PRIVATE LIMITED",
"VIDYA TRAINING INSTITUTES PRIVATE LIMITED",
"VIDYA VIHAR",
"VIDYA VIHAR INTER COLLEGE",
"VIDYA VIHAR SCHOOL",
"VIDYA VIKAS EDUCATION TRUST",
"VIDYA VIKAS MANDIR NIMGAON MHALUNGI SCHOOL",
"VIDYA VIKAS PRIMARY SCHOOL DHULE",
"VIDYA VINAY VIDYALAYA BADUR",
"VIDYA WIRES PRIVATE LIMITED",
"VIDYAA VIKAS MATRIC HR SEC SCHOOL",
"VIDYABHARATI COLLEGE OF PHARMACY AMRAVATI",
"VIDYABHUSHAN ENGLISH SECONDARY SCHOOL",
"VIDYADAYINI COLLEGE OF EDUCATION",
"VIDYADEVI ELECTRONICS PRIVATE LIMITED",
"VIDYADHARI ESTATES PRIVATE LIMITED",
"VIDYAKIRANA PU COLLEGE",
"VIDYALANKAR INSTITUTE OF TECHNOLOGY",
"VIDYALAXMI CONSTRUCTIONS PRIVATE LIMITED",
"VIDYALAXMI GROUP OF INSTITUTIONS",
"VIDYAMANDIR GLOBAL INSTITUTE PRIVATE LIMITED",
"VIDYAMANDIR HIGH SCHOOL & JR COLLEGE SHIVLE",
"VIDYAN BIOCOMMERCE PRIVATE LIMITED",
"VIDYANIKETAN EDUCATION TRUST",
"VIDYANIKETAN PU SCIENCE COLLEGE",
"VIDYANJALI ACADEMY FOR LEARNING",
"VIDYANT HINDU DEGREE COLLEGE",
"VIDYANT HINDU PG COLLEGE",
"VIDYANTA SKILLS INSTITUTE PRIVATE LIMITED",
"VIDYAPATI COLD STORAGE PVT LTD",
"VIDYAPATI VIDYAMANDIR",
"VIDYARANYA HOSPITAL PRIVATE LIMITED",
"VIDYARANYA MULTISPECIALITY HOSPITAL PRIVATE LIMITED",
"VIDYARTHHI UNIFORMS INDIA PRIVATE LIMITED",
"VIDYARTHI ENTERPRISES PRIVATE LIMITED",
"VIDYARTHI KENDRA PUBLISHER AND DISTRIBUTOR PRIVATE LIMITED",
"VIDYASAGAR COMTRADE PRIVATE LIMITED",
"VIDYASAGAR FOODS PRIVATE LIMITED",
"VIDYASAGAR HIMGHAR PRIVATE LIMITED",
"VIDYASAGAR HOSPITAL",
"VIDYASAGAR PRIMARY SCHOOL AURANGABAD",
"VIDYASAGAR SCHOOL SMITI",
"VIDYASHILP ACADEMY",
"VIDYASHILP INDIA PRIVATE LIMITED",
"VIDYASHILP PUBLIC SCHOOL",
"VIDYASHILP UNIVERSITY",
"VIDYASHREE HIGH SCHOOL",
"VIDYASHRI SUPPLIERS & SALES PRIVATE LIMITED",
"VIDYASTHALI PUBLIC SCHOOL",
"VIDYATECH SOLUTIONS PRIVATE LIMITED",
"VIDYAVARDHAKA COLLEGE OF ENGINEERING",
"VIDYAVARDHAKA SANGHA FIRST GRADE COLLEGE",
"VIDYAVARDHAN S INSTITUTE OF DESIGN ENVIRONMENT AND ARCHITECTURE IDEA",
"VIDYAVARDHAN'S INSTITUTE OF DESIGN ENVIRONMENT AND ARCHITECTURE",
"VIDYAVARDHINI COLLEGE OF ENGINEERING AND TECHNOLOGY",
"VIDYAVATI INVESTMENTS PRIVATE LIMITED",
"VIDYAVATI SUPERMARKET PRIVATE LIMITED",
"VIDYAVIHAR KELVANI MANDAL PALITANA",
"VIDYAYUG SOFT TECHNOLOGIES PRIVATE LIMITED",
"VIDYODAYA MATRICULATION HIGHER SEC ACADMY",
"VIDYUT CONTROLS AND AUTOMATION PRIVATE LIMITED",
"VIDYUT ENGINEERING AND TECHNOLOGIES PRIVATE LIMITED",
"VIDYUT INSULATION PVT. LTD.",
"VIDYUT LUBRICANTS PRIVATE LIMITED",
"VIDYUT TECHNOLOGIES INDIA PRIVATE LIMITED",
"VIDYUT TELETRONICS LIMITED",
"VIDYUT TRANSFORMERS PRIVATE LIMITED",
"VIDYUT URJA EQUIPMENTS PRIVATE LIMITED",
"VIDYUTH CONTROL SYSTEMS PRIVATE LIMITED",
"VIDYUTH SOFTWARE SOLUTIONS (OPC) PRIVATE LIMITED",
"VIDYUTYANTRA E MOBILITY PRIVATE LIMITED",
"VIDZI PRODUCTION SERVICES PRIVATE LIMITED",
"VIE SUPPORT LANGUAGE SERVICES PRIVATE LIMITED",
"VIEGA INDIA INNOVATIVE TECHNOLOGIES PRIVATE LIMITED",
"VIEGA INDIA PRIVATE LIMITED",
"VIENA PETROCHEM PRIVATE LIMITED",
"VIENCEE PHARMA SCIENCE PRIVATE LIMITED",
"VIENNA IT SOLUTIONS PRIVATE LIMITED",
"VIENO ENGINEERING PRIVATE LIMITED",
"VIENSYS INDIA PRIVATE LIMITED",
"VIENTO RENEWABLES PRIVATE LIMITED",
"VIER WUNDER ED TECH PRIVATE LIMITED",
"VIEVA INTECH PRIVATE LIMITED",
"VIEW FINDER PUBLICITY PVT LTD",
"VIEW HOLIDAY TRIP PRIVATE LIMITED",
"VIEW INDIA TOUR AND TRAVELS PRIVATE LIMITED",
"VIEW PAKER TECHNOLOGY INDIA PRIVATE LIMITED",
"TRUBRIDGE HEALTHCARE PRIVATE LIMITED",
"VIEWLINK MERCHANTS PRIVATE LIMITED",
"VIEWPOINT ADVERTISING AGENCY",
"VIEWPOINT PROPERTIES PRIVATE LIMITED",
"VIEWSONIC TECHNOLOGIES INDIA PRIVATE LIMITED",
"VIEWTECH NIRMAN PRIVATE LIMITED",
"VIF COLLEGE OF ENGINEERING",
"VIFI SOLUTIONS AND TECHNOLOGIES PRIVATE LIMITED",
"VIG FOREX PVT LTD",
"VIG GRAPHICS PRIVATE LIMITED",
"VIG LEGEND TOUR AND TRAVELS PRIVATE LIMITED",
"VIG WEAVES PRIVATE LIMITED",
"VIGA APPLICATIONS PRIVATE LIMITED",
"VIGA ENTERTAINMENT TECHNOLOGY PRIVATE LIMITED",
"VIGAR ENTERPRISES PRIVATE LIMITED",
"VIGASA INDUSTRIES PRIVATE LIMITED",
"VIGAYANAND RAM NARAYN VAIDIK INTER COLLEGE",
"VIGEL MANUFACTURING TECHNOLOGIES PRIVATE. LIMITED.",
"VIGEN SEEDS AND BIOTECH PRIVATE LIMITED",
"VIGENINDIA MEDIQUIP PRIVATE LIMITED",
"VIGEO GRANIT PRIVATE LIMITED",
"VIGGO MEDICAL DEVICES INDIA PRIVATE LIMITED",
"VIGHNAHAR CLEARING, SHIPPING AND LOGISTICS PRIVATE LIMITED",
"VIGHNAHAR ENGINEERS PRIVATE LIMITED",
"VIGHNAHAR PACKAGING PRIVATE LIMITED",
"VIGHNAHARA PROPERTIES PRIVATE LIMITED",
"VIGHNAHARTA AQUA FARM TRADING PRIVATE LIMITED",
"VIGHNAHARTA HEALTH VISIONARIES PRIVATE LIMITED",
"VIGHNAHARTA LOGISTICS SERVICES PRIVATE LIMITED",
"VIGHNAHARTA OILS & CHEMICALS PRIVATE LIMITED",
"VIGHNAHARTA SERVICES",
"VIGHNAHARTA TECHNOLOGIES PRIVATE LIMITED",
"VIGHNARAJA MARKETING PRIVATE LIMITED",
"VIGHNESHWAR AIRCONDITIONING PRIVATE LIMITED",
"VIGHNESHWAR ISPAT PRIVATE LIMITED",
"VIGHNESWAR RICE MILL PRIVATE LIMITED",
"VIGHNHAR MARKETING PVT. LTD.",
"VIGI AGRIFILMS PRIVATE LIMITED",
"VIGI MEDSAFE PRIVATE LIMITED",
"VIGIBOSS IT SOLUTIONS PRIVATE LIMITED",
"VIGIL 24X7 GUARDING SERVICES PRIVATE LIMITED",
"VIGIL ALLIED MANAGEMENT PRIVATE LIMITED",
"VIGIL SECURITY BUREAU PRIVATE LIMITED",
"VIGILANCE 24X7 SECURITY AND ALLIED SERVICES PRIVATE LIMITED",
"VIGILANCE INDIA CONSULTANTS PRIVATE LIMI TED",
"VIGILANCE SECURITY SERVICES PVT. LTD.",
"VIGILANCE SERVICES INDIA PRIVATE LIMITED",
"VIGILANCE WORKFORCE SOLUTIONS PRIVATE LIMITED",
"VIGILANT COMPUTECHNOLOGIES PRIVATE LIMITED",
"VIGILANT CORPORATE SERVICES PRIVATE LIMITED",
"VIGILANT HEALTHCARE PRIVATE LIMITED",
"VIGILANT MEDIA PRIVATE LIMITED",
"VIGILANTE SERVICES PRIVATE LIMITED",
"VIGILARE BIOPHARMA PRIVATE LIMITED",
"VIGILES FACILITIES PRIVATE LIMITED",
"VIGILITY TECHNOLOGIES PRIVATE LIMITED",
"VIGILPLUS SECURITY SOLUTIONS PRIVATE LIMITED",
"VIGIROM PRIVATE LIMITED",
"VIGIS SEARCH AND SUPPORT PRIVATE LIMITED",
"VIGIZARA HOSPITALITIES PRIVATE LIMITED",
"VIGLES SECURITY PRIVATE LIMITED",
"VIGN ENGINEERING AND SERVICES PRIVATE LIMITED",
"VIGNA HUMAN DEVELOPMENT PRIVATE LIMITED",
"VIGNAHARTA BRICKS ENTERPRISE PRIVATE LIMITED",
"VIGNAHARTA ENTERPRISES PRIVATE LIMITED",
"VIGNAN EDUCATIONAL ACADEMY",
"VIGNAN EDUCATIONAL INSTITUTIONS PVT LTD",
"VIGNAN GLOBAL GEN SCHOOL",
"VIGNAN INSTITUTE OF TECHNOLOGY AND SCIENCE",
"VIGNAN JR DEGREE ENGINEERING COLLEGES",
"VIGNAN PUBLISHERS LIMITED",
"VIGNAN S LARA INSTITUTE OF TECHNOLOGY & SCIENCE",
"VIGNAN S WORLD ONE SCHOOL",
"VIGNAN VIDYALAYA",
"VIGNAN‚ÄôS INSTITUTE OF INFORMATION TECHNOLOGYAUTONOMOUS",
"VIGNANA BHARATHI ENGINEERING COLLEGE",
"VIGNANA BHARATHI INSTITUTE OF TECHNOLOGY",
"VIGNAN'S FOUNDATION FOR SCIENCE, TECHNOLOGY & RESEARCH DEEMED TO BE UNIVERSITY",
"VIGNANS INSTITUTE OF ENGINEERING FOR WOMEN",
"VIGNAN'S INSTITUTE OF INFORMATION TECHNOLOGYAUTONOMOUS",
"VIGNAN'S INSTITUTE OF MANAGEMENT AND TECHNOLOGY FOR WOMEN",
"VIGNAN'S NIRULA INSTITUTE OF TECHNOLOGY AND SCIENCE FOR WOMEN",
"VIGNAN'S PRABODHANANDA PRASHANTI NIKETAN",
"VIGNASAI LABORATORIES PRIVATE LIMITED",
"VIGNATHA MINES PRIVATE LIMITED",
"VIGNESH BUSINESS SERVICES PRIVATE LIMITED",
"VIGNESH CAREWELL HOSPITALS PRIVATE LIMITED",
"VIGNESH ELECTRICAL HYDERABAD (OPC) PRIVATE LIMITED",
"VIGNESH ENTERPRISES",
"VIGNESH FERTILITY & CHILDREN‚ÄôS HOSPITAL",
"VIGNESH IRON AND STEELS INDIA PRIVATE LIMITED",
"VIGNESH LIFE SCIENCES PRIVATE LIMITED",
"VIGNESH MATCH WORKS PRIVATE LIMITED",
"VIGNESH MITRA TECHCON ENTERPRISES PRIVATE LIMITED",
"VIGNESH MOTEURX PRIVATE LIMITED",
"VIGNESH OVERSEAS (C & F) PRIVATE LIMITED",
"VIGNESH PERSONAL CARE PRIVATE LIMITED",
"VIGNESH POLYMERS INDIA PRIVATE LIMITED",
"VIGNESH PROJECTS PRIVATE LIMITED",
"VIGNESH SCORING",
"VIGNESH SUPER SPECIALITY HOSPITALS PRIVATE LIMITED",
"VIGNESHH PHARMA IMPEX PRIVATE LIMITED",
"VIGNESHKUMAR SPINNING MILLS PRIVATE LIMITED",
"VIGNESHWAR SYNTHETICS PRIVATE LIMITED",
"VIGNESSH GEARS PRIVATE LIMITED",
"VIGNESWARA RENEWABLES PRIVATE LIMITED",
"VIGNESWARA THERMAL POWER PRIVATE LIMITED",
"VIGNET IT SOLUTIONS PRIVATE LIMITED",
"VIGOR JUTE PRIVATE LIMITED",
"VIGOR PLAST INDIA PRIVATE LIMITED",
"VIGOR STEEL INDIA PRIVATE LIMITED",
"VIGOROUS ALUMINIUM PRIVATE LIMITED",
"VIGOROUS FOOD VENTURES PRIVATE LIMITED",
"VIGOUR AGRITECH SOLUTIONS PRIVATE LIMITED",
"VIGOUR HEALTH CARE PRIVATE LIMITED",
"VIGOUR MOBILE INDIA PRIVATE LIMITED",
"VIGOURGLOBAL TRAVEL SOLUTIONS PRIVATE LIMITED",
"VIGOURSOFT GLOBAL SOLUTIONS PRIVATE LIMITED",
"VIGVEN TECH MARK PRIVATE LIMITED",
"VIGYA LIFE SCIENCES PRIVATE LIMITED",
"VIGYAN PHARMA CHEM PRIVATE LIMITED",
"VIGYANLABS INNOVATIONS PRIVATE LIMITED",
"VIGYASHREE SHARODA INFRASTRUCTURE LIMITED",
"VIHA DIGITAL COMMERCE PRIVATE LIMITED",
"VIHA HOTELS PRIVATE LIMITED",
"VIHAA PRINT AND PACK PRIVATE LIMITED",
"VIHAA TECHNOLOGIES LLP",
"VIHAAN AUTO VENTURES PRIVATE LIMITED",
"VIHAAN BOARDS PRIVATE LIMITED",
"VIHAAN DIRECT SELLING INDIA PRIVATE LIMITED",
"VIHAAN ENTERPRISES PRIVATE LIMITED",
"VIHAAN EXIMS COMPANY PRIVATE LIMITED",
"VIHAAN FOREX PRIVATE LIMITED",
"VIHAAN HEART CARE PRIVATE LIMITED",
"VIHAAN INFIN & EXIM PRIVATE LIMITED VIEPL",
"VIHAAN INFRASYSTEMS INDIA PRIVATE LIMITED",
"VIHAAN LIFE CARE",
"VIHAAN METALS PRIVATE LIMITED",
"VIHAAN NETWORKS LIMITED",
"VIHAAN OVERSEAS PRIVATE LIMITED",
"VIHAAN TELECOMMUNICATION PRIVATE LIMITED",
"VIHAAN WEB SOLUTIONS PRIVATE LIMITED",
"VIHAANAGRO ENGINEERING PRIVATE LIMITED",
"VIHAN BUILDTECH PRIVATE LIMITED",
"VIHAN ELECTRIC PRIVATE LIMITED",
"VIHAN ENGINEERING PRIVATE LIMITED",
"VIHAN ENTERPRISES PRIVATE LIMITED",
"VIHAN EXIM",
"VIHAN IRON & STEEL PRIVATE LIMITED",
"VIHAN TEXTILES PRIVATE LIMITED",
"VIHANA HEALTH CARE LLP",
"VIHANG ADCON PRIVATE LIMITED",
"VIHANG FOOD INDUSTRIES PRIVATE LIMITED",
"VIHANG INFOMEDIA PRIVATE LIMITED",
"VIHANG INFRASTRUCTURE PRIVATE LIMITED.",
"VIHANGAM SECURITY SERVICES PRIVATE LIMITED",
"VIHANN EQUIPMENT AND MACHINES PRIVATE LIMITED",
"VIHARI AUTO PRIVATE LIMITED",
"VIHARI MARKETING PRIVATE LIMITED",
"VIHAV REALTY PRIVATE LIMITED",
"VIHAWK TECH SOLUTIONS PRIVATE LIMITED",
"VIHITA BIO-CHEM PRIVATE LIMITED",
"VIHITA CHEM PRIVATE LIMITED",
"VIIKING BEVERAGES PRIVATE LIMITED",
"VIIKING MEDIA AND ENTERTAINMENT PRIVATE LIMITED",
"VIIKING VENTURES PRIVATE LIMITED",
"VIIKRAM MOTOR CRAFT PRIVATE LIMITED",
"VIILBERY HEALTHCARE PRIVATE LIMITED",
"VIITORCLOUD TECHNOLOGIES PRIVATE LIMITED",
"VIJ CONTRACTS PRIVATE LIMITED",
"VIJA EXPORTS AND HANDICRAFT PVT LTLD",
"VIJAI CONSTRUCTION INDIA PRIVATE LIMITED VCIPL",
"VIJAI DENTAL DEPOT PRIVATE LIMITED",
"VIJAI EARTH MOVING EQUIPMENT PRIVATE LIMITED",
"VIJAI ELECTRICALS LIMITED",
"VIJAI INFRAENGINEERS PRIVATE LIMITED",
"VIJAI MARINE SERVICES PRIVATE LIMITED",
"VIJAI SHREE PRIVATE LIMITED",
"VIJAI SHREE WRITING CONCEPT PRIVATE LIMITED",
"VIJAI SHRI PRIVATE LIMITED",
"VIJAINAGAR FORT HOSPITALITY PRIVATE LIMITED",
"VIJAN HOTELS PRIVATE LIMITED",
"VIJAN MOTORS SERVICES PRIVATE LIMITED",
"VIJAPUR METALS PRIVATE LIMITED",
"VIJAPUR NAGARPALIKA",
"VIJAPURA SOLAR ENERGY PRIVATE LIMITED",
"VIJAS DIGITAL INDIA PRIVATE LIMITED",
"VIJAS GRAPHICS PRIVATE LIMITED",
"VIJASMI CONSULTANCY PRIVATE LIMITED",
"VIJATA INFRAPROJECTS PRIVATE LIMITED",
"VIJAY ADVANCED PAIN CLINIC PRIVATE LIMITED",
"VIJAY AGRO FOODS PRIVATE. LIMITED.",
"VIJAY AGRO PRODUCTS PVT LTD",
"VIJAY AIRCONDITIONING PRIVATE LIMITED",
"VIJAY AJAY JUTE PRIVATE LIMITED",
"VIJAY ANAND AND ASSOCIATES LLP",
"VIJAY ANAND FABRICS PVT LTD",
"VIJAY ANAND KRAFT PAPERS PRIVATE LIMITED",
"VIJAY ANAND SPECIALITY PAPERS PRIVATE LIMITED",
"VIJAY ASSAY CENTRE PRIVATE LIMITED",
"VIJAY AUTO WORKS PRIVATE LIMITED",
"VIJAY AUTOSHINE INDIA PRIVATE LIMITED",
"VIJAY AUTOWORK LIMITED",
"VIJAY BHARAT MOTORS PRIVATE LIMITED",
"VIJAY BHARAT TRANSPORT CORPORATION PRIVATE LIMITED",
"VIJAY BUILDERS & CONSTRUCTIONS PRIVATE LIMITED",
"VIJAY CHAIN AND JEWELLERY PRIVATE LIMITED",
"VIJAY COTSWIN PRIVATE LIMITED",
"VIJAY DAIRY & FARM PRODUCTS PRIVATE LIMITED",
"VIJAY DEEP FABRICS PRIVATE LIMITED",
"VIJAY DEEP SILK MILLS PRIVATE LIMITED",
"VIJAY DESIGN INSPIRATION PRIVATE LIMITED",
"VIJAY DEVELOPERS PVT LTD",
"VIJAY DWELLERS PRIVATE LIMITED",
"VIJAY ENGIFAB INDIA PRIVATE LIMITED",
"VIJAY ENGINEERING & MACHINERY CO",
"VIJAY ENTERPRISES PVT LTD",
"VIJAY ESTATES (MADURA) PRIVATE LIMITED",
"VIJAY EXPORTS",
"VIJAY FERROMET PRIVATE LIMITED.",
"VIJAY FIRE VEHICLES AND PUMPS LIMITED",
"VIJAY FOOD INDUSTRIES REWA PRIVATE LIMITED",
"VIJAY FOOD PRODUCTS PRIVATE. LIMITED.",
"VIJAY FURNITURE MANUFACTURING COMPANY PRIVATE LIMITED",
"VIJAY GANGA SPECIALITY CARE",
"VIJAY GARMENTS",
"VIJAY GEMS AND JEWELLERY MANUFACTURERS PRIVATE LIMITED",
"VIJAY GEMS PRIVATE LIMITED",
"VIJAY GLOBAL PRIVATE LIMITED",
"VIJAY HEATWELL CASTING PRIVATE LIMITED",
"VIJAY HEMANT FINANCE AND ESTATES LIMITED",
"VIJAY HOSPITAL",
"VIJAY ICE AND COLD STORAGE PRIVATE LIMITED",
"VIJAY INFRA PROJECTS PRIVATE LIMITED",
"VIJAY INFRATECH (INDIA) PRIVATE LIMITED",
"VIJAY INVESTEDGE PRIVATE LIMITED",
"VIJAY JINDAL BUILDERS PRIVATE LIMITED",
"VIJAY KARAN EDUCATION TRUST",
"VIJAY KUMAR & CO JUTE PRIVATE LIMITED",
"VIJAY KUMAR AGRO OILS PRIVATE LIMITED",
"VIJAY KUMAR REFRACTORIES AND CHEMICALS PRIVATE LIMITED",
"VIJAY KUMAR SAHU INFRASTRUCTURE PRIVATE LIMITED",
"VIJAY LABOUR & SECURITY SERVICES PRIVATE LIMITED",
"VIJAY LAKSHMI ALLOYS PRIVATE LIMITED",
"VIJAY LAKSHMI CARGO MOVERS PRIVATE LIMITED",
"VIJAY LAKSHMI TRANSOLUTIONS PRIVATE LIMITED",
"VIJAY LANDBUILD PRIVATE LIMITED",
"VIJAY LATEX PRODUCTS PRIVATE LIMITED",
"VIJAY LAXMI LABELS PRIVATE LIMITED",
"VIJAY LAXMI MANSOL PRIVATE LIMITED",
"VIJAY LAXMI TEXTILE INDUSTRIES PRIVATE LIMITED",
"VIJAY LOGISTICS PRIVATE LIMITED",
"VIJAY M MISTRY CONSTRUCTION PRIVATE LIMITED",
"VIJAY MACHINE TOOLS PRIVATE LIMITED",
"VIJAY MAHAL HOTELSPRIVATE LIMITED",
"VIJAY MAHIENDRA SPINNTEX PRIVATE. LIMITED.",
"VIJAY MAHIENDRAA IMPEX SHARVESH PRIVATE LIMITED",
"VIJAY MAMARA PRIVATE LIMITED",
"VIJAY METAL FORGINGS PVT.LTD.",
"VIJAY MODERN LOOMTEX PRIVATE LIMITED",
"VIJAY MOHAN STEEL INDUSTRIES PRIVATE LIMITED",
"VIJAY MOTOWINGS PRIVATE LIMITED",
"VIJAY NIRMAN COMPANY PRIVATE LIMITED",
"VIJAY OIL MILLS",
"VIJAY PALLET AND BOX MANUFACTURERS (INDIA) PRIVATE LIMITED",
"VIJAY PETROCHEM PRIVATE LIMITED",
"VIJAY PLYWOOD",
"VIJAY POLYPLAST PRIVATE LIMITED",
"VIJAY POULTRY",
"VIJAY POWERCONTROL SYSTEMS PRIVATE LIMITED",
"VIJAY PRAKASH AEROMARINE METALS PRIVATE LIMITED",
"VIJAY PRECISION DIES PRIVATE LIMITED",
"VIJAY PRESTRESSED PRODUCTS PVT LTD",
"VIJAY PRINTING PRESS PRIVATE LIMITED",
"VIJAY PUBLIC SCHOOL",
"VIJAY PULSE PRIVATE LIMITED",
"VIJAY PUNJABI CONSULTANTS PRIVATE LIMITED",
"VIJAY RAJ MEWAR CONSTRUCTION COMPANY PRIVATE LIMITED",
"VIJAY RAJA HOMES PRIVATE LIMITED",
"VIJAY RAJA'S INHOUSE CARE PRIVATE LIMITED",
"VIJAY SABRE SAFETY PRIVATE LIMITED",
"VIJAY SAI HEALTH CARE HOSUR PRIVATE LIMITED",
"VIJAY SALES",
"VIJAY SALES ELECTRONICS PRIVATE LIMITED",
"VIJAY SALES INDIA PRIVATE LIMITED",
"VIJAY SAMARAJ HOTEL PRIVATE LIMITED",
"VIJAY SECURITY SYSTEMS PRIVATE LIMITED",
"VIJAY SHANTHI BUILDERS LIMITED",
"VIJAY SHANTHI ELECTRICALS PRIVATE LIMITED",
"VIJAY SHOES PRIVATE LIMITED",
"VIJAY SHREE PROPERTIES PVT LTD",
"VIJAY SHREE TEXTILES PVT LTD",
"VIJAY SHREE TRADERS",
"VIJAY SPHEROIDALS PRIVATE LIMITED",
"VIJAY SPINNING MILLS LTD",
"VIJAY SPRINGS INDIA PRIVATE LIMITED",
"VIJAY STEEL CORPORATION PRIVATE LIMITED",
"VIJAY STONE QUARRIES PRIVATE LIMITED",
"VIJAY STORE PRIVATE LIMITED",
"VIJAY SUPREME BUILDERS PRIVATE LIMITED",
"VIJAY SURAKSHA REALTY LLP",
"VIJAY SWARN JEWELS PRIVATE LIMITED",
"VIJAY SYSTEMS ENGINEERS PRIVATE LIMITED",
"VIJAY TAK GEMS PRIVATE LIMITED",
"VIJAY TANKS AND VESSELS PRIVATE LIMITED",
"VIJAY TECHNICAL SERVICES AND CONSTRUCTION PVT LTD",
"VIJAY TECHNNOCRATS PRIVATE LIMITED.",
"VIJAY TECHS PRIVATE LIMITED",
"VIJAY TEXTILES LTD",
"VIJAY TILES PRIVATE LIMITED",
"VIJAY TOOL ROOM PRIVATE LIMITED",
"VIJAY TRANSCAB INDIA PRIVATE LIMITED",
"VIJAY TRANSMISSION PRIVATE LIMITED",
"VIJAY TRANSPORT PRIVATE LIMITED",
"VIJAY TRANSTECH PRIVATE LIMITED",
"VIJAY UDYOG KITCHEN EQUIPMENT PRIVATE LIMITED",
"VIJAY VALLABH SARVAJANIK HOSPITAL",
"VIJAY VELAVAN SPINNING MILLS PRIVATE LIMITED",
"VIJAY VENKAT STEELS PRIVATE LIMITED",
"VIJAY WEAVING & DYING PRIVATE LIMITED",
"VIJAY WHEELS PRIVATE LIMITED",
"VIJAYA AGENCIES",
"VIJAYA APPARELS PVT LTD",
"VIJAYA AUTOMOBILES PRIVATE LIMITED",
"VIJAYA BANK",
"VIJAYA BHANU ENGINEERING INDIA PRIVATE LIMITED",
"VIJAYA CHAITANYA ENTERPRISES PRIVATE. LIMITED.",
"VIJAYA CLINIC MATERNITY & SURGICAL NURSING HOME",
"VIJAYA COLLEGE",
"VIJAYA COLLEGE OF PHARMACY",
"VIJAYA DAIRY MILK & MILK PRODUCTS PRIVATE LIMITED",
"VIJAYA DIAGNOSTIC CENTRE LIMITED",
"VIJAYA DURGA INFRACON PRIVATE LIMITED",
"VIJAYA DURGA PHOSPATE FERTILIZERS PRIVATE LIMITED",
"VIJAYA ELE TECHS PRIVATE LIMITED",
"VIJAYA ELECTRONICS PRIVATE LIMITED",
"VIJAYA ENERGY PLUS PRIVATE LIMITED",
"VIJAYA ENGINEERING PRIVATE LIMITED",
"VIJAYA ENTERPRISES",
"VIJAYA EXPORTS INDIA PRIVATE LIMITED",
"VIJAYA FREIGHT CARRIERS LIMITED",
"VIJAYA GROUP OF HOSPITALS",
"VIJAYA HANUMAN COLD STORAGES PRIVATE LIMITED",
"VIJAYA HANUMAN RICE INDUSTRIES PRIVATE LIMITED",
"VIJAYA HEART FOUNDATION",
"VIJAYA HOMES PRIVATE LIMITED",
"VIJAYA HOSPITALITY AND RESORTS LIMITED",
"VIJAYA HOSPITALS PVT LTD",
"VIJAYA INFRA PROJECT PRIVATE LIMITED",
"VIJAYA INSTITUTE OF PHARMACEUTICAL SCIENCES",
"VIJAYA INSTITUTE OF TECHNOLOGY FOR WOMEN",
"VIJAYA KRISHNA AGRO FOOD PROCESSING PRIVATE LIMITED",
"VIJAYA LAKSHMI R & B RICE TRADING COMPANY",
"VIJAYA MANOHAR INDUSTRIES PRIVATE LIMITED",
"VIJAYA MEDICAL & EDUCATIONAL TRUST",
"VIJAYA MERCANTILE PRIVATE LIMITED",
"VIJAYA MOTELS PRIVATE LIMITED",
"VIJAYA ORTHO AND TRAUMA CENTRE PRIVATE LIMITED",
"VIJAYA PATHLABS PRIVATE LIMITED",
"VIJAYA POLYMERS INDIA PRIVATE LIMITED",
"VIJAYA PRODUCTIONS PRIVATE LIMITED",
"VIJAYA RAJA RAJESHWARI CONSTRUCTIONS PRIVATE LIMITED",
"VIJAYA SAI LABORATORIES INDIA PRIVATE LIMITED",
"VIJAYA SAI POULTRIES PRIVATE LIMITED",
"VIJAYA SARADA DELINT SEED MILLS",
"VIJAYA SEAMLESS CONTAINERS PRIVATE LIMITED",
"VIJAYA SPONGE & ISPAT PRIVATE LIMITED",
"VIJAYA SRI COLD STORAGE PRIVATE LIMITED",
"VIJAYA SUPER SPECIALITY CLINIC",
"VIJAYA TEA TRADING COMPANY PRIVATE LIMITED",
"VIJAYA VITALA CHEMICALS PRIVATE LIMITED",
"VIJAYABHARATHI AUTOMOBILES PRIVATE LIMITED",
"VIJAYAKRISHNA AGRITECH PRIVATE LIMITED",
"VIJAYAKRISHNA SPICE FARMS PRIVATE. LIMITED.",
"VIJAYAKRISHNA SPICES PRIVATE LIMITED",
"VIJAYAKRISHNA STEEL PROCESSORS PRIVATE LIMITED",
"VIJAYALAKSHMI CANS PRIVATE LIMITED",
"VIJAYALAKSHMI CARGO HANDLERS PRIVATE LIMITED",
"VIJAYALAKSHMI HEALTH & SURGICALS PRIVATE LIMITED",
"VIJAYALAKSHMI HOSPITALS PRIVATE LIMITED",
"VIJAYALAKSHMI HYDRO POWER PRIVATE LIMITED",
"VIJAYALAKSHMI INFRASTRUCTURE AND LOGISTICS PRIVATE LIMITED",
"VIJAYALAKSHMI MARINE EXPORTS PRIVATE LIMITED",
"VIJAYALAKSHMI MATRICULATION HR. SEC. SCHOOL",
"VIJAYALAKSHMI R AND B RICE TRADING COMPANY",
"VIJAYALAKSHMI SPINTEX LIMITED",
"VIJAYALAXMI AGENCIES PVT LTD",
"VIJAYALAXMI AUTO ENGINEERING (HUBLI) PRIVATE LIMITED",
"VIJAYALAXMI MEMORIAL STONEBRIDGE SCHOOL",
"VIJAYALAXMI RICE MILLS PRIVATE LIMITED",
"VIJAYAMBICA PAPERS PRIVATE LIMITED",
"VIJAYANAG POLYMERS PRIVATE LIMITED",
"VIJAYANAGAR EDUCATIONAL TRUST",
"VIJAYANAGAR FERTILIZERS PRIVATE LIMITED",
"VIJAYANAGAR HATCHERIES PVT LTD",
"VIJAYANAGAR HOSPITAL",
"VIJAYANAGAR HOSPITALS PRIVATE LIMITED",
"VIJAYANAGAR INDUSTRIAL CREDITS LIMITED.",
"VIJAYANAGAR SUGAR PRIVATE LIMITED",
"VIJAYANAGARAM WHEAT PRODUCTS PRIVATE LIMITED",
"VIJAYANI NUTRACEUTICALS PRIVATE LIMITED",
"VIJAYANT AGENCIES PRIVATE LIMITED",
"VIJAYANT FACILITY SERVICES PRIVATE LIMITED",
"VIJAYANT TRAVELS PRIVATE LIMITED",
"VIJAYANTA TECHNOLOGIES PRIVATE LIMITED",
"VIJAYANTH COSMIC POWERS PRIVATE LIMITED",
"VIJAYANTH DEVELOPERS PRIVATE LIMITED",
"VIJAYAPURA TOLLWAY PRIVATE LIMITED",
"VIJAYAPURI AGROS PRIVATE LIMITED",
"VIJAYASHREE HOSPIALS",
"VIJAYASREE FOODS",
"VIJAYASREE RICE INDUSTRIES PRIVATE LIMITED",
"VIJAYASRI HOSPITALS AND INTEGRAL CARE PRIVATE LIMITED",
"VIJAYASRI ORGANICS PRIVATE LIMITED",
"VIJAYATEJ HOSPITALITY PRIVATE LIMITED",
"VIJAYAVAHINI CHARITABLE FOUNDATION",
"VIJAYAWADA BYPASS PROJECT PRIVATE LIMITED",
"VIJAYAWADA HOSPITALITIES PRIVATE LIMITED",
"VIJAYAWADA NURSING HOME AND POLY CLINIC PRIVATE LIMITED.",
"VIJAYAWADA TOLLWAY PRIVATE LIMITED",
"VIJAYDEEP HOTELS PRIVATE LIMITED",
"VIJAYDEEP MOULD ACCESSORIES PRIVATE LIMITED",
"VIJAYDHARA EXIM PRIVATE LIMITED",
"VIJAYDIMON DIAMOND (INDIA) PRIVATE LIMITED",
"VIJAYENDRA KABRA COLLEGE OF SOCIAL WORK",
"VIJAYESH KUMAR & SONS PRIVATE LIMITED",
"VIJAYESH PROJECTS PRIVATE LIMITED",
"VIJAYESWARI COTTON MILLS PRIVATE LIMITED",
"VIJAYESWARI RING TRAVELLERS PRIVATE LIMITED",
"VIJAYGIRI AUTO AGENCIES PVT LTD",
"VIJAYGROUP HOUSING PRIVATE LIMITED",
"VIJAYKANT DAIRY AND FOOD PRODUCTS LIMITED",
"VIJAYKUMAR COLD STORAGE PRIVATE LIMITED",
"VIJAYLAKSHMI COTTON GINNING & PRESSING PRIVATE LIMITED",
"VIJAYLAKSMI PRINTING WORKS PRIVATE LIMITED",
"VIJAYLAXMI EQUIPMENTS PRIVATE LIMITED",
"VIJAYLAXMI HOSPITAL AND RESEARCH CENTER",
"VIJAYLAXMI INFRA PROJECTS PRIVATE LIMITED",
"VIJAYLAXMI INFRABUILD PRIVATE LIMITED",
"VIJAYLAXMI PRIVATE LIMITED",
"VIJAYLAXMI TRANSLINK SERVICES PRIVATE LIMITED",
"VIJAYNAGAR BIOTECH LIMITED",
"VIJAYNAGAR INVESTMENTS & INFRA DEVELOPERS PRIVATE LIMITED",
"VIJAYNATH ROOF AND WALL CLADDING SYSTEMS PRIVATE LIMITED",
"VIJAYNEHA POLYMERS PRIVATE LIMITED",
"VIJAYPANDIYAN TEXTILES PRIVATE LIMITED",
"VIJAYPAT SINGHANIA SCHOOL PARDI",
"VIJAYRAJ BHARAT AVIATION & TECHNOLOGY FOUNDATION",
"VIJAYRAJA'S MINES AND MINERALS PRIVATE LIMITED",
"VIJAYRAJA'S PRECAST CONCRETE PRIVATE LIMITED",
"VIJAYRAJA'S VRIST PRIVATE LIMITED",
"VIJAYRATNA INFRACONSTRO PRIVATE LIMITED",
"VIJAY'S ENERGY INDUSTRIES(INDIA) PRIVATE LIMITED",
"VIJAYSHREE ALLOYS (PUNE) PRIVATE LIMITED",
"VIJAYSHREE AUTOCOM LIMITED",
"VIJAYSHREE AUTOCOMM LIMITED",
"VIJAYSHREE ELECTROMECH PRIVATE LIMITED",
"VIJAYSHREE FOOD PRODUCTS PRIVATE LIMITED",
"VIJAYSHREE HERITAGE VILLAGE PRIVATE LIMITED",
"VIJAYSHREE JEWELLERS PRIVATE LIMITED",
"VIJAYSHRI AGRO CHEMICALS PRIVATE LIMITED",
"VIJAYSHRI GEMS AND JEWELLERS PRIVATE LIMITED",
"VIJAYSHRI NOTE BOOKS PRIVATE LIMITED",
"VIJAYSHRI PACKAGING LIMITED",
"VIJAYSHRI STATIONERY PRODUCTS PRIVATE LIMITED",
"VIJAYSHRI TEXCOM PRIVATE LIMITED",
"VIJAYSOYA AGRO BUSINESS PRIVATE LIMITED",
"VIJAYSUBHAM BENEFIT FUND NIDHI LIMITED",
"VIJAYTECH CONSULTANTS PRIVATE LIMITED",
"VIJAYVALLABH TRADERS PRIVATE LIMITED",
"VIJAYWARGI INFRA ENGINEERS PRIVATE LIMITED",
"VIJEET FACILITY MANAGEMENT PRIVATE LIMITED",
"VIJEKA LOGISTICS PRIVATE LIMITED",
"VIJEN BIOTECH (INDIA) PRIVATE LIMITED",
"VIJET PRODUCTS PRIVATE LIMITED",
"VIJETA BEVERAGES PRIVATE LIMITED",
"VIJETA BROKING INDIA PRIVATE LIMITED",
"VIJETA PROJECTS AND INFRASTRUCTURES LIMITED",
"VIJETA STOCK AND SHARES SERVICES PRIVATE LIMITED",
"VIJETA SWITCHGEAR PVT LTD",
"VIJETA TEXFAB PRIVATE LIMITED",
"VIJETHA FARM AIDS PRIVATE LIMITED",
"VIJETHA GLOBAL POWER PRIVATE LIMITED",
"VIJETHA LABS PRIVATE LIMITED",
"VIJETHA SUPER MARKETS PRIVATE LIMITED",
"VIJEX OFFICE EQUIPMENTS PRIVATE LIMITED",
"VIJEX VYAPAAR PRIVAT LIMITED",
"VIJEY ELECTRODES AND WIRES PRIVATE LIMITED",
"VIJI FINANCE LIMITED",
"VIJI POWER TRANSFORMERS PRIVATE LIMITED",
"VIJISAN EXPORTS PRIVATE LIMITED",
"VIJISAN JEWELS PRIVATE LIMITED",
"VIJIT GLOBAL SECURITIES PRIVATE LIMITED",
"VIJIT HOSPITALITY PRIVATE LIMITED",
"VIJMOHAN CONSTRUCTIONS PRIVATE LIMITED",
"VIJNA CONSULTING ENGINEERS PRIVATE LIMITED",
"VIJNA LABS PRIVATE LIMITED",
"VIJOSH DISTRIBUTORS PRIVATE LIMITED",
"VIJSAN HOSPITALITY PRIVATE LIMITED",
"VIJSONS POLYCOAT PRIVATE LIMITED",
"VIJYASUN MULTI SPECIALITY HOSPITAL",
"VIJYOTI MANAGEMENT & COMMUNICATIONS LEARNING INSTITUTE PRIVATE LIMITED",
"VIJYOTI MEDICAL PRIVATE LIMITED",
"VIKA SHIPPING AGENCY PRIVATE LIMITED",
"VIKAA INNOVATIONS PRIVATE LIMITED",
"VIKABH SECURITIES PRIVATE LIMITED",
"VIKALP SOLUTIONS PRIVATE LIMITED",
"VIKAMSHI FABRICS PVT LTD",
"VIKANI PAINT AND CHEMICALS PRIVATE LIMITED",
"VIKARA SERVICES PRIVATE LIMITED",
"VIKARABAD PULP AND PAPER MILLS PRIVATE LIMITED.",
"VIKARSH NANO TECHNOLOGY AND ALLOYS PRIVATE LIMITED",
"VIKARTAN INFRASTRUCTURE PRIVATE LIMITED",
"VIKAS AGRO BEARING PRIVATE LIMITED",
"VIKAS AGRO EXPORTS PRIVATE LIMITED",
"VIKAS AGRO PRODUCER COMPANY LIMITED",
"VIKAS AIR SOLUTIONS PRIVATE LIMITED",
"VIKAS BALAJI MARBLE PRIVATE LIMITED",
"VIKAS BENLING PRIVATE LIMITED",
"VIKAS BHARATI PUBLIC SCHOOL",
"VIKAS BHARTI SCHOOL",
"VIKAS BRIGHT STEEL PVT LTD",
"VIKAS BUILDERS AND CONTRACTORS PRIVATE LIMITED",
"VIKAS BUILDESTATE PRIVATE LIMITED",
"VIKAS CABLES PRIVATE LTD",
"VIKAS CHAIN ANDJEWELLERY PRIVATE LIMITED",
"VIKAS COAL AND MINERALS PRIVATE LIMITED",
"VIKAS COLLEGE",
"VIKAS COLLEGE OF ARTS SCIENCE AND COMMERCE",
"VIKAS COLLEGE OF PHYSIOTHERAPY",
"VIKAS COLOUR CARTONS PRIVATE LIMITED",
"VIKAS CONCAST PRIVATE LIMITED",
"VIKAS COTEX",
"VIKAS COTTON GINNING & PRESSING",
"VIKAS COTTON INDUSTRIES PRIVATE LIMITED",
"VIKAS DEEP SALES PRIVATE LIMITED",
"VIKAS DYE-STUFF PRIVATE LIMITED",
"VIKAS ECOTECH LIMITED. FORMERLY KNOWN AS VIKAS GLOBAL ONE LIMITED.",
"VIKAS EDUCATIONAL INSTITUTION",
"VIKAS ELASTOCHEM AGENCIES PVT LTD",
"VIKAS EMARK INFRASTRUCTURE PRIVATE LIMITED",
"VIKAS FASHIONS PRIVATE LIMITED",
"VIKAS FILAMENTS PRIVATE LIMITED",
"VIKAS FOILS PRIVATE LIMITED",
"VIKAS FOOTWEAR COMPANY PRIVATE LIMITED",
"VIKAS FORGINGS PRIVATE LIMITED",
"VIKAS GEO TECHNICAL PRIVATE LIMITED",
"VIKAS HARDWARE TRADING CO PRIVATE LIMITED",
"VIKAS HIGH SCHOOL",
"VIKAS HOME FURNISHING PRIVATE LIMITED",
"VIKAS HOSPITAL",
"VIKAS HYBRID SEEDS PRIVATE LIMITED",
"VIKAS IMPEX PRIVATE LIMITED",
"VIKAS INDUSTRIES AND CHEMICALS PRIVATE LIMITED",
"VIKAS INFRA WORKS CONTRACT PRIVATE LIMITED",
"VIKAS INFRABUILD PRIVATE LIMITED",
"VIKAS INTERNATIONAL PRIVATE LIMITED",
"VIKAS JUNIOR COLLEGE",
"VIKAS LABORATIES PRIVATE LIMITED",
"VIKAS LABORATORIES PRIVATE LIMITED",
"VIKAS LATHWAL BUILDERS PRIVATE LIMITED",
"VIKAS LIFECARE LIMITED",
"VIKAS MANTRA PROPERTIES AND INFRASTRUCTURE PRIVATE LIMITED",
"VIKAS MARKCOM PRIVATE LIMITED",
"VIKAS METALS PRIVATE LIMITED",
"VIKAS MINERALS PRIVATE LIMITED",
"VIKAS MONEY LIMITED",
"VIKAS ORGANICS PRIVATE LIMITED",
"VIKAS PACKING PRODUCTS PRIVATE LIMITED",
"VIKAS PAPER FLEXO PACKAGING LIMITED",
"VIKAS PARKS PRIVATE LIMITED",
"VIKAS PENCIL MANUFACTURERS PRIVATE LIMITED",
"VIKAS PLASTOFINE PRIVATE LIMITED.",
"VIKAS PLYWOOD PRIVATE LIMITED",
"VIKAS POLYPLAST PRIVATE LIMITED",
"VIKAS POWER EQUIPMENTS PRIVATE LIMITED",
"VIKAS PROTECH PRIVATE LIMITED",
"VIKAS PU COLLEGE",
"VIKAS PUBLIC SCHOOL",
"VIKAS PUBLISHING HOUSE PRIVATE LIMITED",
"VIKAS PULSES PRIVATE LIMITED",
"VIKAS RADIATORS PRIVATE LIMITED",
"VIKAS RETAIL PRIVATE LIMITED",
"VIKAS RICE MILLS PRIVATE LIMITED",
"VIKAS ROAD CARRIERS LIMITED",
"VIKAS SCAFFOLDING PRIVATE LIMITED",
"VIKAS SEEDS PRIVATE LIMITED",
"VIKAS SHUTTERING STORE PRIVATE LIMITED",
"VIKAS SPOOL PRIVATE LIMITED",
"VIKAS STAINLESS PRIVATE LIMITED",
"VIKAS STAINLESS STEEL INDIA PRIVATE LIMITED",
"VIKAS STRIPS PRIVATE LIMITED",
"VIKAS SWEETS PRIVATE LIMITED",
"VIKAS TECH-INFRA CONS PRIVATE LIMITED",
"VIKAS TECHNOPLAST PRIVATE LIMITED",
"VIKAS TELECOM PRIVATE LIMITED",
"VIKAS THE CONCEPT SCHOOL",
"VIKAS TRENDZ PRIVATE LIMITED",
"VIKAS UPPER PRIMARY SCHOOL",
"VIKAS VIDYAMANDIR KOLHAPUR",
"VIKAS WEAVERS PRIVATE LIMITED",
"VIKASA RESOURCES PRIVATE LIMITED",
"VIKASH AGRITECHFOOD PRIVATE LIMITED",
"VIKASH ALUMINIUM EXTRUSION PRIVATE LIMITED",
"VIKASH EDUCATIONAL INSTITUTIONS",
"VIKASH FASHION CLOTHING PRIVATE LIMITED",
"VIKASH FASTNERS PVT LTD",
"VIKASH FORGE PVT.LTD.",
"VIKASH MEDICINES PRIVATE LIMITED",
"VIKASH MITUL BIRLA PAPER MILLS P LTD",
"VIKASH MULTI SPECIALITY HOSPITAL",
"VIKASH SAW CUM VENEER MILL PRIVATE LIMITED",
"VIKASH STEEL TUBE PRIVATE LIMITED",
"VIKASH STOCK BROKING SERVICES PRIVATE LIMITED",
"VIKASH TECHSEC PRIVATE LIMITED",
"VIKASH TOY CENTRE PRIVATE LIMITED",
"VIKASH VYAPAAR PRIVATE LIMITED",
"VIKASIETUM TECKNOLOGY PRIVATE LIMITED",
"VIKASVIHAR DEVELOPERS AND CONSTRUCTION PRIVATE LIMITED",
"VIKAT ALLOYS PRIVATE LIMITED",
"VIKATAN MEDIA SERVICES PRIVATE LIMITED",
"VIKATAN.COM PRIVATE LIMITED",
"VIKATMEV CONTAINERS LIMITED",
"VIKATZ SOLAR.COM (OPC) PRIVATE LIMITED",
"VIKEBIKE INDIA PRIVATE LIMITED",
"VIKEN TAPE LIMITED",
"VIKHROLI CORPORATE PARK PRIVATE LIMITED",
"VIKHYAT PROJECTS PRIVATE LIMITED",
"VIKI COMPUTECH PRIVATE LIMITED",
"VIKI INDUSTRIES PRIVATE LIMITED",
"VIKING DISTRIBUTORS PRIVATE LIMITED",
"VIKING FIRE PRODUCTS (INDIA) PRIVATE LIMITED",
"VIKING INDUSTRIES PRIVATE LIMITED",
"VIKING LIFE-SAVING EQUIPMENT MUMBAI PRIVATE LIMITED",
"VIKING NETWORK PRIVATE LIMITED",
"VIKING RESORTS PRIVATE LIMITED",
"VIKING RUBBERS PVT LTD",
"VIKING SHIPPING CHENNAI PRIVATE LIMITED",
"VIKKY'S AGRISCIENCES PRIVATE LIMITED",
"VIKMA CHEMICALS & COATINGS PVT LTD",
"VIKMANS MULTIMEDIA INDIA PRIVATE LIMITED",
"VIKRAM ADITYA AND ASSOCIATES PRIVATE LIMITED",
"VIKRAM ADVISORY SERVICES PRIVATE LIMITED",
"VIKRAM AGRITECH PRIVATE LIMITED",
"VIKRAM AGROEXTRACTS INDIA PRIVATE LIMITED",
"VIKRAM AHUJA ENTERPRISE INTERNATIONAL",
"VIKRAM ARYA BAKERS LLP",
"VIKRAM ARYA FOOD PRODUCTS PRIVATE LIMITED",
"VIKRAM BAKSHI AND COMPANY PRIVATE LIMITED",
"VIKRAM BOOK LINKS PRIVATE LIMITED",
"VIKRAM BUILDWELL PRIVATE LIMITED",
"VIKRAM CAPITAL MANAGEMENT PRIVATE LIMITED",
"VIKRAM CARPETS PRIVATE LIMITED",
"VIKRAM CHEMICALS PVT LTD",
"VIKRAM COAL CARRIERS PVT. LTD.",
"VIKRAM COILS PRIVATE LIMITED",
"VIKRAM ENGINEERS PRIVATE LIMITED",
"VIKRAM FINANCIAL SERVICES LTD",
"VIKRAM HOMES PRIVATE LIMITED",
"VIKRAM HOSPITAL BENGALURU PRIVATE LIMITED",
"VIKRAM HOSPITALBENGALURU PRIVATE LIMITED",
"VIKRAM INDUSTRIES",
"VIKRAM INFRAENGINEERING PRIVATE LIMITED",
"VIKRAM INFRATECH DEVELOPERS PRIVATE LIMITED",
"VIKRAM INTELLIGENCE SECURITY PRIVATE LIMITED",
"VIKRAM ISPAT LIMITED",
"VIKRAM LABORATORIES PRIVATE LIMITED",
"VIKRAM MILK PRODUCTS PRIVATE LIMITED",
"VIKRAM NUVOTECH INDIA PRIVATE LIMITED",
"VIKRAM OVERSEAS LIMITED",
"VIKRAM PHADNIS CLOTHING (INDIA) PRIVATE LIMITED",
"VIKRAM PHARMACEUTICALS PVT LTD",
"VIKRAM PLANTATIONS PRIVATE LIMITED",
"VIKRAM PLASTICIZERS PROP. VIN PLASTICIZERS PRIVATE. LIMITED.",
"VIKRAM POLYESTERS PRIVATE LIMITED",
"VIKRAM POWER TECHNOLOGIES PRIVATE LIMITED",
"VIKRAM PRINTERS PRIVATE LIMITED",
"VIKRAM PRIVATE LIMITED",
"VIKRAM PROENER PROJECTS PRIVATE LIMITED",
"VIKRAM PROTIENS PRIVATE LIMITED",
"VIKRAM PUBLISHERS PRIVATE LIMITED",
"VIKRAM ROLLER FLOUR MILLS LTD",
"VIKRAM SOLAR LIMITED",
"VIKRAM STRUCTURES PRIVATE. LIMITED.",
"VIKRAM SYNTEX PRIVATE LIMITED",
"VIKRAM TEA PROCESSOR PRIVATE LIMITED",
"VIKRAM TELEINFRA PRIVATE LIMITED",
"VIKRAM THERMO INDIA LIMITED",
"VIKRAM THREADS PRIVATE LIMITED",
"VIKRAM UNIVERSITY UJJAIN",
"VIKRAM URETHANE PRIVATE LIMITED",
"VIKRAM VENTURE CAPITAL PRIVATE LIMITED",
"VIKRAM VIDYALAYABRANCHGOVT OF WEST BENGAL",
"VIKRAMA SIMHAPURI UNIVERSITY",
"VIKRAMADITYA BEVERAGES & DAIRY PRODUCTS PRIVATE LIMITED",
"VIKRAMADITYA COLLEGE",
"VIKRAMADITYA MINETECH PRIVATE LIMITED",
"VIKRAMASHILA METROLOGY PRIVATE LIMITED",
"VIKRAMGEET INVESTMENTS AND HOLDINGS PRIVATE LIMITED",
"VIKRAMSHILA DEVELOPERS PRIVATE LIMITED",
"VIKRAMSILA INDUSTRIES PRIVATE LIMITED",
"VIKRAN GLOBAL INFRAPROJECTS PRIVATE LIMITED",
"VIKRANGEE SALES & SERVICES PRIVATE LIMITED",
"VIKRANT AGRO CHEM INDUSTRIES INDIA PRIVATE LIMITED",
"VIKRANT AUTO SUSPENSIONS",
"VIKRANT CHEMICO INDUSTRIES LIMITED",
"VIKRANT CHEMICO INDUSTRIES PRIVATE LIMITED",
"VIKRANT CRANES INDIA PRIVATE LIMITED",
"VIKRANT FORGE LIMITED",
"VIKRANT GROUP OF INSTITUTIONS GWALIOR",
"VIKRANT HAPPY-HOMES PVT LTD",
"VIKRANT HEAT EXCHANGERS PRIVATE LIMITED",
"VIKRANT HOLIDAYS PRIVATE LIMITED",
"VIKRANT INTERNATIONAL PRIVATE LIMITED",
"VIKRANT IRON PRIVATE LIMITED",
"VIKRANT LIFE SCIENCES PRIVATE LIMITED.",
"VIKRANT MALLEABLES PRIVATE LIMITED",
"VIKRANT MARITIME SERVICES PRIVATE LIMITED",
"VIKRANT PACKERS PVT LTD",
"VIKRANT ROPES PVT LTD",
"VIKRANT RUBBERS PRIVATE LIMITED",
"VIKRANT SAFEGUARD INDIA PRIVATE LIMITED",
"VIKRANT SPECIALITY SERVICES PRIVATE LIMITED",
"VIKRANT TRADECOM PRIVATE LIMITED",
"VIKRANTH USHA HEALTHCARE PRIVATE LIMITED",
"VIKRMA DEALERS PRIVATE LIMITED",
"VIKRMA IMPEX PVT LTD",
"VIKRUTI INFRASTRUCTURES PRIVATE LIMITED",
"VIKS GEARS (INDIA) LIMITED",
"VIK-SANDVIK DESIGN INDIA PRIVATE LIMITED",
"VIKSHA EDUSERVE PRIVATE LIMITED",
"VIKSIT LOGISTICS PRIVATE LIMITED",
"VIKSON SECURITIES PRIVATE LIMITED",
"VIKSON SPRING PRIVATE LIMITED",
"VIKUDHA HONG KONG LIMITED",
"VIKVINS CONSULTANTS PRIVATE LIMITED",
"VIKYATH PROPERTIES PRIVATE LIMITED",
"VIL MEDIA PRIVATE. LIMITED.",
"VILAKSHAN INTERIORS PRIVATE LIMITED",
"VILAS BUSINESS SOLUTIONS PRIVATE LIMITED",
"VILAS JAVDEKAR ECO HOMES",
"VILAS JAVDEKAR ECO SHELTERS PRIVATE LIMITED",
"VILAS JAVDEKAR LIFESTYLE DEVELOPERS PRIVATE LIMITED",
"VILAS POLYMER LIMITED",
"VILAS POLYMER PRIVATE LIMITED",
"VILAS SAHAKARI SAKHAR KARKHANA LTD",
"VILAS TRANSCORE LIMITED",
"VILASAAHUTA PRIVATE LIMITED",
"VILASRAO DESHMUKH FOUNDATION GROUP OF INSTITUTIONS LATUR",
"VILAVANCODE SELF RELIANCE CREDIT SERVICES NIDHI LIMITED",
"VILAX INDUSTRIAL FABRICS PRIVATE LIMITED",
"VILAYATEE COUTURE PRIVATE LIMITED",
"VILCART SOLUTIONS PRIVATE LIMITED",
"VILCO LABORATORIES PVT LTD",
"VILE PARLE MAHILA SANGH ENGLISH PRIMARY SCHOOL",
"VILIN BIO MED LIMITED",
"VILITE MULTIMEDIA PRIVATE LIMITED",
"VILLA CITY BUILDERS LLP",
"VILLA INDUSTRIES PRIVATE LIMITED",
"VILLA INTERIEUR PRIVATE LIMITED",
"VILLA THERESA HIGH SCHOOL",
"VILLA VEGAS BUILDERS PRIVATE LIMITED",
"VILLAGE FINANCIAL SERVICES PRIVATE LIMITED",
"VILLAGE PANCHAYAT DEPARTMENT",
"VILLAGE PANCHAYAT DEPARTMENT P S MIRAJ",
"VILLAMODE EXPORT (INDIA) P LTD",
"VILLEGE PANCHAYAT DEPARTMENT",
"VILLGRO FARMS PRODUCER COMPANY LIMITED",
"VILLOO POONAWALLA RACING & BREEDING PRIVATE LIMITED",
"VILLSUN LABORATORIES (INDIA) LIMITED",
"VILMOS CORPORATE SERVICES PRIVATE LIMITED",
"VILNIUS TECHNOLOGY & SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED",
"VILO APPLIANCES PRIVATE LIMITED",
"VILSON GRAPHICS INDIA PRIVATE LIMITED",
"VILSONS DISTRIBUTORS PRIVATE LIMITED",
"VILTEK LED & SOLAR SYSTEM PRIVATE LIMITED",
"VILVAH STORE PRIVATE LIMITED",
"VILVEX CABLES PRIVATE LIMITED",
"VIM DYECHEM PVT LTD",
"VIM MEDITECH PRIVATE LIMITED",
"VIM SOFT PRIVATE LIMITED",
"VIMA ALLIANCE INFRA PRIVATE LIMITED",
"VIMAAN ROBOTICS INDIA PRIVATE LIMITED",
"VI-MAC TECHNOCAST PRIVATE LIMITED",
"VIMAL AGENCIES PVT LTD",
"VIMAL AGRO PRODUCTS PRIVATE. LIMITED.",
"VIMAL ALLOYS PRIVATE LIMITED",
"VIMAL CARS PRIVATE LIMITED",
"VIMAL CHHAGANLAL JEWELLERS PRIVATE LIMITED",
"VIMAL CHROME TECH PRIVATE LIMITED",
"VIMAL COAL PRIVATE LIMITED",
"VIMAL CREATIONS PRIVATE LIMITED",
"VIMAL CROP CARE PRIVATE LIMITED",
"VIMAL DAIRY LIMITED",
"VIMAL DRUGS PRIVATE LIMITED",
"VIMAL DYES AND GAS INDUSTRIES PRIVATE LIMITED",
"VIMAL ELECTRICAL PRIVATE LIMITED",
"VIMAL EXPORTS GLOBAL LLP",
"VIMAL EXTRUSIONS PRIVATE LIMITED",
"VIMAL FACILITY SOLUTIONS PRIVATE LIMITED",
"VIMAL FASHION PRIVATE LIMITED",
"VIMAL FINSTOCK PRIVATE LIMITED",
"VIMAL FIRE AND EMERGENCY SERVICES LIMITED",
"VIMAL FIRE CONTROLS PRIVATE LIMITED",
"VIMAL FLEXSOL LIMITED",
"VIMAL FOREX INDIA PRIVATE LIMITED",
"VIMAL HI-TECH PRIVATE LIMITED",
"VIMAL HOUSING PRIVATE LIMITED",
"VIMAL INDUSTRIES PRIVATE LIMITED",
"VIMAL INNOVATIONS PRIVATE LIMITED",
"VIMAL INSULATIONS PRIVATE LIMITED",
"VIMAL INTERNATIONAL",
"VIMAL INTERTRADE PRIVATE LIMITED",
"VIMAL IRON PRIVATE LIMITED",
"VIMAL JEE JEWELLERS PRIVATE LIMITED",
"VIMAL JYOTHI ENGINEERING COLLEGE",
"VIMAL LIFE SCIENCES PRIVATE LIMITED",
"VIMAL LOGISTICS PRIVATE LIMITED",
"VIMAL MERCHANT PRIVATE LIMITED",
"VIMAL MICRONS LIMITED",
"VIMAL MOULDERS INDIA PRIVATE LIMITED",
"VIMAL NOURISHMENT TECHNOLOGIES PRIVATE LIMITED",
"VIMAL ORGANICS LIMITED",
"VIMAL OUTSOURCING SOLUTIONS PRIVATE LIMITED",
"VIMAL PAPERS PRIVATE LIMITED",
"VIMAL PERFECT MERCHANT PRIVATE LIMITED",
"VIMAL PLASTICS",
"VIMAL PLATNIUM PRIVATE LIMITED",
"VIMAL POLYESTER PRIVATE LIMITED",
"VIMAL POLYFAB PRIVATE LIMITED",
"VIMAL PROBUILD PRIVATE LIMITED",
"VIMAL PROMOTERS & DEVELOPERS PRIVATE LIMITED",
"VIMAL PROTEINS INDUSTRY (JUNAGADH) PRIVATE LIMITED",
"VIMAL PUMPS PVT LTD",
"VIMAL SAPHIRE PRIVATE LIMITED",
"VIMAL SULZ PVT.LTD.",
"VIMAL SULZCON PRIVATE LIMITED",
"VIMAL SULZTEX PRIVATE LIMITED",
"VIMAL TELECOM PRIVATE LIMITED",
"VIMAL TELEKTRONIX PRIVATE LIMITED",
"VIMAL TEX-O-FAB PRIVATE LIMITED",
"VIMAL TOP MAN TRADE PRIVATE LIMITED",
"VIMAL TROUSER LINE PRIVATE LIMITED",
"VIMALA COLLEGE",
"VIMALA FEEDS PRIVATE LIMITED",
"VIMALA MATRIC HR SEC SCHOOL",
"VIMALA VALUE MATERIALS PRIVATE LIMITED",
"VIMALACHAL PRINT AND PACK PVT LTD",
"VIMALNATH CHEM PVT LTD",
"VIMALOXY TEXOFINE PRIVATE LIMITED",
"VIMALSCOP TEXOPRINTS PRIVATE LIMITED",
"VIMAN HOSPITALITY AND ENTERTAINMENT PRIVATE LIMITED",
"VIMAN MULTIPLUG PRIVATE LIMITED",
"VIMARSH DEVELOPEMENT SOLUTIONS PRIVATE LIMITED",
"VIMAX CROP SCIENCE LIMITED",
"VIMAX TECHNOCAST PRIVATE LIMITED",
"VIMBRI MEDIA PRIVATE LIMITED",
"VIMBRI TRADERS PRIVATE LIMITED",
"VIMCO MOTORS PRIVATE LIMITED",
"VIMCO ROLLS PRIVATE LIMITED",
"VIMERSE INFOTECH INDIA PRIVATE LIMITED",
"VIMGI INVESTMENTS PRIVATE LIMITED",
"VIMIT METALS AND INFRASTRUCTURE PRIVATE LIMITED",
"VIMKAR CONTRACTS WORK LLP",
"VIMLA DUPATTA PRIVATE LIMITED",
"VIMLA FUELS & METALS LIMITED",
"VIMLA INFRASTRUCTURE INDIA PRIVATE LIMITED",
"VIMLA IRON & STEEL WORKS PVT LTD",
"VIMLA SHELTERS PRIVATE LIMITED",
"VIMLANGI PROJECTS PRIVATE LIMITED",
"VIMLESH INDUSTRIES PRIVATE LIMITED",
"VIMLESH INVESTMENTS PRIVATE LIMITED",
"VIMLON DYEING AND PRINTING MILLS PVT LTD",
"VIMMI IMPEX PRIVATE LIMITED",
"VIMO FOODS PRIVATE LIMITED",
"VIMO SOFTWARE DEVELOPMENT PRIVATE LIMITED",
"VIMOKAS CONSULTANTSAND ENGINEERSPRIVATE LIMITED",
"VIMOKSHA BEVERAGE SOLUTIONS PRIVATE LIMITED",
"VIMOS TECHNOCRATS PRIVATE LIMITED",
"VIMSHUBH INDUSTRIES INDIA PRIVATE LIMITED",
"VIMSON OPTICS PRIVATE LIMITED",
"VIMTA LABS LIMITED",
"VIMTRA VENTURES PRIVATE LIMITED",
"VIMUKHT JATI WA BHATKYA JAMATINCHI MULA MULINCHI PRATHAMIK ASHARAM SHALA UDANE TA DHULE",
"VIMUKTI TECHNOLOGIES PRIVATE LIMITED",
"VIN AUTO",
"VIN BIOTECH SYSTEMS PRIVATE LIMITED",
"VIN DIP INDIA PRIVATE LIMITED",
"VIN GRACE SOLUTIONS PRIVATE LIMITED",
"VIN INDUSTRIES PRIVATE LIMITED",
"VIN MANAGEMENT CONSULTANT PRIVATE LIMITED",
"VIN MEDICAMENT PRIVATE LIMITED",
"VIN PETROCHEM PRIVATE LIMITED",
"VIN PLASTICIZERS PRIVATE LIMITED",
"VIN POLY TECHNOLOGIES PRIVATE LIMITED",
"VIN PRECISE PUNCH PRIVATE LIMITED",
"VINA ELECTRICALS PRIVATE LIMITED",
"VINA INTERNATIONAL PRIVATE LIMITED",
"VINA POLYMERS PRIVATE LIMITED",
"VINADITH CORPORATION PRIVATE LIMITED",
"VINAIR SYSTEMS PRIVATE LIMITED",
"VINALS PRECISION PRIVATE LIMITED",
"VINAM ENTERPRISES OPC PRIVATE LIMITED",
"VINAM FINANCE PRIVATE LIMITED",
"VINAM INVESTMENT PVT. LTD.",
"VINAMAX ORGANICS PRIVATE LIMITED",
"VINAMRA HEALTHCARE LLP",
"VINAMRA PROPERTIES PRIVATE LIMITED",
"VINAMRATA CREATION",
"VINAR INTEGRATION LIMITED",
"VINAR INTERNATIONAL PRIVATE LIMITED",
"VINAR SYSTEMS PRIVATE LIMITED",
"VINASO INFOTECH AND LEASING PRIVATE LIMITED",
"VINATI JEWELLERS PRIVATE LIMITED",
"VINATI ORGANICS LIMITED",
"VINATIA ENTERPRISES INDIA PRIVATE LIMITED",
"VINAY AND KESHAVA LLP",
"VINAY ASSOCIATES DISTRIBUTORS PRIVATE LIMITED",
"VINAY AUTO TECH PRIVATE LIMITED",
"VINAY ENTERPRISES",
"VINAY HARI EDUCATION CONSULTANTS PRIVATE LIMITED",
"VINAY HOLDINGS PVT.LTD.",
"VINAY HOMES PRIVATE LIMITED",
"VINAY INDUSTRIES LIMITED",
"VINAY INFRATECH PRIVATE LIMITED",
"VINAY LABEL PRIVATE LIMITED",
"VINAY MARBLES PVT. LTD.",
"VINAY POULTRY FARM PRIVATE LIMITED",
"VINAY PUMPS (INDIA) PRIVATE LIMITED",
"VINAY ROADLINES PVT LTD",
"VINAY SIL-COS PRIVATE LIMITED",
"VINAY TRANSPORT PRIVATE LIMITED",
"VINAYAGA MARINE PETRO LIMITED",
"VINAYAGAR PROMOTERS AND BUILDERS",
"VINAYAK AUTOLINK PRIVATE LIMITED",
"VINAYAK AUTOMOTIVE PRIVATE LIMITED",
"VINAYAK AUTOTRADE PRIVATE LIMITED",
"VINAYAK BAKERY & FOOD PRODUCTS PRIVATE LIMITED",
"VINAYAK BOARD & PAPER PRIVATE LIMITED",
"VINAYAK BULK CARRIER",
"VINAYAK BULK MOVERS PRIVATE LIMITED",
"VINAYAK BUSINESS PVT LTD",
"VINAYAK CARGOMOVERS PRIVATE LIMITED",
"VINAYAK CARS PRIVATE LIMITED",
"VINAYAK CHANNEL MANUFACTURERS PRIVATE LIMITED",
"VINAYAK CLOTHINGS PRIVATE LIMITED",
"VINAYAK COMM.& TECH EQUIP CORPORATION",
"VINAYAK CONES PRIVATE LIMITED",
"VINAYAK CONSUMER PRODUCTS PRIVATE LIMITED",
"VINAYAK COTTON",
"VINAYAK CREATION`S PRIVATE LIMITED",
"VINAYAK DIAMOND TOOLS PRIVATE LIMITED",
"VINAYAK ELECTROMECH PRIVATE LIMITED",
"VINAYAK EMPORIUM PRIVATE LIMITED",
"VINAYAK FACILITY MANAGEMENT PRIVATE LIMITED",
"VINAYAK FLOUR MILLS PRIVATE LIMITED",
"VINAYAK FOUNDERS PVT.LTD.",
"VINAYAK GINNING PRESSING PRIVATE. LIMITED.",
"VINAYAK GYPSUM AND INTERIORS PRIVATE LIMITED",
"VINAYAK HOSPITAL",
"VINAYAK HOSPITALITY PRIVATE LIMITED",
"VINAYAK IMPEX",
"VINAYAK INFRA SIGNS & PROJECTS PRIVATE LIMITED",
"VINAYAK INGREDIENTS INDIA PRIVATE LIMITED",
"VINAYAK INTERNATIONAL HOUSEWARES PRIVATE LIMITED",
"VINAYAK INTERNATIONAL SCHOOL",
"VINAYAK JEWELLERS AND GEMSTONES PRIVATE LIMITED",
"VINAYAK JEWELS INDIA PRIVATE LIMITED",
"VINAYAK JUNCTION PRIVATE LIMITED",
"VINAYAK JUNIOR COLLEGE M C V C KHADAKPURA PETH BEED",
"VINAYAK LASER TECH PRIVATE LIMITED",
"VINAYAK LEAF PRIVATE LIMITED",
"VINAYAK MANUFACTURERS PRIVATE LIMITED",
"VINAYAK MANUTRADE PRIVATE LIMITED",
"VINAYAK MARINE SERVICES PRIVATE LIMITED",
"VINAYAK MARKETING CONSULTANT PRIVATE LIMITED",
"VINAYAK METASTEEL PRIVATE LIMITED",
"VINAYAK MINERALS",
"VINAYAK NIRMAN PRIVATE LIMITED",
"VINAYAK OIL & FATS PRIVATE LIMITED",
"VINAYAK ORGANICS PVT LTD",
"VINAYAK PIPES AND TUBES PRIVATE LIMITED",
"VINAYAK PLANTATION PRIVATE LIMITED",
"VINAYAK POLYALLOYS PRIVATE LIMITED",
"VINAYAK POLYCON INTERNATIONAL LIMITED",
"VINAYAK POLYPIPES PRIVATE LIMITED",
"VINAYAK POLYVENTURES PRIVATE LIMITED",
"VINAYAK PRATISTHAN PRIVATE LIMITED",
"VINAYAK PREMISES PVT LTD",
"VINAYAK PRINTER PVT. LTD.",
"VINAYAK PRODUCTS PRIVATE LIMITED",
"VINAYAK PUBLIC SCHOOL GARAULI KALAN GURUGRAM",
"VINAYAK PUMPS INDIA PRIVATE LIMITED",
"VINAYAK RAIL TRACK (INDIA) PRIVATE LIMITED",
"VINAYAK REMEDIES LIMITED",
"VINAYAK ROADLINES PRIVATE LIMITED",
"VINAYAK SOLUTIONS PRIVATE LIMITED",
"VINAYAK STEELS LIMITED",
"VINAYAK SUPPORT SERVICES PRIVATE LIMITED",
"VINAYAK TECHNOLOGIES PRIVATE LIMITED",
"VINAYAK TMT BARS PRIVATE LIMITED",
"VINAYAK TRANSCO PRIVATE LIMITED",
"VINAYAK TRAVELS",
"VINAYAK ULTRAFLEX PRIVATE LIMITED",
"VINAYAK VASTRA PRIVATE LIMITED",
"VINAYAK VIDEO VISION PRIVATE LIMITED",
"VINAYAK VIHAR PRIVATE LIMITED",
"VINAYAK WIRE PRODUCTS PRIVATE LIMITED",
"VINAYAKA AGRO INDUSTRIES",
"VINAYAKA BRIGHT STEELS PRIVATE LIMITED",
"VINAYAKA CAPSEC PRIVATE LIMITED",
"VINAYAKA CHEMTRADE PRIVATE LIMITED",
"VINAYAKA CNC CENTRE PRIVATE LIMITED",
"VINAYAKA COLLEGE OF PHARMACY",
"VINAYAKA CONTINUOUS STATIONERY PRIVATE LIMITED",
"VINAYAKA COTTON MILLS PRIVATE LIMITED",
"VINAYAKA ELECTRO ALLOYS I PRIVATE LIMITED",
"VINAYAKA EXPO PLAZA PRIVATE LIMITED",
"VINAYAKA GLOBAL SERVICES PRIVATE LIMITED",
"VINAYAKA INDUSTRIES",
"VINAYAKA MICRONS INDIA PRIVATE LIMITED",
"VINAYAKA MISSION HOSPITAL",
"VINAYAKA MISSION SUPER SPECIALITY HOSPITALS PRIVATE LIMITED",
"VINAYAKA MISSION UNIVERSITY",
"VINAYAKA MISSIONS RESEARCH FOUNDATION",
"VINAYAKA MOTOR PRIVATE LIMITED",
"VINAYAKA REALTY (GUJARAT) PRIVATE LIMITED",
"VINAYAKA ROCKS PRIVATE LIMITED",
"VINAYAKA SEEDS PRIVATE LIMITED",
"VINAYAKA SHOPPING COMPLEX PRIVATE LIMITED",
"VINAYAKA SHOT PRIVATE LIMITED",
"VINAYAKAM EQUIPMENTS PRIVATE LIMITED",
"VINAYAKAM FASHIONHUT PRIVATE LIMITED",
"VINAYAKAM POLYMERS INDIA PRIVATE LIMITED",
"VINAYAKKRIPA BUILDWELL PRIVATE LIMITED",
"VINAYAKKRIPA REALTORS PRIVATE LIMITED",
"VINAYAKSHAKTI POWERTECH PRIVATE LIMITED",
"VINAYAN (INDIA) CONSULTING AND SERVICES PRIVATE LIMITED",
"VINAYANA INVESTMENT AND FINANCE LIMITED",
"VINAYIKA AQUA PRIVATE LIMITED",
"VINAYLENE TEXTILE INDUSTRIEES PVT LTD",
"VINAYSHREE METAL INDUSTRIES",
"VINAYVISHAL HEALTH CARE PRIVATE LIMITED",
"VINBOX MARTECH PRIVATE LIMITED",
"VINCA CYBERTECH PRIVATE LIMITED",
"VINCA DEVELOPER PRIVATE LIMITED",
"VINCA REALTORS PRIVATE LIMITED",
"VINCA SERVICES PRIVATE LIMITED",
"VINCCENT BIOTECH PRIVATE LIMITED",
"VINCE SOFTWARE INDIA PRIVATE LIMITED",
"VINCELL STUDIOS PRIVATE LIMITED",
"VINCENT (INDIA) LIMITED",
"VINCENT DE PAUL PRIMARY SCHOOL",
"VINCENT EDUKARE PRIVATE LIMITED VIBGYOR GROUP ENTITY",
"VINCENT EDUTECH PRIVATE LIMITED",
"VINCENT TRADING PRIVATE LIMITED",
"VINCENT VIBES PRIVATE LIMITED",
"VINCHEM INDUSTRIES PRIVATE LIMITED",
"VINCHIP SYSTEMS PRIVATE LIMITED",
"VINCHURKAR DIAGNOSTICS PRIVATE LIMITED",
"VINCHURKAR PAWAR DIAGNOSTIC CENTRE PRIVATE LIMITED",
"VINCI GLOBAL PRIVATE LIMITED",
"VINCI TECHNOLOGIES LIMITED",
"VINCITORE TEXTILES PRIVATE LIMITED",
"VINCLEY ESTATES PRIVATE LIMITED",
"VINCLIS TECHNOLOGIES PRIVATE LIMITED",
"VINCO RESOURCES PRIVATE LIMITED",
"VINCO SALES AND SERVICES PRIVATE LIMITED",
"VINCOM COST MANAGEMENT PRIVATE LIMITED",
"VINCOPLAS PRIVATE LIMITED",
"VINDA ONLINE MATERIAL PRIVATE LIMITED",
"VINDARVIND HYGINE PRODUCTS PVT LTD",
"VINDAS CHEMICAL INDUSTRIES PRIVATE LIMITED",
"VINDECA LIFE SCIENCES PRIVATE LIMITED",
"VINDESHWARI EXIM PRIVATE LIMITED",
"VINDHYA BOARDS PVT LTD",
"VINDHYA CARPETS LTD",
"VINDHYA E-INFO MEDIA PRIVATE LIMITED",
"VINDHYA ERECTORS PRIVATE LIMITED",
"VINDHYA ORGANICS PRIVATE LIMITED",
"VINDHYA PHARMA (INDIA) PRIVATE LIMITED",
"VINDHYA SHAKTI INFRAPROJECTS PRIVATE LIMITED",
"VINDHYA SHIKSHA SAMITHI",
"VINDHYA SPINNING MILLS PRIVATE LIMITED",
"VINDHYA TELELINKS LIMITED",
"VINDHYACHAL BUILDWELL LIMITED",
"VINDHYACHAL CROP PRODUCER COMPANY LIMITED",
"VINDHYACHAL DISTILLERIES PRIVATE LIMITED",
"VINDHYACHAL EXPRESSWAY PRIVATE LIMITED",
"VINDHYACHAL HYDRO POWER PRIVATE LIMITED",
"VINDHYACHAL INFRA PROJECT PRIVATE LIMITED",
"VINDHYACHAL OXYGEN PRIVATE LIMITED",
"VINDHYACHAL PAINTS & CHEMICALS PVT LTD",
"VINDHYANCHAL CROP PRODUCER COMPANY LIMITED",
"VINDHYANCHAL FINLEASE PRIVATE LIMITED",
"VINDHYANCHAL KRISHI UTPADAK PRODUCER COMPANY LIMITED",
"VINDHYANCHAL RESORTS PRIVATE LIMITED",
"VINDHYAVASINI AUTOMOBILES PRIVATE LIMITED",
"VINDHYAVASINI ENTERPRISES PRIVATE LIMITED",
"VINDHYAVASINISHAKTI RICE & AGRO INDUSTRIES PRIVATE LIMITED",
"VINDHYAWASHINI MARINE SERVICES PRIVATE LIMITED",
"VINDHYAWASINI FERRO ALLOYS PRIVATE LIMITED",
"VINDHYAWASINI SALES PRIVATE LIMITED",
"VINDI VAK PUMP PVT LTD",
"VINDISH INSTRUMENTS PRIVATE LIMITED",
"VINE2WINE RETAIL PRIVATE LIMITED",
"VINEENGINEER ENTERPRISES PRIVATE LIMITED",
"VINEET AUTOMOBILES PRIVATE LIMITED",
"VINEET CHEM TRADE PRIVATE LIMITED",
"VINEET COTEX PVT LTD",
"VINEET FURNISHINGS PRIVATE LIMITED",
"VINEET LABORATORIES LIMITED",
"VINEET LIFE SCIENCES PRIVATE LIMITED",
"VINEET PLASTIC INDUSTRIES PRIVATE LIMITED",
"VINEET PLASTICS LIMITED",
"VINEET PLYWOOD PRIVATE LIMITED",
"VINEET POLYFAB PRIVATE LIMITED",
"VINEET PVT LTD",
"VINEET QUALITY PRODUCTS PRIVATE LIMITED",
"VINEET SINGH CONSTRUCTION COMPANY PRIVATE LIMITED",
"VINEET SYNTHETICS PVT LTD",
"VINEET UDYOG LTD",
"VINEETA B. ENTERPRISE PRIVATE LIMITED",
"VINEETH PRECIOUS CATALYSTS PVT LTD",
"VINEETPOWER TRANSFORMER AND SWITCHGEAR PRIVATE LIMITED",
"VINEIL HITEK TOOLING COMPANY PRIVATE LIMITED",
"VINEX ENTERPRISES PRIVATE LIMITED",
"VINEY CORPORATION PRIVATE LIMITED",
"VINEY GEMS AND JEWELLERY LIMITED",
"VINEY KNITWEARS PRIVATE LIMITED",
"VINFAB ENGINEERS INDIA PRIVATE LIMITED",
"VINFINET TECHNOLOGIES PRIVATE LIMITED",
"VINFINITY BRIGHT PRIVATE LIMITED",
"VINFORMAX DIMENSIONS TECHNOLOGY PRIVATE LIMITED",
"VINFORMAX TECHNOLOGY SYSTEMS PRIVATE LIMITED",
"VINGAS INDUSTRIES PRIVATE LIMITED",
"VINGLOB GREENTECH (I) PRIVATE LIMITED",
"VINHEET TECHNOLOGIES PRIVATE LIMITED",
"VINI COSMETICS PRIVATE LIMITED",
"VINI FABRICS MARKETING PRIVATE LIMITED",
"VINI REALITIES PRIVATE LIMITED",
"VINICOLA PRIVATE LIMITED",
"VINIFINE TEXTILE MILLS PRIVATE LIMITED",
"VINILOK SOLUTIONS PRIVATE LIMITED",
"VINIMAY DEVELOPERS PRIVATE LIMITED",
"VININDUX IMPEX PRIVATE LIMITED",
"VINIPRO ENGINEERS LLP",
"VINIR ENGINEERING PRIVATE LIMITED",
"VINIRRMAA PROJECTS PRIVATE LIMITED",
"VINIS PRODUCTS PRIVATE LIMITED",
"VINIS RETAIL INDIA PRIVATE. LIMITED.",
"VINISA E. I. PRIVATE LIMITED",
"VINISH HEALTHCARE AND MULTI SERVICES PRIVATE LIMITED",
"VINISHMA TECHNOLOGIES PRIVATE LIMITED",
"VINISTA BIOSCIENCES PRIVATE LIMITED",
"VINIT CONSULTING SERVICES PRIVATE LIMITED",
"VINIT FABRICS PRIVATE LIMITED",
"VINIT GLOVES MANUFACTURING PRIVATE LIMITED",
"VINIT KNITTINGS PRIVATE. LIMITED.",
"VINIT MACHINES PRIVATE LIMITED",
"VINIT PERFORMANCE POLYMERS PVT LTD",
"VINIT YARN DYEING PRIVATE LIMITED",
"VINITA INTERNATIONAL",
"VINITA METAL PRIVATE LIMITED",
"VINITA SYNTHETIC INDUSTRIES PVT LTD",
"VINITECH METAL PRIVATE LIMITED",
"VINJAY ASSOCIATES PRIVATE LIMITED",
"VINJOH HEALTHCARE PRIVATE LIMITED",
"VINKAS ESTATES PRIVATE LIMITED",
"VINKAY AUTO PRIVATE LIMITED",
"VINKAY TEXTILES PRIVATE LIMITED",
"VINKO AUTO INDUSTRIES LIMITED",
"VINKY INDUSTRIS PRIVATE LIMITED",
"VINLAND PEARL SPIRITS PRIVATE LIMITED",
"VINLINE ENGINEERING PVT LTD",
"VINMAN ENGINEERING PRIVATE LIMITED",
"VINMAR BUSINESS SERVICES PRIVATE LIMITED",
"VINMAR BUSINESS SOLUTION PRIVATE LIMITED",
"VINMAR INDIA PRIVATE LIMITED",
"VINMEHTA FILMS PRIVATE LIMITED",
"VINMIR RESOURCES PRIVATE LIMITED",
"VINN HEALTHCARE PRIVATE LIMITED",
"VINNAV INFRATECK PRIVATE LIMITED",
"VINNDHYA CIRCUIT PROCESSORS PRIVATE LIMITED",
"VINNER LABS PRIVATE LIMITED",
"VINNI CHEMICALS PRIVATE LIMITED",
"VINNIE NUTWORLD PRIVATE LIMITED",
"VINNOVATIVE ENGINEERING PRIVATE LIMITED",
"VINNTAGE POLYMERS PRIVATE LIMITED",
"VINNY HEALTH CARE PRIVATE LIMITED",
"VINNY OVERSEAS LIMITED",
"VINNY TEXTILES PVT LTD",
"VINNYS RESTAURANT PRIVATE LIMITED",
"VINO TRADING PRIVATE LIMITED",
"VINOBA BHAVE UNIVERSITY HAZARIBAG",
"VINOD AGARWAL & CO. PRIVATE LIMITED",
"VINOD CHEMICALS PRIVATE LIMITED",
"VINOD COOL STORES PRIVATE LIMITED",
"VINOD COTFAB PRIVATE LIMITED",
"VINOD DISTRIBUTORS PRIVATE LIMITED",
"VINOD FABRICS PVT LTD",
"VINOD FOODS PRIVATE LIMITED",
"VINOD FRESHNERS PRIVATE LIMITED",
"VINOD H PATEL",
"VINOD INDUSTRIES PRIVATE LIMITED",
"VINOD INFOTECH PVT LTD",
"VINOD INTERNATIONAL LIMITED",
"VINOD ISPAT PRIVATE LIMITED",
"VINOD KHANAN PRIVATE LIMITED",
"VINOD KUMAR AND BROTHERS PVT LTD",
"VINOD KUMAR JAIN",
"VINOD KUMAR SHUKLA CONSTRUCTIONS PRIVATE LIMITED",
"VINOD MARBLES PVT. LTD.",
"VINOD MEDICAL SYSTEMS PRIVATE LIMITED",
"VINOD MERCANTILE PRIVATE LIMITED",
"VINOD MOTORS",
"VINOD MULTIFOOD PRODUCTS PRIVATE LIMITED",
"VINOD MUTNEJA CONSULTANTS PRIVATE LIMITED",
"VINOD PUBLICATIONS PRIVATE LIMITED",
"VINOD RICE MILL PRIVATE LIMITED",
"VINOD ROADLINES PRIVATE LIMITED",
"VINOD SALT WORKS PRIVATE LIMITED",
"VINOD SHUKLA HIGH SCHOOL",
"VINOD SNACKS & CONFECTIONERS PRIVATE LIMITED",
"VINOD SPINNERS PRIVATE LIMITED",
"VINOD STEELS TRADING PRIVATE LIMITED",
"VINOD TEXWORLD PRIVATE LIMITED",
"VINOD UDYOG PRIVATE LIMITED.",
"VINODHAGAN MEMORIAL HOSPITAL PRIVATE LIMITED",
"VINODHEDA TEXTILE PRIVATE LIMITED",
"VINODRAI ENGINEERS PRIVATE LIMITED",
"VINOLYA SERVICES PRIVATE LIMITED",
"VINOOTHANA ELECTRO CONTROL SYSTEMS PRIVATE LIMITED",
"VINORA INDUSTRIES",
"VINOSHA TRADE PRIVATE LIMITED",
"VINOTH BUILDERS",
"VINOTH FEEDS AND POULTRY PRIVATE LIMITED",
"VINOVE SOFTWARE AND SERVICES PRIVATE LIMITED",
"VINOX INDIA PRIVATE LIMITED",
"VINOZA COMMERCIAL TRADE PRIVATE LIMITED",
"VINP INFRA PROJECTS PRIVATE LIMITED",
"VINPA EXPORTS PRIVATE LIMITED",
"VINPACK (INDIA) PRIVATE LIMITED",
"VINPAK MACHINES PRIVATE LIMITED",
"VINPAR SOFTECH PRIVATE LIMITED",
"VINPLA PLATING PRIVATE LIMITED",
"VINPLEX INDIA PRIVATE LIMITED",
"VINRA ESTATES & INFRASTRUCTURE PRIVATE LIMITED",
"VINRAJ STEELS PRIVATE LIMITED",
"VINRAK TECHNOLOGIES PRIVATE LIMITED",
"VINS BIOPRODUCTS LIMITED",
"VIN'S FRESH PRIVATE LIMITED",
"VINS HOSPITAL PRIVATE LIMITED",
"VINS INTERNATIONAL PRIVATE LIMITED",
"VINSA CHEMICALS PRIVATE LIMITED",
"VINSA PHARMACEUTICALS PRIVATE LIMITED",
"VINSAK INDIA PRIVATE LIMITED",
"VINSAN COMMERCIAL PRODUCTS PRIVATE LIMITED",
"VINSAN CREDIT AND SECURITIES LIMITED.",
"VINSAN INFRAPROJECTS PRIVATE LIMITED",
"VINSHA MACHINES PVT LTD",
"VINSHEK PRIVATE LIMITED",
"VINSHINE SALES PRIVATE LIMITED",
"VINSHUBH EXPORTS PRIVATE LIMITED",
"VINSINFO PRIVATE LIMITED",
"VINSM GLOBE PRIVATE LIMITED",
"VINSOL (HUBLI) ENERGY PRIVATE LIMITED",
"VINSON ECO-ENERGY INDIA PRIVATE LIMITED",
"VINSON LOGISTICS PRIVATE LIMITED",
"VINSON MASSIF HEALTHCARE PRIVATE LIMITED",
"VINSPRI DISTRIBUTORS PRIVATE LIMITED",
"VINSUL MAKARDI LIMITED",
"VINSUM AXPRESS INDIA PRIVATE LIMITED",
"VINSUN INFRA ENGINEERING PRIVATE LIMITED",
"VINSURE ENERGY INDIA PRIVATE LIMITED",
"VINSYS IT SERVICES INDIA LIMITED",
"VINSYS IT SERVICES INDIA PRIVATE LIMITED",
"VINTAGE AGRO FOODS PRIVATE LIMITED",
"VINTAGE BLUE GARMENTS PRIVATE LIMITED",
"VINTAGE COFFEE AND BEVERAGES LIMITED",
"VINTAGE COFFEE PRIVATE LIMITED",
"VINTAGE CREDIT AND LEASING PRIVATE LIMITED",
"VINTAGE DISTILLERS LIMITED",
"VINTAGE FACILITY MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"VINTAGE HOME FASHIONS",
"VINTAGE INTEGRATED LOGISTICS SERVICES PRIVATE LIMITED",
"VINTAGE LABS PRIVATE LIMITED",
"VINTAGE NIRMAN PRIVATE LIMITED",
"VINTAGE RETAIL PRIVATE LIMITED",
"VINTAGE TILES PRIVATE LIMITED",
"VINTAR RESEARCH LABORATORIES PRIVATE LIMITED",
"VINTECH BUSINESS SOLUTIONS PRIVATE LIMITED",
"VINTECH ELECTRONIC SYSTEMS PRIVATE LIMITED",
"VINTECH FLUXO PRIVATE LIMITED",
"VINTECH INDUSTRIES PRIVATE LIMITED",
"VINTECH INTERIORS PRIVATE LIMITED",
"VINTECH INTERNATIONAL PRIVATE LIMITED",
"VINTECH POLYMERS PRIVATE LIMITED",
"VINTEK CASTINGS PRIVATE LIMITED",
"VINTEK CHEMICAL PRODUCTS PRIVATE LIMITED",
"VINTEK CIRCUITS (INDIA) PRIVATE LIMITED",
"VINTERLA LOGISTICS PRIVATE LIMITED",
"VINTEX FIRE PROTECTION PRIVATE LIMITED",
"VINTEX TOOLS PRIVATE LIMITED",
"VINTRANS AND CONSTRUCTIONS PRIVATE LIMITED",
"VINTROL LUBES PRIVATE LIMITED",
"VINTRON CONVERGYS LIMITED",
"VINTRON SMARTVISION PRIVATE LIMITED",
"VINTY IMPEX PRIVATE LIMITED",
"VINUBHAI STEEL COMPANY PRIVATE LIMITED",
"VINUM TRADERS PRIVATE LIMITED",
"VINURA GLASS PRIVATE LIMITED",
"VINUTHANA CHEM TECH PRIVATE LIMITED",
"VINVISH TECHNOLOGIES PRIVATE LIMITED",
"VINVIV HOLDINGS AND TRADING COMPNAY PVT LTD",
"VINWORLD HEALTHCARE PRIVATE LIMITED",
"VINWORTH ELETECH PRIVATE LIMITED",
"VINWORTH STEEL PRIVATE LIMITED",
"VINYAAS PROJECT PRIVATE LIMITED",
"VINYAS INNOVATIVE TECHNOLOGIES PRIVATE LIMITED",
"VINYAS MECHANICAL ENGINEERING PRIVATE LIMITED",
"VINYASA AUTOMATION SYSTEMS PRIVATE LIMITED",
"VINYASA ENGINEERS PRIVATE LIMITED",
"VINYL CHEMICALS INDIA LIMITED",
"VINYL CHEMICALS LIMITED",
"VINYL PACKS PRIVATE LIMITED",
"VINYL TUBES PRIVATE LIMITED",
"VINYL TUBOS PRIVATE LIMITED",
"VINYOFLEX LIMITED",
"VINYTICS PERIPHERALS PRIVATE LIMITED",
"VINZ AGRII TEK PRIVATE LIMITED",
"VINZAI CHEMICAL INDUSTRIES PRIVATE LIMITED",
"VINZAS SOLUTIONS INDIA PRIVATE LIMITED",
"VINZILLION EDIBLES PRIVATE LIMITED",
"VIOLA DECORATIVES PRIVATE LIMITED",
"VIOLA RESORTS PRIVATE LIMITED",
"VIOLA SERVICES INDIA PRIVATE LIMITED",
"VIOLET AND PURPLE FASHION JEWELLERY PRIVATE LIMITED",
"VIOLET GREEN POWER PRIVATE LIMITED",
"VIOLET INFOSYSTEMS PRIVATE LIMITED",
"VIOLET JEWELS PRIVATE LIMITED",
"VIOLETFLAME INFO SYSTEMS PRIVATE LIMITED",
"VIOLETTE REMEDIES PRIVATE LIMITED",
"VIOLIN TECHNOLOGIES PRIVATE LIMITED",
"VIOM NETWORKS LIMITED",
"VIOMA LIFESCIENCES PRIVATE LIMITED",
"VIOMSHI TEXTILES PRIVATE LIMITED",
"VION CONSULTING PRIVATE LIMITED",
"VION PLASTICS PRIVATE LIMITED",
"VIOTONIC FEEDS PRIVATE LIMITED",
"VIOWN METTUBE PRIVATE LIMITED",
"VIP APEX MEDICAL CENTRE PRIVATE LIMITED",
"VIP CHEMICALS PVT LTD",
"VIP CLOTHING LIMITED",
"VIP CONVEYORS PRIVATE LIMITED",
"VIP DENTAL LAB PRIVATE LIMITED",
"VIP DISTRIBUTORS PRIVATE LIMITED",
"VIP ENTERPRISE",
"VIP ENTERPRISE PRIVATE LIMITED",
"VIP INDUSTRIES LIMITED",
"VIP INFRACONSTRUCTION AND OUTDOOR SERVICES PRIVATE LIMITED",
"VIP MANAGEMENT SERVICES PRIVATE LIMITED",
"VIP PHARMACEUTICALS PRIVATE LIMITED",
"VIP SWEETS PRIVATE LIMITED",
"VIP TRANS LOGISTICS PRIVATE LIMITED",
"VIP VALVES (INDIA) PRIVATE LIMITED",
"VIPA AUTOMATION INDIA PRIVATE LIMITED",
"VIPADM SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"VIPALA FOOD PRODUCTS PRIVATE LIMITED",
"VIPANA RETAIL PRIVATE LIMITED",
"VIPANY MANAGEMENT CONSULTING PRIVATE LIMITED",
"VIPASSANA INFRASTRUCTURES PRIVATE LIMITED",
"VIPATRA TECHNOLOGIES PRIVATE LIMITED",
"VIPCO MARINE PRIVATE LIMITED",
"VIPIN CLOTHING PRIVATE LIMITED",
"VIPIN KUMAR SINGH INFRATECH PRIVATE LIMITED",
"VIPIN MILK CHILLING PRIVATE LIMITED",
"VIPIN MOTORS PVT LTD",
"VIPIN PACKAGING PRIVATE LIMITED",
"VIPIN PRINT SERVICES PRIVATE LIMITED",
"VIPIN S.T. POLES PRIVATE LIMITED",
"VIPLA FOUNDATION",
"VIPLAV CRYO ENGINEERING PRIVATE LIMITED",
"VIPLUS PHARMACEUTICALS PRIVATE LIMITED",
"VIPOR CHEMICALS PRIVATE LIMITED",
"VIPPY INDUSTRIES LIMITED",
"VIPPY SPIN PRO LIMITED",
"VIPRA AUTO CARE PRIVATE LIMITED",
"VIPRA BUSINESS CONSULTING SERVICES PRIVATE LIMITED",
"VIPRA CLOSURES PRIVATE LIMITED",
"VIPRA FERRO ALLOYS PRIVATE LIMITED",
"VIPRA INKS & POLYMERS",
"VIPRA MACHINE TOOLS PRIVATE LIMITED",
"VIPRAH TECHNOLOGIES LIMITED",
"VIPRAJ THERMOSET PVT LTD",
"VIPRAS FACILITY MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"VIPRE SG INDIA PRIVATE LIMITED",
"VIPRI INDUSTRIES PRIVATE LIMITED",
"VIPRO EXIM PRIVATE LIMITED",
"VIPSA BEARING PRIVATE LIMITED",
"VIPSA TALENT SOLUTIONS PRIVATE LIMITED",
"VIPSHEL INFOTECH PRIVATE LIMITED",
"VIPSWALLET PRIVATE LIMITED",
"VIPUL BRIGHT STEELS PRIVATE LIMITED",
"VIPUL CHEMICALS INDIA PRIVATE LIMITED",
"VIPUL COAL TRANSPORT PRIVATE LIMITED",
"VIPUL COPPER PRIVATE LIMITED",
"VIPUL DISTRIBUTORS PRIVATE LIMITED",
"VIPUL ENGITECH PRIVATE LIMITED",
"VIPUL ENTERPRISES",
"VIPUL HVAC SOLUTION PRIVATE LIMITED",
"VIPUL INDUSTRIES PRIVATE LIMITED",
"VIPUL INFRA SYSTEMS PRIVATE LIMITED",
"VIPUL INFRACON PRIVATE LIMITED",
"VIPUL INSURANCE BROKERS PRIVATE LIMITED",
"VIPUL IT INFRASOFT PRIVATE. LIMITED.",
"VIPUL LIFE SCIENCE LIMITED",
"VIPUL MEDCORP INSURANCE TPA PRIVATE LIMITED",
"VIPUL MEDCORP TPA PRIVATE LIMITED",
"VIPUL MODERN BUILDCON PRIVATE LIMITED",
"VIPUL MOTORS P LIMITED",
"VIPUL MOTORS PRIVATE LIMITED",
"VIPUL ORGANICS LIMITED",
"VIPUL OVERSEAS PRIVATE LIMITED",
"VIPUL PHARMA PRIVATE LIMITED",
"VIPUL SHAH",
"VIPUL STAR EXPORTS PRIVATE LIMITED",
"VIPUL TOOLS PRIVATE LIMITED",
"VIPUL VIDHYUT PRIVATE LIMITED",
"VIPUL WATER PROOFERS PRIVATE LIMITED",
"VIPULDUDHIYA SWEETS (AMBICA) LIMITED",
"VIPUTHI AGRO AND COLD STORAGE PRIVATE LIMITED",
"VIR ALLOYS AND STEEL COMPANY PRIVATE LIMITED",
"VIR ARJUN INVESTMENT PRIVATE LIMITED",
"VIR DECORATIVE SHEETS PRIVATE LIMITED",
"VIR ELECTRO ENGINEERING PRIVATE LIMITED",
"VIR POLYTECH PRIVATE LIMITED",
"VIR SOFTECH PRIVATE LIMITED",
"VIRA AUTO COMPONENTS PRIVATE LIMITED",
"VIRA CORPORATION PRIVATE LIMITED",
"VIRA LIFESCIENCES PRIVATE LIMITED",
"VIRA PROPERTIES (MADRAS) PRIVATE LIMITED",
"VIRA THEATRES PRIVATE LIMITED",
"VIRAAJ AUTO RETAIL PRIVATE LIMITED",
"VIRAAJ EXIM PRIVATE LIMITED",
"VIRAAJ MULTIFOREX PRIVATE LIMITED",
"VIRAANSH INDUSTRIES PRIVATE LIMITED",
"VIRAASAT JEWELS PRIVATE LIMITED",
"VIRAAT AUTHENTICATION SYSTEMS PRIVATE LIMITED",
"VIRAAT CREATORS PRIVATE LIMITED",
"VIRAAT TECHNOLOGY LABS PRIVATE LIMITED",
"VIRABH RESEARCH SOLUTIONS & CONSULTANCY PRIVATE LIMITED",
"VIRAD RENDERING TECHNOLOGIES PRIVATE LIMITED",
"VIRADHYA INFRATECH PRIVATE LIMITED",
"VIRADI ENTERPRISES PRIVATE LIMITED",
"VIRAJ ALCHOHOL AND ALLIED INDUSTRIES LIMITED",
"VIRAJ AUTOMOBILES PRIVATE LIMITED",
"VIRAJ BUILDTECH PRIVATE LIMITED",
"VIRAJ CANES AND ENERGY LIMITED",
"VIRAJ CASTING PRIVATE LIMITED",
"VIRAJ CATTLE FEEDS PRIVATE LIMITED",
"VIRAJ CLEAN SEA ENTERPRISES PRIVATE LIMITED",
"VIRAJ COLD STORAGE PRIVATE LIMITED",
"VIRAJ CONDUCTORS PVT LTD",
"VIRAJ CONSTRUCTIONS PRIVATE LIMITED",
"VIRAJ DISTRIBUTORS PRIVATE LIMITED",
"VIRAJ ENGINEERS AND EXPORTERS PRIVATE LIMITED",
"VIRAJ ESTATES PRIVATE LIMITED",
"VIRAJ FAB PRIVATE LIMITED",
"VIRAJ GARMENTS PRIVATE LIMITED",
"VIRAJ HOTELWARES PRIVATE LIMITED",
"VIRAJ IMPEX PRIVATE LIMITED",
"VIRAJ INFOCOMM PRIVATE LIMITED",
"VIRAJ INKS AND CHEMICALS PRIVATE LIMITED",
"VIRAJ LOGISTICS",
"VIRAJ MASCHINENFABRIK PRIVATE LIMITED",
"VIRAJ PHARMACEUTICALS PRIVATE LIMITED",
"VIRAJ PROCON PRIVATE LIMITED",
"VIRAJ PROFILES PRIVATE LIMITED",
"VIRAJ REFINERY PRIVATE LIMITED",
"VIRAJ SOLAR MAHARASHTRA PRIVATE LIMITED",
"VIRAJ SPINNERS LIMITED",
"VIRAJ STEEL AND ENERGY PRIVATE LIMITED",
"VIRAJ SYNTEX PRIVATE LIMITED",
"VIRAJ TECHNOCAST PRIVATE LIMITED",
"VIRAJ TECHNOLOGY INDIA LIMITED",
"VIRAJ UPKRAM PRIVATE LIMITED",
"VIRAJAA STEEL AND POWER PRIVATE LIMITED",
"VIRAJE CARGO CARE PRIVATE LIMITED",
"VIRAJIT PVT LTD",
"VIRAJMAN MOTELS INDIA PRIVATE LIMITED",
"VIRAL ALKALIS LIMITED",
"VIRAL HEALTHCARE PRIVATE LIMITED",
"VIRAL IMPEX PRIVATE LIMITED",
"VIRAL INDUSTRIES PRIVATE LIMITED",
"VIRAL INFRA-AGRO AND CULTIVATION PRIVATE LIMITED",
"VIRAL INTERNATIONAL PRIVATE LIMITED",
"VIRAL LIFECARE PRIVATE LIMITED",
"VIRAL MICRONS PRIVATE LIMITED",
"VIRAL PROLECTS INDIA PRIVATE LIMITED",
"VIRAL TECHNOLOGIES PRIVATE LIMITED.",
"VIRAL TEXTILES PRIVATE LIMITED",
"VIRAL ZONE MEDIA PRIVATE LIMITED",
"VIRALA INDIA PRIVATE LIMITED",
"VIRALCRAFT DIGITAL MEDIA PRIVATE LIMITED",
"VIRALCURRY DIGITAL PRIVATE LIMITED",
"VIRALI INDUSTRIAL SOLUTIONS PRIVATE LIMITED",
"VIRALII LIFE SCIENCES PRIVATE LIMITED",
"VIRAM ASHA SHIPPING SERVICES LIMITED",
"VIRAM AUTOMOTIVES PRIVATE LIMITED",
"VIRAM INTERNATIONAL PRIVATE LIMITED",
"VIRAMA INDUSTRIES PRIVATE LIMITED",
"VIRAMA LAMINATES PRIVATE LIMITED",
"VIRAMI ALLOYS PRIVATE LIMITED",
"VIRANDAVAN FARMS PRIVATE LIMITED",
"VIRANGI CREATION PRIVATE LIMITED",
"VIRANGI WEAVES PRIVATE LIMITED",
"VIRANIAM SOLUTIONS PRIVATE LIMITED",
"VIRAT ACID PRIVATE LIMITED",
"VIRAT ALLOYS PRIVATE LIMITED",
"VIRAT COLD STORAGE (INDIA) PRIVATE LIMITED",
"VIRAT COMMUNICATION SERVICES INDIA PRIVATE LIMITED",
"VIRAT CRANE INDUSTRIES LIMITED",
"VIRAT CREDIT & HOLDINGS PRIVATE LIMITED",
"VIRAT FABRICS PRIVATE LIMITED",
"VIRAT INDUSTRIES LIMITED",
"VIRAT INFRACITY PRIVATE LIMITED",
"VIRAT INFRACON PRIVATE LIMITED",
"VIRAT INFRAREALTY PRIVATE LIMITED",
"VIRAT JEWELS & CRAFTS (OPC) PRIVATE LIMITED",
"VIRAT KNITWEARS PRIVATE LIMITED",
"VIRAT RESIDENCY",
"VIRAT SOLVENT PRIVATE LIMITED",
"VIRAT SPECIAL STEELS PRIVATE LIMITED",
"VIRAT SPINNERS PRIVATE LIMITED",
"VIRAT WEAVING PRIVATE LIMITED",
"VIRAT YARNS TRADING PRIVATE LIMITED",
"VIRATA SITARA FOODS PRIVATE LIMITED",
"VIRATECH SOFTWARE & COMMUNICATIONS LIMITED",
"VIRATHI SECURITY AND MANPOWER SERVICES PRIVATE LIMITED",
"VIRATRA EXPORT PRIVATE LIMITED",
"VIRAUNIQUE REALTORS LIMITED",
"VIRAYA STEELS PRIVATE LIMITED",
"VIRBAC ANIMAL HEALTH INDIA PRIVATE LIMITED",
"VIRBHADRA FARMER PRODUCER COMPANY LIMITED",
"VIRCHAND NARSI COTTON PRIVATE LIMITED",
"VIRCHOW BIOTECH PRIVATE LIMITED",
"VIRCHOW CHEMICALS PRIVATE. LIMITED",
"VIRCHOW DRUGS LIMITED",
"VIRCHOW LABORATORIES LIMITED",
"VIRCHOW PETROCHEMICALS PRIVATE LIMITED",
"VIRDEEKA INDUSTRIES PRIVATE LIMITED",
"VIRDEV INTERMEDIATES PRIVATE LIMITED",
"VIRDEY AGRO PRIVATE LIMITED",
"VIRDI ELECTRIC WORKS PRIVATE LIMITED",
"VIRDISONS INDUSTRIES PRIVATE LIMITED",
"VIREET INVESTMENTS PRIVATE LIMITED",
"VIREN BUSINESS SOLUTIONS PRIVATE LIMITED",
"VIREN INVESTMENTS PRIVATE LIMITED",
"VIREN SILK MILLS PRIVATE LIMITED",
"VIREN TELECOM PRIVATE LIMITED",
"VIRENDRA FOOD PRODUCTS PRIVATE LIMITED",
"VIRENDRA HEALTH CARE PRIVATE LIMITED",
"VIRENDRA KUMAR SINGH",
"VIRENDRA LIFE STYLE PRIVATE LIMITED",
"VIRENDRA LOGISTICS PRIVATE LIMITED",
"VIRENDRA ROADLINES PRIVATE LIMITED",
"VIRENT POWER & PROJECTS PRIVATE LIMITED",
"VIRENTIATECH PRIVATE LIMITED",
"VIRESCENT INFRASTRUCTURE INVESTMENT MANAGER PRIVATE LIMITED",
"VIRESCENT RENEWABLE ENERGY PROJECT MANAGER PRIVATE LIMITED",
"VIRESHVAR IRON AND STEEL PRIVATE LIMITED",
"VIRGIN ATLANTIC AIRWAYS LIMITED",
"VIRGIN MANUFACTURING INDUSTRIES PRIVATE LIMITED",
"VIRGIN MARY HIGHER SECONDARY SCHOOL",
"VIRGIN MINERALS PRIVATE LIMITED",
"VIRGIN MOBILE INDIA PRIVATE LIMITED",
"VIRGIN POWER AND ENGINEERING PRIVATE LIMITED",
"VIRGIN RECORDS INDIA PRIVATE LIMITED",
"VIRGIN ROCK PRIVATE LIMITED",
"VIRGIN RUBBER PRIVATE LIMITED",
"VIRGIN SECURITIES AND CREDITS PRIVATE LIMITED",
"VIRGINCAR HOTELS PRIVATE LIMITED",
"VIRGINIA DEVELOPERS PRIVATE LIMITED",
"VIRGINIA MINING RESOURCES PRIVATE LIMITED",
"VIRGINIA TECH INDIA RESEARCH & EDUCATION FORUM",
"VIRGINIA TRANSFORMER INDIA PRIVATE LIMITED",
"VIRGINICA PRIVATE LIMITED",
"VIRGO ALUMINUM LIMITED",
"VIRGO BOARDS LIMITED",
"VIRGO BUILDESTATE PRIVATE LIMITED",
"VIRGO CONTAINERS LINE PRIVATE LIMITED",
"VIRGO DECORS PRIVATE LIMITED",
"VIRGO DISTRIPARKS PRIVATE LIMITED",
"VIRGO GLOBAL LIMITED",
"VIRGO HEALTH CARE PRIVATE LIMITED",
"VIRGO LAMINATES LIMITED",
"VIRGO LOGIPARK PRIVATE LIMITED",
"VIRGO MARK PRIVATE LIMITED",
"VIRGO MOTOR AGENCIES PRIVATE LIMITED",
"VIRGO PAINTS PRIVATE LIMITED",
"VIRGO PLYWOODS LIMITED",
"VIRGO POLYMERS INDIA LIMITED",
"VIRGO PROPERTIES PRIVATE LIMITED",
"VIRGO REALTORS PRIVATE LIMITED",
"VIRGO SPECIALTIES PRIVATE LIMITED",
"VIRGO TECHNOCRATES PRIVATE LIMITED",
"VIRGO UAP PHARMA PRIVATE LIMITED",
"VIRGO VALVES AND CONTROLS PRIVATE LIMITED",
"VIRGO VENEERS PRIVATE LIMITED",
"VIRIBUS RETAILS PRIVATE LIMITED",
"VIRIDIAN ADVISORS PRIVATE LIMITED",
"VIRIDIAN DEVELOPMENT MANAGERS PRIVATE LIMITED",
"VIRIDIS BIOPHARMA PRIVATE LIMITED",
"VIRIDIS ENGINEERING INDIA PRIVATE LIMITED",
"VIRILLE HEALTH CARE PRIVATE LIMITED",
"VIRIM INFOTECH PRIVATE LIMITED",
"VIRIMA TECHNOLOGIES INDIA PRIVATE LIMITED",
"VIRINCHI CAPITAL PRIVATE LIMITED",
"VIRINCHI ENGINEERING PRIVATE LIMITED",
"VIRINCHI HEALTH CARE PRIVATE LIMITED",
"VIRINCHI LIMITED",
"VIRINCHI PUBLISHERS PRIVATE LIMITED",
"VIRINDER ENGINEERING AND CHEMICALS PVT LTD",
"VIRINDRA BUILDCON PRIVATE LIMITED",
"VIRJALA POLYFLEX PRIVATE LIMITED",
"VIRJO PHARMA AND CHEMICALS LIMITED",
"VIRK HOSPITAL PRIVATE LIMITED",
"VIRKAMAL OPTICS PRIVATE LIMITED",
"VIRLOK INDUSTRIAL SOLUTIONS PRIVATE LIMITED",
"VIRMANI BROTHERS PRIVATE LIMITED",
"VIRMANI HOSPITALS PRIVATE LIMITED",
"VIRMATI INFOTECH LIMITED",
"VIRMATI SOFTWARES AND TELECOMMUNICATIONS LIMITED",
"VIRMATI TECHNOLOGIES LIMITED",
"VIRMAWATI FOODS PRIVATE LIMITED",
"VIRMUELLER ARCHITECTS PRIVATE LIMITED",
"VIRO HI-TECH ENGINEERS PRIVATE LIMITED",
"VIROCHA TECHNOVATIONS PRIVATE LIMITED",
"VIROCO ELECTRICALS PRIVATE LIMITED",
"VIROGREEN INDIA PRIVATE LIMITED",
"VIROHAN INSTITUTE OF HEALTH AND MANAGEMENT SCIENCE",
"VIROKA TECHNOLOGY PRIVATE LIMITED",
"VIROLA INTERNATIONAL",
"VIROLA SHOES PRIVATE LIMITED.",
"VIROM HEALTHCARE PRIVATE LIMITED",
"VIRPUR STRIPS PRIVATE LIMITED",
"VIRRAJ WORLDWIDE PRIVATE LIMITED",
"VIRRAM VIRALITY PRIVATE LIMITED",
"VIRRAN TECH SOLUTIONS PRIVATE LIMITED",
"VIRRENDRA EDUCARE SERVICES",
"VIRSEC SYSTEMS INDIA PRIVATE LIMITED",
"VIRSTRA I-TECHNOLOGY SERVICES LIMITED",
"VIRSUN MANAGEMENT SERVICES PRIVATE LIMITED",
"VIRTUAL AUTOMATION SERVICES PRIVATE LIMITED",
"VIRTUAL BUILDING STUDIO PRIVATE LIMITED",
"VIRTUAL BUSINESS SOLUTION PRIVATE LIMITED",
"VIRTUAL CRYSTAL MULTITRADE PRIVATE LIMITED",
"VIRTUAL DIAMOND BOUTIQUE INDIA PRIVATE LIMITED",
"VIRTUAL ELEMENT STUDIOS PRIVATE LIMITED",
"VIRTUAL EMPLOYEE PRIVATE LIMITED",
"VIRTUAL ENGINEERING SERVICES PRIVATE LIMITED",
"VIRTUAL FINANCE AND INVESTMENT PRIVATE LIMITED",
"VIRTUAL FLOW TECH PRIVATE LIMITED",
"VIRTUAL GALAXY INFOTECH PRIVATE LIMITED",
"VIRTUAL GUARD SERVICES PRIVATE LIMITED",
"VIRTUAL HEIGHT IT SERVICES PRIVATE LIMITED",
"VIRTUAL INFOSYSTEMS PRIVATE LIMITED",
"VIRTUAL KPO CONSULTANTS PRIVATE LIMITED",
"VIRTUAL MEDICO TECHNOLOGIES PRIVATE LIMITED",
"VIRTUAL MEDICONNECT PRIVATE LIMITED",
"VIRTUAL METALSTREET PRIVATE LIMITED",
"VIRTUAL PACKAGINGS PRIVATE LIMITED",
"VIRTUAL REALITY INFOSYS PRIVATE LIMITED",
"VIRTUAL RECRUITERS PRIVATE LIMITED",
"VIRTUAL SUPPORT SERVICES PRIVATE LIMITED",
"VIRTUAL TECH GURUS INDIA PRIVATE LIMITED",
"VIRTUAL VISION PRIVATE LIMITED",
"VIRTUAL WALLET SYSTEMS PRIVATE LIMITED",
"VIRTUALFOREST PRIVATE LIMITED",
"VIRTUALITY INNOVENTURE PRIVATE LIMITED",
"VIRTUALMAZE SOFTSYS PRIVATE LIMITED",
"VIRTUALSOFT SYSTEMS LIMITED",
"VIRTUALTECH OUTSOURCING SERVICES PRIVATE LIMITED",
"VIRTUAL-WHITE FLAME PRIVATE LIMITED",
"VIRTUBOX INFOTECH PRIVATE LIMITED",
"VIRTUE ANALYTICS PRIVATE LIMITED",
"VIRTUE CERAMICS PRIVATE LIMITED",
"VIRTUE ENGINEERING PRIVATE LIMITED",
"VIRTUE FINANCE LIMITED",
"VIRTUE FINANCIAL SERVICES PRIVATE LIMITED",
"VIRTUE INFO WEB TECHNOLOGIES PRIVATE LIMITED",
"VIRTUE INFRASTRUCTURES PRIVATE LIMITED",
"VIRTUE INTERNATIONAL PRIVATE LIMITED",
"VIRTUE SOFT SOLUTION PRIVATE LIMITED",
"VIRTUE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"VIRTUE SPECIALITY PRIVATE LIMITED",
"VIRTUE TRADECOM PRIVATE LIMITED",
"VIRTUEINFO SOFT WEB PRIVATE LIMITED",
"VIRTUEVISE TECHNOLOGIES DECODING DESIRES",
"VIRTUEZ MEDIA SOLUTIONS PRIVATE LIMITED",
"VIRTUINFOTECH PRIVATE LIMITED",
"VIRTULIVE TECHNOLOGIES PRIVATE LIMITED",
"VIRTUNET SYSTEMS PRIVATE LIMITED",
"VIRTUOS SOLUTIONS PRIVATE LIMITED",
"VIRTUOSO AGRO PRIVATE LIMITED",
"VIRTUOSO BEVERAGES PRIVATE LIMITED",
"VIRTUOSO BUSINESS CONSULTING SERVICES PRIVATE LIMITED",
"VIRTUOSO INFOTECH PRIVATE LIMITED",
"VIRTUOSO MEDICO INFRATECH PRIVATE LIMITED",
"VIRTUOSO NETSOFT PRIVATE LIMITED",
"VIRTUOSO OPTOELECTRONICS LIMITED",
"VIRTUOSO OPTOELECTRONICS PRIVATE LIMITED",
"VIRTUOSO PROJECTS & ENGINEERS PRIVATE LIMITED",
"VIRTUOSO STAFFING SOLUTIONS PRIVATE LIMITED",
"VIRTUOSO TECHNOLOGIES AND CONSULTING PRIVATE LIMITED",
"VIRTUOSO TECHNOLOGIES INDIA PRIVATE LIMITED",
"VIRTUOSO TRADE & SERVICES PRIVATE LIMITED",
"VIRTUOSOS SOLUTIONS PRIVATE LIMITED",
"VIRTUOUS CAPITAL LIMITED",
"VIRTUOUS CORPORATE ADVISORS PRIVATE LIMITED",
"VIRTUOUS ENERGY PRIVATE LIMITED",
"VIRTUOUS MEDICINE PRIVATE LIMITED",
"VIRTUOUS METAL INDUSTRIES PRIVATE LIMITED",
"VIRTUOUS SECURITY AND FACILITY MANAGEMENT PRIVATE LIMITED",
"VIRTUOUS TRADECORP PRIVATE LIMITED",
"VIRTUOUS TRANSACTIONAL ANALYTICS PRIVATE LIMITED",
"VIRTUREAL WORCON PRIVATE LIMITED",
"VIRTUS EXPORTS AND IMPORT PRIVATE LIMITED",
"VIRTUS IT INDIA PRIVATE LIMITED",
"VIRTUS PRO LOGISTICS PRIVATE LIMITED",
"VIRTUSA CONSULTING SERVICES PRIVATE LIMITED",
"VIRTUSA LIFE SPACES INDIA PRIVATE LIMITED",
"VIRTUSA SYSTEMS (INDIA) PRIVATE LIMITED",
"VIRTUSA SYSTEMS INDIA PRIVATE LIMITED",
"VIRTUSO VERIFICA I PRIVATE LIMITED",
"VIRTUZO INFOSYSTEMS PRIVATE LIMITED",
"VIRU TEXTILE MILLS PRIVATE LIMITED",
"VIRUDHUNAGAR KSHATRIYA VIDHYASALA MANAGING BOARD",
"VIRUDHUNAGAR SOFTWARE ANALYSIS PRIVATE LIMITED",
"VIRUJ PHARMACEUTICALS PRIVATE LIMITED",
"VIRUPA RENEWABLE ENERGY PRIVATE LIMITED",
"VIRUPAKSHA LABORATORIES PRIVATE LIMITED",
"VIRUPAKSHA ORGANICS LIMITED",
"VIRUTCHAM MICROFINANCE LIMITED",
"VIRYA INFOTECH PRIVATE LIMITED",
"VIRYA LOGISTICS TECHNOLOGIES PRIVATE LIMITED",
"VIRYA RESOURCES LIMITED",
"VIS A VIS INDIA PRIVATE LIMITED",
"VIS LEGIS LAW PRACTICE",
"VIS NETWORKS PRIVATE LIMITED",
"VIS SIGNS PRIVATE LIMITED",
"VIS VIVA PACKAGING PRIVATE LIMITED",
"VISA ALLIANCE AND TRAVEL SERVICES PRIVATE LIMITED",
"VISA COKE LIMITED",
"VISA CONSOLIDATED SUPPORT SERVICES INDIA PRIVATE LIMITED",
"VISA CORPORATE SERVICES PRIVATE LIMITED",
"VISA ELECTROFAB PRIVATE LIMITED",
"VISA ENGINEERING PRODUCTS (INDIA) PRIVAT E LIMITED",
"VISA ENGINEERS AND PROMOTORS PRIVATE LIMITED",
"VISA INDUSTRIES LIMITED",
"VISA INFRASTRUCTURE LIMITED",
"VISA LOGISTICS PVT LTD",
"VISA MINMETAL LIMITED",
"VISA STEEL LIMITED",
"VISAGAR FINANCIAL SERVICES LIMITED",
"VISAGAR POLYTEX LIMITED",
"VISAGAR TEXTILES PRIVATE LIMITED",
"VISAGE BEAUTY AND HEALTH CARE PRIVATE LIMITED",
"VISAGE IMPEX INDIA PRIVATE LIMITED",
"VISAGE LINES PERSONAL CARE PRIVATE LIMITED",
"VISAGE VENTURES PRIVATE LIMITED",
"VISAKA GREEN PRIVATE LIMITED",
"VISAKA INDUSTRIES LIMITED",
"VISAKHA CFS & LOGISTICS PRIVATE LIMITED",
"VISAKHA CONTAINER TERMINAL PRIVATE LIMITED",
"VISAKHA FOODS PRIVATE LIMITED",
"VISAKHA GOVT JR COLLEGE FOR GIRLS",
"VISAKHA GOVT WOMEN COLLEGE",
"VISAKHA HEALTHCARE (INDIA) PRIVATE LIMITED",
"VISAKHA HOSPITALS AND DIAGNOSTICS LIMITED",
"VISAKHA INDUSTRIAL GASES PRIVATE LIMITED",
"VISAKHA JUNIOR COLLEGE",
"VISAKHA MILK PRODUCTS (INDIA) PRIVATE LIMITED",
"VISAKHA NETHRA JYOTHI PVT. LTD.",
"VISAKHA PHARMACITY LIMITED",
"VISAKHA PROJECTS PRIVATE LIMITED",
"VISAKHA SOLVENTS LIMITED",
"VISAKHA TRADES",
"VISAKHA VALLEY SCHOOL",
"VISAKHA WIRE ROPES LIMITED",
"VISAKHA WOMENS COLLEGE",
"VISAKHAPATNAM INDUSTRIAL WATER SUPPLY COMPANY LIMITED",
"VISAKHAPATNAM PORT TRUST",
"VISAL TRIBOTECH PRIVATE LIMITED",
"VISALAATCHI FOOD INDIA PRIVATE LIMITED",
"VISALAKSHI MARKETING PRIVATE LIMITED",
"VISALAM FINANCE PRIVATE LIMITED",
"VISALAM PAPERS PRIVATE LIMITED",
"VISAMAN SALES PRIVATE LIMITED",
"VISAN INFRASTRUCTURE PRIVATE LIMITED",
"VISAN TRADING PRIVATE LIMITED",
"VISARIA SECURITIES PRIVATE LIMITED",
"VISARPAN INFRATECH PRIVATE LIMITED",
"VISAS AVENUE PRIVATE LIMITED",
"VISASPRING CONSULTANTS PRIVATE LIMITED",
"VISAT DETERGENTS PRIVATE LIMITED",
"VISAT HEATING (INDIA) PRIVATE LIMITED",
"VISAT REALTY PRIVATE LIMITED",
"VISAT TOOLS PRIVATE LIMITED",
"VISBIN MANAGEMENT ASSOCIATES PRIVATE LIMITED",
"VISCAIR AUTO INDUSTRIES PRIVATE LIMITED",
"VISCAP CONSULTANCY SERVICES PRIVATE LIMITED",
"VISCID POLYMERS INDIA PRIVATE LIMITED",
"VISCO TRADE ASSOCIATES LTD",
"VISCOL ENERGY & PETRO-CHEMICALS PRIVATE LIMITED",
"VISCOMM 360 COMMUNICATIONS PRIVATE LIMITED",
"VISCOT SURGICALS PRIVATE LIMITED",
"VISCOTEC INDIA PRIVATE LIMITED",
"VISCOTEX ENERGY PRIVATE LIMITED",
"VISCOUS ENGINEERS PRIVATE LIMITED",
"VISCUS OILS PRIVATE LIMITED",
"VISDIL VENTURES PRIVATE LIMITED",
"VISEN INDUSTRIES LIMITED",
"VISER LOGISTIC PRIVATE LIMITED",
"VISESA MAINTENANCE SERVICES PRIVATE LIMITED",
"VISESH AYURVED INDIA PRIVATE LIMITED",
"VISESH CARGO & TRAVELS PRIVATE LIMITED",
"VISESH INFOSYSTEMS PRIVATE LIMITED",
"VISESH TRANSMISSIONS PRIVATE LIMITED",
"VISEVEN INDIA PRIVATE LIMITED",
"VISHA AUTOMOTIVE SALES & SERVICES PRIVATE LIMITED",
"VISHAAL PROMOTERS PRIVATE LIMITED",
"VISHAAL'S HOME STORES RETAIL PRIVATE LIMITED",
"VISHAD EDUTECH PRIVATE LIMITED",
"VISHAGAN FOODS PRIVATE LIMITED",
"VISHAKA EYE HOSPITAL",
"VISHAKAM MEDICARE PRIVATE LIMITED",
"VISHAKAVEL TEXTILE MILLS PRIVATE LIMITED",
"VISHAKHA ACCOUNTING SERVICES PRIVATE LIMITED",
"VISHAKHA BUILDCON PRIVATE LIMITED",
"VISHAKHA ESTATES PRIVATE LIMITED",
"VISHAKHA INDUSTRIES",
"VISHAKHA IRRIGATION PRIVATE. LIMITED.",
"VISHAKHA METALS PRIVATE LIMITED",
"VISHAKHA PLASTIC PIPES PRIVATE LIMITED",
"VISHAKHA POLYFAB PRIVATE. LIMITED.",
"VISHAKHA RENEWABLES PRIVATE LIMITED",
"VISHAKHA TRADING CO. PRIVATE LIMITED",
"VISHAKHAPATNAM PORT ROAD COMPANY LIMITED",
"VISHAL AGRIGENETICS PRIVATE LIMITED",
"VISHAL AGRO IRON PRIVATE LIMITED",
"VISHAL ALUMINIUM PRIVATE LIMITED",
"VISHAL AROGYA SAMPAT PRIVATE LIMITED",
"VISHAL ARTS SIGN AND GRAPHICS PRIVATE LIMITED",
"VISHAL AUTOMOVERS PRIVATE LIMITED",
"VISHAL BEARINGS LIMITED",
"VISHAL BEVERAGES PVT LTD",
"VISHAL BHARDWAJ PICTURES PRIVATE LIMITED",
"VISHWA BHARATI PUBLIC SCHOOL",
"VISHAL BOX COMPANY PRIVATE LIMITED",
"VISHAL BROTHERS PRIVATE LIMITED",
"VISHAL CABLES PRIVATE LIMITED",
"VISHAL CHAIN AND JEWELLERY PRIVATE LIMITED",
"VISHAL CHEMTRADE PRIVATE LIMITED",
"VISHAL CIVIL ENGINEERING PRIVATE LIMITED",
"VISHAL COATERS LIMITED",
"VISHAL COLLECTION PRIVATE LIMITED",
"VISHAL COLOUR ROOFS PRIVATE LIMITED",
"VISHAL COMPUTECH PRIVATE LIMITED",
"VISHAL CONTAINERS LIMITED",
"VISHAL CONTRACTORS & DEVELOPERS PRIVATE LIMITED",
"VISHAL CONVEYOR SYSTEMS PRIVATE LIMITED",
"VISHAL CORRUGTORS PRIVATE LIMITED",
"VISHAL CRANES PRIVATE LIMITED",
"VISHAL CYCLES PVT LTD",
"VISHAL DESIGN PRIVATE LIMITED",
"VISHAL DIAMONDS",
"VISHAL DIESELS PRIVATE LIMITED",
"VISHAL EARTHMOVERS INDIA PRIVATE LIMITED",
"VISHAL ELECTRO INDUSTRIES PRIVATE LIMITED",
"VISHAL ENGINEERS PRIVATE LIMITED",
"VISHAL ENTERPRISE",
"VISHAL ERGONOMICS PRIVATE LIMITED",
"VISHAL ETHNIC PRIVATE LIMITED",
"VISHAL EXPERT SERVICES PRIVATE LIMITED",
"VISHAL FABRICS LIMITED",
"VISHAL FASHIONS PRIVATE LIMITED",
"VISHAL FINTRADE PRIVATE LIMITED (TRF)",
"VISHAL FURNISHING LIMITED",
"VISHAL FURNISHINGS LIMITED",
"VISHAL GASES PVT LTD",
"VISHAL GEMS AND JEWELS PRIVATE LIMITED",
"VISHAL GS ENGINEERING AND ASSOCIATES PRIVATE LIMITED",
"VISHAL GS INFRAWELL PRIVATE LIMITED",
"VISHAL HOLO SOLUTIONS PRIVATE LIMITED",
"VISHAL HOME APPLIANCES PRIVATE LIMITED",
"VISHAL ICE FACTORY AND COLD STORAGE PVT LTD",
"VISHAL INFRABUILD LIMITED",
"VISHAL INFRAPROMOTERS PRIVATE LIMITED",
"VISHAL INFRASTRUCTURE LIMITED",
"VISHAL INTERNATIONAL PRODUCTIONS PRIVATE LIMITED",
"VISHAL JUNNER SAHAKARI PATHPEDHI MARYADIT",
"VISHAL KARNATAKA TRADE LINKS PRIVATE LIMITED",
"VISHAL KRISHI PRODUCTS PRIVATE LIMITED",
"VISHAL LABORATORIES PRIVATE LIMITED",
"VISHAL LIFE SCIENCES PRIVATE LIMITED",
"VISHAL MANUFACTURER PRIVATE LIMITED",
"VISHAL MARBLES PRIVATE LIMITED",
"VISHAL MEGA MART PRIVATE LIMITED",
"VISHAL MEGA TELETRADING PRIVATE LIMITED",
"VISHAL METAL CASTING PRIVATE LIMITED",
"VISHAL METALLICS PRIVATE LIMITED",
"VISHAL MINERALS PRIVATE LIMITED",
"VISHAL MOBILES PRIVATE LIMITED",
"VISHAL MODEL SR SEC SCHOOL",
"VISHAL MOULDS MANUFACTURING P LTD",
"VISHAL MULTITRADE PRIVATE LIMITED",
"VISHAL NATURAL FOOD PRODUCTS INDIA PRIVATE LIMITED",
"VISHAL NIRMITI PRIVATE LIMITED",
"VISHAL PACKERS PRIVATE LIMITED",
"VISHAL PAPER INDUSTRIES PRIVATE LIMITED",
"VISHAL PAPER MILLS PRIVATE LIMITED",
"VISHAL PAPERTECH (INDIA) LIMITED",
"VISHAL PERSONAL CARE PRIVATE LIMITED",
"VISHAL PIPES LIMITED",
"VISHAL POLY FIBRES PRIVATE LIMITED",
"VISHAL POLYFILMS PRIVATE LIMITED",
"VISHAL PRECISION PRODUCTS PRIVATE LIMITED",
"VISHAL PRECISION STEEL TUBES & STRIPS PRIVATE LIMITED",
"VISHAL PRINT - N - PLAST PRIVATE LIMITED",
"VISHAL PRINT TRADER PRIVATE LIMITED",
"VISHAL PRODUCTIONS PRIVATE LIMITED",
"VISHAL PROFIN PVT. LTD",
"VISHAL PROJECTS PRIVATE LIMITED",
"VISHAL REROLLERS PRIVATE LIMITED",
"VISHAL RESORTS AND HOTELS PRIVATE LIMITED",
"VISHAL RUBBER TECHNOLOGIES PRIVATE LIMITED",
"VISHAL SAW CUM VENEER MILLS PRIVATE LIMITED",
"VISHAL SCM PRIVATE LIMITED",
"VISHAL SEEDS AGRO INDUSTRIES PRIVATE LIMITED",
"VISHAL SHIPPING AGENCIES PRIVATE LIMITED",
"VISHAL SONEPAT AGRO-TECH PRIVATE LIMITED",
"VISHAL SPACE PRIVATE LIMITED",
"VISHAL SPONGE PRIVATE LIMITED",
"VISHAL STRUCTURAL PRIVATE LIMITED",
"VISHAL SURGICAL EQUIPMENT CO PRIVATE LIMITED",
"VISHAL SURGITECH PRIVATE LIMITED",
"VISHAL TECHNOMATION PRIVATE LIMITED",
"VISHAL TOOLS AND FORGINGS PVT LTD",
"VISHAL TRANSFORMERS AND SWITCHGEARS PRIVATE LIMITED",
"VISHAL TRAVELS PRIVATE LIMITED",
"VISHAL TUBES AND PIPES PRIVATE LIMITED",
"VISHAL UDHYAN PRIVATE LIMITED",
"VISHAL UDYOG PVT LTD",
"VISHAL VIDEO AND APPLIANCES PRIVATE LIMITED",
"VISHAL WATERWORLD PRIVATE LIMITED",
"VISHAL WHEELERS PRIVATE LIMITED",
"VISHAL WOOLLENS PRIVATE LIMITED",
"VISHALA INDIA COMMERCIAL DEVELOPERS PRIVATE LIMITED",
"VISHALA INDUSTRIAL CRAFT PRIVATE LIMITED",
"VISHALFAB (INDIA) PRIVATE LIMITED",
"VISHAMBARA POLYMER PRIVATE LIMITED",
"VISHANT AUDIO VISUALS PRIVATE LIMITED",
"VISHANT STEELS PRIVATE LIMITED",
"VISHANT TRADERS PRIVATE LIMITED",
"VISHAT DIAGNOSTIC PRIVATE LIMITED",
"VISHAURA HEALTHCARE PRIVATE LIMITED",
"VISHAV BHARTI VARTMAAN SCHOOL",
"VISHAV COMPONENTS PRIVATE LIMITED",
"VISHAVARI TOLLWAY PRIVATE LIMITED",
"VISHAVKARMA MECHANICAL WORKS PRIVATE LIMITED",
"VISHAVKARMA STEEL FORGING PRIVATE LIMITED",
"VISHAWA SHAKTI CONSTRUCTIONS PRIVATE LIMITED",
"VISHAWAS FINVEST PRIVATE LIMITED",
"VISHAY COMPONENTS INDIA PRIVATE LIMITED",
"VISHAY PRECISION TRANSDUCERS INDIA PRIVATE LIMITED",
"VISHAY SEMICONDUCTOR INDIA PRIVATE LIMITED",
"VISHAY TRANSDUCERS INDIA PRIVATE LIMITED",
"VISHESH DIAGNOSTICS PRIVATE LIMITED",
"VISHESH DISTRIBUTORS PRIVATE LIMITED",
"VISHESH FILMS PRIVATE LIMITED",
"VISHESH GREENSCAPE LLP",
"VISHESH INFRASTRUCTURE PRIVATE LIMITED",
"VISHESH INFRATECH INDIA PRIVATE LIMITED",
"VISHESH JEWELLERS PRIVATE LIMITED",
"VISHESH POLYIMPEX PRIVATE LIMITED",
"VISHESHH GLOBE TRADE PRIVATE LIMITED",
"VISHESHT FINANCIAL SERVICES PRIVATE LIMITED",
"VISHI ADVERTISING PRIVATE LIMITED",
"VISHI ELECTRONICS (INDIA) PRIVATE LIMITED",
"VISHINI VENTURES PRIVATE LIMITED",
"VISHIST BUSINESS SOLUTIONS PRIVATE LIMITED",
"VISHIVKARMA INDUSTRIES PVT LTD",
"VISHKAR INFRASTRUCTURE PRIVATE LIMITED",
"VISHKUL ENTERPRISES PRIVATE LIMITED",
"VISHLESHAN SOFTWARE SOLUTIONS PRIVATE LIMITED",
"VISHNA FOODS PRIVATE LIMITED",
"VISHNU & COMPANY TRADEMARKS PRIVATE LIMITED",
"VISHNU APARTMENTS PVT. LTD. (PART IX)",
"VISHNU AROMA POUCHING PRIVATE LIMITED",
"VISHNU BARIUM PRIVATE LIMITED",
"VISHNU BHAGWAN PUBLIC SCHOOL",
"VISHNU CARS PRIVATE LIMITED",
"VISHNU CHEMICALS LIMITED",
"VISHNU COAL TRADERS LIMITED",
"VISHNU COTTON MILLS LTD",
"VISHNU ENTERPRISE LTD.",
"VISHNU FOOD PRODUCTS PRIVATE LIMITED",
"VISHNU FOOT FIRST PRIVATE LIMITED",
"VISHNU FORGE INDUSTRIES LIMITED",
"VISHNU GANESUN INDUSTRIES PRIVATE LIMITED",
"VISHNU HOSIERY PRIVATE LIMITED",
"VISHNU INDUSTRIAL ENGINEERS PRIVATE LIMITED",
"VISHNU IRON & STEEL PRIVATE LIMITED",
"VISHNU KANCHI CREATIONS",
"VISHNU KRUPA ALLOYS PRIVATE LIMITED",
"VISHNU LAKSHMI MILLS PRIVATE LIMITED",
"VISHNU LAXMI TEXTILES INDUSTRIES PRIVATE LIMITED",
"VISHNU LIFE SCIENCES LIMITED",
"VISHNU MASALA FOODS PRIVATE LIMITED",
"VISHNU MINECHEM PRIVATE LIMITED",
"VISHNU MOTORPLAZA PRIVATE LIMITED",
"VISHNU OIL MILL PRIVATE LIMITED",
"VISHNU OPS (INDIA) PRIVATE LIMITED (PART IX)",
"VISHNU OPTICALS PRIVATE LIMITED",
"VISHNU PACKWELL PRIVATE LIMITED",
"VISHNU PAPER PRODUCTS PRIVATE LIMITED",
"VISHNU PRAKASH R PUNGLIA LIMITED",
"VISHNU PRESSINGS PRIVATE LIMITED",
"VISHNU PRIYA DYEING AND PRINTING MILLS PRIVATE LIMITED",
"VISHNU PRIYA INDUSTRIES PRIVATE LIMITED",
"VISHNU PRIYA ISPAT PRIVATE LIMITED",
"VISHNU PROJECTS AND CONSTRUCTIONS PRIVATE LIMITED",
"VISHNU RESOURCES INDIA LIMITED",
"VISHNU RICE MILLS",
"VISHNU SOLUTIONS P LIMITED",
"VISHNU STOCK HOLDING PRIVATE LIMITED",
"VISHNU SUGAR MILLS LIMITED",
"VISHNU TEA & INDUSTRIES PVT LTD",
"VISHNU TRADING AND INVESTMENT CO.PVT.LTD.",
"VISHNU TRADING COMPANY",
"VISHNU TRADING COMPANY PRIVATE LIMITED",
"VISHNU VAIBHAV INDUSTRIES PRIVATE LIMITED",
"VISHNU VINIMAY PVT.LTD.",
"VISHNU WAMAN THAKUR CHARITABLE TRUSTS",
"VISHNU WEAVETEX PRIVATE LIMITED",
"VISHNU WEBTECH PRIVATE LIMITED",
"VISHNUANDARUN RETAIL PRIVATE LIMITED",
"VISHNUAVTAR HOSPITALITY",
"VISHNUJI REFINERY PRIVATE LIMITED",
"VISHNUJI SHEKUJI SATAV HIGH SCHOOL",
"VISHNULAXMI POLYPACK PRIVATE LIMITED",
"VISHNULENE POLYFAB LIMITED",
"VISHNUMA GLOBAL SOLUTIONS PRIVATE LIMITED",
"VISHNUMAYA UNIVERSAL PRIVATE LIMITED",
"VISHNUMOORTHY CATERING SERVICES PRIVATE LIMITED",
"VISHNUMURTI EXIM PRIAVATE LIMITED",
"VISHNUPRIYA CHEMICALS PRIVATE LIMITED",
"VISHNUPRIYA FOODS",
"VISHNUPRIYA PROJECTS PRIVATE LIMITED",
"VISHNUPRIYA PROPERTIES PVT LTD",
"VISHNURAAM TEXTILES LIMITED",
"VISHNUSHIVA INFRA & MINING PRIVATE LIMITED",
"VISHNUSHIVA INFRASTRUCTURES",
"VISHNUSURYA PROJECTS AND INFRA LIMITED",
"VISHNUTEJA INFRA PRIVATE LIMITED",
"VISHNUVALLABH TRADE INDIA PRIVATE LIMITED",
"VISHNUVARDHAN HOSPITALITY AND CATERERS PRIVATE LIMITED",
"VISHNUVELAN TEXTILES PRIVATE LIMITED",
"VISHPA RAIL EQUIPMENTS PRIVATE LIMITED",
"VISHRA FOUNDATION FOR EDUCATION AND RESEARCH",
"VISHRA JUNIOR KALASALA",
"VISHRAAM BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"VISHRAM SPICES (INDIA) PRIVATE LIMITED",
"VISHRAMBHAI GORASIA CONSTRUCTION PRIVATE LIMITED",
"VISHRANTHI HOMES PRIVATE LIMITED",
"VISHRUDH ORGANICS PRIVATE LIMITED",
"VISHRUT HOUSING PRIVATE LIMITED",
"VISHRUTA PACKAGING PRIVATE LIMITED",
"VISHRUTH TRADELINKS PRIVATE LIMITED",
"VISHU CARTONS & LABELS PRIVATE LIMITED",
"VISHU CONSTRUCTIONS PRIVATE LIMITED",
"VISHU STEELS PRIVATE LIMITED",
"VISHUBH INTEGERATED SOLUTION PRIVATE LIMITED",
"VISHUDDH RECYCLE PRIVATE LIMITED",
"VISHUDDHA NUTRIOL PRIVATE LIMITED",
"VISHUDDHI ENVIRO PRIVATE LIMITED",
"VISHUL GLOBAL PRIVATE LIMITED",
"VISHUS PRODUCTIONS PRIVATE LIMITED",
"VISHV BOOKS PRIVATE LIMITED",
"VISHV ENTERPRISE MEHSANA",
"VISHV VIJAY PRIVATE LIMITED",
"VISHVA BHARTI VIDYALAYA",
"VISHVA ELECTROTECH LIMITED",
"VISHVA EXIM PRIVATE LIMITED",
"VISHVA INSTITUTE OF UROLOGY AND KIDNEY CENTRE PRIVATE LIMITED",
"VISHVA MACHINERY PRIVATE LIMITED",
"VISHVA NAIN IMPEX OVERSEAS PRIVATE LIMITED",
"VISHVA PROTECH PRIVATE LIMITED",
"VISHVA VISHAL ENGINEERING LIMITED",
"VISHVA VISHAL REFRACTORY LIMITED",
"VISHVACHAYA STEELS PVT LTD",
"VISHVAKARMA CONSULTING SERVICES PRIVATE LIMITED",
"VISHVAKARMA PAPER AND BOARDS PRIVATE LIMITED",
"VISHVAKARMA PREFAB STEEL PRIVATE LIMITED",
"VISHVAM EXIM PRIVATE LIMITED",
"VISHVAM TECHNOLOGIES PRIVATE LIMITED",
"VISHVARAJ AGENCIES PRIVATE LIMITED",
"VISHVARAJ ENVIRONMENT PRIVATE LIMITED",
"VISHVARAJ INFRASTRUCTURE LIMITED",
"VISHVARAJ INFRASTRUCTURE PRIVATE LIMITED",
"VISHVARDAN COMMERCIAL COMPANY PRIVATE LIMITED",
"VISHVARTH INFRASTRUCTURES PRIVATE LIMITED",
"VISHVARUPA SOLAR POWER PRIVATE LIMITED",
"VISHVAS BUILDHOMES PRIVATE LIMITED",
"VISHVAS COMMUNICATIONS PRIVATE LIMITED",
"VISHVAS GINNING AND INDUSTRIES",
"VISHVAS INTERNATIONAL PRIVATE LIMITED",
"VISHVAS POWER ENGINEERING SERVICES PRIVATE LIMITED",
"VISHVAS SALES PRIVATE LIMITED",
"VISHVASRAO NAIK SAHAKARI SAKHAR KARKHANA LIMITED",
"VISHVESHWAR EXIM PRIVATE LIMITED",
"VISHVESHWAR OIL AND LUBRICANTS PRIVATE LIMITED",
"VISHVIN TECHNOLOGIES PRIVATE LIMITED",
"VISHVPRABHA VENTURES LIMITED",
"VISHWA BHARATI FOODS PRIVATE LIMITED",
"VISHWA BHARTI GIRLS INTERNATIONAL SCHOOL",
"VISHWA BHARTI LOGISTICS PRIVATE LIMITED",
"VISHWA BHARTI VIDYALAYA",
"VISHWA BUSES AND COACHES LIMITED",
"VISHWA CNC TECHNOLOGIES PRIVATE LIMITED",
"VISHWA CONCRETE PRIVETE LIMITED",
"VISHWA ELECTRICALS PRIVATE LIMITED",
"VISHWA FASHIONS PVT LTD",
"VISHWA GLASS AND CERAMICS PRIVATE LIMITED",
"VISHWA GREEN REALTORS PRIVATE LIMITED",
"VISHWA HEALTH INSTITUTE PRIVATE LIMITED",
"VISHWA HOLISTIC SOLUTIONS PRIVATE LIMITED",
"VISHWA INDUSTRIAL CO LTD",
"VISHWA INFRATECH PRIVATE LIMITED",
"VISHWA KHANIJ INDUSTRIES PRIVATE LIMITED",
"VISHWA KUTUMB PRIVATE LIMITED",
"VISHWA LAKSHMI EXPORTS PRIVATE LIMITED",
"VISHWA MACHINERY AND PROCESSING PRIVATE LIMITED",
"VISHWA MECHVIL PRIVATE LIMITED",
"VISHWA MICRO PROCESSORS PVT. LTD.",
"VISHWA MILLS",
"VISHWA POLY-CHEM PRIVATE LIMITED",
"VISHWA POWER AND INFRASTRUCTURE PRIVATE LIMITED",
"VISHWA PRINTERS & PACKEGERS PRIVATE LIMITED",
"VISHWA SAFETY GLASS PRIVATE LIMITED",
"VISHWA SAMANYU PROJECTS PRIVATE LIMITED",
"VISHWA SAMUDRA HOLDINGS PRIVATE LIMITED",
"VISHWA SAMUDRA KANNUR EXPRESSWAY PRIVATE LIMITED",
"VISHWA SAMUDRA SHIPMENT SERVICES PRIVATE LIMITED",
"VISHWA STAINLESS PRIVATE LIMITED",
"VISHWA TRANSCRIPTION SERVICES PRIVATE LIMITED",
"VISHWA TRANSLINK PRIVATE LIMITED",
"VISHWA TRANSOLUTIONS PRIVATE LIMITED",
"VISHWA VENKATESHWARA INTERNATIONAL SCHOOL",
"VISHWA VIDYALAYA",
"VISHWA VIDYALAYA HIGHERSECONDARY SC",
"VISHWA VIDYAPEETH",
"VISHWA VINAYAKA NATIONAL ENGLISH MEDIUM SCHOOL",
"VISHWA VISHWANI INSTITUTE OF SYSTEMS & MANAGEMENT OFFICE",
"VISHWAA APPARELS",
"VISHWAA PACKWEL PRIVATE LIMITED",
"VISHWABALAA ENGINEERING PRIVATE LIMITED",
"VISHWABHARTI ACADEMYS COLLEGE OF ENGINEERING AHMEDNAGAR",
"VISHWABHARTI AUTOMOBILES PRIVATE LIMITED",
"VISHWABHARTI VIDYALAYA SHAHWADI",
"VISHWACHETANA VIDYANIKETANA RESIDENTIAL SCHOOL",
"VISHWADEEP PRESS PARTS PRIVATE LIMITED",
"VISHWADUTT MINERALS PVT LTD",
"VISHWAHIND LOGISTICS LIMITED",
"VISHWAJYOT HIGH SCHOOL",
"VISHWAJYOTHI INTERNATIONAL PUBLIC SCHOOL",
"VISHWAK PROJECTS PRIVATE LIMITED",
"VISHWAK SOLUTIONS PRIVATE LIMITED",
"VISHWAKARMA ALUMINUM HOUSE PRIVATE LIMITED",
"VISHWAKARMA AUTO COMPONENTS PRIVATE LIMITED",
"VISHWAKARMA AUTO PARTS PRIVATE LIMITED",
"VISHWAKARMA AUTOMOTIVE PRIVATE LIMITED.",
"VISHWAKARMA CAR CARE AND SERVICE CENTRE PRIVATE LIMITED",
"VISHWAKARMA COLLEGE OF ARTS, COMMERCE & SCIENCE",
"VISHWAKARMA CREATIVE ENGINEERING PRIVATE LIMITED",
"VISHWAKARMA DEVELOPERS PRIVATE LIMITED",
"VISHWAKARMA FACILITY PRIVATE LIMITED",
"VISHWAKARMA FOUNDERS INDIA PRIVATE LIMITED",
"VISHWAKARMA GEARS PRIVATE LIMITED",
"VISHWAKARMA GOVT ENG COLLEGE",
"VISHWAKARMA GRAH UDYOG PRIVATE LIMITED",
"VISHWAKARMA HEALTH CARE PRIVATE LIMITED",
"VISHWAKARMA INFRASTRUCTURES PRIVATE LIMITED",
"VISHWAKARMA INNOVATIVE ENGINEERS PRIVATE LIMITED",
"VISHWAKARMA INSTITUTE OF INFORMATION TECHNOLOGY",
"VISHWAKARMA INSTITUTE OF TECHNOLOGY",
"VISHWAKARMA MACHINERY PRIVATE LIMITED",
"VISHWAKARMA MARITIME INSTITUTE",
"VISHWAKARMA MINERALS PRIVATE LIMITED",
"VISHWAKARMA PETROCHEM PRIVATE LIMITED",
"VISHWAKARMA REFRACTORIES PRIVATE LIMITED",
"VISHWAKARMA ROCKSTONES PRIVATE LIMITED",
"VISHWAKARMA SALVAGE PRIVATE LIMITED",
"VISHWAKARMA SCALES PRIVATE LIMITED",
"VISHWAKARMA SOLAR LIGHT PRIVATE LIMITED",
"VISHWAKARMA SUPPLIERS CONSTRUCTION PRIVATE LIMITED",
"VISHWAKARMA UNIVERSITY",
"VISHWAKARMA VIDYALAYA MARATHI PRIMARY",
"VISHWAKARMAN INFRATECH PRIVATE LIMITED",
"VISHWAKARMNA INSTITUTE OF TECHNOLOGY",
"VISHWAKRUPA PHARMA PRIVATE LIMITED",
"VISHWALAXMI TRADING AND FINANCE PRIVATE LIMITED",
"VISHWAM ASSOCIATES PRIVATE LIMITED",
"VISHWAM CONCRETE AND TECHNOLOGIES PRIVATE LIMITED",
"VISHWAM FABRICS PRIVATE LIMITED",
"VISHWAMBHAR CHEMICALS PRIVATE LIMITED",
"VISHWAMBHARI COMMODITIES INDIA PRIVATE LIMITED",
"VISHWAMITRA SALT COMPANY PRIVATE LIMITED",
"VISHWAMUKTA PRIVATE LIMITED",
"VISHWANADH AVENUES ( INDIA ) PRIVATE LIMITED",
"VISHWANATH AYURVEDIC MEDICAL COLLEGE H",
"VISHWANATH BHAGWATI COLD STORAGE PRIVATE LIMITED",
"VISHWANATH ENTERPRISES",
"VISHWANATH FOODS PRIVATE. LIMITED.",
"VISHWANATH HOTELS PVT LTD",
"VISHWANATH ISPAT PRIVATE LIMITED",
"VISHWANATH MATCHES PRIVATE LIMITED",
"VISHWANATH PAPER & BOARDS PRIVATE LIMITED",
"VISHWANATH PROJECTS LIMITED.",
"VISHWANATH RASAYANSHALA",
"VISHWANATH VYAPAR CO. PRIVATE LIMITED",
"VISHWANETHRA HEALTH SERVICES PRIVATE LIMITED",
"VISHWANIKETAN INSTITUTE OF MANAGEMENT ENTERPRUNERSHIP & ENGINEERING TECHNOLOGY",
"VISHWANIRANJAN SPECIALITY HOSPITAL PRIVATE LIMITED",
"VISHWANVI ENGINEERING PRIVATE LIMITED",
"VISHWAPREM DYEING AND PRINTING MILLS PRIVATE LIMITED",
"VISHWARAJ HOSPITAL",
"VISHWARAJ POLYCHEM PRIVATE LIMITED",
"VISHWARAJ SUGAR INDUSTRIES LIMITED",
"VISHWARATNA FURNITURES PRIVATE LIMITED",
"VISHWARATNA HOTEL PRIVATE LIMITED",
"VISHWAROOPA PETROCHEM PRIVATE LIMITED",
"VISHWARUPA INFRATECH PRIVATE LIMITED",
"VISHWAS AGRI SEEDS LIMITED",
"VISHWAS AUTO ENGINEERS PRIVATE LIMITED",
"VISHWAS AUTOLINK PRIVATE LIMITED",
"VISHWAS AUTOMATION PRIVATE LIMITED",
"VISHWAS BIO-GENATIC PRIVATE LIMITED",
"VISHWAS BUILDCON",
"VISHWAS BUILDERS",
"VISHWAS CONCRETE PRIVATE LIMITED",
"VISHWAS CONCRETE PRODUCTS PRIVATE LIMITED",
"VISHWAS CONSTRUCTION INDUSTRIES PRIVATE LIMITED",
"VISHWAS COTTON TRADING INDIA PRIVATE LIMITED",
"VISHWAS DESHPANDE ALLIANCE PRIVATE LIMITED",
"VISHWAS FINCAP SERVICES PRIVATE LIMITED",
"VISHWAS FOODS PRIVATE LIMITED",
"VISHWAS HITECH INFRAPROJECTS PRIVATE LIMITED",
"VISHWAS INDUSTRIAL AUTOTECH PRIVATE LIMITED",
"VISHWAS INFRASPACE PRIVATE LIMITED",
"VISHWAS INVESTMENT AND TRADING COMPANY PRIVATE LIMITED",
"VISHWAS JEWELS PRIVATE LIMITED",
"VISHWAS MILK PRODUCTS PRIVATE LIMITED",
"VISHWAS MULTITECH SYSTEM PRIVATE LIMITED",
"VISHWAS PEST CONTROL EXPERTS PRIVATE LIMITED",
"VISHWAS POLYPACKS PRIVATE LIMITED",
"VISHWAS PULSES PRIVATE LIMITED",
"VISHWAS RAYONS PRIVATE LIMITED",
"VISHWAS SHIPPING PRIVATE LIMITED",
"VISHWAS TUBES INDIA LIMITED",
"VISHWAS VISION FOR HEALTH. WELFARE AND SPECIAL NEEDS",
"VISHWASHANTI MERCHANDISE PRIVATE LIMITED",
"VISHWASHILPI ENGINEERING SOLUTIONS PRIVATE LIMITED",
"VISHWASHREYA FASHION PRIVATE LIMITED",
"VISHWA-SYNTHARO PHARMACHEM PRIVATE LIMITED",
"VISHWATMA COMMERCIAL PRIVATE LIMITED",
"VISHWATMA SOLAR ENERGY PRIVATE LIMITED",
"VISHWAUDYAM TECHNOLOGIES AND HR SERVICES PRIVATE LIMITED",
"VISHWAVIHAR HOLIDAYS PRIVATE LIMITED",
"VISHWAYODDHA SHETKARI MULTITRADE PRIVATE LIMITED",
"VISHWDEEP GLOBAL LOGISTICS PRIVATE LIMITED",
"VISHWESH HEATERS PRIVATE LIMITED",
"VISHWESH KNITTING AND DYEING MILLS PRIVATE LIMITED",
"VISHWESHWARAYYA ABHIYANTRIKI PADVIKA MAHAVIDYALAYA",
"VISHWKARMA IMPEX PRIVATE LIMITED",
"VISHWKARMA LAMINATES PRIVATE LIMITED",
"VISHWKARMA MANUFACTURING COMPANY PRIVATE LIMITED",
"VISHWRAJ INSTITUTE OF NURSING",
"VISIBLE ALPHA SOLUTIONS INDIA PRIVATE LIMITED",
"VISIBLE BODY PRIVATE LIMITED",
"VISIBLE INFOTECH PRIVATE LIMITED",
"VISICOLOR PAINTS PRIVATE LIMITED",
"VISID CONSTRUCTION PRIVATE LIMITED",
"VISIGHT TECHNOLOGIES PRIVATE LIMITED",
"VISILEAN INDIA PRIVATE LIMITED",
"VISION 21 H R RECRUITMENTS PRIVATE LIMITED",
"VISION 3K TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"VISION ADVANCE SPECIALITY CARBONS PRIVATE LIMITED",
"VISION ADVANCED CONSTRUCTION LIMITED",
"VISION AND WINGS EDUCATIONAL SOCIETY",
"VISION AVENUES PRIVATE LIMITED",
"VISION BEYOND RESOURCES INDIA PRIVATE LIMITED",
"VISION BIO-SCIENCE PRIVATE LIMITED",
"VISION BIOSCIENCES PRIVATE LIMITED",
"VISION BOOKS PRIVATE LIMITED",
"VISION CARE & IMPLANTS PRIVATE LIMITED",
"VISION CARE (INDIA) PRIVATE LIMITED",
"VISION CELL PRIVATE LIMITED",
"VISION CERAMIC PRIVATE LIMITED",
"VISION CIVIL ENGINEER CONTRACTOR AND VALUER",
"VISION COMPTECH INTEGRATORS LIMITED",
"VISION COMPTEL PRIVATE LIMITED",
"VISION COMTECH PRIVATE LIMITED",
"VISION CONTAINER LINE PRIVATE LIMITED",
"VISION CORPORATION LIMITED",
"VISION DATA ANALYTICS LLP",
"VISION DEMPO HOSPITALITY AND ESTATES PRIVATE LIMITED",
"VISION DEVOTE BUSINESS SOLUTIONS PRIVATE LIMITED",
"VISION DIAGNOSTIC INDIA PRIVATE LIMITED",
"VISION DISPLAY PRIVATE LIMITED",
"VISION DISTRIBUTION PRIVATE LIMITED",
"VISION DREAM REALITY PRIVATE LIMITED",
"VISION DRUGS PRIVATE LIMITED",
"VISION EARTHCARE PRIVATE LIMITED",
"VISION EIS CONSULTING PRIVATE LIMITED.",
"VISION ELEVATORS PRIVATE LIMITED",
"VISION ENGINEERING MADRAS PRIVATE LIMITED",
"VISION ENTECH PRIVATE LIMITED",
"VISION ENTERPRISES",
"VISION ENTERTAINMENT NETWORK PRIVATE LIMITED",
"VISION EYE CENTRE PRIVATE LIMITED",
"VISION FOODWORKS PRIVATE LIMITED",
"VISION FOOTCARE (INDIA) PRIVATE LIMITED",
"VISION FOREX PRIVATE LIMITED",
"VISION GEMS PRIVATE LIMITED",
"VISION GROUP RETAIL TECHNOLOGIES PRIVATE LIMITED",
"VISION HIRE ENTERTAINMENTS PRIVATE LIMITED",
"VISION HOSPITALITY SERVICES & CONSULTANTS PRIVATE LIMITED",
"VISION HOSPITALS PRIVATE LIMITED",
"VISION HVAC PRIVATE LIMITED",
"VISION INDIA COLONIZERS PRIVATE LIMITED",
"VISION INDIA DEVELOPERS PRIVATE LIMITED",
"VISION INDIA INFRASTRUCTURE PRIVATE LIMITED",
"VISION INDIA REALTORS PRIVATE LIMITED",
"VISION INDIA SERVICES PRIVATE LIMITED",
"VISION INDIA TALENT FOUNDATION",
"VISION INFINITY LIMITED",
"VISION INFPRO (INDIA) PRIVATE LIMITED",
"VISION INKS AND RESINS PRIVATE LIMITED",
"VISION INSTRUMENT CO. PRIVATE LIMITED",
"VISION INSULATION PRIVATE LIMITED",
"VISION INTEGRATED SERVICES VENTURES PRIVATE LIMITED",
"VISION INTERNATIONAL GROUP",
"VISION INTERNATIONAL SCHOOL",
"VISION INVEST TECH PRIVATE LIMITED",
"VISION ISOFTECH (INDIA) PRIVATE LIMITED",
"VISION ISPAT PRIVATE LIMITED",
"VISION IT SOFTWARE SOLUTIONS",
"VISION KREST EMBEDED TECHNOLOGIES PRIVATE LIMITED",
"VISION LABELS (INDIA) PRIVATE LIMITED",
"VISION LAMINATES PRIVATE LIMITED",
"VISION MANPOWER PRIVATE LIMITED",
"VISION MARITIME PRIVATE LIMITED",
"VISION MARKETING INFORMATION AND SERVICES PRIVATE LIMITED",
"VISION MECHATRONICS PRIVATE LIMITED",
"VISION MEDICAID EQUIPMENTS PRIVATE LIMITED",
"VISION MEDICAL DEVICES (INDIA) PRIVATE LIMITED",
"VISION MEDINST CARE PRIVATE LIMITED",
"VISION MEDITECH PRIVATE LIMITED",
"VISION METAL AIDS PRIVATE LIMITED",
"VISION MODE PRIVATE LIMITED",
"VISION MOTORS PRIVATE LIMITED",
"VISION MULTIMETALS PRIVATE LIMITED",
"VISION NETSOFT PRIVATE LIMITED",
"VISION NEWS PRIVATE LIMITED",
"VISION NEXT FOUNDATION",
"VISION PARENTERAL PRIVATE LIMITED",
"VISION PHARMACARE PRIVATE LIMITED",
"VISION PHARMACOAT PRIVATE LIMITED",
"VISION PLUS SECURITY CONTROL PRIVATE LIMITED",
"VISION POLYMER PRIVATE LIMITED",
"VISION PRECISION PRIVATE LIMITED",
"VISION PRIME TECH PRIVATE LIMITED",
"VISION PRINTEK PRIVATE LIMITED",
"VISION PROCON PVT LTD",
"VISION PRODUCTS PRIVATE LIMITED",
"VISION PROPERTY MANAGEMENT SERVICES PRIVATE LIMITED",
"VISION REALTECH PRIVATE LIMITED",
"VISION RESINS AND RESOL PRIVATE LIMITED",
"VISION RX LAB PRIVATE LIMITED",
"VISION SCIENCE INTERNATIONAL SCHOOL",
"VISION SMARTLINK NETWORKING PRIVATE LIMITED",
"VISION SOLUTIONS PRIVATE LIMITED",
"VISION SPONGE IRON PRIVATE. LIMITED.",
"VISION STATIONERY PRIVATE LIMITED",
"VISION SUPPORT SERVICES PRIVATE LIMITED",
"VISION SYSTEMS & SOLUTIONS",
"VISION TECHNOCRATES PRIVATE LIMITED",
"VISION TECHNOLOGY & STAFFING SOLUTIONS PRIVATE LIMITED",
"VISION TECHZONE PRIVATE LIMITED",
"VISION TELE LINKS PRIVATE LIMITED",
"VISION TELECOMMUNICATIONS INDIA PRIVATE LIMITED",
"VISION TRADESOLUTIONS (INDIA) PRIVATE LIMITED",
"VISION TRAVELS & TOURS PRIVATE LIMITED",
"VISION UNITED COMMERCIAL PRIVATE LIMITED",
"VISION VANIJYA PRIVATE LIMITED",
"VISION VIDYUT ENGINEERS PRIVATE LIMITED",
"VISION WATER PRIVATE LIMITED",
"VISION WORLD PRIVATE LIMITED",
"VISIONAIRE GLOBAL ENGINEERING PRIVATE LIMITED",
"VISIONAIRE LAB SYSTEMS PRIVATE LIMITED",
"VISIONAIRE TECHNOLOGIES INDIA PRIVATE LIMITED",
"VISIONARY DEVELOPMENT GROUP",
"VISIONARY MEDTECH SOLUTIONS PRIVATE LIMITED",
"VISIONARY RCM INFOTECH INDIA PRIVATE LIMITED",
"VISIONARY TECHNOCRATS PRIVATE LIMITED",
"VISIONET INFO SOLUTION PRIVATE LIMITED",
"VISIONET SYSTEMS PRIVATE LIMITED",
"VISIONFUND INDIA PRIVATE LIMITED",
"VISIONGEO INFORMATICS PRIVATE LIMITED",
"VISIONINDIA TECH SERVICES LIMITED",
"VISION-IT EDUCATION INDIA PRIVATE LIMITED",
"VISIONKRID STUDIO PRIVATE LIMITED",
"VISIONLIFE HEALTHCARE PRIVATE LIMITED",
"VISIONPARK MACHINERIES PRIVATE LIMITED",
"VISIONRI CONNEXION SERVICES PRIVATE LIMITED",
"VISIONS ENTERPRISES PRIVATE LIMITED",
"VISIONS MEDCOM PRIVATE LIMITED",
"VISIONSOFT ASPAC PRIVATE LIMITED",
"VISIONSPRING PRIVATE LIMITED",
"VISIONSPRINGINDIA",
"VISIONTEC CONSULTANTS MUMBAI PRIVATE LIMITED",
"VISIONTECH ENGINEERING PRIVATE LIMITED",
"VISIONTECH IT SERVICES PRIVATE LIMITED",
"VISIONTECH SYSTEM (INDIA) PRIVATE LIMITED",
"VISIONTEK CONSULTANCY SERVICES PRIVATE LIMITED",
"VISIONWAY IELTS AND IMMIGRATION PRIVATE LIMITED",
"VISISHT CORPORATE GROWTH ASSOCIATES PRIVATE LIMITED",
"VISISHTA TEJ INFRA INDIA PRIVATE LIMITED",
"VISISTA ESTATES PRIVATE LIMITED",
"VISISTA INSURANCE BROKING SERVICES PRIVATE LIMITED",
"VISIT HEALTH PRIVATE LIMITED",
"VISITECH ENGINEERS PRIVATE LTD",
"VISITOR GARMENTS",
"VISKAAN PHARMA PVT LTD",
"VISKAGRO PRIVATE LIMITED",
"VISKAN LOGISTICS SERVICES PRIVATE",
"VISMA FASHION EMBROIDERY PRIVATE LIMITED",
"VISMA PLASTICS PRIVATE LIMITED",
"VISMAAD MEDIATECH PRIVATE LIMITED",
"VISMAYA CONSTRUCTIONS PRIVATE LIMITED",
"VISMAYA INFOTECH SOLUTIONS PRIVATE LIMITED",
"VISMAYA SUPERPROJECTS PRIVATE LIMITED",
"VISN LOGISTICS PRIVATE LIMITED",
"VISNAGAR LEASE FINANCE LIMITED",
"VISNUKUMAR TRADERS PRIVATE LIMITED",
"VISOKA ENGINEERING PRIVATE LIMITED",
"VI-SON CABLES PRIVATE LIMITED",
"VISPARK JEWELLERY MANUFACTURERS PRIVATE LIMITED",
"VISPRO ALPHA PRIVATE LIMITED",
"VISPRO MEGATRADES LIMITED",
"VISPUTE JEWELLERS PRIVATE LIMITED",
"VISRUTA HEALTHCARE PRIVATE LIMITED",
"VISSCO HEALTHCARE PRIVATE LIMITED",
"VISSCO REHABILITATION AIDS PRIVATE LIMITED",
"VISSION AUTOMATION PRIVATE LIMITED",
"VISSKAN AVIATION PRIVATE LIMITED",
"VISSOL VASSU TECH SERVICES PRIVATE LIMITED",
"VISTA AGRIGENETICS PRIVATE LIMITED",
"VISTA BILLABONG HIGH INTERNATIONAL SCHOOL",
"VISTA BPO PRIVATE LIMITED",
"VISTA CAPITAL ADVISORS PRIVATE LIMITED",
"VISTA CHEMTECH PRIVATE LIMITED",
"VISTA CONSOLES ELECTRONICS PRIVATE LIMITED",
"VISTA DRIVELINE MOTORS PRIVATE LIMITED",
"VISTA ENGG SOLUTIONS PRIVATE LIMITED",
"VISTA FINANCE AND LEASING PRIVATE LIMITED",
"VISTA FORTIFOODS PRIVATE LIMITED",
"VISTA FURNISHING LIMITED",
"VISTA FURNISHING PRIVATE LIMITED",
"VISTA INDIA DIGITEK PRIVATE LIMITED",
"VISTA INFORMATION SYSTEMS PRIVATE LIMITED",
"VISTA INFRACON PRIVATE LIMITED",
"VISTA INTERNATIONAL SCHOOL",
"VISTA IT SOLUTIONS PRIVATE LIMITED",
"VISTA KNITBERRY FASHIONS LIMITED",
"VISTA KNITBERRY FASHIONS P LIMITED",
"VISTA LOGISTICS PRIVATE LIMITED",
"VISTA OFFICE SYSTEMS PRIVATE LIMITED",
"VISTA PACKAGING PRIVATE LIMITED",
"VISTA PANELS PRIVATE LIMITED",
"VISTA PRINT PRIVATE LIMITED",
"VISTA PROCESSED FOODS PRIVATE LIMITED",
"VISTA RESIDENCY PRIVATE LIMITED",
"VISTA RETAIL PRIVATE LIMITED",
"VISTA SALES PRIVATE LIMITED",
"VISTA SOLAR ENERGY LIMITED",
"VISTA SPACES ANANDA PRIVATE LIMITED",
"VISTA SPACES SUN (RAINTREE) PRIVATE LIMITED",
"VISTA SPECIALITY DIAGNOSTICS PRIVATE LIMITED",
"VISTA TIE-UP PRIVATE LIMITED",
"VISTA TRADECOMM PRIVATE LIMITED",
"VISTA WEALTH PRIVATE LIMITED",
"VISTAAR DIGITAL COMMUNICATIONS PRIVATE LIMITED",
"VISTAAR ENTERTAINMENT VENTURES PRIVATE LIMITED",
"VISTAAR FINANCIAL SERVICES PRIVATE LIMITED",
"VISTAAR SYSTEMS PRIVATE LIMITED",
"VISTAARA POWER KURTAKOTI PRIVATE LIMITED",
"VISTAAS DIGITAL MEDIA PRIVATE LIMITED",
"VISTACORE INFRAPROJECTS PRIVATE LIMITED",
"VISTAGLOBAL TEXTILES PRIVATE LIMITED",
"VISTAMIND EDUCATION PRIVATE LIMITED",
"VISTAR AMAR LIMITED",
"VISTAR BUILDERS AND DEVELOPERS",
"VISTAR CONSTRUCTIONS PRIVATE LIMITED",
"VISTAR LOGITEK PRIVATE LIMITED",
"VISTAR PROPERTIES PRIVATE LIMITED",
"VISTARA FARMS PRIVATE LIMITED",
"VISTARA INDUSTRIES (I) PRIVATE LIMITED",
"VISTARA PRODUCTS PRIVATE LIMITED",
"VISTARAN HEALTH CARE SERVICES PRIVATE LIMITED",
"VISTAS AD MEDIA COMMUNICATIONS PRIVATE LIMITED",
"VISTAS DESIGNERS PRIVATE LIMITED",
"VISTAS INVESTMENTS PRIVATE LIMITED",
"VISTAS JEWELLERS PRIVATE LIMITED",
"VISTAS TECHNOLABS PRIVATE LIMITED",
"VISTASPACES ASSETS LLP",
"VISTASPACES EPC PRIVATE LIMITED",
"VISTASTORES ONLINE PRIVATE LIMITED",
"VISTATEQ VIRTUOSITY INDIA PRIVATE LIMITED",
"VISTEON CORPORATION",
"VISTEON ELECTRONICS INDIA PRIVATE LIMITED",
"VISTEON TECHNICAL AND SERVICES CENTRE PRIVATE LIMITED",
"VISTEX ASIA - PACIFIC PRIVATE. LIMITED.",
"VISTRA CORPORATE SERVICES INDIA PRIVATE LIMITED",
"VISTRA INTERNATIONAL EXPANSION INDIA PRIVATE LIMITED",
"VISTRA ITCL INDIA LIMITED",
"VISU POLY PRODUCTS PRIVATE LIMITED",
"VISUAL AUTOLINK PRIVATE LIMITED",
"VISUAL BI SOLUTIONS INDIA PRIVATE LIMITED",
"VISUAL CHEM CLEAN SERVICES PRIVATE LIMITED",
"VISUAL CITI SIGNS & DISPLAYS PRIVATE LIMITED",
"VISUAL COLLABORATION TECHNOLOGIES PRIVATE LIMITED",
"VISUAL DISPLAY SOLUTION PRIVATE LIMITED",
"VISUAL EDGE MARKETING PRIVATE LIMITED",
"VISUAL EDUCATION AIDS PRIVATE LIMITED",
"VISUAL GRAPHICS COMPUTING SERVICES INDIA PRIVATE LIMITED",
"VISUAL HOUSE INDIA PRIVATE LIMITED",
"VISUAL INFOSOFT PRIVATE LIMITED",
"VISUAL IQ TECHNO SERVICES INDIA PRIVATE LIMITED",
"VISUAL IT SOLUTIONS PRIVATE LIMITED",
"VISUAL MERCHANDISE SOLUTIONS PRIVATE LIMITED",
"VISUAL METAPHOR INDIA PRIVATE LIMITED",
"VISUAL MOTORS PRIVATE LIMITED",
"VISUAL PERCEPT SOLAR PROJECTS PRIVATE LIMITED",
"VISUAL QUEST INDIA PRIVATE LIMITED",
"VISUAL SCULPTORS DESIGN SERVICES PRIVATE LIMITED",
"VISUAL SECURAS LIMITED",
"VISUAL SECURITIES PRIVATE LIMITED",
"VISUAL SYNERGY PRIVATE LIMITED",
"VISUAL TECHNOLOGIES INDIA PRIVATE LIMITED",
"VISUAL VIBRATIONS PRIVATE LIMITED",
"VISUALEYES COMMUNICATIONS PRIVATE LIMITED",
"VISUALIZE TRADECOM PRIVATE LIMITED",
"VISUALMEDIA SYSTEMS PRIVATE LIMITED",
"VISUALPOINT INDIA PRIVATE LIMITED",
"VISUALS STOCK PRIVATE LIMITED",
"VISUDHI DEVELOPERS PRIVATE LIMITED",
"VISUDIRA IMPEX PRIVATE LIMITED",
"VISUELL CREATIONS",
"VISURA (INDIA) LIMITED",
"VISURA TRADING & INVESTMENT INDIA LIMITED",
"VISUSOFT PRIVATE LIMITED",
"VISVAS PROMOTERS PRIVATE LIMITED",
"VISVAS VOYAGES INDIA PRIVATE LIMITED",
"VISVASRK INFRASTRUCTURE PRIVATE LIMITED",
"VISVES DENIM PRIVATE LIMITED",
"VISVESVARAYA COLLEGE OF ENGINEERING AND TECHNOLOGY",
"VISVESVARAYA JALA NIGAM LIMITED",
"VISVESVARAYA NATIONAL INSTITUTE OF TECHNOLOGY",
"VISVESVARAYA TECHNOLOGICAL UNIVERSITY",
"VISVESWARAPURA COLLEGE OF SCIENCE",
"VISVESWARAPURAM COLLEGE",
"VISVESWARAPURAM EVENING COLLEGE",
"VISVIC ENTERPRISES PRIVATE LIMITED",
"VISWA AND DEVJI DIAMONDS PRIVATE LIMITED",
"VISWA INTERIORS PRIVATE LIMITED",
"VISWA LABORATORIES PRIVATE LIMITED",
"VISWA SANTOSH ENTERPRISES PRIVATE LIMITED",
"VISWA SOWBHAGYA MILK PRODUCTS PVT LTD",
"VISWA VIJETHA AGROS INDIA PRIVATE LIMITED",
"VISWAAT CHEMICALS LIMITED",
"VISWABHARATHI EDUCATIONAL SOCIETY",
"VISWABHARATHI HOUSING PRIVATE LIMITED",
"VISWADEEP MEDICAL SERVICES PRIVATE LIMITED",
"VISWADEEPTHI MULTI STATE AGRI CO OPERATIVE SOCIETY LTD",
"VISWADHAM COMMODITIES LLP",
"VISWAK ADVANCE POLYMERS PRIVATE LIMITED",
"VISWAKARMA LOGISTICS PRIVATE LIMITED",
"VISWAKARMA ROOFINGS INDIA PRIVATE LIMITED",
"VISWAL HOUSE KEEPING SERVICES PRIVATE LIMITED",
"VISWAM DIGITAL PRESS PRIVATE LIMITED",
"VISWAM ENGINEERS",
"VISWAM GLOBAL SOLUTIONS PRIVATE LIMITED",
"VISWAMBARA SOFTWARE SYSTEMS PRIVATE LIMITED",
"VISWAMBI SECURITY AGENCY PRIVATE LIMITED",
"VISWAMITHRA BIOAGRO PRIVATE LIMITED",
"VISWANADHA RAJU KONDURU",
"VISWANATH ELECTRICALS PRIVATE LIMITED",
"VISWANATHAN CONSTRUCTIONS PRIVATE LIMITED",
"VISWANATHAN SECURITIES PRIVATE LIMITED",
"VISWANETRA AGENCIES PRIVATE LIMITED",
"VISWAPRIYA AGRO FARMS PRIVATE LIMITED",
"VISWAROOPI ENERGY PRIVATE LIMITED",
"VISWARUPA AUTOMOTIVES PRIVATE LIMITED",
"VISWA'S BULLIONS PRIVATE LIMITED",
"VISWASAI EDUCATIONAL SOCIETY",
"VISWASAI FOODS & COLD STORAGE PRIVATE LIMITED",
"VISWATEJA CONSTRUCTIONS",
"VISWATEJA SPINNING MILLS PRIVATE LIMITED",
"VIT AP UNIVERSITY",
"VIT CONSULTANCY PRIVATE LIMITED",
"VITA AGRO INDUSTRIES PRIVATE LIMITED",
"VITA HEALTH PRIVATE LIMITED",
"VITA PLASTO PRODUCTS PRIVATE LIMITED",
"VITA PRIVATE LIMITED",
"VITA SANA FOODS PRIVATE LIMITED",
"VITA SCIENTIA GLOBUS PRIVATE LIMITED",
"VITA TECHNOLOGY PRIVATE LIMITED",
"VITAAGLOBAL BIOSCIENCE PRIVATE LIMITED",
"VITABIOTECH HEALTHCARE PRIVATE LIMITED",
"VITABOLIK PHARMACEUTICALS PRIVATE LIMITED",
"VITACARE MEDICAL SOLUTIONS PRIVATE LIMITED",
"VITAE INTERNATIONAL ACCOUNTING SERVICES PRIVATE LIMITED",
"VITAGE SYSTEMS PRIVATE LIMITED",
"VITAGREEN PRODUCTS PRIVATE LIMITED",
"VITAL APPARELS PRIVATE LIMITED",
"VITAL BIOTECHNOLOGIES PRIVATE LIMITED",
"VITAL CARE PVT LTD GUJRAT",
"VITAL CROP SCIENCE PRIVATE LIMITED",
"VITAL ENVIRONMENT INDIA PRIVATE LIMITED",
"VITAL FACILITIES PRIVATE LIMITED",
"VITAL FUEL LOGISTICS PRIVATE LIMITED",
"VITAL HEALTHCARE PRIVATE LIMITED SANTACRUZ",
"VITAL HOME REALTIES PRIVATE LIMITED",
"VITAL HOSPITALITY PRIVATE LIMITED",
"VITAL INDUSTRIES INDIA PRIVATE. LIMITED.",
"VITAL LABORATORIES PRIVATE LIMITED",
"VITAL LIFESCIENCES PRIVATE LIMITED",
"VITAL MEDIHEALTH CARE PRIVATE LIMITED",
"VITAL PAPER INTERNATIONAL PRIVATE LIMITED",
"VITAL PAPER PRODUCTS PRIVATE LIMITED",
"VITAL RECORDS PRIVATE LIMITED",
"VITAL SIGN MEDIDEVICES PRIVATE LIMITED",
"VITAL SYNTHETICLABS PRIVATE LIMITED",
"VITAL THERAPEUTICS AND FORMULATIONS PRIVATE LIMITED",
"VITAL THERAPEUTICS PRIVATE LIMITED",
"VITAL VERTEX VALUE VENTURE PRIVATE LIMITED",
"VITAL WIRES CONSULTING PRIVATE LIMITED",
"VITALCHAIN TECHNOLOGIES PRIVATE LIMITED",
"VITALCORE INDUSTRIALS PRIVATE LIMITED",
"VITALHEALTH SOFTWARE INDIA PRIVATE LIMITED.",
"VITALIC HEALTH LIMITED",
"VITALIC HEALTH PRIVATE LIMITED",
"VITALITY AQUACULTURE PRIVATE LIMITED",
"VITALIUM DENTAL LAB PRIVATE LIMITED",
"VITALIZE GALAXY PRIVATE LIMITED",
"VITALMED SOLUTIONS AND SERVICES PRIVATE LIMITED",
"VITALY INDIA PRIVATE LIMITED",
"VITALYS PHARMACEUTICALS PRIVATE LIMITED",
"VITAM ENGINEERING COLLEGE",
"VITAMAX HEALTHCARE PRIVATE LIMITED",
"VITAMINS DIRECT SERVICES PRIVATE LIMITED",
"VITAN MEDICAL SYSTEMS PRIVATE LIMITED",
"VITANE BIOLOGICS PRIVATE LIMITED",
"VITANE PHARMACEUTICALS PRIVATE LIMITED",
"VITANUTRIX FOODS AND FEEDS PRIVATE LIMITED",
"VIT-AP UNIVERSITY",
"VITARA FOODS AND BEVERAGES PRIVATE LIMITED",
"VITARA INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"VITARAN ELECTRONICS PRIVATE LIMITED",
"VITARI DISTRIBUTORS PRIVATE LIMITED",
"VITARICH AGRO FOOD (INDIA) LIMITED",
"VITASTA CONSULTING PRIVATE LIMITED",
"VITASTA ENVIRO SERVICES PRIVATE LIMITED",
"VITASTA PUBLISHING PRIVATE LIMITED",
"VITASTAA ONLINE SERVICES PRIVATE LIMITED",
"VITAZ FOOD AND BEVERAGES PRIVATE LIMITED",
"VITCO TEA & ALLIED PRIVATE LIMITED",
"VITEB SOLUTIONS PRIVATE LIMITED",
"VITECH ENVIRO SYSTEMS PRIVATE LIMITED",
"VITECH EQUIPMENTS PRIVATE LIMITED",
"VITECH HEAVY EQUIPMENTS PRIVATE LIMITED",
"VITECH SYSTEMS ASIA PRIVATE LIMITED",
"VITERRA INDIA PRIVATE LIMITED",
"VITESCO TECHNOLOGIES INDIA PRIVATE LIMITED",
"VITESH INFRASTRUCTURE PRIVATE LIMITED",
"VITESSE PRIVATE LIMITED",
"VITESSE TRAVELS PRIVATE LIMITED",
"VITEZA ENTERPRISES PRIVATE LIMITED",
"VITHABAI AGRO PRODUCT PRIVATE LIMITED",
"VITHADWAITHA FINANCIAL SERVICES PRIVATE LIMITED",
"VITHAI ENGINEERING PRIVATE LIMITED",
"VITHAI INTERNATIONAL SERVICES PRIVATE LIMITED",
"VITHAL CASTOR POLYOLS PRIVATE LIMITED",
"VITHAL VAMAN MUTHYE AROMATICS PRIVATE LIMITED",
"VITHALDAS JEWELLERS PRIVATE LIMITED",
"VITHALRAO CHAMAT U P SCHOOL PARDI NAGPUR",
"VITHAYATHIL HEALTHCARE PRIVATE LIMITED",
"VITHI IT SOLUTIONS PRIVATE LIMITED",
"VITIZEN HOTELS LIMITED",
"VITMA POSITECH PRIVATE LIMITED",
"VITO INDIA ADVISORS PRIVATE LIMITED",
"VITON ENGINEERS PRIVATE LIMITED",
"VITP PRIVATE LIMITED",
"VITRA INDIA GLASS PRIVATE LIMITED",
"VITRA INDIA PRIVATE LIMITED",
"VITRAAG INDIA PRIVATE LIMITED",
"VITRAG BIOFABS PRIVATE LIMITED",
"VITRAG CHEMICALS PRIVATE LIMITED",
"VITRAG CREATION PRIVATE LIMITED",
"VITRAG ENTERPRISE LLP",
"VITRAG FABRICS PRIVATE LIMITED",
"VITRAG FOAM PRIVATE LIMITED",
"VITRAG METAL PRIVATE LIMITED",
"VITREOUS CONTRACTS SOLUTIONS PRIVATE LIMITED",
"VITREX INFRA PRIVATE LIMITED",
"VITRO FURNITURE PRIVATE LIMITED",
"VITRO SUPPLIERS PVT LTD",
"VITRO WORLD HEALTHCARE PRIVATE LIMITED",
"VITROMED HEALTHCARE",
"VITRONICS CONTROLS PRIVATE LIMITED",
"VITRUM GLASS - EMPIRE INDUSTRIES LIMITED",
"VITS HOTEL",
"VITS TOTAL POWER SOLUTIONS PRIVATE LIMITED",
"VITSON STEEL CORP PRIVATE LIMITED",
"VITT MANAGEMENT SERVICES",
"VITTAL'S MEDICARE PRIVATE LIMITED",
"VITTANATH POWER PRIVATE LIMITED",
"VITTHAL DAS & SONS PRIVATE LIMITED",
"VITTHAL ENTERPRISES PRIVATE LIMITED",
"VITTHAL FINSERVE PRIVATE LIMITED",
"VITTHAL ISPAT PRIVATE LIMITED",
"VITTHAL NAGAR",
"VITTHAL POLYPACK PRIVATE LIMITED",
"VITTHAL SAYANA GENERAL HOSPITAL",
"VITTHAL SAYANNA GENERAL HOSPITAL THANE",
"VITTHAL TEXTILES PRIVATE LIMITED",
"VITTHALAI FOUNDRY PRIVATE LIMITED",
"VITTHALGANGA FARMERS PRODUCER COMPANY LIMITED",
"VITTHALRATNA SHRI PAPER TECH PRIVATE LIMITED",
"VITTHOBA MAULI INFRAPROJECT PRIVATE LIMITED",
"VITTIBHUMI PROJECTS PRIVATE LIMITED",
"VITTORIA DESIGNS PRIVATE LIMITED",
"VITTRAK DISTRIBUTORS PRIVATE LIMITED",
"VITUSSPINE CARE & RESEARCH PRIVATE LIMITED",
"VIVA AGRI PRIVATE LIMITED",
"VIVA AGRO & FOODS",
"VIVA APPAREL PRIVATE LIMITED",
"VIVA ARRHYTHMIA SOLUTIONS LLP",
"VIVA BOARDS PRIVATE. LIMITED.",
"VIVA BOOKS PRIVATE LIMITED",
"VIVA CITY WOVEN SACK PRIVATE LIMITED",
"VIVA COLLEGE",
"VIVA COMMUNICATIONS PRIVATE LIMITED",
"VIVA COMPOSITE PANEL PRIVATE LIMITED",
"VIVA DRUGS PRIVATE LIMITED",
"VIVA EXIM PRIVATE LIMITED",
"VIVA FACILITY SERVICES PRIVATE LIMITED",
"VIVA FACILITY SERVICES PRIVATE LIMITED¬†",
"VIVA FACILITY SERVICES PRIVATE LIMITED",
"VIVA HIGHWAYS LIMITED",
"VIVA HOLIDAYS TOURS AND TRAVELS PRIVATE LIMITED",
"VIVA HOME FINANCE LIMITED",
"VIVA HONDA",
"VIVA IMAGES PRIVATE LIMITED",
"VIVA INFRACON PRIVATE LIMITED",
"VIVA INFRASTRUCTURE LIMITED",
"VIVA INSTITUTE OF PHARMACY",
"VIVA LIFESCIENCES PRIVATE LIMITED",
"VIVA MAGNA WHEELERS PRIVATE LIMITED",
"VIVA PACK PRIVATE LIMITED",
"VIVA RAILING SYSTEMS PRIVATE LIMITED",
"VIVA SERVITRADE PRIVATE. LIMITED.",
"VIVA THE SCHOOL",
"VIVA TOTAL FACILITY AND MANAGEMENT SERVICES PRIVATE LIMITED",
"VIVA VOYAGES PRIVATE LIMITED",
"VIVA WINNER VENTURE REALTORS LLP",
"VIVAA TRADECOM LIMITED",
"VIVAAMART ENTERPRISES INDIA PRIVATE LIMITED",
"VIVAAN BUILDCON PROJECTS PRIVATE LIMITED",
"VIVAAN CONTECH INDIA PRIVATE LIMITED",
"VIVAAN ELECTRONIC TECHNOLOGY PRIVATE LIMITED",
"VIVAAN FLEXI PACK PRIVATE LIMITED",
"VIVAAN RENEWABLE PRIVATE LIMITED",
"VIVAAN SOLAR PRIVATE LIMITED",
"VIVAAN SPECIALITY WIRE PRIVATE LIMITED",
"VIVAAN SPUNTEX PRIVATE LIMITED",
"VIVAANSH EDUTECH PRIVATE LIMITED",
"VIVA-API LABS PRIVATE LIMITED",
"VIVAAZ JEWELS PRIVATE LIMITED",
"VIVACHEM INTERMEDIATES PRIVATE LIMITED",
"VIVACI LUXURY PRIVATE LIMITED",
"VIVACIOUS ENTERPRISES PRIVATE LIMITED",
"VIVACIOUS MINING DEVELOPERS PRIVATE LIMITED",
"VIVACIOUS PHARMATEX PRIVATE LIMITED",
"VIVACITY ENTERTAINMENT INDIA PRIVATE LIMITED",
"VIVACITY MALL PRIVATE LIMITED",
"VIVACITY TRADE AND COMMERCE PRIVATE LIMITED",
"VIVACONNECT PRIVATE LIMITED",
"VIVADA CORPORATION LIMITED",
"VIVADI MANAGEMENT SERVICES PRIVATE LIMITED",
"VIVAGEN HEALTHCARE PRIVATE LIMITED",
"VIVAH TEXTILES PRIVATE LIMITED",
"VIVAHOLIDAY PLANNERS PRIVATE LIMITED",
"VIVALA BEVERAGES PRIVATE LIMITED",
"VIVALA CARTONS PRIVATE. LIMITED.",
"VIVALAVITA PHARMACEUTICALS PRIVATE LIMITED",
"VIVALDI LEATHER PRIVATE LIMITED",
"VIVALDIS HEALTH AND FOODS PRIVATE LIMITED",
"VIVALIA REMEDIES PRIVATE LIMITED",
"VIVAN ACIDCHEM PRIVATE LIMITED",
"VIVAN AGRO SOLUTIONS PRIVATE LIMITED",
"VIVAN BUSINESS CONSULTANTS PRIVATE LIMITED",
"VIVAN FOODS PRIVATE LIMITED",
"VIVAN INDUSTRIES PRIVATE LIMITED",
"VIVAN LIFE SCIENCES PRIVATE LIMITED",
"VIVAN PAPER BOX (OPC) PRIVATE LIMITED",
"VIVAN STEELS PRIVATE LIMITED",
"VIVANT SOLUTIONS PRIVATE LIMITED",
"VIVANTA BY TAJ - SURAJKUND",
"VIVANTA BY TAJ BEGUMPET",
"VIVANTA CERAMIC PRIVATE LIMITED",
"VIVANTA DIAGNOSTIC PRIVATE LIMITED",
"VIVANTA LABORATORIES PRIVATE LIMITED",
"VIVANTA SEEDS PRIVATE LIMITED",
"VIVANTE FOODS PRIVATE LIMITED",
"VIVANZA LIFESCIENCES PRIVATE LIMITED",
"VIVARDHANA MICROFINANCE LIMITED",
"VIVARTANA VENTURES INDIA PRIVATE LIMITED",
"VIVASA DEVELOPERS PRIVATE LIMITED",
"VIVASV INFRA INDIA PRIVATE LIMITED",
"VIVASVAT RETAIL AND IT SERVICES PRIVATE LIMITED",
"VIVASVAT SOLAR ENERGY PRIVATE LIMITED",
"VIVASWAN HOTELS (INDIA) PRIVATE LIMITED",
"VIVATECH R&D PRIVATE LIMITED",
"VIVATEST RESEARCH AND DEVELOPMENT PRIVATE LIMITED",
"VIVAZPERK BUSINESS SERVICES (OPC) PRIVATE LIMITED",
"VIVEJA IT SERVICES PRIVATE LIMITED",
"VIVEK AGROTECH PRIVATE LIMITED",
"VIVEK ALLOYS PRIVATE LIMITED.",
"VIVEK ANCILLARY PRIVATE LIMITED",
"VIVEK BHOLE ARCHITECTS PRIVATE LIMITED",
"VIVEK BHOLE CONSULTANTS PRIVATE LIMITED",
"VIVEK BULB INDUSTRIES PVT LTD",
"VIVEK COLD STORAGE PVT LTD",
"VIVEK CONTRACTS PRIVATE LIMITED",
"VIVEK CONTROL SYSTEMS PRIVATE LIMITED",
"VIVEK EQUIPMENTS PRIVATE LIMITED",
"VIVEK FINANCIAL FOCUS LIMITED",
"VIVEK FREIGHT & LOGISTICS PRIVATE LIMITED",
"VIVEK INFRADEVELOPERS PRIVATE LIMITED",
"VIVEK KNITFAB PRIVATE LIMITED",
"VIVEK MITTAL HOTELS PRIVATE LIMITED",
"VIVEK OUTSOURCING SERVICES PRIVATE LIMITED",
"VIVEK PHARMACHEM INDIA LIMITED",
"VIVEK PLY AND VENEERS PRIVATE LIMITED",
"VIVEK POLYCHEM PRIVATE LIMITED",
"VIVEK POLYPLAST INDIA PRIVATE LIMITED",
"VIVEK PRIVATE LIMITED",
"VIVEK REALTY & RESORTS PRIVATE LIMITED",
"VIVEK ROADLINES PRIVATE LIMITED",
"VIVEK SONI EDUCATIONAL INSTITUTE PRIVATE LIMITED",
"VIVEK SPICES PRIVATE LIMITED",
"VIVEK SRI FARMS PRIVATE LIMITED",
"VIVEK STEELS SKYLINE PRIVATE LIMITED",
"VIVEK TRADE CONSULTANTS PRIVATE LIMITED",
"VIVEK TRADELINK PRIVATE LIMITED",
"VIVEK VYAPAR LIMITED",
"VIVEKA HOSPITAL",
"VIVEKA LOGISTICS SOLUTIONS PRIVATE LIMITED..",
"VIVEKA PU COLLEGE KOTA",
"VIVEKA SUPER SPECIALITY HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED",
"VIVEKAM FINANCIAL SERVICES PRIVATE LIMITED",
"VIVEKAM SR SEC SCHOOL",
"VIVEKANAND ARTS SARDARDALIP SING COMMERCE AND SCIENCE COLLEGE",
"VIVEKANAND BUILDERS PVT LTD",
"VIVEKANAND EDUCATION SCOETY S INSTITUTE",
"VIVEKANAND EDUCATION SOCIETY VES INSTITUTE OF TECHNOLOGY",
"VIVEKANAND ENGLISH MEDIUM SCHOOL CHOPDA JALGAON",
"VIVEKANAND ENTERPRISE",
"VIVEKANAND FOOD ADDITIVES DEALERS PRIVATE LIMITED",
"VIVEKANAND HOSPITAL",
"VIVEKANAND HOSPITAL FERTILITY CENTRE",
"VIVEKANAND INDUSTRIES PRIVATE LIMITED",
"VIVEKANAND INSTITUTE OF NEUROLOGY NEUROSURGERY & SPINE",
"VIVEKANAND INSTITUTE OF TECHNOLOGY S COL",
"VIVEKANAND MEDICAL MISSION LIMITED",
"VIVEKANAND NURSING HOME PRIVATE LIMITED",
"VIVEKANAND PUBLIC SCHOOL",
"VIVEKANAND VIDYA MANDIR RANCHI",
"VIVEKANAND VIDYA NIKETAN",
"VIVEKANAND VIDYALAYA",
"VIVEKANANDA CEREALS PRIVATE LIMITED",
"VIVEKANANDA COLLEGE",
"VIVEKANANDA COLLEGE FOR WOMEN",
"VIVEKANANDA DEGREE & PG COLLEGE",
"VIVEKANANDA EDUCATIONAL TRUST",
"VIVEKANANDA FIRST GRADE COLLEGE",
"VIVEKANANDA GLOBAL UNIVERSITY",
"VIVEKANANDA HEEMGHAR PVT LTD",
"VIVEKANANDA HIGH SCHOOL",
"VIVEKANANDA HOSPITAL PVT LTD",
"VIVEKANANDA INSTITUTE OF TECHNOLOGY & SCIENCE",
"VIVEKANANDA KENDRA PRAKASHAN TRUST",
"VIVEKANANDA KENDRA VIDYALAYA",
"VIVEKANANDA MISSION SCHOOL",
"VIVEKANANDA PADDY FLOUR MILLS PRIVATE LIMITED",
"VIVEKANANDA PRE UNIVERSITY COLLEGE",
"VIVEKANANDA SEEDS",
"VIVEKANANDA VIDYA MANDIR",
"VIVEKANANDA VIDYAPEETH",
"VIVEKANANDA WORLD SCHOOL",
"VIVEKANDA MATRIC HR SEC SCHOOL",
"VIVEKLENE INDUSTRIES PRIVATE LIMITED",
"VIVEKNANAD EDUCATION SOCIETY POLYTECHNIC",
"VIVEK'S GREEN HOMES PRIVATE LIMITED",
"VIVEKSHIL AGRO SALES PRIVATE LIMITED",
"VIVEN FARMS PRIVATE LIMITED",
"VIVENNS GLOBAL PRIVATE LIMITED",
"VIVENSAS INFOTECH PRIVATE LIMITED",
"VIVENTIS RECRUITMENT (OPC) PRIVATE LIMITED",
"VIVERA PRIVATE LIMITED",
"VIVERATI INTERACTIVE MARKETING PRIVATE LIMITED",
"VIVERE IMAGING PRIVATE LIMITED",
"VIVERO PHARMACEUTICALS PRIVATE LIMITED",
"VIVERS FRESH ORGANIC GAYATRI FARMS PRIVATE LIMITED",
"VIVESH INFOTECH PRIVATE LIMITED",
"VIVESSA INDUSTRIES PRIVATE LIMITED",
"VIVGAM MARKETING PRIVATE LIMITED",
"VIVI FACILITY MANAGEMENT SERVICE PRIVATE LIMITED",
"VIVI ORGO-CHEM INDUSTRIES PVT LTD",
"VIVIA ADVERTISING PRIVATE LIMITED",
"VIVIA INTERNATIONAL PRIVATE LIMITED",
"VIVIAL FORGE PRIVATE LIMITED",
"VIVIANA POWER TECH LIMITED",
"VIVIANA VITRIFIED PRIVATE LIMITED",
"VIVIANO HEALTHCARE PRIVATE LIMITED",
"VIVID BIOTECH (INDIA) PRIVATE LIMITED",
"VIVID BIOTEK PRIVATE LIMITED",
"VIVID CLOTHING PVT LTD",
"VIVID DIAGNOSTICS PRIVATE LIMITED",
"VIVID DIGITEX PRIVATE LIMITED",
"VIVID EDGE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"VIVID ELECTROMECH PRIVATE LIMITED",
"VIVID FASHIONS PVT LTD.",
"VIVID GEOSPATIAL SERVICES",
"VIVID GLOBAL INDUSTRIES LIMITED",
"VIVID INDIA CORPORATE ADVISORS PRIVATE LIMITED",
"VIVID INFRASOLUTIONS PRIVATE LIMITED",
"VIVID INFRAZONE PRIVATE LIMITED",
"VIVID INTERMEDIATES PRIVATE LIMITED",
"VIVID INTERNATIONAL PRIVATE LIMITED",
"VIVID LABS PRIVATE LIMITED",
"VIVID LIFESTYLE PRIVATE LIMITED",
"VIVID LOGISTICS I PRIVATE LIMITED",
"VIVID MANUFACTURING COMPANY PRIVATE LIMITED",
"VIVID MERCANTILE LIMITED",
"VIVID PACKAGING PRIVATE LIMITED",
"VIVID PLASTICS PRIVATE LIMITED",
"VIVID PLUS PRIVATE LIMITED",
"VIVID SOLAIRE ENERGY PRIVATE LIMITED",
"VIVID TECHNOLOGIES STAFFING LLP",
"VIVID VISIONS TREXIM PRIVATE LIMITED",
"VIVIDH COMMERCIAL PRIVATE LIMITED",
"VIVIDH DISTRIBUTORS PVT LTD",
"VIVIDH FINVEST PRIVATE LIMITED",
"VIVIDH HI-FAB PRIVATE LIMITED",
"VIVIDH LANDSCAPE CONSULTANTS PRIVATE LIMITED",
"VIVIDH METALTECH PRIVATE LIMITED",
"VIVIDH PACKAGING PRIVATE LIMITED",
"VIVIDH PRINT MEDIA PRIVATE LIMITED",
"VIVIDH SILK AGENCY PVT LTD",
"VIVIDH VASTU BHANDAAR PRIVATE LIMITED",
"VIVIDH WIRES LIMITED",
"VIVIDHA GENERAL PRODUCTS PRIVATE LIMITED",
"VIVIDHA HOME FASHIONS PRIVATE LIMITED",
"VIVIDHA INFRASTRUCTURE PRIVATE LIMITED",
"VIVIDHA IT SOLUTIONS (INDIA) PRIVATE LIMITED",
"VIVIDHA LOGISTICS & SOLUTION PRIVATE LIMITED",
"VIVIDHAAN TEXT PROCESSORS PRIVATE LIMITED",
"VIVIDHMARGI INVESTMENTS PRIVATE LIMITED",
"VIVIDMINDS TECHNOLOGIES PRIVATE LIMITED",
"VIVIDUS HEALTH PRIVATE LIMITED",
"VIVIFI INDIA FINANCE PRIVATE LIMITED",
"VIVIFI LIFE SCIENCES PRIVATE LIMITED",
"VIVIID RENEWABLES PRIVATE LIMITED",
"VIVIL EXPORTS PRIVATE LIMITED",
"VIVILS SILK MILLS PRIVATE LIMITED",
"VIVIMED LABS LIMITED",
"VIVIMED LIFE SCIENCES PRIVATE LIMITED",
"VIVIN ENTERPRISES PRIVATE LIMITED",
"VIVIN KRAFT PRIVATE LIMITED",
"VIVIN LUXURY SUITES PRIVATE LIMITED",
"VIVIN TECHNOLOGIES PRIVATE LIMITED",
"VIVINA MARKETING PRIVATE LIMITED",
"VIVIR CONSTRUCTION PRIVATE LIMITED",
"VIVIRA INVESTMENT AND TRADING PRIVATE LIMITED",
"VIVISH TECHNOLOGIES PRIVATE LIMITED",
"VI-VISION POWER ELECTRONICS PRIVATE LIMITED",
"VIVISU BUILDCON PRIVATE LIMITED",
"VIVO BIO TECH LIMITED",
"VIVO CARE PVT LTD",
"VIVO COLLABORATION SOLUTIONS LIMITED",
"VIVO HEALTHCARE PRIVATE LIMITED",
"VIVO LIFE SCIENCES P LIMITED",
"VIVO TECHNOLOGIES PRIVATE LIMITED",
"VIVO TELCOM PRIVATE LIMITED",
"VIVOG COMMERCIAL LTD.",
"VIVOKI BUSINESS INTELLIGENCE PRIVATE LIMITED",
"VIVONO DESIGNS PRIVATE LIMITED",
"VIVOSTELO EXPORTS PRIVATE LIMITED",
"VIVPACK PACKAGING PRIVATE LIMITED",
"VIVRA WELLNESS PRIVATE LIMITED",
"VIVRAN AGRITECH LIMITED",
"VIVRE PANELS PRIVATE LIMITED",
"VIVRITI ASSET MANAGEMENT PRIVATE LIMITED",
"VIVRITI CAPITAL LIMITED",
"VIVRITI CAPITAL PRIVATE LIMITED",
"VIVRO FINANCIAL SERVICES PRIVATE LIMITED",
"VIVRTHI LABS PRIVATE LIMITED",
"VIVRUT DEVELOPERS PRIVATE LIMITED",
"VIVS SAMPRADAYA DELICACIES PRIVATE LIMITED",
"VIVSON GAMES PRIVATE LIMITED",
"VIVSUN EXPORTS PRIVATE LIMITED",
"VIVUS EDUCATION PRIVATE LIMITED",
"VIVUZONO TRADERS PRIVATE LIMITED",
"VIVYAANA HOSPITALITY PRIVATE LIMITED",
"VIW VACCINE WORLD PRIVATE LIMITED",
"VIWYN PHARMA PRIVATE LIMITED",
"VIXMART PRIVATE LIMITED",
"VIYAAN EDUSERVE LLP",
"VIYAHAN BUILDING MATERIALS PRIVATE LIMITED",
"VIYANIA BUSINESS SOLUTIONS PRIVATE LIMITED",
"VIYANS SCHOOL OF NEET",
"VIYASH LIFE SCIENCES PRIVATE LIMITED",
"VIYO SNACKS PRIVATE LIMITED",
"VIYOMA COMPUTER AIDED MANUFACTURING PRIVATE LIMITED",
"VIYYAT POWER PRIVATE LIMITED",
"VIZ EXPERTS INDIA PRIVATE LIMITED",
"VIZ ON INDIA ENGINEERING SERVICES PRIVATE LIMITED",
"VIZ TECHNOLOGIES PRIVATE LIMITED",
"VIZAG BROADCASTING COMPANY PRIVATE LIMITED",
"VIZAG EDUCATIONAL INSTITUTIONS PRIVATE LIMITED",
"VIZAG EXPORTS",
"VIZAG FOODS PRIVATE LIMITED",
"VIZAG GENERAL CARGO BERTH PRIVATE LIMITED",
"VIZAG HOSPITAL AND CANCER RESEARCH CENTRE PRIVATE LIMITED",
"VIZAG IMPEX PRIVATE LIMITED",
"VIZAG IT PARK LIMITED",
"VIZAG PROFILES LOGISTICS PRIVATE LIMITED",
"VIZAG PROFILES PRIVATE LIMITED",
"VIZAG RE-BARS PRIVATE LIMITED",
"VIZAG SEAPORT PRIVATE LIMITED",
"VIZAG TEXPRO PRIVATE LIMITED",
"VIZARA TECHNOLOGIES PRIVATE LIMITED",
"VIZDA SOFTWARE SOLUTIONS PRIVATE LIMITED",
"VIZEBH AGRI - SCIENCES PRIVATE LIMITED",
"VIZEBH COMPOSITECH PRIVATE LIMITED",
"VIZENT SOLUTIONS PRIVATE LIMITED",
"VIZEXEC TRANSFORMATION PRIVATE LIMITED",
"VIZIANAGAR STARCH AND ALLIED PRODUCTS PRIVATE LIMITED",
"VIZIEN AGRI VENTURES LIMITED",
"VIZIEN ORGANICS",
"VIZIN INDIA PRIVATE LIMITED",
"VIZIO DIGITAL ELECTRONICS PRIVATE LIMITED",
"VIZION LIGHTS PRIVATE LIMITED",
"VIZIPA CONSTRUCTIONS PRIVATE LIMITED",
"VIZNAR TECHNOCRAFTS PRIVATE LIMITED",
"VIZOUS INTERIO PRIVATE LIMITED",
"VIZPAY BUSINESS SOLUTION PRIVATE LIMITED",
"VIZRT INDIA PRIVATE LIMITED",
"VIZRY SERVICES PRIVATE LIMITED",
"VIZTAR INTERNATIONAL PRIVATE LIMITED",
"VIZTECH SOFT SOLUTIONS PRIVATE LIMITED",
"VIZUAL JUNKIES PRIVATE LIMITED",
"VIZURY INTERACTIVE SOLUTIONS PRIVATE LIMITED",
"VIZZA INSURANCE BROKING SERVICES PRIVATE LIMITED",
"VIZZITEC SOLUTIONS PRIVATE LIMITED",
"VJ CROP SCIENCE PRIVATE LIMITED",
"VJ EXIM PRIVATE LIMITED",
"VJ FINE CHEM PRIVATE LIMITED",
"VJ HOLIDAY PLANNERS PRIVATE LIMITED",
"VJ IMAGING TECHNOLOGIES PRIVATE LIMITED",
"VJ INFRACOM PRIVATE LIMITED",
"VJ INTERIOR PRIVATE LIMITED",
"VJ JINDAL COCOA PRIVATE LIMITED",
"VJ MET CRAFT (INDIA) PRIVATE LIMITED",
"VJ MOTORS PRIVATE LIMITED",
"VJ SOURCING PRIVATE LIMITED",
"VJ VERMA JEWELLERS PRIVATE LIMITED",
"VJAGDISHKUMAR INDUSTRIES PRIVATE LIMITED",
"VJAR SOFTWARE PRIVATE LIMITED",
"VJAYAM RUBBERS PRIVATE LIMITED",
"VJH SOFTWARE PRIVATE LIMITED",
"VJM CERAMICS PRIVATE LIMITED",
"VJMAC INFRACON PRIVATE LIMITED",
"VJNT ART AND SCIENCE JUNIOR COLLEGE KUMBHARKINHI PUNARVASAN TQ DARWHA DIST YAVATMAL",
"VJOLEN PHARMA",
"VJP CONSTRUCTION (INDIA) PRIVATE LIMITED",
"VJP SHIPPING INDIA PRIVATE LIMITED",
"VJPN ENGINEERING PRIVATE LIMITED",
"VJR HOSPITALITY PRIVATE LIMITED",
"VJR IMPORT & EXPORT SOLUTIONS PRIVATE LIMITED",
"VJR STEELS LIMITED",
"VJS FUMIGATION SERVICE",
"VJS WORKFORCE PRIVATE LIMITED",
"VJSIMRAN DESIGNERS PRIVATE LIMITED",
"VJT ENGINEERING SOLUTIONS PRIVATE LIMITED",
"VJTF EDUSERVICES LIMITEDCORPORATE OFFICE",
"VK ASSOCIATES PRIVATE LIMITED",
"VK AUTOMOBILES (INDIA) PRIVATE LIMITED",
"VK BUILDING SERVICES PRIVATE LIMITED",
"VK CLOUD SOLUTIONS PRIVATE LIMITED",
"VK DAIRY ESSENTIALS PRIVATE LIMITED",
"VK DENTAL INDIA PRIVATE LIMITED",
"VK DIGITAL NETWORK PRIVATE LIMITED",
"VK FASTENERS PRIVATE LIMITED",
"VK FIRE ENGINEERS PRIVATE LIMITED",
"VK GLOBAL DIGITAL PRIVATE LIMITED",
"VK GLOBAL PUBLICATIONS PRIVATE LIMITED",
"VK JEWELS PRIVATE LIMITED",
"VK O OPERATIONS",
"VK READY MIX CONCRETE PRIVATE LIMITED",
"VK RICE MILL",
"VK TILES AND BATH FITTINGS PRIVATE LIMITED",
"VK TYRE INDIA LIMITED",
"VK1 EXPRESSWAY LIMITED",
"VKA ELECTRICALS PRIVATE LIMITED",
"VKA LOGISTICS PRIVATE LIMITED",
"VKA POWERMASTER PRIVATE LIMITED",
"VKA SALES AND MARKETING PRIVATE LIMITED",
"VKALP CONSULTANCY PRIVATE LIMITED",
"VKALP OUTSOURCING SERVICES PRIVATE LIMITED",
"VKARE INFORMATICS PRIVATE LIMITED",
"VKART INFO SOLUTIONS PRIVATE LIMITED",
"VKB 53 ADVISORY PRIVATE LIMITED",
"VKC BUILDERS PRIVATE LIMITED",
"VKC CORPORATE SOLUTIONS PRIVATE LIMITED",
"VKC NUTS PRIVATE LIMITED",
"VKCL PRIVATE LIMITED",
"VKCOAL PRIVATE LIMITED",
"VKD ENTERPRISES PRIVATE LIMITED",
"VKE ENVIRONMENTAL",
"VKE PLUMBING PRIVATE LIMITED",
"VKE VALVES INDUSTRIES PVT LTD",
"VKG ENERGY PRIVATE LIMITED",
"VKG MOTORS",
"VKGM INFRASTRUCTURE PRIVATE LIMITED",
"VKHVAC SYSTEMS SERVICES PRIVATE LIMITED",
"VKING INTERNATIONAL PRIVATE LIMITED",
"VKJ COPPER AND ALLOYS PRIVATE LIMITED",
"VKJ PROJECTS PRIVATE LIMITED",
"VKK ADVISORS INDIA PRIVATE LIMITED",
"VKK MENON COLLEGE OF COMMERCE AND ECONOMICS",
"VKL BUILDERS INDIA PRIVATE LIMITED",
"VKL SEASONING PRIVATE LIMITED",
"VKM CONSTRUCTION EQUIPMENTS PRIVATE LIMITED",
"VKM CONSULTANTS PRIVATE LIMITED",
"VKM ENGINEERS",
"VKM ENTERPRISES PRIVATE LIMITED",
"VKM FOODS PRIVATE LIMITED",
"VKM TOWNSHIP PRIVATE LIMITED",
"VKMOTOR WORKS PRIVATE LIMITED",
"VKNP DESIGNS PRIVATE LIMITED",
"VKOLLAB TECHNOLOGIES PRIVATE LIMITED",
"VKP ENGINEERING IND PRIVATE LIMITED",
"VKR CONSTRUCTIONS PRIVATE LIMITED",
"VKR DIAGNOSTICS AND HEALTHCARE PRIVATE LIMITED",
"VKR HR SERVICES PRIVATE LIMITED",
"VKRAFT SOFTWARE SERVICES PRIVATE LIMITED",
"VKRG HEALTHCARE PRIVATE LIMITED",
"VKRG PHARMA PRIVATE LIMITED",
"VKRG PRIVATE LIMITED",
"VKS - GORMI UDOTGARH CORRIDOR PRIVATE LIMITED",
"VKS BARETHA GHODADONGRI CORRIDOR PRIVATE LIMITED",
"VKS FACILITY INDIA PRIVATE LIMITED",
"VKS FOODS PRIVATE LIMITED",
"VKS HYTECH PRIVATE LIMITED",
"VKS JAISWAL MARKETING PRIVATE LIMITED",
"VKS JAISWAL STEEL PRIVATE LIMITED",
"VKS LOGISTICS PRIVATE LIMITED",
"VKS METAL SYSTEM PRIVATE LIMITED",
"VKS PLASTIC COMPOUND PRIVATE LIMITED",
"VKS PRODUCT PRIVATE LIMITED",
"VKS SEOPUR BARODA CORRIDOR PRIVATE LIMITED",
"VKS SERVICES PRIVATE LIMITED",
"VKS TEXPORTS PRIVATE LIMITED",
"VKSC INFRAPROJECTS LIMITED",
"VKSCPL KHARGONE- BARWANI CORRIDOR PRIVATE LIMITED",
"VKSP CHEMICALS PRIVATE LIMITED",
"VKT PHARMA PRIVATE LIMITED",
"VKTG BISTRO PRIVATE LIMITED",
"VKV AUTOMOTIVE PRIVATE LIMITED",
"VL ACCESS INDIA PRIVATE LIMITED",
"VL APPLIANCE INDIA PRIVATE LIMITED",
"VL ASTRA ENGINEERS (INDIA) PRIVATE LIMITED",
"VL E-GOVERNANCE & IT SOLUTIONS LIMITED",
"VL IMPEX PRIVATE LIMITED",
"VL PAPERS PRIVATE LIMITED",
"VLA INDUSTRIES LIMITED",
"VLADO SKY ENTERPRISE PRIVATE LIMITED",
"VLAND ENGINEERING & CONSTRUCTION PRIVATE LIMITED",
"VLC SPICES PRIVATE LIMITED",
"VLCC HEALTH CARE LIMITED",
"VLCC ONLINE SERVICES PRIVATE LIMITED",
"VLCC PERSONAL CARE LIMITED",
"VLCOM HEALTHCARE PRIVATE LIMITED",
"VLE BAZAAR PRIVATE LIMITED",
"VLEAD DESIGN SERVICES PRIVATE LIMITED",
"VLF TRENDS PRIVATE LIMITED",
"VLH BANSAL MOTORS PRIVATE LIMITED",
"VLH LEATHER EXPORTS PRIVATE LIMITED",
"V-LINK AUTOMOTIVE SERVICES PRIVATE LIMITED",
"V-LINK FLEET SOLUTIONS PRIVATE LIMITED",
"VLINK INDIA PRIVATE LIMITED",
"VLK ASSOCIATES PRIVATE LIMITED",
"V-LOCK ENGINEERING PRIVATE LIMITED",
"VLOOKUP BUSINESS SOLUTIONS PRIVATE LIMITED",
"V-LOOP INTERNATIONALS PRIVATE LIMITED",
"VLPCPL WELLNESS PRIVATE LIMITED",
"VLR CORPORATE SOLUTIONS PRIVATE LIMITED",
"VLS CAPITAL LIMITED",
"VLS CONSULTING LLP",
"VLS GLOBAL LOGISTICS PRIVATE LIMITED",
"VLS SECURITIES LIMITED",
"VM APPARELS PRIVATE LIMITED",
"VM AVIATION PRIVATE LIMITED",
"VM CAN INDUSTRIES PRIVATE LIMITED",
"VM CELL ACESESS PRIVATE LIMITED",
"VM DIGITAL NETWORKS PRIVATE LIMITED",
"VM ELECTROTECH PRIVATE LIMITED",
"VM FOOD PRODUCTS PRIVATE LIMITED",
"VM LOUIS MARKETING PRIVATE LIMITED",
"VM PRECISION PUNCH PRIVATE LIMITED",
"VM7 EXPRESSWAY PRIVATE LIMITED",
"VMA ENERGY PRIVATE LIMITED",
"VMA ENGINEERING PRIVATE LIMITED",
"VMACH STEELS PRIVATE LIMITED",
"VMAG AUTOMATION SYSTEMS PRIVATE LIMITED",
"VMAK HEALTHCARE INDIA PRIVATE LIMITED",
"VMAK RESEARCH & SERVICES PRIVATE LIMITED",
"VMAKS CONSTRUCTIONS PRIVATE LIMITED",
"VMAN AVIATION SERVICES IFSC PRIVATE LIMITED",
"VMANSIONS INDIA PRIVATE LIMITED",
"VMAPSTECH INDIA PRIVATE LIMITED",
"V-MARC ELECTRICALS PRIVATE LIMITED",
"VMARSH TEXTILE CONSULTANCY SERVICES PRIVATE LIMITED",
"VMAX CONSTRUCTIONS PRIVATE LIMITED",
"V-MAX MULTICARE HOSPITAL",
"VMB CREATION PRIVATE LIMITED",
"VMB MAINTENANCE SERVICES PRIVATE LIMITED",
"VMC MANAGEMENT CONSULTING PRIVATE LIMITED",
"VMC REFRACTORY SOLUTIONS PRIVATE LIMITED",
"VMC STEEL PRIVATE LIMITED",
"VMC TECHNOLOGIES PRIVATE LIMITED",
"VMD CAD AND GRAPHIC TECHNOLOGIES PRIVATE LIMITED",
"VMD MILLS PRIVATE LIMITED",
"VME INFRASTRUCTURE PRIVATE LIMITED",
"VMF ENGINEERS PRIVATE LIMITED",
"VMG BARAMATI INDUSTRIES PRIVATE LIMITED",
"VMG DIGITAL PRIVATE LIMITED",
"VMG FOODS PRIVATE LIMITED",
"VMH AGRO PRIVATE LIMITED",
"VMH THERMAL TECH ENGINEERING PRIVATE LIMITED",
"VMI PLASTIC PRIVATE LIMITED",
"VMIDAS PRIVATE LIMITED",
"VMIX MINERAL TECHNOLOGIES PRIVATE LIMITED",
"VMK AGRO CHEMICALS PRIVATE LIMITED",
"VMN BUILDCON PRIVATE LIMITED",
"VMN EXPORTS PRIVATE LIMITED",
"VMOBI SOLUTIONS PRIVATE LIMITED",
"VMOBO MOBILE PRIVATE LIMITED",
"VMOCK INDIA PRIVATE LIMITED",
"V-MODE FASHIONS PRIVATE LIMITED",
"VMOKSHA TECHNOLOGIES PRIVATE LIMITED",
"VMP ENERGY PRIVATE LIMITED",
"VMR BUILDPRO PRIVATE LIMITED",
"VMR CLOUD SOLUTIONS PRIVATE LIMITED",
"VMR INFO VISION PRIVATE LIMITED",
"VMR VISION",
"VMS AUTO TECH PRIVATE LIMITED",
"VMS BATH & KITCHEN INDIA PRIVATE LIMITED",
"VMS BATHWARE PRIVATE LIMITED",
"VMS ENGINEERING AND DESIGN SERVICES PRIVATE. LIMITED.",
"VMS EQUIPMENT PRIVATE LIMITED",
"VMS EVENTS PRIVATE LIMITED",
"VMS FABRICS PRIVATE LIMITED",
"VMS FOOD AND BEVERAGES SERVICES PRIVATE LIMITED",
"VMS GLOBAL COMMODITIES PRIVATE LIMITED",
"VMS INDUSTRIES LIMITED",
"VMS INFRATECH PRIVATE LIMITED",
"VMS INTERNATIONAL",
"VMS INTERNATIONAL PRIVATE LIMITED",
"VMS KNITTING PRIVATE LIMITED",
"VMS MEDIA PRIVATE LIMITED",
"VMS METAL WORKS PRIVATE LIMITED",
"VMS NIRMAN PRIVATE LIMITED",
"VMS RODS PRIVATE LIMITED",
"VMS TMT LIMITED",
"VMS TRAVEL TECH INDIA PRIVATE LIMITED",
"VMSALGAOCAR CORPORATION PRIVATE LIMITED",
"VMT INDUSTRIES PRIVATE LIMITED",
"VMT SPINNING COMPANY LIMITED",
"VMUKTI SOLUTIONS PRIVATE LIMITED",
"VMV COLLEGE",
"VMW MOULD PRIVATE LIMITED",
"VMX HI CONNECTORS PRIVATE LIMITED",
"VMY BUILDERS PRIVATE LIMITED",
"VN AGENCIES PRIVATE LIMITED",
"VN CREATIVE CHEMICALS PRIVATE LIMITED",
"VN STEELARCH INDIA PRIVATE LIMITED",
"VN SUNRISE REFRIGERATION TECHNOLOGY PRIVATE LIMITED",
"VN TEXPORTS PRIVATE LIMITED",
"VN VIGNAN JYOTHI INSTI OF TECH ENGG",
"VNA HOSPITAL",
"VNA REALTY PRIVATE LIMITED",
"VNA SOFTWARE SOLUTIONS PRIVATE LIMITED",
"VNBC JUNIOR COLLEGE",
"VNC DIGITAL SERVICES PRIVATE LIMITED",
"VNC ENTERPRISES",
"VNC NUTRITION FOODS PRIVATE LIMITED",
"VNCJ MERCHANDISE & PRINTS PRIVATE LIMITED",
"VND PLASTICO PUMPS PRIVATE LIMITED",
"VND WEALTH PRIVATE LIMITED",
"VNEIGHBORHOOD HOSPITALITY AND RESORT PRIVATE LIMITED",
"VNET INFORMATION SYSTEMS PRIVATE LIMITED",
"VNEXTGEN IT SOLUTIONS PRIVATE LIMITED",
"VNF FARMER PRODUCER COMPANY LIMITED",
"VNF IDEAS PRIVATE LIMITED",
"VNG AUTOMOTIVES PRIVATE LIMITED",
"VNG CHAMRIA AYURVED LAB PRIVATE LIMITED",
"VNG ENTERPRISES PRIVATE LIMITED",
"VNG EXPORTS PRIVATE LIMITED",
"VNG MEDICAL INNOVATION SYSTEM PRIVATE LIMITED",
"VNG PACKAGING PRIVATE LIMITED",
"VNG TECHNOLOGY PRIVATE LIMITED",
"VNJ AGRO FOODS PVT LTD",
"VNM ENGINEERING PRIVATE LIMITED",
"VNM ENGINEERS",
"VNM INDUSTRIES PRIVATE LIMITED",
"VNM JEWEL CRAFTS LIMITED",
"VNM POLYMERS PVT LTD",
"VNNOVATE SOLUTIONS PRIVATE LIMITED",
"V-NOVA BUSINESS GROWTH SERVICES PRIVATE LIMITED",
"VNR HOMES PRIVATE LIMITED",
"VNR NURSERY PRIVATE LIMITED",
"VNR POLYFILMS PRIVATE LIMITED",
"VNR SEEDS PRIVATE LIMITED",
"VNRN HEALTH SERVICES PRIVATE LIMITED",
"VNS ACCESSORIES INDIA LLP",
"VNS ACCOUNTING SOLUTIONS PRIVATE LIMITED",
"VNS BROKING PRIVATE LIMITED",
"VNS ENVIRO BIOTECHQ PRIVATE LIMITED",
"VNS FINANCE & CAPITAL SERVICES LIMITED.",
"VNS FOREX PRIVATE LIMITED",
"VNS GROUP OF EDUCATION INSTITUTES",
"VNS HOSPITAL",
"VNS INDUSTRIES PRIVATE LIMITED",
"VNS MAKRO TECHNOLOGIES PRIVATE LIMITED",
"VNS METALS PRIVATE LIMITED",
"VNS RISK MANAGEMENT SERVICES PRIVATE LIMITED",
"VNS ROOFING INDIA PRIVATE LIMITED",
"VNS SWITCHGEAR (INDIA) PRIVATE LIMITED",
"VNSURE BUSINESS SOLUTIONS PRIVATE LIMITED",
"VNU COAL PRIVATE LIMITED",
"VNV BUSINESS SOLUTIONS PRIVATE LIMITED",
"VNYK GIFTS PRIVATE LIMITED",
"VOCALBUG COMMUNICATIONS PRIVATE LIMITED",
"VOCATIONAL EDUCATIONAL COLLEGE SANGLI",
"VOCATIONAL JR COLLEGE UPALE",
"VOCATIONAL SKILLS COUNCIL INDIA PRIVATE LIMITED",
"VOCERA COMMUNICATIONS INDIA PRIVATE LIMITED",
"VOCMAN INDIA PRIVATE LIMITED",
"VOCON MANUFACTURING PRIVATE LIMITED",
"VODA CHEMICALS PRIVATE LIMITED",
"VODACOM TECHNOLOGIES PRIVATE LIMITED",
"VODAFONE DIGILINK LIMITED",
"VODAFONE EAST LIMITED",
"VODAFONE FOUNDATION",
"VODAFONE GLOBAL SERVICES PRIVATE LIMITED",
"VODAFONE IDEA BUSINESS SERVICES LIMITED",
"VODAFONE IDEA COMMUNICATION SYSTEMS LIMITED",
"VODAFONE IDEA LIMITED",
"VODAFONE IDEA MANPOWER SERVICES LIMITED",
"VODAFONE IDEA SHARED SERVICES LIMITED",
"VODAFONE IDEA TECHNOLOGY SOLUTIONS LIMITED",
"VODAFONE IDEA TELECOM INFRASTRUCTURE LIMITED",
"VODAFONE INDIA PRIVATE LIMITED",
"VODAFONE INDIA SERVICES PRIVATE LIMITED",
"VODAFONE MOBILE SERVICES LIMITED",
"VODAFONE M-PESA LIMITED",
"VODAFONE WEST LIMITED",
"VOEDEN INDIA PRIVATE LIMITED",
"VOEREIR INDIA PRIVATE LIMITED",
"VOESTALPINE BOHLER WELDING INDIA PRIVATE LIMITED",
"VOESTALPINE BOHLER WELDING INDIA TECHNOLOGY PRIVATE LIMITED",
"VOESTALPINE HIGH PERFORMANCE METALS INDIA PRIVATE LIMITED",
"VOESTALPINE VAE VKN INDIA PRIVATE LIMITED",
"VOFOX SOLUTIONS PRIVATE LIMITED",
"VOG GEMS PRIVATE LIMITED",
"VOGANOW FASHIONS PRIVATE LIMITED",
"VOGATT UNIVERA ASSOCIATES PRIVATE LIMITED",
"VOGEL BUSINESS MEDIA INDIA PRIVATE LIMITED",
"VOGELSANG INDIA PRIVATE LIMITED",
"VOGO AUTOMOTIVE PRIVATE LIMITED",
"VOGUE CLOTHING COMPANY",
"VOGUE COMMERCIAL COMPANY LIMITED",
"VOGUE CONSTRUCTION AND CONSULTANCY SERVICES PRIVATE LTD.",
"VOGUE INSTITUTE OF CREATIVE ARTS PRIVATE LIMITED",
"VOGUE LOGISTICS PRIVATE LIMITED",
"VOGUE N HYDE PRIVATE LIMITED",
"VOGUE PHARMACEUTICALS PRIVATE LIMITED",
"VOGUE SECURITY SOLUTIONS PRIVATE LIMITED",
"VOGUE TEXTILES LIMITED",
"VOGUEME TECHNOLOGIES PRIVATE LIMITED",
"VOGUESTOCK COMMODITIES LIMITED",
"VOHRA AUTO DISTRIBUTORS PRIVATE LIMITED",
"VOHRA ENTERPRISES PRIVATE LIMITED",
"VOHRA FOODS PRIVATE LIMITED",
"VOHRA SOLVEX PRIVATE LIMITED",
"VOHRA TEA AND INDUSTRIES PRIVATE LIMITED",
"VOHRA WOUND CARE PRIVATE LIMITED",
"VOHRAFAB PRIVATE LIMITED",
"VOI JEANS RETAIL INDIA PRIVATE LIMITED",
"VOIC NETWORKS PRIVATE LIMITED",
"VOICE SNAP SERVICES PRIVATE LIMITED",
"VOICE SNAP SOFTWARE PRIVATE LIMITED",
"VOICEBACK ANALYTICS PRIVATE LIMITED",
"VOICECLOUD TECHNOLOGIES PRIVATE LIMITED",
"VOICECOM TECHNOLOGIES PRIVATE LIMITED",
"VOICEGATE TECHNOLOGIES INDIA PRIVATE LIMITED",
"VOICEGEAR NETWORK TECHNOLOGIES PRIVATE. LIMITED",
"VOICEOC INNOVATIONS PRIVATE LIMITED",
"VOICETEC BUSINESS SYSTEM INDIA PRIVATE LIMITED",
"VOICEZEN INDIA PRIVATE LIMITED",
"VOIDSTARINDIA SOLUTIONS LLP",
"VOILA F9 GOURMET LLP",
"VOING TECHNOLOGIES LLP",
"VOIP OFFICE TELECOMMUNICATIONS PRIVATE LIMITED",
"VOIPCONNECT PRIVATE LIMITED",
"VOISIN CONSULTING PRIVATE LIMITED",
"VOITEKK SOFTSOL PRIVATE LIMITED",
"VOITH DIGITAL SOLUTIONS INDIA PRIVATE LIMITED",
"VOITH HYDRO PRIVATE LIMITED",
"VOITH PAPER FABRICS INDIA LIMITED",
"VOITH PAPER TECHNOLOGY INDIA LIMITED",
"VOITH TURBO PRIVATE LIMITED",
"VOIZMED PHARMA PRIVATE LIMITED",
"VOKIAN LOCALISATION PRIVATE LIMITED",
"VOKKAL SEEDS PRIVATE LIMITED",
"VOLANE INDIA PRIVATE LIMITED",
"VOLANS INFOMATICS PRIVATE LIMITED",
"VOLANS LIFE SCIENCES PRIVATE LIMITED",
"VOLANSYS TECHNOLOGIES PRIVATE LIMITED",
"VOLANT EXIM PRIVATE LIMITED",
"VOLANT SHOES PRIVATE LIMITED",
"VOLANTE SOFTWARE PRIVATE LIMITED",
"VOLANTE TECHNOLOGIES INDIA PRIVATE LIMITED",
"VOLANTIS TECHNOLOGIES PRIVATE LIMITED",
"VOLANZO CARS PRIVATE LIMITED",
"VOLAR FASHION PRIVATE LIMITED",
"VOLARE LOGISTIX PRIVATE LIMITED",
"VOLARE TECHNOLOGIES PRIVATE LIMITED",
"VOLARIS LIFE SCIENCES PRIVATE LIMITED",
"VOLCANIC STONES PRIVATE LIMITED",
"VOLCANO GOODS PRIVATE LIMITED",
"VOLCON SOLUTIONS PRIVATE LIMITED",
"VOLCUR ELECTRIX PRIVATE LIMITED",
"VOLEN SOFTWARE SERVICES PRIVATE LIMITED",
"VOLER CAR PRIVATE LIMITED MOST URGENT",
"VOLEX INTERCONNECT INDIA PRIVATE LIMITED",
"VOLFRAM SYSTEMS INDIA PRIVATE LIMITED",
"VOLGA CERAMIC PRIVATE LIMITED",
"VOLGA CREDIT AND LEASING LIMITED",
"VOLGA FOODS PRIVATE LIMITED",
"VOLGA HOSPITALITY PRIVATE LIMITED",
"VOLGA INDIA RUBBER PRIVATE LIMITED",
"VOLGA INFOTECH PRIVATE LIMITED",
"VOLGA INSTRUMENTS PRIVATE LIMITED",
"VOLGA OVERSEAS PRIVATE LIMITED",
"VOLI INNOVATIONS PRIVATE LIMITED",
"VOLIO TECHNOLOGIES LIMITED",
"VOLITION CREDIT & HOLDING PRIVATE LIMITED",
"VOLITION PROJECTS PRIVATE LIMITED",
"VOLKART FOUNDATION INDIA TRUST",
"VOLKER ENERGIETECHNIK INDIA PRIVATE LIMITED",
"VOLKOV INFRA PRIVATE LIMITED",
"VOLKSARA TECHNO SOLUTIONS PRIVATE LIMITED",
"VOLKSCHEM CROP SCIENCE PRIVATE LIMITED",
"VOLKSOFT CONSULTING PRIVATE LIMITED",
"VOLKSOFT TECHNOLOGIES PRIVATE LIMITED",
"VOLKSWAGEN FINANCE PRIVATE LIMITED",
"VOLKSWAGEN GROUP SALES INDIA PRIVATE LIMITED.",
"VOLKSWAGEN GROUP TECHNOLOGY SOLUTIONS INDIA PRIVATE LIMITED",
"VOLL SANTE FUNCTIONAL FOODS & NUTRACEUTICALS PRIVATE LIMITED",
"VOLLERT INDIA PRIVATE LIMITED",
"VOLLKRAFT ENGINEERS & CONSULTANTS PVT LTD",
"VOLLMOND TRADERS PRIVATE LIMITED",
"VOLLWERT ELECTRIC PRIVATE LIMITED",
"VOLMIN INDUSTRIES PRIVATE LIMITED",
"VOLO FIN SERVICES PRIVATE LIMITED",
"VOLO RETAILS PRIVATE LIMITED",
"VOLODY PRODUCTS PRIVATE LIMITED",
"VOLPAK SYSTEMS PRIVATE LIMITED",
"VOLSTAR BUSINESS SOLUTIONS PRIVATE LIMITED",
"VOLT INFORMATION SCIENCES (INDIA) PRIVATE LIMITED",
"VOLTA FASHIONS PRIVATE LIMITED",
"VOLTA GREEN STRUCTURES PRIVATE LIMITED",
"VOLTA IMPEX PRIVATE LIMITED",
"VOLTA SWITCHGEAR INDIA PRIVATE LIMITED",
"VOLTA TOURS & TRAVELS PRIVATE LIMITED",
"VOLTACTIVE POWER TECHNOLOGIES PRIVATE LIMITED",
"VOLTAIC CABLE PRIVATE LIMITED",
"VOLTAIC INDUSTRIES PRIVATE LIMITED",
"VOLTAIC POWER PRIVATE LIMITED",
"VOLTAMP CONTROLS (INDIA) PRIVATE LIMITED",
"VOLTAMP ELECTRICALS PVT. LTD.",
"VOLTAMP TRANSFORMERS LIMITED",
"VOLTARC ELECTRODES PVT LTD",
"VOLTAS LIMITED",
"VOLTBEK HOME APPLIANCES PRIVATE LIMITED",
"VOLTECH BLISS MANAGEMENT SERVICES PRIVATE LIMITED",
"VOLTECH ENGINEERS PRIVATE LIMITED",
"VOLTECH HR SERVICES PRIVATE LIMITED",
"VOLTECH MANUFACTURING COMPANY LIMITED.",
"VOLTECH MANUFACTURING COMPANY PRIVATE LIMITED",
"VOLTECH O AND M SERVICES PRIVATE LIMITED",
"VOLTECH TRANSRAIL PRIVATE LIMITED",
"VOLTEDGE MARKETING PRIVATE LIMITED",
"VOLTEMP ENTERPRISES PRIVATE LIMITED",
"VOLTEO TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"VOLTKON SWITCHGEAR PRIVATE LIMITED",
"VOLTON ENGINEERING (INDIA) PRIVATE LIMITED",
"VOLTOZ INDIA PRIVATE LIMITED",
"VOLTRIQ INDIA PRIVATE LIMITED",
"VOLTS AND WATTS ELECTRONICS PRIVATE LIMITED",
"VOLTUSWAVE TECHNOLOGIES INDIA PRIVATE LIMITED",
"VOLTWORK ELECTRICALS PRIVATE LIMITED",
"VOLTY IOT SOLUTIONS PRIVATE LIMITED",
"VOLTZTECH SOLUTIONS PRIVATE LIMITED",
"VOLUMETREE TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"VOLUMINOUS ENERGY INDIA PRIVATE LIMITED",
"VOLUMNUS DEVELOPERS PRIVATE LIMITED",
"VOLUNTARY SERVICE OVERSEAS",
"VOLUNTEERING TRAVEL SOLUTIONS PRIVATE LIMITED",
"VOLUPIA DEVELOPERS PRIVATE LIMITED",
"VOLUS PHARMA PRIVATE LIMITED",
"VOLVO AUTO INDIA PRIVATE LIMITED",
"VOLVO CE INDIA PRIVATE LIMITED",
"VOLVO FINANCIAL SERVICES (INDIA) PRIVATE LIMITED",
"VOLVO GROUP INDIA PRIVATE LIMITED",
"VOLYO SOLUTIONS PRIVATE LIMITED",
"VOLYTY INDIA PRIVATE LIMITED",
"VOMAX SPORTS PRIVATE LIMITED",
"VON ROLL INDIA PRIVATE LIMITED",
"VONAGE BUSINESS COMMUNICATIONS PRIVATE LIMITED",
"VONCO PLASTICS PRIVATE LIMITED",
"VONDA TECHNOLOGY PRIVATE LIMITED",
"VONE INDIA SERVICES PRIVATE LIMITED",
"VONKEN BRANDTECH PRIVATE LIMITED",
"VONKEN TECHNOLOGIES PRIVATE LIMITED",
"VONUP BPO PRIVATE LIMITED",
"VONUX SOLUTIONS PRIVATE LIMITED",
"VOOLSY NETWORKS PRIVATE LIMITED",
"VOONIK TECHNOLOGIES PRIVATE LIMITED",
"VOOPAR SCIENCES PRIVATE LIMITED",
"VOORA ENERGY PRIVATE LIMITED",
"VOORA PROPERTY DEVELOPERS PRIVATE LIMITED",
"VOORA SHREERAM CONSTRUCTIONS PRIVATE LIMITED",
"VOOSHFOODS TECHNOLOGIES PRIVATE LIMITED",
"VOPAK INDIA PRIVATE LIMITED",
"VORA AUTOMOTIVES PRIVATE LIMITED",
"VORA CERAMICS PRIVATE LIMITED",
"VORA DRUGS AND CHEMICAL PRIVATE LTD",
"VORA ELECTRIC SERVICE PRIVATE LIMITED",
"VORA ENGINEERING COMPANY PRIVATE LIMITED",
"VORA FARMS AND INVESTMENTS PRIVATE LIMITED",
"VORA FINANCIAL SERVICES PRIVATE LIMITED",
"VORA LOGISTICS PRIVATE LIMITED",
"VORA WIRES INDUSTRIES (INDIA) LIMITED",
"VORDURJA EDUCATION PRIVATE LIMITED",
"VORSIA PHARMACEUTICALS P LIMITED",
"VORTEX ELECTRONICS PRIVATE LIMITED",
"VORTEX ENGINEERING PRIVATE LIMITED",
"VORTEX ENGINEERING WORKS INDIA PRIVATE LIMITED",
"VORTEX FACILITIES MANAGEMENT PRIVATE LIMITED",
"VORTEX FLEX PRIVATE LIMITED",
"VORTEX IMPEX PRIVATE LIMITED",
"VORTEX NETSOL PRIVATE LIMITED",
"VORTEX SPRINGS AND COMPONENTS PRIVATE LIMITED",
"VOS TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"VOSO SUPPLIES SOLUTIONS PRIVATE LIMITED",
"VOSS AUTOMOTIVE INDIA PRIVATE LIMITED",
"VOSS EXOTECH AUTOMOTIVE PRIVATE LIMITED",
"VOSSLOH BEEKAY CASTINGS LIMITED",
"VOSSLOH FASTENING SYSTEMS INDIA PRIVATE LIMITED",
"VOSTA LMG INDIA PRIVATE LIMITED",
"VOSTOK (FAREAST) SECURITIES PRIVATE LIMITED",
"VOSTRO DESIGN & FASHION PRIVATE LIMITED",
"V-OSWAL REALTY PRIVATE LIMITED",
"VOTARY AGRO FOODS INDUSTRIES LIMITED",
"VOTARY LABORATORIES INDIA LIMITED",
"VOTARY SOFTECH SOLUTIONS PRIVATE LIMITED",
"VOTIVESOFT BUSINESS SOLUTIONS PRIVATE LIMITED",
"VOTO TECHNOLOGIES PRIVATE LIMITED",
"VOTOS COMMUNICATIONS LIMITED",
"VOUCHAGRAM INDIA PRIVATE LIMITED",
"VOUCHER ACTIVATION SERVICES INDIA PRIVATE LIMITED",
"VOUCHPRO SERVICES PRIVATE LIMITED",
"VOVANCE WOOD PRIVATE LIMITED",
"VOVANTIS LABORATORIES PRIVATE LIMITED",
"VOVISTO DESTINATION MANAGEMENT SERVICES",
"VOW BUILDTECH PRIVATE LIMITED",
"VOW TRADEIMPEX PRIVATE LIMITED",
"VOWEL DIGITAL ADWORLD (OPC) PRIVATE LIMITED",
"VOWEL JUNIOR COLLEGE",
"VOWEL LEARNING SOLUTIONS LLP",
"VOW'S MARKETING AND SOFTWARE SOLUTIONS PRIVATE LIMITED",
"VOX BUILDING PRODUCTS PRIVATE LIMITED",
"VOX POPULI RESEARCH AND CONSULTANCY PRIVATE LIMITED",
"VOX SPECTRUM PRIVATE LIMITED",
"VOXAI IT SOLUTIONS INDIA PRIVATE LIMITED",
"VOXCO PIGMENTS AND CHEMICALS PRIVATE LIMITED",
"VOXEL 1 SOLUTIONS PRIVATE LIMITED",
"VOXEL TECHNO SOLUTIONS PRIVATE LIMITED",
"VOXELGRIDS INNOVATIONS PRIVATE LIMITED",
"VOXELJET INDIA PRIVATE LIMITED",
"VOXTA COMMUNICATIONS PRIVATE LIMITED",
"VOXTUR BIO LIMITED",
"VOXTURR CONSULTING PRIVATE LIMITED",
"VOXVALLEY TECHNOLOGIES PRIVATE LIMITED",
"VOXXVISION VENTURES PRIVATE LIMITED",
"VOXXY MEDIA PRIVATE LIMITED",
"VOYA GLOBAL SERVICES PRIVATE LIMITED",
"VOYAGE GLOBAL JOURNEYS PRIVATE LIMITED",
"VOYAGE OVERSEAS PRIVATE LIMITED",
"VOYAGER INFOSEC PRIVATE LIMITED",
"VOYAGER MARINE SERVICES INDIA PRIVATE LIMITED",
"VOYANTS SOLUTIONS PRIVATE LIMITED",
"VOYLLA FASHIONS PRIVATE LIMITED",
"VOYOX SHIPPING & LOGISTICS PRIVATE LIMITED",
"VOZIQ INDIA PRIVATE LIMITED",
"VOZON COMSOF PRIVATE LIMITED",
"VP AERO SOLUTIONS PRIVATE LIMITED",
"VP BULLION PRIVATE LIMITED",
"VP DIAGNOSTICS PRIVATE LIMITED",
"VP EXIM GLOBAL PRIVATE LIMITED",
"VP EXIM LIMITED",
"VP FACILITY SERVICES PRIVATE LIMITED",
"VP FIRE SYSTEM PRIVATE LIMITED",
"VP FOODS AND HERBALS PRIVATE LIMITED",
"VP KOMMODITY TRADE (I) PRIVATE LIMITED",
"VP LOGISTICS PRIVATE LIMITED",
"VP MITTAL REALESTATE PRIVATE LIMITED",
"VP PETRO6 ENGINEERS AND CONSULTANTS PRIVATE LIMITED",
"VP SPACES PRIVATE LIMITED",
"VP SUGARS LIMITED",
"VP SYNERGIC WELD SOLUTIONS PRIVATE LIMITED",
"VP UTILITIES & SERVICES PRIVATE LIMITED",
"V-PACK AUTOMATIONS PRIVATE LIMITED",
"VPAM HEALTHCARE PRIVATE LIMITED",
"VPBA MITTAL FINANCE PRIVATE LIMITED",
"VPC FREIGHT FORWARDERS PRIVATE LIMITED",
"VPC INFRATECH PRIVATE LIMITED",
"VPCG EXIM PRIVATE LIMITED",
"VPD CONSULTANTS PRIVATE LIMITED",
"V-PERFECT LIFTTECH PRIVATE LIMITED",
"VPERSIST CORPORATE SOLUTIONS PRIVATE LIMITED",
"VPERSONALIZE TECHNOLOGY INDIA PRIVATE LIMITED",
"VPG BUILDWELL INDIA PRIVATE LIMITED",
"VPG FAB CARE PRIVATE LIMITED",
"VPG FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"VPHRASE ANALYTICS SOLUTIONS PRIVATE LIMITED",
"VPI INFRA PRIVATE LIMITED",
"VPI MEDISALES PRIVATE LIMITED",
"VPK MOTORS PRIVATE LIMITED",
"VPL CHEMICALS PRIVATE LIMITED",
"VPL DIAGNOSTIC & RESEARCH PRIVATE LIMITED",
"VPL INDUSTRIAL TECHNOLOGIES PRIVATE LIMITED",
"VPM PAPER AND BOARDS PRIVATE LIMITED",
"VPMS LJNJ MAHILA MAHAVIDYALAYA",
"VPN CONTROLS PRIVATE LIMITED",
"VPN POWER SOLUTIONS PRIVATE LIMITED",
"VPR FOOTSTEPS PRIVATE LIMITED",
"VPR LOGISTICS AND SERVICES PRIVATE LIMITED",
"VPR MINING INFRASTRUCTURE PRIVATE LIMITED",
"VPR TELESERVICES PRIVATE LIMITED",
"VPRIYA DEALERS PRIVATE LIMITED",
"VPS AGRITECH LIMITED",
"VPS AGRO & AUTO PRIVATE LIMITED",
"VPS HEALTH CARE PRIVATE LIMITED",
"VPS METAL WORKS PRIVATE LIMITED",
"VPS MOTORS PRIVATE LIMITED",
"VPS REAL ESTATE PRIVATE LIMITED",
"VPS SILK FABRICS PRIVATE. LIMITED.",
"VPS SYSTECH PRIVATE LIMITED",
"VPS TEXTILES INDIA PRIVATE LIMITED",
"VPTI SOLUTIONS PRIVATE LIMITED",
"VPV PRODUCTS PRIVATE LIMITED",
"VPY TRADER PRIVATE LIMITED",
"VQUALZEN RCM PRIVATE LIMITED",
"VQURE PACKAGING PRIVATE LIMITED",
"VR ACCOUNTING SOLUTIONS PRIVATE LIMITED",
"VR AUTOCARE PRIVATE LIMITED",
"VR AUTOWORLD PRIVATE LIMITED",
"VR COMPOSITES PRIVATE LIMITED",
"VR EARTH MOVERS AND CONSTRUCTIONS PRIVATE LIMITED",
"VR FLEET SERVICES PRIVATE LIMITED",
"VR FOUNDRIES TECH PRIVATE LIMITED",
"VR HEALTH SCIENCE PRIVATE LIMITED",
"VR HVAC SYSTEM",
"VR HYDROCHEM PRIVATE LIMITED",
"VR INCORPORATION",
"VR INDIA SECURITY SERVICES PRIVATE LIMITED",
"VR KABLE INDIA PRIVATE LIMITED",
"VR KONKAN PRIVATE LIMITED",
"VR MAJHA LIMITED",
"VR MARITIME SERVICES PRIVATE LIMITED",
"VR MEDICARE PRIVATE LIMITED",
"VR MOTORS",
"VR RADIANT FRAGRANCES PRIVATE LIMITED",
"VR SULPHUR PRIVATE LIMITED",
"VR SURAT PRIVATE LIMITED",
"VR WEALTH ADVISORS PRIVATE LIMITED",
"VR3 TECHNOLOGIES PRIVATE LIMITED",
"VR7EPAY PRIVATE LIMITED",
"VRA CONSTRUCTIONS PRIVATE LIMITED",
"VRA HOSPITALITY PRIVATE LIMITED",
"VRA RETAIL AND FOOD SOLUTIONS PRIVATE LIMITED",
"VRAHEJA DESIGN CONSTRUCTION PRIVATE LIMITED",
"VRAI LABS PRIVATE LIMITED",
"VRAJ CATTLE FEED PRIVATE LIMITED",
"VRAJ COMMERCIAL PRIVATE LIMITED",
"VRAJ ENGINEERS AND CONSULTANTS PRIVATE LIMITED",
"VRAJ HEALTHCARE PRIVATE LIMITED",
"VRAJ HOSPITAL PRIVATE LIMITED",
"VRAJ HYBRID SEEDS LIMITED",
"VRAJ INFRASTRUCTURE PRIVATE LIMITED",
"VRAJ INTEGRATED TEXTILE PARK LIMITED",
"VRAJ IRON AND STEEL LIMITED",
"VRAJ LABELS PRIVATE LIMITED",
"VRAJ LOGISTICS",
"VRAJ MACHINETOOLS PRIVATE LIMITED",
"VRAJ MERCANTILE PRIVATE LIMITED",
"VRAJ METALIKS PRIVATE LIMITED",
"VRAJ PACKAGING PRIVATE LIMITED",
"VRAJ POLYMERS PRIVATE LIMITED",
"VRAJ TRADELINK PRIVATE LIMITED",
"VRAJBHUMI COTTON INDUSTRIES",
"VRAJBHUMI TECHNOCAST PRIVATE LIMITED",
"VRAJESHWAREE STEEL PRIVATE LIMITED",
"VRAJESHWARI ENGINEER'S LLP",
"VRAJKAMMAN SAI HOSPITALITY PRIVATE LIMITED",
"VRAJMANGAL LIQUID MOVERS AND TRADERS PRIVATE LIMITED",
"VRAMATH FINANCIAL SERVICES PRIVATE LIMITED",
"VRAMPS INGENIOUS PRIVATE LIMITED",
"VRANDAVAN HOSPITALS PRIVATE LIMITED",
"VRANDAVANESHWREE AUTOMOTIVE PRIVATE LIMITED",
"VRAR PROPERTIES PRIVATE LIMITED",
"VRATA TECH SOLUTIONS PRIVATE LIMITED",
"VRAV SALESMART PRIVATE LIMITED",
"VRAZ ACADEMY PRIVATE LIMITED",
"VRB CONSUMER PRODUCTS PRIVATE LIMITED",
"VRC CONSTRUCTIONS INDIA PRIVATE LIMITED",
"VRC DC HIGHWAYS PRIVATE LIMITED",
"VRC LOGISTICS PRIVATE LIMITED",
"VRC PLASTOMOULD (INDIA) PRIVATE LIMITED",
"VRC SILOS PRIVATE LIMITED",
"VRD AGRO PRODUCER COMPANY LIMITED",
"VRD BEST FOODS PRIVATE LIMITED",
"VRD MANAGEMENT SERVICES PRIVATE LIMITED",
"VRD NETWORK AND COMMUNICATION PRIVATE LIMITED",
"VRD RETAIL PRIVATE LIMITED",
"VRENTIN TECH PRIVATE LIMITED",
"VRENYAM WOOD PLASTICS PRIVATE LIMITED",
"VREP CONSTRUCTION AND CONSULTANTS PRIVATE LIMITED",
"VRF AIRCON PRIVATE LIMITED",
"VRF MARKETING PRIVATE LIMITED",
"VRG ELECTRONICS PRIVATE LIMITED",
"VRG ENERGY INDIA PRIVATE LIMITED",
"VRG INDUSTRIES PRIVATE LIMITED",
"VRG INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"VRH LIGHTNING PROTECTION PRIVATE LIMITED",
"VRH LOGISTICS PRIVATE LIMITED",
"VRHK INTERNATIONAL COURIER PRIVATE LIMITED",
"VRHR ENGINEERING PRIVATE LIMITED",
"VRHYTHMS SOFTWARE PRIVATE LIMITED",
"VRIDDHI FARMS PRIVATE LIMITED",
"VRIDDHI INFRATECH INDIA PRIVATE LIMITED",
"VRIDDHI PACKS PRIVATE LIMITED",
"VRIDDHI SOFTWARE SOLUTIONS PRIVATE LIMITED",
"V-RIDE INDIA MULTITRADE PRIVATE LIMITED",
"VRIDHI CONSULTANCY SERVICES PRIVATE LIMITED",
"VRIDHI ENTERPRISES PRIVATE LIMITED",
"VRIDHI EXPORTS PRIVATE LIMITED",
"VRIDHI MARITIME PRIVATE LIMITED",
"VRIDHI SOFTECH SERVICES PRIVATE LIMITED",
"VRIHIS PROPERTIES PRIVATE LIMITED",
"VRIJESH CORPORATION",
"VRIJESH NATURAL FIBRE & FABRICS INDIA PRIVATE LIMITED",
"VRIJESH OVERSEAS PRIVATE LIMITED",
"VRIJESH VESTIO PRIVATE LIMITED",
"VRIKS TELECOM PRIVATE LIMITED",
"VRIKSH TRANSWORLD HOLDINGS LIMITED",
"VRIKSHA AGRO SCIENCES PRIVATE LIMITED",
"VRIKSHA INVESTMENTS PVT LTD",
"VRINAM RETAIL LLP",
"VRINDA BIHARI JI ALLOYS PRIVATE LIMITED",
"VRINDA CHEMICALS (INDIA) PRIVATE LIMITED",
"VRINDA DIAGNOSTIC CENTRE PRIVATE LIMITED",
"VRINDA ENGINEERS PRIVATE LIMITED",
"VRINDA FINLEASE LIMITED",
"VRINDA GLOBAL PRIVATE LIMITED",
"VRINDA HEALTHCARE PRIVATE LIMITED",
"VRINDA HOUSING PRIVATE LIMITED",
"VRINDA INTERNATIONAL PRIVATE LIMITED",
"VRINDA LABS AND RESEARCH CENTRE PRIVATE LIMITED",
"VRINDA LOGISTICS PRIVATE LIMITED",
"VRINDA MEDICARE PRIVATE LIMITED",
"VRINDA NANO TECHNOLOGIES PRIVATE LIMITED",
"VRINDA PAPERS PRIVATE. LIMITED.",
"VRINDA PETROLEUM AND CHEMICALS PRIVATE LIMITED",
"VRINDA POLYPLAST PRIVATE LIMITED",
"VRINDA TECHNOLOGIES PRIVATE LIMITED",
"VRINDA TEX PRIVATE LIMITED",
"VRINDAA ADVANCED MATERIALS LIMITED",
"VRINDABAN CONSTRUCTION AND ENGINEERING PRIVATE LIMITED",
"VRINDABAN TEA & PLANTATIONS PRIVATE LIMITED",
"VRINDAMADHAV TRADE AND E SERVICES PRIVATE LIMITED",
"VRINDAVAN APPARELS PRIVATE LIMITED",
"VRINDAVAN COLD STORAGE (INDORE) PRIVATE LIMITED",
"VRINDAVAN ENGINEERS AND CONTRACTORS INDIA PRIVATE LIMITED",
"VRINDAVAN FASHIONS PRIVATE LIMITED",
"VRINDAVAN FERRO TECH PRIVATE LIMITED",
"VRINDAVAN FINVEST PRIVATE LIMITED",
"VRINDAVAN FOODWORKS PRIVATE LIMITED",
"VRINDAVAN INFOTECH PRIVATE LIMITED",
"VRINDAVAN INFRA ESTATES PRIVATE LIMITED",
"VRINDAVAN INTERNATIONAL PUBLIC SCHOOL",
"VRINDAVAN METAL INDUSTRIES PRIVATE LIMITED",
"VRINDAVAN NURSERY & FARM",
"VRINDAVAN POLYMERS PRIVATE LIMITED",
"VRINDAVAN SERVICES PRIVATE LIMITED",
"VRINDAVAN TELECOMS INDIA PRIVATE LIMITED",
"VRINDAWAN BIHARI RUBBER PRODUCTS PRIVATE LIMITED",
"VRINDKANHA COTPRINT PRIVATE LIMITED",
"VRINSOFT TECHNOLOGY PRIVATE LIMITED",
"VRION GLOBAL PRIVATE LIMITED",
"VRISA INNOVATION LIMITED",
"VRISA SALES PRIVATE LIMITED",
"VRISE SECURITIES PRIVATE LIMITED",
"VRISHAB INFRA VENTURES PRIVATE LIMITED",
"VRISHABH COTTON PRIVATE LIMITED",
"VRISHABHA LABORATORIES PRIVATE LIMITED",
"VRISHAH SERVICES PRIVATE LIMITED",
"VRISHALI HOTELS PRIVATE LIMITED",
"VRISHNI LOGISTICS PRIVATE LIMITED",
"VRISHTI BEVERAGESS PRIVATE LIMITED",
"VRITA VENTURES PRIVATE LIMITED",
"VRITI JEWELS PRIVATE LIMITED",
"VRITIKA HERBOTECH PRIVATE LIMITED",
"VRITIKA LIFESTYLE PRIVATE LIMITED",
"VRITIKA TRADING PRIVATE LIMITED",
"VRITTI IMPEX PRIVATE LIMITED",
"VRIX ELECTRIC INDIA PRIVATE LIMITED",
"VRIZE TECHNOLOGIES PRIVATE LIMITED",
"VRJ LOGISTICS PRIVATE LIMITED",
"VRJ PETRO CHEMICALS PRIVATE LIMITED",
"VRK ALUMART PRIVATE LIMITED",
"VRK LIFESCIENCES PRIVATE LIMITED",
"VRK POWER PRIVATE LIMITED",
"VRKP STEEL INDUSTRIES PRIVATE LIMITED",
"VRL AUTOMATION ENGINEERING & PROJECTS PRIVATE. LIMITED.",
"VRL LOGISTICS LIMITED",
"VRL MEDIA LIMITED",
"VRL MEDIA PRIVATE LIMITED",
"VRM BUSINESS SERVICES PRIVATE LIMITED",
"VRM ENERGY CONSULTANCY SERVICES PRIVATE LIMITED",
"VRM METAZINE PRIVATE LIMITED",
"VRML CONSTRUCTIONS PRIVATE LIMITED",
"VRMX CONCRETE INDIA PRIVATE LIMITED",
"VRN CERAMICS LIMITED",
"VRN TECHNOLOGIES PRIVATE LIMITED",
"VRNDA SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"VROBAL RECYCLING INDIA PRIVATE LIMITED",
"VROOMATIC SOLUTIONS PRIVATE LIMITED",
"VROOMBLE SERVICES PRIVATE LIMITED",
"VRP DIAMONDS LLP",
"VRP TELEMATICS PRIVATE LIMITED",
"VRPL HEALTHCARE PRIVATE LIMITED",
"VRPM INVESTMENTS PRIVATE LIMITED",
"VRRDDHI FREIGHT PRIVATE LIMITED",
"VRRIDHI EXTRUSIONS PRIVATE LIMITED",
"VRS AGRITECH PRIVATE LIMITED",
"VRS BROTHERS ENTERPRISES PRIVATE LIMITED",
"VRS DREAMLAND FRESH PRIVATE LIMITED",
"VRS FASHIONS PRIVATE LIMITED",
"VRS FOODS LIMITED",
"VRS INFOTECH PRIVATE LIMITED",
"VRS LEATHERS PRIVATE LIMITED",
"VRS LOGISTICS (OPC) PRIVATE LIMITED",
"VRS SECURITIES LIMITED",
"VRS TOWNSHIPS PRIVATE LIMITED",
"VRSR RETAIL PRIVATE LIMITED",
"VRT LOGISTICS SOLUTIONS PRIVATE LIMITED",
"VRUDAM INSTITUTE OF MEDICAL SCIENCE",
"VRUDANT FINE CHEM PRIVATE LIMITED",
"VRUDDHI ENGINEERING WORKS LIMITED",
"VRUDHI LIFESCIENCES PRIVATE LIMITED",
"VRUDHI OUTSOURCING SERVICES PRIVATE LIMITED",
"VRUJ TELECOM (I) PRIVATE LIMITED",
"VRUKSHA MICROFIN PRIVATE LIMITED",
"VRUKSHAA PLY & INTERIORS PRIVATE LIMITED",
"VRUNDA FABRICS PRIVATE LIMITED",
"VRUNDA VITTHAL POLYNET LIMITED",
"VRUNDAVAN ENTERPRISE",
"VRUNDAVAN ENTERTAINMENT PRIVATE LIMITED",
"VRUNDAVAN SHALBY HOSPITALS LIMITED",
"VRUSHA ORGANICS PRIVATE LIMITED",
"VRUSHAL TRADING PRIVATE LIMITED",
"VRUSHALI ENGINEERING PRIVATE LIMITED",
"VRUSHIKA RESEARCH ADVISOR PRIVATE LIMITED",
"VRV ASIA PACIFIC PRIVATE LIMITED",
"VRV DEVELOPERS PRIVATE LIMITED",
"VRV ENERGIES INDIA PRIVATE LIMITED",
"VRV FOODS LIMITED",
"VRV INFO LED PRIVATE LIMITED",
"VRVITALS PRIVATE LIMITED",
"VRVS INDIA PRIVATE LIMITED",
"VRX HEALTH CARE PRIVATE LIMITED",
"VRX SPORTS PRIVATE LIMITED",
"VRYLY VENTURES PRIVATE LIMITED",
"VS AND B DOMESTIC CONTAINER SOLUTIONS PRIVATE LIMITED",
"VS ASSET LEGACY PRIVATE LIMITED",
"VS DENTAL COLLEGE AND HOSPITAL",
"VS DESIGN WORX PRIVATE LIMITED",
"VS ECO POWER PRIVATE LIMITED",
"VS GARMENTS",
"VS GEOSPATIAL TECHNOLOGIES PRIVATE LIMITED",
"VS HEALTHTECH PRIVATE LIMITED",
"VS JEWELLERY WHOLESALER GLOBAL PRIVATE LIMITED",
"VS KISAN PRODUCER COMPANY LIMITED",
"VS LIGNITE POWER PRIVATE LIMITED",
"VS MANICKAM STORE",
"VS METALLIC PRIVATE LIMITED",
"VS MOTORS PRIVATE LIMITED",
"VS OVERSEAS PRIVATE LIMITED",
"VS REALPROJECTS PRIVATE LIMITED",
"VS RETAILS PRIVATE LIMITED",
"VS RUBBER PRIVATE LIMITED",
"VS SECURITY & SYSTEMS PRIVATE LIMITED",
"VS SPAN AGRO PRIVATE LIMITED",
"VS TOWERS & CONTRACTORS PRIVATE LIMITED",
"VS TRADECOM PRIVATE LIMITED",
"VS TRANS LOJISTIK LLP",
"VS&DJ CONNECT PRIVATE LIMITED",
"VSA FOODS & BEVERAGES PRIVATE LIMITED",
"VSA HEALTH & WELLNESS PRIVATE LIMITED",
"VSA INDIA PRIVATE LIMITED",
"VSA3B PRIVATE LIMITED",
"VSAAR PHARMA PRIVATE LIMITED",
"VSAN INFRASTRUCTURE PRIVATE LIMITED",
"VSANDV COMMUNICATION PRIVATE LIMITED",
"VSAR TECHNOLOGIES PRIVATE LIMITED",
"VSAS AUTOMATION SERVICES PRIVATE LIMITED",
"VSAT REFURB SOLUTIONS PRIVATE LIMITED",
"VSAVE ELECTRONICS PRIVATE LIMITED",
"VSAY FOODS LLP",
"VSB VASTTRAM PRIVATE LIMITED",
"VSC CONSULTING PRIVATE LIMITED",
"VSC INFRA PRIVATE LIMITED",
"VSC STEELERS PRIVATE LIMITED",
"VSCILARO STEEL INDUSTRY PRIVATE LIMITED",
"VSCON ENGINEERING PRIVATE LIMITED",
"VSD HEALTHPOINT HOSPITAL PRIVATE LIMITED",
"VSD PLASTICS PRIVATE LIMITED",
"VSD RENEWABLE AND CONSULTANTS INDIA PRIVATE LIMITED",
"VSD TECHNOLOGIES PRIVATE LIMITED",
"VSE STOCK SERVICES LIMITED",
"VSECURE TECHNOLOGIES PRIVATE LIMITED",
"VSERV DIGITAL SERVICES PRIVATE LIMITED",
"VSERV INFOSYSTEMS PRIVATE LIMITED",
"VSERVE ECOMMERCE SALES AND SERVICES PRIVATE LIMITED",
"VSERVICE IT SOLUTIONS PRIVATE LIMITED",
"VSES INDIA PRIVATE LIMITED",
"VSF PROJECTS LIMITED",
"VSF SUITINGS PRIVATE LIMITED",
"VSG BIO-PRODUCTS PRIVATE LIMITED",
"VSG CAPITAL ADVISORS PRIVATE LIMITED",
"VSG EXPORTS PRIVATE LIMITED",
"VSG PAN INDUSTRIES PRIVATE LIMITED",
"VSG RESOURCES INDIA PRIVATE LIMITED",
"VSG VENTURES PRIVATE LIMITED",
"VSH TEKALEIDO BUSINESS SOLUTIONS PRIVATE LIMITED",
"V-SHALL FOREX PRIVATE LIMITED",
"V-SHARP MAGNET PRIVATE LIMITED",
"V-SHESH LEARNING SERVICES PRIVATE LIMITED",
"VSIGN ENTERPRISES PRIVATE LIMITED",
"VSINTERCONNECT INDIA PRIVATE LIMITED",
"VSION TECH PARK PRIVATE LIMITED",
"VSIX AUTOTECH SOLUTIONS INDIA PRIVATE LIMITED",
"VSJ FINCAP PRIVATE LIMITED",
"VSJ INVESTMENTS PRIVATE LIMITED",
"VSK ASSOCIATES",
"VSK CITY BUS OPERATIONS PRIVATE LIMITED",
"VSK DISTRIBUTORS PRIVATE LIMITED",
"VSK FINANCIAL CONSULTANCY SERVICES P LTD",
"VSK INDUSTRIES PRIVATE LIMITED",
"VSK INFRASTRUCTURES PRIVATE LIMITED",
"VSK INTERNATIONAL PRIVATE LIMITED",
"VSK MEDICAL EQUIPMENT PRIVATE LIMITED",
"VSK POLYFINS PRIVATE LIMITED",
"VSKB CONSULTANTS PRIVATE LIMITED",
"VSL BIOGREEN SOLUTION PRIVATE LIMITED",
"VSL ELECTRONICS PRIVATE LIMITED",
"VSL INDIA PRIVATE LIMITED",
"VSL INDUSTRIES",
"VSL LOGISTICS SOLUTIONS PRIVATE LIMITED",
"VSL MARINE TECHNOLOGY PRIVATE LIMITED",
"VSL RE POWER PRIVATE LIMITED",
"VSL REALTIES PRIVATE LIMITED",
"VSL SHOPPING MALL PRIVATE LIMITED",
"VSL TECHNOLOGIES PRIVATE LIMITED",
"VSL VENTURES PRIVATE LIMITED",
"VSLS GLOBAL LOGISTICS SERVICES PRIVATE LIMITED",
"VSM ENTERPRISES PRIVATE LIMITED VSME",
"VSM FOOD COLD CHAIN AND PROCESSORS LLP",
"VSM HATCHERIES PRIVATE LIMITED",
"VSM IMPEX PRIVATE LIMITED",
"VSM INDIA PRIVATE LIMITED",
"VSM INDUSTRIES PRIVATE LIMITED",
"VSM INTERNATIONAL PRIVATE LIMITED",
"VSM OVERSEAS PRIVATE LIMITED",
"VSM PAPER PRIVATE LIMITED",
"VSM PROJECTS PRIVATE LIMITED",
"VSM SOFTWARE PRIVATE LIMITED",
"VSM SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED",
"VSM TECHNOLOGIES PRIVATE LIMITED",
"VSM VENTURE CONTROL SYSTEMS PRIVATE LIMITED",
"VSM WEAVESS INDIA PRIVATE LIMITED",
"VSMART HEALTH VENTURES PRIVATE LIMITED",
"VSMC LOGISTICS PARK PRIVATE LIMITED",
"VSN AUTOMOBILES PRIVATE LIMITED",
"VSN COMMERCIALS PRIVATE LIMITED",
"VSN ELECTRO COMPONENTS PRIVATE LIMITED",
"VSN INFRA SYSTEMS PRIVATE LIMITED",
"VSN INTERNATIONAL PRIVATE LIMITED",
"VSN LABORATORIES PRIVATE. LIMITED.",
"VSN MONEY EXCHANGERS PRIVATE LIMITED",
"VSNAP TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"VSNR INFRASTRUCTURE PRIVATE LIMITED",
"VSOFT TECHNOLOGIES PRIVATE LIMITED",
"VSOLV ENGINEERING INDIA PRIVATE LIMITED",
"VSON CREATIONS PRIVATE LIMITED",
"VSOURCE EDUCATIONAL CONSULTANTS PRIVATE LIMITED",
"VSP CROP SCIENCE PRIVATE LIMITED",
"VSP ENTERPRISES PRIVATE LIMITED",
"VSP HOTELS PRIVATE LIMITED",
"VSP STARRR REALTY PRIVATE LIMITED",
"VSPA FINANCE LIMITED",
"VSPARK COMMUNICATIONS PRIVATE LIMITED",
"V-SPARK LABORATORIES PRIVATE LIMITED",
"VSPIRE MANAGEMENT SERVICES PRIVATE LIMITED",
"VSPL ENERGY PRIVATE LIMITED",
"VSPLASH TECH LABS PRIVATE LIMITED",
"VSPM ACADAMY OF HIGHER EDUCATION",
"VSPM ACADEMY OF HIGHER EDUCATION",
"VSPMS DENTAL COLLEGE RESE",
"VSQUARE SERVICES PRIVATE LIMITED",
"VSQUARE SYSTEMS PRIVATE LIMITED",
"VSR AUTO ENGINEERING PRIVATE LIMITED",
"VSR CORPORATION PRIVATE LIMITED",
"VSR ELECTRICAL & INSTRUMENTS INDIA PRIVATE LIMITED",
"VSR INDUSTRIES PRIVATE LIMITED",
"VSR INFRATECH PRIVATE LIMITED",
"VSR LAMINATES PRIVATE LIMITED",
"VSR ROLLING MILLS AND MACHINERY PRIVATE LIMITED",
"VSR VENTURES PRIVATE LIMITED",
"VSRC AGRO PRODUCTS INDIA PRIVATE LIMITED",
"VSRK CAPITAL PRIVATE LIMITED",
"VSS FOREX SERVICES PRIVATE LIMITED",
"VSS HOUSING PRIVATE LIMITED",
"VSS INVESTCO PRIVATE LIMITED",
"VSS IRON AND MINERALS PRIVATE LIMITED",
"VSS METALS PRIVATE LIMITED",
"VSS PACKAGING PRIVATE LIMITED",
"VSS TECH SOLUTION PRIVATE LIMITED",
"VSSD COLLEGE KANPUR",
"VSSM VARSO BELTS PRIVATE LIMITED",
"VST ELECTRONIC SECURITY PRIVATE LIMITED",
"VST FABTEX PRIVATE LIMITED",
"VST INDUSTRIES LIMITED",
"VST NATIONAL PRODUCTS LIMITED",
"VST PROJECTS PRIVATE LIMITED",
"VST SPINTEX INDIA PRIVATE LIMITED",
"VST TILLERS TRACTORS LIMITED",
"VST TITANIUM MOTORS PRIVATE LIMITED",
"VST WEAVES INDIA PRIVATE LIMITED",
"VSTACKS INFOTECH PRIVATE LIMITED",
"VSU EXIM PRIVATE LIMITED",
"VSV ONSITE PRIVATE LIMITED",
"VSV POWERTECH PRIVATE LIMITED",
"VSV RENEWABLES PRIVATE LIMITED",
"VSV SAFETY PRODUCTS PRIVATE LIMITED",
"VSV TOOLS ORIENTED PRIVATE LIMITED",
"VSVB BUSINESS SOLUTIONS PRIVATE LIMITED",
"VSVR CHEMS PRIVATE LIMITED",
"VSY OPHTHALMIC INDIA PRIVATE LIMITED",
"VT CAPITAL MARKET PRIVATE LIMITED",
"VT COMMODITIES INDIA PRIVATE LIMITED",
"VT DAIRY PRIVATE LIMITED",
"VT EMOBILITY PRIVATE LIMITED",
"VT EXPORTS PVT LTD",
"VT FOOTWEAR PRIVATE LIMITED",
"VT NETZWELT PRIVATE LIMITED",
"VT PHARMATEK PRIVATE LIMITED",
"VT TOOLS PRIVATE LIMITED",
"VT VACUUM HEAT TREATERS PRIVATE LIMITED",
"VT VACUUM TECHNOLOGIES PRIVATE LIMITED",
"VTALITY AGRO PRIVATE LIMITED",
"VTAURUS TECHNOLOGIES PRIVATE LIMITED",
"VTC 3 PL SERVICES LIMITED",
"VTC 3 PL SERVICES PRIVATE LIMITED",
"VTC ENGINEERING PVT LTD",
"VTC PROJECTS PRIVATE LIMITED",
"VTC SURFACE TECHNOLOGIES PRIVATE LIMITED",
"VTC TRADEWINGS PRIVATE LIMITED",
"VTC TRANSPORT PRIVATE LIMITED",
"VTD TOURISM PRIVATE LIMITED",
"V-TECH (INDIA) AUTOMOTIVE PRIVATE LIMITED",
"V-TECH (INDIA) PRIVATE LIMITED",
"VTECH BIOTRON PRIVATE LIMITED",
"VTECH BUILDCON PRIVATE LIMITED",
"V-TECH ENGINEERING PRIVATE LIMITED",
"V-TECH INSTRUMENTATION (INDIA) PRIVATE LIMITED",
"V-TECH INTEGRAHOMES PRIVATE LIMITED",
"VTECH NXTGEN CARS PRIVATE LIMITED",
"VTECH SUNSYSTEMS PRIVATE LIMITED",
"VTECH SYNERGY INDIA PRIVATE LIMITED",
"V-TECH TECHNOLOGIES PRIVATE LIMITED",
"VTECHFAMILY SOLUTION INDIA PRIVATE LIMITED",
"V-TECHWEB (INDIA) PRIVATE LIMITED",
"VTEL AUTO INDIA PRIVATE LIMITED",
"V-TEN REALTY PRIVATE LIMITED",
"VTEX OVERSEAS PRIVATE LIMITED",
"V-TEX SILK MILLS PRIVATE LIMITED",
"VTGURU TECHNOLOGY PRIVATE LIMITED",
"VTH SOURCE COMPONENTS PRIVATE LIMITED",
"VTHINK GLOBAL TECHNOLOGIES PRIVATE LIMITED",
"VTHRIVE SOLUTIONS PRIVATE LIMITED",
"VTI INSTRUMENTS PRIVATE LIMITED",
"VTIGER SYSTEMS INDIA PRIVATE LIMITED",
"VTK AUTOMOBILES PRIVATE LIMITED",
"VTK INDUSTRIES PRIVATE LIMITED",
"VTL ELECTRONICS LIMITED",
"VTL GLOBAL SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED",
"VTL LOGISTICS INDIA PRIVATE LIMITED",
"VTM LIMITED",
"VTMTEX VIRTUAL TEXTILE MILL (INDIA) PRIVATE LIMITED",
"VTO INFORMATION TECHNOLOGY PRIVATE LIMITED",
"VTOTECH SEATING SYSTEMS PRIVATE LIMITED",
"VTP CORPORATION LLP",
"VTP GLOBAL PRODUCTS & SERVICES PRIVATE LIMITED",
"VTP RAIRAH FOODS PRIVATE LIMITED",
"V-TRAC WORLDWIDE TRAFFIC CONSULTING PRIVATE LIMITED",
"VTRIO SOLUTIONS PRIVATE LIMITED",
"VTRIP LOGISTICS (OPC) PRIVATE LIMITED",
"VTRPOWERX TOOLS PRIVATE LIMITED",
"VTS CLIMA INDIA PRIVATE LIMITED",
"VTS INFOSOFT PRIVATE LIMITED",
"VTS PROJECTS PRIVATE LIMITED",
"VTS TF AIR SYSTEMS PRIVATE LIMITED",
"VTT TRANSPORT SOLUTIONS PRIVATE LIMITED",
"VTWENTYNINE MANUFACTURING AND MARKETING PRIVATE LIMITED",
"VU TECHNOLOGIES PRIVATE LIMITED",
"VU VIDEOCONFERENCING PRIVATE LIMITED",
"VUB EXPORTS PRIVATE LIMITED",
"VUBITES INDIA PRIVATE LIMITED",
"VUCHI MEDIA PRIVATE LIMITED",
"VUCLIP (INDIA) PRIVATE LIMITED",
"VUCLIP INDIA PRIVATE LIMITED",
"VUDDANDA SOLAR POWER PRIVATE LIMITED",
"VUE DATA TECHNOLOGIES PRIVATE LIMITED",
"VUEARK TECHNOLOGY SERVICES PRIVATE LIMITED",
"VUELOGIX TECHNOLOGIES PRIVATE LIMITED",
"VUENOW INFOTECH PRIVATE LIMITED",
"VUENOW MARKETING SERVICES PRIVATE LIMITED",
"VUESOL SOFTWARE SOLUTIONS",
"VUI CONSULTANCY PRIVATE LIMITED",
"VUI SYSTEMS PRIVATE LIMITED",
"VUJWALA HOUSING PRIVATE LIMITED",
"VUK FINVEST PRIVATE LIMITED",
"VUK INDUSTRIES PRIVATE LIMITED",
"VULCAN ADVANCE INTELLIGENCE COMPUTING PRIVATE LIMITED",
"VULCAN CASTINGS PRIVATE LIMITED",
"VULCAN CERAMICS COMPANY PRIVATE LIMITED",
"VULCAN COLD FORGE PRIVATE. LIMITED.",
"VULCAN COLD FORM PRIVATE LIMITED",
"VULCAN COMMERCIALS PRIVATE LIMITED",
"VULCAN COMMERCIALS PVT LTD",
"VULCAN CONSULTECH PRIVATE LIMITED",
"VULCAN ELECTRO CONTROLS LIMITED",
"VULCAN EXPRESS PRIVATE LIMITED",
"VULCAN EXTRUSIONS PRIVATE LIMITED",
"VULCAN FORCE FACILITY MANAGEMENT (INDIA) PRIVATE LIMITED",
"VULCAN FORGE PRIVATE. LIMITED.",
"VULCAN INDUSTRIAL ENGINEERING COMPANY LIMITED",
"VULCAN INDUSTRIAL ENGINEERING COMPANY PRIVATE LIMITED",
"VULCAN INSURANCE SERVICES PRIVATE LIMITED",
"VULCAN LABORATORIES PVT LTD",
"VULCANTECH SOFTWARE INDIA PRIVATE LIMITED",
"VULKAN TECHNOLOGIES PRIVATE LIMITED",
"VULTBIZ SOLUTIONS PRIVATE LIMITED",
"VULTURE INNOVATION PRIVATE LIMITED",
"VUMMIDI BANGARU JWELLERS",
"VUN DIGITAL PRIVATE LIMITED",
"VUNDAVALLI ENTERPRISES PRIVATE LIMITED",
"VUNET SYSTEMS PRIVATE LIMITED",
"VUNUM INFOTECH SOLUTIONS PRIVATE LIMITED",
"VUPADHI TECHNO SERVICES PRIVATE LIMITED",
"VURA BAU-CHEMIE LLP",
"VURAM TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"VURVE SALONS PRIVATE LIMITED",
"VV AUTOTEST SYSTEMS PRIVATE LIMITED",
"VV COLLEGE- DAY",
"VV COLLEGE EVE",
"VV FINLY TECHNOLOGY PRIVATE LIMITED",
"VV LABS PRIVATE LIMITED",
"VV RESTAURANTS PRIVATE LIMITED",
"VV SILVER PALACE PRIVATE LIMITED",
"VV. EXPORTS UNIVERSAL PRIVATE LIMITED",
"VVA AUTO INDUSTRIES PRIVATE LIMITED",
"VVA HOTELS PRIVATE LIMITED",
"VVAAN LIFESCIENCES PRIVATE LIMITED",
"VVALETI MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"VVBG PRIVATE LIMITED",
"VVC FARM EQUIPMENTS PRIVATE LIMITED",
"VVC MKS PROJECT PRIVATE LIMITED",
"VVC MOTORS PRIVATE LIMITED",
"VVC REALINFRA PRIVATE LIMITED",
"VVD AND SONS PRIVATE LIMITED",
"VVDN TECHNOLOGIES PRIVATE LIMITED",
"VVE TRANSFORMERS PRIVATE LIMITED",
"V-VERMA JEWELLERS PRIVATE LIMITED",
"VVF INDIA LIMITED",
"VVFLEX PACK PRIVATE LIMITED",
"VVG LANDMARKS PRIVATE LIMITED",
"VVIP FLIGHT PRIVATE LIMITED",
"VVIP INFRAHOME PRIVATE LIMITED",
"VVIP INFRATECH LIMITED",
"VVJK BUILDERS PRIVATE LIMITED",
"VVKS DEVELOPERS PRIVATE LIMITED",
"VVM BIOTECH INFRA PRIVATE LIMITED",
"VVMP FORE VENTURES PRIVATE LIMITED",
"VVN TECHNOLOGIES PRIVATE LIMITED",
"VVNKM SR SEC SCHOOL",
"VVP BUSINESS LOGISTICS PRIVATE LIMITED",
"VVR CONSULTANTS & ENTERPRISES PRIVATE LIMITED",
"VVR HOSPITALS PRIVATE LIMITED",
"VVR ORGANICS PRIVATE LIMITED",
"VVS ALLOYS PRIVATE LIMITED",
"VVS CONCAST PRIVATE LIMITED",
"VVS GLOBAL FORWARDERS PRIVATE LIMITED",
"VVS JEWELS PRIVATE LIMITED",
"VVS MARKETING PRIVATE LIMITED",
"VVV CHEMICALS LIMITED",
"VVV CONSTRUCTION PRIVATE LIMITED",
"VVV PROJECTS AND SYSTEMS PRIVATE LIMITED",
"VVV SPICES INDIA PRIVATE LIMITED",
"VVV STRUCTURE TECHNOLOGIES PRIVATE LIMITED",
"VVVESTURES PRIVATE LIMITED",
"VW CUISINES AND CONCEPTS PRIVATE LIMITED",
"VWF INDUSTRIES PRIVATE LIMITED",
"VWI TRAVEL PRIVATE LIMITED",
"VWILL FOOTWEAR PRIVATE LIMITED",
"VWIN NOTEBOOKS PRIVATE LIMITED",
"VWR LAB PRODUCTS PRIVATE LIMITED",
"VXCEED SOFTWARE SOLUTIONS PRIVATE LIMITED",
"VXL FABRICS PRIVATE LIMITED",
"VXL INDIA EDU CENTRE PRIVATE LIMITED",
"VXL INSTRUMENTS LIMITED",
"VXL RINGTRAVELLERS PRIVATE LIMITED",
"VXL SOFTWARE SOLUTION PRIVATE LIMITED",
"VXL STEELS",
"VXL TECHNOLOGIES LIMITED",
"VXPLORE TECHNOLOGIES PRIVATE LIMITED",
"V-XUBER MARKETING AND COMMUNICATION SOLUTIONS PRIVATE LIMITED",
"VY LABS TECHNOLOGIES PRIVATE LIMITED",
"VY SYSTEMS PRIVATE LIMITED",
"VYAAN EQUIPMENTS INDIA PRIVATE LIMITED",
"VYAASH LOGISTICS PRIVATE LIMITED",
"VYAGHRA HEALTH FOODS PRIVATE LIMITED",
"VYAIRE MEDICAL PRIVATE LIMITED",
"VYAKYA TECHNOLOGIES PRIVATE LIMITED",
"VYANKATDRI CONSULTANCY PRIVATE LIMITED",
"VYANKATESH CRUSHING AND CONSTRUCTIONS PRIVATE LIMITED",
"VYANKATESH METALS AND ALLOYS PRIVATE LIMITED",
"VYANKATESH TEXCOSPIN PRIVATE LIMITED",
"VYANKATESH UDYOG (INDIA) PRIVATE LIMITED",
"VYANKATESHA BUILDERS & DEVELOPERS",
"VYANKTESH CORRUGATORS PRIVATE LIMITED",
"VYANKTESH FABRICRAFT PRIVATE LIMITED",
"VYANKTESH INDUSTRIAL CREATIONS PRIVATE LIMITED",
"VYANKTESH INDUSTRIAL SOLUTIONS PRIVATE LIMITED",
"VYANKTESH PACKAGING (HYDERABAD) PRIVATE LIMITED",
"VYANKTESH PLASTICS AND PACKAGINGS PVT LTD",
"VYANTECH PRIVATE LIMITED",
"VYAPAAR VISTAAR TECH PRIVATE LIMITED",
"VYAPARAVIJAYAM TRADES AND AGENCIES PVT LTD",
"VYAPARIK AUDHYOGIK SAHAKARI BANK LTD",
"VYAPIN SOFTWARE SYSTEMS PRIVATE LIMITED",
"VYAPINI TECH SERVICES PRIVATE LIMITED",
"VYAPTAM INFRA PRIVATE LIMITED",
"VYAPTI VANDEMATARAM (I) INFRABUILD PRIVATE LIMITED",
"VYARA TILES PRIVATE LIMITED",
"VYAS AND SON CONSTRUCTION PRIVATE LIMITED",
"VYAS BUILDCON PRIVATE LIMITED",
"VYAS DIGITAL RETAIL PRIVATE LIMITED",
"VYAS GIANNETTI CREATIVE PRIVATE LIMITED",
"VYAS MEDICITY SUPER SPECIALITY HOSPITAL IN JODHPUR",
"VYAS RASAYAN PRIVATE LIMITED",
"VYAS REALTIES PRIVATE LIMITED",
"VYASA INTERNATIONAL SCHOOL",
"VYASA SEEDS PRIVATE LIMITED",
"VYASV INDUSTRIES (INDIA) LIMITED",
"VYAVASAYI VIDYA PRATISTHAN SANCHALIT ENGINEERING COLLEGE",
"VYAVSAY SHIKSHAN VIBHAG KANYASHALA WAI",
"VYAVSAYI BACHAT EVAM SAKH SWAMLAMBI NIDHI LIMITED",
"VYBRANT INVESTO & PROJECTS PRIVATE LIMITED",
"VYD CONSULTING PRIVATE LIMITED",
"VYDEHI INSTITITE OF MEDICAL SCIENCES",
"VYDEHI SCHOOL OF EXCELLENCE",
"VYDEHI SUPERSPECIALITY HOSPITAL LIMITED",
"VYENKATESH AGROTRADE PRIVATE LIMITED",
"VYENKATESH GLOBAL VENTURES PRIVATE LIMITED",
"VYGON INDIA PRIVATE.LIMITED",
"VYJACK PRINTPACK PRIVATE LIMITED",
"VYMO SOLUTIONS PRIVATE LIMITED",
"VYNBOXES SERVICES PRIVATE LIMITED",
"VYNTELLIGENCE INDIA PRIVATE LIMITED",
"VYOM DISTRIBUTORS PRIVATE LIMITED",
"VYOM FASTENERS PRIVATE LIMITED",
"VYOM FERTILIZERS AND AGROCHEM PRIVATE LIMITED",
"VYOM FINANCE PRIVATE LIMITED",
"VYOM FOODCRAFT PRIVATE LIMITED",
"VYOM LABS PRIVATE LIMITED",
"VYOM POWER PRIVATE LIMITED",
"VYOM PRODUCTIONS INDIA PRIVATE LIMITED",
"VYOM SHUBHAM LOGISTICS PRIVATE LIMITED",
"VYOMA DECORS PRIVATE LIMITED",
"VYOMA LINGUISTIC LABS FOUNDATION",
"VYOMA LOGITECH PRIVATE LIMITED",
"VYOMA TECHNOLOGIES PRIVATE LIMITED",
"VYOMAA ENERGY PRIVATE LIMITED",
"VYOMAN INDIA PRIVATE LIMITED",
"VYOME BIOSCIENCES PRIVATE LIMITED",
"VYOME THERAPEUTICS LIMITED",
"VYOMEDIA PRIVATE LIMITED",
"VYOMESH INVESTMENT AND TRADING COMPANY PRIVATE LIMITED",
"VYOMFACILITY INDIA PRIVATE LIMITED",
"VYOMSAI TECHNOLOGY PRIVATE LIMITED",
"VYONA LOGISTICS PRIVATE LIMITED",
"VYOSYS TECHNOLOGIES PRIVATE LIMITED",
"VYSHALI ENERGY PRIVATE LIMITED",
"VYSHNAVI APPARELS PRIVATE LIMITED",
"VYSHNAVI INFORMATION TECHNOLOGIES INDIAPRIVATE LIMITED",
"VYSUS CONSULTING INDIA PRIVATE LIMITED",
"VYSYARAJU JEWELLERS PRIVATE LIMITED",
"VYTTILA STEEL PRIVATE LIMITED",
"VYUHA OUTLINE MEDIA PRIVATE LIMITED",
"VYUHANA PRIVATE LIMITED",
"VYUHGENICS INDIA PRIVATE LIMITED",
"VYUSYNC DESIGN SOLUTIONS PRIVATE LIMITED",
"VYZE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"VZEN INDUSTRIES PRIVATE LIMITED",
"VZOIC HEALTHCARE PRIVATE LIMITED",
"VZZA INDUSTRIES PRIVATE LIMITED",
"W & G FASHION PRIVATE LIMITED",
"W & W ENGINEERING PRIVATE LIMITED",
"W .R O. LOGISTICS PRIVATE LIMITED",
"W AND W PROJECTS PRIVATE LIMITED",
"W B AGRO PRODUCTS PRIVATE LIMITED",
"WE EXCEL SOFTWARE PRIVATE LIMITED",
"W FIVE COMMUNICATION PRIVATE LIMITED",
"W G TECHNOLOGIES PRIVATE LIMITED",
"W GOA A UNIT OF DIANA BUILDWELL PVT LTD",
"W H SMITH MEMORIAL SCHOOL",
"W R TALWALKER BROTHERS PRIVATE LIMITED",
"W R TALWALKER ENGINEERING PRIVATE LIMITED",
"W S ATKINS INDIA PRIVATE LIMITED",
"W S FITNESS PRIVATE LIMITED",
"W S TELEMATICS PRIVATE LIMITED",
"W SHAKTI FOUNDATION",
"W T T INTERNATIONAL PRIVATE LIMITED",
"W W TRADING PRIVATE LIMITED",
"W&H DENTAL INDIA PRIVATE LIMITED",
"W. G. ENTERPRISES PRIVATE LIMITED",
"W. HUNGER HYDRAULICS INDIA PRIVATE LIMITED",
"W.B. TEA INFOMATICS PRIVATE LIMITED",
"W.H. BRADY & COMPANY LIMITED",
"W.W. SHIPPING & FORWARDING PRIVATE LIMITED",
"W1 SPORTS CONSULTING PRIVATE LIMITED",
"W3ERA WEB TECHNOLOGY PRIVATE LIMITED",
"W3GLOBAL INDIA PRIVATE LIMITED",
"W3VILLA TECHNOLOGIES PRIVATE LIMITED",
"WAA MOTORS AND PUMPS PRIVATE LIMITED",
"WAA SOLAR PRIVATE LIMITED",
"WAAMAN PRODUCTS PRIVATE LIMITED",
"WAANEEP SOLAR PRIVATE LIMITED",
"WAAREE ENERGIES LIMITED",
"WAAREE ESS PRIVATE LIMITED",
"WAAREE GREEN ALUMINIUM PRIVATE LIMITED",
"WAAREE PV TECHNOLOGIES PRIVATE LIMITED",
"WAAREE RENEWABLE TECHNOLOGIES LIMITED",
"WAAREE RENEWABLES PRIVATE LIMITED",
"WAAREE SOLAR ENERGY PRIVATE LIMITED",
"WAAREE TECHNOLOGIES LIMITED",
"WAATAVARAN CLIMATE ENVIRONMENT AND SUSTAINABILITY FOUNDATION",
"WAB INDIA PRIVATE LIMITED",
"WABAN SOFTWARE PRIVATE LIMITED",
"WABISABI LIVING PRIVATE LIMITED",
"WABTEC INDIA INDUSTRIAL PRIVATE LIMITED",
"WABTEC LOCOMOTIVE PRIVATE LIMITED",
"WABTEC TEXMACO RAIL PRIVATE LIMITED",
"WACHSTUM INDUSTRIES PRIVATE LIMITED",
"WACHSTUM LASERS AND FAB PRIVATE LIMITED",
"WACHTER ORIENTAL EMERGING MARKETS MANAGEMENT SUPPORT PRIVATE LIMITED",
"WACKER CHEMIE INDIA PRIVATE LIMITED",
"WACKER METROARK CHEMICALS PRIVATE LIMITED",
"WACKER NEUSON EQUIPMENT PRIVATE LIMITED",
"WACKYTOON STUDIO PRIVATE LIMITED",
"WACOAL INDIA PRIVATE LIMITED",
"WACOM INDIA PRIVATE LIMITED",
"WACORP HYUNDAI INDIA LIMITED",
"WACOT RETAIL PRIVATE LIMITED",
"WADA INGOTS PRIVATE LIMITED",
"WADA STEEL MOULD INDIA PRIVATE. LIMITED.",
"WADCORPP INDIA PRIVATE LIMITED",
"WADEGATI LABEQUIP PRIVATE LIMITED",
"WADEHRA AND COMPANY PRIVATE LIMITED",
"WADEKAR FRUITS PROCESSING PRIVATE LIMITED",
"WADEKARS",
"WADHAWAN TECHSPACES PRIVATE LIMITED",
"WADHWA CONSTRUCTION AND INFRASTRUCTURE PRIVATE LIMITED",
"WADHWA DESIGNS AND EXHIBIT'S PRIVATE LIMITED",
"WADHWA ESTATES AND DEVELOPERS INDIA PRIVATE LIMITED",
"WADHWA GLASS WORKS PRIVATE LIMITED",
"WADHWA GROUP HOLDING PRIVATE LIMITED",
"WADHWA POLYFILMS PRIVATE LIMITED",
"WADHWA REALTY PRIVATE LIMITED WRPL",
"WADHWA RESIDENCY PRIVATE LIMITED",
"WADHWA SAREES PRIVATE LIMITED",
"WADHWAGROUP HOLDINGS PRIVATE LIMITED",
"WADHWANIA SPORTS & FASHIONS PRIVATE LIMITED",
"WADIA COLLEGE OF COMMERCE",
"WADIA HOSPITAL CHILDREN",
"WADIA HOTELS PRIVATE LIMITED",
"WADIA INSTITUTE OF HIMALYAN GEOLOGY",
"WADIA REALITY PRIVATE LIMITED",
"WADIA TECHNO ENGINEERING SERVICES LIMITED",
"WADIKAR INDUSTRIES PRIVATE LIMITED",
"WADPACK PRIVATE LIMITED",
"WADSON METALS PRIVATE LIMITED",
"WADSONS INDIA PRIVATE LIMITED",
"WAE LIMITED",
"WAFE AUXILIARY CHEMICALS PRIVATE LIMITED",
"WAFER SPACE SEMICONDUCTOR TECHNOLOGIES PRIVATE LIMITED",
"WAFFDEL F&B PRIVATE LIMITED",
"WAFTURE HEALTHCARE PRIVATE LIMITED",
"WAGAD INFRAPROJECTS PRIVATE LIMITED",
"WAGEPOINT INDIA PRIVATE LIMITED",
"WAGESHAWARY PLASTIC MANUFACTURING PRIVATE LIMITED",
"WAGH AND SONS SUPERMARKET PRIVATE LIMITED",
"WAGHESHWAR VIDYALAYA",
"WAGHESHWARI IMPEX PRIVATE LIMITED",
"WAGHESHWARI MILK AND AGRO PRODUCT PRIVATE LIMITED",
"WAGHMARE FOOD PRODUCTS PRIVATE LIMITED",
"WAGMAN DIGITAL TECHNOLOGIES PRIVATE LIMITED",
"WAGNERHUBER PHARMACEUTICALS PRIVATE LIMITED",
"WAGO PRIVATE LIMITED",
"WAGON RENT A CAB (INDIA) PRIVATE LIMITED",
"WAGON WHEELZ",
"WAGONS LEARNING PRIVATE LIMITED",
"WAGTAIL TECHNOLOGIES INDIA PRIVATE LIMITED",
"WAH KONG CONSTRUCTION INDIA PRIVATE LIMITED",
"WAH RESTAURANTS PRIVATE LIMITED",
"WAHAL PROCESS TECHNOLOGIES PRIVATE LIMITED",
"WAHE GURU ENGINEERING PRIVATE LIMITED",
"WAHED TECHNOLOGIES PRIVATE LIMITED",
"WAHEGURU ENTERPRISES PRIVATE LIMITED",
"WAHEGURU FOODS PRIVATE LIMITED",
"WAHEGURU MOTORS (INDIA) PRIVATE LIMITED",
"WAHEGURU RUBBER MANUFACTURING COMPANY PVT LTD",
"WAHI AKITA FINE BLANKING PRIVATE LIMITED",
"WAHI ENTERPRISES PRIVATE LIMITED",
"WAHI SONS AUTOMOTIVE PRIVATE LIMITED",
"WAHI SONS PRIVATE LIMITED",
"WAHINNOVATIONS TECHNOLOGIES PRIVATE LIMITED",
"WAHL INDIA GROOMING PRODUCTS PRIVATE LIMITED",
"WAHLEN TECH PRIVATE LIMITED",
"WAI DISHA ACADEMY PRIVATE LIMITED",
"WAI INSURANCE BROKING SERVICES PRIVATE LIMITED",
"WAI TECHNOLOGIES PRIVATE LIMITED",
"WAIDHAN ENGINEERING & INDUSTRIES PVT LTD",
"WAIDHAN TYRES PRIVATE LIMITED",
"WAIG SOLAR PRIVATE LIMITED",
"WAII INFRA PRIVATE LIMITED",
"WAINGANGA COLLEGE OF ENGINEERING & MANAGEMENT",
"WAINGANGA EXPRESSWAY PRIVATE LIMITED",
"WAINGANGA SPUN PIPE INDUSTRIES PRIVATE LIMITED",
"WAISL LIMITED",
"WAKADE CLASSES PRIVATE LIMITED",
"WAKE CUP INDIA FOODS PRIVATE LIMITED",
"WAKEFIT INNOVATIONS PRIVATE LIMITED",
"WAKENCODE TECHNOLOGIES PRIVATE LIMITED",
"WAKESHWAR PRODUCER COMPANY LIMITED",
"WAKHRA SWAAD FOOD AND BEVERAGES PRIVATE LIMITED",
"WAKSMED LIFESCIENCE PRIVATE LIMITED",
"WAL MART INDIA PRIVATE LIMITED",
"WALA OVERSEAS PRIVATE LIMITED",
"WALAMTARI I & CAD DEPTT GOVT OF TELANGANA",
"WALAYAR RESORTS PRIVATE LIMITED",
"WALAYAR STEELS PRIVATE LIMITED",
"WALAYAR VADAKKENCHERRY EXPRESSWAYS PRIVATE LIMITED",
"WALCHAND AND COMPANY PRIVATE LIMITED",
"WALCHAND COLLEGE OF ENGINEERING SANGLI",
"WALCHAND INSTITUTE OF TECHNOLOGY",
"WALCHAND PEOPLEFIRST LIMITED",
"WALCHANDNAGAR INDUSTRIES LIMITED",
"WALDAT PRIVATE LIMITED",
"WALDEMAR LINK INDIA PRIVATE LIMITED",
"WALDEN PROPERTIES PRIVATE LIMITED",
"WALDENT INNOVATIONS PRIVATE LIMITED",
"WALDIES COMPOUND LIMITED",
"WALDNER INDIA PRIVATE LIMITED",
"WALE INVESTMENT PRIVATE LIMITED",
"WALFS INFRA INDIA PRIVATE LIMITED",
"WALFS INFRA PRIVATE LIMITED",
"WALGREEN CO.",
"WALGREENS SPORTS ACADEMY",
"WALHEKAR HOSPITALITY PRIVATE LIMITED",
"WALIA AGNI INDUSTRIES PRIVATE LIMITED",
"WALIA AUTO ANCILLARIES PRIVATE LIMITED",
"WALIAS F & B PRIVATE LIMITED",
"WALIATECH PRIVATE LIMITED",
"WALIMAKERS CONSTRUCTIONS INDIA LIMITED",
"WALIRAM TANEJA MINES PRIVATE LIMITED",
"WALJIS TRAVELS INDIA PRIVATE LIMITED",
"WALK EXPERIENTIAL MARKETING AND MANAGEMENT PRIVATE LIMITED",
"WALK IN THE WOODS PRIVATE LIMITED",
"WALKAROO INTERNATIONAL PRIVATE LIMITED",
"WALKER CHANDIOK & CO LLP",
"WALKE'S REFRIGERATION INDUSTRIES PRIVATE LIMITED",
"WALKI LAMINATES INDIA PRIVATE LIMITED",
"WALKING TREE BRANDS PRIVATE LIMITED",
"WALKING TREE INDIA PRIVATE LIMITED",
"WALKING TREE RESOURCES PRIVATE LIMITED",
"WALKING TREE TECHNOLOGIES PRIVATE LIMITED",
"WALKING TREE VENTURES PRIVATE LIMITED",
"WALKO FOOD COMPANY PRIVATE LIMITED",
"WALKO QSR COMPANY PRIVATE LIMITED",
"WALKOVER WEB SOLUTIONS PRIVATE LIMITED",
"WALKSTREET CONSULTANCY PRIVATE LIMITED",
"WALKWATER MEDIA LIMITED",
"WALKWATER PROPERTIES PRIVATE LIMITED",
"WALKWATER TALENT ADVISORS PRIVATE LIMITED",
"WALKWAY RETAIL PROPERTIES PRIVATE LIMITED",
"WALL JAZZ EXCELENCIA PRIVATE LIMITED",
"WALL QUEEN INTERIORS PRIVATE LIMITED",
"WALL ROCK INFRATECH PRIVATE LIMITED",
"WALL STREET ENGLISH INDIA PRIVATE LIMITED",
"WALL STREET FINCAP SERVICES PRIVATE LIMITED",
"WALLA WALLA LOGISTICS PRIVATE LIMITED",
"WALLACE FLOUR MILLS COMPANY PRIVATE LIMITED",
"WALLACE PHARMACEUTICALS PRIVATE LIMITED",
"WALLART TECHNOLOGIES PRIVATE LIMITED",
"WALLART WALLPAPER PRIVATE LIMITED",
"WALLBERT TRADING AND CONSULTANTS PRIVATE LIMITED",
"WALLCERA TILES PRIVATE LIMITED",
"WALLED CITY HOTELS PRIVATE LIMITED",
"WALLEM MARITIME TRAINING (INDIA) PRIVATE LIMITED",
"WALLEM SHIPMANAGEMENT INDIA PRIVATE LIMITED",
"WALLENIUS WILHELMSEN LOGISTICS INDIA PRIVATE LIMITED",
"WALLERO TECHNOLOGIES PRIVATE LIMITED",
"WALLET CIRCLE TECHNOLOGIES LIMITED",
"WALLET FINSERVE PRIVATE LIMITED",
"WALLET UNCLE SERVICES PRIVATE LIMITED",
"WALLETHUB PRIVATE LIMITED",
"WALLFORT FINANCIAL SERVICES LIMITED",
"WALLFORT PROPERTIES PRIVATE LIMITED",
"WALLFORT SHARE AND STOCK BROKERS PRIVATE LIMITED.",
"WALLICK GLOBAL CONSULTING PRIVATE LIMITED",
"WALLIS TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"WALLMAAX PAINTS PRIVATE LIMITED",
"WALLMARK CERAMIC INDUSTRY",
"WALLMAX INDIA ENTERPRISES PRIVATE LIMITED",
"WALLNUT BUILDING SOLUTIONS INDIA PRIVATE LIMITED",
"WALLOP ADVERTISING PRIVATE LIMITED",
"WALLOYS FASTENERS INDIA PRIVATE LIMITED",
"WALLSET SECURITY AND ALLIED SERVICES PRIVATE LIMITED",
"WALLSTREET CAPITAL MARKETS PVT LTD",
"WALLTRACTS INDIA PRIVATE LIMITED",
"WALMAN INFRA & ENERGY PRIVATE LIMITED",
"WALMARK MEDITECH PRIVATE LIMITED",
"WALMART INDIA TECHNICAL & CONSULTING SERVICES PRIVATE LIMITED",
"WALMIK AGROTECH PRIVATE LIMITED",
"WALMIKI BALAK PRIMARY ASHRAM SCHOOL HANJAGI",
"WALNUT ADVERTISING INDIA PRIVATE.LIMITED",
"WALNUT FOLKS PRIVATE LIMITED",
"WALNUT KNOWLEDGE SOLUTIONS PRIVATE LIMITED",
"WALNUT LIFE SCIENCES PRIVATE LIMITED",
"WALNUT PHARMA PRIVATE LIMITED",
"WALNUT SCHOOL",
"WALNUT SOFTECH PRIVATE LIMITED",
"WALNUT TRADING & SERVICES PRIVATE LIMITED",
"WALPAR NUTRI SCIENCE PRIVATE LIMITED",
"WALPAR NUTRITIONS LIMITED",
"WALPAR WELLNESS PRIVATE LIMITED",
"WALPLAST PRODUCTS PRIVATE LIMITED",
"WALRON HEALTHCARE PRIVATE LIMITED",
"WALRUS LABS PRIVATE LIMITED",
"WALRUS POOLS AND FITNESS PRIVATE LIMITED",
"WALSH PATEL GROUP WPG TECHNOLOGIES PRIVATE LIMITED",
"WALSON RETAILS PRIVATE LIMITED",
"WALSON WOODBURN WIRE DIE PRIVATE LIMITED",
"WALSONS FACILITY SOLUTIONS PRIVATE LIMITED",
"WALSONS SERVICES PRIVATE LIMITED",
"WALTAIR COAL PRIVATE LIMITED",
"WALTAZ COMMOSALE PRIVATE LIMITED",
"WALTER ADVISORS PRIVATE LIMITED",
"WALTER BUSHNELL BIOSCIENCES PRIVATE LIMITED",
"WALTER BUSHNELL DRUGS PRIVATE LIMITED",
"WALTER BUSHNELL ENTERPRISES PRIVATE LIMITED",
"WALTER BUSHNELL HEALTHSCIENCES PRIVATE LIMITED",
"WALTER BUSHNELL LABORATORIES PRIVATE LIMITED",
"WALTER BUSHNELL MEDICAID PRIVATE LIMITED",
"WALTER BUSHNELL MEDICINES PRIVATE LIMITED",
"WALTER BUSHNELL MEDINOVA PRIVATE LIMITED",
"WALTER BUSHNELL MEDISAFE PRIVATE LIMITED",
"WALTER BUSHNELL MEDIVIN PRIVATE LIMITED",
"WALTER MAX CHEMICALS PRIVATE LIMITED",
"WALTER P MOORE ENGINEERING INDIA PRIVATE LIMITED",
"WALTER PACK AUTOMOTIVE PRODUCTS INDIA PRIVATE LIMITED",
"WALTER SECURITY SERVICES PRIVATE LIMITED",
"WALTER TOOLS INDIA PRIVATE LIMITED",
"WALTON HEALTH CARE PRIVATE LIMITED",
"WALTON LIFESCIENCES PRIVATE LIMITED",
"WALTON STREET INDIA FINANCE PRIVATE LIMITED",
"WALTON STREET INDIA INVESTMENT ADVISORS PRIVATE LIMITED",
"WALTZ PHARMACEUTICALS PRIVATE LIMITED",
"WALVEKAR BROTHERS AND COMPANY",
"WALVEKAR SONS",
"WALVOIL FLUID POWER (INDIA) PRIVATE LIMITED",
"WALWHAN ENERGY RJ LIMITED",
"WALWHAN RENEWABLE ENERGY LIMITED",
"WALWHAN SOLAR AP LIMITED",
"WALWHAN SOLAR BH LIMITED",
"WALWHAN SOLAR ENERGY GJ LIMITED",
"WALWHAN SOLAR KA LIMITED",
"WALWHAN SOLAR MH LIMITED",
"WALWHAN SOLAR MP LIMITED",
"WALWHAN SOLAR PB LIMITED",
"WALWHAN SOLAR RAJ LIMITED",
"WALWHAN SOLAR RJ LIMITED",
"WALWHAN SOLAR TN LIMITED",
"WALWHAN WIND RJ LIMITED",
"WALZEN STRIPS PRIVATE LIMITED",
"WAM INDIA PRIVATE LIMITED",
"WAMA TECHNOLOGY PRIVATE LIMITED",
"WAMAN HARI PETHE JEWELLERS",
"WAMAN HARI PETHE JEWELLERS INDIA PRIVATE LIMITED",
"WAMAN HARI PETHE SONS PRIVATE. LIMITED. WHPS",
"WAMAN MOTORS PRIVATE LIMITED",
"WAMANBHAU MADHYAMIK VIDYALAYA SHIRUR KASAR DIST.BEED",
"WAMPUM SYNTEX PRIVATE LIMITED",
"WAN AND LAN INTERNET PRIVATE LIMITED",
"WAN HAI LINES INDIA PRIVATE LIMITED",
"WANBURY LIMITED",
"WANDERERS ADVENTURE SPORTS PRIVATE LIMITED",
"WANDERERS BREWING PRIVATE LIMITED",
"WANDERERS LEISURE TRAVELS PRIVATE LIMITED",
"WANDERLAND REAL ESTATES PRIVATE LIMITED",
"WANDERON EXPERIENCES PRIVATE LIMITED",
"WANDX SOLUTIONS PRIVATE LIMITED",
"WANFENG ALUMINUM WHEEL INDIA PRIVATE LIMITED",
"WANFUDA INSTRUMENTS INDIA PRIVATE LIMITED",
"WANG HOSPITALITY EQUIPMENT PRIVATE LIMITED",
"WANG INVESTMENT & FINANCE PRIVATE LIMITED",
"WANG PROFESSIONALS PRIVATE LIMITED",
"WANHUA INTERNATIONAL (INDIA) PRIVATE LIMITED",
"WANI INFRATECH PRIVATE LIMITED",
"WANI MULTI VENTURES PRIVATE LIMITED",
"WANI PROJECTS AND INFRA PRIVATE LIMITED",
"WANI TECHNOLOGIES PRIVATE LIMITED",
"WANKSONS CHEMICALS INDUSTRIES PRIVATE LIMITED",
"WANKYS SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"WANLESS HOSPITAL MIRAJ",
"WANNAMO MARKETING PRIVATE LIMITED",
"WANSHAN MOBILES PRIVATE LIMITED",
"WANTI ASSOCIATES PRIVATE LIMITED",
"WANTI OVERSEAS PRIVATE LIMITED",
"WANTSTATS RESEARCH AND MEDIA PRIVATE LIMITED",
"WANZL INDIA PRIVATE LIMITED",
"WAP SOLUTIONS",
"WAPCOS LIMITED",
"WAPRAA BIO-ORGANIC INDUSTRIES PRIVATE LIMITED",
"WAQA LOGI SOLUTIONS PRIVATE LIMITED",
"WARANA DAIRY AND AGRO INDUSTRIES LIMITED",
"WARANA PATBHANDARE UPVIBHAG KODOLI",
"WARANGAL AGROS PRIVATE LIMITED",
"WARANGAL INSTITUTE TECHNOLOGY AND SCIENCES",
"WARANGAL URBAN CO-OPERATIVE BANK LIMITED",
"WARBURG PINCUS INDIA PRIVATE LIMITED",
"WARD AGRICULTURAL MACHINERY INDIA PRIVATE LIMITED",
"WARD FOUR CONSULTING PRIVATE LIMITED",
"WARDEN CONSTRUCTION AND FINANCE LIMITED",
"WARDEN GOVERNMENT TRIBAL GIRLS HOSTEL ULHASNAGAR",
"WARDEN GOVT E.B.C BOYS HOSTEL BEED",
"WARDEN GOVT GIRLS HOSTEL B C AND EBC CHAKUR",
"WARDEN GOVT ST¬† BOYS HOSTEL NIZAMPUR",
"WARDEN INTERNATIONAL PRIVATE LIMITED",
"WARDEN SECURITY SYSTEMS PRIVATE LIMITED",
"WARDEN SURGICAL COMPANY PRIVATE LIMITED",
"WARDEN WINE AND LIQUOR MART PVT LTD",
"WARDEX PHARMACEUTICALS PRIVATE LIMITED",
"WARDHA JILHA DEKHREKH SAHKARI SANSTHA MARYADIT WARDHA",
"WARDHA POWER COMPANY LIMITED",
"WARDHA SOLAR (MAHARASHTRA) PRIVATE LIMITED",
"WARDWIZARD INNOVATIONS & MOBILITY LIMITED",
"WARDWIZARD SOLUTIONS INDIA PRIVATE LIMITED",
"WAREHOUSE INTERNATIONAL PRIVATE LIMITED",
"WAREHOUSE PRODUCTS PRIVATE LIMITED",
"WAREHOUSING EXPRESS LOGISTICS PRIVATE LIMITED",
"WAREHOUSING SS SERVICES PRIVATE LIMITED",
"WAREX TECHNOLOGIES PRIVATE LIMITED",
"WARIS BUILDCON INDIA PRIVATE LIMITED",
"WARIS INFRACON PRIVATE LIMITED",
"WARIVO MOTOR INDIA PRIVATE LIMITED",
"WARIVO PHARMA PRIVATE LIMITED",
"WARKEM BIOTECH PRIVATE LIMITED",
"WARM CONNECT SOLUTIONS PRIVATE LIMITED",
"WARMCONNECT INTERNET SERVICES PRIVATE LIMITED",
"WARMEX HOME APPLIANCES PRIVATE LIMITED",
"WARNER (INDIA) PHARMA PRIVATE LIMITED",
"WARNER BROS PICTURES INDIA PRIVATE LIMITED",
"WARNER ELECTRONICS INDIA PRIVATE LIMITED",
"WARNER EXPORTS PRIVATE LIMITED",
"WARNER HINDUSTHAN PRIVATE LIMITED",
"WARNER MUSIC INDIA PRIVATE LIMITED",
"WARNERMEDIA INDIA PRIVATE LIMITED",
"WARORA CHANDRAPUR BALLARPUR TOLL ROAD LIMITED",
"WARORA-KURNOOL TRANSMISSION LIMITED",
"WARP N WEFT DESIGNS PRIVATE LIMITED",
"WARP WEBSTERS PRIVATE LIMITED",
"WARPP ENGINEERS PRIVATE LIMITED",
"WARRANTO SERVICES PRIVATE LIMITED",
"WARREN ACADEMY SCHOOL",
"WARREN TEA LIMITED",
"WARRIOR FMS INDIA PRIVATE LIMITED",
"WARROUS PRIVATE LIMITED",
"WARSCHNE DESIGNS PRIVATE LIMITED",
"WARTEX SYSTEM PRIVATE LIMITED",
"WARTSILA CHINA LIMITED",
"WARTSILA INDIA PRIVATE LIMITED",
"WARTSILA VOYAGE LIMITED",
"WARUKSHA LABORATORIES PRIVATE LIMITED",
"WARWICK FABRICS INDIA PRIVATE LIMITED",
"WARYAM STEEL CASTINGS PRIVATE LIMITED",
"WASAN BROTHERS PRIVATE LIMITED",
"WASAN BUSINESS INNOVATIONS PRIVATE LIMITED",
"WASAN FINISHING SCHOOL PRIVATE LIMITED",
"WASAN HOSPITALITY PRIVATE LIMITED",
"WASAN MOTORS PRIVATE LIMITED",
"WASAN OVERSEAS PRIVATE LIMITED",
"WASAN TRUCKING PRIVATE LIMITED",
"WASCON CONSTRUCTION PRIVATE LIMITED",
"WASDOM PHARMCHEM PRIVATE LIMITED",
"WASERS INFOTECH PRIVATE LIMITED",
"WASH INSTITUTE",
"WASHABARIE TEA CO PVT LTD",
"WASHMATIC INDIA PRIVATE LIMITED",
"WASHROOM HYGIENE CONCEPTS PRIVATE LIMITED",
"WASIKA OFFICE LUCKNOW",
"WASP PUMPS PRIVATE LIMITED",
"WASSER CHEMICAL AND & SYSTEMS PRIVATE LIMITED",
"WASSER KRAFT TECH",
"WASSER TECHNOCHEM (INDIA) LIMITED",
"WASSERFLUSS INDIA PRIVATE LIMITED",
"WASSUP MEDIA PRIVATE LIMITED",
"WASSYA INTERTRADE PRIVATE LIMITED",
"WASTE MANAGEMENT INC.",
"WASTE VENTURES INDIA PRIVATE LIMITED",
"WASTE WARRIORS SOCIETY",
"WASTE WISE MANAGEMENT AND CONSULTANCY SERVICES PRIVATE LIMITED",
"WATAI ELECTRONICS PRIVATE LIMITED",
"WATAIR TECHNOLOGIES PRIVATE LIMITED",
"WATANMAL INDIA PRIVATE LIMITED",
"WATCH YOUR HEALTH.COM INDIA PRIVATE LIMITED",
"WATCHDATA TECHNOLOGIES INDIA PRIVATE LIMITED",
"WATCHES OF SWITZERLAND",
"WATCHGUARD TECHNOLOGIES INDIA PRIVATE LIMITED",
"WATCHMASTERS PRIVATE LIMITED",
"WATCHOID SECURITY & FACILITY SERVICES PRIVATE LIMITED",
"WATCO",
"WATCO INDIA PRIVATE LIMITED",
"WATCON WATER SPECIALISTS PVT LTD",
"WATECH GREEPO SYSTEMS PRIVATE LIMITED",
"WATENVA SOLUTION PRIVATE LIMITED",
"WATER AND LAND MANAGEMENT INSTITUTE CUTT",
"WATER AND LAND MANAGEMENT INSTITUTE WALMI",
"WATER AND SANITATION MANAGEMENT ORGANISATION",
"WATER ANGEL PRIVATE LIMITED",
"WATER DNA PRIVATE LIMITED",
"WATER FIELD TECHNOLOGIES PRIVATE LIMITED",
"WATER FLOW (INDIA) PRIVATE LIMITED",
"WATER FOR PEOPLE",
"WATER HEALTH INDIA PRIVATE LIMITED",
"WATER MANAGEMENT AND PLUMBING SKILL COUNCIL",
"WATER MARK MARKETING PRIVATE LIMITED",
"WATER MASS SYSTEMS PRIVATE LIMITED",
"WATER NEXT SOLUTIONS LLP",
"WATER PROOF CORPORATION PRIVATE LIMITED",
"WATER RESOURCE DEPARTMENT",
"WATER RESOURCES DEDPARTMENT GOVT OF BIHAR",
"WATER RESOURSE DEPARTMENT OF MADHYA PRADESH",
"WATER SANITATION AND HYGIENE INSTITUTE",
"WATER SERVICES INFRASTRUCTURE (INDIA) PRIVATE LIMITED",
"WATER SUPPLY AND SANITATION DEPARTMENT",
"WATER SYSTEMS INDIA PRIVATE LIMITED",
"WATER SYSTEMS SPECIALITY CHEMICALS PRIVATE LIMITED",
"WATER TECHNOCRATS PRIVATE LIMITED",
"WATER TODAY PRIVATE LIMITED",
"WATER WEALTH INFRA-TECH (INDIA) PRIVATE LIMITED",
"WATERCAD ENGINEERING SERVICES PRIVATE LIMITED",
"WATERFAB CREATION PRIVATE LIMITED",
"WATERFALL ESTATE PRIVATE LIMITED",
"WATERFIELD ADVISORS PRIVATE LIMITED",
"WATERFIELD FINANCIAL AND INVESTMENT ADVISORS PRIVATE LIMITED",
"WATERFIELD FISHING INDUSTRIES PRIVATE LIMITED",
"WATERFIELD FUND MANAGERS PRIVATE LIMITED",
"WATERFIELD RETAIL PRIVATE LIMITED",
"WATERFLO PIPING SYSTEM",
"WATERFRONT AU-119 ROAD PRIVATE LIMITED",
"WATERFRONT FERTILIZER & CHEMICALS PRIVATE LIMITED",
"WATERHEALTH INDIA PRIVATE LIMITED",
"WATERJET POLYMER PRIVATE LIMITED",
"WATERJET SYSTEMS INTERNATIONAL PRIVATE LIMITED",
"WATERLEAF CONSULTANTS PRIVATE LIMITED",
"WATERLEY PHARMA CEUTICALS PRIVATE LIMITED",
"WATERLIFE INDIA PRIVATE LIMITED",
"WATERLINE HOTELS PRIVATE LIMITED",
"WATERLOO MOTORS PRIVATE LIMITED",
"WATERMAN AQUATIC SYSTEMS PRIVATE LIMITED",
"WATERMAN CONSULTING ENGINEERS INDIA PRIVATE LIMITED",
"WATERMAN FREIGHT (INDIA) PRIVATE LIMITED",
"WATERMAN GRANITO INDIA PRIVATE LIMITED",
"WATERMAN INDUSTRIES PRIVATE LIMITED",
"WATERMAN INTERNATIONAL TECHNOLOGIES PRIVATE LIMITED",
"WATERMARK CAPITAL LIMITED",
"WATERMARK CARS PRIVATE LIMITED",
"WATERMARK FOREX PRIVATE LIMITED",
"WATERMARK INSIGHTS INDIA PRIVATE LIMITED",
"WATERMARK SYSTEMS (INDIA) PRIVATE LIMITED",
"WATERMARKE RESIDENCY LIMITED",
"WATERMATE TECHNOLOGIES PRIVATE LIMITED",
"WATERMATICS AGRI TECH PRIVATE LIMITED",
"WATERMELON FOODS AND BEVERAGES PRIVATE LIMITED",
"WATERMELON HR SERVICES PRIVATE LIMITED",
"WATERMELON MANAGEMENT SERVICES PRIVATE LIMITED",
"WATERMEN JINDAL INDIA PRIVATE LIMITED",
"WATERS INDIA PRIVATE LIMITED",
"WATERSHED DEVP SOIL CONSERVATION DEPT",
"WATERSHED ORGANISATION TRUST WOTR",
"WATERSPORTS SIMPLE INDIA PRIVATE LIMITED",
"WATERTEC (INDIA) PRIVATE LIMITED",
"WATERTECH SERVICES PRIVATE LIMITED",
"WATERVISION SYSTEMS PRIVATE LIMITED",
"WATERWAAYS CARGO PRIVATE LIMITED",
"WATERWALA LABS PRIVATE LIMITED",
"WATERWALK AUTOMATION PRIVATE LIMITED",
"WATERWAVE SHIPPING PRIVATE LIMITED",
"WATERWAVES INDUSTRIES PRIVATE LIMITED",
"WATERWAYS CERAMICA PRIVATE LIMITED",
"WATERWAYS SHIPYARD PRIVATE LIMITED",
"WATERWOODS LODGE & RESORTS PRIVATE LIMITED",
"WATERWORLD CERAMICS PRIVATE LIMITED",
"WATIKA NIRMAN PRIVATE LIMITED",
"WATLOW THERMAL SOLUTIONS INDIA PRIVATE LIMITED",
"WATMOV ENGINEERING PRIVATE LIMITED",
"WATRAN PHARMACEUTICALS PRIVATE LIMITED",
"WATRANA RENTALS PRIVATE LIMITED",
"WATRANA TRACTION PRIVATE LIMITED",
"WATSAN ENVIROTECH PRIVATE LIMITED",
"WATSON & CHALIN INDIA PRIVATE LIMITED",
"WATSON GLOBAL CARGO PRIVATE LIMITED",
"WATSON GLOBAL LOGISTICS PRIVATE LIMITED",
"WATSON LOGISTICS PRIVATE LIMITED",
"WATSON PHARMA PRIVATE LIMITED",
"WATSONITE SYSTEMS PRIVATE LIMITED",
"WATSON-MARLOW INDIA PRIVATE LIMITED",
"WATSOO EXPRESS PRIVATE LIMITED",
"WATSUN INFRABUILD PRIVATE LIMITED",
"WATTERA INDUSTRIES PRIVATE LIMITED",
"WATTFIN VENTURES PRIVATE LIMITED",
"WATTKRAFT INDUSTRIES PRIVATE LIMITED",
"WATTMART ENERGY STORES PRIVATE LIMITED",
"WATTMONK TECHNOLOGIES PRIVATE LIMITED",
"WATTPLUS ENERGY PRIVATE LIMITED",
"WATTS ELECTRONICS PVT LTD",
"WATTS HEATING EQUIPMENTS (INDIA) PRIVATE LIMITED",
"WATTSUN ENERGY INDIA PRIVATE LIMITED",
"WATTVOLT ENERGY PRIVATE LIMITED",
"WATWA ENGINEERS PRIVATE LIMITED",
"WAULITE TECHNOLOGIES PRIVATE LIMITED",
"WAVE 9 IT SOLUTIONS PRIVATE LIMITED",
"WAVE AGRO PRIVATE LIMITED",
"WAVE BEVERAGES PRIVATE LIMITED",
"WAVE BUILDWELL PRIVATE LIMITED",
"WAVE CODE LOGIX PRIVATE LIMITED",
"WAVE CREST PAYMENT TECHNOLOGY PRIVATE LIMITED",
"WAVE DISTILLERIES AND BREWERIES LIMITED",
"WAVE ENERGY AND INFRASTRUCTURES INDIA PRIVATE LIMITED",
"WAVE EXPONENTIAL PRIVATE LIMITED",
"WAVE FIBER PRIVATE LIMITED",
"WAVE GEO-SERVICES PRIVATE LIMITED",
"WAVE HOSPITALITY PRIVATE LIMITED",
"WAVE INDUSTRIES PRIVATE LIMITED",
"WAVE INFOTECH SOLUTIONS INDIA PRIVATE LIMITED",
"WAVE INFRATECH PRIVATE LIMITED",
"WAVE LAKEWOODS PRIVATE LIMITED",
"WAVE MECHANICS PRIVATE. LIMITED.",
"WAVE MEDIA",
"WAVE ONE PRIVATE LIMITED",
"WAVE ONLINE INFOWAY PRIVATE LIMITED",
"WAVE PHARMACEUTICALS LIMITED",
"WAVE POLYMER TECHNOLOGY PRIVATE LIMITED",
"WAVE SALES PRIVATE LIMITED",
"WAVE SILVER TOWER PRIVATE LIMITED",
"WAVE TRAVELS (INDIA) PRIVATE LIMITED",
"WAVEAXIS TECHNOLOGIES PRIVATE LIMITED",
"WAVEBIT INFRATECH PRIVATE LIMITED",
"WAVECORRUGATORS PRIVATE LIMITED",
"WAVECURRENT PRECISION PARTS PRIVATE LIMITED",
"WAVEFORM CONTROLS PVT. LTD.",
"WAVELABS TECHNOLOGIES INDIA PRIVATE LIMITED",
"WAVELABS TECHNOLOGIES PRIVATE LIMITED",
"WAVELENGTH NETWORK AND MANAGEMENT PRIVATE LIMITED",
"WAVELET COMMUNICATIONS PRIVATE LIMITED",
"WAVELET TECHNOLOGIES PRIVATE LIMITED",
"WAVELL INVESTMENTS PRIVATE LIMITED",
"WAVEMV SOLUTIONS PRIVATE LIMITED",
"WAVENET SOLUTIONS PRIVATE LIMITED",
"WAVENET TECHNOLOGIES PRIVATE LIMITED",
"WAVERLEY PAINTS PRIVATE LIMITED",
"WAVERS INDIA TAPS MOUNTING PRIVATE LIMITED",
"WAVES AIRCON PRIVATE LIMITED",
"WAVES BIO-TECH PRIVATE LIMITED",
"WAVES CLOTHING PRIVATE LIMITED",
"WAVES ELECTRONICS PVT LTD",
"WAVES EMPOWERMENT FOUNDATION",
"WAVES FINANCIAL SOLUTION",
"WAVES HOTELS AND ESTATES PRIVATE LIMITED",
"WAVESIGHT WIRELESS SOLUTIONS PRIVATE LIMITED",
"WAVETECH INFOCOM PRIVATE LIMITED",
"WAVEULTRA ENGINEERS AUTOMATION PRIVATE LIMITED",
"WAVIN INDIA HOLDINGS PRIVATE LIMITED",
"WAVIN INDIA LIMITED",
"WAVIN INDIA PIPES AND FITTINGS MANUFACTURING PRIVATE LIMITED",
"WAVIN INDUSTRIES LIMITED",
"WAVITY PRIVATE LIMITED",
"WAXOILS PRIVATE LIMITED",
"WAY 2 CARE PHARMA OPC PRIVATE LIMITED",
"WAY 2 CAREER CONSULTING SERVICES PRIVATE LIMITED",
"WAY DOT COM INDIA PRIVATE LIMITED",
"WAY2 DIGITAL PRIVATE LIMITED",
"WAY2INNOVATIONS HEALTHCARE PRIVATE LIMITED",
"WAY2NEWS PRIVATE LIMITED",
"WAY2ONLINE INTERACTIVE INDIA PRIVATE LIMITED",
"WAY2SMILE SOLUTIONS PRIVATE LIMITED",
"WAY2WEALTH BROKERS PRIVATE LIMITED",
"WAY2WEALTH CAPITAL PRIVATE LIMITED",
"WAY2WEALTH COMMODITIES PRIVATE LIMITED",
"WAY2WEALTH INSURANCE BROKERS PRIVATE LIMITED",
"WAY2WEALTH INSURANCE PRIVATE LIMITED",
"WAY2WEALTH SECURITIES PRIVATE LIMITED",
"WAYANAD CLUB PRIVATE LIMITED",
"WAYANAD INFRASTRUCTURE PRIVATE LIMITED",
"WAYDELTA FINANCIAL SERVICES PRIVATE LIMITED",
"WAYFAR CONSULTING PRIVATE LIMITED",
"WAYFARER E-COMMERCE PRIVATE LIMITED",
"WAYFARER FILMS PRIVATE LIMITED",
"WAYGUARD CONSTRUCTION PRIVATE LIMITED",
"WAYINIA LIFESCIENCES OPC PRIVATE LIMITED",
"WAYLANE LOGISTICS PRIVATE LIMITED",
"WAYLONE HEALTHCARE PRIVATE LIMITED",
"WAYMED LIFECARE PRIVATE LIMITED",
"WAYMOB PRIVATE LIMITED",
"WAYMORE CONSULTANCY PRIVATE LIMITED",
"WAYONEXT PHARMACEUTICALS PRIVATE LIMITED",
"WAYPOINT PORT SERVICES PRIVATE LIMITED",
"WAYS AND MEANS TECHNOLOGY PRIVATE LIMITED",
"WAYSNX TECHNOLOGIES PRIVATE LIMITED",
"WAYSTAR HOSIERY PRIVATE LIMITED",
"WAYU DIGITAL STUDIO PRIVATE LIMITED",
"WAYZON INFOTECH PRIVATE LIMITED",
"WAZIR ADVISORS PRIVATE LIMITED",
"WAZIR CHAND AND COMPANY PRIVATE LIMITED",
"WAZIR SINGH SWARN SINGH CONSIGNMENT STOCKISTS PRIVATE LIMITED",
"WAZIRS CONSULTING PRIVATE LIMITED",
"WB SPANK CREATIONS PRIVATE LIMITED",
"WB TRADE AND SERVICES PRIVATE LIMITED",
"WBC SOFTWARE LAB PRIVATE LIMITED",
"WBCSD INDIA PRIVATE LIMITED",
"WBF STEEL DETAILING & ENGINEERING PRIVATE LIMITED",
"WBT-INDIA PRIVATE LIMITED",
"WBY EVENTS MANAGEMENT & MEDIA PRIVATE LIMITED",
"WC & C ENGINEERING PRIVATE LIMITED",
"WC SECURITIES PRIVATE LIMITED",
"WCC SOLUTIONS PRIVATE LIMITED",
"WCFN SOLUTIONS PRIVATE LIMITED",
"WCI SHIPPING PRIVATE LIMITED",
"WCITIES CONTENT SOLUTIONS INDIA PRIVATE LIMITED",
"WCM IMAGE MNAGEMENT PRIVATE LTT",
"WCO GLOBAL PROJECTS PRIVATE LIMITED",
"WCT OCEAN CONTAINERS PRIVATE LIMITED",
"WCUBE SOLUTIONS PRIVATE LIMITED",
"WCWALLET ADVISORY INSURANCE MARKETING PRIVATE LIMITED",
"WD PARTNERS INDIA PRIVATE LIMITED",
"WDA BUILDERS PRIVATE LIMITED",
"WDB INDIA PRIVATE LIMITED",
"WDS ONLINE PRIVATE LIMITED",
"WDSA SECURE AND ALLIED SERVICES PRIVATE LIMITED",
"WDTS INDIA PRIVATE LIMITED",
"WE ARE ONE ENTERPRISES PRIVATE LIMITED",
"WE BROS MEDIA PRIVATE LIMITED",
"WE CARE CORPORATE FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"WE COMPONENTS INDIA PRIVATE LIMITED",
"WE CREATE INFOTECH PRIVATE LIMITED",
"WE DO IT INDIA PRIVATE LIMITED",
"WE ENGINEERS STRUCTURAL CONSULTANTS PRIVATE LIMITED",
"WE FOUNDER CIRCLE PRIVATE LIMITED",
"WE HEAL PRIVATE LIMITED",
"WE INNOVATE BUSINESS SOLUTIONS PRIVATE LIMITED",
"WE MEDIA INDIA PRIVATE LIMITED",
"WE ONE SEEDS PRIVATE LIMITED",
"WE TAILWIND TECHNOLOGIES PRIVATE LIMITED",
"WE TECHSHIKSHA LABS PRIVATE LIMITED",
"WE WIN LOGISTICS & WAREHOUSES PRIVATE LIMITED",
"WE3 CONSTECH PRIVATE LIMITED",
"WE3 PR & CORPORATE CONSULTANTS PRIVATE LIMITED",
"WE3 SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED",
"WE4U MAINTENANCE PRIVATE LIMITED",
"WEA DESIGNS PRIVATE LIMITED",
"WEAGILE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"WEALDEN HR SOLUTIONS INDIA LLP",
"WEALTH ADVISORS INDIA PRIVATE LIMITED",
"WEALTH AURA TRADE SOLUTIONS PRIVATE LIMITED",
"WEALTH CAFE BUSINESS ADVISORS PRIVATE LIMITED",
"WEALTH CLINIC PRIVATE LIMITED",
"WEALTH CONCEPTS INVESTMENT SERVICES",
"WEALTH DISCOVERY FINANCE PRIVATE LIMITED",
"WEALTH DISCOVERY SECURITIES PRIVATE LIMITED",
"WEALTH FIRST ADVISORS PRIVATE LIMITED",
"WEALTH FIRST PORTFOLIO MANAGERS PRIVATE LIMITED",
"WEALTH INDIA FINANCIAL SERVICES PRIVATE LIMITED",
"WEALTH MANAGERS INDIA PRIVATE LIMITED",
"WEALTH MANAGERS UNITED (INDIA) PRIVATE LIMITED",
"WEALTH MANTRA CONSULTANTS PRIVATE LIMITED",
"WEALTH TECHNOLOGY & SERVICES PRIVATE LIMITED",
"WEALTH TRANSFORMERS INDIA PRIVATE LIMITED",
"WEALTH TREE ADVISORS PRIVATE LIMITED",
"WEALTH WALLET TECHNOLOGIES PRIVATE LIMITED",
"WEALTH WISDOM INDIA PRIVATE LIMITED",
"WEALTH WIZARDS PRIVATE LIMITED",
"WEALTHASSURE CONSULTANTS PRIVATE LIMITED",
"WEALTHBRIDGE CAPITAL ADVISORS PRIVATE LIMITED",
"WEALTHCARE GLOBAL COMMERCE PRIVATE LIMITED",
"WEALTHDIRECT MUTUAL FUND DISTRIBUTOR PRIVATE LIMITED",
"WEALTHENGINE SOFTWARE PRIVATE LIMITED",
"WEALTHIAN PRIVATE LIMITED",
"WEALTHKRAFT INVESTMENT SERVICES PRIVATE LIMITED",
"WEALTHOLOGISTS PRIVATE LIMITED",
"WEALTHSIGNS FINTECH PRIVATE LIMITED",
"WEALTHSTRATZ CAPITAL PRIVATE LIMITED",
"WEALTHSTREET FINANCIAL SERVICES PRIVATE LIMITED",
"WEALTHTECH ROBO ADVISORY PRIVATE LIMITED",
"WEALTHY MILLENNIUM INVESTMENT AND TRADING PRIVATE LIMITED",
"WEALTHYIN CUSTOMER SERVICES PRIVATE LIMITED",
"WEAR ON ENSEMBLES PRIVATE LIMITED",
"WEAR STEELS PRIVATE LIMITED",
"WEAR THREE FASHIONS PRIVATE LIMITED",
"WEAR WELL APPARELS PRIVATE LIMITED",
"WEAR WELL INDIA PRIVATE LIMITED",
"WEARCHECK LABORATORIES INDIA PRIVATE LIMITED",
"WEARHOUSE PRODUCTS PRIVATE LIMITED",
"WEARRESIST TECHNOLOGIES PRIVATE LIMITED",
"WEARTECH ALLOYS PRIVATE LIMITED",
"WEARTECH ENGINEERS PRIVATE LIMITED",
"WEARTECH FUSION PRIVATE LIMITED",
"WEATHER COMFORT ENGINEERS PRIVATE LIMITED",
"WEATHER CONTROLLING SOLUTIONS INDIA PRIVATE LIMITED",
"WEATHER COOL SALES PRIVATE LIMITED",
"WEATHER FIGHTER PRIVATE LIMITED",
"WEATHER RISK MANAGEMENT SERVICES PRIVATE LIMITED",
"WEATHERFORD DRILLING AND PRODUCTION SERVICES INDIA",
"WEATHERFORD OIL TOOLS MIDDLE EAST LIMITED",
"WEATHERS MAKERS PVT LTD",
"WEATHERSPELL AIRCON ENGINEERS PRIVATE LIMITED",
"WEATHERSTONE BUILDING BLOCKS PRIVATE LIMITED",
"WEATHERTECH AUTOMOTIVES PRIVATE LIMITED",
"WEAVE COMMUNICATIONS INDIA PRIVATE LIMITED",
"WEAVER BIRD CONSULTANTS PRIVATE LIMITED",
"WEAVERBIRD ENGINEERING & TECHNOLOGY PRIVATE LIMITED",
"WEAVERS SIZING MILLS (INDIA) PRIVATE LIMITED",
"WEAVERS WEB SOLUTIONS PRIVATE LIMITED",
"WEAVESTAR TEXTILES PRIVATE LIMITED",
"WEAVETECH ENGINEERS LIMITED",
"WEAVETECH INDUSTRIES PRIVATE LIMITED",
"WEAVE-TEX ENGINEERS PRIVATE LIMITED",
"WEAVETEX TECHNOLOGY AND SERVICES PRIVATE LIMITED",
"WEAVETTE TEXSTYLES LIMITED",
"WEAVEWELL EXPORTS PRIVATE LIMITED",
"WEAVINGS MANPOWER SOLUTIONS PRIVATE LIMITED",
"WEB ACCESS INDIA PRIVATE LIMITED",
"WEB AFFINITY TECHNOLOGIES PRIVATE LIMITED",
"WEB BYTE TECHNOLOGIES PRIVATE LIMITED",
"WEB CONCEPTS 4U.COM PRIVATE LIMITED",
"WEB CONNECT MEDIA PRIVATE LIMITED",
"WEB DREAMWORKS (INDIA ) PRIVATE LIMITED",
"WEB ELEMENT SOLUTIONS LIMITED",
"WEB FORTE TECHNOLOGIES PRIVATE LIMITED",
"WEB GEO SERVICES INDIA PRIVATE LIMITED",
"WEB INFOCOM SERVICES PRIVATE LIMITED",
"WEB INNOVATIONS PRIVATE LIMITED",
"WEB LINK SERVICES PRIVATE LIMITED",
"WEB NETWORKS MADRAS P LIMITED",
"WEB OVERSEAS LIMITED",
"WEB PROJECT PRIVATE LIMITED",
"WEB SPIDERS INDIA PRIVATE LIMITED",
"WEB SPIDERS PRIVATE LIMITED",
"WEB STIX DESIGN PRIVATE LIMITED",
"WEB SUPPLEMENTS",
"WEB SYNERGIES INDIA PRIVATE LIMITED",
"WEB TALKIES PRIVATE LIMITED",
"WEB TRAVERSE (INDIA) PRIVATE LIMITED",
"WEB WERKS INDIA PRIVATE LIMITED",
"WEB WERKS INFRASTRUCTURE PRIVATE LIMITED",
"WEB18 SOFTWARE SERVICES LIMITED",
"WEBAHN INTERNET SOLUTIONS PRIVATE LIMITED",
"WEBAPPLOGIC LLP",
"WEBAROX TECHNOLOGIES PRIVATE LIMITED",
"WEBASTO ROOFSYSTEMS INDIA PRIVATE LIMITED",
"WEBBER INDIA",
"WEBBERZ EDUCOMP LIMITED",
"WEBBITECH MAESTRO PRIVATE LIMITED",
"WEBBIZZ INFOSOLUTIONS PRIVATE LIMITED",
"WEBBY TOYS PRIVATE LIMITED",
"WEBBYGENIUS INFOTECH PRIVATE LIMITED",
"WEBCASTLE MEDIA PRIVATE LIMITED",
"WEBCLICK DIGITAL PRIVATE LIMITED",
"WEBCOBBLERS BUSINESS SOLUTIONS PRIVATE LIMITED",
"WEBCODEGENIE TECHNOLOGY PRIVATE LIMITED",
"WEBCOM DESIGNS SERVICES PRIVATE LIMITED",
"WEBCOM INFORMATION TECHNOLOGY PRIVATE LIMITED",
"WEBCON CONSULTING INDIA LIMITED",
"WEBCON ENGINEERS PRIVATE LIMITED",
"WEBCON IT SOLUTIONS PRIVATE LIMITED",
"WEBCON LABS PRIVATE LIMITED",
"WEBCONNECT PRIVATE LIMITED",
"WEBCONTENTOR INDIA PRIVATE LIMITED",
"WEBCONTRIVE TECHNOLOGIES PRIVATE LIMITED",
"WEBCONTXT INDIA PRIVATE LIMITED",
"WEBCRUNCH TECHNOLOGY PRIVATE LIMITED",
"WEBDEFY CREATIVE STUDIO PRIVATE LIMITED",
"WEBDESK SOLUTION PRIVATE LIMITED",
"WEBDESK TECHNOLOGIES PRIVATE LIMITED",
"WEBDIREKT INDIA PRIVATE LIMITED",
"WEBDYN INDIA PRIVATE LIMITED",
"WEBEL INFORMATICS LIMITED",
"WEBEL SUPPORT MULTIPURPOSE SERVICE CO-OPERATIVE SOCIETY LIMITED",
"WEBEL TECHNOLOGY LIMITED",
"WEBEL VENTURE CAPITAL LIMITED",
"WEBENTIC SERVICES PRIVATE LIMITED",
"WEBENZA INDIA PRIVATE LIMITED",
"WEBER SHANDWICK",
"WEBERINDIA INFRA POWER (OPC) PRIVATE LIMITED",
"WEBERLEADS SERVICES PRIVATE LIMITED",
"WEBEX COMMUNICATIONS INDIA PRIVATE LIMITED",
"WEBFIL LTD",
"WEBFLUENZ INTELSYS PRIVATE LIMITED",
"WEBFOSYS NETWORKS PRIVATE LIMITED",
"WEBFRIES IT SOLUTIONS PRIVATE LIMITED",
"WEBFURTHER INDIA PRIVATE LIMITED",
"WEBGARH SOLUTIONS PRIVATE LIMITED",
"WEBGILITY SOFTWARE TECHNOCRATS PRIVATE LIMITED",
"WEBGURU INFOSYSTEMS PRIVATE LIMITED",
"WEBGURUZ TECHNOLOGIES PRIVATE LIMITED",
"WEBHELP INDIA PRIVATE LIMITED",
"WEBIAN TECHNOLOGIES PRIVATE LIMITED",
"WEBILEAPPS INDIA PRIVATE LIMITED",
"WEBILEAPPS TECHNOLOGY SERVICES PRIVATE LIMITED",
"WEBINDIA INC",
"WEBINDIA INTERNET SERVICES (CHENNAI) PRIVATE LIMITED",
"WEBINO TRADER PRIVATE LIMITED",
"WEBISDOM MANAGEMENT SERVICES PRIVATE LIMITED",
"WEBJI HOSTING PRIVATE LIMITED",
"WEBKLIPPER TECHNOLOGIES PRIVATE LIMITED",
"WEBKUL SOFTWARE PRIVATE LIMITED",
"WEBLENGTH INFONET PRIVATE LIMITED",
"WEBLIGHT PROPERTY MANAGEMENT PRIVATE LIMITED",
"WEBLINE SOLUTIONS PRIVATE LIMITED",
"WEBLINK IN PRIVATE LIMITED",
"WEBLOUDSPEAKER PRIVATE LIMITED",
"WEBLYTICS",
"WEBMANTRA CREATIONS PRIVATE LIMITED",
"WEBMATRIX PRIVATE LIMITED",
"WEBMEP ONLINE TRADERS",
"WEBMICRO SOLUTIONS PRIVATE LIMITED",
"WEBMOBI NETWORK SOLUTIONS PRIVATE LIMITED",
"WEBMOBRIL TECHNOLOGIES PRIVATE LIMITED",
"WEBMOBTECH SOLUTIONS PRIVATE LIMITED",
"WEBMYNE SYSTEMS PRIVATE LIMITED",
"WEBNCLINE",
"WEBNER SOLUTIONS PRIVATE LIMITED",
"WEBNETKEY TECHNOLOGIES PRIVATE LIMITED",
"WEBNORIA E-COMMERCE PRIVATE LIMITED",
"WEBNWARE INFO SOLUTIONS PRIVATE LIMITED",
"WEBNYXA TECHNOLOGIES PRIVATE LIMITED",
"WEBOASIS GARMENTS PRIVATE LIMITED",
"WEBOCCULT TECHNOLOGIES PRIVATE LIMITED",
"WEBOMAZE TECHNOLOGIES PRIVATE LIMITED",
"WEBONISE LAB PRIVATE LIMITED",
"WEBPLANEX INFOTECH PRIVATE LIMITED",
"WEBPRENEUR RESEARCH & ADVISORY PRIVATE LIMITED",
"WEBPROS SOLUTIONS PRIVATE LIMITED",
"WEBPULSE SOLUTION PRIVATE LIMITED",
"WEBREINVENT TECHNOLOGIES PRIVATE LIMITED",
"WEBRICKS AGRO CHEMICALS PRIVATE LIMITED",
"WEBS BEETLE IT SERVICES PRIVATE LIMITED",
"WEBS TECHNO PRIVATE LIMITED",
"WEBSCALE NETWORKS INDIA PRIVATE LIMITED",
"WEBSHAR INDIA PRIVATE LIMITED",
"WEBSITE DEVELOPERS INDIA PRIVATE LIMITED",
"WEBSITE TOOLBOX INDIA PRIVATE LIMITED",
"WEBSKITTERS TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"WEBSMITH TECHNOLOGIES PRIVATE LIMITED",
"WEBSMOJO TECHNOLOGIES LLP",
"WEBSOL ENERGY SYSTEM LIMITED",
"WEBSON INDUSTRIES PRIVATE LIMITED",
"WEBSPIDERS INTERWEB PRIVATE LIMITED",
"WEBSPOT GROWMAX COMMERCE PRIVATE LIMITED",
"WEBSQUE TECHNOLOGIES PRIVATE LIMITED",
"WEBSTEP TECHNOLOGIES PRIVATE LIMITED",
"WEBSTORM INFORMATION TECHNOLOGY PRIVATE LIMITED",
"WEBSTREAM COMMUNICATIONS PRIVATE LIMITED",
"WEBSULTANATE SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"WEBSYM SOLUTIONS PRIVATE LIMITED",
"WEBSYM TECHNOLOGIES PRIVATE LIMITED",
"WEBTEC INDIA TRANSPORTATION PRIVATE LIMITED",
"WEBTECH DEVELOPERS PRIVATE LIMITED",
"WEBTECH EVOLUTION",
"WEBTECH INDUSTRIES",
"WEBTECH MEDIA SYNERGY PRIVATE LIMITED",
"WEBTEL ELECTRO SOFT PRIVATE LIMITED",
"WEBTOGO MOBILES INTERNET PRIVATE LIMITED",
"WEBTUAL TECHNOLOGIES PRIVATE LIMITED",
"WEBUTERS TECHNOLOGIES PRIVATE LIMITED",
"WEBVILLEE TECHNOLOGY PRIVATE LIMITED",
"WEBVIO TECHNOLOGIES PRIVATE LIMITED",
"WEBVIRTUE TECHNOLOGY PRIVATE LIMITED",
"WEBWINGS GLOBAL SOLUTIONS PRIVATE LIMITED",
"WEBWIZ NEW MEDIA PRIVATE LIMITED",
"WEBWORLD EXPERTS INDIA PRIVATE LIMITED",
"WEBYOG SOFTWORKS PRIVATE LIMITED",
"WEBZLABZ PRIVATE LIMITED",
"WECHARTERED CONSULTANCY PRIVATE LIMITED",
"WECKERLE COSMETICS INDIA PRIVATE LIMITED",
"WECO ELEVATOR PRIVATE LIMITED",
"WECODEE INNOVATIONS PRIVATE LIMITED",
"WECOLAB EDUSYSTEM PRIVATE LIMITED",
"WECONNECT SOFT SOLUTIONS PRIVATE LIMITED",
"WECOOL IMPORTS AND TRADING PRIVATE LIMITED",
"WECOORDINATE INDIA PRIVATE LIMITED",
"WECP PRIVATE LIMITED",
"WEDDING DECOR (INDIA) PRIVATE LIMITED",
"WEDDING SAREES INDIA PRIVATE LIMITED",
"WEDDINGPARK HOSPITALITIES PRIVATE LIMITED",
"WEDDINGWIRE INDIA PRIVATE LIMITED",
"WEDEL EXPRESS INDIA PRIVATE LIMITED",
"WEDGE SLOT (INDIA) PRIVATE LIMITED",
"WEDHA COMMUNICATION PRIVATE LIMITED",
"WEDIB EXPRESS LIMITED",
"WEDIG TECHSOLUTIONS PRIVATE LIMITED",
"WEDIGI GLOBAL CONSULTING PRIVATE LIMITED",
"WEDNESDAY SOLAR PRIVATE LIMITED",
"WEDOWEBAPPS PRIVATE LIMITED",
"WEDTREE ESTORE PRIVATE LIMITED",
"WEE BUILDTECH PRIVATE LIMITED",
"WEEBO NETWORKS PRIVATE LIMITED",
"WEECLU SOLUTIONS PRIVATE LIMITED",
"WEEDO VENTURES PRIVATE LIMITED",
"WEEKLINE INVESTMENT AND TRADING COMPANY LTD",
"WEENER EMPIRE PLASTICS PRIVATE LIMITED",
"WEEPROTECT GOODS PRIVATE LIMITED",
"WEEVENTS CONVENTIONS PRIVATE LIMITED",
"WEFAST INDIA PRIVATE LIMITED",
"WEFE TECHNOLOGY PRIVATE LIMITED",
"WEFIVESOFT PRIVATE LIMITED",
"WEFLY TRAVEL & TOURS PRIVATE LIMITED",
"WEFREIGHT INDIA PRIVATE LIMITED",
"WEG INDUSTRIES INDIA PRIVATE LIMITED",
"WEGCON INFRA PRIVATE LIMITED",
"WEGMANS FINANCIAL SERVICES LIMITED",
"WEGMANS INDUSTRIES PRIVATE. LIMITED.",
"WEGOT UTILITY SOLUTIONS PRIVATE LIMITED",
"WEGROW FINANCIAL SERVICES PRIVATE LIMITED",
"WEGUARANTEE PRODUCTS PRIVATE LIMITED",
"WEI (WISEENERGY INDIA) PRIVATE LIMITED",
"WEIDMULLER ELECTRONICS INDIA PRIVATE.LIMITED",
"WEIFORE CABLES PRIVATE LIMITED",
"WEIGHCELL SYSTEMS PRIVATE LIMITED",
"WEIGHTECH",
"WEIGHTRACK INDIA PRIVATE LIMITED",
"WEIGHTRONICS INDUSTRIES PRIVATE LIMITED",
"WEIKFIELD FOODS PRIVATE LIMITED",
"WEIKFIELD PRODUCTS CORPORATION LLP",
"WEILBURGER COATINGS (INDIA) PRIVATE LIMITED",
"WEIMA KIRON INDIA PRIVATE LIMITED",
"WEIND PROVIDER SOLUTIONS PRIVATE LIMITED",
"WEI-PACK ENGINEERING PRIVATE LIMITED",
"WEIR MINERALS (INDIA) PRIVATE LIMITED.",
"WEIR MINERALS INDIA PRIVATE LIMITED",
"WEIRDASS COMEDY PRIVATE LIMITED",
"WEISHEIT TECHNO PRIVATE LIMITED",
"WEISS TECHNIK INDIA PRIVATE LIMITED",
"WEISZ FOREX PRIVATE LIMITED",
"WEIWO COMMUNICATION PRIVATE LIMITED",
"WEIWO TELECOM SERVICES PRIVATE LIMITED",
"WEIZMANN FOREX LIMITED",
"WEIZMANN IMPEX SERVICE ENTERPRISE LIMITED",
"WEIZMANN INTERNATIONAL LIMITED",
"WEIZMANN LIMITED.",
"WEKANCODE TECHNOLOGIES PRIVATE LIMITED",
"WEKEYAR DRUGGIST & CHEMIST PRIVATE LIMITED",
"WEKEYAR PLUS PHARMA PRIVATE LIMITED",
"WEL CAST ENGINEERS PRIVATE LIMITED",
"WEL FINISH METAL PROCESSORS PRIVATE LIMITED",
"WELASSURE PRIVATE LIMITED",
"WELBILT FOODSERVICE INDIA PRIVATE LIMITED",
"WELBOND PIPES AND FITTINGS PRIVATE LIMITED",
"WELBORN INDUSTRIES PRIVATE LIMITED",
"WELBY IMPEX PRIVATE LIMITED",
"WELCARE CORPORATE SERVICES PRIVATE LIMITED",
"WELCARE FACILITY MANAGEMENT PRIVATE LIMITED",
"WELCAST INDIA PRIVATE LIMITED",
"WELCAST PRODUCTS PRIVATE. LIMITED",
"WELCAST STEELS LIMITED",
"WELCH MATERIALS INDIA PRIVATE LIMITED",
"WELCO AGENCIES PRIVATE LIMITED",
"WELCO EXPORT PRIVATE LIMITED",
"WELCO GARMENT MACHINERY PRIVATE LIMITED",
"WELCO INFOTECH PRIVATE LIMITED",
"WELCOME AIR EXPRESS PRIVATE LIMITED",
"WELCOME CROP SCIENCE PRIVATE LIMITED",
"WELCOME CURE PRIVATE LIMITED",
"WELCOME ENTERPRISES PRIVATE LIMITED",
"WELCOME FABRICS PRIVATE LIMITED",
"WELCOME HARDWARE & SAFETY PRIVATE LIMITED",
"WELCOME HOTEL KENCES PALM BEACH",
"WELCOME IMPEX PRIVATE LIMITED",
"WELCOME INFOTECH PRIVATE LIMITED",
"WELCOME INFRATOLL LIMITED",
"WELCOME MINERAL PRIVATE LIMITED",
"WELCOME PHARMALIFE PRIVATE LIMITED",
"WELCOME POLYMERS INDIA PVT LTD",
"WELCOME PSYLLIUM PRIVATE LIMITED",
"WELCOME RESORTS PRIVATE LIMITED",
"WELCOME RETAIL PRIVATE LIMITED",
"WELCOME SAREE CREATION PRIVATE LIMITED",
"WELCOME SHOES PRIVATE LIMITED",
"WELCOME SUPER TEA PROCESSING PRIVATE LIMITED",
"WELCOME TILES PRIVATE LIMITED",
"WELCOME WAFERS PRIVATE LIMITED",
"WELCOMETECH IT SERVICES PRIVATE LIMITED",
"WELCOMEVET PHARMA PRIVATE LIMITED",
"WELCOMHOTEL JODHPUR",
"WELCON EQUIPMENTS INDIA PRIVATE LIMITED",
"WELCON FINANCIALS PRIVATE LIMITED",
"WELCRAFT HEALTHCARE PRIVATE LIMITED",
"WELCRAFT TRADELINKS PRIVATE LIMITED",
"WELD CRAFT PRIVATE LIMITED",
"WELD EQUIPMENT DEVELOPMENT CO. PRIVATE LIMITED",
"WELD EXCEL INDIA LIMITED",
"WELD FUSE PVT LTD",
"WELD SAFE TRADELINK PRIVATE LIMITED",
"WELD TRADE PRIVATE LIMITED",
"WELDAID SAFETY AND SIGNAGE PRIVATE LIMITED",
"WELDCOM ELECTRODES PRIVATE LIMITED",
"WELDCON INDIA PRIVATE LIMITED",
"WELDFAST ELECTRODES PRIVATE LIMITED",
"WELDING ALLOYS SOUTH ASIA PRIVATE LIMITED",
"WELDOMAC ENGINEERING PRIVATE LIMITED",
"WELDON BIOTECH (INDIA) PRIVATE LIMITED",
"WELDON CABLES PRIVATE LIMITED",
"WELDON ENGINEERS PRIVATE LIMITED",
"WELDON FINCAP PRIVATE LIMITED",
"WELDON SEEDS PRIVATE LIMITED",
"WELDON TOURS &TRAVELS PRIVATE .LIMITED",
"WELDOR APPLIANCES PRIVATE LIMITED",
"WELDOR ENGINEERING PRIVATE LIMITED",
"WELDSTEEL WIRES PRIVATE LIMITED",
"WELD-TECH ENGINEERS INDIA PRIVATE LIMITED",
"WELDWELL SPECIALITY PRIVATE LIMITED",
"WELEX LABORATORIES PRIVATE LIMITED",
"WELFAB TECHNOLOGIES PRIVATE LIMITED",
"WELFARE COMMISSIONER AHMEDABAD",
"WELFARE COMMISSIONER L.W.O",
"WELFARE INFOTECH PRIVATE LIMITED",
"WELFARE MEDICAL INDIA PRIVATE LIMITED",
"WELFARE PROPERTIES PRIVATE LIMITED",
"WELFAST MEDICAL CENTRE PRIVATE LIMITED",
"WELFEED REMEDIES PRIVATE LIMITED",
"WELFURN INTERIORS PRIVATE LIMITED",
"WELGATE ORGANIC LIFE (OPC) PRIVATE LIMITED",
"WELGENO PRIVATE LIMITED",
"WELGROW HOTEL CONCEPTS PRIVATE LIMITED",
"WELGROW LINE (NORTH INDIA) PRIVATE LIMITED",
"WELGROW LINE INDIA PRIVATE LIMITED",
"WELGROW TRAVELS PRIVATE LIMITED",
"WELHAM BOYS SCHOOL",
"WELHAM GIRLS SCHOOL",
"WELINGKAR INSTITUTE OF MANAGEMENT DEVELOPMENT & RESEARCH",
"WELKIN AIR EXPRESS PRIVATE LIMITED",
"WELKIN APEX PRIVATE LIMITED",
"WELKIN BUILDERS INFRASTRUCTURE PRIVATE LIMITED",
"WELKIN CONVERGENCE PRIVATE LIMITED",
"WELKIN HEALTHCARE PRIVATE LIMITED",
"WELKIN MARKETING PRIVATE LIMITED",
"WELKIN MEDICARE PRIVATE LIMITED",
"WELKIN SOFT TECH PRIVATE LIMITED",
"WELKIN TELECOM INFRA PRIVATE LIMITED",
"WELKINZONE INDIA PRIVATE LIMITED",
"WELKYN TECHNOLOGIES PRIVATE LIMITED",
"WELL BE MEDIC INDIA PRIVATE LIMITED",
"WELL CARE INFRA-TECH PRIVATE LIMITED",
"WELL EDUCATE INDIA PRIVATE LIMITED",
"WELL FORGE PRIVATE LIMITED",
"WELL FREIGHT PRIVATE LIMITED",
"WELL GREEN KISAN BAZAR PRIVATE LIMITED",
"WELL GROWN SPICES PRIVATE LIMITED",
"WELL HOME DECOR STUDIO PRIVATE LIMITED",
"WELL KNIT INDUSTRIES",
"WELL KNOWN COMPUTERS PRIVATE LIMITED",
"WELL LIFE PHARMACEUTICALS PRIVATE LIMITED",
"WELL O WELL CAPITAL LIMITED",
"WELL PROTECT MANPOWER SERVICES PRIVATE LIMITED",
"WELL SHINE LIGHTS PRIVATE LIMITED",
"WELL SPAIN RUBBER PRIVATE LIMITED",
"WELL TECH ENVIRONMENTAL ENGINEERING PRIVATE LIMITED",
"WELL TECH PACKAGING",
"WELL WEAVE FABRICS PRIVATE LIMITED",
"WELL WORTH WIRE ROPES PRIVATE LIMITED",
"WELLA INDIA PRIVATE LIMITED",
"WELLBEING ENTERPRISES PRIVATE LIMITED",
"WELLBORE ENGINEERING CO",
"WELLBORN DIGITAL PRIVATE LIMITED",
"WELLBORN FLOORINGS PRIVATE LIMITED",
"WELLCARE FACILITY INDIA PRIVATE LIMITED",
"WELLCARE HEALTH PLANS INC.",
"WELLCARE OIL TOOLS PRIVATE LIMITED",
"WELLCARE OIL TOOLS UNIT-II PRIVATE LIMITED",
"WELLCHEM HEALTHCARE LLP",
"WELLCHEM SPECIALITY PRIVATE LIMITED",
"WELLCOME FISHERIES LIMITED",
"WELLCOME GUJARAT INN PVT LTD",
"WELLCON ANIMAL HEALTH PRIVATE LIMITED",
"WELLCON CONSTRUCTIONS PRIVATE LIMITED",
"WELLCONNECT FACILITIES PRIVATE LIMITED",
"WELLCORP HEALTH SERVICES PRIVATE LIMITED",
"WELLCRAFT STORAGE SYSTEMS PRIVATE LIMITED",
"WELLCROP BIOTECH PRIVATE LIMITED",
"WELLCURE LABORATORIES PRIVATE LIMITED",
"WELLCUT TOOLS INDIA PRIVATE LIMITED",
"WELLDOC SOFTWARE PRIVATE LIMITED",
"WELLDONE INFRASTRUCTURE PRIVATE. LIMITED.",
"WELLDONE INTEGRATED SERVICES PRIVATE LIMITED",
"WELLDONE PACKERS INDIA PVT LTD",
"WELLDONE TRADECOM PRIVATE LIMITED",
"WELLESLEY PARTNERS CONSULTING INDIA PRIVATE LIMITED",
"WELLESTA HEALTHCARE PRIVATE LIMITED",
"WELLFARE BUILDINGS AND ESTATES PRIVATE LIMITED",
"WELLFARE INSTITUTE OF SCIENCE TECHNOLOGY AND MANAGEMENT",
"WELLFOAM INDIA PRIVATE LIMITED",
"WELLGEN MEDICARE LLP",
"WELLGIO HEALTHCARE PRIVATE LIMITED",
"WELLGROWTH GRIHA NIRMAN PRIVATE LIMITED",
"WELLHEAD EQUIPMENT ENGINEERS PRIVATE LIMITED",
"WELLING HEALTHCARE PRIVATE LIMITED",
"WELLINGTON INTERNATIONAL SCHOOL",
"WELLIT INDIA PRIVATE LIMITED",
"WELLIX HEALTHCARE PRIVATE LIMITED",
"WELLKNIT FASHION RETAIL PRIVATE LIMITED",
"WELLKNOWN POLYESTERS LIMITED",
"WELLKNOWN TEXTILE INDUSTRIES PRIVATE LIMITED",
"WELLMAC PLASTICS PRIVATE LIMITED",
"WELL-MACH ENGINEERING SYSTEMS PRIVATE LIMITED",
"WELLMAKE ENGINEERING COMPANY PRIVATE LIMITED",
"WELLMAKE TECHNOCAST PRIVATE LIMITED",
"WELLMAN EMPLOYMENT INDIA PRIVATE LIMITED",
"WELLMAN POWER PRIVATE LIMITED",
"WELLMAN WACOMA LTD",
"WELLMARK HOSPITAL PRIVATE LIMITED",
"WELLMEC AUTO PRIVATE LIMITED",
"WELLMED INTERNATIONAL INDUSTRIES PRIVATE LIMITED",
"WELLMON TEXTILE PRIVATE LIMITED",
"WELLNESS DIAGNOSTICS PRIVATE LIMITED",
"WELLNESS DIET PRIVATE LIMITED",
"WELLNESS FIRST GLOBAL KONCEPTS PRIVATE LIMITED",
"WELLNESS FOREVER MEDICARE LIMITED",
"WELLNESS FOREVER MEDICARE PRIVATE LIMITED",
"WELLNESS HOSPITALS",
"WELLNESS NONI LIMITED",
"WELLNESS OF WOMEN PRIVATE LIMITED",
"WELLNESS SOLUTIONS PRIVATE LIMITED",
"WELLNESS VILLE PRIVATE LIMITED",
"WELLNESS WINGS PRIVATE LIMITED",
"WELLNET SERVICES PRIVATE LIMITED",
"WELLNEX EXPERTS SOLUTION PRIVATE LIMITED",
"WELLO RETAIL PRIVATE LIMITED",
"WELLOGEN PHARMA PRIVATE LIMITED",
"WELLONA MEDIWORKS PRIVATE LIMITED",
"WELLONE WASH AND CLEAN SERVICES PRIVATE LIMITED",
"WELLOUS PHARMA PRIVATE LIMITED",
"WELLPOINT",
"WELLPOINT IT SOLUTIONS PRIVATE LIMITED",
"WELLPRO COMPONENTS PRIVATE LIMITED",
"WELLPRO PAPER PRIVATE LIMITED",
"WELLPROOF TECHNOLOGIES PRIVATE LIMITED",
"WELLRAY SOLAR INDUSTRIES PRIVATE LIMITED",
"WELLROOT ORGANICS PRIVATE LIMITED",
"WELLRX TECHNOLOGIES PRIVATE LIMITED",
"WELLS FARGO",
"WELLS FARGO BANK",
"WELLS FARGO INTERNATIONAL SOLUTIONS PRIVATE LIMITED",
"WELLSECURE OIL TOOLS PRIVATE LIMITED",
"WELLSHARK PHARMACEUTICALS PRIVATE LIMITED",
"WELLSIDE GLOBAL PRIVATE LIMITED",
"WELLSIDE INFRASTRUCTURE PRIVATE LIMITED",
"WELLSPHERE HEALTH PRIVATE LIMITED",
"WELLSPRING HEALTHCARE PRIVATE LIMITED",
"WELLSPRING HEALTHCARE SERVICES",
"WELLSPRING INDUSTRIES PRIVATE LIMITED",
"WELLSPRING SOFTWARE LABS PRIVATE LIMITED",
"WELLSPRING STEELS PRIVATE LIMITED",
"WELLSPRING SYSTEMS PRIVATE LIMITED",
"WELLSUN FARMER FERTILIZER PRIVATE LIMITED",
"WELLSUN TEXCHEM PRIVATE LIMITED",
"WELLSURE E-COMM SERVICES PRIVATE LIMITED",
"WELLSYSKURE PHARMACEUTICALS",
"WELLTASS PHARMACEUTICALS PRIVATE LIMITED.",
"WELLTEC OILFIELD SOLUTIONS (INDIA) PRIVATE LIMITED",
"WELLTECH MINERALS PRIVATE LIMITED",
"WELL-TRANS LOGISTICS INDIA PRIVATE LIMITED",
"WELLTREAT CRITICAL CARE CENTER",
"WELLTUCH FURNITURE INDIA PRIVATE LIMITED",
"WELLVERSED HEALTH PRIVATE LIMITED",
"WELLVIO HEALTHCARE PRIVATE LIMITED",
"WELLWIN TECHNOSOFT LIMITED",
"WELLWIN WATERPROOFINGS PRIVATE LIMITED",
"WELL-WISHER CONSTRUCTION PRIVATE LIMITED",
"WELLWISHER SALES PROMOTION PVT.LTD.",
"WELLWORTH AGENCIES PRIVATE LIMITED",
"WELLWORTH CURRENCY CONVERTER PRIVATE LIMITED",
"WELLWORTH ENGINEERING COMPANY PRIVATE LIMITED",
"WELLWORTH FACILITIES PRIVATE LIMITED",
"WELLWORTH LIFE SCIENCE PRIVATE LIMITED",
"WELLWORTH SHARE AND STOCK BROKING LIMITED",
"WELLZYN HEALTHCARE PRIVATE LIMITED",
"WELMADE IMPEX PRIVATE LIMITED",
"WELMADE LOCKING SYSTEM PRIVATE LIMITED",
"WELMAN INDIA PRIVATE LIMITED",
"WELMAN SUPPORT SERVICES PRIVATE LIMITED",
"WELMECH ENGINEERING COMPANY PRIVATE LIMITED",
"WELMET TECHNOLOGIES PRIVATE LIMITED",
"WELMON WOODPLAST PRIVATE LIMITED",
"WELNEX BIO PRIVATE LIMITED",
"WELONA HEALTH CARE PRIVATE LIMITED",
"WELPACK INDUSTRIES PRIVATE LIMITED",
"WELPACK PPOLYMERS LIMITED",
"WELPAR PHARMBIZZ LIMITED",
"WELPLAN INFRASTRUCTURES PRIVATE LIMITED",
"WELQUIN SUPPLIERS PVT.LTD.",
"WELSCON TECHNOLOGIES PRIVATE LIMITED",
"WELSET PLAST EXTURSIONS PRIVATE LIMITED",
"WELSET POLYPACK PRIVATE LIMITED",
"WELSPUN ADVANCED MATERIALS INDIA LIMITED",
"WELSPUN ANJAR SEZ LIMITED",
"WELSPUN AUNTA-SIMARIA PROJECT PRIVATE LIMITED",
"WELSPUN CAPTIVE POWER GENERATION LIMITED",
"WELSPUN CORP LIMITED",
"WELSPUN DELHI MEERUT EXPRESSWAY PRIVATE LIMITED",
"WELSPUN ENTERPRISES LIMITED",
"WELSPUN FINANCIAL SERVICES LIMITED",
"WELSPUN FLOORING LIMITED",
"WELSPUN FOUNDATION FOR HEALTH AND KNOWLEDGE",
"WELSPUN GLOBAL BRANDS LIMITED",
"WELSPUN GLOBAL SERVICES LIMITED",
"WELSPUN INVESTMENTS AND COMMERCIALS LIMITED",
"WELSPUN LIVING LIMITED",
"WELSPUN LOGISTICS LIMITED",
"WELSPUN METALLICS LIMITED",
"WELSPUN MICHIGAN ENGINEERS LIMITED",
"WELSPUN ONE LOGISTICS PARKS DEVELOPMENT MANAGEMENT PRIVATE LIMITED",
"WELSPUN REALTY PRIVATE LIMITED",
"WELSPUN RENEWABLES ENERGY PRIVATE LIMITED",
"WELSPUN ROAD INFRA PRIVATE LIMITED",
"WELSPUN SATTANATHAPURAM NAGAPATTINAM ROAD PRIVATE LIMITED",
"WELSPUN SOLAR MADHYA PRADESH PRIVATE LIMITED",
"WELSPUN SPECIALTY SOLUTIONS LIMITED",
"WELSPUN STEEL LIMITED",
"WELSPUN STEEL RESOURCES PRIVATE LIMITED",
"WELSPUN TRADINGS LIMITED",
"WELSPUN URJA GUJARAT PRIVATE LIMITED",
"WELSPUN VIDYAMANDIR",
"WELSPUN WASCO COATINGS PRIVATE LIMITED",
"WELSTAMP AUTO PRIVATE LIMITED",
"WELSTAND INFRACON PRIVATE LIMITED",
"WELSUIT GLASS AND CERAMICS PRIVATE LIMITED",
"WELT FINSERV PRIVATE LIMITED",
"WELTECH CONTROLS PRIVATE LIMITED",
"WELTECH DESIGNERS PRIVATE LIMITED",
"WELTECH EQUIPMENT AND INFRASTRUCTURE LIMITED",
"WEL-TECH EQUIPMENTS PRIVATE LIMITED",
"WELTECH FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"WELTECH INDUSTRIES PRIVATE LIMITED",
"WELTEK PUMPS PVT LTD",
"WELTIME FOOTWEAR PRIVATE LIMITED",
"WELTRANS LOGISTICS PRIVATE LIMITED",
"WELWORTH FOODS PRIVATE LIMITED",
"WELWORTH TEXTILES PVT LTD",
"WEMAKESCHOLARS EDTECH PRIVATE LIMITED",
"WEMARK MARKETING PRIVATE LIMITED",
"WEMAXIMUM SERVICES PRIVATE LIMITED",
"WEMBLEY INTERIOR PVT LTD",
"WEMBLEY LABORATORIES LIMITED",
"WEMBLEY REALTORS PRIVATE LIMITED",
"WEMECH AUTOMATION PRIVATE LIMITED",
"WEMET PAPERS (INDIA) PRIVATE LIMITED",
"WEMONDE PRIVATE LIMITED",
"WEN ENERGY SYSTEMS PRIVATE LIMITED",
"WENABLE TECHNOLOGIES PRIVATE LIMITED",
"WENDORS OFFICE SUPPLY PRIVATE LIMITED",
"WENDT CORPORATE SERVICES PRIVATE LIMITED",
"WENDT INDIA LIMITED",
"WENDY MARKETING PRIVATE LIMITED",
"WENEERA CONSULTANCY OPC PRIVATE LIMITED",
"WENGLOR SENSORIC INDIA PRIVATE LIMITED",
"WENLAY MEDICARE PRIVATE LIMITED",
"WEN-PARKER LOGISTICS INDIA PRIVATE LIMITED",
"WENS CARGO MOVERS PRIVATE LIMITED",
"WENS INFRA PROJECTS PRIVATE LIMITED",
"WENS REMEDIES PRIVATE LIMITED",
"WENSAR WEIGHING SCALES LIMITED",
"WENSO CREATIVE SOLUTIONS PRIVATE LIMITED",
"WENTWORT MANAGMENT INDIA",
"WENZ INTERNATIONAL PVT LTD",
"WENZEL SOUTH ASIA PRIVATE LIMITED",
"WEO INFOTECH PRIVATE LIMITED",
"WEOWN SERVICES PRIVATE LIMITED",
"WEP PERIPHERALS LIMITED",
"WEP SOLUTIONS LIMITED.",
"WEPAY FINANCE PRIVATE LIMITED",
"WEPLUS CONSULTANCY PRIVATE LIMITED",
"WEPROMISE HOUSEHOLD CONCEPTS PRIVATE LIMITED",
"WERARDT SYSTEMSS PRIVATE LIMITED",
"WERGO REALTECH INDIA OPE PRIVATE.LIMITED",
"WERMORE SOLUTIONS PRIVATE LIMITED",
"WERNER ELECTRIC PRIVATE LIMITED",
"WERNER FINLEY PRIVATE LIMITED",
"WEROOF METAL INDIA PRIVATE LIMITED",
"WERT ERSTELLEN PRIVATE LIMITED",
"WESA HEALTHCARE PRIVATE LIMITED",
"WESAFE INDIA LIFESTYLE PRIVATE LIMITED",
"WESBOK LIFESTYLE PRIVATE LIMITED",
"WESCO AIRCRAFT HARDWARE INDIA PRIVATE LIMITED",
"WESCO WOOD PRIVATE LIMITED",
"WESENCE TECHNOLOGIES PRIVATE LIMITED",
"WESENSE MEDICAL PRIVATE LIMITED",
"WESFO ECO PRODUCTS PRIVATE LIMITED",
"WESHINE TECH PRIVATE LIMITED",
"WESMAN SIMPSON TECHNOLOGIES PRIVATE LIMITED",
"WESMAN THERMAL ENGINEERING PROCESSES PRIVATE LIMITED",
"WESMEC ENGINEERING PRIVATE LIMITED",
"WESOURCE BUSINESS SOLUTIONS PRIVATE LIMITED",
"WESQUARE INDIA PRIVATE LIMITED",
"WESSEL CONSULTANCY PRIVATE LIMITED",
"WEST & BEST TRADING PRIVATE LIMITED",
"WEST ACADEMY SENIOR SECONDARY SCHOOL",
"WEST ADVANCED TECHNOLOGIES INDIA PRIVATE LIMITED",
"WEST ASIA EXPORTS AND IMPORTS PRIVATE LIMITED",
"WEST ASSAM MILK PRODUCERS CO-OPERATIVE UNION LTD",
"WEST BENGAL AGRO TEXTILE CORPORATION LTD",
"WEST BENGAL AGRO-INDUSTRIES CORPN LTD",
"WEST BENGAL CHEMICAL INDUSTRIES LIMITED",
"WEST BENGAL ELECTRONICS INDUSTRY DEVELOPMENT CORPN LTD",
"WEST BENGAL GREEN ENERGY DEVELOPMENT CORPORATION LIMITED",
"WEST BENGAL HOSIERY INDUSTRIES PRIVATE LIMITED",
"WEST BENGAL HOSIERY PARK INFRASTRUCTURE LIMITED",
"WEST BENGAL HOUSING INFRASTRUCTURE DEVELOPMENT CORPORATION LIMITED",
"WEST BENGAL INDUSTRIAL DEVELOPMENT CORPN LIMITED",
"WEST BENGAL INFRASTRUCTURE DEVELOPMENT FINANCE CORPN LTD (WBGOVT COMPANY)",
"WEST BENGAL LEGISLATIVE ASSEMBLY SECRETARIAT",
"WEST BENGAL LOTTERY STOCKISTS SYNDICATE PRIVATE LIMITED",
"WEST BENGAL MFG. CO PVT LTD",
"WEST BENGAL MINERAL DEVELOPMENT AND TRADING CORP LTD",
"WEST BENGAL MOTOR VEHICLES WEIGH BRIDGE CORPORATION LIMITED",
"WEST BENGAL SIKKIM AND ANDAMAN NICOBAR ISLAND GDC KOLKATA",
"WEST BENGAL STATE CO OPERATIVE BANK LTD",
"WEST BENGAL STATE ELECTRICITY DISTRIBUTION COMPANY LIMITED",
"WEST BENGAL STATE ELECTRICITY TRANSMISSION COMPANY LIMITED",
"WEST BENGAL STATE HEALTH AND FAMILY WELFARE SAMITI",
"WEST BENGAL STATE MINOR IRRIGATION CORPN LTD",
"WEST BENGAL STATE RURAL DEVELOPMENT AGENCY",
"WEST BENGAL SURFACE TRANSPORT CORPORATION LTD",
"WEST BENGAL SWAROJGAR CORPORATION LIMITED",
"WEST BENGAL TEXT BOOK CORPORATION LIMITED",
"WEST BENGAL TOURISM DEVELOPMENT CORPN LTD",
"WEST BENGAL TRANSPORT CORPORATION LIMITED",
"WEST CENTRAL RAILWAYS",
"WEST COAST CORROTECH SERVICE LLP",
"WEST COAST ENGINEERING WORKS PRIVATE LIMITED",
"WEST COAST ENTERPRISES PRIVATE LIMITED",
"WEST COAST FOODS PRIVATE LIMITED",
"WEST COAST HOSPITALS AND DIAGNOSTIC CENTRES PRIVATE LIMITED",
"WEST COAST INGOTS PRIVATE LIMITED",
"WEST COAST LUBRICANTS AND ASPHALTS PRIVATE LIMITED",
"WEST COAST MARINE YACHT SERVICES PRIVATE LIMITED",
"WEST COAST MOTORS PRIVATE LIMITED",
"WEST COAST OPTICABLE LIMITED",
"WEST COAST OPTILINKS",
"WEST COAST PAPER BAGS PRIVATE LIMITED",
"WEST COAST PAPER MILLS LIMITED",
"WEST COAST POLYCHEM PRIVATE LIMITED",
"WEST COAST POLYMERS PVT LTD",
"WEST COAST PORT EQUIPMENT SERVICES PRIVATE LIMITED",
"WEST COAST RASAYAN INTERNATIONAL PVT LTD",
"WEST COAST SPICES PRIVATE LIMITED",
"WEST DELHI VAULTS PRIVATE LIMITED",
"WEST END HOTEL",
"WEST END HOUSING FINANCE LIMITED",
"WEST END INVESTMENT AND FINANCE CONSULTANCY PVT LTD",
"WEST GODAVARI INSTITUTE OF SCIENCE AND ENGINEERING",
"WEST GUJARAT EXPRESSWAY LIMITED",
"WEST HILL COMMODITIES PRIVATE LIMITED",
"WEST INDIA CONTINENTAL OILS & FATS PRIVATE LIMITED",
"WEST INDIA EQUIPMENTS PRIVATE LIMITED",
"WEST INDIA GLOBAL PRIVATE LIMITED",
"WEST INDIA HOSPITALITY LIMITED",
"WEST INDIA INFRATECH PRIVATE LIMITED",
"WEST INDIA STEEL CO LTD",
"WEST INDIA TEXTILE MILLS PVT LTD",
"WEST LAND BUILDCON LIMITED",
"WEST MAN INTERNATIONAL DENTAL LAB PRIVATE LIMITED",
"WEST MIDLANDS VENTURES PRIVATE LIMITED",
"WEST PHARMACEUTICAL PACKAGING INDIA PRIVATE LIMITED",
"WEST PIONEER PROPERTIES INDIA PRIVATE LIMITED",
"WEST POINT MARKETING PRIVATE LIMITED",
"WEST POINT MODEL SCHOOL",
"WEST SIDE HOTELS AND RESORTS PRIVATE LIMITED",
"WEST SPACE INDIA PRIVATE LIMITED",
"WEST UNIFIED COMMUNICATIONS INDIA PRIVATE LIMITED",
"WEST WIND CONCEPTS PRIVATE LIMITED",
"WEST WIND PROPERTIES KOCHI PRIVATE LIMITED",
"WEST WIND RETAILS PRIVATE LIMITED",
"WEST WIND SHIPPING AND LOGISTICS PRIVATE LIMITED",
"WEST WING INFRASTRUCTURES PVT LTD",
"WESTA CROP INDIA PRIVATE LIMITED",
"WESTAGILE IT LABS INDIA PRIVATE LIMITED",
"WESTART COMMUNICATIONS INDIA PRIVATE LIMITED",
"WESTBURY ESTATES PRIVATE LIMITED",
"WESTBURY HOLDINGS PRIVATE LIMITED",
"WESTBURY HOSPITALITY PRIVATE LIMITED",
"WESTBURY KOMMERCE",
"WESTBURY TRADECOM LIMITED",
"WESTCOAST NEUROSCIENCE INSTITUTE PRIVATE LIMITED",
"WESTCOAST PHARMACEUTICAL WORKS LIMITED",
"WESTCOURT REAL ESTATE PRIVATE LIMITED",
"WESTECH PROCESS EQUIPMENT INDIA PRIVATE LIMITED",
"WESTECH SECURITIES PRIVATE LIMITED",
"WESTEND AGRO PRODUCTS PRIVATE LIMITED",
"WESTEND COLLEGE OF COMPUTER SCIENCE AND",
"WESTEND CORPORATION PRIVATE LIMITED",
"WESTEND ENTERPRISES PRIVATE LIMITED",
"WESTEND FOUNDRY PRIVATE LIMITED",
"WESTERLY RETAIL PRIVATE LIMITED",
"WESTERN ABRASIVE INDUSTRIES PVT LTD",
"WESTERN AGRI FOOD PARK PRIVATE LIMITED",
"WESTERN AGRI SEEDS LIMITED",
"WESTERN AIRDUCTS INDIA PRIVATE LIMITED",
"WESTERN ALFA LEATHER PRIVATE LIMITED",
"WESTERN ALLOY STEELS PRIVATE LIMITED",
"WESTERN AMMONIA PRIVATE LIMITED",
"WESTERN ANDHRA TOLLWAYS PRIVATE LIMITED",
"WESTERN ARYA FINLEASE PRIVATE LIMITED",
"WESTERN AUTOMOTIVE LLP",
"WESTERN BELTING PRIVATE LIMITED",
"WESTERN BEVERAGES PRIVATE LIMITED.",
"WESTERN BIO SYSTEMS INDIA PRIVATE LIMITED",
"WESTERN BIO VEGETABLE SEEDS PRIVATE LIMITED",
"WESTERN CABLEX ENGINEERING PRIVATE LIMITED",
"WESTERN CANS PVT LTD",
"WESTERN CAPITAL ADVISORS PRIVATE LIMITED",
"WESTERN CARRIERS INDIA LIMITED",
"WESTERN CHEMICAL INDUSTRIES PRIVATE LIMITED",
"WESTERN CLEARING AND FORWARDING AGENCY P LTD",
"WESTERN COALFIELDS LIMITED",
"WESTERN COFFEE CURERS & EXPORTS PRIVATE LIMITED",
"WESTERN COLLEGE OF COMMERCE AND BUSINESS MANAGEMENT",
"WESTERN CONCESSIONS PRIVATE LIMITED",
"WESTERN CONGLOMERATE LIMITED",
"WESTERN CONSOLIDATED PRIVATE LIMITED",
"WESTERN CONTROL AUTOMATION PRIVATE LIMITED",
"WESTERN CROPSCIENCE PRIVATE LIMITED",
"WESTERN DIAGNOSTIC CENTRE PRIVATE LIMITED",
"WESTERN DIGITAL CORPORATION",
"WESTERN DRUGS LIMITED",
"WESTERN ELECTRICALS PRIVATE LIMITED",
"WESTERN ELECTRICITY SUPPLY COMPANY OF ODISHA LIMITED",
"WESTERN ELECTROTRANS PRIVATE LIMITED",
"WESTERN ENTERPRISES INDIA PRIVATE LIMITED",
"WESTERN ENVIROTECH PRIVATE LIMITED",
"WESTERN FARM FRESH PRIVATE LIMITED",
"WESTERN FOODS",
"WESTERN FUND PRIVATE LIMITED",
"WESTERN GRAIN TRADING PRIVATE LIMITED",
"WESTERN HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"WESTERN HEAT AND FORGE PVT LTD",
"WESTERN HUMAN RESOURCES PRIVATE LIMITED",
"WESTERN IMAGINARY TRANSCON PRIVATE LIMITED",
"WESTERN INDIA AIR PRODUCTS PVT LTD",
"WESTERN INDIA AUTOMOBILE ASSOCIATION",
"WESTERN INDIA BAKERS PRIVATE LIMITED",
"WESTERN INDIA CASHEW COMPANY PRIVATE LIMITED",
"WESTERN INDIA CERAMICS PRIVATE LIMITED",
"WESTERN INDIA COMMERCIAL CO LIMITED",
"WESTERN INDIA ELECTRO MEDICAL SYSTEMS PRIVATE LIMITED",
"WESTERN INDIA ERECTORS LLP",
"WESTERN INDIA FORGINGS PRIVATE LIMITED",
"WESTERN INDIA INSTITUTE OF AERONAUTICS PRIVATE LIMITED",
"WESTERN INDIA LOGISTICS COMPANY PRIVATE LIMITED",
"WESTERN INDIA MEDIA PRIVATE LIMITED",
"WESTERN INDIA MINING SERVICES PVT LTD",
"WESTERN INDIA PAINT & COLOUR COMPANY PRIVATE LIMITED",
"WESTERN INDIA SEA BRINES PVT LTD",
"WESTERN INDIA STEEL COMPANY PRIVATE LIMITED",
"WESTERN INDIA TRANSPORT FINANCE COMPANY PRIVATE LIMITED",
"WESTERN INDUSTRIAL APPLICATIONS PRIVATE LIMITED",
"WESTERN INFRA EQUIPMENTS PRIVATE LIMITED",
"WESTERN INFRATECH PRIVATE LIMITED",
"WESTERN IRRIGATION SYSTEM PRIVATE LIMITED",
"WESTERN LIFTERS PRIVATE LIMITED",
"WESTERN LOANS AND REAL ESTATES PVT LTD",
"WESTERN LUBE COMPANY",
"WESTERN MAHARASHTRA DEVELOPMENT CORPN LTD",
"WESTERN MARINE AND ENGINEERING SERVICES PRIVATE LIMITED",
"WESTERN MILLENNIUM INFOTECH PRIVATE LIMITED",
"WESTERN MINIFORGE PRIVATE LIMITED",
"WESTERN OFFSHORE & MARINE PROJECTS PRIVATE LIMITED",
"WESTERN OIL FIELD SERVICES",
"WESTERN OUTDOOR STRUCTURES PRIVATE LIMITED",
"WESTERN OVERSEAS STUDY ABROAD PRIVATE LIMITED",
"WESTERN PLASTIC PROCESSING COMPANY PRIVATE LIMITED",
"WESTERN POLYRUB INDIA PRIVATE LIMITED",
"WESTERN POWER PROJECTS PRIVATE LIMITED",
"WESTERN PRECICAST P LTD",
"WESTERN PRESS PRIVATE LIMITED",
"WESTERN RAILWAYS",
"WESTERN REFRA -CAST PVT LTD",
"WESTERN REFRACTORIES PRIVATE LIMITED",
"WESTERN REFRIGERATION PRIVATE LIMITED",
"WESTERN RUBBER WORKS PRIVATE LIMITED",
"WESTERN RUBBERS INDIA PRIVATE LIMITED",
"WESTERN STAR LINE PRIVATE LIMITED",
"WESTERN SUITINGS PRIVATE LIMITED",
"WESTERN SUPERFRESH STORES PRIVATE LIMITED",
"WESTERN TELECOM PRIVATE LIMITED",
"WESTERN THOMSON INDIA LIMITED",
"WESTERN TOBBACO LIMITED",
"WESTERN TRADE WINGS PRIVATE LIMITED",
"WESTERN TRANSCO POWER LIMITED",
"WESTERN TRANSFORMER & EQUIPMENT PRIVATE LIMITED",
"WESTERN TRANSMISSION (GUJARAT) LIMITED",
"WESTERN U P POWER TRANSMISSION COMPANY LIMITED",
"WESTERN UNION SERVICES INDIA PRIVATE LIMITED",
"WESTERN UP TOLLWAY LIMITED",
"WESTERN WARE HOUSING PVT LTD",
"WESTERN WOOD INDIA PRIVATE LIMITED",
"WESTERNACHER CONSULTING PRIVATE LIMITED",
"WESTERNISED FOOD MATRIX PRIVATE LIMITED",
"WESTFIN INTERNATIONAL PRIVATE LIMITED",
"WESTFORD INSURANCE BROKERS AND RISK MANAGERS PRIVATE LIMITED",
"WESTFORT HI-TECH HOSPITAL LIMITED",
"WESTFROST EQUIPMENTS PRIVATE LIMITED",
"WEST-IN AVO NURSERIES PRIVATE LIMITED",
"WESTIN PHARMACEUTICALS PRIVATE LIMITED",
"WESTING HOUSE SAXBY FARMER LTD",
"WESTLAKE EPOXY INDIA PRIVATE LIMITED",
"WESTLAKE SECURITIES LIMITED",
"WESTLAKE TACKLE EXIM PRIVATE LIMITED",
"WESTLAND CAFE PRIVATE LIMITED",
"WESTLAND PUBLICATIONS PRIVATE LIMITED",
"WESTLAND RUBBER PRIVATE LIMITED",
"WESTLIFE FOODS PRIVATE LIMITED",
"WESTLINE BUILDERS PRIVATE LIMITED",
"WESTMINSTER HEALTHCARE PRIVATE LIMITED",
"WESTOCEANIC SERVICES PRIVATE LIMITED",
"WESTON LIFTS PRIVATE LIMITED",
"WESTPAC BANKING CORPORATION",
"WESTPLAINS AGRO COMMODITIES PRIVATE LIMITED",
"WESTPOINT IMPEX PVT LTD",
"WESTROBE CLOTHING PRIVATE LIMITED",
"WESTROCK CLOTHING PRIVATE LIMITED",
"WESTROCK INDIA PRIVATE LIMITED",
"WESTSHIP LOGISTICS PRIVATE LIMITED",
"WESTSIDE AGRO FOODS PRIVATE LIMITED",
"WESTSIDE IT SOLUTIONS PRIVATE LIMITED",
"WESTTEK ENTERPRISES PRIVATE LIMITED",
"WESTWAY ELECTRONICS LIMITED",
"WESTWELL BIOREFINERIES PRIVATE LIMITED",
"WESTWELL DISTRIBUTORS PRIVATE LIMITED",
"WESTWELL GASES PRIVATE LIMITED",
"WESTWELL POLYTUBES PRIVATE LIMITED",
"WESTWIND REALTORS PRIVATE LIMITED",
"WESTWOOD EDUCATION FOUNDATION",
"WESTZONE DEVELOPERS PRIVATE LIMITED",
"WESUCCEED SOLUTIONS INDIA PRIVATE LIMITED",
"WET AND DRY PERSONAL CARE PRIVATE LIMITED",
"WETEC AUTOMATION INDIA PRIVATE LIMITED",
"WETECH HOMEFINDERS PRIVATE LIMITED",
"WETPOINT AQUA EQUIPMENTS PRIVATE LIMITED",
"WETWO FOODS PRIVATE LIMITED",
"WEVIN PRIVATE LIMITED",
"WEVIN TECHNOLOGY CENTRE PRIVATE LIMITED",
"WEVOIS LABS PRIVATE LIMITED",
"WEWORK INDIA MANAGEMENT PRIVATE LIMITED",
"WEX TECHNOLOGIES PRIVATE LIMITED",
"WEXFORD LABORATORIES PRIVATE LIMITED",
"WEY TECHNOLOGY INDIA PRIVATE LIMITED",
"WEYENBERG RESOURCES (INDIA) PRIVATE LIMITED",
"WEZEN EDUCATION PRIVATE LIMITED",
"WEZMANN TOOLS PRIVATE LIMITED",
"WFB BAIRD & COMPANY INDIA PRIVATE. LIMITED.",
"WFB BAIRD AND COMPANY INDIA PRIVATE LIMITED",
"WFM TECHNOLOGIES PRIVATE LIMITED",
"WGBL INDIA PRIVATE LIMITED",
"WGH HOTELS AND RESORTS PRIVATE LIMITED",
"WGI TRADERS (INDIA) PRIVATE LIMITED",
"WHACKED OUT MEDIA PRIVATE LIMTED",
"WHALE BLUE HITECH PRIVATE LIMITED",
"WHALE CLOUD TECHNOLOGY INDIA PRIVATE LIMITED",
"WHALE ENTERPRISE PRIVATE LIMITED",
"WHALE GRAPHICS (INDIA) LIMITED",
"WHALE STATIONERY PRODUCTS LIMITED",
"WHAM INFOCOM PRIVATE LIMITED",
"WHARTON ENGINEERS AND DEVELOPERS PVT LTD",
"WHAT DIGITAL TECHNOLOGIES PRIVATE LIMITED",
"WHATNOT INDIA PRIVATE LIMITED",
"WHATNOT MARKETING PRIVATE LIMITED",
"WHATS EXTRA INDIA PRIVATE LIMITED",
"WHATS ON INDIA MEDIA PRIVATE LIMITED",
"WHATSAPP APPLICATION SERVICES PRIVATE LIMITED",
"WHATTAY VENTURE PRIVATE LIMITED",
"WHEATCO AGRO PRIVATE LIMITED",
"WHEATONS DESIGN PRIVATE LIMITED",
"WHEECON INSTRUMENTS PRIVATE LIMITED",
"WHEEL & PRECISION FORGINGS INDIA LIMITED",
"WHEEL A TRADERS INDIA PRIVATE LIMITED",
"WHEEL FLEXIBLE PACKAGING PRIVATE LIMITED",
"WHEEL INDIA SCM SOLUTIONS PRIVATE LIMITED",
"WHEELABRATOR ALLOY CASTINGS LIMITED",
"WHEELERS DEVELOPERS PVT LTD",
"WHEELGRAM LOGISTICS PRIVATE LIMITED",
"WHEELOCITY MOTORS PRIVATE LIMITED",
"WHEELPORT LOGISTICS PRIVATE LIMITED",
"WHEELS & MILES INTER LOGISTICS PRIVATE LIMITED",
"WHEELS & WAVES LOGISTICS PRIVATE LIMITED",
"WHEELS CORPORATE SOLUTIONS PRIVATE LIMITED",
"WHEELS FORWARDERS PRIVATE LIMITED",
"WHEELS INDIA LIMITED",
"WHEELS MART PRIVATE LIMITED",
"WHEELS SCAFFOLDING (INDIA) LIMITED",
"WHEELSEMI PRIVATE LIMITED",
"WHEELSEYE LOGISTICS PRIVATE LIMITED",
"WHEELSEYE TECHNOLOGY INDIA PRIVATE LIMITED",
"WHEELSON LOGISTICS AND SOLUTIONS PRIVATE LIMITED",
"WHEEZAL HOMEO PHARMA",
"WHEN-IT-STRIKES CRISIS MANAGEMENT PRIVATE LIMITED",
"WHERESCAPE INDIA PRIVATE LIMITED",
"WHERESJENNY LEARNING CENTRE INDIA PRIVATE LIMITED",
"WHIG BEVERAGES PRIVATE LIMITED",
"WHILEOFONE INNOVATION LAB PRIVATE LIMITED",
"WHIPLASH IMPEX PRIVATE LIMITED",
"WHIRLDATA LABS PRIVATE LIMITED",
"WHIRLER CENTRIFUGALS PRIVATE LIMITED",
"WHIRLPOOL ASIA LLP",
"WHIRLPOOL CORPORATION",
"WHIRLPOOL OF INDIA LIMITED",
"WHIRLYBIRD ELECTRONICS PRIVATE LIMITED",
"WHISHWORKS IT CONSULTING PRIVATE LIMITED",
"GSPANN TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"WHISKIN SPIRITS PRIVATE LIMITED",
"WHISPER MEDIA PRIVATE LIMITED",
"WHISPERING MEADOWS CLUB AND RESORTS PRIVATE LIMITED",
"WHISPERING PALMS BEACH RESORTS",
"WHISPERING RESORTS PRIVATE LIMITED",
"WHISSKERS MARKETING PRIVATE LIMITED",
"WHISTLEDRIVE PRIVATE LIMITED",
"WHISTLER HOLDING CORPORATION PRIVATE LIMITED",
"WHISTLER PHARMACEUTICALS PRIVATE LIMITED",
"WHISTLING WOOD EXIM PRIVATE LIMITED",
"WHISTLING WOODS INTERNATIONAL LIMITED",
"WHITBY WOOD PRITAMDASANI CONSULTING ENGINEERS PRIVATE LIMITED",
"WHITE ALLOY INDUSTRIES PRIVATE LIMITED",
"WHITE AND BRIEF (OPC) PRIVATE LIMITED",
"WHITE BIRD REALTY PRIVATE LIMITED",
"WHITE BLOCKS PRIVATE LIMITED",
"WHITE CANARY PRIVATE LIMITED",
"WHITE CANVAS COMMUNICATIONS PRIVATE LIMITED",
"WHITE CLIFF TEA PVT LTD",
"WHITE CLOUDZ PRIVATE LIMITED",
"WHITE CLOVE SERVICES PRIVATE LIMITED",
"WHITE COMMUNICATION PRIVATE LIMITED",
"WHITE COPPER PRIVATE LIMITED",
"WHITE CROSS HEALTH INITIATIVES PRIVATE LIMITED",
"WHITE CROW RESEARCH PRIVATE LIMITED",
"WHITE DATA SYSTEMS INDIA PRIVATE LIMITED",
"WHITE DWARF MEDIA PRIVATE LIMITED",
"WHITE ELEPHANT SOLUTIONS PRIVATE LIMITED",
"WHITE FEATHER FILMS LIMITED",
"WHITE FEATHER HEALTHCARE PRIVATE LIMITED",
"WHITE FIBRE ARTS PRIVATE LIMITED",
"WHITE FIN PRIVATE LIMITED",
"WHITE FIRE DIAMONDS INDIA PRIVATE LIMITED",
"WHITE FORT HOTELS PRIVATE LIMITED",
"WHITE FOX SUPPORT SERVICES PRIVATE LIMITED",
"WHITE GANGA MILKFOOD PRIVATE LIMITED",
"WHITE GLOBE PRIVATE LIMITED",
"WHITE GLOVES FACILITY SERVICES PRIVATE LIMITED",
"WHITE GOLD TRANSPORT PRIVATE LIMITED",
"WHITE GRAPE COMMUNICATIONS PRIVATE LIMITED",
"WHITE HATS RESTAURANTS PRIVATE LIMITED",
"WHITE HEARTS FOODIES PRIVATE LIMITED",
"WHITE HILL DHAAKAD PRIVATE LIMITED",
"WHITE HILL MUSIC PRIVATE LIMITED",
"WHITE HILL PRODUCTION INDIA PRIVATE LIMITED",
"WHITE HORSE MANPOWER CONSULTANCY PRIVATE LIMITED",
"WHITE HOUSE",
"WHITE HOUSE APPARIELS",
"WHITE HOUSE APPERALS PRIVATE LIMITED",
"WHITE HOUSE BUSINESS SOLUTIONS PRIVATE LIMITED",
"WHITE HOUSE FURNITURE PRIVATE LIMITED",
"WHITE HOUSE GALAXY PRIVATE LIMITED",
"WHITE HOUSE TILES PRIVATE LIMITED",
"WHITE INFRASTRUCTURE PRIVATE LIMITED",
"WHITE JACKET HOSPITALITY PRIVATE LIMITED",
"WHITE JEWELS PRIVATE LIMITED",
"WHITE KETTLE CONSULTING PRIVATE LIMITED",
"WHITE KNIGHT FILTERS PRIVATE LIMITED",
"WHITE KNIGHT FOREX SERVICES PRIVATE LIMITED",
"WHITE KNIGHTS",
"WHITE KNIGHTS REALTY PRIVATE LIMITED",
"WHITE LABS INDIA PRIVATE LIMITED",
"WHITE LEAF ENTERTAINMENT MEDIA PRIVATE LIMITED",
"WHITE LEAF SOFTWARE SOLUTIONS PRIVATE LIMITED",
"WHITE LIGHT FOOD PRIVATE LIMITED",
"WHITE LINE PHARMA PRIVATE LIMITED",
"WHITE LION ENTERTAINMENT PRIVATE LIMITED",
"WHITE LOTUS AGRICULTURE PRIVATE LIMITED",
"WHITE LOTUS CONNECT PRIVATE LIMITED",
"WHITE LOTUS LIFESCAPES PRIVATE LIMITED",
"WHITE LOTUS POLYTEX PRIVATE LIMITED",
"WHITE LOTUS SURGITECH PRIVATE LIMITED",
"WHITE MARK LIMITED",
"WHITE MARQUE SOLUTIONS PRIVATE LIMITED",
"WHITE MAVENS MEDIA PRIVATE LIMITED",
"WHITE MEDIAMARKETING PRIVATE LIMITED",
"WHITE MONKEY F&B LLP",
"WHITE MOUNTAIN RESORTS PRIVATE LIMITED",
"WHITE 'N' WHITE MINERALS PRIVATE LIMITED",
"WHITE OAK CAPITAL MANAGEMENT CONSULTANTS LLP",
"WHITE OCEAN FACILITY MANAGEMENT PRIVATE LIMITED",
"WHITE ORGANIC AGRO LIMITED",
"WHITE ORGANIC RETAIL LIMITED",
"WHITE PAPERPULP INDUSTRIES PRIVATE LIMITED",
"WHITE PEARL AGRO INDIA PRIVATE LIMITED",
"WHITE PEARL WEB PRIVATE LIMITED",
"WHITE PEARLS HOTELS AND INVESTMENT PVT LTD",
"WHITE PLACARD TECHNOLOGIES PRIVATE LIMITED",
"WHITE PROJECTS PRIVATE LIMITED",
"WHITE QUARZ PRIVATE LIMITED",
"WHITE RIVERS MEDIA SOLUTIONS PRIVATE LIMITED",
"WHITE ROOF BUILDING SYSTEMS PRIVATE LIMITED",
"WHITE ROSE COUNTY PRIVATE LIMITED",
"WHITE ROSE SALT AND CHEMICALS PRIVATE LIMITED",
"WHITE SHARK ENTERTAINMENT PRIVATE LIMITED",
"WHITE SHRUB PRIVATE LIMITED",
"WHITE SKY LABS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"WHITE SPACES CONSULTING PRIVATE LIMITED",
"WHITE SPREAD FOODS PRIVATE LIMITED",
"WHITE STONE DEVELOPERS PRIVATE LIMITED",
"WHITE SWAN LOGISTICS INDIA PRIVATE LIMITED",
"WHITE SWAN TRADERS PRIVATE LIMITED",
"WHITE THOUGHTS AND BRANDING PRIVATE LIMITED",
"WHITE TIGER PROPERTIES PRIVATE LIMITED",
"WHITE TURTLE STUDIOS LLP",
"WHITE VALLEY PRIVATE LIMITED",
"WHITE VENTURES ONLINE PRIVATE LIMITED",
"WHITE WARBLER COMMUNICATIONS PRIVATE LIMITED",
"WHITE WATER ADVISORS PRIVATE LIMITED",
"WHITE WATER CAFE PRIVATE LIMITED",
"WHITE WATER DESIGN STUDIO LLP",
"WHITE WATER TEXFAB PRIVATE LIMITED",
"WHITE WINDOWS INFRASTRUCTURE PRIVATE LIMITED",
"WHITE&TRUST PHARMACEUTICALS (INDIA) PRIVATE LIMITED",
"WHITEANDGREY MEDIA SOLUTIONS PRIVATE LIMITED",
"WHITEBOARD IDEA LABS PRIVATE LIMITED",
"WHITEBOARD TECHNOLOGIES PRIVATE LIMITED",
"WHITECAPS CULINARY EDUCATION PRIVATE LIMITED",
"WHITECITY CERAMIC PRIVATE LIMITED",
"WHITECITY MERCANTILE COMPANY PRIVATE LIMITED",
"WHITECLIFF POLYTEX PRIVATE LIMITED",
"WHITECLOUD HOSPITALITY PRIVATE LIMITED",
"WHITECOOL INSULATION PRIVATE LIMITED",
"WHITE-ELEPHANT FINANCE LIMITED",
"WHITE-ELEPHANT JEWELLERY PRIVATE LIMITED",
"WHITEFIELD COMMUNICATION PRIVATE LIMITED",
"WHITEFIELD DAIRY PRIVATE LIMITED",
"WHITEFIELD MOTORS PRIVATE LIMITED",
"WHITEFIELD REFRACTORIES PRIVATE LIMITED",
"WHITEFIELDS OVERSEAS LIMITED",
"WHITEFOX SMART CARE PRIVATE LIMITED",
"WHITEGOLD CERA CLAY PRIVATE LIMITED",
"WHITEGOLD CERAMICS PRIVATE LIMITED.",
"WHITEGOLD TRADING COMPANY PRIVATE LIMITED",
"WHITEHATS TECHNOLOGIES PRIVATE LIMITED",
"WHITEHEDGE TECHNOLOGIES PRIVATE LIMITED",
"WHITEHEN PRIVATE LIMITED",
"WHITEINC RETAIL PRIVATE LIMITED",
"WHITEKLAY TECHNOLOGIES PRIVATE LIMITED",
"WHITEKNIGHT",
"WHITELAKE TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"WHITELEAF BUSINESS SERVICES PRIVATE LIMI TED",
"WHITELINE TECHNOLOGIES PRIVATE LIMITED",
"WHITELION SYSTEMS PRIVATE LIMITED",
"WHITELOTUS INDUSTRIES LIMITED",
"WHITENIGHTS PRIVATE LIMITED",
"WHITEOAK CAPITAL ASSET MANAGEMENT LIMITED",
"WHITEPAPER FOREX PRIVATE LIMITED",
"WHITEPAPER INFRATECH PRIVATE LIMITED",
"WHITEPAPER SOLUTIONS PRIVATE LIMITED",
"WHITESCAPE SERVICES LLP",
"WHITESHARK ENERGY PRIVATE LIMITED",
"WHITESHEEP TECHNOLOGY PRIVATE LIMITED",
"WHITESPACE LOGISTICS PRIVATE LIMITED",
"WHITESPAN BUSINESS SOLUTIONS PRIVATE LIMITED",
"WHITESPRING ESTATES PRIVATE LIMITED",
"WHITESTONE DIAMONDS PRIVATE LIMITED",
"WHITESTONE SALES PVT. LTD.",
"WHITESUN GREEN ENERGY PRIVATE LIMITED",
"WHITESWAN CONSULTANCY SERVICES PRIVATE LIMITED",
"WHITE-TONE MICRON PRIVATE LIMITED",
"WHITEWATER CORPORATE ADVISORY PRIVATE LIMITED",
"WHITEX METALS PRIVATE LIMITED",
"WHITFORD INDIA PRIVATE LIMITED",
"WHITON CHEM PRIVATE LIMITED",
"WHITWORTH ENGINEERS PRIVATE LIMITED",
"WHIZ CONSULTING PRIVATE LIMITED",
"WHIZ FOODS PRIVATE LIMITED",
"WHIZ LABORATORIES (INDIA) PRIVATE LIMITED",
"WHIZ SOFTWARE SOLUTIONS PRIVATE LIMITED",
"WHIZAMET SERVICES PRIVATE LIMITED",
"WHIZCHIP DESIGN TECHNOLOGIES PRIVATE LIMITED",
"WHIZCLOUD PRIVATE LIMITED",
"WHIZDM FINANCE PRIVATE LIMITED",
"WHIZDOTAI INDIA PRIVATE LIMITED",
"WHIZHACK TECHNOLOGIES PRIVATE LIMITED",
"WHIZKID COMPUTERS PVT LTD",
"WHIZKID TRAVELS PRIVATE LIMITED",
"WHIZLABS SOFTWARE PRIVATE LIMITED",
"WHIZZ EVENTS AND ENTERTAINMENT PRIVATE LIMITED",
"WHIZZ HR PRIVATE LIMITED",
"WHIZZ KIDZS ACADEMY PRIVATE LIMITED",
"WHIZZ SALES & MARKETING PRIVATE LIMITED",
"WHOA MAMA STUDIOS PRIVATE LIMITED",
"WHOLDINGS TRAVEL MANAGEMENT PRIVATE LIMITED",
"WHOLE EARTH BRANDS PRIVATE LIMITED",
"WHOLE FOODS MARKET INC.",
"WHOLE SOLAR PRIVATE LIMITED",
"WHOLEFOOD INDIA (CONFECTIONARY) PRIVATE LIMITED",
"WHOLESALEBOX INTERNET PRIVATE LIMITED",
"WHOLESOMEBASKET MARKETING PRIVATE LIMITED",
"WHOPPL GLOBAL PRIVATE LIMITED",
"WHP JEWELLERS ECOMMERCE PRIVATE LIMITED",
"WHT NXT TRADE FAIR SOLUTIONS PRIVATE LIMITED",
"WHYNESS COMMUNICATIONS PRIVATE LIMITED",
"WHYQ LLP",
"WHYTE KNOWLEDGE AND DATA SOLUTIONS PRIVATE LIMITED",
"WHYWHEEL SHIPPING AND LOGISTICS PRIVATE LIMITED",
"WI BRIDGE NETWORK SOLUTIONS PRIVATE LIMITED",
"WI-BRO SOLUTIONS PRIVATE LIMITED",
"WICODE INFOTECH PRIVATE LIMITED",
"WICTOR CHEMICALS INDIA PRIVATE LIMITED",
"WIDASCONCEPTS INDIA PRIVATE LIMITED",
"WIDE ANGLE INFRASPACE PRIVATE LIMITED",
"WIDE ANGLE MEDIA PRIVATE LIMITED",
"WIDE ANGLE PACKAGING SYSTEM PVT LTD",
"WIDE INFOTECH INDIA PRIVATE LIMITED",
"WIDE REACH ADVERTISING PRIVATE LIMITED",
"WIDE SPACE TECHNOSOLUTION PRIVATE LIMITED",
"WIDECHOICE DEPARTMENTAL STORE PRIVATE LIMITED",
"WIDELINE BUILDERS AND DEVELOPERS INDIA PRIVATE LIMITED",
"WIDENER INFRASTRUCTURE PRIVATE LIMITED",
"WIDER LOGISTICS (INDIA) PRIVATE LIMITED",
"WIDESCREEN HOLDINGS PRIVATE LIMITED",
"WIDEX INDIA PRIVATE LIMITED",
"WIDIA INDIA TOOLING PRIVATE LIMITED",
"WIDIA POORNA PRAJNA PRE UNIVERSITY COLLEGE",
"WIDIA POORNAPRAJNA SCHOOL",
"WIEDEN + KENNEDY INDIA PRIVATE LIMITED",
"WIEGAND INDIA PVT LTD",
"WIELAND METALS INDIA PRIVATE LIMITED",
"WIENERBERGER INDIA PRIVATE LIMITED",
"WIESNER WORLDWIDE KREATIONS PRIVATE LIMITED",
"WIFA CLADDING TECHNOLOGY PRIVATE LIMITED",
"WI-FI COMMUNICATIONS PRIVATE LIMITED",
"WIFI NETWORKS PRIVATE LIMITED",
"WIFIN TECHNOLOGIES INDIA PRIVATE LIMITED",
"WIG AIR FREIGHT PRIVATE LIMITED",
"WIG BROTHERS INDIA PRIVATE. LIMITED.",
"WIG BROTHERS INFRASTRUCTURE PRIVATE LIMITED",
"WIG BROTHERS PROJECTS PRIVATE LIMITED",
"WIGGLEWINK VENTURES PRIVATE LIMITED",
"WIGO INDUSTRIAL SERVICES PRIVATE LIMITED",
"WIINANCE FINANCIAL SERVICES PRIVATE LIMITED",
"WIKA INSTRUMENTS INDIA PRIVATE LIMITED",
"WIKAS PRINTING AND CARRIERS PRIVATE LIMITED",
"WIKATI EDUCATION LLP",
"WIKI IMPEX PRIVATE LIMITED",
"WIKKERWORK SOFTWARE PRIVATE LIMITED",
"WIKREATE WORLDWIDE PRIVATE LIMITED",
"WIKUS INDIA PRIVATE LIMITED",
"WIL CAR WHEELS LIMITED",
"WIL HAVEN CONTAINER LINE PRIVATE LIMITED",
"WILA CNC INDIA PRIVATE LIMITED",
"WILBER IMPEX PRIVATE LIMITED",
"WILBER STONE SOLUTIONS PRIVATE LIMITED",
"WILBURT REMEDIES PRIVATE LIMITED",
"WILCO APPAREL PRIVATE LIMITED",
"WILCO FINEXIM PVT. LTD.",
"WILCO SOURCE TECHNOLOGIES PRIVATE LIMITED",
"WILCURE REMEDIES PRIVATE LIMITED",
"WILD CREEK WEB STUDIO PRIVATE LIMITED",
"WILD DAISIES PRIVATE LIMITED",
"WILD FRONTIERS TRAVEL PRIVATE LIMITED",
"WILD INDIA CAMPS PRIVATE LIMITED",
"WILD INNOVATION PRIVATE LIMITED",
"WILD PLANET PRIVATE LIMITED",
"WILDCARD TECHNO SERVICES PRIVATE LIMITED",
"WILDCRAFT BEVERAGE PRIVATE LIMITED",
"WILDCRAFT INDIA LIMITED",
"WILDCRAFT INDIA PRIVATE. LIMITED.",
"WILDERNESS FILMS INDIA LIMITED",
"WILDLIFE CONSERVATION SOCIETY - INDIA",
"WILDLIFE SOS",
"WILDLIFE SOS INDIA FOUNDATION",
"WILDLION TECHNOLOGIES PRIVATE LIMITED",
"WILDLOTUS FASHIONS PRIVATE LIMITED",
"WILDNET TECHNOLOGIES PRIVATE LIMITED",
"WILEY APAC SERVICES LLP",
"WILEY INDIA PRIVATE LIMITED",
"WILH LOESCH SEA LAND INDIA PRIVATE LIMITED",
"WILH.LOESCH INDIA PRIVATE LIMITED",
"WILHELM TEXTIL INDIA PRIVATE LIMITED",
"WILHELMSEN MARITIME SERVICES PRIVATE LIMITED",
"WILHELMSEN SHIP MANAGEMENT PRIVATE LIMITED",
"WILL IMPEX PHARMACHEM PRIVATE LIMITED",
"WILL INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"WILL MARINE CONTAINER SERVICE PRIVATE LIMITED",
"WILL POWER CONSTRUCTION PRIVATE LIMITED",
"WILLARD ADVISORY PRIVATE LIMITED",
"WILLBROSE HITECH INFRASTRUCTURE PRIVATE LIMITED",
"WILLCARE LIFESCIENCES PRIVATE LIMITED",
"WILLEE HOSPITAL",
"WILLETT CABLES PRIVATE LIMITED",
"WILLFIELD LOGISTICS PRIVATE LIMITED",
"WILLIAM E CONNOR & ASSOCIATES SOURCING PRIVATE LIMITED",
"WILLIAM GOODACRE AND SONS INDIA PRIVATE LTD",
"WILLIAM GRANT AND SONS INDIA PRIVATE LIMITED",
"WILLIAM HARE INDIA PRIVATE LIMITED",
"WILLIAM INDUSTRIES PRIVATE LIMITED",
"WILLIAM J. CLINTON FOUNDATION",
"WILLIAM O'NEIL INDIA PRIVATE LIMITED",
"WILLIAM PENN PRIVATE LIMITED",
"WILLIAMS BAKERY PRIVATE LIMITED",
"WILLIAMS COMMERCE TECHNOLOGY PRIVATE.LIMITED.",
"WILLIAMS CONTROLS INDIA PRIVATE LIMITED",
"WILLIAMS LEA INDIA PRIVATE LIMITED",
"WILLIAMS MARKETING OPC PRIVATE LIMITED",
"WILLIAMS SONOMA INDIA PRIVATE LIMITED",
"WILLIAMSON FINANCIAL SERVICES LIMITED",
"WILLIAMSON MAGOR & CO.LIMITED",
"WILLIEZ PRE SCHOOL",
"WILLINGDON COLLEGE SANGLI",
"WILLIS TOWERS WATSON",
"WILLIS TOWERS WATSON INDIA INSURANCE BROKERS PRIVATE LIMITED",
"WILLMAR COT FAB PRIVATE LIMITED",
"WILLMARK PHARMACEUTICALS PRIVATE LIMITED",
"WILLMAX INDIA PRIVATE LIMITED",
"WILLMORE PLY PRIVATE LIMITED",
"WILL-NEST INDO STERLING HAUSER PROJECTS PRIVATE LIMITED",
"WILLOW POLYMERS PRIVATE LIMITED",
"WILLOW STONE REALTY PRIVATE LIMITED",
"WILLOWOOD CHEMICALS LIMITED",
"WILLOWOOD CHEMICALS PRIVATE LIMITED",
"WILLOWOOD CROP SCIENCES PRIVATE LIMITED",
"WILLSTRONG SOLUTIONS PRIVATE LIMITED",
"WILLUS INFRASTRUCTURE PRIVATE LIMITED",
"WILLY TRADE PRIVATE LIMITED",
"WILLY'S INTEGRATED PRIMARY SCHOOL",
"WILMAC ENGINEERING (INDIA) PRIVATE LIMITED",
"WILMAN INFRAPROJECTS PRIVATE LIMITED",
"WILMAR SUGAR INDIA PRIVATE LIMITED",
"WILO MATHER AND PLATT PUMPS PRIVATE LIMITED",
"WILSHIRE PESTICIDES & FERTILIZER PRIVATE LIMITED",
"WILSHIRE PHARMACCUTICALS PRIVATE LIMITED PHARMA",
"WILSON DRUGS AND PHARMACEUTICALS PVT LTD",
"WILSON ENGINEERING INDUSTRIES PRIVATE LIMITED",
"WILSON EQUIPMENTS PRIVATE LIMITED",
"WILSON FINANCIAL SERVICES PRIVATE LIMITED",
"WILSON GREEN INDUSTRIES PRIVATE LIMITED",
"WILSON HIGHSCHOOL WARD D",
"WILSON HOLDINGS PRIVATE LIMITED",
"WILSON LEARNING INDIA PRIVATE LIMITED",
"WILSON PAPER MILLS PRIVATE LIMITED",
"WILSON PEN PRIVATE LIMITED",
"WILSON POWER AND DISTRIBUTION TECHNOLOGIES PRIVATE LIMITED",
"WILSON REAL ESTATE AND SECURITIES PRIVATE LIMITED",
"WILSON SANDHU LOGISTICS (INDIA) LIMITED",
"WILSON SURVEYORS AND ADJUSTERS PRIVATE LIMITED",
"WILSON TAPES PRIVATE LIMITED",
"WILTON WEAVERS PRIVATE LIMITED",
"WILWAY ENGINEERING AND CONSTRUCTION PRIVATE LIMITED",
"WILWORTH TECHSOL PRIVATE LIMITED",
"WILY LEASING & INFOTECH PRIVATE LIMITED",
"WIM PLAST LIMITED",
"WIM PLAST MOLDETIPO PRIVATE LIMITED",
"WIMATE TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"WIMAXX POLYTEX INDIA PRIVATE LIMITED",
"WIMCO LIMITED",
"WIMERA SYSTEMS PRIVATE LIMITED",
"WIMI INDUSTRIES PRIVATE LIMITED",
"WIMROCK GRANITE PRIVATE LIMITED",
"WIMS HOSPITAL, AGRA",
"WIMSON ELETRONICS PRIVATE LIMITED",
"WIMWI FOODS PRIVATE LIMITED",
"WIN ALL RUBBER INDUSTRIES PRIVATE LIMITED",
"WIN AMR SYSTEMS PRIVATE LIMITED",
"WIN AXIS CONSULTANTS PRIVATE LIMITED",
"WIN CABLE ENTERTAINMENT PRIVATE LIMITED",
"WIN CABLE NETWORK PRIVATE LIMITED",
"WIN CARS PRIVATE LIMITED",
"WIN CREATIVES INDIA PRIVATE LIMITED",
"WIN ENGINEERING PVT LTD",
"WIN ESTATECARE PRIVATE LIMITED",
"WIN EX FILMS PRIVATE LIMITED",
"WIN FIRE SERVICES PRIVATE LIMITED",
"WIN HEALTH PHARMA",
"WIN HIDE PRIVATE LIMITED",
"WIN INDIA EXPORTS",
"WIN INFORMATION TECHNOLOGY PRIVATE LIMITED",
"WIN LIFE MEDICARE PRIVATE LIMITED",
"WIN MEDICARE PRIVATE LIMITED",
"WIN PENS PRIVATE LIMITED",
"WIN POWER ENGINEERING PRIVATE LIMITED",
"WIN STAR INDUSTRIES PRIVATE LIMITED",
"WIN STAR MARKETINNG INDIA PRIVATE LIMITED",
"WIN TEL CERAMICS PRIVATE LIMITED",
"WIN TEX ENGINEERS INDIA PRIVATE LIMITED",
"WIN TOOLS INDIA PRIVATE LIMITED",
"WIN TRUST PHARMACEUTICALS LIMITED",
"WIN VENTURE PRIVATE LIMITED",
"WIN VISION EYE HOSPITALS (AS RAO NAGAR) PRIVATE LIMITED",
"WIN VISION EYE HOSPITALS (GACHIBOWLI) PRIVATE LIMITED",
"WIN VISION EYE HOSPITALS (KUKATPALLY) PRIVATE LIMITED",
"WIN VISION EYE HOSPITALS PRIVATE LIMITED",
"WIN WIN AUTOMOBILES PRIVATE LIMITED",
"WIN WIN DISTRIBUTION PRIVATE LIMITED",
"WIN WIN INDUSTRIES PRIVATE LIMITED",
"WIN WIN VEHICLES (CAR) PRIVATE LIMITED",
"WIN WOODS PRIVATE LIMITED",
"WINACLE NETWORK LLP",
"WINAIR INDIA LOGISTIC PRIVATE LIMITED",
"WINAJES CONSTRUCTIONS INDIA PRIVATE LIMITED",
"WINBEE SOLUTIONS PRIVATE LIMITED",
"WINBELL COMPRESSORS PRIVATE LIMITED",
"WINC IT SERVICES PRIVATE LIMITED",
"WINCARE REMEDIES LIMITED",
"WINCERE SOLUTIONS PRIVATE LIMITED",
"WINCHEMINDIA",
"WINCITO TEK SOLUTIONS PRIVATE LIMITED",
"WINCO CONSTRUCTIONS AND DEVELOPERS PRIVATE LIMITED",
"WINCO VALVES PRIVATE LIMITED",
"WINCOR IT SOLUTIONS PRIVATE LIMITED",
"WINCOR NIXDORF INDIA PRIVATE LIMITED",
"WINCROP AGRITECH PRIVATE LIMITED",
"WINCURE CHEMICALS PRIVATE LIMITED",
"WIND BREAKERS PRIVATE LIMITED",
"WIND CHIMES FOODS PRIVATE LIMITED",
"WIND FIVE RENERGY LIMITED",
"WIND FOUR RENERGY PRIVATE LIMITED",
"WIND LOGISTICS PRIVATE LIMITED",
"WIND ONE RENERGY LIMITED",
"WIND RIVER SYSTEMS INTERNATIONAL INC",
"WIND STREAM ENERGY TECHNOLOGIES INDIA PRIVATE. LIMITED",
"WIND THREE RENERGY LIMITED",
"WIND URJA INDIA PRIVATE LIMITED",
"WIND WORLD WIND FARMS (HINDUSTAN) PRIVATE LIMITED",
"WIND WORLD WIND FARMS (INDIA) LIMITED",
"WIND WORLD WIND FARMS (JAISALMER) PRIVATE LIMITED",
"WIND WORLD WIND FARMS (KARNATAKA) LIMITED",
"WIND WORLD WIND FARMS (KRISHNA) LIMITED",
"WIND WORLD WIND FARMS (SAI) PRIVATE LIMITED",
"WIND WORLD WIND FARMS (TEMDARAI) PRIVATE LIMITED",
"WIND WORLD WIND RESOURCES DEVELOPMENT PRIVATE LIMITED",
"WINDAGE POWER COMPANY PRIVATE LIMITED",
"WINDALS PRECISION PRIVATE LIMITED",
"WINDAR RENEWABLE ENERGY PRIVATE LIMITED",
"WINDBERRY LIFE SCIENCES PRIVATE LIMITED",
"WINDBORNE AIR1 PRIVATE LIMITED",
"WINDBORNE AVIATION PRIVATE LIMITED",
"WINDCARE INDIA PRIVATE LIMITED",
"WINDCHIMES COMMUNICATIONS PRIVATE LIMITED",
"WINDCHIMES CONSTRUCTIONS PRIVATE LIMITED",
"WINDERMERE CONSULTANTS PRIVATE LIMITED",
"WINDESON TRADEMART PRIVATE LIMITED",
"WINDFALL PRODUCTIONS PRIVATE LIMITED",
"WINDFALL TECHNO SYSTEMS PRIVATE LIMITED",
"WINDFORCE MANAGEMENT SERVICES PRIVATE LIMITED",
"WINDIA CHEMICALS PRIVATE LIMITED",
"WINDIA INFRASTRUCTURE FINANCE LIMITED",
"WINDLAS BIOTECH LIMITED",
"WINDLAS HEALTHCARE PRIVATE LIMITED",
"WINDLASS DEVELOPER PRIVATE LIMITED",
"WINDLASS STEELCRAFTS LLP FORMERLY WINDLASS STEELCRAFTS",
"WINDMILL CAPITAL PRIVATE LIMITED",
"WINDMILL HOLIDAYS PRIVATE LIMITED",
"WINDMOLLER AND HOISCHER INDIA PRIVATE LIMITED",
"WINDOORS INTERNATIONAL LIMITED",
"WINDOR INDIA PRIVATE LIMITED",
"WINDORZ INDIA PRIVATE LIMITED",
"WINDOW EXPERT INDUSTRIES PRIVATE LIMITED",
"WINDOW MAGIC INDIA PRIVATE LIMITED",
"WINDOW TECHNOLOGIES PRIVATE LIMITED",
"WINDOW TECHS INDIA PRIVATE LIMITED",
"WINDOW WEST TECHNOLOGIES PRIVATE LIMITED",
"WINDOW WORLD INDIA PRIVATE LIMITED",
"WINDOWALA INDIA PRIVATE LIMITED",
"WINDOWMAKER SOFTWARE PRIVATE LIMITED",
"WINDPLUS PRIVATE LIMITED",
"WINDS BUSINESS SOLUTIONS PRIVATE LIMITED",
"WINDSHIELD XPRESS PRIVATE LIMITED",
"WINDSON CERAMIC",
"WINDSON ORGANICS PRIVATE LIMITED",
"WINDSON POWER AND CONTROL SYSTEMS PRIVATE LIMITED",
"WINDSOR BIOGEN PRIVATE LIMITED",
"WINDSOR CLUB AND RESORTS PRIVATE LIMITED",
"WINDSOR COTTON MILLS PRIVATE. LIMITED.",
"WINDSOR EDIFICES PRIVATE LIMITED",
"WINDSOR FASHIONS PVT LTD",
"WINDSOR GARDENS PRIVATE LIMITED",
"WINDSOR INDUSTRIES PRIVATE LIMITED",
"WINDSOR INFRASTRUCTURE LIMITED",
"WINDSOR MACHINES LIMITED",
"WINDSOR PETROCHEMICALS PRIVATE LIMITED",
"WINDSOR REALITY",
"WINDSOR REFRACTORIES LTD",
"WINDSOR SPECIALTY SERVICES PRIVATE LIMITED",
"WINDSOR SUPPORT SERVICES PRIVATE LIMITED",
"WINDSOR TOWER PRIVATE LIMITED",
"WINDSTREAM ENERGY TECHNOLOGIES INDIA PRIVATE LIMITED",
"WINDSTREAM HOLDINGS INC.",
"WINDSUN RENEWABLES PRIVATE LIMITED",
"WINDTREE INFRA PRIVATE LIMITED",
"WINDWALKER LOGISTICS SOLUTIONS PRIVATE LIMITED",
"WINDY INVESTMENTS PRIVATE LIMITED",
"WINDY OAKS EXPORTS PRIVATE LIMITED",
"WINDYCITY TECHNOLOGIES PRIVATE LIMITED",
"WINE ENTERPRISES PRIVATE LIMITED",
"WINE KING PRIVATE LIMITED",
"WINE NOOK DEALERS PRIVATE LIMITED",
"WINE SAMRAT PRIVATE LIMITED",
"WINET INFRATEL PRIVATE LIMITED",
"WINEX LOGISTICS INDIA PRIVATE LIMITED",
"WINFAB EQUIPMENTS PRIVATE. LIMITED.",
"WINFAB INTERIORS INDIA PRIVATE LIMITED",
"WINFIELD ESTATES PRIVATE LIMITED",
"WINFINITH MARKETING PRIVATE LIMITED",
"WINFLEX LIMITED",
"WINFO SOLUTIONS PRIVATE LIMITED",
"WINFOCUS SOLUTIONS PRIVATE LIMITED",
"WINFOGLOBAL TECHNOLOGIES PRIVATE LIMITED",
"WINFOMI TECHNOLOGIES LLP",
"WINFORT SERVICES PRIVATE LIMITED",
"WINFOWARE TECHNOLOGIES LIMITED",
"WINFUL DIESEL PRIVATE LIMITED",
"WING COLONISERS PRIVATE LIMITED",
"WING CONSTRUCTIONS & DEVELOPERS PRIVATE LIMITED",
"WING GLOBAL IT SERVICES PRIVATE LIMITED",
"WING INFRABUILD PRIVATE LIMITED",
"WING OPERATIONS & TECHNOLOGIES INDIA PRIVATE LIMITED",
"WING TALENTS MANAGEMENT PRIVATE LIMITED",
"WINGEDHUMAN ENTERPRISES PRIVATE LIMITED",
"WINGER POLYMERS PRIVATE LIMITED",
"WINGER POWER PRIVATE LIMITED",
"WINGFAN INDIA PRIVATE LIMITED",
"WINGFLOW CONSTRUCTION PRIVATE LIMITED",
"WINGIFY SOFTWARE PRIVATE LIMITED",
"WINGLOBE HEALTHCARE PRIVATE LIMITED",
"WINGMAN FREIGHT EXPRESS PRIVATE LIMITED",
"WINGO LABS PRIVATE LIMITED",
"WINGRIP PLAST PRIVATE LIMITED",
"WINGS AGRICULTURE PRIVATE LIMITED",
"WINGS AGRO PRIVATE LIMITED",
"WINGS AUTOMOBLIE PRODUCTS PRIVATE LIMITED",
"WINGS AVIATION PRIVATE LIMITED",
"WINGS BIOTECH LIMITED",
"WINGS BRAND ACTIVATIONS INDIA PRIVATE LIMITED",
"WINGS CORPORATE SERVICES PRIVATE LIMITED",
"WINGS ECO HOMES PRIVATE LIMITED",
"WINGS FINSERV",
"WINGS INDIA FASHION PRIVATE LIMITED",
"WINGS INFONET PRIVATE LIMITED",
"WINGS LOGISTICS PRIVATE LIMITED",
"WINGS PHARMACEUTICALS PRIVATE LIMITED",
"WINGS REALTY VENTURES LLP",
"WINGS SECURITY AND ALLIED SERVICES PRIVATE LIMITED",
"WINGS TECH.SOLUTIONS PRIVATE LIMITED",
"WINGS2I IT SOLUTIONS PRIVATE LIMITED",
"WINGSLIFE SPACES MARKETING SERVICES PRIVATE. LIMITED",
"WINGSTER ENGINEERS PRIVATE LIMITED",
"WINGTECH MOBILE COMMUNICATIONS INDIA PRIVATE LIMITED",
"WINGZ FORWARDING AND LOGISTICS PRIVATE LIMITED",
"WINIIN TAXSCOPE PRIVATE LIMITED",
"WINJIT TECHNOLOGIES PRIVATE LIMITED",
"WINJOY TECHNOLOGIES",
"WINKLE TWINKLE CONSTRUCTIONS PRIVATE LIMITED",
"WINKO PACKAGINGS INDIA PRIVATE LIMITED",
"WINKTALES CREATIVE SOLUTIONS PRIVATE LIMITED",
"WINLAC PAINTS PRIVATE LIMITED",
"WINLANTIC BUSINESS SOLUTIONS PRIVATE LIMITED",
"WINLEY POLYMERS PRIVATE LIMITED",
"WINLIGHT TECHNOLOGIES PRIVATE LIMITED",
"WINLINTECH SOLUTIONS PRIVATE LIMITED",
"WINMACH AUTOMATIONS PRIVATE LIMITED",
"WINMAGIC TOYS PRIVATE LIMITED",
"WINMAN SOFTWARE INDIA LLP",
"WINMARK ENTERPRISES PRIVATE LIMITED",
"WINMARK SPORTS PRIVATE LIMITED",
"WINMAX CERAMIC PRIVATE LIMITED",
"WINMAX TECHNOLOGIES PRIVATE LIMITED",
"WINMED DEVICES PRIVATE LIMITED",
"WINMET TECHNOLOGIES PRIVATE LIMITED",
"WINMET UNITED ACCESSORIES PRIVATE LIMITED",
"WINNDSOR COTTON MILLS PRIVATE LIMITED",
"WINNER AUTO COMPONENTS INDIA PRIVATE LIMITED",
"WINNER CONSTRUCTIONS PRIVATE LIMITED",
"WINNER DAIRY PVT LTD",
"WINNER GAMES AND TECHNOLOGIES PRIVATE LIMITED",
"WINNER IMPEX PRIVATE LIMITED",
"WINNER MILK PRIVATE LIMITED",
"WINNER NIPPON LEATHERETTE PRIVATE LIMITED",
"WINNER OVERSEAS",
"WINNER SCREEN MACHINES PRIVATE LIMITED",
"WINNER TECHNOPLAST PRIVATE LIMITED",
"WINNERCOM SANDHAR TECHNOLOGIES PRIVATE LIMITED",
"WINNERS FREIGHT MANAGEMENT INDIA PRIVATE LIMITED",
"WINNERS INDUSTRIES PRIVATE LIMITED",
"WINNERS LIFE TRAINING PRIVATE LIMITED",
"WINNERS ROYAL VARSHA CREDIT COOPERATIVE SOCIETY LTD",
"WINNERSPITCH ENERGY PRIVATE LIMITED",
"WINNI RETAILS PRIVATE LIMITED",
"WINNING ATTITUDE EDUMART PRIVATE LIMITED",
"WINNING EDGE AGRO PRODUCTS THE",
"WINNING EDGE SPORTS PROMOTION PRIVATE LIMITED",
"WINNOW IT SERVICES PRIVATE LIMITED",
"WINNTRA PEB AND ROOFING SYSTEMS PRIVATE LIMITED",
"WINNTUS FORMWORK PRIVATE LIMITED",
"WINNTUS SCAFFOLDING PRIVATE LIMITED",
"WINNWIN LEADERSHIP ACADEMY PRIVATE LIMITED",
"WINNY IMMIGRATION & EDUCATION SERVICES LIMITED",
"WINNY IMMIGRATION & EDUCATION SERVICES PRIVATE LIMITED",
"WINOA ABRASIVES INDIA PRIVATE LIMITED",
"WINOLA INDIA PRIVATE LIMITED",
"WINOMECHANIC PRIVATE LIMITED",
"WINONE PRECISION TECHNOLOGY INDIA PRIVATE LIMITED",
"WINONE PRODUCT TECHNOLOGIES PRIVATE LIMITED",
"WINORA SALES PRIVATE LIMITED",
"WINOVA ENTERPRISES PRIVATE LIMITED",
"WINPLAY TECHNOLOGY INDIA PRIVATE LIMITED",
"WIN-POLY FILAMENTS PRIVATE LIMITED",
"WIN-POWER MARKETING PRIVATE LIMITED",
"WINPRAD INFRACON PRIVATE LIMITED",
"WINPRO EXIM PRIVATE LIMITED",
"WINPROTECH IT SOLUTIONS INDIA PRIVATE LIMITED",
"WINQUALIS CONSULTING PRIVATE LIMITED",
"WINRO COMMERCIAL INDIA LIMITED",
"WINROYAL WINDOWS AND DOORS PRIVATE LIMITED",
"WINS VIMAL TEXZONE PRIVATE LIMITED",
"WINSAR INFOSOFT PRIVATE LIMITED",
"WINSEED AGRI PRIVATE LIMITED",
"WINSERVE SYSTEMS PRIVATE LIMITED",
"WINSHER COMMERCIAL PVT.LTD.",
"WINSHUTTLE SOFTWARE INDIA PRIVATE LIMITED",
"WINSMED PHARMACEUTICALS PRIVATE LIMITED",
"WINSOFT EDUCARE FOUNDATION",
"WINSOFT EXPORTS PRIVATE LIMITED",
"WINSOFT TECHNOLOGIES INDIA PRIVATE LIMITED",
"WINSOL ENGINEERS LIMITED",
"WINSOL SOLAR FIELDS (POLEPALLY) PRIVATE LIMITED",
"WINSOL SOLAR FIELDS POLEPALLY PRIVATE LIMITED",
"WINSOME BREWERIES LIMITED",
"WINSOME DESIGN PRIVATE LIMITED",
"WINSOME MEDICARE PRIVATE LIMITED",
"WINSOME PARK PRIVATE LIMITED",
"WINSOME TEA PLANTATION (P) LTD",
"WINSOME TEXTILE INDUSTRIES LIMITED",
"WINSON PERFUMES & COSMETICS PRIVATE LIMITED",
"WINSOR TECHNOLOGIES PRIVATE LIMITED",
"WINSPECT INFOSYSTEM PRIVATE LIMITED",
"WINSPIR COMMUNICATIONS PRIVATE LIMITED",
"WINSPIR CREATIONS PRIVATE LIMITED",
"WINSPIRATION ENERGY & ENGINEERING PRIVATE LIMITED",
"WINSPIRE SOLUTIONS PRIVATE LIMITED",
"WINSPIRING IDEAS PRIVATE LIMITED",
"WINSPREE FASHIONS PRIVATE LIMITED",
"WINSPREE MERCHANTS PRIVATE LIMITED",
"WINSTAR AUTOMOTIVES PRIVATE LIMITED",
"WINSTIC INSURANCE BROKERS (INDIA) PRIVATE LIMITED",
"WINSTO CORPORATION PRIVATE LIMITED",
"WINSTON ESTATE PRIVATE LIMITED",
"WINSTON PHARMACEUTICALS LIMITED",
"WINSTRATA SOFTWARE SOLUTIONS PRIVATE LIMITED",
"WINSTREET IMPEX PRIVATE LIMITED",
"WINSTRIM CONSULTANTS PRIVATE LIMITED",
"WINSTROL PETRO CHEMICALS PVT LTD",
"WINSUM AIR CONTROLS PRIVATE LIMITED",
"WINSUM SERVICES PRIVATE LIMITED",
"WINSUN CERAMIC PRIVATE LIMITED",
"WINTAAS WINDOW SYSTEMS PRIVATE LIMITED",
"WINTAC LIMITED",
"WINTAGE ENGINEERS & CONSULTANTS PRIVATE LIMITED",
"WINTAGE ENGINEERS AND CONSULTANTS PRIVATE LIMITED",
"WINTAGE GARMENTS PRIVATE LIMITED",
"WINTEAM CONSOLIDATORS INDIA PRIVATE LIMITED",
"WINTEC POLYMER PRIVATE LIMITED",
"WINTECH ECO SOLUTIONS PRIVATE LIMITED",
"WINTECH GLAZING SYSTEMS PRIVATE LIMITED",
"WINTECH INDUSTRIES PRIVATE LIMITED",
"WINTECH INSTRUMENTS & TECHNOLOGIES PRIVATE LIMITED",
"WINTECH INTERNATIONAL INC",
"WINTECH JEWELS EQUIPMENT PRIVATE LIMITED",
"WINTECH MARKETING PRIVATE LIMITED",
"WINTECH PHARMACEUTICALS LIMITED",
"WINTECH PHARMACHEM EQUIPMENTS PRIVATE LIMITED",
"WINTECH POLYSOL PRIVATE LIMITED",
"WINTECH SERVICES INDIA PRIVATE LIMITED",
"WINTEK INFOTECH PRIVATE LIMITED",
"WINTEK NON WOVEN PRIVATE LIMITED",
"WINTEK TECHNOLOGY INDIA PRIVATE LIMITED",
"WINTERFELL REALTY PRIVATE LIMITED",
"WINTERHALTER INDIA PRIVATE LIMITED",
"WINTERHUGS TEXTILES PRIVATE LIMITED",
"WINTERLAND TRADING PRIVATE LIMITED",
"WINTERMATE FIBER PRIVATE LIMITED",
"WINTEX APPAREL LIMITED",
"WINTEX FOOTWEAR COMPANY PRIVATE LIMITED",
"WINTEX KNIT (INDIA) PRIVATE LIMITED",
"WINTLT TECHNOLOGIES PRIVATE LIMITED",
"WINTOP MARINE PRIVATE LIMITED",
"WINTOP VITRIFIED PRIVATE LIMITED",
"WINTOUCH CERAMIC",
"WINTROBE ASSOCIATES PVT LTD",
"WINTRUST LOGISTICS PRIVATE LIMITED",
"WINTRY COLD CHAIN PRIVATE LIMITED",
"WINTRY ENGINEERING AND CHEMICALS P.LIMITED",
"WINVEST TECHNOLOGY CONSULTANCY SERVICES",
"WINVESTA INDIA TECHNOLOGIES PRIVATE LIMITED",
"WINVINAYA INFOSYSTEMS INDIA PRIVATE LIMITED",
"WINWALL TECHNOLOGY INDIA PRIVATE LIMITED",
"WINWAY COMMUNICATION PRIVATE LIMITED",
"WINWAYS SYSTEMS PRIVATE LIMITED",
"WIN-WIN AUTOLINK PRIVATE LIMITED",
"WINWIN MARITIME LIMITED",
"WINWIND POWER ENERGY PRIVATE LIMITED",
"WINWIRE TECHNOLOGIES INDIA PRIVATE LIMITED",
"WINWORLD CONTAINER LINES PRIVATE LIMITED",
"WINY HEALTHCARE PRIVATE LIMITED",
"WINZAI APPAREL PRIVATE LIMITED",
"WINZEN CARE PRIVATE LIMITED",
"WINZO GAMES PRIVATE LIMITED",
"WIPFLI INDIA LLP",
"WIPRO CHANDRIKA PRIVATE LIMITED",
"WIPRO CONSUMER AND PERSONAL CARE PRIVATE LIMITED",
"WIPRO ENTERPRISES PRIVATE LIMITED",
"WIPRO FINANCE PRIVATE LIMITED",
"WIPRO GE HEALTHCARE PRIVATE LIMITED",
"WIPRO GE MEDICAL DEVICE MANUFACTURING PRIVATE LIMITED",
"WIPRO HR SERVICES INDIA PRIVATE LIMITED",
"WIPRO INSFRASTRUCTURE AND ENGINEERING P LIMITED",
"WIPRO INSURANCE SOLUTIONS LLC",
"WIPRO KAWASAKI PRECISION MACHINERY PRIVATE LIMITED",
"WIPRO LIMITED",
"WIPRO LINECRAFT AI PRIVATE LIMITED",
"WIPRO PARI ENGINEERING AND SERVICES PRIVATE LIMITED",
"WIPRO PARI PRIVATE LIMITED",
"WIPRO PARI ROBOTICS PRIVATE LIMITED",
"WIPRO SPECTRAMIND",
"WIPRO TECHNOLOGY PRODUCT SERVICES PRIVATE LIMITED",
"WIPRO TRAVEL SERVICES LIMITED",
"WIPRO VLSI DESIGN SERVICES INDIA PRIVATE LIMITED",
"WIPTECH PERIPHERALS PRIVATE LIMITED",
"WIRALITY MEDIA PRIVATE LIMITED",
"WIRE AND INSULATED CABLE PRODUCTS PRIVATE LIMITED",
"WIRE AND WIRELESS INDIA",
"WIRE BRIGADE INDUSTRIES PRIVATE LIMITED",
"WIRE DEVELOPERS PRIVATE LIMITED",
"WIRE LINE SOLUTION (INDIA) PRIVATE LIMITED",
"WIRE SHOPPE PRIVATE LIMITED",
"WIREAXIS PRIVATE LIMITED",
"WIRECARD INDIA PRIVATE LIMITED",
"WIRECOM INDIA PRIVATE LIMITED",
"WIREFORM COMPONENTS (INDIA) PRIVATE LIMITED",
"WIRELESS COMMUNICATION SERVICES INDIA PRIVATE LIMITED",
"WIRELESS PLANNING & CONSULTANCY INDIA PRIVATE LIMITED",
"WIRELESS TELEINFRA PRIVATE LIMITED",
"WIRELESS WAVES PRIVATE LIMITED",
"WIRELUX CABLES PRIVATE LIMITED",
"WIREMANN INDUSTRIES PRIVATE LIMITED",
"WIRES AND CABLES INDIA",
"WIRES AND FABRIKS SA LIMITED",
"WIREX DIES AND STEELS (I) PRIVATE LIMITED",
"WIRINTCO TECHNOLOGIES PRIVATE LIMITED",
"WIRKFORCE STAFFING PRIVATE LIMITED",
"WIRLEBEN SOFTECH PRIVATE LIMITED",
"WIRONIX STEEL PRIVATE LIMITED",
"WIRTGEN INDIA PRIVATE LIMITED",
"WIRTZ MANUFACTURING INDIA PRIVATE LIMITED",
"WISCON PHARMACEUTICALS PRIVATE LIMITED",
"WISDOM AGRICARE PRIVATE LIMITED",
"WISDOM COLONIZERS PRIVATE LIMITED",
"WISDOM COTTON",
"WISDOM HIMALAYAN VOYAGES PRIVATE LIMITED",
"WISDOM INFOTECH PRIVATE LIMITED",
"WISDOM INNOVATIONS PRIVATE LIMITED",
"WISDOM IT SERVICES INDIA PRIVATE LIMITED",
"WISDOM OVERSEAS PRIVATE LIMITED",
"WISDOM TECHSEAL PRIVATE LIMITED",
"WISDOM VALLEY GLOBAL SCHOOL",
"WISDOM VALLEY SCHOOL JABALPUR\n",
"WISDOM WORLD SCHOOL",
"WISDOMLEAF TECHNOLOGIES PRIVATE LIMITED",
"WISDOMTECH SERVICES PRIVATE LIMITED",
"WISDOMTOOLZ LEARNING SOLUTIONS PRIVATE LIMITED",
"WISDOMTREE PRODUCTIONS PRIVATE LIMITED",
"WISDOMWORLD PROJECTS PRIVATE LIMITED",
"WISE ENGAGE PRIVATE LIMITED",
"WISE FINSERV INSURANCE MARKETING PRIVATE LIMITED",
"WISE LEAP TECHNOLOGIES PRIVATE LIMITED",
"WISE LIFECARE PRIVATE LIMITED",
"WISE MAN CONSULTING SERVICE INDIA LLP",
"WISE MEN CONSULTING SERVICE INDIA LLP",
"WISE MEN CONSULTING SERVICE INDIA PRIVATE LIMITED",
"WISE NEOSCO INDIA PRIVATE LIMITED",
"WISE ONLINE STORES PRIVATE LIMITED",
"WISE PAYMENTS INDIA PRIVATE LIMITED",
"WISE SHIPPING & LOGISTICS PRIVATE LIMITED",
"WISE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"WISE TRAVEL INDIA LIMITED",
"WISE TRAVEL INDIA PRIVATE LIMITED",
"WISECOR SERVICES PRIVATE LIMITED",
"WISECOW MARKETING AND MEDIA CONSULTANTS PRIVATE LIMITED",
"WISEGUY RESEARCH CONSULTANTS PRIVATE LIMITED",
"WISEINVEST PRIVATE LIMITED",
"WISEKARTE INNOVATION PRIVATE LIMITED",
"WISELAP TECHNOLOGIES PRIVATE LIMITED",
"WISELINK GLOBAL SERVICES PRIVATE LIMITED",
"WISEMONK SERVICES PRIVATE LIMITED",
"WISEPOWER ENTERPRISE INDIA PRIVATE LIMITED",
"WISESOURCE SOLUTIONS PRIVATE LIMITED",
"WISETECH GLOBAL (INDIA) PRIVATE LIMITED",
"WISETECH MEP CONSULTANTS PRIVATE LIMITED",
"WISETECH SOURCE PRIVATE LIMITED",
"WISETHINK INFORMATION SOLUTIONS PRIVATE LIMITED",
"WISETR TECHNOLOGY PRIVATE LIMITED",
"WISFLUX PRIVATE LIMITED",
"WISH ENERGY SOLUTIONS PRIVATE LIMITED",
"WISH NET PRIVATE LIMITED",
"WISH TRIP PRIVATE LIMITED",
"WISH WELL FINANCE AND LEASING PRIVATE LIMITED",
"WISHACLOUD PRIVATE LIMITED",
"WISHBAG ONLINE PRIVATE LIMITED",
"WISHBOX COMMUNICATIONS PRIVATE LIMITED",
"WISHERY ONLINE PRIVATE LIMITED",
"WISHGREEN INDUSTRIES PRIVATE LIMITED",
"WISHHEALTH PRIVATE LIMITED",
"WISHING WELL HEALTHCARE PRIVATE LIMITED",
"WISHMAKERS EVENTS PRIVATE LIMITED",
"WISHOPEDIA SERVICES PRIVATE LIMITED",
"WISHPOINT TECH PRIVATE LIMITED",
"WISHTEL PRIVATE LIMITED",
"WISHTREE TECHNOLOGIES LLP",
"WISHUP TECHNOLOGY PRIVATE LIMITED",
"WISHWOOD COTTAGE SCHOOL",
"WISIG NETWORKS PRIVATE LIMITED",
"WISILICA INDIA PRIVATE LIMITED",
"WISITECH INFOSOLUTIONS PRIVATE LIMITED",
"WISKA INDIA PRIVATE LIMITED",
"WISO MANUFACTURING PRIVATE LIMITED",
"WISSDA CONSULTING PRIVATE LIMITED",
"WISSEN INFOTECH PRIVATE LIMITED",
"WISSEN TECHNOLOGY PRIVATE LIMITED",
"WISSEND CONSULTANCY SERVICES PRIVATE LIMITED",
"WIST MRG MERCHANDISING PRIVATE LIMITED",
"WIST WATER SOLUTIONS PRIVATE LIMITED",
"WISTELI INFORMATICS PRIVATE LIMITED",
"WISTERIA HOUSING PRIVATE LIMITED",
"WISTERIA REAL VISION PRIVATE LIMITED",
"WISTERN LOGISTICS PRIVATE LIMITED",
"WISTRA ELMETHERM INDIA PRIVATE LIMITED",
"TATA ELECTRONICS SYSTEMS SOLUTIONS PRIVATE LIMITED",
"WIT EXECUTORS PRIVATE LIMITED",
"WITAL SEE MARKETING LIMITED",
"WITARIST IT SERVICES PRIVATE LIMITED",
"WITCO INDIA PRIVATE LIMITED",
"WITCONS INFRA PROJECTS PRIVATE LIMITED",
"WITH U HOSPITALITY PRIVATE LIMITED",
"WITHUMSMITHBROWN INDIA LLP",
"WITMANS ADVANCED FLUIDS PRIVATE LIMITED",
"WITMANS ENGINEERING PRIVATE LIMITED",
"WITMANS INDUSTRIES PRIVATE LIMITED",
"WITMATES TECHNOLOGIES PRIVATE LIMITED",
"WITS INTERACTIVE PRIVATE LIMITED",
"WITS INTERIOR PRIVATE LIMITED",
"WITT INDIA PRIVATE LIMITED",
"WITTMANN BATTENFELD INDIA PRIVATE LIMITED",
"WITTUR ELEVATOR COMPONENTS INDIA PRIVATE LIMITED",
"WITTY EDUCATION PRIVATE LIMITED",
"WITTY ENTERPRISES PRIVATE LIMITED",
"WITTY INTERNATIONAL SCHOOL",
"WITTYBRAINS SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"WITZEAL TECHNOLOGIES PRIVATE LIMITED",
"WITZENMANN INDIA PRIVATE LIMITED",
"WITZONE TECHNOLOGIES PRIVATE LIMITED",
"WIX COM INDIA PRIVATE LIMITED",
"WIXCON HEALTHCARE PRIVATE LIMITED",
"WIZ DIGITAL SERVICES PRIVATE LIMITED",
"WIZ LOGTEC INDIA PRIVATE LIMITED",
"WIZ PLAST PRIVATE LIMITED",
"WIZARD CORPORATE CONSULTANTS PRIVATE LIMITED",
"WIZARD DIGITEK COMPUTERS PRIVATE LIMITED",
"WIZARD E MARKETING PRIVATE LIMITED",
"WIZARD ESTATES PRIVATE LIMITED",
"WIZARD INDIA PRIVATE LIMITED",
"WIZARD INFOWAYS PRIVATE LIMITED",
"WIZARD RESTAURANTS PRIVATE LIMITED",
"WIZARD SECURITY SERVICES PRIVATE LIMITED",
"WIZARD TUBE & ENGINEERED COMPONENTS PRIVATE LIMITED",
"WIZARDRY INFRA PRIVATE LIMITED",
"WIZCOM TECHNOLOGIES PRIVATE LIMITED",
"WIZCURE MEDICAL DEVICES PRIVATE LIMITED",
"WIZCURE PHARMAA PRIVATE LIMITED",
"WIZDO TRAINING AND CONSULTING PRIVATE LIMITED",
"WIZE-MEN HR SERVICES PRIVATE LIMITED",
"WIZERGOS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"WIZERTECH INFORMATICS PRIVATE LIMITED",
"WIZFX COMMUNICATIONS PRIVATE LIMITED",
"WIZIE.COM INDIA PRIVATE LIMITED",
"WIZKLUB LEARNING PRIVATE LIMITED",
"WIZN SYSTEMS PRIVATE LIMITED",
"WIZNI SOFTWARE PRIVATE LIMITED",
"WIZPLEX PRIVATE LIMITED",
"WIZQART PRIVATE LIMITED",
"WIZSPK COMMUNICATION AND PR PRIVATE LIMITED",
"WIZTAG GLOBAL EXPORTS PRIVATE LIMITED",
"WIZTECH SERVICES PRIVATE LIMITED",
"WIZTOONZ ANIMATIONS PRIVATE LIMITED",
"WIZZRIDE TECHNOLOGIES PRIVATE LIMITED",
"WK ASSOCIATES LLP",
"WK LIFESTYLE INDIA PRIVATE LIMITED",
"WKM AUTOMOTIVE INDIA PRIVATE LIMITED",
"WK-SYSTEMS INDIA PRIVATE LIMITED",
"WKT LOGISTICS PRIVATE LIMITED",
"WLC COLLEGE INDIA LIMITED",
"WLDD PRIVATE LIMITED",
"WM DEVELOPERS PRIVATE LIMITED",
"WM ENERGY AND LIGHTING PRIVATE LIMITED",
"WM GLOBAL SOURCING INDIA PRIVATE LIMITED",
"WM GLOBAL TECHNOLOGY SERVICES INDIA PRIVATE LIMITED",
"WM LOGISTIC INDIA PRIVATE LIMITED",
"WM LOGISTICS INDIA PRIVATE LIMITED",
"WM TRAVEL SOLUTIONS PRIVATE LIMITED",
"WM UNIVERSAL SOLUTIONS PRIVATE LIMITED",
"WMD SERVICES INDIA PRIVATE LIMITED",
"EGIS ENGINEERING PRIVATE LIMITED",
"WMG WEALTH PRIVATE LIMITED",
"WMI POWER PRIVATE LIMITED",
"WMI REAL ESTATE DEVELOPERS LLP",
"WMS ENTERTAINMENT PRIVATE LIMITED",
"WMS SOLUTIONS PRIVATE LIMITED",
"WMS TECHNOLOGIES PRIVATE LIMITED",
"WMSS LABS (INDIA) PRIVATE LIMITED",
"WMT FILMS PRIVATE LIMITED",
"WMW EVENTS AND ENTERTAINMENT PRIVATE LIMITED",
"WMW METAL FABRICS LIMITED",
"WNET TELECOM PRIVATE LIMITED",
"WNS BUSINESS CONSULTING SERVICES PRIVATE LIMITED",
"WNS GLOBAL SERVICES PRIVATE LIMITED",
"WOAS TECHNOLOGY PRIVATE LIMITED",
"WOBOT INTELLIGENCE PRIVATE LIMITED",
"WOC SOLUTIONS PRIVATE LIMITED",
"WOCKHARDT FOUNDATION",
"WOCKHARDT GLOBAL SCHOOL",
"WOCKHARDT HOSPITALS LIMITED",
"WOCKHARDT INFRASTRUCTURE DEVELOPMENT LIMITED",
"WOCKHARDT LIMITED",
"WOCO TECH ELASTOMERE NOIDA LIMITED",
"WOCO TECH POLYMERE KANDLA LIMITED",
"WODEHOUSE CAPITAL ADVISORS PRIVATE LIMITED",
"WODEHOUSE GYMKHANA LIMITED",
"WOG TECHNOLOGIES PRIVATE LIMITED",
"WOHLER TECHNOLOGIES INDIA PRIVATE LIMITED",
"WOHLHAUPTER INDIA PRIVATE LIMITED",
"WOHLIG TRANSFORMATIONS PRIVATE LIMITED",
"WOHR PARKINGS SYSTEMS PRIVATE LIMITED",
"WOKE UP HOSPITALITY PRIVATE LIMITED",
"WOKNSTOVE FOODWORKS PRIVATE LIMITED",
"WOL 3D INDIA LIMITED",
"WOLCUT ABRASIVES INDUSTRIES PRIVATE LIMITED",
"WOLF PRECISION TOOLS INDIA PRIVATE LIMITED",
"WOLF SHADOW TRADERS PRIVATE LIMITED",
"WOLFFKRAFT DESIGN STUDIO (OPC) PRIVATE LIMITED",
"WOLKEM INDIA LIMITED",
"WOLKEM INDUSTRIES LIMITED",
"WOLKEN SOFTWARE PRIVATE LIMITED",
"WOLLAQUE VENTILATION AND CONDITIONING PVT LTD",
"WOLLAY BATH INDUSTRIES PRIVATE LIMITED",
"WOLLMILCHSAU TECHNOLOGIES PRIVATE LIMITED",
"WOLONG INDIA TECHNOLOGY PRIVATE LIMITED",
"WOLS LOGISTICS PRIVATE LIMITED",
"WOLTER VENTILATORS INDIA PRIVATE LIMITED",
"WOLTERS KLUWER (INDIA) PRIVATE LIMITED",
"WOLTERS KLUWER ELM SOLUTIONS PRIVATE LIMITED",
"WOLTERS KLUWER INDIA PRIVATE LIMITED",
"WOLTOP INDIA PRIVATE LIMITED",
"WOLVERINE WORLDWIDE INC.",
"WOLVES CREATA PRIVATE LIMITED",
"WOLVES RECRUITMENT AND STAFFING PRIVATE LIMITED",
"WOLWYN EXPORTS PRIVATE LIMITED",
"WOM RETAIL PRIVATE LIMITED",
"WOMANCART LIMITED",
"WOMANS ERA MEDIA PRIVATE LIMITED",
"WOMB LABORATORIES PVT.LTD.",
"WOMEN & CHILD DEVELOPMENT DEPARTMENT",
"WOMEN AND CHILD DEVELOPMENT DEPARTMENT",
"WOMEN AND CHILD DEVELOPMENT INTEGRATED CHILD DEV SCHEME",
"WOMEN AND CHILD DEVELOPMENT OFFICER INDORE",
"WOMEN AND CHILD DEVELOPMENT OFFICER SHAJAPUR",
"WOMEN AND CHILD DEVELOPMENT ZP LATUR",
"WOMEN CHILD DEVP DEPT-SECTETARIAT",
"WOMEN CHILD WELFARE DEPARTMENT",
"WOMEN CHILDREN HOSPITAL",
"WOMEN CHRISTIAN COLLEGE",
"WOMEN POLY TECHNIC COLLEGE - GOVT RAJ",
"WOMEN POWER FOODS PRIVATE LIMITED",
"WOMEN WELFARE DIRECTORATE",
"WOMENKA TRENDS PRIVATE LIMITED",
"WOMENS ARTS COMMERCE COLLEGE",
"WOMENS CENTRE AND HOSPITALS PRIVATE LIMITED",
"WOMENS CHRISTIAN COLLEGE",
"WOMEN'S INDIA PERSONAL CARE PRIVATE LIMITED",
"WOMENS NEXT LOUNGERIES LIMITED",
"WOMENS TECHNICAL EDUCATION",
"WON HOTELS PRIVATE LIMITED",
"WONDAR SALVAGE INDIA PRIVATE LIMITED",
"WONDER AGRITECH PRIVATE LIMITED",
"WONDER APPLIANCES PVT. LTD",
"WONDER BROTHERS TRADE PRIVATE LIMITED",
"WONDER CARS PRIVATE LIMITED",
"WONDER CEMENT LIMITED",
"WONDER CITY BUILDCON LIMITED",
"WONDER CLEAN EQUIPMENT PRIVATE LIMITED",
"WONDER CONSTRUCTION",
"WONDER CROP CARE PRIVATE LIMITED",
"WONDER DRUGS PRIVATE LIMITED",
"WONDER ELECTRICALS LIMITED",
"WONDER FACILITY SERVICES INDIA PRIVATE LIMITED",
"WONDER GLOBAL INDIA TECHNOLOGY CENTRE PRIVATE LIMITED",
"WONDER HOME FINANCE LIMITED",
"WONDER HYGIENE PRODUCTS PVT LTD",
"WONDER IMAGES PRIVATE LIMITED",
"WONDER INDUSTRIES PRIVATE LIMITED",
"WONDER INVESTMENT MANAGEMENT PRIVATE LIMITED.",
"WONDER MARKETING PRIVATE LIMITED",
"WONDER MARMOSTONES PRIVATE LIMITED",
"WONDER MINERALS PRIVATE LIMITED",
"WONDER PILLARS TECHNOLOGY PRIVATE LIMITED",
"WONDER POINT CREATIVE SOLUTIONS PRIVATE LIMITED",
"WONDER POLYMERS PRIVATE LIMITED",
"WONDER PRECISION PRIVATE LIMITED",
"WONDER PROJECTS DEVELOPMENT PRIVATE LIMITED",
"WONDER READY MIX CONCRETE PRIVATE LIMITED",
"WONDER SIGNS INDIA PRIVATE LIMITED",
"WONDER SYSTEMS ( INDIA) PRIVATE LIMITED",
"WONDER VALLEY RECREATIONS AND HOSPITALITY PRIVATE LIMITED",
"WONDER WASH PRIVATE LIMITED",
"WONDERBIZ TECHNOLOGIES PRIVATE LIMITED",
"WONDERBOTZ INDIA PRIVATE LIMITED",
"WONDERCHEF HOME APPLIANCES PRIVATE LIMITED",
"WONDERCUTS JEWELS PRIVATE LIMITED",
"WONDERDECOR PVT. LTD.",
"WONDERFAB PRIVATE LIMITED",
"WONDERFEX PROCESSING PRIVATE LIMITED",
"WONDERKIDS INDUSTRIES PRIVATE LIMITED",
"WONDERKIDS METRICS PRIVATE LIMITED",
"WONDERLA HOLIDAYS LIMITED",
"WONDERLAND ACADEMY OF EARLY LEARNING PRIVATE LIMITED",
"WONDERLAND AMUSEMENT PARKS PRIVATE LIMITED",
"WONDERLAND CONTRACTOR AND LABOUR SUPPLY PRIVATE LIMITED",
"WONDERLAND ENGLISH MEDIUM SCHOOL",
"WONDERLAND FOODS PRIVATE LIMITED",
"WONDERLAND RESIDENCY PRIVATE LIMITED",
"WONDERLAND SUPPLIERS PRIVATE LIMITED",
"WONDERLEND HUBS PRIVATE LIMITED",
"WONDERMART SUPERMARKET PRIVATE LIMITED",
"WONDERMONT INDUSTRIES PRIVATE LIMITED",
"WONDERSOFT PRIVATE LIMITED",
"WONDRLAB INDIA PRIVATE LIMITED",
"WONDROUS ADWORLD PRIVATE LIMITED",
"WONE CREATIONS PRIVATE LIMITED",
"WONE MANAGEMENT SYSTEMS PRIVATE LIMITED",
"WONESE INDIA PRIVATE LIMITED",
"WONEX LOGISTICS AND WAREHOUSING PRIVATE LIMITED",
"WONIRY ELECTRONICS PRIVATE LIMITED",
"WONJIN AUTOPARTS INDIA PRIVATE LIMITED",
"WONKSKNOW TECHNOLOGIES INDIA PRIVATE LIMITED",
"WONSET HEALTH CARE PRIVATE LIMITED",
"WONTECH ENGINEERING PRIVATE LIMITED",
"WOOD BARN INDIA PRIVATE LIMITED",
"WOOD CAPITAL FINANCE LIMITED",
"WOOD CRAFT PROJECTS PRIVATE LIMITED",
"WOOD GRIP INDUISTRIES PRIVATE LIMITED",
"WOOD GROUP KENNY INDIA PRIVATE LIMITED",
"WOOD GROUP PSN INDIA PRIVATE LIMITED",
"WOOD INDIA ENGINEERING & PROJECTS PRIVATE LIMITED",
"WOOD LAMINATES PVT LTD",
"WOOD LAND BOARDS PRIVATE LIMITED",
"WOOD MART INTERIOR PRIVATE LIMITED",
"WOOD SQUARE TECHNOLOGIES PRIVATE LIMITED",
"WOODALL INDIA PRIVATE LIMITED",
"WOODAPPLE INTERACTIVE PRIVATE LIMITED",
"WOODBINE FLORET PUBLIC SCHOOL",
"WOODBRIAR ESTATE LIMITED",
"WOODBRIDGE FOAM PRIVATE LIMITED",
"WOODFIELD SYSTEMS INTERNATIONAL PRIVATE LIMITED",
"WOODFUR ART & DESIGN PRIVATE LIMITED",
"WOODHILL INFRASTRUCTURE LIMITED",
"WOODKRAFT (INDIA) PRIVATE LIMITED",
"WOODKRAFT KITCHEN INDIA PRIVATE LIMITED",
"WOODLAND FARMS PVT LTD",
"WOODLAND HOSPITALS PRIVATE LIMITED",
"WOODLAND IMPEX PRIVATE LIMITED",
"WOODLAND MARKETING PRIVATE LIMITED.",
"WOODLAND RETAILS PRIVATE LIMITED",
"WOODLAND WORKS INDIA PRIVATE LIMITED",
"WOODLANDS HOTELS PRIVATE LIMITED",
"WOODLANDS HOUSING PRIVATE LIMITED",
"WOODLANDS MULTISPECIALITY HOSPITAL LIMITED",
"WOODLARK PACKAGING PRIVATE LIMITED",
"WOODMAN ELECTRONICS INDIA PRIVATE LIMITED",
"WOODMASTER INDIA MACHINES PRIVATE LIMITED",
"WOODNESS POETREE PRIVATE LIMITED",
"WOODNEST DEVELOPERS PRIVATE LIMITED",
"WOODOFA LIFESTYLE PRIVATE LIMITED",
"WOODPECKER BAGS PRIVATE LIMITED",
"WOODPECKER BIOENERGY PRIVATE LIMITED",
"WOODPECKER DISTILLERIES & BREWERIES PRIVATE LIMITED",
"WOODPECKER MACHINES INDIA PRIVATE LIMITED",
"WOODPECKERS HOMES PRIVATE LIMITED",
"WOODPECKERS INDIA PRIVATE LIMITED",
"WOODRIDGE HIGH SCHOOL",
"WOODROCK HOTELS PRIVATE LIMITED",
"WOODS AND WEAVES FURNITURE PRIVATE LIMITED",
"WOODSHADE BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"WOODSIDE FASHIONS LIMITED",
"WOODSIDE PARKS LIMITED",
"WOODSMITH KRAFTS PRIVATE LIMITED",
"WOODSTOCK BROKING PRIVATE LIMITED",
"WOODSTOCK HELICOPTERS PRIVATE LIMITED",
"WOODSTOCK LAMINATES LIMITED",
"WOODSTOCK MERCHANDISING PRIVATE LIMITED",
"WOODSTOCK REALTIES PRIVATE LIMITED",
"WOODSTOCK SCHOOL",
"WOODSVILLA LIMITED",
"WOODTECH CONSULTANTS PRIVATE LIMITED",
"WOODVER COATINGS PRIVATE LIMITED",
"WOODWARD INDIA PRIVATE LIMITED",
"WOODZON INTEGRATIVE BUSINESS SOLUTIONS PRIVATE LIMITED",
"WOOH SHARE TRADING PRIVATE LIMITED",
"WOOHYUN ENG INDIA PRIVATE LIMITED",
"WOOJIN AUTOMOTIVE INDIA PRIVATE LIMITED",
"WOOLEN PROCESSOR PRIVATE LIMITED",
"WOOLLY FARMS PRIVATE LIMITED",
"WOOLSHEEL TRADERS PRIVATE LIMITED",
"WOOLTEX EXIM PRIVATE LIMITED.",
"WOON KA SAGAR VASTRAM PRIVATE LIMITED",
"WOOPLR TECHNOLOGIES PRIVATE LIMITED",
"WOORI BANK",
"WOORY AUTOMOTIVES INDIA PRIVATE LIMITED",
"WOOSHIN ENGINEERING PRIVATE LIMITED",
"WOOSHIN SAFETY SYSTEMS INDIA PRIVATE LIMITED",
"WOOST INTERNET PRIVATE LIMITED",
"WOOSU AUTOMOTIVE INDIA PRIVATE LIMITED",
"WOOTU NUTRITION PRIVATE LIMITED",
"WOOTZ METAL SOLUTIONS INDIA PRIVATE LIMITED",
"WOOTZ STRUCTURES PRIVATE LIMITED",
"WOOYOUNG AUTOMOTIVE INDIA PRIVATE LIMITED",
"WORD AND DEED INDIA",
"WORDBOX SERVICES PRIVATE LIMITED",
"WORDS & WORTHS BOOKS PRIVATE LIMITED",
"WORDSMAYA EDUTECH PRIVATE LIMITED",
"WORDSWORK LLP",
"WORDSYS INFORMATION TECHNOLOGY PRIVATE LIMITED",
"WORIOX INDIA LOGISTICS PRIVATE LIMITED",
"WORIUR BENEFIT FUND NIDHI LIMITED",
"WORK & BENCH TOOLS INDIA PRIVATE LIMITED",
"WORK ADVANTAGE PRIVATE LIMITED",
"WORK BETTER TRAINING PRIVATE LIMITED",
"WORK DIVISION III (PHE) PWD",
"WORK EASY SPACE SOLUTIONS PRIVATE LIMITED",
"WORK PLACE INTERIOR PRIVATE LIMITED",
"WORK SPACE SOLUTIONS INDIA PRIVATE LIMITED",
"WORK STATION SYSTEMS PRIVATE LIMITED",
"WORK STORE LIMITED",
"WORK VENTURES EXPERIENTIAL MARKETING PRIVATE LIMITED",
"WORKAMP SPACES PRIVATE LIMITED",
"WORKAPPS PRODUCT SOLUTIONS PRIVATE LIMITED",
"WORKAPPS SOLUTIONS PRIVATE LIMITED",
"WORKCELL SOLUTIONS PRIVATE LIMITED",
"WORKDAY INDIA PRIVATE LIMITED",
"WORKENSTEIN COLLABORATIVE SPACES LLP",
"WORKENSTEIN COLLABORATIVESPACES PRIVATE LIMITED",
"WORKEX SOLUTIONS AND SERVICES PRIVATE LIMITED",
"WORKFLOWLABS PRIVATE LIMITED",
"WORKFORCE ADVISORY PRIVATE LIMITED",
"WORKFORCE CLOUD TECH INDIA PRIVATE LIMITED",
"WORKFORCE INIDA PRIVATE LIMITED",
"WORKFORCE LOGIQ INDIA PRIVATE LIMITED",
"WORKFORCE SOLUTIONS INDIA PRIVATE LIMITED",
"WORKFUSION INDIA PRIVATE LIMITED",
"WORKGEN SOLUTIONS PRIVATE LIMITED",
"WORKINGDOM OFFICE SOLUTIONS PRIVATE LIMITED",
"WORKLINE PRIVATE LIMITED",
"WORKLLAMA SOFTWARE PRIVATE LIMITED",
"WORKLY MANAGEMENT SERVICES PRIVATE LIMITED",
"WORKMATES CORE2CLOUD SOLUTION PRIVATE LIMITED",
"WORKPARK PRIVATE LIMITED",
"WORKPLACE ESSENTIALS PRIVATE LIMITED",
"WORKPLACE FABRIC INDIA PRIVATE LIMITED",
"WORKPLACE OPTIONS INDIA PRIVATE LIMITED",
"WORKPLACE SOLUTIONS PRIVATE LIMITED",
"WORKPLACE SYNERGIES PRIVATE LIMITED",
"WORKPULSE SOFTWARE PRIVATE LIMITED",
"WORKS DEPARTMENT GOVERNMENT OF ODISHA",
"WORKS DIVISION XV (NH) PUBLIC WORKS DEPARTMENT",
"WORKSENT TECHNOLOGIES PRIVATE LIMITED",
"WORKSOL SERVICES PRIVATE LIMITED",
"WORKSOURCE PROFESSIONAL",
"WORKSPACE BUSINESS SERVICES PRIVATE LIMITED",
"WORKSPACE METAL SOLUTIONS PRIVATE LIMITED",
"WORKSPACE OFFICE SOLUTIONS PRIVATE LIMITED",
"WORKSPHERE VENTURES INDIA PRIVATE LIMITED",
"WORKSPOT PRIVATE LIMITED",
"WORKSTUDY HYDRAULICS PRIVATE LIMITED",
"WORKSUREMEDPHARMA CONSULTANCY INDIA PRIVATE LIMITED",
"WORKVED SPACES PRIVATE LIMITED",
"WORKWINGS ACCELERATORS PRIVATE LIMITED",
"WORKXMART BUSINESS SOLUTIONS PRIVATE LIMITED",
"WORLD 13 DISTRIBUTIONS PRIVATE LIMITED",
"WORLD AGRI SOLUTIONS PRIVATE LIMITED",
"WORLD AIR & FOREX PRIVATE LIMITED",
"WORLD BHARUCHI VAHORA FEDERATION",
"WORLD BRAIN CENTER AND RESEARCH INSTITUTE",
"WORLD BRANDS & TRENDS PRIVATE LIMITED",
"WORLD CARGO INDIA PRIVATE LIMITED",
"WORLD CHEM INDUSTRIES PRIVATE LIMITED",
"WORLD CLASS AUTOMOBILES PRIVATE LIMITED",
"WORLD CLASS SERVICES LIMITED",
"WORLD CLASS SERVICES PRIVATE LIMITED",
"WORLD COLOPROCTOLOGY (OPC) PRIVATE LIMITED",
"WORLD COMPLIANCE TECHNOLOGIES PRIVATE LIMITED",
"WORLD CONNECT PRIVATE LIMITED",
"WORLD CONSTRUCTION COMPANY PRIVATE LIMITED",
"WORLD COURIER INDIA PRIVATE LIMITED",
"WORLD DATA TRAFFIC TECH PRIVATE LIMITED",
"WORLD EXPEDITIONS INDIAPRIVATE LIMITED",
"WORLD FASHION EXCHANGE (INDIA) PRIVATE LIMITED",
"WORLD FUEL SERVICES CORPORATION",
"WORLD GAS (INDIA) PRIVATE LIMITED (OPC)",
"WORLD GOLD COUNCIL (INDIA) PRIVATE LIMITED",
"WORLD GURU ENGIFAB PRIVATE LIMITED",
"WORLD HEALTH ORGANISATION",
"WORLD HUMAN RIGHTS PROTECTION COMMISSION",
"WORLD INFERTILITY & IVF CENTRE",
"WORLD IT CONSULTING PRIVATE LIMITED",
"WORLD LEARNING INDIA PRIVATE LIMITED",
"WORLD LINE INDIA PRIVATE LIMITED",
"WORLD MEDIA PRIVATE LIMITED",
"WORLD MEMON ORGANIZATION",
"WORLD MOBILE NEWS NETWORK PRIVATE LIMITED",
"WORLD NATURAL WELLNESS PRIVATE LIMITED",
"WORLD NICE AUTOMOBILES PRIVATE LIMITED",
"WORLD OF ORGANICS GLOBAL PRIVATE LIMITED",
"WORLD OF SHALOM RESTAURANTS PRIVATE LIMITED",
"WORLD OF STONES PRIVATE LIMITED",
"WORLD OF WONDERS TRAVEL PRIVATE LIMITED",
"WORLD ONE INDIA FOREX PRIVATE LIMITED",
"WORLD ONE SOLUTIONS PRIVATE LIMITED",
"WORLD OVERSEAS ADVISOR",
"WORLD PACK AUTOMATION SYSTEMS PRIVATE LIMITED",
"WORLD PARCEL XPRESS PRIVATE LIMITED",
"WORLD PEACE INTERNATIONAL INDIA PRIVATE LIMITED",
"WORLD PHONE INDIA PRIVATE LIMITED",
"WORLD PHONE INTERNET SERVICES PRIVATE LIMITED",
"WORLD PHONE IT SERVICES PRIVATE LIMITED",
"WORLD PRANIC HEALING INDIA PRIVATE LIMITED",
"WORLD RESOURCES INSTITUTE INDIA PRIVATE UNLIMITED",
"WORLD SEALANTS PRIVATE LIMITED",
"WORLD STEEL TECH INDIA PRIVATE LIMITED",
"WORLD TECHNOLOGICAL PRODUCTS PRIVATE LIMITED",
"WORLD TRADE LOGISTICS PRIVATE LIMITED",
"WORLD TRADE PARK LIMITED",
"WORLD VIEW SHIPPING & LOGISTICS PRIVATE LIMITED",
"WORLD VISION INDIA",
"WORLD VISION TRAVELS PRIVATE LIMITED",
"WORLD WATER WORKS INDIA PRIVATE LIMITED",
"WORLD WEB TECHNOLOGY PRIVATE LIMITED",
"WORLD WIDE ADVENTURES INDIA PRIVATE LIMITED",
"WORLD WIDE CARRIERS PRIVATE LIMITED",
"WORLD WIDE IRON AND STEELS PRIVATE LIMITED",
"WORLD WIDE LOGISTICS INDIA PRIVATE LIMITED",
"WORLD WIDE PRODUCTS PRIVATE LIMITED",
"WORLD ZONE LOGISTICS PRIVATE LIMITED",
"WORLDBOX SHIPPING PRIVATE LIMITED",
"WORLDCLASS GOURMETFOODS PRIVATE LIMITED",
"WORLDEMP INDIA PRIVATE LIMITED",
"WORLDEX COURIER AND CARGO PRIVATE LIMITED",
"WORLDEX INDIA EXHIBITION AND PROMOTION PRIVATE LIMITED",
"WORLDFA EXPORTS PRIVATE LIMITED",
"WORLDGATE EXPRESS LINES INTERNATIONAL PRIVATE LIMITED",
"WORLDHAUS INDIA PRIVATE LIMITED",
"WORLDINFORMATIX CYBER SECURITY INDIA PRIVATE",
"WORLDLINE EPAYMENTS INDIA PRIVATE LIMITED",
"WORLDLINE GLOBAL SERVICES PRIVATE LIMITED",
"WORLDLINE INDIA PRIVATE LIMITED",
"WORLDLINE LOGISTICS PRIVATE LIMITED",
"WORLDLOOKS TRAVEL AND FOREX PRIVATE LIMITED",
"WORLDPAY INDIA PRIVATE LIMITED",
"WORLDQUANT RESEARCH (INDIA) PRIVATE LIMITED",
"WORLDS WINDOW INFRASTRUCTURE AND LOGISTICS PRIVATE LIMITED",
"WORLDS WINDOW WARDHA INFRASTRUCTURE PRIVATE LIMITED",
"WORLDSOURCE HEALTHCARE INDIA PRIVATE LIMITED",
"WORLDSTAR EDUCATION PRIVATE LIMITED",
"WORLDSTAR SHIPPING SERVICES INDIA PRIVATE LIMITED",
"WORLDTANKERS CREWING INDIA PRIVATE LIMITED",
"WORLDTECH GLASS PRIVATE LIMITED",
"WORLDTECH INDUSTRIES PRIVATE LIMITED",
"WORLDTECH SOFTWARE SOLUTIONS PRIVATE LIMITED",
"WORLDTRAVEL STUDIO HNV PRIVATE LIMITED",
"WORLDTRON LOGISTICS INTERNATIONAL PRIVATE LIMITED",
"WORLDVICTORY MART PRIVATE LIMITED",
"WORLDVIEWER DOT COM INDIA PRIVATE LIMITED",
"WORLDWIDE ALUMINIUM LIMITED",
"WORLDWIDE AUTOCRAFT PRIVATE LIMITED",
"WORLDWIDE AUTOMOTIVE WORKS PRIVATE LIMITED",
"WORLDWIDE AUTOZONE PRIVATE LIMITED",
"WORLDWIDE BEVERAGES PRIVATE LIMITED",
"WORLDWIDE BMO CONSULTANTS PRIVATE LIMITED",
"WORLDWIDE BUSINESS MANAGEMENT OUTSOURCING PRIVATE LIMITED",
"WORLDWIDE COMMTRADE PRIVATE LIMITED",
"WORLDWIDE CONTAINER TRADING PRIVATE LIMITED",
"WORLDWIDE CRICKET COMPANY PRIVATE LIMITED",
"WORLDWIDE DIAMOND AND JEWELLERY MANUFACTURERS PRIVATE LIMITED",
"WORLDWIDE DIAMOND MANUFACTURERS PRIVATE LIMITED",
"WORLDWIDE DIAMOND SORTING PRIVATE LIMITED",
"WORLDWIDE ESTORIES PRIVATE LIMITED",
"WORLDWIDE FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"WORLDWIDE FREIGHT SOLUTIONS PRIVATE LIMITED",
"WORLDWIDE HOLDINGS LIMITED",
"WORLDWIDE INSURANCE BROKERS LIMITED",
"WORLDWIDE LINE PRIVATE LIMITED",
"WORLDWIDE LOGISTICS (INDIA) PRIVATE LIMITED",
"WORLDWIDE MACHINERY SOLUTIONS PRIVATE LIMITED",
"WORLDWIDE MEDIA PRIVATE LIMITED",
"WORLDWIDE MOVERS PRIVATE LIMITED",
"WORLDWIDE OILFIELD MACHINE PRIVATE LIMITED",
"WORLDWIDE ONLINE SERVICES PRIVATE LIMITED",
"WORLDWIDE REALCON PRIVATE LIMITED",
"WORLDWIDE SAFETY PRIVATE LIMITED",
"WORLDWIDE SECURITY SYSTEMS AND CONSULTAN TS PRIVATE LIMITED",
"WORLDWIDE SMALL DIAMONDS MANUFACTURING PRIVATE LIMITED",
"WORLDWYN PRIVATE LIMITED",
"WORLEY INDIA PRIVATE LIMITED",
"WORLEY SERVICES INDIA PRIVATE LIMITED",
"WORLI INDUSTRIAL PROPERTIES LIMITED",
"WORSHIP INFRAPROJECTS PRIVATE LIMITED",
"WORTGAGE FINANCE PRIVATE LIMITED",
"WORTH CART PRIVATE LIMITED",
"WORTH CORPORATE SOLUTIONS PRIVATE LIMITED",
"WORTH INFRA INDUSTRIES PRIVATE LIMITED",
"WORTH MEDICINES INDIA PRIVATE LIMITED",
"WORTH OF WASTE PRIVATE LIMITED",
"WORTH PERIPHERALS LIMITED",
"WORTHWELL PAPERS PRIVATE LIMITED",
"WORTHWHILE PROPERTIES PRIVATE LIMITED",
"WORTHWILL FOAM INDIA PRIVATE LIMITED",
"WORTHY TEA CO PVT LTD",
"WORXOGO SOLUTIONS PRIVATE LIMITED",
"WORXWIDE CONSULTING PRIVATE LIMITED",
"WOSON INDIA PRIVATE LIMITED",
"WOUND COMPONENT PRIVATE LIMITED",
"WOUNDTECH INNOVATIVE HEALTHCARE SOLUTIONS PRIVATE LIMITED",
"WOURECHT ENTERPRISES (OPC) PRIVATE LIMITED",
"WOV TRAVEL COMPANY PRIVATE LIMITED",
"WOVEN DREAMS LIMITED",
"WOVEN GOLD ACRYLIC INDIA PRIVATE LIMITED",
"WOVENTEX INDIA PRIVATE LIMITED",
"WOW DESIGN PRIVATE LIMITED",
"WOW ECARTS PRIVATE LIMITED",
"WOW ENTERTAINMENT AND MEDIA PRIVATE LIMITED",
"WOW EQUIPMENT & INFRA PRIVATE LIMITED",
"WOW HOME SOLUTIONS PRIVATE LIMITED",
"WOW HOTELS PRIVATE LIMITED",
"WOW INDIA TRAVEL & TOURS PRIVATE LIMITED",
"WOW JOBS PRIVATE LIMITED",
"WOW JOURNEYS PRIVATE LIMITED",
"WOW LADDUS PRIVATE LIMITED",
"WOW MOMO FOODS PRIVATE LIMITED",
"WOW OVERSEAS PRIVATE LIMITED",
"WOW PUBLISHINGS PRIVATE LIMITED",
"WOW SHARED SPACES PRIVATE LIMITED",
"WOW SOFTECH PRIVATE LIMITED",
"WOW STONIC PRIVATE LIMITED",
"WOW VISION INDIA PRIVATE LIMITED",
"WOWONI PRIVATE LIMITED",
"WOWTRUCK TECHNOLOGIES PRIVATE LIMITED",
"WOX COOLERS PRIVATE LIMITED",
"WOXA TECHNOLOGIES PRIVATE LIMITED",
"WOXMEN BIO TECHNOLOGIES PRIVATE LIMITED",
"WOXSEN UNIVERSITY",
"WOXWAX SOLUTIONS PRIVATE LIMITED",
"WPA WORLD CLASS SERVICES INDIA PRIVATE LIMITED",
"WPG C&C COMPUTERS AND PERIPHERAL (INDIA) PRIVATE LIMITED",
"WPG INDIA ELECTRONICS PRIVATE LIMITED",
"WPI INDIA DEVELOPMENT PRIVATE LIMITED",
"WPIL LIMITED",
"WPP INDIA CORPORATE SOCIAL RESPONSIBILITY FOUNDATION",
"WPP MARKETING COMMUNICATIONS INDIA PRIVATE LIMITED",
"WR AHMEDABAD DIVISION",
"WRAP (INDIA) POLYMERS PRIVATE LIMITED",
"WRAP ART & DESIGN PRIVATE LIMITED",
"WRAP FASHION PRIVATE LIMITED",
"WRAPOTEX INTERNATIONAL PRIVATE LIMITED",
"WRAPTECH MACHINES PRIVATE LIMITED",
"WRAPWELL PACKAGING PRIVATE LIMITED",
"WRC ENGINEERING COMPANY PRIVATE LIMITED",
"WRECKER JEANS CASUALS PRIVATE LIMITED",
"WRELTT INDIA PRIVATE LIMITED",
"WRENCH INDIA TECHNOLOGIES PRIVATE LIMITED",
"WRENCH SOLUTIONS PRIVATE LIMITED",
"WRENCHITUP FACILITY MANAGEMENT PRIVATE LIMITED",
"WRENSEVEN TECHNO SOLUTIONS PRIVATE LIMITED",
"WREST HEALTHCARE PRIVATE LIMITED",
"WRI PENS PRIVATE LIMITED",
"WRIG NANOSYSTEMS PRIVATE LIMITED",
"WRIGGLE ENTERPRISES PRIVATE LIMITED",
"WRIGHT INDUSTRIES PRIVATE LIMITED",
"WRIGHT SHORE TECHNOLOGIES PRIVATE LIMITED",
"WRIGHTSPACES INDIA PRIVATE LIMITED",
"WRIGLEY INDIA PRIVATE LIMITED",
"WRINKLE CART PACKAGES PVT LTD",
"WRINKLE DISTRIBUTORS PRIVATE LIMITED",
"WRINKLE TIEUP PRIVATE LIMITED",
"WRIR ADVISORS LLP",
"WRITAX DISTRIBUTION PRIVATE LIMITED",
"WRITE IT SOLUTIONS PRIVATE LIMITED",
"WRITEMEN MEDIA PRIVATE LIMITED",
"WRITER BUSINESS SERVICES PRIVATE LIMITED",
"WRITER LOGISTICS PRIVATE LIMITED",
"WRITER SAFEGUARD PRIVATE LIMITED",
"WRITERS AND PUBLISHERS PRIVATE LIMITED",
"WRITTENLYHUB PRIVATE LIMITED",
"WRITTER NOTEBOOK PRIVATE LIMITED",
"WRKINTEL PRIVATE LIMITED",
"WRKSPOT TECHNOLOGIES INDIA PRIVATE LIMITED",
"WROCUS TECHNOLOGIES PRIVATE LIMITED",
"WROFFY TECHNOLOGIES PRIVATE LIMITED",
"WROOTS GLOBAL PRIVATE LIMITED",
"WRS INFO INDIA PRIVATE LIMITED",
"WRSS XXI (A) TRANSCO LIMITED",
"WRY RAJEEV HOSPITAL",
"WRYGHT RESEARCH & CAPITAL PRIVATE LIMITED",
"WRYHTA BUILDERS AND DEVELOPERS PRIVATE LIMITED",
"WS FOODS PRIVATE LIMITED",
"WS LIFESTYLE PRIVATE LIMITED",
"WS RETAIL SERVICES PRIVATE LIMITED",
"WSA SHIPPING BOMBAY PRIVATE LIMITED",
"WSB REAL ESTATE PARTNERS PRIVATE LIMITED",
"WSD CONSULTANT PRIVATE LIMITED",
"WSE POLYZAP PRIVATE LIMITED",
"WSERVE TECHNOLOGIES PRIVATE LIMITED",
"WSFX GLOBAL PAY LIMITED",
"WSG VENTURES PRIVATE LIMITED",
"WSL AUTOMOBILES PRIVATE LIMITED",
"WSMI FOREX PRIVATE LIMITED",
"WSP CONSULTANTS INDIA PRIVATE LIMITED",
"WSS SECURITY SOLUTIONS PRIVATE LIMITED",
"WST TECHNOLOGIES PRIVATE LIMITED",
"WT E-BOOKS PRIVATE LIMITED",
"WT MICROELECTRONICS INDIA PRIVATE LIMITED",
"WT MICROELECTRONICS SINGAPORE PTE LIMITED",
"WTC APPARELS (OPC) PRIVATE LIMITED",
"WTC ENTERPRISES PRIVATE LIMITED",
"WTC NOIDA DEVELOPMENT COMPANY PRIVATE LIMITED",
"WTC TRADES & PROJECTS PRIVATE LIMITED",
"WTE INFRA PROJECTS PRIVATE LIMITED",
"WTI TRANSCRIPTIONS INDIA PRIVATE LIMITED",
"WTL GARMENTS PRIVATE LIMITED",
"WTP COST ADVISORY SERVICES INDIA PRIVATE LIMITED",
"WTS INDIA PRIVATE LIMITED",
"WTS TRAVEL SERVICES PRIVATE LIMITED",
"WTSLN FINTECH PRIVATE LIMITED",
"WTVISION SOLUTIONS PRIVATE LIMITED",
"WTW GLOBAL DELIVERY AND SOLUTIONS INDIA PRIVATE LIMITED",
"WU TECHNOLOGY ENGINEERING SERVICES PRIVATE LIMITED",
"WUDAPPLE IMPEX AND TRADES PRIVATE LIMITED",
"WUDHOUSE DESIGNS PRIVATE LIMITED",
"WUDS MEDIA PRIVATE LIMITED",
"WUERTH ELEKTRONIK CBT INDIA PRIVATE LIMI TED",
"WUERTH ELEKTRONIK INDIA PRIVATE LIMITED",
"WUERTH INDIA PRIVATE LIMITED",
"WUERTH INDUSTRIAL SERVICES INDIA PRIVATE LIMITED",
"WUHUAN ENGINEERING CO. LTD",
"WULAR INFRASTRUCTURE PRIVATE LIMITED",
"WULFPAK MARKETING SERVICES PRIVATE LIMITED",
"WULROTI EQUIPMENT SOLUTIONS PRIVATE LIMITED",
"WUNDER CONTROL AND SWITCH GEAR PRIVATE LIMITED",
"WUNDERBAKED TECHNOLOGIES PRIVATE LIMITED",
"WUNDERBAR KIDS PRIVATE LIMITED",
"WUNDERKIND INNOVATIONS PRIVATE LIMITED",
"WUNDERMAN INDIA PRIVATE LIMITED",
"WUNDERMAN THOMPSON COMMERCE PRIVATE LIMITED",
"WUNDERZ PHARMACEUTICALS PRIVATE LIMITED",
"WURFEL LIVING PRIVATE LIMITED",
"WURTH ELECTRONICS SERVICES INDIA PRIVATE LIMITED",
"WURTH INFORMATION TECHNOLOGY INDIA PRIVATE LIMITED",
"WURZEL INTERNO PRIVATE LIMITED",
"WURZEN NUTRACEUTICALS PRIVATE LIMITED",
"WUTONG TELECOMMUNICATIONS INDIA PRIVATE LIMITED",
"WVL INFRASTRUCTURE PRIVATE LIMITED",
"WVP SERVICES PRIVATE LIMITED",
"WVT ELEVATORS PRIVATE LIMITED",
"WW DEFSYS PRIVATE LIMITED",
"WW INFRA PROJECT PRIVATE LIMITED",
"WW SHIPPING AGENCIES PRIVATE LIMITED.",
"WWC WAREHOUSE PRIVATE LIMITED",
"WWES IT SOLUTIONS PRIVATE LIMITED",
"W-WESTERN PRODUCTS PRIVATE LIMITED",
"WWF SECYRITY SERVICES PRIVATE LIMITED",
"WWH INDIA PRIVATE LIMITED",
"WWICS ESTATES PRIVATE LIMITED",
"WWICS GLOBAL LAW OFFICES PRIVATE LIMITED",
"WWICS RESORTS PRIVATE LIMITED",
"WWL CENTRE FOR LOGISTICS EXCELLENCE PRIVATE LIMITED",
"WWL INDIA PRIVATE LIMITED",
"WWL TRANSPORT SOLUTIONS INDIA PRIVATE LIMITED",
"WWS SKYSHOP PRIVATE LIMITED",
"WWSO SECURITY AND FACILITY LIMITED",
"WWSTAY SERVICES INDIA PRIVATE LIMITED",
"WWT INDIA PRIVATE LIMITED",
"WWW BMINDS TECHNOLOGIES PRIVATE LIMITED",
"WYAN INDUSTRIES PRIVATE. LIMITED.",
"WYATTPRISM COMMUNICATIONS PRIVATE LIMITED",
"WYBE SPACES PRIVATE LIMITED",
"WYBOR TECH PRIVATE LIMITED.",
"WYCH ELM LABORATORIES LIMITED",
"WYETH-AYERST INTERNATIONAL LLC",
"WYLIE INDICATORS LIMITED",
"WYN VENTURES PRIVATE LIMITED",
"WYNBI SOLUTIONS PRIVATE LIMITED",
"WYNCLARK PHARMACEUTICALS PRIVATE LIMITED",
"WYNDHAM CHANDIGARH MOHALI",
"WYNDHAM HOTELS & RESORTS INDIA PRIVATE LIMITED",
"WYNNCOM DIGITAL DEVICES PRIVATE LIMITED",
"WYNTRONIX INNOVATIONS PRIVATE LIMITED",
"WYNUM AUTOMATION SERVICES PRIVATE LIMITED",
"WYP BRAND SOLUTIONS PRIVATE LIMITED",
"WYSETEK SYSTEMS TECHNOLOGISTS PRIVATE LIMITED",
"WYSIWYG EVENTS PRIVATE LIMITED",
"WYTE PRINT INDIA PRIVATE LIMITED",
"WYTECH PHARMACEUTICALS PRIVATE LIMITED",
"WYWID ZONE PRIVATE LIMITED",
"WYZEN SYSTEMS PRIVATE LIMITED",
"WYZMINDZ SOLUTIONS PRIVATE LIMITED",
"X & O CLOTHING PRIVATE LIMITED",
"X I SECURITY SYSTEMS PRIVATE LIMITED",
"X PLOR MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"X SECURITY SERVICE PRIVATE LIMITED",
"X0PA AI PRIVATE LIMITED",
"X2 LOGICS STAFFING SOLUTION PRIVATE LIMITED",
"X360 SOFTWARE SOLUTIONS PRIVATE LIMITED",
"XAAS INFOTECH PRIVATE LIMITED",
"XAASABILITY LABS PRIVATE LIMITED",
"XABIERS INSTITUTE OF BUSINESS MANAGEMENT STUDIES",
"XACA TECHNOLOGIES SOLUTION OPC PRIVATE LIMITED",
"XACT DATA DISCOVERY INDIA PRIVATE LIMITED",
"XACT SPECIAL STEELS PRIVATE LIMITED",
"XACTLY TECHNOLOGIES INDIA PRIVATE LIMITED",
"XACTON LOGISTIC SERVICES PRIVATE LIMITED",
"XAGE COMMUNICATION INDIA PRIVATE LIMITED",
"XAL INDIA PRIVATE LIMITED",
"XAL TOOL INDIA PRIVATE LIMITED",
"XALTED INFORMATION SYSTEMS PRIVATE LIMITED",
"XANADU FOODS LIMITED",
"XANADU REALTY LIMITED",
"XANADU REALTY MANAGEMENT PRIVATE LIMITED",
"XANADU REALTY PRIVATE LIMITED",
"XANADUTEC DATA SOLUTIONS PRIVATE LIMITED",
"XANDARI PEARL BEACH RESORTS PRIVATE LIMITED",
"XANDER ADVISORS INDIA PRIVATE LIMITED.",
"XANDER CONSULTING AND ADVISORY PRIVATE LIMITED",
"XANDER FINANCE PRIVATE LIMITED",
"XANDR INDIA PRIVATE LIMITED",
"XANGARS INFRATECH SOLUTIONS PRIVATE LIMITED",
"HONEYBEE TECH SOLUTIONS PRIVATE LIMITED",
"XANGBO TRADING (INDIA) PRIVATE LIMITED",
"XANTHIPPE CREATIONS PRIVATE LIMITED",
"XANTI COMMERCIAL PRIVATE LIMITED",
"XAPADS MEDIA PRIVATE LIMITED",
"XAPER WASTE SOLUTIONS PRIVATE LIMITED",
"XAPLE TECHNOLOGY PRIVATE LIMITED",
"XARLESYS INFRATECH PRIVATE LIMITED",
"XARPIE LABS LLP",
"XASCOM INFO SOLUTIONS LLP",
"XAVI BIOTECH PRIVATE LIMITED",
"XAVICA SOFTWARE SOLUTIONS PRIVATE LIMITED",
"XAVIENT INFORMATION SYSTEMS INDIA PRIVATE LIMITED",
"XAVIENT INFOTECH PRIVATE LIMITED",
"XAVIENT SOFTWARE SOLUTIONS (INDIA) PRIVATE LIMITED",
"XAVIER CHILD DEVELOPMENT CENTRE",
"XAVIER EDUCATIONAL SERVICES AND TECHNOLOGY PRIVATE LIMITED",
"XAVIER INSTITUTE OF MANAGEMENT & ENTREPRENEURSHIP XIME",
"XAVIER KIDS THE ULTIMATE SCHOOL",
"XAVIER LABOUR RELATIONS INSTITUTE",
"XAVIER MED PRIVATE LIMITED",
"XAVIER MOTORS PRIVATE LIMITED",
"XAVIER SCHOOL OF MANAGEMENT",
"XAVIERIAN HIGH SCHOOL",
"XAVIERS EXPORT IMPORT MANAGEMENT INSTITUTE",
"XAVIERS INSTITUTE OF BUSINESS MANAGEMENT STUDIES",
"XAZINA DIAMONDS PRIVATE LIMITED",
"XBALL INDIA PRIVATE LIMITED",
"XBHP AUTOMEDIA PRIVATE LIMITED",
"X-BIZ TECHVENTURES PRIVATE LIMITED",
"XBOOM UTILITIES PRIVATE LIMITED",
"XBYTE TECHNOLABS PRIVATE LIMITED",
"XCALIBER INFOTECH PRIVATE LIMITED",
"XCALIBRATE GLOBAL PRIVATE LIMITED",
"XCCELERATA VENTURES PRIVATE LIMITED",
"XCD HR PRIVATE LIMITED",
"XCEED TOOLINGS PRIVATE LIMITED",
"XCEEDANCE CONSULTING INDIA PRIVATE LIMITED",
"XCEEDANCE INFOTECH PRIVATE LIMITED",
"XCEL CONSOLIDATOR SERVICES INDIA PRIVATE LIMITED",
"X-CEL LABS PRIVATE LIMITED",
"XCEL LOGISOLUTIONS PRIVATE LIMITED",
"XCEL OFFICE EQUIPMENT INDIA PRIVATE LIMITED",
"XCEL STIRO PRIVATE LIMITED",
"XCELENT PHARMACEUTICALS PRIVATE LIMITED",
"XCELENTRA FINANCIAL CONSULTANCY SERVICES PRIVATE LIMITED",
"XCELERATING GROWTH PRIVATE LIMITED",
"XCELL SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED",
"XCELL TRADING PRIVATE LIMITED",
"XCELLANCE MEDICAL TECHNOLOGIES PRIVATE LIMITED",
"XCELLENT CARE SUPER -SPECIALITY HOSPITAL PRIVATE LIMITED",
"XCELLHOST CLOUD SERVICES PRIVATE LIMITED",
"XCELRIS LABS LIMITED",
"XCELSERV SOLUTIONS PRIVATE LIMITED",
"XCELTEC INTERACTIVE PRIVATE LIMITED",
"XCESS SECURITIES PRIVATE LIMITED",
"XCHANGE LEASING INDIA PRIVATE LIMITED",
"XCHANGETECHS INDIA PRIVATE LIMITED",
"XCHANGETECHS STAR ALLIANCE LLP",
"XCHANGING SOLUTIONS LIMITED",
"XCHANGING TECHNOLOGY SERVICES INDIA PRIVATE LIMITED",
"XCHEM POLYMERS INDIA PRIVATE LIMITED",
"XCLUSIF SHOPEE",
"XCLUSIVE INTERIORS PRIVATE LIMITED OPC",
"XCLUSIVE SOLUTIONS",
"XCMG MACHINERY INDIA PRIVATE LIMITED",
"XCOAL ENERGY & RESOURCES INDIA PRIVATE LIMITED",
"XCUBATED BUSINESS SOLUTIONS PRIVATE LIMITED",
"XCYTON DIAGNOSTICS PRIVATE LIMITED",
"XDUCE TECHNOLOGIES PRIVATE LIMITED",
"XE FOREX BUREAU INDIA PRIVATE LIMITED",
"XEAM VENTURES PRIVATE LIMITED",
"XEBEC COMMUNICATIONS PRIVATE LIMITED",
"XEBEC DESIGN AND FACILITIES PRIVATE LIMITED",
"XEBEC E MEDIA TECHNOLOGIES PRIVATE LIMITED",
"XEBEC PROJECT MANAGEMENT SERVICES PRIVATE LIMITED",
"XEBEC PROPERTY MANAGEMENT PRIVATE LIMITED",
"XEBIA CMIT SOFTWARE SERVICES PRIVATE LIMITED",
"XEBIA IT ARCHITECTS INDIA PRIVATE LIMITED",
"XEBRIUM SOFTWARE PRIVATE LIMITED",
"XECH TECHNOLOGIES PRIVATE LIMITED",
"XECOM INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"XECTA RESOURCE MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"XED EXECUTIVE DEVELOPMENT PRIVATE LIMITED",
"XEDGE CONSULTANCY PRIVATE LIMITED",
"XEENIUS TECHNOLOGY CONSULTING PRIVATE LIMITED",
"XEEVA INDIA PRIVATE LIMITED",
"XEINA DRUGS PRIVATE LIMITED",
"XEJIC TECHNOLOGIES PRIVATE LIMITED",
"XEL IT SERVICES PRIVATE LIMITED",
"XELECTRON TECHNOLOGIES PRIVATE LIMITED",
"XELIUM RETAIL PRIVATE LIMITED",
"XELIUMTECH SOLUTIONS PRIVATE LIMITED",
"XELLIA PHARMACEUTICALS PRIVATE LIMITED",
"XELPMOC DESIGN AND TECH LIMITED",
"XEME TRADING COMPANY PRIVATE LIMITED.",
"XEMPLAR INFOSOFT INSIGHTS PRIVATE LIMITED",
"XENA CARE PRIVATE LIMITED",
"XENA CORONUS HEALTH CARE PRIVATE LIMITED",
"XENA TECHNOLOGIES PRIVATE LIMITED",
"XENCIA TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"XENIA FOREX PRIVATE LIMITED",
"XENIA HEALING CENTRE LLP",
"XENIAL INDIA PRIVATE LIMITED",
"XENNEO TECH PRIVATE LIMITED",
"XENO PRIVATE LIMITED",
"XENOCOR PHARMALAB PRIVATE LIMITED",
"XENON INFO SOLUTIONS PRIVATE LIMITED",
"XENON PHARMA PRIVATE LIMITED",
"XENONE HEALTHCARE PRIVATE LIMITED",
"XENONSTACK PRIVATE LIMITED",
"XENOSOFT TECHNOLOGIES INDIA PRIVATE LIMITED",
"XENOTTABYTE SERVICES PRIVATE LIMITED",
"XENOVEX TECHNOLOGIES PRIVATE LIMITED",
"XENTA QSYS TECHNOLOGIES PRIVATE LIMITED",
"XEON WASTE MANAGERS PRIVATE LIMITED",
"XEONIX TECHNOLOGIES PRIVATE LIMITED",
"XERAGO ANALYTICS SOLUTIONS PRIVATE LIMITED",
"XERAGO CUSTOMER VALUE MAXIMIZATION PRIVATE LIMITED",
"XERAGO E-BIZ SERVICES PRIVATE LIMITED",
"XERAPHIN FINVEST PRIVATE LIMITED",
"XERCES TECHNOLOGIES PRIVATE LIMITED",
"XERION RETAIL PRIVATE LIMITED",
"XEROX INDIA LIMITED",
"XEROX TECHNOLOGY SERVICES INDIA LLP",
"XERTZ BUSINESS SOLUTIONS PRIVATE LIMITED",
"XESTION ADVISOR PRIVATE LIMITED",
"XETA NETWORKS PRIVATE LIMITED",
"XETECH PRIVATE LIMITED",
"XETGO PRIVATE LIMITED",
"XEVIERS INSTITUTE OF BUSINESS MANAGEMENT STUDIES",
"XFAS LOGISTICS PRIVATE LIMITED",
"XFINITE TECHNOLOGIES PRIVATE LIMITED",
"XFINITIVE ACCESSORIES INDIA PRIVATE LIMITED",
"XFORIA TECHNOLOGIES PRIVATE LIMITED",
"XFORMICS TECHNOLOGIES INDIA PRIVATE LIMITED",
"XH SMART TECH (INDIA) PRIVATE LIMITED",
"XI TECHNOLOGIES PRIVATE LIMITED",
"XIA HEALTHCARE PRIVATE LIMITED",
"XIAN OVERSEAS PRIVATE LIMITED",
"XIANGRUI INDUSTRY PRIVATE LIMITED",
"XIAOLIN ELECTRONIC PRIVATE LIMITED",
"XIAOMI COMMUNICATIONS AND LOGISTICS INDIA PRIVATE LIMITED",
"XIARCH SOLUTIONS PRIVATE LIMITED",
"XICOM TECHNOLOGIES LIMITED",
"XICON ENGINEERING SERVICES PRIVATE LIMITED",
"XICON INTERNATIONAL LIMITED",
"XIDA TECHNOLOGY PRIVATE LIMITED",
"XIENO E-SERVICES PRIVATE LIMITED",
"XIENT TECHNOLOGIES PRIVATE LIMITED",
"XIEON LIFE SCIENCES PRIVATE LIMITED",
"XIHI TECHNOLOGY PRIVATE LIMITED",
"XILINX INDIA TECHNOLOGY SERVICES PRIVATE LIMITED",
"XILLIGENCE TECHNOLOGIES PRIVATE LIMITED",
"XILONTECH SOLUTION PRIVATE LIMITED",
"XIM UNIVERSITY",
"XINDO WINDOW PRIVATE LIMITED",
"XINE IT BRAINS PRIVATE LIMITED",
"XINTHE TECHNOLOGIES PRIVATE LIMITED",
"XIOCARE LIFE SCIENCES PRIVATE LIMITED",
"XION MULTITRADE PRIVATE LIMITED",
"XION MULTIVENTURES PRIVATE LIMITED",
"XIP BUSINESS SOLUTION PRIVATE LIMITED",
"XIPE TECH",
"XIPHIAS IMMIGRATION PRIVATE LIMITED",
"XIPHIAS SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"XIPHIAS XPAY LIFE PRIVATE LIMITED",
"X-IS TECH PRIVATE LIMITED",
"XIT SOLUTIONS PRIVATE LIMITED",
"XITADEL CAE TECHNOLOGIES INDIA PRIVATE LIMITED",
"XITE LIVE INTEGRATED MARKETING CONSULTANCY PRIVATE LIMITED",
"XITIZ CHEMICAL INDUSTRIES PRIVATE LIMITED",
"XJ ELEVATOR INDIA PRIVATE LIMITED",
"XJS ELECTRONICS PRIVATE LIMITED",
"XL DYNAMICS INDIA PRIVATE LIMITED",
"XL ELECTRICALS PRIVATE LIMITED",
"XL ENTERPRISES LTD",
"XL HEALTH CORPORATION INDIA PRIVATE LIMITED",
"XL INDIA BUSINESS SERVICES PRIVATE LIMITED",
"XL INFOMATICS PRIVATE LIMITED",
"XL KPO SERVICES PRIVATE LIMITED",
"XL LABORATORIES PRIVATE LIMITED",
"XL RETAIL PRIVATE LIMITED",
"XLBYTE PRIVATE LIMITED",
"XLERATE DRIVELINE INDIA LIMITED",
"XLERATE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"XLI ELECTRONICS PRIVATE LIMITED",
"XLIT PRIVATE LIMITED",
"XLLENT CORPORATE SERVICES PRIVATE LIMITED",
"XLLENT MARINE LINE PRIVATE LIMITED",
"XLNC ACADEMY INTERNATIONAL PRIVATE LIMITED",
"XLNC CORPORATE SERVICES PRIVATE LIMITED",
"XLP ENGINEERS PVT LTD",
"XLS PACKAGING PRIVATE LIMITED",
"XLSCOUT XLPAT PRIVATE LIMITED",
"XM SERVICES INDIA PRIVATE LIMITED",
"XM SOFTWARE SOLUTIONS PRIVATE LIMITED",
"X'MAS STEELS PRIVATE LIMITED",
"XMETRIC WATER SOLUTIONS PRIVATE LIMITED",
"X'MEX CLOTHING PRIVATE LIMITED",
"XMINDS INFOTECH PRIVATE LIMITED",
"XMOLD POLYMERS PRIVATE LIMITED",
"XMPLAR MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"XN HOTEL SYSTEMS (INDIA) PRIVATE LIMITED",
"XN TRAVELS PRIVATE LIMITED",
"XNESA SOLUTIONS PRIVATE LIMITED",
"XNET LOGISTICS AND SUPPLY CHAIN PRIVATE LIMITED",
"XNETIC SOLUTIONS PRIVATE LIMITED",
"XNG AUTOMATION SOLUTIONS PRIVATE LIMITED",
"X-NINE CONTRACTS PRIVATE. LIMITED.",
"XNODES TECHNOLOGIES PRIVATE LIMITED",
"XNRGI INDIA PRIVATE LIMITED",
"XO FOOTWERS PRIVATE LIMITED",
"XO PACK PRIVATE LIMITED",
"XOANON PHARMACEUTICAL PRIVATE LIMITED",
"XOBIN TECHNOLOGIES PRIVATE LIMITED",
"XOGENE SOLUTIONS PRIVATE LIMITED",
"XOLA TRAVELS PRIVATE LIMITED",
"XOLERTIC ASIA PRIVATE LIMITED",
"XOLOPAK INDIA LIMITED",
"XOME SERVICES INDIA PRIVATE LIMITED",
"XOMOX SANMAR LIMITED",
"XONIQUE VENTRUES PRIVATE LIMITED",
"XONWARE TECHNOLOGIES PRIVATE LIMITED",
"XOOA TECHNOLOGIES PRIVATE LIMITED",
"XOOGLE GLOBAL TECHNOLOGIES PRIVATE LIMITED",
"XOPTIMO TECHNOLOGIES PRIVATE LIMITED",
"XOR TECHNOLOGIES LLP",
"XOREA EXPORTS PRIVATE LIMITED",
"XORIANT SOLUTIONS PRIVATE LIMITED",
"XORNOR TECHNOLOGIES PRIVATE LIMITED",
"XORPTECH LIFESCIENCE PRIVATE LIMITED",
"XOTIK FRUJUS PRIVATE LIMITED",
"XOTIK TRAVEL AND FOREX PRIVATE LIMITED",
"XOVEC GLOBAL SOLUTIONS PRIVATE LIMITED",
"XOXO HOSPITALITY PRIVATE LIMITED",
"XOXO SKYSHOP PRIVATE LIMITED",
"XPAN LOGISTICS PRIVATE LIMITED",
"XPAN SOLUTIONS PRIVATE LIMITED",
"XPAND DIGITAL PRIVATE LIMITED",
"XPANDR VENTURES INDIA PRIVATE LIMITED",
"XPANS IT SERVICES PRIVATE LIMITED",
"XPANXION INTERNATIONAL PRIVATE LIMITED",
"XPEDIANT SOFTWARES PRIVATE LIMITED",
"XPEDITE VENTURES PRIVATE LIMITED",
"XPEDIZE VENTURES PRIVATE LIMITED",
"XPEEDAS INDUSTRIAL AUTOMATION TECHNOLOGIES PRIVATE LIMITED",
"XPER SOFTWARES PRIVATE LIMITED",
"XPERIA HEALTHCARE PRIVATE LIMITED",
"XPERIENCE INDIA HOTELS & RESORTS PRIVATE LIMITED",
"XPERIENCE INFINITE SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"XPERITUS INSURANCE BROKERS PRIVATE LIMITED",
"XPERT GAS EQUIPMENTS PRIVATE LIMITED",
"XPERT PROPERTY MANAGEMENT SERVICES PRIVATE LIMITED",
"X-PERT PUBLICITY PRIVATE LIMITED",
"XPERTIFI SKILLS TECH PRIVATE LIMITED",
"XPERTNEST SOLUTIONS PRIVATE LIMITED",
"XPERTPACK TRANSPORT PACKAGING PRIVATE LIMITED",
"XPERT-PRO IP CONSULTING PRIVATE LIMITED",
"XPERTTECH CONSULTANTS PRIVATE LIMITED",
"XPERTZ ANKUR LIGHTS PRIVATE LIMITED",
"XPERTZ HOLIDAYS PRIVATE LIMITED",
"XPETIZE TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"XPHENO PRIVATE LIMITED",
"XPL LOGISTICS PRIVATE LIMITED",
"XPLANCK MARKETING PRIVATE LIMITED",
"XPLENT LOGISTICS PARK PRIVATE LIMITED",
"XPLOR WORLDWIDE PRIVATE LIMITED",
"XPLORE LIFESTYLE SOLUTIONS PRIVATE LIMITED",
"XPLORE TECH SERVICES PRIVATE LIMITED",
"XPLORER CONSULTANCY SERVICES PRIVATE LIMITED",
"XPLUSD EVENTS PRIVATE LIMITED",
"XPM SERVICES PRIVATE LIMITED",
"XPNT CUSTOMER CONNECT PRIVATE LIMITED",
"XPO INDIA SHARED SERVICES LLP",
"XPONENTIAL DATA AND BUSINESS SERVICES PRIVATE. LIMITED.",
"XPOODLE TECH PRIVATE LIMITED",
"XPORTIFY TECHNOLOGIES PRIVATE LIMITED",
"XPORTSOFT TECHNOLOGIES",
"XPORTUS FREIGHT INDIA PRIVATE LIMITED",
"XPOVA DESTINATION PRIVATE LIMITED",
"X-PRESS AUTOMOTIVE PRIVATE LIMITED",
"XPRESS COMPUTERS LIMITED",
"XPRESS IMPRINT PRIVATE LIMITED",
"XPRESS LABELS PRIVATE LIMITED",
"XPRESS MARITIME PRIVATE LIMITED",
"XPRESS MINDS EDUTAINMENT PRIVATE LIMITED",
"XPRESS RETAILS PRIVATE LIMITED",
"XPRESSIONS PIXEL WORKS PRIVATE LIMITED",
"XPRESSO AUTO LLP",
"XPREZ INFOSOLUTIONS PRIVATE LIMITED",
"XPRO INDIA LIMITED.",
"XPRO IT INNOVATIONS PRIVATE LIMITED",
"XPRT ENGINEERED PACKAGING SOLUTIONS PRIVATE LIMITED.",
"XPS CARGO SERVICES LIMITED",
"XPT CONSULTANCY AND SOFTWARE SERVICES PRIVATE LIMITED",
"XQUISITE PRINT SOLUTIONS PRIVATE LIMITED",
"XR CINEMA PRIVATE LIMITED",
"XRBIA ABODE DEVELOPERS PRIVATE LIMITED",
"XRBIA CHAKAN DEVELOPER PRIVATE LIMITED",
"XRBIA WARAI DEVELOPERS PRIVATE LIMITED",
"XRG CONSULTING PRIVATE LIMITED",
"XRIG PRIVATE LIMITED",
"X-RITE INDIA PRIVATE LIMITED",
"XRS LOGISTICS PRIVATE LIMITED",
"XS CAD INDIA PRIVATE LIMITED",
"XS COMMUNICATIONS PRIVATE LIMITED",
"XS PRODUCTIONS INDIA PRIVATE LIMITED",
"XS REAL PROPERTIES PRIVATE LIMITED",
"XSC TECHSOL PRIVATE LIMITED",
"XSEED EDUCATION PRIVATE LIMITED",
"XSERV METALS PRIVATE LIMITED",
"XSI SEMICONDUCTORS PRIVATE LIMITED",
"XSILICA SOFTWARE SOLUTIONSPRIVATE LIMITED",
"XSIS VALVES PRIVATE LIMITED",
"XSN NUTRACEUTICALS PRIVATE LIMITED",
"XSOLLA INDIA PRIVATE LIMITED",
"XSONI SYSTEMS PRIVATE LIMITED",
"XSTREEM POWER SYSTEMS PRIVATE LIMITED",
"XSTROPS CONSULTING PRIVATE LIMITED",
"XSYS TECHNOLOGIES PRIVATE LIMITED",
"XSYSYS TECHNOLOGIES PRIVATE LIMITED",
"XT SHIPS MANAGEMENT INDIA PRIVATE LIMITED",
"XTAGE TECHNOLOGIES PRIVATE LIMITED",
"X-TEAM EQUIPMENTS PRIVATE LIMITED",
"XTECHS TESTINGS PRIVATE LIMITED",
"XTELESIS DATACOM PRIVATE LIMITED",
"XTEN-AV INDIA PRIVATE LIMITED",
"XTEND ELECTRONICS PRIVATE LIMITED",
"XTEND INDUSTRIAL DESIGNERS AND ENGINEERS PRIVATE LIMITED",
"XTEND TECHNOLOGIES PRIVATE LIMITED",
"XTEND VALUE PRIVATE LIMITED",
"XTENDED BUSINESS REPORTING LIMITED",
"XTENSIBLE SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"XTENTICS CONSULTANCY SERVICES PRIVATE LIMITED",
"XTGLOBAL INFOTECH LIMITED",
"XTHETIC INFRASTRUCTURE PRIVATE LIMITED",
"XTO10X TECHNOLOGIES PRIVATE LIMITED",
"XTORD DESIGNS PRIVATE LIMITED",
"X'TRA CARE PRIVATE LIMITED",
"XTRA PRECISION SCREWS PRIVATE LIMITED",
"XTRACARE HYGIENE PRIVATE LIMITED",
"XTRACARE LOGISTICS PRIVATE LIMITED",
"XTRACARE PRODUCTS PRIVATE LIMITED",
"TOAST TAB PRIVATE LIMITED",
"XTRACITHUB PRIVATE LIMITED",
"XTRAMILESOFT TECHNOLOGIES PRIVATE LIMITED",
"XTRANET BPO PRIVATE LIMITED",
"XTRANET TECHNOLOGIES PRIVATE LIMITED",
"XTRAPOWER TOOLS PRIVATE LIMITED",
"XTRATRUST DIGISIGN PRIVATE LIMITED",
"XTREAM INSTRUMENTS PRIVATE LIMITED",
"XTREAM MOTORS KASHMIR PRIVATE LIMITED",
"XTREAM MOTORS PRIVATE LIMITED",
"XTREME COIR INDIA PRIVATE LIMITED",
"XTREME DOCS INDIA PRIVATE LIMITED",
"XTREME ELECTRICALS PRIVATE LIMITED",
"XTREME ENGINEERING EQUIPMENT PRIVATE LIMITED",
"XTREME ICT PRIVATE LIMITED",
"XTREME MEDIA PRIVATE LIMITED",
"XTREME OFFICE AIDS PRIVATE LIMITED",
"XTREME ONLINE SOLUTIONS PRIVATE LIMITED",
"XTREME PRODUCTIVITY PRIVATE LIMITED",
"X-TREME(BANGALORE)PRIVATE LIMITED",
"XTREMEDATA TECHNOLOGIES PRIVATE LIMITED",
"XTREMSOFT TECHNOLOGIES PRIVATE LIMITED",
"XTRIM GLOBAL SOLUTIONS PRIVATE LIMITED",
"XTRM INDIA PRIVATE LIMITED",
"XTRO KIDS PRIVATE LIMITED",
"XUBERANT SOLUTIONS PRIVATE LIMITED",
"XUVI TECHNOLOGY LABS PRIVATE LIMITED",
"XUZHOU CONSTRUCTION MACHINERY MANUFACTURING INDIA PRIVATE LIMITED",
"XVARIAN AUTO INDUSTRIES PRIVATE LIMITED",
"XXPLORE AUTOMOTIVE PRIVATE LIMITED",
"XY ADS PRIVATE LIMITED",
"XYANT TECHNOLOGY INDIA PRIVATE LIMITED",
"XYATA LIFE SCIENCES PRIVATE LIMITED",
"XYBION INDIA PRIVATE LIMITED",
"XYDOR SCIENTIFIC PRIVATE LIMITED",
"XYKA HOTELS INDIA PRIVATE LIMITED",
"XYLEM INTEGRATED SOLUTIONS PRIVATE LIMITED",
"XYLEM PAPERCRAFT PRIVATE LIMITED",
"XYLEM RESOURCE MANAGEMENT PRIVATE LIMITED",
"XYLEM WATER SOLUTIONS INDIA PRIVATE LIMITED",
"XYLO MARKETING PRIVATE LIMITED",
"XYLO PAINTS PRIVATE LIMITED",
"XYLO WOODWORKS PRIVATE LIMITED",
"XYLON VENTURES PRIVATE LIMITED",
"XYLOPIA LABS PRIVATE LIMITED",
"XYLOPIA ZYDUS GROUP",
"XYLOS ARTERIORS INDIA PRIVATE LIMITED",
"XYLOSMA SOFTWARE PRIVATE LIMITED",
"XYLUS FLOWTECH ENGINEERING PRIVATE LIMITED",
"XYNTAC RETAIL PRIVATE LIMITED",
"XYRAM SOFTWARE SOLUTIONS PRIVATE LIMITED",
"XYSEC LABS PRIVATE LIMITED",
"XYTEL INDIA PRIVATE LIMITED",
"XYTIQ TECHNOLOGIES PRIVATE LIMITED",
"XYZ DIGITAL PRIVATE LIMITED",
"XYZ GRAPHIC SOLUTIONS",
"Y & H CARGO PRIVATE LIMITED",
"Y & H INTERNATIONAL PRIVATE LIMITED",
"Y AND O FASHIONS PRIVATE LIMITED",
"Y AXIS SOLUTIONS PRIVATE LIMITED",
"Y COOK INDIA PRIVATE LIMITED",
"Y CREATORS MEDIA LLP",
"Y I INTERNATIONAL PRIVATE LIMITED",
"Y J MALL MAINTENANCE SERVICES PRIVATE LIMITED",
"Y K GRAPHICS PRIVATE LIMITED",
"Y K JEWELLERS PRIVATE LIMITED",
"Y K M BOTTLING COMPANY PRIVATE LIMITED",
"Y K M HEALTH CARE PRIVATE LIMITED",
"Y K WIN CONTAINERS PRIVATE LIMITED",
"Y M G CREATIONS PRIVATE LIMITED",
"Y MEDIA LABS PRIVATE LIMITED",
"Y N GARMENTS PRIVATE LIMITED",
"Y P TECHNOLOGIES PRIVATE LIMITED",
"Y POINT ANALYTICS (INDIA) PRIVATE LIMITED",
"Y R GAITONDE MEDICAL EDUCATIONAL AND RESEARCH FOUNDATION",
"Y R INFRASTRUCTURES PRIVATE LIMITED",
"Y S R SPINNING AND WEAVING MILLS PRIVATE LIMITED",
"Y S T FRAGRANCES PRIVATE LIMITED",
"Y TEC INDIA PRIVATE LIMITED",
"Y TECHNO SOLUTIONS PRIVATE LIMITED",
"Y V R MEDIVISION PRIVATE LIMITED",
"Y V SIVA REDDY COLLEGE OF ENGINEERING AND TECHNOLOGY",
"Y Y FORGE PRIVATE LIMITED",
"Y. H. TOOLS MANUFACTURERS PRIVATE LIMITED",
"Y. M. INFRA PRIVATE LIMITED",
"Y. T. ENTERTAINMENT LIMITED",
"Y.A. GLOBAL VENTURES PRIVATE LIMITED",
"Y.A. MACHINING (OPC) PRIVATE LIMITED",
"Y.B. CONSTRUCTIONS PRIVATE LIMITED",
"Y.D. BUILDERS AND HOTELS PRIVATE LIMITED",
"Y.F.A. ADVERTISING AND MARKETING PRIVATE LIMITED",
"Y.J.DECOR PRIVATE LIMITED",
"Y.K.AGROTECH PRIVATE LIMITED",
"Y.P. SPICES PRIVATE LIMITED",
"Y.P. STEEL EXIM PRIVATE LIMITED",
"Y.R.D IMPEX INDIA PRIVATE LIMITED",
"Y.S. TEXTILE PRIVATE LIMITED",
"Y.S.ARSIWALA AND COMPANY PRIVATE LIMITED",
"Y.T.INFOCOM PRIVATE LIMITED",
"Y.V.S. AGRO FARMS PRIVATE LIMITED",
"Y2K AIRSYSTEMS PRIVATE LIMITED",
"Y2K TRADING AND MARKETING PRIVATE LIMITED",
"Y3 TECHNOLOGIES INDIA PRIVATE LIMITED",
"YA AUTO INDUSTRIES",
"YA TECHNO SOLUTION PRIVATE LIMITED",
"YAA SECURITY PRIVATE LIMITED",
"YAAGANTI SEEDS PRIVATE LIMITED",
"YAAL. GLOBAL E-WASTE RECYCLING PRIVATE LIMITED",
"YAALI PUMPS INDIA PRIVATE LIMITED",
"YAALI SHOES",
"YAAN ENTERPRISES LIMITED",
"YAANA APPARELS PRIVATE LIMITED",
"YAANA PETRO PRODUCTS PRIVATE LIMITED",
"YAAP DIGITAL PRIVATE LIMITED",
"YAARANA TRADECORP PRIVATE LIMITED",
"YAASHKRISHNI FOOD SCIENCE LIMITED",
"YAASHVI JEWELLERS PRIVATE LIMITED",
"YABHI ACID REGENERATION SERVICES PRIVATE LIMITED",
"YABX INDIA PRIVATE LIMITED",
"YACCA LIFESCIENCES PRIVATE LIMITED",
"YACCA PHARMACEUTICALS PRIVATE LIMITED",
"YACHIYO INDIA MANUFACTURING PRIVATE LIMITED",
"YACLASS TECH PRIVATE LIMITED",
"YADADA COMMUNICATION PRIVATE LIMITED",
"YADADRI AGRO FARMS PRIVATE LIMITED",
"YADADRI MANUFACTURERS & TRADERS PRIVATE LIMITED",
"YADADRI PIPES AND FITTINGS (OPC) PRIVATE LIMITED",
"YADADRI POULTRY BREEDING FARMS PRIVATE LIMITED",
"YADAN AUTOTEX PRIVATE LIMITED",
"YADAV BUS SERVICES PRIVATE LIMITED",
"YADAV CRANE SERVICES PRIVATE LIMITED",
"YADAV ENTERPRISES",
"YADAV FABRICATION AND CONTRACTOR",
"YADAV FANCY AND GENERAL STORE",
"YADAV FLOUR MILLS LIMITED",
"YADAV FOODS LIMITED.",
"YADAV INFRAPOLYMERS PRIVATE LIMITED",
"YADAV LASER DIE PRIVATE LIMITED",
"YADAV MEASUREMENTS PRIVATE LIMITED",
"YADAV PETRO PRODUCTS PRIVATE LIMITED",
"YADAV SOLVEX PRIVATE LIMITED",
"YADAV TOURIST SERVICES PRIVATE LIMITED",
"YADAV TRAVELS AND CARGO PRIVATE LIMITED",
"YADAVI AUTOMOBILES PRIVATE LIMITED",
"YADAVINDRA PUBLIC SCHOOL",
"YADAVJI PURE MILK PRODUCTS PRIVATE LIMITED",
"YADHUNANDAN TRADING PRIVATE LIMITED",
"YADNYA ACADEMY PRIVATE LIMITED",
"YADU IMPEX PRIVATE LIMITED",
"YADU INTERNATIONAL LIMITED",
"YADU SUGAR LIMITED",
"YADUKA AGROTECH PRIVATE LIMITED",
"YADUKA FINANCIAL SERVICES LIMITED",
"YADUNANDAN COTTON PRIVATE LIMITED",
"YADURAJ TRADELINK PRIVATE LIMITED",
"YADUVANSHI HEALTHCARE SERVICES PRIVATE LIMITED",
"YADUVANSHI INDUSTRIES PRIVATE LIMITED",
"YADUVANSHI INFRATECH PRIVATE LIMITED",
"YADUVANSHI PACKAGING SOLUTION PRIVATE LIMITED",
"YADUVANSHI SHIKSHA NIKETAN",
"YADVENDRA FOODS PRIVATE. LIMITED.",
"YAFFA'S INTERIOR TURNKEY SOLUTIONS LLP",
"YAG INDUSTRIAL ESTATE PRIVATE LIMITED",
"YAG PLAST PRIVATE LIMITED",
"YAGACHI TECHNOLOGIES PRIVATE LIMITED",
"YAGANTI AGRO TECH PRIVATE LIMITED",
"YAGNA AGRO INDUSTRIES PRIVATE LIMITED",
"YAGNA IQ INDIA PRIVATE LIMITED",
"YAGNM INDUSTRIES PRIVATE LIMITED",
"YAGYA AGARWAL CONSTRUCTIONS & INFRA SOLUTIONS PRIVATE LIMITED",
"YAH KASZA CHEMICALS PVT LTD",
"YAHA WATER SYSTEMS PRIVATE LIMITED",
"YAHOO INDIA PRIVATE LIMITED",
"YAHOO SOFTWARE DEVELOPMENT INDIA PRIVATE LIMITED",
"YAHSKA POLYMERS PRIVATE LIMITED",
"YAHSMITA INFRASTRUCTURE AND DEVELOPERS PRIVATE LIMITED",
"YAHVI JEWELLERY PRIVATE LIMITED",
"YAHWEH GLOBAL LOGISTICS PRIVATE LIMITED",
"YAJAT SITRON PRIVATE LIMITED",
"YAJUR COMMODITIES LIMITED",
"YAJUR COMTRADE PRIVATE LIMITED",
"YAJUR FIBRES LIMITED",
"YAK CARPET PRIVATE LIMITED",
"YAK MANAGEMENT AND MARINE EDUCATION CENTRE",
"YAKEAN ENTERPRISES PRIVATE LIMITED",
"YAKHAS RETAIL OUTLET PRIVATE LIMITED",
"YAKIDOO IA INDIA PRIVATE LIMITED",
"YAKSHA FINTECH PRIVATE LIMITED",
"YAKSHA INFORMATICS PRIVATE LIMITED",
"YAKSI DEEPTHI REDDY DESIGNS PRIVATE LIMITED",
"YAKULT DANONE INDIA PRIVATE LIMITED",
"YALA TRAVELZ INDIA (OPC) PRIVATE LIMITED",
"YALAKA'S INFRA PRIVATE LIMITED",
"YALAMANCHILI ENGINEERS PRIVATE LIMITED",
"YALAMANCHILI SCHOOL OF LEARNING PRIVATE LIMITED",
"YALAMANCHILI SOFTWARE EXPORTS LIMITED",
"YALAMANCHILI SOFTWARE EXPORTS PRIVATE LIMITED",
"YALAVARTHI SOFTWARE SOLUTIONS PRIVATE LIMITED",
"YALAVARTI ENGINEERING PRIVATE LIMITED",
"YALAVARTI PROJECTS PRIVATE LIMITED",
"YALE SYNTHLUBE INDUSTRIES PRIVATE LIMITED",
"YALEY CHIT FUNDS PRIVATE LIMITED",
"YALI MOBILITY PRIVATE LIMITED",
"YALI STEELS PVT LTD",
"YALOCHAT INDIA PRIVATE LIMITED",
"YAM COMMODITIES PRIVATE LIMITED",
"YAM LOGISTICS PRIVATE LIMITED",
"YAMA RIBBONS & BOWS INDIA PRIVATE LIMITED",
"YAMADA CONSULTING SPIRE INDIA PRIVATE LIMITED",
"YAMADA LOGISTICS LIMITED",
"YAMAHA MOTOR ELECTRONICS INDIA PRIVATE LIMITED",
"YAMAHA MOTOR INDIA PRIVATE LIMITED",
"YAMAHA MOTOR INDIA SALES PRIVATE LIMITED",
"YAMAHA MOTOR RESEARCH AND DEVELOPMENT INDIA PRIVATE LIMITED",
"YAMAHA MOTOR SOLUTIONS INDIA PRIVATE LIMITED",
"YAMAHA MUSIC INDIA PRIVATE LIMITED",
"YAMAI FASHIONS PRIVATE LIMITED",
"YAMANAGA HOTELS AND ENTERPRISES PRIVATE LIMITED",
"YAMARI INDIA TEMPERATURE SENSOR PRIVATE LIMITED",
"YAMATECH INFINITY PRIVATE LIMITED",
"YAMATO SCALE INDIA PRIVATE LIMITED",
"YAMATO TRADE PRIVATE LIMITED",
"YAMAZAKI MAZAK INDIA PRIVATE LIMITED",
"YAMAZEN MACHINERY & TOOLS INDIA PRIVATE LIMITED",
"YAMINEE ELECTRICAL PROJECTS PRIVATE LIMITED",
"YAMINI INTERIORS PRIVATE LIMITED",
"YAMINI INVESTMENTS COMPANY LTD",
"YAMIR PACKAGING PRIVATE LIMITED",
"YAMUNA ALLOYS LIMITED",
"YAMUNA BEVERAGES PRIVATE LIMITED",
"YAMUNA BIO ENERGY PRIVATE LIMITED",
"YAMUNA BUILTECH PRIVATE LIMITED",
"YAMUNA CABLE ACCESSORIES PRIVATE LIMITED",
"YAMUNA CALCIUM PRIVATE LIMITED",
"YAMUNA CONTRACTS INDIA PRIVATE LIMITED",
"YAMUNA DIAMOND MANUFACTURING LLP",
"YAMUNA DYECHEM PVT LTD",
"YAMUNA ENTERPRISES",
"YAMUNA EXPORTS PRIVATE LIMITED",
"YAMUNA FREIGHTS & LOGISTICS PRIVATE LIMITED",
"YAMUNA GEARS PRIVATE LIMITED",
"YAMUNA HOMES AND DESIGN PRIVATE LIMITED",
"YAMUNA HOMES INDIA PRIVATE LIMITED",
"YAMUNA INDUSTRIES LIMITED",
"YAMUNA INFRATECH PRIVATE LIMITED",
"YAMUNA INTERIORS PRIVATE LIMITED",
"YAMUNA INTERNATIONAL AIRPORT PRIVATE LIMITED",
"YAMUNA MACHINE WORKS LIMITED.",
"YAMUNA MEDITECH PRIVATE LIMITED",
"YAMUNA NAGAR ENGINEERING CLUSTER PRIVATE LIMITED",
"YAMUNA POWER AND INFRASTRUCTURE LIMITED",
"YAMUNA REALTY PRIVATE LIMITED",
"YAMUNA ROLLER FLOUR MILLS PRIVATE LIMITED",
"YAMUNA SEEDS PRIVATE LIMITED",
"YAMUNA SYNDICATE LIMITED",
"YAMUNA SYNTHETICS PRIVATE LIMITED",
"YAMUNA TECHNICAL PRODUCTS PRIVATE LIMITED",
"YAMUNA WATER SERVICE GOVT",
"YAMUNABAI B P MADHYAMIK V UCHCH MADHYAMIK VIDYALAY NAIGAON",
"YAMUNAJI ENTERPRISE",
"YAMUNANAGAR PLYWOOD CLUSTER PRIVATE LIMITED",
"YAN IT SOLUTIONS PRIVATE LIMITED",
"YANA IVF AND FERTILITY SOLUTIONS PRIVATE LIMITED",
"YANA SOFTWARE PRIVATE LIMITED",
"YANA SOLAR PRIVATE LIMITED",
"YANFENG INDIA AUTOMOTIVE INTERIOR SYSTEMS PRIVATE LIMITED",
"YANFENG SEATING (INDIA) PRIVATE LIMITED",
"YANG DU ESTATES PRIVATE LIMITED",
"YANG MING LINE INDIA PRIVATE LIMITED",
"YANGPOO MARKETING PRIVATE LIMITED",
"YANJAN NEW MATERIAL INDIA PRIVATE LIMITED",
"YANKEE BUILDERS",
"YANKI SIZZLERR PRIVATE LIMITED",
"YANMAR COROMANDEL AGRISOLUTIONS PRIVATE LIMITED",
"YANMAR ENGINE MANUFACTURING INDIA PRIVATE LIMITED",
"YANMAR INDIA PRIVATE LIMITED",
"YANNI BUSINESS SOLUTION PRIVATE LIMITED",
"YANNI INFRA PROJECTS PRIVATE LIMITED",
"YANNI INTERNATIONAL PRIVATE LIMITED",
"YANNICK TECK SYSTEMS PRIVATE LIMITED",
"GLS SPECIALITY CHEMICALS PRIVATE LIMITED",
"YANSONS ENGINEERING PRIVATE LIMITED",
"YANSONS MARKETING SERVICES PRIVATE LIMITED",
"YANTRA ALUMINIUM WINDOW SYSTEMS PRIVATE LIMITED",
"YANTRA ESOLARINDIA PRIVATE LIMITED",
"YANTRA FINTECH INDIA LIMITED",
"YANTRA HARVEST ENERGY PRIVATE LIMITED",
"YANTRA INDIA LIMITED",
"YANTRA KAUSHALYA ENGINEERS PRIVATE LIMITED",
"YANTRA SOFTWARE PRIVATE LIMITED",
"YANTRA WORLD SIGHTSEEING PRIVATE LIMITED",
"YANTRAKSH LOGISTICS PRIVATE LIMITED",
"YANTRALIVE PARTS TECHNOLOGY PRIVATE LIMITED",
"YANTRAMAN AUTOMAC PRIVATE LIMITED",
"YANTRANG CNC AUTOMATION PRIVATE LIMITED",
"YANTRANSH GLOBAL PRIVATE LIMITED",
"YANTRASHILPA TECHNOLOGIES PRIVATE LIMITED",
"YANTRAVISION SOFTWARE PRIVATE LIMITED",
"YANTRIK AGRITECH PRIVATE LIMITED",
"YANTRIK ENGINEERING PVT LTD",
"YANTRIKA INSTRUMENTS PRIVATE LIMITED",
"YANTRIKS INDIA PRIVATE LIMITED",
"YANTRIQ SYSTEMS PRIVATE LIMITED",
"YANTRR ELECTRONIC SYSTEMS PRIVATE LIMITED",
"YAP MARKETING PRIVATE LIMITED",
"YAPAN BIO PRIVATE LIMITED",
"YAPER TECHNOLOGIES PRIVATE LIMITED",
"YAPP INDIA AUTOMOTIVE SYSTEMS PRIVATE LIMITED",
"YAPSODY INDIA PRIVATE LIMITED",
"YARA DIGITAL FARMING INDIA PRIVATE LIMITED",
"YARA ENVIRONMENTAL TECHNOLOGIES PRIVATE LIMITED",
"YARA FERTILISERS INDIA PRIVATE LIMITED",
"YARA INTERNATIONAL PRIVATE LIMITED",
"YARAB TECHNOLOGIES PRIVATE LIMITED",
"YARBAL PRINT-PACK PRIVATE LIMITED",
"YARD HOUSE BREWERY PRIVATE LIMITED",
"YARDI PRABHU CONSULTANTS AND VALUERS PRIVATE LIMITED",
"YARDI SOFTWARE INDIA PRIVATE LIMITED",
"YARDLEY INVESTMENT AND TRADING COMPANY PRIVATE LIMITED",
"YARDSTICK EDUCATIONAL INITIATIVES PRIVATE LIMITED",
"YARE HEALTHCARE PRIVATE LIMITED",
"YARLAGADDA AGROS PRIVATE LIMITED",
"YARLAGADDA EXPORTS PRIVATE LIMITED",
"YARN PROCESSING CO PVT LTD",
"YARNCOMS INDIA PRIVATE LIMITED",
"YARNCOMS OVERSEAS PRIVATE LIMITED",
"YARRA INDUSTRIES PRIVATE LIMITED",
"YARROW INFRASTRUCTURE PRIVATE LIMITED",
"YARUNARA TECHNOLOGIES PRIVATE LIMITED",
"YASEN LIGHTING PRIVATE LIMITED",
"YASH ABRATECH PRIVATE LIMITED",
"YASH ACCOUNTING AND E-SERVICES PRIVATE LIMITED",
"YASH AEROSPACE PRIVATE LIMITED",
"YASH AGRO INDUSTRIES",
"YASH AGROMECH PRIVATE LIMITED",
"YASH ALLOYS PRIVATE LIMITED",
"YASH AMAN HOSPITAL",
"YASH ANIL ORNAMENTS PRIVATE LIMITED",
"YASH APPLIANCES",
"YASH APPLIANCES PRIVATE LIMITED",
"YASH ARTS & DESIGNER DRESSES PRIVATE LIMITED",
"YASH ASSOCIATES",
"YASH AUTOLINK PRIVATE LIMITED",
"YASH AUTOMATION PRIVATE LIMITED",
"YASH BLOWERS PRIVATE LIMITED",
"YASH BREEDING FARM",
"YASH CAPACITORS PRIVATE LIMITED",
"YASH CARGO MOVERS PRIVATE LIMITED",
"YASH CHEMEX LIMITED",
"YASH CONCHEM PRIVATE LIMITED",
"YASH CONSUMER PRODUCTS PRIVATE LIMITED",
"YASH COTYARN PRIVATE LIMITED",
"YASH DAIRY SPICES AND FOOD PRIVATE LIMITED",
"YASH DEEP AUTOMOTIVES PRIVATE LIMITED",
"YASH DIESEL EQUIPMENTS PRIVATE LIMITED",
"YASH EARTHING SOLUTIONS PRIVATE LIMITED",
"YASH ELECTROTECHNICS PRIVATE LIMITED",
"YASH ENERGY PRIVATE LIMITED",
"YASH ENGINEERING CONSULTANTS PRIVATE LIMITED",
"YASH ENGISTEEL PRIVATE LIMITED",
"YASH ENVIRO TECH INDIA PRIVATE LIMITED",
"YASH EPC PROJECTS PRIVATE LIMITED",
"YASH EXPORTS INDIA PRIVATE LIMITED",
"YASH FABRITEX PVT LTD",
"YASH FANS & APPLIANCES LIMITED",
"YASH FANS PRIVATE LIMITED",
"YASH FASHIONS PRIVATE LIMITED",
"YASH FLEXI PACK PRIVATE LIMITED",
"YASH FLOUR MILLS PRIVATE LIMITED",
"YASH FOOD PROCESSORS PRIVATE LIMITED",
"YASH FOODS",
"YASH FORGINGS PRIVATE LIMITED",
"YASH GOLD PRIVATE LIMITED",
"YASH GRANISTONE PRIVATE LIMITED",
"YASH GROUP",
"YASH HIGHVOLTAGE LIMITED",
"YASH HOSIERY INDIA PRIVATE LIMITED",
"YASH HYDRAULICS",
"YASH INFOMEDIA & ESTATE PRIVATE LIMITED",
"YASH INFRALINK PRIVATE LIMITED",
"YASH INFRAPARK & SERVICES PRIVATE LIMITED",
"YASH LASERTEK INDIA PRIVATE LIMITED",
"YASH LAXMI SOLVENT PRIVATE LIMITED",
"YASH LOGISTIC PRIVATE LIMITED",
"YASH MANAGEMENT AND SATELLITE LIMITED",
"YASH MEDICARE PRIVATE LIMITED",
"YASH METAL IMPEX PRIVATE LIMITED",
"YASH METALICS PRIVATE LIMITED",
"YASH MODULAR FURNITURE PRIVATE LIMITED",
"YASH MOTORS (GUJ.) PRIVATE LIMITED",
"YASH NUTRITION AND BIO ENERGY PRIVATE LIMITED",
"YASH OPTICS & LENS LIMITED",
"YASH ORNAMENTS PRIVATE LIMITED",
"YASH ORO INDIA PRIVATE LIMITED",
"YASH PACKAGING PAPER PRIVATE LIMITED",
"YASH PACKERS",
"YASH PAKKA LIMITED",
"YASH PHARMA LABORATORIES PRIVATE LIMITED",
"YASH PIPELINE PROJECTS PRIVATE LIMITED",
"YASH PLASTOMET PRIVATE LIMITED",
"YASH PLYWOOD PRIVATE LIMITED",
"YASH POLY INDUSTRIES PRIVATE LIMITED",
"YASH POLYCHEM PRIVATE LIMITED",
"YASH POLYTHENE PRIVATE LIMITED",
"YASH POWERSOL (INDIA) PRIVATE LIMITED",
"YASH PRINTS PVT. LTD.",
"YASH PROCON PRIVATE LIMITED",
"YASH PROTEINS PRIVATE. LIMITED.",
"YASH RAJ BEVERAGES AND AGROPRODUCTS PRIVATE. LIMITED.",
"YASH RAJ FILMS PRIVATE LIMITED",
"YASH RAJ JEWELLERS PRIVATE LIMITED",
"YASH ROAD CARRIERS PRIVATE LIMITED",
"YASH ROTOPRINT PRIVATE LIMITED",
"YASH ROYAL CABLES INDIA LIMITED",
"YASH SEALS PRIVATE LIMITED",
"YASH SHIPTRANS PRIVATE LIMITED",
"YASH SILVER HOUSE PRIVATE LIMITED",
"YASH SPECIALITY CHEMICALS LLP",
"YASH STRIPS PRIVATE LIMITED",
"YASH SYSTEMS MANUFACTURING COMPANY PRIVATE LIMITED",
"YASH TECHNOLOGIES PRIVATE LIMITED",
"YASH TEXLEEN PVT LTD",
"YASH TEXTILE MACHINES PRIVATE LIMITED",
"YASH TOOLS (INDIA) PRIVATE LIMITED",
"YASH TRAVELS",
"YASH VEGETABLE OILS PRIVATE LIMITED",
"YASH WATER PURIFIERS PRIVATE LIMITED",
"YASH WEAVERS PRIVATE LIMITED",
"YASH WINES PRIVATE LIMITED",
"YASHAM SPECIALITY INGREDIENTS PRIVATE LIMITED",
"YASHAMM VENTURES PRIVATE LIMITED",
"YASHAM-MITSUYA CONSTRUCTION ADDITIVES PRIVATE LIMITED",
"YASHANAND INFRA PRIVATE LIMITED",
"YASHARTH WELLNESS SOLUTIONS PRIVATE LIMITED",
"YASHARYN PACKAGING PRIVATE LIMITED",
"YASHAS MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"YASHASH CABLE NETWORK PRIVATE LIMITED",
"YASHASH COMMODITIES PRIVATE LIMITED",
"YASHASHREE HOTELS AND RESORTS PRIVATE LIMITED",
"YASHASHRI CT SCAN CENTRE PRIVATE LIMITED",
"YASHASHRI POLYEXTRUSION PRIVATE LIMITED",
"YASHASHVI POULTRY PRIVATE LIMITED",
"YASHASHVI RASAYAN PRIVATE LIMITED",
"YASHASKAR INFRASTRUCTURES PRIVATE LIMITED",
"YASHASVI FOODS INDIA PRIVATE LIMITED",
"YASHASVI INFORMATION SOLUTIONS PRIVATE LIMITED",
"YASHASVI RECYCLERS PRIVATE LIMITED",
"YASHASVI TECHNOLOGY PRIVATE LIMITED",
"YASHASWI ACADEMY FOR SKILLS",
"YASHASWI ACADEMY FOR TALENT MANAGEMENT PRIVATE LIMITED",
"YASHASWI ELECTRONICS PRIVATE LIMITED",
"YASHASWI FISH MEAL AND OIL COMPANY",
"YASHASWI ISPAT PRIVATE LIMITED",
"YASHASWI TEMPSQUAD PRIVATE LIMITED",
"YASHASWINI CONSULTANTS PRIVATE LIMITED",
"YASHAVINASH SECURITY FORCE PRIVATE LIMITED",
"YASHAWANT FORGINGS PRIVATE LIMITED",
"YASHBIZ MARKETING PRIVATE LIMITED",
"YASHDEEP BOOKTIQUE PRIVATE LIMITED",
"YASHDEEP MARBLES PRIVATE LIMITED",
"YASHENERGY CAPACITORS PRIVATE LIMITED",
"YASHI CONSULTING SERVICES PRIVATE LIMITED",
"YASHI FILMS PRIVATE LIMITED",
"YASHI INDUSTRIES PRIVATE LIMITED",
"YASHICA PHARMACEUTICALS PRIVATE LIMITED",
"YASHIKA DIAMONDS PRIVATE LIMITED",
"YASHIKA ENERGY SYSTEMS PRIVATE LIMITED",
"YASHIKA FACILITY & MANPOWER SOLUTION PRIVATE LIMITED",
"YASHIKA INVESTMENT SERVICES PRIVATE LIMITED",
"YASHIKA JEWELS PRIVATE LIMITED",
"YASHIKA JOURNAL PUBLICATION PRIVATE LIMITED",
"YASHIKAA GRANITES PRIVATE LIMITED",
"YASHITA AUTOMOTIVE ENGINEERING PRIVATE LIMITED",
"YASHITA FINANCE PRIVATE LIMITED",
"YASHITA GLOBAL SPIRIT PRIVATE LIMITED",
"YASHJYOTI DEBT CONSULTANCY PRIVATE LIMITED",
"YASHK INFRASTRUCTURES PRIVATE LIMITED",
"YASHKA INFOTRONICS PRIVATE LIMITED",
"YASHMAY ADVENTURES INDIA PRIVATE LIMITED",
"YASHMETAL ALLOYS PRIVATE LIMITED",
"YASHMIN BUILDCON PRIVATE LIMITED",
"YASHMUN ENGINEERS LIMITED",
"YASHNA MEDISYS PRIVATE LIMITED",
"YASHNAND ENGINEERS AND CONTRACTORS PRIVATE LIMITED",
"YASHNEE AGROCHEMICALS INDIA PRIVATE LIMITED",
"YASHNIDHI BUILDERS PRIVATE LIMITED",
"YASHO ELECTRIC WORKS PRIVATE LIMITED",
"YASHO INDUSTRIES LIMITED",
"YASHOBHAV ENTERPRISES PRIVATE LIMITED",
"YASHODA GEMS PRIVATE LIMITED",
"YASHODA GIRLS ARTS & COMMERCE COLLEGE",
"YASHODA HEALTHCARE SERVICES PRIVATE LIMITED",
"YASHODA HOSIERY PRIVATE LIMITED",
"YASHODA HOSPITAL & RESEARCH CENTRE",
"YASHODA HOSPITALS",
"YASHODA HYBRID SEEDS PRIVATE LIMITED",
"YASHODA INFERTILITY AND HEALTHCARE SERVICES PRIVATE LIMITED",
"YASHODA INSTITUTE OF PHYSIOTHERAPY",
"YASHODA KRISHNA AUTOMOBILES PRIVATE LIMITED",
"YASHODA LAB PRIVATE LIMITED",
"YASHODA LOGISTICS PRIVATE LIMITED",
"YASHODA ORGANIC FOOD PRIVATE LIMITED",
"YASHODA RESOURCE CHANNEL LIMITED",
"YASHODA SUPER SPECIALITY HOSPITAL",
"YASHODA SUPER SPECIALITY HOSPITALS PRIVATE LIMITED",
"YASHODAKRISHNA AUTOMOBILES PRIVATE LIMITED",
"YASHODAPLUS PHARMACIES INDIA PRIVATE LIMITED",
"YASHODEEP CONSTRUCTIONS PRIVATE LIMITED",
"YASHODEEP INSTITUTE OF PHARMACY",
"YASHODHA MOTORS PRIVATE LIMITED",
"YASHODHA TECHNICAL CAMPUS SATARA",
"YASHODHA TRANSWHEELS LLP",
"YASHODHAM HIGH SCHOOL & JUNIOR COLLEGE",
"YASHODHAM HIGH SCHOOL AND JUNIOR COLLEGE",
"YASHODHAN HIGHWAYS PRIVATE LIMITED",
"YASHODHAN TRAVELS PRIVATE LIMITED",
"YASHODHARA SUPER-SPECIALITY HOSPITAL PRIVATE LIMITED",
"YASHODHRA INFRASTRUCTURE LLP",
"YASHOMATI HOSPITALS PRIVATE LIMITED",
"YASHOTEJ FOUNDATION",
"YASHOVARDHAN INVESTMENT & TRADING COMPANY LIMITED",
"YASHOWAN TOWER COOPERATIVE HOUSING SOCIETY LTD",
"YASHPAL CONSTRUCTIONS PRIVATE LIMITED",
"YASHPAL METALS PRIVATE LIMITED",
"YASHPG COMFY ABODE PRIVATE LIMITED",
"YASHRAAJ ETHANOLL PROCESSING PRIVATE LIMITED",
"YASHRAJ ALLOY INDUSTRIES PRIVATE LIMITED",
"YASHRAJ AUTOMATION SERVICES NAGPUR",
"YASHRAJ BIOTECHNOLOGY LIMITED",
"YASHRAJ CONSTRUCTION PRIVATE LIMITED",
"YASHRAJ CONTAINEURS LIMITED",
"YASHRAJ ELECTRICALS PRIVATE LIMITED",
"YASHRAJ INFRA PROJECTS PRIVATE LIMITED",
"YASHRAJ MOTORS PRIVATE LIMITED",
"YASHRAM LIFESTYLE BRANDS PRIVATE LIMITED",
"YASHSHIVANGI BUILCON PRIVATE LIMITED",
"YASHSHIVANGI DEVELOPERS PRIVATE LIMITED",
"YASHSHREE TRADERS PRIVATE LIMITED",
"YASHT CONSULTANTS PRIVATE LIMITED",
"YASHU IRON PRIVATE LIMITED",
"YASHUSS UNLIMITED BUSINESS SOLUTIONS PRIVATE LIMITED",
"YASHVANT BALAK MANDIR SHIRALA",
"YASHVANTRAO MOHITE COLLEGE OF ARTS SCIE",
"YASHVARDHAN MARKETING PVT LTD",
"YASHVEER CERAMIC",
"YASHVI AGRO INDUSTRIES PRIVATE LIMITED",
"YASHVI COAL & MINERALS PRIVATE LIMITED",
"YASHVI EXPORTS PRIVATE LIMITED",
"YASHVI FASHIONS PRIVATE LIMITED",
"YASHVI PRINTPACK PRIVATE LIMITED",
"YASHVI PROPERTIES PRIVATE LIMITED",
"YASHVI SYNTEX PRIVATE LIMITED",
"YASHVI TOURS AND TRAVELS PRIVATE LIMITED",
"YASHVIKRAM INFRASTRUCTURE PRIVATE LIMITED",
"YASHVIR EVENTS PRIVATE LIMITED",
"YASHWANT AGRITECH PRIVATE LIMITED",
"YASHWANT AGRO PRODUCT AND ALLIED INDUSTRIES PRIVATE LIMITED",
"YASHWANT ARTS AND SCIENCE JR COLLEGE DHAWADA TQ BHOKARDAN DI JALNA",
"YASHWANT DAIRY PRIVATE LIMITED",
"YASHWANT DHARMARTH RUGNALAYA KODOLI",
"YASHWANT DUGDH PRAKRIYA LIMITED",
"YASHWANT GRAPHIC PRIVATE LIMITED",
"YASHWANT HOSPITAL",
"YASHWANT HOSPITAL & TRAUMA CENTRE",
"YASHWANT IRON AND STEEL WORKS PRIVATE LIMITED",
"YASHWANT MEDICAL AND RESEARCH FOUNDATION LIMITED",
"YASHWANT SAHAKARI SOOT GIRNI MARYADIT AMBAD",
"YASHWANT SUGAR AND POWER PRIVATE LIMITED",
"YASHWANT VIDYALAYA & KANISHTA MAHAVIDYALAYA NANDURBAR",
"YASHWANTH RUTHWICK INFRA PROJECTS PRIVATE LIMITED",
"YASHWANTRAO CHAUHAN COLLEGE OF ENGINEERI",
"YASHWANTRAO CHAVAN AYURVEDIC MEDICAL COLLEGE AND HOSPITAL",
"YASHWANTRAO CHAVAN COLLEGE OF ARTS COMMERCE AND SCIENCE",
"YASHWANTRAO CHAVAN MEMORIAL HOSPITAL",
"YASHWANTRAO CHAVAN POLYTECHNIC ICHALKARANJI",
"YASHWANTRAO TECHNICAL AND TRAINING FOUNDATION",
"YASHWI SECURITIES PRIVATE LIMITED",
"YASIKA STEELS PRIVATE LIMITED",
"YASIKAN ENTERPRISES PRIVATE LIMITED",
"YASIN IMPEX INDIA PRIVATE LIMITED",
"YASKAWA DOOLIM INDIA PRIVATE LIMITED",
"YASKAWA INDIA PRIVATE LIMITED",
"YASMIN AIRCONDITIONING PRIVATE LIMITED",
"YASMIN'S BODY IMAGE PRIVATE LIMITED",
"YASODA COLD STORAGE PRIVATE LIMITED",
"YASONI GOLDIAM PRIVATE LIMITED",
"YASONS CHEMEX CARE LIMITED",
"YASORAM BUILDERS PRIVATE LIMITED",
"YASTA POWER PRIVATE LIMITED",
"YASTEL NETWORKS PRIVATE LIMITED",
"YASUI FIELD ENGINEERING PRIVATE LIMITED",
"YATCH COMMERCIAL PRIVATE LIMITED",
"YATEE REAL ESTATE PRIVATE LIMITED",
"YATEE TRADERS PRIVATE LIMITED",
"YATEEN ELECTRICAL AND ELECTRONICS PRIVATE LIMITED",
"YATES STEELS PRIVATE LIMITED",
"YATHAPU CONSULTING PRIVATE LIMITED",
"YATHARTH AGROTECH PRIVATE LIMITED",
"YATHARTH HOSPITAL & TRAUMA CARE SERVICES LIMITED",
"YATHARTH INFRASTRUCTURE PRIVATE LIMITED",
"YATHARTH SUPER SPECIALITY HOSPITAL",
"YATHARTH SUPERSPECIALITY HOSPITAL",
"YATHARTH VYAPAAR PVT LTD",
"YATHARTHA INVESTMENT AND FINANCE PRIVATE LIMITED",
"YATHIC INFRASTRUCTURE PRIVATE LIMITED",
"YATI INFOTECH SOLUTION PRIVATE LIMITED",
"YATI OVERSEAS PRIVATE LIMITED",
"YATIN SHAH HOSPITALS PRIVATE LIMITED",
"YATIN STEELS INDIA PRIVATE LIMITED",
"YATINDRA COLD STORAGE PRIVATE LIMITED",
"YATINIDHI CONSTRUCTIONS PRIVATE LIMITED",
"YATISH TRADING COMPANY PVT LTD",
"YATNA BUILDING MATERIALS PRIVATE LIMITED",
"YATNAM TECHNOLOGIES PRIVATE LIMITED",
"YATNESH PHARMA PRIVATE LIMITED",
"YATRA HOTEL SOLUTIONS PRIVATE LIMITED",
"YATRA ONLINE LIMITED",
"YATRA ONLINE PRIVATE LIMITED",
"YATRA TG STAYS PRIVATE LIMITED",
"YATRI CORPORATE SERVICES PRIVATE LIMITED",
"YATRI VIHAR HOSPITALITY PRIVATE LIMITED",
"YATRIK ARTS FURNITURE PRIVATE LIMITED",
"YATRIK NETWEORK PRIVATE LIMITED",
"YAVA PREFAB PRIVATE LIMITED",
"YAVASURA BREWS LLP",
"YAVICA GLOBAL DELIVERY CENTER PRIVATE LIMITED",
"YAWAL NAGARPARISHAD YAWAL",
"YAWALE COMBINES PRIVATE LIMITED",
"YAWALKAR PESTICIDES PRIVATE LIMITED",
"YAXIS STRUCTURAL STEELS PRIVATE LIMITED",
"YAXON BIO CARE PRIVATE LIMITED",
"YAY FUN FOODS PRIVATE LIMITED",
"YAYA PLAY ZONE PRIVATE LIMITED",
"YAYAATI MARKETING PRIVATE LIMITED",
"YAYAVAR LUGGAGE PRIVATE LIMITED",
"YAZAKI INDIA PRIVATE LIMITED",
"YAZALI FARMERS PRODUCER COMPANY LIMITED",
"YAZDAAN ENTERPRISE PRIVATE LIMITED",
"YAZDANI INTERNATIONAL (P) LTD.",
"YAZDANI PROJECTS & ESTATES PRIVATE LIMITED",
"YAZDANI STEEL & POWER LIMITED",
"YB GROUP OF INDUSTRIES PRIVATE LIMITED",
"YBER DIGITAL PRIVATE LIMITED",
"YBK INDUSTRIES PRIVATE LIMITED",
"YBM TRAVELS PRIVATE LIMITED",
"YBR INFORMATION PRIVATE LIMITED",
"YBR MUSIC PUBLISHING PRIVATE LIMITED",
"YBRANT PEOPLE MANPOWER & CONSULTING PRIVATE LIMITED",
"YBRANTWORKS PRIVATE LIMITED",
"YBS CABLES PRIVATE LIMITED",
"YBURIS INFOTECH PRIVATE LIMITED",
"YCD INDUSTRIES LIMITED",
"YCH LOGISTICS INDIA PRIVATE LIMITED",
"YCH TRADE SOLUTIONS PRIVATE LIMITED",
"YCM HOSPITAL",
"YCP SOLIDIANCE PRIVATE LIMITED",
"YCS BARODA PRIVATE LIMITED",
"YCS LINES PRIVATE LIMITED",
"YCUBE ENGINEERED SOLUTIONS PRIVATE LIMITED",
"YD FOREX AND HOLIDAYS PRIVATE LIMITED",
"YD TECHNOLOGY SERVICES INDIA PRIVATE LIMITED",
"YDP GLOBAL BUSINESS SOLUTIONS PRIVATE LIMITED",
"YDR CONSTRUCTIONS PRIVATE LIMITED",
"YDR DEVELOPERS PRIVATE LIMITED",
"YDRA EVENTS PRIVATE LIMITED",
"YEARBOOK CANVAS PRIVATE LIMITED",
"YEARN CONSTRUCTIONS INDIA PRIVATE LIMITED",
"YECTRA TECHNOLOGIES PRIVATE LIMITED",
"YED ELECTRIC PRIVATE LIMITED",
"YEDESHI AURANGABAD TOLLWAY LIMITED",
"YEDESHWARI AGRO PRODUCTS LIMITED",
"YEHCHINA EDUCATION PRIVATE LIMITED",
"YEL SRI RANGA SANKU COLLEGE",
"YELAHANKA - AP BORDER TOLLWAYS PRIVATE LIMITED",
"YELALA INDUSTRIAL SERVICES PRIVATE LIMITED",
"YELAMANCHILI COLD STORAGE PRIVATE LIMITED",
"YELAVARTHY FOUNDATIONS PRIVATE LIMITED",
"YELBEN ENGINEERING PRIVATE LIMITED",
"YELDI SOFTCOM PRIVATE LIMITED",
"YELLA CONSTRUCTIONS PRIVATE LIMITED",
"YELLOPHANT DIGITAL PRIVATE LIMITED",
"YELLOW BANANA FOOD COMPANY PRIVATE LIMITED",
"YELLOW BIRD PUBLICATIONS PRIVATE LIMITED",
"YELLOW BIRDS RETAIL PRIVATE LIMITED",
"YELLOW BOX HR SERVICES PRIVATE LIMITED",
"YELLOW DREAMS EXIM PRIVATE LIMITED",
"YELLOW DWELLING PRIVATE LIMITED",
"YELLOW FINTECH PRIVATE LIMITED",
"YELLOW JERSEYS LLP",
"YELLOW LILY HOSPITALITY PRIVATE LIMITED",
"YELLOW LINE ENGINEERING SERVICES PRIVATE LIMITED",
"YELLOW LOOP PRIVATE LIMITED",
"YELLOW MUSIC PRIVATE LIMITED",
"YELLOW OBJECTS SOLUTIONS PRIVATE LIMITED",
"YELLOW PANTHER TECHNOLOGY PRIVATE LIMITED",
"YELLOW PLY INDUSTRIES PRIVATE LIMITED",
"YELLOW SAPPHIRE TECHNOLOGIES PRIVATE LIMITED",
"YELLOW SEED CONTENT SOLUTIONS PRIVATE LIMITED",
"YELLOW SHADES PRIVATE LIMITED",
"YELLOW STAGE EVENTS AND EXHIBITIONS P L",
"YELLOW STONE ENGINEERS INDIA PRIVATE LIMITED",
"YELLOW STONE ESTATES PRIVATE LIMITED",
"YELLOW SUBMARINE FILM PRIVATE LIMITED",
"YELLOW THREAD INDIA PRIVATE LIMITED",
"YELLOW TURTLE SOLUTIONS PRIVATE LIMITED",
"YELLOWANT TECHNOLOGIES PRIVATE LIMITED",
"YELLOWCOPPER LLP",
"YELLOWDIGI PRIVATE LIMITED",
"YELLOWFIRST EXPERIENCES PRIVATE LIMITED",
"YELLOWLIGHT HOSPITALITY LLP",
"YELLOWLINE OVERSEAS PRIVATE LIMITED",
"YELLOWS AND GREENS AGRI FRESH PRIVATE LIMITED",
"YELLOWSQUASH PRIVATE LIMITED",
"YELLOWSTONE SKYSCRAPERS LLP",
"YELLOWTORK TECHNOLOGY PRIVATE LIMITED",
"YELSONS INDIA PRIVATE LIMITED",
"YELURI FORMULATIONS PRIVATE LIMITED",
"YEMYES DINES PRIVATE LIMITED",
"YEN ACADEMY LLP",
"YEN PLAS PVT LTD.",
"YENDIGITAL TECHNOLOGIES PRIVATE LIMITED",
"YENEPOYA FOOD AND BEVERAGES INDIA PRIVATE LIMITED",
"YENEPOYA FOUNDATION FOR TECHNOLOGY INCUBATION",
"YENEPOYA HOSPITALS",
"YENEPOYA INSTITUTE OF MEDICAL SCIENCES AND RESEARCH PRIVATE LIMITED",
"YENEPOYA INSTITUTE OF TECHNOLOGY",
"YENEPOYA SPECIALITY HOSPITAL",
"YENEPOYA UNIVERSITY",
"YENKAYS ENGINEERING PRIVATE LIMITED",
"YENNES INFOTEC PRIVATE LIMITED",
"YENOPOYA HOSPITAL &MEDICAL COLLEGE",
"YENOVUS PHARMA PRIVATE LIMITED",
"YENTOP COIRS PRIVATE LIMITED",
"YENTOP MANICKAM EDIBLE OILS PRIVATE LIMITED",
"YENTOP MANICKAVEL SONS EDIBLE OILS PRIVATE LIMITED",
"YENTRANS MARITIME LOGISTICS PRIVATE LIMITED",
"YEO HR INDIA PRIVATE LIMITED",
"YEOMAN EQUIPMENT PRIVATE LIMITED",
"YEOMAN MARINE PRIVATE LIMITED",
"YEOMAN MARINE SERVICES PRIVATE LIMITED",
"YEP EDUCATION PRIVATE LIMITED",
"YEPTHOMI MOTORS PRIVATE LIMITED",
"YERCAUD ELECTRONICS PRIVATE LIMITED",
"YERIK INTERNATIONAL",
"YERROWDA INVESTMENTS LIMITED",
"YERVIK GLOBAL PRIVATE LIMITED",
"YERWADA PRISON PRESS PUNE",
"YES 24 GUARDING & FACILITY SOLUTIONS PRIVATE LIMITED",
"YES AND YES INFRACON PRIVATE LIMITED",
"YES BANK LIMITED",
"YES BOND ADHESIVE PRIVATE LIMITED",
"YES CAPITAL (INDIA) PRIVATE LIMITED",
"YES CAPITAL VENTURE PRIVATE LIMITED",
"YES DYEING & PRINTING PRIVATE LIMITED",
"YES EMBROIDERY PRIVATE LIMITED",
"YES FACADE SYSTEMS PRIVATE LIMITED",
"YES FASHIONS PVT LTD",
"YES FUELS INDIA PRIVATE LIMITED",
"YES GARMENTS PRIVATE LIMITED",
"YES GERMANY MUMBAI",
"YES KEM INDUSTRIES PRIVATE LIMITED",
"YES KNITS",
"YES LAB TECHNOLOGIES PRIVATE LIMITED",
"YES LOANS PRIVATE LIMITED",
"YES LOGISTICS INDIA PRIVATE LIMITED",
"YES MECH ENGINEERING COMPANY PRIVATE LIMITED",
"YES NUTRIMENTS PRIVATE LIMITED",
"YES PROPERTY VENTURES PRIVATE LIMITED",
"YES SALT PRIVATE LIMITED",
"YES SECURITIES (INDIA) LIMITED",
"YES SHIPPING & LOGISTICS PRIVATE LIMITED",
"YES TECNO LIMITED",
"YES VCS INDIA PRIVATE LIMITED",
"YESEMM STEEL PRODUCTS ( KANJIKKODU ) PRIVATE LIMITED",
"YESES RETAIL VENTURES PRIVATE LIMITED",
"YESESDE MATCH COMPANY PRIVATE LIMITED",
"YESESI SUPERMARKET PRIVATE LIMITED",
"YESGT TRAVELS (INDIA) PRIVATE LIMITED",
"YESH LAMIPRINT PRIVATE LIMITED",
"YESH TECHNOLOGIES PRIVATE LIMITED",
"YESHA ELECTRICALS PRIVATE LIMITED",
"YESHA MECHANICAL WORKS PRIVATE LIMITED",
"YESHASHVI STEELS & ALLOYS PRIVATE LIMITED",
"YESHO FLOAT GLASS PRIVATE LIMITED",
"YESHODA ROSE BAZAAR RETAIL PRIVATE LIMITED",
"YESHODEEP INFRASTRUCTURE PRIVATE LIMITED",
"YESHSHREE PRESS COMPS PRIVATE LIMITED",
"YESHSHREE TECHNOLOGY PRIVATE LIMITED",
"YESHWANT VIDYALAYA TALEGAON",
"YESHWANT WIRES PRIVATE LIMITED",
"YESHWANTRAO CHAVAN COLLEGE OF ENGINEERING",
"YESIAMHITCHED PRIVATE LIMITED",
"YESINDIACAN INDUSTRIES PRIVATE LIMITED",
"YESITIS MARKETING PRIVATE LIMITED",
"YESJR DISTRIBUTORS PRIVATE LIMITED",
"YESKAY FACILITIES CONSULTANTS P LIMITED",
"YESMAN INFIN P LIMITED",
"YESORYES PRIVATE LIMITED",
"YESPOHO INDIA PRIVATE LIMITED",
"YESQUEST",
"YESRGB ARTSTUDIOS PRIVATE LIMITED",
"YESSSWORKS SPACES PRIVATE LIMITED",
"YESSTECH ENGINEERS & BUILDERS PRIVATE LIMITED",
"YESTEAM SECURITY AND MANPOWER SERVICE PRIVATE LIMITED",
"YESTEAM SOLUTION PRIVATE LIMITED",
"YESTER PHARMA PRIVATE LIMITED",
"YESTOSHINE PRIVATE LIMITED",
"YESVENTIVE IT LABS PRIVATE LIMITED",
"YESVI INFRA SOLUTIONS PRIVATE LIMITED",
"YETHI CONSULTING PRIVATE LIMITED",
"YEW PHARMA PRIVATE LIMITED",
"YEWALE AMRUTTULYA PRIVATE LIMITED",
"YEWALE FOOD PRODUCTS PRIVATE LIMITED",
"YEWBELLE HOME SOLUTION PRIVATE LIMITED",
"YEXLE DIGITAL SERVICES INDIA PRIVATE LIMITED",
"YEXT INDIA PRIVATE LIMITED",
"YF INDIA PRIVATE LIMITED",
"YFC AVIATION PRIVATE LIMITED",
"YFC CONCRETE PRIVATE LIMITED",
"YFC PROJECTS PRIVATE LIMITED",
"YFX STUDIOS PRIVATE LIMITED",
"YG CUTTING TOOLS CORPORATION PRIVATE LIMITED",
"YG ESTATES FACILITIES MANAGEMENT PRIVATE LIMITED",
"YG RESEARCH INDIA PRIVATE LIMITED",
"YGC PROJECTS LIMITED",
"YGM EQUIPMENT PRIVATE LIMITED",
"YH ENGINEERING PRIVATE LIMITED",
"Y-HAT ANALYTICS INDIA PRIVATE LIMITED",
"YHATAW REAL ESTATE FACILITATORS PRIVATE LIMITED",
"YIBEAL TRADEX PRIVATE LIMITED",
"YICHENG LOGISTICS (INDIA) PRIVATE LIMITED",
"YIELD 4 FINANCE PRIVATE LIMITED",
"YIELD INDIA PRIVATE LIMITED",
"YINDU TEXTILES PRIVATE LIMITED",
"YINGJIA COMMUNICATION PRIVATE LIMITED",
"YINGTONG ELECTRONIC TECHNOLOGY INDIA PRIVATE LIMITED",
"YINLUN ADM INDIA PRIVATE LIMITED",
"YIOT SOFTECH PRIVATE LIMITED",
"YIRE EXIM & HOTELS PRIVATE LIMITED",
"YIRON TECHNOLOGIES PRIVATE LIMITED",
"YITRO BUSINESS CONSULTANTS (INDIA) PRIVATE LIMITED",
"YIZUMI ADVANCED PROCESSING TECHNOLOGY PRIVATE LIMITED",
"YIZUMI PRECISION MACHINERY (INDIA) TECHNICAL CENTER PRIVATE LIMITED",
"YIZUMI PRECISION MACHINERY INDIA PRIVATE LIMITED",
"YJ POLYTEC PRIVATE LIMITED",
"YJ REALTY PRIVATE LIMITED",
"YJINUS SOLUTIONS PRIVATE LIMITED",
"YK COTTON & GINNING MILL PRIVATE LIMITED",
"YK GLOBAL PRIVATE LIMITED",
"YKA MEDIA PRIVATE LIMITED",
"YKING TOOLS MANUFACTURING COMPANY LIMITED",
"YKK INDIA PRIVATE LIMITED",
"YKM HOLDINGS PVT LTD",
"YLA INFRASTRUCTURES PRIVATE LIMITED",
"YLC INFRASTRUCTURE PRIVATE LIMITED",
"YLDA INDIA PRIVATE LIMITED",
"YLEM SOFTWARES PRIVATE LIMITED",
"YLM RECRUITS PRIVATE LIMITED",
"YLN INFRAPROJECTS PRIVATE LIMITED",
"YM GLOBAL TECHNOLOGIES PRIVATE LIMITED",
"YM LANDMARK PRIVATE LIMITED",
"YM MOTORS PRIVATE LIMITED",
"YMATECH PROFESSIONAL SERVICES PRIVATE LIMITED",
"YMC INDIA PRIVATE LIMITED",
"YMEDIA LABS PRIVATE LIMITED",
"YMP AGROTECH PRIVATE LIMITED",
"YMR CONSULTANCY SERVICES INDIA PRIVATE LIMITED",
"YMR NUTS PRIVATE LIMITED",
"YMRB INSIGHTS PRIVATE LIMITED",
"YMS BUSINESS SOLUTIONS PRIVATE LIMITED",
"YMS CONSULTANTS LIMITED",
"YMS FINANCE PRIVATE LIMITED",
"YMS LABORATORIES PRIVATE LIMITED",
"YNB CATERING SERVICES INDIA PRIVATE LIMITED",
"YNB HEALTHCARE PRIVATE LIMITED",
"YNG CONSTRUCTION INDIA PRIVATE LIMITED",
"YNG STEELS LIMITED",
"YNKRISH TRADELINK PRIVATE LIMITED",
"YNM PAN GLOBAL TRADE PRIVATE LIMITED",
"YNS INFRA PROJECTS PRIVATE LIMITED",
"YNT SUPPLY CHAIN PRIVATE LIMITED",
"YO DIGITALS PRIVATE LIMITED",
"YO SPACES DESIGN & BUILD PRIVATE LIMITED",
"YO SPORTS MANAGEMENT PRIVATE LIMITED",
"YOBOHO NEW MEDIA PRIVATE LIMITED",
"YOCHANA IT SOLUTIONS PRIVATE LIMITED",
"YOCOMAN SERVICES PRIVATE LIMITED",
"YOCTEL SOLUTIONS PRIVATE LIMITED",
"YOCTOZANT TECHNOLOGIES INDIA PRIVATE LIMITED",
"YODA- YOUTH ORGANISATION IN DEFNCE OF ANIMALS",
"YODAPLUS TECHNOLOGIES PRIVATE LIMITED",
"YODEVA PLASTICS PRIVATE. LIMITED",
"YODLEE INFOTECH PRIVATE LIMITED",
"YODLEY LIFE SCIENCES PRIVATE LIMITED",
"YOE YOE ELECTRONICS INDIA PRIVATE LIMITED",
"YOEKI SOFT PRIVATE LIMITED",
"YOFLIC INDIA PRIVATE LIMITED",
"YOG CHEM PRIVATE LIMITED",
"YOG ELECTRICALS PRIVATE LIMITED",
"YOG ELECTRO PROCESS PRIVATE LIMITED",
"YOG FASHIONS PRIVATE LIMITED",
"YOG SHRI SAI FACILITY & SECURITY PRIVATE LIMITED",
"YOGA BUILDERS PRIVATE LIMITED",
"YOGA SAW COLD STORAGE PRIVATE LIMITED",
"YOGAKSHEM SANSTHAN",
"YOGAKSHEMAM LOANS LIMITED",
"YOGANAND AUTOCOMP PRIVATE LIMITED",
"YOGANANDA INSTITUTE OF TECHNOLOGY AND SCIENCE",
"YOGANANDA MULTI SPECIALITY HOSPITAL",
"YOGASHRI HEAVY ENGINEERING PRIVATE LIMITED",
"YOGAYATAN PETROLEUM PRIVATE LIMITED",
"YOGENDRA HOTELS AND RESTAURANT PRIVATE LIMITED",
"MAHANSARIA ENTERPRISES PRIVATE LIMITED",
"YOGESH COMMERCIAL PRIVATE LIMITED",
"YOGESH CONSTRUCTION",
"YOGESH DYESTUFF PRODUCTS PRIVATE LIMITED",
"YOGESH FABTEX PRIVATE LIMITED",
"YOGESH INDUSTRIES",
"YOGESH OVERSEAS PRIVATE LIMITED",
"YOGESH SHAH SECURITIES PRIVATE LIMITED",
"YOGESH SWITCHGEARS AND CABLES PRIVATE LIMITED",
"YOGESH TRADING COMPANY",
"YOGESH TUBES PRIVATE LIMITED",
"YOGESH VANASPATI PRIVATE LIMITED",
"YOGESHVAR PRINTPACK PRIVATE LIMITED",
"YOGESHWAR CHEMICALS LIMITED",
"YOGESHWAR CONDUCTORS PRIVATE LIMITED",
"YOGESHWAR DEVELOPMENT PRIVATE LIMITED",
"YOGESHWAR EDUCATION FOUNDATION",
"YOGESHWAR ENGINEERING PVT LTD",
"YOGESHWAR IMPLANTS INDIA PRIVATE LIMITED",
"YOGESHWAR METAL PRIVATE LIMITED",
"YOGESHWARI SUGAR INDUSTRIES PRIVATE LIMITED",
"YOGHEM PACKAGING INDIA PRIVATE LIMITED",
"YOGI AIRCON PRIVATE LIMITED",
"YOGI AYURVEDIC PRODUCTS PRIVATE LIMITED",
"YOGI CAB INSULATION PRIVATE LIMITED",
"YOGI CROP SCIENCES PRIVATE LIMITED.",
"YOGI DYE-CHEM PRIVATE LIMITED",
"YOGI GRC PRODUCTS PRIVATE LIMITED",
"YOGI HI-TECH PVT LTD",
"YOGI HOLIDAY RESORTS PRIVATE LIMITED",
"YOGI HOTELS PVT LTD",
"YOGI INTERMEDIATES PRIVATE LIMITED",
"YOGI JEWELLERS PRIVATE LIMITED",
"YOGI JI TECHNOEQUIP PRIVATE LIMITED",
"YOGI KRIPA MEDI CHEM PRIVATE LIMITED",
"YOGI POLYFAB PRIVATE LIMITED",
"YOGI PROPERTIES PRIVATE LIMITED",
"YOGI STRUCTURED PACKINGS AND ENGINEERING PRIVATE LIMITED",
"YOGI STUCBUILD POWER PRIVATE LIMITED",
"YOGI TEXTURISERS LTD",
"YOGI VEMANA UNIVERSITY KADAPA",
"YOGI WIRES PRIVATE LIMITED",
"YOGIC FOODS PRIVATE LIMITED",
"YOGIJI DIGI PRIVATE LIMITED",
"YOGIKUTI PRIVATE LIMITED",
"YOGINDER BUILDWELL PRIVATE LIMITED",
"YOGINDERA POWERS LIMITED",
"YOGINDERA WORSTED LIMITED",
"YOGINI VASANTDEVI HOSPITAL",
"YOGIRAJ CABLE VISION PRIVATE LIMITED",
"YOGIRAJ HOSPITAL",
"YOGIRAJ METRO (OPC) PRIVATE LIMITED",
"YOGIRAJ POWERTECH PRIVATE LIMITED",
"YOGIRAM DISTRIBUTORS PRIVATE LIMITED",
"YOGISTAR TOURS AND FOREX PRIVATE LIMITED",
"YOGKAMAL CONSULTANTS PRIVATE LIMITED",
"YOGLEELA SULPHUR AND AGCHEM INDUSTRIES PRIVATE LIMITED",
"YOGMAYA CONSTRUCTION PRIVATE LIMITED",
"YOGMAYA HOSTELS PRIVATE LIMITED",
"YOGMAYA MARBLES PRIVATE LIMITED",
"YOGNA TRADING PRIVATE LIMITED",
"YOGODA SATSANGA MAHAVIDYALAYA",
"YOGVINDA PROMOTERS AND DEVELOPERS PRIVATE LIMITED",
"YOHA SECURITIES LIMITED",
"YOHO TECHNOLOGIES PRIVATE LIMITED",
"YOJAK FOODS AND BEVERAGES PRIVATE LIMITED",
"YOJAKA INDIA PRIVATE LIMITED",
"YOJANA INTERMEDIATES PVT LTD",
"YOJANA ORGANICS PRIVATE LIMITED",
"YOJANA POULTRY PRIVATE LIMITED",
"YOJANA UDYOG PRIVATE LIMITED",
"YOKE SECURITIES LIMITED",
"YOKINS INSTRUMENTS PRIVATE LIMITED",
"YOKO SOLUTIONS PRIVATE LIMITED",
"YOKOGAWA INDIA LIMITED",
"YOKOGAWA TECHNOLOGY SOLUTIONS INDIA PRIVATE LIMITED",
"YOKOHAMA INDIA PRIVATE LIMITED",
"YOKOSTONE CONTINENTAL LIMITED",
"YOLA STAYS LIMITED",
"YOLAX INFRANERGY PRIVATE LIMITED",
"YOLK STUDIO PRIVATE LIMITED",
"YOLO DESIGNS PRIVATE LIMITED",
"YOLO MEDIA PRIVATE LIMITED",
"YOLO TECHNOLOGIES PRIVATE LIMITED",
"YOMA BUSINESS SOLUTIONS PRIVATE LIMITED",
"YOMA MULTINATIONAL SOLUTIONS LLP",
"YOMA TECHNOLOGIES PRIVATE LIMITED",
"YOMIKA FABRICS PRIVATE LIMITED",
"YONAM INTERNATIONAL PRIVATE LIMITED",
"YONDR OPERATIONS INDIA PRIVATE LIMITED",
"YONEX INDIA PRIVATE LIMITED",
"YONG INDIA PRIVATE LIMITED",
"YONG SAN AUTOMOTIVE INDIA PRIVATE LIMITED",
"YONGHWA ACE INDUSTRY PRIVATE LIMITED",
"YONGNAM ENGINEERING INDIA PRIVATE LIMITED",
"YONKER SPORTS PRIVATE LIMITED",
"YOOCHANG ROBOTECH INDIA PRIVATE LIMITED",
"YOOFOO TECHNOLOGIES INDIA PRIVATE LIMITED",
"YOOIL ENVIROTECH PRIVATE LIMITED",
"YOONIL INDIA PRIVATE LIMITED",
"YOONWOO AUTOMOTIVE INDIA PRIVATE LIMITED",
"YOOSHA ERGONOMICS PRIVATE LIMITED",
"YOOSHIN ENGINEERING CORPORATION",
"YOP REAL ESTATE PRIVATE LIMITED",
"YOPTIMA MEDIA SOLUTIONS PRIVATE LIMITED",
"YORIES MEDIA PRIVATE LIMITED",
"YORK AGROTECH PRIVATE LIMITED",
"YORK BUILDERS PRIVATE LIMITED",
"YORK CELLULOSE PRIVATE. LIMITED.",
"YORK EXPORTS LIMITED",
"YORK INTERNATIONAL CORPORATION",
"YORK PRINT AND PACK",
"YORK PRINT PRIVATE LIMITED",
"YORK PRINTS PVT LTD",
"YORK REALTORS PRIVATE LIMITED",
"YORK TECH PRIVATE LIMITED",
"YORK TECHNOSYSTEMS PRIVATE LIMITED",
"YORK TRANSPORT EQUIPMENT INDIA PRIVATE LIMITED",
"YORK WINERY PRIVATE LIMITED",
"YORKER ENGINEERING PRIVATE LIMITED",
"YORKER HOLIDAYS SERVICES PRIVATE LIMITED",
"YOROZU JBM AUTOMOTIVE TAMIL NADU PRIVATE LIMITED",
"YOSA TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"YOSH INFRATECH PRIVATE LIMITED",
"YOSHAMA AND COMPANY PRIVATE LIMITED",
"YOSHIAKI CHEMICALS COMPANY PRIVATE LIMITED",
"YOSHIKA ENGINEERING PRIVATE LIMITED",
"YOSHIN SALES INDIA PRIVATE LIMITED",
"YOSHITHA HOUSING AND INFRA PRIVATE LIMITED",
"YO-TANA FILTRATION EQUIPMENTS PRIVATE LIMITED",
"YO-TANA MACHINE TOOLS PRIVATE LIMITED",
"YOTI BIOMETRIC IDENTITY PRIVATE LIMITED",
"YOTI HEAT TREATMENT PRIVATE LIMITED",
"YOTTA AGRO VENTURES PRIVATE LIMITED",
"YOTTA BUSINESS VENTURES PRIVATE LIMITED",
"YOTTA INFRASTRUCTURE SOLUTIONS LLP",
"YOTTABYTE AVIT & BUSINESS SOLUTIONS PRIVATE LIMITED",
"YOTTACTO CONSULTING PRIVATE LIMITED",
"YOU & ME COMMUNICATIONS PRIVATE LIMITED",
"YOU BROADBAND INDIA LIMITED",
"YOU SEUNG SANG SA INDIA CONSTRUCTION PRIVATE LIMITED",
"YOU V RESEARCH PRIVATE LIMITED",
"YOUCANFREE.US HUMAN RIGHTS PROTECTION SERVICES PRIVATE LIMITED",
"YOUDEE MERCHANDISING SOLUTIONS PRIVATE LIMITED",
"YOUGAL SONS FASHIONS PRIVATE LIMITED",
"YOUGOTAGIFT PRIVATE LIMITED",
"YOUHE LOGISTICS PRIVATE LIMITED",
"YOUHIVE SOLUTIONS PRIVATE LIMITED",
"YOUKRAFT SOLUTIONS PRIVATE LIMITED",
"YOUMEPRIME SELLER SERVICES PRIVATE LIMITED",
"YOUMINT MEDIA PRIVATE LIMITED",
"YOUNG ATTITUDE VENTURES PRIVATE LIMITED",
"YOUNG BRAND APPAREL PRIVATE LIMITED",
"YOUNG BUHMWOO INDIA COMPANY PRIVATE LIMITED",
"YOUNG BUILDERS PRIVATE LIMITED",
"YOUNG DECADE IT SOFTWARE SOLUTION",
"YOUNG EMPEROR SERVICE PRIVATE LIMITED",
"YOUNG ENGG & CALIBRATION SERVICES PRIVATE LIMITED",
"YOUNG HATS PRIVATE LIMITED",
"YOUNG HORIZONS SCHOOL",
"YOUNG INDIA CONSTRUCTION PRIVATE LIMITED",
"YOUNG INDIA INFORMATION TECHNOLOGY SERVICES PRIVATE LIMITED",
"YOUNG INDIA PRESTRESS PVT LTD",
"YOUNG INDIAN",
"YOUNG KNIGHT EXPRESS PRIVATE LIMITED",
"YOUNG LIVES PRIVATE LIMITED",
"YOUNG MONK COMMUNICATIONS PRIVATE LIMITED",
"YOUNG OPTIMISTIC TRANSPORT SOLUTIONS PRIVATE LIMITED",
"YOUNG PRESIDENTS ORGANISATION (CHENNAI CHAPTER)",
"YOUNG PRESIDENTS ORGANISATION (KERALA CHAPTER)",
"YOUNG PRESIDENT'S ORGANISATION (PUNJAB CHAPTER)",
"YOUNG PRESIDENTS ORGANIZATION (MUMBAI CHAPTER)",
"YOUNG STAR FOOTWEAR PRIVATE LIMITED",
"YOUNG STEELS PRIVATE LIMITED",
"YOUNG TEA PRIVATE LIMITED",
"YOUNGMAN BLANKETS PRIVATE LIMITED",
"YOUNGMAN INDIA PRIVATE LIMITED",
"YOUNGMAN MANUFACTURING INDIA PRIVATE LIMITED",
"YOUNGMAN WOOLLEN MILLS PRIVATE LIMITED",
"YOUNGMINDS TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"YOUNGSEONG INDIA PRIVATE LIMITED",
"YOUNGSHIN AUTOMOTIVE INDIA PRIVATE LIMITED",
"YOUNGSHIN MOTHERSON AUTO TECH LIMITED",
"YOUNION FOCUSED MARKETING SERVICES PRIVATE LIMITED",
"YOUNITY ENERGY PRIVATE LIMITED",
"YOUR FITNESS CLUB PRIVATE LIMITED",
"YOUR LEARNING PRIVATE LIMITED",
"YOUR LIFESTYLE PRIVATE LIMITED",
"YOUR NURSE INDIA",
"YOUR OWN WAY SOLUTIONS PRIVATE LIMITED",
"YOUR PRACTICE ONLINE INDIA PRIVATE LIMITED",
"YOUR STAFFING SOLUTIONS PRIVATE LIMITED",
"YOURASSISTANT LLP",
"YOURDOST HEALTH SOLUTIONS PRIVATE LIMITED",
"YOURNEST CAPITAL ADVISORS PRIVATE LIMITED",
"YOUROWNROOM PRIVATE LIMITED",
"YOURPICK CLOTHING PRIVATE LIMITED",
"YOURQUOTE SOLUTIONS PRIVATE LIMITED",
"YOURS EFFICIENTLY CONSULTING & TECHNOLOGY SERVICES PRIVATE LIMITED",
"YOURS PROJECTS PRIVATE LIMITED",
"YOURSTORY MEDIA PRIVATE LIMITED",
"YOURWAY TRANSPORT BIOPHARMA SERVICES PRIVATE LIMITED",
"YOUTAG INFOTECH PRIVATE LIMITED",
"YOUTH 4 JOBS FOUNDATION",
"YOUTH ENERGY HEALTH MARKETING PRIVATE LIMITED",
"YOUTH HOSTELS ASSOCIATION OF INDIA",
"YOUTH INDIA AUTO COMPONENTS PRIVATE LIMITED",
"YOUTH SERVICES SPORTS DEPTT",
"YOUTH SHOPPING PLAZA PRIVATE LIMITED",
"YOUTHAID GLOBAL SERVICES PRIVATE LIMITED",
"YOUTHSTAR VANIJYA PRIVATE LIMITED",
"YOUTILITY TECHNOLOGIES PRIVATE LIMITED",
"YOUVANA ENTERPRISE PRIVATE LIMITED",
"YOUZU INDIA PRIVATE LIMITED",
"YOVANT LABS PRIVATE LIMITED",
"YOYO FASHION INDIA PRIVATE LIMITED",
"YOYO FOOD STUFF PRIVATE LIMITED",
"YOYO MEDIA PRIVATE LIMITED",
"YP FOODS PRIVATE LIMITED",
"YP INNOVATIONS PRIVATE LIMITED",
"YPA RESTAURANT PRIVATE LIMITED",
"YPL INFO-TECH PRIVATE LIMITED",
"YPO (CALCUTTA)",
"YPO (DELHI CHAPTER)",
"YPO BANGALORE CHAPTER",
"YPO MUMBAI CONNECT FOUNDATION",
"YPO RAJASTHAN",
"YPO SOUTH ASIA CHAPTER",
"YPP AGRO CORP PRIVATE LIMITED",
"YPR ENGINEERING AND SOLUTIONS PRIVATE LIMITED",
"YPSOMED INDIA PRIVATE LIMITED",
"YQ SOFT LABS PRIVATE LIMITED",
"YR GAITONDE MEDICAL EDUCATIONAL AND RESEARCH FOUNDATION",
"YR IMPEX TRADING PRIVATE LIMITED",
"YRALS DIGITAL INDIA PRIVATE LIMITED",
"YRB TRADING PRIVATE LIMITED",
"YRC LOGISTICS INDIA PRIVATE LIMITED",
"YRF STUDIOS PRIVATE LIMITED",
"YRF TELEVISION PRIVATE LIMITED",
"YRK BROADCASTING PRIVATE LIMITED",
"YRPS LINES PRIVATE LIMITED",
"YRR TEX FAB PRIVATE LIMITED",
"YRS MANPOWER SOLUTION PRIVATE LIMITED",
"YRSR PRIVATE LIMITED",
"YS ACADEMY PRIVATE LIMITED",
"YS BRANDS PRIVATE LIMITED",
"YS CAPITAL",
"YS COMMUNICATIONS PRIVATE LIMITED",
"YS ECOFIBRE PRIVATE LIMITED",
"YS EVENTS PRIVATE LIMITED",
"YS POLYMERS PRIVATE LIMITED",
"YS ROAD CARRIERS PRIVATE LIMITED",
"YSC INDIA BUSINESS PSYCHOLOGISTS PRIVATE LIMITED",
"YSECIT SOFTWARES INDIA PRIVATE LIMITED",
"YSI AUTOMOTIVE PRIVATE LIMITED",
"YSK INFO TECH PRIVATE LIMITED",
"YSL ESTATES PRIVATE LTD",
"YSM BUILDCON PRIVATE LIMITED",
"YSM DAIRY & BIOTECH PRIVATE LIMITED",
"YSM INDIA TECHNOLOGIES PRIVATE LIMITED",
"YSM INTERNATIONAL PRIVATE LIMITED",
"YSR INDUSTRIES PRIVATE LIMITED",
"YSR STEEL CORPORATION LIMITED",
"YST LIFE SCIENCES PRIVATE LIMITED",
"YSTRAL INDIA PRIVATE LIMITED",
"YT COMMODITIES BROKING PRIVATE LIMITED",
"YT PROPERTIES PRIVATE LIMITED",
"YTC FABRICS PRIVATE LIMITED",
"YTL MANUFACTURING PRIVATE LIMITED",
"YTS TRAVEL SERVICES PRIVATE LIMITED",
"YU BEAUTY AND WELLNESS LLP",
"YU TECHNOLOGIES PRIVATE LIMITED",
"YUAM CREW MANAGEMENT PRIVATE LIMITED",
"YUANTAI INTERNATIONAL SUPPLY CHAIN MANAGEMENT PRIVATE LIMITED",
"YUASA TRADING INDIA PRIVATE LIMITED",
"YUCAN SOLUTIONS PRIVATE LIMITED",
"YUCCA IT SOLUTIONS PRIVATE LIMITED",
"YUCON EXPORTS PVT LTD",
"YUCON OVERSEAS PRIVATE LIMITED",
"YUDEK ENGINEERING PRIVATE LIMITED",
"YUDHISHTHRA KAPUR EXPORTS PRIVATE LIMITED",
"YUDIZ SOLUTIONS LIMITED",
"YUDO HOT RUNNER INDIA PRIVATE LIMITED,",
"YUEDU TECHNOLOGY PRIVATE LIMITED",
"YUFLOW ENGINEERING PRIVATE LIMITED",
"YUG BITE AND VITTLES PRIVATE LIMITED",
"YUG CARGO AND COURIER SERVICES PRIVATE LIMITED",
"YUG CARS",
"YUG COMPUTECH PRIVATE LIMITED",
"YUG DECOR LIMITED",
"YUG ENTERPRISES PRIVATE LIMITED",
"YUG GLOBAL PRIVATE LIMITED",
"YUG INDIA PRIVATE LIMITED",
"YUG INFRASTRUCTURES PRIVATE LIMITED",
"YUG INTERNATIONAL PRIVATE LIMITED",
"YUG NIRMAN INTER COLLEGE",
"YUG SEALINE PRIVATE LIMITED",
"YUG SECURITIES PRIVATE LIMITED",
"YUG SHAKTI CARE SERVICES PRIVATE LIMITED",
"YUGA HOMES LIMITED",
"YUGA PHARMA PRIVATE LIMITED",
"YUGA STOCKS & COMMODITIES PRIVATE LIMITED",
"YUGABYTE SOFTWARE PRIVATE LIMITED",
"YUGAL CHIT FUND AND TRADING CO PRIVATE LIMITED",
"YUGAL CONCRETE FLOORS PRIVATE LIMITED",
"YUGAL PRECISION PRIVATE LIMITED",
"YUGAL RAS PRIVATE LIMITED",
"YUGANT INFRASTRUCTURE PRIVATE LIMITED",
"YUGANTAR PUBLIC SCHOOL RAJNANDGAON",
"YUGASA SOFTWARE LABS PRIVATE LIMITED",
"YUGASMITA INNOVATIONS PRIVATE LIMITED",
"YUGASYS SOFTWARE PRIVATE LIMITED",
"YUGEN ANALYTICS PRIVATE LIMITED",
"YUGEN CHEMICALS PRIVATE LIMITED",
"YUGSTART TECHNOLOGIES PRIVATE LIMITED",
"YU-HAI TECHNOLOGY & MANUFACTURING SUPPLIES PRIVATE LIMITED",
"YUHAN TECHNOPAC PRIVATE LIMITED",
"YUJ DESIGNS PRIVATE LIMITED",
"YUJI INTERMEDIATES PRIVATE LIMITED",
"YUKEN INDIA LIMITED",
"YUKENG MACHINERY PRIVATE LIMITED",
"YUKIE MOTORS PRIVATE LIMITED",
"YUKO COMPUTERS PRIVATE LIMITED",
"YUKRA PROJECTS PRIVATE LIMITED",
"YUKSEL PROJE INDIA PRIVATE LIMITED",
"YUKTA ELECTRO PRIVATE LIMITED",
"YUKTHA ENERGY SOLUTIONS PRIVATE LIMITED",
"YUKTHA MOTORS PRIVATE LIMITED",
"YUKTHI CONSULTING SERVICES PRIVATE LIMITED",
"YUKTHI DATASOFT PRIVATE.LIMITED",
"YUKTI MULTIMEDIA PRIVATE LIMITED",
"YUKTI SECURITIES PRIVATE LIMITED",
"YUKTI SOLUTIONS PRIVATE LIMITED",
"YUKTI WIND AND POWER PRIVATE LIMITED",
"YULE INVESTMENTS PRIVATE LIMITED",
"YULICIOUS HOSPITALITY PRIVATE LIMITED",
"YULU BIKES PRIVATE LIMITED",
"YUM INDIA TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"YUM RESTAURANTS INDIA PRIVATE LIMITED",
"YUM RESTAURANTS MARKETING PRIVATE LIMITED",
"YUME INDIAPRIVATE LIMITED",
"YUME TECHNOLOGIES PRIVATE LIMITED",
"YUMERTO OILFIELD CONSTRUCTION AND TRADING PRIVATE LIMITED",
"YUMFOODS & CONFECTIONERIES PRIVATE LIMITED",
"YUMIST FOODTECH PRIVATE LIMITED",
"YUMMIQO F&B PRIVATE LIMITED",
"YUMMY FOODSPECIALITIES PRIVATE LIMITED",
"YUMMY TUMMY FOODS PRIVATE LIMITED",
"YUMMYGO SHOTS PRIVATE LIMITED",
"YUMTIMES HOSPITALITY PRIVATE LIMITED",
"YUNAV REPROCESSORS PRIVATE LIMITED",
"YUNCA MACHINERY MANUFACTURING PRIVATE LIMITED",
"YUNCHENG ROTOGRAVURE PRIVATE LIMITED",
"YUNFANG METALS PRIVATE LIMITED",
"YUNG DIGITAL MEDIA INDIA PRIVATE LIMITED",
"YUNITIVE INFRA PRIVATE LIMITED",
"YUNO PACKAGING PRIVATE. LIMITED.",
"YUNUS KHAN HAJI MUSA KHAN URDU HIGH SCHOOL BHADGAON",
"YUNUS SOCIAL BUSINESS FUND BENGALURU PRIVATE LIMITED",
"YUPAA FRESH PRIVATE LIMITED",
"YUPP VIDEO SERVICES INDIA PRIVATE LIMITED",
"YUPPLE TECHNOLOGIES PRIVATE LIMITED",
"YUPPTV DIGITAL INDIA PRIVATE LIMITED",
"YUPPTV INDIA PRIVATE LIMITED",
"YURATECH GLOBAL PRIVATE LIMITED",
"YUSATA INFOTECH PRIVATE LIMITED",
"YUSEN LOGISTICS INDIA PRIVATE LIMITED",
"YUSEONG ENTERPRISES PRIVATE LIMITED",
"YUSH ENGINEERING AND STRUCTURES PRIVATE LIMITED",
"YUSHIN PRECISION EQUIPMENT INDIA PRIVATE LIMITED",
"YUSHIRO INDIA COMPANY PRIVATE LIMITED",
"YUTAKA AUTOPARTS INDIA PRIVATE LIMITED",
"YUTECH HYDRAULIC (INDIA) PRIVATE LIMITED",
"YUTI TEXTILE PROCESSORS PRIVATE LIMITED",
"YUTIKA NATURAL PRIVATE LIMITED",
"YUTIKA WELFARE FOUNDATION",
"YUTO PRINTING & PACKAGING INDIA PRIVATE LIMITED",
"YUVA ENRICHMENT SERVICES PRIVATE LIMITED",
"YUVA FREIGHT CARRIERS PRIVATE LIMITED",
"YUVA HEALTH CARE INDIA PRIVATE LIMITED",
"YUVA HERBS",
"YUVA JUNIOR COLLEGE",
"YUVA MITRA",
"YUVA MOTORS PRIVATE LIMITED",
"YUVA NAVNIRAM GROUP TRUST MEHSANA",
"YUVA TRAVELS PRIVATE LIMITED",
"YUVA TRIP PRIVATE LIMITED",
"YUVAAN ENERGY PRIVATE LIMITED",
"YUVAAN INFRASTRUCTURE PRIVATE LIMITED",
"YUVAAN MEDICARE PRIVATE LIMITED",
"YUVAKMANGAL AGROTECH FARMERS PRODUCER COMPANY LIMITED",
"YUVAKSHETRA INSTITUTE OF MANAGEMENT STUDIES PALAKKAD",
"YUVAN FARMERS PRODUCER COMPANY LIMITED",
"YUVARAJ FACILITY SERVICES PRIVATE LIMITED",
"YUVARAJ INTERNATIONAL PRIVATE LIMITED",
"YUVARAJ VENTURES PRIVATE LIMITED",
"YUVARAJA TEA MANUFACTURING COMPANY PRIVATE LIMITED",
"YUVASHAKTHI ENTERPRISES",
"YUVASHAKTI TEA PROCESSOR PRIVATE LIMITED",
"YUVASHAKTI WARRIORS PRIVATE LIMITED",
"YUVDHI APPARELS PRIVATE LIMITED",
"YUVEER HOME DECOR PRIVATE LIMITED",
"YUVI FOODS PRIVATE LIMITED",
"YUVI HOSPITALITY PRIVATE LIMITED",
"YUVI IMPEX PRIVATE LIMITED",
"YUVI INNOVATE PRIVATE LIMITED",
"YUVIAARA ISPAT PRIVATE LIMITED",
"YUVIKA METACAST PRIVATE LIMITED",
"YUVIKA SILK MILLS PRIVATE LIMITED",
"YUVISH INDUSTRIES PRIVATE LIMITED",
"YUVISYSTEMS",
"YUVITECH SOLUTIONS PRIVATE LIMITED",
"YUVNAM PRIVATE LIMITED",
"YUVRAJ BUILDCON PRIVATE LIMITED",
"YUVRAJ CHEMICALS PRIVATE LIMITED",
"YUVRAJ CONSTRUCTIONS AND LEASING (INDIA) LIMITED",
"YUVRAJ FASHIONS PRIVATE LIMITED",
"YUVRAJ LUBE AND PETRO CHEMICAL PRIVATE L IMITED",
"YUVRAJ OVERSEAS PRIVATE LIMITED",
"YUVRAJ PACKAGING INDIA PRIVATE LIMITED",
"YUVRAJ PHARMACEUTICALS PRIVATE LIMITED",
"YUVRAJ SINGH GROUP PRIVATE LIMITED",
"YUVRAJ STEEL PRIVATE LIMITED",
"YUWAN FINANCIERS PRIVATE LIMITED",
"YUWASA INDUSTRIES INDIA PRIVATE LIMITED",
"YUWATECH ENGINEERING SOLUTIONS PRIVATE LIMITED",
"YUYU MEDIMPEX PRIVATE LIMITED",
"YUZEN MOBILITY PRIVATE LIMITED",
"YVU FINANCIAL SERVICES PRIVATE LIMITED",
"YVU MILK PRODUCER COMPANY LIMITED",
"YVZ MOTTORS PRIVATE LIMITED",
"YWC SPORTS PRIVATE LIMITED",
"YXIOM TECHNOLOGIES PRIVATE LIMITED",
"YYYS CONSTRUCTION PRIVATE LIMITED",
"Z & H CONSULTANCY SERVICES PRIVATE LIMITED",
"Z AND A INFOTEK PRIVATE LIMITED",
"Z H INTERNATIONAL PRIVATE LIMITED",
"Z P C P S DAVALA",
"Z P HIGH SCHOOL NER",
"Z P P S JAMDI TANDA CPS WADNER",
"Z P P S POKALWADGAON",
"Z P P S SHELWADA",
"Z P P S SOYGAON DEVI",
"Z P PRATHMIK SHALA KOLGAON GEORAI BEED",
"Z P PRATHMIK SHALA VAIDYA KINHI BEED",
"Z P PRIMARY SCHOOL KHACHADPADA",
"Z P PRIMARY SCHOOL SUKALI",
"Z P PRY SCHOOL BABAPUR",
"Z P PS SHIVAPURI DHOROSHI",
"Z P SCHOOL",
"Z P SCHOOL BIJYAMAL",
"Z P SCHOOL DHADGAON",
"Z P UPPER PRIMARY SCHOOL",
"Z P UPPER PRM SCHOOL PHARADA",
"Z P URDU SHALA NIJAMPUR",
"Z PLUS DISPOSABLE PRIVATE LIMITED",
"Z PLUS SURVEILLANCE SECURITY PRIVATE LIMITED",
"Z STAR COMMOTRADE PVT LTD",
"Z TRONICS INFRATEL PRIVATE LIMITED",
"Z V STEELS PRIVATE LIMITED",
"Z&L FASHION PRIVATE LIMITED",
"Z. A EXIM PRIVATE LIMITED",
"Z. A. SEA FOODS PRIVATE LIMITED",
"Z. ENGINEERS CONSTRUCTIONS PRIVATE LIMITED",
"Z.F.FILAMENTS PRIVATE LIMITED",
"Z9 STEEL PRIVATE LIMITED",
"ZA CAPITAL SERVICES INDIA PRIVATE LIMITED.",
"ZAAB FASHION LIMITED",
"ZAAK EPAYMENT SERVICES PRIVATE LIMITED",
"ZAAL COMMERCIAL PRIVATE LIMITED",
"ZAAMOR INTERNATIONAL LIFESTYLE PRIVATE LIMITED",
"ZAAN RESTAURANTS PRIVATE LIMITED",
"ZAAN WEBVEDA PRIVATE LIMITED",
"ZAAROZ SERVICES PRIVATE LIMITED",
"ZABDA TECHNOLOGIES PRIVATE LIMITED",
"ZABIN INDIA PRIVATE LIMITED",
"ZABRON LIFE SCIENCES PRIVATE LIMITED",
"ZACCO INDIA R&D PRIVATE LIMITED",
"ZACH RUBBER PRIVATE LIMITED",
"ZACK MARKETING (INDIA) PRIVATE LIMITED",
"ZACKS RESEARCH PRIVATE LIMITED",
"ZACLON INDIA LIMITED",
"ZACO COMPUTERS PRIVATE LIMITED",
"ZADARA TECHNOLOGIES INDIA PRIVATE LIMITED",
"ZADO INFOTECH SOLUTIONS INDIA PRIVATE LIMITED",
"ZADORA DESIGNS PRIVATE LIMITED",
"ZAFF JAY MEDICAL SERVICE (INDIA) PRIVATE LIMITED",
"ZAFIN SOFTWARE CENTRE OF EXCELLENCE PRIVATE LIMITED",
"ZAGGLE PREPAID OCEAN SERVICES LIMITED",
"ZAGGLE PREPAID OCEAN SERVICES PRIVATE LIMITED",
"ZAHARA FOOD PRODUCTS PRIVATE LIMITED",
"ZAHEER KHANS HOSPITALITY PRIVATE LIMITED",
"ZAHI TYRES INDIA PRIVATE LIMITED",
"ZAHIDI PHARMACEUTICALS PRIVATE LIMITED",
"ZAHONERO INDIA PRIVATE LIMITED",
"ZAHORANSKY MOULDS AND MACHINES PRIVATE LIMITED",
"ZAHRAWI HEALTH SOLUTIONS PRIVATE LIMITED",
"ZAIDI EXPORT PRIVATE LIMITED",
"ZAIGO INFOTECH SOFTWARE SOLUTIONS PRIVATE LIMITED",
"ZAIN ENGINEERS & TECHNOLOGIES CONSULTANTS PRIVATE LIMITED",
"ZAIN NATURAL AGRO INDIA PRIVATE LIMITED",
"ZAINAB AGENCIES & LOGISTICS PRIVATE LIMITED",
"ZAINAB INTERNATIONAL PRIVATE LIMITED",
"ZAITEX CHEMICALS PRIVATE LIMITED",
"ZAIVA LIFESCIENCES PRIVATE LIMITED (OPC)",
"ZAK ADVISORS PRIVATE LIMITED",
"ZAK DECOR MART PRIVATE LIMITED",
"ZAK GLOBAL SERVICES PRIVATE LIMITED",
"ZAK HARDWARE PRIVATE LIMITED",
"ZAK INFRAPROJECTS PRIVATE LIMITED",
"ZAK TRADE FAIRS & EXHIBITIONS PRIVATE LIMITED",
"ZAK VENTURE PRIVATE LIMITED",
"ZAKAPPS SOFTWARE PRIVATE LIMITED",
"ZAKARIYA AGRO PRIVATE LIMITED",
"ZAKASHA FOOD CART PRIVATE LIMITED",
"ZAKI & ASSOCIATE",
"ZAKIR HUSAIN DELHI COLLEGE",
"ZAKOOPI INFOTECH PRIVATE LIMITED",
"ZAKS SUPPLY CHAIN PRIVATE LIMITED",
"Z-AKSYS SOLUTIONS PRIVATE LIMITED",
"ZALAK POLYPACK PRIVATE LIMITED",
"ZALARIS HR SERVICES INDIA PRIVATE LIMITED",
"ZALE SHIPPING & LOGISTICS SERVICES PRIVATE LIMITED",
"ZALE TRADING PRIVATE LIMITED",
"ZALONI TECHNOLOGIES INDIA PRIVATE LIMITED",
"ZAM ENGG AND LOGISTICS PRIVATE LIMITED",
"ZAM ZAM ENTERPRISE PRIVATE LIMITED",
"ZAM ZAM RESTAURANT PRIVATE LIMITED",
"ZAMBAD GASES PRIVATE LIMITED",
"ZAMBAD INFRASTRUCTURE LIMITED",
"ZAMBAD JEWELLERS PRIVATE LIMITED",
"ZAMBIA HIGH COMMISSION",
"ZAMBO TECHNOLOGY INDIA PRIVATE LIMITED",
"ZAMBRE CONSTROTECH PRIVATE LIMITED",
"ZAMCO APPAREL PRIVATE LIMITED",
"ZAMIA SECURITIES AND FINANCE PRIVATE LIMITED",
"ZAMIL AIR CONDITIONERS INDIA PRIVATE LIMITED",
"ZAMIL CONSTRUCTION INDIA PRIVATE LIMITED",
"ZAMIL INFORMATION TECHNOLOGY GLOBAL PRIVATE LIMITED",
"ZAMIL STEEL BUILDINGS INDIA PRIVATE LIMITED",
"ZAMIL STEEL ENGINEERING INDIA PRIVATE LIMITED",
"ZAMINDARA ENGINEERING AND AUTOS PRIVATE LIMITED",
"ZAMINDARA TIMBER PRIVATE LIMITED",
"ZAMINDARINI KAMULAMMAL MEMORIAL EDUCATIONAL FOUNDATION",
"ZAMMAR ALLOYS PRIVATE LIMITED",
"ZAMSTARS MANAGEMENT SERVICES INDIA PRIVATE LIMITED",
"ZANACEA BIOTEC PRIVATE LIMITED",
"ZANANA HOSPITAL -GOVT RAJ",
"ZANDERS RESORTS PRIVATE LIMITED",
"ZANDRA HEALTHCARE PRIVATE LIMITED",
"ZANDRA LIFE SCIENCES PRIVATE LIMITED",
"ZANDU FOUNDATION FOR HEALTH CARE",
"ZANDU REALTY LIMITED",
"ZANEC SOFT TECH PRIVATE LIMITED",
"ZANEKA HEALTHCARE LIMITED",
"ZANEKA PHARMACEUTICALS PRIVATE LIMITED",
"ZANGFAI EVENTS AND PROMOTIONS PRIVATE LIMITED",
"ZANNAT BEVERAGES PRIVATE LIMITED",
"ZANSHIN HOLDINGS PRIVATE LIMITED",
"ZANSKAR PROPERTIES PRIVATE LIMITED",
"ZANTHUS ALLIED SERVICES PRIVATE LIMITED",
"ZANTIC PHARMACEUTICALS PRIVATE LIMITED",
"ZANVAR ENGINEERING EXPORTS PVT LTD",
"ZANZAR JEWELLERS PRIVATE LIMITED",
"ZAOCBDT",
"ZAP LOGISTICARE PRIVATE LIMITED",
"ZAP TECH PRIVATE LIMITED",
"ZAPAK DIGITAL ENTERTAINMENT LIMITED",
"ZAPAK GAMES PRIVATE LIMITED",
"ZAPAK MOBILE GAMES PRIVATE LIMITED",
"ZAPATO EXPORTS PRIVATE LIMITED",
"ZAPBUILD TECHNOLOGIES PRIVATE LIMITED",
"ZAPBYTES TECHNOLOGIES PRIVATE LIMITED",
"ZAPCOM SOLUTIONS PRIVATE LIMITED",
"ZAPDESK ITES SOLUTIONS PRIVATE LIMITED",
"ZAPFEN INTERNATIONAL",
"ZAPFIN TEKNOLOGIES PRIVATE LIMITED",
"ZAPI INDIA PRIVATE LIMITED",
"ZAPI TECHNOLOGIES INDIA PRIVATE LIMITED",
"ZAPIMON TECHNOLOGIES PRIVATE LIMITED",
"ZAPMINATI MARKETING PRIVATE LIMITED",
"ZAPP PRECISION METALS (INDIA) PRIVATE LIMITED",
"ZAPPIAN MEDIA INDIA PRIVATE LIMITED",
"ZAPPY HOME SOLUTIONS PRIVATE LIMITED",
"ZAPPY LIFESTYLE PRIVATE LIMITED",
"ZAPPYWORKS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"ZAPTAS TECHNOLOGIES PRIVATE LIMITED",
"ZAPTY SOFTWARE PRIVATE LIMITED",
"ZAQ HEALTH CARE PRIVATE LIMITED",
"ZAR JEWELS PRIVATE LIMITED",
"ZAR METAMORPHOSE COMBINE PRIVATE LIMITED",
"ZARA FOOTWEAR PRIVATE LIMITED",
"ZARA INDUSTRIES PRIVATE LIMITED",
"ZARA INFRASTRUCTURE PRIVATE LIMITED",
"ZARA VALVES PRIVATE LIMITED",
"ZARAH CONCEPT INDIA (OPC) PRIVATE LIMITED",
"ZARANTECH SOFTWARE PRIVATE LIMITED",
"ZARAVYA INFORMATICS PRIVATE LIMITED",
"ZARCO REALTIES PRIVATE LIMITED",
"ZARDOZI RETAILERS PRIVATE LIMITED",
"ZAREE TRENDS PRIVATE LIMITED",
"ZAREEN FOODS PRIVATE LIMITED",
"ZARHAK STEELS PRIVATE LIMITED",
"ZARI SILK INDIA PRIVATE. LIMITED",
"ZARIA PHARMACEUTICALS PRIVATE LIMITED",
"ZARINA LEATHER EXPORTS",
"ZARKO GRANITO PRIVATE LIMITED",
"ZARYA IMPEX PRIVATE LIMITED",
"ZASHA ADVERTISING PRIVATE LIMITED",
"ZASHA EDUCATION AND RESEARCH FOUNDATION",
"ZASHED FASHIONTECH PRIVATE LIMITED",
"ZASNAK INDIA PRIVATE LIMITED",
"ZAST LOGISOLUTIONS PRIVATE LIMITED",
"ZASTI INDIA PRIVATE LIMITED",
"ZASTRA INNOVATIONS PRIVATE LIMITED",
"ZATPAT TECHNOLOGIES PRIVATE LIMITED",
"ZAURAC CONSULTING PRIVATE LIMITED",
"ZAV ENGINEERS PRIVATE LIMITED",
"ZAVASI TECHNOLOGIES PRIVATE LIMITED",
"ZAVEN IT SOLUTIONS PRIVATE LIMITED",
"ZAVENIR DAUBERT INDIA PRIVATE LIMITED",
"ZAVERAT JEWELS HUB PRIVATE LIMITED",
"ZAVERAT JEWELS PRIVATE LIMITED",
"ZAVERCHAND SPORTS PRIVATE LIMITED",
"ZAVERI AND COMPANY PRIVATE LIMITED",
"ZAVERI BROTHERS SILVER PLATERS PRIVATE LIMITED",
"ZAVERI FINSTOCK PRIVATE LIMITED",
"ZAVERI GOVINDDAS UTTAMCHAND SARAF PRIVATE LIMITED",
"ZAVERI MOTORS PRIVATE LIMITED",
"ZAVERI OIL & GAS PRIVATE LIMITED",
"ZAVI DESIGNS PRIVATE LIMITED",
"ZAVICH INFRASTRUCTURE & POWER PRIVATE LIMITED",
"ZAVIER AUTOMOTIVE PRIVATE LIMITED",
"ZAVIK DRUGS PRIVATE LIMITED",
"ZAVIYA EXPORTS PRIVATE LIMITED",
"ZAWAR GAUGES AND TOOLS PRIVATE LIMITED",
"ZAWARE CREATIVE ENTERPRISES PRIVATE LIMITED",
"Z-AXIS AGGREGATORS PRIVATE LIMITED",
"Z-AXIS TECH SOLUTIONS INDIA PRIVATE LIMITED",
"ZAYAN GOLD AND DIAMONDS PRIVATE LIMITED",
"ZAYCA CATERS PRIVATE LIMITED",
"ZAYN CONSULTING PRIVATE LIMITED",
"ZAYN SALES PRIVATE LIMITED",
"ZAYNTEX SPINNERS PRIVATE LIMITED",
"ZAYS AUTO ENGINEERS PRIVATE LIMITED",
"ZAZEN PHARMA PRIVATE LIMITED",
"ZAZSONS EXPORTS PRIVATE LIMITED",
"ZAZZ TECHNOLOGY CONNECT PRIVATE LIMITED",
"ZAZZLES SALONS INDIA PRIVATE LIMITED",
"ZBN LAKSHMI CIVIL ENGINEERS PRIVATE LIMITED",
"ZCARE PHARMA PRIVATE LIMITED",
"ZCC TECHNO PRIVATE LIMITED",
"ZCHEM POLYMERS INDIA PRIVATE LIMITED",
"ZCL CHEMICALS LIMITED",
"ZCLUS (INDIA) LIMITED",
"ZCODIA TECHNOLOGIES PRIVATE LIMITED",
"ZCON SOLUTIONS PRIVATE LIMITED",
"ZCYPHHER FILMS PRIVATE LIMITED",
"ZDLZODIACAL PHARMACEUTICS PRIVATE LIMITED",
"ZDSB SUPPORT PRIVATE LIMITED",
"ZEA MAIZE PRIVATE LIMITED",
"ZEABUS HOSPITALITY CONSULTANTS PRIVATE LIMITED",
"ZEAL ADVERTISING PRIVATE LIMITED",
"ZEAL AQUA PRIVATE LIMITED",
"ZEAL COLLEGE OF ENGINEERING AND RESEARCH",
"ZEAL CORRUGATION PRIVATE LIMITED",
"ZEAL DIRECT AND REINSURANCE BROKING SERVICES PRIVATE LIMITED",
"ZEAL EDUCATION SOCIETY",
"ZEAL ELECTROMECH PRIVATE LIMITED",
"ZEAL FOODS PRIVATE LIMITED",
"ZEAL GEARS PRIVATE LIMITED",
"ZEAL GLOBAL SERVICES LIMITED",
"ZEAL GLOBAL SERVICES PRIVATE LIMITED",
"ZEAL IMPEX AND TRADERS PRIVATE LIMITED",
"ZEAL INSTITUTE OF MANAGEMENT & COMPUTER APPLICATION",
"ZEAL INTEGRATED MARKETING SOLUTIONS PRIVATE LIMITED",
"ZEAL JUNIOR COLLEGE PUNE",
"ZEAL LIFE SCIENCES PRIVATE LIMITED",
"ZEAL MANUFACTURING AND CALIBRATION SERVICES PRIVATE LIMITED",
"ZEAL MARKETING PRIVATE LIMITED",
"ZEAL MEDI SOLUTIONS PRIVATE LIMITED",
"ZEAL MEDICAL PRIVATE LIMITED",
"ZEAL MEDIPHARMA (EXPORT) PRIVATE LIMITED",
"ZEAL METALIKS PRIVATE LIMITED",
"ZEAL ORGANOSYS PRIVATE LIMITED",
"ZEAL POLYMERS PRIVATE LIMITED",
"ZEAL PROFESSIONAL SERVICES PRIVATE LIMITED",
"ZEAL RESORTS PRIVATE LIMITED",
"ZEAL TECH INDUSTRIES PRIVATE LIMITED",
"ZEAL TRADELINKS PRIVATE LIMITED",
"ZEAL Z ENTERTAINMENT SERVICES PRIVATE LIMITED",
"ZEAL&ZEST INDUSTRIES PRIVATE LIMITED",
"ZEALCAMP SOLUTIONS INDIA PRIVATE LIMITED",
"ZEALHEIGHT ORES PRIVATE LIMTED",
"ZEALIE INDIA PRIVATE LIMITED",
"ZEALMAX INNOVATIONS PRIVATE LIMITED",
"ZEALOT INDUSTRIAL & LOGISTIC SERVICES PRIVATE LIMITED",
"ZEALOTECH PEOPLE",
"ZEALOUS AND EARNEST SERVICES TOURISM INDIA PRIVATE LIMITED",
"ZEALOUS ANIMATION STUDIO PRIVATE LIMITED",
"ZEALOUS BIOTECHNOLOGIES PRIVATE LIMITED",
"ZEALOUS CALL CENTRE SERVICES PRIVATE LIMITED",
"ZEALOUS SYSTEM PRIVATE LIMITED",
"ZEALOUSWEB TECHNOLOGIES PRIVATE LIMITED",
"ZEALTEL GLOBAL PRIVATE LIMITED",
"ZEALTOP GRANITO PRIVATE LIMITED",
"ZEAN LITHOS AND COMPANY PRIVATE LIMITED",
"ZEASSETZ SOLUTIONS PRIVATE LIMITED",
"ZEB INTERNATIONAL PRIVATE LIMITED",
"ZEBA LAB FURNITURE PRIVATE LIMITED",
"ZEBA LAB SYSTEMS PRIVATE LIMITED",
"ZEBAR SCHOOL FOR CHILDREN",
"ZEBBOI CERAMICS PRIVATE LIMITED",
"ZEBEC MARINE CONSULTANTS AND SERVICES PRIVATE LIMITED",
"ZEBEC MARINE SERVICES PRIVATE LIMITED",
"ZEBI DATA INDIA PRIVATE LIMITED",
"ZEBION INFOTECH PRIVATE LIMITED",
"ZEBO PAPER INDUSTRIES",
"ZEBRA AUTO CHEM PRIVATE LIMITED",
"ZEBRA FASHION PRIVATE LIMITED",
"ZEBRA FOREX PRIVATE LIMITED",
"ZEBRA IDEALAB PRIVATE LIMITED",
"ZEBRA PACK PRIVATE LIMITED",
"ZEBRA ROLLERS PRIVATE LIMITED",
"ZEBRA TECHNOLOGIES INDIA PRIVATE LIMITED",
"ZEBRANO FACILITY MANAGEMENT SERVICES PRIVATE LIMITED",
"ZEBRO OFFICEMATE LIMITED",
"ZEBRONICS INDIA PRIVATE LIMITED",
"ZEBRS INDIA (OPC) PRIVATE LIMITED",
"ZEBU ANIMATION STUDIOS PRIVATE LIMITED",
"ZEBU INTELLIGENT SYSTEMS PRIVATE LIMITED",
"ZEBU SHARE AND WEALTH MANAGEMENTS PRIVATE LIMITED",
"ZEBYTE INFOTECH PRIVATE LIMITED",
"ZECHA PRECISION TOOLS LIMITED",
"ZECK PRIVATE LIMITED",
"ZECO AIRCON LIMITED",
"ZECO ELECTRICALS MANUFACTURING PRIVATE LIMITED",
"ZECON PHARMACEUTICALS PRIVATE LIMITED",
"ZECROM ENTERPRISES PRIVATE LIMITED",
"ZECRUITERS JOBCONNECT PRIVATE LIMITED",
"ZED CHEM PVT LTD",
"ZED INFRASTRUCTURE PRIVATE LIMITED.",
"ZED LIFESTYLE PRIVATE LIMITED",
"ZED R 18 REALCON PRIVATE LIMITED",
"ZED SECURITY SERVICES PRIVATE LIMITED",
"ZED TECHNOLOGIES PRIVATE LIMITED",
"ZED VALVES COMPANY PRIVATE LIMITED",
"ZED VITRIFIED PRIVATE LIMITED",
"ZED VYAPAAR PRIVATE LIMITED",
"ZEDAWN LIFE SCIENCES PRIVATE LIMITED",
"ZED-AXIS TECHNOLOGIES PRIVATE LIMITED",
"ZEDBEE TECHNOLOGIES PRIVATE LIMITED",
"ZEDENGINES INDIA PRIVATE LIMITED",
"ZEDEX AUTO INDIA PRIVATE LIMITED",
"ZEDEX CLOTHING PRIVATE LIMITED",
"ZEDEX INFO PRIVATE LIMITED",
"ZEDEX ORTHOCARE PRIVATE LIMITED",
"ZEDGEO SYSTEMS PRIVATE LIMITED",
"ZEDIANT TECHNOLOGIES PRIVATE LIMITED",
"ZEDNEM STEELS PVT LTD",
"ZEDO INDIA PRIVATE LIMITED",
"ZEDPOINT MANAGEMENT SERVICES PRIVATE LIMITED",
"ZEDROCK TECHNOLOGIES AND PHARMACEUTICALS PRIVATE LIMITED",
"ZEDSON AGRO PRIVATE LIMITED",
"ZEDTECH WATER SOLUTION PRIVATE LIMITED",
"ZEE AKAASH NEWS PRIVATE LIMITED",
"ZEE BANGLES PRIVATE LIMITED",
"ZEE BAZAR INDIA PRIVATE LIMITED",
"ZEE COM TRADE PRIVATE LIMITED",
"ZEE DIGITAL CONVERGENCE LIMITED",
"ZEE ENTERTAINMENT ENTERPRISES LIMITED",
"ZEE FOODEX INDIA PRIVATE LIMITED",
"ZEE FOOTWEARS PRIVATE LIMITED",
"ZEE HYGINE PRODUCTS PVT LTD",
"ZEE LABORATORIES LIMITED",
"ZEE LIFECARE PRIVATE LIMITED",
"ZEE MEDIA CORPORATION LIMITED",
"ZEE STUDIOS LIMITED",
"ZEE TEXTILE VARELI PVT LTD",
"ZEE UNIMEDIA LIMITED",
"ZEEALERT SERVICES PRIVATE LIMITED",
"ZEECO INDIA PRIVATE LIMITED",
"ZEEINDIA LOGISTICS SERVICES PRIVATE LIMITED",
"ZEEL ENTERPRISE",
"ZEEL FINCAP SERVICES PRIVATE LIMITED",
"ZEEL INFOTECH PRIVATE LIMITED",
"ZEELAB PHARMACY PRIVATE LIMITED",
"ZEELOG LOGISTICS SOLUTIONS PRIVATE LIMITED",
"ZEEMAX ENGINEERING PRIVATE LIMITED",
"ZEEMO PRIVATE LIMITED",
"ZEENATH SAREES AND FASHIONS PRIVATE LIMITED",
"ZEENESTA TRADERS & DISTRIBUTORS PRIVATE LIMITED",
"ZEERA HOTELS PRIVATE LIMITED",
"ZEESENSE SYSTEMS PRIVATE LIMITED",
"ZEETA ELECTRICAL ENGINEERING PRIVATE LIMITED",
"ZEETAA BUSINESS SOLUTIONS PRIVATE LIMITED",
"ZEE-TURNER LIMITED",
"ZEEVA HEALTHPLUS PRIVATE LIMITED",
"ZEEVAA TECH MANAGEMENT SERVICES PRIVATE LIMITED",
"ZEEVE DEEPTECH PRIVATE LIMITED",
"ZEF SCIENTIFIC INDIA PRIVATE LIMITED",
"ZEFE LABS (I) PRIVATE LIMITED",
"ZEFMO MEDIA PRIVATE LIMITED",
"ZEGNA SOUTH ASIA PRIVATE LIMITED",
"ZEHE METALS (OPC) PRIVATE LIMITED",
"ZEHNTECH TECHNOLOGIES PRIVATE LIMITED",
"ZEHRON CHEMICALS PRIVATE LIMITED",
"ZEIDLER CONSULTANCY SERVICES INDIA PRIVATE LIMITED",
"ZEIQ INDIA PRIVATE LIMITED",
"ZEISS PHARMA LIMITED",
"ZEISS PHARMACEUTICALS PRIVATE. LIMITED.",
"ZEITECH SOLUTIONS PRIVATE LIMITED",
"ZEITGEIST RETAIL PRIVATE LIMITED",
"ZEITGEIST VENTURES PRIVATE LIMITED",
"ZEITIG TRADING SOLUTIONS PRIVATE LIMITED",
"ZEKELABS TECHNOLOGIES PRIVATE LIMITED",
"ZEKESYS PRIVATE LIMITED",
"ZEKKO POWER PRIVATE LIMITED",
"ZEKKO TECH PRIVATE LIMITED",
"ZEKY ENTERPRISES PRIVATE LIMITED",
"ZEL JEWELLERS LIMITED",
"ZELA WELLENSS PRIVATE LIMITED",
"ZELADOR TALENT MANAGEMENT PRIVATE LIMITED",
"ZELAR SOFT PRIVATE LIMITED",
"ZELIANT LASERS PRIVATE LIMITED",
"ZELIANT MARCOM SOLUTIONS PRIVATE LIMITED",
"ZELIOT CONNECTED SERVICES PRIVATE LIMITED",
"ZELITE SOLUTIONS PRIVATE LIMITED",
"ZELLE BIOTECHNOLOGY PRIVATE LIMITED",
"ZELLEVEN HEALTHCARE PRIVATE LIMITED",
"ZELLEVEN LIFESCIENCE PRIVATE LIMITED",
"ZELLIS HR INDIA PRIVATE LIMITED",
"ZELORE TECHNOLOGIES PRIVATE LIMITED",
"ZELOS DEVELOPERS PRIVATE LIMITED",
"ZELOS PACKAGING PRIVATE LIMITED",
"ZELTEX MAGNETICS PRIVATE LIMITED",
"ZELTS INDIA PRIVATE LIMITED",
"ZEMA AUTOMATION AND CONTROLS PRIVATE LIMITED",
"ZEMBOO PRODUCTS PRIVATE LIMITED",
"ZEMINI AGRO LAND DEVELOPERS PRIVATE LIMITED",
"ZEMIRA RENEWABLE ENERGY LIMITED",
"ZEMOSO TECHNOLOGIES PRIVATE LIMITED",
"ZEN ADSORPTIONS PRIVATE LIMITED",
"ZEN AIR TECH PRIVATE LIMITED",
"ZEN BIO TECH PRIVATE LIMITED",
"ZEN BUILDING SOLUTION PRIVATE LIMITED",
"ZEN CHEMICALS PRIVATE LIMITED",
"ZEN CROP CARE INDIA PRIVATE LIMITED",
"ZEN CRUISES PRIVATE LIMITED",
"ZEN DATA SHASTRA LLP",
"ZEN DISTILLATION TECHNOLOGIES PRIVATE LIMITED",
"ZEN EDUCATION AND LEARNING",
"ZEN ENTERPRISES PRIVATE LIMITED",
"ZEN EQUIP INDIA PRIVATE LIMITED",
"ZEN EXIM PRIVATE LIMITED",
"ZEN FINCORP PRIVATE LIMITED",
"ZEN FOOD PROCESSORS PRIVATE LIMITED",
"ZEN HOSPITALITY SERVICES PRIVATE LIMITED",
"ZEN INDUSTRIES PRIVATE LIMITED",
"ZEN INTERACTIVE TECHNOLOGIES PRIVATE LIMITED",
"ZEN INTERNATIONAL PUBLIC SCHOOL",
"ZEN LEFIN PRIVATE LIMITED",
"ZEN LIFESTYLE PRIVATE LIMITED",
"ZEN LINEN INTERNATIONAL PRIVATE LIMITED",
"ZEN LIQUOR TRADING PRIVATE LIMITED",
"ZEN LOGICARE PRIVATE LIMITED",
"ZEN MARKETING LIMITED",
"ZEN MATRIX PRIVATE LIMITED",
"ZEN MATTRESSES PRIVATE LIMITED",
"ZEN MEDI DEVICES PRIVATE LIMITED",
"ZEN MEDICAL SERVICES",
"ZEN MULTISPECIALITY HOSPITAL",
"ZEN OVERSEAS PRIVATE LIMITED",
"ZEN PHARMA PRIVATE LIMITED",
"ZEN QUALITY ASSURANCE PRIVATE LIMITED",
"ZEN RESTAURANTS PRIVATE LIMITED",
"ZEN SCIENTIFIC PRIVATE LIMITED",
"ZEN SECURITIES LIMITED",
"ZEN SECURITIES LTD",
"ZEN SHIPPING & PORTS INDIA PRIVATE LIMITED",
"ZEN STOCK & SHARE BROKING PVT LTD",
"ZEN SYNDICATIONS PRIVATE LIMITED",
"ZEN TECHNO ENGINEERING PRIVATE LIMITED",
"ZEN TECHNOLOGIES LIMITED",
"ZEN TOBACCO PRIVATE LIMITED",
"ZEN TRADELINK PRIVATE LIMITED",
"ZEN TURNKEY SOLUTIONS PRIVATE LIMITED",
"ZEN URZZA TECH PRIVATE LIMITED",
"ZEN3 INFOSOLUTIONS PRIVATE LIMITED",
"ZENACTS PHARMA PRIVATE LIMITED",
"ZENAIS CONSULTANCY SERVICES PRIVATE LIMITED",
"ZENARA PHARMA PRIVATE LIMITED",
"ZENASIA INFRATECH PRIVATE LIMITED",
"ZENASIA LIFE SCIENCES PRIVATE LIMITED",
"ZENATIX SOLUTIONS PRIVATE LIMITED",
"ZENBI INTERNATIONAL PRIVATE LIMITED",
"ZENBLOOM PRIVATE LIMITED",
"ZENBRAIN SYSTEMS PRIVATE LIMITED",
"ZENCO EDIBLE OILS PRIVATE LIMITED",
"ZENCODE SOLUTIONS PRIVATE LIMITED",
"ZENCONTROL PRIVATE LIMITED",
"ZENDESK TECHNOLOGIES PRIVATE LIMITED",
"ZENDRIVE TECHNOLOGIES INDIA PRIVATE LIMITED",
"ZENDYNAMIX SOFTWARE PRIVATE LIMITED",
"ZENEDL CNS PRIVATE LIMITED",
"ZENEFITS TECHNOLOGIES INDIA PRIVATE LIMITED",
"ZENELEC POWER SYSTEMS PRIVATE LIMITED",
"ZENELY FOODS (OPC) PRIVATE LIMITED",
"ZENER ENGINEERING PRIVATE LIMITED",
"ZENER MARITIME SOLUTIONS PRIVATE LIMITED",
"ZENER SYSTEMS PRIVATE LIMITED",
"ZENERIS PHARMA PRIVATE LIMITED",
"ZENES BIOTECH PRIVATE LIMITED",
"ZENESIS AGROSCIENCE AND CONSULTING PRIVATE LIMITED",
"ZENESYS TECHNOSYS PRIVATE LIMITED",
"ZENETH KITCHEN EQUIPMENT PRIVATE LIMITED",
"ZENEVA CROP SCIENCE PRIVATE LIMITED",
"ZENEX ANIMAL HEALTH INDIA PRIVATE LIMITED",
"ZENEX E-COMMERCE PRIVATE LIMITED",
"ZENEX ENGINEERING PRIVATE LIMITED",
"ZENEX GRAINS PRIVATE LIMITED",
"ZENEX IMPEX PRIVATE LIMITED",
"ZENEX RETAIL PRIVATE LIMITED",
"ZENEXPRESS LOGISTICS PRIVATE LIMITED",
"ZENFIN ENGINEERING",
"ZENFOCUS SOFTWARE PRIVATE LIMITED",
"ZENHEAL WELLNESS PRIVATE LIMITED",
"ZENIA TECHNO CREATIONS PRIVATE LIMITED",
"ZENIAI PRIVATE LIMITED",
"ZENIAK INNOVATION INDIA LIMITED",
"ZENISHA CREATION PRIVATE LIMITED",
"ZENITA AUTO WORKS",
"ZENITH ALGORITHMS PRIVATE LIMITED",
"ZENITH APEX PRIVATE LIMITED",
"ZENITH AUTO INDUSTRIES PRIVATE LIMITED",
"ZENITH BIO CHEMICAL INDUSTRIES PRIVATE LIMITED",
"ZENITH BIRLA STEELS PRIVATE LIMITED",
"ZENITH CHEMICAL WORKS PRIVATE LIMITED",
"ZENITH CONSULTANTS & SOFTWARE PRIVATE LIMITED",
"ZENITH CONTROLS AND SYSTEMS PRIVATE LIMITED",
"ZENITH CONVEYANCE SOLUTIONS PRIVATE LIMITED",
"ZENITH CREDIT LTD.",
"ZENITH CUTTERS PRIVATE LIMITED",
"ZENITH DANCE INSTITUTE PRIVATE LIMITED",
"ZENITH DESIGNS",
"ZENITH DIE MAKERS PRIVATE LIMITED",
"ZENITH DRILLING PRIVATE LIMITED",
"ZENITH DRUGS LIMITED",
"ZENITH DRUGS PRIVATE LIMITED",
"ZENITH DYE-CHEM PRIVATE LIMITED",
"ZENITH DYEINTERMEDIATES LIMITED",
"ZENITH ELASTO FIBRESS PRIVATE LIMITED",
"ZENITH ELECTROTECH PRIVATE LIMITED",
"ZENITH ENERGY SERVICES P LIMITED",
"ZENITH ENGINEERING CORPORATION",
"ZENITH ENTERPRISES LIMITED",
"ZENITH ENZYMATIC DRUGS PRIVATE LIMITED",
"ZENITH ERECTORS PRIVATE LIMITED",
"ZENITH FASHIONS PRIVATE LIMITED",
"ZENITH FIBRES LIMITED",
"ZENITH FOOD SOLUTIONS PRIVATE LIMITED",
"ZENITH FORGINGS PVT LTD",
"ZENITH HARDWARE INDUSTRIES PVT LTD",
"ZENITH HEALTHCARE LIMITED",
"ZENITH HOSPITAL PRIVATE LIMITED",
"ZENITH HYBRID SEEDS PRIVATE LIMITED",
"ZENITH INDUSTRIAL RUBBER PRODUCTS PRIVATE LIMITED",
"ZENITH IRRIGATION PRIVATE LIMITED",
"ZENITH LEISURE HOLIDAYS LIMITED",
"ZENITH MEDIA SCOPE PRIVATE LIMITED",
"ZENITH METALIK ALLOYS LIMITED",
"ZENITH METAPLAST PRIVATE LIMITED",
"ZENITH PORTFOLIO AND INSURANCE ADVISORS",
"ZENITH POWER PROJECTS PRIVATE LIMITED",
"ZENITH PRECISION PRIVATE LIMITED",
"ZENITH QUALITY ASSESSORS PRIVATE LIMITED",
"ZENITH ROLLERS PRIVATE LIMITED",
"ZENITH RUBBER PRIVATE LIMITED",
"ZENITH SECURITIES AND INVESTMENT LIMITED",
"ZENITH SILK MILLS PRIVATE LIMITED",
"ZENITH SOFTWARE LIMITED",
"ZENITH SPECIALITY PRIVATE LIMITED",
"ZENITH SPRAY & AEROSOLS PRIVATE LIMITED",
"ZENITH STEEL PIPES & INDUSTRIES LIMITED",
"ZENITH SUBSCRIPTION SERVICES PRIVATE LIMITED",
"ZENITH SYSTEM SOLUTIONS PRIVATE LIMITED",
"ZENITH WELDAIDS PRIVATE LIMITED",
"ZENITH WELLNESS PRIVATE LIMITED",
"ZENITHSOFT SYSTEMS PRIVATE LIMITED",
"ZENITIVA PHARMACEUTICALS INDIA PRIVATE LIMITED",
"ZENITRON LUMINAIRES PRIVATE LIMITED",
"ZENIUM CABLES LIMITED",
"ZENIUS IT SERVICES PRIVATE LIMITED",
"ZENIX REMEDIES",
"ZENIXO GLOBAL INNOVATION SYSTEMS PRIVATE LIMITED",
"ZENIYA ELECTECH PRIVATE LIMITED",
"ZENLABS ETHICA LIMITED",
"ZENLAYER NETWORKS INDIA PRIVATE LIMITED",
"ZENLIVE MEDIA PRIVATE LIMITED",
"ZENMARC SURVEYS PRIVATE LIMITED",
"ZENMED SOLUTIONS PRIVATE LIMITED",
"ZENMONEY INSURANCE BROKING SERVICES PRIVATE LIMITED",
"ZENMONICS SOFT WARE PRIVATE LIMITED",
"ZENNER AQUAMET INDIA PRIVATE LIMITED",
"ZENO COMMUNICATIONS INDIA PRIVATE LIMITED",
"ZENOKS BIOTECH PRIVATE LIMITED",
"ZENOM VINIMAY PVT.LTD.",
"ZENOMED HEALTHCARE PRIVATE LIMITED",
"ZENON HEALTHCARE LIMITED",
"ZENON LIFESCIENCES PRIVATE LIMITED",
"ZENONA LIFESCIENCES PRIVATE LIMITED",
"ZENOTECH LABORATORIES LIMITED",
"ZENOTI INDIA PRIVATE LIMITED",
"ZENOVA BIO NUTRITION PRIVATE LIMITED",
"ZENOXX KNOWLEDGE SERVICES PRIVATE LIMITED",
"ZENPACK PREMIUM INDUSTRIES PRIVATE LIMITED",
"ZENPOWER TECHNOLOGIES PRIVATE LIMITED",
"ZENRISE CLINICAL RESEARCH PRIVATE LIMITED",
"ZENRIV EXIM LLP",
"ZENROCK COMTRADE PRIVATE LIMITED",
"ZENSA MANPOWER SERVICES PRIVATE LIMITED",
"ZENSAR TECHNOLOGIES LIMITED",
"ZENSARK INDIA PRIVATE LIMITED",
"ZENSARK TECHNOLOGIES PRIVATE LIMITED",
"ZENSE HOSPITALITY PRIVATE LIMITED",
"ZENSHO FOOD INDIA PRIVATE LIMITED",
"ZENSKA LIFE SCIENCES PRIVATE LIMITED",
"ZENSOFT SERVICES PRIVATE LIMITED",
"ZENSOL FASHION PRIVATE LIMITED",
"ZENSTAR COMPUTER SOLUTIONS PRIVATE LIMITED",
"ZENSTAR JEWELLERY LLP",
"ZENSTAYS PROPERTY SOLUTIONS PRIVATE LIMITED",
"ZENSTER POWER SOLUTION PRIVATE LIMITED",
"ZENTA MORTGAGE SERVICES LLC",
"ZENTAI WORKFORCE PRIVATE LIMITED",
"ZENTECH INDIA OFFSHORE AND MARINE ENGINEERS PRIVATE LIMITED",
"ZENTECH INFO SOLUTIONS PRIVATE LIMITED",
"ZENTECH INNOVATIONS PRIVATE LIMITED",
"ZENTECH OFFSHORE ENGINEERING PRIVATE LIMITED",
"ZENTEK BIZSOL PRIVATE LIMITED",
"ZENTERIOR TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"ZENTEST SOFTWARE PRIVATE LIMITED",
"ZENTIS DRUGS PRIVATE LIMITED",
"ZENTIVA PRIVATE LIMITED",
"ZENTRO ENTERPRISE PRIVATE LIMITED",
"ZENTROPY PRIVATE LIMITED",
"ZENTUM PHARMACEUTICALS PRIVATE LIMITED",
"ZENVIRON ENGINEERING SOLUTIONS PRIVATE LIMITED",
"ZENVISION PHARMA LLP",
"ZENWARE INFOTECH PRIVATE LIMITED",
"ZENWICK PHARMA PRIVATE LIMITED",
"ZENWORK LABS INDIA PRIVATE LIMITED",
"ZENZI PHARMACEUTICAL INDUSTRIES PRIVATE LIMITED",
"ZEO INFOSOFT PRIVATE LIMITED",
"ZEOLITE HERBALS PRIVATE LIMITED",
"ZEOLITE WATER TECHNOLOGIES PRIVATE LIMITED",
"ZEOLITES AND ALLIED PRODUCTS PRIVATE LIMITED",
"ZEOMEGA INFOTECH PRIVATE LIMITED",
"ZEON BIOTECH PRIVATE LIMITED",
"ZEON CINEMAS PRIVATE LIMITED",
"ZEON INDIA PRIVATE LIMITED",
"ZEON LIFESCIENCES LIMITED",
"ZEON STEELS PRIVATE LIMITED",
"ZEONICS SYSTECH DEFENCE AND AEROSPACE ENGINEERS PRIVATE LIMITED",
"ZEOTAP INDIA PRIVATE LIMITED",
"ZEP INFRATECH LIMITED",
"ZEPHAIRE CLOTHES PRIVATE LIMITED",
"ZEPHER INFOTECH PRIVATE LIMITED",
"ZEPHIR RAIL EQUIPMENT PRIVATE LIMITED",
"ZEPHIRUM RESEARCH PRIVATE LIMITED",
"ZEPHYR FINANCIAL PUBLISHERS PRIVATE LIMITED",
"ZEPHYR LIMITED.",
"ZEPHYR POLYMERS PRIVATE LIMITED",
"ZEPHYR SYNTHESIS PVT LTD",
"ZEPHYR TOYMAKERS PRIVATE LIMITED",
"ZEPHYRSUN ELECTRO MECH PRIVATE LIMITED",
"ZEPIN SECURITIES PVT LTD",
"ZEPO TECHNOLOGIES PRIVATE LIMITED",
"ZEPPELIN SYSTEMS INDIA PRIVATE LIMITED",
"ZERACH RENEWABLES ENERGY PRIVATE LIMITED",
"ZEREBRAL IT SOLUTIONS PRIVATE LIMITED",
"ZERICO LIFESCIENCES PRIVATE LIMITED",
"ZERMATT IT SOLUTIONS PRIVATE LIMITED",
"ZERMATT SHOES PRIVATE LIMITED",
"ZERO 21 RENEWABLE ENERGY SOLUTIONS PRIVATE LIMITED",
"ZERO D INDUSTRIES PRIVATE LIMITED",
"ZERO DEGREE OOH PRIVATE LIMITED",
"ZERO DISCHARGE SYSTEMS PRIVATE LIMITED",
"ZERO DISCHARGE TECHNOLOGIES PRIVATE LIMITED",
"ZERO EFFORT TECHNOLOGIES PRIVATE LIMITED",
"ZERO ENTHALPY LACS PRIVATE LIMITED",
"ZERO LEVEL INSTALLATIONS PRIVATE LIMITED",
"ZERO LIGHTBILL INDIA PRIVATE LIMITED",
"ZERO MASS PRIVATE LIMITED",
"ZERO PIXELS TECHNOLOGIES PRIVATE LIMITED",
"ZERODHA BROKING LIMITED",
"ZERODHA CAPITAL PRIVATE LIMITED",
"ZERODHA COMMODITIES PRIVATE LIMITED",
"ZERODHA SECURITIES PRIVATE LIMITED",
"ZERODHA TECHNOLOGY PRIVATE LIMITED",
"ZEROFOX INDIA PRIVATE LIMITED",
"ZEROIN HSE INFRASTRUCTURE PRIVATE LIMITED",
"ZEROMILE WAREHOUSING PRIVATE LIMITED",
"ZEROMILES TECHNOLOGIES SERVICES PRIVATE LIMITED",
"ZEROMM PROJECTS PRIVATE LIMITED",
"ZERONE CONSULTING PRIVATE LIMITED",
"ZERONE TECHNOLOGIES PRIVATE LIMITED",
"ZERONSEC INDIA PRIVATE LIMITED",
"ZEROONE TECHNOLOGIES PRIVATE LIMITED",
"ZEROSTAR AGRO PRIVATE LIMITED",
"ZERO-SUM ITS SOLUTIONS INDIA PRIVATE LIMITED",
"ZEROWASTE RECYCLING PRIVATE LIMITED",
"ZEROZILLA INFOTECH PRIVATE LIMITED",
"ZERSYS TECHNOLOGIES PRIVATE LIMITED",
"ZERUND MANUFACTURING PRIVATE LIMITED",
"ZESPRI INTERNATIONAL (INDIA) PRIVATE LIMITED",
"ZESSO VENTURES PRIVATE LIMITED",
"ZESSTA SOFTWARE SERVICES PRIVATE LIMITED",
"ZEST AROMAS PRIVATE LIMITED",
"ZEST AVIATION PRIVATE LIMITED",
"ZEST BPO SERVICES PRIVATE LIMITED",
"ZEST CABLES PRIVATE LIMITED",
"ZEST DIABETES CARE PRIVATE LIMITED",
"ZEST EDIFICE PRIVATE LIMITED",
"ZEST FERRO BENEFICATION PRIVATE LIMITED",
"ZEST GARTEX LIMITED",
"ZEST INFRASTRUCTURE PRIVATE LIMITED",
"ZEST LIFESTYLE PRIVATE LIMITED",
"ZEST MARINE SERVICES PRIVATE LIMITED",
"ZEST MELANGE PRIVATE LIMITED",
"ZEST ONLINE PRIVATE LIMITED",
"ZEST SYSTEMS PRIVATE LIMITED",
"ZESTAR INVENTION PRIVATE LIMITED",
"ZESTARD TECHNOLOGIES PRIVATE LIMITED",
"ZESTASOFT PRIVATE LIMITED",
"ZESTBRAINS PRIVATE LIMITED",
"ZESTGEEK SOLUTIONS PRIVATE LIMITED",
"ZESTHA DEVELOPERS LIMITED",
"ZESTHA PROJECTS PRIVATE LIMITED",
"ZESTIN SOLUTIONS PRIVATE LIMITED",
"ZESTIOT TECHNOLOGIES PRIVATE LIMITED",
"ZESTL SOFTWARE PRIVATE LIMITED",
"ZESTORM TECHNOLOGIES PRIVATE LIMITED",
"ZESTTECH DIGITAL PRIVATE LIMITED",
"ZESTY VIBE PRIVATE LIMITED",
"ZET TOWN INDIA PRIVATE LIMITED",
"ZETA BUILDTECH PRIVATE LIMITED",
"ZETA INDUSTRIAL CORPORATION PRIVATE LIMITED",
"ZETA INFOTECH PRIVATE LIMITED",
"ZETA INTERACTIVE SYSTEMS INDIA PRIVATE LIMITED",
"ZETADEL TECHNOLOGIES PVT LTD",
"ZETAOPT INDIA PRIVATE LIMITED",
"ZETATEK INDUSTRIES LIMITED",
"ZETATEK TECHNOLOGIES PRIVATE LIMITED",
"ZETECHNO PRODUCTS AND SERVICES PRIVATE LIMITED",
"ZETEK CASTINGS PRIVATE LIMITED",
"ZETFAB INDIA PRIVATE LIMITED",
"ZETKO-DKV TECHNIK (INDIA) PRIVATE LIMITED",
"ZETO ENGINEERS & FABRICATORS",
"ZETOR INDIA PRIVATE LIMITED",
"ZETTAMOBI TECHNOLOGIES (OPC) PRIVATE LIMITED",
"ZETTAONE TECHNOLOGIES INDIA PRIVATE LIMITED",
"ZETTS COSMETICS PRIVATE LIMITED",
"ZETWERK KINETIX TECHNOLOGIES PRIVATE LIMITED",
"ZETWERK MANUFACTURING BUSINESSES PRIVATE LIMITED",
"ZEUS BIOTECH PRIVATE LIMITED",
"ZEUS ENGITECH PRIVATE LIMITED",
"ZEUS FEED SUPPLEMENTS PRIVATE LIMITED",
"ZEUS FITNESS POINT PRIVATE LIMITED",
"ZEUS HOUSING & CONSTRUCTION LIMITED",
"ZEUS HYGIA LIFE SCIENCES PRIVATE LIMITED",
"ZEUS INFRAMANAGEMENT PRIVATE LIMITED",
"ZEUS KNOWLEDGE CENTRE PRIVATE LIMITED",
"ZEUS METALS PRIVATE LIMITED",
"ZEUS NUMERIX PRIVATE LIMITED",
"ZEUS PROPERTIES LIMITED",
"ZEUS SHELTERS PRIVATE LIMITED",
"ZEUS SYSTEMS PRIVATE LIMITED",
"ZEUS WORLDCAST PRIVATE LIMITED",
"ZEUSIP ADVOCATES LLP",
"ZEUSK NETWORK PRIVATE LIMITED",
"ZEUTECH ENGINEERS PRIVATE LIMITED",
"ZEUX INNOVATION PRIVATE LIMITED",
"ZEUZER ENGINEERS INDIA PRIVATE LIMITED",
"ZEVA CAPSOL PRIVATE LIMITED",
"ZEVAR ORNAMENTS PRIVATE LIMITED",
"ZEVER & GEMS PVT LTD",
"ZEVER MARKETING PRIVATE LIMITED",
"ZEVER TOWER PRIVATE LIMITED",
"ZEVITH VENTURES PRIVATE LIMITED",
"ZEW ENGINEERING WORKS PRIVATE LIMITED",
"ZEWAR COMMERCIAL CONSTRUCTIONS PRIVATE LIMITED",
"ZEXICON TECHNOLOGIES PRIVATE LIMITED",
"ZEXPRIM PHARMACLS PRIVATE LIMITED",
"ZEXUS AIR SERVICES PRIVATE LIMITED",
"ZEYE SECURITY SOLUTION PRIVATE LIMITED",
"ZEZA TECHNOLOGIES LLP",
"ZF COMMERCIAL VEHICLE CONTROL SYSTEMS INDIA LIMITED",
"ZF DIGITAL SOLUTIONS INDIA PRIVATE LIMITED",
"ZF HERO CHASSIS SYSTEMS PRIVATE LIMITED",
"ZF INDIA PRIVATE LIMITED",
"ZF RANE AUTOMOTIVE INDIA PRIVATE LIMITED",
"ZF STEERING GEAR INDIA LIMITED",
"ZF WIND POWER COIMBATORE PRIVATE LIMITED",
"ZFINCA INSURANCE BROKERS PRIVATE LIMITED",
"ZFPN CONSTRUCTION PRIVATE LIMITED",
"ZFW HOSPITALITY PRIVATE LIMITED",
"ZH CHEMICALS PRIVATE LIMITED",
"ZHAGARAM BUSINESS DYNAMICS LLP",
"ZHAN XIN ELECTRONIC TECHNOLOGY (INDIA) PRIVATE LIMITED",
"ZHANNA MAINTENANCE PRIVATE LIMITED",
"ZHAOQUAN RECYCLING PRIVATE LIMITED",
"ZHAPAAK BUSINESS SOLUTIONS PRIVATE LIMITED",
"ZHARNA KNIT FAB PRIVATE LIMITED",
"ZHELTER PRIVATE LIMITED",
"ZHEN DING DEVELOPER INDIA PRIVATE LIMITED",
"ZHENG YUAN MOBILES PRIVATE LIMITED",
"ZHIKODE TECHNOLOGIES PRIVATE LIMITED",
"ZHIPON LOGISTICS PRIVATE LIMITED",
"ZHONGFU MOBILE PRIVATE LIMITED",
"ZHONGGUO SECAI DESIGNERS AND ADVERTISERS PRIVATE LIMITED",
"ZHONGHUA (INDIA) ENG PRIVATE LIMITED",
"ZHONGMAO INTERNATIONAL PROJECTS PRIVATE LIMITED",
"ZI AESTHETICS PRIVATE LIMITED",
"ZI INFRACON PRIVATE LIMITED",
"ZI LINES LOGISTICS PRIVATE LIMITED",
"ZI- PEARL INFRA INDIA PRIVATE LIMITED",
"ZI SYSTECH PRIVATE LIMITED",
"ZIA SEMICONDUCTOR PRIVATE LIMITED",
"ZIAA DTP PRIVATE LIMITED",
"ZIAMA FASHION PRIVATE LIMITED",
"ZIAYARA LOGISTICS PRIVATE LIMITED",
"ZIAZ ENGINEERING & CONSTRUCTIONS PRIVATE LIMITED",
"ZIBAL EXIM PRIVATE LIMITED",
"ZIBAL TECHNOLOGIES PRIVATE LIMITED",
"ZIBANKA MEDIA SERVICES PRIVATE LIMITED",
"ZIBBRI INDIA PRIVATE LIMITED",
"ZIBO PAPERS PRIVATE LIMITED",
"ZIBON CERAMIC PRIVATE LIMITED",
"ZIBRA TOURS AND TRAVELS PRIVATE LIMITED",
"ZIBTEK PRIVATE LIMITED",
"ZICOM SAAS PRIVATE LIMITED",
"ZIEHL-ABEGG INDIA PRIVATE LIMITED",
"ZIEL FINANCIAL TECHNOLOGIES PRIVATE LIMITED",
"ZIELEN INDUSTRIES PRIVATE LIMITED",
"ZIEO PHARMACEUTICALS PRIVATE LIMITED",
"ZIETA TECHNOLOGIES PRIVATE LIMITED",
"ZIEVA FARM PRIVATE LIMITED",
"ZIFF DAVIS PERFORMANCE MARKETING PRIVATE LIMITED",
"ZIFFE EXPORTS PRIVATE LIMITED",
"ZIFFITY SOLUTIONS PRIVATE LIMITED",
"ZIFFY ELECTRICAL & CONTROLS PRIVATE LIMITED",
"ZIFFYTECH DIGITAL HEALTHCARE PRIVATE LIMITED",
"ZIFO TECHNOLOGIES PRIVATE LIMITED",
"ZIGEDU LEARNING SOLUTIONS PRIVATE LIMITED",
"ZIGHRA LOGISTICS PRIVATE LIMITED",
"ZIGMA CABIN PRIVATE LIMITED",
"ZIGMA FASHION PRIVATE LIMITED",
"ZIGMA GLOBAL ENVIRON SOLUTIONS PRIVATE LIMITED",
"ZIGMA GOODS PRIVATE LIMITED",
"ZIGMA GREEN POWER PRIVATE LIMITED",
"ZIGMA MEDITECH INDIA PRIVATE LIMITED",
"ZIGMA PAINTS PVT LTD",
"ZIGNITE LABS (OPC) PRIVATE LIMITED",
"ZIGNUTS TECHNOLAB PRIVATE LIMITED",
"ZIGRAM DATA TECHNOLOGIES PRIVATE LIMITED",
"ZIGZAG FILMS PRIVATE LIMITED",
"ZIIKI MEDIA PRIVATE LIMITED",
"ZIK FACILITY & SECURITY PRIVATE LIMITED",
"ZIKHA LASERTECH PRIVATE LIMITED",
"ZIKOMO SOLUTIONS LTD",
"ZIKOOL REFRIGERATION PRIVATE LIMITED",
"ZIL ORGANICS PRIVATE LIMITED",
"ZILA BASIC SHIKSHA PARISAD",
"ZILA BHOOMI SANARAKHAN ADHIKARI",
"ZILA HOMYOPATHEIC MEDICAL OFFICER",
"ZILA PANCHAYAT GIRLS INTER COLLEGE",
"ZILA PANCHAYAT RAJ ADHIKARI CHANDAULI",
"ZILA PANCHAYATI RAJ ADHIKARI PANCHAYAT RAJ DEPARTMENT",
"ZILA PARISHAD MARATHI SHALA BIJARI",
"ZILA PARISHAD MARATHI SHALA PUSAND",
"ZILA PARISHAD NAGPUR",
"ZILA PARISHAD NANDURBAR",
"ZILA PARISHAD PRATHAMIK SHALA UKHALIAAMBA",
"ZILA PARISHAD PRATHMIK SHALA",
"ZILA PARISHAD SCHOOL",
"ZILA PARISHAD SCHOOL SHENGARMAL",
"ZILA SAHKARI BANK ¬†LTD",
"ZILA SAHKARI BANK LTD AGRA",
"ZILA SAHKARI BANK LTD BAREILLY",
"ZILA SAHKARI BANK LTD HARIDWAR",
"ZILA SEWAYOJAN ADHIKARI",
"ZILA VIDYALAYA NIRICHAK LUCKNOW",
"ZILHA PARISHAD BEED",
"ZILHA PARISHAD BHANDARA",
"ZILHA PARISHAD CENTER PRIMARY SCHOOL CHINCHWAN BEED",
"ZILHA PARISHAD CENTER PRIMARY SCHOOL KANYA AMALNER",
"ZILHA PARISHAD CENTER PRIMARY SCHOOL KHUNTEFAL ASHTI BEED",
"ZILHA PARISHAD GONDIA",
"ZILHA PARISHAD HIGH SCHOOL CHAKLAMBA BEED",
"ZILHA PARISHAD HINDI UCCHA PRATHAMIK SHADA",
"ZILHA PARISHAD KENDRA PRIMARY SCHOOL BEED",
"ZILHA PARISHAD KENDRA PRIMARY SCHOOL DHANORA TAL ASHTI DIST BEED",
"ZILHA PARISHAD KENDRIYA PRATHMIK SHALA BANGALI PIMPALA BEED",
"ZILHA PARISHAD KENDRIYA PRATHMIK SHALA CHINCHALA BEED",
"ZILHA PARISHAD PRATHMIK SCHOOL GOPALPUR NEWASA AHMEDNAGAR",
"ZILHA PARISHAD PRATHMIK SHALA MAHINDA",
"ZILHA PARISHAD PRATHMIK SHALA MORWANDI VAIDYAKINHI",
"ZILHA PARISHAD PRATHMIK SHALA NIRGUNDI NAYGAON",
"ZILHA PARISHAD PRATHMIK SHALA PIMPALSUTTI BEED",
"ZILHA PARISHAD PRIMARY SCHOOL SHRIRAMWASTI SHIRUR GHAT BEED",
"ZILHA PARSHAD CENTER PRIMARY SCHOOL JARUD BEED",
"ZILINGO GLOBAL PRIVATE LIMITED",
"ZILKER LEARNING TECHNOLOGIES PRIVATE LIMITED",
"ZILLA PARISHAD ANTARWALA",
"ZILLA PARISHAD AURANGABAD",
"ZILLA PARISHAD HIGH SCHOOL BADNAPUR",
"ZILLA PARISHAD HIGH SCHOOL NANDGAON",
"ZILLA PARISHAD JALNA",
"ZILLA PARISHAD KENDRA PRATHMIK SHALA PARAGON SERIES",
"ZILLA PARISHAD KOLHAPUR",
"ZILLA PARISHAD LATUR",
"ZILLA PARISHAD NAGPUR",
"ZILLA PARISHAD NANDURBAR",
"ZILLA PARISHAD PRASHALA",
"ZILLA PARISHAD PRI SCHOOL REPALA",
"ZILLA PARISHAD PRIMARY SCHOOL",
"ZILLA PARISHAD PRIMARY SCHOOL MANDVI KHURD TAL DHADGAON DIST NANDURBAR",
"ZILLA PARISHAD PRIMARY SCHOOL MANEWADI",
"ZILLA PARISHAD PRIMARY SCHOOL MARWALI",
"ZILLA PARISHAD PRIMARY SCHOOL MULSHI",
"ZILLA PARISHAD PRIMERY SCHOOL AATWAN TAL MAWAL PUNE",
"ZILLA PARISHAD PUNE",
"ZILLA PARISHAD RATNAGIRI",
"ZILLA PARISHAD SANGLI",
"ZILLA PARISHAD SATARA",
"ZILLA PARISHAD SCHOOL BONSHET",
"ZILLA PARISHAD SCHOOL CHANDESHILY",
"ZILLA PARISHAD SCHOOL PUNE",
"ZILLA PARISHAD SHALA OHAWA",
"ZILLIOBIT INTERACTIVE PRIVATE LIMITED",
"ZILLION ANALYTICS PRIVATE LIMITED",
"ZILLION FOREX PRIVATE LIMITED",
"ZILLION HOTELS & RESORTS PRIVATE LIMITED",
"ZILLION POWER (INDIA) PRIVATE LIMITED",
"ZILLION TECHNOLOGIES INDIA PRIVATE LIMITED",
"ZILLIOUS SOLUTIONS PRIVATE LIMITED",
"ZILOGIC SYSTEMS PRIVATE LIMITED",
"ZILVER LIFESTYLE",
"ZIM HEALTH TECHNOLOGIES LIMITED",
"ZIM INTEGRATED SHIPPING SERVICES (INDIA) PRIVATE LIMITED",
"ZIM LABORATORIES LIMITED",
"ZIM WORLD FREIGHT PRIVATE LIMITED",
"ZIMBLE ONE PRIVATE LIMITED",
"ZIMBRA TECHNOLOGY INDIA PRIVATE LIMITED",
"ZIMETRICS TECHNOLOGIES PRIVATE LIMITED",
"ZIMIDARA PESTICIDES PRIVATE. LIMITED.",
"ZIMMER I PRIVATE LIMITED",
"ZIMPLISTIC INDIA PRIVATE LIMITED",
"ZIMPLSTIC INDIA PRIVATE LIMITED",
"ZIMSON TIMES PRIVATE LIMITED",
"ZIMSON TRADING PRIVATE LIMITED",
"ZIN STEEL INDUSTRIES PRIVATE LIMITED",
"ZINC CLOTHING PRIVATE LIMITED",
"ZINC ELECTRO BAZAR PRIVATE LIMITED",
"ZINC FOODS PRIVATE LIMITED",
"ZINC PIXEL INDIA PRIVATE LIMITED",
"ZINCOT IMPEX PRIVATE LIMITED",
"ZINDAGI TECHNOLOGIES PRIVATE LIMITED",
"ZINDUS INFRA (INDIA) PRIVATE LIMITED",
"ZINEONE INDIA PRIVATE LIMITED",
"ZINFOWAY TECHNOLOGIES PRIVATE LIMITED",
"ZING ACNR PRIVATE. LIMITED",
"ZING ECOMMERCE PRIVATE LIMITED",
"ZING IMPEX PRIVATE LIMITED",
"ZING LIFECARE PRIVATE LIMITED",
"ZING RESTAURANTS PRIVATE LIMITED",
"ZINGAR",
"ZINGBI LIFESTYLE INDIA PRIVATE LIMITED",
"ZINGOY REWARDS PRIVATE LIMITED",
"ZINICA AGRO SOLUTIONS PRIVATE LIMITED",
"ZINIER TECHNOLOGIES PRIVATE LIMITED",
"ZINIOS INFORMATION TECHNOLOGIES PRIVATE LIMITED",
"ZINIOSEDGE SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"ZINKA LOGISTICS SOLUTIONS PRIVATE LIMITED",
"ZINKADS PRIVATE LIMITED",
"ZINNIA HEALTHCARE INDIA PRIVATE LIMITED",
"ZINNIA LIFE SCIENCES PRIVATE LIMITED",
"ZINNIA SALES PRIVATE LIMITED",
"ZINNIA TRADING PVT.LTD.",
"ZINNOV MANAGEMENT CONSULTING PRIVATE LIMITED",
"ZINQ ELECTRONICS PRIVATE LIMITED",
"ZINTEX BLUE OCEAN PRIVATE LIMITED",
"ZINZINO HEALTH PRODUCTS INDIA PRIVATE LIMITED",
"ZION CABINS",
"ZION DIGITAL TECHNOLOGIES PRIVATE LIMITED",
"ZION DISTRUBUTION PRIVATE LIMITED",
"ZION ENVIRO SYSTEMS PRIVATE LIMITED",
"ZION EVENT MANAGEMENT PRIVATE LIMITED",
"ZION EXPRESS CARGO PRIVATE LIMITED",
"ZION HOLIDAYS PRIVATE LIMITED",
"ZION HOSPITALITY PRIVATE LIMITED",
"ZION HOSPITALS AND RESEARCH CENTRE PRIVATE LIMITED",
"ZION INTERNATIONAL FOOD INGREDIENTS PRIVATE LIMITED",
"ZION INTERNATIONAL PUBLIC SCHOOL",
"ZION LOGISTICS INDIA PRIVATE LIMITED",
"ZION MATRIC SCHOOL HIGHER SECONDARY SCHOOL",
"ZION MATRICULATION HR SEC SCHOOL",
"ZION MONEY CHANGERS PRIVATE LIMITED",
"ZION PROMOTERS AND DEVELOPERS PRIVATE LIMITED",
"ZION RETAILS",
"ZION WERKSTATT PRIVATE LIMITED",
"ZIONDB SERVICES PRIVATE LIMITED",
"ZIONEXT TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"ZIONHILLS GOLF PRIVATE LIMITED",
"ZIONHILLS HOMES PRIVATE LIMITED",
"ZIONRAY CONSULTING PRIVATE LIMITED",
"ZIONS FOOD & FUN MANAGEMENT PRIVATE LIMITED",
"ZIONTECH SOLUTIONS PRIVATE LIMITED",
"ZIOTRON CONSULTING PRIVATE LIMITED",
"ZIOWEAR APPARELS PRIVATE LIMITED",
"ZIP ADVENTURE TOURS PRIVATE LIMITED",
"ZIP ENTERPRISES PRIVATE LIMITED",
"ZIP INDUSTRIES LIMITED",
"ZIP INDUSTRIES PRIVATE LIMITED",
"ZIP INFOSOLUTIONS PRIVATE LIMITED",
"ZIP ZAP EXIM PRIVATE LIMITED",
"ZIPBOOKS SOFTWARE SOLUTIONS PRIVATE LIMITED",
"ZIPGIGZ PRIVATE LIMITED",
"ZIPPCO COMPONENTS PRIVATE LIMITED",
"ZIPPCO TECHNOLOGY PRIVATE LIMITED",
"ZIPPED SOLUTIONS PRIVATE LIMITED",
"ZIPPER MERCANTILES PVT.LTD.",
"ZIPPIN PHARMA PRIVATE LIMITED",
"ZIPPOLIGHTERS INDIA PRIVATE LIMITED",
"ZIPPR PRIVATE LIMITED",
"ZIPPY COSMETICS PRIVATE LIMITED",
"ZIPPY EDIBLE PRODUCTS PRIVATE LIMITED",
"ZIPTECH ENTERPRISES PRIVATE LIMITED",
"ZIPTRAX CLEANTECH PRIVATE LIMITED",
"ZIPZAP LOGISTICS PRIVATE LIMITED",
"ZIQITZA BRAND MANAGEMENT PRIVATE LIMITED",
"ZIQITZA HEALTH CARE LIMITED",
"ZIRAFF TECHNOLOGIES PRIVATE LIMITED",
"ZIRCA DIGITAL SOLUTIONS PRIVATE LIMITED",
"ZIRCAR CRUCIBLES PRIVATE LIMITED",
"ZIRCAR REFRACTORIES LIMITED",
"ZIRCON ENTERPRISES PRIVATE LIMITED",
"ZIRCON EXPORTS PRIVATE LIMITED",
"ZIRCON INFRASTRUCTURE LLP",
"ZIRCON LOGISTICS PRIVATE LIMITED",
"ZIRCON TECHNOLOGIES INDIA LIMITED",
"ZIRCON TRADERS LIMITED",
"ZIRCONIUM CHEMICALS PRIVATE LIMITED",
"ZIRCONIUM EXIM PRIVATE LIMITED",
"ZIRI TRADELINK PRIVATE LIMITED",
"ZIRKEL INFRACA PRIVATE LIMITED",
"ZIRKEL TECHNOLOGIES PRIVATE LIMITED",
"ZISAFE CONSULTANCY SERVICES PRIVATE LIMITED",
"ZITHER PHARMACEUTICAL PRIVATE LIMITED",
"ZITIN TECHNOLOGIES PRIVATE LIMITED",
"ZITRON INDIA PVT LTD",
"ZITRON PHARMA PVT LTD",
"ZIV AUTOMATION INDIA PRIVATE LIMITED",
"ZIV DIAMOND PRIVATE LIMITED",
"ZIV LOGISTICS AND SHIPPING PRIVATE LIMITED",
"ZIVA CONSTRUCTION AND DEVELOPERS PRIVATE LIMITED",
"ZIVA FOUNADATION",
"ZIVA IMPEX PRIVATE LIMITED",
"ZIVA JEWELLERY PRIVATE LIMITED",
"ZIVAH INTERNATIONAL PRIVATE LIMITED",
"ZIVANTA ANALYTICS PRIVATE LIMITED",
"ZIVAYA WELLNESS PRIVATE LIMITED",
"ZIVIRA LABS PRIVATE LIMITED",
"ZIVON LIFESTYLE PRIVATE LIMITED",
"ZIVORE DESIGN PRIVATE LIMITED",
"ZIYA INFRATECH SERVICES PRIVATE LIMITED",
"ZIYANA LIFESCIENCES PRIVATE LIMITED",
"ZIYAUL COUTURE PRIVATE LIMITED",
"ZK GOURMET PRIVATE LIMITED",
"ZKL BEARINGS INDIA PRIVATE LIMITED ZKLBIPL",
"ZKONSULT INNOVATIVE SOLUTIONS PRIVATE LIMITED",
"ZKTECO BIOMETRICS INDIA PRIVATE LIMITED",
"ZL SOFTWARE SYSTEMS PRIVATE LIMITED",
"ZLAIT SPORTS MANAGEMENT PRIVATE LIMITED",
"ZLD TECHNOLOGIES PRIVATE LIMITED",
"ZLENDO TECHNOLOGIES PRIVATE LIMITED",
"ZLURI TECHNOLOGIES PRIVATE LIMITED",
"ZM DIGITECH COMMUNICATIONS PRIVATE LIMITED",
"ZMC JEWELLERY PRIVATE LIMITED",
"ZMOT PRO PRIVATE LIMITED",
"ZMQ DEVELOPMENT",
"ZMS FOREX AND TOURS PRIVATE LIMITED",
"ZN RETAIL PRIVATE LIMITED",
"ZN SYNERGIES PRIVATE LIMITED",
"ZNALYTICS BUSINESS SOLUTIONS PRIVATE LIMITED",
"ZNET TECHNOLOGIES PRIVATE LIMITED",
"ZOA FASHIONS PRIVATE LIMITED",
"ZOBBLE SOLUTIONS PRIVATE LIMITED",
"ZOBELE INDIA PRIVATE LIMITED",
"ZOBHA FASHIONS PRIVATE LIMITED",
"ZOBI WEB SOLUTIONS PRIVATE LIMITED",
"ZOBONE INTERNATIONAL OUTSOURCING PRIVATE LIMITED",
"ZOBOX RETAILS PRIVATE LIMITED",
"ZOCDOC ONLINE HEALTH MANAGEMENT INDIA PRIVATE LIMITED",
"ZOCHEM PHARMA PRIVATE LIMITED",
"ZOCONUT PRIVATE LIMITED",
"ZODHITA HEALTH SOLUTIONS PRIVATE LIMITED",
"ZODIAC BUSINESS PVT LTD",
"ZODIAC CLOTHING COMPANY LIMITED",
"ZODIAC DEALERS PRIVATE. LIMITED.",
"ZODIAC DEVELOPERS PRIVATE LIMITED",
"ZODIAC ENERGY LIMITED",
"ZODIAC ENTERPRISES PVT LTD",
"ZODIAC ESTATES INDIA PRIVATE LIMITED",
"ZODIAC EXPRESS PRIVATE LIMITED",
"ZODIAC GLOBAL PRIVATE LIMITED",
"ZODIAC HEALOTRONICS PRIVATE LIMITED",
"ZODIAC HEALTHCARE",
"ZODIAC INFOTECH PRIVATE LIMITED",
"ZODIAC LIFE SCIENCES PRIVATE LIMITED",
"ZODIAC MANPOWER SERVICES PRIVATE LIMITED",
"ZODIAC MARITIME AGENCIES INDIA PRIVATE LIMITED",
"ZODIAC MEDICARE & HOSPITAL PRIVATE LIMITED",
"ZODIAC MEDIQUIP LIMITED",
"ZODIAC METAL STRIPS LIMITED",
"ZODIAC REPROGRAPHICS PRIVATE LIMITED",
"ZODIAC RUBBER INDUSTRIES PVT LTD",
"ZODIAC SECURITIES PRIVATE LIMITED",
"ZODIAC TANK CONTAINER TERMINALS PRIVATE LIMITED",
"ZODIAC TRADELINK PRIVATE LIMITED",
"ZODIAC VENTURES LIMITED",
"ZODIACAL OVERSEAS PRIVATE LIMITED",
"ZODIAC-JRD-MKJ LIMITED",
"ZODNIK SOLUTIONS INDIA PRIVATE LIMITED",
"ZOE CONCEPTS PRIVATE LIMITED",
"ZOE HEALTHCARE PRIVATE LIMITED",
"ZOET DESSERTS PRIVATE LIMITED",
"ZOETIC AYURVEDICS PRIVATE LIMITED",
"ZOETIS INDIA LIMITED",
"ZOETIS PHARMACEUTICAL RESEARCH PRIVATE LIMITED",
"ZOFFO FOUNTAINS PRIVATE LIMITED",
"ZOFIA INGREDIENTS PRIVATE LIMITED",
"ZOFTEC VERAS INDIA PRIVATE LIMITED",
"ZOFTSOLUTIONS PRIVATE LIMITED",
"ZOGATO TECH PRIVATE LIMITED",
"ZOHA FOODS PRIVATE LIMITED",
"ZOHO CORPORATION PRIVATE LIMITED",
"ZOHO TECHNOLOGIES PRIVATE LIMITED",
"ZOI FINTECH SERVICES PRIVATE LIMITED",
"ZOI HEALTH PRIVATE LIMITED",
"ZOI HOSPITALS",
"ZOI HOSPITALS PRIVATE LIMITED",
"ZOIC BIOTECH PRIVATE LIMITED",
"ZOIE AGRO PRIVATE LIMITED",
"ZOLA REAL ESTATE PRIVATE LIMITED",
"ZOLIJNS DESIGNS PRIVATE LIMITED",
"ZOLINA EXPRESS PRIVATE LIMITED",
"ZOLL MEDICAL INDIA PRIVATE LIMITED",
"ZOLLER INDIA PRIVATE LIMITED",
"ZOLON TECH LTD",
"ZOLOSTAYS PROPERTY SOLUTIONS PRIVATE LIMITED",
"ZOLOTO VALVES PRIVATE LIMITED",
"ZOLT ENERGY PRIVATE LIMITED",
"ZOLT INFO SOLUTIONS PRIVATE LIMITED",
"ZOLVE INNOVATIONS PRIVATE LIMITED",
"ZOMAR TECHNOLOGIES PRIVATE LIMITED",
"ZOMATO ENTERTAINMENT PRIVATE LIMITED",
"ZOMATO HYPERPURE PRIVATE LIMITED",
"ZOMATO LIMITED",
"ZOMATO PAYMENTS PRIVATE LIMITED",
"ZOMEX DIGITAL PRIVATE LIMITED",
"ZOMO TECHNOLOGY PRIVATE LIMITED",
"ZON BIO SYSTEMS PRIVATE LIMITED",
"ZON CONTAINER MANAGEMENT SERVICES PRIVATE LIMITED",
"ZON HOTELS PRIVATE LIMITED",
"ZON TECH PRIVATE LIMITED",
"ZONAC KNITTING MACHINES PRIVATE LIMITED",
"ZONAH DEVELOEPRS PRIVATE LIMITED",
"ZONAP ENGINEERING SOLUTIONS PRIVATE LIMITED",
"ZONAR TECHNO PRIVATE LIMITED",
"ZONE BRIGHTS INFRA PRIVATE LIMITED",
"ZONE MASTER INDIA PRIVATE LIMITED",
"ZONEDOUT MEDIAWORKS AND ENTERTAINMENT PRIVATE LIMITED",
"ZONEONE VENTURE PRIVATE LIMITED",
"ZONES CORPORATE SOLUTIONS PRIVATE LIMITED",
"ZONET TV PRIVATE LIMITED",
"ZONIAC SOFTWARE PRIVATE LIMITED",
"ZONJE SOLAR LLP",
"ZONKA TECHNOLOGIES PRIVATE LIMITED",
"ZONTA INFRATECH PRIVATE LIMITED",
"ZONY TRANSMISSION SYSTEMS PRIVATE LIMITED",
"ZOO ENTERTAINMENT PRIVATE LIMITED",
"ZOO MEDIA PRIVATE LIMITED",
"ZOOF WEB AND MOBILE DEVELOPMENT SERVICES PRIVATE LIMITED",
"ZOOFRESH FOODS PRIVATE LIMITED",
"ZOOKOO CONSULTING PRIVATE LIMITED",
"ZOOL TECH SOLUTIONS PRIVATE LIMITED",
"ZOOM APPARELS PRIVATE LIMITED",
"ZOOM DIGITAL PRESS PRIVATE LIMITED",
"ZOOM ENTERPRISES",
"ZOOM ENTERTAINMENT NETWORK LIMITED",
"ZOOM FABRICS PRIVATE LIMITED",
"ZOOM HR STAFFING SOLUTION",
"ZOOM INSURANCE BROKERS PRIVATE LIMITED",
"ZOOM INTERNATIONAL SCHOOL",
"ZOOM PUBLISHERS PRIVATE LIMITED",
"ZOOM SYNTHETICS PRIVATE LIMITED",
"ZOOM TEXTURISERS PRIVATE LIMITED",
"ZOOM TRADE AND REALTY PRIVATE LIMITED",
"ZOOM TV",
"ZOOM VANIJYA PVT LTD",
"ZOOMABROAD EDUCATION CONSULTANTS PRIVATE LIMITED",
"ZOOMFARMS ORGANIC PRIVATE LIMITED",
"ZOOMIN ONLINE INDIA PRIVATE LIMITED",
"ZOOMINFO TECHNOLOGIES INDIA PRIVATE LIMITED",
"ZOOMLION HEAVY INDUSTRY INDIA PRIVATE LIMITED",
"ZOOMLION INDIA PRIVATE LIMITED",
"ZOOMRX HEALTHCARE TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"ZOONDIA SOFTWARE PRIVATE LIMITED",
"ZOONIS INDIA PRIVATE LIMITED",
"ZOOPERO MARKETING PRIVATE LIMITED",
"ZOOPPAY PRIVATE LIMITED",
"ZOOT FASHION PRIVATE LIMITED",
"ZOPAR EXPORTS PRIVATE LIMITED",
"ZOPATE ELECTRICAL CONSULTANTS PRIVATE LIMITED",
"ZOPNIK INNOVATIONS PRIVATE LIMITED",
"ZOPPER INSURANCE BROKERS PRIVATE LIMITED",
"ZOPSMART TECHNOLOGY PRIVATE LIMITED",
"ZOPTAL SOLUTIONS PRIVATE LIMITED",
"ZORA TRADERS LIMITED",
"ZORABIAN CHICKS PVT LTD",
"ZORAM BETON PRIVATE LIMITED",
"ZORAM GOURMET PRIVATE LIMITED",
"ZORBA DIAMOND PRIVATE LIMITED",
"ZORBA DYESTUFFS PRIVATE LIMITED",
"ZORBA ENTERTAINMENT PRIVATE LIMITED",
"ZORBA HEALTH CARE MARKETING PRIVATE LIMITED",
"ZORBA RENAISSANCE PRIVATE LIMITED",
"ZORDER TECHNOLOGIES PRIVATE LIMITED",
"ZORDIAL TECHNOLOGIES PRIVATE LIMITED",
"ZOREK EDUCATION TECHNOLOGIES PRIVATE LIMITED",
"ZOREX FORGING LIMITED",
"ZOREX PHARMA PRIVATE LIMITED",
"ZORIN INTERIORS PRIVATE LIMITED",
"ZORIS BOUTIQUE HOTEL PRIVATE LIMITED",
"ZORON IT SOLUTIONS LLP",
"ZOROTO ENGINEERING PRIVATE LIMITED",
"ZOROY RETAIL PRIVATE LIMITED",
"ZORRO FABRICS PVT LTD",
"ZORYA FASHIONS PRIVATE LIMITED",
"ZOSTEL HOSPITALITY PRIVATE LIMITED",
"ZOTA HEALTH CARE LIMITED",
"ZOTA PHARMACEUTICALS PRIVATE LIMITED",
"ZOTLAY MOBILITY PRIVATE LIMITED",
"ZOTOMART PRIVATE LIMITED",
"ZOTOXA PHARMA PRIVATE LIMITED",
"ZOUKA SOLUTIONS PRIVATE LIMITED",
"ZOVAITALIA HEALTHCARE PRIVATE LIMITED",
"ZOVEC HEALTHCARE PRIVATE LIMITED",
"ZOVI TRADELIINKS PRIVATE LIMITED",
"ZOWORLD LIMITED",
"ZOXIMA SOLUTIONS PRIVATE LIMITED",
"ZOYA FASHIONS PRIVATE LIMITED",
"ZOYA HEALTH CARE PRIVATE LIMITED",
"ZOYA INTERNATIONAL PRIVATE LIMITED",
"ZOYA STEELS PRIVATE LIMITED",
"ZOYA TOUR AND TRAVELS PRIVATE LIMITED",
"ZOYAKSA CONSULTANTS PRIVATE LIMITED",
"ZOYLO DIGIHEALTH PRIVATE LIMITED",
"ZP CPS ATOLA CHAKUR",
"ZP INDIA ADVISORY PRIVATE LIMITED",
"ZPCPS JAMKHED",
"ZPE SYSTEMS INDIA PRIVATE LIMITED",
"ZPHS MULTIPURPOSE HIGHSCHOOL",
"ZPHSCHOOL",
"ZPLUS TECHNOWAYS PRIVATE LIMITED",
"ZPMC ENGINEERING (INDIA) PRIVATE LIMITED",
"Z-POWER IMPEX PRIVATE LIMITED",
"ZPPS ANTARWALA",
"ZPPS BAJIUMRAD",
"ZPPS BHAGWAN NAGAR CPS CHIKHALI",
"ZPPS BHAWADI",
"ZPPS BORIBEL",
"ZPPS GHODEWASTI PRIMARY SCHOOL PUNE",
"ZPPS JAWALGAWADI, AUSA",
"ZPPS KANNAD NAVINDGITANDA",
"ZPPS KARHALA CPS SHRISHTI TQ PARTUR",
"ZPPS KHIREWADI KHAIREWADI",
"ZPPS KURUNDWADI",
"ZPPS MHAMANE JAMDADE WASTI (KORAVALI)",
"ZPPS PANGARE",
"ZPPS PATILWASTI",
"ZPPS RANDVE WASTI RANDVE WASTI",
"ZPPS RANJANI",
"ZPPS SAROLA AUSA",
"ZPPS SATONA BK",
"ZPPS SCHOOL BHADWAL",
"ZPPS SCHOOL TAMBHAD BHOR PUNE",
"ZPPS SONKHED NILANGA",
"ZPPS TAPOWAN",
"ZPPS WAJEGAON",
"ZPPS WALMIKNAGAR",
"ZR INFRA LIMITED",
"ZR INFRA LIMITED.",
"ZR RENEWABLE ENERGY PRIVATE LIMITED",
"ZREDHI SOLUTIONS PRIVATE LIMITED",
"ZREYAH SEMICONDUCTOR SYSTEMS PRIVATE LIMITED",
"ZREYAS TECHNOLOGY PRIVATE LIMITED",
"ZRIZA PHARMACEUTICALS PRIVATE LIMITED",
"ZRM OPERATIONS PRIVATE LIMITED",
"ZS ASSOCIATES INDIA PRIVATE LIMITED",
"ZS AUTOCRAFT PRIVATE LIMITED",
"ZSAH INDIA PRIVATE LIMITED",
"ZSCALER SOFTECH INDIA PRIVATE LIMITED",
"ZSEE SMART SOLUTION INDIA PRIVATE LIMITED",
"ZSIVIRA CHEMIE MERK PRIVATE LIMITED",
"ZSJB. DREAMCARE PRIVATE LIMITED",
"ZSL PRIVATE LIMITED",
"ZSL REALTORS PRIVATE LIMITED",
"ZSOFT CONSULTANCY SERVICES PRIVATE LIMITED",
"ZSOFT TECHNOLOGY SERVICES PRIVATE LIMITED",
"Z-SQUARE SHOPPING MALL PRIVATE LIMITED",
"ZSS CONSULTANTS PRIVATE LIMITED",
"ZT SYSTEMS INDIA PRIVATE LIMITED",
"ZTA INFRATECH PRIVATE LIMITED",
"ZTE TELECOM INDIA PRIVATE LIMITED",
"Z-TECH (INDIA) LIMITED",
"Z-TECH INDIA PRIVATE LIMITED",
"ZTEK CONSULTING INC",
"ZTEK CONSULTING PRIVATE LIMITED",
"ZTRIC INDIA PRIVATE LIMITED",
"ZTT INDIA PRIVATE. LIMITED",
"ZUARI AGRI SCIENCES LIMITED",
"ZUARI AGRO CHEMICALS LIMITED",
"ZUARI CEMENT LIMITED",
"ZUARI COMMODITY TRADING LIMITED",
"ZUARI DESIGNS PRIVATE LIMITED",
"ZUARI FARMHUB LIMITED",
"ZUARI FERTILISERS & CHEMICALS LIMITED",
"ZUARI FINSERV LIMITED",
"ZUARI FOODS & FARMS PRIVATE LIMITED",
"ZUARI INDIAN OILTANKING PRIVATE LIMITED",
"ZUARI INDUSTRIES LIMITED",
"ZUARI INFRAWORLD INDIA LIMITED",
"ZUARI INSURANCE BROKERS LIMITED",
"ZUARI INTERNATIONAL LIMITED",
"ZUARI INVESTMENTS LIMITED",
"ZUARI MANAGEMENT SERVICES LIMITED",
"ZUARI MAROC PHOSPHATES PRIVATE LIMITED",
"ZUARI SUGAR & POWER LIMITED",
"ZUB INNOMINDS PRIVATE LIMITED",
"ZUBEDA HOSPITAL",
"ZUBERI ENGINEERING CONSTRUCTION PRIVATE LIMITED",
"ZUBERI FIBRES PRIVATE LIMITED",
"ZUBHRA INDUSTRIES PRIVATE LIMITED",
"ZUCHE PHARMACEUTICALS PRIVATE LIMITED",
"ZUCI OVERSEAS PRIVATE LIMITED",
"ZUCI SYSTEMS (INDIA) PRIVATE LIMITED",
"ZUCITECH SOFTWARE SOLUTIONS PRIVATE LIMITED",
"ZUCOL SERVICES PRIVATE LIMITED",
"ZUCOL SOLUTIONS PRIVATE LIMITED",
"ZUDDHA ECO SOLUTIONS PRIVATE LIMITED",
"ZUELLIG PHARMA SPECIALTY SOLUTIONS (INDIA) PRIVATE LIMITED",
"ZUGANG MANPOWERS INDIA PRIVATE LIMITED",
"ZUGZWANG CHESS SCHOOL PRIVATE LIMITED",
"ZUHA LEATHER PRIVATE LIMITED",
"ZUINK SMART MOBILITY SOLUTIONS PRIVATE LIMITED",
"ZUIVEREN IMPEXCELLENCE PRIVATE LIMITED",
"ZUKA POWER PRIVATE LIMITED",
"ZUKEN INDIA PRIVATE LIMITED",
"ZULAIKHA MOTORS PRIVATE LIMITED",
"ZULPLAST PRIVATE LIMITED",
"ZULU HEALTH SN IT SERVICES PRIVATE LIMITED",
"ZUM ZUM COLD STORAGE PRIVATE LIMITED",
"ZUMA TRADING ENTERPRISES (OPC) PRIVATE LIMITED",
"ZUMANIX REMEDIES PRIVATE LIMITED",
"ZUMAX EQUIPMENTS PRIVATE LIMITED",
"ZUMBACH ELECTRONIC INDIA PRIVATE LIMITED",
"ZUME INDIA PRIVATE LIMITED",
"ZUMEN SOFTWARE INDIA PRIVATE LIMITED",
"ZUMI SOLUTIONS PRIVATE LIMITED",
"ZUMIGO INDIA PRIVATE LIMITED",
"ZUMUTOR BIOLOGICS PRIVATE LIMITED",
"ZUNO GENERAL INSURANCE LIMITED",
"ZUORA INDIA PRIVATE LIMITED",
"ZUPER HOTEL SOLUTIONS",
"ZUPERIA AUTO PRIVATE LIMITED",
"ZUPERSOFT SOLUTIONS PRIVATE LIMITED",
"ZUPITEX (INDIA) PRIVATE LIMITED",
"ZUPLEX ESTATES PRIVATE LIMITED",
"ZUPPA HOSPITALITY PRIVATE LIMITED",
"ZURAY TRADE MERCHANTS PRIVATE LIMITED",
"ZUREE TELECOM PRIVATE LIMITED",
"ZURI HOTELS AND RESORTS PRIVATE LIMITED",
"ZURICH INSURANCE GROP",
"ZURICH RISK MANAGEMENT SERVICES (INDIA) PRIVATE LIMITED",
"ZURINOVO HEALTHCARE PRIVATE LIMITED",
"ZURIY MARKETPLACE PRIVATE LIMITED",
"ZURU TECH INDIA PRIVATE LIMITED",
"ZUSAK EXIM PRIVATE LIMITED",
"ZUTI ENGINEERING SOLUTIONS PRIVATE LIMITED",
"ZUVA ENGINEERING PRIVATE LIMITED",
"ZUVAN ENERGY PRIVATE LIMITED",
"ZUVAN INTERNATIONAL TRANSPORT LIMITED",
"ZUVENTUS HEALTHCARE LIMITED",
"ZUVIUS LIFESCIENCES PRIVATE LIMITED",
"ZVC INDIA PRIVATE LIMITED",
"ZVEN TECHNOLOGIES PRIVATE LIMITED",
"ZVENTION MEDIA PRIVATE LIMITED",
"ZVEST FINANCIAL SERVICES LLP",
"ZVKY DESIGN STUDIO PRIVATE LIMITED",
"ZWAYAM DIGITAL PRIVATE LIMITED",
"ZWEEZLE MEDIA PRIVATE LIMITED",
"ZWENZI TRADERS AND ADVISORS PRIVATE LIMITED",
"ZWICKROELL PRIVATE LIMITED",
"ZWILLING KITCHEN INDIA PRIVATE LIMITED",
"ZWZ BEARINGS INDIA PRIVATE LIMITED",
"ZX SPORTING PRIVATE LIMITED",
"ZYBISYS CONSULTING SERVICES LLP",
"ZYCUS INFOTECH PRIVATE LIMITED",
"ZYDE SOFT SOLUTIONS PRIVATE LIMITED",
"ZYDEX INDUSTRIES PRIVATE LIMITED",
"ZYDEX ORGANICS",
"ZYDOVA HEALTHCARE PRIVATE LIMITED",
"ZYDUS ANIMAL HEALTH AND INVESTMENTS LIMITED",
"ZYDUS FOUNDATION",
"ZYDUS HEALTHCARE LIMITED",
"ZYDUS HOSPIRA ONCOLOGY PRIVATE LIMITED",
"ZYDUS HOSPITALS AND HEALTHCARE RESEARCH PRIVATE LIMITED",
"ZYDUS HOSPITALS VADODARA",
"ZYDUS INFRASTRUCTURE PRIVATE LIMITED",
"ZYDUS LIFESCIENCES LIMITED",
"ZYDUS PHARMACEUTICALS LIMITED",
"ZYDUS SITAPUR HOSPITAL",
"ZYDUS TAKEDA HEALTHCARE PRIVATE LIMITED",
"ZYDUS WELLNESS LIMITED",
"ZYDUS WELLNESS PRODUCTS LIMITED",
"ZYE TELECOM PRIVATE LIMITED",
"ZYEN BUSINESS SYSTEMS PRIVATE LIMITED",
"ZYENAC SOLUTIONS PRIVATE LIMITED",
"ZYETA INTERIORS PRIVATE LIMITED",
"ZYF TEX PRIVATE LIMITED",
"ZYFIN RESEARCH PRIVATE LIMITED",
"ZYFIX TOOLS PRIVATE LIMITED",
"ZYGNUM TECHNOLOGIES PRIVATE LIMITED",
"ZYGO COMBINES EXPRESS CARRIERS PRIVATE LIMITED",
"ZYGON INFRASTRUCTURES PRIVATE LIMITED",
"ZYGOTE DESIGN PRIVATE LIMITED",
"ZYLA HEALTH PRIVATE LIMITED",
"ZYLOTECH SOLUTIONS PRIVATE LIMITED",
"ZYMA PROPERTIES PRIVATE LIMITED",
"ZYME SOLUTIONS PRIVATE LIMITED",
"ZYMES BIOSCIENCE PRIVATE LIMITED",
"ZYMR SYSTEMS PRIVATE LIMITED",
"ZYNA MEDTECH PRIVATE LIMITED",
"ZYNC CAFE PRIVATE LIMITED",
"ZYNE IT CONSULTING PRIVATE LIMITED",
"ZYNERGY SOLAR PROJECTS AND SERVICES PRIVATE LIMITED",
"ZYNGA GAME NETWORK INDIA PRIVATE LIMITED",
"ZYNOM TECHNOLOGIES PRIVATE LIMITED",
"ZYNOVA HOSPITALS PRIVATE LIMITED",
"ZYNOVA SHALBY HOSPITAL",
"ZYNQ SOFTWARE PRIVATE LIMITED",
"ZYOIN WEB PRIVATE LIMITED",
"ZYPHARS PHARMACEUTICS PRIVATE LIMITED",
"ZYPHER LIFESCIENCES PRIVATE LIMITED",
"ZYPHER POWER LABS PRIVATE LIMITED",
"ZYPMEDIA INDIA PRIVATE LIMITED",
"ZYRUS ERETAIL PRIVATE LIMITED",
"ZYTEL ENTERPRISES PRIVATE LIMITED",
"ZYTERA RETAIL PRIVATE LIMITED",
"ZYTEX BIOTECH PRIVATE LIMITED",
"ZYTEX INDIA PRIVATE LIMITED",
"ZYTHUM INFOSYSTEM PRIVATE LIMITED",
"ZYTX SOFTWARE INDIA PRIVATE LIMITED",
"ZYVANA INTEGRATED SERVICES PRIVATE LIMITED",
"ZYVIEON HEALTHCARE PRIVATE LIMITED",
"ZYWIE VENTURES PRIVATE LIMITED",
"ZYXEL TECHNOLOGY INDIA PRIVATE LIMITED",
"ZYXWARE TECHNOLOGIES PRIVATE LIMITED",
"RKM INTERNATIONAL LLP",
"ITREAT GROCERS LLP",
"AVASI HOTELS",
"AEROGREEN BUILDING SOLUTIONS INDUSTRIES",
"UNIVERSAL AUTO PRODUCT",
"PROJECT FORCE 3E PVT LTD",
"MANOMITHRA INSTITUTE OF MEDICAL SCIENCES PRIVATE LIMITED",
"UDAY VIKAS VIDYALAY SOLAPUR",
"RATNAI MAGASVARGIY MULINCHE VASTIGRUH",
"VYANKATRAO DESHMUKH VIDYALAY BANSHELAKI",
"3M GLOBAL TECHNOLOGY CENTER LLP",
"KELIYA VASANA PRIMARY SCHOOL",
"SUB DISTRICT HOSPITAL PATHARDI",
"SHAMBHUNATH RESEARCH INSTITUTE OF MEDICAL SCIENCES AND HOSPITAL \nJHALWA",
"DY DIRECTOR REGIONAL RESEARCH STANDARD LAB AHMEDABAD",
"SHRI KRISHNA NEURO SPINE AND MULTISPECILIATY HOSPITAL",
"ECO ROYAL HANTEX LLP",
"GOVERNMENT OF ASSAM",
"DAKSH INFRASTRUCTURE",
"DR SHYAMA PRASAD MUKHERJEE UNIVERSITY",
"SYNCTHREADS COMPUTING LLP",
"ZSM BUSINESS SOLUTION PRIVATE LIMITED",
"MAHATMA GANDHI VIDYALAYA RAJGURUNAGAR",
"PRACHYA SHIKSHA NILAY SR SEC SCHOOL",
"RAWAT PUBLIC SCHOOL",
"KARMVIR SHANKARSING NAIK HIGH SCHOOL AURANGABAD",
"THE MILLENNIUM SCHOOL SURAT",
"MEDWELL HOSPITAL",
"GSFC UNIVERSITY",
"THE NAWANAGAR COOP BANK LTD",
"VAGMINE TECHNICAL SERVICES",
"AAKANKSHA KANYA VIDYALAYA",
"NATIONAL MODEL SENIOR SECONDARY SCHOOL",
"CEPHAS LIFE SCIENCES PRIVATE LIMITED",
"ROSARY PRIMARY SCHOOL",
"PHINIA DELPHI INDIA PRIVATE LIMITED",
"THE NAVODAYA ACADEMY SR SEC SCHOOL",
"XAVIER INSTITUTE OF SOCIAL SERVICE",
"C KANDASWAMI NAIDU COLLEGE FOR MEN",
"PACIFIC INSTITUTE OF MEDICAL SCIENCE",
"QUEENS PUBLIC SCHOOL",
"CENTRAL BUREAU OF COMMUNICATION",
"VISHWAS MULTISPECIALITY HOSPITAL",
"TARAPUR VIDYA MANDIR AND JR COLLEGE",
"MAINTWIZ TECHNOLOGIES PRIVATE LIMITED",
"BTW VISA SERVICES (INDIA) PRIVATE LIMITED",
"SILVERSTORM AMUSEMENT PARKS PRIVATE LIMITED",
"PREMIUM GLOBAL REALTY (INDIA) PRIVATE LIMITED",
"FOREX-CAPITAL SERVICES PRIVATE LIMITED",
"ARBRE CREATIONS PRIVATE LIMITED",
"CAMERAAH LABS PRIVATE LIMITED",
"FAST CREDIT FINANCE PRIVATE LIMITED",
"OUTER ORBIT TECHNOLOGIES PRIVATE LIMITED",
"AARK TECHNOLOGIES AND STAFFING PRIVATE LIMITED",
"PIONEER ELASTIC (INDIA) PRIVATE LIMITED",
"THE ANDHRA PRADESH STATE SEEDS DEVELOPMENT CORPORATION LIMITED",
"AIDIN TECHNOLOGIES PRIVATE LIMITED",
"DIALTRONICS SYSTEMS PRIVATE LIMITED",
"SRI VASISHTA EDUCATIONAL INSTITUTIONS",
"SAI SWARAJ MULTISPECIALITY HOSPITAL",
"NEW HIGHSCHOOL JR COLLEGE BACHANI",
"BAVLA NAGARPALIKA",
"NATIONAL INSTITUTE OF SCIENCE EDUCATION AND RESEARCH BHUBANESWAR",
"GANGAMAI COLLEGE OF ENGINEERING",
"ALIPORE HOSPITAL",
"DEVRAO PATIL MADYAMIC VIDYALAYA MAGRUL",
"SHREE SARASSWATHI VIDHYAAH MANDHEER SCHOOL",
"PATIALA HEART INSTITUTE",
"CM HO BURHANPUR",
"VANRAJ FOODS PRIVATE LIMITED",
"SUNRISE MULTISPECIALITY HOSPITAL",
"REVENUE DEPARTMENT",
"MUNICIPAL CORPORATION ABOHAR",
"THE SPORTS SCHOOL",
"VIGNAN INSTITUTE OF INFORMATION TECHNOLOGY",
"RAJO SINGH HIGH SCHOOL",
"INFORMATION AND PUBLIC RELATIONS DEPARTMENT",
"TECNI AND METAL PRIVATE LIMITED",
"RISHAANK FASHIONS ACCESSORIES PRIVATE LIMITED",
"INTER COLLEGE NAWABGANJ",
"VCODE INKJET SOLUTIONS PRIVATE LIMITED",
"MAXICUS TECHNOLOGIES PRIVATE LIMITED",
"KIRTI INTEGRATED SOLUTIONS INDIA PRIVATE LIMITED",
"SAIBOON LIFECARE PRIVATE LIMITED",
"INDIAN INSTITUTE OF MANAGEMENT SAMBALPUR",
"DIVINE ENGINEERING & INDUSTRIAL SOLUTIONS PRIVATE LIMITED",
"FULLSCOOP DIGITAL PRIVATE LIMITED",
"ASUUKI PRIVATE LIMITED",
"ROYAL FURNISHINGS PRIVATE LIMITED",
"VEDAS CURE PRIVATE LIMITED",
"AXIAI INNOVATIONS PRIVATE LIMITED",
"SANSAD TELEVISION",
"AADESH INTERNATIONAL SCHOOL",
"MP MANSINGAKA VIDHAYALAY SODDI",
"DILSUKHNAGAR HIGH SCHOOL",
"VIVEKANAND SENIOR SECONDRY SCHOOL",
"MODERN INDIAN SR SEC SCHOOL",
"CH DEVI LAL CO OP SUGAR MILLS LIMITED",
"PHOENIX PUBLIC SCHOOL",
"KARYALAY NAGAR PARISHAD DHAMNOD DIST RATLAM",
"ZEAL INTERNATIONAL SCHOOL",
"DR DY PATIL ACADEMY SHANTINIKETAN",
"MSME TECHNOLOGY DEVELOPMENT CENTRE AGRA",
"TARANG SOFTWARE TECHNOLOGIES PRIVATE LIMITED",
"SIEGER SPINTECH EQUIPMENTS PRIVATE LIMITED",
"PETROFAC PROJECTS AND SERVICES PRIVATE LIMITED",
"KHALSA COLLEGE OF VETERINARY & ANIMAL SCIENCES",
"WRS ENERGY SOLUTIONS LLP",
"MINDA INFRASTRUCTURE LLP",
"SRI RAGHAVENDRA EDUCATIONAL TRUST",
"RELIANCE PROJECTS AND PROPERTY MANAGEMENT SERVICES LIMITED",
"TECHNI IT SERVICES PVT LTD",
"FOUNDATION TO EDUCATE GIRLS GLOBALLY",
"JASTECH SYSTEMS PVT LTD",
"COLONEL ACADEMY MHOW",
"ACCURATE LABS",
"BRAND FANATICS PRIVATE LIMITED",
"PANCHAYAT RAJ DEPARTMENT",
"TRUSHAPE PRECISION CASTING PVT LTD",
"KHANDELWAL EDIBLE OIL LTD",
"TARJANI COMMUNICATIONS PVT LTD",
"ISHA BEARINGS",
"LUCEM LEGAL LLP",
"PROVIDENCE GIRLS H P S",
"DHANESHWARI AYURVED HOSPITAL & RESEARCH INSTITUTE",
"VIDYALANKAR GROUP OF EDUCATIONAL INSTITUTES",
"ST VINCENTS MATRICULATION HIGHER SECONDARY SCHOOL",
"AARNA CAPITAL LIMITED",
"C J LIVING",
"BASAS SEEDS INTERNATIONAL PRIVATE LIMITED",
"SRM BUSINESS SCHOOL",
"NATIONAL INSTITUTE OF FINANCE AND ACCOUNTS",
"TRIMURTI EDUCATION SOCIETYS VALLEY VIEW HIGH SCHOOL",
"DANA SHIVAM HEART & SUPER SPECIALITY",
"GIRISH PRASAD MEMORIAL COLLEGE BAREILLY",
"JMG BORDING SCHOOL",
"SINGHAL EXPORTS",
"DNTERIOR STUDIO",
"NAGARPARISHAD PULGAON DIST WARDHA",
"DISTRICT MALARIA OFFICE",
"SGL SUPER SPECIALITY HOSPITAL",
"SHRIFFLE TECHNOLOGIES PRIVATE LIMITED",
"GOPI PAPER MART (INDIA) PRIVATE LIMITED",
"SURYAPRIYA CONSTRUCTIONS PRIVATE LIMITED",
"PATEL LABOUR CONTRACTORS PRIVATE LIMITED",
"SYPRAM TECHNOLOGY PRIVATE LIMITED",
"ALATHEA BIOTEC PRIVATE LIMITED",
"JHALANI ISPAT PVT LTD",
"BLUVIUM TECHNOLOGIES PRIVATE LIMITED",
"DUNNAGE BAG PRIVATE LIMITED",
"TRIVEDI INFOWAY PRIVATE LIMITED",
"AXIOM TECHNOLOGIES SERVICES PRIVATE LIMITED",
"ASSOTECH SUN GROWTH ABODE LLP",
"ZPPS ZODEGAON",
"TAYWADE COLLEGE OF PHARMACY",
"RAMADA HOTEL JSR",
"ANJUMAN KHAIRUL ISLAM URDU HIGH SCHOOL MAHABALESHWAR",
"BLOCK EDUCATION OFFICER BHAIYATHAN",
"BASANT HIGH SCHOOL",
"MAYELE SERVICES LLP",
"TRINITY SKY DEVELOPERS LLP",
"VAISHNAVI MAHAVIDYALAYA WADWANI",
"GARE PALMA II COLLIERIES PRIVATE LIMITED",
"JANTA VIDYALAY LODGA",
"CAMP EDUCATION SOCIETY S DY CYRUS POONAWALLA HIGH SCHOOL",
"SRI RAMAKRISHNA BOYS MATRIC HR SEC SCHOOL",
"MAP PUBLIC SCHOOL",
"PLATINUM DESIGNS LIMITED LIABILITY PARTN ERSHIP",
"ASEEMA CHARITABLE TRUST",
"CMR UNIVERSITY SCHOOL OF LIBERAL STUDIES",
"UNITY JEWELS",
"CHEMTREAT CONSULTANTS",
"BOMBAY LOGISTICS",
"HUMAN RESOURCES SOCIETY",
"SARA NURSING COLLEGE",
"KSRTC SWIFT LIMITED",
"TRIADA TECHNOLOGIES INDIA PRIVATE LIMITED",
"KYOWA CASTEC INDIA PVT LTD",
"SHUBHASHISH BUILDERS AND DEVELOPERS",
"MANGLAM CONSULTANCY SERVICES HYDERABAD",
"KSR INSTITUTE OF DENTAL SCIENCE AND RESEARCH",
"ACS COLLEGE OF ENGINEERING",
"CS CUM SUPDT DISTT HOSPITAL KHANDWA",
"ZENITH EDUCATIONAL FOUNDATION",
"DHANALAKSHMI SRINIVASAN INSTITUTE OF MEDICAL SCIENCES AND HOSPITAL",
"PRIMARY SCHOOL INDRAVARNA",
"PRASHASTHI PU & DEGREE COLLEGE",
"MADHYAMIK GRAM SHALA",
"BIHAR STATE POWER TRANSMISSION COMPANY LIMITED",
"PSP MEDICAL COLLEGE HOSPITAL & RESEARCH INSTITUTE",
"NAVJEEVAN CBSE ACADEMY",
"ADD UR CO LLP",
"JAIPUR INDUSTRIAL SERVICES",
"NEW LEAF CONSULTANTS19",
"ZENITH EXIM PRIVATE LIMITED",
"CIVIL JUDGE J D KOPARGAON",
"SAL INSTITUTE OF MEDICAL SCIENCES",
"PIXELVIDE DESIGN SOLUTIONS LLP",
"M B PATEL RASHTRABHASHA ARTS AND COMMERCE COLLEGE AHMEDABAD",
"GURU GOBIND SINGH COLLEGE OF PHARMACY",
"JAIPUR CONSTRUCTION",
"PICTORY INDIA PRIVATE LIMITED",
"RED APRICOT SOFTWARE PRIVATE LIMITED",
"NBN MINDS PRIVATE LIMITED",
"SUKAN EQUIPMENTS PRIVATE LIMITED",
"SENTHUR TEXTILES PRIVATE LIMITED",
"MALLAVEE GLOBAL MANUFATURING",
"ASPIN IT SOLUTIONS PRIVATE LIMITED",
"BENCHMARK TALENTS",
"MS SCHOOL",
"DISTT WOMEN AND CHILD DEV SAGAR",
"STATE TAX ASSISTANT COMMISSIONER KORBA CIRCLE 2",
"ORDNANCE FACTORY ITARSI",
"KRISHAK COLLEGE OF PHARMACY",
"DHARMA INDUSTRIES",
"DR RADHAKRISHNAN SCHOOL OF ARTS COMMERCE & SCIENCE",
"DESIGN PLANNING AND MONITORING CIRCLE JSR",
"SHARP ENGINEERING SERVICES",
"PINEGROVE EDUCATIONAL INSTITUTIONS",
"MS BHARAT ENTERPRISES (SHOE UNIT)",
"SIDDH MULTISPECIALTY HOSPITAL MORADABAD",
"SKY ENTERPRISE",
"THE NIZAMABAD DIST COOP CENTRAL BANK LTD",
"SKYWORLD HOTELS AND RESORTS",
"LONGTONG TEA COMPANY",
"IMATE ENGINEERING PRIVATE LIMITED",
"KRISHNA VISHWA VIDYAPEETH (DEEMED TO BE UNIVERSITY ) KARAD",
"ADITYA AUTOMOTIVE INC INDIA",
"U V OVERSEAS",
"SCHOOL EDUCATION DEPARTMENT PRINCIPAL GOVT HIGHER SECONDARY SCHOOL BHAIYATHAN",
"VARA HOUSING DEVELOPERS LLP",
"UNI CAL LABS PRIVATE LIMITED",
"APS MINERALS & ADDITIVES PRIVATE LIMITED",
"ZEYYER PHARMACEUTICALS PRIVATE LIMITED",
"NOPADVANCE LLP",
"PARMANAND",
"SHREE SAIBABA SANSTHAN TRUST SHIRDI",
"SERRALA CENTER OF EXCELLENCE LLP",
"NEW ORG ABROAD SERVICES INC",
"NEW ORG HOLY CROSS COLLEGE",
"VIKRAM TRADING COMPANY",
"AMITY CENTRE FOR EDUCATIONAL RESEARCH AND TRAINING",
"KTS GENRAL HOSPITAL",
"ASSOCIATION URDU GIRLS PRIMARY SCHOOL",
"SANGAM UNIVERSITY",
"MELWIN HOME FASHION",
"TANDAV NEWS",
"AHMEDNAGAR APEX MULTI SPECIALITY HOSPITAL",
"DAKSH INFRA PROJECT",
"WOODLANDS EDUCATIONAL SOCIETY",
"WEB TECHNOLOGY",
"JEEVAN MULTISPECIALITY HOSPITAL AND TRAUMA CENTRE",
"GOODAY PRODUCTS",
"CWC REGIONAL OFFICE AHMEDABAD",
"SARAWGI MOTORS PRIVATE LIMITED",
"IQUANTS ENGINEERING SOLUTIONS PRIVATE LIMITED",
"BOMBAY TOOLS CENTRE (BOMBAY) PRIVATE LIMITED",
"PAMZ3D DESIGNS INDIA PRIVATE LIMITED",
"COMPUTER TRANSWORLD (IT) PRIVATE LIMITED",
"HEALTH CATALYST INDIA PRIVATE LIMITED",
"AMBIKA SAREES PRIVATE LIMITED",
"RUDRA INNOVATIVE SOFTWARE PRIVATE LIMITED",
"CH DEVILAL CO-OPERATIVE SUGAR MILLS LIMITED",
"VIVEK HOSTING COMPANY",
"HORIZON CARGO SYSTEM PRIVATE",
"INDO STEEL ENGINEERS",
"ST. XAVIERS ENGLISH SCHOOL",
"MALYA JEWEL CRAFT",
"JANTA VIDYAMANDIR MURUD",
"YAGYAVALKYA INSTITUTE OF TECHNOLOGY",
"A R J COLLEGE OF ENGINEERING AND TECHNOLOGY",
"GAUGE16 HOTELWARES LLP",
"SHREE SWAMINARAYAN HIGHSCHOOL",
"DISTRICT CONSUMER DISPUTE REDRESSAL FORUM SURGUJA C.G",
"SARASWATI VIDYA MANDIR",
"ST¬†PAUL S SCHOOL",
"AMAN DENTAL CARE AND IMPLANT CENTRE",
"VIDYAMANDIR PERID",
"GR GUPTA AND COMPANY",
"VTI SECURITY SERVICES",
"MAYA CONSTRUCTION",
"ST VINCENT PALLOTTI COLLEGE OF ENG AND TECH",
"SHRI DHOKESHWAR COLLEGE",
"SHREE MONARK EDUCATION TRUST",
"HIMACHAL PRADESH UNIVERSITY SHIMLA",
"ST JOSEPHS COLLEGE OF COMMERCE",
"BO INVESTMENT SERVICES LLP",
"CHRISTIAN MEDICAL ASSOCIATION OF INDIA",
"STAINLESS INDCOSERVE",
"USD HR SOLUTIONS",
"RTSS MAN POWER SOLUTIONS",
"QUALITY FOODS",
"INDIANA OPHTHALMICS",
"SKI DETAIL",
"EDUCATION OFFICE OF THE BLOCK EDUCATION OFFICER PUSSORE RAIGARH",
"UPPER WARDHA IRRIGATION DIVISION AMRAVATI",
"SAANCTUMN LABS PRIVATE LIMITED",
"ILLUMIFIN INDIA LLP",
"TIRUPUR DISTRICT CONSUMER COOPERATIVE WHOLE SALE STORE LTD",
"CITY CORPORATION BELGAUM",
"MECKLAI AND MECKLAI",
"THUKKUGUDA MUNICIPALITY",
"RNS INTERNATIONAL SCHOOL",
"GREEN GLOBE SOLUTION",
"ORIENTAL INSTITUTE SENIOR SECONDARY SCHOOL",
"ZAVI MEDICARE LLP",
"BELLE CRAFT",
"NISCORT FATHER AGNEL SCHOOL",
"ST ANDREWS SCHOOL AGRA",
"TRYON SOLUTIONS INDIA PRIVATE LIMITED",
"AMPLUS LOGISTICS INDIA PRIVATE LIMITED",
"SAGAR SHIKSHA SANSTHAN",
"ARMY PUBLIC SCHOOL BARRACKPORE",
"BHOOMI TIMBERS",
"MITTAL EYE CARE",
"MISHRA SAHU JAIN & ASSOCIATES",
"PEARLDATA DIRECT PRIVATE LIMITED",
"MAULANA ABUL KALAM AZAD UNIVERSITY OF TECHNOLOGY",
"GREYAMP CONSULTING",
"BHARTHIDHASANAR GROUP OF SCHOOLS",
"SHRI MAHAVIR HOSPITAL",
"VILASRAO DESHMUKH COLLEGE OF AGRICULTURAL BIOTECHNOLOGY",
"MVM EDUCATIONAL TRUST",
"DFO W GEN DIVISION MANDLA",
"SCHOOL EDUCATION DEPARTMENT BLOCK EDUCATION OFFICER PATHARIYA",
"SAIVVY INFOTECH",
"K V PENDHARKAR COLLEGE OF ARTS SCIENCE AND COMMERCE",
"DISTRICT HEALTH SOCIETY",
"DREAMS SUPERSPECIALITY HOSPITAL",
"TASIL OFFICE SHIRUR",
"SRI RAMA SWAMY VARI DEVASTHANAM RAMATHEERTHAM",
"UNIVERSAL CONSTRUCTIONS",
"LAL JI GOPINATH JI INDUSTRIES",
"SCHOOL EDUCATION DEPARTMENT BLOCK EDUCATION OFFICER PREMNAGAR",
"IMMACULATE DATA SOLUTIONS PRIVATE LIMITED",
"DIVINE INSTITUTE OF MANAGEMENT STIDIES",
"ST PETER'S SENIOR SECONDARY SCHOOL",
"BRONCO SYSTEMS",
"INFOWELL AUTOMATION SOLUTIONS",
"NATIONAL GROUP OF SERVICE",
"SPIC NAGAR SCHOOL",
"PAPER PACK INDUSTRIES",
"NEDSPICE DEHYDRATION INDIA LLP",
"SWAMI ATMANANDA GOVT ENGLISH MEDIUM SCHOOL EXCELLENCE BALODA JANJGIR CHAMPA",
"ST SOLDIER ELITE SCHOOL",
"RAJSHREE MEDICAL RESEARCH INSTITUTE BAREILLY",
"PRINCIPAL GOVT H S SCHOOL BAIMA",
"SUPPLY DEPARTMENT BEED",
"JALNA COLLEGE OF SOCIAL WORK",
"UDUPI NIRMITHI KENDRA",
"SRI CHANNABASAVESHWAR P U COLLEGE OF ARTS SCIENCE AND COMMERCE",
"VISHWAS MULTI HOSPITAL",
"KRUSHI UTPANNA BAZAR SAMITI BHIWANDI",
"GENERAL HOSPITAL MANSA",
"ARR EXPORTERS PRIVATE LIMITED",
"CHAHARWATI INT COLL AKOLA AGRA",
"MARUTI MANAGEMENT SERVICES",
"DCIPHERS IT SOLUTIONS PRIVATE LIMITED",
"THASVIEK INC",
"GOA SAMAGRA SHIKSHA",
"MANSI HOSPITAL¬†",
"ACCOUNTANT GENERAL A AND E AP VIJAYAWADA",
"SOUTH CITY PUBLIC SCHOOL",
"NAVBHARAT",
"MURLIDHAR AYURVED COLLEGE",
"IRENA JEWELS LLP",
"STATION HEAD QUARTER KIRKEE",
"R G YADAV ENGLISH HIGHER SECONDARY SCHOOL",
"JERMELS ACADEMY",
"FRIENDS DETECTIVE SECURITY SERVICES",
"ST FRANCES WORLD SCHOOL",
"UDVAT TECHNOLOGIES PRIVATE LIMITED",
"PRASHANSA INDUSTRIES",
"SURYODAY FOUNDATION",
"RAO KHEMCHAND VIDYA VIHA SR SEC SCHOOL",
"STANLEY MATRICULATION HIGHER SECONDARY SCHOOL",
"BMR ENTERPRISES",
"ASTER HOSPITALS AND CLINIC",
"PANCHAYAT SAMITI MALSHIRAS",
"ESPIRIT TRUCKING GHAZIABAD",
"INSIGHT DIRECT INDIA PRIVATE LIMITED",
"OBS HIGHER SECONDRY SCHOOL",
"DIRECTORATE OF SECONDARY EDUCATION UTTAR PRADESH",
"S D MEMORIAL SR SEC SCHOOL",
"GECO SPECIAL MACHINERS",
"SUNFLOWER LABORATORY AND DIAGNOSTIC CENTRE",
"PAHARI SECURITY SERVICE PRIVATE LIMITED",
"ASHOKE BHAI PATEL SECURITY AGENCY",
"HIMMAT JAI MOTORS",
"DSP PUMPS",
"RADICAL AIR TECH LLP",
"TECHNO CANADA INC",
"GOVERNMENT AYURVEDA COLLEGE BILASPUR",
"MADHAMIK ASHRAMSHALA PETH VADGAON",
"TALUKA AGRICULTURE OFFICE PATHARDI",
"MITRA ACADEMY",
"UNITE CLOUD SERVICES LLP",
"LOTUS EYE HOSPITAL",
"R D CONTRACTOR HIGH SCHOOL SECONDARY HIGHER SECONDARY",
"PAILAN COLLEGE OF MANAGEMENT & TECHNOLOGY",
"MAN MOHAN GROVER",
"ROBUST EVENTS LLP",
"THE RENAISSANCE SCHOOL",
"ZAN COMPUTECH INDIA PRIVATE LIMITED",
"SECURITY GUARDS BOARD FOR BRIHAN MUMBAI & THANE DISTRICT",
"SIDDHASIRI SOUHARDA SAHAKARI SANHGA NIYAMIT",
"SRI BHEEMANNA KHANDRE INSTITUTE OF TECHNOLOGY BHALKI",
"CODEMYMOBILE INC",
"KEEN SMART SOLUTION",
"ELITE HAIR & BEAUTY BAR",
"SLEEFEX METAL SYSTEMS PRIVATE LIMITED",
"BARODA DISTRICT CO-OPERATIVE MILK PRODUCER'S UNION LTD",
"SHIV SAMARTH VIDYALAYA THANE",
"PAO GSI CENTRAL REGION NAGPUR",
"MOMS PRIDE SCHOOL",
"COLORS CHILDREN HOSPITAL",
"NASHIK MAHANAGAR PALIKA",
"GAD P S RAJAPUR",
"STARLIGHT PACKAGING PRIVATE LIMITED",
"AKSHARA PUBLIC SCHOOL",
"GIR SOMNATH DISTRICT EDUCATION COMMITEE MANAGED PRIMARY SCHOOL TEACHER",
"KISHAN INDUSTRIES",
"RAGENDRA SWARUP PUBLIC SCHOOL AGRA",
"MONOCLOUD (INDIA) LLP",
"BRANCH METRICS APAC INDIA PRIVATE LIMITED",
"R P CLAN LLP",
"SANJIVANI COLLEGE OF NURSING IN TIRLA DHAR",
"S G DEGREE B.ED PRASHIKSHAN KENDRA",
"DFO T DIVISION JABALPUR",
"DATTA VIDYALAYA BHOYARE GANGARDA",
"SMIT HOSPITAL NANDURBAR",
"APANG NIVASHI VIDHYALAY JALNA",
"R K ENTERPRISES",
"PUBLIC INT COLL JAHANGIR PUR G B NAGAR",
"AVTEL SERVICES INDIA LLP",
"GLOBAL HOMES AND HEIGHTS LLP",
"HORIZON HOSPITAL",
"SPAN ENTERPRISES",
"PROPEL HEALTH CARE",
"RONSON CHEMICALS LLP",
"SRINIVASA TEXTILE",
"SANT DNYANESHWAR VIDYA TAKLIMIYA",
"JAGANNATH GUPTA INSTITUTE OF MEDICAL SCIENCES",
"BEO DEWAS MADHYA PRADESH",
"MVAC ENGINEERS",
"SRI VAISHNAVI GROUP OF SCHOOLS",
"GOVT H S SCHOOL SILPHILI DIST SURAJPUR CG DDO 2720036",
"BEST SCHOOL",
"APARNA AUTOMOTIVES",
"DELHI BHARAT VIKAS FOUNDATION",
"FASHION SALON ACADEMY",
"SMP JEWELS",
"SJR KENGERI PUBLIC SCHOOL",
"HI TECH GROUP",
"JINDAL VIDYA MANDIR",
"TOOLIQA INNOVATIONS LLP",
"PAO(COLLECTORATE OF CUSTOMS) CHENNAI",
"JARUN PHARMACEUTICALS PRIVATE LIMITED",
"LOURDES CONVENT SCHOOL (CBSE)",
"TVISHI SERVICE PRIVATE LIMITED",
"DAHOD DISTRICT EDUCATION COMMITTEE RUN PRIVATE SCHOOL TEACHERS",
"SJ ENVIRONMENTAL SOLUTIONS¬†",
"EZONE",
"KATIHAR MUNICIPAL CORPORATION",
"VENUS GLOBAL CAMPUS CBSE SCHOOL",
"DELTA LEATHER CORPORATION",
"UNITED METALTECH INDUSTRIES LLP",
"HUSAMIAH BOYS HIGH SCHOOL",
"CHURCH AND DWIGHT INTERNATIONAL OPERATIONS LLC",
"DAKSHAYANI VIDYAMANDIR RANJANGAON SP",
"YEASWANT MADHYAMIK VIDYALAYA BEED",
"R R INSTITUTE OF TECHNOLOGY /P K M EDUCATIONAL TRUST",
"REHANSH CHEMWORLD",
"INNOVATE OR DIE",
"SRIMATHI SUNDARAVALLI MEMORIAL SCHOOL",
"LATE SHANTILALJI SONI NIPHAD NAGARI SAHAKARI PAT MAR NIPHAD",
"GNYANA SUDHA PU COLLEGE FOR SCIENCE ARTS AND COMMERCE BIDAR",
"PSVS CLEAN SHEET GROUP",
"MAHARSHI GURUKUL",
"MAHALAXMI HOSPITAL AND TRAUMA CENTRE SIYANA",
"VIDYANIKETAN HIGH SCHOOL",
"AGRICULTURE DEPARTMENT HEAD QUARTER Z P GONDIA",
"OFFICE DEPUTY DIRECTOR AGRICULTURE PLANT PROTECTION PRAYAGRAJ",
"DATA TECHNOLOGY PROCESSING CORPORATION",
"SHREE TDD HIGH SCHOOL",
"THE AKSHAYA ACADEMY CAMPUS",
"GOVERNMENT ARTS AND COMMERCE COLLEGE NETRANG",
"P E S JR COLLEGE C B D",
"BIOMEDICA HEALTHCARE",
"MAYOOR SCHOOL SILIGURI",
"KAMLA NEHRU MEMORIAL HOSPITAL",
"BAAASUREE",
"WITS INNOVATION LAB",
"JALGAON ZILLA SARKARI NOKRANCHI SAHKARI PATPEDHI LTD",
"H D PUBLIC SCHOOL",
"FIRST CONNECT DIGITAL PRIVATE LIMITED",
"M/S RATNA ROY",
"SHARDA SCHOOL OF PHARMACY",
"BHARAT ASSOCIATES PRIVATE LIMITED",
"CABTECH ENGINEERING LLP",
"(VUG) ITM VOCATIONAL UNIVERSITY",
"BAL SAHYOG",
"ANDH KANYA PRAKASH GRUH",
"DECCAN DEVELOPMENT SOCIETY‚ÄôS KRISHI VIGYAN KENDRA",
"SHIV SHAKTI ENGINEERS",
"RBS PUBLIC SCHOOL",
"NAGAR PARISHAD KARYALAY DARWA",
"FORESIGHT ROOFINGS LLP",
"ATRIUM INSIGHT LLP",
"SUNDARI DEVI INTER COLLEGE ALIGARH",
"MAMLATDAR OFFICE VADALI",
"NETAJI SUBHASH HIGH SCHOOL",
"SUP LEND RECORD RE DEWAS",
"PRICELINE.COM TECHNOLOGY INDIA LLP",
"VENTURESPRO PROJECTS LLP",
"TAGORE ACADEMY",
"BEST MATRIC HR SEC SCHOOL",
"SAN ACADEMY GROUP OF SCHOOLS",
"MS M F JAIN",
"THE GANDHINAGAR MILK CONSUMER CO OP SOCIETY LTD",
"FUTURE TECH WIZARDS LLP",
"MALAVIA MULTI SPECIALITY HOSPITAL",
"GURUKUL OLYMPAID SCHOOL",
"C P GOENKA INTERNATIONAL SCHOOL",
"ADDL REGISTRAR HIGH COURT MP INDORE BENCH",
"YUG NIRMAN POWER PROJECT",
"MVR TECHNOLOGY",
"TRIMURTI KNITTING WORKS",
"SRI KRISHNA INT COLL",
"PERENNIAL SYSTEMS",
"HINDUSTAN RUBBERS(SILVASSA)",
"NEW PARAGON SENIOR SECONDRY SCHOOL",
"LAL BAHADUR SHASHTRI VIDYALAYA BAHE",
"GOVT OF CHHATTISGARH HIGHER EDUCATION DEPARTMENTPRINCIPAL GOVT. P G COLLEGE CHAMPA JANJGIR-CHAMPA(C.G.)",
"GURU JAMBHESHWAR UNIVERSITY OF SCIENCE & TECNOLOGY HISAR HARYANA",
"KEC BRCCPL JV",
"THE SKY SCHOOL",
"A M POWER SOLUTION",
"MAHARAJA RANJITSINH GAEKWAD INSTITUTE OF DESIGN",
"I N S B INSTITUTE OF INFORMATION TECHNOLOGY AND MGT.STUDIES",
"EVER GREEN THE FACILITY SOLUTIONS",
"CHEMICAL RESOURSES",
"B E O MOHKHED MADHYA PRADESH",
"PRATHMIK ASHRAM SCHOOL AKOLABAZAE",
"SWAMI KESHWANAND SHIKSHAN SANSTHAN SR SEC SCHOOL",
"WARDEN GOVT S T BOYS HOSTEL RAMTEK",
"MANISH JEWELLERS",
"NAVJEEVAN SHIKSHA SASTHAN SENIOR SEC SCHOOL",
"Z P PS RAMDONGRI",
"SAHAJ INFOTECH",
"CONCEPTUAL PHYSICS",
"SINHGAD DENTAL COLLEGE & HOSPITAL",
"ADFACTORS ADVERTISING LLP",
"THE HYDERABAD PBLIC SCHOOL",
"CHITTURI HIGH SCHOOL",
"M2 I",
"BANSAL CARGO MOVERS",
"SAI ENGLISH ACADEMY",
"ACADEMY OF MANAGEMENT STUDIES",
"BRIGHT VISIONZ",
"SNPB INTERNATION SCHOOL",
"SOCIETY FOR TECHNOLOGYAND ACTION FOR RURAL ADVANCEMENT",
"YASHWANT MADHAMIK KANYA SHALA DEOLI",
"EMBASSY OF THE REPUBLIC OF TURKEY",
"STERLING MULTI SPECIALITY HOSPITAL",
"PRATHAMIK SHALA KOLHAPUR (RAO) P. S. DEOLI",
"NARSINHBHAI PATEL COLLEGE OF COMUPTER STUDIES AND MANAGEMENT",
"JB MAHAJAN DEGREE COLLEGE CHAURI CHAURA",
"THE BHAGYALAKSHMI MAHILA SAHKARI BANK LTD",
"JESUS AND MARY CONVENT SCHOOL",
"VINAYAK VIDYALYA CHANDAI EKO",
"INLOOMS STUDIO",
"PANCHI JR HIGH SCHOOL",
"MRS K S K ARTS SCIENCE AND COMM COLLEGE BEED",
"UNIVERSITY OF SCIENCE AND TECHNOLOGY MEGHALAYA",
"M/S DANSPARK & CO",
"SNDT ARTS & COMMERCE COLLEGE",
"BELGHARIA JATINDAS VIDYAMANDIR",
"GOVT OF CHHATTISGARHGOVT H.S.S.MONGRA KORBA(C.G.)",
"MERISIS WEALTH PRIVATE LIMITED",
"XTREME SOFTECH PVT.LTD.",
"LUK TECHNICAL SERVICES PRIVATE LIMITED",
"THE HERO PUBLIC SCHOOL",
"NEW ENGLISH SCHOOL & JR. COLLEGE OF SCIENCE PARNER",
"JPR MOTORS LLP",
"AUTOMOTIVEIS DE CRISTAL LLP",
"AMBASSADOR TOURS AND TRAVELS LLP",
"NEED BASE INDIA NGO",
"SIGMA HTS LLP",
"ARS BLASTING SERVICES PRIVATE LIMITED",
"SESHACHALAM AND CO¬†",
"G D MATRICULATION HIGHER SECONDARY SCHOOL¬†",
"STERLING MOTORS- SOLAPUR",
"RED ON POWER SOLUTIONS LLP",
"SHRI RAJKOT DISTRICT CO OP BANK LTD",
"SOUTH INDIA SHOPPING MALL",
"NEXINA LIFE SCIENCES PRIVATE LIMITED",
"OFFICE OF THE ELECTRICAL INSPECTOR",
"SS GOLD",
"KMC PUBLIC SENIOR SECONDARY SCHOOL",
"HAPPY VALLEY SCHOOL",
"WANTURA LABORATORIES",
"ANANTA INSTITUTE OF HOTEL MANAGEMENT & ALLIED STUDIES",
"RIGHT MARK CONSULTANCY",
"NAGAR NIGAM VARANASI",
"INVESTMENTSATHI",
"PARAG VIDYALAYA",
"SHRI CHAITANYA HEALTH AND CARE TRUST",
"D Y PATIL EDUCATION SOCIETY KOLHAPUR",
"SHREE JAGADGURU GANGADHAR HIGH SCHOOL",
"INNOVATIVE LEARNING FOUNDATION",
"DEPL O&M LIMITED",
"KAMAR TECHINICAL INTER COLLEGE JEWAR",
"BABASAHEB PATIL VIDYAMANDIR YELAVI",
"THE GURUKULAM PUBLIC SCHOOL",
"RIGHTSERVE SOLUTIONS PRIVATE LIMITED",
"SRI RAMAKRISHNA MATRIC HR SEC SCHOOL",
"SUPA HOSPITALS PRIVATE LIMITED",
"ARCHANA CHILDREN'S ACADEMY SR SEC SCHOOL",
"ST CLARE'S SENIOR SECONDARY SCHOOL",
"SURENDRANAGAR DISTRICT PANCHAYAT",
"THE LUDHIANA CENTRAL COOPERATIVE BANK LTD",
"HP GHOSH HOSPITAL",
"SATCHIDANANDA JOTHI NIKETHAN INTERNATIONAL SCHOOL",
"PRAGATI COLLEGE DOMBIVLI EAST",
"THE CO-OPERATIVE BANK OF RAJKOT LIMITED",
"SARATHA MATRIC HIGHER SECONDARY SCHOOL",
"PAO LOK SABHA SECRETARIAT",
"NOIDA INTERNATIONAL UNIVERSITY",
"SANDIP UNIVERSITY",
"AMRAPALI EXPORTS",
"BARKAAT PUBLIC SCHOOL",
"DANCENTER A/S",
"MADHYA PRADESH SHASKIYA MADHYAMIK VIDYALAYA MIDDLE SCHOOL",
"LOVELY AUTOS",
"BELIEVE IT C.W.S",
"BABA FARID GROUP OF INSTITUTIONS",
"MILITARY HOSPITAL JHANSI",
"PREMIER MEDICAL ASSOCIATES PRIVATE LIMITED",
"SRI DEEP CHAND INTER COLLEGE",
"ASPIRE SOFTSERV PRIVATE LIMITED",
"AANDB BUSINESS SOLUTIONS PRIVATE LIMITED",
"SHEETAL CONSULTANCY SERVICES¬†",
"GOVERNMENT OF CHHATTISGARH DISTRICT AND SESSIONS JUDGE",
"GURU HOSPITAL",
"SOPHIA SR SEC SCHOOL",
"ASTECH PHARMA",
"BLOCK EDUCATION OFFICER PARASIA MADHYA PRADESH",
"SCHOOL EDUCATION DEPARMENT CHHATTISGARH OFFICE OF THE BLOCKEDUCATION OFFICER KORBA DISTT.-KORBA(C.G.)",
"GOVT OF INDIA INDIAN AUDIT AND ACCOUNT DEPARTMENT",
"GUDEL PRIMARY SCHOOL",
"IMPELCO ELECTRIC COMPANY",
"S E D SR SEC SCHOOL",
"INS-MED HOSPITAL LLP",
"SIDDHARTHA COLLEGE OF PHYSICAL EDUCATION",
"ST PATRICKS HS SCHOOL",
"GOVE OF CHHATTISGARH HOME ( JAIL ) DEPARTMENT OFFICE OF THE JAIL SUPERINTENTDENT DISTRICT JAIL KORBA ( C.G )",
"EDUCE SOLUTIONS PRIVATE LIMITED",
"KUVAM ENTERPRISES",
"DRIEMS UNIVERSITY",
"PEARL DROP SCHOOL",
"PREM RAGHU AYURVEDIC MEDICAL COLLEGE AND HOSPITAL",
"SHAHBABU URDU JR COLLEGE PATUR DISTRICT AKOLA",
"WEDLOCK GREENS HOTELS & RESORT",
"LANS PROJECTS LOGISTICS PRIVATE LIMITED",
"DR MOHD IQBAL JR COLLEGE AMBAJOGAI",
"SAGITTARIA EXPORTS PRIVATE LIMITED",
"NUTAN MADHYAMIK VIDYALAY INDAVE",
"EREHWON ORBIT-SHIFT FOUNDATION (EOSF)",
"OM HOSPITAL MULTISPECIALITY AND TRAUMA CENTRE",
"UTOPIAN LUXE",
"MBBG RGC GIRLS COLLEGE OF EDUCATION MANSOWAL",
"DR ROY'S DIAGNOSTICS CENTRE PRIVATE LIMITED",
"PN ENTERPRISES",
"INDIVILLAGE TECH SOLUTIONS LLP",
"DISTINCT PRODUCTIVITY SOLUTIONS",
"SALT LAKE SOCIETY FOR HOTEL MANAGEMENT",
"V P ENTERPRISES LLP",
"KUMAR AUTO SALES",
"KUMBHALGARH FORT RESORT & SPA PRIVATE LIMITED",
"KAIROSE PHARMA PRIVATE LIMITED",
"PRONEXUS CONSULTING PRIVATE LIMITED",
"PRIMROSE STAFFING SOLUTIONS INDIA PRIVATE LIMITED",
"GLANIS INSTITUTE OF MEDICAL AND ALLIED HEALTH SCIENCES",
"SHREE AMBIKA PRINTERS PUBLICATIONS",
"VISHNU CARPET 38500",
"GOREL PRIMARY SCHOOL",
"REVA RESORTS AND HOLIDAY HOMES",
"STEP BY STEP PUBLIC SCHOOL ALWAR",
"RAJA MOTORS",
"CHARU OVERSEAS",
"NISHA ENGINEERS & CONTRACTORS",
"MAHESH MADHYAMIK VIDYALAYA",
"AADHARSH MARATHI PR SCHOOL",
"EUPRAXIA - CENTRE FOR CLINICAL EXCELLENC E LLP",
"ST JOSEPH'S CONVENT SENIOR SECONDARY SCHOOL",
"GOEL INSTITUTE OF TECHNOLOGY & MANAGEMENT",
"KHAIRUL MOMINEEN URDU HS KIRADPURA",
"MANGRULE SEC SCHOOL AKKALKOT (URBAN/RURAL)",
"HOTEL HD RESIDENCY",
"CHENDHURAN COLLEGE OF ENGINEERING TECHNOLOGY",
"BHARATHI VIDYA BHAVAN MATRIC HR SEC. SCHOOL",
"SALBARI HIGH SCHOOL",
"NEW ERA COLLEGE INDORE",
"SAPPHIRE HOSPITAL",
"UNIVERSITY COLLEGE OF ENGINEERING ARIYALUR",
"INVASSET LLP",
"BLUE OCEAN CRM INC",
"SUPERINTENDING ENGINEER RAMPUR",
"N TEX APPAREL PRIVATE LIMITED",
"TRUVISORY GLOBAL SERVICES PRIVATE LIMITED",
"STELLEN INFOTECH PRIVATE LIMITED",
"INNOVATIVE CONTROLS PRIVATE LIMITED",
"TOTAL EVENT MARKETING PRIVATE LIMITED",
"SUPERIOR POWER SOLUTION SERVICES PRIVATE LIMITED",
"GURJARI SERVICES LIMITED",
"SAMIR AGRO PRODUCTS PRIVATE LIMITED",
"SANGUINE GENETICS PRIVATE LIMITED",
"ITAUTI INTEGRATED SOLUTIONS PRIVATE LIMITED",
"LAXMI OPHTHALMIC SERVICES PRIVATE LIMITED",
"EZEEES INDIA PRIVATE LIMITED",
"EXPRIMUNT MEDICAL BILLING PRIVATE LIMITED",
"SHRIPAD ENGINEERING SERVICES PRIVATE LIMITED",
"OPTINN SOLUTIONS PRIVATE LIMITED",
"VOTERCIRCLE INDIA PRIVATE LIMITED",
"DIGI NURTURE PRIVATE LIMITED",
"SHIMPUKADE METALLGUSS PRIVATE LIMITED",
"RAINFOREST GOLDEN BASKET PRIVATE LIMITED",
"JANANAM FERTILITY PRIVATE LIMITED",
"IKORP TECHNOLOGY CONSULTING PRIVATE LIMITED",
"SAI SHRADDHA ENTERPRISES LLP",
"DHANESH FABRICS PRIVATE LIMITED",
"OXY LINE BEVERAGES PRIVATE LIMITED",
"BHIMRAO PINGLE MS BEED",
"SPK & CO",
"DR CHANDRABHANU SONVANE JR COLLEGE",
"SARTHAK CONSTRUCTION COMPANY",
"MAA BHAGVATI KANYA VIDHYALAY",
"JAIMAL CONSTRUCTION",
"SHREE MAHALAXMI TEXTILE",
"MNOHARBHAI PATEL COLLEGE OF ARTS, COMMERCE & SCIENCE",
"DISTRICT INTEGRATED HEALTH AND FAMILY DEPARTMENT JALNA",
"JYOTHI ENGINEERING COLLEGE",
"DIRECTORATE OF EDUCATION SHIKSHA SADAN",
"MAHAVEER JAIN NATIONAL SCHOOL JAORA",
"K S INSTITUTE OF TECHNOLOGY",
"PH&FW DEPTTGOVERMENT OF CHHATTISGARH CIVIL SURGEON CUM CHIEF HOSPITAL SUPTT",
"RAM'S EDUCATION FOUNDATION",
"MOTHER TERASA COLLEGE OF AGRICULTURE",
"ZP CEN MARATHI UPPER SCH BHIVGAON BK BHIVGAON BK",
"DAULAT RAM GENERAL EDUCATION SOCIETY",
"GURUKRUPA REALCON LLP",
"CROWDANALYTIX SOLUTIONS PRIVATE LIMITED",
"TIRUPATI MADHYAMIK ASHRAM SHALA PACHEGAON GEORAI BEED",
"TECHSUPPORT ELECTRICAL SERVICES",
"YOUTHBUILD FOUNDATION",
"S S HOTEL AND RESORTS",
"GST & IT BUDDIES",
"KRISHNA MOHAN MEDICAL COLLEGE & HOSPITAL",
"S N INDUSTRIAL FABRICATOR",
"HOLY MISSION PUBLIC SEC SCHOOL",
"SHRI MO K PATEL MADHYAMIK SHALA TA BARDOLI",
"JODHPUR ACADEMY",
"VAGAD GLOBAL SCHOOL",
"Z P PRI SCHOOL KALAMB",
"KARMEL INTERNATIONAL SCHOOL",
"LALA LAJPAT RAI UNIVERSITY OF VETERINARY AND ANIMAL SCIENCES",
"ST. PATRICK SCHOOL PVT.LTD.",
"VELNOURISH PHARMA PRIVATE LIMITED",
"VCG TECHNOLOGIES PRIVATE LIMITED",
"DORMER PRAMET INDIA PRIVATE LIMITED",
"DIGITALROOAR PRIVATE LIMITED",
"KINGSTON ENGINEERING COLLEGE",
"SWAMINARAYAN AKSHARPITH",
"REVENUE TAHASILDAR",
"GOOD MORNING SUPERSPECIALITY AND RESEARCH CENTER",
"UNIQUE ENGLISH MEDIUM SCHOOL & JR COLLEGE",
"SHRI AYURVED MAHAVIDYALAYA NAGPUR",
"TRADR STOCK MARKET EDUCATION SERVICES",
"CURE SURGICALS",
"BALAJI TESTING PLANT",
"TRINITY EDUCATIONAL TRUST",
"UNIVERSAL COLLEGE OF ENGINEERING & TECHNOLOGY",
"MOKSHAA MOTORCYCLE LLP",
"PUBLICIS SAPIENT",
"LINEMARK",
"BUREAU VERITAS PAYROLL",
"GEETA EYE CARE AND OPTICAL CENTER",
"AAYOJAN SCHOOL OF ARCHITECTURE",
"ONTOGENY SCHOOL OF EXCELLENCE",
"TEJAS FOOD INDUSTRIES LLP",
"EMPIRE ENTERPRISE",
"B K PRINT & PACK",
"MANKORI DEVI SR SEC SCHOOL CHIRAWA",
"TRAINING SUPTD MINI ITI KURAI MADHYA PRADESH",
"ANNA ENGINEERING CORPORATION",
"SUBBIAH CENTRAL SCHOOL",
"BHARAT RAM GLOBAL SCHOOL¬†",
"CHANAKYA BUSINESS SCHOOL",
"GAUTAM ELECTRICALS SERVICES PRIVATE LIMITED",
"MINAS LOGISTICS PRIVATE LIMITED",
"DIGIAIR TECHNOLOGIES AND ANALYTICS PRIVATE LIMITED",
"ACV EXPLOSIVES LLP",
"THE NATIONAL CO-OPERATIVE BANK LTD",
"MAA YASHODA HOSPITAL PRIVATE LIMITED",
"HARE KRISHNA INDUSTRIES",
"ST MICHAELS ACADEMY MATRICULATION HIGHER SECONDARY SCHOOL",
"SIVANTHI JOE COIRS",
"ALCOVE DEVELOPERS LLP",
"NARAYANA VIDYALAYAM",
"ASHOKRAO MANE GROUP OF INSTITUTIONS",
"MODI SUGAR MILLS",
"PCM AUTOMOTIVE DESIGNERS INDIA PVT LTD",
"AAVASA RESORT",
"CONFORMIS INDIA LLP",
"RAJSHREE SHOES",
"DCUBE DATA SCIENCES LLP",
"SRIRANGAM HR SERVICE PRIVATE LIMITED",
"SILVER OAKS SCHOOL",
"SHREE BALAJI HOSIERY MILLS PRIVATE LIMITED",
"CHAKAN NAGAR PARISHAD",
"NANDANWAN PRATHAMIK VIDYALAYA",
"KING LORD ENGLISH HIGH SCHOOL & JR. COLLEGE",
"DEEP CHAND BANDHU HOSPITAL",
"WORK2GETHER LIMITED",
"THE CAMBRIDGE INTERNATIONAL SCHOOL",
"SMT SUMITRABAI THAKARE COLLEGE OF NURSING",
"U P SEHKARI GRAM VIKAS BANK LIMITED",
"UMBRELLA CORP",
"SRI ANURAGAVI GARMENTS",
"PROTINGENT INDIA LLP",
"K S RUBBER INDUSTRIES",
"BLOCK HEALTH OFFICE 1 VALSAD DISTRICT PANCHAYAT",
"PUNJAB WATER RESOURCES MANAGEMENT AND DEVELOPMENT CORPORATION",
"DIST MALERIA OFFICER NOWGAON CHHATARPUR",
"NAMMA EXPERTS PU COLLEGE",
"THE BHOPAL SCHOOL OF SOCIAL SCIENCES",
"MPF CLOTHING COLLECTIONS PRIVATE LIMITED",
"VIJAYSHREE WEAR PARTS PRIVATE LIMITED",
"RAMA SYNERGY SPACES",
"DINO MOTORCYCLES",
"APOLLO GAURDS PVT LTD",
"POSITIWISE INFOTECH PRIVATE LIMITED",
"MAHATAMA PHULE VIDYALAYA BHADGAO TQ LATUR",
"VRNDA PHARMA PRIVATE LIMITED",
"SHRI L G HARIA MULTIPURPOSE SCHOOL",
"SAGAR NAGAR NIGAM",
"EDS INSTRUMENTS AND SYSTEMS PRIVATE LIMITED",
"DADHICH ENTERPRISES",
"AAROORAN POLYTECHNIC COLLEGE",
"THESIS CENTRE",
"ODISHA IAS ACADEMY",
"GOVE OF CHHATTISGARH HOURTICULTURE DEPARTMENT OFFICE OF THE ASSTT DIRECTOR HOURTICALTURE , SURAJPUR",
"SANSKAR BALMANDIR",
"BHAVYA EDUCATIONAL SERVICES LLP",
"BLUPORD TECHNOLOGIES",
"SETH SHIVDUTT RAI ENGLISH MEDIUM SCHOOL",
"SHRI INDORE CLOTH MARKET HOSPITAL",
"BALAJI SONI HOSPITAL",
"KALIKADEVI JR COLLEGE SHIRUR(KASAR)",
"JAYSHREE PERIWAL INTERNATIONAL SCHOOL",
"SATGURU BUS SERVICES LLP",
"ASTER MIMS HOSPITAL",
"SPLASHJET INKJET INK PRIVATE LIMITED",
"SHARMA EAST INDIA HOSPITALS AND MEDICAL RESEARCH LTD.",
"ACCESSION CONSULTING AND HEALTHTECH LLP",
"ASS ARR LOGISTICS PRIVATE LIMITED",
"ACTIVE PROJECT",
"WILSHIRE HEALTHCARE",
"ALOKAY CLINIC",
"NEXIVO CONSULTING PRIVATE LIMITED",
"BLUEBELLS INTERNATIONAL SCHOOL",
"BLUE CHIP INFORMATICS PRIVATE LIMITED",
"GOVT RESIDENCE WOMENS POLYTECHNIC LATUR",
"JCS VASTRA",
"ORGANIC HUT",
"GOSI JEWELS INDIA",
"ANNEXURE TO FINANCE DEPARTMENT",
"BIRLA BHARATI",
"SHRI CHATRAPATI SHIVAJI MAHARAJ SAHAKARI BANK NIYAMITH",
"ALPINE CONVENT SCHOOL",
"ODISHA STATE ROAD TRANSPORT CORPORATION",
"TEHSIDAR SAUSAR MADHYA PRADESH",
"SHIV SHAKTI INFRABUILDWELL PRIVATE LIMITED",
"SHAKUNTALAMATA PRATHMIK ASHRAM SHALA",
"RAJKIYA HIGH SCHOOL PIPLAUTH ALIGARH",
"GSA INFOSERVE",
"MEDICAL SUPERINTENDENT REGIONAL MENTAL HOSPITAL THANE",
"JOYCE IVF CENTRE",
"HOXBRIDGE LORE INTERNATIONAL SCHOOL",
"MARUDHARA HANDMADE PAPERS AND HANDICRAFTS",
"SUMIT GUPTA CHILDREN HOSPITAL",
"HARCHARAN DASS GUPTA",
"C J PATEL COLLEGE TIRODA",
"AGRICULTURE HIGHSCHOOL & ART SCIENCE JR COLLEGE KHANDBARA",
"PARTH PUBLIC SCHOOL",
"AAVISHKAR SCHOOL",
"GAONDEVI VIDYAMANDIR",
"B E O MALTHONE",
"MAHINDRA LAST MILE MOBILITY LIMITED",
"SILVER SPORTS CLUB",
"GRAMIN SAMASSYA MUKTI TRUST",
"E E PWD DIV NO 1 B/R HBAD",
"B D O BIRSA MADHYA PRADESH",
"ABG MEP PROJECTS PRIVATE LIMITED",
"QUALITAS INFOTECH PRIVATE LIMITED",
"POPE PROFESSIONAL ACOUSTICS LIMITED",
"CNM HOSPITAL¬†",
"SP GLOBAL",
"GRAM PANCHAYAT",
"BHAWAN SALES PRIVATE LIMITED",
"AMOLIQ JEWELS LLP",
"BHANWARU CONSTRUCTION COMPANY",
"B M SORNAM PILLAI SONS",
"BILLABONG HIGH INTERNATIONAL SCHOOL KANCHIPURAM",
"ENES TEXTILE MILLS",
"OM VILAS BENARES",
"BIHAR ANIMAL SCIENCES UNIVERSITY",
"UPASHNA ENTERPRISES",
"KARYALAYA PARIYOJNA SANCHALAK KISAN KALYAN TATHA KRISHI VIKAS",
"LANTEC TECHNOLOGIES",
"VELAMMAL COLLEGE OF ENGINEERING AND TECHNOLOGY",
"AFFLATUS ENGINEERING ENTERPRISES",
"DHANALAKSHMI SRINIVASAN UNIVERSITY",
"ORISSA WATER SUPPLY & SEWERAGE BOARD",
"KEYBLOCKS STRATEGY CONSULTING PRIVATE LIMITED",
"ACCENTRA TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"UTTAM UDAN TOURS AND TRAVELES",
"AMBERTECH SOLUTIONS",
"CUREVET PHARMACEUTICAL¬†",
"JAMIAHAMDARD",
"RANKESHWAR COLLECTION LLP",
"DIPCHEM INDUSTRIES",
"MERCURY SPORTSWEAR AND LUBRICANTS",
"CENTRAL MEDICAL",
"INDU-SCCL-CGME CONSORTIUM",
"IPIVOT LLC",
"RENUKA LIFE CARE SYSTEM",
"CREATIONS",
"TIRUPATI ENGINEERING WORKS",
"SRN MEHTA SCHOOL",
"CAPRICORNE MINDFRAME",
"GLOBALROVER LLP",
"ANAND AND ASSOCIATES",
"PERIYAR ARTS COLLEGE¬†",
"SDNA TECH",
"WESOLVE FACILITY MANAGEMENT SERVICES",
"ARROW PROJECTS PRIVATE LIMITED",
"CANTIER SYSTEMS PRIVATE LIMITED",
"AAREN INTPRO",
"THE FERN KADAMBA HOTEL AND SPA",
"P SONI JEWELS LLP",
"DINESH CONSTRUCTION CO",
"NAVA SAMAJ MANDAL DEGREE COLLEGE",
"LOHAGARH FARMS PRIVATE LIMITED",
"JAI GURUDEV MULTISPECIALITY HOSPITAL",
"SHREE CHAMUNDA CATERERS",
"B E O SENDHWA",
"THEMIS BARBECUE HOUSE (A UNIT OF FACTION HOSPITALITY PVT LTD)",
"EDEN INTERNATIONAL SCHOOL",
"Z P SCHOOL DATTNAGAR JAVKHEDA THO",
"SRI MAIKRUPA EDUCATION TRUST PERFECT SCHOOL AKODRA",
"GANDHI INSTITUTE FOR EDUCATION AND TECHNOLOGY",
"INFOFACE TECHNOLOGIES PRIVATE LIMITED",
"VEERAJA INDUSTRIES",
"VEERAJA INDUSTRIES PRIVATE LIMITED",
"SHAKUN HOTELS AND RESORTS",
"VAIBHAV INSTITUTE OF MANAGEMENT & TECHNOLOGY",
"GROUP GRAM PANCHAYAT KALOTE",
"JANTA JUNIOR COLLEGE DHANORA",
"SACHANAND WELCOME CLOTH STORE",
"VIJAYAPURA & BAGALKOT DISTRICT COOPERATIVE MILK PRODUCERS‚Äô SOCIETIES UNION LTD",
"MANSION PARERGON DEVLOPERS",
"ANUSANDHAN EVM NIYOJAN BARH MANDAL UNIT 7 10 LKO",
"SMK FOMRA INSTITUTE OF TECHNOLOGY",
"PRERANA PU COLLEGE",
"THINKTANK ENGINEERING PRIVATE LIMITED",
"SAFEY MEDICAL DEVICES PRIVATE LIMITED",
"KRISHNA COLOUR CHEAM",
"LOKMANGAL CO OP BANK LTD SOLAPUR",
"NIHALHELTHCERE",
"H & C O GLOBAL ADVISORS IN PRIVATE LIMITED",
"SRI VAISHANAVI EDUCATIONAL TRUST",
"DISTRICT FOOD MARKETING OFFICER DISTRICT FATEHPUR",
"NORTH POINT MOTORS PRIVATE LIMITED",
"AUTOMATRIX INNOVATION PRIVATE LIMITED",
"CK CONSERV PRIVATE LIMITED",
"SAPEAR INDIA PRIVATE LIMITED",
"GUDHA PUBLIC SCHOOL",
"D M PETIT HIGH SCHOOL",
"SARDA IMAGING AND PATHOLOGY CLINIC",
"AKS & COMPANY CHARTERED ACCOUNTANTS",
"SOUTHERN ERECTORS",
"LOK JEEVAN VIDYALAYA AND JR COLLEGE",
"ANKLESARIA AUTOMOBILES",
"MODERN DELHI INTERNATIONAL SCHOOL",
"VEDATYA INSTITUTE",
"MAHATMA GANDHI JR COLLAGE AHMEDPUR",
"GURU NANAK ENTERPRISES",
"UMEED MULTISPECIALITY & TRAUMA CENTRE",
"TAHSIL OFFICE SHIRUR",
"GORMALONE LLP",
"SHALIMAR KSMB PROJECTS",
"THE ARYAN SCHOOL",
"ST JOSEPHS INTERNATIONAL SCHOOL",
"FISHERY SURVEY OF INDIA MUMBAI BASE",
"SANJEEVANI MULTIPURPOSE FOUNDATIONS DR. DEEPAK PATIL NURSING INSTITUTE",
"HINDUSTAN INDUSTRIAL PERSONNEL SERVICE",
"LUCKY INTERNATIONAL SCHOOL",
"ARIHANT CONSULTANCY",
"SANKURATHRI FOUNDATION",
"UPES DEHRADUN",
"HORMAH ELECTRO TECH PRIVATE LIMITED",
"ADANI AVIATION FUELS LIMITED",
"SANCHETI INSTITUTE FOR ORTHOPAEDICS &\nREHABILITATION",
"SHANKAR NAGARI SAHAKARI BANK LTD NANDED",
"SIDDIQ URDU HIGH SCHOOL LATUR",
"SHRI RAGHUNANDAN INTER COLLEGE CHARRA ALIGARH",
"BCM PRECISION ENGINEERING",
"THE BAZPUR COOPERATIVE SUGAR FACTORY LTD",
"DISTRICT EDUCATION COMMITTEE BANASKANTHA",
"MAHARASHTRA REAL ESTATE REGULATORY AUTHORITY",
"SHAAN ELECTRICALS",
"SIR MOHAMED YUSUF SEAMEN WELFARE FOUNDATION",
"MAHARAJA CHHATRASAL BUNDELKHAND UNIVERSITY CHHATARPUR",
"SREE LAKSHMI ENERGY SYSTEMS PRIVATE LIMITED",
"HIL INFOTECH LLP",
"DIRECTORATE OF EDUCATION",
"TAHSIL OFFICE PAITHAN",
"GOVT MAHARAJA CHHATRASAL BUNDELKHAND UNIVERSITY CHHATARPUR",
"SRI DURGAPARAMESWARI ENTERPRISE",
"SURANA WIRES PVT LTD",
"BRC BHAVAN FATEHPURA",
"SENIOR GEOHYDROLOGIST DIVISIONAL GROUND WATERE SURVEY UNIT NO-8 RAIPUR (C.G.)",
"K R MANGALAM WORLD SCHOOL",
"DISTRICT EDUCATION COMMITTEE KHEDA",
"SATYA SCHOOL",
"M J P M AND ASSOCIATES",
"SBS CAMPUS",
"PAYAL SINGHAL DESIGN HOUSE LLP",
"DISTRICT PANCHAYAT ARVALLI",
"AHARIC IT HUB LLP",
"M/S CARE MEDICOS",
"R N PATEL (MORARAJI) MUN PRI SHALA NO 6",
"RAMA KRISHNA SCHOOL",
"INDAS MAHAVIDYALAYA",
"SUB DIVISIONAL WATER CONSERVATION OFFICER",
"NEEMRANA FOODS PRIVATE LIMITED",
"NEHRU VIDYALAYA CHINCHOLI BK TQ LATUR",
"RUGAS TECHNOLOGIES PRIVATE LIMITED",
"TAUTMORE LEARNING PRIVATE LIMITED",
"SYSTEM HOUSE FACTORY FOR SEP",
"LABYRINTH GLOBAL SOLUTIONS",
"PARKER ROBINSON PVT LTD",
"ZOPEUS TECHNOLOGIES PRIVATE LIMITED",
"CENTRAL CHINMAYA MISSION TRUST",
"SHEETLA ASSOCIATES",
"JAGADGURU RAMBHADRACHARYA DIVYANG STATE UNIVERSITY",
"INDUSTRIAL TRAINING INSTITUTE ITI JALALPOR",
"HEATTRANS EQUIPMENT PRIVATE LIMITED",
"COMMISSIONERATE OF EMPLOYEES STATE INSURANC E SCHEME",
"SANDIPANI GURUKUL VIDHYALAY",
"WADAKANCHERY GOVT SERVENT CO- OPERATIVE SOCIETY LTD",
"SHREE VENKATESHA MULTI STATE CO OPERATIVE CREDIT SOCIETY LIMITED",
"THE MIRADOR",
"NET2SOURCE LLP",
"SMT DANAMMA CHANNABASAVAIAH ( SDC ) INDEPENDENT P U COLLEGE BANGARPET KOLAR",
"VARAM SUPER SPECIALITY HOSPITAL AND FERTILITY CENTRE",
"LUXMI PHARMA",
"DISTRICT PROSECUTION OFFICER DEWAS",
"C E O JANPAD PANCHAYAT KHACHROD",
"PHC WADWANI",
"M M PUBLIC SCHOOL",
"RICH FARMS AGRO EXPORTS",
"QUEENSLAND GOVERNMENT TRADE & INVESTMENT",
"SWA SAWARKAR MAHAVIDYALAYA BEED",
"VASUNDHARA COLLEGE OF ARTS SCIENCE & COMMERCE GHATNANDUR",
"DPR DIRECTORATE OF POULTRY RESEARCH",
"D Y PATIL INTERNATIONA SCHOOL",
"SRI AMBICA STEELS AND METALS INDIA PRIVATE LIMITED",
"TECNOVA TECHNOLOGIES PRIVATE LIMITED",
"PHOTECH INDIA PRIVATE LIMITED",
"JAISRIDEVI HOMES PRIVATE LIMITED",
"PRERNA INTERNATIONAL SCHOOL¬†",
"SSCHEMICALS",
"HINDMED¬†",
"VIDYABHARTI TRUST POLYTECHNIC",
"SUNRISE FASHIONS",
"SRI KUMARAN CHILDREN‚ÄôS HOME EDUCATIONAL COUNCIL",
"ST MICHAELS SCHOOL AHMEDNAGAR",
"ARYA SEWA MADHYAMIK VIDALAYA",
"NAVODAYA LEADERSHIP INSTITUTE MAVLI UDAIPUR",
"UNIQUE DIAGNOSTICS & RESEARCH CENTRE",
"AMAN BHALLA FOUNDATION",
"PRASANNA BALRUGNALAY AND RESEARCH CENTRE",
"VIDYA MANDIR ADUR ADUR",
"AKRSTA CONSTRUCTION",
"SIDDEHWAR JR COLLEGE",
"CHANDRABHAGA URBAN MULTISTATE CO-OP. CREDIT SOCIETY LTD",
"AR INFRATECH SERVICES",
"LAKSHYAVEDH MULTISTATE CO OP CREDIT SOCIETY AHMEDNAGAR",
"LIFE HEALTH CARE GROUP",
"P S R ENGINEERING COLLEGE",
"CONCEPT MANUFACTURING SERVICES",
"BHARTI SINGHAL & CO",
"MIT VISHWAJYOTI INTERNATIONAL SCHOOL",
"INDIAN INSTITUTE OF HEALTH CARE COURSE",
"A WADHWA AND ASSOCIATE",
"DISTRICT OFFICE DEPARTMENT OF INFORMATION TECHNOLOGY AND COMMUNICATIONS BARAN",
"EXECUTIVE ENGINEER NORTH MUMBAI PW",
"PUNJAB AGRICULTURAL UNIVERSITY",
"EDIRECTSYS",
"ARVIND GUPTA DAV CENTENARY PUBLIC SCHOOL",
"GURUPADAPPA NAGMARPALLI",
"SHREE M M CHAUDHARI UCHCHATAR MADHYAMIK SHALA MANSA",
"DAKSH SECURITY & SERVICES",
"SANJIV PRAKASHAN",
"ASCENT BRAND COMMUNICATIONS PRIVATE LIMITED.",
"TECEZE CONSULTANCY SERVICES PRIVATE LIMITED",
"SUTRA ADVERTISING AND CONSULTANCY PRIVATE LIMITED",
"ZAMCO FOODS¬†",
"RAJNIKANT AND CO",
"SHREE JWELS¬†",
"EDU PEARL IMMIGRATION SERVICES¬†",
"SHREE DHANAJAY ELECTRICALS",
"JAYOSTUTE INDIA PRIVATE LIMITED",
"YODEP SOFTWARE LLP",
"PARIVAR SEVA SANSTHA",
"RASHTROTTHANA VIDYA KENDRA",
"GOVERNMENT OF CHHATTISGARH GENERAL ADMINISTRATION DEPARTMENT OFFICE OF THE TAHSILDAR KATGHORA KORBA",
"CENTRAL RAILWAY SOLAPUR DIVISION",
"WORLD UNIVERSITY OF DESIGN",
"JAI BABA INDUSTRIES",
"ZPPS AURANGPUR KUKDA",
"SARVODAYA KANYA VIDYALAYA",
"SUCHITRA ACADEMY INTERNATIONAL SCHOOL",
"K S CHAVAN PRIMARY ADIWASI ASHRAM SCHOOL BHOKAR",
"NIRMALA DEVI KALE VIDY VISHAL NAGAR LATUR",
"ZPPS MOHOL NO 4",
"PLIGHT PHARMA PRIVATE LIMITED",
"MACBRO TECHNOLOGY INDIA PRIVATE LIMITED",
"RAMOSE LABORATORIES PRIVATE LIMITED",
"KLOUDEYE SOFTWARE SOLUTIONS PRIVATE LIMITED",
"TALUKA HEALTH CENTRE ANJAR KACHCHH",
"ANJALI VIDHYALAY( EDUCATION DEPARTMENT COMMISSIONER OF SCHOOLS GANDHINAGAR )",
"JYOTSANA MADAN & ASSOCIATES",
"EYE ALERT & COMPANY",
"PRINCE SRIVARI SENIOR SECONDARY SCHOOL",
"K D LOGISTICS SERVICES",
"PRINCIPAL SC RESIDENTIAL SCHOOL INDORE",
"DAAMNI INDUSTRIES",
"WESTERN CONSTRUCTIONS WINDSOR PARK LLP",
"B E O KHACHROD",
"AASHISH GROUP",
"MICRO CULTUR",
"DIOCESE OF AGRA",
"GAYATRI GIRLS INTERNATIONAL SCHOOL",
"PURUSOTTAM HOMOEO BIKASH LABORATORY",
"GALADA PETRO CHEMICALS PRIVATE LIMITED",
"RAVINDRA PS NANDED",
"BLUEWEIGHT BIOSCIENCES PRIVATE LIMITED",
"VSM AGENCIES PRIVATE LIMITED",
"PAVAGADA SOUHARDA MULTIPURPOSE",
"AAYAN MULTITRADE LLP",
"INDUSTRIAL COMPONENT CORPORATION FORGING",
"ADDITIVE 3D",
"SUPDT NACHEN KOCHI",
"VIJAYBHOOMI UNIVERSITY",
"LOYOLA SCHOOL JAMSHEDPUR",
"OFFICE OF THE JAWAHAR NAVODAYA VIDYALAYA",
"S L R CHHINDWARA",
"MAHARASHTRA SHIKSHAN PRASARAK MANDAL",
"AKANKSHA CONSTRUCTING ASPIRATIONS",
"SWASTIK INFRACON",
"L M SARDAR URDU PRIMARY SCHOOL",
"NAVJIVAN MULTISPECIALITY HOSPITAL JALNA",
"B K BIRLA COLLEGE OF ARTS SCIENCE & COMMERCE",
"KARYALAYA JANPAD PANCHAYAT CHHEGAON MAKHAN",
"BRIGHT FUTURE INDIA",
"VIDYA MANDIR SAVARDE/SATAVE",
"VIVIDHLAXI DOLVAN HIGH SCHOOL",
"VIVIDHLAXI HIGH SCHOOL & U MA SHALA DOLVAN",
"AMERICAN INDIA FOUNDATION",
"YASHODA INDUSTRIES",
"SICHERTEN INFO CONSULTING PRIVATE LIMITED",
"FWS ASSOCIATES LLP",
"NETIMPACT STRATEGIES",
"IVAKYA SOLUTIONS LLP",
"GOA HUMAN RESOURCE DEVELOPMENT CORPORATION",
"LARDNER NORTH & COMPANY PRIVATE LIMITED",
"CHENNAI HYDRAULIC AND ENGINEERING CO",
"KLAP6 TECHNOLOGIES PRIVATE LIMITED",
"SHRI KESARI",
"LAKSHY ENGITECH LLP",
"VECTRUS GLOBAL SUPPORT SERVICES LLP",
"HEALTHCARE ENTERPRISES",
"HAPPY TEXO FAB",
"GOEL GRAPHICS",
"RAJASTHAN ARTS AND CRAFTS HOUSE",
"KUNDAPURA RURAL AYURVEDA MEDICAL COLLEGE AND HOSPITAL",
"GERRYSUN",
"SARASWATI SR SEC SCHOOL",
"VISHYANIKETAN VIDYALAYA VADVAL NAGNATH TQ CHAKUR DIST LATUR",
"PNNM AYURVEDA MEDICAL COLLEGE AND HOSPITAL",
"SHRI G S INSTITUTE OF TECHNOLOGY & SCIENCE INDORE",
"NEW RAJASTHAN PUBLIC SCHOOL",
"DPT REG COP SOCITIES",
"KOSHE KOSHA",
"NAGAL PAR K V P SCHOOL BOTAD",
"HNL BUSINESS SERVICES INDIA PRIVATE LIMITED",
"CHAMPO CARPETS",
"ZPPS DABI PARLI VAI",
"TECH WING AUTOMATIONS",
"DIVISION OF ME HIN TECH EDGE SOLUTIONS",
"GOVT KRISHI UPAJ MANDI SAMITI NOWGONG",
"NATION FIRST MANAGEMENT AND ASSOCIATES",
"YASHASWI EDUCATION SOCIETY",
"AASTHA HOSPITAL & ICU JALNA",
"CITY ENGLISH MEDIUM SCHOOL SANGLI",
"E E PWD BRIDGE CONSTRUCTION DN BHOPAL",
"CONTROLLER OF BUILDING VIDHANSABHA CPA BHOPAL",
"AGRICULTURE & CO-OPERATION DEPARTMENT",
"THE CHANCERY HOTEL BANGALORE",
"TRAINING SUPDT ITI KHACHROD",
"SWARNANDHRA COLLEGE OF ENGINEERING AND TECHNOLOGY",
"B V RAJU COLLEGE",
"EATON MANAGEMENT SERVICES LLP",
"SHREE VENKATESH HIGH SCHOOL AND JUNIOR COLLEGE",
"SQUARE SOLUTION",
"DPM GREEN BRICKS",
"EDCITE LEARNING PRIVATE LIMITED",
"AMER VILLAGE CORPORATION",
"MADHAVNAGAR HIGHSCHOOL",
"ZILA PARISHAD SHALA BIJGAON",
"GOVERMENT OF CHATTISGARH SUB DIVISIONAL AGRICULTURE OFFICER BILASPUR(C.G)",
"MADHNAMIK VIDYALAYA ARDAL",
"SINGLA RICE MILLS",
"PRABHU DHAN DEGREE COLLEGE",
"DEPTID HIGHER EDUCATION DEPARTMENT (HIGHER TECHNICAL SCIENCE & TECHNOLOGY)",
"LILAVATI FOUNDATION",
"ENTARGET IT PRIVATE LIMITED",
"SCOPIC SOLUTIONS PRIVATE LIMITED",
"NISARGA BIOTECH PRIVATE LIMITED",
"GLOWFAB INDUSTRIES PRIVATE LIMITED",
"YAANEE FASHIONS INDIA PRIVATE LIMITED",
"FAR EAST BROADCASTING ASSOCIATES OF INDIA¬†",
"REYNOBOND INDIA¬†",
"SHRI KESARI¬†",
"PAVITRA FABTECK",
"AMRUT JYOTI SCHOOL",
"MES ASMABI COLLEGE",
"TERNA PUBLIC CHARITABLE TRUST (TERNA SPECIALITY HOSPITAL AND RESEARCH CENTRE)",
"Z P SCHOOL VADGAON",
"RAIGAD Z P HIGH PRIMARY SCHOOL",
"KASARWADI HIGHSCHOOL KASARWADI",
"OM SAI HOSPITALITY & VENTURES VR MALL",
"BHASKARACHARYA COLLEGE OF APPLIED SCIENCES",
"DISTRICT EDUCATION COMMITTEE DAHOD",
"SANSKAR PRIMARY SCHOOL PARLI(V)",
"GURU NANAK MULTISPECIALTY HOSPITAL & TRAUMA CENTRE",
"SMT BAIJANTI DEVI INTER COLLEGE",
"JEEVAN JYOTI GROUP OF INSTITUTION",
"V S B ENGINEERING COLLEGE",
"SANJEEVANEE MAHAVIDYALAYA CHAPOLI",
"AKS AMMA HOSPITAL",
"D R MANE MAHAVIDYALAYA KAGAL",
"ST TERESA S CONVENT ENGLISH MEDIUM SCHOOL",
"ST JOHN S COLLEGE AGRA",
"JAIPUR NOVOTEL CONVENTION CENTRE AND JAIPUR EXHIBITION CONVENTION CENTRE",
"A C P M MEDICAL COLLEGE DHULE",
"BASVESHWAR VOCATIONAL JUNIOR COLLEGE KILLEDHARUR DIST BEED",
"AV SALES CORPORATION",
"AMRAVATI DISTRICT SECURITY GUARD BOARD",
"SAM HIGGINBOTTOM UNIVERSITY OF AGRICULTURE",
"JAN SEVA HOSPITAL",
"ALPINE TECHNOLOGIES",
"PUSHPALATA VIDYA MANDIR",
"AAROGYAM HOSPITAL",
"RAJA ALUMINIUM COMPANY",
"SAI TEJA MOTERS",
"RURAL DEVALAPMENT TRUST",
"SALKARA RESTAURANT GROUP OF PARAGON",
"PUJA REALTY",
"TECHTRINITE CONSULTING INDIA LLP",
"ARIHANT MANPOWER SERVICES",
"HOTEL SREE BAALAAJI BHAVAN",
"KABADI SHANKARSA OVERSEAS",
"POLARIS BUILDCON LLP",
"MOBILITY INDIA¬†",
"BRIGHT INSPECTION SERVICE",
"CITADINES ARPORA NAGOA GOA",
"ESSVI INSULATIONS",
"ESPAT KARMCHARI CO-OP CREDIT SOCIETY LTD BHILAI NAGAR",
"PREMIER PRODUCTS",
"CHHATTISGARH RAJYA VAN VIKAS NIGAM LIMITED",
"SANCHEN DORJEE JR BASIC SCHOOL",
"KALINDA TECHNICAL SERVICES & CONSULTANCY",
"SHREE DURGAPARAMESHWARI MULTIPURPOSE CO OPERATIVE SOCIETY LIMITED",
"CREATIVE MANPOWER CONSULTANT",
"DIRECTORATE OF CENSUS OPERATIONS GWALIOR",
"KEEVA JEWELS LLP",
"BADAMPUDI LSCS",
"MILITARY HOSPITAL JAIPUR",
"FEALTY GLOBECOM LLP",
"ARMY MEDICAL CORPS",
"MULA EDUCATION SOCIETY YASH ACADEMY SCHOOL SONAI",
"RAM KRISHAN¬†PARAMHANS SEN SEC SCHOOL",
"ZPHS KANYA BEED",
"KHATRIJI SWEETS",
"MATRIX NEET DIVISION",
"JAN SEWA HOSPITAL",
"XLRI XAVIER SCHOOL OF MANAGEMENT",
"SHIVANI HIGHSCHOOL SHIVANI TQ DIS BEED",
"SOLAPUR INSTITUTE OF MEDICAL SCIENCE",
"UITOUX SOLUTIONS PRIVATE LIMITED",
"PRATAYAKSHA CONSTRUCTION PRIVATE LIMITED",
"CHILLAR PAYMENT SOLUTIONS PRIVATE LIMITED",
"GOLDBRICK¬†",
"PRATAKSHYA CONTRACTOR",
"THE ICFAI UNIVERSITY JAIPUR",
"THE GRENADIERS REGIMENTAL CENTER JABALPUR",
"TRUEWARE INTERNATIONAL LLP",
"ALTOSTRATUS SOLUTIONS PRIVATE LIMITED",
"SAINT MSG GLORIOUS INTERNATIONAL SCHOOL",
"THE VENDING COMPANY",
"HEALTH CARE IMAGING CENTRE",
"ALL SAINTS HR SEC SCHOOL",
"PRIMUS SAM PRIVATE LIMITED",
"BHAVA INFOTECH PRIVATE LIMITED",
"Z P P S AKOLKARWASTI",
"AQUA STRUCTURE",
"ABSEIL PHARMACEUTICALS PRIVATE LIMITED",
"SP AGIWAL AND ASSOCIATES",
"SPRING BELLS SCHOOL SAHARANPUR",
"ZILA PARISHAD PRATHAMIK SHALA CHINCHKATHI",
"GREEN EARTH PROTECTION PRIVATE LIMITED",
"REAL ILLUSION LLP",
"DHWANI FOUNDATION",
"TEELABS APPAREL PRIVATE LIMITED",
"SUMIT RICE AND AGRO MILLS",
"GN BROTHERS",
"SECURDI LLP",
"BLOCK EDUCATION OFFICER SOHAWAL",
"THE KARNAL CO-OP. SUGAR MILLS LTD",
"SHAHEEN EDUCATION TRUST",
"UNIVERSAL FLAREON INDUSTRIES",
"BHAGWATI SECURITY SERVICES SAHARANPUR",
"ETHANE WEB TECHNOLOGIES PRIVATE LIMITED",
"PEOPLE POINT",
"GJM CO.",
"KONGUNADU POLYTECHNIC COLLEGE",
"PSG POLYTECHNIC COLLEGE",
"SCHANGALAYA MOTORS¬†",
"SREE NARAYANA GURU CO OP BANK LTD¬†",
"RANSON I TECH",
"ASW RELIABLE LOGISTICS PRIVATE LIMITED",
"DAV BHEL SCHOOL¬†",
"NTE INDIA BY ANSR LLP",
"POOJA PLUS",
"BANASKANTHA DISTRICT CO OPERATIVE MILK UNION LTD",
"SHRI J S MEHTA HIGH SCHOOL AND K J MEHTA HIGH SECONDARY SCHOOL",
"SUBEX DIGITAL LLP",
"HEALTH PLUS INDIA",
"VIDYA MANDIR SIRSE",
"SBER BANK",
"ALL-WAYS LOGISTICS ( CHA ) PRIVATE LIMITED",
"RISHABA INDUSTRIES LLP",
"SANE GURUJI MADHYAMIK VIDYALAY LATUR",
"SEWA SADAN EYE HOSPITAL TRUST",
"FOOD BUS OF INDIA LLP",
"SKILLSOURCE IT SOLUTIONS LLP",
"PAHAL SOLAR",
"EKOSTAY LLP",
"MADRASA ARBIA FAIZUL ULOOM TALGRAM KANNAUJ",
"GENERAL HOSPITAL RAJKOT",
"GSS KANKARALA MOOLANI SERWA BARMER",
"HELP IN SUFFERING",
"HEWETT MUSLIM INTER COLLEGE MORADABAD",
"ANANYA COLLEGE OF MEDICINE & RESEARCH KALOL",
"JILA SAHKARI KENDRIYA BANK MARYADIT",
"WORK DEPARTMENT P S KMAHANKAL",
"ROYAL STAFFING SERVICES LLP",
"RAJIV LOCHAN AYURVED MEDICAL COLLEGE CHANDKHURI",
"TECHCLOUDVERKS IT SOLUTIONS PRIVATE LIMITED",
"TOTAL FACILITY MANAGEMENT PRIVATE LIMITED",
"NIKASHI ENTERPRISES LLP",
"HIGH PRECISION ENGINEERING COMPOSITES PRIVATE LIMITED",
"KING EXPORTS",
"NIRMITI KENDRA KOPPAL",
"MYSORE DEEP PERFUMERY HOUSE",
"BANWARI LAL JINDAL SUIWALA COLLEGE",
"SERVOMAC SERVICES",
"MARENGO ASIA HOSPITALS GURUGRAM",
"GOVERNMENT OF CHHATISGARH CHIKITSA SHIKCHHA DEPARTMENT OFFICE OF DISTRICT AYURVED OFFICER KORBA",
"PIMPRI CHINCHWAD UNIVERSITY",
"OPERON BIOTECH AND HEALTHCARE",
"GULERMARK SAM INDIA SURAT METRO UG P1 JOINT VENTURE",
"CNS INTERNATIONAL SCHOOL",
"WOODBRIDGE HIGH SCHOOL",
"D A V PUBLIC SCHOOL AIROLI",
"MATA RAMAI MADHYAMIK VIDHYALAYA",
"SRI KONDA LAXMAN TELANGANA STATE HORTICULTURAL UNIVERSITY",
"EXECUTIVE ENGINEER DESIGN DIVISION ROORKEE",
"GOVERNMENT OF GUJARAT LEGAL DEPARTMENT",
"ALLAMA IQBAL EDUCATION AL SOCIETY",
"AQUA 49 WEBSTREET TECHNOLOGIES PRIVATE LIMITED",
"HIGH PRECISION INDUSTRY¬†",
"MED EXPERT¬†",
"HERAMB INDUSTRIES",
"BANGIYA GRAMIN VIKASH BANK",
"RV LEARNING HUB",
"COLT DCS INDIA LLP",
"RV PU COLLEGE",
"PEOPLE POINT SERVICE",
"NEW SHRI RAM MESS",
"SREEVATSA VISWANATHAN VIVEKANANDA VIDYALAYA SR SEC SCHOOL",
"LYNKSTR PRIVATE LIMITED",
"S P ELEGANCE",
"GOVERNMENT OF CHHATTISGARH GOVT GIRLS HR SEC SCHOOL BALCO NAGAR KORBA (C G)",
"P S PAITHITWAR GIRLS NAGAR KSHETRA SAMBAL",
"DISTRICT LEGAL SERVICES AUTHORITY DAUSA",
"CHAUDHARY CHARAN SINGH HARYANA AGRICULTURAL UNIVERSITY HISAR",
"SOCIETY FOR EMPOWERMENT THROUGH VOLUNTARY ACTION IN KARNATAKA",
"MEHER GOVT UP SCHOOL",
"C D GLOBAL HOSPITAL",
"BAL BHAVAN PUBLIC SR SEC SCHOOL",
"SEIKOMAX HEALTHCARE",
"ARPAN INTERNATIONAL SCHOOL",
"VERSIL PUMPS LLP",
"HYATT CENTRIC MG ROAD BANGALORE",
"DR KNS MEMORIAL INSTITUTE OF MEDICAL SCIENCES",
"M/S ASPLREFOX",
"GSSS SAROLA SANGOD KOTA",
"CHARAK AYURVEDIC COLLEGE HOSPITAL AND RESEARCH CENTRE",
"DEO BUNDI",
"ASMITA RESORTS PRIVATE LIMITED",
"VIUSTATS TECH SOLUTIONS PRIVATE LIMITED",
"S S NATARAJAN AND CO",
"L GANSHAM",
"KEK ENGINEERING SERVICES",
"WISDOM WEALTH INTERNATIONAL SCHOOL",
"TSI ENGINEERING INDUSTRIES PRIVATE LIMITED",
"NIRMAL JYOT FACILITIES PRIVATE LIMITED",
"KISAN GATEWAY LLP",
"SARVAGA TECHNOLOGIES LLP",
"R GOPAL & ASSOCIATES",
"NEW HORIZON EDUCATIONAL & CULTURAL TRUST",
"KARYALAY JANPAD PANCHAYAT BAGLI DEWAS",
"PANCHAYAT SAMITI BARSHI",
"VRS MANPOWER AND SECURITY SERVICE PRIVATE LIMITED",
"TAHSILDAR RAHATGARH",
"M R JANTA JUNIAR HIGH SCHOOL KASTALI ALIGARH",
"TAHASILDAR JAGATSINGHPUR",
"KHAMIGAN GOVT UP SCHOOL",
"MUNICIPAL COUNCIL JHUNJHUNU",
"ASSISTANT DIRECTOR PRINTING STATIONERY AND PUBLICATION CUTTACK",
"SPRINGUP LABS PRIVATE LIMITED",
"ST XAVIER S TECHNICAL INSTITUTE",
"JIET MEDICAL COLLEGE AND HOSPITAL",
"PATODIA OVERSEAS EXPORTS LLP",
"GSSS NIWARU",
"SURVEYHEART LLP",
"A E N PWD SUB DN I KUMHER",
"VIDYA SANSKAAR EDUCATIONAL CHARITABLE TRUST",
"CYBERSOFT TECHNOLOGIES INC",
"GEETADEVI KHANDELWAL INSTITUDE OF PHARMACY AKOLA",
"SITABAI ARTS COMMERCE & SCIENCE COLLAGE AKOLA",
"ADARSH BALVIKAS PRIMARY SCHOOL",
"SMT PAARVATI DEVI HOSPITAL",
"DHOLTIKARI JR HIGH SCHOOL",
"UNIVERSITY OF KALYANI",
"NAGAR PALIKA BALIKA INTERMEDIATE SCHOOL",
"GARRISON ENGINEER AIR FORCE NAL",
"B E O THANDLA",
"HOTEL MEADOWS VARANASI",
"DIRECTOR PUBLIC INSTRUCTION",
"THE DEN BENGALURU",
"ROOPA SCREEN PRIVATE LIMITED",
"PARLE FREUND MACHINERY PRIVATE LIMITED",
"MIDAS ARCHITECTURAL SYSTEMS LLP",
"VIAAN SOLUTIONS LLP",
"THE GSF COOPERATIVE SOCIETY LTD",
"MSRTC SANGLI",
"NWR BIKANER WORKSHOP",
"ASCENT TECHNOSYSTEMS PRIVATE LIMITED",
"VIDYA BAL BHAWAN SR SEC SCHOOL",
"GGSSS KANWAT",
"SHREE K L PATEL AND SHREE VMM SARVAJANIK HIGH SCHOOL",
"PASRICHA AND COMPANY",
"MATHURA DAS MATHUR HOSPITAL",
"MAHATMA GANDHI HOSPITAL JODHPUR",
"VIKASH ENGINEERING WORKS",
"JODHPUR CT AND DIAGNOSTIC CENTER",
"SIR ISSAC NEWTON MATRICULATION HIGHER SECONDARY SCHOOL",
"DEPUTY COMMISSIONER OF CT AND GST GANJAM II CIRCLE BERHAMPUR",
"M B SENIOR SECONDARY SCHOOL",
"REPROTACH INTERNATIONAL",
"MADHYMIK VIDYALAY DHAWDE DIST DHULE",
"CAPITAL AIR TRAVELS",
"JAIJAWAN VIDYALAY KAWADGAON TAL WADWANI DIST BEED",
"LAXMI BOOK DEPOT",
"ADM MUNICIPALITIES COUNCIL PIPARCITY",
"GENERAL ADMINISTRATION AND PUBLIC GRIEVANCE DEPARTMENT",
"M/S VIBGYOR SERVICES",
"NWR JAIPUR DIV",
"DPO ICDS CHHATARPUR",
"A R T O KHANDWA",
"SAGE BUSINESS TECHNOLOGY (INDIA) PRIVATE LIMITED",
"PEEO JAWAR",
"KAILASHPUR JR HIGH SCHOOL",
"GSSS MARKHI SAHAPURA",
"ASSTT DIR AGRI BADGAON",
"MANAV SAMPADA UTTAR PRADESH",
"BATISWAR DR SD VIDYAPITH",
"TAHSIL OFFICE AKKALKOT",
"FUTURISTIC BUG PRIVATE LIMITED",
"EX EN FLOOD WORK DIV 1 BASTI",
"MAGRA PRAVABATI BALIKA VIDYALAYA HS",
"THE PANDHARPUR URBAN CO OP BANK LTD",
"DISTRICT EDUCATION COMMITTEE MUNICIPAL",
"PRIMARY HEALTH CENTER KUSUMWADA",
"VIDYA VIDYAPRATISHTHANSENGLISHMEDIUMSCHOOLCBSEBARAMATI",
"KASTURBA HOSPITAL SEVAGRAM",
"SHREE RENUKAMATA MULTISTATE CO-OP URBAN SOCIETY LTD AHMEDNAGAR",
"ADARSH KISAN MAJDOOR JUNIOR HIGH SCHOOL",
"SIR CHHOTU RAM SR SEC SCHOOL",
"MYSORE SAREE UDYOG LLP",
"LITTLE FLOWER HOSPITAL AND RESEARCH CENTER",
"ALPINE PUBLIC SCHOOL",
"A M REDDY MEMORIAL COLLEGE OF ENGINEERING AND TECHNOLOGY",
"PARAVATICAR COCORPORATION",
"SHRI DURGA ELECTRICALS PVT LTD",
"SCIENTIFIC ELECTRICAL SERVICES",
"HOPE FOUNDATION",
"ADVAITH FOUNDATION",
"NAVIN HEAVY LIFTERS",
"SRI UDYOG ENTERPRISES",
"D Y PATIL INTERNATIONALSCHOOL",
"SNEHALATHA HOSPITAL",
"ULASI JS VIDYAPITH HS",
"DEPTT OF HEALTH & FAMILY WELFARE",
"GUPTA NURSING HOME",
"COIMBATOTLRE PUBLIC SCHOOL",
"TARUN VADEHRA INTERIORS PRIVATE LIMITED",
"KAVE TEXTILE MILLS SALEM PRIVATE LIMITED",
"ALERT ENTERPRISES PRIVATE LIMITED",
"VCOLLAB ETIQUETTE PRIVATE LIMITED",
"KASEYA",
"KAMADHENU WIRES",
"MARUTHI KNITTERS¬†",
"BEEPKART¬†",
"WHITE HOUSE¬†",
"TRANSTEK ASEAN TEKNOLOGY",
"HITACHI CASH MANAGEMENT¬†",
"GREEN-ECOMES SOLUTIONS PRIVATE LIMITED",
"INDUS SECURE SERVICES PRIVATE LIMITED",
"CMO BBK",
"ASSTT DIRECTOR OF AGRICULTURE (ADMN) ULUBERIA HOWRAH",
"EX OFFICER MUN COMM CHOMU",
"SAMRAT ASHOK VIDYALA",
"BASBADI FP SCHOOL",
"CHILD DEVELOPMENT PROJECT OFFICER INTEGRATED CHILD DEVELOPMENT PROJECT ICDP ATHAGARH",
"GSSS MARKHI SAHAPURA JAIPUR",
"CHITORMA JUNIOR HIGH SCHOOL",
"HOTEL KAILASH INTERNATIONAL",
"6079 A EN PHED CITY SUB DIV II UDR",
"H M GOVT P B ASHRAM SCHOOL LOBHANI",
"INDORE MULTI SPECIALITY HOSPITAL",
"PUNYASHLOK AHILYADEVI HOLKAR HEAD & NECK CANCER INSTITUTE OF INDIA",
"CARRYLON ACCOUNTING SERVICES PRIVATE LIMITED",
"GNIOT INSTITUTE OF MANAGEMENT STUDIES",
"MADHYAMIK VIDYALAYA DUDHALE",
"R S PUBLIC SCHOOL",
"S W MONE & ASSOCIATE",
"PROGIST SOLUTIONS LLP",
"VIJAY RAJ JINDAL AND CO",
"A V T FASTNERS",
"JAGANNATH UNIVERSITY",
"NARAYANA EDUCATION TRUST",
"SODEPUR COLLIERY HIGH SCHOOL",
"CIVIL JUDGE & JUDICIAL MAGISTRATE CHATARGARH (BIKANER)",
"IBOTIX LLP",
"ADITYA BIRLA FINANCIAL SERVICES",
"SANSKRITI THE GURUKUL",
"YASHWANT HIGH SCHOOL",
"MADHAVRAO PATIL BALMANDIR",
"UDAIPUR TEHSILDAR BHINDER",
"PANCHAYAT SAMITI ANDHI",
"KMCCORP INDIA PRIVATE LIMITED",
"ANOVI ENGINEERING PRIVATE LIMITED",
"SHANMUGHA BIO FUELS PRIVATE LIMITED",
"VIRTUOSO OPTOELECTRONIS LIMITED",
"GITANJALI SCHOOL",
"GVP COLLEGE FOR DEGREE AND P G COURSES",
"MEEENAKSHI SUNDARARAJAN ENGINEERING COLLEGE",
"RAHUL HOUSEKEEPING SERVICES",
"EON COLLECTIVE",
"GSSS BAGAR RIYABARI",
"DEPARTMENT OF ECONOMIC AND STATISTICAL AFFAIRS HARYANA",
"GOPIRAM PALIWAL INTER COLLEGE",
"N C JINDAL INSTITUTE OF MEDICAL CARE AND RESEARCH",
"MADHAVRAO PATIL BALMANDIR KALHER THANE",
"MAHATMA PHULE KRISHI VIDYAPEETH RAHURI",
"DARUL ULOOM SAYEEDIA",
"YOUTH EMPOWERMENT AND ENTREPRENEURSHIP DEPARTMENT HARYANA",
"ANIMAL HUSBANDRY BRANCH UPLETA TALUKA PANCHAYAT",
"ADDVANTIS ENTERPRISES LLP",
"GROUP LEASE NETWORK",
"J P S CENTRAL ACADEMY",
"S R INTERNATIONAL SCHOOL",
"OFFICE OF THE CHIEF SUPERINTENDENT DISTRICT HOSPITAL GORAKHPUR",
"GOVERNMENT OF CHHATTISGARH HEALTH DEPARTMENT",
"TELTRONICS",
"C P KUKREJA INTERNATIONAL LLP",
"SHRI RAM GROUP OF INSTITUTIONS",
"SHRI K R PANDAV INSTITUTE OF PHARMACY NAGPUR",
"OXFORD HEALTHCARE",
"PS BANSWARA",
"KARAYALAY KHAND MUKHYA CHIKITSA ADHIKARI JAMWARAMGARD",
"NATIONAL DEFENCE ACADEMY KHADAWASLA PUNE",
"ONEASSIST TECHNOLOGIES LLP",
"MERFANTZ TECHNOLOGIES PRIVATE LIMITED",
"HENDRICKSON RENEWABLES INDIA PRIVATE LIMITED",
"SAT SUKRIT MEDIA PRIVATE LIMITED",
"TECHNERDS SOLUTIONS PRIVATE LIMITED",
"ROY AND BAGCHI",
"JAISHREE ASSOCIATES",
"POOVI TRADERS",
"EDTECH SOLUTIONS",
"HARI PRINTING PRESS",
"CREDENCE ENGINEERING HUB",
"SANGLI MEDICAL HUB LLP",
"SAHYADRI COLLEGE OF HOTEL MANAGEMENT",
"BKL WALAWALKAR HOSPITAL",
"OM DATA ENTRY INDIA",
"STARMARK FITNESS STUDIO PRIVATE LIMITED",
"BLOCK DEVELOPMENT OFFICER BAHANAGA",
"NAV MAHARASHTRA SAHAKARI SOOT GIRANI LIMITED",
"DIST HEALTH OFFICE Z P LATUR",
"DECENT PUBLIC SCHOOL",
"INDRAPRASTHA SPA RESORT",
"SHREE SARDAR PATEL MAHILA HOMOEOPATHIC MEDICAL COLLEGE & HOSPITAL MORBI ROAD",
"ARGUS TECHNO CONSTRUCTION",
"THE HAVELOCK HOTEL INDORE",
"DOWNTOWN LIFESPACES LLP",
"ZILA PANCHAYAT HOSHANGABAD (DRD√Ä)",
"ZPPS KUSALI GEORAI",
"KISAN CONSTRUCTION COMPANY",
"RAMKRISHNA VIDYAPITH",
"DELOITTE SOUTH ASIA LLP",
"R INT COLL CHHARRA ALIGARH",
"MGB MOBILES",
"NITHYA AMIRTHAM¬†",
"SETH JAI PARKASH POLYTECHNIC DAMLA¬†",
"HHSHMS BLOOD CENTRE",
"SKY AUTOMOBILES",
"HARIOM FLEXIPACK INDUSTIRES",
"RAKESH KUMAR PANDEY",
"CITIART PRIVATE LIMITED",
"MKR EDUCATIONAL SOCIETY",
"GSSS SARIANA",
"OMFED",
"DEPARTMENT OF TREASURIES ACCOUNTS AND LOTTERIES",
"GENIUS MODEL SR SEC SCHOOL",
"17 MAHARASHTRA B N NCC AHMEDNAGAR",
"TRI DESIGN ALLIANCE LLP",
"GOVERNMENT SECRETRIAT INCLUDING STATE PLAN MAHINERY",
"CBEO SIKRAI",
"SUPERVISORY URBAN LEPROSY UNIT",
"OFFICE OF THE SUB INSPECTOR OF SCHOOLS",
"GOVERNMENT OF WEST BENGAL PANCHUR COLLEGE",
"BIRLA OPUS",
"M P SHAH ENGLISH HIGH SCHOOL",
"ANANT POWERTECH",
"ARIHANT AGENCIES",
"NAVBHARAT VIDYALAY",
"A EN PHED CITY SUB DIV I UDR",
"GOBI ARTS & SCIENCE COLLEGE",
"SARVODAYA CO ED VIDYALAYA",
"SRI ¬†JAGANNATH SAFETY AGENCY",
"SIR CHOTTU RAM SHIKSHA SADAN SCHOOL",
"DASS GUPTA & ASSOCIATES",
"SANSKAR PUBLIC SR SEC SCHOOL",
"JUNIDPUR HIGH SCHOOL",
"MASSIVE PHARMACEUTICALS PRIVATE LIMITED",
"S S A CASTINGS INDIA PRIVATE LIMITED",
"M/S VINDYAVASHINI SALES",
"BCA TECH",
"LIVEWATCH SECURITY AND ALLIED SERVICES",
"NEW TECH FASTENERS",
"NOTETECH SOFTWARE",
"SREEMAYEE ENGINEERS",
"AISWARYAFEDS",
"CONNECT BUSINESS SOLUTIONS¬†",
"A S TRADERS¬†",
"WNS GLOBAL SERVICES¬†",
"TATA MILL",
"MIRADA CREATIVES LLP",
"SHREE SAI GOLD PALACE",
"PRECISION TECH ENTERPRISES¬†",
"SARAL FACILITY AND CORPORATE SOLUTIONS",
"AVINASH INDUSTRIES¬†",
"AVEER HOSPITALITY¬†",
"BIRLA INSTITUTE OF TECHNOLOGY AND SCIENCE",
"DOMSJ√ñ FABRIKER (DOMSJ√ñ)",
"INDO PHIL GROUP OF COMPANIES",
"INDO PHIL TEXTILE MILLS",
"NOVELIS INC",
"PT ELEGANT TEXTILE INDUSTRY (INDONESIA)",
"PT INDO BHARAT RAYON (INDONESIA)",
"PT INDO LIBERTY TEXTILES (INDONESIA)",
"PT INDO RAYA KIMIA (INDONESIA)",
"PT SUNRISE BUMI TEXTILES (INDONESIA)",
"SWISS SINGAPORE OVERSEAS ENTERPRISES PTE LTD (SSOE)",
"THAI ACRYLIC FIBRE CO LTD (TAF)",
"ADITYA BIRLA MEMORIAL HOSPITAL",
"THAI RAYON PUBLIC COMPANY LIMITED",
"NOVEL JEWELS",
"BIRLA RESEARCH CENTRE",
"ADITYA BIRLA NEW AGE HOSPITALITY",
"NOVELIS CENTRE ALP",
"LOVEDALE ACADEMY",
"SHRADHANAND BAL MANDIR SENIOR SECONDARY SCHOOL",
"AIRSEAL TECHNOLOGY LLP",
"ARULMIGU VIGNESWARAR VAGAIYARA THIRUKOVIL OLD AYAIKUDI PALANI",
"OPEL IT CONSULTING",
"LAMINAR TECHNOLOGIES",
"CHILLCARE APPARELS PRIVATE LIMITED",
"JRI LOGISTICS PRIVATE LIMITED",
"INDOGLOBE ADVISORY PRIVATE LIMITED",
"MAHARASHTRA STATE PHARMACY COUNCIL",
"ACCESS INTERNATIONAL",
"CROSSBOW GLOBAL MARKETPLACE SOLUTIONS PRIVATE LIMITED",
"JAYSHREE ENTERPRISE",
"WE CARE HEALTH CENTER",
"BLOCK EDUCATION OFFICER MORAR MADHYA PRADESH",
"PEEO 9 FF",
"PRASAD NAGAR HIGH SCHOOL",
"S O BUREAU OF CIVIL AVIATION SECURITY NEW DELHI",
"ZPPS NANDGAON TANDA",
"GOVERNMENT GIRLS SENIOR SECONDARY SCHOOL KAILASH NAGAR",
"GINNIDEVI SATYANARAYAN SEKHSARIA GIRLS P G COLLEGE",
"COMMUNITY HEALTH CENTER NAPASAR",
"SHIVALAYA PRATHAMIK ASHRAMSHALA",
"JYOTIBA MADHYAMIK VIDYALAYA",
"VENKATESHWARA CO OPERATIVE POWER AGRO PROCESSING LTD",
"TEENLOK PLAZA LLP",
"BLOCK CHIEF MEDICAL OFFICER KELWARA RAJSAMAND",
"S I HOSPITAL ICU & TRAUMA CENTRE",
"TECHNO INDIA GROUP ACADEMIA SOUTH KOLKATA",
"B E O KESLI",
"GSSS KONKARWALI SARADA",
"M L A INT COLL MIRPUR KHAS ALIGARH",
"NETHAJI SUBASH CHANDRA BOSE EX SERVICEMEN SECURITY SERVICE",
"AG AANDE BIHAR PATNA",
"DR AMBEDKAR INSTITUTE OF MANAGEMENT STUDIES AND RESEARCH",
"EXECUTIVE ENGINEER P H E",
"PURE & CURE TECHNOLOGY",
"UPGROWTH DIGITAL LLP",
"GSSS MADALA JHADOL-F",
"V CARE HEARING AND SPEECH CENTER",
"DHULE IRRIGATION PROJECT CIRCLE DHULE",
"VECTOR97 SOFTWARE AND SERVICE PRIVATE LIMITED",
"VASTAL PHARMACEUTICALS PRIVATE LIMITED",
"SOXA FORMULATIONS AND RESEARCH PRIVATE LIMITED",
"SARALAM TECHNOLOGIES PRIVATE LIMITED",
"TURBO ENGINEERING SERVICES",
"AMMARUN FOUNDRIES",
"UNITED SCALES COMPANY PRIVATE LIMITED",
"ANAPLAN INDIA PRIVATE LIMITED",
"F D Z P NANDED",
"GOVT C F WORKING PLAN CHHATARPUR",
"SHAHEED CHHOTURAM MEGHWAL GSSS CHOPASNI CHARNAN",
"FLURYS A UNIT OF APEEJAY SURRENDRA PARK HOTELS LTD",
"DIVYA JYOTI DISABLED DEVELOPMENT SOCIETY",
"OFFICE OF UPGRADED MIDDLE SCHOOL",
"RANJEET CAPITAL",
"Z P YAVATMAL",
"MAHATMA GANDHI INSTITUTE OF TECHNOLOGY (AUTONOMOUS)",
"CIVIL SERGEON C P R HOSPITAL KOLHAPUR",
"EXEENG NH DIVISION PWD DOIWALA",
"TIRUMALA HOSPITALS",
"MAHATMA GANDHI GOVT SCHOOL (ENGLISH MEDIUM) SANBHARLAKE",
"AEN CITY SUB DIV TONK",
"PANIIT ALUMNI REACH FOR INDIA FOUNDATION",
"GALLANT JEWELRY",
"INSTITUTE OF INFORMATION TECHNOLOGY AND MANAGEMENT (IITM)",
"RAJIV GANDHI UNIVERSITY OF HEALTH SCIENCES",
"ANUPAMA HOSPITAL",
"RADHA VATIKA SEN SEC SCHOOL",
"GOVT PRIMARY SCHOOL KHICHIPUR",
"DARWIN PUBLIC SCHOOL",
"H B GLOBAL",
"OFFICE OF THE PRINCIPAL GOVT POLYETCHNIC SOCIETY MANESAR GURGARAM",
"SHREE NIKETAN MATRICULATION HIGHER SECONDARY SCHOOL",
"ADD DIRECTOR AYURVED DEPTT DIVISON UDAIPUR",
"SO CENTRAL ELECTRICITY AUTHORITY SEWA BHAVAN R K PURAM NEW DELHI",
"E E PHE DIVISION HOSHANGABAD MP",
"DY DIRECTOR IMPLEMENTATION DOL GUWAHATI",
"PREM CHAND SMARAK I C PANDEYPUR VARANASI",
"IBMR COLLEGE",
"CLOUDOFFIS TECHNOLOGIES LLP",
"VIHAN AUTOMOBILES SAHARANPUR",
"MATRUSRI ENGINEERING COLLEGE",
"SHRI BHAIRAVNATH HIGH SCH SAHA",
"ERODE CHEMICALS SUPPLIERS PRIVATE LIMITED",
"BURNET PHARMACEUTICALS PVT LTD",
"AVANI SANSTHA",
"VYDEHI INSTITUTE OF MEDICAL SCIENCE AND RESEARCH CENTER",
"CINSULTING AND BEYOND",
"OFFICE OF THE TEHSILDAR BAHERI (BAREILLY)",
"SUPERINTENDING ENGINEER WATER RERSOURCES CIRCLE UDAIPUR",
"NAVSARI DISTRICT EDUCATION COMMITY GROUP OF PRIMARY SCHOOLS",
"MUNICIPAL CORPORATION OF FARIDABAD",
"TAHSILDAR BADAMALHARA",
"GOVERNMENT POLYTECHNIC NANDED",
"CIHHM FOUNDATION",
"SATYAM SONOGRAPHI & DIAGNOSTIC CENTRE",
"GOVERNMENT OF CHHATTISGARH SCHOOL EDUCATION DEPARTMENT OFFICE OF THE B E O NAWAGARH",
"ZPPS SELGI NILANGA",
"SUDEV ENGINEERING",
"S R K COLLEGE FIROZABAD",
"VIVANTA AHMEDABAD",
"SAI SAKSHI SERVICES",
"NAV JEEVAN MISSION SCHOOL",
"ASST COMMI OF SALES TAX",
"PEEO KHEDIA",
"VERTEX ENTERPRISES",
"EGOVERNMENTS FOUNDATION",
"SANKARDEV BIDYAMANDIR HIGH SCHOOL PURAN BURKA SATRA",
"KHAJURAHO NAGAR PARISHAD",
"KARIYALAY JANPAD PANCHAYAT BICHHUA",
"DAYANAND HOSPITAL",
"INSTITUTE OF ADVANCE STUDY IN SCIENCE AND TECHNOLOGY",
"ANSARI HOSPITAL",
"GANDHINAGAR DISTRICT EDUCATION COMMITTEE MANAGED PRIMARY SCHOOL TEACHER",
"HR KAPURTHALA DEO SE",
"D AND S J SAGAR",
"PRINCIPAL MEDICAL OFFICER CHURU",
"DR P S HARDIA ADVANCED EYE LASER SURGERY CENTRE",
"ADDIM OFFICER CMO",
"KRTRIMAIQ COGNITIVE SOLUTIONS",
"LATE GHANSHYAM PATIL HIGH SCHOOL",
"DYAL SINGH PUBLIC SCHOOL PANIPAT",
"MOXY MUMBAI ANDHERI WEST",
"PERFECT FOOTWEAR",
"DISTRICT AYURVED OFFICER RAIPUR",
"DESIGN2OCCUPANCY SERVICES LLP",
"GOOD LUCK METALLICS",
"BVM PUBLIC SCHOOL",
"SHATAYU MULTISPECILIEST HOSPITAL DEDICATION BEYOND MEASURE",
"BHAGWATI GIRLS H S NEW NANDANWAN",
"GURU JI CLASSES",
"ST JOSEPH S BOYS SCHOOL",
"EDUCATION SECONDARY",
"SUPDT CHC BAROLI AHEER AGRA",
"SEEMA GUJRAL CREATIONS LLP",
"MAHAGANPATI MULTI STATE CO-OP CR.SOC.LTD",
"AVON FLAVOURS",
"BTRANZ SOFTWARE SOLUTIONS PRIVATE LIMITED",
"CHETAN MOTORS DIGRAJ",
"SRI VINAYAKA ENGINEERING WORKS",
"ADHESIVE SPECIALITIES",
"BELL BIRD DIGITAL PRIVATE LIMITED",
"COIMBATORE MARINE COLLEGE",
"MADHYA PRADESH RAJYA VAN VIKAS NIGAM LIMITED",
"POLY TECH",
"HOYSALA VILLAGE RESORT",
"SUPERINTENDENT M B GOVT HOSPITAL UDAIPUR",
"AEN SUB DIV LUNI",
"224 ADVANCE BASE ORDNANCE DEPOT",
"JIJAMATA EDUCATION SOCIETYS ART SCIENCE AND COMMERCE COLLEGE NANDURBAR",
"GRASIM SRIGANDA HIGH SCH KAVALETTU",
"DPS JODHPUR",
"AEN PWD SUB DIV SEWAR",
"SAMAHARANALYA",
"SUPDT A G HOSPITALS BIKANER",
"OFFICE OF DEPUTY COMMISSIONER CUM CHAIRMAN ADVISORY MANAGING COMMITTEE MANDIR SHRI KALI DEVI JI/SHRI RAJ RAJESHWARI JI PATIALA",
"VIDYA SOUDHA PUBLIC SCHOOL KIADB",
"BHARTIYA SKILL DEVELOPMENT UNIVERSITY",
"EDUCATION ELEMENTRY",
"PANCHAYAT SAMITI SUWANA",
"K T C (INDIA) LIMITED",
"RAGIST CLASS RAJ HIGH COURT JODHPUR",
"PANCHAMRUT INTERNATIONAL PUBLIC SCHOOL",
"TALUKA SEED FARM",
"MAJIDIA ISLAMIA INTER COLLEGE ALLD",
"GOVT CENTRAL PRIMARY SCHOOL MANDONI",
"THE DALY COLLEGE INDORE",
"NWR JODHPUR WORKSHOP",
"SHRI RANGLAXMI ADARSH SANSKRIT MAHAVIDYALAYA",
"TECHNICAL EDUCATION",
"DR CHANNABASAVESHWAR GURUKUL RESIDENTIAL SCIENCE COMP COLLEGE KARDYAL",
"STARK PHARMA PRIVATE LIMITED",
"VTEST SOFTWARE PRIVATE LIMITED",
"AFFLUENCE IT SOLUTIONS PRIVATE LIMITED",
"MEDAZ SUPER SPECIALITY HOSPITAL PRIVATE LIMITED",
"R K ROAD CARRIER PRIVATE LIMITED",
"THEPINNACLESEARCH",
"GENE APPARELS",
"LOTT CAREY BAPTIST MISSION",
"THE MADRAS SEVA SADAN HR SEC SCHOOL",
"MILAGRES",
"L.S.DAVAR CO.",
"ANS",
"CENTRE TAP ENGG",
"NARAYANA GROUP OF SCHOOLS",
"EURO AGENCIES",
"MARUTI INDUSTRIES",
"NY D I WAALA LLP",
"SAR ENGINEERS",
"TECHSUNBIO GREEN ENERGY PRIVATE LIMITED",
"VJBJ PRATHAMIC ASHRAMSHALA SHINDKHEDA",
"BLUE DARWAZA TRAVEL PRIVATE LIMITED",
"V AND L DIAGNOSTICS CENTRE LLP",
"MRIG FASHION",
"GAWKY GOOSE KITCHEN AND BAR",
"PEEO JATIYANA",
"DEEKSHA TIWARI UCMAS IDEAL ABACUS ACADEMY",
"SHREE KUMAR MANDIR BHADRAN",
"TERASTAR NETWORKS INDIA PRIVATE LIMITED",
"NUMAC POWERTECH",
"U S OSTWAL EDUCATION SOCIETY",
"UPNIRIKSHAK SANSKRIT PATHSHALAYE MEERUT",
"HONOURABLE PUNJAB AND HARYANA HIGH COURT",
"KOSMOSS BONE AND JOINT CENTRE",
"GSSS BADKOCHARA JAWAJA",
"MADHYAMIK VIDYALAY TOKANAPIMPRI TAL AKKALKUWA DIST NANDURBAR",
"KALINTH ADVISORS PRIVATE LIMITED",
"DIVINE KUTCH LIFE CARE HOSPITAL",
"GSSS MAHAWA",
"DEPARTMENT OF WATER RESOURCES",
"PSR ARTS AND SCIENCE COLLEGE",
"BANGLADESH STEEL RE-ROLLING MILLS LTD",
"EP SOFT PRIVATE LIMITED",
"AAA SERVICES INDIA",
"THE K V CO OP & C J BHAKTA & D C BHAKTA SECONDRY SCHOOL",
"SHRI UTTAR BUNIYADI AASHRAM SHALA VARIYAV",
"MUNICIPAL CORPORATION CHANDIGARH (FIRE AND EMERGENCY SERIVICE)",
"Z P PRATHAMIK SHALA BAMDOD",
"PRATHIMA RELIEF COLLEGE OF NURSING",
"ECR",
"CARVED ADDITIONS",
"CENTRAL GOVERNMENT UTTRI RAILWAY",
"LOKPRIYA SUPERSPECIALITY HOSPITAL",
"PONNUSAMY NADAR COLLEGE OF EDUCATION",
"DUTTAPULIA UNION ACADEMY FOR GIRLS",
"DISTRICT TRANSPORT OFFICE BARAN",
"BIMS MULTISPECIALITY HOSPITAL",
"HARYANA STATE AGRICULTURAL MARKETING BOARD",
"CAYMAN INTERNATIONAL",
"JYOTI INDUSTRIES UNIT NO",
"RAJASHREE CHHATRAPATI SHAHU MAHARAJ GOVERNMENT MEDICAL COLLEGE",
"DWARKA DEPOT SEC 2",
"OFFICE OF THE BOARD OF COUNCILLORS",
"ARCON DESIGN PRIVATE LIMITED",
"MOTHER THERESA MATRICULATION HR SEC SCHOOL",
"UPS MANGARI",
"ABDUL SALAM AND SONS",
"RANOLI HIGH SCHOOL",
"THE FERN RESIDENCY BHIWANDI PIMPLAS MAHARASHTRA",
"KANYA GURUKUL MAHAVIDYALAYA DEHRADUN",
"SYMBIOSIS UNIVERSITY OF APPLIED SCIENCES",
"ASHOK INDUSTRIAL ENTERPRISE",
"ABG GURUKULAM",
"COMMISSIONER VINDHYACHAL DIVISION MIRZAPUR",
"DR B R AMBEDKAR UNIVERSITY OF SOCIAL SCIENCES",
"YOUTH EMPOWERMENT AND ENTREPRENEURSHIP DEPARTMENT ( SKILL DEVELOPMENT AND INDUSTRIAL TRAINING EMPLOYMENT , YOUTH AFFAIR )",
"KONCEPT KREATIONS",
"ECR DANAPUR DIVISION",
"CHRIST CONVENT SCHOOL",
"VOIDEK WEBSOLUTIONS",
"RANA HOLIDAYS",
"MAHATMA GANDHI GOVT SCHOOL (ENGLISH MEDIUM) AALOD",
"HIMACHAL PRADESH STATE FOREST DEVELOPMENT",
"GSSS PEELAK JHADOL",
"QUALIZEAL INDIA LLP",
"KHIDKI DIGITAL BRANDING PRIVATE LIMITED",
"ATOPIC LABORATORIES PRIVATE LIMITED",
"UNI MEDICOLABS",
"MEPSC",
"NIYUPRENE PLASTICS COMPANY PRIVATE LIMITED",
"SATHURAGIRI FACILITY SERVICES PRIVATE LIMITED",
"RAJ AD MASS MEDIA PVT LTD",
"INTELLO HOME SOLUTION PRIVATE LIMITED",
"ARID FOREST RESERCH INSTITUTE",
"TUMKUR VEERASHAIVA CO-OPERATIVE BANK LTD",
"GOVT DEGREE COLLEGE BADAUN",
"ORISSA STATE AIDS CONTROL SOCIETY",
"THE BHOGPUR CO-OP SUGAR MILL LTD",
"ROY ENGINEERING",
"DY DIRECTOR OF EDUCATION DISTT NORTH WEST A",
"ISHAN INTERNATIONAL PUBLIC SCHOOL",
"PAVITHRA ENTERPRISES",
"ANIMAL HUSBANDRY BRANCH",
"PRINCIPAL LN SAHU MAHAVIDYALAYA JAGATPUR",
"GOVERNMENT POLYTECHNIC WAGAI DANG",
"C M S DISTT M S HOSPITAL ALIGARH",
"THE GLOBAL EDGE SCHOOL",
"FLICKERING STAR OF DUNES SENIOR SECONDARY SCHOOL",
"SAMABHARATHAM MATRIC HIGHER SECONDARY SCHOOL",
"THE SALVATION ARMY HIGHER SECONDARY SCHOOL",
"KARDIAC FRONTIDA LLP",
"UTTARANCHAL UNIVERSITY",
"SARASWATI PRATHMIK VIDYAMANDIR",
"GOVT OF CHHATTISGARH OFFICE OF THE TAHSILDAR GOVT REV DEPT KURUD DHAMTARI CG",
"VIDYA SADHANA HIGH SCHOOL",
"PRAMOD I COLLEGE SAHASWAN BADAUN",
"KEMPEGOWDA INSTITUTE OF NURSING",
"PURBA RADHANAGAR SOUTH PRIMARY SCHOOL",
"G R C & SONS¬†",
"MANISH MAN POWER AGENCY",
"REZNET PRIVATE LIMITED",
"SBV REALTY CAPITAL PRIVATE LIMITED",
"ESSEX PROFIT ENHANCEMENT ADVISORY SERVICES PRIVATE LIMITED",
"HANSA PEST CONTROL OF INDIA¬†",
"SRI SAINATH MOULD WORKS¬†",
"IMPACT GURU",
"SCS ENTERPRISES",
"GOURMET CATERING",
"RI WORKFLOW",
"OPTIQUALL IT SOLUTIONS PRIVATE LIMITED",
"THE HUBLI URBAN CO OPERATIVE BANK LTD",
"NBF PUBLIC SCHOOL",
"DY COLLECTOR NAZUL RATLAM",
"INTERNATIONAL CENTRE FOR AUTOMOTIVE TECHNOLOGY",
"DHARMAPUR GOPAL CHANDRA SMRITI F P SCHOOL",
"PT B D SHARMA POSTGRADUATE INSTITUTE OF MEDICAL SCIENCE",
"CONCEPT PROMOTIONS AND EVENTS",
"SHRI BRIJ RAJ ADARSH INTER COLLEGE CHAUKHARA MIRZAPUR",
"TIRUPATI TRADER",
"JRM MANAGEMENT AND CONSULTANCY SERVICES",
"NEOCLINIC (A UNIT OF SATYA HEALTHCARE PRIVATE LIMITED)",
"MUNICIPAL CORPORATION OF ALWAR",
"SHREE SHIVAJI PRATHAMIK VIDYALAYA",
"E E IPH DIVISION PALAMPUR",
"ADDITIONAL DEPUTY COMMISSIONER OFFICE",
"COMMISSIONER NAGAR NIGAM",
"DR BANSI DHAR SCHOOL",
"JAMNAGAR DISTRICT EDUCATION COMMITTEE MANAGED PRIMARY SCHOOL TEACHER",
"PLUTO SUPERSPECIALITY HOSPITAL & TRAUMA CENTER",
"ADANI VIDYA MANDIR AHMEDABAD",
"BLOCK EDUCATION OFFICER (GHATIYA) UJJAIN",
"DR AMBEDKAR SMARAK HIGHSCHOOL",
"SHELL EV CHARGING SOLUTION ASIA LLP",
"ZPPS KHALCHAMALA",
"SWAMI KRUPA ENGINEERING",
"SOUTH ASIA CONSORTIUM FOR INTERDISCIPLINARY WATER RESOURCES STUDIES",
"ALLIED MANPOWER SERVICES",
"HIGH COURT",
"GOVT PRIMARY SCHOOL GANESHPUR",
"HI TECH INSTITUTE OF ENGINEERING AND TECHNOLOGY",
"MAKWANA BROTHERS",
"MUNICIPAL COUNCIL DHARIWAL",
"ZF WADIA WOMENS AND NK JHOTA COLLEGE OF COMMERCE",
"JALNA MISSION HOSPITAL",
"TEKINROADS CONSULTING LLP",
"D O T W CHHATARPUR",
"PEEO ROLIYA",
"SAI SPARSH CHILDRENS HOSPITAL",
"MUNICIPAL CORPORATION JODHPUR NORTH",
"RV VISA & CONSULTANT LLP",
"NAYACHAK JADUNATH HIGH SCHOOL",
"DY DIRECTOR NATIONAL PARK PANNA",
"ASSIATANT ENGINEER WATER RESOURCES SUB DIVISION GIRWA",
"MADRAS UNITED TRANSPORT(INDIA) PRIVATE LIMITED",
"SHREE SHYAM POLYSTER PRIVATE LIMITED",
"BUILDCON CONSULTANTS PRIVATE LIMITED",
"AMAZEIP SOLUTIONS PRIVATE LIMITED",
"DISTRICT EDUCATION COMMITTEE ARAVALLI",
"INDIRA GANDHI UCCHHA PRATHAMIK SHADA",
"BARASAT GOVERNMENT MEDICAL COLLEGE & HOSPITAL",
"SKY VENTURES",
"THE MOTHERS INTERNATIONAL SCHOOL",
"VIJAYEE BHAV VIDYAPEETH",
"RAFFLES UNIVERSITY NEEMRANA",
"POORNIMA PU COLLEGE",
"GOVT GIRLS INTER COLLEGE HATHRAS",
"PRAKASH TRANSPORT CORPORATION",
"CAS CARPET YARN DYERS",
"ENORM MEDIA LLP",
"QUALITY CONTROL DIVISION",
"GSSS NAL GOGUNDA",
"APEX EQUIPMENTS",
"GSSS GANPATIYA KHEDA",
"GANPATI ELECTRONICS",
"PERFECT UTILITIES",
"CAREWELL PHARMAPACK INTERNATIONAL PRIVATE LIMITED",
"BLISS PACKAGING",
"NYLON HOSIERY MILLS",
"GRUPO ANTOLIN DESIGN AND BUSINESS SERVICES PRIVATE LIMITED",
"MALOO HOSPITAL",
"ALWAR DCF ALWAR",
"ARYAVRAT MULTI SPECIALITY HOSPITAL",
"TRENDING ALIVE",
"SHREE SIDDHIVINAYAK MULTISPECIALITY HOSPITAL",
"UPPER PRIMARY SCHOOL RAMEDI NAGAR",
"H3 LEARNING CENTER LLP",
"KHALSA PRIMARY SCHOOL",
"DISTRICT JUDGES COURT",
"LOGIC E ENGINEER PRIVATE LIMITED",
"COMPOSITE JHS PARMESVARPUR KUDARAHA BASTI",
"P S TIKARA GHAT (DIRECTOR GENERAL SCHOOL EDUCATION UTTAR PRADESH)",
"AAI SHREE KHODIYAR ENGLISH SCHOOL",
"DHIRUBHAI AMBANI INSTITUTE OF INFO AND COMM TECHNOLOGY",
"MS KAVYA SERVICES",
"NIRMANA INSTITUTE OF MANAGEMENT AND TECHNOLOGY",
"GRAMIN ROJGAR KOSHAL VIKAS CENTRE",
"AGRAGAMI VIDYA KENDRA¬†",
"EMINENCE MANAGEMENT SOLUTIONS PRIVATE LIMITED",
"SANMAY BUILDING SOLUTIONS PRIVATE LIMITED",
"KAMALA NIKETAN MONTESSORI SCHOOL",
"KRISHNA VIDYA MANDIR MATRIC HR SEC SCHOOL",
"MODEL RESOURCES SERVICES PRIVATE LIMITED",
"SST LOGISTIC SERVICES PRIVATE LIMITED",
"ARVIND HUMANFORCE SERVICES PRIVATE LIMITED",
"THE MARITIME FLOATING STAFF WELFARE TRUST",
"HARBOUR ENGINEER HARBOUR ENGINEERING DIVISON NORTH",
"GURU BRAHMANAND SR SEC SCHOOL",
"THE SHARADA EDUCATIONAL SOCIETY",
"GSS ATLA KALAN",
"NOVAMESH LIMITED",
"RAVINDRA BHARATHI EM SCHOOL",
"DIGIGLOBE ADVERTISING PRIVATE LIMITED",
"THE PIONEER URBAN CO-OPERATIVE BANK LTD",
"KAS CARPET YARN DYERS",
"GOVT BRC RAJNAGAR",
"CHIEF VETERINARY OFFICER U S NAGAR",
"A K AUTOMATICS",
"ST ANNS SCHOOL MISSION HIGH SCHOOL",
"SHRIRAM ALKALI & CHEMICALS ¬†BUSINESS",
"DISTRICT CIVIL HOSPITAL KAITHAL",
"EG EARTH FITNESS GYM",
"DEPARTMENT OF HIGHER EDUCATION M P GOVERNMENT",
"BRAHMACHARI WADI TRUST INSTITUTE OF BUSINESS ADMINISTRATION",
"ADDITIONAL DISTRICT & SESSIONS JUDGE TIZARA ALWAR",
"PS TAMOTIA GONDA ALIGARH",
"GEMS EDUCATION SOCIETY",
"PS SHIVALA KHURD KHAIR ALIGARH",
"KRISHI VIGYAN KENDRA KAUSHAMBI",
"PRIMARY HEALTH CENTRE VALHERI",
"SARVODAYA MULTISPECIALITY AND CANCER HOSPITAL",
"OFFICE MEERUT DIVISION GANGA CANAL MEERUT",
"DIRECTOR AUDHANIC PRYOG PRASHIKSHAN KENDRA",
"PURNA NAGARPARISHAD",
"FAIRFAX SOFTWARE SOLUTIONS LLP",
"RIC GEMS AND MINERAL",
"MOTOMATIC ENGINEERING AND MACHINE TOOLS",
"MUNICIPAL BOARD GANGAPUR",
"PRINCIPAL MEDICAL OFFICER SAHAPURA",
"OFFICE OF THE CHHATTISGSRH INSTITUTE OF MEDICAL SCIENC BILASPUR CHHATTISGARH",
"CANOPUS INFOSYSTEMS PRIVATE LIMITED",
"TRINITY INTERNATIONAL FORWARDERS¬†",
"REGIONAL COLLEGE OF MANAGEMENT BANGALORE¬†",
"LUXURY PERSONIFIED LLP",
"GLOBAL AGRO INDUSTRIES",
"CITY PRIDE JUNIOR COLLEGE",
"ALANCO TECHNOLOGIES PRIVATE LIMITED",
"REDSPECK SOLUTIONS PRIVATE LIMITED",
"LIVEWATCH SECURITY SERVICES LLP",
"ACCSYS ELECTRONICS",
"PEARL APPARELS INC¬†",
"RK SECURITY MAINTENANCE",
"INCUBYTE CONSULTING LLP",
"ILAKSHI MOTORS¬†",
"ST GEORGES SCHOOL",
"LIONSGATE PLAY LLC",
"JAMIA URDU ALIGARH",
"JYOTI COLLEGE OF MANAGEMENT SCIENCE AND TECHNOLOGY",
"TRIBO INDUSTRIES",
"GSSS SANGRA",
"UPS KHEDHA NUNH",
"SSMG HOSPITAL CHOMU",
"GOVERMENT SENIOR SECOUNDERY SCHOOL FATTU DHINGA",
"TAHSILDAR CHHATARPUR MADHYA PRADESH CHHATARPUR",
"D D NAGPUR JR COLLEGE",
"CHAMELI DEVI INSTITUTE OF PROFESSIONAL STUDIES",
"DR AMBEDKAR INSTITUTE OF SOCIAL WORK",
"THE AMBALA CENTRAL CO-OPERATIVE BANK LTD",
"DDO PAY AND ACCOUNTS OFFICE NORTH ZONE",
"MS KARTAR SINGH CONST CO",
"ALPHA FLEX",
"REGISTRAR CIVIL COURT CUTTACK",
"PRIMARY SCHOOL TANA 2",
"BODHI TECHNOCRATS LLP",
"SRI BADALCHAND SAYARCHAND CHORDIA JAIN VIDYALAYA PRIMARY SCHOOL",
"YASH MOTORS",
"JOVIAL SECURITY & FACILITY SERVICES",
"LAB ICONICS TECHNOLOGIES LLP",
"DEPRONTO INFOTECH",
"HILTON BANGALORE EMBASSY GOLFLINKS (UNIT OF UMBEL PROPERTIES PVT LTD)",
"JHS PIDHORA COMPOSITE PINAHAT AGRA",
"SHIVCHATRAPATI VIDYALAYA SUNDARWADI ZALTA",
"PRINCIPAL S P MEDICAL COLLEGE BIKANER",
"DHAN CORPORATE AND INSURANCE SERVICES LLP",
"SHRI SHALIGRAM SHARMA SMARAK (P G ) COLLEGE",
"SRMS FUNCTIONAL IMAGING AND MEDICAL CENTRE",
"PROVINCIAL DIVISION HATHRAS",
"NIRISHA JR HIGH SCHOOL",
"REGIONAL DIRECTOR (HANDFW) REGIONAL OFFICE OF HEALTH",
"HARIVANDANA PHYSIOTHERAPY COLLEGE",
"ST JOSEPH S HIGHER PRIMERY/HIGH SCHOOL",
"BORIMADA",
"GSSS TIJARA",
"DISTRICT EDUCATION OFFICER SERAIKELLA KHARSWAN",
"K R MANGALAM GLOBAL SCHOOL",
"UMS DATTMAI DHANARUA PATNA",
"76 JOINT DIRECTOR ANIMAL HUSBANDRY GANGANAGAR",
"TEERTHANKER MAHAVEER UNIVERSITY",
"PANCHAYATI RAJ VIBHAG",
"D A V COLLEGE MUZAFFARNAGAR",
"BALLPRO TECHNOLOGY LLP",
"SHIVALIK SECONDARY SCHOOL",
"GSSS CHANDWAS",
"ALPHONSA HIGH SCHOOL",
"M/S S S JEWELLERS",
"COMPACT COMPUTER & PERIPHERALS",
"BHOOMI PROPERTYS",
"DASHMESH GIRLS SEN SEC PUBLIC SCHOOL",
"SPECTRUM REAGENTS AND CHEMICALS PRIVATE LIMITED",
"JVD RECOVERY AGENCY LIMITED",
"MEHUL GEO PROJECTS LLP",
"PANKAJAM MEMORIAL HOSPITAL",
"FOREST AND WILDLIFE ENVIRONMENT AND CLIMATE CHANGE",
"BIANCA HOME LLP",
"INDUSTRIAL ENGINEERING SYNDICATE",
"BELAKOBA HIGH SCHOOL",
"CONQUER CARE TECHNOLOGY¬†",
"ACCORD SUPER SPECIALTY HOSPITAL",
"EDULJI PRAMJI DOTIVALA GINNING AND PRESSING FACTORIES PRIVATE LIMITED",
"KOXTONS SPORTS EQUIPMENTS PRIVATE LIMITED",
"WHITE PLUS INNOVATIONS (I) PRIVATE LIMITED",
"1CENTER SOLUTIONS PRIVATE LIMITED",
"SPARSH REAL ESTATE PRIVATE LIMITED",
"METAPERCEPT TECHNOLOGY SERVICES LLP",
"SAMRTH DAIMONDS",
"SREE AHOBILA HOSPITAL SERVICES",
"CREATIVE WEB DESIGNER",
"CARNEGIE SOFT (INDIA) PRIVATE LIMITED",
"ST PAUL COLLEGE OF EDUCATION",
"P S NAGLA BEECH RAYA MATHURA",
"BABA BANDA BAHADUR PUBLIC SCHOOL",
"SCHOLARS WORLD SCHOOL",
"GANDHI SMARK KISHAN INTER COLLEGE KRIWOLI AGRA",
"KARYALAY PRABANDHAK SANCHALAK JILA VANOUPAJ SAHKARI UNIOAN MARYADID RAIGARH CG",
"PURKAITPARA FP SCHOOL",
"DEPUTY DIRECTOR PANCHAYAT BALODABAZAR",
"TWC SERVICES",
"RASIKLAL M DHARIWAL INSTITUTE OF TECHNOLOGY",
"THE PABANA HASSANPUR PRIMERY AGRICULTURE CO-OP SOCIETY LTD (GOVT OF HARYANA)",
"SWAMI KESWANAND RAJASTHAN AGRICULTURAL UNIVERSITY BIKANER",
"CHANNABASAVESHWARA INSTITUTE OF TECHNOLOGY",
"BABU BANARASI DAS NORTHERN INDIA INSTITUTE OF TECHNOLOGY",
"S E ELECTRICAL CIRCLE P W D JODHPUR",
"MK AUTO CLUTCH COMPANY",
"DIRECTOR URBAN LOCAL BODIES",
"DIVISIONAL COMMISSIONER GURGAON",
"TIERA TECHNOLOGIES PRIVATE LIMITED",
"CHC REHATI JALALPUR JAUNPUR",
"ONCOBIOTEK FORMULATIONS PRIVATE LIMITED",
"ARYANS MODEL SR SEC SCHOOL",
"APPECTUAL IT SOLUTIONS LLP",
"INDIAN AUTO WHEELS",
"MEGHANA HOUSE KEEPING CONSULTANCY SERVICES PRIVATE LIMITED",
"TIRATH RAM SHAH CHARITABLE HOSPITAL",
"SPLENDOUR GOLD COLLECTIONS L L P",
"MASSMUTUAL GLOBAL BUSINESS INDIA LLP",
"SK GOLDSMITHS INDUSTRIAL COOPERATIVE SOCIETY LTD",
"NAGAR PARISHAD KARYALAY",
"CENTRAL ORDNANCE DEPOT DEHU ROAD PUNE",
"ARB SOFTWARE INDIA PVT.LTD.",
"MATRIX FACILITY SERVICES INDIA PRIVATE LIMITED",
"TRUSHAPE PRECISION CASTINGS PRIVATE LIMITED",
"CIVIL JUDGE J D AHMEDNAGAR",
"GOVERMENT OF CHHATTISGARH MAN POWER PLANNING DEPARTMENT OFFICE OF THE PRINCIPAL GOVT. POLYTECHNIC KORBA CHHATTISGARH",
"SUPERITENDENT RANIDURGAWATI HOSPITAL JABALPUR",
"ST JOSEPHS SCHOOL",
"B E O BABAI HOSHANGABAD MADHYA PRADESH",
"QA TESTING LABORARTORIES PVT LTD",
"DIST ANIMAL HUSBANDARY OFFICER",
"TECHNOCON SERVICES",
"INFINIUM",
"C M AND H O SEONI MADHYA PRADESH",
"TIRUPUR DISTRICT CONSUMER COOPERATIVE WHOLESALE STORE LTD",
"GOVERNMENT OF CHHATTISGARH OFFICE OF THE BLOCK EDUCATION OFFICER",
"SCHOOL EDUCATION DEPARTMENT BLOCK EDUCATION OFFICER RAMANUJNAGAR",
"BLOCK EDUCATION OFFICER BARGHAT MADHYA PRADESH",
"DISTRICT & SESSIONS COURT",
"VATSALYA HEALTHCARE LLP",
"BHARATI VIDYAPEETH DEEMED TO BE UNIVERSITY COLLEGE OF NURSING",
"BLOCK DEVELOPOMENT OFFICER CHHAPARA MADHYA PRADESH",
"KARYALAY JANPAD PANCHAYAT SOHAWAL JILA SATNA",
"EDUCATION DEPARTMENT OFFICE OF THE BLOCK EDUCATION OFFICER RAIGARH",
"DISTRICT AYUSH OFFICER SAGAR",
"SWAMINARAYAN AKSHARPITH¬†",
"D Y PATIL EDUCATIONAL ACADEMYS DY PATIL SCHOOL OF ENGINEERING ACADEMY",
"TALUKA INSPECTOR OF LAND RECORDS HAWELI",
"DINO MOTORCYCLES¬†",
"GOVERNMENT OF CHHATTISGARH EDUCATION DEPARTMENT (T) GOVT. HR.SEC.SCHOOL DEONAGAR DIS.SURAJPUR ( C.G )",
"PH & FW DEPARTMENT BLOCK MEDICAL OFFICER DARIMA DIST.SURGUJA ( C.G )",
"AIDED SECONDARY ASHRAM SCHOOL NARA TAL KARANJA",
"OFFICE OF THE EXECUTIVE ENGINEER M R P DISNET DIVISION",
"GOVT MEMBER SECRETARY MADHYA PRADESH",
"INDUSTRIAL TRAINING INSTITUTE DISABLE RAJKOT",
"DISTRICT AAYUSH OFFICER MANDLA",
"DR D Y PATIL SCHOOL OF ALLIED HEALTH SCIENCES PIMPRI",
"Z P P S NANDANWAN",
"DISTRICT HEALTH OFFICER ZILLA PARISHAD CHANDRAPUR",
"TECHNOCRAT",
"RISHI VIDYA EDUCATIONAL FOUNDATION JALNA",
"JAY AMBE INTERNATIONAL SCHOOL",
"ADARSH MADHYAMIK VIDYALAYA DUM DUM BRANCH HS",
"TALUKA AGRICULTURE OFFICE BEED",
"B E O KHANDWA",
"MIDAS ARCHITECTURAL SYSTEMS LLP¬†",
"DIRECTOR GENERAL OF AUDIT (COAL)",
"SUB DISTRICT HOSPITAL HINGANGHAT",
"BLOCK EDUCATION OFFICER CUTTACK SADAR",
"MEDICAL OFFICER COMMUNITY HEALTH CENTRE AGARPADA BHADRAK",
"MUNICIPAL OF CORPORATION OF DELHI",
"CHAMPABERIA HIGH SCHOOL HS",
"DISTRICT INSPECTOR OF SCHOOL SE HOOGHLY",
"HARIOM FLEXIPACK INDUSTRIES",
"SUPREME HOSPITAL",
"BLOCK EDUCATION OFFICER KOREI",
"GOVT HIGH SCHOOL PANDORI KHATRIAN (FZR)",
"GOVT CO ED SARVODAYA VIDYALAYA",
"DIST PROGRAMME OFFICER WOMAN AND CHILD DEV HOSHANGABAD MADHYA PRADESH",
"M AND M PUBLIC SCHOOL",
"Z P HIGH SCHOOL BOYS WADDHONA",
"GOVERNMENT OF CHHATISGARH SCHOOL EDUCATION DEPARTMENT",
"AEN SUB DIV RAMGARH",
"A E N P H E D SUB DIV III ALWAR",
"CHAUDHARY CHARAN SINGH BRIJ KHAND INTER COLLEGE BATHAIN CHHATA MATHURA",
"PRIMARY SCHOOL ANANT KAMTAUL",
"GANDHINAGAR HOMOEOPATHICMEDICAL COLLEGE",
"MULTILINK",
"ABHIJEET ENGINEERS",
"SWARN HOTELS LLP",
"SHREE VAISHNAV ACADEMY",
"KAANAN ENTERPRISE",
"MY FIRST SCHOOL INTERNATIONAL",
"MK FASTENERS",
"PS BHAGWANTPUR SIKANDRA RAO HATHRAS",
"S D DIAMOND",
"GUDAH CONSULTANTS",
"SAWALI CARE CENTRE",
"ANUDANIT PRATHAMIK AASHRAM SHALA MUKHED",
"BACKBASE INDIA LLP",
"SEKHON SCAN",
"R K SEEDS FARM",
"KAWAL ENTERPRISES",
"BHARATIYA SANSKRITI DARSHAN TRUST",
"THE GURUSAR SAINE WALA MPCASS LTD BATHINDA (GOVT OF PUNJAB)",
"SRI BADALCHANDS SAYARCHAND CHORDIA JAIN VIDYALA MATRICULATION SCHOOL",
"CENTRAL GROUND WATER BOARD DIV X",
"BRUNDAVAN HOSPITALS",
"NOIDA INTERNATIONAL INSTITUTE OF MEDICAL SCIENCES",
"J K ELECTRIC CONTRACTOR LLP",
"MUNICIPAL CORPORATION CHANDIGARH FIRE AND EMERGENCY SERVICES",
"WEB COM INDIA PRIVATE LIMITED",
"KALYAN MOTORS",
"RURAL DEVELOPMENT AND PANCHAYATS",
"SHIV BHOLEY RICE MILLS",
"SYNEOS HEALTH INDIA PRIVATE LIMITED",
"MONEYEDGE INVESTMENT",
"DE NOBILI SCHOOL BHULI",
"AXIS TOOLING¬†",
"COMMUNITY HEALTH CENTER SUWANA BHILWARA",
"CHIEF SECRETARIAT ESTABLISHMENT",
"SRB & ASSOCIATES",
"ADVOCATE GENERAL HIMACHAL PRADESH",
"KSS PG CENTRE OF STUDIES IN COMMERCE M.COM VIDYANAGAR HUBLI",
"MAHADEV ASSOCIATES",
"S G S INTER COLLEGE BAJHERA BHARATPUR",
"MISSION GYAN",
"DISTT EXISE OFFICER SATNA",
"SUB TREASURY LAXMANGARH ALWAR",
"OPENGROWTH ACADEMY PRIVATE LIMITED",
"THE IDEA TRIANGLE",
"B E O PALERA TIKAMGARH",
"ALI YAVAR JUNG NATIONAL INSTITUTE OF SPEECH AND HEARING DISABLITIES REGIONAL CENTRE",
"SOUTHWINDS PROJECT LLP",
"SADH CARE HOSPITAL",
"P S LABOUR CONTRACTOR",
"DRM MULTI SPECIALITY HOSPITAL",
"EKOCHING",
"R B INSTITUTE OF MANAGMENT STUDIES ( RBIMS )",
"SHRI AMMANI ENTERPRISES",
"GMV DISTRIBUTORS",
"BASIRHAT DISTRICT HOSPITAL",
"PD STEELS",
"KARYALYA NAGAR PARISAD SATAI JILA CHHATARPUR",
"M K ENTERPRISES",
"TUNGABHADRA BOARD TUNGABHADRA HYDRO ELECTRIC SCHEEM",
"PRAVIN PATIL COLLEGE OF DIPLOMA ENGINEERING AND TECHNOLOGY",
"VIVEKANAND GLOBAL UNIVERSITY",
"TEHSILDAR BAMOUR",
"PANCHYAT SAMITI NADBAI",
"BANHARISHPUR GIRLS HIGH SCHOOL",
"AAFT UNIVERSITY OF MEDIA ART",
"KRISHNA SUPER SPECIALITY HOSPITAL",
"VIBE SOLUTIONS",
"DEVELOPMENT AND PANCHAYAT",
"MAYO INSTITUTE OF MEDICAL SCIENCES",
"TALENTHIVEE HR SOLUTIONS LLP",
"125 DEPUTY DIRECTOR POLYCLINIC JAIPUR",
"SABHARWAL TRADERS",
"EXECUTIVE ENGINEER DAM REHABILITATION IMPROVEMENT PROJECT",
"S S KOTHARI MEHTA & CO. LLP",
"OSCAR FOUNDATION",
"QRIOUS CREATIVE",
"KNAV SERVICES PRIVATE LIMITED",
"TAPS HEALTHCARE PRIVATE LIMITED",
"PAZINO INFOTECH PRIVATE LIMITED",
"WORLDBRIDGE SOLUTIONS PRIVATE LIMITED",
"RAJDHANI FOLIAGE FLORA",
"JAI ASHAPURA HYDRAULICS",
"JANTA BAZAR",
"SRI GAVISIDHESHWARA LORRY TRANSPORT CO",
"DEENDAYAL MULTIPURPOSE COOP SCTY LTD",
"FORAM WORLDWIDE HOSPITALITY LLP",
"GOVERNMENT MEDICAL COLLEGE HOSPITAL PUDUKKOTTAI",
"SOWKAR M BABA PAI",
"SAI SYSTEMS HEALTHCARE",
"ROFU INDIA PRIVATE LIMITED",
"SDBPG ENTERPRISES LLP",
"MODERN CIVIL CONSTRUCTION LLP",
"BLOCK CHIEF MEDICAL OFFICER BUNDI",
"GOVERNMENT POLYTECHNIC SOLAPUR",
"ARNIKA ENTERPRAISES",
"THE AHMEDABAD MERCANTILE CO OP BANK LTD",
"PASCOEARTHMOVERS LLP",
"B E O BADAMALEHRA",
"MED-REVIVE BIOTEC LLP",
"G B PANT HOSPITAL (GIPMER)",
"SECURECOP FACILITY PLUS SERVICES",
"DIRECTOR RAJASTHAN INTELLIGENCE TRAINING ACADEMY JAIPUR",
"GOVERNMENT OF NAGALAND OFFICE OF THE DEPUTY RESIDENT COMMISSIONER NAGALAND HOUSE GUWAHATI-22",
"CORPORATE CARE",
"S D PUBLIC SCHOOL",
"PRINCIPAL DISTRICT AND SESSIONS JUDE SHAHDARA DISTICT",
"KRISHNA INTERNATIONAL SCHOOL",
"P SQUARE BUILDERS LLP",
"THE NAGAUR CENTRAL CO OPERATIVE BANK LTD",
"PRINCIPAL MEDICAL OFFICER BARMER",
"ENVIRONMENT FORESTS AND WILDLIFE DEPARTMENT",
"NINJATECH",
"JUGDIA HIGH MADRASAH HS",
"TEHSILDAR DEORI MADHYA PRADESH SAGAR",
"DDO CENTRAL SHEEP BREADING FARM",
"KHONAMUKH HIGHER SECONDARY SCHOOL",
"MANKHAMAR HIGH SCHOOL",
"H M M S DUDHITAND",
"KEN BETWA LINK NAHAR NIRMAN KHAND 1 JHANSI",
"GSSS CHATARGANJ KISHANGANJ",
"B D G C BULANDHSHAHAR",
"DIRECTOR ANIMAL HUSBANDRY",
"D F O NOURADEHI SAGAR",
"MADHYMIK VIDYALAY WATKHED",
"ACCORD POWER DIGITAL PRODUCTS",
"THE PRESIDIUM SCHOOL",
"DEVTOOLS",
"PRIME BONX 147",
"M/S PANSARI MANUFACTURING AND TRADING COMPANY",
"VEL TECH RANGARAJAN DR SAGUNTHALA R&D INSTINSTITUTE OF SCIENCE AND TECHNOLOGY",
"DR B BOROOAH CANCER INSTITUTE",
"EMPLOYMENT DEPARTMENT",
"MISSION FOR VISION",
"AKSHAYA MOTORS",
"SMT SUCHETA KRIPLANI HOSPITAL",
"JNB STEEL INDUSTRIES",
"ULTRRA NONWOVEN",
"C S CUM HOSPITAL SUPDT DIST UJJAIN MADHYA PRADESH",
"BLOCK EDUCATION KASARAWAD MADHYA PRADESH KHARGONE",
"THE NEW ERA HIGH SCHOOL & HIGHER SECONDARY SCHOOL",
"M L P WORLD SCHOOL TIJARA",
"PARV VILAS RESORT & SPA KASAULI HILLS SOLAN",
"DISTRICT MAGISTRATE U S NAGAR",
"TEHSILDER CWA MADHYA PRADESH",
"PRATAP PUBLIC SCHOOL",
"MANKORI DEVI HIGHER SEC SCHOOL CHIRAWA",
"MAULI MADHYAMIK VIDHYALAYA EKDARA",
"PATNA SMART CITY LIMITED",
"PRAKASH BATTERY UDYOG",
"CHIEF CONSERVATOR SOIL AND WATER CONVERSATION",
"CHIEF AUDITOR COOPERATIVE SOCIETIES",
"KHARIMACHAN DURODRISTI FP SCHOOL",
"SYMBIOSIS MEDICAL COLLEGE FOR WOMEN",
"MOIC PRIMARY HEALTH CENTRE BHEEMTAL",
"PANIHATI BALIKA VIDYALAYA",
"DISTRICT EDUCATION OFFICER HOSHANGABAD",
"SUPTD ENGR DAM SAFETY ORGANIZATION",
"B E O SONKACHHA DEWAS",
"JAIN INTERNATIONAL RESIDENTIAL SCHOOL",
"GSSS TITRDI",
"SAFEW TECH SYSTEMS",
"DIVINE ENTERPRISE",
"DOORWIN INTERNATIONAL",
"BAHULA NO TWO FREE PRIMARY SCHOOL",
"SAMDARSHI PROJECTS LLP",
"SHREEJI VENTURES REALTY PRIVATE LIMITED",
"INNOVATE TAX PRIVATE LIMITED",
"INTELLIGENZ IT PRIVATE LIMITED",
"RAJKIYA AYURVED MAHAVIDYALAY VARANASI",
"BT-PIERIAN MANAGED SERVICES LLP",
"POWER CONTROL ENGINEERING AND CONTRACTOR",
"LSA RECRUIT PRIVATE LIMITED",
"PRINCIPAL MEDICAL OFFICER NEEMKATHANA",
"C E O JANPAD PANCHAYAT REHLI SAGAR",
"SAHAYOG HOSPITAL GONDIA",
"STATION HEAD QUARTER AMRITSAR",
"SAI SIDDHI COLLEGE OF NURSING YEOLA",
"SHD MADRAK ALIGARH",
"R4 SPORTS FOUNDATION",
"SHRI S B HIGH SCHOOL BHARAD",
"THE UMARPUR CO-OP CREDIT AND SERVICE SOCIETY LTD",
"LEASPIN TEXTILE LLP",
"LUMENS SCHOOL",
"B E O BIJAWAR CHHATARPUR MADHYA PRADESH CHHATARPUR",
"POSSESS I TECHNOLOGIES PRIVATE LIMITED",
"HRMS GOVT OF BIHAR",
"STATE NODAL AGENCY CHHATTISGARH",
"CHENG SHRE VID NIKE HI SCH",
"TRIANGLE TECHNO ENGINEERING",
"CLOUDRAN LLC",
"CHHATTISGARH MEDICAL SERVICES CORPORATION LIMITED",
"GOVT SPON MULTIPURPOSE B TAKI",
"NSAG HOSPITALITY LLP",
"GSSS RAMGARH",
"DIRECTORATE RESEARCH AND MEDICAL EDUCATION",
"ARS HYDROJET SERVICES PRIVATE LIMITED",
"KAYTES BUSINESS SERVICES LLP",
"BHARTI VIDYAPEETH JAWAHARLAL NEHRU INSTITUTE OF TECHNOLOGY (POLY)",
"POWER CONTROL ENGINEERS PRIVATE LIMITED",
"PORCHAND FIRM",
"SILICON INSTITUTE OF TECHNOLOGY",
"CENTELLI INDIA LLP",
"GATE INSTITUTE OF TECHNOLOGY AND SCIENCE",
"K G B M HIGH SCHOOL",
"SECRETARY TO GOVERNOR PUNJAB RAJ BHAWAN",
"EXECUTIVE ENGINEER TUBEWELL DIVISION HALDWANI",
"SATYAM INFRA",
"BLOCK EDUCATION OFFICER MASTURI BILASPUR",
"GGSSS VINOVA BHAVE NAGAR",
"K M D S SR MADRASA U P",
"JPH INTERPRISES",
"JESSICA KITCHEN EQUIPMENT",
"NEW PATH DEVLOPERS LLP",
"A EN PHED CITY SUB DIV III UDR",
"UDAIPUR DCF UDAIPUR",
"SINDHI COLLEGE",
"G C GARG TRADING CO",
"OM SREE BUILDERS & DEVELOPERS LLP",
"SIVASAGAR WATER RESOURCES DIVISION KHIJUNUR ALI ROAD BABUPATTY SIVASAGAR (GOVT OF ASSAM)",
"WENTWORTH MANAGEMENT (INDIA)",
"PAO IMD MINISTRY OF EARTH SCIENCES NEW DELHI",
"RAJIBPUR GIRLS HIGH SCHOOL",
"RENUKAI CAREER CENTER (RCC) LATUR",
"NUTAN MADHYAMIK VIDYALAY DONDAICHA TAL SHINDKHEDA DIST DHULE",
"MAHATMA GANDHI GOVT SCHOOL ENGLISH MEDIUM HADIYA¬†MAHWA DAUSA",
"DIVISIONAL FOREST OFFICER CHANDAKA WILD LIFE DIVISION BHUBANESWAR",
"MATA GUJRI PUBLIC SENIOR SECONDARY SCHOOL",
"STARLIT CANCER HOSPITAL",
"LAL BAHADUR SHASTRI GOVERNMENT DEGREE COLLEGE",
"MUNICIPAL COUNCIL BHIWADI",
"PRIVILEGEINN",
"RAJARAJESWARI MEDICAL COLLEGE & HOSPITAL",
"GSSS JHUNIR",
"CONTAGIOUS V",
"SURIYA MARKETING",
"STAFF NURSE",
"GAMEZOP",
"SIERRA CLOUD LLP",
"V5 GLOVES COMPANY",
"DISTRICT T B OFFICE PUNE",
"N H GOEL WORLD SCHOOL",
"BLOCK CHIEF MEDICAL OFFICER KHERWADA UDAIPUR",
"ARMY PUBLIC SCHOOL CLEMENT TOWN DEHRADUN",
"PEEO VARADARA",
"SHIVA ALLOYS",
"SATTVA SATTVIK PRIVATE LIMITED",
"DISTRICT EXCISE OFFICER JHUNJHUNU",
"NUTAN MADHVAMIK VIDYALAY DONDAICHA",
"OLD NAVDEEP JEWELLERS",
"HELAN JUNIOR BASIC SCHOOL",
"MINISTRY OF LABOUR",
"S S S PUBLIC SCHOOL",
"STATION HEADQUARTERS SADHUWALI CANTT",
"LABOUR COURT MUMBAI",
"KARNATAKA STATE AKKAMAHADEVI WOMEN'S UNIVERSITY",
"PEEO HARNAWDA GAJA",
"M/S SAI MOTORS",
"GOPAL SHARMA BLOOMING BUDS PRE SCHOOL",
"IRESTORE LIFESCIENCE TECHNOLOGY LLP",
"GSSS SUTHEPA",
"GSSS CHANSDA GIRWA",
"PURBA KALITALA ADARSHA VIDYAMANDIR",
"ANANTAPUR DISTRICT CO OPERATIVE CENTRAL BANK LIMITED",
"JAGADDAL WOOMA CHARAN HIGH SCHOOL",
"BRIJ BHUSHAN LAL PUBLIC SCHOOL BAREILLY",
"DEPARTMENT OF MEDICAL EDUCATION",
"RSRTC UDAIPUR DEPOT",
"RERIPUR JUNIOR HIGH SCHOOL",
"ROHINI JEWELLERS PRIVATE LIMITED",
"MEDICAMEN LIFE SCIENCES PRIVATE LIMITED",
"SPAAR ENVIRONMENTAL TECHNOLOGIES PRIVATE LIMITED",
"MITSUFUKU COMPOUND PRIVATE LIMITED",
"JORIM INFRASTRUCTURE PRIVATE LIMITED",
"LILLY POWER-TECH PRIVATE LIMITED",
"EAKCON SYSTEMS PRIVATE LIMITED",
"ERGON SEATINGS PRIVATE LIMITED",
"PATHFINDER TUTORIAL CENTRE",
"INLAND WATERWAYS AUTHORITY OF INDIA",
"KANKPUL HIGH SCHOOL",
"POLE STAR INTERNATIONAL SCHOOL",
"HANSHABAHINI",
"BHANWAR SINGH PALACE JAIPUR",
"LORD KRISHNA'S SCHOOL",
"COAST GUARD PAY AND ACCOUNTS OFFICE",
"VIRSA CUISINE HOSPITALITY",
"IIMT COLLEGE OF POLYTECHNIC",
"EAST COAST RAILWAY KHURDA ROAD",
"BHACHAR PRATHMIK KENDRA SHALA",
"ARMY PUBLIC SCHOOL",
"FOOD CONTROLLER SAGAR",
"DHEKNAMARI DA VIDYAPITH HS",
"ST JOHNS MEDICAL COLLEGE HOSPITAL",
"COMMUNITY HEALTH CENTER MOJAMABAD JAIPUR",
"VR ARCHITECTS",
"PEEO MANDAWAR",
"COMVISION SOFTWARE LLP",
"BARODA RAJASTHAN KSHETRIYA GRAMIN BANK",
"BLOCK DEVELOPMENT OFFICER CHANDBALI",
"EX ENG KONAR NAHAR BANASO",
"HETFY SOFTWARE SOLUTIONS LLP",
"PHENIX CONSTRUCTION TECHNOLOGIES",
"SREE SIDDAGANGA EDUCATION SOCIETY",
"L A SR SEC SCHOOL",
"INDIAN FINANCIAL TECHNOLOGY AND ALLIED SERVICES",
"JB INNOVATIONS",
"HM G M S CHALKUSHA BAKATHA",
"PERFECTION IAS",
"BEDEPOTA BARAGOBRA F P SCHOOL",
"SRI RAM INTERNATIONAL SCHOOL",
"BHARTI AYURVED MEDICAL COLLEGE & HOSPITAL",
"COLLECTORATE VARANASI",
"MILITARY HOSPITAL MEERUT",
"JAY PRAKASH NARAYAN SARVODAY VIDHYALAY",
"SHAILYA HOSPITAL",
"ANDWESUPPORT",
"SUPERINTENDENT STATE EXCISE SOLAPUR",
"SHRI SHARDA BHAVAN EDUCATION SOCIETY‚ÄôS INSTITUTE OF TECHNOLOGY & MANAGEMENT",
"A EN PHED SUB DIV SIKRAI",
"EXCELLERE WORLD SCHOOL",
"ANUGRAHA EDUCATION SOCIETY",
"KLIO-TECH LLP",
"ZPPS BORGAON AUSA",
"DIRECTOR OF PRINTING & STATIONERY",
"MAHARSHI DAYANAND UNIVERSITY",
"REGREEN-EXCEL EPC INDIA LIMITED",
"KEYAN HYDRAULICS PRIVATE LIMITED",
"KSR FOODS AND BEVERAGES PRIVATE LIMITED",
"DIGITAL DATA AUTOMATION PRIVATE LIMITED",
"SHREE HARI",
"GANTECH E TECHNOLOGIES PRIVATE LIMITED",
"CHANDRABHAN YADAV",
"MARWET PETROLEUM AGENCY",
"MURUGAPPA POLYTECHNIC COLLEGE",
"BRIGHT ELECTRO PROCESS",
"BLOCK CHIEF MEDICAL OFFICER TIJARA ALWAR",
"B E O ISHA NAGAR MADHYA PRADESH CHHATARPUR",
"DY S P SPECIAL LOKAYUKTA",
"GOVERNMENT COLLEGE FOR WOMEN",
"DIRECTORATE OF HEALTH AND FAMILY WELFARE",
"INFLUX MEDIA LLP",
"PEEODHAND",
"GARG PHARMACEUTICALS",
"THE FATEHABAD DISTT PRIMARY CO-OP AGRI & RURAL DEV BANK LTD",
"DIRECTORATE OF STATISTICS PUNJAB",
"N C JINDAL INSTITUTE OF MEDICAL CARE & RESEARCH",
"NATIONAL TRAINING INSTITUTE LUDHIANA",
"DIGITAL CROWN IT SYSTEMS LLP",
"ANUBHAVAMANTAPA INDEPENDENT PRE UNIVERSITY COLLEGE",
"DIRECTOR STATE TAX ACADEMY JAIPUR",
"GOVT BOYS SR SEC SCHOOL NAJAFGARH",
"MINERAL RESIURCE DEPARTMENT OFFICE OF THE REGIONAL HEAD DIRECTORATE OF GEOLOGY AND MINING REGIONAL OFFICE",
"BALAJI MEDICAL & DIAGNOSTIC RESEARCH CENTRE",
"M/S.TRADING ENGINEERS",
"MEDICAL OFFICER COMMUNITY HEALTH CENTRE DAHAGADI JAJPUR",
"SOFTEK COMPUTER CONSULTANCY",
"UNIQUE ADEPT SERVICES PRIVATE LIMITED",
"PGT RESOURCES PRIVATE LIMITED",
"FIRST LIVINGSPACES PRIVATE LIMITED",
"MAHENDRA INDUSTRIES",
"MAHARAJA READYMADE",
"ETOUCH SYSTEMS",
"GROUPM MEDIA",
"INDIRA COLLEGE OF COMMERCE AND SCIENCE",
"SPECIAL DISTRICT SOCIAL WELFARE OFFICER PUNE",
"SRI DURGA MALLESWARA SWAMY VARLA DEVASTHANAM",
"PRASHEETAN ENERGY CONSULTANTS LLP",
"GSSS BHIKHANSAR ALSISAR",
"KAMALABAI UMAK NURSING SCHOOL",
"BARSHI NAGARPARISHAD BARSHI DIST SOLAPUR",
"INSTITUTE OF SECRETARIAT TRAINING AND MANAGEMENT NEW DELHI",
"RASHTRAMATA INDIRA GANDHI COLLEGE",
"CAVALARY CANTEEN AC AND SCHOOL AHMEDNAGAR",
"DISTT PROGRAM OFFICER",
"ADVANCED NEUROLOGY & SUPER SPECIALITY HOSPITAL JAIPUR",
"DALCO HEALTHCARE AND WELLNESS CENTER",
"BHARTI AIRTEL FOUNDATION",
"BELCON POWERTRANS LLP",
"AJINKYA AUTOWHEELS LLP",
"KARYALAY MUKHYA KARYAPALAN ADHIKARI JANPAD PANCHAYAT SAGAR",
"DINKAR VIDYALAYA DINKARNAGAR JAMNI",
"PANCHAYAT SAMITI MAJALGAON",
"GSSS GHRACHON",
"CONGRUENCE MARKET INSIGHTS",
"MADHYA PRADESH KHADI TATHA GRAMODYOG BOARD",
"B E O GOURIHAR CHHATARPUR MADHYA PRADESH CHHATARPUR",
"HEALTH DEPARTMENT ZILLA PARISHAD KOLHAPUR",
"PANCHYAT SAMITI SHIRUR ANATPAL",
"SHRI KRUSHNA AADIVASI AASHRAM SHADA KOKANA",
"V CARE HOSPITAL",
"NATIONAL LAW UNIVERSITY AND JUDICIAL ACADEMY ASSAM",
"DEPUTY REGISTRAR HIGH COURT SHIMLA",
"RURAL DEVELOPMENT DEPARTMENT",
"WELLSUN MEDICITY SUPER SPECIALITY HOSPITAL",
"NATIONAL INSTITUTE OF AYURVEDA",
"OFFICE DEPARTMENT OF INFORMATION TECHNOLOGY AND COMMUNICATION KOTA",
"MAHARANI LAXMI BAI MEDICAL COLLEGE",
"SOFTWEBPOS",
"KESORAM RAYON UNIT OF CYGNET INDUSTRIES LIMITED",
"MOSS ADAMS (INDIA) LLP",
"HERITAGE TOYOTA",
"SAADHYA INFRA SOLUTIONS LLP",
"S S ENGINEERING SERVICES",
"MEDICAL OFFICER COMMUNITY HEALTH CENTRE DANAGADI JAJPUR",
"STATE CIVIL SUPPLY CORPORATION",
"YARK ENTERPRISES",
"ZYDUS SCHOOL OF EXCELLENCE",
"VIDYANIKETAN ENGLISH SCHOOL",
"MOTHER INDIA FARMS",
"FALCON PROPERTY MANAGEMENT SERVICES",
"RAJDHANI SERVICE STATION",
"BRIGHT DAY SCHOOL",
"NFR LUMDING DIVISION",
"XL SOLUTION LLC",
"MUNICIPAL COUNCIL KHANNA LUDHIANA",
"GSSS REBARION KA GUDA BADGAON",
"INDUSTRIAL TRANING INSTIUTE SARKHEJ AHMEDABAD",
"UNFILTERED WATER SUPPLY DIV",
"TRAVEL GEEKS SOLUTIONS LLP",
"NIRMAL BETHANY PRIMARY SCHOOL",
"KINGS ROYAL RIDERS",
"AMPAR CO-OPERATIVE AGRICULTURAL SOCIETY LTD",
"NANASAHEB MAHADIK COLLEGE OF ENGINEERING PETH",
"ZAO CBDT JAIPUR",
"ROYAL CONVENT SCHOOL",
"VIKRAM SARABHAI SPACE CENTRE",
"BIJPUR NETAJI SIKSHA NIKETAN",
"CIT DELHI CORPORATE INCOME TAX",
"GSSS LAKHANI",
"DIRECTOR GEOLOGY MINING BHOPAL",
"THE HARYANA STATE CO OPERATIVE LABOUR & CONSTRUCTION FED LTD",
"MUNICIPAL COMMITTEE BAWANI KHERA",
"FUSION LIFE SCIENCES TECHNOLOGIES PRIVATE LIMITED",
"JAGDISH RAI CHAMAN LAL",
"SWAMI VIVEKANANDA YOUTH MOVEMENT",
"TWAY IT SERVICES",
"DISTRICT HEALTH SOCIETY SUPAUL",
"APRARI SOLUTIONS",
"FARCON LEATHER EXPORTS PRIVATE LIMITED",
"ZILLA PARISHAD PRE MIDDLE SCHOOL BELORA DHAMAK",
"SAARTHI PROPACK",
"HOLIDAY INN BENGALURU RACECOURSE",
"GOVERNMENT GIRLS SENIOR SECONDARY SCHOOL",
"JYOTI SAREE HOUSE",
"SHRI NARAYAN VIDY AHER CHINCHOLI",
"AGRA DIVISION",
"SANCHANALAYA AYUSH DEPARTMENT MADHYA PRADESH",
"REAL OUTSOURCING SERVICES LIMITED",
"STAR EXPRESS CARGO",
"SUMUKHA ENTERPRISES",
"EMSC SECURITY SERVICES",
"SELLBRITE DIGITAL LLP",
"ACCOUNTMEIN FINTECH SOLUTIONS PRIVATE LIMITED",
"CHAMPAVATI PRIMARY SCHOOL BEED",
"SHRI NARAYAN VIDYALAYA AHER CHINCHOLI",
"MANTRALAYA SQUARE MEAL AND CANTEEN",
"GSSS MEWADON KA MATH (KOTDA) UDAIPUR",
"KAJORA HIGH SCHOOL",
"22710 COMMUNITY HEALTH CENTER NAPASAR (BIKANER)",
"DIVISIONAL TRAINING CENTER ALIYABADA",
"MCLAREN STRATEGIC VENTURES INDIA PRIVATE LIMITED",
"DAUSA TEHSILDAR LAWAN",
"TECHCOMPILER DATA SYSTEMS PRIVATE LIMITED",
"SECT RAJASTHAN LEGISLATIVE ASSEMBLY JAIPUR",
"NATIONAL CRIME RECORDS BUREAU",
"QUANTET ENGINEERING",
"GODREJ SKYLINE DEVELOPERS LIMITED",
"DISTRICT MAHATMA GANDHI GOVT SCHOOL",
"INSTITUTE OF TECHNOLOGY AND SCIENCE MOHAN NAGAR",
"CHANAKYA GYAN KENDRA",
"SAVITRI DEVI HOSPITAL",
"NARAIN PUBLIC SCHOOL",
"CATALYST",
"KHS INNOVATION & ENGINEERING LLP",
"UHT PROJECTS LLP",
"GOVT SRVODAYA SR SEC SCHOOL BADAR PUR KHADAR",
"JOINT DIRECTOR ANIMAL HUSBANDRY UDAIPUR",
"TSDC TECHNOLOGIES LLP",
"VOLIBITS LLP",
"RATNAM INSTITUTE OF PHARMACY",
"DR G S KALYANASUNDARAM MEMORIAL SCHOOL",
"SHRI SHIV SHANKAR LAL UPP PR",
"GANDHI SRAMIK HINDI VIDYALAYA",
"MAHESHWARI VIDHYAPEETH",
"B E O RAHATGARH MADHYA PRADESH SAGAR",
"SARDAR PATEL INSTITUTE OF HIGHER EDUCATION",
"JOYKRISHNAPUR NEHRU VIDYABHABAN HS",
"SHAMBHUNATH INSTITUTE OF PHARMACY",
"V JULKA FOOTWEAR",
"SOUTH SANKRAIL HIGH SCHOOL (H S)",
"MEHERBAI TATA MEMORIAL HOSPITAL",
"PASCO AUTOMOBILES GURGAON",
"M / S PRAGJYOTI BIOFUELS",
"SHRI OM PARKASH A V N PUBLIC SCHOOL",
"JOINT AGRI DIRECTOR HZB",
"DISTRICT REGISTRATION AND COUNSELING CENTRE",
"GALAXY HYDRAULICS",
"SWAMI RAMANAND TEERTH MEDICAL COLLEGE AND HOSPITAL AMBEJOGAI",
"EMPLOYMENT GENERATION SKILL DEVELOPMENT & TRAINING",
"BISHOP WESTCOTT BOYS' SCHOOL NAMKUM RANCHI",
"LALJEE GODHOO & CO",
"KHORKI F P SCHOOL",
"EX ENGR IRRIGATION RESEARCH DIVISION THANE",
"PRIMARY HEALTH CENTER SAWALAJ",
"TENTULKULY HIGH SCHOOL",
"EXPAT SOLUTIONS INDIA PRIVATE LIMITED",
"QUALIBAR PRIVATE LIMITED",
"KAVERI GARAGE PRIVATE LIMITED",
"VIRDHI TECH LAB PRIVATE LIMITED",
"C S ACADEMY",
"ERGOMATIC AUTOMATION INDIA PRIVATE LIMITED",
"FANINDRA DEB INSTITUTION",
"DEPUTY SUPERINTENDENT STATE EXCISE SANGLI",
"SANTALPUR MISSION HIGH",
"BETHESDA HOSPITAL SOCIETY",
"DEPARTMENT OF RURAL DEVELOPMENT",
"MS ENGINEERING COLLEGE",
"LOCOMOTIVE GLOBAL MEDIA LLP",
"KHANDELWAL HEART INSTITUTE",
"GUJARAT STATE CO OPERATIVE MARKETING FEDERATION LIMITED",
"CHIEF DISTRICT VETERINARY OFFICER DISTRICT VETERINARY ANUGUL",
"DY DIRECTOR VETERINARY SERVICES KHARGONE",
"RSRTC LOHAGARH DEPOT",
"NATIONAL INSTITUTE OF OPEN SCHOOLING",
"16074 GSSS JAWAHAR AJMER",
"ADHOC KHANNA FUELS",
"SRISHTI ENTERPRISES",
"ISMS TBS",
"EXCISE AND TAXATION DEPARTMENT",
"TTC CO-OPERATIVE BANK LIMITED",
"RSRTC ALWAR DEPOT",
"SRI VENKATESWARA INSTITUTE OF TECHNOLOGY",
"TENUGHAT VIDYUT NIGAM LIMITED",
"ELMECH ENGINEERING",
"THE LEELA AMBIENCE GURUGRAM HOTEL AND RESIDENCES",
"BHATANA ALLOYS PRIVATE LIMITED",
"HARI BALAKRISHNA AUTOMOBILES¬†",
"VR ENGINEERING WORKS",
"SYNERGEIN SOLUTIONS LLP",
"DATTER CHAK HIGH SCHOOL HS",
"DDO SECT M/O PETROLEUM AND NATURAL GAS",
"GOVERNMENT OF INDIA DEPARTMENT OF ATOMIC ENERGY HEAVY WATER BOARD FACILITIES",
"OFFICE OF THE DEPUTY COMMISSIONER OF POLICE ARMED POLICE TARDEO MUMBAI",
"FUTURE CAMPUS SCHOOL SONARPUR",
"SPRING MOUNT VALLEY SCHOOL",
"BULDHANA URBAN CO OP CREDIT SOCIETY LTD",
"DEPARTMENT OF MEDICAL HEALTH & FAMILY WELFARE",
"VIJAY KIRAN EDUCATION TRUST",
"MAAN TRADING COMPANY",
"GREENBOX DIGITAL INSTITUTE",
"JAI ROADWAYS",
"NAVYUG PUBLIC SR SEC SCHOOL",
"PRINCIPAL DIRECTOR OF AUDIT DEFENCE COMMERCIAL BENGALURU",
"TRINITY JUNIOR COLLEGE",
"A G AUDIT JHARKHAND RANCHI",
"THE ZOROASTRIAN CO-OPERATIVE BANK LTD",
"GREATX",
"BAKERS COLOURS FLAVOUR INDIA",
"INTEGRITY PACKAGING LLP",
"B E O RAJNAGAR CHHATARPUR MADHYA PRADESH CHHATARPUR",
"GOVERNMENT OF RAJASTHAN",
"INSPECTOR OF STATE EXCISE CHECK NAKA SOLAPUR",
"ZPPS LONDHEWADI LONDHEWADI",
"SENIOR BASIC MIDDLE SCHOOL NIRSA-1",
"INDUSTRIAL TRAINING INSTITUTE LAKHANI",
"PREM TEXTILES",
"SHRI M B VAMDOT C B¬†PATEL HIGHER¬†SECONDARY SCHOOL",
"PREFERENT WAY SERVICES",
"STEMS INTEGRATED ACADEMYST TERESA'S ENGLISH MEDIUM SCHOOL, DANGARKUCHI CHOWK, BARPETA (ASSAM)",
"PRAKASH HOSPITAL AND TRAUMA CENTRE",
"SRI BALAJI FABRICATION WORKS",
"SWASTHYA KALYAN SAMITI",
"GOVERNMENT OF ASSAM DIVISIONAL FOREST OFFICE, SIVASAGAR (T) DIVISION",
"THORI MUBARAK PRIMARY SCHOOL VIRAMGAM",
"UTTARAKHAND CIVIL AVIATION DEVELOPMENT AUTHORITY",
"SKILLZCAFE LEARNING SOLUTIONS PRIVATE LIMITED",
"JSM CONSULTING INDIA PRIVATE LIMITED",
"STRIDES SOFTWARE SOLUTIONS PRIVATE LIMITED",
"FULCRUM INDIA LIFESCIENCES PRIVATE LIMITED",
"DESIGN THINKING TECHNOLOGIES INDIA PRIVATE LIMITED",
"ASTRAL COATINGS PRIVATE LIMITED",
"CREATIVE IMPRINTS LLP",
"BAY TALKITEC PRIVATE LIMITED",
"GOVERNMENT OF ASSAM EXECUTIVE ENGINEER JORHAT DIVISION ( IRRIGATION)",
"STATE PLANNING BOARD MAHARASHTRA",
"DHANWATE NATIONAL COLLEGE CAMPUS",
"BALAJITEK PUMPS AND VALVES PRIVATE LIMITED",
"VALTON INFRAWORKS PRIVATE LIMITED",
"PUNJAB WATER SANITATION AND SEWERAGE BOARD",
"NASA BRAIN AND SPINE CENTRE",
"AQSA GIRLS URDU HIGH SCHOOL",
"COOZMOO DIGITAL SOLUTIONS LLP",
"Z P SCHOOL VIRACHA PADA KHADAKOHOLE",
"HIMACHAL PRADESH BOARD OF SCHOOL EDUCATION",
"MAXBRIDGE SOLUTIONS LLP",
"CHAIRMAN PUNJAB PUBLIC SERVICE COMMISSION",
"KRYPTON INTERNATIONAL SCHOOL",
"BLOOM PUBLIC SCHOOL",
"ICAR ATARI ZONE VI GUWAHATI",
"NOVOTEL VIJAYAWADA VARUN",
"BHARAT TANKS AND VESSELS LLP",
"SPAR INFOTECH",
"ASSIST DIRECTOR CENCUS OPERATION (PAO CENSUS NEW DELHI)",
"SAVVY ATS REALTY LLP",
"SHRI LAL BAHADUR SHASTRI NATIONAL SANSKRIT UNIVERSITY",
"PIET NCR COLLEGE",
"PUNJAB STATE AIDS CONTROL SOCIETY",
"D M C ENGG DEPARTMENT CO OP THRIFT & CREDIT SOCIETY LTD",
"DIRECTORATE YOUTH SERVICES",
"MOUNT LITERA SCHOOL INTERNATIONAL",
"BLOCK MEDICAL OFFICER HEALTH DEPARTMENT CMHO BMO DISST BIJAPUR (C G)",
"NITYANAND VED ITWARI",
"LAXMIKRIPA GARMENTS PRIVATE LIMITED",
"MOREPEN RX LIMITED",
"SWAMI VIVEKANAND INSTITUTE OF MANAGEMENT AND TECHNOLOGY¬†",
"DROGHERIA",
"POPULAR SWEETS",
"MANYAVAR SHREE KASHIRAM JI GREEN ECO GARDEN LUCKNOW",
"B E O SAGAR MADHYA PRADESH",
"GURUWARYA BH WA SANAP PRIMARY SCHOOL BEED",
"VASANTRAO NAIK HIGH SCHOOL AND JUNIOR COLLEGE HATGAON",
"SUNDRI DEVI JUNIOR HIGH SCHOOL",
"WESLEY GIRLS HIGH SCHOOL SECUNDERABAD",
"MAHATMA GANDHI GOVT SCHOOL ENGLISH MEDIUM NECHHWA",
"ID4 CONSULTANCY PRIVATE LIMITED",
"SAGAR DUTTA MEDICAL COLLEGE & HOSPITAL",
"SETH VISHAMBHAR NATH INSTITUTE OF PHARMACY",
"OLYMPIAN INTERNATIONL EDUCATION SOCIETY BUNIYAAD SCHOOL",
"12125 GSSS RINYABARI",
"KANYA PRIMARY SCHOOL KOCHRA",
"SUPDT GOVT PRESS JODHPUR",
"SMART VISION EYE HOSPITALS",
"THINGSWORK DESIGN ATTIC PRIVATE LIMITED",
"SECRETARY PERSONNEL DEPARTMENT",
"DY COLLECTOR FOR COLLECTOR",
"AKSHITA INFRATECH PRIVATE LIMITED",
"TAHSILDAR NOWGAON CHHATARPUR MADHYA PRADESH CHHATARPUR",
"CANCER CONTROL MISSION",
"TECH INNOVATIVE GROUP OF MANPOWER SECURITIES",
"SUNFLAG GLOBAL HOSPITAL",
"MADHYA VIDYALAYA PURANAIYA BIHITA",
"ANNET TECHNOLOGIES (MUMBAI) LLP",
"SUKANTI INTERNATIONAL SCHOOL",
"HON SHRI ANNASAHEB DANGE AYURVED MEDICAL COLLEGE & POST GRADUATE RESEARCH CENTER",
"ZOOLOGICAL SURVEY OF INDIA",
"MEWAR UNIVERSITY",
"D F O SOUTH SAGAR MADHYA PRADESH SAGAR",
"SHRI UP ARTS AND SMT MGP SCIENCE AND SHRI VLS COMMERCE COLLEGE",
"SNOOX AUTOMATION PRIVATE LIMITED",
"HOMEMONDE LIFESTYLE PRIVATE LIMITED",
"VDEAL SYSTEM LIMITED",
"UNIDUS DECOR PRIVATE LIMITED",
"RUTAM ENVIRO SYSTEMS PRIVATE LIMITED",
"DR. DUDHABHATE HEALTHCARE PRIVATE LIMITED",
"OMSHIVAM PACKAGING PRIVATE LIMITED",
"PROJECT CONCERN INTERNATIONAL",
"RJ SAFETY SERVICES",
"JAYAM ENGINEERING AND CONSTRUCTION",
"JPL EDUCATIONAL SOCIETY",
"NARAYAN INDUSTRIES",
"BROTHERHOOD MAT HR SEC SCHOOL",
"UNICO CONNECT",
"SENSI EQUIPMENT LLP",
"SIDDHI HEALTHCARE PRIVATE LIMITED",
"VLG INDIA",
"ANCHORAGE FINKRED PRIVATE LIMITED",
"JK WHITE CEMENT",
"URBAN LOCAL BODY DIRECTORATE ULB NPP HATHRAS",
"SAWARIYA SECURITY & SERVICES PRIVATE LIMITED",
"THE PANCHMAHAL DISTRICT CO-OPERATIVE BANK LIMITED",
"MED MECS BILLING SERVICES",
"PRONOMIO SOLUTIONS LLP",
"REGALIX A MARKETSTAR COMPANY",
"DEPUTY INSPECTOR OF SCHOOLS PRAGJYOTISHPUR CHATRIBARI GUWAHATI",
"THE SIVAKASI LIONS MATRICULATION HIGHER SECONDARY SCHOOL",
"BALVANTRAY MEHTA VIDYA BHAWAN ASMA",
"SHIKSHA ADHIKARI",
"MUNICIPAL CORPORATION SHIMLA",
"HIMACHAL PRADESH WAQF BOARD",
"Z P SCHOOL DASVAD",
"PROLIFE HOSPITALS",
"SHRI SIDDHESHWAR CANCER HOSPITAL AND RESEARCH CENTER",
"SNBP INTERNATIONAL SCHOOL",
"SD BIOMEDICAL WASTE MANAGEMENT",
"CIVIL SURGEON OFFICE RAMGARH",
"INDUSTRIAL TRAINING INSTITUTE KHANPUR BAKOR",
"ANIMAL HEALTH PATHOLOGY LAB",
"PRINCIPAL SRI SRI BAYA BABA COLLEGE MAHAKALPARA",
"THE PLAZA HOTEL",
"NEW STEWART SCHOOL CUTTACK",
"DE NOBILI SCHOOL FRI",
"GOVERNMENT OF ASSAM EXECUTIVE ENGINEER JORHAT DERGAON TEOK DIVISION",
"SAINT THOMAS HIGHER SECONDARY SCHOOL BARNAGAR",
"CHALK HIRANYABATI PRIMARY SCHOOL",
"KALITALA DHASPARA F P SCHOOL",
"CHILADANGI RABINDRA VIDYABITHI",
"PRINCIPAL GOVT HIGHER SECONDARY SCHOOL KHOULI RAIPUR",
"RURAL HOSPITAL BHIDI",
"VINAYAK GANESH VAZE COLLEGE OF ARTS SCIENCE & COMMERCE",
"EE TAWA PROJECT DIVISION ITARSI",
"JOKAI BOWA KALIA HIGH SCHOOL JOKAIBOWA MAJULI ASSAM",
"Z P PRE MID SCHOOL WITALA",
"JOY HOME INDUSTRIES LLP",
"JINDAL ADARSH GRAMYA BHARTI HIGHER SECONDARY SCHOOL KIRODIMAL NAGAR",
"MAHATMA GANDHI GOVT SCHOOL ENGLISH MEDIUM NAKAMADAR AJMER",
"AHMEDABAD DISTRICT EDUCATION COMMITTEE RUNNING PRIVATE SCHOOL TEACHERS",
"RZP SCHOOL WAGHACHI WADI",
"GREYSCALE ENTERTAINMENT",
"Z P P S HANUMAN WASTI JIWACHIWADI TAL KAIJ DIST BEED",
"THE HIMACHAL PRADESH STATE COOPERATIVE AGRICULTURE & RURAL DEVELOPMENT BANK LTD",
"GSSS BERASHAR BADA BERASAR CHHOTA RAJGARH",
"CORPORATION BHILAI",
"SARJI FOUNDATION",
"ORGAN PRIME DIAGNOSTIC CENTRE",
"CHIEF TOWN PLANNER TOWN AND COUNTRY PLANNING",
"TULAS INSTITUTE DHOOLKOT DEHRADUN",
"OLYMPIAN INTERNATIONAL EDUCATION SOCIETY BUNIYAAD SCHOOL",
"MUSEUM OF SOLUTIONS",
"HEALTH OFFICE BOTAD DISTRICT PANCHAYAT",
"NETIZENS FOUNDATION ACADEMY",
"OFFICE SHREE MAHAKALESHWAR MANDIR PRABHANDH SAMITI UJJAIN",
"CYBER TECH SOLUTION",
"PAO LHLS NOIDA",
"APEX INTERNATIONAL PUBLIC SR SEC SCHOOL",
"ARABLE LABS INDIA PRIVATE LIMITED",
"ARBOINT INTERNATIONAL SOLUTIONS LLP",
"ROYAL ASSOCIATES",
"GARMEX (IND) APPAREL LLP",
"PUSH MATERNITY HOME & HOSPITAL",
"ALPINE DIAGNOSTIC CENTRE LLP",
"KANCHRAPARA HIGH SCHOOL",
"KUSHABHAU THAKRE UNIVERSITY OF JOURNALISM & MASS COMMUNICATION",
"CENTRAL PUBLIC SCHOOL BADARPUR",
"TILJALA BRAJANATH VIDYAPITH",
"DR AMBEDKAR COLLEGE",
"OASISSERVE DESIGN SERVICES PRIVATE LIMITED",
"PROMITRA SOFTTECH PRIVATE LIMITED",
"RAINTREE COMPUTING PRIVATE LIMITED",
"SHELKE CONSTRUCTIONS PRIVATE LIMITED",
"L&T FINANCE LIMITED",
"DILRAJ CONTRACTOR",
"KALINGA INSTITUTE OF MEDICAL SCIENCE",
"SREE AGASTHYA MEDICAL CENTRE",
"SANDEEP SHIKRE AND ASSOCIATES",
"GOVERNMENT COLLEGE OF TECHNOLOGY",
"DATTUSIH CHAVAN PRIMARY SCHOOL VIKRAMNAGAR LATUR",
"GOVERNMENT OF PUNJAB EDUCATION",
"HIRE LABS CONSULTANTS",
"VASANT VIHAR HIGH SCHOOL JUNIOR COLLEGE",
"PRAKHAND SHIKSHA PADADHIKARI VAISHALI",
"CENTRAL FOOTWEAR TRAINING INSTITUTE",
"H M G H SCHANDPUR",
"RURAL ENGINEERING SERVICES BALAGHAT (M P)",
"MANAGING DIRECTOR JILA LAGHU VANOPAJ UNION MAR KORBA",
"YOSO ENGINEERING & SUPPLIERS",
"SHETH SHREE PURSHOTTAMDAS MULJIBHAI GOKLANI HIGHER SECONDARY SCHOOL VAARAHI",
"SHREE LAXMI HIGH SCHOOL",
"G TECH CONSTRUCTIONS INDIA LLP",
"ZPPS URDU SALGARWADI",
"GOVT VARISHTHA UPADHYAYA SANSKRIT SCHOOL PANDER BHILWARA",
"EPISTLE COMMUNICATIONS LLP",
"HILIKES INNOVATION PRIVATE LIMITED",
"THE YAVATMAL URBAN CO-OP BANK LTD",
"REVENUE BRANCH BHARUCH DISTRICT PANCHAYAT",
"ARIANA DEZINER KREATIONS PRIVATE LIMITED",
"PEGASUS FININVEST ADVISORY PRIVATE LIMITED",
"RAJASHREE INTERNATIONAL MANUFACTURING PRIVATE LIMITED",
"P L BAGRI & CO",
"ANANTHA MK INSTITUTE OF MEDICAL SCIENCES LLP",
"SGA RECRUITMENT LLP",
"ALA PRIMARY SCHOOL",
"COLLECTOR CHHINDWARA",
"THE SASTI COLLERY COALMINES EMPLOYEE CO OP PAT SOCIETY LTD",
"SD ENTERPRISES",
"COMPOSITE SCHOOL SAHPAU HATHRAS",
"HERITAGE INSTITUTE OF HOTEL & TOURISM",
"BHARAT LIFESPACE PRIVATE LIMITED",
"PUNJAB EX SERVICEMEN CORPORATION",
"AADHYA MAHAVIDHYALAYA GARHAKOTA SAGAR",
"OFFICE OF THE SUPERINTENDENT CHC RAJSUNAKHALA",
"K L INTERNATIONAL SCHOOL",
"DRX LABS",
"GLENHILL SCHOOL VARANASI",
"BORDA PRIMARY SCHOOL SONGADH",
"HEALTH LEDGER DIAGNOSTICS",
"PUNJAB URBAN PLANNING & DEVELOPMENT AUTHORITY",
"DDO P I M O PLANNING",
"COMMUNITY HEALTH CENTRE PAOTA (JAIPUR)",
"TINNA ILLAMPUR P S VIDYAMANDIR",
"Z P SCHOOL KARBHARIPADA (MAL)",
"EXPORT INSPECTION COUNCIL OF INDIA",
"BHARAT INFRASTRUCTURE",
"MIND TREE SCHOOL",
"GOVERNMENT MEDICAL COLLEGE AND GENERAL HOSPITAL BARAMATI DISTRICT PUNE",
"KALINAGAR MATANGINI HAZRA SMRITI F P SCHOOL",
"ADVOCATE GENERAL",
"MAHARASHTRA JUNIOR MAHAVIDYALAYA NILANGA",
"JOSH PROPERTIES",
"D D ASSOCIATES AOP",
"SUJATHA SCHOOL",
"LA MARTINIERE SCHOOL",
"BLOCK ELEMENTARY EDUCATION OFFICE AMGURI GAURISAGAR SIVASAGAR (GOVT OF ASSAM)",
"SHETH R T AGRAWAL HINDI HIGH SCHOOL",
"SDEAS CORPORATE SERVICES (INDIA) PRIVATE LIMITED",
"MOKSH TECH AHMEDABAD",
"SRI SARASWATHI VIDYANIKETHAN",
"VENKATESWARA JEWELLERY",
"ANNAI AMARAVATHI HOSPITAL",
"TELANGANA GOVERNMENT ROAD TRANSPORT CORPORATION",
"IMON CORTEGE PRIVATE LIMITED",
"ISHANYA MOTORS LLP",
"WELNIT INDUSTRIES",
"ASST EXCISE COMMISIONAR UJJAIN",
"ST JOHNS SCHOOL",
"EXOTIC POWER SOLUTIONS PRIVATE LIMITED",
"AURO PLASCOM ENGINEERS LLP",
"MANGAYARKARASI GROUP OF INSTITUTION PARAVAI MADURAI",
"STATION HEADQUARTERS KAPURTHALA",
"CENTRAL UNIVERSITY OF HARYANA",
"NWR BIKANER DIV",
"PANCHAYAT SAMITTEE AMRAVATI",
"JANAKPURI SUPER SPECIALITY HOSPITAL",
"RASHTRIYA MILITARY SCHOOL",
"SURYADATTA COLLEGE OF HOSPITALITY MANAGEMENT AND TRAVELS TOURISM",
"MAHATMA GANDHI GOVT SCHOOL ENGLISH MEDIUM MUNDARU",
"ELIAS AUTO INDIA PRIVATE LIMITED",
"7185 SR MED OFFICER GOVT NATURAL HOSPITAL HANUMANGARH",
"VILAS CO OPERATIVE BANK LTD LATUR",
"GEOLOGICAL SURVEY OF INDIA CENTRAL REGION NAGPUR",
"TIMEUS INTERACTIVE SERVICES PRIVATE LIMITED",
"JUNAGADH DISTRICT EDUCATION COMMITTEE MANAGED PRIMARY SCHOOL TEACHAR",
"ZPPS CJIKALA TANDA MOTHA",
"INDIA VISION FOUNDATION",
"GOLDEN PRO DIGITAL SERVICES",
"NARAYANRAO NAGRE SR COLLEGE DUSARBID",
"PROCESS DRIVE INDIA PRIVATE LIMITED",
"NIVASOFT INDIA PRIVATE LIMITED",
"VV MARINE PRODUCTS",
"AGIVANT TECHNOLOGIES",
"GUS EDUCATION INDIA",
"DISTRICT EDUCATION COMMITTEE MAHISAGAR",
"GSSS TYOD",
"PERINGAMALA GRAMA PANCHAYAT",
"B E O RUDRAPUR",
"KARIGHARS HOME DECOR LLP",
"THE WHITE MEDICAL COLLEGE & HOSPITAL",
"H R ASSOCIATES",
"INTERNATIONAL AIRCON",
"A K AUTOMATICS I",
"PEEO SINOD",
"HARYANA HUMAN RIGHTS COMMISSION CHANDIGARH",
"FINE COLOUR PROCESS",
"AHMEDNAGAR SHAHAR SHAHAKARI BANK LTD",
"HARYANA STATE COOPERATIVE BANK LTD",
"ASCENT LANDMARKS LLP",
"PINNSOFT CONSULTANCY SERVICES PRIVATE LIMITED",
"NAXNOVA TECHNOLOGIES PRIVATE LIMITED",
"INFOSHORE SOFTWARE PRIVATE LIMITED",
"MAHARSHI DAYANAND SARASWATI UNIVERSITY AJMER",
"PAO LEGAL AFFAIRS NEW DELHI",
"RELIANCE REFRACTORIES PRIVATE LIMITED",
"ZILHA PARISHAD PRATHMIK SCHOOL BELGAON",
"UJJAWAL SOYA & CHEMICALS",
"DIRECTORATE OF HEALTH SERVICES WEST BENGAL",
"RIGM SAINIKI SCHOOL",
"SISOTHYA AUTOMOBILES",
"WCR JABALPUR CONSTRUCTION",
"BAN SAGAR CANAL CONSTRUCTION DIV 05 MIRZAPUR",
"BEFORE FIRST SOLUTIONS LLP",
"OFFICE OF THE ZILA PARISHAD SANGRUR (PUNJAB)",
"ARCGATE TECHNOLOGIES LLP",
"PUNJAB WATER SUPPLY AND SEWERAGE BOARD",
"MEDICAL SUPDT RURAL HOSPITAL MURGUD",
"VARDHMAN POLYMERS INDIA",
"PRATHIKSAI INNOVATIONS LLP",
"EXECUTIVE ENGINEER PWD ARKI",
"AEN PHED SUB DIV TODARAYSINGH (TONK)",
"NAVGAN SHIKSHAN SANSTHA RAJURI VASANT DADA ARTS COMMERCE AND SCIENCE COLLEGE",
"DEVIPRASAD GOENKA MANAGEMENT COLLEGE OF MEDIA STUDIES",
"CASA GRANDE COIMBATORE LLP",
"Z P SCHOOL AAMKHEL",
"PANCHAYAT SAMIT CHOPDA",
"ZPPS KALMAN KALMAN",
"TECHTINIUM TECHNOLOGIES",
"COLONELS BRIGHTLAND PUBLIC SCHOOL",
"ELITE ELEVATOR",
"C E O JANPAD PANCHAYAT JAISINGHNAGAR MADHYA PRADESH SAGAR",
"INNOVATIONE INDIA PROJECTS LLP",
"OFFICER OF SENIOR MEDICAL OFFICER SDCH INDRI",
"SANT VINOBA BALAK ASHRAM BADE KILEPAL BASTAR",
"HERQLIS INDIA PRIVATE LIMITED",
"TRIBOCARE MARINE SERVICES PRIVATE LIMITED",
"ISLAMIC LEARNING SOLUTIONS PRIVATE LIMITED",
"SIRI IT INNOVATIONS PRIVATE LIMITED",
"OMISOL PRIVATE LIMITED",
"CLEAR LENS OPTICAL INDUSTRIES",
"OKAY INDUSTRIES",
"AIR FORCE SCHOOL HALWARA",
"KALAAR GALASS/ KLAARGLAS(EPFO NAME)",
"INDIGO BLUES",
"MAHINDRA WORLD SCHOOL",
"SHRI GOVIND DEGREE COLLEGE",
"NAVKAR BUSINESS SERVICE",
"GREETINGS COLOUR PROCESS",
"TRAK TELL",
"TELANGANA WAQF BOARD",
"PAO DGET DELHI",
"OFFICE OF JANPAD PANCHYAT TENDUKHEDA",
"BAAN INFRA PROJECTS",
"CHIEF CONSTRUCTION ENGINEER R&D CENTRAL",
"HYDERABAD SIND NATIONAL COLLEGIATE BOARD",
"XCEL SOLUTIONS",
"YOUNG WOMENS CHRISTIAN ASSOCIATION OF DELHI",
"SHREE RAM VIDHYALAY",
"SCHOOL OF TECHNICAL TRAINING INDIAN ARMY",
"OFFICE OF THE BLOCK ELEMENTARY EDUCATION OFFICER JORHAT BLOCK BAGHCHUNG",
"SUPRO INFO SOLUTIONS PRIVATE LIMITED",
"THE SUPERINTENDING ARCHAEOLOGIST DELHI CIRCLE",
"PM SHRI SCHOOL JAWAHAR NAVODAYA VIDYALAYA VANKAL",
"2894 GSSS JANDAWALI",
"SHRI GAURIDUTT MITTAL VIDYALAYA AND JR COLLEGE",
"BHARTIYA CONSULTANCY SERVCIES",
"STUCARE TECHNOLOGIES PRIVATE LIMITED",
"MATA HARKI DEVI SR SEC SCHOOL",
"NAV JYOTI SR SEC SCHOOL",
"B E O REHLI MADHYA PRADESH SAGAR",
"SVENLA ENTERPRISES PRIVATE LIMITED",
"BANGALORE MOUNTAINEERING CLUB PRIVATE LIMITED",
"SHARMA AUTOMOTIVE PRIVATE LIMITED",
"LALA LAJPAT RAI INSTITUTE OF NURSING EDUCATION",
"JUDICIAL LEGISTATURE UP GOVT",
"INDUSTRIAL TRAINING INSTITUTE BARRACKPORE",
"ST ANN S SCHOOL ICSE",
"BHUSAVAL NAGAR PARISAD BHUSAVAL",
"OFFICE OF SETTLEMENT OFFICER COSOLIDATION",
"DR RAJENDRA PRASAD CENTRAL AGRICULTURAL UNIVERSITY",
"GOVT HIGH SCHOOL TIKOHNA FARM PALIA",
"ASTT COMM TRIBAL SAGAR MADHYA PRADESH SAGAR",
"S K TRADING CORPORATION",
"TWILIGHT POST LLP",
"DESUN NURSING SCHOOL AND COLLEGE",
"GODAVARI COLLEGE OF NURSHING(GNM)",
"MANEEFJI COOPER EDUCATION TRUST SCHOOL",
"GOVERNMENT E-MARKETPLACE",
"SHREE SHREE JAGANNATH HIGHER SECONDARY SCHOOL",
"PUBLIC HEALTH & FAMILY WELFARE DEPARTMENT BLOCK MEDICAL OFFICER PUBLIC HEALTH CENTRE BASTAR DISTT JAGDALPUR",
"SWASTHYA MULTISPECIALITY HOSPITAL BANSWARA",
"DEPARTMENT OF SOCIAL SECURITY WOMENT & CHILD DEVELOPMENT PUNJAB",
"PRIMARY HEALTH CENTER CHAPOLI TQ LATUR",
"MANGALMAY INSTITUTE OF MANAGEMENT & TECHNOLOGY TECHNOLOGY",
"B K SALES CORPORATION",
"DISTRICT EDUCATION OFFICER BARIPADA MAYURBHANJ",
"SEKHA INDANA GRAMIN VITRAK",
"BAL VIKAS VIDYA MANDIR SCHOOL",
"PRINCIPAL MEDICAL OFFICER ALWAR",
"DTEA SENIOR SECONDARY SCHOOL",
"KEC KAVERI JOINT VENTURE",
"CREDIT VIDHYA",
"DR S RADHAKRISHNAN TEACHER'S TRAINING COLLEGE",
"GLORZIENT TECHNOLOGIES PRIVATE LIMITED",
"YMX INDIA SERVICES PRIVATE LIMITED",
"ZYLNX SOLUTIONS PRIVATE LIMITED",
"BIHAR SKILL DEVELOPMENT MISSION",
"TRINITY INTETNATIONAL SCHOOL",
"PRAGNA VIDYANIKETAN",
"SCMS SCHOOL OF ENGINEERING AND TECHNOLOGY",
"JAYTEX SILK MILLS",
"INDIA INTERNATIONAL SCHOOL",
"GHMC",
"JYOTI HERO",
"ASIAN INFOTEL PRIVATE LIMITED",
"LPF AGENCIES LLP",
"INTERNATIONAL CONNECTIONS",
"JAYAM SUPER MARKET",
"SAMARPAN FACILITY MANAGEMENT LLP",
"SAKTIGARH BIDYAPITH HS",
"STEPHEN INTERNATIONAL SCHOOL",
"G V D SARVAJANIK HIGH SCHOOL VALSAD",
"MOMANSA ENTERPRISES",
"AKSHARA HIGH SCHOOL",
"FIRDAUS AMRUT CENTRE SCHOOL (CBSE)",
"VINAYAK VIDYA MANDIR PARNER A NAGAR",
"ROVENTURE SOFTWARE SERVICES PRIVATE LIMITED",
"BIJU PATNAIK NATIONAL STEEL INSTITUTE",
"MAHARAJA AGRASEN INSTITUTE OF MEDICAL RESEARCH & TECHNOLOGY",
"Z P SCHOOL DHANDANE",
"V A STEEL CORPORATION",
"INSIGHT EDUCATION TRUST",
"SHRI SWAMI VIVEKANAND SHIKSHAN SANSTA KOLHAPUR ENGLISH MEDIUM SCHOOL",
"SAI UNIVERSITY",
"BURHANI NATIONAL HIGH SCHOOL GHATI ROAD AURANGABAD",
"SHRI SAI VIDYALAYA MANKHURD",
"MUNICIPAL CORPORATION GURUGRAM",
"LALGUAGI AND LEARNING FOUNDATION",
"P WADHWANI COLLEGE PHARMACY YAVATMAL",
"FIRST FIDDLE VENTURES LLP",
"SIXTEEN MAHARASHTRA BATTALION NATIONAL CADET CORPS VISHRAMBAG ,SANGLI",
"HAJI SAYED AKBAR URDU HIGH SCHOOL",
"INNOTECH IT SERVICES LLP",
"GOVERNMENT PRIMARY SCHOOL MARICHAGARH URDU",
"GSVR TALENT SOLUTIONS PRIVATE LIMITED",
"EOL PACKWORLD PRIVATE LIMITED",
"UVJ TECHNOLOGIES",
"ATLAS EXPORT ENTERPRISES KARUR.",
"SCHOOL HEALTH SCHEME KARKARDOOMA",
"THE TONSBRIDGE SCHOOL DEHRADUN",
"FATEPUR HINDI NAGARI PRACHARAK VID HS",
"SARASWATI SIKSHAN SADAN PRABANDH SAMITI",
"INTER COLLEGE NAGLA KAROLI GAUTAM BUDDHA NAGAR",
"INDIAN INSTITUTE OF TECHNOLOGY INDORE",
"BLOCK HEALTH OFFICE 4 MORBL DISTRICT PANCHAYAT",
"RPS PUBLIC SCHOOL",
"DEPUTY DIRECTOR OF TOWN PLANNING KONKAN DIVISION",
"MIDNAPORE MUNICIPALITY",
"BERHAMPUR UNIVERSITY",
"TALUKA HELATH OFFICE DEORI",
"DG HOMEGUARDS & SDERF OFFICE BHOPAL",
"DISTRICT EDUCATION COMITTEE BOTAD",
"CANTEEN STORES DEPARTMRNT MINISTRY OF DEFENCE",
"GOVT R C KHAITAN POLYTECHNIC COLLEGE JAIPUR",
"LAKSHMI ENGEENERING WORKS",
"BAGHBAN PACKAGING LLP",
"GOVT OF MAHARASHTRA DEPT OF LAW AND JUDICIARY",
"THE INCODA",
"PADAM INTERIORS",
"003 BMO NAGROTA BAGWAN",
"NALANDAS GURUKUL",
"AQDAS MARITIME AGENCY PRIVATE LIMITED",
"SMART ROTAMACH PRIVATE LIMITED",
"SYNCHRONISING DESTINATIONS PRIVATE LIMITED",
"BLOCK EDUCATION OFFICER NARASINGHPUR",
"BY SALT DESIGN STUDIO",
"HAJI SAYAD AKBAR URDU HIGH SCHOOL PATUR",
"RAINSKY HR SERVICES LLP",
"RAJULA NAGARIK SAHAKARI BANK LTD",
"BAL MANDIR MODEL SENIOR SECONDARY SCHOOL",
"ADDL CHIEF MEDICAL & HEALTH OFFICER (FW) BONGAIGAON",
"TIRTHAPATI INSTITUTION PRIMARY SCHOOL",
"BUDHA DAL PUBLIC SCHOOL",
"DIRECTOR AGRICULTURE",
"103523 CIVIL JUDGE & JUDL MAGISTRATE BALESAR (JODHPUR DISTRICT))",
"ST PAULS MODERN SCHOOL",
"KAMLA NEHRU INTER COLLEGE",
"SHIVANI TRUPACK PRIVATE LIMITED",
"MUNICIPAL COUNCIL FATEHABAD",
"SHIV NADAR INSTITUTION OF EMINENCE DTU",
"INTELLIH ANALYTICS SOFTWARE INDIA PRIVATE LIMITED",
"FLEET MAINTENANCE UNIT",
"MATA BALJINDER KAUR MEMORIAL KALER INTERNATIONAL PUBLIC SCHOOL",
"ORION CREDENCE SOLUTIONS PRIVATE LIMITED",
"SUGS LLOYD LIMITED",
"SHRI CHHATRAPATI SHIVAJI MAHARAJ COLLEGE OF ENGINEERING NEPTI AHMEDNAGAR",
"CDA(FUNDS) MEERUT",
"S K SOMAIYA COLLEGE OF ARTS SCIENCE & COMMERCE",
"UNIVERSAL METRO PROPERTIES LLP",
"ST KABIRS SCHOOL",
"15576 GSSS AAKODIYA ARAI",
"RANCHI WOMEN'S COLLEGE",
"GOVT SR SEC SCHOOL MAHAPURA",
"LOGANATHA NARAYANASAMY GOVERNMENT COLLEGE",
"ATAL AMRIT ABHIYAN SOCIETY ( GOVT OF ASSAM )",
"309260 BLOCK CHIEF MEDICAL OFFICER BHINAI AJMER",
"DIRECTOR KN COLLEGE",
"PANDIT DEENDAYAL UPADHYAY AGRICULTURE COLLEGE DEOLI",
"SR CIVIL JUDGE CUM CHIEF METROPOLITAN MAGISTRATE JAIPUR METROPOLITAN I",
"INSPIRA REALTY LLP",
"MBR EDUCATIONAL SOCIETY",
"CHELEK JANAJATI HIGH SCHOOL CHELEK JANAJATI KAMALPUR",
"DEPARTMENT OF SECONDARY EDUCATION UTTAR PRADESH",
"CYBERICA NET TECHNOLOGIES PRIVATE LIMITED",
"ANAND PUBLIC SR SEC SCHOOL",
"FLOW TECH INDUSTRIAL COMPANY",
"OFFICE OF THE SPECIAL JUDGE ARTROCITIES AMBIKAPUR SURGUJA C G",
"SHRI BAJRANG CHEMICAL DISTILLERY LLP",
"CAREER ZONE RECRUITING LLP",
"BHANDERHATI B M INSTITUTION",
"CHIEF ENGINEER DEPT OF WATER SUPPLY SANITATION",
"MIDNAPORE MEDICAL COLLEGE & HOSPITAL",
"NBPGR NATIONAL BUREAU OF PLANT GENETIC RESOURCES",
"PHU SIRASMARG TAL GEORAI BEED",
"THREE ROCK",
"CHAHAT EXPORT",
"MAGRAHAT M A ORIENTAL INSTITUTION",
"DENSAY MARINE PRIVATE LIMITED",
"AAKANSHA ADVISORY SERVICES PVT LTD",
"ADITYA AVARTAN TECHNOLOGIES PRIVATE LIMITED",
"M M BRIGHT FUTURE SENIOR SECONDARY SCHOOL",
"MOHAMMAD ALI JOHAR URDU HIGH SCHOOL SEWLI",
"LUCKNOW MONTESSORI INTER COLLEGE",
"HIND ZINC SCHOOL",
"GEMS PUBLIC SCHOOL",
"CHAKER VERI F P SCHOOL",
"FENL IT SERVICES FINANCIAL ENGINES LLP",
"POA ENVIRONMENT NEW DELHI",
"ELECTRICAL DIV NO 1 HPPWD KASUMPTI",
"JAI PRAKASH NARAYAN SARVODAY VIDHYALAY OBRA",
"SP INSTRUMENT AND SERVICES",
"DEPARTMENT OF PLANNING ECONOMICS AND STATISTICS DIRECTORATE",
"GURUKULAM THE SCHOOL",
"DISTRICT TREASURY OFFICE YAVATMAL",
"ANTRANG HOSPITAL",
"INNOGENX",
"GOVT PRAVESHIKA SANSKRIT SCHOOL GOVINDPURA",
"PD COMM AUDIT JHARKHAND RANCHI",
"REGISTRAR CO OPERATIVE SOCIETIES HARYANA",
"IMP PRINT AND ALLIED SERVICES LLP",
"SAMARTH INTERNATIONAL SCHOOL",
"HP HOUSING AND URBAN DEVELOPMENT AUTHORITY DIVISION SHIMLA KASUMPTI",
"TAHSIL OFFICE UDGIR",
"OFFICE OF DIRECTOR WESTERN CIRCLE",
"VEDANTI DREAM HOMES",
"GURUKUL INTERNATIONAL SCHOOL",
"SUNSHINE PUBLIC SCHOOL",
"MEDICAL COLLEGE JAIPUR",
"UDAIPUR A D M UDAIPUR",
"BLOCK MEDICAL OFFICER SHAHPUR DISTT KANGRA HP",
"COLLECTORATE BULANDSHAHR",
"RANCHI MUNICIPAL CORPORATION",
"ADARSHA HIGH SCHOOL",
"SHRI DASHUBHAI A PATEL TECHNICAL HIGH SCHOOL KADI",
"SHAHEED GIRAJ SINGH GSSS CHIMRAWALI GAUD LAXMANGARH",
"SER KHARAGPUR WORKSHOP",
"JAIN GEMS INTERNATIONAL LLP",
"AMBE INFRAPROJECTS PRIVATE LIMITED",
"ADEPTPROS IT SOLUTIONS PRIVATE LIMITED",
"CENTRAL JAIL HOSPITAL",
"ASTT COMMISNER T W D RTM MADHYA PRADESH",
"RAGHABPUR PROJECTS LLP",
"TUBEWELL DIVISION II ALLAHABAD",
"11900 GSSS AAKELI A",
"NATIONAL INSTITUTE OF LABOUR ECONOMICS RESEARCH AND DEVELOPMENT",
"ASSISTANT ADMINISTRATIVE OFFICER O/O SPECIAL DG",
"SHREE GANESH LOGISTICS",
"RAMAKRISHNA MISSION ASHRAMA",
"CENTRE FOR TRAINING AND EMPLOYMENT OF PUNJAB YOUTH",
"ADARSH MILLS",
"GANNA VIKAS INTER COLLEGE",
"S E W R CIRCLE CWA",
"MAUD TEA ESTATE",
"PAO DEPARTMENT OF PUBLIC ENTERPRISES",
"D J ENTERPRISE",
"GURU GOVIND SINH GOVERNMENT HOSPITAL",
"KAVERI INTERNATIONAL SCHOOL",
"A D PROSECUTION ALLD RANGE",
"COLLECTOR SATNA",
"DEPARTMENT OF HOME ABHIYOJAN NIDESHALAY",
"DV2JS INNOVATION LLP",
"OFFICE OF JOINT DIRECTOR SUPERINTENDENT JA HOSPITAL GWALIOR MP",
"NAV JYOTI ¬†SR SEC SCHOOL LAKRIA",
"309770 MAHATMA GANDHI GOVT SCHOOL PRAGPURA",
"PEEO 21H",
"YASHWANTRAO CHAVAN MAHARASHTRA OPEN UNIVERSITY",
"RANI LAXMIBAI MADHYAMIK VIDYALAYA YASHWANTNAGAR NANDED",
"CANDOR NATIONAL PUBLIC SCHOOL",
"DALI PRIMARY SCHOOL¬†",
"OFFICE OF MUNICIPAL COUNCIL JIND",
"APEX TECHNO-PLAST PRIVATE LIMITED",
"HANCE ODC PRIVATE LIMITED",
"SYNERGY NATIONAL SCHOOL",
"HEAD MASTER GOVT ASHRAM SCHOOL JAMGAWHAN TAL KALMNURI",
"KIAAN INFRASTRUCTURE",
"AEN PHED NEWAI",
"TAHTAGAT VIDYALAYA KOTAMBA",
"SPARK ACCOUNTING SERVICES LLP",
"PAY4PRINTZ SERVICES PRIVATE LIMITED",
"RANI ENTERPRISE",
"GIFT INTERNATIONAL CENTER GANDHINAGAR",
"308433 GSS BARWALA MAKRANA",
"SHREE HOSPITAL",
"PUNJAB AND CHANDIGARH GEOSPATIAL DATA CENTRE CHANDIGARH",
"LITTLE ANGEL PUBLIC SCHOOL",
"SRI NAYANA EYE HOSPITAL PRIVATE LIMITED",
"B E O BANDA SAGAR MADHYA PRADESH SAGAR",
"DEV ASSOCIATES",
"IMS GHAZIABAD",
"AVSAR HR SERVICES",
"RADHAKRISHAN HOSPITAL",
"GOVT SSS ABHAYPURA",
"SUBH LAXMI ENGINEERING WORKS",
"ANSH FOUNDATION",
"CHHATTISGARH COMMERCIAL TAX DEPARTMENT",
"ARMY INSTITUTE OF HOTEL MANAGEMENT & CATERING TECHNOLOGY",
"MOTHERSON AUTOMOTIVE TECHNOLOGIES AND ENGINEERING",
"V O CHIDAMBARAM COLLEGE",
"AABHAR MULTISPECIALITY HOSPITAL",
"BAKHRAHAT F P SCHOOL",
"ACCOUNTANT GENERAL A AND E HIMACHAL PRADESH SHIMLA",
"LITTLE TRICKS MEDIA LLP",
"ADMIRABLE PRIDE LLP",
"308543 GSSS MAKRANA",
"BILLS AND PAYMENT BRANCH BANDP LOK SABHA SECTT NEW DELHI",
"HOS STATE CONSUMER DISPUTES REDRESSAL COMMISSION",
"ATHPUR BALIKA VIDYALAYA",
"MALANGAPARA KCB INSTITUTION",
"NATIONAL HIGHWAYS AND INFRASTRUCTURE DEVELOPMENT CORPORATION",
"PEEO KANKRWA",
"SECURDEN TECHNOLOGIES PRIVATE LIMITED",
"WE 45 SOLUTIONS PRIVATE LIMITED",
"UTTAM BLASTECH PRIVATE LIMITED",
"FLEEK MOTORS PRIVATE LIMITED",
"GSSS AALISAR GOVINDGARH",
"LIGHT HOUSE INTERNATIONAL SCHOOL",
"GOVT BOYS SR SEC SCHOOL TRILOKPURI BLOCK 27",
"PACIFIC ACADEMY OF HIGHER EDUCATION & RESEARCH SOCIETY",
"DIGITAL CONCEPTS",
"STUDIO 33",
"UTAVAD PRIMARY SCHOOL TA KUKARMUNDA",
"AK ENTERPRISES",
"OFFICE OF JANPAD PANCHAYAT BERASIA DIST BHOPAL M.P",
"COURT OF CHIEF JUDICIAL MAGISTRATE ESPLANADE MUMBAI",
"312030 GSSS 6 JKM",
"K D BUILDING SERVICES LLP",
"WMF'S VILLO POONAWALLA MEMORIAL HOSPITAL",
"GOVT OF JHARKHAND DIRECTORATE OF MUNICIPAL ADMINIS PROJECT BUILDING",
"ST ANTHONYS BOYS HR PRY SCHOOL",
"U P STATE INDUSTRIAL DEVELOPMENT CORPORATION LIMITED",
"H M M S CHAINPUR DUMRI III",
"ZPPS VASANTNAGAR MANGRUL NO 1",
"ZILHA PARISHAD SCHOOL AMBABARIPADA",
"PRATIBHA NIKETAN JUNIOR COLLEGE NANDED",
"SHREENATH TRADELINKS",
"ANZA SPECIAL SCHOOL FOR MENTALLY HANDICAPPED",
"DISTRICT EXCISE OFFICER",
"THE GREEN APPLE (HOOPSTAR ACADEMY)",
"HEALTH BUDDY DUMDUMA MEDICAL",
"ST MARYS COLLEGE OF PHARMACY",
"ASTT DIRECTOR VETY SERVICE RTM",
"KALLAPPANNA AWADE JAWAHAR SHETKARI SAHAKARI SAKHAR KARKHANA LIMITED",
"JNJ TECHNOLOGIES & SERVICES LLP",
"PR GSSS SAKRI",
"SHREEYASH PRATISHTHAN SHREEYASH COLLEGE OF ENGINEERING & TECHNOLOGY AURANGABAD",
"SANGHRHA ADHISTATAN BHANPUR BASTI",
"LORENZ SNACKS INDIA PRIVATE LIMITED",
"TOSHNIWAL ENGINEERING & SYSTEMS PRIVATE LIMITED",
"FTC SOLAR INDIA PRIVATE LIMITED",
"CHARLIE FOXTROT AVIATION SERVICES PRIVATE LIMITED",
"WARREN REMEDIES PRIVATE LIMITED",
"SYNERGIC SOFTEK SOLUTIONS PRIVATE LIMITED",
"AURANGABAD MATHADHI AND UNPROTECTED LABOUR BOARD",
"SRMIST FACULTY OF SCIENCE AND HUMANITIES",
"STALWART HOMESTYLE",
"DEO EXCISE DHAR",
"ANVIL PROJECTS LLP",
"SR ANNE S PREP SCHOOL",
"ZPPS PARITEWADI PARITEWADI",
"CHANAKYA VIDYASHRAM SENIOR SECONDARY SCHOOL",
"BHUERA CHHORA D N HIGH SCHOOL",
"C S M S S POLYTECHNIC COLLEGE",
"THE ACADEMY OF ENGINEERING AND MANAGEMENT TRUST",
"DEHRADUN DISTRICT COOPERATIVE BANK",
"RATNA PRABHA NURSING INSTITUTE",
"AGE VENURES INDIA",
"DCM TEXTILES",
"REGIONAL DIRECTORATE OF SKILL DEVELOPMENT & ENTREPRENEURSHIP (RDSDE)",
"DISTRICT GAZETIER",
"SHREE KRISHNA DEGREE COLLEGE (6U)",
"DEEN DAYAL UPADHYAY AGRICULTURE COLLEGE",
"MG MOTORS",
"EMPLOYEES STATE INSURANCE HEALTH CARE",
"DIRECTOR RURAL DEVELOPMENT & PANCHAYATS",
"DELHI NAGAR NIGAM",
"BEEKU EXPORT",
"NAVNEET",
"PRIME SUPER SPECIALITY HOSPITAL REWARI",
"GYAN GANGA GLOBAL SCHOOL",
"J D FREIGHT SOLUTION",
"GOVERNMENT PRIMARY SCHOOL MUSAIPUR",
"DISTRICT AND SESSION JUDGE MANSA",
"SRI BALAJI VENKATESHWARA SWAMY TEMPLE",
"TEXPORT SYNDICATE PRIVATE LIMITED",
"CLAIMPOWER INDIA PRIVATE LIMITED",
"CHANGE NETWORKS PRIVATE LIMITED",
"MYJOBCART SOFTWARE PRIVATE LIMITED",
"ANA DATA CONSULTING PRIVATE LIMITED",
"MRIDI LOGIC PRIVATE LIMITED",
"DONA SOFTWARE SOLUTIONS PRIVATE LIMITED",
"ATRIBS METSCON IT CONSULTING PRIVATE LIMITED",
"PRADESIK CO-OPERATIVE DAIRY FEDRATION LTD",
"KARYALAYA CHINHIT MADHYA VIDHYALAY TURKOLIYA",
"GOVERNMENT BOYS SENIOR SECONDARY SCHOOL BADARPUR BADARPUR TAJPUR PAHARI,ND-44",
"DAYANAND PUBLIC SCHOOL",
"STATE GOVT NAGER NIGAM",
"WEST BENGAL BOARD OF SECONDARY EDUCATION",
"STRUGGLE LIFE SOLUTION PRIVATE LIMITED",
"ASHTAVINAYAK HOSPITAL AND ICU",
"HOLY CROSS CONVENT SENIOR SECONDARY SCHOOL",
"UN MEHTA INST OF CARDIOLOGY & RESEARCH CENTRE",
"BHARTIYA INDUSTRIES",
"GEO MARINE SOLUTIONS PRIVATE LIMITED",
"DOHA BANK QPSC",
"EXECUTIVE ENGINEER CGWB DIV XI JODHPUR",
"BLOCK CHIEF MEDICAL OFFICER GOVINDGARH JAIPUR",
"PRINCIPAL PANDU COLLEGE PANDU COLLEGE PANDU GUWAHATI",
"VERSATILE COMMERCE LLP",
"KOTA DCF KOTA",
"ACTIVE KID S INTERNATIONAL ENGLISH SCHOOL",
"DISTRICT AND SESSION JUDGE LUDHIANA",
"AC CTO CIRCLE D UDAIPUR",
"PUNJAB LAND RECORDS SOCIETY PUNJAB GOVERNMENT",
"NAVKAR VIDYA MANDIR SR SEC SCHOOL",
"TAHSILDAR SADAR GORAKHPUR LEKHPAL ADHISTHAN",
"DIRECTOR HORTICULTURE DEPARTMENT",
"OPEN DOOR EDUCATION",
"CHIEF MEDICAL & HEALTH OFFICER JAIPUR I",
"SHREEMATI S B GARDI VIDHYALAY GUNDIYALA",
"TALWAR AND TALWAR CONSULTANTS PVT LTD",
"DESHBANDHU COLLEGE PAYROLL",
"RAJE SHIVAJI VIDYALAYA NANDURBAR",
"TAHASILDAR SOHELLA",
"RAJKOT DISTRICT EDUCATION COMMITY OPERATED PRIMARY SCHOOL",
"SLEEN INDIA BIZVENTURE PRIVATE LIMITED",
"HUMRES RECRUITMENT SERVICES INDIA PRIVATE LIMITED",
"CELOSIA PHARMACEUTICAL PRIVATE LIMITED",
"AMETEK BUILDTECH INDIA PRIVATE LIMITED",
"MAHAGIT AGRO PRIVATE LIMITED",
"CENTUM CONTROLS PRIVATE LIMITED",
"CHOPRA HIGH SCHOOL",
"POCT SERVICES",
"HEVLON COSMETICS",
"REGENTIA CENTIRAL HESTIA DAHEJ",
"JHARKHAND STATE POLLUTION CONTROL BOARD",
"SHREE BHAKTI VIDHYALAY HALVAD",
"MAAN VANKAL MALANI JAN KALYAN AVM SHIKSHAN SANSTHAN",
"GOVT OF JHARKHAND D E O",
"KAI RASIKA MAHAVIDYALAYA DEONI",
"STAR PEST CONTROL SERVICES",
"GSSS UNDAKAH BARMER",
"AVANI SAANVI VIDYAMANDIR",
"DR B N BOSE S D HOSPITAL BKP",
"GURU TEG BAHADUR HOSPITAL",
"ST JOSEPH GLOBAL SCHOOL",
"ACCURATE GROUP OF INSTITUTIONS",
"DHANESHWARI WOMENS COLLEGE OF EDUCATION (B.ED)",
"JAWAHAR LAL CONTRACTOR",
"SWASTHI FARMS",
"MEDICAL SUPERINTENDENT CIVIL HOSPITAL AHMEDABAD",
"HARMET INDUSTRIES",
"BHANGAR II BLOCK DEVELOPMENT OFFICE",
"REGIONAL OILSEEDS GROWERS CO- OP SOCIETIES UNION LIMITED RAICHUR",
"BISHOP JHONSON SCHOOL & COLLEGE ALLD",
"NARHAR KURUNDKAR HIGH SCHOOL KAUTHA NANDED",
"GSSS KALAKH",
"IMPERIAL VENTURES PRIVATE LIMITED",
"STAUNCHSYS IT SERVICES PRIVATE LIMITED",
"SIDI INDIA PACK PRIVATE LIMITED",
"BUSON DIGITAL SERVICES INDIA PRIVATE LIMITED",
"SWAMI VIVEKANAND COLLEGE OF ENGINEERING",
"S & SLIGHTING",
"WCR",
"PRINCIPAL JADUNATH COLLEGE RASALPUR BALASORE",
"SHREE COMMERCIAL INTERIORS PRIVATE LIMITED",
"ZILA KARYAKARAM ADHIKARI BARABANKI BAL VIKAS",
"ACQUIESCENT SUPPORT SECURITY SERVICES LLP",
"BENGAL ULTIMATE RESORTS LLP",
"KALYANGARH VIDYAMANDIR",
"NEUBERG SUPRATECH",
"SCHOOL EDUCATION DEPARTMENT BLOCK EDUCATION OFFICER GUNDERDEHI",
"INVICTUS INTERNATIONAL SCHOOL",
"RAMAWAT INDUSTRIES LLP",
"MANAGEMENT CONSUTANCY E SERVICE",
"RAJ MS GOVINDPUR MD",
"MAYURAKSHI REVENUE DIVISION NO-I",
"MADHYA PRADESH BUILDING DEVELOPMENT CORPORATION LIMITED",
"EX ENGR SOLAPUR IRRIGATION DIVISION",
"MUNICIPAL COUNCIL DARYAPUR",
"MATHURAPUR ARYA VIDYAPITH HS",
"SUPERINTENDENT PAY AND PROVIDENT FUND UNIT PRIMARY",
"SRI VINSUREMAX ENTERPRISES LLP",
"NABAGRAM HIGH SCHOOL",
"THE ODISHA STATE BAR COUNCIL",
"B E O ZEERAPUR RAJGARH MADHYA PRADESH RAJGARH",
"B E O BIAORA RAJGARH MADHYA PRADESH RAJGARH",
"B E O SARANGPUR RAJGARH MADHYA PRADESH RAJGARH",
"B E O KHILCHIPUR RAJGARH MADHYA PRADESH RAJGARH",
"SUB DIVISIONAL VETERINARY OFFICER NILGIRI",
"RAJPUTANA PG COLLEGE KOTPUTLI",
"EMERALD SOLUTIONS",
"AKRUTHI APPARREL",
"NORSTELLA",
"AXOM SARBA SIKSHA ABHIYAN MISSION",
"ST MARK'S HIGHER SECONDARY SCHOOL",
"CJSS TECHNOLOGIES PRIVATE LIMITED",
"MYFRESH RETAILS PRIVATE LIMITED",
"EXTEND INFORMATION SYSTEMS PRIVATE LIMITED",
"MOTHER TERESA WOMEN'S UNIVERSITY",
"GSSS SEPUR SARADA",
"GOVT MIDDLE SCHOOL RAIDASKA",
"GURU KASHI UNIVERSITY",
"MAHARAJ SINGH COLLEGE SAHARANPUR",
"JOINT DIRECTOR OF HEALTH SERVICES DOLMUKH CHARIALI",
"DIRECTOR OF TECHNICAL EDUCATION",
"ADGAON HIGH SCHOOL ADGAON CHOPDA",
"TEHSILDAR OFFICE HARSOOD",
"CLEO CONSULTING",
"THE ROYAL RETREAT RESORT AND SPA UDAIPUR",
"OFFICE OF THE SUPERINTENDENT GOVT BLIND SCHOOL",
"THE CITIZEN CO-OPERATIVE SOCIETY LTD",
"PRINCIPAL PG COLLAGE CHHINDWARA",
"LDRP INSTITUTE OF TECHNOLOGY & RESEARCH-GANDHINAGAR",
"ZILA SHIKSHA KENDRA",
"K L UNIVERSITY",
"FLEXBOOK INC",
"ESIS DISPENSARY UZANBAZAR SENAPATI ROAD GUWAHATI 03",
"RAJKIYA M S T TANGER",
"SOMNIATE SOLUTIONS",
"D D V S CHHATARPUR MADHYA PRADESH CHHATARPUR",
"DIRECTORATE OF RAPESEED MUSTARD RESEARCH",
"GOVERNMENT MEDICAL COLLEGE AND HOSPITAL AURANGABAD",
"ASSISTANT DIRECTOR PROSECUTION JODHPUR",
"DY DIR PANCHAYAT AND SOCIAL WELLFAIR TKG MADHYA PRADESH TIKAMGARH",
"BALI DHANAMANI MODEL HIGH SCHOOL HS",
"ZILA SHIKSHA AND PRISHIKSHAN SANSTHAN TRAINING CENTER BARABANKI",
"APEX CLUB OF BALLY",
"GUPTA COMPUTER CARE",
"P GOVT DEGREE COLLEGE SAGAR MADHYA PRADESH SAGAR",
"ADDITIONAL DIRECTOR OF HEALTH SERVICES",
"GSSS SANGAWAS",
"HELIVERSE TECHNOLOGIES",
"PERFECT AIR",
"D KUMAR AND COMPANY",
"B E O CHACHODA MADHYA PRADESH GUNA",
"BHAUSAHEB BAJIRAO ONKAR PATIL MADHYMIK VIDYALAY TARKHEDA",
"SHANKAR HIGH SCHOOL GHATNANDUR",
"KEDARNATH MAHILA INTER COLLEGE BADAUN",
"SECURE GUARD SECURITY AND MANPOWER SERVICES",
"RAJKIYA SARVODAYA KANYA VIDYALAYA",
"GSSS INDPUR LAXMANGARH",
"HOME FOR MALE BEGGERS ABLED AND DISABLED DSW OFFICE OF THE DDO HOO HMB A&D LAMPUR NARELA DELHI",
"GSSS CHOPASNI HOUSING BOARD SECOND PULIYA JODHPUR",
"INFINITY PVT I T I",
"PEEPAL PRODIGY SCHOOL",
"MK BUILDERS AND DEVELOPERS",
"GOVT COLLEGE JHUNJHUNU",
"PACIFIC ACADEMY OF HIGHER EDUCATION & RESEARCH UNIVERSITY",
"NATIONAL B ED COLLEGE",
"DISTT ORGANISER TRIBAL WELFARE ASHOKNAGAR MADHYA PRADESH ASHOKNAGAR",
"B E O ASHOKNAGAR MADHYA PRADESH ASHOKNAGAR",
"JILA SAHAKARI KENDRIYA BANK MYDT GUNA",
"C4 SECURE PLUS",
"CEEKAY ASSOCIATES",
"SCALE PLUS HEALTHCARE RCM",
"UNIVERSITY ENGINEER (GOVERNMENT OF RAJASTHAN)",
"MUDRA INSTITUTE OF COMMUNICATIONS",
"GSSS UNDRA",
"ST SAVIOURS HIGH SCHOOL AND JUNIOR COLLEGE",
"OFFICE OF THE SUB INSPECTOR SANSKRIT SCHOOL MEERUT AREA MEERUT",
"MART2GLOBAL",
"CHERUBS PRESCHOOL (THE LIVING TREE BREAD)",
"PFLANZE PHARMA PRIVATE LIMITED",
"TRUE BUILD ENGINEERING AND CONSTRUCTION LLP",
"SARVODYA SR SEC SCHOOL",
"PANCHAYATS AND RURAL DEVELOPMENT DEPARTMENT",
"SNP SHIP MANAGEMENT PRIVATE LIMITED",
"REGIONAL DENTAL COLLEGE ( GOVT OF ASSAM )",
"SMT SARASWATIBAI NISTANE PRATHAMIK SHADA",
"BLOCK HEALTH OFFICER VALOD",
"SEVA SAHKARI SAMITI MARYADIT",
"ALBERO DESIGN STUDIO LLP",
"HARI OM SHIV OM PUBLIC SCHOOL",
"DISTRICT INFORMATION AND PUBLIC RELATIONS OFFICE MUKTSAR SAHIB",
"BLOCK EDUCATION OFFICER REMUNA",
"OFFICE OF THE DY DIRECTOR VETY SERVICE DISTT JANJGIR-CHAMPA",
"ASSTT DIRECTOR (EXT)",
"MINISTRY OF DEFENCE DIRECTORATE OF ORDNANCE¬†KOLKATA",
"GOVT CO-ED SR SEC SCHOOL",
"LADY SUPERINTEMDENT SCHOOL OF PUBLIC HEALTH",
"MADHYAMIK VIDHYALAY",
"SARASWATI HIGHSCHOOL",
"VIJAYA SE SEC SCHOOL",
"CIVIL SURGON BOKARO",
"THE SHRIRAM MILLENNIUM SCHOOL",
"BMO MAHANKAL",
"P D TURAKHIA JR COLLEGE",
"CEDRES INDUSTRIES INDIA PRIVATE LIMITED",
"SPECIALCHEM INDIA PRIVATE LIMITED",
"UNIVERSAL ESTERS LIMITED",
"ASST INSPECTOR GENERAL OF REGISTRATION OFFICE SURAT",
"MADANGOPAL AGRAWAL HIGH SCHOOL",
"SRI SAI EYE HOSPITAL",
"8465 JOINT DIRECTOR AGRI EXT Z P PALI",
"MINISTRY OF PANCHAYAT AND RURAL DEPARTMENT",
"MPF INTERNATIONAL SCHOOL",
"ALIGARH PUBLIC SCHOOL",
"GOVERNMENT TRANSPORT SERVICE ( HOME DEPARTMENT )",
"BHAGIRATHIBAI PRIMARY & HIGH SCHOOL",
"C M O PARIWARKALYAN OFFICE SONEBHADRA",
"AHMEDNAGAR JR COLLEGE AHMEDNAGAR",
"M P HOUSING & INFRASTRUCTURE DEVELOPMENT BOARD",
"ADINARAYAN MEDICARE PRIVATE LIMITED",
"B E O AARON GUNA MADHYA PRADESH GUNA",
"POSITRON MULTISPECIALITY & CANCER HOSPITAL",
"GODREJ AMITIS DEVELOPERS LLP",
"PRIDE PURPLE INFRASTRUCTURE",
"PAO SSI MUMBAI",
"OASIS BEVERAGES INCORPORATION",
"SARAF THE JEWELLER",
"THE PUNDRI PRIMARY AGRICULTURE CO-OP SOCIETY LTD. PUNDRI",
"BHAGYA TRADERS",
"JILLA PANCHAYAT AYURVEDIC SHAKHA VALSAD",
"PANDIT MADAN MOHAN MALVIYA HOSPITAL",
"18914 DISTRICT EXCISE OFFICER SIKAR",
"PUNJAB HEALTH SYSTEMS CORPORATION",
"PRONTO INTERNATIONAL",
"KARANGA GIRL'S HIGHER SECONDARY SCHOOL",
"NUTAN MARATHI VIDYALAYA ICHALKARANJI",
"RAMGANGA AUTO LLP",
"MY TECH FOUNDATION OF REVOLUTION",
"TEHSILDAR GWALIOR",
"MOTHER'S PRIDE SCHOOL",
"E S I DISPENSARY NO 8 JAIPUR",
"UCCK MATRIC HR SEC SCHOOL",
"H K DESIGNS (INDIA) LLP",
"HIGH SCHOOL SHIRUR SHIRUR",
"SHITAL VACUUM TREAT PRIVATE LIMITED",
"C E O JANPAD PANCHAYAT RAGHOGARH MADHYA PRADESH GUNA",
"CTO TREASURY OFFICE BASTI",
"QENIT SOLUTIONS PRIVATE LIMITED",
"MUSCLEPRO SECURITIES SERVICES LLP",
"ASHRAM SHALA KHAMBHALA",
"EMPERIUM DEVELOPERS PRIVATE LIMITED",
"SJK CONSULTING PRIVATE LIMITED",
"NORTH RAILWAY",
"ARPIT MULTISPECIALITY HOSPITAL & LAPROSCOPY CENTRE",
"R B SHAH MAHAVIR SUPER SPECIALITY HOSPITAL SURAT",
"REVENUE BRANCH GARIADHAR TALUKA PANCHAYAT",
"S L BAWA DAV COLLEGE BATALA",
"A H BILIMORIA & CO",
"GOVT GIRLS DEGREE COLLEGE SAIYADRAJA CHANDAULI",
"ADMN OFFICER FOR C M H O BHOPAL",
"MAHA INFOTECH PRIVATE LIMITED",
"100446 GSSS PICHOLIYA",
"G D PUBLIC SENIOR SECONDARY SCHOOL",
"SARDAR PATEL POSTGRADUATE INSTITUTE OF DENTAL AND MEDICAL INSTITUTE",
"DISTRICT EDUCATION COMMITTEE PANCHMAHAL",
"ARTHERMED PHARMACEUTICALS",
"MEDICAL SUPERINTENDENT REGIONAL MENTAL HOSPITAL NAGPUR",
"ANGLO URDO HIGH SCHOOL BHADGAON",
"SHIVAM HOSPTAL GESTRO",
"EKATMIK BALVIKAS SEVA YOJANA PURKALP",
"TS DIVISION HVPNL HISAR",
"DIRECTOR INFORMATION AND PUBLIC RELATIONS",
"LUMINOGURU PRIVATE LIMITED",
"AEN PHED CITY SUB DIV VII SOUTH JAIPUR",
"DEPARTMENT OF CANE DEVELOPMENT CANE DEVELOPMENT AND SUGAR INDUSTRY OFFICE OF DCO JAUNPUR",
"SRI RAMAKRISHNA MISSION VIDYALAYA COLLEGE OF ARTS AND SCIENCE",
"PRINCIPAL MEDICAL OFFICER DAUSA",
"ZPPS CHORMALEWASTI",
"MAHARASHTRA RAJYA GRAMIN JIVANJYOTI ABHIYAN",
"SRI SANATAN DHARAM INTER COLLEGE GHAZIABAD",
"DADASAHEB GULABRAO BORSE AGRI VIDYALAYA KALAMBU",
"ASO KINNAUR AND SHIMLA",
"ST JOSEPH S CONVENT SCHOOL",
"CLOUDMOTIV IT TECHNOLOGIES PRIVATE LIMITED",
"M N COLLEGE VISNAGAR MEHSANA",
"MADHYAMIK SIKSHA PARISHAD KSHETRIYA KARYALYA VNS",
"TAXATION PUNJAB",
"COMMUNITY HEALTH CENTER KHANNAUR DIST ROHTAK",
"UNIVERSITY OF HYDERABAD",
"ROSSELL TECHSYS LIMITED",
"EGES ENVIRO SOLUTIONS PRIVATE LIMITED",
"AZURO STAFFING SOLUTIONS PRIVATE LIMITED",
"THINK AI INDIA CONSULTING PRIVATE LIMITED",
"HABITAT FOR HUMANITY INDIA TRUST",
"GSSS MOULASAR",
"KISHAN LMV BELADE SHUKAL",
"5156 MAHATMA GANDHI GOVT SCHOOL GUHDAPONKH",
"BANGALORE CLUB",
"SURAKSHA SECURITY SERVICES",
"DEPUTY INSPECTOR OF SCHOOL MAJULI KAMALABARI",
"IT NOW TECHNOLOGIES",
"NUAPAL B PRIMARY SCHOOL",
"PEOPLE FOR ACTION",
"RAJHANS URF BALGANDHARV VIDYALAYA NAGTHANE",
"INDORE NAGAR NIGAM",
"RADHIKA SUPER SPECIALITY AND ADVANCED TRAUMA CENTRE",
"CIVIL HOSPITAL RATNAGIRI",
"C'ESTLAVIE PHARMACEUTICALS PRIVATE LIMITED",
"SVM INC",
"GOVERNMENT OF WEST BENGAL MAHISHADAL RAJ COLLEGE",
"DEPARTMENT OF CONSUMER PROTECTION & WEIGHTS, MEASURES LEGAL METROLOGY DEPARTMENT",
"MANKAR INSTITUTE OF EDUCATION AND RESEARCH AND PHARMACY SCIENCE",
"M C S M LTD",
"GPS JAMSHER B",
"THE KUPPAM RURAL ELECTRIC CO OP SOCIETY LTD",
"NRRI NATIONAL RICE RESEARCH INSTITUTE",
"COTTAGE HOSPITAL ACHALPUR",
"BANDOBAST ADHIKARI CHAKBANDI AGRA",
"M/S CITY FOOTKRAFT",
"TECHNOBLAST MINING CORPORATION",
"ADDARO",
"ECR SONPUR DIVISION",
"A C SCHOOL JALAHALLI BANGALORE",
"DR AMBEDKAR COLLEGE OF ARTS AND COMMERCE",
"SCHOOL OF EMINENCE BARIWALA MUKTSAR",
"S K CONTRUCTION CO",
"GSS DHANI GUMAN SINGH",
"JILA PARISHAD JAIPUR",
"BLOCK EDUCATION OFFICER BHOGRAI",
"ST PAULS ACADEMY",
"SHIFT BOOLEAN",
"KOURANI OVERSEAS",
"B E O RADHOGARH¬†MADHYA PRADESH GUNA",
"MAJULI DISTRICT TERRITORIAL ROAD DIVISION PWD GARMUR MAJULI",
"HEALTH PRIDE",
"BROADIFI TECH PRIVATE LIMITED",
"BITCRAFTSMEN TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"POLYGON ENTERPRISES PRIVATE LIMITED",
"GBH ELECTRICALS PRIVATE LIMITED",
"CBEO RAMGARH",
"MARGO INDUSTRIES",
"ST JOSEPH COLLEGE NAINITAL",
"M C AJMER 100300",
"EAGLE ROADLINES PRIVATE LIMITED",
"VIN BYTES TECHNOLOGIES PRIVATE LIMITED",
"MOTLEY LAMINATES PRIVATE LIMITED",
"K.M IT ESERVICES PRIVATE LIMITED",
"KULYA ABINAS CHANDRA MEMORIAL HIGH SCHOOL",
"GIRLS HIGH SCHOOL & COLLEGE",
"DEW HOSPITALITY SERVICES",
"MATOSHRI MINATAI THAKARE PRIMARY SCHOOL",
"L S RAHEJA SCHOOL OF ARCHITECTURE",
"POSITRON SUPER SPECIALITY & CANCER HOSPITAL",
"310137 COMMUNITY HEALTH CENTRE PAOTA JAIPUR",
"GOVT MILK SCHEME PARBHANI",
"YUVODAYA HIGHER SECONDARY SCHOOL",
"E E TEMP DIV P W D SAHIYA",
"WCR KOTA DIVISION",
"ALLIANCE MANPOWER SERVICES",
"LASTMILE LOGI SOLUTIONS LLP",
"ST HELENA S SCHOOL PUNE",
"VAZ ELEVATORS AND ESCALATORS PRIVATE LIMITED",
"PB WATER RESOURCES MANAGEMENT AND DEVELOPMENT CORP",
"SPONSORED RESEARCH & INDUSTRIAL CONSULTANCY OFFICE (SRIC OFFICE )",
"GANGA INTERNATIONAL SCHOOL",
"RAJBALLAVPUR HIGH SCHOOL",
"PHC CHIMTHANE SINDHAKHEDA",
"MOTHER TERESA HIGHER SECONDARY SCHOOL",
"TREASURY OFFICE JAIPUR",
"BLOCK CHIEF MEDICAL OFFICER KISHANGANJ BARAN",
"LITTLE ROSE ENGLISH SCHOOL",
"BLOCK EDUCATION OFFICER SIMULIA",
"DISTRICT EDUCATION OFFICER BALANGIR",
"JOYSHREE ASSAM INDUSTRIES",
"INDIAN MODEL SCHOOL CBSE",
"GMS FAIJGARH",
"GSSS KADUNI SALUMBER",
"PHULANI HIGH SCHOOL PO KARKICHUK",
"BABA ELECTROMECH ENGINEERS PRIVATE LIMITED",
"SECURITY FIRE AND SAFETY SERVICES PRIVATE LIMITED",
"MANMANDIR JEWELLERS & FOREX PRIVATE LIMITED",
"TORGEM PHARMACEUTICALS PRIVATE LIMITED",
"SPIDER INDUSTRIAL SECURITY SERVICES PRIVATE LIMITED",
"TRIVENI MEDICHEM PRIVATE LIMITED",
"SPORTWALK SPORTS SOLUTIONS PRIVATE LIMITED",
"SHREE OM SIDDHIVINAYAK MULTI STATE CO OPERATIVE CREDIT SOCIETY LIMITED",
"GOVERNMENT SECRETARIAT",
"SOFTUDE INFOTECH PRIVATE LIMITED",
"VISIONCARE SERVICES PRIVATE LIMITED",
"PIPLAPANI PRIMARY SCHOOL TA SAGBARA",
"DARSHAN UNIVERSITY",
"DISTRICT AND SESSIONS JUDGE JODHPUR METROPOLITAN",
"D C B GIRLS HIGH SCHOOL PO JORHAT",
"SAMY AIRCONDITIONING AND REFRIGERATION",
"MEHRANGRAH MUSEUM TRUST",
"HIDAN FACTORING PRIVATE LIMITED",
"WHITE APPLE LLP",
"STUDIO SLEEVESUP PRIVATE LIMITED",
"SHRI RANG NAVCHETAN MAHILA ARTS COLLEGE VALIA",
"RAI UNIVERSITY",
"AMFICO COATINGS PRIVATE LIMITED",
"BC JINDAL FOUNDATION",
"TEXAS MULTISPECIALITY HOSPITAL",
"GOVT OF JHARKHAND G M S ARKI",
"EE NARORA DN LGC ALIGARH",
"BHIMASHANKAR AYURVEDIK COLLEGE",
"GPS BHOLAPUR",
"ST JOSEPH SCHOOL AMBALA CITY",
"ADMINISTRATIVE OFFICER NCC (HEAD QTRS)",
"SWASTIK BRIDGE & ROAD CONTRACT LLP",
"CMS TB HOSPITAL GETHIA",
"CIVIL CUM CRIMINAL COURT TALODA",
"ST FRANCIS CONVENT INTER COLLEGE",
"SUPERCHEM NUTRI FORMULATIONS",
"B E O NALCHHA MADHYA PRADESH DHAR",
"GUJARAT URBAN HEALTH PROJECT",
"S I W S ENGLISH PRIMARY SCHOOL MATUNGA",
"CHEEMA HOSPITAL & TRAUMA CENTRE",
"SAGILITY INDIA LIMITED",
"SERAMPORE MALINA LAHIRI BOYS ACADEMY HIGH SCHOOL",
"COMMUNITY HEALTH CENTRE DANPUR",
"PUSHKAR & CO LLP",
"DIST PROGRAM OFFICER DHAR",
"HON SHRI ANNASAHEB DANGE ARTS COMMERCE AND SCIENCE COLLEGE HATKANANGALE",
"KAMAKSHADEVI VIDYALAYA KINGAON RAJA",
"COUNCIL OF HANDICRAFTS DEVELOPMENT CORPORATIONS",
"KANUMURI HOSPITALS",
"SWAMI VIVEKANANDA DEGREE AND PG COLLEGE",
"GOVT OF JHARKHAND GIRLS M/S SIMARIA",
"NETAJI SUBHAS CHANDRA BOSE INSTITUTE OF PHARMACY",
"S R S AYURVEDIC MEICAL COLLEGE & HOSPITAL",
"DIGITAL ACADEMY 360",
"B E O KOLARAS MADHYA PRADESH SHIVPURI",
"B E O ESSAGARH¬† MADHYA PRADESH ASHOKNAGAR",
"ANSIMAP TECHNOLOGIES PRIVATE LIMITED",
"QUICKBOOKER TRAVELS PRIVATE LIMITED",
"RAMESH WATCH COMPANY PRIVATE LIMITED",
"LOGKRAFT INDIA PRIVATE LIMITED",
"VAJRESHWARI ENTERPRISES",
"DEPUTY COMMISSIONER OF COMMERCIAL TAXES",
"APTIA GROUP",
"INSPIRIA KNOWLEDGE CAMPUS (J P SAHU FOUNDATION)",
"WATER RESOURCES DEPARTMENT OFFICE OF THE EXECUTIVE ENGINEER",
"EXE ENGINEER MIDDLE GANGA DIVISION 1 CWC LUCKNOW",
"OPEN DHI PRIVATE LIMITED",
"DEPARTMENT OF VOCATIONAL EDUCATION SKILL DEVELOPMENT AND ENTREPRENEURSHIP",
"MARVEL INTERNATIONAL",
"ZILLA PARISHAD DHULE",
"NETAJI SUBHASHCHANDRA JR COLLAGE SUNDARNAGAR",
"MAP IT SOLUTIONS INDIA",
"SHRI SIDDI VINAYAK MEDICAL COLLEGE AND HOSPITAL SAMBHAL",
"RAJKIYA UCCHTAR MADHYAMIK VIDHYALAY AKOS",
"INFOMERICS INDIA FOUNDATION",
"FINANCE AND BUDGET OFFICER",
"RAHAT MEDICARE",
"UTTAR DURGAPUR FP",
"JILA PARISHAD BARNALA",
"DY COMM UDAIPUR",
"SOCIAL CLOUD VENTURES PRIVATE LIMITED",
"MAHARAJA AGRASEN INSTITUTE OF MEDICAL RESEARCH & EDUCATION",
"THE RANGIAN MULTIPURPOSE CO-OPERATIVE AGRICULTURAL SERVICE SOCIETY RANGIAN",
"SRI ANARDEVI KHANDELWAL MAHILA POLYTECHNIC",
"VEER BAHADUR SINGH PURVANCHAL UNIVERSITY",
"CMC MULTISPECIALITY HOSPITAL",
"COMMISSIONER AND MAYOR NAGAR NIGAM JAIPUR HERITAGE",
"HYDERABAD EYE INSTITUTE",
"B E O BADARWAAS MADHYA PRADESH SHIVPURI",
"KMC MEDICAL COLLEGE AND HOSPITAL",
"SANGITA HIGH SCHOOL",
"GOVERNMENT OF CHHATTISGARH TRIBAL DEVELOPMENT",
"GSSSS PAPRA",
"Z P PRI SCHOOL BOPAPUR",
"DR D Y PATIL VIDYAPEETH PUNE",
"DEPARTMENT OF SAD SECRETARIAT ADMINISTRATION DEPARTMENT",
"MONTESSORI ELITE E M SCHOOL",
"M E S ABASAHEB GARWARE COLLEGE",
"CIVIL COURT SENIOR DIVISION SOLAPUR",
"GHATESWAR BK VIDYAMANDIR HS",
"INDRA GANESAN COLLEGE OF ENGINEERING",
"HAND IN HAND ACADEMY FOR SOCIAL ENTREPRENEURSHIP",
"PUBLIC WORKS CIRCLE OSMANABAD",
"JMS INFRACITY LLP",
"SIGNAL EXPERT GLOBAL LLP",
"VIDYANIKETAN SCHOOL",
"JIVANPRABHODHINI MADHYAMIK VIDYALAYA NAGEWADI",
"EXCELLENT PRINT",
"ADAR MARATHI PRATHMIK SHALA MULEGAON ROAD SOLAPUR",
"YASHVANT HIGH SCHOOL WARD NO 30",
"GARUD ZEP ACADEMY SHIKRAPUR",
"PANCHAYAT SAMITI LATUR",
"GSSS SHARANI HANUMANGARH HANUMANGARH",
"ANIMAL RESOURCE DEVELOPMENT",
"MATA GUJRI PUBLIC SCHOOL",
"THE BATH STUDIO LLP",
"KARYALAY JILA ADHIKARI BASTI",
"GOVERNMENT MODEL SCIENCE COLLEGE GWALIOR",
"BHARATI VIDYAPEETH'S BHARATI HOSPITAL KOLHAPUR",
"SB AUTOMATICS",
"CANTONMENT BOARD SAGAR",
"DEPUTY S P RAILWAY POLICE INDORE",
"TAJ FILLING STATION",
"MAHENDRA NARAYN MISHRA",
"SAHYOG IMAGING CENTRE",
"EDUCATION PANCHAYAT SAMITI DHULE",
"ALPHA PLUS CAPITAL ASSOCIATES LLP",
"PYRAMID HEALTH INFORMATION SOLUTIONS",
"AEN PHED SUB DIV KEKRI",
"GSSS SAWAR",
"K & D DESIGN KRAFT LLP",
"NEW DELHI INSTITUTE OF MANAGEMENT",
"BILHARA NAGAR PARISHAD REVENU RECOVER",
"JAY SAVARIYA SHETH SEC & HIGHER SECONDARY ASHRAMSHALA",
"AMARA RAJA ADVANCED CELL TECHNOLOGIES PRIVATE LIMITED",
"ST XAVIER`S HR SEC SCHOOL",
"MADHYANCHAL GRAMEEN BANK",
"SHRI CHATRAPATI SHIVAJI MAHARAJ GENERAL HOSPITAL SOLAPUR",
"OFFICE OF THE DISTRICT MAGISTRATE & COLLECTOR SOUTH 24 PGS",
"AMDAVAD MUNCIPAL CORPORATION",
"CAMBAY HEALTHCARE",
"TBC HOMES INFRA CORP",
"SIKSHA O ANUSANDHAN",
"VIVANTA BHUBANESWAR DN SQUARE",
"NAVA NALANDA PRIMARY SCHOOL",
"ARVIND SAHAKARI BANK LTD",
"ADARSH KRISHAK INT COLL KARAB MATHURA",
"DR BABASAHEB AMBEDKAR HIGH SCHOOL",
"VALENTINA PHARMACEUTICAL LLP",
"BHARATI HOSPITAL & RESEARCH CENTER",
"THE WEST BENGAL COUNCIL OF RABINDRA OPEN SCHOOLING",
"MAHATMA GANDHI GOVT SCHOOL (ENGLISH MEDIUM),DABABKHANA",
"PRAVARAN KENDRA PURVA SELECTION CENTRE EAST",
"GLOBAL SCHOOL OF EXCELLENCE",
"EXPOINN SUITES AND CONVENTION",
"DEPUTY DIRECTOR HORTICULTURE JODHAPUR",
"SANGOLA VIDYAMANDIR PRASHALA SANGOLA",
"OFFICE OF BLOCK RESOURCE COORDINATOR",
"EXECUTIVE ENGINEER BOKO CHAYGAON DIVISION IRRIGATION BOKO GOVT OF ASSAM",
"CLOUD EXPERTS INDIA",
"B E O KHARGONE",
"FLSMIDTH CEMENT INDIA LLP",
"307859 GSSS JHALARA",
"DEPUTY DIRECTOR PANCHAYAT KORBA",
"R K BARUAH H S PO CHENGELI GAON JORHAT",
"EMPLOYMENT GENERATION AND TRAINING",
"AMBIKA SECURITY SERVICE",
"ITI JODHPUR",
"SHREE NARAYANA GURU ENGLISH VIDYALAYA",
"ALLTERRA SOLUTIONS LLP",
"JAMIA HAMDARD UNVERSITY",
"MAHARSHI WALMIKI VIDYALAY SAMDA",
"LADY ENGINEER HIGH SCHOOL",
"M G NATHANI SINDHI HINDI PRIMERY SCHOOL",
"MATSYODARI SHIKSHAN SANSTHA LAW COLLEGE JALNA",
"BLOCK CHIEF MEDICAL OFFICER BADNOR",
"Q AND Q SOLUTIONS INDIA PRIVATE LIMITED",
"PEEO NOGANWA",
"PT MOTI LAL NEHRU LAW COLLEGE CHHATARPUR",
"THE REAL REALTY",
"DISTRICT EDUCATION COMMITTEE GANDHINAGAR",
"SAMAGRA SHIKSHA GANDHINAGAR",
"SHIVAM NA PRI SCHOOL KALOL",
"BATT DALGANJAN VIDHYA PITH INTER COLLEGE",
"POPULATION SERVICES INTERNATIONAL",
"DIRECTOR OF FISHERIES UP LKO",
"NATIONAL CHILDREN HR SEC SCHOOL BADA GAON MORAR GWALIOR",
"GUDAKESA TECHNOLOGIES",
"MAHARAJA AGRASEN MEDICAL COLLEGE",
"TUMKUR MILK UNION LTD",
"PW GURUKULAM SCHOOL",
"DUBO DIGITAL CONSULTING LLP",
"RANGE FOREST OFFICE PAWANI",
"I D U B S JUNIOR COLLEGE",
"SETH EKNATH KABRA MARATHI MADH VID.TEMBHURNI JALNA",
"PUNIA CONSTRUCTION COMPANY",
"B E O JATARA TIKAMGARH MADHYA PRADESH TIKAMGARH",
"KAMLADEVI PRATHMIK ASHRAM SHALA KONHALI",
"E E WATER RESOURCES DIV ASHOKNAGER MADHYA PRADESH ASHOKNAGAR",
"ASSISTANT ENGINEER W R SUB DIVISION RAISINGHNAGAR",
"MILITARY HOSPITAL AMRITSAR",
"SONA VALLIAPPA PUBLIC SCHOOL",
"RUSHI VALMIKI VIDYALAYA",
"WORK DEPARTMENT P S TASGAON",
"ISTA BADISTA HIGH SCHOOL",
"U M S MOHIUDDINPUR FATUHA",
"DREAM INDIA SCHOOL",
"ICAR INDIAN INSTITUTE OF SOIL AND WATER CONSERVATION",
"ASSTT DIRECTOR CENSUS OPERATIONS",
"GREEN GARDEN MATRIC HR SEC SCHOOL",
"GOVT PRAVESHIKA SANSKRIT SCHOOL AKHEPUR",
"SUKDEO MADHYAMIK VIDYALAYA NASHIK",
"HIMACHAL PRADESH HOUSING AND URBAN DEVELOPMENT AUTHORITY DIVISION MANDI",
"GOVT OF CHHATTISGARH OFFICE OF THE PRINCIPAL",
"POLY CLINIC",
"D F O NORTH T BETUL MADHYA PRASAD",
"B E O RAJGARH",
"AL AMEEN ENGINEERING COLLEGE",
"ZILLA PARISHAD CENTRAL PRIMARY SCHOOL BOYS KAIJ",
"GANGAI PHARMACY COLLEGE",
"NAGER NIGAM JODHPUR SOUTH",
"ME HIN ME HIN DIVISION OF ME HIN TECH EDGE SOLUTIONS",
"VTP PROJECTS LLP",
"H M M S PATAMDA JSR",
"SWISS GARNIER LIFE SCIENCES",
"HIGH COURT OF JHARKHAND RANCHI",
"LABOUR OFFICER SOLAN",
"SHIKSHANMAHARSHI GURUVARYA R G SHINDE MAHAVIDYALAYA PARANDA",
"SHRI GANESH HIGH SECONDARY SCHOOL DEOGAONRANGARI",
"CENTRAL ELECTRICITY REGULATORY COMMISSION",
"PAO PRINTING MINISTRY OF URBAN DEVELOPMENT NEW DELHI",
"GLOBAL ACADEMY OF TECHNOLOGY (NATIONAL EDUCATION FOUNDATION)",
"GULSHAN NIWASI MATIMAND VIDYALAY AURANGPURA",
"RADIANT INNOVATIVE MANUFACTURING LIMITED",
"JAWAHARLAL NEHRU MEDICAL COLLEGE",
"MAMLATDAR OFFICE NAKHATRANA",
"BALAJI FRACTURE & GENERAL HOSPITAL",
"AVENTA PROPERTIES LLP",
"LUCKNOW KHAND- 2 SHARDA CANAL LUCKNOW",
"KIRORI MAL COLLEGE",
"MEDICAL SUPDT RURAL HOSPITAL KANNAD TQ KANNAD DIST",
"GSSS DODA",
"CLINILAUNCH RESEARCH INSTITUTE LLP",
"GOVT ART AND CRAFT TTI NABHA",
"FORMS KART",
"F.H. MEDICAL COLEGE HOSPITAL",
"AVNEE ENVIROTECH INDIA PRIVATE LIMITED",
"SHIROMANI GURDWARA PARBANDHAK COMMITTEE",
"SANYA PRIME DIAGNOSTIC CENTER",
"RAJSHREE INSTITUTE OF MANAGEMENT AND TECHNOLOGY",
"MEDICAL OFFICER COMMUNITY HEALTH CENTRE HATIGARH",
"RONAK SWITCHGEAR AND AUTOMATION",
"Z P P SCHOOL KHANAPUR",
"ST MARTIN'S DIOCESAN SCHOOL",
"ADARSH SIKSHAN SANSTHA`S KALIKADEVI ARTS COMM SCI COLLAGE SHIRUR ( KA )",
"UNO MINDA KYORAKU LIMITED",
"THE SKY INDUSTRIES",
"TALUKA INSPECTOR OF LAND RECORDS KARANJA GHADGE",
"GSSS BANEY KA BERKHERA",
"MEDILIFE TECHNOLOGIES",
"LNJ SKILLS BHILWARA",
"SANTOSH INTERNATIONAL SCHOOL",
"ROADS AND BUILDING DIVISION KHORDHA",
"B E O BAGLI",
"EE HPPWD(ROAD&BRIDGES) DHARAMSHALA",
"SHRI GANDHI ADARSH KANYA VIDHALAYA",
"GOVERNMENT SPECIAL GOVERNMENT SPECIAL REHABILITY CENTRE FOR GIRLS DEONAR",
"CLW HEADQUARTER",
"BALBHARTI PUBLIC HIGHER SECANDARY SCHOOL",
"NATURAL ROCKSAND PRODUCT",
"ROCKY ENTERPRISES",
"SHRI GORAKSH ART'S COMMERCE & SCIENCE COLLEGE",
"OFFICE OF THE PRINCIPAL GENERAL NURSING AND MIDWIFERY TRAINING CENTER",
"NANDAN CORPORATION LLP",
"KUKHRAJORE HIGH SCHOOL",
"CIVIL SURGEON CUM SUPDT DISTRICT HOSPITAL CHHATARPUR",
"A C TWD DHAR",
"MEDICAL SUP ESI HOSPITAL",
"DELOITTE HASKINS & SELLS CHARTERED ACCOUNTANTS LLP",
"DIRECTOR STATE T B TRG & DEMO CENTRE AHMEDABAD",
"31682 JOINT DIRECTOR SCHOOL EDUCATION REGIONAL OFFICE PALI",
"EAST COAST RAILWAY DHANBAD DIVISION",
"B E E O KASUMPTI",
"UPA SAMBHAGIY KRISHI PRSAR ADHIKARI SADAR/PINDRA V",
"RAM NARAYAN INTERMEDIATE COLLEGE",
"AEN PHED DISTT RURAL SUB DIVISION AJMER",
"JOINT DIRECTOR ANIMAL HUSBANDRY SAWAIMADHOPUR",
"ASSTT REGISTAR CENTRAL EXICSE AND SERVICE TAX APPELLATE TRIBUNAL MUMBAI",
"LANDMARK INCORPORATES",
"ZAO CBDT THANE",
"GSSS RAJKOT",
"GOVERNMENT SERVICE SHIKSHA VIBHAG",
"PHASEZERO INDIA LLP",
"DISTT PUBLIC PROSECUTION OFFICER INDORE",
"AKSHAR FOUNDATION",
"D K PATIL INSTITUTE OF PHARMACY",
"HASSAN PUBLIC SCHOOL",
"PEEO PYARIWAS",
"E E N H DIVISION HPPWD THEOG",
"ONE MEDIA NETWORK",
"SHREE MURLIDHAR VIDHYALAY",
"JOINT DIRECTOR MAHILA AVAM BAL VIKAS",
"RYTHM REAL FOOD PRODUCTS",
"CHRIST JUNIOR COLLEGE",
"M/S CHEHAR DIAMOND",
"GOKULCHAND REHTI DEVI KANYA INTER COLLEGE",
"GSSS PATASAR PATODI",
"PEEO KAWARPURA",
"SHRIMAN BHAUSAHEB ZADBUKE MAHAVIDYALAYA BARSHI",
"MADRASA KHANAM JAN ARABIC SCHOOL",
"ASSAM DOWN TOWN UNIVERSITY",
"GSSS GUNDALI",
"SHRI JASODA DEVI REVACHAND GURNANI GSSS ENGLISH MEDIUM FATEHTIBA JAIPUR",
"ARDEN PROGRESSIVE SCHOOL",
"ACTIVE AUTOMOBILES",
"VANDE MATARAM PRIMARY SCHOOL",
"FRACTAL ANALYTICS LIMITED",
"SRIHATI SHYAMRAJ SANSKRIT VIDYALAYA (GOVT OF ASSAM)",
"SRI RAMAKRISHNA DENTAL COLLEGE AND HOSPITAL",
"GOBIND LOGISTICS",
"DELHI PUBLIC SCHOOL GANDHIDHAM",
"UNITY BUILDERS AND ROAD CONSTRUCTIONS PRIVATE LIMITED",
"MANDYA MILK UNION LTD",
"THE AJNALA CO OPERATIVE SUGAR MILLS LTD",
"JUBILEE HILLS PUBLIC SCHOOL",
"COMMISSIONER NAGAR NIGAM BIKANER",
"KALINIDI COLLEGE (UNIVERSITY OF DELHI)",
"MUNICIPAL COUNCIL THANESAR",
"EE RES DN 2 CHHINDWARA",
"SIDDH HOSPITAL",
"SECONDARY TEACHERS TRAINING COLLEGE VISNAGAR",
"ENDEAVOUR EDUCATION & MIGRATION CONSULTANT",
"ASSTT DIR AGRI EXT CHITTORGARH",
"PAO O O THE AG (A&E) HIMACHAL PRADESH SHIMLA",
"SSR MEMORIAL TRUST",
"SKY WAY PUBLIC HIGHER SECONDARY SCHOOL",
"POCHAMPALLY CO-OPERATIVE URBAN BANK LIMITED",
"J S CENTREPETAL SENIOR SECONDARY SCHOOL CHIRAWA",
"MAHARANA PRATAP MULTISPECIALITY HOSPITAL PVT LTD",
"PVINSIGHT PRIVATE LIMITED",
"ECONSTRA BUSINESS CONSULTANTS LLP",
"SURAJBA & M K PATEL SARVAJANIK VIDYALAYA",
"PUNJAB SCHOOL EDUCATION BOARD",
"NARMADA JILLA SIKASHAN SAMITI SANCHALIT PRIMARY SCHOOL",
"GAURAV INDUSTRIAL SECURITY AND ALLIED SERVICES",
"ABIS SAMPOORNA LLP",
"OUR LADY OF GOOD COUNSEL HIGH SCHOOL",
"AIR FORCE CENTRAL ACCOUNT OFFICE",
"M K E S COLLEGE OF LAW",
"RAJA BALWANT SINGH INTER COLLEGE AGRA",
"INTEGRATED TEST RANGE CHANDIPUR",
"PANCHAYAT UNION CUDDALORE",
"AKSHAR WATER TECH",
"BHAGWATIDEVI VIDHYALAYA DEOSARI",
"SATYA BHARTI SCHOOL",
"BOLSTERBIZ INDIA LLP",
"MAHATMA GANDHI GOVT SCHOOL ENGLISH MEDIUM GAGARWAR",
"ASSOCIATION OF BIOTECHNOLOGY LED ENTERPRISES",
"SHRI J P HIGH SCHOOL GAUDGAON BK",
"MAHATMA GANDHI GOVT SCHOOL (ENGLISH MEDIUM) R A C BATALIYAN 5TH RAC LINE",
"HERITAGE INTERNATIONAL SCHOOL",
"OPB EN POINTE ADWISERS LLP",
"ESSBEE FIRE SERVICES",
"HARYANA STATE INDUSTRIAL & INFRASTRUCTURE DEVELOPMENT CORPORATION LIMITED",
"SHRI JAYENDRAPURI ARTS AND SCIENCE COLLEGE",
"INFINITIVE PHARMACEUTICAL INDUSTRIES",
"CHURU TEHSLLDAR RAJGARH",
"DIT(T P) I MUMBAI",
"WOMEN HOSPITAL BEED",
"ANERI SERVICES",
"PAO (CAT) NEW DELHI",
"DEPARTMENT OF TELECOMMUNICATIONS",
"TRIBAL AND SCHEDULE CAST WELFARE DEPARTMENT",
"INTELLECT CORPORATE SERVICES PRIVATE LIMITED",
"MARWARI HOSPITALS",
"RAILWAY BOARD",
"KUNOSOLTECH",
"LAVIT TILE LLP",
"R.K BAHETI & CO CHARTERED ACCOUNTANTS",
"STUDENTS WELFARE AMM PRIMARY SCHOOL",
"URBAN PRIMARY HEALTH CENTRE YAMUNANAGAR (UNDER HEALTH DEPT HARYANA)",
"CBEESO SPACESAVERS LLP",
"SIDDARAMESHWAR PU SCIENCE COLLEGE",
"SMART HOMES BUILDING SMART INDIA",
"FAB FOUR TECHNOPLAST",
"SHRI RAMSWAROOP MEMORIAL UNIVERSITY",
"AEN PWD CITY SUB DIV II JODHPUR",
"TEHSILDAR HOSHANGABAD",
"GOVT OF JHARKHAND SPECIAL EMPLOMENT EXCHANGE FOR P/H BOKARO",
"AQUAPUMP INDUSTRIES BRANCH",
"HAUSABAI ATHAWALE VJNT PRI A S",
"MAHARASHTRA POSTGRADUATE INSTITUTE MER MUHS NASHIK",
"PURANAMAL LAHOTI PRI AZAD CHOWK LATUR",
"GLOBAL SHANTI CARE HOSPITAL",
"PJ INTERNATIONAL",
"PROFUSE SERVICES",
"GSSS SALODA KHAMNOR",
"PANCHYAT SAMITI ARAI",
"PRANVEER SINGH INSTITUTE OF TECHNOLOGY",
"SRI GURU HARGOBIND CONVENT SEN SEC SCHOOL",
"GOVT SARVODAYA VIDYALAYA",
"MPOWER MINDS MATTER ADITYA BIRLA EDUCATION TRUST",
"OFFICE OF THE CIVIL DEFENCE SURAT",
"MAHESHPUR HIGH SCHOOL HS",
"BHOGESHWAR VIDYALAYA DAVANHIPPARGA TQ DEONI",
"ASSTT COMM TRI HDB DEV HBAD HOSHANGABAD",
"DELHI DIVISION",
"ARYA SENIOR SECONDARY SCHOOL",
"GULSHAN KUMAR EDUCATION TRUST",
"KONGU POLYTECHNIC COLLEGE PERUNDURAI",
"EASTERN RLY ASN",
"AGRICALTURE DEPARTMENT Z P NANDED",
"RSNG INFO SOLUTIONS",
"DIRECTORATE OF SECONDARY EDUCATION HARYANA",
"RASHTRYA SHIKSHAN PRASARAK MANDAL BEED LOKMANYA TILAK MAHAVIDYALYA",
"CENTRAL DESIGNS ORGANISATION GANDHINAGAR",
"PATRASAYER B P H C",
"ASPIRE IIT & MEDICAL",
"PLANET SNAPS",
"KUNVARJI REALITY ADVISORS",
"B E O MANAWAR",
"ROYAL SR SEC PUBLIC SCHOOL",
"NAVKAR HAND RUGS",
"DR RADHAKRUSHANAN PRATHMIK VIDHYALAYA UDGIR",
"GSSS LAKAPA (SALUMBAR)",
"MGC GLOBAL RISK ADVISORY LLP",
"GANPATI FOODS",
"DISTRICT TUBERCULOSIS CENTER KOLHAPUR",
"BELIAGHATA DESHBANDHU HS MAIN",
"HINDU GIRLS COLLEGE SONIPAT",
"INFINITE ENTERPRISE CONSULTING",
"BAGRANA DEPOT",
"ADARSH COOPERATIVE BANK LTD",
"THE WESTIN HYDERABAD HITEC CITY",
"JEEWAN JYOTI HOSPITAL",
"GOVT SR SECONDARY SCHOOL CHANDIGARH",
"DATA PROCESSING DIVISION AHMEDABAD",
"MOHANLAL SONS",
"JDFS BUSINESS SOLUTIONS LLP",
"ESTATE DIRECTORATE LUCKNOW",
"REGIONAL MENTAL HOSPITAL YERAWADA PUNE 6",
"L R O MATHURA",
"310223 GSSS JEETALA NEEM KA THANA",
"31334 GOVT PRAVESHIKA SANSKRIT SCHOOL BAMANWAS DHOODH WALO KA BAS",
"G G H S BHITHAURA STP",
"AEROSTAR HELMETS & ACCESSORIES",
"RASHTRIYA GLOBAL SCHOOL",
"GGSSS JALORIGATE JODHPUR",
"GSSS RAKSHI BANEDA BHILWARA",
"310168 GSSS BAAR",
"CENTRE FOR YOUTH AND SOCIAL DEVELOPMENT",
"THE INTERNATIONAL TRUCKING",
"GOVT SHRMODAYA AWASIYA VIDYALAYA JABALPUR",
"SVN ENTERPRISES",
"SCHOOL OF EMINENCE BHARGO CAMP",
"SETTELMENT OFFICER JAIPUR",
"HIYAAV INDUSTRIES",
"DY DIRECTOR OF EDUCATION DISTT SOUTH WEST",
"POA MINISTRY OF URBAN DEVELOPMENT",
"GOVT SARVODAYA KANYA VIDYALAYA SHIV RAM PARK NANGLOI",
"L K S SHAH HIGH SCHOOL NIRMALI",
"TEHSILDAR CHHATA",
"SATTORE HIGH SCHOOL",
"MATHABHANGA F P SCHOOL",
"GOVERNMENT OF WEST BENGAL SUB-DIVISIONAL LAND & LAND REFORMS OFFICE BARUIPUR",
"GOVT PRAVESHIKA SANSKRIT SCHOOL MALWA JAIPUR",
"JAGADISHPUR SK INSTITUTION HS",
"PURBANCHAL COLLEGE SILAPATHAR",
"MUNICIPAL CORPORATION DHARAMSHALA",
"HIM INTERNATIONAL SCHOOL",
"PRAYAGRAJ DEVELOPMENT AUTHORITY PRAYAGRAJ",
"MEDICAL HEALTH & FAMILY WELFARE DEPARTMENT NAWALGARH",
"MAHALAKSHMI TRANSFORMERS",
"AUROBINDO TATTVA TOWNSHIP DEVELOPERS LLP",
"COBURN SLIDING SYSTEMS INDIA PRIVATE LIMITED",
"BLOCK EDUCATIONAL OFFICER",
"AUTOZONE HYUNDAI",
"OMSHANTI VIDYALAYA AMBAD",
"LAMBA VIJ & CO",
"TILAK DHARI P G COLLEGE",
"ZERO DESIGN STUDEO",
"CYBER INFORMATIC TECHNOLOGIES & SERVICES",
"KARYALAY MAHILA EVAM BALVIKASH PARIYOGNA",
"BROSIS TECHNOLOGIES",
"ADK VENTUREE",
"DELHI KHADI AND VILLAGE INDUSTRIES BOARD GOVT OF NCT OF DELHI",
"CMS WOMAN HOSPITAL JHANSI",
"ASST COMMR OF ANIMAL HUSBANDRY SILLOD",
"MEDICAL OFFICER COMMUNITY HEALTH CENTRE SORO",
"A C AGRO TECHNOLOGY",
"HUMAN HORIZON PRIVATE LIMITED",
"ASSITANT ENGINEER TO EXCUTIVE ENGINEER I&PH DIV RAMPUR",
"HOTEL ANNPURAN INN",
"EAZY REFUND CONSULTANCY LLP",
"A.R. FOUNDATIONS PRIVATE LIMITED",
"GSSS RAMPURIYA (SUWANA) BHILWARA",
"HVR MANAGEMENT SERVICES PRIVATE LIMITED",
"DIRECTOR HOMEOPATHIC CHIKITSA DEPARTMENT JAIPUR",
"SUJLAM SUFLAM DIVISION NO 2 VISANAGAR MEHSANA",
"GREATER NOIDA COLLEGE",
"SHAHEED MAHENDRA KARMA VISHWAVIDYALAYA BASTAR",
"BAGHAJATIN VIDYAPITH HS",
"ZPPS HANMANTWADI UDIR",
"SAIFEE GOLDEN JUBLEE ENGLISH PUBLIC SCHOOL",
"SMALL CAUSE COURT AHMEDABAD",
"PANCHAYAT SAMITEE BHIWAPUR",
"KIERABELLA ROSALIND FOUNDATION",
"GSSS PATA RAMGARHI",
"PUBLIC HEALTH ENGINEERING DEPARTMENT CHAKSU",
"SHECHEN CLINIC",
"EXECUTIVE ENGINEER CGWB DIV-XI JODHPUR",
"DEO AGRI CAD SULTANPUR",
"SHANKAR GRAPHICS INC",
"SAI NS NIS",
"JILHA PARISHAD PARTHAMIK SHALA GOREWADI (SOLAPURE)",
"DEPARTMENT OF AYUSHDIRECTORATE OF HOMOEPATHY OFFICE OF DMHO OFFICE DEORIA",
"OFFICE OF DISTRICT FOOD MARKETING OFFICER",
"CT AND GST OFFICER ENFORCEMENT UNIT",
"BLOCK CHIEF MEDICAL OFFICER JAHAJPUR BHILWARA",
"RAMADE MEMORIAL MEDICARE AND RESEARCH INSTITUTE LLP",
"PUBLICATION BOARD ASSAM",
"MADHYAMIK VIDYALAYA SAPAD",
"HARE KRISHNA MOVEMENT INDIA",
"RAINBOW WORLD SCHOOL BHAWRNA TEH PALAMPUR",
"DIVINE HEALTH AND EDUCATIONAL TRUST",
"PAO CWC NEW DELHI",
"TOWN AND COUNTRY PLANNING",
"DASHMESH CONSULTANTS",
"NAVJEEVAN COLLEGE OF NURSING",
"VIJAY PATIL SCHOOL OF MANAGEMENT",
"SATAVAHANA UNIVERSITY",
"SHREE G S KUMAR VIDYALAYA LIMBDI",
"SATPUDA COLLEGE OF ENGINEERING & POLYTECHNIC",
"MARKET EXPERTISE",
"SWAMI VIVEKANAND MAHAVIDYALAY SHIRUR TAJBAND",
"UTTARAKHAND RAJYA KARAMCHARI KALYAN NIGAM DEHRADUN",
"DEBNAGAR KUMUDINI BALIKA VIDYALAYA",
"MAHATMA GANDHI GOVT SCHOOL ENGLISH MEDIUM JHAPADA KALAN",
"SANOFI CONSUMER HEALTHCARE INDIA LIMITED",
"M/S IMAGE MARKETING",
"B S ANANGPURIA INSTITUTE OF TECHNOLOGY AND MANAGEMENT",
"SRI RAMA CHANDRA EDUCATIONAL SOCIETY",
"GOVT DEGREE COLLEGE SHIVNAGAR",
"TALUKA AGRICULTURAL OFFICE MANTHA JALNA",
"BLOCK EDUCATION OFFICER BLOCK GARIYABAND",
"A B COMMODITIES",
"GSSS MASARON KI OBARI",
"DHANDHIYA PRATHMIK SHALA",
"CIRCLE OFFICE JHARIA",
"1ST MAH SIGNAL COY N C C PUNE",
"ASSISTANT ENGINEER III TUBE WELL SUB DIVISION AULA",
"NETISION TECHNOLOGY LLP",
"KRIAT",
"MUNICIPAL CORPORATION KOTA NORTH",
"LEO RADIODIAGNOSTIC CENTRE",
"MAHARASHTRA RURAL ROAD DEVELOPMENT ASSOCIATION",
"GOVT POST BASIC ASHRAM SCHOOL MHASAGAN",
"22237 BLOCK CHIEF MEDICAL OFFICER RAINI ALWAR",
"CHIEF DISTRICT VETERINARY OFFICE JAJPUR",
"NEW HORIZON EDUCATION INSTITUTION",
"PAINGANAGA URBAN CO OPERATIVE CREDIT SOCIETY LTD",
"YESPIVOT TECH PRIVATE LIMITED",
"BIOBEAM SCIENTIFIC INSTRUMENT LLP",
"GOVT OF JHARKHAND NCC GR H Q RANCHI",
"BRIJESH HIMMATRAMKA AND ASSOCIATES",
"THE DEVERKHANA MULTI PURPOSE PRIMARY AGRI CO OP SOCIETY LIMITED",
"ONRGY SERVICES PRIVATE LIMITED",
"AADYA INDUSTRIES",
"GOVT OF JHARKHAND FISHRIES BOKARO",
"COLLECTORATE PATAN",
"GARRISON ENGINEER (ARMY) NO 2",
"ARUN JAITLEY NATIONAL INSTITUTE OF FINANCIAL MANAGEMENT",
"BHARAT LAB NETWORK",
"JAY MATRICULATION SCHOOL",
"VANRAJ FALIYA LIMADADA PRIMARY SCHOOL TA- VYARA",
"SCHOOL OF EMINENCE",
"NANIGOPAL BALIKA VIDYALAYA",
"CHHATRAPATI SHAHU VIDYALAYA",
"GHS CHAK SHEKHUPUR KALAN",
"EME SCHOOL",
"NP BOYS SCHOOL NO 4",
"DHARAPUR HIGHER SECONDARY SCHOOL",
"FORTIS OP JINDAL HOSPITAL AND RESEARCH CENTRE",
"WORK&GROW",
"PLAYWAYS SR SEC SCHOOL",
"SHRI SATSANGI SAKETDHAM RAM ASHRAM GROUP OF INSTITUTIONS",
"JOINT DIRECTOR OF PROSECUTION HATHRAS",
"PANCHIAR PRIMARY SCHOOL",
"DIRECTOR URBAN DEVELOPMENT DEHRADUN",
"VINAYAK P G COLLEGE CHOMU",
"SHRI H J HIGHSCHOOL LILAKHA",
"MAULANA AZAD INSTITUTE OF DENTAL SCIENCES",
"ALLAHABAD MUSEUM",
"FERRARIA METAL INDUSTRIES LLP",
"GOVERNMENT BOYS SENIOR SECONDARY SCHOOL MADANPUR KHADAR",
"NARAYAN SWAROOP HOSPITAL",
"MAHATMA GANDHI GOVT SCHOOL ENGLISH MEDIUM RANSAR",
"KIMAYA HIMALAYAN BEVERAGES LLP",
"SMT DHARMRAJI DEVI G P SINGH I C KHUIRI JAUNPUR",
"RAYMOND LIFESTYLE LIMITED",
"DIRECTOR HEALTH SERVICES",
"RSRTC KOTPUTLI DEPO",
"RAAM ELECTRIC TWO WHEELERS LLP",
"REVENUE AND DISASTER MANAGEMENT FIRE OFFICE (FIRE SERVICES)",
"MAHATMA GANDHI GOVT SCHOOL ENGLISH MEDIUM SANBHARLAKE",
"THE GURU SENIOR SECONDARY SCHOOL BAREILLY",
"ST JOSEPHSS INTERNATIONAL SCHOOL",
"A E TO E E HPPWD DIVISION NO II SML",
"209 PRINCIPAL G SSS SHOGHI SHIMLA",
"EXCUTIVE ENGINEER HEAD QUATER JALKAL VIBHAG NAGAR NIGAM VARANASI",
"EDUKALP PUBLICATION",
"WHITEGOLD",
"JP JAIN SENIOR SECONDRY SCHOOL",
"PROJECT DIRECTOR AND SECRETARY STATE REMOTE SENSING APLICATION CENTER SRSAC JODHPUR",
"EMINENT RESEARCH AND ADVISORY SERVICES",
"SRI MARUTHI ENTERPRISES",
"528 COMMANDANT HOME GUARDS SOLAN",
"SABURI PLYWOOD",
"GOVT OF CHHATTISGARH DIVISIONAL FOREST OFFICE RAIGARH CHHATTISGARH",
"DIRECTOR SOCIAL SECURITY WOMEN AND CHILD DEVELPOMENT",
"KASOR KANYA SHALA",
"MANAGEMENT AND COMPUTER CONSULTANTS",
"BAL V MAHILA CHETNA SAMITI",
"REGISTRAR PWD DEPTT VIG",
"PIPRA HIGHSCHOOL TAL UMRED DIST NAGPUR",
"23539 COMMUNITY HEALTH CENTRE MALPURA TONK",
"INSTITUTE FOR MACHINE TOOLS TECHNOLOGY",
"RATLAM PUBLIC HR SEC SCHOOL",
"HAMMOCK VENTURES PRIVATE LIMITED",
"SUNVI LABS ENG PRIVATE LIMITED",
"JOINT DIRECTOR ANIMAL HUSBANDRY BHARATPUR",
"RAB & COMPANY",
"PAO SSI NEW DELHI",
"VIVEKANAND PRIMARY SCHOOL PARTUR",
"PRIMARY HEALTH CENTER KAPASI TAL KAGAL",
"HOLIDAY INN AGRA",
"KEYATALA HIGH SCHOOL",
"GSSS DHADHOLI",
"B E O GUNA MADHYA PRADESH GUNA",
"PAO CHIEF LABOUR COMMISSIONER NEW DELHI",
"MAND COLD STORAGE",
"ZUNAX ENERGY PRODUCTS LLP",
"PANCHAY SAMITI UDGIR",
"AE TO EE HPPWD DIV 1",
"AUDIO LIFE",
"Z P SCHOOL FANASPADA KHARWAL VIRNAGAR",
"DISTRICT VOCATIONAL EDUCATION AND TRAINING OFFICE GONDIA",
"SRI BALDEO INT COLL BARAGAON VARANASI",
"PALAK BUILDVISION LLP",
"CENTRAL SQUARE FOUNDATION",
"ARVINTH COLLEGE OF NURSING",
"DIST EMPLOYMENT OFFICER SAGAR",
"DIVISIONAL COMMISSIONER KARNAL",
"G M S KARRA GOVT OF JHARKHAND",
"NIH NATIONAL INSTITUTE OF HOMOEOPATHY",
"MEDICAL EDUCATION AND RESEARCH",
"VUG ITM VOCATIONAL UNIVERSITY",
"DULKI FP GOVT OF WEST BENGAL",
"BHAGWAT DAYAL SHARMA POST GRADUATE INSTITUTE OF MEDICAL SCIENCES ROHTAK",
"L R TRADERS",
"HUPTA PRINTEX AND POLYMERS",
"AMBULANCE GAREJ",
"B E O BADAMALEHRA CHHATARPUR",
"SHAKTI SECURITY",
"522 DISTT AYUREVEDIC OFFICER",
"BARCODE BIOSCIENCES PRIVATE LIMITED",
"KALAWATI HOSPITAL",
"OFFICE OF MUNICIPAL CORPORATION SONIPAT",
"MUNICIPAL CORPORATION SONEPAT",
"Y D V D ARTS COMMERCE COLLEGE",
"ITI SWAIMADHOPUR",
"GENERAL ADMINISTRATION DEPT WALWA PANCHAYAT SAMITI ISLAMPUR",
"THE PHAGUWALA MULTIPURPOSE COOPERATIVE AGRICULTURAL SERVICE SOCIETY LTD. PHAGUWALA",
"KYB DIAGNOSTIC",
"RADISSON BLU UDAIPUR PALACE RESORT AND SPA",
"PROGRESSIVE EDUCATION TRUST",
"JAKBRILLO UDYOG LLP",
"PRINCIPAL SUPER SPECIALITY HOSPITAL CHAMIANA SHIMLA",
"OLIVE GREEN CONSULTING LLP",
"OFFICE OF THE BLOCK LIVESTOCK DEVELOPMENT OFFICER",
"FARMER WELFARE & AGRICULTURE DEVELOPMENT DISTRICT UJJAIN",
"PROPHAZE TECHNOLOGIES PRIVATE LIMITED",
"TEHSILDAR BAMORI MADHYA PRADESH GUNA",
"HEDIS ASSOCIATES PRIVATE LIMITED",
"CBEO ARAI",
"SATHYA SAAI MATRIC HR SEC SCHOOL",
"BLOCK EDUCATION OFFICER DHARI",
"KARYALAY JANPAD PANCHAYAT BIAORA JILA RAJGARH M P",
"PRAVEEN KUMAR PATEL SECURITY AGENCY",
"COMMUNITY HEALTH CENTER MADPHIYA CHITTORGARH",
"CHIEF EXECUTIVE OFFICER ZILLA PARISHAD",
"DISTT AND SESSION JUDGE UJJAIN MADHYA PRADESH",
"A P INDUSTRIES",
"GOVT KRISHI UPAJ MANDI SAMITI",
"SHRI MAHATMA DUDHADARI INTER COLLEGE NAGLA VISHNU AGRA",
"FINANCIAL COMMISSIONER",
"RAJAT VIDHYAPEETH SHIKSHAN SANSTHAN",
"BENGALI HIGH SCHOOL NAGPUR",
"KOLHAPUR PUBLIC SCHOOL",
"UN MEHTA INSTITUTE OF CARDIOLOGY & RESEARCH CENTRE",
"NDV SALON & SPA LLP",
"PANDIT BHAGWAT DAYAL SHARMA POST GRADUATE INSTITUTE OF MEDICAL SCIENCES",
"HAMIRA FOOD",
"GOVT P G COLLEGE NIWARI",
"SONKATCH NAGAR PARISHAD",
"NAVANEETHA PUBLIC SCHOOL",
"GOVT ITI W FEROZEPUR",
"SUDHA HOSPITALS",
"606 EXECUTIVE ENGINEER",
"VAISHNAV CAPITAL ASSOCIATES",
"L B KUNJIR",
"CQA GS KANPUR",
"NATIONAL ARTS AND SCIENCE COLLEGE JAYAKONDAM",
"FEROZEPUR MEDICITY SUPERSPECALITY HOSPITAL",
"SHAHEED UDHAM SINGH ACADEMY SATAUJ",
"GSSS BHAGEGA",
"YATHARTHA YANTRA UDYOG",
"SAHARA INDIA",
"PRINCIPAL GSSS SIDHPUR SARKARI",
"BADMINTON ASSOCIATION OF INDIA",
"SANT NANDLAL SAMRITI VIDYA MANDIR",
"THE BARNAGORE JUTE FACTORY PLC",
"JORHAT ENGINEERING COLLEGE",
"GAGAN HIGH SCHOOL KHADKI",
"PAO BSI ZSI KOLKATA",
"THE BAGHPAT CO-OPERATIVE SUGAR MILLS LTD",
"PRINCIPAL GOVERNMENT ITI DEOPRAYAG",
"CONTROLLER GENERAL OF DEFENCE ACCOUNTS",
"UPPER AYUKT KARYALAY AYUKT VI TRAN ADHIKARI KARYALAY AYUKT MIRZAPUR",
"NATIONAL URDU PRIMARY SCHOOL",
"SAMBHAJIRAO KENDRE MAHAVIDYALAYA",
"FYTIKA HEALTHCARE PRODUCTS LLP",
"SHYAMNAGAR VIVEKANANDA VIDYAPITH",
"INDRA GANDHI MEMORIAL HOSPITAL BHIWANDI",
"EXE ENG IRRIGATION DIVISION RAMNAGAR",
"GGSSS CHITTORGARH",
"ADMINISTRATIVE OFFICER FARIDABAD WEST DIVISION CENTRAL TAX COMMISSIONERATES GST FARIDABAD",
"GOLDEN PUBLIC SCHOOL",
"SHEKHAR SARRAF CHARITABLE TRUST",
"Z P C P S WADNER TQ KANNAD DIST-AURANGABAD",
"RELACY HEALTHCARE MANAGEMENT LLP",
"QUADRATIC CONSULTANTS PRIVATE LIMITED",
"UNNATI ACADEMY BADNAWAR",
"ICAR CENTRAL INSTITUTE FOR SUBTROPICAL HORTICULTURE",
"EX ENGR MECHANICAL DIVISION KOLHAPUR",
"SW RAJIV GANDHI MADHYAMIK VIDYALAYA LATUR",
"GSSS KAHARANI TIJARA",
"INDRAPRASTHA INSTITUTE OF INFORMATION TECHNOLOGY DELHI",
"ANNAPOORNA LUXURY AND AUTOMATIONS PRIVATE LIMITED",
"PSYPHER GAMES LLP",
"JYANI ASSOCIATES",
"THE CLARKS HOTELS & RESORTS",
"GGSSS BAGLA CHURU",
"HOTEL MARINA",
"AANDAVAR SILKS",
"THE BORAL UNION CO-OPERATIVE BANK LTD",
"ORIION CITICARE SUPER SPECIALTY HOSPITAL",
"MUDIPARA NN HIGH SCHOOL",
"PRANAVANANDA VIDYAMANDIR & GAIRIK",
"SAISUDHIR ENERGY LIMITED",
"PRINCIPAL GOVT HR SEC SCHOOL NUNERA DIST KORBA CG EDUCATION DEPARTMENT KORBA",
"EE PWD BANDR DIVB DEWAS MADHYA PRADESH",
"SHREE BALAJI ENTERPRISES",
"MONOHARPUR PRIMARY SCHOOL",
"GOVT OF JHARKHAND HIGH SCHOOL BISUNPUR",
"SARASWATI VIDYALAYA HIGH SCHOOL AND JUNIOR COLLEGE OF SCIENCE",
"J&K GRAMEEN BANK",
"DYAL SINGH COLLEGE KARNAL",
"D D V S SHIVPURI MADHYA PRADESH SHIVPURI",
"MAEERS VISHWASHANTI GURUKUL SCHOOL SOLAPUR",
"EXCUTIVE ENGINEER SHIMLA DIV NO III HPPWD",
"PIONEER A ONE GROUP",
"LCGC RESOLUTE APPLIANCES LLP",
"BHUSKADANGA BHOLANATH HIGH SCHOOL",
"AMERICAN INTERNATIONAL INSTITUTE OF MEDICAL SCIENCES",
"FLYING FLAMINGOS INDIA PRIVATE LIMITED",
"NEW ROOTS HAIR CLINIC PRIVATE LIMITED",
"SARASWATI VIDYALAYA HIGH SCHOOL & JR COLLEGE OF SCIENCE THANE",
"MAJEHERUL ULUM ISLAMIA SR MADRASAH",
"JERICHO FOODS AND BEVERAGES LLP",
"DAYASADAN AGARWAL VIDYALAYA",
"GOVT ITI RAIGARH",
"SMT SARASWATI GURUPADAPPA NAGAMARPALLI COLLEGE OF NURSING",
"ASHWINI RURAL MEDICAL COLLEGE",
"BHARATI VIDYAPEETH PUNE",
"GSSS KHANPUR",
"ANSH BAJAJ",
"KONARK EQUIPMENT SALES & SERVICE",
"HIMACHAL PRADESH TOURISM DEVELOPMENT CORP LTD",
"GANGAPURI SIKSHA SADAN",
"REDCROWN VENTURES LLP",
"COLLECTOR RAIGARH",
"KAPITAL GUARD FINANCIAL SERVICES",
"MUNICIPAL COUNCIL CHITTORGARH",
"DEVELOPMENT BLOCK JUBBAL SHIMLA",
"SHREE KESHARBA INSTITUTE OF NURSING",
"GRATTITUDE SYNERGY LLP",
"REGISTRAR HIGH COURT MP GWALIOR MADHYA PRADESH",
"DISTRICT EDUCATION OFFICER KEONJHAR",
"LAKSHYA CONSULTANT & RELATORS",
"SHAHID GANGARAM GSSS DHANDHANIYA",
"13776 DY DIRECTOR AYURVED DEPTT DISTRICT SRIGANGANAGAR",
"A S C O RATLAM",
"DISTRICT MALARIA OFFICER NME UNIT ONE",
"DIRECTOR TRI UDAIPUR",
"DEPARTMENT OF EXPENDITURE",
"SANT GADGE MAHARAJ MAGASVARGIYA HIGHSCHOOL",
"PCDA SC PUNE",
"401 DISTT PROGRAMME OFFICER(HQ) WCD SHIMLA",
"SPECIAL DUTY GROUP OLD JNU CAMPUS NEW DELHI",
"JAIPUR COLLECTOR JAIPUR",
"BEAUTY ESSENTIALS MARKETING INDIA LLP",
"CHAWAN BISLERI DILEER",
"M & J INSTITUTE OF OPHTHALMOLOGY AHMEDABAD",
"DAKSHAGNAA EDUCATIONAL SOCIETY",
"GLOBAL COLLEGE OF ENGINEERING AND TECHNOLOGY",
"BARASAT PRIYANATH BALIKA VIDYALAYA",
"ESSEN INFRATECH LLP",
"SHREE RAM ENGINEERS",
"DISTRICT LAPROSY OFFICE GODHRA",
"STIFFENERS PROPERTY VALUATORS CONSULTANTS",
"AHMEDABAD DISTRICT EDUCATION COMMITTEE MANAGED PRIMARY TEACHER",
"RPAO (TEXTILE) KOLKATA",
"30269 GSSS BHIMPURA",
"STRATTON REALTY LLP",
"TEHSILDAR KHANDWA",
"INTERNATIONAL PUBLIC SR SEC SCHOOL",
"B E O GOURIHAR CHHATARPUR MP",
"MOUNT CARMEL CONVENT SENIOR SECONDARY SCHOOL",
"VKNRL SCHOOL OF NURSING",
"PRIMARY ASHRAM SCHOOL (VJNT)",
"STAR DIAGNOSTIC CENTER",
"PAVNA INTERNATIONAL SCHOOL",
"Z P PRIMARY URDU SCHOOL MAMALADE",
"GSSS MALPURA JAWAJA",
"ENQUIP TECHNOLOGIES PRIVATE LIMITED",
"INDYPAY TECHNOLOGIES PRIVATE LIMITED",
"BLOCK¬† EDUCATION OFFICER JAORA RATLAM",
"GULSHAN NIWASI MATIMAND VIDYALAYA NILANGA",
"SUB DIVISIONAL AGRICULTURE OFFICER KARVIR",
"GSSS GAGWANA",
"REGIONAL REFERRAL HOSPITAL NASHIK",
"Z P PS JAKATWADI JAKATWADI",
"MARRIOTT EXECUTIVE APARTMENTS",
"MAHATMA GANDHI GOVT SCHOOL ENGLISH MEDIUM MAKDO BUHANA",
"CHIEF MEDICAL SUPERINTENDENT VEERGANA AVANTI BAI WOMEN‚ÄôS HOSPITAL LUCKNOW",
"SHIVKRUPA PRINT PACK PRIVATE LIMITED",
"GADH PAGAR KENDRA PRATHMIK SHALA 2",
"BLOCK CHIEF MEDICAL OFFICER BARMER",
"DY DIRECTOR GOVT LITHO PRESS ROORKEE",
"THE OXFORD ACADEMY",
"MEDZOR",
"RAJ CONSULTANTS",
"ASSAM MEDICAL COLLEGE",
"PELAD BUHARI PRIMARY SCHOOL TA-VALOD",
"RAJASTHAN MARUDHARA GRAMIN BANK PAPARDA",
"DISTRICT EDUCATION OFFICER JAJPUR",
"KSHETRIYA AAYURVEDIK AND YUNANI ADHIAKARI VARANASI",
"NXTGEN DATACENTER AND CLOUD TECHNOLOGIES",
"SHRI GAJANAN MAHARAJ BOILERS LLP",
"SOBEN INTERNATIONAL LLP",
"BARKHETRI JR COLLEGE MUKALMUA",
"T S R T & K S L I VDHYAMANDIR CHHALIYER",
"DIRECTOR AND WARDEN OF FISHERIES",
"VIGHNAHARTA HEART CARE AND IMAGINE CENTRE",
"GSSS CHHAN BAS SURYA",
"SARASWATI SCIENCE HIGHER SECONDARY SCHOOL",
"ITO JAMMU (GOVT DEPT)",
"NUEVOSOL MANUFACTURING PRIVATE LIMITED",
"AERON COMPOSITE LIMITED",
"BANSAL PUBLIC SCHOOL",
"ABACUS INSTITUTE OF ENGINEERING & MANAGEMENT(JV)",
"GSSS SAYON KA KHERA",
"SR MAHARANA PRATAP A I C SATIDHAM RAIPURI MIRZAPUR",
"JAYPEE UNIVERSITY OF INFORMATION TECHNOLOGY",
"E E FLOOD DIV 2 GORAKHUR",
"COMMUNITY HEALTH CENTER BHIWADI ALWAR",
"DISTT HOMOEOPAITHIC MEDICAL OFFICER JAUNPUR",
"JINDAL FINE INDUSTRIES",
"HUMS EDUCATION AND TRAINING PRIVATE LIMITED",
"IDZ DIGITAL PRIVATE LIMITED",
"EXECUTIVE ENGINEER FLOOD WORKS DIVISION ALLAHABAD",
"PT DR SHIV SHAKTILAL SHARMA AYURVEDIC COLLEGE",
"PARADISE PUBLIC SR SEC SCHOOL",
"DEPARTMENT OF HEALTH FAMILY WELFARE",
"ACCOUNTANT GENERAL (A&E) KARNATAKA BENGALURU",
"SHELL ELECTRICAL ENGINEERS",
"PRAFULLA NAGAR VIDYAMANDIR",
"COMMI OF YOUTH SERVICES & CULTURAL ACTI GANDHINAGAR",
"BIO CARE ASSOCIATES",
"C M AND H O DHAR MADHYA PRADESH",
"MAMLATDAR OFFICE SONGADH",
"CENTRAL RESERVE POLICE FORCE RECRUIT TRAINING CENTER AMETHI UP",
"WINART INDUSTRIES",
"020 REGISTRAR IPH DEPTT",
"MADHYAMIK VIDYALAYA TALWADE",
"GSSS FATEHPURA",
"AJITDADA PAWAR COLLEGE OF POLYTECHNIC",
"THE RAMAYANA HOTEL",
"CHILDREN HOME (OBSERVATION HOME) VYARA",
"MODERN SANDEEPNI SCHOOL",
"MAYOOR SCHOOL",
"OFFICE OF THE HEADMASTER HOOGHLY C0LLEGIATE SCHOOL (GOGT.)",
"INDICIUM INSIGHTS & TALENT LLP",
"ETERNAL PUBLICATION",
"MEDICITY FZR LLP",
"SHRI RAMA BHARTI SCHOOL",
"MGM'S COLLEGE OF ENGINEERING AND TECHNOLOGY MUMBAI",
"NAYANATARA AND SONS",
"HAZRAPOTA JUNIOR HIGH SCHOOL",
"YELLOW TRAIN SCHOOL",
"RAMA-EESH CHARITABLE TRUST",
"PANCHAYAT SAMITI BEED",
"3DE TECHNOLOGY PROTOTYPE SOLUTIONS PRIVATE LIMITED",
"BENDUA F P SCHOOL",
"KANYA MAHAVIDYALAYA",
"CITY CENTRE",
"AMRIT HOSPITAL",
"KING GEORGE V MEMORIAL",
"OFFICE OF THE CCE ( R & D) NORTH DRDO MINISTRY OF DEFENCE",
"JAIN SARVODAYA VIDHYA GYANPITH SAMITI (MIMS)¬†BHOPAL¬†",
"OFFICE OF THE EXECUTIVE ENGINEER ALIGARH DIVISION GANGA CANAL ALIGARH",
"SARVAJANIK HIGH SCHOOL DUNGARI",
"MARKANDA NATIONAL COLLEGE SHAHABAD MARKANDA",
"SHAYA POLYMERS LIMITED",
"DUTCHVIEW TECHNOLOGIES PRIVATE LIMITED",
"GSSS MENDWAS",
"OFFICE OF THE PRINCIPAL DIRECTOR OF COMMERCIAL AUDIT",
"RAJASTHAN MARUDHARA GRAMIN BANK LOTWARA",
"MISHODESIGNS",
"SPECTHRUM",
"CHIEF DISTRICT MEDICAL OFFICE MEDICAL AND TUBERCULOSIS AND LEPROSY PURI",
"MAHATMA GANDHI GOVT SCHOOL (ENGLISH MEDIUM) BANSA",
"TRUE LIFE CHARITABLE TRUST",
"SANTOSH INSTITUTE FOR MENTALLY CHALLENGED CHILDREN TRUST",
"THAKUR COLLEGE OF ENGINEERING & TECHNOLOGY",
"PEEO KAJIPURA",
"ORBIT SUPER SPECIALITY HOSPITAL",
"NANDAJHAR ADIBASI TAPASHILI HIGH SCHOOL",
"STATE GOVENRMENT OF MAHARASHTRA PANCHAYAT SAMITI",
"V C FASHION",
"B E O BADNAWAR",
"SHASTRY INSTITUTE OF PHARMACY",
"CHOITHRAM SCHOOL",
"VELANKANI AI AND CLOUD SOLUTIONS LLP",
"R.N ENTERPRISE",
"Z P SCHOOL MOHILI",
"MANAV CHARITABLE HOSPITAL",
"WORLDCARE CLINICAL (INDIA) PRIVATE LIMITED",
"LIFE N COLORS PRIVATE LIMITED",
"TINSUKIA ZILLA PARISHAD BORGURI TINSUKIA",
"GSSS DAULATPURA",
"GSSS OND MINNA",
"SUPERINTEDENTL SAHEED LAXMAN NAYAK MEDICAL COLLEGE AND HOSPITAL KORAPUT",
"TAJ CITY CENTRE NEW TOWN",
"OFFICE OF CHILD DEVELOPMENT PROJECT OFFICER AMRITSAR",
"NEW GREEN FIELDS SCHOOL SAKET",
"BOARD OF CONTROL FOR CRICKET IN INDIA",
"SUPERINTENDING ENGINEER BAN SAGAR CONSTRUCTION DIVISION-I MIRAJPUR",
"KARYALAY JANPAD PANCHYAT KHACHROD DIST UJJAIN",
"PUBLIC HEALTH AND FAMILY WELFARE DEPARTMENT GOVERNMENT MALE HEALTH WORKER TRAINING CENTER AMBIKAPUR DIST SURGUJA CHHATTISGARH",
"ICMR NATIONAL INSTITUTE OF OCCUPATIONAL HEALTH AHMEDABAD",
"HINDU VIDYAPITH FPS",
"GSSS MANDLACHARAN",
"LAMRIN TECH SKILLS UNIVERSITY PUNJAB",
"SILAPATHAR SCIENCE COLLEGE",
"BEEO REWALSAR",
"SHREE HARIHAR MAHADEV SECONDARY AND HIGER SECONDARY SCHOOL TEACHER COMMITEE",
"CIVIL SURGEON FARIDKOT",
"MEDICAL OFFICER COMMUNITY HEALTH CENTRE DHARAMASALA",
"GANDHI ACADEMY OF TECHNOLOGY AND ENGINEERING",
"JSA COLLEGE OF AGRICULTURE AND TECHNOLOGY",
"ADDL SR CIVIL JUDGE CUM ADDL CHIEF JUDICIAL MAGISTRATE NO 2 KOTPUTLI JAIPUR",
"DFO NACHAN",
"APEX PLUS SUPER SPECIALITY HOSPITAL",
"DAGADOJIRAO DESHMUKH D PHARMACY COLLEGE",
"DEPUTY INSPECTOR OF SCHOOLS RANGIA",
"VJ MEDIA MARKETING",
"GSSS PALDI MANGALIYA MANDOUR",
"SRI KUMARAN PUBLIC SENIOR SECONDARY SCHOOL",
"DISTRICT AND SESSION JUDGE SATNA",
"JR ASSOCIATES",
"INDIRA GANDHI INSTITUTE OF MEDICAL SCIENCES",
"RAJSHREE SUGARS RAMAKRISHNA VIDYALAYA MATRICULATION HIGHER SECONDARY SCHOOL",
"SHRI RAM AGRITECH INDIA",
"B E O (SHAHGARH) SAGAR DISTRICT SAGAR MADHYA PRADESH SAGAR",
"DEESA NAGAR PALIKA",
"TRIMURTI EDUCATION SOCIETY",
"VIKRAN ENGINEERING LIMITED",
"CENTER FOR MODERNIZING GOVERNMENT INITIATIVE",
"PATHARDI NAGAR PARISHAD",
"C U SHAH UNIVERSITY",
"THE ADMINISTRATIVE OFFICER SARVOPCHAR RUGNALAY DHULE",
"MOHALI WHEELS PRIVATE LIMITED",
"VSKY SOLUTIONS PRIVATE LIMITED",
"SHUBRAJ TECH PRIVATE LIMITED",
"OFFICE OF THE ASST DIRECTOR OF FISHERIES",
"OFFICE OF THE SUPERITENDING ENGINEER INDRAVATI PROJECT CIRCLE",
"UTTAR BUNIYADI KANYA VIDHYALAYA¬†BORSAD",
"SDF ENTERPRISES KOLHAPUR",
"BUILTCON CONSTRUCTIONS LLP",
"VIDYA INFRASTRUCTURE AND DEVELOPERS",
"CENTRAL GOVERNMENT HOSPITAL",
"OM EDUCATION TRUST",
"BLOSSOM SCHOOL ACCESSORIES PRIVATE LIMITED",
"NARAYANA HEALTH",
"HARITA SAMS LLP",
"ANCILE DIGITAL",
"DHARMA SAMAJ COLLEGE",
"THE TRIMURTI EDUCATION SOCIETYS",
"SARASWATI VIDYALAYA (PRIMARY) NAGPUR",
"SREE SANNIDHI FOODS PRIVATE LIMITED",
"SARATHA INTERNATIONAL SENIOR SECONDARY SCHOOL",
"INDU SCCL CORUM CONSORTIUM",
"ODM EDUCATIONAL FOUNDATION",
"DIVISIONAL AYURVEDIC & UNANI OFFICER BAREILLY",
"RUSHVI HOSPITAL",
"SRI RAMAKRISHNA MATRIC HIGHER SECONDARY SCHOOL",
"HIREEASY CONSULTING LLP",
"MATOSHRI GIRIJABAI DHOBALE WOMEN'S COLLAGE COLLAGE OF EDUCATION JULE SOLAPUR",
"SHREE NARAYAN MEDICAL INSTITUTE AND HOSPITAL",
"CHEIF DEVELOPMENT OFFICER MIRZAPUR",
"GK PRINT PACK EXHIBITION LLP",
"THE MAHARASHTRA AGRO INDUSTRIES DEVELOPMENT CORPORATION LIMITED",
"GSSS POSHAL",
"UDAIPUR DCF",
"EI SAMAY WEST BENGAL INDIA",
"BHARATHIAR UNIVERSITY",
"GURU NANAK KHALSA SCHOOL",
"INDIA NATURAL RESOURCE ECONOMIC AND MANAGEMENT FOUNDATION",
"B E O GANDHWANI",
"GOVERNMENT OF CHHATTISGARH DEPTT OF LAW & LEGAL AFAIR OFFICE OF PRINCIPAL DISTRICT & SESSION JUDE RAIPUR",
"LFC CONSULTING PRACTICE LLP",
"ROYALIMPERIAL EVOLUTION LLP",
"DIWAN HOSPITAL",
"OFFICE OF THE JOINT DIRECTOR HORTICULTURAL EXPERIMENT AND TRAINING CENTER SAHARANPUR",
"AMALNER NAGARPARISHAD KARAYALAYA",
"SHIV SHATI HOME",
"R P S DEGREE COLLEGE",
"JILA SAHAKARI KENDRIYA BANK MARYADIT MORENA",
"COMMISSIONER LAND RECORDS AND SETTLEMENT M.P. GWALIOR",
"SGML EYE HOSPITAL HASAMPURA UJJAIN",
"AGRICARE CHEMICAL INDUSTRIES",
"S K INTERNATIONAL",
"RAJEEV INSTITUTE OF AYURVEDIC MEDICAL SCIENCE AND RESEARCH CENTRE",
"DUNECREST UNIVERSAL PRE SCHOOL",
"PRINCIPAL GSSS SHAMALAGHAT",
"BIDHANNAGAR GOVT HIGH SCHOOL",
"LOKMANYA MAHAVIDYALAYA",
"GOVT OF JHARKHAND DISTRICT ADMINSTATION",
"SP INTERNATIONAL",
"KALYANGARH SANSKRITI SANGHA SIKSHANIKETAN",
"MUNICIPAL BOARD NATHDWARA",
"PARMAR HOSPITAL",
"SUB DIVISIONAL MAGISTRATE OFFICE RUDRAPUR",
"GOVERNMENT OF JAMMU & KASHMIR IRRIGATION DIVISION II JAMMU",
"BATTERLIFE TRIBE LLC",
"GSSS GHANAKAPURA RAJAKHERA",
"MUMBAI CENTRAL",
"B E O KHURAI MADHYA PRADESH SAGAR",
"ZPPS¬†PAPALWADI",
"MOIC COMMUNITY HEALTH CENTRE GADARPUR",
"THIP HEALTHTECH PRIVATE LIMITED",
"PRAMUKH SWAMI PHARMA LIMITED",
"GEPSI IMMIGRATION SERVICES PRIVATE LIMITED",
"DGA AUTOMATION INDIA PRIVATE LIMITED",
"SIAMO LIFESTYLE PRIVATE LIMITED",
"SPORTS",
"K P T C EMPLOYEES CREDIT CO-OP SOCIETY LTD",
"SD SPORTING ELEMENTS LLP",
"GUPTA PRINTEX & POLYMERS",
"CENTIUM CONSULTING INDIA LLP",
"KERALA STATE GOVERNMENT",
"YRTV MAT HR SEC SCHOOL",
"J B FRAGR AND FLAVOURS",
"PIMS MEDICAL AND EDUCATION CHARITABLE SOCIETY JALANDHAR",
"ADMIN BRIGHT LLP",
"SHRI MATA VAISHNO DEVI SHRINE BOARD",
"DAYANAND COLLEGE AJMER",
"MAHATMA GANDHI INSTITUTE FOR COMBATING CLIMATE CHANGE(G O V T OF N C T OF DELHI)",
"DELTATRE LIMITED",
"GHATIHARANIA HIGH SCHOOL HS",
"BLOCK CHIEF MEDICAL & HEALTH OFFICER BASI JAIPUR",
"PLUTUS MULTITECH LLP",
"618 EXCUTIVE ENGINEER SHIMLA DIV NO III HPPWD",
"SHREE ADITYA NARAYAN SINGH PUBLIC SCHOOL",
"PANCHAYAT SAMITI SANGOD",
"MAGNUM ENGINEERING",
"FIRE AND EMERGENCY SERVICES ASST DIVISIONAL OFFICER CENTRAL ZONE PONDA",
"P A HOLKAR VIDYALAYA RANISAWARGAON",
"GSSS GONER",
"PADMABUSHAN VASANTDADA PATIL GOVERNMENT HOSPITAL SANGLI",
"RSRTC M NAGAR DEPOT",
"MERU ACCOUNTING PRIVATE LIMITED",
"PAO O/O THE AG (A & E) II MAHARASHTRA NAGPUR",
"HYATT REGENCY KOLKATA",
"SHRI J B UPADHYAY DEAF MUTE SCHOOL TALOD",
"K V N PRIMARY ASHRAM SCHOOL ANANDNAGAR",
"ECOR SAMBALPUR",
"SAGGU HI TECH ENGINEERS",
"NAVRANGPURA ( R & B ) DIVISION AHMEDABAD",
"M R TUBES PRIVATE LTD",
"ADDICTIVE MARTECH LLP",
"AEN GWD JALOR",
"PENTA LATEX LLP",
"AMABALA DIVISION",
"ATOMIC ENERGY EDUCATION SOCIETY",
"RAIN FOREST RESEARCH INSTITUTE JORHAT ASSAM",
"THIRUVERKADU MUNICIPALITY",
"GSSS JARKHODA",
"PARUL INSTITUTE OF AYURVED AND RESEARCH GUJRAT",
"ANUDANIT SECONDARY ASHRAM SHALA REWADI",
"ENGINEER OFFICER IPH CIRCLE SHIMLA 9",
"RK INFRA",
"PRIN PG COLLEGE TKG MADHYA PRADESH TIKAMGARH",
"B E O (PRATHIVIPUR) DIST NIWARI MADHYA PRADESH NIWARI",
"APARNAA WORLD SCHOOL",
"MP TECHNOLOGIES",
"DELHI PUBLIC SCHOOL PATNA",
"YESHWANTRAO HOLKAR VIDYALAYA",
"SANJAY GHODAWAT INSTITUTE",
"B E O NALCHHA",
"GSSS NADANABHATAN",
"KASHI NARESH RAJKIYA SNATKOTTAR MAHAVIDYALAYA¬†",
"M/S ARUN ASSOCIATES",
"SITABAI ARTS COMMERCE AND SCIENCE COLLEGE AKOLA",
"TRIAARSHA EDUCATIONAL SOCIETY",
"INTERACTIVE LABS PRIVATE LIMITED",
"SAI MICROSYSTEMS PVT LTD",
"RELINNS TECHNOLOGIES PRIVATE LIMITED",
"MERIL MEDICAL INNOVATIONS PRIVATE LIMITED",
"GITA IT PRIVATE LIMITED",
"FREDDIE'S DINER",
"OFFICE OF THE MUNICIPAL COUNCIL CHAMPA",
"TINGKHONG H S SCHOOL",
"SOUTH INDIAN CREDITS LIMITED",
"TAP ACADEMY",
"OFFICE OF THE BLOCK DEVELOPMENT EDUCATION OFFICER BAKAWAND",
"GOVT HSS KHARVAKALA",
"PRINCIPAL ACCOUNTANT GENERAL (AUDIT) TELENGANA",
"GOVT PUBLIC HEALTH AND WELFARE DEPT",
"PR AG (GANDSSA) KARNATAKA",
"PR GSSS (G ) MANDI HP",
"FAME INTERNATIONAL",
"ENGINEERS INDIA CONSTRUCTION CO",
"GEWAN INFO TECH SOLUTIONS INDIA PRIVATE LIMITED",
"J B C HIGH SCHOOL JAMTARA",
"OFFICE OF THE BLOCK ELEMENTARY EDUCATION OFFICER KAKOPATHER CHELLENGURI",
"OPEN SKY SCHOOL",
"TAHSILDAR RAGHURAJ NAGAR SATNA",
"083 D D (INDUSTRIES)",
"THE RAJASTHAN STATE CO OPERATIVE BANK LTD",
"SETTLEMENT COMMISSIONER RAJASTHAN JAIPUR",
"DIRECTOR STATE TRANSPORT",
"PRINCIPAL MEDICAL OFFICER NEEMKATHANA SIKAR",
"AEN PHED SUBDIVISION RAMGARH PACHWARA (DAUSA)",
"NWN INDIA",
"DIRECTORATE OF AGRICULTURE",
"ASSTT SOIL CONSERVATION OFFICE RTM",
"CROWNTECH SURFACE FINISHINGS PRIVATE LIMITED",
"A O FOR INSPECTOR GENERAL OF REGISTRATION M P BHOPAL MADHYA PRADESH",
"NOVELTY DATA SOLUTIONS LLP",
"HARINKHALI ADIBASI F P",
"BIPRADASPUR F P SCHOOL",
"DY EDUCATION OFFICER ELEMENTARY",
"MEDICAL OFFICER COMMUNITY HEALTH CENTRE ATHAGARH BERHAMPUR",
"SAHARI AJIVIKA KENDRA CLC",
"VISION TIME INDIA LIMITED",
"MDN GLOBAL SCHOOL",
"OFFICE OF THE PRINCIPAL GOVT ENGINEERING COLLEGE JAGDALPUR DISTT BASTAR CHHATTISGARH",
"SCHOOL EDUCATION DEPARTMENT BLOCK EDUCATION OFFICER DARBHA",
"SLR PHARMA PRIVATE LIMITED",
"HIMACHAL PRADESH DEPARTMENT OF HOME GUARDS",
"SMART WORK SOLUTIONS",
"SHRI BHARUDI PRIMARY SCHOOL",
"DDO DEBT RECOVERY TRIBUNAL",
"LIFE LINE EDUCATION TRUST",
"TOP RANKER INTERNATIONAL SCHOOL",
"TELANGANA UNIVERSITY",
"XTRACIT",
"DASMESH GLOBAL SCHOOL",
"GOVERNMENT POLYTECHNIC KOLHAPUR",
"KOHINOOR CLOTHS STORES LLP",
"GSSS HIRANAWALI",
"BLUE OCEAN",
"JK HRMS (JAMMU AND KASHMIR HUMAN RESOURCE MANAGEMENT SYSTEM)",
"SACHDEVA PUBLIC SCHOOL",
"NAGPUR CITY MULTISTATE CO OPERATIVE CREDIT SOCIETY LTD NAGPUR",
"TEJAS CARGO INDIA LIMITED",
"TKP ENGINEERING SOLUTIONS PRIVATE LIMITED",
"RAJMANE SERVICES PRIVATE LIMITED",
"BIKANER TEHSILDAR (REVENUE) KHAJUWALA",
"SECTION OFFICER DIRECTOR GENERAL CIVIL AVIATION R K PURAM NEW DELHI",
"BAAGWAAN IRRIGATION PRIVATE LIMITED",
"RASHTRIYA BAL SWASTHYA KARYAKRAM (NATIONAL HEALTH MISSION HP)",
"GSSS FOJU WALA RAISINGHNAGAR (SRI GANGANANAGR)",
"SUMERMAL JAIN PUBLIC SCHOOL",
"GUJARAT CO-OPERATIVE MILK MARKETING FEDERATION LIMITED",
"SUPERINTENDING ENGINEER PUBLIC HEALTH DIVISION BHUBANESWAR",
"BLOCK EDUCATION OFFICE ODAPADA",
"SOLUTION CONSULTANTS",
"EXECUTIVE ENGINEER I&PH MANDI",
"UTTAM GROUP",
"GANDHI SMARAK P G COLLEGE",
"MARIA MATA CONVENT HIGH SCHOOL CHHATARPUR",
"GSSS RUPNAGAR",
"RURAL WORKS DEPARTMENT",
"ALAKNANDA ACADEMIC SCHOOL",
"ZIROH LABS PRIVATE LIMITED",
"AAHAN CORPORATE LLP",
"TOLLANIS SOLUTIONS LLP",
"M/S KARAM ENTERPRISES",
"TEKACCEL SOFTWARE SERVICES LLP",
"E O NAGARPALIKA RAJGARH",
"9643 AEN PHED CITY SUB DIV 7 AJMER",
"ZEN PROMOTERS LLP",
"MICRO IRRIGATION & COMMAND AREA DEVELOPMENT AUTHORITY",
"P B ASSOCIATES",
"MIRI PIRI KHALSA ACADEMY",
"PRIMARY HEALTH CENTER YELAMBHGHAT BEED",
"SANSKRUTI BUILDCON",
"Z P URDU P INDIRA AWAS BARSHITAKALI",
"GSSS MUNDAWAR",
"MAHATMA GANDHI GOVT SCHOOL ENGLISH MEDIUM NAHARGARH KISHANGANJ",
"GOVT SENIOR SECONDARY SCHOOL TASOL",
"PRINCIPAL ACCOUNTANT GENERAL A AND E",
"SUKHMANI CHILDREN HOSPITAL",
"GOVT SENIOR SECONDARY SCHOOL JEETALA",
"KARYALAY JANPAD PANCHAYAT BHAYATHAN SURAJPUR",
"ZPPS DHAMDHAM",
"DISTT MALARIYA GUNA MADHYA PRADESH",
"NATIONAL STANDARD TYRE MOULDS (INDIA) LIMITED",
"BHARATHIDASAN INSTITUTE OF TECHNOLOGY CAMPUS",
"MILITARY HOSPITAL MATHURA",
"ASSTT GARRISON ENGINEER (MES)",
"QUALITY FASTENERS INDIA",
"ZPPPS BOTHI TANDA CHAKUR",
"EXCEL SERVICES",
"GOVERNMENT OF ASSAM TINGKHONG COLLEGE TINGKHONG",
"BLOCK MEDICAL OFFICER PACHHAD",
"DRONE IMAGING & INFORMATION SERVICES OF HARYANA LIMITED",
"ELEVATE HOMES PRIVATE LIMITED",
"GOVERNMENT OF WEST BENGAL SUPERINTENDENT WALSH S D HOSPITAL SERAMPORE HOOGHLY",
"ALLINDIAN IT SERVICES LLP",
"THE BHAWANIGARH KISSAN CO OPERATIVE MARKETING COM PROCESSING SOCIETY LIMITED",
"DANIELSON HIGHER SECONDARY SCHOOL",
"SWAMI RAMCHANDER MEMORIAL INTERNATIONAL SCHOOL",
"ADITYA IMPEX",
"ST DOMINIC'S SR SEC SCHOOL",
"GOVT OF CHHATTISGARH REVENUE DEPARTMENT",
"BLOCK EDUCATION OFFICER KUJANG",
"CKS THEJA INSTITUTE OF DENTAL SCIENCES AND RESEARCH",
"DY COMMISSIONER ADM CONNERCIAL TAXES MEERUT",
"WARDEN GOVT. S T BOYS HOSTEL KARANJA",
"HIREPRO TECHNOLOGIES PRIVATE LIMITED",
"C S I BISHOP CORRIE ANGLO INDIAN HIGHER SECONDARY SCHOOL",
"COLLEGE OF VETERINARY SCIENCE AND ANIMAL HUSBANDRY JABALPUR",
"GOVT UMS SUGAULI",
"UNITED COKE PRIVATE LIMITED",
"KLINE INDIA RESEARCH AND CONSULTING PRIVATE LIMITED",
"NAVY CHILDREN SCHOOL VISAKHAPATNAM",
"SILVER CREST HOSPITAL DOMBIVLI",
"SUKUR H P INSTITUTION",
"DISTRICT AND SESSIONS JUDGE BARNALA",
"SOUTH EASTERN RAILWAY KHARAGPUR DIVISION",
"OFFICE OF THE DDHS(E&S) CMS",
"GGSSS 29 SSW (HANUMANGARH)",
"BLOCK EDUCATION OFFICER DEPALPUR",
"TAHSILDAR ALAPUR AMBEDKARNAGAR",
"SITARAM RAMA PATIL VIDYALAY",
"HAPPYFOX TECHNOLOGIES LLP",
"AIM INDIA LOGISTIC LLP",
"ZION MATRIC HR SEC SCHOOL",
"LATE BABASAHEB VARHADE URDU MADHYAMIK VIDYALAYA KASBEGAVHAN",
"COSTYLEE APPARELS PRIVATE LIMITED",
"FRANK TECHNOLOGIES PRIVATE LIMITED",
"CBEO ATRU",
"OFFICE OF THE BLOCK EDUCATION OFFICER JAGDALPUR DISTT BASTAR CHHATISHGARH",
"SALES TAX OFFICE MUMBAI",
"GEETA INSTITUTE OF LAW",
"GRAMIN PRASHALA MADAJ",
"AAYUSH GROUP OF HOSPITAL JUNAGADH",
"ACRON WATERFRONT RESORT",
"THE DY DIRECTOR GENERAL EASTERN REGION 5 MIDDLETION STREET CALCUTTA",
"MUNICIPAL COUNCIL BHAWANIGARH",
"JIIU‚ÄôS MOTHER HAWWA COLLEGE OF ENGINEERING",
"E O MUNICIPALY BANDIKUI",
"GASTRO CARE KOTA",
"SER KHARAGPUR DIVISION",
"SCHOOL EDUCATION DEPARTMENT GOVT HIGHER SECONDARY SCHOOL GUMGARAKALA BLOCK LAKHANPUR SURGUJA",
"FNS INTERNATIONAL LIMITED",
"ANEETA PLASTPACK LLP",
"DISTRICT AND SESSION JUDGE DHAR",
"KARTAR FASHIONS PRIVATE LIMITED",
"BHAI PARMANAND VIDYA MANDIR",
"RUDRA AGRI DIVISION",
"18005 GSSS TASAUL RAJSAMAND",
"DIGAMBER SWAMI P S",
"B E O THIKARI",
"MADRASA ARABIA MISBAHUL ULOOM ASAUNJI BAZAR GORAKHPUR",
"LATE KISHANRAOJI PATIL PRIMARY ASHRAM SCHOOL KAVATHA",
"GOKILAMBAL INTERNATIONAL SCHOOL",
"DEPUTY DIRECTOR OF EDUCATION DISTRICT NORTH-EAST",
"C R D A V PUBLIC SENIOR SECONDARY¬†SCHOOL",
"UNIVERSITY OF AGRICULTURAL SCIENCES RAICHUR",
"SRIMAD ANDAVAN ARTS AND SCIENCE COLLEGE TRICHY",
"QUANTUM STRIDES INDIA PRIVATE LIMITED",
"LEONARD LOGISTICS PRIVATE LIMITED",
"RUDRA BUILDCON",
"TALUKA SEED FARM WADA",
"MAHARASHTRA HINDI VIDYALAYA (SEC) AURANGABAD",
"SHREE ALPHA VIDHYA SANKUL",
"PANIGHATTA H S SCHOOL",
"HERITAGE SCHOOL OF NURSING",
"GODANI METAL CO",
"NAVYUG PUBLIC SCHOOL",
"BAMUNPUKHURI HIGH SCHOOL",
"THE VENKATESHWAR SCHOOL",
"OFFICE OF THE PRINCIPAL RANGAPAT HIGHER SECONDARY SCHOOL",
"NATIONAL RURAL HEALTH MISSION",
"INDIAN BANKS' ASSOCIATION",
"RADIANCE ENGINEERING AND SERVICES",
"ZILHA PARISHAD PRATHMIK SHALA BHANSHIWARE NEWASA",
"PANJAB UNIVERSITY",
"GLOBAL FORKLIFTER & MHE SOLUTIONS",
"206 PRINCIPAL TANG NARWANA",
"B E O BARWAHA",
"SAI GARBHA FERTILITY CENTER",
"PRIMARY HEALTH CENTRE NITUR TQ NILANGA",
"LMDMAX INDIA PRIVATE LIMITED",
"DISTRICT & SESSION COURT MORADABAD",
"ECO LIGHT DIAMOND",
"N S C GOVERNMERT MEDICAL COLLEGE KHANDWA",
"LIKE MINDS SOFTWARE INDIA PRIVATE LIMITED",
"ASSISTANT DIRECTOR HORTICULTURE CHHATARPUR",
"JODHPUR TEHSIL BALESAR JODHPUR",
"SRI MA VIDYALAYA",
"SWAMI VIVEKANND URBAN CO OP CREDIT SOCIETY LTD BEED",
"GOPAL STEELS",
"CROWN PACKAGING",
"MUNICIPAL COUNCIL BHIWANI",
"AIR INDIA MODERN HIGH SCHOOL",
"GARRISON ENGINEER ARMY NO 1",
"SHREE RAGHUVIR COTTEX",
"020 REGISTRAR(IPH) DEPTT (VIG.)",
"INDIAN INSTITUTE OF MANAGEMENT VISAKHAPATNAM",
"CAPSURANCE INSURANCE BROKERS LIMITED",
"M/S PANDITHYA EDUCATION TRUST HASSAN",
"LATUR URDU PRIMARY SCHOOL LATUR",
"ADDI CIVIL JUDGE & METROPOLITAN MAGISTRATE N0 7 JODHPUR",
"GURU NANAK DEV POLYTECHNIC COLLEGE",
"BRADFORD INTERNATIONAL SCHOOL",
"GSSS JHAMBER HANUMANGARH",
"JAWAHARLAL NEHRU MEMORIAL FUND",
"HEALTH DEPARTMENT DEPARTMENT OF HEALTH AND FAMILY¬†WELFARE",
"GOPALAN ENTERPRISES",
"ANAND CHARITABLE SANSTHA GANGAI PHARMACY COLLEGE KADA",
"17 BUTALION MAHAR REGIMENT",
"Z P P MARTHI SCHOOL VAZEGAON",
"OFFICE OF THE PRINCIPAL UNIVERSITY ARTS & SCIENCE COLLEGE",
"VALLABHBHAI D SACHAPRA",
"TRIBAL DEVELOPMENT DEPARTMENT",
"27886 GSSS SAHAJAN PURA CHIPABADOD BARAN",
"WT TECHNOLOGIES PRIVATE LIMITED",
"ZED PLUS BLOWERS SYSTEM PRIVATE LIMITED",
"GOVERNMENT OF JAMMU & KASHMIR EXECUTIVE ENGINEER MACHINERY DIVISION JAMMU",
"GAD PANCHAYAT SAMITI BEED",
"VENKATESHWARA GROUP OF INSTITUTIONS",
"DORMAN PRODUCTS INDIA LLP",
"COLLECTTORATE BARABANKI",
"ZENITH COMMERCIAL",
"DISTRICT COMDT H G SAGAR",
"JHANKAR SENIOR SECONDARY SCHOOL",
"HIMACHAL PRADESH STATE INDUSTRIAL DEVELOPMENT CORP LTD",
"LATUR PATTERN SCIENCE ACADEMY OSMANABAD",
"MADHURI REMEDY HOSPITAL",
"FABMONT ENGINEERING LLP",
"INTECHHUB SOLUTIONS",
"DEFENCE METALLURGICAL RESEARCH LABORATORY",
"SHRI BHAUSAHEB POTEY VID AND JUNIOR COLLEGE AKOT",
"DISTRICT FAMILY WELFARE BUREAU ZILLA PARISHAD THANE",
"MANIFOLD COMMUNICATIONS INDIA LLP",
"HOSPITALITY ORGANISATION",
"BOSS HYDRAULICS LLP",
"GUJARAT BIOTECHNOLOGY RESEARCH CENTRE",
"21402 D E O (H Q) SEC EDU CHITTORGARH",
"DELHI HEART INSITITUTE AND MULTISPECIALITY HOSPITAL",
"KANVAS TRAVEL SERVICES PRIVATE LIMITED",
"KP TENDER ADVISOR PRIVATE LIMITED",
"SHRI RAM CHANDRA AYURVEDIC MEDICAL COLLEGE & HOSPITAL LUCKNOW",
"ODETOCLOUD SOLUTIONS LLP",
"DR BR AMBEDKAR OPEN UNIVERSITY",
"SHREE KOLAK SARVAJANIK VIDYALAYA KOLAK",
"29500 GSSS DABLA KHASOLI",
"NEW ALIPURE COLLEGE",
"DISTT HORTICULTURE OFFICER NAINITAL",
"TAHSIL OFFICE VAIJAPUR",
"SUPERITENDENT ENGINEERING RURAL ENGINEERING SERVICE UJJAIN",
"PRINCIPAL GIC SULTANPUR",
"PANGKA R H HIGH SCHOOL",
"BHAGWAN PARSHURAM PUBLIC SCHOOL",
"JALGAON JANATA SAHAKARI BANK LTD",
"TIKAR VARDAN DEVELOPMENT FOUNDATION",
"SRI SHANKARLAL JEWELLERS",
"BRINDAVAN VIDYALAYA MATRICULATION HR SEC SCHOOL",
"515 ARMY BASE WORKSHOP BENGALURU",
"BLOCK ELEMENTARY EDUCATION",
"SHRI RAGHUBIR MADHYAMIK VIDYALAYA KANDIVALI E",
"SEALANT ENTERPRISES",
"23366 BLOCK CHIEF MEDICAL OFFICER JAYAL (NAGAUR)",
"HK SAGAR REALTORS LLP",
"24729 DISTRICT & SESSIONS JUDGE CHITTORGARH",
"R N G PATEL INSTITUTE OF TECHNOLOGY",
"GOVERNMENT OF ASSAM DIBRUGARH BENGALI HIGH SCHOOL",
"LOYOLA SCHOOL BHUBANESWAR",
"D D V S DHAR",
"CBEO CUM BRCF KOTA CITY",
"ADGAON HIGH SCHOOL ADGAON",
"PIMPARI CHINCHWAD MATHADI AND UNPROTECTED WORKER BOARD",
"SHIKSHAN MAHERSHI DDASAHEB RAWAL PRATHAMIK SCHOOL DONDAICHA TAL SHINDKHEDA DIST DHULE",
"GOVT CO ED SEC SCHOOL NEB SARAI",
"MUNICIPAL BOARD MAHWA",
"PES INSTITUTE OF MEDICAL SCIENCES RESEARCH",
"GEETADEVI KHANDELWAL INSTITUTE OF PHARMACY",
"AYUSH DIALYSIS CENTER",
"SHRI SWAMI SAMARTH VIDYA NIKETAN‚ÄôS KANAIYALAL RAVJIBHAI PUBLIC SCHOOL",
"311034 GSSS KARANISAR ANUPGARH",
"SECRETORY C G STATE ST COMMISSION RAIPUR",
"PRATIKSHA EDUCATIONAL TRUST",
"35542 DISTRICT HOSPITAL PRATAP NAGAR JODHPUR",
"22231 BLOCK CHIEF MEDICAL OFFICER RAMGARH (ALWAR)",
"D S COLLEGE ALIGARH",
"KARAN PUBLIC SCHOOL EDUCATIONAL SOCIETY",
"OFFICE OF THE FOOD DRUG ADMINISTRATION AUTHORITY",
"CHIEF CONSTRCUTION ENGINEER ANANDAPUR BARRAGE PROJECT SALAPADA",
"MAHENDRA ENGINEERING & CONSULTANCY",
"ACER TAX & CORPORATE SERVICES LLP",
"DHARMASHASTRA NATIONAL LAW UNIVERSITY JABALPUR DISTRICT JABALPUR MADHYA PRADESH",
"SHRI KANHA STAINLESS LIMITED",
"HQ RTG ZONE (MP&CG) JABALPUR",
"GILT EDGE BUILDCON PRIVATE LIMITED",
"DRISHTI IAS",
"KEMIEZEN LIFESCIENCES LLP",
"LIMENDO INDIA PRIVATE LIMITED",
"PRAJA MNADAL MAHILA COLLEGE NAYAGARH",
"NMDC APOLLO CENTRAL HOSPITAL",
"B E O SARDARPUR",
"DARBHANGA COLLEGE OF ENGINEERING",
"UMS PANDRA BEJRA URDU ( GOVT OF JHARKHAND)",
"INTELLIMANTRA INFOWEB PRIVATE LIMITED",
"IQRA QUALITY SERVICES PRIVATE LIMITED",
"RAJEEV HOSPITAL",
"DIRECTOER STATE TRANSPORT",
"BHAARGAV CLINICAL LABORATORY",
"SHRI JYOTI VIDHYAMANDIR CHANDRALA",
"JASLOK HOSPITAL & RESEARCH CENTRE",
"JILA SAHAKARI KENDRIYA BANK MARYADIT DHAR",
"A G AANDE JHARKHAND RANCHI",
"VERBOLABS LANGUAGES (OPC) PRIVATE LIMITED",
"CONTETRA PRIVATE LIMITED",
"DISTRICT HORTICULTURE OFFICER NAINITAL",
"GOVERNMENT OF JAMMU & KASHMIR DIVISIONAL FOREST OFFICER",
"OFFICE OF THE EXECUTIVE ENGINEER DIVISION IRRIGATION NAHARKATIA",
"GMT PUBLIC SCHOOL",
"SANT BALUDEV MAHARAJ VIDYALAY",
"GENERAL HOSPITAL GANDHINAGAR",
"GSSS DEVPURI",
"SUB JAIL SANCHORE",
"HOME & HILL AFFAIRS DEPARTMENT",
"11550 GSSS KALRU",
"GSSS BASNA JAMWARAMGARH",
"CYARA OPERATIONS INDIA PRIVATE LIMITED",
"GSSS MANOHARPURA",
"MS BRAJ MOHAN SHARMA",
"THE BIRLA AND HARJIVANDAS HIGH SCHOOL DHANDHUKA",
"ASST COMM TRIBAL SAGAR",
"SHREE WARANA SAHAKARI BANK LTD",
"RAMCHAKI F P SCHOOL",
"SOFTMINT DIGITAL SERVICES PRIVATE LIMITED",
"RELIANCE BIO ENERGY LIMITED",
"LAKHANI JORDAN ENGINEERS PRIVATE LIMITED",
"GSSS GARINDA",
"EMPOWER (GREAT WEST)",
"DIRECTORATE OF TECHNICAL EDUCATION UTTAR PRADESH",
"GSSS KUI JODHA",
"DIV J D KISAN KALIYAN AND KRASHI VIKAS",
"ADDITIONAL CHIEF ENGINNER PWD ZONE¬†1 JODHPUR",
"GSSS ASTAWAN",
"LIVING STONE SOCIETY",
"GOVT OF JHARKHAND C S OFFICE DHANBAD",
"VIVANTA HOSPITAL",
"DEPARTMENT OF JUSTICE NEW DELHI",
"SHRI KRISHNA SR SEC SCHOOL",
"DOABA KHALSA SENIOR SECONDARY SCHOOL",
"OFFICE OF EXECUTIVE ENGINEER TUBEWELL BLOCK L ALIGARH",
"RADHE MULTI-SPECIALITY HOSPITAL",
"DISTT AYUSH OFFICER DHAR",
"BIRLA INSTITUTE OF TECHNOLOGY MESRA RANCHI",
"2638 MAHATMA GANDHI GOVT SCHOOL GNR",
"OFFICE OF THE PRINCIPAL GOVT H S SCHOOL JAGDALPUR DIST BASTAR (C G)",
"AVILLION INFRASTRUCTURE",
"AXIS MY INDIA LIMITED",
"PRINCIPAL ACCOUNTANT GENERAL (AUDIT) BIHAR",
"MAHARASHTRA NIGHT HIGH SCHOOL CHEMBUR MU",
"DR RAI HOSPITAL SUPERSPECIALITY HOSPITAL SAGAR",
"B E O (SEGAON) KHARGAON",
"DIVISIONAL COMMISSIONER ROHTAK",
"DHULIA JHUPKHALI F P SCHOOL",
"CUTECODE STREET STYLE STORE LLP",
"MIGRATES OVERSEAS CONSULTANCY LLP",
"GLOBAL HOSPITAL",
"INDIAN INSTITUTE OF TECHNOLOGY BHILAI RAIPUR DURG CHATTISGARH",
"LALA ISHAR DASS GUMBER DAV CENTENARY SR SEC PUBLIC SCHOOL",
"KARYALAY NAGAR PALIKA PARISAD DAMOH DISTRICT",
"KALYANAM KAROTI",
"PEEO MUNGANA",
"EXECUTIVE OFFICER PANCHAYAT SAMITI PATRAN",
"2382 GGSSS MIRJAWALA SRIGANGANAGAR",
"SEKHA INDANE GRAMIN VITRAK",
"PEEO MANDLACHARAN",
"CORWIN EAGLE SAFECARE PRIVATE LIMITED",
"JAYCO GLOBAL PRIVATE LIMITED",
"AFLOAT CONTAINER LINES INDIA PRIVATE LIMITED",
"RATNAMANI FINOW SPOOLING SOLUTIONS PRIVATE LIMITED",
"M BALMIKI M/SCHOOL BANDGAON",
"SHRI SADGURU SEVA SANGH TRUST",
"INFINITY MULTISPECIALITY HOSPITAL",
"SWAMI DAYANANDA COLLEGE OF ARTS & SCIENCE",
"SMT SUHASINI ADHIKARI PRIMARY SCHOOL",
"MAHARASHTRA GEOSPATIC DATA CENTER PUNE",
"MAHARASHTRA VIDYALAYA SHELGI TQ NILANGA",
"NFR GUWAHATI",
"PDX RESEARCH LABS LLP",
"EMBEE NEXTGEN SERVICES LLP",
"GUJARAT MARITIME BOARD SURAT",
"GSSS RUPAHELI",
"EXE ENGG P H E D RTM",
"GLOBAL MANAGEMENT SERVICES",
"GOVERNMENT OF ASSAM BELTOLA COLLEGE",
"GOVERNMENT OF ASSAM MORAN COLLEGE",
"DAYAWATI MODI ACADEMY",
"A CLASS FASTENERS",
"C M AND H O CHHATARPUR MADHYA PRADESH CHHATARPUR",
"NFR CONSTRUCTION HQ MALIGAON",
"AMOGH PLAST",
"SANYOG ENGINEERS",
"EKTA SHAKTI FOUNDATION",
"Q SECURITY SERVICES",
"ONLINE24X7 INDIA PRIVATE LIMITED",
"SSC LOGISTICS PRIVATE LIMITED",
"INVERGENCE ANALYTICS PRIVATE LIMITED",
"SUNDAWN INDUSTRIES PRIVATE LIMITED",
"AMY ELECTRICALS PRIVATE LIMITED",
"ZAM ZAM BOYS URDU PS SADAT NAGAR",
"ZILLA PARISHAD SCHOOL WAGHMARAPADA",
"SREE KRISHNA PRAKRUTHI EDUCATIONAL SOCIETY",
"ADMINISTRATIVE OFFICER CGST APPEAL",
"DAV UNIVERSITY JALANDHAR",
"V V INTER COLLEGE (GOVT DEPT)",
"37636 GSSS SURAJNIYAWAS (NAGAUR) NAGAUR",
"SURAKSHA KIDZ HOSPITAL",
"AMBIBUZZ TECHNOLOGIES LLP",
"FACTANA COMPUTING PRIVATE LIMITED",
"SKEI SMT KAMALABAI EDUCATIONAL INSTITUTION",
"DNYANDEEP VIDYAMANDIR BHADGAON",
"CIVIL SURGEON OFFICE JAMTARA",
"DAYAWATI MODI KANYA JHS SHAHJAHANPUR",
"AKLAI VIDYALAY AKLUS",
"THE INDIAN INSTITUTE OF ARCHITECTS",
"34281 GSSS KRISHAN NAGAR (LOONKARANSAR)",
"EXECUTIVE ENGINEER SOLAN",
"SHREE SHYAM HOSPITAL",
"KGK INFOTECH LLP",
"B R METALLICS",
"AKSHEYA PROJECTS & SYSTEMS PRIVATE LIMITED",
"DHOLPUR TEHSILDAR SAPAU",
"KUMBHI KASARI SAHAKARI SAKHAR KARKHANA LIMITED",
"ASHRA SHIKSHAN SANSTA DEONI(BK)TQ DEONI PRIMARY ASHRAM SCHOOL LONI",
"SOUTH 24 PARGANAS HIGHWAY DIVISION P W ROADS (DIRECTORATE)",
"SADGURU SAMARTH SERVICES",
"SHRI CHATRAPATI VIDYALAYA VAVOSHI",
"GOVERNMENT OF WEST BENGAL BANWARILAL BHALOTIA COLLEGE",
"PEEO GSSS 3 KSD",
"ANUDANIT AADI PRATHAMIK ASHRAM SHALA HATEL BU. TAL CHOPDA",
"SRI GURU RAM DAS INSTITUTE OF MEDICAL SCIENCES & RESEARCH",
"VEER ABHIMANYU EDUCATION SOCIETY",
"BEP (INDIA) AUTOMOTIVE SYSTEMS",
"SUBDIVL HOSPITAL TENUGHAT",
"PURPOS PLANET",
"MEDENS PHARMACEUTICAL PRIVATE LIMITED",
"NEREST HOTEL & RESORTS",
"GSSS GAMACH",
"OFFICERS TRAINING ACADEMY",
"FICCI RESEARCH AND ANALYSIS CENTRE",
"MASA COFFEE WORKS PRIVATE LIMITED",
"DISTRICT PROJECT COORDINATOR HISAR",
"TTS CONSULTANT",
"MALEM TECHNOLOGY SOLUTIONS PRIVATE LIMITED",
"SPARKMAN SOLAR ENERGY PRIVATE LIMITED",
"AMH SERVICES PRIVATE LIMITED",
"BATFEED ELECTRICAL SOLUTIONS PRIVATE LIMITED",
"KONKAN EDUCATION SOCIETY DATTU SHET PRIMARY SCHOOL",
"DIRECTORATE ANIMAL HUSBANDRY RAJASTHAN JAIPUR",
"GSSS VIJAYNAGAR",
"BLOCK EDUCATION OFFICER SAWER",
"SUKUR H P INSTITUTION ( A UNIT OF SRIJAN SUPER FACILITIES LLP)",
"MEDINEXT HOSPITAL INDORE",
"UNITED INNOVATORY GLOBAL SOLUTIONS LLP",
"COLLEGE OF DEFENCE MANAGEMENT",
"MAHATMA GANDHI GOVT SCHOOL ENGLISH MEDIUM HINGONIYA JOBNER",
"BD GREEN CONSULTANT PRIVATE LIMITED",
"VISION EXPORTS",
"INDIA ARTS PALACE",
"ARYA VIDYAPEETH COLLEGE ( GOVT OF ASSAM )",
"PRINCIPAL GOVT HIGHER SECONDRY SCHOOL BAIJNATHPUR DIST SURAJPUR CG",
"EXSETE CONSULTING PRIVATE LIMITED",
"WAYPOINT TECHNOLOGIES INDIA PRIVATE LIMITED",
"EXECUTIVE ENGINEER HP PWD",
"PANCHYAT SAMITI MASUDA",
"KONGU ARTS AND SCIENCE COLLEGE (AUTONOMOUS)",
"INDIRA GANDHI MEMORIAL HIGH SCHOOL",
"SADAR BHOLASINGH NAYAK VIDYALAYA",
"B E O DHAR",
"DIGI GRAFT INNOVATIVE",
"P G UMATHE GOVT ENGLISH MEDIUM UTKRISHT VIDYALAYA",
"VICTORIA HIGH SCHOOL",
"R G I MEDITECH PRIVATE LIMITED",
"MAHATMA GANDHI PRATHMIK SHALA OMERGA",
"BLOCK EDUCATION OFFICER (BEGUMGANJ)RAISEN",
"INDIAN PHYTOPATHOLOGICAL SOCIETY",
"UNDER SECRETARY (CASH) DEPARTMENT OF CULTURE NEW DELHI",
"GOVERNMENT OF WEST BENGAL SCHOOL EDUCATION DEPARTMENT",
"SAINT VINCENT GIRLS HIGHER SECONDARY SCHOOL",
"OFFICE OF THE DIVIDIONAL FOREST OFFICER BASTAR DIVISION JAGDALPUR DISTT BASTAR C G",
"GOVERNMENT OF JHARKHAND JPSC RANCHI",
"ALL INDIA INSTITUTE OF MEDICAL SCIENCES",
"ATHMASHAKTHI MULTI PURPOSE CO OP SOCIETY LTD",
"THE KANAKA MAHALAKSHMI CO-OPERATIVE BANK LTD",
"SWAMI RAMANAND TEERTH MARATHWADA UNIVERSITY",
"PUSHYA HOSPITAL",
"HERITAGE SCHOOL",
"AISHWARYA LIFESCIENCES",
"UJWAL MADHYAMIK VIDYALAYA GHONSHI",
"IINSIGHT JUNIOR COLLEGE",
"MUNICIPAL BOARD BUNDI",
"GSSS BHANSU",
"INVESTO XPERT",
"JIJAMATA VIDYALAYA MIDC LATUR",
"050 A I G POLICE (HQ) SHIMLA",
"PUBLIC HEALTH & FAMILY WELFARE DEPARTMENT CIVIL SURGEON CUM CHIEF HOSPITAL SUPERINTENDENT MUNGELI",
"JAI AMBE INDUSTRIES",
"OFFICE OF THE PRINCIPAL INDUSTRIAL TRAINING INSTITUTE",
"GORAKSHNATH MADHYAMIK VIDYALAY ANANDGAON",
"DEV BHUMI PLASTIC & AUTO MOBILE INDUSTRIES",
"UBHI AGRO INDUSTRIES",
"MADHYAMIK VIDYALAYA GOLAI AMRAVATI",
"MAHATMA GANDHI GOVT SCHOOL BARAPAL",
"NCSI TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"CALIBER MINING AND LOGISTICS LIMITED",
"INEST WEB PRIVATE LIMITED",
"IDIQ SOFTECH SOLUTIONS PRIVATE LIMITED",
"YEPPERS SOLUTIONS PRIVATE LIMITED",
"GOVT OF JHARKHAND H M M S PATAMDA JSR",
"GOVT OF JHARKHAND BOARD M S HALDIPOKHAR POTKA-2 JSR",
"JK ACADEMY OF ART AND DESIGN",
"TUBE WELL DIVISION ALLAHABAD",
"20629 BLOCK CHIEF MEDICAL OFFICER ARAIN AJMER",
"TRUE NORTH INFOTECH INDIA PRIVATE LIMITED",
"BAPUJI HIGH SCHOOL",
"BMC MATRICULATION HR SEC SCHOOL",
"SAMAL EQUIP",
"THE KARNAL CO SUGAR MILLS LTD",
"961 PROJECT DIRCETOR & DY SECRETARY STATE REMOTE SENSILG APPLICATION",
"JOINT DIRECTOR ANIMAL HUSBANDRY DAUSA LISTING",
"SWARNA BHARATHI INSTITUTE OF SCIENCE & TECHNOLOGY (SBIT)",
"312025 GSSS 10 T K RAISINGNAGAR SHRI GANGANAGAR",
"MUMBAI AGRICULTURAL PRODUCE MARKET COMMITTEE",
"SOCIETY FOR EMPLOYMENT PROMOTION & TRAINING IN TWIN CITIES",
"ISWARBATI JR HIGH SCHOOL",
"ZPPS PIMPALA PIMPALA",
"TAHSIL OFFICE KINWAT",
"VIKAS ADHIKARI P S K PATAN(1971)",
"BOYERMARI SARAT SARDAR SMRITY F P SCHOOL",
"GOVT OF INDIA T W DEPARTMENT",
"ELEVAR DIGITEL INFRASTRUCTURE PRIVATE LIMITED",
"WELLINGTON COLLEGE INTERNATIONAL PUNE (UNIT OF DIT EDUCATION FOUNDATION)",
"PAO SAFDARJUNG HOSPITAL NEW DELHI",
"MITSUBISHI ELECTRIC CORPORATION",
"GSSS KHAKHOLI",
"NATIONAL INSTITUTE OF BANK MANAGEMENT PUNE",
"SARKARI HIGHSCHOOL SCHOOL MALIYA HATINA",
"GOVERNMENT OF JAMMU & KASHMIR CONTROLLER STORES HEALTH DEPARTMENT INDIRA JAMMU",
"DY DIRECTOR OF HEALTH SERVICES STATE PUBLIC HEALTH LAB",
"SURAT CONTRACTOR",
"GPM DEVELOPERS PRIVATE LIMITED",
"SPECIAL BUREAU GOVERNMENT OF INDIA KOLKATA",
"CHIEF CONSERVATOR SOIL AND WATER CONSERVATION",
"ANANTA CHARITABLE EDUCATIONAL SOCIETY",
"PARAMOUNT FINETEX AND INDUSTRIES INDIA LIMITED",
"GOVERNMENT OF WEST BENGAL MEMARI-II BLOCK DEVELOPMENT OFFICE",
"LEAPFORWORD",
"CHHABRA HOSPITAL",
"PASCHIM SRIPATINAGAR DR B C ROY MEMORIAL VIDYAPITH HS",
"SURABA SPECIALITY LABORATORY",
"INARA POLYFAB PRIVATE LIMITED",
"XFINITY BUILDCON PRIVATE LIMITED",
"FOREST AND WILDLIFE ENVIRONMENT AND CLIMATE CHANGE DEPARTMENT",
"V. J. TECHNOCRAFT PRIVATE LIMITED",
"RCP HOSPITALITY PRIVATE LIMITED",
"TAURUS INNOVATION",
"TULJABHAVANI PRATHMIK VIDYAMANDIR SANT DNYANESHWAR NAGAR LATUR",
"ZYDUS MEDICAL COLLEGE AND HOSPITAL",
"25779 ADDITIONAL DISTRICT & SESSIONS JUDGE NO 3 BHARATPUR",
"FISH WELFARE INITIATIVE INDIA FOUNDATION",
"GSSS SONAGAR CHITTORGARH CHITTORGARH",
"GYAN BOOSTER",
"BIRLA INDUSTRIES GROUP CHARITY TRUST",
"69 JOINT DIRECTOR ANIMAL HUSBANDRY BIKANER",
"SHREE RAMKRISHNA MANDAL S SADAFULI DEAF SCHOOL",
"HIGH SCHOOL GORANE",
"KRISHNA BOARD AND CONTAINERS",
"VIDHI ANALYTICA LLP",
"M/S VIPIN AUTOMOBILES",
"SHRI KRISHNA SENIOR SECONDARY SCHOOL",
"LCIT PUBLIC SCHOOL",
"SEVEN - 9 DEVCON LLP",
"INSOLVENCY AND BANKRUPTCY BOARD OF INDIA",
"EXE ENG E M DIVISION P W D ALLD",
"MAHATMA GANDHI CENTRAL UNIVERSITY",
"FUSIE ENGINEERS PRIVATE LIMITED",
"SHRIYA PROFESSIONAL SERVICES",
"GRACE KENNETT FOUNDATION HOSPITAL",
"DIMA PRODUCTS",
"NAGARPALIKA PALITANA",
"CHAKLIART PRIVATE LIMITED",
"KHANNA HIGH SCHOOL",
"SHREE GORAKSHNATH MADHYAMIK VIDYALAYA",
"SMT RAJDEVI PRATHMIK HINDI VIDYALAYA",
"ASB INFOTECH",
"SULOCAHANA BELHEKAR SAMAJIK VA BAHU UDDIESSHIYA SIKSHAN SANSTHA DNYANESHWAR POLYTECHNIC",
"100906 GSSS PIPLAJ",
"KARUR CITY MUNICIPAL CORPORATION",
"SARVODAYA VIDYALAYA",
"MADRAS DIVISION",
"21761 GSSS BARAN",
"SATGAON HIGH SCHOOL",
"GSSS GHASA",
"DISTT STATISTICAL OFFICER ASHOKNAGAR MADHYA PRADESH ASHOKNAGAR",
"ABC EXPRESS",
"MODI SCHOOL JAMANAR",
"CCMT BOOKS AND PUBLICATIONS DIVISION",
"UJALA CYGNUS KULWANTI HOSPITAL KANPUR",
"LDHR SERVICES INDIA LLP",
"ABHIYANTA EN FABRICATION",
"OFFICE OF THE EXECUTIVE ENGINEER HASDEO BARRAGE W/M DIVISION RAMPUR KORBA CG",
"14929 GSSS KHANDI",
"SAGES NIVEDITA G H S SCHOOL",
"TAGORE SCHOOL",
"SHEKHAWAT SECURITY SERVICES",
"J G CHEMICALS LIMITED",
"ASHOK G AND CO",
"NEWTON PUBLIC SR SEC SCHOOL",
"WCR JABALPUR",
"BRAHMAPUTRA BOARD¬†(CENTRAL GOVT OF INDIA)",
"JAYCEES PUBLIC SCHOOL RUDRAPUR",
"SENT MARRY CONVENT SCHOOL PEN INDIA BRANCH",
"NAXALBARI HERITAGE ACADEMY",
"THE CENTRAL SCHOOL FOR THE DEAF",
"DNYANESHWAR POLYTECHNIC",
"NAVA BALODYAN TRUST SANE GURUJIENG",
"CONSTELLA INTELLIGENCE PRIVATE LIMITED",
"SYEMCO SWITCHGEARS PRIVATE LIMITED",
"DYNAMIC ELEMENTS TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"BGS GLOBAL INSTITUTE OF PHARMACEUTICAL SCIENCES",
"KUNWARI PUKHURI GIRLS' HIGH SCHOOL",
"ADITYA BIRLA PUBLIC SCHOOL OSAPADA",
"OFFICE OF THE DEPUTY INSPECTOR OF SCHOOLS ( GOVT OF ASSAM)",
"MERCHANT AYURVED COLLEGE AND HOSPITAL",
"ANANTRAO PAWAR COLLEGE OF ENGINEERING AND RESEARCH",
"KAI VISHWANATH KURHE MADHYAMIK VIDYALAY CHEDGAON TAL RAHURI DIST AHMEDNAGAR",
"SHRI MARUTRAO GHULE PATIL SHIKSHAN SANSTHECHE JIJAMATA MADHYA V UCHHA MADHYAMIK VIDYALAY",
"DIRECTORATE OF GEOLOGY AND MINING UP LUCKNOW",
"VIDYAVIKAS PRIMARY HIGH SCHOOL HINGANGHAT",
"U & S ERECTORS",
"VIKINGARNA SOLUTIONS PRIVATE LIMITED",
"PRTIMARY EDUCATION DEPARTMENT",
"DIVISIONAL FOREST OFFICER FOREST DIVISION ATHAGARH",
"SHREE SAGAR HIGHER SECONDRY SCHOOL",
"ST URSULA GIRLS H S CIVIL LINE NGP",
"GREATER NOIDA ACADEMY OF LEGAL STUDIES AND RESEARCH",
"O P JINDAL INSTITUTE OF CANCER AND RESEARCH CARE",
"RAATH INTERNATIONAL SCHOOL",
"SARASWATI VIDYALAYA HIGH SCHOOL & JR. COLLEGE OF SCIENCE",
"ASST ENG CITY SUB DIV II SOUTH PHED JAIPUR",
"OBS HIGHER SECONDARY SCHOOL",
"DD SHAH FOOD LABS LLP",
"MAHATMA GANDHI GOVT SCHOOL (ENGLISH MEDIUM) GOVERDHAN VILAS UDAIPUR",
"ENCHANTING TALES HOTELS AND RESORTS PRIVATE LIMITED",
"BRIJ DHAM VIDYA MANDIR SENIOR SECONDARY SCHOOL",
"100166 AJMER REGISTRAR BOARD OF REVENUE FOR RAJASTHAN AJMER",
"Z P SCHOOL LAMAZ",
"I3 REALTORS",
"B D M MAHAVIDYALAYA",
"JYOTI VIDYA VIHAR HINDI HIGH SCHOOL",
"CHIEF ENGINEER PUBLIC WORKS DEPARTMENT B AND R",
"ASCENT FS (INDIA) LLP",
"GOVT OF PUNJAB STATION HEAD QUARTER GURDASPUR",
"STELLA MARIS COLLEGE",
"ZILA PARISHAD SHALA MINARFATA",
"18484 PALI TEHSILDAR MARWAR JUNCTION",
"CHIEF ENGINEER MAHANADI PROJECT WRD RAIPUR",
"B E O BAMORI MADHYA PRADESH",
"ANDRE CONSULTANCY SERVICES PRIVATE LIMITED",
"PRINCIPAL BSC NURSING COLLEGE UJJAIN",
"SHRI RAMKRUSHNA PARAMHANS VIDYANIKETAN",
"K L JANTA INTER COLLEGE DEOBAND",
"20249 CHIEF MEDICAL & HEALTH OFFICER JAIPUR-I",
"NEXAGE TECHNOLOGY",
"SHAHU DAYANAND HIGHSCHOOL AND JUNIOR COLLEGE",
"NFR TINSUKIA DIVISION",
"SHIVAJI VIDYALAYA ROSHANGAON TQ BADNAPUR",
"MAPLE WOOD (A UNIT OF REMA ENTERPRISES PVT LTD)",
"DHANBAD DIVISION",
"2DOTS TECHNOLOGIES",
"HITECH ENGINEERING SERVICES",
"ADITYA ENTERPRISES",
"TALUKA HEALTH OFFICE BHALKI",
"DISTT COLLECTION OFFICE COLLECTRATE MAHAMAYANAGAR",
"RAJASTHAN STATE SEED & ORGAINIC CERTIFICATION AGENCY",
"GSSS KUNDA",
"NUQI WEALTH INDIA PRIVATE LIMITED",
"DIVYANSH ORGANICS PRIVATE LIMITED",
"INDO SEALS PRIVATE LIMITED",
"SHRI DURGA KHANDSARI SUGAR MILLS KANPUR",
"THE FARIDKOT CENTRAL COOPERATIVE BANK LTD",
"17494 E S I DISPENSARY NO-1 SRIGANGANAGAR",
"GOVT OF INDIA COFFEE BOARD",
"ELECTIONS",
"ORDNANCE EQUIPMENT FACTORY HAZRATPUR",
"SAMBALPURI BASTRALAYA HANDLOOM CO-OPERATIVE SOCIETY LIMITED",
"RANI LAXMIBAI H S NARSI",
"THERMAX VEBRO POLYMERS INDIA PRIVATE LIMITED",
"EE IPH DIVISION SHAHPUR",
"TIME CARE",
"AMITY INDIAN MILITARY COLLEGE",
"GOVT MIDDLE SCHOOL JALPAR (BAPOLI)",
"1 UP ENGR COY NCC ALIGARH",
"THE IMPERIAL CLECTRIC COMPANY",
"SAHYADRI PODAR LEARN SCHOOL MURUD",
"APS INTERNATIONAL SCHOOL",
"SHAIKH UL HIND MAULANA MAHMOOD HASAN MEDICAL COLLEGE",
"GOSSNER HIGH SCHOOL",
"Z P P S BAVDHAN WAI SATARA",
"MISSION P S KORBA",
"KULAPATI DR S BALAKRISHNA JOSHI GURRUKULAM CBSE SCHOOL",
"THE IMPERIAL ELECTRIC COMPANY",
"801 CHIEF ENGINEER WATER RESOURCES DEPARTMENT RAJASTHAN JAIPUR",
"PALLADIUM SCHOOL",
"MILES INCORPORATION",
"CHAUDHARY BANSI LAL UNIVERSITY¬†",
"LCT PROJECTS PRIVATE LIMITED",
"HORIZON ACADEMY",
"MEDICAL SUPERITENDENT RURAL HOSPITAL DEORI",
"SYNERGY GROUP OF INSTITUTES",
"SARASWATI U M KANYA VIDYALAY KALIYAKUVA",
"ZPCPS KHANDVI",
"BRIDGESPAN INDIA PRIVATE LIMITED",
"MINERVA INFOTECH",
"NARMADA ENGINEERING",
"GULSHAN FASHIONS LLP",
"42776 GSSS PRATAPPURA DIGGI MALPURA TONK",
"LAXMIBEN HOMOEOPOTHY INSTITUTE AND RESEARCH CENTRE BHANDU",
"NEHARU VIDYAMANDIR",
"DK INTERNATIONAL",
"RUDRA CONSULTANCY",
"HARYANA SAHARI VIKAS PRADHIKARAN",
"EX ENG NATIONAL HIGHWAY DIVISION AURANGABAD",
"COLLEGE OF AGRICULTURE DARWHA",
"JAGANNATH VIDYALAYA MATRICULATION SCHOOL",
"VIVEKANANDA MAHAVIDYALAYA",
"GOVERNMENT OF BIHAR BIHAR VIKAS MISSION DISRTICT REGISTRATION & COUNSELING CENTRE",
"PARMAR ENTERPRISES",
"RAJASTHAN UNIVERSITY OF VETERINARY AND ANIMAL SCIENCES",
"ASST ADM CUM ACCOUNT OFFICER",
"Z P P SCHOOL NAGUR",
"GSSS MOHANPURA PRATHVE SINGH PHAGI",
"GSSS DOBARI KALA MAKRANA",
"PPS TECH LLP",
"LOYOLA HIGH SCHOOL",
"ZEENAT MAHAL GOVT SKV UM JAFRABAD",
"DISST AUYRVED OFFICE RAIGARH CHHATTISGARH",
"SOLASTA LIFESCIENCES PRIVATE LIMITED",
"ADDICTED",
"PRINCIPAL JUDGE FAMILY COURT KHANDWA MP",
"GOVT OF JHARKHAND DY C F & F D PROJ ELEPHANT JSR",
"MAHILA CHIKITSALAYA",
"RAICHUR BALLARY KOPPAL MILK UNION",
"CORD ROBOTICS INDIA LLP",
"MAHARASHTRA LEGISLATURE SECRETARIAT",
"ZILA PANCHYAT MAHARAJGANJ",
"SARASWATI VIDYAMANDIR UKKADGAON TAL. BARSHI",
"S BANKAR ASSOCIATES LLP",
"KAKASAHEB MHASKE HOMOEOPATHIC MEDICAL COLLEGE & HOSPITAL & POST GRADUATE INSTITUTE",
"SADBHAVNA MULTISPECIALITY HOSPITAL",
"SIR J P GIRLS DEGREE COLLEGE",
"JAGADHARI WORKSHOP",
"DIRECTORATE OF HEALTH AND FAMILY WELFARE¬†BILGA",
"MIT WORLD PEACE UNIVERSITY(MITWPU)",
"GSSS MOKHAB KALLA",
"THIRD EYE DATA ANALYTICS SERVICES INDIA PRIVATE LIMITED",
"WISDOM INTERNATIONAL SCHOOL",
"JAIN DEEMED TO BE UNIVERSITY",
"19787 DIVISIONAL SANSKRIT EDUCATION OFFICER JAIPUR",
"24632 CHIEF ENGINEER IGNP BIKANER",
"NEPALI HIGH SCHOOL NAXALBARI",
"A E N P W D SUB DN I JHUNJHUNU",
"NAGPUR NEURO & TRAUMA HOSPITAL",
"SAHYADRI COLLEGE OF PHARMACY METHWADE",
"DISTRICT SOCIAL WELFARE OFFICER JHANSI",
"PRIYADARSHANI VIDYA MANDIR DHA",
"THASILDAR OFFICE",
"PRINCIPAL CIVIL COURT JOTANA",
"XLHEALTH CORPORATION INDIA PRIVATE LIMITED",
"THE SHREE JI SCHOOL",
"IKUE INTERNATIONAL PU COLLEGE",
"MAILSTONE PRIVATE LIMITED",
"LATE SHREE YASHWANTRAO CHAVAN MEMORIAL MEDICAL AND RURAL DEVELOPMENT FOUNDATION'S DENTAL COLLEGE AND HOSPITAL",
"COAL MINES PROVIDENT FUND ORGANISATION",
"EEPWD B AND R DHAR",
"ODHAVNAGAR PRIMARY SCHOOL DISTRICT PATAN",
"GSSS CHAMBIDHAR",
"MUNICIPAL BOARD KHAJUWALA",
"GYAN KUNJ ACADEMY",
"AEN SUB DIV PHED NAGAR",
"COMMISSIONER AND MAYOR NAGAR NIGAM JAIPUR HERITAGE 36525",
"THE KOTA CENTRAL CO OPERATIVE BANK LTD KOTA",
"LOCUZ ENTERPRISE SOLUTIONS PRIVATE LIMITED",
"ANKUR SCHOOL",
"SUPERINTENDANT V S S MEDICAL COLLEGE HOSPITAL BURLA",
"M/S. TRANSTECH",
"Z P SCHOOL VASKHEDI",
"IQRA HIGH SCHOOL",
"G J SENIOR SECONDARY SCHOOL",
"EMULUS CONSULTING LLP",
"21191 GSSS SHADI CHITORGARH",
"SMT R D GARDI COLLEGE OF EDUCATION HARIPAR (PAL) RAJKOT",
"BLOCK EDUCATION OFFICER ODAGAON",
"PERFECT ENGINEERS & CONSULTANTS",
"GSSS KELWA",
"ATLENGTH BUILDTECH AND INTERIORS PRIVATE LIMITED",
"RHENUS A&O INDIA PRIVATE LIMITED",
"SRF ALTECH LIMITED",
"SERENDIPITY TRAVEL (INDIA) PRIVATE LIMITED",
"IDEAL URDU MADHYAMIK SHALA NORTH SOLAPUR",
"FIRE OFFICER CENTRAL RANGE CUTTACK",
"UDDHESHWAR HIGHER SECONDARY SCHOOL SAWARGAON TQ DEONI DIST LATUR",
"CHIEF BLOCK EDUCATION OFFICER",
"BLOCK CHIEF MEDICAL OFFICER JHADOL",
"NAHNNA FP SCHOOL",
"GEOLOGY AND MINING NAGPUR",
"P S KAGADIPURA",
"RAJIV BUSINESS SOLUTIONS PRIVATE LIMITED",
"ROCKWELL COOLTECH PRIVATE LIMITED",
"BUVANA KRISHNAN MAT HR SEC SCHOOL",
"SHETKARI SHIKSHAN SANSTHA JUNIOR COLLEGE",
"GOVT OF JHARKHAND G.M.S.KARRA",
"GHS HUSNAR",
"KHALSA LITTLE FLOWER SCHOOL AHMEDABAD",
"NERIM GROUP OF INSTITUTIONS",
"M S SERVICES PRIVATE LIMITED",
"SANJAY GANDHI HIGH SCHOOL NANDED",
"EDUCATION DEPARTMENT GOVT OF CHHATTISGARH BLOCK EDUCATION OFFICE PALI DIST KORBA CG",
"GOVT OF CHHATTISGARH OFFICE OF THE BLOCK EDUCATION OFFICER KOTA DIST BILASPUR CG",
"AMD INTEGRAL SERVICES PRIVATE LIMITED",
"BEOBAIRASIYABHOPALMP",
"DIVISIONAL COMMISSIONER HISSAR¬†",
"GSSS AALIYAPADA BANDIKUE",
"THE J. B. PETIT HIGH SCHOOL FOR GIRLS",
"MAHARASHTRA RAJYA MARG PARIVAHAN MAHAMANDAL RAVER AAGAR",
"Z. P. SHALA RALTEL",
"GOVT SARSWATI DIV PUB LIB UDAIPUR",
"NANNANA",
"LAXMANDAS MAHARAJ PRIMARY ASHRAM SCHOOL",
"SALARIA MADARSA ISLAMIA KANZUL ULOOM",
"GOVT SARVODAYA BAL VIDYALAYA VIVEK VIHAR DELHI",
"CH DEVI LAL CO OP SUGAR MILLS LIMITED GOHANA",
"GIRLS INTER COLLEGE ITHARNA",
"PUBLIC SERVICE TRIBUNAL UA DDN",
"OVERIT PRIVATE LIMITED",
"GSSS GEGAL SHRINAGAR AJMER",
"RAJMATA VIJAYARAJE SCINDIA KRISHI VISHWA VIDYALAYA GWL",
"SAPTAGRAM SARVESWAR HIGH SCHOOL",
"KHARAMBA BANI VIDYALAYA HS",
"DFO TERRITORIAL SOUTH SEONI",
"KALIKAPUR RAMKAMAL VIDYAPITH",
"SUBHAS VID CO-EDUCATIONAL HIGH SCHOOL PHOOLBAGAN",
"BOARD OF PRACTICAL TRAINING (EASTERN REGION",
"PURUSOTTAMPUR HIGH SCHOOL",
"AARTHAM MULTI SUPER SPECIALITY HOSPITAL",
"MKSSS BAKUL TAMBAT INSTITUTE OF NURSING EDUCATION",
"VIJAYSINGH VIDYALAYA CHINCHPUR BK",
"SHANKAR DIAGNOSTIC CENTRE",
"ESI DISPENSORY HATHRAS",
"JAWAHAR BALAK M BASMATH",
"ZPPS BAVAHAN 1",
"PRICIPAL DISTRICT AND SESSION JUDGE NEW DELHI DISTRICT PATIALA HOUSE NEW DELHI",
"SWATI EXPORTS (INDIA) PRIVATE LIMITED",
"MAHARAJA AGRASEN INTERNATIONAL COLLEGE",
"SISTERS OF OUR LADY OF FATIMA KROOT MEMORIAL SCHOOL",
"Z.P. SCHOOL, CHANDETANDA",
"BODINAYAKANUR MUNICIPALITY",
"K J SOMAIYA POLYTECHNIC",
"LEARLAUF DESIGN AND ENGINEERS PRIVATE LIMITED",
"SAPIENT HEALTH AND BEAUTY PVT LTD",
"PRATIBHA JUNIOR COLLEGE ARTS SCIENCE AND COMMERCE",
"JAYA JAYA SANKARA INTERNATIONAL SCHOOL NAZARATHPET",
"NAINANPUR OLD FP SCHOOL",
"BLOCK CHIEF MEDICAL OFFICER HAMIRGARH",
"GOVT VARISTH UPAD SANSKRIT SCHOOL KALADERA CHOMU JAIPUR",
"EDUCATION DEPARTMENT GOVT OF CHHATTISGARH BLOCK EDUCATION OFFICE",
"NR DELHI DIVISION",
"ST. PETER‚ÄôS SR. SECONDARY SCHOOOL",
"DR. NATURE WELLNESS PRIVATE LIMITED",
"GOVERNMENT OF ASSAM ,HANDLOOM AND TEXTILES, PHOOLBAGAN",
"DAV COLLEGE CHEEKA",
"SUPERINTENDING ENGINEER SHYAM BARNAI PROJECT¬†AMBIKAPUR SURGUJA",
"MALARA ISLAMPUR HIGH SCHOOL",
"OFFICE OF THE EXECUTIVE ENGINEER PWD AMINGAON",
"HARIDAS KHIMJI M.K.S. VIDYALAYA PARASOLI GOVERDHAN",
"COLLECTION OFFICE MAT MATHURA",
"AYATI CONSTRUCTIONS AND ESTATES LLP",
"DELHI CANTONMENT BOARD",
"GOVT. SARVODAYA BAL VIDYALAYA VIVEK VIHAR",
"GH RAISONI UNIVERSITY AMRAVATI",
"MEMBER SECRETARY MADHYA¬†PRADESH JABALPUR",
"ASITT COMMISSIONER OF STATE TAX UNIT 25 KALOL",
"SIGNALS RECORDS JABALPUR",
"RATNAI COLLEGE OF AGRICULTURE AKLUJ",
"SARVESH HEALTH CARE",
"VIDYA VINAY VIDYALAYA BADUR TQ NILANGA",
"27266 GSSS GEGAL SHRINAGAR AJMER",
"DARAPUR HIGH SCHOOL DARAPUR",
"MADARSA ARABIYA FAIZUL JOGIGHAT DARIYABAD PRAYAGRAJ",
"AIRPORT SENIOR SECONDARY SCHOOL CALICUT",
"SIGNANT HEALTH PRIVATE LIMITED",
"PRATHAMIK ASHRAM SHALA ADGAON DEVALA",
"THE BHUNSLA PRIMARY AGRICULTURE CO-OP SOCIETY LTD",
"BEEDU SERVICE PVT LTD",
"BAREILLY COLLEGE BAREILLY",
"SHRI SWAMI SAMARTH INSTITUTE OF MANAGEMENT AND TECHNOLOGY",
"311259 (GSSS, SINLI JAGIR)",
"SULAX TECHNOLOGIES PRIVATE LIMITED",
"ANNET RETRANSFORM (GUJARAT) LLP",
"MULTI-PURPOSE PRIMARY RURAL COOPERATIVE SOCIETY LTD",
"INDIAN REGISTER OF SHIPPING",
"BEINEX CONSULTING PRIVATE LIMITED",
"HOLY CROSS CONVENT SCHOOL -NANBHAT",
"LLOYD GROUP OF INSTITUTE",
"GOVERNMENT OF ASSAM OFFICE OF THE COMMANDANT 19TH AP(IR) BATTALION, 19TH ASSAM POLICE (IR) BN. TENGAKHAT",
"GOVERNMENT OF ASSAM SF DIVISION DIBRUGARH",
"SAMARTHANAM TRUST",
"VTAA INFRA PROJECT PRIVATE LIMITED",
"GOVERNMENT OF CHHATTISGARH OFFICE OF THE PRINCIPAL GOVT ITI RAJNANDGAON",
"MODERN TERRY TOWELS (DIV OF MODERN INSULATOR LTD)",
"UNIVERSITY OF AGRICULTURAL SCIENCES",
"M L S DAV SR SEC PUBLIC SCHOOL",
"DIVISIONAL SANSKRIT EDUCATION OFFICER JAIPUR",
"SHREE SARDAR VALLABHBHAI UTTAR BUNIYADI VIDYALAYA",
"VASAVI REALTY PRIVATE LIMITED",
"TALUKA PRIMARY EDUCATION OFFICER BHARUCH",
"DISTRICT EDUCATION OFFICER TIKAMGARH MADHYA PRADESH",
"SOLAI AGRO FRESH PRIVATE LIMITED",
"CITY HOSPITAL BHARATPUR",
"HUTATMA JAYWANTRAO PATIL MAHAVIDYALAYA HIMAYATNAGAR",
"VIDYA MANDIR EAINI",
"BHARAT DAIRY FOODS LLP",
"BAJEL PROJECTS LIMITED",
"ADDITIONAL CHIEF ENGINEER WATER RESOURCES ZONE UDAIPUR",
"DISTRICT AYUSH OFFICER TIKAMGARH MADHYA PRADESH",
"JAY SWAMI NARAYAN VIDYALAYA SAMUDRAL",
"DREAM A DREAM",
"SHRI U C K A V N INT COLL HATHRAS",
"ASSESSING OFFICER, DIRECTORATE GENERAL OF INCOME TAX (INVESTIGATION)",
"THE INDIAN HEIGHTS SCHOOL",
"ANTIER SOLUTIONS PRIVATE LIMITED",
"MANAV SAMPADA UTTAR¬† PRADESH",
"ASTT.DIR.AGRICULTURE(EXT). BHARATPUR",
"GOVERNMENT OF HIMACHAL PRADESH DEPARTMENT OF TREASURIES, ACCOUNTS AND LOTTERIES",
"SHREE K. G. DHOLAKIYA SCHOOL",
"PEEO MANGAL",
"MAPEI CONSTRUCTION PRODUCTS INDIA PRIVATE LIMITED",
"PARK METRO HOSPITAL",
"VISAMAN GLOBAL SALES LIMITED",
"ASSISTANT REGINONAL TRANSPORT OFFICER",
"DISTRICT AND SESSION JUDGE",
"CHETAK TECHNOLOGY LIMITED",
"ASSISTANT ENGINEER PUBLIC HEALTH ENGINEERING DEPARTMENT",
"IVISTEC PARTNERS INDIA PRIVATE LIMITED",
"PANCHAYAT SAMITI JALASU",
"FC GLOBAL SERVICES INDIA LLP",
"DIST PROGRAMME OFFICER WOMAN AND CHILD DEV KHANDWA MADHYA PRADESH",
"NAHANNA F P SCHOOL",
"Z P C P SCHOOL KESAR JAWALGA",
"GSSS BHAGWANPURA NIMBAHEDA",
"K D GAVIT SAINIKI VIDYALAYA",
"SENIOR DEPUTY DIRECTOR OG GEOLOGY AND MINING NAGPUR",
"DISTRICT COOPERATIVE BANK LTD",
"U M S KHAIRI SCHOOL SAMASTIPUR",
"SRM SUPER SPECIALITY HOSPITAL CHENNAI",
"NEO-TECH BUSINESS SOLUTIONS PRIVATE",
"JUPITER LIFE LINE HOSPITALS LIMITED",
"MEHRA HOSPITAL AMBALA",
"RAIDANGJURI NAGABAT HIGHER SECONDARY SCHOOL",
"BLOCK EDUCATION OFFICER TIRTOL",
"KUSHAL FINNOVATION CAPITAL PRIVATE LIMITED",
"7ARRAY SOLUTIONS PRIVATE LIMITED",
"TATA TECHNOLOGIES LIMITED",
"BLOCKFORTRUST SOLUTIONS PRIVATE LIMITED",
"QUANTRAN SYSTEMS INDIA PRIVATE LIMITED",
"KES SECURITY PRIVATE LIMITED",
"WINNOVATION EDUCATION SERVICES PRIVATE LIMITED",
"BSS MAGMETER PRIVATE LIMITED",
"ZAO CBDT PUNE",
"AIR INDIA LIMITED",
"VIDARBHA IRRIGATION DEVELOPMENT CORPORATION NAGPUR",
"PANCHAYAT SAMITI RAJAKHEDA",
"CHIEF MEDICAL AND HEALTH OFFICER CWA CHHINDWARA MADHYA PRADESH",
"ADARSH SENIOR SECONDARY SCHOOL CHARKHI DADRI",
"SECRATARY PUNJAB VIDHAN SABHA",
"E E P H MECH DIV SAGAR MADHYA PRADESH",
"NORTHERN REGION FARM MACHINERY TRAINING AND TESTING INSTITUTE",
"BOSCH MOBILITY PLATFORM AND SOLUTIONS INDIA PRIVATE LIMITED",
"LAL BAHADUR SHASTRI MAHAVIDYALAY DHARMABAD",
"G J SENIOR SECONDARY SCHOOL KALWAS",
"DISTRICT INFORMATION TECHNOLOGY SOCIETY KARNAL",
"KINGS COLLEGE INDIA",
"ELDORADO AGRITECH PRIVATE LIMITED",
"ARIHANT INTERNATIONAL SCHOOL BHILWARA",
"DISTRICT AYUSH OFFICER",
"ECOM AGRO INDIA PRIVATE LIMITED",
"GOV POLYTECNIC EDUCATION SOCIETY UTTAWAR PALWAL",
"E E PHE GUNA MADHYA PRADESH",
"SIDDESHWAR FOUNDERS PRIVATE LIMITED",
"CORP ATTIRE",
"HOLISTIC DEVELOPERS AND BUILDERS",
"534 DIST MINING OFFICER C/ GHAT SOLAN",
"MBM UNIVERSITY JODHPUR",
"BLUE RIBBON TECHNOLOGIES PRIVATE LIMITED",
"TAHSIL OFFICE AHMADPUR",
"GOVT OF JHARKHAND CIRCLE OFFICER BARHI HZB",
"SONY ACADEMY PUBLIC SR SEC SCHOOL",
"SIS CERTIFICATIONS PRIVATE LIMITED",
"SHIV SHAKTI PACKAGING AND MANPOWER",
"B & R BOREWELL CO",
"HIRANYA CELLULOSE PRODUCTS",
"B E O T W GDONGRI MADHYA PRADESH",
"SHARI GANESH VIDYALAY PIMPALNER",
"WANLESSWADI HIGHSCHOOL& JR.COLLEGE WANLESSWADI SANGLI",
"TRIVENI PUMPCAST",
"SHRI JANARDAN SWAMI HOSPITAL",
"U M S KHAIRI",
"GPS VAIROKE",
"SATYAM RICE INDUSTRIES",
"ORLEAN COLLEGE OF PHARMACY",
"ST ABR PUBLIC SCHOOL",
"UNNATI ORGANISATION FOR DEVLOPMENT EDUCATION",
"GOVT OF CHHATTISGARH PUBLIC HEALTH ENGINEERING DEPARTMENT",
"KESHAV GLOBAL ACADEMY",
"CIVIL SURGEON GUNA MADHYA PRADESH",
"OFFICE OF THE DISTRICT PANCHAYAT TAMNAR",
"JINDAL EDUCATION WELFARE SOCIETY",
"JOINT REGISTRAR COOPERATIVE SOCIETIES AGRA",
"MINISTRY OF RAILWAY GOVT OF INDIA",
"ST JOHNS CHILDRENS ACADEMY",
"M/S NATIONAL PRINTERS",
"ST PAUL‚ÄôS HIGH SCHOOL",
"DRONA EDUCATION FOUNDATION",
"HIMACHAL PRADESH GRAMIN BANK",
"ST FIDELIS SR SEC SCHOOL",
"AC TO DC SHIMLA",
"JEPH INTERNATIONAL SCHOOL",
"MAHATMA GANDHI VIDYAMANDIR",
"NATIVE SOFTWARE",
"MOTHERSON ELECTRONIC COMPONENTS PRIVATE LIMITED",
"REGISTRAR COOPERATIVE SOCIETIES",
"SOCIO ECONOMIC ALTERNATIVE RESEARCH & RESOURCE COMMUNITY FOR HUMANITY",
"COMMANDER WORKS ENGINEER ARMY",
"H R INDUSTRIES",
"CONSUMER AFFIAIRS FOOD AND PUBLIC DISTRIBUTION",
"ASSISTANT CONSOLIDATION OFFICER MEHSANA",
"MOTHER CASE INSTITUTE OF NURSING COLLAGE",
"SURBHI RESTAURENT",
"TAJ MAHAL LUCKNOW",
"NARESH ENTERPRISES",
"SHRI SHISHU BHAWAN SUPER SPECIALITY HOSPITAL",
"GODAVARI URBAN MULTISATE CREDIT CO-OPERATIVE SOCIETY LTD",
"KPSN & ASSOCIATES LLP",
"CHILDLINE 1098",
"UNIFY HEALTHCARE SERVICES LLP",
"SPECIAL AUDITOR CL 2 CO.OP SOCITIES AKOLA",
"SHREE TATYASAHEB KORE WARANA SAHAKARI SAKHAR KARKHANA LIMITED",
"ST MARK'S SR SEC PUBLIC SCHOOL",
"MOTHER TERESA WOMEN'S UNIVERSITY KODAIKANAL",
"2 HIGH SCHOOL BALIAPUR",
"SHITIJ REAL ESTATES LLP",
"RELATION REALTECH PRIVATE LIMITED",
"HRSC STRATEGIES CONSULTING INDIA PRIVATE LIMITED",
"NEXT GEN EQUIPMENTS PRIVATE LIMITED",
"B D O PANCHAYAT SAMITI BHADESHAR",
"BABA FARID UNIVERSITY OF HEALTH SCIENCES",
"ADHYAPAK VIDYALAYA EKHATPUR",
"DEPARTMENT OF PERSONNEL & TRAINING",
"SUBHASINI ENTERPRICES",
"FSBUSINESS SOLUTIONS",
"CENTRAL UNIVERSITY OF RAJASTHAN",
"DR SHYAMA PRASAD MUKHERJEE CIVIL HOSPITAL LUCKNOW",
"082 DIRECTOR ECO & STAT",
"BROTHERN HIGH SCHOOL DOLARA",
"CHIRANJEEVI EYE & BLOOD CENTRE",
"GOVERNMENT POLYTECHNIC JHANSI",
"SARANSH SOFTWARE SOLUTIONS PRIVATE LIMITED",
"ADDL CIVIL JUDGE & JUDL MAGISTRATE KARAULI",
"KAITECH CONSULTANT",
"NIMICHI RAMNARAYAN VIDYALAYA",
"SMT S A PATEL B ED COLLEGE",
"SANJIVINI EYE CARE HOSPITAL",
"GOVT COLLEGE FOR WOMEN BADHRA",
"EX E T L B C KEOLARI",
"B E O PATHARIA MADHYA PRADESH",
"TRANSPORT DEPARTMENT HARYANA",
"GIREESHAM DIGITAL SCHOOL",
"WEBCUBATOR TECHNOLOGIES LLP",
"DY COMMISSIONER EXCISE UJJAIN",
"ADANI VIDYA MANDIR SURGUJA C.G",
"SHRI KRISHAN CHAITANYA INT COLL NANDGAON MATHURA",
"SARISKA DCF DY RD SARISKA TP ALWAR",
"ZPPS KAUDGAON GHODA KAUDGAON GHODA",
"LINK ANANYA PROJECT LLP",
"TASHIL OFFICE BHADGAON DIST JALGAON",
"SANCHETI INSTITUTE FOR ORTHOPAEDICS & REHABILITATION",
"TALAT HIGH SCHOOL AURANGABAD",
"JASUDBEN ML SCHOOL PRIMARY SECTION",
"KARYALAY PRABHARI CHIKITSA PADADHIKARI REFERAL ASPATAL SAKARA",
"RAJESH MEDICAL & CO",
"H D SR SEC SCHOOL",
"PRINCIPAL DISTRICT & SESSIONS JUDGE NEW DELHI DISTRICT PATIALA HOUSE NEW DELHI",
"IMMUNO COLLECTION SERVICES",
"SHENFADU FAKIRBA SONWANE INSTITUTE OF PHARMACY",
"UMMEED CHILD DEVELOPMENT CENTER",
"KRISHNA SALES CORPORATION",
"27304 GSSS BANWADA TONK TONK",
"Z P C P S KODLI UDGIR",
"SHEVAGA MANAGEMENT SERVICES PRIVATE LIMITED",
"GOVT OF JHARKHAND EXE ENGG PLAN MONITRIG DIV JSR",
"311458 GSSS BAMANWAS KOTPUTALI JAIPUR",
"CM AND HO KHANDWA MADHYA PRADESH",
"REGIONAL DIRECTOR CGWB MER PATNA",
"AI-TEC ELECTRICALS",
"KURUA HIGHER SECONDARY SCHOOL",
"K V M GLOBAL SCHOOL",
"TAHASILDAR OFFICE PANVEL",
"B-SOLAR CONSULTANT & ENGINEER PRIVATE LIMITED",
"MURLIWALA HOTEL AND RESTAURANT PRIVATE LIMITED",
"SAMAY INSURANCE BROKERS PRIVATE LIMITED",
"JOINT DIRECTOR & HEAD OFFICE",
"THE MAN-MADE TEXTILES RESEARCH ASSOCAITION",
"GGSSS JAGDISH CHOWK UDAIPUR",
"FRIENDS ENGINEERING WORKS",
"MEDICAL SUPERINTENDENT RURAL HOSPITAL KAIJ",
"RAMKRSHNA PATI VIDYALAYA SONWALA TA JALKOT",
"CARE CHL HOSPITALS INDORE",
"RESIDENTIAL COACHING ACADEMY ALIGARH MUSLIM UNIVERSITY",
"PRINCIPAL INDUSTRIAL TRAINING INSTITUTE SHIRPUR",
"REWA NAGAR NIGAM",
"VALLABH SCIENTIFIC CORPORATION",
"SUN BUILDERS",
"RAJ ENTERPRISES",
"23688 AEN CITY SUB DIV NAGORI GATE",
"SABARKANTHA DIST CENTRAL CO OP BANK LTD",
"BOSCH INDIA FOUNDATION",
"SUPERFORM CHEMISTRIES LIMITED",
"SHARADCHANDRA MAHAVIDYALAYA SHIRADHON",
"DIRECTOR DAIRY DEVELOPMENT",
"GSSS CHAWANDIYA",
"SUBHAM INFRA",
"LBS SENIOR SEC SCHOOL TONK",
"ZPPS DURDI",
"KAUTILYA VIDYALAYA",
"TAHSIL OFFICE GANGAPUR",
"40607 GSSS RATANPURA HANUMANGARH",
"FOUNDATION FOR NEGLECTED DISEASE RESEARCH",
"SURYAVANSHI MACHINE TOOLS",
"INDIA CHURCH OF CHRIST",
"42617 GSSS MALIHALA KHORI",
"GOVERNMENT OF WEST BENGAL DEPUTY DIRECTOR OF RATIONING ASANSOL",
"PORWAL COTSYN",
"DAXINAPATH VIVIDHLAXI VIDHYALAY VYARA",
"SRI VENKATESWARA MATRICULATION HIGHER SECONDARY SCHOOL",
"060 CIVIL JUDGE JR DIVISION CUMJMIC(COURT-II)",
"CRESCENT PUBLIC SCHOOL",
"BILIMORA MUNICIPALITY",
"THE CHEEKA PRIMARY AGRICULTURE COOPERATIVE SOCIETY",
"UDYOGRATNA VELANKAR PRATHAMIK VIDYALAY SANGLI",
"KAY SHIVRAMPANT CHALUKYAVIDYA KUNHALI",
"CBEO UCHAIN",
"307841 X EN P W D DIVISION PARBATSAR",
"B E O TIRLA MADHYA PRADESH DHAR",
"PRECON INDIA CONSULTING LLP",
"DISTRICT TREASURY OFFICE KOLHAPUR",
"Z P HIGHSCHOOL KATI",
"CLINOVO (INDIA) LLP",
"CIRCLE AGRICULTURAL OFFICER NAVAPUR",
"ENGLISH SCHOOL JUNIOR COLLEGE MANGALWEDHA",
"S N COLLEGE OF NURSING",
"HOME HOME GUARD AND CIVIL DEFENCE",
"SMS MEDICAL COLLEGE",
"B R C OFFICE SONGADH",
"CHC ZANKHVAV",
"KRAFTCO",
"SHREE SHANTARAM BHAT ENGLISH MEDIUM SCHOOL MOTA",
"OFFICE OF THE DEPUTY CONSERVATOR OF FOREST (SOUTH)",
"ZP PRIMARY SCHOOL",
"TAHASILDAR BIJEPUR BARGARH",
"THE UNIVERSITY OF BURDWAN",
"PDM COLLEGE OF COMMERCE RAJKOT",
"KUNVARJI ENTERPRISE LLP",
"SCHOOL EDUCATION DEPARTMENT BLOCK EDUCATION OFFICER PRATAPPUR",
"SHIVA PRINTING SOLUTIONS",
"ACCOUNT BRANCH AHMEDABAD DISTRICT PANCHAYAT",
"AMOL POULTRY AND BREEDING FARM",
"LUXURY HOME SOLUTIONS",
"MIRZAPUR PRIMARY SCHOOL",
"OFFICE OF SENIOR MEDICAL OFFICER PRIMARY HEALTH CENTRE PATTO HIRA SINGH MOGA",
"MADARSA MOHAMMADIA MAHEWA PRAYAGRAJ",
"PRATHMIK KRASHI SAHAKARI SANSTHA MARYADIT KHAJURI",
"GOVERNMENT OF CHHATTISGARH LAW AND LEGISLATIVE DEPARTMENT",
"MANEAKCHOWK CO OP BANK ARTS COLLEGE MAHEMADABAD",
"FEROZEPUR CANTONMENT BOARD",
"NC JINDAL PUBLIC SCHOOL",
"GIRNAR PACKAGING",
"SUPERINTENDENT PAY PROVIDENT FUND UNIT SECONDARY LATUR",
"A A D C TIRLA",
"911 D D ADMN BIKANER",
"JALAN TECHNOLOGY CONSULTING PRIVATE LIMITED",
"R J SAFETY SOLUTIONS PRIVATE LIMITED",
"SUNRISE MOTORS",
"RAGHUNATHPUR HIGH SCHOOL",
"S M MODULAR LLP",
"SUPREME MEDICAL DEVICES",
"22200 DISTRICT EMPLOYMENT OFFICE BHARATPUR",
"SM CONSTRUCTION",
"KOTA WORKSHOP",
"C P PATEL AND F H SHAH COMMERCE COLLEGE ANAND",
"R S JHUNJHUNWALA INTERNATIONAL SCHOOL",
"OFFICE OF DISTRIC TUBERCULOSIS OFFICER DISTRICT",
"GYAN STHALI CONVENT SCHOOL JAISINAGAR SAGAR (M.P)",
"RAJKIYA M S KERSAI",
"PERSPICIENTIA CONSULTANCY PRIVATE LIMITED",
"BLOCK EDUCATION OFFICER BARACHANA",
"SAHAYAK AABKARI AYUKT ENFORCEMENT AGRA",
"AEN PHED KATHUMAR",
"G R ENTERPRISES",
"OFFICE OF THE CIVIL SURGEON SUPER DIST HOSPITAL DISTRCIT DHAR M.P",
"GROWN SOLITAIRE LLP",
"RUHS COLLEGE OF MEDICAL SCIENCES",
"SAMAHARNALAYAA PURVI CHAMPARAN MOTIHARI",
"DIST PUBLIC PROCECUTION OFFICAR CHHINDWARA",
"JADE INN",
"CIVIL SURGEON CUM SUPDT MAIN HOSPITAL KHARGONE",
"GOVT OF CHHATTISGARH WOMEN AND CHILD DEVELOPMENT DISTRICT WOMEN AND CHILD DEVELOPMENT DIST KORBA CG",
"STATE INSTITUTE OF PANCHAYAT & RURAL DEV ASAM",
"SHERWOOD PUBLIC SCHOOL",
"BIDHI CHANDRA PUR JR HIGH SCHOOL",
"MALVIYA URBAN CO-OPERATIVE BANK LTD",
"INSTITUTE FOR STEM CELL SCIENCE AND REGENERATIVE MEDICINE",
"GRECIAN HOSPITAL",
"BOTAD DISTRICT EDUCATION COMMITTEE MANAGED PRIMARY SCHOOL TEACHER",
"JAWAHAR NAVODAYA VIDYALAYA AHMEDABAD",
"PS MAHARANI LAKSHMI BAI COMP NAGAR MATHURA",
"KAI SHRIPATRAO SONTAKKE PRASHALA",
"COMPOSITE SCHOOL NARAYANPUR BAD SAHPAU HATHRAS",
"MAHARSHI SANDIPANI RASHTRIYA VEDAVIDYA PRATISHTHAN UJIAIN",
"KOLHAPUR VIDYUT APPRENTICE SWAYAM ROJGAR SAHAKARI SANSTHA MARYADIT",
"DADASAHEB KUMBHARE VIDYALAYA",
"KOMARABAD F P SCHOOL",
"ONE WORLD INSTITUTE OF NURSING",
"STELLAR SCHOOL",
"NEURATECH INNOVATIONS PRIVATE LIMITED",
"SOFTLABS TECHNOLOGIES & DEVELOPMENT PRIVATE LIMITED",
"S D M PUBLIC SCHOOL",
"P S NAGLA PAKHURNI SHERGARH BAREILLY",
"DYAN STAR PUBLIC SCHOOL",
"SHRI SHYAM HOSPITAL",
"GOVT OF CHHATTISGARH OFFICE OF THE BLOCK EDUCATION OFFICE EDUCATION DEPARTMENT PONDIUPRODA DIST KORBA CG",
"TRIAD INFRAVENTURE AND LIFE CARE SOLUTIO N LLP",
"GSSS DHANETA",
"HARIHARPUR CENTRAL SPONSORED PRIMARY SCHOOL",
"CHETANA S INSTITUTE OF MANAGEMENT & RESEARCH",
"AL KAUSAR URDU PRIMARY SCHOOL",
"EDUCATION OFFICE OF PRINCIPAL GOVT HIGHER SECONDARY GODAM SARANGARH-BILAIGARH",
"GAUTHAMI TECHNO SCHOOL",
"MUSKAAN DREAM CREATIVE FOUNDATION",
"JAGANNATH ENTERPRISES",
"ASSOCIATED PROJECT INFRA",
"Z P P SCHOOL KASGI",
"HOLY HELP HOSPITAL",
"LUMANI SCHUCO GERMAN WINDOW SYSTEM",
"BLUE LEAF ENERGY INDIA LLP",
"EQUIP MASTERS CORPORATION",
"Z P SCHOOL BEDAKIPADA",
"BINODINI GIRLS HIGH SCHOOL",
"GAYATRI CONSTRUCTORS LLP",
"NATIONAL HIGHWAY DIVISION THANE",
"AASTHA HOSPITAL",
"GOVT OF JHARKHAND R D SPL DIV GIRIDIH",
"SRI SANGVEDA SANSKRIT SECONDARY SCHOOL NAGHARI PUR MUSTAFABAD",
"JAGAT NARAYAN PURV MADHYAMIK VIDHYALAY",
"YASHWANTRAO GHATAGE HIGHSCHOOL",
"RAJIV GANDHI MADHYAMIK VIDHYALAYA FULCHINCHOLI",
"SHARADCHANDRAJI PAWAR HIGH SCHOOL NAI CHAKUR DIST OSMANABAD",
"100908 GSSS MOYANA",
"BAFRA FP",
"SUPERINTENDENT SCB MEDICAL COLLEGE AND HOSPITAL CUTTACK",
"Z P PRIMARY SCHOOL WAGHMARE WASTI WAGHOLI",
"SAI AIRCON",
"RADIO COMPUTING SERVICES (INDIA ) PRIVATE LIMITED",
"ANIMAL HUSBANDARY PANCHAYAT SAMITI SAKRI",
"AAYUSHMAN HOSPITAL",
"KIKANI HR SEC SCHOOL",
"GOLDEN JUBILEE SCHOOL JALNA",
"MARVEL SYNTEX LLP",
"GOVERNMENT OF ASSAM MORAN PUBLIC HIGH SCHOOL, MORAN",
"ARUN M AGARWAL AND ASSOCIATES",
"SHREE AMBA INDUSTRIES-CORP",
"IN-COUNTRY LOGISTICS PRIVATE LIMITED",
"SRI VENKATA SAI ENGINEERING PRIVATE LIMITED",
"LEHAL DIVISION IB PATIALA",
"TARGET AGRO CHEMICAL",
"ZPPS GAIKWADWADI",
"SEAL SUSTAINABLE & AFFORDABLE ENERGY FOR LIFE",
"ATOZ INDUERSTRIES",
"ALWAR COLLECTOR ALWAR",
"SHREE BALAJI GROUP",
"C M S SWAROOPRANI NEHRU HOSPITAL ALLAHABAD",
"DY COMMISSIONER TRADE TAXKANPUR NAGAR",
"SL MEMORIAL ENGLISH SEN SEC SCHOOL",
"COM MUNICIPALITY HANUMANGARH",
"SAINI INTERNATIONAL SCHOOL HOWRAH",
"THE LEELA CORPORATE OFFICE",
"DISTRICT EDUCATION COMITTEE BHAVNAGAR",
"2398 SR SUPERINTENDENT GARDENS PWD JODHPUR",
"DISTRICT EDUCATION COMMITTEE ANAND",
"ACADEMIC WORLD SCHOOL",
"B E O (PETLAWAD) JHABUA",
"PRINCIPAL L H M C AND SMT SUCHETA KRIPLANI HOSPITAL",
"RHYTHM SUPER SPECIALITY HOSPITAL",
"MSME TOOL ROOM",
"4947 DY DIR AGRICULTURE ( BOTANY) SEED TESTING LAB SRIGANGANAGAR",
"SINDHUTAI VIKHE PATIL MEMORIAL HOSPITAL",
"MOOGAMBIGAI CHARITABLE AND EDUCATIONAL TRUST",
"NARAYAN MEDICAL COLLEGE & HOSPITAL",
"GOVT OF JHARKHAND EX ENG RCD ROAD DIV HZB",
"VASANT VALLEY SCHOOL",
"MOONSHINE FOOD VENTURES LLP",
"BLOCK MNREGA",
"DEVA NAGRI COLLEGE MEERUT",
"CHHATTISGARH INSTITUTE OF MEDICAL SCIENCES",
"GOVT SENIOR SECONDARY SCHOOL BHOJPURAKALAN",
"REVATHI COLLEGE OF NURSING",
"TUNAV FOOD PRODUCTS LLP",
"PREMJI RATANSI PATEL HIGHSCHOOL SHRIRAMPUR JI.AHMEDNAGAR",
"EE RES DEWAS",
"CHOUDHARY GHARSIRAM COLLEGE OF PHARMACY",
"SAHIBZADA AJIT SINGH ACADEMY",
"INDIRA PRIYADRSHINI COLLEGE FOR WOMEN",
"MAULI AGRI TECH SCHOOL UMBADGA",
"MEHTA PUBLIC SR SEC SCHOOL",
"PATEL ADVANCE JV",
"NML KERALA PUBLIC SCHOOL",
"KULCHA HANSRAJ MORDERN SCHOOL",
"THE YASHWANT CO OPERATIVE BANK LIMITED",
"URBAN DEPARTMENT DEVELOPMENT OF GNCTD OF DELHI",
"SADBHAVNA MEDICAL & HEART INSTITUTE",
"KNAV & CO. LLP",
"NORTH INDIA TRANSXPRESS PRIVATE LIMITED",
"ATHARVA LABORATORIES PRIVATE LIMITED",
"FEATURE PLANET PRIVATE LIMITED",
"ETERNO HOUSING PRIVATE LIMITED",
"BML GEMS & JEWELLERY",
"CROWN HOSPITALITY",
"VIP HOUSING AND PROPERTIES LLP",
"ASSISTANT DIRECTOR SOIL CONSERVATION BHADRAK",
"KHODIYAR EDUCATION TRUST MEHSANA",
"VIVACITY MULTISPECIALITY HOSPITAL",
"PANCHASHEEL RATRA VIDYALAYA",
"ST CLARET COLLEGE",
"ADD COMMISSIONER MUNICIPAL COOPRATION JAIPUR GRATER",
"SPECIALIST TUBERCULOSIS STAT EMPLOYEEE INSURANCE TB HOSPITAL MADHYA PRADESH INDORE",
"M J P ROHILKHAND UNIVERSITY",
"MAHARISHI VIDYA MANDIR",
"DIRECTOR",
"S BASAVRAJ HIGH SCHOOL KARAJAG KARAJGI",
"NATIONAL COMPANY LAW TRIBUNAL",
"DEFENCE PUBLIC SCHOOL",
"S V M CHILDRENS ACADEMY",
"GOVERNMENT OF CHHATTISGARH LAW AND LEGISLATURE WORK DEPARTMENT",
"BHARATPUR TEHSIL RARAH",
"UNIQUE LOGISTIC AND SERVICES",
"AG AANDE II MAH NAGPUR",
"SUYOG ENGINEERS",
"PLACE STUDIOS",
"PRIYADARSHANI MAHILA NAGARI SAHAKARI BANK LTD BEED",
"UTTAR PRADESH STATE SEED CERTIFICATION AGENCY",
"THE HISAR CENTRAL CO OPERATIVE BANK LTD",
"DAMDIM TG JR HIGH SCHOOL",
"CHALTABERIA HIGH MADRASAH",
"WADZPAY TECHNOLOGY INDIA PRIVATE LIMITED",
"JASGUN VENTURES PRIVATE LIMITED",
"GSSS BILIYA SHAHPURA",
"DFSC BATHINDA",
"PRASASANIK SUDHAR UP GOVT",
"DISTT HOMEOPATHIC MEDICAL OFFICE ALIGARH",
"SHUBH SHAGUN ENTERPRISES",
"VEERANGANA AVANTI BAI MAHILA CHIKITSALAYA",
"GOVERNMENT OF ASSAM OFFICE OF THE INSPECTOR OF SCHOOL TINSUKIA",
"NATIONAL AUTOPLAST",
"ABHIJEET VIDHYALAYA NER JALNA",
"LIVEGAGE TECHNOLOGY SERVICES PRIVATE LIMITED",
"2334 GSSS 50 F RUPNAGER",
"AKSHARA SIRI VIDYA MANDIR",
"AASHIMA HOSPITAL",
"SHREE MAHATMA BASVESHWAR KANNAD PRIMARY SCHOOL SOLAPUR",
"TURBOTECH ENGINEERS",
"ZPPSSI SIDDHESHWAR NAGAR",
"LATE MAROTISA SAVAJI PRI SCHOOL AKOLA",
"CLIMATE COLLECTIVE FOUNDATION",
"PRINCIPAL GSSS KOTLA PANJOLA",
"521 DISTRICT STATISTICAL OFFICER",
"21762 GSSS SHAHBAD",
"JAHNAVI AUTOMOBILES PRIVATE LIMITED",
"JAIRAJ DEVELOPERS LLP",
"PRAJA CONTROLS & SYSTEMS PRIVATE LIMITED",
"MNR KNOWLEDGE TRUST",
"JR ADMINISTRATIVE OFFICER GENERAL HOSPITAL BHANDARA",
"I C D S PANCHAYAT SAMITI KARAD 2",
"SANT ATTAR SINGH INTERNATIONAL SEN SEC SCHOOL",
"EX ENG P H E MAIN DN UJJAIN",
"ULTRADENIM LIFESTYLE PRIVATE LIMITED",
"HARYANA SCHEDULED CASTES FINANCE AND DEVELOPMENT CORPORATION",
"ZPPS SANPURI",
"MARATHWADA MADHYAMIK VIDYALAY SAROLA ROAD DIST LATUR",
"PRABHU NARAYAN RAJKIYA INTER COLLEGE",
"GOVT PRINCIPAL DISTRIC JUGDE CHHATARPUR",
"GUARDIAN HOSPITAL & RESEARCH CENTRE",
"SUNBERRY LIFESCIENCES PRIVATE LIMITED",
"RINGING BELLS SCHOOL",
"SIDDHARTH SHIKSHAN PRASARAK MANDAL SANMADI SANCHALIT",
"SEVENTH DAY ADVENTIST SENIOR SECONDARY SCHOOL",
"PT MOTI LAL NEHRU LAW COLLEGE CHATARPUR M.P",
"PRIXCART E BIZ SOLUTION LLP",
"SHRI MAHATMA BASVESWAR KANNAD PRATHAMIK SHALA SOLA",
"CALIFORNIA PUBLIC SCHOOL",
"FRIEDRICH NAUMANN STIFTUNG FUR DIE FREIHEIT",
"DEPARTMENT OF ARCHAEOLOGY",
"GOVT COLLEGE FOR WOMEN BAWANI KHERA BHIWANI",
"OM PARKASH BANSAL MODREN SCHOOL",
"DHANBAD PUBLIC SCHOOL",
"DONIKANA HIGH SCHOOL",
"B E O TONK KHURD DEWAS",
"ICLEI SOUTH ASIA SECRETARIAT",
"C D P O THANAGAJI",
"15754 GSSS AASAN",
"RAW MANGO DESIGNS PRIVATE LIMITED",
"14221 ADDITIONAL DIR DLB JPR",
"KALGIDHAR PUBLIC SCHOOL",
"MADAN MEMORIAL CHILDREN HOSPITAL",
"J S TYAGI HR SEC SCHOOL ALIGARH",
"SEALINE SHIPPING & LOGISTICS",
"HARYANA SPACE APPLICATIONS CENTER",
"SREE BHARAT LABS",
"LOKPRIYA JANTA INTER COLLEGE",
"GANDHI INSTITUTE OF TECHNOLOGY AND MANAGEMENT",
"ROYAL INDIA SECURITAUS",
"M I HOSPITAL",
"NARAYANA SUPERSPECIALITY HOSPITAL",
"BABY SAINIK HIGH SCHOOL",
"DR B R AMBEDKAR NATIONAL INSTITUTE OF TECHNOLOGY",
"PAREVARTAN SCHOOL",
"DISTRICT EDUCATION COMMITTEE DWARKA",
"BLOCK EDUCATION OFFICER TANGI CHOUDWAR",
"NAGALAND UNIVERSITY",
"209 PRINCIPAL GSSS KUFRI",
"GUREPOLE HIGH SCHOOL",
"BALASORE BHADRAK CENTRAL CO-OPERATIVE BANK",
"RISHI BEVERAGES",
"GOVT OF CHHATTISGARH OFFICE OF THE PRINCIPAL GOVT BOYS HIGHER SECONDARY SCHOOL HARDIBAZAR DIST KORBA CG",
"NATIONAL ASSOCIATION FOR THE BLIND",
"EXE ENGINEER ELC DIV IV O & M MARGAO",
"061 A O I G M C",
"PS RAJSAMAND",
"N J SURESH AND ASSOCIATES",
"MAA ENT HOSPITALS",
"SMBT HOSPITAL",
"ECARTER TECHNOLOGIES PRIVATE LIMITED",
"DIAMOND COPY HOUSE",
"GOVT OF CHHATTISGARH HEALTH DEPARTMENT OFFICE OF THE CIVIL SURGEON DIST KORBA CG",
"RATNAI MAHASWARGIYA MULINCHE VASTIGHRUH PIRAL",
"GOVT OF JHARKHAND M S KOLAKUSMA",
"BEO PUNASA MADHYA PRADESH KHANDWA",
"1810 DIRECTOR MOBLIE SURGICAL UNIT JAIPUR",
"TILAK INTER COLLEGE KOTWA ALLAHABAD",
"GURUDAS BHASKARGIRI MAHARAJ MADHYAMIK VIDYALAY",
"OFFICE OF THE EXECUTIVE ENGINEER OKHLA",
"MUNICIPAL COUNCIL",
"THE BADSUI CO OP CREDIT & SERVICE SOCIETY LTD",
"SHREEMAYA CELEBRATY",
"ZILHA PARISHAD CANTRAL HIGHSCHOOL FULSANGAVI",
"GREENWAY PACKAGING INDIA LLP",
"ULTRA TECH ENVIRONMENTAL CONSULTANCY & LABORATORY",
"BHUMI CONSTRUCTION COMPANY",
"P W SPECIAL PROJECT DEVISION AAREY",
"ZILHA PARISHAD RATNAGIRI",
"PROOWRX LLP",
"GFC GLOBAL PUBLIC SCHOOL",
"BLOCK EDUCATION OFFICE BRAHMAGIRI PURI",
"ORCHID SMART SCHOOL",
"ATK EXPRESS LLP",
"COMMUNITY HEALTH CENTER SIKANDRA DAUSA",
"THE SHRI RAM ACADEMY",
"HIGHER EDUCATION DEPARTMENT (HIGHER TECHNICAL SCIENCE & TECHNOLOGY)",
"GSSS TARSIKKA",
"B D M INTERNATIONAL PRATAPGARH",
"DAV PUBLIC SCHOOL WATER WORKS ROAD PURI",
"ELANKARA TRADERS",
"SAGAR MULTISPECIALTY HOSPITAL",
"SHEREE SHETH GANAPATARAAV SOORYAVANSHEE VIDAALAY TAMBAAVE",
"RVR & JC COLLEGE OF ENGINEERING",
"GALGOTIAS COLLEGE OF ENGINEERING & TECHNOLOGY",
"NEUTEN HEALTHCARE",
"M D PAWAR PEOPLES CO OP BANK LTD",
"PUBLIC HEALTH AND FAMILY WELFARE DEPARTMENT HEALTH DEPARTMENT OFFICE OF CHIEF MEDICAL AND HEALTH OFFICER KORBA CG",
"PANORAMA WORLD SCHOOL",
"SOURCERIGHT TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"DHARMA IT SOLUTIONS PRIVATE LIMITED",
"ASAP BUSINESS AND IT CONSULTING INDIA PRIVATE LIMITED",
"AMERICANA RESTAURANTS (INDIA) PRIVATE LIMITED",
"VYSYA CO OPERATIVE BANK LIMITED",
"ZP PS NHAVI",
"26761 GSSS MARKHI SAHAPURA JAIPUR",
"ANADYA BPO SERVICES LLP",
"JILA KRISHI RAKSHA ADHIKARI VARANASI",
"FARIDKOT SDSCO",
"FELLOWSHIP INTERNATIONAL SCHOOL MAJIGAM CHIKHLI",
"DR AGD BENDALE MAHILA COLLEGE JALGAON",
"SPECIAL DEPUTY SUPERINTENDENT OF LAND RECORDS SOLAPUR",
"UNNATI STRATEGIC VENTURES LLP",
"TAHASILDAR CHANDABALI",
"AMRISHBHAI R PATEL SCHOOL",
"CSK HIMACHAL PRADESH AGRICULTURE UNIVERSITY PALAMPUR",
"VIKRANT AUTOMOBILES",
"OFFICE OF THE EXECUTIVE ENGINEER P W D",
"WISETEK IT SOLUTIONS",
"CIVIL COURT SENIOR DIVISION AURANGABAD",
"PRINCIPAL SR CIVIL COURT SAVLI",
"YAMUNA INSTITUTE OF ENGINEERING AND TECHNOLOGY",
"APOLLO HOSPITALS EDUCATIONAL & RESEARCH FOUNDATION",
"KRUSHNA FINSERV LLP",
"HI TECH DIAGNOSTIC CENTRE GONDIA",
"NATIONAL INSTITUTE OF ADVANCED MANUFACTURING TECHNOLOGY (NIAMT)",
"RAJKOT CANCER SOCIETY",
"SMT C DEVI BHOSLE UPS K BARA NAGPUR",
"ACTION ISPAT AND POWER PRIVATE LIMITED",
"KAZI NAZRUL ISLAM MAHAVIDYALAYA",
"UTTAR BUNIYADI VIDHYALAY GHANI",
"C M DESAI HIGH SCHOOL",
"LILUAH CO OPERATIVE BANK LIMITED",
"DABIRI FASHION PRIVATE LIMITED",
"SEVALAYA",
"OSEL DEVICES LIMITED",
"STANES SCHOOL CBSC",
"PEEOFARASHPURA",
"DIRECTOR ANIMAL HEALTH AND VET BIOLOGICAL RASALPURA MHOW",
"BLOCK EDUCATION OFFICER PURI SADAR",
"A G AANDE II M P GWALIOR",
"V & ASK INDIA VENTURES PRIVATE LIMITED",
"OFFICE OF THE ELECTRICAL EXECUTIVE ENGINEER ELECTRICAL SUPPLY DIVISION DHANBAD",
"AGRAWAL HOSPITAL",
"DEPARTMENT OF HEALTH & FAMILY WELFARE DELHI SECRETARIAT",
"THE ADVENTURE CONVENTION & RESORT BBSR",
"MUKHYAMANTRI LAGHU EVAM KUTIR UDYAM VIKAS BOARD",
"MINI SING AND GRAPHICS",
"H N A & CO LLP",
"SHRI TIKAMDAS PURSHOTTAM BHATIA JR COLLEGE OF SCIENCE",
"787 E E JAL SHAKTI DIV BADDI",
"THE SIRSA DISTT CO OP MILK PRODUCSERS UNION LTD",
"SUTHAR ENTERPRISES",
"AMNS GANDHIDHAM LIMITED",
"ALL INDIA PINGALWARA CHARITABLE SOCIETY",
"WAHEGURU TELECOM",
"DISTRICT EDUCATION OFFICER GANJAM BERHAMPUR",
"SHREE SARIGAM ENGLISH NURSERY",
"23315 BLOCK CHIEF MEDICAL OFFICER SALAWAS JODHPUR",
"NAV NIRMAN UTTAR JUNIYAR VIDHALAYA",
"MS VIDIT HEALTHCARE",
"309733 GSSS BEDAWAL SALUMBER",
"TALUKA PANCHAYAT GODHRA",
"ZPPS SAKAT",
"GOVERNMENT INDUSTRIAL TRAINING INSTITUTE KALKA AT BITNA",
"FRONTLINE EX SERVICEMEN BUREAU",
"DFO TERRITORIAL NORTH SEONI",
"PRIMARY HEALTH CENTER BHOSE",
"GOVT OF JHARKHAND MS BANDHDIH (JARIDIH) BOKARO",
"GSSS AANJANI LASADIYA UDAIPUR",
"FATEH BAHADUR INTERMEDIATE COLLEGE",
"A ONE REFRIGERATION",
"MADHYAMIC VIDYALAY",
"MEHAM CO-OPERATIVE SUGAR MILLS LTD",
"PEARLTECH CONSULTANCY PRIVATE LIMITED",
"ARYAN PACKAGING INDUSTRIES",
"BPKIC BALRAMPUR BARETHI ALLAHABAD",
"20 DEGREES SOFTWARE INDIA PRIVATE LIMITED",
"INMUTO CONSULTING PRIVATE LIMITED",
"CEREMORPHIC TECHNOLOGIES PRIVATE LIMITED",
"CAPITAL SOLAR SOLUTIONS PRIVATE LIMITED",
"RELIANT FACILITATOR PRIVATE LIMITED",
"MAGNA YUMA PRIVATE LIMITED",
"DARK MATTER LABS PRIVATE LIMITED",
"APAR ADVERTISERS PRIVATE LIMITED",
"FEATLY TEXTILIA AND FABRICAE PRIVATE LIMITED",
"TSSIND INDUSTRIES PRIVATE LIMITED",
"RURAL DENTAL COLLEGE",
"ASS COMM OF ANIMAL HUSBADARY VETY POLICLINIC AHMEDNAGAR",
"VIR BHAGATSINH VIDYALAY BHORDU",
"SANE GURUJI PRIMARY SCHOOL AKKALKOT RAOD SOLAPUR",
"GOVERNMENT OF CHHATTISGARH PH AND FW DEPARTMENT OFFICE",
"BLOCK EDUCATION OFFICER PIPILI",
"TEHSILDAR PANDHANA MADHYA PRADESH KHANDWA",
"RADAD PRIMARY SCHOOL TA PADDHARI",
"GLOBAL ENTERPRISE TECH RESOURCES PRIVATE LIMITED",
"MAA TARINI STEELS LLP",
"ISIEINDIA PRIVATE LIMITED",
"NEXTDOORHUB INTERNATIONAL PRIVATE LIMITED",
"DEEKSHA JUNIOR COLLEGE HYDERABAD",
"FORTUNE CONVENT SR SEC SCHOOL",
"SBSBM UNIVERSITY COLLEGE SARDULGARH",
"HOLIDAY INN CHENNAI",
"MIDDLE SCHOOL ASTHAWAN NALANDA",
"B E O DHARAMPURI DHAR",
"GPS BIDHIPUR",
"NIMO INNOVATIONS INDIA PRIVATE LIMITED",
"BHIMASHANKAR VIDYALAYA WAHEGAON",
"GHS KOTHE LAL SINGH",
"MEGHA AUTOMOTIVE LLP",
"U P STATE ROAD TRANSPORTATION CORPORATION ANAND VIHAR DEPOT",
"EKLAVYA MY SCHOOL",
"B E O RAMPUR BAGHELAN SATNA",
"616 AE TO EE HPPWD DIV 1",
"DEVIKRUPA EXTRUSION",
"BAI KABIBAI AND HANSRAJ MORARJI CHARITY TRUST",
"ADHYAYANA PRE UNIVERSITY COLLEGE HASSAN",
"IINVSYS PRIVATE LIMITED",
"YEELANCER",
"214 PR GOVT SSS TUTIKANDI",
"ACHARYA PRAFULLA CHANDRA HIGH SCHOOL",
"DISTT PROGRAMME OFFICER WOMAN AND CHILD DEVLP",
"FINEXPERT CONSULTANTS LLP",
"UPBOTT CONSULTING PRIVATE LIMITED",
"KHANDHERI PRI SCHOOL TA PADDHARI",
"VELA TECHNOLOGIES INDIA LLP",
"MANDYA DISTRICT CO OPERATIVE CENTRAL BANK LTD",
"FIRE SERVICES",
"MEGHA FLOWERS",
"MATA GUJRI KINDERGARTEN",
"BANTRA MSPC HIGH SCHOOL",
"SHRI DHOKAJI MAHARAJ MADH VIDYALAYA NIMGAONDAKU",
"PRAJ GENX LIMITED",
"INNO VALLEY WORKS PRIVATE LIMITED",
"TITRI DIGITAL SERVICES PRIVATE LIMITED",
"EMMAY ENTERTAINMENT & MOTION PICTURES LLP",
"67 JOINT DIRECTOR ANIMAL HUSBANDRY ALWA",
"BLOCK HEALTH OFFICE 5 BHUJ DISTRICT PANCHAYAT",
"VIEWZEN LABS PRIVATE LIMITED",
"RAMRAHIM PRAGATI PRODUCER COMPANY LIMITED",
"MAYANK BUILDCON",
"URMI SUPERMARKET 24 *7",
"ACE PACKAGING",
"ZAO CBDT ALLAHABAD",
"NAJARAT ADHISHTHAN COLLECTORATE MTR",
"PR DIRECTOR OF AUDIT SD NEW DELHI",
"CONTROLLERATE OF NAVAL ARMAMENT INSPECTION VISAKHAPATNAM",
"VADODARA DISTRICT EDUCATION COMMITTEE MANAGED PRIMARY SCHOOL TEACHER",
"ROYAL ENTERPRISES",
"LOK BANDHU RAJ NARAYAN SAIYUKT CHIKATSALAYA LUCKNOW",
"NAURANGILAL GOVERNMENT INTER COLLEGE ALIGARH",
"ASTT COMMISNER T W D RTM MADHYA PRADESH RATLAM",
"MAXWELL GEOSYSTEMS INDIA PRIVATE LIMITED",
"GOVERNMENT OF TRIPURA",
"KAKASAHEB MHASKE PRATHMIK VIDYALAY",
"V R AGRO PROCESSORS LLP",
"RUBY PARK PUBLIC SCHOOL",
"GURU JAMBHESHWAR UNIVERSITY OF SCIENCE AND TECHNOLOGY",
"202 GSSS DABLOO",
"CHIEF VETENORY OFFICER NAINITAL",
"SANKALCHAND PATEL UNIVERSITY VISNAGAR",
"SHRI PADMAAVATHI MULTI SPECIALITY HOSPITAL",
"WINNING MOVE INFOTECH LLP",
"BENGALURU COOPERATIVE MILK UNION LIMITED",
"MAVERICKS AND MUSERS MEDIA PRIVATE LIMITED",
"PEACE POINT HOSPITALS PRIVATE LIMITED",
"TRINITY COLLEGE",
"MAHATMA GANDHI GOVT SCHOOL ENGLISH MEDIUM CHHAPOLI UDAIPURWATI",
"NEW ADARSH SECONDARY ENGLISH MEDIUM SCHOOL",
"THE UNITED PURI NIMAPARA CENTRAL CO OPERATIVE BANK LTD",
"ASHOKA STEEL FURNITURE INDUSTRIES",
"P K MARKETING CO",
"EX ENGR BHIMA IRRIGATION DIVISION PANDHARPUR",
"ECR SAMASTIPUR DIVISION",
"GYAN GANGA INTERNATIONAL SCHOOL",
"MRUDALA HOSPITAL",
"MOTIVATION ACADEMY",
"12235 DY DIRECTOR AYURVED DEPTT DISTRICT DAUSA",
"ST XAVIERS HIGH SCHOOL ZAROLI",
"TORANDA PRIMARY SCHOOL KUKARMUNDA",
"OFFICE OF THE DMEO",
"RAJIV GANDHI SUPER SPECLALITY HOPSITAL",
"PEEO DIWER",
"JOINT DIRECTOR ANIMAL HUSBANDRY SIKAR",
"GURU GOBIND SINGH COLLEGE OF EDUCATION GIDDARBAHA",
"KOMALI LOGISTICS",
"THE APOLLO UNIVERCITY",
"CENTRAL RAILWAY NAGPUR DIVISION",
"WELCOMHOTEL BY ITC HOTELS JABALPUR",
"CORRL8 INSIGHTS PRIVATE LIMITED",
"GGSSS KAMLA NEHRU JAIPUR",
"MAXKING (INDIA) FOOTWEAR PRIVATE LIMITED",
"DUFRY INDIA RETAIL PRIVATE LIMITED",
"BATCH SERVICE PRIVATE LIMITED",
"HANUMA INFOTECH PRIVATE LIMITED",
"TOURS INFOTECH PRIVATE LIMITED",
"DILSUKHNAGAR PUBLIC SCHOOL",
"OFFICE OF THE COLLECTOR DISTRICT SARANGARH",
"SANGOLE NAGAR PARISHAD SANGOLE",
"ASHOK ELECTRICAL FABRICATOR",
"P D PWD FRZ",
"ETERNITY FORWARDERS PRIVATE LIMITED",
"NAGPUR AND WARDHA DISTRICT MATHADI AND UNPROTECTED LABOUR BOARD",
"ESTABLISHMENT BRANCH TAPI TALUKA PANCHAYAT",
"ZPPS LADABAPADAL",
"CHOPRA MANUFACTURING CO",
"EXECUTIVE ENGINEER MUJAFFARNAGAR SECTION CANAL MUJAFFARNAGAR",
"BAHUDDESHIYA KELAKHEDA KISAN SEWA SEHKARI SAMITI LIMITED",
"MADARSA JAMIATUL FALAH",
"BHATKYA JATI JAMATI ASHRAM SCHOOL KADKHEDE",
"MATERIAL ORGANISATION",
"HOTEL RAMADA (UNIT OF SRPL)",
"VETERINARY HOSPITAL SIRAULI GAUSPUR BARABANKI",
"TUMKUR DISTRICT CO OPERATIVE CENTAL BANK LTD",
"HANSPAL TRADERS",
"SPHERE360 PRIVATE LIMITED",
"BLUE BELLS MODEL SCHOOL GURGAON",
"BHARAT MUK VIDYALAYA NANDANVAN NAGPUR",
"EXECUTIVE OFFICER MUNICIPAL COUNCIL SOHNA",
"YADAVRAO TASGAONKAR COLLEGE OF ENGINEERING & MANAGEMENT",
"HYDERABAD DIVISION",
"MUNESHWAR NAVIN CONSTRUCTION",
"VASU SHIPPING AND LOGISTICS LLP",
"SUPDT CUM CIVIL SURGEON DHAR",
"KRUSHI UTPANNA BAZAR SAMITI MAJALGAON JILHA BEED",
"ENVIROMENT FOREST AND WILDLIFE",
"DISTRICT EDUCATION OFFICE NABARANGPUR",
"22582 BLOCK CHIEF MEDICAL OFFICER SHHABAD (BARAN)",
"THE ASSAM KAZIRANGA UNIVERSITY",
"ADVANTEK ELECTRONICS LLP",
"DOABA COLLEGE JALANDHAR",
"SUN INDIYA PUBLIC SCHOOL",
"PRECISION TECHNOCRATE AND MARKETERS",
"THE CO OP BANK OF MEHSANA LTD",
"1426 CBEO MUNDWA",
"PRANALI TRANSOLUTIONS PRIVATE LIMITED",
"HUTATMA BABURAO BORGAONKAR VIDHYALAYA BORGAON",
"KRYSTAL SKIN CLINIC",
"MALHOTRA DENTAL CLINIC",
"TIRUPATI VIDY PANGAO",
"SHRI MAHALXMI VID KUNDANLAL GUPTA NAGAR NGP",
"K K PATEL SUPER SPECIALITY HOSPITAL",
"SHRI GOWRIKRISHNAA",
"VINDYAVASINI TRADERS MOHADDIPUR GORAKHPUR",
"DIST ANIMAL HUSBANDRY OFFICER Z P NANDED",
"ZPPS ADIVASI WADI KODA",
"DR VITHALRAO VIKHE PATIL FOUNDATION MEDICAL COLLEGE",
"PUBLIC HEALTH & FAMILY WELFARE DEPARTMENT BLOCK MEDICAL OFFICER DURG",
"PUNJAB INDUSTRIES",
"VAIDHYAMEGHA PRIVATE LIMITED",
"LOGIMAX TECHNOLOGIES PRIVATE LIMITED",
"GOVERNMENT MEDICAL COLLEGE AND SUPERSPECIALITY",
"NOOTAN COLLEGE OF NURSING",
"AQUA ORANGE",
"P T B D SHARMA POST GRADUATE¬† INSTITUTE OF MEDICAL SCIENCE",
"B E O PIPARIYA MADHYA PRADESH HOSHANGABAD",
"NEOSOFT TECHNOLOGIES INTERNATIONAL",
"ONE ACADEMY",
"NHDC BHOPAL",
"S H S S BAHERA SANDAL SINGH SAHARANPUR",
"PRINCIPAL DISTRICT JUDGE",
"A A D C SARDARPUR",
"WELCOMHOTEL DEVEE GRAND BAY",
"SAMRAT PRITHVIRAJ CHAUHAN INSTITUTE OF NURSING AND PARAMEDICALSCIENCE",
"MAHATMA GANDHI GOVERNMENT SCHOOL (ENGLISH MEDIUM) NAYABAS ALWAR",
"GMC SUNRISE HOSPITAL",
"E2 INFOSYSTEMS PRIVATE LIMITED",
"VIZAG SPECIALITY HOSPITALS",
"LAKHDHIRPUR PRATHMIK SHALA",
"BARRY WEHMILLER INDIA PRIVATE LIMITED",
"THE MYSORE AND CHAMARAJANAGAR DISTRICT CO OPERATIVE CENTRAL BANK LTD",
"SHREE SELAMBA HIGH SCHOOL",
"MOINUL ULOOM HIGH SCHOOL SILK MILLS COLONY AURANGABAD",
"BLOCK EDUCATION OFFICER JODA",
"M S CHARHI CHURCHU",
"EXECUTIVE ENGINEER MATATILA DAM DIVISION JHANSI",
"RNG ASSOCIATES PRIVATE LIMITED",
"N G PATEL POLYTECHNIC",
"SAI RAM SECURITY & PLACEMENT SERVICE HISAR",
"JUSTICE K S HEGDE INSTITUTE OF MANAGEMENT",
"THE KALANWALI CO-OP¬† MKG C/P SOCIETY LIMITED",
"TELANGANA REMOTE SENSING APPLICATIONS CENTRE (TGRAC)",
"OFFICE OF THE DISTRICT REGISTRAR CO OPERATIVE SOCIETIES MEHSANA",
"RISING PHARMA SPECIALITIES PRIVATE LIMITED",
"QUANTUM BUSINESS MULTISERVICES PRIVATE LIMITED",
"INBA LOGISTICS PRIVATE LIMITED",
"JAYASHREE CONSULTANT PRIVATE LIMITED",
"DAMOR JAYANTILAL GOMANBHAI GANJI PRIMARY SCHOOL",
"ZPPS KALWATI TANDA N0 1 KALWATI TANDA NO 1",
"HUSN SAHARA ENGLISH MEDIUM HIGH SCHOOL",
"PATTRACHAR SHIKSHA SANSTHAN UP ALLAHBAD",
"PHOENIX POULTRY PARIYAT UNIT",
"UTTAR PRADESH FOREST CORPORATION",
"R P S INTER COLLEGE BHONDELA FIROZABAD",
"SHRI O H NAZAR AYURVED COLLEGE HOSPITAL SURAT",
"MATA BHATEE DEVI SR SEC SCHOOL",
"SOU ANUSAYADEVI SONKAWADE VIDYALAYA WALANDI TQ DE",
"AGM BACK OFFICE SUPPORT SYSTEM PRIVATE LIMITED",
"AURA JEWELS",
"AEN PHED SUB DIVISION SHAHAPURA",
"A P SUPERSPECIALITY DENTAL HOSPITAL",
"SOUTH INDIAN WELFARE SOCIETY COLLEGE",
"AYYAPPA EDUCATIONAL SOCIETY",
"SHRI ANAND PARSHWA GURUKUL SCHOOL KEDGAON",
"SRI VENKATESHWAR INTERNATIONAL SENIOR SECONDARY",
"SHRI GURU BUDDHISWAMI MAHAVIDYALAYA",
"DDO",
"R C PATEL INSTITUTE OF TECHNOLOGY SHIRPUR",
"ITI ARAB KI SARAI NIZAMUDDIN",
"SHARP EYE FOUNDATION PRIVATE LIMITED",
"STAR SUPERSPECIALITY JALANDHAR",
"SINDHUSONS CORPORATION",
"PROZEAL GREEN ENERGY LIMITED",
"ADSULS TECHINCAL CAMPUS FACULTY OF ENGINEERING AND MBA",
"T B S HR SECONDARY SCHOOL",
"SBM GLOBAL SERVICES",
"KITY SALES",
"SAINT JOSEPH S SCHOOL NTPC",
"PROMHO ENERGY PRIVATE LIMITED",
"METRIX RESEARCH AND ANALYTICS PRIVATE LIMITED",
"MARKETCAST INDIA PRIVATE LIMITED",
"FORWARD NETWORKS INDIA PRIVATE LIMITED",
"WORLD AT WORK PRIVATE LIMITED",
"POWER GAIN ENGINEERS",
"22230 BLOCK CHIEF MEDICAL OFFICER RAJGARH ALWAR",
"SARDAR PATEL VIDYALAYA",
"POA CULTURE NEW DELHI",
"EDUCATION DEPARTMENT P S PALUS",
"CHIEF MEDICAL SUPDT WOMEN HOSPITAL BAREILLY",
"COMMUNITY HEALTH CENTER TALERA",
"SANJAY ASHRAMSHALA",
"223 B E E D DEHRA",
"REGENT DEFENCE AND ENGINEERING SYSTEMS LIMITED",
"ELEENA COSMETICS",
"THE BVB SCHOOL",
"SRI SAI GRAMOTHAN SAMITI",
"RO KART SALES AND SERVICES",
"GOVT OF HARYANA EDUCATION DEPARTMENT",
"S R P VAV PRIMARY SCHOOL",
"ISF COLLEGE OF PHARMACY",
"GOVT ARTS COMMERCE & SCIENCE COLLEGE KHERGAM",
"C S CUM HOSPITAL SUPDT HARDA",
"ENEA SOFTWARE PRIVATE LIMITED",
"ROCK AND ROSE CONSTRUCTION PRIVATE LIMITED",
"ELLIOTT LABS PRIVATE LIMITED",
"MAHARASHTRA KRUSHI UDYOG VIKAS MAHAMANDAL MARYADIT MUMBAI",
"RASHMI 6 PARADIGM LIMITED",
"DR MONISHA KAPOOR AESTHETICS",
"RASTRMATA INDIRA GANDHI HIGH SCHOOL MOHADURA",
"RAMADEVI EDUCATIONAL TRUST",
"NAIB TAHSILDAR SANJAY GANDHI YOJNA",
"MC PRIMARY SCHOOL",
"NATIONAL CONVENT SEN SEC SCHOOL",
"SNOWWHITESOLUTION GLOBAL SERVICES LLP",
"KRASHAK MADYAMIK VIDYALAYA SHAHNAGAR",
"2609 SE GANGNAHAR O F D CIRCLE C A D SRIGANGANAGAR",
"AROGYA NIKETAN NURSING HOME AND MATERNITY HOME",
"CADIZ LIFESCIENCE",
"MADARSA ARBIA RIYZZUL ULOOM",
"BARUIPUR MULTI DEVELOPMENT SOCIETY FOR SOCIAL WELFARE",
"OFFICE OF THE EXECUTIVE ENGINEER PANAM PROJECT DIVISION GODHARA",
"DECCAN DREAMS ANIMATIONS LLP",
"UNIVERSAL MATRIC HR SEC SCHOOL",
"7439 GSSS SALEMPUR",
"MGM SCHOOL OF PHYSIOTHERAPY",
"KAILASH HOSPITAL & NEURO INSTITUTE",
"SHREE M B PATEL SARVAJANIK HOSPITAL",
"E G S PILLAY ENGINEERING COLLEGE",
"TRIMURTI HS BAJAJNAGAR",
"CHURCH SCHOOL",
"UNIVERSAL ACADEMY RESIDENTAL SCHOOL",
"MONDRAGON CORPORACION DE COMERCIO INTERN ATIONAL S A",
"ECOLE CENTRALE SCHOOL OF ENGINEERING",
"ADITYA BIRLA CARBON PATALGANGA",
"ANDY CONSULTANTS",
"GOVT COLLEGE MEHAM",
"EMPOWHER FOUNDATION",
"SE CUM PROJECT MANAGER WCDC WATERSHED DEVELOPMENT & SOIL COSERVATION Z P ALWAR",
"ABHEPAR PRIMARY SCHOOL",
"COMMUNITY HEALTH CENTER KOTRI BHILWARA",
"SRI AUROBINDO COLLEGE (EVENING)",
"VASHU GLOBAL SERVICES",
"JANAM SHAKTI PUNJ BARHA MANAV KALYAN",
"BHARTIYA SAKH SAHKARI SANSTHA MARYADIT",
"CUSTOMIZED CARE PRODUCTS & SERVICES INDIA PRIVATE LIMITED",
"CHEAPFAREMART PRIVATE LIMITED",
"THE PALACE OF JEWELS",
"GGS GOVERNMENT POLYTECHNIC EDUCATION SOCIETY CHEEKA",
"SHARANALAYA INTERNATIONAL MONTESSORI SCHOOL",
"COGNITIVEVALUETECH PRIVATE LIMITED",
"G B PANT INTER COLLEGE BHOWALI",
"SHREE SOLUTIONS AND SERVICES",
"GOVT OF JHARKHAND H M M S PHULCHI",
"CH BANSI LAL GOVT COLLEGE LOHARU",
"STATION HEADQUARTERS ALWAR",
"SUBIKSHAM WOMEN'S WELFARE FOUNDATION",
"BCD BANGALORE LIMITED LIABILITY PARTNERSHIP",
"UNION PUBLIC SCHOOL",
"D S SCIENCE ACADEMY",
"CHAVARA FAMILY WELFARE CENTRE",
"LORETO CONVENT GIRLS HIGH SCHOOL",
"CHIEF MEDICAL HEALTH OFFICER",
"SHREE CHHOTUBHAI A PATEL HOSPITAL AND COMMUNITY HEALTH CENTER",
"BLOCK HEALTH OFFICE 5 RAJKOT DISTRICT PANCHAYAT",
"THE KHERA DONA CO-OP AGRI MULTIPURPOSE SERVICE SOCIETY LTD",
"JANTA ADARSH KANYA JHS RUHERI",
"URMILA MEMORIAL HOSPITAL",
"DIRECTOR GENERAL TOURISM C I HUTMENT NEW DELHI",
"GOVT OF CHHATTISHGARH COMMAMDANT 2 BN CAF SAKARI BILSPUR",
"WINEXT POLYTECH PRIVATE LIMITED",
"SAROVARA ENVIROTECH PRIVATE LIMITED",
"P2 ENGINEERING ASSOCIATES",
"TAXEDGE BOUTIQUE LLP",
"MILIR GROUP OF INSTITUTIONS",
"GOVERNMENT OF ASSAM OFFICE OF THE SUPERINTENDING ENGINEER DIBRUGARH CIRCLE IRRIGATION",
"PRODUCTION AND FOOD PROCESSING DEPARTMENT",
"PDK INFRATECH LLP",
"GURU NANAK DEV SUPER SPECIALITY HOSPITAL",
"GREENWELL AGROTECH",
"SAINI ADARSH BAL NIKETAN HIGHER SECONDARY SCHOOL DAUSA",
"NICE HYBRID SEEDS COMPANY",
"NUHOME D√âCOR",
"NATIONAL ATMOSPHERIC RESEARCH LABORATORY",
"VAISHNO INDUSTRIES",
"SANSKAR CITY INTERNATIONAL SCHOOL",
"INFORMATION TECHNOLOGY AND COMMUNICATION DEPARTMENT",
"MADARSA HAMIDUL MADARIS POST AND KOTWALI PIHANI DISTT HARDOI",
"DY DIR VETERINARY SERVICES TKG MADHYA PRADESH TIKAMGARH",
"RAMESH AND SHARDA AGARWAL FOUNDATION",
"PLANTATION OFFICER SOCIAL FORESTRY AHMEDNAGAR",
"REPONO LIMITED",
"KONICO FARMERSSTOP PRIVATE LIMITED",
"JAY SHREE KRUSHNA CONCRETE PRIVATE LIMITED",
"AGEYE TECHNOLOGIES (INDIA) PRIVATE LIMITED",
"EMTREAT PHARMACEUTICALS PRIVATE LIMITED",
"ZPPS LAVHARMAL TANDA LAVHARMAL TANDA BEED",
"JAI GAJANAN ENTERPRISES",
"DR A P J ABDUL KALAM UNIVERSITY",
"KSHETRIYA KRIDA ADHIKARI VARANASI",
"SAMARTH VALUATION ADVISORY LLP",
"UTTAM PUBLIC SCHOOL",
"ATKINSENVIRO TECHNOLOGIES INDIA PRIVATE LIMITED",
"NAPASOFT EXCELLENCEN SIMPLICITY",
"URBAN PRIMARY HEALTH CENTER",
"ST ALPHONSUS H S SCHOOL",
"KALIKADEVI JR COLLEGE SHIRUR KASAR",
"ZILLA PARISHAD KENDRA PRATHMIK SHALA KOLGAON GEORAI BEED",
"VYANKATRAO HIGH SCHOOL AND JUNIOR COLLEGE ICHALKARANJI",
"AGRICULTURAL DEVELOPMENT OFFICER ZILLA PARISHAD NANDURBAR",
"DACC CCO DELHI",
"G M MODI SCHOOL",
"VERSATILETECH SOLUTIONS",
"GENESIS INTERNATIONAL SR SEC SCHOOL",
"ABHINAV VIDYALAYA JANUNA NANDGAON KH",
"ANKUR GARG & ASSOCIATES",
"SHRI VILE PARLE KELAVANI MANDAL‚ÄôS INSTITUTE OF TECHNOLOGY DHULE",
"SHRI SADGURU BAGADE MAHARAJ",
"INDIA AGRO CHEMICAL",
"DR RAJKUMAR ACADEMY FOR CIVIL SERVICES",
"SL MINDA MEMORIAL HOSPITAL",
"NAGAR NIGAM JODHPUR (SOUTH)",
"SHAKTI BIOTECH",
"ADARSHA MARKANDYA PRASHALA PRABHAG NO-6",
"URBAN LOCAL BODY DIRECTORATE",
"SHRI ATMIYA SHISHU VIDHYA MANDIR CBSE",
"CONTROLLER OF COMMUNICATION ACCOUNTS WEST BENGAL",
"BVRIT HYDERABAD COLLEGE OF ENGINEERING FOR WOMEN",
"SVR DRUGS AND INTERMEDIATES",
"PRANAM HVAC ENGINEERING PRIVATE LIMITED",
"EREVNA PHARMA PRIVATE LIMITED",
"GOVERNMENT OF JAMMU & KASHMIR CO TWO JK BN NCC",
"SOMRUK SHITAL CHANDRA INSTITUT",
"ITO REAC AU 1 (1)(2)",
"BLOCK DEVELOPMENT OFFICER BHOGRAI",
"BLOCK DEVELOPOMENT OFFICER KURAI MADHYA PRADESH",
"ELECTRIC SUPPLY DIVISION DHANBAD",
"JALGAON SHAHAR MAHANAGARPALIKA JALGAON",
"THE RADIANCE SCHOOL",
"BLOCK DEVELOPOMENT OFFICER LAKHANADON",
"BAIF INSTITTUTE FOR SUSTAINABLE LIVE LIHOODS AND DEVELOPMENT RAJSTHAN BR UDAIPUR",
"THE HARYANA COOP SUGAR MILLS ROHTAK",
"UDHAM SINGH NAGAR DISTRICT CO OPERATIVE BANK LIMITED",
"COMMANDANT COMMANDO POLICE TRAINING SCHOOL",
"BLOCK DEVELOPMENT OFFICER KAPTIPADA",
"PRAGNA EDUCATIONAL SOCIETY",
"ZILA PANCHAYAT MATHURA",
"SILVER BELLS ENG MED SCHOOL CBSE JAGANA ROAD PALANPUR",
"CHHOTAUDEPUR DISTRICT EDUCATION COMMITTEE MANAGED PRIMARY SCHOOL TEACHER",
"KAKADPADA VIBHAG VIDYALAYA KAKADPADA HIGH SCHOOL",
"PANITRAS HIGH SCHOOL",
"KHO KHO FEDERATION OF INDIA",
"Z P HIGHSCHOOL KALLAMB",
"VETERNARY DEPARTMENT DUPUTY DIRECTOR VETERINARY SERVICES RAIGARH",
"EC DEPARTMENT OF COLLEGIATE EDUCATION",
"TUFSEER LEATHER WORK & CORPORATE GIFTS",
"LITTLE PROFIT TRADING CO",
"HANSRAJ CONVENT SCHOOL",
"PRINCIPAL DISTRICT JUDGE KHANDWA",
"SARVA SIDDHANT VIDHYALAY",
"ST VINCENT‚ÄôS HIGH & TECHNICAL SCHOOL",
"ICS MAHESH PU COLLEGE",
"KHAGAUL LOCO LABOUR CO-OP SOCIETY LTD",
"SEO CRAFT INDIA",
"XPROWN FACILITY PRIVATE LIMITED",
"MMR CONSULTING IND PRIVATE LIMITED",
"VCS STAFFING GEEK PRIVATE LIMITED",
"247 HEALTHMEDPRO PRIVATE LIMITED",
"TALUKA HEALTH CENTRE DHOLERA",
"HARINA HIGH SCHOOL",
"DIVISIONAL COMMISSIONER OFFICE PUNE",
"MAHATMA GANDHI GOVT SCHOOL NADBAI",
"REGENTA SHYAM RESORT BHARATPUR",
"SHREE AMBAJI IMPEX",
"ACHARYA JUGALKISHOR H S SCHOOL JAMUNA PAAR MATHURA",
"GOVERMENT OF CHHATTISGARH DEPARTMENT OF FINANCE RAJNANDGAON 491441",
"DEVAGADH PRIMARY SCHOOL MANDAVI",
"RAJENDRA PRASAD DEGREE COLLEGE",
"BLOCK EDUCATION OFFICER KAPTIPADA",
"JIJAMATA UCHCH MADHYAMIK VIDYALAY",
"BEE LOGICAL SOFTWARE SOLUTIONS",
"JOYFUL INTERNATIONAL LEARNING ACADEMY KALOL",
"JYOTI VIDHYA VIHAR HINDI HIGH SCHOOL",
"CENTRAL ACADEMY JODHPUR EDUCATION SOCIETY",
"RACY PROJECTS",
"KET S V G VAZE COLLEGE OF ARTS SCIENCE AND COMMERCE",
"YASHWANTRAO MOHITE KRISHNA SAHAKARI SAKHAR KARKHANA LTD",
"A E N P H E D NIMBAHERA",
"SHRI BHIMASHANKAR SAHAKARI SAKKARE KARKHANE NIYAMIT MARAGUR",
"SSM PHARMACY COLLEGE",
"DEPARTMENT OF HEALTH SANITATION AND SOLID WASTE MANAGEMENT (PART-G)RATLAM",
"SMAJ AUTOMOTIVE",
"SARAWATI MODERN SR SEC SCHOOL BANSUR",
"SPARTAN JMD LOGISTICS LLP",
"BLOCK EDUCATION OFFICER SEONI MADHYA PRADESH",
"MATA RAMAI MADHYAMIK VIDYALAY PRAKASHA TAL SHAHADA DIST NANDURBAR",
"GSSS INSTITUTE OF ENGINEERING AND TECHNOLOGY FOR WOMEN",
"MERCHANT NURSING COLLEGE",
"TAPRI FALIYA NISHANA PRIMARY SCHOOL",
"EVA GROW PACKAGING",
"POINTER INSTRUMENTS PRIVATE LIMITED",
"Not Listed"
];